
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2baf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2baf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1H0lk", function(module, exports) {
"use strict";
/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $13ba12ba7c0c1370$var$__assign = module.exports && module.exports.__assign || function() {
    $13ba12ba7c0c1370$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $13ba12ba7c0c1370$var$__assign.apply(this, arguments);
};
var $13ba12ba7c0c1370$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $13ba12ba7c0c1370$var$utils_1 = $13ba12ba7c0c1370$var$__importDefault((parcelRequire("5MA6C")));

var $13ba12ba7c0c1370$var$config_1 = $13ba12ba7c0c1370$var$__importDefault((parcelRequire("4Gv6O")));

var $13ba12ba7c0c1370$var$errors_1 = $13ba12ba7c0c1370$var$__importDefault((parcelRequire("2n9qH")));

var $oCdZL = parcelRequire("oCdZL");

var $13ba12ba7c0c1370$var$tensorflowlib_1 = $13ba12ba7c0c1370$var$__importDefault((parcelRequire("iySBu")));
var $13ba12ba7c0c1370$var$utils = new $13ba12ba7c0c1370$var$utils_1.default();
/**
 * N-Dimension data structure. Stores multi-dimensional
 * data in a size-mutable, labeled data structure. Analogous to the Python Pandas DataFrame.
 *
 * @param  Object
 *
 *  data:  1D or 2D Array, JSON, Tensor, Block of data.
 *
 *  index: Array of numeric or string names for subseting array. If not specified, indexes are auto generated.
 *
 *  columns: Array of column names. If not specified, column names are auto generated.
 *
 *  dtypes: Array of data types for each the column. If not specified, dtypes inferred.
 *
 *  config: General configuration object for NDframe
 *
 * @returns NDframe
 */ var $13ba12ba7c0c1370$var$NDframe = /** @class */ function() {
    function NDframe(_a) {
        var data = _a.data, index = _a.index, columns = _a.columns, dtypes = _a.dtypes, config = _a.config, isSeries = _a.isSeries;
        this.$dataIncolumnFormat = [];
        this.$index = [];
        this.$columns = [];
        this.$dtypes = [];
        this.$isSeries = isSeries;
        if (config) this.$config = new $13ba12ba7c0c1370$var$config_1.default($13ba12ba7c0c1370$var$__assign($13ba12ba7c0c1370$var$__assign({}, $oCdZL.BASE_CONFIG), config));
        else this.$config = new $13ba12ba7c0c1370$var$config_1.default($oCdZL.BASE_CONFIG);
        if (data instanceof $13ba12ba7c0c1370$var$tensorflowlib_1.default.Tensor) data = data.arraySync();
        if (data === undefined || Array.isArray(data) && data.length === 0) {
            if (columns === undefined) columns = [];
            if (dtypes === undefined) dtypes = [];
            if (columns.length === 0 && dtypes.length !== 0) $13ba12ba7c0c1370$var$errors_1.default.throwDtypeWithoutColumnError();
            this.loadArrayIntoNdframe({
                data: [],
                index: [],
                columns: columns,
                dtypes: dtypes
            });
        } else if ($13ba12ba7c0c1370$var$utils.is1DArray(data)) this.loadArrayIntoNdframe({
            data: data,
            index: index,
            columns: columns,
            dtypes: dtypes
        });
        else {
            if (Array.isArray(data) && $13ba12ba7c0c1370$var$utils.isObject(data[0])) this.loadObjectIntoNdframe({
                data: data,
                type: 1,
                index: index,
                columns: columns,
                dtypes: dtypes
            });
            else if ($13ba12ba7c0c1370$var$utils.isObject(data)) this.loadObjectIntoNdframe({
                data: data,
                type: 2,
                index: index,
                columns: columns,
                dtypes: dtypes
            });
            else if (Array.isArray(data[0]) || $13ba12ba7c0c1370$var$utils.isNumber(data[0]) || $13ba12ba7c0c1370$var$utils.isString(data[0])) this.loadArrayIntoNdframe({
                data: data,
                index: index,
                columns: columns,
                dtypes: dtypes
            });
            else if (Array.isArray(data) && data.length > 0 && $13ba12ba7c0c1370$var$utils.isDate(data[0])) this.loadArrayIntoNdframe({
                data: data,
                index: index,
                columns: columns,
                dtypes: dtypes
            });
            else throw new Error("File format not supported!");
        }
    }
    /**
     * Internal function to load array of data into NDFrame
     * @param data The array of data to load into NDFrame
     * @param index Array of numeric or string names for subsetting array.
     * @param columns Array of column names.
     * @param dtypes Array of data types for each the column.
    */ NDframe.prototype.loadArrayIntoNdframe = function(_a) {
        var data = _a.data, index = _a.index, columns = _a.columns, dtypes = _a.dtypes;
        // this.$data = utils.replaceUndefinedWithNaN(data, this.$isSeries);
        this.$data = data;
        if (!this.$config.isLowMemoryMode) //In NOT low memory mode, we transpose the array and save in column format.
        //This makes column data retrieval run in constant time
        this.$dataIncolumnFormat = $13ba12ba7c0c1370$var$utils.transposeArray(data);
        this.$setIndex(index);
        this.$setDtypes(dtypes);
        this.$setColumnNames(columns);
    };
    /**
     * Internal function to format and load a Javascript object or object of arrays into NDFrame.
     * @param data Object or object of arrays.
     * @param type The type of the object. There are two recognized types:
     *
     * - type 1 object are in JSON format `[{a: 1, b: 2}, {a: 30, b: 20}]`.
     *
     * - type 2 object are of the form `{a: [1,2,3,4], b: [30,20, 30, 20}]}`
     * @param index Array of numeric or string names for subsetting array.
     * @param columns Array of column names.
     * @param dtypes Array of data types for each the column.
    */ NDframe.prototype.loadObjectIntoNdframe = function(_a) {
        var data = _a.data, type = _a.type, index = _a.index, columns = _a.columns, dtypes = _a.dtypes;
        if (type === 1 && Array.isArray(data)) {
            var _data = data.map(function(item) {
                return Object.values(item);
            });
            var _columnNames = void 0;
            if (columns) _columnNames = columns;
            else _columnNames = Object.keys(data[0]);
            this.loadArrayIntoNdframe({
                data: _data,
                index: index,
                columns: _columnNames,
                dtypes: dtypes
            });
        } else {
            var _b = $13ba12ba7c0c1370$var$utils.getRowAndColValues(data), _data = _b[0], _colNames = _b[1];
            var _columnNames = void 0;
            if (columns) _columnNames = columns;
            else _columnNames = _colNames;
            this.loadArrayIntoNdframe({
                data: _data,
                index: index,
                columns: _columnNames,
                dtypes: dtypes
            });
        }
    };
    Object.defineProperty(NDframe.prototype, "tensor", {
        /**
         * Converts and returns the data in the NDframe as a Tensorflow.js Tensor.
        */ get: function() {
            if (this.$isSeries) return $13ba12ba7c0c1370$var$tensorflowlib_1.default.tensor1d(this.$data, this.$dtypes[0]);
            else return $13ba12ba7c0c1370$var$tensorflowlib_1.default.tensor2d(this.$data, this.shape, "float32");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NDframe.prototype, "dtypes", {
        /**
         * Returns the dtypes of the columns
        */ get: function() {
            return this.$dtypes;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Internal function to set the Dtypes of the NDFrame from an array. This function
     * performs the necessary checks.
    */ NDframe.prototype.$setDtypes = function(dtypes) {
        if (this.$isSeries) {
            if (dtypes) {
                if (this.$data.length != 0 && dtypes.length != 1) $13ba12ba7c0c1370$var$errors_1.default.throwDtypesLengthError(this, dtypes);
                if (!$oCdZL.DATA_TYPES.includes("" + dtypes[0])) $13ba12ba7c0c1370$var$errors_1.default.throwDtypeNotSupportedError(dtypes[0]);
                this.$dtypes = dtypes;
            } else this.$dtypes = $13ba12ba7c0c1370$var$utils.inferDtype(this.$data);
        } else if (dtypes) {
            if (this.$data.length != 0 && dtypes.length != this.shape[1]) $13ba12ba7c0c1370$var$errors_1.default.throwDtypesLengthError(this, dtypes);
            if (this.$data.length == 0 && dtypes.length == 0) this.$dtypes = dtypes;
            else {
                dtypes.forEach(function(dtype) {
                    if (!$oCdZL.DATA_TYPES.includes(dtype)) $13ba12ba7c0c1370$var$errors_1.default.throwDtypeNotSupportedError(dtype);
                });
                this.$dtypes = dtypes;
            }
        } else this.$dtypes = $13ba12ba7c0c1370$var$utils.inferDtype(this.$data);
    };
    Object.defineProperty(NDframe.prototype, "ndim", {
        /**
         * Returns the dimension of the data. Series have a dimension of 1,
         * while DataFrames have a dimension of 2.
        */ get: function() {
            if (this.$isSeries) return 1;
            else return 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NDframe.prototype, "axis", {
        /**
         * Returns the axis labels of the NDFrame.
        */ get: function() {
            return {
                index: this.$index,
                columns: this.$columns
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NDframe.prototype, "config", {
        /**
         * Returns the configuration object of the NDFrame.
        */ get: function() {
            return this.$config;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Internal function to set the configuration of the ndframe
    */ NDframe.prototype.$setConfig = function(config) {
        this.$config = config;
    };
    Object.defineProperty(NDframe.prototype, "index", {
        /**
         * Returns the indices of the NDFrame
        */ get: function() {
            return this.$index;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Internal function to set the index of the NDFrame with the specified
     * array of indices. Performs all necessary checks to ensure that the
     * index is valid.
    */ NDframe.prototype.$setIndex = function(index) {
        if (index) {
            if (this.$data.length != 0 && index.length != this.shape[0]) $13ba12ba7c0c1370$var$errors_1.default.throwIndexLengthError(this, index);
            if (Array.from(new Set(index)).length !== this.shape[0]) $13ba12ba7c0c1370$var$errors_1.default.throwIndexDuplicateError();
            this.$index = index;
        } else this.$index = $13ba12ba7c0c1370$var$utils.range(0, this.shape[0] - 1); //generate index
    };
    /**
     * Internal function to reset the index of the NDFrame using a range of indices.
    */ NDframe.prototype.$resetIndex = function() {
        this.$index = $13ba12ba7c0c1370$var$utils.range(0, this.shape[0] - 1);
    };
    Object.defineProperty(NDframe.prototype, "columns", {
        /**
         * Returns the column names of the NDFrame
        */ get: function() {
            return this.$columns;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Internal function to set the column names for the NDFrame. This function
     * performs a check to ensure that the column names are unique, and same length as the
     * number of columns in the data.
    */ NDframe.prototype.$setColumnNames = function(columns) {
        // console.log(columns);
        if (this.$isSeries) {
            if (columns) {
                if (this.$data.length != 0 && columns.length != 1 && typeof columns != 'string') $13ba12ba7c0c1370$var$errors_1.default.throwColumnNamesLengthError(this, columns);
                this.$columns = columns;
            } else this.$columns = [
                "0"
            ];
        } else if (columns) {
            if (this.$data.length != 0 && columns.length != this.shape[1]) $13ba12ba7c0c1370$var$errors_1.default.throwColumnNamesLengthError(this, columns);
            if (Array.from(new Set(columns)).length !== columns.length) $13ba12ba7c0c1370$var$errors_1.default.throwColumnDuplicateError();
            this.$columns = columns;
        } else this.$columns = $13ba12ba7c0c1370$var$utils.range(0, this.shape[1] - 1).map(function(val) {
            return "" + val;
        }); //generate columns
    };
    Object.defineProperty(NDframe.prototype, "shape", {
        /**
         * Returns the shape of the NDFrame. Shape is determined by [row length, column length]
        */ get: function() {
            if (this.$data.length === 0) {
                if (this.$columns.length === 0) return [
                    0,
                    0
                ];
                else return [
                    0,
                    this.$columns.length
                ];
            }
            if (this.$isSeries) return [
                this.$data.length,
                1
            ];
            else {
                var rowLen = this.$data.length;
                var colLen = this.$data[0].length;
                return [
                    rowLen,
                    colLen
                ];
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NDframe.prototype, "values", {
        /**
         * Returns the underlying data in Array format.
        */ get: function() {
            return this.$data;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Updates the internal $data property to the specified value
     * @param values An array of values to set
     * @param checkLength Whether to check the length of the new values and the existing row length
     * @param checkColumnLength Whether to check the length of the new values and the existing column length
     * */ NDframe.prototype.$setValues = function(values, checkLength, checkColumnLength) {
        var _this = this;
        if (checkLength === void 0) checkLength = true;
        if (checkColumnLength === void 0) checkColumnLength = true;
        if (this.$isSeries) {
            if (checkLength && values.length != this.shape[0]) $13ba12ba7c0c1370$var$errors_1.default.throwRowLengthError(this, values.length);
            this.$data = values;
            this.$dtypes = $13ba12ba7c0c1370$var$utils.inferDtype(values); //Dtype may change depeneding on the value set
            if (!this.$config.isLowMemoryMode) this.$dataIncolumnFormat = values;
        } else {
            if (checkLength && values.length != this.shape[0]) $13ba12ba7c0c1370$var$errors_1.default.throwRowLengthError(this, values.length);
            if (checkColumnLength) values.forEach(function(value) {
                if (value.length != _this.shape[1]) $13ba12ba7c0c1370$var$errors_1.default.throwColumnLengthError(_this, values.length);
            });
            this.$data = values;
            this.$dtypes = $13ba12ba7c0c1370$var$utils.inferDtype(values);
            if (!this.$config.isLowMemoryMode) this.$dataIncolumnFormat = $13ba12ba7c0c1370$var$utils.transposeArray(values);
        }
    };
    Object.defineProperty(NDframe.prototype, "getColumnData", {
        /**
          * Returns the underlying data in Array column format.
          * Similar to this.values, but in column format.
        */ get: function() {
            if (this.config.isLowMemoryMode) return $13ba12ba7c0c1370$var$utils.transposeArray(this.values);
            else return this.$dataIncolumnFormat;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NDframe.prototype, "size", {
        /**
         * Returns the size of the NDFrame object
         *
        */ get: function() {
            return this.shape[0] * this.shape[1];
        },
        enumerable: false,
        configurable: true
    });
    NDframe.prototype.toCSV = function(options) {
        throw new Error("`toCSV` function is deprecated. Use `toCSV` function directly instead. e.g. `dfd.toCSV(df)`");
    };
    NDframe.prototype.toJSON = function(options) {
        throw new Error("`toJSON` function is deprecated. Use `toJSON` function directly instead. e.g. `dfd.toJSON(df, { format: 'row' })`");
    };
    /**
     * Converts a DataFrame or Series to Excel.
     * @deprecated Use `toExcel` function directly instead.
     * @example
     * ```
     * import * as dfd from "danfojs"
     * const df = new dfd.DataFrame([[1, 2, 3], [4, 5, 6]])
     * dfd.toExcel(df, {
     *     filePath: "./data/sample.xlsx",
     *     sheetName: "MySheet",
     *   })
     * ```
     *
     * @example
     * ```
     * import { toExcel } from "danfojs-node"
     * const df = new DataFrame([[1, 2, 3], [4, 5, 6]])
     * toExcel(df, {
     *     filePath: "./data/sample.xlsx",
     *     sheetName: "MySheet",
     *   })
     * ```
     */ NDframe.prototype.toExcel = function(options) {
        throw new Error("Deprecated. Use `toExcel` function directly instead. e.g. `dfd.toExcel(df, {filePath: 'path/to/file.xlsx'})`");
    };
    /**
     * Pretty prints a DataFrame or Series to the console
     */ NDframe.prototype.print = function() {
        console.log(this + "");
    };
    return NDframe;
}();
module.exports.default = $13ba12ba7c0c1370$var$NDframe;

});
parcelRegister("5MA6C", function(module, exports) {
"use strict";
/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $435d714d01bcd7f9$var$__assign = module.exports && module.exports.__assign || function() {
    $435d714d01bcd7f9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $435d714d01bcd7f9$var$__assign.apply(this, arguments);
};
var $435d714d01bcd7f9$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $435d714d01bcd7f9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $oCdZL = parcelRequire("oCdZL");

var $435d714d01bcd7f9$var$config_1 = $435d714d01bcd7f9$var$__importDefault((parcelRequire("4Gv6O")));

var $4j43E = parcelRequire("4j43E");

var $4j43E = parcelRequire("4j43E");

var $435d714d01bcd7f9$var$errors_1 = $435d714d01bcd7f9$var$__importDefault((parcelRequire("2n9qH")));
var $435d714d01bcd7f9$var$config = new $435d714d01bcd7f9$var$config_1.default($oCdZL.BASE_CONFIG);
/**
 * General Utility class
 */ var $435d714d01bcd7f9$var$Utils = /** @class */ function() {
    function Utils() {}
    /**
     * Removes an element from a 1D array
     *
     * ```js
     *
     * ```
     * @param arr The array to filter.
     * @param index The index to filter by.
     */ Utils.prototype.removeElementFromArray = function(arr, index) {
        var newArr = arr.filter(function(_, i) {
            return i != index;
        });
        return newArr;
    };
    /**
     * Check if value is a string.
     * @param value The value to check.
     * @returns
     */ Utils.prototype.isString = function(value) {
        return typeof value === "string";
    };
    /**
     * Checks if value is a number.
     * @param value The value to check.
     * @returns
     */ Utils.prototype.isNumber = function(value) {
        return typeof value === "number" && isFinite(value);
    };
    /**
     * Checks if value is an object.
     * @param value The value to check.
     * @returns
     */ Utils.prototype.isObject = function(value) {
        return value && typeof value === "object" && value.constructor && value.constructor.name === "Object";
    };
    /**
     * Checks if a value is null
     * @param value The value to check.
     * @returns
     */ Utils.prototype.isNull = function(value) {
        return value === null;
    };
    /**
     * Checks if a value is undefined
     * @param value The value to check.
     * @returns
     */ Utils.prototype.isUndefined = function(value) {
        return typeof value === "undefined";
    };
    /**
     * Checks if a value is empty. Empty means it's either null, undefined or NaN.
     * Empty strings are NOT considered empty.
     * @param value The value to check.
     * @returns boolean indicating if the value is empty
     */ Utils.prototype.isEmpty = function(value) {
        if (value === undefined || value === null) return true;
        if (typeof value === 'bigint') return false; // BigInt values are never considered empty
        if (typeof value === 'number') return isNaN(value);
        return false; // All other types (strings, objects, arrays, etc) are not considered empty
    };
    /**
     * Checks if a value is a date object
     * @param value A date object
     * @returns boolean
     */ Utils.prototype.isDate = function(value) {
        return value instanceof Date;
    };
    /**
     * Generates an array of integers between specified range
     * @param start The starting number.
     * @param end The ending number.
     */ Utils.prototype.range = function(start, end) {
        if (end < start) throw new Error("ParamError: end must be greater than start");
        if (start === end) return [
            start
        ];
        var arr = [];
        for(var i = start; i <= end; i++)arr.push(i);
        return arr;
    };
    /**
     * Checks if object has the specified key
     * @param obj The object to check.
     * @param key The key to find.
     */ Utils.prototype.keyInObject = function(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
    };
    /**
     * Transposes an array of array
     * @param obj The object to check.
     * @param key The key to find.
     */ Utils.prototype.transposeArray = function(arr) {
        if (arr.length === 0) return arr;
        var rowLen = arr.length;
        if (Array.isArray(arr[0])) {
            var colLen = arr[0].length;
            var newArr = [];
            for(var i = 0; i <= colLen - 1; i++){
                var temp = [];
                for(var j = 0; j < rowLen; j++){
                    var _elem = arr[j][i];
                    temp.push(_elem);
                }
                newArr.push(temp);
            }
            return newArr;
        } else return arr;
    };
    /**
     * Retrieve row array and column names from an object of the form {a: [1,2,3,4], b: [30,20, 30, 20]}
     * @param obj The object to retrieve rows and column names from.
     */ Utils.prototype.getRowAndColValues = function(obj) {
        var colNames = Object.keys(obj);
        var colData = Object.values(obj);
        var firstColLen = colData[0].length;
        colData.forEach(function(cdata) {
            if (cdata.length != firstColLen) throw Error("Length Error: Length of columns must be the same!");
        });
        var rowsArr = this.transposeArray(colData);
        return [
            rowsArr,
            colNames
        ];
    };
    /**
     * Converts a 2D array of array to 1D array for Series Class
     * @param arr The array to convert.
     */ Utils.prototype.convert2DArrayToSeriesArray = function(arr) {
        var _this = this;
        var newArr = arr.map(function(val) {
            if (_this.isObject(val)) return JSON.stringify(val);
            else return "" + val;
        });
        return newArr;
    };
    /**
     * Replaces all missing values with NaN. Missing values are undefined, Null and Infinity
     * @param arr The array
     * @param isSeries Whether the arr is a series or not
     */ Utils.prototype.replaceUndefinedWithNaN = function(arr, isSeries) {
        if (arr.length === 0) return arr;
        if (isSeries && Array.isArray(arr)) {
            var newArr = arr.map(function(ele) {
                if (typeof ele === "undefined") return NaN;
                if (typeof ele === "number" && (isNaN(ele) || ele == Infinity)) return NaN;
                if (ele == null) return NaN;
                return ele;
            });
            return newArr;
        } else {
            var newArr = [];
            if (Array.isArray(arr)) for(var i = 0; i < arr.length; i++){
                var innerArr = arr[i];
                var temp = innerArr.map(function(ele) {
                    if (typeof ele === "undefined") return NaN;
                    if (typeof ele === "number" && (isNaN(ele) || ele == Infinity)) return NaN;
                    if (ele == null) return NaN;
                    return ele;
                });
                newArr.push(temp);
            }
            return newArr;
        }
    };
    /**
     * Infer data type from an array or array of arrays
     * @param arr An array or array of arrays
    */ Utils.prototype.inferDtype = function(arr) {
        var self = this;
        if (this.is1DArray(arr)) return [
            this.$typeChecker(arr)
        ];
        else {
            var arrSlice = this.transposeArray(arr.slice(0, $435d714d01bcd7f9$var$config.getDtypeTestLim));
            var dtypes = arrSlice.map(function(innerArr) {
                return self.$typeChecker(innerArr);
            });
            return dtypes;
        }
    };
    /**
     * Private type checker used by inferDtype function
     * @param arr The array
     */ Utils.prototype.$typeChecker = function(arr) {
        var dtypes;
        var lim;
        var intTracker = [];
        var floatTracker = [];
        var stringTracker = [];
        var boolTracker = [];
        var dateTracker = [];
        if (arr.length < $435d714d01bcd7f9$var$config.getDtypeTestLim) lim = arr.length;
        else lim = $435d714d01bcd7f9$var$config.getDtypeTestLim;
        var arrSlice = arr.slice(0, lim);
        for(var i = 0; i < lim; i++){
            var ele = arrSlice[i];
            if (typeof ele == "boolean") {
                floatTracker.push(false);
                intTracker.push(false);
                stringTracker.push(false);
                boolTracker.push(true);
                dateTracker.push(false);
            } else if (this.isEmpty(ele)) {
                floatTracker.push(true);
                intTracker.push(false);
                stringTracker.push(false);
                boolTracker.push(false);
                dateTracker.push(false);
            } else if (this.isDate(ele)) {
                floatTracker.push(false);
                intTracker.push(false);
                stringTracker.push(false);
                boolTracker.push(false);
                dateTracker.push(true);
            } else if (!isNaN(Number(ele))) {
                if (ele.toString().includes(".")) {
                    floatTracker.push(true);
                    intTracker.push(false);
                    stringTracker.push(false);
                    boolTracker.push(false);
                    dateTracker.push(false);
                } else {
                    floatTracker.push(false);
                    intTracker.push(true);
                    stringTracker.push(false);
                    boolTracker.push(false);
                    dateTracker.push(false);
                }
            } else {
                floatTracker.push(false);
                intTracker.push(false);
                stringTracker.push(true);
                boolTracker.push(false);
                dateTracker.push(false);
            }
        }
        var even = function(ele) {
            return ele == true;
        };
        if (stringTracker.some(even)) dtypes = "string";
        else if (floatTracker.some(even)) dtypes = "float32";
        else if (intTracker.some(even)) dtypes = "int32";
        else if (boolTracker.some(even)) dtypes = "boolean";
        else if (dateTracker.some(even)) dtypes = "datetime";
        else dtypes = "undefined";
        return dtypes;
    };
    /**
     * Returns the unique values in an 1D array
     * @param arr The array
    */ Utils.prototype.unique = function(arr) {
        var uniqueArr = new Set(arr);
        return Array.from(uniqueArr);
    };
    /**
     * Checks if array is 1D
     * @param arr The array
    */ Utils.prototype.is1DArray = function(arr) {
        if (typeof arr[0] == "number" || typeof arr[0] == "string" || typeof arr[0] == "boolean" || arr[0] === null) return true;
        else return false;
    };
    /**
     * Converts an array to an object using array index as object keys
     * @param arr The array
    */ Utils.prototype.convertArrayToObject = function(arr) {
        var arrObj = {};
        for(var i = 0; i < arr.length; i++)arrObj[i] = arr[i];
        return arrObj;
    };
    /**
     * Count the NaN and non-NaN values present in an array
     * @param  arr Array object
     * @param val whether to return the value count instead of the null count
     * @param isSeries Whether the array is of type series or not
     */ Utils.prototype.countNaNs = function(arr, returnVal, isSeries) {
        if (returnVal === void 0) returnVal = true;
        if (isSeries) {
            var nullCount = 0;
            var valCount = 0;
            for(var i = 0; i < arr.length; i++){
                var ele = arr[i];
                if (Number.isNaN(ele)) nullCount = nullCount + 1;
                else valCount = valCount + 1;
            }
            if (returnVal) return valCount;
            else return nullCount;
        } else {
            var resultArr = [];
            for(var i = 0; i < arr.length; i++){
                var innerArr = arr[i];
                var nullCount = 0;
                var valCount = 0;
                for(var i_1 = 0; i_1 < innerArr.length; i_1++){
                    var ele = innerArr[i_1];
                    if (Number.isNaN(ele)) nullCount = nullCount + 1;
                    else valCount = valCount + 1;
                }
                if (returnVal) resultArr.push(valCount);
                else resultArr.push(nullCount);
            }
            return resultArr;
        }
    };
    /**
     * Round elements of an array or array of arrays to specified dp
     * @param arr The Array to round
     * @param dp The number of dp to round to
     * @param isSeries Whether the array is of type Series or not
     */ Utils.prototype.round = function(arr, dp, isSeries) {
        if (dp === void 0) dp = 1;
        if (dp < 0) dp = 1;
        if (isSeries) {
            var newArr = [];
            for(var i = 0; i < arr.length; i++){
                var ele = arr[i];
                if (typeof ele == "number" && !isNaN(ele) && ele !== undefined && ele !== null) newArr.push(Number(ele.toFixed(dp)));
                else newArr.push(ele);
            }
            return newArr;
        } else {
            var resultArr = [];
            for(var i = 0; i < arr.length; i++){
                var innerVal = arr[i];
                var newArr = [];
                if (Array.isArray(innerVal)) {
                    for(var i_2 = 0; i_2 < innerVal.length; i_2++){
                        var ele = innerVal[i_2];
                        if (typeof ele == "number" && !isNaN(ele) && ele !== undefined && ele !== null) newArr.push(Number(ele.toFixed(dp)));
                        else newArr.push(ele);
                    }
                    resultArr.push(newArr);
                } else if (typeof innerVal == "number" && !isNaN(innerVal) && innerVal !== undefined && innerVal !== null) newArr.push(Number(innerVal.toFixed(dp)));
                else newArr.push(innerVal);
            }
            return resultArr;
        }
    };
    /**
     * Checks if a func is a function
     * @param func
     */ Utils.prototype.isFunction = function(func) {
        return typeof func == "function";
    };
    /**
     * Generates n random numbers between start and end.
     * @param start
     * @param end
     * @param size
     */ Utils.prototype.randNumberGenerator = function(start, end, size) {
        var genNum = [];
        function randi(a, b) {
            return Math.floor(Math.random() * (b - a) + a);
        }
        function recursive(val, arr) {
            if (!arr.includes(val)) return val;
            val = randi(start, end);
            recursive(val, arr);
        }
        for(var i = 0; i < size; i++){
            var genVal = randi(start, end);
            var recursiveVal = recursive(genVal, genNum);
            genNum.push(recursiveVal);
        }
        return genNum;
    };
    /**
     * Throws error when a required parameter is missing.
     * @param paramsObject The parameters passed to the function
     * @param paramsNeeded The required parameters in the function
     */ Utils.prototype.throwErrorOnWrongParams = function(paramsObject, paramsNeeded) {
        var keys = Object.keys(paramsObject);
        var bool = [];
        for(var i = 0; i < keys.length; i++)if (paramsNeeded.includes(keys[i])) bool.push(true);
        else bool.push(false);
        var truthy = function(element) {
            return element == false;
        };
        if (bool.some(truthy)) throw Error("Params Error: Required parameter not found. Your params must include the following [" + paramsNeeded + "]");
    };
    /**
     * Maps integer values (0, 1) to boolean (false, true)
     * @param arr The array of integers
     * @param dim The dimension of the array
     */ Utils.prototype.mapIntegersToBooleans = function(arr, dim) {
        if (dim == 2) {
            var newArr_1 = [];
            arr.map(function(innerArr) {
                var temp = [];
                innerArr.map(function(val) {
                    return temp.push(val == 1);
                });
                newArr_1.push(temp);
            });
            return newArr_1;
        } else {
            var newArr_2 = [];
            arr.map(function(val) {
                return newArr_2.push(val == 1);
            });
            return newArr_2;
        }
    };
    /**
     * Maps boolean values (false, true) to integer equivalent (0, 1)
     * @param arr The array of booleans
     * @param dim The dimension of the array
     */ Utils.prototype.mapBooleansToIntegers = function(arr, dim) {
        if (dim == 2) {
            var newArr_3 = [];
            arr.map(function(innerArr) {
                var temp = [];
                innerArr.map(function(val) {
                    return temp.push(val ? 1 : 0);
                });
                newArr_3.push(temp);
            });
            return newArr_3;
        } else {
            var newArr_4 = [];
            arr.map(function(val) {
                return newArr_4.push(val ? 1 : 0);
            });
            return newArr_4;
        }
    };
    /**
     * Generates an array of dim (row x column) with inner values set to zero
     * @param row
     * @param column
     */ Utils.prototype.zeros = function(row, column) {
        var zeroData = [];
        for(var i = 0; i < row; i++){
            var colData = Array(column);
            for(var j = 0; j < column; j++)colData[j] = 0;
            zeroData.push(colData);
        }
        return zeroData;
    };
    /**
     * Shuffles and returns a random slice of an array
     * @param num
     * @param array
     */ Utils.prototype.shuffle = function(array, num) {
        var i = array.length;
        var j = 0;
        var temp;
        while(i--){
            j = Math.floor(Math.random() * (i + 1));
            temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array.slice(0, num);
    };
    /**
     * Sorts an array in specified order
     * @param arr
     * @param ascending
     * @returns
     */ Utils.prototype.sort = function(arr, ascending) {
        if (ascending === void 0) ascending = true;
        var sorted = $435d714d01bcd7f9$var$__spreadArray([], arr, true);
        return sorted.sort(function(a, b) {
            if (ascending) {
                if (typeof a === "string" && typeof b === "string") return a.charCodeAt(0) - b.charCodeAt(0);
                else return a - b;
            } else {
                if (typeof a === "string" && typeof b === "string") return b.charCodeAt(0) - a.charCodeAt(0);
                else return b - a;
            }
        });
    };
    /**
     * Checks if current environment is Browser
     */ Utils.prototype.isBrowserEnv = function() {
        var isBrowser = new Function("try {return this===window;}catch(e){ return false;}");
        return isBrowser();
    };
    /**
     * Checks if current environment is Node
     */ Utils.prototype.isNodeEnv = function() {
        var isNode = new Function("try {return this===global;}catch(e){return false;}");
        return isNode();
    };
    /**
     * Remove NaN values from 1D array
     * @param arr
     */ Utils.prototype.removeMissingValuesFromArray = function(arr) {
        var _this = this;
        var values = arr.filter(function(val) {
            return !_this.isEmpty(val);
        });
        return values;
    };
    /**
     * Replace NaN with null before tensor operations
     * @param arr
     */ Utils.prototype.replaceNanWithNull = function(arr) {
        var values = arr.map(function(val) {
            if (isNaN(val)) return null;
            else return val;
        });
        return values;
    };
    /**
     * Get duplicate values in a array
     * @param arr
     */ Utils.prototype.getDuplicate = function(arr) {
        var tempObj = {};
        var resultObj = {};
        for(var i = 0; i < arr.length; i++){
            var val = arr[i];
            if (this.keyInObject(tempObj, val)) {
                tempObj[val]["count"] += 1;
                tempObj[val]["index"].push(i);
            } else {
                tempObj[val] = {};
                tempObj[val]["count"] = 1;
                tempObj[val]["index"] = [
                    i
                ];
            }
        }
        for(var key in tempObj)if (tempObj[key]["count"] >= 2) {
            resultObj[key] = {};
            resultObj[key]["count"] = tempObj[key]["count"];
            resultObj[key]["index"] = tempObj[key]["index"];
        }
        return resultObj;
    };
    /**
     * Returns the index of a sorted array
     * @param arr1 The first array
     * @param arr2 The second array
     * @param dtype The data type of the arrays
     *
     * @returns sorted index
     */ Utils.prototype.sortArrayByIndex = function(arr1, arr2, dtype) {
        var sortedIdx = arr1.map(function(item, index) {
            return [
                arr2[index],
                item
            ];
        });
        if (dtype == "string") sortedIdx.sort();
        else sortedIdx.sort(function(_a, _b) {
            var arg1 = _a[0];
            var arg2 = _b[0];
            return arg2 - arg1;
        });
        return sortedIdx.map(function(_a) {
            var item = _a[1];
            return item;
        });
    };
    /**
     * Returns a new series with properties of the old series
     *
     * @param series The series to copy
    */ Utils.prototype.createNdframeFromNewDataWithOldProps = function(_a) {
        var ndFrame = _a.ndFrame, newData = _a.newData, isSeries = _a.isSeries;
        if (isSeries) return new $4j43E.Series(newData, {
            index: $435d714d01bcd7f9$var$__spreadArray([], ndFrame.index, true),
            columns: $435d714d01bcd7f9$var$__spreadArray([], ndFrame.columns, true),
            dtypes: $435d714d01bcd7f9$var$__spreadArray([], ndFrame.dtypes, true),
            config: $435d714d01bcd7f9$var$__assign({}, ndFrame.config)
        });
        else return new $4j43E.DataFrame(newData, {
            index: $435d714d01bcd7f9$var$__spreadArray([], ndFrame.index, true),
            columns: $435d714d01bcd7f9$var$__spreadArray([], ndFrame.columns, true),
            dtypes: $435d714d01bcd7f9$var$__spreadArray([], ndFrame.dtypes, true),
            config: $435d714d01bcd7f9$var$__assign({}, ndFrame.config)
        });
    };
    /**
    * Checks if two series are compatible for a mathematical operation
    * @param object
    *
    *   firstSeries ==>  First Series object
    *
    *   secondSeries ==> Second Series object to comapre with
    *
    *   operation ==> The mathematical operation
    */ Utils.prototype.checkSeriesOpCompactibility = function(_a) {
        var firstSeries = _a.firstSeries, secondSeries = _a.secondSeries, operation = _a.operation;
        if (firstSeries.shape[0] != secondSeries.shape[0]) $435d714d01bcd7f9$var$errors_1.default.throwSeriesMathOpLengthError(firstSeries, secondSeries);
        if (firstSeries.dtypes[0] == 'string' || secondSeries.dtypes[0] == 'string') $435d714d01bcd7f9$var$errors_1.default.throwStringDtypeOperationError(operation);
    };
    /**
    * Custom sort for an array of index and values
    * @param arr The array of objects to sort
    * @param ascending Whether to sort in ascending order or not
    */ Utils.prototype.sortObj = function(arr, ascending) {
        var sortedValues = arr.sort(function(obj1, obj2) {
            var a = obj2.value;
            var b = obj1.value;
            if (!ascending) {
                if (typeof a === "string" && typeof b === "string") {
                    a = a.toUpperCase();
                    b = b.toUpperCase();
                    if (a < b) return -1;
                    if (a > b) return 1;
                    return 0;
                } else return Number(a) - Number(b);
            } else {
                if (typeof a === "string" && typeof b === "string") {
                    a = a.toUpperCase();
                    b = b.toUpperCase();
                    if (a > b) return -1;
                    if (a < b) return 1;
                    return 0;
                } else return Number(b) - Number(a);
            }
        });
        return sortedValues;
    };
    return Utils;
}();
module.exports.default = $435d714d01bcd7f9$var$Utils;

});
parcelRegister("oCdZL", function(module, exports) {
"use strict";
/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DATA_TYPES = module.exports.BASE_CONFIG = void 0;
/**
 * Default config object
 */ module.exports.BASE_CONFIG = {
    tableMaxRow: 10,
    tableMaxColInConsole: 10,
    dtypeTestLim: 20,
    lowMemoryMode: false
};
module.exports.DATA_TYPES = [
    "float32",
    "int32",
    "string",
    "boolean",
    "datetime",
    'undefined'
];

});

parcelRegister("4Gv6O", function(module, exports) {
"use strict";
var $3693373fa47ca5c9$var$__assign = module.exports && module.exports.__assign || function() {
    $3693373fa47ca5c9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3693373fa47ca5c9$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package wide configuration class
 */ var $3693373fa47ca5c9$var$Configs = /** @class */ function() {
    function Configs(options) {
        var _a = $3693373fa47ca5c9$var$__assign({
            tableDisplayConfig: {},
            tableMaxRow: 10,
            tableMaxColInConsole: 10,
            dtypeTestLim: 500,
            lowMemoryMode: false
        }, options), tableDisplayConfig = _a.tableDisplayConfig, tableMaxRow = _a.tableMaxRow, tableMaxColInConsole = _a.tableMaxColInConsole, dtypeTestLim = _a.dtypeTestLim, lowMemoryMode = _a.lowMemoryMode;
        this.tableDisplayConfig = tableDisplayConfig;
        this.tableMaxRow = tableMaxRow; // The maximum number of rows to display in console
        this.tableMaxColInConsole = tableMaxColInConsole; // The maximum number of columns to display in console
        this.dtypeTestLim = dtypeTestLim; // The number of rows to use when inferring data type
        this.lowMemoryMode = lowMemoryMode; // Whether to use minimal memory or not.
    }
    Configs.prototype.setTableDisplayConfig = function(config) {
        this.tableDisplayConfig = config;
    };
    Object.defineProperty(Configs.prototype, "getTableDisplayConfig", {
        get: function() {
            return this.tableDisplayConfig;
        },
        enumerable: false,
        configurable: true
    });
    Configs.prototype.setTableMaxColInConsole = function(val) {
        this.tableMaxColInConsole = val;
    };
    Object.defineProperty(Configs.prototype, "getTableMaxColInConsole", {
        get: function() {
            return this.tableMaxColInConsole;
        },
        enumerable: false,
        configurable: true
    });
    Configs.prototype.setMaxRow = function(val) {
        this.tableMaxRow = val;
    };
    Object.defineProperty(Configs.prototype, "getMaxRow", {
        get: function() {
            return this.tableMaxRow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configs.prototype, "getDtypeTestLim", {
        get: function() {
            return this.dtypeTestLim;
        },
        enumerable: false,
        configurable: true
    });
    Configs.prototype.setDtypeTestLim = function(val) {
        this.dtypeTestLim = val;
    };
    Object.defineProperty(Configs.prototype, "isLowMemoryMode", {
        get: function() {
            return this.lowMemoryMode;
        },
        enumerable: false,
        configurable: true
    });
    Configs.prototype.setIsLowMemoryMode = function(val) {
        this.lowMemoryMode = val;
    };
    return Configs;
}();
module.exports.default = $3693373fa47ca5c9$var$Configs;

});

parcelRegister("4j43E", function(module, exports) {
"use strict";
var $322c158ffd1c1335$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $322c158ffd1c1335$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $322c158ffd1c1335$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $322c158ffd1c1335$var$__createBinding(result, mod, k);
    }
    $322c158ffd1c1335$var$__setModuleDefault(result, mod);
    return result;
};
var $322c158ffd1c1335$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.__version = module.exports.tensorflow = module.exports.dateRange = module.exports.merge = module.exports.concat = module.exports.getDummies = module.exports.OneHotEncoder = module.exports.LabelEncoder = module.exports.StandardScaler = module.exports.MinMaxScaler = module.exports.DataFrame = module.exports.Series = module.exports.toDateTime = module.exports.Dt = module.exports.Str = module.exports.Utils = module.exports.Config = module.exports.NDframe = void 0;

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $322c158ffd1c1335$var$generic_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("1H0lk")));
module.exports.NDframe = $322c158ffd1c1335$var$generic_1.default;

var $322c158ffd1c1335$var$config_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("4Gv6O")));
module.exports.Config = $322c158ffd1c1335$var$config_1.default;

var $322c158ffd1c1335$var$utils_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("5MA6C")));
module.exports.Utils = $322c158ffd1c1335$var$utils_1.default;

var $322c158ffd1c1335$var$series_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("hIkcL")));
module.exports.Series = $322c158ffd1c1335$var$series_1.default;

var $322c158ffd1c1335$var$frame_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("6QWdY")));
module.exports.DataFrame = $322c158ffd1c1335$var$frame_1.default;

var $322c158ffd1c1335$var$strings_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("5iins")));
module.exports.Str = $322c158ffd1c1335$var$strings_1.default;

var $322c158ffd1c1335$var$datetime_1 = $322c158ffd1c1335$var$__importStar((parcelRequire("7umVJ")));
module.exports.Dt = $322c158ffd1c1335$var$datetime_1.default;
Object.defineProperty(module.exports, "toDateTime", {
    enumerable: true,
    get: function() {
        return $322c158ffd1c1335$var$datetime_1.toDateTime;
    }
});

var $322c158ffd1c1335$var$min_max_scaler_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("eFBgL")));
module.exports.MinMaxScaler = $322c158ffd1c1335$var$min_max_scaler_1.default;

var $322c158ffd1c1335$var$standard_scaler_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("4dUaX")));
module.exports.StandardScaler = $322c158ffd1c1335$var$standard_scaler_1.default;

var $322c158ffd1c1335$var$label_encoder_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("cMNpa")));
module.exports.LabelEncoder = $322c158ffd1c1335$var$label_encoder_1.default;

var $322c158ffd1c1335$var$one_hot_encoder_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("hUaPm")));
module.exports.OneHotEncoder = $322c158ffd1c1335$var$one_hot_encoder_1.default;

var $322c158ffd1c1335$var$dummy_encoder_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("38Fpc")));
module.exports.getDummies = $322c158ffd1c1335$var$dummy_encoder_1.default;

var $322c158ffd1c1335$var$concat_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("hlO5L")));
module.exports.concat = $322c158ffd1c1335$var$concat_1.default;

var $322c158ffd1c1335$var$merge_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("89ENH")));
module.exports.merge = $322c158ffd1c1335$var$merge_1.default;

var $322c158ffd1c1335$var$daterange_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("6oCk2")));
module.exports.dateRange = $322c158ffd1c1335$var$daterange_1.default;

var $322c158ffd1c1335$var$tensorflowlib_1 = $322c158ffd1c1335$var$__importDefault((parcelRequire("iySBu")));
module.exports.tensorflow = $322c158ffd1c1335$var$tensorflowlib_1.default;
var $322c158ffd1c1335$var$__version = "1.2.0";
module.exports.__version = $322c158ffd1c1335$var$__version;

});
parcelRegister("hIkcL", function(module, exports) {
"use strict";
var $ce5638028c09d8b3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ce5638028c09d8b3$var$__assign = module.exports && module.exports.__assign || function() {
    $ce5638028c09d8b3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ce5638028c09d8b3$var$__assign.apply(this, arguments);
};
var $ce5638028c09d8b3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ce5638028c09d8b3$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ce5638028c09d8b3$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $ce5638028c09d8b3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $ce5638028c09d8b3$var$dummy_encoder_1 = $ce5638028c09d8b3$var$__importDefault((parcelRequire("38Fpc")));

var $j3dDi = parcelRequire("j3dDi");

var $ce5638028c09d8b3$var$tensorflowlib_1 = $ce5638028c09d8b3$var$__importDefault((parcelRequire("iySBu")));

var $oCdZL = parcelRequire("oCdZL");

var $3zkxi = parcelRequire("3zkxi");

var $ce5638028c09d8b3$var$errors_1 = $ce5638028c09d8b3$var$__importDefault((parcelRequire("2n9qH")));

var $36CW2 = parcelRequire("36CW2");

var $ce5638028c09d8b3$var$utils_1 = $ce5638028c09d8b3$var$__importDefault((parcelRequire("5MA6C")));

var $ce5638028c09d8b3$var$generic_1 = $ce5638028c09d8b3$var$__importDefault((parcelRequire("1H0lk")));

var $4qjR5 = parcelRequire("4qjR5");

var $ce5638028c09d8b3$var$strings_1 = $ce5638028c09d8b3$var$__importDefault((parcelRequire("5iins")));

var $ce5638028c09d8b3$var$datetime_1 = $ce5638028c09d8b3$var$__importDefault((parcelRequire("7umVJ")));

var $hmLMy = parcelRequire("hmLMy");
var $ce5638028c09d8b3$var$utils = new $ce5638028c09d8b3$var$utils_1.default();
/**
 * One-dimensional ndarray with axis labels.
 * The object supports both integer- and label-based indexing and provides a host of methods for performing operations involving the index.
 * Operations between Series (+, -, /, , *) align values based on their associated index values – they need not be the same length.
 * @param data 1D Array, JSON, Tensor, Block of data.
 * @param options.index Array of numeric or string index for subseting array. If not specified, indices are auto generated.
 * @param options.columns Column name. This is like the name of the Series. If not specified, column name is set to 0.
 * @param options.dtypes Data types of the Series data. If not specified, dtypes is inferred.
 * @param options.config General configuration object for extending or setting Series behavior.
 */ var $ce5638028c09d8b3$var$Series = /** @class */ function(_super) {
    $ce5638028c09d8b3$var$__extends(Series, _super);
    function Series(data, options) {
        if (data === void 0) data = [];
        if (options === void 0) options = {};
        var _this = this;
        var index = options.index, columns = options.columns, dtypes = options.dtypes, config = options.config;
        if (Array.isArray(data[0]) || $ce5638028c09d8b3$var$utils.isObject(data[0])) {
            data = $ce5638028c09d8b3$var$utils.convert2DArrayToSeriesArray(data);
            _this = _super.call(this, {
                data: data,
                index: index,
                columns: columns,
                dtypes: dtypes,
                config: config,
                isSeries: true
            }) || this;
        } else _this = _super.call(this, {
            data: data,
            index: index,
            columns: columns,
            dtypes: dtypes,
            config: config,
            isSeries: true
        }) || this;
        return _this;
    }
    /**
    * Purely integer-location based indexing for selection by position.
    * ``.iloc`` is primarily integer position based (from ``0`` to
    * ``length-1`` of the axis), but may also be used with a boolean array.
    *
    * @param rows Array of row indexes
    *
    * Allowed inputs are in rows and columns params are:
    *
    * - An array of single integer, e.g. ``[5]``.
    * - A list or array of integers, e.g. ``[4, 3, 0]``.
    * - A slice array string with ints, e.g. ``["1:7"]``.
    * - A boolean array.
    * - A ``callable`` function with one argument (the calling Series or
    * DataFrame) and that returns valid output for indexing (one of the above).
    * This is useful in method chains, when you don't have a reference to the
    * calling object, but would like to base your selection on some value.
    *
    * ``.iloc`` will raise ``IndexError`` if a requested indexer is
    * out-of-bounds.
    *
    * @example
    * ```
    * const sf = new Series([1, 2, 3, 4, 5, 6], { index: ['a', 'b', 'c', 'd', 'e', 'f'] });
    * const sf2 = sf.iloc([0, 2, 4]);
    * sf2.print();
    * ```
    */ Series.prototype.iloc = function(rows) {
        return (0, $36CW2._iloc)({
            ndFrame: this,
            rows: rows
        });
    };
    /**
     * Access a group of rows by label(s) or a boolean array.
     * ``loc`` is primarily label based, but may also be used with a boolean array.
     *
     * @param rows Array of row indexes
     *
     * Allowed inputs are:
     *
     * - A single label, e.g. ``["5"]`` or ``['a']``, (note that ``5`` is interpreted as a
     *   *label* of the index, and **never** as an integer position along the index).
     *
     * - A list or array of labels, e.g. ``['a', 'b', 'c']``.
     *
     * - A slice object with labels, e.g. ``["a:f"]``. Note that start and the stop are included
     *
     * - A boolean array of the same length as the axis being sliced,
     * e.g. ``[True, False, True]``.
     *
     * - A ``callable`` function with one argument (the calling Series or
     * DataFrame) and that returns valid output for indexing (one of the above)
     *
     * @example
     * ```
     * const sf = new Series([1, 2, 3, 4, 5, 6], { index: ['a', 'b', 'c', 'd', 'e', 'f'] });
     * const sf2 = sf.loc(['a', 'c', 'e']);
     * sf2.print();
     * ```
     *
     * @example
     * ```
     * const sf = new Series([1, 2, 3, 4, 5, 6], { index: ['a', 'b', 'c', 'd', 'e', 'f'] });
     * const sf2 = sf.loc(sf.gt(2));
     * sf2.print();
     * ```
    */ Series.prototype.loc = function(rows) {
        return (0, $36CW2._loc)({
            ndFrame: this,
            rows: rows
        });
    };
    /**
      * Returns the first n values in a Series
      * @param rows The number of rows to return
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6], { index: ['a', 'b', 'c', 'd', 'e', 'f'] });
      * const sf2 = sf.head(3);
      * sf2.print();
      * ```
    */ Series.prototype.head = function(rows) {
        if (rows === void 0) rows = 5;
        if (rows <= 0) throw new Error("ParamError: Number of rows cannot be less than 1");
        if (this.shape[0] <= rows) return this.copy();
        if (this.shape[0] - rows < 0) throw new Error("ParamError: Number of rows cannot be greater than available rows in data");
        return this.iloc([
            "0:" + rows
        ]);
    };
    /**
      * Returns the last n values in a Series
      * @param rows The number of rows to return
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6], { index: ['a', 'b', 'c', 'd', 'e', 'f'] });
      * const sf2 = sf.tail(3);
      * sf2.print();
      * ```
    */ Series.prototype.tail = function(rows) {
        if (rows === void 0) rows = 5;
        if (rows <= 0) throw new Error("ParamError: Number of rows cannot be less than 1");
        if (this.shape[0] <= rows) return this.copy();
        if (this.shape[0] - rows < 0) throw new Error("ParamError: Number of rows cannot be greater than available rows in data");
        var startIdx = this.shape[0] - rows;
        return this.iloc([
            startIdx + ":"
        ]);
    };
    /**
     * Returns specified number of random rows in a Series
     * @param num The number of rows to return
     * @param options.seed An integer specifying the random seed that will be used to create the distribution.
     * @example
     * ```
     * const df = new Series([1, 2, 3, 4])
     * const df2 = await df.sample(2)
     * df2.print()
     * ```
     * @example
     * ```
     * const df = new Series([1, 2, 3, 4])
     * const df2 = await df.sample(1, { seed: 1 })
     * df2.print()
     * ```
    */ Series.prototype.sample = function(num, options) {
        if (num === void 0) num = 5;
        return $ce5638028c09d8b3$var$__awaiter(this, void 0, void 0, function() {
            var seed, shuffledIndex, sf;
            return $ce5638028c09d8b3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        seed = $ce5638028c09d8b3$var$__assign({
                            seed: 1
                        }, options).seed;
                        if (num > this.shape[0]) throw new Error("Sample size n cannot be bigger than size of dataset");
                        if (num < -1 || num == 0) throw new Error("Sample size cannot be less than -1 or be equal to 0");
                        num = num === -1 ? this.shape[0] : num;
                        return [
                            4 /*yield*/ ,
                            $ce5638028c09d8b3$var$tensorflowlib_1.default.data.array(this.index).shuffle(num, "" + seed).take(num).toArray()
                        ];
                    case 1:
                        shuffledIndex = _a.sent();
                        sf = this.iloc(shuffledIndex);
                        return [
                            2 /*return*/ ,
                            sf
                        ];
                }
            });
        });
    };
    Series.prototype.add = function(other, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (this.dtypes[0] == "string") $ce5638028c09d8b3$var$errors_1.default.throwStringDtypeOperationError("add");
        var newData = (0, $3zkxi._genericMathOp)({
            ndFrame: this,
            other: other,
            operation: "add"
        });
        if (inplace) this.$setValues(newData);
        else return $ce5638028c09d8b3$var$utils.createNdframeFromNewDataWithOldProps({
            ndFrame: this,
            newData: newData,
            isSeries: true
        });
    };
    Series.prototype.sub = function(other, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (this.dtypes[0] == "string") $ce5638028c09d8b3$var$errors_1.default.throwStringDtypeOperationError("sub");
        var newData = (0, $3zkxi._genericMathOp)({
            ndFrame: this,
            other: other,
            operation: "sub"
        });
        if (inplace) this.$setValues(newData);
        else return $ce5638028c09d8b3$var$utils.createNdframeFromNewDataWithOldProps({
            ndFrame: this,
            newData: newData,
            isSeries: true
        });
    };
    Series.prototype.mul = function(other, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (this.dtypes[0] == "string") $ce5638028c09d8b3$var$errors_1.default.throwStringDtypeOperationError("mul");
        var newData = (0, $3zkxi._genericMathOp)({
            ndFrame: this,
            other: other,
            operation: "mul"
        });
        if (inplace) this.$setValues(newData);
        else return $ce5638028c09d8b3$var$utils.createNdframeFromNewDataWithOldProps({
            ndFrame: this,
            newData: newData,
            isSeries: true
        });
    };
    Series.prototype.div = function(other, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (this.dtypes[0] == "string") $ce5638028c09d8b3$var$errors_1.default.throwStringDtypeOperationError("div");
        var newData = (0, $3zkxi._genericMathOp)({
            ndFrame: this,
            other: other,
            operation: "div"
        });
        if (inplace) this.$setValues(newData);
        else return $ce5638028c09d8b3$var$utils.createNdframeFromNewDataWithOldProps({
            ndFrame: this,
            newData: newData,
            isSeries: true
        });
    };
    Series.prototype.pow = function(other, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (this.dtypes[0] == "string") $ce5638028c09d8b3$var$errors_1.default.throwStringDtypeOperationError("pow");
        var newData = (0, $3zkxi._genericMathOp)({
            ndFrame: this,
            other: other,
            operation: "pow"
        });
        if (inplace) this.$setValues(newData);
        else return $ce5638028c09d8b3$var$utils.createNdframeFromNewDataWithOldProps({
            ndFrame: this,
            newData: newData,
            isSeries: true
        });
    };
    Series.prototype.mod = function(other, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (this.dtypes[0] == "string") $ce5638028c09d8b3$var$errors_1.default.throwStringDtypeOperationError("mod");
        var newData = (0, $3zkxi._genericMathOp)({
            ndFrame: this,
            other: other,
            operation: "mod"
        });
        if (inplace) this.$setValues(newData);
        else return $ce5638028c09d8b3$var$utils.createNdframeFromNewDataWithOldProps({
            ndFrame: this,
            newData: newData,
            isSeries: true
        });
    };
    /**
     * Checks if the array value passed has a compatible dtype, removes NaN values, and if
     * boolean values are present, converts them to integer values.
    */ Series.prototype.$checkAndCleanValues = function(values, operation) {
        if (this.dtypes[0] == "string") $ce5638028c09d8b3$var$errors_1.default.throwStringDtypeOperationError(operation);
        values = $ce5638028c09d8b3$var$utils.removeMissingValuesFromArray(values);
        if (this.dtypes[0] == "boolean") values = $ce5638028c09d8b3$var$utils.mapBooleansToIntegers(values, 1);
        return values;
    };
    /**
     * Returns the mean of elements in Series.
     * @example
     * ```
     * const sf = new Series([1, 2, 3, 4, 5, 6]);
     * console.log(sf.mean());
     * //output 3.5
     * ```
    */ Series.prototype.mean = function() {
        var values = this.$checkAndCleanValues(this.values, "mean");
        return values.reduce(function(a, b) {
            return a + b;
        }) / values.length;
    };
    /**
      * Returns the median of elements in Series
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6]);
      * console.log(sf.median());
      * //output 3.5
      * ```
    */ Series.prototype.median = function() {
        var values = this.$checkAndCleanValues(this.values, "median");
        return (0, $j3dDi.median)(values);
    };
    /**
      * Returns the modal value of elements in Series
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 4, 5, 6]);
      * console.log(sf.mode());
      * //output [ 4 ]
      * ```
      *
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 4, 5, 5, 6]);
      * console.log(sf.mode());
      * //output [ 4, 5 ]
      * ```
      *
    */ Series.prototype.mode = function() {
        var values = this.$checkAndCleanValues(this.values, "mode");
        return (0, $j3dDi.mode)(values);
    };
    /**
      * Returns the minimum value in a Series
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6]);
      * console.log(sf.min());
      * //output 1
      * ```
      *
    */ Series.prototype.min = function() {
        var values = this.$checkAndCleanValues(this.values, "min");
        var smallestValue = values[0];
        for(var i = 0; i < values.length; i++)smallestValue = smallestValue < values[i] ? smallestValue : values[i];
        return smallestValue;
    };
    /**
      * Returns the maximum value in a Series
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6]);
      * console.log(sf.max());
      * //output 6
      * ```
    */ Series.prototype.max = function() {
        var values = this.$checkAndCleanValues(this.values, "max");
        var biggestValue = values[0];
        for(var i = 0; i < values.length; i++)biggestValue = biggestValue > values[i] ? biggestValue : values[i];
        return biggestValue;
    };
    /**
      * Return the sum of the values in a series.
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6]);
      * console.log(sf.sum());
      * //output 21
      * ```
    */ Series.prototype.sum = function() {
        var values = this.$checkAndCleanValues(this.values, "sum");
        return values.reduce(function(sum, value) {
            return sum + value;
        }, 0);
    };
    /**
       * Return number of non-null elements in a Series
       * @example
       * ```
       * const sf = new Series([1, 2, 3, 4, 5, 6]);
       * console.log(sf.count());
       * //output 6
       * ```
       *
       * @example
       * ```
       * const sf = new Series([1, 2, 3, 4, 5, 6, NaN]);
       * console.log(sf.count());
       * //output 6
       * ```
    */ Series.prototype.count = function() {
        var values = $ce5638028c09d8b3$var$utils.removeMissingValuesFromArray(this.values);
        return values.length;
    };
    /**
      * Return maximum of series and other.
      * @param other Series, number or Array of numbers to check against
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6]);
      * const sf2 = sf.maximum(3);
      * console.log(sf2.values);
      * //output [ 3, 3, 3, 4, 5, 6 ]
      * ```
      *
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6]);
      * const sf2 = new Series([4, 1, 3, 40, 5, 3]);
      * const sf3 = sf.maximum(sf2);
      * console.log(sf3.values);
      * //output [ 4, 2, 3, 40, 5, 6 ]
      * ```
    */ Series.prototype.maximum = function(other) {
        if (this.dtypes[0] == "string") $ce5638028c09d8b3$var$errors_1.default.throwStringDtypeOperationError("maximum");
        var newData = (0, $3zkxi._genericMathOp)({
            ndFrame: this,
            other: other,
            operation: "maximum"
        });
        return new Series(newData, {
            columns: this.columns,
            index: this.index
        });
    };
    /**
      * Return minimum of series and other.
      * @param other Series, number of Array of numbers to check against
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6]);
      * const sf2 = sf.minimum(3);
      * console.log(sf2.values);
      * //output [ 1, 2, 3, 3, 3, 3 ]
      * ```
      *
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6]);
      * const sf2 = new Series([4, 1, 3, 40, 5, 3]);
      * const sf3 = sf.minimum(sf2);
      * console.log(sf3.values);
      * //output [ 1, 1, 3, 4, 5, 3 ]
      * ```
      *
    */ Series.prototype.minimum = function(other) {
        if (this.dtypes[0] == "string") $ce5638028c09d8b3$var$errors_1.default.throwStringDtypeOperationError("maximum");
        var newData = (0, $3zkxi._genericMathOp)({
            ndFrame: this,
            other: other,
            operation: "minimum"
        });
        return new Series(newData, {
            columns: this.columns,
            index: this.index
        });
    };
    Series.prototype.round = function(dp, options) {
        if (dp === void 0) dp = 1;
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (dp === undefined) dp = 1;
        var newValues = $ce5638028c09d8b3$var$utils.round(this.values, dp, true);
        if (inplace) this.$setValues(newValues);
        else return $ce5638028c09d8b3$var$utils.createNdframeFromNewDataWithOldProps({
            ndFrame: this,
            newData: newValues,
            isSeries: true
        });
    };
    /**
      * Return sample standard deviation of elements in Series
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6]);
      * console.log(sf.std());
      * //output 1.8708286933869707
      * ```
    */ Series.prototype.std = function() {
        var values = this.$checkAndCleanValues(this.values, "max");
        return (0, $j3dDi.std)(values);
    };
    /**
      *  Return unbiased variance of elements in a Series.
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6]);
      * console.log(sf.var());
      * //output 3.5
      * ```
    */ Series.prototype.var = function() {
        var values = this.$checkAndCleanValues(this.values, "max");
        return (0, $j3dDi.variance)(values);
    };
    /**
     * Return a boolean same-sized object indicating where elements are NaN.
     * NaN and undefined values gets mapped to true, and everything else gets mapped to false.
     * @example
     * ```
     * const sf = new Series([1, 2, 3, 4, NaN, 6]);
     * console.log(sf.isNaN());
     * //output [ false, false, false, false, true, false ]
     * ```
     *
    */ Series.prototype.isNa = function() {
        var newData = this.values.map(function(value) {
            if ($ce5638028c09d8b3$var$utils.isEmpty(value)) return true;
            else return false;
        });
        var sf = new Series(newData, {
            index: this.index,
            dtypes: [
                "boolean"
            ],
            config: this.config
        });
        return sf;
    };
    Series.prototype.fillNa = function(value, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (!value && typeof value !== "boolean" && typeof value !== "number") throw Error('ParamError: value must be specified');
        var newValues = [];
        this.values.forEach(function(val) {
            if ($ce5638028c09d8b3$var$utils.isEmpty(val)) newValues.push(value);
            else newValues.push(val);
        });
        if (inplace) this.$setValues(newValues);
        else return $ce5638028c09d8b3$var$utils.createNdframeFromNewDataWithOldProps({
            ndFrame: this,
            newData: newValues,
            isSeries: true
        });
    };
    Series.prototype.sortValues = function(options) {
        var _a = $ce5638028c09d8b3$var$__assign({
            ascending: true,
            inplace: false
        }, options), ascending = _a.ascending, inplace = _a.inplace;
        var sortedValues = [];
        var sortedIndex = [];
        var rangeIdx = $ce5638028c09d8b3$var$utils.range(0, this.index.length - 1);
        var sortedIdx = $ce5638028c09d8b3$var$utils.sortArrayByIndex(rangeIdx, this.values, this.dtypes[0]);
        for(var _i = 0, sortedIdx_1 = sortedIdx; _i < sortedIdx_1.length; _i++){
            var indx = sortedIdx_1[_i];
            sortedValues.push(this.values[indx]);
            sortedIndex.push(this.index[indx]);
        }
        if (ascending) {
            sortedValues = sortedValues.reverse();
            sortedIndex = sortedIndex.reverse();
        }
        if (inplace) {
            this.$setValues(sortedValues);
            this.$setIndex(sortedIndex);
        } else {
            var sf = new Series(sortedValues, {
                index: sortedIndex,
                dtypes: this.dtypes,
                config: this.config
            });
            return sf;
        }
    };
    /**
      * Makes a deep copy of a Series
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6]);
      * const sf2 = sf.copy();
      * ```
      *
    */ Series.prototype.copy = function() {
        var sf = new Series($ce5638028c09d8b3$var$__spreadArray([], this.values, true), {
            columns: $ce5638028c09d8b3$var$__spreadArray([], this.columns, true),
            index: $ce5638028c09d8b3$var$__spreadArray([], this.index, true),
            dtypes: $ce5638028c09d8b3$var$__spreadArray([], this.dtypes, true),
            config: $ce5638028c09d8b3$var$__assign({}, this.config)
        });
        return sf;
    };
    /**
      * Generate descriptive statistics.
      * Descriptive statistics include those that summarize the central tendency,
      * dispersion and shape of a dataset’s distribution, excluding NaN values.
      * @example
      * ```
      * const sf = new Series([1, 2, 3, 4, 5, 6]);
      * const sf2 = sf.describe();
      * sf2.print();
      * ```
    */ Series.prototype.describe = function() {
        if (this.dtypes[0] == "string") throw new Error("DType Error: Cannot generate descriptive statistics for Series with string dtype");
        else {
            var index = [
                'count',
                'mean',
                'std',
                'min',
                'median',
                'max',
                'variance'
            ];
            var count = this.count();
            var mean = this.mean();
            var std_1 = this.std();
            var min = this.min();
            var median_1 = this.median();
            var max = this.max();
            var variance_1 = this.var();
            var data = [
                count,
                mean,
                std_1,
                min,
                median_1,
                max,
                variance_1
            ];
            var sf = new Series(data, {
                index: index
            });
            return sf;
        }
    };
    Series.prototype.resetIndex = function(options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (inplace) this.$resetIndex();
        else {
            var sf = this.copy();
            sf.$resetIndex();
            return sf;
        }
    };
    Series.prototype.setIndex = function(index, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (!index) throw Error('Param Error: Must specify index array');
        if (inplace) this.$setIndex(index);
        else {
            var sf = this.copy();
            sf.$setIndex(index);
            return sf;
        }
    };
    Series.prototype.map = function(callable, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        var isCallable = $ce5638028c09d8b3$var$utils.isFunction(callable);
        var data = this.values.map(function(val, i) {
            if (isCallable) return callable(val, i);
            else if ($ce5638028c09d8b3$var$utils.isObject(callable)) {
                if (val in callable) //@ts-ignore
                return callable[val];
                else return val;
            } else throw new Error("Param Error: callable must either be a function or an object");
        });
        if (inplace) this.$setValues(data);
        else {
            var sf = this.copy();
            sf.$setValues(data);
            return sf;
        }
    };
    Series.prototype.apply = function(callable, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        var isCallable = $ce5638028c09d8b3$var$utils.isFunction(callable);
        if (!isCallable) throw new Error("Param Error: callable must be a function");
        var data = this.values.map(function(val) {
            return callable(val);
        });
        if (inplace) this.$setValues(data);
        else {
            var sf = this.copy();
            sf.$setValues(data);
            return sf;
        }
    };
    /**
     * Returns a Series with only the unique value(s) in the original Series
     * @example
     * ```
     * const sf = new Series([1, 2, 3, 4, 5, 6, 1, 2, 3, 4, 5, 6]);
     * const sf2 = sf.unique();
     * console.log(sf2.values);
     * //output [ 1, 2, 3, 4, 5, 6 ]
     * ```
    */ Series.prototype.unique = function() {
        var newValues = new Set(this.values);
        var series = new Series(Array.from(newValues));
        return series;
    };
    /**
     * Return the number of unique elements in a Series
     * @example
     * ```
     * const sf = new Series([1, 2, 3, 4, 5, 6, 1, 2, 3, 4, 5, 6]);
     * console.log(sf.nUnique());
     * //output 6
     * ```
     *
    */ Series.prototype.nUnique = function() {
        return new Set(this.values).size;
    };
    /**
     * Returns unique values and their counts in a Series
     * @example
     * ```
     * const sf = new Series([1, 2, 3, 4, 5, 6, 1, 2, 3, 4, 5, 6]);
     * const sf2 = sf.valueCounts();
     * sf2.print();
     * ```
    */ Series.prototype.valueCounts = function() {
        var sData = this.values;
        var dataDict = {};
        for(var i = 0; i < sData.length; i++){
            var val = sData[i];
            if ("" + val in dataDict) dataDict["" + val] = dataDict["" + val] + 1;
            else dataDict["" + val] = 1;
        }
        var index = Object.keys(dataDict).map(function(x) {
            return parseInt(x) ? parseInt(x) : x;
        });
        var data = Object.values(dataDict);
        var series = new Series(data, {
            index: index
        });
        return series;
    };
    Series.prototype.abs = function(options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (this.dtypes[0] == "string") $ce5638028c09d8b3$var$errors_1.default.throwStringDtypeOperationError("abs");
        var newValues;
        newValues = this.values.map(function(val) {
            return Math.abs(val);
        });
        if (inplace) this.$setValues(newValues);
        else {
            var sf = this.copy();
            sf.$setValues(newValues);
            return sf;
        }
    };
    Series.prototype.cumSum = function(options) {
        var ops = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options);
        return this.cumOps("sum", ops);
    };
    Series.prototype.cumMin = function(options) {
        var ops = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options);
        return this.cumOps("min", ops);
    };
    Series.prototype.cumMax = function(options) {
        var ops = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options);
        return this.cumOps("max", ops);
    };
    Series.prototype.cumProd = function(options) {
        var ops = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options);
        return this.cumOps("prod", ops);
    };
    /**
     * Internal helper function to calculate cumulative operations on series data
    */ Series.prototype.cumOps = function(ops, options) {
        if (this.dtypes[0] == "string") $ce5638028c09d8b3$var$errors_1.default.throwStringDtypeOperationError(ops);
        var inplace = options.inplace;
        var sData = this.values;
        var tempval = sData[0];
        var data = [
            tempval
        ];
        for(var i = 1; i < sData.length; i++){
            var currVal = sData[i];
            switch(ops){
                case "max":
                    if (currVal > tempval) {
                        data.push(currVal);
                        tempval = currVal;
                    } else data.push(tempval);
                    break;
                case "min":
                    if (currVal < tempval) {
                        data.push(currVal);
                        tempval = currVal;
                    } else data.push(tempval);
                    break;
                case "sum":
                    tempval = tempval + currVal;
                    data.push(tempval);
                    break;
                case "prod":
                    tempval = tempval * currVal;
                    data.push(tempval);
                    break;
            }
        }
        if (inplace) this.$setValues(data);
        else return new Series(data, {
            index: this.index,
            config: $ce5638028c09d8b3$var$__assign({}, this.config)
        });
    };
    /**
       * Returns less than of series and other. Supports element wise operations
       * @param other Series, number, or Array of numbers to compare against
       * @example
       * ```
       * const sf = new Series([1, 2, 3, 4, 5, 6]);
       * const sf2 = sf.lt(3);
       * console.log(sf2.values);
       * //output [ true, true, false, false, false, false ]
       * ```
       *
       * @example
       * ```
       * const sf = new Series([1, 2, 3, 4, 5, 6]);
       * const sf2 = sf.lt([3, 4, 5, 6, 7, 8]);
       * console.log(sf2.values);
       * //output [ true, true, false, false, false, false ]
       * ```
    */ Series.prototype.lt = function(other) {
        return this.boolOps(other, "lt");
    };
    /**
       * Returns Greater than of series and other. Supports element wise operations
       * @param other Series, number or Array of numbers to compare against
       * @example
       * ```
       * const sf = new Series([1, 2, 3, 4, 5, 6]);
       * const sf2 = sf.gt(3);
       * console.log(sf2.values);
       * //output [ false, false, true, true, true, true ]
       * ```
       *
       * @example
       * ```
       * const sf = new Series([1, 2, 3, 4, 5, 6]);
       * const sf2 = sf.gt([3, 4, 5, 6, 7, 8]);
       * console.log(sf2.values);
       * //output [ false, false, true, true, true, true ]
       * ```
    */ Series.prototype.gt = function(other) {
        return this.boolOps(other, "gt");
    };
    /**
       * Returns Less than or Equal to of series and other. Supports element wise operations
       * @param other Series, number or Array of numbers to compare against
       * @example
       * ```
       * const sf = new Series([1, 2, 3, 4, 5, 6]);
       * const sf2 = sf.le(3);
       * console.log(sf2.values);
       * //output [ true, true, true, true, false, false ]
       * ```
       *
       * @example
       * ```
       * const sf = new Series([1, 2, 3, 4, 5, 6]);
       * const sf2 = sf.le([3, 4, 5, 6, 7, 8]);
       * console.log(sf2.values);
       * //output [ true, true, true, true, false, false ]
       * ```
       *
    */ Series.prototype.le = function(other) {
        return this.boolOps(other, "le");
    };
    /**
       * Returns Greater than or Equal to of series and other. Supports element wise operations
       * @param other Series, number or Array of numbers to compare against
       * @example
       * ```
       * const sf = new Series([1, 2, 3, 4, 5, 6]);
       * const sf2 = sf.ge(3);
       * console.log(sf2.values);
       * //output [ false, false, true, true, true, true ]
       * ```
       *
       * @example
       * ```
       * const sf = new Series([1, 2, 3, 4, 5, 6]);
       * const sf2 = sf.ge([3, 4, 5, 6, 7, 8]);
       * console.log(sf2.values);
       * //output [ false, false, true, true, true, true ]
       * ```
       */ Series.prototype.ge = function(other) {
        return this.boolOps(other, "ge");
    };
    /**
        * Returns Not Equal to of series and other. Supports element wise operations
        * @param other Series, number or Array of numbers to compare against
        * @example
        * ```
        * const sf = new Series([1, 2, 3, 4, 5, 6]);
        * const sf2 = sf.ne(3);
        * console.log(sf2.values);
        * //output [ true, true, false, true, true, true ]
        * ```
        *
        * @example
        * ```
        * const sf = new Series([1, 2, 3, 4, 5, 6]);
        * const sf2 = sf.ne([3, 2, 5, 6, 7, 8]);
        * console.log(sf2.values);
        * //output [ true, false, true, true, true, true ]
        * ```
        *
    */ Series.prototype.ne = function(other) {
        return this.boolOps(other, "ne");
    };
    /**
       * Returns Equal to of series and other. Supports element wise operations
       * @param other Series, number or Array of numbers to compare against
       * @example
       * ```
       * const sf = new Series([1, 2, 3, 4, 5, 6]);
       * const sf2 = sf.eq(3);
       * console.log(sf2.values);
       * //output [ false, false, true, false, false, false ]
       * ```
       *
       * @example
       * ```
       * const sf = new Series([1, 2, 3, 4, 5, 6]);
       * const sf2 = sf.eq(new Series([3, 2, 5, 6, 7, 8]));
       * console.log(sf2.values);
       * //output [ false, true, false, false, false, false ]
       * ```
       */ Series.prototype.eq = function(other) {
        return this.boolOps(other, "eq");
    };
    /**
     * Internal function to perform boolean operations
     * @param other Other Series or number to compare with
     * @param bOps Name of operation to perform [ne, ge, le, gt, lt, eq]
     */ Series.prototype.boolOps = function(other, bOps) {
        var data = [];
        var lSeries = this.values;
        var rSeries;
        if (typeof other == "number") rSeries = Array(this.values.length).fill(other); //create array of repeated value for broadcasting
        else if (typeof other == "string" && [
            "eq",
            "ne"
        ].includes(bOps)) rSeries = Array(this.values.length).fill(other);
        else if (other instanceof Series) rSeries = other.values;
        else if (Array.isArray(other)) rSeries = other;
        else throw new Error("ParamError: value for other not supported. It must be either a scalar, Array or Series");
        if (!(lSeries.length === rSeries.length)) throw new Error("LengthError: length of other must be equal to length of Series");
        for(var i = 0; i < lSeries.length; i++){
            var lVal = lSeries[i];
            var rVal = rSeries[i];
            var bool = null;
            switch(bOps){
                case "lt":
                    bool = lVal < rVal ? true : false;
                    data.push(bool);
                    break;
                case "gt":
                    bool = lVal > rVal ? true : false;
                    data.push(bool);
                    break;
                case "le":
                    bool = lVal <= rVal ? true : false;
                    data.push(bool);
                    break;
                case "ge":
                    bool = lVal >= rVal ? true : false;
                    data.push(bool);
                    break;
                case "ne":
                    bool = lVal !== rVal ? true : false;
                    data.push(bool);
                    break;
                case "eq":
                    bool = lVal === rVal ? true : false;
                    data.push(bool);
                    break;
            }
        }
        return new Series(data, {
            index: this.index,
            config: $ce5638028c09d8b3$var$__assign({}, this.config)
        });
    };
    Series.prototype.replace = function(oldValue, newValue, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (typeof oldValue === 'number' && isNaN(oldValue)) throw Error("Params Error: Param 'oldValue' does not support NaN. Use Series.fillNa() instead.");
        if (!oldValue && typeof oldValue !== 'boolean' && typeof oldValue !== 'number' && typeof oldValue !== 'string') throw Error("Params Error: Must specify param 'oldValue' to replace");
        if (!newValue && typeof newValue !== 'boolean' && typeof newValue !== 'number' && typeof newValue !== 'string') throw Error("Params Error: Must specify param 'newValue' to replace with");
        var newArr = $ce5638028c09d8b3$var$__spreadArray([], this.values, true).map(function(val) {
            if (val === oldValue) return newValue;
            else return val;
        });
        if (inplace) this.$setValues(newArr);
        else {
            var sf = this.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Series.prototype.dropNa = function(options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        var oldValues = this.values;
        var oldIndex = this.index;
        var newValues = [];
        var newIndex = [];
        var isNaVals = this.isNa().values;
        isNaVals.forEach(function(val, i) {
            if (!val) {
                newValues.push(oldValues[i]);
                newIndex.push(oldIndex[i]);
            }
        });
        if (inplace) {
            this.$setValues(newValues, false);
            this.$setIndex(newIndex);
        } else {
            var sf = this.copy();
            sf.$setValues(newValues, false);
            sf.$setIndex(newIndex);
            return sf;
        }
    };
    /**
     * Returns the integer indices that would sort the Series.
     * @param ascending Boolean indicating whether to sort in ascending order or not. Defaults to true
     * @example
     * ```
     * const sf = new Series([3, 1, 2]);
     * const sf2 = sf.argSort();
     * console.log(sf2.values);
     * //output [ 1, 2, 0 ]
     * ```
     *
     * @example
     * ```
     * const sf = new Series([3, 1, 2]);
     * const sf2 = sf.argSort({ascending: false});
     * console.log(sf2.values);
     * //output [ 0, 2, 1 ]
     *
     */ Series.prototype.argSort = function(options) {
        var ascending = $ce5638028c09d8b3$var$__assign({
            ascending: true
        }, options).ascending;
        var sortedIndex = this.sortValues({
            ascending: ascending
        });
        var sf = new Series(sortedIndex.index);
        return sf;
    };
    /**
       * Returns integer position of the largest value in the Series.
       * @example
       * ```
       * const sf = new Series([3, 1, 2]);
       * const sf2 = sf.argMax();
       * console.log(sf2);
       * //output 0
       * ```
       *
    */ Series.prototype.argMax = function() {
        return this.tensor.argMax().arraySync();
    };
    /**
       * Returns integer position of the smallest value in the Series.
       * @example
       * ```
       * const sf = new Series([3, 1, 2]);
       * const sf2 = sf.argMin();
       * console.log(sf2);
       * //output 1
       * ```
       *
    */ Series.prototype.argMin = function() {
        return this.tensor.argMin().arraySync();
    };
    Series.prototype.dropDuplicates = function(options) {
        var _a = $ce5638028c09d8b3$var$__assign({
            keep: "first",
            inplace: false
        }, options), keep = _a.keep, inplace = _a.inplace;
        if (![
            "first",
            "last"
        ].includes(keep)) throw Error("Params Error: Keep must be one of 'first' or 'last'");
        var dataArr;
        var newArr = [];
        var oldIndex;
        var newIndex = [];
        if (keep === "last") {
            dataArr = this.values.reverse();
            oldIndex = this.index.reverse();
        } else {
            dataArr = this.values;
            oldIndex = this.index;
        }
        dataArr.forEach(function(val, i) {
            if (!newArr.includes(val)) {
                newIndex.push(oldIndex[i]);
                newArr.push(val);
            }
        });
        if (keep === "last") {
            //re-reversed the array and index to its true order
            newArr = newArr.reverse();
            newIndex = newIndex.reverse();
        }
        if (inplace) {
            this.$setValues(newArr, false);
            this.$setIndex(newIndex);
        } else {
            var sf = this.copy();
            sf.$setValues(newArr, false);
            sf.$setIndex(newIndex);
            return sf;
        }
    };
    Series.prototype.asType = function(dtype, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (!dtype) throw Error("Param Error: Please specify dtype to cast to");
        if (!$oCdZL.DATA_TYPES.includes(dtype)) throw Error("dtype " + dtype + " not supported. dtype must be one of " + $oCdZL.DATA_TYPES);
        var oldValues = $ce5638028c09d8b3$var$__spreadArray([], this.values, true);
        var newValues = [];
        switch(dtype){
            case "float32":
                oldValues.forEach(function(val) {
                    newValues.push(Number(val));
                });
                break;
            case "int32":
                oldValues.forEach(function(val) {
                    newValues.push(parseInt(val));
                });
                break;
            case "string":
                oldValues.forEach(function(val) {
                    newValues.push(String(val));
                });
                break;
            case "boolean":
                oldValues.forEach(function(val) {
                    newValues.push(Boolean(val));
                });
                break;
            case "undefined":
                oldValues.forEach(function(_) {
                    newValues.push(NaN);
                });
                break;
            default:
                break;
        }
        if (inplace) {
            this.$setValues(newValues, false);
            this.$setDtypes([
                dtype
            ]);
        } else {
            var sf = this.copy();
            sf.$setValues(newValues, false);
            sf.$setDtypes([
                dtype
            ]);
            return sf;
        }
    };
    Series.prototype.append = function(newValue, index, options) {
        var inplace = $ce5638028c09d8b3$var$__assign({
            inplace: false
        }, options).inplace;
        if (!newValue && typeof newValue !== "boolean" && typeof newValue !== "number") throw Error("Param Error: newValue cannot be null or undefined");
        if (!index) throw Error("Param Error: index cannot be null or undefined");
        var newData = $ce5638028c09d8b3$var$__spreadArray([], this.values, true);
        var newIndx = $ce5638028c09d8b3$var$__spreadArray([], this.index, true);
        if (Array.isArray(newValue) && Array.isArray(index)) {
            if (newValue.length !== index.length) throw Error("Param Error: Length of new values and index must be the same");
            newValue.forEach(function(el, i) {
                newData.push(el);
                newIndx.push(index[i]);
            });
        } else if (newValue instanceof Series) {
            var _value = newValue.values;
            if (!Array.isArray(index)) throw Error("Param Error: index must be an array");
            if (index.length !== _value.length) throw Error("Param Error: Length of new values and index must be the same");
            _value.forEach(function(el, i) {
                newData.push(el);
                newIndx.push(index[i]);
            });
        } else {
            newData.push(newValue);
            newIndx.push(index);
        }
        if (inplace) {
            this.$setValues(newData, false);
            this.$setIndex(newIndx);
        } else {
            var sf = new Series(newData, {
                index: newIndx,
                columns: this.columns,
                dtypes: this.dtypes,
                config: this.config
            });
            return sf;
        }
    };
    Object.defineProperty(Series.prototype, "dtype", {
        /**
         * Returns dtype of Series
         * @example
         * ```
         * const sf = new Series([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
         * console.log(sf.dtype);
         * //output "int32"
         * ```
        */ get: function() {
            return this.dtypes[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "str", {
        /**
         * Exposes numerous string methods to manipulate Series of string dtype
         * @example
         * ```
         * const sf = new Series(["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"]);
         * const sfs = sf.str.join("HelloWorld", "");
         * console.log(sfs.values);
         * //output ["aHelloWorld", "bHelloWorld", "cHelloWorld", "dHelloWorld", "eHelloWorld", "fHelloWorld", "gHelloWorld", "hHelloWorld", "iHelloWorld", "jHelloWorld"]
         * ```
        */ get: function() {
            if (this.dtypes[0] == "string") return new $ce5638028c09d8b3$var$strings_1.default(this);
            else throw new Error("Cannot call accessor str on non-string type");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "dt", {
        /**
          * Returns time class that exposes different date time method
          * @example
          * ```
          * const sf = new Series([
          *  "2020-01-01",
          *  "2020-01-02",
          *  "2020-01-03",
          *  "2020-01-04",
          *  "2020-01-05",
          * ]);
          * const sfd = sf.dt.dayOfWeekName();
          * console.log(sfd.values);
          * //output [ 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday' ]
          * ```
        */ get: function() {
            if ([
                "string",
                "datetime"
            ].includes(this.dtypes[0])) return new $ce5638028c09d8b3$var$datetime_1.default(this);
            else throw new Error("Cannot call accessor dt on non-string type");
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Overrides default toString implementation. This essentially makes `print()` works.
    */ Series.prototype.toString = function() {
        var maxRow = this.$config.getMaxRow;
        var indx;
        var values = [];
        if (this.shape[0] > maxRow) {
            //slice rows to show [max_rows] rows
            var sfSlice = this.iloc([
                "0:" + maxRow
            ]);
            indx = sfSlice.index;
            values = sfSlice.values;
        } else {
            indx = this.index;
            values = this.values;
        }
        var tabledata = values.map(function(x, i) {
            return [
                indx[i],
                x
            ];
        });
        return (0, $4qjR5.table)(tabledata);
    };
    /**
     * Returns the logical AND between Series and other. Supports element wise operations and broadcasting.
     * @param other Series, Scalar, Array of Scalars
     * @example
     * ```
     * const sf = new Series([true, true, false, false, true]);
     * const sf2 = new Series([true, false, true, false, true]);
     * const sf3 = sf.and(sf2);
     * console.log(sf3.values);
     * //output [ true, false, false, false, false ]
     * ```
    */ Series.prototype.and = function(other) {
        if (other === undefined) throw new Error("Param Error: other cannot be undefined");
        var newValues = [];
        if (other instanceof Series) {
            if (this.dtypes[0] !== other.dtypes[0]) throw new Error("Param Error: Series must be of same dtype");
            if (this.shape[0] !== other.shape[0]) throw new Error("Param Error: Series must be of same shape");
            this.values.forEach(function(val, i) {
                newValues.push(Boolean(val) && Boolean(other.values[i]));
            });
        } else if (typeof other === "boolean") this.values.forEach(function(val) {
            newValues.push(Boolean(val) && Boolean(other));
        });
        else if (Array.isArray(other)) this.values.forEach(function(val, i) {
            newValues.push(Boolean(val) && Boolean(other[i]));
        });
        else throw new Error("Param Error: other must be a Series, Scalar, or Array of Scalars");
        return new Series(newValues, {
            index: this.index,
            config: $ce5638028c09d8b3$var$__assign({}, this.config)
        });
    };
    /**
     * Returns the logical OR between Series and other. Supports element wise operations and broadcasting.
     * @param other Series, Scalar, Array of Scalars
     * @example
     * ```
     * const sf = new Series([true, true, false, false, true]);
     * const sf2 = new Series([true, false, true, false, true]);
     * const sf3 = sf.or(sf2);
     * console.log(sf3.values);
     * //output [ true, true, true, false, true ]
     * ```
     *
    */ Series.prototype.or = function(other) {
        if (other === undefined) throw new Error("Param Error: other cannot be undefined");
        var newValues = [];
        if (other instanceof Series) {
            if (this.dtypes[0] !== other.dtypes[0]) throw new Error("Param Error: Series must be of same dtype");
            if (this.shape[0] !== other.shape[0]) throw new Error("Param Error: Series must be of same shape");
            this.values.forEach(function(val, i) {
                newValues.push(Boolean(val) || Boolean(other.values[i]));
            });
        } else if (typeof other === "boolean") this.values.forEach(function(val) {
            newValues.push(Boolean(val) || Boolean(other));
        });
        else if (Array.isArray(other)) this.values.forEach(function(val, i) {
            newValues.push(Boolean(val) || Boolean(other[i]));
        });
        else throw new Error("Param Error: other must be a Series, Scalar, or Array of Scalars");
        return new Series(newValues, {
            index: this.index,
            config: $ce5638028c09d8b3$var$__assign({}, this.config)
        });
    };
    /**
     * One-hot encode values in the Series.
     * @param options Options for the operation. The following options are available:
     * - `prefix`: Prefix to add to the new column. Defaults to unique labels.
     * - `prefixSeparator`: Separator to use for the prefix. Defaults to '_'.
     * @example
     * ```
     * const sf = new Series(["a", "b", "c", "a"]);
     * const sf2 = sf.getDummies({ prefix: "category" });
     * console.log(sf2.values);
     * //output [ [ 1, 0, 0 ], [ 0, 1, 0 ], [ 0, 0, 1 ], [ 1, 0, 0 ] ]
     * ```
     *
     * @example
     * ```
     * const sf = new Series(["a", "b", "c", "a"]);
     * const sf2 = sf.getDummies({ prefix: "category", prefixSeparator: "-" });
     * console.log(sf2.values);
     * //output [ [ 1, 0, 0 ], [ 0, 1, 0 ], [ 0, 0, 1 ], [ 1, 0, 0 ] ]
     * ```
     */ Series.prototype.getDummies = function(options) {
        return (0, $ce5638028c09d8b3$var$dummy_encoder_1.default)(this, options);
    };
    /**
     * Access a single value for a row index.
     * Similar to iloc, in that both provide index-based lookups.
     * Use iat if you only need to get or set a single value in a Series.
     * @param row Row index of the value to access.
     * @example
     * ```
     * const sf = new Series([1, 2, 3, 4, 5])
     * sf.iat(0) //returns 1
     * sf.iat(1) //returns 2
     * sf.iat(2) //returns 3
     * ```
    */ Series.prototype.iat = function(row) {
        if (typeof row === 'string') throw new Error('ParamError: row index must be an integer. Use .at to get a row by label.');
        return this.values[row];
    };
    /**
     * Access a single value for a row label.
     * Similar to loc, in that both provide label-based lookups.
     * Use at if you only need to get or set a single value in a Series.
     * @param row Row label of the value to access.
     * @example
     * ```
     * const sf = new Series([1, 2, 3, 4, 5, 6], { index: ['A', 'B', 'C', 'D', 'E', 'F'] })
     * sf.at('A') //returns 1
     * sf.at('B') //returns 2
     * sf.at('C') //returns 3
     * ```
    */ Series.prototype.at = function(row) {
        if (typeof row !== 'string') throw new Error('ParamError: row index must be a string. Use .iat to get a row by index.');
        return this.values[this.index.indexOf(row)];
    };
    /**
     * Exposes functions for creating charts from a DataFrame.
     * Charts are created using the Plotly.js library, so all Plotly's configuration parameters are available.
     * @param divId name of the HTML Div to render the chart in.
    */ Series.prototype.plot = function(divId) {
        //TODO: Add support for check plot library to use. So we can support other plot library like d3, vega, etc
        if ($ce5638028c09d8b3$var$utils.isBrowserEnv()) {
            var plt = new $hmLMy.PlotlyLib(this, divId);
            return plt;
        } else throw new Error("Not supported in NodeJS");
    };
    return Series;
}($ce5638028c09d8b3$var$generic_1.default);
module.exports.default = $ce5638028c09d8b3$var$Series;

});
parcelRegister("38Fpc", function(module, exports) {
"use strict";
var $24923cb56b4c7841$var$__assign = module.exports && module.exports.__assign || function() {
    $24923cb56b4c7841$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $24923cb56b4c7841$var$__assign.apply(this, arguments);
};
var $24923cb56b4c7841$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $24923cb56b4c7841$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $24923cb56b4c7841$var$frame_1 = $24923cb56b4c7841$var$__importDefault((parcelRequire("6QWdY")));

var $24923cb56b4c7841$var$series_1 = $24923cb56b4c7841$var$__importDefault((parcelRequire("hIkcL")));

var $24923cb56b4c7841$var$utils_1 = $24923cb56b4c7841$var$__importDefault((parcelRequire("5MA6C")));
var $24923cb56b4c7841$var$utils = new $24923cb56b4c7841$var$utils_1.default();
/**
 * Generate one-hot encoding for categorical columns in an Array, Series or Dataframe.
 * @param data Series or Dataframe
 * @param columns Columns to encode
 * @param prefix Prefix for the new columns
 * @param prefixSeparator Separator for the prefix and the column name
 * @returns Encoded Dataframe
 * @example
 * import { DataFrame, DummyEncoder }from 'danfojs';
 * const df = new DataFrame([[1,2,3], [4,5,6]], { columns: ['a', 'b', 'c'] });
 * const df2 = new DummyEncoder({data: df, columns: ['a', 'b'], prefix: 'enc', prefixSeparator: '#'}).encode();
 * df2.print();
 */ function $24923cb56b4c7841$var$dummyEncode(data, options) {
    var _a = $24923cb56b4c7841$var$__assign({
        columns: null,
        prefix: null,
        prefixSeparator: "_"
    }, options), columns = _a.columns, prefix = _a.prefix, prefixSeparator = _a.prefixSeparator;
    if (!data) throw new Error('ParamError: data must be one of Array, Series or DataFrame');
    if (data instanceof $24923cb56b4c7841$var$series_1.default || data instanceof $24923cb56b4c7841$var$frame_1.default) {
        if (!columns) {
            var colsWithStringDtype_1 = [];
            data.dtypes.forEach(function(dtype, index) {
                if (dtype === "string") colsWithStringDtype_1.push(data.columns[index]);
            });
            columns = colsWithStringDtype_1;
        }
    } else throw new Error('ParamError: data must be one of Array, Series or DataFrame');
    if (typeof columns === "string") {
        columns = [
            columns
        ];
        if (Array.isArray(prefix) && prefix.length === 1) prefix;
        else if (typeof prefix === "string") prefix = [
            prefix
        ];
        else throw new Error('ParamError: prefix must be a string, or an array of same length as columns');
        if (Array.isArray(prefixSeparator) && prefixSeparator.length === 1) prefixSeparator;
        else if (typeof prefixSeparator === "string") prefixSeparator = [
            prefixSeparator
        ];
        else throw new Error('ParamError: prefix must be a string, or an array of same length as columns');
    } else if (Array.isArray(columns)) {
        if (prefix) {
            if (Array.isArray(prefix) && prefix.length !== columns.length) throw new Error("ParamError: prefix and data array must be of the same length. If you need to use the same prefix, then pass a string param instead. e.g {prefix: \"" + prefix + "\"}");
            if (typeof prefix === "string") prefix = columns.map(function(_) {
                return prefix;
            });
        }
        if (prefixSeparator) {
            if (Array.isArray(prefixSeparator) && prefixSeparator.length !== columns.length) throw new Error("ParamError: prefixSeparator and data array must be of the same length. If you need to use the same prefix separator, then pass a string param instead. e.g {prefixSeparator: \"" + prefixSeparator + "\"}");
            if (typeof prefixSeparator === "string") prefixSeparator = columns.map(function(_) {
                return prefixSeparator;
            });
        }
    } else throw new Error('ParamError: columns must be a string or an array of strings');
    if (data instanceof $24923cb56b4c7841$var$series_1.default) {
        var colData = data.values;
        var newColumnNames = [];
        var uniqueValues = Array.from(new Set(colData));
        var oneHotArr = $24923cb56b4c7841$var$utils.zeros(colData.length, uniqueValues.length);
        for(var i = 0; i < colData.length; i++){
            var index = uniqueValues.indexOf(colData[i]);
            oneHotArr[i][index] = 1;
        }
        for(var i = 0; i < uniqueValues.length; i++){
            var prefixToAdd = prefix ? prefix[0] : i;
            newColumnNames.push("" + prefixToAdd + prefixSeparator[0] + uniqueValues[i]);
        }
        return new $24923cb56b4c7841$var$frame_1.default(oneHotArr, {
            columns: newColumnNames
        });
    } else {
        var dfWithSelectedColumnsDropped = data.drop({
            columns: columns
        });
        var newData = dfWithSelectedColumnsDropped === null || dfWithSelectedColumnsDropped === void 0 ? void 0 : dfWithSelectedColumnsDropped.values;
        var newColumnNames = dfWithSelectedColumnsDropped === null || dfWithSelectedColumnsDropped === void 0 ? void 0 : dfWithSelectedColumnsDropped.columns;
        for(var i = 0; i < columns.length; i++){
            var column = columns[i];
            var colData = data.column(column).values;
            var uniqueValues = Array.from(new Set(colData));
            var oneHotArr = $24923cb56b4c7841$var$utils.zeros(colData.length, uniqueValues.length);
            for(var j = 0; j < colData.length; j++){
                var index = uniqueValues.indexOf(colData[j]);
                oneHotArr[j][index] = 1;
                var prefixToAdd = prefix ? prefix[i] : column;
                var newColName = "" + prefixToAdd + prefixSeparator[i] + colData[j];
                if (!newColumnNames.includes(newColName)) newColumnNames.push(newColName);
            }
            for(var k = 0; k < newData.length; k++)newData[k] = $24923cb56b4c7841$var$__spreadArray($24923cb56b4c7841$var$__spreadArray([], newData[k], true), oneHotArr[k], true);
        }
        return new $24923cb56b4c7841$var$frame_1.default(newData, {
            columns: newColumnNames
        });
    }
}
module.exports.default = $24923cb56b4c7841$var$dummyEncode;

});
parcelRegister("6QWdY", function(module, exports) {
"use strict";
var $4fd4c38d994b420a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4fd4c38d994b420a$var$__assign = module.exports && module.exports.__assign || function() {
    $4fd4c38d994b420a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4fd4c38d994b420a$var$__assign.apply(this, arguments);
};
var $4fd4c38d994b420a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4fd4c38d994b420a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4fd4c38d994b420a$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $4fd4c38d994b420a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $4fd4c38d994b420a$var$dummy_encoder_1 = $4fd4c38d994b420a$var$__importDefault((parcelRequire("38Fpc")));

var $j3dDi = parcelRequire("j3dDi");

var $4fd4c38d994b420a$var$tensorflowlib_1 = $4fd4c38d994b420a$var$__importDefault((parcelRequire("iySBu")));

var $oCdZL = parcelRequire("oCdZL");

var $4fd4c38d994b420a$var$groupby_1 = $4fd4c38d994b420a$var$__importDefault((parcelRequire("7hVND")));

var $4fd4c38d994b420a$var$errors_1 = $4fd4c38d994b420a$var$__importDefault((parcelRequire("2n9qH")));

var $36CW2 = parcelRequire("36CW2");

var $4fd4c38d994b420a$var$utils_1 = $4fd4c38d994b420a$var$__importDefault((parcelRequire("5MA6C")));

var $4fd4c38d994b420a$var$generic_1 = $4fd4c38d994b420a$var$__importDefault((parcelRequire("1H0lk")));

var $4qjR5 = parcelRequire("4qjR5");

var $4fd4c38d994b420a$var$series_1 = $4fd4c38d994b420a$var$__importDefault((parcelRequire("hIkcL")));

var $hmLMy = parcelRequire("hmLMy");
var $4fd4c38d994b420a$var$utils = new $4fd4c38d994b420a$var$utils_1.default();
/**
 * Two-dimensional ndarray with axis labels.
 * The object supports both integer- and label-based indexing and provides a host of methods for performing operations involving the index.
 * Operations between DataFrame (+, -, /, , *) align values based on their associated index values– they need not be the same length.
 * @param data 2D Array, JSON, Tensor, Block of data.
 * @param options.index Array of numeric or string names for subseting array. If not specified, indexes are auto generated.
 * @param options.columns Array of column names. If not specified, column names are auto generated.
 * @param options.dtypes Array of data types for each the column. If not specified, dtypes are/is inferred.
 * @param options.config General configuration object for extending or setting NDframe behavior.
 */ var $4fd4c38d994b420a$var$DataFrame = /** @class */ function(_super) {
    $4fd4c38d994b420a$var$__extends(DataFrame, _super);
    function DataFrame(data, options) {
        if (options === void 0) options = {};
        var _this = this;
        var index = options.index, columns = options.columns, dtypes = options.dtypes, config = options.config;
        _this = _super.call(this, {
            data: data,
            index: index,
            columns: columns,
            dtypes: dtypes,
            config: config,
            isSeries: false
        }) || this;
        _this.$setInternalColumnDataProperty();
        return _this;
    }
    /**
     * Maps all column names to their corresponding data, and return them as Series objects.
     * This makes column subsetting works. E.g this can work ==> `df["col1"]`
     * @param column Optional, a single column name to map
     */ DataFrame.prototype.$setInternalColumnDataProperty = function(column) {
        var self = this;
        if (column && typeof column === "string") Object.defineProperty(self, column, {
            get: function() {
                return self.$getColumnData(column);
            },
            set: function(arr) {
                self.$setColumnData(column, arr);
            }
        });
        else {
            var columns = this.columns;
            var _loop_1 = function(i) {
                var column_1 = columns[i];
                Object.defineProperty(this_1, column_1, {
                    get: function() {
                        return self.$getColumnData(column_1);
                    },
                    set: function(arr) {
                        self.$setColumnData(column_1, arr);
                    }
                });
            };
            var this_1 = this;
            for(var i = 0; i < columns.length; i++)_loop_1(i);
        }
    };
    /**
     * Returns the column data from the DataFrame by column name.
     * @param column column name to get the column data
     * @param returnSeries Whether to return the data in series format or not. Defaults to true
     */ DataFrame.prototype.$getColumnData = function(column, returnSeries) {
        if (returnSeries === void 0) returnSeries = true;
        var columnIndex = this.columns.indexOf(column);
        if (columnIndex == -1) $4fd4c38d994b420a$var$errors_1.default.throwColumnNotFoundError(this);
        var dtypes = [
            this.$dtypes[columnIndex]
        ];
        var index = $4fd4c38d994b420a$var$__spreadArray([], this.$index, true);
        var columns = [
            column
        ];
        var config = $4fd4c38d994b420a$var$__assign({}, this.$config);
        if (this.$config.isLowMemoryMode) {
            var data = [];
            for(var i = 0; i < this.values.length; i++){
                var row = this.values[i];
                data.push(row[columnIndex]);
            }
            if (returnSeries) return new $4fd4c38d994b420a$var$series_1.default(data, {
                dtypes: dtypes,
                index: index,
                columns: columns,
                config: config
            });
            else return data;
        } else {
            var data = this.$dataIncolumnFormat[columnIndex];
            if (returnSeries) return new $4fd4c38d994b420a$var$series_1.default(data, {
                dtypes: dtypes,
                index: index,
                columns: columns,
                config: config
            });
            else return data;
        }
    };
    /**
     * Updates the internal column data via column name.
     * @param column The name of the column to update.
     * @param arr The new column data
     */ DataFrame.prototype.$setColumnData = function(column, arr) {
        var columnIndex = this.$columns.indexOf(column);
        if (columnIndex == -1) throw new Error("ParamError: column " + column + " not found in " + this.$columns + ". If you need to add a new column, use the df.addColumn method. ");
        var colunmValuesToAdd;
        if (arr instanceof $4fd4c38d994b420a$var$series_1.default) colunmValuesToAdd = arr.values;
        else if (Array.isArray(arr)) colunmValuesToAdd = arr;
        else throw new Error("ParamError: specified value not supported. It must either be an Array or a Series of the same length");
        if (colunmValuesToAdd.length !== this.shape[0]) $4fd4c38d994b420a$var$errors_1.default.throwColumnLengthError(this, colunmValuesToAdd.length);
        if (this.$config.isLowMemoryMode) {
            //Update row ($data) array
            for(var i = 0; i < this.$data.length; i++)this.$data[i][columnIndex] = colunmValuesToAdd[i];
            //Update the dtypes
            this.$dtypes[columnIndex] = $4fd4c38d994b420a$var$utils.inferDtype(colunmValuesToAdd)[0];
        } else {
            //Update row ($data) array
            for(var i = 0; i < this.values.length; i++)this.$data[i][columnIndex] = colunmValuesToAdd[i];
            //Update column ($dataIncolumnFormat) array since it's available in object
            this.$dataIncolumnFormat[columnIndex] = arr;
            //Update the dtypes
            this.$dtypes[columnIndex] = $4fd4c38d994b420a$var$utils.inferDtype(colunmValuesToAdd)[0];
        }
    };
    /**
     * Return data with missing values removed from a specified axis
     * @param axis 0 or 1. If 0, column-wise, if 1, row-wise
    */ DataFrame.prototype.$getDataByAxisWithMissingValuesRemoved = function(axis) {
        var oldValues = this.$getDataArraysByAxis(axis);
        var cleanValues = [];
        for(var i = 0; i < oldValues.length; i++){
            var values = oldValues[i];
            cleanValues.push($4fd4c38d994b420a$var$utils.removeMissingValuesFromArray(values));
        }
        return cleanValues;
    };
    /**
     * Return data aligned to the specified axis. Transposes the array if needed.
     * @param axis 0 or 1. If 0, column-wise, if 1, row-wise
    */ DataFrame.prototype.$getDataArraysByAxis = function(axis) {
        if (axis === 1) return this.values;
        else {
            var dfValues = void 0;
            if (this.config.isLowMemoryMode) dfValues = $4fd4c38d994b420a$var$utils.transposeArray(this.values);
            else dfValues = this.$dataIncolumnFormat;
            return dfValues;
        }
    };
    /*
    * checks if DataFrame is compactible for arithmetic operation
    * compatible Dataframe must have only numerical dtypes
    **/ DataFrame.prototype.$frameIsNotCompactibleForArithmeticOperation = function() {
        var dtypes = this.dtypes;
        var str = function(element) {
            return element == "string";
        };
        return dtypes.some(str);
    };
    /**
     * Return Tensors in the right axis for math operations.
     * @param other DataFrame or Series or number or array
     * @param axis 0 or 1. If 0, column-wise, if 1, row-wise
     * */ DataFrame.prototype.$getTensorsForArithmeticOperationByAxis = function(other, axis) {
        if (typeof other === "number") return [
            this.tensor,
            $4fd4c38d994b420a$var$tensorflowlib_1.default.scalar(other)
        ];
        else if (other instanceof DataFrame) return [
            this.tensor,
            other.tensor
        ];
        else if (other instanceof $4fd4c38d994b420a$var$series_1.default) {
            if (axis === 0) return [
                this.tensor,
                $4fd4c38d994b420a$var$tensorflowlib_1.default.tensor2d(other.values, [
                    other.shape[0],
                    1
                ])
            ];
            else return [
                this.tensor,
                $4fd4c38d994b420a$var$tensorflowlib_1.default.tensor2d(other.values, [
                    other.shape[0],
                    1
                ]).transpose()
            ];
        } else if (Array.isArray(other)) {
            if (axis === 0) return [
                this.tensor,
                $4fd4c38d994b420a$var$tensorflowlib_1.default.tensor2d(other, [
                    other.length,
                    1
                ])
            ];
            else return [
                this.tensor,
                $4fd4c38d994b420a$var$tensorflowlib_1.default.tensor2d(other, [
                    other.length,
                    1
                ]).transpose()
            ];
        } else throw new Error("ParamError: Invalid type for other parameter. other must be one of Series, DataFrame or number.");
    };
    /**
     * Returns the dtype for a given column name
     * @param column
     */ DataFrame.prototype.$getColumnDtype = function(column) {
        var columnIndex = this.columns.indexOf(column);
        if (columnIndex === -1) throw Error("ColumnNameError: Column \"" + column + "\" does not exist");
        return this.dtypes[columnIndex];
    };
    DataFrame.prototype.$logicalOps = function(tensors, operation) {
        var newValues = [];
        switch(operation){
            case 'gt':
                newValues = tensors[0].greater(tensors[1]).arraySync();
                break;
            case 'lt':
                newValues = tensors[0].less(tensors[1]).arraySync();
                break;
            case 'ge':
                newValues = tensors[0].greaterEqual(tensors[1]).arraySync();
                break;
            case 'le':
                newValues = tensors[0].lessEqual(tensors[1]).arraySync();
                break;
            case 'eq':
                newValues = tensors[0].equal(tensors[1]).arraySync();
                break;
            case 'ne':
                newValues = tensors[0].notEqual(tensors[1]).arraySync();
                break;
        }
        var newData = $4fd4c38d994b420a$var$utils.mapIntegersToBooleans(newValues, 2);
        return new DataFrame(newData, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
            columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
            config: $4fd4c38d994b420a$var$__assign({}, this.config)
        });
    };
    DataFrame.prototype.$MathOps = function(tensors, operation, inplace) {
        var tensorResult;
        switch(operation){
            case 'add':
                tensorResult = tensors[0].add(tensors[1]);
                break;
            case 'sub':
                tensorResult = tensors[0].sub(tensors[1]);
                break;
            case 'pow':
                tensorResult = tensors[0].pow(tensors[1]);
                break;
            case 'div':
                tensorResult = tensors[0].div(tensors[1]);
                break;
            case 'divNoNan':
                tensorResult = tensors[0].divNoNan(tensors[1]);
                break;
            case 'mul':
                tensorResult = tensors[0].mul(tensors[1]);
                break;
            case 'mod':
                tensorResult = tensors[0].mod(tensors[1]);
                break;
        }
        if (inplace) {
            var newData = tensorResult === null || tensorResult === void 0 ? void 0 : tensorResult.arraySync();
            this.$setValues(newData);
        } else return new DataFrame(tensorResult, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
            columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
            config: $4fd4c38d994b420a$var$__assign({}, this.config)
        });
    };
    /**
    * Purely integer-location based indexing for selection by position.
    * ``.iloc`` is primarily integer position based (from ``0`` to
    * ``length-1`` of the axis), but may also be used with a boolean array.
    *
    * @param rows Array of row indexes
    * @param columns Array of column indexes
    *
    * Allowed inputs are in rows and columns params are:
    *
    * - An array of single integer, e.g. ``[5]``.
    * - A list or array of integers, e.g. ``[4, 3, 0]``.
    * - A slice array string with ints, e.g. ``["1:7"]``.
    * - A boolean array.
    * - A ``callable`` function with one argument (the calling Series or
    * DataFrame) and that returns valid output for indexing (one of the above).
    * This is useful in method chains, when you don't have a reference to the
    * calling object, but would like to base your selection on some value.
    *
    * ``.iloc`` will raise ``IndexError`` if a requested indexer is
    * out-of-bounds.
    *
    * @example
    * ```
    * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B'] })
    * const df2 = df.iloc({ rows: [1], columns: ["A"] })
    * ```
    */ DataFrame.prototype.iloc = function(_a) {
        var rows = _a.rows, columns = _a.columns;
        return (0, $36CW2._iloc)({
            ndFrame: this,
            rows: rows,
            columns: columns
        });
    };
    /**
     * Access a group of rows and columns by label(s) or a boolean array.
     * ``loc`` is primarily label based, but may also be used with a boolean array.
     *
     * @param rows Array of row indexes
     * @param columns Array of column indexes
     *
     * Allowed inputs are:
     *
     * - A single label, e.g. ``["5"]`` or ``['a']``, (note that ``5`` is interpreted as a
     *   *label* of the index, and **never** as an integer position along the index).
     *
     * - A list or array of labels, e.g. ``['a', 'b', 'c']``.
     *
     * - A slice object with labels, e.g. ``["a:f"]``. Note that start and the stop are included
     *
     * - A boolean array of the same length as the axis being sliced,
     * e.g. ``[True, False, True]``.
     *
     * - A ``callable`` function with one argument (the calling Series or
     * DataFrame) and that returns valid output for indexing (one of the above)
    * @example
    * ```
    * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B'] })
    * const df2 = df.loc({ rows: [1], columns: ["A"] })
    * ```
    */ DataFrame.prototype.loc = function(_a) {
        var rows = _a.rows, columns = _a.columns;
        return (0, $36CW2._loc)({
            ndFrame: this,
            rows: rows,
            columns: columns
        });
    };
    /**
     * Prints DataFrame to console as a formatted grid of row and columns.
    */ DataFrame.prototype.toString = function() {
        var maxRow = this.config.getMaxRow;
        var maxColToDisplayInConsole = this.config.getTableMaxColInConsole;
        // let data;
        var dataArr = [];
        var colLen = this.columns.length;
        var header = [];
        if (colLen > maxColToDisplayInConsole) {
            //truncate displayed columns to fit in the console
            var firstFourcolNames = this.columns.slice(0, 4);
            var lastThreecolNames = this.columns.slice(colLen - 3);
            //join columns with truncate ellipse in the middle
            header = $4fd4c38d994b420a$var$__spreadArray($4fd4c38d994b420a$var$__spreadArray($4fd4c38d994b420a$var$__spreadArray([
                ""
            ], firstFourcolNames, true), [
                "..."
            ], false), lastThreecolNames, true);
            var subIdx = void 0;
            var firstHalfValues = void 0;
            var lastHalfValueS = void 0;
            if (this.values.length > maxRow) {
                //slice Object to show [max_rows]
                var dfSubset1 = this.iloc({
                    rows: [
                        "0:" + maxRow
                    ],
                    columns: [
                        "0:4"
                    ]
                });
                var dfSubset2 = this.iloc({
                    rows: [
                        "0:" + maxRow
                    ],
                    columns: [
                        colLen - 3 + ":"
                    ]
                });
                subIdx = this.index.slice(0, maxRow);
                firstHalfValues = dfSubset1.values;
                lastHalfValueS = dfSubset2.values;
            } else {
                var dfSubset1 = this.iloc({
                    columns: [
                        "0:4"
                    ]
                });
                var dfSubset2 = this.iloc({
                    columns: [
                        colLen - 3 + ":"
                    ]
                });
                subIdx = this.index.slice(0, maxRow);
                firstHalfValues = dfSubset1.values;
                lastHalfValueS = dfSubset2.values;
            }
            // merge subset 
            for(var i = 0; i < subIdx.length; i++){
                var idx = subIdx[i];
                var row = $4fd4c38d994b420a$var$__spreadArray($4fd4c38d994b420a$var$__spreadArray($4fd4c38d994b420a$var$__spreadArray([
                    idx
                ], firstHalfValues[i], true), [
                    "..."
                ], false), lastHalfValueS[i], true);
                dataArr.push(row);
            }
        } else {
            //display all columns
            header = $4fd4c38d994b420a$var$__spreadArray([
                ""
            ], this.columns, true);
            var subIdx = void 0;
            var values = void 0;
            if (this.values.length > maxRow) {
                //slice Object to show a max of [max_rows]
                var data = this.iloc({
                    rows: [
                        "0:" + maxRow
                    ]
                });
                subIdx = data.index;
                values = data.values;
            } else {
                values = this.values;
                subIdx = this.index;
            }
            // merge subset 
            for(var i = 0; i < subIdx.length; i++){
                var idx = subIdx[i];
                var row = $4fd4c38d994b420a$var$__spreadArray([
                    idx
                ], values[i], true);
                dataArr.push(row);
            }
        }
        var columnsConfig = {};
        columnsConfig[0] = {
            width: 10
        }; //set column width for index column
        for(var index = 1; index < header.length; index++)columnsConfig[index] = {
            width: 17,
            truncate: 16
        };
        var tableData = $4fd4c38d994b420a$var$__spreadArray([
            header
        ], dataArr, true); //Adds the column names to values before printing
        return (0, $4qjR5.table)(tableData, $4fd4c38d994b420a$var$__assign({
            columns: columnsConfig
        }, this.config.getTableDisplayConfig));
    };
    /**
      * Returns the first n values in a DataFrame
      * @param rows The number of rows to return
      * @example
      * ```
      * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
      * const df2 = df.head(1)
      * ```
    */ DataFrame.prototype.head = function(rows) {
        if (rows === void 0) rows = 5;
        if (rows <= 0) throw new Error("ParamError: Number of rows cannot be less than 1");
        if (this.shape[0] <= rows) return this.copy();
        if (this.shape[0] - rows < 0) throw new Error("ParamError: Number of rows cannot be greater than available rows in data");
        return this.iloc({
            rows: [
                "0:" + rows
            ]
        });
    };
    /**
      * Returns the last n values in a DataFrame
      * @param rows The number of rows to return
      * @example
      * ```
      * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
      * const df2 = df.tail(1)
      * ```
    */ DataFrame.prototype.tail = function(rows) {
        if (rows === void 0) rows = 5;
        if (rows <= 0) throw new Error("ParamError: Number of rows cannot be less than 1");
        if (this.shape[0] <= rows) return this.copy();
        if (this.shape[0] - rows < 0) throw new Error("ParamError: Number of rows cannot be greater than available rows in data");
        rows = this.shape[0] - rows;
        return this.iloc({
            rows: [
                rows + ":"
            ]
        });
    };
    /**
     * Gets n number of random rows in a dataframe. Sample is reproducible if seed is provided.
     * @param num The number of rows to return. Default to 5.
     * @param options.seed An integer specifying the random seed that will be used to create the distribution.
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B'] })
     * const df2 = await df.sample(1)
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B'] })
     * const df2 = await df.sample(1, { seed: 1 })
     * ```
    */ DataFrame.prototype.sample = function(num, options) {
        if (num === void 0) num = 5;
        return $4fd4c38d994b420a$var$__awaiter(this, void 0, void 0, function() {
            var seed, shuffledIndex, df;
            return $4fd4c38d994b420a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        seed = $4fd4c38d994b420a$var$__assign({
                            seed: 1
                        }, options).seed;
                        if (num > this.shape[0]) throw new Error("ParamError: Sample size cannot be bigger than number of rows");
                        if (num <= 0) throw new Error("ParamError: Sample size cannot be less than 1");
                        return [
                            4 /*yield*/ ,
                            $4fd4c38d994b420a$var$tensorflowlib_1.default.data.array(this.index).shuffle(num, "" + seed).take(num).toArray()
                        ];
                    case 1:
                        shuffledIndex = _a.sent();
                        df = this.iloc({
                            rows: shuffledIndex
                        });
                        return [
                            2 /*return*/ ,
                            df
                        ];
                }
            });
        });
    };
    DataFrame.prototype.add = function(other, options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false,
            axis: 1
        }, options), inplace = _a.inplace, axis = _a.axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: add operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$MathOps(tensors, "add", inplace);
    };
    DataFrame.prototype.sub = function(other, options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false,
            axis: 1
        }, options), inplace = _a.inplace, axis = _a.axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: sub operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$MathOps(tensors, "sub", inplace);
    };
    DataFrame.prototype.mul = function(other, options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false,
            axis: 1
        }, options), inplace = _a.inplace, axis = _a.axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: mul operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$MathOps(tensors, "mul", inplace);
    };
    DataFrame.prototype.div = function(other, options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false,
            axis: 1
        }, options), inplace = _a.inplace, axis = _a.axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: div operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$MathOps(tensors, "div", inplace);
    };
    DataFrame.prototype.divNoNan = function(other, options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false,
            axis: 1
        }, options), inplace = _a.inplace, axis = _a.axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: div operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$MathOps(tensors, "divNoNan", inplace);
    };
    DataFrame.prototype.pow = function(other, options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false,
            axis: 1
        }, options), inplace = _a.inplace, axis = _a.axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: pow operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$MathOps(tensors, "pow", inplace);
    };
    DataFrame.prototype.mod = function(other, options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false,
            axis: 1
        }, options), inplace = _a.inplace, axis = _a.axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: mod operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$MathOps(tensors, "mod", inplace);
    };
    /**
     * Return mean of DataFrame across specified axis.
     * @param options.axis 0 or 1. If 0, compute the mean column-wise, if 1, row-wise. Defaults to 1
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B'] })
     * df.mean().print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B'] })
     * df.mean({ axis: 0 }).print()
     * ```
    */ DataFrame.prototype.mean = function(options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: mean operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var newData = this.$getDataByAxisWithMissingValuesRemoved(axis);
        var resultArr = newData.map(function(arr) {
            return arr.reduce(function(a, b) {
                return a + b;
            }, 0) / arr.length;
        });
        if (axis === 0) return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.columns
        });
        else return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.index
        });
    };
    /**
     * Return median of DataFrame across specified axis.
     * @param options.axis 0 or 1. If 0, compute the median column-wise, if 1, row-wise. Defaults to 1
     * @example
     * ```
     * const df = new DataFrame([[1, 2, 4], [3, 4, 5], [6, 7, 8]], { columns: ['A', 'B', 'C'] });
     * df.median().print()
     * ```
    */ DataFrame.prototype.median = function(options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: median operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var newData = this.$getDataByAxisWithMissingValuesRemoved(axis);
        var resultArr = newData.map(function(arr) {
            return (0, $j3dDi.median)(arr);
        });
        if (axis === 0) return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.columns
        });
        else return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.index
        });
    };
    /**
     * Return mode of DataFrame across specified axis.
     * @param options.axis 0 or 1. If 0, compute the mode column-wise, if 1, row-wise. Defaults to 1
     * @param options.keep If there are more than one modes, returns the mode at position [keep]. Defaults to 0
     * @example
     * ```
     * const df = new DataFrame([[1, 2, 4], [3, 4, 5], [6, 7, 8]], { columns: ['A', 'B', 'C'] });
     * df.mode().print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2, 4], [3, 4, 5], [6, 7, 8]], { columns: ['A', 'B', 'C'] });
     * df.mode({ keep: 1 }).print()
     * ```
    */ DataFrame.prototype.mode = function(options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            axis: 1,
            keep: 0
        }, options), axis = _a.axis, keep = _a.keep;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: mode operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var newData = this.$getDataByAxisWithMissingValuesRemoved(axis);
        var resultArr = newData.map(function(arr) {
            var tempMode = (0, $j3dDi.mode)(arr);
            if (tempMode.length === 1) return tempMode[0];
            else return tempMode[keep];
        });
        if (axis === 0) return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.columns
        });
        else return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.index
        });
    };
    /**
     * Return minimum of values in a DataFrame across specified axis.
     * @param options.axis 0 or 1. If 0, compute the minimum value column-wise, if 1, row-wise. Defaults to 1
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.min().print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.min({ axis: 0 }).print()
     * ```
    */ DataFrame.prototype.min = function(options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: min operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var newData = this.$getDataByAxisWithMissingValuesRemoved(axis);
        var resultArr = newData.map(function(arr) {
            var smallestValue = arr[0];
            for(var i = 0; i < arr.length; i++)smallestValue = smallestValue < arr[i] ? smallestValue : arr[i];
            return smallestValue;
        });
        if (axis === 0) return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.columns
        });
        else return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.index
        });
    };
    /**
     * Return maximum of values in a DataFrame across specified axis.
     * @param options.axis 0 or 1. If 0, compute the maximum column-wise, if 1, row-wise. Defaults to 1
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.max().print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.max({ axis: 0 }).print()
     * ```
    */ DataFrame.prototype.max = function(options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: max operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var newData = this.$getDataByAxisWithMissingValuesRemoved(axis);
        var resultArr = newData.map(function(arr) {
            var biggestValue = arr[0];
            for(var i = 0; i < arr.length; i++)biggestValue = biggestValue > arr[i] ? biggestValue : arr[i];
            return biggestValue;
        });
        if (axis === 0) return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.columns
        });
        else return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.index
        });
    };
    /**
     * Return standard deviation of values in a DataFrame across specified axis.
     * @param options.axis 0 or 1. If 0, compute the standard deviation column-wise, if 1, row-wise. Defaults to 1
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.std().print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.std({ axis: 0 }).print()
     * ```
    */ DataFrame.prototype.std = function(options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: std operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var newData = this.$getDataByAxisWithMissingValuesRemoved(axis);
        var resultArr = newData.map(function(arr) {
            return (0, $j3dDi.std)(arr);
        });
        if (axis === 0) return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.columns
        });
        else return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.index
        });
    };
    /**
     * Return variance of values in a DataFrame across specified axis.
     * @param options.axis 0 or 1. If 0, compute the variance column-wise, if 1, add row-wise. Defaults to 1
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.var().print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.var({ axis: 0 }).print()
     * ```
    */ DataFrame.prototype.var = function(options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: var operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var newData = this.$getDataByAxisWithMissingValuesRemoved(axis);
        var resultArr = newData.map(function(arr) {
            return (0, $j3dDi.variance)(arr);
        });
        if (axis === 0) return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.columns
        });
        else return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.index
        });
    };
    /**
     * Get Less than of dataframe and other, element-wise (binary operator lt).
     * @param other DataFrame, Series, Array or Scalar number to compare with
     * @param options.axis 0 or 1. If 0, add column-wise, if 1, add row-wise
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.lt(2).print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.lt([2, 3], { axis: 0 }).print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * const sf = new Series([2, 3])
     * df.lt(sf, { axis: 1 }).print()
     * ```
    */ DataFrame.prototype.lt = function(other, options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: lt operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$logicalOps(tensors, "lt");
    };
    /**
     * Returns "greater than" of dataframe and other.
     * @param other DataFrame, Series, Array or Scalar number to compare with
     * @param options.axis 0 or 1. If 0, add column-wise, if 1, add row-wise
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.gt(2).print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.gt([2, 3], { axis: 0 }).print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * const sf = new Series([2, 3])
     * df.gt(sf, { axis: 1 }).print()
     * ```
    */ DataFrame.prototype.gt = function(other, options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: gt operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$logicalOps(tensors, "gt");
    };
    /**
     * Returns "equals to" of dataframe and other.
     * @param other DataFrame, Series, Array or Scalar number to compare with
     * @param options.axis 0 or 1. If 0, add column-wise, if 1, add row-wise
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.eq(2).print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.eq([2, 3], { axis: 0 }).print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * const sf = new Series([2, 3])
     * df.eq(sf, { axis: 1 }).print()
     * ```
    */ DataFrame.prototype.eq = function(other, options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: eq operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$logicalOps(tensors, "eq");
    };
    /**
     * Returns "not equal to" of dataframe and other.
     * @param other DataFrame, Series, Array or Scalar number to compare with
     * @param options.axis 0 or 1. If 0, add column-wise, if 1, add row-wise
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.ne(2).print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.ne([2, 3], { axis: 0 }).print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * const sf = new Series([2, 3])
     * df.ne(sf, { axis: 1 }).print()
     * ```
    */ DataFrame.prototype.ne = function(other, options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: ne operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$logicalOps(tensors, "ne");
    };
    /**
    * Returns "less than or equal to" of dataframe and other.
    * @param other DataFrame, Series, Array or Scalar number to compare with
    * @param options.axis 0 or 1. If 0, add column-wise, if 1, add row-wise
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.le(2).print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.le([2, 3], { axis: 0 }).print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * const sf = new Series([2, 3])
     * df.le(sf, { axis: 1 }).print()
     * ```
    */ DataFrame.prototype.le = function(other, options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: le operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$logicalOps(tensors, "le");
    };
    /**
    * Returns "greater than or equal to" between dataframe and other.
    * @param other DataFrame, Series, Array or Scalar number to compare with
    * @param options.axis 0 or 1. If 0, add column-wise, if 1, add row-wise
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.ge(2).print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.ge([2, 3], { axis: 0 }).print()
     * ```
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * const sf = new Series([2, 3])
     * df.ge(sf, { axis: 1 }).print()
     * ```
    */ DataFrame.prototype.ge = function(other, options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: ge operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
        return this.$logicalOps(tensors, "ge");
    };
    /**
     * Return number of non-null elements in a Series
     * @param options.axis 0 or 1. If 0, count column-wise, if 1, add row-wise. Defaults to 1
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.count().print()
     * ```
     *
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.count({ axis: 0 }).print()
     * ```
    */ DataFrame.prototype.count = function(options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var newData = this.$getDataByAxisWithMissingValuesRemoved(axis);
        var resultArr = newData.map(function(arr) {
            return arr.length;
        });
        if (axis === 0) return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.columns
        });
        else return new $4fd4c38d994b420a$var$series_1.default(resultArr, {
            index: this.index
        });
    };
    /**
     * Return the sum of values across an axis.
     * @param options.axis 0 or 1. If 0, count column-wise, if 1, add row-wise. Defaults to 1
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.sum().print()
     * ```
     *
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.sum({ axis: 0 }).print()
     * ```
    */ DataFrame.prototype.sum = function(options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var result = this.$getDataByAxisWithMissingValuesRemoved(axis);
        var sumArr = result.map(function(innerArr) {
            return innerArr.reduce(function(a, b) {
                return Number(a) + Number(b);
            }, 0);
        });
        if (axis === 0) return new $4fd4c38d994b420a$var$series_1.default(sumArr, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true)
        });
        else return new $4fd4c38d994b420a$var$series_1.default(sumArr, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true)
        });
    };
    DataFrame.prototype.pctChange = function(other, options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false,
            axis: 1
        }, options), inplace = _a.inplace, axis = _a.axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: pctChange operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        if (other === 0) return this;
        if (typeof other === "number") {
            var origDF = this.copy();
            if (axis === 0) origDF = origDF.T;
            var originalTensor = origDF.tensor.clone();
            var unit = new Array(originalTensor.shape[originalTensor.rank - 1]).fill(NaN);
            var pctArray = originalTensor.arraySync();
            if (other > 0) for(var i = 0; i < other; i++){
                pctArray.unshift(unit);
                pctArray.pop();
            }
            else if (other < 0) for(var i = 0; i > other; i--){
                pctArray.push(unit);
                pctArray.shift();
            }
            var pctTensor = $4fd4c38d994b420a$var$tensorflowlib_1.default.tensor2d(pctArray, originalTensor.shape);
            var pctDF = this.$MathOps([
                originalTensor,
                pctTensor
            ], "divNoNan", inplace).sub(1);
            if (axis === 0) return pctDF.T;
            return pctDF;
        }
        if (other instanceof DataFrame || other instanceof $4fd4c38d994b420a$var$series_1.default) {
            var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
            var pctDF = this.$MathOps(tensors, "divNoNan", inplace).sub(1);
            return pctDF;
        }
    };
    DataFrame.prototype.diff = function(other, options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false,
            axis: 1
        }, options), inplace = _a.inplace, axis = _a.axis;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: diff operation is not supported for string dtypes");
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        if (other === 0) return this;
        if (typeof other === "number") {
            var origDF = this.copy();
            if (axis === 0) origDF = origDF.T;
            var originalTensor = origDF.tensor.clone();
            var unit = new Array(originalTensor.shape[originalTensor.rank - 1]).fill(NaN);
            var diffArray = originalTensor.arraySync();
            if (other > 0) for(var i = 0; i < other; i++){
                diffArray.unshift(unit);
                diffArray.pop();
            }
            else if (other < 0) for(var i = 0; i > other; i--){
                diffArray.push(unit);
                diffArray.shift();
            }
            var diffTensor = $4fd4c38d994b420a$var$tensorflowlib_1.default.tensor2d(diffArray, originalTensor.shape);
            var diffDF = this.$MathOps([
                originalTensor,
                diffTensor
            ], "sub", inplace);
            if (axis === 0) return diffDF.T;
            return diffDF;
        }
        if (other instanceof DataFrame || other instanceof $4fd4c38d994b420a$var$series_1.default) {
            var tensors = this.$getTensorsForArithmeticOperationByAxis(other, axis);
            return this.$MathOps(tensors, "sub", inplace);
        }
    };
    DataFrame.prototype.abs = function(options) {
        var inplace = $4fd4c38d994b420a$var$__assign({
            inplace: false
        }, options).inplace;
        var newData = this.values.map(function(arr) {
            return arr.map(function(val) {
                return Math.abs(val);
            });
        });
        if (inplace) this.$setValues(newData);
        else return new DataFrame(newData, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
            columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
            config: $4fd4c38d994b420a$var$__assign({}, this.config)
        });
    };
    DataFrame.prototype.round = function(dp, options) {
        if (dp === void 0) dp = 1;
        var inplace = $4fd4c38d994b420a$var$__assign({
            inplace: false
        }, options).inplace;
        if (this.$frameIsNotCompactibleForArithmeticOperation()) throw Error("TypeError: round operation is not supported for string dtypes");
        if (typeof dp !== "number") throw Error("ParamError: dp must be a number");
        var newData = $4fd4c38d994b420a$var$utils.round(this.values, dp, false);
        if (inplace) this.$setValues(newData);
        else return new DataFrame(newData, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
            columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            config: $4fd4c38d994b420a$var$__assign({}, this.config)
        });
    };
    DataFrame.prototype.cumProd = function(options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            axis: 1,
            inplace: false
        }, options), axis = _a.axis, inplace = _a.inplace;
        return this.cumOps("prod", axis, inplace);
    };
    DataFrame.prototype.cumSum = function(options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            axis: 1,
            inplace: false
        }, options), axis = _a.axis, inplace = _a.inplace;
        return this.cumOps("sum", axis, inplace);
    };
    DataFrame.prototype.cumMin = function(options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            axis: 1,
            inplace: false
        }, options), axis = _a.axis, inplace = _a.inplace;
        return this.cumOps("min", axis, inplace);
    };
    DataFrame.prototype.cumMax = function(options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            axis: 1,
            inplace: false
        }, options), axis = _a.axis, inplace = _a.inplace;
        return this.cumOps("max", axis, inplace);
    };
    DataFrame.prototype.cumOps = function(ops, axis, inplace) {
        if (this.dtypes.includes("string")) $4fd4c38d994b420a$var$errors_1.default.throwStringDtypeOperationError(ops);
        var result = this.$getDataByAxisWithMissingValuesRemoved(axis);
        var newData = result.map(function(sData) {
            var tempval = sData[0];
            var data = [
                tempval
            ];
            for(var i = 1; i < sData.length; i++){
                var currVal = sData[i];
                switch(ops){
                    case "max":
                        if (currVal > tempval) {
                            data.push(currVal);
                            tempval = currVal;
                        } else data.push(tempval);
                        break;
                    case "min":
                        if (currVal < tempval) {
                            data.push(currVal);
                            tempval = currVal;
                        } else data.push(tempval);
                        break;
                    case "sum":
                        tempval = tempval + currVal;
                        data.push(tempval);
                        break;
                    case "prod":
                        tempval = tempval * currVal;
                        data.push(tempval);
                        break;
                }
            }
            return data;
        });
        if (axis === 0) newData = $4fd4c38d994b420a$var$utils.transposeArray(newData);
        if (inplace) this.$setValues(newData);
        else return new DataFrame(newData, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
            columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
            config: $4fd4c38d994b420a$var$__assign({}, this.config)
        });
    };
    /**
     * Generate descriptive statistics for all numeric columns.
     * Descriptive statistics include those that summarize the central tendency,
     * dispersion and shape of a dataset’s distribution, excluding NaN values.
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.describe().print()
     * ```
     */ DataFrame.prototype.describe = function() {
        var _this = this;
        var numericColumnNames = this.columns.filter(function(name) {
            return _this.$getColumnDtype(name) !== "string";
        });
        var index = [
            "count",
            "mean",
            "std",
            "min",
            "median",
            "max",
            "variance"
        ];
        var statsObject = {};
        for(var i = 0; i < numericColumnNames.length; i++){
            var colName = numericColumnNames[i];
            var $count = this.$getColumnData(colName).count();
            var $mean = (0, $j3dDi.mean)(this.$getColumnData(colName, false));
            var $std = (0, $j3dDi.std)(this.$getColumnData(colName, false));
            var $min = this.$getColumnData(colName).min();
            var $median = (0, $j3dDi.median)(this.$getColumnData(colName, false));
            var $max = this.$getColumnData(colName).max();
            var $variance = (0, $j3dDi.variance)(this.$getColumnData(colName, false));
            var stats = [
                $count,
                $mean,
                $std,
                $min,
                $median,
                $max,
                $variance
            ];
            statsObject[colName] = stats;
        }
        var df = new DataFrame(statsObject, {
            index: index
        });
        return df;
    };
    DataFrame.prototype.dropNa = function(options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            axis: 1,
            inplace: false
        }, options), axis = _a.axis, inplace = _a.inplace;
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: Axis must be 0 or 1");
        var newIndex = [];
        if (axis == 1) {
            var newData = [];
            var dfValues = this.values;
            for(var i = 0; i < dfValues.length; i++){
                var values = dfValues[i];
                //@ts-ignore
                if (!values.includes(NaN) && !values.includes(undefined) && !values.includes(null)) {
                    newData.push(values);
                    newIndex.push(this.index[i]);
                }
            }
            if (inplace) {
                this.$setValues(newData, false);
                this.$setIndex(newIndex);
            } else return new DataFrame(newData, {
                index: newIndex,
                columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
                dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
                config: $4fd4c38d994b420a$var$__assign({}, this.config)
            });
        } else {
            var newColumnNames = [];
            var newDtypes = [];
            var dfValues = [];
            if (this.config.isLowMemoryMode) dfValues = $4fd4c38d994b420a$var$utils.transposeArray(this.values);
            else dfValues = this.$dataIncolumnFormat;
            var tempColArr = [];
            for(var i = 0; i < dfValues.length; i++){
                var values = dfValues[i];
                if (!values.includes(NaN)) {
                    tempColArr.push(values);
                    newColumnNames.push(this.columns[i]);
                    newDtypes.push(this.dtypes[i]);
                }
            }
            var newData = $4fd4c38d994b420a$var$utils.transposeArray(tempColArr);
            if (inplace) {
                this.$setValues(newData, false, false);
                this.$setColumnNames(newColumnNames);
                this.$setDtypes(newDtypes);
            } else return new DataFrame(newData, {
                index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
                columns: newColumnNames,
                dtypes: newDtypes,
                config: $4fd4c38d994b420a$var$__assign({}, this.config)
            });
        }
    };
    DataFrame.prototype.addColumn = function(column, values, options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false,
            atIndex: this.columns.length
        }, options), inplace = _a.inplace, atIndex = _a.atIndex;
        if (typeof atIndex === "string") {
            if (!this.columns.includes(atIndex)) throw new Error(atIndex + " not a column");
            atIndex = this.columns.indexOf(atIndex);
        }
        if (!column) throw new Error("ParamError: column must be specified");
        if (!values) throw new Error("ParamError: values must be specified");
        var columnIndex = this.$columns.indexOf(column);
        if (columnIndex === -1) {
            var colunmValuesToAdd = void 0;
            if (values instanceof $4fd4c38d994b420a$var$series_1.default) colunmValuesToAdd = values.values;
            else if (Array.isArray(values)) colunmValuesToAdd = values;
            else throw new Error("ParamError: specified value not supported. It must either be an Array or a Series of the same length");
            if (colunmValuesToAdd.length !== this.shape[0]) $4fd4c38d994b420a$var$errors_1.default.throwColumnLengthError(this, colunmValuesToAdd.length);
            var newData = [];
            var oldValues = this.$data;
            for(var i = 0; i < oldValues.length; i++){
                var innerArr = $4fd4c38d994b420a$var$__spreadArray([], oldValues[i], true);
                innerArr.splice(atIndex, 0, colunmValuesToAdd[i]);
                newData.push(innerArr);
            }
            if (inplace) {
                this.$setValues(newData, true, false);
                var columns = $4fd4c38d994b420a$var$__spreadArray([], this.columns, true);
                columns.splice(atIndex, 0, column);
                this.$setColumnNames(columns);
                this.$setInternalColumnDataProperty(column);
            } else {
                var columns = $4fd4c38d994b420a$var$__spreadArray([], this.columns, true);
                columns.splice(atIndex, 0, column);
                var df = new DataFrame(newData, {
                    index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
                    columns: columns,
                    dtypes: $4fd4c38d994b420a$var$__spreadArray($4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true), [
                        $4fd4c38d994b420a$var$utils.inferDtype(colunmValuesToAdd)[0]
                    ], false),
                    config: $4fd4c38d994b420a$var$__assign({}, this.$config)
                });
                return df;
            }
        } else this.$setColumnData(column, values);
    };
    /**
     * Makes a deep copy of a DataFrame.
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * const df2 = df.copy()
     * df2.print()
     * ```
     */ DataFrame.prototype.copy = function() {
        var df = new DataFrame($4fd4c38d994b420a$var$__spreadArray([], this.$data, true), {
            columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
            dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
            config: $4fd4c38d994b420a$var$__assign({}, this.$config)
        });
        return df;
    };
    /**
     * Return a boolean, same-sized object indicating where elements are empty (NaN, undefined, null).
     * NaN, undefined and null values gets mapped to true, and everything else gets mapped to false.
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.isNa().print()
     * ```
    */ DataFrame.prototype.isNa = function() {
        var newData = [];
        for(var i = 0; i < this.values.length; i++){
            var valueArr = this.values[i];
            var tempData = valueArr.map(function(value) {
                if ($4fd4c38d994b420a$var$utils.isEmpty(value)) return true;
                else return false;
            });
            newData.push(tempData);
        }
        var df = new DataFrame(newData, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
            columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            config: $4fd4c38d994b420a$var$__assign({}, this.config)
        });
        return df;
    };
    DataFrame.prototype.fillNa = function(values, options) {
        var _this = this;
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false
        }, options), columns = _a.columns, inplace = _a.inplace;
        if (!values && typeof values !== "boolean" && typeof values !== "number" && typeof values !== "string") throw Error('ParamError: value must be specified');
        if (Array.isArray(values)) {
            if (!Array.isArray(columns)) throw Error('ParamError: value is an array, hence columns must also be an array of same length');
            if (values.length !== columns.length) throw Error('ParamError: specified column and values must have the same length');
            columns.forEach(function(col) {
                if (!_this.columns.includes(col)) throw Error("ValueError: Specified column \"" + col + "\" must be one of " + _this.columns);
            });
        }
        var newData = [];
        var oldValues = $4fd4c38d994b420a$var$__spreadArray([], this.values, true);
        if (!columns) {
            var _loop_2 = function(i) {
                var valueArr = $4fd4c38d994b420a$var$__spreadArray([], oldValues[i], true);
                var tempArr = valueArr.map(function(innerVal) {
                    if ($4fd4c38d994b420a$var$utils.isEmpty(innerVal)) {
                        var replaceWith = Array.isArray(values) ? values[i] : values;
                        return replaceWith;
                    } else return innerVal;
                });
                newData.push(tempArr);
            };
            //Fill all columns
            for(var i = 0; i < oldValues.length; i++)_loop_2(i);
        } else {
            //Fill specific columns
            var tempData = $4fd4c38d994b420a$var$__spreadArray([], this.values, true);
            for(var i = 0; i < tempData.length; i++){
                var valueArr = tempData[i];
                for(var i_1 = 0; i_1 < columns.length; i_1++){
                    var columnIndex = this.columns.indexOf(columns[i_1]);
                    var replaceWith = Array.isArray(values) ? values[i_1] : values;
                    valueArr[columnIndex] = $4fd4c38d994b420a$var$utils.isEmpty(valueArr[columnIndex]) ? replaceWith : valueArr[columnIndex];
                }
                newData.push(valueArr);
            }
        }
        if (inplace) this.$setValues(newData);
        else {
            var df = new DataFrame(newData, {
                index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
                columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
                dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
                config: $4fd4c38d994b420a$var$__assign({}, this.config)
            });
            return df;
        }
    };
    DataFrame.prototype.drop = function(options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false
        }, options), columns = _a.columns, index = _a.index, inplace = _a.inplace;
        if (!columns && !index) throw Error('ParamError: Must specify one of columns or index');
        if (columns && index) throw Error('ParamError: Can only specify one of columns or index');
        if (columns) {
            var columnIndices = [];
            if (typeof columns === "string") columnIndices.push(this.columns.indexOf(columns));
            else if (Array.isArray(columns)) for(var _i = 0, columns_1 = columns; _i < columns_1.length; _i++){
                var column = columns_1[_i];
                if (this.columns.indexOf(column) === -1) throw Error("ParamError: specified column \"" + column + "\" not found in columns");
                columnIndices.push(this.columns.indexOf(column));
            }
            else throw Error('ParamError: columns must be an array of column names or a string of column name');
            var newRowData = [];
            var newColumnNames = [];
            var newDtypes = [];
            for(var i = 0; i < this.values.length; i++){
                var tempInnerArr = [];
                var innerArr = this.values[i];
                for(var j = 0; j < innerArr.length; j++)if (!columnIndices.includes(j)) tempInnerArr.push(innerArr[j]);
                newRowData.push(tempInnerArr);
            }
            for(var i = 0; i < this.columns.length; i++){
                var element = this.columns[i];
                if (!columns.includes(element)) {
                    newColumnNames.push(element);
                    newDtypes.push(this.dtypes[i]);
                }
            }
            if (inplace) {
                this.$setValues(newRowData, true, false);
                this.$setColumnNames(newColumnNames);
            } else {
                var df = new DataFrame(newRowData, {
                    index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
                    columns: newColumnNames,
                    dtypes: newDtypes,
                    config: $4fd4c38d994b420a$var$__assign({}, this.config)
                });
                return df;
            }
        }
        if (index) {
            var rowIndices = [];
            if (typeof index === "string" || typeof index === "number" || typeof index === "boolean") rowIndices.push(this.index.indexOf(index));
            else if (Array.isArray(index)) for(var _b = 0, index_1 = index; _b < index_1.length; _b++){
                var indx = index_1[_b];
                if (this.index.indexOf(indx) === -1) throw Error("ParamError: specified index \"" + indx + "\" not found in indices");
                rowIndices.push(this.index.indexOf(indx));
            }
            else throw Error('ParamError: index must be an array of indices or a scalar index');
            var newRowData = [];
            var newIndex = [];
            for(var i = 0; i < this.values.length; i++){
                var innerArr = this.values[i];
                if (!rowIndices.includes(i)) newRowData.push(innerArr);
            }
            for(var i = 0; i < this.index.length; i++){
                var indx = this.index[i];
                if (!index.includes(indx)) newIndex.push(indx);
            }
            if (inplace) {
                this.$setValues(newRowData, false);
                this.$setIndex(newIndex);
            } else {
                var df = new DataFrame(newRowData, {
                    index: newIndex,
                    columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
                    dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
                    config: $4fd4c38d994b420a$var$__assign({}, this.config)
                });
                return df;
            }
        }
    };
    DataFrame.prototype.sortValues = function(column, options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            ascending: true,
            inplace: false
        }, options), ascending = _a.ascending, inplace = _a.inplace;
        if (!column) throw Error("ParamError: must specify a column to sort by");
        if (this.columns.indexOf(column) === -1) throw Error("ParamError: specified column \"" + column + "\" not found in columns");
        var columnValues = this.$getColumnData(column, false);
        var index = $4fd4c38d994b420a$var$__spreadArray([], this.index, true);
        var objToSort = columnValues.map(function(value, i) {
            return {
                index: index[i],
                value: value
            };
        });
        var sortedObjectArr = $4fd4c38d994b420a$var$utils.sortObj(objToSort, ascending);
        var sortedIndex = sortedObjectArr.map(function(obj) {
            return obj.index;
        });
        var newDf = (0, $36CW2._loc)({
            ndFrame: this,
            rows: sortedIndex
        });
        if (inplace) {
            this.$setValues(newDf.values);
            this.$setIndex(newDf.index);
        } else return newDf;
    };
    DataFrame.prototype.setIndex = function(options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            drop: false,
            inplace: false
        }, options), index = _a.index, column = _a.column, drop = _a.drop, inplace = _a.inplace;
        if (!index && !column) throw new Error("ParamError: must specify either index or column");
        var newIndex = [];
        if (index) {
            if (!Array.isArray(index)) throw Error("ParamError: index must be an array");
            if (index.length !== this.values.length) throw Error("ParamError: index must be the same length as the number of rows");
            newIndex = index;
        }
        if (column) {
            if (this.columns.indexOf(column) === -1) throw Error("ParamError: column not found in column names");
            newIndex = this.$getColumnData(column, false);
        }
        if (drop) {
            var dfDropped = this.drop({
                columns: [
                    column
                ]
            });
            var newData = dfDropped === null || dfDropped === void 0 ? void 0 : dfDropped.values;
            var newColumns = dfDropped === null || dfDropped === void 0 ? void 0 : dfDropped.columns;
            var newDtypes = dfDropped === null || dfDropped === void 0 ? void 0 : dfDropped.dtypes;
            if (inplace) {
                this.$setValues(newData, true, false);
                this.$setIndex(newIndex);
                this.$setColumnNames(newColumns);
            } else {
                var df = new DataFrame(newData, {
                    index: newIndex,
                    columns: newColumns,
                    dtypes: newDtypes,
                    config: $4fd4c38d994b420a$var$__assign({}, this.config)
                });
                return df;
            }
        } else if (inplace) this.$setIndex(newIndex);
        else {
            var df = new DataFrame(this.values, {
                index: newIndex,
                columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
                dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
                config: $4fd4c38d994b420a$var$__assign({}, this.config)
            });
            return df;
        }
    };
    DataFrame.prototype.resetIndex = function(options) {
        var inplace = $4fd4c38d994b420a$var$__assign({
            inplace: false
        }, options).inplace;
        if (inplace) this.$resetIndex();
        else {
            var df = new DataFrame(this.values, {
                index: this.index.map(function(_, i) {
                    return i;
                }),
                columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
                dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
                config: $4fd4c38d994b420a$var$__assign({}, this.config)
            });
            return df;
        }
    };
    /**
     * Apply a function along an axis of the DataFrame. To apply a function element-wise, use `applyMap`.
     * Objects passed to the function are Series values whose
     * index is either the DataFrame’s index (axis=0) or the DataFrame’s columns (axis=1)
     * @param callable Function to apply to each column or row.
     * @param options.axis 0 or 1. If 0, apply "callable" column-wise, else apply row-wise
     *
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * const df2 = df.apply(Math.sqrt, { axis: 0 })
     * df2.print()
     * ```
    */ DataFrame.prototype.apply = function(callable, options) {
        var axis = $4fd4c38d994b420a$var$__assign({
            axis: 1
        }, options).axis;
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: axis must be 0 or 1");
        var valuesForFunc = this.$getDataByAxisWithMissingValuesRemoved(axis);
        var result = valuesForFunc.map(function(row) {
            return callable(row);
        });
        if (axis === 0) {
            if ($4fd4c38d994b420a$var$utils.is1DArray(result)) return new $4fd4c38d994b420a$var$series_1.default(result, {
                index: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true)
            });
            else return new DataFrame(result, {
                index: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
                columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
                dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
                config: $4fd4c38d994b420a$var$__assign({}, this.config)
            });
        } else {
            if ($4fd4c38d994b420a$var$utils.is1DArray(result)) return new $4fd4c38d994b420a$var$series_1.default(result, {
                index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true)
            });
            else return new DataFrame(result, {
                index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
                columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
                dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
                config: $4fd4c38d994b420a$var$__assign({}, this.config)
            });
        }
    };
    DataFrame.prototype.applyMap = function(callable, options) {
        var inplace = $4fd4c38d994b420a$var$__assign({
            inplace: false
        }, options).inplace;
        var newData = this.values.map(function(row) {
            var tempData = row.map(function(val) {
                return callable(val);
            });
            return tempData;
        });
        if (inplace) this.$setValues(newData);
        else return new DataFrame(newData, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
            columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
            config: $4fd4c38d994b420a$var$__assign({}, this.config)
        });
    };
    /**
     * Returns the specified column data as a Series object.
     * @param column The name of the column to return
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * const sf = df.column('A')
     * sf.print()
     * ```
     *
    */ DataFrame.prototype.column = function(column) {
        return this.$getColumnData(column);
    };
    /**
     * Return a subset of the DataFrame based on the column dtypes.
     * @param include An array of dtypes or strings to be included.
     * @example
     * ```
     * const df = new DataFrame([[1, 2.1, "Dog"], [3, 4.3, "Cat"]], { columns: ['A', 'B', 'C']})
     * const df2 = df.selectDtypes(['float32'])
     * df2.print()
     * ```
     *
     * @example
     * ```
     * const df = new DataFrame([[1, 2.1, "Dog"], [3, 4.3, "Cat"]], { columns: ['A', 'B', 'C']})
     * const df2 = df.selectDtypes(['float32', 'int32'])
     * df2.print()
     * ```
     *
    */ DataFrame.prototype.selectDtypes = function(include) {
        var supportedDtypes = [
            "float32",
            "int32",
            "string",
            "boolean",
            'undefined'
        ];
        if (Array.isArray(include) === false) throw Error("ParamError: include must be an array");
        include.forEach(function(dtype) {
            if (supportedDtypes.indexOf(dtype) === -1) throw Error("ParamError: include must be an array of valid dtypes");
        });
        var newColumnNames = [];
        for(var i = 0; i < this.dtypes.length; i++)if (include.includes(this.dtypes[i])) newColumnNames.push(this.columns[i]);
        return this.loc({
            columns: newColumnNames
        });
    };
    DataFrame.prototype.transpose = function(options) {
        var inplace = $4fd4c38d994b420a$var$__assign({
            inplace: false
        }, options).inplace;
        var newData = $4fd4c38d994b420a$var$utils.transposeArray(this.values);
        var newColNames = $4fd4c38d994b420a$var$__spreadArray([], this.index.map(function(i) {
            return i.toString();
        }), true);
        if (inplace) {
            this.$setValues(newData, false, false);
            this.$setIndex($4fd4c38d994b420a$var$__spreadArray([], this.columns, true));
            this.$setColumnNames(newColNames);
        } else return new DataFrame(newData, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            columns: newColNames,
            config: $4fd4c38d994b420a$var$__assign({}, this.config)
        });
    };
    Object.defineProperty(DataFrame.prototype, "T", {
        /**
         * Returns the Transpose of the DataFrame. Similar to `transpose`.
         * @example
         * ```
         * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
         * const df2 = df.T()
         * df2.print()
         * ```
        **/ get: function() {
            var newData = $4fd4c38d994b420a$var$utils.transposeArray(this.values);
            return new DataFrame(newData, {
                index: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
                columns: $4fd4c38d994b420a$var$__spreadArray([], this.index.map(function(i) {
                    return i.toString();
                }), true),
                config: $4fd4c38d994b420a$var$__assign({}, this.config)
            });
        },
        enumerable: false,
        configurable: true
    });
    DataFrame.prototype.replace = function(oldValue, newValue, options) {
        var _this = this;
        var _a = $4fd4c38d994b420a$var$__assign({
            inplace: false
        }, options), columns = _a.columns, inplace = _a.inplace;
        if (typeof oldValue === 'number' && isNaN(oldValue)) throw Error("Params Error: Param 'oldValue' does not support NaN. Use DataFrame.fillNa() instead.");
        if (!oldValue && typeof oldValue !== 'boolean' && typeof oldValue !== 'number' && typeof oldValue !== 'string') throw Error("Params Error: Must specify param 'oldValue' to replace");
        if (!newValue && typeof newValue !== 'boolean' && typeof newValue !== 'number' && typeof newValue !== 'string') throw Error("Params Error: Must specify param 'newValue' to replace with");
        var newData = [];
        if (columns) {
            if (!Array.isArray(columns)) throw Error("Params Error: column must be an array of column(s)");
            var columnIndex_1 = [];
            columns.forEach(function(column) {
                var _indx = _this.columns.indexOf(column);
                if (_indx === -1) throw Error("Params Error: column not found in columns");
                columnIndex_1.push(_indx);
            });
            newData = this.values.map(function(_a) {
                var row = _a.slice(0);
                for(var _i = 0, columnIndex_2 = columnIndex_1; _i < columnIndex_2.length; _i++){
                    var colIndx = columnIndex_2[_i];
                    if (row[colIndx] === oldValue) row[colIndx] = newValue;
                }
                return row;
            });
        } else newData = this.values.map(function(_a) {
            var row = _a.slice(0);
            return row.map(function(cell) {
                if (cell === oldValue) return newValue;
                else return cell;
            });
        });
        if (inplace) this.$setValues(newData);
        else return new DataFrame(newData, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
            columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
            config: $4fd4c38d994b420a$var$__assign({}, this.config)
        });
    };
    DataFrame.prototype.asType = function(column, dtype, options) {
        var inplace = $4fd4c38d994b420a$var$__assign({
            inplace: false
        }, options).inplace;
        var columnIndex = this.columns.indexOf(column);
        if (columnIndex === -1) throw Error("Params Error: column not found in columns");
        if (!$oCdZL.DATA_TYPES.includes(dtype)) throw Error("dtype " + dtype + " not supported. dtype must be one of " + $oCdZL.DATA_TYPES);
        var data = this.values;
        var newData = data.map(function(row) {
            if (dtype === "float32") {
                row[columnIndex] = Number(row[columnIndex]);
                return row;
            } else if (dtype === "int32") {
                row[columnIndex] = parseInt(row[columnIndex]);
                return row;
            } else if (dtype === "string") {
                row[columnIndex] = row[columnIndex].toString();
                return row;
            } else if (dtype === "boolean") {
                row[columnIndex] = Boolean(row[columnIndex]);
                return row;
            }
        });
        if (inplace) this.$setValues(newData);
        else {
            var newDtypes = $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true);
            newDtypes[columnIndex] = dtype;
            return new DataFrame(newData, {
                index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
                columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
                dtypes: newDtypes,
                config: $4fd4c38d994b420a$var$__assign({}, this.config)
            });
        }
    };
    /**
     * Return the number of unique elements in a column, across the specified axis.
     * To get the values use `.unique()` instead.
     * @param axis The axis to count unique elements across. Defaults to 1
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4], [1, 2], [5, 6]], { columns: ['A', 'B'] })
     * df.nunique().print()
     * ```
     *
    */ DataFrame.prototype.nUnique = function(axis) {
        if (axis === void 0) axis = 1;
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: axis must be 0 or 1");
        var data = this.$getDataArraysByAxis(axis);
        var newData = data.map(function(row) {
            return new Set(row).size;
        });
        if (axis === 0) return new $4fd4c38d994b420a$var$series_1.default(newData, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            dtypes: [
                "int32"
            ]
        });
        else return new $4fd4c38d994b420a$var$series_1.default(newData, {
            index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
            dtypes: [
                "int32"
            ]
        });
    };
    DataFrame.prototype.rename = function(mapper, options) {
        var _a = $4fd4c38d994b420a$var$__assign({
            axis: 1,
            inplace: false
        }, options), axis = _a.axis, inplace = _a.inplace;
        if ([
            0,
            1
        ].indexOf(axis) === -1) throw Error("ParamError: axis must be 0 or 1");
        if (axis === 1) {
            var colsAdded_2 = [];
            var newColumns = this.columns.map(function(col) {
                if (mapper[col] !== undefined) {
                    var newCol = "" + mapper[col];
                    colsAdded_2.push(newCol);
                    return newCol;
                } else return col;
            });
            if (inplace) {
                this.$setColumnNames(newColumns);
                for(var _i = 0, colsAdded_1 = colsAdded_2; _i < colsAdded_1.length; _i++){
                    var col = colsAdded_1[_i];
                    this.$setInternalColumnDataProperty(col);
                }
            } else return new DataFrame($4fd4c38d994b420a$var$__spreadArray([], this.values, true), {
                index: $4fd4c38d994b420a$var$__spreadArray([], this.index, true),
                columns: newColumns,
                dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
                config: $4fd4c38d994b420a$var$__assign({}, this.config)
            });
        } else {
            var newIndex = this.index.map(function(col) {
                if (mapper[col] !== undefined) return mapper[col];
                else return col;
            });
            if (inplace) this.$setIndex(newIndex);
            else return new DataFrame($4fd4c38d994b420a$var$__spreadArray([], this.values, true), {
                index: newIndex,
                columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
                dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
                config: $4fd4c38d994b420a$var$__assign({}, this.config)
            });
        }
    };
    DataFrame.prototype.sortIndex = function(options) {
        var _this = this;
        var _a = $4fd4c38d994b420a$var$__assign({
            ascending: true,
            inplace: false
        }, options), ascending = _a.ascending, inplace = _a.inplace;
        var indexPosition = $4fd4c38d994b420a$var$utils.range(0, this.index.length - 1);
        var index = $4fd4c38d994b420a$var$__spreadArray([], this.index, true);
        var objToSort = index.map(function(idx, i) {
            return {
                index: indexPosition[i],
                value: idx
            };
        });
        var sortedObjectArr = $4fd4c38d994b420a$var$utils.sortObj(objToSort, ascending);
        var sortedIndex = sortedObjectArr.map(function(obj) {
            return obj.index;
        });
        var newData = sortedIndex.map(function(i) {
            return _this.values[i];
        });
        sortedIndex = sortedIndex.map(function(i) {
            return index[i];
        });
        if (inplace) {
            this.$setValues(newData);
            this.$setIndex(sortedIndex);
        } else return new DataFrame(newData, {
            index: sortedIndex,
            columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
            config: $4fd4c38d994b420a$var$__assign({}, this.config)
        });
    };
    DataFrame.prototype.append = function(newValues, index, options) {
        var inplace = $4fd4c38d994b420a$var$__assign({
            inplace: false
        }, options).inplace;
        if (!newValues) throw Error("ParamError: newValues must be a Series, DataFrame or Array");
        if (!index) throw Error("ParamError: index must be specified");
        var rowsToAdd = [];
        if (newValues instanceof $4fd4c38d994b420a$var$series_1.default) {
            if (newValues.values.length !== this.shape[1]) throw Error("ValueError: length of newValues must be the same as the number of columns.");
            rowsToAdd = [
                newValues.values
            ];
        } else if (newValues instanceof DataFrame) {
            if (newValues.shape[1] !== this.shape[1]) throw Error("ValueError: length of newValues must be the same as the number of columns.");
            rowsToAdd = newValues.values;
        } else if (Array.isArray(newValues)) {
            if ($4fd4c38d994b420a$var$utils.is1DArray(newValues)) rowsToAdd = [
                newValues
            ];
            else rowsToAdd = newValues;
            if (rowsToAdd[0].length !== this.shape[1]) throw Error("ValueError: length of newValues must be the same as the number of columns.");
        } else throw Error("ValueError: newValues must be a Series, DataFrame or Array");
        var indexInArrFormat = [];
        if (!Array.isArray(index)) indexInArrFormat = [
            index
        ];
        else indexInArrFormat = index;
        if (rowsToAdd.length !== indexInArrFormat.length) throw Error("ParamError: index must contain the same number of values as newValues");
        var newData = $4fd4c38d994b420a$var$__spreadArray([], this.values, true);
        var newIndex = $4fd4c38d994b420a$var$__spreadArray([], this.index, true);
        rowsToAdd.forEach(function(row, i) {
            newData.push(row);
            newIndex.push(indexInArrFormat[i]);
        });
        if (inplace) {
            this.$setValues(newData);
            this.$setIndex(newIndex);
        } else return new DataFrame(newData, {
            index: newIndex,
            columns: $4fd4c38d994b420a$var$__spreadArray([], this.columns, true),
            dtypes: $4fd4c38d994b420a$var$__spreadArray([], this.dtypes, true),
            config: $4fd4c38d994b420a$var$__assign({}, this.config)
        });
    };
    DataFrame.prototype.query = function(condition, options) {
        var inplace = $4fd4c38d994b420a$var$__assign({
            inplace: false
        }, options).inplace;
        if (!condition) throw new Error("ParamError: condition must be specified");
        var result = (0, $36CW2._iloc)({
            ndFrame: this,
            rows: condition
        });
        if (inplace) {
            this.$setValues(result.values, false, false);
            this.$setIndex(result.index);
        } else return result;
    };
    Object.defineProperty(DataFrame.prototype, "ctypes", {
        /**
         * Returns the data types for each column as a Series.
         * @example
         * ```
         * const df = new DataFrame([[1, 2.1, "Dog"], [3, 4.3, "Cat"]], { columns: ['A', 'B', 'C'] })
         * df.ctypes().print()
         * ```
         */ get: function() {
            return new $4fd4c38d994b420a$var$series_1.default(this.dtypes, {
                index: this.columns
            });
        },
        enumerable: false,
        configurable: true
    });
    DataFrame.prototype.getDummies = function(options) {
        var inplace = $4fd4c38d994b420a$var$__assign({
            inplace: false
        }, options).inplace;
        var encodedDF = (0, $4fd4c38d994b420a$var$dummy_encoder_1.default)(this, options);
        if (inplace) {
            this.$setValues(encodedDF.values, false, false);
            this.$setColumnNames(encodedDF.columns);
        } else return encodedDF;
    };
    /**
     * Groupby
     * @params col a list of column
     * @returns Groupby
     * @example
     * let data = [ [ 1, 2, 3 ], [ 4, 5, 6 ], [ 20, 30, 40 ], [ 39, 89, 78 ] ];
     * let cols = [ "A", "B", "C" ];
     * let df = new dfd.DataFrame(data, { columns: cols });
     * let groupDf = df.groupby([ "A" ]);
     */ DataFrame.prototype.groupby = function(col) {
        var columns = this.columns;
        var colIndex = col.map(function(val) {
            return columns.indexOf(val);
        });
        var colDtype = this.dtypes;
        return new $4fd4c38d994b420a$var$groupby_1.default(col, this.values, columns, colDtype, colIndex).group();
    };
    /**
     * Access a single value for a row/column pair by integer position.
     * Similar to {@link iloc}, in that both provide integer-based lookups.
     * Use iat if you only need to get or set a single value in a DataFrame.
     * @param row Row index of the value to access.
     * @param column Column index of the value to access.
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.iat(0, 0) // 1
     * df.iat(0, 1) // 2
     * df.iat(1, 0) // 3
     * ```
    */ DataFrame.prototype.iat = function(row, column) {
        if (typeof row === 'string' || typeof column === 'string') throw new Error('ParamError: row and column index must be an integer. Use .at to get a row or column by label.');
        return this.values[row][column];
    };
    /**
     * Access a single value for a row/column label pair.
     * Similar to {@link loc}, in that both provide label-based lookups.
     * Use at if you only need to get or set a single value in a DataFrame.
     * @param row Row index of the value to access.
     * @param column Column label of the value to access.
     * @example
     * ```
     * const df = new DataFrame([[1, 2], [3, 4]], { columns: ['A', 'B']})
     * df.at(0,'A') // 1
     * df.at(1, 'A') // 3
     * df.at(1, 'B') // 4
     * ```
    */ DataFrame.prototype.at = function(row, column) {
        if (typeof column !== 'string') throw new Error('ParamError: column index must be a string. Use .iat to get a row or column by index.');
        return this.values[this.index.indexOf(row)][this.columns.indexOf(column)];
    };
    /**
     * Exposes functions for creating charts from a DataFrame.
     * Charts are created using the Plotly.js library, so all Plotly's configuration parameters are available.
     * @param divId name of the HTML Div to render the chart in.
    */ DataFrame.prototype.plot = function(divId) {
        //TODO: Add support for check plot library to use. So we can support other plot library like d3, vega, etc
        if ($4fd4c38d994b420a$var$utils.isBrowserEnv()) {
            var plt = new $hmLMy.PlotlyLib(this, divId);
            return plt;
        } else throw new Error("Not supported in NodeJS");
    };
    return DataFrame;
}($4fd4c38d994b420a$var$generic_1.default);
module.exports.default = $4fd4c38d994b420a$var$DataFrame;

});
parcelRegister("j3dDi", function(module, exports) {

$parcel$export(module.exports, "mode", () => $dde8df59118aada2$export$549ff81930776885);
$parcel$export(module.exports, "mean", () => $dde8df59118aada2$export$1ce691f85baaa52);
$parcel$export(module.exports, "variance", () => $dde8df59118aada2$export$9b77da0927470c3d);
$parcel$export(module.exports, "median", () => $dde8df59118aada2$export$9c490b34b2f16a34);
$parcel$export(module.exports, "std", () => $dde8df59118aada2$export$b14c5e819cb6c927);
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */ 
var $bO2eg = parcelRequire("bO2eg");

var $kEdGs = parcelRequire("kEdGs");
var $04pgm = parcelRequire("04pgm");
var $iU3tp = parcelRequire("iU3tp");
var $ibMRy = parcelRequire("ibMRy");
var $fLjTM = parcelRequire("fLjTM");
var $5Qqxq = parcelRequire("5Qqxq");
var $4aat8 = parcelRequire("4aat8");
var $axTFP = parcelRequire("axTFP");
var $3dLdY = parcelRequire("3dLdY");
var $3ZIwJ = parcelRequire("3ZIwJ");
var $irWpb = parcelRequire("irWpb");
var $dz2Xh = parcelRequire("dz2Xh");
var $aiRWv = parcelRequire("aiRWv");
var $bNlle = parcelRequire("bNlle");
var $6TUWD = parcelRequire("6TUWD");
var $hwGg6 = parcelRequire("hwGg6");
var $1evUW = parcelRequire("1evUW");
var $juxrq = parcelRequire("juxrq");
var $WMtdB = parcelRequire("WMtdB");
var $bfQdA = parcelRequire("bfQdA");
var $6Gx92 = parcelRequire("6Gx92");
var $iLb2J = parcelRequire("iLb2J");
var $9Or3F = parcelRequire("9Or3F");
var $1HJ6i = parcelRequire("1HJ6i");
var $em9kx = parcelRequire("em9kx");
var $huYRB = parcelRequire("huYRB");
var $ed2ke = parcelRequire("ed2ke");
var $2JIUE = parcelRequire("2JIUE");
var $8sQFM = parcelRequire("8sQFM");
var $Xa8Ku = parcelRequire("Xa8Ku");
var $ioRMl = parcelRequire("ioRMl");
var $9MGdW = parcelRequire("9MGdW");
var $aXW9Y = parcelRequire("aXW9Y");
var $9vb66 = parcelRequire("9vb66");
var $9ekhe = parcelRequire("9ekhe");
var $024St = parcelRequire("024St");
var $jmzYP = parcelRequire("jmzYP");
var $hWhPN = parcelRequire("hWhPN");
var $h3DmQ = parcelRequire("h3DmQ");
var $90lmK = parcelRequire("90lmK");
var $40OE2 = parcelRequire("40OE2");
var $fMkjK = parcelRequire("fMkjK");
var $eZUfL = parcelRequire("eZUfL");
var $LMkdO = parcelRequire("LMkdO");
var $bAJmb = parcelRequire("bAJmb");
var $azcwD = parcelRequire("azcwD");
var $55m3V = parcelRequire("55m3V");
var $4lxho = parcelRequire("4lxho");
var $g3xgo = parcelRequire("g3xgo");
var $2DDJF = parcelRequire("2DDJF");
var $dELqD = parcelRequire("dELqD");
var $iXClk = parcelRequire("iXClk");
var $2jlSc = parcelRequire("2jlSc");
var $95cDc = parcelRequire("95cDc");
var $2WfNa = parcelRequire("2WfNa");
var $hY5r0 = parcelRequire("hY5r0");
var $beYd8 = parcelRequire("beYd8");
var $e6uiK = parcelRequire("e6uiK");
var $ejXGq = parcelRequire("ejXGq");
var $3t0qc = parcelRequire("3t0qc");
var $1aeKv = parcelRequire("1aeKv");
var $gz8Vv = parcelRequire("gz8Vv");
var $aWbIO = parcelRequire("aWbIO");
var $bNcnf = parcelRequire("bNcnf");
var $euY4t = parcelRequire("euY4t");
var $ibm2n = parcelRequire("ibm2n");
var $dvf0V = parcelRequire("dvf0V");
var $iaukn = parcelRequire("iaukn");
var $7iTF4 = parcelRequire("7iTF4");
var $gAGKJ = parcelRequire("gAGKJ");
var $6GjXW = parcelRequire("6GjXW");
var $k8DEe = parcelRequire("k8DEe");
var $eqOzB = parcelRequire("eqOzB");
var $dqQg9 = parcelRequire("dqQg9");
var $gYuoo = parcelRequire("gYuoo");
var $gBhx4 = parcelRequire("gBhx4");
var $hpWEx = parcelRequire("hpWEx");
var $c6ghs = parcelRequire("c6ghs");
var $eP5Jr = parcelRequire("eP5Jr");
var $ghUlP = parcelRequire("ghUlP");
var $4UXXo = parcelRequire("4UXXo");
var $jbGYt = parcelRequire("jbGYt");
var $hqqnu = parcelRequire("hqqnu");
var $4J1dU = parcelRequire("4J1dU");
var $5tB88 = parcelRequire("5tB88");
var $8BMAm = parcelRequire("8BMAm");
var $k1P9A = parcelRequire("k1P9A");
var $lwYat = parcelRequire("lwYat");
var $49ajn = parcelRequire("49ajn");
var $9vJYi = parcelRequire("9vJYi");
var $9cMbe = parcelRequire("9cMbe");
var $2pmUs = parcelRequire("2pmUs");
var $arfuc = parcelRequire("arfuc");
var $gNRKw = parcelRequire("gNRKw");
var $atHq5 = parcelRequire("atHq5");
var $fuwCS = parcelRequire("fuwCS");
var $jvvOm = parcelRequire("jvvOm");
var $iJlfn = parcelRequire("iJlfn");
var $dH0wG = parcelRequire("dH0wG");
var $jqPCL = parcelRequire("jqPCL");
var $cO11J = parcelRequire("cO11J");
var $aWTnj = parcelRequire("aWTnj");
var $aUeQh = parcelRequire("aUeQh");
var $1tonU = parcelRequire("1tonU");
var $dUvuH = parcelRequire("dUvuH");
var $kFQL0 = parcelRequire("kFQL0");
var $lSqCP = parcelRequire("lSqCP");
var $lD1Hd = parcelRequire("lD1Hd");
var $fueOV = parcelRequire("fueOV");
var $ckhIK = parcelRequire("ckhIK");
var $eDLq1 = parcelRequire("eDLq1");
var $1tZnA = parcelRequire("1tZnA");
var $e2lPV = parcelRequire("e2lPV");
var $7Gn1s = parcelRequire("7Gn1s");
var $aelBe = parcelRequire("aelBe");
var $8Dful = parcelRequire("8Dful");
var $dPUMt = parcelRequire("dPUMt");
var $SnoAE = parcelRequire("SnoAE");
var $dMQoA = parcelRequire("dMQoA");
var $jWy7j = parcelRequire("jWy7j");
var $eRGGO = parcelRequire("eRGGO");
var $4aB2a = parcelRequire("4aB2a");
var $gPUdm = parcelRequire("gPUdm");
var $eCRSR = parcelRequire("eCRSR");
var $djtod = parcelRequire("djtod");
var $iNWZH = parcelRequire("iNWZH");
var $gQcPe = parcelRequire("gQcPe");
var $aTI6t = parcelRequire("aTI6t");
var $4P03R = parcelRequire("4P03R");
var $bhx9l = parcelRequire("bhx9l");
var $5eklJ = parcelRequire("5eklJ");
var $9zAMj = parcelRequire("9zAMj");
var $6Ql8D = parcelRequire("6Ql8D");
var $4byQb = parcelRequire("4byQb");
var $hkIg9 = parcelRequire("hkIg9");
var $fSbwS = parcelRequire("fSbwS");
var $1hReh = parcelRequire("1hReh");
var $etNV0 = parcelRequire("etNV0");
var $cuftd = parcelRequire("cuftd");
var $kim9k = parcelRequire("kim9k");
var $OD7u9 = parcelRequire("OD7u9");
var $b6EZL = parcelRequire("b6EZL");
var $hiSMC = parcelRequire("hiSMC");
var $8AhI2 = parcelRequire("8AhI2");
var $ePbwm = parcelRequire("ePbwm");
var $i1uRq = parcelRequire("i1uRq");
var $1EwLg = parcelRequire("1EwLg");
var $btDSk = parcelRequire("btDSk");
var $gCVW0 = parcelRequire("gCVW0");
var $7maP8 = parcelRequire("7maP8");
var $ldY29 = parcelRequire("ldY29");
var $3atMK = parcelRequire("3atMK");
var $b2fQ4 = parcelRequire("b2fQ4");
var $1aZzR = parcelRequire("1aZzR");
var $4wYIm = parcelRequire("4wYIm");
var $cVCJF = parcelRequire("cVCJF");
var $niWmr = parcelRequire("niWmr");
var $6mvgD = parcelRequire("6mvgD");
var $jM2Rh = parcelRequire("jM2Rh");
var $eOP6I = parcelRequire("eOP6I");
var $aCm7m = parcelRequire("aCm7m");
var $c8phe = parcelRequire("c8phe");
var $8m8fU = parcelRequire("8m8fU");
var $gIM5x = parcelRequire("gIM5x");
var $5aeqE = parcelRequire("5aeqE");
var $YeBIy = parcelRequire("YeBIy");
var $jxFbm = parcelRequire("jxFbm");
var $ccYsB = parcelRequire("ccYsB");
var $gt0lu = parcelRequire("gt0lu");
var $3Bb0y = parcelRequire("3Bb0y");
var $3sovY = parcelRequire("3sovY");
var $3S0eX = parcelRequire("3S0eX");
var $9dgfi = parcelRequire("9dgfi");
var $7x7Wx = parcelRequire("7x7Wx");
var $fCaiE = parcelRequire("fCaiE");
var $YpSzg = parcelRequire("YpSzg");
var $77hWe = parcelRequire("77hWe");
var $2YRdb = parcelRequire("2YRdb");
var $7jsoH = parcelRequire("7jsoH");
var $ahdW9 = parcelRequire("ahdW9");
var $2noYB = parcelRequire("2noYB");
var $bv6xC = parcelRequire("bv6xC");
var $i8fn6 = parcelRequire("i8fn6");
var $gjIaM = parcelRequire("gjIaM");
var $lLfhi = parcelRequire("lLfhi");
var $gwdP6 = parcelRequire("gwdP6");
var $3QcS2 = parcelRequire("3QcS2");
var $eAKdZ = parcelRequire("eAKdZ");
var $8pEqa = parcelRequire("8pEqa");
var $cqKSJ = parcelRequire("cqKSJ");
var $isiu0 = parcelRequire("isiu0");
var $iQRUk = parcelRequire("iQRUk");
var $kROJn = parcelRequire("kROJn");
var $4oju7 = parcelRequire("4oju7");
var $i2dyg = parcelRequire("i2dyg");
var $568HB = parcelRequire("568HB");
var $9BZAX = parcelRequire("9BZAX");
var $j2DxC = parcelRequire("j2DxC");
var $7nyTK = parcelRequire("7nyTK");
var $57e22 = parcelRequire("57e22");
var $kkSft = parcelRequire("kkSft");
var $4NZiI = parcelRequire("4NZiI");
var $CGoi6 = parcelRequire("CGoi6");
var $lD4pT = parcelRequire("lD4pT");
var $5pDCm = parcelRequire("5pDCm");
var $fLBnu = parcelRequire("fLBnu");
var $lo0mZ = parcelRequire("lo0mZ");
var $iOTwI = parcelRequire("iOTwI");
var $3tozm = parcelRequire("3tozm");
var $31sl8 = parcelRequire("31sl8");
var $jhCJr = parcelRequire("jhCJr");
var $10cD4 = parcelRequire("10cD4");
var $9QsFn = parcelRequire("9QsFn");
var $fmE5G = parcelRequire("fmE5G");
var $lvQKV = parcelRequire("lvQKV");
var $c0n5Z = parcelRequire("c0n5Z");
var $4yw8r = parcelRequire("4yw8r");
var $bBj1m = parcelRequire("bBj1m");
var $1FImG = parcelRequire("1FImG");
var $gTtZ4 = parcelRequire("gTtZ4");
var $dde8df59118aada2$export$aebd5179ff543a90 = /* #__PURE__ */ (0, $c8phe.createResultSet)({});
var $dde8df59118aada2$export$50ceb3fb9926e63e = /* #__PURE__ */ (0, $40OE2.createComplexClass)({});
var $dde8df59118aada2$export$9a58ef0d7ad3278c = /* #__PURE__ */ (0, $niWmr.createRangeClass)({});
var $dde8df59118aada2$export$f650004d56f90c2a = /* #__PURE__ */ (0, $iaukn.createFalse)({});
var $dde8df59118aada2$export$a2cbb38cda512d16 = /* #__PURE__ */ (0, $iaukn.createNull)({});
var $dde8df59118aada2$export$93f71dfe5e50cd3e = /* #__PURE__ */ (0, $iaukn.createTrue)({});
var $dde8df59118aada2$export$d97aa349ed20696 = /* #__PURE__ */ (0, $9Or3F.createBigNumberClass)({
    config: $bO2eg.config
});
var $dde8df59118aada2$export$5b12bf1653c0dd85 = /* #__PURE__ */ (0, $eCRSR.createMatrixClass)({});
var $dde8df59118aada2$export$b644b65666fe0c18 = /* #__PURE__ */ (0, $jM2Rh.createReplacer)({});
var $dde8df59118aada2$export$23f2a1d2818174ef = /* #__PURE__ */ (0, $iaukn.createI)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e
});
var $dde8df59118aada2$export$c44341d65988fdd6 = /* #__PURE__ */ (0, $iaukn.createLN10)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$5ed2c057bd191c66 = /* #__PURE__ */ (0, $iaukn.createLOG10E)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$14edd9ca775dcd61 = /* #__PURE__ */ (0, $iaukn.createNaN)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$18c7bea995a110f = /* #__PURE__ */ (0, $iaukn.createPi)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$83247d8be11c091e = /* #__PURE__ */ (0, $iaukn.createSQRT1_2)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$a4b4b4d4d776fe92 = /* #__PURE__ */ (0, $iaukn.createTau)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$9ea6550edaaee998 = /* #__PURE__ */ (0, $bfQdA.createEfimovFactor)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$5c15dd8d2782cbd0 = /* #__PURE__ */ (0, $bfQdA.createFineStructure)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$a7100dcd4c5af6d4 = /* #__PURE__ */ (0, $bfQdA.createSackurTetrode)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$857d2e3e2bc524d0 = /* #__PURE__ */ (0, $bfQdA.createWeakMixingAngle)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$b336c2702c498be5 = /* #__PURE__ */ (0, $8BMAm.createFractionClass)({});
var $dde8df59118aada2$export$f1e1789686576879 = /* #__PURE__ */ (0, $iaukn.createE)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$20607595d292e7d3 = /* #__PURE__ */ (0, $iaukn.createInfinity)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$8c2c65adacba8d14 = /* #__PURE__ */ (0, $iaukn.createLOG2E)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$83d89fbfd8236492 = /* #__PURE__ */ (0, $iaukn.createVersion)({});
var $dde8df59118aada2$export$97f0d27b48f120e8 = /* #__PURE__ */ (0, $beYd8.createDenseMatrixClass)({
    Matrix: $dde8df59118aada2$export$5b12bf1653c0dd85
});
var $dde8df59118aada2$export$324943737027944a = /* #__PURE__ */ (0, $iaukn.createPhi)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$519f616c41a1c711 = /* #__PURE__ */ (0, $iOTwI.createTyped)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    Fraction: $dde8df59118aada2$export$b336c2702c498be5
});
var $dde8df59118aada2$export$a287f47fed4544b8 = /* #__PURE__ */ (0, $jqPCL.createIsInteger)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$e90fb89750dba83f = /* #__PURE__ */ (0, $aUeQh.createIsNumeric)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$7e69d4236fcc3b19 = /* #__PURE__ */ (0, $1tonU.createIsPositive)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$c9f5652083b8129d = /* #__PURE__ */ (0, $cO11J.createIsNaN)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$943761f5c9c3f156 = /* #__PURE__ */ (0, $6GjXW.createEqualScalar)({
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$98e628dec113755e = /* #__PURE__ */ (0, $OD7u9.createNumber)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$4a21f16c33752377 = /* #__PURE__ */ (0, $8sQFM.createBoolean)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$83a0e34f1302825b = /* #__PURE__ */ (0, $90lmK.createComplex)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$dd67294014106b35 = /* #__PURE__ */ (0, $iQRUk.createSplitUnit)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$df8c837ae5df4ce4 = /* #__PURE__ */ (0, $jhCJr.createUnaryPlus)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$5635d7ef4b8fee1c = /* #__PURE__ */ (0, $irWpb.createApply)({
    isInteger: $dde8df59118aada2$export$a287f47fed4544b8,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$2b0340f6c7dec49a = /* #__PURE__ */ (0, $2WfNa.createCube)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$b6c0a80d46d3391d = /* #__PURE__ */ (0, $gBhx4.createExpm1)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$75e08744a3ff8516 = /* #__PURE__ */ (0, $7Gn1s.createLog10)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$c697bed75648cdb7 = /* #__PURE__ */ (0, $fSbwS.createMultiplyScalar)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$c5552dfdbc7cec71 = /* #__PURE__ */ (0, $2noYB.createSign)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Fraction: $dde8df59118aada2$export$b336c2702c498be5,
    complex: $dde8df59118aada2$export$83a0e34f1302825b,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$dd4f28cef696bc7d = /* #__PURE__ */ (0, $i2dyg.createSquare)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$aabc449fa5b5f4c0 = /* #__PURE__ */ (0, $huYRB.createBitNot)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$d8da458ed75e15b = /* #__PURE__ */ (0, $dz2Xh.createArg)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$5fc500b917996661 = /* #__PURE__ */ (0, $gNRKw.createIm)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$6003a5f097c73977 = /* #__PURE__ */ (0, $etNV0.createNot)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$3dea766d36a8935f = /* #__PURE__ */ (0, $eP5Jr.createFilter)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$4b80e395e36b5a56 = /* #__PURE__ */ (0, $hqqnu.createForEach)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$871de8747c9eaa88 = /* #__PURE__ */ (0, $4aB2a.createMap)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$d3896f355fc09423 = /* #__PURE__ */ (0, $eqOzB.createErf)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$d9468344d3651243 = /* #__PURE__ */ (0, $4J1dU.createFormat)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$8d9f5ae1af806929 = /* #__PURE__ */ (0, $hiSMC.createOct)({
    format: $dde8df59118aada2$export$d9468344d3651243,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$c2d084dc44961371 = /* #__PURE__ */ (0, $7maP8.createPrint)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$8676dd5fabd5ee34 = /* #__PURE__ */ (0, $dUvuH.createIsPrime)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$fd6306be3fde5b04 = /* #__PURE__ */ (0, $04pgm.createAcos)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$4919a578c4aafd3 = /* #__PURE__ */ (0, $ibMRy.createAcot)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$43298db932064b4a = /* #__PURE__ */ (0, $5Qqxq.createAcsc)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$ec42f46098b24bb4 = /* #__PURE__ */ (0, $aiRWv.createAsec)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$41726bdb1fc63f = /* #__PURE__ */ (0, $6TUWD.createAsin)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$628dc4eed22b0fbd = /* #__PURE__ */ (0, $1evUW.createAtan)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$21ea955025ceb08b = /* #__PURE__ */ (0, $WMtdB.createAtanh)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$2e2fd1ad24e4d350 = /* #__PURE__ */ (0, $azcwD.createCosh)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$fe7b8a3b046ac25b = /* #__PURE__ */ (0, $4lxho.createCoth)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$ca7427e8bf42a21b = /* #__PURE__ */ (0, $2jlSc.createCsch)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$becbc39f348ea65e = /* #__PURE__ */ (0, $3Bb0y.createSech)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$545004b505d7c555 = /* #__PURE__ */ (0, $i8fn6.createSinh)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$7128670e45beef9a = /* #__PURE__ */ (0, $lD4pT.createTanh)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$bdfcf4c6b5766439 = /* #__PURE__ */ (0, $9ekhe.createCombinations)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$2e015b6955893291 = /* #__PURE__ */ (0, $btDSk.createPickRandom)({
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$3c5f89dae98e900b = /* #__PURE__ */ (0, $4wYIm.createRandomInt)({
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$578b45ddcdefa518 = /* #__PURE__ */ (0, $iaukn.createLN2)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$9cd59f9826255e47 = /* #__PURE__ */ (0, $aXW9Y.createClone)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$f6fc628e09f3ff5d = /* #__PURE__ */ (0, $9vJYi.createHasNumericValue)({
    isNumeric: $dde8df59118aada2$export$e90fb89750dba83f,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$f5bbd400c2f4426f = /* #__PURE__ */ (0, $3tozm.createTypeOf)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$22b082955e083ec3 = /* #__PURE__ */ (0, $7nyTK.createString)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$7f34ce79760854f7 = /* #__PURE__ */ (0, $5tB88.createFraction)({
    Fraction: $dde8df59118aada2$export$b336c2702c498be5,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$6cd304851a69e08 = /* #__PURE__ */ (0, $31sl8.createUnaryMinus)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$2b7b095c4f443355 = /* #__PURE__ */ (0, $3dLdY.createAddScalar)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$b310ec824aaee37f = /* #__PURE__ */ (0, $dqQg9.createExp)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$b9fae0bba9d9094d = /* #__PURE__ */ (0, $8Dful.createLog2)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$eba8049fb5020b81 = /* #__PURE__ */ (0, $kROJn.createSqrt)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$fb254c661fe9c0db = /* #__PURE__ */ (0, $LMkdO.createConj)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$42c7d1d712906e32 = /* #__PURE__ */ (0, $49ajn.createGetMatrixDataType)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$549ff81930776885 = /* #__PURE__ */ (0, $6Ql8D.createMode)({
    isNaN: $dde8df59118aada2$export$c9f5652083b8129d,
    isNumeric: $dde8df59118aada2$export$e90fb89750dba83f,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$f03e751d9cddb7a = /* #__PURE__ */ (0, $1HJ6i.createBin)({
    format: $dde8df59118aada2$export$d9468344d3651243,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$b26caf0f29211d08 = /* #__PURE__ */ (0, $iU3tp.createAcosh)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$eafdb403a25900df = /* #__PURE__ */ (0, $4aat8.createAcsch)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$839d8a01b6af4fc0 = /* #__PURE__ */ (0, $hwGg6.createAsinh)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$50d414a77b60d802 = /* #__PURE__ */ (0, $bAJmb.createCos)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$a830b5ed334924be = /* #__PURE__ */ (0, $iXClk.createCsc)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$5de3937cb4b592ed = /* #__PURE__ */ (0, $bv6xC.createSin)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$f297162cf5d656b2 = /* #__PURE__ */ (0, $024St.createCombinationsWithRep)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$4385e60b38654f68 = /* #__PURE__ */ (0, $1aZzR.createRandom)({
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$3681641e15b6e2c3 = /* #__PURE__ */ (0, $iaukn.createSQRT2)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$d0909a4f38b5c4d0 = /* #__PURE__ */ (0, $aWTnj.createIsNegative)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$de9b2b7556879848 = /* #__PURE__ */ (0, $isiu0.createSparseMatrixClass)({
    Matrix: $dde8df59118aada2$export$5b12bf1653c0dd85,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$9bdad1ae37d738e0 = /* #__PURE__ */ (0, $gPUdm.createMatrix)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    Matrix: $dde8df59118aada2$export$5b12bf1653c0dd85,
    SparseMatrix: $dde8df59118aada2$export$de9b2b7556879848,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$2335f513bbd82c6d = /* #__PURE__ */ (0, $kEdGs.createAbs)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$f81847884871263e = /* #__PURE__ */ (0, $lwYat.createGcd)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$842a2cf37af977e1 = /* #__PURE__ */ (0, $9zAMj.createMod)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$cc5da69d359d7991 = /* #__PURE__ */ (0, $cuftd.createNthRoot)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$6ba103b0465fe6cc = /* #__PURE__ */ (0, $bBj1m.createXgcd)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$a74ff8d3fdef72fc = /* #__PURE__ */ (0, $em9kx.createBitAnd)({
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$bfcff4501301c191 = /* #__PURE__ */ (0, $2JIUE.createBitXor)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$252bb8b3bbdf6749 = /* #__PURE__ */ (0, $ePbwm.createOr)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$ee1b3e54f0441b22 = /* #__PURE__ */ (0, $eZUfL.createConcat)({
    isInteger: $dde8df59118aada2$export$a287f47fed4544b8,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$c042e7c2f59bc046 = /* #__PURE__ */ (0, $ejXGq.createDiag)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    SparseMatrix: $dde8df59118aada2$export$de9b2b7556879848,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$f0954fd7d5368655 = /* #__PURE__ */ (0, $arfuc.createIdentity)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    SparseMatrix: $dde8df59118aada2$export$de9b2b7556879848,
    config: $bO2eg.config,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$21041dee6b8001b0 = /* #__PURE__ */ (0, $8AhI2.createOnes)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$9eaad88cf88cee2b = /* #__PURE__ */ (0, $eOP6I.createReshape)({
    isInteger: $dde8df59118aada2$export$a287f47fed4544b8,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$346677f925de839c = /* #__PURE__ */ (0, $gjIaM.createSize)({
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$e06bd7b1ab877a71 = /* #__PURE__ */ (0, $57e22.createSubset)({
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$4445a00dafa2633b = /* #__PURE__ */ (0, $gTtZ4.createZeros)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    config: $bO2eg.config,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$834dfc94dde4b3d8 = /* #__PURE__ */ (0, $9cMbe.createHex)({
    format: $dde8df59118aada2$export$d9468344d3651243,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$2077e0241d6afd3c = /* #__PURE__ */ (0, $jxFbm.createRound)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    zeros: $dde8df59118aada2$export$4445a00dafa2633b
});
var $dde8df59118aada2$export$48901d58d322262f = /* #__PURE__ */ (0, $1tZnA.createLeftShift)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    zeros: $dde8df59118aada2$export$4445a00dafa2633b
});
var $dde8df59118aada2$export$502f8a5a1147da = /* #__PURE__ */ (0, $gIM5x.createRightLogShift)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    zeros: $dde8df59118aada2$export$4445a00dafa2633b
});
var $dde8df59118aada2$export$398604a469f7de9a = /* #__PURE__ */ (0, $jmzYP.createCompare)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    Fraction: $dde8df59118aada2$export$b336c2702c498be5,
    config: $bO2eg.config,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$2da9287da10b19e2 = /* #__PURE__ */ (0, $h3DmQ.createCompareText)({
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$3f732695c1493aec = /* #__PURE__ */ (0, $gwdP6.createSmaller)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    config: $bO2eg.config,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$a94a7414fa942aea = /* #__PURE__ */ (0, $fueOV.createLarger)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    config: $bO2eg.config,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$b20c1c5fa0c7dd75 = /* #__PURE__ */ (0, $10cD4.createUnequal)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    config: $bO2eg.config,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$66fe727d7ec8c7b9 = /* #__PURE__ */ (0, $atHq5.createImmutableDenseMatrixClass)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    smaller: $dde8df59118aada2$export$3f732695c1493aec
});
var $dde8df59118aada2$export$dd5bb73729f20aa3 = /* #__PURE__ */ (0, $c6ghs.createFibonacciHeapClass)({
    larger: $dde8df59118aada2$export$a94a7414fa942aea,
    smaller: $dde8df59118aada2$export$3f732695c1493aec
});
var $dde8df59118aada2$export$b6b7e189aa5d134c = /* #__PURE__ */ (0, $cqKSJ.createSparse)({
    SparseMatrix: $dde8df59118aada2$export$de9b2b7556879848,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$6faaac9ab79fd3a4 = /* #__PURE__ */ (0, $fLjTM.createAcoth)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$b8b770ee6a0d9760 = /* #__PURE__ */ (0, $juxrq.createAtan2)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$e17a63917e2ebf0f = /* #__PURE__ */ (0, $gt0lu.createSec)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$e16d8520af44a096 = /* #__PURE__ */ (0, $axTFP.createAdd)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    SparseMatrix: $dde8df59118aada2$export$de9b2b7556879848,
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$94132a0e348806d4 = /* #__PURE__ */ (0, $bNcnf.createDot)({
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    conj: $dde8df59118aada2$export$fb254c661fe9c0db,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    size: $dde8df59118aada2$export$346677f925de839c,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$fd2cf6bce05a0b18 = /* #__PURE__ */ (0, $fMkjK.createComposition)({
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    combinations: $dde8df59118aada2$export$bdfcf4c6b5766439,
    isInteger: $dde8df59118aada2$export$a287f47fed4544b8,
    isNegative: $dde8df59118aada2$export$d0909a4f38b5c4d0,
    isPositive: $dde8df59118aada2$export$7e69d4236fcc3b19,
    larger: $dde8df59118aada2$export$a94a7414fa942aea,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$c46ec7d82fb1f602 = /* #__PURE__ */ (0, $kFQL0.createIsZero)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$7860df605315d572 = /* #__PURE__ */ (0, $iNWZH.createMatrixFromFunction)({
    isZero: $dde8df59118aada2$export$c46ec7d82fb1f602,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$841fc4d5a1480b85 = /* #__PURE__ */ (0, $ioRMl.createCbrt)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    Fraction: $dde8df59118aada2$export$b336c2702c498be5,
    config: $bO2eg.config,
    isNegative: $dde8df59118aada2$export$d0909a4f38b5c4d0,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    unaryMinus: $dde8df59118aada2$export$6cd304851a69e08
});
var $dde8df59118aada2$export$a3fe094919f356fd = /* #__PURE__ */ (0, $jbGYt.createFloor)({
    config: $bO2eg.config,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    round: $dde8df59118aada2$export$2077e0241d6afd3c,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$2060d2db72cce88f = /* #__PURE__ */ (0, $hkIg9.createMultiply)({
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    dot: $dde8df59118aada2$export$94132a0e348806d4,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$c6d93afbf4ee8afc = /* #__PURE__ */ (0, $ibm2n.createDotMultiply)({
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$b1f1627d659a651 = /* #__PURE__ */ (0, $6mvgD.createRe)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$bffa455ba8c619a6 = /* #__PURE__ */ (0, $4UXXo.createFlatten)({
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$4380c87abf28fdf = /* #__PURE__ */ (0, $aCm7m.createResize)({
    config: $bO2eg.config,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0
});
var $dde8df59118aada2$export$889c931173b77c2f = /* #__PURE__ */ (0, $568HB.createSqueeze)({
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$2c618a4308a30424 = /* #__PURE__ */ (0, $5pDCm.createTo)({
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$9c297f60e22e3389 = /* #__PURE__ */ (0, $gCVW0.createPow)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    fraction: $dde8df59118aada2$export$7f34ce79760854f7,
    identity: $dde8df59118aada2$export$f0954fd7d5368655,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    number: $dde8df59118aada2$export$98e628dec113755e,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$ef3b15136279c2ab = /* #__PURE__ */ (0, $dvf0V.createDotPow)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    pow: $dde8df59118aada2$export$9c297f60e22e3389,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$a1da16976d3a5f68 = /* #__PURE__ */ (0, $8m8fU.createRightArithShift)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    zeros: $dde8df59118aada2$export$4445a00dafa2633b
});
var $dde8df59118aada2$export$762e84baec56595d = /* #__PURE__ */ (0, $hWhPN.createCompareNatural)({
    compare: $dde8df59118aada2$export$398604a469f7de9a,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$5bc21f656fb5d284 = /* #__PURE__ */ (0, $k8DEe.createEqualText)({
    compareText: $dde8df59118aada2$export$2da9287da10b19e2,
    isZero: $dde8df59118aada2$export$c46ec7d82fb1f602,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$72693dfc692346df = /* #__PURE__ */ (0, $ckhIK.createLargerEq)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    config: $bO2eg.config,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$54d1e322cf7aa273 = /* #__PURE__ */ (0, $i1uRq.createPartitionSelect)({
    compare: $dde8df59118aada2$export$398604a469f7de9a,
    isNaN: $dde8df59118aada2$export$c9f5652083b8129d,
    isNumeric: $dde8df59118aada2$export$e90fb89750dba83f,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$cf17b003b6192af3 = /* #__PURE__ */ (0, $jvvOm.createIndexClass)({
    ImmutableDenseMatrix: $dde8df59118aada2$export$66fe727d7ec8c7b9
});
var $dde8df59118aada2$export$3aaf4e522be48075 = /* #__PURE__ */ (0, $bNlle.createAsech)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$fcdd3b0b3246a325 = /* #__PURE__ */ (0, $CGoi6.createTan)({
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$8bd517cc5b3722f7 = /* #__PURE__ */ (0, $3S0eX.createSetDifference)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    Index: $dde8df59118aada2$export$cf17b003b6192af3,
    compareNatural: $dde8df59118aada2$export$762e84baec56595d,
    size: $dde8df59118aada2$export$346677f925de839c,
    subset: $dde8df59118aada2$export$e06bd7b1ab877a71,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$9404cfefeb010e68 = /* #__PURE__ */ (0, $7x7Wx.createSetIntersect)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    Index: $dde8df59118aada2$export$cf17b003b6192af3,
    compareNatural: $dde8df59118aada2$export$762e84baec56595d,
    size: $dde8df59118aada2$export$346677f925de839c,
    subset: $dde8df59118aada2$export$e06bd7b1ab877a71,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$8bb4a52260216736 = /* #__PURE__ */ (0, $YpSzg.createSetMultiplicity)({
    Index: $dde8df59118aada2$export$cf17b003b6192af3,
    compareNatural: $dde8df59118aada2$export$762e84baec56595d,
    size: $dde8df59118aada2$export$346677f925de839c,
    subset: $dde8df59118aada2$export$e06bd7b1ab877a71,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$1c70a6cc12bc0366 = /* #__PURE__ */ (0, $2YRdb.createSetSize)({
    compareNatural: $dde8df59118aada2$export$762e84baec56595d,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$357889f174732d38 = /* #__PURE__ */ (0, $fLBnu.createTrace)({
    add: $dde8df59118aada2$export$e16d8520af44a096,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$ff63ee916cadcfe = /* #__PURE__ */ (0, $b2fQ4.createQuantileSeq)({
    add: $dde8df59118aada2$export$e16d8520af44a096,
    compare: $dde8df59118aada2$export$398604a469f7de9a,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    partitionSelect: $dde8df59118aada2$export$54d1e322cf7aa273,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$a7ebe8cc6aaf8d37 = /* #__PURE__ */ (0, $k1P9A.createGamma)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    pow: $dde8df59118aada2$export$9c297f60e22e3389,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$8576f72eb7f14a7e = /* #__PURE__ */ (0, $iLb2J.createBignumber)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$e8999e227859a482 = /* #__PURE__ */ (0, $djtod.createMatrixFromColumns)({
    flatten: $dde8df59118aada2$export$bffa455ba8c619a6,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    size: $dde8df59118aada2$export$346677f925de839c,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$f686d97e407ec4ef = /* #__PURE__ */ (0, $eDLq1.createLcm)({
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$361eb278cc70bacf = /* #__PURE__ */ (0, $ed2ke.createBitOr)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$44f32dfde3d58545 = /* #__PURE__ */ (0, $lD1Hd.createKron)({
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$9cb09a71b7d66923 = /* #__PURE__ */ (0, $lo0mZ.createTranspose)({
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$b7a508fa8dae59fc = /* #__PURE__ */ (0, $b6EZL.createNumeric)({
    bignumber: $dde8df59118aada2$export$8576f72eb7f14a7e,
    fraction: $dde8df59118aada2$export$7f34ce79760854f7,
    number: $dde8df59118aada2$export$98e628dec113755e
});
var $dde8df59118aada2$export$21c0ac7fe1cef1b8 = /* #__PURE__ */ (0, $3ZIwJ.createAnd)({
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    not: $dde8df59118aada2$export$6003a5f097c73977,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    zeros: $dde8df59118aada2$export$4445a00dafa2633b
});
var $dde8df59118aada2$export$8d38c87f33a93d98 = /* #__PURE__ */ (0, $3QcS2.createSmallerEq)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    config: $bO2eg.config,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$97db5808d8f88186 = /* #__PURE__ */ (0, $eAKdZ.createSort)({
    compare: $dde8df59118aada2$export$398604a469f7de9a,
    compareNatural: $dde8df59118aada2$export$762e84baec56595d,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$96ec731ed4dcb222 = /* #__PURE__ */ (0, $5eklJ.createMin)({
    config: $bO2eg.config,
    numeric: $dde8df59118aada2$export$b7a508fa8dae59fc,
    smaller: $dde8df59118aada2$export$3f732695c1493aec,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$ef569ec50496610c = /* #__PURE__ */ (0, $55m3V.createCot)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$ec60221e756bab15 = /* #__PURE__ */ (0, $9dgfi.createSetDistinct)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    Index: $dde8df59118aada2$export$cf17b003b6192af3,
    compareNatural: $dde8df59118aada2$export$762e84baec56595d,
    size: $dde8df59118aada2$export$346677f925de839c,
    subset: $dde8df59118aada2$export$e06bd7b1ab877a71,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$f6ce4c11993e56f2 = /* #__PURE__ */ (0, $77hWe.createSetPowerset)({
    Index: $dde8df59118aada2$export$cf17b003b6192af3,
    compareNatural: $dde8df59118aada2$export$762e84baec56595d,
    size: $dde8df59118aada2$export$346677f925de839c,
    subset: $dde8df59118aada2$export$e06bd7b1ab877a71,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$b610b8812bbcded9 = /* #__PURE__ */ (0, $fuwCS.createIndex)({
    Index: $dde8df59118aada2$export$cf17b003b6192af3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$8a63f25cc62965f1 = /* #__PURE__ */ (0, $4NZiI.createSum)({
    add: $dde8df59118aada2$export$e16d8520af44a096,
    config: $bO2eg.config,
    numeric: $dde8df59118aada2$export$b7a508fa8dae59fc,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$329ce89a99f0e343 = /* #__PURE__ */ (0, $hpWEx.createFactorial)({
    gamma: $dde8df59118aada2$export$a7ebe8cc6aaf8d37,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$4567adbe5dd91621 = /* #__PURE__ */ (0, $1EwLg.createPermutations)({
    factorial: $dde8df59118aada2$export$329ce89a99f0e343,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$f4f4b934de52d430 = /* #__PURE__ */ (0, $gQcPe.createMatrixFromRows)({
    flatten: $dde8df59118aada2$export$bffa455ba8c619a6,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    size: $dde8df59118aada2$export$346677f925de839c,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$4e2d2ead65e5f7e3 = /* #__PURE__ */ (0, $kkSft.createSubtract)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    unaryMinus: $dde8df59118aada2$export$6cd304851a69e08
});
var $dde8df59118aada2$export$bb646b20bb93d339 = /* #__PURE__ */ (0, $dELqD.createCross)({
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$d02631cccf789723 = /* #__PURE__ */ (0, $cVCJF.createRange)({
    bignumber: $dde8df59118aada2$export$8576f72eb7f14a7e,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    config: $bO2eg.config,
    larger: $dde8df59118aada2$export$a94a7414fa942aea,
    largerEq: $dde8df59118aada2$export$72693dfc692346df,
    smaller: $dde8df59118aada2$export$3f732695c1493aec,
    smallerEq: $dde8df59118aada2$export$8d38c87f33a93d98,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$120ff0929b202a6d = /* #__PURE__ */ (0, $ccYsB.createRow)({
    Index: $dde8df59118aada2$export$cf17b003b6192af3,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    range: $dde8df59118aada2$export$d02631cccf789723,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$5e143010dea16c85 = /* #__PURE__ */ (0, $ldY29.createProd)({
    config: $bO2eg.config,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    numeric: $dde8df59118aada2$export$b7a508fa8dae59fc,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$411ce8e5a71e3069 = /* #__PURE__ */ (0, $gAGKJ.createEqual)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$8960430cfd85939f = /* #__PURE__ */ (0, $aTI6t.createMax)({
    config: $bO2eg.config,
    larger: $dde8df59118aada2$export$a94a7414fa942aea,
    numeric: $dde8df59118aada2$export$b7a508fa8dae59fc,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$dcac7a71ff10ad82 = /* #__PURE__ */ (0, $3sovY.createSetCartesian)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    Index: $dde8df59118aada2$export$cf17b003b6192af3,
    compareNatural: $dde8df59118aada2$export$762e84baec56595d,
    size: $dde8df59118aada2$export$346677f925de839c,
    subset: $dde8df59118aada2$export$e06bd7b1ab877a71,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$a7eac91d5496c35b = /* #__PURE__ */ (0, $7jsoH.createSetSymDifference)({
    Index: $dde8df59118aada2$export$cf17b003b6192af3,
    concat: $dde8df59118aada2$export$ee1b3e54f0441b22,
    setDifference: $dde8df59118aada2$export$8bd517cc5b3722f7,
    size: $dde8df59118aada2$export$346677f925de839c,
    subset: $dde8df59118aada2$export$e06bd7b1ab877a71,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$803ce6b71a0a94b2 = /* #__PURE__ */ (0, $9MGdW.createCeil)({
    config: $bO2eg.config,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    round: $dde8df59118aada2$export$2077e0241d6afd3c,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$6444ef5cd411280c = /* #__PURE__ */ (0, $1FImG.createXor)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$85b9a36db797e02b = /* #__PURE__ */ (0, $g3xgo.createCount)({
    prod: $dde8df59118aada2$export$5e143010dea16c85,
    size: $dde8df59118aada2$export$346677f925de839c,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$eb6ad7870b1d0b0b = /* #__PURE__ */ (0, $95cDc.createCtranspose)({
    conj: $dde8df59118aada2$export$fb254c661fe9c0db,
    transpose: $dde8df59118aada2$export$9cb09a71b7d66923,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$9cb4719e2e525b7a = /* #__PURE__ */ (0, $hY5r0.createDeepEqual)({
    equal: $dde8df59118aada2$export$411ce8e5a71e3069,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$ca5251f59a067f9a = /* #__PURE__ */ (0, $fCaiE.createSetIsSubset)({
    Index: $dde8df59118aada2$export$cf17b003b6192af3,
    compareNatural: $dde8df59118aada2$export$762e84baec56595d,
    size: $dde8df59118aada2$export$346677f925de839c,
    subset: $dde8df59118aada2$export$e06bd7b1ab877a71,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$d838837eb5b184e3 = /* #__PURE__ */ (0, $ghUlP.createFix)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    ceil: $dde8df59118aada2$export$803ce6b71a0a94b2,
    floor: $dde8df59118aada2$export$a3fe094919f356fd,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$a37e3c603d7117e5 = /* #__PURE__ */ (0, $3t0qc.createDiff)({
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    number: $dde8df59118aada2$export$98e628dec113755e,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$67275f837d70084d = /* #__PURE__ */ (0, $aWbIO.createDivideScalar)({
    numeric: $dde8df59118aada2$export$b7a508fa8dae59fc,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$adb173527af10aca = /* #__PURE__ */ (0, $kim9k.createNthRoots)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$be3b83cc1aa539e4 = /* #__PURE__ */ (0, $dPUMt.createLsolve)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$de5c6af4003ef448 = /* #__PURE__ */ (0, $SnoAE.createLsolveAll)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$6d4069f4b64f7492 = /* #__PURE__ */ (0, $8pEqa.createSpaClass)({
    FibonacciHeap: $dde8df59118aada2$export$dd5bb73729f20aa3,
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156
});
var $dde8df59118aada2$export$667066422fa0af46 = /* #__PURE__ */ (0, $ahdW9.createSetUnion)({
    Index: $dde8df59118aada2$export$cf17b003b6192af3,
    concat: $dde8df59118aada2$export$ee1b3e54f0441b22,
    setIntersect: $dde8df59118aada2$export$9404cfefeb010e68,
    setSymDifference: $dde8df59118aada2$export$a7eac91d5496c35b,
    size: $dde8df59118aada2$export$346677f925de839c,
    subset: $dde8df59118aada2$export$e06bd7b1ab877a71,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$91d2d01a33a1e6f8 = /* #__PURE__ */ (0, $dMQoA.createLup)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    Spa: $dde8df59118aada2$export$6d4069f4b64f7492,
    SparseMatrix: $dde8df59118aada2$export$de9b2b7556879848,
    abs: $dde8df59118aada2$export$2335f513bbd82c6d,
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    larger: $dde8df59118aada2$export$a94a7414fa942aea,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    unaryMinus: $dde8df59118aada2$export$6cd304851a69e08
});
var $dde8df59118aada2$export$95c7459688ef4e3a = /* #__PURE__ */ (0, $lLfhi.createSlu)({
    SparseMatrix: $dde8df59118aada2$export$de9b2b7556879848,
    abs: $dde8df59118aada2$export$2335f513bbd82c6d,
    add: $dde8df59118aada2$export$e16d8520af44a096,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    larger: $dde8df59118aada2$export$a94a7414fa942aea,
    largerEq: $dde8df59118aada2$export$72693dfc692346df,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    transpose: $dde8df59118aada2$export$9cb09a71b7d66923,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$d063d65fed97e7fa = /* #__PURE__ */ (0, $e6uiK.createDet)({
    lup: $dde8df59118aada2$export$91d2d01a33a1e6f8,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    unaryMinus: $dde8df59118aada2$export$6cd304851a69e08
});
var $dde8df59118aada2$export$9f17032d917177de = /* #__PURE__ */ (0, $1aeKv.createDistance)({
    abs: $dde8df59118aada2$export$2335f513bbd82c6d,
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    sqrt: $dde8df59118aada2$export$eba8049fb5020b81,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    unaryMinus: $dde8df59118aada2$export$6cd304851a69e08
});
var $dde8df59118aada2$export$a5abae3de3985f2f = /* #__PURE__ */ (0, $j2DxC.createStirlingS2)({
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    combinations: $dde8df59118aada2$export$bdfcf4c6b5766439,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    factorial: $dde8df59118aada2$export$329ce89a99f0e343,
    isInteger: $dde8df59118aada2$export$a287f47fed4544b8,
    isNegative: $dde8df59118aada2$export$d0909a4f38b5c4d0,
    larger: $dde8df59118aada2$export$a94a7414fa942aea,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    pow: $dde8df59118aada2$export$9c297f60e22e3389,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$d8807a6c0487483a = /* #__PURE__ */ (0, $Xa8Ku.createCatalan)({
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    combinations: $dde8df59118aada2$export$bdfcf4c6b5766439,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    isInteger: $dde8df59118aada2$export$a287f47fed4544b8,
    isNegative: $dde8df59118aada2$export$d0909a4f38b5c4d0,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$4e0c71f277ca26b3 = /* #__PURE__ */ (0, $9vb66.createColumn)({
    Index: $dde8df59118aada2$export$cf17b003b6192af3,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    range: $dde8df59118aada2$export$d02631cccf789723,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$bef1f36f5486a6a3 = /* #__PURE__ */ (0, $e2lPV.createLog)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$c74f132961c51406 = /* #__PURE__ */ (0, $euY4t.createDotDivide)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$c8a1cf0e83678d9 = /* #__PURE__ */ (0, $c0n5Z.createUsolveAll)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$f95c7888b62f8e9a = /* #__PURE__ */ (0, $2pmUs.createHypot)({
    abs: $dde8df59118aada2$export$2335f513bbd82c6d,
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    isPositive: $dde8df59118aada2$export$7e69d4236fcc3b19,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    smaller: $dde8df59118aada2$export$3f732695c1493aec,
    sqrt: $dde8df59118aada2$export$eba8049fb5020b81,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$7c27fb47516129d9 = /* #__PURE__ */ (0, $3atMK.createQr)({
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    complex: $dde8df59118aada2$export$83a0e34f1302825b,
    conj: $dde8df59118aada2$export$fb254c661fe9c0db,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    equal: $dde8df59118aada2$export$411ce8e5a71e3069,
    identity: $dde8df59118aada2$export$f0954fd7d5368655,
    isZero: $dde8df59118aada2$export$c46ec7d82fb1f602,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    sign: $dde8df59118aada2$export$c5552dfdbc7cec71,
    sqrt: $dde8df59118aada2$export$eba8049fb5020b81,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    unaryMinus: $dde8df59118aada2$export$6cd304851a69e08,
    zeros: $dde8df59118aada2$export$4445a00dafa2633b
});
var $dde8df59118aada2$export$c02accee9f2b6a8f = /* #__PURE__ */ (0, $dH0wG.createInv)({
    abs: $dde8df59118aada2$export$2335f513bbd82c6d,
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    det: $dde8df59118aada2$export$d063d65fed97e7fa,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    identity: $dde8df59118aada2$export$f0954fd7d5368655,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    unaryMinus: $dde8df59118aada2$export$6cd304851a69e08
});
var $dde8df59118aada2$export$d9bacaa51f70e8e = /* #__PURE__ */ (0, $gYuoo.createExpm)({
    abs: $dde8df59118aada2$export$2335f513bbd82c6d,
    add: $dde8df59118aada2$export$e16d8520af44a096,
    identity: $dde8df59118aada2$export$f0954fd7d5368655,
    inv: $dde8df59118aada2$export$c02accee9f2b6a8f,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$cd007d971a5a2143 = /* #__PURE__ */ (0, $gz8Vv.createDivide)({
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    inv: $dde8df59118aada2$export$c02accee9f2b6a8f,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$1ce691f85baaa52 = /* #__PURE__ */ (0, $4P03R.createMean)({
    add: $dde8df59118aada2$export$e16d8520af44a096,
    divide: $dde8df59118aada2$export$cd007d971a5a2143,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$9b77da0927470c3d = /* #__PURE__ */ (0, $4yw8r.createVariance)({
    add: $dde8df59118aada2$export$e16d8520af44a096,
    apply: $dde8df59118aada2$export$5635d7ef4b8fee1c,
    divide: $dde8df59118aada2$export$cd007d971a5a2143,
    isNaN: $dde8df59118aada2$export$c9f5652083b8129d,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$a9fffb6ae6e33dcc = /* #__PURE__ */ (0, $lSqCP.createKldivergence)({
    divide: $dde8df59118aada2$export$cd007d971a5a2143,
    dotDivide: $dde8df59118aada2$export$c74f132961c51406,
    isNumeric: $dde8df59118aada2$export$e90fb89750dba83f,
    log: $dde8df59118aada2$export$bef1f36f5486a6a3,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    sum: $dde8df59118aada2$export$8a63f25cc62965f1,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$bb522a71cda46a13 = /* #__PURE__ */ (0, $6Gx92.createBellNumbers)({
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    isInteger: $dde8df59118aada2$export$a287f47fed4544b8,
    isNegative: $dde8df59118aada2$export$d0909a4f38b5c4d0,
    stirlingS2: $dde8df59118aada2$export$a5abae3de3985f2f,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$144dcf16adfb9698 = /* #__PURE__ */ (0, $aelBe.createLog1p)({
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    config: $bO2eg.config,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    log: $dde8df59118aada2$export$bef1f36f5486a6a3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$1d8b9ae22d404866 = /* #__PURE__ */ (0, $9QsFn.createUnitClass)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Complex: $dde8df59118aada2$export$50ceb3fb9926e63e,
    Fraction: $dde8df59118aada2$export$b336c2702c498be5,
    abs: $dde8df59118aada2$export$2335f513bbd82c6d,
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    config: $bO2eg.config,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    equal: $dde8df59118aada2$export$411ce8e5a71e3069,
    fix: $dde8df59118aada2$export$d838837eb5b184e3,
    format: $dde8df59118aada2$export$d9468344d3651243,
    isNumeric: $dde8df59118aada2$export$e90fb89750dba83f,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    number: $dde8df59118aada2$export$98e628dec113755e,
    pow: $dde8df59118aada2$export$9c297f60e22e3389,
    round: $dde8df59118aada2$export$2077e0241d6afd3c,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3
});
var $dde8df59118aada2$export$aab44654646f3ccc = /* #__PURE__ */ (0, $2DDJF.createCreateUnit)({
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$17c7cd2216e18593 = /* #__PURE__ */ (0, $4oju7.createSqrtm)({
    abs: $dde8df59118aada2$export$2335f513bbd82c6d,
    add: $dde8df59118aada2$export$e16d8520af44a096,
    identity: $dde8df59118aada2$export$f0954fd7d5368655,
    inv: $dde8df59118aada2$export$c02accee9f2b6a8f,
    max: $dde8df59118aada2$export$8960430cfd85939f,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    size: $dde8df59118aada2$export$346677f925de839c,
    sqrt: $dde8df59118aada2$export$eba8049fb5020b81,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$9c490b34b2f16a34 = /* #__PURE__ */ (0, $bhx9l.createMedian)({
    add: $dde8df59118aada2$export$e16d8520af44a096,
    compare: $dde8df59118aada2$export$398604a469f7de9a,
    divide: $dde8df59118aada2$export$cd007d971a5a2143,
    partitionSelect: $dde8df59118aada2$export$54d1e322cf7aa273,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$b14c5e819cb6c927 = /* #__PURE__ */ (0, $9BZAX.createStd)({
    sqrt: $dde8df59118aada2$export$eba8049fb5020b81,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    variance: $dde8df59118aada2$export$9b77da0927470c3d
});
var $dde8df59118aada2$export$11b531e5540c3ca4 = /* #__PURE__ */ (0, $bfQdA.createAtomicMass)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$c779781d69f736e8 = /* #__PURE__ */ (0, $bfQdA.createBohrMagneton)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$f727e86dcab4e2c6 = /* #__PURE__ */ (0, $bfQdA.createBoltzmann)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$6eafe330bdda8c71 = /* #__PURE__ */ (0, $bfQdA.createConductanceQuantum)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$80bf07f129ad1319 = /* #__PURE__ */ (0, $bfQdA.createDeuteronMass)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$c00fb43e712bef2c = /* #__PURE__ */ (0, $bfQdA.createElectronMass)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$7130fbae042d5c0f = /* #__PURE__ */ (0, $bfQdA.createFaraday)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$f83f3c3b84952e0b = /* #__PURE__ */ (0, $bfQdA.createFirstRadiation)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$d9cccfa50756330b = /* #__PURE__ */ (0, $bfQdA.createGravitationConstant)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$37b0dd3693d47685 = /* #__PURE__ */ (0, $bfQdA.createHartreeEnergy)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$10054c6b64de12f5 = /* #__PURE__ */ (0, $bfQdA.createKlitzing)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$ba3f3691dd1c5a7 = /* #__PURE__ */ (0, $bfQdA.createMagneticConstant)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$6d4ff429f3f89356 = /* #__PURE__ */ (0, $bfQdA.createMolarMass)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$dacf4a2cf8881dff = /* #__PURE__ */ (0, $bfQdA.createMolarPlanckConstant)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$ba7a41eda790cc15 = /* #__PURE__ */ (0, $bfQdA.createNeutronMass)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$9b1b4e5bc980cec6 = /* #__PURE__ */ (0, $bfQdA.createPlanckCharge)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$c20ab336465d7d5e = /* #__PURE__ */ (0, $bfQdA.createPlanckLength)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$5a85cd1a26c2cced = /* #__PURE__ */ (0, $bfQdA.createPlanckTemperature)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$1c88a737209eb089 = /* #__PURE__ */ (0, $bfQdA.createProtonMass)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$963167ae5579ea00 = /* #__PURE__ */ (0, $bfQdA.createReducedPlanckConstant)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$1f7c42a78c01e4f9 = /* #__PURE__ */ (0, $bfQdA.createSecondRadiation)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$f63e81544c3d56ef = /* #__PURE__ */ (0, $bfQdA.createStefanBoltzmann)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$4b15dbe639ad9539 = /* #__PURE__ */ (0, $bfQdA.createVacuumImpedance)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$41828460570e21eb = /* #__PURE__ */ (0, $lvQKV.createUsolve)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$fccc724a69f253a = /* #__PURE__ */ (0, $jWy7j.createLusolve)({
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    lsolve: $dde8df59118aada2$export$be3b83cc1aa539e4,
    lup: $dde8df59118aada2$export$91d2d01a33a1e6f8,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    slu: $dde8df59118aada2$export$95c7459688ef4e3a,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    usolve: $dde8df59118aada2$export$41828460570e21eb
});
var $dde8df59118aada2$export$e822b38c59ee8a2a = /* #__PURE__ */ (0, $7iTF4.createEigs)({
    abs: $dde8df59118aada2$export$2335f513bbd82c6d,
    add: $dde8df59118aada2$export$e16d8520af44a096,
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    atan: $dde8df59118aada2$export$628dc4eed22b0fbd,
    bignumber: $dde8df59118aada2$export$8576f72eb7f14a7e,
    column: $dde8df59118aada2$export$4e0c71f277ca26b3,
    complex: $dde8df59118aada2$export$83a0e34f1302825b,
    config: $bO2eg.config,
    cos: $dde8df59118aada2$export$50d414a77b60d802,
    diag: $dde8df59118aada2$export$c042e7c2f59bc046,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    dot: $dde8df59118aada2$export$94132a0e348806d4,
    equal: $dde8df59118aada2$export$411ce8e5a71e3069,
    flatten: $dde8df59118aada2$export$bffa455ba8c619a6,
    im: $dde8df59118aada2$export$5fc500b917996661,
    inv: $dde8df59118aada2$export$c02accee9f2b6a8f,
    larger: $dde8df59118aada2$export$a94a7414fa942aea,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    matrixFromColumns: $dde8df59118aada2$export$e8999e227859a482,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    number: $dde8df59118aada2$export$98e628dec113755e,
    qr: $dde8df59118aada2$export$7c27fb47516129d9,
    re: $dde8df59118aada2$export$b1f1627d659a651,
    sin: $dde8df59118aada2$export$5de3937cb4b592ed,
    smaller: $dde8df59118aada2$export$3f732695c1493aec,
    sqrt: $dde8df59118aada2$export$eba8049fb5020b81,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    usolve: $dde8df59118aada2$export$41828460570e21eb,
    usolveAll: $dde8df59118aada2$export$c8a1cf0e83678d9
});
var $dde8df59118aada2$export$b14ea41a64d6efa6 = /* #__PURE__ */ (0, $eRGGO.createMad)({
    abs: $dde8df59118aada2$export$2335f513bbd82c6d,
    map: $dde8df59118aada2$export$871de8747c9eaa88,
    median: $dde8df59118aada2$export$9c490b34b2f16a34,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$1236f2451dbdfd63 = /* #__PURE__ */ (0, $bfQdA.createAvogadro)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$f48a0c6b8cc21601 = /* #__PURE__ */ (0, $bfQdA.createClassicalElectronRadius)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$11ff82822f958f25 = /* #__PURE__ */ (0, $bfQdA.createElectricConstant)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$84a9a66802fec40 = /* #__PURE__ */ (0, $bfQdA.createFermiCoupling)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$bfb00cec0048377d = /* #__PURE__ */ (0, $bfQdA.createGravity)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$9eedba962d6a1c01 = /* #__PURE__ */ (0, $bfQdA.createLoschmidt)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$9589ebe123df8f2e = /* #__PURE__ */ (0, $bfQdA.createMolarMassC12)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$7274fb1d27d1cd19 = /* #__PURE__ */ (0, $bfQdA.createNuclearMagneton)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$5ce790af25e5ac75 = /* #__PURE__ */ (0, $bfQdA.createPlanckMass)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$5d88bfa2004001d3 = /* #__PURE__ */ (0, $bfQdA.createQuantumOfCirculation)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$5d66ae3b3e8fce48 = /* #__PURE__ */ (0, $bfQdA.createSpeedOfLight)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$2bcc1e96766dec50 = /* #__PURE__ */ (0, $bfQdA.createWienDisplacement)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$523c0b569236b342 = /* #__PURE__ */ (0, $fmE5G.createUnitFunction)({
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$1f4807a235930d45 = /* #__PURE__ */ (0, $iJlfn.createIntersect)({
    abs: $dde8df59118aada2$export$2335f513bbd82c6d,
    add: $dde8df59118aada2$export$e16d8520af44a096,
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    config: $bO2eg.config,
    divideScalar: $dde8df59118aada2$export$67275f837d70084d,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    flatten: $dde8df59118aada2$export$bffa455ba8c619a6,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    smaller: $dde8df59118aada2$export$3f732695c1493aec,
    subtract: $dde8df59118aada2$export$4e2d2ead65e5f7e3,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$2f2e110dac549211 = /* #__PURE__ */ (0, $bfQdA.createCoulomb)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$a614e1ad972260a9 = /* #__PURE__ */ (0, $bfQdA.createGasConstant)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$699e2a89b148c5ee = /* #__PURE__ */ (0, $bfQdA.createMagneticFluxQuantum)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$cbd33810258dab2e = /* #__PURE__ */ (0, $bfQdA.createPlanckConstant)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$683732ab8f5759dc = /* #__PURE__ */ (0, $bfQdA.createRydberg)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$1991ecd29cc92c6b = /* #__PURE__ */ (0, $1hReh.createNorm)({
    abs: $dde8df59118aada2$export$2335f513bbd82c6d,
    add: $dde8df59118aada2$export$e16d8520af44a096,
    conj: $dde8df59118aada2$export$fb254c661fe9c0db,
    ctranspose: $dde8df59118aada2$export$eb6ad7870b1d0b0b,
    eigs: $dde8df59118aada2$export$e822b38c59ee8a2a,
    equalScalar: $dde8df59118aada2$export$943761f5c9c3f156,
    larger: $dde8df59118aada2$export$a94a7414fa942aea,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    pow: $dde8df59118aada2$export$9c297f60e22e3389,
    smaller: $dde8df59118aada2$export$3f732695c1493aec,
    sqrt: $dde8df59118aada2$export$eba8049fb5020b81,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$199cdfec7f52c877 = /* #__PURE__ */ (0, $bfQdA.createElementaryCharge)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$863459416408c428 = /* #__PURE__ */ (0, $bfQdA.createMolarVolume)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$93039724ea765a8e = /* #__PURE__ */ (0, $bfQdA.createThomsonCrossSection)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$52ded331ee8b28e8 = /* #__PURE__ */ (0, $YeBIy.createRotationMatrix)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    DenseMatrix: $dde8df59118aada2$export$97f0d27b48f120e8,
    SparseMatrix: $dde8df59118aada2$export$de9b2b7556879848,
    addScalar: $dde8df59118aada2$export$2b7b095c4f443355,
    config: $bO2eg.config,
    cos: $dde8df59118aada2$export$50d414a77b60d802,
    matrix: $dde8df59118aada2$export$9bdad1ae37d738e0,
    multiplyScalar: $dde8df59118aada2$export$c697bed75648cdb7,
    norm: $dde8df59118aada2$export$1991ecd29cc92c6b,
    sin: $dde8df59118aada2$export$5de3937cb4b592ed,
    typed: $dde8df59118aada2$export$519f616c41a1c711,
    unaryMinus: $dde8df59118aada2$export$6cd304851a69e08
});
var $dde8df59118aada2$export$5a57f82afcc3edeb = /* #__PURE__ */ (0, $bfQdA.createBohrRadius)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$85aaf319784a5b0 = /* #__PURE__ */ (0, $bfQdA.createPlanckTime)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});
var $dde8df59118aada2$export$bb628a54ab399bc9 = /* #__PURE__ */ (0, $5aeqE.createRotate)({
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    rotationMatrix: $dde8df59118aada2$export$52ded331ee8b28e8,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$f4d580f3101a1c7e = /* #__PURE__ */ (0, $4byQb.createMultinomial)({
    add: $dde8df59118aada2$export$e16d8520af44a096,
    divide: $dde8df59118aada2$export$cd007d971a5a2143,
    factorial: $dde8df59118aada2$export$329ce89a99f0e343,
    isInteger: $dde8df59118aada2$export$a287f47fed4544b8,
    isPositive: $dde8df59118aada2$export$7e69d4236fcc3b19,
    multiply: $dde8df59118aada2$export$2060d2db72cce88f,
    typed: $dde8df59118aada2$export$519f616c41a1c711
});
var $dde8df59118aada2$export$f060c4f0aa5bef89 = /* #__PURE__ */ (0, $bfQdA.createInverseConductanceQuantum)({
    BigNumber: $dde8df59118aada2$export$d97aa349ed20696,
    Unit: $dde8df59118aada2$export$1d8b9ae22d404866,
    config: $bO2eg.config
});

});
parcelRegister("bO2eg", function(module, exports) {

$parcel$export(module.exports, "config", () => $898617dbf90506b1$export$e506a1d27d1eaa20);

var $8Wv3B = parcelRequire("8Wv3B");

var $a0Wtd = parcelRequire("a0Wtd");

var $i8I70 = parcelRequire("i8I70");
var $898617dbf90506b1$export$e506a1d27d1eaa20 = /* #__PURE__ */ function config(options) {
    if (options) throw new Error("The global config is readonly. \nPlease create a mathjs instance if you want to change the default configuration. \nExample:\n\n  import { create, all } from 'mathjs';\n  const mathjs = create(all);\n  mathjs.config({ number: 'BigNumber' });\n");
    return Object.freeze((0, $a0Wtd.DEFAULT_CONFIG));
};
(0, (/*@__PURE__*/$parcel$interopDefault($8Wv3B)))($898617dbf90506b1$export$e506a1d27d1eaa20, (0, $a0Wtd.DEFAULT_CONFIG), {
    MATRIX_OPTIONS: $i8I70.MATRIX_OPTIONS,
    NUMBER_OPTIONS: $i8I70.NUMBER_OPTIONS
});

});
parcelRegister("8Wv3B", function(module, exports) {
function $682bd4cd285df927$var$_extends() {
    return module.exports = $682bd4cd285df927$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $682bd4cd285df927$var$_extends.apply(null, arguments);
}
module.exports = $682bd4cd285df927$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("a0Wtd", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $74a7426a9c73f81d$export$c2f8e0cc249a8d8f);
var $74a7426a9c73f81d$export$c2f8e0cc249a8d8f = {
    // minimum relative difference between two compared values,
    // used by all comparison functions
    epsilon: 1e-12,
    // type of default matrix output. Choose 'matrix' (default) or 'array'
    matrix: 'Matrix',
    // type of default number output. Choose 'number' (default) 'BigNumber', or 'Fraction
    number: 'number',
    // number of significant digits in BigNumbers
    precision: 64,
    // predictable output type of functions. When true, output type depends only
    // on the input types. When false (default), output type can vary depending
    // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
    // predictable is false, and returns `NaN` when true.
    predictable: false,
    // random seed for seeded pseudo random number generation
    // null = randomly seed
    randomSeed: null
};

});

parcelRegister("i8I70", function(module, exports) {

$parcel$export(module.exports, "MATRIX_OPTIONS", () => $d34b3110603c9f9a$export$517ab898194ae9af);
$parcel$export(module.exports, "NUMBER_OPTIONS", () => $d34b3110603c9f9a$export$f4b0a2084fdf2177);

var $4mYv9 = parcelRequire("4mYv9");

var $a0Wtd = parcelRequire("a0Wtd");
var $d34b3110603c9f9a$export$517ab898194ae9af = [
    'Matrix',
    'Array'
]; // valid values for option matrix
var $d34b3110603c9f9a$export$f4b0a2084fdf2177 = [
    'number',
    'BigNumber',
    'Fraction'
]; // valid values for option number
function $d34b3110603c9f9a$export$3984aa6f7f77f1ae(config, emit) {
    /**
   * Set configuration options for math.js, and get current options.
   * Will emit a 'config' event, with arguments (curr, prev, changes).
   *
   * This function is only available on a mathjs instance created using `create`.
   *
   * Syntax:
   *
   *     math.config(config: Object): Object
   *
   * Examples:
   *
   *
   *     import { create, all } from 'mathjs'
   *
   *     // create a mathjs instance
   *     const math = create(all)
   *
   *     math.config().number                // outputs 'number'
   *     math.evaluate('0.4')                // outputs number 0.4
   *     math.config({number: 'Fraction'})
   *     math.evaluate('0.4')                // outputs Fraction 2/5
   *
   * @param {Object} [options] Available options:
   *                            {number} epsilon
   *                              Minimum relative difference between two
   *                              compared values, used by all comparison functions.
   *                            {string} matrix
   *                              A string 'Matrix' (default) or 'Array'.
   *                            {string} number
   *                              A string 'number' (default), 'BigNumber', or 'Fraction'
   *                            {number} precision
   *                              The number of significant digits for BigNumbers.
   *                              Not applicable for Numbers.
   *                            {string} parenthesis
   *                              How to display parentheses in LaTeX and string
   *                              output.
   *                            {string} randomSeed
   *                              Random seed for seeded pseudo random number generator.
   *                              Set to null to randomly seed.
   * @return {Object} Returns the current configuration
   */ function _config(options) {
        if (options) {
            var prev = (0, $4mYv9.mapObject)(config, (0, $4mYv9.clone)); // validate some of the options
            $d34b3110603c9f9a$var$validateOption(options, 'matrix', $d34b3110603c9f9a$export$517ab898194ae9af);
            $d34b3110603c9f9a$var$validateOption(options, 'number', $d34b3110603c9f9a$export$f4b0a2084fdf2177); // merge options
            (0, $4mYv9.deepExtend)(config, options);
            var curr = (0, $4mYv9.mapObject)(config, (0, $4mYv9.clone));
            var changes = (0, $4mYv9.mapObject)(options, (0, $4mYv9.clone)); // emit 'config' event
            emit('config', curr, prev, changes);
            return curr;
        } else return (0, $4mYv9.mapObject)(config, (0, $4mYv9.clone));
    } // attach the valid options to the function so they can be extended
    _config.MATRIX_OPTIONS = $d34b3110603c9f9a$export$517ab898194ae9af;
    _config.NUMBER_OPTIONS = $d34b3110603c9f9a$export$f4b0a2084fdf2177; // attach the config properties as readonly properties to the config function
    Object.keys((0, $a0Wtd.DEFAULT_CONFIG)).forEach((key)=>{
        Object.defineProperty(_config, key, {
            get: ()=>config[key],
            enumerable: true,
            configurable: true
        });
    });
    return _config;
}
/**
 * Test whether an Array contains a specific item.
 * @param {Array.<string>} array
 * @param {string} item
 * @return {boolean}
 */ function $d34b3110603c9f9a$var$contains(array, item) {
    return array.indexOf(item) !== -1;
}
/**
 * Validate an option
 * @param {Object} options         Object with options
 * @param {string} name            Name of the option to validate
 * @param {Array.<string>} values  Array with valid values for this option
 */ function $d34b3110603c9f9a$var$validateOption(options, name, values) {
    if (options[name] !== undefined && !$d34b3110603c9f9a$var$contains(values, options[name])) // unknown value
    console.warn('Warning: Unknown value "' + options[name] + '" for configuration option "' + name + '". ' + 'Available options: ' + values.map((value)=>JSON.stringify(value)).join(', ') + '.');
}

});
parcelRegister("4mYv9", function(module, exports) {

$parcel$export(module.exports, "clone", () => $32e825ce866e8ccf$export$9cd59f9826255e47);
$parcel$export(module.exports, "mapObject", () => $32e825ce866e8ccf$export$d6051a0f7a227332);
$parcel$export(module.exports, "hasOwnProperty", () => $32e825ce866e8ccf$export$5a15a386532a5ea4);
$parcel$export(module.exports, "extend", () => $32e825ce866e8ccf$export$8b58be045bf06082);
$parcel$export(module.exports, "deepExtend", () => $32e825ce866e8ccf$export$54e9fb29908872fa);
$parcel$export(module.exports, "deepStrictEqual", () => $32e825ce866e8ccf$export$6cc798251952180);
$parcel$export(module.exports, "pickShallow", () => $32e825ce866e8ccf$export$8cea971c64639ea7);

var $gs7TF = parcelRequire("gs7TF");
function $32e825ce866e8ccf$export$9cd59f9826255e47(x) {
    var type = typeof x; // immutable primitive types
    if (type === 'number' || type === 'string' || type === 'boolean' || x === null || x === undefined) return x;
     // use clone function of the object when available
    if (typeof x.clone === 'function') return x.clone();
     // array
    if (Array.isArray(x)) return x.map(function(value) {
        return $32e825ce866e8ccf$export$9cd59f9826255e47(value);
    });
    if (x instanceof Date) return new Date(x.valueOf());
    if ((0, $gs7TF.isBigNumber)(x)) return x; // bignumbers are immutable
    if (x instanceof RegExp) throw new TypeError('Cannot clone ' + x); // TODO: clone a RegExp
    // object
    return $32e825ce866e8ccf$export$d6051a0f7a227332(x, $32e825ce866e8ccf$export$9cd59f9826255e47);
}
function $32e825ce866e8ccf$export$d6051a0f7a227332(object, callback) {
    var clone = {};
    for(var key in object)if ($32e825ce866e8ccf$export$5a15a386532a5ea4(object, key)) clone[key] = callback(object[key]);
    return clone;
}
function $32e825ce866e8ccf$export$8b58be045bf06082(a, b) {
    for(var prop in b)if ($32e825ce866e8ccf$export$5a15a386532a5ea4(b, prop)) a[prop] = b[prop];
    return a;
}
function $32e825ce866e8ccf$export$54e9fb29908872fa(a, b) {
    // TODO: add support for Arrays to deepExtend
    if (Array.isArray(b)) throw new TypeError('Arrays are not supported by deepExtend');
    for(var prop in b)// We check against prop not being in Object.prototype or Function.prototype
    // to prevent polluting for example Object.__proto__.
    if ($32e825ce866e8ccf$export$5a15a386532a5ea4(b, prop) && !(prop in Object.prototype) && !(prop in Function.prototype)) {
        if (b[prop] && b[prop].constructor === Object) {
            if (a[prop] === undefined) a[prop] = {};
            if (a[prop] && a[prop].constructor === Object) $32e825ce866e8ccf$export$54e9fb29908872fa(a[prop], b[prop]);
            else a[prop] = b[prop];
        } else if (Array.isArray(b[prop])) throw new TypeError('Arrays are not supported by deepExtend');
        else a[prop] = b[prop];
    }
    return a;
}
function $32e825ce866e8ccf$export$6cc798251952180(a, b) {
    var prop, i, len;
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0, len = a.length; i < len; i++){
            if (!$32e825ce866e8ccf$export$6cc798251952180(a[i], b[i])) return false;
        }
        return true;
    } else if (typeof a === 'function') return a === b;
    else if (a instanceof Object) {
        if (Array.isArray(b) || !(b instanceof Object)) return false;
        for(prop in a){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in b) || !$32e825ce866e8ccf$export$6cc798251952180(a[prop], b[prop])) return false;
        }
        for(prop in b){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in a) || !$32e825ce866e8ccf$export$6cc798251952180(a[prop], b[prop])) return false;
        }
        return true;
    } else return a === b;
}
function $32e825ce866e8ccf$export$519b2d75cc54d03b(nestedObject) {
    var flattenedObject = {};
    $32e825ce866e8ccf$var$_deepFlatten(nestedObject, flattenedObject);
    return flattenedObject;
} // helper function used by deepFlatten
function $32e825ce866e8ccf$var$_deepFlatten(nestedObject, flattenedObject) {
    for(var prop in nestedObject)if ($32e825ce866e8ccf$export$5a15a386532a5ea4(nestedObject, prop)) {
        var value = nestedObject[prop];
        if (typeof value === 'object' && value !== null) $32e825ce866e8ccf$var$_deepFlatten(value, flattenedObject);
        else flattenedObject[prop] = value;
    }
}
function $32e825ce866e8ccf$export$a73e197d57374bd3() {
    // test needed for broken IE8 implementation
    try {
        if (Object.defineProperty) {
            Object.defineProperty({}, 'x', {
                get: function get() {}
            });
            return true;
        }
    } catch (e) {}
    return false;
}
function $32e825ce866e8ccf$export$488013bae63b21da(object, prop, valueResolver) {
    var _uninitialized = true;
    var _value;
    Object.defineProperty(object, prop, {
        get: function get() {
            if (_uninitialized) {
                _value = valueResolver();
                _uninitialized = false;
            }
            return _value;
        },
        set: function set(value) {
            _value = value;
            _uninitialized = false;
        },
        configurable: true,
        enumerable: true
    });
}
function $32e825ce866e8ccf$export$df3f009e3d155b20(object, path) {
    if (path && typeof path === 'string') return $32e825ce866e8ccf$export$df3f009e3d155b20(object, path.split('.'));
    var obj = object;
    if (path) for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (!(key in obj)) obj[key] = {};
        obj = obj[key];
    }
    return obj;
}
function $32e825ce866e8ccf$export$5a15a386532a5ea4(object, property) {
    return object && Object.hasOwnProperty.call(object, property);
}
function $32e825ce866e8ccf$export$1bc2c269dfa97885(object) {
    return object && typeof object.factory === 'function';
}
function $32e825ce866e8ccf$export$3988ae62b71be9a3(object, path) {
    if (typeof path === 'string') {
        if ($32e825ce866e8ccf$var$isPath(path)) return $32e825ce866e8ccf$export$3988ae62b71be9a3(object, path.split('.'));
        else return object[path];
    }
    var child = object;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        child = child ? child[key] : undefined;
    }
    return child;
}
function $32e825ce866e8ccf$export$adaa4cf7ef1b65be(object, path, value) {
    if (typeof path === 'string') {
        if ($32e825ce866e8ccf$var$isPath(path)) return $32e825ce866e8ccf$export$adaa4cf7ef1b65be(object, path.split('.'), value);
        else {
            object[path] = value;
            return object;
        }
    }
    var child = object;
    for(var i = 0; i < path.length - 1; i++){
        var key = path[i];
        if (child[key] === undefined) child[key] = {};
        child = child[key];
    }
    if (path.length > 0) {
        var lastKey = path[path.length - 1];
        child[lastKey] = value;
    }
    return object;
}
function $32e825ce866e8ccf$export$357523c63a2253b9(object, properties, transform) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = $32e825ce866e8ccf$export$3988ae62b71be9a3(object, key);
        if (value !== undefined) $32e825ce866e8ccf$export$adaa4cf7ef1b65be(copy, key, transform ? transform(value, key) : value);
    }
    return copy;
}
function $32e825ce866e8ccf$export$8cea971c64639ea7(object, properties) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = object[key];
        if (value !== undefined) copy[key] = value;
    }
    return copy;
}
function $32e825ce866e8ccf$export$68c286be0e7e55b7(object) {
    return Object.keys(object).map((key)=>object[key]);
} // helper function to test whether a string contains a path like 'user.name'
function $32e825ce866e8ccf$var$isPath(str) {
    return str.indexOf('.') !== -1;
}

});
parcelRegister("gs7TF", function(module, exports) {

$parcel$export(module.exports, "isNumber", () => $bfa56304cacb87e5$export$7e4aa119212bc614);
$parcel$export(module.exports, "isBigNumber", () => $bfa56304cacb87e5$export$e51d0e7e5c4a03ab);
$parcel$export(module.exports, "isComplex", () => $bfa56304cacb87e5$export$8849a896711efe0c);
$parcel$export(module.exports, "isFraction", () => $bfa56304cacb87e5$export$e312cb8a8e5e7c34);
$parcel$export(module.exports, "isUnit", () => $bfa56304cacb87e5$export$8960dc335987b8da);
$parcel$export(module.exports, "isString", () => $bfa56304cacb87e5$export$844ec244b1367d54);
$parcel$export(module.exports, "isArray", () => $bfa56304cacb87e5$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMatrix", () => $bfa56304cacb87e5$export$b22160e0a14f87b7);
$parcel$export(module.exports, "isCollection", () => $bfa56304cacb87e5$export$cea7aa84e978eba5);
$parcel$export(module.exports, "isDenseMatrix", () => $bfa56304cacb87e5$export$eb44495df7ba11d);
$parcel$export(module.exports, "isSparseMatrix", () => $bfa56304cacb87e5$export$d508368d4da3c38a);
$parcel$export(module.exports, "isRange", () => $bfa56304cacb87e5$export$e331ccfa6f694c99);
$parcel$export(module.exports, "isIndex", () => $bfa56304cacb87e5$export$ba3dc792055c2f45);
$parcel$export(module.exports, "isBoolean", () => $bfa56304cacb87e5$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isResultSet", () => $bfa56304cacb87e5$export$381a1a20e6a63376);
$parcel$export(module.exports, "isHelp", () => $bfa56304cacb87e5$export$e5dec9a75b602d6c);
$parcel$export(module.exports, "isFunction", () => $bfa56304cacb87e5$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isDate", () => $bfa56304cacb87e5$export$871608497c498473);
$parcel$export(module.exports, "isRegExp", () => $bfa56304cacb87e5$export$49841c62b9eff15);
$parcel$export(module.exports, "isObject", () => $bfa56304cacb87e5$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isNull", () => $bfa56304cacb87e5$export$630801d484da15df);
$parcel$export(module.exports, "isUndefined", () => $bfa56304cacb87e5$export$fce6876652108ab);
$parcel$export(module.exports, "isAccessorNode", () => $bfa56304cacb87e5$export$f88fb19d6b9ee5cb);
$parcel$export(module.exports, "isArrayNode", () => $bfa56304cacb87e5$export$440fa93dcf2757a3);
$parcel$export(module.exports, "isAssignmentNode", () => $bfa56304cacb87e5$export$64d7d515ec030d5e);
$parcel$export(module.exports, "isBlockNode", () => $bfa56304cacb87e5$export$1665e2275a3d717a);
$parcel$export(module.exports, "isConditionalNode", () => $bfa56304cacb87e5$export$e1babefe78c70737);
$parcel$export(module.exports, "isConstantNode", () => $bfa56304cacb87e5$export$fa9d80731fd8c54b);
$parcel$export(module.exports, "isFunctionAssignmentNode", () => $bfa56304cacb87e5$export$27c05cfffd263d30);
$parcel$export(module.exports, "isFunctionNode", () => $bfa56304cacb87e5$export$6ae03b16e064e6c4);
$parcel$export(module.exports, "isIndexNode", () => $bfa56304cacb87e5$export$ff90979121a6cabc);
$parcel$export(module.exports, "isNode", () => $bfa56304cacb87e5$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isObjectNode", () => $bfa56304cacb87e5$export$3f18867a334658e9);
$parcel$export(module.exports, "isOperatorNode", () => $bfa56304cacb87e5$export$7e624cbaab6cce94);
$parcel$export(module.exports, "isParenthesisNode", () => $bfa56304cacb87e5$export$c55e3736c5721220);
$parcel$export(module.exports, "isRangeNode", () => $bfa56304cacb87e5$export$92729c5c4ff6fc83);
$parcel$export(module.exports, "isSymbolNode", () => $bfa56304cacb87e5$export$87815d550facaed9);
$parcel$export(module.exports, "isChain", () => $bfa56304cacb87e5$export$dc36953d0b3a4f05);
$parcel$export(module.exports, "typeOf", () => $bfa56304cacb87e5$export$f5bbd400c2f4426f);
// type checks for all known types
//
// note that:
//
// - check by duck-typing on a property like `isUnit`, instead of checking instanceof.
//   instanceof cannot be used because that would not allow to pass data from
//   one instance of math.js to another since each has it's own instance of Unit.
// - check the `isUnit` property via the constructor, so there will be no
//   matches for "fake" instances like plain objects with a property `isUnit`.
//   That is important for security reasons.
// - It must not be possible to override the type checks used internally,
//   for security reasons, so these functions are not exposed in the expression
//   parser.
function $bfa56304cacb87e5$export$7e4aa119212bc614(x) {
    return typeof x === 'number';
}
function $bfa56304cacb87e5$export$e51d0e7e5c4a03ab(x) {
    if (!x || typeof x !== 'object' || typeof x.constructor !== 'function') return false;
    if (x.isBigNumber === true && typeof x.constructor.prototype === 'object' && x.constructor.prototype.isBigNumber === true) return true;
    if (typeof x.constructor.isDecimal === 'function' && x.constructor.isDecimal(x) === true) return true;
    return false;
}
function $bfa56304cacb87e5$export$8849a896711efe0c(x) {
    return x && typeof x === 'object' && Object.getPrototypeOf(x).isComplex === true || false;
}
function $bfa56304cacb87e5$export$e312cb8a8e5e7c34(x) {
    return x && typeof x === 'object' && Object.getPrototypeOf(x).isFraction === true || false;
}
function $bfa56304cacb87e5$export$8960dc335987b8da(x) {
    return x && x.constructor.prototype.isUnit === true || false;
}
function $bfa56304cacb87e5$export$844ec244b1367d54(x) {
    return typeof x === 'string';
}
var $bfa56304cacb87e5$export$43bee75e5e14138e = Array.isArray;
function $bfa56304cacb87e5$export$b22160e0a14f87b7(x) {
    return x && x.constructor.prototype.isMatrix === true || false;
}
function $bfa56304cacb87e5$export$cea7aa84e978eba5(x) {
    return Array.isArray(x) || $bfa56304cacb87e5$export$b22160e0a14f87b7(x);
}
function $bfa56304cacb87e5$export$eb44495df7ba11d(x) {
    return x && x.isDenseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $bfa56304cacb87e5$export$d508368d4da3c38a(x) {
    return x && x.isSparseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $bfa56304cacb87e5$export$e331ccfa6f694c99(x) {
    return x && x.constructor.prototype.isRange === true || false;
}
function $bfa56304cacb87e5$export$ba3dc792055c2f45(x) {
    return x && x.constructor.prototype.isIndex === true || false;
}
function $bfa56304cacb87e5$export$f9ce7b637dfbe238(x) {
    return typeof x === 'boolean';
}
function $bfa56304cacb87e5$export$381a1a20e6a63376(x) {
    return x && x.constructor.prototype.isResultSet === true || false;
}
function $bfa56304cacb87e5$export$e5dec9a75b602d6c(x) {
    return x && x.constructor.prototype.isHelp === true || false;
}
function $bfa56304cacb87e5$export$f6e2535fb5126e54(x) {
    return typeof x === 'function';
}
function $bfa56304cacb87e5$export$871608497c498473(x) {
    return x instanceof Date;
}
function $bfa56304cacb87e5$export$49841c62b9eff15(x) {
    return x instanceof RegExp;
}
function $bfa56304cacb87e5$export$a6cdc56e425d0d0a(x) {
    return !!(x && typeof x === 'object' && x.constructor === Object && !$bfa56304cacb87e5$export$8849a896711efe0c(x) && !$bfa56304cacb87e5$export$e312cb8a8e5e7c34(x));
}
function $bfa56304cacb87e5$export$630801d484da15df(x) {
    return x === null;
}
function $bfa56304cacb87e5$export$fce6876652108ab(x) {
    return x === undefined;
}
function $bfa56304cacb87e5$export$f88fb19d6b9ee5cb(x) {
    return x && x.isAccessorNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$440fa93dcf2757a3(x) {
    return x && x.isArrayNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$64d7d515ec030d5e(x) {
    return x && x.isAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$1665e2275a3d717a(x) {
    return x && x.isBlockNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$e1babefe78c70737(x) {
    return x && x.isConditionalNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$fa9d80731fd8c54b(x) {
    return x && x.isConstantNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$27c05cfffd263d30(x) {
    return x && x.isFunctionAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$6ae03b16e064e6c4(x) {
    return x && x.isFunctionNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$ff90979121a6cabc(x) {
    return x && x.isIndexNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$8ee0fc9ee280b4ee(x) {
    return x && x.isNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$3f18867a334658e9(x) {
    return x && x.isObjectNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$7e624cbaab6cce94(x) {
    return x && x.isOperatorNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$c55e3736c5721220(x) {
    return x && x.isParenthesisNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$92729c5c4ff6fc83(x) {
    return x && x.isRangeNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$87815d550facaed9(x) {
    return x && x.isSymbolNode === true && x.constructor.prototype.isNode === true || false;
}
function $bfa56304cacb87e5$export$dc36953d0b3a4f05(x) {
    return x && x.constructor.prototype.isChain === true || false;
}
function $bfa56304cacb87e5$export$f5bbd400c2f4426f(x) {
    var t = typeof x;
    if (t === 'object') {
        // JavaScript types
        if (x === null) return 'null';
        if (Array.isArray(x)) return 'Array';
        if (x instanceof Date) return 'Date';
        if (x instanceof RegExp) return 'RegExp'; // math.js types
        if ($bfa56304cacb87e5$export$e51d0e7e5c4a03ab(x)) return 'BigNumber';
        if ($bfa56304cacb87e5$export$8849a896711efe0c(x)) return 'Complex';
        if ($bfa56304cacb87e5$export$e312cb8a8e5e7c34(x)) return 'Fraction';
        if ($bfa56304cacb87e5$export$b22160e0a14f87b7(x)) return 'Matrix';
        if ($bfa56304cacb87e5$export$8960dc335987b8da(x)) return 'Unit';
        if ($bfa56304cacb87e5$export$ba3dc792055c2f45(x)) return 'Index';
        if ($bfa56304cacb87e5$export$e331ccfa6f694c99(x)) return 'Range';
        if ($bfa56304cacb87e5$export$381a1a20e6a63376(x)) return 'ResultSet';
        if ($bfa56304cacb87e5$export$8ee0fc9ee280b4ee(x)) return x.type;
        if ($bfa56304cacb87e5$export$dc36953d0b3a4f05(x)) return 'Chain';
        if ($bfa56304cacb87e5$export$e5dec9a75b602d6c(x)) return 'Help';
        return 'Object';
    }
    if (t === 'function') return 'Function';
    return t; // can be 'string', 'number', 'boolean', ...
}

});




parcelRegister("kEdGs", function(module, exports) {

$parcel$export(module.exports, "createAbs", () => $f08228681ff9dba1$export$dd8a9b3843a4df95);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $eRNhQ = parcelRequire("eRNhQ");
var $f08228681ff9dba1$var$name = 'abs';
var $f08228681ff9dba1$var$dependencies = [
    'typed'
];
var $f08228681ff9dba1$export$dd8a9b3843a4df95 = /* #__PURE__ */ (0, $4eE2e.factory)($f08228681ff9dba1$var$name, $f08228681ff9dba1$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the absolute value of a number. For matrices, the function is
   * evaluated element wise.
   *
   * Syntax:
   *
   *    math.abs(x)
   *
   * Examples:
   *
   *    math.abs(3.5)                // returns number 3.5
   *    math.abs(-4.2)               // returns number 4.2
   *
   *    math.abs([3, -5, -1, 0, 2])  // returns Array [3, 5, 1, 0, 2]
   *
   * See also:
   *
   *    sign
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            A number or matrix for which to get the absolute value
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
   *            Absolute value of `x`
   */ return typed($f08228681ff9dba1$var$name, {
        number: (0, $eRNhQ.absNumber),
        Complex: function Complex(x) {
            return x.abs();
        },
        BigNumber: function BigNumber(x) {
            return x.abs();
        },
        Fraction: function Fraction(x) {
            return x.abs();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since abs(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        },
        Unit: function Unit(x) {
            return x.abs();
        }
    });
});

});
parcelRegister("4eE2e", function(module, exports) {

$parcel$export(module.exports, "factory", () => $3157865a0721d8a0$export$e9008f2713103c6c);

var $10UPF = parcelRequire("10UPF");

var $4mYv9 = parcelRequire("4mYv9");
function $3157865a0721d8a0$export$e9008f2713103c6c(name, dependencies, create, meta) {
    function assertAndCreate(scope) {
        // we only pass the requested dependencies to the factory function
        // to prevent functions to rely on dependencies that are not explicitly
        // requested.
        var deps = (0, $4mYv9.pickShallow)(scope, dependencies.map($3157865a0721d8a0$export$2f4d32a1468e229c));
        $3157865a0721d8a0$export$19a2c26dad95d6e7(name, dependencies, scope);
        return create(deps);
    }
    assertAndCreate.isFactory = true;
    assertAndCreate.fn = name;
    assertAndCreate.dependencies = dependencies.slice().sort();
    if (meta) assertAndCreate.meta = meta;
    return assertAndCreate;
}
function $3157865a0721d8a0$export$883f1d394ed355c(factories) {
    var factoriesByName = {};
    factories.forEach((factory)=>{
        factoriesByName[factory.fn] = factory;
    });
    function containsDependency(factory, dependency) {
        // TODO: detect circular references
        if ($3157865a0721d8a0$export$34763cfbed1075c2(factory)) {
            if ((0, $10UPF.contains)(factory.dependencies, dependency.fn || dependency.name)) return true;
            if (factory.dependencies.some((d)=>containsDependency(factoriesByName[d], dependency))) return true;
        }
        return false;
    }
    var sorted = [];
    function addFactory(factory) {
        var index = 0;
        while(index < sorted.length && !containsDependency(sorted[index], factory))index++;
        sorted.splice(index, 0, factory);
    } // sort regular factory functions
    factories.filter($3157865a0721d8a0$export$34763cfbed1075c2).forEach(addFactory); // sort legacy factory functions AFTER the regular factory functions
    factories.filter((factory)=>!$3157865a0721d8a0$export$34763cfbed1075c2(factory)).forEach(addFactory);
    return sorted;
} // TODO: comment or cleanup if unused in the end
function $3157865a0721d8a0$export$185802fd694ee1f5(factories) {
    var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $3157865a0721d8a0$export$883f1d394ed355c(factories).forEach((factory)=>factory(scope));
    return scope;
}
function $3157865a0721d8a0$export$34763cfbed1075c2(obj) {
    return typeof obj === 'function' && typeof obj.fn === 'string' && Array.isArray(obj.dependencies);
}
function $3157865a0721d8a0$export$19a2c26dad95d6e7(name, dependencies, scope) {
    var allDefined = dependencies.filter((dependency)=>!$3157865a0721d8a0$export$1399ac7f45b04b5(dependency)) // filter optionals
    .every((dependency)=>scope[dependency] !== undefined);
    if (!allDefined) {
        var missingDependencies = dependencies.filter((dependency)=>scope[dependency] === undefined); // TODO: create a custom error class for this, a MathjsError or something like that
        throw new Error("Cannot create function \"".concat(name, "\", ") + "some dependencies are missing: ".concat(missingDependencies.map((d)=>"\"".concat(d, "\"")).join(', '), "."));
    }
}
function $3157865a0721d8a0$export$1399ac7f45b04b5(dependency) {
    return dependency && dependency[0] === '?';
}
function $3157865a0721d8a0$export$2f4d32a1468e229c(dependency) {
    return dependency && dependency[0] === '?' ? dependency.slice(1) : dependency;
}

});
parcelRegister("10UPF", function(module, exports) {

$parcel$export(module.exports, "arraySize", () => $0bd1e04303100c96$export$51ffaee4afb683a5);
$parcel$export(module.exports, "validate", () => $0bd1e04303100c96$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "validateIndex", () => $0bd1e04303100c96$export$3cfe3fbfec03f260);
$parcel$export(module.exports, "resize", () => $0bd1e04303100c96$export$4380c87abf28fdf);
$parcel$export(module.exports, "reshape", () => $0bd1e04303100c96$export$9eaad88cf88cee2b);
$parcel$export(module.exports, "flatten", () => $0bd1e04303100c96$export$bffa455ba8c619a6);
$parcel$export(module.exports, "processSizesWildcard", () => $0bd1e04303100c96$export$d0efc868ac2c6822);
$parcel$export(module.exports, "squeeze", () => $0bd1e04303100c96$export$889c931173b77c2f);
$parcel$export(module.exports, "unsqueeze", () => $0bd1e04303100c96$export$5a07c5202d40a604);
$parcel$export(module.exports, "forEach", () => $0bd1e04303100c96$export$4b80e395e36b5a56);
$parcel$export(module.exports, "filter", () => $0bd1e04303100c96$export$3dea766d36a8935f);
$parcel$export(module.exports, "filterRegExp", () => $0bd1e04303100c96$export$322859471e81229d);
$parcel$export(module.exports, "identify", () => $0bd1e04303100c96$export$65e5b62a4c490288);
$parcel$export(module.exports, "generalize", () => $0bd1e04303100c96$export$d57ad8b840ad6a01);
$parcel$export(module.exports, "getArrayDataType", () => $0bd1e04303100c96$export$d31e00bf4359ea8b);
$parcel$export(module.exports, "contains", () => $0bd1e04303100c96$export$2344b14b097df817);

var $6egKm = parcelRequire("6egKm");

var $gs7TF = parcelRequire("gs7TF");

var $aEppI = parcelRequire("aEppI");

var $iAoVB = parcelRequire("iAoVB");

var $9juUc = parcelRequire("9juUc");
function $0bd1e04303100c96$export$51ffaee4afb683a5(x) {
    var s = [];
    while(Array.isArray(x)){
        s.push(x.length);
        x = x[0];
    }
    return s;
}
/**
 * Recursively validate whether each element in a multi dimensional array
 * has a size corresponding to the provided size array.
 * @param {Array} array    Array to be validated
 * @param {number[]} size  Array with the size of each dimension
 * @param {number} dim   Current dimension
 * @throws DimensionError
 * @private
 */ function $0bd1e04303100c96$var$_validate(array, size, dim) {
    var i;
    var len = array.length;
    if (len !== size[dim]) throw new (0, $iAoVB.DimensionError)(len, size[dim]);
    if (dim < size.length - 1) {
        // recursively validate each child array
        var dimNext = dim + 1;
        for(i = 0; i < len; i++){
            var child = array[i];
            if (!Array.isArray(child)) throw new (0, $iAoVB.DimensionError)(size.length - 1, size.length, '<');
            $0bd1e04303100c96$var$_validate(array[i], size, dimNext);
        }
    } else // last dimension. none of the childs may be an array
    for(i = 0; i < len; i++){
        if (Array.isArray(array[i])) throw new (0, $iAoVB.DimensionError)(size.length + 1, size.length, '>');
    }
}
function $0bd1e04303100c96$export$a22775fa5e2eebd9(array, size) {
    var isScalar = size.length === 0;
    if (isScalar) {
        // scalar
        if (Array.isArray(array)) throw new (0, $iAoVB.DimensionError)(array.length, 0);
    } else // array
    $0bd1e04303100c96$var$_validate(array, size, 0);
}
function $0bd1e04303100c96$export$3cfe3fbfec03f260(index, length) {
    if (!(0, $gs7TF.isNumber)(index) || !(0, $6egKm.isInteger)(index)) throw new TypeError('Index must be an integer (value: ' + index + ')');
    if (index < 0 || typeof length === 'number' && index >= length) throw new (0, $9juUc.IndexError)(index, length);
}
function $0bd1e04303100c96$export$4380c87abf28fdf(array, size, defaultValue) {
    // TODO: add support for scalars, having size=[] ?
    // check the type of the arguments
    if (!Array.isArray(array) || !Array.isArray(size)) throw new TypeError('Array expected');
    if (size.length === 0) throw new Error('Resizing to scalar is not supported');
     // check whether size contains positive integers
    size.forEach(function(value) {
        if (!(0, $gs7TF.isNumber)(value) || !(0, $6egKm.isInteger)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $aEppI.format)(size) + ')');
    }); // recursively resize the array
    var _defaultValue = defaultValue !== undefined ? defaultValue : 0;
    $0bd1e04303100c96$var$_resize(array, size, 0, _defaultValue);
    return array;
}
/**
 * Recursively resize a multi dimensional array
 * @param {Array} array         Array to be resized
 * @param {number[]} size       Array with the size of each dimension
 * @param {number} dim          Current dimension
 * @param {*} [defaultValue]    Value to be filled in in new entries,
 *                              undefined by default.
 * @private
 */ function $0bd1e04303100c96$var$_resize(array, size, dim, defaultValue) {
    var i;
    var elem;
    var oldLen = array.length;
    var newLen = size[dim];
    var minLen = Math.min(oldLen, newLen); // apply new length
    array.length = newLen;
    if (dim < size.length - 1) {
        // non-last dimension
        var dimNext = dim + 1; // resize existing child arrays
        for(i = 0; i < minLen; i++){
            // resize child array
            elem = array[i];
            if (!Array.isArray(elem)) {
                elem = [
                    elem
                ]; // add a dimension
                array[i] = elem;
            }
            $0bd1e04303100c96$var$_resize(elem, size, dimNext, defaultValue);
        } // create new child arrays
        for(i = minLen; i < newLen; i++){
            // get child array
            elem = [];
            array[i] = elem; // resize new child array
            $0bd1e04303100c96$var$_resize(elem, size, dimNext, defaultValue);
        }
    } else {
        // last dimension
        // remove dimensions of existing values
        for(i = 0; i < minLen; i++)while(Array.isArray(array[i]))array[i] = array[i][0];
         // fill new elements with the default value
        for(i = minLen; i < newLen; i++)array[i] = defaultValue;
    }
}
function $0bd1e04303100c96$export$9eaad88cf88cee2b(array, sizes) {
    var flatArray = $0bd1e04303100c96$export$bffa455ba8c619a6(array);
    var currentLength = flatArray.length;
    if (!Array.isArray(array) || !Array.isArray(sizes)) throw new TypeError('Array expected');
    if (sizes.length === 0) throw new (0, $iAoVB.DimensionError)(0, currentLength, '!=');
    sizes = $0bd1e04303100c96$export$d0efc868ac2c6822(sizes, currentLength);
    var newLength = $0bd1e04303100c96$var$product(sizes);
    if (currentLength !== newLength) throw new (0, $iAoVB.DimensionError)(newLength, currentLength, '!=');
    try {
        return $0bd1e04303100c96$var$_reshape(flatArray, sizes);
    } catch (e) {
        if (e instanceof (0, $iAoVB.DimensionError)) throw new (0, $iAoVB.DimensionError)(newLength, currentLength, '!=');
        throw e;
    }
}
function $0bd1e04303100c96$export$d0efc868ac2c6822(sizes, currentLength) {
    var newLength = $0bd1e04303100c96$var$product(sizes);
    var processedSizes = sizes.slice();
    var WILDCARD = -1;
    var wildCardIndex = sizes.indexOf(WILDCARD);
    var isMoreThanOneWildcard = sizes.indexOf(WILDCARD, wildCardIndex + 1) >= 0;
    if (isMoreThanOneWildcard) throw new Error('More than one wildcard in sizes');
    var hasWildcard = wildCardIndex >= 0;
    var canReplaceWildcard = currentLength % newLength === 0;
    if (hasWildcard) {
        if (canReplaceWildcard) processedSizes[wildCardIndex] = -currentLength / newLength;
        else throw new Error('Could not replace wildcard, since ' + currentLength + ' is no multiple of ' + -newLength);
    }
    return processedSizes;
}
/**
 * Computes the product of all array elements.
 * @param {Array<number>} array Array of factors
 * @returns {number}            Product of all elements
 */ function $0bd1e04303100c96$var$product(array) {
    return array.reduce((prev, curr)=>prev * curr, 1);
}
/**
 * Iteratively re-shape a multi dimensional array to fit the specified dimensions
 * @param {Array} array           Array to be reshaped
 * @param {Array.<number>} sizes  List of sizes for each dimension
 * @returns {Array}               Array whose data has been formatted to fit the
 *                                specified dimensions
 */ function $0bd1e04303100c96$var$_reshape(array, sizes) {
    // testing if there are enough elements for the requested shape
    var tmpArray = array;
    var tmpArray2; // for each dimensions starting by the last one and ignoring the first one
    for(var sizeIndex = sizes.length - 1; sizeIndex > 0; sizeIndex--){
        var size = sizes[sizeIndex];
        tmpArray2 = []; // aggregate the elements of the current tmpArray in elements of the requested size
        var length = tmpArray.length / size;
        for(var i = 0; i < length; i++)tmpArray2.push(tmpArray.slice(i * size, (i + 1) * size));
         // set it as the new tmpArray for the next loop turn or for return
        tmpArray = tmpArray2;
    }
    return tmpArray;
}
function $0bd1e04303100c96$export$889c931173b77c2f(array, size) {
    var s = size || $0bd1e04303100c96$export$51ffaee4afb683a5(array); // squeeze outer dimensions
    while(Array.isArray(array) && array.length === 1){
        array = array[0];
        s.shift();
    } // find the first dimension to be squeezed
    var dims = s.length;
    while(s[dims - 1] === 1)dims--;
     // squeeze inner dimensions
    if (dims < s.length) {
        array = $0bd1e04303100c96$var$_squeeze(array, dims, 0);
        s.length = dims;
    }
    return array;
}
/**
 * Recursively squeeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $0bd1e04303100c96$var$_squeeze(array, dims, dim) {
    var i, ii;
    if (dim < dims) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $0bd1e04303100c96$var$_squeeze(array[i], dims, next);
    } else while(Array.isArray(array))array = array[0];
    return array;
}
function $0bd1e04303100c96$export$5a07c5202d40a604(array, dims, outer, size) {
    var s = size || $0bd1e04303100c96$export$51ffaee4afb683a5(array); // unsqueeze outer dimensions
    if (outer) for(var i = 0; i < outer; i++){
        array = [
            array
        ];
        s.unshift(1);
    }
     // unsqueeze inner dimensions
    array = $0bd1e04303100c96$var$_unsqueeze(array, dims, 0);
    while(s.length < dims)s.push(1);
    return array;
}
/**
 * Recursively unsqueeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $0bd1e04303100c96$var$_unsqueeze(array, dims, dim) {
    var i, ii;
    if (Array.isArray(array)) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $0bd1e04303100c96$var$_unsqueeze(array[i], dims, next);
    } else for(var d = dim; d < dims; d++)array = [
        array
    ];
    return array;
}
function $0bd1e04303100c96$export$bffa455ba8c619a6(array) {
    if (!Array.isArray(array)) // if not an array, return as is
    return array;
    var flat = [];
    array.forEach(function callback(value) {
        if (Array.isArray(value)) value.forEach(callback); // traverse through sub-arrays recursively
        else flat.push(value);
    });
    return flat;
}
function $0bd1e04303100c96$export$871de8747c9eaa88(array, callback) {
    return Array.prototype.map.call(array, callback);
}
function $0bd1e04303100c96$export$4b80e395e36b5a56(array, callback) {
    Array.prototype.forEach.call(array, callback);
}
function $0bd1e04303100c96$export$3dea766d36a8935f(array, callback) {
    if ($0bd1e04303100c96$export$51ffaee4afb683a5(array).length !== 1) throw new Error('Only one dimensional matrices supported');
    return Array.prototype.filter.call(array, callback);
}
function $0bd1e04303100c96$export$322859471e81229d(array, regexp) {
    if ($0bd1e04303100c96$export$51ffaee4afb683a5(array).length !== 1) throw new Error('Only one dimensional matrices supported');
    return Array.prototype.filter.call(array, (entry)=>regexp.test(entry));
}
function $0bd1e04303100c96$export$f7e2c8231c57a8bd(array, separator) {
    return Array.prototype.join.call(array, separator);
}
function $0bd1e04303100c96$export$65e5b62a4c490288(a) {
    if (!Array.isArray(a)) throw new TypeError('Array input expected');
    if (a.length === 0) return a;
    var b = [];
    var count = 0;
    b[0] = {
        value: a[0],
        identifier: 0
    };
    for(var i = 1; i < a.length; i++){
        if (a[i] === a[i - 1]) count++;
        else count = 0;
        b.push({
            value: a[i],
            identifier: count
        });
    }
    return b;
}
function $0bd1e04303100c96$export$d57ad8b840ad6a01(a) {
    if (!Array.isArray(a)) throw new TypeError('Array input expected');
    if (a.length === 0) return a;
    var b = [];
    for(var i = 0; i < a.length; i++)b.push(a[i].value);
    return b;
}
function $0bd1e04303100c96$export$d31e00bf4359ea8b(array, typeOf) {
    var type; // to hold type info
    var length = 0; // to hold length value to ensure it has consistent sizes
    for(var i = 0; i < array.length; i++){
        var item = array[i];
        var isArray = Array.isArray(item); // Saving the target matrix row size
        if (i === 0 && isArray) length = item.length;
         // If the current item is an array but the length does not equal the targetVectorSize
        if (isArray && item.length !== length) return undefined;
        var itemType = isArray ? $0bd1e04303100c96$export$d31e00bf4359ea8b(item, typeOf) // recurse into a nested array
         : typeOf(item);
        if (type === undefined) type = itemType; // first item
        else if (type !== itemType) return 'mixed';
    }
    return type;
}
function $0bd1e04303100c96$export$4c7897fafd92b108(array) {
    return array[array.length - 1];
}
function $0bd1e04303100c96$export$59ff82fc918bd7e3(array) {
    return array.slice(0, array.length - 1);
}
function $0bd1e04303100c96$export$2344b14b097df817(array, item) {
    return array.indexOf(item) !== -1;
}

});
parcelRegister("6egKm", function(module, exports) {

$parcel$export(module.exports, "isInteger", () => $48910a75fd8d56ca$export$a287f47fed4544b8);
$parcel$export(module.exports, "sign", () => $48910a75fd8d56ca$export$c5552dfdbc7cec71);
$parcel$export(module.exports, "log2", () => $48910a75fd8d56ca$export$b9fae0bba9d9094d);
$parcel$export(module.exports, "log10", () => $48910a75fd8d56ca$export$75e08744a3ff8516);
$parcel$export(module.exports, "log1p", () => $48910a75fd8d56ca$export$144dcf16adfb9698);
$parcel$export(module.exports, "cbrt", () => $48910a75fd8d56ca$export$841fc4d5a1480b85);
$parcel$export(module.exports, "expm1", () => $48910a75fd8d56ca$export$b6c0a80d46d3391d);
$parcel$export(module.exports, "format", () => $48910a75fd8d56ca$export$d9468344d3651243);
$parcel$export(module.exports, "toFixed", () => $48910a75fd8d56ca$export$a81f732198733497);
$parcel$export(module.exports, "digits", () => $48910a75fd8d56ca$export$9c0987062f8f5d89);
$parcel$export(module.exports, "nearlyEqual", () => $48910a75fd8d56ca$export$6f3989c6ecc04081);
$parcel$export(module.exports, "acosh", () => $48910a75fd8d56ca$export$b26caf0f29211d08);
$parcel$export(module.exports, "asinh", () => $48910a75fd8d56ca$export$839d8a01b6af4fc0);
$parcel$export(module.exports, "atanh", () => $48910a75fd8d56ca$export$21ea955025ceb08b);
$parcel$export(module.exports, "cosh", () => $48910a75fd8d56ca$export$2e2fd1ad24e4d350);
$parcel$export(module.exports, "sinh", () => $48910a75fd8d56ca$export$545004b505d7c555);
$parcel$export(module.exports, "tanh", () => $48910a75fd8d56ca$export$7128670e45beef9a);

var $gs7TF = parcelRequire("gs7TF");
function $48910a75fd8d56ca$export$a287f47fed4544b8(value) {
    if (typeof value === 'boolean') return true;
    return isFinite(value) ? value === Math.round(value) : false;
}
var $48910a75fd8d56ca$export$c5552dfdbc7cec71 = /* #__PURE__ */ Math.sign || function(x) {
    if (x > 0) return 1;
    else if (x < 0) return -1;
    else return 0;
};
var $48910a75fd8d56ca$export$b9fae0bba9d9094d = /* #__PURE__ */ Math.log2 || function log2(x) {
    return Math.log(x) / Math.LN2;
};
var $48910a75fd8d56ca$export$75e08744a3ff8516 = /* #__PURE__ */ Math.log10 || function log10(x) {
    return Math.log(x) / Math.LN10;
};
var $48910a75fd8d56ca$export$144dcf16adfb9698 = /* #__PURE__ */ Math.log1p || function(x) {
    return Math.log(x + 1);
};
var $48910a75fd8d56ca$export$841fc4d5a1480b85 = /* #__PURE__ */ Math.cbrt || function cbrt(x) {
    if (x === 0) return x;
    var negate = x < 0;
    var result;
    if (negate) x = -x;
    if (isFinite(x)) {
        result = Math.exp(Math.log(x) / 3); // from https://en.wikipedia.org/wiki/Cube_root#Numerical_methods
        result = (x / (result * result) + 2 * result) / 3;
    } else result = x;
    return negate ? -result : result;
};
var $48910a75fd8d56ca$export$b6c0a80d46d3391d = /* #__PURE__ */ Math.expm1 || function expm1(x) {
    return x >= 2e-4 || x <= -0.0002 ? Math.exp(x) - 1 : x + x * x / 2 + x * x * x / 6;
};
/**
 * Formats a number in a given base
 * @param {number} n
 * @param {number} base
 * @param {number} size
 * @returns {string}
 */ function $48910a75fd8d56ca$var$formatNumberToBase(n, base, size) {
    var prefixes = {
        2: '0b',
        8: '0o',
        16: '0x'
    };
    var prefix = prefixes[base];
    var suffix = '';
    if (size) {
        if (size < 1) throw new Error('size must be in greater than 0');
        if (!$48910a75fd8d56ca$export$a287f47fed4544b8(size)) throw new Error('size must be an integer');
        if (n > 2 ** (size - 1) - 1 || n < -(2 ** (size - 1))) throw new Error("Value must be in range [-2^".concat(size - 1, ", 2^").concat(size - 1, "-1]"));
        if (!$48910a75fd8d56ca$export$a287f47fed4544b8(n)) throw new Error('Value must be an integer');
        if (n < 0) n = n + 2 ** size;
        suffix = "i".concat(size);
    }
    var sign = '';
    if (n < 0) {
        n = -n;
        sign = '-';
    }
    return "".concat(sign).concat(prefix).concat(n.toString(base)).concat(suffix);
}
function $48910a75fd8d56ca$export$d9468344d3651243(value, options) {
    if (typeof options === 'function') // handle format(value, fn)
    return options(value);
     // handle special cases
    if (value === Infinity) return 'Infinity';
    else if (value === -Infinity) return '-Infinity';
    else if (isNaN(value)) return 'NaN';
     // default values for options
    var notation = 'auto';
    var precision;
    var wordSize;
    if (options) {
        // determine notation from options
        if (options.notation) notation = options.notation;
         // determine precision from options
        if ((0, $gs7TF.isNumber)(options)) precision = options;
        else if ((0, $gs7TF.isNumber)(options.precision)) precision = options.precision;
        if (options.wordSize) {
            wordSize = options.wordSize;
            if (typeof wordSize !== 'number') throw new Error('Option "wordSize" must be a number');
        }
    } // handle the various notations
    switch(notation){
        case 'fixed':
            return $48910a75fd8d56ca$export$a81f732198733497(value, precision);
        case 'exponential':
            return $48910a75fd8d56ca$export$888cb08ddc4765be(value, precision);
        case 'engineering':
            return $48910a75fd8d56ca$export$9299fe684ed0ee48(value, precision);
        case 'bin':
            return $48910a75fd8d56ca$var$formatNumberToBase(value, 2, wordSize);
        case 'oct':
            return $48910a75fd8d56ca$var$formatNumberToBase(value, 8, wordSize);
        case 'hex':
            return $48910a75fd8d56ca$var$formatNumberToBase(value, 16, wordSize);
        case 'auto':
            // remove trailing zeros after the decimal point
            return $48910a75fd8d56ca$export$3e91a10e66078270(value, precision, options && options).replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== '.' ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
    }
}
function $48910a75fd8d56ca$export$feb80e120a50087f(value) {
    // parse the input value
    var match = String(value).toLowerCase().match(/^0*?(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
    if (!match) throw new SyntaxError('Invalid number ' + value);
    var sign = match[1];
    var digits = match[2];
    var exponent = parseFloat(match[4] || '0');
    var dot = digits.indexOf('.');
    exponent += dot !== -1 ? dot - 1 : digits.length - 1;
    var coefficients = digits.replace('.', '') // remove the dot (must be removed before removing leading zeros)
    .replace(/^0*/, function(zeros) {
        // remove leading zeros, add their count to the exponent
        exponent -= zeros.length;
        return '';
    }).replace(/0*$/, '') // remove trailing zeros
    .split('').map(function(d) {
        return parseInt(d);
    });
    if (coefficients.length === 0) {
        coefficients.push(0);
        exponent++;
    }
    return {
        sign: sign,
        coefficients: coefficients,
        exponent: exponent
    };
}
function $48910a75fd8d56ca$export$9299fe684ed0ee48(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var split = $48910a75fd8d56ca$export$feb80e120a50087f(value);
    var rounded = $48910a75fd8d56ca$export$e5b32ced877afc7e(split, precision);
    var e = rounded.exponent;
    var c = rounded.coefficients; // find nearest lower multiple of 3 for exponent
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3;
    if ((0, $gs7TF.isNumber)(precision)) // add zeroes to give correct sig figs
    while(precision > c.length || e - newExp + 1 > c.length)c.push(0);
    else {
        // concatenate coefficients with necessary zeros
        // add zeros if necessary (for example: 1e+8 -> 100e+6)
        var missingZeros = Math.abs(e - newExp) - (c.length - 1);
        for(var i = 0; i < missingZeros; i++)c.push(0);
    } // find difference in exponents
    var expDiff = Math.abs(e - newExp);
    var decimalIdx = 1; // push decimal index over by expDiff times
    while(expDiff > 0){
        decimalIdx++;
        expDiff--;
    } // if all coefficient values are zero after the decimal point and precision is unset, don't add a decimal value.
    // otherwise concat with the rest of the coefficients
    var decimals = c.slice(decimalIdx).join('');
    var decimalVal = (0, $gs7TF.isNumber)(precision) && decimals.length || decimals.match(/[1-9]/) ? '.' + decimals : '';
    var str = c.slice(0, decimalIdx).join('') + decimalVal + 'e' + (e >= 0 ? '+' : '') + newExp.toString();
    return rounded.sign + str;
}
function $48910a75fd8d56ca$export$a81f732198733497(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var splitValue = $48910a75fd8d56ca$export$feb80e120a50087f(value);
    var rounded = typeof precision === 'number' ? $48910a75fd8d56ca$export$e5b32ced877afc7e(splitValue, splitValue.exponent + 1 + precision) : splitValue;
    var c = rounded.coefficients;
    var p = rounded.exponent + 1; // exponent may have changed
    // append zeros if needed
    var pp = p + (precision || 0);
    if (c.length < pp) c = c.concat($48910a75fd8d56ca$var$zeros(pp - c.length));
     // prepend zeros if needed
    if (p < 0) {
        c = $48910a75fd8d56ca$var$zeros(-p + 1).concat(c);
        p = 1;
    } // insert a dot if needed
    if (p < c.length) c.splice(p, 0, p === 0 ? '0.' : '.');
    return rounded.sign + c.join('');
}
function $48910a75fd8d56ca$export$888cb08ddc4765be(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
     // round if needed, else create a clone
    var split = $48910a75fd8d56ca$export$feb80e120a50087f(value);
    var rounded = precision ? $48910a75fd8d56ca$export$e5b32ced877afc7e(split, precision) : split;
    var c = rounded.coefficients;
    var e = rounded.exponent; // append zeros if needed
    if (c.length < precision) c = c.concat($48910a75fd8d56ca$var$zeros(precision - c.length));
     // format as `C.CCCe+EEE` or `C.CCCe-EEE`
    var first = c.shift();
    return rounded.sign + first + (c.length > 0 ? '.' + c.join('') : '') + 'e' + (e >= 0 ? '+' : '') + e;
}
function $48910a75fd8d56ca$export$3e91a10e66078270(value, precision, options) {
    if (isNaN(value) || !isFinite(value)) return String(value);
     // determine lower and upper bound for exponential notation.
    var lowerExp = options && options.lowerExp !== undefined ? options.lowerExp : -3;
    var upperExp = options && options.upperExp !== undefined ? options.upperExp : 5;
    var split = $48910a75fd8d56ca$export$feb80e120a50087f(value);
    var rounded = precision ? $48910a75fd8d56ca$export$e5b32ced877afc7e(split, precision) : split;
    if (rounded.exponent < lowerExp || rounded.exponent >= upperExp) // exponential notation
    return $48910a75fd8d56ca$export$888cb08ddc4765be(value, precision);
    else {
        var c = rounded.coefficients;
        var e = rounded.exponent; // append trailing zeros
        if (c.length < precision) c = c.concat($48910a75fd8d56ca$var$zeros(precision - c.length));
         // append trailing zeros
        // TODO: simplify the next statement
        c = c.concat($48910a75fd8d56ca$var$zeros(e - c.length + 1 + (c.length < precision ? precision - c.length : 0))); // prepend zeros
        c = $48910a75fd8d56ca$var$zeros(-e).concat(c);
        var dot = e > 0 ? e : 0;
        if (dot < c.length - 1) c.splice(dot + 1, 0, '.');
        return rounded.sign + c.join('');
    }
}
function $48910a75fd8d56ca$export$e5b32ced877afc7e(split, precision) {
    // create a clone
    var rounded = {
        sign: split.sign,
        coefficients: split.coefficients,
        exponent: split.exponent
    };
    var c = rounded.coefficients; // prepend zeros if needed
    while(precision <= 0){
        c.unshift(0);
        rounded.exponent++;
        precision++;
    }
    if (c.length > precision) {
        var removed = c.splice(precision, c.length - precision);
        if (removed[0] >= 5) {
            var i = precision - 1;
            c[i]++;
            while(c[i] === 10){
                c.pop();
                if (i === 0) {
                    c.unshift(0);
                    rounded.exponent++;
                    i++;
                }
                i--;
                c[i]++;
            }
        }
    }
    return rounded;
}
/**
 * Create an array filled with zeros.
 * @param {number} length
 * @return {Array}
 */ function $48910a75fd8d56ca$var$zeros(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push(0);
    return arr;
}
function $48910a75fd8d56ca$export$9c0987062f8f5d89(value) {
    return value.toExponential().replace(/e.*$/, '') // remove exponential notation
    .replace(/^0\.?0*|\./, '') // remove decimal point and leading zeros
    .length;
}
var $48910a75fd8d56ca$export$41b54fa1db30dbb5 = Number.EPSILON || 2.2204460492503130808472633361816E-16;
function $48910a75fd8d56ca$export$6f3989c6ecc04081(x, y, epsilon) {
    // if epsilon is null or undefined, test whether x and y are exactly equal
    if (epsilon === null || epsilon === undefined) return x === y;
    if (x === y) return true;
     // NaN
    if (isNaN(x) || isNaN(y)) return false;
     // at this point x and y should be finite
    if (isFinite(x) && isFinite(y)) {
        // check numbers are very close, needed when comparing numbers near zero
        var diff = Math.abs(x - y);
        if (diff < $48910a75fd8d56ca$export$41b54fa1db30dbb5) return true;
        else // use relative error
        return diff <= Math.max(Math.abs(x), Math.abs(y)) * epsilon;
    } // Infinite and Number or negative Infinite and positive Infinite cases
    return false;
}
var $48910a75fd8d56ca$export$b26caf0f29211d08 = Math.acosh || function(x) {
    return Math.log(Math.sqrt(x * x - 1) + x);
};
var $48910a75fd8d56ca$export$839d8a01b6af4fc0 = Math.asinh || function(x) {
    return Math.log(Math.sqrt(x * x + 1) + x);
};
var $48910a75fd8d56ca$export$21ea955025ceb08b = Math.atanh || function(x) {
    return Math.log((1 + x) / (1 - x)) / 2;
};
var $48910a75fd8d56ca$export$2e2fd1ad24e4d350 = Math.cosh || function(x) {
    return (Math.exp(x) + Math.exp(-x)) / 2;
};
var $48910a75fd8d56ca$export$545004b505d7c555 = Math.sinh || function(x) {
    return (Math.exp(x) - Math.exp(-x)) / 2;
};
var $48910a75fd8d56ca$export$7128670e45beef9a = Math.tanh || function(x) {
    var e = Math.exp(2 * x);
    return (e - 1) / (e + 1);
};

});

parcelRegister("aEppI", function(module, exports) {

$parcel$export(module.exports, "endsWith", () => $7c115a7a746b1417$export$10fdab3683b55b22);
$parcel$export(module.exports, "format", () => $7c115a7a746b1417$export$d9468344d3651243);
$parcel$export(module.exports, "compareText", () => $7c115a7a746b1417$export$2da9287da10b19e2);

var $gs7TF = parcelRequire("gs7TF");

var $6egKm = parcelRequire("6egKm");

var $ddoIR = parcelRequire("ddoIR");
function $7c115a7a746b1417$export$10fdab3683b55b22(text, search) {
    var start = text.length - search.length;
    var end = text.length;
    return text.substring(start, end) === search;
}
function $7c115a7a746b1417$export$d9468344d3651243(value, options) {
    if (typeof value === 'number') return (0, $6egKm.format)(value, options);
    if ((0, $gs7TF.isBigNumber)(value)) return (0, $ddoIR.format)(value, options);
     // note: we use unsafe duck-typing here to check for Fractions, this is
    // ok here since we're only invoking toString or concatenating its values
    if ($7c115a7a746b1417$var$looksLikeFraction(value)) {
        if (!options || options.fraction !== 'decimal') // output as ratio, like '1/3'
        return value.s * value.n + '/' + value.d;
        else // output as decimal, like '0.(3)'
        return value.toString();
    }
    if (Array.isArray(value)) return $7c115a7a746b1417$var$formatArray(value, options);
    if ((0, $gs7TF.isString)(value)) return '"' + value + '"';
    if (typeof value === 'function') return value.syntax ? String(value.syntax) : 'function';
    if (value && typeof value === 'object') {
        if (typeof value.format === 'function') return value.format(options);
        else if (value && value.toString(options) !== ({}).toString()) // this object has a non-native toString method, use that one
        return value.toString(options);
        else {
            var entries = Object.keys(value).map((key)=>{
                return '"' + key + '": ' + $7c115a7a746b1417$export$d9468344d3651243(value[key], options);
            });
            return '{' + entries.join(', ') + '}';
        }
    }
    return String(value);
}
function $7c115a7a746b1417$export$fac44ee5b035f737(value) {
    var text = String(value);
    var escaped = '';
    var i = 0;
    while(i < text.length){
        var c = text.charAt(i);
        if (c === '\\') {
            escaped += c;
            i++;
            c = text.charAt(i);
            if (c === '' || '"\\/bfnrtu'.indexOf(c) === -1) escaped += '\\'; // no valid escape character -> escape it
            escaped += c;
        } else if (c === '"') escaped += '\\"';
        else escaped += c;
        i++;
    }
    return '"' + escaped + '"';
}
function $7c115a7a746b1417$export$4e7f196112fea3c5(value) {
    var text = String(value);
    text = text.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return text;
}
/**
 * Recursively format an n-dimensional matrix
 * Example output: "[[1, 2], [3, 4]]"
 * @param {Array} array
 * @param {Object | number | Function} [options]  Formatting options. See
 *                                                lib/utils/number:format for a
 *                                                description of the available
 *                                                options.
 * @returns {string} str
 */ function $7c115a7a746b1417$var$formatArray(array, options) {
    if (Array.isArray(array)) {
        var str = '[';
        var len = array.length;
        for(var i = 0; i < len; i++){
            if (i !== 0) str += ', ';
            str += $7c115a7a746b1417$var$formatArray(array[i], options);
        }
        str += ']';
        return str;
    } else return $7c115a7a746b1417$export$d9468344d3651243(array, options);
}
/**
 * Check whether a value looks like a Fraction (unsafe duck-type check)
 * @param {*} value
 * @return {boolean}
 */ function $7c115a7a746b1417$var$looksLikeFraction(value) {
    return value && typeof value === 'object' && typeof value.s === 'number' && typeof value.n === 'number' && typeof value.d === 'number' || false;
}
function $7c115a7a746b1417$export$2da9287da10b19e2(x, y) {
    // we don't want to convert numbers to string, only accept string input
    if (!(0, $gs7TF.isString)(x)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $gs7TF.typeOf)(x) + ', index: 0)');
    if (!(0, $gs7TF.isString)(y)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $gs7TF.typeOf)(y) + ', index: 1)');
    return x === y ? 0 : x > y ? 1 : -1;
}

});
parcelRegister("ddoIR", function(module, exports) {

$parcel$export(module.exports, "format", () => $99efaaab2f49d127$export$d9468344d3651243);

var $6egKm = parcelRequire("6egKm");
/**
 * Formats a BigNumber in a given base
 * @param {BigNumber} n
 * @param {number} base
 * @param {number} size
 * @returns {string}
 */ function $99efaaab2f49d127$var$formatBigNumberToBase(n, base, size) {
    var BigNumberCtor = n.constructor;
    var big2 = new BigNumberCtor(2);
    var suffix = '';
    if (size) {
        if (size < 1) throw new Error('size must be in greater than 0');
        if (!(0, $6egKm.isInteger)(size)) throw new Error('size must be an integer');
        if (n.greaterThan(big2.pow(size - 1).sub(1)) || n.lessThan(big2.pow(size - 1).mul(-1))) throw new Error("Value must be in range [-2^".concat(size - 1, ", 2^").concat(size - 1, "-1]"));
        if (!n.isInteger()) throw new Error('Value must be an integer');
        if (n.lessThan(0)) n = n.add(big2.pow(size));
        suffix = "i".concat(size);
    }
    switch(base){
        case 2:
            return "".concat(n.toBinary()).concat(suffix);
        case 8:
            return "".concat(n.toOctal()).concat(suffix);
        case 16:
            return "".concat(n.toHexadecimal()).concat(suffix);
        default:
            throw new Error("Base ".concat(base, " not supported "));
    }
}
function $99efaaab2f49d127$export$d9468344d3651243(value, options) {
    if (typeof options === 'function') // handle format(value, fn)
    return options(value);
     // handle special cases
    if (!value.isFinite()) return value.isNaN() ? 'NaN' : value.gt(0) ? 'Infinity' : '-Infinity';
     // default values for options
    var notation = 'auto';
    var precision;
    var wordSize;
    if (options !== undefined) {
        // determine notation from options
        if (options.notation) notation = options.notation;
         // determine precision from options
        if (typeof options === 'number') precision = options;
        else if (options.precision) precision = options.precision;
        if (options.wordSize) {
            wordSize = options.wordSize;
            if (typeof wordSize !== 'number') throw new Error('Option "wordSize" must be a number');
        }
    } // handle the various notations
    switch(notation){
        case 'fixed':
            return $99efaaab2f49d127$export$a81f732198733497(value, precision);
        case 'exponential':
            return $99efaaab2f49d127$export$888cb08ddc4765be(value, precision);
        case 'engineering':
            return $99efaaab2f49d127$export$9299fe684ed0ee48(value, precision);
        case 'bin':
            return $99efaaab2f49d127$var$formatBigNumberToBase(value, 2, wordSize);
        case 'oct':
            return $99efaaab2f49d127$var$formatBigNumberToBase(value, 8, wordSize);
        case 'hex':
            return $99efaaab2f49d127$var$formatBigNumberToBase(value, 16, wordSize);
        case 'auto':
            // determine lower and upper bound for exponential notation.
            // TODO: implement support for upper and lower to be BigNumbers themselves
            var lowerExp = options && options.lowerExp !== undefined ? options.lowerExp : -3;
            var upperExp = options && options.upperExp !== undefined ? options.upperExp : 5; // handle special case zero
            if (value.isZero()) return '0'; // determine whether or not to output exponential notation
            var str;
            var rounded = value.toSignificantDigits(precision);
            var exp = rounded.e;
            if (exp >= lowerExp && exp < upperExp) // normal number notation
            str = rounded.toFixed();
            else // exponential notation
            str = $99efaaab2f49d127$export$888cb08ddc4765be(value, precision);
             // remove trailing zeros after the decimal point
            return str.replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== '.' ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
    }
}
function $99efaaab2f49d127$export$9299fe684ed0ee48(value, precision) {
    // find nearest lower multiple of 3 for exponent
    var e = value.e;
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3; // find difference in exponents, and calculate the value without exponent
    var valueWithoutExp = value.mul(Math.pow(10, -newExp));
    var valueStr = valueWithoutExp.toPrecision(precision);
    if (valueStr.indexOf('e') !== -1) valueStr = valueWithoutExp.toString();
    return valueStr + 'e' + (e >= 0 ? '+' : '') + newExp.toString();
}
function $99efaaab2f49d127$export$888cb08ddc4765be(value, precision) {
    if (precision !== undefined) return value.toExponential(precision - 1); // Note the offset of one
    else return value.toExponential();
}
function $99efaaab2f49d127$export$a81f732198733497(value, precision) {
    return value.toFixed(precision);
}

});


parcelRegister("iAoVB", function(module, exports) {

$parcel$export(module.exports, "DimensionError", () => $d87eecf969c00ef5$export$ad1391ca020fdd96);
/**
 * Create a range error with the message:
 *     'Dimension mismatch (<actual size> != <expected size>)'
 * @param {number | number[]} actual        The actual size
 * @param {number | number[]} expected      The expected size
 * @param {string} [relation='!=']          Optional relation between actual
 *                                          and expected size: '!=', '<', etc.
 * @extends RangeError
 */ function $d87eecf969c00ef5$export$ad1391ca020fdd96(actual, expected, relation) {
    if (!(this instanceof $d87eecf969c00ef5$export$ad1391ca020fdd96)) throw new SyntaxError('Constructor must be called with the new operator');
    this.actual = actual;
    this.expected = expected;
    this.relation = relation;
    this.message = 'Dimension mismatch (' + (Array.isArray(actual) ? '[' + actual.join(', ') + ']' : actual) + ' ' + (this.relation || '!=') + ' ' + (Array.isArray(expected) ? '[' + expected.join(', ') + ']' : expected) + ')';
    this.stack = new Error().stack;
}
$d87eecf969c00ef5$export$ad1391ca020fdd96.prototype = new RangeError();
$d87eecf969c00ef5$export$ad1391ca020fdd96.prototype.constructor = RangeError;
$d87eecf969c00ef5$export$ad1391ca020fdd96.prototype.name = 'DimensionError';
$d87eecf969c00ef5$export$ad1391ca020fdd96.prototype.isDimensionError = true;

});

parcelRegister("9juUc", function(module, exports) {

$parcel$export(module.exports, "IndexError", () => $6c7ddc9256171f2c$export$efa5eacb1304c464);
/**
 * Create a range error with the message:
 *     'Index out of range (index < min)'
 *     'Index out of range (index < max)'
 *
 * @param {number} index     The actual index
 * @param {number} [min=0]   Minimum index (included)
 * @param {number} [max]     Maximum index (excluded)
 * @extends RangeError
 */ function $6c7ddc9256171f2c$export$efa5eacb1304c464(index, min, max) {
    if (!(this instanceof $6c7ddc9256171f2c$export$efa5eacb1304c464)) throw new SyntaxError('Constructor must be called with the new operator');
    this.index = index;
    if (arguments.length < 3) {
        this.min = 0;
        this.max = min;
    } else {
        this.min = min;
        this.max = max;
    }
    if (this.min !== undefined && this.index < this.min) this.message = 'Index out of range (' + this.index + ' < ' + this.min + ')';
    else if (this.max !== undefined && this.index >= this.max) this.message = 'Index out of range (' + this.index + ' > ' + (this.max - 1) + ')';
    else this.message = 'Index out of range (' + this.index + ')';
    this.stack = new Error().stack;
}
$6c7ddc9256171f2c$export$efa5eacb1304c464.prototype = new RangeError();
$6c7ddc9256171f2c$export$efa5eacb1304c464.prototype.constructor = RangeError;
$6c7ddc9256171f2c$export$efa5eacb1304c464.prototype.name = 'IndexError';
$6c7ddc9256171f2c$export$efa5eacb1304c464.prototype.isIndexError = true;

});



parcelRegister("9nwyh", function(module, exports) {

$parcel$export(module.exports, "containsCollections", () => $6d3f8326c4407484$export$4d8f6a27e2f5bcb2);
$parcel$export(module.exports, "deepForEach", () => $6d3f8326c4407484$export$519ada94592b97fc);
$parcel$export(module.exports, "deepMap", () => $6d3f8326c4407484$export$ce7eaaed37329a1b);
$parcel$export(module.exports, "reduce", () => $6d3f8326c4407484$export$533b26079ad0b4b);
$parcel$export(module.exports, "scatter", () => $6d3f8326c4407484$export$c97954fff4307550);

var $gs7TF = parcelRequire("gs7TF");

var $9juUc = parcelRequire("9juUc");

var $10UPF = parcelRequire("10UPF");
function $6d3f8326c4407484$export$4d8f6a27e2f5bcb2(array) {
    for(var i = 0; i < array.length; i++){
        if ((0, $gs7TF.isCollection)(array[i])) return true;
    }
    return false;
}
function $6d3f8326c4407484$export$519ada94592b97fc(array, callback) {
    if ((0, $gs7TF.isMatrix)(array)) array = array.valueOf();
    for(var i = 0, ii = array.length; i < ii; i++){
        var value = array[i];
        if (Array.isArray(value)) $6d3f8326c4407484$export$519ada94592b97fc(value, callback);
        else callback(value);
    }
}
function $6d3f8326c4407484$export$ce7eaaed37329a1b(array, callback, skipZeros) {
    if (array && typeof array.map === 'function') // TODO: replace array.map with a for loop to improve performance
    return array.map(function(x) {
        return $6d3f8326c4407484$export$ce7eaaed37329a1b(x, callback, skipZeros);
    });
    else return callback(array);
}
function $6d3f8326c4407484$export$533b26079ad0b4b(mat, dim, callback) {
    var size = Array.isArray(mat) ? (0, $10UPF.arraySize)(mat) : mat.size();
    if (dim < 0 || dim >= size.length) // TODO: would be more clear when throwing a DimensionError here
    throw new (0, $9juUc.IndexError)(dim, size.length);
    if ((0, $gs7TF.isMatrix)(mat)) return mat.create($6d3f8326c4407484$var$_reduce(mat.valueOf(), dim, callback));
    else return $6d3f8326c4407484$var$_reduce(mat, dim, callback);
}
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $6d3f8326c4407484$var$_reduce(mat, dim, callback) {
    var i, ret, val, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) {
            val = mat[0];
            for(i = 1; i < mat.length; i++)val = callback(val, mat[i]);
            return val;
        } else {
            tran = $6d3f8326c4407484$var$_switch(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $6d3f8326c4407484$var$_reduce(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $6d3f8326c4407484$var$_reduce(mat[i], dim - 1, callback);
        return ret;
    }
}
/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $6d3f8326c4407484$var$_switch(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
} // TODO: document function scatter
function $6d3f8326c4407484$export$c97954fff4307550(a, j, w, x, u, mark, cindex, f, inverse, update, value) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr; // vars
    var k, k0, k1, i; // check we need to process values (pattern matrix)
    if (x) // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k]; // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark; // add i to pattern of C
            cindex.push(i); // x(i) = A, check we need to call function this time
            if (update) {
                // copy value to workspace calling callback function
                x[i] = inverse ? f(avalues[k], value) : f(value, avalues[k]); // function was called on current row
                u[i] = mark;
            } else // copy value to workspace
            x[i] = avalues[k];
        } else {
            // i exists in C already
            x[i] = inverse ? f(avalues[k], x[i]) : f(x[i], avalues[k]); // function was called on current row
            u[i] = mark;
        }
    }
    else // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k]; // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark; // add i to pattern of C
            cindex.push(i);
        } else // indicate function was called on current row
        u[i] = mark;
    }
}

});

parcelRegister("eRNhQ", function(module, exports) {

$parcel$export(module.exports, "absNumber", () => $ad2c3f3f50db052d$export$59270f717756a93a);
$parcel$export(module.exports, "addNumber", () => $ad2c3f3f50db052d$export$d6751d2a3b6da12a);
$parcel$export(module.exports, "multiplyNumber", () => $ad2c3f3f50db052d$export$4ad41ac849e391ec);
$parcel$export(module.exports, "unaryMinusNumber", () => $ad2c3f3f50db052d$export$339666dc881be46b);
$parcel$export(module.exports, "unaryPlusNumber", () => $ad2c3f3f50db052d$export$da5b80d388a295fb);
$parcel$export(module.exports, "cbrtNumber", () => $ad2c3f3f50db052d$export$95c2aecb85f70726);
$parcel$export(module.exports, "ceilNumber", () => $ad2c3f3f50db052d$export$dd91a1966a303b99);
$parcel$export(module.exports, "cubeNumber", () => $ad2c3f3f50db052d$export$9505f0b39acd04c);
$parcel$export(module.exports, "expNumber", () => $ad2c3f3f50db052d$export$a33b288b35672fe5);
$parcel$export(module.exports, "expm1Number", () => $ad2c3f3f50db052d$export$756d0c010cecc6c3);
$parcel$export(module.exports, "gcdNumber", () => $ad2c3f3f50db052d$export$3a8d786b08b3a70c);
$parcel$export(module.exports, "lcmNumber", () => $ad2c3f3f50db052d$export$b55f99ec1f4c5649);
$parcel$export(module.exports, "logNumber", () => $ad2c3f3f50db052d$export$4df0e8fcdd5c0927);
$parcel$export(module.exports, "log10Number", () => $ad2c3f3f50db052d$export$e3f8d49574d29dff);
$parcel$export(module.exports, "log2Number", () => $ad2c3f3f50db052d$export$f9bc93220cfa3c59);
$parcel$export(module.exports, "modNumber", () => $ad2c3f3f50db052d$export$64b58c5b0372ae95);
$parcel$export(module.exports, "nthRootNumber", () => $ad2c3f3f50db052d$export$9f26f16bd796a7b3);
$parcel$export(module.exports, "signNumber", () => $ad2c3f3f50db052d$export$af3d9fe43be78285);
$parcel$export(module.exports, "squareNumber", () => $ad2c3f3f50db052d$export$c4094a156ed9ab35);
$parcel$export(module.exports, "xgcdNumber", () => $ad2c3f3f50db052d$export$8cb756a23a623229);
$parcel$export(module.exports, "powNumber", () => $ad2c3f3f50db052d$export$3f512e7fd4999e01);
$parcel$export(module.exports, "roundNumber", () => $ad2c3f3f50db052d$export$a3992db8dd0fd9e6);

var $6egKm = parcelRequire("6egKm");
var $ad2c3f3f50db052d$var$n1 = 'number';
var $ad2c3f3f50db052d$var$n2 = 'number, number';
function $ad2c3f3f50db052d$export$59270f717756a93a(a) {
    return Math.abs(a);
}
$ad2c3f3f50db052d$export$59270f717756a93a.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$d6751d2a3b6da12a(a, b) {
    return a + b;
}
$ad2c3f3f50db052d$export$d6751d2a3b6da12a.signature = $ad2c3f3f50db052d$var$n2;
function $ad2c3f3f50db052d$export$fd8ce9cfca47ace5(a, b) {
    return a - b;
}
$ad2c3f3f50db052d$export$fd8ce9cfca47ace5.signature = $ad2c3f3f50db052d$var$n2;
function $ad2c3f3f50db052d$export$4ad41ac849e391ec(a, b) {
    return a * b;
}
$ad2c3f3f50db052d$export$4ad41ac849e391ec.signature = $ad2c3f3f50db052d$var$n2;
function $ad2c3f3f50db052d$export$58c48a269ab4a155(a, b) {
    return a / b;
}
$ad2c3f3f50db052d$export$58c48a269ab4a155.signature = $ad2c3f3f50db052d$var$n2;
function $ad2c3f3f50db052d$export$339666dc881be46b(x) {
    return -x;
}
$ad2c3f3f50db052d$export$339666dc881be46b.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$da5b80d388a295fb(x) {
    return x;
}
$ad2c3f3f50db052d$export$da5b80d388a295fb.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$95c2aecb85f70726(x) {
    return (0, $6egKm.cbrt)(x);
}
$ad2c3f3f50db052d$export$95c2aecb85f70726.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$dd91a1966a303b99(x) {
    return Math.ceil(x);
}
$ad2c3f3f50db052d$export$dd91a1966a303b99.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$9505f0b39acd04c(x) {
    return x * x * x;
}
$ad2c3f3f50db052d$export$9505f0b39acd04c.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$a33b288b35672fe5(x) {
    return Math.exp(x);
}
$ad2c3f3f50db052d$export$a33b288b35672fe5.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$756d0c010cecc6c3(x) {
    return (0, $6egKm.expm1)(x);
}
$ad2c3f3f50db052d$export$756d0c010cecc6c3.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$f0d92d0037f57a41(x) {
    return x > 0 ? Math.floor(x) : Math.ceil(x);
}
$ad2c3f3f50db052d$export$f0d92d0037f57a41.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$10d3df201a8983fc(x) {
    return Math.floor(x);
}
$ad2c3f3f50db052d$export$10d3df201a8983fc.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$3a8d786b08b3a70c(a, b) {
    if (!(0, $6egKm.isInteger)(a) || !(0, $6egKm.isInteger)(b)) throw new Error('Parameters in function gcd must be integer numbers');
     // https://en.wikipedia.org/wiki/Euclidean_algorithm
    var r;
    while(b !== 0){
        r = a % b;
        a = b;
        b = r;
    }
    return a < 0 ? -a : a;
}
$ad2c3f3f50db052d$export$3a8d786b08b3a70c.signature = $ad2c3f3f50db052d$var$n2;
function $ad2c3f3f50db052d$export$b55f99ec1f4c5649(a, b) {
    if (!(0, $6egKm.isInteger)(a) || !(0, $6egKm.isInteger)(b)) throw new Error('Parameters in function lcm must be integer numbers');
    if (a === 0 || b === 0) return 0;
     // https://en.wikipedia.org/wiki/Euclidean_algorithm
    // evaluate lcm here inline to reduce overhead
    var t;
    var prod = a * b;
    while(b !== 0){
        t = b;
        b = a % t;
        a = t;
    }
    return Math.abs(prod / a);
}
$ad2c3f3f50db052d$export$b55f99ec1f4c5649.signature = $ad2c3f3f50db052d$var$n2;
function $ad2c3f3f50db052d$export$4df0e8fcdd5c0927(x) {
    return Math.log(x);
}
$ad2c3f3f50db052d$export$4df0e8fcdd5c0927.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$e3f8d49574d29dff(x) {
    return (0, $6egKm.log10)(x);
}
$ad2c3f3f50db052d$export$e3f8d49574d29dff.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$f9bc93220cfa3c59(x) {
    return (0, $6egKm.log2)(x);
}
$ad2c3f3f50db052d$export$f9bc93220cfa3c59.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$ae1f56e105ebe4a1(x) {
    return (0, $6egKm.log1p)(x);
}
$ad2c3f3f50db052d$export$ae1f56e105ebe4a1.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$64b58c5b0372ae95(x, y) {
    if (y > 0) // We don't use JavaScript's % operator here as this doesn't work
    // correctly for x < 0 and x === 0
    // see https://en.wikipedia.org/wiki/Modulo_operation
    return x - y * Math.floor(x / y);
    else if (y === 0) return x;
    else // y < 0
    // TODO: implement mod for a negative divisor
    throw new Error('Cannot calculate mod for a negative divisor');
}
$ad2c3f3f50db052d$export$64b58c5b0372ae95.signature = $ad2c3f3f50db052d$var$n2;
function $ad2c3f3f50db052d$export$9f26f16bd796a7b3(a, root) {
    var inv = root < 0;
    if (inv) root = -root;
    if (root === 0) throw new Error('Root must be non-zero');
    if (a < 0 && Math.abs(root) % 2 !== 1) throw new Error('Root must be odd when a is negative.');
     // edge cases zero and infinity
    if (a === 0) return inv ? Infinity : 0;
    if (!isFinite(a)) return inv ? 0 : a;
    var x = Math.pow(Math.abs(a), 1 / root); // If a < 0, we require that root is an odd integer,
    // so (-1) ^ (1/root) = -1
    x = a < 0 ? -x : x;
    return inv ? 1 / x : x; // Very nice algorithm, but fails with nthRoot(-2, 3).
// Newton's method has some well-known problems at times:
// https://en.wikipedia.org/wiki/Newton%27s_method#Failure_analysis
/*
  let x = 1 // Initial guess
  let xPrev = 1
  let i = 0
  const iMax = 10000
  do {
    const delta = (a / Math.pow(x, root - 1) - x) / root
    xPrev = x
    x = x + delta
    i++
  }
  while (xPrev !== x && i < iMax)
   if (xPrev !== x) {
    throw new Error('Function nthRoot failed to converge')
  }
   return inv ? 1 / x : x
  */ }
$ad2c3f3f50db052d$export$9f26f16bd796a7b3.signature = $ad2c3f3f50db052d$var$n2;
function $ad2c3f3f50db052d$export$af3d9fe43be78285(x) {
    return (0, $6egKm.sign)(x);
}
$ad2c3f3f50db052d$export$af3d9fe43be78285.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$aacd0ed14e49886d(x) {
    return Math.sqrt(x);
}
$ad2c3f3f50db052d$export$aacd0ed14e49886d.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$c4094a156ed9ab35(x) {
    return x * x;
}
$ad2c3f3f50db052d$export$c4094a156ed9ab35.signature = $ad2c3f3f50db052d$var$n1;
function $ad2c3f3f50db052d$export$8cb756a23a623229(a, b) {
    // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
    var t; // used to swap two variables
    var q; // quotient
    var r; // remainder
    var x = 0;
    var lastx = 1;
    var y = 1;
    var lasty = 0;
    if (!(0, $6egKm.isInteger)(a) || !(0, $6egKm.isInteger)(b)) throw new Error('Parameters in function xgcd must be integer numbers');
    while(b){
        q = Math.floor(a / b);
        r = a - q * b;
        t = x;
        x = lastx - q * x;
        lastx = t;
        t = y;
        y = lasty - q * y;
        lasty = t;
        a = b;
        b = r;
    }
    var res;
    if (a < 0) res = [
        -a,
        -lastx,
        -lasty
    ];
    else res = [
        a,
        a ? lastx : 0,
        lasty
    ];
    return res;
}
$ad2c3f3f50db052d$export$8cb756a23a623229.signature = $ad2c3f3f50db052d$var$n2;
function $ad2c3f3f50db052d$export$3f512e7fd4999e01(x, y) {
    // x^Infinity === 0 if -1 < x < 1
    // A real number 0 is returned instead of complex(0)
    if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
    return Math.pow(x, y);
}
$ad2c3f3f50db052d$export$3f512e7fd4999e01.signature = $ad2c3f3f50db052d$var$n2;
function $ad2c3f3f50db052d$export$a3992db8dd0fd9e6(value) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return parseFloat((0, $6egKm.toFixed)(value, decimals));
}
$ad2c3f3f50db052d$export$a3992db8dd0fd9e6.signature = $ad2c3f3f50db052d$var$n2;
function $ad2c3f3f50db052d$export$d78ecacee56245ec(x) {
    return Math.abs(x);
}
$ad2c3f3f50db052d$export$d78ecacee56245ec.signature = $ad2c3f3f50db052d$var$n1;

});


parcelRegister("04pgm", function(module, exports) {

$parcel$export(module.exports, "createAcos", () => $00d3f881612e1cb9$export$33da46c5ece67581);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $00d3f881612e1cb9$var$name = 'acos';
var $00d3f881612e1cb9$var$dependencies = [
    'typed',
    'config',
    'Complex'
];
var $00d3f881612e1cb9$export$33da46c5ece67581 = /* #__PURE__ */ (0, $4eE2e.factory)($00d3f881612e1cb9$var$name, $00d3f881612e1cb9$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the inverse cosine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acos(x)
   *
   * Examples:
   *
   *    math.acos(0.5)           // returns number 1.0471975511965979
   *    math.acos(math.cos(1.5)) // returns number 1.5
   *
   *    math.acos(2)             // returns Complex 0 + 1.3169578969248166 i
   *
   * See also:
   *
   *    cos, atan, asin
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc cosine of x
   */ return typed($00d3f881612e1cb9$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.acos(x);
            else return new Complex(x, 0).acos();
        },
        Complex: function Complex(x) {
            return x.acos();
        },
        BigNumber: function BigNumber(x) {
            return x.acos();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("iU3tp", function(module, exports) {

$parcel$export(module.exports, "createAcosh", () => $dc3026b6e10383bf$export$c634796792055579);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $dc3026b6e10383bf$var$name = 'acosh';
var $dc3026b6e10383bf$var$dependencies = [
    'typed',
    'config',
    'Complex'
];
var $dc3026b6e10383bf$export$c634796792055579 = /* #__PURE__ */ (0, $4eE2e.factory)($dc3026b6e10383bf$var$name, $dc3026b6e10383bf$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the hyperbolic arccos of a value,
   * defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acosh(x)
   *
   * Examples:
   *
   *    math.acosh(1.5)       // returns 0.9624236501192069
   *
   * See also:
   *
   *    cosh, asinh, atanh
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccosine of x
   */ return typed($dc3026b6e10383bf$var$name, {
        number: function number(x) {
            if (x >= 1 || config.predictable) return (0, $fkvqw.acoshNumber)(x);
            if (x <= -1) return new Complex(Math.log(Math.sqrt(x * x - 1) - x), Math.PI);
            return new Complex(x, 0).acosh();
        },
        Complex: function Complex(x) {
            return x.acosh();
        },
        BigNumber: function BigNumber(x) {
            return x.acosh();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});
parcelRegister("fkvqw", function(module, exports) {

$parcel$export(module.exports, "acoshNumber", () => $b29119f3201331c2$export$84088556f7d2d0be);
$parcel$export(module.exports, "acotNumber", () => $b29119f3201331c2$export$ba80ccbf024897ef);
$parcel$export(module.exports, "acothNumber", () => $b29119f3201331c2$export$e2be1aa5d5a3f81);
$parcel$export(module.exports, "acscNumber", () => $b29119f3201331c2$export$e3b67a6e3df3fd81);
$parcel$export(module.exports, "acschNumber", () => $b29119f3201331c2$export$51cd224337b2c783);
$parcel$export(module.exports, "asecNumber", () => $b29119f3201331c2$export$5ec3930177455ade);
$parcel$export(module.exports, "asechNumber", () => $b29119f3201331c2$export$cf144300ea173362);
$parcel$export(module.exports, "asinhNumber", () => $b29119f3201331c2$export$3a027485d3336d8d);
$parcel$export(module.exports, "atanhNumber", () => $b29119f3201331c2$export$44a1f653c6513db8);
$parcel$export(module.exports, "cotNumber", () => $b29119f3201331c2$export$515b39f7fd07e09f);
$parcel$export(module.exports, "cothNumber", () => $b29119f3201331c2$export$925affe88b2512fc);
$parcel$export(module.exports, "cscNumber", () => $b29119f3201331c2$export$5a8409ad16e318b2);
$parcel$export(module.exports, "cschNumber", () => $b29119f3201331c2$export$143835b5c1db9790);
$parcel$export(module.exports, "secNumber", () => $b29119f3201331c2$export$ee1efc70bd8a6d93);
$parcel$export(module.exports, "sechNumber", () => $b29119f3201331c2$export$b83345d70fe4a871);
$parcel$export(module.exports, "sinhNumber", () => $b29119f3201331c2$export$89648c4ce0d79e70);

var $6egKm = parcelRequire("6egKm");
var $b29119f3201331c2$var$n1 = 'number';
var $b29119f3201331c2$var$n2 = 'number, number';
function $b29119f3201331c2$export$99a14685a3a2b607(x) {
    return Math.acos(x);
}
$b29119f3201331c2$export$99a14685a3a2b607.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$84088556f7d2d0be(x) {
    return (0, $6egKm.acosh)(x);
}
$b29119f3201331c2$export$84088556f7d2d0be.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$ba80ccbf024897ef(x) {
    return Math.atan(1 / x);
}
$b29119f3201331c2$export$ba80ccbf024897ef.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$e2be1aa5d5a3f81(x) {
    return isFinite(x) ? (Math.log((x + 1) / x) + Math.log(x / (x - 1))) / 2 : 0;
}
$b29119f3201331c2$export$e2be1aa5d5a3f81.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$e3b67a6e3df3fd81(x) {
    return Math.asin(1 / x);
}
$b29119f3201331c2$export$e3b67a6e3df3fd81.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$51cd224337b2c783(x) {
    var xInv = 1 / x;
    return Math.log(xInv + Math.sqrt(xInv * xInv + 1));
}
$b29119f3201331c2$export$51cd224337b2c783.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$5ec3930177455ade(x) {
    return Math.acos(1 / x);
}
$b29119f3201331c2$export$5ec3930177455ade.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$cf144300ea173362(x) {
    var xInv = 1 / x;
    var ret = Math.sqrt(xInv * xInv - 1);
    return Math.log(ret + xInv);
}
$b29119f3201331c2$export$cf144300ea173362.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$444ef2855488a2d5(x) {
    return Math.asin(x);
}
$b29119f3201331c2$export$444ef2855488a2d5.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$3a027485d3336d8d(x) {
    return (0, $6egKm.asinh)(x);
}
$b29119f3201331c2$export$3a027485d3336d8d.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$c38dcb11df4699c0(x) {
    return Math.atan(x);
}
$b29119f3201331c2$export$c38dcb11df4699c0.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$a97666a135b540f9(y, x) {
    return Math.atan2(y, x);
}
$b29119f3201331c2$export$a97666a135b540f9.signature = $b29119f3201331c2$var$n2;
function $b29119f3201331c2$export$44a1f653c6513db8(x) {
    return (0, $6egKm.atanh)(x);
}
$b29119f3201331c2$export$44a1f653c6513db8.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$8d04496be3e647d4(x) {
    return Math.cos(x);
}
$b29119f3201331c2$export$8d04496be3e647d4.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$7cf8db0cff734545(x) {
    return (0, $6egKm.cosh)(x);
}
$b29119f3201331c2$export$7cf8db0cff734545.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$515b39f7fd07e09f(x) {
    return 1 / Math.tan(x);
}
$b29119f3201331c2$export$515b39f7fd07e09f.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$925affe88b2512fc(x) {
    var e = Math.exp(2 * x);
    return (e + 1) / (e - 1);
}
$b29119f3201331c2$export$925affe88b2512fc.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$5a8409ad16e318b2(x) {
    return 1 / Math.sin(x);
}
$b29119f3201331c2$export$5a8409ad16e318b2.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$143835b5c1db9790(x) {
    // consider values close to zero (+/-)
    if (x === 0) return Number.POSITIVE_INFINITY;
    else return Math.abs(2 / (Math.exp(x) - Math.exp(-x))) * (0, $6egKm.sign)(x);
}
$b29119f3201331c2$export$143835b5c1db9790.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$ee1efc70bd8a6d93(x) {
    return 1 / Math.cos(x);
}
$b29119f3201331c2$export$ee1efc70bd8a6d93.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$b83345d70fe4a871(x) {
    return 2 / (Math.exp(x) + Math.exp(-x));
}
$b29119f3201331c2$export$b83345d70fe4a871.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$b6e96f13f41c8816(x) {
    return Math.sin(x);
}
$b29119f3201331c2$export$b6e96f13f41c8816.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$89648c4ce0d79e70(x) {
    return (0, $6egKm.sinh)(x);
}
$b29119f3201331c2$export$89648c4ce0d79e70.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$ecbd7b3271ebce16(x) {
    return Math.tan(x);
}
$b29119f3201331c2$export$ecbd7b3271ebce16.signature = $b29119f3201331c2$var$n1;
function $b29119f3201331c2$export$70e2e2cc9c2555e4(x) {
    return (0, $6egKm.tanh)(x);
}
$b29119f3201331c2$export$70e2e2cc9c2555e4.signature = $b29119f3201331c2$var$n1;

});


parcelRegister("ibMRy", function(module, exports) {

$parcel$export(module.exports, "createAcot", () => $d3df283a71a02c58$export$8a6845771325148e);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $d3df283a71a02c58$var$name = 'acot';
var $d3df283a71a02c58$var$dependencies = [
    'typed',
    'BigNumber'
];
var $d3df283a71a02c58$export$8a6845771325148e = /* #__PURE__ */ (0, $4eE2e.factory)($d3df283a71a02c58$var$name, $d3df283a71a02c58$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse cotangent of a value, defined as `acot(x) = atan(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acot(x)
   *
   * Examples:
   *
   *    math.acot(0.5)           // returns number 0.4636476090008061
   *    math.acot(math.cot(1.5)) // returns number 1.5
   *
   *    math.acot(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    cot, atan
   *
   * @param {number | Complex | Array | Matrix} x   Function input
   * @return {number | Complex | Array | Matrix} The arc cotangent of x
   */ return typed($d3df283a71a02c58$var$name, {
        number: (0, $fkvqw.acotNumber),
        Complex: function Complex(x) {
            return x.acot();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atan();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("fLjTM", function(module, exports) {

$parcel$export(module.exports, "createAcoth", () => $b79aae4463db5492$export$67e40c7fd8f5703a);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $b79aae4463db5492$var$name = 'acoth';
var $b79aae4463db5492$var$dependencies = [
    'typed',
    'config',
    'Complex',
    'BigNumber'
];
var $b79aae4463db5492$export$67e40c7fd8f5703a = /* #__PURE__ */ (0, $4eE2e.factory)($b79aae4463db5492$var$name, $b79aae4463db5492$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arccotangent of a value,
   * defined as `acoth(x) = atanh(1/x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acoth(x)
   *
   * Examples:
   *
   *    math.acoth(0.5)       // returns 0.8047189562170503
   *
   * See also:
   *
   *    acsch, asech
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccotangent of x
   */ return typed($b79aae4463db5492$var$name, {
        number: function number(x) {
            if (x >= 1 || x <= -1 || config.predictable) return (0, $fkvqw.acothNumber)(x);
            return new Complex(x, 0).acoth();
        },
        Complex: function Complex(x) {
            return x.acoth();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atanh();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("5Qqxq", function(module, exports) {

$parcel$export(module.exports, "createAcsc", () => $441664fac8433c9a$export$95580581b134a5bd);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $441664fac8433c9a$var$name = 'acsc';
var $441664fac8433c9a$var$dependencies = [
    'typed',
    'config',
    'Complex',
    'BigNumber'
];
var $441664fac8433c9a$export$95580581b134a5bd = /* #__PURE__ */ (0, $4eE2e.factory)($441664fac8433c9a$var$name, $441664fac8433c9a$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse cosecant of a value, defined as `acsc(x) = asin(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acsc(x)
   *
   * Examples:
   *
   *    math.acsc(0.5)           // returns number 0.5235987755982989
   *    math.acsc(math.csc(1.5)) // returns number ~1.5
   *
   *    math.acsc(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    csc, asin, asec
   *
   * @param {number | Complex | Array | Matrix} x   Function input
   * @return {number | Complex | Array | Matrix} The arc cosecant of x
   */ return typed($441664fac8433c9a$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $fkvqw.acscNumber)(x);
            return new Complex(x, 0).acsc();
        },
        Complex: function Complex(x) {
            return x.acsc();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asin();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("4aat8", function(module, exports) {

$parcel$export(module.exports, "createAcsch", () => $3080377f841621b9$export$d6534043a40dc59);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $3080377f841621b9$var$name = 'acsch';
var $3080377f841621b9$var$dependencies = [
    'typed',
    'BigNumber'
];
var $3080377f841621b9$export$d6534043a40dc59 = /* #__PURE__ */ (0, $4eE2e.factory)($3080377f841621b9$var$name, $3080377f841621b9$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arccosecant of a value,
   * defined as `acsch(x) = asinh(1/x) = ln(1/x + sqrt(1/x^2 + 1))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acsch(x)
   *
   * Examples:
   *
   *    math.acsch(0.5)       // returns 1.4436354751788103
   *
   * See also:
   *
   *    asech, acoth
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccosecant of x
   */ return typed($3080377f841621b9$var$name, {
        number: (0, $fkvqw.acschNumber),
        Complex: function Complex(x) {
            return x.acsch();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asinh();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("axTFP", function(module, exports) {

$parcel$export(module.exports, "createAdd", () => $01fb3a845d0d3ae0$export$c6b51545da64d82f);

var $4eE2e = parcelRequire("4eE2e");

var $4mYv9 = parcelRequire("4mYv9");

var $bCo9f = parcelRequire("bCo9f");

var $fF2Gm = parcelRequire("fF2Gm");

var $ecxvm = parcelRequire("ecxvm");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");
var $01fb3a845d0d3ae0$var$name = 'add';
var $01fb3a845d0d3ae0$var$dependencies = [
    'typed',
    'matrix',
    'addScalar',
    'equalScalar',
    'DenseMatrix',
    'SparseMatrix'
];
var $01fb3a845d0d3ae0$export$c6b51545da64d82f = /* #__PURE__ */ (0, $4eE2e.factory)($01fb3a845d0d3ae0$var$name, $01fb3a845d0d3ae0$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    var algorithm01 = (0, $bCo9f.createAlgorithm01)({
        typed: typed
    });
    var algorithm04 = (0, $fF2Gm.createAlgorithm04)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $ecxvm.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Add two or more values, `x + y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.add(x, y)
   *    math.add(x, y, z, ...)
   *
   * Examples:
   *
   *    math.add(2, 3)               // returns number 5
   *    math.add(2, 3, 4)            // returns number 9
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(-4, 1)
   *    math.add(a, b)               // returns Complex -2 + 4i
   *
   *    math.add([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   *    const c = math.unit('5 cm')
   *    const d = math.unit('2.1 mm')
   *    math.add(c, d)               // returns Unit 52.1 mm
   *
   *    math.add("2.3", "4")         // returns number 6.3
   *
   * See also:
   *
   *    subtract, sum
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to add
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to add
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Sum of `x` and `y`
   */ return typed($01fb3a845d0d3ae0$var$name, (0, $4mYv9.extend)({
        // we extend the signatures of addScalar with signatures dealing with matrices
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, addScalar);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, addScalar, false);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, addScalar, true);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, addScalar);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, addScalar, false);
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm10(x, y, addScalar, false);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, addScalar, true);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm10(y, x, addScalar, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, addScalar, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, addScalar, true).valueOf();
        },
        'any, any': addScalar,
        'any, any, ...any': function anyAnyAny(x, y, rest) {
            var result = this(x, y);
            for(var i = 0; i < rest.length; i++)result = this(result, rest[i]);
            return result;
        }
    }, addScalar.signatures));
});

});
parcelRegister("bCo9f", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm01", () => $8755f9a4f47e0743$export$5e6d55d37a917802);

var $4eE2e = parcelRequire("4eE2e");

var $iAoVB = parcelRequire("iAoVB");
var $8755f9a4f47e0743$var$name = 'algorithm01';
var $8755f9a4f47e0743$var$dependencies = [
    'typed'
];
var $8755f9a4f47e0743$export$5e6d55d37a917802 = /* #__PURE__ */ (0, $4eE2e.factory)($8755f9a4f47e0743$var$name, $8755f9a4f47e0743$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  Dij          ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm1(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $iAoVB.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // process data types
        var dt = typeof adt === 'string' && adt === bdt ? adt : undefined; // callback function
        var cf = dt ? typed.find(callback, [
            dt,
            dt
        ]) : callback; // vars
        var i, j; // result (DenseMatrix)
        var cdata = []; // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
         // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns in b
        for(j = 0; j < columns; j++){
            // column mark
            var mark = j + 1; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]); // mark i as updated
                w[i] = mark;
            } // loop rows
            for(i = 0; i < rows; i++)// check row is in workspace
            if (w[i] === mark) // c[i][j] was already calculated
            cdata[i][j] = x[i];
            else // item does not exist in S
            cdata[i][j] = adata[i][j];
        } // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("fF2Gm", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm04", () => $b66cc3ffa009e92c$export$898ea3bef50d41b7);

var $4eE2e = parcelRequire("4eE2e");

var $iAoVB = parcelRequire("iAoVB");
var $b66cc3ffa009e92c$var$name = 'algorithm04';
var $b66cc3ffa009e92c$var$dependencies = [
    'typed',
    'equalScalar'
];
var $b66cc3ffa009e92c$export$898ea3bef50d41b7 = /* #__PURE__ */ (0, $4eE2e.factory)($b66cc3ffa009e92c$var$name, $b66cc3ffa009e92c$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
   *          └  B(i,j)       ; B(i,j) !== 0
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm04(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $iAoVB.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspace
        var xa = avalues && bvalues ? [] : undefined;
        var xb = avalues && bvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // vars
        var i, j, k, k0, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // update c
                cindex.push(i); // update workspace
                wa[i] = mark; // check we need to process values
                if (xa) xa[i] = avalues[k];
            } // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // check row exists in A
                if (wa[i] === mark) // update record in xa @ i
                {
                    if (xa) {
                        // invoke callback
                        var v = cf(xa[i], bvalues[k]); // check for zero
                        if (!eq(v, zero)) // update workspace
                        xa[i] = v;
                        else // remove mark (index will be removed later)
                        wa[i] = null;
                    }
                } else {
                    // update c
                    cindex.push(i); // update workspace
                    wb[i] = mark; // check we need to process values
                    if (xb) xb[i] = bvalues[k];
                }
            } // check we need to process values (non pattern matrix)
            if (xa && xb) {
                // initialize first index in j
                k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k]; // check workspace has value @ i
                    if (wa[i] === mark) {
                        // push value (Aij != 0 || (Aij != 0 && Bij != 0))
                        cvalues[k] = xa[i]; // increment pointer
                        k++;
                    } else if (wb[i] === mark) {
                        // push value (bij != 0)
                        cvalues[k] = xb[i]; // increment pointer
                        k++;
                    } else // remove index @ k
                    cindex.splice(k, 1);
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("ecxvm", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm10", () => $a56c2d0aca6b17f0$export$72a88f2eee9ec1ed);

var $4eE2e = parcelRequire("4eE2e");
var $a56c2d0aca6b17f0$var$name = 'algorithm10';
var $a56c2d0aca6b17f0$var$dependencies = [
    'typed',
    'DenseMatrix'
];
var $a56c2d0aca6b17f0$export$72a88f2eee9ec1ed = /* #__PURE__ */ (0, $4eE2e.factory)($a56c2d0aca6b17f0$var$name, $a56c2d0aca6b17f0$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  b          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm10(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string') {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cdata = []; // workspaces
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k]; // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            } // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                 // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = b;
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("KKjvJ", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm13", () => $08c838ed241ff42b$export$fa05124e71a8ffb3);

var $4eE2e = parcelRequire("4eE2e");

var $iAoVB = parcelRequire("iAoVB");
var $08c838ed241ff42b$var$name = 'algorithm13';
var $08c838ed241ff42b$var$dependencies = [
    'typed'
];
var $08c838ed241ff42b$export$fa05124e71a8ffb3 = /* #__PURE__ */ (0, $4eE2e.factory)($08c838ed241ff42b$var$name, $08c838ed241ff42b$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, Bij..z).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, Bij..z)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Matrix}   b                 The DenseMatrix instance (B)
   * @param {Function} callback          The f(Aij..z,Bij..z) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97658658
   */ return function algorithm13(a, b, callback) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b arrays
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // c arrays
        var csize = []; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $iAoVB.DimensionError)(asize.length, bsize.length);
         // validate each one of the dimension sizes
        for(var s = 0; s < asize.length; s++){
            // must match
            if (asize[s] !== bsize[s]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
             // update dimension in c
            csize[s] = asize[s];
        } // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // populate cdata, iterate through dimensions
        var cdata = csize.length > 0 ? _iterate(cf, 0, csize, csize[0], adata, bdata) : []; // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: csize,
            datatype: dt
        });
    }; // recursive function
    function _iterate(f, level, s, n, av, bv) {
        // initialize array for this level
        var cv = []; // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = f(av[i], bv[i]);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv[j]);
        return cv;
    }
});

});

parcelRegister("laEuG", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm14", () => $f699f15eb6b90db5$export$e5afe3bc814ef550);

var $4eE2e = parcelRequire("4eE2e");

var $4mYv9 = parcelRequire("4mYv9");
var $f699f15eb6b90db5$var$name = 'algorithm14';
var $f699f15eb6b90db5$var$dependencies = [
    'typed'
];
var $f699f15eb6b90db5$export$e5afe3bc814ef550 = /* #__PURE__ */ (0, $4eE2e.factory)($f699f15eb6b90db5$var$name, $f699f15eb6b90db5$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, b).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, b)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij..z,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Aij..z)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97659042
   */ return function algorithm14(a, b, callback, inverse) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string') {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // populate cdata, iterate through dimensions
        var cdata = asize.length > 0 ? _iterate(cf, 0, asize, asize[0], adata, b, inverse) : []; // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: (0, $4mYv9.clone)(asize),
            datatype: dt
        });
    }; // recursive function
    function _iterate(f, level, s, n, av, bv, inverse) {
        // initialize array for this level
        var cv = []; // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = inverse ? f(bv, av[i]) : f(av[i], bv);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv, inverse);
        return cv;
    }
});

});


parcelRegister("3dLdY", function(module, exports) {

$parcel$export(module.exports, "createAddScalar", () => $258737c09e84ff66$export$bbebd809b9ccc50b);

var $4eE2e = parcelRequire("4eE2e");

var $eRNhQ = parcelRequire("eRNhQ");
var $258737c09e84ff66$var$name = 'addScalar';
var $258737c09e84ff66$var$dependencies = [
    'typed'
];
var $258737c09e84ff66$export$bbebd809b9ccc50b = /* #__PURE__ */ (0, $4eE2e.factory)($258737c09e84ff66$var$name, $258737c09e84ff66$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Add two scalar values, `x + y`.
   * This function is meant for internal use: it is used by the public function
   * `add`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to add
   * @param  {number | BigNumber | Fraction | Complex} y          Second value to add
   * @return {number | BigNumber | Fraction | Complex | Unit}     Sum of `x` and `y`
   * @private
   */ return typed($258737c09e84ff66$var$name, {
        'number, number': (0, $eRNhQ.addNumber),
        'Complex, Complex': function ComplexComplex(x, y) {
            return x.add(y);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.plus(y);
        },
        'Fraction, Fraction': function FractionFraction(x, y) {
            return x.add(y);
        },
        'Unit, Unit': function UnitUnit(x, y) {
            if (x.value === null || x.value === undefined) throw new Error('Parameter x contains a unit with undefined value');
            if (y.value === null || y.value === undefined) throw new Error('Parameter y contains a unit with undefined value');
            if (!x.equalBase(y)) throw new Error('Units do not match');
            var res = x.clone();
            res.value = this(res.value, y.value);
            res.fixPrefix = false;
            return res;
        }
    });
});

});

parcelRegister("3ZIwJ", function(module, exports) {

$parcel$export(module.exports, "createAnd", () => $2e899bbc7ee7dbe9$export$15a698d88cae0eff);

var $5IUkw = parcelRequire("5IUkw");

var $hXAgg = parcelRequire("hXAgg");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");

var $eIf4a = parcelRequire("eIf4a");

var $4eE2e = parcelRequire("4eE2e");

var $jg11Z = parcelRequire("jg11Z");
var $2e899bbc7ee7dbe9$var$name = 'and';
var $2e899bbc7ee7dbe9$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'zeros',
    'not'
];
var $2e899bbc7ee7dbe9$export$15a698d88cae0eff = /* #__PURE__ */ (0, $4eE2e.factory)($2e899bbc7ee7dbe9$var$name, $2e899bbc7ee7dbe9$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, not: not } = _ref;
    var algorithm02 = (0, $5IUkw.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $eIf4a.createAlgorithm06)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Logical `and`. Test whether two values are both defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.and(x, y)
   *
   * Examples:
   *
   *    math.and(2, 4)   // returns true
   *
   *    a = [2, 0, 0]
   *    b = [3, 7, 0]
   *    c = 0
   *
   *    math.and(a, b)   // returns [true, false, false]
   *    math.and(a, c)   // returns [false, false, false]
   *
   * See also:
   *
   *    not, or, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when both inputs are defined with a nonzero/nonempty value.
   */ return typed($2e899bbc7ee7dbe9$var$name, {
        'number, number': (0, $jg11Z.andNumber),
        'Complex, Complex': function ComplexComplex(x, y) {
            return (x.re !== 0 || x.im !== 0) && (y.re !== 0 || y.im !== 0);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return !x.isZero() && !y.isZero() && !x.isNaN() && !y.isNaN();
        },
        'Unit, Unit': function UnitUnit(x, y) {
            return this(x.value || 0, y.value || 0);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, this, false);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            // check scalar
            if (not(y)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            // check scalar
            if (not(y)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            // check scalar
            if (not(x)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm11(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            // check scalar
            if (not(x)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
});

});
parcelRegister("5IUkw", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm02", () => $42acc1c8bcb611c3$export$92edb534a8f19a37);

var $4eE2e = parcelRequire("4eE2e");

var $iAoVB = parcelRequire("iAoVB");
var $42acc1c8bcb611c3$var$name = 'algorithm02';
var $42acc1c8bcb611c3$var$dependencies = [
    'typed',
    'equalScalar'
];
var $42acc1c8bcb611c3$export$92edb534a8f19a37 = /* #__PURE__ */ (0, $4eE2e.factory)($42acc1c8bcb611c3$var$name, $42acc1c8bcb611c3$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm02(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $iAoVB.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result (SparseMatrix)
        var cvalues = [];
        var cindex = [];
        var cptr = []; // loop columns in b
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k]; // update C(i,j)
                var cij = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]); // check for nonzero
                if (!eq(cij, zero)) {
                    // push i & v
                    cindex.push(i);
                    cvalues.push(cij);
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return sparseMatrix.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("hXAgg", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm11", () => $d1341314d7dcb90a$export$a38279a12199d831);

var $4eE2e = parcelRequire("4eE2e");
var $d1341314d7dcb90a$var$name = 'algorithm11';
var $d1341314d7dcb90a$var$dependencies = [
    'typed',
    'equalScalar'
];
var $d1341314d7dcb90a$export$a38279a12199d831 = /* #__PURE__ */ (0, $4eE2e.factory)($d1341314d7dcb90a$var$name, $d1341314d7dcb90a$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm11(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string') {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = []; // loop columns
        for(var j = 0; j < columns; j++){
            // initialize ptr
            cptr[j] = cindex.length; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = aindex[k]; // invoke callback
                var v = inverse ? cf(b, avalues[k]) : cf(avalues[k], b); // check value is zero
                if (!eq(v, zero)) {
                    // push index & value
                    cindex.push(i);
                    cvalues.push(v);
                }
            }
        } // update ptr
        cptr[columns] = cindex.length; // return sparse matrix
        return s.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("eIf4a", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm06", () => $ab60dc9170085f42$export$d6f401e6f2a7e54b);

var $4eE2e = parcelRequire("4eE2e");

var $iAoVB = parcelRequire("iAoVB");

var $9nwyh = parcelRequire("9nwyh");
var $ab60dc9170085f42$var$name = 'algorithm06';
var $ab60dc9170085f42$var$dependencies = [
    'typed',
    'equalScalar'
];
var $ab60dc9170085f42$export$d6f401e6f2a7e54b = /* #__PURE__ */ (0, $4eE2e.factory)($ab60dc9170085f42$var$name, $ab60dc9170085f42$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked (Anz U Bnz) times, where Anz and Bnz are the nonzero elements in both matrices.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm06(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $iAoVB.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var x = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var w = []; // marks indicating value in a given row has been updated
        var u = []; // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // scatter the values of A(:,j) into workspace
            (0, $9nwyh.scatter)(a, j, w, x, u, mark, cindex, cf); // scatter the values of B(:,j) into workspace
            (0, $9nwyh.scatter)(b, j, w, x, u, mark, cindex, cf); // check we need to process values (non pattern matrix)
            if (x) {
                // initialize first index in j
                var k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    var i = cindex[k]; // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[i] === mark) {
                        // value @ i
                        var v = x[i]; // check for zero value
                        if (!eq(v, zero)) {
                            // push value
                            cvalues.push(v); // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    } else // remove value @ i, do not increment pointer
                    cindex.splice(k, 1);
                }
            } else {
                // initialize first index in j
                var p = cptr[j]; // loop index in j
                while(p < cindex.length){
                    // row
                    var r = cindex[p]; // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[r] !== mark) // remove value @ i, do not increment pointer
                    cindex.splice(p, 1);
                    else // increment pointer
                    p++;
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("jg11Z", function(module, exports) {

$parcel$export(module.exports, "notNumber", () => $e0504fadc743505e$export$5c3e9fce4e8f3d3a);
$parcel$export(module.exports, "orNumber", () => $e0504fadc743505e$export$cb9e31d07eec8012);
$parcel$export(module.exports, "xorNumber", () => $e0504fadc743505e$export$17cc7dc3a74df3af);
$parcel$export(module.exports, "andNumber", () => $e0504fadc743505e$export$11dffb061e00e795);
var $e0504fadc743505e$var$n1 = 'number';
var $e0504fadc743505e$var$n2 = 'number, number';
function $e0504fadc743505e$export$5c3e9fce4e8f3d3a(x) {
    return !x;
}
$e0504fadc743505e$export$5c3e9fce4e8f3d3a.signature = $e0504fadc743505e$var$n1;
function $e0504fadc743505e$export$cb9e31d07eec8012(x, y) {
    return !!(x || y);
}
$e0504fadc743505e$export$cb9e31d07eec8012.signature = $e0504fadc743505e$var$n2;
function $e0504fadc743505e$export$17cc7dc3a74df3af(x, y) {
    return !!x !== !!y;
}
$e0504fadc743505e$export$17cc7dc3a74df3af.signature = $e0504fadc743505e$var$n2;
function $e0504fadc743505e$export$11dffb061e00e795(x, y) {
    return !!(x && y);
}
$e0504fadc743505e$export$11dffb061e00e795.signature = $e0504fadc743505e$var$n2;

});


parcelRegister("irWpb", function(module, exports) {

$parcel$export(module.exports, "createApply", () => $d6e80dafe74bf551$export$5ccffa1686df7f00);

var $4eE2e = parcelRequire("4eE2e");

var $10UPF = parcelRequire("10UPF");

var $gs7TF = parcelRequire("gs7TF");

var $9juUc = parcelRequire("9juUc");
var $d6e80dafe74bf551$var$name = 'apply';
var $d6e80dafe74bf551$var$dependencies = [
    'typed',
    'isInteger'
];
var $d6e80dafe74bf551$export$5ccffa1686df7f00 = /* #__PURE__ */ (0, $4eE2e.factory)($d6e80dafe74bf551$var$name, $d6e80dafe74bf551$var$dependencies, (_ref)=>{
    var { typed: typed, isInteger: isInteger } = _ref;
    /**
   * Apply a function that maps an array to a scalar
   * along a given axis of a matrix or array.
   * Returns a new matrix or array with one less dimension than the input.
   *
   * Syntax:
   *
   *     math.apply(A, dim, callback)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [3, 4]]
   *    const sum = math.sum
   *
   *    math.apply(A, 0, sum)             // returns [4, 6]
   *    math.apply(A, 1, sum)             // returns [3, 7]
   *
   * See also:
   *
   *    map, filter, forEach
   *
   * @param {Array | Matrix} array   The input Matrix
   * @param {number} dim             The dimension along which the callback is applied
   * @param {Function} callback      The callback function that is applied. This Function
   *                                 should take an array or 1-d matrix as an input and
   *                                 return a number.
   * @return {Array | Matrix} res    The residual matrix with the function applied over some dimension.
   */ return typed($d6e80dafe74bf551$var$name, {
        'Array | Matrix, number | BigNumber, function': function ArrayMatrixNumberBigNumberFunction(mat, dim, callback) {
            if (!isInteger(dim)) throw new TypeError('Integer number expected for dimension');
            var size = Array.isArray(mat) ? (0, $10UPF.arraySize)(mat) : mat.size();
            if (dim < 0 || dim >= size.length) throw new (0, $9juUc.IndexError)(dim, size.length);
            if ((0, $gs7TF.isMatrix)(mat)) return mat.create($d6e80dafe74bf551$var$_apply(mat.valueOf(), dim, callback));
            else return $d6e80dafe74bf551$var$_apply(mat, dim, callback);
        }
    });
});
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $d6e80dafe74bf551$var$_apply(mat, dim, callback) {
    var i, ret, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) return callback(mat);
        else {
            tran = $d6e80dafe74bf551$var$_switch(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $d6e80dafe74bf551$var$_apply(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $d6e80dafe74bf551$var$_apply(mat[i], dim - 1, callback);
        return ret;
    }
}
/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $d6e80dafe74bf551$var$_switch(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
}

});

parcelRegister("dz2Xh", function(module, exports) {

$parcel$export(module.exports, "createArg", () => $9e00d60ee3547080$export$bde3dabbd4699a93);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $9e00d60ee3547080$var$name = 'arg';
var $9e00d60ee3547080$var$dependencies = [
    'typed'
];
var $9e00d60ee3547080$export$bde3dabbd4699a93 = /* #__PURE__ */ (0, $4eE2e.factory)($9e00d60ee3547080$var$name, $9e00d60ee3547080$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the argument of a complex value.
   * For a complex number `a + bi`, the argument is computed as `atan2(b, a)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.arg(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 2)
   *    math.arg(a) / math.pi          // returns number 0.25
   *
   *    const b = math.complex('2 + 3i')
   *    math.arg(b)                    // returns number 0.982793723247329
   *    math.atan2(3, 2)               // returns number 0.982793723247329
   *
   * See also:
   *
   *    re, im, conj, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The argument of x
   */ return typed($9e00d60ee3547080$var$name, {
        number: function number(x) {
            return Math.atan2(0, x);
        },
        BigNumber: function BigNumber(x) {
            return x.constructor.atan2(0, x);
        },
        Complex: function Complex(x) {
            return x.arg();
        },
        // TODO: implement BigNumber support for function arg
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("aiRWv", function(module, exports) {

$parcel$export(module.exports, "createAsec", () => $78056dbbcfa8acd6$export$e1f28fc7c94f90b0);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $78056dbbcfa8acd6$var$name = 'asec';
var $78056dbbcfa8acd6$var$dependencies = [
    'typed',
    'config',
    'Complex',
    'BigNumber'
];
var $78056dbbcfa8acd6$export$e1f28fc7c94f90b0 = /* #__PURE__ */ (0, $4eE2e.factory)($78056dbbcfa8acd6$var$name, $78056dbbcfa8acd6$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse secant of a value. Defined as `asec(x) = acos(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asec(x)
   *
   * Examples:
   *
   *    math.asec(0.5)           // returns 1.0471975511965979
   *    math.asec(math.sec(1.5)) // returns 1.5
   *
   *    math.asec(2)             // returns 0 + 1.3169578969248166 i
   *
   * See also:
   *
   *    acos, acot, acsc
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} The arc secant of x
   */ return typed($78056dbbcfa8acd6$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $fkvqw.asecNumber)(x);
            return new Complex(x, 0).asec();
        },
        Complex: function Complex(x) {
            return x.asec();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acos();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("bNlle", function(module, exports) {

$parcel$export(module.exports, "createAsech", () => $8964d34b39f4606b$export$8eeff5f09afe95bc);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $8964d34b39f4606b$var$name = 'asech';
var $8964d34b39f4606b$var$dependencies = [
    'typed',
    'config',
    'Complex',
    'BigNumber'
];
var $8964d34b39f4606b$export$8eeff5f09afe95bc = /* #__PURE__ */ (0, $4eE2e.factory)($8964d34b39f4606b$var$name, $8964d34b39f4606b$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arcsecant of a value,
   * defined as `asech(x) = acosh(1/x) = ln(sqrt(1/x^2 - 1) + 1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asech(x)
   *
   * Examples:
   *
   *    math.asech(0.5)       // returns 1.3169578969248166
   *
   * See also:
   *
   *    acsch, acoth
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arcsecant of x
   */ return typed($8964d34b39f4606b$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) {
                var xInv = 1 / x;
                if (xInv > 0 || config.predictable) return (0, $fkvqw.asechNumber)(x);
                var ret = Math.sqrt(xInv * xInv - 1);
                return new Complex(Math.log(ret - xInv), Math.PI);
            }
            return new Complex(x, 0).asech();
        },
        Complex: function Complex(x) {
            return x.asech();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acosh();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("6TUWD", function(module, exports) {

$parcel$export(module.exports, "createAsin", () => $50640d2df1ce3a18$export$5f05d91ddc56bc14);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $50640d2df1ce3a18$var$name = 'asin';
var $50640d2df1ce3a18$var$dependencies = [
    'typed',
    'config',
    'Complex'
];
var $50640d2df1ce3a18$export$5f05d91ddc56bc14 = /* #__PURE__ */ (0, $4eE2e.factory)($50640d2df1ce3a18$var$name, $50640d2df1ce3a18$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the inverse sine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asin(x)
   *
   * Examples:
   *
   *    math.asin(0.5)           // returns number 0.5235987755982989
   *    math.asin(math.sin(1.5)) // returns number ~1.5
   *
   *    math.asin(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    sin, atan, acos
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc sine of x
   */ return typed($50640d2df1ce3a18$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.asin(x);
            else return new Complex(x, 0).asin();
        },
        Complex: function Complex(x) {
            return x.asin();
        },
        BigNumber: function BigNumber(x) {
            return x.asin();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since asin(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        }
    });
});

});

parcelRegister("hwGg6", function(module, exports) {

$parcel$export(module.exports, "createAsinh", () => $cc2634863480c03c$export$7278bb4e3c84d46a);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $cc2634863480c03c$var$name = 'asinh';
var $cc2634863480c03c$var$dependencies = [
    'typed'
];
var $cc2634863480c03c$export$7278bb4e3c84d46a = /* #__PURE__ */ (0, $4eE2e.factory)($cc2634863480c03c$var$name, $cc2634863480c03c$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic arcsine of a value,
   * defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asinh(x)
   *
   * Examples:
   *
   *    math.asinh(0.5)       // returns 0.48121182505960347
   *
   * See also:
   *
   *    acosh, atanh
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arcsine of x
   */ return typed('asinh', {
        number: (0, $fkvqw.asinhNumber),
        Complex: function Complex(x) {
            return x.asinh();
        },
        BigNumber: function BigNumber(x) {
            return x.asinh();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since asinh(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        }
    });
});

});

parcelRegister("1evUW", function(module, exports) {

$parcel$export(module.exports, "createAtan", () => $0e5fdb62d2c496b3$export$b87f3a3301a24256);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $0e5fdb62d2c496b3$var$name = 'atan';
var $0e5fdb62d2c496b3$var$dependencies = [
    'typed'
];
var $0e5fdb62d2c496b3$export$b87f3a3301a24256 = /* #__PURE__ */ (0, $4eE2e.factory)($0e5fdb62d2c496b3$var$name, $0e5fdb62d2c496b3$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the inverse tangent of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atan(x)
   *
   * Examples:
   *
   *    math.atan(0.5)           // returns number 0.4636476090008061
   *    math.atan(math.tan(1.5)) // returns number 1.5
   *
   *    math.atan(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    tan, asin, acos
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc tangent of x
   */ return typed('atan', {
        number: function number(x) {
            return Math.atan(x);
        },
        Complex: function Complex(x) {
            return x.atan();
        },
        BigNumber: function BigNumber(x) {
            return x.atan();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since atan(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        }
    });
});

});

parcelRegister("juxrq", function(module, exports) {

$parcel$export(module.exports, "createAtan2", () => $e30ac2712fdbbe08$export$c56716e11a38354e);

var $4eE2e = parcelRequire("4eE2e");

var $5IUkw = parcelRequire("5IUkw");

var $6MKpt = parcelRequire("6MKpt");

var $ejwmL = parcelRequire("ejwmL");

var $hXAgg = parcelRequire("hXAgg");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");
var $e30ac2712fdbbe08$var$name = 'atan2';
var $e30ac2712fdbbe08$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'BigNumber',
    'DenseMatrix'
];
var $e30ac2712fdbbe08$export$c56716e11a38354e = /* #__PURE__ */ (0, $4eE2e.factory)($e30ac2712fdbbe08$var$name, $e30ac2712fdbbe08$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: BigNumber, DenseMatrix: DenseMatrix } = _ref;
    var algorithm02 = (0, $5IUkw.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm09 = (0, $ejwmL.createAlgorithm09)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculate the inverse tangent function with two arguments, y/x.
   * By providing two arguments, the right quadrant of the computed angle can be
   * determined.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atan2(y, x)
   *
   * Examples:
   *
   *    math.atan2(2, 2) / math.pi       // returns number 0.25
   *
   *    const angle = math.unit(60, 'deg') // returns Unit 60 deg
   *    const x = math.cos(angle)
   *    const y = math.sin(angle)
   *
   *    math.atan(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    tan, atan, sin, cos
   *
   * @param {number | Array | Matrix} y  Second dimension
   * @param {number | Array | Matrix} x  First dimension
   * @return {number | Array | Matrix} Four-quadrant inverse tangent
   */ return typed($e30ac2712fdbbe08$var$name, {
        'number, number': Math.atan2,
        // Complex numbers doesn't seem to have a reasonable implementation of
        // atan2(). Even Matlab removed the support, after they only calculated
        // the atan only on base of the real part of the numbers and ignored the imaginary.
        'BigNumber, BigNumber': function BigNumberBigNumber(y, x) {
            return BigNumber.atan2(y, x);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm09(x, y, this, false);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            // mind the order of y and x!
            return algorithm02(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            return this(x, matrix(y));
        },
        'SparseMatrix, number | BigNumber': function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, number | BigNumber': function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        'number | BigNumber, SparseMatrix': function numberBigNumberSparseMatrix(x, y) {
            // mind the order of y and x
            return algorithm12(y, x, this, true);
        },
        'number | BigNumber, DenseMatrix': function numberBigNumberDenseMatrix(x, y) {
            // mind the order of y and x
            return algorithm14(y, x, this, true);
        },
        'Array, number | BigNumber': function ArrayNumberBigNumber(x, y) {
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'number | BigNumber, Array': function numberBigNumberArray(x, y) {
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});

});
parcelRegister("6MKpt", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm03", () => $4f0b39caa0c13fa5$export$486bb900f1a3c833);

var $4eE2e = parcelRequire("4eE2e");

var $iAoVB = parcelRequire("iAoVB");
var $4f0b39caa0c13fa5$var$name = 'algorithm03';
var $4f0b39caa0c13fa5$var$dependencies = [
    'typed'
];
var $4f0b39caa0c13fa5$export$486bb900f1a3c833 = /* #__PURE__ */ (0, $4eE2e.factory)($4f0b39caa0c13fa5$var$name, $4f0b39caa0c13fa5$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over SparseMatrix items and invokes the callback function f(Dij, Sij).
   * Callback function invoked M*N times.
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(Dij, 0)    ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (C)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm03(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $iAoVB.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result (DenseMatrix)
        var cdata = []; // initialize dense matrix
        for(var z = 0; z < rows; z++)// initialize row
        cdata[z] = [];
         // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns in b
        for(var j = 0; j < columns; j++){
            // column mark
            var mark = j + 1; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k]; // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
                w[i] = mark;
            } // process workspace
            for(var y = 0; y < rows; y++)// check we have a calculated value for current row
            if (w[y] === mark) // use calculated value
            cdata[y][j] = x[y];
            else // calculate value
            cdata[y][j] = inverse ? cf(zero, adata[y][j]) : cf(adata[y][j], zero);
        } // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("ejwmL", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm09", () => $a6bbf2463d802162$export$c769437575b0fcdd);

var $4eE2e = parcelRequire("4eE2e");

var $iAoVB = parcelRequire("iAoVB");
var $a6bbf2463d802162$var$name = 'algorithm09';
var $a6bbf2463d802162$var$dependencies = [
    'typed',
    'equalScalar'
];
var $a6bbf2463d802162$export$c769437575b0fcdd = /* #__PURE__ */ (0, $4eE2e.factory)($a6bbf2463d802162$var$name, $a6bbf2463d802162$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and invokes the callback function f(Aij, Bij).
   * Callback function invoked NZA times, number of nonzero elements in A.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm09(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $iAoVB.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var x = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var w = []; // vars
        var i, j, k, k0, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // column mark
            var mark = j + 1; // check we need to process values
            if (x) // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // update workspace
                w[i] = mark;
                x[i] = bvalues[k];
            }
             // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // check we need to process values
                if (x) {
                    // b value @ i,j
                    var vb = w[i] === mark ? x[i] : zero; // invoke f
                    var vc = cf(avalues[k], vb); // check zero value
                    if (!eq(vc, zero)) {
                        // push index
                        cindex.push(i); // push value
                        cvalues.push(vc);
                    }
                } else // push index
                cindex.push(i);
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});

parcelRegister("6Q1Sk", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm12", () => $4fa90dca1374c2e0$export$806772cd23b603dc);

var $4eE2e = parcelRequire("4eE2e");
var $4fa90dca1374c2e0$var$name = 'algorithm12';
var $4fa90dca1374c2e0$var$dependencies = [
    'typed',
    'DenseMatrix'
];
var $4fa90dca1374c2e0$export$806772cd23b603dc = /* #__PURE__ */ (0, $4eE2e.factory)($4fa90dca1374c2e0$var$name, $4fa90dca1374c2e0$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked MxN times.
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(0, b)    ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm12(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string') {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cdata = []; // workspaces
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k]; // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            } // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                 // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = inverse ? cf(b, 0) : cf(0, b);
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});


parcelRegister("WMtdB", function(module, exports) {

$parcel$export(module.exports, "createAtanh", () => $0b0b04144aee834a$export$c2dbbeab1e5e6195);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $0b0b04144aee834a$var$name = 'atanh';
var $0b0b04144aee834a$var$dependencies = [
    'typed',
    'config',
    'Complex'
];
var $0b0b04144aee834a$export$c2dbbeab1e5e6195 = /* #__PURE__ */ (0, $4eE2e.factory)($0b0b04144aee834a$var$name, $0b0b04144aee834a$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the hyperbolic arctangent of a value,
   * defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atanh(x)
   *
   * Examples:
   *
   *    math.atanh(0.5)       // returns 0.5493061443340549
   *
   * See also:
   *
   *    acosh, asinh
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arctangent of x
   */ return typed($0b0b04144aee834a$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) return (0, $fkvqw.atanhNumber)(x);
            return new Complex(x, 0).atanh();
        },
        Complex: function Complex(x) {
            return x.atanh();
        },
        BigNumber: function BigNumber(x) {
            return x.atanh();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since atanh(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        }
    });
});

});

parcelRegister("bfQdA", function(module, exports) {

$parcel$export(module.exports, "createSpeedOfLight", () => $831999d8defca460$export$ace78258608300fc);
$parcel$export(module.exports, "createGravitationConstant", () => $831999d8defca460$export$157e78cb05354391);
$parcel$export(module.exports, "createPlanckConstant", () => $831999d8defca460$export$e58ff8150d83ea6a);
$parcel$export(module.exports, "createReducedPlanckConstant", () => $831999d8defca460$export$50bee65ab76b402);
$parcel$export(module.exports, "createMagneticConstant", () => $831999d8defca460$export$e7fcb8898ecb0703);
$parcel$export(module.exports, "createElectricConstant", () => $831999d8defca460$export$d69030cf93f04407);
$parcel$export(module.exports, "createVacuumImpedance", () => $831999d8defca460$export$c9ff08d282f03cf0);
$parcel$export(module.exports, "createCoulomb", () => $831999d8defca460$export$815f2029cd62d0d6);
$parcel$export(module.exports, "createElementaryCharge", () => $831999d8defca460$export$542715ad7e3a9798);
$parcel$export(module.exports, "createBohrMagneton", () => $831999d8defca460$export$f5851397fd1173db);
$parcel$export(module.exports, "createConductanceQuantum", () => $831999d8defca460$export$e26bbd27fc291ddf);
$parcel$export(module.exports, "createInverseConductanceQuantum", () => $831999d8defca460$export$f2f136373157165b);
$parcel$export(module.exports, "createMagneticFluxQuantum", () => $831999d8defca460$export$fd46b6c8680e4d01);
$parcel$export(module.exports, "createNuclearMagneton", () => $831999d8defca460$export$9670d94122b9a81b);
$parcel$export(module.exports, "createKlitzing", () => $831999d8defca460$export$e3f21ac13bee6a0f);
$parcel$export(module.exports, "createBohrRadius", () => $831999d8defca460$export$19b72356ad84e4ee);
$parcel$export(module.exports, "createClassicalElectronRadius", () => $831999d8defca460$export$68a9771dccce9a23);
$parcel$export(module.exports, "createElectronMass", () => $831999d8defca460$export$85362d2a7862e209);
$parcel$export(module.exports, "createFermiCoupling", () => $831999d8defca460$export$b6687a2f3911256b);
$parcel$export(module.exports, "createFineStructure", () => $831999d8defca460$export$aaddb59a993d3ac4);
$parcel$export(module.exports, "createHartreeEnergy", () => $831999d8defca460$export$8bb818baeaa40bd6);
$parcel$export(module.exports, "createProtonMass", () => $831999d8defca460$export$f357c1a8d4fccef6);
$parcel$export(module.exports, "createDeuteronMass", () => $831999d8defca460$export$a403f6c5bed71f22);
$parcel$export(module.exports, "createNeutronMass", () => $831999d8defca460$export$676d5ebe8fbeb250);
$parcel$export(module.exports, "createQuantumOfCirculation", () => $831999d8defca460$export$6840f334b8a5b6b1);
$parcel$export(module.exports, "createRydberg", () => $831999d8defca460$export$fd1b48ecb0d5c0ef);
$parcel$export(module.exports, "createThomsonCrossSection", () => $831999d8defca460$export$229739a879741f68);
$parcel$export(module.exports, "createWeakMixingAngle", () => $831999d8defca460$export$fa2d42c5c25c1883);
$parcel$export(module.exports, "createEfimovFactor", () => $831999d8defca460$export$55fc8769b037d266);
$parcel$export(module.exports, "createAtomicMass", () => $831999d8defca460$export$2f8d2da219209d0a);
$parcel$export(module.exports, "createAvogadro", () => $831999d8defca460$export$4924e3d8de6ad850);
$parcel$export(module.exports, "createBoltzmann", () => $831999d8defca460$export$221b7a8c9510b6cc);
$parcel$export(module.exports, "createFaraday", () => $831999d8defca460$export$17ef8d738c9b0091);
$parcel$export(module.exports, "createFirstRadiation", () => $831999d8defca460$export$266a9bae8a62fb6e);
$parcel$export(module.exports, "createLoschmidt", () => $831999d8defca460$export$c38bce537e0ffddb);
$parcel$export(module.exports, "createGasConstant", () => $831999d8defca460$export$85a77a0842c24f74);
$parcel$export(module.exports, "createMolarPlanckConstant", () => $831999d8defca460$export$12e2358797b853c9);
$parcel$export(module.exports, "createMolarVolume", () => $831999d8defca460$export$f5e8f56ebfacbaca);
$parcel$export(module.exports, "createSackurTetrode", () => $831999d8defca460$export$467c65d9dfc3d3a2);
$parcel$export(module.exports, "createSecondRadiation", () => $831999d8defca460$export$ea93a35a6f35e1b6);
$parcel$export(module.exports, "createStefanBoltzmann", () => $831999d8defca460$export$a943525a62f69cd2);
$parcel$export(module.exports, "createWienDisplacement", () => $831999d8defca460$export$3c74568e9574d168);
$parcel$export(module.exports, "createMolarMass", () => $831999d8defca460$export$85414d775c93e6de);
$parcel$export(module.exports, "createMolarMassC12", () => $831999d8defca460$export$d5045cf71611a462);
$parcel$export(module.exports, "createGravity", () => $831999d8defca460$export$42b5845f95e0feee);
$parcel$export(module.exports, "createPlanckLength", () => $831999d8defca460$export$675ebbcd6bdcebd7);
$parcel$export(module.exports, "createPlanckMass", () => $831999d8defca460$export$d44b96c94520b20e);
$parcel$export(module.exports, "createPlanckTime", () => $831999d8defca460$export$3bf63d7b96fd8541);
$parcel$export(module.exports, "createPlanckCharge", () => $831999d8defca460$export$43e139a6eec1ab59);
$parcel$export(module.exports, "createPlanckTemperature", () => $831999d8defca460$export$d21f20fc89fac8c0);

var $4eE2e = parcelRequire("4eE2e");
var $831999d8defca460$export$ace78258608300fc = /* #__PURE__ */ $831999d8defca460$var$unitFactory('speedOfLight', '299792458', 'm s^-1');
var $831999d8defca460$export$157e78cb05354391 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('gravitationConstant', '6.67430e-11', 'm^3 kg^-1 s^-2');
var $831999d8defca460$export$e58ff8150d83ea6a = /* #__PURE__ */ $831999d8defca460$var$unitFactory('planckConstant', '6.62607015e-34', 'J s');
var $831999d8defca460$export$50bee65ab76b402 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('reducedPlanckConstant', '1.0545718176461565e-34', 'J s'); // Electromagnetic constants
var $831999d8defca460$export$e7fcb8898ecb0703 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('magneticConstant', '1.25663706212e-6', 'N A^-2');
var $831999d8defca460$export$d69030cf93f04407 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('electricConstant', '8.8541878128e-12', 'F m^-1');
var $831999d8defca460$export$c9ff08d282f03cf0 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('vacuumImpedance', '376.730313667', 'ohm');
var $831999d8defca460$export$815f2029cd62d0d6 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('coulomb', '8.987551792261171e9', 'N m^2 C^-2');
var $831999d8defca460$export$542715ad7e3a9798 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('elementaryCharge', '1.602176634e-19', 'C');
var $831999d8defca460$export$f5851397fd1173db = /* #__PURE__ */ $831999d8defca460$var$unitFactory('bohrMagneton', '9.2740100783e-24', 'J T^-1');
var $831999d8defca460$export$e26bbd27fc291ddf = /* #__PURE__ */ $831999d8defca460$var$unitFactory('conductanceQuantum', '7.748091729863649e-5', 'S');
var $831999d8defca460$export$f2f136373157165b = /* #__PURE__ */ $831999d8defca460$var$unitFactory('inverseConductanceQuantum', '12906.403729652257', 'ohm');
var $831999d8defca460$export$fd46b6c8680e4d01 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('magneticFluxQuantum', '2.0678338484619295e-15', 'Wb');
var $831999d8defca460$export$9670d94122b9a81b = /* #__PURE__ */ $831999d8defca460$var$unitFactory('nuclearMagneton', '5.0507837461e-27', 'J T^-1');
var $831999d8defca460$export$e3f21ac13bee6a0f = /* #__PURE__ */ $831999d8defca460$var$unitFactory('klitzing', '25812.807459304513', 'ohm');
var $831999d8defca460$export$c090909964c68de4 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('josephson', '4.835978484169836e14 Hz V', 'Hz V^-1'); // TODO: support for Hz needed
var $831999d8defca460$export$19b72356ad84e4ee = /* #__PURE__ */ $831999d8defca460$var$unitFactory('bohrRadius', '5.29177210903e-11', 'm');
var $831999d8defca460$export$68a9771dccce9a23 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('classicalElectronRadius', '2.8179403262e-15', 'm');
var $831999d8defca460$export$85362d2a7862e209 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('electronMass', '9.1093837015e-31', 'kg');
var $831999d8defca460$export$b6687a2f3911256b = /* #__PURE__ */ $831999d8defca460$var$unitFactory('fermiCoupling', '1.1663787e-5', 'GeV^-2');
var $831999d8defca460$export$aaddb59a993d3ac4 = $831999d8defca460$var$numberFactory('fineStructure', 7.2973525693e-3);
var $831999d8defca460$export$8bb818baeaa40bd6 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('hartreeEnergy', '4.3597447222071e-18', 'J');
var $831999d8defca460$export$f357c1a8d4fccef6 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('protonMass', '1.67262192369e-27', 'kg');
var $831999d8defca460$export$a403f6c5bed71f22 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('deuteronMass', '3.3435830926e-27', 'kg');
var $831999d8defca460$export$676d5ebe8fbeb250 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('neutronMass', '1.6749271613e-27', 'kg');
var $831999d8defca460$export$6840f334b8a5b6b1 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('quantumOfCirculation', '3.6369475516e-4', 'm^2 s^-1');
var $831999d8defca460$export$fd1b48ecb0d5c0ef = /* #__PURE__ */ $831999d8defca460$var$unitFactory('rydberg', '10973731.568160', 'm^-1');
var $831999d8defca460$export$229739a879741f68 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('thomsonCrossSection', '6.6524587321e-29', 'm^2');
var $831999d8defca460$export$fa2d42c5c25c1883 = $831999d8defca460$var$numberFactory('weakMixingAngle', 0.22290);
var $831999d8defca460$export$55fc8769b037d266 = $831999d8defca460$var$numberFactory('efimovFactor', 22.7); // Physico-chemical constants
var $831999d8defca460$export$2f8d2da219209d0a = /* #__PURE__ */ $831999d8defca460$var$unitFactory('atomicMass', '1.66053906660e-27', 'kg');
var $831999d8defca460$export$4924e3d8de6ad850 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('avogadro', '6.02214076e23', 'mol^-1');
var $831999d8defca460$export$221b7a8c9510b6cc = /* #__PURE__ */ $831999d8defca460$var$unitFactory('boltzmann', '1.380649e-23', 'J K^-1');
var $831999d8defca460$export$17ef8d738c9b0091 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('faraday', '96485.33212331001', 'C mol^-1');
var $831999d8defca460$export$266a9bae8a62fb6e = /* #__PURE__ */ $831999d8defca460$var$unitFactory('firstRadiation', '3.7417718521927573e-16', 'W m^2'); // export const createSpectralRadiance = /* #__PURE__ */ unitFactory('spectralRadiance', '1.1910429723971881e-16', 'W m^2 sr^-1') // TODO spectralRadiance
var $831999d8defca460$export$c38bce537e0ffddb = /* #__PURE__ */ $831999d8defca460$var$unitFactory('loschmidt', '2.686780111798444e25', 'm^-3');
var $831999d8defca460$export$85a77a0842c24f74 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('gasConstant', '8.31446261815324', 'J K^-1 mol^-1');
var $831999d8defca460$export$12e2358797b853c9 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('molarPlanckConstant', '3.990312712893431e-10', 'J s mol^-1');
var $831999d8defca460$export$f5e8f56ebfacbaca = /* #__PURE__ */ $831999d8defca460$var$unitFactory('molarVolume', '0.022413969545014137', 'm^3 mol^-1');
var $831999d8defca460$export$467c65d9dfc3d3a2 = $831999d8defca460$var$numberFactory('sackurTetrode', -1.16487052358);
var $831999d8defca460$export$ea93a35a6f35e1b6 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('secondRadiation', '0.014387768775039337', 'm K');
var $831999d8defca460$export$a943525a62f69cd2 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('stefanBoltzmann', '5.67037441918443e-8', 'W m^-2 K^-4');
var $831999d8defca460$export$3c74568e9574d168 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('wienDisplacement', '2.897771955e-3', 'm K'); // Adopted values
var $831999d8defca460$export$85414d775c93e6de = /* #__PURE__ */ $831999d8defca460$var$unitFactory('molarMass', '0.99999999965e-3', 'kg mol^-1');
var $831999d8defca460$export$d5045cf71611a462 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('molarMassC12', '11.9999999958e-3', 'kg mol^-1');
var $831999d8defca460$export$42b5845f95e0feee = /* #__PURE__ */ $831999d8defca460$var$unitFactory('gravity', '9.80665', 'm s^-2'); // atm is defined in Unit.js
var $831999d8defca460$export$675ebbcd6bdcebd7 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('planckLength', '1.616255e-35', 'm');
var $831999d8defca460$export$d44b96c94520b20e = /* #__PURE__ */ $831999d8defca460$var$unitFactory('planckMass', '2.176435e-8', 'kg');
var $831999d8defca460$export$3bf63d7b96fd8541 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('planckTime', '5.391245e-44', 's');
var $831999d8defca460$export$43e139a6eec1ab59 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('planckCharge', '1.87554603778e-18', 'C');
var $831999d8defca460$export$d21f20fc89fac8c0 = /* #__PURE__ */ $831999d8defca460$var$unitFactory('planckTemperature', '1.416785e+32', 'K'); // helper function to create a factory function which creates a physical constant,
// a Unit with either a number value or a BigNumber value depending on the configuration
function $831999d8defca460$var$unitFactory(name, valueStr, unitStr) {
    var dependencies = [
        'config',
        'Unit',
        'BigNumber'
    ];
    return (0, $4eE2e.factory)(name, dependencies, (_ref)=>{
        var { config: config, Unit: Unit, BigNumber: BigNumber } = _ref;
        // Note that we can parse into number or BigNumber.
        // We do not parse into Fractions as that doesn't make sense: we would lose precision of the values
        // Therefore we dont use Unit.parse()
        var value = config.number === 'BigNumber' ? new BigNumber(valueStr) : parseFloat(valueStr);
        var unit = new Unit(value, unitStr);
        unit.fixPrefix = true;
        return unit;
    });
} // helper function to create a factory function which creates a numeric constant,
// either a number or BigNumber depending on the configuration
function $831999d8defca460$var$numberFactory(name, value) {
    var dependencies = [
        'config',
        'BigNumber'
    ];
    return (0, $4eE2e.factory)(name, dependencies, (_ref2)=>{
        var { config: config, BigNumber: BigNumber } = _ref2;
        return config.number === 'BigNumber' ? new BigNumber(value) : value;
    });
}

});

parcelRegister("6Gx92", function(module, exports) {

$parcel$export(module.exports, "createBellNumbers", () => $4de06034e0859f0b$export$7b7dc3bd00d38afb);

var $4eE2e = parcelRequire("4eE2e");
var $4de06034e0859f0b$var$name = 'bellNumbers';
var $4de06034e0859f0b$var$dependencies = [
    'typed',
    'addScalar',
    'isNegative',
    'isInteger',
    'stirlingS2'
];
var $4de06034e0859f0b$export$7b7dc3bd00d38afb = /* #__PURE__ */ (0, $4eE2e.factory)($4de06034e0859f0b$var$name, $4de06034e0859f0b$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, isNegative: isNegative, isInteger: isInteger, stirlingS2: stirlingS2 } = _ref;
    /**
   * The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S.
   * bellNumbers only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.bellNumbers(n)
   *
   * Examples:
   *
   *    math.bellNumbers(3) // returns 5
   *    math.bellNumbers(8) // returns 4140
   *
   * See also:
   *
   *    stirlingS2
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @return {Number | BigNumber}     B(n)
   */ return typed($4de06034e0859f0b$var$name, {
        'number | BigNumber': function numberBigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError('Non-negative integer value expected in function bellNumbers');
             // Sum (k=0, n) S(n,k).
            var result = 0;
            for(var i = 0; i <= n; i++)result = addScalar(result, stirlingS2(n, i));
            return result;
        }
    });
});

});

parcelRegister("iLb2J", function(module, exports) {

$parcel$export(module.exports, "createBignumber", () => $da852eae4f257ba2$export$1c955ee1b8a97877);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $da852eae4f257ba2$var$name = 'bignumber';
var $da852eae4f257ba2$var$dependencies = [
    'typed',
    'BigNumber'
];
var $da852eae4f257ba2$export$1c955ee1b8a97877 = /* #__PURE__ */ (0, $4eE2e.factory)($da852eae4f257ba2$var$name, $da852eae4f257ba2$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: BigNumber } = _ref;
    /**
   * Create a BigNumber, which can store numbers with arbitrary precision.
   * When a matrix is provided, all elements will be converted to BigNumber.
   *
   * Syntax:
   *
   *    math.bignumber(x)
   *
   * Examples:
   *
   *    0.1 + 0.2                                  // returns number 0.30000000000000004
   *    math.bignumber(0.1) + math.bignumber(0.2)  // returns BigNumber 0.3
   *
   *
   *    7.2e500                                    // returns number Infinity
   *    math.bignumber('7.2e500')                  // returns BigNumber 7.2e500
   *
   * See also:
   *
   *    boolean, complex, index, matrix, string, unit
   *
   * @param {number | string | Fraction | BigNumber | Array | Matrix | boolean | null} [value]  Value for the big number,
   *                                                    0 by default.
   * @returns {BigNumber} The created bignumber
   */ return typed('bignumber', {
        '': function _() {
            return new BigNumber(0);
        },
        number: function number(x) {
            // convert to string to prevent errors in case of >15 digits
            return new BigNumber(x + '');
        },
        string: function string(x) {
            var wordSizeSuffixMatch = x.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
            if (wordSizeSuffixMatch) {
                // x has a word size suffix
                var size = wordSizeSuffixMatch[2];
                var n = BigNumber(wordSizeSuffixMatch[1]);
                var twoPowSize = new BigNumber(2).pow(Number(size));
                if (n.gt(twoPowSize.sub(1))) throw new SyntaxError("String \"".concat(x, "\" is out of range"));
                var twoPowSizeSubOne = new BigNumber(2).pow(Number(size) - 1);
                if (n.gte(twoPowSizeSubOne)) return n.sub(twoPowSize);
                else return n;
            }
            return new BigNumber(x);
        },
        BigNumber: function BigNumber(x) {
            // we assume a BigNumber is immutable
            return x;
        },
        Fraction: function Fraction(x) {
            return new BigNumber(x.n).div(x.d).times(x.s);
        },
        null: function _null(x) {
            return new BigNumber(0);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("9Or3F", function(module, exports) {

$parcel$export(module.exports, "createBigNumberClass", () => $724dc5c1e1d8b6e7$export$234de8d4231bfea3);

var $5Pv9S = parcelRequire("5Pv9S");

var $4eE2e = parcelRequire("4eE2e");
var $724dc5c1e1d8b6e7$var$name = 'BigNumber';
var $724dc5c1e1d8b6e7$var$dependencies = [
    '?on',
    'config'
];
var $724dc5c1e1d8b6e7$export$234de8d4231bfea3 = /* #__PURE__ */ (0, $4eE2e.factory)($724dc5c1e1d8b6e7$var$name, $724dc5c1e1d8b6e7$var$dependencies, (_ref)=>{
    var { on: on, config: config } = _ref;
    var BigNumber = (0, (/*@__PURE__*/$parcel$interopDefault($5Pv9S))).clone({
        precision: config.precision,
        modulo: (0, (/*@__PURE__*/$parcel$interopDefault($5Pv9S))).EUCLID
    });
    BigNumber.prototype = Object.create(BigNumber.prototype);
    /**
   * Attach type information
   */ BigNumber.prototype.type = 'BigNumber';
    BigNumber.prototype.isBigNumber = true;
    /**
   * Get a JSON representation of a BigNumber containing
   * type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "BigNumber", "value": "0.2"}`
   */ BigNumber.prototype.toJSON = function() {
        return {
            mathjs: 'BigNumber',
            value: this.toString()
        };
    };
    /**
   * Instantiate a BigNumber from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "BigNumber", "value": "0.2"}`
   * @return {BigNumber}
   */ BigNumber.fromJSON = function(json) {
        return new BigNumber(json.value);
    };
    if (on) // listen for changed in the configuration, automatically apply changed precision
    on('config', function(curr, prev) {
        if (curr.precision !== prev.precision) BigNumber.config({
            precision: curr.precision
        });
    });
    return BigNumber;
}, {
    isClass: true
});

});
parcelRegister("5Pv9S", function(module, exports) {
(function(globalScope) {
    'use strict';
    /*!
   *  decimal.js v10.6.0
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The maximum exponent magnitude.
    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
    var EXP_LIMIT = 9e15, // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    MAX_DIGITS = 1e9, // Base conversion alphabet.
    NUMERALS = '0123456789abcdef', // The natural logarithm of 10 (1025 digits).
    LN10 = '2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058', // Pi (1025 digits).
    PI = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789', // The initial configuration properties of the Decimal constructor.
    DEFAULTS = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -EXP_LIMIT,
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: EXP_LIMIT,
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: false // true/false
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    Decimal, inexact, noConflict, quadrant, external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', precisionLimitExceeded = decimalError + 'Precision limit exceeded', cryptoUnavailable = decimalError + 'crypto unavailable', tag = '[object Decimal]', mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, // Decimal.prototype object
    P = {
        toStringTag: tag
    };
    // Decimal prototype methods
    /*
   *  absoluteValue             abs
   *  ceil
   *  clampedTo                 clamp
   *  comparedTo                cmp
   *  cosine                    cos
   *  cubeRoot                  cbrt
   *  decimalPlaces             dp
   *  dividedBy                 div
   *  dividedToIntegerBy        divToInt
   *  equals                    eq
   *  floor
   *  greaterThan               gt
   *  greaterThanOrEqualTo      gte
   *  hyperbolicCosine          cosh
   *  hyperbolicSine            sinh
   *  hyperbolicTangent         tanh
   *  inverseCosine             acos
   *  inverseHyperbolicCosine   acosh
   *  inverseHyperbolicSine     asinh
   *  inverseHyperbolicTangent  atanh
   *  inverseSine               asin
   *  inverseTangent            atan
   *  isFinite
   *  isInteger                 isInt
   *  isNaN
   *  isNegative                isNeg
   *  isPositive                isPos
   *  isZero
   *  lessThan                  lt
   *  lessThanOrEqualTo         lte
   *  logarithm                 log
   *  [maximum]                 [max]
   *  [minimum]                 [min]
   *  minus                     sub
   *  modulo                    mod
   *  naturalExponential        exp
   *  naturalLogarithm          ln
   *  negated                   neg
   *  plus                      add
   *  precision                 sd
   *  round
   *  sine                      sin
   *  squareRoot                sqrt
   *  tangent                   tan
   *  times                     mul
   *  toBinary
   *  toDecimalPlaces           toDP
   *  toExponential
   *  toFixed
   *  toFraction
   *  toHexadecimal             toHex
   *  toNearest
   *  toNumber
   *  toOctal
   *  toPower                   pow
   *  toPrecision
   *  toSignificantDigits       toSD
   *  toString
   *  truncated                 trunc
   *  valueOf                   toJSON
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s < 0) x.s = 1;
        return finalise(x);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of positive Infinity.
   *
   */ P.ceil = function() {
        return finalise(new this.constructor(this), this.e + 1, 2);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal clamped to the range
   * delineated by `min` and `max`.
   *
   * min {number|string|bigint|Decimal}
   * max {number|string|bigint|Decimal}
   *
   */ P.clampedTo = P.clamp = function(min, max) {
        var k, x = this, Ctor = x.constructor;
        min = new Ctor(min);
        max = new Ctor(max);
        if (!min.s || !max.s) return new Ctor(NaN);
        if (min.gt(max)) throw Error(invalidArgument + max);
        k = x.cmp(min);
        return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value,
   *   NaN  if the value of either Decimal is NaN.
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
        // Either NaN or ±Infinity?
        if (!xd || !yd) return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
        // Either zero?
        if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
        // Signs differ?
        if (xs !== ys) return xs;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
        xdL = xd.length;
        ydL = yd.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };
    /*
   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * cos(0)         = 1
   * cos(-0)        = 1
   * cos(Infinity)  = NaN
   * cos(-Infinity) = NaN
   * cos(NaN)       = NaN
   *
   */ P.cosine = P.cos = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.d) return new Ctor(NaN);
        // cos(0) = cos(-0) = 1
        if (!x.d[0]) return new Ctor(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
    };
    /*
   *
   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   *  cbrt(0)  =  0
   *  cbrt(-0) = -0
   *  cbrt(1)  =  1
   *  cbrt(-1) = -1
   *  cbrt(N)  =  N
   *  cbrt(-I) = -I
   *  cbrt(I)  =  I
   *
   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
   *
   */ P.cubeRoot = P.cbrt = function() {
        var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        external = false;
        // Initial estimate.
        s = x.s * mathpow(x.s * x, 1 / 3);
        // Math.cbrt underflow/overflow?
        // Pass x to Math.pow as integer, then adjust the exponent of the result.
        if (!s || Math.abs(s) == 1 / 0) {
            n = digitsToString(x.d);
            e = x.e;
            // Adjust n exponent so it is a multiple of 3 away from x exponent.
            if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? '0' : '00';
            s = mathpow(n, 1 / 3);
            // Rarely, e may be one less than the result exponent value.
            e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
            r.s = x.s;
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Halley's method.
        // TODO? Compare Newton's method.
        for(;;){
            t = r;
            t3 = t.times(t).times(t);
            t3plusx = t3.plus(x);
            r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
                // , i.e. approaching a rounding boundary, continue the iteration.
                if (n == '9999' || !rep && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var w, d = this.d, n = NaN;
        if (d) {
            w = d.length - 1;
            n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last word.
            w = d[w];
            if (w) for(; w % 10 == 0; w /= 10)n--;
            if (n < 0) n = 0;
        }
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedToIntegerBy = P.divToInt = function(y) {
        var x = this, Ctor = x.constructor;
        return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of negative Infinity.
   *
   */ P.floor = function() {
        return finalise(new this.constructor(this), this.e + 1, 3);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        var k = this.cmp(y);
        return k == 1 || k === 0;
    };
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [1, Infinity]
   *
   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
   *
   * cosh(0)         = 1
   * cosh(-0)        = 1
   * cosh(Infinity)  = Infinity
   * cosh(-Infinity) = Infinity
   * cosh(NaN)       = NaN
   *
   *  x        time taken (ms)   result
   * 1000      9                 9.8503555700852349694e+433
   * 10000     25                4.4034091128314607936e+4342
   * 100000    171               1.4033316802130615897e+43429
   * 1000000   3817              1.5166076984010437725e+434294
   * 10000000  abandoned after 2 minute wait
   *
   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
   *
   */ P.hyperbolicCosine = P.cosh = function() {
        var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
        if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
        if (x.isZero()) return one;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
        // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
        // Estimate the optimum number of times to use the argument reduction.
        // TODO? Estimation reused from cosine() and may not be optimal here.
        if (len < 32) {
            k = Math.ceil(len / 3);
            n = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            n = '2.3283064365386962890625e-10';
        }
        x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
        // Reverse argument reduction
        var cosh2_x, i = k, d8 = new Ctor(8);
        for(; i--;){
            cosh2_x = x.times(x);
            x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
        }
        return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
   *
   * sinh(0)         = 0
   * sinh(-0)        = -0
   * sinh(Infinity)  = Infinity
   * sinh(-Infinity) = -Infinity
   * sinh(NaN)       = NaN
   *
   * x        time taken (ms)
   * 10       2 ms
   * 100      5 ms
   * 1000     14 ms
   * 10000    82 ms
   * 100000   886 ms            1.4033316802130615897e+43429
   * 200000   2613 ms
   * 300000   5407 ms
   * 400000   8824 ms
   * 500000   13026 ms          8.7080643612718084129e+217146
   * 1000000  48543 ms
   *
   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
   *
   */ P.hyperbolicSine = P.sinh = function() {
        var k, pr, rm, len, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        if (len < 3) x = taylorSeries(Ctor, 2, x, x, true);
        else {
            // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
            // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
            // 3 multiplications and 1 addition
            // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
            // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
            // 4 multiplications and 2 additions
            // Estimate the optimum number of times to use the argument reduction.
            k = 1.4 * Math.sqrt(len);
            k = k > 16 ? 16 : k | 0;
            x = x.times(1 / tinyPow(5, k));
            x = taylorSeries(Ctor, 2, x, x, true);
            // Reverse argument reduction
            var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
            for(; k--;){
                sinh2_x = x.times(x);
                x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
            }
        }
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * tanh(x) = sinh(x) / cosh(x)
   *
   * tanh(0)         = 0
   * tanh(-0)        = -0
   * tanh(Infinity)  = 1
   * tanh(-Infinity) = -1
   * tanh(NaN)       = NaN
   *
   */ P.hyperbolicTangent = P.tanh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(x.s);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 7;
        Ctor.rounding = 1;
        return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };
    /*
   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
   * this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [0, pi]
   *
   * acos(x) = pi/2 - asin(x)
   *
   * acos(0)       = pi/2
   * acos(-0)      = pi/2
   * acos(1)       = 0
   * acos(-1)      = pi
   * acos(1/2)     = pi/3
   * acos(-1/2)    = 2*pi/3
   * acos(|x| > 1) = NaN
   * acos(NaN)     = NaN
   *
   */ P.inverseCosine = P.acos = function() {
        var x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
        if (k !== -1) return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
        if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
        // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        // See https://github.com/MikeMcl/decimal.js/pull/217
        x = new Ctor(1).minus(x).div(x.plus(1)).sqrt().atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
   * value of this Decimal.
   *
   * Domain: [1, Infinity]
   * Range: [0, Infinity]
   *
   * acosh(x) = ln(x + sqrt(x^2 - 1))
   *
   * acosh(x < 1)     = NaN
   * acosh(NaN)       = NaN
   * acosh(Infinity)  = Infinity
   * acosh(-Infinity) = NaN
   * acosh(0)         = NaN
   * acosh(-0)        = NaN
   * acosh(1)         = 0
   * acosh(-1)        = NaN
   *
   */ P.inverseHyperbolicCosine = P.acosh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
        if (!x.isFinite()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).minus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * asinh(x) = ln(x + sqrt(x^2 + 1))
   *
   * asinh(NaN)       = NaN
   * asinh(Infinity)  = Infinity
   * asinh(-Infinity) = -Infinity
   * asinh(0)         = 0
   * asinh(-0)        = -0
   *
   */ P.inverseHyperbolicSine = P.asinh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).plus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
   * value of this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [-Infinity, Infinity]
   *
   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
   *
   * atanh(|x| > 1)   = NaN
   * atanh(NaN)       = NaN
   * atanh(Infinity)  = NaN
   * atanh(-Infinity) = NaN
   * atanh(0)         = 0
   * atanh(-0)        = -0
   * atanh(1)         = Infinity
   * atanh(-1)        = -Infinity
   *
   */ P.inverseHyperbolicTangent = P.atanh = function() {
        var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        xsd = x.sd();
        if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
        Ctor.precision = wpr = xsd - x.e;
        x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
        Ctor.precision = pr + 4;
        Ctor.rounding = 1;
        x = x.ln();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(0.5);
    };
    /*
   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
   *
   * asin(0)       = 0
   * asin(-0)      = -0
   * asin(1/2)     = pi/6
   * asin(-1/2)    = -pi/6
   * asin(1)       = pi/2
   * asin(-1)      = -pi/2
   * asin(|x| > 1) = NaN
   * asin(NaN)     = NaN
   *
   * TODO? Compare performance of Taylor series.
   *
   */ P.inverseSine = P.asin = function() {
        var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
        if (x.isZero()) return new Ctor(x);
        k = x.abs().cmp(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (k !== -1) {
            // |x| is 1
            if (k === 0) {
                halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
                halfPi.s = x.s;
                return halfPi;
            }
            // |x| > 1 or x is NaN
            return new Ctor(NaN);
        }
        // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
   *
   * atan(0)         = 0
   * atan(-0)        = -0
   * atan(1)         = pi/4
   * atan(-1)        = -pi/4
   * atan(Infinity)  = pi/2
   * atan(-Infinity) = -pi/2
   * atan(NaN)       = NaN
   *
   */ P.inverseTangent = P.atan = function() {
        var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
        if (!x.isFinite()) {
            if (!x.s) return new Ctor(NaN);
            if (pr + 4 <= PI_PRECISION) {
                r = getPi(Ctor, pr + 4, rm).times(0.5);
                r.s = x.s;
                return r;
            }
        } else if (x.isZero()) return new Ctor(x);
        else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
            r = getPi(Ctor, pr + 4, rm).times(0.25);
            r.s = x.s;
            return r;
        }
        Ctor.precision = wpr = pr + 10;
        Ctor.rounding = 1;
        // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
        // Argument reduction
        // Ensure |x| < 0.42
        // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
        k = Math.min(28, wpr / LOG_BASE + 2 | 0);
        for(i = k; i; --i)x = x.div(x.times(x).plus(1).sqrt().plus(1));
        external = false;
        j = Math.ceil(wpr / LOG_BASE);
        n = 1;
        x2 = x.times(x);
        r = new Ctor(x);
        px = x;
        // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
        for(; i !== -1;){
            px = px.times(x2);
            t = r.minus(px.div(n += 2));
            px = px.times(x2);
            r = t.plus(px.div(n += 2));
            if (r.d[j] !== void 0) for(i = j; r.d[i] === t.d[i] && i--;);
        }
        if (k) r = r.times(2 << k - 1);
        external = true;
        return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return true if the value of this Decimal is a finite number, otherwise return false.
   *
   */ P.isFinite = function() {
        return !!this.d;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isInt = function() {
        return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is NaN, otherwise return false.
   *
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isNeg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.isPos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
   *
   */ P.isZero = function() {
        return !!this.d && this.d[0] === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * If no base is specified, return log[10](arg).
   *
   * log[base](arg) = ln(arg) / ln(base)
   *
   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
   * otherwise:
   *
   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
   * between the result and the correctly rounded result will be one ulp (unit in the last place).
   *
   * log[-b](a)       = NaN
   * log[0](a)        = NaN
   * log[1](a)        = NaN
   * log[NaN](a)      = NaN
   * log[Infinity](a) = NaN
   * log[b](0)        = -Infinity
   * log[b](-0)       = -Infinity
   * log[b](-a)       = NaN
   * log[b](1)        = 0
   * log[b](Infinity) = Infinity
   * log[b](NaN)      = NaN
   *
   * [base] {number|string|bigint|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
        // Default base is 10.
        if (base == null) {
            base = new Ctor(10);
            isBase10 = true;
        } else {
            base = new Ctor(base);
            d = base.d;
            // Return NaN if base is negative, or non-finite, or is 0 or 1.
            if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
            isBase10 = base.eq(10);
        }
        d = arg.d;
        // Is arg negative, non-finite, 0 or 1?
        if (arg.s < 0 || !d || !d[0] || arg.eq(1)) return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
        // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
        // integer power of 10.
        if (isBase10) {
            if (d.length > 1) inf = true;
            else {
                for(k = d[0]; k % 10 === 0;)k /= 10;
                inf = k !== 1;
            }
        }
        external = false;
        sd = pr + guard;
        num = naturalLogarithm(arg, sd);
        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
        // The result will have 5 rounding digits.
        r = divide(num, denominator, sd, 1);
        // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
        // calculate 10 further digits.
        //
        // If the result is known to have an infinite decimal expansion, repeat this until it is clear
        // that the result is above or below the boundary. Otherwise, if after calculating the 10
        // further digits, the last 14 are nines, round up and assume the result is exact.
        // Also assume the result is exact if the last 14 are zero.
        //
        // Example of a result that will be incorrectly rounded:
        // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
        // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
        // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
        // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
        // place is still 2.6.
        if (checkRoundingDigits(r.d, k = pr, rm)) do {
            sd += 10;
            num = naturalLogarithm(arg, sd);
            denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
            r = divide(num, denominator, sd, 1);
            if (!inf) {
                // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
                if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
                break;
            }
        }while (checkRoundingDigits(r.d, k += 10, rm));
        external = true;
        return finalise(r, pr, rm);
    };
    /*
   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|bigint|Decimal}
   *
  P.max = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, -1);
  };
   */ /*
   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|bigint|Decimal}
   *
  P.min = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 1);
  };
   */ /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.minus = P.sub = function(y) {
        var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (x.d) y.s = -y.s;
            else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.plus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return y negated if x is zero and y is non-zero.
            if (yd[0]) y.s = -y.s;
            else if (xd[0]) y = new Ctor(x);
            else return new Ctor(rm === 3 ? -0 : 0);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        e = mathfloor(y.e / LOG_BASE);
        xe = mathfloor(x.e / LOG_BASE);
        xd = xd.slice();
        k = xe - e;
        // If base 1e7 exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of
            // zeros needing to be prepended, but this can be avoided while still ensuring correct
            // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to `xd` if shorter.
        // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * The result depends on the modulo mode.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
        if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
        // Return x if y is ±Infinity or x is ±0.
        if (!y.d || x.d && !x.d[0]) return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
        // Prevent rounding of intermediate calculations.
        external = false;
        if (Ctor.modulo == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // result = x - q * y    where  0 <= result < abs(y)
            q = divide(x, y.abs(), 0, 3, 1);
            q.s *= y.s;
        } else q = divide(x, y, 0, Ctor.modulo, 1);
        q = q.times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.naturalExponential = P.exp = function() {
        return naturalExponential(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return naturalLogarithm(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return finalise(x);
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.plus = P.add = function(y) {
        var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!yd[0]) y = new Ctor(x);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        k = mathfloor(x.e / LOG_BASE);
        e = mathfloor(y.e / LOG_BASE);
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var k, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        if (x.d) {
            k = getPrecision(x.d);
            if (z && x.e + 1 > k) k = x.e + 1;
        } else k = NaN;
        return k;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.round = function() {
        var x = this, Ctor = x.constructor;
        return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
    };
    /*
   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * sin(x) = x - x^3/3! + x^5/5! - ...
   *
   * sin(0)         = 0
   * sin(-0)        = -0
   * sin(Infinity)  = NaN
   * sin(-Infinity) = NaN
   * sin(NaN)       = NaN
   *
   */ P.sine = P.sin = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = sine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   *  sqrt(-n) =  N
   *  sqrt(N)  =  N
   *  sqrt(-I) =  N
   *  sqrt(I)  =  I
   *  sqrt(0)  =  0
   *  sqrt(-0) = -0
   *
   */ P.squareRoot = P.sqrt = function() {
        var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !d || !d[0]) return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (n == '9999' || !rep && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * tan(0)         = 0
   * tan(-0)        = -0
   * tan(Infinity)  = NaN
   * tan(-Infinity) = NaN
   * tan(NaN)       = NaN
   *
   */ P.tangent = P.tan = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 10;
        Ctor.rounding = 1;
        x = x.sin();
        x.s = 1;
        x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        y.s *= x.s;
        // If either is NaN, ±Infinity or ±0...
        if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
        e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = getBase10Exponent(r, e);
        return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
    };
    /*
   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toBinary = function(sd, rm) {
        return toStringBinary(this, 2, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.toDP = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return finalise(x, dp + x.e + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), dp + 1, rm);
            str = finiteToString(x, true, dp + 1);
        }
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            y = finalise(new Ctor(x), dp + x.e + 1, rm);
            str = finiteToString(y, false, dp + y.e + 1);
        }
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return an array representing the value of this Decimal as a simple fraction with an integer
   * numerator and an integer denominator.
   *
   * The denominator will be a positive non-zero value less than or equal to the specified maximum
   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
   * value necessary to represent the number exactly.
   *
   * [maxD] {number|string|bigint|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
   *
   */ P.toFraction = function(maxD) {
        var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
        if (!xd) return new Ctor(x);
        n1 = d0 = new Ctor(1);
        d1 = n0 = new Ctor(0);
        d = new Ctor(d1);
        e = d.e = getPrecision(xd) - x.e - 1;
        k = e % LOG_BASE;
        d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
        if (maxD == null) // d is 10**e, the minimum max-denominator needed.
        maxD = e > 0 ? d : n1;
        else {
            n = new Ctor(maxD);
            if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
            maxD = n.gt(d) ? e > 0 ? d : n1 : n;
        }
        external = false;
        n = new Ctor(digitsToString(xd));
        pr = Ctor.precision;
        Ctor.precision = e = xd.length * LOG_BASE * 2;
        for(;;){
            q = divide(n, d, 0, 1, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.cmp(maxD) == 1) break;
            d0 = d1;
            d1 = d2;
            d2 = n1;
            n1 = n0.plus(q.times(d2));
            n0 = d2;
            d2 = d;
            d = n.minus(q.times(d2));
            n = d2;
        }
        d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        // Determine which fraction is closer to x, n0/d0 or n1/d1?
        r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        Ctor.precision = pr;
        external = true;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toHexadecimal = P.toHex = function(sd, rm) {
        return toStringBinary(this, 16, sd, rm);
    };
    /*
   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
   *
   * The return value will always have the same sign as this Decimal, unless either this Decimal
   * or `y` is NaN, in which case the return value will be also be NaN.
   *
   * The return value is not affected by the value of `precision`.
   *
   * y {number|string|bigint|Decimal} The magnitude to round to a multiple of.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toNearest() rounding mode not an integer: {rm}'
   * 'toNearest() rounding mode out of range: {rm}'
   *
   */ P.toNearest = function(y, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (y == null) {
            // If x is not finite, return x.
            if (!x.d) return x;
            y = new Ctor(1);
            rm = Ctor.rounding;
        } else {
            y = new Ctor(y);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            // If x is not finite, return x if y is not NaN, else NaN.
            if (!x.d) return y.s ? x : y;
            // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
            if (!y.d) {
                if (y.s) y.s = x.s;
                return y;
            }
        }
        // If y is not zero, calculate the nearest multiple of y to x.
        if (y.d[0]) {
            external = false;
            x = divide(x, y, 0, rm, 1).times(y);
            external = true;
            finalise(x);
        // If y is zero, return zero with the sign of x.
        } else {
            y.s = x.s;
            x = y;
        }
        return x;
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   * Zero keeps its sign.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toOctal = function(sd, rm) {
        return toStringBinary(this, 8, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
   * to `precision` significant digits using rounding mode `rounding`.
   *
   * ECMAScript compliant.
   *
   *   pow(x, NaN)                           = NaN
   *   pow(x, ±0)                            = 1

   *   pow(NaN, non-zero)                    = NaN
   *   pow(abs(x) > 1, +Infinity)            = +Infinity
   *   pow(abs(x) > 1, -Infinity)            = +0
   *   pow(abs(x) == 1, ±Infinity)           = NaN
   *   pow(abs(x) < 1, +Infinity)            = +0
   *   pow(abs(x) < 1, -Infinity)            = +Infinity
   *   pow(+Infinity, y > 0)                 = +Infinity
   *   pow(+Infinity, y < 0)                 = +0
   *   pow(-Infinity, odd integer > 0)       = -Infinity
   *   pow(-Infinity, even integer > 0)      = +Infinity
   *   pow(-Infinity, odd integer < 0)       = -0
   *   pow(-Infinity, even integer < 0)      = +0
   *   pow(+0, y > 0)                        = +0
   *   pow(+0, y < 0)                        = +Infinity
   *   pow(-0, odd integer > 0)              = -0
   *   pow(-0, even integer > 0)             = +0
   *   pow(-0, odd integer < 0)              = -Infinity
   *   pow(-0, even integer < 0)             = +Infinity
   *   pow(finite x < 0, finite non-integer) = NaN
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
   * probability of an incorrectly rounded result
   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
   * i.e. 1 in 250,000,000,000,000
   *
   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
   *
   * y {number|string|bigint|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
        // Either ±Infinity, NaN or ±0?
        if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
        x = new Ctor(x);
        if (x.eq(1)) return x;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (y.eq(1)) return finalise(x, pr, rm);
        // y exponent
        e = mathfloor(y.e / LOG_BASE);
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = intPow(Ctor, x, k, pr);
            return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
        }
        s = x.s;
        // if x is negative
        if (s < 0) {
            // if y is not an integer
            if (e < y.d.length - 1) return new Ctor(NaN);
            // Result is positive if x is negative and the last digit of integer y is even.
            if ((y.d[e] & 1) == 0) s = 1;
            // if x.eq(-1)
            if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
                x.s = s;
                return x;
            }
        }
        // Estimate result exponent.
        // x^y = 10^e,  where e = y * log10(x)
        // log10(x) = log10(x_significand) + x_exponent
        // log10(x_significand) = ln(x_significand) / ln(10)
        k = mathpow(+x, yn);
        e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log('0.' + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + '').e;
        // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
        // Overflow/underflow?
        if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
        external = false;
        Ctor.rounding = x.s = 1;
        // Estimate the extra guard digits needed to ensure five correct rounding digits from
        // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
        // new Decimal(2.32456).pow('2087987436534566.46411')
        // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
        k = Math.min(12, (e + '').length);
        // r = x^y = exp(y*ln(x))
        r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
        // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
        if (r.d) {
            // Truncate to the required precision plus five rounding digits.
            r = finalise(r, pr + 5, 1);
            // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
            // the result.
            if (checkRoundingDigits(r.d, pr, rm)) {
                e = pr + 10;
                // Truncate to the increased precision plus five rounding digits.
                r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
                // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
                if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
            }
        }
        r.s = s;
        external = true;
        Ctor.rounding = rm;
        return finalise(r, pr, rm);
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var str, x = this, Ctor = x.constructor;
        if (sd === void 0) str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), sd, rm);
            str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
        }
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toSD() digits out of range: {sd}'
   * 'toSD() digits not an integer: {sd}'
   * 'toSD() rounding mode not an integer: {rm}'
   * 'toSD() rounding mode out of range: {rm}'
   *
   */ P.toSignificantDigits = P.toSD = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return finalise(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
   *
   */ P.truncated = P.trunc = function() {
        return finalise(new this.constructor(this), this.e + 1, 1);
    };
    /*
   * Return a string representing the value of this Decimal.
   * Unlike `toString`, negative zero will include the minus sign.
   *
   */ P.valueOf = P.toJSON = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() ? '-' + str : str;
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
   *                           finiteToString, naturalExponential, naturalLogarithm
   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
   *  convertBase              toStringBinary, parseOther
   *  cos                      P.cos
   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
   *                           taylorSeries, atan2, parseOther
   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
   *                           naturalLogarithm, ceil, floor, round, trunc
   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
   *                           toStringBinary
   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
   *  getLn10                  P.logarithm, naturalLogarithm
   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
   *  getPrecision             P.precision, P.toFraction
   *  getZeroString            digitsToString, finiteToString
   *  intPow                   P.toPower, parseOther
   *  isOdd                    toLessThanHalfPi
   *  maxOrMin                 max, min
   *  naturalExponential       P.naturalExponential, P.toPower
   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
   *                           P.toPower, naturalExponential
   *  nonFiniteToString        finiteToString, toStringBinary
   *  parseDecimal             Decimal
   *  parseOther               Decimal
   *  sin                      P.sin
   *  taylorSeries             P.cosh, P.sinh, cos, sin
   *  toLessThanHalfPi         P.cos, P.sin
   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
   *  truncate                 intPow
   *
   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
   *                           naturalLogarithm, config, parseOther, random, Decimal
   */ function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    /*
   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
   * `repeating == null` if caller is `log` or `pow`,
   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
   */ function checkRoundingDigits(d, i, rm, repeating) {
        var di, k, r, rd;
        // Get the length of the first word of the array d.
        for(k = d[0]; k >= 10; k /= 10)--i;
        // Is the rounding digit in the first word of d?
        if (--i < 0) {
            i += LOG_BASE;
            di = 0;
        } else {
            di = Math.ceil((i + 1) / LOG_BASE);
            i %= LOG_BASE;
        }
        // i is the index (0 - 6) of the rounding digit.
        // E.g. if within the word 3487563 the first rounding digit is 5,
        // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
        k = mathpow(10, LOG_BASE - i);
        rd = d[di] % k | 0;
        if (repeating == null) {
            if (i < 3) {
                if (i == 0) rd = rd / 100 | 0;
                else if (i == 1) rd = rd / 10 | 0;
                r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
            } else r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
        } else if (i < 4) {
            if (i == 0) rd = rd / 1000 | 0;
            else if (i == 1) rd = rd / 100 | 0;
            else if (i == 2) rd = rd / 10 | 0;
            r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
        return r;
    }
    // Convert string of `baseIn` to an array of numbers of `baseOut`.
    // Eg. convertBase('255', 10, 16) returns [15, 15].
    // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
    function convertBase(str, baseIn, baseOut) {
        var j, arr = [
            0
        ], arrL, i = 0, strL = str.length;
        for(; i < strL;){
            for(arrL = arr.length; arrL--;)arr[arrL] *= baseIn;
            arr[0] += NUMERALS.indexOf(str.charAt(i++));
            for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] === void 0) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    }
    /*
   * cos(x) = 1 - x^2/2! + x^4/4! - ...
   * |x| < pi/2
   *
   */ function cosine(Ctor, x) {
        var k, len, y;
        if (x.isZero()) return x;
        // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
        // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
        // Estimate the optimum number of times to use the argument reduction.
        len = x.d.length;
        if (len < 32) {
            k = Math.ceil(len / 3);
            y = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            y = '2.3283064365386962890625e-10';
        }
        Ctor.precision += k;
        x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
        // Reverse argument reduction
        for(var i = k; i--;){
            var cos2x = x.times(x);
            x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
        }
        Ctor.precision -= k;
        return x;
    }
    /*
   * Perform division in the specified base.
   */ var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k, base) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % base | 0;
                carry = temp / base | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, rm, dp, base) {
            var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either NaN, Infinity or 0?
            if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
            xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
            if (base) {
                logBase = 1;
                e = x.e - y.e;
            } else {
                base = BASE;
                logBase = LOG_BASE;
                e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
            }
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            // The digit array of a Decimal from toStringBinary may have trailing zeros.
            for(i = 0; yd[i] == (xd[i] || 0); i++);
            if (yd[i] > (xd[i] || 0)) e--;
            if (pr == null) {
                sd = pr = Ctor.precision;
                rm = Ctor.rounding;
            } else if (dp) sd = pr + (x.e - y.e) + 1;
            else sd = pr;
            if (sd < 0) {
                qd.push(1);
                more = true;
            } else {
                // Convert precision in number of base 10 digits to base 1e7 digits.
                sd = sd / logBase + 2 | 0;
                i = 0;
                // divisor < 1e7
                if (yL == 1) {
                    k = 0;
                    yd = yd[0];
                    sd++;
                    // k is the carry.
                    for(; (i < xL || k) && sd--; i++){
                        t = k * base + (xd[i] || 0);
                        qd[i] = t / yd | 0;
                        k = t % yd | 0;
                    }
                    more = k || i < xL;
                // divisor >= 1e7
                } else {
                    // Normalise xd and yd so highest order digit of yd is >= base/2
                    k = base / (yd[0] + 1) | 0;
                    if (k > 1) {
                        yd = multiplyInteger(yd, k, base);
                        xd = multiplyInteger(xd, k, base);
                        yL = yd.length;
                        xL = xd.length;
                    }
                    xi = yL;
                    rem = xd.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL;)rem[remL++] = 0;
                    yz = yd.slice();
                    yz.unshift(0);
                    yd0 = yd[0];
                    if (yd[1] >= base / 2) ++yd0;
                    do {
                        k = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, k.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // k will be how many times the divisor goes into the current remainder.
                            k = rem0 / yd0 | 0;
                            //  Algorithm:
                            //  1. product = divisor * trial digit (k)
                            //  2. if product > remainder: product -= divisor, k--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, k++
                            if (k > 1) {
                                if (k >= base) k = base - 1;
                                // product = divisor * trial digit.
                                prod = multiplyInteger(yd, k, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                cmp = compare(prod, rem, prodL, remL);
                                // product > remainder.
                                if (cmp == 1) {
                                    k--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                                }
                            } else {
                                // cmp is -1.
                                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                                if (k == 0) cmp = k = 1;
                                prod = yd.slice();
                            }
                            prodL = prod.length;
                            if (prodL < remL) prod.unshift(0);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            // If product was < previous remainder.
                            if (cmp == -1) {
                                remL = rem.length;
                                // Compare divisor and new remainder.
                                cmp = compare(yd, rem, yL, remL);
                                // If divisor < new remainder, subtract divisor from remainder.
                                if (cmp < 1) {
                                    k++;
                                    // Subtract divisor from remainder.
                                    subtract(rem, yL < remL ? yz : yd, remL, base);
                                }
                            }
                            remL = rem.length;
                        } else if (cmp === 0) {
                            k++;
                            rem = [
                                0
                            ];
                        } // if cmp === 1, k will be 0
                        // Add the next digit, k, to the result array.
                        qd[i++] = k;
                        // Update the remainder.
                        if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                        else {
                            rem = [
                                xd[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] !== void 0) && sd--);
                    more = rem[0] !== void 0;
                }
                // Leading zero?
                if (!qd[0]) qd.shift();
            }
            // logBase is 1 when divide is being used for base conversion.
            if (logBase == 1) {
                q.e = e;
                inexact = more;
            } else {
                // To calculate q.e, first get the number of digits of qd[0].
                for(i = 1, k = qd[0]; k >= 10; k /= 10)i++;
                q.e = i + e * logBase - 1;
                finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
            }
            return q;
        };
    }();
    /*
   * Round `x` to `sd` significant digits using rounding mode `rm`.
   * Check for over/under-flow.
   */ function finalise(x, sd, rm, isTruncated) {
        var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
        // Don't round if sd is null or undefined.
        out: if (sd != null) {
            xd = x.d;
            // Infinity/NaN.
            if (!xd) return x;
            // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
            // w: the word of xd containing rd, a base 1e7 number.
            // xdi: the index of w within xd.
            // digits: the number of digits of w.
            // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
            // they had leading zeros)
            // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
            // Get the length of the first word of the digits array xd.
            for(digits = 1, k = xd[0]; k >= 10; k /= 10)digits++;
            i = sd - digits;
            // Is the rounding digit in the first word of xd?
            if (i < 0) {
                i += LOG_BASE;
                j = sd;
                w = xd[xdi = 0];
                // Get the rounding digit at index j of w.
                rd = w / mathpow(10, digits - j - 1) % 10 | 0;
            } else {
                xdi = Math.ceil((i + 1) / LOG_BASE);
                k = xd.length;
                if (xdi >= k) {
                    if (isTruncated) {
                        // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                        for(; k++ <= xdi;)xd.push(0);
                        w = rd = 0;
                        digits = 1;
                        i %= LOG_BASE;
                        j = i - LOG_BASE + 1;
                    } else break out;
                } else {
                    w = k = xd[xdi];
                    // Get the number of digits of w.
                    for(digits = 1; k >= 10; k /= 10)digits++;
                    // Get the index of rd within w.
                    i %= LOG_BASE;
                    // Get the index of rd within w, adjusted for leading zeros.
                    // The number of leading zeros of w is given by LOG_BASE - digits.
                    j = i - LOG_BASE + digits;
                    // Get the rounding digit at index j of w.
                    rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
                }
            }
            // Are there any non-zero digits after the rounding digit?
            isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
            // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
            // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
            // will give 714.
            roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
            if (sd < 1 || !xd[0]) {
                xd.length = 0;
                if (roundUp) {
                    // Convert sd to decimal places.
                    sd -= x.e + 1;
                    // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                    x.e = -sd || 0;
                } else // Zero.
                xd[0] = x.e = 0;
                return x;
            }
            // Remove excess digits.
            if (i == 0) {
                xd.length = xdi;
                k = 1;
                xdi--;
            } else {
                xd.length = xdi + 1;
                k = mathpow(10, LOG_BASE - i);
                // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                // j > 0 means i > number of leading zeros of w.
                xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
            }
            if (roundUp) {
                for(;;)// Is the digit to be rounded up in the first word of xd?
                if (xdi == 0) {
                    // i will be the length of xd[0] before k is added.
                    for(i = 1, j = xd[0]; j >= 10; j /= 10)i++;
                    j = xd[0] += k;
                    for(k = 1; j >= 10; j /= 10)k++;
                    // if i != k the length has increased.
                    if (i != k) {
                        x.e++;
                        if (xd[0] == BASE) xd[0] = 1;
                    }
                    break;
                } else {
                    xd[xdi] += k;
                    if (xd[xdi] != BASE) break;
                    xd[xdi--] = 0;
                    k = 1;
                }
            }
            // Remove trailing zeros.
            for(i = xd.length; xd[--i] === 0;)xd.pop();
        }
        if (external) {
            // Overflow?
            if (x.e > Ctor.maxE) {
                // Infinity.
                x.d = null;
                x.e = NaN;
            // Underflow?
            } else if (x.e < Ctor.minE) {
                // Zero.
                x.e = 0;
                x.d = [
                    0
                ];
            // Ctor.underflow = true;
            } // else Ctor.underflow = false;
        }
        return x;
    }
    function finiteToString(x, isExp, sd) {
        if (!x.isFinite()) return nonFiniteToString(x);
        var k, e = x.e, str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (x.e < 0 ? 'e' : 'e+') + x.e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return str;
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(digits, e) {
        var w = digits[0];
        // Add the number of digits of the first word of the digits array.
        for(e *= LOG_BASE; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > LN10_PRECISION) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(precisionLimitExceeded);
        }
        return finalise(new Ctor(LN10), sd, 1, true);
    }
    function getPi(Ctor, sd, rm) {
        if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
        return finalise(new Ctor(PI), sd, rm, true);
    }
    function getPrecision(digits) {
        var w = digits.length - 1, len = w * LOG_BASE + 1;
        w = digits[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)len--;
            // Add the number of digits of the first word.
            for(w = digits[0]; w >= 10; w /= 10)len++;
        }
        return len;
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
   * integer of type number.
   *
   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
   *
   */ function intPow(Ctor, x, n, pr) {
        var isTruncated, r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        k = Math.ceil(pr / LOG_BASE + 4);
        external = false;
        for(;;){
            if (n % 2) {
                r = r.times(x);
                if (truncate(r.d, k)) isTruncated = true;
            }
            n = mathfloor(n / 2);
            if (n === 0) {
                // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
                n = r.d.length - 1;
                if (isTruncated && r.d[n] === 0) ++r.d[n];
                break;
            }
            x = x.times(x);
            truncate(x.d, k);
        }
        external = true;
        return r;
    }
    function isOdd(n) {
        return n.d[n.d.length - 1] & 1;
    }
    /*
   * Handle `max` (`n` is -1) and `min` (`n` is 1).
   */ function maxOrMin(Ctor, args, n) {
        var k, y, x = new Ctor(args[0]), i = 0;
        for(; ++i < args.length;){
            y = new Ctor(args[i]);
            // NaN?
            if (!y.s) {
                x = y;
                break;
            }
            k = x.cmp(y);
            if (k === n || k === 0 && x.s === n) x = y;
        }
        return x;
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
   * digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(Infinity)  = Infinity
   *  exp(-Infinity) = 0
   *  exp(NaN)       = NaN
   *  exp(±0)        = 1
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   *  The result will always be correctly rounded.
   *
   */ function naturalExponential(x, sd) {
        var denominator, guard, j, pow, sum, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // 0/NaN/Infinity?
        if (!x.d || !x.d[0] || x.e > 17) return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        // while abs(x) >= 0.1
        while(x.e > -2){
            // x = x / 2^5
            x = x.times(t);
            k += 5;
        }
        // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
        // necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(1);
        Ctor.precision = wpr;
        for(;;){
            pow = finalise(pow.times(x), wpr, 1);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                j = k;
                while(j--)sum = finalise(sum.times(sum), wpr, 1);
                // Check to see if the first 4 rounding digits are [49]999.
                // If so, repeat the summation with a higher precision, otherwise
                // e.g. with precision: 18, rounding: 1
                // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += 10;
                        denominator = pow = t = new Ctor(1);
                        i = 0;
                        rep++;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
        }
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
   * digits.
   *
   *  ln(-n)        = NaN
   *  ln(0)         = -Infinity
   *  ln(-0)        = -Infinity
   *  ln(1)         = 0
   *  ln(Infinity)  = Infinity
   *  ln(-Infinity) = NaN
   *  ln(NaN)       = NaN
   *
   *  ln(n) (n != 1) is non-terminating.
   *
   */ function naturalLogarithm(y, sd) {
        var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // Is x negative or Infinity, NaN, 0 or 1?
        if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        Ctor.precision = wpr += guard;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        if (Math.abs(e = x.e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = x.e;
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = naturalLogarithm(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? finalise(x, pr, rm, external = true) : x;
        }
        // x1 is x reduced to a value near 1.
        x1 = x;
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
        x2 = finalise(x.times(x), wpr, 1);
        denominator = 3;
        for(;;){
            numerator = finalise(numerator.times(x2), wpr, 1);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
                // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr, 1);
                // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
                // been repeated previously) and the first 4 rounding digits 9999?
                // If so, restart the summation with a higher precision, otherwise
                // e.g. with precision: 12, rounding: 1
                // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += guard;
                        t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
                        x2 = finalise(x.times(x), wpr, 1);
                        denominator = rep = 1;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
            denominator += 2;
        }
    }
    // ±Infinity, NaN.
    function nonFiniteToString(x) {
        // Unsigned.
        return String(x.s * x.s / 0);
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // TODO BigInt str: no need to check for decimal point, exponential form or leading zeros.
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48; --len);
        str = str.slice(i, len);
        if (str) {
            len -= i;
            x.e = e = e - i - 1;
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external) {
                // Overflow?
                if (x.e > x.constructor.maxE) {
                    // Infinity.
                    x.d = null;
                    x.e = NaN;
                // Underflow?
                } else if (x.e < x.constructor.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [
                        0
                    ];
                // x.constructor.underflow = true;
                } // else x.constructor.underflow = false;
            }
        } else {
            // Zero.
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
   */ function parseOther(x, str) {
        var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
        if (str.indexOf('_') > -1) {
            str = str.replace(/(\d)_(?=\d)/g, '$1');
            if (isDecimal.test(str)) return parseDecimal(x, str);
        } else if (str === 'Infinity' || str === 'NaN') {
            if (!+str) x.s = NaN;
            x.e = NaN;
            x.d = null;
            return x;
        }
        if (isHex.test(str)) {
            base = 16;
            str = str.toLowerCase();
        } else if (isBinary.test(str)) base = 2;
        else if (isOctal.test(str)) base = 8;
        else throw Error(invalidArgument + str);
        // Is there a binary exponent part?
        i = str.search(/p/i);
        if (i > 0) {
            p = +str.slice(i + 1);
            str = str.substring(2, i);
        } else str = str.slice(2);
        // Convert `str` as an integer then divide the result by `base` raised to a power such that the
        // fraction part will be restored.
        i = str.indexOf('.');
        isFloat = i >= 0;
        Ctor = x.constructor;
        if (isFloat) {
            str = str.replace('.', '');
            len = str.length;
            i = len - i;
            // log[10](16) = 1.2041... , log[10](88) = 1.9444....
            divisor = intPow(Ctor, new Ctor(base), i, i * 2);
        }
        xd = convertBase(str, base, BASE);
        xe = xd.length - 1;
        // Remove trailing zeros.
        for(i = xe; xd[i] === 0; --i)xd.pop();
        if (i < 0) return new Ctor(x.s * 0);
        x.e = getBase10Exponent(xd, xe);
        x.d = xd;
        external = false;
        // At what precision to perform the division to ensure exact conversion?
        // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
        // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
        // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
        // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
        // Therefore using 4 * the number of digits of str will always be enough.
        if (isFloat) x = divide(x, divisor, len * 4);
        // Multiply by the binary exponent part if present.
        if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
        external = true;
        return x;
    }
    /*
   * sin(x) = x - x^3/3! + x^5/5! - ...
   * |x| < pi/2
   *
   */ function sine(Ctor, x) {
        var k, len = x.d.length;
        if (len < 3) return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
        // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
        // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
        // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;
        x = x.times(1 / tinyPow(5, k));
        x = taylorSeries(Ctor, 2, x, x);
        // Reverse argument reduction
        var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for(; k--;){
            sin2_x = x.times(x);
            x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
        }
        return x;
    }
    // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
    function taylorSeries(Ctor, n, x, y, isHyperbolic) {
        var j, t, u, x2, i = 1, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
        external = false;
        x2 = x.times(x);
        u = new Ctor(y);
        for(;;){
            t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
            u = isHyperbolic ? y.plus(t) : y.minus(t);
            y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
            t = u.plus(y);
            if (t.d[k] !== void 0) {
                for(j = k; t.d[j] === u.d[j] && j--;);
                if (j == -1) break;
            }
            j = u;
            u = y;
            y = t;
            t = j;
            i++;
        }
        external = true;
        t.d.length = k + 1;
        return t;
    }
    // Exponent e must be positive and non-zero.
    function tinyPow(b, e) {
        var n = b;
        while(--e)n *= b;
        return n;
    }
    // Return the absolute value of `x` reduced to less than or equal to half pi.
    function toLessThanHalfPi(Ctor, x) {
        var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
        x = x.abs();
        if (x.lte(halfPi)) {
            quadrant = isNeg ? 4 : 1;
            return x;
        }
        t = x.divToInt(pi);
        if (t.isZero()) quadrant = isNeg ? 3 : 2;
        else {
            x = x.minus(t.times(pi));
            // 0 <= x < pi
            if (x.lte(halfPi)) {
                quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
                return x;
            }
            quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
        }
        return x.minus(pi).abs();
    }
    /*
   * Return the value of Decimal `x` as a string in base `baseOut`.
   *
   * If the optional `sd` argument is present include a binary exponent suffix.
   */ function toStringBinary(x, baseOut, sd, rm) {
        var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
        if (isExp) {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        } else {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        }
        if (!x.isFinite()) str = nonFiniteToString(x);
        else {
            str = finiteToString(x);
            i = str.indexOf('.');
            // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
            // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
            // minBinaryExponent = floor(decimalExponent * log[2](10))
            // log[2](10) = 3.321928094887362347870319429489390175864
            if (isExp) {
                base = 2;
                if (baseOut == 16) sd = sd * 4 - 3;
                else if (baseOut == 8) sd = sd * 3 - 2;
            } else base = baseOut;
            // Convert the number as an integer then divide the result by its base raised to a power such
            // that the fraction part will be restored.
            // Non-integer.
            if (i >= 0) {
                str = str.replace('.', '');
                y = new Ctor(1);
                y.e = str.length - i;
                y.d = convertBase(finiteToString(y), 10, base);
                y.e = y.d.length;
            }
            xd = convertBase(str, 10, base);
            e = len = xd.length;
            // Remove trailing zeros.
            for(; xd[--len] == 0;)xd.pop();
            if (!xd[0]) str = isExp ? '0p+0' : '0';
            else {
                if (i < 0) e--;
                else {
                    x = new Ctor(x);
                    x.d = xd;
                    x.e = e;
                    x = divide(x, y, sd, rm, 0, base);
                    xd = x.d;
                    e = x.e;
                    roundUp = inexact;
                }
                // The rounding digit, i.e. the digit after the digit that may be rounded up.
                i = xd[sd];
                k = base / 2;
                roundUp = roundUp || xd[sd + 1] !== void 0;
                roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
                xd.length = sd;
                if (roundUp) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(; ++xd[--sd] > base - 1;){
                    xd[sd] = 0;
                    if (!sd) {
                        ++e;
                        xd.unshift(1);
                    }
                }
                // Determine trailing zeros.
                for(len = xd.length; !xd[len - 1]; --len);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ''; i < len; i++)str += NUMERALS.charAt(xd[i]);
                // Add binary exponent suffix?
                if (isExp) {
                    if (len > 1) {
                        if (baseOut == 16 || baseOut == 8) {
                            i = baseOut == 16 ? 4 : 3;
                            for(--len; len % i; len++)str += '0';
                            xd = convertBase(str, base, baseOut);
                            for(len = xd.length; !xd[len - 1]; --len);
                            // xd[0] will always be be 1
                            for(i = 1, str = '1.'; i < len; i++)str += NUMERALS.charAt(xd[i]);
                        } else str = str.charAt(0) + '.' + str.slice(1);
                    }
                    str = str + (e < 0 ? 'p' : 'p+') + e;
                } else if (e < 0) {
                    for(; ++e;)str = '0' + str;
                    str = '0.' + str;
                } else {
                    if (++e > len) for(e -= len; e--;)str += '0';
                    else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
                }
            }
            str = (baseOut == 16 ? '0x' : baseOut == 2 ? '0b' : baseOut == 8 ? '0o' : '') + str;
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  abs
   *  acos
   *  acosh
   *  add
   *  asin
   *  asinh
   *  atan
   *  atanh
   *  atan2
   *  cbrt
   *  ceil
   *  clamp
   *  clone
   *  config
   *  cos
   *  cosh
   *  div
   *  exp
   *  floor
   *  hypot
   *  ln
   *  log
   *  log2
   *  log10
   *  max
   *  min
   *  mod
   *  mul
   *  pow
   *  random
   *  round
   *  set
   *  sign
   *  sin
   *  sinh
   *  sqrt
   *  sub
   *  sum
   *  tan
   *  tanh
   *  trunc
   */ /*
   * Return a new Decimal whose value is the absolute value of `x`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function abs(x) {
        return new this(x).abs();
    }
    /*
   * Return a new Decimal whose value is the arccosine in radians of `x`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function acos(x) {
        return new this(x).acos();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function acosh(x) {
        return new this(x).acosh();
    }
    /*
   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function add(x, y) {
        return new this(x).plus(y);
    }
    /*
   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function asin(x) {
        return new this(x).asin();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function asinh(x) {
        return new this(x).asinh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function atan(x) {
        return new this(x).atan();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function atanh(x) {
        return new this(x).atanh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi, pi]
   *
   * y {number|string|bigint|Decimal} The y-coordinate.
   * x {number|string|bigint|Decimal} The x-coordinate.
   *
   * atan2(±0, -0)               = ±pi
   * atan2(±0, +0)               = ±0
   * atan2(±0, -x)               = ±pi for x > 0
   * atan2(±0, x)                = ±0 for x > 0
   * atan2(-y, ±0)               = -pi/2 for y > 0
   * atan2(y, ±0)                = pi/2 for y > 0
   * atan2(±y, -Infinity)        = ±pi for finite y > 0
   * atan2(±y, +Infinity)        = ±0 for finite y > 0
   * atan2(±Infinity, x)         = ±pi/2 for finite x
   * atan2(±Infinity, -Infinity) = ±3*pi/4
   * atan2(±Infinity, +Infinity) = ±pi/4
   * atan2(NaN, x) = NaN
   * atan2(y, NaN) = NaN
   *
   */ function atan2(y, x) {
        y = new this(y);
        x = new this(x);
        var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
        // Either NaN
        if (!y.s || !x.s) r = new this(NaN);
        else if (!y.d && !x.d) {
            r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
            r.s = y.s;
        // x is ±Infinity or y is ±0
        } else if (!x.d || y.isZero()) {
            r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
            r.s = y.s;
        // y is ±Infinity or x is ±0
        } else if (!y.d || x.isZero()) {
            r = getPi(this, wpr, 1).times(0.5);
            r.s = y.s;
        // Both non-zero and finite
        } else if (x.s < 0) {
            this.precision = wpr;
            this.rounding = 1;
            r = this.atan(divide(y, x, wpr, 1));
            x = getPi(this, wpr, 1);
            this.precision = pr;
            this.rounding = rm;
            r = y.s < 0 ? r.minus(x) : r.plus(x);
        } else r = this.atan(divide(y, x, wpr, 1));
        return r;
    }
    /*
   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function cbrt(x) {
        return new this(x).cbrt();
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function ceil(x) {
        return finalise(x = new this(x), x.e + 1, 2);
    }
    /*
   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
   *
   * x {number|string|bigint|Decimal}
   * min {number|string|bigint|Decimal}
   * max {number|string|bigint|Decimal}
   *
   */ function clamp(x, min, max) {
        return new this(x).clamp(min, max);
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *   maxE       {number}
   *   minE       {number}
   *   modulo     {number}
   *   crypto     {boolean|number}
   *   defaults   {true}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, useDefaults = obj.defaults === true, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -EXP_LIMIT,
            0,
            'toExpPos',
            0,
            EXP_LIMIT,
            'maxE',
            0,
            EXP_LIMIT,
            'minE',
            -EXP_LIMIT,
            0,
            'modulo',
            0,
            9
        ];
        for(i = 0; i < ps.length; i += 3){
            if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
            if ((v = obj[p]) !== void 0) {
                if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
                else throw Error(invalidArgument + p + ': ' + v);
            }
        }
        if (p = 'crypto', useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
            if (v === true || v === false || v === 0 || v === 1) {
                if (v) {
                    if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[p] = true;
                    else throw Error(cryptoUnavailable);
                } else this[p] = false;
            } else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    /*
   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function cos(x) {
        return new this(x).cos();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function cosh(x) {
        return new this(x).cosh();
    }
    /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * v {number|string|bigint|Decimal} A numeric value.
     *
     */ function Decimal(v) {
            var e, i, t, x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(v);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            if (isDecimalInstance(v)) {
                x.s = v.s;
                if (external) {
                    if (!v.d || v.e > Decimal.maxE) {
                        // Infinity.
                        x.e = NaN;
                        x.d = null;
                    } else if (v.e < Decimal.minE) {
                        // Zero.
                        x.e = 0;
                        x.d = [
                            0
                        ];
                    } else {
                        x.e = v.e;
                        x.d = v.d.slice();
                    }
                } else {
                    x.e = v.e;
                    x.d = v.d ? v.d.slice() : v.d;
                }
                return;
            }
            t = typeof v;
            if (t === 'number') {
                if (v === 0) {
                    x.s = 1 / v < 0 ? -1 : 1;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                // Fast path for small integers.
                if (v === ~~v && v < 1e7) {
                    for(e = 0, i = v; i >= 10; i /= 10)e++;
                    if (external) {
                        if (e > Decimal.maxE) {
                            x.e = NaN;
                            x.d = null;
                        } else if (e < Decimal.minE) {
                            x.e = 0;
                            x.d = [
                                0
                            ];
                        } else {
                            x.e = e;
                            x.d = [
                                v
                            ];
                        }
                    } else {
                        x.e = e;
                        x.d = [
                            v
                        ];
                    }
                    return;
                }
                // Infinity or NaN?
                if (v * 0 !== 0) {
                    if (!v) x.s = NaN;
                    x.e = NaN;
                    x.d = null;
                    return;
                }
                return parseDecimal(x, v.toString());
            }
            if (t === 'string') {
                if ((i = v.charCodeAt(0)) === 45) {
                    v = v.slice(1);
                    x.s = -1;
                } else {
                    if (i === 43) v = v.slice(1); // plus sign
                    x.s = 1;
                }
                return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
            }
            if (t === 'bigint') {
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                return parseDecimal(x, v.toString());
            }
            throw Error(invalidArgument + v);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.EUCLID = 9;
        Decimal.config = Decimal.set = config;
        Decimal.clone = clone;
        Decimal.isDecimal = isDecimalInstance;
        Decimal.abs = abs;
        Decimal.acos = acos;
        Decimal.acosh = acosh; // ES6
        Decimal.add = add;
        Decimal.asin = asin;
        Decimal.asinh = asinh; // ES6
        Decimal.atan = atan;
        Decimal.atanh = atanh; // ES6
        Decimal.atan2 = atan2;
        Decimal.cbrt = cbrt; // ES6
        Decimal.ceil = ceil;
        Decimal.clamp = clamp;
        Decimal.cos = cos;
        Decimal.cosh = cosh; // ES6
        Decimal.div = div;
        Decimal.exp = exp;
        Decimal.floor = floor;
        Decimal.hypot = hypot; // ES6
        Decimal.ln = ln;
        Decimal.log = log;
        Decimal.log10 = log10; // ES6
        Decimal.log2 = log2; // ES6
        Decimal.max = max;
        Decimal.min = min;
        Decimal.mod = mod;
        Decimal.mul = mul;
        Decimal.pow = pow;
        Decimal.random = random;
        Decimal.round = round;
        Decimal.sign = sign; // ES6
        Decimal.sin = sin;
        Decimal.sinh = sinh; // ES6
        Decimal.sqrt = sqrt;
        Decimal.sub = sub;
        Decimal.sum = sum;
        Decimal.tan = tan;
        Decimal.tanh = tanh; // ES6
        Decimal.trunc = trunc; // ES6
        if (obj === void 0) obj = {};
        if (obj) {
            if (obj.defaults !== true) {
                ps = [
                    'precision',
                    'rounding',
                    'toExpNeg',
                    'toExpPos',
                    'maxE',
                    'minE',
                    'modulo',
                    'crypto'
                ];
                for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
            }
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function div(x, y) {
        return new this(x).div(y);
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} The power to which to raise the base of the natural log.
   *
   */ function exp(x) {
        return new this(x).exp();
    }
    /*
   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function floor(x) {
        return finalise(x = new this(x), x.e + 1, 3);
    }
    /*
   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
   *
   * arguments {number|string|bigint|Decimal}
   *
   */ function hypot() {
        var i, n, t = new this(0);
        external = false;
        for(i = 0; i < arguments.length;){
            n = new this(arguments[i++]);
            if (!n.d) {
                if (n.s) {
                    external = true;
                    return new this(1 / 0);
                }
                t = n;
            } else if (t.d) t = t.plus(n.times(n));
        }
        external = true;
        return t.sqrt();
    }
    /*
   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
   * otherwise return false.
   *
   */ function isDecimalInstance(obj) {
        return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function ln(x) {
        return new this(x).ln();
    }
    /*
   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * log[y](x)
   *
   * x {number|string|bigint|Decimal} The argument of the logarithm.
   * y {number|string|bigint|Decimal} The base of the logarithm.
   *
   */ function log(x, y) {
        return new this(x).log(y);
    }
    /*
   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function log2(x) {
        return new this(x).log(2);
    }
    /*
   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function log10(x) {
        return new this(x).log(10);
    }
    /*
   * Return a new Decimal whose value is the maximum of the arguments.
   *
   * arguments {number|string|bigint|Decimal}
   *
   */ function max() {
        return maxOrMin(this, arguments, -1);
    }
    /*
   * Return a new Decimal whose value is the minimum of the arguments.
   *
   * arguments {number|string|bigint|Decimal}
   *
   */ function min() {
        return maxOrMin(this, arguments, 1);
    }
    /*
   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function mod(x, y) {
        return new this(x).mod(y);
    }
    /*
   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function mul(x, y) {
        return new this(x).mul(y);
    }
    /*
   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} The base.
   * y {number|string|bigint|Decimal} The exponent.
   *
   */ function pow(x, y) {
        return new this(x).pow(y);
    }
    /*
   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
   * are produced).
   *
   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
   *
   */ function random(sd) {
        var d, e, k, n, i = 0, r = new this(1), rd = [];
        if (sd === void 0) sd = this.precision;
        else checkInt32(sd, 1, MAX_DIGITS);
        k = Math.ceil(sd / LOG_BASE);
        if (!this.crypto) for(; i < k;)rd[i++] = Math.random() * 1e7 | 0;
        else if (crypto.getRandomValues) {
            d = crypto.getRandomValues(new Uint32Array(k));
            for(; i < k;){
                n = d[i];
                // 0 <= n < 4294967296
                // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
                if (n >= 4.29e9) d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
                else // 0 <= n <= 4289999999
                // 0 <= (n % 1e7) <= 9999999
                rd[i++] = n % 1e7;
            }
        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {
            // buffer
            d = crypto.randomBytes(k *= 4);
            for(; i < k;){
                // 0 <= n < 2147483648
                n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
                // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
                if (n >= 2.14e9) crypto.randomBytes(4).copy(d, i);
                else {
                    // 0 <= n <= 2139999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd.push(n % 1e7);
                    i += 4;
                }
            }
            i = k / 4;
        } else throw Error(cryptoUnavailable);
        k = rd[--i];
        sd %= LOG_BASE;
        // Convert trailing digits to zeros according to sd.
        if (k && sd) {
            n = mathpow(10, LOG_BASE - sd);
            rd[i] = (k / n | 0) * n;
        }
        // Remove trailing words which are zero.
        for(; rd[i] === 0; i--)rd.pop();
        // Zero?
        if (i < 0) {
            e = 0;
            rd = [
                0
            ];
        } else {
            e = -1;
            // Remove leading words which are zero and adjust exponent accordingly.
            for(; rd[0] === 0; e -= LOG_BASE)rd.shift();
            // Count the digits of the first word of rd to determine leading zeros.
            for(k = 1, n = rd[0]; n >= 10; n /= 10)k++;
            // Adjust the exponent for leading zeros of the first word of rd.
            if (k < LOG_BASE) e -= LOG_BASE - k;
        }
        r.e = e;
        r.d = rd;
        return r;
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
   *
   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
   *
   * x {number|string|bigint|Decimal}
   *
   */ function round(x) {
        return finalise(x = new this(x), x.e + 1, this.rounding);
    }
    /*
   * Return
   *   1    if x > 0,
   *  -1    if x < 0,
   *   0    if x is 0,
   *  -0    if x is -0,
   *   NaN  otherwise
   *
   * x {number|string|bigint|Decimal}
   *
   */ function sign(x) {
        x = new this(x);
        return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
    }
    /*
   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function sin(x) {
        return new this(x).sin();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function sinh(x) {
        return new this(x).sinh();
    }
    /*
   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function sqrt(x) {
        return new this(x).sqrt();
    }
    /*
   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal}
   * y {number|string|bigint|Decimal}
   *
   */ function sub(x, y) {
        return new this(x).sub(y);
    }
    /*
   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * Only the result is rounded, not the intermediate calculations.
   *
   * arguments {number|string|bigint|Decimal}
   *
   */ function sum() {
        var i = 0, args = arguments, x = new this(args[i]);
        external = false;
        for(; x.s && ++i < args.length;)x = x.plus(args[i]);
        external = true;
        return finalise(x, this.precision, this.rounding);
    }
    /*
   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function tan(x) {
        return new this(x).tan();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|bigint|Decimal} A value in radians.
   *
   */ function tanh(x) {
        return new this(x).tanh();
    }
    /*
   * Return a new Decimal whose value is `x` truncated to an integer.
   *
   * x {number|string|bigint|Decimal}
   *
   */ function trunc(x) {
        return finalise(x = new this(x), x.e + 1, 1);
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(DEFAULTS);
    Decimal.prototype.constructor = Decimal;
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Create the internal constants from their string values.
    LN10 = new Decimal(LN10);
    PI = new Decimal(PI);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (module.exports) {
        if (typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol') {
            P[Symbol['for']('nodejs.util.inspect.custom')] = P.toString;
            P[Symbol.toStringTag] = 'Decimal';
        }
        module.exports = Decimal;
    // Browser.
    } else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : window;
        noConflict = globalScope.Decimal;
        Decimal.noConflict = function() {
            globalScope.Decimal = noConflict;
            return Decimal;
        };
        globalScope.Decimal = Decimal;
    }
})(module.exports);

});


parcelRegister("1HJ6i", function(module, exports) {

$parcel$export(module.exports, "createBin", () => $13dccaa4d05d0368$export$a770ddfd7e536064);

var $4eE2e = parcelRequire("4eE2e");
var $13dccaa4d05d0368$var$name = 'bin';
var $13dccaa4d05d0368$var$dependencies = [
    'typed',
    'format'
];
var $13dccaa4d05d0368$export$a770ddfd7e536064 = (0, $4eE2e.factory)($13dccaa4d05d0368$var$name, $13dccaa4d05d0368$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($13dccaa4d05d0368$var$name, {
        'number | BigNumber': function numberBigNumber(n) {
            return format(n, {
                notation: 'bin'
            });
        },
        'number | BigNumber, number': function numberBigNumberNumber(n, wordSize) {
            return format(n, {
                notation: 'bin',
                wordSize: wordSize
            });
        }
    });
});

});

parcelRegister("em9kx", function(module, exports) {

$parcel$export(module.exports, "createBitAnd", () => $02b27d58e9aa3357$export$bea4e06c5befec3b);

var $2hy17 = parcelRequire("2hy17");

var $5IUkw = parcelRequire("5IUkw");

var $hXAgg = parcelRequire("hXAgg");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");

var $eIf4a = parcelRequire("eIf4a");

var $4eE2e = parcelRequire("4eE2e");

var $aFhba = parcelRequire("aFhba");
var $02b27d58e9aa3357$var$name = 'bitAnd';
var $02b27d58e9aa3357$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar'
];
var $02b27d58e9aa3357$export$bea4e06c5befec3b = /* #__PURE__ */ (0, $4eE2e.factory)($02b27d58e9aa3357$var$name, $02b27d58e9aa3357$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar } = _ref;
    var algorithm02 = (0, $5IUkw.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $eIf4a.createAlgorithm06)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise AND two values, `x & y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitAnd(x, y)
   *
   * Examples:
   *
   *    math.bitAnd(53, 131)               // returns number 1
   *
   *    math.bitAnd([1, 12, 31], 42)       // returns Array [0, 8, 10]
   *
   * See also:
   *
   *    bitNot, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to and
   * @param  {number | BigNumber | Array | Matrix} y Second value to and
   * @return {number | BigNumber | Array | Matrix} AND of `x` and `y`
   */ return typed($02b27d58e9aa3357$var$name, {
        'number, number': (0, $aFhba.bitAndNumber),
        'BigNumber, BigNumber': (0, $2hy17.bitAndBigNumber),
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, this, false);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm11(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});

});
parcelRegister("2hy17", function(module, exports) {

$parcel$export(module.exports, "bitAndBigNumber", () => $1a978e65d4dbabf9$export$94757ce5cf54fec9);
$parcel$export(module.exports, "bitNotBigNumber", () => $1a978e65d4dbabf9$export$2ada53b3c51e9645);
$parcel$export(module.exports, "bitOrBigNumber", () => $1a978e65d4dbabf9$export$e43ec6c4cff46d2c);
$parcel$export(module.exports, "bitXor", () => $1a978e65d4dbabf9$export$bfcff4501301c191);
$parcel$export(module.exports, "leftShiftBigNumber", () => $1a978e65d4dbabf9$export$626dff8098a67b4c);
$parcel$export(module.exports, "rightArithShiftBigNumber", () => $1a978e65d4dbabf9$export$d489c03691bd4cd);
/**
 * Bitwise and for Bignumbers
 *
 * Special Cases:
 *   N &  n =  N
 *   n &  0 =  0
 *   n & -1 =  n
 *   n &  n =  n
 *   I &  I =  I
 *  -I & -I = -I
 *   I & -I =  0
 *   I &  n =  n
 *   I & -n =  I
 *  -I &  n =  0
 *  -I & -n = -I
 *
 * @param {BigNumber} x
 * @param {BigNumber} y
 * @return {BigNumber} Result of `x` & `y`, is fully precise
 * @private
 */ function $1a978e65d4dbabf9$export$94757ce5cf54fec9(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error('Integers expected in function bitAnd');
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero() || y.eq(-1) || x.eq(y)) return x;
    if (y.isZero() || x.eq(-1)) return y;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) {
            if (x.isNegative() === y.isNegative()) return x;
            return new BigNumber(0);
        }
        if (!x.isFinite()) {
            if (y.isNegative()) return x;
            if (x.isNegative()) return new BigNumber(0);
            return y;
        }
        if (!y.isFinite()) {
            if (x.isNegative()) return y;
            if (y.isNegative()) return new BigNumber(0);
            return x;
        }
    }
    return $1a978e65d4dbabf9$export$884842863a0853c4(x, y, function(a, b) {
        return a & b;
    });
}
function $1a978e65d4dbabf9$export$2ada53b3c51e9645(x) {
    if (x.isFinite() && !x.isInteger()) throw new Error('Integer expected in function bitNot');
    var BigNumber = x.constructor;
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    var result = x.plus(new BigNumber(1));
    result.s = -result.s || null;
    BigNumber.config({
        precision: prevPrec
    });
    return result;
}
function $1a978e65d4dbabf9$export$e43ec6c4cff46d2c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error('Integers expected in function bitOr');
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    var negOne = new BigNumber(-1);
    if (x.isZero() || y.eq(negOne) || x.eq(y)) return y;
    if (y.isZero() || x.eq(negOne)) return x;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !x.isNegative() && y.isNegative() || x.isNegative() && !y.isNegative() && !y.isFinite()) return negOne;
        if (x.isNegative() && y.isNegative()) return x.isFinite() ? x : y;
        return x.isFinite() ? y : x;
    }
    return $1a978e65d4dbabf9$export$884842863a0853c4(x, y, function(a, b) {
        return a | b;
    });
}
function $1a978e65d4dbabf9$export$884842863a0853c4(x, y, func) {
    var BigNumber = x.constructor;
    var xBits, yBits;
    var xSign = +(x.s < 0);
    var ySign = +(y.s < 0);
    if (xSign) {
        xBits = $1a978e65d4dbabf9$var$decCoefficientToBinaryString($1a978e65d4dbabf9$export$2ada53b3c51e9645(x));
        for(var i = 0; i < xBits.length; ++i)xBits[i] ^= 1;
    } else xBits = $1a978e65d4dbabf9$var$decCoefficientToBinaryString(x);
    if (ySign) {
        yBits = $1a978e65d4dbabf9$var$decCoefficientToBinaryString($1a978e65d4dbabf9$export$2ada53b3c51e9645(y));
        for(var _i = 0; _i < yBits.length; ++_i)yBits[_i] ^= 1;
    } else yBits = $1a978e65d4dbabf9$var$decCoefficientToBinaryString(y);
    var minBits, maxBits, minSign;
    if (xBits.length <= yBits.length) {
        minBits = xBits;
        maxBits = yBits;
        minSign = xSign;
    } else {
        minBits = yBits;
        maxBits = xBits;
        minSign = ySign;
    }
    var shortLen = minBits.length;
    var longLen = maxBits.length;
    var expFuncVal = func(xSign, ySign) ^ 1;
    var outVal = new BigNumber(expFuncVal ^ 1);
    var twoPower = new BigNumber(1);
    var two = new BigNumber(2);
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    while(shortLen > 0){
        if (func(minBits[--shortLen], maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    while(longLen > 0){
        if (func(minSign, maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    BigNumber.config({
        precision: prevPrec
    });
    if (expFuncVal === 0) outVal.s = -outVal.s;
    return outVal;
}
/* Extracted from decimal.js, and edited to specialize. */ function $1a978e65d4dbabf9$var$decCoefficientToBinaryString(x) {
    // Convert to string
    var a = x.d; // array with digits
    var r = a[0] + '';
    for(var i = 1; i < a.length; ++i){
        var s = a[i] + '';
        for(var z = 7 - s.length; z--;)s = '0' + s;
        r += s;
    }
    var j = r.length;
    while(r.charAt(j) === '0')j--;
    var xe = x.e;
    var str = r.slice(0, j + 1 || 1);
    var strL = str.length;
    if (xe > 0) {
        if (++xe > strL) {
            // Append zeros.
            xe -= strL;
            while(xe--)str += '0';
        } else if (xe < strL) str = str.slice(0, xe) + '.' + str.slice(xe);
    } // Convert from base 10 (decimal) to base 2
    var arr = [
        0
    ];
    for(var _i2 = 0; _i2 < str.length;){
        var arrL = arr.length;
        while(arrL--)arr[arrL] *= 10;
        arr[0] += parseInt(str.charAt(_i2++)); // convert to int
        for(var _j = 0; _j < arr.length; ++_j)if (arr[_j] > 1) {
            if (arr[_j + 1] === null || arr[_j + 1] === undefined) arr[_j + 1] = 0;
            arr[_j + 1] += arr[_j] >> 1;
            arr[_j] &= 1;
        }
    }
    return arr.reverse();
}
function $1a978e65d4dbabf9$export$bfcff4501301c191(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error('Integers expected in function bitXor');
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero()) return y;
    if (y.isZero()) return x;
    if (x.eq(y)) return new BigNumber(0);
    var negOne = new BigNumber(-1);
    if (x.eq(negOne)) return $1a978e65d4dbabf9$export$2ada53b3c51e9645(y);
    if (y.eq(negOne)) return $1a978e65d4dbabf9$export$2ada53b3c51e9645(x);
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) return negOne;
        return new BigNumber(x.isNegative() === y.isNegative() ? Infinity : -Infinity);
    }
    return $1a978e65d4dbabf9$export$884842863a0853c4(x, y, function(a, b) {
        return a ^ b;
    });
}
function $1a978e65d4dbabf9$export$626dff8098a67b4c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error('Integers expected in function leftShift');
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!x.isFinite() && !y.isFinite()) return new BigNumber(NaN);
     // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.times(Math.pow(2, y.toNumber()) + '');
    return x.times(new BigNumber(2).pow(y));
}
function $1a978e65d4dbabf9$export$d489c03691bd4cd(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error('Integers expected in function rightArithShift');
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!y.isFinite()) {
        if (x.isNegative()) return new BigNumber(-1);
        if (!x.isFinite()) return new BigNumber(NaN);
        return new BigNumber(0);
    } // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.div(Math.pow(2, y.toNumber()) + '').floor();
    return x.div(new BigNumber(2).pow(y)).floor();
}

});

parcelRegister("aFhba", function(module, exports) {

$parcel$export(module.exports, "bitAndNumber", () => $7c3b0f24181a1eac$export$e7607930867bd49a);
$parcel$export(module.exports, "bitNotNumber", () => $7c3b0f24181a1eac$export$22a2b2a0351218e7);
$parcel$export(module.exports, "bitOrNumber", () => $7c3b0f24181a1eac$export$9aecb772cb5ad1c7);
$parcel$export(module.exports, "bitXorNumber", () => $7c3b0f24181a1eac$export$2260a44ec1c987dc);
$parcel$export(module.exports, "leftShiftNumber", () => $7c3b0f24181a1eac$export$65c07a47901525ba);
$parcel$export(module.exports, "rightArithShiftNumber", () => $7c3b0f24181a1eac$export$b6d96f775be90000);
$parcel$export(module.exports, "rightLogShiftNumber", () => $7c3b0f24181a1eac$export$2a8d1e3dcede6e47);

var $6egKm = parcelRequire("6egKm");
var $7c3b0f24181a1eac$var$n1 = 'number';
var $7c3b0f24181a1eac$var$n2 = 'number, number';
function $7c3b0f24181a1eac$export$e7607930867bd49a(x, y) {
    if (!(0, $6egKm.isInteger)(x) || !(0, $6egKm.isInteger)(y)) throw new Error('Integers expected in function bitAnd');
    return x & y;
}
$7c3b0f24181a1eac$export$e7607930867bd49a.signature = $7c3b0f24181a1eac$var$n2;
function $7c3b0f24181a1eac$export$22a2b2a0351218e7(x) {
    if (!(0, $6egKm.isInteger)(x)) throw new Error('Integer expected in function bitNot');
    return ~x;
}
$7c3b0f24181a1eac$export$22a2b2a0351218e7.signature = $7c3b0f24181a1eac$var$n1;
function $7c3b0f24181a1eac$export$9aecb772cb5ad1c7(x, y) {
    if (!(0, $6egKm.isInteger)(x) || !(0, $6egKm.isInteger)(y)) throw new Error('Integers expected in function bitOr');
    return x | y;
}
$7c3b0f24181a1eac$export$9aecb772cb5ad1c7.signature = $7c3b0f24181a1eac$var$n2;
function $7c3b0f24181a1eac$export$2260a44ec1c987dc(x, y) {
    if (!(0, $6egKm.isInteger)(x) || !(0, $6egKm.isInteger)(y)) throw new Error('Integers expected in function bitXor');
    return x ^ y;
}
$7c3b0f24181a1eac$export$2260a44ec1c987dc.signature = $7c3b0f24181a1eac$var$n2;
function $7c3b0f24181a1eac$export$65c07a47901525ba(x, y) {
    if (!(0, $6egKm.isInteger)(x) || !(0, $6egKm.isInteger)(y)) throw new Error('Integers expected in function leftShift');
    return x << y;
}
$7c3b0f24181a1eac$export$65c07a47901525ba.signature = $7c3b0f24181a1eac$var$n2;
function $7c3b0f24181a1eac$export$b6d96f775be90000(x, y) {
    if (!(0, $6egKm.isInteger)(x) || !(0, $6egKm.isInteger)(y)) throw new Error('Integers expected in function rightArithShift');
    return x >> y;
}
$7c3b0f24181a1eac$export$b6d96f775be90000.signature = $7c3b0f24181a1eac$var$n2;
function $7c3b0f24181a1eac$export$2a8d1e3dcede6e47(x, y) {
    if (!(0, $6egKm.isInteger)(x) || !(0, $6egKm.isInteger)(y)) throw new Error('Integers expected in function rightLogShift');
    return x >>> y;
}
$7c3b0f24181a1eac$export$2a8d1e3dcede6e47.signature = $7c3b0f24181a1eac$var$n2;

});


parcelRegister("huYRB", function(module, exports) {

$parcel$export(module.exports, "createBitNot", () => $cbd4733ca2504297$export$9e7f3c72ca8b5aa);

var $2hy17 = parcelRequire("2hy17");

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");

var $aFhba = parcelRequire("aFhba");
var $cbd4733ca2504297$var$name = 'bitNot';
var $cbd4733ca2504297$var$dependencies = [
    'typed'
];
var $cbd4733ca2504297$export$9e7f3c72ca8b5aa = /* #__PURE__ */ (0, $4eE2e.factory)($cbd4733ca2504297$var$name, $cbd4733ca2504297$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Bitwise NOT value, `~x`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.bitNot(x)
   *
   * Examples:
   *
   *    math.bitNot(1)               // returns number -2
   *
   *    math.bitNot([2, -3, 4])      // returns Array [-3, 2, 5]
   *
   * See also:
   *
   *    bitAnd, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to not
   * @return {number | BigNumber | Array | Matrix} NOT of `x`
   */ return typed($cbd4733ca2504297$var$name, {
        number: (0, $aFhba.bitNotNumber),
        BigNumber: (0, $2hy17.bitNotBigNumber),
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("ed2ke", function(module, exports) {

$parcel$export(module.exports, "createBitOr", () => $a584155daf500b37$export$f45a7846535e9b07);

var $2hy17 = parcelRequire("2hy17");

var $4eE2e = parcelRequire("4eE2e");

var $laEuG = parcelRequire("laEuG");

var $KKjvJ = parcelRequire("KKjvJ");

var $ecxvm = parcelRequire("ecxvm");

var $fF2Gm = parcelRequire("fF2Gm");

var $bCo9f = parcelRequire("bCo9f");

var $aFhba = parcelRequire("aFhba");
var $a584155daf500b37$var$name = 'bitOr';
var $a584155daf500b37$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'DenseMatrix'
];
var $a584155daf500b37$export$f45a7846535e9b07 = /* #__PURE__ */ (0, $4eE2e.factory)($a584155daf500b37$var$name, $a584155daf500b37$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $bCo9f.createAlgorithm01)({
        typed: typed
    });
    var algorithm04 = (0, $fF2Gm.createAlgorithm04)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $ecxvm.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise OR two values, `x | y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the lowest print base.
   *
   * Syntax:
   *
   *    math.bitOr(x, y)
   *
   * Examples:
   *
   *    math.bitOr(1, 2)               // returns number 3
   *
   *    math.bitOr([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to or
   * @param  {number | BigNumber | Array | Matrix} y Second value to or
   * @return {number | BigNumber | Array | Matrix} OR of `x` and `y`
   */ return typed($a584155daf500b37$var$name, {
        'number, number': (0, $aFhba.bitOrNumber),
        'BigNumber, BigNumber': (0, $2hy17.bitOrBigNumber),
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, this);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm10(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm10(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});

});

parcelRegister("2JIUE", function(module, exports) {

$parcel$export(module.exports, "createBitXor", () => $1fe29f79375823c4$export$1cae728fa8e01928);

var $2hy17 = parcelRequire("2hy17");

var $6MKpt = parcelRequire("6MKpt");

var $ai5Sw = parcelRequire("ai5Sw");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");

var $4eE2e = parcelRequire("4eE2e");

var $aFhba = parcelRequire("aFhba");
var $1fe29f79375823c4$var$name = 'bitXor';
var $1fe29f79375823c4$var$dependencies = [
    'typed',
    'matrix',
    'DenseMatrix'
];
var $1fe29f79375823c4$export$1cae728fa8e01928 = /* #__PURE__ */ (0, $4eE2e.factory)($1fe29f79375823c4$var$name, $1fe29f79375823c4$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $ai5Sw.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise XOR two values, `x ^ y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitXor(x, y)
   *
   * Examples:
   *
   *    math.bitXor(1, 2)               // returns number 3
   *
   *    math.bitXor([2, 3, 4], 4)       // returns Array [6, 7, 0]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to xor
   * @param  {number | BigNumber | Array | Matrix} y Second value to xor
   * @return {number | BigNumber | Array | Matrix} XOR of `x` and `y`
   */ return typed($1fe29f79375823c4$var$name, {
        'number, number': (0, $aFhba.bitXorNumber),
        'BigNumber, BigNumber': (0, $2hy17.bitXor),
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});

});
parcelRegister("ai5Sw", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm07", () => $77e025284f7fd201$export$b908fb77c4366999);

var $4eE2e = parcelRequire("4eE2e");

var $iAoVB = parcelRequire("iAoVB");
var $77e025284f7fd201$var$name = 'algorithm07';
var $77e025284f7fd201$var$dependencies = [
    'typed',
    'DenseMatrix'
];
var $77e025284f7fd201$export$b908fb77c4366999 = /* #__PURE__ */ (0, $4eE2e.factory)($77e025284f7fd201$var$name, $77e025284f7fd201$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B items (zero and nonzero) and invokes the callback function f(Aij, Bij).
   * Callback function invoked MxN times.
   *
   * C(i,j) = f(Aij, Bij)
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm07(a, b, callback) {
        // sparse matrix arrays
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $iAoVB.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // vars
        var i, j; // result arrays
        var cdata = []; // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
         // workspaces
        var xa = [];
        var xb = []; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // loop columns
        for(j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // scatter the values of A(:,j) into workspace
            _scatter(a, j, wa, xa, mark); // scatter the values of B(:,j) into workspace
            _scatter(b, j, wb, xb, mark); // loop rows
            for(i = 0; i < rows; i++){
                // matrix values @ i,j
                var va = wa[i] === mark ? xa[i] : zero;
                var vb = wb[i] === mark ? xb[i] : zero; // invoke callback
                cdata[i][j] = cf(va, vb);
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
    function _scatter(m, j, w, x, mark) {
        // a arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // loop values in column j
        for(var k = ptr[j], k1 = ptr[j + 1]; k < k1; k++){
            // row
            var i = index[k]; // update workspace
            w[i] = mark;
            x[i] = values[k];
        }
    }
});

});


parcelRegister("8sQFM", function(module, exports) {

$parcel$export(module.exports, "createBoolean", () => $6299cbfbba27646a$export$3c82aec2d86a5525);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $6299cbfbba27646a$var$name = 'boolean';
var $6299cbfbba27646a$var$dependencies = [
    'typed'
];
var $6299cbfbba27646a$export$3c82aec2d86a5525 = /* #__PURE__ */ (0, $4eE2e.factory)($6299cbfbba27646a$var$name, $6299cbfbba27646a$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a boolean or convert a string or number to a boolean.
   * In case of a number, `true` is returned for non-zero numbers, and `false` in
   * case of zero.
   * Strings can be `'true'` or `'false'`, or can contain a number.
   * When value is a matrix, all elements will be converted to boolean.
   *
   * Syntax:
   *
   *    math.boolean(x)
   *
   * Examples:
   *
   *    math.boolean(0)     // returns false
   *    math.boolean(1)     // returns true
   *    math.boolean(-3)     // returns true
   *    math.boolean('true')     // returns true
   *    math.boolean('false')     // returns false
   *    math.boolean([1, 0, 1, 1])     // returns [true, false, true, true]
   *
   * See also:
   *
   *    bignumber, complex, index, matrix, string, unit
   *
   * @param {string | number | boolean | Array | Matrix | null} value  A value of any type
   * @return {boolean | Array | Matrix} The boolean value
   */ return typed($6299cbfbba27646a$var$name, {
        '': function _() {
            return false;
        },
        boolean: function boolean(x) {
            return x;
        },
        number: function number(x) {
            return !!x;
        },
        null: function _null(x) {
            return false;
        },
        BigNumber: function BigNumber(x) {
            return !x.isZero();
        },
        string: function string(x) {
            // try case insensitive
            var lcase = x.toLowerCase();
            if (lcase === 'true') return true;
            else if (lcase === 'false') return false;
             // test whether value is a valid number
            var num = Number(x);
            if (x !== '' && !isNaN(num)) return !!num;
            throw new Error('Cannot convert "' + x + '" to a boolean');
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("Xa8Ku", function(module, exports) {

$parcel$export(module.exports, "createCatalan", () => $0b1d606ad69f44db$export$5a3f7692f3d4dd50);

var $4eE2e = parcelRequire("4eE2e");
var $0b1d606ad69f44db$var$name = 'catalan';
var $0b1d606ad69f44db$var$dependencies = [
    'typed',
    'addScalar',
    'divideScalar',
    'multiplyScalar',
    'combinations',
    'isNegative',
    'isInteger'
];
var $0b1d606ad69f44db$export$5a3f7692f3d4dd50 = /* #__PURE__ */ (0, $4eE2e.factory)($0b1d606ad69f44db$var$name, $0b1d606ad69f44db$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, combinations: combinations, isNegative: isNegative, isInteger: isInteger } = _ref;
    /**
   * The Catalan Numbers enumerate combinatorial structures of many different types.
   * catalan only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.catalan(n)
   *
   * Examples:
   *
   *    math.catalan(3) // returns 5
   *    math.catalan(8) // returns 1430
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    nth Catalan number
   * @return {Number | BigNumber}     Cn(n)
   */ return typed($0b1d606ad69f44db$var$name, {
        'number | BigNumber': function numberBigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError('Non-negative integer value expected in function catalan');
            return divideScalar(combinations(multiplyScalar(n, 2), n), addScalar(n, 1));
        }
    });
});

});

parcelRegister("ioRMl", function(module, exports) {

$parcel$export(module.exports, "createCbrt", () => $d6542f3527458f71$export$2103fed9c34b0004);

var $4eE2e = parcelRequire("4eE2e");

var $gs7TF = parcelRequire("gs7TF");

var $9nwyh = parcelRequire("9nwyh");

var $eRNhQ = parcelRequire("eRNhQ");
var $d6542f3527458f71$var$name = 'cbrt';
var $d6542f3527458f71$var$dependencies = [
    'config',
    'typed',
    'isNegative',
    'unaryMinus',
    'matrix',
    'Complex',
    'BigNumber',
    'Fraction'
];
var $d6542f3527458f71$export$2103fed9c34b0004 = /* #__PURE__ */ (0, $4eE2e.factory)($d6542f3527458f71$var$name, $d6542f3527458f71$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, isNegative: isNegative, unaryMinus: unaryMinus, matrix: matrix, Complex: Complex, BigNumber: BigNumber, Fraction: Fraction } = _ref;
    /**
   * Calculate the cubic root of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cbrt(x)
   *    math.cbrt(x, allRoots)
   *
   * Examples:
   *
   *    math.cbrt(27)                  // returns 3
   *    math.cube(3)                   // returns 27
   *    math.cbrt(-64)                 // returns -4
   *    math.cbrt(math.unit('27 m^3')) // returns Unit 3 m
   *    math.cbrt([27, 64, 125])       // returns [3, 4, 5]
   *
   *    const x = math.complex('8i')
   *    math.cbrt(x)                   // returns Complex 1.7320508075689 + i
   *    math.cbrt(x, true)             // returns Matrix [
   *                                    //    1.7320508075689 + i
   *                                    //   -1.7320508075689 + i
   *                                    //   -2i
   *                                    // ]
   *
   * See also:
   *
   *    square, sqrt, cube
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x
   *            Value for which to calculate the cubic root.
   * @param {boolean} [allRoots]  Optional, false by default. Only applicable
   *            when `x` is a number or complex number. If true, all complex
   *            roots are returned, if false (default) the principal root is
   *            returned.
   * @return {number | BigNumber | Complex | Unit | Array | Matrix}
   *            Returns the cubic root of `x`
   */ return typed($d6542f3527458f71$var$name, {
        number: (0, $eRNhQ.cbrtNumber),
        // note: signature 'number, boolean' is also supported,
        //       created by typed as it knows how to convert number to Complex
        Complex: _cbrtComplex,
        'Complex, boolean': _cbrtComplex,
        BigNumber: function BigNumber(x) {
            return x.cbrt();
        },
        Unit: _cbrtUnit,
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since cbrt(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        }
    });
    /**
   * Calculate the cubic root for a complex number
   * @param {Complex} x
   * @param {boolean} [allRoots]   If true, the function will return an array
   *                               with all three roots. If false or undefined,
   *                               the principal root is returned.
   * @returns {Complex | Array.<Complex> | Matrix.<Complex>} Returns the cubic root(s) of x
   * @private
   */ function _cbrtComplex(x, allRoots) {
        // https://www.wikiwand.com/en/Cube_root#/Complex_numbers
        var arg3 = x.arg() / 3;
        var abs = x.abs(); // principal root:
        var principal = new Complex((0, $eRNhQ.cbrtNumber)(abs), 0).mul(new Complex(0, arg3).exp());
        if (allRoots) {
            var all = [
                principal,
                new Complex((0, $eRNhQ.cbrtNumber)(abs), 0).mul(new Complex(0, arg3 + Math.PI * 2 / 3).exp()),
                new Complex((0, $eRNhQ.cbrtNumber)(abs), 0).mul(new Complex(0, arg3 - Math.PI * 2 / 3).exp())
            ];
            return config.matrix === 'Array' ? all : matrix(all);
        } else return principal;
    }
    /**
   * Calculate the cubic root for a Unit
   * @param {Unit} x
   * @return {Unit} Returns the cubic root of x
   * @private
   */ function _cbrtUnit(x) {
        if (x.value && (0, $gs7TF.isComplex)(x.value)) {
            var result = x.clone();
            result.value = 1.0;
            result = result.pow(1.0 / 3); // Compute the units
            result.value = _cbrtComplex(x.value); // Compute the value
            return result;
        } else {
            var negate = isNegative(x.value);
            if (negate) x.value = unaryMinus(x.value);
             // TODO: create a helper function for this
            var third;
            if ((0, $gs7TF.isBigNumber)(x.value)) third = new BigNumber(1).div(3);
            else if ((0, $gs7TF.isFraction)(x.value)) third = new Fraction(1, 3);
            else third = 1 / 3;
            var _result = x.pow(third);
            if (negate) _result.value = unaryMinus(_result.value);
            return _result;
        }
    }
});

});

parcelRegister("9MGdW", function(module, exports) {

$parcel$export(module.exports, "createCeil", () => $71f9598ce294b0d6$export$bab247d909829ddf);

var $5Pv9S = parcelRequire("5Pv9S");

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $6egKm = parcelRequire("6egKm");

var $iV3Fc = parcelRequire("iV3Fc");

var $eRNhQ = parcelRequire("eRNhQ");

var $hXAgg = parcelRequire("hXAgg");

var $laEuG = parcelRequire("laEuG");
var $71f9598ce294b0d6$var$name = 'ceil';
var $71f9598ce294b0d6$var$dependencies = [
    'typed',
    'config',
    'round',
    'matrix',
    'equalScalar'
];
var $71f9598ce294b0d6$export$bab247d909829ddf = /* #__PURE__ */ (0, $4eE2e.factory)($71f9598ce294b0d6$var$name, $71f9598ce294b0d6$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, round: round, matrix: matrix, equalScalar: equalScalar } = _ref;
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Round a value towards plus infinity
   * If `x` is complex, both real and imaginary part are rounded towards plus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.ceil(x)
   *    math.ceil(x, n)
   *
   * Examples:
   *
   *    math.ceil(3.2)               // returns number 4
   *    math.ceil(3.8)               // returns number 4
   *    math.ceil(-4.2)              // returns number -4
   *    math.ceil(-4.7)              // returns number -4
   *
   *    math.ceil(3.212, 2)          // returns number 3.22
   *    math.ceil(3.288, 2)          // returns number 3.29
   *    math.ceil(-4.212, 2)         // returns number -4.21
   *    math.ceil(-4.782, 2)         // returns number -4.78
   *
   *    const c = math.complex(3.24, -2.71)
   *    math.ceil(c)                 // returns Complex 4 - 2i
   *    math.ceil(c, 1)              // returns Complex 3.3 - 2.7i
   *
   *    math.ceil([3.2, 3.8, -4.7])  // returns Array [4, 4, -4]
   *    math.ceil([3.21, 3.82, -4.71], 1)  // returns Array [3.3, 3.9, -4.7]
   *
   * See also:
   *
   *    floor, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ return typed('ceil', {
        number: function number(x) {
            if ((0, $6egKm.nearlyEqual)(x, round(x), config.epsilon)) return round(x);
            else return (0, $eRNhQ.ceilNumber)(x);
        },
        'number, number': function numberNumber(x, n) {
            if ((0, $6egKm.nearlyEqual)(x, round(x, n), config.epsilon)) return round(x, n);
            else {
                var [number, exponent] = "".concat(x, "e").split('e');
                var result = Math.ceil(Number("".concat(number, "e").concat(Number(exponent) + n)));
                [number, exponent] = "".concat(result, "e").split('e');
                return Number("".concat(number, "e").concat(Number(exponent) - n));
            }
        },
        Complex: function Complex(x) {
            return x.ceil();
        },
        'Complex, number': function ComplexNumber(x, n) {
            return x.ceil(n);
        },
        BigNumber: function BigNumber(x) {
            if ((0, $iV3Fc.nearlyEqual)(x, round(x), config.epsilon)) return round(x);
            else return x.ceil();
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, n) {
            if ((0, $iV3Fc.nearlyEqual)(x, round(x, n), config.epsilon)) return round(x, n);
            else return x.toDecimalPlaces(n.toNumber(), (0, (/*@__PURE__*/$parcel$interopDefault($5Pv9S))).ROUND_CEIL);
        },
        Fraction: function Fraction(x) {
            return x.ceil();
        },
        'Fraction, number': function FractionNumber(x, n) {
            return x.ceil(n);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since ceil(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        },
        'Array | Matrix, number': function ArrayMatrixNumber(x, n) {
            // deep map collection, skip zeros since ceil(0) = 0
            return (0, $9nwyh.deepMap)(x, (i)=>this(i, n), true);
        },
        'SparseMatrix, number | BigNumber': function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, number | BigNumber': function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        'number | Complex | BigNumber, Array': function numberComplexBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});

});
parcelRegister("iV3Fc", function(module, exports) {

$parcel$export(module.exports, "nearlyEqual", () => $dc606456a4d3dd0f$export$6f3989c6ecc04081);
/**
 * Compares two BigNumbers.
 * @param {BigNumber} x       First value to compare
 * @param {BigNumber} y       Second value to compare
 * @param {number} [epsilon]  The maximum relative difference between x and y
 *                            If epsilon is undefined or null, the function will
 *                            test whether x and y are exactly equal.
 * @return {boolean} whether the two numbers are nearly equal
 */ function $dc606456a4d3dd0f$export$6f3989c6ecc04081(x, y, epsilon) {
    // if epsilon is null or undefined, test whether x and y are exactly equal
    if (epsilon === null || epsilon === undefined) return x.eq(y);
     // use "==" operator, handles infinities
    if (x.eq(y)) return true;
     // NaN
    if (x.isNaN() || y.isNaN()) return false;
     // at this point x and y should be finite
    if (x.isFinite() && y.isFinite()) {
        // check numbers are very close, needed when comparing numbers near zero
        var diff = x.minus(y).abs();
        if (diff.isZero()) return true;
        else {
            // use relative error
            var max = x.constructor.max(x.abs(), y.abs());
            return diff.lte(max.times(epsilon));
        }
    } // Infinite and Number or negative Infinite and positive Infinite cases
    return false;
}

});


parcelRegister("aXW9Y", function(module, exports) {

$parcel$export(module.exports, "createClone", () => $020f6d89ed241c91$export$39ad70de4044028a);

var $4mYv9 = parcelRequire("4mYv9");

var $4eE2e = parcelRequire("4eE2e");
var $020f6d89ed241c91$var$name = 'clone';
var $020f6d89ed241c91$var$dependencies = [
    'typed'
];
var $020f6d89ed241c91$export$39ad70de4044028a = /* #__PURE__ */ (0, $4eE2e.factory)($020f6d89ed241c91$var$name, $020f6d89ed241c91$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Clone an object. Will make a deep copy of the data.
   *
   * Syntax:
   *
   *     math.clone(x)
   *
   * Examples:
   *
   *    math.clone(3.5)                   // returns number 3.5
   *    math.clone(math.complex('2-4i') // returns Complex 2 - 4i
   *    math.clone(math.unit(45, 'deg'))  // returns Unit 45 deg
   *    math.clone([[1, 2], [3, 4]])      // returns Array [[1, 2], [3, 4]]
   *    math.clone("hello world")         // returns string "hello world"
   *
   * @param {*} x   Object to be cloned
   * @return {*} A clone of object x
   */ return typed($020f6d89ed241c91$var$name, {
        any: (0, $4mYv9.clone)
    });
});

});

parcelRegister("9vb66", function(module, exports) {

$parcel$export(module.exports, "createColumn", () => $6eaf9e05e0579a31$export$1bfa986e9c92c0b5);

var $4eE2e = parcelRequire("4eE2e");

var $4mYv9 = parcelRequire("4mYv9");

var $10UPF = parcelRequire("10UPF");
var $6eaf9e05e0579a31$var$name = 'column';
var $6eaf9e05e0579a31$var$dependencies = [
    'typed',
    'Index',
    'matrix',
    'range'
];
var $6eaf9e05e0579a31$export$1bfa986e9c92c0b5 = /* #__PURE__ */ (0, $4eE2e.factory)($6eaf9e05e0579a31$var$name, $6eaf9e05e0579a31$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    /**
   * Return a column from a Matrix.
   *
   * Syntax:
   *
   *     math.column(value, index)
   *
   * Example:
   *
   *     // get a column
   *     const d = [[1, 2], [3, 4]]
   *     math.column(d, 1) // returns [[2], [4]]
   *
   * See also:
   *
   *     row
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} column           The index of the column
   * @return {Array | Matrix}         The retrieved column
   */ return typed($6eaf9e05e0579a31$var$name, {
        'Matrix, number': _column,
        'Array, number': function ArrayNumber(value, column) {
            return _column(matrix((0, $4mYv9.clone)(value)), column).valueOf();
        }
    });
    /**
   * Retrieve a column of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} column  The index of the column
   * @return {Matrix}        The retrieved column
   */ function _column(value, column) {
        // check dimensions
        if (value.size().length !== 2) throw new Error('Only two dimensional matrix is supported');
        (0, $10UPF.validateIndex)(column, value.size()[1]);
        var rowRange = range(0, value.size()[0]);
        var index = new Index(rowRange, column);
        return value.subset(index);
    }
});

});

parcelRegister("9ekhe", function(module, exports) {

$parcel$export(module.exports, "createCombinations", () => $6b85266c6061d700$export$63e3129a196da23d);

var $4eE2e = parcelRequire("4eE2e");

var $fSgJ9 = parcelRequire("fSgJ9");
var $6b85266c6061d700$var$name = 'combinations';
var $6b85266c6061d700$var$dependencies = [
    'typed'
];
var $6b85266c6061d700$export$63e3129a196da23d = /* #__PURE__ */ (0, $4eE2e.factory)($6b85266c6061d700$var$name, $6b85266c6061d700$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities.
   *
   * Combinations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.combinations(n, k)
   *
   * Examples:
   *
   *    math.combinations(7, 5) // returns 21
   *
   * See also:
   *
   *    combinationsWithRep, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations.
   */ return typed($6b85266c6061d700$var$name, {
        'number, number': (0, $fSgJ9.combinationsNumber),
        'BigNumber, BigNumber': function BigNumberBigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var nMinusk = n.minus(k);
            var one = new BigNumber(1);
            if (!$6b85266c6061d700$var$isPositiveInteger(n) || !$6b85266c6061d700$var$isPositiveInteger(k)) throw new TypeError('Positive integer value expected in function combinations');
            if (k.gt(n)) throw new TypeError('k must be less than n in function combinations');
            result = one;
            if (k.lt(nMinusk)) for(i = one; i.lte(nMinusk); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusk.plus(i)).dividedBy(i);
            return result;
        } // TODO: implement support for collection in combinations
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $6b85266c6061d700$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}

});
parcelRegister("fSgJ9", function(module, exports) {

$parcel$export(module.exports, "combinationsNumber", () => $b8e8dfd8a7b20d08$export$2a122d28e37477a2);

var $6egKm = parcelRequire("6egKm");

var $78cF8 = parcelRequire("78cF8");
function $b8e8dfd8a7b20d08$export$2a122d28e37477a2(n, k) {
    if (!(0, $6egKm.isInteger)(n) || n < 0) throw new TypeError('Positive integer value expected in function combinations');
    if (!(0, $6egKm.isInteger)(k) || k < 0) throw new TypeError('Positive integer value expected in function combinations');
    if (k > n) throw new TypeError('k must be less than or equal to n');
    var nMinusk = n - k;
    var prodrange;
    if (k < nMinusk) {
        prodrange = (0, $78cF8.product)(nMinusk + 1, n);
        return prodrange / (0, $78cF8.product)(1, k);
    }
    prodrange = (0, $78cF8.product)(k + 1, n);
    return prodrange / (0, $78cF8.product)(1, nMinusk);
}
$b8e8dfd8a7b20d08$export$2a122d28e37477a2.signature = 'number, number';

});
parcelRegister("78cF8", function(module, exports) {

$parcel$export(module.exports, "product", () => $53131a45b83b63fa$export$dbd0f18357df1ddd);
/** @param {number} i
 *  @param {number} n
 *  @returns {number} product of i to n
 */ function $53131a45b83b63fa$export$dbd0f18357df1ddd(i, n) {
    if (n < i) return 1;
    if (n === i) return n;
    var half = n + i >> 1; // divide (n + i) by 2 and truncate to integer
    return $53131a45b83b63fa$export$dbd0f18357df1ddd(i, half) * $53131a45b83b63fa$export$dbd0f18357df1ddd(half + 1, n);
}

});



parcelRegister("024St", function(module, exports) {

$parcel$export(module.exports, "createCombinationsWithRep", () => $0063f89cfa653259$export$4bdc90311ec7c1dd);

var $4eE2e = parcelRequire("4eE2e");

var $6egKm = parcelRequire("6egKm");

var $78cF8 = parcelRequire("78cF8");
var $0063f89cfa653259$var$name = 'combinationsWithRep';
var $0063f89cfa653259$var$dependencies = [
    'typed'
];
var $0063f89cfa653259$export$4bdc90311ec7c1dd = /* #__PURE__ */ (0, $4eE2e.factory)($0063f89cfa653259$var$name, $0063f89cfa653259$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities, allowing individual outcomes to be repeated more than once.
   *
   * CombinationsWithRep only takes integer arguments.
   * The following condition must be enforced: k <= n + k -1.
   *
   * Syntax:
   *
   *     math.combinationsWithRep(n, k)
   *
   * Examples:
   *
   *    math.combinationsWithRep(7, 5) // returns 462
   *
   * See also:
   *
   *    combinations, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations with replacement.
   */ return typed($0063f89cfa653259$var$name, {
        'number, number': function numberNumber(n, k) {
            if (!(0, $6egKm.isInteger)(n) || n < 0) throw new TypeError('Positive integer value expected in function combinationsWithRep');
            if (!(0, $6egKm.isInteger)(k) || k < 0) throw new TypeError('Positive integer value expected in function combinationsWithRep');
            if (n < 1) throw new TypeError('k must be less than or equal to n + k - 1');
            if (k < n - 1) {
                var _prodrange = (0, $78cF8.product)(n, n + k - 1);
                return _prodrange / (0, $78cF8.product)(1, k);
            }
            var prodrange = (0, $78cF8.product)(k + 1, n + k - 1);
            return prodrange / (0, $78cF8.product)(1, n - 1);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var one = new BigNumber(1);
            var nMinusOne = n.minus(one);
            if (!$0063f89cfa653259$var$isPositiveInteger(n) || !$0063f89cfa653259$var$isPositiveInteger(k)) throw new TypeError('Positive integer value expected in function combinationsWithRep');
            if (n.lt(one)) throw new TypeError('k must be less than or equal to n + k - 1 in function combinationsWithRep');
            result = one;
            if (k.lt(nMinusOne)) for(i = one; i.lte(nMinusOne); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusOne.plus(i)).dividedBy(i);
            return result;
        }
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $0063f89cfa653259$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}

});

parcelRegister("jmzYP", function(module, exports) {

$parcel$export(module.exports, "createCompare", () => $e18bfb4bf344774a$export$a6e723c0e3b918d4);

var $iV3Fc = parcelRequire("iV3Fc");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");

var $6MKpt = parcelRequire("6MKpt");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $laEuG = parcelRequire("laEuG");

var $KKjvJ = parcelRequire("KKjvJ");

var $69TlR = parcelRequire("69TlR");
var $e18bfb4bf344774a$var$name = 'compare';
var $e18bfb4bf344774a$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'equalScalar',
    'BigNumber',
    'Fraction',
    'DenseMatrix'
];
var $e18bfb4bf344774a$export$a6e723c0e3b918d4 = /* #__PURE__ */ (0, $4eE2e.factory)($e18bfb4bf344774a$var$name, $e18bfb4bf344774a$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, equalScalar: equalScalar, matrix: matrix, BigNumber: BigNumber, Fraction: Fraction, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm05 = (0, $69TlR.createAlgorithm05)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * x and y are considered equal when the relative difference between x and y
   * is smaller than the configured epsilon. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.compare(x, y)
   *
   * Examples:
   *
   *    math.compare(6, 1)           // returns 1
   *    math.compare(2, 3)           // returns -1
   *    math.compare(7, 7)           // returns 0
   *    math.compare('10', '2')      // returns 1
   *    math.compare('1000', '1e3')  // returns 0
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compare(a, b)           // returns 1
   *
   *    math.compare(2, [1, 2, 3])   // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, largerEq, compareNatural, compareText
   *
   * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} y Second value to compare
   * @return {number | BigNumber | Fraction | Array | Matrix} Returns the result of the comparison:
   *                                                          1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($e18bfb4bf344774a$var$name, {
        'boolean, boolean': function booleanBoolean(x, y) {
            return x === y ? 0 : x > y ? 1 : -1;
        },
        'number, number': function numberNumber(x, y) {
            return (0, $6egKm.nearlyEqual)(x, y, config.epsilon) ? 0 : x > y ? 1 : -1;
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return (0, $iV3Fc.nearlyEqual)(x, y, config.epsilon) ? new BigNumber(0) : new BigNumber(x.cmp(y));
        },
        'Fraction, Fraction': function FractionFraction(x, y) {
            return new Fraction(x.compare(y));
        },
        'Complex, Complex': function ComplexComplex() {
            throw new TypeError('No ordering relation is defined for complex numbers');
        },
        'Unit, Unit': function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error('Cannot compare units with different base');
            return this(x.value, y.value);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, this);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $e18bfb4bf344774a$export$e744cf3e2e3d6926 = /* #__PURE__ */ (0, $4eE2e.factory)($e18bfb4bf344774a$var$name, [
    'typed',
    'config'
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($e18bfb4bf344774a$var$name, {
        'number, number': function numberNumber(x, y) {
            return (0, $6egKm.nearlyEqual)(x, y, config.epsilon) ? 0 : x > y ? 1 : -1;
        }
    });
});

});
parcelRegister("69TlR", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm05", () => $47be85006f6c96d5$export$f80c3080566d43b4);

var $4eE2e = parcelRequire("4eE2e");

var $iAoVB = parcelRequire("iAoVB");
var $47be85006f6c96d5$var$name = 'algorithm05';
var $47be85006f6c96d5$var$dependencies = [
    'typed',
    'equalScalar'
];
var $47be85006f6c96d5$export$f80c3080566d43b4 = /* #__PURE__ */ (0, $4eE2e.factory)($47be85006f6c96d5$var$name, $47be85006f6c96d5$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 || B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm05(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $iAoVB.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var xa = cvalues ? [] : undefined;
        var xb = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // vars
        var i, j, k, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop values A(:,j)
            for(k = aptr[j], k1 = aptr[j + 1]; k < k1; k++){
                // row
                i = aindex[k]; // push index
                cindex.push(i); // update workspace
                wa[i] = mark; // check we need to process values
                if (xa) xa[i] = avalues[k];
            } // loop values B(:,j)
            for(k = bptr[j], k1 = bptr[j + 1]; k < k1; k++){
                // row
                i = bindex[k]; // check row existed in A
                if (wa[i] !== mark) // push index
                cindex.push(i);
                 // update workspace
                wb[i] = mark; // check we need to process values
                if (xb) xb[i] = bvalues[k];
            } // check we need to process values (non pattern matrix)
            if (cvalues) {
                // initialize first index in j
                k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k]; // marks
                    var wai = wa[i];
                    var wbi = wb[i]; // check Aij or Bij are nonzero
                    if (wai === mark || wbi === mark) {
                        // matrix values @ i,j
                        var va = wai === mark ? xa[i] : zero;
                        var vb = wbi === mark ? xb[i] : zero; // Cij
                        var vc = cf(va, vb); // check for zero
                        if (!eq(vc, zero)) {
                            // push value
                            cvalues.push(vc); // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    }
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});


parcelRegister("hWhPN", function(module, exports) {

$parcel$export(module.exports, "createCompareNatural", () => $d0f5affd6ea41b71$export$ac9dd39e43534605);

var $51qf0 = parcelRequire("51qf0");

var $gs7TF = parcelRequire("gs7TF");

var $4eE2e = parcelRequire("4eE2e");
var $d0f5affd6ea41b71$var$name = 'compareNatural';
var $d0f5affd6ea41b71$var$dependencies = [
    'typed',
    'compare'
];
var $d0f5affd6ea41b71$export$ac9dd39e43534605 = /* #__PURE__ */ (0, $4eE2e.factory)($d0f5affd6ea41b71$var$name, $d0f5affd6ea41b71$var$dependencies, (_ref)=>{
    var { typed: typed, compare: compare } = _ref;
    var compareBooleans = compare.signatures['boolean,boolean'];
    /**
   * Compare two values of any type in a deterministic, natural way.
   *
   * For numeric values, the function works the same as `math.compare`.
   * For types of values that can't be compared mathematically,
   * the function compares in a natural way.
   *
   * For numeric values, x and y are considered equal when the relative
   * difference between x and y is smaller than the configured epsilon.
   * The function cannot be used to compare values smaller than
   * approximately 2.22e-16.
   *
   * For Complex numbers, first the real parts are compared. If equal,
   * the imaginary parts are compared.
   *
   * Strings are compared with a natural sorting algorithm, which
   * orders strings in a "logic" way following some heuristics.
   * This differs from the function `compare`, which converts the string
   * into a numeric value and compares that. The function `compareText`
   * on the other hand compares text lexically.
   *
   * Arrays and Matrices are compared value by value until there is an
   * unequal pair of values encountered. Objects are compared by sorted
   * keys until the keys or their values are unequal.
   *
   * Syntax:
   *
   *    math.compareNatural(x, y)
   *
   * Examples:
   *
   *    math.compareNatural(6, 1)              // returns 1
   *    math.compareNatural(2, 3)              // returns -1
   *    math.compareNatural(7, 7)              // returns 0
   *
   *    math.compareNatural('10', '2')         // returns 1
   *    math.compareText('10', '2')            // returns -1
   *    math.compare('10', '2')                // returns 1
   *
   *    math.compareNatural('Answer: 10', 'Answer: 2') // returns 1
   *    math.compareText('Answer: 10', 'Answer: 2')    // returns -1
   *    math.compare('Answer: 10', 'Answer: 2')
   *        // Error: Cannot convert "Answer: 10" to a number
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compareNatural(a, b)              // returns 1
   *
   *    const c = math.complex('2 + 3i')
   *    const d = math.complex('2 + 4i')
   *    math.compareNatural(c, d)              // returns -1
   *
   *    math.compareNatural([1, 2, 4], [1, 2, 3]) // returns 1
   *    math.compareNatural([1, 2, 3], [1, 2])    // returns 1
   *    math.compareNatural([1, 5], [1, 2, 3])    // returns 1
   *    math.compareNatural([1, 2], [1, 2])       // returns 0
   *
   *    math.compareNatural({a: 2}, {a: 4})       // returns -1
   *
   * See also:
   *
   *    compare, compareText
   *
   * @param  {*} x First value to compare
   * @param  {*} y Second value to compare
   * @return {number} Returns the result of the comparison:
   *                  1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($d0f5affd6ea41b71$var$name, {
        'any, any': function anyAny(x, y) {
            var typeX = (0, $gs7TF.typeOf)(x);
            var typeY = (0, $gs7TF.typeOf)(y);
            var c; // numeric types
            if ((typeX === 'number' || typeX === 'BigNumber' || typeX === 'Fraction') && (typeY === 'number' || typeY === 'BigNumber' || typeY === 'Fraction')) {
                c = compare(x, y);
                if (c.toString() !== '0') // c can be number, BigNumber, or Fraction
                return c > 0 ? 1 : -1; // return a number
                else return (0, (/*@__PURE__*/$parcel$interopDefault($51qf0)))(typeX, typeY);
            } // matrix types
            if (typeX === 'Array' || typeX === 'Matrix' || typeY === 'Array' || typeY === 'Matrix') {
                c = compareMatricesAndArrays(this, x, y);
                if (c !== 0) return c;
                else return (0, (/*@__PURE__*/$parcel$interopDefault($51qf0)))(typeX, typeY);
            } // in case of different types, order by name of type, i.e. 'BigNumber' < 'Complex'
            if (typeX !== typeY) return (0, (/*@__PURE__*/$parcel$interopDefault($51qf0)))(typeX, typeY);
            if (typeX === 'Complex') return $d0f5affd6ea41b71$var$compareComplexNumbers(x, y);
            if (typeX === 'Unit') {
                if (x.equalBase(y)) return this(x.value, y.value);
                 // compare by units
                return compareArrays(this, x.formatUnits(), y.formatUnits());
            }
            if (typeX === 'boolean') return compareBooleans(x, y);
            if (typeX === 'string') return (0, (/*@__PURE__*/$parcel$interopDefault($51qf0)))(x, y);
            if (typeX === 'Object') return compareObjects(this, x, y);
            if (typeX === 'null') return 0;
            if (typeX === 'undefined') return 0;
             // this should not occur...
            throw new TypeError('Unsupported type of value "' + typeX + '"');
        }
    });
    /**
   * Compare mixed matrix/array types, by converting to same-shaped array.
   * This comparator is non-deterministic regarding input types.
   * @param {Array | SparseMatrix | DenseMatrix | *} x
   * @param {Array | SparseMatrix | DenseMatrix | *} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareMatricesAndArrays(compareNatural, x, y) {
        if ((0, $gs7TF.isSparseMatrix)(x) && (0, $gs7TF.isSparseMatrix)(y)) return compareArrays(compareNatural, x.toJSON().values, y.toJSON().values);
        if ((0, $gs7TF.isSparseMatrix)(x)) // note: convert to array is expensive
        return compareMatricesAndArrays(compareNatural, x.toArray(), y);
        if ((0, $gs7TF.isSparseMatrix)(y)) // note: convert to array is expensive
        return compareMatricesAndArrays(compareNatural, x, y.toArray());
         // convert DenseArray into Array
        if ((0, $gs7TF.isDenseMatrix)(x)) return compareMatricesAndArrays(compareNatural, x.toJSON().data, y);
        if ((0, $gs7TF.isDenseMatrix)(y)) return compareMatricesAndArrays(compareNatural, x, y.toJSON().data);
         // convert scalars to array
        if (!Array.isArray(x)) return compareMatricesAndArrays(compareNatural, [
            x
        ], y);
        if (!Array.isArray(y)) return compareMatricesAndArrays(compareNatural, x, [
            y
        ]);
        return compareArrays(compareNatural, x, y);
    }
    /**
   * Compare two Arrays
   *
   * - First, compares value by value
   * - Next, if all corresponding values are equal,
   *   look at the length: longest array will be considered largest
   *
   * @param {Array} x
   * @param {Array} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareArrays(compareNatural, x, y) {
        // compare each value
        for(var i = 0, ii = Math.min(x.length, y.length); i < ii; i++){
            var v = compareNatural(x[i], y[i]);
            if (v !== 0) return v;
        } // compare the size of the arrays
        if (x.length > y.length) return 1;
        if (x.length < y.length) return -1;
         // both Arrays have equal size and content
        return 0;
    }
    /**
   * Compare two objects
   *
   * - First, compare sorted property names
   * - Next, compare the property values
   *
   * @param {Object} x
   * @param {Object} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareObjects(compareNatural, x, y) {
        var keysX = Object.keys(x);
        var keysY = Object.keys(y); // compare keys
        keysX.sort((0, (/*@__PURE__*/$parcel$interopDefault($51qf0))));
        keysY.sort((0, (/*@__PURE__*/$parcel$interopDefault($51qf0))));
        var c = compareArrays(compareNatural, keysX, keysY);
        if (c !== 0) return c;
         // compare values
        for(var i = 0; i < keysX.length; i++){
            var v = compareNatural(x[keysX[i]], y[keysY[i]]);
            if (v !== 0) return v;
        }
        return 0;
    }
});
/**
 * Compare two complex numbers, `x` and `y`:
 *
 * - First, compare the real values of `x` and `y`
 * - If equal, compare the imaginary values of `x` and `y`
 *
 * @params {Complex} x
 * @params {Complex} y
 * @returns {number} Returns the comparison result: -1, 0, or 1
 */ function $d0f5affd6ea41b71$var$compareComplexNumbers(x, y) {
    if (x.re > y.re) return 1;
    if (x.re < y.re) return -1;
    if (x.im > y.im) return 1;
    if (x.im < y.im) return -1;
    return 0;
}

});
parcelRegister("51qf0", function(module, exports) {
/*
 * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
 */ /*jshint unused:false */ module.exports = function naturalSort(a, b) {
    "use strict";
    var re = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, sre = /(^[ ]*|[ ]*$)/g, dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, hre = /^0x[0-9a-f]+$/i, ore = /^0/, i = function(s) {
        return naturalSort.insensitive && ('' + s).toLowerCase() || '' + s;
    }, // convert all to strings strip whitespace
    x = i(a).replace(sre, '') || '', y = i(b).replace(sre, '') || '', // chunk/tokenize
    xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'), yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'), // numeric, hex or date detection
    xD = parseInt(x.match(hre), 16) || xN.length !== 1 && x.match(dre) && Date.parse(x), yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null, oFxNcL, oFyNcL;
    // first try and sort Hex codes or Dates
    if (yD) {
        if (xD < yD) return -1;
        else if (xD > yD) return 1;
    }
    // natural sorting through split numeric strings and default strings
    for(var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++){
        // find floats not starting with '0', string or 0 if not defined (Clint Priest)
        oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
        oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
        // handle numeric vs string comparison - number < string - (Kyle Adams)
        if (isNaN(oFxNcL) !== isNaN(oFyNcL)) return isNaN(oFxNcL) ? 1 : -1;
        else if (typeof oFxNcL !== typeof oFyNcL) {
            oFxNcL += '';
            oFyNcL += '';
        }
        if (oFxNcL < oFyNcL) return -1;
        if (oFxNcL > oFyNcL) return 1;
    }
    return 0;
};

});


parcelRegister("h3DmQ", function(module, exports) {

$parcel$export(module.exports, "createCompareText", () => $c6b14106b9ac89fd$export$3e578d0534ab5935);

var $aEppI = parcelRequire("aEppI");

var $4eE2e = parcelRequire("4eE2e");

var $laEuG = parcelRequire("laEuG");

var $KKjvJ = parcelRequire("KKjvJ");
var $c6b14106b9ac89fd$var$name = 'compareText';
var $c6b14106b9ac89fd$var$dependencies = [
    'typed',
    'matrix'
];
var $c6b14106b9ac89fd$export$3e578d0534ab5935 = /* #__PURE__ */ (0, $4eE2e.factory)($c6b14106b9ac89fd$var$name, $c6b14106b9ac89fd$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Compare two strings lexically. Comparison is case sensitive.
   * Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.compareText(x, y)
   *
   * Examples:
   *
   *    math.compareText('B', 'A')     // returns 1
   *    math.compareText('2', '10')    // returns 1
   *    math.compare('2', '10')        // returns -1
   *    math.compareNatural('2', '10') // returns -1
   *
   *    math.compareText('B', ['A', 'B', 'C']) // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, equalText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns the result of the comparison:
   *                                        1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($c6b14106b9ac89fd$var$name, {
        'any, any': (0, $aEppI.compareText),
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, (0, $aEppI.compareText));
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, (0, $aEppI.compareText), false);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, (0, $aEppI.compareText), true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, (0, $aEppI.compareText), false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, (0, $aEppI.compareText), true).valueOf();
        }
    });
});
var $c6b14106b9ac89fd$export$1d0ea0d151dafd85 = /* #__PURE__ */ (0, $4eE2e.factory)($c6b14106b9ac89fd$var$name, [
    'typed'
], (_ref2)=>{
    var { typed: typed } = _ref2;
    return typed($c6b14106b9ac89fd$var$name, {
        'any, any': (0, $aEppI.compareText)
    });
});

});

parcelRegister("90lmK", function(module, exports) {

$parcel$export(module.exports, "createComplex", () => $68e4aff4ad6cad2f$export$82a905fb6826da0d);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $68e4aff4ad6cad2f$var$name = 'complex';
var $68e4aff4ad6cad2f$var$dependencies = [
    'typed',
    'Complex'
];
var $68e4aff4ad6cad2f$export$82a905fb6826da0d = /* #__PURE__ */ (0, $4eE2e.factory)($68e4aff4ad6cad2f$var$name, $68e4aff4ad6cad2f$var$dependencies, (_ref)=>{
    var { typed: typed, Complex: Complex } = _ref;
    /**
   * Create a complex value or convert a value to a complex value.
   *
   * Syntax:
   *
   *     math.complex()                           // creates a complex value with zero
   *                                              // as real and imaginary part.
   *     math.complex(re : number, im : string)   // creates a complex value with provided
   *                                              // values for real and imaginary part.
   *     math.complex(re : number)                // creates a complex value with provided
   *                                              // real value and zero imaginary part.
   *     math.complex(complex : Complex)          // clones the provided complex value.
   *     math.complex(arg : string)               // parses a string into a complex value.
   *     math.complex(array : Array)              // converts the elements of the array
   *                                              // or matrix element wise into a
   *                                              // complex value.
   *     math.complex({re: number, im: number})   // creates a complex value with provided
   *                                              // values for real an imaginary part.
   *     math.complex({r: number, phi: number})   // creates a complex value with provided
   *                                              // polar coordinates
   *
   * Examples:
   *
   *    const a = math.complex(3, -4)     // a = Complex 3 - 4i
   *    a.re = 5                          // a = Complex 5 - 4i
   *    const i = a.im                    // Number -4
   *    const b = math.complex('2 + 6i')  // Complex 2 + 6i
   *    const c = math.complex()          // Complex 0 + 0i
   *    const d = math.add(a, b)          // Complex 5 + 2i
   *
   * See also:
   *
   *    bignumber, boolean, index, matrix, number, string, unit
   *
   * @param {* | Array | Matrix} [args]
   *            Arguments specifying the real and imaginary part of the complex number
   * @return {Complex | Array | Matrix} Returns a complex value
   */ return typed('complex', {
        '': function _() {
            return Complex.ZERO;
        },
        number: function number(x) {
            return new Complex(x, 0);
        },
        'number, number': function numberNumber(re, im) {
            return new Complex(re, im);
        },
        // TODO: this signature should be redundant
        'BigNumber, BigNumber': function BigNumberBigNumber(re, im) {
            return new Complex(re.toNumber(), im.toNumber());
        },
        Fraction: function Fraction(x) {
            return new Complex(x.valueOf(), 0);
        },
        Complex: function Complex(x) {
            return x.clone();
        },
        string: function string(x) {
            return Complex(x); // for example '2 + 3i'
        },
        null: function _null(x) {
            return Complex(0);
        },
        Object: function Object(x) {
            if ('re' in x && 'im' in x) return new Complex(x.re, x.im);
            if ('r' in x && 'phi' in x || 'abs' in x && 'arg' in x) return new Complex(x);
            throw new Error('Expected object with properties (re and im) or (r and phi) or (abs and arg)');
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("40OE2", function(module, exports) {

$parcel$export(module.exports, "createComplexClass", () => $2ebe72829abb51c2$export$24a4be44fc8b6392);

var $8Qx7W = parcelRequire("8Qx7W");

var $6egKm = parcelRequire("6egKm");

var $gs7TF = parcelRequire("gs7TF");

var $4eE2e = parcelRequire("4eE2e");
var $2ebe72829abb51c2$var$name = 'Complex';
var $2ebe72829abb51c2$var$dependencies = [];
var $2ebe72829abb51c2$export$24a4be44fc8b6392 = /* #__PURE__ */ (0, $4eE2e.factory)($2ebe72829abb51c2$var$name, $2ebe72829abb51c2$var$dependencies, ()=>{
    /**
   * Attach type information
   */ (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W))).prototype.type = 'Complex';
    (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W))).prototype.isComplex = true;
    /**
   * Get a JSON representation of the complex number
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Complex", "re": 2, "im": 3}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W))).prototype.toJSON = function() {
        return {
            mathjs: 'Complex',
            re: this.re,
            im: this.im
        };
    };
    /*
   * Return the value of the complex number in polar notation
   * The angle phi will be set in the interval of [-pi, pi].
   * @return {{r: number, phi: number}} Returns and object with properties r and phi.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W))).prototype.toPolar = function() {
        return {
            r: this.abs(),
            phi: this.arg()
        };
    };
    /**
   * Get a string representation of the complex number,
   * with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string} str
   */ (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W))).prototype.format = function(options) {
        var str = '';
        var im = this.im;
        var re = this.re;
        var strRe = (0, $6egKm.format)(this.re, options);
        var strIm = (0, $6egKm.format)(this.im, options); // round either re or im when smaller than the configured precision
        var precision = (0, $gs7TF.isNumber)(options) ? options : options ? options.precision : null;
        if (precision !== null) {
            var epsilon = Math.pow(10, -precision);
            if (Math.abs(re / im) < epsilon) re = 0;
            if (Math.abs(im / re) < epsilon) im = 0;
        }
        if (im === 0) // real value
        str = strRe;
        else if (re === 0) {
            // purely complex value
            if (im === 1) str = 'i';
            else if (im === -1) str = '-i';
            else str = strIm + 'i';
        } else {
            // complex value
            if (im < 0) {
                if (im === -1) str = strRe + ' - i';
                else str = strRe + ' - ' + strIm.substring(1) + 'i';
            } else if (im === 1) str = strRe + ' + i';
            else str = strRe + ' + ' + strIm + 'i';
        }
        return str;
    };
    /**
   * Create a complex number from polar coordinates
   *
   * Usage:
   *
   *     Complex.fromPolar(r: number, phi: number) : Complex
   *     Complex.fromPolar({r: number, phi: number}) : Complex
   *
   * @param {*} args...
   * @return {Complex}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W))).fromPolar = function(args) {
        switch(arguments.length){
            case 1:
                var arg = arguments[0];
                if (typeof arg === 'object') return (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W)))(arg);
                else throw new TypeError('Input has to be an object with r and phi keys.');
            case 2:
                var r = arguments[0];
                var phi = arguments[1];
                if ((0, $gs7TF.isNumber)(r)) {
                    if ((0, $gs7TF.isUnit)(phi) && phi.hasBase('ANGLE')) // convert unit to a number in radians
                    phi = phi.toNumber('rad');
                    if ((0, $gs7TF.isNumber)(phi)) return new (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W)))({
                        r: r,
                        phi: phi
                    });
                    throw new TypeError('Phi is not a number nor an angle unit.');
                } else throw new TypeError('Radius r is not a number.');
            default:
                throw new SyntaxError('Wrong number of arguments in function fromPolar');
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W))).prototype.valueOf = (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W))).prototype.toString;
    /**
   * Create a Complex number from a JSON object
   * @param {Object} json  A JSON Object structured as
   *                       {"mathjs": "Complex", "re": 2, "im": 3}
   *                       All properties are optional, default values
   *                       for `re` and `im` are 0.
   * @return {Complex} Returns a new Complex number
   */ (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W)))(json);
    };
    /**
   * Compare two complex numbers, `a` and `b`:
   *
   * - Returns 1 when the real part of `a` is larger than the real part of `b`
   * - Returns -1 when the real part of `a` is smaller than the real part of `b`
   * - Returns 1 when the real parts are equal
   *   and the imaginary part of `a` is larger than the imaginary part of `b`
   * - Returns -1 when the real parts are equal
   *   and the imaginary part of `a` is smaller than the imaginary part of `b`
   * - Returns 0 when both real and imaginary parts are equal.
   *
   * @params {Complex} a
   * @params {Complex} b
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ (0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W))).compare = function(a, b) {
        if (a.re > b.re) return 1;
        if (a.re < b.re) return -1;
        if (a.im > b.im) return 1;
        if (a.im < b.im) return -1;
        return 0;
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($8Qx7W));
}, {
    isClass: true
});

});
parcelRegister("8Qx7W", function(module, exports) {
/*
Complex.js v2.4.3 11/13/2025
https://raw.org/article/complex-numbers-in-javascript/

Copyright (c) 2025, Robert Eisele (https://raw.org/)
Licensed under the MIT license.
*/ 'use strict';
(function(q) {
    function l(a, b) {
        if (a === void 0 || a === null) f.re = f.im = 0;
        else if (b !== void 0) f.re = a, f.im = b;
        else switch(typeof a){
            case "object":
                if ("im" in a && "re" in a) f.re = a.re, f.im = a.im;
                else if ("abs" in a && "arg" in a) {
                    if (!isFinite(a.abs) && isFinite(a.arg)) return c.INFINITY;
                    f.re = a.abs * Math.cos(a.arg);
                    f.im = a.abs * Math.sin(a.arg);
                } else if ("r" in a && "phi" in a) {
                    if (!isFinite(a.r) && isFinite(a.phi)) return c.INFINITY;
                    f.re = a.r * Math.cos(a.phi);
                    f.im = a.r * Math.sin(a.phi);
                } else a.length === 2 ? (f.re = a[0], f.im = a[1]) : m();
                break;
            case "string":
                f.im = f.re = 0;
                a = a.replace(/_/g, "").match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
                b = 1;
                let d = 0;
                a === null && m();
                for(let e = 0; e < a.length; e++){
                    const g = a[e];
                    g !== " " && g !== "\t" && g !== "\n" && (g === "+" ? b++ : g === "-" ? d++ : (g === "i" || g === "I" ? (b + d === 0 && m(), a[e + 1] === " " || isNaN(a[e + 1]) ? f.im += parseFloat((d % 2 ? "-" : "") + "1") : (f.im += parseFloat((d % 2 ? "-" : "") + a[e + 1]), e++)) : ((b + d === 0 || isNaN(g)) && m(), a[e + 1] === "i" || a[e + 1] === "I" ? (f.im += parseFloat((d % 2 ? "-" : "") + g), e++) : f.re += parseFloat((d % 2 ? "-" : "") + g)), b = d = 0));
                }
                b + d > 0 && m();
                break;
            case "number":
                f.im = 0;
                f.re = a;
                break;
            default:
                m();
        }
        return f;
    }
    function m() {
        throw SyntaxError("Invalid Param");
    }
    function n(a, b) {
        a = Math.abs(a);
        b = Math.abs(b);
        a < b && ([a, b] = [
            b,
            a
        ]);
        if (a < 1E8) return Math.sqrt(a * a + b * b);
        b /= a;
        return a * Math.sqrt(1 + b * b);
    }
    function p(a, b) {
        const d = Math.abs(a), e = Math.abs(b);
        if (a === 0) return Math.log(e);
        if (b === 0) return Math.log(d);
        if (d < 3E3 && e < 3E3) return Math.log(a * a + b * b) * .5;
        a *= .5;
        b *= .5;
        return .5 * Math.log(a * a + b * b) + Math.LN2;
    }
    function c(a, b) {
        if (!(this instanceof c)) return new c(a, b);
        a = l(a, b);
        this.re = a.re;
        this.im = a.im;
    }
    const h = Math.cosh || function(a) {
        return Math.abs(a) < 1E-9 ? 1 - a : (Math.exp(a) + Math.exp(-a)) * .5;
    }, k = Math.sinh || function(a) {
        return Math.abs(a) < 1E-9 ? a : (Math.exp(a) - Math.exp(-a)) * .5;
    }, f = {
        re: 0,
        im: 0
    };
    c.prototype = {
        re: 0,
        im: 0,
        sign: function() {
            const a = n(this.re, this.im);
            return new c(this.re / a, this.im / a);
        },
        add: function(a, b) {
            a = l(a, b);
            b = this.isInfinite();
            const d = !(isFinite(a.re) && isFinite(a.im));
            return b || d ? b && d ? c.NAN : c.INFINITY : new c(this.re + a.re, this.im + a.im);
        },
        sub: function(a, b) {
            a = l(a, b);
            b = this.isInfinite();
            const d = !(isFinite(a.re) && isFinite(a.im));
            return b || d ? b && d ? c.NAN : c.INFINITY : new c(this.re - a.re, this.im - a.im);
        },
        mul: function(a, b) {
            a = l(a, b);
            b = this.isInfinite();
            const d = !(isFinite(a.re) && isFinite(a.im)), e = this.re === 0 && this.im === 0, g = a.re === 0 && a.im === 0;
            return b && g || d && e ? c.NAN : b || d ? c.INFINITY : a.im === 0 && this.im === 0 ? new c(this.re * a.re, 0) : new c(this.re * a.re - this.im * a.im, this.re * a.im + this.im * a.re);
        },
        div: function(a, b) {
            a = l(a, b);
            b = this.isInfinite();
            const d = !(isFinite(a.re) && isFinite(a.im)), e = this.re === 0 && this.im === 0, g = a.re === 0 && a.im === 0;
            if (e && g || b && d) return c.NAN;
            if (g || b) return c.INFINITY;
            if (e || d) return c.ZERO;
            if (0 === a.im) return new c(this.re / a.re, this.im / a.re);
            if (Math.abs(a.re) < Math.abs(a.im)) return b = a.re / a.im, a = a.re * b + a.im, new c((this.re * b + this.im) / a, (this.im * b - this.re) / a);
            b = a.im / a.re;
            a = a.im * b + a.re;
            return new c((this.re + this.im * b) / a, (this.im - this.re * b) / a);
        },
        pow: function(a, b) {
            a = l(a, b);
            b = this.re === 0 && this.im === 0;
            if (a.re === 0 && a.im === 0) return c.ONE;
            if (a.im === 0) {
                if (this.im === 0 && this.re > 0) return new c(Math.pow(this.re, a.re), 0);
                if (this.re === 0) switch((a.re % 4 + 4) % 4){
                    case 0:
                        return new c(Math.pow(this.im, a.re), 0);
                    case 1:
                        return new c(0, Math.pow(this.im, a.re));
                    case 2:
                        return new c(-Math.pow(this.im, a.re), 0);
                    case 3:
                        return new c(0, -Math.pow(this.im, a.re));
                }
            }
            if (b && a.re > 0) return c.ZERO;
            const d = Math.atan2(this.im, this.re), e = p(this.re, this.im);
            b = Math.exp(a.re * e - a.im * d);
            a = a.im * e + a.re * d;
            return new c(b * Math.cos(a), b * Math.sin(a));
        },
        sqrt: function() {
            const a = this.re, b = this.im;
            if (b === 0) return a >= 0 ? new c(Math.sqrt(a), 0) : new c(0, Math.sqrt(-a));
            var d = n(a, b);
            d = Math.sqrt(.5 * (d + Math.abs(a)));
            let e = Math.abs(b) / (2 * d);
            return a >= 0 ? new c(d, b < 0 ? -e : e) : new c(e, b < 0 ? -d : d);
        },
        exp: function() {
            const a = Math.exp(this.re);
            return this.im === 0 ? new c(a, 0) : new c(a * Math.cos(this.im), a * Math.sin(this.im));
        },
        expm1: function() {
            const a = this.re, b = this.im, d = Math.sin(.5 * b);
            return new c(Math.expm1(a) * Math.cos(b) + -2 * d * d, Math.exp(a) * Math.sin(b));
        },
        log: function() {
            const a = this.re, b = this.im;
            return b === 0 && a > 0 ? new c(Math.log(a), 0) : new c(p(a, b), Math.atan2(b, a));
        },
        abs: function() {
            return n(this.re, this.im);
        },
        arg: function() {
            return Math.atan2(this.im, this.re);
        },
        sin: function() {
            const a = this.re, b = this.im;
            return new c(Math.sin(a) * h(b), Math.cos(a) * k(b));
        },
        cos: function() {
            const a = this.re, b = this.im;
            return new c(Math.cos(a) * h(b), -Math.sin(a) * k(b));
        },
        tan: function() {
            const a = 2 * this.re, b = 2 * this.im, d = Math.cos(a) + h(b);
            return new c(Math.sin(a) / d, k(b) / d);
        },
        cot: function() {
            const a = 2 * this.re, b = 2 * this.im, d = Math.cos(a) - h(b);
            return new c(-Math.sin(a) / d, k(b) / d);
        },
        sec: function() {
            const a = this.re, b = this.im, d = .5 * h(2 * b) + .5 * Math.cos(2 * a);
            return new c(Math.cos(a) * h(b) / d, Math.sin(a) * k(b) / d);
        },
        csc: function() {
            const a = this.re, b = this.im, d = .5 * h(2 * b) - .5 * Math.cos(2 * a);
            return new c(Math.sin(a) * h(b) / d, -Math.cos(a) * k(b) / d);
        },
        asin: function() {
            var a = this.re;
            const b = this.im, d = new c(b * b - a * a + 1, -2 * a * b).sqrt();
            a = new c(d.re - b, d.im + a).log();
            return new c(a.im, -a.re);
        },
        acos: function() {
            var a = this.re;
            const b = this.im, d = new c(b * b - a * a + 1, -2 * a * b).sqrt();
            a = new c(d.re - b, d.im + a).log();
            return new c(Math.PI / 2 - a.im, a.re);
        },
        atan: function() {
            var a = this.re;
            const b = this.im;
            if (a === 0) {
                if (b === 1) return new c(0, Infinity);
                if (b === -1) return new c(0, -Infinity);
            }
            const d = a * a + (1 - b) * (1 - b);
            a = new c((1 - b * b - a * a) / d, -2 * a / d).log();
            return new c(-0.5 * a.im, .5 * a.re);
        },
        acot: function() {
            const a = this.re, b = this.im;
            if (b === 0) return new c(Math.atan2(1, a), 0);
            const d = a * a + b * b;
            return d !== 0 ? new c(a / d, -b / d).atan() : new c(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).atan();
        },
        asec: function() {
            const a = this.re, b = this.im;
            if (a === 0 && b === 0) return new c(0, Infinity);
            const d = a * a + b * b;
            return d !== 0 ? new c(a / d, -b / d).acos() : new c(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).acos();
        },
        acsc: function() {
            const a = this.re, b = this.im;
            if (a === 0 && b === 0) return new c(Math.PI / 2, Infinity);
            const d = a * a + b * b;
            return d !== 0 ? new c(a / d, -b / d).asin() : new c(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).asin();
        },
        sinh: function() {
            const a = this.re, b = this.im;
            return new c(k(a) * Math.cos(b), h(a) * Math.sin(b));
        },
        cosh: function() {
            const a = this.re, b = this.im;
            return new c(h(a) * Math.cos(b), k(a) * Math.sin(b));
        },
        tanh: function() {
            const a = 2 * this.re, b = 2 * this.im, d = h(a) + Math.cos(b);
            return new c(k(a) / d, Math.sin(b) / d);
        },
        coth: function() {
            const a = 2 * this.re, b = 2 * this.im, d = h(a) - Math.cos(b);
            return new c(k(a) / d, -Math.sin(b) / d);
        },
        csch: function() {
            const a = this.re, b = this.im, d = Math.cos(2 * b) - h(2 * a);
            return new c(-2 * k(a) * Math.cos(b) / d, 2 * h(a) * Math.sin(b) / d);
        },
        sech: function() {
            const a = this.re, b = this.im, d = Math.cos(2 * b) + h(2 * a);
            return new c(2 * h(a) * Math.cos(b) / d, -2 * k(a) * Math.sin(b) / d);
        },
        asinh: function() {
            const a = this.re;
            var b = this.im;
            if (b === 0) {
                if (a === 0) return new c(0, 0);
                b = Math.abs(a);
                b = Math.log(b + Math.sqrt(b * b + 1));
                return new c(a < 0 ? -b : b, 0);
            }
            const d = new c(a * a - b * b + 1, 2 * a * b).sqrt();
            return new c(a + d.re, b + d.im).log();
        },
        acosh: function() {
            const a = this.re, b = this.im;
            if (b === 0) return a > 1 ? new c(Math.log(a + Math.sqrt(a - 1) * Math.sqrt(a + 1)), 0) : a < -1 ? new c(Math.log(-a + Math.sqrt(a * a - 1)), Math.PI) : new c(0, Math.acos(a));
            const d = new c(a - 1, b).sqrt(), e = new c(a + 1, b).sqrt();
            return new c(a + d.re * e.re - d.im * e.im, b + d.re * e.im + d.im * e.re).log();
        },
        atanh: function() {
            var a = this.re, b = this.im;
            if (b === 0) return a === 0 ? new c(0, 0) : a === 1 ? new c(Infinity, 0) : a === -1 ? new c(-Infinity, 0) : -1 < a && a < 1 ? new c(.5 * Math.log((1 + a) / (1 - a)), 0) : a > 1 ? new c(.5 * Math.log((a + 1) / (a - 1)), -Math.PI / 2) : new c(.5 * Math.log(-((1 + a) / (1 - a))), Math.PI / 2);
            const d = 1 - a, e = 1 + a, g = d * d + b * b;
            if (g === 0) return new c(a !== -1 ? a / 0 : 0, b !== 0 ? b / 0 : 0);
            a = (e * d - b * b) / g;
            b = (b * d + e * b) / g;
            return new c(p(a, b) / 2, Math.atan2(b, a) / 2);
        },
        acoth: function() {
            const a = this.re, b = this.im;
            if (a === 0 && b === 0) return new c(0, Math.PI / 2);
            const d = a * a + b * b;
            return d !== 0 ? new c(a / d, -b / d).atanh() : new c(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).atanh();
        },
        acsch: function() {
            var a = this.re;
            const b = this.im;
            if (b === 0) {
                if (a === 0) return new c(Infinity, 0);
                a = 1 / a;
                return new c(Math.log(a + Math.sqrt(a * a + 1)), 0);
            }
            const d = a * a + b * b;
            return d !== 0 ? new c(a / d, -b / d).asinh() : new c(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).asinh();
        },
        asech: function() {
            const a = this.re, b = this.im;
            if (this.isZero()) return c.INFINITY;
            const d = a * a + b * b;
            return d !== 0 ? new c(a / d, -b / d).acosh() : new c(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).acosh();
        },
        inverse: function() {
            if (this.isZero()) return c.INFINITY;
            if (this.isInfinite()) return c.ZERO;
            const a = this.re, b = this.im, d = a * a + b * b;
            return new c(a / d, -b / d);
        },
        conjugate: function() {
            return new c(this.re, -this.im);
        },
        neg: function() {
            return new c(-this.re, -this.im);
        },
        ceil: function(a) {
            a = Math.pow(10, a || 0);
            return new c(Math.ceil(this.re * a) / a, Math.ceil(this.im * a) / a);
        },
        floor: function(a) {
            a = Math.pow(10, a || 0);
            return new c(Math.floor(this.re * a) / a, Math.floor(this.im * a) / a);
        },
        round: function(a) {
            a = Math.pow(10, a || 0);
            return new c(Math.round(this.re * a) / a, Math.round(this.im * a) / a);
        },
        equals: function(a, b) {
            a = l(a, b);
            return Math.abs(a.re - this.re) <= c.EPSILON && Math.abs(a.im - this.im) <= c.EPSILON;
        },
        clone: function() {
            return new c(this.re, this.im);
        },
        toString: function() {
            let a = this.re, b = this.im, d = "";
            if (this.isNaN()) return "NaN";
            if (this.isInfinite()) return "Infinity";
            Math.abs(a) < c.EPSILON && (a = 0);
            Math.abs(b) < c.EPSILON && (b = 0);
            if (b === 0) return d + a;
            a !== 0 ? (d = d + a + " ", b < 0 ? (b = -b, d += "-") : d += "+", d += " ") : b < 0 && (b = -b, d += "-");
            1 !== b && (d += b);
            return d + "i";
        },
        toVector: function() {
            return [
                this.re,
                this.im
            ];
        },
        valueOf: function() {
            return this.im === 0 ? this.re : null;
        },
        isNaN: function() {
            return isNaN(this.re) || isNaN(this.im);
        },
        isZero: function() {
            return this.im === 0 && this.re === 0;
        },
        isFinite: function() {
            return isFinite(this.re) && isFinite(this.im);
        },
        isInfinite: function() {
            return !this.isFinite();
        }
    };
    c.ZERO = new c(0, 0);
    c.ONE = new c(1, 0);
    c.I = new c(0, 1);
    c.PI = new c(Math.PI, 0);
    c.E = new c(Math.E, 0);
    c.INFINITY = new c(Infinity, Infinity);
    c.NAN = new c(NaN, NaN);
    c.EPSILON = 1E-15;
    typeof define === "function" && define.amd ? define([], function() {
        return c;
    }) : (Object.defineProperty(c, "__esModule", {
        value: !0
    }), c["default"] = c, c.Complex = c, module.exports = c);
})(module.exports);

});


parcelRegister("fMkjK", function(module, exports) {

$parcel$export(module.exports, "createComposition", () => $b7cb195611ab1d24$export$1ddf9cbadd17315f);

var $4eE2e = parcelRequire("4eE2e");
var $b7cb195611ab1d24$var$name = 'composition';
var $b7cb195611ab1d24$var$dependencies = [
    'typed',
    'addScalar',
    'combinations',
    'isNegative',
    'isPositive',
    'isInteger',
    'larger'
];
var $b7cb195611ab1d24$export$1ddf9cbadd17315f = /* #__PURE__ */ (0, $4eE2e.factory)($b7cb195611ab1d24$var$name, $b7cb195611ab1d24$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, combinations: combinations, isPositive: isPositive, isNegative: isNegative, isInteger: isInteger, larger: larger } = _ref;
    /**
   * The composition counts of n into k parts.
   *
   * composition only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *   math.composition(n, k)
   *
   * Examples:
   *
   *    math.composition(5, 3) // returns 6
   *
   * See also:
   *
   *    combinations
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     Returns the composition counts of n into k parts.
   */ return typed($b7cb195611ab1d24$var$name, {
        'number | BigNumber, number | BigNumber': function numberBigNumberNumberBigNumber(n, k) {
            if (!isInteger(n) || !isPositive(n) || !isInteger(k) || !isPositive(k)) throw new TypeError('Positive integer value expected in function composition');
            else if (larger(k, n)) throw new TypeError('k must be less than or equal to n in function composition');
            return combinations(addScalar(n, -1), addScalar(k, -1));
        }
    });
});

});

parcelRegister("eZUfL", function(module, exports) {

$parcel$export(module.exports, "createConcat", () => $aeb265ee9cde7525$export$c36b5511b12560e8);

var $gs7TF = parcelRequire("gs7TF");

var $4mYv9 = parcelRequire("4mYv9");

var $10UPF = parcelRequire("10UPF");

var $9juUc = parcelRequire("9juUc");

var $iAoVB = parcelRequire("iAoVB");

var $4eE2e = parcelRequire("4eE2e");
var $aeb265ee9cde7525$var$name = 'concat';
var $aeb265ee9cde7525$var$dependencies = [
    'typed',
    'matrix',
    'isInteger'
];
var $aeb265ee9cde7525$export$c36b5511b12560e8 = /* #__PURE__ */ (0, $4eE2e.factory)($aeb265ee9cde7525$var$name, $aeb265ee9cde7525$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, isInteger: isInteger } = _ref;
    /**
   * Concatenate two or more matrices.
   *
   * Syntax:
   *
   *     math.concat(A, B, C, ...)
   *     math.concat(A, B, C, ..., dim)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *   By default the last dimension of the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [5, 6]]
   *    const B = [[3, 4], [7, 8]]
   *
   *    math.concat(A, B)                  // returns [[1, 2, 3, 4], [5, 6, 7, 8]]
   *    math.concat(A, B, 0)               // returns [[1, 2], [5, 6], [3, 4], [7, 8]]
   *    math.concat('hello', ' ', 'world') // returns 'hello world'
   *
   * See also:
   *
   *    size, squeeze, subset, transpose
   *
   * @param {... Array | Matrix} args     Two or more matrices
   * @return {Array | Matrix} Concatenated matrix
   */ return typed($aeb265ee9cde7525$var$name, {
        // TODO: change signature to '...Array | Matrix, dim?' when supported
        '...Array | Matrix | number | BigNumber': function ArrayMatrixNumberBigNumber(args) {
            var i;
            var len = args.length;
            var dim = -1; // zero-based dimension
            var prevDim;
            var asMatrix = false;
            var matrices = []; // contains multi dimensional arrays
            for(i = 0; i < len; i++){
                var arg = args[i]; // test whether we need to return a Matrix (if not we return an Array)
                if ((0, $gs7TF.isMatrix)(arg)) asMatrix = true;
                if ((0, $gs7TF.isNumber)(arg) || (0, $gs7TF.isBigNumber)(arg)) {
                    if (i !== len - 1) throw new Error('Dimension must be specified as last argument');
                     // last argument contains the dimension on which to concatenate
                    prevDim = dim;
                    dim = arg.valueOf(); // change BigNumber to number
                    if (!isInteger(dim)) throw new TypeError('Integer number expected for dimension');
                    if (dim < 0 || i > 0 && dim > prevDim) // TODO: would be more clear when throwing a DimensionError here
                    throw new (0, $9juUc.IndexError)(dim, prevDim + 1);
                } else {
                    // this is a matrix or array
                    var m = (0, $4mYv9.clone)(arg).valueOf();
                    var size = (0, $10UPF.arraySize)(m);
                    matrices[i] = m;
                    prevDim = dim;
                    dim = size.length - 1; // verify whether each of the matrices has the same number of dimensions
                    if (i > 0 && dim !== prevDim) throw new (0, $iAoVB.DimensionError)(prevDim + 1, dim + 1);
                }
            }
            if (matrices.length === 0) throw new SyntaxError('At least one matrix expected');
            var res = matrices.shift();
            while(matrices.length)res = $aeb265ee9cde7525$var$_concat(res, matrices.shift(), dim, 0);
            return asMatrix ? matrix(res) : res;
        },
        '...string': function string(args) {
            return args.join('');
        }
    });
});
/**
 * Recursively concatenate two matrices.
 * The contents of the matrices is not cloned.
 * @param {Array} a             Multi dimensional array
 * @param {Array} b             Multi dimensional array
 * @param {number} concatDim    The dimension on which to concatenate (zero-based)
 * @param {number} dim          The current dim (zero-based)
 * @return {Array} c            The concatenated matrix
 * @private
 */ function $aeb265ee9cde7525$var$_concat(a, b, concatDim, dim) {
    if (dim < concatDim) {
        // recurse into next dimension
        if (a.length !== b.length) throw new (0, $iAoVB.DimensionError)(a.length, b.length);
        var c = [];
        for(var i = 0; i < a.length; i++)c[i] = $aeb265ee9cde7525$var$_concat(a[i], b[i], concatDim, dim + 1);
        return c;
    } else // concatenate this dimension
    return a.concat(b);
}

});

parcelRegister("LMkdO", function(module, exports) {

$parcel$export(module.exports, "createConj", () => $08f9e04532ca2445$export$af5efe8ad97f01a2);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $08f9e04532ca2445$var$name = 'conj';
var $08f9e04532ca2445$var$dependencies = [
    'typed'
];
var $08f9e04532ca2445$export$af5efe8ad97f01a2 = /* #__PURE__ */ (0, $4eE2e.factory)($08f9e04532ca2445$var$name, $08f9e04532ca2445$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the complex conjugate of a complex value.
   * If `x = a+bi`, the complex conjugate of `x` is `a - bi`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.conj(x)
   *
   * Examples:
   *
   *    math.conj(math.complex('2 + 3i'))  // returns Complex 2 - 3i
   *    math.conj(math.complex('2 - 3i'))  // returns Complex 2 + 3i
   *    math.conj(math.complex('-5.2i'))  // returns Complex 5.2i
   *
   * See also:
   *
   *    re, im, arg, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            The complex conjugate of x
   */ return typed($08f9e04532ca2445$var$name, {
        number: function number(x) {
            return x;
        },
        BigNumber: function BigNumber(x) {
            return x;
        },
        Complex: function Complex(x) {
            return x.conjugate();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("bAJmb", function(module, exports) {

$parcel$export(module.exports, "createCos", () => $87063d6b64e69b28$export$923b60dfa791c630);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $87063d6b64e69b28$var$name = 'cos';
var $87063d6b64e69b28$var$dependencies = [
    'typed'
];
var $87063d6b64e69b28$export$923b60dfa791c630 = /* #__PURE__ */ (0, $4eE2e.factory)($87063d6b64e69b28$var$name, $87063d6b64e69b28$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the cosine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cos(x)
   *
   * Examples:
   *
   *    math.cos(2)                      // returns number -0.4161468365471422
   *    math.cos(math.pi / 4)            // returns number  0.7071067811865475
   *    math.cos(math.unit(180, 'deg'))  // returns number -1
   *    math.cos(math.unit(60, 'deg'))   // returns number  0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number ~1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Cosine of x
   */ return typed($87063d6b64e69b28$var$name, {
        number: Math.cos,
        Complex: function Complex(x) {
            return x.cos();
        },
        BigNumber: function BigNumber(x) {
            return x.cos();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function cos is no angle');
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("azcwD", function(module, exports) {

$parcel$export(module.exports, "createCosh", () => $7b16e390be871550$export$63d35097da636c02);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $6egKm = parcelRequire("6egKm");
var $7b16e390be871550$var$name = 'cosh';
var $7b16e390be871550$var$dependencies = [
    'typed'
];
var $7b16e390be871550$export$63d35097da636c02 = /* #__PURE__ */ (0, $4eE2e.factory)($7b16e390be871550$var$name, $7b16e390be871550$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic cosine of a value,
   * defined as `cosh(x) = 1/2 * (exp(x) + exp(-x))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cosh(x)
   *
   * Examples:
   *
   *    math.cosh(0.5)       // returns number 1.1276259652063807
   *
   * See also:
   *
   *    sinh, tanh
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic cosine of x
   */ return typed($7b16e390be871550$var$name, {
        number: (0, $6egKm.cosh),
        Complex: function Complex(x) {
            return x.cosh();
        },
        BigNumber: function BigNumber(x) {
            return x.cosh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function cosh is no angle');
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("55m3V", function(module, exports) {

$parcel$export(module.exports, "createCot", () => $3b3e888571d4a1dc$export$c5598f542ea1565c);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $3b3e888571d4a1dc$var$name = 'cot';
var $3b3e888571d4a1dc$var$dependencies = [
    'typed',
    'BigNumber'
];
var $3b3e888571d4a1dc$export$c5598f542ea1565c = /* #__PURE__ */ (0, $4eE2e.factory)($3b3e888571d4a1dc$var$name, $3b3e888571d4a1dc$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the cotangent of a value. Defined as `cot(x) = 1 / tan(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cot(x)
   *
   * Examples:
   *
   *    math.cot(2)      // returns number -0.45765755436028577
   *    1 / math.tan(2)  // returns number -0.45765755436028577
   *
   * See also:
   *
   *    tan, sec, csc
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Cotangent of x
   */ return typed($3b3e888571d4a1dc$var$name, {
        number: (0, $fkvqw.cotNumber),
        Complex: function Complex(x) {
            return x.cot();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.tan());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function cot is no angle');
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("4lxho", function(module, exports) {

$parcel$export(module.exports, "createCoth", () => $32a2f03794aa4de9$export$3f7f9b5400315e6a);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $32a2f03794aa4de9$var$name = 'coth';
var $32a2f03794aa4de9$var$dependencies = [
    'typed',
    'BigNumber'
];
var $32a2f03794aa4de9$export$3f7f9b5400315e6a = /* #__PURE__ */ (0, $4eE2e.factory)($32a2f03794aa4de9$var$name, $32a2f03794aa4de9$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic cotangent of a value,
   * defined as `coth(x) = 1 / tanh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.coth(x)
   *
   * Examples:
   *
   *    // coth(x) = 1 / tanh(x)
   *    math.coth(2)         // returns 1.0373147207275482
   *    1 / math.tanh(2)     // returns 1.0373147207275482
   *
   * See also:
   *
   *    sinh, tanh, cosh
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic cotangent of x
   */ return typed($32a2f03794aa4de9$var$name, {
        number: (0, $fkvqw.cothNumber),
        Complex: function Complex(x) {
            return x.coth();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.tanh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function coth is no angle');
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("g3xgo", function(module, exports) {

$parcel$export(module.exports, "createCount", () => $bb06ba920c6ab485$export$decd32c762b504bc);

var $4eE2e = parcelRequire("4eE2e");
var $bb06ba920c6ab485$var$name = 'count';
var $bb06ba920c6ab485$var$dependencies = [
    'typed',
    'size',
    'prod'
];
var $bb06ba920c6ab485$export$decd32c762b504bc = /* #__PURE__ */ (0, $4eE2e.factory)($bb06ba920c6ab485$var$name, $bb06ba920c6ab485$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, prod: prod } = _ref;
    /**
   * Count the number of elements of a matrix, array or string.
   *
   * Syntax:
   *
   *     math.count(x)
   *
   * Examples:
   *
   *     math.count('hello world')        // returns 11
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.count(A)                    // returns 6
   *     math.count(math.range(1,6))      // returns 5
   *
   * See also:
   *
   *     size
   *
   * @param {string | Array | Matrix} x  A matrix or string
   * @return {number} An integer with the elements in `x`.
   */ return typed($bb06ba920c6ab485$var$name, {
        string: function string(x) {
            return x.length;
        },
        'Matrix | Array': function MatrixArray(x) {
            return prod(size(x));
        }
    });
});

});

parcelRegister("2DDJF", function(module, exports) {

$parcel$export(module.exports, "createCreateUnit", () => $1ebe0beded3defc4$export$27641941eb5cadbb);

var $4eE2e = parcelRequire("4eE2e");
var $1ebe0beded3defc4$var$name = 'createUnit';
var $1ebe0beded3defc4$var$dependencies = [
    'typed',
    'Unit'
];
var $1ebe0beded3defc4$export$27641941eb5cadbb = /* #__PURE__ */ (0, $4eE2e.factory)($1ebe0beded3defc4$var$name, $1ebe0beded3defc4$var$dependencies, (_ref)=>{
    var { typed: typed, Unit: Unit } = _ref;
    /**
   * Create a user-defined unit and register it with the Unit type.
   *
   * Syntax:
   *
   *     math.createUnit({
   *       baseUnit1: {
   *         aliases: [string, ...]
   *         prefixes: object
   *       },
   *       unit2: {
   *         definition: string,
   *         aliases: [string, ...]
   *         prefixes: object,
   *         offset: number
   *       },
   *       unit3: string    // Shortcut
   *     })
   *
   *     // Another shortcut:
   *     math.createUnit(string, unit : string, [object])
   *
   * Examples:
   *
   *     math.createUnit('foo')
   *     math.createUnit('knot', {definition: '0.514444444 m/s', aliases: ['knots', 'kt', 'kts']})
   *     math.createUnit('mph', '1 mile/hour')
   *
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string, Unit} definition      Definition of the unit in terms of existing units. For example, '0.514444444 m / s'.
   * @param {Object} options   (optional) An object containing any of the following properties:
   *     - `prefixes {string}` "none", "short", "long", "binary_short", or "binary_long". The default is "none".
   *     - `aliases {Array}` Array of strings. Example: ['knots', 'kt', 'kts']
   *     - `offset {Numeric}` An offset to apply when converting from the unit. For example, the offset for celsius is 273.15. Default is 0.
   *
   * See also:
   *
   *     unit
   *
   * @return {Unit} The new unit
   */ return typed($1ebe0beded3defc4$var$name, {
        // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
        'Object, Object': function ObjectObject(obj, options) {
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        Object: function Object(obj) {
            return Unit.createUnit(obj, {});
        },
        // Shortcut method for creating one unit.
        'string, Unit | string | Object, Object': function stringUnitStringObjectObject(name, def, options) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        'string, Unit | string | Object': function stringUnitStringObject(name, def) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, {});
        },
        // Without a definition, creates a base unit.
        string: function string(name) {
            var obj = {};
            obj[name] = {};
            return Unit.createUnit(obj, {});
        }
    });
});

});

parcelRegister("dELqD", function(module, exports) {

$parcel$export(module.exports, "createCross", () => $9f13cd1bc9403ea7$export$bc2585c0ed744c0e);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $9f13cd1bc9403ea7$var$name = 'cross';
var $9f13cd1bc9403ea7$var$dependencies = [
    'typed',
    'matrix',
    'subtract',
    'multiply'
];
var $9f13cd1bc9403ea7$export$bc2585c0ed744c0e = /* #__PURE__ */ (0, $4eE2e.factory)($9f13cd1bc9403ea7$var$name, $9f13cd1bc9403ea7$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, multiply: multiply } = _ref;
    /**
   * Calculate the cross product for two vectors in three dimensional space.
   * The cross product of `A = [a1, a2, a3]` and `B = [b1, b2, b3]` is defined
   * as:
   *
   *    cross(A, B) = [
   *      a2 * b3 - a3 * b2,
   *      a3 * b1 - a1 * b3,
   *      a1 * b2 - a2 * b1
   *    ]
   *
   * If one of the input vectors has a dimension greater than 1, the output
   * vector will be a 1x3 (2-dimensional) matrix.
   *
   * Syntax:
   *
   *    math.cross(x, y)
   *
   * Examples:
   *
   *    math.cross([1, 1, 0],   [0, 1, 1])       // Returns [1, -1, 1]
   *    math.cross([3, -3, 1],  [4, 9, 2])       // Returns [-15, -2, 39]
   *    math.cross([2, 3, 4],   [5, 6, 7])       // Returns [-3, 6, -3]
   *    math.cross([[1, 2, 3]], [[4], [5], [6]]) // Returns [[-3, 6, -3]]
   *
   * See also:
   *
   *    dot, multiply
   *
   * @param  {Array | Matrix} x   First vector
   * @param  {Array | Matrix} y   Second vector
   * @return {Array | Matrix}     Returns the cross product of `x` and `y`
   */ return typed($9f13cd1bc9403ea7$var$name, {
        'Matrix, Matrix': function MatrixMatrix(x, y) {
            return matrix(_cross(x.toArray(), y.toArray()));
        },
        'Matrix, Array': function MatrixArray(x, y) {
            return matrix(_cross(x.toArray(), y));
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            return matrix(_cross(x, y.toArray()));
        },
        'Array, Array': _cross
    });
    /**
   * Calculate the cross product for two arrays
   * @param {Array} x  First vector
   * @param {Array} y  Second vector
   * @returns {Array} Returns the cross product of x and y
   * @private
   */ function _cross(x, y) {
        var highestDimension = Math.max((0, $10UPF.arraySize)(x).length, (0, $10UPF.arraySize)(y).length);
        x = (0, $10UPF.squeeze)(x);
        y = (0, $10UPF.squeeze)(y);
        var xSize = (0, $10UPF.arraySize)(x);
        var ySize = (0, $10UPF.arraySize)(y);
        if (xSize.length !== 1 || ySize.length !== 1 || xSize[0] !== 3 || ySize[0] !== 3) throw new RangeError("Vectors with length 3 expected (Size A = [" + xSize.join(', ') + '], B = [' + ySize.join(', ') + '])');
        var product = [
            subtract(multiply(x[1], y[2]), multiply(x[2], y[1])),
            subtract(multiply(x[2], y[0]), multiply(x[0], y[2])),
            subtract(multiply(x[0], y[1]), multiply(x[1], y[0]))
        ];
        if (highestDimension > 1) return [
            product
        ];
        else return product;
    }
});

});

parcelRegister("iXClk", function(module, exports) {

$parcel$export(module.exports, "createCsc", () => $dcdb7ad35161d507$export$a0beb298aa7a2962);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $dcdb7ad35161d507$var$name = 'csc';
var $dcdb7ad35161d507$var$dependencies = [
    'typed',
    'BigNumber'
];
var $dcdb7ad35161d507$export$a0beb298aa7a2962 = /* #__PURE__ */ (0, $4eE2e.factory)($dcdb7ad35161d507$var$name, $dcdb7ad35161d507$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the cosecant of a value, defined as `csc(x) = 1/sin(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.csc(x)
   *
   * Examples:
   *
   *    math.csc(2)      // returns number 1.099750170294617
   *    1 / math.sin(2)  // returns number 1.099750170294617
   *
   * See also:
   *
   *    sin, sec, cot
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Cosecant of x
   */ return typed($dcdb7ad35161d507$var$name, {
        number: (0, $fkvqw.cscNumber),
        Complex: function Complex(x) {
            return x.csc();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.sin());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function csc is no angle');
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("2jlSc", function(module, exports) {

$parcel$export(module.exports, "createCsch", () => $1aee52b3aa8c0ea5$export$9160aa3a39425fc9);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $1aee52b3aa8c0ea5$var$name = 'csch';
var $1aee52b3aa8c0ea5$var$dependencies = [
    'typed',
    'BigNumber'
];
var $1aee52b3aa8c0ea5$export$9160aa3a39425fc9 = /* #__PURE__ */ (0, $4eE2e.factory)($1aee52b3aa8c0ea5$var$name, $1aee52b3aa8c0ea5$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic cosecant of a value,
   * defined as `csch(x) = 1 / sinh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.csch(x)
   *
   * Examples:
   *
   *    // csch(x) = 1/ sinh(x)
   *    math.csch(0.5)       // returns 1.9190347513349437
   *    1 / math.sinh(0.5)   // returns 1.9190347513349437
   *
   * See also:
   *
   *    sinh, sech, coth
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic cosecant of x
   */ return typed($1aee52b3aa8c0ea5$var$name, {
        number: (0, $fkvqw.cschNumber),
        Complex: function Complex(x) {
            return x.csch();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.sinh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function csch is no angle');
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("95cDc", function(module, exports) {

$parcel$export(module.exports, "createCtranspose", () => $69ce6100fd31b3da$export$5d07146b3894f212);

var $4eE2e = parcelRequire("4eE2e");
var $69ce6100fd31b3da$var$name = 'ctranspose';
var $69ce6100fd31b3da$var$dependencies = [
    'typed',
    'transpose',
    'conj'
];
var $69ce6100fd31b3da$export$5d07146b3894f212 = /* #__PURE__ */ (0, $4eE2e.factory)($69ce6100fd31b3da$var$name, $69ce6100fd31b3da$var$dependencies, (_ref)=>{
    var { typed: typed, transpose: transpose, conj: conj } = _ref;
    /**
   * Transpose and complex conjugate a matrix. All values of the matrix are
   * reflected over its main diagonal and then the complex conjugate is
   * taken. This is equivalent to complex conjugation for scalars and
   * vectors.
   *
   * Syntax:
   *
   *     math.ctranspose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, math.complex(6,7)]]
   *     math.ctranspose(A)               // returns [[1, 4], [2, 5], [3, {re:6,im:7}]]
   *
   * See also:
   *
   *     transpose, diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be ctransposed
   * @return {Array | Matrix}   The ctransposed matrix
   */ return typed($69ce6100fd31b3da$var$name, {
        any: function any(x) {
            return conj(transpose(x));
        }
    });
});

});

parcelRegister("2WfNa", function(module, exports) {

$parcel$export(module.exports, "createCube", () => $223d3f8a297743ab$export$ce223d612b94804b);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $eRNhQ = parcelRequire("eRNhQ");
var $223d3f8a297743ab$var$name = 'cube';
var $223d3f8a297743ab$var$dependencies = [
    'typed'
];
var $223d3f8a297743ab$export$ce223d612b94804b = /* #__PURE__ */ (0, $4eE2e.factory)($223d3f8a297743ab$var$name, $223d3f8a297743ab$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the cube of a value, `x * x * x`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cube(x)
   *
   * Examples:
   *
   *    math.cube(2)            // returns number 8
   *    math.pow(2, 3)          // returns number 8
   *    math.cube(4)            // returns number 64
   *    4 * 4 * 4               // returns number 64
   *
   *    math.cube([1, 2, 3, 4]) // returns Array [1, 8, 27, 64]
   *
   * See also:
   *
   *    multiply, square, pow, cbrt
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x  Number for which to calculate the cube
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} Cube of x
   */ return typed($223d3f8a297743ab$var$name, {
        number: (0, $eRNhQ.cubeNumber),
        Complex: function Complex(x) {
            return x.mul(x).mul(x); // Is faster than pow(x, 3)
        },
        BigNumber: function BigNumber(x) {
            return x.times(x).times(x);
        },
        Fraction: function Fraction(x) {
            return x.pow(3); // Is faster than mul()mul()mul()
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since cube(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        },
        Unit: function Unit(x) {
            return x.pow(3);
        }
    });
});

});

parcelRegister("hY5r0", function(module, exports) {

$parcel$export(module.exports, "createDeepEqual", () => $d14c416feebd3773$export$b1b11fc839367b58);

var $4eE2e = parcelRequire("4eE2e");
var $d14c416feebd3773$var$name = 'deepEqual';
var $d14c416feebd3773$var$dependencies = [
    'typed',
    'equal'
];
var $d14c416feebd3773$export$b1b11fc839367b58 = /* #__PURE__ */ (0, $4eE2e.factory)($d14c416feebd3773$var$name, $d14c416feebd3773$var$dependencies, (_ref)=>{
    var { typed: typed, equal: equal } = _ref;
    /**
   * Test element wise whether two matrices are equal.
   * The function accepts both matrices and scalar values.
   *
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.deepEqual(x, y)
   *
   * Examples:
   *
   *    math.deepEqual(2, 4)   // returns false
   *
   *    a = [2, 5, 1]
   *    b = [2, 7, 1]
   *
   *    math.deepEqual(a, b)   // returns false
   *    math.equal(a, b)       // returns [true, false, true]
   *
   * See also:
   *
   *    equal, unequal
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First matrix to compare
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second matrix to compare
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Returns true when the input matrices have the same size and each of their elements is equal.
   */ return typed($d14c416feebd3773$var$name, {
        'any, any': function anyAny(x, y) {
            return _deepEqual(x.valueOf(), y.valueOf());
        }
    });
    /**
   * Test whether two arrays have the same size and all elements are equal
   * @param {Array | *} x
   * @param {Array | *} y
   * @return {boolean} Returns true if both arrays are deep equal
   */ function _deepEqual(x, y) {
        if (Array.isArray(x)) {
            if (Array.isArray(y)) {
                var len = x.length;
                if (len !== y.length) return false;
                for(var i = 0; i < len; i++){
                    if (!_deepEqual(x[i], y[i])) return false;
                }
                return true;
            } else return false;
        } else {
            if (Array.isArray(y)) return false;
            else return equal(x, y);
        }
    }
});

});

parcelRegister("beYd8", function(module, exports) {

$parcel$export(module.exports, "createDenseMatrixClass", () => $82efb52326a31523$export$1a088ca8dd364cd1);

var $gs7TF = parcelRequire("gs7TF");

var $10UPF = parcelRequire("10UPF");

var $aEppI = parcelRequire("aEppI");

var $6egKm = parcelRequire("6egKm");

var $4mYv9 = parcelRequire("4mYv9");

var $iAoVB = parcelRequire("iAoVB");

var $4eE2e = parcelRequire("4eE2e");
var $82efb52326a31523$var$name = 'DenseMatrix';
var $82efb52326a31523$var$dependencies = [
    'Matrix'
];
var $82efb52326a31523$export$1a088ca8dd364cd1 = /* #__PURE__ */ (0, $4eE2e.factory)($82efb52326a31523$var$name, $82efb52326a31523$var$dependencies, (_ref)=>{
    var { Matrix: Matrix } = _ref;
    /**
   * Dense Matrix implementation. A regular, dense matrix, supporting multi-dimensional matrices. This is the default matrix type.
   * @class DenseMatrix
   * @enum {{ value, index: number[] }}
   */ function DenseMatrix(data, datatype) {
        if (!(this instanceof DenseMatrix)) throw new SyntaxError('Constructor must be called with the new operator');
        if (datatype && !(0, $gs7TF.isString)(datatype)) throw new Error('Invalid datatype: ' + datatype);
        if ((0, $gs7TF.isMatrix)(data)) {
            // check data is a DenseMatrix
            if (data.type === 'DenseMatrix') {
                // clone data & size
                this._data = (0, $4mYv9.clone)(data._data);
                this._size = (0, $4mYv9.clone)(data._size);
                this._datatype = datatype || data._datatype;
            } else {
                // build data from existing matrix
                this._data = data.toArray();
                this._size = data.size();
                this._datatype = datatype || data._datatype;
            }
        } else if (data && (0, $gs7TF.isArray)(data.data) && (0, $gs7TF.isArray)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size; // verify the dimensions of the array
            (0, $10UPF.validate)(this._data, this._size);
            this._datatype = datatype || data.datatype;
        } else if ((0, $gs7TF.isArray)(data)) {
            // replace nested Matrices with Arrays
            this._data = preprocess(data); // get the dimensions of the array
            this._size = (0, $10UPF.arraySize)(this._data); // verify the dimensions of the array, TODO: compute size while processing array
            (0, $10UPF.validate)(this._data, this._size); // data type unknown
            this._datatype = datatype;
        } else if (data) // unsupported type
        throw new TypeError('Unsupported type of data (' + (0, $gs7TF.typeOf)(data) + ')');
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
        }
    }
    DenseMatrix.prototype = new Matrix();
    /**
   * Create a new DenseMatrix
   */ DenseMatrix.prototype.createDenseMatrix = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ DenseMatrix.prototype.type = 'DenseMatrix';
    DenseMatrix.prototype.isDenseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf DenseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ DenseMatrix.prototype.getDataType = function() {
        return (0, $10UPF.getArrayDataType)(this._data, (0, $gs7TF.typeOf));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()  // retrieve storage format
   *
   * @memberof DenseMatrix
   * @return {string}           The storage format.
   */ DenseMatrix.prototype.storage = function() {
        return 'dense';
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()   // retrieve matrix datatype
   *
   * @memberof DenseMatrix
   * @return {string}           The datatype.
   */ DenseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new DenseMatrix
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ DenseMatrix.prototype.create = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof DenseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ DenseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        switch(arguments.length){
            case 1:
                return _get(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _set(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError('Wrong number of arguments');
        }
    };
    /**
   * Get a single element from the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ DenseMatrix.prototype.get = function(index) {
        if (!(0, $gs7TF.isArray)(index)) throw new TypeError('Array expected');
        if (index.length !== this._size.length) throw new (0, $iAoVB.DimensionError)(index.length, this._size.length);
         // check index
        for(var x = 0; x < index.length; x++)(0, $10UPF.validateIndex)(index[x], this._size[x]);
        var data = this._data;
        for(var i = 0, ii = index.length; i < ii; i++){
            var indexI = index[i];
            (0, $10UPF.validateIndex)(indexI, data.length);
            data = data[indexI];
        }
        return data;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {DenseMatrix} self
   */ DenseMatrix.prototype.set = function(index, value, defaultValue) {
        if (!(0, $gs7TF.isArray)(index)) throw new TypeError('Array expected');
        if (index.length < this._size.length) throw new (0, $iAoVB.DimensionError)(index.length, this._size.length, '<');
        var i, ii, indexI; // enlarge matrix when needed
        var size = index.map(function(i) {
            return i + 1;
        });
        _fit(this, size, defaultValue); // traverse over the dimensions
        var data = this._data;
        for(i = 0, ii = index.length - 1; i < ii; i++){
            indexI = index[i];
            (0, $10UPF.validateIndex)(indexI, data.length);
            data = data[indexI];
        } // set new value
        indexI = index[index.length - 1];
        (0, $10UPF.validateIndex)(indexI, data.length);
        data[indexI] = value;
        return this;
    };
    /**
   * Get a submatrix of this matrix
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index   Zero-based index
   * @private
   */ function _get(matrix, index) {
        if (!(0, $gs7TF.isIndex)(index)) throw new TypeError('Invalid index');
        var isScalar = index.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(index.min());
        else {
            // validate dimensions
            var size = index.size();
            if (size.length !== matrix._size.length) throw new (0, $iAoVB.DimensionError)(size.length, matrix._size.length);
             // validate if any of the ranges in the index is out of range
            var min = index.min();
            var max = index.max();
            for(var i = 0, ii = matrix._size.length; i < ii; i++){
                (0, $10UPF.validateIndex)(min[i], matrix._size[i]);
                (0, $10UPF.validateIndex)(max[i], matrix._size[i]);
            } // retrieve submatrix
            // TODO: more efficient when creating an empty matrix and setting _data and _size manually
            return new DenseMatrix(_getSubmatrix(matrix._data, index, size.length, 0), matrix._datatype);
        }
    }
    /**
   * Recursively get a submatrix of a multi dimensional matrix.
   * Index is not checked for correct number or length of dimensions.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {number} dims   Total number of dimensions
   * @param {number} dim    Current dimension
   * @return {Array} submatrix
   * @private
   */ function _getSubmatrix(data, index, dims, dim) {
        var last = dim === dims - 1;
        var range = index.dimension(dim);
        if (last) return range.map(function(i) {
            (0, $10UPF.validateIndex)(i, data.length);
            return data[i];
        }).valueOf();
        else return range.map(function(i) {
            (0, $10UPF.validateIndex)(i, data.length);
            var child = data[i];
            return _getSubmatrix(child, index, dims, dim + 1);
        }).valueOf();
    }
    /**
   * Replace a submatrix in this matrix
   * Indexes are zero-based.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index
   * @param {DenseMatrix | Array | *} submatrix
   * @param {*} defaultValue          Default value, filled in on new entries when
   *                                  the matrix is resized.
   * @return {DenseMatrix} matrix
   * @private
   */ function _set(matrix, index, submatrix, defaultValue) {
        if (!index || index.isIndex !== true) throw new TypeError('Invalid index');
         // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar(); // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $gs7TF.isMatrix)(submatrix)) {
            sSize = submatrix.size();
            submatrix = submatrix.valueOf();
        } else sSize = (0, $10UPF.arraySize)(submatrix);
        if (isScalar) {
            // set a scalar
            // check whether submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError('Scalar expected');
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // set a submatrix
            // validate dimensions
            if (iSize.length < matrix._size.length) throw new (0, $iAoVB.DimensionError)(iSize.length, matrix._size.length, '<');
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                } // unsqueeze both outer and inner dimensions
                submatrix = (0, $10UPF.unsqueeze)(submatrix, iSize.length, outer, sSize);
            } // check whether the size of the submatrix matches the index size
            if (!(0, $4mYv9.deepStrictEqual)(iSize, sSize)) throw new (0, $iAoVB.DimensionError)(iSize, sSize, '>');
             // enlarge matrix when needed
            var size = index.max().map(function(i) {
                return i + 1;
            });
            _fit(matrix, size, defaultValue); // insert the sub matrix
            var dims = iSize.length;
            var dim = 0;
            _setSubmatrix(matrix._data, index, submatrix, dims, dim);
        }
        return matrix;
    }
    /**
   * Replace a submatrix of a multi dimensional matrix.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {Array} submatrix
   * @param {number} dims   Total number of dimensions
   * @param {number} dim
   * @private
   */ function _setSubmatrix(data, index, submatrix, dims, dim) {
        var last = dim === dims - 1;
        var range = index.dimension(dim);
        if (last) range.forEach(function(dataIndex, subIndex) {
            (0, $10UPF.validateIndex)(dataIndex);
            data[dataIndex] = submatrix[subIndex[0]];
        });
        else range.forEach(function(dataIndex, subIndex) {
            (0, $10UPF.validateIndex)(dataIndex);
            _setSubmatrix(data[dataIndex], index, submatrix[subIndex[0]], dims, dim + 1);
        });
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof DenseMatrix
   * @param {number[] || Matrix} size The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ DenseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $gs7TF.isCollection)(size)) throw new TypeError('Array or Matrix expected');
         // SparseMatrix input is always 2d, flatten this into 1d if it's indeed a vector
        var sizeArray = size.valueOf().map((value)=>{
            return Array.isArray(value) && value.length === 1 ? value[0] : value;
        }); // matrix to resize
        var m = copy ? this.clone() : this; // resize matrix
        return _resize(m, sizeArray, defaultValue);
    };
    function _resize(matrix, size, defaultValue) {
        // check size
        if (size.length === 0) {
            // first value in matrix
            var v = matrix._data; // go deep
            while((0, $gs7TF.isArray)(v))v = v[0];
            return v;
        } // resize matrix
        matrix._size = size.slice(0); // copy the array
        matrix._data = (0, $10UPF.resize)(matrix._data, matrix._size, defaultValue); // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof DenseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ DenseMatrix.prototype.reshape = function(size, copy) {
        var m = copy ? this.clone() : this;
        m._data = (0, $10UPF.reshape)(m._data, size);
        var currentLength = m._size.reduce((length, size)=>length * size);
        m._size = (0, $10UPF.processSizesWildcard)(size, currentLength);
        return m;
    };
    /**
   * Enlarge the matrix when it is smaller than given size.
   * If the matrix is larger or equal sized, nothing is done.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix           The matrix to be resized
   * @param {number[]} size
   * @param {*} defaultValue          Default value, filled in on new entries.
   * @private
   */ function _fit(matrix, size, defaultValue) {
        var newSize = matrix._size.slice(0);
        var changed = false; // add dimensions when needed
        while(newSize.length < size.length){
            newSize.push(0);
            changed = true;
        } // enlarge size when needed
        for(var i = 0, ii = size.length; i < ii; i++)if (size[i] > newSize[i]) {
            newSize[i] = size[i];
            changed = true;
        }
        if (changed) // resize only when size is changed
        _resize(matrix, newSize, defaultValue);
    }
    /**
   * Create a clone of the matrix
   * @memberof DenseMatrix
   * @return {DenseMatrix} clone
   */ DenseMatrix.prototype.clone = function() {
        var m = new DenseMatrix({
            data: (0, $4mYv9.clone)(this._data),
            size: (0, $4mYv9.clone)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof DenseMatrix
   * @returns {number[]} size
   */ DenseMatrix.prototype.size = function() {
        return this._size.slice(0); // return a clone of _size
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   *
   * @return {DenseMatrix} matrix
   */ DenseMatrix.prototype.map = function(callback) {
        // matrix instance
        var me = this;
        var recurse = function recurse(value, index) {
            if ((0, $gs7TF.isArray)(value)) return value.map(function(child, i) {
                return recurse(child, index.concat(i));
            });
            else return callback(value, index, me);
        }; // determine the new datatype when the original matrix has datatype defined
        // TODO: should be done in matrix constructor instead
        var data = recurse(this._data, []);
        var datatype = this._datatype !== undefined ? (0, $10UPF.getArrayDataType)(data, (0, $gs7TF.typeOf)) : undefined;
        return new DenseMatrix(data, datatype);
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ DenseMatrix.prototype.forEach = function(callback) {
        // matrix instance
        var me = this;
        var recurse = function recurse(value, index) {
            if ((0, $gs7TF.isArray)(value)) value.forEach(function(child, i) {
                recurse(child, index.concat(i));
            });
            else callback(value, index, me);
        };
        recurse(this._data, []);
    };
    /**
   * Iterate over the matrix elements
   * @return {Iterable<{ value, index: number[] }>}
   */ DenseMatrix.prototype[Symbol.iterator] = function*() {
        var recurse = function* recurse(value, index) {
            if ((0, $gs7TF.isArray)(value)) for(var i = 0; i < value.length; i++)yield* recurse(value[i], index.concat(i));
            else yield {
                value: value,
                index: index
            };
        };
        yield* recurse(this._data, []);
    };
    /**
   * Returns an array containing the rows of a 2D matrix
   * @returns {Array<Matrix>}
   */ DenseMatrix.prototype.rows = function() {
        var result = [];
        var s = this.size();
        if (s.length !== 2) throw new TypeError('Rows can only be returned for a 2D matrix.');
        var data = this._data;
        for (var row of data)result.push(new DenseMatrix([
            row
        ], this._datatype));
        return result;
    };
    /**
   * Returns an array containing the columns of a 2D matrix
   * @returns {Array<Matrix>}
   */ DenseMatrix.prototype.columns = function() {
        var _this = this;
        var result = [];
        var s = this.size();
        if (s.length !== 2) throw new TypeError('Rows can only be returned for a 2D matrix.');
        var data = this._data;
        var _loop = function _loop(i) {
            var col = data.map((row)=>[
                    row[i]
                ]);
            result.push(new DenseMatrix(col, _this._datatype));
        };
        for(var i = 0; i < s[1]; i++)_loop(i);
        return result;
    };
    /**
   * Create an Array with a copy of the data of the DenseMatrix
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.toArray = function() {
        return (0, $4mYv9.clone)(this._data);
    };
    /**
   * Get the primitive value of the DenseMatrix: a multidimensional array
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.valueOf = function() {
        return this._data;
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof DenseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ DenseMatrix.prototype.format = function(options) {
        return (0, $aEppI.format)(this._data, options);
    };
    /**
   * Get a string representation of the matrix
   * @memberof DenseMatrix
   * @returns {string} str
   */ DenseMatrix.prototype.toString = function() {
        return (0, $aEppI.format)(this._data);
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof DenseMatrix
   * @returns {Object}
   */ DenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: 'DenseMatrix',
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof DenseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix with the diagonal values.
   */ DenseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $gs7TF.isBigNumber)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $gs7TF.isNumber)(k) || !(0, $6egKm.isInteger)(k)) throw new TypeError('The parameter k must be an integer number');
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper); // x is a matrix get diagonal from matrix
        var data = []; // loop rows
        for(var i = 0; i < n; i++)data[i] = this._data[i + kSub][i + kSuper];
         // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                n
            ],
            datatype: this._datatype
        });
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof DenseMatrix
   * @param {Array} size                     The matrix size.
   * @param {number | Matrix | Array } value The values for the diagonal.
   * @param {number | BigNumber} [k=0]       The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]          The default value for non-diagonal
   * @param {string} [datatype]              The datatype for the diagonal
   *
   * @returns {DenseMatrix}
   */ DenseMatrix.diagonal = function(size, value, k, defaultValue) {
        if (!(0, $gs7TF.isArray)(size)) throw new TypeError('Array expected, size parameter');
        if (size.length !== 2) throw new Error('Only two dimensions matrix are supported');
         // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $gs7TF.isBigNumber)(s)) // convert it
            s = s.toNumber();
             // validate arguments
            if (!(0, $gs7TF.isNumber)(s) || !(0, $6egKm.isInteger)(s) || s < 1) throw new Error('Size values must be positive integers');
            return s;
        }); // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $gs7TF.isBigNumber)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $gs7TF.isNumber)(k) || !(0, $6egKm.isInteger)(k)) throw new TypeError('The parameter k must be an integer number');
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows and columns
        var rows = size[0];
        var columns = size[1]; // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper); // value extraction function
        var _value; // check value
        if ((0, $gs7TF.isArray)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error('Invalid value array length');
             // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $gs7TF.isMatrix)(value)) {
            // matrix size
            var ms = value.size(); // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error('Invalid matrix length');
             // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
         // discover default value if needed
        if (!defaultValue) // check first value in array
        defaultValue = (0, $gs7TF.isBigNumber)(_value(0)) ? _value(0).mul(0) // trick to create a BigNumber with value zero
         : 0;
         // empty array
        var data = []; // check we need to resize array
        if (size.length > 0) {
            // resize array
            data = (0, $10UPF.resize)(data, size, defaultValue); // fill diagonal
            for(var d = 0; d < n; d++)data[d + kSub][d + kSuper] = _value(d);
        } // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof DenseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "DenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {DenseMatrix}
   */ DenseMatrix.fromJSON = function(json) {
        return new DenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof DenseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ DenseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $gs7TF.isNumber)(i) || !(0, $6egKm.isInteger)(i) || !(0, $gs7TF.isNumber)(j) || !(0, $6egKm.isInteger)(j)) throw new Error('Row index must be positive integers');
         // check dimensions
        if (this._size.length !== 2) throw new Error('Only two dimensional matrix is supported');
         // validate index
        (0, $10UPF.validateIndex)(i, this._size[0]);
        (0, $10UPF.validateIndex)(j, this._size[0]); // swap rows
        DenseMatrix._swapRows(i, j, this._data); // return current instance
        return this;
    };
    /**
   * Swap rows i and j in Dense Matrix data structure.
   *
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   * @param {Array} data     Matrix data
   */ DenseMatrix._swapRows = function(i, j, data) {
        // swap values i <-> j
        var vi = data[i];
        data[i] = data[j];
        data[j] = vi;
    };
    /**
   * Preprocess data, which can be an Array or DenseMatrix with nested Arrays and
   * Matrices. Replaces all nested Matrices with Arrays
   * @memberof DenseMatrix
   * @param {Array} data
   * @return {Array} data
   */ function preprocess(data) {
        for(var i = 0, ii = data.length; i < ii; i++){
            var elem = data[i];
            if ((0, $gs7TF.isArray)(elem)) data[i] = preprocess(elem);
            else if (elem && elem.isMatrix === true) data[i] = preprocess(elem.valueOf());
        }
        return data;
    }
    return DenseMatrix;
}, {
    isClass: true
});

});

parcelRegister("e6uiK", function(module, exports) {

$parcel$export(module.exports, "createDet", () => $02a6573fd0c87040$export$93f810683c54b005);

var $gs7TF = parcelRequire("gs7TF");

var $4mYv9 = parcelRequire("4mYv9");

var $aEppI = parcelRequire("aEppI");

var $4eE2e = parcelRequire("4eE2e");
var $02a6573fd0c87040$var$name = 'det';
var $02a6573fd0c87040$var$dependencies = [
    'typed',
    'matrix',
    'subtract',
    'multiply',
    'unaryMinus',
    'lup'
];
var $02a6573fd0c87040$export$93f810683c54b005 = /* #__PURE__ */ (0, $4eE2e.factory)($02a6573fd0c87040$var$name, $02a6573fd0c87040$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, multiply: multiply, unaryMinus: unaryMinus, lup: lup } = _ref;
    /**
   * Calculate the determinant of a matrix.
   *
   * Syntax:
   *
   *    math.det(x)
   *
   * Examples:
   *
   *    math.det([[1, 2], [3, 4]]) // returns -2
   *
   *    const A = [
   *      [-2, 2, 3],
   *      [-1, 1, 3],
   *      [2, 0, -1]
   *    ]
   *    math.det(A) // returns 6
   *
   * See also:
   *
   *    inv
   *
   * @param {Array | Matrix} x  A matrix
   * @return {number} The determinant of `x`
   */ return typed($02a6573fd0c87040$var$name, {
        any: function any(x) {
            return (0, $4mYv9.clone)(x);
        },
        'Array | Matrix': function det(x) {
            var size;
            if ((0, $gs7TF.isMatrix)(x)) size = x.size();
            else if (Array.isArray(x)) {
                x = matrix(x);
                size = x.size();
            } else // a scalar
            size = [];
            switch(size.length){
                case 0:
                    // scalar
                    return (0, $4mYv9.clone)(x);
                case 1:
                    // vector
                    if (size[0] === 1) return (0, $4mYv9.clone)(x.valueOf()[0]);
                    else throw new RangeError("Matrix must be square (size: " + (0, $aEppI.format)(size) + ')');
                case 2:
                    // two dimensional array
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _det(x.clone().valueOf(), rows, cols);
                    else throw new RangeError("Matrix must be square (size: " + (0, $aEppI.format)(size) + ')');
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $aEppI.format)(size) + ')');
            }
        }
    });
    /**
   * Calculate the determinant of a matrix
   * @param {Array[]} matrix  A square, two dimensional matrix
   * @param {number} rows     Number of rows of the matrix (zero-based)
   * @param {number} cols     Number of columns of the matrix (zero-based)
   * @returns {number} det
   * @private
   */ function _det(matrix, rows, cols) {
        if (rows === 1) // this is a 1 x 1 matrix
        return (0, $4mYv9.clone)(matrix[0][0]);
        else if (rows === 2) // this is a 2 x 2 matrix
        // the determinant of [a11,a12;a21,a22] is det = a11*a22-a21*a12
        return subtract(multiply(matrix[0][0], matrix[1][1]), multiply(matrix[1][0], matrix[0][1]));
        else {
            // Compute the LU decomposition
            var decomp = lup(matrix); // The determinant is the product of the diagonal entries of U (and those of L, but they are all 1)
            var det = decomp.U[0][0];
            for(var _i = 1; _i < rows; _i++)det = multiply(det, decomp.U[_i][_i]);
             // The determinant will be multiplied by 1 or -1 depending on the parity of the permutation matrix.
            // This can be determined by counting the cycles. This is roughly a linear time algorithm.
            var evenCycles = 0;
            var i = 0;
            var visited = [];
            while(true){
                while(visited[i])i++;
                if (i >= rows) break;
                var j = i;
                var cycleLen = 0;
                while(!visited[decomp.p[j]]){
                    visited[decomp.p[j]] = true;
                    j = decomp.p[j];
                    cycleLen++;
                }
                if (cycleLen % 2 === 0) evenCycles++;
            }
            return evenCycles % 2 === 0 ? det : unaryMinus(det);
        }
    }
});

});

parcelRegister("ejXGq", function(module, exports) {

$parcel$export(module.exports, "createDiag", () => $a6d122e58f927be3$export$743a950f2cd4bacc);

var $gs7TF = parcelRequire("gs7TF");

var $10UPF = parcelRequire("10UPF");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");
var $a6d122e58f927be3$var$name = 'diag';
var $a6d122e58f927be3$var$dependencies = [
    'typed',
    'matrix',
    'DenseMatrix',
    'SparseMatrix'
];
var $a6d122e58f927be3$export$743a950f2cd4bacc = /* #__PURE__ */ (0, $4eE2e.factory)($a6d122e58f927be3$var$name, $a6d122e58f927be3$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a diagonal matrix or retrieve the diagonal of a matrix
   *
   * When `x` is a vector, a matrix with vector `x` on the diagonal will be returned.
   * When `x` is a two dimensional matrix, the matrixes `k`th diagonal will be returned as vector.
   * When k is positive, the values are placed on the super diagonal.
   * When k is negative, the values are placed on the sub diagonal.
   *
   * Syntax:
   *
   *     math.diag(X)
   *     math.diag(X, format)
   *     math.diag(X, k)
   *     math.diag(X, k, format)
   *
   * Examples:
   *
   *     // create a diagonal matrix
   *     math.diag([1, 2, 3])      // returns [[1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *     math.diag([1, 2, 3], 1)   // returns [[0, 1, 0, 0], [0, 0, 2, 0], [0, 0, 0, 3]]
   *     math.diag([1, 2, 3], -1)  // returns [[0, 0, 0], [1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *
   *    // retrieve the diagonal from a matrix
   *    const a = [[1, 2, 3], [4, 5, 6], [7, 8, 9]]
   *    math.diag(a)   // returns [1, 5, 9]
   *
   * See also:
   *
   *     ones, zeros, identity
   *
   * @param {Matrix | Array} x          A two dimensional matrix or a vector
   * @param {number | BigNumber} [k=0]  The diagonal where the vector will be filled
   *                                    in or retrieved.
   * @param {string} [format='dense']   The matrix storage format.
   *
   * @returns {Matrix | Array} Diagonal matrix from input vector, or diagonal from input matrix.
   */ return typed($a6d122e58f927be3$var$name, {
        // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
        Array: function Array(x) {
            return _diag(x, 0, (0, $10UPF.arraySize)(x), null);
        },
        'Array, number': function ArrayNumber(x, k) {
            return _diag(x, k, (0, $10UPF.arraySize)(x), null);
        },
        'Array, BigNumber': function ArrayBigNumber(x, k) {
            return _diag(x, k.toNumber(), (0, $10UPF.arraySize)(x), null);
        },
        'Array, string': function ArrayString(x, format) {
            return _diag(x, 0, (0, $10UPF.arraySize)(x), format);
        },
        'Array, number, string': function ArrayNumberString(x, k, format) {
            return _diag(x, k, (0, $10UPF.arraySize)(x), format);
        },
        'Array, BigNumber, string': function ArrayBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), (0, $10UPF.arraySize)(x), format);
        },
        Matrix: function Matrix(x) {
            return _diag(x, 0, x.size(), x.storage());
        },
        'Matrix, number': function MatrixNumber(x, k) {
            return _diag(x, k, x.size(), x.storage());
        },
        'Matrix, BigNumber': function MatrixBigNumber(x, k) {
            return _diag(x, k.toNumber(), x.size(), x.storage());
        },
        'Matrix, string': function MatrixString(x, format) {
            return _diag(x, 0, x.size(), format);
        },
        'Matrix, number, string': function MatrixNumberString(x, k, format) {
            return _diag(x, k, x.size(), format);
        },
        'Matrix, BigNumber, string': function MatrixBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), x.size(), format);
        }
    });
    /**
   * Creeate diagonal matrix from a vector or vice versa
   * @param {Array | Matrix} x
   * @param {number} k
   * @param {string} format Storage format for matrix. If null,
   *                          an Array is returned
   * @returns {Array | Matrix}
   * @private
   */ function _diag(x, k, size, format) {
        if (!(0, $6egKm.isInteger)(k)) throw new TypeError('Second parameter in function diag must be an integer');
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // check dimensions
        switch(size.length){
            case 1:
                return _createDiagonalMatrix(x, k, format, size[0], kSub, kSuper);
            case 2:
                return _getDiagonal(x, k, format, size, kSub, kSuper);
        }
        throw new RangeError('Matrix for function diag must be 2 dimensional');
    }
    function _createDiagonalMatrix(x, k, format, l, kSub, kSuper) {
        // matrix size
        var ms = [
            l + kSub,
            l + kSuper
        ];
        if (format && format !== 'sparse' && format !== 'dense') throw new TypeError("Unknown matrix type ".concat(format, "\""));
         // create diagonal matrix
        var m = format === 'sparse' ? SparseMatrix.diagonal(ms, x, k) : DenseMatrix.diagonal(ms, x, k); // check we need to return a matrix
        return format !== null ? m : m.valueOf();
    }
    function _getDiagonal(x, k, format, s, kSub, kSuper) {
        // check x is a Matrix
        if ((0, $gs7TF.isMatrix)(x)) {
            // get diagonal matrix
            var dm = x.diagonal(k); // check we need to return a matrix
            if (format !== null) {
                // check we need to change matrix format
                if (format !== dm.storage()) return matrix(dm, format);
                return dm;
            }
            return dm.valueOf();
        } // vector size
        var n = Math.min(s[0] - kSub, s[1] - kSuper); // diagonal values
        var vector = []; // loop diagonal
        for(var i = 0; i < n; i++)vector[i] = x[i + kSub][i + kSuper];
         // check we need to return a matrix
        return format !== null ? matrix(vector) : vector;
    }
});

});

parcelRegister("3t0qc", function(module, exports) {

$parcel$export(module.exports, "createDiff", () => $2864683b689b9ec9$export$49df08fd121951b4);

var $4eE2e = parcelRequire("4eE2e");

var $6egKm = parcelRequire("6egKm");

var $gs7TF = parcelRequire("gs7TF");
var $2864683b689b9ec9$var$name = 'diff';
var $2864683b689b9ec9$var$dependencies = [
    'typed',
    'matrix',
    'subtract',
    'number'
];
var $2864683b689b9ec9$export$49df08fd121951b4 = /* #__PURE__ */ (0, $4eE2e.factory)($2864683b689b9ec9$var$name, $2864683b689b9ec9$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, number: number } = _ref;
    /**
   * Create a new matrix or array of the difference between elements of the given array
   * The optional dim parameter lets you specify the dimension to evaluate the difference of
   * If no dimension parameter is passed it is assumed as dimension 0
   *
   * Dimension is zero-based in javascript and one-based in the parser and can be a number or bignumber
   * Arrays must be 'rectangular' meaning arrays like [1, 2]
   * If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays
   *
   * Syntax:
   *
   *     math.diff(arr)
   *     math.diff(arr, dim)
   *
   * Examples:
   *
   *     const arr = [1, 2, 4, 7, 0]
   *     math.diff(arr) // returns [1, 2, 3, -7] (no dimension passed so 0 is assumed)
   *     math.diff(math.matrix(arr)) // returns math.matrix([1, 2, 3, -7])
   *
   *     const arr = [[1, 2, 3, 4, 5], [1, 2, 3, 4, 5], [9, 8, 7, 6, 4]]
   *     math.diff(arr) // returns [[0, 0, 0, 0, 0], [8, 6, 4, 2, -1]]
   *     math.diff(arr, 0) // returns [[0, 0, 0, 0, 0], [8, 6, 4, 2, -1]]
   *     math.diff(arr, 1) // returns [[1, 1, 1, 1], [1, 1, 1, 1], [-1, -1, -1, -2]]
   *     math.diff(arr, math.bignumber(1)) // returns [[1, 1, 1, 1], [1, 1, 1, 1], [-1, -1, -1, -2]]
   *
   *     math.diff(arr, 2) // throws RangeError as arr is 2 dimensional not 3
   *     math.diff(arr, -1) // throws RangeError as negative dimensions are not allowed
   *
   *     // These will all produce the same result
   *     math.diff([[1, 2], [3, 4]])
   *     math.diff([math.matrix([1, 2]), math.matrix([3, 4])])
   *     math.diff([[1, 2], math.matrix([3, 4])])
   *     math.diff([math.matrix([1, 2]), [3, 4]])
   *     // They do not produce the same result as  math.diff(math.matrix([[1, 2], [3, 4]])) as this returns a matrix
   *
   * See Also:
   *
   *      sum
   *      subtract
   *      partitionSelect
   *
   * @param {Array | Matrix} arr    An array or matrix
   * @param {number} dim            Dimension
   * @return {Array | Matrix}       Difference between array elements in given dimension
   */ return typed($2864683b689b9ec9$var$name, {
        'Array | Matrix': function ArrayMatrix(arr) {
            // No dimension specified => assume dimension 0
            if ((0, $gs7TF.isMatrix)(arr)) return matrix(_diff(arr.toArray()));
            else return _diff(arr);
        },
        'Array | Matrix, number': function ArrayMatrixNumber(arr, dim) {
            if (!(0, $6egKm.isInteger)(dim)) throw new RangeError('Dimension must be a whole number');
            if ((0, $gs7TF.isMatrix)(arr)) return matrix(_recursive(arr.toArray(), dim));
            else return _recursive(arr, dim);
        },
        'Array | Matrix, BigNumber': function ArrayMatrixBigNumber(arr, dim) {
            return this(arr, number(dim));
        }
    });
    /**
   * Recursively find the correct dimension in the array/matrix
   * Then Apply _diff to that dimension
   *
   * @param {Array} arr      The array
   * @param {number} dim     Dimension
   * @return {Array}         resulting array
   */ function _recursive(arr, dim) {
        if ((0, $gs7TF.isMatrix)(arr)) arr = arr.toArray(); // Makes sure arrays like [ matrix([0, 1]), matrix([1, 0]) ] are processed properly
        if (!Array.isArray(arr)) throw RangeError('Array/Matrix does not have that many dimensions');
        if (dim > 0) {
            var result = [];
            arr.forEach((element)=>{
                result.push(_recursive(element, dim - 1));
            });
            return result;
        } else if (dim === 0) return _diff(arr);
        else throw RangeError('Cannot have negative dimension');
    }
    /**
   * Difference between elements in the array
   *
   * @param {Array} arr      An array
   * @return {Array}         resulting array
   */ function _diff(arr) {
        var result = [];
        var size = arr.length;
        if (size < 2) return arr;
        for(var i = 1; i < size; i++)result.push(_ElementDiff(arr[i - 1], arr[i]));
        return result;
    }
    /**
   * Difference between 2 objects
   *
   * @param {Object} obj1    First object
   * @param {Object} obj2    Second object
   * @return {Array}         resulting array
   */ function _ElementDiff(obj1, obj2) {
        // Convert matrices to arrays
        if ((0, $gs7TF.isMatrix)(obj1)) obj1 = obj1.toArray();
        if ((0, $gs7TF.isMatrix)(obj2)) obj2 = obj2.toArray();
        var obj1IsArray = Array.isArray(obj1);
        var obj2IsArray = Array.isArray(obj2);
        if (obj1IsArray && obj2IsArray) return _ArrayDiff(obj1, obj2);
        if (!obj1IsArray && !obj2IsArray) return subtract(obj2, obj1); // Difference is (second - first) NOT (first - second)
        throw TypeError('Cannot calculate difference between 1 array and 1 non-array');
    }
    /**
   * Difference of elements in 2 arrays
   *
   * @param {Array} arr1     Array 1
   * @param {Array} arr2     Array 2
   * @return {Array}         resulting array
   */ function _ArrayDiff(arr1, arr2) {
        if (arr1.length !== arr2.length) throw RangeError('Not all sub-arrays have the same length');
        var result = [];
        var size = arr1.length;
        for(var i = 0; i < size; i++)result.push(_ElementDiff(arr1[i], arr2[i]));
        return result;
    }
});

});

parcelRegister("1aeKv", function(module, exports) {

$parcel$export(module.exports, "createDistance", () => $0d922a80aa0f20eb$export$23f482ad1a94fa7e);

var $gs7TF = parcelRequire("gs7TF");

var $4eE2e = parcelRequire("4eE2e");
var $0d922a80aa0f20eb$var$name = 'distance';
var $0d922a80aa0f20eb$var$dependencies = [
    'typed',
    'addScalar',
    'subtract',
    'divideScalar',
    'multiplyScalar',
    'unaryMinus',
    'sqrt',
    'abs'
];
var $0d922a80aa0f20eb$export$23f482ad1a94fa7e = /* #__PURE__ */ (0, $4eE2e.factory)($0d922a80aa0f20eb$var$name, $0d922a80aa0f20eb$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, subtract: subtract, multiplyScalar: multiplyScalar, divideScalar: divideScalar, unaryMinus: unaryMinus, sqrt: sqrt, abs: abs } = _ref;
    /**
    * Calculates:
    *    The eucledian distance between two points in N-dimensional spaces.
    *    Distance between point and a line in 2 and 3 dimensional spaces.
    *    Pairwise distance between a set of 2D or 3D points
    * NOTE:
    *    When substituting coefficients of a line(a, b and c), use ax + by + c = 0 instead of ax + by = c
    *    For parametric equation of a 3D line, x0, y0, z0, a, b, c are from: (x−x0, y−y0, z−z0) = t(a, b, c)
    *
    * Syntax:
    *    math.distance([x1, y1], [x2, y2])
    *-   math.distance({pointOneX: 4, pointOneY: 5}, {pointTwoX: 2, pointTwoY: 7})
    *    math.distance([x1, y1, z1], [x2, y2, z2])
    *    math.distance({pointOneX: 4, pointOneY: 5, pointOneZ: 8}, {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})
    *    math.distance([x1, y1, ... , N1], [x2, y2, ... , N2])
    *    math.distance([[A], [B], [C]...])
    *    math.distance([x1, y1], [LinePtX1, LinePtY1], [LinePtX2, LinePtY2])
    *    math.distance({pointX: 1, pointY: 4}, {lineOnePtX: 6, lineOnePtY: 3}, {lineTwoPtX: 2, lineTwoPtY: 8})
    *    math.distance([x1, y1, z1], [LinePtX1, LinePtY1, LinePtZ1], [LinePtX2, LinePtY2, LinePtZ2])
    *    math.distance({pointX: 1, pointY: 4, pointZ: 7}, {lineOnePtX: 6, lineOnePtY: 3, lineOnePtZ: 4}, {lineTwoPtX: 2, lineTwoPtY: 8, lineTwoPtZ: 5})
    *    math.distance([x1, y1], [xCoeffLine, yCoeffLine, constant])
    *    math.distance({pointX: 10, pointY: 10}, {xCoeffLine: 8, yCoeffLine: 1, constant: 3})
    *    math.distance([x1, y1, z1], [x0, y0, z0, a-tCoeff, b-tCoeff, c-tCoeff]) point and parametric equation of 3D line
    *    math.distance([x, y, z], [x0, y0, z0, a, b, c])
    *    math.distance({pointX: 2, pointY: 5, pointZ: 9}, {x0: 4, y0: 6, z0: 3, a: 4, b: 2, c: 0})
    *
    * Examples:
    *    math.distance([0,0], [4,4])                     // Returns 5.6569
    *    math.distance(
    *     {pointOneX: 0, pointOneY: 0},
    *     {pointTwoX: 10, pointTwoY: 10})                // Returns 14.142135623730951
    *    math.distance([1, 0, 1], [4, -2, 2])            // Returns 3.74166
    *    math.distance(
    *     {pointOneX: 4, pointOneY: 5, pointOneZ: 8},
    *     {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})    // Returns 3
    *    math.distance([1, 0, 1, 0], [0, -1, 0, -1])     // Returns 2
    *    math.distance([[1, 2], [1, 2], [1, 3]])         // Returns [0, 1, 1]
    *    math.distance([[1,2,4], [1,2,6], [8,1,3]])      // Returns [2, 7.14142842854285, 7.681145747868608]
    *    math.distance([10, 10], [8, 1, 3])              // Returns 11.535230316796387
    *    math.distance([10, 10], [2, 3], [-8, 0])        // Returns 8.759953130362847
    *    math.distance(
    *     {pointX: 1, pointY: 4},
    *     {lineOnePtX: 6, lineOnePtY: 3},
    *     {lineTwoPtX: 2, lineTwoPtY: 8})                // Returns 2.720549372624744
    *    math.distance([2, 3, 1], [1, 1, 2, 5, 0, 1])    // Returns 2.3204774044612857
    *    math.distance(
    *     {pointX: 2, pointY: 3, pointZ: 1},
    *     {x0: 1, y0: 1, z0: 2, a: 5, b: 0, c: 1}        // Returns 2.3204774044612857
    *
    * @param {Array | Matrix | Object} x    Co-ordinates of first point
    * @param {Array | Matrix | Object} y    Co-ordinates of second point
    * @return {Number | BigNumber} Returns the distance from two/three points
  */ return typed($0d922a80aa0f20eb$var$name, {
        'Array, Array, Array': function ArrayArrayArray(x, y, z) {
            // Point to Line 2D (x=Point, y=LinePoint1, z=LinePoint2)
            if (x.length === 2 && y.length === 2 && z.length === 2) {
                if (!_2d(x)) throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument');
                if (!_2d(y)) throw new TypeError('Array with 2 numbers or BigNumbers expected for second argument');
                if (!_2d(z)) throw new TypeError('Array with 2 numbers or BigNumbers expected for third argument');
                var m = divideScalar(subtract(z[1], z[0]), subtract(y[1], y[0]));
                var xCoeff = multiplyScalar(multiplyScalar(m, m), y[0]);
                var yCoeff = unaryMinus(multiplyScalar(m, y[0]));
                var constant = x[1];
                return _distancePointLine2D(x[0], x[1], xCoeff, yCoeff, constant);
            } else throw new TypeError('Invalid Arguments: Try again');
        },
        'Object, Object, Object': function ObjectObjectObject(x, y, z) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 2 && Object.keys(z).length === 2) {
                if (!_2d(x)) throw new TypeError('Values of pointX and pointY should be numbers or BigNumbers');
                if (!_2d(y)) throw new TypeError('Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers');
                if (!_2d(z)) throw new TypeError('Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers');
                if ('pointX' in x && 'pointY' in x && 'lineOnePtX' in y && 'lineOnePtY' in y && 'lineTwoPtX' in z && 'lineTwoPtY' in z) {
                    var m = divideScalar(subtract(z.lineTwoPtY, z.lineTwoPtX), subtract(y.lineOnePtY, y.lineOnePtX));
                    var xCoeff = multiplyScalar(multiplyScalar(m, m), y.lineOnePtX);
                    var yCoeff = unaryMinus(multiplyScalar(m, y.lineOnePtX));
                    var constant = x.pointX;
                    return _distancePointLine2D(x.pointX, x.pointY, xCoeff, yCoeff, constant);
                } else throw new TypeError('Key names do not match');
            } else throw new TypeError('Invalid Arguments: Try again');
        },
        'Array, Array': function ArrayArray(x, y) {
            // Point to Line 2D (x=[pointX, pointY], y=[x-coeff, y-coeff, const])
            if (x.length === 2 && y.length === 3) {
                if (!_2d(x)) throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument');
                if (!_3d(y)) throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument');
                return _distancePointLine2D(x[0], x[1], y[0], y[1], y[2]);
            } else if (x.length === 3 && y.length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument');
                if (!_parametricLine(y)) throw new TypeError('Array with 6 numbers or BigNumbers expected for second argument');
                return _distancePointLine3D(x[0], x[1], x[2], y[0], y[1], y[2], y[3], y[4], y[5]);
            } else if (x.length === y.length && x.length > 0) {
                // Point to Point N-dimensions
                if (!_containsOnlyNumbers(x)) throw new TypeError('All values of an array should be numbers or BigNumbers');
                if (!_containsOnlyNumbers(y)) throw new TypeError('All values of an array should be numbers or BigNumbers');
                return _euclideanDistance(x, y);
            } else throw new TypeError('Invalid Arguments: Try again');
        },
        'Object, Object': function ObjectObject(x, y) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 3) {
                if (!_2d(x)) throw new TypeError('Values of pointX and pointY should be numbers or BigNumbers');
                if (!_3d(y)) throw new TypeError('Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers');
                if ('pointX' in x && 'pointY' in x && 'xCoeffLine' in y && 'yCoeffLine' in y && 'constant' in y) return _distancePointLine2D(x.pointX, x.pointY, y.xCoeffLine, y.yCoeffLine, y.constant);
                else throw new TypeError('Key names do not match');
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError('Values of pointX, pointY and pointZ should be numbers or BigNumbers');
                if (!_parametricLine(y)) throw new TypeError('Values of x0, y0, z0, a, b and c should be numbers or BigNumbers');
                if ('pointX' in x && 'pointY' in x && 'x0' in y && 'y0' in y && 'z0' in y && 'a' in y && 'b' in y && 'c' in y) return _distancePointLine3D(x.pointX, x.pointY, x.pointZ, y.x0, y.y0, y.z0, y.a, y.b, y.c);
                else throw new TypeError('Key names do not match');
            } else if (Object.keys(x).length === 2 && Object.keys(y).length === 2) {
                // Point to Point 2D
                if (!_2d(x)) throw new TypeError('Values of pointOneX and pointOneY should be numbers or BigNumbers');
                if (!_2d(y)) throw new TypeError('Values of pointTwoX and pointTwoY should be numbers or BigNumbers');
                if ('pointOneX' in x && 'pointOneY' in x && 'pointTwoX' in y && 'pointTwoY' in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY
                ], [
                    y.pointTwoX,
                    y.pointTwoY
                ]);
                else throw new TypeError('Key names do not match');
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 3) {
                // Point to Point 3D
                if (!_3d(x)) throw new TypeError('Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers');
                if (!_3d(y)) throw new TypeError('Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers');
                if ('pointOneX' in x && 'pointOneY' in x && 'pointOneZ' in x && 'pointTwoX' in y && 'pointTwoY' in y && 'pointTwoZ' in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY,
                    x.pointOneZ
                ], [
                    y.pointTwoX,
                    y.pointTwoY,
                    y.pointTwoZ
                ]);
                else throw new TypeError('Key names do not match');
            } else throw new TypeError('Invalid Arguments: Try again');
        },
        Array: function Array1(arr) {
            if (!_pairwise(arr)) throw new TypeError('Incorrect array format entered for pairwise distance calculation');
            return _distancePairwise(arr);
        }
    });
    function _isNumber(a) {
        // distance supports numbers and bignumbers
        return typeof a === 'number' || (0, $gs7TF.isBigNumber)(a);
    }
    function _2d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]);
    }
    function _3d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]);
    }
    function _containsOnlyNumbers(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (!Array.isArray(a)) a = _objectToArray(a);
        return a.every(_isNumber);
    }
    function _parametricLine(a) {
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]) && _isNumber(a[3]) && _isNumber(a[4]) && _isNumber(a[5]);
    }
    function _objectToArray(o) {
        var keys = Object.keys(o);
        var a = [];
        for(var i = 0; i < keys.length; i++)a.push(o[keys[i]]);
        return a;
    }
    function _pairwise(a) {
        // checks for valid arguments passed to _distancePairwise(Array)
        if (a[0].length === 2 && _isNumber(a[0][0]) && _isNumber(a[0][1])) {
            if (a.some((aI)=>aI.length !== 2 || !_isNumber(aI[0]) || !_isNumber(aI[1]))) return false;
        } else if (a[0].length === 3 && _isNumber(a[0][0]) && _isNumber(a[0][1]) && _isNumber(a[0][2])) {
            if (a.some((aI)=>aI.length !== 3 || !_isNumber(aI[0]) || !_isNumber(aI[1]) || !_isNumber(aI[2]))) return false;
        } else return false;
        return true;
    }
    function _distancePointLine2D(x, y, a, b, c) {
        var num = abs(addScalar(addScalar(multiplyScalar(a, x), multiplyScalar(b, y)), c));
        var den = sqrt(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)));
        return divideScalar(num, den);
    }
    function _distancePointLine3D(x, y, z, x0, y0, z0, a, b, c) {
        var num = [
            subtract(multiplyScalar(subtract(y0, y), c), multiplyScalar(subtract(z0, z), b)),
            subtract(multiplyScalar(subtract(z0, z), a), multiplyScalar(subtract(x0, x), c)),
            subtract(multiplyScalar(subtract(x0, x), b), multiplyScalar(subtract(y0, y), a))
        ];
        num = sqrt(addScalar(addScalar(multiplyScalar(num[0], num[0]), multiplyScalar(num[1], num[1])), multiplyScalar(num[2], num[2])));
        var den = sqrt(addScalar(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)), multiplyScalar(c, c)));
        return divideScalar(num, den);
    }
    function _euclideanDistance(x, y) {
        var vectorSize = x.length;
        var result = 0;
        var diff = 0;
        for(var i = 0; i < vectorSize; i++){
            diff = subtract(x[i], y[i]);
            result = addScalar(multiplyScalar(diff, diff), result);
        }
        return sqrt(result);
    }
    function _distancePairwise(a) {
        var result = [];
        var pointA = [];
        var pointB = [];
        for(var i = 0; i < a.length - 1; i++)for(var j = i + 1; j < a.length; j++){
            if (a[0].length === 2) {
                pointA = [
                    a[i][0],
                    a[i][1]
                ];
                pointB = [
                    a[j][0],
                    a[j][1]
                ];
            } else if (a[0].length === 3) {
                pointA = [
                    a[i][0],
                    a[i][1],
                    a[i][2]
                ];
                pointB = [
                    a[j][0],
                    a[j][1],
                    a[j][2]
                ];
            }
            result.push(_euclideanDistance(pointA, pointB));
        }
        return result;
    }
});

});

parcelRegister("gz8Vv", function(module, exports) {

$parcel$export(module.exports, "createDivide", () => $c0f6d6d3c0ae5ab6$export$4df5e56bb6d14758);

var $4eE2e = parcelRequire("4eE2e");

var $4mYv9 = parcelRequire("4mYv9");

var $hXAgg = parcelRequire("hXAgg");

var $laEuG = parcelRequire("laEuG");
var $c0f6d6d3c0ae5ab6$var$name = 'divide';
var $c0f6d6d3c0ae5ab6$var$dependencies = [
    'typed',
    'matrix',
    'multiply',
    'equalScalar',
    'divideScalar',
    'inv'
];
var $c0f6d6d3c0ae5ab6$export$4df5e56bb6d14758 = /* #__PURE__ */ (0, $4eE2e.factory)($c0f6d6d3c0ae5ab6$var$name, $c0f6d6d3c0ae5ab6$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, multiply: multiply, equalScalar: equalScalar, divideScalar: divideScalar, inv: inv } = _ref;
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Divide two values, `x / y`.
   * To divide matrices, `x` is multiplied with the inverse of `y`: `x * inv(y)`.
   *
   * Syntax:
   *
   *    math.divide(x, y)
   *
   * Examples:
   *
   *    math.divide(2, 3)            // returns number 0.6666666666666666
   *
   *    const a = math.complex(5, 14)
   *    const b = math.complex(4, 1)
   *    math.divide(a, b)            // returns Complex 2 + 3i
   *
   *    const c = [[7, -6], [13, -4]]
   *    const d = [[1, 2], [4, 3]]
   *    math.divide(c, d)            // returns Array [[-9, 4], [-11, 6]]
   *
   *    const e = math.unit('18 km')
   *    math.divide(e, 4.5)          // returns Unit 4 km
   *
   * See also:
   *
   *    multiply
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x   Numerator
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} y          Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                      Quotient, `x / y`
   */ return typed('divide', (0, $4mYv9.extend)({
        // we extend the signatures of divideScalar with signatures dealing with matrices
        'Array | Matrix, Array | Matrix': function ArrayMatrixArrayMatrix(x, y) {
            // TODO: implement matrix right division using pseudo inverse
            // https://www.mathworks.nl/help/matlab/ref/mrdivide.html
            // https://www.gnu.org/software/octave/doc/interpreter/Arithmetic-Ops.html
            // https://stackoverflow.com/questions/12263932/how-does-gnu-octave-matrix-division-work-getting-unexpected-behaviour
            return multiply(x, inv(y));
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, divideScalar, false);
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm11(x, y, divideScalar, false);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, divideScalar, false).valueOf();
        },
        'any, Array | Matrix': function anyArrayMatrix(x, y) {
            return multiply(x, inv(y));
        }
    }, divideScalar.signatures));
});

});

parcelRegister("aWbIO", function(module, exports) {

$parcel$export(module.exports, "createDivideScalar", () => $7f6869dff6766b00$export$399593177816ff82);

var $4eE2e = parcelRequire("4eE2e");

var $gs7TF = parcelRequire("gs7TF");
var $7f6869dff6766b00$var$name = 'divideScalar';
var $7f6869dff6766b00$var$dependencies = [
    'typed',
    'numeric'
];
var $7f6869dff6766b00$export$399593177816ff82 = /* #__PURE__ */ (0, $4eE2e.factory)($7f6869dff6766b00$var$name, $7f6869dff6766b00$var$dependencies, (_ref)=>{
    var { typed: typed, numeric: numeric } = _ref;
    /**
   * Divide two scalar values, `x / y`.
   * This function is meant for internal use: it is used by the public functions
   * `divide` and `inv`.
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   Numerator
   * @param  {number | BigNumber | Fraction | Complex} y          Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit}     Quotient, `x / y`
   * @private
   */ return typed($7f6869dff6766b00$var$name, {
        'number, number': function numberNumber(x, y) {
            return x / y;
        },
        'Complex, Complex': function ComplexComplex(x, y) {
            return x.div(y);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.div(y);
        },
        'Fraction, Fraction': function FractionFraction(x, y) {
            return x.div(y);
        },
        'Unit, number | Fraction | BigNumber': function UnitNumberFractionBigNumber(x, y) {
            var res = x.clone(); // TODO: move the divide function to Unit.js, it uses internals of Unit
            var one = numeric(1, (0, $gs7TF.typeOf)(y));
            res.value = this(res.value === null ? res._normalize(one) : res.value, y);
            return res;
        },
        'number | Fraction | BigNumber, Unit': function numberFractionBigNumberUnit(x, y) {
            var res = y.clone();
            res = res.pow(-1); // TODO: move the divide function to Unit.js, it uses internals of Unit
            var one = numeric(1, (0, $gs7TF.typeOf)(x));
            res.value = this(x, y.value === null ? y._normalize(one) : y.value);
            return res;
        },
        'Unit, Unit': function UnitUnit(x, y) {
            return x.divide(y);
        }
    });
});

});

parcelRegister("bNcnf", function(module, exports) {

$parcel$export(module.exports, "createDot", () => $895dde872b7af97b$export$3dc59ff00984d687);

var $4eE2e = parcelRequire("4eE2e");

var $gs7TF = parcelRequire("gs7TF");
var $895dde872b7af97b$var$name = 'dot';
var $895dde872b7af97b$var$dependencies = [
    'typed',
    'addScalar',
    'multiplyScalar',
    'conj',
    'size'
];
var $895dde872b7af97b$export$3dc59ff00984d687 = /* #__PURE__ */ (0, $4eE2e.factory)($895dde872b7af97b$var$name, $895dde872b7af97b$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, multiplyScalar: multiplyScalar, conj: conj, size: size } = _ref;
    /**
   * Calculate the dot product of two vectors. The dot product of
   * `A = [a1, a2, ..., an]` and `B = [b1, b2, ..., bn]` is defined as:
   *
   *    dot(A, B) = conj(a1) * b1 + conj(a2) * b2 + ... + conj(an) * bn
   *
   * Syntax:
   *
   *    math.dot(x, y)
   *
   * Examples:
   *
   *    math.dot([2, 4, 1], [2, 2, 3])       // returns number 15
   *    math.multiply([2, 4, 1], [2, 2, 3])  // returns number 15
   *
   * See also:
   *
   *    multiply, cross
   *
   * @param  {Array | Matrix} x     First vector
   * @param  {Array | Matrix} y     Second vector
   * @return {number}               Returns the dot product of `x` and `y`
   */ return typed($895dde872b7af97b$var$name, {
        'Array | DenseMatrix, Array | DenseMatrix': _denseDot,
        'SparseMatrix, SparseMatrix': _sparseDot
    });
    function _validateDim(x, y) {
        var xSize = _size(x);
        var ySize = _size(y);
        var xLen, yLen;
        if (xSize.length === 1) xLen = xSize[0];
        else if (xSize.length === 2 && xSize[1] === 1) xLen = xSize[0];
        else throw new RangeError('Expected a column vector, instead got a matrix of size (' + xSize.join(', ') + ')');
        if (ySize.length === 1) yLen = ySize[0];
        else if (ySize.length === 2 && ySize[1] === 1) yLen = ySize[0];
        else throw new RangeError('Expected a column vector, instead got a matrix of size (' + ySize.join(', ') + ')');
        if (xLen !== yLen) throw new RangeError('Vectors must have equal length (' + xLen + ' != ' + yLen + ')');
        if (xLen === 0) throw new RangeError('Cannot calculate the dot product of empty vectors');
        return xLen;
    }
    function _denseDot(a, b) {
        var N = _validateDim(a, b);
        var adata = (0, $gs7TF.isMatrix)(a) ? a._data : a;
        var adt = (0, $gs7TF.isMatrix)(a) ? a._datatype : undefined;
        var bdata = (0, $gs7TF.isMatrix)(b) ? b._data : b;
        var bdt = (0, $gs7TF.isMatrix)(b) ? b._datatype : undefined; // are these 2-dimensional column vectors? (as opposed to 1-dimensional vectors)
        var aIsColumn = _size(a).length === 2;
        var bIsColumn = _size(b).length === 2;
        var add = addScalar;
        var mul = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string') {
            var dt = adt; // find signatures that matches (dt, dt)
            add = typed.find(addScalar, [
                dt,
                dt
            ]);
            mul = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // both vectors 1-dimensional
        if (!aIsColumn && !bIsColumn) {
            var c = mul(conj(adata[0]), bdata[0]);
            for(var i = 1; i < N; i++)c = add(c, mul(conj(adata[i]), bdata[i]));
            return c;
        } // a is 1-dim, b is column
        if (!aIsColumn && bIsColumn) {
            var _c = mul(conj(adata[0]), bdata[0][0]);
            for(var _i = 1; _i < N; _i++)_c = add(_c, mul(conj(adata[_i]), bdata[_i][0]));
            return _c;
        } // a is column, b is 1-dim
        if (aIsColumn && !bIsColumn) {
            var _c2 = mul(conj(adata[0][0]), bdata[0]);
            for(var _i2 = 1; _i2 < N; _i2++)_c2 = add(_c2, mul(conj(adata[_i2][0]), bdata[_i2]));
            return _c2;
        } // both vectors are column
        if (aIsColumn && bIsColumn) {
            var _c3 = mul(conj(adata[0][0]), bdata[0][0]);
            for(var _i3 = 1; _i3 < N; _i3++)_c3 = add(_c3, mul(conj(adata[_i3][0]), bdata[_i3][0]));
            return _c3;
        }
    }
    function _sparseDot(x, y) {
        _validateDim(x, y);
        var xindex = x._index;
        var xvalues = x._values;
        var yindex = y._index;
        var yvalues = y._values; // TODO optimize add & mul using datatype
        var c = 0;
        var add = addScalar;
        var mul = multiplyScalar;
        var i = 0;
        var j = 0;
        while(i < xindex.length && j < yindex.length){
            var I = xindex[i];
            var J = yindex[j];
            if (I < J) {
                i++;
                continue;
            }
            if (I > J) {
                j++;
                continue;
            }
            if (I === J) {
                c = add(c, mul(xvalues[i], yvalues[j]));
                i++;
                j++;
            }
        }
        return c;
    } // TODO remove this once #1771 is fixed
    function _size(x) {
        return (0, $gs7TF.isMatrix)(x) ? x.size() : size(x);
    }
});

});

parcelRegister("euY4t", function(module, exports) {

$parcel$export(module.exports, "createDotDivide", () => $a8e276ea20a38ce1$export$e4930a420a373a24);

var $4eE2e = parcelRequire("4eE2e");

var $5IUkw = parcelRequire("5IUkw");

var $6MKpt = parcelRequire("6MKpt");

var $ai5Sw = parcelRequire("ai5Sw");

var $hXAgg = parcelRequire("hXAgg");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");
var $a8e276ea20a38ce1$var$name = 'dotDivide';
var $a8e276ea20a38ce1$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'divideScalar',
    'DenseMatrix'
];
var $a8e276ea20a38ce1$export$e4930a420a373a24 = /* #__PURE__ */ (0, $4eE2e.factory)($a8e276ea20a38ce1$var$name, $a8e276ea20a38ce1$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, divideScalar: divideScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm02 = (0, $5IUkw.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $ai5Sw.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Divide two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotDivide(x, y)
   *
   * Examples:
   *
   *    math.dotDivide(2, 4)   // returns 0.5
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotDivide(a, b)   // returns [[3, 2.5], [1.2, 0.5]]
   *    math.divide(a, b)      // returns [[1.75, 0.75], [-1.75, 2.25]]
   *
   * See also:
   *
   *    divide, multiply, dotMultiply
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Numerator
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Quotient, `x ./ y`
   */ return typed($a8e276ea20a38ce1$var$name, {
        'any, any': divideScalar,
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, divideScalar, false);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, divideScalar, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, divideScalar, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, divideScalar);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm11(x, y, divideScalar, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, divideScalar, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, divideScalar, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, divideScalar, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, divideScalar, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, divideScalar, true).valueOf();
        }
    });
});

});

parcelRegister("ibm2n", function(module, exports) {

$parcel$export(module.exports, "createDotMultiply", () => $d3ca5939ac603166$export$a4620e84460f321e);

var $4eE2e = parcelRequire("4eE2e");

var $5IUkw = parcelRequire("5IUkw");

var $ejwmL = parcelRequire("ejwmL");

var $hXAgg = parcelRequire("hXAgg");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");
var $d3ca5939ac603166$var$name = 'dotMultiply';
var $d3ca5939ac603166$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'multiplyScalar'
];
var $d3ca5939ac603166$export$a4620e84460f321e = /* #__PURE__ */ (0, $4eE2e.factory)($d3ca5939ac603166$var$name, $d3ca5939ac603166$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, multiplyScalar: multiplyScalar } = _ref;
    var algorithm02 = (0, $5IUkw.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm09 = (0, $ejwmL.createAlgorithm09)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Multiply two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotMultiply(x, y)
   *
   * Examples:
   *
   *    math.dotMultiply(2, 4) // returns 8
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotMultiply(a, b) // returns [[27, 10], [30, 2]]
   *    math.multiply(a, b)    // returns [[52, 28], [23, 14]]
   *
   * See also:
   *
   *    multiply, divide, dotDivide
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Left hand value
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Right hand value
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Multiplication of `x` and `y`
   */ return typed($d3ca5939ac603166$var$name, {
        'any, any': multiplyScalar,
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm09(x, y, multiplyScalar, false);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, multiplyScalar, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, multiplyScalar, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, multiplyScalar);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm11(x, y, multiplyScalar, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, multiplyScalar, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm11(y, x, multiplyScalar, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, multiplyScalar, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
        }
    });
});

});

parcelRegister("dvf0V", function(module, exports) {

$parcel$export(module.exports, "createDotPow", () => $9d49d10e2c1c1fa9$export$734b49568d8effd6);

var $4eE2e = parcelRequire("4eE2e");

var $6MKpt = parcelRequire("6MKpt");

var $ai5Sw = parcelRequire("ai5Sw");

var $hXAgg = parcelRequire("hXAgg");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");
var $9d49d10e2c1c1fa9$var$name = 'dotPow';
var $9d49d10e2c1c1fa9$var$dependencies = [
    'typed',
    'equalScalar',
    'matrix',
    'pow',
    'DenseMatrix'
];
var $9d49d10e2c1c1fa9$export$734b49568d8effd6 = /* #__PURE__ */ (0, $4eE2e.factory)($9d49d10e2c1c1fa9$var$name, $9d49d10e2c1c1fa9$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar, matrix: matrix, pow: pow, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $ai5Sw.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculates the power of x to y element wise.
   *
   * Syntax:
   *
   *    math.dotPow(x, y)
   *
   * Examples:
   *
   *    math.dotPow(2, 3)            // returns number 8
   *
   *    const a = [[1, 2], [4, 3]]
   *    math.dotPow(a, 2)            // returns Array [[1, 4], [16, 9]]
   *    math.pow(a, 2)               // returns Array [[9, 8], [16, 17]]
   *
   * See also:
   *
   *    pow, sqrt, multiply
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y  The exponent
   * @return {number | BigNumber | Complex | Unit | Array | Matrix}                     The value of `x` to the power `y`
   */ return typed($9d49d10e2c1c1fa9$var$name, {
        'any, any': pow,
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, pow, false);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, pow, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, pow, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, pow);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});

});

parcelRegister("iaukn", function(module, exports) {

$parcel$export(module.exports, "createTrue", () => $d3a0afa00784c0a1$export$e13d32722e2756df);
$parcel$export(module.exports, "createFalse", () => $d3a0afa00784c0a1$export$cb94e3a54c9e99b);
$parcel$export(module.exports, "createNull", () => $d3a0afa00784c0a1$export$d07c6114481fc17b);
$parcel$export(module.exports, "createInfinity", () => $d3a0afa00784c0a1$export$df1313fb6eb44f05);
$parcel$export(module.exports, "createNaN", () => $d3a0afa00784c0a1$export$fbdaee11df58c3cc);
$parcel$export(module.exports, "createPi", () => $d3a0afa00784c0a1$export$2dbe69c48ac7f49c);
$parcel$export(module.exports, "createTau", () => $d3a0afa00784c0a1$export$d5973a6d5d95d479);
$parcel$export(module.exports, "createE", () => $d3a0afa00784c0a1$export$6dca51ff4d4b257f);
$parcel$export(module.exports, "createPhi", () => $d3a0afa00784c0a1$export$f131830080647892);
$parcel$export(module.exports, "createLN2", () => $d3a0afa00784c0a1$export$ab67ddb9e8290a2c);
$parcel$export(module.exports, "createLN10", () => $d3a0afa00784c0a1$export$5365e90aad1235b4);
$parcel$export(module.exports, "createLOG2E", () => $d3a0afa00784c0a1$export$b57f4b4cfc057c2d);
$parcel$export(module.exports, "createLOG10E", () => $d3a0afa00784c0a1$export$57f654bce66ec8ce);
$parcel$export(module.exports, "createSQRT1_2", () => $d3a0afa00784c0a1$export$e6df2cb14f3e8316);
$parcel$export(module.exports, "createSQRT2", () => $d3a0afa00784c0a1$export$f7a593fe98eba575);
$parcel$export(module.exports, "createI", () => $d3a0afa00784c0a1$export$7122d2461a6f9b76);
$parcel$export(module.exports, "createVersion", () => $d3a0afa00784c0a1$export$72a91d9326d5a672);

var $4eE2e = parcelRequire("4eE2e");

var $4YpQH = parcelRequire("4YpQH");

var $cUmcc = parcelRequire("cUmcc");

var $aslLP = parcelRequire("aslLP");
var $d3a0afa00784c0a1$export$e13d32722e2756df = /* #__PURE__ */ (0, $4eE2e.factory)('true', [], ()=>true);
var $d3a0afa00784c0a1$export$cb94e3a54c9e99b = /* #__PURE__ */ (0, $4eE2e.factory)('false', [], ()=>false);
var $d3a0afa00784c0a1$export$d07c6114481fc17b = /* #__PURE__ */ (0, $4eE2e.factory)('null', [], ()=>null);
var $d3a0afa00784c0a1$export$df1313fb6eb44f05 = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('Infinity', [
    'config',
    '?BigNumber'
], (_ref)=>{
    var { config: config, BigNumber: BigNumber } = _ref;
    return config.number === 'BigNumber' ? new BigNumber(Infinity) : Infinity;
});
var $d3a0afa00784c0a1$export$fbdaee11df58c3cc = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('NaN', [
    'config',
    '?BigNumber'
], (_ref2)=>{
    var { config: config, BigNumber: BigNumber } = _ref2;
    return config.number === 'BigNumber' ? new BigNumber(NaN) : NaN;
});
var $d3a0afa00784c0a1$export$2dbe69c48ac7f49c = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('pi', [
    'config',
    '?BigNumber'
], (_ref3)=>{
    var { config: config, BigNumber: BigNumber } = _ref3;
    return config.number === 'BigNumber' ? (0, $cUmcc.createBigNumberPi)(BigNumber) : (0, $aslLP.pi);
});
var $d3a0afa00784c0a1$export$d5973a6d5d95d479 = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('tau', [
    'config',
    '?BigNumber'
], (_ref4)=>{
    var { config: config, BigNumber: BigNumber } = _ref4;
    return config.number === 'BigNumber' ? (0, $cUmcc.createBigNumberTau)(BigNumber) : (0, $aslLP.tau);
});
var $d3a0afa00784c0a1$export$6dca51ff4d4b257f = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('e', [
    'config',
    '?BigNumber'
], (_ref5)=>{
    var { config: config, BigNumber: BigNumber } = _ref5;
    return config.number === 'BigNumber' ? (0, $cUmcc.createBigNumberE)(BigNumber) : (0, $aslLP.e);
}); // golden ratio, (1+sqrt(5))/2
var $d3a0afa00784c0a1$export$f131830080647892 = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('phi', [
    'config',
    '?BigNumber'
], (_ref6)=>{
    var { config: config, BigNumber: BigNumber } = _ref6;
    return config.number === 'BigNumber' ? (0, $cUmcc.createBigNumberPhi)(BigNumber) : (0, $aslLP.phi);
});
var $d3a0afa00784c0a1$export$ab67ddb9e8290a2c = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('LN2', [
    'config',
    '?BigNumber'
], (_ref7)=>{
    var { config: config, BigNumber: BigNumber } = _ref7;
    return config.number === 'BigNumber' ? new BigNumber(2).ln() : Math.LN2;
});
var $d3a0afa00784c0a1$export$5365e90aad1235b4 = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('LN10', [
    'config',
    '?BigNumber'
], (_ref8)=>{
    var { config: config, BigNumber: BigNumber } = _ref8;
    return config.number === 'BigNumber' ? new BigNumber(10).ln() : Math.LN10;
});
var $d3a0afa00784c0a1$export$b57f4b4cfc057c2d = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('LOG2E', [
    'config',
    '?BigNumber'
], (_ref9)=>{
    var { config: config, BigNumber: BigNumber } = _ref9;
    return config.number === 'BigNumber' ? new BigNumber(1).div(new BigNumber(2).ln()) : Math.LOG2E;
});
var $d3a0afa00784c0a1$export$57f654bce66ec8ce = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('LOG10E', [
    'config',
    '?BigNumber'
], (_ref10)=>{
    var { config: config, BigNumber: BigNumber } = _ref10;
    return config.number === 'BigNumber' ? new BigNumber(1).div(new BigNumber(10).ln()) : Math.LOG10E;
});
var $d3a0afa00784c0a1$export$e6df2cb14f3e8316 = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('SQRT1_2', [
    'config',
    '?BigNumber'
], (_ref11)=>{
    var { config: config, BigNumber: BigNumber } = _ref11;
    return config.number === 'BigNumber' ? new BigNumber('0.5').sqrt() : Math.SQRT1_2;
});
var $d3a0afa00784c0a1$export$f7a593fe98eba575 = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('SQRT2', [
    'config',
    '?BigNumber'
], (_ref12)=>{
    var { config: config, BigNumber: BigNumber } = _ref12;
    return config.number === 'BigNumber' ? new BigNumber(2).sqrt() : Math.SQRT2;
});
var $d3a0afa00784c0a1$export$7122d2461a6f9b76 = /* #__PURE__ */ $d3a0afa00784c0a1$var$recreateFactory('i', [
    'Complex'
], (_ref13)=>{
    var { Complex: Complex } = _ref13;
    return Complex.I;
}); // for backward compatibility with v5
var $d3a0afa00784c0a1$export$5aab935c59859292 = /* #__PURE__ */ (0, $4eE2e.factory)('PI', [
    'pi'
], (_ref14)=>{
    var { pi: pi } = _ref14;
    return pi;
});
var $d3a0afa00784c0a1$export$56c791a240a1c942 = /* #__PURE__ */ (0, $4eE2e.factory)('E', [
    'e'
], (_ref15)=>{
    var { e: e } = _ref15;
    return e;
});
var $d3a0afa00784c0a1$export$72a91d9326d5a672 = /* #__PURE__ */ (0, $4eE2e.factory)('version', [], ()=>(0, $4YpQH.version)); // helper function to create a factory with a flag recreateOnConfigChange
// idea: allow passing optional properties to be attached to the factory function as 4th argument?
function $d3a0afa00784c0a1$var$recreateFactory(name, dependencies, create) {
    return (0, $4eE2e.factory)(name, dependencies, create, {
        recreateOnConfigChange: true
    });
}

});
parcelRegister("4YpQH", function(module, exports) {

$parcel$export(module.exports, "version", () => $39f0d117556b7b8c$export$83d89fbfd8236492);
var $39f0d117556b7b8c$export$83d89fbfd8236492 = '9.4.4'; // Note: This file is automatically generated when building math.js.
 // Changes made in this file will be overwritten.

});

parcelRegister("cUmcc", function(module, exports) {

$parcel$export(module.exports, "createBigNumberE", () => $965beea1ab88771d$export$737cba75de6dfb68);
$parcel$export(module.exports, "createBigNumberPhi", () => $965beea1ab88771d$export$c7e121b24930c156);
$parcel$export(module.exports, "createBigNumberPi", () => $965beea1ab88771d$export$d0a8190d955e3c5b);
$parcel$export(module.exports, "createBigNumberTau", () => $965beea1ab88771d$export$83b6ee92a84f32c6);

var $jHpUf = parcelRequire("jHpUf");
var $965beea1ab88771d$export$737cba75de6dfb68 = (0, $jHpUf.memoize)(function(BigNumber) {
    return new BigNumber(1).exp();
}, {
    hasher: $965beea1ab88771d$var$hasher
});
var $965beea1ab88771d$export$c7e121b24930c156 = (0, $jHpUf.memoize)(function(BigNumber) {
    return new BigNumber(1).plus(new BigNumber(5).sqrt()).div(2);
}, {
    hasher: $965beea1ab88771d$var$hasher
});
var $965beea1ab88771d$export$d0a8190d955e3c5b = (0, $jHpUf.memoize)(function(BigNumber) {
    return BigNumber.acos(-1);
}, {
    hasher: $965beea1ab88771d$var$hasher
});
var $965beea1ab88771d$export$83b6ee92a84f32c6 = (0, $jHpUf.memoize)(function(BigNumber) {
    return $965beea1ab88771d$export$d0a8190d955e3c5b(BigNumber).times(2);
}, {
    hasher: $965beea1ab88771d$var$hasher
});
/**
 * Create a hash for a BigNumber constructor function. The created has is
 * the configured precision
 * @param {Array} args         Supposed to contain a single entry with
 *                             a BigNumber constructor
 * @return {number} precision
 * @private
 */ function $965beea1ab88771d$var$hasher(args) {
    return args[0].precision;
}

});
parcelRegister("jHpUf", function(module, exports) {

$parcel$export(module.exports, "memoize", () => $e57620ec2cea878d$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "maxArgumentCount", () => $e57620ec2cea878d$export$6c00fba23f8c91a7);
// function utils

var $d7tYS = parcelRequire("d7tYS");
function $e57620ec2cea878d$export$fc10aeed3a532e2a(fn) {
    var { hasher: hasher, limit: limit } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    limit = limit == null ? Number.POSITIVE_INFINITY : limit;
    hasher = hasher == null ? JSON.stringify : hasher;
    return function memoize() {
        if (typeof memoize.cache !== 'object') memoize.cache = {
            values: new Map(),
            lru: (0, $d7tYS.lruQueue)(limit || Number.POSITIVE_INFINITY)
        };
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        var hash = hasher(args);
        if (memoize.cache.values.has(hash)) {
            memoize.cache.lru.hit(hash);
            return memoize.cache.values.get(hash);
        }
        var newVal = fn.apply(fn, args);
        memoize.cache.values.set(hash, newVal);
        memoize.cache.values.delete(memoize.cache.lru.hit(hash));
        return newVal;
    };
}
function $e57620ec2cea878d$export$22992fec26710d5a(fn, isEqual) {
    var memoize = function memoize() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        for(var c = 0; c < memoize.cache.length; c++){
            var cached = memoize.cache[c];
            if (isEqual(args, cached.args)) // TODO: move this cache entry to the top so recently used entries move up?
            return cached.res;
        }
        var res = fn.apply(fn, args);
        memoize.cache.unshift({
            args: args,
            res: res
        });
        return res;
    };
    memoize.cache = [];
    return memoize;
}
function $e57620ec2cea878d$export$6c00fba23f8c91a7(fn) {
    return Object.keys(fn.signatures || {}).reduce(function(args, signature) {
        var count = (signature.match(/,/g) || []).length + 1;
        return Math.max(args, count);
    }, -1);
}

});
parcelRegister("d7tYS", function(module, exports) {

$parcel$export(module.exports, "lruQueue", () => $98d32f615ead3eb3$export$6080faceac22b73a);
// (c) 2018, Mariusz Nowak
// SPDX-License-Identifier: ISC
// Derived from https://github.com/medikoo/lru-queue
function $98d32f615ead3eb3$export$6080faceac22b73a(limit) {
    var size = 0;
    var base = 1;
    var queue = Object.create(null);
    var map = Object.create(null);
    var index = 0;
    var del = function del(id) {
        var oldIndex = map[id];
        if (!oldIndex) return;
        delete queue[oldIndex];
        delete map[id];
        --size;
        if (base !== oldIndex) return;
        if (!size) {
            index = 0;
            base = 1;
            return;
        }
        while(!hasOwnProperty.call(queue, ++base))continue;
    };
    limit = Math.abs(limit);
    return {
        hit: function hit(id) {
            var oldIndex = map[id];
            var nuIndex = ++index;
            queue[nuIndex] = id;
            map[id] = nuIndex;
            if (!oldIndex) {
                ++size;
                if (size <= limit) return undefined;
                id = queue[base];
                del(id);
                return id;
            }
            delete queue[oldIndex];
            if (base !== oldIndex) return undefined;
            while(!hasOwnProperty.call(queue, ++base))continue;
            return undefined;
        },
        delete: del,
        clear: function clear() {
            size = index = 0;
            base = 1;
            queue = Object.create(null);
            map = Object.create(null);
        }
    };
}

});



parcelRegister("aslLP", function(module, exports) {

$parcel$export(module.exports, "pi", () => $79cd680aaf1fa224$export$18c7bea995a110f);
$parcel$export(module.exports, "tau", () => $79cd680aaf1fa224$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "e", () => $79cd680aaf1fa224$export$f1e1789686576879);
$parcel$export(module.exports, "phi", () => $79cd680aaf1fa224$export$324943737027944a);
var $79cd680aaf1fa224$export$18c7bea995a110f = Math.PI;
var $79cd680aaf1fa224$export$a4b4b4d4d776fe92 = 2 * Math.PI;
var $79cd680aaf1fa224$export$f1e1789686576879 = Math.E;
var $79cd680aaf1fa224$export$324943737027944a = 1.6180339887498948; // eslint-disable-line no-loss-of-precision

});


parcelRegister("7iTF4", function(module, exports) {

$parcel$export(module.exports, "createEigs", () => $55156406ba9d8ef7$export$ba9e077a2df092d7);

var $4eE2e = parcelRequire("4eE2e");

var $aEppI = parcelRequire("aEppI");

var $ekHr5 = parcelRequire("ekHr5");

var $4Kg5X = parcelRequire("4Kg5X");

var $gs7TF = parcelRequire("gs7TF");
var $55156406ba9d8ef7$var$name = 'eigs'; // The absolute state of math.js's dependency system:
var $55156406ba9d8ef7$var$dependencies = [
    'config',
    'typed',
    'matrix',
    'addScalar',
    'equal',
    'subtract',
    'abs',
    'atan',
    'cos',
    'sin',
    'multiplyScalar',
    'divideScalar',
    'inv',
    'bignumber',
    'multiply',
    'add',
    'larger',
    'column',
    'flatten',
    'number',
    'complex',
    'sqrt',
    'diag',
    'qr',
    'usolve',
    'usolveAll',
    'im',
    're',
    'smaller',
    'matrixFromColumns',
    'dot'
];
var $55156406ba9d8ef7$export$ba9e077a2df092d7 = /* #__PURE__ */ (0, $4eE2e.factory)($55156406ba9d8ef7$var$name, $55156406ba9d8ef7$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, matrix: matrix, addScalar: addScalar, subtract: subtract, equal: equal, abs: abs, atan: atan, cos: cos, sin: sin, multiplyScalar: multiplyScalar, divideScalar: divideScalar, inv: inv, bignumber: bignumber, multiply: multiply, add: add, larger: larger, column: column, flatten: flatten, number: number, complex: complex, sqrt: sqrt, diag: diag, qr: qr, usolve: usolve, usolveAll: usolveAll, im: im, re: re, smaller: smaller, matrixFromColumns: matrixFromColumns, dot: dot } = _ref;
    var doRealSymetric = (0, $4Kg5X.createRealSymmetric)({
        config: config,
        addScalar: addScalar,
        subtract: subtract,
        column: column,
        flatten: flatten,
        equal: equal,
        abs: abs,
        atan: atan,
        cos: cos,
        sin: sin,
        multiplyScalar: multiplyScalar,
        inv: inv,
        bignumber: bignumber,
        complex: complex,
        multiply: multiply,
        add: add
    });
    var doComplexEigs = (0, $ekHr5.createComplexEigs)({
        config: config,
        addScalar: addScalar,
        subtract: subtract,
        multiply: multiply,
        multiplyScalar: multiplyScalar,
        flatten: flatten,
        divideScalar: divideScalar,
        sqrt: sqrt,
        abs: abs,
        bignumber: bignumber,
        diag: diag,
        qr: qr,
        inv: inv,
        usolve: usolve,
        usolveAll: usolveAll,
        equal: equal,
        complex: complex,
        larger: larger,
        smaller: smaller,
        matrixFromColumns: matrixFromColumns,
        dot: dot
    });
    /**
   * Compute eigenvalues and eigenvectors of a matrix. The eigenvalues are sorted by their absolute value, ascending.
   * An eigenvalue with multiplicity k will be listed k times. The eigenvectors are returned as columns of a matrix –
   * the eigenvector that belongs to the j-th eigenvalue in the list (eg. `values[j]`) is the j-th column (eg. `column(vectors, j)`).
   * If the algorithm fails to converge, it will throw an error – in that case, however, you may still find useful information
   * in `err.values` and `err.vectors`.
   *
   * Syntax:
   *
   *     math.eigs(x, [prec])
   *
   * Examples:
   *
   *     const { eigs, multiply, column, transpose } = math
   *     const H = [[5, 2.3], [2.3, 1]]
   *     const ans = eigs(H) // returns {values: [E1,E2...sorted], vectors: [v1,v2.... corresponding vectors as columns]}
   *     const E = ans.values
   *     const U = ans.vectors
   *     multiply(H, column(U, 0)) // returns multiply(E[0], column(U, 0))
   *     const UTxHxU = multiply(transpose(U), H, U) // diagonalizes H
   *     E[0] == UTxHxU[0][0]  // returns true
   *
   * See also:
   *
   *     inv
   *
   * @param {Array | Matrix} x  Matrix to be diagonalized
   *
   * @param {number | BigNumber} [prec] Precision, default value: 1e-15
   * @return {{values: Array|Matrix, vectors: Array|Matrix}} Object containing an array of eigenvalues and a matrix with eigenvectors as columns.
   *
   */ return typed('eigs', {
        Array: function Array(x) {
            var mat = matrix(x);
            return computeValuesAndVectors(mat);
        },
        'Array, number|BigNumber': function ArrayNumberBigNumber(x, prec) {
            var mat = matrix(x);
            return computeValuesAndVectors(mat, prec);
        },
        Matrix: function Matrix(mat) {
            var { values: values, vectors: vectors } = computeValuesAndVectors(mat);
            return {
                values: matrix(values),
                vectors: matrix(vectors)
            };
        },
        'Matrix, number|BigNumber': function MatrixNumberBigNumber(mat, prec) {
            var { values: values, vectors: vectors } = computeValuesAndVectors(mat, prec);
            return {
                values: matrix(values),
                vectors: matrix(vectors)
            };
        }
    });
    function computeValuesAndVectors(mat, prec) {
        if (prec === undefined) prec = config.epsilon;
        var size = mat.size();
        if (size.length !== 2 || size[0] !== size[1]) throw new RangeError('Matrix must be square (size: ' + (0, $aEppI.format)(size) + ')');
        var arr = mat.toArray();
        var N = size[0];
        if (isReal(arr, N, prec)) {
            coerceReal(arr, N);
            if (isSymmetric(arr, N, prec)) {
                var _type = coerceTypes(mat, arr, N);
                return doRealSymetric(arr, N, prec, _type);
            }
        }
        var type = coerceTypes(mat, arr, N);
        return doComplexEigs(arr, N, prec, type);
    }
    /** @return {boolean} */ function isSymmetric(arr, N, prec) {
        for(var i = 0; i < N; i++)for(var j = i; j < N; j++){
            // TODO proper comparison of bignum and frac
            if (larger(bignumber(abs(subtract(arr[i][j], arr[j][i]))), prec)) return false;
        }
        return true;
    }
    /** @return {boolean} */ function isReal(arr, N, prec) {
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++){
            // TODO proper comparison of bignum and frac
            if (larger(bignumber(abs(im(arr[i][j]))), prec)) return false;
        }
        return true;
    }
    function coerceReal(arr, N) {
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++)arr[i][j] = re(arr[i][j]);
    }
    /** @return {'number' | 'BigNumber' | 'Complex'} */ function coerceTypes(mat, arr, N) {
        /** @type {string} */ var type = mat.datatype();
        if (type === 'number' || type === 'BigNumber' || type === 'Complex') return type;
        var hasNumber = false;
        var hasBig = false;
        var hasComplex = false;
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++){
            var el = arr[i][j];
            if ((0, $gs7TF.isNumber)(el) || (0, $gs7TF.isFraction)(el)) hasNumber = true;
            else if ((0, $gs7TF.isBigNumber)(el)) hasBig = true;
            else if ((0, $gs7TF.isComplex)(el)) hasComplex = true;
            else throw TypeError('Unsupported type in Matrix: ' + (0, $gs7TF.typeOf)(el));
        }
        if (hasBig && hasComplex) console.warn('Complex BigNumbers not supported, this operation will lose precission.');
        if (hasComplex) {
            for(var _i = 0; _i < N; _i++)for(var _j = 0; _j < N; _j++)arr[_i][_j] = complex(arr[_i][_j]);
            return 'Complex';
        }
        if (hasBig) {
            for(var _i2 = 0; _i2 < N; _i2++)for(var _j2 = 0; _j2 < N; _j2++)arr[_i2][_j2] = bignumber(arr[_i2][_j2]);
            return 'BigNumber';
        }
        if (hasNumber) {
            for(var _i3 = 0; _i3 < N; _i3++)for(var _j3 = 0; _j3 < N; _j3++)arr[_i3][_j3] = number(arr[_i3][_j3]);
            return 'number';
        } else throw TypeError('Matrix contains unsupported types only.');
    }
});

});
parcelRegister("ekHr5", function(module, exports) {

$parcel$export(module.exports, "createComplexEigs", () => $a6f4a064d0e99881$export$190353ff415180b5);

var $4mYv9 = parcelRequire("4mYv9");
function $a6f4a064d0e99881$export$190353ff415180b5(_ref) {
    var { addScalar: addScalar, subtract: subtract, flatten: flatten, multiply: multiply, multiplyScalar: multiplyScalar, divideScalar: divideScalar, sqrt: sqrt, abs: abs, bignumber: bignumber, diag: diag, inv: inv, qr: qr, usolve: usolve, usolveAll: usolveAll, equal: equal, complex: complex, larger: larger, smaller: smaller, matrixFromColumns: matrixFromColumns, dot: dot } = _ref;
    /**
   * @param {number[][]} arr the matrix to find eigenvalues of
   * @param {number} N size of the matrix
   * @param {number|BigNumber} prec precision, anything lower will be considered zero
   * @param {'number'|'BigNumber'|'Complex'} type
   * @param {boolean} findVectors should we find eigenvectors?
   *
   * @returns {{ values: number[], vectors: number[][] }}
   */ function complexEigs(arr, N, prec, type, findVectors) {
        if (findVectors === undefined) findVectors = true;
         // TODO check if any row/col are zero except the diagonal
        // make sure corresponding rows and columns have similar magnitude
        // important because of numerical stability
        var R = balance(arr, N, prec, type, findVectors); // R is the row transformation matrix
        // A' = R A R⁻¹, A is the original matrix
        // (if findVectors is false, R is undefined)
        // TODO if magnitudes of elements vary over many orders,
        // move greatest elements to the top left corner
        // using similarity transformations, reduce the matrix
        // to Hessenberg form (upper triangular plus one subdiagonal row)
        // updates the transformation matrix R with new row operationsq
        reduceToHessenberg(arr, N, prec, type, findVectors, R); // find eigenvalues
        var { values: values, C: C } = iterateUntilTriangular(arr, N, prec, type, findVectors); // values is the list of eigenvalues, C is the column
        // transformation matrix that transforms the hessenberg
        // matrix to upper triangular
        // compose transformations A → hess. and hess. → triang.
        C = multiply(inv(R), C);
        var vectors;
        if (findVectors) {
            vectors = findEigenvectors(arr, N, C, values, prec, type);
            vectors = matrixFromColumns(...vectors);
        }
        return {
            values: values,
            vectors: vectors
        };
    }
    /**
   * @param {number[][]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {number[][]}
   */ function balance(arr, N, prec, type, findVectors) {
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1; // base of the floating-point arithmetic
        var radix = big ? bignumber(10) : 2;
        var radixSq = multiplyScalar(radix, radix); // the diagonal transformation matrix R
        var Rdiag;
        if (findVectors) Rdiag = Array(N).fill(one);
         // this isn't the only time we loop thru the matrix...
        var last = false;
        while(!last){
            // ...haha I'm joking! unless...
            last = true;
            for(var i = 0; i < N; i++){
                // compute the taxicab norm of i-th column and row
                // TODO optimize for complex numbers
                var colNorm = zero;
                var rowNorm = zero;
                for(var j = 0; j < N; j++){
                    if (i === j) continue;
                    var c = abs(arr[i][j]);
                    colNorm = addScalar(colNorm, c);
                    rowNorm = addScalar(rowNorm, c);
                }
                if (!equal(colNorm, 0) && !equal(rowNorm, 0)) {
                    // find integer power closest to balancing the matrix
                    // (we want to scale only by integer powers of radix,
                    // so that we don't lose any precision due to round-off)
                    var f = one;
                    var _c = colNorm;
                    var rowDivRadix = divideScalar(rowNorm, radix);
                    var rowMulRadix = multiplyScalar(rowNorm, radix);
                    while(smaller(_c, rowDivRadix)){
                        _c = multiplyScalar(_c, radixSq);
                        f = multiplyScalar(f, radix);
                    }
                    while(larger(_c, rowMulRadix)){
                        _c = divideScalar(_c, radixSq);
                        f = divideScalar(f, radix);
                    } // check whether balancing is needed
                    // condition = (c + rowNorm) / f < 0.95 * (colNorm + rowNorm)
                    var condition = smaller(divideScalar(addScalar(_c, rowNorm), f), multiplyScalar(addScalar(colNorm, rowNorm), 0.95)); // apply balancing similarity transformation
                    if (condition) {
                        // we should loop once again to check whether
                        // another rebalancing is needed
                        last = false;
                        var g = divideScalar(1, f);
                        for(var _j = 0; _j < N; _j++){
                            if (i === _j) continue;
                            arr[i][_j] = multiplyScalar(arr[i][_j], f);
                            arr[_j][i] = multiplyScalar(arr[_j][i], g);
                        } // keep track of transformations
                        if (findVectors) Rdiag[i] = multiplyScalar(Rdiag[i], f);
                    }
                }
            }
        } // return the diagonal row transformation matrix
        return diag(Rdiag);
    }
    /**
   * @param {number[][]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number'|'BigNumber'|'Complex'} type
   * @param {boolean} findVectors
   * @param {number[][]} R the row transformation matrix that will be modified
   */ function reduceToHessenberg(arr, N, prec, type, findVectors, R) {
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        if (big) prec = bignumber(prec);
        for(var i = 0; i < N - 2; i++){
            // Find the largest subdiag element in the i-th col
            var maxIndex = 0;
            var max = zero;
            for(var j = i + 1; j < N; j++){
                var el = arr[j][i];
                if (smaller(abs(max), abs(el))) {
                    max = el;
                    maxIndex = j;
                }
            } // This col is pivoted, no need to do anything
            if (smaller(abs(max), prec)) continue;
            if (maxIndex !== i + 1) {
                // Interchange maxIndex-th and (i+1)-th row
                var tmp1 = arr[maxIndex];
                arr[maxIndex] = arr[i + 1];
                arr[i + 1] = tmp1; // Interchange maxIndex-th and (i+1)-th column
                for(var _j2 = 0; _j2 < N; _j2++){
                    var tmp2 = arr[_j2][maxIndex];
                    arr[_j2][maxIndex] = arr[_j2][i + 1];
                    arr[_j2][i + 1] = tmp2;
                } // keep track of transformations
                if (findVectors) {
                    var tmp3 = R[maxIndex];
                    R[maxIndex] = R[i + 1];
                    R[i + 1] = tmp3;
                }
            } // Reduce following rows and columns
            for(var _j3 = i + 2; _j3 < N; _j3++){
                var n = divideScalar(arr[_j3][i], max);
                if (n === 0) continue;
                 // from j-th row subtract n-times (i+1)th row
                for(var k = 0; k < N; k++)arr[_j3][k] = subtract(arr[_j3][k], multiplyScalar(n, arr[i + 1][k]));
                 // to (i+1)th column add n-times j-th column
                for(var _k = 0; _k < N; _k++)arr[_k][i + 1] = addScalar(arr[_k][i + 1], multiplyScalar(n, arr[_k][_j3]));
                 // keep track of transformations
                if (findVectors) for(var _k2 = 0; _k2 < N; _k2++)R[_j3][_k2] = subtract(R[_j3][_k2], multiplyScalar(n, R[i + 1][_k2]));
            }
        }
        return R;
    }
    /**
   * @returns {{values: values, C: Matrix}}
   * @see Press, Wiliams: Numerical recipes in Fortran 77
   * @see https://en.wikipedia.org/wiki/QR_algorithm
   */ function iterateUntilTriangular(A, N, prec, type, findVectors) {
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        if (big) prec = bignumber(prec);
         // The Francis Algorithm
        // The core idea of this algorithm is that doing successive
        // A' = Q⁺AQ transformations will eventually converge to block-
        // upper-triangular with diagonal blocks either 1x1 or 2x2.
        // The Q here is the one from the QR decomposition, A = QR.
        // Since the eigenvalues of a block-upper-triangular matrix are
        // the eigenvalues of its diagonal blocks and we know how to find
        // eigenvalues of a 2x2 matrix, we know the eigenvalues of A.
        var arr = (0, $4mYv9.clone)(A); // the list of converged eigenvalues
        var lambdas = []; // size of arr, which will get smaller as eigenvalues converge
        var n = N; // the diagonal of the block-diagonal matrix that turns
        // converged 2x2 matrices into upper triangular matrices
        var Sdiag = []; // N×N matrix describing the overall transformation done during the QR algorithm
        var Qtotal = findVectors ? diag(Array(N).fill(one)) : undefined; // n×n matrix describing the QR transformations done since last convergence
        var Qpartial = findVectors ? diag(Array(n).fill(one)) : undefined; // last eigenvalue converged before this many steps
        var lastConvergenceBefore = 0;
        while(lastConvergenceBefore <= 100){
            lastConvergenceBefore += 1; // TODO if the convergence is slow, do something clever
            // Perform the factorization
            var k = 0; // TODO set close to an eigenvalue
            for(var i = 0; i < n; i++)arr[i][i] = subtract(arr[i][i], k);
             // TODO do an implicit QR transformation
            var { Q: Q, R: R } = qr(arr);
            arr = multiply(R, Q);
            for(var _i = 0; _i < n; _i++)arr[_i][_i] = addScalar(arr[_i][_i], k);
             // keep track of transformations
            if (findVectors) Qpartial = multiply(Qpartial, Q);
             // The rightmost diagonal element converged to an eigenvalue
            if (n === 1 || smaller(abs(arr[n - 1][n - 2]), prec)) {
                lastConvergenceBefore = 0;
                lambdas.push(arr[n - 1][n - 1]); // keep track of transformations
                if (findVectors) {
                    Sdiag.unshift([
                        [
                            1
                        ]
                    ]);
                    inflateMatrix(Qpartial, N);
                    Qtotal = multiply(Qtotal, Qpartial);
                    if (n > 1) Qpartial = diag(Array(n - 1).fill(one));
                } // reduce the matrix size
                n -= 1;
                arr.pop();
                for(var _i2 = 0; _i2 < n; _i2++)arr[_i2].pop();
                 // The rightmost diagonal 2x2 block converged
            } else if (n === 2 || smaller(abs(arr[n - 2][n - 3]), prec)) {
                lastConvergenceBefore = 0;
                var ll = eigenvalues2x2(arr[n - 2][n - 2], arr[n - 2][n - 1], arr[n - 1][n - 2], arr[n - 1][n - 1]);
                lambdas.push(...ll); // keep track of transformations
                if (findVectors) {
                    Sdiag.unshift(jordanBase2x2(arr[n - 2][n - 2], arr[n - 2][n - 1], arr[n - 1][n - 2], arr[n - 1][n - 1], ll[0], ll[1], prec, type));
                    inflateMatrix(Qpartial, N);
                    Qtotal = multiply(Qtotal, Qpartial);
                    if (n > 2) Qpartial = diag(Array(n - 2).fill(one));
                } // reduce the matrix size
                n -= 2;
                arr.pop();
                arr.pop();
                for(var _i3 = 0; _i3 < n; _i3++){
                    arr[_i3].pop();
                    arr[_i3].pop();
                }
            }
            if (n === 0) break;
        } // standard sorting
        lambdas.sort((a, b)=>+subtract(abs(a), abs(b))); // the algorithm didn't converge
        if (lastConvergenceBefore > 100) {
            var err = Error('The eigenvalues failed to converge. Only found these eigenvalues: ' + lambdas.join(', '));
            err.values = lambdas;
            err.vectors = [];
            throw err;
        } // combine the overall QR transformation Qtotal with the subsequent
        // transformation S that turns the diagonal 2x2 blocks to upper triangular
        var C = findVectors ? multiply(Qtotal, blockDiag(Sdiag, N)) : undefined;
        return {
            values: lambdas,
            C: C
        };
    }
    /**
   * @param {Matrix} A original matrix
   * @param {number} N size of A
   * @param {Matrix} C column transformation matrix that turns A into upper triangular
   * @param {number[]} values array of eigenvalues of A
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {number[][]} eigenvalues
   */ function findEigenvectors(A, N, C, values, prec, type) {
        var Cinv = inv(C);
        var U = multiply(Cinv, A, C);
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1; // turn values into a kind of "multiset"
        // this way it is easier to find eigenvectors
        var uniqueValues = [];
        var multiplicities = [];
        for (var \u03BB of values){
            var i = indexOf(uniqueValues, \u03BB, equal);
            if (i === -1) {
                uniqueValues.push(\u03BB);
                multiplicities.push(1);
            } else multiplicities[i] += 1;
        } // find eigenvectors by solving U − λE = 0
        // TODO replace with an iterative eigenvector algorithm
        // (this one might fail for imprecise eigenvalues)
        var vectors = [];
        var len = uniqueValues.length;
        var b = Array(N).fill(zero);
        var E = diag(Array(N).fill(one)); // eigenvalues for which usolve failed (due to numerical error)
        var failedLambdas = [];
        for(var _i4 = 0; _i4 < len; _i4++){
            var _\u03BB = uniqueValues[_i4];
            var _A = subtract(U, multiply(_\u03BB, E)); // the characteristic matrix
            var solutions = usolveAll(_A, b);
            solutions = solutions.map((v)=>multiply(C, v));
            solutions.shift(); // ignore the null vector
            // looks like we missed something, try inverse iteration
            while(solutions.length < multiplicities[_i4]){
                var approxVec = inverseIterate(_A, N, solutions, prec, type);
                if (approxVec == null) {
                    // no more vectors were found
                    failedLambdas.push(_\u03BB);
                    break;
                }
                solutions.push(approxVec);
            }
            vectors.push(...solutions.map((v)=>flatten(v)));
        }
        if (failedLambdas.length !== 0) {
            var err = new Error('Failed to find eigenvectors for the following eigenvalues: ' + failedLambdas.join(', '));
            err.values = values;
            err.vectors = vectors;
            throw err;
        }
        return vectors;
    }
    /**
   * Compute the eigenvalues of an 2x2 matrix
   * @return {[number,number]}
   */ function eigenvalues2x2(a, b, c, d) {
        // λ± = ½ trA ± ½ √( tr²A - 4 detA )
        var trA = addScalar(a, d);
        var detA = subtract(multiplyScalar(a, d), multiplyScalar(b, c));
        var x = multiplyScalar(trA, 0.5);
        var y = multiplyScalar(sqrt(subtract(multiplyScalar(trA, trA), multiplyScalar(4, detA))), 0.5);
        return [
            addScalar(x, y),
            subtract(x, y)
        ];
    }
    /**
   * For an 2x2 matrix compute the transformation matrix S,
   * so that SAS⁻¹ is an upper triangular matrix
   * @return {[[number,number],[number,number]]}
   * @see https://math.berkeley.edu/~ogus/old/Math_54-05/webfoils/jordan.pdf
   * @see http://people.math.harvard.edu/~knill/teaching/math21b2004/exhibits/2dmatrices/index.html
   */ function jordanBase2x2(a, b, c, d, l1, l2, prec, type) {
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1; // matrix is already upper triangular
        // return an identity matrix
        if (smaller(abs(c), prec)) return [
            [
                one,
                zero
            ],
            [
                zero,
                one
            ]
        ];
         // matrix is diagonalizable
        // return its eigenvectors as columns
        if (larger(abs(subtract(l1, l2)), prec)) return [
            [
                subtract(l1, d),
                subtract(l2, d)
            ],
            [
                c,
                c
            ]
        ];
         // matrix is not diagonalizable
        // compute off-diagonal elements of N = A - λI
        // N₁₂ = 0 ⇒ S = ( N⃗₁, I⃗₁ )
        // N₁₂ ≠ 0 ⇒ S = ( N⃗₂, I⃗₂ )
        var na = subtract(a, l1);
        var nb = subtract(b, l1);
        var nc = subtract(c, l1);
        var nd = subtract(d, l1);
        if (smaller(abs(nb), prec)) return [
            [
                na,
                one
            ],
            [
                nc,
                zero
            ]
        ];
        else return [
            [
                nb,
                zero
            ],
            [
                nd,
                one
            ]
        ];
    }
    /**
   * Enlarge the matrix from n×n to N×N, setting the new
   * elements to 1 on diagonal and 0 elsewhere
   */ function inflateMatrix(arr, N) {
        // add columns
        for(var i = 0; i < arr.length; i++)arr[i].push(...Array(N - arr[i].length).fill(0));
         // add rows
        for(var _i5 = arr.length; _i5 < N; _i5++){
            arr.push(Array(N).fill(0));
            arr[_i5][_i5] = 1;
        }
        return arr;
    }
    /**
   * Create a block-diagonal matrix with the given square matrices on the diagonal
   * @param {Matrix[] | number[][][]} arr array of matrices to be placed on the diagonal
   * @param {number} N the size of the resulting matrix
   */ function blockDiag(arr, N) {
        var M = [];
        for(var i = 0; i < N; i++)M[i] = Array(N).fill(0);
        var I = 0;
        for (var sub of arr){
            var n = sub.length;
            for(var _i6 = 0; _i6 < n; _i6++)for(var j = 0; j < n; j++)M[I + _i6][I + j] = sub[_i6][j];
            I += n;
        }
        return M;
    }
    /**
   * Finds the index of an element in an array using a custom equality function
   * @template T
   * @param {Array<T>} arr array in which to search
   * @param {T} el the element to find
   * @param {function(T, T): boolean} fn the equality function, first argument is an element of `arr`, the second is always `el`
   * @returns {number} the index of `el`, or -1 when it's not in `arr`
   */ function indexOf(arr, el, fn) {
        for(var i = 0; i < arr.length; i++){
            if (fn(arr[i], el)) return i;
        }
        return -1;
    }
    /**
   * Provided a near-singular upper-triangular matrix A and a list of vectors,
   * finds an eigenvector of A with the smallest eigenvalue, which is orthogonal
   * to each vector in the list
   * @template T
   * @param {T[][]} A near-singular square matrix
   * @param {number} N dimension
   * @param {T[][]} orthog list of vectors
   * @param {number} prec epsilon
   * @param {'number'|'BigNumber'|'Complex'} type
   * @return {T[] | null} eigenvector
   *
   * @see Numerical Recipes for Fortran 77 – 11.7 Eigenvalues or Eigenvectors by Inverse Iteration
   */ function inverseIterate(A, N, orthog, prec, type) {
        var largeNum = type === 'BigNumber' ? bignumber(1000) : 1000;
        var b; // the vector
        // you better choose a random vector before I count to five
        var i = 0;
        while(true){
            b = randomOrthogonalVector(N, orthog, type);
            b = usolve(A, b);
            if (larger(norm(b), largeNum)) break;
            if (++i >= 5) return null;
        } // you better converge before I count to ten
        i = 0;
        while(true){
            var c = usolve(A, b);
            if (smaller(norm(orthogonalComplement(b, [
                c
            ])), prec)) break;
            if (++i >= 10) return null;
            b = normalize(c);
        }
        return b;
    }
    /**
   * Generates a random unit vector of dimension N, orthogonal to each vector in the list
   * @template T
   * @param {number} N dimension
   * @param {T[][]} orthog list of vectors
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {T[]} random vector
   */ function randomOrthogonalVector(N, orthog, type) {
        var big = type === 'BigNumber';
        var cplx = type === 'Complex'; // generate random vector with the correct type
        var v = Array(N).fill(0).map((_)=>2 * Math.random() - 1);
        if (big) v = v.map((n)=>bignumber(n));
        if (cplx) v = v.map((n)=>complex(n));
         // project to orthogonal complement
        v = orthogonalComplement(v, orthog); // normalize
        return normalize(v, type);
    }
    /**
   * Project vector v to the orthogonal complement of an array of vectors
   */ function orthogonalComplement(v, orthog) {
        for (var w of orthog)// v := v − (w, v)/∥w∥² w
        v = subtract(v, multiply(divideScalar(dot(w, v), dot(w, w)), w));
        return v;
    }
    /**
   * Calculate the norm of a vector.
   * We can't use math.norm because factory can't handle circular dependency.
   * Seriously, I'm really fed up with factory.
   */ function norm(v) {
        return abs(sqrt(dot(v, v)));
    }
    /**
   * Normalize a vector
   * @template T
   * @param {T[]} v
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {T[]} normalized vec
   */ function normalize(v, type) {
        var big = type === 'BigNumber';
        var cplx = type === 'Complex';
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        return multiply(divideScalar(one, norm(v)), v);
    }
    return complexEigs;
}

});

parcelRegister("4Kg5X", function(module, exports) {

$parcel$export(module.exports, "createRealSymmetric", () => $3747f176a06f3b61$export$a8f76d83a88e1b99);

var $4mYv9 = parcelRequire("4mYv9");
function $3747f176a06f3b61$export$a8f76d83a88e1b99(_ref) {
    var { config: config, addScalar: addScalar, subtract: subtract, abs: abs, atan: atan, cos: cos, sin: sin, multiplyScalar: multiplyScalar, inv: inv, bignumber: bignumber, multiply: multiply, add: add } = _ref;
    /**
   * @param {number[] | BigNumber[]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number' | 'BigNumber'} type
   */ function main(arr, N) {
        var prec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : config.epsilon;
        var type = arguments.length > 3 ? arguments[3] : undefined;
        if (type === 'number') return diag(arr, prec);
        if (type === 'BigNumber') return diagBig(arr, prec);
        throw TypeError('Unsupported data type: ' + type);
    } // diagonalization implementation for number (efficient)
    function diag(x, precision) {
        var N = x.length;
        var e0 = Math.abs(precision / N);
        var psi;
        var Sij = new Array(N); // Sij is Identity Matrix
        for(var i = 0; i < N; i++){
            Sij[i] = createArray(N, 0);
            Sij[i][i] = 1.0;
        } // initial error
        var Vab = getAij(x);
        while(Math.abs(Vab[1]) >= Math.abs(e0)){
            var _i = Vab[0][0];
            var j = Vab[0][1];
            psi = getTheta(x[_i][_i], x[j][j], x[_i][j]);
            x = x1(x, psi, _i, j);
            Sij = Sij1(Sij, psi, _i, j);
            Vab = getAij(x);
        }
        var Ei = createArray(N, 0); // eigenvalues
        for(var _i2 = 0; _i2 < N; _i2++)Ei[_i2] = x[_i2][_i2];
        return sorting((0, $4mYv9.clone)(Ei), (0, $4mYv9.clone)(Sij));
    } // diagonalization implementation for bigNumber
    function diagBig(x, precision) {
        var N = x.length;
        var e0 = abs(precision / N);
        var psi;
        var Sij = new Array(N); // Sij is Identity Matrix
        for(var i = 0; i < N; i++){
            Sij[i] = createArray(N, 0);
            Sij[i][i] = 1.0;
        } // initial error
        var Vab = getAijBig(x);
        while(abs(Vab[1]) >= abs(e0)){
            var _i3 = Vab[0][0];
            var j = Vab[0][1];
            psi = getThetaBig(x[_i3][_i3], x[j][j], x[_i3][j]);
            x = x1Big(x, psi, _i3, j);
            Sij = Sij1Big(Sij, psi, _i3, j);
            Vab = getAijBig(x);
        }
        var Ei = createArray(N, 0); // eigenvalues
        for(var _i4 = 0; _i4 < N; _i4++)Ei[_i4] = x[_i4][_i4];
         // return [clone(Ei), clone(Sij)]
        return sorting((0, $4mYv9.clone)(Ei), (0, $4mYv9.clone)(Sij));
    } // get angle
    function getTheta(aii, ajj, aij) {
        var denom = ajj - aii;
        if (Math.abs(denom) <= config.epsilon) return Math.PI / 4.0;
        else return 0.5 * Math.atan(2.0 * aij / (ajj - aii));
    } // get angle
    function getThetaBig(aii, ajj, aij) {
        var denom = subtract(ajj, aii);
        if (abs(denom) <= config.epsilon) return bignumber(-1).acos().div(4);
        else return multiplyScalar(0.5, atan(multiply(2.0, aij, inv(denom))));
    } // update eigvec
    function Sij1(Sij, theta, i, j) {
        var N = Sij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var Ski = createArray(N, 0);
        var Skj = createArray(N, 0);
        for(var k = 0; k < N; k++){
            Ski[k] = c * Sij[k][i] - s * Sij[k][j];
            Skj[k] = s * Sij[k][i] + c * Sij[k][j];
        }
        for(var _k = 0; _k < N; _k++){
            Sij[_k][i] = Ski[_k];
            Sij[_k][j] = Skj[_k];
        }
        return Sij;
    } // update eigvec for overlap
    function Sij1Big(Sij, theta, i, j) {
        var N = Sij.length;
        var c = cos(theta);
        var s = sin(theta);
        var Ski = createArray(N, bignumber(0));
        var Skj = createArray(N, bignumber(0));
        for(var k = 0; k < N; k++){
            Ski[k] = subtract(multiplyScalar(c, Sij[k][i]), multiplyScalar(s, Sij[k][j]));
            Skj[k] = addScalar(multiplyScalar(s, Sij[k][i]), multiplyScalar(c, Sij[k][j]));
        }
        for(var _k2 = 0; _k2 < N; _k2++){
            Sij[_k2][i] = Ski[_k2];
            Sij[_k2][j] = Skj[_k2];
        }
        return Sij;
    } // update matrix
    function x1Big(Hij, theta, i, j) {
        var N = Hij.length;
        var c = bignumber(cos(theta));
        var s = bignumber(sin(theta));
        var c2 = multiplyScalar(c, c);
        var s2 = multiplyScalar(s, s);
        var Aki = createArray(N, bignumber(0));
        var Akj = createArray(N, bignumber(0)); // 2cs Hij
        var csHij = multiply(bignumber(2), c, s, Hij[i][j]); //  Aii
        var Aii = addScalar(subtract(multiplyScalar(c2, Hij[i][i]), csHij), multiplyScalar(s2, Hij[j][j]));
        var Ajj = add(multiplyScalar(s2, Hij[i][i]), csHij, multiplyScalar(c2, Hij[j][j])); // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = subtract(multiplyScalar(c, Hij[i][k]), multiplyScalar(s, Hij[j][k]));
            Akj[k] = addScalar(multiplyScalar(s, Hij[i][k]), multiplyScalar(c, Hij[j][k]));
        } // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = bignumber(0);
        Hij[j][i] = bignumber(0); // 0  to i
        for(var _k3 = 0; _k3 < N; _k3++)if (_k3 !== i && _k3 !== j) {
            Hij[i][_k3] = Aki[_k3];
            Hij[_k3][i] = Aki[_k3];
            Hij[j][_k3] = Akj[_k3];
            Hij[_k3][j] = Akj[_k3];
        }
        return Hij;
    } // update matrix
    function x1(Hij, theta, i, j) {
        var N = Hij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var c2 = c * c;
        var s2 = s * s;
        var Aki = createArray(N, 0);
        var Akj = createArray(N, 0); //  Aii
        var Aii = c2 * Hij[i][i] - 2 * c * s * Hij[i][j] + s2 * Hij[j][j];
        var Ajj = s2 * Hij[i][i] + 2 * c * s * Hij[i][j] + c2 * Hij[j][j]; // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = c * Hij[i][k] - s * Hij[j][k];
            Akj[k] = s * Hij[i][k] + c * Hij[j][k];
        } // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = 0;
        Hij[j][i] = 0; // 0  to i
        for(var _k4 = 0; _k4 < N; _k4++)if (_k4 !== i && _k4 !== j) {
            Hij[i][_k4] = Aki[_k4];
            Hij[_k4][i] = Aki[_k4];
            Hij[j][_k4] = Akj[_k4];
            Hij[_k4][j] = Akj[_k4];
        }
        return Hij;
    } // get max off-diagonal value from Upper Diagonal
    function getAij(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (Math.abs(maxMij) < Math.abs(Mij[i][j])) {
                maxMij = Math.abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    } // get max off-diagonal value from Upper Diagonal
    function getAijBig(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (abs(maxMij) < abs(Mij[i][j])) {
                maxMij = abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    } // sort results
    function sorting(E, S) {
        var N = E.length;
        var values = Array(N);
        var vectors = Array(N);
        for(var k = 0; k < N; k++)vectors[k] = Array(N);
        for(var i = 0; i < N; i++){
            var minID = 0;
            var minE = E[0];
            for(var j = 0; j < E.length; j++)if (abs(E[j]) < abs(minE)) {
                minID = j;
                minE = E[minID];
            }
            values[i] = E.splice(minID, 1)[0];
            for(var _k5 = 0; _k5 < N; _k5++){
                vectors[_k5][i] = S[_k5][minID];
                S[_k5].splice(minID, 1);
            }
        }
        return {
            values: values,
            vectors: vectors
        };
    }
    /**
   * Create an array of a certain size and fill all items with an initial value
   * @param {number} size
   * @param {number} value
   * @return {number[]}
   */ function createArray(size, value) {
        // TODO: as soon as all browsers support Array.fill, use that instead (IE doesn't support it)
        var array = new Array(size);
        for(var i = 0; i < size; i++)array[i] = value;
        return array;
    }
    return main;
}

});


parcelRegister("gAGKJ", function(module, exports) {

$parcel$export(module.exports, "createEqual", () => $c1412bf2cf46d00e$export$988f37bc1f709b0d);

var $4eE2e = parcelRequire("4eE2e");

var $6MKpt = parcelRequire("6MKpt");

var $ai5Sw = parcelRequire("ai5Sw");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");
var $c1412bf2cf46d00e$var$name = 'equal';
var $c1412bf2cf46d00e$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'DenseMatrix'
];
var $c1412bf2cf46d00e$export$988f37bc1f709b0d = /* #__PURE__ */ (0, $4eE2e.factory)($c1412bf2cf46d00e$var$name, $c1412bf2cf46d00e$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $ai5Sw.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether two values are equal.
   *
   * The function tests whether the relative difference between x and y is
   * smaller than the configured epsilon. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must equal y.re, and x.im must equal y.im.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is only
   * equal to `null` and nothing else, and `undefined` is only equal to
   * `undefined` and nothing else. Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.equal(x, y)
   *
   * Examples:
   *
   *    math.equal(2 + 2, 3)         // returns false
   *    math.equal(2 + 2, 4)         // returns true
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.equal(a, b)             // returns true
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.equal(c, d)             // returns [true, false, true]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.equal("1000", "1e3")    // returns true
   *    math.equal(0, null)          // returns false
   *
   * See also:
   *
   *    unequal, smaller, smallerEq, larger, largerEq, compare, deepEqual, equalText
   *
   * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are equal, else returns false
   */ return typed($c1412bf2cf46d00e$var$name, {
        'any, any': function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y === null;
            if (y === null) return x === null;
            if (x === undefined) return y === undefined;
            if (y === undefined) return x === undefined;
            return equalScalar(x, y);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, equalScalar);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, equalScalar, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, equalScalar, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, equalScalar);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, equalScalar, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, equalScalar, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, equalScalar, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, equalScalar, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, equalScalar, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, equalScalar, true).valueOf();
        }
    });
});
var $c1412bf2cf46d00e$export$87c1b92540f5e2ae = (0, $4eE2e.factory)($c1412bf2cf46d00e$var$name, [
    'typed',
    'equalScalar'
], (_ref2)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref2;
    return typed($c1412bf2cf46d00e$var$name, {
        'any, any': function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y === null;
            if (y === null) return x === null;
            if (x === undefined) return y === undefined;
            if (y === undefined) return x === undefined;
            return equalScalar(x, y);
        }
    });
});

});

parcelRegister("6GjXW", function(module, exports) {

$parcel$export(module.exports, "createEqualScalar", () => $4dd62719a1d44f1f$export$c370bab664a0c9a2);

var $iV3Fc = parcelRequire("iV3Fc");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");

var $2usAb = parcelRequire("2usAb");
var $4dd62719a1d44f1f$var$name = 'equalScalar';
var $4dd62719a1d44f1f$var$dependencies = [
    'typed',
    'config'
];
var $4dd62719a1d44f1f$export$c370bab664a0c9a2 = /* #__PURE__ */ (0, $4eE2e.factory)($4dd62719a1d44f1f$var$name, $4dd62719a1d44f1f$var$dependencies, (_ref)=>{
    var { typed: typed, config: config } = _ref;
    /**
   * Test whether two scalar values are nearly equal.
   *
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit} x   First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Complex} y          Second value to compare
   * @return {boolean}                                                  Returns true when the compared values are equal, else returns false
   * @private
   */ return typed($4dd62719a1d44f1f$var$name, {
        'boolean, boolean': function booleanBoolean(x, y) {
            return x === y;
        },
        'number, number': function numberNumber(x, y) {
            return (0, $6egKm.nearlyEqual)(x, y, config.epsilon);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.eq(y) || (0, $iV3Fc.nearlyEqual)(x, y, config.epsilon);
        },
        'Fraction, Fraction': function FractionFraction(x, y) {
            return x.equals(y);
        },
        'Complex, Complex': function ComplexComplex(x, y) {
            return (0, $2usAb.complexEquals)(x, y, config.epsilon);
        },
        'Unit, Unit': function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error('Cannot compare units with different base');
            return this(x.value, y.value);
        }
    });
});
var $4dd62719a1d44f1f$export$55f78fcc2979d648 = (0, $4eE2e.factory)($4dd62719a1d44f1f$var$name, [
    'typed',
    'config'
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($4dd62719a1d44f1f$var$name, {
        'number, number': function numberNumber(x, y) {
            return (0, $6egKm.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});
parcelRegister("2usAb", function(module, exports) {

$parcel$export(module.exports, "complexEquals", () => $1d048e03ba580289$export$852c8261c9f393e0);

var $6egKm = parcelRequire("6egKm");
function $1d048e03ba580289$export$852c8261c9f393e0(x, y, epsilon) {
    return (0, $6egKm.nearlyEqual)(x.re, y.re, epsilon) && (0, $6egKm.nearlyEqual)(x.im, y.im, epsilon);
}

});


parcelRegister("k8DEe", function(module, exports) {

$parcel$export(module.exports, "createEqualText", () => $ea934f3e4b7ad6fd$export$1589aaa29568b87);

var $4eE2e = parcelRequire("4eE2e");
var $ea934f3e4b7ad6fd$var$name = 'equalText';
var $ea934f3e4b7ad6fd$var$dependencies = [
    'typed',
    'compareText',
    'isZero'
];
var $ea934f3e4b7ad6fd$export$1589aaa29568b87 = /* #__PURE__ */ (0, $4eE2e.factory)($ea934f3e4b7ad6fd$var$name, $ea934f3e4b7ad6fd$var$dependencies, (_ref)=>{
    var { typed: typed, compareText: compareText, isZero: isZero } = _ref;
    /**
   * Check equality of two strings. Comparison is case sensitive.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.equalText(x, y)
   *
   * Examples:
   *
   *    math.equalText('Hello', 'Hello')     // returns true
   *    math.equalText('a', 'A')             // returns false
   *    math.equal('2e3', '2000')            // returns true
   *    math.equalText('2e3', '2000')        // returns false
   *
   *    math.equalText('B', ['A', 'B', 'C']) // returns [false, true, false]
   *
   * See also:
   *
   *    equal, compareText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns true if the values are equal, and false if not.
   */ return typed($ea934f3e4b7ad6fd$var$name, {
        'any, any': function anyAny(x, y) {
            return isZero(compareText(x, y));
        }
    });
});

});

parcelRegister("eqOzB", function(module, exports) {

$parcel$export(module.exports, "createErf", () => $a81ab929af23e9e6$export$470dfa326d6cbdf5);
/* eslint-disable no-loss-of-precision */ 
var $9nwyh = parcelRequire("9nwyh");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");
var $a81ab929af23e9e6$var$name = 'erf';
var $a81ab929af23e9e6$var$dependencies = [
    'typed'
];
var $a81ab929af23e9e6$export$470dfa326d6cbdf5 = /* #__PURE__ */ (0, $4eE2e.factory)($a81ab929af23e9e6$var$name, $a81ab929af23e9e6$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the erf function of a value using a rational Chebyshev
   * approximations for different intervals of x.
   *
   * This is a translation of W. J. Cody's Fortran implementation from 1987
   * ( https://www.netlib.org/specfun/erf ). See the AMS publication
   * "Rational Chebyshev Approximations for the Error Function" by W. J. Cody
   * for an explanation of this process.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.erf(x)
   *
   * Examples:
   *
   *    math.erf(0.2)    // returns 0.22270258921047847
   *    math.erf(-0.5)   // returns -0.5204998778130465
   *    math.erf(4)      // returns 0.9999999845827421
   *
   * @param {number | Array | Matrix} x   A real number
   * @return {number | Array | Matrix}    The erf of `x`
   */ return typed('name', {
        number: function number(x) {
            var y = Math.abs(x);
            if (y >= $a81ab929af23e9e6$var$MAX_NUM) return (0, $6egKm.sign)(x);
            if (y <= $a81ab929af23e9e6$var$THRESH) return (0, $6egKm.sign)(x) * erf1(y);
            if (y <= 4.0) return (0, $6egKm.sign)(x) * (1 - erfc2(y));
            return (0, $6egKm.sign)(x) * (1 - erfc3(y));
        },
        'Array | Matrix': function ArrayMatrix(n) {
            return (0, $9nwyh.deepMap)(n, this);
        } // TODO: For complex numbers, use the approximation for the Faddeeva function
    });
    /**
   * Approximates the error function erf() for x <= 0.46875 using this function:
   *               n
   * erf(x) = x * sum (p_j * x^(2j)) / (q_j * x^(2j))
   *              j=0
   */ function erf1(y) {
        var ysq = y * y;
        var xnum = $a81ab929af23e9e6$var$P[0][4] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 3; i += 1){
            xnum = (xnum + $a81ab929af23e9e6$var$P[0][i]) * ysq;
            xden = (xden + $a81ab929af23e9e6$var$Q[0][i]) * ysq;
        }
        return y * (xnum + $a81ab929af23e9e6$var$P[0][3]) / (xden + $a81ab929af23e9e6$var$Q[0][3]);
    }
    /**
   * Approximates the complement of the error function erfc() for
   * 0.46875 <= x <= 4.0 using this function:
   *                       n
   * erfc(x) = e^(-x^2) * sum (p_j * x^j) / (q_j * x^j)
   *                      j=0
   */ function erfc2(y) {
        var xnum = $a81ab929af23e9e6$var$P[1][8] * y;
        var xden = y;
        var i;
        for(i = 0; i < 7; i += 1){
            xnum = (xnum + $a81ab929af23e9e6$var$P[1][i]) * y;
            xden = (xden + $a81ab929af23e9e6$var$Q[1][i]) * y;
        }
        var result = (xnum + $a81ab929af23e9e6$var$P[1][7]) / (xden + $a81ab929af23e9e6$var$Q[1][7]);
        var ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
    /**
   * Approximates the complement of the error function erfc() for x > 4.0 using
   * this function:
   *
   * erfc(x) = (e^(-x^2) / x) * [ 1/sqrt(pi) +
   *               n
   *    1/(x^2) * sum (p_j * x^(-2j)) / (q_j * x^(-2j)) ]
   *              j=0
   */ function erfc3(y) {
        var ysq = 1 / (y * y);
        var xnum = $a81ab929af23e9e6$var$P[2][5] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 4; i += 1){
            xnum = (xnum + $a81ab929af23e9e6$var$P[2][i]) * ysq;
            xden = (xden + $a81ab929af23e9e6$var$Q[2][i]) * ysq;
        }
        var result = ysq * (xnum + $a81ab929af23e9e6$var$P[2][4]) / (xden + $a81ab929af23e9e6$var$Q[2][4]);
        result = ($a81ab929af23e9e6$var$SQRPI - result) / y;
        ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
});
/**
 * Upper bound for the first approximation interval, 0 <= x <= THRESH
 * @constant
 */ var $a81ab929af23e9e6$var$THRESH = 0.46875;
/**
 * Constant used by W. J. Cody's Fortran77 implementation to denote sqrt(pi)
 * @constant
 */ var $a81ab929af23e9e6$var$SQRPI = 5.6418958354775628695e-1;
/**
 * Coefficients for each term of the numerator sum (p_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $a81ab929af23e9e6$var$P = [
    [
        3.16112374387056560e00,
        1.13864154151050156e02,
        3.77485237685302021e02,
        3.20937758913846947e03,
        1.85777706184603153e-1
    ],
    [
        5.64188496988670089e-1,
        8.88314979438837594e00,
        6.61191906371416295e01,
        2.98635138197400131e02,
        8.81952221241769090e02,
        1.71204761263407058e03,
        2.05107837782607147e03,
        1.23033935479799725e03,
        2.15311535474403846e-8
    ],
    [
        3.05326634961232344e-1,
        3.60344899949804439e-1,
        1.25781726111229246e-1,
        1.60837851487422766e-2,
        6.58749161529837803e-4,
        1.63153871373020978e-2
    ]
];
/**
 * Coefficients for each term of the denominator sum (q_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $a81ab929af23e9e6$var$Q = [
    [
        2.36012909523441209e01,
        2.44024637934444173e02,
        1.28261652607737228e03,
        2.84423683343917062e03
    ],
    [
        1.57449261107098347e01,
        1.17693950891312499e02,
        5.37181101862009858e02,
        1.62138957456669019e03,
        3.29079923573345963e03,
        4.36261909014324716e03,
        3.43936767414372164e03,
        1.23033935480374942e03
    ],
    [
        2.56852019228982242e00,
        1.87295284992346047e00,
        5.27905102951428412e-1,
        6.05183413124413191e-2,
        2.33520497626869185e-3
    ]
];
/**
 * Maximum/minimum safe numbers to input to erf() (in ES6+, this number is
 * Number.[MAX|MIN]_SAFE_INTEGER). erf() for all numbers beyond this limit will
 * return 1
 */ var $a81ab929af23e9e6$var$MAX_NUM = Math.pow(2, 53);

});

parcelRegister("dqQg9", function(module, exports) {

$parcel$export(module.exports, "createExp", () => $9c763db902eebf68$export$95a576617fd015b1);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $eRNhQ = parcelRequire("eRNhQ");
var $9c763db902eebf68$var$name = 'exp';
var $9c763db902eebf68$var$dependencies = [
    'typed'
];
var $9c763db902eebf68$export$95a576617fd015b1 = /* #__PURE__ */ (0, $4eE2e.factory)($9c763db902eebf68$var$name, $9c763db902eebf68$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the exponent of a value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.exp(x)
   *
   * Examples:
   *
   *    math.exp(2)                  // returns number 7.3890560989306495
   *    math.pow(math.e, 2)          // returns number 7.3890560989306495
   *    math.log(math.exp(2))        // returns number 2
   *
   *    math.exp([1, 2, 3])
   *    // returns Array [
   *    //   2.718281828459045,
   *    //   7.3890560989306495,
   *    //   20.085536923187668
   *    // ]
   *
   * See also:
   *
   *    expm1, log, pow
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to exponentiate
   * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
   */ return typed($9c763db902eebf68$var$name, {
        number: (0, $eRNhQ.expNumber),
        Complex: function Complex(x) {
            return x.exp();
        },
        BigNumber: function BigNumber(x) {
            return x.exp();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // TODO: exp(sparse) should return a dense matrix since exp(0)==1
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("gYuoo", function(module, exports) {

$parcel$export(module.exports, "createExpm", () => $c5b9d33e8143f819$export$f2c0a6357ff6cb4c);

var $gs7TF = parcelRequire("gs7TF");

var $aEppI = parcelRequire("aEppI");

var $4eE2e = parcelRequire("4eE2e");
var $c5b9d33e8143f819$var$name = 'expm';
var $c5b9d33e8143f819$var$dependencies = [
    'typed',
    'abs',
    'add',
    'identity',
    'inv',
    'multiply'
];
var $c5b9d33e8143f819$export$f2c0a6357ff6cb4c = /* #__PURE__ */ (0, $4eE2e.factory)($c5b9d33e8143f819$var$name, $c5b9d33e8143f819$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, identity: identity, inv: inv, multiply: multiply } = _ref;
    /**
   * Compute the matrix exponential, expm(A) = e^A. The matrix must be square.
   * Not to be confused with exp(a), which performs element-wise
   * exponentiation.
   *
   * The exponential is calculated using the Padé approximant with scaling and
   * squaring; see "Nineteen Dubious Ways to Compute the Exponential of a
   * Matrix," by Moler and Van Loan.
   *
   * Syntax:
   *
   *     math.expm(x)
   *
   * Examples:
   *
   *     const A = [[0,2],[0,0]]
   *     math.expm(A)        // returns [[1,2],[0,1]]
   *
   * See also:
   *
   *     exp
   *
   * @param {Matrix} x  A square Matrix
   * @return {Matrix}   The exponential of x
   */ return typed($c5b9d33e8143f819$var$name, {
        Matrix: function Matrix(A) {
            // Check matrix size
            var size = A.size();
            if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $aEppI.format)(size) + ')');
            var n = size[0]; // Desired accuracy of the approximant (The actual accuracy
            // will be affected by round-off error)
            var eps = 1e-15; // The Padé approximant is not so accurate when the values of A
            // are "large", so scale A by powers of two. Then compute the
            // exponential, and square the result repeatedly according to
            // the identity e^A = (e^(A/m))^m
            // Compute infinity-norm of A, ||A||, to see how "big" it is
            var infNorm = infinityNorm(A); // Find the optimal scaling factor and number of terms in the
            // Padé approximant to reach the desired accuracy
            var params = findParams(infNorm, eps);
            var q = params.q;
            var j = params.j; // The Pade approximation to e^A is:
            // Rqq(A) = Dqq(A) ^ -1 * Nqq(A)
            // where
            // Nqq(A) = sum(i=0, q, (2q-i)!p! / [ (2q)!i!(q-i)! ] A^i
            // Dqq(A) = sum(i=0, q, (2q-i)!q! / [ (2q)!i!(q-i)! ] (-A)^i
            // Scale A by 1 / 2^j
            var Apos = multiply(A, Math.pow(2, -j)); // The i=0 term is just the identity matrix
            var N = identity(n);
            var D = identity(n); // Initialization (i=0)
            var factor = 1; // Initialization (i=1)
            var AposToI = Apos; // Cloning not necessary
            var alternate = -1;
            for(var i = 1; i <= q; i++){
                if (i > 1) {
                    AposToI = multiply(AposToI, Apos);
                    alternate = -alternate;
                }
                factor = factor * (q - i + 1) / ((2 * q - i + 1) * i);
                N = add(N, multiply(factor, AposToI));
                D = add(D, multiply(factor * alternate, AposToI));
            }
            var R = multiply(inv(D), N); // Square j times
            for(var _i = 0; _i < j; _i++)R = multiply(R, R);
            return (0, $gs7TF.isSparseMatrix)(A) ? A.createSparseMatrix(R) : R;
        }
    });
    function infinityNorm(A) {
        var n = A.size()[0];
        var infNorm = 0;
        for(var i = 0; i < n; i++){
            var rowSum = 0;
            for(var j = 0; j < n; j++)rowSum += abs(A.get([
                i,
                j
            ]));
            infNorm = Math.max(rowSum, infNorm);
        }
        return infNorm;
    }
    /**
   * Find the best parameters for the Pade approximant given
   * the matrix norm and desired accuracy. Returns the first acceptable
   * combination in order of increasing computational load.
   */ function findParams(infNorm, eps) {
        var maxSearchSize = 30;
        for(var k = 0; k < maxSearchSize; k++)for(var q = 0; q <= k; q++){
            var j = k - q;
            if (errorEstimate(infNorm, q, j) < eps) return {
                q: q,
                j: j
            };
        }
        throw new Error('Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)');
    }
    /**
   * Returns the estimated error of the Pade approximant for the given
   * parameters.
   */ function errorEstimate(infNorm, q, j) {
        var qfac = 1;
        for(var i = 2; i <= q; i++)qfac *= i;
        var twoqfac = qfac;
        for(var _i2 = q + 1; _i2 <= 2 * q; _i2++)twoqfac *= _i2;
        var twoqp1fac = twoqfac * (2 * q + 1);
        return 8.0 * Math.pow(infNorm / Math.pow(2, j), 2 * q) * qfac * qfac / (twoqfac * twoqp1fac);
    }
});

});

parcelRegister("gBhx4", function(module, exports) {

$parcel$export(module.exports, "createExpm1", () => $c15db39d4f66558c$export$2b203b63f664bab3);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $eRNhQ = parcelRequire("eRNhQ");
var $c15db39d4f66558c$var$name = 'expm1';
var $c15db39d4f66558c$var$dependencies = [
    'typed',
    'Complex'
];
var $c15db39d4f66558c$export$2b203b63f664bab3 = /* #__PURE__ */ (0, $4eE2e.factory)($c15db39d4f66558c$var$name, $c15db39d4f66558c$var$dependencies, (_ref)=>{
    var { typed: typed, Complex: _Complex } = _ref;
    /**
   * Calculate the value of subtracting 1 from the exponential value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.expm1(x)
   *
   * Examples:
   *
   *    math.expm1(2)                      // returns number 6.38905609893065
   *    math.pow(math.e, 2) - 1            // returns number 6.3890560989306495
   *    math.log(math.expm1(2) + 1)        // returns number 2
   *
   *    math.expm1([1, 2, 3])
   *    // returns Array [
   *    //   1.718281828459045,
   *    //   6.3890560989306495,
   *    //   19.085536923187668
   *    // ]
   *
   * See also:
   *
   *    exp, log, pow
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to apply expm1
   * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
   */ return typed($c15db39d4f66558c$var$name, {
        number: (0, $eRNhQ.expm1Number),
        Complex: function Complex(x) {
            var r = Math.exp(x.re);
            return new _Complex(r * Math.cos(x.im) - 1, r * Math.sin(x.im));
        },
        BigNumber: function BigNumber(x) {
            return x.exp().minus(1);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("hpWEx", function(module, exports) {

$parcel$export(module.exports, "createFactorial", () => $cae244b823e83ef0$export$92c37ad44e3d0481);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");
var $cae244b823e83ef0$var$name = 'factorial';
var $cae244b823e83ef0$var$dependencies = [
    'typed',
    'gamma'
];
var $cae244b823e83ef0$export$92c37ad44e3d0481 = /* #__PURE__ */ (0, $4eE2e.factory)($cae244b823e83ef0$var$name, $cae244b823e83ef0$var$dependencies, (_ref)=>{
    var { typed: typed, gamma: gamma } = _ref;
    /**
   * Compute the factorial of a value
   *
   * Factorial only supports an integer value as argument.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.factorial(n)
   *
   * Examples:
   *
   *    math.factorial(5)    // returns 120
   *    math.factorial(3)    // returns 6
   *
   * See also:
   *
   *    combinations, combinationsWithRep, gamma, permutations
   *
   * @param {number | BigNumber | Array | Matrix} n   An integer number
   * @return {number | BigNumber | Array | Matrix}    The factorial of `n`
   */ return typed($cae244b823e83ef0$var$name, {
        number: function number(n) {
            if (n < 0) throw new Error('Value must be non-negative');
            return gamma(n + 1);
        },
        BigNumber: function BigNumber(n) {
            if (n.isNegative()) throw new Error('Value must be non-negative');
            return gamma(n.plus(1));
        },
        'Array | Matrix': function ArrayMatrix(n) {
            return (0, $9nwyh.deepMap)(n, this);
        }
    });
});

});

parcelRegister("c6ghs", function(module, exports) {

$parcel$export(module.exports, "createFibonacciHeapClass", () => $8cf2ac91946e6246$export$3143a09e27a84c41);

var $4eE2e = parcelRequire("4eE2e");
var $8cf2ac91946e6246$var$name = 'FibonacciHeap';
var $8cf2ac91946e6246$var$dependencies = [
    'smaller',
    'larger'
];
var $8cf2ac91946e6246$export$3143a09e27a84c41 = /* #__PURE__ */ (0, $4eE2e.factory)($8cf2ac91946e6246$var$name, $8cf2ac91946e6246$var$dependencies, (_ref)=>{
    var { smaller: smaller, larger: larger } = _ref;
    var oneOverLogPhi = 1.0 / Math.log((1.0 + Math.sqrt(5.0)) / 2.0);
    /**
   * Fibonacci Heap implementation, used interally for Matrix math.
   * @class FibonacciHeap
   * @constructor FibonacciHeap
   */ function FibonacciHeap() {
        if (!(this instanceof FibonacciHeap)) throw new SyntaxError('Constructor must be called with the new operator');
         // initialize fields
        this._minimum = null;
        this._size = 0;
    }
    /**
   * Attach type information
   */ FibonacciHeap.prototype.type = 'FibonacciHeap';
    FibonacciHeap.prototype.isFibonacciHeap = true;
    /**
   * Inserts a new data element into the heap. No heap consolidation is
   * performed at this time, the new node is simply inserted into the root
   * list of this heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.insert = function(key, value) {
        // create node
        var node = {
            key: key,
            value: value,
            degree: 0
        }; // check we have a node in the minimum
        if (this._minimum) {
            // minimum node
            var minimum = this._minimum; // update left & right of node
            node.left = minimum;
            node.right = minimum.right;
            minimum.right = node;
            node.right.left = node; // update minimum node in heap if needed
            if (smaller(key, minimum.key)) // node has a smaller key, use it as minimum
            this._minimum = node;
        } else {
            // set left & right
            node.left = node;
            node.right = node; // this is the first node
            this._minimum = node;
        } // increment number of nodes in heap
        this._size++; // return node
        return node;
    };
    /**
   * Returns the number of nodes in heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.size = function() {
        return this._size;
    };
    /**
   * Removes all elements from this heap.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.clear = function() {
        this._minimum = null;
        this._size = 0;
    };
    /**
   * Returns true if the heap is empty, otherwise false.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.isEmpty = function() {
        return this._size === 0;
    };
    /**
   * Extracts the node with minimum key from heap. Amortized running
   * time: O(log n).
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.extractMinimum = function() {
        // node to remove
        var node = this._minimum; // check we have a minimum
        if (node === null) return node;
         // current minimum
        var minimum = this._minimum; // get number of children
        var numberOfChildren = node.degree; // pointer to the first child
        var x = node.child; // for each child of node do...
        while(numberOfChildren > 0){
            // store node in right side
            var tempRight = x.right; // remove x from child list
            x.left.right = x.right;
            x.right.left = x.left; // add x to root list of heap
            x.left = minimum;
            x.right = minimum.right;
            minimum.right = x;
            x.right.left = x; // set Parent[x] to null
            x.parent = null;
            x = tempRight;
            numberOfChildren--;
        } // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left; // update minimum
        if (node === node.right) // empty
        minimum = null;
        else {
            // update minimum
            minimum = node.right; // we need to update the pointer to the root with minimum key
            minimum = _findMinimumNode(minimum, this._size);
        } // decrement size of heap
        this._size--; // update minimum
        this._minimum = minimum; // return node
        return node;
    };
    /**
   * Removes a node from the heap given the reference to the node. The trees
   * in the heap will be consolidated, if necessary. This operation may fail
   * to remove the correct element if there are nodes with key value -Infinity.
   * Running time: O(log n) amortized.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.remove = function(node) {
        // decrease key value
        this._minimum = _decreaseKey(this._minimum, node, -1); // remove the smallest
        this.extractMinimum();
    };
    /**
   * Decreases the key value for a heap node, given the new value to take on.
   * The structure of the heap may be changed and will not be consolidated.
   * Running time: O(1) amortized.
   * @memberof FibonacciHeap
   */ function _decreaseKey(minimum, node, key) {
        // set node key
        node.key = key; // get parent node
        var parent = node.parent;
        if (parent && smaller(node.key, parent.key)) {
            // remove node from parent
            _cut(minimum, node, parent); // remove all nodes from parent to the root parent
            _cascadingCut(minimum, parent);
        } // update minimum node if needed
        if (smaller(node.key, minimum.key)) minimum = node;
         // return minimum
        return minimum;
    }
    /**
   * The reverse of the link operation: removes node from the child list of parent.
   * This method assumes that min is non-null. Running time: O(1).
   * @memberof FibonacciHeap
   */ function _cut(minimum, node, parent) {
        // remove node from parent children and decrement Degree[parent]
        node.left.right = node.right;
        node.right.left = node.left;
        parent.degree--; // reset y.child if necessary
        if (parent.child === node) parent.child = node.right;
         // remove child if degree is 0
        if (parent.degree === 0) parent.child = null;
         // add node to root list of heap
        node.left = minimum;
        node.right = minimum.right;
        minimum.right = node;
        node.right.left = node; // set parent[node] to null
        node.parent = null; // set mark[node] to false
        node.mark = false;
    }
    /**
   * Performs a cascading cut operation. This cuts node from its parent and then
   * does the same for its parent, and so on up the tree.
   * Running time: O(log n); O(1) excluding the recursion.
   * @memberof FibonacciHeap
   */ function _cascadingCut(minimum, node) {
        // store parent node
        var parent = node.parent; // if there's a parent...
        if (!parent) return;
         // if node is unmarked, set it marked
        if (!node.mark) node.mark = true;
        else {
            // it's marked, cut it from parent
            _cut(minimum, node, parent); // cut its parent as well
            _cascadingCut(parent);
        }
    }
    /**
   * Make the first node a child of the second one. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ var _linkNodes = function _linkNodes(node, parent) {
        // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left; // make node a Child of parent
        node.parent = parent;
        if (!parent.child) {
            parent.child = node;
            node.right = node;
            node.left = node;
        } else {
            node.left = parent.child;
            node.right = parent.child.right;
            parent.child.right = node;
            node.right.left = node;
        } // increase degree[parent]
        parent.degree++; // set mark[node] false
        node.mark = false;
    };
    function _findMinimumNode(minimum, size) {
        // to find trees of the same degree efficiently we use an array of length O(log n) in which we keep a pointer to one root of each degree
        var arraySize = Math.floor(Math.log(size) * oneOverLogPhi) + 1; // create list with initial capacity
        var array = new Array(arraySize); // find the number of root nodes.
        var numRoots = 0;
        var x = minimum;
        if (x) {
            numRoots++;
            x = x.right;
            while(x !== minimum){
                numRoots++;
                x = x.right;
            }
        } // vars
        var y; // For each node in root list do...
        while(numRoots > 0){
            // access this node's degree..
            var d = x.degree; // get next node
            var next = x.right; // check if there is a node already in array with the same degree
            while(true){
                // get node with the same degree is any
                y = array[d];
                if (!y) break;
                 // make one node with the same degree a child of the other, do this based on the key value.
                if (larger(x.key, y.key)) {
                    var temp = y;
                    y = x;
                    x = temp;
                } // make y a child of x
                _linkNodes(y, x); // we have handled this degree, go to next one.
                array[d] = null;
                d++;
            } // save this node for later when we might encounter another of the same degree.
            array[d] = x; // move forward through list.
            x = next;
            numRoots--;
        } // Set min to null (effectively losing the root list) and reconstruct the root list from the array entries in array[].
        minimum = null; // loop nodes in array
        for(var i = 0; i < arraySize; i++){
            // get current node
            y = array[i];
            if (!y) continue;
             // check if we have a linked list
            if (minimum) {
                // First remove node from root list.
                y.left.right = y.right;
                y.right.left = y.left; // now add to root list, again.
                y.left = minimum;
                y.right = minimum.right;
                minimum.right = y;
                y.right.left = y; // check if this is a new min.
                if (smaller(y.key, minimum.key)) minimum = y;
            } else minimum = y;
        }
        return minimum;
    }
    return FibonacciHeap;
}, {
    isClass: true
});

});

parcelRegister("eP5Jr", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $acaa465469cedebd$export$5d81789ff4aeccdf);

var $10UPF = parcelRequire("10UPF");

var $jHpUf = parcelRequire("jHpUf");

var $4eE2e = parcelRequire("4eE2e");
var $acaa465469cedebd$var$name = 'filter';
var $acaa465469cedebd$var$dependencies = [
    'typed'
];
var $acaa465469cedebd$export$5d81789ff4aeccdf = /* #__PURE__ */ (0, $4eE2e.factory)($acaa465469cedebd$var$name, $acaa465469cedebd$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Filter the items in an array or one dimensional matrix.
   *
   * Syntax:
   *
   *    math.filter(x, test)
   *
   * Examples:
   *
   *    function isPositive (x) {
   *      return x > 0
   *    }
   *    math.filter([6, -2, -1, 4, 3], isPositive) // returns [6, 4, 3]
   *
   *    math.filter(["23", "foo", "100", "55", "bar"], /[0-9]+/) // returns ["23", "100", "55"]
   *
   * See also:
   *
   *    forEach, map, sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to filter
   * @param {Function | RegExp} test
   *        A function or regular expression to test items.
   *        All entries for which `test` returns true are returned.
   *        When `test` is a function, it is invoked with three parameters:
   *        the value of the element, the index of the element, and the
   *        matrix/array being traversed. The function must return a boolean.
   * @return {Matrix | Array} Returns the filtered matrix.
   */ return typed('filter', {
        'Array, function': $acaa465469cedebd$var$_filterCallback,
        'Matrix, function': function MatrixFunction(x, test) {
            return x.create($acaa465469cedebd$var$_filterCallback(x.toArray(), test));
        },
        'Array, RegExp': (0, $10UPF.filterRegExp),
        'Matrix, RegExp': function MatrixRegExp(x, test) {
            return x.create((0, $10UPF.filterRegExp)(x.toArray(), test));
        }
    });
});
/**
 * Filter values in a callback given a callback function
 * @param {Array} x
 * @param {Function} callback
 * @return {Array} Returns the filtered array
 * @private
 */ function $acaa465469cedebd$var$_filterCallback(x, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $jHpUf.maxArgumentCount)(callback);
    return (0, $10UPF.filter)(x, function(value, index, array) {
        // invoke the callback function with the right number of arguments
        if (args === 1) return callback(value);
        else if (args === 2) return callback(value, [
            index
        ]);
        else // 3 or -1
        return callback(value, [
            index
        ], array);
    });
}

});

parcelRegister("ghUlP", function(module, exports) {

$parcel$export(module.exports, "createFix", () => $bdb9f1ff8d9f907f$export$3ed06081b8a4ee6);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $laEuG = parcelRequire("laEuG");
var $bdb9f1ff8d9f907f$var$name = 'fix';
var $bdb9f1ff8d9f907f$var$dependencies = [
    'typed',
    'Complex',
    'matrix',
    'ceil',
    'floor'
];
var $bdb9f1ff8d9f907f$export$3ed06081b8a4ee6 = /* #__PURE__ */ (0, $4eE2e.factory)($bdb9f1ff8d9f907f$var$name, $bdb9f1ff8d9f907f$var$dependencies, (_ref)=>{
    var { typed: typed, Complex: _Complex, matrix: matrix, ceil: ceil, floor: floor } = _ref;
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Round a value towards zero.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.fix(x)
   *
   * Examples:
   *
   *    math.fix(3.2)                // returns number 3
   *    math.fix(3.8)                // returns number 3
   *    math.fix(-4.2)               // returns number -4
   *    math.fix(-4.7)               // returns number -4
   *
   *    math.fix(3.12, 1)                // returns number 3.1
   *    math.fix(3.18, 1)                // returns number 3.1
   *    math.fix(-4.12, 1)               // returns number -4.1
   *    math.fix(-4.17, 1)               // returns number -4.1
   *
   *    const c = math.complex(3.22, -2.78)
   *    math.fix(c)                  // returns Complex 3 - 2i
   *    math.fix(c, 1)               // returns Complex 3.2 - 2.7i
   *
   *    math.fix([3.2, 3.8, -4.7])      // returns Array [3, 3, -4]
   *    math.fix([3.2, 3.8, -4.7], 1)   // returns Array [3.2, 3.8, -4.7]
   *
   * See also:
   *
   *    ceil, floor, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x    Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                             Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix}     Rounded value
   */ return typed('fix', {
        number: function number(x) {
            return x > 0 ? floor(x) : ceil(x);
        },
        'number, number | BigNumber': function numberNumberBigNumber(x, n) {
            return x > 0 ? floor(x, n) : ceil(x, n);
        },
        Complex: function Complex(x) {
            return new _Complex(x.re > 0 ? Math.floor(x.re) : Math.ceil(x.re), x.im > 0 ? Math.floor(x.im) : Math.ceil(x.im));
        },
        'Complex, number | BigNumber': function ComplexNumberBigNumber(x, n) {
            return new _Complex(x.re > 0 ? floor(x.re, n) : ceil(x.re, n), x.im > 0 ? floor(x.im, n) : ceil(x.im, n));
        },
        BigNumber: function BigNumber(x) {
            return x.isNegative() ? ceil(x) : floor(x);
        },
        'BigNumber, number | BigNumber': function BigNumberNumberBigNumber(x, n) {
            return x.isNegative() ? ceil(x, n) : floor(x, n);
        },
        Fraction: function Fraction(x) {
            return x.s < 0 ? x.ceil() : x.floor();
        },
        'Fraction, number | BigNumber': function FractionNumberBigNumber(x, n) {
            return x.s < 0 ? x.ceil(n) : x.floor(n);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since fix(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        },
        'Array | Matrix, number | BigNumber': function ArrayMatrixNumberBigNumber(x, n) {
            // deep map collection, skip zeros since fix(0) = 0
            return (0, $9nwyh.deepMap)(x, (i)=>this(i, n), true);
        },
        'number | Complex | BigNumber, Array': function numberComplexBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});

});

parcelRegister("4UXXo", function(module, exports) {

$parcel$export(module.exports, "createFlatten", () => $394ae69ccbb288cf$export$107988e3ee9f3d12);

var $4mYv9 = parcelRequire("4mYv9");

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $394ae69ccbb288cf$var$name = 'flatten';
var $394ae69ccbb288cf$var$dependencies = [
    'typed',
    'matrix'
];
var $394ae69ccbb288cf$export$107988e3ee9f3d12 = /* #__PURE__ */ (0, $4eE2e.factory)($394ae69ccbb288cf$var$name, $394ae69ccbb288cf$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Flatten a multi dimensional matrix into a single dimensional matrix.
   * It is guaranteed to always return a clone of the argument.
   *
   * Syntax:
   *
   *    math.flatten(x)
   *
   * Examples:
   *
   *    math.flatten([[1,2], [3,4]])   // returns [1, 2, 3, 4]
   *
   * See also:
   *
   *    concat, resize, size, squeeze
   *
   * @param {Matrix | Array} x   Matrix to be flattened
   * @return {Matrix | Array} Returns the flattened matrix
   */ return typed($394ae69ccbb288cf$var$name, {
        Array: function Array(x) {
            return (0, $10UPF.flatten)((0, $4mYv9.clone)(x));
        },
        Matrix: function Matrix(x) {
            var flat = (0, $10UPF.flatten)((0, $4mYv9.clone)(x.toArray())); // TODO: return the same matrix type as x
            return matrix(flat);
        }
    });
});

});

parcelRegister("jbGYt", function(module, exports) {

$parcel$export(module.exports, "createFloor", () => $df8061391e3cd7c5$export$e04e4803a9128c9b);

var $5Pv9S = parcelRequire("5Pv9S");

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $6egKm = parcelRequire("6egKm");

var $iV3Fc = parcelRequire("iV3Fc");

var $hXAgg = parcelRequire("hXAgg");

var $laEuG = parcelRequire("laEuG");
var $df8061391e3cd7c5$var$name = 'floor';
var $df8061391e3cd7c5$var$dependencies = [
    'typed',
    'config',
    'round',
    'matrix',
    'equalScalar'
];
var $df8061391e3cd7c5$export$e04e4803a9128c9b = /* #__PURE__ */ (0, $4eE2e.factory)($df8061391e3cd7c5$var$name, $df8061391e3cd7c5$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, round: round, matrix: matrix, equalScalar: equalScalar } = _ref;
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Round a value towards minus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.floor(x)
   *    math.floor(x, n)
   *
   * Examples:
   *
   *    math.floor(3.2)              // returns number 3
   *    math.floor(3.8)              // returns number 3
   *    math.floor(-4.2)             // returns number -5
   *    math.floor(-4.7)             // returns number -5
   *
   *    math.floor(3.212, 2)          // returns number 3.21
   *    math.floor(3.288, 2)          // returns number 3.28
   *    math.floor(-4.212, 2)         // returns number -4.22
   *    math.floor(-4.782, 2)         // returns number -4.79
   *
   *    const c = math.complex(3.24, -2.71)
   *    math.floor(c)                 // returns Complex 3 - 3i
   *    math.floor(c, 1)              // returns Complex 3.2 - 2.8i
   *
   *    math.floor([3.2, 3.8, -4.7])       // returns Array [3, 3, -5]
   *    math.floor([3.21, 3.82, -4.71], 1)  // returns Array [3.2, 3.8, -4.8]
   *
   * See also:
   *
   *    ceil, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ return typed('floor', {
        number: function number(x) {
            if ((0, $6egKm.nearlyEqual)(x, round(x), config.epsilon)) return round(x);
            else return Math.floor(x);
        },
        'number, number': function numberNumber(x, n) {
            if ((0, $6egKm.nearlyEqual)(x, round(x, n), config.epsilon)) return round(x, n);
            else {
                var [number, exponent] = "".concat(x, "e").split('e');
                var result = Math.floor(Number("".concat(number, "e").concat(Number(exponent) + n)));
                [number, exponent] = "".concat(result, "e").split('e');
                return Number("".concat(number, "e").concat(Number(exponent) - n));
            }
        },
        Complex: function Complex(x) {
            return x.floor();
        },
        'Complex, number': function ComplexNumber(x, n) {
            return x.floor(n);
        },
        BigNumber: function BigNumber(x) {
            if ((0, $iV3Fc.nearlyEqual)(x, round(x), config.epsilon)) return round(x);
            else return x.floor();
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, n) {
            if ((0, $iV3Fc.nearlyEqual)(x, round(x, n), config.epsilon)) return round(x, n);
            else return x.toDecimalPlaces(n.toNumber(), (0, (/*@__PURE__*/$parcel$interopDefault($5Pv9S))).ROUND_FLOOR);
        },
        Fraction: function Fraction(x) {
            return x.floor();
        },
        'Fraction, number': function FractionNumber(x, n) {
            return x.floor(n);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since floor(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        },
        'Array | Matrix, number': function ArrayMatrixNumber(x, n) {
            // deep map collection, skip zeros since ceil(0) = 0
            return (0, $9nwyh.deepMap)(x, (i)=>this(i, n), true);
        },
        'SparseMatrix, number | BigNumber': function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, number | BigNumber': function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        'number | Complex | BigNumber, Array': function numberComplexBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});

});

parcelRegister("hqqnu", function(module, exports) {

$parcel$export(module.exports, "createForEach", () => $caf95372d2d627d5$export$a5218987e0811e05);

var $jHpUf = parcelRequire("jHpUf");

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $caf95372d2d627d5$var$name = 'forEach';
var $caf95372d2d627d5$var$dependencies = [
    'typed'
];
var $caf95372d2d627d5$export$a5218987e0811e05 = /* #__PURE__ */ (0, $4eE2e.factory)($caf95372d2d627d5$var$name, $caf95372d2d627d5$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterate over all elements of a matrix/array, and executes the given callback function.
   *
   * Syntax:
   *
   *    math.forEach(x, callback)
   *
   * Examples:
   *
   *    math.forEach([1, 2, 3], function(value) {
   *      console.log(value)
   *    })
   *    // outputs 1, 2, 3
   *
   * See also:
   *
   *    filter, map, sort
   *
   * @param {Matrix | Array} x    The matrix to iterate on.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix/array being traversed.
   */ return typed($caf95372d2d627d5$var$name, {
        'Array, function': $caf95372d2d627d5$var$_forEach,
        'Matrix, function': function MatrixFunction(x, callback) {
            return x.forEach(callback);
        }
    });
});
/**
 * forEach for a multi dimensional array
 * @param {Array} array
 * @param {Function} callback
 * @private
 */ function $caf95372d2d627d5$var$_forEach(array, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $jHpUf.maxArgumentCount)(callback);
    var recurse = function recurse(value, index) {
        if (Array.isArray(value)) (0, $10UPF.forEach)(value, function(child, i) {
            // we create a copy of the index array and append the new index value
            recurse(child, index.concat(i));
        });
        else {
            // invoke the callback function with the right number of arguments
            if (args === 1) callback(value);
            else if (args === 2) callback(value, index);
            else // 3 or -1
            callback(value, index, array);
        }
    };
    recurse(array, []);
}

});

parcelRegister("4J1dU", function(module, exports) {

$parcel$export(module.exports, "createFormat", () => $370c505077ff4e7a$export$abf0d9399b60f9bb);

var $aEppI = parcelRequire("aEppI");

var $4eE2e = parcelRequire("4eE2e");
var $370c505077ff4e7a$var$name = 'format';
var $370c505077ff4e7a$var$dependencies = [
    'typed'
];
var $370c505077ff4e7a$export$abf0d9399b60f9bb = /* #__PURE__ */ (0, $4eE2e.factory)($370c505077ff4e7a$var$name, $370c505077ff4e7a$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Format a value of any type into a string.
   *
   * Syntax:
   *
   *    math.format(value)
   *    math.format(value, options)
   *    math.format(value, precision)
   *    math.format(value, callback)
   *
   * Where:
   *
   *  - `value: *`
   *    The value to be formatted
   *  - `options: Object`
   *    An object with formatting options. Available options:
   *    - `notation: string`
   *      Number notation. Choose from:
   *      - 'fixed'
   *        Always use regular number notation.
   *        For example '123.40' and '14000000'
   *      - 'exponential'
   *        Always use exponential notation.
   *        For example '1.234e+2' and '1.4e+7'
   *      - 'engineering'
   *        Always use engineering notation: always have exponential notation,
   *        and select the exponent to be a multiple of 3.
   *        For example '123.4e+0' and '14.0e+6'
   *      - 'auto' (default)
   *        Regular number notation for numbers having an absolute value between
   *        `lower` and `upper` bounds, and uses exponential notation elsewhere.
   *        Lower bound is included, upper bound is excluded.
   *        For example '123.4' and '1.4e7'.
   *      - 'bin', 'oct, or 'hex'
   *        Format the number using binary, octal, or hexadecimal notation.
   *        For example '0b1101' and '0x10fe'.
   *    - `wordSize: number`
   *      The word size in bits to use for formatting in binary, octal, or
   *      hexadecimal notation. To be used only with 'bin', 'oct', or 'hex'
   *      values for 'notation' option. When this option is defined the value
   *      is formatted as a signed twos complement integer of the given word
   *      size and the size suffix is appended to the output.
   *      For example format(-1, {notation: 'hex', wordSize: 8}) === '0xffi8'.
   *      Default value is undefined.
   *    - `precision: number`
   *      A number between 0 and 16 to round the digits of the number. In case
   *      of notations 'exponential', 'engineering', and 'auto', `precision`
   *      defines the total number of significant digits returned.
   *      In case of notation 'fixed', `precision` defines the number of
   *      significant digits after the decimal point.
   *      `precision` is undefined by default.
   *    - `lowerExp: number`
   *      Exponent determining the lower boundary for formatting a value with
   *      an exponent when `notation='auto`. Default value is `-3`.
   *    - `upperExp: number`
   *      Exponent determining the upper boundary for formatting a value with
   *      an exponent when `notation='auto`. Default value is `5`.
   *    - `fraction: string`. Available values: 'ratio' (default) or 'decimal'.
   *      For example `format(fraction(1, 3))` will output '1/3' when 'ratio' is
   *      configured, and will output `0.(3)` when 'decimal' is configured.
   * - `callback: function`
   *   A custom formatting function, invoked for all numeric elements in `value`,
   *   for example all elements of a matrix, or the real and imaginary
   *   parts of a complex number. This callback can be used to override the
   *   built-in numeric notation with any type of formatting. Function `callback`
   *   is called with `value` as parameter and must return a string.
   *
   * When `value` is an Object:
   *
   * - When the object contains a property `format` being a function, this function
   *   is invoked as `value.format(options)` and the result is returned.
   * - When the object has its own `toString` method, this method is invoked
   *   and the result is returned.
   * - In other cases the function will loop over all object properties and
   *   return JSON object notation like '{"a": 2, "b": 3}'.
   *
   * When value is a function:
   *
   * - When the function has a property `syntax`, it returns this
   *   syntax description.
   * - In other cases, a string `'function'` is returned.
   *
   * Examples:
   *
   *    math.format(6.4)                                        // returns '6.4'
   *    math.format(1240000)                                    // returns '1.24e6'
   *    math.format(1/3)                                        // returns '0.3333333333333333'
   *    math.format(1/3, 3)                                     // returns '0.333'
   *    math.format(21385, 2)                                   // returns '21000'
   *    math.format(12e8, {notation: 'fixed'})                  // returns '1200000000'
   *    math.format(2.3,  {notation: 'fixed', precision: 4})    // returns '2.3000'
   *    math.format(52.8, {notation: 'exponential'})            // returns '5.28e+1'
   *    math.format(12400,{notation: 'engineering'})            // returns '12.400e+3'
   *    math.format(2000, {lowerExp: -2, upperExp: 2})          // returns '2e+3'
   *
   *    function formatCurrency(value) {
   *      // return currency notation with two digits:
   *      return '$' + value.toFixed(2)
   *
   *      // you could also use math.format inside the callback:
   *      // return '$' + math.format(value, {notation: 'fixed', precision: 2})
   *    }
   *    math.format([2.1, 3, 0.016], formatCurrency}            // returns '[$2.10, $3.00, $0.02]'
   *
   * See also:
   *
   *    print
   *
   * @param {*} value                               Value to be stringified
   * @param {Object | Function | number} [options]  Formatting options
   * @return {string} The formatted value
   */ return typed($370c505077ff4e7a$var$name, {
        any: (0, $aEppI.format),
        'any, Object | function | number': (0, $aEppI.format)
    });
});

});

parcelRegister("5tB88", function(module, exports) {

$parcel$export(module.exports, "createFraction", () => $3fcc767e7c5eae6a$export$de147ca8498e0312);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $3fcc767e7c5eae6a$var$name = 'fraction';
var $3fcc767e7c5eae6a$var$dependencies = [
    'typed',
    'Fraction'
];
var $3fcc767e7c5eae6a$export$de147ca8498e0312 = /* #__PURE__ */ (0, $4eE2e.factory)($3fcc767e7c5eae6a$var$name, $3fcc767e7c5eae6a$var$dependencies, (_ref)=>{
    var { typed: typed, Fraction: Fraction } = _ref;
    /**
   * Create a fraction convert a value to a fraction.
   *
   * Syntax:
   *     math.fraction(numerator, denominator)
   *     math.fraction({n: numerator, d: denominator})
   *     math.fraction(matrix: Array | Matrix)         Turn all matrix entries
   *                                                   into fractions
   *
   * Examples:
   *
   *     math.fraction(1, 3)
   *     math.fraction('2/3')
   *     math.fraction({n: 2, d: 3})
   *     math.fraction([0.2, 0.25, 1.25])
   *
   * See also:
   *
   *    bignumber, number, string, unit
   *
   * @param {number | string | Fraction | BigNumber | Array | Matrix} [args]
   *            Arguments specifying the numerator and denominator of
   *            the fraction
   * @return {Fraction | Array | Matrix} Returns a fraction
   */ return typed('fraction', {
        number: function number(x) {
            if (!isFinite(x) || isNaN(x)) throw new Error(x + ' cannot be represented as a fraction');
            return new Fraction(x);
        },
        string: function string(x) {
            return new Fraction(x);
        },
        'number, number': function numberNumber(numerator, denominator) {
            return new Fraction(numerator, denominator);
        },
        null: function _null(x) {
            return new Fraction(0);
        },
        BigNumber: function BigNumber(x) {
            return new Fraction(x.toString());
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Object: function Object(x) {
            return new Fraction(x);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("8BMAm", function(module, exports) {

$parcel$export(module.exports, "createFractionClass", () => $6447777a33154665$export$c317f082100fca89);

var $aeGWs = parcelRequire("aeGWs");

var $4eE2e = parcelRequire("4eE2e");
var $6447777a33154665$var$name = 'Fraction';
var $6447777a33154665$var$dependencies = [];
var $6447777a33154665$export$c317f082100fca89 = /* #__PURE__ */ (0, $4eE2e.factory)($6447777a33154665$var$name, $6447777a33154665$var$dependencies, ()=>{
    /**
   * Attach type information
   */ (0, (/*@__PURE__*/$parcel$interopDefault($aeGWs))).prototype.type = 'Fraction';
    (0, (/*@__PURE__*/$parcel$interopDefault($aeGWs))).prototype.isFraction = true;
    /**
   * Get a JSON representation of a Fraction containing type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Fraction", "n": 3, "d": 8}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($aeGWs))).prototype.toJSON = function() {
        return {
            mathjs: 'Fraction',
            n: this.s * this.n,
            d: this.d
        };
    };
    /**
   * Instantiate a Fraction from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "Fraction", "n": 3, "d": 8}`
   * @return {BigNumber}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($aeGWs))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($aeGWs)))(json);
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($aeGWs));
}, {
    isClass: true
});

});
parcelRegister("aeGWs", function(module, exports) {
/**
 * @license Fraction.js v4.3.7 31/08/2023
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2023, Robert Eisele (robert@raw.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/ /**
 *
 * This class offers the possibility to calculate fractions.
 * You can pass a fraction in different formats. Either as array, as double, as string or as an integer.
 *
 * Array/Object form
 * [ 0 => <numerator>, 1 => <denominator> ]
 * [ n => <numerator>, d => <denominator> ]
 *
 * Integer form
 * - Single integer value
 *
 * Double form
 * - Single double value
 *
 * String form
 * 123.456 - a simple double
 * 123/456 - a string fraction
 * 123.'456' - a double with repeating decimal places
 * 123.(456) - synonym
 * 123.45'6' - a double with repeating last place
 * 123.45(6) - synonym
 *
 * Example:
 *
 * var f = new Fraction("9.4'31'");
 * f.mul([-4, 3]).div(4.9);
 *
 */ (function(root) {
    "use strict";
    // Maximum search depth for cyclic rational numbers. 2000 should be more than enough.
    // Example: 1/7 = 0.(142857) has 6 repeating decimal places.
    // If MAX_CYCLE_LEN gets reduced, long cycles will not be detected and toString() only gets the first 10 digits
    var MAX_CYCLE_LEN = 2000;
    // Parsed data to avoid calling "new" all the time
    var P = {
        "s": 1,
        "n": 0,
        "d": 1
    };
    function assign(n, s) {
        if (isNaN(n = parseInt(n, 10))) throw InvalidParameter();
        return n * s;
    }
    // Creates a new Fraction internally without the need of the bulky constructor
    function newFraction(n, d) {
        if (d === 0) throw DivisionByZero();
        var f = Object.create(Fraction.prototype);
        f["s"] = n < 0 ? -1 : 1;
        n = n < 0 ? -n : n;
        var a = gcd(n, d);
        f["n"] = n / a;
        f["d"] = d / a;
        return f;
    }
    function factorize(num) {
        var factors = {};
        var n = num;
        var i = 2;
        var s = 4;
        while(s <= n){
            while(n % i === 0){
                n /= i;
                factors[i] = (factors[i] || 0) + 1;
            }
            s += 1 + 2 * i++;
        }
        if (n !== num) {
            if (n > 1) factors[n] = (factors[n] || 0) + 1;
        } else factors[num] = (factors[num] || 0) + 1;
        return factors;
    }
    var parse = function(p1, p2) {
        var n = 0, d = 1, s = 1;
        var v = 0, w = 0, x = 0, y = 1, z = 1;
        var A = 0, B = 1;
        var C = 1, D = 1;
        var N = 10000000;
        var M;
        if (p1 === undefined || p1 === null) ;
        else if (p2 !== undefined) {
            n = p1;
            d = p2;
            s = n * d;
            if (n % 1 !== 0 || d % 1 !== 0) throw NonIntegerParameter();
        } else switch(typeof p1){
            case "object":
                if ("d" in p1 && "n" in p1) {
                    n = p1["n"];
                    d = p1["d"];
                    if ("s" in p1) n *= p1["s"];
                } else if (0 in p1) {
                    n = p1[0];
                    if (1 in p1) d = p1[1];
                } else throw InvalidParameter();
                s = n * d;
                break;
            case "number":
                if (p1 < 0) {
                    s = p1;
                    p1 = -p1;
                }
                if (p1 % 1 === 0) n = p1;
                else if (p1 > 0) {
                    if (p1 >= 1) {
                        z = Math.pow(10, Math.floor(1 + Math.log(p1) / Math.LN10));
                        p1 /= z;
                    }
                    // Using Farey Sequences
                    // http://www.johndcook.com/blog/2010/10/20/best-rational-approximation/
                    while(B <= N && D <= N){
                        M = (A + C) / (B + D);
                        if (p1 === M) {
                            if (B + D <= N) {
                                n = A + C;
                                d = B + D;
                            } else if (D > B) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                            break;
                        } else {
                            if (p1 > M) {
                                A += C;
                                B += D;
                            } else {
                                C += A;
                                D += B;
                            }
                            if (B > N) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                        }
                    }
                    n *= z;
                } else if (isNaN(p1) || isNaN(p2)) d = n = NaN;
                break;
            case "string":
                B = p1.match(/\d+|./g);
                if (B === null) throw InvalidParameter();
                if (B[A] === '-') {
                    s = -1;
                    A++;
                } else if (B[A] === '+') A++;
                if (B.length === A + 1) w = assign(B[A++], s);
                else if (B[A + 1] === '.' || B[A] === '.') {
                    if (B[A] !== '.') v = assign(B[A++], s);
                    A++;
                    // Check for decimal places
                    if (A + 1 === B.length || B[A + 1] === '(' && B[A + 3] === ')' || B[A + 1] === "'" && B[A + 3] === "'") {
                        w = assign(B[A], s);
                        y = Math.pow(10, B[A].length);
                        A++;
                    }
                    // Check for repeating places
                    if (B[A] === '(' && B[A + 2] === ')' || B[A] === "'" && B[A + 2] === "'") {
                        x = assign(B[A + 1], s);
                        z = Math.pow(10, B[A + 1].length) - 1;
                        A += 3;
                    }
                } else if (B[A + 1] === '/' || B[A + 1] === ':') {
                    w = assign(B[A], s);
                    y = assign(B[A + 2], 1);
                    A += 3;
                } else if (B[A + 3] === '/' && B[A + 1] === ' ') {
                    v = assign(B[A], s);
                    w = assign(B[A + 2], s);
                    y = assign(B[A + 4], 1);
                    A += 5;
                }
                if (B.length <= A) {
                    d = y * z;
                    s = /* void */ n = x + d * v + z * w;
                    break;
                }
            default:
                throw InvalidParameter();
        }
        if (d === 0) throw DivisionByZero();
        P["s"] = s < 0 ? -1 : 1;
        P["n"] = Math.abs(n);
        P["d"] = Math.abs(d);
    };
    function modpow(b, e, m) {
        var r = 1;
        for(; e > 0; b = b * b % m, e >>= 1)if (e & 1) r = r * b % m;
        return r;
    }
    function cycleLen(n, d) {
        for(; d % 2 === 0; d /= 2);
        for(; d % 5 === 0; d /= 5);
        if (d === 1) return 0;
        // If we would like to compute really large numbers quicker, we could make use of Fermat's little theorem:
        // 10^(d-1) % d == 1
        // However, we don't need such large numbers and MAX_CYCLE_LEN should be the capstone,
        // as we want to translate the numbers to strings.
        var rem = 10 % d;
        var t = 1;
        for(; rem !== 1; t++){
            rem = rem * 10 % d;
            if (t > MAX_CYCLE_LEN) return 0; // Returning 0 here means that we don't print it as a cyclic number. It's likely that the answer is `d-1`
        }
        return t;
    }
    function cycleStart(n, d, len) {
        var rem1 = 1;
        var rem2 = modpow(10, len, d);
        for(var t = 0; t < 300; t++){
            // Solve 10^s == 10^(s+t) (mod d)
            if (rem1 === rem2) return t;
            rem1 = rem1 * 10 % d;
            rem2 = rem2 * 10 % d;
        }
        return 0;
    }
    function gcd(a, b) {
        if (!a) return b;
        if (!b) return a;
        while(true){
            a %= b;
            if (!a) return b;
            b %= a;
            if (!b) return a;
        }
    }
    /**
   * Module constructor
   *
   * @constructor
   * @param {number|Fraction=} a
   * @param {number=} b
   */ function Fraction(a, b) {
        parse(a, b);
        if (this instanceof Fraction) {
            a = gcd(P["d"], P["n"]); // Abuse variable a
            this["s"] = P["s"];
            this["n"] = P["n"] / a;
            this["d"] = P["d"] / a;
        } else return newFraction(P['s'] * P['n'], P['d']);
    }
    var DivisionByZero = function() {
        return new Error("Division by Zero");
    };
    var InvalidParameter = function() {
        return new Error("Invalid argument");
    };
    var NonIntegerParameter = function() {
        return new Error("Parameters must be integer");
    };
    Fraction.prototype = {
        "s": 1,
        "n": 0,
        "d": 1,
        /**
     * Calculates the absolute value
     *
     * Ex: new Fraction(-4).abs() => 4
     **/ "abs": function() {
            return newFraction(this["n"], this["d"]);
        },
        /**
     * Inverts the sign of the current fraction
     *
     * Ex: new Fraction(-4).neg() => 4
     **/ "neg": function() {
            return newFraction(-this["s"] * this["n"], this["d"]);
        },
        /**
     * Adds two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
     **/ "add": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] + P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Subtracts two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
     **/ "sub": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] - P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Multiplies two rational numbers
     *
     * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
     **/ "mul": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Divides two rational numbers
     *
     * Ex: new Fraction("-17.(345)").inverse().div(3)
     **/ "div": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["d"], this["d"] * P["n"]);
        },
        /**
     * Clones the actual object
     *
     * Ex: new Fraction("-17.(345)").clone()
     **/ "clone": function() {
            return newFraction(this['s'] * this['n'], this['d']);
        },
        /**
     * Calculates the modulo of two rational numbers - a more precise fmod
     *
     * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
     **/ "mod": function(a, b) {
            if (isNaN(this['n']) || isNaN(this['d'])) return new Fraction(NaN);
            if (a === undefined) return newFraction(this["s"] * this["n"] % this["d"], 1);
            parse(a, b);
            if (0 === P["n"] && 0 === this["d"]) throw DivisionByZero();
            /*
       * First silly attempt, kinda slow
       *
       return that["sub"]({
       "n": num["n"] * Math.floor((this.n / this.d) / (num.n / num.d)),
       "d": num["d"],
       "s": this["s"]
       });*/ /*
       * New attempt: a1 / b1 = a2 / b2 * q + r
       * => b2 * a1 = a2 * b1 * q + b1 * b2 * r
       * => (b2 * a1 % a2 * b1) / (b1 * b2)
       */ return newFraction(this["s"] * (P["d"] * this["n"]) % (P["n"] * this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional gcd of two rational numbers
     *
     * Ex: new Fraction(5,8).gcd(3,7) => 1/56
     */ "gcd": function(a, b) {
            parse(a, b);
            // gcd(a / b, c / d) = gcd(a, c) / lcm(b, d)
            return newFraction(gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional lcm of two rational numbers
     *
     * Ex: new Fraction(5,8).lcm(3,7) => 15
     */ "lcm": function(a, b) {
            parse(a, b);
            // lcm(a / b, c / d) = lcm(a, c) / gcd(b, d)
            if (P["n"] === 0 && this["n"] === 0) return newFraction(0, 1);
            return newFraction(P["n"] * this["n"], gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]));
        },
        /**
     * Calculates the ceil of a rational number
     *
     * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
     **/ "ceil": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.ceil(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Calculates the floor of a rational number
     *
     * Ex: new Fraction('4.(3)').floor() => (4 / 1)
     **/ "floor": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.floor(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational numbers
     *
     * Ex: new Fraction('4.(3)').round() => (4 / 1)
     **/ "round": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.round(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational number to a multiple of another rational number
     *
     * Ex: new Fraction('0.9').roundTo("1/8") => 7 / 8
     **/ "roundTo": function(a, b) {
            /*
      k * x/y ≤ a/b < (k+1) * x/y
      ⇔ k ≤ a/b / (x/y) < (k+1)
      ⇔ k = floor(a/b * y/x)
      */ parse(a, b);
            return newFraction(this['s'] * Math.round(this['n'] * P['d'] / (this['d'] * P['n'])) * P['n'], P['d']);
        },
        /**
     * Gets the inverse of the fraction, means numerator and denominator are exchanged
     *
     * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
     **/ "inverse": function() {
            return newFraction(this["s"] * this["d"], this["n"]);
        },
        /**
     * Calculates the fraction to some rational exponent, if possible
     *
     * Ex: new Fraction(-1,2).pow(-3) => -8
     */ "pow": function(a, b) {
            parse(a, b);
            // Trivial case when exp is an integer
            if (P['d'] === 1) {
                if (P['s'] < 0) return newFraction(Math.pow(this['s'] * this["d"], P['n']), Math.pow(this["n"], P['n']));
                else return newFraction(Math.pow(this['s'] * this["n"], P['n']), Math.pow(this["d"], P['n']));
            }
            // Negative roots become complex
            //     (-a/b)^(c/d) = x
            // <=> (-1)^(c/d) * (a/b)^(c/d) = x
            // <=> (cos(pi) + i*sin(pi))^(c/d) * (a/b)^(c/d) = x         # rotate 1 by 180°
            // <=> (cos(c*pi/d) + i*sin(c*pi/d)) * (a/b)^(c/d) = x       # DeMoivre's formula in Q ( https://proofwiki.org/wiki/De_Moivre%27s_Formula/Rational_Index )
            // From which follows that only for c=0 the root is non-complex. c/d is a reduced fraction, so that sin(c/dpi)=0 occurs for d=1, which is handled by our trivial case.
            if (this['s'] < 0) return null;
            // Now prime factor n and d
            var N = factorize(this['n']);
            var D = factorize(this['d']);
            // Exponentiate and take root for n and d individually
            var n = 1;
            var d = 1;
            for(var k in N){
                if (k === '1') continue;
                if (k === '0') {
                    n = 0;
                    break;
                }
                N[k] *= P['n'];
                if (N[k] % P['d'] === 0) N[k] /= P['d'];
                else return null;
                n *= Math.pow(k, N[k]);
            }
            for(var k in D){
                if (k === '1') continue;
                D[k] *= P['n'];
                if (D[k] % P['d'] === 0) D[k] /= P['d'];
                else return null;
                d *= Math.pow(k, D[k]);
            }
            if (P['s'] < 0) return newFraction(d, n);
            return newFraction(n, d);
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "equals": function(a, b) {
            parse(a, b);
            return this["s"] * this["n"] * P["d"] === P["s"] * P["n"] * this["d"]; // Same as compare() === 0
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "compare": function(a, b) {
            parse(a, b);
            var t = this["s"] * this["n"] * P["d"] - P["s"] * P["n"] * this["d"];
            return (0 < t) - (t < 0);
        },
        "simplify": function(eps) {
            if (isNaN(this['n']) || isNaN(this['d'])) return this;
            eps = eps || 0.001;
            var thisABS = this['abs']();
            var cont = thisABS['toContinued']();
            for(var i = 1; i < cont.length; i++){
                var s = newFraction(cont[i - 1], 1);
                for(var k = i - 2; k >= 0; k--)s = s['inverse']()['add'](cont[k]);
                if (Math.abs(s['sub'](thisABS).valueOf()) < eps) return s['mul'](this['s']);
            }
            return this;
        },
        /**
     * Check if two rational numbers are divisible
     *
     * Ex: new Fraction(19.6).divisible(1.5);
     */ "divisible": function(a, b) {
            parse(a, b);
            return !(!(P["n"] * this["d"]) || this["n"] * P["d"] % (P["n"] * this["d"]));
        },
        /**
     * Returns a decimal representation of the fraction
     *
     * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
     **/ 'valueOf': function() {
            return this["s"] * this["n"] / this["d"];
        },
        /**
     * Returns a string-fraction representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toFraction(true) => "4 1/3"
     **/ 'toFraction': function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += '-';
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    str += " ";
                    n %= d;
                }
                str += n;
                str += '/';
                str += d;
            }
            return str;
        },
        /**
     * Returns a latex representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
     **/ 'toLatex': function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += '-';
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    n %= d;
                }
                str += "\\frac{";
                str += n;
                str += '}{';
                str += d;
                str += '}';
            }
            return str;
        },
        /**
     * Returns an array of continued fraction elements
     *
     * Ex: new Fraction("7/8").toContinued() => [0,1,7]
     */ 'toContinued': function() {
            var t;
            var a = this['n'];
            var b = this['d'];
            var res = [];
            if (isNaN(a) || isNaN(b)) return res;
            do {
                res.push(Math.floor(a / b));
                t = a % b;
                a = b;
                b = t;
            }while (a !== 1);
            return res;
        },
        /**
     * Creates a string representation of a fraction with all digits
     *
     * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
     **/ 'toString': function(dec) {
            var N = this["n"];
            var D = this["d"];
            if (isNaN(N) || isNaN(D)) return "NaN";
            dec = dec || 15; // 15 = decimal places when no repetation
            var cycLen = cycleLen(N, D); // Cycle length
            var cycOff = cycleStart(N, D, cycLen); // Cycle start
            var str = this['s'] < 0 ? "-" : "";
            str += N / D | 0;
            N %= D;
            N *= 10;
            if (N) str += ".";
            if (cycLen) {
                for(var i = cycOff; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += "(";
                for(var i = cycLen; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += ")";
            } else for(var i = dec; N && i--;){
                str += N / D | 0;
                N %= D;
                N *= 10;
            }
            return str;
        }
    };
    Object.defineProperty(module.exports, "__esModule", {
        'value': true
    });
    module.exports['default'] = Fraction;
    module.exports = Fraction;
})(module.exports);

});


parcelRegister("k1P9A", function(module, exports) {

$parcel$export(module.exports, "createGamma", () => $e94b94b4d8166bfa$export$115da31fc3cf3d15);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");

var $amvew = parcelRequire("amvew");
var $e94b94b4d8166bfa$var$name = 'gamma';
var $e94b94b4d8166bfa$var$dependencies = [
    'typed',
    'config',
    'multiplyScalar',
    'pow',
    'BigNumber',
    'Complex'
];
var $e94b94b4d8166bfa$export$115da31fc3cf3d15 = /* #__PURE__ */ (0, $4eE2e.factory)($e94b94b4d8166bfa$var$name, $e94b94b4d8166bfa$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, pow: pow, BigNumber: _BigNumber, Complex: _Complex } = _ref;
    /**
   * Compute the gamma function of a value using Lanczos approximation for
   * small values, and an extended Stirling approximation for large values.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.gamma(n)
   *
   * Examples:
   *
   *    math.gamma(5)       // returns 24
   *    math.gamma(-0.5)    // returns -3.5449077018110335
   *    math.gamma(math.i)  // returns -0.15494982830180973 - 0.49801566811835596i
   *
   * See also:
   *
   *    combinations, factorial, permutations
   *
   * @param {number | Array | Matrix} n   A real or complex number
   * @return {number | Array | Matrix}    The gamma of `n`
   */ return typed($e94b94b4d8166bfa$var$name, {
        number: (0, $amvew.gammaNumber),
        Complex: function Complex(n) {
            if (n.im === 0) return this(n.re);
            n = new _Complex(n.re - 1, n.im);
            var x = new _Complex((0, $amvew.gammaP)[0], 0);
            for(var i = 1; i < (0, $amvew.gammaP).length; ++i){
                var real = n.re + i; // x += p[i]/(n+i)
                var den = real * real + n.im * n.im;
                if (den !== 0) {
                    x.re += (0, $amvew.gammaP)[i] * real / den;
                    x.im += -((0, $amvew.gammaP)[i] * n.im) / den;
                } else x.re = (0, $amvew.gammaP)[i] < 0 ? -Infinity : Infinity;
            }
            var t = new _Complex(n.re + (0, $amvew.gammaG) + 0.5, n.im);
            var twoPiSqrt = Math.sqrt(2 * Math.PI);
            n.re += 0.5;
            var result = pow(t, n);
            if (result.im === 0) // sqrt(2*PI)*result
            result.re *= twoPiSqrt;
            else if (result.re === 0) result.im *= twoPiSqrt;
            else {
                result.re *= twoPiSqrt;
                result.im *= twoPiSqrt;
            }
            var r = Math.exp(-t.re); // exp(-t)
            t.re = r * Math.cos(-t.im);
            t.im = r * Math.sin(-t.im);
            return multiplyScalar(multiplyScalar(result, t), x);
        },
        BigNumber: function BigNumber(n) {
            if (n.isInteger()) return n.isNegative() || n.isZero() ? new _BigNumber(Infinity) : bigFactorial(n.minus(1));
            if (!n.isFinite()) return new _BigNumber(n.isNegative() ? NaN : Infinity);
            throw new Error('Integer BigNumber expected');
        },
        'Array | Matrix': function ArrayMatrix(n) {
            return (0, $9nwyh.deepMap)(n, this);
        }
    });
    /**
   * Calculate factorial for a BigNumber
   * @param {BigNumber} n
   * @returns {BigNumber} Returns the factorial of n
   */ function bigFactorial(n) {
        if (n < 8) return new _BigNumber([
            1,
            1,
            2,
            6,
            24,
            120,
            720,
            5040
        ][n]);
        var precision = config.precision + (Math.log(n.toNumber()) | 0);
        var Big = _BigNumber.clone({
            precision: precision
        });
        if (n % 2 === 1) return n.times(bigFactorial(new _BigNumber(n - 1)));
        var p = n;
        var prod = new Big(n);
        var sum = n.toNumber();
        while(p > 2){
            p -= 2;
            sum += p;
            prod = prod.times(sum);
        }
        return new _BigNumber(prod.toPrecision(_BigNumber.precision));
    }
});

});
parcelRegister("amvew", function(module, exports) {

$parcel$export(module.exports, "gammaNumber", () => $01f263ddbb15dcaf$export$da03a9f23c941fae);
$parcel$export(module.exports, "gammaP", () => $01f263ddbb15dcaf$export$4ef5d09c80bf8d89);
$parcel$export(module.exports, "gammaG", () => $01f263ddbb15dcaf$export$c1392abb9fefd3b6);
/* eslint-disable no-loss-of-precision */ 
var $6egKm = parcelRequire("6egKm");

var $78cF8 = parcelRequire("78cF8");
function $01f263ddbb15dcaf$export$da03a9f23c941fae(n) {
    var x;
    if ((0, $6egKm.isInteger)(n)) {
        if (n <= 0) return isFinite(n) ? Infinity : NaN;
        if (n > 171) return Infinity; // Will overflow
        return (0, $78cF8.product)(1, n - 1);
    }
    if (n < 0.5) return Math.PI / (Math.sin(Math.PI * n) * $01f263ddbb15dcaf$export$da03a9f23c941fae(1 - n));
    if (n >= 171.35) return Infinity; // will overflow
    if (n > 85.0) {
        // Extended Stirling Approx
        var twoN = n * n;
        var threeN = twoN * n;
        var fourN = threeN * n;
        var fiveN = fourN * n;
        return Math.sqrt(2 * Math.PI / n) * Math.pow(n / Math.E, n) * (1 + 1 / (12 * n) + 1 / (288 * twoN) - 139 / (51840 * threeN) - 571 / (2488320 * fourN) + 163879 / (209018880 * fiveN) + 5246819 / (75246796800 * fiveN * n));
    }
    --n;
    x = $01f263ddbb15dcaf$export$4ef5d09c80bf8d89[0];
    for(var i = 1; i < $01f263ddbb15dcaf$export$4ef5d09c80bf8d89.length; ++i)x += $01f263ddbb15dcaf$export$4ef5d09c80bf8d89[i] / (n + i);
    var t = n + $01f263ddbb15dcaf$export$c1392abb9fefd3b6 + 0.5;
    return Math.sqrt(2 * Math.PI) * Math.pow(t, n + 0.5) * Math.exp(-t) * x;
}
$01f263ddbb15dcaf$export$da03a9f23c941fae.signature = 'number'; // TODO: comment on the variables g and p
var $01f263ddbb15dcaf$export$c1392abb9fefd3b6 = 4.7421875;
var $01f263ddbb15dcaf$export$4ef5d09c80bf8d89 = [
    0.99999999999999709182,
    57.156235665862923517,
    -59.59796035547549,
    14.136097974741747174,
    -0.4919138160976202,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4,
    -0.00009837447530487956,
    0.15808870322491248884e-3,
    -0.00021026444172410488,
    0.21743961811521264320e-3,
    -0.0001643181065367639,
    0.84418223983852743293e-4,
    -0.000026190838401581408,
    0.36899182659531622704e-5
];

});


parcelRegister("lwYat", function(module, exports) {

$parcel$export(module.exports, "createGcd", () => $facb423a411de927$export$2eb8acc96c598512);

var $4eE2e = parcelRequire("4eE2e");

var $bCo9f = parcelRequire("bCo9f");

var $fF2Gm = parcelRequire("fF2Gm");

var $ecxvm = parcelRequire("ecxvm");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");

var $eRNhQ = parcelRequire("eRNhQ");
var $facb423a411de927$var$name = 'gcd';
var $facb423a411de927$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'BigNumber',
    'DenseMatrix'
];
var $facb423a411de927$export$2eb8acc96c598512 = /* #__PURE__ */ (0, $4eE2e.factory)($facb423a411de927$var$name, $facb423a411de927$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: BigNumber, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $bCo9f.createAlgorithm01)({
        typed: typed
    });
    var algorithm04 = (0, $fF2Gm.createAlgorithm04)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $ecxvm.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculate the greatest common divisor for two or more values or arrays.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.gcd(a, b)
   *    math.gcd(a, b, c, ...)
   *
   * Examples:
   *
   *    math.gcd(8, 12)              // returns 4
   *    math.gcd(-4, 6)              // returns 2
   *    math.gcd(25, 15, -10)        // returns 5
   *
   *    math.gcd([8, -4], [12, 6])   // returns [4, 2]
   *
   * See also:
   *
   *    lcm, xgcd
   *
   * @param {... number | BigNumber | Fraction | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Fraction | Array | Matrix}                           The greatest common divisor
   */ return typed($facb423a411de927$var$name, {
        'number, number': (0, $eRNhQ.gcdNumber),
        'BigNumber, BigNumber': _gcdBigNumber,
        'Fraction, Fraction': function FractionFraction(x, y) {
            return x.gcd(y);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, this);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, number | BigNumber': function SparseMatrixNumberBigNumber(x, y) {
            return algorithm10(x, y, this, false);
        },
        'DenseMatrix, number | BigNumber': function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        'number | BigNumber, SparseMatrix': function numberBigNumberSparseMatrix(x, y) {
            return algorithm10(y, x, this, true);
        },
        'number | BigNumber, DenseMatrix': function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, number | BigNumber': function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'number | BigNumber, Array': function numberBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        },
        // TODO: need a smarter notation here
        'Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber': function ArrayMatrixNumberBigNumberArrayMatrixNumberBigNumberArrayMatrixNumberBigNumber(a, b, args) {
            var res = this(a, b);
            for(var i = 0; i < args.length; i++)res = this(res, args[i]);
            return res;
        }
    });
    /**
   * Calculate gcd for BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns greatest common denominator of a and b
   * @private
   */ function _gcdBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error('Parameters in function gcd must be integer numbers');
         // https://en.wikipedia.org/wiki/Euclidean_algorithm
        var zero = new BigNumber(0);
        while(!b.isZero()){
            var r = a.mod(b);
            a = b;
            b = r;
        }
        return a.lt(zero) ? a.neg() : a;
    }
});

});

parcelRegister("49ajn", function(module, exports) {

$parcel$export(module.exports, "createGetMatrixDataType", () => $3050005996e523e1$export$b83055c9a38abe3c);

var $4eE2e = parcelRequire("4eE2e");

var $10UPF = parcelRequire("10UPF");

var $gs7TF = parcelRequire("gs7TF");
var $3050005996e523e1$var$name = 'getMatrixDataType';
var $3050005996e523e1$var$dependencies = [
    'typed'
];
var $3050005996e523e1$export$b83055c9a38abe3c = /* #__PURE__ */ (0, $4eE2e.factory)($3050005996e523e1$var$name, $3050005996e523e1$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Find the data type of all elements in a matrix or array,
   * for example 'number' if all items are a number and 'Complex' if all values
   * are complex numbers.
   * If a matrix contains more than one data type, it will return 'mixed'.
   *
   * Syntax:
   *
   *    math.getMatrixDataType(x)
   *
   * Examples:
   *
   *    const x = [ [1, 2, 3], [4, 5, 6] ]
   *    const mixedX = [ [1, true], [2, 3] ]
   *    const fractionX = [ [math.fraction(1, 3)], [math.fraction(1, 3] ]
   *    const unitX = [ [math.unit('5cm')], [math.unit('5cm')] ]
   *    const bigNumberX = [ [math.bignumber(1)], [math.bignumber(0)] ]
   *    const sparse = math.sparse(x)
   *    const dense = math.matrix(x)
   *    math.getMatrixDataType(x)   // returns 'number'
   *    math.getMatrixDataType(sparse)   // returns 'number'
   *    math.getMatrixDataType(dense)   // returns 'number'
   *    math.getMatrixDataType(mixedX) // returns 'mixed'
   *    math.getMatrixDataType(fractionX) // returns 'Fraction'
   *    math.getMatrixDataType(unitX) // returns 'Unit'
   *    math.getMatrixDataType(bigNumberX) // return 'BigNumber'
   *
   * See also:
   *  SparseMatrix, DenseMatrix
   *
   * @param {...Matrix | Array} x   The Matrix with values.
   *
   * @return {string} A string representation of the matrix type
   */ return typed($3050005996e523e1$var$name, {
        Array: function Array(x) {
            return (0, $10UPF.getArrayDataType)(x, (0, $gs7TF.typeOf));
        },
        Matrix: function Matrix(x) {
            return x.getDataType();
        }
    });
});

});

parcelRegister("9vJYi", function(module, exports) {

$parcel$export(module.exports, "createHasNumericValue", () => $01c976602b649244$export$acff9f91b891ace6);

var $4eE2e = parcelRequire("4eE2e");
var $01c976602b649244$var$name = 'hasNumericValue';
var $01c976602b649244$var$dependencies = [
    'typed',
    'isNumeric'
];
var $01c976602b649244$export$acff9f91b891ace6 = /* #__PURE__ */ (0, $4eE2e.factory)($01c976602b649244$var$name, $01c976602b649244$var$dependencies, (_ref)=>{
    var { typed: typed, isNumeric: isNumeric } = _ref;
    /**
   * Test whether a value is an numeric value.
   *
   * In case of a string, true is returned if the string contains a numeric value.
   *
   * Syntax:
   *
   *     math.hasNumericValue(x)
   *
   * Examples:
   *
   *    math.hasNumericValue(2)                     // returns true
   *    math.hasNumericValue('2')                   // returns true
   *    math.isNumeric('2')                         // returns false
   *    math.hasNumericValue(0)                     // returns true
   *    math.hasNumericValue(math.bignumber(500))   // returns true
   *    math.hasNumericValue(math.fraction(4))      // returns true
   *    math.hasNumericValue(math.complex('2-4i')   // returns false
   *    math.hasNumericValue([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, isNumeric
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, `Boolean`, or a `String` containing number. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ return typed($01c976602b649244$var$name, {
        string: function string(x) {
            return x.trim().length > 0 && !isNaN(Number(x));
        },
        any: function any(x) {
            return isNumeric(x);
        }
    });
});

});

parcelRegister("9cMbe", function(module, exports) {

$parcel$export(module.exports, "createHex", () => $6b3a9ba42ea63d12$export$9cafd9970d25a17c);

var $4eE2e = parcelRequire("4eE2e");
var $6b3a9ba42ea63d12$var$name = 'hex';
var $6b3a9ba42ea63d12$var$dependencies = [
    'typed',
    'format'
];
var $6b3a9ba42ea63d12$export$9cafd9970d25a17c = (0, $4eE2e.factory)($6b3a9ba42ea63d12$var$name, $6b3a9ba42ea63d12$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($6b3a9ba42ea63d12$var$name, {
        'number | BigNumber': function numberBigNumber(n) {
            return format(n, {
                notation: 'hex'
            });
        },
        'number | BigNumber, number': function numberBigNumberNumber(n, wordSize) {
            return format(n, {
                notation: 'hex',
                wordSize: wordSize
            });
        }
    });
});

});

parcelRegister("2pmUs", function(module, exports) {

$parcel$export(module.exports, "createHypot", () => $1c0fafead3f62ed3$export$87e3687740a09cb);

var $4eE2e = parcelRequire("4eE2e");

var $10UPF = parcelRequire("10UPF");
var $1c0fafead3f62ed3$var$name = 'hypot';
var $1c0fafead3f62ed3$var$dependencies = [
    'typed',
    'abs',
    'addScalar',
    'divideScalar',
    'multiplyScalar',
    'sqrt',
    'smaller',
    'isPositive'
];
var $1c0fafead3f62ed3$export$87e3687740a09cb = /* #__PURE__ */ (0, $4eE2e.factory)($1c0fafead3f62ed3$var$name, $1c0fafead3f62ed3$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, sqrt: sqrt, smaller: smaller, isPositive: isPositive } = _ref;
    /**
   * Calculate the hypotenusa of a list with values. The hypotenusa is defined as:
   *
   *     hypot(a, b, c, ...) = sqrt(a^2 + b^2 + c^2 + ...)
   *
   * For matrix input, the hypotenusa is calculated for all values in the matrix.
   *
   * Syntax:
   *
   *     math.hypot(a, b, ...)
   *     math.hypot([a, b, c, ...])
   *
   * Examples:
   *
   *     math.hypot(3, 4)      // 5
   *     math.hypot(3, 4, 5)   // 7.0710678118654755
   *     math.hypot([3, 4, 5]) // 7.0710678118654755
   *     math.hypot(-2)        // 2
   *
   * See also:
   *
   *     abs, norm
   *
   * @param {... number | BigNumber | Array | Matrix} args    A list with numeric values or an Array or Matrix.
   *                                                          Matrix and Array input is flattened and returns a
   *                                                          single number for the whole matrix.
   * @return {number | BigNumber} Returns the hypothenusa of the input values.
   */ return typed($1c0fafead3f62ed3$var$name, {
        '... number | BigNumber': _hypot,
        Array: function Array(x) {
            return this.apply(this, (0, $10UPF.flatten)(x));
        },
        Matrix: function Matrix(x) {
            return this.apply(this, (0, $10UPF.flatten)(x.toArray()));
        }
    });
    /**
   * Calculate the hypotenusa for an Array with values
   * @param {Array.<number | BigNumber>} args
   * @return {number | BigNumber} Returns the result
   * @private
   */ function _hypot(args) {
        // code based on `hypot` from es6-shim:
        // https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js#L1619-L1633
        var result = 0;
        var largest = 0;
        for(var i = 0; i < args.length; i++){
            var value = abs(args[i]);
            if (smaller(largest, value)) {
                result = multiplyScalar(result, multiplyScalar(divideScalar(largest, value), divideScalar(largest, value)));
                result = addScalar(result, 1);
                largest = value;
            } else result = addScalar(result, isPositive(value) ? multiplyScalar(divideScalar(value, largest), divideScalar(value, largest)) : value);
        }
        return multiplyScalar(largest, sqrt(result));
    }
});

});

parcelRegister("arfuc", function(module, exports) {

$parcel$export(module.exports, "createIdentity", () => $79987034aeae470d$export$2eca89e9ac669625);

var $gs7TF = parcelRequire("gs7TF");

var $10UPF = parcelRequire("10UPF");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");
var $79987034aeae470d$var$name = 'identity';
var $79987034aeae470d$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'BigNumber',
    'DenseMatrix',
    'SparseMatrix'
];
var $79987034aeae470d$export$2eca89e9ac669625 = /* #__PURE__ */ (0, $4eE2e.factory)($79987034aeae470d$var$name, $79987034aeae470d$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a 2-dimensional identity matrix with size m x n or n x n.
   * The matrix has ones on the diagonal and zeros elsewhere.
   *
   * Syntax:
   *
   *    math.identity(n)
   *    math.identity(n, format)
   *    math.identity(m, n)
   *    math.identity(m, n, format)
   *    math.identity([m, n])
   *    math.identity([m, n], format)
   *
   * Examples:
   *
   *    math.identity(3)                    // returns [[1, 0, 0], [0, 1, 0], [0, 0, 1]]
   *    math.identity(3, 2)                 // returns [[1, 0], [0, 1], [0, 0]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.identity(math.size(A))         // returns [[1, 0, 0], [0, 1, 0]]
   *
   * See also:
   *
   *    diag, ones, zeros, size, range
   *
   * @param {...number | Matrix | Array} size   The size for the matrix
   * @param {string} [format]                   The Matrix storage format
   *
   * @return {Matrix | Array | number} A matrix with ones on the diagonal.
   */ return typed($79987034aeae470d$var$name, {
        '': function _() {
            return config.matrix === 'Matrix' ? matrix([]) : [];
        },
        string: function string(format) {
            return matrix(format);
        },
        'number | BigNumber': function numberBigNumber(rows) {
            return _identity(rows, rows, config.matrix === 'Matrix' ? 'dense' : undefined);
        },
        'number | BigNumber, string': function numberBigNumberString(rows, format) {
            return _identity(rows, rows, format);
        },
        'number | BigNumber, number | BigNumber': function numberBigNumberNumberBigNumber(rows, cols) {
            return _identity(rows, cols, config.matrix === 'Matrix' ? 'dense' : undefined);
        },
        'number | BigNumber, number | BigNumber, string': function numberBigNumberNumberBigNumberString(rows, cols, format) {
            return _identity(rows, cols, format);
        },
        Array: function Array(size) {
            return _identityVector(size);
        },
        'Array, string': function ArrayString(size, format) {
            return _identityVector(size, format);
        },
        Matrix: function Matrix(size) {
            return _identityVector(size.valueOf(), size.storage());
        },
        'Matrix, string': function MatrixString(size, format) {
            return _identityVector(size.valueOf(), format);
        }
    });
    function _identityVector(size, format) {
        switch(size.length){
            case 0:
                return format ? matrix(format) : [];
            case 1:
                return _identity(size[0], size[0], format);
            case 2:
                return _identity(size[0], size[1], format);
            default:
                throw new Error('Vector containing two values expected');
        }
    }
    /**
   * Create an identity matrix
   * @param {number | BigNumber} rows
   * @param {number | BigNumber} cols
   * @param {string} [format]
   * @returns {Matrix}
   * @private
   */ function _identity(rows, cols, format) {
        // BigNumber constructor with the right precision
        var Big = (0, $gs7TF.isBigNumber)(rows) || (0, $gs7TF.isBigNumber)(cols) ? BigNumber : null;
        if ((0, $gs7TF.isBigNumber)(rows)) rows = rows.toNumber();
        if ((0, $gs7TF.isBigNumber)(cols)) cols = cols.toNumber();
        if (!(0, $6egKm.isInteger)(rows) || rows < 1) throw new Error('Parameters in function identity must be positive integers');
        if (!(0, $6egKm.isInteger)(cols) || cols < 1) throw new Error('Parameters in function identity must be positive integers');
        var one = Big ? new BigNumber(1) : 1;
        var defaultValue = Big ? new Big(0) : 0;
        var size = [
            rows,
            cols
        ]; // check we need to return a matrix
        if (format) {
            // create diagonal matrix (use optimized implementation for storage format)
            if (format === 'sparse') return SparseMatrix.diagonal(size, one, 0, defaultValue);
            if (format === 'dense') return DenseMatrix.diagonal(size, one, 0, defaultValue);
            throw new TypeError("Unknown matrix type \"".concat(format, "\""));
        } // create and resize array
        var res = (0, $10UPF.resize)([], size, defaultValue); // fill in ones on the diagonal
        var minimum = rows < cols ? rows : cols; // fill diagonal
        for(var d = 0; d < minimum; d++)res[d][d] = one;
        return res;
    }
});

});

parcelRegister("gNRKw", function(module, exports) {

$parcel$export(module.exports, "createIm", () => $c3baea7616133530$export$47dfdf308b91581);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $c3baea7616133530$var$name = 'im';
var $c3baea7616133530$var$dependencies = [
    'typed'
];
var $c3baea7616133530$export$47dfdf308b91581 = /* #__PURE__ */ (0, $4eE2e.factory)($c3baea7616133530$var$name, $c3baea7616133530$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Get the imaginary part of a complex number.
   * For a complex number `a + bi`, the function returns `b`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.im(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number -5.2
   *    math.re(math.complex(2.4))     // returns number 0
   *
   * See also:
   *
   *    re, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The imaginary part of x
   */ return typed($c3baea7616133530$var$name, {
        number: function number(x) {
            return 0;
        },
        BigNumber: function BigNumber(x) {
            return x.mul(0);
        },
        Fraction: function Fraction(x) {
            return x.mul(0);
        },
        Complex: function Complex(x) {
            return x.im;
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("atHq5", function(module, exports) {

$parcel$export(module.exports, "createImmutableDenseMatrixClass", () => $7a0e4b166900e934$export$49a565643b9ab608);

var $gs7TF = parcelRequire("gs7TF");

var $4mYv9 = parcelRequire("4mYv9");

var $4eE2e = parcelRequire("4eE2e");
var $7a0e4b166900e934$var$name = 'ImmutableDenseMatrix';
var $7a0e4b166900e934$var$dependencies = [
    'smaller',
    'DenseMatrix'
];
var $7a0e4b166900e934$export$49a565643b9ab608 = /* #__PURE__ */ (0, $4eE2e.factory)($7a0e4b166900e934$var$name, $7a0e4b166900e934$var$dependencies, (_ref)=>{
    var { smaller: smaller, DenseMatrix: DenseMatrix } = _ref;
    function ImmutableDenseMatrix(data, datatype) {
        if (!(this instanceof ImmutableDenseMatrix)) throw new SyntaxError('Constructor must be called with the new operator');
        if (datatype && !(0, $gs7TF.isString)(datatype)) throw new Error('Invalid datatype: ' + datatype);
        if ((0, $gs7TF.isMatrix)(data) || (0, $gs7TF.isArray)(data)) {
            // use DenseMatrix implementation
            var matrix = new DenseMatrix(data, datatype); // internal structures
            this._data = matrix._data;
            this._size = matrix._size;
            this._datatype = matrix._datatype;
            this._min = null;
            this._max = null;
        } else if (data && (0, $gs7TF.isArray)(data.data) && (0, $gs7TF.isArray)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size;
            this._datatype = data.datatype;
            this._min = typeof data.min !== 'undefined' ? data.min : null;
            this._max = typeof data.max !== 'undefined' ? data.max : null;
        } else if (data) // unsupported type
        throw new TypeError('Unsupported type of data (' + (0, $gs7TF.typeOf)(data) + ')');
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
            this._min = null;
            this._max = null;
        }
    }
    ImmutableDenseMatrix.prototype = new DenseMatrix();
    /**
   * Attach type information
   */ ImmutableDenseMatrix.prototype.type = 'ImmutableDenseMatrix';
    ImmutableDenseMatrix.prototype.isImmutableDenseMatrix = true;
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | ImmutableDenseMatrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ ImmutableDenseMatrix.prototype.subset = function(index) {
        switch(arguments.length){
            case 1:
                // use base implementation
                var m = DenseMatrix.prototype.subset.call(this, index); // check result is a matrix
                if ((0, $gs7TF.isMatrix)(m)) // return immutable matrix
                return new ImmutableDenseMatrix({
                    data: m._data,
                    size: m._size,
                    datatype: m._datatype
                });
                return m;
            // intentional fall through
            case 2:
            case 3:
                throw new Error('Cannot invoke set subset on an Immutable Matrix instance');
            default:
                throw new SyntaxError('Wrong number of arguments');
        }
    };
    /**
   * Replace a single element in the matrix.
   * @param {Number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {ImmutableDenseMatrix} self
   */ ImmutableDenseMatrix.prototype.set = function() {
        throw new Error('Cannot invoke set on an Immutable Matrix instance');
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {Number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ ImmutableDenseMatrix.prototype.resize = function() {
        throw new Error('Cannot invoke resize on an Immutable Matrix instance');
    };
    /**
   * Disallows reshaping in favor of immutability.
   *
   * @throws {Error} Operation not allowed
   */ ImmutableDenseMatrix.prototype.reshape = function() {
        throw new Error('Cannot invoke reshape on an Immutable Matrix instance');
    };
    /**
   * Create a clone of the matrix
   * @return {ImmutableDenseMatrix} clone
   */ ImmutableDenseMatrix.prototype.clone = function() {
        return new ImmutableDenseMatrix({
            data: (0, $4mYv9.clone)(this._data),
            size: (0, $4mYv9.clone)(this._size),
            datatype: this._datatype
        });
    };
    /**
   * Get a JSON representation of the matrix
   * @returns {Object}
   */ ImmutableDenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: 'ImmutableDenseMatrix',
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Generate a matrix from a JSON object
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ImmutableDenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {ImmutableDenseMatrix}
   */ ImmutableDenseMatrix.fromJSON = function(json) {
        return new ImmutableDenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @param {Number} i       Matrix row index 1
   * @param {Number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ ImmutableDenseMatrix.prototype.swapRows = function() {
        throw new Error('Cannot invoke swapRows on an Immutable Matrix instance');
    };
    /**
   * Calculate the minimum value in the set
   * @return {Number | undefined} min
   */ ImmutableDenseMatrix.prototype.min = function() {
        // check min has been calculated before
        if (this._min === null) {
            // minimum
            var m = null; // compute min
            this.forEach(function(v) {
                if (m === null || smaller(v, m)) m = v;
            });
            this._min = m !== null ? m : undefined;
        }
        return this._min;
    };
    /**
   * Calculate the maximum value in the set
   * @return {Number | undefined} max
   */ ImmutableDenseMatrix.prototype.max = function() {
        // check max has been calculated before
        if (this._max === null) {
            // maximum
            var m = null; // compute max
            this.forEach(function(v) {
                if (m === null || smaller(m, v)) m = v;
            });
            this._max = m !== null ? m : undefined;
        }
        return this._max;
    };
    return ImmutableDenseMatrix;
}, {
    isClass: true
});

});

parcelRegister("fuwCS", function(module, exports) {

$parcel$export(module.exports, "createIndex", () => $b472f73a1e9d6171$export$c6d108d7c8095f19);

var $4eE2e = parcelRequire("4eE2e");

var $gs7TF = parcelRequire("gs7TF");
var $b472f73a1e9d6171$var$name = 'index';
var $b472f73a1e9d6171$var$dependencies = [
    'typed',
    'Index'
];
var $b472f73a1e9d6171$export$c6d108d7c8095f19 = /* #__PURE__ */ (0, $4eE2e.factory)($b472f73a1e9d6171$var$name, $b472f73a1e9d6171$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index } = _ref;
    /**
   * Create an index. An Index can store ranges having start, step, and end
   * for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Syntax:
   *
   *     math.index(range1, range2, ...)
   *
   * Where each range can be any of:
   *
   * - A number
   * - A string for getting/setting an object property
   * - An instance of `Range`
   * - A one-dimensional Array or a Matrix with numbers
   *
   * Indexes must be zero-based, integer numbers.
   *
   * Examples:
   *
   *    const b = [1, 2, 3, 4, 5]
   *    math.subset(b, math.index([1, 2, 3]))     // returns [2, 3, 4]
   *
   *    const a = math.matrix([[1, 2], [3, 4]])
   *    a.subset(math.index(0, 1))             // returns 2
   *
   * See also:
   *
   *    bignumber, boolean, complex, matrix, number, string, unit
   *
   * @param {...*} ranges   Zero or more ranges or numbers.
   * @return {Index}        Returns the created index
   */ return typed($b472f73a1e9d6171$var$name, {
        '...number | string | BigNumber | Range | Array | Matrix': function numberStringBigNumberRangeArrayMatrix(args) {
            var ranges = args.map(function(arg) {
                if ((0, $gs7TF.isBigNumber)(arg)) return arg.toNumber(); // convert BigNumber to Number
                else if (Array.isArray(arg) || (0, $gs7TF.isMatrix)(arg)) return arg.map(function(elem) {
                    // convert BigNumber to Number
                    return (0, $gs7TF.isBigNumber)(elem) ? elem.toNumber() : elem;
                });
                else return arg;
            });
            var res = new Index();
            Index.apply(res, ranges);
            return res;
        }
    });
});

});

parcelRegister("jvvOm", function(module, exports) {

$parcel$export(module.exports, "createIndexClass", () => $e33996a02fb41cad$export$300720b4fe34e62e);

var $gs7TF = parcelRequire("gs7TF");

var $4mYv9 = parcelRequire("4mYv9");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");
var $e33996a02fb41cad$var$name = 'Index';
var $e33996a02fb41cad$var$dependencies = [
    'ImmutableDenseMatrix'
];
var $e33996a02fb41cad$export$300720b4fe34e62e = /* #__PURE__ */ (0, $4eE2e.factory)($e33996a02fb41cad$var$name, $e33996a02fb41cad$var$dependencies, (_ref)=>{
    var { ImmutableDenseMatrix: ImmutableDenseMatrix } = _ref;
    /**
   * Create an index. An Index can store ranges and sets for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Usage:
   *     const index = new Index(range1, range2, matrix1, array1, ...)
   *
   * Where each parameter can be any of:
   *     A number
   *     A string (containing a name of an object property)
   *     An instance of Range
   *     An Array with the Set values
   *     A Matrix with the Set values
   *
   * The parameters start, end, and step must be integer numbers.
   *
   * @class Index
   * @Constructor Index
   * @param {...*} ranges
   */ function Index(ranges) {
        if (!(this instanceof Index)) throw new SyntaxError('Constructor must be called with the new operator');
        this._dimensions = [];
        this._isScalar = true;
        for(var i = 0, ii = arguments.length; i < ii; i++){
            var arg = arguments[i];
            if ((0, $gs7TF.isRange)(arg)) {
                this._dimensions.push(arg);
                this._isScalar = false;
            } else if (Array.isArray(arg) || (0, $gs7TF.isMatrix)(arg)) {
                // create matrix
                var m = _createImmutableMatrix(arg.valueOf());
                this._dimensions.push(m); // size
                var size = m.size(); // scalar
                if (size.length !== 1 || size[0] !== 1) this._isScalar = false;
            } else if (typeof arg === 'number') this._dimensions.push(_createImmutableMatrix([
                arg
            ]));
            else if (typeof arg === 'string') // object property (arguments.count should be 1)
            this._dimensions.push(arg);
            else throw new TypeError('Dimension must be an Array, Matrix, number, string, or Range');
             // TODO: implement support for wildcard '*'
        }
    }
    /**
   * Attach type information
   */ Index.prototype.type = 'Index';
    Index.prototype.isIndex = true;
    function _createImmutableMatrix(arg) {
        // loop array elements
        for(var i = 0, l = arg.length; i < l; i++){
            if (typeof arg[i] !== 'number' || !(0, $6egKm.isInteger)(arg[i])) throw new TypeError('Index parameters must be positive integer numbers');
        } // create matrix
        return new ImmutableDenseMatrix(arg);
    }
    /**
   * Create a clone of the index
   * @memberof Index
   * @return {Index} clone
   */ Index.prototype.clone = function() {
        var index = new Index();
        index._dimensions = (0, $4mYv9.clone)(this._dimensions);
        index._isScalar = this._isScalar;
        return index;
    };
    /**
   * Create an index from an array with ranges/numbers
   * @memberof Index
   * @param {Array.<Array | number>} ranges
   * @return {Index} index
   * @private
   */ Index.create = function(ranges) {
        var index = new Index();
        Index.apply(index, ranges);
        return index;
    };
    /**
   * Retrieve the size of the index, the number of elements for each dimension.
   * @memberof Index
   * @returns {number[]} size
   */ Index.prototype.size = function() {
        var size = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var d = this._dimensions[i];
            size[i] = typeof d === 'string' ? 1 : d.size()[0];
        }
        return size;
    };
    /**
   * Get the maximum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} max
   */ Index.prototype.max = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === 'string' ? range : range.max();
        }
        return values;
    };
    /**
   * Get the minimum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} min
   */ Index.prototype.min = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === 'string' ? range : range.min();
        }
        return values;
    };
    /**
   * Loop over each of the ranges of the index
   * @memberof Index
   * @param {Function} callback   Called for each range with a Range as first
   *                              argument, the dimension as second, and the
   *                              index object as third.
   */ Index.prototype.forEach = function(callback) {
        for(var i = 0, ii = this._dimensions.length; i < ii; i++)callback(this._dimensions[i], i, this);
    };
    /**
   * Retrieve the dimension for the given index
   * @memberof Index
   * @param {Number} dim                  Number of the dimension
   * @returns {Range | null} range
   */ Index.prototype.dimension = function(dim) {
        return this._dimensions[dim] || null;
    };
    /**
   * Test whether this index contains an object property
   * @returns {boolean} Returns true if the index is an object property
   */ Index.prototype.isObjectProperty = function() {
        return this._dimensions.length === 1 && typeof this._dimensions[0] === 'string';
    };
    /**
   * Returns the object property name when the Index holds a single object property,
   * else returns null
   * @returns {string | null}
   */ Index.prototype.getObjectProperty = function() {
        return this.isObjectProperty() ? this._dimensions[0] : null;
    };
    /**
   * Test whether this index contains only a single value.
   *
   * This is the case when the index is created with only scalar values as ranges,
   * not for ranges resolving into a single value.
   * @memberof Index
   * @return {boolean} isScalar
   */ Index.prototype.isScalar = function() {
        return this._isScalar;
    };
    /**
   * Expand the Index into an array.
   * For example new Index([0,3], [2,7]) returns [[0,1,2], [2,3,4,5,6]]
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.toArray = function() {
        var array = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            array.push(typeof dimension === 'string' ? dimension : dimension.toArray());
        }
        return array;
    };
    /**
   * Get the primitive value of the Index, a two dimensional array.
   * Equivalent to Index.toArray().
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.valueOf = Index.prototype.toArray;
    /**
   * Get the string representation of the index, for example '[2:6]' or '[0:2:10, 4:7, [1,2,3]]'
   * @memberof Index
   * @returns {String} str
   */ Index.prototype.toString = function() {
        var strings = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            if (typeof dimension === 'string') strings.push(JSON.stringify(dimension));
            else strings.push(dimension.toString());
        }
        return '[' + strings.join(', ') + ']';
    };
    /**
   * Get a JSON representation of the Index
   * @memberof Index
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Index", "ranges": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   */ Index.prototype.toJSON = function() {
        return {
            mathjs: 'Index',
            dimensions: this._dimensions
        };
    };
    /**
   * Instantiate an Index from a JSON object
   * @memberof Index
   * @param {Object} json A JSON object structured as:
   *                     `{"mathjs": "Index", "dimensions": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   * @return {Index}
   */ Index.fromJSON = function(json) {
        return Index.create(json.dimensions);
    };
    return Index;
}, {
    isClass: true
});

});

parcelRegister("iJlfn", function(module, exports) {

$parcel$export(module.exports, "createIntersect", () => $da2ce92b8f2f0d1f$export$e2d92d8f89fdd92d);

var $gs7TF = parcelRequire("gs7TF");

var $4eE2e = parcelRequire("4eE2e");
var $da2ce92b8f2f0d1f$var$name = 'intersect';
var $da2ce92b8f2f0d1f$var$dependencies = [
    'typed',
    'config',
    'abs',
    'add',
    'addScalar',
    'matrix',
    'multiply',
    'multiplyScalar',
    'divideScalar',
    'subtract',
    'smaller',
    'equalScalar',
    'flatten'
];
var $da2ce92b8f2f0d1f$export$e2d92d8f89fdd92d = /* #__PURE__ */ (0, $4eE2e.factory)($da2ce92b8f2f0d1f$var$name, $da2ce92b8f2f0d1f$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, abs: abs, add: add, addScalar: addScalar, matrix: matrix, multiply: multiply, multiplyScalar: multiplyScalar, divideScalar: divideScalar, subtract: subtract, smaller: smaller, equalScalar: equalScalar, flatten: flatten } = _ref;
    /**
   * Calculates the point of intersection of two lines in two or three dimensions
   * and of a line and a plane in three dimensions. The inputs are in the form of
   * arrays or 1 dimensional matrices. The line intersection functions return null
   * if the lines do not meet.
   *
   * Note: Fill the plane coefficients as `x + y + z = c` and not as `x + y + z + c = 0`.
   *
   * Syntax:
   *
   *    math.intersect(endPoint1Line1, endPoint2Line1, endPoint1Line2, endPoint2Line2)
   *    math.intersect(endPoint1, endPoint2, planeCoefficients)
   *
   * Examples:
   *
   *    math.intersect([0, 0], [10, 10], [10, 0], [0, 10])              // Returns [5, 5]
   *    math.intersect([0, 0, 0], [10, 10, 0], [10, 0, 0], [0, 10, 0])  // Returns [5, 5, 0]
   *    math.intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])            // Returns [7, -4, 3]
   *
   * @param  {Array | Matrix} w   Co-ordinates of first end-point of first line
   * @param  {Array | Matrix} x   Co-ordinates of second end-point of first line
   * @param  {Array | Matrix} y   Co-ordinates of first end-point of second line
   *                              OR Co-efficients of the plane's equation
   * @param  {Array | Matrix} z   Co-ordinates of second end-point of second line
   *                              OR undefined if the calculation is for line and plane
   * @return {Array}              Returns the point of intersection of lines/lines-planes
   */ return typed('intersect', {
        'Array, Array, Array': _AAA,
        'Array, Array, Array, Array': _AAAA,
        'Matrix, Matrix, Matrix': function MatrixMatrixMatrix(x, y, plane) {
            var arr = _AAA(x.valueOf(), y.valueOf(), plane.valueOf());
            return arr === null ? null : matrix(arr);
        },
        'Matrix, Matrix, Matrix, Matrix': function MatrixMatrixMatrixMatrix(w, x, y, z) {
            // TODO: output matrix type should match input matrix type
            var arr = _AAAA(w.valueOf(), x.valueOf(), y.valueOf(), z.valueOf());
            return arr === null ? null : matrix(arr);
        }
    });
    function _AAA(x, y, plane) {
        x = _coerceArr(x);
        y = _coerceArr(y);
        plane = _coerceArr(plane);
        if (!_3d(x)) throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument');
        if (!_3d(y)) throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument');
        if (!_4d(plane)) throw new TypeError('Array with 4 numbers expected as third argument');
        return _intersectLinePlane(x[0], x[1], x[2], y[0], y[1], y[2], plane[0], plane[1], plane[2], plane[3]);
    }
    function _AAAA(w, x, y, z) {
        w = _coerceArr(w);
        x = _coerceArr(x);
        y = _coerceArr(y);
        z = _coerceArr(z);
        if (w.length === 2) {
            if (!_2d(w)) throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument');
            if (!_2d(x)) throw new TypeError('Array with 2 numbers or BigNumbers expected for second argument');
            if (!_2d(y)) throw new TypeError('Array with 2 numbers or BigNumbers expected for third argument');
            if (!_2d(z)) throw new TypeError('Array with 2 numbers or BigNumbers expected for fourth argument');
            return _intersect2d(w, x, y, z);
        } else if (w.length === 3) {
            if (!_3d(w)) throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument');
            if (!_3d(x)) throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument');
            if (!_3d(y)) throw new TypeError('Array with 3 numbers or BigNumbers expected for third argument');
            if (!_3d(z)) throw new TypeError('Array with 3 numbers or BigNumbers expected for fourth argument');
            return _intersect3d(w[0], w[1], w[2], x[0], x[1], x[2], y[0], y[1], y[2], z[0], z[1], z[2]);
        } else throw new TypeError('Arrays with two or thee dimensional points expected');
    }
    /** Coerce row and column 2-dim arrays to 1-dim array */ function _coerceArr(arr) {
        // row matrix
        if (arr.length === 1) return arr[0]; // column matrix
        if (arr.length > 1 && Array.isArray(arr[0])) {
            if (arr.every((el)=>Array.isArray(el) && el.length === 1)) return flatten(arr);
        }
        return arr;
    }
    function _isNumeric(a) {
        // intersect supports numbers and bignumbers
        return typeof a === 'number' || (0, $gs7TF.isBigNumber)(a);
    }
    function _2d(x) {
        return x.length === 2 && _isNumeric(x[0]) && _isNumeric(x[1]);
    }
    function _3d(x) {
        return x.length === 3 && _isNumeric(x[0]) && _isNumeric(x[1]) && _isNumeric(x[2]);
    }
    function _4d(x) {
        return x.length === 4 && _isNumeric(x[0]) && _isNumeric(x[1]) && _isNumeric(x[2]) && _isNumeric(x[3]);
    }
    function _intersect2d(p1a, p1b, p2a, p2b) {
        var o1 = p1a;
        var o2 = p2a;
        var d1 = subtract(o1, p1b);
        var d2 = subtract(o2, p2b);
        var det = subtract(multiplyScalar(d1[0], d2[1]), multiplyScalar(d2[0], d1[1]));
        if (smaller(abs(det), config.epsilon)) return null;
        var d20o11 = multiplyScalar(d2[0], o1[1]);
        var d21o10 = multiplyScalar(d2[1], o1[0]);
        var d20o21 = multiplyScalar(d2[0], o2[1]);
        var d21o20 = multiplyScalar(d2[1], o2[0]);
        var t = divideScalar(addScalar(subtract(subtract(d20o11, d21o10), d20o21), d21o20), det);
        return add(multiply(d1, t), o1);
    }
    function _intersect3dHelper(a, b, c, d, e, f, g, h, i, j, k, l) {
        // (a - b)*(c - d) + (e - f)*(g - h) + (i - j)*(k - l)
        var add1 = multiplyScalar(subtract(a, b), subtract(c, d));
        var add2 = multiplyScalar(subtract(e, f), subtract(g, h));
        var add3 = multiplyScalar(subtract(i, j), subtract(k, l));
        return addScalar(addScalar(add1, add2), add3);
    }
    function _intersect3d(x1, y1, z1, x2, y2, z2, x3, y3, z3, x4, y4, z4) {
        var d1343 = _intersect3dHelper(x1, x3, x4, x3, y1, y3, y4, y3, z1, z3, z4, z3);
        var d4321 = _intersect3dHelper(x4, x3, x2, x1, y4, y3, y2, y1, z4, z3, z2, z1);
        var d1321 = _intersect3dHelper(x1, x3, x2, x1, y1, y3, y2, y1, z1, z3, z2, z1);
        var d4343 = _intersect3dHelper(x4, x3, x4, x3, y4, y3, y4, y3, z4, z3, z4, z3);
        var d2121 = _intersect3dHelper(x2, x1, x2, x1, y2, y1, y2, y1, z2, z1, z2, z1);
        var ta = divideScalar(subtract(multiplyScalar(d1343, d4321), multiplyScalar(d1321, d4343)), subtract(multiplyScalar(d2121, d4343), multiplyScalar(d4321, d4321)));
        var tb = divideScalar(addScalar(d1343, multiplyScalar(ta, d4321)), d4343);
        var pax = addScalar(x1, multiplyScalar(ta, subtract(x2, x1)));
        var pay = addScalar(y1, multiplyScalar(ta, subtract(y2, y1)));
        var paz = addScalar(z1, multiplyScalar(ta, subtract(z2, z1)));
        var pbx = addScalar(x3, multiplyScalar(tb, subtract(x4, x3)));
        var pby = addScalar(y3, multiplyScalar(tb, subtract(y4, y3)));
        var pbz = addScalar(z3, multiplyScalar(tb, subtract(z4, z3)));
        if (equalScalar(pax, pbx) && equalScalar(pay, pby) && equalScalar(paz, pbz)) return [
            pax,
            pay,
            paz
        ];
        else return null;
    }
    function _intersectLinePlane(x1, y1, z1, x2, y2, z2, x, y, z, c) {
        var x1x = multiplyScalar(x1, x);
        var x2x = multiplyScalar(x2, x);
        var y1y = multiplyScalar(y1, y);
        var y2y = multiplyScalar(y2, y);
        var z1z = multiplyScalar(z1, z);
        var z2z = multiplyScalar(z2, z);
        var numerator = subtract(subtract(subtract(c, x1x), y1y), z1z);
        var denominator = subtract(subtract(subtract(addScalar(addScalar(x2x, y2y), z2z), x1x), y1y), z1z);
        var t = divideScalar(numerator, denominator);
        var px = addScalar(x1, multiplyScalar(t, subtract(x2, x1)));
        var py = addScalar(y1, multiplyScalar(t, subtract(y2, y1)));
        var pz = addScalar(z1, multiplyScalar(t, subtract(z2, z1)));
        return [
            px,
            py,
            pz
        ]; // TODO: Add cases when line is parallel to the plane:
    //       (a) no intersection,
    //       (b) line contained in plane
    }
});

});

parcelRegister("dH0wG", function(module, exports) {

$parcel$export(module.exports, "createInv", () => $9f7fb3023ed33aa2$export$ad9771ef9eafe06a);

var $gs7TF = parcelRequire("gs7TF");

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");

var $aEppI = parcelRequire("aEppI");
var $9f7fb3023ed33aa2$var$name = 'inv';
var $9f7fb3023ed33aa2$var$dependencies = [
    'typed',
    'matrix',
    'divideScalar',
    'addScalar',
    'multiply',
    'unaryMinus',
    'det',
    'identity',
    'abs'
];
var $9f7fb3023ed33aa2$export$ad9771ef9eafe06a = /* #__PURE__ */ (0, $4eE2e.factory)($9f7fb3023ed33aa2$var$name, $9f7fb3023ed33aa2$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, addScalar: addScalar, multiply: multiply, unaryMinus: unaryMinus, det: det, identity: identity, abs: abs } = _ref;
    /**
   * Calculate the inverse of a square matrix.
   *
   * Syntax:
   *
   *     math.inv(x)
   *
   * Examples:
   *
   *     math.inv([[1, 2], [3, 4]])  // returns [[-2, 1], [1.5, -0.5]]
   *     math.inv(4)                 // returns 0.25
   *     1 / 4                       // returns 0.25
   *
   * See also:
   *
   *     det, transpose
   *
   * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
   * @return {number | Complex | Array | Matrix} The inverse of `x`.
   */ return typed($9f7fb3023ed33aa2$var$name, {
        'Array | Matrix': function ArrayMatrix(x) {
            var size = (0, $gs7TF.isMatrix)(x) ? x.size() : (0, $10UPF.arraySize)(x);
            switch(size.length){
                case 1:
                    // vector
                    if (size[0] === 1) {
                        if ((0, $gs7TF.isMatrix)(x)) return matrix([
                            divideScalar(1, x.valueOf()[0])
                        ]);
                        else return [
                            divideScalar(1, x[0])
                        ];
                    } else throw new RangeError("Matrix must be square (size: " + (0, $aEppI.format)(size) + ')');
                case 2:
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) {
                        if ((0, $gs7TF.isMatrix)(x)) return matrix(_inv(x.valueOf(), rows, cols), x.storage());
                        else // return an Array
                        return _inv(x, rows, cols);
                    } else throw new RangeError("Matrix must be square (size: " + (0, $aEppI.format)(size) + ')');
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $aEppI.format)(size) + ')');
            }
        },
        any: function any(x) {
            // scalar
            return divideScalar(1, x); // FIXME: create a BigNumber one when configured for bignumbers
        }
    });
    /**
   * Calculate the inverse of a square matrix
   * @param {Array[]} mat     A square matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns, must equal rows
   * @return {Array[]} inv    Inverse matrix
   * @private
   */ function _inv(mat, rows, cols) {
        var r, s, f, value, temp;
        if (rows === 1) {
            // this is a 1 x 1 matrix
            value = mat[0][0];
            if (value === 0) throw Error('Cannot calculate inverse, determinant is zero');
            return [
                [
                    divideScalar(1, value)
                ]
            ];
        } else if (rows === 2) {
            // this is a 2 x 2 matrix
            var d = det(mat);
            if (d === 0) throw Error('Cannot calculate inverse, determinant is zero');
            return [
                [
                    divideScalar(mat[1][1], d),
                    divideScalar(unaryMinus(mat[0][1]), d)
                ],
                [
                    divideScalar(unaryMinus(mat[1][0]), d),
                    divideScalar(mat[0][0], d)
                ]
            ];
        } else {
            // this is a matrix of 3 x 3 or larger
            // calculate inverse using gauss-jordan elimination
            //      https://en.wikipedia.org/wiki/Gaussian_elimination
            //      http://mathworld.wolfram.com/MatrixInverse.html
            //      http://math.uww.edu/~mcfarlat/inverse.htm
            // make a copy of the matrix (only the arrays, not of the elements)
            var A = mat.concat();
            for(r = 0; r < rows; r++)A[r] = A[r].concat();
             // create an identity matrix which in the end will contain the
            // matrix inverse
            var B = identity(rows).valueOf(); // loop over all columns, and perform row reductions
            for(var c = 0; c < cols; c++){
                // Pivoting: Swap row c with row r, where row r contains the largest element A[r][c]
                var ABig = abs(A[c][c]);
                var rBig = c;
                r = c + 1;
                while(r < rows){
                    if (abs(A[r][c]) > ABig) {
                        ABig = abs(A[r][c]);
                        rBig = r;
                    }
                    r++;
                }
                if (ABig === 0) throw Error('Cannot calculate inverse, determinant is zero');
                r = rBig;
                if (r !== c) {
                    temp = A[c];
                    A[c] = A[r];
                    A[r] = temp;
                    temp = B[c];
                    B[c] = B[r];
                    B[r] = temp;
                } // eliminate non-zero values on the other rows at column c
                var Ac = A[c];
                var Bc = B[c];
                for(r = 0; r < rows; r++){
                    var Ar = A[r];
                    var Br = B[r];
                    if (r !== c) // eliminate value at column c and row r
                    {
                        if (Ar[c] !== 0) {
                            f = divideScalar(unaryMinus(Ar[c]), Ac[c]); // add (f * row c) to row r to eliminate the value
                            // at column c
                            for(s = c; s < cols; s++)Ar[s] = addScalar(Ar[s], multiply(f, Ac[s]));
                            for(s = 0; s < cols; s++)Br[s] = addScalar(Br[s], multiply(f, Bc[s]));
                        }
                    } else {
                        // normalize value at Acc to 1,
                        // divide each value on row r with the value at Acc
                        f = Ac[c];
                        for(s = c; s < cols; s++)Ar[s] = divideScalar(Ar[s], f);
                        for(s = 0; s < cols; s++)Br[s] = divideScalar(Br[s], f);
                    }
                }
            }
            return B;
        }
    }
});

});

parcelRegister("jqPCL", function(module, exports) {

$parcel$export(module.exports, "createIsInteger", () => $e2587d86fd92457e$export$766996d075d5608a);

var $9nwyh = parcelRequire("9nwyh");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");
var $e2587d86fd92457e$var$name = 'isInteger';
var $e2587d86fd92457e$var$dependencies = [
    'typed'
];
var $e2587d86fd92457e$export$766996d075d5608a = /* #__PURE__ */ (0, $4eE2e.factory)($e2587d86fd92457e$var$name, $e2587d86fd92457e$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is an integer number.
   * The function supports `number`, `BigNumber`, and `Fraction`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isInteger(x)
   *
   * Examples:
   *
   *    math.isInteger(2)                     // returns true
   *    math.isInteger(0)                     // returns true
   *    math.isInteger(0.5)                   // returns false
   *    math.isInteger(math.bignumber(500))   // returns true
   *    math.isInteger(math.fraction(4))      // returns true
   *    math.isInteger('3')                   // returns true
   *    math.isInteger([3, 0.5, -2])          // returns [true, false, true]
   *    math.isInteger(math.complex('2-4i')   // throws an error
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isZero
   *
   * @param {number | BigNumber | Fraction | Array | Matrix} x   Value to be tested
   * @return {boolean}  Returns true when `x` contains a numeric, integer value.
   *                    Throws an error in case of an unknown data type.
   */ return typed($e2587d86fd92457e$var$name, {
        number: (0, $6egKm.isInteger),
        // TODO: what to do with isInteger(add(0.1, 0.2))  ?
        BigNumber: function BigNumber(x) {
            return x.isInt();
        },
        Fraction: function Fraction(x) {
            return x.d === 1 && isFinite(x.n);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("cO11J", function(module, exports) {

$parcel$export(module.exports, "createIsNaN", () => $952af37d3b676635$export$f85085363cf09711);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");

var $7f7zD = parcelRequire("7f7zD");
var $952af37d3b676635$var$name = 'isNaN';
var $952af37d3b676635$var$dependencies = [
    'typed'
];
var $952af37d3b676635$export$f85085363cf09711 = /* #__PURE__ */ (0, $4eE2e.factory)($952af37d3b676635$var$name, $952af37d3b676635$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is NaN (not a number).
   * The function supports types `number`, `BigNumber`, `Fraction`, `Unit` and `Complex`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNaN(x)
   *
   * Examples:
   *
   *    math.isNaN(3)                     // returns false
   *    math.isNaN(NaN)                   // returns true
   *    math.isNaN(0)                     // returns false
   *    math.isNaN(math.bignumber(NaN))   // returns true
   *    math.isNaN(math.bignumber(0))     // returns false
   *    math.isNaN(math.fraction(-2, 5))  // returns false
   *    math.isNaN('-2')                  // returns false
   *    math.isNaN([2, 0, -3, NaN]')      // returns [false, false, false, true]
   *
   * See also:
   *
   *    isNumeric, isNegative, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is NaN.
   *                    Throws an error in case of an unknown data type.
   */ return typed($952af37d3b676635$var$name, {
        number: (0, $7f7zD.isNaNNumber),
        BigNumber: function BigNumber(x) {
            return x.isNaN();
        },
        Fraction: function Fraction(x) {
            return false;
        },
        Complex: function Complex(x) {
            return x.isNaN();
        },
        Unit: function Unit(x) {
            return Number.isNaN(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, Number.isNaN);
        }
    });
});

});
parcelRegister("7f7zD", function(module, exports) {

$parcel$export(module.exports, "isNegativeNumber", () => $545fcf1d35e7d154$export$6dbd64961904ec9a);
$parcel$export(module.exports, "isPositiveNumber", () => $545fcf1d35e7d154$export$5374bb854d0e41c8);
$parcel$export(module.exports, "isZeroNumber", () => $545fcf1d35e7d154$export$83fb4ed1cc9804a);
$parcel$export(module.exports, "isNaNNumber", () => $545fcf1d35e7d154$export$9fd08d8371c55110);

var $6egKm = parcelRequire("6egKm");
var $545fcf1d35e7d154$var$n1 = 'number';
function $545fcf1d35e7d154$export$312381923ba56895(x) {
    return (0, $6egKm.isInteger)(x);
}
$545fcf1d35e7d154$export$312381923ba56895.signature = $545fcf1d35e7d154$var$n1;
function $545fcf1d35e7d154$export$6dbd64961904ec9a(x) {
    return x < 0;
}
$545fcf1d35e7d154$export$6dbd64961904ec9a.signature = $545fcf1d35e7d154$var$n1;
function $545fcf1d35e7d154$export$5374bb854d0e41c8(x) {
    return x > 0;
}
$545fcf1d35e7d154$export$5374bb854d0e41c8.signature = $545fcf1d35e7d154$var$n1;
function $545fcf1d35e7d154$export$83fb4ed1cc9804a(x) {
    return x === 0;
}
$545fcf1d35e7d154$export$83fb4ed1cc9804a.signature = $545fcf1d35e7d154$var$n1;
function $545fcf1d35e7d154$export$9fd08d8371c55110(x) {
    return Number.isNaN(x);
}
$545fcf1d35e7d154$export$9fd08d8371c55110.signature = $545fcf1d35e7d154$var$n1;

});


parcelRegister("aWTnj", function(module, exports) {

$parcel$export(module.exports, "createIsNegative", () => $7f8a468244a3a2cb$export$159ccd8c63e17c58);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");

var $7f7zD = parcelRequire("7f7zD");
var $7f8a468244a3a2cb$var$name = 'isNegative';
var $7f8a468244a3a2cb$var$dependencies = [
    'typed'
];
var $7f8a468244a3a2cb$export$159ccd8c63e17c58 = /* #__PURE__ */ (0, $4eE2e.factory)($7f8a468244a3a2cb$var$name, $7f8a468244a3a2cb$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is negative: smaller than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNegative(x)
   *
   * Examples:
   *
   *    math.isNegative(3)                     // returns false
   *    math.isNegative(-2)                    // returns true
   *    math.isNegative(0)                     // returns false
   *    math.isNegative(-0)                    // returns false
   *    math.isNegative(math.bignumber(2))     // returns false
   *    math.isNegative(math.fraction(-2, 5))  // returns true
   *    math.isNegative('-2')                  // returns true
   *    math.isNegative([2, 0, -3]')           // returns [false, false, true]
   *
   * See also:
   *
   *    isNumeric, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($7f8a468244a3a2cb$var$name, {
        number: (0, $7f7zD.isNegativeNumber),
        BigNumber: function BigNumber(x) {
            return x.isNeg() && !x.isZero() && !x.isNaN();
        },
        Fraction: function Fraction(x) {
            return x.s < 0; // It's enough to decide on the sign
        },
        Unit: function Unit(x) {
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("aUeQh", function(module, exports) {

$parcel$export(module.exports, "createIsNumeric", () => $7f0aa5b76410e1df$export$85b0631fa122b7f1);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");
var $7f0aa5b76410e1df$var$name = 'isNumeric';
var $7f0aa5b76410e1df$var$dependencies = [
    'typed'
];
var $7f0aa5b76410e1df$export$85b0631fa122b7f1 = /* #__PURE__ */ (0, $4eE2e.factory)($7f0aa5b76410e1df$var$name, $7f0aa5b76410e1df$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is an numeric value.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNumeric(x)
   *
   * Examples:
   *
   *    math.isNumeric(2)                     // returns true
   *    math.isNumeric('2')                   // returns false
   *    math.hasNumericValue('2')             // returns true
   *    math.isNumeric(0)                     // returns true
   *    math.isNumeric(math.bignumber(500))   // returns true
   *    math.isNumeric(math.fraction(4))      // returns true
   *    math.isNumeric(math.complex('2-4i')   // returns false
   *    math.isNumeric([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, hasNumericValue
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, or `boolean`. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ return typed($7f0aa5b76410e1df$var$name, {
        'number | BigNumber | Fraction | boolean': function numberBigNumberFractionBoolean() {
            return true;
        },
        'Complex | Unit | string | null | undefined | Node': function ComplexUnitStringNullUndefinedNode() {
            return false;
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("1tonU", function(module, exports) {

$parcel$export(module.exports, "createIsPositive", () => $112b6a2d1c599168$export$2d862c12fb537dd9);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");

var $7f7zD = parcelRequire("7f7zD");
var $112b6a2d1c599168$var$name = 'isPositive';
var $112b6a2d1c599168$var$dependencies = [
    'typed'
];
var $112b6a2d1c599168$export$2d862c12fb537dd9 = /* #__PURE__ */ (0, $4eE2e.factory)($112b6a2d1c599168$var$name, $112b6a2d1c599168$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is positive: larger than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPositive(x)
   *
   * Examples:
   *
   *    math.isPositive(3)                     // returns true
   *    math.isPositive(-2)                    // returns false
   *    math.isPositive(0)                     // returns false
   *    math.isPositive(-0)                    // returns false
   *    math.isPositive(0.5)                   // returns true
   *    math.isPositive(math.bignumber(2))     // returns true
   *    math.isPositive(math.fraction(-2, 5))  // returns false
   *    math.isPositive(math.fraction(1,3))    // returns false
   *    math.isPositive('2')                   // returns true
   *    math.isPositive([2, 0, -3])            // returns [true, false, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($112b6a2d1c599168$var$name, {
        number: (0, $7f7zD.isPositiveNumber),
        BigNumber: function BigNumber(x) {
            return !x.isNeg() && !x.isZero() && !x.isNaN();
        },
        Fraction: function Fraction(x) {
            return x.s > 0 && x.n > 0;
        },
        Unit: function Unit(x) {
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("dUvuH", function(module, exports) {

$parcel$export(module.exports, "createIsPrime", () => $a208ef63aaa5fc97$export$4e02350f5fb7a050);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");
var $a208ef63aaa5fc97$var$name = 'isPrime';
var $a208ef63aaa5fc97$var$dependencies = [
    'typed'
];
var $a208ef63aaa5fc97$export$4e02350f5fb7a050 = /* #__PURE__ */ (0, $4eE2e.factory)($a208ef63aaa5fc97$var$name, $a208ef63aaa5fc97$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is prime: has no divisors other than itself and one.
   * The function supports type `number`, `bignumber`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPrime(x)
   *
   * Examples:
   *
   *    math.isPrime(3)                     // returns true
   *    math.isPrime(-2)                    // returns false
   *    math.isPrime(0)                     // returns false
   *    math.isPrime(-0)                    // returns false
   *    math.isPrime(0.5)                   // returns false
   *    math.isPrime('2')                   // returns true
   *    math.isPrime([2, 17, 100])           // returns [true, true, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($a208ef63aaa5fc97$var$name, {
        number: function number(x) {
            if (x * 0 !== 0) return false;
            if (x <= 3) return x > 1;
            if (x % 2 === 0 || x % 3 === 0) return false;
            for(var i = 5; i * i <= x; i += 6){
                if (x % i === 0 || x % (i + 2) === 0) return false;
            }
            return true;
        },
        BigNumber: function BigNumber(n) {
            if (n.toNumber() * 0 !== 0) return false;
            if (n.lte(3)) return n.gt(1);
            if (n.mod(2).eq(0) || n.mod(3).eq(0)) return false;
            if (n.lt(Math.pow(2, 32))) {
                var x = n.toNumber();
                for(var i = 5; i * i <= x; i += 6){
                    if (x % i === 0 || x % (i + 2) === 0) return false;
                }
                return true;
            }
            function modPow(base, exponent, modulus) {
                // exponent can be huge, use non-recursive variant
                var accumulator = 1;
                while(!exponent.eq(0))if (exponent.mod(2).eq(0)) {
                    exponent = exponent.div(2);
                    base = base.mul(base).mod(modulus);
                } else {
                    exponent = exponent.sub(1);
                    accumulator = base.mul(accumulator).mod(modulus);
                }
                return accumulator;
            } // https://en.wikipedia.org/wiki/Miller%E2%80%93Rabin_primality_test#Deterministic_variants
            var Decimal = n.constructor.clone({
                precision: n.toFixed(0).length * 2
            });
            n = new Decimal(n);
            var r = 0;
            var d = n.sub(1);
            while(d.mod(2).eq(0)){
                d = d.div(2);
                r += 1;
            }
            var bases = null; // https://en.wikipedia.org/wiki/Miller–Rabin_primality_test#Testing_against_small_sets_of_bases
            if (n.lt('3317044064679887385961981')) bases = [
                2,
                3,
                5,
                7,
                11,
                13,
                17,
                19,
                23,
                29,
                31,
                37,
                41
            ].filter((x)=>x < n);
            else {
                var max = Math.min(n.toNumber() - 2, Math.floor(2 * Math.pow(n.toFixed(0).length * Math.log(10), 2)));
                bases = [];
                for(var _i = 2; _i <= max; _i += 1)bases.push(max);
            }
            for(var _i2 = 0; _i2 < bases.length; _i2 += 1){
                var a = bases[_i2];
                var adn = modPow(n.sub(n).add(a), d, n);
                if (!adn.eq(1)) for(var _i3 = 0, _x = adn; !_x.eq(n.sub(1)); _i3 += 1, _x = _x.mul(_x).mod(n)){
                    if (_i3 === r - 1) return false;
                }
            }
            return true;
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("kFQL0", function(module, exports) {

$parcel$export(module.exports, "createIsZero", () => $f0d08f734e31022f$export$ea90652d00dab06e);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");

var $7f7zD = parcelRequire("7f7zD");
var $f0d08f734e31022f$var$name = 'isZero';
var $f0d08f734e31022f$var$dependencies = [
    'typed'
];
var $f0d08f734e31022f$export$ea90652d00dab06e = /* #__PURE__ */ (0, $4eE2e.factory)($f0d08f734e31022f$var$name, $f0d08f734e31022f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is zero.
   * The function can check for zero for types `number`, `BigNumber`, `Fraction`,
   * `Complex`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isZero(x)
   *
   * Examples:
   *
   *    math.isZero(0)                     // returns true
   *    math.isZero(2)                     // returns false
   *    math.isZero(0.5)                   // returns false
   *    math.isZero(math.bignumber(0))     // returns true
   *    math.isZero(math.fraction(0))      // returns true
   *    math.isZero(math.fraction(1,3))    // returns false
   *    math.isZero(math.complex('2 - 4i') // returns false
   *    math.isZero(math.complex('0i')     // returns true
   *    math.isZero('0')                   // returns true
   *    math.isZero('2')                   // returns false
   *    math.isZero([2, 0, -3]')           // returns [false, true, false]
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isInteger
   *
   * @param {number | BigNumber | Complex | Fraction | Unit | Array | Matrix} x       Value to be tested
   * @return {boolean}  Returns true when `x` is zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($f0d08f734e31022f$var$name, {
        number: (0, $7f7zD.isZeroNumber),
        BigNumber: function BigNumber(x) {
            return x.isZero();
        },
        Complex: function Complex(x) {
            return x.re === 0 && x.im === 0;
        },
        Fraction: function Fraction(x) {
            return x.d === 1 && x.n === 0;
        },
        Unit: function Unit(x) {
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("lSqCP", function(module, exports) {

$parcel$export(module.exports, "createKldivergence", () => $fed34b5e2727feaa$export$eaa5cb8fd86b8d43);

var $4eE2e = parcelRequire("4eE2e");
var $fed34b5e2727feaa$var$name = 'kldivergence';
var $fed34b5e2727feaa$var$dependencies = [
    'typed',
    'matrix',
    'divide',
    'sum',
    'multiply',
    'dotDivide',
    'log',
    'isNumeric'
];
var $fed34b5e2727feaa$export$eaa5cb8fd86b8d43 = /* #__PURE__ */ (0, $4eE2e.factory)($fed34b5e2727feaa$var$name, $fed34b5e2727feaa$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divide: divide, sum: sum, multiply: multiply, dotDivide: dotDivide, log: log, isNumeric: isNumeric } = _ref;
    /**
     * Calculate the Kullback-Leibler (KL) divergence  between two distributions
     *
     * Syntax:
     *
     *     math.kldivergence(x, y)
     *
     * Examples:
     *
     *     math.kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])   //returns 0.24376698773121153
     *
     *
     * @param  {Array | Matrix} q    First vector
     * @param  {Array | Matrix} p    Second vector
     * @return {number}              Returns distance between q and p
     */ return typed($fed34b5e2727feaa$var$name, {
        'Array, Array': function ArrayArray(q, p) {
            return _kldiv(matrix(q), matrix(p));
        },
        'Matrix, Array': function MatrixArray(q, p) {
            return _kldiv(q, matrix(p));
        },
        'Array, Matrix': function ArrayMatrix(q, p) {
            return _kldiv(matrix(q), p);
        },
        'Matrix, Matrix': function MatrixMatrix(q, p) {
            return _kldiv(q, p);
        }
    });
    function _kldiv(q, p) {
        var plength = p.size().length;
        var qlength = q.size().length;
        if (plength > 1) throw new Error('first object must be one dimensional');
        if (qlength > 1) throw new Error('second object must be one dimensional');
        if (plength !== qlength) throw new Error('Length of two vectors must be equal');
         // Before calculation, apply normalization
        var sumq = sum(q);
        if (sumq === 0) throw new Error('Sum of elements in first object must be non zero');
        var sump = sum(p);
        if (sump === 0) throw new Error('Sum of elements in second object must be non zero');
        var qnorm = divide(q, sum(q));
        var pnorm = divide(p, sum(p));
        var result = sum(multiply(qnorm, log(dotDivide(qnorm, pnorm))));
        if (isNumeric(result)) return result;
        else return Number.NaN;
    }
});

});

parcelRegister("lD1Hd", function(module, exports) {

$parcel$export(module.exports, "createKron", () => $fbee8e4bac52f66c$export$cee275bf38ddc295);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $fbee8e4bac52f66c$var$name = 'kron';
var $fbee8e4bac52f66c$var$dependencies = [
    'typed',
    'matrix',
    'multiplyScalar'
];
var $fbee8e4bac52f66c$export$cee275bf38ddc295 = /* #__PURE__ */ (0, $4eE2e.factory)($fbee8e4bac52f66c$var$name, $fbee8e4bac52f66c$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, multiplyScalar: multiplyScalar } = _ref;
    /**
     * Calculates the kronecker product of 2 matrices or vectors.
     *
     * NOTE: If a one dimensional vector / matrix is given, it will be
     * wrapped so its two dimensions.
     * See the examples.
     *
     * Syntax:
     *
     *    math.kron(x, y)
     *
     * Examples:
     *
     *    math.kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])
     *    // returns [ [ 1, 2, 0, 0 ], [ 3, 4, 0, 0 ], [ 0, 0, 1, 2 ], [ 0, 0, 3, 4 ] ]
     *
     *    math.kron([1,1], [2,3,4])
     *    // returns [ [ 2, 3, 4, 2, 3, 4 ] ]
     *
     * See also:
     *
     *    multiply, dot, cross
     *
     * @param  {Array | Matrix} x     First vector
     * @param  {Array | Matrix} y     Second vector
     * @return {Array | Matrix}       Returns the kronecker product of `x` and `y`
     */ return typed($fbee8e4bac52f66c$var$name, {
        'Matrix, Matrix': function MatrixMatrix(x, y) {
            return matrix(_kron(x.toArray(), y.toArray()));
        },
        'Matrix, Array': function MatrixArray(x, y) {
            return matrix(_kron(x.toArray(), y));
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            return matrix(_kron(x, y.toArray()));
        },
        'Array, Array': _kron
    });
    /**
     * Calculate the kronecker product of two matrices / vectors
     * @param {Array} a  First vector
     * @param {Array} b  Second vector
     * @returns {Array} Returns the kronecker product of x and y
     * @private
     */ function _kron(a, b) {
        // Deal with the dimensions of the matricies.
        if ((0, $10UPF.arraySize)(a).length === 1) // Wrap it in a 2D Matrix
        a = [
            a
        ];
        if ((0, $10UPF.arraySize)(b).length === 1) // Wrap it in a 2D Matrix
        b = [
            b
        ];
        if ((0, $10UPF.arraySize)(a).length > 2 || (0, $10UPF.arraySize)(b).length > 2) throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = " + JSON.stringify(a.length) + ', y = ' + JSON.stringify(b.length) + ')');
        var t = [];
        var r = [];
        return a.map(function(a) {
            return b.map(function(b) {
                r = [];
                t.push(r);
                return a.map(function(y) {
                    return b.map(function(x) {
                        return r.push(multiplyScalar(y, x));
                    });
                });
            });
        }) && t;
    }
});

});

parcelRegister("fueOV", function(module, exports) {

$parcel$export(module.exports, "createLarger", () => $b465275f7beb93b7$export$af9bc16ae70e9aa8);

var $iV3Fc = parcelRequire("iV3Fc");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");

var $6MKpt = parcelRequire("6MKpt");

var $ai5Sw = parcelRequire("ai5Sw");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $laEuG = parcelRequire("laEuG");

var $KKjvJ = parcelRequire("KKjvJ");
var $b465275f7beb93b7$var$name = 'larger';
var $b465275f7beb93b7$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'DenseMatrix'
];
var $b465275f7beb93b7$export$af9bc16ae70e9aa8 = /* #__PURE__ */ (0, $4eE2e.factory)($b465275f7beb93b7$var$name, $b465275f7beb93b7$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $ai5Sw.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether value x is larger than y.
   *
   * The function returns true when x is larger than y and the relative
   * difference between x and y is larger than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.larger(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 3)             // returns false
   *    math.larger(5, 2 + 2)         // returns true
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.larger(a, b)             // returns false
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger than y, else returns false
   */ return typed($b465275f7beb93b7$var$name, {
        'boolean, boolean': function booleanBoolean(x, y) {
            return x > y;
        },
        'number, number': function numberNumber(x, y) {
            return x > y && !(0, $6egKm.nearlyEqual)(x, y, config.epsilon);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.gt(y) && !(0, $iV3Fc.nearlyEqual)(x, y, config.epsilon);
        },
        'Fraction, Fraction': function FractionFraction(x, y) {
            return x.compare(y) === 1;
        },
        'Complex, Complex': function ComplexComplex() {
            throw new TypeError('No ordering relation is defined for complex numbers');
        },
        'Unit, Unit': function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error('Cannot compare units with different base');
            return this(x.value, y.value);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $b465275f7beb93b7$export$36e0507f86788708 = /* #__PURE__ */ (0, $4eE2e.factory)($b465275f7beb93b7$var$name, [
    'typed',
    'config'
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($b465275f7beb93b7$var$name, {
        'number, number': function numberNumber(x, y) {
            return x > y && !(0, $6egKm.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});

parcelRegister("ckhIK", function(module, exports) {

$parcel$export(module.exports, "createLargerEq", () => $8f951943b317051e$export$26aa7f5b5fee1150);

var $iV3Fc = parcelRequire("iV3Fc");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");

var $6MKpt = parcelRequire("6MKpt");

var $ai5Sw = parcelRequire("ai5Sw");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $laEuG = parcelRequire("laEuG");

var $KKjvJ = parcelRequire("KKjvJ");
var $8f951943b317051e$var$name = 'largerEq';
var $8f951943b317051e$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'DenseMatrix'
];
var $8f951943b317051e$export$26aa7f5b5fee1150 = /* #__PURE__ */ (0, $4eE2e.factory)($8f951943b317051e$var$name, $8f951943b317051e$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $ai5Sw.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether value x is larger or equal to y.
   *
   * The function returns true when x is larger than y or the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.largerEq(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 1 + 1)         // returns false
   *    math.largerEq(2, 1 + 1)       // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger or equal to y, else returns false
   */ return typed($8f951943b317051e$var$name, {
        'boolean, boolean': function booleanBoolean(x, y) {
            return x >= y;
        },
        'number, number': function numberNumber(x, y) {
            return x >= y || (0, $6egKm.nearlyEqual)(x, y, config.epsilon);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.gte(y) || (0, $iV3Fc.nearlyEqual)(x, y, config.epsilon);
        },
        'Fraction, Fraction': function FractionFraction(x, y) {
            return x.compare(y) !== -1;
        },
        'Complex, Complex': function ComplexComplex() {
            throw new TypeError('No ordering relation is defined for complex numbers');
        },
        'Unit, Unit': function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error('Cannot compare units with different base');
            return this(x.value, y.value);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $8f951943b317051e$export$494ed93834104475 = /* #__PURE__ */ (0, $4eE2e.factory)($8f951943b317051e$var$name, [
    'typed',
    'config'
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($8f951943b317051e$var$name, {
        'number, number': function numberNumber(x, y) {
            return x >= y || (0, $6egKm.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});

parcelRegister("eDLq1", function(module, exports) {

$parcel$export(module.exports, "createLcm", () => $aa897d8cd3cb67ee$export$5d3af1956d9bb33b);

var $4eE2e = parcelRequire("4eE2e");

var $5IUkw = parcelRequire("5IUkw");

var $eIf4a = parcelRequire("eIf4a");

var $hXAgg = parcelRequire("hXAgg");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");

var $eRNhQ = parcelRequire("eRNhQ");
var $aa897d8cd3cb67ee$var$name = 'lcm';
var $aa897d8cd3cb67ee$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar'
];
var $aa897d8cd3cb67ee$export$5d3af1956d9bb33b = /* #__PURE__ */ (0, $4eE2e.factory)($aa897d8cd3cb67ee$var$name, $aa897d8cd3cb67ee$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar } = _ref;
    var algorithm02 = (0, $5IUkw.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $eIf4a.createAlgorithm06)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculate the least common multiple for two or more values or arrays.
   *
   * lcm is defined as:
   *
   *     lcm(a, b) = abs(a * b) / gcd(a, b)
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.lcm(a, b)
   *    math.lcm(a, b, c, ...)
   *
   * Examples:
   *
   *    math.lcm(4, 6)               // returns 12
   *    math.lcm(6, 21)              // returns 42
   *    math.lcm(6, 21, 5)           // returns 210
   *
   *    math.lcm([4, 6], [6, 21])    // returns [12, 42]
   *
   * See also:
   *
   *    gcd, xgcd
   *
   * @param {... number | BigNumber | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Array | Matrix}                           The least common multiple
   */ return typed($aa897d8cd3cb67ee$var$name, {
        'number, number': (0, $eRNhQ.lcmNumber),
        'BigNumber, BigNumber': _lcmBigNumber,
        'Fraction, Fraction': function FractionFraction(x, y) {
            return x.lcm(y);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, this);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, number | BigNumber': function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, number | BigNumber': function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        'number | BigNumber, SparseMatrix': function numberBigNumberSparseMatrix(x, y) {
            return algorithm11(y, x, this, true);
        },
        'number | BigNumber, DenseMatrix': function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, number | BigNumber': function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'number | BigNumber, Array': function numberBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        },
        // TODO: need a smarter notation here
        'Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber': function ArrayMatrixNumberBigNumberArrayMatrixNumberBigNumberArrayMatrixNumberBigNumber(a, b, args) {
            var res = this(a, b);
            for(var i = 0; i < args.length; i++)res = this(res, args[i]);
            return res;
        }
    });
    /**
   * Calculate lcm for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns the least common multiple of a and b
   * @private
   */ function _lcmBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error('Parameters in function lcm must be integer numbers');
        if (a.isZero()) return a;
        if (b.isZero()) return b;
         // https://en.wikipedia.org/wiki/Euclidean_algorithm
        // evaluate lcm here inline to reduce overhead
        var prod = a.times(b);
        while(!b.isZero()){
            var t = b;
            b = a.mod(t);
            a = t;
        }
        return prod.div(a).abs();
    }
});

});

parcelRegister("1tZnA", function(module, exports) {

$parcel$export(module.exports, "createLeftShift", () => $11481c942f3114e2$export$ce15600b23f5e78);

var $5IUkw = parcelRequire("5IUkw");

var $hXAgg = parcelRequire("hXAgg");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");

var $bCo9f = parcelRequire("bCo9f");

var $ecxvm = parcelRequire("ecxvm");

var $i6sSD = parcelRequire("i6sSD");

var $4eE2e = parcelRequire("4eE2e");

var $aFhba = parcelRequire("aFhba");

var $2hy17 = parcelRequire("2hy17");
var $11481c942f3114e2$var$name = 'leftShift';
var $11481c942f3114e2$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'zeros',
    'DenseMatrix'
];
var $11481c942f3114e2$export$ce15600b23f5e78 = /* #__PURE__ */ (0, $4eE2e.factory)($11481c942f3114e2$var$name, $11481c942f3114e2$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $bCo9f.createAlgorithm01)({
        typed: typed
    });
    var algorithm02 = (0, $5IUkw.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $i6sSD.createAlgorithm08)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $ecxvm.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise left logical shift of a value x by y number of bits, `x << y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.leftShift(x, y)
   *
   * Examples:
   *
   *    math.leftShift(1, 2)               // returns number 4
   *
   *    math.leftShift([1, 2, 3], 4)       // returns Array [16, 32, 64]
   *
   * See also:
   *
   *    leftShift, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber} y Amount of shifts
   * @return {number | BigNumber | Array | Matrix} `x` shifted left `y` times
   */ return typed($11481c942f3114e2$var$name, {
        'number, number': (0, $aFhba.leftShiftNumber),
        'BigNumber, BigNumber': (0, $2hy17.leftShiftBigNumber),
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, this, false);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, number | BigNumber': function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, number | BigNumber': function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, this, false);
        },
        'number | BigNumber, SparseMatrix': function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, this, true);
        },
        'number | BigNumber, DenseMatrix': function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, this, true);
        },
        'Array, number | BigNumber': function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        'number | BigNumber, Array': function numberBigNumberArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
});

});
parcelRegister("i6sSD", function(module, exports) {

$parcel$export(module.exports, "createAlgorithm08", () => $d2df308b57a1c010$export$59a068f853cfbf8);

var $4eE2e = parcelRequire("4eE2e");

var $iAoVB = parcelRequire("iAoVB");
var $d2df308b57a1c010$var$name = 'algorithm08';
var $d2df308b57a1c010$var$dependencies = [
    'typed',
    'equalScalar'
];
var $d2df308b57a1c010$export$59a068f853cfbf8 = /* #__PURE__ */ (0, $4eE2e.factory)($d2df308b57a1c010$var$name, $d2df308b57a1c010$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm08(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $iAoVB.DimensionError)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
         // sparse matrix cannot be a Pattern matrix
        if (!avalues || !bvalues) throw new Error('Cannot perform operation on Pattern Sparse Matrices');
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === 'string' && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = []; // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // vars
        var k, k0, k1, i; // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop values in a
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // mark workspace
                w[i] = mark; // set value
                x[i] = avalues[k]; // add index
                cindex.push(i);
            } // loop values in b
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // check value exists in workspace
                if (w[i] === mark) // evaluate callback
                x[i] = cf(x[i], bvalues[k]);
            } // initialize first index in j
            k = cptr[j]; // loop index in j
            while(k < cindex.length){
                // row
                i = cindex[k]; // value @ i
                var v = x[i]; // check for zero value
                if (!eq(v, zero)) {
                    // push value
                    cvalues.push(v); // increment pointer
                    k++;
                } else // remove value @ i, do not increment pointer
                cindex.splice(k, 1);
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});

});


parcelRegister("e2lPV", function(module, exports) {

$parcel$export(module.exports, "createLog", () => $a38230ddae9fc071$export$aea8a16d5c9d1b93);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $eRNhQ = parcelRequire("eRNhQ");
var $a38230ddae9fc071$var$name = 'log';
var $a38230ddae9fc071$var$dependencies = [
    'config',
    'typed',
    'divideScalar',
    'Complex'
];
var $a38230ddae9fc071$export$aea8a16d5c9d1b93 = /* #__PURE__ */ (0, $4eE2e.factory)($a38230ddae9fc071$var$name, $a38230ddae9fc071$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, Complex: Complex } = _ref;
    /**
   * Calculate the logarithm of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log(x)
   *    math.log(x, base)
   *
   * Examples:
   *
   *    math.log(3.5)                  // returns 1.252762968495368
   *    math.exp(math.log(2.4))        // returns 2.4
   *
   *    math.pow(10, 4)                // returns 10000
   *    math.log(10000, 10)            // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *
   *    math.log(1024, 2)              // returns 10
   *    math.pow(2, 10)                // returns 1024
   *
   * See also:
   *
   *    exp, log2, log10, log1p
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x` is calculated.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the logarithm of `x`
   */ return typed($a38230ddae9fc071$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $eRNhQ.logNumber)(x);
            else // negative value -> complex value computation
            return new Complex(x, 0).log();
        },
        Complex: function Complex(x) {
            return x.log();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.ln();
            else // downgrade to number, return Complex valued result
            return new Complex(x.toNumber(), 0).log();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        },
        'any, any': function anyAny(x, base) {
            // calculate logarithm for a specified base, log(x, base)
            return divideScalar(this(x), this(base));
        }
    });
});

});

parcelRegister("7Gn1s", function(module, exports) {

$parcel$export(module.exports, "createLog10", () => $597e506b62db06bc$export$dea4efeb24d4590d);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $eRNhQ = parcelRequire("eRNhQ");
var $597e506b62db06bc$var$name = 'log10';
var $597e506b62db06bc$var$dependencies = [
    'typed',
    'config',
    'Complex'
];
var $597e506b62db06bc$export$dea4efeb24d4590d = /* #__PURE__ */ (0, $4eE2e.factory)($597e506b62db06bc$var$name, $597e506b62db06bc$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: _Complex } = _ref;
    /**
   * Calculate the 10-base logarithm of a value. This is the same as calculating `log(x, 10)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log10(x)
   *
   * Examples:
   *
   *    math.log10(0.00001)            // returns -5
   *    math.log10(10000)              // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *    math.pow(10, 4)                // returns 10000
   *
   * See also:
   *
   *    exp, log, log1p, log2
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 10-base logarithm of `x`
   */ return typed($597e506b62db06bc$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $eRNhQ.log10Number)(x);
            else // negative value -> complex value computation
            return new _Complex(x, 0).log().div(Math.LN10);
        },
        Complex: function Complex(x) {
            return new _Complex(x).log().div(Math.LN10);
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log();
            else // downgrade to number, return Complex valued result
            return new _Complex(x.toNumber(), 0).log().div(Math.LN10);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("aelBe", function(module, exports) {

$parcel$export(module.exports, "createLog1p", () => $772bf760a202fd71$export$93da279859a704f0);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $6egKm = parcelRequire("6egKm");
var $772bf760a202fd71$var$name = 'log1p';
var $772bf760a202fd71$var$dependencies = [
    'typed',
    'config',
    'divideScalar',
    'log',
    'Complex'
];
var $772bf760a202fd71$export$93da279859a704f0 = /* #__PURE__ */ (0, $4eE2e.factory)($772bf760a202fd71$var$name, $772bf760a202fd71$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, log: log, Complex: Complex } = _ref;
    /**
   * Calculate the logarithm of a `value+1`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log1p(x)
   *    math.log1p(x, base)
   *
   * Examples:
   *
   *    math.log1p(2.5)                 // returns 1.252762968495368
   *    math.exp(math.log1p(1.4))       // returns 2.4
   *
   *    math.pow(10, 4)                 // returns 10000
   *    math.log1p(9999, 10)            // returns 4
   *    math.log1p(9999) / math.log(10) // returns 4
   *
   * See also:
   *
   *    exp, log, log2, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm of `x+1`.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x+1` is calculated.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the logarithm of `x+1`
   */ return typed($772bf760a202fd71$var$name, {
        number: function number(x) {
            if (x >= -1 || config.predictable) return (0, $6egKm.log1p)(x);
            else // negative value -> complex value computation
            return _log1pComplex(new Complex(x, 0));
        },
        Complex: _log1pComplex,
        BigNumber: function BigNumber(x) {
            var y = x.plus(1);
            if (!y.isNegative() || config.predictable) return y.ln();
            else // downgrade to number, return Complex valued result
            return _log1pComplex(new Complex(x.toNumber(), 0));
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        },
        'any, any': function anyAny(x, base) {
            // calculate logarithm for a specified base, log1p(x, base)
            return divideScalar(this(x), log(base));
        }
    });
    /**
   * Calculate the natural logarithm of a complex number + 1
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log1pComplex(x) {
        var xRe1p = x.re + 1;
        return new Complex(Math.log(Math.sqrt(xRe1p * xRe1p + x.im * x.im)), Math.atan2(x.im, xRe1p));
    }
});

});

parcelRegister("8Dful", function(module, exports) {

$parcel$export(module.exports, "createLog2", () => $648dfae9cd3b4c06$export$a993dae3988e0f19);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $eRNhQ = parcelRequire("eRNhQ");
var $648dfae9cd3b4c06$var$name = 'log2';
var $648dfae9cd3b4c06$var$dependencies = [
    'typed',
    'config',
    'Complex'
];
var $648dfae9cd3b4c06$export$a993dae3988e0f19 = /* #__PURE__ */ (0, $4eE2e.factory)($648dfae9cd3b4c06$var$name, $648dfae9cd3b4c06$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log2(x)
   *
   * Examples:
   *
   *    math.log2(0.03125)           // returns -5
   *    math.log2(16)                // returns 4
   *    math.log2(16) / math.log2(2) // returns 4
   *    math.pow(2, 4)               // returns 16
   *
   * See also:
   *
   *    exp, log, log1p, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 2-base logarithm of `x`
   */ return typed($648dfae9cd3b4c06$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $eRNhQ.log2Number)(x);
            else // negative value -> complex value computation
            return _log2Complex(new Complex(x, 0));
        },
        Complex: _log2Complex,
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log(2);
            else // downgrade to number, return Complex valued result
            return _log2Complex(new Complex(x.toNumber(), 0));
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
    /**
   * Calculate log2 for a complex value
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log2Complex(x) {
        var newX = Math.sqrt(x.re * x.re + x.im * x.im);
        return new Complex(Math.log2 ? Math.log2(newX) : Math.log(newX) / Math.LN2, Math.atan2(x.im, x.re) / Math.LN2);
    }
});

});

parcelRegister("dPUMt", function(module, exports) {

$parcel$export(module.exports, "createLsolve", () => $a12c1544c89d4248$export$1b88d04961967a10);

var $4eE2e = parcelRequire("4eE2e");

var $4ssS1 = parcelRequire("4ssS1");
var $a12c1544c89d4248$var$name = 'lsolve';
var $a12c1544c89d4248$var$dependencies = [
    'typed',
    'matrix',
    'divideScalar',
    'multiplyScalar',
    'subtract',
    'equalScalar',
    'DenseMatrix'
];
var $a12c1544c89d4248$export$1b88d04961967a10 = /* #__PURE__ */ (0, $4eE2e.factory)($a12c1544c89d4248$var$name, $a12c1544c89d4248$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $4ssS1.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds one solution of a linear equation system by forwards substitution. Matrix must be a lower triangular matrix. Throws an error if there's no solution.
   *
   * `L * x = b`
   *
   * Syntax:
   *
   *    math.lsolve(L, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = lsolve(a, b)  // [[-5.5], [20]]
   *
   * See also:
   *
   *    lsolveAll, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} L       A N x N matrix or array (L)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($a12c1544c89d4248$var$name, {
        'SparseMatrix, Array | Matrix': function SparseMatrixArrayMatrix(m, b) {
            return _sparseForwardSubstitution(m, b);
        },
        'DenseMatrix, Array | Matrix': function DenseMatrixArrayMatrix(m, b) {
            return _denseForwardSubstitution(m, b);
        },
        'Array, Array | Matrix': function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var r = _denseForwardSubstitution(m, b);
            return r.valueOf();
        }
    });
    function _denseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1]; // result
        var x = [];
        var mdata = m._data; // loop columns
        for(var j = 0; j < columns; j++){
            var bj = bdata[j][0] || 0;
            var xj = void 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = mdata[j][j];
                if (equalScalar(vjj, 0)) throw new Error('Linear system cannot be solved since matrix is singular');
                xj = divideScalar(bj, vjj); // loop rows
                for(var i = j + 1; i < rows; i++)bdata[i] = [
                    subtract(bdata[i][0] || 0, multiplyScalar(xj, mdata[i][j]))
                ];
            } else // degenerate row, we can choose any value
            xj = 0;
            x[j] = [
                xj
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // result
        var x = []; // loop columns
        for(var j = 0; j < columns; j++){
            var bj = bdata[j][0] || 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = 0; // matrix values & indices (column j)
                var jValues = [];
                var jIndices = []; // first and last index in the column
                var firstIndex = ptr[j];
                var lastIndex = ptr[j + 1]; // values in column, find value at [j, j]
                for(var k = firstIndex; k < lastIndex; k++){
                    var i = index[k]; // check row (rows are not sorted!)
                    if (i === j) vjj = values[k];
                    else if (i > j) {
                        // store lower triangular
                        jValues.push(values[k]);
                        jIndices.push(i);
                    }
                } // at this point we must have a value in vjj
                if (equalScalar(vjj, 0)) throw new Error('Linear system cannot be solved since matrix is singular');
                var xj = divideScalar(bj, vjj);
                for(var _k = 0, l = jIndices.length; _k < l; _k++){
                    var _i = jIndices[_k];
                    bdata[_i] = [
                        subtract(bdata[_i][0] || 0, multiplyScalar(xj, jValues[_k]))
                    ];
                }
                x[j] = [
                    xj
                ];
            } else // degenerate row, we can choose any value
            x[j] = [
                0
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});

});
parcelRegister("4ssS1", function(module, exports) {

$parcel$export(module.exports, "createSolveValidation", () => $33f02bfa28384b56$export$6accbcba5dda801d);

var $gs7TF = parcelRequire("gs7TF");

var $10UPF = parcelRequire("10UPF");

var $aEppI = parcelRequire("aEppI");
function $33f02bfa28384b56$export$6accbcba5dda801d(_ref) {
    var { DenseMatrix: DenseMatrix } = _ref;
    /**
   * Validates matrix and column vector b for backward/forward substitution algorithms.
   *
   * @param {Matrix} m            An N x N matrix
   * @param {Array | Matrix} b    A column vector
   * @param {Boolean} copy        Return a copy of vector b
   *
   * @return {DenseMatrix}        Dense column vector b
   */ return function solveValidation(m, b, copy) {
        var mSize = m.size();
        if (mSize.length !== 2) throw new RangeError('Matrix must be two dimensional (size: ' + (0, $aEppI.format)(mSize) + ')');
        var rows = mSize[0];
        var columns = mSize[1];
        if (rows !== columns) throw new RangeError('Matrix must be square (size: ' + (0, $aEppI.format)(mSize) + ')');
        var data = [];
        if ((0, $gs7TF.isMatrix)(b)) {
            var bSize = b.size();
            var bdata = b._data; // 1-dim vector
            if (bSize.length === 1) {
                if (bSize[0] !== rows) throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
                for(var i = 0; i < rows; i++)data[i] = [
                    bdata[i]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ],
                    datatype: b._datatype
                });
            } // 2-dim column
            if (bSize.length === 2) {
                if (bSize[0] !== rows || bSize[1] !== 1) throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
                if ((0, $gs7TF.isDenseMatrix)(b)) {
                    if (copy) {
                        data = [];
                        for(var _i = 0; _i < rows; _i++)data[_i] = [
                            bdata[_i][0]
                        ];
                        return new DenseMatrix({
                            data: data,
                            size: [
                                rows,
                                1
                            ],
                            datatype: b._datatype
                        });
                    }
                    return b;
                }
                if ((0, $gs7TF.isSparseMatrix)(b)) {
                    for(var _i2 = 0; _i2 < rows; _i2++)data[_i2] = [
                        0
                    ];
                    var values = b._values;
                    var index = b._index;
                    var ptr = b._ptr;
                    for(var k1 = ptr[1], k = ptr[0]; k < k1; k++){
                        var _i3 = index[k];
                        data[_i3][0] = values[k];
                    }
                    return new DenseMatrix({
                        data: data,
                        size: [
                            rows,
                            1
                        ],
                        datatype: b._datatype
                    });
                }
            }
            throw new RangeError('Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.');
        }
        if ((0, $gs7TF.isArray)(b)) {
            var bsize = (0, $10UPF.arraySize)(b);
            if (bsize.length === 1) {
                if (bsize[0] !== rows) throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
                for(var _i4 = 0; _i4 < rows; _i4++)data[_i4] = [
                    b[_i4]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            }
            if (bsize.length === 2) {
                if (bsize[0] !== rows || bsize[1] !== 1) throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
                for(var _i5 = 0; _i5 < rows; _i5++)data[_i5] = [
                    b[_i5][0]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            }
            throw new RangeError('Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.');
        }
    };
}

});


parcelRegister("SnoAE", function(module, exports) {

$parcel$export(module.exports, "createLsolveAll", () => $0a373124556160f0$export$70743fd0ad1f42d7);

var $4eE2e = parcelRequire("4eE2e");

var $4ssS1 = parcelRequire("4ssS1");
var $0a373124556160f0$var$name = 'lsolveAll';
var $0a373124556160f0$var$dependencies = [
    'typed',
    'matrix',
    'divideScalar',
    'multiplyScalar',
    'subtract',
    'equalScalar',
    'DenseMatrix'
];
var $0a373124556160f0$export$70743fd0ad1f42d7 = /* #__PURE__ */ (0, $4eE2e.factory)($0a373124556160f0$var$name, $0a373124556160f0$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $4ssS1.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds all solutions of a linear equation system by forwards substitution. Matrix must be a lower triangular matrix.
   *
   * `L * x = b`
   *
   * Syntax:
   *
   *    math.lsolveAll(L, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = lsolveAll(a, b)  // [ [[-5.5], [20]] ]
   *
   * See also:
   *
   *    lsolve, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} L       A N x N matrix or array (L)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix[] | Array[]}  An array of affine-independent column vectors (x) that solve the linear system
   */ return typed($0a373124556160f0$var$name, {
        'SparseMatrix, Array | Matrix': function SparseMatrixArrayMatrix(m, b) {
            return _sparseForwardSubstitution(m, b);
        },
        'DenseMatrix, Array | Matrix': function DenseMatrixArrayMatrix(m, b) {
            return _denseForwardSubstitution(m, b);
        },
        'Array, Array | Matrix': function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var R = _denseForwardSubstitution(m, b);
            return R.map((r)=>r.valueOf());
        }
    });
    function _denseForwardSubstitution(m, b_) {
        // the algorithm is derived from
        // https://www.overleaf.com/read/csvgqdxggyjv
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var M = m._data;
        var rows = m._size[0];
        var columns = m._size[1]; // loop columns
        for(var i = 0; i < columns; i++){
            var L = B.length; // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                if (!equalScalar(M[i][i], 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], M[i][i]);
                    for(var j = i + 1; j < columns; j++)// b[j] -= b[i] * M[j,i]
                    b[j] = subtract(b[j], multiplyScalar(b[i], M[j][i]));
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j = i + 1; _j < columns; _j++)bNew[_j] = subtract(bNew[_j], M[_j][i]);
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
    function _sparseForwardSubstitution(m, b_) {
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // loop columns
        for(var i = 0; i < columns; i++){
            var L = B.length; // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k]; // values & indices (column i)
                var iValues = [];
                var iIndices = []; // first & last indeces in column
                var firstIndex = ptr[i];
                var lastIndex = ptr[i + 1]; // find the value at [i, i]
                var Mii = 0;
                for(var j = firstIndex; j < lastIndex; j++){
                    var J = index[j]; // check row
                    if (J === i) Mii = values[j];
                    else if (J > i) {
                        // store lower triangular
                        iValues.push(values[j]);
                        iIndices.push(J);
                    }
                }
                if (!equalScalar(Mii, 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], Mii);
                    for(var _j2 = 0, _lastIndex = iIndices.length; _j2 < _lastIndex; _j2++){
                        var _J = iIndices[_j2];
                        b[_J] = subtract(b[_J], multiplyScalar(b[i], iValues[_j2]));
                    }
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j3 = 0, _lastIndex2 = iIndices.length; _j3 < _lastIndex2; _j3++){
                        var _J2 = iIndices[_j3];
                        bNew[_J2] = subtract(bNew[_J2], iValues[_j3]);
                    }
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
});

});

parcelRegister("dMQoA", function(module, exports) {

$parcel$export(module.exports, "createLup", () => $a09866b9fce37410$export$86ddf344397699d5);

var $4mYv9 = parcelRequire("4mYv9");

var $4eE2e = parcelRequire("4eE2e");
var $a09866b9fce37410$var$name = 'lup';
var $a09866b9fce37410$var$dependencies = [
    'typed',
    'matrix',
    'abs',
    'addScalar',
    'divideScalar',
    'multiplyScalar',
    'subtract',
    'larger',
    'equalScalar',
    'unaryMinus',
    'DenseMatrix',
    'SparseMatrix',
    'Spa'
];
var $a09866b9fce37410$export$86ddf344397699d5 = /* #__PURE__ */ (0, $4eE2e.factory)($a09866b9fce37410$var$name, $a09866b9fce37410$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, abs: abs, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, larger: larger, equalScalar: equalScalar, unaryMinus: unaryMinus, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix, Spa: Spa } = _ref;
    /**
   * Calculate the Matrix LU decomposition with partial pivoting. Matrix `A` is decomposed in two matrices (`L`, `U`) and a
   * row permutation vector `p` where `A[p,:] = L * U`
   *
   * Syntax:
   *
   *    math.lup(A)
   *
   * Example:
   *
   *    const m = [[2, 1], [1, 4]]
   *    const r = math.lup(m)
   *    // r = {
   *    //   L: [[1, 0], [0.5, 1]],
   *    //   U: [[2, 1], [0, 3.5]],
   *    //   P: [0, 1]
   *    // }
   *
   * See also:
   *
   *    slu, lsolve, lusolve, usolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array for which to get the LUP decomposition.
   *
   * @return {{L: Array | Matrix, U: Array | Matrix, P: Array.<number>}} The lower triangular matrix, the upper triangular matrix and the permutation matrix.
   */ return typed($a09866b9fce37410$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseLUP(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseLUP(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a); // lup, use matrix implementation
            var r = _denseLUP(m); // result
            return {
                L: r.L.valueOf(),
                U: r.U.valueOf(),
                p: r.p
            };
        }
    });
    function _denseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // minimum rows and columns
        var n = Math.min(rows, columns); // matrix array, clone original data
        var data = (0, $4mYv9.clone)(m._data); // l matrix arrays
        var ldata = [];
        var lsize = [
            rows,
            n
        ]; // u matrix arrays
        var udata = [];
        var usize = [
            n,
            columns
        ]; // vars
        var i, j, k; // permutation vector
        var p = [];
        for(i = 0; i < rows; i++)p[i] = i;
         // loop columns
        for(j = 0; j < columns; j++){
            // skip first column in upper triangular matrix
            if (j > 0) // loop rows
            for(i = 0; i < rows; i++){
                // min i,j
                var min = Math.min(i, j); // v[i, j]
                var s = 0; // loop up to min
                for(k = 0; k < min; k++)// s = l[i, k] - data[k, j]
                s = addScalar(s, multiplyScalar(data[i][k], data[k][j]));
                data[i][j] = subtract(data[i][j], s);
            }
             // row with larger value in cvector, row >= j
            var pi = j;
            var pabsv = 0;
            var vjj = 0; // loop rows
            for(i = j; i < rows; i++){
                // data @ i, j
                var v = data[i][j]; // absolute value
                var absv = abs(v); // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = i; // update max value
                    pabsv = absv; // value @ [j, j]
                    vjj = v;
                }
            } // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in p
                p[j] = [
                    p[pi],
                    p[pi] = p[j]
                ][0]; // swap j <-> pi in data
                DenseMatrix._swapRows(j, pi, data);
            } // check column is in lower triangular matrix
            if (j < rows) // loop rows (lower triangular matrix)
            for(i = j + 1; i < rows; i++){
                // value @ i, j
                var vij = data[i][j];
                if (!equalScalar(vij, 0)) // update data
                data[i][j] = divideScalar(data[i][j], vjj);
            }
        } // loop columns
        for(j = 0; j < columns; j++)// loop rows
        for(i = 0; i < rows; i++){
            // initialize row in arrays
            if (j === 0) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i] = [];
                 // L
                ldata[i] = [];
            } // check we are in the upper triangular matrix
            if (i < j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                 // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 0;
                continue;
            } // diagonal value
            if (i === j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                 // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 1;
                continue;
            } // check row exists in upper triangular matrix
            if (i < columns) // U
            udata[i][j] = 0;
             // check column exists in lower triangular matrix
            if (j < rows) // L
            ldata[i][j] = data[i][j];
        }
         // l matrix
        var l = new DenseMatrix({
            data: ldata,
            size: lsize
        }); // u matrix
        var u = new DenseMatrix({
            data: udata,
            size: usize
        }); // p vector
        var pv = [];
        for(i = 0, n = p.length; i < n; i++)pv[p[i]] = i;
         // return matrices
        return {
            L: l,
            U: u,
            p: pv,
            toString: function toString() {
                return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\nP: ' + this.p;
            }
        };
    }
    function _sparseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // minimum rows and columns
        var n = Math.min(rows, columns); // matrix arrays (will not be modified, thanks to permutation vector)
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // l matrix arrays
        var lvalues = [];
        var lindex = [];
        var lptr = [];
        var lsize = [
            rows,
            n
        ]; // u matrix arrays
        var uvalues = [];
        var uindex = [];
        var uptr = [];
        var usize = [
            n,
            columns
        ]; // vars
        var i, j, k; // permutation vectors, (current index -> original index) and (original index -> current index)
        var pvCo = [];
        var pvOc = [];
        for(i = 0; i < rows; i++){
            pvCo[i] = i;
            pvOc[i] = i;
        } // swap indices in permutation vectors (condition x < y)!
        var swapIndeces = function swapIndeces(x, y) {
            // find pv indeces getting data from x and y
            var kx = pvOc[x];
            var ky = pvOc[y]; // update permutation vector current -> original
            pvCo[kx] = y;
            pvCo[ky] = x; // update permutation vector original -> current
            pvOc[x] = ky;
            pvOc[y] = kx;
        }; // loop columns
        var _loop = function _loop() {
            // sparse accumulator
            var spa = new Spa(); // check lower triangular matrix has a value @ column j
            if (j < rows) {
                // update ptr
                lptr.push(lvalues.length); // first value in j column for lower triangular matrix
                lvalues.push(1);
                lindex.push(j);
            } // update ptr
            uptr.push(uvalues.length); // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // copy column j into sparse accumulator
            for(k = k0; k < k1; k++){
                // row
                i = index[k]; // copy column values into sparse accumulator (use permutation vector)
                spa.set(pvCo[i], values[k]);
            } // skip first column in upper triangular matrix
            if (j > 0) // loop rows in column j (above diagonal)
            spa.forEach(0, j - 1, function(k, vkj) {
                // loop rows in column k (L)
                SparseMatrix._forEachRow(k, lvalues, lindex, lptr, function(i, vik) {
                    // check row is below k
                    if (i > k) // update spa value
                    spa.accumulate(i, unaryMinus(multiplyScalar(vik, vkj)));
                });
            });
             // row with larger value in spa, row >= j
            var pi = j;
            var vjj = spa.get(j);
            var pabsv = abs(vjj); // loop values in spa (order by row, below diagonal)
            spa.forEach(j + 1, rows - 1, function(x, v) {
                // absolute value
                var absv = abs(v); // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = x; // update max value
                    pabsv = absv; // value @ [j, j]
                    vjj = v;
                }
            }); // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in L
                SparseMatrix._swapRows(j, pi, lsize[1], lvalues, lindex, lptr); // swap values j <-> pi in U
                SparseMatrix._swapRows(j, pi, usize[1], uvalues, uindex, uptr); // swap values in spa
                spa.swap(j, pi); // update permutation vector (swap values @ j, pi)
                swapIndeces(j, pi);
            } // loop values in spa (order by row)
            spa.forEach(0, rows - 1, function(x, v) {
                // check we are above diagonal
                if (x <= j) {
                    // update upper triangular matrix
                    uvalues.push(v);
                    uindex.push(x);
                } else {
                    // update value
                    v = divideScalar(v, vjj); // check value is non zero
                    if (!equalScalar(v, 0)) {
                        // update lower triangular matrix
                        lvalues.push(v);
                        lindex.push(x);
                    }
                }
            });
        };
        for(j = 0; j < columns; j++)_loop();
         // update ptrs
        uptr.push(uvalues.length);
        lptr.push(lvalues.length); // return matrices
        return {
            L: new SparseMatrix({
                values: lvalues,
                index: lindex,
                ptr: lptr,
                size: lsize
            }),
            U: new SparseMatrix({
                values: uvalues,
                index: uindex,
                ptr: uptr,
                size: usize
            }),
            p: pvCo,
            toString: function toString() {
                return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\nP: ' + this.p;
            }
        };
    }
});

});

parcelRegister("jWy7j", function(module, exports) {

$parcel$export(module.exports, "createLusolve", () => $e84de606b072e15f$export$a3f0777edf21dcd5);

var $gs7TF = parcelRequire("gs7TF");

var $4eE2e = parcelRequire("4eE2e");

var $4ssS1 = parcelRequire("4ssS1");

var $7CY0X = parcelRequire("7CY0X");
var $e84de606b072e15f$var$name = 'lusolve';
var $e84de606b072e15f$var$dependencies = [
    'typed',
    'matrix',
    'lup',
    'slu',
    'usolve',
    'lsolve',
    'DenseMatrix'
];
var $e84de606b072e15f$export$a3f0777edf21dcd5 = /* #__PURE__ */ (0, $4eE2e.factory)($e84de606b072e15f$var$name, $e84de606b072e15f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, lup: lup, slu: slu, usolve: usolve, lsolve: lsolve, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $4ssS1.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Solves the linear system `A * x = b` where `A` is an [n x n] matrix and `b` is a [n] column vector.
   *
   * Syntax:
   *
   *    math.lusolve(A, b)     // returns column vector with the solution to the linear system A * x = b
   *    math.lusolve(lup, b)   // returns column vector with the solution to the linear system A * x = b, lup = math.lup(A)
   *
   * Examples:
   *
   *    const m = [[1, 0, 0, 0], [0, 2, 0, 0], [0, 0, 3, 0], [0, 0, 0, 4]]
   *
   *    const x = math.lusolve(m, [-1, -1, -1, -1])        // x = [[-1], [-0.5], [-1/3], [-0.25]]
   *
   *    const f = math.lup(m)
   *    const x1 = math.lusolve(f, [-1, -1, -1, -1])       // x1 = [[-1], [-0.5], [-1/3], [-0.25]]
   *    const x2 = math.lusolve(f, [1, 2, 1, -1])          // x2 = [[1], [1], [1/3], [-0.25]]
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = math.lusolve(a, b)  // [[2], [5]]
   *
   * See also:
   *
   *    lup, slu, lsolve, usolve
   *
   * @param {Matrix | Array | Object} A      Invertible Matrix or the Matrix LU decomposition
   * @param {Matrix | Array} b               Column Vector
   * @param {number} [order]                 The Symbolic Ordering and Analysis order, see slu for details. Matrix must be a SparseMatrix
   * @param {Number} [threshold]             Partial pivoting threshold (1 for partial pivoting), see slu for details. Matrix must be a SparseMatrix.
   *
   * @return {DenseMatrix | Array}           Column vector with the solution to the linear system A * x = b
   */ return typed($e84de606b072e15f$var$name, {
        'Array, Array | Matrix': function ArrayArrayMatrix(a, b) {
            a = matrix(a);
            var d = lup(a);
            var x = _lusolve(d.L, d.U, d.p, null, b);
            return x.valueOf();
        },
        'DenseMatrix, Array | Matrix': function DenseMatrixArrayMatrix(a, b) {
            var d = lup(a);
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        'SparseMatrix, Array | Matrix': function SparseMatrixArrayMatrix(a, b) {
            var d = lup(a);
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        'SparseMatrix, Array | Matrix, number, number': function SparseMatrixArrayMatrixNumberNumber(a, b, order, threshold) {
            var d = slu(a, order, threshold);
            return _lusolve(d.L, d.U, d.p, d.q, b);
        },
        'Object, Array | Matrix': function ObjectArrayMatrix(d, b) {
            return _lusolve(d.L, d.U, d.p, d.q, b);
        }
    });
    function _toMatrix(a) {
        if ((0, $gs7TF.isMatrix)(a)) return a;
        if ((0, $gs7TF.isArray)(a)) return matrix(a);
        throw new TypeError('Invalid Matrix LU decomposition');
    }
    function _lusolve(l, u, p, q, b) {
        // verify decomposition
        l = _toMatrix(l);
        u = _toMatrix(u); // apply row permutations if needed (b is a DenseMatrix)
        if (p) {
            b = solveValidation(l, b, true);
            b._data = (0, $7CY0X.csIpvec)(p, b._data);
        } // use forward substitution to resolve L * y = b
        var y = lsolve(l, b); // use backward substitution to resolve U * x = y
        var x = usolve(u, y); // apply column permutations if needed (x is a DenseMatrix)
        if (q) x._data = (0, $7CY0X.csIpvec)(q, x._data);
        return x;
    }
});

});
parcelRegister("7CY0X", function(module, exports) {

$parcel$export(module.exports, "csIpvec", () => $58daa2a2617f0a0e$export$29cc81cfd083fd62);
/**
 * Permutes a vector; x = P'b. In MATLAB notation, x(p)=b.
 *
 * @param {Array} p           The permutation vector of length n. null value denotes identity
 * @param {Array} b           The input vector
 *
 * @return {Array}            The output vector x = P'b
 */ function $58daa2a2617f0a0e$export$29cc81cfd083fd62(p, b) {
    // vars
    var k;
    var n = b.length;
    var x = []; // check permutation vector was provided, p = null denotes identity
    if (p) // loop vector
    for(k = 0; k < n; k++)// apply permutation
    x[p[k]] = b[k];
    else // loop vector
    for(k = 0; k < n; k++)// x[i] = b[i]
    x[k] = b[k];
    return x;
}

});


parcelRegister("eRGGO", function(module, exports) {

$parcel$export(module.exports, "createMad", () => $ad27212d7e6f48ac$export$7b17fbe41c88575a);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");

var $ijiby = parcelRequire("ijiby");
var $ad27212d7e6f48ac$var$name = 'mad';
var $ad27212d7e6f48ac$var$dependencies = [
    'typed',
    'abs',
    'map',
    'median',
    'subtract'
];
var $ad27212d7e6f48ac$export$7b17fbe41c88575a = /* #__PURE__ */ (0, $4eE2e.factory)($ad27212d7e6f48ac$var$name, $ad27212d7e6f48ac$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, map: map, median: median, subtract: subtract } = _ref;
    /**
   * Compute the median absolute deviation of a matrix or a list with values.
   * The median absolute deviation is defined as the median of the absolute
   * deviations from the median.
   *
   * Syntax:
   *
   *     math.mad(a, b, c, ...)
   *     math.mad(A)
   *
   * Examples:
   *
   *     math.mad(10, 20, 30)             // returns 10
   *     math.mad([1, 2, 3])              // returns 1
   *     math.mad([[1, 2, 3], [4, 5, 6]]) // returns 1.5
   *
   * See also:
   *
   *     median, mean, std, abs
   *
   * @param {Array | Matrix} array
   *                        A single matrix or multiple scalar values.
   * @return {*} The median absolute deviation.
   */ return typed($ad27212d7e6f48ac$var$name, {
        // mad([a, b, c, d, ...])
        'Array | Matrix': _mad,
        // mad(a, b, c, d, ...)
        '...': function _(args) {
            return _mad(args);
        }
    });
    function _mad(array) {
        array = (0, $10UPF.flatten)(array.valueOf());
        if (array.length === 0) throw new Error('Cannot calculate median absolute deviation (mad) of an empty array');
        try {
            var med = median(array);
            return median(map(array, function(value) {
                return abs(subtract(value, med));
            }));
        } catch (err) {
            if (err instanceof TypeError && err.message.indexOf('median') !== -1) throw new TypeError(err.message.replace('median', 'mad'));
            else throw (0, $ijiby.improveErrorMessage)(err, 'mad');
        }
    }
});

});
parcelRegister("ijiby", function(module, exports) {

$parcel$export(module.exports, "improveErrorMessage", () => $d5481b8f8e153ae1$export$c8994973cec629ae);

var $gs7TF = parcelRequire("gs7TF");
function $d5481b8f8e153ae1$export$c8994973cec629ae(err, fnName, value) {
    // TODO: add information with the index (also needs transform in expression parser)
    var details;
    if (String(err).indexOf('Unexpected type') !== -1) {
        details = arguments.length > 2 ? ' (type: ' + (0, $gs7TF.typeOf)(value) + ', value: ' + JSON.stringify(value) + ')' : ' (type: ' + err.data.actual + ')';
        return new TypeError('Cannot calculate ' + fnName + ', unexpected type of argument' + details);
    }
    if (String(err).indexOf('complex numbers') !== -1) {
        details = arguments.length > 2 ? ' (type: ' + (0, $gs7TF.typeOf)(value) + ', value: ' + JSON.stringify(value) + ')' : '';
        return new TypeError('Cannot calculate ' + fnName + ', no ordering relation is defined for complex numbers' + details);
    }
    return err;
}

});


parcelRegister("4aB2a", function(module, exports) {

$parcel$export(module.exports, "createMap", () => $3094d2c302446c12$export$d49c9aa30b771d59);

var $jHpUf = parcelRequire("jHpUf");

var $4eE2e = parcelRequire("4eE2e");
var $3094d2c302446c12$var$name = 'map';
var $3094d2c302446c12$var$dependencies = [
    'typed'
];
var $3094d2c302446c12$export$d49c9aa30b771d59 = /* #__PURE__ */ (0, $4eE2e.factory)($3094d2c302446c12$var$name, $3094d2c302446c12$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a new matrix or array with the results of the callback function executed on
   * each entry of the matrix/array.
   *
   * Syntax:
   *
   *    math.map(x, callback)
   *
   * Examples:
   *
   *    math.map([1, 2, 3], function(value) {
   *      return value * value
   *    })  // returns [1, 4, 9]
   *
   * See also:
   *
   *    filter, forEach, sort
   *
   * @param {Matrix | Array} x    The matrix to iterate on.
   * @param {Function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the matrix being traversed.
   * @return {Matrix | array}     Transformed map of x
   */ return typed($3094d2c302446c12$var$name, {
        'Array, function': $3094d2c302446c12$var$_map,
        'Matrix, function': function MatrixFunction(x, callback) {
            return x.map(callback);
        }
    });
});
/**
 * Map for a multi dimensional array
 * @param {Array} array
 * @param {Function} callback
 * @return {Array}
 * @private
 */ function $3094d2c302446c12$var$_map(array, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $jHpUf.maxArgumentCount)(callback);
    var recurse = function recurse(value, index) {
        if (Array.isArray(value)) return value.map(function(child, i) {
            // we create a copy of the index array and append the new index value
            return recurse(child, index.concat(i));
        });
        else {
            // invoke the callback function with the right number of arguments
            if (args === 1) return callback(value);
            else if (args === 2) return callback(value, index);
            else // 3 or -1
            return callback(value, index, array);
        }
    };
    return recurse(array, []);
}

});

parcelRegister("gPUdm", function(module, exports) {

$parcel$export(module.exports, "createMatrix", () => $c41d03cf4b970b8b$export$f3cf8b510f9cb8ab);

var $4eE2e = parcelRequire("4eE2e");
var $c41d03cf4b970b8b$var$name = 'matrix';
var $c41d03cf4b970b8b$var$dependencies = [
    'typed',
    'Matrix',
    'DenseMatrix',
    'SparseMatrix'
];
var $c41d03cf4b970b8b$export$f3cf8b510f9cb8ab = /* #__PURE__ */ (0, $4eE2e.factory)($c41d03cf4b970b8b$var$name, $c41d03cf4b970b8b$var$dependencies, (_ref)=>{
    var { typed: typed, Matrix: Matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   * Supported storage formats are 'dense' and 'sparse'.
   *
   * Syntax:
   *
   *    math.matrix()                         // creates an empty matrix using default storage format (dense).
   *    math.matrix(data)                     // creates a matrix with initial data using default storage format (dense).
   *    math.matrix('dense')                  // creates an empty matrix using the given storage format.
   *    math.matrix(data, 'dense')            // creates a matrix with initial data using the given storage format.
   *    math.matrix(data, 'sparse')           // creates a sparse matrix with initial data.
   *    math.matrix(data, 'sparse', 'number') // creates a sparse matrix with initial data, number data type.
   *
   * Examples:
   *
   *    let m = math.matrix([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, sparse
   *
   * @param {Array | Matrix} [data]    A multi dimensional array
   * @param {string} [format]          The Matrix storage format, either `'dense'` or `'sparse'`
   * @param {string} [datatype]        Type of the values
   *
   * @return {Matrix} The created matrix
   */ return typed($c41d03cf4b970b8b$var$name, {
        '': function _() {
            return _create([]);
        },
        string: function string(format) {
            return _create([], format);
        },
        'string, string': function stringString(format, datatype) {
            return _create([], format, datatype);
        },
        Array: function Array(data) {
            return _create(data);
        },
        Matrix: function Matrix(data) {
            return _create(data, data.storage());
        },
        'Array | Matrix, string': _create,
        'Array | Matrix, string, string': _create
    });
    /**
   * Create a new Matrix with given storage format
   * @param {Array} data
   * @param {string} [format]
   * @param {string} [datatype]
   * @returns {Matrix} Returns a new Matrix
   * @private
   */ function _create(data, format, datatype) {
        // get storage format constructor
        if (format === 'dense' || format === 'default' || format === undefined) return new DenseMatrix(data, datatype);
        if (format === 'sparse') return new SparseMatrix(data, datatype);
        throw new TypeError('Unknown matrix type ' + JSON.stringify(format) + '.');
    }
});

});

parcelRegister("eCRSR", function(module, exports) {

$parcel$export(module.exports, "createMatrixClass", () => $aa5e697e11f54eb6$export$72d485cc3ed6a97a);

var $4eE2e = parcelRequire("4eE2e");
var $aa5e697e11f54eb6$var$name = 'Matrix';
var $aa5e697e11f54eb6$var$dependencies = [];
var $aa5e697e11f54eb6$export$72d485cc3ed6a97a = /* #__PURE__ */ (0, $4eE2e.factory)($aa5e697e11f54eb6$var$name, $aa5e697e11f54eb6$var$dependencies, ()=>{
    /**
   * @constructor Matrix
   *
   * A Matrix is a wrapper around an Array. A matrix can hold a multi dimensional
   * array. A matrix can be constructed as:
   *
   *     let matrix = math.matrix(data)
   *
   * Matrix contains the functions to resize, get and set values, get the size,
   * clone the matrix and to convert the matrix to a vector, array, or scalar.
   * Furthermore, one can iterate over the matrix using map and forEach.
   * The internal Array of the Matrix can be accessed using the function valueOf.
   *
   * Example usage:
   *
   *     let matrix = math.matrix([[1, 2], [3, 4]])
   *     matix.size()              // [2, 2]
   *     matrix.resize([3, 2], 5)
   *     matrix.valueOf()          // [[1, 2], [3, 4], [5, 5]]
   *     matrix.subset([1,2])       // 3 (indexes are zero-based)
   *
   */ function Matrix() {
        if (!(this instanceof Matrix)) throw new SyntaxError('Constructor must be called with the new operator');
    }
    /**
   * Attach type information
   */ Matrix.prototype.type = 'Matrix';
    Matrix.prototype.isMatrix = true;
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @return {string}           The storage format.
   */ Matrix.prototype.storage = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke storage on a Matrix interface');
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @return {string}           The datatype.
   */ Matrix.prototype.datatype = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke datatype on a Matrix interface');
    };
    /**
   * Create a new Matrix With the type of the current matrix instance
   * @param {Array | Object} data
   * @param {string} [datatype]
   */ Matrix.prototype.create = function(data, datatype) {
        throw new Error('Cannot invoke create on a Matrix interface');
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ Matrix.prototype.subset = function(index, replacement, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke subset on a Matrix interface');
    };
    /**
   * Get a single element from the matrix.
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ Matrix.prototype.get = function(index) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke get on a Matrix interface');
    };
    /**
   * Replace a single element in the matrix.
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {Matrix} self
   */ Matrix.prototype.set = function(index, value, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke set on a Matrix interface');
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ Matrix.prototype.resize = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke resize on a Matrix interface');
    };
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ Matrix.prototype.reshape = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke reshape on a Matrix interface');
    };
    /**
   * Create a clone of the matrix
   * @return {Matrix} clone
   */ Matrix.prototype.clone = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke clone on a Matrix interface');
    };
    /**
   * Retrieve the size of the matrix.
   * @returns {number[]} size
   */ Matrix.prototype.size = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke size on a Matrix interface');
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {Matrix} matrix
   */ Matrix.prototype.map = function(callback, skipZeros) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke map on a Matrix interface');
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ Matrix.prototype.forEach = function(callback) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke forEach on a Matrix interface');
    };
    /**
   * Iterate over the matrix elements
   * @return {Iterable<{ value, index: number[] }>}
   */ Matrix.prototype[Symbol.iterator] = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot iterate a Matrix interface');
    };
    /**
   * Create an Array with a copy of the data of the Matrix
   * @returns {Array} array
   */ Matrix.prototype.toArray = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke toArray on a Matrix interface');
    };
    /**
   * Get the primitive value of the Matrix: a multidimensional array
   * @returns {Array} array
   */ Matrix.prototype.valueOf = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke valueOf on a Matrix interface');
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Matrix.prototype.format = function(options) {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke format on a Matrix interface');
    };
    /**
   * Get a string representation of the matrix
   * @returns {string} str
   */ Matrix.prototype.toString = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error('Cannot invoke toString on a Matrix interface');
    };
    return Matrix;
}, {
    isClass: true
});

});

parcelRegister("djtod", function(module, exports) {

$parcel$export(module.exports, "createMatrixFromColumns", () => $9b13d8e32fe9521f$export$65fefc9f63da4d13);

var $4eE2e = parcelRequire("4eE2e");
var $9b13d8e32fe9521f$var$name = 'matrixFromColumns';
var $9b13d8e32fe9521f$var$dependencies = [
    'typed',
    'matrix',
    'flatten',
    'size'
];
var $9b13d8e32fe9521f$export$65fefc9f63da4d13 = /* #__PURE__ */ (0, $4eE2e.factory)($9b13d8e32fe9521f$var$name, $9b13d8e32fe9521f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, flatten: flatten, size: size } = _ref;
    /**
   * Create a dense matrix from vectors as individual columns.
   * If you pass row vectors, they will be transposed (but not conjugated!)
   *
   * Syntax:
   *
   *    math.matrixFromColumns(...arr)
   *    math.matrixFromColumns(col1, col2)
   *    math.matrixFromColumns(col1, col2, col3)
   *
   * Examples:
   *
   *    math.matrixFromColumns([1, 2, 3], [[4],[5],[6]])
   *    math.matrixFromColumns(...vectors)
   *
   * See also:
   *
   *    matrix, matrixFromRows, matrixFromFunction, zeros
   *
   * @param {... Array | Matrix} cols Multiple columns
   * @return { number[][] | Matrix } if at least one of the arguments is an array, an array will be returned
   */ return typed($9b13d8e32fe9521f$var$name, {
        '...Array': function Array(arr) {
            return _createArray(arr);
        },
        '...Matrix': function Matrix(arr) {
            return matrix(_createArray(arr.map((m)=>m.toArray())));
        } // TODO implement this properly for SparseMatrix
    });
    function _createArray(arr) {
        if (arr.length === 0) throw new TypeError('At least one column is needed to construct a matrix.');
        var N = checkVectorTypeAndReturnLength(arr[0]); // create an array with empty rows
        var result = [];
        for(var i = 0; i < N; i++)result[i] = [];
         // loop columns
        for (var col of arr){
            var colLength = checkVectorTypeAndReturnLength(col);
            if (colLength !== N) throw new TypeError('The vectors had different length: ' + (N | 0) + " \u2260 " + (colLength | 0));
            var f = flatten(col); // push a value to each row
            for(var _i = 0; _i < N; _i++)result[_i].push(f[_i]);
        }
        return result;
    }
    function checkVectorTypeAndReturnLength(vec) {
        var s = size(vec);
        if (s.length === 1) // 1D vector
        return s[0];
        else if (s.length === 2) {
            // 2D vector
            if (s[0] === 1) // row vector
            return s[1];
            else if (s[1] === 1) // col vector
            return s[0];
            else throw new TypeError('At least one of the arguments is not a vector.');
        } else throw new TypeError('Only one- or two-dimensional vectors are supported.');
    }
});

});

parcelRegister("iNWZH", function(module, exports) {

$parcel$export(module.exports, "createMatrixFromFunction", () => $db0a90a064a51738$export$983d2c97138363e0);

var $4eE2e = parcelRequire("4eE2e");
var $db0a90a064a51738$var$name = 'matrixFromFunction';
var $db0a90a064a51738$var$dependencies = [
    'typed',
    'matrix',
    'isZero'
];
var $db0a90a064a51738$export$983d2c97138363e0 = /* #__PURE__ */ (0, $4eE2e.factory)($db0a90a064a51738$var$name, $db0a90a064a51738$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, isZero: isZero } = _ref;
    /**
   * Create a matrix by evaluating a generating function at each index.
   * The simplest overload returns a multi-dimensional array as long as `size` is an array.
   * Passing `size` as a Matrix or specifying a `format` will result in returning a Matrix.
   *
   * Syntax:
   *
   *    math.matrixFromFunction(size, fn)
   *    math.matrixFromFunction(size, fn, format)
   *    math.matrixFromFunction(size, fn, format, datatype)
   *    math.matrixFromFunction(size, format, fn)
   *    math.matrixFromFunction(size, format, datatype, fn)
   *
   * Examples:
   *
   *    math.matrixFromFunction([3,3], i => i[0] - i[1]) // an antisymmetric matrix
   *    math.matrixFromFunction([100, 100], 'sparse', i => i[0] - i[1] === 1 ? 4 : 0) // a sparse subdiagonal matrix
   *    math.matrixFromFunction([5], i => math.random()) // a random vector
   *
   * See also:
   *
   *    matrix, zeros
   *
   * @param {Array | Matrix} size   The size of the matrix to be created
   * @param {function} fn           Callback function invoked for every entry in the matrix
   * @param {string} [format]       The Matrix storage format, either `'dense'` or `'sparse'`
   * @param {string} [datatype]     Type of the values
   * @return {Array | Matrix} Returns the created matrix
   */ return typed($db0a90a064a51738$var$name, {
        'Array | Matrix, function, string, string': function ArrayMatrixFunctionStringString(size, fn, format, datatype) {
            return _create(size, fn, format, datatype);
        },
        'Array | Matrix, function, string': function ArrayMatrixFunctionString(size, fn, format) {
            return _create(size, fn, format);
        },
        'Matrix, function': function MatrixFunction(size, fn) {
            return _create(size, fn, 'dense');
        },
        'Array, function': function ArrayFunction(size, fn) {
            return _create(size, fn, 'dense').toArray();
        },
        'Array | Matrix, string, function': function ArrayMatrixStringFunction(size, format, fn) {
            return _create(size, fn, format);
        },
        'Array | Matrix, string, string, function': function ArrayMatrixStringStringFunction(size, format, datatype, fn) {
            return _create(size, fn, format, datatype);
        }
    });
    function _create(size, fn, format, datatype) {
        var m;
        if (datatype !== undefined) m = matrix(format, datatype);
        else m = matrix(format);
        m.resize(size);
        m.forEach(function(_, index) {
            var val = fn(index);
            if (isZero(val)) return;
            m.set(index, val);
        });
        return m;
    }
});

});

parcelRegister("gQcPe", function(module, exports) {

$parcel$export(module.exports, "createMatrixFromRows", () => $c42b738823aa307e$export$b72d61f960d7c36b);

var $4eE2e = parcelRequire("4eE2e");
var $c42b738823aa307e$var$name = 'matrixFromRows';
var $c42b738823aa307e$var$dependencies = [
    'typed',
    'matrix',
    'flatten',
    'size'
];
var $c42b738823aa307e$export$b72d61f960d7c36b = /* #__PURE__ */ (0, $4eE2e.factory)($c42b738823aa307e$var$name, $c42b738823aa307e$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, flatten: flatten, size: size } = _ref;
    /**
   * Create a dense matrix from vectors as individual rows.
   * If you pass column vectors, they will be transposed (but not conjugated!)
   *
   * Syntax:
   *
   *    math.matrixFromRows(...arr)
   *    math.matrixFromRows(row1, row2)
   *    math.matrixFromRows(row1, row2, row3)
   *
   * Examples:
   *
   *    math.matrixFromRows([1, 2, 3], [[4],[5],[6]])
   *    math.matrixFromRows(...vectors)
   *
   * See also:
   *
   *    matrix, matrixFromColumns, matrixFromFunction, zeros
   *
   * @param {... Array | Matrix} rows  Multiple rows
   * @return { number[][] | Matrix } if at least one of the arguments is an array, an array will be returned
   */ return typed($c42b738823aa307e$var$name, {
        '...Array': function Array(arr) {
            return _createArray(arr);
        },
        '...Matrix': function Matrix(arr) {
            return matrix(_createArray(arr.map((m)=>m.toArray())));
        } // TODO implement this properly for SparseMatrix
    });
    function _createArray(arr) {
        if (arr.length === 0) throw new TypeError('At least one row is needed to construct a matrix.');
        var N = checkVectorTypeAndReturnLength(arr[0]);
        var result = [];
        for (var row of arr){
            var rowLength = checkVectorTypeAndReturnLength(row);
            if (rowLength !== N) throw new TypeError('The vectors had different length: ' + (N | 0) + " \u2260 " + (rowLength | 0));
            result.push(flatten(row));
        }
        return result;
    }
    function checkVectorTypeAndReturnLength(vec) {
        var s = size(vec);
        if (s.length === 1) // 1D vector
        return s[0];
        else if (s.length === 2) {
            // 2D vector
            if (s[0] === 1) // row vector
            return s[1];
            else if (s[1] === 1) // col vector
            return s[0];
            else throw new TypeError('At least one of the arguments is not a vector.');
        } else throw new TypeError('Only one- or two-dimensional vectors are supported.');
    }
});

});

parcelRegister("aTI6t", function(module, exports) {

$parcel$export(module.exports, "createMax", () => $7ef14077d6f4b43f$export$b18a1b0c26c000ee);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");

var $ijiby = parcelRequire("ijiby");
var $7ef14077d6f4b43f$var$name = 'max';
var $7ef14077d6f4b43f$var$dependencies = [
    'typed',
    'config',
    'numeric',
    'larger'
];
var $7ef14077d6f4b43f$export$b18a1b0c26c000ee = /* #__PURE__ */ (0, $4eE2e.factory)($7ef14077d6f4b43f$var$name, $7ef14077d6f4b43f$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, larger: larger } = _ref;
    /**
   * Compute the maximum value of a matrix or a  list with values.
   * In case of a multi dimensional array, the maximum of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.max(a, b, c, ...)
   *     math.max(A)
   *     math.max(A, dim)
   *
   * Examples:
   *
   *     math.max(2, 1, 4, 3)                  // returns 4
   *     math.max([2, 1, 4, 3])                // returns 4
   *
   *     // maximum over a specified dimension (zero-based)
   *     math.max([[2, 5], [4, 3], [1, 7]], 0) // returns [4, 7]
   *     math.max([[2, 5], [4, 3]], [1, 7], 1) // returns [5, 4, 7]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, min, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The maximum value
   */ return typed($7ef14077d6f4b43f$var$name, {
        // max([a, b, c, d, ...])
        'Array | Matrix': _max,
        // max([a, b, c, d, ...], dim)
        'Array | Matrix, number | BigNumber': function ArrayMatrixNumberBigNumber(array, dim) {
            return (0, $9nwyh.reduce)(array, dim.valueOf(), _largest);
        },
        // max(a, b, c, d, ...)
        '...': function _(args) {
            if ((0, $9nwyh.containsCollections)(args)) throw new TypeError('Scalar values expected in function max');
            return _max(args);
        }
    });
    /**
   * Return the largest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is largest, or y when y is largest
   * @private
   */ function _largest(x, y) {
        try {
            return larger(x, y) ? x : y;
        } catch (err) {
            throw (0, $ijiby.improveErrorMessage)(err, 'max', y);
        }
    }
    /**
   * Recursively calculate the maximum value in an n-dimensional array
   * @param {Array} array
   * @return {number} max
   * @private
   */ function _max(array) {
        var res;
        (0, $9nwyh.deepForEach)(array, function(value) {
            try {
                if (isNaN(value) && typeof value === 'number') res = NaN;
                else if (res === undefined || larger(value, res)) res = value;
            } catch (err) {
                throw (0, $ijiby.improveErrorMessage)(err, 'max', value);
            }
        });
        if (res === undefined) throw new Error('Cannot calculate max of an empty array');
         // make sure returning numeric value: parse a string into a numeric value
        if (typeof res === 'string') res = numeric(res, config.number);
        return res;
    }
});

});

parcelRegister("4P03R", function(module, exports) {

$parcel$export(module.exports, "createMean", () => $382bf8fd5bc38a6d$export$301ef7ca1de6782c);

var $9nwyh = parcelRequire("9nwyh");

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");

var $ijiby = parcelRequire("ijiby");
var $382bf8fd5bc38a6d$var$name = 'mean';
var $382bf8fd5bc38a6d$var$dependencies = [
    'typed',
    'add',
    'divide'
];
var $382bf8fd5bc38a6d$export$301ef7ca1de6782c = /* #__PURE__ */ (0, $4eE2e.factory)($382bf8fd5bc38a6d$var$name, $382bf8fd5bc38a6d$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide } = _ref;
    /**
   * Compute the mean value of matrix or a list with values.
   * In case of a multi dimensional array, the mean of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.mean(a, b, c, ...)
   *     math.mean(A)
   *     math.mean(A, dim)
   *
   * Examples:
   *
   *     math.mean(2, 1, 4, 3)                     // returns 2.5
   *     math.mean([1, 2.7, 3.2, 4])               // returns 2.725
   *
   *     math.mean([[2, 5], [6, 3], [1, 7]], 0)    // returns [3, 5]
   *     math.mean([[2, 5], [6, 3], [1, 7]], 1)    // returns [3.5, 4.5, 4]
   *
   * See also:
   *
   *     median, min, max, sum, prod, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The mean of all values
   */ return typed($382bf8fd5bc38a6d$var$name, {
        // mean([a, b, c, d, ...])
        'Array | Matrix': _mean,
        // mean([a, b, c, d, ...], dim)
        'Array | Matrix, number | BigNumber': _nmeanDim,
        // mean(a, b, c, d, ...)
        '...': function _(args) {
            if ((0, $9nwyh.containsCollections)(args)) throw new TypeError('Scalar values expected in function mean');
            return _mean(args);
        }
    });
    /**
   * Calculate the mean value in an n-dimensional array, returning a
   * n-1 dimensional array
   * @param {Array} array
   * @param {number} dim
   * @return {number} mean
   * @private
   */ function _nmeanDim(array, dim) {
        try {
            var sum = (0, $9nwyh.reduce)(array, dim, add);
            var s = Array.isArray(array) ? (0, $10UPF.arraySize)(array) : array.size();
            return divide(sum, s[dim]);
        } catch (err) {
            throw (0, $ijiby.improveErrorMessage)(err, 'mean');
        }
    }
    /**
   * Recursively calculate the mean value in an n-dimensional array
   * @param {Array} array
   * @return {number} mean
   * @private
   */ function _mean(array) {
        var sum;
        var num = 0;
        (0, $9nwyh.deepForEach)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
                num++;
            } catch (err) {
                throw (0, $ijiby.improveErrorMessage)(err, 'mean', value);
            }
        });
        if (num === 0) throw new Error('Cannot calculate the mean of an empty array');
        return divide(sum, num);
    }
});

});

parcelRegister("bhx9l", function(module, exports) {

$parcel$export(module.exports, "createMedian", () => $836aff188446dfb5$export$cdebf3fc89add777);

var $9nwyh = parcelRequire("9nwyh");

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");

var $ijiby = parcelRequire("ijiby");
var $836aff188446dfb5$var$name = 'median';
var $836aff188446dfb5$var$dependencies = [
    'typed',
    'add',
    'divide',
    'compare',
    'partitionSelect'
];
var $836aff188446dfb5$export$cdebf3fc89add777 = /* #__PURE__ */ (0, $4eE2e.factory)($836aff188446dfb5$var$name, $836aff188446dfb5$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide, compare: compare, partitionSelect: partitionSelect } = _ref;
    /**
   * Recursively calculate the median of an n-dimensional array
   * @param {Array} array
   * @return {Number} median
   * @private
   */ function _median(array) {
        try {
            array = (0, $10UPF.flatten)(array.valueOf());
            var num = array.length;
            if (num === 0) throw new Error('Cannot calculate median of an empty array');
            if (num % 2 === 0) {
                // even: return the average of the two middle values
                var mid = num / 2 - 1;
                var right = partitionSelect(array, mid + 1); // array now partitioned at mid + 1, take max of left part
                var left = array[mid];
                for(var i = 0; i < mid; ++i)if (compare(array[i], left) > 0) left = array[i];
                return middle2(left, right);
            } else {
                // odd: return the middle value
                var m = partitionSelect(array, (num - 1) / 2);
                return middle(m);
            }
        } catch (err) {
            throw (0, $ijiby.improveErrorMessage)(err, 'median');
        }
    } // helper function to type check the middle value of the array
    var middle = typed({
        'number | BigNumber | Complex | Unit': function numberBigNumberComplexUnit(value) {
            return value;
        }
    }); // helper function to type check the two middle value of the array
    var middle2 = typed({
        'number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit': function numberBigNumberComplexUnitNumberBigNumberComplexUnit(left, right) {
            return divide(add(left, right), 2);
        }
    });
    /**
   * Compute the median of a matrix or a list with values. The values are
   * sorted and the middle value is returned. In case of an even number of
   * values, the average of the two middle values is returned.
   * Supported types of values are: Number, BigNumber, Unit
   *
   * In case of a (multi dimensional) array or matrix, the median of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.median(a, b, c, ...)
   *     math.median(A)
   *
   * Examples:
   *
   *     math.median(5, 2, 7)        // returns 5
   *     math.median([3, -1, 5, 7])  // returns 4
   *
   * See also:
   *
   *     mean, min, max, sum, prod, std, variance, quantileSeq
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The median
   */ return typed($836aff188446dfb5$var$name, {
        // median([a, b, c, d, ...])
        'Array | Matrix': _median,
        // median([a, b, c, d, ...], dim)
        'Array | Matrix, number | BigNumber': function ArrayMatrixNumberBigNumber(array, dim) {
            // TODO: implement median(A, dim)
            throw new Error('median(A, dim) is not yet supported'); // return reduce(arguments[0], arguments[1], ...)
        },
        // median(a, b, c, d, ...)
        '...': function _(args) {
            if ((0, $9nwyh.containsCollections)(args)) throw new TypeError('Scalar values expected in function median');
            return _median(args);
        }
    });
});

});

parcelRegister("5eklJ", function(module, exports) {

$parcel$export(module.exports, "createMin", () => $3cee0b88fef0f7dc$export$b795f47e2b99170);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");

var $ijiby = parcelRequire("ijiby");
var $3cee0b88fef0f7dc$var$name = 'min';
var $3cee0b88fef0f7dc$var$dependencies = [
    'typed',
    'config',
    'numeric',
    'smaller'
];
var $3cee0b88fef0f7dc$export$b795f47e2b99170 = /* #__PURE__ */ (0, $4eE2e.factory)($3cee0b88fef0f7dc$var$name, $3cee0b88fef0f7dc$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, smaller: smaller } = _ref;
    /**
   * Compute the minimum value of a matrix or a  list of values.
   * In case of a multi dimensional array, the minimum of the flattened array
   * will be calculated. When `dim` is provided, the minimum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.min(a, b, c, ...)
   *     math.min(A)
   *     math.min(A, dim)
   *
   * Examples:
   *
   *     math.min(2, 1, 4, 3)                  // returns 1
   *     math.min([2, 1, 4, 3])                // returns 1
   *
   *     // minimum over a specified dimension (zero-based)
   *     math.min([[2, 5], [4, 3], [1, 7]], 0) // returns [1, 3]
   *     math.min([[2, 5], [4, 3], [1, 7]], 1) // returns [2, 3, 1]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, max, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The minimum value
   */ return typed($3cee0b88fef0f7dc$var$name, {
        // min([a, b, c, d, ...])
        'Array | Matrix': _min,
        // min([a, b, c, d, ...], dim)
        'Array | Matrix, number | BigNumber': function ArrayMatrixNumberBigNumber(array, dim) {
            return (0, $9nwyh.reduce)(array, dim.valueOf(), _smallest);
        },
        // min(a, b, c, d, ...)
        '...': function _(args) {
            if ((0, $9nwyh.containsCollections)(args)) throw new TypeError('Scalar values expected in function min');
            return _min(args);
        }
    });
    /**
   * Return the smallest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is smallest, or y when y is smallest
   * @private
   */ function _smallest(x, y) {
        try {
            return smaller(x, y) ? x : y;
        } catch (err) {
            throw (0, $ijiby.improveErrorMessage)(err, 'min', y);
        }
    }
    /**
   * Recursively calculate the minimum value in an n-dimensional array
   * @param {Array} array
   * @return {number} min
   * @private
   */ function _min(array) {
        var min;
        (0, $9nwyh.deepForEach)(array, function(value) {
            try {
                if (isNaN(value) && typeof value === 'number') min = NaN;
                else if (min === undefined || smaller(value, min)) min = value;
            } catch (err) {
                throw (0, $ijiby.improveErrorMessage)(err, 'min', value);
            }
        });
        if (min === undefined) throw new Error('Cannot calculate min of an empty array');
         // make sure returning numeric value: parse a string into a numeric value
        if (typeof min === 'string') min = numeric(min, config.number);
        return min;
    }
});

});

parcelRegister("9zAMj", function(module, exports) {

$parcel$export(module.exports, "createMod", () => $6f83e9553cd29745$export$735bb6c30160c058);

var $4eE2e = parcelRequire("4eE2e");

var $5IUkw = parcelRequire("5IUkw");

var $6MKpt = parcelRequire("6MKpt");

var $69TlR = parcelRequire("69TlR");

var $hXAgg = parcelRequire("hXAgg");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");

var $eRNhQ = parcelRequire("eRNhQ");
var $6f83e9553cd29745$var$name = 'mod';
var $6f83e9553cd29745$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'DenseMatrix'
];
var $6f83e9553cd29745$export$735bb6c30160c058 = /* #__PURE__ */ (0, $4eE2e.factory)($6f83e9553cd29745$var$name, $6f83e9553cd29745$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm02 = (0, $5IUkw.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm05 = (0, $69TlR.createAlgorithm05)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculates the modulus, the remainder of an integer division.
   *
   * For matrices, the function is evaluated element wise.
   *
   * The modulus is defined as:
   *
   *     x - y * floor(x / y)
   *
   * See https://en.wikipedia.org/wiki/Modulo_operation.
   *
   * Syntax:
   *
   *    math.mod(x, y)
   *
   * Examples:
   *
   *    math.mod(8, 3)                // returns 2
   *    math.mod(11, 2)               // returns 1
   *
   *    function isOdd(x) {
   *      return math.mod(x, 2) != 0
   *    }
   *
   *    isOdd(2)                      // returns false
   *    isOdd(3)                      // returns true
   *
   * See also:
   *
   *    divide
   *
   * @param  {number | BigNumber | Fraction | Array | Matrix} x Dividend
   * @param  {number | BigNumber | Fraction | Array | Matrix} y Divisor
   * @return {number | BigNumber | Fraction | Array | Matrix} Returns the remainder of `x` divided by `y`.
   */ return typed($6f83e9553cd29745$var$name, {
        'number, number': (0, $eRNhQ.modNumber),
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            if (y.isNeg()) throw new Error('Cannot calculate mod for a negative divisor');
            return y.isZero() ? x : x.mod(y);
        },
        'Fraction, Fraction': function FractionFraction(x, y) {
            if (y.compare(0) < 0) throw new Error('Cannot calculate mod for a negative divisor');
             // Workaround suggested in Fraction.js library to calculate correct modulo for negative dividend
            return x.compare(0) >= 0 ? x.mod(y) : x.mod(y).add(y).mod(y);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, this, false);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});

});

parcelRegister("6Ql8D", function(module, exports) {

$parcel$export(module.exports, "createMode", () => $4fb7ff0b6e841b3f$export$822530980ba269d9);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $4fb7ff0b6e841b3f$var$name = 'mode';
var $4fb7ff0b6e841b3f$var$dependencies = [
    'typed',
    'isNaN',
    'isNumeric'
];
var $4fb7ff0b6e841b3f$export$822530980ba269d9 = /* #__PURE__ */ (0, $4eE2e.factory)($4fb7ff0b6e841b3f$var$name, $4fb7ff0b6e841b3f$var$dependencies, (_ref)=>{
    var { typed: typed, isNaN: isNaN, isNumeric: isNumeric } = _ref;
    /**
  * Computes the mode of a set of numbers or a list with values(numbers or characters).
  * If there are more than one modes, it returns a list of those values.
  *
  * Syntax:
  *
  *     math.mode(a, b, c, ...)
  *     math.mode(A)
  *
  * Examples:
  *
  *     math.mode(2, 1, 4, 3, 1)                            // returns [1]
  *     math.mode([1, 2.7, 3.2, 4, 2.7])                    // returns [2.7]
  *     math.mode(1, 4, 6, 1, 6)                             // returns [1, 6]
  *     math.mode('a','a','b','c')                           // returns ["a"]
  *     math.mode(1, 1.5, 'abc')                             // returns [1, 1.5, "abc"]
  *
  * See also:
  *
  *     median,
  *     mean
  *
  * @param {... *} args  A single matrix
  * @return {*} The mode of all values
  */ return typed($4fb7ff0b6e841b3f$var$name, {
        'Array | Matrix': _mode,
        '...': function _(args) {
            return _mode(args);
        }
    });
    /**
   * Calculates the mode in an 1-dimensional array
   * @param {Array} values
   * @return {Array} mode
   * @private
   */ function _mode(values) {
        values = (0, $10UPF.flatten)(values.valueOf());
        var num = values.length;
        if (num === 0) throw new Error('Cannot calculate mode of an empty array');
        var count = {};
        var mode = [];
        var max = 0;
        for(var i = 0; i < values.length; i++){
            var value = values[i];
            if (isNumeric(value) && isNaN(value)) throw new Error('Cannot calculate mode of an array containing NaN values');
            if (!(value in count)) count[value] = 0;
            count[value]++;
            if (count[value] === max) mode.push(value);
            else if (count[value] > max) {
                max = count[value];
                mode = [
                    value
                ];
            }
        }
        return mode;
    }
});

});

parcelRegister("4byQb", function(module, exports) {

$parcel$export(module.exports, "createMultinomial", () => $30c3371f251f3af7$export$b15aee1001d110);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");
var $30c3371f251f3af7$var$name = 'multinomial';
var $30c3371f251f3af7$var$dependencies = [
    'typed',
    'add',
    'divide',
    'multiply',
    'factorial',
    'isInteger',
    'isPositive'
];
var $30c3371f251f3af7$export$b15aee1001d110 = /* #__PURE__ */ (0, $4eE2e.factory)($30c3371f251f3af7$var$name, $30c3371f251f3af7$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide, multiply: multiply, factorial: factorial, isInteger: isInteger, isPositive: isPositive } = _ref;
    /**
   * Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities.
   *
   * multinomial takes one array of integers as an argument.
   * The following condition must be enforced: every ai <= 0
   *
   * Syntax:
   *
   *     math.multinomial(a) // a is an array type
   *
   * Examples:
   *
   *    math.multinomial([1,2,1]) // returns 12
   *
   * See also:
   *
   *    combinations, factorial
   *
   * @param {number[] | BigNumber[]} a    Integer numbers of objects in the subset
   * @return {Number | BigNumber}         Multinomial coefficient.
   */ return typed($30c3371f251f3af7$var$name, {
        'Array | Matrix': function ArrayMatrix(a) {
            var sum = 0;
            var denom = 1;
            (0, $9nwyh.deepForEach)(a, function(ai) {
                if (!isInteger(ai) || !isPositive(ai)) throw new TypeError('Positive integer value expected in function multinomial');
                sum = add(sum, ai);
                denom = multiply(denom, factorial(ai));
            });
            return divide(factorial(sum), denom);
        }
    });
});

});

parcelRegister("hkIg9", function(module, exports) {

$parcel$export(module.exports, "createMultiply", () => $c9e6a2f3070fa21d$export$86d08fd318fa07c8);

var $4eE2e = parcelRequire("4eE2e");

var $gs7TF = parcelRequire("gs7TF");

var $4mYv9 = parcelRequire("4mYv9");

var $10UPF = parcelRequire("10UPF");

var $hXAgg = parcelRequire("hXAgg");

var $laEuG = parcelRequire("laEuG");
var $c9e6a2f3070fa21d$var$name = 'multiply';
var $c9e6a2f3070fa21d$var$dependencies = [
    'typed',
    'matrix',
    'addScalar',
    'multiplyScalar',
    'equalScalar',
    'dot'
];
var $c9e6a2f3070fa21d$export$86d08fd318fa07c8 = /* #__PURE__ */ (0, $4eE2e.factory)($c9e6a2f3070fa21d$var$name, $c9e6a2f3070fa21d$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, multiplyScalar: multiplyScalar, equalScalar: equalScalar, dot: dot } = _ref;
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    function _validateMatrixDimensions(size1, size2) {
        // check left operand dimensions
        switch(size1.length){
            case 1:
                // check size2
                switch(size2.length){
                    case 1:
                        // Vector x Vector
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError('Dimension mismatch in multiplication. Vectors must have the same length');
                        break;
                    case 2:
                        // Vector x Matrix
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError('Dimension mismatch in multiplication. Vector length (' + size1[0] + ') must match Matrix rows (' + size2[0] + ')');
                        break;
                    default:
                        throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix B has ' + size2.length + ' dimensions)');
                }
                break;
            case 2:
                // check size2
                switch(size2.length){
                    case 1:
                        // Matrix x Vector
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError('Dimension mismatch in multiplication. Matrix columns (' + size1[1] + ') must match Vector length (' + size2[0] + ')');
                        break;
                    case 2:
                        // Matrix x Matrix
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError('Dimension mismatch in multiplication. Matrix A columns (' + size1[1] + ') must match Matrix B rows (' + size2[0] + ')');
                        break;
                    default:
                        throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix B has ' + size2.length + ' dimensions)');
                }
                break;
            default:
                throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix A has ' + size1.length + ' dimensions)');
        }
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (N)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {number}             Scalar value
   */ function _multiplyVectorVector(a, b, n) {
        // check empty vector
        if (n === 0) throw new Error('Cannot multiply two empty vectors');
        return dot(a, b);
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Matrix         (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorMatrix(a, b) {
        // process storage
        if (b.storage() !== 'dense') throw new Error('Support for SparseMatrix not implemented');
        return _multiplyVectorDenseMatrix(a, b);
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Dense Matrix   (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorDenseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // rows & columns
        var alength = asize[0];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix columns
        for(var j = 0; j < bcolumns; j++){
            // sum (do not initialize it with zero)
            var sum = mf(adata[0], bdata[0][j]); // loop vector
            for(var i = 1; i < alength; i++)// multiply & accumulate
            sum = af(sum, mf(adata[i], bdata[i][j]));
            c[j] = sum;
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                bcolumns
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {Matrix}             Dense Vector   (M)
   */ var _multiplyMatrixVector = typed('_multiplyMatrixVector', {
        'DenseMatrix, any': _multiplyDenseMatrixVector,
        'SparseMatrix, any': _multiplySparseMatrixVector
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Matrix         (NxC)
   *
   * @return {Matrix}             Matrix         (MxC)
   */ var _multiplyMatrixMatrix = typed('_multiplyMatrixMatrix', {
        'DenseMatrix, DenseMatrix': _multiplyDenseMatrixDenseMatrix,
        'DenseMatrix, SparseMatrix': _multiplyDenseMatrixSparseMatrix,
        'SparseMatrix, DenseMatrix': _multiplySparseMatrixDenseMatrix,
        'SparseMatrix, SparseMatrix': _multiplySparseMatrixSparseMatrix
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix  (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             Dense Vector (M)
   */ function _multiplyDenseMatrixVector(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = asize[0];
        var acolumns = asize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i]; // sum (do not initialize it with zero)
            var sum = mf(row[0], bdata[0]); // loop matrix a columns
            for(var j = 1; j < acolumns; j++)// multiply & accumulate
            sum = af(sum, mf(row[j], bdata[j]));
            c[i] = sum;
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            DenseMatrix    (NxC)
   *
   * @return {Matrix}             DenseMatrix    (MxC)
   */ function _multiplyDenseMatrixDenseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // rows & columns
        var arows = asize[0];
        var acolumns = asize[1];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i]; // initialize row array
            c[i] = []; // loop matrix b columns
            for(var j = 0; j < bcolumns; j++){
                // sum (avoid initializing sum to zero)
                var sum = mf(row[0], bdata[0][j]); // loop matrix a columns
                for(var x = 1; x < acolumns; x++)// multiply & accumulate
                sum = af(sum, mf(row[x], bdata[x][j]));
                c[i][j] = sum;
            }
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            SparseMatrix   (NxC)
   *
   * @return {Matrix}             SparseMatrix   (MxC)
   */ function _multiplyDenseMatrixSparseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate b matrix
        if (!bvalues) throw new Error('Cannot multiply Dense Matrix times Pattern only Matrix');
         // rows & columns
        var arows = asize[0];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // c matrix
        var c = b.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // indeces in column jb
            var kb0 = bptr[jb];
            var kb1 = bptr[jb + 1]; // do not process column jb if no data exists
            if (kb1 > kb0) {
                // last row mark processed
                var last = 0; // loop a rows
                for(var i = 0; i < arows; i++){
                    // column mark
                    var mark = i + 1; // C[i, jb]
                    var cij = void 0; // values in b column j
                    for(var kb = kb0; kb < kb1; kb++){
                        // row
                        var ib = bindex[kb]; // check value has been initialized
                        if (last !== mark) {
                            // first value in column jb
                            cij = mf(adata[i][ib], bvalues[kb]); // update mark
                            last = mark;
                        } else // accumulate value
                        cij = af(cij, mf(adata[i][ib], bvalues[kb]));
                    } // check column has been processed and value != 0
                    if (last === mark && !eq(cij, zero)) {
                        // push row & value
                        cindex.push(i);
                        cvalues.push(cij);
                    }
                }
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix    (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             SparseMatrix    (M, 1)
   */ function _multiplySparseMatrixVector(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // validate a matrix
        if (!avalues) throw new Error('Cannot multiply Pattern only Matrix times Dense Matrix');
         // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var brows = b._size[0]; // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // workspace
        var x = []; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // update ptr
        cptr[0] = 0; // rows in b
        for(var ib = 0; ib < brows; ib++){
            // b[ib]
            var vbi = bdata[ib]; // check b[ib] != 0, avoid loops
            if (!eq(vbi, zero)) // A values & index in ib column
            for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                // a row
                var ia = aindex[ka]; // check value exists in current j
                if (!w[ia]) {
                    // ia is new entry in j
                    w[ia] = true; // add i to pattern of C
                    cindex.push(ia); // x(ia) = A
                    x[ia] = mf(vbi, avalues[ka]);
                } else // i exists in C already
                x[ia] = af(x[ia], mf(vbi, avalues[ka]));
            }
        } // copy values from x to column jb of c
        for(var p1 = cindex.length, p = 0; p < p1; p++){
            // row
            var ic = cindex[p]; // copy value
            cvalues[p] = x[ic];
        } // update ptr
        cptr[1] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                1
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            DenseMatrix       (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixDenseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // validate a matrix
        if (!avalues) throw new Error('Cannot multiply Pattern only Matrix times Dense Matrix');
         // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var brows = b._size[0];
        var bcolumns = b._size[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // workspace
        var x = []; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // mark in workspace for current column
            var mark = jb + 1; // rows in jb
            for(var ib = 0; ib < brows; ib++){
                // b[ib, jb]
                var vbij = bdata[ib][jb]; // check b[ib, jb] != 0, avoid loops
                if (!eq(vbij, zero)) // A values & index in ib column
                for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // a row
                    var ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia); // x(ia) = A
                        x[ia] = mf(vbij, avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(vbij, avalues[ka]));
                }
            } // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p]; // copy value
                cvalues[p] = x[ic];
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            SparseMatrix      (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixSparseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var bcolumns = b._size[1]; // flag indicating both matrices (a & b) contain data
        var values = avalues && bvalues; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === 'string') {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = []; // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // workspace
        var x = values ? [] : undefined; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // variables
        var ka, ka0, ka1, kb, kb0, kb1, ia, ib; // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // mark in workspace for current column
            var mark = jb + 1; // B values & index in j
            for(kb0 = bptr[jb], kb1 = bptr[jb + 1], kb = kb0; kb < kb1; kb++){
                // b row
                ib = bindex[kb]; // check we need to process values
                if (values) // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia); // x(ia) = A
                        x[ia] = mf(bvalues[kb], avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(bvalues[kb], avalues[ka]));
                }
                else // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia);
                    }
                }
            } // check we need to process matrix values (pattern matrix)
            if (values) // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p]; // copy value
                cvalues[p] = x[ic];
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * Multiply two or more values, `x * y`.
   * For matrices, the matrix product is calculated.
   *
   * Syntax:
   *
   *    math.multiply(x, y)
   *    math.multiply(x, y, z, ...)
   *
   * Examples:
   *
   *    math.multiply(4, 5.2)        // returns number 20.8
   *    math.multiply(2, 3, 4)       // returns number 24
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.multiply(a, b)          // returns Complex 5 + 14i
   *
   *    const c = [[1, 2], [4, 3]]
   *    const d = [[1, 2, 3], [3, -4, 7]]
   *    math.multiply(c, d)          // returns Array [[7, -6, 17], [13, -4, 33]]
   *
   *    const e = math.unit('2.1 km')
   *    math.multiply(3, e)          // returns Unit 6.3 km
   *
   * See also:
   *
   *    divide, prod, cross, dot
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to multiply
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to multiply
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Multiplication of `x` and `y`
   */ return typed($c9e6a2f3070fa21d$var$name, (0, $4mYv9.extend)({
        // we extend the signatures of multiplyScalar with signatures dealing with matrices
        'Array, Array': function ArrayArray(x, y) {
            // check dimensions
            _validateMatrixDimensions((0, $10UPF.arraySize)(x), (0, $10UPF.arraySize)(y)); // use dense matrix implementation
            var m = this(matrix(x), matrix(y)); // return array or scalar
            return (0, $gs7TF.isMatrix)(m) ? m.valueOf() : m;
        },
        'Matrix, Matrix': function MatrixMatrix(x, y) {
            // dimensions
            var xsize = x.size();
            var ysize = y.size(); // check dimensions
            _validateMatrixDimensions(xsize, ysize); // process dimensions
            if (xsize.length === 1) {
                // process y dimensions
                if (ysize.length === 1) // Vector * Vector
                return _multiplyVectorVector(x, y, xsize[0]);
                 // Vector * Matrix
                return _multiplyVectorMatrix(x, y);
            } // process y dimensions
            if (ysize.length === 1) // Matrix * Vector
            return _multiplyMatrixVector(x, y);
             // Matrix * Matrix
            return _multiplyMatrixMatrix(x, y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use Matrix * Matrix implementation
            return this(x, matrix(y));
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use Matrix * Matrix implementation
            return this(matrix(x, y.storage()), y);
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm11(x, y, multiplyScalar, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, multiplyScalar, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm11(y, x, multiplyScalar, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, multiplyScalar, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
        },
        'any, any': multiplyScalar,
        'any, any, ...any': function anyAnyAny(x, y, rest) {
            var result = this(x, y);
            for(var i = 0; i < rest.length; i++)result = this(result, rest[i]);
            return result;
        }
    }, multiplyScalar.signatures));
});

});

parcelRegister("fSbwS", function(module, exports) {

$parcel$export(module.exports, "createMultiplyScalar", () => $b8e4d79efb1a47a0$export$37dc64d7e8361b32);

var $4eE2e = parcelRequire("4eE2e");

var $eRNhQ = parcelRequire("eRNhQ");
var $b8e4d79efb1a47a0$var$name = 'multiplyScalar';
var $b8e4d79efb1a47a0$var$dependencies = [
    'typed'
];
var $b8e4d79efb1a47a0$export$37dc64d7e8361b32 = /* #__PURE__ */ (0, $4eE2e.factory)($b8e4d79efb1a47a0$var$name, $b8e4d79efb1a47a0$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Multiply two scalar values, `x * y`.
   * This function is meant for internal use: it is used by the public function
   * `multiply`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to multiply
   * @param  {number | BigNumber | Fraction | Complex} y          Second value to multiply
   * @return {number | BigNumber | Fraction | Complex | Unit}     Multiplication of `x` and `y`
   * @private
   */ return typed('multiplyScalar', {
        'number, number': (0, $eRNhQ.multiplyNumber),
        'Complex, Complex': function ComplexComplex(x, y) {
            return x.mul(y);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.times(y);
        },
        'Fraction, Fraction': function FractionFraction(x, y) {
            return x.mul(y);
        },
        'number | Fraction | BigNumber | Complex, Unit': function numberFractionBigNumberComplexUnit(x, y) {
            var res = y.clone();
            res.value = res.value === null ? res._normalize(x) : this(res.value, x);
            return res;
        },
        'Unit, number | Fraction | BigNumber | Complex': function UnitNumberFractionBigNumberComplex(x, y) {
            var res = x.clone();
            res.value = res.value === null ? res._normalize(y) : this(res.value, y);
            return res;
        },
        'Unit, Unit': function UnitUnit(x, y) {
            return x.multiply(y);
        }
    });
});

});

parcelRegister("1hReh", function(module, exports) {

$parcel$export(module.exports, "createNorm", () => $0f00ab3bac61f9b3$export$ce85a9d2952c2966);

var $4eE2e = parcelRequire("4eE2e");
var $0f00ab3bac61f9b3$var$name = 'norm';
var $0f00ab3bac61f9b3$var$dependencies = [
    'typed',
    'abs',
    'add',
    'pow',
    'conj',
    'sqrt',
    'multiply',
    'equalScalar',
    'larger',
    'smaller',
    'matrix',
    'ctranspose',
    'eigs'
];
var $0f00ab3bac61f9b3$export$ce85a9d2952c2966 = /* #__PURE__ */ (0, $4eE2e.factory)($0f00ab3bac61f9b3$var$name, $0f00ab3bac61f9b3$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, pow: pow, conj: conj, sqrt: sqrt, multiply: multiply, equalScalar: equalScalar, larger: larger, smaller: smaller, matrix: matrix, ctranspose: ctranspose, eigs: eigs } = _ref;
    /**
   * Calculate the norm of a number, vector or matrix.
   *
   * The second parameter p is optional. If not provided, it defaults to 2.
   *
   * Syntax:
   *
   *    math.norm(x)
   *    math.norm(x, p)
   *
   * Examples:
   *
   *    math.abs(-3.5)                         // returns 3.5
   *    math.norm(-3.5)                        // returns 3.5
   *
   *    math.norm(math.complex(3, -4))         // returns 5
   *
   *    math.norm([1, 2, -3], Infinity)        // returns 3
   *    math.norm([1, 2, -3], -Infinity)       // returns 1
   *
   *    math.norm([3, 4], 2)                   // returns 5
   *
   *    math.norm([[1, 2], [3, 4]], 1)          // returns 6
   *    math.norm([[1, 2], [3, 4]], 'inf')     // returns 7
   *    math.norm([[1, 2], [3, 4]], 'fro')     // returns 5.477225575051661
   *
   * See also:
   *
   *    abs, hypot
   *
   * @param  {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the norm
   * @param  {number | BigNumber | string} [p=2]
   *            Vector space.
   *            Supported numbers include Infinity and -Infinity.
   *            Supported strings are: 'inf', '-inf', and 'fro' (The Frobenius norm)
   * @return {number | BigNumber} the p-norm
   */ return typed($0f00ab3bac61f9b3$var$name, {
        number: Math.abs,
        Complex: function Complex(x) {
            return x.abs();
        },
        BigNumber: function BigNumber(x) {
            // norm(x) = abs(x)
            return x.abs();
        },
        boolean: function boolean(x) {
            // norm(x) = abs(x)
            return Math.abs(x);
        },
        Array: function Array(x) {
            return _norm(matrix(x), 2);
        },
        Matrix: function Matrix(x) {
            return _norm(x, 2);
        },
        'number | Complex | BigNumber | boolean, number | BigNumber | string': function numberComplexBigNumberBooleanNumberBigNumberString(x) {
            // ignore second parameter, TODO: remove the option of second parameter for these types
            return this(x);
        },
        'Array, number | BigNumber | string': function ArrayNumberBigNumberString(x, p) {
            return _norm(matrix(x), p);
        },
        'Matrix, number | BigNumber | string': function MatrixNumberBigNumberString(x, p) {
            return _norm(x, p);
        }
    });
    /**
   * Calculate the plus infinity norm for a vector
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNormPlusInfinity(x) {
        // norm(x, Infinity) = max(abs(x))
        var pinf = 0; // skip zeros since abs(0) === 0
        x.forEach(function(value) {
            var v = abs(value);
            if (larger(v, pinf)) pinf = v;
        }, true);
        return pinf;
    }
    /**
   * Calculate the minus infinity norm for a vector
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNormMinusInfinity(x) {
        // norm(x, -Infinity) = min(abs(x))
        var ninf; // skip zeros since abs(0) === 0
        x.forEach(function(value) {
            var v = abs(value);
            if (!ninf || smaller(v, ninf)) ninf = v;
        }, true);
        return ninf || 0;
    }
    /**
   * Calculate the norm for a vector
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNorm(x, p) {
        // check p
        if (p === Number.POSITIVE_INFINITY || p === 'inf') return _vectorNormPlusInfinity(x);
        if (p === Number.NEGATIVE_INFINITY || p === '-inf') return _vectorNormMinusInfinity(x);
        if (p === 'fro') return _norm(x, 2);
        if (typeof p === 'number' && !isNaN(p)) {
            // check p != 0
            if (!equalScalar(p, 0)) {
                // norm(x, p) = sum(abs(xi) ^ p) ^ 1/p
                var n = 0; // skip zeros since abs(0) === 0
                x.forEach(function(value) {
                    n = add(pow(abs(value), p), n);
                }, true);
                return pow(n, 1 / p);
            }
            return Number.POSITIVE_INFINITY;
        } // invalid parameter value
        throw new Error('Unsupported parameter value');
    }
    /**
   * Calculate the Frobenius norm for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormFrobenius(x) {
        // norm(x) = sqrt(sum(diag(x'x)))
        var fro = 0;
        x.forEach(function(value, index) {
            fro = add(fro, multiply(value, conj(value)));
        });
        return abs(sqrt(fro));
    }
    /**
   * Calculate the norm L1 for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormOne(x) {
        // norm(x) = the largest column sum
        var c = []; // result
        var maxc = 0; // skip zeros since abs(0) == 0
        x.forEach(function(value, index) {
            var j = index[1];
            var cj = add(c[j] || 0, abs(value));
            if (larger(cj, maxc)) maxc = cj;
            c[j] = cj;
        }, true);
        return maxc;
    }
    /**
   * Calculate the norm L2 for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormTwo(x) {
        // norm(x) = sqrt( max eigenvalue of A*.A)
        var sizeX = x.size();
        if (sizeX[0] !== sizeX[1]) throw new RangeError('Invalid matrix dimensions');
        var tx = ctranspose(x);
        var squaredX = multiply(tx, x);
        var eigenVals = eigs(squaredX).values.toArray();
        var rho = eigenVals[eigenVals.length - 1];
        return abs(sqrt(rho));
    }
    /**
   * Calculate the infinity norm for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormInfinity(x) {
        // norm(x) = the largest row sum
        var r = []; // result
        var maxr = 0; // skip zeros since abs(0) == 0
        x.forEach(function(value, index) {
            var i = index[0];
            var ri = add(r[i] || 0, abs(value));
            if (larger(ri, maxr)) maxr = ri;
            r[i] = ri;
        }, true);
        return maxr;
    }
    /**
   * Calculate the norm for a 2D Matrix (M*N)
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNorm(x, p) {
        // check p
        if (p === 1) return _matrixNormOne(x);
        if (p === Number.POSITIVE_INFINITY || p === 'inf') return _matrixNormInfinity(x);
        if (p === 'fro') return _matrixNormFrobenius(x);
        if (p === 2) return _matrixNormTwo(x);
         // invalid parameter value
        throw new Error('Unsupported parameter value ' + p);
    }
    /**
   * Calculate the norm for an array
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _norm(x, p) {
        // size
        var sizeX = x.size(); // check if it is a vector
        if (sizeX.length === 1) return _vectorNorm(x, p);
         // MxN matrix
        if (sizeX.length === 2) {
            if (sizeX[0] && sizeX[1]) return _matrixNorm(x, p);
            else throw new RangeError('Invalid matrix dimensions');
        }
    }
});

});

parcelRegister("etNV0", function(module, exports) {

$parcel$export(module.exports, "createNot", () => $a8aa7ee3d897720e$export$8dbfb388cd6a8853);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");

var $jg11Z = parcelRequire("jg11Z");
var $a8aa7ee3d897720e$var$name = 'not';
var $a8aa7ee3d897720e$var$dependencies = [
    'typed'
];
var $a8aa7ee3d897720e$export$8dbfb388cd6a8853 = /* #__PURE__ */ (0, $4eE2e.factory)($a8aa7ee3d897720e$var$name, $a8aa7ee3d897720e$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Logical `not`. Flips boolean value of a given parameter.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.not(x)
   *
   * Examples:
   *
   *    math.not(2)      // returns false
   *    math.not(0)      // returns true
   *    math.not(true)   // returns false
   *
   *    a = [2, -7, 0]
   *    math.not(a)      // returns [false, false, true]
   *
   * See also:
   *
   *    and, or, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when input is a zero or empty value.
   */ return typed($a8aa7ee3d897720e$var$name, {
        number: (0, $jg11Z.notNumber),
        Complex: function Complex(x) {
            return x.re === 0 && x.im === 0;
        },
        BigNumber: function BigNumber(x) {
            return x.isZero() || x.isNaN();
        },
        Unit: function Unit(x) {
            return x.value !== null ? this(x.value) : true;
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("cuftd", function(module, exports) {

$parcel$export(module.exports, "createNthRoot", () => $9174496a4aff282a$export$964e38ef60b1ac68);

var $4eE2e = parcelRequire("4eE2e");

var $bCo9f = parcelRequire("bCo9f");

var $5IUkw = parcelRequire("5IUkw");

var $eIf4a = parcelRequire("eIf4a");

var $hXAgg = parcelRequire("hXAgg");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");

var $eRNhQ = parcelRequire("eRNhQ");
var $9174496a4aff282a$var$name = 'nthRoot';
var $9174496a4aff282a$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'BigNumber'
];
var $9174496a4aff282a$export$964e38ef60b1ac68 = /* #__PURE__ */ (0, $4eE2e.factory)($9174496a4aff282a$var$name, $9174496a4aff282a$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: _BigNumber } = _ref;
    var algorithm01 = (0, $bCo9f.createAlgorithm01)({
        typed: typed
    });
    var algorithm02 = (0, $5IUkw.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $eIf4a.createAlgorithm06)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Calculate the nth root of a value.
   * The principal nth root of a positive real number A, is the positive real
   * solution of the equation
   *
   *     x^root = A
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *     math.nthRoot(a)
   *     math.nthRoot(a, root)
   *
   * Examples:
   *
   *     math.nthRoot(9, 2)    // returns 3, as 3^2 == 9
   *     math.sqrt(9)          // returns 3, as 3^2 == 9
   *     math.nthRoot(64, 3)   // returns 4, as 4^3 == 64
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param {number | BigNumber | Array | Matrix | Complex} a
   *              Value for which to calculate the nth root
   * @param {number | BigNumber} [root=2]    The root.
   * @return {number | Complex | Array | Matrix} Returns the nth root of `a`
   */ var complexErr = "Complex number not supported in function nthRoot. Use nthRoots instead.";
    return typed($9174496a4aff282a$var$name, {
        number: function number(x) {
            return (0, $eRNhQ.nthRootNumber)(x, 2);
        },
        'number, number': (0, $eRNhQ.nthRootNumber),
        BigNumber: function BigNumber(x) {
            return _bigNthRoot(x, new _BigNumber(2));
        },
        Complex: function Complex(x) {
            throw new Error(complexErr);
        },
        'Complex, number': function ComplexNumber(x, y) {
            throw new Error(complexErr);
        },
        'BigNumber, BigNumber': _bigNthRoot,
        'Array | Matrix': function ArrayMatrix(x) {
            return this(x, 2);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // sparse + sparse
            return algorithm06(x, y, this);
            else // throw exception
            throw new Error('Root must be non-zero');
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // dense + sparse
            return algorithm01(x, y, this, false);
            else // throw exception
            throw new Error('Root must be non-zero');
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, number | BigNumber': function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, number | BigNumber': function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        'number | BigNumber, SparseMatrix': function numberBigNumberSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // sparse - scalar
            return algorithm11(y, x, this, true);
            else // throw exception
            throw new Error('Root must be non-zero');
        },
        'number | BigNumber, DenseMatrix': function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, number | BigNumber': function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        'number | BigNumber, Array': function numberBigNumberArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
    /**
   * Calculate the nth root of a for BigNumbers, solve x^root == a
   * https://rosettacode.org/wiki/Nth_root#JavaScript
   * @param {BigNumber} a
   * @param {BigNumber} root
   * @private
   */ function _bigNthRoot(a, root) {
        var precision = _BigNumber.precision;
        var Big = _BigNumber.clone({
            precision: precision + 2
        });
        var zero = new _BigNumber(0);
        var one = new Big(1);
        var inv = root.isNegative();
        if (inv) root = root.neg();
        if (root.isZero()) throw new Error('Root must be non-zero');
        if (a.isNegative() && !root.abs().mod(2).equals(1)) throw new Error('Root must be odd when a is negative.');
         // edge cases zero and infinity
        if (a.isZero()) return inv ? new Big(Infinity) : 0;
        if (!a.isFinite()) return inv ? zero : a;
        var x = a.abs().pow(one.div(root)); // If a < 0, we require that root is an odd integer,
        // so (-1) ^ (1/root) = -1
        x = a.isNeg() ? x.neg() : x;
        return new _BigNumber((inv ? one.div(x) : x).toPrecision(precision));
    }
});
var $9174496a4aff282a$export$f098cf3c4ef0f7ef = /* #__PURE__ */ (0, $4eE2e.factory)($9174496a4aff282a$var$name, [
    'typed'
], (_ref2)=>{
    var { typed: typed } = _ref2;
    return typed($9174496a4aff282a$var$name, {
        number: (0, $eRNhQ.nthRootNumber),
        'number, number': (0, $eRNhQ.nthRootNumber)
    });
});

});

parcelRegister("kim9k", function(module, exports) {

$parcel$export(module.exports, "createNthRoots", () => $ec66ab83f11939b6$export$36e27b45d2aa738c);

var $4eE2e = parcelRequire("4eE2e");
var $ec66ab83f11939b6$var$name = 'nthRoots';
var $ec66ab83f11939b6$var$dependencies = [
    'config',
    'typed',
    'divideScalar',
    'Complex'
];
var $ec66ab83f11939b6$export$36e27b45d2aa738c = /* #__PURE__ */ (0, $4eE2e.factory)($ec66ab83f11939b6$var$name, $ec66ab83f11939b6$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, Complex: Complex } = _ref;
    /**
   * Each function here returns a real multiple of i as a Complex value.
   * @param  {number} val
   * @return {Complex} val, i*val, -val or -i*val for index 0, 1, 2, 3
   */ // This is used to fix float artifacts for zero-valued components.
    var _calculateExactResult = [
        function realPos(val) {
            return new Complex(val, 0);
        },
        function imagPos(val) {
            return new Complex(0, val);
        },
        function realNeg(val) {
            return new Complex(-val, 0);
        },
        function imagNeg(val) {
            return new Complex(0, -val);
        }
    ];
    /**
   * Calculate the nth root of a Complex Number a using De Movire's Theorem.
   * @param  {Complex} a
   * @param  {number} root
   * @return {Array} array of n Complex Roots
   */ function _nthComplexRoots(a, root) {
        if (root < 0) throw new Error('Root must be greater than zero');
        if (root === 0) throw new Error('Root must be non-zero');
        if (root % 1 !== 0) throw new Error('Root must be an integer');
        if (a === 0 || a.abs() === 0) return [
            new Complex(0, 0)
        ];
        var aIsNumeric = typeof a === 'number';
        var offset; // determine the offset (argument of a)/(pi/2)
        if (aIsNumeric || a.re === 0 || a.im === 0) {
            if (aIsNumeric) offset = 2 * +(a < 0); // numeric value on the real axis
            else if (a.im === 0) offset = 2 * +(a.re < 0); // complex value on the real axis
            else offset = 2 * +(a.im < 0) + 1; // complex value on the imaginary axis
        }
        var arg = a.arg();
        var abs = a.abs();
        var roots = [];
        var r = Math.pow(abs, 1 / root);
        for(var k = 0; k < root; k++){
            var halfPiFactor = (offset + 4 * k) / root;
            /**
       * If (offset + 4*k)/root is an integral multiple of pi/2
       * then we can produce a more exact result.
       */ if (halfPiFactor === Math.round(halfPiFactor)) {
                roots.push(_calculateExactResult[halfPiFactor % 4](r));
                continue;
            }
            roots.push(new Complex({
                r: r,
                phi: (arg + 2 * Math.PI * k) / root
            }));
        }
        return roots;
    }
    /**
   * Calculate the nth roots of a value.
   * An nth root of a positive real number A,
   * is a positive real solution of the equation "x^root = A".
   * This function returns an array of complex values.
   *
   * Syntax:
   *
   *    math.nthRoots(x)
   *    math.nthRoots(x, root)
   *
   * Examples:
   *
   *    math.nthRoots(1)
   *    // returns [
   *    //   {re: 1, im: 0},
   *    //   {re: -1, im: 0}
   *    // ]
   *    nthRoots(1, 3)
   *    // returns [
   *    //   { re: 1, im: 0 },
   *    //   { re: -0.4999999999999998, im: 0.8660254037844387 },
   *    //   { re: -0.5000000000000004, im: -0.8660254037844385 }
   *    ]
   *
   * See also:
   *
   *    nthRoot, pow, sqrt
   *
   * @param {number | BigNumber | Fraction | Complex} x Number to be rounded
   * @return {number | BigNumber | Fraction | Complex}            Rounded value
   */ return typed($ec66ab83f11939b6$var$name, {
        Complex: function Complex(x) {
            return _nthComplexRoots(x, 2);
        },
        'Complex, number': _nthComplexRoots
    });
});

});

parcelRegister("OD7u9", function(module, exports) {

$parcel$export(module.exports, "createNumber", () => $098303fd6562e46c$export$763ee9f6477981ab);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $098303fd6562e46c$var$name = 'number';
var $098303fd6562e46c$var$dependencies = [
    'typed'
];
/**
 * Separates the radix, integer part, and fractional part of a non decimal number string
 * @param {string} input string to parse
 * @returns {object} the parts of the string or null if not a valid input
 */ function $098303fd6562e46c$var$getNonDecimalNumberParts(input) {
    var nonDecimalWithRadixMatch = input.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
    if (nonDecimalWithRadixMatch) {
        var radix = {
            '0b': 2,
            '0o': 8,
            '0x': 16
        }[nonDecimalWithRadixMatch[1]];
        var integerPart = nonDecimalWithRadixMatch[2];
        var fractionalPart = nonDecimalWithRadixMatch[3];
        return {
            input: input,
            radix: radix,
            integerPart: integerPart,
            fractionalPart: fractionalPart
        };
    } else return null;
}
/**
 * Makes a number from a radix, and integer part, and a fractional part
 * @param {parts} [x] parts of the number string (from getNonDecimalNumberParts)
 * @returns {number} the number
 */ function $098303fd6562e46c$var$makeNumberFromNonDecimalParts(parts) {
    var n = parseInt(parts.integerPart, parts.radix);
    var f = 0;
    for(var i = 0; i < parts.fractionalPart.length; i++){
        var digitValue = parseInt(parts.fractionalPart[i], parts.radix);
        f += digitValue / Math.pow(parts.radix, i + 1);
    }
    var result = n + f;
    if (isNaN(result)) throw new SyntaxError('String "' + parts.input + '" is no valid number');
    return result;
}
var $098303fd6562e46c$export$763ee9f6477981ab = /* #__PURE__ */ (0, $4eE2e.factory)($098303fd6562e46c$var$name, $098303fd6562e46c$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a number or convert a string, boolean, or unit to a number.
   * When value is a matrix, all elements will be converted to number.
   *
   * Syntax:
   *
   *    math.number(value)
   *    math.number(unit, valuelessUnit)
   *
   * Examples:
   *
   *    math.number(2)                         // returns number 2
   *    math.number('7.2')                     // returns number 7.2
   *    math.number(true)                      // returns number 1
   *    math.number([true, false, true, true]) // returns [1, 0, 1, 1]
   *    math.number(math.unit('52cm'), 'm')    // returns 0.52
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, string, unit
   *
   * @param {string | number | BigNumber | Fraction | boolean | Array | Matrix | Unit | null} [value]  Value to be converted
   * @param {Unit | string} [valuelessUnit] A valueless unit, used to convert a unit to a number
   * @return {number | Array | Matrix} The created number
   */ var number = typed('number', {
        '': function _() {
            return 0;
        },
        number: function number(x) {
            return x;
        },
        string: function string(x) {
            if (x === 'NaN') return NaN;
            var nonDecimalNumberParts = $098303fd6562e46c$var$getNonDecimalNumberParts(x);
            if (nonDecimalNumberParts) return $098303fd6562e46c$var$makeNumberFromNonDecimalParts(nonDecimalNumberParts);
            var size = 0;
            var wordSizeSuffixMatch = x.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
            if (wordSizeSuffixMatch) {
                // x includes a size suffix like 0xffffi32, so we extract
                // the suffix and remove it from x
                size = Number(wordSizeSuffixMatch[2]);
                x = wordSizeSuffixMatch[1];
            }
            var num = Number(x);
            if (isNaN(num)) throw new SyntaxError('String "' + x + '" is no valid number');
            if (wordSizeSuffixMatch) {
                // x is a signed bin, oct, or hex literal
                // num is the value of string x if x is interpreted as unsigned
                if (num > 2 ** size - 1) // literal is too large for size suffix
                throw new SyntaxError("String \"".concat(x, "\" is out of range"));
                 // check if the bit at index size - 1 is set and if so do the twos complement
                if (num >= 2 ** (size - 1)) num = num - 2 ** size;
            }
            return num;
        },
        BigNumber: function BigNumber(x) {
            return x.toNumber();
        },
        Fraction: function Fraction(x) {
            return x.valueOf();
        },
        Unit: function Unit(x) {
            throw new Error('Second argument with valueless unit expected');
        },
        null: function _null(x) {
            return 0;
        },
        'Unit, string | Unit': function UnitStringUnit(unit, valuelessUnit) {
            return unit.toNumber(valuelessUnit);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    }); // reviver function to parse a JSON object like:
    //
    //     {"mathjs":"number","value":"2.3"}
    //
    // into a number 2.3
    number.fromJSON = function(json) {
        return parseFloat(json.value);
    };
    return number;
});

});

parcelRegister("b6EZL", function(module, exports) {

$parcel$export(module.exports, "createNumeric", () => $81600e0896bf9f4e$export$e3cf2d123164e554);

var $gs7TF = parcelRequire("gs7TF");

var $4eE2e = parcelRequire("4eE2e");

var $g9z12 = parcelRequire("g9z12");
var $81600e0896bf9f4e$var$name = 'numeric';
var $81600e0896bf9f4e$var$dependencies = [
    'number',
    '?bignumber',
    '?fraction'
];
var $81600e0896bf9f4e$export$e3cf2d123164e554 = /* #__PURE__ */ (0, $4eE2e.factory)($81600e0896bf9f4e$var$name, $81600e0896bf9f4e$var$dependencies, (_ref)=>{
    var { number: _number, bignumber: bignumber, fraction: fraction } = _ref;
    var validInputTypes = {
        string: true,
        number: true,
        BigNumber: true,
        Fraction: true
    }; // Load the conversion functions for each output type
    var validOutputTypes = {
        number: (x)=>_number(x),
        BigNumber: bignumber ? (x)=>bignumber(x) : (0, $g9z12.noBignumber),
        Fraction: fraction ? (x)=>fraction(x) : (0, $g9z12.noFraction)
    };
    /**
   * Convert a numeric input to a specific numeric type: number, BigNumber, or Fraction.
   *
   * Syntax:
   *
   *    math.numeric(x)
   *
   * Examples:
   *
   *    math.numeric('4')                           // returns number 4
   *    math.numeric('4', 'number')                 // returns number 4
   *    math.numeric('4', 'BigNumber')              // returns BigNumber 4
   *    math.numeric('4', 'Fraction')               // returns Fraction 4
   *    math.numeric(4, 'Fraction')                 // returns Fraction 4
   *    math.numeric(math.fraction(2, 5), 'number') // returns number 0.4
   *
   * See also:
   *
   *    number, fraction, bignumber, string, format
   *
   * @param {string | number | BigNumber | Fraction } value
   *              A numeric value or a string containing a numeric value
   * @param {string} outputType
   *              Desired numeric output type.
   *              Available values: 'number', 'BigNumber', or 'Fraction'
   * @return {number | BigNumber | Fraction}
   *              Returns an instance of the numeric in the requested type
   */ return function numeric(value, outputType) {
        var inputType = (0, $gs7TF.typeOf)(value);
        if (!(inputType in validInputTypes)) throw new TypeError('Cannot convert ' + value + ' of type "' + inputType + '"; valid input types are ' + Object.keys(validInputTypes).join(', '));
        if (!(outputType in validOutputTypes)) throw new TypeError('Cannot convert ' + value + ' to type "' + outputType + '"; valid output types are ' + Object.keys(validOutputTypes).join(', '));
        if (outputType === inputType) return value;
        else return validOutputTypes[outputType](value);
    };
});

});
parcelRegister("g9z12", function(module, exports) {

$parcel$export(module.exports, "noBignumber", () => $bc28a60492478778$export$f0829713dc162a8);
$parcel$export(module.exports, "noFraction", () => $bc28a60492478778$export$9978fd42ef220ba0);
$parcel$export(module.exports, "noMatrix", () => $bc28a60492478778$export$b81416cb7ecca475);
function $bc28a60492478778$export$f0829713dc162a8() {
    throw new Error('No "bignumber" implementation available');
}
function $bc28a60492478778$export$9978fd42ef220ba0() {
    throw new Error('No "fraction" implementation available');
}
function $bc28a60492478778$export$b81416cb7ecca475() {
    throw new Error('No "matrix" implementation available');
}
function $bc28a60492478778$export$a38f8cf2e48f2bd() {
    throw new Error('No "index" implementation available');
}
function $bc28a60492478778$export$32411ef9704d5eea() {
    throw new Error('No "matrix" implementation available');
}

});


parcelRegister("hiSMC", function(module, exports) {

$parcel$export(module.exports, "createOct", () => $c98e9ceded81b452$export$6692788ef49c21c9);

var $4eE2e = parcelRequire("4eE2e");
var $c98e9ceded81b452$var$name = 'oct';
var $c98e9ceded81b452$var$dependencies = [
    'typed',
    'format'
];
var $c98e9ceded81b452$export$6692788ef49c21c9 = (0, $4eE2e.factory)($c98e9ceded81b452$var$name, $c98e9ceded81b452$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($c98e9ceded81b452$var$name, {
        'number | BigNumber': function numberBigNumber(n) {
            return format(n, {
                notation: 'oct'
            });
        },
        'number | BigNumber, number': function numberBigNumberNumber(n, wordSize) {
            return format(n, {
                notation: 'oct',
                wordSize: wordSize
            });
        }
    });
});

});

parcelRegister("8AhI2", function(module, exports) {

$parcel$export(module.exports, "createOnes", () => $63ff6c329c7008b3$export$f524a435b9c16a90);

var $gs7TF = parcelRequire("gs7TF");

var $6egKm = parcelRequire("6egKm");

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $63ff6c329c7008b3$var$name = 'ones';
var $63ff6c329c7008b3$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'BigNumber'
];
var $63ff6c329c7008b3$export$f524a435b9c16a90 = /* #__PURE__ */ (0, $4eE2e.factory)($63ff6c329c7008b3$var$name, $63ff6c329c7008b3$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Create a matrix filled with ones. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.ones(m)
   *    math.ones(m, format)
   *    math.ones(m, n)
   *    math.ones(m, n, format)
   *    math.ones([m, n])
   *    math.ones([m, n], format)
   *    math.ones([m, n, p, ...])
   *    math.ones([m, n, p, ...], format)
   *
   * Examples:
   *
   *    math.ones(3)                   // returns [1, 1, 1]
   *    math.ones(3, 2)                // returns [[1, 1], [1, 1], [1, 1]]
   *    math.ones(3, 2, 'dense')       // returns Dense Matrix [[1, 1], [1, 1], [1, 1]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.ones(math.size(A))       // returns [[1, 1, 1], [1, 1, 1]]
   *
   * See also:
   *
   *    zeros, identity, size, range
   *
   * @param {...number | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix | number}  A matrix filled with ones
   */ return typed('ones', {
        '': function _() {
            return config.matrix === 'Array' ? _ones([]) : _ones([], 'default');
        },
        // math.ones(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        '...number | BigNumber | string': function numberBigNumberString(size) {
            var last = size[size.length - 1];
            if (typeof last === 'string') {
                var format = size.pop();
                return _ones(size, format);
            } else if (config.matrix === 'Array') return _ones(size);
            else return _ones(size, 'default');
        },
        Array: _ones,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _ones(size.valueOf(), format);
        },
        'Array | Matrix, string': function ArrayMatrixString(size, format) {
            return _ones(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with ones
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _ones(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(1) : 1;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $10UPF.resize)(arr, size, defaultValue);
            return arr;
        }
    } // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $gs7TF.isBigNumber)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    } // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== 'number' || !(0, $6egKm.isInteger)(value) || value < 0) throw new Error('Parameters in function ones must be positive integers');
        });
    }
});

});

parcelRegister("ePbwm", function(module, exports) {

$parcel$export(module.exports, "createOr", () => $acaec3e7dd128946$export$3d19b09907d6fd4a);

var $6MKpt = parcelRequire("6MKpt");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");

var $69TlR = parcelRequire("69TlR");

var $4eE2e = parcelRequire("4eE2e");

var $jg11Z = parcelRequire("jg11Z");
var $acaec3e7dd128946$var$name = 'or';
var $acaec3e7dd128946$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'DenseMatrix'
];
var $acaec3e7dd128946$export$3d19b09907d6fd4a = /* #__PURE__ */ (0, $4eE2e.factory)($acaec3e7dd128946$var$name, $acaec3e7dd128946$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm05 = (0, $69TlR.createAlgorithm05)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Logical `or`. Test if at least one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.or(x, y)
   *
   * Examples:
   *
   *    math.or(2, 4)   // returns true
   *
   *    a = [2, 5, 0]
   *    b = [0, 22, 0]
   *    c = 0
   *
   *    math.or(a, b)   // returns [true, true, false]
   *    math.or(b, c)   // returns [false, true, false]
   *
   * See also:
   *
   *    and, not, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one of the inputs is defined with a nonzero/nonempty value.
   */ return typed($acaec3e7dd128946$var$name, {
        'number, number': (0, $jg11Z.orNumber),
        'Complex, Complex': function ComplexComplex(x, y) {
            return x.re !== 0 || x.im !== 0 || y.re !== 0 || y.im !== 0;
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return !x.isZero() && !x.isNaN() || !y.isZero() && !y.isNaN();
        },
        'Unit, Unit': function UnitUnit(x, y) {
            return this(x.value || 0, y.value || 0);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, this);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});

});

parcelRegister("i1uRq", function(module, exports) {

$parcel$export(module.exports, "createPartitionSelect", () => $d1f0424ad26b92d1$export$47c1a746705f5c42);

var $gs7TF = parcelRequire("gs7TF");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");
var $d1f0424ad26b92d1$var$name = 'partitionSelect';
var $d1f0424ad26b92d1$var$dependencies = [
    'typed',
    'isNumeric',
    'isNaN',
    'compare'
];
var $d1f0424ad26b92d1$export$47c1a746705f5c42 = /* #__PURE__ */ (0, $4eE2e.factory)($d1f0424ad26b92d1$var$name, $d1f0424ad26b92d1$var$dependencies, (_ref)=>{
    var { typed: typed, isNumeric: isNumeric, isNaN: isNaN, compare: compare } = _ref;
    var asc = compare;
    var desc = (a, b)=>-compare(a, b);
    /**
   * Partition-based selection of an array or 1D matrix.
   * Will find the kth smallest value, and mutates the input array.
   * Uses Quickselect.
   *
   * Syntax:
   *
   *    math.partitionSelect(x, k)
   *    math.partitionSelect(x, k, compare)
   *
   * Examples:
   *
   *    math.partitionSelect([5, 10, 1], 2)           // returns 10
   *    math.partitionSelect(['C', 'B', 'A', 'D'], 1) // returns 'B'
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.partitionSelect(['Langdon', 'Tom', 'Sara'], 2, sortByLength) // returns 'Langdon'
   *
   * See also:
   *
   *    sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Number} k            The kth smallest value to be retrieved zero-based index
   * @param {Function | 'asc' | 'desc'} [compare='asc']
   *        An optional comparator function. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {*} Returns the kth lowest value.
   */ return typed($d1f0424ad26b92d1$var$name, {
        'Array | Matrix, number': function ArrayMatrixNumber(x, k) {
            return _partitionSelect(x, k, asc);
        },
        'Array | Matrix, number, string': function ArrayMatrixNumberString(x, k, compare) {
            if (compare === 'asc') return _partitionSelect(x, k, asc);
            else if (compare === 'desc') return _partitionSelect(x, k, desc);
            else throw new Error('Compare string must be "asc" or "desc"');
        },
        'Array | Matrix, number, function': _partitionSelect
    });
    function _partitionSelect(x, k, compare) {
        if (!(0, $6egKm.isInteger)(k) || k < 0) throw new Error('k must be a non-negative integer');
        if ((0, $gs7TF.isMatrix)(x)) {
            var size = x.size();
            if (size.length > 1) throw new Error('Only one dimensional matrices supported');
            return quickSelect(x.valueOf(), k, compare);
        }
        if (Array.isArray(x)) return quickSelect(x, k, compare);
    }
    /**
   * Quickselect algorithm.
   * Code adapted from:
   * https://blog.teamleadnet.com/2012/07/quick-select-algorithm-find-kth-element.html
   *
   * @param {Array} arr
   * @param {Number} k
   * @param {Function} compare
   * @private
   */ function quickSelect(arr, k, compare) {
        if (k >= arr.length) throw new Error('k out of bounds');
         // check for NaN values since these can cause an infinite while loop
        for(var i = 0; i < arr.length; i++){
            if (isNumeric(arr[i]) && isNaN(arr[i])) return arr[i]; // return NaN
        }
        var from = 0;
        var to = arr.length - 1; // if from == to we reached the kth element
        while(from < to){
            var r = from;
            var w = to;
            var pivot = arr[Math.floor(Math.random() * (to - from + 1)) + from]; // stop if the reader and writer meets
            while(r < w)// arr[r] >= pivot
            if (compare(arr[r], pivot) >= 0) {
                // put the large values at the end
                var tmp = arr[w];
                arr[w] = arr[r];
                arr[r] = tmp;
                --w;
            } else // the value is smaller than the pivot, skip
            ++r;
             // if we stepped up (r++) we need to step one down (arr[r] > pivot)
            if (compare(arr[r], pivot) > 0) --r;
             // the r pointer is on the end of the first k elements
            if (k <= r) to = r;
            else from = r + 1;
        }
        return arr[k];
    }
});

});

parcelRegister("1EwLg", function(module, exports) {

$parcel$export(module.exports, "createPermutations", () => $1342f0995556a790$export$1d58d7915914cc9c);

var $6egKm = parcelRequire("6egKm");

var $78cF8 = parcelRequire("78cF8");

var $4eE2e = parcelRequire("4eE2e");
var $1342f0995556a790$var$name = 'permutations';
var $1342f0995556a790$var$dependencies = [
    'typed',
    'factorial'
];
var $1342f0995556a790$export$1d58d7915914cc9c = /* #__PURE__ */ (0, $4eE2e.factory)($1342f0995556a790$var$name, $1342f0995556a790$var$dependencies, (_ref)=>{
    var { typed: typed, factorial: factorial } = _ref;
    /**
   * Compute the number of ways of obtaining an ordered subset of `k` elements
   * from a set of `n` elements.
   *
   * Permutations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.permutations(n)
   *     math.permutations(n, k)
   *
   * Examples:
   *
   *    math.permutations(5)     // 120
   *    math.permutations(5, 3)  // 60
   *
   * See also:
   *
   *    combinations, combinationsWithRep, factorial
   *
   * @param {number | BigNumber} n   The number of objects in total
   * @param {number | BigNumber} [k] The number of objects in the subset
   * @return {number | BigNumber}    The number of permutations
   */ return typed($1342f0995556a790$var$name, {
        'number | BigNumber': factorial,
        'number, number': function numberNumber(n, k) {
            if (!(0, $6egKm.isInteger)(n) || n < 0) throw new TypeError('Positive integer value expected in function permutations');
            if (!(0, $6egKm.isInteger)(k) || k < 0) throw new TypeError('Positive integer value expected in function permutations');
            if (k > n) throw new TypeError('second argument k must be less than or equal to first argument n');
             // Permute n objects, k at a time
            return (0, $78cF8.product)(n - k + 1, n);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(n, k) {
            var result, i;
            if (!$1342f0995556a790$var$isPositiveInteger(n) || !$1342f0995556a790$var$isPositiveInteger(k)) throw new TypeError('Positive integer value expected in function permutations');
            if (k.gt(n)) throw new TypeError('second argument k must be less than or equal to first argument n');
            var one = n.mul(0).add(1);
            result = one;
            for(i = n.minus(k).plus(1); i.lte(n); i = i.plus(1))result = result.times(i);
            return result;
        } // TODO: implement support for collection in permutations
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $1342f0995556a790$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}

});

parcelRegister("btDSk", function(module, exports) {

$parcel$export(module.exports, "createPickRandom", () => $85b1558522babb64$export$fbe25b9f25feec34);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");

var $gs7TF = parcelRequire("gs7TF");

var $lS0mN = parcelRequire("lS0mN");
var $85b1558522babb64$var$name = 'pickRandom';
var $85b1558522babb64$var$dependencies = [
    'typed',
    'config',
    '?on'
];
var $85b1558522babb64$export$fbe25b9f25feec34 = /* #__PURE__ */ (0, $4eE2e.factory)($85b1558522babb64$var$name, $85b1558522babb64$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $lS0mN.createRng)(config.randomSeed);
    if (on) on('config', function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $lS0mN.createRng)(curr.randomSeed);
    });
    /**
   * Random pick one or more values from a one dimensional array.
   * Array elements are picked using a random function with uniform or weighted distribution.
   *
   * Syntax:
   *
   *     math.pickRandom(array)
   *     math.pickRandom(array, number)
   *     math.pickRandom(array, weights)
   *     math.pickRandom(array, number, weights)
   *     math.pickRandom(array, weights, number)
   *     math.pickRandom(array, { weights, number, elementWise })
   *
   * Examples:
   *
   *     math.pickRandom([3, 6, 12, 2])                  // returns one of the values in the array
   *     math.pickRandom([3, 6, 12, 2], 2)               // returns an array of two of the values in the array
   *     math.pickRandom([3, 6, 12, 2], { number: 2 })   // returns an array of two of the values in the array
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1])    // returns one of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], 2, [1, 3, 2, 1]) // returns an array of two of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1], 2) // returns an array of two of the values in the array with weighted distribution
   *
   *     math.pickRandom([{x: 1.0, y: 2.0}, {x: 1.1, y: 2.0}], { elementWise: false })
   *         // returns one of the items in the array
   *
   * See also:
   *
   *     random, randomInt
   *
   * @param {Array | Matrix} array     A one dimensional array
   * @param {Int} number               An int or float
   * @param {Array | Matrix} weights   An array of ints or floats
   * @return {number | Array}          Returns a single random value from array when number is 1 or undefined.
   *                                   Returns an array with the configured number of elements when number is > 1.
   */ return typed($85b1558522babb64$var$name, {
        'Array | Matrix': function ArrayMatrix(possibles) {
            return _pickRandom(possibles, {});
        },
        'Array | Matrix, Object': function ArrayMatrixObject(possibles, options) {
            return _pickRandom(possibles, options);
        },
        'Array | Matrix, number': function ArrayMatrixNumber(possibles, number) {
            return _pickRandom(possibles, {
                number: number
            });
        },
        'Array | Matrix, Array | Matrix': function ArrayMatrixArrayMatrix(possibles, weights) {
            return _pickRandom(possibles, {
                weights: weights
            });
        },
        'Array | Matrix, Array | Matrix, number': function ArrayMatrixArrayMatrixNumber(possibles, weights, number) {
            return _pickRandom(possibles, {
                number: number,
                weights: weights
            });
        },
        'Array | Matrix, number, Array | Matrix': function ArrayMatrixNumberArrayMatrix(possibles, number, weights) {
            return _pickRandom(possibles, {
                number: number,
                weights: weights
            });
        }
    });
    /**
   * @param {Array | Matrix} possibles
   * @param {{
   *   number?: number,
   *   weights?: Array | Matrix,
   *   elementWise: boolean
   * }} options
   * @returns {number | Array}
   * @private
   */ function _pickRandom(possibles, _ref2) {
        var { number: number, weights: weights, elementWise: elementWise = true } = _ref2;
        var single = typeof number === 'undefined';
        if (single) number = 1;
        var createMatrix = (0, $gs7TF.isMatrix)(possibles) ? possibles.create : (0, $gs7TF.isMatrix)(weights) ? weights.create : null;
        possibles = possibles.valueOf(); // get Array
        if (weights) weights = weights.valueOf(); // get Array
        if (elementWise === true) {
            possibles = (0, $10UPF.flatten)(possibles);
            weights = (0, $10UPF.flatten)(weights);
        }
        var totalWeights = 0;
        if (typeof weights !== 'undefined') {
            if (weights.length !== possibles.length) throw new Error('Weights must have the same length as possibles');
            for(var i = 0, len = weights.length; i < len; i++){
                if (!(0, $gs7TF.isNumber)(weights[i]) || weights[i] < 0) throw new Error('Weights must be an array of positive numbers');
                totalWeights += weights[i];
            }
        }
        var length = possibles.length;
        var result = [];
        var pick;
        while(result.length < number){
            if (typeof weights === 'undefined') pick = possibles[Math.floor(rng() * length)];
            else {
                var randKey = rng() * totalWeights;
                for(var _i = 0, _len = possibles.length; _i < _len; _i++){
                    randKey -= weights[_i];
                    if (randKey < 0) {
                        pick = possibles[_i];
                        break;
                    }
                }
            }
            result.push(pick);
        }
        return single ? result[0] : createMatrix ? createMatrix(result) : result;
    }
});

});
parcelRegister("lS0mN", function(module, exports) {

$parcel$export(module.exports, "createRng", () => $febeecf37d820674$export$eaf9227667332084);

var $ftPHE = parcelRequire("ftPHE");
var $febeecf37d820674$var$singletonRandom = /* #__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($ftPHE)))(Date.now());
function $febeecf37d820674$export$eaf9227667332084(randomSeed) {
    var random; // create a new random generator with given seed
    function setSeed(seed) {
        random = seed === null ? $febeecf37d820674$var$singletonRandom : (0, (/*@__PURE__*/$parcel$interopDefault($ftPHE)))(String(seed));
    } // initialize a seeded pseudo random number generator with config's random seed
    setSeed(randomSeed); // wrapper function so the rng can be updated via generator
    function rng() {
        return random();
    }
    return rng;
}

});
parcelRegister("ftPHE", function(module, exports) {
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $1NWL6 = parcelRequire("1NWL6");

var $8FlDu = parcelRequire("8FlDu");

var $1rFi6 = parcelRequire("1rFi6");

var $iDdZD = parcelRequire("iDdZD");

var $bDA0X = parcelRequire("bDA0X");

var $oBon1 = parcelRequire("oBon1");

var $layLz = parcelRequire("layLz");
$layLz.alea = $1NWL6;
$layLz.xor128 = $8FlDu;
$layLz.xorwow = $1rFi6;
$layLz.xorshift7 = $iDdZD;
$layLz.xor4096 = $bDA0X;
$layLz.tychei = $oBon1;
module.exports = $layLz;

});
parcelRegister("1NWL6", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(' ');
        me.s1 = mash(' ');
        me.s2 = mash(' ');
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("8FlDu", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("1rFi6", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("iDdZD", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = '' + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("bDA0X", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + '\0';
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("oBon1", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("layLz", function(module, exports) {

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = 'random', startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == 'object') {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == 'string' ? obj : obj + '\0';
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if (module.exports) {
        module.exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("1frus"));
        } catch (ex) {}
    } else if (typeof define == 'function' && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math['seed' + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== 'undefined' ? self : module.exports, [], Math // math: package containing random, pow, and seedrandom
);

});
parcelRegister("1frus", function(module, exports) {
"use strict";

});





parcelRegister("gCVW0", function(module, exports) {

$parcel$export(module.exports, "createPow", () => $c1ad228de149eb48$export$9c94d2d08a8d8146);

var $4eE2e = parcelRequire("4eE2e");

var $6egKm = parcelRequire("6egKm");

var $10UPF = parcelRequire("10UPF");

var $eRNhQ = parcelRequire("eRNhQ");
var $c1ad228de149eb48$var$name = 'pow';
var $c1ad228de149eb48$var$dependencies = [
    'typed',
    'config',
    'identity',
    'multiply',
    'matrix',
    'fraction',
    'number',
    'Complex'
];
var $c1ad228de149eb48$export$9c94d2d08a8d8146 = /* #__PURE__ */ (0, $4eE2e.factory)($c1ad228de149eb48$var$name, $c1ad228de149eb48$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, identity: identity, multiply: multiply, matrix: matrix, number: number, fraction: fraction, Complex: Complex } = _ref;
    /**
   * Calculates the power of x to y, `x ^ y`.
   * Matrix exponentiation is supported for square matrices `x`, and positive
   * integer exponents `y`.
   *
   * For cubic roots of negative numbers, the function returns the principal
   * root by default. In order to let the function return the real root,
   * math.js can be configured with `math.config({predictable: true})`.
   * To retrieve all cubic roots of a value, use `math.cbrt(x, true)`.
   *
   * Syntax:
   *
   *    math.pow(x, y)
   *
   * Examples:
   *
   *    math.pow(2, 3)               // returns number 8
   *
   *    const a = math.complex(2, 3)
   *    math.pow(a, 2)                // returns Complex -5 + 12i
   *
   *    const b = [[1, 2], [4, 3]]
   *    math.pow(b, 2)               // returns Array [[9, 8], [16, 17]]
   *
   * See also:
   *
   *    multiply, sqrt, cbrt, nthRoot
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | Complex} y                          The exponent
   * @return {number | BigNumber | Complex | Array | Matrix} The value of `x` to the power `y`
   */ return typed($c1ad228de149eb48$var$name, {
        'number, number': _pow,
        'Complex, Complex': function ComplexComplex(x, y) {
            return x.pow(y);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            if (y.isInteger() || x >= 0 || config.predictable) return x.pow(y);
            else return new Complex(x.toNumber(), 0).pow(y.toNumber(), 0);
        },
        'Fraction, Fraction': function FractionFraction(x, y) {
            var result = x.pow(y);
            if (result != null) return result;
            if (config.predictable) throw new Error('Result of pow is non-rational and cannot be expressed as a fraction');
            else return _pow(x.valueOf(), y.valueOf());
        },
        'Array, number': _powArray,
        'Array, BigNumber': function ArrayBigNumber(x, y) {
            return _powArray(x, y.toNumber());
        },
        'Matrix, number': _powMatrix,
        'Matrix, BigNumber': function MatrixBigNumber(x, y) {
            return _powMatrix(x, y.toNumber());
        },
        'Unit, number | BigNumber': function UnitNumberBigNumber(x, y) {
            return x.pow(y);
        }
    });
    /**
   * Calculates the power of x to y, x^y, for two numbers.
   * @param {number} x
   * @param {number} y
   * @return {number | Complex} res
   * @private
   */ function _pow(x, y) {
        // Alternatively could define a 'realmode' config option or something, but
        // 'predictable' will work for now
        if (config.predictable && !(0, $6egKm.isInteger)(y) && x < 0) // Check to see if y can be represented as a fraction
        try {
            var yFrac = fraction(y);
            var yNum = number(yFrac);
            if (y === yNum || Math.abs((y - yNum) / y) < 1e-14) {
                if (yFrac.d % 2 === 1) return (yFrac.n % 2 === 0 ? 1 : -1) * Math.pow(-x, y);
            }
        } catch (ex) {} // Unable to express y as a fraction, so continue on
         // **for predictable mode** x^Infinity === NaN if x < -1
        // N.B. this behavour is different from `Math.pow` which gives
        // (-2)^Infinity === Infinity
        if (config.predictable && (x < -1 && y === Infinity || x > -1 && x < 0 && y === -Infinity)) return NaN;
        if ((0, $6egKm.isInteger)(y) || x >= 0 || config.predictable) return (0, $eRNhQ.powNumber)(x, y);
        else {
            // TODO: the following infinity checks are duplicated from powNumber. Deduplicate this somehow
            // x^Infinity === 0 if -1 < x < 1
            // A real number 0 is returned instead of complex(0)
            if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
            return new Complex(x, 0).pow(y, 0);
        }
    }
    /**
   * Calculate the power of a 2d array
   * @param {Array} x     must be a 2 dimensional, square matrix
   * @param {number} y    a positive, integer value
   * @returns {Array}
   * @private
   */ function _powArray(x, y) {
        if (!(0, $6egKm.isInteger)(y) || y < 0) throw new TypeError('For A^b, b must be a positive integer (value is ' + y + ')');
         // verify that A is a 2 dimensional square matrix
        var s = (0, $10UPF.arraySize)(x);
        if (s.length !== 2) throw new Error('For A^b, A must be 2 dimensional (A has ' + s.length + ' dimensions)');
        if (s[0] !== s[1]) throw new Error('For A^b, A must be square (size is ' + s[0] + 'x' + s[1] + ')');
        var res = identity(s[0]).valueOf();
        var px = x;
        while(y >= 1){
            if ((y & 1) === 1) res = multiply(px, res);
            y >>= 1;
            px = multiply(px, px);
        }
        return res;
    }
    /**
   * Calculate the power of a 2d matrix
   * @param {Matrix} x     must be a 2 dimensional, square matrix
   * @param {number} y    a positive, integer value
   * @returns {Matrix}
   * @private
   */ function _powMatrix(x, y) {
        return matrix(_powArray(x.valueOf(), y));
    }
});

});

parcelRegister("7maP8", function(module, exports) {

$parcel$export(module.exports, "createPrint", () => $55b2fbdae9eeccee$export$ea4b9d9569ff81cc);

var $aEppI = parcelRequire("aEppI");

var $gs7TF = parcelRequire("gs7TF");

var $4eE2e = parcelRequire("4eE2e");
var $55b2fbdae9eeccee$var$name = 'print';
var $55b2fbdae9eeccee$var$dependencies = [
    'typed'
];
var $55b2fbdae9eeccee$export$ea4b9d9569ff81cc = /* #__PURE__ */ (0, $4eE2e.factory)($55b2fbdae9eeccee$var$name, $55b2fbdae9eeccee$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Interpolate values into a string template.
   *
   * Syntax:
   *
   *     math.print(template, values)
   *     math.print(template, values, precision)
   *     math.print(template, values, options)
   *
   * Example usage:
   *
   *     // the following outputs: 'Lucy is 5 years old'
   *     math.print('Lucy is $age years old', {age: 5})
   *
   *     // the following outputs: 'The value of pi is 3.141592654'
   *     math.print('The value of pi is $pi', {pi: math.pi}, 10)
   *
   *     // the following outputs: 'hello Mary! The date is 2013-03-23'
   *     math.print('Hello $user.name! The date is $date', {
   *       user: {
   *         name: 'Mary',
   *       },
   *       date: new Date(2013, 2, 23).toISOString().substring(0, 10)
   *     })
   *
   *     // the following outputs: 'My favorite fruits are apples and bananas !'
   *     math.print('My favorite fruits are $0 and $1 !', [
   *       'apples',
   *       'bananas'
   *     ])
   *
   * See also:
   *
   *     format
   *
   * @param {string} template           A string containing variable placeholders.
   * @param {Object | Array | Matrix}   values An object or array containing variables
   *                                    which will be filled in in the template.
   * @param {number | Object} [options] Formatting options,
   *                                    or the number of digits to format numbers.
   *                                    See function math.format for a description
   *                                    of all options.
   * @return {string} Interpolated string
   */ return typed($55b2fbdae9eeccee$var$name, {
        // note: Matrix will be converted automatically to an Array
        'string, Object | Array': $55b2fbdae9eeccee$var$_print,
        'string, Object | Array, number | Object': $55b2fbdae9eeccee$var$_print
    });
});
/**
 * Interpolate values into a string template.
 * @param {string} template
 * @param {Object} values
 * @param {number | Object} [options]
 * @returns {string} Interpolated string
 * @private
 */ function $55b2fbdae9eeccee$var$_print(template, values, options) {
    return template.replace(/\$([\w.]+)/g, function(original, key) {
        var keys = key.split('.');
        var value = values[keys.shift()];
        while(keys.length && value !== undefined){
            var k = keys.shift();
            value = k ? value[k] : value + '.';
        }
        if (value !== undefined) {
            if (!(0, $gs7TF.isString)(value)) return (0, $aEppI.format)(value, options);
            else return value;
        }
        return original;
    });
}

});

parcelRegister("ldY29", function(module, exports) {

$parcel$export(module.exports, "createProd", () => $f739614dd232ec19$export$60310f756e9cfd41);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");

var $ijiby = parcelRequire("ijiby");
var $f739614dd232ec19$var$name = 'prod';
var $f739614dd232ec19$var$dependencies = [
    'typed',
    'config',
    'multiplyScalar',
    'numeric'
];
var $f739614dd232ec19$export$60310f756e9cfd41 = /* #__PURE__ */ (0, $4eE2e.factory)($f739614dd232ec19$var$name, $f739614dd232ec19$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, numeric: numeric } = _ref;
    /**
   * Compute the product of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.prod(a, b, c, ...)
   *     math.prod(A)
   *
   * Examples:
   *
   *     math.multiply(2, 3)           // returns 6
   *     math.prod(2, 3)               // returns 6
   *     math.prod(2, 3, 4)            // returns 24
   *     math.prod([2, 3, 4])          // returns 24
   *     math.prod([[2, 5], [4, 3]])   // returns 120
   *
   * See also:
   *
   *    mean, median, min, max, sum, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The product of all values
   */ return typed($f739614dd232ec19$var$name, {
        // prod([a, b, c, d, ...])
        'Array | Matrix': _prod,
        // prod([a, b, c, d, ...], dim)
        'Array | Matrix, number | BigNumber': function ArrayMatrixNumberBigNumber(array, dim) {
            // TODO: implement prod(A, dim)
            throw new Error('prod(A, dim) is not yet supported'); // return reduce(arguments[0], arguments[1], math.prod)
        },
        // prod(a, b, c, d, ...)
        '...': function _(args) {
            return _prod(args);
        }
    });
    /**
   * Recursively calculate the product of an n-dimensional array
   * @param {Array} array
   * @return {number} prod
   * @private
   */ function _prod(array) {
        var prod;
        (0, $9nwyh.deepForEach)(array, function(value) {
            try {
                prod = prod === undefined ? value : multiplyScalar(prod, value);
            } catch (err) {
                throw (0, $ijiby.improveErrorMessage)(err, 'prod', value);
            }
        }); // make sure returning numeric value: parse a string into a numeric value
        if (typeof prod === 'string') prod = numeric(prod, config.number);
        if (prod === undefined) throw new Error('Cannot calculate prod of an empty array');
        return prod;
    }
});

});

parcelRegister("3atMK", function(module, exports) {

$parcel$export(module.exports, "createQr", () => $24e968fd1c2630f5$export$39b52312ba2c4d03);

var $8Wv3B = parcelRequire("8Wv3B");

var $4eE2e = parcelRequire("4eE2e");
var $24e968fd1c2630f5$var$name = 'qr';
var $24e968fd1c2630f5$var$dependencies = [
    'typed',
    'matrix',
    'zeros',
    'identity',
    'isZero',
    'equal',
    'sign',
    'sqrt',
    'conj',
    'unaryMinus',
    'addScalar',
    'divideScalar',
    'multiplyScalar',
    'subtract',
    'complex'
];
var $24e968fd1c2630f5$export$39b52312ba2c4d03 = /* #__PURE__ */ (0, $4eE2e.factory)($24e968fd1c2630f5$var$name, $24e968fd1c2630f5$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, zeros: zeros, identity: identity, isZero: isZero, equal: equal, sign: sign, sqrt: sqrt, conj: conj, unaryMinus: unaryMinus, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, complex: complex } = _ref;
    /**
   * Calculate the Matrix QR decomposition. Matrix `A` is decomposed in
   * two matrices (`Q`, `R`) where `Q` is an
   * orthogonal matrix and `R` is an upper triangular matrix.
   *
   * Syntax:
   *
   *    math.qr(A)
   *
   * Example:
   *
   *    const m = [
   *      [1, -1,  4],
   *      [1,  4, -2],
   *      [1,  4,  2],
   *      [1,  -1, 0]
   *    ]
   *    const result = math.qr(m)
   *    // r = {
   *    //   Q: [
   *    //     [0.5, -0.5,   0.5],
   *    //     [0.5,  0.5,  -0.5],
   *    //     [0.5,  0.5,   0.5],
   *    //     [0.5, -0.5,  -0.5],
   *    //   ],
   *    //   R: [
   *    //     [2, 3,  2],
   *    //     [0, 5, -2],
   *    //     [0, 0,  4],
   *    //     [0, 0,  0]
   *    //   ]
   *    // }
   *
   * See also:
   *
   *    lup, lusolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array
   * for which to get the QR decomposition.
   *
   * @return {{Q: Array | Matrix, R: Array | Matrix}} Q: the orthogonal
   * matrix and R: the upper triangular matrix
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($8Wv3B)))(typed($24e968fd1c2630f5$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseQR(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseQR(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a); // lup, use matrix implementation
            var r = _denseQR(m); // result
            return {
                Q: r.Q.valueOf(),
                R: r.R.valueOf()
            };
        }
    }), {
        _denseQRimpl: _denseQRimpl
    });
    function _denseQRimpl(m) {
        // rows & columns (m x n)
        var rows = m._size[0]; // m
        var cols = m._size[1]; // n
        var Q = identity([
            rows
        ], 'dense');
        var Qdata = Q._data;
        var R = m.clone();
        var Rdata = R._data; // vars
        var i, j, k;
        var w = zeros([
            rows
        ], '');
        for(k = 0; k < Math.min(cols, rows); ++k){
            /*
       * **k-th Household matrix**
       *
       * The matrix I - 2*v*transpose(v)
       * x     = first column of A
       * x1    = first element of x
       * alpha = x1 / |x1| * |x|
       * e1    = tranpose([1, 0, 0, ...])
       * u     = x - alpha * e1
       * v     = u / |u|
       *
       * Household matrix = I - 2 * v * tranpose(v)
       *
       *  * Initially Q = I and R = A.
       *  * Household matrix is a reflection in a plane normal to v which
       *    will zero out all but the top right element in R.
       *  * Appplying reflection to both Q and R will not change product.
       *  * Repeat this process on the (1,1) minor to get R as an upper
       *    triangular matrix.
       *  * Reflections leave the magnitude of the columns of Q unchanged
       *    so Q remains othoganal.
       *
       */ var pivot = Rdata[k][k];
            var sgn = unaryMinus(equal(pivot, 0) ? 1 : sign(pivot));
            var conjSgn = conj(sgn);
            var alphaSquared = 0;
            for(i = k; i < rows; i++)alphaSquared = addScalar(alphaSquared, multiplyScalar(Rdata[i][k], conj(Rdata[i][k])));
            var alpha = multiplyScalar(sgn, sqrt(alphaSquared));
            if (!isZero(alpha)) {
                // first element in vector u
                var u1 = subtract(pivot, alpha); // w = v * u1 / |u|    (only elements k to (rows-1) are used)
                w[k] = 1;
                for(i = k + 1; i < rows; i++)w[i] = divideScalar(Rdata[i][k], u1);
                 // tau = - conj(u1 / alpha)
                var tau = unaryMinus(conj(divideScalar(u1, alpha)));
                var s = void 0;
                /*
         * tau and w have been choosen so that
         *
         * 2 * v * tranpose(v) = tau * w * tranpose(w)
         */ /*
         * -- calculate R = R - tau * w * tranpose(w) * R --
         * Only do calculation with rows k to (rows-1)
         * Additionally columns 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(j = k; j < cols; j++){
                    s = 0.0; // calculate jth element of [tranpose(w) * R]
                    for(i = k; i < rows; i++)s = addScalar(s, multiplyScalar(conj(w[i]), Rdata[i][j]));
                     // calculate the jth element of [tau * transpose(w) * R]
                    s = multiplyScalar(s, tau);
                    for(i = k; i < rows; i++)Rdata[i][j] = multiplyScalar(subtract(Rdata[i][j], multiplyScalar(w[i], s)), conjSgn);
                }
                /*
         * -- calculate Q = Q - tau * Q * w * transpose(w) --
         * Q is a square matrix (rows x rows)
         * Only do calculation with columns k to (rows-1)
         * Additionally rows 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(i = 0; i < rows; i++){
                    s = 0.0; // calculate ith element of [Q * w]
                    for(j = k; j < rows; j++)s = addScalar(s, multiplyScalar(Qdata[i][j], w[j]));
                     // calculate the ith element of [tau * Q * w]
                    s = multiplyScalar(s, tau);
                    for(j = k; j < rows; ++j)Qdata[i][j] = divideScalar(subtract(Qdata[i][j], multiplyScalar(s, conj(w[j]))), conjSgn);
                }
            }
        } // return matrices
        return {
            Q: Q,
            R: R,
            toString: function toString() {
                return 'Q: ' + this.Q.toString() + '\nR: ' + this.R.toString();
            }
        };
    }
    function _denseQR(m) {
        var ret = _denseQRimpl(m);
        var Rdata = ret.R._data;
        if (m._data.length > 0) {
            var zero = Rdata[0][0].type === 'Complex' ? complex(0) : 0;
            for(var i = 0; i < Rdata.length; ++i)for(var j = 0; j < i && j < (Rdata[0] || []).length; ++j)Rdata[i][j] = zero;
        }
        return ret;
    }
    function _sparseQR(m) {
        throw new Error('qr not implemented for sparse matrices yet');
    }
});

});

parcelRegister("b2fQ4", function(module, exports) {

$parcel$export(module.exports, "createQuantileSeq", () => $808c2ade9a3b05a7$export$524607d17ea053e9);

var $gs7TF = parcelRequire("gs7TF");

var $6egKm = parcelRequire("6egKm");

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $808c2ade9a3b05a7$var$name = 'quantileSeq';
var $808c2ade9a3b05a7$var$dependencies = [
    'typed',
    'add',
    'multiply',
    'partitionSelect',
    'compare'
];
var $808c2ade9a3b05a7$export$524607d17ea053e9 = /* #__PURE__ */ (0, $4eE2e.factory)($808c2ade9a3b05a7$var$name, $808c2ade9a3b05a7$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, multiply: multiply, partitionSelect: partitionSelect, compare: compare } = _ref;
    /**
   * Compute the prob order quantile of a matrix or a list with values.
   * The sequence is sorted and the middle value is returned.
   * Supported types of sequence values are: Number, BigNumber, Unit
   * Supported types of probability are: Number, BigNumber
   *
   * In case of a (multi dimensional) array or matrix, the prob order quantile
   * of all elements will be calculated.
   *
   * Syntax:
   *
   *     math.quantileSeq(A, prob[, sorted])
   *     math.quantileSeq(A, [prob1, prob2, ...][, sorted])
   *     math.quantileSeq(A, N[, sorted])
   *
   * Examples:
   *
   *     math.quantileSeq([3, -1, 5, 7], 0.5)         // returns 4
   *     math.quantileSeq([3, -1, 5, 7], [1/3, 2/3])  // returns [3, 5]
   *     math.quantileSeq([3, -1, 5, 7], 2)           // returns [3, 5]
   *     math.quantileSeq([-1, 3, 5, 7], 0.5, true)   // returns 4
   *
   * See also:
   *
   *     median, mean, min, max, sum, prod, std, variance
   *
   * @param {Array, Matrix} data                A single matrix or Array
   * @param {Number, BigNumber, Array} probOrN  prob is the order of the quantile, while N is
   *                                            the amount of evenly distributed steps of
   *                                            probabilities; only one of these options can
   *                                            be provided
   * @param {Boolean} sorted=false              is data sorted in ascending order
   * @return {Number, BigNumber, Unit, Array}   Quantile(s)
   */ function quantileSeq(data, probOrN, sorted) {
        var probArr, dataArr, one;
        if (arguments.length < 2 || arguments.length > 3) throw new SyntaxError('Function quantileSeq requires two or three parameters');
        if ((0, $gs7TF.isCollection)(data)) {
            sorted = sorted || false;
            if (typeof sorted === 'boolean') {
                dataArr = data.valueOf();
                if ((0, $gs7TF.isNumber)(probOrN)) {
                    if (probOrN < 0) throw new Error('N/prob must be non-negative');
                    if (probOrN <= 1) // quantileSeq([a, b, c, d, ...], prob[,sorted])
                    return _quantileSeq(dataArr, probOrN, sorted);
                    if (probOrN > 1) {
                        // quantileSeq([a, b, c, d, ...], N[,sorted])
                        if (!(0, $6egKm.isInteger)(probOrN)) throw new Error('N must be a positive integer');
                        var nPlusOne = probOrN + 1;
                        probArr = new Array(probOrN);
                        for(var i = 0; i < probOrN;)probArr[i] = _quantileSeq(dataArr, ++i / nPlusOne, sorted);
                        return probArr;
                    }
                }
                if ((0, $gs7TF.isBigNumber)(probOrN)) {
                    var BigNumber = probOrN.constructor;
                    if (probOrN.isNegative()) throw new Error('N/prob must be non-negative');
                    one = new BigNumber(1);
                    if (probOrN.lte(one)) // quantileSeq([a, b, c, d, ...], prob[,sorted])
                    return new BigNumber(_quantileSeq(dataArr, probOrN, sorted));
                    if (probOrN.gt(one)) {
                        // quantileSeq([a, b, c, d, ...], N[,sorted])
                        if (!probOrN.isInteger()) throw new Error('N must be a positive integer');
                         // largest possible Array length is 2^32-1
                        // 2^32 < 10^15, thus safe conversion guaranteed
                        var intN = probOrN.toNumber();
                        if (intN > 4294967295) throw new Error('N must be less than or equal to 2^32-1, as that is the maximum length of an Array');
                        var _nPlusOne = new BigNumber(intN + 1);
                        probArr = new Array(intN);
                        for(var _i = 0; _i < intN;)probArr[_i] = new BigNumber(_quantileSeq(dataArr, new BigNumber(++_i).div(_nPlusOne), sorted));
                        return probArr;
                    }
                }
                if (Array.isArray(probOrN)) {
                    // quantileSeq([a, b, c, d, ...], [prob1, prob2, ...][,sorted])
                    probArr = new Array(probOrN.length);
                    for(var _i2 = 0; _i2 < probArr.length; ++_i2){
                        var currProb = probOrN[_i2];
                        if ((0, $gs7TF.isNumber)(currProb)) {
                            if (currProb < 0 || currProb > 1) throw new Error('Probability must be between 0 and 1, inclusive');
                        } else if ((0, $gs7TF.isBigNumber)(currProb)) {
                            one = new currProb.constructor(1);
                            if (currProb.isNegative() || currProb.gt(one)) throw new Error('Probability must be between 0 and 1, inclusive');
                        } else throw new TypeError('Unexpected type of argument in function quantileSeq'); // FIXME: becomes redundant when converted to typed-function
                        probArr[_i2] = _quantileSeq(dataArr, currProb, sorted);
                    }
                    return probArr;
                }
                throw new TypeError('Unexpected type of argument in function quantileSeq'); // FIXME: becomes redundant when converted to typed-function
            }
            throw new TypeError('Unexpected type of argument in function quantileSeq'); // FIXME: becomes redundant when converted to typed-function
        }
        throw new TypeError('Unexpected type of argument in function quantileSeq'); // FIXME: becomes redundant when converted to typed-function
    }
    /**
   * Calculate the prob order quantile of an n-dimensional array.
   *
   * @param {Array} array
   * @param {Number, BigNumber} prob
   * @param {Boolean} sorted
   * @return {Number, BigNumber, Unit} prob order quantile
   * @private
   */ function _quantileSeq(array, prob, sorted) {
        var flat = (0, $10UPF.flatten)(array);
        var len = flat.length;
        if (len === 0) throw new Error('Cannot calculate quantile of an empty sequence');
        if ((0, $gs7TF.isNumber)(prob)) {
            var _index = prob * (len - 1);
            var _fracPart = _index % 1;
            if (_fracPart === 0) {
                var value = sorted ? flat[_index] : partitionSelect(flat, _index);
                validate(value);
                return value;
            }
            var _integerPart = Math.floor(_index);
            var _left;
            var _right;
            if (sorted) {
                _left = flat[_integerPart];
                _right = flat[_integerPart + 1];
            } else {
                _right = partitionSelect(flat, _integerPart + 1); // max of partition is kth largest
                _left = flat[_integerPart];
                for(var i = 0; i < _integerPart; ++i)if (compare(flat[i], _left) > 0) _left = flat[i];
            }
            validate(_left);
            validate(_right); // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
            return add(multiply(_left, 1 - _fracPart), multiply(_right, _fracPart));
        } // If prob is a BigNumber
        var index = prob.times(len - 1);
        if (index.isInteger()) {
            index = index.toNumber();
            var _value = sorted ? flat[index] : partitionSelect(flat, index);
            validate(_value);
            return _value;
        }
        var integerPart = index.floor();
        var fracPart = index.minus(integerPart);
        var integerPartNumber = integerPart.toNumber();
        var left;
        var right;
        if (sorted) {
            left = flat[integerPartNumber];
            right = flat[integerPartNumber + 1];
        } else {
            right = partitionSelect(flat, integerPartNumber + 1); // max of partition is kth largest
            left = flat[integerPartNumber];
            for(var _i3 = 0; _i3 < integerPartNumber; ++_i3)if (compare(flat[_i3], left) > 0) left = flat[_i3];
        }
        validate(left);
        validate(right); // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
        var one = new fracPart.constructor(1);
        return add(multiply(left, one.minus(fracPart)), multiply(right, fracPart));
    }
    /**
   * Check if array value types are valid, throw error otherwise.
   * @param {number | BigNumber | Unit} x
   * @param {number | BigNumber | Unit} x
   * @private
   */ var validate = typed({
        'number | BigNumber | Unit': function numberBigNumberUnit(x) {
            return x;
        }
    });
    return quantileSeq;
});

});

parcelRegister("1aZzR", function(module, exports) {

$parcel$export(module.exports, "createRandom", () => $0db67d9f39c769d6$export$5c03d20f483e909a);

var $4eE2e = parcelRequire("4eE2e");

var $gs7TF = parcelRequire("gs7TF");

var $lS0mN = parcelRequire("lS0mN");

var $6Dvgj = parcelRequire("6Dvgj");
var $0db67d9f39c769d6$var$name = 'random';
var $0db67d9f39c769d6$var$dependencies = [
    'typed',
    'config',
    '?on'
];
var $0db67d9f39c769d6$export$5c03d20f483e909a = /* #__PURE__ */ (0, $4eE2e.factory)($0db67d9f39c769d6$var$name, $0db67d9f39c769d6$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $lS0mN.createRng)(config.randomSeed);
    if (on) on('config', function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $lS0mN.createRng)(curr.randomSeed);
    });
    /**
   * Return a random number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.random()                // generate a random number between 0 and 1
   *     math.random(max)             // generate a random number between 0 and max
   *     math.random(min, max)        // generate a random number between min and max
   *     math.random(size)            // generate a matrix with random numbers between 0 and 1
   *     math.random(size, max)       // generate a matrix with random numbers between 0 and max
   *     math.random(size, min, max)  // generate a matrix with random numbers between min and max
   *
   * Examples:
   *
   *     math.random()       // returns a random number between 0 and 1
   *     math.random(100)    // returns a random number between 0 and 100
   *     math.random(30, 40) // returns a random number between 30 and 40
   *     math.random([2, 3]) // returns a 2x3 matrix with random numbers between 0 and 1
   *
   * See also:
   *
   *     randomInt, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random number
   */ return typed($0db67d9f39c769d6$var$name, {
        '': ()=>_random(0, 1),
        number: (max)=>_random(0, max),
        'number, number': (min, max)=>_random(min, max),
        'Array | Matrix': (size)=>_randomMatrix(size, 0, 1),
        'Array | Matrix, number': (size, max)=>_randomMatrix(size, 0, max),
        'Array | Matrix, number, number': (size, min, max)=>_randomMatrix(size, min, max)
    });
    function _randomMatrix(size, min, max) {
        var res = (0, $6Dvgj.randomMatrix)(size.valueOf(), ()=>_random(min, max));
        return (0, $gs7TF.isMatrix)(size) ? size.create(res) : res;
    }
    function _random(min, max) {
        return min + rng() * (max - min);
    }
}); // number only implementation of random, no matrix support
var $0db67d9f39c769d6$export$267a132af241f602 = /* #__PURE__ */ (0, $4eE2e.factory)($0db67d9f39c769d6$var$name, [
    'typed',
    'config',
    '?on'
], (_ref2)=>{
    var { typed: typed, config: config, on: on, matrix: matrix } = _ref2;
    // seeded pseudo random number generator1
    var rng = (0, $lS0mN.createRng)(config.randomSeed);
    if (on) on('config', function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $lS0mN.createRng)(curr.randomSeed);
    });
    return typed($0db67d9f39c769d6$var$name, {
        '': ()=>_random(0, 1),
        number: (max)=>_random(0, max),
        'number, number': (min, max)=>_random(min, max)
    });
    function _random(min, max) {
        return min + rng() * (max - min);
    }
});

});
parcelRegister("6Dvgj", function(module, exports) {

$parcel$export(module.exports, "randomMatrix", () => $4d4ea29cfee0871e$export$6549281d357a44ec);
/**
 * This is a util function for generating a random matrix recursively.
 * @param {number[]} size
 * @param {function} random
 * @returns {Array}
 */ function $4d4ea29cfee0871e$export$6549281d357a44ec(size, random) {
    var data = [];
    size = size.slice(0);
    if (size.length > 1) for(var i = 0, length = size.shift(); i < length; i++)data.push($4d4ea29cfee0871e$export$6549281d357a44ec(size, random));
    else for(var _i = 0, _length = size.shift(); _i < _length; _i++)data.push(random());
    return data;
}

});


parcelRegister("4wYIm", function(module, exports) {

$parcel$export(module.exports, "createRandomInt", () => $34c93f3a678a1b1f$export$e158da47ae479dd4);

var $4eE2e = parcelRequire("4eE2e");

var $6Dvgj = parcelRequire("6Dvgj");

var $lS0mN = parcelRequire("lS0mN");

var $gs7TF = parcelRequire("gs7TF");
var $34c93f3a678a1b1f$var$name = 'randomInt';
var $34c93f3a678a1b1f$var$dependencies = [
    'typed',
    'config',
    '?on'
];
var $34c93f3a678a1b1f$export$e158da47ae479dd4 = /* #__PURE__ */ (0, $4eE2e.factory)($34c93f3a678a1b1f$var$name, $34c93f3a678a1b1f$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $lS0mN.createRng)(config.randomSeed);
    if (on) on('config', function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $lS0mN.createRng)(curr.randomSeed);
    });
    /**
   * Return a random integer number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.randomInt()                // generate a random integer between 0 and 1
   *     math.randomInt(max)             // generate a random integer between 0 and max
   *     math.randomInt(min, max)        // generate a random integer between min and max
   *     math.randomInt(size)            // generate a matrix with random integer between 0 and 1
   *     math.randomInt(size, max)       // generate a matrix with random integer between 0 and max
   *     math.randomInt(size, min, max)  // generate a matrix with random integer between min and max
   *
   * Examples:
   *
   *     math.randomInt(100)    // returns a random integer between 0 and 100
   *     math.randomInt(30, 40) // returns a random integer between 30 and 40
   *     math.randomInt([2, 3]) // returns a 2x3 matrix with random integers between 0 and 1
   *
   * See also:
   *
   *     random, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random integer value
   */ return typed($34c93f3a678a1b1f$var$name, {
        '': ()=>_randomInt(0, 1),
        number: (max)=>_randomInt(0, max),
        'number, number': (min, max)=>_randomInt(min, max),
        'Array | Matrix': (size)=>_randomIntMatrix(size, 0, 1),
        'Array | Matrix, number': (size, max)=>_randomIntMatrix(size, 0, max),
        'Array | Matrix, number, number': (size, min, max)=>_randomIntMatrix(size, min, max)
    });
    function _randomIntMatrix(size, min, max) {
        var res = (0, $6Dvgj.randomMatrix)(size.valueOf(), ()=>_randomInt(min, max));
        return (0, $gs7TF.isMatrix)(size) ? size.create(res) : res;
    }
    function _randomInt(min, max) {
        return Math.floor(min + rng() * (max - min));
    }
});

});

parcelRegister("cVCJF", function(module, exports) {

$parcel$export(module.exports, "createRange", () => $9698dafe574d6a63$export$d372f2f3c4d1b8e5);

var $4eE2e = parcelRequire("4eE2e");

var $g9z12 = parcelRequire("g9z12");
var $9698dafe574d6a63$var$name = 'range';
var $9698dafe574d6a63$var$dependencies = [
    'typed',
    'config',
    '?matrix',
    '?bignumber',
    'smaller',
    'smallerEq',
    'larger',
    'largerEq'
];
var $9698dafe574d6a63$export$d372f2f3c4d1b8e5 = /* #__PURE__ */ (0, $4eE2e.factory)($9698dafe574d6a63$var$name, $9698dafe574d6a63$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, bignumber: bignumber, smaller: smaller, smallerEq: smallerEq, larger: larger, largerEq: largerEq } = _ref;
    /**
   * Create an array from a range.
   * By default, the range end is excluded. This can be customized by providing
   * an extra parameter `includeEnd`.
   *
   * Syntax:
   *
   *     math.range(str [, includeEnd])               // Create a range from a string,
   *                                                  // where the string contains the
   *                                                  // start, optional step, and end,
   *                                                  // separated by a colon.
   *     math.range(start, end [, includeEnd])        // Create a range with start and
   *                                                  // end and a step size of 1.
   *     math.range(start, end, step [, includeEnd])  // Create a range with start, step,
   *                                                  // and end.
   *
   * Where:
   *
   * - `str: string`
   *   A string 'start:end' or 'start:step:end'
   * - `start: {number | BigNumber}`
   *   Start of the range
   * - `end: number | BigNumber`
   *   End of the range, excluded by default, included when parameter includeEnd=true
   * - `step: number | BigNumber`
   *   Step size. Default value is 1.
   * - `includeEnd: boolean`
   *   Option to specify whether to include the end or not. False by default.
   *
   * Examples:
   *
   *     math.range(2, 6)        // [2, 3, 4, 5]
   *     math.range(2, -3, -1)   // [2, 1, 0, -1, -2]
   *     math.range('2:1:6')     // [2, 3, 4, 5]
   *     math.range(2, 6, true)  // [2, 3, 4, 5, 6]
   *
   * See also:
   *
   *     ones, zeros, size, subset
   *
   * @param {*} args   Parameters describing the ranges `start`, `end`, and optional `step`.
   * @return {Array | Matrix} range
   */ return typed($9698dafe574d6a63$var$name, {
        // TODO: simplify signatures when typed-function supports default values and optional arguments
        // TODO: a number or boolean should not be converted to string here
        string: _strRange,
        'string, boolean': _strRange,
        'number, number': function numberNumber(start, end) {
            return _out(_rangeEx(start, end, 1));
        },
        'number, number, number': function numberNumberNumber(start, end, step) {
            return _out(_rangeEx(start, end, step));
        },
        'number, number, boolean': function numberNumberBoolean(start, end, includeEnd) {
            return includeEnd ? _out(_rangeInc(start, end, 1)) : _out(_rangeEx(start, end, 1));
        },
        'number, number, number, boolean': function numberNumberNumberBoolean(start, end, step, includeEnd) {
            return includeEnd ? _out(_rangeInc(start, end, step)) : _out(_rangeEx(start, end, step));
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(start, end) {
            var BigNumber = start.constructor;
            return _out(_bigRangeEx(start, end, new BigNumber(1)));
        },
        'BigNumber, BigNumber, BigNumber': function BigNumberBigNumberBigNumber(start, end, step) {
            return _out(_bigRangeEx(start, end, step));
        },
        'BigNumber, BigNumber, boolean': function BigNumberBigNumberBoolean(start, end, includeEnd) {
            var BigNumber = start.constructor;
            return includeEnd ? _out(_bigRangeInc(start, end, new BigNumber(1))) : _out(_bigRangeEx(start, end, new BigNumber(1)));
        },
        'BigNumber, BigNumber, BigNumber, boolean': function BigNumberBigNumberBigNumberBoolean(start, end, step, includeEnd) {
            return includeEnd ? _out(_bigRangeInc(start, end, step)) : _out(_bigRangeEx(start, end, step));
        }
    });
    function _out(arr) {
        if (config.matrix === 'Matrix') return matrix ? matrix(arr) : (0, $g9z12.noMatrix)();
        return arr;
    }
    function _strRange(str, includeEnd) {
        var r = _parse(str);
        if (!r) throw new SyntaxError('String "' + str + '" is no valid range');
        var fn;
        if (config.number === 'BigNumber') {
            if (bignumber === undefined) (0, $g9z12.noBignumber)();
            fn = includeEnd ? _bigRangeInc : _bigRangeEx;
            return _out(fn(bignumber(r.start), bignumber(r.end), bignumber(r.step)));
        } else {
            fn = includeEnd ? _rangeInc : _rangeEx;
            return _out(fn(r.start, r.end, r.step));
        }
    }
    /**
   * Create a range with numbers. End is excluded
   * @param {number} start
   * @param {number} end
   * @param {number} step
   * @returns {Array} range
   * @private
   */ function _rangeEx(start, end, step) {
        var array = [];
        var x = start;
        if (step > 0) while(smaller(x, end)){
            array.push(x);
            x += step;
        }
        else if (step < 0) while(larger(x, end)){
            array.push(x);
            x += step;
        }
        return array;
    }
    /**
   * Create a range with numbers. End is included
   * @param {number} start
   * @param {number} end
   * @param {number} step
   * @returns {Array} range
   * @private
   */ function _rangeInc(start, end, step) {
        var array = [];
        var x = start;
        if (step > 0) while(smallerEq(x, end)){
            array.push(x);
            x += step;
        }
        else if (step < 0) while(largerEq(x, end)){
            array.push(x);
            x += step;
        }
        return array;
    }
    /**
   * Create a range with big numbers. End is excluded
   * @param {BigNumber} start
   * @param {BigNumber} end
   * @param {BigNumber} step
   * @returns {Array} range
   * @private
   */ function _bigRangeEx(start, end, step) {
        var zero = bignumber(0);
        var array = [];
        var x = start;
        if (step.gt(zero)) while(smaller(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        else if (step.lt(zero)) while(larger(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        return array;
    }
    /**
   * Create a range with big numbers. End is included
   * @param {BigNumber} start
   * @param {BigNumber} end
   * @param {BigNumber} step
   * @returns {Array} range
   * @private
   */ function _bigRangeInc(start, end, step) {
        var zero = bignumber(0);
        var array = [];
        var x = start;
        if (step.gt(zero)) while(smallerEq(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        else if (step.lt(zero)) while(largerEq(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        return array;
    }
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @param {string} str
   * @return {{start: number, end: number, step: number} | null} range Object containing properties start, end, step
   * @private
   */ function _parse(str) {
        var args = str.split(':'); // number
        var nums = args.map(function(arg) {
            // use Number and not parseFloat as Number returns NaN on invalid garbage in the string
            return Number(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return {
                    start: nums[0],
                    end: nums[1],
                    step: 1
                };
            case 3:
                return {
                    start: nums[0],
                    end: nums[2],
                    step: nums[1]
                };
            default:
                return null;
        }
    }
});

});

parcelRegister("niWmr", function(module, exports) {

$parcel$export(module.exports, "createRangeClass", () => $0460d73f6f08ee8d$export$e87cc8d3f29c5e1b);

var $gs7TF = parcelRequire("gs7TF");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");
var $0460d73f6f08ee8d$var$name = 'Range';
var $0460d73f6f08ee8d$var$dependencies = [];
var $0460d73f6f08ee8d$export$e87cc8d3f29c5e1b = /* #__PURE__ */ (0, $4eE2e.factory)($0460d73f6f08ee8d$var$name, $0460d73f6f08ee8d$var$dependencies, ()=>{
    /**
   * Create a range. A range has a start, step, and end, and contains functions
   * to iterate over the range.
   *
   * A range can be constructed as:
   *
   *     const range = new Range(start, end)
   *     const range = new Range(start, end, step)
   *
   * To get the result of the range:
   *     range.forEach(function (x) {
   *         console.log(x)
   *     })
   *     range.map(function (x) {
   *         return math.sin(x)
   *     })
   *     range.toArray()
   *
   * Example usage:
   *
   *     const c = new Range(2, 6)       // 2:1:5
   *     c.toArray()                     // [2, 3, 4, 5]
   *     const d = new Range(2, -3, -1)  // 2:-1:-2
   *     d.toArray()                     // [2, 1, 0, -1, -2]
   *
   * @class Range
   * @constructor Range
   * @param {number} start  included lower bound
   * @param {number} end    excluded upper bound
   * @param {number} [step] step size, default value is 1
   */ function Range(start, end, step) {
        if (!(this instanceof Range)) throw new SyntaxError('Constructor must be called with the new operator');
        var hasStart = start !== null && start !== undefined;
        var hasEnd = end !== null && end !== undefined;
        var hasStep = step !== null && step !== undefined;
        if (hasStart) {
            if ((0, $gs7TF.isBigNumber)(start)) start = start.toNumber();
            else if (typeof start !== 'number') throw new TypeError('Parameter start must be a number');
        }
        if (hasEnd) {
            if ((0, $gs7TF.isBigNumber)(end)) end = end.toNumber();
            else if (typeof end !== 'number') throw new TypeError('Parameter end must be a number');
        }
        if (hasStep) {
            if ((0, $gs7TF.isBigNumber)(step)) step = step.toNumber();
            else if (typeof step !== 'number') throw new TypeError('Parameter step must be a number');
        }
        this.start = hasStart ? parseFloat(start) : 0;
        this.end = hasEnd ? parseFloat(end) : 0;
        this.step = hasStep ? parseFloat(step) : 1;
    }
    /**
   * Attach type information
   */ Range.prototype.type = 'Range';
    Range.prototype.isRange = true;
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @memberof Range
   * @param {string} str
   * @return {Range | null} range
   */ Range.parse = function(str) {
        if (typeof str !== 'string') return null;
        var args = str.split(':');
        var nums = args.map(function(arg) {
            return parseFloat(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return new Range(nums[0], nums[1]);
            case 3:
                return new Range(nums[0], nums[2], nums[1]);
            default:
                return null;
        }
    };
    /**
   * Create a clone of the range
   * @return {Range} clone
   */ Range.prototype.clone = function() {
        return new Range(this.start, this.end, this.step);
    };
    /**
   * Retrieve the size of the range.
   * Returns an array containing one number, the number of elements in the range.
   * @memberof Range
   * @returns {number[]} size
   */ Range.prototype.size = function() {
        var len = 0;
        var start = this.start;
        var step = this.step;
        var end = this.end;
        var diff = end - start;
        if ((0, $6egKm.sign)(step) === (0, $6egKm.sign)(diff)) len = Math.ceil(diff / step);
        else if (diff === 0) len = 0;
        if (isNaN(len)) len = 0;
        return [
            len
        ];
    };
    /**
   * Calculate the minimum value in the range
   * @memberof Range
   * @return {number | undefined} min
   */ Range.prototype.min = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start;
            else // negative step
            return this.start + (size - 1) * this.step;
        } else return undefined;
    };
    /**
   * Calculate the maximum value in the range
   * @memberof Range
   * @return {number | undefined} max
   */ Range.prototype.max = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start + (size - 1) * this.step;
            else // negative step
            return this.start;
        } else return undefined;
    };
    /**
   * Execute a callback function for each value in the range.
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Range being traversed.
   */ Range.prototype.forEach = function(callback) {
        var x = this.start;
        var step = this.step;
        var end = this.end;
        var i = 0;
        if (step > 0) while(x < end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
        else if (step < 0) while(x > end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
    };
    /**
   * Execute a callback function for each value in the Range, and return the
   * results as an array
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @returns {Array} array
   */ Range.prototype.map = function(callback) {
        var array = [];
        this.forEach(function(value, index, obj) {
            array[index[0]] = callback(value, index, obj);
        });
        return array;
    };
    /**
   * Create an Array with a copy of the Ranges data
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.toArray = function() {
        var array = [];
        this.forEach(function(value, index) {
            array[index[0]] = value;
        });
        return array;
    };
    /**
   * Get the primitive value of the Range, a one dimensional array
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.valueOf = function() {
        // TODO: implement a caching mechanism for range.valueOf()
        return this.toArray();
    };
    /**
   * Get a string representation of the range, with optional formatting options.
   * Output is formatted as 'start:step:end', for example '2:6' or '0:0.2:11'
   * @memberof Range
   * @param {Object | number | function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Range.prototype.format = function(options) {
        var str = (0, $6egKm.format)(this.start, options);
        if (this.step !== 1) str += ':' + (0, $6egKm.format)(this.step, options);
        str += ':' + (0, $6egKm.format)(this.end, options);
        return str;
    };
    /**
   * Get a string representation of the range.
   * @memberof Range
   * @returns {string}
   */ Range.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the range
   * @memberof Range
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   */ Range.prototype.toJSON = function() {
        return {
            mathjs: 'Range',
            start: this.start,
            end: this.end,
            step: this.step
        };
    };
    /**
   * Instantiate a Range from a JSON object
   * @memberof Range
   * @param {Object} json A JSON object structured as:
   *                      `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   * @return {Range}
   */ Range.fromJSON = function(json) {
        return new Range(json.start, json.end, json.step);
    };
    return Range;
}, {
    isClass: true
});

});

parcelRegister("6mvgD", function(module, exports) {

$parcel$export(module.exports, "createRe", () => $013204576daf91a9$export$803e46d0de790dbf);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $013204576daf91a9$var$name = 're';
var $013204576daf91a9$var$dependencies = [
    'typed'
];
var $013204576daf91a9$export$803e46d0de790dbf = /* #__PURE__ */ (0, $4eE2e.factory)($013204576daf91a9$var$name, $013204576daf91a9$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Get the real part of a complex number.
   * For a complex number `a + bi`, the function returns `a`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.re(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number 0
   *    math.re(math.complex(2.4))     // returns number 2.4
   *
   * See also:
   *
   *    im, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The real part of x
   */ return typed($013204576daf91a9$var$name, {
        number: function number(x) {
            return x;
        },
        BigNumber: function BigNumber(x) {
            return x;
        },
        Fraction: function Fraction(x) {
            return x;
        },
        Complex: function Complex(x) {
            return x.re;
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("jM2Rh", function(module, exports) {

$parcel$export(module.exports, "createReplacer", () => $03b70b384e79ed4d$export$481a522c866104eb);

var $4eE2e = parcelRequire("4eE2e");
var $03b70b384e79ed4d$var$name = 'replacer';
var $03b70b384e79ed4d$var$dependencies = [];
var $03b70b384e79ed4d$export$481a522c866104eb = /* #__PURE__ */ (0, $4eE2e.factory)($03b70b384e79ed4d$var$name, $03b70b384e79ed4d$var$dependencies, ()=>{
    /**
   * Stringify data types into their JSON representation.
   * Most data types can be serialized using their `.toJSON` method,
   * but not all, for example the number `Infinity`. For these cases you have
   * to use the replacer. Example usage:
   *
   *     JSON.stringify([2, Infinity], math.replacer)
   *
   * @param {string} key
   * @param {*} value
   * @returns {*} Returns the replaced object
   */ return function replacer(key, value) {
        // the numeric values Infinitiy, -Infinity, and NaN cannot be serialized to JSON
        if (typeof value === 'number' && (!isFinite(value) || isNaN(value))) return {
            mathjs: 'number',
            value: String(value)
        };
        return value;
    };
});

});

parcelRegister("eOP6I", function(module, exports) {

$parcel$export(module.exports, "createReshape", () => $ac9d61071e53aeef$export$76c9752f34fb3440);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $ac9d61071e53aeef$var$name = 'reshape';
var $ac9d61071e53aeef$var$dependencies = [
    'typed',
    'isInteger',
    'matrix'
];
var $ac9d61071e53aeef$export$76c9752f34fb3440 = /* #__PURE__ */ (0, $4eE2e.factory)($ac9d61071e53aeef$var$name, $ac9d61071e53aeef$var$dependencies, (_ref)=>{
    var { typed: typed, isInteger: isInteger } = _ref;
    /**
   * Reshape a multi dimensional array to fit the specified dimensions
   *
   * Syntax:
   *
   *     math.reshape(x, sizes)
   *
   * Examples:
   *
   *     math.reshape([1, 2, 3, 4, 5, 6], [2, 3])
   *     // returns Array  [[1, 2, 3], [4, 5, 6]]
   *
   *     math.reshape([[1, 2], [3, 4]], [1, 4])
   *     // returns Array  [[1, 2, 3, 4]]
   *
   *     math.reshape([[1, 2], [3, 4]], [4])
   *     // returns Array [1, 2, 3, 4]
   *
   *     const x = math.matrix([1, 2, 3, 4, 5, 6, 7, 8])
   *     math.reshape(x, [2, 2, 2])
   *     // returns Matrix [[[1, 2], [3, 4]], [[5, 6], [7, 8]]]
   *
   *    math.reshape([1, 2, 3, 4], [-1, 2])
   *    // returns Matrix [[1, 2], [3, 4]]
   *
   * See also:
   *
   *     size, squeeze, resize
   *
   * @param {Array | Matrix | *} x  Matrix to be reshaped
   * @param {number[]} sizes        One dimensional array with integral sizes for
   *                                each dimension. One -1 is allowed as wildcard,
   *                                which calculates this dimension automatically.
   *
   * @return {* | Array | Matrix}   A reshaped clone of matrix `x`
   *
   * @throws {TypeError}            If `sizes` does not contain solely integers
   * @throws {DimensionError}       If the product of the new dimension sizes does
   *                                not equal that of the old ones
   */ return typed($ac9d61071e53aeef$var$name, {
        'Matrix, Array': function MatrixArray(x, sizes) {
            return x.reshape(sizes);
        },
        'Array, Array': function ArrayArray(x, sizes) {
            sizes.forEach(function(size) {
                if (!isInteger(size)) throw new TypeError('Invalid size for dimension: ' + size);
            });
            return (0, $10UPF.reshape)(x, sizes);
        }
    });
});

});

parcelRegister("aCm7m", function(module, exports) {

$parcel$export(module.exports, "createResize", () => $7bae9c16b6a8b9cc$export$58909557046ca413);

var $gs7TF = parcelRequire("gs7TF");

var $iAoVB = parcelRequire("iAoVB");

var $lYA0O = parcelRequire("lYA0O");

var $6egKm = parcelRequire("6egKm");

var $aEppI = parcelRequire("aEppI");

var $4mYv9 = parcelRequire("4mYv9");

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $7bae9c16b6a8b9cc$var$name = 'resize';
var $7bae9c16b6a8b9cc$var$dependencies = [
    'config',
    'matrix'
];
var $7bae9c16b6a8b9cc$export$58909557046ca413 = /* #__PURE__ */ (0, $4eE2e.factory)($7bae9c16b6a8b9cc$var$name, $7bae9c16b6a8b9cc$var$dependencies, (_ref)=>{
    var { config: config, matrix: matrix } = _ref;
    /**
   * Resize a matrix
   *
   * Syntax:
   *
   *     math.resize(x, size)
   *     math.resize(x, size, defaultValue)
   *
   * Examples:
   *
   *     math.resize([1, 2, 3, 4, 5], [3]) // returns Array  [1, 2, 3]
   *     math.resize([1, 2, 3], [5], 0)    // returns Array  [1, 2, 3, 0, 0]
   *     math.resize(2, [2, 3], 0)         // returns Matrix [[2, 0, 0], [0, 0, 0]]
   *     math.resize("hello", [8], "!")    // returns string 'hello!!!'
   *
   * See also:
   *
   *     size, squeeze, subset, reshape
   *
   * @param {Array | Matrix | *} x             Matrix to be resized
   * @param {Array | Matrix} size              One dimensional array with numbers
   * @param {number | string} [defaultValue=0] Zero by default, except in
   *                                           case of a string, in that case
   *                                           defaultValue = ' '
   * @return {* | Array | Matrix} A resized clone of matrix `x`
   */ // TODO: rework resize to a typed-function
    return function resize(x, size, defaultValue) {
        if (arguments.length !== 2 && arguments.length !== 3) throw new (0, $lYA0O.ArgumentsError)('resize', arguments.length, 2, 3);
        if ((0, $gs7TF.isMatrix)(size)) size = size.valueOf(); // get Array
        if ((0, $gs7TF.isBigNumber)(size[0])) // convert bignumbers to numbers
        size = size.map(function(value) {
            return !(0, $gs7TF.isBigNumber)(value) ? value : value.toNumber();
        });
         // check x is a Matrix
        if ((0, $gs7TF.isMatrix)(x)) // use optimized matrix implementation, return copy
        return x.resize(size, defaultValue, true);
        if (typeof x === 'string') // resize string
        return _resizeString(x, size, defaultValue);
         // check result should be a matrix
        var asMatrix = Array.isArray(x) ? false : config.matrix !== 'Array';
        if (size.length === 0) {
            // output a scalar
            while(Array.isArray(x))x = x[0];
            return (0, $4mYv9.clone)(x);
        } else {
            // output an array/matrix
            if (!Array.isArray(x)) x = [
                x
            ];
            x = (0, $4mYv9.clone)(x);
            var res = (0, $10UPF.resize)(x, size, defaultValue);
            return asMatrix ? matrix(res) : res;
        }
    };
    /**
   * Resize a string
   * @param {string} str
   * @param {number[]} size
   * @param {string} [defaultChar=' ']
   * @private
   */ function _resizeString(str, size, defaultChar) {
        if (defaultChar !== undefined) {
            if (typeof defaultChar !== 'string' || defaultChar.length !== 1) throw new TypeError('Single character expected as defaultValue');
        } else defaultChar = ' ';
        if (size.length !== 1) throw new (0, $iAoVB.DimensionError)(size.length, 1);
        var len = size[0];
        if (typeof len !== 'number' || !(0, $6egKm.isInteger)(len)) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $aEppI.format)(size) + ')');
        if (str.length > len) return str.substring(0, len);
        else if (str.length < len) {
            var res = str;
            for(var i = 0, ii = len - str.length; i < ii; i++)res += defaultChar;
            return res;
        } else return str;
    }
});

});
parcelRegister("lYA0O", function(module, exports) {

$parcel$export(module.exports, "ArgumentsError", () => $fffb22d8daf41f8b$export$f27c2c74ddc37d80);
/**
 * Create a syntax error with the message:
 *     'Wrong number of arguments in function <fn> (<count> provided, <min>-<max> expected)'
 * @param {string} fn     Function name
 * @param {number} count  Actual argument count
 * @param {number} min    Minimum required argument count
 * @param {number} [max]  Maximum required argument count
 * @extends Error
 */ function $fffb22d8daf41f8b$export$f27c2c74ddc37d80(fn, count, min, max) {
    if (!(this instanceof $fffb22d8daf41f8b$export$f27c2c74ddc37d80)) throw new SyntaxError('Constructor must be called with the new operator');
    this.fn = fn;
    this.count = count;
    this.min = min;
    this.max = max;
    this.message = 'Wrong number of arguments in function ' + fn + ' (' + count + ' provided, ' + min + (max !== undefined && max !== null ? '-' + max : '') + ' expected)';
    this.stack = new Error().stack;
}
$fffb22d8daf41f8b$export$f27c2c74ddc37d80.prototype = new Error();
$fffb22d8daf41f8b$export$f27c2c74ddc37d80.prototype.constructor = Error;
$fffb22d8daf41f8b$export$f27c2c74ddc37d80.prototype.name = 'ArgumentsError';
$fffb22d8daf41f8b$export$f27c2c74ddc37d80.prototype.isArgumentsError = true;

});


parcelRegister("c8phe", function(module, exports) {

$parcel$export(module.exports, "createResultSet", () => $8d59d6dbdf789e1f$export$dfb3187f1c4e3bbe);

var $4eE2e = parcelRequire("4eE2e");
var $8d59d6dbdf789e1f$var$name = 'ResultSet';
var $8d59d6dbdf789e1f$var$dependencies = [];
var $8d59d6dbdf789e1f$export$dfb3187f1c4e3bbe = /* #__PURE__ */ (0, $4eE2e.factory)($8d59d6dbdf789e1f$var$name, $8d59d6dbdf789e1f$var$dependencies, ()=>{
    /**
   * A ResultSet contains a list or results
   * @class ResultSet
   * @param {Array} entries
   * @constructor ResultSet
   */ function ResultSet(entries) {
        if (!(this instanceof ResultSet)) throw new SyntaxError('Constructor must be called with the new operator');
        this.entries = entries || [];
    }
    /**
   * Attach type information
   */ ResultSet.prototype.type = 'ResultSet';
    ResultSet.prototype.isResultSet = true;
    /**
   * Returns the array with results hold by this ResultSet
   * @memberof ResultSet
   * @returns {Array} entries
   */ ResultSet.prototype.valueOf = function() {
        return this.entries;
    };
    /**
   * Returns the stringified results of the ResultSet
   * @memberof ResultSet
   * @returns {string} string
   */ ResultSet.prototype.toString = function() {
        return '[' + this.entries.join(', ') + ']';
    };
    /**
   * Get a JSON representation of the ResultSet
   * @memberof ResultSet
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "ResultSet", "entries": [...]}`
   */ ResultSet.prototype.toJSON = function() {
        return {
            mathjs: 'ResultSet',
            entries: this.entries
        };
    };
    /**
   * Instantiate a ResultSet from a JSON object
   * @memberof ResultSet
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "ResultSet", "entries": [...]}`
   * @return {ResultSet}
   */ ResultSet.fromJSON = function(json) {
        return new ResultSet(json.entries);
    };
    return ResultSet;
}, {
    isClass: true
});

});

parcelRegister("8m8fU", function(module, exports) {

$parcel$export(module.exports, "createRightArithShift", () => $6156c83547d4147a$export$ef742376390cbf7);

var $2hy17 = parcelRequire("2hy17");

var $5IUkw = parcelRequire("5IUkw");

var $hXAgg = parcelRequire("hXAgg");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");

var $bCo9f = parcelRequire("bCo9f");

var $ecxvm = parcelRequire("ecxvm");

var $i6sSD = parcelRequire("i6sSD");

var $4eE2e = parcelRequire("4eE2e");

var $aFhba = parcelRequire("aFhba");
var $6156c83547d4147a$var$name = 'rightArithShift';
var $6156c83547d4147a$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'zeros',
    'DenseMatrix'
];
var $6156c83547d4147a$export$ef742376390cbf7 = /* #__PURE__ */ (0, $4eE2e.factory)($6156c83547d4147a$var$name, $6156c83547d4147a$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $bCo9f.createAlgorithm01)({
        typed: typed
    });
    var algorithm02 = (0, $5IUkw.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $i6sSD.createAlgorithm08)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $ecxvm.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise right arithmetic shift of a value x by y number of bits, `x >> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightArithShift(x, y)
   *
   * Examples:
   *
   *    math.rightArithShift(4, 2)               // returns number 1
   *
   *    math.rightArithShift([16, -32, 64], 4)   // returns Array [1, -2, 3]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber} y Amount of shifts
   * @return {number | BigNumber | Array | Matrix} `x` sign-filled shifted right `y` times
   */ return typed($6156c83547d4147a$var$name, {
        'number, number': (0, $aFhba.rightArithShiftNumber),
        'BigNumber, BigNumber': (0, $2hy17.rightArithShiftBigNumber),
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, this, false);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, number | BigNumber': function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, number | BigNumber': function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, this, false);
        },
        'number | BigNumber, SparseMatrix': function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, this, true);
        },
        'number | BigNumber, DenseMatrix': function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, this, true);
        },
        'Array, number | BigNumber': function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        'number | BigNumber, Array': function numberBigNumberArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
});

});

parcelRegister("gIM5x", function(module, exports) {

$parcel$export(module.exports, "createRightLogShift", () => $c2c60ebc1bcb73d8$export$2dd001e9fd66adcd);

var $5IUkw = parcelRequire("5IUkw");

var $hXAgg = parcelRequire("hXAgg");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");

var $bCo9f = parcelRequire("bCo9f");

var $ecxvm = parcelRequire("ecxvm");

var $i6sSD = parcelRequire("i6sSD");

var $4eE2e = parcelRequire("4eE2e");

var $aFhba = parcelRequire("aFhba");
var $c2c60ebc1bcb73d8$var$name = 'rightLogShift';
var $c2c60ebc1bcb73d8$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'zeros',
    'DenseMatrix'
];
var $c2c60ebc1bcb73d8$export$2dd001e9fd66adcd = /* #__PURE__ */ (0, $4eE2e.factory)($c2c60ebc1bcb73d8$var$name, $c2c60ebc1bcb73d8$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $bCo9f.createAlgorithm01)({
        typed: typed
    });
    var algorithm02 = (0, $5IUkw.createAlgorithm02)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $i6sSD.createAlgorithm08)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $ecxvm.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Bitwise right logical shift of value x by y number of bits, `x >>> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightLogShift(x, y)
   *
   * Examples:
   *
   *    math.rightLogShift(4, 2)               // returns number 1
   *
   *    math.rightLogShift([16, -32, 64], 4)   // returns Array [1, 2, 3]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, leftShift, rightLogShift
   *
   * @param  {number | Array | Matrix} x Value to be shifted
   * @param  {number} y Amount of shifts
   * @return {number | Array | Matrix} `x` zero-filled shifted right `y` times
   */ return typed($c2c60ebc1bcb73d8$var$name, {
        'number, number': (0, $aFhba.rightLogShiftNumber),
        // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, this, false);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, number | BigNumber': function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, number | BigNumber': function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, this, false);
        },
        'number | BigNumber, SparseMatrix': function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, this, true);
        },
        'number | BigNumber, DenseMatrix': function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, this, true);
        },
        'Array, number | BigNumber': function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        'number | BigNumber, Array': function numberBigNumberArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
});

});

parcelRegister("5aeqE", function(module, exports) {

$parcel$export(module.exports, "createRotate", () => $3c29142e0ea10d6a$export$484058214789ee04);

var $4eE2e = parcelRequire("4eE2e");

var $10UPF = parcelRequire("10UPF");
var $3c29142e0ea10d6a$var$name = 'rotate';
var $3c29142e0ea10d6a$var$dependencies = [
    'typed',
    'multiply',
    'rotationMatrix'
];
var $3c29142e0ea10d6a$export$484058214789ee04 = /* #__PURE__ */ (0, $4eE2e.factory)($3c29142e0ea10d6a$var$name, $3c29142e0ea10d6a$var$dependencies, (_ref)=>{
    var { typed: typed, multiply: multiply, rotationMatrix: rotationMatrix } = _ref;
    /**
     * Rotate a vector of size 1x2 counter-clockwise by a given angle
     * Rotate a vector of size 1x3 counter-clockwise by a given angle around the given axis
     *
     * Syntax:
     *
     *    math.rotate(w, theta)
     *    math.rotate(w, theta, v)
     *
     * Examples:
     *
     *    math.rotate([11, 12], math.pi / 2)                           // returns matrix([-12, 11])
     *    math.rotate(matrix([11, 12]), math.pi / 2)                   // returns matrix([-12, 11])
     *
     *    math.rotate([1, 0, 0], unit('90deg'), [0, 0, 1])             // returns matrix([0, 1, 0])
     *    math.rotate(matrix([1, 0, 0]), unit('90deg'), [0, 0, 1])     // returns matrix([0, 1, 0])
     *
     *    math.rotate([1, 0], math.complex(1 + i))                     // returns matrix([cos(1 + i) - sin(1 + i), sin(1 + i) + cos(1 + i)])
     *
     * See also:
     *
     *    matrix, rotationMatrix
     *
     * @param {Array | Matrix} w                             Vector to rotate
     * @param {number | BigNumber | Complex | Unit} theta    Rotation angle
     * @param {Array | Matrix} [v]                           Rotation axis
     * @return {Array | Matrix}                              Multiplication of the rotation matrix and w
     */ return typed($3c29142e0ea10d6a$var$name, {
        'Array , number | BigNumber | Complex | Unit': function ArrayNumberBigNumberComplexUnit(w, theta) {
            _validateSize(w, 2);
            var matrixRes = multiply(rotationMatrix(theta), w);
            return matrixRes.toArray();
        },
        'Matrix , number | BigNumber | Complex | Unit': function MatrixNumberBigNumberComplexUnit(w, theta) {
            _validateSize(w, 2);
            return multiply(rotationMatrix(theta), w);
        },
        'Array, number | BigNumber | Complex | Unit, Array | Matrix': function ArrayNumberBigNumberComplexUnitArrayMatrix(w, theta, v) {
            _validateSize(w, 3);
            var matrixRes = multiply(rotationMatrix(theta, v), w);
            return matrixRes;
        },
        'Matrix, number | BigNumber | Complex | Unit, Array | Matrix': function MatrixNumberBigNumberComplexUnitArrayMatrix(w, theta, v) {
            _validateSize(w, 3);
            return multiply(rotationMatrix(theta, v), w);
        }
    });
    function _validateSize(v, expectedSize) {
        var actualSize = Array.isArray(v) ? (0, $10UPF.arraySize)(v) : v.size();
        if (actualSize.length > 2) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
        if (actualSize.length === 2 && actualSize[1] !== 1) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
        if (actualSize[0] !== expectedSize) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
    }
});

});

parcelRegister("YeBIy", function(module, exports) {

$parcel$export(module.exports, "createRotationMatrix", () => $0b50ef6d336b1bc2$export$7c79514a80dc15a2);

var $gs7TF = parcelRequire("gs7TF");

var $4eE2e = parcelRequire("4eE2e");
var $0b50ef6d336b1bc2$var$name = 'rotationMatrix';
var $0b50ef6d336b1bc2$var$dependencies = [
    'typed',
    'config',
    'multiplyScalar',
    'addScalar',
    'unaryMinus',
    'norm',
    'matrix',
    'BigNumber',
    'DenseMatrix',
    'SparseMatrix',
    'cos',
    'sin'
];
var $0b50ef6d336b1bc2$export$7c79514a80dc15a2 = /* #__PURE__ */ (0, $4eE2e.factory)($0b50ef6d336b1bc2$var$name, $0b50ef6d336b1bc2$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, addScalar: addScalar, unaryMinus: unaryMinus, norm: norm, BigNumber: BigNumber, matrix: matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix, cos: cos, sin: sin } = _ref;
    /**
   * Create a 2-dimensional counter-clockwise rotation matrix (2x2) for a given angle (expressed in radians).
   * Create a 2-dimensional counter-clockwise rotation matrix (3x3) by a given angle (expressed in radians) around a given axis (1x3).
   *
   * Syntax:
   *
   *    math.rotationMatrix(theta)
   *    math.rotationMatrix(theta, format)
   *    math.rotationMatrix(theta, [v])
   *    math.rotationMatrix(theta, [v], format)
   *
   * Examples:
   *
   *    math.rotationMatrix(math.pi / 2)                      // returns [[0, -1], [1, 0]]
   *    math.rotationMatrix(math.bignumber(1))                // returns [[bignumber(cos(1)), bignumber(-sin(1))], [bignumber(sin(1)), bignumber(cos(1))]]
   *    math.rotationMatrix(math.complex(1 + i))              // returns [[cos(1 + i), -sin(1 + i)], [sin(1 + i), cos(1 + i)]]
   *    math.rotationMatrix(math.unit('1rad'))                // returns [[cos(1), -sin(1)], [sin(1), cos(1)]]
   *
   *    math.rotationMatrix(math.pi / 2, [0, 1, 0])           // returns [[0, 0, 1], [0, 1, 0], [-1, 0, 0]]
   *    math.rotationMatrix(math.pi / 2, matrix([0, 1, 0]))   // returns matrix([[0, 0, 1], [0, 1, 0], [-1, 0, 0]])
   *
   *
   * See also:
   *
   *    matrix, cos, sin
   *
   *
   * @param {number | BigNumber | Complex | Unit} theta    Rotation angle
   * @param {Array | Matrix} [v]                           Rotation axis
   * @param {string} [format]                              Result Matrix storage format
   * @return {Array | Matrix}                              Rotation matrix
   */ return typed($0b50ef6d336b1bc2$var$name, {
        '': function _() {
            return config.matrix === 'Matrix' ? matrix([]) : [];
        },
        string: function string(format) {
            return matrix(format);
        },
        'number | BigNumber | Complex | Unit': function numberBigNumberComplexUnit(theta) {
            return _rotationMatrix2x2(theta, config.matrix === 'Matrix' ? 'dense' : undefined);
        },
        'number | BigNumber | Complex | Unit, string': function numberBigNumberComplexUnitString(theta, format) {
            return _rotationMatrix2x2(theta, format);
        },
        'number | BigNumber | Complex | Unit, Array': function numberBigNumberComplexUnitArray(theta, v) {
            var matrixV = matrix(v);
            _validateVector(matrixV);
            return _rotationMatrix3x3(theta, matrixV, undefined);
        },
        'number | BigNumber | Complex | Unit, Matrix': function numberBigNumberComplexUnitMatrix(theta, v) {
            _validateVector(v);
            var storageType = v.storage() || (config.matrix === 'Matrix' ? 'dense' : undefined);
            return _rotationMatrix3x3(theta, v, storageType);
        },
        'number | BigNumber | Complex | Unit, Array, string': function numberBigNumberComplexUnitArrayString(theta, v, format) {
            var matrixV = matrix(v);
            _validateVector(matrixV);
            return _rotationMatrix3x3(theta, matrixV, format);
        },
        'number | BigNumber | Complex | Unit, Matrix, string': function numberBigNumberComplexUnitMatrixString(theta, v, format) {
            _validateVector(v);
            return _rotationMatrix3x3(theta, v, format);
        }
    });
    /**
   * Returns 2x2 matrix of 2D rotation of angle theta
   *
   * @param {number | BigNumber | Complex | Unit} theta  The rotation angle
   * @param {string} format                              The result Matrix storage format
   * @returns {Matrix}
   * @private
   */ function _rotationMatrix2x2(theta, format) {
        var Big = (0, $gs7TF.isBigNumber)(theta);
        var minusOne = Big ? new BigNumber(-1) : -1;
        var cosTheta = cos(theta);
        var sinTheta = sin(theta);
        var data = [
            [
                cosTheta,
                multiplyScalar(minusOne, sinTheta)
            ],
            [
                sinTheta,
                cosTheta
            ]
        ];
        return _convertToFormat(data, format);
    }
    function _validateVector(v) {
        var size = v.size();
        if (size.length < 1 || size[0] !== 3) throw new RangeError('Vector must be of dimensions 1x3');
    }
    function _mul(array) {
        return array.reduce((p, curr)=>multiplyScalar(p, curr));
    }
    function _convertToFormat(data, format) {
        if (format) {
            if (format === 'sparse') return new SparseMatrix(data);
            if (format === 'dense') return new DenseMatrix(data);
            throw new TypeError("Unknown matrix type \"".concat(format, "\""));
        }
        return data;
    }
    /**
   * Returns a 3x3 matrix of rotation of angle theta around vector v
   *
   * @param {number | BigNumber | Complex | Unit} theta The rotation angle
   * @param {Matrix} v                                  The rotation axis vector
   * @param {string} format                             The storage format of the resulting matrix
   * @returns {Matrix}
   * @private
   */ function _rotationMatrix3x3(theta, v, format) {
        var normV = norm(v);
        if (normV === 0) throw new RangeError('Rotation around zero vector');
        var Big = (0, $gs7TF.isBigNumber)(theta) ? BigNumber : null;
        var one = Big ? new Big(1) : 1;
        var minusOne = Big ? new Big(-1) : -1;
        var vx = Big ? new Big(v.get([
            0
        ]) / normV) : v.get([
            0
        ]) / normV;
        var vy = Big ? new Big(v.get([
            1
        ]) / normV) : v.get([
            1
        ]) / normV;
        var vz = Big ? new Big(v.get([
            2
        ]) / normV) : v.get([
            2
        ]) / normV;
        var c = cos(theta);
        var oneMinusC = addScalar(one, unaryMinus(c));
        var s = sin(theta);
        var r11 = addScalar(c, _mul([
            vx,
            vx,
            oneMinusC
        ]));
        var r12 = addScalar(_mul([
            vx,
            vy,
            oneMinusC
        ]), _mul([
            minusOne,
            vz,
            s
        ]));
        var r13 = addScalar(_mul([
            vx,
            vz,
            oneMinusC
        ]), _mul([
            vy,
            s
        ]));
        var r21 = addScalar(_mul([
            vx,
            vy,
            oneMinusC
        ]), _mul([
            vz,
            s
        ]));
        var r22 = addScalar(c, _mul([
            vy,
            vy,
            oneMinusC
        ]));
        var r23 = addScalar(_mul([
            vy,
            vz,
            oneMinusC
        ]), _mul([
            minusOne,
            vx,
            s
        ]));
        var r31 = addScalar(_mul([
            vx,
            vz,
            oneMinusC
        ]), _mul([
            minusOne,
            vy,
            s
        ]));
        var r32 = addScalar(_mul([
            vy,
            vz,
            oneMinusC
        ]), _mul([
            vx,
            s
        ]));
        var r33 = addScalar(c, _mul([
            vz,
            vz,
            oneMinusC
        ]));
        var data = [
            [
                r11,
                r12,
                r13
            ],
            [
                r21,
                r22,
                r23
            ],
            [
                r31,
                r32,
                r33
            ]
        ];
        return _convertToFormat(data, format);
    }
});

});

parcelRegister("jxFbm", function(module, exports) {

$parcel$export(module.exports, "createRound", () => $e3a10b556013dcf8$export$c41ddfead54b1fbc);

var $OB7fF = parcelRequire("OB7fF");

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $6egKm = parcelRequire("6egKm");

var $hXAgg = parcelRequire("hXAgg");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $laEuG = parcelRequire("laEuG");

var $eRNhQ = parcelRequire("eRNhQ");
function $e3a10b556013dcf8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e3a10b556013dcf8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e3a10b556013dcf8$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($OB7fF)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e3a10b556013dcf8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $e3a10b556013dcf8$var$NO_INT = 'Number of decimals in function round must be an integer';
var $e3a10b556013dcf8$var$name = 'round';
var $e3a10b556013dcf8$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'zeros',
    'BigNumber',
    'DenseMatrix'
];
var $e3a10b556013dcf8$export$c41ddfead54b1fbc = /* #__PURE__ */ (0, $4eE2e.factory)($e3a10b556013dcf8$var$name, $e3a10b556013dcf8$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, BigNumber: BigNumber, DenseMatrix: DenseMatrix } = _ref;
    var algorithm11 = (0, $hXAgg.createAlgorithm11)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Round a value towards the nearest integer.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.round(x)
   *    math.round(x, n)
   *
   * Examples:
   *
   *    math.round(3.22)             // returns number 3
   *    math.round(3.82)             // returns number 4
   *    math.round(-4.2)             // returns number -4
   *    math.round(-4.7)             // returns number -5
   *    math.round(3.22, 1)          // returns number 3.2
   *    math.round(3.88, 1)          // returns number 3.9
   *    math.round(-4.21, 1)         // returns number -4.2
   *    math.round(-4.71, 1)         // returns number -4.7
   *    math.round(math.pi, 3)       // returns number 3.142
   *    math.round(123.45678, 2)     // returns number 123.46
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.round(c)                // returns Complex 3 - 3i
   *
   *    math.round([3.2, 3.8, -4.7]) // returns Array [3, 4, -5]
   *
   * See also:
   *
   *    ceil, fix, floor
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ return typed($e3a10b556013dcf8$var$name, $e3a10b556013dcf8$var$_objectSpread($e3a10b556013dcf8$var$_objectSpread({}, $e3a10b556013dcf8$var$roundNumberSignatures), {}, {
        Complex: function Complex(x) {
            return x.round();
        },
        'Complex, number': function ComplexNumber(x, n) {
            if (n % 1) throw new TypeError($e3a10b556013dcf8$var$NO_INT);
            return x.round(n);
        },
        'Complex, BigNumber': function ComplexBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($e3a10b556013dcf8$var$NO_INT);
            var _n = n.toNumber();
            return x.round(_n);
        },
        'number, BigNumber': function numberBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($e3a10b556013dcf8$var$NO_INT);
            return new BigNumber(x).toDecimalPlaces(n.toNumber());
        },
        BigNumber: function BigNumber(x) {
            return x.toDecimalPlaces(0);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($e3a10b556013dcf8$var$NO_INT);
            return x.toDecimalPlaces(n.toNumber());
        },
        Fraction: function Fraction(x) {
            return x.round();
        },
        'Fraction, number': function FractionNumber(x, n) {
            if (n % 1) throw new TypeError($e3a10b556013dcf8$var$NO_INT);
            return x.round(n);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since round(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        },
        'SparseMatrix, number | BigNumber': function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        'DenseMatrix, number | BigNumber': function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        'number | Complex | BigNumber, SparseMatrix': function numberComplexBigNumberSparseMatrix(x, y) {
            // check scalar is zero
            if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
            return zeros(y.size(), y.storage());
            return algorithm12(y, x, this, true);
        },
        'number | Complex | BigNumber, DenseMatrix': function numberComplexBigNumberDenseMatrix(x, y) {
            // check scalar is zero
            if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
            return zeros(y.size(), y.storage());
            return algorithm14(y, x, this, true);
        },
        'Array, number | BigNumber': function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'number | Complex | BigNumber, Array': function numberComplexBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    }));
});
var $e3a10b556013dcf8$var$roundNumberSignatures = {
    number: (0, $eRNhQ.roundNumber),
    'number, number': function numberNumber(x, n) {
        if (!(0, $6egKm.isInteger)(n)) throw new TypeError($e3a10b556013dcf8$var$NO_INT);
        if (n < 0 || n > 15) throw new Error('Number of decimals in function round must be in the range of 0-15');
        return (0, $eRNhQ.roundNumber)(x, n);
    }
};
var $e3a10b556013dcf8$export$ee2894e1239ff693 = /* #__PURE__ */ (0, $4eE2e.factory)($e3a10b556013dcf8$var$name, [
    'typed'
], (_ref2)=>{
    var { typed: typed } = _ref2;
    return typed($e3a10b556013dcf8$var$name, $e3a10b556013dcf8$var$roundNumberSignatures);
});

});
parcelRegister("OB7fF", function(module, exports) {

var $hV2mq = parcelRequire("hV2mq");
function $0981761551a5c1d4$var$_defineProperty(e, r, t) {
    return (r = $hV2mq(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $0981761551a5c1d4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hV2mq", function(module, exports) {

var $68Cwz = parcelRequire("68Cwz");
var $d0b9975793564d1a$var$_typeof = $68Cwz.default;

var $jubVf = parcelRequire("jubVf");
function $d0b9975793564d1a$var$toPropertyKey(t) {
    var i = $jubVf(t, "string");
    return "symbol" == $d0b9975793564d1a$var$_typeof(i) ? i : i + "";
}
module.exports = $d0b9975793564d1a$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("68Cwz", function(module, exports) {
function $47815f8f84c0b138$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $47815f8f84c0b138$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $47815f8f84c0b138$var$_typeof(o);
}
module.exports = $47815f8f84c0b138$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jubVf", function(module, exports) {

var $68Cwz = parcelRequire("68Cwz");
var $e2fa113662ee6733$var$_typeof = $68Cwz.default;
function $e2fa113662ee6733$var$toPrimitive(t, r) {
    if ("object" != $e2fa113662ee6733$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e2fa113662ee6733$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $e2fa113662ee6733$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("ccYsB", function(module, exports) {

$parcel$export(module.exports, "createRow", () => $8e35812eaab29088$export$3442c5d213434705);

var $4eE2e = parcelRequire("4eE2e");

var $4mYv9 = parcelRequire("4mYv9");

var $10UPF = parcelRequire("10UPF");
var $8e35812eaab29088$var$name = 'row';
var $8e35812eaab29088$var$dependencies = [
    'typed',
    'Index',
    'matrix',
    'range'
];
var $8e35812eaab29088$export$3442c5d213434705 = /* #__PURE__ */ (0, $4eE2e.factory)($8e35812eaab29088$var$name, $8e35812eaab29088$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    /**
   * Return a row from a Matrix.
   *
   * Syntax:
   *
   *     math.row(value, index)
   *
   * Example:
   *
   *     // get a row
   *     const d = [[1, 2], [3, 4]]
   *     math.row(d, 1) // returns [[3, 4]]
   *
   * See also:
   *
   *     column
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} row              The index of the row
   * @return {Array | Matrix}         The retrieved row
   */ return typed($8e35812eaab29088$var$name, {
        'Matrix, number': _row,
        'Array, number': function ArrayNumber(value, row) {
            return _row(matrix((0, $4mYv9.clone)(value)), row).valueOf();
        }
    });
    /**
   * Retrieve a row of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} row     The index of the row
   * @return {Matrix}        The retrieved row
   */ function _row(value, row) {
        // check dimensions
        if (value.size().length !== 2) throw new Error('Only two dimensional matrix is supported');
        (0, $10UPF.validateIndex)(row, value.size()[0]);
        var columnRange = range(0, value.size()[1]);
        var index = new Index(row, columnRange);
        return value.subset(index);
    }
});

});

parcelRegister("gt0lu", function(module, exports) {

$parcel$export(module.exports, "createSec", () => $bfcf9f662c88e27d$export$5c169ecd5c25a09e);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $bfcf9f662c88e27d$var$name = 'sec';
var $bfcf9f662c88e27d$var$dependencies = [
    'typed',
    'BigNumber'
];
var $bfcf9f662c88e27d$export$5c169ecd5c25a09e = /* #__PURE__ */ (0, $4eE2e.factory)($bfcf9f662c88e27d$var$name, $bfcf9f662c88e27d$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the secant of a value, defined as `sec(x) = 1/cos(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sec(x)
   *
   * Examples:
   *
   *    math.sec(2)      // returns number -2.4029979617223822
   *    1 / math.cos(2)  // returns number -2.4029979617223822
   *
   * See also:
   *
   *    cos, csc, cot
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Secant of x
   */ return typed($bfcf9f662c88e27d$var$name, {
        number: (0, $fkvqw.secNumber),
        Complex: function Complex(x) {
            return x.sec();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.cos());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function sec is no angle');
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("3Bb0y", function(module, exports) {

$parcel$export(module.exports, "createSech", () => $29ed5dc40aaf93ea$export$97a0cf2b7d31f38b);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $29ed5dc40aaf93ea$var$name = 'sech';
var $29ed5dc40aaf93ea$var$dependencies = [
    'typed',
    'BigNumber'
];
var $29ed5dc40aaf93ea$export$97a0cf2b7d31f38b = /* #__PURE__ */ (0, $4eE2e.factory)($29ed5dc40aaf93ea$var$name, $29ed5dc40aaf93ea$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic secant of a value,
   * defined as `sech(x) = 1 / cosh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sech(x)
   *
   * Examples:
   *
   *    // sech(x) = 1/ cosh(x)
   *    math.sech(0.5)       // returns 0.886818883970074
   *    1 / math.cosh(0.5)   // returns 0.886818883970074
   *
   * See also:
   *
   *    cosh, csch, coth
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic secant of x
   */ return typed($29ed5dc40aaf93ea$var$name, {
        number: (0, $fkvqw.sechNumber),
        Complex: function Complex(x) {
            return x.sech();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.cosh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function sech is no angle');
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("3sovY", function(module, exports) {

$parcel$export(module.exports, "createSetCartesian", () => $284700c0e81ef158$export$9fa12a9d198718c8);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $284700c0e81ef158$var$name = 'setCartesian';
var $284700c0e81ef158$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index',
    'DenseMatrix'
];
var $284700c0e81ef158$export$9fa12a9d198718c8 = /* #__PURE__ */ (0, $4eE2e.factory)($284700c0e81ef158$var$name, $284700c0e81ef158$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the cartesian product of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setCartesian(set1, set2)
   *
   * Examples:
   *
   *    math.setCartesian([1, 2], [3, 4])        // returns [[1, 3], [1, 4], [2, 3], [2, 4]]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference, setPowerset
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The cartesian product of two (multi)sets
   */ return typed($284700c0e81ef158$var$name, {
        'Array | Matrix, Array | Matrix': function ArrayMatrixArrayMatrix(a1, a2) {
            var result = [];
            if (subset(size(a1), new Index(0)) !== 0 && subset(size(a2), new Index(0)) !== 0) {
                // if any of them is empty, return empty
                var b1 = (0, $10UPF.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural);
                var b2 = (0, $10UPF.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural);
                result = [];
                for(var i = 0; i < b1.length; i++)for(var j = 0; j < b2.length; j++)result.push([
                    b1[i],
                    b2[j]
                ]);
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return result;
             // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});

});

parcelRegister("3S0eX", function(module, exports) {

$parcel$export(module.exports, "createSetDifference", () => $2d1699f082f296b1$export$d81c0f9dab86d854);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $2d1699f082f296b1$var$name = 'setDifference';
var $2d1699f082f296b1$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index',
    'DenseMatrix'
];
var $2d1699f082f296b1$export$d81c0f9dab86d854 = /* #__PURE__ */ (0, $4eE2e.factory)($2d1699f082f296b1$var$name, $2d1699f082f296b1$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the difference of two (multi)sets: every element of set1, that is not the element of set2.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2]
   *    math.setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2]
   *
   * See also:
   *
   *    setUnion, setIntersect, setSymDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The difference of two (multi)sets
   */ return typed($2d1699f082f296b1$var$name, {
        'Array | Matrix, Array | Matrix': function ArrayMatrixArrayMatrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0) // empty-anything=empty
            result = [];
            else if (subset(size(a2), new Index(0)) === 0) // anything-empty=anything
            return (0, $10UPF.flatten)(a1.toArray());
            else {
                var b1 = (0, $10UPF.identify)((0, $10UPF.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $10UPF.identify)((0, $10UPF.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                var inb2;
                for(var i = 0; i < b1.length; i++){
                    inb2 = false;
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        inb2 = true;
                        break;
                    }
                    if (!inb2) result.push(b1[i]);
                }
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $10UPF.generalize)(result);
             // return a matrix otherwise
            return new DenseMatrix((0, $10UPF.generalize)(result));
        }
    });
});

});

parcelRegister("9dgfi", function(module, exports) {

$parcel$export(module.exports, "createSetDistinct", () => $6b51ee097970732d$export$c149680b9d8f2963);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $6b51ee097970732d$var$name = 'setDistinct';
var $6b51ee097970732d$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index',
    'DenseMatrix'
];
var $6b51ee097970732d$export$c149680b9d8f2963 = /* #__PURE__ */ (0, $4eE2e.factory)($6b51ee097970732d$var$name, $6b51ee097970732d$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Collect the distinct elements of a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setDistinct(set)
   *
   * Examples:
   *
   *    math.setDistinct([1, 1, 1, 2, 2, 3])        // returns [1, 2, 3]
   *
   * See also:
   *
   *    setMultiplicity
   *
   * @param {Array | Matrix}    a  A multiset
   * @return {Array | Matrix}    A set containing the distinc elements of the multiset
   */ return typed($6b51ee097970732d$var$name, {
        'Array | Matrix': function ArrayMatrix(a) {
            var result;
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            result = [];
            else {
                var b = (0, $10UPF.flatten)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                result = [];
                result.push(b[0]);
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) result.push(b[i]);
            } // return an array, if the input was an array
            if (Array.isArray(a)) return result;
             // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});

});

parcelRegister("7x7Wx", function(module, exports) {

$parcel$export(module.exports, "createSetIntersect", () => $57c1c6d3fe9665d3$export$b20ee2bdfbf6defd);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $57c1c6d3fe9665d3$var$name = 'setIntersect';
var $57c1c6d3fe9665d3$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index',
    'DenseMatrix'
];
var $57c1c6d3fe9665d3$export$b20ee2bdfbf6defd = /* #__PURE__ */ (0, $4eE2e.factory)($57c1c6d3fe9665d3$var$name, $57c1c6d3fe9665d3$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the intersection of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIntersect(set1, set2)
   *
   * Examples:
   *
   *    math.setIntersect([1, 2, 3, 4], [3, 4, 5, 6])            // returns [3, 4]
   *    math.setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [3, 4]
   *
   * See also:
   *
   *    setUnion, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The intersection of two (multi)sets
   */ return typed($57c1c6d3fe9665d3$var$name, {
        'Array | Matrix, Array | Matrix': function ArrayMatrixArrayMatrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0 || subset(size(a2), new Index(0)) === 0) // of any of them is empty, return empty
            result = [];
            else {
                var b1 = (0, $10UPF.identify)((0, $10UPF.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $10UPF.identify)((0, $10UPF.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                for(var i = 0; i < b1.length; i++){
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        result.push(b1[i]);
                        break;
                    }
                }
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $10UPF.generalize)(result);
             // return a matrix otherwise
            return new DenseMatrix((0, $10UPF.generalize)(result));
        }
    });
});

});

parcelRegister("fCaiE", function(module, exports) {

$parcel$export(module.exports, "createSetIsSubset", () => $b5e264ef1e5693e4$export$40ad73493b9f8712);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $b5e264ef1e5693e4$var$name = 'setIsSubset';
var $b5e264ef1e5693e4$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index'
];
var $b5e264ef1e5693e4$export$40ad73493b9f8712 = /* #__PURE__ */ (0, $4eE2e.factory)($b5e264ef1e5693e4$var$name, $b5e264ef1e5693e4$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Check whether a (multi)set is a subset of another (multi)set. (Every element of set1 is the element of set2.)
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIsSubset(set1, set2)
   *
   * Examples:
   *
   *    math.setIsSubset([1, 2], [3, 4, 5, 6])        // returns false
   *    math.setIsSubset([3, 4], [3, 4, 5, 6])        // returns true
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {boolean}            true | false
   */ return typed($b5e264ef1e5693e4$var$name, {
        'Array | Matrix, Array | Matrix': function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // empty is a subset of anything
            return true;
            else if (subset(size(a2), new Index(0)) === 0) // anything is not a subset of empty
            return false;
            var b1 = (0, $10UPF.identify)((0, $10UPF.flatten)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
            var b2 = (0, $10UPF.identify)((0, $10UPF.flatten)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
            var inb2;
            for(var i = 0; i < b1.length; i++){
                inb2 = false;
                for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                    // the identifier is always a decimal int
                    inb2 = true;
                    break;
                }
                if (inb2 === false) return false;
            }
            return true;
        }
    });
});

});

parcelRegister("YpSzg", function(module, exports) {

$parcel$export(module.exports, "createSetMultiplicity", () => $0b59adc45088f67f$export$d1f961d649e525df);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $0b59adc45088f67f$var$name = 'setMultiplicity';
var $0b59adc45088f67f$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index'
];
var $0b59adc45088f67f$export$d1f961d649e525df = /* #__PURE__ */ (0, $4eE2e.factory)($0b59adc45088f67f$var$name, $0b59adc45088f67f$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Count the multiplicity of an element in a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setMultiplicity(element, set)
   *
   * Examples:
   *
   *    math.setMultiplicity(1, [1, 2, 2, 4])    // returns 1
   *    math.setMultiplicity(2, [1, 2, 2, 4])    // returns 2
   *
   * See also:
   *
   *    setDistinct, setSize
   *
   * @param {number | BigNumber | Fraction | Complex} e  An element in the multiset
   * @param {Array | Matrix}     a  A multiset
   * @return {number}            The number of how many times the multiset contains the element
   */ return typed($0b59adc45088f67f$var$name, {
        'number | BigNumber | Fraction | Complex, Array | Matrix': function numberBigNumberFractionComplexArrayMatrix(e, a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return 0
            return 0;
            var b = (0, $10UPF.flatten)(Array.isArray(a) ? a : a.toArray());
            var count = 0;
            for(var i = 0; i < b.length; i++)if (compareNatural(b[i], e) === 0) count++;
            return count;
        }
    });
});

});

parcelRegister("77hWe", function(module, exports) {

$parcel$export(module.exports, "createSetPowerset", () => $52e71a029a19dc25$export$55c6b5cb0b0637db);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $52e71a029a19dc25$var$name = 'setPowerset';
var $52e71a029a19dc25$var$dependencies = [
    'typed',
    'size',
    'subset',
    'compareNatural',
    'Index'
];
var $52e71a029a19dc25$export$55c6b5cb0b0637db = /* #__PURE__ */ (0, $4eE2e.factory)($52e71a029a19dc25$var$name, $52e71a029a19dc25$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Create the powerset of a (multi)set. (The powerset contains very possible subsets of a (multi)set.)
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setPowerset(set)
   *
   * Examples:
   *
   *    math.setPowerset([1, 2, 3])        // returns [[], [1], [2], [3], [1, 2], [1, 3], [2, 3], [1, 2, 3]]
   *
   * See also:
   *
   *    setCartesian
   *
   * @param {Array | Matrix}    a  A (multi)set
   * @return {Array}    The powerset of the (multi)set
   */ return typed($52e71a029a19dc25$var$name, {
        'Array | Matrix': function ArrayMatrix(a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            return [];
            var b = (0, $10UPF.flatten)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
            var result = [];
            var number = 0;
            while(number.toString(2).length <= b.length){
                result.push(_subset(b, number.toString(2).split('').reverse()));
                number++;
            } // can not return a matrix, because of the different size of the subarrays
            return _sort(result);
        }
    }); // create subset
    function _subset(array, bitarray) {
        var result = [];
        for(var i = 0; i < bitarray.length; i++)if (bitarray[i] === '1') result.push(array[i]);
        return result;
    } // sort subsests by length
    function _sort(array) {
        var temp = [];
        for(var i = array.length - 1; i > 0; i--){
            for(var j = 0; j < i; j++)if (array[j].length > array[j + 1].length) {
                temp = array[j];
                array[j] = array[j + 1];
                array[j + 1] = temp;
            }
        }
        return array;
    }
});

});

parcelRegister("2YRdb", function(module, exports) {

$parcel$export(module.exports, "createSetSize", () => $22ba7617a6e5cb6d$export$55134310fc79366a);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $22ba7617a6e5cb6d$var$name = 'setSize';
var $22ba7617a6e5cb6d$var$dependencies = [
    'typed',
    'compareNatural'
];
var $22ba7617a6e5cb6d$export$55134310fc79366a = /* #__PURE__ */ (0, $4eE2e.factory)($22ba7617a6e5cb6d$var$name, $22ba7617a6e5cb6d$var$dependencies, (_ref)=>{
    var { typed: typed, compareNatural: compareNatural } = _ref;
    /**
   * Count the number of elements of a (multi)set. When a second parameter is 'true', count only the unique values.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setSize(set)
   *    math.setSize(set, unique)
   *
   * Examples:
   *
   *    math.setSize([1, 2, 2, 4])          // returns 4
   *    math.setSize([1, 2, 2, 4], true)    // returns 3
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a  A multiset
   * @return {number}            The number of elements of the (multi)set
   */ return typed($22ba7617a6e5cb6d$var$name, {
        'Array | Matrix': function ArrayMatrix(a) {
            return Array.isArray(a) ? (0, $10UPF.flatten)(a).length : (0, $10UPF.flatten)(a.toArray()).length;
        },
        'Array | Matrix, boolean': function ArrayMatrixBoolean(a, unique) {
            if (unique === false || a.length === 0) return Array.isArray(a) ? (0, $10UPF.flatten)(a).length : (0, $10UPF.flatten)(a.toArray()).length;
            else {
                var b = (0, $10UPF.flatten)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                var count = 1;
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) count++;
                return count;
            }
        }
    });
});

});

parcelRegister("7jsoH", function(module, exports) {

$parcel$export(module.exports, "createSetSymDifference", () => $553055e62a5400e8$export$4a9a0ead2012bfc4);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $553055e62a5400e8$var$name = 'setSymDifference';
var $553055e62a5400e8$var$dependencies = [
    'typed',
    'size',
    'concat',
    'subset',
    'setDifference',
    'Index'
];
var $553055e62a5400e8$export$4a9a0ead2012bfc4 = /* #__PURE__ */ (0, $4eE2e.factory)($553055e62a5400e8$var$name, $553055e62a5400e8$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, concat: concat, subset: subset, setDifference: setDifference, Index: Index } = _ref;
    /**
   * Create the symmetric difference of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setSymDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 5, 6]
   *    math.setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 5, 6]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The symmetric difference of two (multi)sets
   */ return typed($553055e62a5400e8$var$name, {
        'Array | Matrix, Array | Matrix': function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $10UPF.flatten)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $10UPF.flatten)(a1);
            var b1 = (0, $10UPF.flatten)(a1);
            var b2 = (0, $10UPF.flatten)(a2);
            return concat(setDifference(b1, b2), setDifference(b2, b1));
        }
    });
});

});

parcelRegister("ahdW9", function(module, exports) {

$parcel$export(module.exports, "createSetUnion", () => $77b64d7e825c980a$export$fbdfd2054d37f888);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $77b64d7e825c980a$var$name = 'setUnion';
var $77b64d7e825c980a$var$dependencies = [
    'typed',
    'size',
    'concat',
    'subset',
    'setIntersect',
    'setSymDifference',
    'Index'
];
var $77b64d7e825c980a$export$fbdfd2054d37f888 = /* #__PURE__ */ (0, $4eE2e.factory)($77b64d7e825c980a$var$name, $77b64d7e825c980a$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, concat: concat, subset: subset, setIntersect: setIntersect, setSymDifference: setSymDifference, Index: Index } = _ref;
    /**
   * Create the union of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setUnion(set1, set2)
   *
   * Examples:
   *
   *    math.setUnion([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 3, 4, 5, 6]
   *    math.setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 3, 4, 5, 6]
   *
   * See also:
   *
   *    setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The union of two (multi)sets
   */ return typed($77b64d7e825c980a$var$name, {
        'Array | Matrix, Array | Matrix': function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $10UPF.flatten)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $10UPF.flatten)(a1);
            var b1 = (0, $10UPF.flatten)(a1);
            var b2 = (0, $10UPF.flatten)(a2);
            return concat(setSymDifference(b1, b2), setIntersect(b1, b2));
        }
    });
});

});

parcelRegister("2noYB", function(module, exports) {

$parcel$export(module.exports, "createSign", () => $1bb11a8b6902e92b$export$45df7cae684751af);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $eRNhQ = parcelRequire("eRNhQ");
var $1bb11a8b6902e92b$var$name = 'sign';
var $1bb11a8b6902e92b$var$dependencies = [
    'typed',
    'BigNumber',
    'Fraction',
    'complex'
];
var $1bb11a8b6902e92b$export$45df7cae684751af = /* #__PURE__ */ (0, $4eE2e.factory)($1bb11a8b6902e92b$var$name, $1bb11a8b6902e92b$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber, complex: complex, Fraction: _Fraction } = _ref;
    /**
   * Compute the sign of a value. The sign of a value x is:
   *
   * -  1 when x > 0
   * - -1 when x < 0
   * -  0 when x == 0
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sign(x)
   *
   * Examples:
   *
   *    math.sign(3.5)               // returns 1
   *    math.sign(-4.2)              // returns -1
   *    math.sign(0)                 // returns 0
   *
   *    math.sign([3, 5, -2, 0, 2])  // returns [1, 1, -1, 0, 1]
   *
   * See also:
   *
   *    abs
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            The number for which to determine the sign
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}e
   *            The sign of `x`
   */ return typed($1bb11a8b6902e92b$var$name, {
        number: (0, $eRNhQ.signNumber),
        Complex: function Complex(x) {
            return x.im === 0 ? complex((0, $eRNhQ.signNumber)(x.re)) : x.sign();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(x.cmp(0));
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x.s, 1);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since sign(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        },
        Unit: function Unit(x) {
            return this(x.value);
        }
    });
});

});

parcelRegister("bv6xC", function(module, exports) {

$parcel$export(module.exports, "createSin", () => $85f7a9e9e5ef70e7$export$4b4fac44ef379cae);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $85f7a9e9e5ef70e7$var$name = 'sin';
var $85f7a9e9e5ef70e7$var$dependencies = [
    'typed'
];
var $85f7a9e9e5ef70e7$export$4b4fac44ef379cae = /* #__PURE__ */ (0, $4eE2e.factory)($85f7a9e9e5ef70e7$var$name, $85f7a9e9e5ef70e7$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the sine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sin(x)
   *
   * Examples:
   *
   *    math.sin(2)                      // returns number 0.9092974268256813
   *    math.sin(math.pi / 4)            // returns number 0.7071067811865475
   *    math.sin(math.unit(90, 'deg'))   // returns number 1
   *    math.sin(math.unit(30, 'deg'))   // returns number 0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number ~1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Sine of x
   */ return typed($85f7a9e9e5ef70e7$var$name, {
        number: Math.sin,
        Complex: function Complex(x) {
            return x.sin();
        },
        BigNumber: function BigNumber(x) {
            return x.sin();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function sin is no angle');
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since sin(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        }
    });
});

});

parcelRegister("i8fn6", function(module, exports) {

$parcel$export(module.exports, "createSinh", () => $d334e5d4fd253516$export$c3a62182c56878d5);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $fkvqw = parcelRequire("fkvqw");
var $d334e5d4fd253516$var$name = 'sinh';
var $d334e5d4fd253516$var$dependencies = [
    'typed'
];
var $d334e5d4fd253516$export$c3a62182c56878d5 = /* #__PURE__ */ (0, $4eE2e.factory)($d334e5d4fd253516$var$name, $d334e5d4fd253516$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic sine of a value,
   * defined as `sinh(x) = 1/2 * (exp(x) - exp(-x))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sinh(x)
   *
   * Examples:
   *
   *    math.sinh(0.5)       // returns number 0.5210953054937474
   *
   * See also:
   *
   *    cosh, tanh
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic sine of x
   */ return typed($d334e5d4fd253516$var$name, {
        number: (0, $fkvqw.sinhNumber),
        Complex: function Complex(x) {
            return x.sinh();
        },
        BigNumber: function BigNumber(x) {
            return x.sinh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function sinh is no angle');
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since sinh(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        }
    });
});

});

parcelRegister("gjIaM", function(module, exports) {

$parcel$export(module.exports, "createSize", () => $be10af7bbd61f277$export$9151c23a59ce3fb6);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");

var $g9z12 = parcelRequire("g9z12");
var $be10af7bbd61f277$var$name = 'size';
var $be10af7bbd61f277$var$dependencies = [
    'typed',
    'config',
    '?matrix'
];
var $be10af7bbd61f277$export$9151c23a59ce3fb6 = /* #__PURE__ */ (0, $4eE2e.factory)($be10af7bbd61f277$var$name, $be10af7bbd61f277$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix } = _ref;
    /**
   * Calculate the size of a matrix or scalar.
   *
   * Syntax:
   *
   *     math.size(x)
   *
   * Examples:
   *
   *     math.size(2.3)                  // returns []
   *     math.size('hello world')        // returns [11]
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.size(A)                    // returns [2, 3]
   *     math.size(math.range(1,6))      // returns [5]
   *
   * See also:
   *
   *     count, resize, squeeze, subset
   *
   * @param {boolean | number | Complex | Unit | string | Array | Matrix} x  A matrix
   * @return {Array | Matrix} A vector with size of `x`.
   */ return typed($be10af7bbd61f277$var$name, {
        Matrix: function Matrix(x) {
            return x.create(x.size());
        },
        Array: (0, $10UPF.arraySize),
        string: function string(x) {
            return config.matrix === 'Array' ? [
                x.length
            ] : matrix([
                x.length
            ]);
        },
        'number | Complex | BigNumber | Unit | boolean | null': function numberComplexBigNumberUnitBooleanNull(x) {
            // scalar
            return config.matrix === 'Array' ? [] : matrix ? matrix([]) : (0, $g9z12.noMatrix)();
        }
    });
});

});

parcelRegister("lLfhi", function(module, exports) {

$parcel$export(module.exports, "createSlu", () => $fd79d6a4f236f359$export$e44ac9822ce417ae);

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");

var $lczcm = parcelRequire("lczcm");

var $iJWPN = parcelRequire("iJWPN");
var $fd79d6a4f236f359$var$name = 'slu';
var $fd79d6a4f236f359$var$dependencies = [
    'typed',
    'abs',
    'add',
    'multiply',
    'transpose',
    'divideScalar',
    'subtract',
    'larger',
    'largerEq',
    'SparseMatrix'
];
var $fd79d6a4f236f359$export$e44ac9822ce417ae = /* #__PURE__ */ (0, $4eE2e.factory)($fd79d6a4f236f359$var$name, $fd79d6a4f236f359$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, multiply: multiply, transpose: transpose, divideScalar: divideScalar, subtract: subtract, larger: larger, largerEq: largerEq, SparseMatrix: SparseMatrix } = _ref;
    var csSqr = (0, $lczcm.createCsSqr)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csLu = (0, $iJWPN.createCsLu)({
        abs: abs,
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract,
        larger: larger,
        largerEq: largerEq,
        SparseMatrix: SparseMatrix
    });
    /**
   * Calculate the Sparse Matrix LU decomposition with full pivoting. Sparse Matrix `A` is decomposed in two matrices (`L`, `U`) and two permutation vectors (`pinv`, `q`) where
   *
   * `P * A * Q = L * U`
   *
   * Syntax:
   *
   *    math.slu(A, order, threshold)
   *
   * Examples:
   *
   *    const A = math.sparse([[4,3], [6, 3]])
   *    math.slu(A, 1, 0.001)
   *    // returns:
   *    // {
   *    //   L: [[1, 0], [1.5, 1]]
   *    //   U: [[4, 3], [0, -1.5]]
   *    //   p: [0, 1]
   *    //   q: [0, 1]
   *    // }
   *
   * See also:
   *
   *    lup, lsolve, usolve, lusolve
   *
   * @param {SparseMatrix} A              A two dimensional sparse matrix for which to get the LU decomposition.
   * @param {Number}       order          The Symbolic Ordering and Analysis order:
   *                                       0 - Natural ordering, no permutation vector q is returned
   *                                       1 - Matrix must be square, symbolic ordering and analisis is performed on M = A + A'
   *                                       2 - Symbolic ordering and analisis is performed on M = A' * A. Dense columns from A' are dropped, A recreated from A'.
   *                                           This is appropriatefor LU factorization of unsymmetric matrices.
   *                                       3 - Symbolic ordering and analisis is performed on M = A' * A. This is best used for LU factorization is matrix M has no dense rows.
   *                                           A dense row is a row with more than 10*sqr(columns) entries.
   * @param {Number}       threshold       Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Object} The lower triangular matrix, the upper triangular matrix and the permutation vectors.
   */ return typed($fd79d6a4f236f359$var$name, {
        'SparseMatrix, number, number': function SparseMatrixNumberNumber(a, order, threshold) {
            // verify order
            if (!(0, $6egKm.isInteger)(order) || order < 0 || order > 3) throw new Error('Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]');
             // verify threshold
            if (threshold < 0 || threshold > 1) throw new Error('Partial pivoting threshold must be a number from 0 to 1');
             // perform symbolic ordering and analysis
            var s = csSqr(order, a, false); // perform lu decomposition
            var f = csLu(a, s, threshold); // return decomposition
            return {
                L: f.L,
                U: f.U,
                p: f.pinv,
                q: s.q,
                toString: function toString() {
                    return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\np: ' + this.p.toString() + (this.q ? '\nq: ' + this.q.toString() : '') + '\n';
                }
            };
        }
    });
});

});
parcelRegister("lczcm", function(module, exports) {

$parcel$export(module.exports, "createCsSqr", () => $f6f605a0cd257f39$export$4d3f338d9cfe48c1);

var $cEALq = parcelRequire("cEALq");

var $awgVt = parcelRequire("awgVt");

var $l4eVE = parcelRequire("l4eVE");

var $jkluE = parcelRequire("jkluE");

var $gwUIk = parcelRequire("gwUIk");

var $4eE2e = parcelRequire("4eE2e");
var $f6f605a0cd257f39$var$name = 'csSqr';
var $f6f605a0cd257f39$var$dependencies = [
    'add',
    'multiply',
    'transpose'
];
var $f6f605a0cd257f39$export$4d3f338d9cfe48c1 = /* #__PURE__ */ (0, $4eE2e.factory)($f6f605a0cd257f39$var$name, $f6f605a0cd257f39$var$dependencies, (_ref)=>{
    var { add: add, multiply: multiply, transpose: transpose } = _ref;
    var csAmd = (0, $jkluE.createCsAmd)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csCounts = (0, $gwUIk.createCsCounts)({
        transpose: transpose
    });
    /**
   * Symbolic ordering and analysis for QR and LU decompositions.
   *
   * @param {Number}  order           The ordering strategy (see csAmd for more details)
   * @param {Matrix}  a               The A matrix
   * @param {boolean} qr              Symbolic ordering and analysis for QR decomposition (true) or
   *                                  symbolic ordering and analysis for LU decomposition (false)
   *
   * @return {Object}                 The Symbolic ordering and analysis for matrix A
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csSqr(order, a, qr) {
        // a arrays
        var aptr = a._ptr;
        var asize = a._size; // columns
        var n = asize[1]; // vars
        var k; // symbolic analysis result
        var s = {}; // fill-reducing ordering
        s.q = csAmd(order, a); // validate results
        if (order && !s.q) return null;
         // QR symbolic analysis
        if (qr) {
            // apply permutations if needed
            var c = order ? (0, $cEALq.csPermute)(a, null, s.q, 0) : a; // etree of C'*C, where C=A(:,q)
            s.parent = (0, $l4eVE.csEtree)(c, 1); // post order elimination tree
            var post = (0, $awgVt.csPost)(s.parent, n); // col counts chol(C'*C)
            s.cp = csCounts(c, s.parent, post, 1); // check we have everything needed to calculate number of nonzero elements
            if (c && s.parent && s.cp && _vcount(c, s)) // calculate number of nonzero elements
            for(s.unz = 0, k = 0; k < n; k++)s.unz += s.cp[k];
        } else {
            // for LU factorization only, guess nnz(L) and nnz(U)
            s.unz = 4 * aptr[n] + n;
            s.lnz = s.unz;
        } // return result S
        return s;
    };
    /**
   * Compute nnz(V) = s.lnz, s.pinv, s.leftmost, s.m2 from A and s.parent
   */ function _vcount(a, s) {
        // a arrays
        var aptr = a._ptr;
        var aindex = a._index;
        var asize = a._size; // rows & columns
        var m = asize[0];
        var n = asize[1]; // initialize s arrays
        s.pinv = []; // (m + n)
        s.leftmost = []; // (m)
        // vars
        var parent = s.parent;
        var pinv = s.pinv;
        var leftmost = s.leftmost; // workspace, next: first m entries, head: next n entries, tail: next n entries, nque: next n entries
        var w = []; // (m + 3 * n)
        var next = 0;
        var head = m;
        var tail = m + n;
        var nque = m + 2 * n; // vars
        var i, k, p, p0, p1; // initialize w
        for(k = 0; k < n; k++){
            // queue k is empty
            w[head + k] = -1;
            w[tail + k] = -1;
            w[nque + k] = 0;
        } // initialize row arrays
        for(i = 0; i < m; i++)leftmost[i] = -1;
         // loop columns backwards
        for(k = n - 1; k >= 0; k--)// values & index for column k
        for(p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++)// leftmost[i] = min(find(A(i,:)))
        leftmost[aindex[p]] = k;
         // scan rows in reverse order
        for(i = m - 1; i >= 0; i--){
            // row i is not yet ordered
            pinv[i] = -1;
            k = leftmost[i]; // check row i is empty
            if (k === -1) continue;
             // first row in queue k
            if (w[nque + k]++ === 0) w[tail + k] = i;
             // put i at head of queue k
            w[next + i] = w[head + k];
            w[head + k] = i;
        }
        s.lnz = 0;
        s.m2 = m; // find row permutation and nnz(V)
        for(k = 0; k < n; k++){
            // remove row i from queue k
            i = w[head + k]; // count V(k,k) as nonzero
            s.lnz++; // add a fictitious row
            if (i < 0) i = s.m2++;
             // associate row i with V(:,k)
            pinv[i] = k; // skip if V(k+1:m,k) is empty
            if (--nque[k] <= 0) continue;
             // nque[k] is nnz (V(k+1:m,k))
            s.lnz += w[nque + k]; // move all rows to parent of k
            var pa = parent[k];
            if (pa !== -1) {
                if (w[nque + pa] === 0) w[tail + pa] = w[tail + k];
                w[next + w[tail + k]] = w[head + pa];
                w[head + pa] = w[next + i];
                w[nque + pa] += w[nque + k];
            }
        }
        for(i = 0; i < m; i++)if (pinv[i] < 0) pinv[i] = k++;
        return true;
    }
});

});
parcelRegister("cEALq", function(module, exports) {

$parcel$export(module.exports, "csPermute", () => $9365bd0136d523be$export$76070a0ecffd0bb2);
/**
 * Permutes a sparse matrix C = P * A * Q
 *
 * @param {SparseMatrix}  a         The Matrix A
 * @param {Array}   pinv            The row permutation vector
 * @param {Array}   q               The column permutation vector
 * @param {boolean} values          Create a pattern matrix (false), values and pattern otherwise
 *
 * @return {Matrix}                 C = P * A * Q, null on error
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $9365bd0136d523be$export$76070a0ecffd0bb2(a, pinv, q, values) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size;
    var adt = a._datatype; // rows & columns
    var m = asize[0];
    var n = asize[1]; // c arrays
    var cvalues = values && a._values ? [] : null;
    var cindex = []; // (aptr[n])
    var cptr = []; // (n + 1)
    // initialize vars
    var nz = 0; // loop columns
    for(var k = 0; k < n; k++){
        // column k of C is column q[k] of A
        cptr[k] = nz; // apply column permutation
        var j = q ? q[k] : k; // loop values in column j of A
        for(var t0 = aptr[j], t1 = aptr[j + 1], t = t0; t < t1; t++){
            // row i of A is row pinv[i] of C
            var r = pinv ? pinv[aindex[t]] : aindex[t]; // index
            cindex[nz] = r; // check we need to populate values
            if (cvalues) cvalues[nz] = avalues[t];
             // increment number of nonzero elements
            nz++;
        }
    } // finalize the last column of C
    cptr[n] = nz; // return C matrix
    return a.createSparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [
            m,
            n
        ],
        datatype: adt
    });
}

});

parcelRegister("awgVt", function(module, exports) {

$parcel$export(module.exports, "csPost", () => $7a8a05b6dcf216cd$export$90626b0a5705891a);

var $7WIWH = parcelRequire("7WIWH");
function $7a8a05b6dcf216cd$export$90626b0a5705891a(parent, n) {
    // check inputs
    if (!parent) return null;
     // vars
    var k = 0;
    var j; // allocate result
    var post = []; // (n)
    // workspace, head: first n entries, next: next n entries, stack: last n entries
    var w = []; // (3 * n)
    var head = 0;
    var next = n;
    var stack = 2 * n; // initialize workspace
    for(j = 0; j < n; j++)// empty linked lists
    w[head + j] = -1;
     // traverse nodes in reverse order
    for(j = n - 1; j >= 0; j--){
        // check j is a root
        if (parent[j] === -1) continue;
         // add j to list of its parent
        w[next + j] = w[head + parent[j]];
        w[head + parent[j]] = j;
    } // loop nodes
    for(j = 0; j < n; j++){
        // skip j if it is not a root
        if (parent[j] !== -1) continue;
         // depth-first search
        k = (0, $7WIWH.csTdfs)(j, k, w, head, next, post, stack);
    }
    return post;
}

});
parcelRegister("7WIWH", function(module, exports) {

$parcel$export(module.exports, "csTdfs", () => $5c90d0768118d29f$export$18e42241aee7902a);
/**
 * Depth-first search and postorder of a tree rooted at node j
 *
 * @param {Number}  j               The tree node
 * @param {Number}  k
 * @param {Array}   w               The workspace array
 * @param {Number}  head            The index offset within the workspace for the head array
 * @param {Number}  next            The index offset within the workspace for the next array
 * @param {Array}   post            The post ordering array
 * @param {Number}  stack           The index offset within the workspace for the stack array
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $5c90d0768118d29f$export$18e42241aee7902a(j, k, w, head, next, post, stack) {
    // variables
    var top = 0; // place j on the stack
    w[stack] = j; // while (stack is not empty)
    while(top >= 0){
        // p = top of stack
        var p = w[stack + top]; // i = youngest child of p
        var i = w[head + p];
        if (i === -1) {
            // p has no unordered children left
            top--; // node p is the kth postordered node
            post[k++] = p;
        } else {
            // remove i from children of p
            w[head + p] = w[next + i]; // increment top
            ++top; // start dfs on child node i
            w[stack + top] = i;
        }
    }
    return k;
}

});


parcelRegister("l4eVE", function(module, exports) {

$parcel$export(module.exports, "csEtree", () => $f5658d452c917fff$export$720e2a9a0fdebf8c);
/**
 * Computes the elimination tree of Matrix A (using triu(A)) or the
 * elimination tree of A'A without forming A'A.
 *
 * @param {Matrix}  a               The A Matrix
 * @param {boolean} ata             A value of true the function computes the etree of A'A
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $f5658d452c917fff$export$720e2a9a0fdebf8c(a, ata) {
    // check inputs
    if (!a) return null;
     // a arrays
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size; // rows & columns
    var m = asize[0];
    var n = asize[1]; // allocate result
    var parent = []; // (n)
    // allocate workspace
    var w = []; // (n + (ata ? m : 0))
    var ancestor = 0; // first n entries in w
    var prev = n; // last m entries (ata = true)
    var i, inext; // check we are calculating A'A
    if (ata) // initialize workspace
    for(i = 0; i < m; i++)w[prev + i] = -1;
     // loop columns
    for(var k = 0; k < n; k++){
        // node k has no parent yet
        parent[k] = -1; // nor does k have an ancestor
        w[ancestor + k] = -1; // values in column k
        for(var p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++){
            // row
            var r = aindex[p]; // node
            i = ata ? w[prev + r] : r; // traverse from i to k
            for(; i !== -1 && i < k; i = inext){
                // inext = ancestor of i
                inext = w[ancestor + i]; // path compression
                w[ancestor + i] = k; // check no anc., parent is k
                if (inext === -1) parent[i] = k;
            }
            if (ata) w[prev + r] = k;
        }
    }
    return parent;
}

});

parcelRegister("jkluE", function(module, exports) {

$parcel$export(module.exports, "createCsAmd", () => $e1208eb3b3d50718$export$485230eb48878637);

var $4eE2e = parcelRequire("4eE2e");

var $lmFeP = parcelRequire("lmFeP");

var $3UFSI = parcelRequire("3UFSI");

var $7WIWH = parcelRequire("7WIWH");
var $e1208eb3b3d50718$var$name = 'csAmd';
var $e1208eb3b3d50718$var$dependencies = [
    'add',
    'multiply',
    'transpose'
];
var $e1208eb3b3d50718$export$485230eb48878637 = /* #__PURE__ */ (0, $4eE2e.factory)($e1208eb3b3d50718$var$name, $e1208eb3b3d50718$var$dependencies, (_ref)=>{
    var { add: add, multiply: multiply, transpose: transpose } = _ref;
    /**
   * Approximate minimum degree ordering. The minimum degree algorithm is a widely used
   * heuristic for finding a permutation P so that P*A*P' has fewer nonzeros in its factorization
   * than A. It is a gready method that selects the sparsest pivot row and column during the course
   * of a right looking sparse Cholesky factorization.
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   *
   * @param {Number} order    0: Natural, 1: Cholesky, 2: LU, 3: QR
   * @param {Matrix} m        Sparse Matrix
   */ return function csAmd(order, a) {
        // check input parameters
        if (!a || order <= 0 || order > 3) return null;
         // a matrix arrays
        var asize = a._size; // rows and columns
        var m = asize[0];
        var n = asize[1]; // initialize vars
        var lemax = 0; // dense threshold
        var dense = Math.max(16, 10 * Math.sqrt(n));
        dense = Math.min(n - 2, dense); // create target matrix C
        var cm = _createTargetMatrix(order, a, m, n, dense); // drop diagonal entries
        (0, $lmFeP.csFkeep)(cm, _diag, null); // C matrix arrays
        var cindex = cm._index;
        var cptr = cm._ptr; // number of nonzero elements in C
        var cnz = cptr[n]; // allocate result (n+1)
        var P = []; // create workspace (8 * (n + 1))
        var W = [];
        var len = 0; // first n + 1 entries
        var nv = n + 1; // next n + 1 entries
        var next = 2 * (n + 1); // next n + 1 entries
        var head = 3 * (n + 1); // next n + 1 entries
        var elen = 4 * (n + 1); // next n + 1 entries
        var degree = 5 * (n + 1); // next n + 1 entries
        var w = 6 * (n + 1); // next n + 1 entries
        var hhead = 7 * (n + 1); // last n + 1 entries
        // use P as workspace for last
        var last = P; // initialize quotient graph
        var mark = _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree); // initialize degree lists
        var nel = _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next); // minimum degree node
        var mindeg = 0; // vars
        var i, j, k, k1, k2, e, pj, ln, nvi, pk, eln, p1, p2, pn, h, d; // while (selecting pivots) do
        while(nel < n){
            // select node of minimum approximate degree. amd() is now ready to start eliminating the graph. It first
            // finds a node k of minimum degree and removes it from its degree list. The variable nel keeps track of thow
            // many nodes have been eliminated.
            for(k = -1; mindeg < n && (k = W[head + mindeg]) === -1; mindeg++);
            if (W[next + k] !== -1) last[W[next + k]] = -1;
             // remove k from degree list
            W[head + mindeg] = W[next + k]; // elenk = |Ek|
            var elenk = W[elen + k]; // # of nodes k represents
            var nvk = W[nv + k]; // W[nv + k] nodes of A eliminated
            nel += nvk; // Construct a new element. The new element Lk is constructed in place if |Ek| = 0. nv[i] is
            // negated for all nodes i in Lk to flag them as members of this set. Each node i is removed from the
            // degree lists. All elements e in Ek are absorved into element k.
            var dk = 0; // flag k as in Lk
            W[nv + k] = -nvk;
            var p = cptr[k]; // do in place if W[elen + k] === 0
            var pk1 = elenk === 0 ? p : cnz;
            var pk2 = pk1;
            for(k1 = 1; k1 <= elenk + 1; k1++){
                if (k1 > elenk) {
                    // search the nodes in k
                    e = k; // list of nodes starts at cindex[pj]
                    pj = p; // length of list of nodes in k
                    ln = W[len + k] - elenk;
                } else {
                    // search the nodes in e
                    e = cindex[p++];
                    pj = cptr[e]; // length of list of nodes in e
                    ln = W[len + e];
                }
                for(k2 = 1; k2 <= ln; k2++){
                    i = cindex[pj++]; // check  node i dead, or seen
                    if ((nvi = W[nv + i]) <= 0) continue;
                     // W[degree + Lk] += size of node i
                    dk += nvi; // negate W[nv + i] to denote i in Lk
                    W[nv + i] = -nvi; // place i in Lk
                    cindex[pk2++] = i;
                    if (W[next + i] !== -1) last[W[next + i]] = last[i];
                     // check we need to remove i from degree list
                    if (last[i] !== -1) W[next + last[i]] = W[next + i];
                    else W[head + W[degree + i]] = W[next + i];
                }
                if (e !== k) {
                    // absorb e into k
                    cptr[e] = (0, $3UFSI.csFlip)(k); // e is now a dead element
                    W[w + e] = 0;
                }
            } // cindex[cnz...nzmax] is free
            if (elenk !== 0) cnz = pk2;
             // external degree of k - |Lk\i|
            W[degree + k] = dk; // element k is in cindex[pk1..pk2-1]
            cptr[k] = pk1;
            W[len + k] = pk2 - pk1; // k is now an element
            W[elen + k] = -2; // Find set differences. The scan1 function now computes the set differences |Le \ Lk| for all elements e. At the start of the
            // scan, no entry in the w array is greater than or equal to mark.
            // clear w if necessary
            mark = _wclear(mark, lemax, W, w, n); // scan 1: find |Le\Lk|
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check if W[elen + i] empty, skip it
                if ((eln = W[elen + i]) <= 0) continue;
                 // W[nv + i] was negated
                nvi = -W[nv + i];
                var wnvi = mark - nvi; // scan Ei
                for(p = cptr[i], p1 = cptr[i] + eln - 1; p <= p1; p++){
                    e = cindex[p];
                    if (W[w + e] >= mark) // decrement |Le\Lk|
                    W[w + e] -= nvi;
                    else if (W[w + e] !== 0) // ensure e is a live element, 1st time e seen in scan 1
                    W[w + e] = W[degree + e] + wnvi;
                }
            } // degree update
            // The second pass computes the approximate degree di, prunes the sets Ei and Ai, and computes a hash
            // function h(i) for all nodes in Lk.
            // scan2: degree update
            for(pk = pk1; pk < pk2; pk++){
                // consider node i in Lk
                i = cindex[pk];
                p1 = cptr[i];
                p2 = p1 + W[elen + i] - 1;
                pn = p1; // scan Ei
                for(h = 0, d = 0, p = p1; p <= p2; p++){
                    e = cindex[p]; // check e is an unabsorbed element
                    if (W[w + e] !== 0) {
                        // dext = |Le\Lk|
                        var dext = W[w + e] - mark;
                        if (dext > 0) {
                            // sum up the set differences
                            d += dext; // keep e in Ei
                            cindex[pn++] = e; // compute the hash of node i
                            h += e;
                        } else {
                            // aggressive absorb. e->k
                            cptr[e] = (0, $3UFSI.csFlip)(k); // e is a dead element
                            W[w + e] = 0;
                        }
                    }
                } // W[elen + i] = |Ei|
                W[elen + i] = pn - p1 + 1;
                var p3 = pn;
                var p4 = p1 + W[len + i]; // prune edges in Ai
                for(p = p2 + 1; p < p4; p++){
                    j = cindex[p]; // check node j dead or in Lk
                    var nvj = W[nv + j];
                    if (nvj <= 0) continue;
                     // degree(i) += |j|
                    d += nvj; // place j in node list of i
                    cindex[pn++] = j; // compute hash for node i
                    h += j;
                } // check for mass elimination
                if (d === 0) {
                    // absorb i into k
                    cptr[i] = (0, $3UFSI.csFlip)(k);
                    nvi = -W[nv + i]; // |Lk| -= |i|
                    dk -= nvi; // |k| += W[nv + i]
                    nvk += nvi;
                    nel += nvi;
                    W[nv + i] = 0; // node i is dead
                    W[elen + i] = -1;
                } else {
                    // update degree(i)
                    W[degree + i] = Math.min(W[degree + i], d); // move first node to end
                    cindex[pn] = cindex[p3]; // move 1st el. to end of Ei
                    cindex[p3] = cindex[p1]; // add k as 1st element in of Ei
                    cindex[p1] = k; // new len of adj. list of node i
                    W[len + i] = pn - p1 + 1; // finalize hash of i
                    h = (h < 0 ? -h : h) % n; // place i in hash bucket
                    W[next + i] = W[hhead + h];
                    W[hhead + h] = i; // save hash of i in last[i]
                    last[i] = h;
                }
            } // finalize |Lk|
            W[degree + k] = dk;
            lemax = Math.max(lemax, dk); // clear w
            mark = _wclear(mark + lemax, lemax, W, w, n); // Supernode detection. Supernode detection relies on the hash function h(i) computed for each node i.
            // If two nodes have identical adjacency lists, their hash functions wil be identical.
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check i is dead, skip it
                if (W[nv + i] >= 0) continue;
                 // scan hash bucket of node i
                h = last[i];
                i = W[hhead + h]; // hash bucket will be empty
                W[hhead + h] = -1;
                for(; i !== -1 && W[next + i] !== -1; i = W[next + i], mark++){
                    ln = W[len + i];
                    eln = W[elen + i];
                    for(p = cptr[i] + 1; p <= cptr[i] + ln - 1; p++)W[w + cindex[p]] = mark;
                    var jlast = i; // compare i with all j
                    for(j = W[next + i]; j !== -1;){
                        var ok = W[len + j] === ln && W[elen + j] === eln;
                        for(p = cptr[j] + 1; ok && p <= cptr[j] + ln - 1; p++)// compare i and j
                        if (W[w + cindex[p]] !== mark) ok = 0;
                         // check i and j are identical
                        if (ok) {
                            // absorb j into i
                            cptr[j] = (0, $3UFSI.csFlip)(i);
                            W[nv + i] += W[nv + j];
                            W[nv + j] = 0; // node j is dead
                            W[elen + j] = -1; // delete j from hash bucket
                            j = W[next + j];
                            W[next + jlast] = j;
                        } else {
                            // j and i are different
                            jlast = j;
                            j = W[next + j];
                        }
                    }
                }
            } // Finalize new element. The elimination of node k is nearly complete. All nodes i in Lk are scanned one last time.
            // Node i is removed from Lk if it is dead. The flagged status of nv[i] is cleared.
            for(p = pk1, pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check  i is dead, skip it
                if ((nvi = -W[nv + i]) <= 0) continue;
                 // restore W[nv + i]
                W[nv + i] = nvi; // compute external degree(i)
                d = W[degree + i] + dk - nvi;
                d = Math.min(d, n - nel - nvi);
                if (W[head + d] !== -1) last[W[head + d]] = i;
                 // put i back in degree list
                W[next + i] = W[head + d];
                last[i] = -1;
                W[head + d] = i; // find new minimum degree
                mindeg = Math.min(mindeg, d);
                W[degree + i] = d; // place i in Lk
                cindex[p++] = i;
            } // # nodes absorbed into k
            W[nv + k] = nvk; // length of adj list of element k
            if ((W[len + k] = p - pk1) === 0) {
                // k is a root of the tree
                cptr[k] = -1; // k is now a dead element
                W[w + k] = 0;
            }
            if (elenk !== 0) // free unused space in Lk
            cnz = p;
        } // Postordering. The elimination is complete, but no permutation has been computed. All that is left
        // of the graph is the assembly tree (ptr) and a set of dead nodes and elements (i is a dead node if
        // nv[i] is zero and a dead element if nv[i] > 0). It is from this information only that the final permutation
        // is computed. The tree is restored by unflipping all of ptr.
        // fix assembly tree
        for(i = 0; i < n; i++)cptr[i] = (0, $3UFSI.csFlip)(cptr[i]);
        for(j = 0; j <= n; j++)W[head + j] = -1;
         // place unordered nodes in lists
        for(j = n; j >= 0; j--){
            // skip if j is an element
            if (W[nv + j] > 0) continue;
             // place j in list of its parent
            W[next + j] = W[head + cptr[j]];
            W[head + cptr[j]] = j;
        } // place elements in lists
        for(e = n; e >= 0; e--){
            // skip unless e is an element
            if (W[nv + e] <= 0) continue;
            if (cptr[e] !== -1) {
                // place e in list of its parent
                W[next + e] = W[head + cptr[e]];
                W[head + cptr[e]] = e;
            }
        } // postorder the assembly tree
        for(k = 0, i = 0; i <= n; i++)if (cptr[i] === -1) k = (0, $7WIWH.csTdfs)(i, k, W, head, next, P, w);
         // remove last item in array
        P.splice(P.length - 1, 1); // return P
        return P;
    };
    /**
   * Creates the matrix that will be used by the approximate minimum degree ordering algorithm. The function accepts the matrix M as input and returns a permutation
   * vector P. The amd algorithm operates on a symmetrix matrix, so one of three symmetric matrices is formed.
   *
   * Order: 0
   *   A natural ordering P=null matrix is returned.
   *
   * Order: 1
   *   Matrix must be square. This is appropriate for a Cholesky or LU factorization.
   *   P = M + M'
   *
   * Order: 2
   *   Dense columns from M' are dropped, M recreated from M'. This is appropriatefor LU factorization of unsymmetric matrices.
   *   P = M' * M
   *
   * Order: 3
   *   This is best used for QR factorization or LU factorization is matrix M has no dense rows. A dense row is a row with more than 10*sqr(columns) entries.
   *   P = M' * M
   */ function _createTargetMatrix(order, a, m, n, dense) {
        // compute A'
        var at = transpose(a); // check order = 1, matrix must be square
        if (order === 1 && n === m) // C = A + A'
        return add(a, at);
         // check order = 2, drop dense columns from M'
        if (order === 2) {
            // transpose arrays
            var tindex = at._index;
            var tptr = at._ptr; // new column index
            var p2 = 0; // loop A' columns (rows)
            for(var j = 0; j < m; j++){
                // column j of AT starts here
                var p = tptr[j]; // new column j starts here
                tptr[j] = p2; // skip dense col j
                if (tptr[j + 1] - p > dense) continue;
                 // map rows in column j of A
                for(var p1 = tptr[j + 1]; p < p1; p++)tindex[p2++] = tindex[p];
            } // finalize AT
            tptr[m] = p2; // recreate A from new transpose matrix
            a = transpose(at); // use A' * A
            return multiply(at, a);
        } // use A' * A, square or rectangular matrix
        return multiply(at, a);
    }
    /**
   * Initialize quotient graph. There are four kind of nodes and elements that must be represented:
   *
   *  - A live node is a node i (or a supernode) that has not been selected as a pivot nad has not been merged into another supernode.
   *  - A dead node i is one that has been removed from the graph, having been absorved into r = flip(ptr[i]).
   *  - A live element e is one that is in the graph, having been formed when node e was selected as the pivot.
   *  - A dead element e is one that has benn absorved into a subsequent element s = flip(ptr[e]).
   */ function _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree) {
        // Initialize quotient graph
        for(var k = 0; k < n; k++)W[len + k] = cptr[k + 1] - cptr[k];
        W[len + n] = 0; // initialize workspace
        for(var i = 0; i <= n; i++){
            // degree list i is empty
            W[head + i] = -1;
            last[i] = -1;
            W[next + i] = -1; // hash list i is empty
            W[hhead + i] = -1; // node i is just one node
            W[nv + i] = 1; // node i is alive
            W[w + i] = 1; // Ek of node i is empty
            W[elen + i] = 0; // degree of node i
            W[degree + i] = W[len + i];
        } // clear w
        var mark = _wclear(0, 0, W, w, n); // n is a dead element
        W[elen + n] = -2; // n is a root of assembly tree
        cptr[n] = -1; // n is a dead element
        W[w + n] = 0; // return mark
        return mark;
    }
    /**
   * Initialize degree lists. Each node is placed in its degree lists. Nodes of zero degree are eliminated immediately. Nodes with
   * degree >= dense are alsol eliminated and merged into a placeholder node n, a dead element. Thes nodes will appera last in the
   * output permutation p.
   */ function _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next) {
        // result
        var nel = 0; // loop columns
        for(var i = 0; i < n; i++){
            // degree @ i
            var d = W[degree + i]; // check node i is empty
            if (d === 0) {
                // element i is dead
                W[elen + i] = -2;
                nel++; // i is a root of assembly tree
                cptr[i] = -1;
                W[w + i] = 0;
            } else if (d > dense) {
                // absorb i into element n
                W[nv + i] = 0; // node i is dead
                W[elen + i] = -1;
                nel++;
                cptr[i] = (0, $3UFSI.csFlip)(n);
                W[nv + n]++;
            } else {
                var h = W[head + d];
                if (h !== -1) last[h] = i;
                 // put node i in degree list d
                W[next + i] = W[head + d];
                W[head + d] = i;
            }
        }
        return nel;
    }
    function _wclear(mark, lemax, W, w, n) {
        if (mark < 2 || mark + lemax < 0) {
            for(var k = 0; k < n; k++)if (W[w + k] !== 0) W[w + k] = 1;
            mark = 2;
        } // at this point, W [0..n-1] < mark holds
        return mark;
    }
    function _diag(i, j) {
        return i !== j;
    }
});

});
parcelRegister("lmFeP", function(module, exports) {

$parcel$export(module.exports, "csFkeep", () => $f8dba4154c856525$export$9453433d9395b8cb);
/**
 * Keeps entries in the matrix when the callback function returns true, removes the entry otherwise
 *
 * @param {Matrix}   a              The sparse matrix
 * @param {function} callback       The callback function, function will be invoked with the following args:
 *                                    - The entry row
 *                                    - The entry column
 *                                    - The entry value
 *                                    - The state parameter
 * @param {any}      other          The state
 *
 * @return                          The number of nonzero elements in the matrix
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $f8dba4154c856525$export$9453433d9395b8cb(a, callback, other) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size; // columns
    var n = asize[1]; // nonzero items
    var nz = 0; // loop columns
    for(var j = 0; j < n; j++){
        // get current location of col j
        var p = aptr[j]; // record new location of col j
        aptr[j] = nz;
        for(; p < aptr[j + 1]; p++)// check we need to keep this item
        if (callback(aindex[p], j, avalues ? avalues[p] : 1, other)) {
            // keep A(i,j)
            aindex[nz] = aindex[p]; // check we need to process values (pattern only)
            if (avalues) avalues[nz] = avalues[p];
             // increment nonzero items
            nz++;
        }
    } // finalize A
    aptr[n] = nz; // trim arrays
    aindex.splice(nz, aindex.length - nz); // check we need to process values (pattern only)
    if (avalues) avalues.splice(nz, avalues.length - nz);
     // return number of nonzero items
    return nz;
}

});

parcelRegister("3UFSI", function(module, exports) {

$parcel$export(module.exports, "csFlip", () => $2d9716e112ea6aff$export$d405b3d9168b83fa);
/**
 * This function "flips" its input about the integer -1.
 *
 * @param {Number}  i               The value to flip
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $2d9716e112ea6aff$export$d405b3d9168b83fa(i) {
    // flip the value
    return -i - 2;
}

});


parcelRegister("gwUIk", function(module, exports) {

$parcel$export(module.exports, "createCsCounts", () => $c08ba0b09b96388e$export$1feb4fbda2abf3b3);

var $4eE2e = parcelRequire("4eE2e");

var $6ajNw = parcelRequire("6ajNw");
var $c08ba0b09b96388e$var$name = 'csCounts';
var $c08ba0b09b96388e$var$dependencies = [
    'transpose'
];
var $c08ba0b09b96388e$export$1feb4fbda2abf3b3 = /* #__PURE__ */ (0, $4eE2e.factory)($c08ba0b09b96388e$var$name, $c08ba0b09b96388e$var$dependencies, (_ref)=>{
    var { transpose: transpose } = _ref;
    /**
   * Computes the column counts using the upper triangular part of A.
   * It transposes A internally, none of the input parameters are modified.
   *
   * @param {Matrix} a           The sparse matrix A
   *
   * @param {Matrix} ata         Count the columns of A'A instead
   *
   * @return                     An array of size n of the column counts or null on error
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function(a, parent, post, ata) {
        // check inputs
        if (!a || !parent || !post) return null;
         // a matrix arrays
        var asize = a._size; // rows and columns
        var m = asize[0];
        var n = asize[1]; // variables
        var i, j, k, J, p, p0, p1; // workspace size
        var s = 4 * n + (ata ? n + m + 1 : 0); // allocate workspace
        var w = []; // (s)
        var ancestor = 0; // first n entries
        var maxfirst = n; // next n entries
        var prevleaf = 2 * n; // next n entries
        var first = 3 * n; // next n entries
        var head = 4 * n; // next n + 1 entries (used when ata is true)
        var next = 5 * n + 1; // last entries in workspace
        // clear workspace w[0..s-1]
        for(k = 0; k < s; k++)w[k] = -1;
         // allocate result
        var colcount = []; // (n)
        // AT = A'
        var at = transpose(a); // at arrays
        var tindex = at._index;
        var tptr = at._ptr; // find w[first + j]
        for(k = 0; k < n; k++){
            j = post[k]; // colcount[j]=1 if j is a leaf
            colcount[j] = w[first + j] === -1 ? 1 : 0;
            for(; j !== -1 && w[first + j] === -1; j = parent[j])w[first + j] = k;
        } // initialize ata if needed
        if (ata) {
            // invert post
            for(k = 0; k < n; k++)w[post[k]] = k;
             // loop rows (columns in AT)
            for(i = 0; i < m; i++){
                // values in column i of AT
                for(k = n, p0 = tptr[i], p1 = tptr[i + 1], p = p0; p < p1; p++)k = Math.min(k, w[tindex[p]]);
                 // place row i in linked list k
                w[next + i] = w[head + k];
                w[head + k] = i;
            }
        } // each node in its own set
        for(i = 0; i < n; i++)w[ancestor + i] = i;
        for(k = 0; k < n; k++){
            // j is the kth node in postordered etree
            j = post[k]; // check j is not a root
            if (parent[j] !== -1) colcount[parent[j]]--;
             // J=j for LL'=A case
            for(J = ata ? w[head + k] : j; J !== -1; J = ata ? w[next + J] : -1)for(p = tptr[J]; p < tptr[J + 1]; p++){
                i = tindex[p];
                var r = (0, $6ajNw.csLeaf)(i, j, w, first, maxfirst, prevleaf, ancestor); // check A(i,j) is in skeleton
                if (r.jleaf >= 1) colcount[j]++;
                 // check account for overlap in q
                if (r.jleaf === 2) colcount[r.q]--;
            }
            if (parent[j] !== -1) w[ancestor + j] = parent[j];
        } // sum up colcount's of each child
        for(j = 0; j < n; j++)if (parent[j] !== -1) colcount[parent[j]] += colcount[j];
        return colcount;
    };
});

});
parcelRegister("6ajNw", function(module, exports) {

$parcel$export(module.exports, "csLeaf", () => $47d308a977f49967$export$e5adc9884f74ac27);
/**
 * This function determines if j is a leaf of the ith row subtree.
 * Consider A(i,j), node j in ith row subtree and return lca(jprev,j)
 *
 * @param {Number}  i               The ith row subtree
 * @param {Number}  j               The node to test
 * @param {Array}   w               The workspace array
 * @param {Number}  first           The index offset within the workspace for the first array
 * @param {Number}  maxfirst        The index offset within the workspace for the maxfirst array
 * @param {Number}  prevleaf        The index offset within the workspace for the prevleaf array
 * @param {Number}  ancestor        The index offset within the workspace for the ancestor array
 *
 * @return {Object}
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $47d308a977f49967$export$e5adc9884f74ac27(i, j, w, first, maxfirst, prevleaf, ancestor) {
    var s, sparent; // our result
    var jleaf = 0;
    var q; // check j is a leaf
    if (i <= j || w[first + j] <= w[maxfirst + i]) return -1;
     // update max first[j] seen so far
    w[maxfirst + i] = w[first + j]; // jprev = previous leaf of ith subtree
    var jprev = w[prevleaf + i];
    w[prevleaf + i] = j; // check j is first or subsequent leaf
    if (jprev === -1) {
        // 1st leaf, q = root of ith subtree
        jleaf = 1;
        q = i;
    } else {
        // update jleaf
        jleaf = 2; // q = least common ancester (jprev,j)
        for(q = jprev; q !== w[ancestor + q]; q = w[ancestor + q]);
        for(s = jprev; s !== q; s = sparent){
            // path compression
            sparent = w[ancestor + s];
            w[ancestor + s] = q;
        }
    }
    return {
        jleaf: jleaf,
        q: q
    };
}

});



parcelRegister("iJWPN", function(module, exports) {

$parcel$export(module.exports, "createCsLu", () => $da4a113ffacde97b$export$5487b5fadeacd2f6);

var $4eE2e = parcelRequire("4eE2e");

var $eQuHN = parcelRequire("eQuHN");
var $da4a113ffacde97b$var$name = 'csLu';
var $da4a113ffacde97b$var$dependencies = [
    'abs',
    'divideScalar',
    'multiply',
    'subtract',
    'larger',
    'largerEq',
    'SparseMatrix'
];
var $da4a113ffacde97b$export$5487b5fadeacd2f6 = /* #__PURE__ */ (0, $4eE2e.factory)($da4a113ffacde97b$var$name, $da4a113ffacde97b$var$dependencies, (_ref)=>{
    var { abs: abs, divideScalar: divideScalar, multiply: multiply, subtract: subtract, larger: larger, largerEq: largerEq, SparseMatrix: SparseMatrix } = _ref;
    var csSpsolve = (0, $eQuHN.createCsSpsolve)({
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract
    });
    /**
   * Computes the numeric LU factorization of the sparse matrix A. Implements a Left-looking LU factorization
   * algorithm that computes L and U one column at a tume. At the kth step, it access columns 1 to k-1 of L
   * and column k of A. Given the fill-reducing column ordering q (see parameter s) computes L, U and pinv so
   * L * U = A(p, q), where p is the inverse of pinv.
   *
   * @param {Matrix}  m               The A Matrix to factorize
   * @param {Object}  s               The symbolic analysis from csSqr(). Provides the fill-reducing
   *                                  column ordering q
   * @param {Number}  tol             Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Number}                 The numeric LU factorization of A or null
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csLu(m, s, tol) {
        // validate input
        if (!m) return null;
         // m arrays
        var size = m._size; // columns
        var n = size[1]; // symbolic analysis result
        var q;
        var lnz = 100;
        var unz = 100; // update symbolic analysis parameters
        if (s) {
            q = s.q;
            lnz = s.lnz || lnz;
            unz = s.unz || unz;
        } // L arrays
        var lvalues = []; // (lnz)
        var lindex = []; // (lnz)
        var lptr = []; // (n + 1)
        // L
        var L = new SparseMatrix({
            values: lvalues,
            index: lindex,
            ptr: lptr,
            size: [
                n,
                n
            ]
        }); // U arrays
        var uvalues = []; // (unz)
        var uindex = []; // (unz)
        var uptr = []; // (n + 1)
        // U
        var U = new SparseMatrix({
            values: uvalues,
            index: uindex,
            ptr: uptr,
            size: [
                n,
                n
            ]
        }); // inverse of permutation vector
        var pinv = []; // (n)
        // vars
        var i, p; // allocate arrays
        var x = []; // (n)
        var xi = []; // (2 * n)
        // initialize variables
        for(i = 0; i < n; i++){
            // clear workspace
            x[i] = 0; // no rows pivotal yet
            pinv[i] = -1; // no cols of L yet
            lptr[i + 1] = 0;
        } // reset number of nonzero elements in L and U
        lnz = 0;
        unz = 0; // compute L(:,k) and U(:,k)
        for(var k = 0; k < n; k++){
            // update ptr
            lptr[k] = lnz;
            uptr[k] = unz; // apply column permutations if needed
            var col = q ? q[k] : k; // solve triangular system, x = L\A(:,col)
            var top = csSpsolve(L, m, col, xi, x, pinv, 1); // find pivot
            var ipiv = -1;
            var a = -1; // loop xi[] from top -> n
            for(p = top; p < n; p++){
                // x[i] is nonzero
                i = xi[p]; // check row i is not yet pivotal
                if (pinv[i] < 0) {
                    // absolute value of x[i]
                    var xabs = abs(x[i]); // check absoulte value is greater than pivot value
                    if (larger(xabs, a)) {
                        // largest pivot candidate so far
                        a = xabs;
                        ipiv = i;
                    }
                } else {
                    // x(i) is the entry U(pinv[i],k)
                    uindex[unz] = pinv[i];
                    uvalues[unz++] = x[i];
                }
            } // validate we found a valid pivot
            if (ipiv === -1 || a <= 0) return null;
             // update actual pivot column, give preference to diagonal value
            if (pinv[col] < 0 && largerEq(abs(x[col]), multiply(a, tol))) ipiv = col;
             // the chosen pivot
            var pivot = x[ipiv]; // last entry in U(:,k) is U(k,k)
            uindex[unz] = k;
            uvalues[unz++] = pivot; // ipiv is the kth pivot row
            pinv[ipiv] = k; // first entry in L(:,k) is L(k,k) = 1
            lindex[lnz] = ipiv;
            lvalues[lnz++] = 1; // L(k+1:n,k) = x / pivot
            for(p = top; p < n; p++){
                // row
                i = xi[p]; // check x(i) is an entry in L(:,k)
                if (pinv[i] < 0) {
                    // save unpermuted row in L
                    lindex[lnz] = i; // scale pivot column
                    lvalues[lnz++] = divideScalar(x[i], pivot);
                } // x[0..n-1] = 0 for next k
                x[i] = 0;
            }
        } // update ptr
        lptr[n] = lnz;
        uptr[n] = unz; // fix row indices of L for final pinv
        for(p = 0; p < lnz; p++)lindex[p] = pinv[lindex[p]];
         // trim arrays
        lvalues.splice(lnz, lvalues.length - lnz);
        lindex.splice(lnz, lindex.length - lnz);
        uvalues.splice(unz, uvalues.length - unz);
        uindex.splice(unz, uindex.length - unz); // return LU factor
        return {
            L: L,
            U: U,
            pinv: pinv
        };
    };
});

});
parcelRegister("eQuHN", function(module, exports) {

$parcel$export(module.exports, "createCsSpsolve", () => $acedbd720346a108$export$517933164557054f);

var $8ovti = parcelRequire("8ovti");

var $4eE2e = parcelRequire("4eE2e");
var $acedbd720346a108$var$name = 'csSpsolve';
var $acedbd720346a108$var$dependencies = [
    'divideScalar',
    'multiply',
    'subtract'
];
var $acedbd720346a108$export$517933164557054f = /* #__PURE__ */ (0, $4eE2e.factory)($acedbd720346a108$var$name, $acedbd720346a108$var$dependencies, (_ref)=>{
    var { divideScalar: divideScalar, multiply: multiply, subtract: subtract } = _ref;
    /**
   * The function csSpsolve() computes the solution to G * x = bk, where bk is the
   * kth column of B. When lo is true, the function assumes G = L is lower triangular with the
   * diagonal entry as the first entry in each column. When lo is true, the function assumes G = U
   * is upper triangular with the diagonal entry as the last entry in each column.
   *
   * @param {Matrix}  g               The G matrix
   * @param {Matrix}  b               The B matrix
   * @param {Number}  k               The kth column in B
   * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
   *                                  The first n entries is the nonzero pattern, the last n entries is the stack
   * @param {Array}   x               The soluton to the linear system G * x = b
   * @param {Array}   pinv            The inverse row permutation vector, must be null for L * x = b
   * @param {boolean} lo              The lower (true) upper triangular (false) flag
   *
   * @return {Number}                 The index for the nonzero pattern
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csSpsolve(g, b, k, xi, x, pinv, lo) {
        // g arrays
        var gvalues = g._values;
        var gindex = g._index;
        var gptr = g._ptr;
        var gsize = g._size; // columns
        var n = gsize[1]; // b arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr; // vars
        var p, p0, p1, q; // xi[top..n-1] = csReach(B(:,k))
        var top = (0, $8ovti.csReach)(g, b, k, xi, pinv); // clear x
        for(p = top; p < n; p++)x[xi[p]] = 0;
         // scatter b
        for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++)x[bindex[p]] = bvalues[p];
         // loop columns
        for(var px = top; px < n; px++){
            // x array index for px
            var j = xi[px]; // apply permutation vector (U x = b), j maps to column J of G
            var J = pinv ? pinv[j] : j; // check column J is empty
            if (J < 0) continue;
             // column value indeces in G, p0 <= p < p1
            p0 = gptr[J];
            p1 = gptr[J + 1]; // x(j) /= G(j,j)
            x[j] = divideScalar(x[j], gvalues[lo ? p0 : p1 - 1]); // first entry L(j,j)
            p = lo ? p0 + 1 : p0;
            q = lo ? p1 : p1 - 1; // loop
            for(; p < q; p++){
                // row
                var i = gindex[p]; // x(i) -= G(i,j) * x(j)
                x[i] = subtract(x[i], multiply(gvalues[p], x[j]));
            }
        } // return top of stack
        return top;
    };
});

});
parcelRegister("8ovti", function(module, exports) {

$parcel$export(module.exports, "csReach", () => $61c8fa38faf798e5$export$125cefbcd149ec98);

var $9Ljwh = parcelRequire("9Ljwh");

var $e82F8 = parcelRequire("e82F8");

var $9n5pp = parcelRequire("9n5pp");
function $61c8fa38faf798e5$export$125cefbcd149ec98(g, b, k, xi, pinv) {
    // g arrays
    var gptr = g._ptr;
    var gsize = g._size; // b arrays
    var bindex = b._index;
    var bptr = b._ptr; // columns
    var n = gsize[1]; // vars
    var p, p0, p1; // initialize top
    var top = n; // loop column indeces in B
    for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++){
        // node i
        var i = bindex[p]; // check node i is marked
        if (!(0, $9Ljwh.csMarked)(gptr, i)) // start a dfs at unmarked node i
        top = (0, $9n5pp.csDfs)(i, g, top, xi, pinv);
    } // loop columns from top -> n - 1
    for(p = top; p < n; p++)// restore G
    (0, $e82F8.csMark)(gptr, xi[p]);
    return top;
}

});
parcelRegister("9Ljwh", function(module, exports) {

$parcel$export(module.exports, "csMarked", () => $71b7a50af38b2da8$export$f0d640c1b5bfa3e);
/**
 * Checks if the node at w[j] is marked
 *
 * @param {Array}   w               The array
 * @param {Number}  j               The array index
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $71b7a50af38b2da8$export$f0d640c1b5bfa3e(w, j) {
    // check node is marked
    return w[j] < 0;
}

});

parcelRegister("e82F8", function(module, exports) {

$parcel$export(module.exports, "csMark", () => $a493e0c2107c4a77$export$53b20e7656f0b914);

var $3UFSI = parcelRequire("3UFSI");
function $a493e0c2107c4a77$export$53b20e7656f0b914(w, j) {
    // mark w[j]
    w[j] = (0, $3UFSI.csFlip)(w[j]);
}

});

parcelRegister("9n5pp", function(module, exports) {

$parcel$export(module.exports, "csDfs", () => $6d2a7522d054b323$export$c913fe476af3832b);

var $9Ljwh = parcelRequire("9Ljwh");

var $e82F8 = parcelRequire("e82F8");

var $gM9UW = parcelRequire("gM9UW");
function $6d2a7522d054b323$export$c913fe476af3832b(j, g, top, xi, pinv) {
    // g arrays
    var index = g._index;
    var ptr = g._ptr;
    var size = g._size; // columns
    var n = size[1]; // vars
    var i, p, p2; // initialize head
    var head = 0; // initialize the recursion stack
    xi[0] = j; // loop
    while(head >= 0){
        // get j from the top of the recursion stack
        j = xi[head]; // apply permutation vector
        var jnew = pinv ? pinv[j] : j; // check node j is marked
        if (!(0, $9Ljwh.csMarked)(ptr, j)) {
            // mark node j as visited
            (0, $e82F8.csMark)(ptr, j); // update stack (last n entries in xi)
            xi[n + head] = jnew < 0 ? 0 : (0, $gM9UW.csUnflip)(ptr[jnew]);
        } // node j done if no unvisited neighbors
        var done = 1; // examine all neighbors of j, stack (last n entries in xi)
        for(p = xi[n + head], p2 = jnew < 0 ? 0 : (0, $gM9UW.csUnflip)(ptr[jnew + 1]); p < p2; p++){
            // consider neighbor node i
            i = index[p]; // check we have visited node i, skip it
            if ((0, $9Ljwh.csMarked)(ptr, i)) continue;
             // pause depth-first search of node j, update stack (last n entries in xi)
            xi[n + head] = p; // start dfs at node i
            xi[++head] = i; // node j is not done
            done = 0; // break, to start dfs(i)
            break;
        } // check depth-first search at node j is done
        if (done) {
            // remove j from the recursion stack
            head--; // and place in the output stack
            xi[--top] = j;
        }
    }
    return top;
}

});
parcelRegister("gM9UW", function(module, exports) {

$parcel$export(module.exports, "csUnflip", () => $c368d26ef955de0a$export$8b1bf205e2e76d92);

var $3UFSI = parcelRequire("3UFSI");
function $c368d26ef955de0a$export$8b1bf205e2e76d92(i) {
    // flip the value if it is negative
    return i < 0 ? (0, $3UFSI.csFlip)(i) : i;
}

});






parcelRegister("gwdP6", function(module, exports) {

$parcel$export(module.exports, "createSmaller", () => $c06a5b7ed8853c68$export$6b477d90b957f03e);

var $iV3Fc = parcelRequire("iV3Fc");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");

var $6MKpt = parcelRequire("6MKpt");

var $ai5Sw = parcelRequire("ai5Sw");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $laEuG = parcelRequire("laEuG");

var $KKjvJ = parcelRequire("KKjvJ");
var $c06a5b7ed8853c68$var$name = 'smaller';
var $c06a5b7ed8853c68$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'DenseMatrix'
];
var $c06a5b7ed8853c68$export$6b477d90b957f03e = /* #__PURE__ */ (0, $4eE2e.factory)($c06a5b7ed8853c68$var$name, $c06a5b7ed8853c68$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $ai5Sw.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether value x is smaller than y.
   *
   * The function returns true when x is smaller than y and the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smaller(x, y)
   *
   * Examples:
   *
   *    math.smaller(2, 3)            // returns true
   *    math.smaller(5, 2 * 2)        // returns false
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.smaller(a, b)            // returns true
   *
   * See also:
   *
   *    equal, unequal, smallerEq, smaller, smallerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ return typed($c06a5b7ed8853c68$var$name, {
        'boolean, boolean': function booleanBoolean(x, y) {
            return x < y;
        },
        'number, number': function numberNumber(x, y) {
            return x < y && !(0, $6egKm.nearlyEqual)(x, y, config.epsilon);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.lt(y) && !(0, $iV3Fc.nearlyEqual)(x, y, config.epsilon);
        },
        'Fraction, Fraction': function FractionFraction(x, y) {
            return x.compare(y) === -1;
        },
        'Complex, Complex': function ComplexComplex(x, y) {
            throw new TypeError('No ordering relation is defined for complex numbers');
        },
        'Unit, Unit': function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error('Cannot compare units with different base');
            return this(x.value, y.value);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $c06a5b7ed8853c68$export$4f82e7db4d803209 = /* #__PURE__ */ (0, $4eE2e.factory)($c06a5b7ed8853c68$var$name, [
    'typed',
    'config'
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($c06a5b7ed8853c68$var$name, {
        'number, number': function numberNumber(x, y) {
            return x < y && !(0, $6egKm.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});

parcelRegister("3QcS2", function(module, exports) {

$parcel$export(module.exports, "createSmallerEq", () => $2cc0363bed4ca31f$export$e1b2fff975be9083);

var $iV3Fc = parcelRequire("iV3Fc");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");

var $6MKpt = parcelRequire("6MKpt");

var $ai5Sw = parcelRequire("ai5Sw");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $laEuG = parcelRequire("laEuG");

var $KKjvJ = parcelRequire("KKjvJ");
var $2cc0363bed4ca31f$var$name = 'smallerEq';
var $2cc0363bed4ca31f$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'DenseMatrix'
];
var $2cc0363bed4ca31f$export$e1b2fff975be9083 = /* #__PURE__ */ (0, $4eE2e.factory)($2cc0363bed4ca31f$var$name, $2cc0363bed4ca31f$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $ai5Sw.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether value x is smaller or equal to y.
   *
   * The function returns true when x is smaller than y or the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smallerEq(x, y)
   *
   * Examples:
   *
   *    math.smaller(1 + 2, 3)        // returns false
   *    math.smallerEq(1 + 2, 3)      // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, larger, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ return typed($2cc0363bed4ca31f$var$name, {
        'boolean, boolean': function booleanBoolean(x, y) {
            return x <= y;
        },
        'number, number': function numberNumber(x, y) {
            return x <= y || (0, $6egKm.nearlyEqual)(x, y, config.epsilon);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.lte(y) || (0, $iV3Fc.nearlyEqual)(x, y, config.epsilon);
        },
        'Fraction, Fraction': function FractionFraction(x, y) {
            return x.compare(y) !== 1;
        },
        'Complex, Complex': function ComplexComplex() {
            throw new TypeError('No ordering relation is defined for complex numbers');
        },
        'Unit, Unit': function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error('Cannot compare units with different base');
            return this(x.value, y.value);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $2cc0363bed4ca31f$export$78c24428429985da = /* #__PURE__ */ (0, $4eE2e.factory)($2cc0363bed4ca31f$var$name, [
    'typed',
    'config'
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($2cc0363bed4ca31f$var$name, {
        'number, number': function numberNumber(x, y) {
            return x <= y || (0, $6egKm.nearlyEqual)(x, y, config.epsilon);
        }
    });
});

});

parcelRegister("eAKdZ", function(module, exports) {

$parcel$export(module.exports, "createSort", () => $a9f848b8d42527dd$export$10463693a2093403);

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $a9f848b8d42527dd$var$name = 'sort';
var $a9f848b8d42527dd$var$dependencies = [
    'typed',
    'matrix',
    'compare',
    'compareNatural'
];
var $a9f848b8d42527dd$export$10463693a2093403 = /* #__PURE__ */ (0, $4eE2e.factory)($a9f848b8d42527dd$var$name, $a9f848b8d42527dd$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, compare: compare, compareNatural: compareNatural } = _ref;
    var compareAsc = compare;
    var compareDesc = (a, b)=>-compare(a, b);
    /**
   * Sort the items in a matrix.
   *
   * Syntax:
   *
   *    math.sort(x)
   *    math.sort(x, compare)
   *
   * Examples:
   *
   *    math.sort([5, 10, 1]) // returns [1, 5, 10]
   *    math.sort(['C', 'B', 'A', 'D'], math.compareNatural)
   *    // returns ['A', 'B', 'C', 'D']
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.sort(['Langdon', 'Tom', 'Sara'], sortByLength)
   *    // returns ['Tom', 'Sara', 'Langdon']
   *
   * See also:
   *
   *    filter, forEach, map, compare, compareNatural
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Function | 'asc' | 'desc' | 'natural'} [compare='asc']
   *        An optional _comparator function or name. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {Matrix | Array} Returns the sorted matrix.
   */ return typed($a9f848b8d42527dd$var$name, {
        Array: function Array(x) {
            _arrayIsVector(x);
            return x.sort(compareAsc);
        },
        Matrix: function Matrix(x) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(compareAsc), x.storage());
        },
        'Array, function': function ArrayFunction(x, _comparator) {
            _arrayIsVector(x);
            return x.sort(_comparator);
        },
        'Matrix, function': function MatrixFunction(x, _comparator) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator), x.storage());
        },
        'Array, string': function ArrayString(x, order) {
            _arrayIsVector(x);
            return x.sort(_comparator(order));
        },
        'Matrix, string': function MatrixString(x, order) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator(order)), x.storage());
        }
    });
    /**
   * Get the comparator for given order ('asc', 'desc', 'natural')
   * @param {'asc' | 'desc' | 'natural'} order
   * @return {Function} Returns a _comparator function
   */ function _comparator(order) {
        if (order === 'asc') return compareAsc;
        else if (order === 'desc') return compareDesc;
        else if (order === 'natural') return compareNatural;
        else throw new Error('String "asc", "desc", or "natural" expected');
    }
    /**
   * Validate whether an array is one dimensional
   * Throws an error when this is not the case
   * @param {Array} array
   * @private
   */ function _arrayIsVector(array) {
        if ((0, $10UPF.arraySize)(array).length !== 1) throw new Error('One dimensional array expected');
    }
    /**
   * Validate whether a matrix is one dimensional
   * Throws an error when this is not the case
   * @param {Matrix} matrix
   * @private
   */ function _matrixIsVector(matrix) {
        if (matrix.size().length !== 1) throw new Error('One dimensional matrix expected');
    }
});

});

parcelRegister("8pEqa", function(module, exports) {

$parcel$export(module.exports, "createSpaClass", () => $6200034e42a3f9dd$export$5e37e847685a0540);

var $4eE2e = parcelRequire("4eE2e");
var $6200034e42a3f9dd$var$name = 'Spa';
var $6200034e42a3f9dd$var$dependencies = [
    'addScalar',
    'equalScalar',
    'FibonacciHeap'
];
var $6200034e42a3f9dd$export$5e37e847685a0540 = /* #__PURE__ */ (0, $4eE2e.factory)($6200034e42a3f9dd$var$name, $6200034e42a3f9dd$var$dependencies, (_ref)=>{
    var { addScalar: addScalar, equalScalar: equalScalar, FibonacciHeap: FibonacciHeap } = _ref;
    /**
   * An ordered Sparse Accumulator is a representation for a sparse vector that includes a dense array
   * of the vector elements and an ordered list of non-zero elements.
   */ function Spa() {
        if (!(this instanceof Spa)) throw new SyntaxError('Constructor must be called with the new operator');
         // allocate vector, TODO use typed arrays
        this._values = [];
        this._heap = new FibonacciHeap();
    }
    /**
   * Attach type information
   */ Spa.prototype.type = 'Spa';
    Spa.prototype.isSpa = true;
    /**
   * Set the value for index i.
   *
   * @param {number} i                       The index
   * @param {number | BigNumber | Complex}   The value at index i
   */ Spa.prototype.set = function(i, v) {
        // check we have a value @ i
        if (!this._values[i]) {
            // insert in heap
            var node = this._heap.insert(i, v); // set the value @ i
            this._values[i] = node;
        } else // update the value @ i
        this._values[i].value = v;
    };
    Spa.prototype.get = function(i) {
        var node = this._values[i];
        if (node) return node.value;
        return 0;
    };
    Spa.prototype.accumulate = function(i, v) {
        // node @ i
        var node = this._values[i];
        if (!node) {
            // insert in heap
            node = this._heap.insert(i, v); // initialize value
            this._values[i] = node;
        } else // accumulate value
        node.value = addScalar(node.value, v);
    };
    Spa.prototype.forEach = function(from, to, callback) {
        // references
        var heap = this._heap;
        var values = this._values; // nodes
        var nodes = []; // node with minimum key, save it
        var node = heap.extractMinimum();
        if (node) nodes.push(node);
         // extract nodes from heap (ordered)
        while(node && node.key <= to){
            // check it is in range
            if (node.key >= from) // check value is not zero
            {
                if (!equalScalar(node.value, 0)) // invoke callback
                callback(node.key, node.value, this);
            } // extract next node, save it
            node = heap.extractMinimum();
            if (node) nodes.push(node);
        } // reinsert all nodes in heap
        for(var i = 0; i < nodes.length; i++){
            // current node
            var n = nodes[i]; // insert node in heap
            node = heap.insert(n.key, n.value); // update values
            values[node.key] = node;
        }
    };
    Spa.prototype.swap = function(i, j) {
        // node @ i and j
        var nodei = this._values[i];
        var nodej = this._values[j]; // check we need to insert indeces
        if (!nodei && nodej) {
            // insert in heap
            nodei = this._heap.insert(i, nodej.value); // remove from heap
            this._heap.remove(nodej); // set values
            this._values[i] = nodei;
            this._values[j] = undefined;
        } else if (nodei && !nodej) {
            // insert in heap
            nodej = this._heap.insert(j, nodei.value); // remove from heap
            this._heap.remove(nodei); // set values
            this._values[j] = nodej;
            this._values[i] = undefined;
        } else if (nodei && nodej) {
            // swap values
            var v = nodei.value;
            nodei.value = nodej.value;
            nodej.value = v;
        }
    };
    return Spa;
}, {
    isClass: true
});

});

parcelRegister("cqKSJ", function(module, exports) {

$parcel$export(module.exports, "createSparse", () => $90cc477c226c8236$export$89ff03fdb3964a99);

var $4eE2e = parcelRequire("4eE2e");
var $90cc477c226c8236$var$name = 'sparse';
var $90cc477c226c8236$var$dependencies = [
    'typed',
    'SparseMatrix'
];
var $90cc477c226c8236$export$89ff03fdb3964a99 = /* #__PURE__ */ (0, $4eE2e.factory)($90cc477c226c8236$var$name, $90cc477c226c8236$var$dependencies, (_ref)=>{
    var { typed: typed, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a Sparse Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   *
   * Syntax:
   *
   *    math.sparse()               // creates an empty sparse matrix.
   *    math.sparse(data)           // creates a sparse matrix with initial data.
   *    math.sparse(data, 'number') // creates a sparse matrix with initial data, number datatype.
   *
   * Examples:
   *
   *    let m = math.sparse([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, matrix
   *
   * @param {Array | Matrix} [data]    A two dimensional array
   *
   * @return {Matrix} The created matrix
   */ return typed($90cc477c226c8236$var$name, {
        '': function _() {
            return new SparseMatrix([]);
        },
        string: function string(datatype) {
            return new SparseMatrix([], datatype);
        },
        'Array | Matrix': function ArrayMatrix(data) {
            return new SparseMatrix(data);
        },
        'Array | Matrix, string': function ArrayMatrixString(data, datatype) {
            return new SparseMatrix(data, datatype);
        }
    });
});

});

parcelRegister("isiu0", function(module, exports) {

$parcel$export(module.exports, "createSparseMatrixClass", () => $d6f92dddb5fddc42$export$a783ce8f6a98b2e5);

var $gs7TF = parcelRequire("gs7TF");

var $6egKm = parcelRequire("6egKm");

var $aEppI = parcelRequire("aEppI");

var $4mYv9 = parcelRequire("4mYv9");

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");

var $iAoVB = parcelRequire("iAoVB");
var $d6f92dddb5fddc42$var$name = 'SparseMatrix';
var $d6f92dddb5fddc42$var$dependencies = [
    'typed',
    'equalScalar',
    'Matrix'
];
var $d6f92dddb5fddc42$export$a783ce8f6a98b2e5 = /* #__PURE__ */ (0, $4eE2e.factory)($d6f92dddb5fddc42$var$name, $d6f92dddb5fddc42$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar, Matrix: Matrix } = _ref;
    /**
   * Sparse Matrix implementation. This type implements
   * a [Compressed Column Storage](https://en.wikipedia.org/wiki/Sparse_matrix#Compressed_sparse_column_(CSC_or_CCS))
   * format for two-dimensional sparse matrices.
   * @class SparseMatrix
   */ function SparseMatrix(data, datatype) {
        if (!(this instanceof SparseMatrix)) throw new SyntaxError('Constructor must be called with the new operator');
        if (datatype && !(0, $gs7TF.isString)(datatype)) throw new Error('Invalid datatype: ' + datatype);
        if ((0, $gs7TF.isMatrix)(data)) // create from matrix
        _createFromMatrix(this, data, datatype);
        else if (data && (0, $gs7TF.isArray)(data.index) && (0, $gs7TF.isArray)(data.ptr) && (0, $gs7TF.isArray)(data.size)) {
            // initialize fields
            this._values = data.values;
            this._index = data.index;
            this._ptr = data.ptr;
            this._size = data.size;
            this._datatype = datatype || data.datatype;
        } else if ((0, $gs7TF.isArray)(data)) // create from array
        _createFromArray(this, data, datatype);
        else if (data) // unsupported type
        throw new TypeError('Unsupported type of data (' + (0, $gs7TF.typeOf)(data) + ')');
        else {
            // nothing provided
            this._values = [];
            this._index = [];
            this._ptr = [
                0
            ];
            this._size = [
                0,
                0
            ];
            this._datatype = datatype;
        }
    }
    function _createFromMatrix(matrix, source, datatype) {
        // check matrix type
        if (source.type === 'SparseMatrix') {
            // clone arrays
            matrix._values = source._values ? (0, $4mYv9.clone)(source._values) : undefined;
            matrix._index = (0, $4mYv9.clone)(source._index);
            matrix._ptr = (0, $4mYv9.clone)(source._ptr);
            matrix._size = (0, $4mYv9.clone)(source._size);
            matrix._datatype = datatype || source._datatype;
        } else // build from matrix data
        _createFromArray(matrix, source.valueOf(), datatype || source._datatype);
    }
    function _createFromArray(matrix, data, datatype) {
        // initialize fields
        matrix._values = [];
        matrix._index = [];
        matrix._ptr = [];
        matrix._datatype = datatype; // discover rows & columns, do not use math.size() to avoid looping array twice
        var rows = data.length;
        var columns = 0; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $gs7TF.isString)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        } // check we have rows (empty array)
        if (rows > 0) {
            // column index
            var j = 0;
            do {
                // store pointer to values index
                matrix._ptr.push(matrix._index.length); // loop rows
                for(var i = 0; i < rows; i++){
                    // current row
                    var row = data[i]; // check row is an array
                    if ((0, $gs7TF.isArray)(row)) {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < row.length) columns = row.length;
                         // check row has column
                        if (j < row.length) {
                            // value
                            var v = row[j]; // check value != 0
                            if (!eq(v, zero)) {
                                // store value
                                matrix._values.push(v); // index
                                matrix._index.push(i);
                            }
                        }
                    } else {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < 1) columns = 1;
                         // check value != 0 (row is a scalar)
                        if (!eq(row, zero)) {
                            // store value
                            matrix._values.push(row); // index
                            matrix._index.push(i);
                        }
                    }
                } // increment index
                j++;
            }while (j < columns);
        } // store number of values in ptr
        matrix._ptr.push(matrix._index.length); // size
        matrix._size = [
            rows,
            columns
        ];
    }
    SparseMatrix.prototype = new Matrix();
    /**
   * Create a new SparseMatrix
   */ SparseMatrix.prototype.createSparseMatrix = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ SparseMatrix.prototype.type = 'SparseMatrix';
    SparseMatrix.prototype.isSparseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf SparseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ SparseMatrix.prototype.getDataType = function() {
        return (0, $10UPF.getArrayDataType)(this._values, (0, $gs7TF.typeOf));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @memberof SparseMatrix
   * @return {string}           The storage format.
   */ SparseMatrix.prototype.storage = function() {
        return 'sparse';
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @memberof SparseMatrix
   * @return {string}           The datatype.
   */ SparseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new SparseMatrix
   * @memberof SparseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ SparseMatrix.prototype.create = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Get the matrix density.
   *
   * Usage:
   *     const density = matrix.density()                   // retrieve matrix density
   *
   * @memberof SparseMatrix
   * @return {number}           The matrix density.
   */ SparseMatrix.prototype.density = function() {
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // calculate density
        return rows !== 0 && columns !== 0 ? this._index.length / (rows * columns) : 0;
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof SparseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ SparseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        // check it is a pattern matrix
        if (!this._values) throw new Error('Cannot invoke subset on a Pattern only matrix');
         // check arguments
        switch(arguments.length){
            case 1:
                return _getsubset(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _setsubset(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError('Wrong number of arguments');
        }
    };
    function _getsubset(matrix, idx) {
        // check idx
        if (!(0, $gs7TF.isIndex)(idx)) throw new TypeError('Invalid index');
        var isScalar = idx.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(idx.min());
         // validate dimensions
        var size = idx.size();
        if (size.length !== matrix._size.length) throw new (0, $iAoVB.DimensionError)(size.length, matrix._size.length);
         // vars
        var i, ii, k, kk; // validate if any of the ranges in the index is out of range
        var min = idx.min();
        var max = idx.max();
        for(i = 0, ii = matrix._size.length; i < ii; i++){
            (0, $10UPF.validateIndex)(min[i], matrix._size[i]);
            (0, $10UPF.validateIndex)(max[i], matrix._size[i]);
        } // matrix arrays
        var mvalues = matrix._values;
        var mindex = matrix._index;
        var mptr = matrix._ptr; // rows & columns dimensions for result matrix
        var rows = idx.dimension(0);
        var columns = idx.dimension(1); // workspace & permutation vector
        var w = [];
        var pv = []; // loop rows in resulting matrix
        rows.forEach(function(i, r) {
            // update permutation vector
            pv[i] = r[0]; // mark i in workspace
            w[i] = true;
        }); // result matrix arrays
        var values = mvalues ? [] : undefined;
        var index = [];
        var ptr = []; // loop columns in result matrix
        columns.forEach(function(j) {
            // update ptr
            ptr.push(index.length); // loop values in column j
            for(k = mptr[j], kk = mptr[j + 1]; k < kk; k++){
                // row
                i = mindex[k]; // check row is in result matrix
                if (w[i] === true) {
                    // push index
                    index.push(pv[i]); // check we need to process values
                    if (values) values.push(mvalues[k]);
                }
            }
        }); // update ptr
        ptr.push(index.length); // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: size,
            datatype: matrix._datatype
        });
    }
    function _setsubset(matrix, index, submatrix, defaultValue) {
        // check index
        if (!index || index.isIndex !== true) throw new TypeError('Invalid index');
         // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar(); // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $gs7TF.isMatrix)(submatrix)) {
            // submatrix size
            sSize = submatrix.size(); // use array representation
            submatrix = submatrix.toArray();
        } else // get submatrix size (array, scalar)
        sSize = (0, $10UPF.arraySize)(submatrix);
         // check index is a scalar
        if (isScalar) {
            // verify submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError('Scalar expected');
             // set value
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // validate dimensions, index size must be one or two dimensions
            if (iSize.length !== 1 && iSize.length !== 2) throw new (0, $iAoVB.DimensionError)(iSize.length, matrix._size.length, '<');
             // check submatrix and index have the same dimensions
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                } // unsqueeze both outer and inner dimensions
                submatrix = (0, $10UPF.unsqueeze)(submatrix, iSize.length, outer, sSize);
            } // check whether the size of the submatrix matches the index size
            if (!(0, $4mYv9.deepStrictEqual)(iSize, sSize)) throw new (0, $iAoVB.DimensionError)(iSize, sSize, '>');
             // offsets
            var x0 = index.min()[0];
            var y0 = index.min()[1]; // submatrix rows and columns
            var m = sSize[0];
            var n = sSize[1]; // loop submatrix
            for(var x = 0; x < m; x++)// loop columns
            for(var y = 0; y < n; y++){
                // value at i, j
                var v = submatrix[x][y]; // invoke set (zero value will remove entry from matrix)
                matrix.set([
                    x + x0,
                    y + y0
                ], v, defaultValue);
            }
        }
        return matrix;
    }
    /**
   * Get a single element from the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ SparseMatrix.prototype.get = function(index) {
        if (!(0, $gs7TF.isArray)(index)) throw new TypeError('Array expected');
        if (index.length !== this._size.length) throw new (0, $iAoVB.DimensionError)(index.length, this._size.length);
         // check it is a pattern matrix
        if (!this._values) throw new Error('Cannot invoke get on a Pattern only matrix');
         // row and column
        var i = index[0];
        var j = index[1]; // check i, j are valid
        (0, $10UPF.validateIndex)(i, this._size[0]);
        (0, $10UPF.validateIndex)(j, this._size[1]); // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index); // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) return this._values[k];
        return 0;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} v
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be set to zero.
   * @return {SparseMatrix} self
   */ SparseMatrix.prototype.set = function(index, v, defaultValue) {
        if (!(0, $gs7TF.isArray)(index)) throw new TypeError('Array expected');
        if (index.length !== this._size.length) throw new (0, $iAoVB.DimensionError)(index.length, this._size.length);
         // check it is a pattern matrix
        if (!this._values) throw new Error('Cannot invoke set on a Pattern only matrix');
         // row and column
        var i = index[0];
        var j = index[1]; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $gs7TF.isString)(this._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                this._datatype,
                this._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, this._datatype);
        } // check we need to resize matrix
        if (i > rows - 1 || j > columns - 1) {
            // resize matrix
            _resize(this, Math.max(i + 1, rows), Math.max(j + 1, columns), defaultValue); // update rows & columns
            rows = this._size[0];
            columns = this._size[1];
        } // check i, j are valid
        (0, $10UPF.validateIndex)(i, rows);
        (0, $10UPF.validateIndex)(j, columns); // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index); // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) {
            // check value != 0
            if (!eq(v, zero)) // update value
            this._values[k] = v;
            else // remove value from matrix
            _remove(k, j, this._values, this._index, this._ptr);
        } else // insert value @ (i, j)
        _insert(k, i, j, v, this._values, this._index, this._ptr);
        return this;
    };
    function _getValueIndex(i, top, bottom, index) {
        // check row is on the bottom side
        if (bottom - top === 0) return bottom;
         // loop rows [top, bottom[
        for(var r = top; r < bottom; r++){
            // check we found value index
            if (index[r] === i) return r;
        } // we did not find row
        return top;
    }
    function _remove(k, j, values, index, ptr) {
        // remove value @ k
        values.splice(k, 1);
        index.splice(k, 1); // update pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]--;
    }
    function _insert(k, i, j, v, values, index, ptr) {
        // insert value
        values.splice(k, 0, v); // update row for k
        index.splice(k, 0, i); // update column pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]++;
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof SparseMatrix
   * @param {number[] | Matrix} size  The new size the matrix should have.
   *                                  Since sparse matrices are always two-dimensional,
   *                                  size must be two numbers in either an array or a matrix
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ SparseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $gs7TF.isCollection)(size)) throw new TypeError('Array or Matrix expected');
         // SparseMatrix input is always 2d, flatten this into 1d if it's indeed a vector
        var sizeArray = size.valueOf().map((value)=>{
            return Array.isArray(value) && value.length === 1 ? value[0] : value;
        });
        if (sizeArray.length !== 2) throw new Error('Only two dimensions matrix are supported');
         // check sizes
        sizeArray.forEach(function(value) {
            if (!(0, $gs7TF.isNumber)(value) || !(0, $6egKm.isInteger)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $aEppI.format)(sizeArray) + ')');
        }); // matrix to resize
        var m = copy ? this.clone() : this; // resize matrix
        return _resize(m, sizeArray[0], sizeArray[1], defaultValue);
    };
    function _resize(matrix, rows, columns, defaultValue) {
        // value to insert at the time of growing matrix
        var value = defaultValue || 0; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $gs7TF.isString)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype); // convert value to the same datatype
            value = typed.convert(value, matrix._datatype);
        } // should we insert the value?
        var ins = !eq(value, zero); // old columns and rows
        var r = matrix._size[0];
        var c = matrix._size[1];
        var i, j, k; // check we need to increase columns
        if (columns > c) {
            // loop new columns
            for(j = c; j < columns; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._values.length; // check we need to insert matrix._values
                if (ins) // loop rows
                for(i = 0; i < r; i++){
                    // add new matrix._values
                    matrix._values.push(value); // update matrix._index
                    matrix._index.push(i);
                }
            } // store number of matrix._values in matrix._ptr
            matrix._ptr[columns] = matrix._values.length;
        } else if (columns < c) {
            // truncate matrix._ptr
            matrix._ptr.splice(columns + 1, c - columns); // truncate matrix._values and matrix._index
            matrix._values.splice(matrix._ptr[columns], matrix._values.length);
            matrix._index.splice(matrix._ptr[columns], matrix._index.length);
        } // update columns
        c = columns; // check we need to increase rows
        if (rows > r) // check we have to insert values
        {
            if (ins) {
                // inserts
                var n = 0; // loop columns
                for(j = 0; j < c; j++){
                    // update matrix._ptr for current column
                    matrix._ptr[j] = matrix._ptr[j] + n; // where to insert matrix._values
                    k = matrix._ptr[j + 1] + n; // pointer
                    var p = 0; // loop new rows, initialize pointer
                    for(i = r; i < rows; i++, p++){
                        // add value
                        matrix._values.splice(k + p, 0, value); // update matrix._index
                        matrix._index.splice(k + p, 0, i); // increment inserts
                        n++;
                    }
                } // store number of matrix._values in matrix._ptr
                matrix._ptr[c] = matrix._values.length;
            }
        } else if (rows < r) {
            // deletes
            var d = 0; // loop columns
            for(j = 0; j < c; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._ptr[j] - d; // where matrix._values start for next column
                var k0 = matrix._ptr[j];
                var k1 = matrix._ptr[j + 1] - d; // loop matrix._index
                for(k = k0; k < k1; k++){
                    // row
                    i = matrix._index[k]; // check we need to delete value and matrix._index
                    if (i > rows - 1) {
                        // remove value
                        matrix._values.splice(k, 1); // remove item from matrix._index
                        matrix._index.splice(k, 1); // increase deletes
                        d++;
                    }
                }
            } // update matrix._ptr for current column
            matrix._ptr[j] = matrix._values.length;
        } // update matrix._size
        matrix._size[0] = rows;
        matrix._size[1] = columns; // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof SparseMatrix
   * @param {number[]} sizes          The new size the matrix should have.
   *                                  Since sparse matrices are always two-dimensional,
   *                                  size must be two numbers in either an array or a matrix
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ SparseMatrix.prototype.reshape = function(sizes, copy) {
        // validate arguments
        if (!(0, $gs7TF.isArray)(sizes)) throw new TypeError('Array expected');
        if (sizes.length !== 2) throw new Error('Sparse matrices can only be reshaped in two dimensions');
         // check sizes
        sizes.forEach(function(value) {
            if (!(0, $gs7TF.isNumber)(value) || !(0, $6egKm.isInteger)(value) || value <= -2 || value === 0) throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + (0, $aEppI.format)(sizes) + ')');
        });
        var currentLength = this._size[0] * this._size[1];
        sizes = (0, $10UPF.processSizesWildcard)(sizes, currentLength);
        var newLength = sizes[0] * sizes[1]; // m * n must not change
        if (currentLength !== newLength) throw new Error('Reshaping sparse matrix will result in the wrong number of elements');
         // matrix to reshape
        var m = copy ? this.clone() : this; // return unchanged if the same shape
        if (this._size[0] === sizes[0] && this._size[1] === sizes[1]) return m;
         // Convert to COO format (generate a column index)
        var colIndex = [];
        for(var i = 0; i < m._ptr.length; i++)for(var j = 0; j < m._ptr[i + 1] - m._ptr[i]; j++)colIndex.push(i);
         // Clone the values array
        var values = m._values.slice(); // Clone the row index array
        var rowIndex = m._index.slice(); // Transform the (row, column) indices
        for(var _i = 0; _i < m._index.length; _i++){
            var r1 = rowIndex[_i];
            var c1 = colIndex[_i];
            var flat = r1 * m._size[1] + c1;
            colIndex[_i] = flat % sizes[1];
            rowIndex[_i] = Math.floor(flat / sizes[1]);
        } // Now reshaping is supposed to preserve the row-major order, BUT these sparse matrices are stored
        // in column-major order, so we have to reorder the value array now. One option is to use a multisort,
        // sorting several arrays based on some other array.
        // OR, we could easily just:
        // 1. Remove all values from the matrix
        m._values.length = 0;
        m._index.length = 0;
        m._ptr.length = sizes[1] + 1;
        m._size = sizes.slice();
        for(var _i2 = 0; _i2 < m._ptr.length; _i2++)m._ptr[_i2] = 0;
         // 2. Re-insert all elements in the proper order (simplified code from SparseMatrix.prototype.set)
        // This step is probably the most time-consuming
        for(var h = 0; h < values.length; h++){
            var _i3 = rowIndex[h];
            var _j = colIndex[h];
            var v = values[h];
            var k = _getValueIndex(_i3, m._ptr[_j], m._ptr[_j + 1], m._index);
            _insert(k, _i3, _j, v, m._values, m._index, m._ptr);
        } // The value indices are inserted out of order, but apparently that's... still OK?
        return m;
    };
    /**
   * Create a clone of the matrix
   * @memberof SparseMatrix
   * @return {SparseMatrix} clone
   */ SparseMatrix.prototype.clone = function() {
        var m = new SparseMatrix({
            values: this._values ? (0, $4mYv9.clone)(this._values) : undefined,
            index: (0, $4mYv9.clone)(this._index),
            ptr: (0, $4mYv9.clone)(this._ptr),
            size: (0, $4mYv9.clone)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof SparseMatrix
   * @returns {number[]} size
   */ SparseMatrix.prototype.size = function() {
        return this._size.slice(0); // copy the Array
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {SparseMatrix} matrix
   */ SparseMatrix.prototype.map = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error('Cannot invoke map on a Pattern only matrix');
         // matrix instance
        var me = this; // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // invoke callback
        var invoke = function invoke(v, i, j) {
            // invoke callback
            return callback(v, [
                i,
                j
            ], me);
        }; // invoke _map
        return _map(this, 0, rows - 1, 0, columns - 1, invoke, skipZeros);
    };
    /**
   * Create a new matrix with the results of the callback function executed on the interval
   * [minRow..maxRow, minColumn..maxColumn].
   */ function _map(matrix, minRow, maxRow, minColumn, maxColumn, callback, skipZeros) {
        // result arrays
        var values = [];
        var index = [];
        var ptr = []; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $gs7TF.isString)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype);
        } // invoke callback
        var invoke = function invoke(v, x, y) {
            // invoke callback
            v = callback(v, x, y); // check value != 0
            if (!eq(v, zero)) {
                // store value
                values.push(v); // index
                index.push(x);
            }
        }; // loop columns
        for(var j = minColumn; j <= maxColumn; j++){
            // store pointer to values index
            ptr.push(values.length); // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = matrix._ptr[j];
            var k1 = matrix._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = matrix._index[k]; // check i is in range
                if (i >= minRow && i <= maxRow) // value @ k
                invoke(matrix._values[k], i - minRow, j - minColumn);
            }
            else {
                // create a cache holding all defined values
                var _values = {};
                for(var _k = k0; _k < k1; _k++){
                    var _i4 = matrix._index[_k];
                    _values[_i4] = matrix._values[_k];
                } // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i5 = minRow; _i5 <= maxRow; _i5++){
                    var value = _i5 in _values ? _values[_i5] : 0;
                    invoke(value, _i5 - minRow, j - minColumn);
                }
            }
        } // store number of values in ptr
        ptr.push(values.length); // return sparse matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                maxRow - minRow + 1,
                maxColumn - minColumn + 1
            ]
        });
    }
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *                              If false, the indices are guaranteed to be in order,
   *                              if true, the indices can be unordered.
   */ SparseMatrix.prototype.forEach = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error('Cannot invoke forEach on a Pattern only matrix');
         // matrix instance
        var me = this; // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k]; // value @ k
                callback(this._values[k], [
                    i,
                    j
                ], me);
            }
            else {
                // create a cache holding all defined values
                var values = {};
                for(var _k2 = k0; _k2 < k1; _k2++){
                    var _i6 = this._index[_k2];
                    values[_i6] = this._values[_k2];
                } // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i7 = 0; _i7 < rows; _i7++){
                    var value = _i7 in values ? values[_i7] : 0;
                    callback(value, [
                        _i7,
                        j
                    ], me);
                }
            }
        }
    };
    /**
   * Iterate over the matrix elements, skipping zeros
   * @return {Iterable<{ value, index: number[] }>}
   */ SparseMatrix.prototype[Symbol.iterator] = function*() {
        if (!this._values) throw new Error('Cannot iterate a Pattern only matrix');
        var columns = this._size[1];
        for(var j = 0; j < columns; j++){
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k];
                yield {
                    value: this._values[k],
                    index: [
                        i,
                        j
                    ]
                };
            }
        }
    };
    /**
   * Create an Array with a copy of the data of the SparseMatrix
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.toArray = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, true);
    };
    /**
   * Get the primitive value of the SparseMatrix: a two dimensions array
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.valueOf = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, false);
    };
    function _toArray(values, index, ptr, size, copy) {
        // rows and columns
        var rows = size[0];
        var columns = size[1]; // result
        var a = []; // vars
        var i, j; // initialize array
        for(i = 0; i < rows; i++){
            a[i] = [];
            for(j = 0; j < columns; j++)a[i][j] = 0;
        } // loop columns
        for(j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                i = index[k]; // set value (use one for pattern matrix)
                a[i][j] = values ? copy ? (0, $4mYv9.clone)(values[k]) : values[k] : 1;
            }
        }
        return a;
    }
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof SparseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ SparseMatrix.prototype.format = function(options) {
        // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // density
        var density = this.density(); // rows & columns
        var str = 'Sparse Matrix [' + (0, $aEppI.format)(rows, options) + ' x ' + (0, $aEppI.format)(columns, options) + '] density: ' + (0, $aEppI.format)(density, options) + '\n'; // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1]; // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k]; // append value
                str += '\n    (' + (0, $aEppI.format)(i, options) + ', ' + (0, $aEppI.format)(j, options) + ') ==> ' + (this._values ? (0, $aEppI.format)(this._values[k], options) : 'X');
            }
        }
        return str;
    };
    /**
   * Get a string representation of the matrix
   * @memberof SparseMatrix
   * @returns {string} str
   */ SparseMatrix.prototype.toString = function() {
        return (0, $aEppI.format)(this.toArray());
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof SparseMatrix
   * @returns {Object}
   */ SparseMatrix.prototype.toJSON = function() {
        return {
            mathjs: 'SparseMatrix',
            values: this._values,
            index: this._index,
            ptr: this._ptr,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof SparseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix vector with the diagonal values.
   */ SparseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $gs7TF.isBigNumber)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $gs7TF.isNumber)(k) || !(0, $6egKm.isInteger)(k)) throw new TypeError('The parameter k must be an integer number');
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper); // diagonal arrays
        var values = [];
        var index = [];
        var ptr = []; // initial ptr value
        ptr[0] = 0; // loop columns
        for(var j = kSuper; j < columns && values.length < n; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1]; // loop x within [k0, k1[
            for(var x = k0; x < k1; x++){
                // row index
                var i = this._index[x]; // check row
                if (i === j - kSuper + kSub) {
                    // value on this column
                    values.push(this._values[x]); // store row
                    index[values.length - 1] = i - kSub; // exit loop
                    break;
                }
            }
        } // close ptr
        ptr.push(values.length); // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                n,
                1
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof SparseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SparseMatrix", "values": [], "index": [], "ptr": [], "size": []}`,
   *                       where mathjs is optional
   * @returns {SparseMatrix}
   */ SparseMatrix.fromJSON = function(json) {
        return new SparseMatrix(json);
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof SparseMatrix
   * @param {Array} size                       The matrix size.
   * @param {number | Array | Matrix } value   The values for the diagonal.
   * @param {number | BigNumber} [k=0]         The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]            The default value for non-diagonal
   * @param {string} [datatype]                The Matrix datatype, values must be of this datatype.
   *
   * @returns {SparseMatrix}
   */ SparseMatrix.diagonal = function(size, value, k, defaultValue, datatype) {
        if (!(0, $gs7TF.isArray)(size)) throw new TypeError('Array expected, size parameter');
        if (size.length !== 2) throw new Error('Only two dimensions matrix are supported');
         // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $gs7TF.isBigNumber)(s)) // convert it
            s = s.toNumber();
             // validate arguments
            if (!(0, $gs7TF.isNumber)(s) || !(0, $6egKm.isInteger)(s) || s < 1) throw new Error('Size values must be positive integers');
            return s;
        }); // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $gs7TF.isBigNumber)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $gs7TF.isNumber)(k) || !(0, $6egKm.isInteger)(k)) throw new TypeError('The parameter k must be an integer number');
        } else // default value
        k = 0;
         // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $gs7TF.isString)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        }
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows and columns
        var rows = size[0];
        var columns = size[1]; // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper); // value extraction function
        var _value; // check value
        if ((0, $gs7TF.isArray)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error('Invalid value array length');
             // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $gs7TF.isMatrix)(value)) {
            // matrix size
            var ms = value.size(); // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error('Invalid matrix length');
             // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
         // create arrays
        var values = [];
        var index = [];
        var ptr = []; // loop items
        for(var j = 0; j < columns; j++){
            // number of rows with value
            ptr.push(values.length); // diagonal index
            var i = j - kSuper; // check we need to set diagonal value
            if (i >= 0 && i < n) {
                // get value @ i
                var v = _value(i); // check for zero
                if (!eq(v, zero)) {
                    // column
                    index.push(i + kSub); // add value
                    values.push(v);
                }
            }
        } // last value should be number of values
        ptr.push(values.length); // create SparseMatrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof SparseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ SparseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $gs7TF.isNumber)(i) || !(0, $6egKm.isInteger)(i) || !(0, $gs7TF.isNumber)(j) || !(0, $6egKm.isInteger)(j)) throw new Error('Row index must be positive integers');
         // check dimensions
        if (this._size.length !== 2) throw new Error('Only two dimensional matrix is supported');
         // validate index
        (0, $10UPF.validateIndex)(i, this._size[0]);
        (0, $10UPF.validateIndex)(j, this._size[0]); // swap rows
        SparseMatrix._swapRows(i, j, this._size[1], this._values, this._index, this._ptr); // return current instance
        return this;
    };
    /**
   * Loop rows with data in column j.
   *
   * @param {number} j            Column
   * @param {Array} values        Matrix values
   * @param {Array} index         Matrix row indeces
   * @param {Array} ptr           Matrix column pointers
   * @param {Function} callback   Callback function invoked for every row in column j
   */ SparseMatrix._forEachRow = function(j, values, index, ptr, callback) {
        // indeces for column j
        var k0 = ptr[j];
        var k1 = ptr[j + 1]; // loop
        for(var k = k0; k < k1; k++)// invoke callback
        callback(index[k], values[k]);
    };
    /**
   * Swap rows x and y in Sparse Matrix data structures.
   *
   * @param {number} x         Matrix row index 1
   * @param {number} y         Matrix row index 2
   * @param {number} columns   Number of columns in matrix
   * @param {Array} values     Matrix values
   * @param {Array} index      Matrix row indeces
   * @param {Array} ptr        Matrix column pointers
   */ SparseMatrix._swapRows = function(x, y, columns, values, index, ptr) {
        // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // find value index @ x
            var kx = _getValueIndex(x, k0, k1, index); // find value index @ x
            var ky = _getValueIndex(y, k0, k1, index); // check both rows exist in matrix
            if (kx < k1 && ky < k1 && index[kx] === x && index[ky] === y) {
                // swap values (check for pattern matrix)
                if (values) {
                    var v = values[kx];
                    values[kx] = values[ky];
                    values[ky] = v;
                } // next column
                continue;
            } // check x row exist & no y row
            if (kx < k1 && index[kx] === x && (ky >= k1 || index[ky] !== y)) {
                // value @ x (check for pattern matrix)
                var vx = values ? values[kx] : undefined; // insert value @ y
                index.splice(ky, 0, y);
                if (values) values.splice(ky, 0, vx);
                 // remove value @ x (adjust array index if needed)
                index.splice(ky <= kx ? kx + 1 : kx, 1);
                if (values) values.splice(ky <= kx ? kx + 1 : kx, 1);
                 // next column
                continue;
            } // check y row exist & no x row
            if (ky < k1 && index[ky] === y && (kx >= k1 || index[kx] !== x)) {
                // value @ y (check for pattern matrix)
                var vy = values ? values[ky] : undefined; // insert value @ x
                index.splice(kx, 0, x);
                if (values) values.splice(kx, 0, vy);
                 // remove value @ y (adjust array index if needed)
                index.splice(kx <= ky ? ky + 1 : ky, 1);
                if (values) values.splice(kx <= ky ? ky + 1 : ky, 1);
            }
        }
    };
    return SparseMatrix;
}, {
    isClass: true
});

});

parcelRegister("iQRUk", function(module, exports) {

$parcel$export(module.exports, "createSplitUnit", () => $db96e636a2033fd4$export$a9f61753ee14ea96);

var $4eE2e = parcelRequire("4eE2e");
var $db96e636a2033fd4$var$name = 'splitUnit';
var $db96e636a2033fd4$var$dependencies = [
    'typed'
];
var $db96e636a2033fd4$export$a9f61753ee14ea96 = /* #__PURE__ */ (0, $4eE2e.factory)($db96e636a2033fd4$var$name, $db96e636a2033fd4$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Split a unit in an array of units whose sum is equal to the original unit.
   *
   * Syntax:
   *
   *     splitUnit(unit: Unit, parts: Array.<Unit>)
   *
   * Example:
   *
   *     math.splitUnit(new Unit(1, 'm'), ['feet', 'inch'])
   *     // [ 3 feet, 3.3700787401575 inch ]
   *
   * See also:
   *
   *     unit
   *
   * @param {Array} [parts] An array of strings or valueless units.
   * @return {Array} An array of units.
   */ return typed($db96e636a2033fd4$var$name, {
        'Unit, Array': function UnitArray(unit, parts) {
            return unit.splitUnit(parts);
        }
    });
});

});

parcelRegister("kROJn", function(module, exports) {

$parcel$export(module.exports, "createSqrt", () => $f3101bf686f0990b$export$eb18ce1988c5f19c);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $f3101bf686f0990b$var$name = 'sqrt';
var $f3101bf686f0990b$var$dependencies = [
    'config',
    'typed',
    'Complex'
];
var $f3101bf686f0990b$export$eb18ce1988c5f19c = /* #__PURE__ */ (0, $4eE2e.factory)($f3101bf686f0990b$var$name, $f3101bf686f0990b$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, Complex: Complex } = _ref;
    /**
   * Calculate the square root of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sqrt(x)
   *
   * Examples:
   *
   *    math.sqrt(25)                // returns 5
   *    math.square(5)               // returns 25
   *    math.sqrt(-4)                // returns Complex 2i
   *
   * See also:
   *
   *    square, multiply, cube, cbrt, sqrtm
   *
   * @param {number | BigNumber | Complex | Array | Matrix | Unit} x
   *            Value for which to calculate the square root.
   * @return {number | BigNumber | Complex | Array | Matrix | Unit}
   *            Returns the square root of `x`
   */ return typed('sqrt', {
        number: _sqrtNumber,
        Complex: function Complex(x) {
            return x.sqrt();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.sqrt();
            else // negative value -> downgrade to number to do complex value computation
            return _sqrtNumber(x.toNumber());
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since sqrt(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        },
        Unit: function Unit(x) {
            // Someday will work for complex units when they are implemented
            return x.pow(0.5);
        }
    });
    /**
   * Calculate sqrt for a number
   * @param {number} x
   * @returns {number | Complex} Returns the square root of x
   * @private
   */ function _sqrtNumber(x) {
        if (isNaN(x)) return NaN;
        else if (x >= 0 || config.predictable) return Math.sqrt(x);
        else return new Complex(x, 0).sqrt();
    }
});

});

parcelRegister("4oju7", function(module, exports) {

$parcel$export(module.exports, "createSqrtm", () => $3328849c57e6bf0a$export$71d0f952576e7511);

var $gs7TF = parcelRequire("gs7TF");

var $aEppI = parcelRequire("aEppI");

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $3328849c57e6bf0a$var$name = 'sqrtm';
var $3328849c57e6bf0a$var$dependencies = [
    'typed',
    'abs',
    'add',
    'multiply',
    'sqrt',
    'subtract',
    'inv',
    'size',
    'max',
    'identity'
];
var $3328849c57e6bf0a$export$71d0f952576e7511 = /* #__PURE__ */ (0, $4eE2e.factory)($3328849c57e6bf0a$var$name, $3328849c57e6bf0a$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, multiply: multiply, sqrt: sqrt, subtract: subtract, inv: inv, size: size, max: max, identity: identity } = _ref;
    var _maxIterations = 1e3;
    var _tolerance = 1e-6;
    /**
   * Calculate the principal square root matrix using the Denman–Beavers iterative method
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix#By_Denman–Beavers_iteration
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   * @private
   */ function _denmanBeavers(A) {
        var error;
        var iterations = 0;
        var Y = A;
        var Z = identity(size(A));
        do {
            var Yk = Y;
            Y = multiply(0.5, add(Yk, inv(Z)));
            Z = multiply(0.5, add(Z, inv(Yk)));
            error = max(abs(subtract(Y, Yk)));
            if (error > _tolerance && ++iterations > _maxIterations) throw new Error('computing square root of matrix: iterative method could not converge');
        }while (error > _tolerance);
        return Y;
    }
    /**
   * Calculate the principal square root of a square matrix.
   * The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix
   *
   * Syntax:
   *
   *     X = math.sqrtm(A)
   *
   * Examples:
   *
   *     math.sqrtm([[1, 2], [3, 4]]) // returns [[-2, 1], [1.5, -0.5]]
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   */ return typed($3328849c57e6bf0a$var$name, {
        'Array | Matrix': function ArrayMatrix(A) {
            var size = (0, $gs7TF.isMatrix)(A) ? A.size() : (0, $10UPF.arraySize)(A);
            switch(size.length){
                case 1:
                    // Single element Array | Matrix
                    if (size[0] === 1) return sqrt(A);
                    else throw new RangeError("Matrix must be square (size: " + (0, $aEppI.format)(size) + ')');
                case 2:
                    // Two-dimensional Array | Matrix
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _denmanBeavers(A);
                    else throw new RangeError("Matrix must be square (size: " + (0, $aEppI.format)(size) + ')');
                default:
                    // Multi dimensional array
                    throw new RangeError("Matrix must be at most two dimensional (size: " + (0, $aEppI.format)(size) + ')');
            }
        }
    });
});

});

parcelRegister("i2dyg", function(module, exports) {

$parcel$export(module.exports, "createSquare", () => $d212ecf4ea8f7f2b$export$4ba960a63f731b0b);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $eRNhQ = parcelRequire("eRNhQ");
var $d212ecf4ea8f7f2b$var$name = 'square';
var $d212ecf4ea8f7f2b$var$dependencies = [
    'typed'
];
var $d212ecf4ea8f7f2b$export$4ba960a63f731b0b = /* #__PURE__ */ (0, $4eE2e.factory)($d212ecf4ea8f7f2b$var$name, $d212ecf4ea8f7f2b$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the square of a value, `x * x`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.square(x)
   *
   * Examples:
   *
   *    math.square(2)           // returns number 4
   *    math.square(3)           // returns number 9
   *    math.pow(3, 2)           // returns number 9
   *    math.multiply(3, 3)      // returns number 9
   *
   *    math.square([1, 2, 3, 4])  // returns Array [1, 4, 9, 16]
   *
   * See also:
   *
   *    multiply, cube, sqrt, pow
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            Number for which to calculate the square
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
   *            Squared value
   */ return typed($d212ecf4ea8f7f2b$var$name, {
        number: (0, $eRNhQ.squareNumber),
        Complex: function Complex(x) {
            return x.mul(x);
        },
        BigNumber: function BigNumber(x) {
            return x.times(x);
        },
        Fraction: function Fraction(x) {
            return x.mul(x);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since square(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        },
        Unit: function Unit(x) {
            return x.pow(2);
        }
    });
});

});

parcelRegister("568HB", function(module, exports) {

$parcel$export(module.exports, "createSqueeze", () => $3b644366693a6984$export$1a885844ffd505a4);

var $4mYv9 = parcelRequire("4mYv9");

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $3b644366693a6984$var$name = 'squeeze';
var $3b644366693a6984$var$dependencies = [
    'typed',
    'matrix'
];
var $3b644366693a6984$export$1a885844ffd505a4 = /* #__PURE__ */ (0, $4eE2e.factory)($3b644366693a6984$var$name, $3b644366693a6984$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Squeeze a matrix, remove inner and outer singleton dimensions from a matrix.
   *
   * Syntax:
   *
   *     math.squeeze(x)
   *
   * Examples:
   *
   *     math.squeeze([3])           // returns 3
   *     math.squeeze([[3]])         // returns 3
   *
   *     const A = math.zeros(3, 1)    // returns [[0], [0], [0]] (size 3x1)
   *     math.squeeze(A)             // returns [0, 0, 0] (size 3)
   *
   *     const B = math.zeros(1, 3)    // returns [[0, 0, 0]] (size 1x3)
   *     math.squeeze(B)             // returns [0, 0, 0] (size 3)
   *
   *     // only inner and outer dimensions are removed
   *     const C = math.zeros(2, 1, 3) // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *     math.squeeze(C)             // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *
   * See also:
   *
   *     subset
   *
   * @param {Matrix | Array} x      Matrix to be squeezed
   * @return {Matrix | Array} Squeezed matrix
   */ return typed($3b644366693a6984$var$name, {
        Array: function Array1(x) {
            return (0, $10UPF.squeeze)((0, $4mYv9.clone)(x));
        },
        Matrix: function Matrix(x) {
            var res = (0, $10UPF.squeeze)(x.toArray()); // FIXME: return the same type of matrix as the input
            return Array.isArray(res) ? matrix(res) : res;
        },
        any: function any(x) {
            // scalar
            return (0, $4mYv9.clone)(x);
        }
    });
});

});

parcelRegister("9BZAX", function(module, exports) {

$parcel$export(module.exports, "createStd", () => $6ff7593c46ff66e7$export$d3f0a8dda5df7afd);

var $4eE2e = parcelRequire("4eE2e");
var $6ff7593c46ff66e7$var$name = 'std';
var $6ff7593c46ff66e7$var$dependencies = [
    'typed',
    'sqrt',
    'variance'
];
var $6ff7593c46ff66e7$export$d3f0a8dda5df7afd = /* #__PURE__ */ (0, $4eE2e.factory)($6ff7593c46ff66e7$var$name, $6ff7593c46ff66e7$var$dependencies, (_ref)=>{
    var { typed: typed, sqrt: sqrt, variance: variance } = _ref;
    /**
   * Compute the standard deviation of a matrix or a  list with values.
   * The standard deviations is defined as the square root of the variance:
   * `std(A) = sqrt(variance(A))`.
   * In case of a (multi dimensional) array or matrix, the standard deviation
   * over all elements will be calculated by default, unless an axis is specified
   * in which case the standard deviation will be computed along that axis.
   *
   * Additionally, it is possible to compute the standard deviation along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Syntax:
   *
   *     math.std(a, b, c, ...)
   *     math.std(A)
   *     math.std(A, normalization)
   *     math.std(A, dimension)
   *     math.std(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.std(2, 4, 6)                     // returns 2
   *     math.std([2, 4, 6, 8])                // returns 2.581988897471611
   *     math.std([2, 4, 6, 8], 'uncorrected') // returns 2.23606797749979
   *     math.std([2, 4, 6, 8], 'biased')      // returns 2
   *
   *     math.std([[1, 2, 3], [4, 5, 6]])      // returns 1.8708286933869707
   *     math.std([[1, 2, 3], [4, 6, 8]], 0)    // returns [2.1213203435596424, 2.8284271247461903, 3.5355339059327378]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1)    // returns [1, 2]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.7071067811865476, 1.4142135623730951]
   *
   * See also:
   *
   *    mean, median, max, min, prod, sum, variance
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the standard deviation for a matrix
   * @return {*} The standard deviation
   */ return typed($6ff7593c46ff66e7$var$name, {
        // std([a, b, c, d, ...])
        'Array | Matrix': _std,
        // std([a, b, c, d, ...], normalization)
        'Array | Matrix, string': _std,
        // std([a, b, c, c, ...], dim)
        'Array | Matrix, number | BigNumber': _std,
        // std([a, b, c, c, ...], dim, normalization)
        'Array | Matrix, number | BigNumber, string': _std,
        // std(a, b, c, d, ...)
        '...': function _(args) {
            return _std(args);
        }
    });
    function _std(array, normalization) {
        if (array.length === 0) throw new SyntaxError('Function std requires one or more parameters (0 provided)');
        try {
            return sqrt(variance.apply(null, arguments));
        } catch (err) {
            if (err instanceof TypeError && err.message.indexOf(' variance') !== -1) throw new TypeError(err.message.replace(' variance', ' std'));
            else throw err;
        }
    }
});

});

parcelRegister("j2DxC", function(module, exports) {

$parcel$export(module.exports, "createStirlingS2", () => $ddcce0450c6e8d9f$export$18813d136a9b83d0);

var $4eE2e = parcelRequire("4eE2e");
var $ddcce0450c6e8d9f$var$name = 'stirlingS2';
var $ddcce0450c6e8d9f$var$dependencies = [
    'typed',
    'addScalar',
    'subtract',
    'multiplyScalar',
    'divideScalar',
    'pow',
    'factorial',
    'combinations',
    'isNegative',
    'isInteger',
    'larger'
];
var $ddcce0450c6e8d9f$export$18813d136a9b83d0 = /* #__PURE__ */ (0, $4eE2e.factory)($ddcce0450c6e8d9f$var$name, $ddcce0450c6e8d9f$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, subtract: subtract, multiplyScalar: multiplyScalar, divideScalar: divideScalar, pow: pow, factorial: factorial, combinations: combinations, isNegative: isNegative, isInteger: isInteger, larger: larger } = _ref;
    /**
   * The Stirling numbers of the second kind, counts the number of ways to partition
   * a set of n labelled objects into k nonempty unlabelled subsets.
   * stirlingS2 only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   *  If n = k or k = 1, then s(n,k) = 1
   *
   * Syntax:
   *
   *   math.stirlingS2(n, k)
   *
   * Examples:
   *
   *    math.stirlingS2(5, 3) //returns 25
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     S(n,k)
   */ return typed($ddcce0450c6e8d9f$var$name, {
        'number | BigNumber, number | BigNumber': function numberBigNumberNumberBigNumber(n, k) {
            if (!isInteger(n) || isNegative(n) || !isInteger(k) || isNegative(k)) throw new TypeError('Non-negative integer value expected in function stirlingS2');
            else if (larger(k, n)) throw new TypeError('k must be less than or equal to n in function stirlingS2');
             // 1/k! Sum(i=0 -> k) [(-1)^(k-i)*C(k,j)* i^n]
            var kFactorial = factorial(k);
            var result = 0;
            for(var i = 0; i <= k; i++){
                var negativeOne = pow(-1, subtract(k, i));
                var kChooseI = combinations(k, i);
                var iPower = pow(i, n);
                result = addScalar(result, multiplyScalar(multiplyScalar(kChooseI, iPower), negativeOne));
            }
            return divideScalar(result, kFactorial);
        }
    });
});

});

parcelRegister("7nyTK", function(module, exports) {

$parcel$export(module.exports, "createString", () => $55f5c0728f8fb9b9$export$b2cf5914f5f18823);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $6egKm = parcelRequire("6egKm");
var $55f5c0728f8fb9b9$var$name = 'string';
var $55f5c0728f8fb9b9$var$dependencies = [
    'typed'
];
var $55f5c0728f8fb9b9$export$b2cf5914f5f18823 = /* #__PURE__ */ (0, $4eE2e.factory)($55f5c0728f8fb9b9$var$name, $55f5c0728f8fb9b9$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a string or convert any object into a string.
   * Elements of Arrays and Matrices are processed element wise.
   *
   * Syntax:
   *
   *    math.string(value)
   *
   * Examples:
   *
   *    math.string(4.2)               // returns string '4.2'
   *    math.string(math.complex(3, 2) // returns string '3 + 2i'
   *
   *    const u = math.unit(5, 'km')
   *    math.string(u.to('m'))         // returns string '5000 m'
   *
   *    math.string([true, false])     // returns ['true', 'false']
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, unit
   *
   * @param {* | Array | Matrix | null} [value]  A value to convert to a string
   * @return {string | Array | Matrix} The created string
   */ return typed($55f5c0728f8fb9b9$var$name, {
        '': function _() {
            return '';
        },
        number: (0, $6egKm.format),
        null: function _null(x) {
            return 'null';
        },
        boolean: function boolean(x) {
            return x + '';
        },
        string: function string(x) {
            return x;
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        },
        any: function any(x) {
            return String(x);
        }
    });
});

});

parcelRegister("57e22", function(module, exports) {

$parcel$export(module.exports, "createSubset", () => $3b987da6aa7e6d31$export$d8c56e74d683bb33);

var $gs7TF = parcelRequire("gs7TF");

var $4mYv9 = parcelRequire("4mYv9");

var $10UPF = parcelRequire("10UPF");

var $5em9H = parcelRequire("5em9H");

var $iAoVB = parcelRequire("iAoVB");

var $4eE2e = parcelRequire("4eE2e");
var $3b987da6aa7e6d31$var$name = 'subset';
var $3b987da6aa7e6d31$var$dependencies = [
    'typed',
    'matrix'
];
var $3b987da6aa7e6d31$export$d8c56e74d683bb33 = /* #__PURE__ */ (0, $4eE2e.factory)($3b987da6aa7e6d31$var$name, $3b987da6aa7e6d31$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Get or set a subset of a matrix or string.
   *
   * Syntax:
   *     math.subset(value, index)                                // retrieve a subset
   *     math.subset(value, index, replacement [, defaultValue])  // replace a subset
   *
   * Examples:
   *
   *     // get a subset
   *     const d = [[1, 2], [3, 4]]
   *     math.subset(d, math.index(1, 0))        // returns 3
   *     math.subset(d, math.index([0, 1], 1))   // returns [[2], [4]]
   *
   *     // replace a subset
   *     const e = []
   *     const f = math.subset(e, math.index(0, [0, 2]), [5, 6])  // f = [[5, 6]]
   *     const g = math.subset(f, math.index(1, 1), 7, 0)         // g = [[5, 6], [0, 7]]
   *
   * See also:
   *
   *     size, resize, squeeze, index
   *
   * @param {Array | Matrix | string} matrix  An array, matrix, or string
   * @param {Index} index                     An index containing ranges for each
   *                                          dimension
   * @param {*} [replacement]                 An array, matrix, or scalar.
   *                                          If provided, the subset is replaced with replacement.
   *                                          If not provided, the subset is returned
   * @param {*} [defaultValue=undefined]      Default value, filled in on new entries when
   *                                          the matrix is resized. If not provided,
   *                                          math.matrix elements will be left undefined.
   * @return {Array | Matrix | string} Either the retrieved subset or the updated matrix.
   */ return typed($3b987da6aa7e6d31$var$name, {
        // get subset
        'Array, Index': function ArrayIndex(value, index) {
            var m = matrix(value);
            var subset = m.subset(index); // returns a Matrix
            return index.isScalar() ? subset : subset.valueOf(); // return an Array (like the input)
        },
        'Matrix, Index': function MatrixIndex(value, index) {
            return value.subset(index);
        },
        'Object, Index': $3b987da6aa7e6d31$var$_getObjectProperty,
        'string, Index': $3b987da6aa7e6d31$var$_getSubstring,
        // set subset
        'Array, Index, any': function ArrayIndexAny(value, index, replacement) {
            return matrix((0, $4mYv9.clone)(value)).subset(index, replacement, undefined).valueOf();
        },
        'Array, Index, any, any': function ArrayIndexAnyAny(value, index, replacement, defaultValue) {
            return matrix((0, $4mYv9.clone)(value)).subset(index, replacement, defaultValue).valueOf();
        },
        'Matrix, Index, any': function MatrixIndexAny(value, index, replacement) {
            return value.clone().subset(index, replacement);
        },
        'Matrix, Index, any, any': function MatrixIndexAnyAny(value, index, replacement, defaultValue) {
            return value.clone().subset(index, replacement, defaultValue);
        },
        'string, Index, string': $3b987da6aa7e6d31$var$_setSubstring,
        'string, Index, string, string': $3b987da6aa7e6d31$var$_setSubstring,
        'Object, Index, any': $3b987da6aa7e6d31$var$_setObjectProperty
    });
});
/**
 * Retrieve a subset of a string
 * @param {string} str            string from which to get a substring
 * @param {Index} index           An index containing ranges for each dimension
 * @returns {string} substring
 * @private
 */ function $3b987da6aa7e6d31$var$_getSubstring(str, index) {
    if (!(0, $gs7TF.isIndex)(index)) // TODO: better error message
    throw new TypeError('Index expected');
    if (index.size().length !== 1) throw new (0, $iAoVB.DimensionError)(index.size().length, 1);
     // validate whether the range is out of range
    var strLen = str.length;
    (0, $10UPF.validateIndex)(index.min()[0], strLen);
    (0, $10UPF.validateIndex)(index.max()[0], strLen);
    var range = index.dimension(0);
    var substr = '';
    range.forEach(function(v) {
        substr += str.charAt(v);
    });
    return substr;
}
/**
 * Replace a substring in a string
 * @param {string} str            string to be replaced
 * @param {Index} index           An index containing ranges for each dimension
 * @param {string} replacement    Replacement string
 * @param {string} [defaultValue] Default value to be uses when resizing
 *                                the string. is ' ' by default
 * @returns {string} result
 * @private
 */ function $3b987da6aa7e6d31$var$_setSubstring(str, index, replacement, defaultValue) {
    if (!index || index.isIndex !== true) // TODO: better error message
    throw new TypeError('Index expected');
    if (index.size().length !== 1) throw new (0, $iAoVB.DimensionError)(index.size().length, 1);
    if (defaultValue !== undefined) {
        if (typeof defaultValue !== 'string' || defaultValue.length !== 1) throw new TypeError('Single character expected as defaultValue');
    } else defaultValue = ' ';
    var range = index.dimension(0);
    var len = range.size()[0];
    if (len !== replacement.length) throw new (0, $iAoVB.DimensionError)(range.size()[0], replacement.length);
     // validate whether the range is out of range
    var strLen = str.length;
    (0, $10UPF.validateIndex)(index.min()[0]);
    (0, $10UPF.validateIndex)(index.max()[0]); // copy the string into an array with characters
    var chars = [];
    for(var i = 0; i < strLen; i++)chars[i] = str.charAt(i);
    range.forEach(function(v, i) {
        chars[v] = replacement.charAt(i[0]);
    }); // initialize undefined characters with a space
    if (chars.length > strLen) {
        for(var _i = strLen - 1, _len = chars.length; _i < _len; _i++)if (!chars[_i]) chars[_i] = defaultValue;
    }
    return chars.join('');
}
/**
 * Retrieve a property from an object
 * @param {Object} object
 * @param {Index} index
 * @return {*} Returns the value of the property
 * @private
 */ function $3b987da6aa7e6d31$var$_getObjectProperty(object, index) {
    if (index.size().length !== 1) throw new (0, $iAoVB.DimensionError)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== 'string') throw new TypeError('String expected as index to retrieve an object property');
    return (0, $5em9H.getSafeProperty)(object, key);
}
/**
 * Set a property on an object
 * @param {Object} object
 * @param {Index} index
 * @param {*} replacement
 * @return {*} Returns the updated object
 * @private
 */ function $3b987da6aa7e6d31$var$_setObjectProperty(object, index, replacement) {
    if (index.size().length !== 1) throw new (0, $iAoVB.DimensionError)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== 'string') throw new TypeError('String expected as index to retrieve an object property');
     // clone the object, and apply the property to the clone
    var updated = (0, $4mYv9.clone)(object);
    (0, $5em9H.setSafeProperty)(updated, key, replacement);
    return updated;
}

});
parcelRegister("5em9H", function(module, exports) {

$parcel$export(module.exports, "getSafeProperty", () => $3cef7224169168e6$export$87a87648a1961976);
$parcel$export(module.exports, "setSafeProperty", () => $3cef7224169168e6$export$e99fe8700ee9f9cd);
$parcel$export(module.exports, "hasSafeProperty", () => $3cef7224169168e6$export$626bde2ef1d9655a);

var $4mYv9 = parcelRequire("4mYv9");
/**
 * Get a property of a plain object
 * Throws an error in case the object is not a plain object or the
 * property is not defined on the object itself
 * @param {Object} object
 * @param {string} prop
 * @return {*} Returns the property value when safe
 */ function $3cef7224169168e6$export$87a87648a1961976(object, prop) {
    // only allow getting safe properties of a plain object
    if ($3cef7224169168e6$export$53b83ca8eaab0383(object) && $3cef7224169168e6$export$3039c640f3cfc12a(object, prop)) return object[prop];
    if (typeof object[prop] === 'function' && $3cef7224169168e6$export$2220a91638ab1d9e(object, prop)) throw new Error('Cannot access method "' + prop + '" as a property');
    throw new Error('No access to property "' + prop + '"');
}
/**
 * Set a property on a plain object.
 * Throws an error in case the object is not a plain object or the
 * property would override an inherited property like .constructor or .toString
 * @param {Object} object
 * @param {string} prop
 * @param {*} value
 * @return {*} Returns the value
 */ // TODO: merge this function into access.js?
function $3cef7224169168e6$export$e99fe8700ee9f9cd(object, prop, value) {
    // only allow setting safe properties of a plain object
    if ($3cef7224169168e6$export$53b83ca8eaab0383(object) && $3cef7224169168e6$export$3039c640f3cfc12a(object, prop)) {
        object[prop] = value;
        return value;
    }
    throw new Error('No access to property "' + prop + '"');
}
function $3cef7224169168e6$export$97accea1a2314d22(object) {
    return Object.keys(object).filter((prop)=>(0, $4mYv9.hasOwnProperty)(object, prop));
}
function $3cef7224169168e6$export$626bde2ef1d9655a(object, prop) {
    return prop in object;
}
/**
 * Test whether a property is safe to use for an object.
 * For example .toString and .constructor are not safe
 * @param {string} prop
 * @return {boolean} Returns true when safe
 */ function $3cef7224169168e6$export$3039c640f3cfc12a(object, prop) {
    if (!object || typeof object !== 'object') return false;
     // SAFE: whitelisted
    // e.g length
    if ((0, $4mYv9.hasOwnProperty)($3cef7224169168e6$var$safeNativeProperties, prop)) return true;
     // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (prop in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
     // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (prop in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
/**
 * Validate whether a method is safe.
 * Throws an error when that's not the case.
 * @param {Object} object
 * @param {string} method
 */ // TODO: merge this function into assign.js?
function $3cef7224169168e6$export$7cfb146d96805fec(object, method) {
    if (!$3cef7224169168e6$export$2220a91638ab1d9e(object, method)) throw new Error('No access to method "' + method + '"');
}
/**
 * Check whether a method is safe.
 * Throws an error when that's not the case (for example for `constructor`).
 * @param {Object} object
 * @param {string} method
 * @return {boolean} Returns true when safe, false otherwise
 */ function $3cef7224169168e6$export$2220a91638ab1d9e(object, method) {
    if (object === null || object === undefined || typeof object[method] !== 'function') return false;
     // UNSAFE: ghosted
    // e.g overridden toString
    // Note that IE10 doesn't support __proto__ and we can't do this check there.
    if ((0, $4mYv9.hasOwnProperty)(object, method) && Object.getPrototypeOf && method in Object.getPrototypeOf(object)) return false;
     // SAFE: whitelisted
    // e.g toString
    if ((0, $4mYv9.hasOwnProperty)($3cef7224169168e6$var$safeNativeMethods, method)) return true;
     // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (method in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
     // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (method in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
function $3cef7224169168e6$export$53b83ca8eaab0383(object) {
    return typeof object === 'object' && object && object.constructor === Object;
}
var $3cef7224169168e6$var$safeNativeProperties = {
    length: true,
    name: true
};
var $3cef7224169168e6$var$safeNativeMethods = {
    toString: true,
    valueOf: true,
    toLocaleString: true
};

});


parcelRegister("kkSft", function(module, exports) {

$parcel$export(module.exports, "createSubtract", () => $ecdfc189ed497a84$export$cd7a6c131b18ab16);

var $4eE2e = parcelRequire("4eE2e");

var $iAoVB = parcelRequire("iAoVB");

var $bCo9f = parcelRequire("bCo9f");

var $6MKpt = parcelRequire("6MKpt");

var $69TlR = parcelRequire("69TlR");

var $ecxvm = parcelRequire("ecxvm");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");
var $ecdfc189ed497a84$var$name = 'subtract';
var $ecdfc189ed497a84$var$dependencies = [
    'typed',
    'matrix',
    'equalScalar',
    'addScalar',
    'unaryMinus',
    'DenseMatrix'
];
var $ecdfc189ed497a84$export$cd7a6c131b18ab16 = /* #__PURE__ */ (0, $4eE2e.factory)($ecdfc189ed497a84$var$name, $ecdfc189ed497a84$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, addScalar: addScalar, unaryMinus: unaryMinus, DenseMatrix: DenseMatrix } = _ref;
    // TODO: split function subtract in two: subtract and subtractScalar
    var algorithm01 = (0, $bCo9f.createAlgorithm01)({
        typed: typed
    });
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm05 = (0, $69TlR.createAlgorithm05)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $ecxvm.createAlgorithm10)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Subtract two values, `x - y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.subtract(x, y)
   *
   * Examples:
   *
   *    math.subtract(5.3, 2)        // returns number 3.3
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.subtract(a, b)          // returns Complex -2 + 2i
   *
   *    math.subtract([5, 7, 4], 4)  // returns Array [1, 3, 0]
   *
   *    const c = math.unit('2.1 km')
   *    const d = math.unit('500m')
   *    math.subtract(c, d)          // returns Unit 1.6 km
   *
   * See also:
   *
   *    add
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x
   *            Initial value
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y
   *            Value to subtract from `x`
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Subtraction of `x` and `y`
   */ return typed($ecdfc189ed497a84$var$name, {
        'number, number': function numberNumber(x, y) {
            return x - y;
        },
        'Complex, Complex': function ComplexComplex(x, y) {
            return x.sub(y);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return x.minus(y);
        },
        'Fraction, Fraction': function FractionFraction(x, y) {
            return x.sub(y);
        },
        'Unit, Unit': function UnitUnit(x, y) {
            if (x.value === null) throw new Error('Parameter x contains a unit with undefined value');
            if (y.value === null) throw new Error('Parameter y contains a unit with undefined value');
            if (!x.equalBase(y)) throw new Error('Units do not match');
            var res = x.clone();
            res.value = this(res.value, y.value);
            res.fixPrefix = false;
            return res;
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            $ecdfc189ed497a84$var$checkEqualDimensions(x, y);
            return algorithm05(x, y, this);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            $ecdfc189ed497a84$var$checkEqualDimensions(x, y);
            return algorithm03(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            $ecdfc189ed497a84$var$checkEqualDimensions(x, y);
            return algorithm01(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            $ecdfc189ed497a84$var$checkEqualDimensions(x, y);
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm10(x, unaryMinus(y), addScalar);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm10(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
/**
 * Check whether matrix x and y have the same number of dimensions.
 * Throws a DimensionError when dimensions are not equal
 * @param {Matrix} x
 * @param {Matrix} y
 */ function $ecdfc189ed497a84$var$checkEqualDimensions(x, y) {
    var xsize = x.size();
    var ysize = y.size();
    if (xsize.length !== ysize.length) throw new (0, $iAoVB.DimensionError)(xsize.length, ysize.length);
}

});

parcelRegister("4NZiI", function(module, exports) {

$parcel$export(module.exports, "createSum", () => $37fb4a13f9b1a074$export$14d444d810bc35b5);

var $9nwyh = parcelRequire("9nwyh");

var $4eE2e = parcelRequire("4eE2e");

var $ijiby = parcelRequire("ijiby");
var $37fb4a13f9b1a074$var$name = 'sum';
var $37fb4a13f9b1a074$var$dependencies = [
    'typed',
    'config',
    'add',
    'numeric'
];
var $37fb4a13f9b1a074$export$14d444d810bc35b5 = /* #__PURE__ */ (0, $4eE2e.factory)($37fb4a13f9b1a074$var$name, $37fb4a13f9b1a074$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, add: add, numeric: numeric } = _ref;
    /**
   * Compute the sum of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.sum(a, b, c, ...)
   *     math.sum(A)
   *
   * Examples:
   *
   *     math.sum(2, 1, 4, 3)               // returns 10
   *     math.sum([2, 1, 4, 3])             // returns 10
   *     math.sum([[2, 5], [4, 3], [1, 7]]) // returns 22
   *
   * See also:
   *
   *    mean, median, min, max, prod, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The sum of all values
   */ return typed($37fb4a13f9b1a074$var$name, {
        // sum([a, b, c, d, ...])
        'Array | Matrix': _sum,
        // sum([a, b, c, d, ...], dim)
        'Array | Matrix, number | BigNumber': _nsumDim,
        // sum(a, b, c, d, ...)
        '...': function _(args) {
            if ((0, $9nwyh.containsCollections)(args)) throw new TypeError('Scalar values expected in function sum');
            return _sum(args);
        }
    });
    /**
   * Recursively calculate the sum of an n-dimensional array
   * @param {Array | Matrix} array
   * @return {number} sum
   * @private
   */ function _sum(array) {
        var sum;
        (0, $9nwyh.deepForEach)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
            } catch (err) {
                throw (0, $ijiby.improveErrorMessage)(err, 'sum', value);
            }
        }); // make sure returning numeric value: parse a string into a numeric value
        if (sum === undefined) sum = numeric(0, config.number);
        if (typeof sum === 'string') sum = numeric(sum, config.number);
        return sum;
    }
    function _nsumDim(array, dim) {
        try {
            var sum = (0, $9nwyh.reduce)(array, dim, add);
            return sum;
        } catch (err) {
            throw (0, $ijiby.improveErrorMessage)(err, 'sum');
        }
    }
});

});

parcelRegister("CGoi6", function(module, exports) {

$parcel$export(module.exports, "createTan", () => $07446ea6eb176860$export$b61ad4f38fd9301d);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $07446ea6eb176860$var$name = 'tan';
var $07446ea6eb176860$var$dependencies = [
    'typed'
];
var $07446ea6eb176860$export$b61ad4f38fd9301d = /* #__PURE__ */ (0, $4eE2e.factory)($07446ea6eb176860$var$name, $07446ea6eb176860$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the tangent of a value. `tan(x)` is equal to `sin(x) / cos(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.tan(x)
   *
   * Examples:
   *
   *    math.tan(0.5)                    // returns number 0.5463024898437905
   *    math.sin(0.5) / math.cos(0.5)    // returns number 0.5463024898437905
   *    math.tan(math.pi / 4)            // returns number 1
   *    math.tan(math.unit(45, 'deg'))   // returns number 1
   *
   * See also:
   *
   *    atan, sin, cos
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Tangent of x
   */ return typed($07446ea6eb176860$var$name, {
        number: Math.tan,
        Complex: function Complex(x) {
            return x.tan();
        },
        BigNumber: function BigNumber(x) {
            return x.tan();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function tan is no angle');
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since tan(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        }
    });
});

});

parcelRegister("lD4pT", function(module, exports) {

$parcel$export(module.exports, "createTanh", () => $fbf0aa86adefebdf$export$e1f66a5bda779194);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $6egKm = parcelRequire("6egKm");
var $fbf0aa86adefebdf$var$name = 'tanh';
var $fbf0aa86adefebdf$var$dependencies = [
    'typed'
];
var $fbf0aa86adefebdf$export$e1f66a5bda779194 = /* #__PURE__ */ (0, $4eE2e.factory)($fbf0aa86adefebdf$var$name, $fbf0aa86adefebdf$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic tangent of a value,
   * defined as `tanh(x) = (exp(2 * x) - 1) / (exp(2 * x) + 1)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.tanh(x)
   *
   * Examples:
   *
   *    // tanh(x) = sinh(x) / cosh(x) = 1 / coth(x)
   *    math.tanh(0.5)                   // returns 0.46211715726000974
   *    math.sinh(0.5) / math.cosh(0.5)  // returns 0.46211715726000974
   *    1 / math.coth(0.5)               // returns 0.46211715726000974
   *
   * See also:
   *
   *    sinh, cosh, coth
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic tangent of x
   */ return typed('tanh', {
        number: (0, $6egKm.tanh),
        Complex: function Complex(x) {
            return x.tanh();
        },
        BigNumber: function BigNumber(x) {
            return x.tanh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError('Unit in function tanh is no angle');
            return this(x.value);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since tanh(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        }
    });
});

});

parcelRegister("5pDCm", function(module, exports) {

$parcel$export(module.exports, "createTo", () => $3f0e04ceee85113a$export$6e6c19ceb4cd6856);

var $4eE2e = parcelRequire("4eE2e");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");
var $3f0e04ceee85113a$var$name = 'to';
var $3f0e04ceee85113a$var$dependencies = [
    'typed',
    'matrix'
];
var $3f0e04ceee85113a$export$6e6c19ceb4cd6856 = /* #__PURE__ */ (0, $4eE2e.factory)($3f0e04ceee85113a$var$name, $3f0e04ceee85113a$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Change the unit of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.to(x, unit)
   *
   * Examples:
   *
   *    math.to(math.unit('2 inch'), 'cm')                   // returns Unit 5.08 cm
   *    math.to(math.unit('2 inch'), math.unit(null, 'cm'))  // returns Unit 5.08 cm
   *    math.to(math.unit(16, 'bytes'), 'bits')              // returns Unit 128 bits
   *
   * See also:
   *
   *    unit
   *
   * @param {Unit | Array | Matrix} x     The unit to be converted.
   * @param {Unit | Array | Matrix} unit  New unit. Can be a string like "cm"
   *                                      or a unit without value.
   * @return {Unit | Array | Matrix} value with changed, fixed unit.
   */ return typed($3f0e04ceee85113a$var$name, {
        'Unit, Unit | string': function UnitUnitString(x, unit) {
            return x.to(unit);
        },
        'Matrix, Matrix': function MatrixMatrix(x, y) {
            // SparseMatrix does not support Units
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'Matrix, any': function MatrixAny(x, y) {
            // SparseMatrix does not support Units
            return algorithm14(x, y, this, false);
        },
        'any, Matrix': function anyMatrix(x, y) {
            // SparseMatrix does not support Units
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});

});

parcelRegister("fLBnu", function(module, exports) {

$parcel$export(module.exports, "createTrace", () => $b7a83d4732d9ac51$export$acff8254414be03b);

var $4mYv9 = parcelRequire("4mYv9");

var $aEppI = parcelRequire("aEppI");

var $4eE2e = parcelRequire("4eE2e");
var $b7a83d4732d9ac51$var$name = 'trace';
var $b7a83d4732d9ac51$var$dependencies = [
    'typed',
    'matrix',
    'add'
];
var $b7a83d4732d9ac51$export$acff8254414be03b = /* #__PURE__ */ (0, $4eE2e.factory)($b7a83d4732d9ac51$var$name, $b7a83d4732d9ac51$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, add: add } = _ref;
    /**
   * Calculate the trace of a matrix: the sum of the elements on the main
   * diagonal of a square matrix.
   *
   * Syntax:
   *
   *    math.trace(x)
   *
   * Examples:
   *
   *    math.trace([[1, 2], [3, 4]]) // returns 5
   *
   *    const A = [
   *      [1, 2, 3],
   *      [-1, 2, 3],
   *      [2, 0, 3]
   *    ]
   *    math.trace(A) // returns 6
   *
   * See also:
   *
   *    diag
   *
   * @param {Array | Matrix} x  A matrix
   *
   * @return {number} The trace of `x`
   */ return typed('trace', {
        Array: function _arrayTrace(x) {
            // use dense matrix implementation
            return _denseTrace(matrix(x));
        },
        SparseMatrix: _sparseTrace,
        DenseMatrix: _denseTrace,
        any: (0, $4mYv9.clone)
    });
    function _denseTrace(m) {
        // matrix size & data
        var size = m._size;
        var data = m._data; // process dimensions
        switch(size.length){
            case 1:
                // vector
                if (size[0] === 1) // return data[0]
                return (0, $4mYv9.clone)(data[0]);
                throw new RangeError('Matrix must be square (size: ' + (0, $aEppI.format)(size) + ')');
            case 2:
                // two dimensional
                var rows = size[0];
                var cols = size[1];
                if (rows === cols) {
                    // calulate sum
                    var sum = 0; // loop diagonal
                    for(var i = 0; i < rows; i++)sum = add(sum, data[i][i]);
                     // return trace
                    return sum;
                } else throw new RangeError('Matrix must be square (size: ' + (0, $aEppI.format)(size) + ')');
            default:
                // multi dimensional
                throw new RangeError('Matrix must be two dimensional (size: ' + (0, $aEppI.format)(size) + ')');
        }
    }
    function _sparseTrace(m) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        var size = m._size; // check dimensions
        var rows = size[0];
        var columns = size[1]; // matrix must be square
        if (rows === columns) {
            // calulate sum
            var sum = 0; // check we have data (avoid looping columns)
            if (values.length > 0) // loop columns
            for(var j = 0; j < columns; j++){
                // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
                var k0 = ptr[j];
                var k1 = ptr[j + 1]; // loop k within [k0, k1[
                for(var k = k0; k < k1; k++){
                    // row index
                    var i = index[k]; // check row
                    if (i === j) {
                        // accumulate value
                        sum = add(sum, values[k]); // exit loop
                        break;
                    }
                    if (i > j) break;
                }
            }
             // return trace
            return sum;
        }
        throw new RangeError('Matrix must be square (size: ' + (0, $aEppI.format)(size) + ')');
    }
});

});

parcelRegister("lo0mZ", function(module, exports) {

$parcel$export(module.exports, "createTranspose", () => $f91c204acf5d907b$export$9a8c88485f8f638b);

var $4mYv9 = parcelRequire("4mYv9");

var $aEppI = parcelRequire("aEppI");

var $4eE2e = parcelRequire("4eE2e");
var $f91c204acf5d907b$var$name = 'transpose';
var $f91c204acf5d907b$var$dependencies = [
    'typed',
    'matrix'
];
var $f91c204acf5d907b$export$9a8c88485f8f638b = /* #__PURE__ */ (0, $4eE2e.factory)($f91c204acf5d907b$var$name, $f91c204acf5d907b$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Transpose a matrix. All values of the matrix are reflected over its
   * main diagonal. Only applicable to two dimensional matrices containing
   * a vector (i.e. having size `[1,n]` or `[n,1]`). One dimensional
   * vectors and scalars return the input unchanged.
   *
   * Syntax:
   *
   *     math.transpose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.transpose(A)               // returns [[1, 4], [2, 5], [3, 6]]
   *
   * See also:
   *
   *     diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be transposed
   * @return {Array | Matrix}   The transposed matrix
   */ return typed('transpose', {
        Array: function Array(x) {
            // use dense matrix implementation
            return this(matrix(x)).valueOf();
        },
        Matrix: function Matrix(x) {
            // matrix size
            var size = x.size(); // result
            var c; // process dimensions
            switch(size.length){
                case 1:
                    // vector
                    c = x.clone();
                    break;
                case 2:
                    // rows and columns
                    var rows = size[0];
                    var columns = size[1]; // check columns
                    if (columns === 0) // throw exception
                    throw new RangeError('Cannot transpose a 2D matrix with no columns (size: ' + (0, $aEppI.format)(size) + ')');
                     // process storage format
                    switch(x.storage()){
                        case 'dense':
                            c = _denseTranspose(x, rows, columns);
                            break;
                        case 'sparse':
                            c = _sparseTranspose(x, rows, columns);
                            break;
                    }
                    break;
                default:
                    // multi dimensional
                    throw new RangeError('Matrix must be a vector or two dimensional (size: ' + (0, $aEppI.format)(this._size) + ')');
            }
            return c;
        },
        // scalars
        any: function any(x) {
            return (0, $4mYv9.clone)(x);
        }
    });
    function _denseTranspose(m, rows, columns) {
        // matrix array
        var data = m._data; // transposed matrix data
        var transposed = [];
        var transposedRow; // loop columns
        for(var j = 0; j < columns; j++){
            // initialize row
            transposedRow = transposed[j] = []; // loop rows
            for(var i = 0; i < rows; i++)// set data
            transposedRow[i] = (0, $4mYv9.clone)(data[i][j]);
        } // return matrix
        return m.createDenseMatrix({
            data: transposed,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
    function _sparseTranspose(m, rows, columns) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // result matrices
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = []; // row counts
        var w = [];
        for(var x = 0; x < rows; x++)w[x] = 0;
         // vars
        var p, l, j; // loop values in matrix
        for(p = 0, l = index.length; p < l; p++)// number of values in row
        w[index[p]]++;
         // cumulative sum
        var sum = 0; // initialize cptr with the cummulative sum of row counts
        for(var i = 0; i < rows; i++){
            // update cptr
            cptr.push(sum); // update sum
            sum += w[i]; // update w
            w[i] = cptr[i];
        } // update cptr
        cptr.push(sum); // loop columns
        for(j = 0; j < columns; j++)// values & index in column
        for(var k0 = ptr[j], k1 = ptr[j + 1], k = k0; k < k1; k++){
            // C values & index
            var q = w[index[k]]++; // C[j, i] = A[i, j]
            cindex[q] = j; // check we need to process values (pattern matrix)
            if (values) cvalues[q] = (0, $4mYv9.clone)(values[k]);
        }
         // return matrix
        return m.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
});

});

parcelRegister("iOTwI", function(module, exports) {

$parcel$export(module.exports, "createTyped", () => $db37f7f4b859fa77$export$8597b5d47504f989);
/**
 * Create a typed-function which checks the types of the arguments and
 * can match them against multiple provided signatures. The typed-function
 * automatically converts inputs in order to find a matching signature.
 * Typed functions throw informative errors in case of wrong input arguments.
 *
 * See the library [typed-function](https://github.com/josdejong/typed-function)
 * for detailed documentation.
 *
 * Syntax:
 *
 *     math.typed(name, signatures) : function
 *     math.typed(signatures) : function
 *
 * Examples:
 *
 *     // create a typed function with multiple types per argument (type union)
 *     const fn2 = typed({
 *       'number | boolean': function (b) {
 *         return 'b is a number or boolean'
 *       },
 *       'string, number | boolean': function (a, b) {
 *         return 'a is a string, b is a number or boolean'
 *       }
 *     })
 *
 *     // create a typed function with an any type argument
 *     const log = typed({
 *       'string, any': function (event, data) {
 *         console.log('event: ' + event + ', data: ' + JSON.stringify(data))
 *       }
 *     })
 *
 * @param {string} [name]                          Optional name for the typed-function
 * @param {Object<string, function>} signatures   Object with one or multiple function signatures
 * @returns {function} The created typed-function.
 */ 
var $gs7TF = parcelRequire("gs7TF");

var $gb5GC = parcelRequire("gb5GC");

var $6egKm = parcelRequire("6egKm");

var $4eE2e = parcelRequire("4eE2e");

var $o4CAS = parcelRequire("o4CAS");
var $db37f7f4b859fa77$var$_createTyped2 = function _createTyped() {
    // initially, return the original instance of typed-function
    // consecutively, return a new instance from typed.create.
    $db37f7f4b859fa77$var$_createTyped2 = (0, (/*@__PURE__*/$parcel$interopDefault($gb5GC))).create;
    return 0, (/*@__PURE__*/$parcel$interopDefault($gb5GC));
};
var $db37f7f4b859fa77$var$dependencies = [
    '?BigNumber',
    '?Complex',
    '?DenseMatrix',
    '?Fraction'
];
var $db37f7f4b859fa77$export$8597b5d47504f989 = /* #__PURE__ */ (0, $4eE2e.factory)('typed', $db37f7f4b859fa77$var$dependencies, function createTyped(_ref) {
    var { BigNumber: BigNumber, Complex: Complex, DenseMatrix: DenseMatrix, Fraction: Fraction } = _ref;
    // TODO: typed-function must be able to silently ignore signatures with unknown data types
    // get a new instance of typed-function
    var typed = $db37f7f4b859fa77$var$_createTyped2(); // define all types. The order of the types determines in which order function
    // arguments are type-checked (so for performance it's important to put the
    // most used types first).
    typed.types = [
        {
            name: 'number',
            test: (0, $gs7TF.isNumber)
        },
        {
            name: 'Complex',
            test: (0, $gs7TF.isComplex)
        },
        {
            name: 'BigNumber',
            test: (0, $gs7TF.isBigNumber)
        },
        {
            name: 'Fraction',
            test: (0, $gs7TF.isFraction)
        },
        {
            name: 'Unit',
            test: (0, $gs7TF.isUnit)
        },
        {
            name: 'string',
            test: (0, $gs7TF.isString)
        },
        {
            name: 'Chain',
            test: (0, $gs7TF.isChain)
        },
        {
            name: 'Array',
            test: (0, $gs7TF.isArray)
        },
        {
            name: 'Matrix',
            test: (0, $gs7TF.isMatrix)
        },
        {
            name: 'DenseMatrix',
            test: (0, $gs7TF.isDenseMatrix)
        },
        {
            name: 'SparseMatrix',
            test: (0, $gs7TF.isSparseMatrix)
        },
        {
            name: 'Range',
            test: (0, $gs7TF.isRange)
        },
        {
            name: 'Index',
            test: (0, $gs7TF.isIndex)
        },
        {
            name: 'boolean',
            test: (0, $gs7TF.isBoolean)
        },
        {
            name: 'ResultSet',
            test: (0, $gs7TF.isResultSet)
        },
        {
            name: 'Help',
            test: (0, $gs7TF.isHelp)
        },
        {
            name: 'function',
            test: (0, $gs7TF.isFunction)
        },
        {
            name: 'Date',
            test: (0, $gs7TF.isDate)
        },
        {
            name: 'RegExp',
            test: (0, $gs7TF.isRegExp)
        },
        {
            name: 'null',
            test: (0, $gs7TF.isNull)
        },
        {
            name: 'undefined',
            test: (0, $gs7TF.isUndefined)
        },
        {
            name: 'AccessorNode',
            test: (0, $gs7TF.isAccessorNode)
        },
        {
            name: 'ArrayNode',
            test: (0, $gs7TF.isArrayNode)
        },
        {
            name: 'AssignmentNode',
            test: (0, $gs7TF.isAssignmentNode)
        },
        {
            name: 'BlockNode',
            test: (0, $gs7TF.isBlockNode)
        },
        {
            name: 'ConditionalNode',
            test: (0, $gs7TF.isConditionalNode)
        },
        {
            name: 'ConstantNode',
            test: (0, $gs7TF.isConstantNode)
        },
        {
            name: 'FunctionNode',
            test: (0, $gs7TF.isFunctionNode)
        },
        {
            name: 'FunctionAssignmentNode',
            test: (0, $gs7TF.isFunctionAssignmentNode)
        },
        {
            name: 'IndexNode',
            test: (0, $gs7TF.isIndexNode)
        },
        {
            name: 'Node',
            test: (0, $gs7TF.isNode)
        },
        {
            name: 'ObjectNode',
            test: (0, $gs7TF.isObjectNode)
        },
        {
            name: 'OperatorNode',
            test: (0, $gs7TF.isOperatorNode)
        },
        {
            name: 'ParenthesisNode',
            test: (0, $gs7TF.isParenthesisNode)
        },
        {
            name: 'RangeNode',
            test: (0, $gs7TF.isRangeNode)
        },
        {
            name: 'SymbolNode',
            test: (0, $gs7TF.isSymbolNode)
        },
        {
            name: 'Map',
            test: (0, $o4CAS.isMap)
        },
        {
            name: 'Object',
            test: (0, $gs7TF.isObject)
        } // order 'Object' last, it matches on other classes too
    ];
    typed.conversions = [
        {
            from: 'number',
            to: 'BigNumber',
            convert: function convert(x) {
                if (!BigNumber) $db37f7f4b859fa77$var$throwNoBignumber(x);
                 // note: conversion from number to BigNumber can fail if x has >15 digits
                if ((0, $6egKm.digits)(x) > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + x + '). ' + 'Use function bignumber(x) to convert to BigNumber.');
                return new BigNumber(x);
            }
        },
        {
            from: 'number',
            to: 'Complex',
            convert: function convert(x) {
                if (!Complex) $db37f7f4b859fa77$var$throwNoComplex(x);
                return new Complex(x, 0);
            }
        },
        {
            from: 'number',
            to: 'string',
            convert: function convert(x) {
                return x + '';
            }
        },
        {
            from: 'BigNumber',
            to: 'Complex',
            convert: function convert(x) {
                if (!Complex) $db37f7f4b859fa77$var$throwNoComplex(x);
                return new Complex(x.toNumber(), 0);
            }
        },
        {
            from: 'Fraction',
            to: 'BigNumber',
            convert: function convert(x) {
                throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
            }
        },
        {
            from: 'Fraction',
            to: 'Complex',
            convert: function convert(x) {
                if (!Complex) $db37f7f4b859fa77$var$throwNoComplex(x);
                return new Complex(x.valueOf(), 0);
            }
        },
        {
            from: 'number',
            to: 'Fraction',
            convert: function convert(x) {
                if (!Fraction) $db37f7f4b859fa77$var$throwNoFraction(x);
                var f = new Fraction(x);
                if (f.valueOf() !== x) throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + x + '). ' + 'Use function fraction(x) to convert to Fraction.');
                return f;
            }
        },
        {
            // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
            //  from: 'Fraction',
            //  to: 'number',
            //  convert: function (x) {
            //    return x.valueOf()
            //  }
            // }, {
            from: 'string',
            to: 'number',
            convert: function convert(x) {
                var n = Number(x);
                if (isNaN(n)) throw new Error('Cannot convert "' + x + '" to a number');
                return n;
            }
        },
        {
            from: 'string',
            to: 'BigNumber',
            convert: function convert(x) {
                if (!BigNumber) $db37f7f4b859fa77$var$throwNoBignumber(x);
                try {
                    return new BigNumber(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to BigNumber');
                }
            }
        },
        {
            from: 'string',
            to: 'Fraction',
            convert: function convert(x) {
                if (!Fraction) $db37f7f4b859fa77$var$throwNoFraction(x);
                try {
                    return new Fraction(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Fraction');
                }
            }
        },
        {
            from: 'string',
            to: 'Complex',
            convert: function convert(x) {
                if (!Complex) $db37f7f4b859fa77$var$throwNoComplex(x);
                try {
                    return new Complex(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Complex');
                }
            }
        },
        {
            from: 'boolean',
            to: 'number',
            convert: function convert(x) {
                return +x;
            }
        },
        {
            from: 'boolean',
            to: 'BigNumber',
            convert: function convert(x) {
                if (!BigNumber) $db37f7f4b859fa77$var$throwNoBignumber(x);
                return new BigNumber(+x);
            }
        },
        {
            from: 'boolean',
            to: 'Fraction',
            convert: function convert(x) {
                if (!Fraction) $db37f7f4b859fa77$var$throwNoFraction(x);
                return new Fraction(+x);
            }
        },
        {
            from: 'boolean',
            to: 'string',
            convert: function convert(x) {
                return String(x);
            }
        },
        {
            from: 'Array',
            to: 'Matrix',
            convert: function convert(array) {
                if (!DenseMatrix) $db37f7f4b859fa77$var$throwNoMatrix();
                return new DenseMatrix(array);
            }
        },
        {
            from: 'Matrix',
            to: 'Array',
            convert: function convert(matrix) {
                return matrix.valueOf();
            }
        }
    ];
    return typed;
});
function $db37f7f4b859fa77$var$throwNoBignumber(x) {
    throw new Error("Cannot convert value ".concat(x, " into a BigNumber: no class 'BigNumber' provided"));
}
function $db37f7f4b859fa77$var$throwNoComplex(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Complex number: no class 'Complex' provided"));
}
function $db37f7f4b859fa77$var$throwNoMatrix() {
    throw new Error('Cannot convert array into a Matrix: no class \'DenseMatrix\' provided');
}
function $db37f7f4b859fa77$var$throwNoFraction(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Fraction, no class 'Fraction' provided."));
}

});
parcelRegister("gb5GC", function(module, exports) {
/**
 * typed-function
 *
 * Type checking for JavaScript functions
 *
 * https://github.com/josdejong/typed-function
 */ 'use strict';
(function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else // OldNode. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like OldNode.
    module.exports = factory();
})(module.exports, function() {
    function ok() {
        return true;
    }
    function notOk() {
        return false;
    }
    function undef() {
        return undefined;
    }
    /**
   * @typedef {{
   *   params: Param[],
   *   fn: function
   * }} Signature
   *
   * @typedef {{
   *   types: Type[],
   *   restParam: boolean
   * }} Param
   *
   * @typedef {{
   *   name: string,
   *   typeIndex: number,
   *   test: function,
   *   conversion?: ConversionDef,
   *   conversionIndex: number,
   * }} Type
   *
   * @typedef {{
   *   from: string,
   *   to: string,
   *   convert: function (*) : *
   * }} ConversionDef
   *
   * @typedef {{
   *   name: string,
   *   test: function(*) : boolean
   * }} TypeDef
   */ // create a new instance of typed-function
    function create() {
        // data type tests
        var _types = [
            {
                name: 'number',
                test: function(x) {
                    return typeof x === 'number';
                }
            },
            {
                name: 'string',
                test: function(x) {
                    return typeof x === 'string';
                }
            },
            {
                name: 'boolean',
                test: function(x) {
                    return typeof x === 'boolean';
                }
            },
            {
                name: 'Function',
                test: function(x) {
                    return typeof x === 'function';
                }
            },
            {
                name: 'Array',
                test: Array.isArray
            },
            {
                name: 'Date',
                test: function(x) {
                    return x instanceof Date;
                }
            },
            {
                name: 'RegExp',
                test: function(x) {
                    return x instanceof RegExp;
                }
            },
            {
                name: 'Object',
                test: function(x) {
                    return typeof x === 'object' && x !== null && x.constructor === Object;
                }
            },
            {
                name: 'null',
                test: function(x) {
                    return x === null;
                }
            },
            {
                name: 'undefined',
                test: function(x) {
                    return x === undefined;
                }
            }
        ];
        var anyType = {
            name: 'any',
            test: ok
        };
        // types which need to be ignored
        var _ignore = [];
        // type conversions
        var _conversions = [];
        // This is a temporary object, will be replaced with a typed function at the end
        var typed = {
            types: _types,
            conversions: _conversions,
            ignore: _ignore
        };
        /**
     * Find the test function for a type
     * @param {String} typeName
     * @return {TypeDef} Returns the type definition when found,
     *                    Throws a TypeError otherwise
     */ function findTypeByName(typeName) {
            var entry = findInArray(typed.types, function(entry) {
                return entry.name === typeName;
            });
            if (entry) return entry;
            if (typeName === 'any') return anyType;
            var hint = findInArray(typed.types, function(entry) {
                return entry.name.toLowerCase() === typeName.toLowerCase();
            });
            throw new TypeError('Unknown type "' + typeName + '"' + (hint ? '. Did you mean "' + hint.name + '"?' : ''));
        }
        /**
     * Find the index of a type definition. Handles special case 'any'
     * @param {TypeDef} type
     * @return {number}
     */ function findTypeIndex(type) {
            if (type === anyType) return 999;
            return typed.types.indexOf(type);
        }
        /**
     * Find a type that matches a value.
     * @param {*} value
     * @return {string} Returns the name of the first type for which
     *                  the type test matches the value.
     */ function findTypeName(value) {
            var entry = findInArray(typed.types, function(entry) {
                return entry.test(value);
            });
            if (entry) return entry.name;
            throw new TypeError('Value has unknown type. Value: ' + value);
        }
        /**
     * Find a specific signature from a (composed) typed function, for example:
     *
     *   typed.find(fn, ['number', 'string'])
     *   typed.find(fn, 'number, string')
     *
     * Function find only only works for exact matches.
     *
     * @param {Function} fn                   A typed-function
     * @param {string | string[]} signature   Signature to be found, can be
     *                                        an array or a comma separated string.
     * @return {Function}                     Returns the matching signature, or
     *                                        throws an error when no signature
     *                                        is found.
     */ function find(fn, signature) {
            if (!fn.signatures) throw new TypeError('Function is no typed-function');
            // normalize input
            var arr;
            if (typeof signature === 'string') {
                arr = signature.split(',');
                for(var i = 0; i < arr.length; i++)arr[i] = arr[i].trim();
            } else if (Array.isArray(signature)) arr = signature;
            else throw new TypeError('String array or a comma separated string expected');
            var str = arr.join(',');
            // find an exact match
            var match = fn.signatures[str];
            if (match) return match;
            // TODO: extend find to match non-exact signatures
            throw new TypeError('Signature not found (signature: ' + (fn.name || 'unnamed') + '(' + arr.join(', ') + '))');
        }
        /**
     * Convert a given value to another data type.
     * @param {*} value
     * @param {string} type
     */ function convert(value, type) {
            var from = findTypeName(value);
            // check conversion is needed
            if (type === from) return value;
            for(var i = 0; i < typed.conversions.length; i++){
                var conversion = typed.conversions[i];
                if (conversion.from === from && conversion.to === type) return conversion.convert(value);
            }
            throw new Error('Cannot convert from ' + from + ' to ' + type);
        }
        /**
     * Stringify parameters in a normalized way
     * @param {Param[]} params
     * @return {string}
     */ function stringifyParams(params) {
            return params.map(function(param) {
                var typeNames = param.types.map(getTypeName);
                return (param.restParam ? '...' : '') + typeNames.join('|');
            }).join(',');
        }
        /**
     * Parse a parameter, like "...number | boolean"
     * @param {string} param
     * @param {ConversionDef[]} conversions
     * @return {Param} param
     */ function parseParam(param, conversions) {
            var restParam = param.indexOf('...') === 0;
            var types = !restParam ? param : param.length > 3 ? param.slice(3) : 'any';
            var typeNames = types.split('|').map(trim).filter(notEmpty).filter(notIgnore);
            var matchingConversions = filterConversions(conversions, typeNames);
            var exactTypes = typeNames.map(function(typeName) {
                var type = findTypeByName(typeName);
                return {
                    name: typeName,
                    typeIndex: findTypeIndex(type),
                    test: type.test,
                    conversion: null,
                    conversionIndex: -1
                };
            });
            var convertibleTypes = matchingConversions.map(function(conversion) {
                var type = findTypeByName(conversion.from);
                return {
                    name: conversion.from,
                    typeIndex: findTypeIndex(type),
                    test: type.test,
                    conversion: conversion,
                    conversionIndex: conversions.indexOf(conversion)
                };
            });
            return {
                types: exactTypes.concat(convertibleTypes),
                restParam: restParam
            };
        }
        /**
     * Parse a signature with comma separated parameters,
     * like "number | boolean, ...string"
     * @param {string} signature
     * @param {function} fn
     * @param {ConversionDef[]} conversions
     * @return {Signature | null} signature
     */ function parseSignature(signature, fn, conversions) {
            var params = [];
            if (signature.trim() !== '') params = signature.split(',').map(trim).map(function(param, index, array) {
                var parsedParam = parseParam(param, conversions);
                if (parsedParam.restParam && index !== array.length - 1) throw new SyntaxError('Unexpected rest parameter "' + param + '": ' + 'only allowed for the last parameter');
                return parsedParam;
            });
            if (params.some(isInvalidParam)) // invalid signature: at least one parameter has no types
            // (they may have been filtered)
            return null;
            return {
                params: params,
                fn: fn
            };
        }
        /**
     * Test whether a set of params contains a restParam
     * @param {Param[]} params
     * @return {boolean} Returns true when the last parameter is a restParam
     */ function hasRestParam(params) {
            var param = last(params);
            return param ? param.restParam : false;
        }
        /**
     * Test whether a parameter contains conversions
     * @param {Param} param
     * @return {boolean} Returns true when at least one of the parameters
     *                   contains a conversion.
     */ function hasConversions(param) {
            return param.types.some(function(type) {
                return type.conversion != null;
            });
        }
        /**
     * Create a type test for a single parameter, which can have one or multiple
     * types.
     * @param {Param} param
     * @return {function(x: *) : boolean} Returns a test function
     */ function compileTest(param) {
            if (!param || param.types.length === 0) // nothing to do
            return ok;
            else if (param.types.length === 1) return findTypeByName(param.types[0].name).test;
            else if (param.types.length === 2) {
                var test0 = findTypeByName(param.types[0].name).test;
                var test1 = findTypeByName(param.types[1].name).test;
                return function or(x) {
                    return test0(x) || test1(x);
                };
            } else {
                var tests = param.types.map(function(type) {
                    return findTypeByName(type.name).test;
                });
                return function or(x) {
                    for(var i = 0; i < tests.length; i++){
                        if (tests[i](x)) return true;
                    }
                    return false;
                };
            }
        }
        /**
     * Create a test for all parameters of a signature
     * @param {Param[]} params
     * @return {function(args: Array<*>) : boolean}
     */ function compileTests(params) {
            var tests, test0, test1;
            if (hasRestParam(params)) {
                // variable arguments like '...number'
                tests = initial(params).map(compileTest);
                var varIndex = tests.length;
                var lastTest = compileTest(last(params));
                var testRestParam = function(args) {
                    for(var i = varIndex; i < args.length; i++){
                        if (!lastTest(args[i])) return false;
                    }
                    return true;
                };
                return function testArgs(args) {
                    for(var i = 0; i < tests.length; i++){
                        if (!tests[i](args[i])) return false;
                    }
                    return testRestParam(args) && args.length >= varIndex + 1;
                };
            } else {
                // no variable arguments
                if (params.length === 0) return function testArgs(args) {
                    return args.length === 0;
                };
                else if (params.length === 1) {
                    test0 = compileTest(params[0]);
                    return function testArgs(args) {
                        return test0(args[0]) && args.length === 1;
                    };
                } else if (params.length === 2) {
                    test0 = compileTest(params[0]);
                    test1 = compileTest(params[1]);
                    return function testArgs(args) {
                        return test0(args[0]) && test1(args[1]) && args.length === 2;
                    };
                } else {
                    tests = params.map(compileTest);
                    return function testArgs(args) {
                        for(var i = 0; i < tests.length; i++){
                            if (!tests[i](args[i])) return false;
                        }
                        return args.length === tests.length;
                    };
                }
            }
        }
        /**
     * Find the parameter at a specific index of a signature.
     * Handles rest parameters.
     * @param {Signature} signature
     * @param {number} index
     * @return {Param | null} Returns the matching parameter when found,
     *                        null otherwise.
     */ function getParamAtIndex(signature, index) {
            return index < signature.params.length ? signature.params[index] : hasRestParam(signature.params) ? last(signature.params) : null;
        }
        /**
     * Get all type names of a parameter
     * @param {Signature} signature
     * @param {number} index
     * @param {boolean} excludeConversions
     * @return {string[]} Returns an array with type names
     */ function getExpectedTypeNames(signature, index, excludeConversions) {
            var param = getParamAtIndex(signature, index);
            var types = param ? excludeConversions ? param.types.filter(isExactType) : param.types : [];
            return types.map(getTypeName);
        }
        /**
     * Returns the name of a type
     * @param {Type} type
     * @return {string} Returns the type name
     */ function getTypeName(type) {
            return type.name;
        }
        /**
     * Test whether a type is an exact type or conversion
     * @param {Type} type
     * @return {boolean} Returns true when
     */ function isExactType(type) {
            return type.conversion === null || type.conversion === undefined;
        }
        /**
     * Helper function for creating error messages: create an array with
     * all available types on a specific argument index.
     * @param {Signature[]} signatures
     * @param {number} index
     * @return {string[]} Returns an array with available types
     */ function mergeExpectedParams(signatures, index) {
            var typeNames = uniq(flatMap(signatures, function(signature) {
                return getExpectedTypeNames(signature, index, false);
            }));
            return typeNames.indexOf('any') !== -1 ? [
                'any'
            ] : typeNames;
        }
        /**
     * Create
     * @param {string} name             The name of the function
     * @param {array.<*>} args          The actual arguments passed to the function
     * @param {Signature[]} signatures  A list with available signatures
     * @return {TypeError} Returns a type error with additional data
     *                     attached to it in the property `data`
     */ function createError(name, args, signatures) {
            var err, expected;
            var _name = name || 'unnamed';
            // test for wrong type at some index
            var matchingSignatures = signatures;
            var index;
            for(index = 0; index < args.length; index++){
                var nextMatchingDefs = matchingSignatures.filter(function(signature) {
                    var test = compileTest(getParamAtIndex(signature, index));
                    return (index < signature.params.length || hasRestParam(signature.params)) && test(args[index]);
                });
                if (nextMatchingDefs.length === 0) {
                    // no matching signatures anymore, throw error "wrong type"
                    expected = mergeExpectedParams(matchingSignatures, index);
                    if (expected.length > 0) {
                        var actualType = findTypeName(args[index]);
                        err = new TypeError('Unexpected type of argument in function ' + _name + ' (expected: ' + expected.join(' or ') + ', actual: ' + actualType + ', index: ' + index + ')');
                        err.data = {
                            category: 'wrongType',
                            fn: _name,
                            index: index,
                            actual: actualType,
                            expected: expected
                        };
                        return err;
                    }
                } else matchingSignatures = nextMatchingDefs;
            }
            // test for too few arguments
            var lengths = matchingSignatures.map(function(signature) {
                return hasRestParam(signature.params) ? Infinity : signature.params.length;
            });
            if (args.length < Math.min.apply(null, lengths)) {
                expected = mergeExpectedParams(matchingSignatures, index);
                err = new TypeError('Too few arguments in function ' + _name + ' (expected: ' + expected.join(' or ') + ', index: ' + args.length + ')');
                err.data = {
                    category: 'tooFewArgs',
                    fn: _name,
                    index: args.length,
                    expected: expected
                };
                return err;
            }
            // test for too many arguments
            var maxLength = Math.max.apply(null, lengths);
            if (args.length > maxLength) {
                err = new TypeError('Too many arguments in function ' + _name + ' (expected: ' + maxLength + ', actual: ' + args.length + ')');
                err.data = {
                    category: 'tooManyArgs',
                    fn: _name,
                    index: args.length,
                    expectedLength: maxLength
                };
                return err;
            }
            err = new TypeError('Arguments of type "' + args.join(', ') + '" do not match any of the defined signatures of function ' + _name + '.');
            err.data = {
                category: 'mismatch',
                actual: args.map(findTypeName)
            };
            return err;
        }
        /**
     * Find the lowest index of all exact types of a parameter (no conversions)
     * @param {Param} param
     * @return {number} Returns the index of the lowest type in typed.types
     */ function getLowestTypeIndex(param) {
            var min = 999;
            for(var i = 0; i < param.types.length; i++)if (isExactType(param.types[i])) min = Math.min(min, param.types[i].typeIndex);
            return min;
        }
        /**
     * Find the lowest index of the conversion of all types of the parameter
     * having a conversion
     * @param {Param} param
     * @return {number} Returns the lowest index of the conversions of this type
     */ function getLowestConversionIndex(param) {
            var min = 999;
            for(var i = 0; i < param.types.length; i++)if (!isExactType(param.types[i])) min = Math.min(min, param.types[i].conversionIndex);
            return min;
        }
        /**
     * Compare two params
     * @param {Param} param1
     * @param {Param} param2
     * @return {number} returns a negative number when param1 must get a lower
     *                  index than param2, a positive number when the opposite,
     *                  or zero when both are equal
     */ function compareParams(param1, param2) {
            var c;
            // compare having a rest parameter or not
            c = param1.restParam - param2.restParam;
            if (c !== 0) return c;
            // compare having conversions or not
            c = hasConversions(param1) - hasConversions(param2);
            if (c !== 0) return c;
            // compare the index of the types
            c = getLowestTypeIndex(param1) - getLowestTypeIndex(param2);
            if (c !== 0) return c;
            // compare the index of any conversion
            return getLowestConversionIndex(param1) - getLowestConversionIndex(param2);
        }
        /**
     * Compare two signatures
     * @param {Signature} signature1
     * @param {Signature} signature2
     * @return {number} returns a negative number when param1 must get a lower
     *                  index than param2, a positive number when the opposite,
     *                  or zero when both are equal
     */ function compareSignatures(signature1, signature2) {
            var len = Math.min(signature1.params.length, signature2.params.length);
            var i;
            var c;
            // compare whether the params have conversions at all or not
            c = signature1.params.some(hasConversions) - signature2.params.some(hasConversions);
            if (c !== 0) return c;
            // next compare whether the params have conversions one by one
            for(i = 0; i < len; i++){
                c = hasConversions(signature1.params[i]) - hasConversions(signature2.params[i]);
                if (c !== 0) return c;
            }
            // compare the types of the params one by one
            for(i = 0; i < len; i++){
                c = compareParams(signature1.params[i], signature2.params[i]);
                if (c !== 0) return c;
            }
            // compare the number of params
            return signature1.params.length - signature2.params.length;
        }
        /**
     * Get params containing all types that can be converted to the defined types.
     *
     * @param {ConversionDef[]} conversions
     * @param {string[]} typeNames
     * @return {ConversionDef[]} Returns the conversions that are available
     *                        for every type (if any)
     */ function filterConversions(conversions, typeNames) {
            var matches = {};
            conversions.forEach(function(conversion) {
                if (typeNames.indexOf(conversion.from) === -1 && typeNames.indexOf(conversion.to) !== -1 && !matches[conversion.from]) matches[conversion.from] = conversion;
            });
            return Object.keys(matches).map(function(from) {
                return matches[from];
            });
        }
        /**
     * Preprocess arguments before calling the original function:
     * - if needed convert the parameters
     * - in case of rest parameters, move the rest parameters into an Array
     * @param {Param[]} params
     * @param {function} fn
     * @return {function} Returns a wrapped function
     */ function compileArgsPreprocessing(params, fn) {
            var fnConvert = fn;
            // TODO: can we make this wrapper function smarter/simpler?
            if (params.some(hasConversions)) {
                var restParam = hasRestParam(params);
                var compiledConversions = params.map(compileArgConversion);
                fnConvert = function convertArgs() {
                    var args = [];
                    var last = restParam ? arguments.length - 1 : arguments.length;
                    for(var i = 0; i < last; i++)args[i] = compiledConversions[i](arguments[i]);
                    if (restParam) args[last] = arguments[last].map(compiledConversions[last]);
                    return fn.apply(this, args);
                };
            }
            var fnPreprocess = fnConvert;
            if (hasRestParam(params)) {
                var offset = params.length - 1;
                fnPreprocess = function preprocessRestParams() {
                    return fnConvert.apply(this, slice(arguments, 0, offset).concat([
                        slice(arguments, offset)
                    ]));
                };
            }
            return fnPreprocess;
        }
        /**
     * Compile conversion for a parameter to the right type
     * @param {Param} param
     * @return {function} Returns the wrapped function that will convert arguments
     *
     */ function compileArgConversion(param) {
            var test0, test1, conversion0, conversion1;
            var tests = [];
            var conversions = [];
            param.types.forEach(function(type) {
                if (type.conversion) {
                    tests.push(findTypeByName(type.conversion.from).test);
                    conversions.push(type.conversion.convert);
                }
            });
            // create optimized conversion functions depending on the number of conversions
            switch(conversions.length){
                case 0:
                    return function convertArg(arg) {
                        return arg;
                    };
                case 1:
                    test0 = tests[0];
                    conversion0 = conversions[0];
                    return function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        return arg;
                    };
                case 2:
                    test0 = tests[0];
                    test1 = tests[1];
                    conversion0 = conversions[0];
                    conversion1 = conversions[1];
                    return function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        if (test1(arg)) return conversion1(arg);
                        return arg;
                    };
                default:
                    return function convertArg(arg) {
                        for(var i = 0; i < conversions.length; i++){
                            if (tests[i](arg)) return conversions[i](arg);
                        }
                        return arg;
                    };
            }
        }
        /**
     * Convert an array with signatures into a map with signatures,
     * where signatures with union types are split into separate signatures
     *
     * Throws an error when there are conflicting types
     *
     * @param {Signature[]} signatures
     * @return {Object.<string, function>}  Returns a map with signatures
     *                                      as key and the original function
     *                                      of this signature as value.
     */ function createSignaturesMap(signatures) {
            var signaturesMap = {};
            signatures.forEach(function(signature) {
                if (!signature.params.some(hasConversions)) splitParams(signature.params, true).forEach(function(params) {
                    signaturesMap[stringifyParams(params)] = signature.fn;
                });
            });
            return signaturesMap;
        }
        /**
     * Split params with union types in to separate params.
     *
     * For example:
     *
     *     splitParams([['Array', 'Object'], ['string', 'RegExp'])
     *     // returns:
     *     // [
     *     //   ['Array', 'string'],
     *     //   ['Array', 'RegExp'],
     *     //   ['Object', 'string'],
     *     //   ['Object', 'RegExp']
     *     // ]
     *
     * @param {Param[]} params
     * @param {boolean} ignoreConversionTypes
     * @return {Param[]}
     */ function splitParams(params, ignoreConversionTypes) {
            function _splitParams(params, index, types) {
                if (index < params.length) {
                    var param = params[index];
                    var filteredTypes = ignoreConversionTypes ? param.types.filter(isExactType) : param.types;
                    var typeGroups;
                    if (param.restParam) {
                        // split the types of a rest parameter in two:
                        // one with only exact types, and one with exact types and conversions
                        var exactTypes = filteredTypes.filter(isExactType);
                        typeGroups = exactTypes.length < filteredTypes.length ? [
                            exactTypes,
                            filteredTypes
                        ] : [
                            filteredTypes
                        ];
                    } else // split all the types of a regular parameter into one type per group
                    typeGroups = filteredTypes.map(function(type) {
                        return [
                            type
                        ];
                    });
                    // recurse over the groups with types
                    return flatMap(typeGroups, function(typeGroup) {
                        return _splitParams(params, index + 1, types.concat([
                            typeGroup
                        ]));
                    });
                } else {
                    // we've reached the end of the parameters. Now build a new Param
                    var splittedParams = types.map(function(type, typeIndex) {
                        return {
                            types: type,
                            restParam: typeIndex === params.length - 1 && hasRestParam(params)
                        };
                    });
                    return [
                        splittedParams
                    ];
                }
            }
            return _splitParams(params, 0, []);
        }
        /**
     * Test whether two signatures have a conflicting signature
     * @param {Signature} signature1
     * @param {Signature} signature2
     * @return {boolean} Returns true when the signatures conflict, false otherwise.
     */ function hasConflictingParams(signature1, signature2) {
            var ii = Math.max(signature1.params.length, signature2.params.length);
            for(var i = 0; i < ii; i++){
                var typesNames1 = getExpectedTypeNames(signature1, i, true);
                var typesNames2 = getExpectedTypeNames(signature2, i, true);
                if (!hasOverlap(typesNames1, typesNames2)) return false;
            }
            var len1 = signature1.params.length;
            var len2 = signature2.params.length;
            var restParam1 = hasRestParam(signature1.params);
            var restParam2 = hasRestParam(signature2.params);
            return restParam1 ? restParam2 ? len1 === len2 : len2 >= len1 : restParam2 ? len1 >= len2 : len1 === len2;
        }
        /**
     * Create a typed function
     * @param {String} name               The name for the typed function
     * @param {Object.<string, function>} signaturesMap
     *                                    An object with one or
     *                                    multiple signatures as key, and the
     *                                    function corresponding to the
     *                                    signature as value.
     * @return {function}  Returns the created typed function.
     */ function createTypedFunction(name, signaturesMap) {
            if (Object.keys(signaturesMap).length === 0) throw new SyntaxError('No signatures provided');
            // parse the signatures, and check for conflicts
            var parsedSignatures = [];
            Object.keys(signaturesMap).map(function(signature) {
                return parseSignature(signature, signaturesMap[signature], typed.conversions);
            }).filter(notNull).forEach(function(parsedSignature) {
                // check whether this parameter conflicts with already parsed signatures
                var conflictingSignature = findInArray(parsedSignatures, function(s) {
                    return hasConflictingParams(s, parsedSignature);
                });
                if (conflictingSignature) throw new TypeError('Conflicting signatures "' + stringifyParams(conflictingSignature.params) + '" and "' + stringifyParams(parsedSignature.params) + '".');
                parsedSignatures.push(parsedSignature);
            });
            // split and filter the types of the signatures, and then order them
            var signatures = flatMap(parsedSignatures, function(parsedSignature) {
                var params = parsedSignature ? splitParams(parsedSignature.params, false) : [];
                return params.map(function(params) {
                    return {
                        params: params,
                        fn: parsedSignature.fn
                    };
                });
            }).filter(notNull);
            signatures.sort(compareSignatures);
            // we create a highly optimized checks for the first couple of signatures with max 2 arguments
            var ok0 = signatures[0] && signatures[0].params.length <= 2 && !hasRestParam(signatures[0].params);
            var ok1 = signatures[1] && signatures[1].params.length <= 2 && !hasRestParam(signatures[1].params);
            var ok2 = signatures[2] && signatures[2].params.length <= 2 && !hasRestParam(signatures[2].params);
            var ok3 = signatures[3] && signatures[3].params.length <= 2 && !hasRestParam(signatures[3].params);
            var ok4 = signatures[4] && signatures[4].params.length <= 2 && !hasRestParam(signatures[4].params);
            var ok5 = signatures[5] && signatures[5].params.length <= 2 && !hasRestParam(signatures[5].params);
            var allOk = ok0 && ok1 && ok2 && ok3 && ok4 && ok5;
            // compile the tests
            var tests = signatures.map(function(signature) {
                return compileTests(signature.params);
            });
            var test00 = ok0 ? compileTest(signatures[0].params[0]) : notOk;
            var test10 = ok1 ? compileTest(signatures[1].params[0]) : notOk;
            var test20 = ok2 ? compileTest(signatures[2].params[0]) : notOk;
            var test30 = ok3 ? compileTest(signatures[3].params[0]) : notOk;
            var test40 = ok4 ? compileTest(signatures[4].params[0]) : notOk;
            var test50 = ok5 ? compileTest(signatures[5].params[0]) : notOk;
            var test01 = ok0 ? compileTest(signatures[0].params[1]) : notOk;
            var test11 = ok1 ? compileTest(signatures[1].params[1]) : notOk;
            var test21 = ok2 ? compileTest(signatures[2].params[1]) : notOk;
            var test31 = ok3 ? compileTest(signatures[3].params[1]) : notOk;
            var test41 = ok4 ? compileTest(signatures[4].params[1]) : notOk;
            var test51 = ok5 ? compileTest(signatures[5].params[1]) : notOk;
            // compile the functions
            var fns = signatures.map(function(signature) {
                return compileArgsPreprocessing(signature.params, signature.fn);
            });
            var fn0 = ok0 ? fns[0] : undef;
            var fn1 = ok1 ? fns[1] : undef;
            var fn2 = ok2 ? fns[2] : undef;
            var fn3 = ok3 ? fns[3] : undef;
            var fn4 = ok4 ? fns[4] : undef;
            var fn5 = ok5 ? fns[5] : undef;
            var len0 = ok0 ? signatures[0].params.length : -1;
            var len1 = ok1 ? signatures[1].params.length : -1;
            var len2 = ok2 ? signatures[2].params.length : -1;
            var len3 = ok3 ? signatures[3].params.length : -1;
            var len4 = ok4 ? signatures[4].params.length : -1;
            var len5 = ok5 ? signatures[5].params.length : -1;
            // simple and generic, but also slow
            var iStart = allOk ? 6 : 0;
            var iEnd = signatures.length;
            var generic = function generic() {
                'use strict';
                for(var i = iStart; i < iEnd; i++){
                    if (tests[i](arguments)) return fns[i].apply(this, arguments);
                }
                return typed.onMismatch(name, arguments, signatures);
            };
            // create the typed function
            // fast, specialized version. Falls back to the slower, generic one if needed
            var fn = function fn(arg0, arg1) {
                'use strict';
                if (arguments.length === len0 && test00(arg0) && test01(arg1)) return fn0.apply(fn, arguments);
                if (arguments.length === len1 && test10(arg0) && test11(arg1)) return fn1.apply(fn, arguments);
                if (arguments.length === len2 && test20(arg0) && test21(arg1)) return fn2.apply(fn, arguments);
                if (arguments.length === len3 && test30(arg0) && test31(arg1)) return fn3.apply(fn, arguments);
                if (arguments.length === len4 && test40(arg0) && test41(arg1)) return fn4.apply(fn, arguments);
                if (arguments.length === len5 && test50(arg0) && test51(arg1)) return fn5.apply(fn, arguments);
                return generic.apply(fn, arguments);
            };
            // attach name the typed function
            try {
                Object.defineProperty(fn, 'name', {
                    value: name
                });
            } catch (err) {
            // old browsers do not support Object.defineProperty and some don't support setting the name property
            // the function name is not essential for the functioning, it's mostly useful for debugging,
            // so it's fine to have unnamed functions.
            }
            // attach signatures to the function
            fn.signatures = createSignaturesMap(signatures);
            return fn;
        }
        /**
     * Action to take on mismatch
     * @param {string} name      Name of function that was attempted to be called
     * @param {Array} args       Actual arguments to the call
     * @param {Array} signatures Known signatures of the named typed-function
     */ function _onMismatch(name, args, signatures) {
            throw createError(name, args, signatures);
        }
        /**
     * Test whether a type should be NOT be ignored
     * @param {string} typeName
     * @return {boolean}
     */ function notIgnore(typeName) {
            return typed.ignore.indexOf(typeName) === -1;
        }
        /**
     * trim a string
     * @param {string} str
     * @return {string}
     */ function trim(str) {
            return str.trim();
        }
        /**
     * Test whether a string is not empty
     * @param {string} str
     * @return {boolean}
     */ function notEmpty(str) {
            return !!str;
        }
        /**
     * test whether a value is not strict equal to null
     * @param {*} value
     * @return {boolean}
     */ function notNull(value) {
            return value !== null;
        }
        /**
     * Test whether a parameter has no types defined
     * @param {Param} param
     * @return {boolean}
     */ function isInvalidParam(param) {
            return param.types.length === 0;
        }
        /**
     * Return all but the last items of an array
     * @param {Array} arr
     * @return {Array}
     */ function initial(arr) {
            return arr.slice(0, arr.length - 1);
        }
        /**
     * return the last item of an array
     * @param {Array} arr
     * @return {*}
     */ function last(arr) {
            return arr[arr.length - 1];
        }
        /**
     * Slice an array or function Arguments
     * @param {Array | Arguments | IArguments} arr
     * @param {number} start
     * @param {number} [end]
     * @return {Array}
     */ function slice(arr, start, end) {
            return Array.prototype.slice.call(arr, start, end);
        }
        /**
     * Test whether an array contains some item
     * @param {Array} array
     * @param {*} item
     * @return {boolean} Returns true if array contains item, false if not.
     */ function contains(array, item) {
            return array.indexOf(item) !== -1;
        }
        /**
     * Test whether two arrays have overlapping items
     * @param {Array} array1
     * @param {Array} array2
     * @return {boolean} Returns true when at least one item exists in both arrays
     */ function hasOverlap(array1, array2) {
            for(var i = 0; i < array1.length; i++){
                if (contains(array2, array1[i])) return true;
            }
            return false;
        }
        /**
     * Return the first item from an array for which test(arr[i]) returns true
     * @param {Array} arr
     * @param {function} test
     * @return {* | undefined} Returns the first matching item
     *                         or undefined when there is no match
     */ function findInArray(arr, test) {
            for(var i = 0; i < arr.length; i++){
                if (test(arr[i])) return arr[i];
            }
            return undefined;
        }
        /**
     * Filter unique items of an array with strings
     * @param {string[]} arr
     * @return {string[]}
     */ function uniq(arr) {
            var entries = {};
            for(var i = 0; i < arr.length; i++)entries[arr[i]] = true;
            return Object.keys(entries);
        }
        /**
     * Flat map the result invoking a callback for every item in an array.
     * https://gist.github.com/samgiles/762ee337dff48623e729
     * @param {Array} arr
     * @param {function} callback
     * @return {Array}
     */ function flatMap(arr, callback) {
            return Array.prototype.concat.apply([], arr.map(callback));
        }
        /**
     * Retrieve the function name from a set of typed functions,
     * and check whether the name of all functions match (if given)
     * @param {function[]} fns
     */ function getName(fns) {
            var name = '';
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                // check whether the names are the same when defined
                if ((typeof fn.signatures === 'object' || typeof fn.signature === 'string') && fn.name !== '') {
                    if (name === '') name = fn.name;
                    else if (name !== fn.name) {
                        var err = new Error('Function names do not match (expected: ' + name + ', actual: ' + fn.name + ')');
                        err.data = {
                            actual: fn.name,
                            expected: name
                        };
                        throw err;
                    }
                }
            }
            return name;
        }
        // extract and merge all signatures of a list with typed functions
        function extractSignatures(fns) {
            var err;
            var signaturesMap = {};
            function validateUnique(_signature, _fn) {
                if (signaturesMap.hasOwnProperty(_signature) && _fn !== signaturesMap[_signature]) {
                    err = new Error('Signature "' + _signature + '" is defined twice');
                    err.data = {
                        signature: _signature
                    };
                    throw err;
                // else: both signatures point to the same function, that's fine
                }
            }
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                // test whether this is a typed-function
                if (typeof fn.signatures === 'object') {
                    // merge the signatures
                    for(var signature in fn.signatures)if (fn.signatures.hasOwnProperty(signature)) {
                        validateUnique(signature, fn.signatures[signature]);
                        signaturesMap[signature] = fn.signatures[signature];
                    }
                } else if (typeof fn.signature === 'string') {
                    validateUnique(fn.signature, fn);
                    signaturesMap[fn.signature] = fn;
                } else {
                    err = new TypeError('Function is no typed-function (index: ' + i + ')');
                    err.data = {
                        index: i
                    };
                    throw err;
                }
            }
            return signaturesMap;
        }
        typed = createTypedFunction('typed', {
            'string, Object': createTypedFunction,
            'Object': function(signaturesMap) {
                // find existing name
                var fns = [];
                for(var signature in signaturesMap)if (signaturesMap.hasOwnProperty(signature)) fns.push(signaturesMap[signature]);
                var name = getName(fns);
                return createTypedFunction(name, signaturesMap);
            },
            '...Function': function(fns) {
                return createTypedFunction(getName(fns), extractSignatures(fns));
            },
            'string, ...Function': function(name, fns) {
                return createTypedFunction(name, extractSignatures(fns));
            }
        });
        typed.create = create;
        typed.types = _types;
        typed.conversions = _conversions;
        typed.ignore = _ignore;
        typed.onMismatch = _onMismatch;
        typed.throwMismatchError = _onMismatch;
        typed.createError = createError;
        typed.convert = convert;
        typed.find = find;
        /**
     * add a type
     * @param {{name: string, test: function}} type
     * @param {boolean} [beforeObjectTest=true]
     *                          If true, the new test will be inserted before
     *                          the test with name 'Object' (if any), since
     *                          tests for Object match Array and classes too.
     */ typed.addType = function(type, beforeObjectTest) {
            if (!type || typeof type.name !== 'string' || typeof type.test !== 'function') throw new TypeError('Object with properties {name: string, test: function} expected');
            if (beforeObjectTest !== false) {
                for(var i = 0; i < typed.types.length; i++)if (typed.types[i].name === 'Object') {
                    typed.types.splice(i, 0, type);
                    return;
                }
            }
            typed.types.push(type);
        };
        // add a conversion
        typed.addConversion = function(conversion) {
            if (!conversion || typeof conversion.from !== 'string' || typeof conversion.to !== 'string' || typeof conversion.convert !== 'function') throw new TypeError('Object with properties {from: string, to: string, convert: function} expected');
            typed.conversions.push(conversion);
        };
        return typed;
    }
    return create();
});

});

parcelRegister("o4CAS", function(module, exports) {

$parcel$export(module.exports, "isMap", () => $0485d3bc4fcb3ded$export$5c90113a285f2241);

var $5em9H = parcelRequire("5em9H");

var $gs7TF = parcelRequire("gs7TF");
class $0485d3bc4fcb3ded$export$6f491f8f4fd27271 {
    constructor(object){
        this.wrappedObject = object;
    }
    keys() {
        return Object.keys(this.wrappedObject);
    }
    get(key) {
        return (0, $5em9H.getSafeProperty)(this.wrappedObject, key);
    }
    set(key, value) {
        (0, $5em9H.setSafeProperty)(this.wrappedObject, key, value);
        return this;
    }
    has(key) {
        return (0, $5em9H.hasSafeProperty)(this.wrappedObject, key);
    }
}
function $0485d3bc4fcb3ded$export$89a4bcaf5b4d37d2() {
    return new Map();
}
function $0485d3bc4fcb3ded$export$d49c9aa30b771d59(mapOrObject) {
    if (!mapOrObject) return $0485d3bc4fcb3ded$export$89a4bcaf5b4d37d2();
    if ($0485d3bc4fcb3ded$export$5c90113a285f2241(mapOrObject)) return mapOrObject;
    if ((0, $gs7TF.isObject)(mapOrObject)) return new $0485d3bc4fcb3ded$export$6f491f8f4fd27271(mapOrObject);
    throw new Error('createMap can create maps from objects or Maps');
}
function $0485d3bc4fcb3ded$export$697e4a1b90752ce2(map) {
    if (map instanceof $0485d3bc4fcb3ded$export$6f491f8f4fd27271) return map.wrappedObject;
    var object = {};
    for (var key of map.keys()){
        var value = map.get(key);
        (0, $5em9H.setSafeProperty)(object, key, value);
    }
    return object;
}
function $0485d3bc4fcb3ded$export$5c90113a285f2241(object) {
    // We can use the fast instanceof, or a slower duck typing check.
    // The duck typing method needs to cover enough methods to not be confused with DenseMatrix.
    if (!object) return false;
    return object instanceof Map || object instanceof $0485d3bc4fcb3ded$export$6f491f8f4fd27271 || typeof object.set === 'function' && typeof object.get === 'function' && typeof object.keys === 'function' && typeof object.has === 'function';
}
function $0485d3bc4fcb3ded$export$e6e34fd1f2686227(map) {
    for(var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)objects[_key - 1] = arguments[_key];
    for (var args of objects){
        if (!args) continue;
        if ($0485d3bc4fcb3ded$export$5c90113a285f2241(args)) for (var key of args.keys())map.set(key, args.get(key));
        else if ((0, $gs7TF.isObject)(args)) for (var _key2 of Object.keys(args))map.set(_key2, args[_key2]);
    }
    return map;
}

});


parcelRegister("3tozm", function(module, exports) {

$parcel$export(module.exports, "createTypeOf", () => $28772380945616ee$export$d7acf116afef7b4d);

var $4eE2e = parcelRequire("4eE2e");

var $gs7TF = parcelRequire("gs7TF");
var $28772380945616ee$var$name = 'typeOf';
var $28772380945616ee$var$dependencies = [
    'typed'
];
var $28772380945616ee$export$d7acf116afef7b4d = /* #__PURE__ */ (0, $4eE2e.factory)($28772380945616ee$var$name, $28772380945616ee$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Determine the type of a variable.
   *
   * Function `typeOf` recognizes the following types of objects:
   *
   * Object                 | Returns       | Example
   * ---------------------- | ------------- | ------------------------------------------
   * null                   | `'null'`      | `math.typeOf(null)`
   * number                 | `'number'`    | `math.typeOf(3.5)`
   * boolean                | `'boolean'`   | `math.typeOf(true)`
   * string                 | `'string'`    | `math.typeOf('hello world')`
   * Array                  | `'Array'`     | `math.typeOf([1, 2, 3])`
   * Date                   | `'Date'`      | `math.typeOf(new Date())`
   * Function               | `'Function'`  | `math.typeOf(function () {})`
   * Object                 | `'Object'`    | `math.typeOf({a: 2, b: 3})`
   * RegExp                 | `'RegExp'`    | `math.typeOf(/a regexp/)`
   * undefined              | `'undefined'` | `math.typeOf(undefined)`
   * math.BigNumber         | `'BigNumber'` | `math.typeOf(math.bignumber('2.3e500'))`
   * math.Chain             | `'Chain'`     | `math.typeOf(math.chain(2))`
   * math.Complex           | `'Complex'`   | `math.typeOf(math.complex(2, 3))`
   * math.Fraction          | `'Fraction'`  | `math.typeOf(math.fraction(1, 3))`
   * math.Help              | `'Help'`      | `math.typeOf(math.help('sqrt'))`
   * math.Help              | `'Help'`      | `math.typeOf(math.help('sqrt'))`
   * math.Index             | `'Index'`     | `math.typeOf(math.index(1, 3))`
   * math.Matrix            | `'Matrix'`    | `math.typeOf(math.matrix([[1,2], [3, 4]]))`
   * math.Range             | `'Range'`     | `math.typeOf(math.range(0, 10))`
   * math.ResultSet         | `'ResultSet'` | `math.typeOf(math.evaluate('a=2\nb=3'))`
   * math.Unit              | `'Unit'`      | `math.typeOf(math.unit('45 deg'))`
   * math.AccessorNode            | `'AccessorNode'`            | `math.typeOf(math.parse('A[2]'))`
   * math.ArrayNode               | `'ArrayNode'`               | `math.typeOf(math.parse('[1,2,3]'))`
   * math.AssignmentNode          | `'AssignmentNode'`          | `math.typeOf(math.parse('x=2'))`
   * math.BlockNode               | `'BlockNode'`               | `math.typeOf(math.parse('a=2; b=3'))`
   * math.ConditionalNode         | `'ConditionalNode'`         | `math.typeOf(math.parse('x<0 ? -x : x'))`
   * math.ConstantNode            | `'ConstantNode'`            | `math.typeOf(math.parse('2.3'))`
   * math.FunctionAssignmentNode  | `'FunctionAssignmentNode'`  | `math.typeOf(math.parse('f(x)=x^2'))`
   * math.FunctionNode            | `'FunctionNode'`            | `math.typeOf(math.parse('sqrt(4)'))`
   * math.IndexNode               | `'IndexNode'`               | `math.typeOf(math.parse('A[2]').index)`
   * math.ObjectNode              | `'ObjectNode'`              | `math.typeOf(math.parse('{a:2}'))`
   * math.ParenthesisNode         | `'ParenthesisNode'`         | `math.typeOf(math.parse('(2+3)'))`
   * math.RangeNode               | `'RangeNode'`               | `math.typeOf(math.parse('1:10'))`
   * math.SymbolNode              | `'SymbolNode'`              | `math.typeOf(math.parse('x'))`
   *
   * Syntax:
   *
   *    math.typeOf(x)
   *
   * Examples:
   *
   *    math.typeOf(3.5)                     // returns 'number'
   *    math.typeOf(math.complex('2-4i'))    // returns 'Complex'
   *    math.typeOf(math.unit('45 deg'))     // returns 'Unit'
   *    math.typeOf('hello world')           // returns 'string'
   *
   * @param {*} x     The variable for which to test the type.
   * @return {string} Returns the name of the type. Primitive types are lower case,
   *                  non-primitive types are upper-camel-case.
   *                  For example 'number', 'string', 'Array', 'Date'.
   */ return typed($28772380945616ee$var$name, {
        any: (0, $gs7TF.typeOf)
    });
});

});

parcelRegister("31sl8", function(module, exports) {

$parcel$export(module.exports, "createUnaryMinus", () => $233772ceccafeb32$export$939e1be6e134f392);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $eRNhQ = parcelRequire("eRNhQ");
var $233772ceccafeb32$var$name = 'unaryMinus';
var $233772ceccafeb32$var$dependencies = [
    'typed'
];
var $233772ceccafeb32$export$939e1be6e134f392 = /* #__PURE__ */ (0, $4eE2e.factory)($233772ceccafeb32$var$name, $233772ceccafeb32$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Inverse the sign of a value, apply a unary minus operation.
   *
   * For matrices, the function is evaluated element wise. Boolean values and
   * strings will be converted to a number. For complex numbers, both real and
   * complex value are inverted.
   *
   * Syntax:
   *
   *    math.unaryMinus(x)
   *
   * Examples:
   *
   *    math.unaryMinus(3.5)      // returns -3.5
   *    math.unaryMinus(-4.2)     // returns 4.2
   *
   * See also:
   *
   *    add, subtract, unaryPlus
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Number to be inverted.
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Returns the value with inverted sign.
   */ return typed($233772ceccafeb32$var$name, {
        number: (0, $eRNhQ.unaryMinusNumber),
        Complex: function Complex(x) {
            return x.neg();
        },
        BigNumber: function BigNumber(x) {
            return x.neg();
        },
        Fraction: function Fraction(x) {
            return x.neg();
        },
        Unit: function Unit(x) {
            var res = x.clone();
            res.value = this(x.value);
            return res;
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since unaryMinus(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        } // TODO: add support for string
    });
});

});

parcelRegister("jhCJr", function(module, exports) {

$parcel$export(module.exports, "createUnaryPlus", () => $e09da638e90fe19d$export$cb425222dc08ff4e);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");

var $eRNhQ = parcelRequire("eRNhQ");
var $e09da638e90fe19d$var$name = 'unaryPlus';
var $e09da638e90fe19d$var$dependencies = [
    'typed',
    'config',
    'BigNumber'
];
var $e09da638e90fe19d$export$cb425222dc08ff4e = /* #__PURE__ */ (0, $4eE2e.factory)($e09da638e90fe19d$var$name, $e09da638e90fe19d$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, BigNumber: BigNumber } = _ref;
    /**
   * Unary plus operation.
   * Boolean values and strings will be converted to a number, numeric values will be returned as is.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.unaryPlus(x)
   *
   * Examples:
   *
   *    math.unaryPlus(3.5)      // returns 3.5
   *    math.unaryPlus(1)     // returns 1
   *
   * See also:
   *
   *    unaryMinus, add, subtract
   *
   * @param  {number | BigNumber | Fraction | string | Complex | Unit | Array | Matrix} x
   *            Input value
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Returns the input value when numeric, converts to a number when input is non-numeric.
   */ return typed($e09da638e90fe19d$var$name, {
        number: (0, $eRNhQ.unaryPlusNumber),
        Complex: function Complex(x) {
            return x; // complex numbers are immutable
        },
        BigNumber: function BigNumber(x) {
            return x; // bignumbers are immutable
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Unit: function Unit(x) {
            return x.clone();
        },
        'Array | Matrix': function ArrayMatrix(x) {
            // deep map collection, skip zeros since unaryPlus(0) = 0
            return (0, $9nwyh.deepMap)(x, this, true);
        },
        'boolean | string': function booleanString(x) {
            // convert to a number or bignumber
            return config.number === 'BigNumber' ? new BigNumber(+x) : +x;
        }
    });
});

});

parcelRegister("10cD4", function(module, exports) {

$parcel$export(module.exports, "createUnequal", () => $0baf966fdbca1545$export$833e6c382e279d04);

var $4eE2e = parcelRequire("4eE2e");

var $6MKpt = parcelRequire("6MKpt");

var $ai5Sw = parcelRequire("ai5Sw");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $laEuG = parcelRequire("laEuG");

var $KKjvJ = parcelRequire("KKjvJ");
var $0baf966fdbca1545$var$name = 'unequal';
var $0baf966fdbca1545$var$dependencies = [
    'typed',
    'config',
    'equalScalar',
    'matrix',
    'DenseMatrix'
];
var $0baf966fdbca1545$export$833e6c382e279d04 = /* #__PURE__ */ (0, $4eE2e.factory)($0baf966fdbca1545$var$name, $0baf966fdbca1545$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, equalScalar: equalScalar, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $ai5Sw.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Test whether two values are unequal.
   *
   * The function tests whether the relative difference between x and y is
   * larger than the configured epsilon. The function cannot be used to compare
   * values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must unequal y.re, or x.im must unequal y.im.
   * Strings are compared by their numerical value.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is unequal
   * with everything except `null`, and `undefined` is unequal with everything
   * except `undefined`.
   *
   * Syntax:
   *
   *    math.unequal(x, y)
   *
   * Examples:
   *
   *    math.unequal(2 + 2, 3)       // returns true
   *    math.unequal(2 + 2, 4)       // returns false
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.unequal(a, b)           // returns false
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.unequal(c, d)           // returns [false, true, false]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.unequal(0, null)        // returns true
   * See also:
   *
   *    equal, deepEqual, smaller, smallerEq, larger, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are unequal, else returns false
   */ return typed('unequal', {
        'any, any': function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y !== null;
            if (y === null) return x !== null;
            if (x === undefined) return y !== undefined;
            if (y === undefined) return x !== undefined;
            return _unequal(x, y);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, _unequal);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, _unequal, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, _unequal, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, _unequal);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, _unequal, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, _unequal, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, _unequal, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, _unequal, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, _unequal, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, _unequal, true).valueOf();
        }
    });
    function _unequal(x, y) {
        return !equalScalar(x, y);
    }
});
var $0baf966fdbca1545$export$b0b3dad01e54080b = (0, $4eE2e.factory)($0baf966fdbca1545$var$name, [
    'typed',
    'equalScalar'
], (_ref2)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref2;
    return typed($0baf966fdbca1545$var$name, {
        'any, any': function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y !== null;
            if (y === null) return x !== null;
            if (x === undefined) return y !== undefined;
            if (y === undefined) return x !== undefined;
            return !equalScalar(x, y);
        }
    });
});

});

parcelRegister("9QsFn", function(module, exports) {

$parcel$export(module.exports, "createUnitClass", () => $72af34e832729a5b$export$3ad06557a3ac7a63);

var $8Wv3B = parcelRequire("8Wv3B");

var $OB7fF = parcelRequire("OB7fF");

var $gs7TF = parcelRequire("gs7TF");

var $4eE2e = parcelRequire("4eE2e");

var $jHpUf = parcelRequire("jHpUf");

var $aEppI = parcelRequire("aEppI");

var $4mYv9 = parcelRequire("4mYv9");

var $cUmcc = parcelRequire("cUmcc");
function $72af34e832729a5b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $72af34e832729a5b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $72af34e832729a5b$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($OB7fF)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $72af34e832729a5b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $72af34e832729a5b$var$name = 'Unit';
var $72af34e832729a5b$var$dependencies = [
    '?on',
    'config',
    'addScalar',
    'subtract',
    'multiplyScalar',
    'divideScalar',
    'pow',
    'abs',
    'fix',
    'round',
    'equal',
    'isNumeric',
    'format',
    'number',
    'Complex',
    'BigNumber',
    'Fraction'
];
var $72af34e832729a5b$export$3ad06557a3ac7a63 = /* #__PURE__ */ (0, $4eE2e.factory)($72af34e832729a5b$var$name, $72af34e832729a5b$var$dependencies, (_ref)=>{
    var { on: on, config: config, addScalar: addScalar, subtract: subtract, multiplyScalar: multiplyScalar, divideScalar: divideScalar, pow: pow, abs: abs, fix: fix, round: round, equal: equal, isNumeric: isNumeric, format: format, number: number, Complex: Complex, BigNumber: _BigNumber, Fraction: _Fraction } = _ref;
    var toNumber = number;
    /**
   * A unit can be constructed in the following ways:
   *
   *     const a = new Unit(value, name)
   *     const b = new Unit(null, name)
   *     const c = Unit.parse(str)
   *
   * Example usage:
   *
   *     const a = new Unit(5, 'cm')               // 50 mm
   *     const b = Unit.parse('23 kg')             // 23 kg
   *     const c = math.in(a, new Unit(null, 'm')  // 0.05 m
   *     const d = new Unit(9.81, "m/s^2")         // 9.81 m/s^2
   *
   * @class Unit
   * @constructor Unit
   * @param {number | BigNumber | Fraction | Complex | boolean} [value]  A value like 5.2
   * @param {string} [name]   A unit name like "cm" or "inch", or a derived unit of the form: "u1[^ex1] [u2[^ex2] ...] [/ u3[^ex3] [u4[^ex4]]]", such as "kg m^2/s^2", where each unit appearing after the forward slash is taken to be in the denominator. "kg m^2 s^-2" is a synonym and is also acceptable. Any of the units can include a prefix.
   */ function Unit(value, name) {
        if (!(this instanceof Unit)) throw new Error('Constructor must be called with the new operator');
        if (!(value === null || value === undefined || isNumeric(value) || (0, $gs7TF.isComplex)(value))) throw new TypeError('First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined');
        if (name !== undefined && (typeof name !== 'string' || name === '')) throw new TypeError('Second parameter in Unit constructor must be a string');
        if (name !== undefined) {
            var u = Unit.parse(name);
            this.units = u.units;
            this.dimensions = u.dimensions;
        } else {
            this.units = [
                {
                    unit: UNIT_NONE,
                    prefix: PREFIXES.NONE,
                    // link to a list with supported prefixes
                    power: 0
                }
            ];
            this.dimensions = [];
            for(var i = 0; i < BASE_DIMENSIONS.length; i++)this.dimensions[i] = 0;
        }
        this.value = value !== undefined && value !== null ? this._normalize(value) : null;
        this.fixPrefix = false; // if true, function format will not search for the
        // best prefix but leave it as initially provided.
        // fixPrefix is set true by the method Unit.to
        // The justification behind this is that if the constructor is explicitly called,
        // the caller wishes the units to be returned exactly as he supplied.
        this.skipAutomaticSimplification = true;
    }
    /**
   * Attach type information
   */ Unit.prototype.type = 'Unit';
    Unit.prototype.isUnit = true; // private variables and functions for the Unit parser
    var text, index, c;
    function skipWhitespace() {
        while(c === ' ' || c === '\t')next();
    }
    function isDigitDot(c) {
        return c >= '0' && c <= '9' || c === '.';
    }
    function isDigit(c) {
        return c >= '0' && c <= '9';
    }
    function next() {
        index++;
        c = text.charAt(index);
    }
    function revert(oldIndex) {
        index = oldIndex;
        c = text.charAt(index);
    }
    function parseNumber() {
        var number = '';
        var oldIndex = index;
        if (c === '+') next();
        else if (c === '-') {
            number += c;
            next();
        }
        if (!isDigitDot(c)) {
            // a + or - must be followed by a digit
            revert(oldIndex);
            return null;
        } // get number, can have a single dot
        if (c === '.') {
            number += c;
            next();
            if (!isDigit(c)) {
                // this is no legal number, it is just a dot
                revert(oldIndex);
                return null;
            }
        } else {
            while(isDigit(c)){
                number += c;
                next();
            }
            if (c === '.') {
                number += c;
                next();
            }
        }
        while(isDigit(c)){
            number += c;
            next();
        } // check for exponential notation like "2.3e-4" or "1.23e50"
        if (c === 'E' || c === 'e') {
            // The grammar branches here. This could either be part of an exponent or the start of a unit that begins with the letter e, such as "4exabytes"
            var tentativeNumber = '';
            var tentativeIndex = index;
            tentativeNumber += c;
            next();
            if (c === '+' || c === '-') {
                tentativeNumber += c;
                next();
            } // Scientific notation MUST be followed by an exponent (otherwise we assume it is not scientific notation)
            if (!isDigit(c)) {
                // The e or E must belong to something else, so return the number without the e or E.
                revert(tentativeIndex);
                return number;
            } // We can now safely say that this is scientific notation.
            number = number + tentativeNumber;
            while(isDigit(c)){
                number += c;
                next();
            }
        }
        return number;
    }
    function parseUnit() {
        var unitName = ''; // Alphanumeric characters only; matches [a-zA-Z0-9]
        while(isDigit(c) || Unit.isValidAlpha(c)){
            unitName += c;
            next();
        } // Must begin with [a-zA-Z]
        var firstC = unitName.charAt(0);
        if (Unit.isValidAlpha(firstC)) return unitName;
        else return null;
    }
    function parseCharacter(toFind) {
        if (c === toFind) {
            next();
            return toFind;
        } else return null;
    }
    /**
   * Parse a string into a unit. The value of the unit is parsed as number,
   * BigNumber, or Fraction depending on the math.js config setting `number`.
   *
   * Throws an exception if the provided string does not contain a valid unit or
   * cannot be parsed.
   * @memberof Unit
   * @param {string} str        A string like "5.2 inch", "4e2 cm/s^2"
   * @return {Unit} unit
   */ Unit.parse = function(str, options) {
        options = options || {};
        text = str;
        index = -1;
        c = '';
        if (typeof text !== 'string') throw new TypeError('Invalid argument in Unit.parse, string expected');
        var unit = new Unit();
        unit.units = [];
        var powerMultiplierCurrent = 1;
        var expectingUnit = false; // A unit should follow this pattern:
        // [number] ...[ [*/] unit[^number] ]
        // unit[^number] ... [ [*/] unit[^number] ]
        // Rules:
        // number is any floating point number.
        // unit is any alphanumeric string beginning with an alpha. Units with names like e3 should be avoided because they look like the exponent of a floating point number!
        // The string may optionally begin with a number.
        // Each unit may optionally be followed by ^number.
        // Whitespace or a forward slash is recommended between consecutive units, although the following technically is parseable:
        //   2m^2kg/s^2
        // it is not good form. If a unit starts with e, then it could be confused as a floating point number:
        //   4erg
        next();
        skipWhitespace(); // Optional number at the start of the string
        var valueStr = parseNumber();
        var value = null;
        if (valueStr) {
            if (config.number === 'BigNumber') value = new _BigNumber(valueStr);
            else if (config.number === 'Fraction') try {
                // not all numbers can be turned in Fractions, for example very small numbers not
                value = new _Fraction(valueStr);
            } catch (err) {
                value = parseFloat(valueStr);
            }
            else // number
            value = parseFloat(valueStr);
            skipWhitespace(); // Whitespace is not required here
            // handle multiplication or division right after the value, like '1/s'
            if (parseCharacter('*')) {
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter('/')) {
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            }
        } // Stack to keep track of powerMultipliers applied to each parentheses group
        var powerMultiplierStack = []; // Running product of all elements in powerMultiplierStack
        var powerMultiplierStackProduct = 1;
        while(true){
            skipWhitespace(); // Check for and consume opening parentheses, pushing powerMultiplierCurrent to the stack
            // A '(' will always appear directly before a unit.
            while(c === '('){
                powerMultiplierStack.push(powerMultiplierCurrent);
                powerMultiplierStackProduct *= powerMultiplierCurrent;
                powerMultiplierCurrent = 1;
                next();
                skipWhitespace();
            } // Is there something here?
            var uStr = void 0;
            if (c) {
                var oldC = c;
                uStr = parseUnit();
                if (uStr === null) throw new SyntaxError('Unexpected "' + oldC + '" in "' + text + '" at index ' + index.toString());
            } else break;
             // Verify the unit exists and get the prefix (if any)
            var res = _findUnit(uStr);
            if (res === null) // Unit not found.
            throw new SyntaxError('Unit "' + uStr + '" not found.');
            var power = powerMultiplierCurrent * powerMultiplierStackProduct; // Is there a "^ number"?
            skipWhitespace();
            if (parseCharacter('^')) {
                skipWhitespace();
                var p = parseNumber();
                if (p === null) // No valid number found for the power!
                throw new SyntaxError('In "' + str + '", "^" must be followed by a floating-point number');
                power *= p;
            } // Add the unit to the list
            unit.units.push({
                unit: res.unit,
                prefix: res.prefix,
                power: power
            });
            for(var i = 0; i < BASE_DIMENSIONS.length; i++)unit.dimensions[i] += (res.unit.dimensions[i] || 0) * power;
             // Check for and consume closing parentheses, popping from the stack.
            // A ')' will always follow a unit.
            skipWhitespace();
            while(c === ')'){
                if (powerMultiplierStack.length === 0) throw new SyntaxError('Unmatched ")" in "' + text + '" at index ' + index.toString());
                powerMultiplierStackProduct /= powerMultiplierStack.pop();
                next();
                skipWhitespace();
            } // "*" and "/" should mean we are expecting something to come next.
            // Is there a forward slash? If so, negate powerMultiplierCurrent. The next unit or paren group is in the denominator.
            expectingUnit = false;
            if (parseCharacter('*')) {
                // explicit multiplication
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter('/')) {
                // division
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            } else // implicit multiplication
            powerMultiplierCurrent = 1;
             // Replace the unit into the auto unit system
            if (res.unit.base) {
                var baseDim = res.unit.base.key;
                UNIT_SYSTEMS.auto[baseDim] = {
                    unit: res.unit,
                    prefix: res.prefix
                };
            }
        } // Has the string been entirely consumed?
        skipWhitespace();
        if (c) throw new SyntaxError('Could not parse: "' + str + '"');
         // Is there a trailing slash?
        if (expectingUnit) throw new SyntaxError('Trailing characters: "' + str + '"');
         // Is the parentheses stack empty?
        if (powerMultiplierStack.length !== 0) throw new SyntaxError('Unmatched "(" in "' + text + '"');
         // Are there any units at all?
        if (unit.units.length === 0 && !options.allowNoUnits) throw new SyntaxError('"' + str + '" contains no units');
        unit.value = value !== undefined ? unit._normalize(value) : null;
        return unit;
    };
    /**
   * create a copy of this unit
   * @memberof Unit
   * @return {Unit} Returns a cloned version of the unit
   */ Unit.prototype.clone = function() {
        var unit = new Unit();
        unit.fixPrefix = this.fixPrefix;
        unit.skipAutomaticSimplification = this.skipAutomaticSimplification;
        unit.value = (0, $4mYv9.clone)(this.value);
        unit.dimensions = this.dimensions.slice(0);
        unit.units = [];
        for(var i = 0; i < this.units.length; i++){
            unit.units[i] = {};
            for(var p in this.units[i])if ((0, $4mYv9.hasOwnProperty)(this.units[i], p)) unit.units[i][p] = this.units[i][p];
        }
        return unit;
    };
    /**
   * Return whether the unit is derived (such as m/s, or cm^2, but not N)
   * @memberof Unit
   * @return {boolean} True if the unit is derived
   */ Unit.prototype._isDerived = function() {
        if (this.units.length === 0) return false;
        return this.units.length > 1 || Math.abs(this.units[0].power - 1.0) > 1e-15;
    };
    /**
   * Normalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number | BigNumber | Fraction | boolean} value
   * @return {number | BigNumber | Fraction | boolean} normalized value
   * @private
   */ Unit.prototype._normalize = function(value) {
        var unitValue, unitOffset, unitPower, unitPrefixValue;
        var convert;
        if (value === null || value === undefined || this.units.length === 0) return value;
        else if (this._isDerived()) {
            // This is a derived unit, so do not apply offsets.
            // For example, with J kg^-1 degC^-1 you would NOT want to apply the offset.
            var res = value;
            convert = Unit._getNumberConverter((0, $gs7TF.typeOf)(value)); // convert to Fraction or BigNumber if needed
            for(var i = 0; i < this.units.length; i++){
                unitValue = convert(this.units[i].unit.value);
                unitPrefixValue = convert(this.units[i].prefix.value);
                unitPower = convert(this.units[i].power);
                res = multiplyScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
            }
            return res;
        } else {
            // This is a single unit of power 1, like kg or degC
            convert = Unit._getNumberConverter((0, $gs7TF.typeOf)(value)); // convert to Fraction or BigNumber if needed
            unitValue = convert(this.units[0].unit.value);
            unitOffset = convert(this.units[0].unit.offset);
            unitPrefixValue = convert(this.units[0].prefix.value);
            return multiplyScalar(addScalar(value, unitOffset), multiplyScalar(unitValue, unitPrefixValue));
        }
    };
    /**
   * Denormalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number} value
   * @param {number} [prefixValue]    Optional prefix value to be used (ignored if this is a derived unit)
   * @return {number} denormalized value
   * @private
   */ Unit.prototype._denormalize = function(value, prefixValue) {
        var unitValue, unitOffset, unitPower, unitPrefixValue;
        var convert;
        if (value === null || value === undefined || this.units.length === 0) return value;
        else if (this._isDerived()) {
            // This is a derived unit, so do not apply offsets.
            // For example, with J kg^-1 degC^-1 you would NOT want to apply the offset.
            // Also, prefixValue is ignored--but we will still use the prefix value stored in each unit, since kg is usually preferable to g unless the user decides otherwise.
            var res = value;
            convert = Unit._getNumberConverter((0, $gs7TF.typeOf)(value)); // convert to Fraction or BigNumber if needed
            for(var i = 0; i < this.units.length; i++){
                unitValue = convert(this.units[i].unit.value);
                unitPrefixValue = convert(this.units[i].prefix.value);
                unitPower = convert(this.units[i].power);
                res = divideScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
            }
            return res;
        } else {
            // This is a single unit of power 1, like kg or degC
            convert = Unit._getNumberConverter((0, $gs7TF.typeOf)(value)); // convert to Fraction or BigNumber if needed
            unitValue = convert(this.units[0].unit.value);
            unitPrefixValue = convert(this.units[0].prefix.value);
            unitOffset = convert(this.units[0].unit.offset);
            if (prefixValue === undefined || prefixValue === null) return subtract(divideScalar(divideScalar(value, unitValue), unitPrefixValue), unitOffset);
            else return subtract(divideScalar(divideScalar(value, unitValue), prefixValue), unitOffset);
        }
    };
    /**
   * Find a unit from a string
   * @memberof Unit
   * @param {string} str              A string like 'cm' or 'inch'
   * @returns {Object | null} result  When found, an object with fields unit and
   *                                  prefix is returned. Else, null is returned.
   * @private
   */ var _findUnit = (0, $jHpUf.memoize)((str)=>{
        // First, match units names exactly. For example, a user could define 'mm' as 10^-4 m, which is silly, but then we would want 'mm' to match the user-defined unit.
        if ((0, $4mYv9.hasOwnProperty)(UNITS, str)) {
            var unit = UNITS[str];
            var prefix = unit.prefixes[''];
            return {
                unit: unit,
                prefix: prefix
            };
        }
        for(var _name in UNITS){
            if ((0, $4mYv9.hasOwnProperty)(UNITS, _name)) {
                if ((0, $aEppI.endsWith)(str, _name)) {
                    var _unit = UNITS[_name];
                    var prefixLen = str.length - _name.length;
                    var prefixName = str.substring(0, prefixLen);
                    var _prefix = (0, $4mYv9.hasOwnProperty)(_unit.prefixes, prefixName) ? _unit.prefixes[prefixName] : undefined;
                    if (_prefix !== undefined) // store unit, prefix, and value
                    return {
                        unit: _unit,
                        prefix: _prefix
                    };
                }
            }
        }
        return null;
    }, {
        hasher: (args)=>args[0],
        limit: 100
    });
    /**
   * Test if the given expression is a unit.
   * The unit can have a prefix but cannot have a value.
   * @memberof Unit
   * @param {string} name   A string to be tested whether it is a value less unit.
   *                        The unit can have prefix, like "cm"
   * @return {boolean}      true if the given string is a unit
   */ Unit.isValuelessUnit = function(name) {
        return _findUnit(name) !== null;
    };
    /**
   * check if this unit has given base unit
   * If this unit is a derived unit, this will ALWAYS return false, since by definition base units are not derived.
   * @memberof Unit
   * @param {BASE_UNITS | string | undefined} base
   */ Unit.prototype.hasBase = function(base) {
        if (typeof base === 'string') base = BASE_UNITS[base];
        if (!base) return false;
         // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (base.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit has a base or bases equal to another base or bases
   * For derived units, the exponent on each base also must match
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if equal base
   */ Unit.prototype.equalBase = function(other) {
        // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (other.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit equals another unit
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if both units are equal
   */ Unit.prototype.equals = function(other) {
        return this.equalBase(other) && equal(this.value, other.value);
    };
    /**
   * Multiply this unit with another one
   * @memberof Unit
   * @param {Unit} other
   * @return {Unit} product of this unit and the other unit
   */ Unit.prototype.multiply = function(other) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) + (other.dimensions[i] || 0);
         // Append other's units list onto res
        for(var _i = 0; _i < other.units.length; _i++){
            // Make a shallow copy of every unit
            var inverted = $72af34e832729a5b$var$_objectSpread({}, other.units[_i]);
            res.units.push(inverted);
        } // If at least one operand has a value, then the result should also have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(1) : this.value;
            var valOther = other.value === null ? other._normalize(1) : other.value;
            res.value = multiplyScalar(valThis, valOther);
        } else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Divide this unit by another one
   * @memberof Unit
   * @param {Unit} other
   * @return {Unit} result of dividing this unit by the other unit
   */ Unit.prototype.divide = function(other) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) - (other.dimensions[i] || 0);
         // Invert and append other's units list onto res
        for(var _i2 = 0; _i2 < other.units.length; _i2++){
            // Make a shallow copy of every unit
            var inverted = $72af34e832729a5b$var$_objectSpread($72af34e832729a5b$var$_objectSpread({}, other.units[_i2]), {}, {
                power: -other.units[_i2].power
            });
            res.units.push(inverted);
        } // If at least one operand has a value, the result should have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(1) : this.value;
            var valOther = other.value === null ? other._normalize(1) : other.value;
            res.value = divideScalar(valThis, valOther);
        } else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Calculate the power of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} p
   * @returns {Unit}      The result: this^p
   */ Unit.prototype.pow = function(p) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) * p;
         // Adjust the power of each unit in the list
        for(var _i3 = 0; _i3 < res.units.length; _i3++)res.units[_i3].power *= p;
        if (res.value !== null) res.value = pow(res.value, p); // only allow numeric output, we don't want to return a Complex number
        else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Return the numeric value of this unit if it is dimensionless, has a value, and config.predictable == false; or the original unit otherwise
   * @param {Unit} unit
   * @returns {number | Fraction | BigNumber | Unit}  The numeric value of the unit if conditions are met, or the original unit otherwise
   */ function getNumericIfUnitless(unit) {
        if (unit.equalBase(BASE_UNITS.NONE) && unit.value !== null && !config.predictable) return unit.value;
        else return unit;
    }
    /**
   * Calculate the absolute value of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} x
   * @returns {Unit}      The result: |x|, absolute value of x
   */ Unit.prototype.abs = function() {
        // This gives correct, but unexpected, results for units with an offset.
        // For example, abs(-283.15 degC) = -263.15 degC !!!
        var ret = this.clone();
        ret.value = ret.value !== null ? abs(ret.value) : null;
        for(var i in ret.units)if (ret.units[i].unit.name === 'VA' || ret.units[i].unit.name === 'VAR') ret.units[i].unit = UNITS.W;
        return ret;
    };
    /**
   * Convert the unit to a specific unit name.
   * @memberof Unit
   * @param {string | Unit} valuelessUnit   A unit without value. Can have prefix, like "cm"
   * @returns {Unit} Returns a clone of the unit with a fixed prefix and unit.
   */ Unit.prototype.to = function(valuelessUnit) {
        var other;
        var value = this.value === null ? this._normalize(1) : this.value;
        if (typeof valuelessUnit === 'string') {
            // other = new Unit(null, valuelessUnit)
            other = Unit.parse(valuelessUnit);
            if (!this.equalBase(other)) throw new Error("Units do not match ('".concat(other.toString(), "' != '").concat(this.toString(), "')"));
            if (other.value !== null) throw new Error('Cannot convert to a unit with a value');
            other.value = (0, $4mYv9.clone)(value);
            other.fixPrefix = true;
            other.skipAutomaticSimplification = true;
            return other;
        } else if ((0, $gs7TF.isUnit)(valuelessUnit)) {
            if (!this.equalBase(valuelessUnit)) throw new Error("Units do not match ('".concat(valuelessUnit.toString(), "' != '").concat(this.toString(), "')"));
            if (valuelessUnit.value !== null) throw new Error('Cannot convert to a unit with a value');
            other = valuelessUnit.clone();
            other.value = (0, $4mYv9.clone)(value);
            other.fixPrefix = true;
            other.skipAutomaticSimplification = true;
            return other;
        } else throw new Error('String or Unit expected as parameter');
    };
    /**
   * Return the value of the unit when represented with given valueless unit
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number} Returns the unit value as number.
   */ // TODO: deprecate Unit.toNumber? It's always better to use toNumeric
    Unit.prototype.toNumber = function(valuelessUnit) {
        return toNumber(this.toNumeric(valuelessUnit));
    };
    /**
   * Return the value of the unit in the original numeric type
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number | BigNumber | Fraction} Returns the unit value
   */ Unit.prototype.toNumeric = function(valuelessUnit) {
        var other;
        if (valuelessUnit) // Allow getting the numeric value without converting to a different unit
        other = this.to(valuelessUnit);
        else other = this.clone();
        if (other._isDerived() || other.units.length === 0) return other._denormalize(other.value);
        else return other._denormalize(other.value, other.units[0].prefix.value);
    };
    /**
   * Get a string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the unit
   * @memberof Unit
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   */ Unit.prototype.toJSON = function() {
        return {
            mathjs: 'Unit',
            value: this._denormalize(this.value),
            unit: this.formatUnits(),
            fixPrefix: this.fixPrefix
        };
    };
    /**
   * Instantiate a Unit from a JSON object
   * @memberof Unit
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   * @return {Unit}
   */ Unit.fromJSON = function(json) {
        var unit = new Unit(json.value, json.unit);
        unit.fixPrefix = json.fixPrefix || false;
        return unit;
    };
    /**
   * Returns the string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.valueOf = Unit.prototype.toString;
    /**
   * Simplify this Unit's unit list and return a new Unit with the simplified list.
   * The returned Unit will contain a list of the "best" units for formatting.
   */ Unit.prototype.simplify = function() {
        var ret = this.clone();
        var proposedUnitList = []; // Search for a matching base
        var matchingBase;
        for(var key in currentUnitSystem){
            if ((0, $4mYv9.hasOwnProperty)(currentUnitSystem, key)) {
                if (ret.hasBase(BASE_UNITS[key])) {
                    matchingBase = key;
                    break;
                }
            }
        }
        if (matchingBase === 'NONE') ret.units = [];
        else {
            var matchingUnit;
            if (matchingBase) // Does the unit system have a matching unit?
            {
                if ((0, $4mYv9.hasOwnProperty)(currentUnitSystem, matchingBase)) matchingUnit = currentUnitSystem[matchingBase];
            }
            if (matchingUnit) ret.units = [
                {
                    unit: matchingUnit.unit,
                    prefix: matchingUnit.prefix,
                    power: 1.0
                }
            ];
            else {
                // Multiple units or units with powers are formatted like this:
                // 5 (kg m^2) / (s^3 mol)
                // Build an representation from the base units of the current unit system
                var missingBaseDim = false;
                for(var i = 0; i < BASE_DIMENSIONS.length; i++){
                    var baseDim = BASE_DIMENSIONS[i];
                    if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                        if ((0, $4mYv9.hasOwnProperty)(currentUnitSystem, baseDim)) proposedUnitList.push({
                            unit: currentUnitSystem[baseDim].unit,
                            prefix: currentUnitSystem[baseDim].prefix,
                            power: ret.dimensions[i] || 0
                        });
                        else missingBaseDim = true;
                    }
                } // Is the proposed unit list "simpler" than the existing one?
                if (proposedUnitList.length < ret.units.length && !missingBaseDim) // Replace this unit list with the proposed list
                ret.units = proposedUnitList;
            }
        }
        return ret;
    };
    /**
   * Returns a new Unit in the SI system with the same value as this one
   */ Unit.prototype.toSI = function() {
        var ret = this.clone();
        var proposedUnitList = []; // Multiple units or units with powers are formatted like this:
        // 5 (kg m^2) / (s^3 mol)
        // Build an representation from the base units of the SI unit system
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            var baseDim = BASE_DIMENSIONS[i];
            if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                if ((0, $4mYv9.hasOwnProperty)(UNIT_SYSTEMS.si, baseDim)) proposedUnitList.push({
                    unit: UNIT_SYSTEMS.si[baseDim].unit,
                    prefix: UNIT_SYSTEMS.si[baseDim].prefix,
                    power: ret.dimensions[i] || 0
                });
                else throw new Error('Cannot express custom unit ' + baseDim + ' in SI units');
            }
        } // Replace this unit list with the proposed list
        ret.units = proposedUnitList;
        ret.fixPrefix = true;
        ret.skipAutomaticSimplification = true;
        return ret;
    };
    /**
   * Get a string representation of the units of this Unit, without the value. The unit list is formatted as-is without first being simplified.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.formatUnits = function() {
        var strNum = '';
        var strDen = '';
        var nNum = 0;
        var nDen = 0;
        for(var i = 0; i < this.units.length; i++){
            if (this.units[i].power > 0) {
                nNum++;
                strNum += ' ' + this.units[i].prefix.name + this.units[i].unit.name;
                if (Math.abs(this.units[i].power - 1.0) > 1e-15) strNum += '^' + this.units[i].power;
            } else if (this.units[i].power < 0) nDen++;
        }
        if (nDen > 0) {
            for(var _i4 = 0; _i4 < this.units.length; _i4++)if (this.units[_i4].power < 0) {
                if (nNum > 0) {
                    strDen += ' ' + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    if (Math.abs(this.units[_i4].power + 1.0) > 1e-15) strDen += '^' + -this.units[_i4].power;
                } else {
                    strDen += ' ' + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    strDen += '^' + this.units[_i4].power;
                }
            }
        } // Remove leading " "
        strNum = strNum.substr(1);
        strDen = strDen.substr(1); // Add parans for better copy/paste back into evaluate, for example, or for better pretty print formatting
        if (nNum > 1 && nDen > 0) strNum = '(' + strNum + ')';
        if (nDen > 1 && nNum > 0) strDen = '(' + strDen + ')';
        var str = strNum;
        if (nNum > 0 && nDen > 0) str += ' / ';
        str += strDen;
        return str;
    };
    /**
   * Get a string representation of the Unit, with optional formatting options.
   * @memberof Unit
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string}
   */ Unit.prototype.format = function(options) {
        // Simplfy the unit list, unless it is valueless or was created directly in the
        // constructor or as the result of to or toSI
        var simp = this.skipAutomaticSimplification || this.value === null ? this.clone() : this.simplify(); // Apply some custom logic for handling VA and VAR. The goal is to express the value of the unit as a real value, if possible. Otherwise, use a real-valued unit instead of a complex-valued one.
        var isImaginary = false;
        if (typeof simp.value !== 'undefined' && simp.value !== null && (0, $gs7TF.isComplex)(simp.value)) // TODO: Make this better, for example, use relative magnitude of re and im rather than absolute
        isImaginary = Math.abs(simp.value.re) < 1e-14;
        for(var i in simp.units){
            if ((0, $4mYv9.hasOwnProperty)(simp.units, i)) {
                if (simp.units[i].unit) {
                    if (simp.units[i].unit.name === 'VA' && isImaginary) simp.units[i].unit = UNITS.VAR;
                    else if (simp.units[i].unit.name === 'VAR' && !isImaginary) simp.units[i].unit = UNITS.VA;
                }
            }
        } // Now apply the best prefix
        // Units must have only one unit and not have the fixPrefix flag set
        if (simp.units.length === 1 && !simp.fixPrefix) // Units must have integer powers, otherwise the prefix will change the
        // outputted value by not-an-integer-power-of-ten
        {
            if (Math.abs(simp.units[0].power - Math.round(simp.units[0].power)) < 1e-14) // Apply the best prefix
            simp.units[0].prefix = simp._bestPrefix();
        }
        var value = simp._denormalize(simp.value);
        var str = simp.value !== null ? format(value, options || {}) : '';
        var unitStr = simp.formatUnits();
        if (simp.value && (0, $gs7TF.isComplex)(simp.value)) str = '(' + str + ')'; // Surround complex values with ( ) to enable better parsing
        if (unitStr.length > 0 && str.length > 0) str += ' ';
        str += unitStr;
        return str;
    };
    /**
   * Calculate the best prefix using current value.
   * @memberof Unit
   * @returns {Object} prefix
   * @private
   */ Unit.prototype._bestPrefix = function() {
        if (this.units.length !== 1) throw new Error('Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!');
        if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw new Error('Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!');
         // find the best prefix value (resulting in the value of which
        // the absolute value of the log10 is closest to zero,
        // though with a little offset of 1.2 for nicer values: you get a
        // sequence 1mm 100mm 500mm 0.6m 1m 10m 100m 500m 0.6km 1km ...
        // Note: the units value can be any numeric type, but to find the best
        // prefix it's enough to work with limited precision of a regular number
        // Update: using mathjs abs since we also allow complex numbers
        var absValue = this.value !== null ? abs(this.value) : 0;
        var absUnitValue = abs(this.units[0].unit.value);
        var bestPrefix = this.units[0].prefix;
        if (absValue === 0) return bestPrefix;
        var power = this.units[0].power;
        var bestDiff = Math.log(absValue / Math.pow(bestPrefix.value * absUnitValue, power)) / Math.LN10 - 1.2;
        if (bestDiff > -2.200001 && bestDiff < 1.800001) return bestPrefix; // Allow the original prefix
        bestDiff = Math.abs(bestDiff);
        var prefixes = this.units[0].unit.prefixes;
        for(var p in prefixes)if ((0, $4mYv9.hasOwnProperty)(prefixes, p)) {
            var prefix = prefixes[p];
            if (prefix.scientific) {
                var diff = Math.abs(Math.log(absValue / Math.pow(prefix.value * absUnitValue, power)) / Math.LN10 - 1.2);
                if (diff < bestDiff || diff === bestDiff && prefix.name.length < bestPrefix.name.length) {
                    // choose the prefix with the smallest diff, or if equal, choose the one
                    // with the shortest name (can happen with SHORTLONG for example)
                    bestPrefix = prefix;
                    bestDiff = diff;
                }
            }
        }
        return bestPrefix;
    };
    /**
   * Returns an array of units whose sum is equal to this unit
   * @memberof Unit
   * @param {Array} [parts] An array of strings or valueless units.
   *
   *   Example:
   *
   *   const u = new Unit(1, 'm')
   *   u.splitUnit(['feet', 'inch'])
   *     [ 3 feet, 3.3700787401575 inch ]
   *
   * @return {Array} An array of units.
   */ Unit.prototype.splitUnit = function(parts) {
        var x = this.clone();
        var ret = [];
        for(var i = 0; i < parts.length; i++){
            // Convert x to the requested unit
            x = x.to(parts[i]);
            if (i === parts.length - 1) break; // Get the numeric value of this unit
            var xNumeric = x.toNumeric(); // Check to see if xNumeric is nearly equal to an integer,
            // since fix can incorrectly round down if there is round-off error
            var xRounded = round(xNumeric);
            var xFixed = void 0;
            var isNearlyEqual = equal(xRounded, xNumeric);
            if (isNearlyEqual) xFixed = xRounded;
            else xFixed = fix(x.toNumeric());
            var y = new Unit(xFixed, parts[i].toString());
            ret.push(y);
            x = subtract(x, y);
        } // This little bit fixes a bug where the remainder should be 0 but is a little bit off.
        // But instead of comparing x, the remainder, with zero--we will compare the sum of
        // all the parts so far with the original value. If they are nearly equal,
        // we set the remainder to 0.
        var testSum = 0;
        for(var _i5 = 0; _i5 < ret.length; _i5++)testSum = addScalar(testSum, ret[_i5].value);
        if (equal(testSum, this.value)) x.value = 0;
        ret.push(x);
        return ret;
    };
    var PREFIXES = {
        NONE: {
            '': {
                name: '',
                value: 1,
                scientific: true
            }
        },
        SHORT: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            da: {
                name: 'da',
                value: 1e1,
                scientific: false
            },
            h: {
                name: 'h',
                value: 1e2,
                scientific: false
            },
            k: {
                name: 'k',
                value: 1e3,
                scientific: true
            },
            M: {
                name: 'M',
                value: 1e6,
                scientific: true
            },
            G: {
                name: 'G',
                value: 1e9,
                scientific: true
            },
            T: {
                name: 'T',
                value: 1e12,
                scientific: true
            },
            P: {
                name: 'P',
                value: 1e15,
                scientific: true
            },
            E: {
                name: 'E',
                value: 1e18,
                scientific: true
            },
            Z: {
                name: 'Z',
                value: 1e21,
                scientific: true
            },
            Y: {
                name: 'Y',
                value: 1e24,
                scientific: true
            },
            d: {
                name: 'd',
                value: 1e-1,
                scientific: false
            },
            c: {
                name: 'c',
                value: 1e-2,
                scientific: false
            },
            m: {
                name: 'm',
                value: 1e-3,
                scientific: true
            },
            u: {
                name: 'u',
                value: 1e-6,
                scientific: true
            },
            n: {
                name: 'n',
                value: 1e-9,
                scientific: true
            },
            p: {
                name: 'p',
                value: 1e-12,
                scientific: true
            },
            f: {
                name: 'f',
                value: 1e-15,
                scientific: true
            },
            a: {
                name: 'a',
                value: 1e-18,
                scientific: true
            },
            z: {
                name: 'z',
                value: 1e-21,
                scientific: true
            },
            y: {
                name: 'y',
                value: 1e-24,
                scientific: true
            }
        },
        LONG: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            deca: {
                name: 'deca',
                value: 1e1,
                scientific: false
            },
            hecto: {
                name: 'hecto',
                value: 1e2,
                scientific: false
            },
            kilo: {
                name: 'kilo',
                value: 1e3,
                scientific: true
            },
            mega: {
                name: 'mega',
                value: 1e6,
                scientific: true
            },
            giga: {
                name: 'giga',
                value: 1e9,
                scientific: true
            },
            tera: {
                name: 'tera',
                value: 1e12,
                scientific: true
            },
            peta: {
                name: 'peta',
                value: 1e15,
                scientific: true
            },
            exa: {
                name: 'exa',
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: 'zetta',
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: 'yotta',
                value: 1e24,
                scientific: true
            },
            deci: {
                name: 'deci',
                value: 1e-1,
                scientific: false
            },
            centi: {
                name: 'centi',
                value: 1e-2,
                scientific: false
            },
            milli: {
                name: 'milli',
                value: 1e-3,
                scientific: true
            },
            micro: {
                name: 'micro',
                value: 1e-6,
                scientific: true
            },
            nano: {
                name: 'nano',
                value: 1e-9,
                scientific: true
            },
            pico: {
                name: 'pico',
                value: 1e-12,
                scientific: true
            },
            femto: {
                name: 'femto',
                value: 1e-15,
                scientific: true
            },
            atto: {
                name: 'atto',
                value: 1e-18,
                scientific: true
            },
            zepto: {
                name: 'zepto',
                value: 1e-21,
                scientific: true
            },
            yocto: {
                name: 'yocto',
                value: 1e-24,
                scientific: true
            }
        },
        SQUARED: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            da: {
                name: 'da',
                value: 1e2,
                scientific: false
            },
            h: {
                name: 'h',
                value: 1e4,
                scientific: false
            },
            k: {
                name: 'k',
                value: 1e6,
                scientific: true
            },
            M: {
                name: 'M',
                value: 1e12,
                scientific: true
            },
            G: {
                name: 'G',
                value: 1e18,
                scientific: true
            },
            T: {
                name: 'T',
                value: 1e24,
                scientific: true
            },
            P: {
                name: 'P',
                value: 1e30,
                scientific: true
            },
            E: {
                name: 'E',
                value: 1e36,
                scientific: true
            },
            Z: {
                name: 'Z',
                value: 1e42,
                scientific: true
            },
            Y: {
                name: 'Y',
                value: 1e48,
                scientific: true
            },
            d: {
                name: 'd',
                value: 1e-2,
                scientific: false
            },
            c: {
                name: 'c',
                value: 1e-4,
                scientific: false
            },
            m: {
                name: 'm',
                value: 1e-6,
                scientific: true
            },
            u: {
                name: 'u',
                value: 1e-12,
                scientific: true
            },
            n: {
                name: 'n',
                value: 1e-18,
                scientific: true
            },
            p: {
                name: 'p',
                value: 1e-24,
                scientific: true
            },
            f: {
                name: 'f',
                value: 1e-30,
                scientific: true
            },
            a: {
                name: 'a',
                value: 1e-36,
                scientific: true
            },
            z: {
                name: 'z',
                value: 1e-42,
                scientific: true
            },
            y: {
                name: 'y',
                value: 1e-48,
                scientific: true
            }
        },
        CUBIC: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            da: {
                name: 'da',
                value: 1e3,
                scientific: false
            },
            h: {
                name: 'h',
                value: 1e6,
                scientific: false
            },
            k: {
                name: 'k',
                value: 1e9,
                scientific: true
            },
            M: {
                name: 'M',
                value: 1e18,
                scientific: true
            },
            G: {
                name: 'G',
                value: 1e27,
                scientific: true
            },
            T: {
                name: 'T',
                value: 1e36,
                scientific: true
            },
            P: {
                name: 'P',
                value: 1e45,
                scientific: true
            },
            E: {
                name: 'E',
                value: 1e54,
                scientific: true
            },
            Z: {
                name: 'Z',
                value: 1e63,
                scientific: true
            },
            Y: {
                name: 'Y',
                value: 1e72,
                scientific: true
            },
            d: {
                name: 'd',
                value: 1e-3,
                scientific: false
            },
            c: {
                name: 'c',
                value: 1e-6,
                scientific: false
            },
            m: {
                name: 'm',
                value: 1e-9,
                scientific: true
            },
            u: {
                name: 'u',
                value: 1e-18,
                scientific: true
            },
            n: {
                name: 'n',
                value: 1e-27,
                scientific: true
            },
            p: {
                name: 'p',
                value: 1e-36,
                scientific: true
            },
            f: {
                name: 'f',
                value: 1e-45,
                scientific: true
            },
            a: {
                name: 'a',
                value: 1e-54,
                scientific: true
            },
            z: {
                name: 'z',
                value: 1e-63,
                scientific: true
            },
            y: {
                name: 'y',
                value: 1e-72,
                scientific: true
            }
        },
        BINARY_SHORT_SI: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            k: {
                name: 'k',
                value: 1e3,
                scientific: true
            },
            M: {
                name: 'M',
                value: 1e6,
                scientific: true
            },
            G: {
                name: 'G',
                value: 1e9,
                scientific: true
            },
            T: {
                name: 'T',
                value: 1e12,
                scientific: true
            },
            P: {
                name: 'P',
                value: 1e15,
                scientific: true
            },
            E: {
                name: 'E',
                value: 1e18,
                scientific: true
            },
            Z: {
                name: 'Z',
                value: 1e21,
                scientific: true
            },
            Y: {
                name: 'Y',
                value: 1e24,
                scientific: true
            }
        },
        BINARY_SHORT_IEC: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            Ki: {
                name: 'Ki',
                value: 1024,
                scientific: true
            },
            Mi: {
                name: 'Mi',
                value: Math.pow(1024, 2),
                scientific: true
            },
            Gi: {
                name: 'Gi',
                value: Math.pow(1024, 3),
                scientific: true
            },
            Ti: {
                name: 'Ti',
                value: Math.pow(1024, 4),
                scientific: true
            },
            Pi: {
                name: 'Pi',
                value: Math.pow(1024, 5),
                scientific: true
            },
            Ei: {
                name: 'Ei',
                value: Math.pow(1024, 6),
                scientific: true
            },
            Zi: {
                name: 'Zi',
                value: Math.pow(1024, 7),
                scientific: true
            },
            Yi: {
                name: 'Yi',
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BINARY_LONG_SI: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            kilo: {
                name: 'kilo',
                value: 1e3,
                scientific: true
            },
            mega: {
                name: 'mega',
                value: 1e6,
                scientific: true
            },
            giga: {
                name: 'giga',
                value: 1e9,
                scientific: true
            },
            tera: {
                name: 'tera',
                value: 1e12,
                scientific: true
            },
            peta: {
                name: 'peta',
                value: 1e15,
                scientific: true
            },
            exa: {
                name: 'exa',
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: 'zetta',
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: 'yotta',
                value: 1e24,
                scientific: true
            }
        },
        BINARY_LONG_IEC: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            kibi: {
                name: 'kibi',
                value: 1024,
                scientific: true
            },
            mebi: {
                name: 'mebi',
                value: Math.pow(1024, 2),
                scientific: true
            },
            gibi: {
                name: 'gibi',
                value: Math.pow(1024, 3),
                scientific: true
            },
            tebi: {
                name: 'tebi',
                value: Math.pow(1024, 4),
                scientific: true
            },
            pebi: {
                name: 'pebi',
                value: Math.pow(1024, 5),
                scientific: true
            },
            exi: {
                name: 'exi',
                value: Math.pow(1024, 6),
                scientific: true
            },
            zebi: {
                name: 'zebi',
                value: Math.pow(1024, 7),
                scientific: true
            },
            yobi: {
                name: 'yobi',
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BTU: {
            '': {
                name: '',
                value: 1,
                scientific: true
            },
            MM: {
                name: 'MM',
                value: 1e6,
                scientific: true
            }
        }
    };
    PREFIXES.SHORTLONG = (0, (/*@__PURE__*/$parcel$interopDefault($8Wv3B)))({}, PREFIXES.SHORT, PREFIXES.LONG);
    PREFIXES.BINARY_SHORT = (0, (/*@__PURE__*/$parcel$interopDefault($8Wv3B)))({}, PREFIXES.BINARY_SHORT_SI, PREFIXES.BINARY_SHORT_IEC);
    PREFIXES.BINARY_LONG = (0, (/*@__PURE__*/$parcel$interopDefault($8Wv3B)))({}, PREFIXES.BINARY_LONG_SI, PREFIXES.BINARY_LONG_IEC);
    /* Internally, each unit is represented by a value and a dimension array. The elements of the dimensions array have the following meaning:
   * Index  Dimension
   * -----  ---------
   *   0    Length
   *   1    Mass
   *   2    Time
   *   3    Current
   *   4    Temperature
   *   5    Luminous intensity
   *   6    Amount of substance
   *   7    Angle
   *   8    Bit (digital)
   * For example, the unit "298.15 K" is a pure temperature and would have a value of 298.15 and a dimension array of [0, 0, 0, 0, 1, 0, 0, 0, 0]. The unit "1 cal / (gm °C)" can be written in terms of the 9 fundamental dimensions as [length^2] / ([time^2] * [temperature]), and would a value of (after conversion to SI) 4184.0 and a dimensions array of [2, 0, -2, 0, -1, 0, 0, 0, 0].
   *
   */ var BASE_DIMENSIONS = [
        'MASS',
        'LENGTH',
        'TIME',
        'CURRENT',
        'TEMPERATURE',
        'LUMINOUS_INTENSITY',
        'AMOUNT_OF_SUBSTANCE',
        'ANGLE',
        'BIT'
    ];
    var BASE_UNITS = {
        NONE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MASS: {
            dimensions: [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        LENGTH: {
            dimensions: [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TIME: {
            dimensions: [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        CURRENT: {
            dimensions: [
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TEMPERATURE: {
            dimensions: [
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0
            ]
        },
        LUMINOUS_INTENSITY: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0
            ]
        },
        AMOUNT_OF_SUBSTANCE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0
            ]
        },
        FORCE: {
            dimensions: [
                1,
                1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        SURFACE: {
            dimensions: [
                0,
                2,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        VOLUME: {
            dimensions: [
                0,
                3,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ENERGY: {
            dimensions: [
                1,
                2,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        POWER: {
            dimensions: [
                1,
                2,
                -3,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        PRESSURE: {
            dimensions: [
                1,
                -1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CHARGE: {
            dimensions: [
                0,
                0,
                1,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CAPACITANCE: {
            dimensions: [
                -1,
                -2,
                4,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_POTENTIAL: {
            dimensions: [
                1,
                2,
                -3,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_RESISTANCE: {
            dimensions: [
                1,
                2,
                -3,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_INDUCTANCE: {
            dimensions: [
                1,
                2,
                -2,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CONDUCTANCE: {
            dimensions: [
                -1,
                -2,
                3,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX: {
            dimensions: [
                1,
                2,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX_DENSITY: {
            dimensions: [
                1,
                0,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        FREQUENCY: {
            dimensions: [
                0,
                0,
                -1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ANGLE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]
        },
        BIT: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ]
        }
    };
    for(var key in BASE_UNITS)if ((0, $4mYv9.hasOwnProperty)(BASE_UNITS, key)) BASE_UNITS[key].key = key;
    var BASE_UNIT_NONE = {};
    var UNIT_NONE = {
        name: '',
        base: BASE_UNIT_NONE,
        value: 1,
        offset: 0,
        dimensions: BASE_DIMENSIONS.map((x)=>0)
    };
    var UNITS = {
        // length
        meter: {
            name: 'meter',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        inch: {
            name: 'inch',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        foot: {
            name: 'foot',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yard: {
            name: 'yard',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mile: {
            name: 'mile',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        link: {
            name: 'link',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rod: {
            name: 'rod',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.0292,
            offset: 0
        },
        chain: {
            name: 'chain',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        angstrom: {
            name: 'angstrom',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1e-10,
            offset: 0
        },
        m: {
            name: 'm',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        in: {
            name: 'in',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        ft: {
            name: 'ft',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yd: {
            name: 'yd',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mi: {
            name: 'mi',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        li: {
            name: 'li',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rd: {
            name: 'rd',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.029210,
            offset: 0
        },
        ch: {
            name: 'ch',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        mil: {
            name: 'mil',
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0000254,
            offset: 0
        },
        // 1/1000 inch
        // Surface
        m2: {
            name: 'm2',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.SQUARED,
            value: 1,
            offset: 0
        },
        sqin: {
            name: 'sqin',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.00064516,
            offset: 0
        },
        // 645.16 mm2
        sqft: {
            name: 'sqft',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.09290304,
            offset: 0
        },
        // 0.09290304 m2
        sqyd: {
            name: 'sqyd',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.83612736,
            offset: 0
        },
        // 0.83612736 m2
        sqmi: {
            name: 'sqmi',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 2589988.110336,
            offset: 0
        },
        // 2.589988110336 km2
        sqrd: {
            name: 'sqrd',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 25.29295,
            offset: 0
        },
        // 25.29295 m2
        sqch: {
            name: 'sqch',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 404.6873,
            offset: 0
        },
        // 404.6873 m2
        sqmil: {
            name: 'sqmil',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 6.4516e-10,
            offset: 0
        },
        // 6.4516 * 10^-10 m2
        acre: {
            name: 'acre',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 4046.86,
            offset: 0
        },
        // 4046.86 m2
        hectare: {
            name: 'hectare',
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 10000,
            offset: 0
        },
        // 10000 m2
        // Volume
        m3: {
            name: 'm3',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.CUBIC,
            value: 1,
            offset: 0
        },
        L: {
            name: 'L',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        l: {
            name: 'l',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        litre: {
            name: 'litre',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        cuin: {
            name: 'cuin',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1.6387064e-5,
            offset: 0
        },
        // 1.6387064e-5 m3
        cuft: {
            name: 'cuft',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.028316846592,
            offset: 0
        },
        // 28.316 846 592 L
        cuyd: {
            name: 'cuyd',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.764554857984,
            offset: 0
        },
        // 764.554 857 984 L
        teaspoon: {
            name: 'teaspoon',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000005,
            offset: 0
        },
        // 5 mL
        tablespoon: {
            name: 'tablespoon',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000015,
            offset: 0
        },
        // 15 mL
        // {name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
        drop: {
            name: 'drop',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        gtt: {
            name: 'gtt',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        // Liquid volume
        minim: {
            name: 'minim',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00000006161152,
            offset: 0
        },
        // 0.06161152 mL
        fluiddram: {
            name: 'fluiddram',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000036966911,
            offset: 0
        },
        // 3.696691 mL
        fluidounce: {
            name: 'fluidounce',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00002957353,
            offset: 0
        },
        // 29.57353 mL
        gill: {
            name: 'gill',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0001182941,
            offset: 0
        },
        // 118.2941 mL
        cc: {
            name: 'cc',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1e-6,
            offset: 0
        },
        // 1e-6 L
        cup: {
            name: 'cup',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0002365882,
            offset: 0
        },
        // 236.5882 mL
        pint: {
            name: 'pint',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0004731765,
            offset: 0
        },
        // 473.1765 mL
        quart: {
            name: 'quart',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0009463529,
            offset: 0
        },
        // 946.3529 mL
        gallon: {
            name: 'gallon',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.003785412,
            offset: 0
        },
        // 3.785412 L
        beerbarrel: {
            name: 'beerbarrel',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1173478,
            offset: 0
        },
        // 117.3478 L
        oilbarrel: {
            name: 'oilbarrel',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1589873,
            offset: 0
        },
        // 158.9873 L
        hogshead: {
            name: 'hogshead',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.2384810,
            offset: 0
        },
        // 238.4810 L
        // {name: 'min', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.00000006161152, offset: 0}, // 0.06161152 mL // min is already in use as minute
        fldr: {
            name: 'fldr',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000036966911,
            offset: 0
        },
        // 3.696691 mL
        floz: {
            name: 'floz',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00002957353,
            offset: 0
        },
        // 29.57353 mL
        gi: {
            name: 'gi',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0001182941,
            offset: 0
        },
        // 118.2941 mL
        cp: {
            name: 'cp',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0002365882,
            offset: 0
        },
        // 236.5882 mL
        pt: {
            name: 'pt',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0004731765,
            offset: 0
        },
        // 473.1765 mL
        qt: {
            name: 'qt',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0009463529,
            offset: 0
        },
        // 946.3529 mL
        gal: {
            name: 'gal',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.003785412,
            offset: 0
        },
        // 3.785412 L
        bbl: {
            name: 'bbl',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1173478,
            offset: 0
        },
        // 117.3478 L
        obl: {
            name: 'obl',
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1589873,
            offset: 0
        },
        // 158.9873 L
        // {name: 'hogshead', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.2384810, offset: 0}, // 238.4810 L // TODO: hh?
        // Mass
        g: {
            name: 'g',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        gram: {
            name: 'gram',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        ton: {
            name: 'ton',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 907.18474,
            offset: 0
        },
        t: {
            name: 't',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 1000,
            offset: 0
        },
        tonne: {
            name: 'tonne',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 1000,
            offset: 0
        },
        grain: {
            name: 'grain',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dram: {
            name: 'dram',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        ounce: {
            name: 'ounce',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        poundmass: {
            name: 'poundmass',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        hundredweight: {
            name: 'hundredweight',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        stick: {
            name: 'stick',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 115e-3,
            offset: 0
        },
        stone: {
            name: 'stone',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 6.35029318,
            offset: 0
        },
        gr: {
            name: 'gr',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dr: {
            name: 'dr',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        oz: {
            name: 'oz',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        lbm: {
            name: 'lbm',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        cwt: {
            name: 'cwt',
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        // Time
        s: {
            name: 's',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        min: {
            name: 'min',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        h: {
            name: 'h',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        second: {
            name: 'second',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        sec: {
            name: 'sec',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        minute: {
            name: 'minute',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        hour: {
            name: 'hour',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        day: {
            name: 'day',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 86400,
            offset: 0
        },
        week: {
            name: 'week',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 604800,
            offset: 0
        },
        month: {
            name: 'month',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 2629800,
            // 1/12th of Julian year
            offset: 0
        },
        year: {
            name: 'year',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600,
            // Julian year
            offset: 0
        },
        decade: {
            name: 'decade',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 315576000,
            // Julian decade
            offset: 0
        },
        century: {
            name: 'century',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3155760000,
            // Julian century
            offset: 0
        },
        millennium: {
            name: 'millennium',
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600000,
            // Julian millennium
            offset: 0
        },
        // Frequency
        hertz: {
            name: 'Hertz',
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        Hz: {
            name: 'Hz',
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        // Angle
        rad: {
            name: 'rad',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        radian: {
            name: 'radian',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
        deg: {
            name: 'deg',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        degree: {
            name: 'degree',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
        grad: {
            name: 'grad',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        gradian: {
            name: 'gradian',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
        cycle: {
            name: 'cycle',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
        arcsec: {
            name: 'arcsec',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
        arcmin: {
            name: 'arcmin',
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // Electric current
        A: {
            name: 'A',
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        ampere: {
            name: 'ampere',
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // Temperature
        // K(C) = °C + 273.15
        // K(F) = (°F + 459.67) / 1.8
        // K(R) = °R / 1.8
        K: {
            name: 'K',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 0
        },
        degC: {
            name: 'degC',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 273.15
        },
        degF: {
            name: 'degF',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 459.67
        },
        degR: {
            name: 'degR',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 0
        },
        kelvin: {
            name: 'kelvin',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 0
        },
        celsius: {
            name: 'celsius',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 273.15
        },
        fahrenheit: {
            name: 'fahrenheit',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 459.67
        },
        rankine: {
            name: 'rankine',
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 0
        },
        // amount of substance
        mol: {
            name: 'mol',
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        mole: {
            name: 'mole',
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // luminous intensity
        cd: {
            name: 'cd',
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        candela: {
            name: 'candela',
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // TODO: units STERADIAN
        // {name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // {name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // Force
        N: {
            name: 'N',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        newton: {
            name: 'newton',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        dyn: {
            name: 'dyn',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 0.00001,
            offset: 0
        },
        dyne: {
            name: 'dyne',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 0.00001,
            offset: 0
        },
        lbf: {
            name: 'lbf',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        poundforce: {
            name: 'poundforce',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        kip: {
            name: 'kip',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 4448.2216,
            offset: 0
        },
        kilogramforce: {
            name: 'kilogramforce',
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 9.80665,
            offset: 0
        },
        // Energy
        J: {
            name: 'J',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        joule: {
            name: 'joule',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        erg: {
            name: 'erg',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.NONE,
            value: 1e-7,
            offset: 0
        },
        Wh: {
            name: 'Wh',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 3600,
            offset: 0
        },
        BTU: {
            name: 'BTU',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.BTU,
            value: 1055.05585262,
            offset: 0
        },
        eV: {
            name: 'eV',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1.602176565e-19,
            offset: 0
        },
        electronvolt: {
            name: 'electronvolt',
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.LONG,
            value: 1.602176565e-19,
            offset: 0
        },
        // Power
        W: {
            name: 'W',
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        watt: {
            name: 'watt',
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        hp: {
            name: 'hp',
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.NONE,
            value: 745.6998715386,
            offset: 0
        },
        // Electrical power units
        VAR: {
            name: 'VAR',
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: Complex.I,
            offset: 0
        },
        VA: {
            name: 'VA',
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Pressure
        Pa: {
            name: 'Pa',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        psi: {
            name: 'psi',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 6894.75729276459,
            offset: 0
        },
        atm: {
            name: 'atm',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 101325,
            offset: 0
        },
        bar: {
            name: 'bar',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORTLONG,
            value: 100000,
            offset: 0
        },
        torr: {
            name: 'torr',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmHg: {
            name: 'mmHg',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmH2O: {
            name: 'mmH2O',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 9.80665,
            offset: 0
        },
        cmH2O: {
            name: 'cmH2O',
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 98.0665,
            offset: 0
        },
        // Electric charge
        coulomb: {
            name: 'coulomb',
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        C: {
            name: 'C',
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric capacitance
        farad: {
            name: 'farad',
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        F: {
            name: 'F',
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric potential
        volt: {
            name: 'volt',
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        V: {
            name: 'V',
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric resistance
        ohm: {
            name: 'ohm',
            base: BASE_UNITS.ELECTRIC_RESISTANCE,
            prefixes: PREFIXES.SHORTLONG,
            // Both Mohm and megaohm are acceptable
            value: 1,
            offset: 0
        },
        /*
     * Unicode breaks in browsers if charset is not specified
    Ω: {
      name: 'Ω',
      base: BASE_UNITS.ELECTRIC_RESISTANCE,
      prefixes: PREFIXES.SHORT,
      value: 1,
      offset: 0
    },
    */ // Electric inductance
        henry: {
            name: 'henry',
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        H: {
            name: 'H',
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric conductance
        siemens: {
            name: 'siemens',
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        S: {
            name: 'S',
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux
        weber: {
            name: 'weber',
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        Wb: {
            name: 'Wb',
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux density
        tesla: {
            name: 'tesla',
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        T: {
            name: 'T',
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Binary
        b: {
            name: 'b',
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 1,
            offset: 0
        },
        bits: {
            name: 'bits',
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 1,
            offset: 0
        },
        B: {
            name: 'B',
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 8,
            offset: 0
        },
        bytes: {
            name: 'bytes',
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 8,
            offset: 0
        }
    }; // aliases (formerly plurals)
    var ALIASES = {
        meters: 'meter',
        inches: 'inch',
        feet: 'foot',
        yards: 'yard',
        miles: 'mile',
        links: 'link',
        rods: 'rod',
        chains: 'chain',
        angstroms: 'angstrom',
        lt: 'l',
        litres: 'litre',
        liter: 'litre',
        liters: 'litre',
        teaspoons: 'teaspoon',
        tablespoons: 'tablespoon',
        minims: 'minim',
        fluiddrams: 'fluiddram',
        fluidounces: 'fluidounce',
        gills: 'gill',
        cups: 'cup',
        pints: 'pint',
        quarts: 'quart',
        gallons: 'gallon',
        beerbarrels: 'beerbarrel',
        oilbarrels: 'oilbarrel',
        hogsheads: 'hogshead',
        gtts: 'gtt',
        grams: 'gram',
        tons: 'ton',
        tonnes: 'tonne',
        grains: 'grain',
        drams: 'dram',
        ounces: 'ounce',
        poundmasses: 'poundmass',
        hundredweights: 'hundredweight',
        sticks: 'stick',
        lb: 'lbm',
        lbs: 'lbm',
        kips: 'kip',
        kgf: 'kilogramforce',
        acres: 'acre',
        hectares: 'hectare',
        sqfeet: 'sqft',
        sqyard: 'sqyd',
        sqmile: 'sqmi',
        sqmiles: 'sqmi',
        mmhg: 'mmHg',
        mmh2o: 'mmH2O',
        cmh2o: 'cmH2O',
        seconds: 'second',
        secs: 'second',
        minutes: 'minute',
        mins: 'minute',
        hours: 'hour',
        hr: 'hour',
        hrs: 'hour',
        days: 'day',
        weeks: 'week',
        months: 'month',
        years: 'year',
        decades: 'decade',
        centuries: 'century',
        millennia: 'millennium',
        hertz: 'hertz',
        radians: 'radian',
        degrees: 'degree',
        gradians: 'gradian',
        cycles: 'cycle',
        arcsecond: 'arcsec',
        arcseconds: 'arcsec',
        arcminute: 'arcmin',
        arcminutes: 'arcmin',
        BTUs: 'BTU',
        watts: 'watt',
        joules: 'joule',
        amperes: 'ampere',
        coulombs: 'coulomb',
        volts: 'volt',
        ohms: 'ohm',
        farads: 'farad',
        webers: 'weber',
        teslas: 'tesla',
        electronvolts: 'electronvolt',
        moles: 'mole',
        bit: 'bits',
        byte: 'bytes'
    };
    /**
   * Calculate the values for the angle units.
   * Value is calculated as number or BigNumber depending on the configuration
   * @param {{number: 'number' | 'BigNumber'}} config
   */ function calculateAngleValues(config) {
        if (config.number === 'BigNumber') {
            var pi = (0, $cUmcc.createBigNumberPi)(_BigNumber);
            UNITS.rad.value = new _BigNumber(1);
            UNITS.deg.value = pi.div(180); // 2 * pi / 360
            UNITS.grad.value = pi.div(200); // 2 * pi / 400
            UNITS.cycle.value = pi.times(2); // 2 * pi
            UNITS.arcsec.value = pi.div(648000); // 2 * pi / 360 / 3600
            UNITS.arcmin.value = pi.div(10800); // 2 * pi / 360 / 60
        } else {
            // number
            UNITS.rad.value = 1;
            UNITS.deg.value = Math.PI / 180; // 2 * pi / 360
            UNITS.grad.value = Math.PI / 200; // 2 * pi / 400
            UNITS.cycle.value = Math.PI * 2; // 2 * pi
            UNITS.arcsec.value = Math.PI / 648000; // 2 * pi / 360 / 3600
            UNITS.arcmin.value = Math.PI / 10800; // 2 * pi / 360 / 60
        } // copy to the full names of the angles
        UNITS.radian.value = UNITS.rad.value;
        UNITS.degree.value = UNITS.deg.value;
        UNITS.gradian.value = UNITS.grad.value;
    } // apply the angle values now
    calculateAngleValues(config);
    if (on) // recalculate the values on change of configuration
    on('config', function(curr, prev) {
        if (curr.number !== prev.number) calculateAngleValues(curr);
    });
    /**
   * A unit system is a set of dimensionally independent base units plus a set of derived units, formed by multiplication and division of the base units, that are by convention used with the unit system.
   * A user perhaps could issue a command to select a preferred unit system, or use the default (see below).
   * Auto unit system: The default unit system is updated on the fly anytime a unit is parsed. The corresponding unit in the default unit system is updated, so that answers are given in the same units the user supplies.
   */ var UNIT_SYSTEMS = {
        si: {
            // Base units
            NONE: {
                unit: UNIT_NONE,
                prefix: PREFIXES.NONE['']
            },
            LENGTH: {
                unit: UNITS.m,
                prefix: PREFIXES.SHORT['']
            },
            MASS: {
                unit: UNITS.g,
                prefix: PREFIXES.SHORT.k
            },
            TIME: {
                unit: UNITS.s,
                prefix: PREFIXES.SHORT['']
            },
            CURRENT: {
                unit: UNITS.A,
                prefix: PREFIXES.SHORT['']
            },
            TEMPERATURE: {
                unit: UNITS.K,
                prefix: PREFIXES.SHORT['']
            },
            LUMINOUS_INTENSITY: {
                unit: UNITS.cd,
                prefix: PREFIXES.SHORT['']
            },
            AMOUNT_OF_SUBSTANCE: {
                unit: UNITS.mol,
                prefix: PREFIXES.SHORT['']
            },
            ANGLE: {
                unit: UNITS.rad,
                prefix: PREFIXES.SHORT['']
            },
            BIT: {
                unit: UNITS.bits,
                prefix: PREFIXES.SHORT['']
            },
            // Derived units
            FORCE: {
                unit: UNITS.N,
                prefix: PREFIXES.SHORT['']
            },
            ENERGY: {
                unit: UNITS.J,
                prefix: PREFIXES.SHORT['']
            },
            POWER: {
                unit: UNITS.W,
                prefix: PREFIXES.SHORT['']
            },
            PRESSURE: {
                unit: UNITS.Pa,
                prefix: PREFIXES.SHORT['']
            },
            ELECTRIC_CHARGE: {
                unit: UNITS.C,
                prefix: PREFIXES.SHORT['']
            },
            ELECTRIC_CAPACITANCE: {
                unit: UNITS.F,
                prefix: PREFIXES.SHORT['']
            },
            ELECTRIC_POTENTIAL: {
                unit: UNITS.V,
                prefix: PREFIXES.SHORT['']
            },
            ELECTRIC_RESISTANCE: {
                unit: UNITS.ohm,
                prefix: PREFIXES.SHORT['']
            },
            ELECTRIC_INDUCTANCE: {
                unit: UNITS.H,
                prefix: PREFIXES.SHORT['']
            },
            ELECTRIC_CONDUCTANCE: {
                unit: UNITS.S,
                prefix: PREFIXES.SHORT['']
            },
            MAGNETIC_FLUX: {
                unit: UNITS.Wb,
                prefix: PREFIXES.SHORT['']
            },
            MAGNETIC_FLUX_DENSITY: {
                unit: UNITS.T,
                prefix: PREFIXES.SHORT['']
            },
            FREQUENCY: {
                unit: UNITS.Hz,
                prefix: PREFIXES.SHORT['']
            }
        }
    }; // Clone to create the other unit systems
    UNIT_SYSTEMS.cgs = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.cgs.LENGTH = {
        unit: UNITS.m,
        prefix: PREFIXES.SHORT.c
    };
    UNIT_SYSTEMS.cgs.MASS = {
        unit: UNITS.g,
        prefix: PREFIXES.SHORT['']
    };
    UNIT_SYSTEMS.cgs.FORCE = {
        unit: UNITS.dyn,
        prefix: PREFIXES.SHORT['']
    };
    UNIT_SYSTEMS.cgs.ENERGY = {
        unit: UNITS.erg,
        prefix: PREFIXES.NONE['']
    }; // there are wholly 4 unique cgs systems for electricity and magnetism,
    // so let's not worry about it unless somebody complains
    UNIT_SYSTEMS.us = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.us.LENGTH = {
        unit: UNITS.ft,
        prefix: PREFIXES.NONE['']
    };
    UNIT_SYSTEMS.us.MASS = {
        unit: UNITS.lbm,
        prefix: PREFIXES.NONE['']
    };
    UNIT_SYSTEMS.us.TEMPERATURE = {
        unit: UNITS.degF,
        prefix: PREFIXES.NONE['']
    };
    UNIT_SYSTEMS.us.FORCE = {
        unit: UNITS.lbf,
        prefix: PREFIXES.NONE['']
    };
    UNIT_SYSTEMS.us.ENERGY = {
        unit: UNITS.BTU,
        prefix: PREFIXES.BTU['']
    };
    UNIT_SYSTEMS.us.POWER = {
        unit: UNITS.hp,
        prefix: PREFIXES.NONE['']
    };
    UNIT_SYSTEMS.us.PRESSURE = {
        unit: UNITS.psi,
        prefix: PREFIXES.NONE['']
    }; // Add additional unit systems here.
    // Choose a unit system to seed the auto unit system.
    UNIT_SYSTEMS.auto = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si)); // Set the current unit system
    var currentUnitSystem = UNIT_SYSTEMS.auto;
    /**
   * Set a unit system for formatting derived units.
   * @param {string} [name] The name of the unit system.
   */ Unit.setUnitSystem = function(name) {
        if ((0, $4mYv9.hasOwnProperty)(UNIT_SYSTEMS, name)) currentUnitSystem = UNIT_SYSTEMS[name];
        else throw new Error('Unit system ' + name + ' does not exist. Choices are: ' + Object.keys(UNIT_SYSTEMS).join(', '));
    };
    /**
   * Return the current unit system.
   * @return {string} The current unit system.
   */ Unit.getUnitSystem = function() {
        for(var _key in UNIT_SYSTEMS)if ((0, $4mYv9.hasOwnProperty)(UNIT_SYSTEMS, _key)) {
            if (UNIT_SYSTEMS[_key] === currentUnitSystem) return _key;
        }
    };
    /**
   * Converters to convert from number to an other numeric type like BigNumber
   * or Fraction
   */ Unit.typeConverters = {
        BigNumber: function BigNumber(x) {
            return new _BigNumber(x + ''); // stringify to prevent constructor error
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x);
        },
        Complex: function Complex(x) {
            return x;
        },
        number: function number(x) {
            return x;
        }
    };
    /**
   * Retrieve the right convertor function corresponding with the type
   * of provided exampleValue.
   *
   * @param {string} type   A string 'number', 'BigNumber', or 'Fraction'
   *                        In case of an unknown type,
   * @return {Function}
   */ Unit._getNumberConverter = function(type) {
        if (!Unit.typeConverters[type]) throw new TypeError('Unsupported type "' + type + '"');
        return Unit.typeConverters[type];
    }; // Add dimensions to each built-in unit
    for(var _key2 in UNITS)if ((0, $4mYv9.hasOwnProperty)(UNITS, _key2)) {
        var unit = UNITS[_key2];
        unit.dimensions = unit.base.dimensions;
    }
     // Create aliases
    for(var _name2 in ALIASES)if ((0, $4mYv9.hasOwnProperty)(ALIASES, _name2)) {
        var _unit2 = UNITS[ALIASES[_name2]];
        var alias = {};
        for(var _key3 in _unit2)if ((0, $4mYv9.hasOwnProperty)(_unit2, _key3)) alias[_key3] = _unit2[_key3];
        alias.name = _name2;
        UNITS[_name2] = alias;
    }
    /**
   * Checks if a character is a valid latin letter (upper or lower case).
   * Note that this function can be overridden, for example to allow support of other alphabets.
   * @param {string} c Tested character
   */ Unit.isValidAlpha = function isValidAlpha(c) {
        return /^[a-zA-Z]$/.test(c);
    };
    function assertUnitNameIsValid(name) {
        for(var i = 0; i < name.length; i++){
            c = name.charAt(i);
            if (i === 0 && !Unit.isValidAlpha(c)) throw new Error('Invalid unit name (must begin with alpha character): "' + name + '"');
            if (i > 0 && !(Unit.isValidAlpha(c) || isDigit(c))) throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + name + '"');
        }
    }
    /**
   * Wrapper around createUnitSingle.
   * Example:
   *  createUnit({
   *    foo: { },
   *    bar: {
   *      definition: 'kg/foo',
   *      aliases: ['ba', 'barr', 'bars'],
   *      offset: 200
   *    },
   *    baz: '4 bar'
   *  },
   *  {
   *    override: true
   *  })
   * @param {object} obj      Object map. Each key becomes a unit which is defined by its value.
   * @param {object} options
   */ Unit.createUnit = function(obj, options) {
        if (typeof obj !== 'object') throw new TypeError("createUnit expects first parameter to be of type 'Object'");
         // Remove all units and aliases we are overriding
        if (options && options.override) for(var _key4 in obj){
            if ((0, $4mYv9.hasOwnProperty)(obj, _key4)) Unit.deleteUnit(_key4);
            if (obj[_key4].aliases) for(var i = 0; i < obj[_key4].aliases.length; i++)Unit.deleteUnit(obj[_key4].aliases[i]);
        }
         // TODO: traverse multiple times until all units have been added
        var lastUnit;
        for(var _key5 in obj)if ((0, $4mYv9.hasOwnProperty)(obj, _key5)) lastUnit = Unit.createUnitSingle(_key5, obj[_key5]);
        return lastUnit;
    };
    /**
   * Create a user-defined unit and register it with the Unit type.
   * Example:
   *  createUnitSingle('knot', '0.514444444 m/s')
   *  createUnitSingle('acre', new Unit(43560, 'ft^2'))
   *
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string, Unit, Object} definition      Definition of the unit in terms
   * of existing units. For example, '0.514444444 m / s'. Can be a Unit, a string,
   * or an Object. If an Object, may have the following properties:
   *   - definition {string|Unit} The definition of this unit.
   *   - prefixes {string} "none", "short", "long", "binary_short", or "binary_long".
   *     The default is "none".
   *   - aliases {Array} Array of strings. Example: ['knots', 'kt', 'kts']
   *   - offset {Numeric} An offset to apply when converting from the unit. For
   *     example, the offset for celsius is 273.15 and the offset for farhenheit
   *     is 459.67. Default is 0.
   *   - baseName {string} If the unit's dimension does not match that of any other
   *     base unit, the name of the newly create base unit. Otherwise, this property
   *     has no effect.
   *
   * @param {Object} options   (optional) An object containing any of the following
   * properties:
   *   - override {boolean} Whether this unit should be allowed to override existing
   *     units.
   *
   * @return {Unit}
   */ Unit.createUnitSingle = function(name, obj, options) {
        if (typeof obj === 'undefined' || obj === null) obj = {};
        if (typeof name !== 'string') throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
         // Check collisions with existing units
        if ((0, $4mYv9.hasOwnProperty)(UNITS, name)) throw new Error('Cannot create unit "' + name + '": a unit with that name already exists');
         // TODO: Validate name for collisions with other built-in functions (like abs or cos, for example), and for acceptable variable names. For example, '42' is probably not a valid unit. Nor is '%', since it is also an operator.
        assertUnitNameIsValid(name);
        var defUnit = null; // The Unit from which the new unit will be created.
        var aliases = [];
        var offset = 0;
        var definition;
        var prefixes;
        var baseName;
        if (obj && obj.type === 'Unit') defUnit = obj.clone();
        else if (typeof obj === 'string') {
            if (obj !== '') definition = obj;
        } else if (typeof obj === 'object') {
            definition = obj.definition;
            prefixes = obj.prefixes;
            offset = obj.offset;
            baseName = obj.baseName;
            if (obj.aliases) aliases = obj.aliases.valueOf(); // aliases could be a Matrix, so convert to Array
        } else throw new TypeError('Cannot create unit "' + name + '" from "' + obj.toString() + '": expecting "string" or "Unit" or "Object"');
        if (aliases) for(var i = 0; i < aliases.length; i++){
            if ((0, $4mYv9.hasOwnProperty)(UNITS, aliases[i])) throw new Error('Cannot create alias "' + aliases[i] + '": a unit with that name already exists');
        }
        if (definition && typeof definition === 'string' && !defUnit) try {
            defUnit = Unit.parse(definition, {
                allowNoUnits: true
            });
        } catch (ex) {
            ex.message = 'Could not create unit "' + name + '" from "' + definition + '": ' + ex.message;
            throw ex;
        }
        else if (definition && definition.type === 'Unit') defUnit = definition.clone();
        aliases = aliases || [];
        offset = offset || 0;
        if (prefixes && prefixes.toUpperCase) prefixes = PREFIXES[prefixes.toUpperCase()] || PREFIXES.NONE;
        else prefixes = PREFIXES.NONE;
         // If defUnit is null, it is because the user did not
        // specify a defintion. So create a new base dimension.
        var newUnit = {};
        if (!defUnit) {
            // Add a new base dimension
            baseName = baseName || name + '_STUFF'; // foo --> foo_STUFF, or the essence of foo
            if (BASE_DIMENSIONS.indexOf(baseName) >= 0) throw new Error('Cannot create new base unit "' + name + '": a base unit with that name already exists (and cannot be overridden)');
            BASE_DIMENSIONS.push(baseName); // Push 0 onto existing base units
            for(var b in BASE_UNITS)if ((0, $4mYv9.hasOwnProperty)(BASE_UNITS, b)) BASE_UNITS[b].dimensions[BASE_DIMENSIONS.length - 1] = 0;
             // Add the new base unit
            var newBaseUnit = {
                dimensions: []
            };
            for(var _i6 = 0; _i6 < BASE_DIMENSIONS.length; _i6++)newBaseUnit.dimensions[_i6] = 0;
            newBaseUnit.dimensions[BASE_DIMENSIONS.length - 1] = 1;
            newBaseUnit.key = baseName;
            BASE_UNITS[baseName] = newBaseUnit;
            newUnit = {
                name: name,
                value: 1,
                dimensions: BASE_UNITS[baseName].dimensions.slice(0),
                prefixes: prefixes,
                offset: offset,
                base: BASE_UNITS[baseName]
            };
            currentUnitSystem[baseName] = {
                unit: newUnit,
                prefix: PREFIXES.NONE['']
            };
        } else {
            newUnit = {
                name: name,
                value: defUnit.value,
                dimensions: defUnit.dimensions.slice(0),
                prefixes: prefixes,
                offset: offset
            }; // Create a new base if no matching base exists
            var anyMatch = false;
            for(var _i7 in BASE_UNITS)if ((0, $4mYv9.hasOwnProperty)(BASE_UNITS, _i7)) {
                var match = true;
                for(var j = 0; j < BASE_DIMENSIONS.length; j++)if (Math.abs((newUnit.dimensions[j] || 0) - (BASE_UNITS[_i7].dimensions[j] || 0)) > 1e-12) {
                    match = false;
                    break;
                }
                if (match) {
                    anyMatch = true;
                    newUnit.base = BASE_UNITS[_i7];
                    break;
                }
            }
            if (!anyMatch) {
                baseName = baseName || name + '_STUFF'; // foo --> foo_STUFF, or the essence of foo
                // Add the new base unit
                var _newBaseUnit = {
                    dimensions: defUnit.dimensions.slice(0)
                };
                _newBaseUnit.key = baseName;
                BASE_UNITS[baseName] = _newBaseUnit;
                currentUnitSystem[baseName] = {
                    unit: newUnit,
                    prefix: PREFIXES.NONE['']
                };
                newUnit.base = BASE_UNITS[baseName];
            }
        }
        Unit.UNITS[name] = newUnit;
        for(var _i8 = 0; _i8 < aliases.length; _i8++){
            var aliasName = aliases[_i8];
            var _alias = {};
            for(var _key6 in newUnit)if ((0, $4mYv9.hasOwnProperty)(newUnit, _key6)) _alias[_key6] = newUnit[_key6];
            _alias.name = aliasName;
            Unit.UNITS[aliasName] = _alias;
        } // delete the memoization cache, since adding a new unit to the array
        // invalidates all old results
        delete _findUnit.cache;
        return new Unit(null, name);
    };
    Unit.deleteUnit = function(name) {
        delete Unit.UNITS[name];
    }; // expose arrays with prefixes, dimensions, units, systems
    Unit.PREFIXES = PREFIXES;
    Unit.BASE_DIMENSIONS = BASE_DIMENSIONS;
    Unit.BASE_UNITS = BASE_UNITS;
    Unit.UNIT_SYSTEMS = UNIT_SYSTEMS;
    Unit.UNITS = UNITS;
    return Unit;
}, {
    isClass: true
});

});

parcelRegister("fmE5G", function(module, exports) {

$parcel$export(module.exports, "createUnitFunction", () => $b2f8023fcbd593fb$export$17074f98b69d2545);

var $4eE2e = parcelRequire("4eE2e");

var $9nwyh = parcelRequire("9nwyh");
var $b2f8023fcbd593fb$var$name = 'unit';
var $b2f8023fcbd593fb$var$dependencies = [
    'typed',
    'Unit'
]; // This function is named createUnitFunction to prevent a naming conflict with createUnit
var $b2f8023fcbd593fb$export$17074f98b69d2545 = /* #__PURE__ */ (0, $4eE2e.factory)($b2f8023fcbd593fb$var$name, $b2f8023fcbd593fb$var$dependencies, (_ref)=>{
    var { typed: typed, Unit: Unit } = _ref;
    /**
   * Create a unit. Depending on the passed arguments, the function
   * will create and return a new math.Unit object.
   * When a matrix is provided, all elements will be converted to units.
   *
   * Syntax:
   *
   *     math.unit(unit : string)
   *     math.unit(value : number, unit : string)
   *
   * Examples:
   *
   *    const a = math.unit(5, 'cm')    // returns Unit 50 mm
   *    const b = math.unit('23 kg')    // returns Unit 23 kg
   *    a.to('m')                       // returns Unit 0.05 m
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, string, createUnit
   *
   * @param {* | Array | Matrix} args   A number and unit.
   * @return {Unit | Array | Matrix}    The created unit
   */ return typed($b2f8023fcbd593fb$var$name, {
        Unit: function Unit(x) {
            return x.clone();
        },
        string: function string(x) {
            if (Unit.isValuelessUnit(x)) return new Unit(null, x); // a pure unit
            return Unit.parse(x, {
                allowNoUnits: true
            }); // a unit with value, like '5cm'
        },
        'number | BigNumber | Fraction | Complex, string': function numberBigNumberFractionComplexString(value, unit) {
            return new Unit(value, unit);
        },
        'Array | Matrix': function ArrayMatrix(x) {
            return (0, $9nwyh.deepMap)(x, this);
        }
    });
});

});

parcelRegister("lvQKV", function(module, exports) {

$parcel$export(module.exports, "createUsolve", () => $fa956a69f99c7c05$export$f652f5e8e3e838da);

var $4eE2e = parcelRequire("4eE2e");

var $4ssS1 = parcelRequire("4ssS1");
var $fa956a69f99c7c05$var$name = 'usolve';
var $fa956a69f99c7c05$var$dependencies = [
    'typed',
    'matrix',
    'divideScalar',
    'multiplyScalar',
    'subtract',
    'equalScalar',
    'DenseMatrix'
];
var $fa956a69f99c7c05$export$f652f5e8e3e838da = /* #__PURE__ */ (0, $4eE2e.factory)($fa956a69f99c7c05$var$name, $fa956a69f99c7c05$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $4ssS1.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds one solution of a linear equation system by backward substitution. Matrix must be an upper triangular matrix. Throws an error if there's no solution.
   *
   * `U * x = b`
   *
   * Syntax:
   *
   *    math.usolve(U, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = usolve(a, b)  // [[8], [9]]
   *
   * See also:
   *
   *    usolveAll, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} U       A N x N matrix or array (U)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($fa956a69f99c7c05$var$name, {
        'SparseMatrix, Array | Matrix': function SparseMatrixArrayMatrix(m, b) {
            return _sparseBackwardSubstitution(m, b);
        },
        'DenseMatrix, Array | Matrix': function DenseMatrixArrayMatrix(m, b) {
            return _denseBackwardSubstitution(m, b);
        },
        'Array, Array | Matrix': function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var r = _denseBackwardSubstitution(m, b);
            return r.valueOf();
        }
    });
    function _denseBackwardSubstitution(m, b) {
        // make b into a column vector
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1]; // result
        var x = [];
        var mdata = m._data; // loop columns backwards
        for(var j = columns - 1; j >= 0; j--){
            // b[j]
            var bj = bdata[j][0] || 0; // x[j]
            var xj = void 0;
            if (!equalScalar(bj, 0)) {
                // value at [j, j]
                var vjj = mdata[j][j];
                if (equalScalar(vjj, 0)) // system cannot be solved
                throw new Error('Linear system cannot be solved since matrix is singular');
                xj = divideScalar(bj, vjj); // loop rows
                for(var i = j - 1; i >= 0; i--)// update copy of b
                bdata[i] = [
                    subtract(bdata[i][0] || 0, multiplyScalar(xj, mdata[i][j]))
                ];
            } else // zero value at j
            xj = 0;
             // update x
            x[j] = [
                xj
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseBackwardSubstitution(m, b) {
        // make b into a column vector
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // result
        var x = []; // loop columns backwards
        for(var j = columns - 1; j >= 0; j--){
            var bj = bdata[j][0] || 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = 0; // upper triangular matrix values & index (column j)
                var jValues = [];
                var jIndices = []; // first & last indeces in column
                var firstIndex = ptr[j];
                var lastIndex = ptr[j + 1]; // values in column, find value at [j, j], loop backwards
                for(var k = lastIndex - 1; k >= firstIndex; k--){
                    var i = index[k]; // check row (rows are not sorted!)
                    if (i === j) vjj = values[k];
                    else if (i < j) {
                        // store upper triangular
                        jValues.push(values[k]);
                        jIndices.push(i);
                    }
                } // at this point we must have a value in vjj
                if (equalScalar(vjj, 0)) throw new Error('Linear system cannot be solved since matrix is singular');
                var xj = divideScalar(bj, vjj);
                for(var _k = 0, _lastIndex = jIndices.length; _k < _lastIndex; _k++){
                    var _i = jIndices[_k];
                    bdata[_i] = [
                        subtract(bdata[_i][0], multiplyScalar(xj, jValues[_k]))
                    ];
                }
                x[j] = [
                    xj
                ];
            } else // degenerate row, we can choose any value
            x[j] = [
                0
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});

});

parcelRegister("c0n5Z", function(module, exports) {

$parcel$export(module.exports, "createUsolveAll", () => $8bd766702bda2de7$export$c8bbc8bec60c7fc3);

var $4eE2e = parcelRequire("4eE2e");

var $4ssS1 = parcelRequire("4ssS1");
var $8bd766702bda2de7$var$name = 'usolveAll';
var $8bd766702bda2de7$var$dependencies = [
    'typed',
    'matrix',
    'divideScalar',
    'multiplyScalar',
    'subtract',
    'equalScalar',
    'DenseMatrix'
];
var $8bd766702bda2de7$export$c8bbc8bec60c7fc3 = /* #__PURE__ */ (0, $4eE2e.factory)($8bd766702bda2de7$var$name, $8bd766702bda2de7$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $4ssS1.createSolveValidation)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds all solutions of a linear equation system by backward substitution. Matrix must be an upper triangular matrix.
   *
   * `U * x = b`
   *
   * Syntax:
   *
   *    math.usolveAll(U, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = usolveAll(a, b)  // [ [[8], [9]] ]
   *
   * See also:
   *
   *    usolve, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} U       A N x N matrix or array (U)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix[] | Array[]}  An array of affine-independent column vectors (x) that solve the linear system
   */ return typed($8bd766702bda2de7$var$name, {
        'SparseMatrix, Array | Matrix': function SparseMatrixArrayMatrix(m, b) {
            return _sparseBackwardSubstitution(m, b);
        },
        'DenseMatrix, Array | Matrix': function DenseMatrixArrayMatrix(m, b) {
            return _denseBackwardSubstitution(m, b);
        },
        'Array, Array | Matrix': function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var R = _denseBackwardSubstitution(m, b);
            return R.map((r)=>r.valueOf());
        }
    });
    function _denseBackwardSubstitution(m, b_) {
        // the algorithm is derived from
        // https://www.overleaf.com/read/csvgqdxggyjv
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var M = m._data;
        var rows = m._size[0];
        var columns = m._size[1]; // loop columns backwards
        for(var i = columns - 1; i >= 0; i--){
            var L = B.length; // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                if (!equalScalar(M[i][i], 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], M[i][i]);
                    for(var j = i - 1; j >= 0; j--)// b[j] -= b[i] * M[j,i]
                    b[j] = subtract(b[j], multiplyScalar(b[i], M[j][i]));
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j = i - 1; _j >= 0; _j--)bNew[_j] = subtract(bNew[_j], M[_j][i]);
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
    function _sparseBackwardSubstitution(m, b_) {
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // loop columns backwards
        for(var i = columns - 1; i >= 0; i--){
            var L = B.length; // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k]; // values & indices (column i)
                var iValues = [];
                var iIndices = []; // first & last indeces in column
                var firstIndex = ptr[i];
                var lastIndex = ptr[i + 1]; // find the value at [i, i]
                var Mii = 0;
                for(var j = lastIndex - 1; j >= firstIndex; j--){
                    var J = index[j]; // check row
                    if (J === i) Mii = values[j];
                    else if (J < i) {
                        // store upper triangular
                        iValues.push(values[j]);
                        iIndices.push(J);
                    }
                }
                if (!equalScalar(Mii, 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], Mii); // loop upper triangular
                    for(var _j2 = 0, _lastIndex = iIndices.length; _j2 < _lastIndex; _j2++){
                        var _J = iIndices[_j2];
                        b[_J] = subtract(b[_J], multiplyScalar(b[i], iValues[_j2]));
                    }
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1; // loop upper triangular
                    for(var _j3 = 0, _lastIndex2 = iIndices.length; _j3 < _lastIndex2; _j3++){
                        var _J2 = iIndices[_j3];
                        bNew[_J2] = subtract(bNew[_J2], iValues[_j3]);
                    }
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
});

});

parcelRegister("4yw8r", function(module, exports) {

$parcel$export(module.exports, "createVariance", () => $351343c57109f188$export$b989221824390fb);

var $9nwyh = parcelRequire("9nwyh");

var $gs7TF = parcelRequire("gs7TF");

var $4eE2e = parcelRequire("4eE2e");

var $ijiby = parcelRequire("ijiby");
var $351343c57109f188$var$DEFAULT_NORMALIZATION = 'unbiased';
var $351343c57109f188$var$name = 'variance';
var $351343c57109f188$var$dependencies = [
    'typed',
    'add',
    'subtract',
    'multiply',
    'divide',
    'apply',
    'isNaN'
];
var $351343c57109f188$export$b989221824390fb = /* #__PURE__ */ (0, $4eE2e.factory)($351343c57109f188$var$name, $351343c57109f188$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, subtract: subtract, multiply: multiply, divide: divide, apply: apply, isNaN: isNaN } = _ref;
    /**
   * Compute the variance of a matrix or a  list with values.
   * In case of a (multi dimensional) array or matrix, the variance over all
   * elements will be calculated.
   *
   * Additionally, it is possible to compute the variance along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Note that older browser may not like the variable name `var`. In that
   * case, the function can be called as `math['var'](...)` instead of
   * `math.var(...)`.
   *
   * Syntax:
   *
   *     math.variance(a, b, c, ...)
   *     math.variance(A)
   *     math.variance(A, normalization)
   *     math.variance(A, dimension)
   *     math.variance(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.variance(2, 4, 6)                     // returns 4
   *     math.variance([2, 4, 6, 8])                // returns 6.666666666666667
   *     math.variance([2, 4, 6, 8], 'uncorrected') // returns 5
   *     math.variance([2, 4, 6, 8], 'biased')      // returns 4
   *
   *     math.variance([[1, 2, 3], [4, 5, 6]])      // returns 3.5
   *     math.variance([[1, 2, 3], [4, 6, 8]], 0)   // returns [4.5, 8, 12.5]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1)   // returns [1, 4]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.5, 2]
   *
   * See also:
   *
   *    mean, median, max, min, prod, std, sum
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the variance for a matrix
   * @return {*} The variance
   */ return typed($351343c57109f188$var$name, {
        // variance([a, b, c, d, ...])
        'Array | Matrix': function ArrayMatrix(array) {
            return _var(array, $351343c57109f188$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, d, ...], normalization)
        'Array | Matrix, string': _var,
        // variance([a, b, c, c, ...], dim)
        'Array | Matrix, number | BigNumber': function ArrayMatrixNumberBigNumber(array, dim) {
            return _varDim(array, dim, $351343c57109f188$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, c, ...], dim, normalization)
        'Array | Matrix, number | BigNumber, string': _varDim,
        // variance(a, b, c, d, ...)
        '...': function _(args) {
            return _var(args, $351343c57109f188$var$DEFAULT_NORMALIZATION);
        }
    });
    /**
   * Recursively calculate the variance of an n-dimensional array
   * @param {Array} array
   * @param {string} normalization
   *                        Determines how to normalize the variance:
   *                        - 'unbiased'    The sum of squared errors is divided by (n - 1)
   *                        - 'uncorrected' The sum of squared errors is divided by n
   *                        - 'biased'      The sum of squared errors is divided by (n + 1)
   * @return {number | BigNumber} variance
   * @private
   */ function _var(array, normalization) {
        var sum;
        var num = 0;
        if (array.length === 0) throw new SyntaxError('Function variance requires one or more parameters (0 provided)');
         // calculate the mean and number of elements
        (0, $9nwyh.deepForEach)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
                num++;
            } catch (err) {
                throw (0, $ijiby.improveErrorMessage)(err, 'variance', value);
            }
        });
        if (num === 0) throw new Error('Cannot calculate variance of an empty array');
        var mean = divide(sum, num); // calculate the variance
        sum = undefined;
        (0, $9nwyh.deepForEach)(array, function(value) {
            var diff = subtract(value, mean);
            sum = sum === undefined ? multiply(diff, diff) : add(sum, multiply(diff, diff));
        });
        if (isNaN(sum)) return sum;
        switch(normalization){
            case 'uncorrected':
                return divide(sum, num);
            case 'biased':
                return divide(sum, num + 1);
            case 'unbiased':
                var zero = (0, $gs7TF.isBigNumber)(sum) ? sum.mul(0) : 0;
                return num === 1 ? zero : divide(sum, num - 1);
            default:
                throw new Error('Unknown normalization "' + normalization + '". ' + 'Choose "unbiased" (default), "uncorrected", or "biased".');
        }
    }
    function _varDim(array, dim, normalization) {
        try {
            if (array.length === 0) throw new SyntaxError('Function variance requires one or more parameters (0 provided)');
            return apply(array, dim, (x)=>_var(x, normalization));
        } catch (err) {
            throw (0, $ijiby.improveErrorMessage)(err, 'variance');
        }
    }
});

});

parcelRegister("bBj1m", function(module, exports) {

$parcel$export(module.exports, "createXgcd", () => $8721e79736279d5b$export$de8cbd18c98bf9d5);

var $4eE2e = parcelRequire("4eE2e");

var $eRNhQ = parcelRequire("eRNhQ");
var $8721e79736279d5b$var$name = 'xgcd';
var $8721e79736279d5b$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'BigNumber'
];
var $8721e79736279d5b$export$de8cbd18c98bf9d5 = /* #__PURE__ */ (0, $4eE2e.factory)($8721e79736279d5b$var$name, $8721e79736279d5b$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Calculate the extended greatest common divisor for two values.
   * See https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm.
   *
   * Syntax:
   *
   *    math.xgcd(a, b)
   *
   * Examples:
   *
   *    math.xgcd(8, 12)             // returns [4, -1, 1]
   *    math.gcd(8, 12)              // returns 4
   *    math.xgcd(36163, 21199)      // returns [1247, -7, 12]
   *
   * See also:
   *
   *    gcd, lcm
   *
   * @param {number | BigNumber} a  An integer number
   * @param {number | BigNumber} b  An integer number
   * @return {Array}              Returns an array containing 3 integers `[div, m, n]`
   *                              where `div = gcd(a, b)` and `a*m + b*n = div`
   */ return typed($8721e79736279d5b$var$name, {
        'number, number': function numberNumber(a, b) {
            var res = (0, $eRNhQ.xgcdNumber)(a, b);
            return config.matrix === 'Array' ? res : matrix(res);
        },
        'BigNumber, BigNumber': _xgcdBigNumber // TODO: implement support for Fraction
    });
    /**
   * Calculate xgcd for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @return {BigNumber[]} result
   * @private
   */ function _xgcdBigNumber(a, b) {
        // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
        var t;
        var q;
        var r;
        var zero = new BigNumber(0);
        var one = new BigNumber(1);
        var x = zero;
        var lastx = one;
        var y = one;
        var lasty = zero;
        if (!a.isInt() || !b.isInt()) throw new Error('Parameters in function xgcd must be integer numbers');
        while(!b.isZero()){
            q = a.div(b).floor();
            r = a.mod(b);
            t = x;
            x = lastx.minus(q.times(x));
            lastx = t;
            t = y;
            y = lasty.minus(q.times(y));
            lasty = t;
            a = b;
            b = r;
        }
        var res;
        if (a.lt(zero)) res = [
            a.neg(),
            lastx.neg(),
            lasty.neg()
        ];
        else res = [
            a,
            !a.isZero() ? lastx : 0,
            lasty
        ];
        return config.matrix === 'Array' ? res : matrix(res);
    }
});

});

parcelRegister("1FImG", function(module, exports) {

$parcel$export(module.exports, "createXor", () => $137c08b25be4f532$export$a2b8cab2c7385f0e);

var $6MKpt = parcelRequire("6MKpt");

var $ai5Sw = parcelRequire("ai5Sw");

var $6Q1Sk = parcelRequire("6Q1Sk");

var $KKjvJ = parcelRequire("KKjvJ");

var $laEuG = parcelRequire("laEuG");

var $4eE2e = parcelRequire("4eE2e");

var $jg11Z = parcelRequire("jg11Z");
var $137c08b25be4f532$var$name = 'xor';
var $137c08b25be4f532$var$dependencies = [
    'typed',
    'matrix',
    'DenseMatrix'
];
var $137c08b25be4f532$export$a2b8cab2c7385f0e = /* #__PURE__ */ (0, $4eE2e.factory)($137c08b25be4f532$var$name, $137c08b25be4f532$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $6MKpt.createAlgorithm03)({
        typed: typed
    });
    var algorithm07 = (0, $ai5Sw.createAlgorithm07)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $6Q1Sk.createAlgorithm12)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $KKjvJ.createAlgorithm13)({
        typed: typed
    });
    var algorithm14 = (0, $laEuG.createAlgorithm14)({
        typed: typed
    });
    /**
   * Logical `xor`. Test whether one and only one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.xor(x, y)
   *
   * Examples:
   *
   *    math.xor(2, 4)   // returns false
   *
   *    a = [2, 0, 0]
   *    b = [2, 7, 0]
   *    c = 0
   *
   *    math.xor(a, b)   // returns [false, true, false]
   *    math.xor(a, c)   // returns [true, false, false]
   *
   * See also:
   *
   *    and, not, or
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one and only one input is defined with a nonzero/nonempty value.
   */ return typed($137c08b25be4f532$var$name, {
        'number, number': (0, $jg11Z.xorNumber),
        'Complex, Complex': function ComplexComplex(x, y) {
            return (x.re !== 0 || x.im !== 0) !== (y.re !== 0 || y.im !== 0);
        },
        'BigNumber, BigNumber': function BigNumberBigNumber(x, y) {
            return (!x.isZero() && !x.isNaN()) !== (!y.isZero() && !y.isNaN());
        },
        'Unit, Unit': function UnitUnit(x, y) {
            return this(x.value || 0, y.value || 0);
        },
        'SparseMatrix, SparseMatrix': function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        'SparseMatrix, DenseMatrix': function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        'DenseMatrix, SparseMatrix': function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        'DenseMatrix, DenseMatrix': function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        'Array, Array': function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        'Array, Matrix': function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        'Matrix, Array': function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        'SparseMatrix, any': function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        'DenseMatrix, any': function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        'any, SparseMatrix': function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        'any, DenseMatrix': function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        'Array, any': function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        'any, Array': function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});

});

parcelRegister("gTtZ4", function(module, exports) {

$parcel$export(module.exports, "createZeros", () => $c4c90a9581616aae$export$13096c1635fe6e3d);

var $gs7TF = parcelRequire("gs7TF");

var $6egKm = parcelRequire("6egKm");

var $10UPF = parcelRequire("10UPF");

var $4eE2e = parcelRequire("4eE2e");
var $c4c90a9581616aae$var$name = 'zeros';
var $c4c90a9581616aae$var$dependencies = [
    'typed',
    'config',
    'matrix',
    'BigNumber'
];
var $c4c90a9581616aae$export$13096c1635fe6e3d = /* #__PURE__ */ (0, $4eE2e.factory)($c4c90a9581616aae$var$name, $c4c90a9581616aae$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Create a matrix filled with zeros. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.zeros(m)
   *    math.zeros(m, format)
   *    math.zeros(m, n)
   *    math.zeros(m, n, format)
   *    math.zeros([m, n])
   *    math.zeros([m, n], format)
   *
   * Examples:
   *
   *    math.zeros(3)                  // returns [0, 0, 0]
   *    math.zeros(3, 2)               // returns [[0, 0], [0, 0], [0, 0]]
   *    math.zeros(3, 'dense')         // returns [0, 0, 0]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.zeros(math.size(A))       // returns [[0, 0, 0], [0, 0, 0]]
   *
   * See also:
   *
   *    ones, identity, size, range
   *
   * @param {...number | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix}           A matrix filled with zeros
   */ return typed($c4c90a9581616aae$var$name, {
        '': function _() {
            return config.matrix === 'Array' ? _zeros([]) : _zeros([], 'default');
        },
        // math.zeros(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        '...number | BigNumber | string': function numberBigNumberString(size) {
            var last = size[size.length - 1];
            if (typeof last === 'string') {
                var format = size.pop();
                return _zeros(size, format);
            } else if (config.matrix === 'Array') return _zeros(size);
            else return _zeros(size, 'default');
        },
        Array: _zeros,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _zeros(size.valueOf(), format);
        },
        'Array | Matrix, string': function ArrayMatrixString(size, format) {
            return _zeros(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with zeros
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _zeros(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(0) : 0;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $10UPF.resize)(arr, size, defaultValue);
            return arr;
        }
    } // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $gs7TF.isBigNumber)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    } // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== 'number' || !(0, $6egKm.isInteger)(value) || value < 0) throw new Error('Parameters in function zeros must be positive integers');
        });
    }
}); // TODO: zeros contains almost the same code as ones. Reuse this?

});


parcelRegister("iySBu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gSWSd = parcelRequire("gSWSd");
module.exports.default = $gSWSd;

});
parcelRegister("gSWSd", function(module, exports) {

$parcel$export(module.exports, "version", () => $c4af5b8d0cc452e8$export$83d89fbfd8236492);
$parcel$export(module.exports, "data", () => (parcelRequire("2gsxU")));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dhAYb = parcelRequire("dhAYb");
var $5n9DG = parcelRequire("5n9DG");
parcelRequire("9RnzO");
parcelRequire("l5obE");
parcelRequire("8ExUf");
var $3lFvz = parcelRequire("3lFvz");
var $8ExUf = parcelRequire("8ExUf");
parcelRequire("dC75r");
var $fdizF = parcelRequire("fdizF");
var $dC75r = parcelRequire("dC75r");
parcelRequire("2gsxU");
var $5JRhQ = parcelRequire("5JRhQ");
var $2gsxU = parcelRequire("2gsxU");
parcelRequire("3IrH1");
var $cwaBk = parcelRequire("cwaBk");
parcelRequire("7VUST");
var $kdLMe = parcelRequire("kdLMe");

var $4Aqjf = parcelRequire("4Aqjf");
const $c4af5b8d0cc452e8$export$83d89fbfd8236492 = {
    'tfjs-core': (0, $dhAYb.version),
    'tfjs-backend-cpu': (0, $cwaBk.version),
    'tfjs-backend-webgl': (0, $kdLMe.version),
    'tfjs-data': (0, $5JRhQ.version),
    'tfjs-layers': (0, $3lFvz.version),
    'tfjs-converter': (0, $fdizF.version),
    'tfjs': (0, $4Aqjf.version)
};
$parcel$exportWildcard(module.exports, $5n9DG);
$parcel$exportWildcard(module.exports, $8ExUf);
$parcel$exportWildcard(module.exports, $dC75r);

});
parcelRegister("5n9DG", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Required side effectful code.
parcelRequire("emJHL");

var $i2ZbH = parcelRequire("i2ZbH");
$parcel$exportWildcard(module.exports, $i2ZbH);

});
parcelRegister("emJHL", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Required side effectful code for tfjs-core
// Set up Engine and ENV

var $aHfUM = parcelRequire("aHfUM");
parcelRequire("aQg53");
parcelRequire("42Qas");
parcelRequire("5kQGc");

var $g81BN = parcelRequire("g81BN");

var $7qWZ5 = parcelRequire("7qWZ5");

var $dnFj7 = parcelRequire("dnFj7");

var $cwNui = parcelRequire("cwNui");

var $bVnU9 = parcelRequire("bVnU9");
(0, $aHfUM.getOrMakeEngine)();
const $a75692d2bb870267$var$opHandler = {
    buffer: $g81BN.buffer,
    cast: $7qWZ5.cast,
    clone: $dnFj7.clone,
    print: $cwNui.print
};
(0, $bVnU9.setOpHandler)($a75692d2bb870267$var$opHandler);

});
parcelRegister("aHfUM", function(module, exports) {

$parcel$export(module.exports, "ENGINE", () => $7c9a43e45e5b37b6$export$33b63313cc511a3b);
$parcel$export(module.exports, "getOrMakeEngine", () => $7c9a43e45e5b37b6$export$ca8737f6c8c212b8);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3PHpx = parcelRequire("3PHpx");

var $aymVi = parcelRequire("aymVi");

var $fRI13 = parcelRequire("fRI13");

var $dCP8m = parcelRequire("dCP8m");

var $kaJSw = parcelRequire("kaJSw");

var $1dbsU = parcelRequire("1dbsU");

var $14dYy = parcelRequire("14dYy");

var $196bZ = parcelRequire("196bZ");

var $bVnU9 = parcelRequire("bVnU9");

var $1vhox = parcelRequire("1vhox");

var $4tCOB = parcelRequire("4tCOB");
var $wx9lK = parcelRequire("wx9lK");
function $7c9a43e45e5b37b6$var$isRegisteredKernelInvocation(kernelInvocation) {
    return kernelInvocation.kernelName != null;
}
class $7c9a43e45e5b37b6$var$EngineState {
    constructor(){
        // Public since optimizers will use it.
        this.registeredVariables = {};
        this.nextTapeNodeId = 0;
        this.numBytes = 0;
        this.numTensors = 0;
        this.numStringTensors = 0;
        this.numDataBuffers = 0;
        // Number of nested tf.grad() statements when computing higher-order
        // gradients. E.g. `1` for first-order gradients and `2` for second-order
        // gradients. Used to track if the tape should be removed after a backprop.
        this.gradientDepth = 0;
        // Number of nested kernel calls. When kernel depth is greater than 1, we turn
        // off the tape.
        this.kernelDepth = 0;
        this.scopeStack = [];
        /**
         * Keeps track of the number of data moves during a kernel execution. We
         * maintain a stack since kernels can call other kernels, recursively.
         */ this.numDataMovesStack = [];
        this.nextScopeId = 0;
        this.tensorInfo = new WeakMap();
        this.profiling = false;
        this.activeProfile = {
            newBytes: 0,
            newTensors: 0,
            peakBytes: 0,
            kernels: [],
            result: null,
            get kernelNames () {
                return Array.from(new Set(this.kernels.map((k)=>k.name)));
            }
        };
    }
    dispose() {
        for(const variableName in this.registeredVariables)this.registeredVariables[variableName].dispose();
    }
}
class $7c9a43e45e5b37b6$export$2c3b404bf3a77a1f {
    constructor(ENV){
        this.ENV = ENV;
        this.registry = {};
        this.registryFactory = {};
        this.pendingBackendInitId = 0;
        this.state = new $7c9a43e45e5b37b6$var$EngineState();
    }
    async ready() {
        if (this.pendingBackendInit != null) return this.pendingBackendInit.then(()=>{});
        if (this.backendInstance != null) return;
        const sortedBackends = this.getSortedBackends();
        for(let i = 0; i < sortedBackends.length; i++){
            const backendName = sortedBackends[i];
            const success = await this.initializeBackend(backendName).success;
            if (success) {
                await this.setBackend(backendName);
                return;
            }
        }
        throw new Error(`Could not initialize any backends, all backend initializations ` + `failed.`);
    }
    get backend() {
        if (this.pendingBackendInit != null) throw new Error(`Backend '${this.backendName}' has not yet been initialized. Make ` + `sure to await tf.ready() or await tf.setBackend() before calling ` + `other methods`);
        if (this.backendInstance == null) {
            const { name: name, asyncInit: asyncInit } = this.initializeBackendsAndReturnBest();
            if (asyncInit) throw new Error(`The highest priority backend '${name}' has not yet been ` + `initialized. Make sure to await tf.ready() or ` + `await tf.setBackend() before calling other methods`);
            this.setBackend(name);
        }
        return this.backendInstance;
    }
    backendNames() {
        return Object.keys(this.registryFactory);
    }
    findBackend(backendName) {
        if (!(backendName in this.registry)) {
            // If the backend hasn't been initialized but we have a registry entry for
            // it, initialize it and return it.
            if (backendName in this.registryFactory) {
                const { asyncInit: asyncInit } = this.initializeBackend(backendName);
                if (asyncInit) // Backend is not ready yet.
                return null;
            } else return null;
        }
        return this.registry[backendName];
    }
    findBackendFactory(backendName) {
        if (!(backendName in this.registryFactory)) return null;
        return this.registryFactory[backendName].factory;
    }
    registerBackend(backendName, factory, priority = 1) {
        if (backendName in this.registryFactory) {
            $1dbsU.warn(`${backendName} backend was already registered. ` + `Reusing existing backend factory.`);
            return false;
        }
        this.registryFactory[backendName] = {
            factory: factory,
            priority: priority
        };
        return true;
    }
    async setBackend(backendName) {
        if (this.registryFactory[backendName] == null) throw new Error(`Backend name '${backendName}' not found in registry`);
        this.backendName = backendName;
        if (this.registry[backendName] == null) {
            this.backendInstance = null;
            const { success: success, asyncInit: asyncInit } = this.initializeBackend(backendName);
            const result = asyncInit ? await success : success;
            if (!result) return false;
        }
        this.backendInstance = this.registry[backendName];
        this.setupRegisteredKernels();
        // Reset the profiler.
        this.profiler = new (0, $14dYy.Profiler)(this.backendInstance);
        return true;
    }
    setupRegisteredKernels() {
        const kernels = (0, $kaJSw.getKernelsForBackend)(this.backendName);
        kernels.forEach((kernel)=>{
            if (kernel.setupFunc != null) kernel.setupFunc(this.backendInstance);
        });
    }
    disposeRegisteredKernels(backendName) {
        const kernels = (0, $kaJSw.getKernelsForBackend)(backendName);
        kernels.forEach((kernel)=>{
            if (kernel.disposeFunc != null) kernel.disposeFunc(this.registry[backendName]);
        });
    }
    /**
     * Initializes a backend by looking up the backend name in the factory
     * registry and calling the factory method. Returns a boolean representing
     * whether the initialization of the backend suceeded. Throws an error if
     * there is no backend in the factory registry.
     */ initializeBackend(backendName) {
        const registryFactoryEntry = this.registryFactory[backendName];
        if (registryFactoryEntry == null) throw new Error(`Cannot initialize backend ${backendName}, no registration found.`);
        try {
            const backend = registryFactoryEntry.factory();
            /* Test if the factory returns a promise.
            Done in a more liberal way than
            previous 'Promise.resolve(backend)===backend'
            as we needed to account for custom Promise
            implementations (e.g. Angular) */ if (backend && !(backend instanceof (0, $3PHpx.KernelBackend)) && typeof backend.then === 'function') {
                const promiseId = ++this.pendingBackendInitId;
                const success = backend.then((backendInstance)=>{
                    // Outdated promise. Another backend was set in the meantime.
                    if (promiseId < this.pendingBackendInitId) return false;
                    this.registry[backendName] = backendInstance;
                    this.pendingBackendInit = null;
                    return true;
                }).catch((err)=>{
                    // Outdated promise. Another backend was set in the meantime.
                    if (promiseId < this.pendingBackendInitId) return false;
                    this.pendingBackendInit = null;
                    $1dbsU.warn(`Initialization of backend ${backendName} failed`);
                    $1dbsU.warn(err.stack || err.message);
                    return false;
                });
                this.pendingBackendInit = success;
                return {
                    success: success,
                    asyncInit: true
                };
            } else {
                this.registry[backendName] = backend;
                return {
                    success: true,
                    asyncInit: false
                };
            }
        } catch (err) {
            $1dbsU.warn(`Initialization of backend ${backendName} failed`);
            $1dbsU.warn(err.stack || err.message);
            return {
                success: false,
                asyncInit: false
            };
        }
    }
    removeBackend(backendName) {
        if (!(backendName in this.registryFactory)) throw new Error(`${backendName} backend not found in registry`);
        if (this.backendName === backendName && this.pendingBackendInit != null) // There is a pending promise of the backend we want to remove. Make it
        // obsolete.
        this.pendingBackendInitId++;
        if (backendName in this.registry) {
            this.disposeRegisteredKernels(backendName);
            this.registry[backendName].dispose();
            delete this.registry[backendName];
        }
        delete this.registryFactory[backendName];
        // Unset the backend if it is active.
        if (this.backendName === backendName) {
            this.pendingBackendInit = null;
            this.backendName = null;
            this.backendInstance = null;
        }
    }
    getSortedBackends() {
        if (Object.keys(this.registryFactory).length === 0) throw new Error('No backend found in registry.');
        return Object.keys(this.registryFactory).sort((a, b)=>{
            // Highest priority comes first.
            return this.registryFactory[b].priority - this.registryFactory[a].priority;
        });
    }
    initializeBackendsAndReturnBest() {
        const sortedBackends = this.getSortedBackends();
        for(let i = 0; i < sortedBackends.length; i++){
            const backendName = sortedBackends[i];
            const { success: success, asyncInit: asyncInit } = this.initializeBackend(backendName);
            if (asyncInit || success) return {
                name: backendName,
                asyncInit: asyncInit
            };
        }
        throw new Error(`Could not initialize any backends, all backend initializations ` + `failed.`);
    }
    moveData(backend, dataId) {
        const info = this.state.tensorInfo.get(dataId);
        const srcBackend = info.backend;
        const values = this.readSync(dataId);
        const refCount = srcBackend.refCount(dataId);
        // Delete the tensor from the old backend and move it to the new
        // backend.
        srcBackend.disposeData(dataId, true);
        info.backend = backend;
        backend.move(dataId, values, info.shape, info.dtype, refCount);
        if (this.shouldCheckForMemLeaks()) // Track the number of moves during a kernel execution to correctly
        // detect memory leaks.
        this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1]++;
    }
    tidy(nameOrFn, fn) {
        let name = null;
        if (fn == null) {
            // Called with only 1 argument.
            if (typeof nameOrFn !== 'function') throw new Error('Please provide a function to tidy()');
            fn = nameOrFn;
        } else {
            // Called with 2 arguments.
            if (typeof nameOrFn !== 'string' && !(nameOrFn instanceof String)) throw new Error("When calling with two arguments, the first argument to tidy() must be a string");
            if (typeof fn !== 'function') throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");
            name = nameOrFn;
        // TODO(nsthorat,smilkov): Do operation logging and performance
        // profiling.
        }
        let result;
        return this.scopedRun(()=>this.startScope(name), ()=>this.endScope(result), ()=>{
            result = fn();
            if (result instanceof Promise) console.error('Cannot return a Promise inside of tidy.');
            return result;
        });
    }
    scopedRun(start, end, f) {
        start();
        try {
            const res = f();
            end();
            return res;
        } catch (ex) {
            end();
            throw ex;
        }
    }
    nextTensorId() {
        return $7c9a43e45e5b37b6$export$2c3b404bf3a77a1f.nextTensorId++;
    }
    nextVariableId() {
        return $7c9a43e45e5b37b6$export$2c3b404bf3a77a1f.nextVariableId++;
    }
    /**
     * This method is called instead of the public-facing tensor.clone() when
     * saving a tensor for backwards pass. It makes sure to add the clone
     * operation to the tape regardless of being called inside a kernel
     * execution.
     */ clone(x) {
        const y = $7c9a43e45e5b37b6$export$33b63313cc511a3b.runKernel((0, $dCP8m.Identity), {
            x: x
        });
        const inputs = {
            x: x
        };
        const grad = (dy)=>({
                x: ()=>{
                    const dtype = 'float32';
                    const gradInputs = {
                        x: dy
                    };
                    const attrs = {
                        dtype: dtype
                    };
                    return $7c9a43e45e5b37b6$export$33b63313cc511a3b.runKernel((0, $dCP8m.Cast), gradInputs, // tslint:disable-next-line: no-unnecessary-type-assertion
                    attrs);
                }
            });
        const saved = [];
        this.addTapeNode(this.state.activeScope.name, inputs, [
            y
        ], grad, saved, {});
        return y;
    }
    /**
     * Execute a kernel with the given name and return the output tensor.
     *
     * @param kernelName The name of the kernel to execute.
     * @param inputs A map of input names to tensors.
     * @param attrs A map of attribute names to their values. An attribute is a
     *     primitive (non-tensor) input to the kernel.
     * @param inputsToSave A list of tensors, inputs to save for the backprop
     *     computation.
     * @param outputsToSave A list of booleans, specifying which output to save
     *     for the backprop computation. These are booleans since the output
     * tensors are not visible to the user.
     */ runKernel(kernelName, inputs, attrs) {
        if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
        // can be deferred until an op/ kernel is run).
        // The below getter has side effects that will try to initialize the
        // backend and set properties like this.backendName
        // tslint:disable-next-line: no-unused-expression
        this.backend;
        const hasKernel = (0, $kaJSw.getKernel)(kernelName, this.backendName) != null;
        if (!hasKernel) throw new Error(`Kernel '${kernelName}' not registered for backend '${this.backendName}'`);
        return this.runKernelFunc({
            kernelName: kernelName,
            inputs: inputs,
            attrs: attrs
        });
    }
    shouldCheckForMemLeaks() {
        return this.ENV.getBool('IS_TEST');
    }
    checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos) {
        const numDataIdsAfter = this.backend.numDataIds();
        // Count the number of data ids associated with the result of the kernel.
        let numOutputDataIds = 0;
        outInfos.forEach((info)=>{
            // Complex numbers allocate 3 data ids, one for 'real', one for
            // 'imaginary', and one for the container that holds the former two.
            numOutputDataIds += info.dtype === 'complex64' ? 3 : 1;
        });
        // Account for the number of moves during kernel execution. A "data move"
        // can happen in the middle of a kernel execution, placing a new (key,value)
        // pair in the data storage. Since data moves have net zero effect (we
        // always remove the data from the old backend), we have to cancel them out
        // when detecting memory leaks.
        const numMoves = this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1];
        const dataIdsLeaked = numDataIdsAfter - numDataIdsBefore - numOutputDataIds - numMoves;
        if (dataIdsLeaked > 0) throw new Error(`Backend '${this.backendName}' has an internal memory leak ` + `(${dataIdsLeaked} data ids) after running '${kernelName}'`);
    }
    /**
     * Internal helper method to execute a kernel Func
     *
     * Use `runKernel` to execute kernels from outside of engine.
     */ runKernelFunc(kernelParams) {
        let outputs;
        let saved = [];
        const isTapeOn = this.isTapeOn();
        const startingBytecount = this.state.numBytes;
        const startingNumTensors = this.state.numTensors;
        if (this.shouldCheckForMemLeaks()) this.state.numDataMovesStack.push(0);
        let kernelFunc;
        if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
        // can be deferred until an op/ kernel is run).
        // The below getter has side effects that will try to initialize the
        // backend and set properties like this.backendName
        // tslint:disable-next-line: no-unused-expression
        this.backend;
        let out;
        const kernelOrScopeName = $7c9a43e45e5b37b6$var$isRegisteredKernelInvocation(kernelParams) ? kernelParams.kernelName : this.state.activeScope != null ? this.state.activeScope.name : '';
        // Create the kernelFunc from either a registered kernel OR passed in
        // forward/backward functions (used by custom grad). In this context a
        // kernelFunc wraps a kernel implementation with some bookkeeping.
        if ($7c9a43e45e5b37b6$var$isRegisteredKernelInvocation(kernelParams)) {
            const { kernelName: kernelName, inputs: inputs, attrs: attrs } = kernelParams;
            if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
            // can be deferred until an op/ kernel is run).
            // The below getter has side effects that will try to initialize the
            // backend and set properties like this.backendName
            // tslint:disable-next-line: no-unused-expression
            this.backend;
            const kernel = (0, $kaJSw.getKernel)(kernelName, this.backendName);
            $4tCOB.assert(kernel != null, ()=>`Cannot find registered kernel '${kernelName}' for backend '${this.backendName}'`);
            kernelFunc = ()=>{
                const numDataIdsBefore = this.backend.numDataIds();
                out = kernel.kernelFunc({
                    inputs: inputs,
                    attrs: attrs,
                    backend: this.backend
                });
                const outInfos = Array.isArray(out) ? out : [
                    out
                ];
                if (this.shouldCheckForMemLeaks()) this.checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos);
                const outTensors = outInfos.map((outInfo)=>{
                    // todo (yassogba) remove this option (Tensor) when node backend
                    // methods have been modularized and they all return tensorInfo.
                    // TensorInfos do not have a rank attribute.
                    if (outInfo.rank != null) return outInfo;
                    return this.makeTensorFromTensorInfo(outInfo);
                });
                // Save any required inputs and outputs.
                // Do not save unless we are recording to the tape. Otherwise it would
                // cause a mem leak since there would be no backprop for these tensors
                // (which would otherwise dispose them).
                if (isTapeOn) {
                    const tensorsToSave = this.getTensorsForGradient(kernelName, inputs, outTensors);
                    saved = this.saveTensorsForBackwardMode(tensorsToSave);
                }
                return outTensors;
            };
        } else {
            const { forwardFunc: forwardFunc } = kernelParams;
            // Running a customGrad op.
            const saveFunc = (tensors)=>{
                // Do not save unless we are recording to the tape. Otherwise it would
                // cause a mem leak since we would never run backprop, which disposes
                // the kept tensors.
                if (!isTapeOn) return;
                saved = tensors.map((tensor)=>this.keep(this.clone(tensor)));
            };
            kernelFunc = ()=>{
                const numDataIdsBefore = this.backend.numDataIds();
                out = this.tidy(()=>forwardFunc(this.backend, saveFunc));
                const outs = Array.isArray(out) ? out : [
                    out
                ];
                if (this.shouldCheckForMemLeaks()) // Scope name is used to print a more helpful error message if needed.
                this.checkKernelForMemLeak(kernelOrScopeName, numDataIdsBefore, outs);
                return outs;
            };
        }
        //
        // Run the kernelFunc. Optionally profiling it.
        //
        const { inputs: inputs, attrs: attrs } = kernelParams;
        const backwardsFunc = $7c9a43e45e5b37b6$var$isRegisteredKernelInvocation(kernelParams) ? null : kernelParams.backwardsFunc;
        let kernelProfile;
        this.scopedRun(// Stop recording to a tape when running a kernel.
        ()=>this.state.kernelDepth++, ()=>this.state.kernelDepth--, ()=>{
            if (!this.ENV.getBool('DEBUG') && !this.state.profiling) outputs = kernelFunc();
            else {
                kernelProfile = this.profiler.profileKernel(kernelOrScopeName, inputs, ()=>kernelFunc());
                if (this.ENV.getBool('DEBUG')) this.profiler.logKernelProfile(kernelProfile);
                outputs = kernelProfile.outputs;
            }
        });
        if (isTapeOn) this.addTapeNode(kernelOrScopeName, inputs, outputs, backwardsFunc, saved, attrs);
        if (this.state.profiling) this.state.activeProfile.kernels.push({
            name: kernelOrScopeName,
            bytesAdded: this.state.numBytes - startingBytecount,
            totalBytesSnapshot: this.state.numBytes,
            tensorsAdded: this.state.numTensors - startingNumTensors,
            totalTensorsSnapshot: this.state.numTensors,
            inputShapes: Object.keys(inputs).map((key)=>inputs[key] != null ? inputs[key].shape : null),
            outputShapes: outputs.map((item)=>item.shape),
            kernelTimeMs: kernelProfile.timeMs,
            extraInfo: kernelProfile.extraInfo
        });
        return Array.isArray(out) ? outputs : outputs[0];
    }
    /**
     * Saves tensors used in forward mode for use in backward mode.
     *
     * @param tensors the list of tensors to save.
     */ saveTensorsForBackwardMode(tensors) {
        const saved = tensors.map((tensor)=>this.keep(this.clone(tensor)));
        return saved;
    }
    /**
     * Returns a list of tensors to save for a given gradient calculation.
     *
     * @param kernelName name of kernel to look up gradient for.
     * @param inputs a map of input tensors.
     * @param outputs an array of output tensors from forward mode of kernel.
     */ getTensorsForGradient(kernelName, inputs, outputs) {
        const gradConfig = (0, $kaJSw.getGradient)(kernelName);
        if (gradConfig != null) {
            const inputsToSave = gradConfig.inputsToSave || [];
            const outputsToSave = gradConfig.outputsToSave || [];
            // If saveAllInputs is true, all inputs will be saved. Otherwise, inputs
            // specified in inputsToSave will be saved.
            let inputTensorsToSave;
            if (gradConfig.saveAllInputs) {
                $4tCOB.assert(Array.isArray(inputs), ()=>'saveAllInputs is true, expected inputs to be an array.');
                inputTensorsToSave = Object.keys(inputs).map((key)=>inputs[key]);
            } else inputTensorsToSave = inputsToSave.map((inputName)=>inputs[inputName]);
            const outputTensorsToSave = outputs.filter((_, i)=>outputsToSave[i]);
            return inputTensorsToSave.concat(outputTensorsToSave);
        }
        // We return an empty list rather than throw an error because the kernel we
        // are looking up may not actually be relevant to backproping through the
        // overall function
        //
        // See 'does not error if irrelevant (pruned) ops are missing grads' test
        // in gradients_test.ts for an example.
        return [];
    }
    /**
     * Internal method used by public APIs for tensor creation. Makes a new
     * tensor with the provided shape, dtype and values. It always
     * creates a new data id and writes the values to the underlying backend.
     */ makeTensor(values, shape, dtype, backend) {
        if (values == null) throw new Error('Values passed to engine.makeTensor() are null');
        dtype = dtype || 'float32';
        backend = backend || this.backend;
        let backendVals = values;
        if (dtype === 'string' && $4tCOB.isString(values[0])) backendVals = values.map((d)=>$wx9lK.encodeString(d));
        const dataId = backend.write(backendVals, shape, dtype);
        const t = new (0, $bVnU9.Tensor)(shape, dtype, dataId, this.nextTensorId());
        this.trackTensor(t, backend);
        // Count bytes for string tensors.
        if (dtype === 'string') {
            const info = this.state.tensorInfo.get(dataId);
            const newBytes = (0, $4tCOB.bytesFromStringArray)(backendVals);
            this.state.numBytes += newBytes - info.bytes;
            info.bytes = newBytes;
        }
        return t;
    }
    /**
     * Internal method used by backends. Makes a new tensor
     * that is a wrapper around an existing data id. It doesn't create
     * a new data id, only increments the ref count used in memory tracking.
     * @deprecated
     */ makeTensorFromDataId(dataId, shape, dtype, backend) {
        dtype = dtype || 'float32';
        const tensorInfo = {
            dataId: dataId,
            shape: shape,
            dtype: dtype
        };
        return this.makeTensorFromTensorInfo(tensorInfo, backend);
    }
    /**
     * Internal method used by backends. Makes a new tensor that is a wrapper
     * around an existing data id in TensorInfo. It doesn't create a new data id,
     * only increments the ref count used in memory tracking.
     */ makeTensorFromTensorInfo(tensorInfo, backend) {
        const { dataId: dataId, shape: shape, dtype: dtype } = tensorInfo;
        const t = new (0, $bVnU9.Tensor)(shape, dtype, dataId, this.nextTensorId());
        this.trackTensor(t, backend);
        return t;
    }
    makeVariable(initialValue, trainable = true, name, dtype) {
        name = name || this.nextVariableId().toString();
        if (dtype != null && dtype !== initialValue.dtype) initialValue = initialValue.cast(dtype);
        const v = new (0, $bVnU9.Variable)(initialValue, trainable, name, this.nextTensorId());
        if (this.state.registeredVariables[v.name] != null) throw new Error(`Variable with name ${v.name} was already registered`);
        this.state.registeredVariables[v.name] = v;
        this.incRef(v, this.backend);
        return v;
    }
    trackTensor(a, backend) {
        this.state.numTensors++;
        if (a.dtype === 'string') this.state.numStringTensors++;
        // Bytes for complex numbers are counted by their components. Bytes for
        // string tensors are counted when writing values.
        let bytes = 0;
        if (a.dtype !== 'complex64' && a.dtype !== 'string') bytes = a.size * $4tCOB.bytesPerElement(a.dtype);
        this.state.numBytes += bytes;
        if (!this.state.tensorInfo.has(a.dataId)) {
            this.state.numDataBuffers++;
            this.state.tensorInfo.set(a.dataId, {
                backend: backend || this.backend,
                dtype: a.dtype,
                shape: a.shape,
                bytes: bytes
            });
        }
        if (!(a instanceof (0, $bVnU9.Variable))) this.track(a);
    }
    // Track the tensor by dataId and increase the refCount for the dataId in the
    // backend.
    // TODO(pyu10055): This is currently used by makeVariable method, to increase
    // refCount on the backend for the dataId. It can potentially be replaced with
    // Identity op indead of calling backend directly.
    incRef(a, backend) {
        this.trackTensor(a, backend);
        this.backend.incRef(a.dataId);
    }
    removeDataId(dataId, backend) {
        if (this.state.tensorInfo.has(dataId) && this.state.tensorInfo.get(dataId).backend === backend) {
            this.state.tensorInfo.delete(dataId);
            this.state.numDataBuffers--;
        }
    }
    disposeTensor(a) {
        if (!this.state.tensorInfo.has(a.dataId)) return;
        const info = this.state.tensorInfo.get(a.dataId);
        this.state.numTensors--;
        if (a.dtype === 'string') {
            this.state.numStringTensors--;
            this.state.numBytes -= info.bytes;
        }
        // Don't count bytes for complex numbers as they are counted by their
        // components.
        if (a.dtype !== 'complex64' && a.dtype !== 'string') {
            const bytes = a.size * $4tCOB.bytesPerElement(a.dtype);
            this.state.numBytes -= bytes;
        }
        // Remove the reference to dataId if backend dispose the data successfully
        if (info.backend.disposeData(a.dataId)) this.removeDataId(a.dataId, info.backend);
    // TODO(nsthorat): Construct an error and save the stack trace for
    // debugging when in debug mode. Creating a stack trace is too expensive
    // to do unconditionally.
    }
    disposeVariables() {
        for(const varName in this.state.registeredVariables){
            const v = this.state.registeredVariables[varName];
            this.disposeVariable(v);
        }
    }
    disposeVariable(v) {
        this.disposeTensor(v);
        if (this.state.registeredVariables[v.name] != null) delete this.state.registeredVariables[v.name];
    }
    memory() {
        const info = this.backend.memory();
        info.numTensors = this.state.numTensors;
        info.numDataBuffers = this.state.numDataBuffers;
        info.numBytes = this.state.numBytes;
        if (this.state.numStringTensors > 0) {
            info.unreliable = true;
            if (info.reasons == null) info.reasons = [];
            info.reasons.push("Memory usage by string tensors is approximate (2 bytes per character)");
        }
        return info;
    }
    async profile(query) {
        this.state.profiling = true;
        const startBytes = this.state.numBytes;
        const startNumTensors = this.state.numTensors;
        this.state.activeProfile.kernels = [];
        this.state.activeProfile.result = await query();
        this.state.profiling = false;
        this.state.activeProfile.peakBytes = Math.max(...this.state.activeProfile.kernels.map((d)=>d.totalBytesSnapshot));
        this.state.activeProfile.newBytes = this.state.numBytes - startBytes;
        this.state.activeProfile.newTensors = this.state.numTensors - startNumTensors;
        for (const kernel of this.state.activeProfile.kernels){
            kernel.kernelTimeMs = await kernel.kernelTimeMs;
            kernel.extraInfo = await kernel.extraInfo;
        }
        return this.state.activeProfile;
    }
    isTapeOn() {
        return this.state.gradientDepth > 0 && this.state.kernelDepth === 0;
    }
    addTapeNode(kernelName, inputs, outputs, gradientsFunc, saved, attrs) {
        const tapeNode = {
            id: this.state.nextTapeNodeId++,
            kernelName: kernelName,
            inputs: inputs,
            outputs: outputs,
            saved: saved
        };
        const gradConfig = (0, $kaJSw.getGradient)(kernelName);
        if (gradConfig != null) gradientsFunc = gradConfig.gradFunc;
        if (gradientsFunc != null) tapeNode.gradient = (dys)=>{
            // TODO(smilkov): To optimize back-prop, pass dys that are not used in
            // the backprop graph to the user as null instead of zeros
            dys = dys.map((dy, i)=>{
                if (dy == null) {
                    const output = outputs[i];
                    const vals = $4tCOB.makeZerosTypedArray(output.size, output.dtype);
                    return this.makeTensor(vals, output.shape, output.dtype);
                }
                return dy;
            });
            // Grad functions of ops with single outputs expect a dy, while ops
            // with multiple outputs expect dys (array of dy).
            return gradientsFunc(dys.length > 1 ? dys : dys[0], saved, attrs);
        };
        this.state.activeTape.push(tapeNode);
    }
    keep(result) {
        result.kept = true;
        return result;
    }
    startTape() {
        if (this.state.gradientDepth === 0) this.state.activeTape = [];
        this.state.gradientDepth++;
    }
    endTape() {
        this.state.gradientDepth--;
    }
    /**
     * Start a scope. Use this with endScope() to achieve the same functionality
     * as scope() without the need for a function closure.
     */ startScope(name) {
        const scopeInfo = {
            track: [],
            name: 'unnamed scope',
            id: this.state.nextScopeId++
        };
        if (name) scopeInfo.name = name;
        this.state.scopeStack.push(scopeInfo);
        this.state.activeScope = scopeInfo;
    }
    /**
     * End a scope. Use this with startScope() to achieve the same functionality
     * as scope() without the need for a function closure.
     */ endScope(result) {
        const tensorsToTrackInParent = (0, $1vhox.getTensorsInContainer)(result);
        const tensorsToTrackInParentSet = new Set(tensorsToTrackInParent.map((t)=>t.id));
        // Dispose the arrays tracked in this scope.
        for(let i = 0; i < this.state.activeScope.track.length; i++){
            const tensor = this.state.activeScope.track[i];
            if (!tensor.kept && !tensorsToTrackInParentSet.has(tensor.id)) tensor.dispose();
        }
        const oldScope = this.state.scopeStack.pop();
        this.state.activeScope = this.state.scopeStack.length === 0 ? null : this.state.scopeStack[this.state.scopeStack.length - 1];
        // Track the current result in the parent scope.
        tensorsToTrackInParent.forEach((tensor)=>{
            // Only track the tensor if was allocated in the inner scope and is not
            // globally kept.
            if (!tensor.kept && tensor.scopeId === oldScope.id) this.track(tensor);
        });
    }
    /**
     * Returns gradients of `f` with respect to each of the `xs`. The gradients
     * returned are of the same length as `xs`, but some might be null if `f`
     * was not a function of that `x`. It also takes optional dy to multiply the
     * gradient, which defaults to `1`.
     */ gradients(f, xs, dy, allowNoGradients = false) {
        $4tCOB.assert(xs.length > 0, ()=>'gradients() received an empty list of xs.');
        if (dy != null && dy.dtype !== 'float32') throw new Error(`dy must have 'float32' dtype, but has '${dy.dtype}'`);
        const y = this.scopedRun(()=>this.startTape(), ()=>this.endTape(), ()=>this.tidy('forward', f));
        $4tCOB.assert(y instanceof (0, $bVnU9.Tensor), ()=>'The result y returned by f() must be a tensor.');
        // Filter out the nodes that don't connect x => y.
        const filteredTape = (0, $196bZ.getFilteredNodesXToY)(this.state.activeTape, xs, y);
        if (!allowNoGradients && filteredTape.length === 0 && xs.length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");
        return this.tidy('backward', ()=>{
            const accumulatedGradientMap = {};
            accumulatedGradientMap[y.id] = dy == null ? $7c9a43e45e5b37b6$var$ones(y.shape) : dy;
            // Backprop gradients through the filtered nodes.
            (0, $196bZ.backpropagateGradients)(accumulatedGradientMap, filteredTape, // Pass the tidy function to avoid circular dep with `tape.ts`.
            (f)=>this.tidy(f), // Pass an add function to avoide a circular dep with `tape.ts`.
            $7c9a43e45e5b37b6$export$e16d8520af44a096);
            const grads = xs.map((x)=>accumulatedGradientMap[x.id]);
            if (this.state.gradientDepth === 0) {
                // This means that we are not computing higher-order gradients
                // and can clean up the tape.
                this.state.activeTape.forEach((node)=>{
                    for (const tensor of node.saved)tensor.dispose();
                });
                this.state.activeTape = null;
            }
            return {
                value: y,
                grads: grads
            };
        });
    }
    customGrad(f) {
        $4tCOB.assert($4tCOB.isFunction(f), ()=>'The f passed in customGrad(f) must be a function.');
        return (...inputs)=>{
            $4tCOB.assert(inputs.every((t)=>t instanceof (0, $bVnU9.Tensor)), ()=>"The args passed in customGrad(f)(x1, x2,...) must all be tensors");
            let res;
            const inputMap = {};
            inputs.forEach((input, i)=>{
                inputMap[i] = input;
            });
            const forwardFunc = (_, save)=>{
                res = f(...[
                    ...inputs,
                    save
                ]);
                $4tCOB.assert(res.value instanceof (0, $bVnU9.Tensor), ()=>"The function f passed in customGrad(f) must return an object where `obj.value` is a tensor");
                $4tCOB.assert($4tCOB.isFunction(res.gradFunc), ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function.");
                return res.value;
            };
            const backwardsFunc = (dy, saved)=>{
                const gradRes = res.gradFunc(dy, saved);
                const grads = Array.isArray(gradRes) ? gradRes : [
                    gradRes
                ];
                $4tCOB.assert(grads.length === inputs.length, ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...).");
                $4tCOB.assert(grads.every((t)=>t instanceof (0, $bVnU9.Tensor)), ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors.");
                const gradMap = {};
                grads.forEach((grad, i)=>{
                    gradMap[i] = ()=>grad;
                });
                return gradMap;
            };
            return this.runKernelFunc({
                forwardFunc: forwardFunc,
                backwardsFunc: backwardsFunc,
                inputs: inputMap
            });
        };
    }
    readSync(dataId) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.readSync(dataId);
    }
    read(dataId) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.read(dataId);
    }
    readToGPU(dataId, options) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.readToGPU(dataId, options);
    }
    async time(query) {
        const start = (0, $wx9lK.now)();
        const timingInfo = await this.backend.time(query);
        timingInfo.wallMs = (0, $wx9lK.now)() - start;
        return timingInfo;
    }
    /**
     * Tracks a Tensor in the current scope to be automatically cleaned up
     * when the current scope ends, and returns the value.
     *
     * @param result The Tensor to track in the current scope.
     */ track(result) {
        if (this.state.activeScope != null) {
            result.scopeId = this.state.activeScope.id;
            this.state.activeScope.track.push(result);
        }
        return result;
    }
    get registeredVariables() {
        return this.state.registeredVariables;
    }
    /**
     * Resets the engine state. Removes all backends but does not remove
     * registered backend factories.
     */ reset() {
        // Make any pending promise obsolete.
        this.pendingBackendInitId++;
        this.state.dispose();
        this.ENV.reset();
        this.state = new $7c9a43e45e5b37b6$var$EngineState();
        for(const backendName in this.registry){
            this.disposeRegisteredKernels(backendName);
            this.registry[backendName].dispose();
            delete this.registry[backendName];
        }
        this.backendName = null;
        this.backendInstance = null;
        this.pendingBackendInit = null;
    }
}
$7c9a43e45e5b37b6$export$2c3b404bf3a77a1f.nextTensorId = 0;
$7c9a43e45e5b37b6$export$2c3b404bf3a77a1f.nextVariableId = 0;
function $7c9a43e45e5b37b6$var$ones(shape) {
    const values = (0, $4tCOB.makeOnesTypedArray)((0, $4tCOB.sizeFromShape)(shape), 'float32');
    return $7c9a43e45e5b37b6$export$33b63313cc511a3b.makeTensor(values, shape, 'float32');
}
function $7c9a43e45e5b37b6$export$ca8737f6c8c212b8() {
    const ns = (0, $fRI13.getGlobalNamespace)();
    if (ns._tfengine == null) {
        const environment = new (0, $aymVi.Environment)(ns);
        ns._tfengine = new $7c9a43e45e5b37b6$export$2c3b404bf3a77a1f(environment);
    }
    (0, $aymVi.setEnvironmentGlobal)(ns._tfengine.ENV);
    // Tell the current tensor interface that the global engine is responsible
    // for tracking.
    (0, $bVnU9.setTensorTracker)(()=>ns._tfengine);
    return ns._tfengine;
}
const $7c9a43e45e5b37b6$export$33b63313cc511a3b = $7c9a43e45e5b37b6$export$ca8737f6c8c212b8();
function $7c9a43e45e5b37b6$export$e16d8520af44a096(a, b) {
    // We duplicate Add here to avoid a circular dependency with add.ts.
    const inputs = {
        a: a,
        b: b
    };
    return $7c9a43e45e5b37b6$export$33b63313cc511a3b.runKernel((0, $dCP8m.Add), inputs);
}

});
parcelRegister("3PHpx", function(module, exports) {

$parcel$export(module.exports, "DataStorage", () => $2ca7cf0135042664$export$e95767ffe2e60cec);
$parcel$export(module.exports, "KernelBackend", () => $2ca7cf0135042664$export$543916c62202b50a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $2ca7cf0135042664$export$76e53a66c52b6d4d = 1e-7;
const $2ca7cf0135042664$export$49716d145771e6a2 = 1e-4;
class $2ca7cf0135042664$export$e95767ffe2e60cec {
    constructor(backend, dataMover){
        this.backend = backend;
        this.dataMover = dataMover;
        this.data = new WeakMap();
        this.dataIdsCount = 0;
    }
    get(dataId) {
        if (!this.data.has(dataId)) this.dataMover.moveData(this.backend, dataId);
        return this.data.get(dataId);
    }
    set(dataId, value) {
        this.dataIdsCount++;
        this.data.set(dataId, value);
    }
    has(dataId) {
        return this.data.has(dataId);
    }
    delete(dataId) {
        this.dataIdsCount--;
        return this.data.delete(dataId);
    }
    numDataIds() {
        return this.dataIdsCount;
    }
}
class $2ca7cf0135042664$export$543916c62202b50a {
    refCount(dataId) {
        return $2ca7cf0135042664$var$notYetImplemented('refCount');
    }
    incRef(dataId) {
        return $2ca7cf0135042664$var$notYetImplemented('incRef');
    }
    timerAvailable() {
        return true;
    }
    time(f) {
        return $2ca7cf0135042664$var$notYetImplemented('time');
    }
    read(dataId) {
        return $2ca7cf0135042664$var$notYetImplemented('read');
    }
    readSync(dataId) {
        return $2ca7cf0135042664$var$notYetImplemented('readSync');
    }
    readToGPU(dataId, options) {
        return $2ca7cf0135042664$var$notYetImplemented('readToGPU');
    }
    numDataIds() {
        return $2ca7cf0135042664$var$notYetImplemented('numDataIds');
    }
    disposeData(dataId, force) {
        return $2ca7cf0135042664$var$notYetImplemented('disposeData');
    }
    write(values, shape, dtype) {
        return $2ca7cf0135042664$var$notYetImplemented('write');
    }
    move(dataId, values, shape, dtype, refCount) {
        return $2ca7cf0135042664$var$notYetImplemented('move');
    }
    memory() {
        return $2ca7cf0135042664$var$notYetImplemented('memory');
    }
    /** Returns the highest precision for floats in bits (e.g. 16 or 32) */ floatPrecision() {
        return $2ca7cf0135042664$var$notYetImplemented('floatPrecision');
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return this.floatPrecision() === 32 ? $2ca7cf0135042664$export$76e53a66c52b6d4d : $2ca7cf0135042664$export$49716d145771e6a2;
    }
    dispose() {
        return $2ca7cf0135042664$var$notYetImplemented('dispose');
    }
}
function $2ca7cf0135042664$var$notYetImplemented(kernelName) {
    throw new Error(`'${kernelName}' not yet implemented or not found in the registry. ` + `This kernel may not be supported by the tfjs backend you have chosen`);
}

});

parcelRegister("aymVi", function(module, exports) {

$parcel$export(module.exports, "Environment", () => $7aeedc6cf63007f3$export$7dc6752a22ab011a);
$parcel$export(module.exports, "env", () => $7aeedc6cf63007f3$export$a7b6bc01c63cdfc3);
$parcel$export(module.exports, "ENV", () => $7aeedc6cf63007f3$export$83401e34d5e11bf4);
$parcel$export(module.exports, "setEnvironmentGlobal", () => $7aeedc6cf63007f3$export$3ef32a49eeda04cc);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
// Expects flags from URL in the format ?tfjsflags=FLAG1:1,FLAG2:true.
const $7aeedc6cf63007f3$var$TENSORFLOWJS_FLAGS_PREFIX = 'tfjsflags';
class $7aeedc6cf63007f3$export$7dc6752a22ab011a {
    // tslint:disable-next-line: no-any
    constructor(global){
        this.global = global;
        this.flags = {};
        this.flagRegistry = {};
        this.urlFlags = {};
        // Jasmine spies on this in 'environment_test.ts'
        this.getQueryParams = $7aeedc6cf63007f3$export$e2de15bbd9edf9c6;
        this.populateURLFlags();
    }
    setPlatform(platformName, platform) {
        if (this.platform != null) {
            if (!($7aeedc6cf63007f3$export$a7b6bc01c63cdfc3().getBool('IS_TEST') || $7aeedc6cf63007f3$export$a7b6bc01c63cdfc3().getBool('PROD'))) console.warn(`Platform ${this.platformName} has already been set. ` + `Overwriting the platform with ${platformName}.`);
        }
        this.platformName = platformName;
        this.platform = platform;
    }
    registerFlag(flagName, evaluationFn, setHook) {
        this.flagRegistry[flagName] = {
            evaluationFn: evaluationFn,
            setHook: setHook
        };
        // Override the flag value from the URL. This has to happen here because
        // the environment is initialized before flags get registered.
        if (this.urlFlags[flagName] != null) {
            const flagValue = this.urlFlags[flagName];
            if (!($7aeedc6cf63007f3$export$a7b6bc01c63cdfc3().getBool('IS_TEST') || $7aeedc6cf63007f3$export$a7b6bc01c63cdfc3().getBool('PROD'))) console.warn(`Setting feature override from URL ${flagName}: ${flagValue}.`);
            this.set(flagName, flagValue);
        }
    }
    async getAsync(flagName) {
        if (flagName in this.flags) return this.flags[flagName];
        this.flags[flagName] = await this.evaluateFlag(flagName);
        return this.flags[flagName];
    }
    get(flagName) {
        if (flagName in this.flags) return this.flags[flagName];
        const flagValue = this.evaluateFlag(flagName);
        if ((0, $4tCOB.isPromise)(flagValue)) throw new Error(`Flag ${flagName} cannot be synchronously evaluated. ` + `Please use getAsync() instead.`);
        this.flags[flagName] = flagValue;
        return this.flags[flagName];
    }
    getNumber(flagName) {
        return this.get(flagName);
    }
    getBool(flagName) {
        return this.get(flagName);
    }
    getFlags() {
        return this.flags;
    }
    // For backwards compatibility.
    get features() {
        return this.flags;
    }
    set(flagName, value) {
        if (this.flagRegistry[flagName] == null) throw new Error(`Cannot set flag ${flagName} as it has not been registered.`);
        this.flags[flagName] = value;
        if (this.flagRegistry[flagName].setHook != null) this.flagRegistry[flagName].setHook(value);
    }
    evaluateFlag(flagName) {
        if (this.flagRegistry[flagName] == null) throw new Error(`Cannot evaluate flag '${flagName}': no evaluation function found.`);
        return this.flagRegistry[flagName].evaluationFn();
    }
    setFlags(flags) {
        this.flags = Object.assign({}, flags);
    }
    reset() {
        this.flags = {};
        this.urlFlags = {};
        this.populateURLFlags();
    }
    populateURLFlags() {
        if (typeof this.global === 'undefined' || typeof this.global.location === 'undefined' || typeof this.global.location.search === 'undefined') return;
        const urlParams = this.getQueryParams(this.global.location.search);
        if ($7aeedc6cf63007f3$var$TENSORFLOWJS_FLAGS_PREFIX in urlParams) {
            const keyValues = urlParams[$7aeedc6cf63007f3$var$TENSORFLOWJS_FLAGS_PREFIX].split(',');
            keyValues.forEach((keyValue)=>{
                const [key, value] = keyValue.split(':');
                this.urlFlags[key] = $7aeedc6cf63007f3$var$parseValue(key, value);
            });
        }
    }
}
function $7aeedc6cf63007f3$export$e2de15bbd9edf9c6(queryString) {
    const params = {};
    queryString.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, (s, ...t)=>{
        $7aeedc6cf63007f3$var$decodeParam(params, t[0], t[1]);
        return t.join('=');
    });
    return params;
}
function $7aeedc6cf63007f3$var$decodeParam(params, name, value) {
    params[decodeURIComponent(name)] = decodeURIComponent(value || '');
}
function $7aeedc6cf63007f3$var$parseValue(flagName, value) {
    value = value.toLowerCase();
    if (value === 'true' || value === 'false') return value === 'true';
    else if (`${+value}` === value) return +value;
    throw new Error(`Could not parse value flag value ${value} for flag ${flagName}.`);
}
function $7aeedc6cf63007f3$export$a7b6bc01c63cdfc3() {
    return $7aeedc6cf63007f3$export$83401e34d5e11bf4;
}
let $7aeedc6cf63007f3$export$83401e34d5e11bf4 = null;
function $7aeedc6cf63007f3$export$3ef32a49eeda04cc(environment) {
    $7aeedc6cf63007f3$export$83401e34d5e11bf4 = environment;
}

});
parcelRegister("4tCOB", function(module, exports) {

$parcel$export(module.exports, "shuffle", () => $3427faba2aa983b6$export$448332262467e042);
$parcel$export(module.exports, "swap", () => $3427faba2aa983b6$export$b0e76d9850c64156);
$parcel$export(module.exports, "shuffleCombo", () => $3427faba2aa983b6$export$ae1498b5fd31a179);
$parcel$export(module.exports, "clamp", () => $3427faba2aa983b6$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "nearestLargerEven", () => $3427faba2aa983b6$export$ece2fd7300c99d1f);
$parcel$export(module.exports, "sum", () => $3427faba2aa983b6$export$8a63f25cc62965f1);
$parcel$export(module.exports, "randUniform", () => $3427faba2aa983b6$export$1c2519d52242937);
$parcel$export(module.exports, "distSquared", () => $3427faba2aa983b6$export$499eb56409f6cbc2);
$parcel$export(module.exports, "assert", () => $3427faba2aa983b6$export$a7a9523472993e97);
$parcel$export(module.exports, "assertShapesMatch", () => $3427faba2aa983b6$export$e08b27e7f37e2782);
$parcel$export(module.exports, "arraysEqual", () => $3427faba2aa983b6$export$234180f8206db11b);
$parcel$export(module.exports, "assertNonNull", () => $3427faba2aa983b6$export$44a06cc2759dd036);
$parcel$export(module.exports, "flatten", () => $3427faba2aa983b6$export$bffa455ba8c619a6);
$parcel$export(module.exports, "isTypedArray", () => $3427faba2aa983b6$export$b119cc7e1840e59c);
$parcel$export(module.exports, "sizeFromShape", () => $3427faba2aa983b6$export$b4c3214a70a0e73f);
$parcel$export(module.exports, "isScalarShape", () => $3427faba2aa983b6$export$d58b8d1ec2129064);
$parcel$export(module.exports, "isInt", () => $3427faba2aa983b6$export$357fc28f6427af8b);
$parcel$export(module.exports, "tanh", () => $3427faba2aa983b6$export$7128670e45beef9a);
$parcel$export(module.exports, "sizeToSquarishShape", () => $3427faba2aa983b6$export$55bdc5631791c247);
$parcel$export(module.exports, "createShuffledIndices", () => $3427faba2aa983b6$export$49070d702e17365);
$parcel$export(module.exports, "rightPad", () => $3427faba2aa983b6$export$390245bab32fb60f);
$parcel$export(module.exports, "repeatedTry", () => $3427faba2aa983b6$export$aa345f93372ddb7b);
$parcel$export(module.exports, "inferFromImplicitShape", () => $3427faba2aa983b6$export$e9459a51c182ffc2);
$parcel$export(module.exports, "parseAxisParam", () => $3427faba2aa983b6$export$72b84eb9fe1f482);
$parcel$export(module.exports, "squeezeShape", () => $3427faba2aa983b6$export$3106ace2a3b5396d);
$parcel$export(module.exports, "getTypedArrayFromDType", () => $3427faba2aa983b6$export$3b783bdb77632623);
$parcel$export(module.exports, "getArrayFromDType", () => $3427faba2aa983b6$export$24f13f6206df8f7c);
$parcel$export(module.exports, "checkConversionForErrors", () => $3427faba2aa983b6$export$579cf7b8ff0a87a3);
$parcel$export(module.exports, "isValidDtype", () => $3427faba2aa983b6$export$a6a3df2178ac9529);
$parcel$export(module.exports, "hasEncodingLoss", () => $3427faba2aa983b6$export$9130d84b35fa7b98);
$parcel$export(module.exports, "bytesPerElement", () => $3427faba2aa983b6$export$3f355ce86503b89f);
$parcel$export(module.exports, "bytesFromStringArray", () => $3427faba2aa983b6$export$c474902e1102282d);
$parcel$export(module.exports, "isString", () => $3427faba2aa983b6$export$844ec244b1367d54);
$parcel$export(module.exports, "isBoolean", () => $3427faba2aa983b6$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isNumber", () => $3427faba2aa983b6$export$7e4aa119212bc614);
$parcel$export(module.exports, "inferDtype", () => $3427faba2aa983b6$export$2005775d905d2dc2);
$parcel$export(module.exports, "isFunction", () => $3427faba2aa983b6$export$f6e2535fb5126e54);
$parcel$export(module.exports, "nearestDivisor", () => $3427faba2aa983b6$export$c0ff3276320ddb5e);
$parcel$export(module.exports, "computeStrides", () => $3427faba2aa983b6$export$6ad0292cf4d50f79);
$parcel$export(module.exports, "toNestedArray", () => $3427faba2aa983b6$export$3983c25181aa68cc);
$parcel$export(module.exports, "makeOnesTypedArray", () => $3427faba2aa983b6$export$b915f681a907ae99);
$parcel$export(module.exports, "makeZerosTypedArray", () => $3427faba2aa983b6$export$edbc8aedac4e036f);
$parcel$export(module.exports, "makeZerosNestedTypedArray", () => $3427faba2aa983b6$export$eef638260c005c74);
$parcel$export(module.exports, "assertNonNegativeIntegerDimensions", () => $3427faba2aa983b6$export$3d8b7619bac22cf5);
$parcel$export(module.exports, "locToIndex", () => $3427faba2aa983b6$export$a14b009c502dc3b4);
$parcel$export(module.exports, "indexToLoc", () => $3427faba2aa983b6$export$2d1ada4c755a8699);
$parcel$export(module.exports, "isPromise", () => $3427faba2aa983b6$export$4369c812aac99591);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Shuffles the array in-place using Fisher-Yates algorithm.
 *
 * ```js
 * const a = [1, 2, 3, 4, 5];
 * tf.util.shuffle(a);
 * console.log(a);
 * ```
 *
 * @param array The array to shuffle in-place.
 *
 * @doc {heading: 'Util', namespace: 'util'}
 */ // tslint:disable-next-line:no-any
function $3427faba2aa983b6$export$448332262467e042(array) {
    let counter = array.length;
    let index = 0;
    // While there are elements in the array
    while(counter > 0){
        // Pick a random index
        index = Math.random() * counter | 0;
        // Decrease counter by 1
        counter--;
        // And swap the last element with it
        $3427faba2aa983b6$export$b0e76d9850c64156(array, counter, index);
    }
}
function $3427faba2aa983b6$export$ae1498b5fd31a179(// tslint:disable-next-line:no-any
array, // tslint:disable-next-line:no-any
array2) {
    if (array.length !== array2.length) throw new Error(`Array sizes must match to be shuffled together ` + `First array length was ${array.length}` + `Second array length was ${array2.length}`);
    let counter = array.length;
    let index = 0;
    // While there are elements in the array
    while(counter > 0){
        // Pick a random index
        index = Math.random() * counter | 0;
        // Decrease counter by 1
        counter--;
        // And swap the last element of each array with it
        $3427faba2aa983b6$export$b0e76d9850c64156(array, counter, index);
        $3427faba2aa983b6$export$b0e76d9850c64156(array2, counter, index);
    }
}
function $3427faba2aa983b6$export$7d15b64cf5a3a4c4(min, x, max) {
    return Math.max(min, Math.min(x, max));
}
function $3427faba2aa983b6$export$ece2fd7300c99d1f(val) {
    return val % 2 === 0 ? val : val + 1;
}
function $3427faba2aa983b6$export$b0e76d9850c64156(object, left, right) {
    const temp = object[left];
    object[left] = object[right];
    object[right] = temp;
}
function $3427faba2aa983b6$export$8a63f25cc62965f1(arr) {
    let sum = 0;
    for(let i = 0; i < arr.length; i++)sum += arr[i];
    return sum;
}
function $3427faba2aa983b6$export$1c2519d52242937(a, b) {
    const r = Math.random();
    return b * r + (1 - r) * a;
}
function $3427faba2aa983b6$export$499eb56409f6cbc2(a, b) {
    let result = 0;
    for(let i = 0; i < a.length; i++){
        const diff = Number(a[i]) - Number(b[i]);
        result += diff * diff;
    }
    return result;
}
function $3427faba2aa983b6$export$a7a9523472993e97(expr, msg) {
    if (!expr) throw new Error(typeof msg === 'string' ? msg : msg());
}
function $3427faba2aa983b6$export$e08b27e7f37e2782(shapeA, shapeB, errorMessagePrefix = '') {
    $3427faba2aa983b6$export$a7a9523472993e97($3427faba2aa983b6$export$234180f8206db11b(shapeA, shapeB), ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
}
function $3427faba2aa983b6$export$44a06cc2759dd036(a) {
    $3427faba2aa983b6$export$a7a9523472993e97(a != null, ()=>`The input to the tensor constructor must be a non-null value.`);
}
function $3427faba2aa983b6$export$bffa455ba8c619a6(arr, result = [], skipTypedArray = false) {
    if (result == null) result = [];
    if (Array.isArray(arr) || $3427faba2aa983b6$export$b119cc7e1840e59c(arr) && !skipTypedArray) for(let i = 0; i < arr.length; ++i)$3427faba2aa983b6$export$bffa455ba8c619a6(arr[i], result, skipTypedArray);
    else result.push(arr);
    return result;
}
function $3427faba2aa983b6$export$b4c3214a70a0e73f(shape) {
    if (shape.length === 0) // Scalar.
    return 1;
    let size = shape[0];
    for(let i = 1; i < shape.length; i++)size *= shape[i];
    return size;
}
function $3427faba2aa983b6$export$d58b8d1ec2129064(shape) {
    return shape.length === 0;
}
function $3427faba2aa983b6$export$234180f8206db11b(n1, n2) {
    if (n1 === n2) return true;
    if (n1 == null || n2 == null) return false;
    if (n1.length !== n2.length) return false;
    for(let i = 0; i < n1.length; i++){
        if (n1[i] !== n2[i]) return false;
    }
    return true;
}
function $3427faba2aa983b6$export$357fc28f6427af8b(a) {
    return a % 1 === 0;
}
function $3427faba2aa983b6$export$7128670e45beef9a(x) {
    // tslint:disable-next-line:no-any
    if (Math.tanh != null) // tslint:disable-next-line:no-any
    return Math.tanh(x);
    if (x === Infinity) return 1;
    else if (x === -Infinity) return -1;
    else {
        const e2x = Math.exp(2 * x);
        return (e2x - 1) / (e2x + 1);
    }
}
function $3427faba2aa983b6$export$55bdc5631791c247(size) {
    const width = Math.ceil(Math.sqrt(size));
    return [
        width,
        Math.ceil(size / width)
    ];
}
function $3427faba2aa983b6$export$49070d702e17365(n) {
    const shuffledIndices = new Uint32Array(n);
    for(let i = 0; i < n; ++i)shuffledIndices[i] = i;
    $3427faba2aa983b6$export$448332262467e042(shuffledIndices);
    return shuffledIndices;
}
function $3427faba2aa983b6$export$390245bab32fb60f(a, size) {
    if (size <= a.length) return a;
    return a + ' '.repeat(size - a.length);
}
function $3427faba2aa983b6$export$aa345f93372ddb7b(checkFn, delayFn = (counter)=>0, maxCounter, scheduleFn = setTimeout) {
    return new Promise((resolve, reject)=>{
        let tryCount = 0;
        const tryFn = ()=>{
            if (checkFn()) {
                resolve();
                return;
            }
            tryCount++;
            const nextBackoff = delayFn(tryCount);
            if (maxCounter != null && tryCount >= maxCounter) {
                reject();
                return;
            }
            scheduleFn(tryFn, nextBackoff);
        };
        tryFn();
    });
}
function $3427faba2aa983b6$export$e9459a51c182ffc2(shape, size) {
    let shapeProd = 1;
    let implicitIdx = -1;
    for(let i = 0; i < shape.length; ++i){
        if (shape[i] >= 0) shapeProd *= shape[i];
        else if (shape[i] === -1) {
            if (implicitIdx !== -1) throw Error(`Shapes can only have 1 implicit size. ` + `Found -1 at dim ${implicitIdx} and dim ${i}`);
            implicitIdx = i;
        } else if (shape[i] < 0) throw Error(`Shapes can not be < 0. Found ${shape[i]} at dim ${i}`);
    }
    if (implicitIdx === -1) {
        if (size > 0 && size !== shapeProd) throw Error(`Size(${size}) must match the product of shape ${shape}`);
        return shape;
    }
    if (shapeProd === 0) throw Error(`Cannot infer the missing size in [${shape}] when ` + `there are 0 elements`);
    if (size % shapeProd !== 0) throw Error(`The implicit shape can't be a fractional number. ` + `Got ${size} / ${shapeProd}`);
    const newShape = shape.slice();
    newShape[implicitIdx] = size / shapeProd;
    return newShape;
}
function $3427faba2aa983b6$export$72b84eb9fe1f482(axis, shape) {
    const rank = shape.length;
    // Normalize input
    axis = axis == null ? shape.map((s, i)=>i) : [].concat(axis);
    // Check for valid range
    $3427faba2aa983b6$export$a7a9523472993e97(axis.every((ax)=>ax >= -rank && ax < rank), ()=>`All values in axis param must be in range [-${rank}, ${rank}) but ` + `got axis ${axis}`);
    // Check for only integers
    $3427faba2aa983b6$export$a7a9523472993e97(axis.every((ax)=>$3427faba2aa983b6$export$357fc28f6427af8b(ax)), ()=>`All values in axis param must be integers but ` + `got axis ${axis}`);
    // Handle negative axis.
    return axis.map((a)=>a < 0 ? rank + a : a);
}
function $3427faba2aa983b6$export$3106ace2a3b5396d(shape, axis) {
    const newShape = [];
    const keptDims = [];
    const isEmptyArray = axis != null && Array.isArray(axis) && axis.length === 0;
    const axes = axis == null || isEmptyArray ? null : $3427faba2aa983b6$export$72b84eb9fe1f482(axis, shape).sort();
    let j = 0;
    for(let i = 0; i < shape.length; ++i){
        if (axes != null) {
            if (axes[j] === i && shape[i] !== 1) throw new Error(`Can't squeeze axis ${i} since its dim '${shape[i]}' is not 1`);
            if ((axes[j] == null || axes[j] > i) && shape[i] === 1) {
                newShape.push(shape[i]);
                keptDims.push(i);
            }
            if (axes[j] <= i) j++;
        }
        if (shape[i] !== 1) {
            newShape.push(shape[i]);
            keptDims.push(i);
        }
    }
    return {
        newShape: newShape,
        keptDims: keptDims
    };
}
function $3427faba2aa983b6$export$3b783bdb77632623(dtype, size) {
    let values = null;
    if (dtype == null || dtype === 'float32') values = new Float32Array(size);
    else if (dtype === 'int32') values = new Int32Array(size);
    else if (dtype === 'bool') values = new Uint8Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
    return values;
}
function $3427faba2aa983b6$export$24f13f6206df8f7c(dtype, size) {
    let values = null;
    if (dtype == null || dtype === 'float32') values = new Float32Array(size);
    else if (dtype === 'int32') values = new Int32Array(size);
    else if (dtype === 'bool') values = new Uint8Array(size);
    else if (dtype === 'string') values = new Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
    return values;
}
function $3427faba2aa983b6$export$579cf7b8ff0a87a3(vals, dtype) {
    for(let i = 0; i < vals.length; i++){
        const num = vals[i];
        if (isNaN(num) || !isFinite(num)) throw Error(`A tensor of type ${dtype} being uploaded contains ${num}.`);
    }
}
function $3427faba2aa983b6$export$a6a3df2178ac9529(dtype) {
    return dtype === 'bool' || dtype === 'complex64' || dtype === 'float32' || dtype === 'int32' || dtype === 'string';
}
function $3427faba2aa983b6$export$9130d84b35fa7b98(oldType, newType) {
    if (newType === 'complex64') return false;
    if (newType === 'float32' && oldType !== 'complex64') return false;
    if (newType === 'int32' && oldType !== 'float32' && oldType !== 'complex64') return false;
    if (newType === 'bool' && oldType === 'bool') return false;
    return true;
}
function $3427faba2aa983b6$export$b119cc7e1840e59c(a) {
    return a instanceof Float32Array || a instanceof Int32Array || a instanceof Uint8Array || a instanceof Uint8ClampedArray;
}
function $3427faba2aa983b6$export$3f355ce86503b89f(dtype) {
    if (dtype === 'float32' || dtype === 'int32') return 4;
    else if (dtype === 'complex64') return 8;
    else if (dtype === 'bool') return 1;
    else throw new Error(`Unknown dtype ${dtype}`);
}
function $3427faba2aa983b6$export$c474902e1102282d(arr) {
    if (arr == null) return 0;
    let bytes = 0;
    arr.forEach((x)=>bytes += x.length);
    return bytes;
}
function $3427faba2aa983b6$export$844ec244b1367d54(value) {
    return typeof value === 'string' || value instanceof String;
}
function $3427faba2aa983b6$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $3427faba2aa983b6$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $3427faba2aa983b6$export$2005775d905d2dc2(values) {
    if (Array.isArray(values)) return $3427faba2aa983b6$export$2005775d905d2dc2(values[0]);
    if (values instanceof Float32Array) return 'float32';
    else if (values instanceof Int32Array || values instanceof Uint8Array || values instanceof Uint8ClampedArray) return 'int32';
    else if ($3427faba2aa983b6$export$7e4aa119212bc614(values)) return 'float32';
    else if ($3427faba2aa983b6$export$844ec244b1367d54(values)) return 'string';
    else if ($3427faba2aa983b6$export$f9ce7b637dfbe238(values)) return 'bool';
    return 'float32';
}
function $3427faba2aa983b6$export$f6e2535fb5126e54(f) {
    return !!(f && f.constructor && f.call && f.apply);
}
function $3427faba2aa983b6$export$c0ff3276320ddb5e(size, start) {
    for(let i = start; i < size; ++i){
        if (size % i === 0) return i;
    }
    return size;
}
function $3427faba2aa983b6$export$6ad0292cf4d50f79(shape) {
    const rank = shape.length;
    if (rank < 2) return [];
    // Last dimension has implicit stride of 1, thus having D-1 (instead of D)
    // strides.
    const strides = new Array(rank - 1);
    strides[rank - 2] = shape[rank - 1];
    for(let i = rank - 3; i >= 0; --i)strides[i] = strides[i + 1] * shape[i + 1];
    return strides;
}
function $3427faba2aa983b6$var$createNestedArray(offset, shape, a, isComplex = false) {
    const ret = new Array();
    if (shape.length === 1) {
        const d = shape[0] * (isComplex ? 2 : 1);
        for(let i = 0; i < d; i++)ret[i] = a[offset + i];
    } else {
        const d = shape[0];
        const rest = shape.slice(1);
        const len = rest.reduce((acc, c)=>acc * c) * (isComplex ? 2 : 1);
        for(let i = 0; i < d; i++)ret[i] = $3427faba2aa983b6$var$createNestedArray(offset + i * len, rest, a, isComplex);
    }
    return ret;
}
function $3427faba2aa983b6$export$3983c25181aa68cc(shape, a, isComplex = false) {
    if (shape.length === 0) // Scalar type should return a single number.
    return a[0];
    const size = shape.reduce((acc, c)=>acc * c) * (isComplex ? 2 : 1);
    if (size === 0) // A tensor with shape zero should be turned into empty list.
    return [];
    if (size !== a.length) throw new Error(`[${shape}] does not match the input size ${a.length}${isComplex ? ' for a complex tensor' : ''}.`);
    return $3427faba2aa983b6$var$createNestedArray(0, shape, a, isComplex);
}
function $3427faba2aa983b6$export$b915f681a907ae99(size, dtype) {
    const array = $3427faba2aa983b6$export$edbc8aedac4e036f(size, dtype);
    for(let i = 0; i < array.length; i++)array[i] = 1;
    return array;
}
function $3427faba2aa983b6$export$edbc8aedac4e036f(size, dtype) {
    if (dtype == null || dtype === 'float32' || dtype === 'complex64') return new Float32Array(size);
    else if (dtype === 'int32') return new Int32Array(size);
    else if (dtype === 'bool') return new Uint8Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
}
function $3427faba2aa983b6$export$eef638260c005c74(shape, dtype) {
    const size = shape.reduce((prev, curr)=>prev * curr, 1);
    if (dtype == null || dtype === 'float32') return $3427faba2aa983b6$export$3983c25181aa68cc(shape, new Float32Array(size));
    else if (dtype === 'int32') return $3427faba2aa983b6$export$3983c25181aa68cc(shape, new Int32Array(size));
    else if (dtype === 'bool') return $3427faba2aa983b6$export$3983c25181aa68cc(shape, new Uint8Array(size));
    else throw new Error(`Unknown data type ${dtype}`);
}
function $3427faba2aa983b6$export$3d8b7619bac22cf5(shape) {
    shape.forEach((dimSize)=>{
        $3427faba2aa983b6$export$a7a9523472993e97(Number.isInteger(dimSize) && dimSize >= 0, ()=>`Tensor must have a shape comprised of positive integers but got ` + `shape [${shape}].`);
    });
}
function $3427faba2aa983b6$export$a14b009c502dc3b4(locs, rank, strides) {
    if (rank === 0) return 0;
    else if (rank === 1) return locs[0];
    let index = locs[locs.length - 1];
    for(let i = 0; i < locs.length - 1; ++i)index += strides[i] * locs[i];
    return index;
}
function $3427faba2aa983b6$export$2d1ada4c755a8699(index, rank, strides) {
    if (rank === 0) return [];
    else if (rank === 1) return [
        index
    ];
    const locs = new Array(rank);
    for(let i = 0; i < locs.length - 1; ++i){
        locs[i] = Math.floor(index / strides[i]);
        index -= locs[i] * strides[i];
    }
    locs[locs.length - 1] = index;
    return locs;
}
function $3427faba2aa983b6$export$4369c812aac99591(object) {
    //  We chose to not use 'obj instanceOf Promise' for two reasons:
    //  1. It only reliably works for es6 Promise, not other Promise
    //  implementations.
    //  2. It doesn't work with framework that uses zone.js. zone.js monkey
    //  patch the async calls, so it is possible the obj (patched) is
    //  comparing to a pre-patched Promise.
    return object && object.then && typeof object.then === 'function';
}

});


parcelRegister("fRI13", function(module, exports) {

$parcel$export(module.exports, "getGlobalNamespace", () => $b8cdf2e3fd547ac5$export$5054b240ae6849b7);
$parcel$export(module.exports, "getGlobal", () => $b8cdf2e3fd547ac5$export$a4e55266d2135a7f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Note that the identifier globalNameSpace is scoped to this module, but will
// always resolve to the same global object regardless of how the module is
// resolved.
// tslint:disable-next-line:no-any

var $4Jj9n = parcelRequire("4Jj9n");
let $b8cdf2e3fd547ac5$var$globalNameSpace;
function $b8cdf2e3fd547ac5$export$5054b240ae6849b7() {
    if ($b8cdf2e3fd547ac5$var$globalNameSpace == null) {
        // tslint:disable-next-line:no-any
        let ns;
        if (typeof window !== 'undefined') ns = window;
        else if (typeof $parcel$global !== 'undefined') ns = $parcel$global;
        else if (typeof $4Jj9n !== 'undefined') ns = $4Jj9n;
        else if (typeof self !== 'undefined') ns = self;
        else throw new Error('Could not find a global object');
        $b8cdf2e3fd547ac5$var$globalNameSpace = ns;
    }
    return $b8cdf2e3fd547ac5$var$globalNameSpace;
}
// tslint:disable-next-line:no-any
function $b8cdf2e3fd547ac5$var$getGlobalMap() {
    const ns = $b8cdf2e3fd547ac5$export$5054b240ae6849b7();
    if (ns._tfGlobals == null) ns._tfGlobals = new Map();
    return ns._tfGlobals;
}
function $b8cdf2e3fd547ac5$export$a4e55266d2135a7f(key, init) {
    const globalMap = $b8cdf2e3fd547ac5$var$getGlobalMap();
    if (globalMap.has(key)) return globalMap.get(key);
    else {
        const singleton = init();
        globalMap.set(key, singleton);
        return globalMap.get(key);
    }
}

});
parcelRegister("4Jj9n", function(module, exports) {
// shim for using process in browser
var $371a3837fd81d701$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = 'browser';
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ''; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$371a3837fd81d701$var$process.cwd = function() {
    return '/';
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};

});


parcelRegister("dCP8m", function(module, exports) {

$parcel$export(module.exports, "Abs", () => $9eb67d14d350b8ec$export$b73c596ee8758a66);
$parcel$export(module.exports, "Acos", () => $9eb67d14d350b8ec$export$3b952c9980dac550);
$parcel$export(module.exports, "Acosh", () => $9eb67d14d350b8ec$export$987da490b7c2e7dd);
$parcel$export(module.exports, "Add", () => $9eb67d14d350b8ec$export$d0265b2c425512d6);
$parcel$export(module.exports, "AddN", () => $9eb67d14d350b8ec$export$eef235ad06d3226a);
$parcel$export(module.exports, "All", () => $9eb67d14d350b8ec$export$5dceb1ab650a1776);
$parcel$export(module.exports, "Any", () => $9eb67d14d350b8ec$export$b24b633b1364b94b);
$parcel$export(module.exports, "ArgMax", () => $9eb67d14d350b8ec$export$17612294a1503e1c);
$parcel$export(module.exports, "ArgMin", () => $9eb67d14d350b8ec$export$baabd09270cbbd94);
$parcel$export(module.exports, "Asin", () => $9eb67d14d350b8ec$export$664c8ca7e7e5c126);
$parcel$export(module.exports, "Asinh", () => $9eb67d14d350b8ec$export$847c88940cb7dcb5);
$parcel$export(module.exports, "Atan", () => $9eb67d14d350b8ec$export$bac667d46ac043ae);
$parcel$export(module.exports, "Atanh", () => $9eb67d14d350b8ec$export$98981a86fa2b1366);
$parcel$export(module.exports, "Atan2", () => $9eb67d14d350b8ec$export$3bf4c619ce589f4b);
$parcel$export(module.exports, "AvgPool", () => $9eb67d14d350b8ec$export$37f2cc7be1add88c);
$parcel$export(module.exports, "AvgPoolGrad", () => $9eb67d14d350b8ec$export$9873fd6046cd6951);
$parcel$export(module.exports, "AvgPool3D", () => $9eb67d14d350b8ec$export$390ecb697af103f6);
$parcel$export(module.exports, "AvgPool3DGrad", () => $9eb67d14d350b8ec$export$7163112adf28c062);
$parcel$export(module.exports, "BatchMatMul", () => $9eb67d14d350b8ec$export$9a3bf60b23f63c8);
$parcel$export(module.exports, "BatchToSpaceND", () => $9eb67d14d350b8ec$export$e2743f47f61cca1f);
$parcel$export(module.exports, "Bincount", () => $9eb67d14d350b8ec$export$45dfbbff595c32aa);
$parcel$export(module.exports, "BroadcastTo", () => $9eb67d14d350b8ec$export$ea5eeb875a7c4dd1);
$parcel$export(module.exports, "BroadcastArgs", () => $9eb67d14d350b8ec$export$32877b1d6d497805);
$parcel$export(module.exports, "Cast", () => $9eb67d14d350b8ec$export$107ecfb3d1ccbd77);
$parcel$export(module.exports, "Ceil", () => $9eb67d14d350b8ec$export$d4a1bccfd52ebd3);
$parcel$export(module.exports, "ClipByValue", () => $9eb67d14d350b8ec$export$611c0e357ac37f7d);
$parcel$export(module.exports, "Complex", () => $9eb67d14d350b8ec$export$50ceb3fb9926e63e);
$parcel$export(module.exports, "ComplexAbs", () => $9eb67d14d350b8ec$export$32902e58f1b48f4b);
$parcel$export(module.exports, "Concat", () => $9eb67d14d350b8ec$export$936bbfc007425eea);
$parcel$export(module.exports, "Conv2D", () => $9eb67d14d350b8ec$export$57742e605d475795);
$parcel$export(module.exports, "Conv2DBackpropFilter", () => $9eb67d14d350b8ec$export$32a8943c0f1ca5a7);
$parcel$export(module.exports, "Conv2DBackpropInput", () => $9eb67d14d350b8ec$export$e26961e8ed0eb404);
$parcel$export(module.exports, "Conv3D", () => $9eb67d14d350b8ec$export$9d3874201dd21933);
$parcel$export(module.exports, "Conv3DBackpropFilterV2", () => $9eb67d14d350b8ec$export$dd2885efe6043eee);
$parcel$export(module.exports, "Conv3DBackpropInputV2", () => $9eb67d14d350b8ec$export$a54f552d6d7d521f);
$parcel$export(module.exports, "Cos", () => $9eb67d14d350b8ec$export$ddfd0a983d257666);
$parcel$export(module.exports, "Cosh", () => $9eb67d14d350b8ec$export$5e311a1c57b0d27c);
$parcel$export(module.exports, "Cumprod", () => $9eb67d14d350b8ec$export$e581acc6014c47a);
$parcel$export(module.exports, "Cumsum", () => $9eb67d14d350b8ec$export$706617d894ad63da);
$parcel$export(module.exports, "CropAndResize", () => $9eb67d14d350b8ec$export$50bc9557793c2e04);
$parcel$export(module.exports, "DenseBincount", () => $9eb67d14d350b8ec$export$5bab6834954299c5);
$parcel$export(module.exports, "DepthToSpace", () => $9eb67d14d350b8ec$export$fb0ee52d0cd6f233);
$parcel$export(module.exports, "DepthwiseConv2dNative", () => $9eb67d14d350b8ec$export$7c0fc590ff9e156f);
$parcel$export(module.exports, "DepthwiseConv2dNativeBackpropFilter", () => $9eb67d14d350b8ec$export$c99f139e0d4d1833);
$parcel$export(module.exports, "DepthwiseConv2dNativeBackpropInput", () => $9eb67d14d350b8ec$export$8649ca3b17033a24);
$parcel$export(module.exports, "Diag", () => $9eb67d14d350b8ec$export$ca73a25315ddeb7f);
$parcel$export(module.exports, "Dilation2D", () => $9eb67d14d350b8ec$export$dbbb7830c6497701);
$parcel$export(module.exports, "Dilation2DBackpropInput", () => $9eb67d14d350b8ec$export$5dd675a6b0f37e17);
$parcel$export(module.exports, "Dilation2DBackpropFilter", () => $9eb67d14d350b8ec$export$91add972be69d592);
$parcel$export(module.exports, "RealDiv", () => $9eb67d14d350b8ec$export$b9880b86e1014bb8);
$parcel$export(module.exports, "Einsum", () => $9eb67d14d350b8ec$export$2541d8be32f3c641);
$parcel$export(module.exports, "Elu", () => $9eb67d14d350b8ec$export$64636e173424d83d);
$parcel$export(module.exports, "EluGrad", () => $9eb67d14d350b8ec$export$9906be4699a73c53);
$parcel$export(module.exports, "Erf", () => $9eb67d14d350b8ec$export$c2ee2551ce71f1d0);
$parcel$export(module.exports, "Equal", () => $9eb67d14d350b8ec$export$8dcf9f58ce5cdfc);
$parcel$export(module.exports, "Exp", () => $9eb67d14d350b8ec$export$f908be7a96fb3363);
$parcel$export(module.exports, "ExpandDims", () => $9eb67d14d350b8ec$export$2391750b1d901146);
$parcel$export(module.exports, "Expm1", () => $9eb67d14d350b8ec$export$261f26143a1ff3);
$parcel$export(module.exports, "FFT", () => $9eb67d14d350b8ec$export$677347237c014ba);
$parcel$export(module.exports, "Fill", () => $9eb67d14d350b8ec$export$ffffe40bfa0649a3);
$parcel$export(module.exports, "FlipLeftRight", () => $9eb67d14d350b8ec$export$34e7296fc8558df5);
$parcel$export(module.exports, "Floor", () => $9eb67d14d350b8ec$export$4880b0ae5643c62b);
$parcel$export(module.exports, "FloorDiv", () => $9eb67d14d350b8ec$export$d79b5692ede26c2f);
$parcel$export(module.exports, "FusedBatchNorm", () => $9eb67d14d350b8ec$export$3821a0416660aaa2);
$parcel$export(module.exports, "GatherV2", () => $9eb67d14d350b8ec$export$ccd988942e5c0181);
$parcel$export(module.exports, "GatherNd", () => $9eb67d14d350b8ec$export$4ef6e37a23721703);
$parcel$export(module.exports, "Greater", () => $9eb67d14d350b8ec$export$d0a25eac5ee3f515);
$parcel$export(module.exports, "GreaterEqual", () => $9eb67d14d350b8ec$export$3b7d21bc9aee0851);
$parcel$export(module.exports, "Identity", () => $9eb67d14d350b8ec$export$544bf02140fa9a77);
$parcel$export(module.exports, "IFFT", () => $9eb67d14d350b8ec$export$21c6f576ae8100e8);
$parcel$export(module.exports, "Imag", () => $9eb67d14d350b8ec$export$303b4473993a24f);
$parcel$export(module.exports, "IsFinite", () => $9eb67d14d350b8ec$export$b9fcc0946d7d485e);
$parcel$export(module.exports, "IsInf", () => $9eb67d14d350b8ec$export$74b5a3bc735b152);
$parcel$export(module.exports, "IsNan", () => $9eb67d14d350b8ec$export$9912dc4fc649dbec);
$parcel$export(module.exports, "LeakyRelu", () => $9eb67d14d350b8ec$export$f0c7162bb7af1a2d);
$parcel$export(module.exports, "Less", () => $9eb67d14d350b8ec$export$728c50f1c88ac779);
$parcel$export(module.exports, "LessEqual", () => $9eb67d14d350b8ec$export$84afd0d8f7fb8c5d);
$parcel$export(module.exports, "LinSpace", () => $9eb67d14d350b8ec$export$34f0ab8eba543ee6);
$parcel$export(module.exports, "Log", () => $9eb67d14d350b8ec$export$ce30dbb46644d06c);
$parcel$export(module.exports, "Log1p", () => $9eb67d14d350b8ec$export$70f05bf9ddcfca68);
$parcel$export(module.exports, "LogicalAnd", () => $9eb67d14d350b8ec$export$8a27ff10dff4d6e5);
$parcel$export(module.exports, "LogicalNot", () => $9eb67d14d350b8ec$export$4393bee5596c68c2);
$parcel$export(module.exports, "LogicalOr", () => $9eb67d14d350b8ec$export$c49f9f5ffc6f678c);
$parcel$export(module.exports, "LogicalXor", () => $9eb67d14d350b8ec$export$656629b293485eff);
$parcel$export(module.exports, "LogSoftmax", () => $9eb67d14d350b8ec$export$85b5bcbd60848a10);
$parcel$export(module.exports, "LowerBound", () => $9eb67d14d350b8ec$export$9ec35fe80d53e931);
$parcel$export(module.exports, "LRN", () => $9eb67d14d350b8ec$export$eb2f713fc3e1ca9a);
$parcel$export(module.exports, "LRNGrad", () => $9eb67d14d350b8ec$export$73ba43cd0ce95b10);
$parcel$export(module.exports, "Max", () => $9eb67d14d350b8ec$export$d36c09e5d02927e7);
$parcel$export(module.exports, "Maximum", () => $9eb67d14d350b8ec$export$d8d02ac92d161004);
$parcel$export(module.exports, "MaxPool", () => $9eb67d14d350b8ec$export$39ea33024ddd5cf);
$parcel$export(module.exports, "MaxPoolGrad", () => $9eb67d14d350b8ec$export$f0f010b1d1db8a46);
$parcel$export(module.exports, "MaxPool3D", () => $9eb67d14d350b8ec$export$88fdc64af890fc53);
$parcel$export(module.exports, "MaxPool3DGrad", () => $9eb67d14d350b8ec$export$52be2c00371a1350);
$parcel$export(module.exports, "MaxPoolWithArgmax", () => $9eb67d14d350b8ec$export$deac4b7497b4047f);
$parcel$export(module.exports, "Mean", () => $9eb67d14d350b8ec$export$1c2d59c4b681fbd8);
$parcel$export(module.exports, "Min", () => $9eb67d14d350b8ec$export$dfed19fabc75a31d);
$parcel$export(module.exports, "Minimum", () => $9eb67d14d350b8ec$export$23cb308301e89d6b);
$parcel$export(module.exports, "MirrorPad", () => $9eb67d14d350b8ec$export$f4c0e95fd7fd31e5);
$parcel$export(module.exports, "Mod", () => $9eb67d14d350b8ec$export$e4835a5e3f3674d5);
$parcel$export(module.exports, "Multinomial", () => $9eb67d14d350b8ec$export$ee0a8cfb693e0e3f);
$parcel$export(module.exports, "Multiply", () => $9eb67d14d350b8ec$export$f14f83b3b531d498);
$parcel$export(module.exports, "Neg", () => $9eb67d14d350b8ec$export$c07c549000872073);
$parcel$export(module.exports, "NotEqual", () => $9eb67d14d350b8ec$export$385ebe9945cae0c5);
$parcel$export(module.exports, "NonMaxSuppressionV3", () => $9eb67d14d350b8ec$export$5e11788439c2f04);
$parcel$export(module.exports, "NonMaxSuppressionV4", () => $9eb67d14d350b8ec$export$7df908154366fe7f);
$parcel$export(module.exports, "NonMaxSuppressionV5", () => $9eb67d14d350b8ec$export$cb45d3fcefce2ef0);
$parcel$export(module.exports, "OnesLike", () => $9eb67d14d350b8ec$export$a2962e735c809d91);
$parcel$export(module.exports, "OneHot", () => $9eb67d14d350b8ec$export$18982b43ba8c02e9);
$parcel$export(module.exports, "Pack", () => $9eb67d14d350b8ec$export$c26f40b29201e5b7);
$parcel$export(module.exports, "PadV2", () => $9eb67d14d350b8ec$export$5d47ba206577f0f2);
$parcel$export(module.exports, "Pool", () => $9eb67d14d350b8ec$export$14963ee5c8637e11);
$parcel$export(module.exports, "Pow", () => $9eb67d14d350b8ec$export$ce28d653ec559ee);
$parcel$export(module.exports, "Prelu", () => $9eb67d14d350b8ec$export$a42f35f308fc2fa3);
$parcel$export(module.exports, "Prod", () => $9eb67d14d350b8ec$export$b8a16d526a791fb0);
$parcel$export(module.exports, "RaggedGather", () => $9eb67d14d350b8ec$export$ffee9c5b4fce08a1);
$parcel$export(module.exports, "RaggedTensorToTensor", () => $9eb67d14d350b8ec$export$616d73a9ab7617c7);
$parcel$export(module.exports, "Range", () => $9eb67d14d350b8ec$export$9a58ef0d7ad3278c);
$parcel$export(module.exports, "Real", () => $9eb67d14d350b8ec$export$f41305719b94e675);
$parcel$export(module.exports, "Reciprocal", () => $9eb67d14d350b8ec$export$c6e4a23ed5e0415b);
$parcel$export(module.exports, "Relu", () => $9eb67d14d350b8ec$export$9a6ff968bf961432);
$parcel$export(module.exports, "Reshape", () => $9eb67d14d350b8ec$export$755ddd847e5abe03);
$parcel$export(module.exports, "ResizeNearestNeighbor", () => $9eb67d14d350b8ec$export$6c8d8ec26192bb18);
$parcel$export(module.exports, "ResizeNearestNeighborGrad", () => $9eb67d14d350b8ec$export$b84ac31c55aa023b);
$parcel$export(module.exports, "ResizeBilinear", () => $9eb67d14d350b8ec$export$24f2f15d869e0fd);
$parcel$export(module.exports, "ResizeBilinearGrad", () => $9eb67d14d350b8ec$export$2d3cf759f1538c13);
$parcel$export(module.exports, "Relu6", () => $9eb67d14d350b8ec$export$3be9e924f629054e);
$parcel$export(module.exports, "Reverse", () => $9eb67d14d350b8ec$export$53c81f36b32e1bba);
$parcel$export(module.exports, "Round", () => $9eb67d14d350b8ec$export$c5ed3eef16c0612f);
$parcel$export(module.exports, "Rsqrt", () => $9eb67d14d350b8ec$export$7cc53aa09f5f3a2d);
$parcel$export(module.exports, "ScatterNd", () => $9eb67d14d350b8ec$export$28eef6f0168af686);
$parcel$export(module.exports, "SearchSorted", () => $9eb67d14d350b8ec$export$9a1405490b09867e);
$parcel$export(module.exports, "Select", () => $9eb67d14d350b8ec$export$ef9b1a59e592288f);
$parcel$export(module.exports, "Selu", () => $9eb67d14d350b8ec$export$6760d858e6f2594a);
$parcel$export(module.exports, "Slice", () => $9eb67d14d350b8ec$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "Sin", () => $9eb67d14d350b8ec$export$75be1b631f7687);
$parcel$export(module.exports, "Sinh", () => $9eb67d14d350b8ec$export$b8c187376329d79b);
$parcel$export(module.exports, "Sign", () => $9eb67d14d350b8ec$export$1db683ad541682f6);
$parcel$export(module.exports, "Sigmoid", () => $9eb67d14d350b8ec$export$fde18c826dda6b1b);
$parcel$export(module.exports, "Softplus", () => $9eb67d14d350b8ec$export$c5af433747f1fd0a);
$parcel$export(module.exports, "Sqrt", () => $9eb67d14d350b8ec$export$21ab404ab9d512a6);
$parcel$export(module.exports, "Sum", () => $9eb67d14d350b8ec$export$534760f50726d5);
$parcel$export(module.exports, "SpaceToBatchND", () => $9eb67d14d350b8ec$export$f63ac5409312707c);
$parcel$export(module.exports, "SplitV", () => $9eb67d14d350b8ec$export$8dffabb4071f05aa);
$parcel$export(module.exports, "Softmax", () => $9eb67d14d350b8ec$export$350a526055d3ca6e);
$parcel$export(module.exports, "SparseFillEmptyRows", () => $9eb67d14d350b8ec$export$8f1933853a5c8cca);
$parcel$export(module.exports, "SparseReshape", () => $9eb67d14d350b8ec$export$f08f0dca44fa542);
$parcel$export(module.exports, "SparseSegmentMean", () => $9eb67d14d350b8ec$export$610b077aecc2447b);
$parcel$export(module.exports, "SparseSegmentSum", () => $9eb67d14d350b8ec$export$68351c28d7116b56);
$parcel$export(module.exports, "SparseToDense", () => $9eb67d14d350b8ec$export$2c426709a9332421);
$parcel$export(module.exports, "SquaredDifference", () => $9eb67d14d350b8ec$export$2f922d20d66089c6);
$parcel$export(module.exports, "Square", () => $9eb67d14d350b8ec$export$b09fb900337259de);
$parcel$export(module.exports, "StridedSlice", () => $9eb67d14d350b8ec$export$60c7f9ac271417a9);
$parcel$export(module.exports, "StringNGrams", () => $9eb67d14d350b8ec$export$11a7f4af7d96ad41);
$parcel$export(module.exports, "StringSplit", () => $9eb67d14d350b8ec$export$7e266f7223b9d396);
$parcel$export(module.exports, "StringToHashBucketFast", () => $9eb67d14d350b8ec$export$a5639899909bc8ae);
$parcel$export(module.exports, "Sub", () => $9eb67d14d350b8ec$export$d7a01e11500dfb6f);
$parcel$export(module.exports, "Tan", () => $9eb67d14d350b8ec$export$115b2d5263ba5985);
$parcel$export(module.exports, "Tanh", () => $9eb67d14d350b8ec$export$893b6e865e352c83);
$parcel$export(module.exports, "Tile", () => $9eb67d14d350b8ec$export$235cb65c20ad2b7);
$parcel$export(module.exports, "TopK", () => $9eb67d14d350b8ec$export$c593cd1ea0d02ebd);
$parcel$export(module.exports, "Transform", () => $9eb67d14d350b8ec$export$563a914cafbdc389);
$parcel$export(module.exports, "Transpose", () => $9eb67d14d350b8ec$export$7e714455f9a1f8f7);
$parcel$export(module.exports, "Unique", () => $9eb67d14d350b8ec$export$8e3adf126971a183);
$parcel$export(module.exports, "Unpack", () => $9eb67d14d350b8ec$export$441ad6bfc5db8ab4);
$parcel$export(module.exports, "UnsortedSegmentSum", () => $9eb67d14d350b8ec$export$af810663cded5fe2);
$parcel$export(module.exports, "UpperBound", () => $9eb67d14d350b8ec$export$7dc194c8da2f9058);
$parcel$export(module.exports, "ZerosLike", () => $9eb67d14d350b8ec$export$430969a37eda1e88);
$parcel$export(module.exports, "Step", () => $9eb67d14d350b8ec$export$fd55ce593607084a);
$parcel$export(module.exports, "FromPixels", () => $9eb67d14d350b8ec$export$d0eb4e7054966c48);
$parcel$export(module.exports, "RotateWithOffset", () => $9eb67d14d350b8ec$export$c5a44649815d1c3);
$parcel$export(module.exports, "_FusedMatMul", () => $9eb67d14d350b8ec$export$8d1af0f7c2a4da9e);
$parcel$export(module.exports, "FusedConv2D", () => $9eb67d14d350b8ec$export$86f8a8e3a8f2a8f2);
$parcel$export(module.exports, "FusedDepthwiseConv2D", () => $9eb67d14d350b8ec$export$5a249e8f498c02c1);
const $9eb67d14d350b8ec$export$b73c596ee8758a66 = 'Abs';
const $9eb67d14d350b8ec$export$3b952c9980dac550 = 'Acos';
const $9eb67d14d350b8ec$export$987da490b7c2e7dd = 'Acosh';
const $9eb67d14d350b8ec$export$d0265b2c425512d6 = 'Add';
const $9eb67d14d350b8ec$export$eef235ad06d3226a = 'AddN';
const $9eb67d14d350b8ec$export$5dceb1ab650a1776 = 'All';
const $9eb67d14d350b8ec$export$b24b633b1364b94b = 'Any';
const $9eb67d14d350b8ec$export$17612294a1503e1c = 'ArgMax';
const $9eb67d14d350b8ec$export$baabd09270cbbd94 = 'ArgMin';
const $9eb67d14d350b8ec$export$664c8ca7e7e5c126 = 'Asin';
const $9eb67d14d350b8ec$export$847c88940cb7dcb5 = 'Asinh';
const $9eb67d14d350b8ec$export$bac667d46ac043ae = 'Atan';
const $9eb67d14d350b8ec$export$98981a86fa2b1366 = 'Atanh';
const $9eb67d14d350b8ec$export$3bf4c619ce589f4b = 'Atan2';
const $9eb67d14d350b8ec$export$37f2cc7be1add88c = 'AvgPool';
const $9eb67d14d350b8ec$export$9873fd6046cd6951 = 'AvgPoolGrad';
const $9eb67d14d350b8ec$export$390ecb697af103f6 = 'AvgPool3D';
const $9eb67d14d350b8ec$export$7163112adf28c062 = 'AvgPool3DGrad';
const $9eb67d14d350b8ec$export$9a3bf60b23f63c8 = 'BatchMatMul';
const $9eb67d14d350b8ec$export$e2743f47f61cca1f = 'BatchToSpaceND';
const $9eb67d14d350b8ec$export$45dfbbff595c32aa = 'Bincount';
const $9eb67d14d350b8ec$export$ea5eeb875a7c4dd1 = 'BroadcastTo';
const $9eb67d14d350b8ec$export$32877b1d6d497805 = 'BroadcastArgs';
const $9eb67d14d350b8ec$export$107ecfb3d1ccbd77 = 'Cast';
const $9eb67d14d350b8ec$export$d4a1bccfd52ebd3 = 'Ceil';
const $9eb67d14d350b8ec$export$611c0e357ac37f7d = 'ClipByValue';
const $9eb67d14d350b8ec$export$50ceb3fb9926e63e = 'Complex';
const $9eb67d14d350b8ec$export$32902e58f1b48f4b = 'ComplexAbs';
const $9eb67d14d350b8ec$export$936bbfc007425eea = 'Concat';
const $9eb67d14d350b8ec$export$57742e605d475795 = 'Conv2D';
const $9eb67d14d350b8ec$export$32a8943c0f1ca5a7 = 'Conv2DBackpropFilter';
const $9eb67d14d350b8ec$export$e26961e8ed0eb404 = 'Conv2DBackpropInput';
const $9eb67d14d350b8ec$export$9d3874201dd21933 = 'Conv3D';
const $9eb67d14d350b8ec$export$dd2885efe6043eee = 'Conv3DBackpropFilterV2';
const $9eb67d14d350b8ec$export$a54f552d6d7d521f = 'Conv3DBackpropInputV2';
const $9eb67d14d350b8ec$export$ddfd0a983d257666 = 'Cos';
const $9eb67d14d350b8ec$export$5e311a1c57b0d27c = 'Cosh';
const $9eb67d14d350b8ec$export$e581acc6014c47a = 'Cumprod';
const $9eb67d14d350b8ec$export$706617d894ad63da = 'Cumsum';
const $9eb67d14d350b8ec$export$50bc9557793c2e04 = 'CropAndResize';
const $9eb67d14d350b8ec$export$5bab6834954299c5 = 'DenseBincount';
const $9eb67d14d350b8ec$export$fb0ee52d0cd6f233 = 'DepthToSpace';
const $9eb67d14d350b8ec$export$7c0fc590ff9e156f = 'DepthwiseConv2dNative';
const $9eb67d14d350b8ec$export$c99f139e0d4d1833 = 'DepthwiseConv2dNativeBackpropFilter';
const $9eb67d14d350b8ec$export$8649ca3b17033a24 = 'DepthwiseConv2dNativeBackpropInput';
const $9eb67d14d350b8ec$export$ca73a25315ddeb7f = 'Diag';
const $9eb67d14d350b8ec$export$dbbb7830c6497701 = 'Dilation2D';
const $9eb67d14d350b8ec$export$5dd675a6b0f37e17 = 'Dilation2DBackpropInput';
const $9eb67d14d350b8ec$export$91add972be69d592 = 'Dilation2DBackpropFilter';
const $9eb67d14d350b8ec$export$b9880b86e1014bb8 = 'RealDiv';
const $9eb67d14d350b8ec$export$2541d8be32f3c641 = 'Einsum';
const $9eb67d14d350b8ec$export$64636e173424d83d = 'Elu';
const $9eb67d14d350b8ec$export$9906be4699a73c53 = 'EluGrad';
const $9eb67d14d350b8ec$export$c2ee2551ce71f1d0 = 'Erf';
const $9eb67d14d350b8ec$export$8dcf9f58ce5cdfc = 'Equal';
const $9eb67d14d350b8ec$export$f908be7a96fb3363 = 'Exp';
const $9eb67d14d350b8ec$export$2391750b1d901146 = 'ExpandDims';
const $9eb67d14d350b8ec$export$261f26143a1ff3 = 'Expm1';
const $9eb67d14d350b8ec$export$677347237c014ba = 'FFT';
const $9eb67d14d350b8ec$export$ffffe40bfa0649a3 = 'Fill';
const $9eb67d14d350b8ec$export$34e7296fc8558df5 = 'FlipLeftRight';
const $9eb67d14d350b8ec$export$4880b0ae5643c62b = 'Floor';
const $9eb67d14d350b8ec$export$d79b5692ede26c2f = 'FloorDiv';
const $9eb67d14d350b8ec$export$3821a0416660aaa2 = 'FusedBatchNorm';
const $9eb67d14d350b8ec$export$ccd988942e5c0181 = 'GatherV2';
const $9eb67d14d350b8ec$export$4ef6e37a23721703 = 'GatherNd';
const $9eb67d14d350b8ec$export$d0a25eac5ee3f515 = 'Greater';
const $9eb67d14d350b8ec$export$3b7d21bc9aee0851 = 'GreaterEqual';
const $9eb67d14d350b8ec$export$544bf02140fa9a77 = 'Identity';
const $9eb67d14d350b8ec$export$21c6f576ae8100e8 = 'IFFT';
const $9eb67d14d350b8ec$export$303b4473993a24f = 'Imag';
const $9eb67d14d350b8ec$export$b9fcc0946d7d485e = 'IsFinite';
const $9eb67d14d350b8ec$export$74b5a3bc735b152 = 'IsInf';
const $9eb67d14d350b8ec$export$9912dc4fc649dbec = 'IsNan';
const $9eb67d14d350b8ec$export$f0c7162bb7af1a2d = 'LeakyRelu';
const $9eb67d14d350b8ec$export$728c50f1c88ac779 = 'Less';
const $9eb67d14d350b8ec$export$84afd0d8f7fb8c5d = 'LessEqual';
const $9eb67d14d350b8ec$export$34f0ab8eba543ee6 = 'LinSpace';
const $9eb67d14d350b8ec$export$ce30dbb46644d06c = 'Log';
const $9eb67d14d350b8ec$export$70f05bf9ddcfca68 = 'Log1p';
const $9eb67d14d350b8ec$export$8a27ff10dff4d6e5 = 'LogicalAnd';
const $9eb67d14d350b8ec$export$4393bee5596c68c2 = 'LogicalNot';
const $9eb67d14d350b8ec$export$c49f9f5ffc6f678c = 'LogicalOr';
const $9eb67d14d350b8ec$export$656629b293485eff = 'LogicalXor';
const $9eb67d14d350b8ec$export$85b5bcbd60848a10 = 'LogSoftmax';
const $9eb67d14d350b8ec$export$9ec35fe80d53e931 = 'LowerBound';
const $9eb67d14d350b8ec$export$eb2f713fc3e1ca9a = 'LRN';
const $9eb67d14d350b8ec$export$73ba43cd0ce95b10 = 'LRNGrad';
const $9eb67d14d350b8ec$export$d36c09e5d02927e7 = 'Max';
const $9eb67d14d350b8ec$export$d8d02ac92d161004 = 'Maximum';
const $9eb67d14d350b8ec$export$39ea33024ddd5cf = 'MaxPool';
const $9eb67d14d350b8ec$export$f0f010b1d1db8a46 = 'MaxPoolGrad';
const $9eb67d14d350b8ec$export$88fdc64af890fc53 = 'MaxPool3D';
const $9eb67d14d350b8ec$export$52be2c00371a1350 = 'MaxPool3DGrad';
const $9eb67d14d350b8ec$export$deac4b7497b4047f = 'MaxPoolWithArgmax';
const $9eb67d14d350b8ec$export$1c2d59c4b681fbd8 = 'Mean';
const $9eb67d14d350b8ec$export$dfed19fabc75a31d = 'Min';
const $9eb67d14d350b8ec$export$23cb308301e89d6b = 'Minimum';
const $9eb67d14d350b8ec$export$f4c0e95fd7fd31e5 = 'MirrorPad';
const $9eb67d14d350b8ec$export$e4835a5e3f3674d5 = 'Mod';
const $9eb67d14d350b8ec$export$ee0a8cfb693e0e3f = 'Multinomial';
const $9eb67d14d350b8ec$export$f14f83b3b531d498 = 'Multiply';
const $9eb67d14d350b8ec$export$c07c549000872073 = 'Neg';
const $9eb67d14d350b8ec$export$385ebe9945cae0c5 = 'NotEqual';
const $9eb67d14d350b8ec$export$5e11788439c2f04 = 'NonMaxSuppressionV3';
const $9eb67d14d350b8ec$export$7df908154366fe7f = 'NonMaxSuppressionV4';
const $9eb67d14d350b8ec$export$cb45d3fcefce2ef0 = 'NonMaxSuppressionV5';
const $9eb67d14d350b8ec$export$a2962e735c809d91 = 'OnesLike';
const $9eb67d14d350b8ec$export$18982b43ba8c02e9 = 'OneHot';
const $9eb67d14d350b8ec$export$c26f40b29201e5b7 = 'Pack';
const $9eb67d14d350b8ec$export$5d47ba206577f0f2 = 'PadV2';
const $9eb67d14d350b8ec$export$14963ee5c8637e11 = 'Pool';
const $9eb67d14d350b8ec$export$ce28d653ec559ee = 'Pow';
const $9eb67d14d350b8ec$export$a42f35f308fc2fa3 = 'Prelu';
const $9eb67d14d350b8ec$export$b8a16d526a791fb0 = 'Prod';
const $9eb67d14d350b8ec$export$ffee9c5b4fce08a1 = 'RaggedGather';
const $9eb67d14d350b8ec$export$616d73a9ab7617c7 = 'RaggedTensorToTensor';
const $9eb67d14d350b8ec$export$9a58ef0d7ad3278c = 'Range';
const $9eb67d14d350b8ec$export$f41305719b94e675 = 'Real';
const $9eb67d14d350b8ec$export$c6e4a23ed5e0415b = 'Reciprocal';
const $9eb67d14d350b8ec$export$9a6ff968bf961432 = 'Relu';
const $9eb67d14d350b8ec$export$755ddd847e5abe03 = 'Reshape';
const $9eb67d14d350b8ec$export$6c8d8ec26192bb18 = 'ResizeNearestNeighbor';
const $9eb67d14d350b8ec$export$b84ac31c55aa023b = 'ResizeNearestNeighborGrad';
const $9eb67d14d350b8ec$export$24f2f15d869e0fd = 'ResizeBilinear';
const $9eb67d14d350b8ec$export$2d3cf759f1538c13 = 'ResizeBilinearGrad';
const $9eb67d14d350b8ec$export$3be9e924f629054e = 'Relu6';
const $9eb67d14d350b8ec$export$53c81f36b32e1bba = 'Reverse';
const $9eb67d14d350b8ec$export$c5ed3eef16c0612f = 'Round';
const $9eb67d14d350b8ec$export$7cc53aa09f5f3a2d = 'Rsqrt';
const $9eb67d14d350b8ec$export$28eef6f0168af686 = 'ScatterNd';
const $9eb67d14d350b8ec$export$9a1405490b09867e = 'SearchSorted';
const $9eb67d14d350b8ec$export$ef9b1a59e592288f = 'Select';
const $9eb67d14d350b8ec$export$6760d858e6f2594a = 'Selu';
const $9eb67d14d350b8ec$export$b3f2e2de3a8baa1e = 'Slice';
const $9eb67d14d350b8ec$export$75be1b631f7687 = 'Sin';
const $9eb67d14d350b8ec$export$b8c187376329d79b = 'Sinh';
const $9eb67d14d350b8ec$export$1db683ad541682f6 = 'Sign';
const $9eb67d14d350b8ec$export$fde18c826dda6b1b = 'Sigmoid';
const $9eb67d14d350b8ec$export$c5af433747f1fd0a = 'Softplus';
const $9eb67d14d350b8ec$export$21ab404ab9d512a6 = 'Sqrt';
const $9eb67d14d350b8ec$export$534760f50726d5 = 'Sum';
const $9eb67d14d350b8ec$export$f63ac5409312707c = 'SpaceToBatchND';
const $9eb67d14d350b8ec$export$8dffabb4071f05aa = 'SplitV';
const $9eb67d14d350b8ec$export$350a526055d3ca6e = 'Softmax';
const $9eb67d14d350b8ec$export$8f1933853a5c8cca = 'SparseFillEmptyRows';
const $9eb67d14d350b8ec$export$f08f0dca44fa542 = 'SparseReshape';
const $9eb67d14d350b8ec$export$610b077aecc2447b = 'SparseSegmentMean';
const $9eb67d14d350b8ec$export$68351c28d7116b56 = 'SparseSegmentSum';
const $9eb67d14d350b8ec$export$2c426709a9332421 = 'SparseToDense';
const $9eb67d14d350b8ec$export$2f922d20d66089c6 = 'SquaredDifference';
const $9eb67d14d350b8ec$export$b09fb900337259de = 'Square';
const $9eb67d14d350b8ec$export$60c7f9ac271417a9 = 'StridedSlice';
const $9eb67d14d350b8ec$export$11a7f4af7d96ad41 = 'StringNGrams';
const $9eb67d14d350b8ec$export$7e266f7223b9d396 = 'StringSplit';
const $9eb67d14d350b8ec$export$a5639899909bc8ae = 'StringToHashBucketFast';
const $9eb67d14d350b8ec$export$d7a01e11500dfb6f = 'Sub';
const $9eb67d14d350b8ec$export$115b2d5263ba5985 = 'Tan';
const $9eb67d14d350b8ec$export$893b6e865e352c83 = 'Tanh';
const $9eb67d14d350b8ec$export$235cb65c20ad2b7 = 'Tile';
const $9eb67d14d350b8ec$export$c593cd1ea0d02ebd = 'TopK';
const $9eb67d14d350b8ec$export$563a914cafbdc389 = 'Transform';
const $9eb67d14d350b8ec$export$7e714455f9a1f8f7 = 'Transpose';
const $9eb67d14d350b8ec$export$8e3adf126971a183 = 'Unique';
const $9eb67d14d350b8ec$export$441ad6bfc5db8ab4 = 'Unpack';
const $9eb67d14d350b8ec$export$af810663cded5fe2 = 'UnsortedSegmentSum';
const $9eb67d14d350b8ec$export$7dc194c8da2f9058 = 'UpperBound';
const $9eb67d14d350b8ec$export$430969a37eda1e88 = 'ZerosLike';
const $9eb67d14d350b8ec$export$fd55ce593607084a = 'Step';
const $9eb67d14d350b8ec$export$d0eb4e7054966c48 = 'FromPixels';
const $9eb67d14d350b8ec$export$c5a44649815d1c3 = 'RotateWithOffset';
const $9eb67d14d350b8ec$export$8d1af0f7c2a4da9e = '_FusedMatMul';
const $9eb67d14d350b8ec$export$86f8a8e3a8f2a8f2 = 'FusedConv2D';
const $9eb67d14d350b8ec$export$5a249e8f498c02c1 = 'FusedDepthwiseConv2D';

});

parcelRegister("kaJSw", function(module, exports) {

$parcel$export(module.exports, "getKernel", () => $eaf854520218dd03$export$1b85808c967cc434);
$parcel$export(module.exports, "getGradient", () => $eaf854520218dd03$export$e14995d3ec1747ee);
$parcel$export(module.exports, "getKernelsForBackend", () => $eaf854520218dd03$export$e4b8d76e176eaecc);
$parcel$export(module.exports, "registerKernel", () => $eaf854520218dd03$export$f3f7c443f3a606e6);
$parcel$export(module.exports, "registerGradient", () => $eaf854520218dd03$export$de9396b872fdfcc3);
$parcel$export(module.exports, "unregisterKernel", () => $eaf854520218dd03$export$1c3fb41896379a12);
$parcel$export(module.exports, "unregisterGradient", () => $eaf854520218dd03$export$41b3e24402efeb81);
$parcel$export(module.exports, "copyRegisteredKernels", () => $eaf854520218dd03$export$fb249e95c44186e6);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aymVi = parcelRequire("aymVi");

var $fRI13 = parcelRequire("fRI13");

var $1dbsU = parcelRequire("1dbsU");
const $eaf854520218dd03$var$kernelRegistry = (0, $fRI13.getGlobal)('kernelRegistry', ()=>new Map());
const $eaf854520218dd03$var$gradRegistry = (0, $fRI13.getGlobal)('gradRegistry', ()=>new Map());
function $eaf854520218dd03$export$1b85808c967cc434(kernelName, backendName) {
    const key = $eaf854520218dd03$var$makeKey(kernelName, backendName);
    return $eaf854520218dd03$var$kernelRegistry.get(key);
}
function $eaf854520218dd03$export$e14995d3ec1747ee(kernelName) {
    return $eaf854520218dd03$var$gradRegistry.get(kernelName);
}
function $eaf854520218dd03$export$e4b8d76e176eaecc(backendName) {
    const it = $eaf854520218dd03$var$kernelRegistry.entries();
    const result = [];
    while(true){
        const { done: done, value: value } = it.next();
        if (done) break;
        const [key, config] = value;
        const [backend] = key.split('_');
        if (backend === backendName) result.push(config);
    }
    return result;
}
function $eaf854520218dd03$export$f3f7c443f3a606e6(config) {
    const { kernelName: kernelName, backendName: backendName } = config;
    const key = $eaf854520218dd03$var$makeKey(kernelName, backendName);
    if ($eaf854520218dd03$var$kernelRegistry.has(key)) $1dbsU.warn(`The kernel '${kernelName}' for backend ` + `'${backendName}' is already registered`);
    $eaf854520218dd03$var$kernelRegistry.set(key, config);
}
function $eaf854520218dd03$export$de9396b872fdfcc3(config) {
    const { kernelName: kernelName } = config;
    if ($eaf854520218dd03$var$gradRegistry.has(kernelName)) // TODO (yassogba) after 3.0 assess whether we need to keep this gated
    // to debug mode.
    {
        if ((0, $aymVi.env)().getBool('DEBUG')) $1dbsU.warn(`Overriding the gradient for '${kernelName}'`);
    }
    $eaf854520218dd03$var$gradRegistry.set(kernelName, config);
}
function $eaf854520218dd03$export$1c3fb41896379a12(kernelName, backendName) {
    const key = $eaf854520218dd03$var$makeKey(kernelName, backendName);
    if (!$eaf854520218dd03$var$kernelRegistry.has(key)) throw new Error(`The kernel '${kernelName}' for backend ` + `'${backendName}' is not registered`);
    $eaf854520218dd03$var$kernelRegistry.delete(key);
}
function $eaf854520218dd03$export$41b3e24402efeb81(kernelName) {
    if (!$eaf854520218dd03$var$gradRegistry.has(kernelName)) throw new Error(`The gradient '${kernelName}' for backend is not registered`);
    $eaf854520218dd03$var$gradRegistry.delete(kernelName);
}
function $eaf854520218dd03$export$fb249e95c44186e6(registeredBackendName, newBackendName) {
    const kernels = $eaf854520218dd03$export$e4b8d76e176eaecc(registeredBackendName);
    kernels.forEach((kernelConfig)=>{
        const newKernelConfig = Object.assign({}, kernelConfig, {
            backendName: newBackendName
        });
        $eaf854520218dd03$export$f3f7c443f3a606e6(newKernelConfig);
    });
}
function $eaf854520218dd03$var$makeKey(kernelName, backendName) {
    return `${backendName}_${kernelName}`;
}

});
parcelRegister("1dbsU", function(module, exports) {

$parcel$export(module.exports, "warn", () => $0e1fe61b37316b49$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "log", () => $0e1fe61b37316b49$export$bef1f36f5486a6a3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aymVi = parcelRequire("aymVi");
function $0e1fe61b37316b49$export$c106dd0671a0fc2d(...msg) {
    if (!((0, $aymVi.env)().getBool('IS_TEST') || (0, $aymVi.env)().getBool('PROD'))) console.warn(...msg);
}
function $0e1fe61b37316b49$export$bef1f36f5486a6a3(...msg) {
    if (!((0, $aymVi.env)().getBool('IS_TEST') || (0, $aymVi.env)().getBool('PROD'))) console.log(...msg);
}

});


parcelRegister("14dYy", function(module, exports) {

$parcel$export(module.exports, "Profiler", () => $0c710173a01d8080$export$e2c29f18771995cb);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aymVi = parcelRequire("aymVi");

var $wx9lK = parcelRequire("wx9lK");
var $4tCOB = parcelRequire("4tCOB");
class $0c710173a01d8080$export$e2c29f18771995cb {
    constructor(backendTimer, logger){
        this.backendTimer = backendTimer;
        this.logger = logger;
        if (logger == null) this.logger = new $0c710173a01d8080$export$efa9a398d6368992();
    }
    profileKernel(kernelName, inputs, f) {
        let outputs;
        const holdResultWrapperFn = ()=>{
            outputs = f();
        };
        let timer;
        const start = $wx9lK.now();
        if (this.backendTimer.timerAvailable()) timer = this.backendTimer.time(holdResultWrapperFn);
        else {
            holdResultWrapperFn();
            for (const output of outputs)output.dataSync();
            timer = Promise.resolve({
                kernelMs: $wx9lK.now() - start
            });
        }
        if ((0, $aymVi.env)().getBool('CHECK_COMPUTATION_FOR_ERRORS')) for(let i = 0; i < outputs.length; i++){
            const output = outputs[i];
            // Dangling promise here because we don't want to propagate up
            // asynchronicity.
            output.data().then((tensorVals)=>{
                $0c710173a01d8080$export$7f6e9a47e989eedc(tensorVals, output.dtype, kernelName);
            });
        }
        const kernelProfile = {
            kernelName: kernelName,
            outputs: outputs,
            inputs: inputs,
            timeMs: timer.then((timing)=>timing.kernelMs),
            extraInfo: timer.then((timing)=>timing.getExtraProfileInfo != null ? timing.getExtraProfileInfo() : '')
        };
        return kernelProfile;
    }
    logKernelProfile(kernelProfile) {
        const { kernelName: kernelName, outputs: outputs, timeMs: timeMs, inputs: inputs, extraInfo: extraInfo } = kernelProfile;
        outputs.forEach((result)=>{
            Promise.all([
                result.data(),
                timeMs,
                extraInfo
            ]).then((valueContainer)=>{
                this.logger.logKernelProfile(kernelName, result, valueContainer[0], valueContainer[1], inputs, valueContainer[2]);
            });
        });
    }
}
function $0c710173a01d8080$export$7f6e9a47e989eedc(vals, dtype, kernelName) {
    if (dtype !== 'float32') // Only floating point computations will generate NaN values
    return false;
    for(let i = 0; i < vals.length; i++){
        const num = vals[i];
        if (isNaN(num) || !isFinite(num)) {
            // Throwing custom exception so behavior is testable.
            console.warn(`Found ${num} in the result of '${kernelName}'`);
            return true;
        }
    }
    return false;
}
class $0c710173a01d8080$export$efa9a398d6368992 {
    logKernelProfile(name, result, vals, timeMs, inputs, extraInfo) {
        const time = typeof timeMs === 'number' ? $4tCOB.rightPad(`${timeMs}ms`, 9) : timeMs['error'];
        const paddedName = $4tCOB.rightPad(name, 25);
        const rank = result.rank;
        const size = result.size;
        const shape = $4tCOB.rightPad(result.shape.toString(), 14);
        let inputShapesDescription = '';
        for(const name in inputs){
            const input = inputs[name];
            if (input != null) {
                // The input might be a non-tensor (e.g HTMLImageElement), in which case
                // we claim the output shape as input shape.
                const inputShape = input.shape || result.shape;
                const inputRank = inputShape.length;
                inputShapesDescription += `${name}: ${inputRank}D ${inputRank > 0 ? inputShape : ''} `;
            }
        }
        console.log(`%c${paddedName}\t%c${time}\t%c${rank}D ${shape}\t%c${size}\t%c${inputShapesDescription}\t%c${extraInfo}`, 'font-weight:bold', 'color:red', 'color:blue', 'color: orange', 'color: green', 'color: steelblue');
    }
}

});
parcelRegister("wx9lK", function(module, exports) {

$parcel$export(module.exports, "createScalarValue", () => $061cb4223a656704$export$cd3f28d8002ec2a2);
$parcel$export(module.exports, "encodeString", () => $061cb4223a656704$export$8146d2e653b87d6a);
$parcel$export(module.exports, "toTypedArray", () => $061cb4223a656704$export$965adc581230795c);
$parcel$export(module.exports, "now", () => $061cb4223a656704$export$461939dd4422153);
$parcel$export(module.exports, "fetch", () => $061cb4223a656704$export$e7aa7bc5c1b3cfb3);
$parcel$export(module.exports, "decodeString", () => $061cb4223a656704$export$a0fb664af7d0cc44);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aymVi = parcelRequire("aymVi");

var $4tCOB = parcelRequire("4tCOB");

var $j42p3 = parcelRequire("j42p3");
function $061cb4223a656704$export$cd3f28d8002ec2a2(value, dtype) {
    if (dtype === 'string') return $061cb4223a656704$export$8146d2e653b87d6a(value);
    return $061cb4223a656704$export$965adc581230795c([
        value
    ], dtype);
}
function $061cb4223a656704$var$noConversionNeeded(a, dtype) {
    return a instanceof Float32Array && dtype === 'float32' || a instanceof Int32Array && dtype === 'int32' || a instanceof Uint8Array && dtype === 'bool';
}
function $061cb4223a656704$export$965adc581230795c(a, dtype) {
    if (dtype === 'string') throw new Error('Cannot convert a string[] to a TypedArray');
    if (Array.isArray(a)) a = $4tCOB.flatten(a);
    if ((0, $aymVi.env)().getBool('DEBUG')) $4tCOB.checkConversionForErrors(a, dtype);
    if ($061cb4223a656704$var$noConversionNeeded(a, dtype)) return a;
    if (dtype == null || dtype === 'float32' || dtype === 'complex64') return new Float32Array(a);
    else if (dtype === 'int32') return new Int32Array(a);
    else if (dtype === 'bool') {
        const bool = new Uint8Array(a.length);
        for(let i = 0; i < bool.length; ++i)if (Math.round(a[i]) !== 0) bool[i] = 1;
        return bool;
    } else throw new Error(`Unknown data type ${dtype}`);
}
function $061cb4223a656704$export$461939dd4422153() {
    return (0, $aymVi.env)().platform.now();
}
function $061cb4223a656704$export$e7aa7bc5c1b3cfb3(path, requestInits) {
    return (0, $aymVi.env)().platform.fetch(path, requestInits);
}
function $061cb4223a656704$export$8146d2e653b87d6a(s, encoding = 'utf-8') {
    encoding = encoding || 'utf-8';
    return (0, $aymVi.env)().platform.encode(s, encoding);
}
function $061cb4223a656704$export$a0fb664af7d0cc44(bytes, encoding = 'utf-8') {
    encoding = encoding || 'utf-8';
    return (0, $aymVi.env)().platform.decode(bytes, encoding);
}
$parcel$exportWildcard(module.exports, $4tCOB);
$parcel$exportWildcard(module.exports, $j42p3);

});
parcelRegister("j42p3", function(module, exports) {

$parcel$export(module.exports, "hexToLong", () => $de10413e4e5e1694$export$20e49d17901a85a5);
$parcel$export(module.exports, "fingerPrint64", () => $de10413e4e5e1694$export$919ee948dc019032);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Workaround for allowing cjs module to be included in bundle created by
// rollup.

var $hQ89b = parcelRequire("hQ89b");
// tslint:disable-next-line
const $de10413e4e5e1694$var$Long = // tslint:disable-next-line
$hQ89b.default || $hQ89b;
function $de10413e4e5e1694$export$20e49d17901a85a5(hex) {
    return $de10413e4e5e1694$var$Long.fromString(hex, true, 16);
}
// Some primes between 2^63 and 2^64 for various uses.
// Hex 0xc3a5c85c97cb3127
const $de10413e4e5e1694$var$k0 = $de10413e4e5e1694$export$20e49d17901a85a5('c3a5c85c97cb3127');
// Hex 0xb492b66fbe98f273
const $de10413e4e5e1694$var$k1 = $de10413e4e5e1694$export$20e49d17901a85a5('b492b66fbe98f273');
// Hex 0x9ae16a3b2f90404f
const $de10413e4e5e1694$var$k2 = $de10413e4e5e1694$export$20e49d17901a85a5('9ae16a3b2f90404f');
function $de10413e4e5e1694$var$shiftMix(val) {
    return val.xor(val.shru(47));
}
function $de10413e4e5e1694$var$fetch(s, offset, numBytes) {
    const bytes = s.slice(offset, offset + numBytes);
    return $de10413e4e5e1694$var$Long.fromBytes(Array.from(bytes), true, true);
}
function $de10413e4e5e1694$var$fetch64(s, offset) {
    return $de10413e4e5e1694$var$fetch(s, offset, 8);
}
function $de10413e4e5e1694$var$fetch32(s, offset) {
    return $de10413e4e5e1694$var$fetch(s, offset, 4);
}
function $de10413e4e5e1694$var$rotate64(val, shift) {
    // Avoid shifting by 64: doing so yields an undefined result.
    return shift === 0 ? val : val.shru(shift).or(val.shl(64 - shift));
}
function $de10413e4e5e1694$var$hashLen16(u, v, mul = $de10413e4e5e1694$export$20e49d17901a85a5('9ddfea08eb382d69')) {
    // Murmur-inspired hashing.
    let a = u.xor(v).mul(mul);
    a = a.xor(a.shru(47));
    let b = v.xor(a).mul(mul);
    b = b.xor(b.shru(47));
    b = b.mul(mul);
    return b;
}
// Return a 16-byte hash for 48 bytes.  Quick and dirty.
// Callers do best to use "random-looking" values for a and b.
function $de10413e4e5e1694$var$weakHashLen32WithSeeds(w, x, y, z, a, b) {
    a = a.add(w);
    b = $de10413e4e5e1694$var$rotate64(b.add(a).add(z), 21);
    const c = a;
    a = a.add(x);
    a = a.add(y);
    b = b.add($de10413e4e5e1694$var$rotate64(a, 44));
    return [
        a.add(z),
        b.add(c)
    ];
}
function $de10413e4e5e1694$var$weakHashLen32WithSeedsStr(s, offset, a, b) {
    return $de10413e4e5e1694$var$weakHashLen32WithSeeds($de10413e4e5e1694$var$fetch64(s, offset), $de10413e4e5e1694$var$fetch64(s, offset + 8), $de10413e4e5e1694$var$fetch64(s, offset + 16), $de10413e4e5e1694$var$fetch64(s, offset + 24), a, b);
}
function $de10413e4e5e1694$var$hashLen0to16(s, len = s.length) {
    if (len >= 8) {
        const mul = $de10413e4e5e1694$var$k2.add(len * 2);
        const a = $de10413e4e5e1694$var$fetch64(s, 0).add($de10413e4e5e1694$var$k2);
        const b = $de10413e4e5e1694$var$fetch64(s, len - 8);
        const c = $de10413e4e5e1694$var$rotate64(b, 37).mul(mul).add(a);
        const d = $de10413e4e5e1694$var$rotate64(a, 25).add(b).mul(mul);
        return $de10413e4e5e1694$var$hashLen16(c, d, mul);
    }
    if (len >= 4) {
        const mul = $de10413e4e5e1694$var$k2.add(len * 2);
        const a = $de10413e4e5e1694$var$fetch32(s, 0);
        return $de10413e4e5e1694$var$hashLen16(a.shl(3).add(len), $de10413e4e5e1694$var$fetch32(s, len - 4), mul);
    }
    if (len > 0) {
        const a = s[0];
        const b = s[len >> 1];
        const c = s[len - 1];
        const y = a + (b << 8);
        const z = len + (c << 2);
        return $de10413e4e5e1694$var$shiftMix($de10413e4e5e1694$var$k2.mul(y).xor($de10413e4e5e1694$var$k0.mul(z))).mul($de10413e4e5e1694$var$k2);
    }
    return $de10413e4e5e1694$var$k2;
}
function $de10413e4e5e1694$var$hashLen17to32(s, len = s.length) {
    const mul = $de10413e4e5e1694$var$k2.add(len * 2);
    const a = $de10413e4e5e1694$var$fetch64(s, 0).mul($de10413e4e5e1694$var$k1);
    const b = $de10413e4e5e1694$var$fetch64(s, 8);
    const c = $de10413e4e5e1694$var$fetch64(s, len - 8).mul(mul);
    const d = $de10413e4e5e1694$var$fetch64(s, len - 16).mul($de10413e4e5e1694$var$k2);
    return $de10413e4e5e1694$var$hashLen16($de10413e4e5e1694$var$rotate64(a.add(b), 43).add($de10413e4e5e1694$var$rotate64(c, 30)).add(d), a.add($de10413e4e5e1694$var$rotate64(b.add($de10413e4e5e1694$var$k2), 18)).add(c), mul);
}
function $de10413e4e5e1694$var$hashLen33to64(s, len = s.length) {
    const mul = $de10413e4e5e1694$var$k2.add(len * 2);
    const a = $de10413e4e5e1694$var$fetch64(s, 0).mul($de10413e4e5e1694$var$k2);
    const b = $de10413e4e5e1694$var$fetch64(s, 8);
    const c = $de10413e4e5e1694$var$fetch64(s, len - 8).mul(mul);
    const d = $de10413e4e5e1694$var$fetch64(s, len - 16).mul($de10413e4e5e1694$var$k2);
    const y = $de10413e4e5e1694$var$rotate64(a.add(b), 43).add($de10413e4e5e1694$var$rotate64(c, 30)).add(d);
    const z = $de10413e4e5e1694$var$hashLen16(y, a.add($de10413e4e5e1694$var$rotate64(b.add($de10413e4e5e1694$var$k2), 18)).add(c), mul);
    const e = $de10413e4e5e1694$var$fetch64(s, 16).mul(mul);
    const f = $de10413e4e5e1694$var$fetch64(s, 24);
    const g = y.add($de10413e4e5e1694$var$fetch64(s, len - 32)).mul(mul);
    const h = z.add($de10413e4e5e1694$var$fetch64(s, len - 24)).mul(mul);
    return $de10413e4e5e1694$var$hashLen16($de10413e4e5e1694$var$rotate64(e.add(f), 43).add($de10413e4e5e1694$var$rotate64(g, 30)).add(h), e.add($de10413e4e5e1694$var$rotate64(f.add(a), 18)).add(g), mul);
}
function $de10413e4e5e1694$export$919ee948dc019032(s, len = s.length) {
    const seed = $de10413e4e5e1694$var$Long.fromNumber(81, true);
    if (len <= 32) {
        if (len <= 16) return $de10413e4e5e1694$var$hashLen0to16(s, len);
        else return $de10413e4e5e1694$var$hashLen17to32(s, len);
    } else if (len <= 64) return $de10413e4e5e1694$var$hashLen33to64(s, len);
    // For strings over 64 bytes we loop.  Internal state consists of
    // 56 bytes: v, w, x, y, and z.
    let x = seed;
    let y = seed.mul($de10413e4e5e1694$var$k1).add(113);
    let z = $de10413e4e5e1694$var$shiftMix(y.mul($de10413e4e5e1694$var$k2).add(113)).mul($de10413e4e5e1694$var$k2);
    let v = [
        $de10413e4e5e1694$var$Long.UZERO,
        $de10413e4e5e1694$var$Long.UZERO
    ];
    let w = [
        $de10413e4e5e1694$var$Long.UZERO,
        $de10413e4e5e1694$var$Long.UZERO
    ];
    x = x.mul($de10413e4e5e1694$var$k2).add($de10413e4e5e1694$var$fetch64(s, 0));
    let offset = 0;
    // Set end so that after the loop we have 1 to 64 bytes left to process.
    const end = (len - 1 >> 6) * 64;
    const last64 = end + (len - 1 & 63) - 63;
    do {
        x = $de10413e4e5e1694$var$rotate64(x.add(y).add(v[0]).add($de10413e4e5e1694$var$fetch64(s, offset + 8)), 37).mul($de10413e4e5e1694$var$k1);
        y = $de10413e4e5e1694$var$rotate64(y.add(v[1]).add($de10413e4e5e1694$var$fetch64(s, offset + 48)), 42).mul($de10413e4e5e1694$var$k1);
        x = x.xor(w[1]);
        y = y.add(v[0]).add($de10413e4e5e1694$var$fetch64(s, offset + 40));
        z = $de10413e4e5e1694$var$rotate64(z.add(w[0]), 33).mul($de10413e4e5e1694$var$k1);
        v = $de10413e4e5e1694$var$weakHashLen32WithSeedsStr(s, offset, v[1].mul($de10413e4e5e1694$var$k1), x.add(w[0]));
        w = $de10413e4e5e1694$var$weakHashLen32WithSeedsStr(s, offset + 32, z.add(w[1]), y.add($de10413e4e5e1694$var$fetch64(s, offset + 16)));
        [z, x] = [
            x,
            z
        ];
        offset += 64;
    }while (offset !== end);
    const mul = $de10413e4e5e1694$var$k1.add(z.and(0xff).shl(1));
    // Point to the last 64 bytes of input.
    offset = last64;
    w[0] = w[0].add(len - 1 & 63);
    v[0] = v[0].add(w[0]);
    w[0] = w[0].add(v[0]);
    x = $de10413e4e5e1694$var$rotate64(x.add(y).add(v[0]).add($de10413e4e5e1694$var$fetch64(s, offset + 8)), 37).mul(mul);
    y = $de10413e4e5e1694$var$rotate64(y.add(v[1]).add($de10413e4e5e1694$var$fetch64(s, offset + 48)), 42).mul(mul);
    x = x.xor(w[1].mul(9));
    y = y.add(v[0].mul(9).add($de10413e4e5e1694$var$fetch64(s, offset + 40)));
    z = $de10413e4e5e1694$var$rotate64(z.add(w[0]), 33).mul(mul);
    v = $de10413e4e5e1694$var$weakHashLen32WithSeedsStr(s, offset, v[1].mul(mul), x.add(w[0]));
    w = $de10413e4e5e1694$var$weakHashLen32WithSeedsStr(s, offset + 32, z.add(w[1]), y.add($de10413e4e5e1694$var$fetch64(s, offset + 16)));
    [z, x] = [
        x,
        z
    ];
    return $de10413e4e5e1694$var$hashLen16($de10413e4e5e1694$var$hashLen16(v[0], w[0], mul).add($de10413e4e5e1694$var$shiftMix(y).mul($de10413e4e5e1694$var$k0)).add(z), $de10413e4e5e1694$var$hashLen16(v[1], w[1], mul).add(x), mul);
}

});
parcelRegister("hQ89b", function(module, exports) {
module.exports = $035a06a8b28ed0fd$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $035a06a8b28ed0fd$var$wasm = null;
try {
    $035a06a8b28ed0fd$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $035a06a8b28ed0fd$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $035a06a8b28ed0fd$var$Long.prototype.__isLong__;
Object.defineProperty($035a06a8b28ed0fd$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $035a06a8b28ed0fd$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$Long.isLong = $035a06a8b28ed0fd$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $035a06a8b28ed0fd$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $035a06a8b28ed0fd$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $035a06a8b28ed0fd$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $035a06a8b28ed0fd$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $035a06a8b28ed0fd$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $035a06a8b28ed0fd$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $035a06a8b28ed0fd$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $035a06a8b28ed0fd$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $035a06a8b28ed0fd$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromInt = $035a06a8b28ed0fd$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $035a06a8b28ed0fd$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $035a06a8b28ed0fd$var$UZERO : $035a06a8b28ed0fd$var$ZERO;
    if (unsigned) {
        if (value < 0) return $035a06a8b28ed0fd$var$UZERO;
        if (value >= $035a06a8b28ed0fd$var$TWO_PWR_64_DBL) return $035a06a8b28ed0fd$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$035a06a8b28ed0fd$var$TWO_PWR_63_DBL) return $035a06a8b28ed0fd$var$MIN_VALUE;
        if (value + 1 >= $035a06a8b28ed0fd$var$TWO_PWR_63_DBL) return $035a06a8b28ed0fd$var$MAX_VALUE;
    }
    if (value < 0) return $035a06a8b28ed0fd$var$fromNumber(-value, unsigned).neg();
    return $035a06a8b28ed0fd$var$fromBits(value % $035a06a8b28ed0fd$var$TWO_PWR_32_DBL | 0, value / $035a06a8b28ed0fd$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromNumber = $035a06a8b28ed0fd$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $035a06a8b28ed0fd$var$fromBits(lowBits, highBits, unsigned) {
    return new $035a06a8b28ed0fd$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromBits = $035a06a8b28ed0fd$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $035a06a8b28ed0fd$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $035a06a8b28ed0fd$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error('empty string');
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $035a06a8b28ed0fd$var$ZERO;
    if (typeof unsigned === 'number') // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    var p;
    if ((p = str.indexOf('-')) > 0) throw Error('interior hyphen');
    else if (p === 0) return $035a06a8b28ed0fd$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $035a06a8b28ed0fd$var$fromNumber($035a06a8b28ed0fd$var$pow_dbl(radix, 8));
    var result = $035a06a8b28ed0fd$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $035a06a8b28ed0fd$var$fromNumber($035a06a8b28ed0fd$var$pow_dbl(radix, size));
            result = result.mul(power).add($035a06a8b28ed0fd$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($035a06a8b28ed0fd$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromString = $035a06a8b28ed0fd$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $035a06a8b28ed0fd$var$fromValue(val, unsigned) {
    if (typeof val === 'number') return $035a06a8b28ed0fd$var$fromNumber(val, unsigned);
    if (typeof val === 'string') return $035a06a8b28ed0fd$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $035a06a8b28ed0fd$var$fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $035a06a8b28ed0fd$var$Long.fromValue = $035a06a8b28ed0fd$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $035a06a8b28ed0fd$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $035a06a8b28ed0fd$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $035a06a8b28ed0fd$var$TWO_PWR_32_DBL = $035a06a8b28ed0fd$var$TWO_PWR_16_DBL * $035a06a8b28ed0fd$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $035a06a8b28ed0fd$var$TWO_PWR_64_DBL = $035a06a8b28ed0fd$var$TWO_PWR_32_DBL * $035a06a8b28ed0fd$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $035a06a8b28ed0fd$var$TWO_PWR_63_DBL = $035a06a8b28ed0fd$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $035a06a8b28ed0fd$var$TWO_PWR_24 = $035a06a8b28ed0fd$var$fromInt($035a06a8b28ed0fd$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$ZERO = $035a06a8b28ed0fd$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.ZERO = $035a06a8b28ed0fd$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$UZERO = $035a06a8b28ed0fd$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.UZERO = $035a06a8b28ed0fd$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$ONE = $035a06a8b28ed0fd$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.ONE = $035a06a8b28ed0fd$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$UONE = $035a06a8b28ed0fd$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.UONE = $035a06a8b28ed0fd$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$NEG_ONE = $035a06a8b28ed0fd$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.NEG_ONE = $035a06a8b28ed0fd$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$MAX_VALUE = $035a06a8b28ed0fd$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.MAX_VALUE = $035a06a8b28ed0fd$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$MAX_UNSIGNED_VALUE = $035a06a8b28ed0fd$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.MAX_UNSIGNED_VALUE = $035a06a8b28ed0fd$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $035a06a8b28ed0fd$var$MIN_VALUE = $035a06a8b28ed0fd$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $035a06a8b28ed0fd$var$Long.MIN_VALUE = $035a06a8b28ed0fd$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $035a06a8b28ed0fd$var$LongPrototype = $035a06a8b28ed0fd$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $035a06a8b28ed0fd$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $035a06a8b28ed0fd$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $035a06a8b28ed0fd$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $035a06a8b28ed0fd$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $035a06a8b28ed0fd$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    if (this.isZero()) return '0';
    if (this.isNegative()) {
        if (this.eq($035a06a8b28ed0fd$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $035a06a8b28ed0fd$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return '-' + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $035a06a8b28ed0fd$var$fromNumber($035a06a8b28ed0fd$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = '';
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = '0' + digits;
            result = '' + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $035a06a8b28ed0fd$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $035a06a8b28ed0fd$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $035a06a8b28ed0fd$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $035a06a8b28ed0fd$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $035a06a8b28ed0fd$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($035a06a8b28ed0fd$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.eqz = $035a06a8b28ed0fd$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.equals = function equals(other) {
    if (!$035a06a8b28ed0fd$var$isLong(other)) other = $035a06a8b28ed0fd$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.eq = $035a06a8b28ed0fd$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.neq = $035a06a8b28ed0fd$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.ne = $035a06a8b28ed0fd$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.lt = $035a06a8b28ed0fd$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.lte = $035a06a8b28ed0fd$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.le = $035a06a8b28ed0fd$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.gt = $035a06a8b28ed0fd$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.gte = $035a06a8b28ed0fd$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $035a06a8b28ed0fd$var$LongPrototype.ge = $035a06a8b28ed0fd$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $035a06a8b28ed0fd$var$LongPrototype.compare = function compare(other) {
    if (!$035a06a8b28ed0fd$var$isLong(other)) other = $035a06a8b28ed0fd$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $035a06a8b28ed0fd$var$LongPrototype.comp = $035a06a8b28ed0fd$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $035a06a8b28ed0fd$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($035a06a8b28ed0fd$var$MIN_VALUE)) return $035a06a8b28ed0fd$var$MIN_VALUE;
    return this.not().add($035a06a8b28ed0fd$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $035a06a8b28ed0fd$var$LongPrototype.neg = $035a06a8b28ed0fd$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $035a06a8b28ed0fd$var$LongPrototype.add = function add(addend) {
    if (!$035a06a8b28ed0fd$var$isLong(addend)) addend = $035a06a8b28ed0fd$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $035a06a8b28ed0fd$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $035a06a8b28ed0fd$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$035a06a8b28ed0fd$var$isLong(subtrahend)) subtrahend = $035a06a8b28ed0fd$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $035a06a8b28ed0fd$var$LongPrototype.sub = $035a06a8b28ed0fd$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $035a06a8b28ed0fd$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $035a06a8b28ed0fd$var$ZERO;
    if (!$035a06a8b28ed0fd$var$isLong(multiplier)) multiplier = $035a06a8b28ed0fd$var$fromValue(multiplier);
    // use wasm support if present
    if ($035a06a8b28ed0fd$var$wasm) {
        var low = $035a06a8b28ed0fd$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $035a06a8b28ed0fd$var$fromBits(low, $035a06a8b28ed0fd$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $035a06a8b28ed0fd$var$ZERO;
    if (this.eq($035a06a8b28ed0fd$var$MIN_VALUE)) return multiplier.isOdd() ? $035a06a8b28ed0fd$var$MIN_VALUE : $035a06a8b28ed0fd$var$ZERO;
    if (multiplier.eq($035a06a8b28ed0fd$var$MIN_VALUE)) return this.isOdd() ? $035a06a8b28ed0fd$var$MIN_VALUE : $035a06a8b28ed0fd$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($035a06a8b28ed0fd$var$TWO_PWR_24) && multiplier.lt($035a06a8b28ed0fd$var$TWO_PWR_24)) return $035a06a8b28ed0fd$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $035a06a8b28ed0fd$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $035a06a8b28ed0fd$var$LongPrototype.mul = $035a06a8b28ed0fd$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $035a06a8b28ed0fd$var$LongPrototype.divide = function divide(divisor) {
    if (!$035a06a8b28ed0fd$var$isLong(divisor)) divisor = $035a06a8b28ed0fd$var$fromValue(divisor);
    if (divisor.isZero()) throw Error('division by zero');
    // use wasm support if present
    if ($035a06a8b28ed0fd$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $035a06a8b28ed0fd$var$wasm.div_u : $035a06a8b28ed0fd$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $035a06a8b28ed0fd$var$fromBits(low, $035a06a8b28ed0fd$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $035a06a8b28ed0fd$var$UZERO : $035a06a8b28ed0fd$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($035a06a8b28ed0fd$var$MIN_VALUE)) {
            if (divisor.eq($035a06a8b28ed0fd$var$ONE) || divisor.eq($035a06a8b28ed0fd$var$NEG_ONE)) return $035a06a8b28ed0fd$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($035a06a8b28ed0fd$var$MIN_VALUE)) return $035a06a8b28ed0fd$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($035a06a8b28ed0fd$var$ZERO)) return divisor.isNegative() ? $035a06a8b28ed0fd$var$ONE : $035a06a8b28ed0fd$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($035a06a8b28ed0fd$var$MIN_VALUE)) return this.unsigned ? $035a06a8b28ed0fd$var$UZERO : $035a06a8b28ed0fd$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $035a06a8b28ed0fd$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $035a06a8b28ed0fd$var$UZERO;
        if (divisor.gt(this.shru(1))) return $035a06a8b28ed0fd$var$UONE;
        res = $035a06a8b28ed0fd$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $035a06a8b28ed0fd$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $035a06a8b28ed0fd$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $035a06a8b28ed0fd$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $035a06a8b28ed0fd$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $035a06a8b28ed0fd$var$LongPrototype.div = $035a06a8b28ed0fd$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $035a06a8b28ed0fd$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$035a06a8b28ed0fd$var$isLong(divisor)) divisor = $035a06a8b28ed0fd$var$fromValue(divisor);
    // use wasm support if present
    if ($035a06a8b28ed0fd$var$wasm) {
        var low = (this.unsigned ? $035a06a8b28ed0fd$var$wasm.rem_u : $035a06a8b28ed0fd$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $035a06a8b28ed0fd$var$fromBits(low, $035a06a8b28ed0fd$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $035a06a8b28ed0fd$var$LongPrototype.mod = $035a06a8b28ed0fd$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $035a06a8b28ed0fd$var$LongPrototype.rem = $035a06a8b28ed0fd$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $035a06a8b28ed0fd$var$LongPrototype.not = function not() {
    return $035a06a8b28ed0fd$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $035a06a8b28ed0fd$var$LongPrototype.and = function and(other) {
    if (!$035a06a8b28ed0fd$var$isLong(other)) other = $035a06a8b28ed0fd$var$fromValue(other);
    return $035a06a8b28ed0fd$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $035a06a8b28ed0fd$var$LongPrototype.or = function or(other) {
    if (!$035a06a8b28ed0fd$var$isLong(other)) other = $035a06a8b28ed0fd$var$fromValue(other);
    return $035a06a8b28ed0fd$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $035a06a8b28ed0fd$var$LongPrototype.xor = function xor(other) {
    if (!$035a06a8b28ed0fd$var$isLong(other)) other = $035a06a8b28ed0fd$var$fromValue(other);
    return $035a06a8b28ed0fd$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($035a06a8b28ed0fd$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $035a06a8b28ed0fd$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $035a06a8b28ed0fd$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shl = $035a06a8b28ed0fd$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($035a06a8b28ed0fd$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $035a06a8b28ed0fd$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $035a06a8b28ed0fd$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shr = $035a06a8b28ed0fd$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($035a06a8b28ed0fd$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $035a06a8b28ed0fd$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $035a06a8b28ed0fd$var$fromBits(high, 0, this.unsigned);
        else return $035a06a8b28ed0fd$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shru = $035a06a8b28ed0fd$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $035a06a8b28ed0fd$var$LongPrototype.shr_u = $035a06a8b28ed0fd$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $035a06a8b28ed0fd$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $035a06a8b28ed0fd$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $035a06a8b28ed0fd$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $035a06a8b28ed0fd$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $035a06a8b28ed0fd$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $035a06a8b28ed0fd$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $035a06a8b28ed0fd$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $035a06a8b28ed0fd$var$Long.fromBytesLE(bytes, unsigned) : $035a06a8b28ed0fd$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $035a06a8b28ed0fd$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $035a06a8b28ed0fd$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $035a06a8b28ed0fd$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};

});




parcelRegister("196bZ", function(module, exports) {

$parcel$export(module.exports, "getFilteredNodesXToY", () => $0d5b6f608a76b290$export$13eebbb952f0db02);
$parcel$export(module.exports, "backpropagateGradients", () => $0d5b6f608a76b290$export$2992958ba0a8790d);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
function $0d5b6f608a76b290$export$13eebbb952f0db02(tape, xs, y) {
    // Forward pass to compute all the nodes and Tensors that are transitively a
    // function of x.
    const tensorsFromX = {};
    const nodesFromX = {};
    for(let i = 0; i < xs.length; i++)tensorsFromX[xs[i].id] = true;
    for(let i = 0; i < tape.length; i++){
        const node = tape[i];
        const nodeInputs = node.inputs;
        for(const inputName in nodeInputs){
            const input = nodeInputs[inputName];
            let anyInputFromX = false;
            for(let j = 0; j < xs.length; j++)if (tensorsFromX[input.id]) {
                node.outputs.forEach((output)=>tensorsFromX[output.id] = true);
                anyInputFromX = true;
                nodesFromX[node.id] = true;
                break;
            }
            if (anyInputFromX) break;
        }
    }
    // Backward pass to find all of the nodes and Tensors that lead to y.
    const tensorsLeadToY = {};
    tensorsLeadToY[y.id] = true;
    const nodesToY = {};
    for(let i = tape.length - 1; i >= 0; i--){
        const node = tape[i];
        const nodeInputs = node.inputs;
        // If any of the outputs lead to y, mark all of the inputs as leading to y.
        for(let j = 0; j < node.outputs.length; j++)if (tensorsLeadToY[node.outputs[j].id]) {
            for(const inputName in nodeInputs){
                tensorsLeadToY[nodeInputs[inputName].id] = true;
                nodesToY[node.id] = true;
            }
            break;
        }
    }
    // Return the paths that come from x and lead to y.
    const filteredTape = [];
    for(let i = 0; i < tape.length; i++){
        const node = tape[i];
        if (nodesFromX[node.id] && nodesToY[node.id]) {
            // Prune the inputs from the node that aren't a function of x.
            const prunedInputs = {};
            for(const inputName in node.inputs){
                const nodeInput = node.inputs[inputName];
                if (tensorsFromX[nodeInput.id]) prunedInputs[inputName] = nodeInput;
            }
            // Copy the node and overwrite inputsAndArgs to the pruned version.
            const prunedNode = Object.assign({}, node);
            prunedNode.inputs = prunedInputs;
            prunedNode.outputs = node.outputs;
            filteredTape.push(prunedNode);
        }
    }
    return filteredTape;
}
function $0d5b6f608a76b290$export$2992958ba0a8790d(tensorAccumulatedGradientMap, filteredTape, tidy, add) {
    // Walk the tape backward and keep a map of Tensor to its gradient.
    for(let i = filteredTape.length - 1; i >= 0; i--){
        const node = filteredTape[i];
        const dys = [];
        node.outputs.forEach((o)=>{
            const gradTensor = tensorAccumulatedGradientMap[o.id];
            if (gradTensor != null) dys.push(gradTensor);
            else // This particular output is not in the back-propagation subgraph, so it
            // does not affect the final output, thus we put null for its dy.
            dys.push(null);
        });
        if (node.gradient == null) throw new Error(`Cannot compute gradient: gradient function not found ` + `for ${node.kernelName}.`);
        // Backprop dy through this node and accumulate gradients over the inputs.
        const inputGradients = node.gradient(dys);
        for(const inputName in node.inputs){
            if (!(inputName in inputGradients)) throw new Error(`Cannot backprop through input ${inputName}. ` + `Available gradients found: ${Object.keys(inputGradients)}.`);
            // Call the gradient function.
            const dx = tidy(()=>inputGradients[inputName]());
            if (dx.dtype !== 'float32') throw new Error(`Error in gradient for op ${node.kernelName}. The gradient of input ` + `${inputName} must have 'float32' dtype, but has '${dx.dtype}'`);
            const x = node.inputs[inputName];
            if (!$4tCOB.arraysEqual(dx.shape, x.shape)) throw new Error(`Error in gradient for op ${node.kernelName}. The gradient of input ` + `'${inputName}' has shape '${dx.shape}', which does not match ` + `the shape of the input '${x.shape}'`);
            if (tensorAccumulatedGradientMap[x.id] == null) tensorAccumulatedGradientMap[x.id] = dx;
            else {
                const curGradient = tensorAccumulatedGradientMap[x.id];
                tensorAccumulatedGradientMap[x.id] = add(curGradient, dx);
                curGradient.dispose();
            }
        }
    }
}

});

parcelRegister("bVnU9", function(module, exports) {

$parcel$export(module.exports, "TensorBuffer", () => $8ae78f86dbc08bbd$export$350df26cd52e08e1);
$parcel$export(module.exports, "setTensorTracker", () => $8ae78f86dbc08bbd$export$b1e34d2f0ffbbd85);
$parcel$export(module.exports, "setOpHandler", () => $8ae78f86dbc08bbd$export$1efe8d8b4884ad31);
$parcel$export(module.exports, "setDeprecationWarningFn", () => $8ae78f86dbc08bbd$export$ca605c1d8919649f);
$parcel$export(module.exports, "Tensor", () => $8ae78f86dbc08bbd$export$7b6b8d90402f8814);
$parcel$export(module.exports, "getGlobalTensorClass", () => $8ae78f86dbc08bbd$export$3cbd87e9d6a9b7ac);
$parcel$export(module.exports, "Variable", () => $8ae78f86dbc08bbd$export$c867a5c9595a1350);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Workaround for: https://github.com/bazelbuild/rules_nodejs/issues/1265
/// <reference types="@webgpu/types/dist" />

var $fRI13 = parcelRequire("fRI13");

var $kA5Vr = parcelRequire("kA5Vr");

var $4tCOB = parcelRequire("4tCOB");
var $wx9lK = parcelRequire("wx9lK");
class $8ae78f86dbc08bbd$export$350df26cd52e08e1 {
    constructor(shape, dtype, values){
        this.dtype = dtype;
        this.shape = shape.slice();
        this.size = $4tCOB.sizeFromShape(shape);
        if (values != null) {
            const n = values.length;
            $4tCOB.assert(n === this.size, ()=>`Length of values '${n}' does not match the size ` + `inferred by the shape '${this.size}'.`);
        }
        if (dtype === 'complex64') throw new Error(`complex64 dtype TensorBuffers are not supported. Please create ` + `a TensorBuffer for the real and imaginary parts separately and ` + `call tf.complex(real, imag).`);
        this.values = values || $4tCOB.getArrayFromDType(dtype, this.size);
        this.strides = (0, $4tCOB.computeStrides)(shape);
    }
    /**
     * Sets a value in the buffer at a given location.
     *
     * @param value The value to set.
     * @param locs  The location indices.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ set(value, ...locs) {
        if (locs.length === 0) locs = [
            0
        ];
        $4tCOB.assert(locs.length === this.rank, ()=>`The number of provided coordinates (${locs.length}) must ` + `match the rank (${this.rank})`);
        const index = this.locToIndex(locs);
        this.values[index] = value;
    }
    /**
     * Returns the value in the buffer at the provided location.
     *
     * @param locs The location indices.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ get(...locs) {
        if (locs.length === 0) locs = [
            0
        ];
        let i = 0;
        for (const loc of locs){
            if (loc < 0 || loc >= this.shape[i]) {
                const msg = `Requested out of range element at ${locs}. ` + `  Buffer shape=${this.shape}`;
                throw new Error(msg);
            }
            i++;
        }
        let index = locs[locs.length - 1];
        for(let i = 0; i < locs.length - 1; ++i)index += this.strides[i] * locs[i];
        return this.values[index];
    }
    locToIndex(locs) {
        if (this.rank === 0) return 0;
        else if (this.rank === 1) return locs[0];
        let index = locs[locs.length - 1];
        for(let i = 0; i < locs.length - 1; ++i)index += this.strides[i] * locs[i];
        return index;
    }
    indexToLoc(index) {
        if (this.rank === 0) return [];
        else if (this.rank === 1) return [
            index
        ];
        const locs = new Array(this.shape.length);
        for(let i = 0; i < locs.length - 1; ++i){
            locs[i] = Math.floor(index / this.strides[i]);
            index -= locs[i] * this.strides[i];
        }
        locs[locs.length - 1] = index;
        return locs;
    }
    get rank() {
        return this.shape.length;
    }
    /**
     * Creates an immutable `tf.Tensor` object from the buffer.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ toTensor() {
        return $8ae78f86dbc08bbd$var$trackerFn().makeTensor(this.values, this.shape, this.dtype);
    }
}
// For tracking tensor creation and disposal.
let $8ae78f86dbc08bbd$var$trackerFn = null;
// Used by chaining methods to call into ops.
let $8ae78f86dbc08bbd$var$opHandler = null;
// Used to warn about deprecated methods.
let $8ae78f86dbc08bbd$var$deprecationWarningFn = null;
function $8ae78f86dbc08bbd$export$b1e34d2f0ffbbd85(fn) {
    $8ae78f86dbc08bbd$var$trackerFn = fn;
}
function $8ae78f86dbc08bbd$export$1efe8d8b4884ad31(handler) {
    $8ae78f86dbc08bbd$var$opHandler = handler;
}
function $8ae78f86dbc08bbd$export$ca605c1d8919649f(fn) {
    $8ae78f86dbc08bbd$var$deprecationWarningFn = fn;
}
class $8ae78f86dbc08bbd$export$7b6b8d90402f8814 {
    constructor(shape, dtype, dataId, id){
        /** Whether this tensor has been globally kept. */ this.kept = false;
        this.isDisposedInternal = false;
        this.shape = shape.slice();
        this.dtype = dtype || 'float32';
        this.size = $4tCOB.sizeFromShape(shape);
        this.strides = (0, $4tCOB.computeStrides)(shape);
        this.dataId = dataId;
        this.id = id;
        this.rankType = this.rank < 5 ? this.rank.toString() : 'higher';
    }
    get rank() {
        return this.shape.length;
    }
    /**
     * Returns a promise of `tf.TensorBuffer` that holds the underlying data.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async buffer() {
        const vals = await this.data();
        return $8ae78f86dbc08bbd$var$opHandler.buffer(this.shape, this.dtype, vals);
    }
    /**
     * Returns a `tf.TensorBuffer` that holds the underlying data.
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ bufferSync() {
        return $8ae78f86dbc08bbd$var$opHandler.buffer(this.shape, this.dtype, this.dataSync());
    }
    /**
     * Returns the tensor data as a nested array. The transfer of data is done
     * asynchronously.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async array() {
        const vals = await this.data();
        return (0, $4tCOB.toNestedArray)(this.shape, vals, this.dtype === 'complex64');
    }
    /**
     * Returns the tensor data as a nested array. The transfer of data is done
     * synchronously.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ arraySync() {
        return (0, $4tCOB.toNestedArray)(this.shape, this.dataSync(), this.dtype === 'complex64');
    }
    /**
     * Asynchronously downloads the values from the `tf.Tensor`. Returns a
     * promise of `TypedArray` that resolves when the computation has finished.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async data() {
        this.throwIfDisposed();
        const data = $8ae78f86dbc08bbd$var$trackerFn().read(this.dataId);
        if (this.dtype === 'string') {
            const bytes = await data;
            try {
                return bytes.map((b)=>$wx9lK.decodeString(b));
            } catch (_a) {
                throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
            }
        }
        return data;
    }
    /**
     * Copy the tensor's data to a new GPU resource. Comparing to the `dataSync()`
     * and `data()`, this method prevents data from being downloaded to CPU.
     *
     * For WebGL backend, the data will be stored on a densely packed texture.
     * This means that the texture will use the RGBA channels to store value.
     *
     * For WebGPU backend, the data will be stored on a buffer. There is no
     * parameter, so can not use a user-defined size to create the buffer.
     *
     * @param options:
     *     For WebGL,
     *         - customTexShape: Optional. If set, will use the user defined
     *     texture shape to create the texture.
     *
     * @returns For WebGL backend, a GPUData contains the new texture and
     *     its information.
     *     {
     *        tensorRef: The tensor that is associated with this texture,
     *        texture: WebGLTexture,
     *        texShape: [number, number] // [height, width]
     *     }
     *
     *     For WebGPU backend, a GPUData contains the new buffer and
     *     its information.
     *     {
     *        tensorRef: The tensor that is associated with this buffer,
     *        buffer: GPUBuffer,
     *        bufSize: number
     *     }
     *
     *     Remember to dispose the GPUData after it is used by
     *     `res.tensorRef.dispose()`.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dataToGPU(options) {
        this.throwIfDisposed();
        return $8ae78f86dbc08bbd$var$trackerFn().readToGPU(this.dataId, options);
    }
    /**
     * Synchronously downloads the values from the `tf.Tensor`. This blocks the
     * UI thread until the values are ready, which can cause performance issues.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dataSync() {
        this.throwIfDisposed();
        const data = $8ae78f86dbc08bbd$var$trackerFn().readSync(this.dataId);
        if (this.dtype === 'string') try {
            return data.map((b)=>$wx9lK.decodeString(b));
        } catch (_a) {
            throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
        }
        return data;
    }
    /** Returns the underlying bytes of the tensor's data. */ async bytes() {
        this.throwIfDisposed();
        const data = await $8ae78f86dbc08bbd$var$trackerFn().read(this.dataId);
        if (this.dtype === 'string') return data;
        else return new Uint8Array(data.buffer);
    }
    /**
     * Disposes `tf.Tensor` from memory.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dispose() {
        if (this.isDisposed) return;
        $8ae78f86dbc08bbd$var$trackerFn().disposeTensor(this);
        this.isDisposedInternal = true;
    }
    get isDisposed() {
        return this.isDisposedInternal;
    }
    throwIfDisposed() {
        if (this.isDisposed) throw new Error(`Tensor is disposed.`);
    }
    /**
     * Prints the `tf.Tensor`. See `tf.print` for details.
     *
     * @param verbose Whether to print verbose information about the tensor,
     *    including dtype and size.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ print(verbose = false) {
        return $8ae78f86dbc08bbd$var$opHandler.print(this, verbose);
    }
    /**
     * Returns a copy of the tensor. See `tf.clone` for details.
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ clone() {
        this.throwIfDisposed();
        return $8ae78f86dbc08bbd$var$opHandler.clone(this);
    }
    /**
     * Returns a human-readable description of the tensor. Useful for logging.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ toString(verbose = false) {
        const vals = this.dataSync();
        return (0, $kA5Vr.tensorToString)(vals, this.shape, this.dtype, verbose);
    }
    cast(dtype) {
        this.throwIfDisposed();
        return $8ae78f86dbc08bbd$var$opHandler.cast(this, dtype);
    }
    variable(trainable = true, name, dtype) {
        this.throwIfDisposed();
        return $8ae78f86dbc08bbd$var$trackerFn().makeVariable(this, trainable, name, dtype);
    }
}
Object.defineProperty($8ae78f86dbc08bbd$export$7b6b8d90402f8814, Symbol.hasInstance, {
    value: (instance)=>{
        // Implementation note: we should use properties of the object that will be
        // defined before the constructor body has finished executing (methods).
        // This is because when this code is transpiled by babel, babel will call
        // classCallCheck before the constructor body is run.
        // See https://github.com/tensorflow/tfjs/issues/3384 for backstory.
        return !!instance && instance.data != null && instance.dataSync != null && instance.throwIfDisposed != null;
    }
});
function $8ae78f86dbc08bbd$export$3cbd87e9d6a9b7ac() {
    // Use getGlobal so that we can augment the Tensor class across package
    // boundaries becase the node resolution alg may result in different modules
    // being returned for this file depending on the path they are loaded from.
    return (0, $fRI13.getGlobal)('Tensor', ()=>{
        return $8ae78f86dbc08bbd$export$7b6b8d90402f8814;
    });
}
// Global side effect. Cache global reference to Tensor class
$8ae78f86dbc08bbd$export$3cbd87e9d6a9b7ac();
class $8ae78f86dbc08bbd$export$c867a5c9595a1350 extends $8ae78f86dbc08bbd$export$7b6b8d90402f8814 {
    constructor(initialValue, trainable, name, tensorId){
        super(initialValue.shape, initialValue.dtype, initialValue.dataId, tensorId);
        this.trainable = trainable;
        this.name = name;
    }
    /**
     * Assign a new `tf.Tensor` to this variable. The new `tf.Tensor` must have
     * the same shape and dtype as the old `tf.Tensor`.
     *
     * @param newValue New tensor to be assigned to this variable.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ assign(newValue) {
        if (newValue.dtype !== this.dtype) throw new Error(`dtype of the new value (${newValue.dtype}) and ` + `previous value (${this.dtype}) must match`);
        if (!$4tCOB.arraysEqual(newValue.shape, this.shape)) throw new Error(`shape of the new value (${newValue.shape}) and ` + `previous value (${this.shape}) must match`);
        $8ae78f86dbc08bbd$var$trackerFn().disposeTensor(this);
        this.dataId = newValue.dataId;
        $8ae78f86dbc08bbd$var$trackerFn().incRef(this, null);
    }
    dispose() {
        $8ae78f86dbc08bbd$var$trackerFn().disposeVariable(this);
        this.isDisposedInternal = true;
    }
}
Object.defineProperty($8ae78f86dbc08bbd$export$c867a5c9595a1350, Symbol.hasInstance, {
    value: (instance)=>{
        return instance instanceof $8ae78f86dbc08bbd$export$7b6b8d90402f8814 && instance.assign != null && instance.assign instanceof Function;
    }
});

});
parcelRegister("kA5Vr", function(module, exports) {

$parcel$export(module.exports, "tensorToString", () => $efbbc417371bd3dc$export$7febe2c78b16daa7);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
// Maximum number of values before we decide to show ellipsis.
const $efbbc417371bd3dc$var$FORMAT_LIMIT_NUM_VALS = 20;
// Number of first and last values to show when displaying a, b,...,y, z.
const $efbbc417371bd3dc$var$FORMAT_NUM_FIRST_LAST_VALS = 3;
// Number of significant digits to show.
const $efbbc417371bd3dc$var$FORMAT_NUM_SIG_DIGITS = 7;
function $efbbc417371bd3dc$export$7febe2c78b16daa7(vals, shape, dtype, verbose) {
    const strides = (0, $4tCOB.computeStrides)(shape);
    const padPerCol = $efbbc417371bd3dc$var$computeMaxSizePerColumn(vals, shape, dtype, strides);
    const rank = shape.length;
    const valsLines = $efbbc417371bd3dc$var$subTensorToString(vals, shape, dtype, strides, padPerCol);
    const lines = [
        'Tensor'
    ];
    if (verbose) {
        lines.push(`  dtype: ${dtype}`);
        lines.push(`  rank: ${rank}`);
        lines.push(`  shape: [${shape}]`);
        lines.push(`  values:`);
    }
    lines.push(valsLines.map((l)=>'    ' + l).join('\n'));
    return lines.join('\n');
}
function $efbbc417371bd3dc$var$computeMaxSizePerColumn(vals, shape, dtype, strides) {
    const n = (0, $4tCOB.sizeFromShape)(shape);
    const numCols = strides[strides.length - 1];
    const padPerCol = new Array(numCols).fill(0);
    const rank = shape.length;
    const valuesOrTuples = dtype === 'complex64' ? $efbbc417371bd3dc$var$createComplexTuples(vals) : vals;
    if (rank > 1) for(let row = 0; row < n / numCols; row++){
        const offset = row * numCols;
        for(let j = 0; j < numCols; j++)padPerCol[j] = Math.max(padPerCol[j], $efbbc417371bd3dc$var$valToString(valuesOrTuples[offset + j], 0, dtype).length);
    }
    return padPerCol;
}
function $efbbc417371bd3dc$var$valToString(val, pad, dtype) {
    let valStr;
    if (Array.isArray(val)) valStr = `${parseFloat(val[0].toFixed($efbbc417371bd3dc$var$FORMAT_NUM_SIG_DIGITS))} + ` + `${parseFloat(val[1].toFixed($efbbc417371bd3dc$var$FORMAT_NUM_SIG_DIGITS))}j`;
    else if ((0, $4tCOB.isString)(val)) valStr = `'${val}'`;
    else if (dtype === 'bool') valStr = $efbbc417371bd3dc$var$boolNumToString(val);
    else valStr = parseFloat(val.toFixed($efbbc417371bd3dc$var$FORMAT_NUM_SIG_DIGITS)).toString();
    return (0, $4tCOB.rightPad)(valStr, pad);
}
function $efbbc417371bd3dc$var$boolNumToString(v) {
    return v === 0 ? 'false' : 'true';
}
function $efbbc417371bd3dc$var$subTensorToString(vals, shape, dtype, strides, padPerCol, isLast = true) {
    const storagePerElement = dtype === 'complex64' ? 2 : 1;
    const size = shape[0];
    const rank = shape.length;
    if (rank === 0) {
        if (dtype === 'complex64') {
            const complexTuple = $efbbc417371bd3dc$var$createComplexTuples(vals);
            return [
                $efbbc417371bd3dc$var$valToString(complexTuple[0], 0, dtype)
            ];
        }
        if (dtype === 'bool') return [
            $efbbc417371bd3dc$var$boolNumToString(vals[0])
        ];
        return [
            vals[0].toString()
        ];
    }
    if (rank === 1) {
        if (size > $efbbc417371bd3dc$var$FORMAT_LIMIT_NUM_VALS) {
            const firstValsSize = $efbbc417371bd3dc$var$FORMAT_NUM_FIRST_LAST_VALS * storagePerElement;
            let firstVals = Array.from(vals.slice(0, firstValsSize));
            let lastVals = Array.from(vals.slice((size - $efbbc417371bd3dc$var$FORMAT_NUM_FIRST_LAST_VALS) * storagePerElement, size * storagePerElement));
            if (dtype === 'complex64') {
                firstVals = $efbbc417371bd3dc$var$createComplexTuples(firstVals);
                lastVals = $efbbc417371bd3dc$var$createComplexTuples(lastVals);
            }
            return [
                '[' + firstVals.map((x, i)=>$efbbc417371bd3dc$var$valToString(x, padPerCol[i], dtype)).join(', ') + ', ..., ' + lastVals.map((x, i)=>$efbbc417371bd3dc$var$valToString(x, padPerCol[size - $efbbc417371bd3dc$var$FORMAT_NUM_FIRST_LAST_VALS + i], dtype)).join(', ') + ']'
            ];
        }
        const displayVals = dtype === 'complex64' ? $efbbc417371bd3dc$var$createComplexTuples(vals) : Array.from(vals);
        return [
            '[' + displayVals.map((x, i)=>$efbbc417371bd3dc$var$valToString(x, padPerCol[i], dtype)).join(', ') + ']'
        ];
    }
    // The array is rank 2 or more.
    const subshape = shape.slice(1);
    const substrides = strides.slice(1);
    const stride = strides[0] * storagePerElement;
    const lines = [];
    if (size > $efbbc417371bd3dc$var$FORMAT_LIMIT_NUM_VALS) {
        for(let i = 0; i < $efbbc417371bd3dc$var$FORMAT_NUM_FIRST_LAST_VALS; i++){
            const start = i * stride;
            const end = start + stride;
            lines.push(...$efbbc417371bd3dc$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, false));
        }
        lines.push('...');
        for(let i = size - $efbbc417371bd3dc$var$FORMAT_NUM_FIRST_LAST_VALS; i < size; i++){
            const start = i * stride;
            const end = start + stride;
            lines.push(...$efbbc417371bd3dc$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i === size - 1 /* isLast */ ));
        }
    } else for(let i = 0; i < size; i++){
        const start = i * stride;
        const end = start + stride;
        lines.push(...$efbbc417371bd3dc$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i === size - 1 /* isLast */ ));
    }
    const sep = rank === 2 ? ',' : '';
    lines[0] = '[' + lines[0] + sep;
    for(let i = 1; i < lines.length - 1; i++)lines[i] = ' ' + lines[i] + sep;
    let newLineSep = ',\n';
    for(let i = 2; i < rank; i++)newLineSep += '\n';
    lines[lines.length - 1] = ' ' + lines[lines.length - 1] + ']' + (isLast ? '' : newLineSep);
    return lines;
}
function $efbbc417371bd3dc$var$createComplexTuples(vals) {
    const complexTuples = [];
    for(let i = 0; i < vals.length; i += 2)complexTuples.push([
        vals[i],
        vals[i + 1]
    ]);
    return complexTuples;
}

});


parcelRegister("1vhox", function(module, exports) {

$parcel$export(module.exports, "makeTypesMatch", () => $11862deab3e122e9$export$8b0e24c749a224d7);
$parcel$export(module.exports, "assertTypesMatch", () => $11862deab3e122e9$export$8a66522456343d17);
$parcel$export(module.exports, "isTensorInList", () => $11862deab3e122e9$export$537d2ee9de90a490);
$parcel$export(module.exports, "getTensorsInContainer", () => $11862deab3e122e9$export$888c106d343989f5);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bVnU9 = parcelRequire("bVnU9");

var $bnEYl = parcelRequire("bnEYl");

var $4tCOB = parcelRequire("4tCOB");
function $11862deab3e122e9$export$8b0e24c749a224d7(a, b) {
    if (a.dtype === b.dtype) return [
        a,
        b
    ];
    const dtype = (0, $bnEYl.upcastType)(a.dtype, b.dtype);
    return [
        a.cast(dtype),
        b.cast(dtype)
    ];
}
function $11862deab3e122e9$export$8a66522456343d17(a, b) {
    (0, $4tCOB.assert)(a.dtype === b.dtype, ()=>`The dtypes of the first(${a.dtype}) and` + ` second(${b.dtype}) input must match`);
}
function $11862deab3e122e9$export$537d2ee9de90a490(tensor, tensorList) {
    return tensorList.some((x)=>x.id === tensor.id);
}
function $11862deab3e122e9$export$888c106d343989f5(result) {
    const list = [];
    const seen = new Set();
    $11862deab3e122e9$var$walkTensorContainer(result, list, seen);
    return list;
}
function $11862deab3e122e9$var$walkTensorContainer(container, list, seen) {
    if (container == null) return;
    if (container instanceof (0, $bVnU9.Tensor)) {
        list.push(container);
        return;
    }
    if (!$11862deab3e122e9$var$isIterable(container)) return;
    // Iteration over keys works also for arrays.
    const iterable = container;
    for(const k in iterable){
        const val = iterable[k];
        if (!seen.has(val)) {
            seen.add(val);
            $11862deab3e122e9$var$walkTensorContainer(val, list, seen);
        }
    }
}
// tslint:disable-next-line:no-any
function $11862deab3e122e9$var$isIterable(obj) {
    return Array.isArray(obj) || typeof obj === 'object';
}

});
parcelRegister("bnEYl", function(module, exports) {

$parcel$export(module.exports, "Rank", () => $84919fed973aec33$export$c36edca8f8f0427a);
$parcel$export(module.exports, "upcastType", () => $84919fed973aec33$export$7bcca02d1a156bdf);
$parcel$export(module.exports, "sumOutType", () => $84919fed973aec33$export$3479b4fbed3c0d8d);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $84919fed973aec33$export$c36edca8f8f0427a;
(function(Rank) {
    Rank["R0"] = "R0";
    Rank["R1"] = "R1";
    Rank["R2"] = "R2";
    Rank["R3"] = "R3";
    Rank["R4"] = "R4";
    Rank["R5"] = "R5";
    Rank["R6"] = "R6";
})($84919fed973aec33$export$c36edca8f8f0427a || ($84919fed973aec33$export$c36edca8f8f0427a = {}));
// Looks for upcasting types. Used, for example, in operations with mixed dtype
// inputs.
var $84919fed973aec33$var$UpcastInt32AndMap;
(function(UpcastInt32AndMap) {
    UpcastInt32AndMap["float32"] = "float32";
    UpcastInt32AndMap["int32"] = "int32";
    UpcastInt32AndMap["bool"] = "int32";
    UpcastInt32AndMap["complex64"] = "complex64";
})($84919fed973aec33$var$UpcastInt32AndMap || ($84919fed973aec33$var$UpcastInt32AndMap = {}));
var $84919fed973aec33$var$UpcastBoolAndMap;
(function(UpcastBoolAndMap) {
    UpcastBoolAndMap["float32"] = "float32";
    UpcastBoolAndMap["int32"] = "int32";
    UpcastBoolAndMap["bool"] = "bool";
    UpcastBoolAndMap["complex64"] = "complex64";
})($84919fed973aec33$var$UpcastBoolAndMap || ($84919fed973aec33$var$UpcastBoolAndMap = {}));
var $84919fed973aec33$var$UpcastFloat32AndMap;
(function(UpcastFloat32AndMap) {
    UpcastFloat32AndMap["float32"] = "float32";
    UpcastFloat32AndMap["int32"] = "float32";
    UpcastFloat32AndMap["bool"] = "float32";
    UpcastFloat32AndMap["complex64"] = "complex64";
})($84919fed973aec33$var$UpcastFloat32AndMap || ($84919fed973aec33$var$UpcastFloat32AndMap = {}));
var $84919fed973aec33$var$UpcastComplex64AndMap;
(function(UpcastComplex64AndMap) {
    UpcastComplex64AndMap["float32"] = "complex64";
    UpcastComplex64AndMap["int32"] = "complex64";
    UpcastComplex64AndMap["bool"] = "complex64";
    UpcastComplex64AndMap["complex64"] = "complex64";
})($84919fed973aec33$var$UpcastComplex64AndMap || ($84919fed973aec33$var$UpcastComplex64AndMap = {}));
const $84919fed973aec33$var$upcastTypeMap = {
    'float32': $84919fed973aec33$var$UpcastFloat32AndMap,
    'int32': $84919fed973aec33$var$UpcastInt32AndMap,
    'bool': $84919fed973aec33$var$UpcastBoolAndMap,
    'complex64': $84919fed973aec33$var$UpcastComplex64AndMap
};
function $84919fed973aec33$export$7bcca02d1a156bdf(typeA, typeB) {
    if (typeA === 'string' || typeB === 'string') {
        if (typeA === 'string' && typeB === 'string') return 'string';
        throw new Error(`Can not upcast ${typeA} with ${typeB}`);
    }
    return $84919fed973aec33$var$upcastTypeMap[typeA][typeB];
}
function $84919fed973aec33$export$3479b4fbed3c0d8d(type) {
    return $84919fed973aec33$export$7bcca02d1a156bdf(type, 'int32');
}

});



parcelRegister("aQg53", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("aHfUM");

var $7L9WU = parcelRequire("7L9WU");

var $aymVi = parcelRequire("aymVi");
const $7e4b3bf3f3427224$var$ENV = (0, $aymVi.env)();
/**
 * This file contains environment-related flag registrations.
 */ /** Whether to enable debug mode. */ $7e4b3bf3f3427224$var$ENV.registerFlag('DEBUG', ()=>false, (debugValue)=>{
    if (debugValue) console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.");
});
/** Whether we are in a browser (as versus, say, node.js) environment. */ $7e4b3bf3f3427224$var$ENV.registerFlag('IS_BROWSER', ()=>$7L9WU.isBrowser());
/** Whether we are in a browser (as versus, say, node.js) environment. */ $7e4b3bf3f3427224$var$ENV.registerFlag('IS_NODE', ()=>false);
/** Whether this browser is Chrome. */ $7e4b3bf3f3427224$var$ENV.registerFlag('IS_CHROME', ()=>typeof navigator !== 'undefined' && navigator != null && navigator.userAgent != null && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
/**
 * True when the environment is "production" where we disable safety checks
 * to gain performance.
 */ $7e4b3bf3f3427224$var$ENV.registerFlag('PROD', ()=>false);
/**
 * Whether to do sanity checks when inferring a shape from user-provided
 * values, used when creating a new tensor.
 */ $7e4b3bf3f3427224$var$ENV.registerFlag('TENSORLIKE_CHECK_SHAPE_CONSISTENCY', ()=>$7e4b3bf3f3427224$var$ENV.getBool('DEBUG'));
/** Whether deprecation warnings are enabled. */ $7e4b3bf3f3427224$var$ENV.registerFlag('DEPRECATION_WARNINGS_ENABLED', ()=>true);
/** True if running unit tests. */ $7e4b3bf3f3427224$var$ENV.registerFlag('IS_TEST', ()=>false);
/** Whether to check computation result for errors. */ $7e4b3bf3f3427224$var$ENV.registerFlag('CHECK_COMPUTATION_FOR_ERRORS', ()=>true);
/** Whether the backend needs to wrap input to imageBitmap. */ $7e4b3bf3f3427224$var$ENV.registerFlag('WRAP_TO_IMAGEBITMAP', ()=>false);
/** Experimental flag, whether enter compile only phase. */ $7e4b3bf3f3427224$var$ENV.registerFlag('ENGINE_COMPILE_ONLY', ()=>false);
/** Whether to enable canvas2d willReadFrequently for GPU backends */ $7e4b3bf3f3427224$var$ENV.registerFlag('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU', ()=>false);
/** Whether to use setTimeoutCustom */ $7e4b3bf3f3427224$var$ENV.registerFlag('USE_SETTIMEOUTCUSTOM', ()=>false);

});
parcelRegister("7L9WU", function(module, exports) {

$parcel$export(module.exports, "mockIsMobile", () => $5a64a3e57f449f68$export$f55f7bd5cb259cb2);
$parcel$export(module.exports, "isMobile", () => $5a64a3e57f449f68$export$d0a8044dce8ff2fc);
$parcel$export(module.exports, "isBrowser", () => $5a64a3e57f449f68$export$4e09c449d6c407f7);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line:no-any
function $5a64a3e57f449f68$var$_isNavigatorDefined() {
    return typeof navigator !== 'undefined' && navigator != null;
}
let $5a64a3e57f449f68$var$isMobileMockValue;
function $5a64a3e57f449f68$export$f55f7bd5cb259cb2(value) {
    $5a64a3e57f449f68$var$isMobileMockValue = value;
}
function $5a64a3e57f449f68$export$d0a8044dce8ff2fc(nav) {
    if ($5a64a3e57f449f68$var$isMobileMockValue !== undefined) return $5a64a3e57f449f68$var$isMobileMockValue;
    if (nav || $5a64a3e57f449f68$var$_isNavigatorDefined()) {
        if (!nav) nav = navigator;
        if (nav.product === 'ReactNative') return true;
        const a = nav.userAgent || nav.vendor || // tslint:disable-next-line:no-any
        (typeof window !== 'undefined' ? window.opera : '');
        // Use `navigator.userAgentData.mobile` as fallback.
        if (!a) {
            // tslint:disable-next-line:no-any
            const navAny = nav;
            return navAny.userAgentData && navAny.userAgentData.mobile;
        }
        // tslint:disable-next-line:max-line-length
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || // tslint:disable-next-line:max-line-length
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
    }
    return false;
}
function $5a64a3e57f449f68$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' && window.document != null || //@ts-ignore
    typeof WorkerGlobalScope !== 'undefined';
}

});


parcelRegister("42Qas", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("aQg53");

var $aymVi = parcelRequire("aymVi");

var $ehkIT = parcelRequire("ehkIT");

var $gIO3p = parcelRequire("gIO3p");

var $1EsOW = parcelRequire("1EsOW");
class $2f1fd0c0807b4066$export$c812b315576f1552 {
    constructor(){
        // For setTimeoutCustom
        this.messageName = 'setTimeoutCustom';
        this.functionRefs = [];
        this.handledMessageCount = 0;
        this.hasEventListener = false;
    }
    fetch(path, init) {
        return fetch(path, init);
    }
    now() {
        return performance.now();
    }
    encode(text, encoding) {
        if (encoding !== 'utf-8' && encoding !== 'utf8') throw new Error(`Browser's encoder only supports utf-8, but got ${encoding}`);
        if (this.textEncoder == null) this.textEncoder = new TextEncoder();
        return this.textEncoder.encode(text);
    }
    decode(bytes, encoding) {
        return new TextDecoder(encoding).decode(bytes);
    }
    // If the setTimeout nesting level is greater than 5 and timeout is less
    // than 4ms, timeout will be clamped to 4ms, which hurts the perf.
    // Interleaving window.postMessage and setTimeout will trick the browser and
    // avoid the clamp.
    setTimeoutCustom(functionRef, delay) {
        if (!window || !(0, $aymVi.env)().getBool('USE_SETTIMEOUTCUSTOM')) {
            setTimeout(functionRef, delay);
            return;
        }
        this.functionRefs.push(functionRef);
        setTimeout(()=>{
            window.postMessage({
                name: this.messageName,
                index: this.functionRefs.length - 1
            }, '*');
        }, delay);
        if (!this.hasEventListener) {
            this.hasEventListener = true;
            window.addEventListener('message', (event)=>{
                if (event.source === window && event.data.name === this.messageName) {
                    event.stopPropagation();
                    const functionRef = this.functionRefs[event.data.index];
                    functionRef();
                    this.handledMessageCount++;
                    if (this.handledMessageCount === this.functionRefs.length) {
                        this.functionRefs = [];
                        this.handledMessageCount = 0;
                    }
                }
            }, true);
        }
    }
}
if ((0, $aymVi.env)().get('IS_BROWSER')) {
    (0, $aymVi.env)().setPlatform('browser', new $2f1fd0c0807b4066$export$c812b315576f1552());
    // Register LocalStorage IOHandler
    try {
        (0, $1EsOW.ModelStoreManagerRegistry).registerManager((0, $gIO3p.BrowserLocalStorage).URL_SCHEME, new (0, $gIO3p.BrowserLocalStorageManager)());
    } catch (err) {}
    // Register IndexedDB IOHandler
    try {
        (0, $1EsOW.ModelStoreManagerRegistry).registerManager((0, $ehkIT.BrowserIndexedDB).URL_SCHEME, new (0, $ehkIT.BrowserIndexedDBManager)());
    } catch (err) {}
}

});
parcelRegister("ehkIT", function(module, exports) {

$parcel$export(module.exports, "BrowserIndexedDB", () => $a652ba685d5bbf2d$export$2c670ce804876090);
$parcel$export(module.exports, "BrowserIndexedDBManager", () => $a652ba685d5bbf2d$export$4b0775e2ff88802);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("aQg53");

var $aymVi = parcelRequire("aymVi");

var $615w2 = parcelRequire("615w2");

var $i9ref = parcelRequire("i9ref");
const $a652ba685d5bbf2d$var$DATABASE_NAME = 'tensorflowjs';
const $a652ba685d5bbf2d$var$DATABASE_VERSION = 1;
// Model data and ModelArtifactsInfo (metadata) are stored in two separate
// stores for efficient access of the list of stored models and their metadata.
// 1. The object store for model data: topology, weights and weight manifests.
const $a652ba685d5bbf2d$var$MODEL_STORE_NAME = 'models_store';
// 2. The object store for ModelArtifactsInfo, including meta-information such
//    as the type of topology (JSON vs binary), byte size of the topology, byte
//    size of the weights, etc.
const $a652ba685d5bbf2d$var$INFO_STORE_NAME = 'model_info_store';
async function $a652ba685d5bbf2d$export$24b6df48b2529372() {
    const idbFactory = $a652ba685d5bbf2d$var$getIndexedDBFactory();
    return new Promise((resolve, reject)=>{
        const deleteRequest = idbFactory.deleteDatabase($a652ba685d5bbf2d$var$DATABASE_NAME);
        deleteRequest.onsuccess = ()=>resolve();
        deleteRequest.onerror = (error)=>reject(error);
    });
}
function $a652ba685d5bbf2d$var$getIndexedDBFactory() {
    if (!(0, $aymVi.env)().getBool('IS_BROWSER')) // TODO(cais): Add more info about what IOHandler subtypes are available.
    //   Maybe point to a doc page on the web and/or automatically determine
    //   the available IOHandlers and print them in the error message.
    throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");
    // tslint:disable-next-line:no-any
    const theWindow = typeof window === 'undefined' ? self : window;
    const factory = theWindow.indexedDB || theWindow.mozIndexedDB || theWindow.webkitIndexedDB || theWindow.msIndexedDB || theWindow.shimIndexedDB;
    if (factory == null) throw new Error('The current browser does not appear to support IndexedDB.');
    return factory;
}
function $a652ba685d5bbf2d$var$setUpDatabase(openRequest) {
    const db = openRequest.result;
    db.createObjectStore($a652ba685d5bbf2d$var$MODEL_STORE_NAME, {
        keyPath: 'modelPath'
    });
    db.createObjectStore($a652ba685d5bbf2d$var$INFO_STORE_NAME, {
        keyPath: 'modelPath'
    });
}
class $a652ba685d5bbf2d$export$2c670ce804876090 {
    constructor(modelPath){
        this.indexedDB = $a652ba685d5bbf2d$var$getIndexedDBFactory();
        if (modelPath == null || !modelPath) throw new Error('For IndexedDB, modelPath must not be null, undefined or empty.');
        this.modelPath = modelPath;
    }
    async save(modelArtifacts) {
        // TODO(cais): Support saving GraphDef models.
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        return this.databaseAction(this.modelPath, modelArtifacts);
    }
    async load() {
        return this.databaseAction(this.modelPath);
    }
    /**
     * Perform database action to put model artifacts into or read model artifacts
     * from IndexedDB object store.
     *
     * Whether the action is put or get depends on whether `modelArtifacts` is
     * specified. If it is specified, the action will be put; otherwise the action
     * will be get.
     *
     * @param modelPath A unique string path for the model.
     * @param modelArtifacts If specified, it will be the model artifacts to be
     *   stored in IndexedDB.
     * @returns A `Promise` of `SaveResult`, if the action is put, or a `Promise`
     *   of `ModelArtifacts`, if the action is get.
     */ databaseAction(modelPath, modelArtifacts) {
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($a652ba685d5bbf2d$var$DATABASE_NAME, $a652ba685d5bbf2d$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$a652ba685d5bbf2d$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                if (modelArtifacts == null) {
                    // Read model out from object store.
                    const modelTx = db.transaction($a652ba685d5bbf2d$var$MODEL_STORE_NAME, 'readonly');
                    const modelStore = modelTx.objectStore($a652ba685d5bbf2d$var$MODEL_STORE_NAME);
                    const getRequest = modelStore.get(this.modelPath);
                    getRequest.onsuccess = ()=>{
                        if (getRequest.result == null) {
                            db.close();
                            return reject(new Error(`Cannot find model with path '${this.modelPath}' ` + `in IndexedDB.`));
                        } else resolve(getRequest.result.modelArtifacts);
                    };
                    getRequest.onerror = (error)=>{
                        db.close();
                        return reject(getRequest.error);
                    };
                    modelTx.oncomplete = ()=>db.close();
                } else {
                    // Put model into object store.
                    const modelArtifactsInfo = (0, $615w2.getModelArtifactsInfoForJSON)(modelArtifacts);
                    // First, put ModelArtifactsInfo into info store.
                    const infoTx = db.transaction($a652ba685d5bbf2d$var$INFO_STORE_NAME, 'readwrite');
                    let infoStore = infoTx.objectStore($a652ba685d5bbf2d$var$INFO_STORE_NAME);
                    const putInfoRequest = infoStore.put({
                        modelPath: this.modelPath,
                        modelArtifactsInfo: modelArtifactsInfo
                    });
                    let modelTx;
                    putInfoRequest.onsuccess = ()=>{
                        // Second, put model data into model store.
                        modelTx = db.transaction($a652ba685d5bbf2d$var$MODEL_STORE_NAME, 'readwrite');
                        const modelStore = modelTx.objectStore($a652ba685d5bbf2d$var$MODEL_STORE_NAME);
                        const putModelRequest = modelStore.put({
                            modelPath: this.modelPath,
                            modelArtifacts: modelArtifacts,
                            modelArtifactsInfo: modelArtifactsInfo
                        });
                        putModelRequest.onsuccess = ()=>resolve({
                                modelArtifactsInfo: modelArtifactsInfo
                            });
                        putModelRequest.onerror = (error)=>{
                            // If the put-model request fails, roll back the info entry as
                            // well.
                            infoStore = infoTx.objectStore($a652ba685d5bbf2d$var$INFO_STORE_NAME);
                            const deleteInfoRequest = infoStore.delete(this.modelPath);
                            deleteInfoRequest.onsuccess = ()=>{
                                db.close();
                                return reject(putModelRequest.error);
                            };
                            deleteInfoRequest.onerror = (error)=>{
                                db.close();
                                return reject(putModelRequest.error);
                            };
                        };
                    };
                    putInfoRequest.onerror = (error)=>{
                        db.close();
                        return reject(putInfoRequest.error);
                    };
                    infoTx.oncomplete = ()=>{
                        if (modelTx == null) db.close();
                        else modelTx.oncomplete = ()=>db.close();
                    };
                }
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
}
$a652ba685d5bbf2d$export$2c670ce804876090.URL_SCHEME = 'indexeddb://';
const $a652ba685d5bbf2d$export$7375c81acb8edf6e = (url)=>{
    if (!(0, $aymVi.env)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($a652ba685d5bbf2d$export$2c670ce804876090.URL_SCHEME)) return $a652ba685d5bbf2d$export$a4d8901e5a950049(url.slice($a652ba685d5bbf2d$export$2c670ce804876090.URL_SCHEME.length));
        else return null;
    }
};
(0, $i9ref.IORouterRegistry).registerSaveRouter($a652ba685d5bbf2d$export$7375c81acb8edf6e);
(0, $i9ref.IORouterRegistry).registerLoadRouter($a652ba685d5bbf2d$export$7375c81acb8edf6e);
function $a652ba685d5bbf2d$export$a4d8901e5a950049(modelPath) {
    return new $a652ba685d5bbf2d$export$2c670ce804876090(modelPath);
}
function $a652ba685d5bbf2d$var$maybeStripScheme(key) {
    return key.startsWith($a652ba685d5bbf2d$export$2c670ce804876090.URL_SCHEME) ? key.slice($a652ba685d5bbf2d$export$2c670ce804876090.URL_SCHEME.length) : key;
}
class $a652ba685d5bbf2d$export$4b0775e2ff88802 {
    constructor(){
        this.indexedDB = $a652ba685d5bbf2d$var$getIndexedDBFactory();
    }
    async listModels() {
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($a652ba685d5bbf2d$var$DATABASE_NAME, $a652ba685d5bbf2d$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$a652ba685d5bbf2d$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                const tx = db.transaction($a652ba685d5bbf2d$var$INFO_STORE_NAME, 'readonly');
                const store = tx.objectStore($a652ba685d5bbf2d$var$INFO_STORE_NAME);
                // tslint:disable:max-line-length
                // Need to cast `store` as `any` here because TypeScript's DOM
                // library does not have the `getAll()` method even though the
                // method is supported in the latest version of most mainstream
                // browsers:
                // https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/getAll
                // tslint:enable:max-line-length
                // tslint:disable-next-line:no-any
                const getAllInfoRequest = store.getAll();
                getAllInfoRequest.onsuccess = ()=>{
                    const out = {};
                    for (const item of getAllInfoRequest.result)out[item.modelPath] = item.modelArtifactsInfo;
                    resolve(out);
                };
                getAllInfoRequest.onerror = (error)=>{
                    db.close();
                    return reject(getAllInfoRequest.error);
                };
                tx.oncomplete = ()=>db.close();
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
    async removeModel(path) {
        path = $a652ba685d5bbf2d$var$maybeStripScheme(path);
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($a652ba685d5bbf2d$var$DATABASE_NAME, $a652ba685d5bbf2d$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$a652ba685d5bbf2d$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                const infoTx = db.transaction($a652ba685d5bbf2d$var$INFO_STORE_NAME, 'readwrite');
                const infoStore = infoTx.objectStore($a652ba685d5bbf2d$var$INFO_STORE_NAME);
                const getInfoRequest = infoStore.get(path);
                let modelTx;
                getInfoRequest.onsuccess = ()=>{
                    if (getInfoRequest.result == null) {
                        db.close();
                        return reject(new Error(`Cannot find model with path '${path}' ` + `in IndexedDB.`));
                    } else {
                        // First, delete the entry in the info store.
                        const deleteInfoRequest = infoStore.delete(path);
                        const deleteModelData = ()=>{
                            // Second, delete the entry in the model store.
                            modelTx = db.transaction($a652ba685d5bbf2d$var$MODEL_STORE_NAME, 'readwrite');
                            const modelStore = modelTx.objectStore($a652ba685d5bbf2d$var$MODEL_STORE_NAME);
                            const deleteModelRequest = modelStore.delete(path);
                            deleteModelRequest.onsuccess = ()=>resolve(getInfoRequest.result.modelArtifactsInfo);
                            deleteModelRequest.onerror = (error)=>reject(getInfoRequest.error);
                        };
                        // Proceed with deleting model data regardless of whether deletion
                        // of info data succeeds or not.
                        deleteInfoRequest.onsuccess = deleteModelData;
                        deleteInfoRequest.onerror = (error)=>{
                            deleteModelData();
                            db.close();
                            return reject(getInfoRequest.error);
                        };
                    }
                };
                getInfoRequest.onerror = (error)=>{
                    db.close();
                    return reject(getInfoRequest.error);
                };
                infoTx.oncomplete = ()=>{
                    if (modelTx == null) db.close();
                    else modelTx.oncomplete = ()=>db.close();
                };
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
}

});
parcelRegister("615w2", function(module, exports) {

$parcel$export(module.exports, "encodeWeights", () => $46171d5d254eac88$export$6c50c12dbd6168b);
$parcel$export(module.exports, "decodeWeights", () => $46171d5d254eac88$export$7a14c2428d4f4a2e);
$parcel$export(module.exports, "arrayBufferToBase64String", () => $46171d5d254eac88$export$28e753ea3e93cabf);
$parcel$export(module.exports, "base64StringToArrayBuffer", () => $46171d5d254eac88$export$aa941b9d243f1be4);
$parcel$export(module.exports, "concatenateArrayBuffers", () => $46171d5d254eac88$export$9a3e9c78eb778da8);
$parcel$export(module.exports, "basename", () => $46171d5d254eac88$export$9bf319d8f74f51d1);
$parcel$export(module.exports, "getModelJSONForModelArtifacts", () => $46171d5d254eac88$export$a725daa2cfaa7bd5);
$parcel$export(module.exports, "getModelArtifactsForJSONSync", () => $46171d5d254eac88$export$ebf48c0f134e5c8);
$parcel$export(module.exports, "getModelArtifactsForJSON", () => $46171d5d254eac88$export$b867c14eedd5b8a2);
$parcel$export(module.exports, "getModelArtifactsInfoForJSON", () => $46171d5d254eac88$export$ece8b449d7d29272);
$parcel$export(module.exports, "getWeightSpecs", () => $46171d5d254eac88$export$9f3fe06e8e8def44);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bxdsK = parcelRequire("bxdsK");

var $ec8bD = parcelRequire("ec8bD");

var $4tCOB = parcelRequire("4tCOB");

var $8Q7Um = parcelRequire("8Q7Um");

var $cbQCu = parcelRequire("cbQCu");
var $46171d5d254eac88$require$Buffer = $cbQCu.Buffer;
/** Number of bytes reserved for the length of the string. (32bit integer). */ const $46171d5d254eac88$var$NUM_BYTES_STRING_LENGTH = 4;
async function $46171d5d254eac88$export$6c50c12dbd6168b(tensors, group) {
    // TODO(adarob, cais): Support quantization.
    const specs = [];
    const dataPromises = [];
    const names = Array.isArray(tensors) ? tensors.map((tensor)=>tensor.name) : Object.keys(tensors);
    for(let i = 0; i < names.length; ++i){
        const name = names[i];
        const t = Array.isArray(tensors) ? tensors[i].tensor : tensors[name];
        if (t.dtype !== 'float32' && t.dtype !== 'int32' && t.dtype !== 'bool' && t.dtype !== 'string' && t.dtype !== 'complex64') throw new Error(`Unsupported dtype in weight '${name}': ${t.dtype}`);
        const spec = {
            name: name,
            shape: t.shape,
            dtype: t.dtype
        };
        if (t.dtype === 'string') {
            const utf8bytes = new Promise(async (resolve)=>{
                const vals = await t.bytes();
                const totalNumBytes = vals.reduce((p, c)=>p + c.length, 0) + $46171d5d254eac88$var$NUM_BYTES_STRING_LENGTH * vals.length;
                const bytes = new Uint8Array(totalNumBytes);
                let offset = 0;
                for(let i = 0; i < vals.length; i++){
                    const val = vals[i];
                    const bytesOfLength = new Uint8Array(new Uint32Array([
                        val.length
                    ]).buffer);
                    bytes.set(bytesOfLength, offset);
                    offset += $46171d5d254eac88$var$NUM_BYTES_STRING_LENGTH;
                    bytes.set(val, offset);
                    offset += val.length;
                }
                resolve(bytes);
            });
            dataPromises.push(utf8bytes);
        } else dataPromises.push(t.data());
        if (group != null) spec.group = group;
        specs.push(spec);
    }
    const tensorValues = await Promise.all(dataPromises);
    return {
        data: $46171d5d254eac88$export$b9f790e5e2031778(tensorValues),
        specs: specs
    };
}
function $46171d5d254eac88$export$7a14c2428d4f4a2e(buffer, specs) {
    // TODO(adarob, cais): Support quantization.
    const out = {};
    let float16Decode;
    let offset = 0;
    for (const spec of specs){
        const name = spec.name;
        const dtype = spec.dtype;
        const shape = spec.shape;
        const size = (0, $4tCOB.sizeFromShape)(shape);
        let values;
        if ('quantization' in spec) {
            const quantization = spec.quantization;
            if (quantization.dtype === 'uint8' || quantization.dtype === 'uint16') {
                if (!('min' in quantization && 'scale' in quantization)) throw new Error(`Weight ${spec.name} with quantization ${quantization.dtype} ` + `doesn't have corresponding metadata min and scale.`);
            } else if (quantization.dtype === 'float16') {
                if (dtype !== 'float32') throw new Error(`Weight ${spec.name} is quantized with ${quantization.dtype} ` + `which only supports weights of type float32 not ${dtype}.`);
            } else throw new Error(`Weight ${spec.name} has unknown ` + `quantization dtype ${quantization.dtype}. ` + `Supported quantization dtypes are: ` + `'uint8', 'uint16', and 'float16'.`);
            const quantizationSizeFactor = (0, $8Q7Um.DTYPE_VALUE_SIZE_MAP)[quantization.dtype];
            const byteBuffer = buffer.slice(offset, offset + size * quantizationSizeFactor);
            const quantizedArray = quantization.dtype === 'uint8' ? new Uint8Array(byteBuffer) : new Uint16Array(byteBuffer);
            if (dtype === 'float32') {
                if (quantization.dtype === 'uint8' || quantization.dtype === 'uint16') {
                    values = new Float32Array(quantizedArray.length);
                    for(let i = 0; i < quantizedArray.length; i++){
                        const v = quantizedArray[i];
                        values[i] = v * quantization.scale + quantization.min;
                    }
                } else if (quantization.dtype === 'float16') {
                    if (float16Decode === undefined) float16Decode = $46171d5d254eac88$export$6f94974d2b5810f7();
                    values = float16Decode(quantizedArray);
                } else throw new Error(`Unsupported quantization type ${quantization.dtype} ` + `for weight type float32.`);
            } else if (dtype === 'int32') {
                if (quantization.dtype !== 'uint8' && quantization.dtype !== 'uint16') throw new Error(`Unsupported quantization type ${quantization.dtype} ` + `for weight type int32.`);
                values = new Int32Array(quantizedArray.length);
                for(let i = 0; i < quantizedArray.length; i++){
                    const v = quantizedArray[i];
                    values[i] = Math.round(v * quantization.scale + quantization.min);
                }
            } else throw new Error(`Unsupported dtype in weight '${name}': ${dtype}`);
            offset += size * quantizationSizeFactor;
        } else if (dtype === 'string') {
            const size = (0, $4tCOB.sizeFromShape)(spec.shape);
            values = [];
            for(let i = 0; i < size; i++){
                const byteLength = new Uint32Array(buffer.slice(offset, offset + $46171d5d254eac88$var$NUM_BYTES_STRING_LENGTH))[0];
                offset += $46171d5d254eac88$var$NUM_BYTES_STRING_LENGTH;
                const bytes = new Uint8Array(buffer.slice(offset, offset + byteLength));
                values.push(bytes);
                offset += byteLength;
            }
        } else {
            const dtypeFactor = (0, $8Q7Um.DTYPE_VALUE_SIZE_MAP)[dtype];
            const byteBuffer = buffer.slice(offset, offset + size * dtypeFactor);
            if (dtype === 'float32') values = new Float32Array(byteBuffer);
            else if (dtype === 'int32') values = new Int32Array(byteBuffer);
            else if (dtype === 'bool') values = new Uint8Array(byteBuffer);
            else if (dtype === 'complex64') {
                values = new Float32Array(byteBuffer);
                const real = new Float32Array(values.length / 2);
                const image = new Float32Array(values.length / 2);
                for(let i = 0; i < real.length; i++){
                    real[i] = values[i * 2];
                    image[i] = values[i * 2 + 1];
                }
                const realTensor = (0, $ec8bD.tensor)(real, shape, 'float32');
                const imageTensor = (0, $ec8bD.tensor)(image, shape, 'float32');
                out[name] = (0, $bxdsK.complex)(realTensor, imageTensor);
                realTensor.dispose();
                imageTensor.dispose();
            } else throw new Error(`Unsupported dtype in weight '${name}': ${dtype}`);
            offset += size * dtypeFactor;
        }
        if (dtype !== 'complex64') out[name] = (0, $ec8bD.tensor)(values, shape, dtype);
    }
    return out;
}
function $46171d5d254eac88$export$b9f790e5e2031778(xs) {
    // TODO(adarob, cais): Support quantization.
    if (xs === null) throw new Error(`Invalid input value: ${JSON.stringify(xs)}`);
    let totalByteLength = 0;
    // `normalizedXs` is here for this reason: a `TypedArray`'s `buffer'
    // can have a different byte length from that of the `TypedArray` itself,
    // for example, when the `TypedArray` is created from an offset in an
    // `ArrayBuffer`. `normliazedXs` holds `TypedArray`s whose `buffer`s match
    // the `TypedArray` in byte length. If an element of `xs` does not show
    // this property, a new `TypedArray` that satisfy this property will be
    // constructed and pushed into `normalizedXs`.
    const normalizedXs = [];
    xs.forEach((x)=>{
        totalByteLength += x.byteLength;
        // tslint:disable:no-any
        normalizedXs.push(x.byteLength === x.buffer.byteLength ? x : new x.constructor(x));
        if (!(x instanceof Float32Array || x instanceof Int32Array || x instanceof Uint8Array)) throw new Error(`Unsupported TypedArray subtype: ${x.constructor.name}`);
    // tslint:enable:no-any
    });
    const y = new Uint8Array(totalByteLength);
    let offset = 0;
    normalizedXs.forEach((x)=>{
        y.set(new Uint8Array(x.buffer), offset);
        offset += x.byteLength;
    });
    return y.buffer;
}
// Use Buffer on Node.js instead of Blob/atob/btoa
const $46171d5d254eac88$var$useNodeBuffer = typeof $46171d5d254eac88$require$Buffer !== 'undefined' && (typeof Blob === 'undefined' || typeof atob === 'undefined' || typeof btoa === 'undefined');
function $46171d5d254eac88$export$42600be9c932993b(str) {
    if ($46171d5d254eac88$var$useNodeBuffer) return $46171d5d254eac88$require$Buffer.byteLength(str);
    return new Blob([
        str
    ]).size;
}
function $46171d5d254eac88$export$28e753ea3e93cabf(buffer) {
    if ($46171d5d254eac88$var$useNodeBuffer) return $46171d5d254eac88$require$Buffer.from(buffer).toString('base64');
    const buf = new Uint8Array(buffer);
    let s = '';
    for(let i = 0, l = buf.length; i < l; i++)s += String.fromCharCode(buf[i]);
    return btoa(s);
}
function $46171d5d254eac88$export$aa941b9d243f1be4(str) {
    if ($46171d5d254eac88$var$useNodeBuffer) {
        const buf = $46171d5d254eac88$require$Buffer.from(str, 'base64');
        return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
    }
    const s = atob(str);
    const buffer = new Uint8Array(s.length);
    for(let i = 0; i < s.length; ++i)buffer.set([
        s.charCodeAt(i)
    ], i);
    return buffer.buffer;
}
function $46171d5d254eac88$export$9a3e9c78eb778da8(buffers) {
    if (buffers.length === 1) return buffers[0];
    let totalByteLength = 0;
    buffers.forEach((buffer)=>{
        totalByteLength += buffer.byteLength;
    });
    const temp = new Uint8Array(totalByteLength);
    let offset = 0;
    buffers.forEach((buffer)=>{
        temp.set(new Uint8Array(buffer), offset);
        offset += buffer.byteLength;
    });
    return temp.buffer;
}
function $46171d5d254eac88$export$9bf319d8f74f51d1(path) {
    const SEPARATOR = '/';
    path = path.trim();
    while(path.endsWith(SEPARATOR))path = path.slice(0, path.length - 1);
    const items = path.split(SEPARATOR);
    return items[items.length - 1];
}
function $46171d5d254eac88$export$a725daa2cfaa7bd5(artifacts, manifest) {
    const result = {
        modelTopology: artifacts.modelTopology,
        format: artifacts.format,
        generatedBy: artifacts.generatedBy,
        convertedBy: artifacts.convertedBy,
        weightsManifest: manifest
    };
    if (artifacts.signature != null) result.signature = artifacts.signature;
    if (artifacts.userDefinedMetadata != null) result.userDefinedMetadata = artifacts.userDefinedMetadata;
    if (artifacts.modelInitializer != null) result.modelInitializer = artifacts.modelInitializer;
    if (artifacts.trainingConfig != null) result.trainingConfig = artifacts.trainingConfig;
    return result;
}
function $46171d5d254eac88$export$ebf48c0f134e5c8(modelJSON, weightSpecs, weightData) {
    const modelArtifacts = {
        modelTopology: modelJSON.modelTopology,
        format: modelJSON.format,
        generatedBy: modelJSON.generatedBy,
        convertedBy: modelJSON.convertedBy
    };
    if (modelJSON.trainingConfig != null) modelArtifacts.trainingConfig = modelJSON.trainingConfig;
    if (modelJSON.weightsManifest != null) {
        if (!weightSpecs) throw new Error('modelJSON has weightsManifest but weightSpecs is null');
        if (!weightData) throw new Error('modelJSON has weightsManifest but weightData is null');
        modelArtifacts.weightSpecs = weightSpecs;
        modelArtifacts.weightData = weightData;
    }
    if (modelJSON.signature != null) modelArtifacts.signature = modelJSON.signature;
    if (modelJSON.userDefinedMetadata != null) modelArtifacts.userDefinedMetadata = modelJSON.userDefinedMetadata;
    if (modelJSON.modelInitializer != null) modelArtifacts.modelInitializer = modelJSON.modelInitializer;
    return modelArtifacts;
}
async function $46171d5d254eac88$export$b867c14eedd5b8a2(modelJSON, loadWeights) {
    let weightSpecs;
    let weightData;
    if (modelJSON.weightsManifest != null) [weightSpecs, weightData] = await loadWeights(modelJSON.weightsManifest);
    return $46171d5d254eac88$export$ebf48c0f134e5c8(modelJSON, weightSpecs, weightData);
}
function $46171d5d254eac88$export$ece8b449d7d29272(modelArtifacts) {
    if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error('Expected JSON model topology, received ArrayBuffer.');
    return {
        dateSaved: new Date(),
        modelTopologyType: 'JSON',
        modelTopologyBytes: modelArtifacts.modelTopology == null ? 0 : $46171d5d254eac88$export$42600be9c932993b(JSON.stringify(modelArtifacts.modelTopology)),
        weightSpecsBytes: modelArtifacts.weightSpecs == null ? 0 : $46171d5d254eac88$export$42600be9c932993b(JSON.stringify(modelArtifacts.weightSpecs)),
        weightDataBytes: modelArtifacts.weightData == null ? 0 : modelArtifacts.weightData.byteLength
    };
}
function $46171d5d254eac88$export$9f3fe06e8e8def44(weightsManifest) {
    const weightSpecs = [];
    for (const entry of weightsManifest)weightSpecs.push(...entry.weights);
    return weightSpecs;
}
/**
 * Computes mantisa table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 2048 mantissa lookup values.
 */ function $46171d5d254eac88$var$computeFloat16MantisaTable() {
    const convertMantissa = (i)=>{
        let m = i << 13;
        let e = 0;
        while((m & 0x00800000) === 0){
            e -= 0x00800000;
            m <<= 1;
        }
        m &= -8388609;
        e += 0x38800000;
        return m | e;
    };
    const mantisaTable = new Uint32Array(2048);
    mantisaTable[0] = 0;
    for(let i = 1; i < 1024; i++)mantisaTable[i] = convertMantissa(i);
    for(let i = 1024; i < 2048; i++)mantisaTable[i] = 0x38000000 + (i - 1024 << 13);
    return mantisaTable;
}
/**
 * Computes exponent table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 64 exponent lookup values.
 */ function $46171d5d254eac88$var$computeFloat16ExponentTable() {
    const exponentTable = new Uint32Array(64);
    exponentTable[0] = 0;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 31; i++)exponentTable[i] = i << 23;
    for(let i = 33; i < 63; i++)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    return exponentTable;
}
/**
 * Computes offset table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 6d offset values.
 */ function $46171d5d254eac88$var$computeFloat16OffsetTable() {
    const offsetTable = new Uint32Array(64);
    for(let i = 0; i < 64; i++)offsetTable[i] = 1024;
    offsetTable[0] = offsetTable[32] = 0;
    return offsetTable;
}
function $46171d5d254eac88$export$6f94974d2b5810f7() {
    // Algorithm is based off of
    // http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
    // Cache lookup tables
    const mantisaTable = $46171d5d254eac88$var$computeFloat16MantisaTable();
    const exponentTable = $46171d5d254eac88$var$computeFloat16ExponentTable();
    const offsetTable = $46171d5d254eac88$var$computeFloat16OffsetTable();
    return (quantizedArray)=>{
        const buffer = new ArrayBuffer(4 * quantizedArray.length);
        const bufferUint32View = new Uint32Array(buffer);
        for(let index = 0; index < quantizedArray.length; index++){
            const float16Bits = quantizedArray[index];
            const float32Bits = mantisaTable[offsetTable[float16Bits >> 10] + (float16Bits & 0x3ff)] + exponentTable[float16Bits >> 10];
            bufferUint32View[index] = float32Bits;
        }
        return new Float32Array(buffer);
    };
}

});
parcelRegister("bxdsK", function(module, exports) {

$parcel$export(module.exports, "complex", () => $865d38311faf26ab$export$83a0e34f1302825b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Converts two real numbers to a complex number.
 *
 * Given a tensor `real` representing the real part of a complex number, and a
 * tensor `imag` representing the imaginary part of a complex number, this
 * operation returns complex numbers elementwise of the form [r0, i0, r1, i1],
 * where r represents the real part and i represents the imag part.
 *
 * The input tensors real and imag must have the same shape.
 *
 * ```js
 * const real = tf.tensor1d([2.25, 3.25]);
 * const imag = tf.tensor1d([4.75, 5.75]);
 * const complex = tf.complex(real, imag);
 *
 * complex.print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $865d38311faf26ab$var$complex_(real, imag) {
    const $real = (0, $5R1UY.convertToTensor)(real, 'real', 'complex');
    const $imag = (0, $5R1UY.convertToTensor)(imag, 'imag', 'complex');
    $4tCOB.assertShapesMatch($real.shape, $imag.shape, `real and imag shapes, ${$real.shape} and ${$imag.shape}, ` + `must match in call to tf.complex().`);
    const inputs = {
        real: $real,
        imag: $imag
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Complex), inputs);
}
const $865d38311faf26ab$export$83a0e34f1302825b = (0, $jKUCi.op)({
    complex_: $865d38311faf26ab$var$complex_
});

});
parcelRegister("5R1UY", function(module, exports) {

$parcel$export(module.exports, "inferShape", () => $443363dfcc9995f8$export$467a8ad638b9ad20);
$parcel$export(module.exports, "convertToTensor", () => $443363dfcc9995f8$export$ede379c4c939d71a);
$parcel$export(module.exports, "convertToTensorArray", () => $443363dfcc9995f8$export$758e66616b4d410b);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $aymVi = parcelRequire("aymVi");

var $bVnU9 = parcelRequire("bVnU9");

var $4tCOB = parcelRequire("4tCOB");
var $wx9lK = parcelRequire("wx9lK");
function $443363dfcc9995f8$export$467a8ad638b9ad20(val, dtype) {
    let firstElem = val;
    if ((0, $4tCOB.isTypedArray)(val)) return dtype === 'string' ? [] : [
        val.length
    ];
    if (!Array.isArray(val)) return []; // Scalar.
    const shape = [];
    while(Array.isArray(firstElem) || (0, $4tCOB.isTypedArray)(firstElem) && dtype !== 'string'){
        shape.push(firstElem.length);
        firstElem = firstElem[0];
    }
    if (Array.isArray(val) && (0, $aymVi.env)().getBool('TENSORLIKE_CHECK_SHAPE_CONSISTENCY')) $443363dfcc9995f8$var$deepAssertShapeConsistency(val, shape, []);
    return shape;
}
function $443363dfcc9995f8$var$deepAssertShapeConsistency(val, shape, indices) {
    indices = indices || [];
    if (!Array.isArray(val) && !(0, $4tCOB.isTypedArray)(val)) {
        (0, $4tCOB.assert)(shape.length === 0, ()=>`Element arr[${indices.join('][')}] is a primitive, ` + `but should be an array/TypedArray of ${shape[0]} elements`);
        return;
    }
    (0, $4tCOB.assert)(shape.length > 0, ()=>`Element arr[${indices.join('][')}] should be a primitive, ` + `but is an array of ${val.length} elements`);
    (0, $4tCOB.assert)(val.length === shape[0], ()=>`Element arr[${indices.join('][')}] should have ${shape[0]} ` + `elements, but has ${val.length} elements`);
    const subShape = shape.slice(1);
    for(let i = 0; i < val.length; ++i)$443363dfcc9995f8$var$deepAssertShapeConsistency(val[i], subShape, indices.concat(i));
}
function $443363dfcc9995f8$var$assertDtype(expectedDtype, actualDType, argName, functionName) {
    if (expectedDtype === 'string_or_numeric') return;
    if (expectedDtype == null) throw new Error(`Expected dtype cannot be null.`);
    if (expectedDtype !== 'numeric' && expectedDtype !== actualDType || expectedDtype === 'numeric' && actualDType === 'string') throw new Error(`Argument '${argName}' passed to '${functionName}' must ` + `be ${expectedDtype} tensor, but got ${actualDType} tensor`);
}
function $443363dfcc9995f8$export$ede379c4c939d71a(x, argName, functionName, parseAsDtype = 'numeric') {
    if (x instanceof (0, $bVnU9.Tensor)) {
        $443363dfcc9995f8$var$assertDtype(parseAsDtype, x.dtype, argName, functionName);
        return x;
    }
    let inferredDtype = (0, $4tCOB.inferDtype)(x);
    // If the user expects a bool/int/float, use that info to update the
    // inferredDtype when it is not a string.
    if (inferredDtype !== 'string' && [
        'bool',
        'int32',
        'float32'
    ].indexOf(parseAsDtype) >= 0) inferredDtype = parseAsDtype;
    $443363dfcc9995f8$var$assertDtype(parseAsDtype, inferredDtype, argName, functionName);
    if (x == null || !(0, $4tCOB.isTypedArray)(x) && !Array.isArray(x) && typeof x !== 'number' && typeof x !== 'boolean' && typeof x !== 'string') {
        const type = x == null ? 'null' : x.constructor.name;
        throw new Error(`Argument '${argName}' passed to '${functionName}' must be a ` + `Tensor or TensorLike, but got '${type}'`);
    }
    const inferredShape = $443363dfcc9995f8$export$467a8ad638b9ad20(x, inferredDtype);
    if (!(0, $4tCOB.isTypedArray)(x) && !Array.isArray(x)) x = [
        x
    ];
    const skipTypedArray = true;
    const values = inferredDtype !== 'string' ? (0, $wx9lK.toTypedArray)(x, inferredDtype) : (0, $4tCOB.flatten)(x, [], skipTypedArray);
    return (0, $aHfUM.ENGINE).makeTensor(values, inferredShape, inferredDtype);
}
function $443363dfcc9995f8$export$758e66616b4d410b(arg, argName, functionName, parseAsDtype = 'numeric') {
    if (!Array.isArray(arg)) throw new Error(`Argument ${argName} passed to ${functionName} must be a ` + '`Tensor[]` or `TensorLike[]`');
    const tensors = arg;
    return tensors.map((t, i)=>$443363dfcc9995f8$export$ede379c4c939d71a(t, `${argName}[${i}]`, functionName, parseAsDtype));
}

});

parcelRegister("jKUCi", function(module, exports) {

$parcel$export(module.exports, "OP_SCOPE_SUFFIX", () => $e61e3b1473f4b3e8$export$93114f1494faf9bb);
$parcel$export(module.exports, "op", () => $e61e3b1473f4b3e8$export$f59964a629598e2);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $4tCOB = parcelRequire("4tCOB");
const $e61e3b1473f4b3e8$export$93114f1494faf9bb = '__op';
function $e61e3b1473f4b3e8$export$f59964a629598e2(f) {
    const keys = Object.keys(f);
    if (keys.length !== 1) throw new Error(`Please provide an object with a single key ` + `(operation name) mapping to a function. Got an object with ` + `${keys.length} keys.`);
    let opName = keys[0];
    const fn = f[opName];
    // Strip the underscore from the end of the function name.
    if (opName.endsWith('_')) opName = opName.substring(0, opName.length - 1);
    // add an __op suffix to distinguish ops from kernels in tf.profile
    opName = opName + $e61e3b1473f4b3e8$export$93114f1494faf9bb;
    // tslint:disable-next-line:no-any
    const f2 = (...args)=>{
        (0, $aHfUM.ENGINE).startScope(opName);
        try {
            const result = fn(...args);
            if ((0, $4tCOB.isPromise)(result)) console.error('Cannot return a Promise inside of tidy.');
            (0, $aHfUM.ENGINE).endScope(result);
            return result;
        } catch (ex) {
            (0, $aHfUM.ENGINE).endScope(null);
            throw ex;
        }
    };
    Object.defineProperty(f2, 'name', {
        value: opName,
        configurable: true
    });
    // tslint:disable-next-line:no-any
    return f2;
}

});


parcelRegister("ec8bD", function(module, exports) {

$parcel$export(module.exports, "tensor", () => $a5588966e86825eb$export$65df3ad1ad888abb);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $lVIqi = parcelRequire("lVIqi");
function $a5588966e86825eb$export$65df3ad1ad888abb(values, shape, dtype) {
    const inferredShape = (0, $5R1UY.inferShape)(values, dtype);
    return (0, $lVIqi.makeTensor)(values, shape, inferredShape, dtype);
}

});
parcelRegister("lVIqi", function(module, exports) {

$parcel$export(module.exports, "makeTensor", () => $ff71615a01cab400$export$f41686c891d7ebce);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $4tCOB = parcelRequire("4tCOB");
var $wx9lK = parcelRequire("wx9lK");
function $ff71615a01cab400$export$f41686c891d7ebce(values, shape, inferredShape, dtype) {
    if (dtype == null) dtype = (0, $4tCOB.inferDtype)(values);
    if (dtype === 'complex64') throw new Error(`Cannot construct a complex64 tensor directly. ` + `Please use tf.complex(real, imag).`);
    if (!(0, $4tCOB.isTypedArray)(values) && !Array.isArray(values) && typeof values !== 'number' && typeof values !== 'boolean' && typeof values !== 'string') throw new Error("values passed to tensor(values) must be a number/boolean/string or an array of numbers/booleans/strings, or a TypedArray");
    if (shape != null) {
        (0, $4tCOB.assertNonNegativeIntegerDimensions)(shape);
        const providedSize = (0, $4tCOB.sizeFromShape)(shape);
        const inferredSize = (0, $4tCOB.sizeFromShape)(inferredShape);
        (0, $4tCOB.assert)(providedSize === inferredSize, ()=>`Based on the provided shape, [${shape}], the tensor should have ` + `${providedSize} values but has ${inferredSize}`);
        for(let i = 0; i < inferredShape.length; ++i){
            const inferred = inferredShape[i];
            const flatDimsDontMatch = i === inferredShape.length - 1 ? inferred !== (0, $4tCOB.sizeFromShape)(shape.slice(i)) : true;
            (0, $4tCOB.assert)(inferredShape[i] === shape[i] || !flatDimsDontMatch, ()=>`Error creating a new Tensor. Inferred shape ` + `(${inferredShape}) does not match the provided ` + `shape (${shape}). `);
        }
    }
    if (!(0, $4tCOB.isTypedArray)(values) && !Array.isArray(values)) values = [
        values
    ];
    shape = shape || inferredShape;
    values = dtype !== 'string' ? (0, $wx9lK.toTypedArray)(values, dtype) : (0, $4tCOB.flatten)(values, [], true);
    return (0, $aHfUM.ENGINE).makeTensor(values, shape, dtype);
}

});


parcelRegister("8Q7Um", function(module, exports) {

$parcel$export(module.exports, "DTYPE_VALUE_SIZE_MAP", () => $66f9506d3d3cc706$export$8103dee73e5eaa46);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /* Type definitions for exporting and importing of models. */ /**
 * A map from Tensor dtype to number of bytes per element of the Tensor.
 */ const $66f9506d3d3cc706$export$8103dee73e5eaa46 = {
    'float32': 4,
    'float16': 2,
    'int32': 4,
    'uint16': 2,
    'uint8': 1,
    'bool': 1,
    'complex64': 8
};

});

parcelRegister("cbQCu", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $8dff54558831dec9$export$a143d493d941bafc, (v) => $8dff54558831dec9$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $8dff54558831dec9$export$f99ded8fe4b79145, (v) => $8dff54558831dec9$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
'use strict';

var $6ocIT = parcelRequire("6ocIT");

var $1wLos = parcelRequire("1wLos");
const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case 'base64':
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6ocIT.fromByteArray(buf);
    else return $6ocIT.fromByteArray(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$8dff54558831dec9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $6ocIT.toByteArray($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("6ocIT", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $4a6eda7d0e4e0857$export$d622b2ad8d90c771, (v) => $4a6eda7d0e4e0857$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $4a6eda7d0e4e0857$export$6100ba28696e12de, (v) => $4a6eda7d0e4e0857$export$6100ba28696e12de = v);
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
'use strict';
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup['-'.charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup['_'.charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("1wLos", function(module, exports) {

$parcel$export(module.exports, "read", () => $11cd8afb6c84e33a$export$aafa59e2e03f2942, (v) => $11cd8afb6c84e33a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $11cd8afb6c84e33a$export$68d8715fc104d294, (v) => $11cd8afb6c84e33a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("i9ref", function(module, exports) {

$parcel$export(module.exports, "IORouterRegistry", () => $d36e305941513669$export$512275d398c0bdcd);
$parcel$export(module.exports, "registerSaveRouter", () => $d36e305941513669$export$94da4683f36f634e);
$parcel$export(module.exports, "registerLoadRouter", () => $d36e305941513669$export$8bf64df3d1fb9866);
$parcel$export(module.exports, "getSaveHandlers", () => $d36e305941513669$export$88af18fd9ddb62ff);
$parcel$export(module.exports, "getLoadHandlers", () => $d36e305941513669$export$90c6c4d24103fa9a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $d36e305941513669$export$512275d398c0bdcd {
    constructor(){
        this.saveRouters = [];
        this.loadRouters = [];
    }
    static getInstance() {
        if ($d36e305941513669$export$512275d398c0bdcd.instance == null) $d36e305941513669$export$512275d398c0bdcd.instance = new $d36e305941513669$export$512275d398c0bdcd();
        return $d36e305941513669$export$512275d398c0bdcd.instance;
    }
    /**
     * Register a save-handler router.
     *
     * @param saveRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `save` method defined or `null`.
     */ static registerSaveRouter(saveRouter) {
        $d36e305941513669$export$512275d398c0bdcd.getInstance().saveRouters.push(saveRouter);
    }
    /**
     * Register a load-handler router.
     *
     * @param loadRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `load` method defined or `null`.
     */ static registerLoadRouter(loadRouter) {
        $d36e305941513669$export$512275d398c0bdcd.getInstance().loadRouters.push(loadRouter);
    }
    /**
     * Look up IOHandler for saving, given a URL-like string.
     *
     * @param url
     * @returns If only one match is found, an instance of IOHandler with the
     * `save` method defined. If no match is found, `null`.
     * @throws Error, if more than one match is found.
     */ static getSaveHandlers(url) {
        return $d36e305941513669$export$512275d398c0bdcd.getHandlers(url, 'save');
    }
    /**
     * Look up IOHandler for loading, given a URL-like string.
     *
     * @param url
     * @param loadOptions Optional, custom load options.
     * @returns All valid handlers for `url`, given the currently registered
     *   handler routers.
     */ static getLoadHandlers(url, loadOptions) {
        return $d36e305941513669$export$512275d398c0bdcd.getHandlers(url, 'load', loadOptions);
    }
    static getHandlers(url, handlerType, loadOptions) {
        const validHandlers = [];
        const routers = handlerType === 'load' ? $d36e305941513669$export$512275d398c0bdcd.getInstance().loadRouters : $d36e305941513669$export$512275d398c0bdcd.getInstance().saveRouters;
        routers.forEach((router)=>{
            const handler = router(url, loadOptions);
            if (handler !== null) validHandlers.push(handler);
        });
        return validHandlers;
    }
}
const $d36e305941513669$export$94da4683f36f634e = (loudRouter)=>$d36e305941513669$export$512275d398c0bdcd.registerSaveRouter(loudRouter);
const $d36e305941513669$export$8bf64df3d1fb9866 = (loudRouter)=>$d36e305941513669$export$512275d398c0bdcd.registerLoadRouter(loudRouter);
const $d36e305941513669$export$88af18fd9ddb62ff = (url)=>$d36e305941513669$export$512275d398c0bdcd.getSaveHandlers(url);
const $d36e305941513669$export$90c6c4d24103fa9a = (url, loadOptions)=>$d36e305941513669$export$512275d398c0bdcd.getLoadHandlers(url, loadOptions);

});


parcelRegister("gIO3p", function(module, exports) {

$parcel$export(module.exports, "BrowserLocalStorage", () => $c2c79513366c786f$export$8984a84f7aef20de);
$parcel$export(module.exports, "BrowserLocalStorageManager", () => $c2c79513366c786f$export$bb7e7fb445a616f4);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("aQg53");

var $aymVi = parcelRequire("aymVi");

var $4tCOB = parcelRequire("4tCOB");

var $615w2 = parcelRequire("615w2");

var $i9ref = parcelRequire("i9ref");
const $c2c79513366c786f$var$PATH_SEPARATOR = '/';
const $c2c79513366c786f$var$PATH_PREFIX = 'tensorflowjs_models';
const $c2c79513366c786f$var$INFO_SUFFIX = 'info';
const $c2c79513366c786f$var$MODEL_TOPOLOGY_SUFFIX = 'model_topology';
const $c2c79513366c786f$var$WEIGHT_SPECS_SUFFIX = 'weight_specs';
const $c2c79513366c786f$var$WEIGHT_DATA_SUFFIX = 'weight_data';
const $c2c79513366c786f$var$MODEL_METADATA_SUFFIX = 'model_metadata';
function $c2c79513366c786f$export$af2a48c9611db360() {
    if (!(0, $aymVi.env)().getBool('IS_BROWSER') || typeof window === 'undefined' || typeof window.localStorage === 'undefined') throw new Error("purgeLocalStorageModels() cannot proceed because local storage is unavailable in the current environment.");
    const LS = window.localStorage;
    const purgedModelPaths = [];
    for(let i = 0; i < LS.length; ++i){
        const key = LS.key(i);
        const prefix = $c2c79513366c786f$var$PATH_PREFIX + $c2c79513366c786f$var$PATH_SEPARATOR;
        if (key.startsWith(prefix) && key.length > prefix.length) {
            LS.removeItem(key);
            const modelName = $c2c79513366c786f$var$getModelPathFromKey(key);
            if (purgedModelPaths.indexOf(modelName) === -1) purgedModelPaths.push(modelName);
        }
    }
    return purgedModelPaths;
}
function $c2c79513366c786f$var$getModelKeys(path) {
    return {
        info: [
            $c2c79513366c786f$var$PATH_PREFIX,
            path,
            $c2c79513366c786f$var$INFO_SUFFIX
        ].join($c2c79513366c786f$var$PATH_SEPARATOR),
        topology: [
            $c2c79513366c786f$var$PATH_PREFIX,
            path,
            $c2c79513366c786f$var$MODEL_TOPOLOGY_SUFFIX
        ].join($c2c79513366c786f$var$PATH_SEPARATOR),
        weightSpecs: [
            $c2c79513366c786f$var$PATH_PREFIX,
            path,
            $c2c79513366c786f$var$WEIGHT_SPECS_SUFFIX
        ].join($c2c79513366c786f$var$PATH_SEPARATOR),
        weightData: [
            $c2c79513366c786f$var$PATH_PREFIX,
            path,
            $c2c79513366c786f$var$WEIGHT_DATA_SUFFIX
        ].join($c2c79513366c786f$var$PATH_SEPARATOR),
        modelMetadata: [
            $c2c79513366c786f$var$PATH_PREFIX,
            path,
            $c2c79513366c786f$var$MODEL_METADATA_SUFFIX
        ].join($c2c79513366c786f$var$PATH_SEPARATOR)
    };
}
function $c2c79513366c786f$var$removeItems(keys) {
    for (const key of Object.values(keys))window.localStorage.removeItem(key);
}
/**
 * Get model path from a local-storage key.
 *
 * E.g., 'tensorflowjs_models/my/model/1/info' --> 'my/model/1'
 *
 * @param key
 */ function $c2c79513366c786f$var$getModelPathFromKey(key) {
    const items = key.split($c2c79513366c786f$var$PATH_SEPARATOR);
    if (items.length < 3) throw new Error(`Invalid key format: ${key}`);
    return items.slice(1, items.length - 1).join($c2c79513366c786f$var$PATH_SEPARATOR);
}
function $c2c79513366c786f$var$maybeStripScheme(key) {
    return key.startsWith($c2c79513366c786f$export$8984a84f7aef20de.URL_SCHEME) ? key.slice($c2c79513366c786f$export$8984a84f7aef20de.URL_SCHEME.length) : key;
}
class $c2c79513366c786f$export$8984a84f7aef20de {
    constructor(modelPath){
        if (!(0, $aymVi.env)().getBool('IS_BROWSER') || typeof window === 'undefined' || typeof window.localStorage === 'undefined') // TODO(cais): Add more info about what IOHandler subtypes are
        // available.
        //   Maybe point to a doc page on the web and/or automatically determine
        //   the available IOHandlers and print them in the error message.
        throw new Error('The current environment does not support local storage.');
        this.LS = window.localStorage;
        if (modelPath == null || !modelPath) throw new Error('For local storage, modelPath must not be null, undefined or empty.');
        this.modelPath = modelPath;
        this.keys = $c2c79513366c786f$var$getModelKeys(this.modelPath);
    }
    /**
     * Save model artifacts to browser local storage.
     *
     * See the documentation to `browserLocalStorage` for details on the saved
     * artifacts.
     *
     * @param modelArtifacts The model artifacts to be stored.
     * @returns An instance of SaveResult.
     */ async save(modelArtifacts) {
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        else {
            const topology = JSON.stringify(modelArtifacts.modelTopology);
            const weightSpecs = JSON.stringify(modelArtifacts.weightSpecs);
            const modelArtifactsInfo = (0, $615w2.getModelArtifactsInfoForJSON)(modelArtifacts);
            try {
                this.LS.setItem(this.keys.info, JSON.stringify(modelArtifactsInfo));
                this.LS.setItem(this.keys.topology, topology);
                this.LS.setItem(this.keys.weightSpecs, weightSpecs);
                this.LS.setItem(this.keys.weightData, (0, $615w2.arrayBufferToBase64String)(modelArtifacts.weightData));
                // Note that JSON.stringify doesn't write out keys that have undefined
                // values, so for some keys, we set undefined instead of a null-ish
                // value.
                const metadata = {
                    format: modelArtifacts.format,
                    generatedBy: modelArtifacts.generatedBy,
                    convertedBy: modelArtifacts.convertedBy,
                    signature: modelArtifacts.signature != null ? modelArtifacts.signature : undefined,
                    userDefinedMetadata: modelArtifacts.userDefinedMetadata != null ? modelArtifacts.userDefinedMetadata : undefined,
                    modelInitializer: modelArtifacts.modelInitializer != null ? modelArtifacts.modelInitializer : undefined,
                    trainingConfig: modelArtifacts.trainingConfig != null ? modelArtifacts.trainingConfig : undefined
                };
                this.LS.setItem(this.keys.modelMetadata, JSON.stringify(metadata));
                return {
                    modelArtifactsInfo: modelArtifactsInfo
                };
            } catch (err) {
                // If saving failed, clean up all items saved so far.
                $c2c79513366c786f$var$removeItems(this.keys);
                throw new Error(`Failed to save model '${this.modelPath}' to local storage: ` + `size quota being exceeded is a possible cause of this failure: ` + `modelTopologyBytes=${modelArtifactsInfo.modelTopologyBytes}, ` + `weightSpecsBytes=${modelArtifactsInfo.weightSpecsBytes}, ` + `weightDataBytes=${modelArtifactsInfo.weightDataBytes}.`);
            }
        }
    }
    /**
     * Load a model from local storage.
     *
     * See the documentation to `browserLocalStorage` for details on the saved
     * artifacts.
     *
     * @returns The loaded model (if loading succeeds).
     */ async load() {
        const info = JSON.parse(this.LS.getItem(this.keys.info));
        if (info == null) throw new Error(`In local storage, there is no model with name '${this.modelPath}'`);
        if (info.modelTopologyType !== 'JSON') throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");
        const out = {};
        // Load topology.
        const topology = JSON.parse(this.LS.getItem(this.keys.topology));
        if (topology == null) throw new Error(`In local storage, the topology of model '${this.modelPath}' ` + `is missing.`);
        out.modelTopology = topology;
        // Load weight specs.
        const weightSpecs = JSON.parse(this.LS.getItem(this.keys.weightSpecs));
        if (weightSpecs == null) throw new Error(`In local storage, the weight specs of model '${this.modelPath}' ` + `are missing.`);
        out.weightSpecs = weightSpecs;
        // Load meta-data fields.
        const metadataString = this.LS.getItem(this.keys.modelMetadata);
        if (metadataString != null) {
            const metadata = JSON.parse(metadataString);
            out.format = metadata.format;
            out.generatedBy = metadata.generatedBy;
            out.convertedBy = metadata.convertedBy;
            if (metadata.signature != null) out.signature = metadata.signature;
            if (metadata.userDefinedMetadata != null) out.userDefinedMetadata = metadata.userDefinedMetadata;
            if (metadata.modelInitializer != null) out.modelInitializer = metadata.modelInitializer;
            if (metadata.trainingConfig != null) out.trainingConfig = metadata.trainingConfig;
        }
        // Load weight data.
        const weightDataBase64 = this.LS.getItem(this.keys.weightData);
        if (weightDataBase64 == null) throw new Error(`In local storage, the binary weight values of model ` + `'${this.modelPath}' are missing.`);
        out.weightData = (0, $615w2.base64StringToArrayBuffer)(weightDataBase64);
        return out;
    }
}
$c2c79513366c786f$export$8984a84f7aef20de.URL_SCHEME = 'localstorage://';
const $c2c79513366c786f$export$64ff64fd6b1180ae = (url)=>{
    if (!(0, $aymVi.env)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($c2c79513366c786f$export$8984a84f7aef20de.URL_SCHEME)) return $c2c79513366c786f$export$96d8dd89e6c22307(url.slice($c2c79513366c786f$export$8984a84f7aef20de.URL_SCHEME.length));
        else return null;
    }
};
(0, $i9ref.IORouterRegistry).registerSaveRouter($c2c79513366c786f$export$64ff64fd6b1180ae);
(0, $i9ref.IORouterRegistry).registerLoadRouter($c2c79513366c786f$export$64ff64fd6b1180ae);
function $c2c79513366c786f$export$96d8dd89e6c22307(modelPath) {
    return new $c2c79513366c786f$export$8984a84f7aef20de(modelPath);
}
class $c2c79513366c786f$export$bb7e7fb445a616f4 {
    constructor(){
        (0, $4tCOB.assert)((0, $aymVi.env)().getBool('IS_BROWSER'), ()=>'Current environment is not a web browser');
        (0, $4tCOB.assert)(typeof window === 'undefined' || typeof window.localStorage !== 'undefined', ()=>'Current browser does not appear to support localStorage');
        this.LS = window.localStorage;
    }
    async listModels() {
        const out = {};
        const prefix = $c2c79513366c786f$var$PATH_PREFIX + $c2c79513366c786f$var$PATH_SEPARATOR;
        const suffix = $c2c79513366c786f$var$PATH_SEPARATOR + $c2c79513366c786f$var$INFO_SUFFIX;
        for(let i = 0; i < this.LS.length; ++i){
            const key = this.LS.key(i);
            if (key.startsWith(prefix) && key.endsWith(suffix)) {
                const modelPath = $c2c79513366c786f$var$getModelPathFromKey(key);
                out[modelPath] = JSON.parse(this.LS.getItem(key));
            }
        }
        return out;
    }
    async removeModel(path) {
        path = $c2c79513366c786f$var$maybeStripScheme(path);
        const keys = $c2c79513366c786f$var$getModelKeys(path);
        if (this.LS.getItem(keys.info) == null) throw new Error(`Cannot find model at path '${path}'`);
        const info = JSON.parse(this.LS.getItem(keys.info));
        $c2c79513366c786f$var$removeItems(keys);
        return info;
    }
}

});

parcelRegister("1EsOW", function(module, exports) {

$parcel$export(module.exports, "ModelStoreManagerRegistry", () => $133fe20f85b0b49c$export$ccf7f72dec8f0028);
$parcel$export(module.exports, "listModels", () => $133fe20f85b0b49c$export$8d63af86d795ece4);
$parcel$export(module.exports, "removeModel", () => $133fe20f85b0b49c$export$e71037184d1ad0fd);
$parcel$export(module.exports, "copyModel", () => $133fe20f85b0b49c$export$b5971478866000ed);
$parcel$export(module.exports, "moveModel", () => $133fe20f85b0b49c$export$598f168272f4fec2);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Classes and functions for model management across multiple storage mediums.
 *
 * Supported client actions:
 * - Listing models on all registered storage mediums.
 * - Remove model by URL from any registered storage mediums, by using URL
 *   string.
 * - Moving or copying model from one path to another in the same medium or from
 *   one medium to another, by using URL strings.
 */ 
var $4tCOB = parcelRequire("4tCOB");

var $i9ref = parcelRequire("i9ref");
const $133fe20f85b0b49c$var$URL_SCHEME_SUFFIX = '://';
class $133fe20f85b0b49c$export$ccf7f72dec8f0028 {
    constructor(){
        this.managers = {};
    }
    static getInstance() {
        if ($133fe20f85b0b49c$export$ccf7f72dec8f0028.instance == null) $133fe20f85b0b49c$export$ccf7f72dec8f0028.instance = new $133fe20f85b0b49c$export$ccf7f72dec8f0028();
        return $133fe20f85b0b49c$export$ccf7f72dec8f0028.instance;
    }
    /**
     * Register a save-handler router.
     *
     * @param saveRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `save` method defined or `null`.
     */ static registerManager(scheme, manager) {
        (0, $4tCOB.assert)(scheme != null, ()=>'scheme must not be undefined or null.');
        if (scheme.endsWith($133fe20f85b0b49c$var$URL_SCHEME_SUFFIX)) scheme = scheme.slice(0, scheme.indexOf($133fe20f85b0b49c$var$URL_SCHEME_SUFFIX));
        (0, $4tCOB.assert)(scheme.length > 0, ()=>'scheme must not be an empty string.');
        const registry = $133fe20f85b0b49c$export$ccf7f72dec8f0028.getInstance();
        (0, $4tCOB.assert)(registry.managers[scheme] == null, ()=>`A model store manager is already registered for scheme '${scheme}'.`);
        registry.managers[scheme] = manager;
    }
    static getManager(scheme) {
        const manager = $133fe20f85b0b49c$export$ccf7f72dec8f0028.getInstance().managers[scheme];
        if (manager == null) throw new Error(`Cannot find model manager for scheme '${scheme}'`);
        return manager;
    }
    static getSchemes() {
        return Object.keys($133fe20f85b0b49c$export$ccf7f72dec8f0028.getInstance().managers);
    }
}
/**
 * Helper method for parsing a URL string into a scheme and a path.
 *
 * @param url E.g., 'localstorage://my-model'
 * @returns A dictionary with two fields: scheme and path.
 *   Scheme: e.g., 'localstorage' in the example above.
 *   Path: e.g., 'my-model' in the example above.
 */ function $133fe20f85b0b49c$var$parseURL(url) {
    if (url.indexOf($133fe20f85b0b49c$var$URL_SCHEME_SUFFIX) === -1) throw new Error(`The url string provided does not contain a scheme. ` + `Supported schemes are: ` + `${$133fe20f85b0b49c$export$ccf7f72dec8f0028.getSchemes().join(',')}`);
    return {
        scheme: url.split($133fe20f85b0b49c$var$URL_SCHEME_SUFFIX)[0],
        path: url.split($133fe20f85b0b49c$var$URL_SCHEME_SUFFIX)[1]
    };
}
async function $133fe20f85b0b49c$var$cloneModelInternal(sourceURL, destURL, deleteSource = false) {
    (0, $4tCOB.assert)(sourceURL !== destURL, ()=>`Old path and new path are the same: '${sourceURL}'`);
    const loadHandlers = (0, $i9ref.IORouterRegistry).getLoadHandlers(sourceURL);
    (0, $4tCOB.assert)(loadHandlers.length > 0, ()=>`Copying failed because no load handler is found for source URL ${sourceURL}.`);
    (0, $4tCOB.assert)(loadHandlers.length < 2, ()=>`Copying failed because more than one (${loadHandlers.length}) ` + `load handlers for source URL ${sourceURL}.`);
    const loadHandler = loadHandlers[0];
    const saveHandlers = (0, $i9ref.IORouterRegistry).getSaveHandlers(destURL);
    (0, $4tCOB.assert)(saveHandlers.length > 0, ()=>`Copying failed because no save handler is found for destination ` + `URL ${destURL}.`);
    (0, $4tCOB.assert)(saveHandlers.length < 2, ()=>`Copying failed because more than one (${loadHandlers.length}) ` + `save handlers for destination URL ${destURL}.`);
    const saveHandler = saveHandlers[0];
    const sourceScheme = $133fe20f85b0b49c$var$parseURL(sourceURL).scheme;
    const sourcePath = $133fe20f85b0b49c$var$parseURL(sourceURL).path;
    const sameMedium = sourceScheme === $133fe20f85b0b49c$var$parseURL(sourceURL).scheme;
    const modelArtifacts = await loadHandler.load();
    // If moving within the same storage medium, remove the old model as soon as
    // the loading is done. Without doing this, it is possible that the combined
    // size of the two models will cause the cloning to fail.
    if (deleteSource && sameMedium) await $133fe20f85b0b49c$export$ccf7f72dec8f0028.getManager(sourceScheme).removeModel(sourcePath);
    const saveResult = await saveHandler.save(modelArtifacts);
    // If moving between mediums, the deletion is done after the save succeeds.
    // This guards against the case in which saving to the destination medium
    // fails.
    if (deleteSource && !sameMedium) await $133fe20f85b0b49c$export$ccf7f72dec8f0028.getManager(sourceScheme).removeModel(sourcePath);
    return saveResult.modelArtifactsInfo;
}
/**
 * List all models stored in registered storage mediums.
 *
 * For a web browser environment, the registered mediums are Local Storage and
 * IndexedDB.
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Delete the model.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 * ```
 *
 * @returns A `Promise` of a dictionary mapping URLs of existing models to
 * their model artifacts info. URLs include medium-specific schemes, e.g.,
 *   'indexeddb://my/model/1'. Model artifacts info include type of the
 * model's topology, byte sizes of the topology, weights, etc.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $133fe20f85b0b49c$export$8d63af86d795ece4() {
    const schemes = $133fe20f85b0b49c$export$ccf7f72dec8f0028.getSchemes();
    const out = {};
    for (const scheme of schemes){
        const schemeOut = await $133fe20f85b0b49c$export$ccf7f72dec8f0028.getManager(scheme).listModels();
        for(const path in schemeOut){
            const url = scheme + $133fe20f85b0b49c$var$URL_SCHEME_SUFFIX + path;
            out[url] = schemeOut[path];
        }
    }
    return out;
}
/**
 * Remove a model specified by URL from a registered storage medium.
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Delete the model.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 * ```
 *
 * @param url A URL to a stored model, with a scheme prefix, e.g.,
 *   'localstorage://my-model-1', 'indexeddb://my/model/2'.
 * @returns ModelArtifactsInfo of the deleted model (if and only if deletion
 *   is successful).
 * @throws Error if deletion fails, e.g., if no model exists at `path`.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $133fe20f85b0b49c$export$e71037184d1ad0fd(url) {
    const schemeAndPath = $133fe20f85b0b49c$var$parseURL(url);
    const manager = $133fe20f85b0b49c$export$ccf7f72dec8f0028.getManager(schemeAndPath.scheme);
    return manager.removeModel(schemeAndPath.path);
}
/**
 * Copy a model from one URL to another.
 *
 * This function supports:
 *
 * 1. Copying within a storage medium, e.g.,
 *    `tf.io.copyModel('localstorage://model-1', 'localstorage://model-2')`
 * 2. Copying between two storage mediums, e.g.,
 *    `tf.io.copyModel('localstorage://model-1', 'indexeddb://model-1')`
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Copy the model, from Local Storage to IndexedDB.
 * await tf.io.copyModel(
 *     'localstorage://demo/management/model1',
 *     'indexeddb://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Remove both models.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 * await tf.io.removeModel('indexeddb://demo/management/model1');
 * ```
 *
 * @param sourceURL Source URL of copying.
 * @param destURL Destination URL of copying.
 * @returns ModelArtifactsInfo of the copied model (if and only if copying
 *   is successful).
 * @throws Error if copying fails, e.g., if no model exists at `sourceURL`, or
 *   if `oldPath` and `newPath` are identical.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $133fe20f85b0b49c$export$b5971478866000ed(sourceURL, destURL) {
    const deleteSource = false;
    return $133fe20f85b0b49c$var$cloneModelInternal(sourceURL, destURL, deleteSource);
}
/**
 * Move a model from one URL to another.
 *
 * This function supports:
 *
 * 1. Moving within a storage medium, e.g.,
 *    `tf.io.moveModel('localstorage://model-1', 'localstorage://model-2')`
 * 2. Moving between two storage mediums, e.g.,
 *    `tf.io.moveModel('localstorage://model-1', 'indexeddb://model-1')`
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Move the model, from Local Storage to IndexedDB.
 * await tf.io.moveModel(
 *     'localstorage://demo/management/model1',
 *     'indexeddb://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Remove the moved model.
 * await tf.io.removeModel('indexeddb://demo/management/model1');
 * ```
 *
 * @param sourceURL Source URL of moving.
 * @param destURL Destination URL of moving.
 * @returns ModelArtifactsInfo of the copied model (if and only if copying
 *   is successful).
 * @throws Error if moving fails, e.g., if no model exists at `sourceURL`, or
 *   if `oldPath` and `newPath` are identical.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $133fe20f85b0b49c$export$598f168272f4fec2(sourceURL, destURL) {
    const deleteSource = true;
    return $133fe20f85b0b49c$var$cloneModelInternal(sourceURL, destURL, deleteSource);
}

});


parcelRegister("5kQGc", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aymVi = parcelRequire("aymVi");

var $4Jj9n = parcelRequire("4Jj9n");

const $3e27af124e41a48b$export$fc0623918121e18f = {
    // tslint:disable-next-line:no-require-imports
    importFetch: ()=>(parcelRequire("1frus"))
};
let $3e27af124e41a48b$var$systemFetch;
function $3e27af124e41a48b$export$ab67f817cc7ff6dc() {
    $3e27af124e41a48b$var$systemFetch = null;
}
function $3e27af124e41a48b$export$fec6b32271d1a551(fetchFn) {
    $3e27af124e41a48b$var$systemFetch = fetchFn;
}
function $3e27af124e41a48b$export$f53da9ce5ba19de0() {
    return $3e27af124e41a48b$var$systemFetch;
}

class $3e27af124e41a48b$export$7befb6c3de272049 {
    constructor(){
        // tslint:disable-next-line:no-require-imports
        this.util = (parcelRequire("1frus"));
        // According to the spec, the built-in encoder can do only UTF-8 encoding.
        // https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder/TextEncoder
        this.textEncoder = new this.util.TextEncoder();
    }
    fetch(path, requestInits) {
        if ((0, $aymVi.env)().global.fetch != null) return (0, $aymVi.env)().global.fetch(path, requestInits);
        if ($3e27af124e41a48b$var$systemFetch == null) $3e27af124e41a48b$var$systemFetch = $3e27af124e41a48b$export$fc0623918121e18f.importFetch();
        return $3e27af124e41a48b$var$systemFetch(path, requestInits);
    }
    now() {
        const time = $4Jj9n.hrtime();
        return time[0] * 1000 + time[1] / 1000000;
    }
    encode(text, encoding) {
        if (encoding !== 'utf-8' && encoding !== 'utf8') throw new Error(`Node built-in encoder only supports utf-8, but got ${encoding}`);
        return this.textEncoder.encode(text);
    }
    decode(bytes, encoding) {
        if (bytes.length === 0) return '';
        return new this.util.TextDecoder(encoding).decode(bytes);
    }
}
if ((0, $aymVi.env)().get('IS_NODE') && !(0, $aymVi.env)().get('IS_BROWSER')) (0, $aymVi.env)().setPlatform('node', new $3e27af124e41a48b$export$7befb6c3de272049());

});

parcelRegister("g81BN", function(module, exports) {

$parcel$export(module.exports, "buffer", () => $bbdea426e69d1bc5$export$ab1029bcae9ddb4a);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bVnU9 = parcelRequire("bVnU9");

var $4tCOB = parcelRequire("4tCOB");
function $bbdea426e69d1bc5$export$ab1029bcae9ddb4a(shape, dtype = 'float32', values) {
    dtype = dtype || 'float32';
    $4tCOB.assertNonNegativeIntegerDimensions(shape);
    return new (0, $bVnU9.TensorBuffer)(shape, dtype, values);
}

});

parcelRegister("7qWZ5", function(module, exports) {

$parcel$export(module.exports, "cast", () => $5698b729050e4bed$export$f2db7d5238e1d23f);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Casts a `tf.Tensor` to a new dtype.
 *
 * ```js
 * const x = tf.tensor1d([1.5, 2.5, 3]);
 * tf.cast(x, 'int32').print();
 * ```
 * @param x The input tensor to be casted.
 * @param dtype The dtype to cast the input tensor to.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $5698b729050e4bed$var$cast_(x, dtype) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'cast');
    // Sanity checks.
    if (!$4tCOB.isValidDtype(dtype)) throw new Error(`Failed to cast to unknown dtype ${dtype}`);
    if (dtype === 'string' && $x.dtype !== 'string' || dtype !== 'string' && $x.dtype === 'string') throw new Error('Only strings can be casted to strings');
    const inputs = {
        x: $x
    };
    const attrs = {
        dtype: dtype
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Cast), inputs, attrs);
}
const $5698b729050e4bed$export$f2db7d5238e1d23f = (0, $jKUCi.op)({
    cast_: $5698b729050e4bed$var$cast_
});

});

parcelRegister("dnFj7", function(module, exports) {

$parcel$export(module.exports, "clone", () => $9bdd771f2bd1fabc$export$9cd59f9826255e47);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Creates a new tensor with the same values and shape as the specified
 * tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 *
 * x.clone().print();
 * ```
 *
 * @param x The tensor to clone.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $9bdd771f2bd1fabc$var$clone_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'clone', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    // Note this op is called tf.identity in python. Hence the kernel name used
    // here.
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Identity), inputs);
}
const $9bdd771f2bd1fabc$export$9cd59f9826255e47 = (0, $jKUCi.op)({
    clone_: $9bdd771f2bd1fabc$var$clone_
});

});

parcelRegister("cwNui", function(module, exports) {

$parcel$export(module.exports, "print", () => $91eedc6fc9f45404$export$c2d084dc44961371);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Prints information about the `tf.Tensor` including its data.
 *
 * ```js
 * const verbose = true;
 * tf.tensor2d([1, 2, 3, 4], [2, 2]).print(verbose);
 * ```
 * @param x The tensor to be printed.
 * @param verbose Whether to print verbose information about the ` Tensor`,
 * including dtype and size.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $91eedc6fc9f45404$export$c2d084dc44961371(x, verbose = false) {
    console.log(x.toString(verbose));
}

});


parcelRegister("i2ZbH", function(module, exports) {

$parcel$export(module.exports, "AdadeltaOptimizer", () => (parcelRequire("aSzso")).AdadeltaOptimizer);
$parcel$export(module.exports, "AdagradOptimizer", () => (parcelRequire("am0NB")).AdagradOptimizer);
$parcel$export(module.exports, "AdamOptimizer", () => (parcelRequire("dXwyG")).AdamOptimizer);
$parcel$export(module.exports, "AdamaxOptimizer", () => (parcelRequire("asOdC")).AdamaxOptimizer);
$parcel$export(module.exports, "MomentumOptimizer", () => (parcelRequire("gk98v")).MomentumOptimizer);
$parcel$export(module.exports, "Optimizer", () => (parcelRequire("4tSgq")).Optimizer);
$parcel$export(module.exports, "OptimizerConstructors", () => (parcelRequire("a7bcD")).OptimizerConstructors);
$parcel$export(module.exports, "RMSPropOptimizer", () => (parcelRequire("gblOj")).RMSPropOptimizer);
$parcel$export(module.exports, "SGDOptimizer", () => (parcelRequire("2vKqD")).SGDOptimizer);
$parcel$export(module.exports, "Tensor", () => (parcelRequire("bVnU9")).Tensor);
$parcel$export(module.exports, "TensorBuffer", () => (parcelRequire("bVnU9")).TensorBuffer);
$parcel$export(module.exports, "Variable", () => (parcelRequire("bVnU9")).Variable);
$parcel$export(module.exports, "Rank", () => (parcelRequire("bnEYl")).Rank);
$parcel$export(module.exports, "sumOutType", () => (parcelRequire("bnEYl")).sumOutType);
$parcel$export(module.exports, "upcastType", () => (parcelRequire("bnEYl")).upcastType);
$parcel$export(module.exports, "Reduction", () => (parcelRequire("fsE65")).Reduction);
$parcel$export(module.exports, "customGrad", () => (parcelRequire("jFQG4")).customGrad);
$parcel$export(module.exports, "grad", () => (parcelRequire("jFQG4")).grad);
$parcel$export(module.exports, "grads", () => (parcelRequire("jFQG4")).grads);
$parcel$export(module.exports, "valueAndGrad", () => (parcelRequire("jFQG4")).valueAndGrad);
$parcel$export(module.exports, "valueAndGrads", () => (parcelRequire("jFQG4")).valueAndGrads);
$parcel$export(module.exports, "variableGrads", () => (parcelRequire("jFQG4")).variableGrads);
$parcel$export(module.exports, "Environment", () => (parcelRequire("aymVi")).Environment);
$parcel$export(module.exports, "env", () => (parcelRequire("aymVi")).env);
$parcel$export(module.exports, "ENV", () => (parcelRequire("aymVi")).ENV);
$parcel$export(module.exports, "version_core", () => (parcelRequire("dhAYb")).version);
$parcel$export(module.exports, "nextFrame", () => (parcelRequire("hy0Vl")).nextFrame);
$parcel$export(module.exports, "browser", () => (parcelRequire("aIDUZ")));
$parcel$export(module.exports, "io", () => (parcelRequire("1RJvL")));
$parcel$export(module.exports, "math", () => (parcelRequire("1Fmuz")));
$parcel$export(module.exports, "serialization", () => (parcelRequire("8AyuI")));
$parcel$export(module.exports, "test_util", () => (parcelRequire("jgvrL")));
$parcel$export(module.exports, "util", () => (parcelRequire("wx9lK")));
$parcel$export(module.exports, "backend_util", () => (parcelRequire("lkN62")));
$parcel$export(module.exports, "broadcast_util", () => (parcelRequire("eqTIO")));
$parcel$export(module.exports, "tensor_util", () => (parcelRequire("1vhox")));
$parcel$export(module.exports, "slice_util", () => (parcelRequire("1KPDG")));
$parcel$export(module.exports, "gather_util", () => (parcelRequire("exBKX")));
$parcel$export(module.exports, "scatter_util", () => (parcelRequire("bSeux")));
$parcel$export(module.exports, "device_util", () => (parcelRequire("7L9WU")));
$parcel$export(module.exports, "kernel_impls", () => (parcelRequire("ff2I2")));
$parcel$export(module.exports, "KernelBackend", () => (parcelRequire("3PHpx")).KernelBackend);
$parcel$export(module.exports, "DataStorage", () => (parcelRequire("3PHpx")).DataStorage);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // base.ts is tfjs-core without auto registration of things like flags,
// gradients, chained ops or the opHandler. See base_side_effects.ts for parts
// tfjs core that are required side effects.
/**
 * @fileoverview
 * @suppress {partialAlias} Optimization disabled due to passing the module
 * object into a function below:
 *
 *   import * as ops from './ops/ops';
 *   setOpHandler(ops);
 */ // Serialization.

var $1RJvL = parcelRequire("1RJvL");

var $1Fmuz = parcelRequire("1Fmuz");

var $eqTIO = parcelRequire("eqTIO");

var $aIDUZ = parcelRequire("aIDUZ");

var $exBKX = parcelRequire("exBKX");

var $bSeux = parcelRequire("bSeux");

var $1KPDG = parcelRequire("1KPDG");

var $8AyuI = parcelRequire("8AyuI");

var $1vhox = parcelRequire("1vhox");

var $jgvrL = parcelRequire("jgvrL");

var $wx9lK = parcelRequire("wx9lK");

var $dhAYb = parcelRequire("dhAYb");

var $aSzso = parcelRequire("aSzso");

var $am0NB = parcelRequire("am0NB");

var $dXwyG = parcelRequire("dXwyG");

var $asOdC = parcelRequire("asOdC");

var $gk98v = parcelRequire("gk98v");

var $4tSgq = parcelRequire("4tSgq");

var $a7bcD = parcelRequire("a7bcD");

var $gblOj = parcelRequire("gblOj");

var $2vKqD = parcelRequire("2vKqD");

var $bVnU9 = parcelRequire("bVnU9");

var $bnEYl = parcelRequire("bnEYl");

var $iNZmA = parcelRequire("iNZmA");

var $fsE65 = parcelRequire("fsE65");

var $bwWuH = parcelRequire("bwWuH");

var $9c0Qr = parcelRequire("9c0Qr");

var $kaJSw = parcelRequire("kaJSw");

var $jFQG4 = parcelRequire("jFQG4");

var $aymVi = parcelRequire("aymVi");

var $hy0Vl = parcelRequire("hy0Vl");

var $lkN62 = parcelRequire("lkN62");

var $7L9WU = parcelRequire("7L9WU");

var $ff2I2 = parcelRequire("ff2I2");

var $3PHpx = parcelRequire("3PHpx");

var $dCP8m = parcelRequire("dCP8m");
$parcel$exportWildcard(module.exports, $iNZmA);
$parcel$exportWildcard(module.exports, $bwWuH);
$parcel$exportWildcard(module.exports, $9c0Qr);
$parcel$exportWildcard(module.exports, $kaJSw);
$parcel$exportWildcard(module.exports, $dCP8m);

});
parcelRegister("1RJvL", function(module, exports) {

$parcel$export(module.exports, "copyModel", () => (parcelRequire("1EsOW")).copyModel);
$parcel$export(module.exports, "listModels", () => (parcelRequire("1EsOW")).listModels);
$parcel$export(module.exports, "moveModel", () => (parcelRequire("1EsOW")).moveModel);
$parcel$export(module.exports, "removeModel", () => (parcelRequire("1EsOW")).removeModel);
$parcel$export(module.exports, "browserFiles", () => (parcelRequire("gC6B5")).browserFiles);
$parcel$export(module.exports, "browserHTTPRequest", () => (parcelRequire("7WyZG")).browserHTTPRequest);
$parcel$export(module.exports, "concatenateArrayBuffers", () => (parcelRequire("615w2")).concatenateArrayBuffers);
$parcel$export(module.exports, "decodeWeights", () => (parcelRequire("615w2")).decodeWeights);
$parcel$export(module.exports, "encodeWeights", () => (parcelRequire("615w2")).encodeWeights);
$parcel$export(module.exports, "fromMemory", () => (parcelRequire("gXQ6t")).fromMemory);
$parcel$export(module.exports, "fromMemorySync", () => (parcelRequire("gXQ6t")).fromMemorySync);
$parcel$export(module.exports, "getLoadHandlers", () => (parcelRequire("i9ref")).getLoadHandlers);
$parcel$export(module.exports, "getModelArtifactsForJSON", () => (parcelRequire("615w2")).getModelArtifactsForJSON);
$parcel$export(module.exports, "getModelArtifactsForJSONSync", () => (parcelRequire("615w2")).getModelArtifactsForJSONSync);
$parcel$export(module.exports, "getModelArtifactsInfoForJSON", () => (parcelRequire("615w2")).getModelArtifactsInfoForJSON);
$parcel$export(module.exports, "getSaveHandlers", () => (parcelRequire("i9ref")).getSaveHandlers);
$parcel$export(module.exports, "getWeightSpecs", () => (parcelRequire("615w2")).getWeightSpecs);
$parcel$export(module.exports, "http", () => (parcelRequire("7WyZG")).http);
$parcel$export(module.exports, "isHTTPScheme", () => (parcelRequire("7WyZG")).isHTTPScheme);
$parcel$export(module.exports, "loadWeights", () => (parcelRequire("cwgmH")).loadWeights);
$parcel$export(module.exports, "registerLoadRouter", () => (parcelRequire("i9ref")).registerLoadRouter);
$parcel$export(module.exports, "registerSaveRouter", () => (parcelRequire("i9ref")).registerSaveRouter);
$parcel$export(module.exports, "weightsLoaderFactory", () => (parcelRequire("cwgmH")).weightsLoaderFactory);
$parcel$export(module.exports, "withSaveHandler", () => (parcelRequire("gXQ6t")).withSaveHandler);
$parcel$export(module.exports, "withSaveHandlerSync", () => (parcelRequire("gXQ6t")).withSaveHandlerSync);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Importing local_storage and indexed_db is necessary for the routers to be
// registered.
parcelRequire("ehkIT");
parcelRequire("gIO3p");

var $gC6B5 = parcelRequire("gC6B5");

var $7WyZG = parcelRequire("7WyZG");

var $615w2 = parcelRequire("615w2");

var $gXQ6t = parcelRequire("gXQ6t");

var $i9ref = parcelRequire("i9ref");

var $cwgmH = parcelRequire("cwgmH");

var $1EsOW = parcelRequire("1EsOW");

});
parcelRegister("gC6B5", function(module, exports) {

$parcel$export(module.exports, "browserFiles", () => $c1854ffed09f560f$export$6729643cf069471c);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * IOHandlers related to files, such as browser-triggered file downloads,
 * user-selected files in browser.
 */ parcelRequire("aQg53");

var $aymVi = parcelRequire("aymVi");

var $615w2 = parcelRequire("615w2");

var $i9ref = parcelRequire("i9ref");
const $c1854ffed09f560f$var$DEFAULT_FILE_NAME_PREFIX = 'model';
const $c1854ffed09f560f$var$DEFAULT_JSON_EXTENSION_NAME = '.json';
const $c1854ffed09f560f$var$DEFAULT_WEIGHT_DATA_EXTENSION_NAME = '.weights.bin';
function $c1854ffed09f560f$var$defer(f) {
    return new Promise((resolve)=>setTimeout(resolve)).then(f);
}
class $c1854ffed09f560f$export$cc3c076530f2848f {
    constructor(fileNamePrefix){
        if (!(0, $aymVi.env)().getBool('IS_BROWSER')) // TODO(cais): Provide info on what IOHandlers are available under the
        //   current environment.
        throw new Error("browserDownloads() cannot proceed because the current environment is not a browser.");
        if (fileNamePrefix.startsWith($c1854ffed09f560f$export$cc3c076530f2848f.URL_SCHEME)) fileNamePrefix = fileNamePrefix.slice($c1854ffed09f560f$export$cc3c076530f2848f.URL_SCHEME.length);
        if (fileNamePrefix == null || fileNamePrefix.length === 0) fileNamePrefix = $c1854ffed09f560f$var$DEFAULT_FILE_NAME_PREFIX;
        this.modelJsonFileName = fileNamePrefix + $c1854ffed09f560f$var$DEFAULT_JSON_EXTENSION_NAME;
        this.weightDataFileName = fileNamePrefix + $c1854ffed09f560f$var$DEFAULT_WEIGHT_DATA_EXTENSION_NAME;
    }
    async save(modelArtifacts) {
        if (typeof document === 'undefined') throw new Error("Browser downloads are not supported in this environment since `document` is not present");
        const weightsURL = window.URL.createObjectURL(new Blob([
            modelArtifacts.weightData
        ], {
            type: 'application/octet-stream'
        }));
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserDownloads.save() does not support saving model topology in binary formats yet.");
        else {
            const weightsManifest = [
                {
                    paths: [
                        './' + this.weightDataFileName
                    ],
                    weights: modelArtifacts.weightSpecs
                }
            ];
            const modelJSON = (0, $615w2.getModelJSONForModelArtifacts)(modelArtifacts, weightsManifest);
            const modelJsonURL = window.URL.createObjectURL(new Blob([
                JSON.stringify(modelJSON)
            ], {
                type: 'application/json'
            }));
            // If anchor elements are not provided, create them without attaching them
            // to parents, so that the downloaded file names can be controlled.
            const jsonAnchor = this.modelJsonAnchor == null ? document.createElement('a') : this.modelJsonAnchor;
            jsonAnchor.download = this.modelJsonFileName;
            jsonAnchor.href = modelJsonURL;
            // Trigger downloads by evoking a click event on the download anchors.
            // When multiple downloads are started synchronously, Firefox will only
            // save the last one.
            await $c1854ffed09f560f$var$defer(()=>jsonAnchor.dispatchEvent(new MouseEvent('click')));
            if (modelArtifacts.weightData != null) {
                const weightDataAnchor = this.weightDataAnchor == null ? document.createElement('a') : this.weightDataAnchor;
                weightDataAnchor.download = this.weightDataFileName;
                weightDataAnchor.href = weightsURL;
                await $c1854ffed09f560f$var$defer(()=>weightDataAnchor.dispatchEvent(new MouseEvent('click')));
            }
            return {
                modelArtifactsInfo: (0, $615w2.getModelArtifactsInfoForJSON)(modelArtifacts)
            };
        }
    }
}
$c1854ffed09f560f$export$cc3c076530f2848f.URL_SCHEME = 'downloads://';
class $c1854ffed09f560f$var$BrowserFiles {
    constructor(files){
        if (files == null || files.length < 1) throw new Error(`When calling browserFiles, at least 1 file is required, ` + `but received ${files}`);
        this.jsonFile = files[0];
        this.weightsFiles = files.slice(1);
    }
    async load() {
        return new Promise((resolve, reject)=>{
            const jsonReader = new FileReader();
            jsonReader.onload = (event)=>{
                // tslint:disable-next-line:no-any
                const modelJSON = JSON.parse(event.target.result);
                const modelTopology = modelJSON.modelTopology;
                if (modelTopology == null) {
                    reject(new Error(`modelTopology field is missing from file ${this.jsonFile.name}`));
                    return;
                }
                const weightsManifest = modelJSON.weightsManifest;
                if (weightsManifest == null) {
                    reject(new Error(`weightManifest field is missing from file ${this.jsonFile.name}`));
                    return;
                }
                if (this.weightsFiles.length === 0) {
                    resolve({
                        modelTopology: modelTopology
                    });
                    return;
                }
                const modelArtifactsPromise = (0, $615w2.getModelArtifactsForJSON)(modelJSON, (weightsManifest)=>this.loadWeights(weightsManifest));
                resolve(modelArtifactsPromise);
            };
            jsonReader.onerror = (error)=>reject(`Failed to read model topology and weights manifest JSON ` + `from file '${this.jsonFile.name}'. BrowserFiles supports loading ` + `Keras-style tf.Model artifacts only.`);
            jsonReader.readAsText(this.jsonFile);
        });
    }
    loadWeights(weightsManifest) {
        const weightSpecs = [];
        const paths = [];
        for (const entry of weightsManifest){
            weightSpecs.push(...entry.weights);
            paths.push(...entry.paths);
        }
        const pathToFile = this.checkManifestAndWeightFiles(weightsManifest);
        const promises = paths.map((path)=>this.loadWeightsFile(path, pathToFile[path]));
        return Promise.all(promises).then((buffers)=>[
                weightSpecs,
                (0, $615w2.concatenateArrayBuffers)(buffers)
            ]);
    }
    loadWeightsFile(path, file) {
        return new Promise((resolve, reject)=>{
            const weightFileReader = new FileReader();
            weightFileReader.onload = (event)=>{
                // tslint:disable-next-line:no-any
                const weightData = event.target.result;
                resolve(weightData);
            };
            weightFileReader.onerror = (error)=>reject(`Failed to weights data from file of path '${path}'.`);
            weightFileReader.readAsArrayBuffer(file);
        });
    }
    /**
     * Check the compatibility between weights manifest and weight files.
     */ checkManifestAndWeightFiles(manifest) {
        const basenames = [];
        const fileNames = this.weightsFiles.map((file)=>(0, $615w2.basename)(file.name));
        const pathToFile = {};
        for (const group of manifest)group.paths.forEach((path)=>{
            const pathBasename = (0, $615w2.basename)(path);
            if (basenames.indexOf(pathBasename) !== -1) throw new Error(`Duplicate file basename found in weights manifest: ` + `'${pathBasename}'`);
            basenames.push(pathBasename);
            if (fileNames.indexOf(pathBasename) === -1) throw new Error(`Weight file with basename '${pathBasename}' is not provided.`);
            else pathToFile[path] = this.weightsFiles[fileNames.indexOf(pathBasename)];
        });
        if (basenames.length !== this.weightsFiles.length) throw new Error(`Mismatch in the number of files in weights manifest ` + `(${basenames.length}) and the number of weight files provided ` + `(${this.weightsFiles.length}).`);
        return pathToFile;
    }
}
const $c1854ffed09f560f$export$6149c5f14395749b = (url)=>{
    if (!(0, $aymVi.env)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($c1854ffed09f560f$export$cc3c076530f2848f.URL_SCHEME)) return $c1854ffed09f560f$export$8fbc9551c735f788(url.slice($c1854ffed09f560f$export$cc3c076530f2848f.URL_SCHEME.length));
        else return null;
    }
};
(0, $i9ref.IORouterRegistry).registerSaveRouter($c1854ffed09f560f$export$6149c5f14395749b);
function $c1854ffed09f560f$export$8fbc9551c735f788(fileNamePrefix = 'model') {
    return new $c1854ffed09f560f$export$cc3c076530f2848f(fileNamePrefix);
}
function $c1854ffed09f560f$export$6729643cf069471c(files) {
    return new $c1854ffed09f560f$var$BrowserFiles(files);
}

});

parcelRegister("7WyZG", function(module, exports) {

$parcel$export(module.exports, "isHTTPScheme", () => $5c891838d6b4f2ef$export$18a721ae4733601b);
$parcel$export(module.exports, "http", () => $5c891838d6b4f2ef$export$7d6f1c8842f9f527);
$parcel$export(module.exports, "browserHTTPRequest", () => $5c891838d6b4f2ef$export$624ff5bc4e3a9d72);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * IOHandler implementations based on HTTP requests in the web browser.
 *
 * Uses [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
 */ 
var $aymVi = parcelRequire("aymVi");

var $4tCOB = parcelRequire("4tCOB");

var $615w2 = parcelRequire("615w2");

var $i9ref = parcelRequire("i9ref");

var $cwgmH = parcelRequire("cwgmH");
const $5c891838d6b4f2ef$var$OCTET_STREAM_MIME_TYPE = 'application/octet-stream';
const $5c891838d6b4f2ef$var$JSON_TYPE = 'application/json';
class $5c891838d6b4f2ef$export$3df08bb5d0f8b499 {
    constructor(path, loadOptions){
        this.DEFAULT_METHOD = 'POST';
        if (loadOptions == null) loadOptions = {};
        this.weightPathPrefix = loadOptions.weightPathPrefix;
        this.onProgress = loadOptions.onProgress;
        this.weightUrlConverter = loadOptions.weightUrlConverter;
        if (loadOptions.fetchFunc != null) {
            (0, $4tCOB.assert)(typeof loadOptions.fetchFunc === 'function', ()=>"Must pass a function that matches the signature of `fetch` (see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)");
            this.fetch = loadOptions.fetchFunc;
        } else this.fetch = (0, $aymVi.env)().platform.fetch;
        (0, $4tCOB.assert)(path != null && path.length > 0, ()=>"URL path for http must not be null, undefined or empty.");
        if (Array.isArray(path)) (0, $4tCOB.assert)(path.length === 2, ()=>'URL paths for http must have a length of 2, ' + `(actual length is ${path.length}).`);
        this.path = path;
        if (loadOptions.requestInit != null && loadOptions.requestInit.body != null) throw new Error('requestInit is expected to have no pre-existing body, but has one.');
        this.requestInit = loadOptions.requestInit || {};
    }
    async save(modelArtifacts) {
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");
        const init = Object.assign({
            method: this.DEFAULT_METHOD
        }, this.requestInit);
        init.body = new FormData();
        const weightsManifest = [
            {
                paths: [
                    './model.weights.bin'
                ],
                weights: modelArtifacts.weightSpecs
            }
        ];
        const modelTopologyAndWeightManifest = (0, $615w2.getModelJSONForModelArtifacts)(modelArtifacts, weightsManifest);
        init.body.append('model.json', new Blob([
            JSON.stringify(modelTopologyAndWeightManifest)
        ], {
            type: $5c891838d6b4f2ef$var$JSON_TYPE
        }), 'model.json');
        if (modelArtifacts.weightData != null) init.body.append('model.weights.bin', new Blob([
            modelArtifacts.weightData
        ], {
            type: $5c891838d6b4f2ef$var$OCTET_STREAM_MIME_TYPE
        }), 'model.weights.bin');
        const response = await this.fetch(this.path, init);
        if (response.ok) return {
            modelArtifactsInfo: (0, $615w2.getModelArtifactsInfoForJSON)(modelArtifacts),
            responses: [
                response
            ]
        };
        else throw new Error(`BrowserHTTPRequest.save() failed due to HTTP response status ` + `${response.status}.`);
    }
    /**
     * Load model artifacts via HTTP request(s).
     *
     * See the documentation to `tf.io.http` for details on the saved
     * artifacts.
     *
     * @returns The loaded model artifacts (if loading succeeds).
     */ async load() {
        const modelConfigRequest = await this.fetch(this.path, this.requestInit);
        if (!modelConfigRequest.ok) throw new Error(`Request to ${this.path} failed with status code ` + `${modelConfigRequest.status}. Please verify this URL points to ` + `the model JSON of the model to load.`);
        let modelJSON;
        try {
            modelJSON = await modelConfigRequest.json();
        } catch (e) {
            let message = `Failed to parse model JSON of response from ${this.path}.`;
            // TODO(nsthorat): Remove this after some time when we're comfortable that
            // .pb files are mostly gone.
            if (this.path.endsWith('.pb')) message += " Your path contains a .pb file extension. Support for .pb models have been removed in TensorFlow.js 1.0 in favor of .json models. You can re-convert your Python TensorFlow model using the TensorFlow.js 1.0 conversion scripts or you can convert your.pb models with the 'pb2json'NPM script in the tensorflow/tfjs-converter repository.";
            else message += " Please make sure the server is serving valid JSON for this request.";
            throw new Error(message);
        }
        // We do not allow both modelTopology and weightsManifest to be missing.
        const modelTopology = modelJSON.modelTopology;
        const weightsManifest = modelJSON.weightsManifest;
        if (modelTopology == null && weightsManifest == null) throw new Error(`The JSON from HTTP path ${this.path} contains neither model ` + `topology or manifest for weights.`);
        return (0, $615w2.getModelArtifactsForJSON)(modelJSON, (weightsManifest)=>this.loadWeights(weightsManifest));
    }
    async loadWeights(weightsManifest) {
        const weightPath = Array.isArray(this.path) ? this.path[1] : this.path;
        const [prefix, suffix] = $5c891838d6b4f2ef$export$7a5253c0f62e0150(weightPath);
        const pathPrefix = this.weightPathPrefix || prefix;
        const weightSpecs = (0, $615w2.getWeightSpecs)(weightsManifest);
        const fetchURLs = [];
        const urlPromises = [];
        for (const weightsGroup of weightsManifest){
            for (const path of weightsGroup.paths)if (this.weightUrlConverter != null) urlPromises.push(this.weightUrlConverter(path));
            else fetchURLs.push(pathPrefix + path + suffix);
        }
        if (this.weightUrlConverter) fetchURLs.push(...await Promise.all(urlPromises));
        const buffers = await (0, $cwgmH.loadWeightsAsArrayBuffer)(fetchURLs, {
            requestInit: this.requestInit,
            fetchFunc: this.fetch,
            onProgress: this.onProgress
        });
        return [
            weightSpecs,
            (0, $615w2.concatenateArrayBuffers)(buffers)
        ];
    }
}
$5c891838d6b4f2ef$export$3df08bb5d0f8b499.URL_SCHEME_REGEX = /^https?:\/\//;
function $5c891838d6b4f2ef$export$7a5253c0f62e0150(url) {
    const lastSlash = url.lastIndexOf('/');
    const lastSearchParam = url.lastIndexOf('?');
    const prefix = url.substring(0, lastSlash);
    const suffix = lastSearchParam > lastSlash ? url.substring(lastSearchParam) : '';
    return [
        prefix + '/',
        suffix
    ];
}
function $5c891838d6b4f2ef$export$18a721ae4733601b(url) {
    return url.match($5c891838d6b4f2ef$export$3df08bb5d0f8b499.URL_SCHEME_REGEX) != null;
}
const $5c891838d6b4f2ef$export$696b487c8ad531d2 = (url, loadOptions)=>{
    if (typeof fetch === 'undefined' && (loadOptions == null || loadOptions.fetchFunc == null)) // `http` uses `fetch` or `node-fetch`, if one wants to use it in
    // an environment that is not the browser or node they have to setup a
    // global fetch polyfill.
    return null;
    else {
        let isHTTP = true;
        if (Array.isArray(url)) isHTTP = url.every((urlItem)=>$5c891838d6b4f2ef$export$18a721ae4733601b(urlItem));
        else isHTTP = $5c891838d6b4f2ef$export$18a721ae4733601b(url);
        if (isHTTP) return $5c891838d6b4f2ef$export$7d6f1c8842f9f527(url, loadOptions);
    }
    return null;
};
(0, $i9ref.IORouterRegistry).registerSaveRouter($5c891838d6b4f2ef$export$696b487c8ad531d2);
(0, $i9ref.IORouterRegistry).registerLoadRouter($5c891838d6b4f2ef$export$696b487c8ad531d2);
function $5c891838d6b4f2ef$export$7d6f1c8842f9f527(path, loadOptions) {
    return new $5c891838d6b4f2ef$export$3df08bb5d0f8b499(path, loadOptions);
}
function $5c891838d6b4f2ef$export$624ff5bc4e3a9d72(path, loadOptions) {
    return $5c891838d6b4f2ef$export$7d6f1c8842f9f527(path, loadOptions);
}

});
parcelRegister("cwgmH", function(module, exports) {

$parcel$export(module.exports, "loadWeightsAsArrayBuffer", () => $91d52af8ed78f706$export$6873c1a1d3325bf7);
$parcel$export(module.exports, "loadWeights", () => $91d52af8ed78f706$export$55f7d42d35356096);
$parcel$export(module.exports, "weightsLoaderFactory", () => $91d52af8ed78f706$export$635f986c4ab6ebe2);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aymVi = parcelRequire("aymVi");

var $4tCOB = parcelRequire("4tCOB");

var $615w2 = parcelRequire("615w2");

var $kJ8Q8 = parcelRequire("kJ8Q8");

var $8Q7Um = parcelRequire("8Q7Um");
async function $91d52af8ed78f706$export$6873c1a1d3325bf7(fetchURLs, loadOptions) {
    if (loadOptions == null) loadOptions = {};
    const fetchFunc = loadOptions.fetchFunc == null ? (0, $aymVi.env)().platform.fetch : loadOptions.fetchFunc;
    // Create the requests for all of the weights in parallel.
    const requests = fetchURLs.map((fetchURL)=>fetchFunc(fetchURL, loadOptions.requestInit, {
            isBinary: true
        }));
    const fetchStartFraction = 0;
    const fetchEndFraction = 0.5;
    const responses = loadOptions.onProgress == null ? await Promise.all(requests) : await (0, $kJ8Q8.monitorPromisesProgress)(requests, loadOptions.onProgress, fetchStartFraction, fetchEndFraction);
    const bufferPromises = responses.map((response)=>response.arrayBuffer());
    const bufferStartFraction = 0.5;
    const bufferEndFraction = 1;
    const buffers = loadOptions.onProgress == null ? await Promise.all(bufferPromises) : await (0, $kJ8Q8.monitorPromisesProgress)(bufferPromises, loadOptions.onProgress, bufferStartFraction, bufferEndFraction);
    return buffers;
}
async function $91d52af8ed78f706$export$55f7d42d35356096(manifest, filePathPrefix = '', weightNames, requestInit) {
    // TODO(nsthorat): Groups are currently fetched atomically. If you need a
    // single weight from a group, the whole group will be fetched. At a future
    // date, we should support fetching only the individual shards within a
    // group that are needed to reconstruct the requested weight.
    // TODO(cais): Use `decodeWeights` for implementation.
    const fetchWeights = (fetchUrls)=>$91d52af8ed78f706$export$6873c1a1d3325bf7(fetchUrls, {
            requestInit: requestInit
        });
    const loadWeights1 = $91d52af8ed78f706$export$635f986c4ab6ebe2(fetchWeights);
    return loadWeights1(manifest, filePathPrefix, weightNames);
}
function $91d52af8ed78f706$export$635f986c4ab6ebe2(fetchWeightsFunction) {
    return async (manifest, filePathPrefix = '', weightNames)=>{
        // Collect all the groups, weights, and their relative offsets to be
        // fetched.
        const groupIndicesToFetchMap = manifest.map(()=>false);
        const groupWeightsToFetch = {};
        const weightsFound = weightNames != null ? weightNames.map(()=>false) : [];
        const allManifestWeightNames = [];
        manifest.forEach((manifestGroupConfig, groupIndex)=>{
            let groupOffset = 0;
            manifestGroupConfig.weights.forEach((weightsEntry)=>{
                const rawDtype = 'quantization' in weightsEntry ? weightsEntry.quantization.dtype : weightsEntry.dtype;
                const weightsBytes = (0, $8Q7Um.DTYPE_VALUE_SIZE_MAP)[rawDtype] * $4tCOB.sizeFromShape(weightsEntry.shape);
                const enqueueWeightsForFetchingFn = ()=>{
                    groupIndicesToFetchMap[groupIndex] = true;
                    if (groupWeightsToFetch[groupIndex] == null) groupWeightsToFetch[groupIndex] = [];
                    groupWeightsToFetch[groupIndex].push({
                        manifestEntry: weightsEntry,
                        groupOffset: groupOffset,
                        sizeBytes: weightsBytes
                    });
                };
                if (weightNames != null) weightNames.forEach((weightName, weightIndex)=>{
                    if (weightName === weightsEntry.name) {
                        enqueueWeightsForFetchingFn();
                        weightsFound[weightIndex] = true;
                    }
                });
                else enqueueWeightsForFetchingFn();
                allManifestWeightNames.push(weightsEntry.name);
                groupOffset += weightsBytes;
            });
        });
        if (!weightsFound.every((found)=>found)) {
            const weightsNotFound = weightNames.filter((_, i)=>!weightsFound[i]);
            throw new Error(`Could not find weights in manifest with names: ` + `${weightsNotFound.join(', ')}. \n` + `Manifest JSON has weights with names: ` + `${allManifestWeightNames.join(', ')}.`);
        }
        // Convert the one-hot boolean groupId => shouldFetch map to a list of group
        // IDs.
        const groupIndicesToFetch = groupIndicesToFetchMap.reduce((accumulator, shouldFetch, i)=>{
            if (shouldFetch) accumulator.push(i);
            return accumulator;
        }, []);
        const fetchUrls = [];
        groupIndicesToFetch.forEach((i)=>{
            manifest[i].paths.forEach((filepath)=>{
                const fetchUrl = filePathPrefix + (!filePathPrefix.endsWith('/') ? '/' : '') + filepath;
                fetchUrls.push(fetchUrl);
            });
        });
        const buffers = await fetchWeightsFunction(fetchUrls);
        const weightsTensorMap = {};
        let bufferIndexOffset = 0;
        groupIndicesToFetch.forEach((i)=>{
            const numBuffers = manifest[i].paths.length;
            let groupBytes = 0;
            for(let i = 0; i < numBuffers; i++)groupBytes += buffers[bufferIndexOffset + i].byteLength;
            // Create a buffer for the whole group.
            const groupBuffer = new ArrayBuffer(groupBytes);
            const groupByteBuffer = new Uint8Array(groupBuffer);
            let groupBufferOffset = 0;
            for(let i = 0; i < numBuffers; i++){
                const buffer = new Uint8Array(buffers[bufferIndexOffset + i]);
                groupByteBuffer.set(buffer, groupBufferOffset);
                groupBufferOffset += buffer.byteLength;
            }
            const weightsEntries = groupWeightsToFetch[i];
            weightsEntries.forEach((weightsEntry)=>{
                const byteBuffer = groupBuffer.slice(weightsEntry.groupOffset, weightsEntry.groupOffset + weightsEntry.sizeBytes);
                const nameToTensorMap = (0, $615w2.decodeWeights)(byteBuffer, [
                    weightsEntry.manifestEntry
                ]);
                for(const name in nameToTensorMap)weightsTensorMap[name] = nameToTensorMap[name];
            });
            bufferIndexOffset += numBuffers;
        });
        return weightsTensorMap;
    };
}

});
parcelRegister("kJ8Q8", function(module, exports) {

$parcel$export(module.exports, "monitorPromisesProgress", () => $f16ede0d98ab51b9$export$b88cae388b9e062e);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
function $f16ede0d98ab51b9$export$b88cae388b9e062e(promises, onProgress, startFraction, endFraction) {
    checkPromises(promises);
    startFraction = startFraction == null ? 0 : startFraction;
    endFraction = endFraction == null ? 1 : endFraction;
    checkFraction(startFraction, endFraction);
    let resolvedPromise = 0;
    const registerMonitor = (promise)=>{
        promise.then((value)=>{
            const fraction = startFraction + ++resolvedPromise / promises.length * (endFraction - startFraction);
            // pass fraction as parameter to callback function.
            onProgress(fraction);
            return value;
        });
        return promise;
    };
    function checkPromises(promises) {
        (0, $4tCOB.assert)(promises != null && Array.isArray(promises) && promises.length > 0, ()=>'promises must be a none empty array');
    }
    function checkFraction(startFraction, endFraction) {
        (0, $4tCOB.assert)(startFraction >= 0 && startFraction <= 1, ()=>`Progress fraction must be in range [0, 1], but ` + `got startFraction ${startFraction}`);
        (0, $4tCOB.assert)(endFraction >= 0 && endFraction <= 1, ()=>`Progress fraction must be in range [0, 1], but ` + `got endFraction ${endFraction}`);
        (0, $4tCOB.assert)(endFraction >= startFraction, ()=>`startFraction must be no more than endFraction, but ` + `got startFraction ${startFraction} and endFraction ` + `${endFraction}`);
    }
    return Promise.all(promises.map(registerMonitor));
}

});



parcelRegister("gXQ6t", function(module, exports) {

$parcel$export(module.exports, "fromMemory", () => $c59a92ac5bf3ebc9$export$89ba941c7951a2e8);
$parcel$export(module.exports, "fromMemorySync", () => $c59a92ac5bf3ebc9$export$c22472cb1d774f45);
$parcel$export(module.exports, "withSaveHandler", () => $c59a92ac5bf3ebc9$export$fa4a26428614aae7);
$parcel$export(module.exports, "withSaveHandlerSync", () => $c59a92ac5bf3ebc9$export$53913891eb9f0585);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $c59a92ac5bf3ebc9$var$PassthroughLoader {
    constructor(modelArtifacts){
        this.modelArtifacts = modelArtifacts;
    }
    load() {
        return this.modelArtifacts;
    }
}
class $c59a92ac5bf3ebc9$var$PassthroughSaver {
    constructor(saveHandler){
        this.saveHandler = saveHandler;
    }
    save(modelArtifacts) {
        return this.saveHandler(modelArtifacts);
    }
}
class $c59a92ac5bf3ebc9$var$PassthroughAsync {
    constructor(handler){
        if (handler.load) this.load = ()=>Promise.resolve(handler.load());
        if (handler.save) this.save = (modelArtifacts)=>Promise.resolve(handler.save(modelArtifacts));
    }
}
function $c59a92ac5bf3ebc9$export$89ba941c7951a2e8(modelArtifacts, weightSpecs, weightData, trainingConfig) {
    const args = arguments;
    return new $c59a92ac5bf3ebc9$var$PassthroughAsync($c59a92ac5bf3ebc9$export$c22472cb1d774f45(...args));
}
function $c59a92ac5bf3ebc9$export$c22472cb1d774f45(modelArtifacts, weightSpecs, weightData, trainingConfig) {
    if (arguments.length === 1) {
        const isModelArtifacts = modelArtifacts.modelTopology != null || modelArtifacts.weightSpecs != null;
        if (isModelArtifacts) return new $c59a92ac5bf3ebc9$var$PassthroughLoader(modelArtifacts);
        else {
            // Legacy support: with only modelTopology.
            // TODO(cais): Remove this deprecated API.
            console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release.");
            return new $c59a92ac5bf3ebc9$var$PassthroughLoader({
                modelTopology: modelArtifacts
            });
        }
    } else {
        // Legacy support.
        // TODO(cais): Remove this deprecated API.
        console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release.");
        return new $c59a92ac5bf3ebc9$var$PassthroughLoader({
            modelTopology: modelArtifacts,
            weightSpecs: weightSpecs,
            weightData: weightData,
            trainingConfig: trainingConfig
        });
    }
}
function $c59a92ac5bf3ebc9$export$fa4a26428614aae7(saveHandler) {
    return new $c59a92ac5bf3ebc9$var$PassthroughSaver(saveHandler);
}
function $c59a92ac5bf3ebc9$export$53913891eb9f0585(saveHandler) {
    return new $c59a92ac5bf3ebc9$var$PassthroughSaver(saveHandler);
}

});


parcelRegister("1Fmuz", function(module, exports) {

$parcel$export(module.exports, "confusionMatrix", () => (parcelRequire("9yn4W")).confusionMatrix);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Exports under the tf.math.* namespace.
 */ 
var $9yn4W = parcelRequire("9yn4W");

});
parcelRegister("9yn4W", function(module, exports) {

$parcel$export(module.exports, "confusionMatrix", () => $6f4930f7ca94f1bc$export$e83fd4c6c32bfa2e);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $7qWZ5 = parcelRequire("7qWZ5");

var $clO9Z = parcelRequire("clO9Z");

var $8feEH = parcelRequire("8feEH");

var $jKUCi = parcelRequire("jKUCi");

var $9PEYs = parcelRequire("9PEYs");
function $6f4930f7ca94f1bc$export$fdc6eac044b0dee2(labels, predictions, numClasses) {
    const $labels = (0, $5R1UY.convertToTensor)(labels, 'labels', 'confusionMatrix');
    const $predictions = (0, $5R1UY.convertToTensor)(predictions, 'predictions', 'confusionMatrix');
    $4tCOB.assert(numClasses == null || numClasses > 0 && Number.isInteger(numClasses), ()=>`If provided, numClasses must be a positive integer, ` + `but got ${numClasses}`);
    $4tCOB.assert($labels.rank === 1, ()=>`Expected the rank of labels to be 1, but got ${$labels.rank}`);
    $4tCOB.assert($predictions.rank === 1, ()=>`Expected the rank of predictions to be 1, ` + `but got ${$predictions.rank}`);
    $4tCOB.assert($labels.shape[0] === $predictions.shape[0], ()=>`Mismatch in the number of examples: ` + `${$labels.shape[0]} vs. ${$predictions.shape[0]}. ` + `Labels and predictions should have the same number of elements.`);
    $4tCOB.assert(numClasses > 0 && Number.isInteger(numClasses), ()=>`numClasses is required to be a positive integer, but got ` + `${numClasses}`);
    // TODO(cais): In the future, if oneHot supports tensors inputs for
    //   `numClasses`, `confusionMatrix` can make `numClasses` optional.
    const oneHotLabels = (0, $8feEH.oneHot)((0, $7qWZ5.cast)($labels, 'int32'), numClasses);
    const oneHotPredictions = (0, $8feEH.oneHot)((0, $7qWZ5.cast)($predictions, 'int32'), numClasses);
    const oneHotLabelsT = (0, $9PEYs.transpose)(oneHotLabels);
    const product = (0, $clO9Z.matMul)(oneHotLabelsT, oneHotPredictions);
    return (0, $7qWZ5.cast)(product, 'int32');
}
const $6f4930f7ca94f1bc$export$e83fd4c6c32bfa2e = (0, $jKUCi.op)({
    confusionMatrix_: $6f4930f7ca94f1bc$export$fdc6eac044b0dee2
});

});
parcelRegister("clO9Z", function(module, exports) {

$parcel$export(module.exports, "matMul", () => $8fde5afb43d2a33a$export$6706882a873e9a8f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the dot product of two matrices, A * B. These must be matrices.
 *
 * ```js
 * const a = tf.tensor2d([1, 2], [1, 2]);
 * const b = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * a.matMul(b).print();  // or tf.matMul(a, b)
 * ```
 * @param a First matrix in dot product operation.
 * @param b Second matrix in dot product operation.
 * @param transposeA If true, `a` is transposed before multiplication.
 * @param transposeB If true, `b` is transposed before multiplication.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $8fde5afb43d2a33a$var$matMul_(a, b, transposeA = false, transposeB = false) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'matMul');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'matMul');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {
        transposeA: transposeA,
        transposeB: transposeB
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.BatchMatMul), inputs, attrs);
}
const $8fde5afb43d2a33a$export$6706882a873e9a8f = (0, $jKUCi.op)({
    matMul_: $8fde5afb43d2a33a$var$matMul_
});

});

parcelRegister("8feEH", function(module, exports) {

$parcel$export(module.exports, "oneHot", () => $600b17b72ea48513$export$341b5490a776d041);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Creates a one-hot `tf.Tensor`. The locations represented by `indices` take
 * value `onValue` (defaults to 1), while all other locations take value
 * `offValue` (defaults to 0). If `indices` is rank `R`, the output has rank
 * `R+1` with the last axis of size `depth`.
 * `indices` used to encode prediction class must start from 0. For example,
 *  if you have 3 classes of data, class 1 should be encoded as 0, class 2
 *  should be 1, and class 3 should be 2.
 *
 * ```js
 * tf.oneHot(tf.tensor1d([0, 1], 'int32'), 3).print();
 * ```
 *
 * @param indices `tf.Tensor` of indices with dtype `int32`. Indices must
 * start from 0.
 * @param depth The depth of the one hot dimension.
 * @param onValue A number used to fill in the output when the index matches
 * the location.
 * @param offValue A number used to fill in the output when the index does
 *     not match the location.
 * @param dtype The dtype of the output tensor, default to 'int32'.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $600b17b72ea48513$var$oneHot_(indices, depth, onValue = 1, offValue = 0, dtype = 'int32') {
    if (depth < 2) throw new Error(`Error in oneHot: depth must be >=2, but it is ${depth}`);
    const $indices = (0, $5R1UY.convertToTensor)(indices, 'indices', 'oneHot', 'int32');
    const inputs = {
        indices: $indices
    };
    const attrs = {
        dtype: dtype,
        depth: depth,
        onValue: onValue,
        offValue: offValue
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.OneHot), inputs, attrs);
}
const $600b17b72ea48513$export$341b5490a776d041 = (0, $jKUCi.op)({
    oneHot_: $600b17b72ea48513$var$oneHot_
});

});

parcelRegister("9PEYs", function(module, exports) {

$parcel$export(module.exports, "transpose", () => $7288a9160548930c$export$9cb09a71b7d66923);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $9c0Qr = parcelRequire("9c0Qr");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $bxdsK = parcelRequire("bxdsK");

var $7of6P = parcelRequire("7of6P");

var $ifge7 = parcelRequire("ifge7");

var $jKUCi = parcelRequire("jKUCi");

var $3XWb2 = parcelRequire("3XWb2");
/**
 * Transposes the `tf.Tensor`. Permutes the dimensions according to `perm`.
 *
 * The returned `tf.Tensor`'s dimension `i` will correspond to the input
 * dimension `perm[i]`. If `perm` is not given, it is set to `[n-1...0]`,
 * where `n` is the rank of the input `tf.Tensor`. Hence by default, this
 * operation performs a regular matrix transpose on 2-D input `tf.Tensor`s.
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4, 5, 6], [2, 3]);
 *
 * a.transpose().print();  // or tf.transpose(a)
 * ```
 *
 * @param x The tensor to transpose.
 * @param perm The permutation of the dimensions of a.
 * @param conjugate Will conjugate complex input if true.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $7288a9160548930c$var$transpose_(x, perm, conjugate) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'transpose');
    if (perm == null) perm = $x.shape.map((s, i)=>i).reverse();
    $4tCOB.assert($x.rank === perm.length, ()=>`Error in transpose: rank of input ${$x.rank} ` + `must match length of perm ${perm}.`);
    perm.forEach((axis)=>{
        $4tCOB.assert(axis >= 0 && axis < $x.rank, ()=>`All entries in 'perm' must be between 0 and ${$x.rank - 1}` + ` but got ${perm}`);
    });
    if ($x.rank <= 1) return $x.clone();
    const inputs = {
        x: $x
    };
    const attrs = {
        perm: perm
    };
    if ($x.dtype === 'complex64') return (0, $9c0Qr.tidy)(()=>{
        let $real = (0, $3XWb2.real)($x);
        let $imag = (0, $7of6P.imag)($x);
        $real = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Transpose), {
            x: $real
        }, attrs);
        $imag = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Transpose), {
            x: $imag
        }, attrs);
        if (conjugate) $imag = (0, $ifge7.neg)($imag);
        return (0, $bxdsK.complex)($real, $imag);
    });
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Transpose), inputs, attrs);
}
const $7288a9160548930c$export$9cb09a71b7d66923 = (0, $jKUCi.op)({
    transpose_: $7288a9160548930c$var$transpose_
});

});
parcelRegister("9c0Qr", function(module, exports) {

$parcel$export(module.exports, "enableProdMode", () => $6b15e3cc13c566a7$export$1e73b1267274f27e);
$parcel$export(module.exports, "enableDebugMode", () => $6b15e3cc13c566a7$export$ef8a131e8a882a3a);
$parcel$export(module.exports, "disableDeprecationWarnings", () => $6b15e3cc13c566a7$export$cb100329fdb11914);
$parcel$export(module.exports, "deprecationWarn", () => $6b15e3cc13c566a7$export$e46eea6a629d2da5);
$parcel$export(module.exports, "disposeVariables", () => $6b15e3cc13c566a7$export$f22ce7a2fa538c48);
$parcel$export(module.exports, "engine", () => $6b15e3cc13c566a7$export$d3c662a6136faebb);
$parcel$export(module.exports, "memory", () => $6b15e3cc13c566a7$export$827b61424e8f52d2);
$parcel$export(module.exports, "profile", () => $6b15e3cc13c566a7$export$4882ae973e0491e);
$parcel$export(module.exports, "tidy", () => $6b15e3cc13c566a7$export$b841c6a213a653eb);
$parcel$export(module.exports, "dispose", () => $6b15e3cc13c566a7$export$fcfbbcec2cb820d5);
$parcel$export(module.exports, "keep", () => $6b15e3cc13c566a7$export$fae3166c418e0471);
$parcel$export(module.exports, "time", () => $6b15e3cc13c566a7$export$2da9be4cfdb689b1);
$parcel$export(module.exports, "setBackend", () => $6b15e3cc13c566a7$export$7953970fabc9c2);
$parcel$export(module.exports, "ready", () => $6b15e3cc13c566a7$export$28ee1007e174a2a6);
$parcel$export(module.exports, "getBackend", () => $6b15e3cc13c566a7$export$b098501f764cdf30);
$parcel$export(module.exports, "removeBackend", () => $6b15e3cc13c566a7$export$c299110fbe92c80c);
$parcel$export(module.exports, "findBackend", () => $6b15e3cc13c566a7$export$f94fbc07ea8e852e);
$parcel$export(module.exports, "findBackendFactory", () => $6b15e3cc13c566a7$export$e4a6d214466a2c7b);
$parcel$export(module.exports, "registerBackend", () => $6b15e3cc13c566a7$export$1ac8c3a90eff05d);
$parcel$export(module.exports, "backend", () => $6b15e3cc13c566a7$export$32a253b6f8b50fb4);
$parcel$export(module.exports, "setPlatform", () => $6b15e3cc13c566a7$export$5f05d56a0f2349cc);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $aymVi = parcelRequire("aymVi");

var $bVnU9 = parcelRequire("bVnU9");

var $1vhox = parcelRequire("1vhox");
function $6b15e3cc13c566a7$export$1e73b1267274f27e() {
    (0, $aymVi.env)().set('PROD', true);
}
function $6b15e3cc13c566a7$export$ef8a131e8a882a3a() {
    (0, $aymVi.env)().set('DEBUG', true);
}
function $6b15e3cc13c566a7$export$cb100329fdb11914() {
    (0, $aymVi.env)().set('DEPRECATION_WARNINGS_ENABLED', false);
    console.warn(`TensorFlow.js deprecation warnings have been disabled.`);
}
function $6b15e3cc13c566a7$export$e46eea6a629d2da5(msg) {
    if ((0, $aymVi.env)().getBool('DEPRECATION_WARNINGS_ENABLED')) console.warn(msg + ' You can disable deprecation warnings with ' + 'tf.disableDeprecationWarnings().');
}
(0, $bVnU9.setDeprecationWarningFn)($6b15e3cc13c566a7$export$e46eea6a629d2da5);
function $6b15e3cc13c566a7$export$f22ce7a2fa538c48() {
    (0, $aHfUM.ENGINE).disposeVariables();
}
function $6b15e3cc13c566a7$export$d3c662a6136faebb() {
    return 0, $aHfUM.ENGINE;
}
function $6b15e3cc13c566a7$export$827b61424e8f52d2() {
    return (0, $aHfUM.ENGINE).memory();
}
function $6b15e3cc13c566a7$export$4882ae973e0491e(f) {
    return (0, $aHfUM.ENGINE).profile(f);
}
function $6b15e3cc13c566a7$export$b841c6a213a653eb(nameOrFn, fn) {
    return (0, $aHfUM.ENGINE).tidy(nameOrFn, fn);
}
function $6b15e3cc13c566a7$export$fcfbbcec2cb820d5(container) {
    const tensors = (0, $1vhox.getTensorsInContainer)(container);
    tensors.forEach((tensor)=>tensor.dispose());
}
function $6b15e3cc13c566a7$export$fae3166c418e0471(result) {
    return (0, $aHfUM.ENGINE).keep(result);
}
function $6b15e3cc13c566a7$export$2da9be4cfdb689b1(f) {
    return (0, $aHfUM.ENGINE).time(f);
}
function $6b15e3cc13c566a7$export$7953970fabc9c2(backendName) {
    return (0, $aHfUM.ENGINE).setBackend(backendName);
}
function $6b15e3cc13c566a7$export$28ee1007e174a2a6() {
    return (0, $aHfUM.ENGINE).ready();
}
function $6b15e3cc13c566a7$export$b098501f764cdf30() {
    return (0, $aHfUM.ENGINE).backendName;
}
function $6b15e3cc13c566a7$export$c299110fbe92c80c(name) {
    (0, $aHfUM.ENGINE).removeBackend(name);
}
function $6b15e3cc13c566a7$export$f94fbc07ea8e852e(name) {
    return (0, $aHfUM.ENGINE).findBackend(name);
}
function $6b15e3cc13c566a7$export$e4a6d214466a2c7b(name) {
    return (0, $aHfUM.ENGINE).findBackendFactory(name);
}
function $6b15e3cc13c566a7$export$1ac8c3a90eff05d(name, factory, priority = 1) {
    return (0, $aHfUM.ENGINE).registerBackend(name, factory, priority);
}
function $6b15e3cc13c566a7$export$32a253b6f8b50fb4() {
    return (0, $aHfUM.ENGINE).backend;
}
function $6b15e3cc13c566a7$export$5f05d56a0f2349cc(platformName, platform) {
    (0, $aymVi.env)().setPlatform(platformName, platform);
}

});

parcelRegister("7of6P", function(module, exports) {

$parcel$export(module.exports, "imag", () => $016375a7d4cde8a3$export$d78fab5778ab392b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the imaginary part of a complex (or real) tensor.
 *
 * Given a tensor input, this operation returns a tensor of type float that is
 * the imaginary part of each element in input considered as a complex number.
 * If input is real, a tensor of all zeros is returned.
 *
 * ```js
 * const x = tf.complex([-2.25, 3.25], [4.75, 5.75]);
 * tf.imag(x).print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $016375a7d4cde8a3$var$imag_(input) {
    const $input = (0, $5R1UY.convertToTensor)(input, 'input', 'imag');
    const inputs = {
        input: $input
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Imag), inputs);
}
const $016375a7d4cde8a3$export$d78fab5778ab392b = (0, $jKUCi.op)({
    imag_: $016375a7d4cde8a3$var$imag_
});

});

parcelRegister("ifge7", function(module, exports) {

$parcel$export(module.exports, "neg", () => $d48636fab1a3f291$export$d9493ff0dfa0fdd5);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes `-1 * x` element-wise.
 *
 * ```js
 * const x = tf.tensor2d([1, 2, -2, 0], [2, 2]);
 *
 * x.neg().print();  // or tf.neg(x)
 * ```
 *
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $d48636fab1a3f291$var$neg_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'neg');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Neg), inputs);
}
const $d48636fab1a3f291$export$d9493ff0dfa0fdd5 = (0, $jKUCi.op)({
    neg_: $d48636fab1a3f291$var$neg_
});

});

parcelRegister("3XWb2", function(module, exports) {

$parcel$export(module.exports, "real", () => $2e34028358468595$export$9fc57fb453bdbd67);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the real part of a complex (or real) tensor.
 *
 * Given a tensor input, this operation returns a tensor of type float that is
 * the real part of each element in input considered as a complex number.
 *
 * If the input is real, it simply makes a clone.
 *
 * ```js
 * const x = tf.complex([-2.25, 3.25], [4.75, 5.75]);
 * tf.real(x).print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $2e34028358468595$var$real_(input) {
    const $input = (0, $5R1UY.convertToTensor)(input, 'input', 'real');
    const inputs = {
        input: $input
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Real), inputs);
}
const $2e34028358468595$export$9fc57fb453bdbd67 = (0, $jKUCi.op)({
    real_: $2e34028358468595$var$real_
});

});




parcelRegister("eqTIO", function(module, exports) {

$parcel$export(module.exports, "getBroadcastDims", () => $a81eb7989c08128f$export$fc823784344690e0);
$parcel$export(module.exports, "getReductionAxes", () => $a81eb7989c08128f$export$9f11ec258a9b2804);
$parcel$export(module.exports, "assertAndGetBroadcastShape", () => $a81eb7989c08128f$export$a3e2a38a57ec8318);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Returns the dimensions in the input shape that are broadcasted to
 * produce the provided output shape.
 *
 * The returned dimensions are 0-indexed and sorted. An example:
 * inShape = [4, 1, 3]
 * outShape = [5, 4, 3, 3]
 * result = [1]. Dimension 1 (2nd dimension of input) gets broadcasted 1 => 3.
 */ function $a81eb7989c08128f$export$fc823784344690e0(inShape, outShape) {
    const inRank = inShape.length;
    const dims = [];
    for(let i = 0; i < inRank; i++){
        const dim = inRank - 1 - i;
        const a = inShape[dim] || 1;
        const b = outShape[outShape.length - 1 - i] || 1;
        if (b > 1 && a === 1) dims.unshift(dim);
    }
    return dims;
}
function $a81eb7989c08128f$export$9f11ec258a9b2804(inShape, outShape) {
    const result = [];
    for(let i = 0; i < outShape.length; i++){
        const inDim = inShape[inShape.length - i - 1];
        const outAxis = outShape.length - i - 1;
        const outDim = outShape[outAxis];
        if (inDim == null || inDim === 1 && outDim > 1) result.unshift(outAxis);
    }
    return result;
}
function $a81eb7989c08128f$export$a3e2a38a57ec8318(shapeA, shapeB) {
    const result = [];
    const l = Math.max(shapeA.length, shapeB.length);
    for(let i = 0; i < l; i++){
        let a = shapeA[shapeA.length - i - 1];
        if (a == null) a = 1;
        let b = shapeB[shapeB.length - i - 1];
        if (b == null) b = 1;
        if (a === 1) result.unshift(b);
        else if (b === 1) result.unshift(a);
        else if (a !== b) {
            const errMsg = `Operands could not be broadcast together with shapes ` + `${shapeA} and ${shapeB}.`;
            throw Error(errMsg);
        } else result.unshift(a);
    }
    return result;
}

});

parcelRegister("aIDUZ", function(module, exports) {

$parcel$export(module.exports, "fromPixelsAsync", () => $7cdcfa637085d9f8$export$6b17f27238fa6bff);
$parcel$export(module.exports, "toPixels", () => $7cdcfa637085d9f8$export$89b6cc959998e12e);
$parcel$export(module.exports, "fromPixels", () => $7cdcfa637085d9f8$export$5a3bc84b10e77d32);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $aymVi = parcelRequire("aymVi");

var $dCP8m = parcelRequire("dCP8m");

var $kaJSw = parcelRequire("kaJSw");

var $bVnU9 = parcelRequire("bVnU9");

var $5R1UY = parcelRequire("5R1UY");

var $7qWZ5 = parcelRequire("7qWZ5");

var $jKUCi = parcelRequire("jKUCi");

var $gLH3k = parcelRequire("gLH3k");
let $7cdcfa637085d9f8$var$fromPixels2DContext;
/**
 * Creates a `tf.Tensor` from an image.
 *
 * ```js
 * const image = new ImageData(1, 1);
 * image.data[0] = 100;
 * image.data[1] = 150;
 * image.data[2] = 200;
 * image.data[3] = 255;
 *
 * tf.browser.fromPixels(image).print();
 * ```
 *
 * @param pixels The input image to construct the tensor from. The
 * supported image types are all 4-channel. You can also pass in an image
 * object with following attributes:
 * `{data: Uint8Array; width: number; height: number}`
 * @param numChannels The number of channels of the output tensor. A
 * numChannels value less than 4 allows you to ignore channels. Defaults to
 * 3 (ignores alpha channel of input image).
 *
 * @returns A Tensor3D with the shape `[height, width, numChannels]`.
 *
 * Note: fromPixels can be lossy in some cases, same image may result in
 * slightly different tensor values, if rendered by different rendering
 * engines. This means that results from different browsers, or even same
 * browser with CPU and GPU rendering engines can be different. See discussion
 * in details:
 * https://github.com/tensorflow/tfjs/issues/5482
 *
 * @doc {heading: 'Browser', namespace: 'browser', ignoreCI: true}
 */ function $7cdcfa637085d9f8$var$fromPixels_(pixels, numChannels = 3) {
    // Sanity checks.
    if (numChannels > 4) throw new Error('Cannot construct Tensor with more than 4 channels from pixels.');
    if (pixels == null) throw new Error('pixels passed to tf.browser.fromPixels() can not be null');
    let isPixelData = false;
    let isImageData = false;
    let isVideo = false;
    let isImage = false;
    let isCanvasLike = false;
    let isImageBitmap = false;
    if (pixels.data instanceof Uint8Array) isPixelData = true;
    else if (typeof ImageData !== 'undefined' && pixels instanceof ImageData) isImageData = true;
    else if (typeof HTMLVideoElement !== 'undefined' && pixels instanceof HTMLVideoElement) isVideo = true;
    else if (typeof HTMLImageElement !== 'undefined' && pixels instanceof HTMLImageElement) isImage = true;
    else if (pixels.getContext != null) isCanvasLike = true;
    else if (typeof ImageBitmap !== 'undefined' && pixels instanceof ImageBitmap) isImageBitmap = true;
    else throw new Error('pixels passed to tf.browser.fromPixels() must be either an ' + `HTMLVideoElement, HTMLImageElement, HTMLCanvasElement, ImageData ` + `in browser, or OffscreenCanvas, ImageData in webworker` + ` or {data: Uint32Array, width: number, height: number}, ` + `but was ${pixels.constructor.name}`);
    // If the current backend has 'FromPixels' registered, it has a more
    // efficient way of handling pixel uploads, so we call that.
    const kernel = (0, $kaJSw.getKernel)((0, $dCP8m.FromPixels), (0, $aHfUM.ENGINE).backendName);
    if (kernel != null) {
        const inputs = {
            pixels: pixels
        };
        const attrs = {
            numChannels: numChannels
        };
        return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.FromPixels), inputs, attrs);
    }
    const [width, height] = isVideo ? [
        pixels.videoWidth,
        pixels.videoHeight
    ] : [
        pixels.width,
        pixels.height
    ];
    let vals;
    if (isCanvasLike) vals = // tslint:disable-next-line:no-any
    pixels.getContext('2d').getImageData(0, 0, width, height).data;
    else if (isImageData || isPixelData) vals = pixels.data;
    else if (isImage || isVideo || isImageBitmap) {
        if ($7cdcfa637085d9f8$var$fromPixels2DContext == null) {
            if (typeof document === 'undefined') {
                if (typeof OffscreenCanvas !== 'undefined' && typeof OffscreenCanvasRenderingContext2D !== 'undefined') // @ts-ignore
                $7cdcfa637085d9f8$var$fromPixels2DContext = new OffscreenCanvas(1, 1).getContext('2d');
                else throw new Error("Cannot parse input in current context. Reason: OffscreenCanvas Context2D rendering is not supported.");
            } else $7cdcfa637085d9f8$var$fromPixels2DContext = document.createElement('canvas').getContext('2d', {
                willReadFrequently: true
            });
        }
        $7cdcfa637085d9f8$var$fromPixels2DContext.canvas.width = width;
        $7cdcfa637085d9f8$var$fromPixels2DContext.canvas.height = height;
        $7cdcfa637085d9f8$var$fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
        vals = $7cdcfa637085d9f8$var$fromPixels2DContext.getImageData(0, 0, width, height).data;
    }
    let values;
    if (numChannels === 4) values = new Int32Array(vals);
    else {
        const numPixels = width * height;
        values = new Int32Array(numPixels * numChannels);
        for(let i = 0; i < numPixels; i++)for(let channel = 0; channel < numChannels; ++channel)values[i * numChannels + channel] = vals[i * 4 + channel];
    }
    const outShape = [
        height,
        width,
        numChannels
    ];
    return (0, $gLH3k.tensor3d)(values, outShape, 'int32');
}
// Helper functions for |fromPixelsAsync| to check whether the input can
// be wrapped into imageBitmap.
function $7cdcfa637085d9f8$var$isPixelData(pixels) {
    return pixels != null && pixels.data instanceof Uint8Array;
}
function $7cdcfa637085d9f8$var$isImageBitmapFullySupported() {
    return typeof window !== 'undefined' && typeof ImageBitmap !== 'undefined' && window.hasOwnProperty('createImageBitmap');
}
function $7cdcfa637085d9f8$var$isNonEmptyPixels(pixels) {
    return pixels != null && pixels.width !== 0 && pixels.height !== 0;
}
function $7cdcfa637085d9f8$var$canWrapPixelsToImageBitmap(pixels) {
    return $7cdcfa637085d9f8$var$isImageBitmapFullySupported() && !(pixels instanceof ImageBitmap) && $7cdcfa637085d9f8$var$isNonEmptyPixels(pixels) && !$7cdcfa637085d9f8$var$isPixelData(pixels);
}
async function $7cdcfa637085d9f8$export$6b17f27238fa6bff(pixels, numChannels = 3) {
    let inputs = null;
    // Check whether the backend needs to wrap |pixels| to imageBitmap and
    // whether |pixels| can be wrapped to imageBitmap.
    if ((0, $aymVi.env)().getBool('WRAP_TO_IMAGEBITMAP') && $7cdcfa637085d9f8$var$canWrapPixelsToImageBitmap(pixels)) {
        // Force the imageBitmap creation to not do any premultiply alpha
        // ops.
        let imageBitmap;
        try {
            // wrap in try-catch block, because createImageBitmap may not work
            // properly in some browsers, e.g.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1335594
            // tslint:disable-next-line: no-any
            imageBitmap = await createImageBitmap(pixels, {
                premultiplyAlpha: 'none'
            });
        } catch (e) {
            imageBitmap = null;
        }
        // createImageBitmap will clip the source size.
        // In some cases, the input will have larger size than its content.
        // E.g. new Image(10, 10) but with 1 x 1 content. Using
        // createImageBitmap will clip the size from 10 x 10 to 1 x 1, which
        // is not correct. We should avoid wrapping such resouce to
        // imageBitmap.
        if (imageBitmap != null && imageBitmap.width === pixels.width && imageBitmap.height === pixels.height) inputs = imageBitmap;
        else inputs = pixels;
    } else inputs = pixels;
    return $7cdcfa637085d9f8$var$fromPixels_(inputs, numChannels);
}
async function $7cdcfa637085d9f8$export$89b6cc959998e12e(img, canvas) {
    let $img = (0, $5R1UY.convertToTensor)(img, 'img', 'toPixels');
    if (!(img instanceof (0, $bVnU9.Tensor))) {
        // Assume int32 if user passed a native array.
        const originalImgTensor = $img;
        $img = (0, $7qWZ5.cast)(originalImgTensor, 'int32');
        originalImgTensor.dispose();
    }
    if ($img.rank !== 2 && $img.rank !== 3) throw new Error(`toPixels only supports rank 2 or 3 tensors, got rank ${$img.rank}.`);
    const [height, width] = $img.shape.slice(0, 2);
    const depth = $img.rank === 2 ? 1 : $img.shape[2];
    if (depth > 4 || depth === 2) throw new Error(`toPixels only supports depth of size ` + `1, 3 or 4 but got ${depth}`);
    if ($img.dtype !== 'float32' && $img.dtype !== 'int32') throw new Error(`Unsupported type for toPixels: ${$img.dtype}.` + ` Please use float32 or int32 tensors.`);
    const data = await $img.data();
    const multiplier = $img.dtype === 'float32' ? 255 : 1;
    const bytes = new Uint8ClampedArray(width * height * 4);
    for(let i = 0; i < height * width; ++i){
        const rgba = [
            0,
            0,
            0,
            255
        ];
        for(let d = 0; d < depth; d++){
            const value = data[i * depth + d];
            if ($img.dtype === 'float32') {
                if (value < 0 || value > 1) throw new Error(`Tensor values for a float32 Tensor must be in the ` + `range [0 - 1] but encountered ${value}.`);
            } else if ($img.dtype === 'int32') {
                if (value < 0 || value > 255) throw new Error(`Tensor values for a int32 Tensor must be in the ` + `range [0 - 255] but encountered ${value}.`);
            }
            if (depth === 1) {
                rgba[0] = value * multiplier;
                rgba[1] = value * multiplier;
                rgba[2] = value * multiplier;
            } else rgba[d] = value * multiplier;
        }
        const j = i * 4;
        bytes[j + 0] = Math.round(rgba[0]);
        bytes[j + 1] = Math.round(rgba[1]);
        bytes[j + 2] = Math.round(rgba[2]);
        bytes[j + 3] = Math.round(rgba[3]);
    }
    if (canvas != null) {
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        const imageData = new ImageData(bytes, width, height);
        ctx.putImageData(imageData, 0, 0);
    }
    if ($img !== img) $img.dispose();
    return bytes;
}
const $7cdcfa637085d9f8$export$5a3bc84b10e77d32 = (0, $jKUCi.op)({
    fromPixels_: $7cdcfa637085d9f8$var$fromPixels_
});

});
parcelRegister("gLH3k", function(module, exports) {

$parcel$export(module.exports, "tensor3d", () => $c3526e79f88eecfe$export$aa36a9de53c6d912);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $lVIqi = parcelRequire("lVIqi");
function $c3526e79f88eecfe$export$aa36a9de53c6d912(values, shape, dtype) {
    (0, $4tCOB.assertNonNull)(values);
    if (shape != null && shape.length !== 3) throw new Error('tensor3d() requires shape to have three numbers');
    const inferredShape = (0, $5R1UY.inferShape)(values, dtype);
    if (inferredShape.length !== 3 && inferredShape.length !== 1) throw new Error('tensor3d() requires values to be number[][][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor3d() requires shape to be provided when `values` are a flat array");
    return (0, $lVIqi.makeTensor)(values, shape, inferredShape, dtype);
}

});


parcelRegister("exBKX", function(module, exports) {

$parcel$export(module.exports, "prepareAndValidate", () => $a9616f61d133ba3d$export$6bb34ea9be10068f);

var $4tCOB = parcelRequire("4tCOB");
function $a9616f61d133ba3d$export$6bb34ea9be10068f(tensor, indices) {
    const tensorRank = tensor.shape.length;
    const indicesRank = indices.shape.length;
    if (tensorRank < 1) throw new Error('tf.gatherND() expects the input to be rank 1 or higher,' + ` but the rank was ${tensorRank}.`);
    if (indicesRank < 1) throw new Error('tf.gatherND() expects the indices to be rank 1 or higher,' + ` but the rank was ${indicesRank}.`);
    if (indices.dtype !== 'int32') throw new Error('tf.gatherND() expects the indices to be int32 type,' + ` but the dtype was ${indices.dtype}.`);
    if (indices.shape[indicesRank - 1] > tensorRank) throw new Error('index innermost dimension length must be <= tensor rank; saw: ' + `${indices.shape[indicesRank - 1]} vs. ${tensorRank}`);
    if ((0, $4tCOB.sizeFromShape)(tensor.shape) === 0) throw new Error('Requested more than 0 entries, but input is empty.' + ` Input shape: ${tensor.shape}.`);
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    // The result shape is
    //   indices.shape[:-1] + params.shape[indices.shape[-1]:]
    let nResult = 1;
    for(let i = 0; i < indicesShape.length - 1; ++i)nResult *= indicesShape[i];
    const inputShape = tensor.shape;
    const resultShape = indicesShape.slice();
    resultShape.pop();
    let sliceSize = 1;
    for(let i = sliceRank; i < tensorRank; ++i){
        sliceSize *= inputShape[i];
        resultShape.push(inputShape[i]);
    }
    const strides = [
        ...(0, $4tCOB.computeStrides)(tensor.shape).map((stride)=>stride / sliceSize),
        1
    ].slice(0, sliceRank);
    return [
        resultShape,
        nResult,
        sliceSize,
        strides
    ];
}

});

parcelRegister("bSeux", function(module, exports) {

$parcel$export(module.exports, "validateUpdateShape", () => $8a4ffa8fdcf12402$export$9d843bc97e7022ed);
$parcel$export(module.exports, "validateInput", () => $8a4ffa8fdcf12402$export$4d09d4ac8ba225dd);
$parcel$export(module.exports, "calculateShapes", () => $8a4ffa8fdcf12402$export$4dc1a8917bf18661);

var $4tCOB = parcelRequire("4tCOB");
function $8a4ffa8fdcf12402$export$9d843bc97e7022ed(shape, indices, updates) {
    const sliceDim = indices.rank > 1 ? indices.shape[indices.rank - 1] : 1;
    const batchDim = indices.rank > 1 ? indices.rank - 1 : 1;
    const shapeError = 'Must have updates.shape = indices.shape[:batchDim] + ' + `shape[sliceDim:], got updates.shape: ${updates.shape}` + `, indices.shape: ${indices.shape}, shape: ${shape}` + `, sliceDim: ${sliceDim}, and batchDim: ${batchDim}.`;
    if (updates.rank < batchDim) throw new Error(shapeError + ` update.rank < ${batchDim}. `);
    if (shape.length < sliceDim + (updates.rank - batchDim)) throw new Error(shapeError + ` Output shape length < ${sliceDim + (updates.rank - batchDim)}`);
    if (updates.rank !== batchDim + shape.length - sliceDim) throw new Error(shapeError + ` update.rank != ${batchDim + shape.length - sliceDim}`);
    for(let d = 0; d < batchDim; ++d){
        if (updates.shape[d] !== indices.shape[d]) throw new Error(shapeError + ` updates.shape[${d}] (${updates.shape[d]}) != indices.shape[${d}] (${indices.shape[d]}).`);
    }
    for(let d = 0; d < updates.rank - batchDim; ++d){
        if (updates.shape[d + batchDim] !== shape[d + sliceDim]) throw new Error(shapeError + ` updates.shape[${d + batchDim}] (${updates.shape[d + batchDim]}) != shape[${d + batchDim}] (${shape[d + batchDim]})`);
    }
}
function $8a4ffa8fdcf12402$export$4d09d4ac8ba225dd(updates, indices, shape) {
    if (indices.rank < 1) throw new Error('tf.scatterND() expects the indices to be rank 1 or higher,' + ` but the rank was ${indices.rank}.`);
    if (updates.rank < 1) throw new Error('tf.scatterND() expects the updates to be rank 1 or higher,' + ` but the rank was ${updates.rank}.`);
    if (indices.dtype !== 'int32') throw new Error(`The dtype of 'indices' should be int32, but got dtype: ${indices.dtype}`);
    if (shape.length < 1) throw new Error(`Output rank must be greater or equal to 1, but got shape: ${shape}`);
    if (shape.length === 0) {
        if (indices.size === 0) throw new Error(`Indices specified for empty output. indices shape: ${indices.shape}`);
        if (updates.size === 0) throw new Error(`Updates specified for empty output. updates shape: ${updates.shape}`);
    }
    $8a4ffa8fdcf12402$export$9d843bc97e7022ed(shape, indices, updates);
}
function $8a4ffa8fdcf12402$export$4dc1a8917bf18661(updates, indices, shape) {
    // Calculate the number of dimensions in indices
    const indicesRank = indices.shape.length;
    const sliceRank = indicesRank > 1 ? indices.shape[indicesRank - 1] : 1;
    // Calculate the number of elements that make up each slice of our updated
    // tensor. This allows us to work with flattened tensors and copy over whole
    // slices at a time.
    const totalNd = shape.length;
    let sliceSize = 1;
    for(let i = sliceRank; i < totalNd; ++i)sliceSize *= shape[i];
    const safeSliceDim = sliceRank < 1 ? 1 : sliceRank;
    const numUpdates = (0, $4tCOB.sizeFromShape)(indices.shape) / safeSliceDim;
    const strides = [
        ...(0, $4tCOB.computeStrides)(shape.slice(0, sliceRank)),
        1
    ];
    const outputSize = (0, $4tCOB.sizeFromShape)(shape);
    return {
        sliceRank: sliceRank,
        numUpdates: numUpdates,
        sliceSize: sliceSize,
        strides: strides,
        outputSize: outputSize
    };
}

});

parcelRegister("1KPDG", function(module, exports) {

$parcel$export(module.exports, "assertParamsValid", () => $147224c93eb5f660$export$1da6c8ba17e84239);
$parcel$export(module.exports, "maskToAxes", () => $147224c93eb5f660$export$ce8be3e704107015);
$parcel$export(module.exports, "computeOutShape", () => $147224c93eb5f660$export$22fa6b3b1305508e);
$parcel$export(module.exports, "stridesWithElidedDims", () => $147224c93eb5f660$export$7f5fa1173bdb6e15);
$parcel$export(module.exports, "getNormalizedAxes", () => $147224c93eb5f660$export$895fe9252fb79d1);
$parcel$export(module.exports, "startIndicesWithElidedDims", () => $147224c93eb5f660$export$a9f0de12634a4ce3);
$parcel$export(module.exports, "stopIndicesWithElidedDims", () => $147224c93eb5f660$export$19a416bd7e87244f);
$parcel$export(module.exports, "startForAxis", () => $147224c93eb5f660$export$643aca61b9318da8);
$parcel$export(module.exports, "stopForAxis", () => $147224c93eb5f660$export$612a961a199ffe65);
$parcel$export(module.exports, "stridesForAxis", () => $147224c93eb5f660$export$9e3fd91f45c1f07f);
$parcel$export(module.exports, "isSliceContinous", () => $147224c93eb5f660$export$9dc11bd6855e72c6);
$parcel$export(module.exports, "computeFlatOffset", () => $147224c93eb5f660$export$b01553f5da8f819c);
$parcel$export(module.exports, "parseSliceParams", () => $147224c93eb5f660$export$8448a0604fef5d62);
$parcel$export(module.exports, "sliceInfo", () => $147224c93eb5f660$export$54d224865abb6767);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
const $147224c93eb5f660$var$NEW_AXIS = -2;
const $147224c93eb5f660$var$SHRINK_AXIS = -1;
function $147224c93eb5f660$export$1da6c8ba17e84239(input, begin, size) {
    const inputRank = input.shape.length;
    $4tCOB.assert(inputRank === begin.length, ()=>`Error in slice${inputRank}D: Length of begin ${begin} must ` + `match the rank of the array (${inputRank}).`);
    $4tCOB.assert(inputRank === size.length, ()=>`Error in slice${inputRank}D: Length of size ${size} must ` + `match the rank of the array (${inputRank}).`);
    for(let i = 0; i < inputRank; ++i)$4tCOB.assert(begin[i] + size[i] <= input.shape[i], ()=>`Error in slice${inputRank}D: begin[${i}] + size[${i}] ` + `(${begin[i] + size[i]}) would overflow input.shape[${i}] (${input.shape[i]})`);
}
function $147224c93eb5f660$export$ce8be3e704107015(mask) {
    const axes = [];
    let axis = 0;
    while(mask > 0){
        if (mask & 1) axes.push(axis);
        mask /= 2;
        axis++;
    }
    return axes;
}
function $147224c93eb5f660$export$22fa6b3b1305508e(begin, end, strides) {
    const size = [];
    for(let axis = 0; axis < begin.length; axis++)size[axis] = Math.ceil((end[axis] - begin[axis]) / strides[axis]);
    return size;
}
function $147224c93eb5f660$export$7f5fa1173bdb6e15(strides, ellipsisInsertionIndex, numElidedAxes, inputShape) {
    const newStrides = [
        ...strides
    ];
    for(let i = newStrides.length; i < inputShape.length; i++)newStrides.push(1);
    for(let i = 0; i < numElidedAxes; i++)if (i === 0) newStrides[ellipsisInsertionIndex] = 1;
    else {
        newStrides.splice(ellipsisInsertionIndex, 0 /* num elements to delete */ , 1 /* element to add */ );
        newStrides.pop();
    }
    return newStrides;
}
function $147224c93eb5f660$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, normalizedAxis) {
    if (normalizedAxis <= ellipsisInsertionIndex) return normalizedAxis;
    return normalizedAxis - (numElidedAxes - 1);
}
function $147224c93eb5f660$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex) {
    const elidedAxes = [];
    for(let i = 0; i < numElidedAxes; i++)elidedAxes.push(ellipsisInsertionIndex + i);
    return elidedAxes;
}
function $147224c93eb5f660$export$895fe9252fb79d1(inputShape, ellipsisAxes, numInterpolatedAxes, begin, end, strides, beginMask, endMask, ellipsisMask) {
    const inputRank = inputShape.length;
    let normalizedBegin = new Array(inputRank), normalizedEnd = new Array(inputRank), normalizedStrides = new Array(inputRank);
    if (ellipsisAxes.length && numInterpolatedAxes > 0) {
        const fullIndex = ellipsisAxes[0];
        // The ellipsis applies to the masked index as well as any dimensions
        // that are interpolated.
        const numElidedAxes = numInterpolatedAxes + 1;
        normalizedBegin = $147224c93eb5f660$export$a9f0de12634a4ce3(beginMask, fullIndex, numElidedAxes, begin, inputShape);
        normalizedEnd = $147224c93eb5f660$export$19a416bd7e87244f(endMask, fullIndex, numElidedAxes, end, inputShape);
        normalizedStrides = $147224c93eb5f660$export$7f5fa1173bdb6e15(strides, fullIndex, numElidedAxes, inputShape);
    } else for(let axis = 0; axis < inputRank; axis++){
        normalizedBegin[axis] = $147224c93eb5f660$export$643aca61b9318da8(beginMask, begin, strides, inputShape, axis, ellipsisMask);
        normalizedEnd[axis] = $147224c93eb5f660$export$612a961a199ffe65(endMask, end, strides, inputShape, axis, ellipsisMask);
        normalizedStrides[axis] = $147224c93eb5f660$export$9e3fd91f45c1f07f(strides, axis, ellipsisMask);
    }
    return {
        begin: normalizedBegin,
        end: normalizedEnd,
        strides: normalizedStrides
    };
}
function $147224c93eb5f660$export$a9f0de12634a4ce3(beginMask, ellipsisInsertionIndex, numElidedAxes, originalBegin, inputShape) {
    const newIndices = [
        ...inputShape
    ];
    const elidedAxes = $147224c93eb5f660$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex);
    for(let axis = 0; axis < newIndices.length; axis++)if (elidedAxes.indexOf(axis) > -1) newIndices[axis] = 0;
    else {
        const originalAxis = $147224c93eb5f660$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, axis);
        let originalValue = originalBegin[originalAxis];
        if (beginMask & 1 << originalAxis) originalValue = 0;
        newIndices[axis] = originalValue;
    }
    return newIndices;
}
function $147224c93eb5f660$export$19a416bd7e87244f(endMask, ellipsisInsertionIndex, numElidedAxes, originalEnd, inputShape) {
    const newIndices = [
        ...inputShape
    ];
    const elidedAxes = $147224c93eb5f660$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex);
    for(let axis = 0; axis < newIndices.length; axis++)if (elidedAxes.indexOf(axis) > -1) newIndices[axis] = Number.MAX_SAFE_INTEGER;
    else {
        const originalAxis = $147224c93eb5f660$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, axis);
        let originalValue = originalEnd[originalAxis];
        if (endMask & 1 << originalAxis) originalValue = Number.MAX_SAFE_INTEGER;
        newIndices[axis] = originalValue;
    }
    for(let i = 0; i < newIndices.length; i++){
        // Handle negative indices
        const axisSize = inputShape[i];
        if (newIndices[i] < 0) newIndices[i] += axisSize;
        newIndices[i] = $4tCOB.clamp(0, newIndices[i], inputShape[i]);
    }
    return newIndices;
}
function $147224c93eb5f660$export$9e3fd91f45c1f07f(strides, axis, ellipsisMask) {
    let stride = strides[axis];
    if (ellipsisMask & 1 << axis || stride == null) stride = 1;
    return stride;
}
function $147224c93eb5f660$export$643aca61b9318da8(beginMask, startIndices, strides, inputShape, axis, ellipsisMask) {
    // Begin with the specified index
    let start = startIndices[axis];
    const stride = strides[axis] || 1;
    // Check the axis bit from right of masked axes, or the begin index is not set
    // for the axis.
    if (beginMask & 1 << axis || ellipsisMask & 1 << axis || start == null) {
        if (stride > 0) // Forward iteration - use the first element. These values will get
        // clamped below (Note: We could have set them to 0 and axis_size-1, but
        // use lowest() and max() to maintain symmetry with StopForAxis())
        start = Number.MIN_SAFE_INTEGER;
        else // Backward iteration - use the last element.
        start = Number.MAX_SAFE_INTEGER;
    }
    // Handle negative indices
    const axisSize = inputShape[axis];
    if (start < 0) start += axisSize;
    // Clamping
    start = $4tCOB.clamp(0, start, axisSize - 1);
    return start;
}
function $147224c93eb5f660$export$612a961a199ffe65(endMask, stopIndices, strides, inputShape, axis, ellipsisMask) {
    // Begin with the specified index
    let stop = stopIndices[axis];
    const stride = strides[axis] || 1;
    // Check the axis bit from right of masked axes, or if the stop index is not
    // set for this axis.
    if (endMask & 1 << axis || ellipsisMask & 1 << axis || stop == null) {
        if (stride > 0) // Forward iteration - use the last element. These values will get
        // clamped below
        stop = Number.MAX_SAFE_INTEGER;
        else // Backward iteration - use the first element.
        stop = Number.MIN_SAFE_INTEGER;
    }
    // Handle negative indices
    const axisSize = inputShape[axis];
    if (stop < 0) stop += axisSize;
    // Clamping
    // Because the end index points one past the last element, we need slightly
    // different clamping ranges depending on the direction.
    if (stride > 0) // Forward iteration
    stop = $4tCOB.clamp(0, stop, axisSize);
    else // Backward iteration
    stop = $4tCOB.clamp(-1, stop, axisSize - 1);
    return stop;
}
function $147224c93eb5f660$export$9dc11bd6855e72c6(shape, begin, size) {
    // Index of the first axis that has size > 1.
    let firstNonOneAxis = size.length;
    for(let i = 0; i < size.length; i++)if (size[i] > 1) {
        firstNonOneAxis = i;
        break;
    }
    for(let i = firstNonOneAxis + 1; i < size.length; i++){
        if (begin[i] > 0 || size[i] !== shape[i]) return false;
    }
    return true;
}
function $147224c93eb5f660$export$b01553f5da8f819c(begin, strides) {
    let flatOffset = begin.length > 0 ? begin[begin.length - 1] : 1;
    for(let i = 0; i < begin.length - 1; i++)flatOffset += begin[i] * strides[i];
    return flatOffset;
}
function $147224c93eb5f660$export$8448a0604fef5d62(x, begin, size) {
    // The following logic allows for more ergonomic calls.
    let begin_;
    const xRank = x.shape.length;
    if (typeof begin === 'number') begin_ = [
        begin,
        ...new Array(xRank - 1).fill(0)
    ];
    else if (begin.length < xRank) begin_ = begin.concat(new Array(xRank - begin.length).fill(0));
    else begin_ = begin.slice();
    begin_.forEach((d)=>{
        $4tCOB.assert(d !== -1, ()=>'slice() does not support negative begin indexing.');
    });
    let size_;
    if (size == null) size_ = new Array(xRank).fill(-1);
    else if (typeof size === 'number') size_ = [
        size,
        ...new Array(xRank - 1).fill(-1)
    ];
    else if (size.length < xRank) size_ = size.concat(new Array(xRank - size.length).fill(-1));
    else size_ = size;
    size_ = size_.map((d, i)=>{
        if (d >= 0) return d;
        else {
            $4tCOB.assert(d === -1, ()=>`Negative size values should be exactly -1 but got ` + `${d} for the slice() size at index ${i}.`);
            return x.shape[i] - begin_[i];
        }
    });
    return [
        begin_,
        size_
    ];
}
function $147224c93eb5f660$export$54d224865abb6767(xShape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask) {
    let stridesNonNull;
    if (strides == null) {
        stridesNonNull = new Array(begin.length);
        stridesNonNull.fill(1);
    } else stridesNonNull = strides;
    // Only one non-zero bit is allowed in ellipsisMask, which means ellipsisMask
    // is a power of 2. Use bit compares to ensure ellipsisMask is 0 or a power
    // of 2. When i is a power of 2, i & (i - 1) is always 0.
    // Also ref:
    // https://stackoverflow.com/questions/600293/how-to-check-if-a-number-is-a-power-of-2
    if (ellipsisMask != null && (ellipsisMask & ellipsisMask - 1) !== 0) throw new Error('Multiple ellipses in slice is not allowed.');
    // Step 1: Account for ellipsis and new axis.
    // Check for ellipsis and count how many non-newaxis there are after.
    let ellipsisSeen = false;
    const sparseSpec = {
        dims: stridesNonNull.length,
        numAddAxisAfterEllipsis: 0,
        begin: begin.slice(),
        end: end.slice(),
        strides: stridesNonNull.slice(),
        beginMask: beginMask,
        endMask: endMask,
        ellipsisMask: ellipsisMask,
        newAxisMask: newAxisMask,
        shrinkAxisMask: shrinkAxisMask
    };
    for(let i = 0; i < sparseSpec.dims; i++){
        if (ellipsisSeen && (1 << i & newAxisMask) !== 0) sparseSpec.numAddAxisAfterEllipsis++;
        if (1 << i & ellipsisMask) ellipsisSeen = true;
    }
    // If no ellipsis insert one at the end.
    if (!ellipsisSeen) {
        sparseSpec.ellipsisMask |= 1 << sparseSpec.dims;
        sparseSpec.dims++; // this effects loop iteration below
    }
    // Step 2: Make a sparse spec into a full index spec.
    //
    // The sparse spec deos not correspond to the number of dimensions.
    // Make a dense spec that cooresponds to the number of dimensions.
    //
    // For example suppose foo[...,3:] on foo.shape = [2, 2, 3] then we need to
    // produce the missing beginMask for the first two dimensions i.e. from
    // beginMaskSpec = 0, endMaskSpec = 2, we achieve beginMask = 6 (110),
    // endMask = 7 (111).
    const denseSpec = {
        dims: xShape.length,
        beginMask: 0,
        endMask: 0,
        beginValid: false,
        endValid: false
    };
    $147224c93eb5f660$var$buildDenseSpec(sparseSpec, denseSpec);
    // Step 3: Make implicit ranges (non-zero beginMasks and endMasks) explicit
    // and bounds check.
    let isIdentity = true;
    let sliceDim0 = true;
    let isSimpleSlice = true;
    const processingShape = [];
    const finalShape = [];
    for(let i = 0; i < xShape.length; ++i){
        if (denseSpec.strides[i] === 0) throw Error(`strides[${i}] must be non-zero`);
        const shrinkI = !!(denseSpec.shrinkAxisMask & 1 << i);
        const dimI = xShape[i];
        if (dimI === -1) {
            processingShape.push(shrinkI ? 1 : -1);
            continue;
        }
        const masks = [
            denseSpec.beginMask & 1 << i,
            denseSpec.endMask & 1 << i
        ];
        const validRange = [
            denseSpec.strides[i] > 0 ? 0 : -1,
            denseSpec.strides[i] > 0 ? dimI : dimI - 1
        ];
        if (shrinkI && denseSpec.strides[i] <= 0) throw Error('only stride 1 allowed on non-range indexing.');
        isSimpleSlice = isSimpleSlice && denseSpec.strides[i] === 1;
        const beginAndEndMasked = !!(denseSpec.beginMask & 1 << i && denseSpec.endMask & 1 << i);
        if (denseSpec.beginValid && denseSpec.endValid) {
            if (shrinkI) {
                // If we are shrinking, the end index is now possibly incorrect. In
                // particular foo[-1] produces sparseBegin = -1, sparseEnd = 0.
                // and canonical puts these to n-1 and 0, which implies a degenerate
                // interval. Fortunately, it is now safe to re-create end as begin + 1.
                const xFwd = denseSpec.begin[i] < 0 ? dimI + denseSpec.begin[i] : denseSpec.begin[i];
                denseSpec.begin[i] = xFwd;
                denseSpec.end[i] = denseSpec.begin[i] + 1;
                if (xFwd < 0 || xFwd >= dimI) throw Error(`slice index ${denseSpec.begin[i]} of dimension ${i} out of bounds.`);
            } else {
                denseSpec.begin[i] = $147224c93eb5f660$var$canonical(denseSpec.begin[i], 0, denseSpec.strides[i], dimI, masks, validRange);
                denseSpec.end[i] = $147224c93eb5f660$var$canonical(denseSpec.end[i], 1, denseSpec.strides[i], dimI, masks, validRange);
            }
            // Update optimization values
            const takeAllInDimension = denseSpec.strides[i] === 1 && denseSpec.begin[i] === 0 && denseSpec.end[i] === dimI;
            isIdentity = isIdentity && takeAllInDimension;
            sliceDim0 = sliceDim0 && (i === 0 && denseSpec.strides[i] === 1 || takeAllInDimension);
        } else {
            isIdentity = isIdentity && denseSpec.strides[i] === 1 && beginAndEndMasked;
            sliceDim0 = sliceDim0 && (i === 0 && denseSpec.strides[i] === 1 || beginAndEndMasked);
        }
        // Compute the processing shape (the intermediate Eigen will produce)
        let intervalLength;
        let knownInterval = false;
        if (denseSpec.beginValid && denseSpec.endValid) {
            intervalLength = denseSpec.end[i] - denseSpec.begin[i];
            knownInterval = true;
        } else if (shrinkI) {
            // The dimension is still known as 1 for the processingShape, but will be
            // discarded for the final shape.
            intervalLength = 1;
            knownInterval = true;
        } else if (beginAndEndMasked) // Even if we don't have values for begin or end, we do know that this
        // dimension covers the whole interval. If we have shape information for
        // this dimension, that tells us the interval length.
        {
            if (dimI >= 0) {
                if (denseSpec.strides[i] < 0) intervalLength = -dimI;
                else intervalLength = dimI;
                knownInterval = true;
            }
        }
        if (knownInterval) {
            let sizeI;
            // Hold zero if the interval is degenerate, otherwise account for
            // remainder
            if (intervalLength === 0 || intervalLength < 0 !== denseSpec.strides[i] < 0) sizeI = 0;
            else sizeI = Math.trunc(intervalLength / denseSpec.strides[i]) + (intervalLength % denseSpec.strides[i] !== 0 ? 1 : 0);
            processingShape.push(sizeI);
        } else processingShape.push(-1);
    }
    // Step 4: Compute the final shape
    //
    // newAxis will increase dimension by 1 (with a one-size dimension)
    // slices like foo[3, ...] will reduce dimension by 1.
    // This cannot be done earlier, because it depends on Step 3.
    for(let denseDim = 0; denseDim < denseSpec.finalShapeGatherIndices.length; ++denseDim){
        const gatherIndex = denseSpec.finalShapeGatherIndices[denseDim];
        if (gatherIndex >= 0) finalShape.push(processingShape[gatherIndex]);
        else if (gatherIndex === $147224c93eb5f660$var$NEW_AXIS) finalShape.push(1);
    }
    const finalShapeSparse = finalShape.filter((dim, i)=>denseSpec.finalShapeGatherIndices[i] !== $147224c93eb5f660$var$NEW_AXIS);
    return {
        finalShapeSparse: finalShapeSparse,
        finalShape: finalShape,
        isIdentity: isIdentity,
        sliceDim0: sliceDim0,
        isSimpleSlice: isSimpleSlice,
        begin: denseSpec.begin,
        end: denseSpec.end,
        strides: denseSpec.strides
    };
}
function $147224c93eb5f660$var$buildDenseSpec(sparse, dense) {
    dense.beginMask = 0;
    dense.endMask = 0;
    dense.shrinkAxisMask = 0;
    let fullIndex = 0;
    dense.beginValid = sparse.begin != null;
    dense.endValid = sparse.end != null;
    dense.begin = new Array(dense.dims);
    dense.end = new Array(dense.dims);
    dense.strides = new Array(dense.dims);
    dense.finalShapeGatherIndices = [];
    dense.finalShapeGatherIndicesSparse = [];
    dense.inputShapeGatherIndicesSparse = new Array(dense.dims);
    for(let i = 0; i < sparse.dims; i++){
        if (1 << i & sparse.ellipsisMask) {
            // Only the bit that has ellipsis will fall in this condition.
            // Expand the ellipsis into the appropriate indices
            // Note: this only works because we guaranteed one ellipsis.
            const nextIndex = Math.min(dense.dims - (sparse.dims - i) + 1 + sparse.numAddAxisAfterEllipsis, dense.dims);
            for(; fullIndex < nextIndex; fullIndex++){
                // newAxis aren't real axis so you have to skip.
                dense.begin[fullIndex] = 0;
                dense.end[fullIndex] = 0;
                dense.strides[fullIndex] = 1;
                dense.beginMask |= 1 << fullIndex;
                dense.endMask |= 1 << fullIndex;
                dense.finalShapeGatherIndices.push(fullIndex);
                dense.finalShapeGatherIndicesSparse.push(-1);
                dense.inputShapeGatherIndicesSparse[fullIndex] = i;
            }
        } else if (1 << i & sparse.newAxisMask) {
            // Only the bit that has newAxis will fall in this condition.
            dense.finalShapeGatherIndices.push($147224c93eb5f660$var$NEW_AXIS);
            dense.finalShapeGatherIndicesSparse.push(-1);
        } else {
            if (fullIndex === dense.begin.length) throw Error(`Index out of range using input dim ${fullIndex}; input ` + `has only ${dense.dims} dims, ${dense.begin.length}.`);
            // Gather slicing spec into appropriate index.
            if (sparse.begin != null) dense.begin[fullIndex] = sparse.begin[i];
            if (sparse.end != null) dense.end[fullIndex] = sparse.end[i];
            dense.strides[fullIndex] = sparse.strides[i];
            if (sparse.beginMask & 1 << i) dense.beginMask |= 1 << fullIndex;
            if (sparse.endMask & 1 << i) dense.endMask |= 1 << fullIndex;
            // If shrink, record where to get the dimensionality from (i.e. newAxis)
            // creates a fake 1 size dimension. Also remember shrink axis (now in
            // dense form) so we can ignore dense.end below.
            if (sparse.shrinkAxisMask & 1 << i) {
                dense.finalShapeGatherIndices.push($147224c93eb5f660$var$SHRINK_AXIS);
                dense.finalShapeGatherIndicesSparse.push(-1);
                dense.shrinkAxisMask |= 1 << fullIndex;
            } else {
                dense.finalShapeGatherIndices.push(fullIndex);
                // Remember that where in the sparse shape the dense dim comes from.
                dense.finalShapeGatherIndicesSparse.push(i);
            }
            dense.inputShapeGatherIndicesSparse[fullIndex] = i;
            fullIndex++;
        }
    }
}
function $147224c93eb5f660$var$canonical(x, c, strideI, dimI, masks, validRange) {
    if (masks[c]) return strideI > 0 ? validRange[c] : validRange[c + 1 & 1];
    else {
        const xFwd = x < 0 ? dimI + x : x; // make negative indices positive
        return xFwd < validRange[0] ? validRange[0] : xFwd > validRange[1] ? validRange[1] : xFwd;
    }
}

});

parcelRegister("8AyuI", function(module, exports) {

$parcel$export(module.exports, "Serializable", () => $640c71683f3098a3$export$64782a6a7800f48c);
$parcel$export(module.exports, "SerializationMap", () => $640c71683f3098a3$export$3a868b20f0f2f6c0);
$parcel$export(module.exports, "registerClass", () => $640c71683f3098a3$export$a3f7d716dc76cb2e);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
class $640c71683f3098a3$export$64782a6a7800f48c {
    /**
     * Return the class name for this class to use in serialization contexts.
     *
     * Generally speaking this will be the same thing that constructor.name
     * would have returned.  However, the class name needs to be robust
     * against minification for serialization/deserialization to work properly.
     *
     * There's also places such as initializers.VarianceScaling, where
     * implementation details between different languages led to different
     * class hierarchies and a non-leaf node is used for serialization purposes.
     */ getClassName() {
        return this.constructor.className;
    }
    /**
     * Creates an instance of T from a ConfigDict.
     *
     * This works for most descendants of serializable.  A few need to
     * provide special handling.
     * @param cls A Constructor for the class to instantiate.
     * @param config The Configuration for the object.
     */ /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config);
    }
}
class $640c71683f3098a3$export$3a868b20f0f2f6c0 {
    constructor(){
        this.classNameMap = {};
    }
    /**
     * Returns the singleton instance of the map.
     */ static getMap() {
        if ($640c71683f3098a3$export$3a868b20f0f2f6c0.instance == null) $640c71683f3098a3$export$3a868b20f0f2f6c0.instance = new $640c71683f3098a3$export$3a868b20f0f2f6c0();
        return $640c71683f3098a3$export$3a868b20f0f2f6c0.instance;
    }
    /**
     * Registers the class as serializable.
     */ static register(cls) {
        $640c71683f3098a3$export$3a868b20f0f2f6c0.getMap().classNameMap[cls.className] = [
            cls,
            cls.fromConfig
        ];
    }
}
function $640c71683f3098a3$export$a3f7d716dc76cb2e(cls) {
    (0, $4tCOB.assert)(cls.className != null, ()=>`Class being registered does not have the static className ` + `property defined.`);
    (0, $4tCOB.assert)(typeof cls.className === 'string', ()=>`className is required to be a string, but got type ` + typeof cls.className);
    (0, $4tCOB.assert)(cls.className.length > 0, ()=>`Class being registered has an empty-string as its className, ` + `which is disallowed.`);
    $640c71683f3098a3$export$3a868b20f0f2f6c0.register(cls);
}

});

parcelRegister("jgvrL", function(module, exports) {

$parcel$export(module.exports, "TEST_EPSILON_FLOAT16", () => $e067e79fc6fc9d4b$export$a86b4427e7a62065);
$parcel$export(module.exports, "expectArraysClose", () => $e067e79fc6fc9d4b$export$33c766a1062be5b2);
$parcel$export(module.exports, "testEpsilon", () => $e067e79fc6fc9d4b$export$e73bb4a504595b05);
$parcel$export(module.exports, "expectPromiseToFail", () => $e067e79fc6fc9d4b$export$f1ce55133f3520c4);
$parcel$export(module.exports, "expectArraysEqual", () => $e067e79fc6fc9d4b$export$347f1ed9dcafca0d);
$parcel$export(module.exports, "expectNumbersClose", () => $e067e79fc6fc9d4b$export$a09d1668dd6f88b6);
$parcel$export(module.exports, "expectValuesInRange", () => $e067e79fc6fc9d4b$export$1af4797b1eac800b);
$parcel$export(module.exports, "expectArrayBuffersEqual", () => $e067e79fc6fc9d4b$export$28801b43871bdbc0);
$parcel$export(module.exports, "encodeStrings", () => $e067e79fc6fc9d4b$export$a3027a992fa03b9e);
$parcel$export(module.exports, "createVideoElement", () => $e067e79fc6fc9d4b$export$f4f3d816544d7e44);
$parcel$export(module.exports, "play", () => $e067e79fc6fc9d4b$export$899fbdb5fa08b653);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");
var $wx9lK = parcelRequire("wx9lK");
const $e067e79fc6fc9d4b$var$TEST_EPSILON_FLOAT32 = 1e-3;
const $e067e79fc6fc9d4b$export$a86b4427e7a62065 = 1e-1;
function $e067e79fc6fc9d4b$export$33c766a1062be5b2(actual, expected, epsilon) {
    if (epsilon == null) epsilon = $e067e79fc6fc9d4b$export$e73bb4a504595b05();
    return $e067e79fc6fc9d4b$var$expectArraysPredicate(actual, expected, (a, b)=>$e067e79fc6fc9d4b$var$areClose(a, b, epsilon));
}
function $e067e79fc6fc9d4b$export$e73bb4a504595b05() {
    return (0, $aHfUM.ENGINE).backend.floatPrecision() === 32 ? $e067e79fc6fc9d4b$var$TEST_EPSILON_FLOAT32 : $e067e79fc6fc9d4b$export$a86b4427e7a62065;
}
function $e067e79fc6fc9d4b$var$expectArraysPredicate(actual, expected, predicate) {
    let checkClassType = true;
    if ((0, $4tCOB.isTypedArray)(actual) || (0, $4tCOB.isTypedArray)(expected)) checkClassType = false;
    if ((0, $4tCOB.isTypedArray)(actual) && (0, $4tCOB.isTypedArray)(expected)) checkClassType = true;
    if (checkClassType) {
        const aType = actual.constructor.name;
        const bType = expected.constructor.name;
        if (aType !== bType) throw new Error(`Arrays are of different type. Actual: ${aType}. ` + `Expected: ${bType}`);
    }
    if (Array.isArray(actual) && Array.isArray(expected)) {
        const actualShape = (0, $5R1UY.inferShape)(actual);
        const expectedShape = (0, $5R1UY.inferShape)(expected);
        if (!(0, $4tCOB.arraysEqual)(actualShape, expectedShape)) throw new Error(`Arrays have different shapes. ` + `Actual: [${actualShape}]. Expected: [${expectedShape}]`);
    }
    const actualFlat = (0, $4tCOB.isTypedArray)(actual) ? actual : (0, $4tCOB.flatten)(actual);
    const expectedFlat = (0, $4tCOB.isTypedArray)(expected) ? expected : (0, $4tCOB.flatten)(expected);
    if (actualFlat.length !== expectedFlat.length) throw new Error(`Arrays have different lengths actual: ${actualFlat.length} vs ` + `expected: ${expectedFlat.length}.\n` + `Actual:   ${actualFlat}.\n` + `Expected: ${expectedFlat}.`);
    for(let i = 0; i < expectedFlat.length; ++i){
        const a = actualFlat[i];
        const e = expectedFlat[i];
        if (!predicate(a, e)) throw new Error(`Arrays differ: actual[${i}] = ${a}, expected[${i}] = ${e}.\n` + `Actual:   ${actualFlat}.\n` + `Expected: ${expectedFlat}.`);
    }
    if (typeof expect !== 'undefined') expect().nothing();
}
function $e067e79fc6fc9d4b$export$f1ce55133f3520c4(fn, done) {
    fn().then(()=>done.fail(), ()=>done());
    if (typeof expect !== 'undefined') expect().nothing();
}
function $e067e79fc6fc9d4b$export$347f1ed9dcafca0d(actual, expected) {
    const exp = typeof expected === 'string' || typeof expected === 'number' || typeof expected === 'boolean' ? [
        expected
    ] : expected;
    if ((0, $4tCOB.isString)(actual) || (0, $4tCOB.isString)(actual[0]) || (0, $4tCOB.isString)(expected) || (0, $4tCOB.isString)(expected[0])) // tslint:disable-next-line: triple-equals
    return $e067e79fc6fc9d4b$var$expectArraysPredicate(actual, exp, (a, b)=>a == b);
    return $e067e79fc6fc9d4b$var$expectArraysPredicate(actual, expected, (a, b)=>$e067e79fc6fc9d4b$var$areClose(a, b, 0));
}
function $e067e79fc6fc9d4b$export$a09d1668dd6f88b6(a, e, epsilon) {
    if (epsilon == null) epsilon = $e067e79fc6fc9d4b$export$e73bb4a504595b05();
    if (!$e067e79fc6fc9d4b$var$areClose(a, e, epsilon)) throw new Error(`Numbers differ: actual === ${a}, expected === ${e}`);
    if (typeof expect !== 'undefined') expect().nothing();
}
function $e067e79fc6fc9d4b$var$areClose(a, e, epsilon) {
    if (!isFinite(a) && !isFinite(e)) return true;
    if (isNaN(a) || isNaN(e) || Math.abs(a - e) > epsilon) return false;
    return true;
}
function $e067e79fc6fc9d4b$export$1af4797b1eac800b(actual, low, high) {
    for(let i = 0; i < actual.length; i++){
        if (actual[i] < low || actual[i] > high) throw new Error(`Value out of range:${actual[i]} low: ${low}, high: ${high}`);
    }
}
function $e067e79fc6fc9d4b$export$28801b43871bdbc0(actual, expected) {
    // Safari does not like comparing ArrayBuffers directly. Wrapping in
    // a Float32Array solves this issue.
    const actualArray = new Float32Array(actual);
    const expectedArray = new Float32Array(expected);
    if (actualArray.length !== expectedArray.length) throw new Error('Expected ArrayBuffer to be of length ' + `${expectedArray.length}, but it was ${actualArray.length}`);
    for(let i = 0; i < expectedArray.length; i++){
        if (actualArray[i] !== expectedArray[i]) throw new Error(`Expected ArrayBuffer value at ${i} to be ` + `${expectedArray[i]} but got ${actualArray[i]} instead`);
    }
}
function $e067e79fc6fc9d4b$export$a3027a992fa03b9e(a) {
    for(let i = 0; i < a.length; i++){
        const val = a[i];
        if (Array.isArray(val)) $e067e79fc6fc9d4b$export$a3027a992fa03b9e(val);
        else a[i] = (0, $wx9lK.encodeString)(val);
    }
    return a;
}
function $e067e79fc6fc9d4b$export$f4f3d816544d7e44(source) {
    const video = document.createElement('video');
    if ('playsInline' in video) // tslint:disable-next-line:no-any
    video.playsInline = true;
    video.muted = true;
    video.loop = true;
    video.style.position = 'fixed';
    video.style.left = '0px';
    video.style.top = '0px';
    video.preload = 'auto';
    video.appendChild(source);
    return new Promise((resolve)=>{
        video.addEventListener('loadeddata', (_)=>resolve(video));
        video.load();
    });
}
async function $e067e79fc6fc9d4b$export$899fbdb5fa08b653(video) {
    await video.play();
    if ('requestVideoFrameCallback' in video) await new Promise((resolve)=>{
        // tslint:disable-next-line:no-any
        video.requestVideoFrameCallback(resolve);
    });
}

});

parcelRegister("dhAYb", function(module, exports) {

$parcel$export(module.exports, "version", () => $9ab98a4f3afc4dda$export$83d89fbfd8236492);
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $9ab98a4f3afc4dda$export$83d89fbfd8236492 = '3.21.0';

});

parcelRegister("aSzso", function(module, exports) {

$parcel$export(module.exports, "AdadeltaOptimizer", () => $7eba73840345b6fb$export$d80a766c536c9aaf);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $9c0Qr = parcelRequire("9c0Qr");

var $1ZrG5 = parcelRequire("1ZrG5");

var $gjFWY = parcelRequire("gjFWY");

var $r7fN6 = parcelRequire("r7fN6");

var $lGdn1 = parcelRequire("lGdn1");

var $gqriC = parcelRequire("gqriC");

var $k1Ozi = parcelRequire("k1Ozi");

var $8AyuI = parcelRequire("8AyuI");

var $4tSgq = parcelRequire("4tSgq");
class $7eba73840345b6fb$export$d80a766c536c9aaf extends (0, $4tSgq.Optimizer) {
    constructor(learningRate, rho, epsilon = null){
        super();
        this.learningRate = learningRate;
        this.rho = rho;
        this.epsilon = epsilon;
        this.accumulatedGrads = [];
        this.accumulatedUpdates = [];
        if (epsilon == null) this.epsilon = (0, $aHfUM.ENGINE).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $aHfUM.ENGINE).registeredVariables[name];
            const trainable = false;
            if (this.accumulatedGrads[i] == null) this.accumulatedGrads[i] = {
                originalName: `${name}/accum_grad`,
                variable: (0, $9c0Qr.tidy)(()=>(0, $k1Ozi.zerosLike)(value).variable(trainable))
            };
            if (this.accumulatedUpdates[i] == null) this.accumulatedUpdates[i] = {
                originalName: `${name}/accum_var`,
                variable: (0, $9c0Qr.tidy)(()=>(0, $k1Ozi.zerosLike)(value).variable(trainable))
            };
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedGrad = this.accumulatedGrads[i].variable;
            const accumulatedUpdate = this.accumulatedUpdates[i].variable;
            (0, $9c0Qr.tidy)(()=>{
                const newAccumulatedGrad = (0, $1ZrG5.add)((0, $r7fN6.mul)(accumulatedGrad, this.rho), (0, $r7fN6.mul)((0, $gqriC.square)(gradient), 1 - this.rho));
                const updates = (0, $r7fN6.mul)((0, $gjFWY.div)((0, $lGdn1.sqrt)((0, $1ZrG5.add)(accumulatedUpdate, this.epsilon)), (0, $lGdn1.sqrt)((0, $1ZrG5.add)(accumulatedGrad, this.epsilon))), gradient);
                const newAccumulatedUpdate = (0, $1ZrG5.add)((0, $r7fN6.mul)(accumulatedUpdate, this.rho), (0, $r7fN6.mul)((0, $gqriC.square)(updates), 1 - this.rho));
                accumulatedGrad.assign(newAccumulatedGrad);
                accumulatedUpdate.assign(newAccumulatedUpdate);
                const newValue = (0, $1ZrG5.add)((0, $r7fN6.mul)(updates, -this.learningRate), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedUpdates != null) {
            (0, $9c0Qr.dispose)(this.accumulatedGrads.map((v)=>v.variable));
            (0, $9c0Qr.dispose)(this.accumulatedUpdates.map((v)=>v.variable));
        }
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedGrads,
            ...this.accumulatedUpdates
        ];
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const variableCount = weightValues.length / 2;
        const trainable = false;
        this.accumulatedGrads = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedUpdates = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'rho': this.rho,
            'epsilon': this.epsilon
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['rho'], config['epsilon']);
    }
}
/** @nocollapse */ $7eba73840345b6fb$export$d80a766c536c9aaf.className = 'Adadelta'; // Name matters for Python compatibility.
(0, $8AyuI.registerClass)($7eba73840345b6fb$export$d80a766c536c9aaf);

});
parcelRegister("1ZrG5", function(module, exports) {

$parcel$export(module.exports, "add", () => $1730f52ef771e2ef$export$e16d8520af44a096);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Adds two `tf.Tensor`s element-wise, A + B. Supports broadcasting.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.tensor1d([10, 20, 30, 40]);
 *
 * a.add(b).print();  // or tf.add(a, b)
 * ```
 *
 * ```js
 * // Broadcast add a with b.
 * const a = tf.scalar(5);
 * const b = tf.tensor1d([10, 20, 30, 40]);
 *
 * a.add(b).print();  // or tf.add(a, b)
 * ```
 * @param a The first `tf.Tensor` to add.
 * @param b The second `tf.Tensor` to add. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $1730f52ef771e2ef$var$add_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'add');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'add');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Add), inputs);
}
const $1730f52ef771e2ef$export$e16d8520af44a096 = (0, $jKUCi.op)({
    add_: $1730f52ef771e2ef$var$add_
});

});

parcelRegister("gjFWY", function(module, exports) {

$parcel$export(module.exports, "div", () => $be0ef61a081ecc9f$export$159d9494db57879b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $6ktJw = parcelRequire("6ktJw");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.div(b).print();  // or tf.div(a, b)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 *
 * a.div(b).print();  // or tf.div(a, b)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $be0ef61a081ecc9f$var$div_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'div');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'div');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    if ($a.dtype === 'int32' && $b.dtype === 'int32') return (0, $6ktJw.floorDiv)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {};
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.RealDiv), inputs, attrs);
}
const $be0ef61a081ecc9f$export$159d9494db57879b = (0, $jKUCi.op)({
    div_: $be0ef61a081ecc9f$var$div_
});

});
parcelRegister("6ktJw", function(module, exports) {

$parcel$export(module.exports, "floorDiv", () => $49bbacb78ce423b9$export$112397bc52715a8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting.
 * The result is rounded with floor function.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.floorDiv(b).print();  // or tf.div(a, b)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 *
 * a.floorDiv(b).print();  // or tf.floorDiv(a, b)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $49bbacb78ce423b9$var$floorDiv_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'floorDiv');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'floorDiv');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.FloorDiv), inputs);
}
const $49bbacb78ce423b9$export$112397bc52715a8 = (0, $jKUCi.op)({
    floorDiv_: $49bbacb78ce423b9$var$floorDiv_
});

});


parcelRegister("r7fN6", function(module, exports) {

$parcel$export(module.exports, "mul", () => $05182629f8333289$export$6e3a27864ab166fe);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Multiplies two `tf.Tensor`s element-wise, A * B. Supports broadcasting.
 *
 * We also expose `tf.mulStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.tensor1d([2, 3, 4, 5]);
 *
 * a.mul(b).print();  // or tf.mul(a, b)
 * ```
 *
 * ```js
 * // Broadcast mul a with b.
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.scalar(5);
 *
 * a.mul(b).print();  // or tf.mul(a, b)
 * ```
 * @param a The first tensor to multiply.
 * @param b The second tensor to multiply. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $05182629f8333289$var$mul_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'mul');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'mul');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Multiply), inputs);
}
const $05182629f8333289$export$6e3a27864ab166fe = (0, $jKUCi.op)({
    mul_: $05182629f8333289$var$mul_
});

});

parcelRegister("lGdn1", function(module, exports) {

$parcel$export(module.exports, "sqrt", () => $fc87e44676150e7a$export$eba8049fb5020b81);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes square root of the input `tf.Tensor` element-wise: `y = sqrt(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 4, -1]);
 *
 * x.sqrt().print();  // or tf.sqrt(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $fc87e44676150e7a$var$sqrt_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'sqrt', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Sqrt), inputs);
}
const $fc87e44676150e7a$export$eba8049fb5020b81 = (0, $jKUCi.op)({
    sqrt_: $fc87e44676150e7a$var$sqrt_
});

});

parcelRegister("gqriC", function(module, exports) {

$parcel$export(module.exports, "square", () => $bf54401e2b427fa5$export$dd4f28cef696bc7d);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes square of `x` element-wise: `x ^ 2`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.sqrt(2), -1]);
 *
 * x.square().print();  // or tf.square(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $bf54401e2b427fa5$var$square_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'square');
    const attrs = {};
    return (0, $aHfUM.ENGINE).runKernel('Square', {
        x: $x
    }, attrs);
}
const $bf54401e2b427fa5$export$dd4f28cef696bc7d = (0, $jKUCi.op)({
    square_: $bf54401e2b427fa5$var$square_
});

});

parcelRegister("k1Ozi", function(module, exports) {

$parcel$export(module.exports, "zerosLike", () => $e94b206ebf0305d1$export$cb1f824e7733584d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Creates a `tf.Tensor` with all elements set to 0 with the same shape as the
 * given tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 * tf.zerosLike(x).print();
 * ```
 *
 * @param x The tensor of required shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $e94b206ebf0305d1$var$zerosLike_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'zerosLike');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.ZerosLike), inputs);
}
const $e94b206ebf0305d1$export$cb1f824e7733584d = (0, $jKUCi.op)({
    zerosLike_: $e94b206ebf0305d1$var$zerosLike_
});

});

parcelRegister("4tSgq", function(module, exports) {

$parcel$export(module.exports, "Optimizer", () => $3433f68d4db4b365$export$69ae9293516e70f0);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9c0Qr = parcelRequire("9c0Qr");

var $jFQG4 = parcelRequire("jFQG4");

var $j7yUF = parcelRequire("j7yUF");

var $8AyuI = parcelRequire("8AyuI");
class $3433f68d4db4b365$export$69ae9293516e70f0 extends (0, $8AyuI.Serializable) {
    /**
     * Executes `f()` and minimizes the scalar output of `f()` by computing
     * gradients of y with respect to the list of trainable variables provided by
     * `varList`. If no list is provided, it defaults to all trainable variables.
     *
     * @param f The function to execute and whose output to minimize.
     * @param returnCost Whether to return the scalar cost value produced by
     * executing `f()`.
     * @param varList An optional list of variables to update. If specified, only
     * the trainable variables in varList will be updated by minimize. Defaults to
     * all trainable variables.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers'}
     */ minimize(f, returnCost = false, varList) {
        const { value: value, grads: grads } = this.computeGradients(f, varList);
        if (varList != null) {
            const gradArray = varList.map((v)=>({
                    name: v.name,
                    tensor: grads[v.name]
                }));
            this.applyGradients(gradArray);
        } else this.applyGradients(grads);
        // Dispose gradients.
        (0, $9c0Qr.dispose)(grads);
        if (returnCost) return value;
        else {
            value.dispose();
            return null;
        }
    }
    /**
     * The number of iterations that this optimizer instance has been invoked for.
     */ get iterations() {
        if (this.iterations_ == null) this.iterations_ = 0;
        return this.iterations_;
    }
    incrementIterations() {
        this.iterations_ = this.iterations + 1;
    }
    /**
     * Executes f() and computes the gradient of the scalar output of f() with
     * respect to the list of trainable variables provided by `varList`. If no
     * list is provided, it defaults to all trainable variables.
     *
     * @param f The function to execute and whose output to use for computing
     * gradients with respect to variables.
     * @param varList An optional list of variables to compute gradients with
     * respect to. If specified, only the trainable variables in varList will have
     * gradients computed with respect to. Defaults to all trainable variables.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers'}
     */ computeGradients(f, varList) {
        return (0, $jFQG4.variableGrads)(f, varList);
    }
    /**
     * Dispose the variables (if any) owned by this optimizer instance.
     */ dispose() {
        if (this.iterations_ != null) (0, $9c0Qr.dispose)(this.iterations_);
    }
    async saveIterations() {
        if (this.iterations_ == null) this.iterations_ = 0;
        return {
            name: 'iter',
            // TODO(cais): Use 'int64' type when available.
            tensor: (0, $j7yUF.scalar)(this.iterations_, 'int32')
        };
    }
    async getWeights() {
        throw new Error('getWeights() is not implemented for this optimizer yet.');
    }
    async setWeights(weightValues) {
        throw new Error(`setWeights() is not implemented for this optimizer class ` + `${this.getClassName()}`);
    }
    /**
     * Extract the first element of the weight values and set it
     * as the iterations counter variable of this instance of optimizer.
     *
     * @param weightValues
     * @returns Weight values with the first element consumed and excluded.
     */ async extractIterations(weightValues) {
        this.iterations_ = (await weightValues[0].tensor.data())[0];
        return weightValues.slice(1);
    }
}
Object.defineProperty($3433f68d4db4b365$export$69ae9293516e70f0, Symbol.hasInstance, {
    value: (instance)=>{
        return instance.minimize != null && instance.computeGradients != null && instance.applyGradients != null;
    }
});

});
parcelRegister("jFQG4", function(module, exports) {

$parcel$export(module.exports, "grad", () => $e52ab55196da3937$export$c24429b22bb73814);
$parcel$export(module.exports, "grads", () => $e52ab55196da3937$export$3f3749f5340c73f2);
$parcel$export(module.exports, "valueAndGrad", () => $e52ab55196da3937$export$9fbe39d4dcb3921e);
$parcel$export(module.exports, "valueAndGrads", () => $e52ab55196da3937$export$c03281a254ef3cf0);
$parcel$export(module.exports, "variableGrads", () => $e52ab55196da3937$export$c756d9ed08b9677f);
$parcel$export(module.exports, "customGrad", () => $e52ab55196da3937$export$5519f0eeb00c44e5);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $bVnU9 = parcelRequire("bVnU9");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");
/**
 * Provided `f(x)`, returns another function `g(x, dy?)`, which gives the
 * gradient of `f(x)` with respect to `x`.
 *
 * If `dy` is provided, the gradient of `f(x).mul(dy).sum()` with respect to
 * `x` is computed instead. `f(x)` must take a single tensor `x` and return a
 * single tensor `y`. If `f()` takes multiple inputs, use `tf.grads` instead.
 *
 * ```js
 * // f(x) = x ^ 2
 * const f = x => x.square();
 * // f'(x) = 2x
 * const g = tf.grad(f);
 *
 * const x = tf.tensor1d([2, 3]);
 * g(x).print();
 * ```
 *
 * ```js
 * // f(x) = x ^ 3
 * const f = x => x.pow(tf.scalar(3, 'int32'));
 * // f'(x) = 3x ^ 2
 * const g = tf.grad(f);
 * // f''(x) = 6x
 * const gg = tf.grad(g);
 *
 * const x = tf.tensor1d([2, 3]);
 * gg(x).print();
 * ```
 *
 * @param f The function f(x), to compute gradient for.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $e52ab55196da3937$export$c24429b22bb73814(f) {
    $4tCOB.assert($4tCOB.isFunction(f), ()=>'The f passed in grad(f) must be a function');
    return (x, dy)=>{
        // x can be of any dtype, thus null as the last argument.
        const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'tf.grad', 'string_or_numeric');
        const $dy = dy != null ? (0, $5R1UY.convertToTensor)(dy, 'dy', 'tf.grad') : null;
        return (0, $aHfUM.ENGINE).tidy(()=>{
            const { value: value, grads: grads } = (0, $aHfUM.ENGINE).gradients(()=>f($x), [
                $x
            ], $dy);
            if ($dy != null) $4tCOB.assertShapesMatch(value.shape, $dy.shape, "The shape of dy passed in grad(f)(x, dy) must match the shape returned by f(x)");
            $e52ab55196da3937$var$checkGrads(grads);
            return grads[0];
        });
    };
}
/**
 * Provided `f(x1, x2,...)`, returns another function `g([x1, x2,...], dy?)`,
 * which gives an array of gradients of `f()` with respect to each input
 * [`x1`,`x2`,...].
 *
 * If `dy` is passed when calling `g()`, the gradient of
 * `f(x1,...).mul(dy).sum()` with respect to each input is computed instead.
 * The provided `f` must take one or more tensors and return a single tensor
 * `y`. If `f()` takes a single input, we recommend using `tf.grad` instead.
 *
 * ```js
 * // f(a, b) = a * b
 * const f = (a, b) => a.mul(b);
 * // df / da = b, df / db = a
 * const g = tf.grads(f);
 *
 * const a = tf.tensor1d([2, 3]);
 * const b = tf.tensor1d([-2, -3]);
 * const [da, db] = g([a, b]);
 * console.log('da');
 * da.print();
 * console.log('db');
 * db.print();
 * ```
 *
 * @param f The function `f(x1, x2,...)` to compute gradients for.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $e52ab55196da3937$export$3f3749f5340c73f2(f) {
    $4tCOB.assert($4tCOB.isFunction(f), ()=>'The f passed in grads(f) must be a function');
    return (args, dy)=>{
        $4tCOB.assert(Array.isArray(args), ()=>"The args passed in grads(f)(args) must be an array of `Tensor`s or `TensorLike`s");
        // args can be of any dtype, thus null as the last argument.
        const $args = (0, $5R1UY.convertToTensorArray)(args, 'args', 'tf.grads', 'string_or_numeric');
        const $dy = dy != null ? (0, $5R1UY.convertToTensor)(dy, 'dy', 'tf.grads') : null;
        return (0, $aHfUM.ENGINE).tidy(()=>{
            const { value: value, grads: grads } = (0, $aHfUM.ENGINE).gradients(()=>f(...$args), $args, $dy);
            if ($dy != null) $4tCOB.assertShapesMatch(value.shape, $dy.shape, "The shape of dy passed in grads(f)([x1,...], dy) must match the shape returned by f([x1,...])");
            $e52ab55196da3937$var$checkGrads(grads);
            return grads;
        });
    };
}
/**
 * Like `tf.grad`, but also returns the value of `f()`. Useful when `f()`
 * returns a metric you want to show.
 *
 * The result is a rich object with the following properties:
 * - grad: The gradient of `f(x)` w.r.t. `x` (result of `tf.grad`).
 * - value: The value returned by `f(x)`.
 *
 * ```js
 * // f(x) = x ^ 2
 * const f = x => x.square();
 * // f'(x) = 2x
 * const g = tf.valueAndGrad(f);
 *
 * const x = tf.tensor1d([2, 3]);
 * const {value, grad} = g(x);
 *
 * console.log('value');
 * value.print();
 * console.log('grad');
 * grad.print();
 * ```
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $e52ab55196da3937$export$9fbe39d4dcb3921e(f) {
    $4tCOB.assert($4tCOB.isFunction(f), ()=>'The f passed in valueAndGrad(f) must be a function');
    return (x, dy)=>{
        $4tCOB.assert(x instanceof (0, $bVnU9.Tensor), ()=>'The x passed in valueAndGrad(f)(x) must be a tensor');
        $4tCOB.assert(dy == null || dy instanceof (0, $bVnU9.Tensor), ()=>'The dy passed in valueAndGrad(f)(x, dy) must be a tensor');
        const { grads: grads, value: value } = (0, $aHfUM.ENGINE).gradients(()=>f(x), [
            x
        ], dy);
        $e52ab55196da3937$var$checkGrads(grads);
        return {
            grad: grads[0],
            value: value
        };
    };
}
/**
 * Like `tf.grads`, but returns also the value of `f()`. Useful when `f()`
 * returns a metric you want to show.
 *
 * The result is a rich object with the following properties:
 * - grads: The gradients of `f()` w.r.t. each input (result of `tf.grads`).
 * - value: The value returned by `f(x)`.
 *
 * ```js
 * // f(a, b) = a * b
 * const f = (a, b) => a.mul(b);
 * // df/da = b, df/db = a
 * const g = tf.valueAndGrads(f);
 *
 * const a = tf.tensor1d([2, 3]);
 * const b = tf.tensor1d([-2, -3]);
 * const {value, grads} = g([a, b]);
 *
 * const [da, db] = grads;
 *
 * console.log('value');
 * value.print();
 *
 * console.log('da');
 * da.print();
 * console.log('db');
 * db.print();
 * ```
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $e52ab55196da3937$export$c03281a254ef3cf0(f) {
    $4tCOB.assert($4tCOB.isFunction(f), ()=>'The f passed in valueAndGrads(f) must be a function');
    return (args, dy)=>{
        $4tCOB.assert(Array.isArray(args) && args.every((arg)=>arg instanceof (0, $bVnU9.Tensor)), ()=>"The args passed in valueAndGrads(f)(args) must be array of tensors");
        $4tCOB.assert(dy == null || dy instanceof (0, $bVnU9.Tensor), ()=>'The dy passed in valueAndGrads(f)(args, dy) must be a tensor');
        const res = (0, $aHfUM.ENGINE).gradients(()=>f(...args), args, dy);
        if (dy != null) $4tCOB.assertShapesMatch(res.value.shape, dy.shape, "The shape of dy passed in valueAndGrads(f)([x1,...], dy) must match the shape returned by f([x1,...])");
        $e52ab55196da3937$var$checkGrads(res.grads);
        return res;
    };
}
/**
 * Computes and returns the gradient of f(x) with respect to the list of
 * trainable variables provided by `varList`. If no list is provided, it
 * defaults to all trainable variables.
 *
 * ```js
 * const a = tf.variable(tf.tensor1d([3, 4]));
 * const b = tf.variable(tf.tensor1d([5, 6]));
 * const x = tf.tensor1d([1, 2]);
 *
 * // f(a, b) = a * x ^ 2 + b * x
 * const f = () => a.mul(x.square()).add(b.mul(x)).sum();
 * // df/da = x ^ 2, df/db = x
 * const {value, grads} = tf.variableGrads(f);
 *
 * Object.keys(grads).forEach(varName => grads[varName].print());
 * ```
 *
 * @param f The function to execute. f() should return a scalar.
 * @param varList The list of variables to compute the gradients with respect
 *     to. Defaults to all trainable variables.
 * @returns An object with the following keys and values:
 *   - `value`: The value of the function `f`.
 *   - `grads`: A map from the names of the variables to the gradients.
 *     If the `varList` argument is provided explicitly and contains a subset of
 *     non-trainable variables, this map in the return value will contain keys
 *     that map the names of the non-trainable variables to `null`.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $e52ab55196da3937$export$c756d9ed08b9677f(f, varList) {
    $4tCOB.assert($4tCOB.isFunction(f), ()=>'The f passed in variableGrads(f) must be a function');
    $4tCOB.assert(varList == null || Array.isArray(varList) && varList.every((v)=>v instanceof (0, $bVnU9.Variable)), ()=>"The varList passed in variableGrads(f, varList) must be an array of variables");
    const specifiedVarList = varList != null;
    if (!specifiedVarList) {
        // Get all of the trainable variables.
        varList = [];
        for(const varName in (0, $aHfUM.ENGINE).registeredVariables)varList.push((0, $aHfUM.ENGINE).registeredVariables[varName]);
    }
    const specifiedNonTrainable = specifiedVarList ? varList.filter((variable)=>!variable.trainable) : null;
    // Prune non-trainable variables.
    const originalVarCount = varList.length;
    varList = varList.filter((variable)=>variable.trainable);
    $4tCOB.assert(varList.length > 0, ()=>`variableGrads() expects at least one of the input variables to ` + `be trainable, but none of the ${originalVarCount} variables is ` + `trainable.`);
    const allowNoGradients = true;
    const { value: value, grads: grads } = (0, $aHfUM.ENGINE).gradients(f, varList, null, allowNoGradients);
    $4tCOB.assert(grads.some((g)=>g != null), ()=>"Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize().");
    $4tCOB.assert(value.rank === 0, ()=>`The f passed in variableGrads(f) must return a scalar, but it ` + `returned a rank-${value.rank} tensor`);
    const namedGrads = {};
    varList.forEach((v, i)=>{
        if (grads[i] != null) namedGrads[v.name] = grads[i];
    });
    if (specifiedNonTrainable != null) // If varList is explicitly provided and contains non-trainable values,
    // add them to the returned gradients with `null` values.
    specifiedNonTrainable.forEach((v)=>namedGrads[v.name] = null);
    return {
        value: value,
        grads: namedGrads
    };
}
/**
 * Overrides the gradient computation of a function `f`.
 *
 * Takes a function
 * `f(...inputs, save) => {value: Tensor, gradFunc: (dy, saved) => Tensor[]}`
 * and returns another function `g(...inputs)` which takes the same inputs as
 * `f`. When called, `g` returns `f().value`. In backward mode, custom gradients
 * with respect to each input of `f` are computed using `f().gradFunc`.
 *
 * The `save` function passed to `f` should be used for saving tensors needed
 * in the gradient. And the `saved` passed to the `gradFunc` is a
 * `NamedTensorMap`, which contains those saved tensors.
 *
 * ```js
 * const customOp = tf.customGrad((x, save) => {
 *   // Save x to make sure it's available later for the gradient.
 *   save([x]);
 *   // Override gradient of our custom x ^ 2 op to be dy * abs(x);
 *   return {
 *     value: x.square(),
 *     // Note `saved.x` which points to the `x` we saved earlier.
 *     gradFunc: (dy, saved) => [dy.mul(saved[0].abs())]
 *   };
 * });
 *
 * const x = tf.tensor1d([-1, -2, 3]);
 * const dx = tf.grad(x => customOp(x));
 *
 * console.log(`f(x):`);
 * customOp(x).print();
 * console.log(`f'(x):`);
 * dx(x).print();
 * ```
 *
 * @param f The function to evaluate in forward mode, which should return
 *     `{value: Tensor, gradFunc: (dy, saved) => Tensor[]}`, where `gradFunc`
 *     returns the custom gradients of `f` with respect to its inputs.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $e52ab55196da3937$export$5519f0eeb00c44e5(f) {
    return (0, $aHfUM.ENGINE).customGrad(f);
}
function $e52ab55196da3937$var$checkGrads(grads) {
    const numNullGradients = grads.filter((g)=>g == null).length;
    if (numNullGradients > 0) throw new Error(`Cannot compute gradient of y=f(x) with respect to x. Make sure that
    the f you passed encloses all operations that lead from x to y.`);
}

});

parcelRegister("j7yUF", function(module, exports) {

$parcel$export(module.exports, "scalar", () => $deb9c0bc55508481$export$7de3fcd3cdba2a46);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");

var $lVIqi = parcelRequire("lVIqi");
function $deb9c0bc55508481$export$7de3fcd3cdba2a46(value, dtype) {
    if (((0, $4tCOB.isTypedArray)(value) && dtype !== 'string' || Array.isArray(value)) && dtype !== 'complex64') throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean|string)");
    if (dtype === 'string' && (0, $4tCOB.isTypedArray)(value) && !(value instanceof Uint8Array)) throw new Error("When making a scalar from encoded string, the value must be `Uint8Array`.");
    const shape = [];
    const inferredShape = [];
    return (0, $lVIqi.makeTensor)(value, shape, inferredShape, dtype);
}

});



parcelRegister("am0NB", function(module, exports) {

$parcel$export(module.exports, "AdagradOptimizer", () => $789c9422a963ad22$export$fa35e48f6f1caa57);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $9c0Qr = parcelRequire("9c0Qr");

var $1ZrG5 = parcelRequire("1ZrG5");

var $gjFWY = parcelRequire("gjFWY");

var $3kNX7 = parcelRequire("3kNX7");

var $r7fN6 = parcelRequire("r7fN6");

var $lGdn1 = parcelRequire("lGdn1");

var $gqriC = parcelRequire("gqriC");

var $8AyuI = parcelRequire("8AyuI");

var $4tSgq = parcelRequire("4tSgq");
class $789c9422a963ad22$export$fa35e48f6f1caa57 extends (0, $4tSgq.Optimizer) {
    constructor(learningRate, initialAccumulatorValue = 0.1){
        super();
        this.learningRate = learningRate;
        this.initialAccumulatorValue = initialAccumulatorValue;
        this.accumulatedGrads = [];
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $aHfUM.ENGINE).registeredVariables[name];
            if (this.accumulatedGrads[i] == null) {
                const trainable = false;
                this.accumulatedGrads[i] = {
                    originalName: `${name}/accumulator`,
                    variable: (0, $9c0Qr.tidy)(()=>(0, $3kNX7.fill)(value.shape, this.initialAccumulatorValue).variable(trainable))
                };
            }
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedGrad = this.accumulatedGrads[i].variable;
            (0, $9c0Qr.tidy)(()=>{
                const newAccumulatedGrad = (0, $1ZrG5.add)(accumulatedGrad, (0, $gqriC.square)(gradient));
                accumulatedGrad.assign(newAccumulatedGrad);
                const newValue = (0, $1ZrG5.add)((0, $r7fN6.mul)((0, $gjFWY.div)(gradient, (0, $lGdn1.sqrt)((0, $1ZrG5.add)(newAccumulatedGrad, (0, $aHfUM.ENGINE).backend.epsilon()))), -this.learningRate), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedGrads != null) (0, $9c0Qr.dispose)(this.accumulatedGrads.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        return [
            await this.saveIterations()
        ].concat(this.accumulatedGrads.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const trainable = false;
        this.accumulatedGrads = weightValues.map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'initialAccumulatorValue': this.initialAccumulatorValue
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['initialAccumulatorValue']);
    }
}
/** @nocollapse */ $789c9422a963ad22$export$fa35e48f6f1caa57.className = 'Adagrad'; // Note: Name matters for Python compatibility.
(0, $8AyuI.registerClass)($789c9422a963ad22$export$fa35e48f6f1caa57);

});
parcelRegister("3kNX7", function(module, exports) {

$parcel$export(module.exports, "fill", () => $26d9fcdfc784cc4a$export$9563e054e6f787fb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");
/**
 * Creates a `tf.Tensor` filled with a scalar value.
 *
 * ```js
 * tf.fill([2, 2], 4).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param value The scalar value to fill the tensor with.
 * @param dtype The type of an element in the resulting tensor. Defaults to
 * 'float'.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $26d9fcdfc784cc4a$export$9563e054e6f787fb(shape, value, dtype) {
    const attrs = {
        shape: shape,
        value: value,
        dtype: dtype
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Fill), {}, attrs);
}

});


parcelRegister("dXwyG", function(module, exports) {

$parcel$export(module.exports, "AdamOptimizer", () => $a29a0a7baa92cfb3$export$de1938eb5fee8ee2);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $9c0Qr = parcelRequire("9c0Qr");

var $1ZrG5 = parcelRequire("1ZrG5");

var $gjFWY = parcelRequire("gjFWY");

var $r7fN6 = parcelRequire("r7fN6");

var $5MZxP = parcelRequire("5MZxP");

var $j7yUF = parcelRequire("j7yUF");

var $lGdn1 = parcelRequire("lGdn1");

var $gqriC = parcelRequire("gqriC");

var $hkR0n = parcelRequire("hkR0n");

var $k1Ozi = parcelRequire("k1Ozi");

var $8AyuI = parcelRequire("8AyuI");

var $4tSgq = parcelRequire("4tSgq");
class $a29a0a7baa92cfb3$export$de1938eb5fee8ee2 extends (0, $4tSgq.Optimizer) {
    constructor(learningRate, beta1, beta2, epsilon = null){
        super();
        this.learningRate = learningRate;
        this.beta1 = beta1;
        this.beta2 = beta2;
        this.epsilon = epsilon;
        this.accumulatedFirstMoment = [];
        this.accumulatedSecondMoment = [];
        (0, $9c0Qr.tidy)(()=>{
            // accB* will be updated by batch.
            this.accBeta1 = (0, $j7yUF.scalar)(beta1).variable();
            this.accBeta2 = (0, $j7yUF.scalar)(beta2).variable();
        });
        if (epsilon == null) this.epsilon = (0, $aHfUM.ENGINE).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const varNames = Array.isArray(variableGradients) ? variableGradients.map((v)=>v.name) : Object.keys(variableGradients);
        (0, $9c0Qr.tidy)(()=>{
            const oneMinusAccBeta1 = (0, $hkR0n.sub)(1, this.accBeta1);
            const oneMinusAccBeta2 = (0, $hkR0n.sub)(1, this.accBeta2);
            varNames.forEach((name, i)=>{
                const value = (0, $aHfUM.ENGINE).registeredVariables[name];
                const trainable = false;
                if (this.accumulatedFirstMoment[i] == null) this.accumulatedFirstMoment[i] = {
                    originalName: `${name}/m`,
                    variable: (0, $9c0Qr.tidy)(()=>(0, $k1Ozi.zerosLike)(value).variable(trainable))
                };
                if (this.accumulatedSecondMoment[i] == null) this.accumulatedSecondMoment[i] = {
                    originalName: `${name}/v`,
                    variable: (0, $9c0Qr.tidy)(()=>(0, $k1Ozi.zerosLike)(value).variable(trainable))
                };
                const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
                if (gradient == null) return;
                const firstMoment = this.accumulatedFirstMoment[i].variable;
                const secondMoment = this.accumulatedSecondMoment[i].variable;
                const newFirstMoment = (0, $1ZrG5.add)((0, $r7fN6.mul)(firstMoment, this.beta1), (0, $r7fN6.mul)(gradient, 1 - this.beta1));
                const newSecondMoment = (0, $1ZrG5.add)((0, $r7fN6.mul)(secondMoment, this.beta2), (0, $r7fN6.mul)((0, $gqriC.square)(gradient), 1 - this.beta2));
                const biasCorrectedFirstMoment = (0, $gjFWY.div)(newFirstMoment, oneMinusAccBeta1);
                const biasCorrectedSecondMoment = (0, $gjFWY.div)(newSecondMoment, oneMinusAccBeta2);
                firstMoment.assign(newFirstMoment);
                secondMoment.assign(newSecondMoment);
                const newValue = (0, $1ZrG5.add)((0, $r7fN6.mul)((0, $gjFWY.div)(biasCorrectedFirstMoment, (0, $1ZrG5.add)((0, $lGdn1.sqrt)(biasCorrectedSecondMoment), this.epsilon)), -this.learningRate), value);
                value.assign(newValue);
            });
            this.accBeta1.assign((0, $r7fN6.mul)(this.accBeta1, this.beta1));
            this.accBeta2.assign((0, $r7fN6.mul)(this.accBeta2, this.beta2));
        });
        this.incrementIterations();
    }
    dispose() {
        this.accBeta1.dispose();
        this.accBeta2.dispose();
        if (this.accumulatedFirstMoment != null) (0, $9c0Qr.dispose)(this.accumulatedFirstMoment.map((v)=>v.variable));
        if (this.accumulatedSecondMoment != null) (0, $9c0Qr.dispose)(this.accumulatedSecondMoment.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedFirstMoment,
            ...this.accumulatedSecondMoment
        ];
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        (0, $9c0Qr.tidy)(()=>{
            this.accBeta1.assign((0, $5MZxP.pow)(this.beta1, this.iterations_ + 1));
            this.accBeta2.assign((0, $5MZxP.pow)(this.beta2, this.iterations_ + 1));
        });
        const variableCount = weightValues.length / 2;
        const trainable = false;
        this.accumulatedFirstMoment = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedSecondMoment = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'beta1': this.beta1,
            'beta2': this.beta2,
            'epsilon': this.epsilon
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon']);
    }
}
/** @nocollapse */ $a29a0a7baa92cfb3$export$de1938eb5fee8ee2.className = 'Adam'; // Note: Name matters for Python compatibility.
(0, $8AyuI.registerClass)($a29a0a7baa92cfb3$export$de1938eb5fee8ee2);

});
parcelRegister("5MZxP", function(module, exports) {

$parcel$export(module.exports, "pow", () => $43712ce7125216f2$export$9c297f60e22e3389);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the power of one `tf.Tensor` to another. Supports broadcasting.
 *
 * Given a `tf.Tensor` x and a `tf.Tensor` y, this operation computes x^y for
 * corresponding elements in x and y. The result's dtype will be the upcasted
 * type of the `base` and `exp` dtypes.
 *
 * ```js
 * const a = tf.tensor([[2, 3], [4, 5]])
 * const b = tf.tensor([[1, 2], [3, 0]]).toInt();
 *
 * a.pow(b).print();  // or tf.pow(a, b)
 * ```
 *
 * ```js
 * const a = tf.tensor([[1, 2], [3, 4]])
 * const b = tf.tensor(2).toInt();
 *
 * a.pow(b).print();  // or tf.pow(a, b)
 * ```
 * We also expose `powStrict` which has the same signature as this op and
 * asserts that `base` and `exp` are the same shape (does not broadcast).
 *
 * @param base The base `tf.Tensor` to pow element-wise.
 * @param exp The exponent `tf.Tensor` to pow element-wise.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $43712ce7125216f2$var$pow_(base, exp) {
    let $base = (0, $5R1UY.convertToTensor)(base, 'base', 'pow');
    let $exp = (0, $5R1UY.convertToTensor)(exp, 'exp', 'pow');
    [$base, $exp] = (0, $1vhox.makeTypesMatch)($base, $exp);
    const inputs = {
        a: $base,
        b: $exp
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Pow), inputs);
}
const $43712ce7125216f2$export$9c297f60e22e3389 = (0, $jKUCi.op)({
    pow_: $43712ce7125216f2$var$pow_
});

});

parcelRegister("hkR0n", function(module, exports) {

$parcel$export(module.exports, "sub", () => $c9ed6b9aa20f718b$export$f93b5905241a7cca);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Subtracts two `tf.Tensor`s element-wise, A - B. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([10, 20, 30, 40]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.sub(b).print();  // or tf.sub(a, b)
 * ```
 *
 * ```js
 * // Broadcast subtract a with b.
 * const a = tf.tensor1d([10, 20, 30, 40]);
 * const b = tf.scalar(5);
 *
 * a.sub(b).print();  // or tf.sub(a, b)
 * ```
 * @param a The first `tf.Tensor` to subtract from.
 * @param b The second `tf.Tensor` to be subtracted. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $c9ed6b9aa20f718b$var$sub_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'sub');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'sub');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Sub), inputs);
}
const $c9ed6b9aa20f718b$export$f93b5905241a7cca = (0, $jKUCi.op)({
    sub_: $c9ed6b9aa20f718b$var$sub_
});

});


parcelRegister("asOdC", function(module, exports) {

$parcel$export(module.exports, "AdamaxOptimizer", () => $79e3794a4b04b598$export$69957d0bff775eb6);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $9c0Qr = parcelRequire("9c0Qr");

var $6oc11 = parcelRequire("6oc11");

var $1ZrG5 = parcelRequire("1ZrG5");

var $gjFWY = parcelRequire("gjFWY");

var $aW7Gb = parcelRequire("aW7Gb");

var $r7fN6 = parcelRequire("r7fN6");

var $j7yUF = parcelRequire("j7yUF");

var $hkR0n = parcelRequire("hkR0n");

var $k1Ozi = parcelRequire("k1Ozi");

var $8AyuI = parcelRequire("8AyuI");

var $4tSgq = parcelRequire("4tSgq");
class $79e3794a4b04b598$export$69957d0bff775eb6 extends (0, $4tSgq.Optimizer) {
    constructor(learningRate, beta1, beta2, epsilon = null, decay = 0.0){
        super();
        this.learningRate = learningRate;
        this.beta1 = beta1;
        this.beta2 = beta2;
        this.epsilon = epsilon;
        this.decay = decay;
        this.accumulatedFirstMoment = [];
        this.accumulatedWeightedInfNorm = [];
        (0, $9c0Qr.tidy)(()=>{
            this.iteration = (0, $j7yUF.scalar)(0).variable();
            this.accBeta1 = (0, $j7yUF.scalar)(beta1).variable();
        });
        if (epsilon == null) this.epsilon = (0, $aHfUM.ENGINE).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        (0, $9c0Qr.tidy)(()=>{
            const oneMinusAccBeta1 = (0, $hkR0n.sub)(1, this.accBeta1);
            const lr = (0, $gjFWY.div)(-this.learningRate, (0, $1ZrG5.add)((0, $r7fN6.mul)(this.iteration, this.decay), 1));
            variableNames.forEach((name, i)=>{
                const value = (0, $aHfUM.ENGINE).registeredVariables[name];
                const trainable = false;
                if (this.accumulatedFirstMoment[i] == null) this.accumulatedFirstMoment[i] = {
                    originalName: `${name}/m`,
                    variable: (0, $k1Ozi.zerosLike)(value).variable(trainable)
                };
                if (this.accumulatedWeightedInfNorm[i] == null) this.accumulatedWeightedInfNorm[i] = {
                    originalName: `${name}/v`,
                    variable: (0, $k1Ozi.zerosLike)(value).variable(trainable)
                };
                const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
                if (gradient == null) return;
                const firstMoment = this.accumulatedFirstMoment[i].variable;
                const weightedInfNorm = this.accumulatedWeightedInfNorm[i].variable;
                const newFirstMoment = (0, $1ZrG5.add)((0, $r7fN6.mul)(firstMoment, this.beta1), (0, $r7fN6.mul)(gradient, 1 - this.beta1));
                const ut0 = (0, $r7fN6.mul)(weightedInfNorm, this.beta2);
                const ut1 = (0, $6oc11.abs)(gradient);
                const newWeightedInfNorm = (0, $aW7Gb.maximum)(ut0, ut1);
                firstMoment.assign(newFirstMoment);
                weightedInfNorm.assign(newWeightedInfNorm);
                const newValue = (0, $1ZrG5.add)((0, $r7fN6.mul)((0, $gjFWY.div)(lr, oneMinusAccBeta1), (0, $gjFWY.div)(newFirstMoment, (0, $1ZrG5.add)(newWeightedInfNorm, this.epsilon))), value);
                value.assign(newValue);
            });
            this.iteration.assign((0, $1ZrG5.add)(this.iteration, 1));
            this.accBeta1.assign((0, $r7fN6.mul)(this.accBeta1, this.beta1));
        });
        this.incrementIterations();
    }
    dispose() {
        this.accBeta1.dispose();
        this.iteration.dispose();
        if (this.accumulatedFirstMoment != null) (0, $9c0Qr.dispose)(this.accumulatedFirstMoment.map((v)=>v.variable));
        if (this.accumulatedWeightedInfNorm != null) (0, $9c0Qr.dispose)(this.accumulatedWeightedInfNorm.map((v)=>v.variable));
    }
    async getWeights() {
        throw new Error('getWeights() is not implemented for Adamax yet.');
    }
    async setWeights(weightValues) {
        throw new Error('setWeights() is not implemented for Adamax yet.');
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'beta1': this.beta1,
            'beta2': this.beta2,
            'epsilon': this.epsilon,
            'decay': this.decay
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon'], config['decay']);
    }
}
/** @nocollapse */ $79e3794a4b04b598$export$69957d0bff775eb6.className = 'Adamax'; // Note: Name matters for Python compatbility.
(0, $8AyuI.registerClass)($79e3794a4b04b598$export$69957d0bff775eb6);

});
parcelRegister("6oc11", function(module, exports) {

$parcel$export(module.exports, "abs", () => $4a6e4e0333af8389$export$2335f513bbd82c6d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes absolute value element-wise: `abs(x)`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.abs().print();  // or tf.abs(x)
 * ```
 * @param x The input `tf.Tensor`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $4a6e4e0333af8389$var$abs_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'abs');
    if ($x.dtype === 'complex64') {
        const inputs = {
            x: $x
        };
        return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.ComplexAbs), inputs);
    } else {
        const inputs = {
            x: $x
        };
        return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Abs), inputs);
    }
}
const $4a6e4e0333af8389$export$2335f513bbd82c6d = (0, $jKUCi.op)({
    abs_: $4a6e4e0333af8389$var$abs_
});

});

parcelRegister("aW7Gb", function(module, exports) {

$parcel$export(module.exports, "maximum", () => $7f65471d0db72906$export$b25e0be55f42c9a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $eqTIO = parcelRequire("eqTIO");

var $7qWZ5 = parcelRequire("7qWZ5");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the max of a and b (`a > b ? a : b`) element-wise.
 * Supports broadcasting.
 *
 * We also expose `tf.maximumStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.maximum(b).print();  // or tf.maximum(a, b)
 * ```
 *
 * ```js
 * // Broadcast maximum a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.maximum(b).print();  // or tf.maximum(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $7f65471d0db72906$var$maximum_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'maximum');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'maximum');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    if ($a.dtype === 'bool') {
        $a = (0, $7qWZ5.cast)($a, 'int32');
        $b = (0, $7qWZ5.cast)($b, 'int32');
    }
    (0, $eqTIO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Maximum), inputs);
}
const $7f65471d0db72906$export$b25e0be55f42c9a = (0, $jKUCi.op)({
    maximum_: $7f65471d0db72906$var$maximum_
});

});


parcelRegister("gk98v", function(module, exports) {

$parcel$export(module.exports, "MomentumOptimizer", () => $be2599dafa0d7ccc$export$1db7ecf1f8312c6);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $9c0Qr = parcelRequire("9c0Qr");

var $1ZrG5 = parcelRequire("1ZrG5");

var $r7fN6 = parcelRequire("r7fN6");

var $j7yUF = parcelRequire("j7yUF");

var $k1Ozi = parcelRequire("k1Ozi");

var $8AyuI = parcelRequire("8AyuI");

var $2vKqD = parcelRequire("2vKqD");
class $be2599dafa0d7ccc$export$1db7ecf1f8312c6 extends (0, $2vKqD.SGDOptimizer) {
    constructor(learningRate, momentum, useNesterov = false){
        super(learningRate);
        this.learningRate = learningRate;
        this.momentum = momentum;
        this.useNesterov = useNesterov;
        this.accumulations = [];
        this.m = (0, $j7yUF.scalar)(this.momentum);
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $aHfUM.ENGINE).registeredVariables[name];
            if (this.accumulations[i] == null) {
                const trainable = false;
                this.accumulations[i] = {
                    originalName: `${name}/momentum`,
                    variable: (0, $9c0Qr.tidy)(()=>(0, $k1Ozi.zerosLike)(value).variable(trainable))
                };
            }
            const accumulation = this.accumulations[i].variable;
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            (0, $9c0Qr.tidy)(()=>{
                let newValue;
                const newAccumulation = (0, $1ZrG5.add)((0, $r7fN6.mul)(this.m, accumulation), gradient);
                if (this.useNesterov) newValue = (0, $1ZrG5.add)((0, $r7fN6.mul)(this.c, (0, $1ZrG5.add)(gradient, (0, $r7fN6.mul)(newAccumulation, this.m))), value);
                else newValue = (0, $1ZrG5.add)((0, $r7fN6.mul)(this.c, newAccumulation), value);
                accumulation.assign(newAccumulation);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        this.m.dispose();
        if (this.accumulations != null) (0, $9c0Qr.dispose)(this.accumulations.map((v)=>v.variable));
    }
    /**
     * Sets the momentum of the optimizer.
     *
     * @param momentum
     */ setMomentum(momentum) {
        this.momentum = momentum;
    }
    async getWeights() {
        // Order matters for Python compatibility.
        return [
            await this.saveIterations()
        ].concat(this.accumulations.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const trainable = false;
        this.accumulations = weightValues.map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'momentum': this.momentum,
            'useNesterov': this.useNesterov
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['momentum'], config['useNesterov']);
    }
}
/** @nocollapse */ $be2599dafa0d7ccc$export$1db7ecf1f8312c6.className = 'Momentum'; // Name matters for Python compatibility.
(0, $8AyuI.registerClass)($be2599dafa0d7ccc$export$1db7ecf1f8312c6);

});
parcelRegister("2vKqD", function(module, exports) {

$parcel$export(module.exports, "SGDOptimizer", () => $1d427dc2ee2aa7d2$export$97318dd520e1bd4f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $9c0Qr = parcelRequire("9c0Qr");

var $1ZrG5 = parcelRequire("1ZrG5");

var $r7fN6 = parcelRequire("r7fN6");

var $j7yUF = parcelRequire("j7yUF");

var $8AyuI = parcelRequire("8AyuI");

var $4tSgq = parcelRequire("4tSgq");
class $1d427dc2ee2aa7d2$export$97318dd520e1bd4f extends (0, $4tSgq.Optimizer) {
    constructor(learningRate){
        super();
        this.learningRate = learningRate;
        this.setLearningRate(learningRate);
    }
    applyGradients(variableGradients) {
        const varNames = Array.isArray(variableGradients) ? variableGradients.map((v)=>v.name) : Object.keys(variableGradients);
        varNames.forEach((name, i)=>{
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const value = (0, $aHfUM.ENGINE).registeredVariables[name];
            (0, $9c0Qr.tidy)(()=>{
                const newValue = (0, $1ZrG5.add)((0, $r7fN6.mul)(this.c, gradient), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    /**
     * Sets the learning rate of the optimizer.
     */ setLearningRate(learningRate) {
        this.learningRate = learningRate;
        if (this.c != null) this.c.dispose();
        this.c = (0, $9c0Qr.keep)((0, $j7yUF.scalar)(-learningRate));
    }
    dispose() {
        this.c.dispose();
    }
    async getWeights() {
        return [
            await this.saveIterations()
        ];
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        if (weightValues.length !== 0) throw new Error('SGD optimizer does not have settable weights.');
    }
    getConfig() {
        return {
            'learningRate': this.learningRate
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate']);
    }
}
/** @nocollapse */ $1d427dc2ee2aa7d2$export$97318dd520e1bd4f.className = 'SGD'; // Note: Name matters for Python compatibility.
(0, $8AyuI.registerClass)($1d427dc2ee2aa7d2$export$97318dd520e1bd4f);

});


parcelRegister("a7bcD", function(module, exports) {

$parcel$export(module.exports, "OptimizerConstructors", () => $75d33f7c3afdd27c$export$1babc3d7b10c0cf6);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aSzso = parcelRequire("aSzso");

var $am0NB = parcelRequire("am0NB");

var $dXwyG = parcelRequire("dXwyG");

var $asOdC = parcelRequire("asOdC");

var $gk98v = parcelRequire("gk98v");

var $gblOj = parcelRequire("gblOj");

var $2vKqD = parcelRequire("2vKqD");
class $75d33f7c3afdd27c$export$1babc3d7b10c0cf6 {
    /**
     * Constructs a `tf.SGDOptimizer` that uses stochastic gradient descent.
     *
     * ```js
     * // Fit a quadratic function by learning the coefficients a, b, c.
     * const xs = tf.tensor1d([0, 1, 2, 3]);
     * const ys = tf.tensor1d([1.1, 5.9, 16.8, 33.9]);
     *
     * const a = tf.scalar(Math.random()).variable();
     * const b = tf.scalar(Math.random()).variable();
     * const c = tf.scalar(Math.random()).variable();
     *
     * // y = a * x^2 + b * x + c.
     * const f = x => a.mul(x.square()).add(b.mul(x)).add(c);
     * const loss = (pred, label) => pred.sub(label).square().mean();
     *
     * const learningRate = 0.01;
     * const optimizer = tf.train.sgd(learningRate);
     *
     * // Train the model.
     * for (let i = 0; i < 10; i++) {
     *   optimizer.minimize(() => loss(f(xs), ys));
     * }
     *
     * // Make predictions.
     * console.log(
     *     `a: ${a.dataSync()}, b: ${b.dataSync()}, c: ${c.dataSync()}`);
     * const preds = f(xs).dataSync();
     * preds.forEach((pred, i) => {
     *   console.log(`x: ${i}, pred: ${pred}`);
     * });
     * ```
     *
     * @param learningRate The learning rate to use for the SGD algorithm.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static sgd(learningRate) {
        return new (0, $2vKqD.SGDOptimizer)(learningRate);
    }
    /**
     * Constructs a `tf.MomentumOptimizer` that uses momentum gradient
     * descent.
     *
     * See
     * [http://proceedings.mlr.press/v28/sutskever13.pdf](
     * http://proceedings.mlr.press/v28/sutskever13.pdf)
     *
     * @param learningRate The learning rate to use for the Momentum gradient
     * descent algorithm.
     * @param momentum The momentum to use for the momentum gradient descent
     * algorithm.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static momentum(learningRate, momentum, useNesterov = false) {
        return new (0, $gk98v.MomentumOptimizer)(learningRate, momentum, useNesterov);
    }
    /**
     * Constructs a `tf.RMSPropOptimizer` that uses RMSProp gradient
     * descent. This implementation uses plain momentum and is not centered
     * version of RMSProp.
     *
     * See
     * [http://www.cs.toronto.edu/~tijmen/csc321/slides/lecture_slides_lec6.pdf](
     * http://www.cs.toronto.edu/~tijmen/csc321/slides/lecture_slides_lec6.pdf)
     *
     * @param learningRate The learning rate to use for the RMSProp gradient
     * descent algorithm.
     * @param decay The discounting factor for the history/coming gradient.
     * @param momentum The momentum to use for the RMSProp gradient descent
     * algorithm.
     * @param epsilon Small value to avoid zero denominator.
     * @param centered If true, gradients are normalized by the estimated
     * variance of the gradient.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static rmsprop(learningRate, decay = .9, momentum = 0.0, epsilon = null, centered = false) {
        return new (0, $gblOj.RMSPropOptimizer)(learningRate, decay, momentum, epsilon, centered);
    }
    /**
     * Constructs a `tf.AdamOptimizer` that uses the Adam algorithm.
     * See [https://arxiv.org/abs/1412.6980](https://arxiv.org/abs/1412.6980)
     *
     * @param learningRate The learning rate to use for the Adam gradient
     * descent algorithm.
     * @param beta1 The exponential decay rate for the 1st moment estimates.
     * @param beta2 The exponential decay rate for the 2nd moment estimates.
     * @param epsilon A small constant for numerical stability.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adam(learningRate = 0.001, beta1 = 0.9, beta2 = 0.999, epsilon = null) {
        return new (0, $dXwyG.AdamOptimizer)(learningRate, beta1, beta2, epsilon);
    }
    /**
     * Constructs a `tf.AdadeltaOptimizer` that uses the Adadelta algorithm.
     * See [https://arxiv.org/abs/1212.5701](https://arxiv.org/abs/1212.5701)
     *
     * @param learningRate The learning rate to use for the Adadelta gradient
     * descent algorithm.
     * @param rho The learning rate decay over each update.
     * @param epsilon A constant epsilon used to better condition the grad
     * update.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adadelta(learningRate = .001, rho = .95, epsilon = null) {
        return new (0, $aSzso.AdadeltaOptimizer)(learningRate, rho, epsilon);
    }
    /**
     * Constructs a `tf.AdamaxOptimizer` that uses the Adamax algorithm.
     * See [https://arxiv.org/abs/1412.6980](https://arxiv.org/abs/1412.6980)
     *
     * @param learningRate The learning rate to use for the Adamax gradient
     * descent algorithm.
     * @param beta1 The exponential decay rate for the 1st moment estimates.
     * @param beta2 The exponential decay rate for the 2nd moment estimates.
     * @param epsilon A small constant for numerical stability.
     * @param decay The learning rate decay over each update.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adamax(learningRate = 0.002, beta1 = 0.9, beta2 = 0.999, epsilon = null, decay = 0.0) {
        return new (0, $asOdC.AdamaxOptimizer)(learningRate, beta1, beta2, epsilon, decay);
    }
    /**
     * Constructs a `tf.AdagradOptimizer` that uses the Adagrad algorithm.
     * See
     * [http://www.jmlr.org/papers/volume12/duchi11a/duchi11a.pdf](
     * http://www.jmlr.org/papers/volume12/duchi11a/duchi11a.pdf)
     * or
     * [http://ruder.io/optimizing-gradient-descent/index.html#adagrad](
     * http://ruder.io/optimizing-gradient-descent/index.html#adagrad)
     *
     * @param learningRate The learning rate to use for the Adagrad gradient
     * descent algorithm.
     * @param initialAccumulatorValue Starting value for the accumulators, must be
     * positive.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adagrad(learningRate, initialAccumulatorValue = 0.1) {
        return new (0, $am0NB.AdagradOptimizer)(learningRate, initialAccumulatorValue);
    }
}

});
parcelRegister("gblOj", function(module, exports) {

$parcel$export(module.exports, "RMSPropOptimizer", () => $bc7e978acc77dd72$export$6e668138ce08e3bf);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $9c0Qr = parcelRequire("9c0Qr");

var $1ZrG5 = parcelRequire("1ZrG5");

var $gjFWY = parcelRequire("gjFWY");

var $r7fN6 = parcelRequire("r7fN6");

var $lGdn1 = parcelRequire("lGdn1");

var $gqriC = parcelRequire("gqriC");

var $hkR0n = parcelRequire("hkR0n");

var $k1Ozi = parcelRequire("k1Ozi");

var $8AyuI = parcelRequire("8AyuI");

var $4tSgq = parcelRequire("4tSgq");
class $bc7e978acc77dd72$export$6e668138ce08e3bf extends (0, $4tSgq.Optimizer) {
    constructor(learningRate, decay = 0.9, momentum = 0.0, epsilon = null, centered = false){
        super();
        this.learningRate = learningRate;
        this.decay = decay;
        this.momentum = momentum;
        this.epsilon = epsilon;
        this.accumulatedMeanSquares = [];
        this.accumulatedMoments = [];
        this.accumulatedMeanGrads = [];
        this.centered = centered;
        if (epsilon == null) this.epsilon = (0, $aHfUM.ENGINE).backend.epsilon();
        if (learningRate == null) throw new Error(`learningRate for RMSPropOptimizer must be defined.`);
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $aHfUM.ENGINE).registeredVariables[name];
            const trainable = false;
            if (this.accumulatedMeanSquares[i] == null) this.accumulatedMeanSquares[i] = {
                originalName: `${name}/rms`,
                variable: (0, $9c0Qr.tidy)(()=>(0, $k1Ozi.zerosLike)(value).variable(trainable))
            };
            if (this.accumulatedMoments[i] == null) this.accumulatedMoments[i] = {
                originalName: `${name}/momentum`,
                variable: (0, $9c0Qr.tidy)(()=>(0, $k1Ozi.zerosLike)(value).variable(trainable))
            };
            if (this.accumulatedMeanGrads[i] == null && this.centered) this.accumulatedMeanGrads[i] = {
                originalName: `${name}/mg`,
                variable: (0, $9c0Qr.tidy)(()=>(0, $k1Ozi.zerosLike)(value).variable(trainable))
            };
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedMeanSquare = this.accumulatedMeanSquares[i].variable;
            const accumulatedMoments = this.accumulatedMoments[i].variable;
            (0, $9c0Qr.tidy)(()=>{
                const newAccumulatedMeanSquare = (0, $1ZrG5.add)((0, $r7fN6.mul)(accumulatedMeanSquare, this.decay), (0, $r7fN6.mul)((0, $gqriC.square)(gradient), 1 - this.decay));
                if (this.centered) {
                    const accumulatedMeanGrad = this.accumulatedMeanGrads[i].variable;
                    // Centered gradient
                    const newAccumulatedMeanGrad = (0, $1ZrG5.add)((0, $r7fN6.mul)(accumulatedMeanGrad, this.decay), (0, $r7fN6.mul)(gradient, 1 - this.decay));
                    const gradContribution = (0, $gjFWY.div)((0, $r7fN6.mul)(gradient, this.learningRate), (0, $lGdn1.sqrt)((0, $hkR0n.sub)(newAccumulatedMeanSquare, (0, $1ZrG5.add)((0, $gqriC.square)(newAccumulatedMeanGrad), this.epsilon))));
                    const newAccumulatedMoments = (0, $1ZrG5.add)((0, $r7fN6.mul)(accumulatedMoments, this.momentum), gradContribution);
                    accumulatedMeanSquare.assign(newAccumulatedMeanSquare);
                    accumulatedMeanGrad.assign(newAccumulatedMeanGrad);
                    accumulatedMoments.assign(newAccumulatedMoments);
                    const newValue = (0, $hkR0n.sub)(value, newAccumulatedMoments);
                    value.assign(newValue);
                } else {
                    // Plain gradient
                    const newAccumulatedMeanSquare = (0, $1ZrG5.add)((0, $r7fN6.mul)(accumulatedMeanSquare, this.decay), (0, $r7fN6.mul)((0, $gqriC.square)(gradient), 1 - this.decay));
                    const newAccumulatedMoments = (0, $1ZrG5.add)((0, $r7fN6.mul)(accumulatedMoments, this.momentum), (0, $gjFWY.div)((0, $r7fN6.mul)(gradient, this.learningRate), (0, $lGdn1.sqrt)((0, $1ZrG5.add)(newAccumulatedMeanSquare, this.epsilon))));
                    accumulatedMeanSquare.assign(newAccumulatedMeanSquare);
                    accumulatedMoments.assign(newAccumulatedMoments);
                    const newValue = (0, $hkR0n.sub)(value, newAccumulatedMoments);
                    value.assign(newValue);
                }
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedMeanSquares != null) (0, $9c0Qr.dispose)(this.accumulatedMeanSquares.map((v)=>v.variable));
        if (this.accumulatedMeanGrads != null && this.centered) (0, $9c0Qr.dispose)(this.accumulatedMeanGrads.map((v)=>v.variable));
        if (this.accumulatedMoments != null) (0, $9c0Qr.dispose)(this.accumulatedMoments.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedMeanSquares,
            ...this.accumulatedMoments
        ];
        if (this.centered) variables.push(...this.accumulatedMeanGrads);
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const variableCount = this.centered ? weightValues.length / 3 : weightValues.length / 2;
        const trainable = false;
        this.accumulatedMeanSquares = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedMoments = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        if (this.centered) this.accumulatedMeanGrads = weightValues.slice(variableCount * 2, variableCount * 3).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'decay': this.decay,
            'momentum': this.momentum,
            'epsilon': this.epsilon,
            'centered': this.centered
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['decay'], config['momentum'], config['epsilon'], config['centered']);
    }
}
/** @nocollapse */ $bc7e978acc77dd72$export$6e668138ce08e3bf.className = 'RMSProp'; // Note: Name matters for Python compatibility.
(0, $8AyuI.registerClass)($bc7e978acc77dd72$export$6e668138ce08e3bf);

});


parcelRegister("iNZmA", function(module, exports) {

$parcel$export(module.exports, "spectral", () => $db0c6716b8253a39$export$e0ccf6166915bd59);
$parcel$export(module.exports, "signal", () => $db0c6716b8253a39$export$e2ef10f86a8d60e8);
$parcel$export(module.exports, "image", () => $db0c6716b8253a39$export$5c452ff88e35e47d);
$parcel$export(module.exports, "linalg", () => $db0c6716b8253a39$export$dbc5be37a4415193);
$parcel$export(module.exports, "losses", () => $db0c6716b8253a39$export$24b113a95118cbdc);
$parcel$export(module.exports, "sparse", () => $db0c6716b8253a39$export$b6b7e189aa5d134c);
$parcel$export(module.exports, "string", () => $db0c6716b8253a39$export$22b082955e083ec3);
$parcel$export(module.exports, "abs", () => (parcelRequire("6oc11")).abs);
$parcel$export(module.exports, "acos", () => (parcelRequire("8XlSR")).acos);
$parcel$export(module.exports, "acosh", () => (parcelRequire("9dYpT")).acosh);
$parcel$export(module.exports, "add", () => (parcelRequire("1ZrG5")).add);
$parcel$export(module.exports, "addN", () => (parcelRequire("jXGsE")).addN);
$parcel$export(module.exports, "all", () => (parcelRequire("br27u")).all);
$parcel$export(module.exports, "any", () => (parcelRequire("joFjq")).any);
$parcel$export(module.exports, "argMax", () => (parcelRequire("iFZ6U")).argMax);
$parcel$export(module.exports, "argMin", () => (parcelRequire("kXTu8")).argMin);
$parcel$export(module.exports, "asin", () => (parcelRequire("13fQN")).asin);
$parcel$export(module.exports, "asinh", () => (parcelRequire("4RKl9")).asinh);
$parcel$export(module.exports, "atan", () => (parcelRequire("jiLKp")).atan);
$parcel$export(module.exports, "atan2", () => (parcelRequire("f4jET")).atan2);
$parcel$export(module.exports, "atanh", () => (parcelRequire("2HRHM")).atanh);
$parcel$export(module.exports, "avgPool", () => (parcelRequire("jqmHD")).avgPool);
$parcel$export(module.exports, "avgPool3d", () => (parcelRequire("iWtLR")).avgPool3d);
$parcel$export(module.exports, "basicLSTMCell", () => (parcelRequire("fxy2h")).basicLSTMCell);
$parcel$export(module.exports, "batchToSpaceND", () => (parcelRequire("7J0of")).batchToSpaceND);
$parcel$export(module.exports, "batchNorm", () => (parcelRequire("vnJKw")).batchNorm);
$parcel$export(module.exports, "batchNorm2d", () => (parcelRequire("NUhQF")).batchNorm2d);
$parcel$export(module.exports, "batchNorm3d", () => (parcelRequire("fACaf")).batchNorm3d);
$parcel$export(module.exports, "batchNorm4d", () => (parcelRequire("f6vw7")).batchNorm4d);
$parcel$export(module.exports, "bincount", () => (parcelRequire("5sha3")).bincount);
$parcel$export(module.exports, "broadcastArgs", () => (parcelRequire("cTB2y")).broadcastArgs);
$parcel$export(module.exports, "broadcastTo", () => (parcelRequire("eJSTd")).broadcastTo);
$parcel$export(module.exports, "buffer", () => (parcelRequire("g81BN")).buffer);
$parcel$export(module.exports, "cast", () => (parcelRequire("7qWZ5")).cast);
$parcel$export(module.exports, "ceil", () => (parcelRequire("hoXwH")).ceil);
$parcel$export(module.exports, "clipByValue", () => (parcelRequire("jU3Ej")).clipByValue);
$parcel$export(module.exports, "clone", () => (parcelRequire("dnFj7")).clone);
$parcel$export(module.exports, "complex", () => (parcelRequire("bxdsK")).complex);
$parcel$export(module.exports, "concat", () => (parcelRequire("6LWfo")).concat);
$parcel$export(module.exports, "concat1d", () => (parcelRequire("ayCnc")).concat1d);
$parcel$export(module.exports, "concat2d", () => (parcelRequire("iy8jW")).concat2d);
$parcel$export(module.exports, "concat3d", () => (parcelRequire("3pVmi")).concat3d);
$parcel$export(module.exports, "concat4d", () => (parcelRequire("cM6MZ")).concat4d);
$parcel$export(module.exports, "conv1d", () => (parcelRequire("a6dzP")).conv1d);
$parcel$export(module.exports, "conv2d", () => (parcelRequire("jOBWR")).conv2d);
$parcel$export(module.exports, "conv2dTranspose", () => (parcelRequire("cKiMT")).conv2dTranspose);
$parcel$export(module.exports, "conv3d", () => (parcelRequire("7V1iv")).conv3d);
$parcel$export(module.exports, "conv3dTranspose", () => (parcelRequire("jVkrH")).conv3dTranspose);
$parcel$export(module.exports, "cos", () => (parcelRequire("hZQWd")).cos);
$parcel$export(module.exports, "cosh", () => (parcelRequire("9p6CG")).cosh);
$parcel$export(module.exports, "cumprod", () => (parcelRequire("hlDAs")).cumprod);
$parcel$export(module.exports, "cumsum", () => (parcelRequire("6nQJI")).cumsum);
$parcel$export(module.exports, "denseBincount", () => (parcelRequire("jQm41")).denseBincount);
$parcel$export(module.exports, "depthToSpace", () => (parcelRequire("7Maa1")).depthToSpace);
$parcel$export(module.exports, "depthwiseConv2d", () => (parcelRequire("kDOuZ")).depthwiseConv2d);
$parcel$export(module.exports, "diag", () => (parcelRequire("iAmAQ")).diag);
$parcel$export(module.exports, "dilation2d", () => (parcelRequire("cPcCM")).dilation2d);
$parcel$export(module.exports, "div", () => (parcelRequire("gjFWY")).div);
$parcel$export(module.exports, "divNoNan", () => (parcelRequire("fFAAa")).divNoNan);
$parcel$export(module.exports, "dot", () => (parcelRequire("8RVHb")).dot);
$parcel$export(module.exports, "einsum", () => (parcelRequire("hJ5gA")).einsum);
$parcel$export(module.exports, "elu", () => (parcelRequire("aYszp")).elu);
$parcel$export(module.exports, "equal", () => (parcelRequire("5Py3O")).equal);
$parcel$export(module.exports, "erf", () => (parcelRequire("44EES")).erf);
$parcel$export(module.exports, "euclideanNorm", () => (parcelRequire("evBPw")).euclideanNorm);
$parcel$export(module.exports, "exp", () => (parcelRequire("4NGnB")).exp);
$parcel$export(module.exports, "expandDims", () => (parcelRequire("6mzQK")).expandDims);
$parcel$export(module.exports, "expm1", () => (parcelRequire("lMtcP")).expm1);
$parcel$export(module.exports, "eye", () => (parcelRequire("dF7rq")).eye);
$parcel$export(module.exports, "fill", () => (parcelRequire("3kNX7")).fill);
$parcel$export(module.exports, "floor", () => (parcelRequire("hnXfr")).floor);
$parcel$export(module.exports, "floorDiv", () => (parcelRequire("6ktJw")).floorDiv);
$parcel$export(module.exports, "gather", () => (parcelRequire("kiLVE")).gather);
$parcel$export(module.exports, "greater", () => (parcelRequire("jUhqf")).greater);
$parcel$export(module.exports, "greaterEqual", () => (parcelRequire("cUuWi")).greaterEqual);
$parcel$export(module.exports, "imag", () => (parcelRequire("7of6P")).imag);
$parcel$export(module.exports, "isFinite", () => (parcelRequire("63ReF")).isFinite);
$parcel$export(module.exports, "isInf", () => (parcelRequire("bpcc2")).isInf);
$parcel$export(module.exports, "isNaN", () => (parcelRequire("grp09")).isNaN);
$parcel$export(module.exports, "leakyRelu", () => (parcelRequire("8XuOv")).leakyRelu);
$parcel$export(module.exports, "less", () => (parcelRequire("6skdg")).less);
$parcel$export(module.exports, "lessEqual", () => (parcelRequire("eXGUa")).lessEqual);
$parcel$export(module.exports, "linspace", () => (parcelRequire("ci8bg")).linspace);
$parcel$export(module.exports, "localResponseNormalization", () => (parcelRequire("eOy3E")).localResponseNormalization);
$parcel$export(module.exports, "log", () => (parcelRequire("djEuh")).log);
$parcel$export(module.exports, "log1p", () => (parcelRequire("ibX5K")).log1p);
$parcel$export(module.exports, "logSigmoid", () => (parcelRequire("Xpmxi")).logSigmoid);
$parcel$export(module.exports, "logSoftmax", () => (parcelRequire("1oQXI")).logSoftmax);
$parcel$export(module.exports, "logSumExp", () => (parcelRequire("awUAx")).logSumExp);
$parcel$export(module.exports, "logicalAnd", () => (parcelRequire("jtRHJ")).logicalAnd);
$parcel$export(module.exports, "logicalNot", () => (parcelRequire("ifcdf")).logicalNot);
$parcel$export(module.exports, "logicalOr", () => (parcelRequire("eQZfy")).logicalOr);
$parcel$export(module.exports, "logicalXor", () => (parcelRequire("cKPSM")).logicalXor);
$parcel$export(module.exports, "lowerBound", () => (parcelRequire("g06WT")).lowerBound);
$parcel$export(module.exports, "matMul", () => (parcelRequire("clO9Z")).matMul);
$parcel$export(module.exports, "max", () => (parcelRequire("Fvpms")).max);
$parcel$export(module.exports, "maxPool", () => (parcelRequire("jslkq")).maxPool);
$parcel$export(module.exports, "maxPool3d", () => (parcelRequire("1lAhs")).maxPool3d);
$parcel$export(module.exports, "maxPoolWithArgmax", () => (parcelRequire("2Og8s")).maxPoolWithArgmax);
$parcel$export(module.exports, "maximum", () => (parcelRequire("aW7Gb")).maximum);
$parcel$export(module.exports, "mean", () => (parcelRequire("gr40e")).mean);
$parcel$export(module.exports, "meshgrid", () => (parcelRequire("8JKsF")).meshgrid);
$parcel$export(module.exports, "min", () => (parcelRequire("8qxBf")).min);
$parcel$export(module.exports, "minimum", () => (parcelRequire("dlTNL")).minimum);
$parcel$export(module.exports, "mirrorPad", () => (parcelRequire("5sP2j")).mirrorPad);
$parcel$export(module.exports, "mod", () => (parcelRequire("62Ung")).mod);
$parcel$export(module.exports, "moments", () => (parcelRequire("9nuoC")).moments);
$parcel$export(module.exports, "mul", () => (parcelRequire("r7fN6")).mul);
$parcel$export(module.exports, "multiRNNCell", () => (parcelRequire("iLhm3")).multiRNNCell);
$parcel$export(module.exports, "multinomial", () => (parcelRequire("gehiq")).multinomial);
$parcel$export(module.exports, "neg", () => (parcelRequire("ifge7")).neg);
$parcel$export(module.exports, "notEqual", () => (parcelRequire("i8e86")).notEqual);
$parcel$export(module.exports, "oneHot", () => (parcelRequire("8feEH")).oneHot);
$parcel$export(module.exports, "ones", () => (parcelRequire("bhi4b")).ones);
$parcel$export(module.exports, "onesLike", () => (parcelRequire("9u8DQ")).onesLike);
$parcel$export(module.exports, "outerProduct", () => (parcelRequire("gD1dS")).outerProduct);
$parcel$export(module.exports, "pad", () => (parcelRequire("4xBxs")).pad);
$parcel$export(module.exports, "pad1d", () => (parcelRequire("1VOOA")).pad1d);
$parcel$export(module.exports, "pad2d", () => (parcelRequire("1yKeQ")).pad2d);
$parcel$export(module.exports, "pad3d", () => (parcelRequire("jGUcb")).pad3d);
$parcel$export(module.exports, "pad4d", () => (parcelRequire("28oUY")).pad4d);
$parcel$export(module.exports, "pool", () => (parcelRequire("eahnV")).pool);
$parcel$export(module.exports, "pow", () => (parcelRequire("5MZxP")).pow);
$parcel$export(module.exports, "prelu", () => (parcelRequire("4Do8T")).prelu);
$parcel$export(module.exports, "print", () => (parcelRequire("cwNui")).print);
$parcel$export(module.exports, "prod", () => (parcelRequire("5TfzT")).prod);
$parcel$export(module.exports, "raggedGather", () => (parcelRequire("3E3zr")).raggedGather);
$parcel$export(module.exports, "raggedTensorToTensor", () => (parcelRequire("6D3aB")).raggedTensorToTensor);
$parcel$export(module.exports, "rand", () => (parcelRequire("9iMrt")).rand);
$parcel$export(module.exports, "randomGamma", () => (parcelRequire("g5Npe")).randomGamma);
$parcel$export(module.exports, "randomNormal", () => (parcelRequire("h5wle")).randomNormal);
$parcel$export(module.exports, "randomStandardNormal", () => (parcelRequire("kww16")).randomStandardNormal);
$parcel$export(module.exports, "randomUniform", () => (parcelRequire("gOgMa")).randomUniform);
$parcel$export(module.exports, "range", () => (parcelRequire("9qLoy")).range);
$parcel$export(module.exports, "real", () => (parcelRequire("3XWb2")).real);
$parcel$export(module.exports, "reciprocal", () => (parcelRequire("iseIE")).reciprocal);
$parcel$export(module.exports, "relu", () => (parcelRequire("1mZlL")).relu);
$parcel$export(module.exports, "relu6", () => (parcelRequire("4QFBe")).relu6);
$parcel$export(module.exports, "reshape", () => (parcelRequire("eP0pM")).reshape);
$parcel$export(module.exports, "reverse", () => (parcelRequire("do1MK")).reverse);
$parcel$export(module.exports, "reverse1d", () => (parcelRequire("1vNdh")).reverse1d);
$parcel$export(module.exports, "reverse2d", () => (parcelRequire("lNcpz")).reverse2d);
$parcel$export(module.exports, "reverse3d", () => (parcelRequire("lc66i")).reverse3d);
$parcel$export(module.exports, "reverse4d", () => (parcelRequire("d9lNy")).reverse4d);
$parcel$export(module.exports, "round", () => (parcelRequire("9mGGG")).round);
$parcel$export(module.exports, "rsqrt", () => (parcelRequire("bvzmJ")).rsqrt);
$parcel$export(module.exports, "scalar", () => (parcelRequire("j7yUF")).scalar);
$parcel$export(module.exports, "selu", () => (parcelRequire("fNXeh")).selu);
$parcel$export(module.exports, "separableConv2d", () => (parcelRequire("iC1W9")).separableConv2d);
$parcel$export(module.exports, "setdiff1dAsync", () => (parcelRequire("gLBco")).setdiff1dAsync);
$parcel$export(module.exports, "sigmoid", () => (parcelRequire("5B3nT")).sigmoid);
$parcel$export(module.exports, "sign", () => (parcelRequire("bJQkq")).sign);
$parcel$export(module.exports, "sin", () => (parcelRequire("b37Kr")).sin);
$parcel$export(module.exports, "sinh", () => (parcelRequire("8sXeR")).sinh);
$parcel$export(module.exports, "slice", () => (parcelRequire("kvpGg")).slice);
$parcel$export(module.exports, "slice1d", () => (parcelRequire("5Uyxp")).slice1d);
$parcel$export(module.exports, "slice2d", () => (parcelRequire("fhfPl")).slice2d);
$parcel$export(module.exports, "slice3d", () => (parcelRequire("eUdR5")).slice3d);
$parcel$export(module.exports, "slice4d", () => (parcelRequire("9y3CH")).slice4d);
$parcel$export(module.exports, "softmax", () => (parcelRequire("5q2Zg")).softmax);
$parcel$export(module.exports, "softplus", () => (parcelRequire("cvbcy")).softplus);
$parcel$export(module.exports, "spaceToBatchND", () => (parcelRequire("95zUK")).spaceToBatchND);
$parcel$export(module.exports, "fft", () => (parcelRequire("kY0nO")).fft);
$parcel$export(module.exports, "ifft", () => (parcelRequire("jxjwy")).ifft);
$parcel$export(module.exports, "irfft", () => (parcelRequire("fiSk4")).irfft);
$parcel$export(module.exports, "rfft", () => (parcelRequire("fBxya")).rfft);
$parcel$export(module.exports, "split", () => (parcelRequire("9DjTt")).split);
$parcel$export(module.exports, "sqrt", () => (parcelRequire("lGdn1")).sqrt);
$parcel$export(module.exports, "square", () => (parcelRequire("gqriC")).square);
$parcel$export(module.exports, "squaredDifference", () => (parcelRequire("fRX4k")).squaredDifference);
$parcel$export(module.exports, "squeeze", () => (parcelRequire("wniip")).squeeze);
$parcel$export(module.exports, "stack", () => (parcelRequire("iSKul")).stack);
$parcel$export(module.exports, "step", () => (parcelRequire("4s2sX")).step);
$parcel$export(module.exports, "stridedSlice", () => (parcelRequire("lbPf7")).stridedSlice);
$parcel$export(module.exports, "sub", () => (parcelRequire("hkR0n")).sub);
$parcel$export(module.exports, "sum", () => (parcelRequire("fVwnn")).sum);
$parcel$export(module.exports, "tan", () => (parcelRequire("1pSFt")).tan);
$parcel$export(module.exports, "tanh", () => (parcelRequire("i3Kce")).tanh);
$parcel$export(module.exports, "tensor", () => (parcelRequire("ec8bD")).tensor);
$parcel$export(module.exports, "tensor1d", () => (parcelRequire("jIDgY")).tensor1d);
$parcel$export(module.exports, "tensor2d", () => (parcelRequire("g4QpC")).tensor2d);
$parcel$export(module.exports, "tensor3d", () => (parcelRequire("gLH3k")).tensor3d);
$parcel$export(module.exports, "tensor4d", () => (parcelRequire("RzdVf")).tensor4d);
$parcel$export(module.exports, "tensor5d", () => (parcelRequire("7WV0q")).tensor5d);
$parcel$export(module.exports, "tensor6d", () => (parcelRequire("9lkzv")).tensor6d);
$parcel$export(module.exports, "tile", () => (parcelRequire("jIHaY")).tile);
$parcel$export(module.exports, "topk", () => (parcelRequire("eW75q")).topk);
$parcel$export(module.exports, "truncatedNormal", () => (parcelRequire("7y8Jw")).truncatedNormal);
$parcel$export(module.exports, "unique", () => (parcelRequire("gMT7b")).unique);
$parcel$export(module.exports, "unsortedSegmentSum", () => (parcelRequire("grKBK")).unsortedSegmentSum);
$parcel$export(module.exports, "unstack", () => (parcelRequire("kDeMO")).unstack);
$parcel$export(module.exports, "upperBound", () => (parcelRequire("haXo2")).upperBound);
$parcel$export(module.exports, "variable", () => (parcelRequire("3mBtj")).variable);
$parcel$export(module.exports, "where", () => (parcelRequire("3dRh6")).where);
$parcel$export(module.exports, "whereAsync", () => (parcelRequire("8waHC")).whereAsync);
$parcel$export(module.exports, "zeros", () => (parcelRequire("7KCJq")).zeros);
$parcel$export(module.exports, "zerosLike", () => (parcelRequire("k1Ozi")).zerosLike);
$parcel$export(module.exports, "op", () => (parcelRequire("jKUCi")).op);
$parcel$export(module.exports, "OP_SCOPE_SUFFIX", () => (parcelRequire("jKUCi")).OP_SCOPE_SUFFIX);
$parcel$export(module.exports, "fused", () => (parcelRequire("kyRlD")));
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Modularized ops.

var $6oc11 = parcelRequire("6oc11");

var $8XlSR = parcelRequire("8XlSR");

var $9dYpT = parcelRequire("9dYpT");

var $1ZrG5 = parcelRequire("1ZrG5");

var $jXGsE = parcelRequire("jXGsE");

var $br27u = parcelRequire("br27u");

var $joFjq = parcelRequire("joFjq");

var $iFZ6U = parcelRequire("iFZ6U");

var $kXTu8 = parcelRequire("kXTu8");

var $13fQN = parcelRequire("13fQN");

var $4RKl9 = parcelRequire("4RKl9");

var $jiLKp = parcelRequire("jiLKp");

var $f4jET = parcelRequire("f4jET");

var $2HRHM = parcelRequire("2HRHM");

var $jqmHD = parcelRequire("jqmHD");

var $iWtLR = parcelRequire("iWtLR");

var $fxy2h = parcelRequire("fxy2h");

var $7J0of = parcelRequire("7J0of");

var $vnJKw = parcelRequire("vnJKw");

var $NUhQF = parcelRequire("NUhQF");

var $fACaf = parcelRequire("fACaf");

var $f6vw7 = parcelRequire("f6vw7");

var $5sha3 = parcelRequire("5sha3");

var $cTB2y = parcelRequire("cTB2y");

var $eJSTd = parcelRequire("eJSTd");

var $g81BN = parcelRequire("g81BN");

var $7qWZ5 = parcelRequire("7qWZ5");

var $hoXwH = parcelRequire("hoXwH");

var $jU3Ej = parcelRequire("jU3Ej");

var $dnFj7 = parcelRequire("dnFj7");

var $bxdsK = parcelRequire("bxdsK");

var $6LWfo = parcelRequire("6LWfo");

var $ayCnc = parcelRequire("ayCnc");

var $iy8jW = parcelRequire("iy8jW");

var $3pVmi = parcelRequire("3pVmi");

var $cM6MZ = parcelRequire("cM6MZ");

var $a6dzP = parcelRequire("a6dzP");

var $jOBWR = parcelRequire("jOBWR");

var $cKiMT = parcelRequire("cKiMT");

var $7V1iv = parcelRequire("7V1iv");

var $jVkrH = parcelRequire("jVkrH");

var $hZQWd = parcelRequire("hZQWd");

var $9p6CG = parcelRequire("9p6CG");

var $hlDAs = parcelRequire("hlDAs");

var $6nQJI = parcelRequire("6nQJI");

var $jQm41 = parcelRequire("jQm41");

var $7Maa1 = parcelRequire("7Maa1");

var $kDOuZ = parcelRequire("kDOuZ");

var $iAmAQ = parcelRequire("iAmAQ");

var $cPcCM = parcelRequire("cPcCM");

var $gjFWY = parcelRequire("gjFWY");

var $fFAAa = parcelRequire("fFAAa");

var $8RVHb = parcelRequire("8RVHb");

var $hJ5gA = parcelRequire("hJ5gA");

var $aYszp = parcelRequire("aYszp");

var $5Py3O = parcelRequire("5Py3O");

var $44EES = parcelRequire("44EES");

var $evBPw = parcelRequire("evBPw");

var $4NGnB = parcelRequire("4NGnB");

var $6mzQK = parcelRequire("6mzQK");

var $lMtcP = parcelRequire("lMtcP");

var $dF7rq = parcelRequire("dF7rq");

var $3kNX7 = parcelRequire("3kNX7");

var $hnXfr = parcelRequire("hnXfr");

var $6ktJw = parcelRequire("6ktJw");

var $kiLVE = parcelRequire("kiLVE");

var $jUhqf = parcelRequire("jUhqf");

var $cUuWi = parcelRequire("cUuWi");

var $7of6P = parcelRequire("7of6P");

var $63ReF = parcelRequire("63ReF");

var $bpcc2 = parcelRequire("bpcc2");

var $grp09 = parcelRequire("grp09");

var $8XuOv = parcelRequire("8XuOv");

var $6skdg = parcelRequire("6skdg");

var $eXGUa = parcelRequire("eXGUa");

var $ci8bg = parcelRequire("ci8bg");

var $eOy3E = parcelRequire("eOy3E");

var $djEuh = parcelRequire("djEuh");

var $ibX5K = parcelRequire("ibX5K");

var $Xpmxi = parcelRequire("Xpmxi");

var $1oQXI = parcelRequire("1oQXI");

var $awUAx = parcelRequire("awUAx");

var $jtRHJ = parcelRequire("jtRHJ");

var $ifcdf = parcelRequire("ifcdf");

var $eQZfy = parcelRequire("eQZfy");

var $cKPSM = parcelRequire("cKPSM");

var $g06WT = parcelRequire("g06WT");

var $clO9Z = parcelRequire("clO9Z");

var $Fvpms = parcelRequire("Fvpms");

var $jslkq = parcelRequire("jslkq");

var $1lAhs = parcelRequire("1lAhs");

var $2Og8s = parcelRequire("2Og8s");

var $aW7Gb = parcelRequire("aW7Gb");

var $gr40e = parcelRequire("gr40e");

var $8JKsF = parcelRequire("8JKsF");

var $8qxBf = parcelRequire("8qxBf");

var $dlTNL = parcelRequire("dlTNL");

var $5sP2j = parcelRequire("5sP2j");

var $62Ung = parcelRequire("62Ung");

var $9nuoC = parcelRequire("9nuoC");

var $r7fN6 = parcelRequire("r7fN6");

var $iLhm3 = parcelRequire("iLhm3");

var $gehiq = parcelRequire("gehiq");

var $ifge7 = parcelRequire("ifge7");

var $i8e86 = parcelRequire("i8e86");

var $8feEH = parcelRequire("8feEH");

var $bhi4b = parcelRequire("bhi4b");

var $9u8DQ = parcelRequire("9u8DQ");

var $gD1dS = parcelRequire("gD1dS");

var $4xBxs = parcelRequire("4xBxs");

var $1VOOA = parcelRequire("1VOOA");

var $1yKeQ = parcelRequire("1yKeQ");

var $jGUcb = parcelRequire("jGUcb");

var $28oUY = parcelRequire("28oUY");

var $eahnV = parcelRequire("eahnV");

var $5MZxP = parcelRequire("5MZxP");

var $4Do8T = parcelRequire("4Do8T");

var $cwNui = parcelRequire("cwNui");

var $5TfzT = parcelRequire("5TfzT");

var $3E3zr = parcelRequire("3E3zr");

var $6D3aB = parcelRequire("6D3aB");

var $9iMrt = parcelRequire("9iMrt");

var $g5Npe = parcelRequire("g5Npe");

var $h5wle = parcelRequire("h5wle");

var $kww16 = parcelRequire("kww16");

var $gOgMa = parcelRequire("gOgMa");

var $9qLoy = parcelRequire("9qLoy");

var $3XWb2 = parcelRequire("3XWb2");

var $iseIE = parcelRequire("iseIE");

var $1mZlL = parcelRequire("1mZlL");

var $4QFBe = parcelRequire("4QFBe");

var $eP0pM = parcelRequire("eP0pM");

var $do1MK = parcelRequire("do1MK");

var $1vNdh = parcelRequire("1vNdh");

var $lNcpz = parcelRequire("lNcpz");

var $lc66i = parcelRequire("lc66i");

var $d9lNy = parcelRequire("d9lNy");

var $9mGGG = parcelRequire("9mGGG");

var $bvzmJ = parcelRequire("bvzmJ");

var $j7yUF = parcelRequire("j7yUF");

var $fNXeh = parcelRequire("fNXeh");

var $iC1W9 = parcelRequire("iC1W9");

var $gLBco = parcelRequire("gLBco");

var $5B3nT = parcelRequire("5B3nT");

var $bJQkq = parcelRequire("bJQkq");

var $b37Kr = parcelRequire("b37Kr");

var $8sXeR = parcelRequire("8sXeR");

var $kvpGg = parcelRequire("kvpGg");

var $5Uyxp = parcelRequire("5Uyxp");

var $fhfPl = parcelRequire("fhfPl");

var $eUdR5 = parcelRequire("eUdR5");

var $9y3CH = parcelRequire("9y3CH");

var $5q2Zg = parcelRequire("5q2Zg");

var $cvbcy = parcelRequire("cvbcy");

var $95zUK = parcelRequire("95zUK");

var $kY0nO = parcelRequire("kY0nO");

var $jxjwy = parcelRequire("jxjwy");

var $fiSk4 = parcelRequire("fiSk4");

var $fBxya = parcelRequire("fBxya");

var $9DjTt = parcelRequire("9DjTt");

var $lGdn1 = parcelRequire("lGdn1");

var $gqriC = parcelRequire("gqriC");

var $fRX4k = parcelRequire("fRX4k");

var $wniip = parcelRequire("wniip");

var $iSKul = parcelRequire("iSKul");

var $4s2sX = parcelRequire("4s2sX");

var $lbPf7 = parcelRequire("lbPf7");

var $hkR0n = parcelRequire("hkR0n");

var $fVwnn = parcelRequire("fVwnn");

var $1pSFt = parcelRequire("1pSFt");

var $i3Kce = parcelRequire("i3Kce");

var $ec8bD = parcelRequire("ec8bD");

var $jIDgY = parcelRequire("jIDgY");

var $g4QpC = parcelRequire("g4QpC");

var $gLH3k = parcelRequire("gLH3k");

var $RzdVf = parcelRequire("RzdVf");

var $7WV0q = parcelRequire("7WV0q");

var $9lkzv = parcelRequire("9lkzv");

var $jIHaY = parcelRequire("jIHaY");

var $eW75q = parcelRequire("eW75q");

var $7y8Jw = parcelRequire("7y8Jw");

var $gMT7b = parcelRequire("gMT7b");

var $grKBK = parcelRequire("grKBK");

var $kDeMO = parcelRequire("kDeMO");

var $haXo2 = parcelRequire("haXo2");

var $3mBtj = parcelRequire("3mBtj");

var $3dRh6 = parcelRequire("3dRh6");

var $8waHC = parcelRequire("8waHC");

var $7KCJq = parcelRequire("7KCJq");

var $k1Ozi = parcelRequire("k1Ozi");

var $8ADzE = parcelRequire("8ADzE");

var $9PEYs = parcelRequire("9PEYs");

var $eiMLq = parcelRequire("eiMLq");

var $etmvs = parcelRequire("etmvs");

var $kXkoS = parcelRequire("kXkoS");

var $42FVE = parcelRequire("42FVE");

var $gcdMR = parcelRequire("gcdMR");

var $4tNZf = parcelRequire("4tNZf");

var $jJRIZ = parcelRequire("jJRIZ");

var $4w6Gi = parcelRequire("4w6Gi");

var $jUv2e = parcelRequire("jUv2e");

var $jKUCi = parcelRequire("jKUCi");

var $kyRlD = parcelRequire("kyRlD");

var $1SE8c = parcelRequire("1SE8c");

var $bZaqB = parcelRequire("bZaqB");

var $ig8W0 = parcelRequire("ig8W0");

var $aUqBT = parcelRequire("aUqBT");

var $8GfHK = parcelRequire("8GfHK");

var $4OCYa = parcelRequire("4OCYa");

var $lom3x = parcelRequire("lom3x");

var $DWI8p = parcelRequire("DWI8p");

var $3n8B6 = parcelRequire("3n8B6");

var $aSrgP = parcelRequire("aSrgP");

var $4WibO = parcelRequire("4WibO");

var $ftDW7 = parcelRequire("ftDW7");

var $lDfEo = parcelRequire("lDfEo");

var $fhRdf = parcelRequire("fhRdf");

var $gswiT = parcelRequire("gswiT");

var $1sK56 = parcelRequire("1sK56");

var $ipc44 = parcelRequire("ipc44");

var $6bYuX = parcelRequire("6bYuX");

var $kwMSz = parcelRequire("kwMSz");

var $oGh0c = parcelRequire("oGh0c");

var $4kIb5 = parcelRequire("4kIb5");

var $aL3Tc = parcelRequire("aL3Tc");

var $dcP3m = parcelRequire("dcP3m");

var $enJxP = parcelRequire("enJxP");

var $il8yL = parcelRequire("il8yL");

var $jJ1jq = parcelRequire("jJ1jq");

var $djdi3 = parcelRequire("djdi3");

var $4Vmwx = parcelRequire("4Vmwx");

var $1A7rG = parcelRequire("1A7rG");

var $3t3og = parcelRequire("3t3og");

var $3g4Gf = parcelRequire("3g4Gf");

var $agocD = parcelRequire("agocD");

var $hv4k2 = parcelRequire("hv4k2");

var $hVn6d = parcelRequire("hVn6d");

var $fALN6 = parcelRequire("fALN6");

var $kSqya = parcelRequire("kSqya");

var $khO5h = parcelRequire("khO5h");
const $db0c6716b8253a39$export$e0ccf6166915bd59 = {
    fft: $kY0nO.fft,
    ifft: $jxjwy.ifft,
    rfft: $fBxya.rfft,
    irfft: $fiSk4.irfft
};
const $db0c6716b8253a39$export$e2ef10f86a8d60e8 = {
    hammingWindow: $1SE8c.hammingWindow,
    hannWindow: $bZaqB.hannWindow,
    frame: $ig8W0.frame,
    stft: $aUqBT.stft
};
const $db0c6716b8253a39$export$5c452ff88e35e47d = {
    flipLeftRight: $4OCYa.flipLeftRight,
    grayscaleToRGB: $lom3x.grayscaleToRGB,
    resizeNearestNeighbor: $1sK56.resizeNearestNeighbor,
    resizeBilinear: $gswiT.resizeBilinear,
    rotateWithOffset: $DWI8p.rotateWithOffset,
    cropAndResize: $8GfHK.cropAndResize,
    nonMaxSuppression: $3n8B6.nonMaxSuppression,
    nonMaxSuppressionAsync: $aSrgP.nonMaxSuppressionAsync,
    nonMaxSuppressionWithScore: $4WibO.nonMaxSuppressionWithScore,
    nonMaxSuppressionWithScoreAsync: $ftDW7.nonMaxSuppressionWithScoreAsync,
    nonMaxSuppressionPadded: $lDfEo.nonMaxSuppressionPadded,
    nonMaxSuppressionPaddedAsync: $fhRdf.nonMaxSuppressionPaddedAsync,
    threshold: $ipc44.threshold,
    transform: $6bYuX.transform
};
const $db0c6716b8253a39$export$dbc5be37a4415193 = {
    bandPart: $kwMSz.bandPart,
    gramSchmidt: $oGh0c.gramSchmidt,
    qr: $4kIb5.qr
};
const $db0c6716b8253a39$export$24b113a95118cbdc = {
    absoluteDifference: $aL3Tc.absoluteDifference,
    computeWeightedLoss: $dcP3m.computeWeightedLoss,
    cosineDistance: $enJxP.cosineDistance,
    hingeLoss: $il8yL.hingeLoss,
    huberLoss: $jJ1jq.huberLoss,
    logLoss: $djdi3.logLoss,
    meanSquaredError: $4Vmwx.meanSquaredError,
    sigmoidCrossEntropy: $1A7rG.sigmoidCrossEntropy,
    softmaxCrossEntropy: $3t3og.softmaxCrossEntropy
};
const $db0c6716b8253a39$export$b6b7e189aa5d134c = {
    sparseFillEmptyRows: $3g4Gf.sparseFillEmptyRows,
    sparseReshape: $agocD.sparseReshape,
    sparseSegmentMean: $hv4k2.sparseSegmentMean,
    sparseSegmentSum: $hVn6d.sparseSegmentSum
};
// tslint:disable-next-line:variable-name
const $db0c6716b8253a39$export$22b082955e083ec3 = {
    stringNGrams: $fALN6.stringNGrams,
    stringSplit: $kSqya.stringSplit,
    stringToHashBucketFast: $khO5h.stringToHashBucketFast
};
$parcel$exportWildcard(module.exports, $8ADzE);
$parcel$exportWildcard(module.exports, $9PEYs);
$parcel$exportWildcard(module.exports, $eiMLq);
$parcel$exportWildcard(module.exports, $etmvs);
$parcel$exportWildcard(module.exports, $kXkoS);
$parcel$exportWildcard(module.exports, $42FVE);
$parcel$exportWildcard(module.exports, $gcdMR);
$parcel$exportWildcard(module.exports, $4tNZf);
$parcel$exportWildcard(module.exports, $jJRIZ);
$parcel$exportWildcard(module.exports, $4w6Gi);
$parcel$exportWildcard(module.exports, $jUv2e);

});
parcelRegister("8XlSR", function(module, exports) {

$parcel$export(module.exports, "acos", () => $6854cf136e7576f3$export$fd6306be3fde5b04);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes acos of the input `tf.Tensor` element-wise: `acos(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.acos().print();  // or tf.acos(x)
 * ```
 * @param x The input tensor.
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $6854cf136e7576f3$var$acos_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'acos');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Acos), inputs);
}
const $6854cf136e7576f3$export$fd6306be3fde5b04 = (0, $jKUCi.op)({
    acos_: $6854cf136e7576f3$var$acos_
});

});

parcelRegister("9dYpT", function(module, exports) {

$parcel$export(module.exports, "acosh", () => $6b743170cb295809$export$b26caf0f29211d08);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the inverse hyperbolic cos of the input `tf.Tensor` element-wise:
 * `acosh(x)`
 *
 * ```js
 * const x = tf.tensor1d([10, 1, 3, 5.7]);
 *
 * x.acosh().print();  // or tf.acosh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $6b743170cb295809$var$acosh_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'acosh');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Acosh), inputs);
}
const $6b743170cb295809$export$b26caf0f29211d08 = (0, $jKUCi.op)({
    acosh_: $6b743170cb295809$var$acosh_
});

});

parcelRegister("jXGsE", function(module, exports) {

$parcel$export(module.exports, "addN", () => $e88476e79d7838c7$export$37b75d0026f96b8d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Adds a list of `tf.Tensor`s element-wise, each with the same shape and dtype.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 *
 * tf.addN([a, b, c]).print();
 * ```
 * @param tensors A list of tensors with the same shape and dtype.
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $e88476e79d7838c7$var$addN_(tensors) {
    $4tCOB.assert(Array.isArray(tensors), ()=>'The argument passed to tf.addN() must be a list of tensors');
    $4tCOB.assert(tensors.length >= 1, ()=>`Must pass at least one tensor to tf.addN(), but got ` + `${tensors.length}`);
    const $tensors = tensors.map((t, i)=>(0, $5R1UY.convertToTensor)(t, `tensors${i}`, 'addN'));
    const firstTensor = $tensors[0];
    $tensors.forEach((t)=>{
        if (t.dtype !== firstTensor.dtype) throw new Error('All tensors passed to tf.addN() must have the same dtype');
    });
    $tensors.forEach((t)=>{
        if (!$4tCOB.arraysEqual(t.shape, firstTensor.shape)) throw new Error('All tensors passed to tf.addN() must have the same shape');
    });
    const inputs = $tensors;
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.AddN), inputs);
}
const $e88476e79d7838c7$export$37b75d0026f96b8d = (0, $jKUCi.op)({
    addN_: $e88476e79d7838c7$var$addN_
});

});

parcelRegister("br27u", function(module, exports) {

$parcel$export(module.exports, "all", () => $8533dc4b44e8c887$export$84bf76cd7afc7469);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the logical and of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 1, 1], 'bool');
 *
 * x.all().print();  // or tf.all(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 1, 0, 0], [2, 2], 'bool');
 *
 * const axis = 1;
 * x.all(axis).print();  // or tf.all(x, axis)
 * ```
 *
 * @param x The input tensor. Must be of dtype bool.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $8533dc4b44e8c887$var$all_(x, axis = null, keepDims = false) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'all', 'bool');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.All), inputs, attrs);
}
const $8533dc4b44e8c887$export$84bf76cd7afc7469 = (0, $jKUCi.op)({
    all_: $8533dc4b44e8c887$var$all_
});

});

parcelRegister("joFjq", function(module, exports) {

$parcel$export(module.exports, "any", () => $e1f04dfe785eee73$export$4154a199d7d90455);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the logical or of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 1, 1], 'bool');
 *
 * x.any().print();  // or tf.any(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 1, 0, 0], [2, 2], 'bool');
 *
 * const axis = 1;
 * x.any(axis).print();  // or tf.any(x, axis)
 * ```
 *
 * @param x The input tensor. Must be of dtype bool.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $e1f04dfe785eee73$var$any_(x, axis = null, keepDims = false) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'any', 'bool');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Any), inputs, attrs);
}
const $e1f04dfe785eee73$export$4154a199d7d90455 = (0, $jKUCi.op)({
    any_: $e1f04dfe785eee73$var$any_
});

});

parcelRegister("iFZ6U", function(module, exports) {

$parcel$export(module.exports, "argMax", () => $d98b7590a10d8ccf$export$7980a683c1b852b4);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the indices of the maximum values along an `axis`.
 *
 * The result has the same shape as `input` with the dimension along `axis`
 * removed.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.argMax().print();  // or tf.argMax(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 4, 3], [2, 2]);
 *
 * const axis = 1;
 * x.argMax(axis).print();  // or tf.argMax(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension to reduce. Defaults to 0 (outer-most dimension).
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $d98b7590a10d8ccf$var$argMax_(x, axis = 0) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'argMax');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.ArgMax), inputs, attrs);
}
const $d98b7590a10d8ccf$export$7980a683c1b852b4 = (0, $jKUCi.op)({
    argMax_: $d98b7590a10d8ccf$var$argMax_
});

});

parcelRegister("kXTu8", function(module, exports) {

$parcel$export(module.exports, "argMin", () => $f4345b83be91118e$export$ec99a91cddfb29a2);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the indices of the minimum values along an `axis`.
 *
 * The result has the same shape as `input` with the dimension along `axis`
 * removed.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.argMin().print();  // or tf.argMin(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 4, 3], [2, 2]);
 *
 * const axis = 1;
 * x.argMin(axis).print();  // or tf.argMin(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension to reduce. Defaults to 0 (outer-most dimension).
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $f4345b83be91118e$var$argMin_(x, axis = 0) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'argMin');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.ArgMin), inputs, attrs);
}
const $f4345b83be91118e$export$ec99a91cddfb29a2 = (0, $jKUCi.op)({
    argMin_: $f4345b83be91118e$var$argMin_
});

});

parcelRegister("13fQN", function(module, exports) {

$parcel$export(module.exports, "asin", () => $0c425dda582d9daa$export$41726bdb1fc63f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes asin of the input `tf.Tensor` element-wise: `asin(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.asin().print();  // or tf.asin(x)
 * ```
 * @param x The input tensor.
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $0c425dda582d9daa$var$asin_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'asin');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Asin), inputs);
}
const $0c425dda582d9daa$export$41726bdb1fc63f = (0, $jKUCi.op)({
    asin_: $0c425dda582d9daa$var$asin_
});

});

parcelRegister("4RKl9", function(module, exports) {

$parcel$export(module.exports, "asinh", () => $38b00edf982a27ae$export$839d8a01b6af4fc0);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes inverse hyperbolic sin of the input `tf.Tensor` element-wise:
 * `asinh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.asinh().print();  // or tf.asinh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $38b00edf982a27ae$var$asinh_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'asinh');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Asinh), inputs);
}
const $38b00edf982a27ae$export$839d8a01b6af4fc0 = (0, $jKUCi.op)({
    asinh_: $38b00edf982a27ae$var$asinh_
});

});

parcelRegister("jiLKp", function(module, exports) {

$parcel$export(module.exports, "atan", () => $e0d4bc6d44a6432d$export$628dc4eed22b0fbd);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes atan of the input `tf.Tensor` element-wise: `atan(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.atan().print();  // or tf.atan(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $e0d4bc6d44a6432d$var$atan_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'atan');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Atan), inputs);
}
const $e0d4bc6d44a6432d$export$628dc4eed22b0fbd = (0, $jKUCi.op)({
    atan_: $e0d4bc6d44a6432d$var$atan_
});

});

parcelRegister("f4jET", function(module, exports) {

$parcel$export(module.exports, "atan2", () => $af867a86a581a510$export$b8b770ee6a0d9760);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes arctangent of `tf.Tensor`s a / b element-wise: `atan2(a, b)`.
 * Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1.0, 1.0, -1.0, .7]);
 * const b = tf.tensor1d([2.0, 13.0, 3.5, .21]);
 *
 * tf.atan2(a, b).print()
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $af867a86a581a510$var$atan2_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'atan2');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'atan2');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Atan2), inputs);
}
const $af867a86a581a510$export$b8b770ee6a0d9760 = (0, $jKUCi.op)({
    atan2_: $af867a86a581a510$var$atan2_
});

});

parcelRegister("2HRHM", function(module, exports) {

$parcel$export(module.exports, "atanh", () => $1f8941a1eabfefb3$export$21ea955025ceb08b);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes inverse hyperbolic tan of the input `tf.Tensor` element-wise:
 * `atanh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, .1, -.1, .7]);
 *
 * x.atanh().print();  // or tf.atanh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $1f8941a1eabfefb3$var$atanh_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'atanh');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Atanh), inputs);
}
const $1f8941a1eabfefb3$export$21ea955025ceb08b = (0, $jKUCi.op)({
    atanh_: $1f8941a1eabfefb3$var$atanh_
});

});

parcelRegister("jqmHD", function(module, exports) {

$parcel$export(module.exports, "avgPool", () => $e2420e56719bac23$export$d5c65a2abd3d97dc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $7qWZ5 = parcelRequire("7qWZ5");

var $yLVwv = parcelRequire("yLVwv");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the 2D average pooling of an image.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *         https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $e2420e56719bac23$var$avgPool_(x, filterSize, strides, pad, dimRoundingMode) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'avgPool', 'float32');
    const dilations = 1;
    $4tCOB.assert($yLVwv.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in avgPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $4tCOB.assert(x4D.rank === 4, ()=>`Error in avgPool: x must be rank 4 but got rank ${x4D.rank}.`);
    $yLVwv.checkPadOnDimRoundingMode('avgPool', pad, dimRoundingMode);
    const inputs = {
        x: x4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    let res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.AvgPool), inputs, attrs);
    res = (0, $7qWZ5.cast)(res, $x.dtype);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $e2420e56719bac23$export$d5c65a2abd3d97dc = (0, $jKUCi.op)({
    avgPool_: $e2420e56719bac23$var$avgPool_
});

});
parcelRegister("yLVwv", function(module, exports) {

$parcel$export(module.exports, "computeDilation2DInfo", () => $06885a5a8d168999$export$24e8a5cb688b9852);
$parcel$export(module.exports, "convertConv2DDataFormat", () => $06885a5a8d168999$export$1641c6bb3eb9a5b4);
$parcel$export(module.exports, "computeConv2DInfo", () => $06885a5a8d168999$export$fdd37387e0a3c672);
$parcel$export(module.exports, "computePool2DInfo", () => $06885a5a8d168999$export$67e321f77840205c);
$parcel$export(module.exports, "computePool3DInfo", () => $06885a5a8d168999$export$1382473b2833755b);
$parcel$export(module.exports, "computeConv3DInfo", () => $06885a5a8d168999$export$e4819ceef3994d7b);
$parcel$export(module.exports, "computeDefaultPad", () => $06885a5a8d168999$export$670354fdcb16da70);
$parcel$export(module.exports, "tupleValuesAreOne", () => $06885a5a8d168999$export$f16174446c2d5b2a);
$parcel$export(module.exports, "eitherStridesOrDilationsAreOne", () => $06885a5a8d168999$export$1e13dbff91e2f5ca);
$parcel$export(module.exports, "checkPadOnDimRoundingMode", () => $06885a5a8d168999$export$1b3400c26a44af8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
function $06885a5a8d168999$export$24e8a5cb688b9852(inputShape, filterShape, strides, pad, dataFormat = 'NHWC', dilations) {
    // `computerConv2DInfo` require filterShape to be in the dimension of:
    // `[filterHeight, filterWidth, depth, outDepth]`, dilation2d doesn't have
    // outDepth, it should have the same depth as the input.
    // Input shape: [batch, height, width, inChannels]
    const inputChannels = inputShape[3];
    const $filterShape = [
        ...filterShape,
        inputChannels
    ];
    const $dataFormat = $06885a5a8d168999$export$1641c6bb3eb9a5b4(dataFormat);
    return $06885a5a8d168999$export$fdd37387e0a3c672(inputShape, $filterShape, strides, dilations, pad, null, null, $dataFormat);
}
function $06885a5a8d168999$export$67e321f77840205c(inShape, filterSize, strides, dilations, pad, roundingMode, dataFormat = 'channelsLast') {
    const [filterHeight, filterWidth] = $06885a5a8d168999$var$parseTupleParam(filterSize);
    let filterShape;
    if (dataFormat === 'channelsLast') filterShape = [
        filterHeight,
        filterWidth,
        inShape[3],
        inShape[3]
    ];
    else if (dataFormat === 'channelsFirst') filterShape = [
        filterHeight,
        filterWidth,
        inShape[1],
        inShape[1]
    ];
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    return $06885a5a8d168999$export$fdd37387e0a3c672(inShape, filterShape, strides, dilations, pad, roundingMode, false, dataFormat);
}
function $06885a5a8d168999$export$1382473b2833755b(inShape, filterSize, strides, dilations, pad, roundingMode, dataFormat = 'NDHWC') {
    const [filterDepth, filterHeight, filterWidth] = $06885a5a8d168999$var$parse3TupleParam(filterSize);
    let filterShape;
    let $dataFormat;
    if (dataFormat === 'NDHWC') {
        $dataFormat = 'channelsLast';
        filterShape = [
            filterDepth,
            filterHeight,
            filterWidth,
            inShape[4],
            inShape[4]
        ];
    } else if (dataFormat === 'NCDHW') {
        $dataFormat = 'channelsFirst';
        filterShape = [
            filterDepth,
            filterHeight,
            filterWidth,
            inShape[1],
            inShape[1]
        ];
    } else throw new Error(`Unknown dataFormat ${dataFormat}`);
    return $06885a5a8d168999$export$e4819ceef3994d7b(inShape, filterShape, strides, dilations, pad, false, $dataFormat, roundingMode);
}
function $06885a5a8d168999$export$fdd37387e0a3c672(inShape, filterShape, strides, dilations, pad, roundingMode, depthwise = false, dataFormat = 'channelsLast') {
    let [batchSize, inHeight, inWidth, inChannels] = [
        -1,
        -1,
        -1,
        -1
    ];
    if (dataFormat === 'channelsLast') [batchSize, inHeight, inWidth, inChannels] = inShape;
    else if (dataFormat === 'channelsFirst') [batchSize, inChannels, inHeight, inWidth] = inShape;
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    const [filterHeight, filterWidth, , filterChannels] = filterShape;
    const [strideHeight, strideWidth] = $06885a5a8d168999$var$parseTupleParam(strides);
    const [dilationHeight, dilationWidth] = $06885a5a8d168999$var$parseTupleParam(dilations);
    const effectiveFilterHeight = $06885a5a8d168999$var$getEffectiveFilterSize(filterHeight, dilationHeight);
    const effectiveFilterWidth = $06885a5a8d168999$var$getEffectiveFilterSize(filterWidth, dilationWidth);
    const { padInfo: padInfo, outHeight: outHeight, outWidth: outWidth } = $06885a5a8d168999$var$getPadAndOutInfo(pad, inHeight, inWidth, strideHeight, strideWidth, effectiveFilterHeight, effectiveFilterWidth, roundingMode, dataFormat);
    const outChannels = depthwise ? filterChannels * inChannels : filterChannels;
    let outShape;
    if (dataFormat === 'channelsFirst') outShape = [
        batchSize,
        outChannels,
        outHeight,
        outWidth
    ];
    else if (dataFormat === 'channelsLast') outShape = [
        batchSize,
        outHeight,
        outWidth,
        outChannels
    ];
    return {
        batchSize: batchSize,
        dataFormat: dataFormat,
        inHeight: inHeight,
        inWidth: inWidth,
        inChannels: inChannels,
        outHeight: outHeight,
        outWidth: outWidth,
        outChannels: outChannels,
        padInfo: padInfo,
        strideHeight: strideHeight,
        strideWidth: strideWidth,
        filterHeight: filterHeight,
        filterWidth: filterWidth,
        effectiveFilterHeight: effectiveFilterHeight,
        effectiveFilterWidth: effectiveFilterWidth,
        dilationHeight: dilationHeight,
        dilationWidth: dilationWidth,
        inShape: inShape,
        outShape: outShape,
        filterShape: filterShape
    };
}
function $06885a5a8d168999$export$e4819ceef3994d7b(inShape, filterShape, strides, dilations, pad, depthwise = false, dataFormat = 'channelsLast', roundingMode) {
    let [batchSize, inDepth, inHeight, inWidth, inChannels] = [
        -1,
        -1,
        -1,
        -1,
        -1
    ];
    if (dataFormat === 'channelsLast') [batchSize, inDepth, inHeight, inWidth, inChannels] = inShape;
    else if (dataFormat === 'channelsFirst') [batchSize, inChannels, inDepth, inHeight, inWidth] = inShape;
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    const [filterDepth, filterHeight, filterWidth, , filterChannels] = filterShape;
    const [strideDepth, strideHeight, strideWidth] = $06885a5a8d168999$var$parse3TupleParam(strides);
    const [dilationDepth, dilationHeight, dilationWidth] = $06885a5a8d168999$var$parse3TupleParam(dilations);
    const effectiveFilterDepth = $06885a5a8d168999$var$getEffectiveFilterSize(filterDepth, dilationDepth);
    const effectiveFilterHeight = $06885a5a8d168999$var$getEffectiveFilterSize(filterHeight, dilationHeight);
    const effectiveFilterWidth = $06885a5a8d168999$var$getEffectiveFilterSize(filterWidth, dilationWidth);
    const { padInfo: padInfo, outDepth: outDepth, outHeight: outHeight, outWidth: outWidth } = $06885a5a8d168999$var$get3DPadAndOutInfo(pad, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, effectiveFilterDepth, effectiveFilterHeight, effectiveFilterWidth, roundingMode);
    const outChannels = depthwise ? filterChannels * inChannels : filterChannels;
    let outShape;
    if (dataFormat === 'channelsFirst') outShape = [
        batchSize,
        outChannels,
        outDepth,
        outHeight,
        outWidth
    ];
    else if (dataFormat === 'channelsLast') outShape = [
        batchSize,
        outDepth,
        outHeight,
        outWidth,
        outChannels
    ];
    return {
        batchSize: batchSize,
        dataFormat: dataFormat,
        inDepth: inDepth,
        inHeight: inHeight,
        inWidth: inWidth,
        inChannels: inChannels,
        outDepth: outDepth,
        outHeight: outHeight,
        outWidth: outWidth,
        outChannels: outChannels,
        padInfo: padInfo,
        strideDepth: strideDepth,
        strideHeight: strideHeight,
        strideWidth: strideWidth,
        filterDepth: filterDepth,
        filterHeight: filterHeight,
        filterWidth: filterWidth,
        effectiveFilterDepth: effectiveFilterDepth,
        effectiveFilterHeight: effectiveFilterHeight,
        effectiveFilterWidth: effectiveFilterWidth,
        dilationDepth: dilationDepth,
        dilationHeight: dilationHeight,
        dilationWidth: dilationWidth,
        inShape: inShape,
        outShape: outShape,
        filterShape: filterShape
    };
}
function $06885a5a8d168999$var$computeOutputShape2D(inShape, fieldSize, stride, zeroPad, roundingMode) {
    if (zeroPad == null) zeroPad = $06885a5a8d168999$export$670354fdcb16da70(inShape, fieldSize, stride);
    const inputRows = inShape[0];
    const inputCols = inShape[1];
    const outputRows = $06885a5a8d168999$var$round((inputRows - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    const outputCols = $06885a5a8d168999$var$round((inputCols - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    return [
        outputRows,
        outputCols
    ];
}
function $06885a5a8d168999$var$computeOutputShape4D(inShape, fieldSize, outChannels, stride, zeroPad, roundingMode) {
    if (zeroPad == null) zeroPad = $06885a5a8d168999$export$670354fdcb16da70(inShape, fieldSize, stride);
    const inputDepth = inShape[0];
    const inputRows = inShape[1];
    const inputCols = inShape[2];
    const outputDepths = $06885a5a8d168999$var$round((inputDepth - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    const outputRows = $06885a5a8d168999$var$round((inputRows - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    const outputCols = $06885a5a8d168999$var$round((inputCols - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    return [
        outputDepths,
        outputRows,
        outputCols,
        outChannels
    ];
}
function $06885a5a8d168999$export$670354fdcb16da70(inputShape, fieldSize, stride, dilation = 1) {
    const effectiveFieldSize = $06885a5a8d168999$var$getEffectiveFilterSize(fieldSize, dilation);
    return Math.floor((inputShape[0] * (stride - 1) - stride + effectiveFieldSize) / 2);
}
function $06885a5a8d168999$var$parseTupleParam(param) {
    if (typeof param === 'number') return [
        param,
        param,
        param
    ];
    if (param.length === 2) return [
        param[0],
        param[1],
        1
    ];
    return param;
}
function $06885a5a8d168999$var$parse3TupleParam(param) {
    return typeof param === 'number' ? [
        param,
        param,
        param
    ] : param;
}
/* See https://www.tensorflow.org/api_docs/python/tf/nn/atrous_conv2d
 * Atrous convolution is equivalent to standard convolution with upsampled
 * filters with effective_filter_height =
 * filter_height + (filter_height - 1) * (dilation - 1)
 * and effective_filter_width =
 * filter_width + (filter_width - 1) * (dilation - 1),
 * produced by inserting dilation - 1 zeros along consecutive elements across
 * the filters' spatial dimensions.
 * When there is a dilation, this converts a filter dimension to the
 * effective filter dimension, so it can be used in a standard convolution.
 */ function $06885a5a8d168999$var$getEffectiveFilterSize(filterSize, dilation) {
    if (dilation <= 1) return filterSize;
    return filterSize + (filterSize - 1) * (dilation - 1);
}
function $06885a5a8d168999$var$getPadAndOutInfo(pad, inHeight, inWidth, strideHeight, strideWidth, filterHeight, filterWidth, roundingMode, dataFormat) {
    let padInfo;
    let outHeight;
    let outWidth;
    if (typeof pad === 'number') {
        const padType = pad === 0 ? 'VALID' : 'NUMBER';
        padInfo = {
            top: pad,
            bottom: pad,
            left: pad,
            right: pad,
            type: padType
        };
        const outShape = $06885a5a8d168999$var$computeOutputShape2D([
            inHeight,
            inWidth
        ], filterHeight, strideHeight, pad, roundingMode);
        outHeight = outShape[0];
        outWidth = outShape[1];
    } else if (pad === 'same') {
        outHeight = Math.ceil(inHeight / strideHeight);
        outWidth = Math.ceil(inWidth / strideWidth);
        const padAlongHeight = Math.max(0, (outHeight - 1) * strideHeight + filterHeight - inHeight);
        const padAlongWidth = Math.max(0, (outWidth - 1) * strideWidth + filterWidth - inWidth);
        const top = Math.floor(padAlongHeight / 2);
        const bottom = padAlongHeight - top;
        const left = Math.floor(padAlongWidth / 2);
        const right = padAlongWidth - left;
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            type: 'SAME'
        };
    } else if (pad === 'valid') {
        padInfo = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            type: 'VALID'
        };
        outHeight = Math.ceil((inHeight - filterHeight + 1) / strideHeight);
        outWidth = Math.ceil((inWidth - filterWidth + 1) / strideWidth);
    } else if (typeof pad === 'object') {
        const top = dataFormat === 'channelsLast' ? pad[1][0] : pad[2][0];
        const bottom = dataFormat === 'channelsLast' ? pad[1][1] : pad[2][1];
        const left = dataFormat === 'channelsLast' ? pad[2][0] : pad[3][0];
        const right = dataFormat === 'channelsLast' ? pad[2][1] : pad[3][1];
        const padType = top === 0 && bottom === 0 && left === 0 && right === 0 ? 'VALID' : 'EXPLICIT';
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            type: padType
        };
        outHeight = $06885a5a8d168999$var$round((inHeight - filterHeight + top + bottom) / strideHeight + 1, roundingMode);
        outWidth = $06885a5a8d168999$var$round((inWidth - filterWidth + left + right) / strideWidth + 1, roundingMode);
    } else throw Error(`Unknown padding parameter: ${pad}`);
    return {
        padInfo: padInfo,
        outHeight: outHeight,
        outWidth: outWidth
    };
}
function $06885a5a8d168999$var$get3DPadAndOutInfo(pad, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, filterDepth, filterHeight, filterWidth, roundingMode) {
    let padInfo;
    let outDepth;
    let outHeight;
    let outWidth;
    if (typeof pad === 'number') {
        const padType = pad === 0 ? 'VALID' : 'NUMBER';
        padInfo = {
            top: pad,
            bottom: pad,
            left: pad,
            right: pad,
            front: pad,
            back: pad,
            type: padType
        };
        const outShape = $06885a5a8d168999$var$computeOutputShape4D([
            inDepth,
            inHeight,
            inWidth,
            1
        ], filterDepth, 1, strideDepth, pad, roundingMode);
        outDepth = outShape[0];
        outHeight = outShape[1];
        outWidth = outShape[2];
    } else if (pad === 'same') {
        outDepth = Math.ceil(inDepth / strideDepth);
        outHeight = Math.ceil(inHeight / strideHeight);
        outWidth = Math.ceil(inWidth / strideWidth);
        const padAlongDepth = (outDepth - 1) * strideDepth + filterDepth - inDepth;
        const padAlongHeight = (outHeight - 1) * strideHeight + filterHeight - inHeight;
        const padAlongWidth = (outWidth - 1) * strideWidth + filterWidth - inWidth;
        const front = Math.floor(padAlongDepth / 2);
        const back = padAlongDepth - front;
        const top = Math.floor(padAlongHeight / 2);
        const bottom = padAlongHeight - top;
        const left = Math.floor(padAlongWidth / 2);
        const right = padAlongWidth - left;
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            front: front,
            back: back,
            type: 'SAME'
        };
    } else if (pad === 'valid') {
        padInfo = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            front: 0,
            back: 0,
            type: 'VALID'
        };
        outDepth = Math.ceil((inDepth - filterDepth + 1) / strideDepth);
        outHeight = Math.ceil((inHeight - filterHeight + 1) / strideHeight);
        outWidth = Math.ceil((inWidth - filterWidth + 1) / strideWidth);
    } else throw Error(`Unknown padding parameter: ${pad}`);
    return {
        padInfo: padInfo,
        outDepth: outDepth,
        outHeight: outHeight,
        outWidth: outWidth
    };
}
/**
 * Rounds a value depending on the rounding mode
 * @param value
 * @param roundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $06885a5a8d168999$var$round(value, roundingMode) {
    if (!roundingMode) return Math.trunc(value);
    switch(roundingMode){
        case 'round':
            // used for Caffe Conv
            return Math.round(value);
        case 'ceil':
            // used for Caffe Pool
            return Math.ceil(value);
        case 'floor':
            return Math.floor(value);
        default:
            throw new Error(`Unknown roundingMode ${roundingMode}`);
    }
}
function $06885a5a8d168999$export$f16174446c2d5b2a(param) {
    const [dimA, dimB, dimC] = $06885a5a8d168999$var$parseTupleParam(param);
    return dimA === 1 && dimB === 1 && dimC === 1;
}
function $06885a5a8d168999$export$1e13dbff91e2f5ca(strides, dilations) {
    return $06885a5a8d168999$export$f16174446c2d5b2a(strides) || $06885a5a8d168999$export$f16174446c2d5b2a(dilations);
}
function $06885a5a8d168999$export$1641c6bb3eb9a5b4(dataFormat) {
    if (dataFormat === 'NHWC') return 'channelsLast';
    else if (dataFormat === 'NCHW') return 'channelsFirst';
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
}
function $06885a5a8d168999$export$1b3400c26a44af8(opDesc, pad, dimRoundingMode) {
    if (dimRoundingMode != null) {
        if (typeof pad === 'string') throw Error(`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${pad}.`);
        else if (typeof pad === 'number') $4tCOB.assert($4tCOB.isInt(pad), ()=>`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${pad}.`);
        else if (typeof pad === 'object') pad.forEach((p)=>{
            p.forEach((v)=>{
                $4tCOB.assert($4tCOB.isInt(v), ()=>`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${v}.`);
            });
        });
        else throw Error(`Error in ${opDesc}: Unknown padding parameter: ${pad}`);
    }
}

});

parcelRegister("eP0pM", function(module, exports) {

$parcel$export(module.exports, "reshape", () => $aca626797328575a$export$9eaad88cf88cee2b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Reshapes a `tf.Tensor` to a given shape.
 *
 * Given an input tensor, returns a new tensor with the same values as the
 * input tensor with shape `shape`.
 *
 * If one component of shape is the special value -1, the size of that
 * dimension is computed so that the total size remains constant. In
 * particular, a shape of [-1] flattens into 1-D. At most one component of
 * shape can be -1.
 *
 * If shape is 1-D or higher, then the operation returns a tensor with shape
 * shape filled with the values of tensor. In this case, the number of
 * elements implied by shape must be the same as the number of elements in
 * tensor.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * x.reshape([2, 2]).print();
 * ```
 *
 * @param x The input tensor to be reshaped.
 * @param shape An array of integers defining the output tensor shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $aca626797328575a$var$reshape_(x, shape) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'reshape', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    const attrs = {
        shape: shape
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Reshape), inputs, attrs);
}
const $aca626797328575a$export$9eaad88cf88cee2b = (0, $jKUCi.op)({
    reshape_: $aca626797328575a$var$reshape_
});

});


parcelRegister("iWtLR", function(module, exports) {

$parcel$export(module.exports, "avgPool3d", () => $dca4bcaeec264cb0$export$ee1b0efb53eb29c3);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $yLVwv = parcelRequire("yLVwv");

var $7qWZ5 = parcelRequire("7qWZ5");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the 3D average pooling.
 *
 * ```js
 * const x = tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]);
 * const result = tf.avgPool3d(x, 2, 1, 'valid');
 * result.print();
 * ```
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     `[batch, depth, height, width, inChannels]`.
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     If `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideDepth == strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $dca4bcaeec264cb0$var$avgPool3d_(x, filterSize, strides, pad, dimRoundingMode, dataFormat = 'NDHWC') {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'avgPool3d', 'float32');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $4tCOB.assert(x5D.rank === 5, ()=>`Error in avgPool3d: x must be rank 5 but got rank ${x5D.rank}.`);
    $4tCOB.assert(dataFormat === 'NDHWC', ()=>`Error in avgPool3d: Only NDHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    (0, $yLVwv.checkPadOnDimRoundingMode)('avgPool3d', pad, dimRoundingMode);
    const inputs = {
        x: x5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dataFormat: dataFormat
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    let res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.AvgPool3D), inputs, attrs);
    res = (0, $7qWZ5.cast)(res, x5D.dtype);
    if (reshapedTo5D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $dca4bcaeec264cb0$export$ee1b0efb53eb29c3 = (0, $jKUCi.op)({
    avgPool3d_: $dca4bcaeec264cb0$var$avgPool3d_
});

});

parcelRegister("fxy2h", function(module, exports) {

$parcel$export(module.exports, "basicLSTMCell", () => $b50456e62e5981c1$export$5f13ab10a3272278);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $1ZrG5 = parcelRequire("1ZrG5");

var $6LWfo = parcelRequire("6LWfo");

var $clO9Z = parcelRequire("clO9Z");

var $r7fN6 = parcelRequire("r7fN6");

var $jKUCi = parcelRequire("jKUCi");

var $5B3nT = parcelRequire("5B3nT");

var $kvpGg = parcelRequire("kvpGg");

var $i3Kce = parcelRequire("i3Kce");
/**
 * Computes the next state and output of a BasicLSTMCell.
 *
 * Returns `[newC, newH]`.
 *
 * Derived from tf.contrib.rnn.BasicLSTMCell.
 *
 * @param forgetBias Forget bias for the cell.
 * @param lstmKernel The weights for the cell.
 * @param lstmBias The bias for the cell.
 * @param data The input to the cell.
 * @param c Previous cell state.
 * @param h Previous cell output.
 *
 * @doc {heading: 'Operations', subheading: 'RNN'}
 */ function $b50456e62e5981c1$var$basicLSTMCell_(forgetBias, lstmKernel, lstmBias, data, c, h) {
    const $forgetBias = (0, $5R1UY.convertToTensor)(forgetBias, 'forgetBias', 'basicLSTMCell');
    const $lstmKernel = (0, $5R1UY.convertToTensor)(lstmKernel, 'lstmKernel', 'basicLSTMCell');
    const $lstmBias = (0, $5R1UY.convertToTensor)(lstmBias, 'lstmBias', 'basicLSTMCell');
    const $data = (0, $5R1UY.convertToTensor)(data, 'data', 'basicLSTMCell');
    const $c = (0, $5R1UY.convertToTensor)(c, 'c', 'basicLSTMCell');
    const $h = (0, $5R1UY.convertToTensor)(h, 'h', 'basicLSTMCell');
    const combined = (0, $6LWfo.concat)([
        $data,
        $h
    ], 1);
    const weighted = (0, $clO9Z.matMul)(combined, $lstmKernel);
    const res = (0, $1ZrG5.add)(weighted, $lstmBias);
    // i = input_gate, j = new_input, f = forget_gate, o = output_gate
    const batchSize = res.shape[0];
    const sliceCols = res.shape[1] / 4;
    const sliceSize = [
        batchSize,
        sliceCols
    ];
    const i = (0, $kvpGg.slice)(res, [
        0,
        0
    ], sliceSize);
    const j = (0, $kvpGg.slice)(res, [
        0,
        sliceCols
    ], sliceSize);
    const f = (0, $kvpGg.slice)(res, [
        0,
        sliceCols * 2
    ], sliceSize);
    const o = (0, $kvpGg.slice)(res, [
        0,
        sliceCols * 3
    ], sliceSize);
    const newC = (0, $1ZrG5.add)((0, $r7fN6.mul)((0, $5B3nT.sigmoid)(i), (0, $i3Kce.tanh)(j)), (0, $r7fN6.mul)($c, (0, $5B3nT.sigmoid)((0, $1ZrG5.add)($forgetBias, f))));
    const newH = (0, $r7fN6.mul)((0, $i3Kce.tanh)(newC), (0, $5B3nT.sigmoid)(o));
    return [
        newC,
        newH
    ];
}
const $b50456e62e5981c1$export$5f13ab10a3272278 = (0, $jKUCi.op)({
    basicLSTMCell_: $b50456e62e5981c1$var$basicLSTMCell_
});

});
parcelRegister("6LWfo", function(module, exports) {

$parcel$export(module.exports, "concat", () => $4ee4509447976ef7$export$ee1b3e54f0441b22);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $dnFj7 = parcelRequire("dnFj7");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Concatenates a list of `tf.Tensor`s along a given axis.
 *
 * The tensors ranks and types must match, and their sizes must match in all
 * dimensions except `axis`.
 *
 * Also available are stricter rank-specific methods that assert that
 * `tensors` are of the given rank:
 *   - `tf.concat1d`
 *   - `tf.concat2d`
 *   - `tf.concat3d`
 *   - `tf.concat4d`
 *
 * Except `tf.concat1d` (which does not have axis param), all methods have
 * same signature as this method.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * a.concat(b).print();  // or a.concat(b)
 * ```
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 * tf.concat([a, b, c]).print();
 * ```
 *
 * ```js
 * const a = tf.tensor2d([[1, 2], [10, 20]]);
 * const b = tf.tensor2d([[3, 4], [30, 40]]);
 * const axis = 1;
 * tf.concat([a, b], axis).print();
 * ```
 * @param tensors A list of tensors to concatenate.
 * @param axis The axis to concatenate along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $4ee4509447976ef7$var$concat_(tensors, axis = 0) {
    (0, $4tCOB.assert)(tensors.length >= 1, ()=>'Pass at least one tensor to concat');
    const $tensors = (0, $5R1UY.convertToTensorArray)(tensors, 'tensors', 'concat', 'string_or_numeric');
    if ($tensors[0].dtype === 'complex64') $tensors.forEach((tensor)=>{
        if (tensor.dtype !== 'complex64') throw new Error(`Cannot concatenate complex64 tensors with a tensor
          with dtype ${tensor.dtype}. `);
    });
    if ($tensors.length === 1) return (0, $dnFj7.clone)($tensors[0]);
    const inputs = $tensors;
    const attr = {
        axis: axis
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Concat), inputs, attr);
}
const $4ee4509447976ef7$export$ee1b3e54f0441b22 = (0, $jKUCi.op)({
    concat_: $4ee4509447976ef7$var$concat_
});

});

parcelRegister("5B3nT", function(module, exports) {

$parcel$export(module.exports, "sigmoid", () => $41330888bed781ca$export$3b295495ca3cad7c);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes sigmoid element-wise, `1 / (1 + exp(-x))`
 *
 * ```js
 * const x = tf.tensor1d([0, -1, 2, -3]);
 *
 * x.sigmoid().print();  // or tf.sigmoid(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $41330888bed781ca$var$sigmoid_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'sigmoid', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Sigmoid), inputs);
}
const $41330888bed781ca$export$3b295495ca3cad7c = (0, $jKUCi.op)({
    sigmoid_: $41330888bed781ca$var$sigmoid_
});

});

parcelRegister("kvpGg", function(module, exports) {

$parcel$export(module.exports, "slice", () => $03da3c615163a57f$export$58adb3bec8346d0f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Extracts a slice from a `tf.Tensor` starting at coordinates `begin`
 * and is of size `size`.
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that `x` is of the given rank:
 *   - `tf.slice1d`
 *   - `tf.slice2d`
 *   - `tf.slice3d`
 *   - `tf.slice4d`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.slice([1], [2]).print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * x.slice([1, 0], [1, 2]).print();
 * ```
 * @param x The input `tf.Tensor` to slice from.
 * @param begin The coordinates to start the slice from. The length can be
 *     less than the rank of x - the rest of the axes will have implicit 0 as
 *     start. Can also be a single number, in which case it specifies the
 *     first axis.
 * @param size The size of the slice. The length can be less than the rank of
 *     x - the rest of the axes will have implicit -1. A value of -1 requests
 *     the rest of the dimensions in the axis. Can also be a single number,
 *     in which case it specifies the size of the first axis.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $03da3c615163a57f$var$slice_(x, begin, size) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'slice', 'string_or_numeric');
    if ($x.rank === 0) throw new Error('Slicing scalar is not possible');
    const inputs = {
        x: $x
    };
    const attrs = {
        begin: begin,
        size: size
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Slice), inputs, attrs);
}
const $03da3c615163a57f$export$58adb3bec8346d0f = (0, $jKUCi.op)({
    slice_: $03da3c615163a57f$var$slice_
});

});

parcelRegister("i3Kce", function(module, exports) {

$parcel$export(module.exports, "tanh", () => $d25c5767c86edc2e$export$7128670e45beef9a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes hyperbolic tangent of the input `tf.Tensor` element-wise: `tanh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, 70]);
 *
 * x.tanh().print();  // or tf.tanh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $d25c5767c86edc2e$var$tanh_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'tanh', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Tanh), inputs);
}
const $d25c5767c86edc2e$export$7128670e45beef9a = (0, $jKUCi.op)({
    tanh_: $d25c5767c86edc2e$var$tanh_
});

});


parcelRegister("7J0of", function(module, exports) {

$parcel$export(module.exports, "batchToSpaceND", () => $59fd09daa363d33c$export$ea37d960c1808536);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * This operation reshapes the "batch" dimension 0 into `M + 1` dimensions of
 * shape `blockShape + [batch]`, interleaves these blocks back into the grid
 * defined by the spatial dimensions `[1, ..., M]`, to obtain a result with
 * the same rank as the input. The spatial dimensions of this intermediate
 * result are then optionally cropped according to `crops` to produce the
 * output. This is the reverse of `tf.spaceToBatchND`. See below for a precise
 * description.
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [4, 1, 1, 1]);
 * const blockShape = [2, 2];
 * const crops = [[0, 0], [0, 0]];
 *
 * x.batchToSpaceND(blockShape, crops).print();
 * ```
 *
 * @param x A `tf.Tensor`. N-D with `x.shape` = `[batch] + spatialShape +
 * remainingShape`, where spatialShape has `M` dimensions.
 * @param blockShape A 1-D array. Must have shape `[M]`, all values must
 * be >= 1.
 * @param crops A 2-D array.  Must have shape `[M, 2]`, all values must be >= 0.
 * `crops[i] = [cropStart, cropEnd]` specifies the amount to crop from input
 * dimension `i + 1`, which corresponds to spatial dimension `i`. It is required
 * that `cropStart[i] + cropEnd[i] <= blockShape[i] * inputShape[i + 1]`
 *
 * This operation is equivalent to the following steps:
 *
 * 1. Reshape `x` to `reshaped` of shape: `[blockShape[0], ...,
 * blockShape[M-1], batch / prod(blockShape), x.shape[1], ...,
 * x.shape[N-1]]`
 *
 * 2. Permute dimensions of `reshaped` to produce `permuted` of shape `[batch /
 * prod(blockShape),x.shape[1], blockShape[0], ..., x.shape[M],
 * blockShape[M-1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * 3. Reshape `permuted` to produce `reshapedPermuted` of shape `[batch /
 * prod(blockShape),x.shape[1] * blockShape[0], ..., x.shape[M] *
 * blockShape[M-1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * 4. Crop the start and end of dimensions `[1, ..., M]` of `reshapedPermuted`
 * according to `crops` to produce the output of shape: `[batch /
 * prod(blockShape),x.shape[1] * blockShape[0] - crops[0,0] - crops[0,1],
 * ..., x.shape[M] * blockShape[M-1] - crops[M-1,0] -
 * crops[M-1,1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $59fd09daa363d33c$var$batchToSpaceND_(x, blockShape, crops) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'batchToSpaceND');
    const prod = blockShape.reduce((a, b)=>a * b);
    $4tCOB.assert($x.rank >= 1 + blockShape.length, ()=>`input rank is ${$x.rank} but should be > than blockShape.length ${blockShape.length}`);
    $4tCOB.assert(crops.length === blockShape.length, ()=>`crops.length is ${crops.length} but should be equal to blockShape.length  ${blockShape.length}`);
    $4tCOB.assert($x.shape[0] % prod === 0, ()=>`input tensor batch is ${$x.shape[0]} but is not divisible by the product of ` + `the elements of blockShape ${blockShape.join(' * ')} === ${prod}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockShape: blockShape,
        crops: crops
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.BatchToSpaceND), inputs, attrs);
}
const $59fd09daa363d33c$export$ea37d960c1808536 = (0, $jKUCi.op)({
    batchToSpaceND_: $59fd09daa363d33c$var$batchToSpaceND_
});

});

parcelRegister("vnJKw", function(module, exports) {

$parcel$export(module.exports, "batchNorm", () => $05e54f0499252986$export$8ea8088e6d0cdd02);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $7ZvCP = parcelRequire("7ZvCP");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Batch normalization.
 *
 * As described in
 * [http://arxiv.org/abs/1502.03167](http://arxiv.org/abs/1502.03167).
 *
 * Mean, variance, scale, and offset can be of two shapes:
 *   - The same shape as the input.
 *   - In the common case, the depth dimension is the last dimension of x, so
 *     the values would be a `tf.Tensor1D` of shape [depth].
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that parameters passed are of given rank
 *   - `tf.batchNorm2d`
 *   - `tf.batchNorm3d`
 *   - `tf.batchNorm4d`
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $05e54f0499252986$var$batchNorm_(x, mean, variance, offset, scale, varianceEpsilon) {
    if (varianceEpsilon == null) varianceEpsilon = 0.001;
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'batchNorm');
    const $mean = (0, $5R1UY.convertToTensor)(mean, 'mean', 'batchNorm');
    const $variance = (0, $5R1UY.convertToTensor)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $5R1UY.convertToTensor)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $5R1UY.convertToTensor)(offset, 'offset', 'batchNorm');
    $4tCOB.assert($mean.rank === $variance.rank, ()=>"Batch normalization gradient requires mean and variance to have equal ranks.");
    $4tCOB.assert($offset == null || $mean.rank === $offset.rank, ()=>"Batch normalization gradient requires mean and offset to have equal ranks.");
    $4tCOB.assert($scale == null || $mean.rank === $scale.rank, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    const x4D = (0, $7ZvCP.xAs4D)($x);
    const inputs = {
        x: x4D,
        scale: $scale,
        offset: $offset,
        mean: $mean,
        variance: $variance
    };
    const attrs = {
        varianceEpsilon: varianceEpsilon
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.FusedBatchNorm), inputs, attrs);
    return (0, $eP0pM.reshape)(res, $x.shape);
}
const $05e54f0499252986$export$8ea8088e6d0cdd02 = (0, $jKUCi.op)({
    batchNorm_: $05e54f0499252986$var$batchNorm_
});

});
parcelRegister("7ZvCP", function(module, exports) {

$parcel$export(module.exports, "xAs4D", () => $5d16c30afc4e0664$export$b76c765a8a7b5836);

var $eP0pM = parcelRequire("eP0pM");
function $5d16c30afc4e0664$export$b76c765a8a7b5836(x) {
    let x4D;
    if (x.rank === 0 || x.rank === 1) x4D = (0, $eP0pM.reshape)(x, [
        1,
        1,
        1,
        x.size
    ]);
    else if (x.rank === 2) x4D = (0, $eP0pM.reshape)(x, [
        1,
        1,
        x.shape[0],
        x.shape[1]
    ]);
    else if (x.rank === 3) x4D = (0, $eP0pM.reshape)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    else x4D = x;
    return x4D;
}

});


parcelRegister("NUhQF", function(module, exports) {

$parcel$export(module.exports, "batchNorm2d", () => $09603d1e84bfc5bb$export$4104d1fc5afa918a);

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $vnJKw = parcelRequire("vnJKw");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Batch normalization, strictly for 2D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $09603d1e84bfc5bb$var$batchNorm2d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'batchNorm');
    const $mean = (0, $5R1UY.convertToTensor)(mean, 'mean', 'batchNorm');
    const $variance = (0, $5R1UY.convertToTensor)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $5R1UY.convertToTensor)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $5R1UY.convertToTensor)(offset, 'offset', 'batchNorm');
    $4tCOB.assert($x.rank === 2, ()=>`Error in batchNorm2D: x must be rank 2 but got rank ` + `${$x.rank}.`);
    $4tCOB.assert($mean.rank === 2 || $mean.rank === 1, ()=>`Error in batchNorm2D: mean must be rank 2 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $4tCOB.assert($variance.rank === 2 || $variance.rank === 1, ()=>`Error in batchNorm2D: variance must be rank 2 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $4tCOB.assert($scale.rank === 2 || $scale.rank === 1, ()=>`Error in batchNorm2D: scale must be rank 2 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $4tCOB.assert($offset.rank === 2 || $offset.rank === 1, ()=>`Error in batchNorm2D: offset must be rank 2 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $vnJKw.batchNorm)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $09603d1e84bfc5bb$export$4104d1fc5afa918a = (0, $jKUCi.op)({
    batchNorm2d_: $09603d1e84bfc5bb$var$batchNorm2d_
});

});

parcelRegister("fACaf", function(module, exports) {

$parcel$export(module.exports, "batchNorm3d", () => $b597d27505af2779$export$76211212fb57f1fa);

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $vnJKw = parcelRequire("vnJKw");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Batch normalization, strictly for 3D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $b597d27505af2779$var$batchNorm3d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'batchNorm');
    const $mean = (0, $5R1UY.convertToTensor)(mean, 'mean', 'batchNorm');
    const $variance = (0, $5R1UY.convertToTensor)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $5R1UY.convertToTensor)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $5R1UY.convertToTensor)(offset, 'offset', 'batchNorm');
    $4tCOB.assert($x.rank === 3, ()=>`Error in batchNorm3D: x must be rank 3 but got rank ` + `${$x.rank}.`);
    $4tCOB.assert($mean.rank === 3 || $mean.rank === 1, ()=>`Error in batchNorm3D: mean must be rank 3 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $4tCOB.assert($variance.rank === 3 || $variance.rank === 1, ()=>`Error in batchNorm3D: variance must be rank 3 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $4tCOB.assert($scale.rank === 3 || $scale.rank === 1, ()=>`Error in batchNorm3D: scale must be rank 3 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $4tCOB.assert($offset.rank === 3 || $offset.rank === 1, ()=>`Error in batchNorm3D: offset must be rank 3 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $vnJKw.batchNorm)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $b597d27505af2779$export$76211212fb57f1fa = (0, $jKUCi.op)({
    batchNorm3d_: $b597d27505af2779$var$batchNorm3d_
});

});

parcelRegister("f6vw7", function(module, exports) {

$parcel$export(module.exports, "batchNorm4d", () => $afefdd2f2adce4fe$export$4573a348ef14e569);

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $vnJKw = parcelRequire("vnJKw");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Batch normalization, strictly for 4D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $afefdd2f2adce4fe$var$batchNorm4d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'batchNorm');
    const $mean = (0, $5R1UY.convertToTensor)(mean, 'mean', 'batchNorm');
    const $variance = (0, $5R1UY.convertToTensor)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $5R1UY.convertToTensor)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $5R1UY.convertToTensor)(offset, 'offset', 'batchNorm');
    $4tCOB.assert($x.rank === 4, ()=>`Error in batchNorm4D: x must be rank 4 but got rank ` + `${$x.rank}.`);
    $4tCOB.assert($mean.rank === 4 || $mean.rank === 1, ()=>`Error in batchNorm4D: mean must be rank 4 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $4tCOB.assert($variance.rank === 4 || $variance.rank === 1, ()=>`Error in batchNorm4D: variance must be rank 4 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $4tCOB.assert($scale.rank === 4 || $scale.rank === 1, ()=>`Error in batchNorm4D: scale must be rank 4 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $4tCOB.assert($offset.rank === 4 || $offset.rank === 1, ()=>`Error in batchNorm4D: offset must be rank 4 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $vnJKw.batchNorm)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $afefdd2f2adce4fe$export$4573a348ef14e569 = (0, $jKUCi.op)({
    batchNorm4d_: $afefdd2f2adce4fe$var$batchNorm4d_
});

});

parcelRegister("5sha3", function(module, exports) {

$parcel$export(module.exports, "bincount", () => $3f8ce125071672e2$export$7e474bab088ed182);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Outputs a vector with length `size` and the same dtype as `weights`.
 *
 * If `weights` are empty, then index `i` stores the number of times the value
 * `i` is counted in `x`. If `weights` are non-empty, then index `i` stores the
 * sum of the value in `weights` at each index where the corresponding value in
 * `x` is `i`.
 *
 * Values in `x` outside of the range [0, size) are ignored.
 *
 * @param x The input int tensor, rank 1.
 * @param weights The weights tensor, must have the same shape as x, or a
 *     length-0 Tensor, in which case it acts as all weights equal to 1.
 * @param size Non-negative integer.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $3f8ce125071672e2$var$bincount_(x, weights, size) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'bincount');
    const $weights = (0, $5R1UY.convertToTensor)(weights, 'weights', 'bincount');
    $4tCOB.assert($x.dtype === 'int32', ()=>`Error in bincount: input ` + `dtype must be int32, but got ${$x.dtype}`);
    $4tCOB.assert(size >= 0, ()=>`size must be non-negative, but got ${size}.`);
    $4tCOB.assert($weights.size === $x.size || $weights.size === 0, ()=>`Error in bincount: weights must have the same size as input or` + `0-length, but got input shape: ${$x.shape}, weights shape: ` + `${$weights.shape}.`);
    const inputs = {
        x: $x,
        weights: $weights
    };
    const attrs = {
        size: size
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Bincount), inputs, attrs);
}
const $3f8ce125071672e2$export$7e474bab088ed182 = (0, $jKUCi.op)({
    bincount_: $3f8ce125071672e2$var$bincount_
});

});

parcelRegister("cTB2y", function(module, exports) {

$parcel$export(module.exports, "broadcastArgs", () => $96375a7d331feaf3$export$d226d344aedce941);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Return the shape of s0 op s1 with broadcast.
 *
 * compute r0, the broadcasted shape as a tensor.
 * s0, s1 and r0 are all integer vectors.
 *
 * This function returns the shape of the result of an operation between
 * two tensors of size s0 and s1 performed with broadcast.
 *
 * @param s0 A tensor representing a shape
 * @param s1 A tensor representing a shape
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $96375a7d331feaf3$var$broadcastArgs_(s0, s1) {
    const shape1Input = (0, $5R1UY.convertToTensor)(s0, 's0', 'broadcastArgs', 'int32');
    const shape2Input = (0, $5R1UY.convertToTensor)(s1, 's1', 'broadcastArgs', 'int32');
    if (shape1Input.rank !== 1) throw new Error('broadcastArgs(): first input must be a vector (rank=1). ' + `Has rank ${shape1Input.rank}`);
    if (shape2Input.rank !== 1) throw new Error('broadcastArgs(): second input must be a vector (rank=1). ' + `Has rank ${shape2Input.rank}`);
    const inputs = {
        s0: shape1Input,
        s1: shape2Input
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.BroadcastArgs), inputs);
}
const $96375a7d331feaf3$export$d226d344aedce941 = (0, $jKUCi.op)({
    broadcastArgs_: $96375a7d331feaf3$var$broadcastArgs_
});

});

parcelRegister("eJSTd", function(module, exports) {

$parcel$export(module.exports, "broadcastTo", () => $abafd89024e07ceb$export$ec9086aff2624eab);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $dnFj7 = parcelRequire("dnFj7");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Broadcast an array to a compatible shape NumPy-style.
 *
 * The tensor's shape is compared to the broadcast shape from end to beginning.
 * Ones are prepended to the tensor's shape until it has the same length as
 * the broadcast shape. If input.shape[i]==shape[i], the (i+1)-th axis is
 * already broadcast-compatible. If input.shape[i]==1 and shape[i]==N, then
 * the input tensor is tiled N times along that axis (using tf.tile).
 *
 * @param input The tensor that is to be broadcasted.
 * @param shape The input is to be broadcast to this shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $abafd89024e07ceb$var$broadcastTo_(x, shape) {
    let input = (0, $5R1UY.convertToTensor)(x, 'broadcastTo', 'x');
    const xShape = input.shape;
    if (shape.some((d)=>!(d > 0) || d % 1 !== 0)) throw new Error(`broadcastTo(): Invalid broadcast shape [${shape}].`);
    if (shape.length < input.rank) throw new Error(`broadcastTo(): shape.length=${shape.length} < input.rank=${input.rank}.`);
    if (shape.length > input.rank) {
        const newShape = input.shape.slice();
        while(newShape.length < shape.length)newShape.unshift(1);
        input = (0, $eP0pM.reshape)(input, newShape);
    }
    const inputShape = input.shape;
    const reps = Array.from(shape);
    for(let i = shape.length - 1; i >= 0; i--){
        if (inputShape[i] === shape[i]) reps[i] = 1;
        else if (input.shape[i] !== 1) throw new Error(`broadcastTo(): [${xShape}] cannot be broadcast to [${shape}].`);
    }
    const axes = reps.map((n, i)=>n > 1 ? i : -1).filter((i)=>i >= 0);
    if (axes.length === 0) return (0, $dnFj7.clone)(input);
    // TODO call broadcastTo kernel directly once backends implement broadcstTo
    const inputs = {
        x: input
    };
    const attrs = {
        reps: reps
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Tile), inputs, attrs);
}
const $abafd89024e07ceb$export$ec9086aff2624eab = (0, $jKUCi.op)({
    broadcastTo_: $abafd89024e07ceb$var$broadcastTo_
});

});

parcelRegister("hoXwH", function(module, exports) {

$parcel$export(module.exports, "ceil", () => $cab2da47a65c15b3$export$803ce6b71a0a94b2);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes ceiling of input `tf.Tensor` element-wise: `ceil(x)`
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.ceil().print();  // or tf.ceil(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $cab2da47a65c15b3$var$ceil_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'ceil', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Ceil), inputs);
}
const $cab2da47a65c15b3$export$803ce6b71a0a94b2 = (0, $jKUCi.op)({
    ceil_: $cab2da47a65c15b3$var$ceil_
});

});

parcelRegister("jU3Ej", function(module, exports) {

$parcel$export(module.exports, "clipByValue", () => $e7d613ef74d02d76$export$fa97baf70ad024c0);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $3kNX7 = parcelRequire("3kNX7");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Clips values element-wise. `max(min(x, clipValueMax), clipValueMin)`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.clipByValue(-2, 3).print();  // or tf.clipByValue(x, -2, 3)
 * ```
 * @param x The input tensor.
 * @param clipValueMin Lower bound of range to be clipped to.
 * @param clipValueMax Upper bound of range to be clipped to.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $e7d613ef74d02d76$var$clipByValue_(x, clipValueMin, clipValueMax) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'clipByValue');
    $4tCOB.assert(clipValueMin <= clipValueMax, ()=>`Error in clip: min (${clipValueMin}) must be ` + `less than or equal to max (${clipValueMax}).`);
    if (clipValueMin === clipValueMax) return (0, $3kNX7.fill)($x.shape, clipValueMin, $x.dtype);
    const inputs = {
        x: $x
    };
    const attrs = {
        clipValueMin: clipValueMin,
        clipValueMax: clipValueMax
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.ClipByValue), inputs, attrs);
}
const $e7d613ef74d02d76$export$fa97baf70ad024c0 = (0, $jKUCi.op)({
    clipByValue_: $e7d613ef74d02d76$var$clipByValue_
});

});

parcelRegister("ayCnc", function(module, exports) {

$parcel$export(module.exports, "concat1d", () => $7afad87c503d97ba$export$1e0bfb2ad280a475);

var $6LWfo = parcelRequire("6LWfo");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Concatenates a list of`tf.Tensor1D`s along an axis. See `concat` for details.
 *
 * For example, if:
 * A: shape(3) = |r1, g1, b1|
 * B: shape(2) = |r2, g2|
 * C = tf.concat1d([A, B]) == |r1, g1, b1, r2, g2|
 *
 * @param tensors A list of`tf.Tensor`s to concatenate.
 * @return The concatenated array.
 */ function $7afad87c503d97ba$var$concat1d_(tensors) {
    return (0, $6LWfo.concat)(tensors, 0 /* axis */ );
}
const $7afad87c503d97ba$export$1e0bfb2ad280a475 = (0, $jKUCi.op)({
    concat1d_: $7afad87c503d97ba$var$concat1d_
});

});

parcelRegister("iy8jW", function(module, exports) {

$parcel$export(module.exports, "concat2d", () => $d811db4240a5a65f$export$ba044983349051fd);

var $6LWfo = parcelRequire("6LWfo");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Concatenates a list of`tf.Tensor2D`s along an axis. See `concat` for details.
 *
 * For example, if:
 * A: shape(2, 3) = | r1, g1, b1 |
 *                  | r2, g2, b2 |
 *
 * B: shape(2, 3) = | r3, g3, b3 |
 *                  | r4, g4, b4 |
 *
 * C = tf.concat2d([A, B], axis)
 *
 * if axis = 0:
 * C: shape(4, 3) = | r1, g1, b1 |
 *                  | r2, g2, b2 |
 *                  | r3, g3, b3 |
 *                  | r4, g4, b4 |
 *
 * if axis = 1:
 * C = shape(2, 6) = | r1, g1, b1, r3, g3, b3 |
 *                   | r2, g2, b2, r4, g4, b4 |
 *
 *
 * @param tensors A list of `tf.Tensor`s to concatenate.
 * @param axis The axis to concatenate along.
 * @return The concatenated array.
 */ function $d811db4240a5a65f$var$concat2d_(tensors, axis) {
    return (0, $6LWfo.concat)(tensors, axis);
}
const $d811db4240a5a65f$export$ba044983349051fd = (0, $jKUCi.op)({
    concat2d_: $d811db4240a5a65f$var$concat2d_
});

});

parcelRegister("3pVmi", function(module, exports) {

$parcel$export(module.exports, "concat3d", () => $27d033213db5706a$export$23e0f187dd67babf);

var $6LWfo = parcelRequire("6LWfo");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Concatenates a list of `tf.Tensor3D`s along an axis.
 * See `concat` for details.
 *
 * For example, if:
 * A: shape(2, 1, 3) = | r1, g1, b1 |
 *                     | r2, g2, b2 |
 *
 * B: shape(2, 1, 3) = | r3, g3, b3 |
 *                     | r4, g4, b4 |
 *
 * C = tf.concat3d([A, B], axis)
 *
 * if axis = 0:
 * C: shape(4, 1, 3) = | r1, g1, b1 |
 *                     | r2, g2, b2 |
 *                     | r3, g3, b3 |
 *                     | r4, g4, b4 |
 *
 * if axis = 1:
 * C: shape(2, 2, 3) = | r1, g1, b1, r3, g3, b3 |
 *                     | r2, g2, b2, r4, g4, b4 |
 *
 * if axis = 2:
 * C = shape(2, 1, 6) = | r1, g1, b1, r3, g3, b3 |
 *                      | r2, g2, b2, r4, g4, b4 |
 *
 * @param tensors A list of`tf.Tensor`s to concatenate.
 * @param axis The axis to concate along.
 * @return The concatenated array.
 */ function $27d033213db5706a$var$concat3d_(tensors, axis) {
    return (0, $6LWfo.concat)(tensors, axis);
}
const $27d033213db5706a$export$23e0f187dd67babf = (0, $jKUCi.op)({
    concat3d_: $27d033213db5706a$var$concat3d_
});

});

parcelRegister("cM6MZ", function(module, exports) {

$parcel$export(module.exports, "concat4d", () => $94cf3befaa5a0046$export$731e01cced6c0a23);

var $6LWfo = parcelRequire("6LWfo");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Concatenates a list of `tf.Tensor4D`s along an axis.
 * See `concat` for details.
 *
 * @param tensors A list of `tf.Tensor`s to concatenate.
 * @param axis The axis to concate along.
 * @return The concatenated array.
 */ function $94cf3befaa5a0046$var$concat4d_(tensors, axis) {
    return (0, $6LWfo.concat)(tensors, axis);
}
const $94cf3befaa5a0046$export$731e01cced6c0a23 = (0, $jKUCi.op)({
    concat4d_: $94cf3befaa5a0046$var$concat4d_
});

});

parcelRegister("a6dzP", function(module, exports) {

$parcel$export(module.exports, "conv1d", () => $75a4ff020c42f3e8$export$d8aa844fa36b350e);

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jOBWR = parcelRequire("jOBWR");

var $yLVwv = parcelRequire("yLVwv");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes a 1D convolution over the input x.
 *
 * @param x The input tensor, of rank 3 or rank 2, of shape
 *     `[batch, width, inChannels]`. If rank 2, batch of 1 is assumed.
 * @param filter The filter, rank 3, of shape
 *     `[filterWidth, inDepth, outDepth]`.
 * @param stride The number of entries by which the filter is moved right at
 *     each step.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat An optional string from "NWC", "NCW". Defaults to "NWC",
 *     the data is stored in the order of [batch, in_width, in_channels]. Only
 *     "NWC" is currently supported.
 * @param dilation The dilation rate in which we sample input values in
 *     atrous convolution. Defaults to `1`. If it is greater than 1, then
 *     stride must be `1`.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $75a4ff020c42f3e8$var$conv1d_(x, filter, stride, pad, dataFormat = 'NWC', dilation = 1, dimRoundingMode) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'conv1d');
    const $filter = (0, $5R1UY.convertToTensor)(filter, 'filter', 'conv1d');
    let x3D = $x;
    let reshapedTo3D = false;
    if ($x.rank === 2) {
        reshapedTo3D = true;
        x3D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1]
        ]);
    }
    $4tCOB.assert(x3D.rank === 3, ()=>`Error in conv1d: input must be rank 3, but got rank ${x3D.rank}.`);
    $4tCOB.assert($filter.rank === 3, ()=>`Error in conv1d: filter must be rank 3, but got rank ` + `${$filter.rank}.`);
    $yLVwv.checkPadOnDimRoundingMode('conv1d', pad, dimRoundingMode);
    $4tCOB.assert(x3D.shape[2] === $filter.shape[1], ()=>`Error in conv1d: depth of input (${x3D.shape[2]}) must match ` + `input depth for filter ${$filter.shape[1]}.`);
    $4tCOB.assert($yLVwv.eitherStridesOrDilationsAreOne(stride, dilation), ()=>'Error in conv1D: Either stride or dilation must be 1. ' + `Got stride ${stride} and dilation '${dilation}'`);
    $4tCOB.assert(dataFormat === 'NWC', ()=>`Error in conv1d: got dataFormat of ${dataFormat} but only NWC is currently supported.`);
    const filter4D = (0, $eP0pM.reshape)($filter, [
        1,
        $filter.shape[0],
        $filter.shape[1],
        $filter.shape[2]
    ]);
    const input4D = (0, $eP0pM.reshape)(x3D, [
        x3D.shape[0],
        1,
        x3D.shape[1],
        x3D.shape[2]
    ]);
    const strides = [
        1,
        stride
    ];
    const dilations = [
        1,
        dilation
    ];
    const conv2dDataFormat = 'NHWC';
    const res = (0, $jOBWR.conv2d)(input4D, filter4D, strides, pad, conv2dDataFormat, dilations, dimRoundingMode);
    if (reshapedTo3D) return (0, $eP0pM.reshape)(res, [
        res.shape[2],
        res.shape[3]
    ]);
    return (0, $eP0pM.reshape)(res, [
        res.shape[0],
        res.shape[2],
        res.shape[3]
    ]);
}
const $75a4ff020c42f3e8$export$d8aa844fa36b350e = (0, $jKUCi.op)({
    conv1d_: $75a4ff020c42f3e8$var$conv1d_
});

});
parcelRegister("jOBWR", function(module, exports) {

$parcel$export(module.exports, "conv2d", () => $e6d01f9c9f1bf352$export$188f9215482e3db8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $yLVwv = parcelRequire("yLVwv");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes a 2D convolution over the input x.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $e6d01f9c9f1bf352$var$conv2d_(x, filter, strides, pad, dataFormat = 'NHWC', dilations = [
    1,
    1
], dimRoundingMode) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'conv2d', 'float32');
    const $filter = (0, $5R1UY.convertToTensor)(filter, 'filter', 'conv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $4tCOB.assert(x4D.rank === 4, ()=>`Error in conv2d: input must be rank 4, but got rank ${x4D.rank}.`);
    $4tCOB.assert($filter.rank === 4, ()=>`Error in conv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    $yLVwv.checkPadOnDimRoundingMode('conv2d', pad, dimRoundingMode);
    const inDepth = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $4tCOB.assert(inDepth === $filter.shape[2], ()=>`Error in conv2d: depth of input (${inDepth}) must match ` + `input depth for filter ${$filter.shape[2]}.`);
    $4tCOB.assert($yLVwv.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in conv2D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Conv2D), inputs, attrs);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $e6d01f9c9f1bf352$export$188f9215482e3db8 = (0, $jKUCi.op)({
    conv2d_: $e6d01f9c9f1bf352$var$conv2d_
});

});


parcelRegister("cKiMT", function(module, exports) {

$parcel$export(module.exports, "conv2dTranspose", () => $94785ab7aa9160cd$export$d5e924cbc07fb966);

var $5R1UY = parcelRequire("5R1UY");

var $f0966 = parcelRequire("f0966");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the transposed 2D convolution of an image, also known as a
 * deconvolution.
 *
 * @param x The input image, of rank 4 or rank 3, of shape
 *   `[batch, height, width, inDepth]`. If rank 3, batch of 1 is assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, outDepth, inDepth]`.
 *     `inDepth` must match `inDepth` in `x`.
 * @param outputShape Output shape, of rank 4 or rank 3:
 *     `[batch, height, width, outDepth]`. If rank 3, batch of 1 is assumed.
 * @param strides The strides of the original convolution:
 *     `[strideHeight, strideWidth]`.
 * @param pad  The type of padding algorithm used in the non-transpose version
 *    of the op.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $94785ab7aa9160cd$var$conv2dTranspose_(x, filter, outputShape, strides, pad, dimRoundingMode) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'conv2dTranspose');
    const $filter = (0, $5R1UY.convertToTensor)(filter, 'filter', 'conv2dTranspose');
    return (0, $f0966.conv2DBackpropInput)(outputShape, $x, $filter, strides, pad, 'NHWC', dimRoundingMode);
}
const $94785ab7aa9160cd$export$d5e924cbc07fb966 = (0, $jKUCi.op)({
    conv2dTranspose_: $94785ab7aa9160cd$var$conv2dTranspose_
});

});
parcelRegister("f0966", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropInput", () => $aebde9abbbc23b1d$export$633310eed0c26e72);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $4tCOB = parcelRequire("4tCOB");

var $yLVwv = parcelRequire("yLVwv");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the derivative of the input of a 2D convolution.
 *
 * @param xShape The shape of the input: [batch, height, width, inDepth].
 * If length of 3, batch of 1 is assumed.
 * @param dy The derivative of the output, of rank 4 or rank 3 of shape
 *   `[batch, outHeight, outWidth, outDepth]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm used:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $aebde9abbbc23b1d$var$conv2DBackpropInput_(xShape, dy, filter, strides, pad, dataFormat = 'NHWC', dimRoundingMode) {
    $4tCOB.assert(xShape.length === dy.rank, ()=>`Length of inShape ` + `(${xShape.length}) and rank of dy (${dy.rank}) must match`);
    let xShape4D = xShape;
    let dy4D = dy;
    let reshapedTo4D = false;
    if (dy.rank === 3) {
        reshapedTo4D = true;
        dy4D = (0, $eP0pM.reshape)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2]
        ]);
        xShape4D = [
            1,
            xShape[0],
            xShape[1],
            xShape[2]
        ];
    }
    $4tCOB.assert(xShape4D.length === 4, ()=>`Error in conv2dDerInput: inShape must be length 4, but got length ` + `${xShape4D.length}.`);
    $4tCOB.assert(dy4D.rank === 4, ()=>`Error in conv2dDerInput: dy must be rank 4, but got ` + `rank ${dy4D.rank}`);
    $4tCOB.assert(filter.rank === 4, ()=>`Error in conv2dDerInput: filter must be rank 4, but got ` + `rank ${filter.rank}`);
    const inDepth = dataFormat === 'NHWC' ? xShape4D[3] : xShape4D[1];
    const outDepth = dataFormat === 'NHWC' ? dy4D.shape[3] : dy4D.shape[1];
    $4tCOB.assert(inDepth === filter.shape[2], ()=>`Error in conv2dDerInput: depth of input (${inDepth}) must ` + `match input depth for filter ${filter.shape[2]}.`);
    $4tCOB.assert(outDepth === filter.shape[3], ()=>`Error in conv2dDerInput: depth of output (${outDepth}) must ` + `match output depth for filter ${filter.shape[3]}.`);
    $yLVwv.checkPadOnDimRoundingMode('conv2dDerInput', pad, dimRoundingMode);
    const inputs = {
        dy: dy4D,
        filter: filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dimRoundingMode: dimRoundingMode,
        inputShape: xShape4D
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Conv2DBackpropInput), inputs, attrs);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $aebde9abbbc23b1d$export$633310eed0c26e72 = (0, $jKUCi.op)({
    conv2DBackpropInput_: $aebde9abbbc23b1d$var$conv2DBackpropInput_
});

});


parcelRegister("7V1iv", function(module, exports) {

$parcel$export(module.exports, "conv3d", () => $017ce287e08f8570$export$c476b02bcf7b2def);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $yLVwv = parcelRequire("yLVwv");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes a 3D convolution over the input x.
 *
 * @param x The input tensor, of rank 5 or rank 4, of shape
 *     `[batch, depth, height, width, channels]`. If rank 4,
 * batch of 1 is assumed.
 * @param filter The filter, rank 5, of shape
 *     `[filterDepth, filterHeight, filterWidth, inChannels, outChannels]`.
 *      inChannels must match between input and filter.
 * @param strides The strides of the convolution: `[strideDepth, strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat: An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @param dilations The dilation rates: `[dilationDepth, dilationHeight,
 *     dilationWidth]` in which we sample input values across the height
 *     and width dimensions in atrous convolution. Defaults to `[1, 1, 1]`.
 *     If `dilations` is a single number, then
 *     `dilationDepth == dilationHeight == dilationWidth`. If it is greater
 *     than 1, then all values of `strides` must be 1.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $017ce287e08f8570$var$conv3d_(x, filter, strides, pad, dataFormat = 'NDHWC', dilations = [
    1,
    1,
    1
]) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'conv3d');
    const $filter = (0, $5R1UY.convertToTensor)(filter, 'filter', 'conv3d');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $4tCOB.assert(x5D.rank === 5, ()=>`Error in conv3d: input must be rank 5, but got rank ${x5D.rank}.`);
    $4tCOB.assert($filter.rank === 5, ()=>`Error in conv3d: filter must be rank 5, but got rank ` + `${$filter.rank}.`);
    $4tCOB.assert(x5D.shape[4] === $filter.shape[3], ()=>`Error in conv3d: depth of input (${x5D.shape[4]}) must match ` + `input depth for filter ${$filter.shape[3]}.`);
    $4tCOB.assert((0, $yLVwv.eitherStridesOrDilationsAreOne)(strides, dilations), ()=>'Error in conv3D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $4tCOB.assert(dataFormat === 'NDHWC', ()=>`Error in conv3d: got dataFormat of ${dataFormat} but only NDHWC is currently supported.`);
    const inputs = {
        x: x5D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Conv3D), inputs, attrs);
    if (reshapedTo5D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $017ce287e08f8570$export$c476b02bcf7b2def = (0, $jKUCi.op)({
    conv3d_: $017ce287e08f8570$var$conv3d_
});

});

parcelRegister("jVkrH", function(module, exports) {

$parcel$export(module.exports, "conv3dTranspose", () => $e8133346e644bb84$export$5eac62031b3f449f);

var $5R1UY = parcelRequire("5R1UY");

var $YRgVI = parcelRequire("YRgVI");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the transposed 3D convolution of a volume, also known as a
 * deconvolution.
 *
 * @param x The input image, of rank 5 or rank 4, of shape
 *   `[batch, depth, height, width, inDepth]`. If rank 4, batch of 1 is assumed.
 * @param filter The filter, rank 4, of shape
 *     `[depth, filterHeight, filterWidth, outDepth, inDepth]`.
 *     `inDepth` must match `inDepth` in `x`.
 * @param outputShape Output shape, of rank 5 or rank 4:
 *     `[batch, depth, height, width, outDepth]`. If rank 3, batch of 1 is
 *    assumed.
 * @param strides The strides of the original convolution:
 *     `[strideDepth, strideHeight, strideWidth]`.
 * @param pad  The type of padding algorithm used in the non-transpose version
 *    of the op.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $e8133346e644bb84$var$conv3dTranspose_(x, filter, outputShape, strides, pad) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'conv3dTranspose');
    const $filter = (0, $5R1UY.convertToTensor)(filter, 'filter', 'conv3dTranspose');
    return (0, $YRgVI.conv3DBackpropInput)(outputShape, $x, $filter, strides, pad);
}
const $e8133346e644bb84$export$5eac62031b3f449f = (0, $jKUCi.op)({
    conv3dTranspose_: $e8133346e644bb84$var$conv3dTranspose_
});

});
parcelRegister("YRgVI", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropInput", () => $0b6eed6ee8197c9f$export$deb6d1ca1fa2977b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the derivative of the input of a 3D convolution.
 *
 * @param xShape The shape of the input: [batch, depth, height, width,
 * in_channels]. If length of 4, batch of 1 is assumed.
 * @param dy The derivative of the output, of rank 5 or rank 4 of shape
 *   `[batch, outDepth, outHeight, outWidth, in_channels]`.
 * If rank 4, batch of 1 is assumed.
 * @param filter The filter, rank 5, of shape
 *     `[filterDepth, filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideDepth, strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm used:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 */ function $0b6eed6ee8197c9f$var$conv3DBackpropInput_(xShape, dy, filter, strides, pad) {
    $4tCOB.assert(xShape.length === dy.rank, ()=>`Length of inShape ` + `(${xShape.length}) and rank of dy (${dy.rank}) must match`);
    let xShape5D = xShape;
    let dy5D = dy;
    let reshapedTo5D = false;
    if (dy.rank === 4) {
        reshapedTo5D = true;
        dy5D = (0, $eP0pM.reshape)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2],
            dy.shape[3]
        ]);
        xShape5D = [
            1,
            xShape[0],
            xShape[1],
            xShape[2],
            xShape[3]
        ];
    }
    const inDepth = xShape5D[4];
    const outDepth = dy5D.shape[4];
    $4tCOB.assert(xShape5D.length === 5, ()=>`Error in conv3dDerInput: inShape must be length 5, but got length ` + `${xShape5D.length}.`);
    $4tCOB.assert(dy5D.rank === 5, ()=>`Error in conv3dDerInput: dy must be rank 5, but got ` + `rank ${dy5D.rank}`);
    $4tCOB.assert(filter.rank === 5, ()=>`Error in conv3dDerInput: filter must be rank 5, but got ` + `rank ${filter.rank}`);
    $4tCOB.assert(inDepth === filter.shape[3], ()=>`Error in conv3dDerInput: depth of input (${inDepth}) must ` + `match input depth for filter ${filter.shape[3]}.`);
    $4tCOB.assert(outDepth === filter.shape[4], ()=>`Error in conv3dDerInput: depth of output (${outDepth}) must ` + `match output depth for filter ${filter.shape[4]}.`);
    const inputs = {
        dy: dy5D,
        filter: filter
    };
    const attrs = {
        pad: pad,
        strides: strides,
        inputShape: xShape5D
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Conv3DBackpropInputV2), inputs, attrs);
    if (reshapedTo5D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $0b6eed6ee8197c9f$export$deb6d1ca1fa2977b = (0, $jKUCi.op)({
    conv3DBackpropInput_: $0b6eed6ee8197c9f$var$conv3DBackpropInput_
});

});


parcelRegister("hZQWd", function(module, exports) {

$parcel$export(module.exports, "cos", () => $d1a13290cbe20860$export$50d414a77b60d802);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes cos of the input `tf.Tensor` element-wise: `cos(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.cos().print();  // or tf.cos(x)
 * ```
 * @param x The input tensor. Must be float32 type.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $d1a13290cbe20860$var$cos_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'cos', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Cos), inputs);
}
const $d1a13290cbe20860$export$50d414a77b60d802 = (0, $jKUCi.op)({
    cos_: $d1a13290cbe20860$var$cos_
});

});

parcelRegister("9p6CG", function(module, exports) {

$parcel$export(module.exports, "cosh", () => $6d8b9609dbf5fb2b$export$2e2fd1ad24e4d350);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes hyperbolic cos of the input `tf.Tensor` element-wise: `cosh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.cosh().print();  // or tf.cosh(x)
 * ```
 * @param x The input tensor. Must be float32 type.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $6d8b9609dbf5fb2b$var$cosh_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'cosh', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Cosh), inputs);
}
const $6d8b9609dbf5fb2b$export$2e2fd1ad24e4d350 = (0, $jKUCi.op)({
    cosh_: $6d8b9609dbf5fb2b$var$cosh_
});

});

parcelRegister("hlDAs", function(module, exports) {

$parcel$export(module.exports, "cumprod", () => $ca131af96b479c77$export$dc7513e907e94b8d);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the cumulative product of a `tf.Tensor` along `axis`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4]);
 * x.cumprod().print();
 * ```
 * ```js
 * const x = tf.tensor([[1, 2], [3, 4]]);
 * x.cumprod().print();
 * ```
 *
 * @param x The input tensor to cumulatively multiply.
 * @param axis The axis along which to multiply. Optional. Defaults to 0.
 * @param exclusive Whether to perform exclusive cumulative product. Optional.
 *     Defaults to false. If set to true then the product of each tensor entry
 *     does not include its own value, but only the values previous to it
 *     along the specified axis.
 * @param reverse Whether to multiply in the opposite direction. Optional.
 *     Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Scan'}
 */ function $ca131af96b479c77$var$cumprod_(x, axis = 0, exclusive = false, reverse = false) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'cumprod');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        exclusive: exclusive,
        reverse: reverse
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Cumprod), inputs, attrs);
}
const $ca131af96b479c77$export$dc7513e907e94b8d = (0, $jKUCi.op)({
    cumprod_: $ca131af96b479c77$var$cumprod_
});

});

parcelRegister("6nQJI", function(module, exports) {

$parcel$export(module.exports, "cumsum", () => $4a5dcc609114e21e$export$71990b1e1c4912fe);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the cumulative sum of a `tf.Tensor` along `axis`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4]);
 * x.cumsum().print();
 * ```
 * ```js
 * const x = tf.tensor([[1, 2], [3, 4]]);
 * x.cumsum().print();
 * ```
 *
 * @param x The input tensor to be summed.
 * @param axis The axis along which to sum. Optional. Defaults to 0.
 * @param exclusive Whether to perform exclusive cumulative sum. Optional.
 *     Defaults to false. If set to true then the sum of each tensor entry
 *     does not include its own value, but only the values previous to it
 *     along the specified axis.
 * @param reverse Whether to sum in the opposite direction. Optional.
 *     Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Scan'}
 */ function $4a5dcc609114e21e$var$cumsum_(x, axis = 0, exclusive = false, reverse = false) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'cumsum');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        exclusive: exclusive,
        reverse: reverse
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Cumsum), inputs, attrs);
}
const $4a5dcc609114e21e$export$71990b1e1c4912fe = (0, $jKUCi.op)({
    cumsum_: $4a5dcc609114e21e$var$cumsum_
});

});

parcelRegister("jQm41", function(module, exports) {

$parcel$export(module.exports, "denseBincount", () => $e723fd0e54442e20$export$436934e6cf1946f1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Outputs a vector with length `size` and the same dtype as `weights`.
 *
 * If `weights` are empty, then index `i` stores the number of times the value
 * `i` is counted in `x`. If `weights` are non-empty, then index `i` stores the
 * sum of the value in `weights` at each index where the corresponding value in
 * `x` is `i`.
 *
 * Values in `x` outside of the range [0, size) are ignored.
 *
 * @param x The input int tensor, rank 1 or rank 2.
 * @param weights The weights tensor, must have the same shape as x, or a
 *     length-0 Tensor, in which case it acts as all weights equal to 1.
 * @param size Non-negative integer.
 * @param binaryOutput Optional. Whether the kernel should count the appearance
 *     or number of occurrences. Defaults to False.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $e723fd0e54442e20$var$denseBincount_(x, weights, size, binaryOutput = false) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'denseBincount');
    const $weights = (0, $5R1UY.convertToTensor)(weights, 'weights', 'denseBincount');
    $4tCOB.assert($x.dtype === 'int32', ()=>`Error in denseBincount: input ` + `dtype must be int32, but got ${$x.dtype}`);
    $4tCOB.assert($x.rank <= 2, ()=>`Error in denseBincount: input must be at most rank 2, but got ` + `rank ${$x.rank}.`);
    $4tCOB.assert(size >= 0, ()=>`size must be non-negative, but got ${size}.`);
    $4tCOB.assert($weights.size === $x.size || $weights.size === 0, ()=>`Error in denseBincount: weights must have the same shape as x or ` + `0-length, but got x shape: ${$x.shape}, weights shape: ` + `${$weights.shape}.`);
    const inputs = {
        x: $x,
        weights: $weights
    };
    const attrs = {
        size: size,
        binaryOutput: binaryOutput
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.DenseBincount), inputs, attrs);
}
const $e723fd0e54442e20$export$436934e6cf1946f1 = (0, $jKUCi.op)({
    denseBincount_: $e723fd0e54442e20$var$denseBincount_
});

});

parcelRegister("7Maa1", function(module, exports) {

$parcel$export(module.exports, "depthToSpace", () => $5a94e5c5e2973fd9$export$3b50daec0f185f12);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Rearranges data from depth into blocks of spatial data. More specifically,
 * this op outputs a copy of the input tensor where values from the `depth`
 * dimension are moved in spatial blocks to the `height` and `width` dimensions.
 * The attr `blockSize` indicates the input block size and how the data is
 * moved.
 *
 *  - Chunks of data of size `blockSize * blockSize` from depth are rearranged
 * into non-overlapping blocks of size `blockSize x blockSize`
 *
 *  - The width the output tensor is `inputWidth * blockSize`, whereas the
 * height is `inputHeight * blockSize`
 *
 *  - The Y, X coordinates within each block of the output image are determined
 * by the high order component of the input channel index
 *
 *  - The depth of the input tensor must be divisible by `blockSize *
 * blockSize`
 *
 * The `dataFormat` attr specifies the layout of the input and output tensors
 * with the following options: "NHWC": [ `batch, height, width, channels` ]
 * "NCHW": [ `batch, channels, height, width` ]
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [1, 1, 1, 4]);
 * const blockSize = 2;
 * const dataFormat = "NHWC";
 *
 * tf.depthToSpace(x, blockSize, dataFormat).print();
 * ```
 *
 * @param x The input tensor of rank 4
 * @param blockSIze  An `int` that is `>= 2`. The size of the spatial block
 * @param dataFormat An optional string from: "NHWC", "NCHW". Defaults to "NHWC"
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $5a94e5c5e2973fd9$var$depthToSpace_(x, blockSize, dataFormat = 'NHWC') {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'depthToSpace', 'float32');
    const inputHeight = dataFormat === 'NHWC' ? $x.shape[1] : $x.shape[2];
    const inputWidth = dataFormat === 'NHWC' ? $x.shape[2] : $x.shape[3];
    const inputDepth = dataFormat === 'NHWC' ? $x.shape[3] : $x.shape[1];
    $4tCOB.assert(blockSize > 1, ()=>`blockSize should be > 1 for depthToSpace, but was: ${blockSize}`);
    $4tCOB.assert(inputHeight * blockSize >= 0, ()=>`Negative dimension size caused by overflow when multiplying
    ${inputHeight} and ${blockSize}  for depthToSpace with input shape
    ${$x.shape}`);
    $4tCOB.assert(inputWidth * blockSize >= 0, ()=>`Negative dimension size caused by overflow when multiplying
    ${inputWidth} and ${blockSize} for depthToSpace with input shape
        ${$x.shape}`);
    $4tCOB.assert(inputDepth % (blockSize * blockSize) === 0, ()=>`Dimension size must be evenly divisible by ${blockSize * blockSize} but is ${inputDepth} for depthToSpace with input shape ${$x.shape}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockSize: blockSize,
        dataFormat: dataFormat
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.DepthToSpace), inputs, attrs);
}
const $5a94e5c5e2973fd9$export$3b50daec0f185f12 = (0, $jKUCi.op)({
    depthToSpace_: $5a94e5c5e2973fd9$var$depthToSpace_
});

});

parcelRegister("kDOuZ", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2d", () => $f06e9f2cffd3a2a8$export$48a8ad9494a8fad8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $yLVwv = parcelRequire("yLVwv");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Depthwise 2D convolution.
 *
 * Given a 4D `input` array and a `filter` array of shape
 * `[filterHeight, filterWidth, inChannels, channelMultiplier]` containing
 * `inChannels` convolutional filters of depth 1, this op applies a
 * different filter to each input channel (expanding from 1 channel to
 * `channelMultiplier` channels for each), then concatenates the results
 * together. The output has `inChannels * channelMultiplier` channels.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d)
 * for more details.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $f06e9f2cffd3a2a8$var$depthwiseConv2d_(x, filter, strides, pad, dataFormat = 'NHWC', dilations = [
    1,
    1
], dimRoundingMode) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'depthwiseConv2d', 'float32');
    const $filter = (0, $5R1UY.convertToTensor)(filter, 'filter', 'depthwiseConv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $4tCOB.assert(x4D.rank === 4, ()=>`Error in depthwiseConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $4tCOB.assert($filter.rank === 4, ()=>`Error in depthwiseConv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    const inChannels = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $4tCOB.assert(inChannels === $filter.shape[2], ()=>`Error in depthwiseConv2d: number of input channels ` + `(${inChannels}) must match the inChannels dimension in ` + `filter ${$filter.shape[2]}.`);
    $yLVwv.checkPadOnDimRoundingMode('depthwiseConv2d', pad, dimRoundingMode);
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.DepthwiseConv2dNative), inputs, attrs);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $f06e9f2cffd3a2a8$export$48a8ad9494a8fad8 = (0, $jKUCi.op)({
    depthwiseConv2d_: $f06e9f2cffd3a2a8$var$depthwiseConv2d_
});

});

parcelRegister("iAmAQ", function(module, exports) {

$parcel$export(module.exports, "diag", () => $d87d1d52e0500064$export$c042e7c2f59bc046);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns a diagonal tensor with given diagonal values.
 *
 * Given a diagonal, this operation returns a tensor with the diagonal and
 * everything else padded with zeros.
 *
 * Assume the input has dimensions `[D1,..., Dk]`, then the output is a tensor
 * of rank 2k with dimensions `[D1,..., Dk, D1,..., Dk]`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * tf.diag(x).print()
 * ```
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4, 5, 6, 6, 8], [4, 2])
 *
 * tf.diag(x).print()
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $d87d1d52e0500064$var$diag_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'diag');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Diag), inputs);
}
const $d87d1d52e0500064$export$c042e7c2f59bc046 = (0, $jKUCi.op)({
    diag_: $d87d1d52e0500064$var$diag_
});

});

parcelRegister("cPcCM", function(module, exports) {

$parcel$export(module.exports, "dilation2d", () => $95640a6d15c39de3$export$d9b8f675671875b9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the grayscale dilation over the input `x`.
 *
 * @param x The input tensor, rank 3 or rank 4 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filter The filter tensor, rank 3, of shape
 *     `[filterHeight, filterWidth, depth]`.
 * @param strides The strides of the sliding window for each dimension of the
 *     input tensor: `[strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat Specify the data format of the input and output data.
 *      Defaults to 'NHWC'. Only 'NHWC' is currently supported. With the
 *      default format "NHWC", the data is stored in the order of: [batch,
 *      height, width, channels].
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     for atrous morphological dilation. Defaults to `[1, 1]`. If `dilations`
 *     is a single number, then `dilationHeight == dilationWidth`. If it is
 *     greater than 1, then all values of `strides` must be 1.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $95640a6d15c39de3$var$dilation2d_(x, filter, strides, pad, dilations = [
    1,
    1
], dataFormat = 'NHWC') {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'dilation2d');
    const $filter = (0, $5R1UY.convertToTensor)(filter, 'filter', 'dilation2d');
    $4tCOB.assert($x.rank === 3 || $x.rank === 4, ()=>`Error in dilation2d: input must be rank 3 or 4, but got rank ` + `${$x.rank}.`);
    $4tCOB.assert($filter.rank === 3, ()=>`Error in dilation2d: filter must be rank 3, but got rank ` + `${$filter.rank}.`);
    $4tCOB.assert(dataFormat === 'NHWC', ()=>`Error in dilation2d: Only NHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        x4D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
        reshapedTo4D = true;
    }
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dilations: dilations
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Dilation2D), inputs, attrs);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $95640a6d15c39de3$export$d9b8f675671875b9 = (0, $jKUCi.op)({
    dilation2d_: $95640a6d15c39de3$var$dilation2d_
});

});

parcelRegister("fFAAa", function(module, exports) {

$parcel$export(module.exports, "divNoNan", () => $b6870fdc046a2fdb$export$9c5df3eb9e56f19e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $gjFWY = parcelRequire("gjFWY");

var $5Py3O = parcelRequire("5Py3O");

var $jKUCi = parcelRequire("jKUCi");

var $3dRh6 = parcelRequire("3dRh6");

var $k1Ozi = parcelRequire("k1Ozi");
/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting. Return 0
 * if denominator is 0.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 * const c = tf.tensor1d([0, 0, 0, 0]);
 *
 * a.divNoNan(b).print();  // or tf.divNoNan(a, b)
 * a.divNoNan(c).print();  // or tf.divNoNan(a, c)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 * const c = tf.scalar(0);
 *
 * a.divNoNan(b).print();  // or tf.divNoNan(a, b)
 * a.divNoNan(c).print();  // or tf.divNoNan(a, c)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $b6870fdc046a2fdb$var$divNoNan_(a, b) {
    // TODO: Make this into its own kernel.
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'div');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'div');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    const divResult = (0, $gjFWY.div)($a, $b);
    const zeros = (0, $k1Ozi.zerosLike)(divResult);
    const bEqualsZero = (0, $5Py3O.equal)($b, zeros);
    return (0, $3dRh6.where)(bEqualsZero, zeros, divResult);
}
const $b6870fdc046a2fdb$export$9c5df3eb9e56f19e = (0, $jKUCi.op)({
    divNoNan_: $b6870fdc046a2fdb$var$divNoNan_
});

});
parcelRegister("5Py3O", function(module, exports) {

$parcel$export(module.exports, "equal", () => $43ec22e41b1e37b7$export$411ce8e5a71e3069);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $eqTIO = parcelRequire("eqTIO");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the truth value of (a == b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.equal(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $43ec22e41b1e37b7$var$equal_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'equal', 'string_or_numeric');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'equal', 'string_or_numeric');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    (0, $eqTIO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Equal), inputs);
}
const $43ec22e41b1e37b7$export$411ce8e5a71e3069 = (0, $jKUCi.op)({
    equal_: $43ec22e41b1e37b7$var$equal_
});

});

parcelRegister("3dRh6", function(module, exports) {

$parcel$export(module.exports, "where", () => $258be9421860a0a8$export$9c59b80dda569a6e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $eJSTd = parcelRequire("eJSTd");

var $eqTIO = parcelRequire("eqTIO");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the elements, either `a` or `b` depending on the `condition`.
 *
 * If the condition is true, select from `a`, otherwise select from `b`.
 *
 * ```js
 * const cond = tf.tensor1d([false, false, true], 'bool');
 * const a = tf.tensor1d([1 , 2, 3]);
 * const b = tf.tensor1d([-1, -2, -3]);
 *
 * a.where(cond, b).print();
 * ```
 *
 * @param condition The input condition. Must be of dtype bool.
 * @param a If `condition` is rank 1, `a` may have a higher rank but
 *     its first dimension must match the size of `condition`.
 * @param b A tensor with the same dtype as `a` and with shape that is
 *     compatible with `a`.
 * @return A tensor with same dtype as `a` and `b`, and shape that is
 *     broadcastable from `a` and `b`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $258be9421860a0a8$var$where_(condition, a, b) {
    const $a = (0, $5R1UY.convertToTensor)(a, 'a', 'where');
    const $b = (0, $5R1UY.convertToTensor)(b, 'b', 'where');
    const $condition = (0, $5R1UY.convertToTensor)(condition, 'condition', 'where', 'bool');
    // TODO: move this logic to forward function when the broadcastTo op is
    // implemented in WASM.
    // Find the broadcastable shape for $condition, $a, and $b.
    const broadcastShape = (0, $eqTIO.assertAndGetBroadcastShape)((0, $eqTIO.assertAndGetBroadcastShape)($condition.shape, $a.shape), $b.shape);
    const $broadcastedCondition = (0, $eJSTd.broadcastTo)($condition, broadcastShape);
    const $broadcastedA = (0, $eJSTd.broadcastTo)($a, broadcastShape);
    const $broadcastedB = (0, $eJSTd.broadcastTo)($b, broadcastShape);
    const inputs = {
        condition: $broadcastedCondition,
        t: $broadcastedA,
        e: $broadcastedB
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Select), inputs);
}
const $258be9421860a0a8$export$9c59b80dda569a6e = (0, $jKUCi.op)({
    where_: $258be9421860a0a8$var$where_
});

});


parcelRegister("8RVHb", function(module, exports) {

$parcel$export(module.exports, "dot", () => $6750071842fd78af$export$94132a0e348806d4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $clO9Z = parcelRequire("clO9Z");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the dot product of two matrices and/or vectors, `t1` and `t2`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor2d([[1, 2], [3, 4]]);
 * const c = tf.tensor2d([[1, 2, 3], [4, 5, 6]]);
 *
 * a.dot(b).print();  // or tf.dot(a, b)
 * b.dot(a).print();
 * b.dot(c).print();
 * ```
 * @param t1 The first tensor in the dot operation.
 * @param t2 The second tensor in the dot operation.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $6750071842fd78af$var$dot_(t1, t2) {
    const $t1 = (0, $5R1UY.convertToTensor)(t1, 't1', 'dot');
    const $t2 = (0, $5R1UY.convertToTensor)(t2, 't2', 'dot');
    $4tCOB.assert(($t1.rank === 1 || $t1.rank === 2) && ($t2.rank === 1 || $t2.rank === 2), ()=>`Error in dot: inputs must all be rank 1 or 2, but got ranks ` + `${$t1.rank} and ${$t2.rank}.`);
    const t1Inner = $t1.rank === 1 ? $t1.size : $t1.shape[1];
    const t2Inner = $t2.rank === 1 ? $t2.size : $t2.shape[0];
    $4tCOB.assert(t1Inner === t2Inner, ()=>`Error in dot: inner dimensions of inputs must match, but got ` + `${t1Inner} and ${t2Inner}.`);
    if ($t1.rank === 1 && $t2.rank === 1) {
        const t12D = (0, $eP0pM.reshape)($t1, [
            1,
            -1
        ]);
        const t22D = (0, $eP0pM.reshape)($t2, [
            -1,
            1
        ]);
        const t1t2 = (0, $clO9Z.matMul)(t12D, t22D);
        return (0, $eP0pM.reshape)(t1t2, []);
    } else if ($t1.rank === 1 && $t2.rank === 2) {
        const t12D = (0, $eP0pM.reshape)($t1, [
            1,
            -1
        ]);
        const t22D = (0, $eP0pM.reshape)($t2, [
            $t2.shape[0],
            $t2.shape[1]
        ]);
        const t1t2 = (0, $clO9Z.matMul)(t12D, t22D);
        return (0, $eP0pM.reshape)(t1t2, [
            t1t2.size
        ]);
    } else if ($t1.rank === 2 && $t2.rank === 1) {
        const t22D = (0, $eP0pM.reshape)($t2, [
            -1,
            1
        ]);
        const t1t2 = (0, $clO9Z.matMul)($t1, t22D);
        return (0, $eP0pM.reshape)(t1t2, [
            t1t2.size
        ]);
    } else {
        const t22D = (0, $eP0pM.reshape)($t2, [
            $t2.shape[0],
            $t2.shape[1]
        ]);
        const t1t2 = (0, $clO9Z.matMul)($t1, t22D);
        return t1t2;
    }
}
const $6750071842fd78af$export$94132a0e348806d4 = (0, $jKUCi.op)({
    dot_: $6750071842fd78af$var$dot_
});

});

parcelRegister("hJ5gA", function(module, exports) {

$parcel$export(module.exports, "einsum", () => $ce7ab973ab2873d1$export$27265e7daac5c403);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
function $ce7ab973ab2873d1$export$f6fde01e521435e1(equation, ...tensors) {
    const $tensors = tensors.map((t, i)=>(0, $5R1UY.convertToTensor)(t, `tensors${i}`, 'einsum'));
    const attrs = {
        equation: equation
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Einsum), $tensors, attrs);
}
const $ce7ab973ab2873d1$export$27265e7daac5c403 = (0, $jKUCi.op)({
    einsum_: $ce7ab973ab2873d1$export$f6fde01e521435e1
});

});

parcelRegister("aYszp", function(module, exports) {

$parcel$export(module.exports, "elu", () => $7fd5ab63e78dab88$export$796b583dd79d8524);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes exponential linear element-wise: `x > 0 ? x : (e ^ x) - 1`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 1, -3, 2]);
 *
 * x.elu().print();  // or tf.elu(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $7fd5ab63e78dab88$var$elu_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'elu', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Elu), inputs);
}
const $7fd5ab63e78dab88$export$796b583dd79d8524 = (0, $jKUCi.op)({
    elu_: $7fd5ab63e78dab88$var$elu_
});

});

parcelRegister("44EES", function(module, exports) {

$parcel$export(module.exports, "erf", () => $2f771308ae5fc142$export$d3896f355fc09423);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $7qWZ5 = parcelRequire("7qWZ5");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes Gauss error function of the input `tf.Tensor` element-wise:
 * `erf(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, .1, -.1, .7]);
 *
 * x.erf().print(); // or tf.erf(x);
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $2f771308ae5fc142$var$erf_(x) {
    let $x = (0, $5R1UY.convertToTensor)(x, 'x', 'erf');
    $4tCOB.assert($x.dtype === 'int32' || $x.dtype === 'float32', ()=>'Input dtype must be `int32` or `float32`.');
    if ($x.dtype === 'int32') $x = (0, $7qWZ5.cast)($x, 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Erf), inputs);
}
const $2f771308ae5fc142$export$d3896f355fc09423 = (0, $jKUCi.op)({
    erf_: $2f771308ae5fc142$var$erf_
});

});

parcelRegister("evBPw", function(module, exports) {

$parcel$export(module.exports, "euclideanNorm", () => $a9014e31efb38b44$export$38d83b337e7c2edd);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eiMLq = parcelRequire("eiMLq");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the Euclidean norm of scalar, vectors, and matrices.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.euclideanNorm().print();  // or tf.euclideanNorm(x)
 * ```
 *
 * @param x The input array.
 * @param axis Optional. If axis is null (the default), the input is
 * considered a vector and a single vector norm is computed over the entire
 * set of values in the Tensor, i.e. euclideanNorm(x) is equivalent
 * to euclideanNorm(x.reshape([-1])). If axis is an integer, the input
 * is considered a batch of vectors, and axis determines the axis in x
 * over which to compute vector norms. If axis is a 2-tuple of integer it is
 * considered a batch of matrices and axis determines the axes in NDArray
 * over which to compute a matrix norm.
 * @param keepDims Optional. If true, the norm has the same dimensionality
 * as the input.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $a9014e31efb38b44$var$euclideanNorm_(x, axis = null, keepDims = false) {
    return (0, $eiMLq.norm)(x, 'euclidean', axis, keepDims);
}
const $a9014e31efb38b44$export$38d83b337e7c2edd = (0, $jKUCi.op)({
    euclideanNorm_: $a9014e31efb38b44$var$euclideanNorm_
});

});
parcelRegister("eiMLq", function(module, exports) {

$parcel$export(module.exports, "norm", () => $a698929d4a53a8e3$export$1991ecd29cc92c6b);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $6oc11 = parcelRequire("6oc11");

var $9k5Lx = parcelRequire("9k5Lx");

var $Fvpms = parcelRequire("Fvpms");

var $8qxBf = parcelRequire("8qxBf");

var $jKUCi = parcelRequire("jKUCi");

var $5MZxP = parcelRequire("5MZxP");

var $eP0pM = parcelRequire("eP0pM");

var $j7yUF = parcelRequire("j7yUF");

var $lGdn1 = parcelRequire("lGdn1");

var $gqriC = parcelRequire("gqriC");

var $fVwnn = parcelRequire("fVwnn");
/**
 * Computes the norm of scalar, vectors, and matrices.
 * This function can compute several different vector norms (the 1-norm, the
 * Euclidean or 2-norm, the inf-norm, and in general the p-norm for p > 0)
 * and matrix norms (Frobenius, 1-norm, and inf-norm).
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.norm().print();  // or tf.norm(x)
 * ```
 *
 * @param x The input array.
 * @param ord Optional. Order of the norm. Supported norm types are
 * following:
 *
 *  | ord        | norm for matrices         | norm for vectors
 *  |------------|---------------------------|---------------------
 *  |'euclidean' |Frobenius norm             |2-norm
 *  |'fro'       |Frobenius norm	           |
 *  |Infinity    |max(sum(abs(x), axis=1))   |max(abs(x))
 *  |-Infinity   |min(sum(abs(x), axis=1))   |min(abs(x))
 *  |1           |max(sum(abs(x), axis=0))   |sum(abs(x))
 *  |2           |                           |sum(abs(x)^2)^(1/2)
 *
 * @param axis Optional. If axis is null (the default), the input is
 * considered a vector and a single vector norm is computed over the entire
 * set of values in the Tensor, i.e. norm(x, ord) is equivalent
 * to norm(x.reshape([-1]), ord). If axis is an integer, the input
 * is considered a batch of vectors, and axis determines the axis in x
 * over which to compute vector norms. If axis is a 2-tuple of integer it is
 * considered a batch of matrices and axis determines the axes in NDArray
 * over which to compute a matrix norm.
 * @param keepDims Optional. If true, the norm has the same dimensionality
 * as the input.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $a698929d4a53a8e3$var$norm_(x, ord = 'euclidean', axis = null, keepDims = false) {
    x = (0, $5R1UY.convertToTensor)(x, 'x', 'norm');
    const norm = $a698929d4a53a8e3$var$normImpl(x, ord, axis);
    let keepDimsShape = norm.shape;
    if (keepDims) {
        const axes = (0, $4tCOB.parseAxisParam)(axis, x.shape);
        keepDimsShape = $9k5Lx.expandShapeToKeepDim(norm.shape, axes);
    }
    return (0, $eP0pM.reshape)(norm, keepDimsShape);
}
function $a698929d4a53a8e3$var$normImpl(x, p, axis = null) {
    if (x.rank === 0) return (0, $6oc11.abs)(x);
    // consider vector when no axis is specified
    if (x.rank !== 1 && axis === null) return $a698929d4a53a8e3$var$normImpl((0, $eP0pM.reshape)(x, [
        -1
    ]), p, axis);
    // vector
    if (x.rank === 1 || typeof axis === 'number' || Array.isArray(axis) && axis.length === 1) {
        if (p === 1) return (0, $fVwnn.sum)((0, $6oc11.abs)(x), axis);
        if (p === Infinity) return (0, $Fvpms.max)((0, $6oc11.abs)(x), axis);
        if (p === -Infinity) return (0, $8qxBf.min)((0, $6oc11.abs)(x), axis);
        if (p === 'euclidean' || p === 2) // norm(x, 2) = sum(abs(xi) ^ 2) ^ 1/2
        return (0, $lGdn1.sqrt)((0, $fVwnn.sum)((0, $5MZxP.pow)((0, $6oc11.abs)(x), (0, $j7yUF.scalar)(2, 'int32')), axis));
        throw new Error(`Error in norm: invalid ord value: ${p}`);
    }
    // matrix (assumption axis[0] < axis[1])
    if (Array.isArray(axis) && axis.length === 2) {
        if (p === 1) return (0, $Fvpms.max)((0, $fVwnn.sum)((0, $6oc11.abs)(x), axis[0]), axis[1] - 1);
        if (p === Infinity) return (0, $Fvpms.max)((0, $fVwnn.sum)((0, $6oc11.abs)(x), axis[1]), axis[0]);
        if (p === -Infinity) return (0, $8qxBf.min)((0, $fVwnn.sum)((0, $6oc11.abs)(x), axis[1]), axis[0]);
        if (p === 'fro' || p === 'euclidean') // norm(x) = sqrt(sum(pow(x, 2)))
        return (0, $lGdn1.sqrt)((0, $fVwnn.sum)((0, $gqriC.square)(x), axis));
        throw new Error(`Error in norm: invalid ord value: ${p}`);
    }
    throw new Error(`Error in norm: invalid axis: ${axis}`);
}
const $a698929d4a53a8e3$export$1991ecd29cc92c6b = (0, $jKUCi.op)({
    norm_: $a698929d4a53a8e3$var$norm_
});

});
parcelRegister("9k5Lx", function(module, exports) {

$parcel$export(module.exports, "axesAreInnerMostDims", () => $6c9a744a6da9c290$export$fcf762ecdaba1fc1);
$parcel$export(module.exports, "combineLocations", () => $6c9a744a6da9c290$export$6cfee5a53150f612);
$parcel$export(module.exports, "computeOutAndReduceShapes", () => $6c9a744a6da9c290$export$68ecd7df33283881);
$parcel$export(module.exports, "expandShapeToKeepDim", () => $6c9a744a6da9c290$export$e35db9afe008d7e3);
$parcel$export(module.exports, "assertAxesAreInnerMostDims", () => $6c9a744a6da9c290$export$f83b6b93f3b44c9c);
$parcel$export(module.exports, "getAxesPermutation", () => $6c9a744a6da9c290$export$d2a6288eef79b310);
$parcel$export(module.exports, "getUndoAxesPermutation", () => $6c9a744a6da9c290$export$2975b40e45f30ba8);
$parcel$export(module.exports, "getInnerMostAxes", () => $6c9a744a6da9c290$export$b62922ed36931ab6);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
function $6c9a744a6da9c290$export$fcf762ecdaba1fc1(axes, rank) {
    for(let i = 0; i < axes.length; ++i){
        if (axes[axes.length - i - 1] !== rank - 1 - i) return false;
    }
    return true;
}
function $6c9a744a6da9c290$export$6cfee5a53150f612(outputLoc, reduceLoc, axes) {
    const rank = outputLoc.length + reduceLoc.length;
    const loc = [];
    let outIdx = 0;
    let reduceIdx = 0;
    for(let dim = 0; dim < rank; dim++)if (axes.indexOf(dim) === -1) loc.push(outputLoc[outIdx++]);
    else loc.push(reduceLoc[reduceIdx++]);
    return loc;
}
function $6c9a744a6da9c290$export$68ecd7df33283881(aShape, axes) {
    const outShape = [];
    const rank = aShape.length;
    for(let dim = 0; dim < rank; dim++)if (axes.indexOf(dim) === -1) outShape.push(aShape[dim]);
    const reduceShape = axes.map((dim)=>aShape[dim]);
    return [
        outShape,
        reduceShape
    ];
}
function $6c9a744a6da9c290$export$e35db9afe008d7e3(shape, axes) {
    const reduceSubShape = axes.map((x)=>1);
    return $6c9a744a6da9c290$export$6cfee5a53150f612(shape, reduceSubShape, axes);
}
function $6c9a744a6da9c290$export$f83b6b93f3b44c9c(msg, axes, rank) {
    $4tCOB.assert($6c9a744a6da9c290$export$fcf762ecdaba1fc1(axes, rank), ()=>`${msg} supports only inner-most axes for now. ` + `Got axes ${axes} and rank-${rank} input.`);
}
function $6c9a744a6da9c290$export$d2a6288eef79b310(axes, rank) {
    if ($6c9a744a6da9c290$export$fcf762ecdaba1fc1(axes, rank)) return null;
    const result = [];
    for(let i = 0; i < rank; ++i)if (axes.indexOf(i) === -1) result.push(i);
    axes.forEach((axis)=>result.push(axis));
    return result;
}
function $6c9a744a6da9c290$export$2975b40e45f30ba8(axes) {
    return axes.map((axis, i)=>[
            i,
            axis
        ]).sort((a, b)=>a[1] - b[1]).map((x)=>x[0]);
}
function $6c9a744a6da9c290$export$b62922ed36931ab6(numAxes, rank) {
    const res = [];
    for(let i = rank - numAxes; i < rank; ++i)res.push(i);
    return res;
}

});

parcelRegister("Fvpms", function(module, exports) {

$parcel$export(module.exports, "max", () => $07cc316f4f931ae9$export$8960430cfd85939f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the maximum of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.max().print();  // or tf.max(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.max(axis).print();  // or tf.max(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $07cc316f4f931ae9$var$max_(x, axis = null, keepDims = false) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'max');
    const inputs = {
        x: $x
    };
    const attrs = {
        reductionIndices: axis,
        keepDims: keepDims
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Max), inputs, attrs);
}
const $07cc316f4f931ae9$export$8960430cfd85939f = (0, $jKUCi.op)({
    max_: $07cc316f4f931ae9$var$max_
});

});

parcelRegister("8qxBf", function(module, exports) {

$parcel$export(module.exports, "min", () => $622ad0ace631d7a0$export$96ec731ed4dcb222);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the minimum value from the input.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the array is reduced by 1 for each entry in `axes`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axes` has no entries, all dimensions are reduced, and an array with a
 * single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.min().print();  // or tf.min(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.min(axis).print();  // or tf.min(x, axis)
 * ```
 *
 * @param x The input Tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $622ad0ace631d7a0$var$min_(x, axis = null, keepDims = false) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'min');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Min), inputs, attrs);
}
const $622ad0ace631d7a0$export$96ec731ed4dcb222 = (0, $jKUCi.op)({
    min_: $622ad0ace631d7a0$var$min_
});

});

parcelRegister("fVwnn", function(module, exports) {

$parcel$export(module.exports, "sum", () => $b9854b197a764834$export$8a63f25cc62965f1);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $7qWZ5 = parcelRequire("7qWZ5");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the sum of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If axes has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.sum().print();  // or tf.sum(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.sum(axis).print();  // or tf.sum(x, axis)
 * ```
 *
 * @param x The input tensor to compute the sum over. If the dtype is `bool`
 *   it will be converted to `int32` and the output dtype will be `int32`.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $b9854b197a764834$var$sum_(x, axis = null, keepDims = false) {
    let $x = (0, $5R1UY.convertToTensor)(x, 'x', 'sum');
    if ($x.dtype === 'bool') $x = (0, $7qWZ5.cast)($x, 'int32');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Sum), inputs, attrs);
}
const $b9854b197a764834$export$8a63f25cc62965f1 = (0, $jKUCi.op)({
    sum_: $b9854b197a764834$var$sum_
});

});



parcelRegister("4NGnB", function(module, exports) {

$parcel$export(module.exports, "exp", () => $37ec9cbc5f242243$export$b310ec824aaee37f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes exponential of the input `tf.Tensor` element-wise. `e ^ x`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, -3]);
 *
 * x.exp().print();  // or tf.exp(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $37ec9cbc5f242243$var$exp_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'exp');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Exp), inputs);
}
const $37ec9cbc5f242243$export$b310ec824aaee37f = (0, $jKUCi.op)({
    exp_: $37ec9cbc5f242243$var$exp_
});

});

parcelRegister("6mzQK", function(module, exports) {

$parcel$export(module.exports, "expandDims", () => $4a209b26587d1c78$export$d660d8ed21f46635);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns a `tf.Tensor` that has expanded rank, by inserting a dimension
 * into the tensor's shape.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const axis = 1;
 * x.expandDims(axis).print();
 * ```
 *
 * @param x The input tensor whose dimensions are to be expanded.
 * @param axis The dimension index at which to insert shape of `1`. Defaults
 *     to 0 (the first dimension).
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $4a209b26587d1c78$var$expandDims_(x, axis = 0) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'expandDims', 'string_or_numeric');
    $4tCOB.assert(axis <= $x.rank, ()=>'Axis must be <= rank of the tensor');
    const inputs = {
        input: $x
    };
    const attrs = {
        dim: axis
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.ExpandDims), inputs, attrs);
}
const $4a209b26587d1c78$export$d660d8ed21f46635 = (0, $jKUCi.op)({
    expandDims_: $4a209b26587d1c78$var$expandDims_
});

});

parcelRegister("lMtcP", function(module, exports) {

$parcel$export(module.exports, "expm1", () => $fdb4bc5a992de705$export$b6c0a80d46d3391d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes exponential of the input `tf.Tensor` minus one element-wise.
 * `e ^ x - 1`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, -3]);
 *
 * x.expm1().print();  // or tf.expm1(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $fdb4bc5a992de705$var$expm1_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'expm1');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Expm1), inputs);
}
const $fdb4bc5a992de705$export$b6c0a80d46d3391d = (0, $jKUCi.op)({
    expm1_: $fdb4bc5a992de705$var$expm1_
});

});

parcelRegister("dF7rq", function(module, exports) {

$parcel$export(module.exports, "eye", () => $9f24e05f0a10406b$export$4e18cf730a59887e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $g81BN = parcelRequire("g81BN");

var $6mzQK = parcelRequire("6mzQK");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");

var $jIHaY = parcelRequire("jIHaY");
/**
 * Create an identity matrix.
 *
 * @param numRows Number of rows.
 * @param numColumns Number of columns. Defaults to `numRows`.
 * @param batchShape If provided, will add the batch shape to the beginning
 *   of the shape of the returned `tf.Tensor` by repeating the identity
 *   matrix.
 * @param dtype Data type.
 * @returns Identity matrix of the specified size and data type, possibly
 *   with batch repetition if `batchShape` is specified.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $9f24e05f0a10406b$var$eye_(numRows, numColumns, batchShape, dtype = 'float32') {
    if (numColumns == null) numColumns = numRows;
    const buff = (0, $g81BN.buffer)([
        numRows,
        numColumns
    ], dtype);
    const n = numRows <= numColumns ? numRows : numColumns;
    for(let i = 0; i < n; ++i)buff.set(1, i, i);
    const out = (0, $eP0pM.reshape)(buff.toTensor(), [
        numRows,
        numColumns
    ]);
    if (batchShape == null) return out;
    else {
        if (batchShape.length === 1) return (0, $jIHaY.tile)((0, $6mzQK.expandDims)(out, 0), [
            batchShape[0],
            1,
            1
        ]);
        else if (batchShape.length === 2) // tslint:disable-next-line:no-unnecessary-type-assertion
        return (0, $jIHaY.tile)((0, $6mzQK.expandDims)((0, $6mzQK.expandDims)(out, 0), 0), [
            batchShape[0],
            batchShape[1],
            1,
            1
        ]);
        else if (batchShape.length === 3) // tslint:disable-next-line:no-unnecessary-type-assertion
        return (0, $jIHaY.tile)((0, $6mzQK.expandDims)((0, $6mzQK.expandDims)((0, $6mzQK.expandDims)(out, 0), 0), 0), [
            batchShape[0],
            batchShape[1],
            batchShape[2],
            1,
            1
        ]);
        else throw new Error(`eye() currently supports only 1D and 2D ` + // tslint:disable-next-line:no-any
        `batchShapes, but received ${batchShape.length}D.`);
    }
}
const $9f24e05f0a10406b$export$4e18cf730a59887e = (0, $jKUCi.op)({
    eye_: $9f24e05f0a10406b$var$eye_
});

});
parcelRegister("jIHaY", function(module, exports) {

$parcel$export(module.exports, "tile", () => $e5b39e3747c27a85$export$3c17558da18e4d75);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Construct a tensor by repeating it the number of times given by reps.
 *
 * This operation creates a new tensor by replicating `input` `reps`
 * times. The output tensor's `i`th dimension has `input.shape[i] *
 * reps[i]` elements, and the values of `input` are replicated
 * `reps[i]` times along the `i`th dimension. For example, tiling
 * `[a, b, c, d]` by `[2]` produces `[a, b, c, d, a, b, c, d]`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 *
 * a.tile([2]).print();    // or a.tile([2])
 * ```
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * a.tile([1, 2]).print();  // or a.tile([1, 2])
 * ```
 * @param x The tensor to tile.
 * @param reps Determines the number of replications per dimension.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $e5b39e3747c27a85$var$tile_(x, reps) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'tile', 'string_or_numeric');
    $4tCOB.assert($x.rank === reps.length, ()=>`Error in transpose: rank of input ${$x.rank} ` + `must match length of reps ${reps}.`);
    const inputs = {
        x: $x
    };
    const attrs = {
        reps: reps
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Tile), inputs, attrs);
}
const $e5b39e3747c27a85$export$3c17558da18e4d75 = (0, $jKUCi.op)({
    tile_: $e5b39e3747c27a85$var$tile_
});

});


parcelRegister("hnXfr", function(module, exports) {

$parcel$export(module.exports, "floor", () => $ca828b0f9ee6a7db$export$a3fe094919f356fd);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes floor of input `tf.Tensor` element-wise: `floor(x)`.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.floor().print();  // or tf.floor(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $ca828b0f9ee6a7db$var$floor_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'floor', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Floor), inputs);
}
const $ca828b0f9ee6a7db$export$a3fe094919f356fd = (0, $jKUCi.op)({
    floor_: $ca828b0f9ee6a7db$var$floor_
});

});

parcelRegister("kiLVE", function(module, exports) {

$parcel$export(module.exports, "gather", () => $ec7aaac574791ede$export$9e05546f00427e8);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Gather slices from tensor `x`'s axis `axis` according to `indices`.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const indices = tf.tensor1d([1, 3, 3], 'int32');
 *
 * x.gather(indices).print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 * const indices = tf.tensor1d([1, 1, 0], 'int32');
 *
 * x.gather(indices).print();
 * ```
 * @param x The input tensor whose slices are to be gathered.
 * @param indices The indices of the values to extract.
 * @param axis The axis over which to select values. Defaults to 0.
 * @param batchDims Optional. The number of batch dimensions. It must be less
 *     than or equal to rank(indices). Defaults to 0.
 *     The output tensor will have shape of
 *     `x.shape[:axis] + indices.shape[batchDims:] + x.shape[axis + 1:]`
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $ec7aaac574791ede$var$gather_(x, indices, axis = 0, batchDims = 0) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'gather');
    const $indices = (0, $5R1UY.convertToTensor)(indices, 'indices', 'gather', 'int32');
    const inputs = {
        x: $x,
        indices: $indices
    };
    const attrs = {
        axis: axis,
        batchDims: batchDims
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.GatherV2), inputs, attrs);
}
const $ec7aaac574791ede$export$9e05546f00427e8 = (0, $jKUCi.op)({
    gather_: $ec7aaac574791ede$var$gather_
});

});

parcelRegister("jUhqf", function(module, exports) {

$parcel$export(module.exports, "greater", () => $e7e0c301bb710539$export$9dca161faaf6308b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $eqTIO = parcelRequire("eqTIO");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the truth value of (a > b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.greater(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $e7e0c301bb710539$var$greater_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'greater', 'string_or_numeric');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'greater', 'string_or_numeric');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    (0, $eqTIO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Greater), inputs);
}
const $e7e0c301bb710539$export$9dca161faaf6308b = (0, $jKUCi.op)({
    greater_: $e7e0c301bb710539$var$greater_
});

});

parcelRegister("cUuWi", function(module, exports) {

$parcel$export(module.exports, "greaterEqual", () => $9662b6e354c633dc$export$c2fd4164cadc1fa2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $eqTIO = parcelRequire("eqTIO");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the truth value of (a >= b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.greaterEqual(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $9662b6e354c633dc$var$greaterEqual_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'greaterEqual', 'string_or_numeric');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'greaterEqual', 'string_or_numeric');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    (0, $eqTIO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.GreaterEqual), inputs);
}
const $9662b6e354c633dc$export$c2fd4164cadc1fa2 = (0, $jKUCi.op)({
    greaterEqual_: $9662b6e354c633dc$var$greaterEqual_
});

});

parcelRegister("63ReF", function(module, exports) {

$parcel$export(module.exports, "isFinite", () => $469c516185a943d1$export$65f0b13f2f82375a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns which elements of x are finite.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isFinite().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $469c516185a943d1$var$isFinite_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'isFinite');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.IsFinite), inputs);
}
const $469c516185a943d1$export$65f0b13f2f82375a = (0, $jKUCi.op)({
    isFinite_: $469c516185a943d1$var$isFinite_
});

});

parcelRegister("bpcc2", function(module, exports) {

$parcel$export(module.exports, "isInf", () => $84db7ccaddfa1901$export$e5d3415c656f7096);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns which elements of x are Infinity or -Infinity.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isInf().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $84db7ccaddfa1901$var$isInf_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'isInf');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.IsInf), inputs);
}
const $84db7ccaddfa1901$export$e5d3415c656f7096 = (0, $jKUCi.op)({
    isInf_: $84db7ccaddfa1901$var$isInf_
});

});

parcelRegister("grp09", function(module, exports) {

$parcel$export(module.exports, "isNaN", () => $bf828fbcb1b11d4c$export$c9f5652083b8129d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns which elements of x are NaN.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isNaN().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $bf828fbcb1b11d4c$var$isNaN_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'isNaN');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.IsNan), inputs);
}
const $bf828fbcb1b11d4c$export$c9f5652083b8129d = (0, $jKUCi.op)({
    isNaN_: $bf828fbcb1b11d4c$var$isNaN_
});

});

parcelRegister("8XuOv", function(module, exports) {

$parcel$export(module.exports, "leakyRelu", () => $685bbc59a02340f5$export$23a860e40a2c6b61);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes leaky rectified linear element-wise.
 *
 * See
 * [http://web.stanford.edu/~awni/papers/relu_hybrid_icml2013_final.pdf](
 *     http://web.stanford.edu/~awni/papers/relu_hybrid_icml2013_final.pdf)
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.leakyRelu(0.1).print();  // or tf.leakyRelu(x, 0.1)
 * ```
 * @param x The input tensor.
 * @param alpha The scaling factor for negative values, defaults to 0.2.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $685bbc59a02340f5$var$leakyRelu_(x, alpha = 0.2) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'leakyRelu');
    const inputs = {
        x: $x
    };
    const attrs = {
        alpha: alpha
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.LeakyRelu), inputs, attrs);
}
const $685bbc59a02340f5$export$23a860e40a2c6b61 = (0, $jKUCi.op)({
    leakyRelu_: $685bbc59a02340f5$var$leakyRelu_
});

});

parcelRegister("6skdg", function(module, exports) {

$parcel$export(module.exports, "less", () => $4b35097ae25f4111$export$bb1a638da8ad190f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $eqTIO = parcelRequire("eqTIO");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the truth value of (a < b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.less(b).print();
 * ```
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $4b35097ae25f4111$var$less_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'less', 'string_or_numeric');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'less', 'string_or_numeric');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    (0, $eqTIO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Less), inputs);
}
const $4b35097ae25f4111$export$bb1a638da8ad190f = (0, $jKUCi.op)({
    less_: $4b35097ae25f4111$var$less_
});

});

parcelRegister("eXGUa", function(module, exports) {

$parcel$export(module.exports, "lessEqual", () => $ae47db62877df203$export$c24ad19a692bb92);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $eqTIO = parcelRequire("eqTIO");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the truth value of (a <= b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.lessEqual(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $ae47db62877df203$var$lessEqual_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'lessEqual', 'string_or_numeric');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'lessEqual', 'string_or_numeric');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    (0, $eqTIO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.LessEqual), inputs);
}
const $ae47db62877df203$export$c24ad19a692bb92 = (0, $jKUCi.op)({
    lessEqual_: $ae47db62877df203$var$lessEqual_
});

});

parcelRegister("ci8bg", function(module, exports) {

$parcel$export(module.exports, "linspace", () => $8f2d82f8bdd2f682$export$71255ea3f595147c);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");
function $8f2d82f8bdd2f682$export$71255ea3f595147c(start, stop, num) {
    if (num <= 0) throw new Error('The number of values should be positive.');
    const attrs = {
        start: start,
        stop: stop,
        num: num
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.LinSpace), {}, attrs);
}

});

parcelRegister("eOy3E", function(module, exports) {

$parcel$export(module.exports, "localResponseNormalization", () => $ac90275ec7571d1c$export$b6127073705f6321);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Normalizes the activation of a local neighborhood across or within
 * channels.
 *
 * @param x The input tensor. The 4-D input tensor is treated as a 3-D array
 *     of 1D vectors (along the last dimension), and each vector is
 *     normalized independently.
 * @param depthRadius The number of adjacent channels in the 1D normalization
 *     window.
 * @param bias A constant bias term for the basis.
 * @param alpha A scale factor, usually positive.
 * @param beta An exponent.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $ac90275ec7571d1c$var$localResponseNormalization_(x, depthRadius = 5, bias = 1, alpha = 1, beta = 0.5) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'localResponseNormalization');
    $4tCOB.assert($x.rank === 4 || $x.rank === 3, ()=>`Error in localResponseNormalization: x must be rank 3 or 4 but got
               rank ${$x.rank}.`);
    $4tCOB.assert($4tCOB.isInt(depthRadius), ()=>`Error in localResponseNormalization: depthRadius must be an ` + `integer but got depthRadius ${depthRadius}.`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    const inputs = {
        x: x4D
    };
    const attrs = {
        depthRadius: depthRadius,
        bias: bias,
        alpha: alpha,
        beta: beta
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.LRN), inputs, attrs);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    else return res;
}
const $ac90275ec7571d1c$export$b6127073705f6321 = (0, $jKUCi.op)({
    localResponseNormalization_: $ac90275ec7571d1c$var$localResponseNormalization_
});

});

parcelRegister("djEuh", function(module, exports) {

$parcel$export(module.exports, "log", () => $9b1c74af8c5505a2$export$bef1f36f5486a6a3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes natural logarithm of the input `tf.Tensor` element-wise: `ln(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.E]);
 *
 * x.log().print();  // or tf.log(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $9b1c74af8c5505a2$var$log_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'log', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Log), inputs);
}
const $9b1c74af8c5505a2$export$bef1f36f5486a6a3 = (0, $jKUCi.op)({
    log_: $9b1c74af8c5505a2$var$log_
});

});

parcelRegister("ibX5K", function(module, exports) {

$parcel$export(module.exports, "log1p", () => $d3e7177918c923db$export$144dcf16adfb9698);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes natural logarithm of the input `tf.Tensor` plus one
 * element-wise: `ln(1 + x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.E - 1]);
 *
 * x.log1p().print();  // or tf.log1p(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $d3e7177918c923db$var$log1p_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'log1p');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Log1p), inputs);
}
const $d3e7177918c923db$export$144dcf16adfb9698 = (0, $jKUCi.op)({
    log1p_: $d3e7177918c923db$var$log1p_
});

});

parcelRegister("Xpmxi", function(module, exports) {

$parcel$export(module.exports, "logSigmoid", () => $0b292f43a44b79bf$export$9e0b8feed033df47);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jFQG4 = parcelRequire("jFQG4");

var $5R1UY = parcelRequire("5R1UY");

var $r7fN6 = parcelRequire("r7fN6");

var $ifge7 = parcelRequire("ifge7");

var $jKUCi = parcelRequire("jKUCi");

var $5B3nT = parcelRequire("5B3nT");

var $cvbcy = parcelRequire("cvbcy");
/**
 * Computes log sigmoid of the input `tf.Tensor` element-wise:
 * `logSigmoid(x)`. For numerical stability, we use `-tf.softplus(-x)`.
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.logSigmoid().print();  // or tf.logSigmoid(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $0b292f43a44b79bf$var$logSigmoid_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'logSigmoid');
    // Use a custom gradient to maintain previous implementation.
    // There is no LogSigmoid kernel in TF so we can't use engine.runKernel
    // directly
    const customOp = (0, $jFQG4.customGrad)((x)=>{
        // TODO(yassogba) we can remove the chained softplus call here only
        // after backends have modualrized softplus at which point we can call
        // engine runKernel(..., Sotfplus, ...) directly.
        const value = (0, $ifge7.neg)((0, $cvbcy.softplus)((0, $ifge7.neg)(x)));
        const gradFunc = (dy)=>{
            const derX = (0, $r7fN6.mul)(dy, (0, $5B3nT.sigmoid)((0, $ifge7.neg)(x)));
            return derX;
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp($x);
}
const $0b292f43a44b79bf$export$9e0b8feed033df47 = (0, $jKUCi.op)({
    logSigmoid_: $0b292f43a44b79bf$var$logSigmoid_
});

});
parcelRegister("cvbcy", function(module, exports) {

$parcel$export(module.exports, "softplus", () => $91a111afed54b3da$export$76aa560a8c2b0055);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes softplus of the input `tf.Tensor` element-wise: `log(exp(x) + 1)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.softplus().print();  // or tf.softplus(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $91a111afed54b3da$var$softplus_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'softplus');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Softplus), inputs);
}
const $91a111afed54b3da$export$76aa560a8c2b0055 = (0, $jKUCi.op)({
    softplus_: $91a111afed54b3da$var$softplus_
});

});


parcelRegister("1oQXI", function(module, exports) {

$parcel$export(module.exports, "logSoftmax", () => $10511d878589dbbe$export$676379a046a2e437);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jFQG4 = parcelRequire("jFQG4");

var $5R1UY = parcelRequire("5R1UY");

var $7qWZ5 = parcelRequire("7qWZ5");

var $4NGnB = parcelRequire("4NGnB");

var $djEuh = parcelRequire("djEuh");

var $Fvpms = parcelRequire("Fvpms");

var $r7fN6 = parcelRequire("r7fN6");

var $jKUCi = parcelRequire("jKUCi");

var $hkR0n = parcelRequire("hkR0n");

var $fVwnn = parcelRequire("fVwnn");
/**
 * Computes the log softmax.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 *
 * a.logSoftmax().print();  // or tf.logSoftmax(a)
 * ```
 *
 * ```js
 * const a = tf.tensor2d([2, 4, 6, 1, 2, 3], [2, 3]);
 *
 * a.logSoftmax().print();  // or tf.logSoftmax(a)
 * ```
 *
 * @param logits The logits array.
 * @param axis The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $10511d878589dbbe$var$logSoftmax_(logits, axis = -1) {
    const $logits = (0, $5R1UY.convertToTensor)(logits, 'logits', 'logSoftmax');
    if (axis === -1) axis = $logits.rank - 1;
    if (axis !== $logits.rank - 1) throw Error('Log Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${$logits.rank} and axis was ${axis}`);
    // const forward: ForwardFunc<Tensor> = (backend, save) => {
    //   const keepDims = true;
    //   const xMax = max(logits, axis, true);
    //   const shifted = sub(logits, xMax);
    //   const value =
    //       sub(cast(shifted, 'float32'), log(sum(exp(shifted), axis,
    //       keepDims)));
    //   save([value]);
    //   return value;
    // };
    // Use a custom gradient for numerical stability.
    const customOp = (0, $jFQG4.customGrad)((logits, save)=>{
        const keepDims = true;
        const xMax = (0, $Fvpms.max)(logits, axis, true);
        const shifted = (0, $hkR0n.sub)(logits, xMax);
        const value = (0, $hkR0n.sub)((0, $7qWZ5.cast)(shifted, 'float32'), (0, $djEuh.log)((0, $fVwnn.sum)((0, $4NGnB.exp)(shifted), axis, keepDims)));
        save([
            value
        ]);
        const gradFunc = (dy, saved)=>{
            const [value] = saved;
            const keepDims = true;
            const softmax = (0, $4NGnB.exp)(value);
            return (0, $hkR0n.sub)(dy, (0, $r7fN6.mul)((0, $fVwnn.sum)(dy, axis, keepDims), softmax));
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp($logits);
// TODO Use Engine.runKernel when CPU/WebGL/WASM backends implement this.
// const inputs: LogSoftmaxInputs = {logits: $logits};
// const attrs: LogSoftmaxAttrs = {axis};
// return ENGINE.runKernel(
//            LogSoftmax, inputs as {} as NamedTensorMap,
//            attrs as {} as NamedAttrMap);
}
const $10511d878589dbbe$export$676379a046a2e437 = (0, $jKUCi.op)({
    logSoftmax_: $10511d878589dbbe$var$logSoftmax_
});

});

parcelRegister("awUAx", function(module, exports) {

$parcel$export(module.exports, "logSumExp", () => $7aa8c9d377c95093$export$e20aca1e89397787);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $1ZrG5 = parcelRequire("1ZrG5");

var $9k5Lx = parcelRequire("9k5Lx");

var $4NGnB = parcelRequire("4NGnB");

var $djEuh = parcelRequire("djEuh");

var $Fvpms = parcelRequire("Fvpms");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");

var $hkR0n = parcelRequire("hkR0n");

var $fVwnn = parcelRequire("fVwnn");
/**
 * Computes the log(sum(exp(elements across the reduction dimensions))).
 *
 * Reduces the input along the dimensions given in `axis`. Unless `keepDims`
 * is true, the rank of the array is reduced by 1 for each entry in `axis`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axis` has no entries, all dimensions are reduced, and an array with a
 * single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.logSumExp().print();  // or tf.logSumExp(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.logSumExp(axis).print();  // or tf.logSumExp(a, axis)
 * ```
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. If null (the default),
 *     reduces all dimensions.
 * @param keepDims If true, retains reduced dimensions with length
 *     of 1. Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $7aa8c9d377c95093$var$logSumExp_(x, axis = null, keepDims = false) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'logSumExp');
    const axes = (0, $4tCOB.parseAxisParam)(axis, $x.shape);
    const xMax = (0, $Fvpms.max)($x, axes, true);
    const a = (0, $hkR0n.sub)($x, xMax);
    const b = (0, $4NGnB.exp)(a);
    const c = (0, $fVwnn.sum)(b, axes);
    const d = (0, $djEuh.log)(c);
    const res = (0, $1ZrG5.add)((0, $eP0pM.reshape)(xMax, d.shape), d);
    if (keepDims) {
        const newShape = (0, $9k5Lx.expandShapeToKeepDim)(res.shape, axes);
        return (0, $eP0pM.reshape)(res, newShape);
    }
    return res;
}
const $7aa8c9d377c95093$export$e20aca1e89397787 = (0, $jKUCi.op)({
    logSumExp_: $7aa8c9d377c95093$var$logSumExp_
});

});

parcelRegister("jtRHJ", function(module, exports) {

$parcel$export(module.exports, "logicalAnd", () => $e2ea6250be401b04$export$db5dd0ef9d505f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $eqTIO = parcelRequire("eqTIO");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the truth value of `a AND b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalAnd(b).print();
 * ```
 *
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $e2ea6250be401b04$var$logicalAnd_(a, b) {
    const $a = (0, $5R1UY.convertToTensor)(a, 'a', 'logicalAnd', 'bool');
    const $b = (0, $5R1UY.convertToTensor)(b, 'b', 'logicalAnd', 'bool');
    (0, $eqTIO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.LogicalAnd), inputs);
}
const $e2ea6250be401b04$export$db5dd0ef9d505f = (0, $jKUCi.op)({
    logicalAnd_: $e2ea6250be401b04$var$logicalAnd_
});

});

parcelRegister("ifcdf", function(module, exports) {

$parcel$export(module.exports, "logicalNot", () => $d48319e168a64a64$export$c836ff7b605b1617);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the truth value of `NOT x` element-wise.
 *
 * ```js
 * const a = tf.tensor1d([false, true], 'bool');
 *
 * a.logicalNot().print();
 * ```
 *
 * @param x The input tensor. Must be of dtype 'bool'.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $d48319e168a64a64$var$logicalNot_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'logicalNot', 'bool');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.LogicalNot), inputs);
}
const $d48319e168a64a64$export$c836ff7b605b1617 = (0, $jKUCi.op)({
    logicalNot_: $d48319e168a64a64$var$logicalNot_
});

});

parcelRegister("eQZfy", function(module, exports) {

$parcel$export(module.exports, "logicalOr", () => $ad056ef1477204fe$export$e2a73975983cadd8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $eqTIO = parcelRequire("eqTIO");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the truth value of `a OR b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalOr(b).print();
 * ```
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $ad056ef1477204fe$var$logicalOr_(a, b) {
    const $a = (0, $5R1UY.convertToTensor)(a, 'a', 'logicalOr', 'bool');
    const $b = (0, $5R1UY.convertToTensor)(b, 'b', 'logicalOr', 'bool');
    (0, $eqTIO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.LogicalOr), inputs);
}
const $ad056ef1477204fe$export$e2a73975983cadd8 = (0, $jKUCi.op)({
    logicalOr_: $ad056ef1477204fe$var$logicalOr_
});

});

parcelRegister("cKPSM", function(module, exports) {

$parcel$export(module.exports, "logicalXor", () => $949206b6b2d92cf8$export$20f90b62b30dbaef);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $eqTIO = parcelRequire("eqTIO");

var $jtRHJ = parcelRequire("jtRHJ");

var $ifcdf = parcelRequire("ifcdf");

var $eQZfy = parcelRequire("eQZfy");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the truth value of `a XOR b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalXor(b).print();
 * ```
 *
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $949206b6b2d92cf8$var$logicalXor_(a, b) {
    const $a = (0, $5R1UY.convertToTensor)(a, 'a', 'logicalXor', 'bool');
    const $b = (0, $5R1UY.convertToTensor)(b, 'b', 'logicalXor', 'bool');
    (0, $eqTIO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    // x ^ y = (x | y) & ~(x & y)
    return (0, $jtRHJ.logicalAnd)((0, $eQZfy.logicalOr)(a, b), (0, $ifcdf.logicalNot)((0, $jtRHJ.logicalAnd)(a, b)));
}
const $949206b6b2d92cf8$export$20f90b62b30dbaef = (0, $jKUCi.op)({
    logicalXor_: $949206b6b2d92cf8$var$logicalXor_
});

});

parcelRegister("g06WT", function(module, exports) {

$parcel$export(module.exports, "lowerBound", () => $ba62095800a5e95b$export$450bb71ab40039dc);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $42FVE = parcelRequire("42FVE");
function $ba62095800a5e95b$export$450bb71ab40039dc(sortedSequence, values) {
    return (0, $42FVE.searchSorted)(sortedSequence, values, 'left');
}

});
parcelRegister("42FVE", function(module, exports) {

$parcel$export(module.exports, "searchSorted", () => $2f17df81c39fdbff$export$56fad8d65b0adbdd);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
const $2f17df81c39fdbff$var$INT32_MAX = 2147483648;
/**
 * Searches for where a value would go in a sorted sequence.
 *
 * This is not a method for checking containment (like javascript in).
 *
 * The typical use case for this operation is "binning", "bucketing", or
 * "discretizing". The values are assigned to bucket-indices based on the edges
 * listed in 'sortedSequence'. This operation returns the bucket-index for each
 * value.
 *
 * The side argument controls which index is returned if a value lands exactly
 * on an edge.
 *
 * The axis is not settable for this operation. It always operates on the
 * innermost dimension (axis=-1). The operation will accept any number of outer
 * dimensions.
 *
 * Note: This operation assumes that 'sortedSequence' is sorted along the
 * innermost axis, maybe using 'sort(..., axis=-1)'. If the sequence is not
 * sorted no error is raised and the content of the returned tensor is not well
 * defined.
 *
 * ```js
 * const edges = tf.tensor1d([-1, 3.3, 9.1, 10.0]);
 * let values = tf.tensor1d([0.0, 4.1, 12.0]);
 * const result1 = tf.searchSorted(edges, values, 'left');
 * result1.print(); // [1, 2, 4]
 *
 * const seq = tf.tensor1d([0, 3, 9, 10, 10]);
 * values = tf.tensor1d([0, 4, 10]);
 * const result2 = tf.searchSorted(seq, values, 'left');
 * result2.print(); // [0, 2, 3]
 * const result3 = tf.searchSorted(seq, values, 'right');
 * result3.print(); // [1, 2, 5]
 *
 * const sortedSequence = tf.tensor2d([[0., 3., 8., 9., 10.],
 *                                     [1., 2., 3., 4., 5.]]);
 * values = tf.tensor2d([[9.8, 2.1, 4.3],
 *                       [0.1, 6.6, 4.5, ]]);
 * const result4 = tf.searchSorted(sortedSequence, values, 'left');
 * result4.print(); // [[4, 1, 2], [0, 5, 4]]
 * ```
 * @param sortedSequence: N-D. Sorted sequence.
 * @param values: N-D. Search values.
 * @param side: 'left'|'right'. Defaults to 'left'. 'left' corresponds to lower
 *     bound and 'right' to upper bound.
 * @return An N-D int32 tensor the size of values containing the result of
 *     applying either lower bound or upper bound (depending on side) to each
 *     value. The result is not a global index to the entire Tensor, but the
 *     index in the last dimension.
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $2f17df81c39fdbff$var$searchSorted_(sortedSequence, values, side = 'left') {
    const $sortedSequence = (0, $5R1UY.convertToTensor)(sortedSequence, 'sortedSequence', 'searchSorted');
    const $values = (0, $5R1UY.convertToTensor)(values, 'values', 'searchSorted');
    const sequenceSize = $sortedSequence.shape[$sortedSequence.shape.length - 1];
    const valuesSize = $values.shape[$values.shape.length - 1];
    const $sortedSequence2D = (0, $eP0pM.reshape)($sortedSequence, [
        -1,
        sequenceSize
    ]);
    const $values2D = (0, $eP0pM.reshape)($values, [
        -1,
        valuesSize
    ]);
    if ($sortedSequence2D.rank < 2) throw new Error(`Sorted input argument must be at least 2-dimensional`);
    if ($sortedSequence2D.shape[0] !== $values2D.shape[0]) throw new Error(`Leading dimension of 'sortedSequence' and 'values' must match.`);
    if ((0, $4tCOB.sizeFromShape)($values2D.shape) >= $2f17df81c39fdbff$var$INT32_MAX) throw new Error(`values tensor size must less than ${$2f17df81c39fdbff$var$INT32_MAX}`);
    if ($sortedSequence2D.shape[1] >= $2f17df81c39fdbff$var$INT32_MAX) throw new Error(`trailing dim_size must less than ${$2f17df81c39fdbff$var$INT32_MAX} for int32 output type, was ${$sortedSequence2D.shape[1]}`);
    const inputs = {
        sortedSequence: $sortedSequence2D,
        values: $values2D
    };
    const attrs = {
        side: side
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.SearchSorted), inputs, attrs);
}
const $2f17df81c39fdbff$export$56fad8d65b0adbdd = (0, $jKUCi.op)({
    searchSorted_: $2f17df81c39fdbff$var$searchSorted_
});

});


parcelRegister("jslkq", function(module, exports) {

$parcel$export(module.exports, "maxPool", () => $e2a12d3961306d14$export$e4aadcf115842782);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $yLVwv = parcelRequire("yLVwv");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the 2D max pooling of an image.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in dilated pooling. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $e2a12d3961306d14$var$maxPool_(x, filterSize, strides, pad, dimRoundingMode) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'maxPool');
    const dilations = 1;
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $4tCOB.assert(x4D.rank === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${x4D.rank}.`);
    $4tCOB.assert($yLVwv.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $yLVwv.checkPadOnDimRoundingMode('maxPool', pad, dimRoundingMode);
    const inputs = {
        x: x4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.MaxPool), inputs, attrs);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $e2a12d3961306d14$export$e4aadcf115842782 = (0, $jKUCi.op)({
    maxPool_: $e2a12d3961306d14$var$maxPool_
});

});

parcelRegister("1lAhs", function(module, exports) {

$parcel$export(module.exports, "maxPool3d", () => $0fb3e5281e989ca3$export$822a6e53be1125f9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $yLVwv = parcelRequire("yLVwv");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the 3D max pooling.
 *
 * ```js
 * const x = tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]);
 * const result = tf.maxPool3d(x, 2, 1, 'valid');
 * result.print();
 * ```
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     `[batch, depth, height, width, inChannels]`.
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     If `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideDepth == strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $0fb3e5281e989ca3$var$maxPool3d_(x, filterSize = [
    1,
    1,
    1
], strides, pad, dimRoundingMode, dataFormat = 'NDHWC') {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'maxPool3d');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $4tCOB.assert(x5D.rank === 5, ()=>`Error in maxPool3d: x must be rank 5 but got rank ${x5D.rank}.`);
    $4tCOB.assert(dataFormat === 'NDHWC', ()=>`Error in maxPool3d: Only NDHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    (0, $yLVwv.checkPadOnDimRoundingMode)('maxPool3d', pad, dimRoundingMode);
    const inputs = {
        x: x5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dataFormat: dataFormat
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.MaxPool3D), inputs, attrs);
    if (reshapedTo5D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $0fb3e5281e989ca3$export$822a6e53be1125f9 = (0, $jKUCi.op)({
    maxPool3d_: $0fb3e5281e989ca3$var$maxPool3d_
});

});

parcelRegister("2Og8s", function(module, exports) {

$parcel$export(module.exports, "maxPoolWithArgmax", () => $20bcc475b15563c7$export$3d8b1b819d23351e);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the 2D max pooling of an image with Argmax index.
 * The indices in argmax are flattened, so that a maximum value at position `[b,
 * y, x, c]` becomes flattened index: `(y * width + x) * channels + c` if
 * include_batch_in_index is False; `((b * height + y) * width + x) * channels
 * +c` if include_batch_in_index is True.
 *
 * The indices returned are always in `[0, height) x [0, width)` before
 * flattening.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param includeBatchIndex Defaults to False. Whether to include batch
 *    dimension in flattened index of argmax.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $20bcc475b15563c7$var$maxPoolWithArgmax_(x, filterSize, strides, pad, includeBatchInIndex = false) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'maxPoolWithArgmax');
    const inputs = {
        x: $x
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        includeBatchInIndex: includeBatchInIndex
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.MaxPoolWithArgmax), inputs, attrs);
    return {
        result: result[0],
        indexes: result[1]
    };
}
const $20bcc475b15563c7$export$3d8b1b819d23351e = (0, $jKUCi.op)({
    maxPoolWithArgmax_: $20bcc475b15563c7$var$maxPoolWithArgmax_
});

});

parcelRegister("gr40e", function(module, exports) {

$parcel$export(module.exports, "mean", () => $bf7245cf24a69f79$export$1ce691f85baaa52);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the mean of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces `x` along the dimensions given in `axis`. Unless `keepDims` is
 * true, the rank of the `tf.Tensor` is reduced by 1 for each entry in `axis`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axis` has no entries, all dimensions are reduced, and a `tf.Tensor` with
 * a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.mean().print();  // or tf.mean(a)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.mean(axis).print();  // or tf.mean(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $bf7245cf24a69f79$var$mean_(x, axis = null, keepDims = false) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'mean');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Mean), inputs, attrs);
}
const $bf7245cf24a69f79$export$1ce691f85baaa52 = (0, $jKUCi.op)({
    mean_: $bf7245cf24a69f79$var$mean_
});

});

parcelRegister("8JKsF", function(module, exports) {

$parcel$export(module.exports, "meshgrid", () => $65c690fb9bacab14$export$2fab8e71e5fefc1a);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $clO9Z = parcelRequire("clO9Z");

var $bhi4b = parcelRequire("bhi4b");

var $eP0pM = parcelRequire("eP0pM");

var $bVnU9 = parcelRequire("bVnU9");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");
function $65c690fb9bacab14$export$2fab8e71e5fefc1a(x, y, { indexing: indexing = 'xy' } = {}) {
    if (indexing !== 'xy' && indexing !== 'ij') throw new TypeError(`${indexing} is not a valid third argument to meshgrid`);
    if (x === undefined) return [];
    let $x = (0, $5R1UY.convertToTensor)(x, 'x', 'meshgrid', x instanceof (0, $bVnU9.Tensor) ? x.dtype : 'float32');
    if (y === undefined) return [
        $x
    ];
    let $y = (0, $5R1UY.convertToTensor)(y, 'y', 'meshgrid', y instanceof (0, $bVnU9.Tensor) ? y.dtype : 'float32');
    const w = (0, $4tCOB.sizeFromShape)($x.shape);
    const h = (0, $4tCOB.sizeFromShape)($y.shape);
    if (indexing === 'xy') {
        $x = (0, $eP0pM.reshape)($x, [
            1,
            -1
        ]);
        $y = (0, $eP0pM.reshape)($y, [
            -1,
            1
        ]);
        return [
            (0, $clO9Z.matMul)((0, $bhi4b.ones)([
                h,
                1
            ], $x.dtype), $x),
            (0, $clO9Z.matMul)($y, (0, $bhi4b.ones)([
                1,
                w
            ], $y.dtype))
        ];
    }
    $x = (0, $eP0pM.reshape)($x, [
        -1,
        1
    ]);
    $y = (0, $eP0pM.reshape)($y, [
        1,
        -1
    ]);
    return [
        (0, $clO9Z.matMul)($x, (0, $bhi4b.ones)([
            1,
            h
        ], $x.dtype)),
        (0, $clO9Z.matMul)((0, $bhi4b.ones)([
            w,
            1
        ], $y.dtype), $y)
    ];
}

});
parcelRegister("bhi4b", function(module, exports) {

$parcel$export(module.exports, "ones", () => $835f4bdc5ff57723$export$21041dee6b8001b0);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $4tCOB = parcelRequire("4tCOB");

var $bxdsK = parcelRequire("bxdsK");

var $7KCJq = parcelRequire("7KCJq");
function $835f4bdc5ff57723$export$21041dee6b8001b0(shape, dtype = 'float32') {
    if (dtype === 'complex64') {
        const real = $835f4bdc5ff57723$export$21041dee6b8001b0(shape, 'float32');
        const imag = (0, $7KCJq.zeros)(shape, 'float32');
        return (0, $bxdsK.complex)(real, imag);
    }
    const values = (0, $4tCOB.makeOnesTypedArray)((0, $4tCOB.sizeFromShape)(shape), dtype);
    return (0, $aHfUM.ENGINE).makeTensor(values, shape, dtype);
}

});
parcelRegister("7KCJq", function(module, exports) {

$parcel$export(module.exports, "zeros", () => $5a4adf968ea55916$export$4445a00dafa2633b);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $4tCOB = parcelRequire("4tCOB");

var $bxdsK = parcelRequire("bxdsK");
function $5a4adf968ea55916$export$4445a00dafa2633b(shape, dtype = 'float32') {
    if (dtype === 'complex64') {
        const real = $5a4adf968ea55916$export$4445a00dafa2633b(shape, 'float32');
        const imag = $5a4adf968ea55916$export$4445a00dafa2633b(shape, 'float32');
        return (0, $bxdsK.complex)(real, imag);
    }
    const values = (0, $4tCOB.makeZerosTypedArray)((0, $4tCOB.sizeFromShape)(shape), dtype);
    return (0, $aHfUM.ENGINE).makeTensor(values, shape, dtype);
}

});



parcelRegister("dlTNL", function(module, exports) {

$parcel$export(module.exports, "minimum", () => $9b88858bfdae869b$export$916782c1f0ddb132);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $eqTIO = parcelRequire("eqTIO");

var $7qWZ5 = parcelRequire("7qWZ5");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the min of a and b (`a < b ? a : b`) element-wise.
 * Supports broadcasting.
 *
 * We also expose `minimumStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.minimum(b).print();  // or tf.minimum(a, b)
 * ```
 *
 * ```js
 * // Broadcast minimum a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.minimum(b).print();  // or tf.minimum(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $9b88858bfdae869b$var$minimum_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'minimum');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'minimum');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    if ($a.dtype === 'bool') {
        $a = (0, $7qWZ5.cast)($a, 'int32');
        $b = (0, $7qWZ5.cast)($b, 'int32');
    }
    (0, $eqTIO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Minimum), inputs);
}
const $9b88858bfdae869b$export$916782c1f0ddb132 = (0, $jKUCi.op)({
    minimum_: $9b88858bfdae869b$var$minimum_
});

});

parcelRegister("5sP2j", function(module, exports) {

$parcel$export(module.exports, "mirrorPad", () => $3fa727ffb271ca82$export$c0b11600e90b86ae);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Pads a `tf.Tensor` using mirror padding.
 *
 * This operation implements the `REFLECT` and `SYMMETRIC` modes of pad.
 *
 * ```js
 * const x = tf.range(0, 9).reshape([1, 1, 3, 3]);
 * x.mirrorPad([[0, 0], [0, 0], [2, 2], [2, 2]], 'reflect').print();
 * ```
 * @param x The tensor to pad.
 * @param paddings An array of length `R` (the rank of the tensor), where
 * each element is a length-2 tuple of ints `[padBefore, padAfter]`,
 * specifying how much to pad along each dimension of the tensor.
 * In "reflect" mode, the padded regions do not include the borders,
 * while in "symmetric" mode the padded regions do include the borders.
 * For example, if the input is `[1, 2, 3]` and paddings is `[0, 2]`,
 * then the output is `[1, 2, 3, 2, 1]` in "reflect" mode, and
 * `[1, 2, 3, 3, 2]` in "symmetric" mode.
 * If `mode` is "reflect" then both `paddings[D, 0]` and `paddings[D, 1]`
 * must be no greater than `x.shape[D] - 1`. If mode is "symmetric"
 * then both `paddings[D, 0]` and `paddings[D, 1]` must be no greater than
 * `x.shape[D]`
 * @param mode String to specify padding mode. Can be `'reflect' | 'symmetric'`
 */ /** @doc {heading: 'Tensors', subheading: 'Transformations'} */ function $3fa727ffb271ca82$var$mirrorPad_(x, paddings, mode) {
    $4tCOB.assert(mode === 'reflect' || mode === 'symmetric', ()=>`Invalid mode. Mode must be either reflect or symmetric. ` + `Got ${mode}.`);
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'mirrorPad');
    if ($x.rank === 0) throw new Error("mirrorPad(scalar) is not defined. Pass non-scalar to mirrorPad");
    $4tCOB.assert(paddings.length === $x.rank, ()=>`Padding doesn't match input. Must be ${$x.rank}. ` + `Got ${paddings.length}.`);
    const shapeOffset = mode === 'reflect' ? 1 : 0;
    for(let i = 0; i < $x.rank; i++){
        $4tCOB.assert(paddings[i].length === 2, ()=>`Invalid number of paddings. Must be length of 2 each.`);
        $4tCOB.assert(paddings[i][0] >= 0 && paddings[i][0] <= $x.shape[i] - shapeOffset && paddings[i][1] >= 0 && paddings[i][1] <= $x.shape[i] - shapeOffset, ()=>`Padding in dimension ${i} cannot be greater than or equal ` + `to ${$x.shape[i] - shapeOffset} or less than 0 for input of ` + `shape ${$x.shape}`);
    }
    const attrs = {
        paddings: paddings,
        mode: mode
    };
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.MirrorPad), inputs, attrs);
}
const $3fa727ffb271ca82$export$c0b11600e90b86ae = (0, $jKUCi.op)({
    mirrorPad_: $3fa727ffb271ca82$var$mirrorPad_
});

});

parcelRegister("62Ung", function(module, exports) {

$parcel$export(module.exports, "mod", () => $466ea8b7f0161bf4$export$842a2cf37af977e1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the mod of a and b element-wise.
 * `floor(x / y) * y + mod(x, y) = x`
 * Supports broadcasting.
 *
 * We also expose `tf.modStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.mod(b).print();  // or tf.mod(a, b)
 * ```
 *
 * ```js
 * // Broadcast a mod b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.mod(b).print();  // or tf.mod(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $466ea8b7f0161bf4$var$mod_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'mod');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'mod');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Mod), inputs);
}
const $466ea8b7f0161bf4$export$842a2cf37af977e1 = (0, $jKUCi.op)({
    mod_: $466ea8b7f0161bf4$var$mod_
});

});

parcelRegister("9nuoC", function(module, exports) {

$parcel$export(module.exports, "moments", () => $6d3dd710890ca87e$export$19ef085469537740);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $9k5Lx = parcelRequire("9k5Lx");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gr40e = parcelRequire("gr40e");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");

var $gqriC = parcelRequire("gqriC");

var $hkR0n = parcelRequire("hkR0n");
/**
 * Calculates the mean and variance of `x`. The mean and variance are
 * calculated by aggregating the contents of `x` across `axes`. If `x` is
 * 1-D and `axes = [0]` this is just the mean and variance of a vector.
 *
 * @param x The input tensor.
 * @param axis The dimension(s) along with to compute mean and
 *     variance. By default it reduces all dimensions.
 * @param keepDims If true, the moments have the same dimensionality as the
 *     input.
 * @return An object with two keys: `mean` and `variance`.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $6d3dd710890ca87e$var$moments_(x, axis = null, keepDims = false) {
    x = (0, $5R1UY.convertToTensor)(x, 'x', 'moments');
    const axes = (0, $4tCOB.parseAxisParam)(axis, x.shape);
    const xMean = (0, $gr40e.mean)(x, axes, keepDims);
    let keepDimsShape = xMean.shape;
    if (!keepDims) keepDimsShape = (0, $9k5Lx.expandShapeToKeepDim)(xMean.shape, axes);
    const devSquared = (0, $gqriC.square)((0, $hkR0n.sub)((0, $7qWZ5.cast)(x, 'float32'), (0, $eP0pM.reshape)(xMean, keepDimsShape)));
    const variance = (0, $gr40e.mean)(devSquared, axes, keepDims);
    return {
        mean: xMean,
        variance: variance
    };
}
const $6d3dd710890ca87e$export$19ef085469537740 = (0, $jKUCi.op)({
    moments_: $6d3dd710890ca87e$var$moments_
});

});

parcelRegister("iLhm3", function(module, exports) {

$parcel$export(module.exports, "multiRNNCell", () => $da8a14148dd8087f$export$cc05b5217b9b924f);

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the next states and outputs of a stack of LSTMCells.
 *
 * Each cell output is used as input to the next cell.
 *
 * Returns `[cellState, cellOutput]`.
 *
 * Derived from tf.contrib.rn.MultiRNNCell.
 *
 * @param lstmCells Array of LSTMCell functions.
 * @param data The input to the cell.
 * @param c Array of previous cell states.
 * @param h Array of previous cell outputs.
 *
 * @doc {heading: 'Operations', subheading: 'RNN'}
 */ function $da8a14148dd8087f$var$multiRNNCell_(lstmCells, data, c, h) {
    const $data = (0, $5R1UY.convertToTensor)(data, 'data', 'multiRNNCell');
    const $c = (0, $5R1UY.convertToTensorArray)(c, 'c', 'multiRNNCell');
    const $h = (0, $5R1UY.convertToTensorArray)(h, 'h', 'multiRNNCell');
    let input = $data;
    const newStates = [];
    for(let i = 0; i < lstmCells.length; i++){
        const output = lstmCells[i](input, $c[i], $h[i]);
        newStates.push(output[0]);
        newStates.push(output[1]);
        input = output[1];
    }
    const newC = [];
    const newH = [];
    for(let i = 0; i < newStates.length; i += 2){
        newC.push(newStates[i]);
        newH.push(newStates[i + 1]);
    }
    return [
        newC,
        newH
    ];
}
const $da8a14148dd8087f$export$cc05b5217b9b924f = (0, $jKUCi.op)({
    multiRNNCell_: $da8a14148dd8087f$var$multiRNNCell_
});

});

parcelRegister("gehiq", function(module, exports) {

$parcel$export(module.exports, "multinomial", () => $bd0b5ed1be7dac9d$export$f4d580f3101a1c7e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Creates a `tf.Tensor` with values drawn from a multinomial distribution.
 *
 * ```js
 * const probs = tf.tensor([.75, .25]);
 * tf.multinomial(probs, 3).print();
 * ```
 *
 * @param logits 1D array with unnormalized log-probabilities, or
 *     2D array of shape `[batchSize, numOutcomes]`. See the `normalized`
 *     parameter.
 * @param numSamples Number of samples to draw for each row slice.
 * @param seed The seed number.
 * @param normalized Whether the provided `logits` are normalized true
 *     probabilities (sum to 1). Defaults to false.
 * @return 1D array of shape `[numSamples]`, or 2D array of shape
 *     `[batchSize, numSamples]`, depending on the rank of the input.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $bd0b5ed1be7dac9d$var$multinomial_(logits, numSamples, seed, normalized = false) {
    const $logits = (0, $5R1UY.convertToTensor)(logits, 'logits', 'multinomial');
    const numOutcomes = $logits.size;
    const origRank = $logits.rank;
    if (numOutcomes < 2) throw new Error(`Error in multinomial: you need at least 2 outcomes, but got ` + `${numOutcomes}.`);
    if (origRank > 2) throw new Error(`Rank of probabilities must be 1 or 2, but is ${origRank}`);
    // TODO(lina128): Investigate correct seed behavior. The code seems not allow
    // setting see to 0.
    seed = seed || Math.random();
    // The kernel only accepts (and returns) rank 2 tensors.
    const logits2D = origRank === 1 ? (0, $eP0pM.reshape)($logits, [
        1,
        -1
    ]) : $logits;
    const inputs = {
        logits: logits2D
    };
    const attrs = {
        numSamples: numSamples,
        seed: seed,
        normalized: normalized
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Multinomial), inputs, attrs);
    // tslint:disable-next-line:no-unnecessary-type-assertion
    return origRank === 1 ? (0, $eP0pM.reshape)(res, [
        res.size
    ]) : res;
}
const $bd0b5ed1be7dac9d$export$f4d580f3101a1c7e = (0, $jKUCi.op)({
    multinomial_: $bd0b5ed1be7dac9d$var$multinomial_
});

});

parcelRegister("i8e86", function(module, exports) {

$parcel$export(module.exports, "notEqual", () => $d333ef368e579e47$export$53a6892c50694894);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $eqTIO = parcelRequire("eqTIO");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns the truth value of (a != b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([0, 2, 3]);
 *
 * a.notEqual(b).print();
 * ```
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $d333ef368e579e47$var$notEqual_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'notEqual', 'string_or_numeric');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'notEqual', 'string_or_numeric');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    (0, $eqTIO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.NotEqual), inputs);
}
const $d333ef368e579e47$export$53a6892c50694894 = (0, $jKUCi.op)({
    notEqual_: $d333ef368e579e47$var$notEqual_
});

});

parcelRegister("9u8DQ", function(module, exports) {

$parcel$export(module.exports, "onesLike", () => $6e7d9e77fb22c623$export$fb6afd6214fee9e9);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Creates a `tf.Tensor` with all elements set to 1 with the same shape as the
 * given tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 * tf.onesLike(x).print();
 * ```
 * @param x A tensor.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $6e7d9e77fb22c623$var$onesLike_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'onesLike');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.OnesLike), inputs);
}
const $6e7d9e77fb22c623$export$fb6afd6214fee9e9 = (0, $jKUCi.op)({
    onesLike_: $6e7d9e77fb22c623$var$onesLike_
});

});

parcelRegister("gD1dS", function(module, exports) {

$parcel$export(module.exports, "outerProduct", () => $c1b13caf4c431643$export$8481b38c75c91cc7);

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $clO9Z = parcelRequire("clO9Z");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the outer product of two vectors, `v1` and `v2`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([3, 4, 5]);
 *
 * tf.outerProduct(a, b).print();
 * ```
 * @param v1 The first vector in the outer product operation.
 * @param v2 The second vector in the outer product operation.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $c1b13caf4c431643$var$outerProduct_(v1, v2) {
    const $v1 = (0, $5R1UY.convertToTensor)(v1, 'v1', 'outerProduct');
    const $v2 = (0, $5R1UY.convertToTensor)(v2, 'v2', 'outerProduct');
    $4tCOB.assert($v1.rank === 1 && $v2.rank === 1, ()=>`Error in outerProduct: inputs must be rank 1, but got ranks ` + `${$v1.rank} and ${$v2.rank}.`);
    const v12D = (0, $eP0pM.reshape)($v1, [
        -1,
        1
    ]);
    const v22D = (0, $eP0pM.reshape)($v2, [
        1,
        -1
    ]);
    return (0, $clO9Z.matMul)(v12D, v22D);
}
const $c1b13caf4c431643$export$8481b38c75c91cc7 = (0, $jKUCi.op)({
    outerProduct_: $c1b13caf4c431643$var$outerProduct_
});

});

parcelRegister("4xBxs", function(module, exports) {

$parcel$export(module.exports, "pad", () => $34e75ce7c3ef8fe7$export$5d04458e2a6c373e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Pads a `tf.Tensor` with a given value and paddings.
 *
 * This operation implements `CONSTANT` mode. For `REFLECT` and `SYMMETRIC`,
 * refer to `tf.mirrorPad`.
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that `paddings` is of given length.
 *   - `tf.pad1d`
 *   - `tf.pad2d`
 *   - `tf.pad3d`
 *   - `tf.pad4d`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * x.pad([[1, 2]]).print();
 * ```
 * @param x The tensor to pad.
 * @param paddings An array of length `R` (the rank of the tensor), where
 * each element is a length-2 tuple of ints `[padBefore, padAfter]`,
 * specifying how much to pad along each dimension of the tensor.
 * @param constantValue The pad value to use. Defaults to 0.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $34e75ce7c3ef8fe7$var$pad_(x, paddings, constantValue = 0) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'pad');
    if ($x.rank === 0) throw new Error('pad(scalar) is not defined. Pass non-scalar to pad');
    const attrs = {
        paddings: paddings,
        constantValue: constantValue
    };
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.PadV2), inputs, attrs);
}
const $34e75ce7c3ef8fe7$export$5d04458e2a6c373e = (0, $jKUCi.op)({
    pad_: $34e75ce7c3ef8fe7$var$pad_
});

});

parcelRegister("1VOOA", function(module, exports) {

$parcel$export(module.exports, "pad1d", () => $1682881a9f2f20c3$export$be67ff622a7fd5);

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $4xBxs = parcelRequire("4xBxs");
/**
 * Pads a `tf.Tensor1D` with a given value and paddings. See `pad` for details.
 */ function $1682881a9f2f20c3$var$pad1d_(x, paddings, constantValue = 0) {
    (0, $4tCOB.assert)(paddings.length === 2, ()=>'Invalid number of paddings. Must be length of 2.');
    return (0, $4xBxs.pad)(x, [
        paddings
    ], constantValue);
}
const $1682881a9f2f20c3$export$be67ff622a7fd5 = (0, $jKUCi.op)({
    pad1d_: $1682881a9f2f20c3$var$pad1d_
});

});

parcelRegister("1yKeQ", function(module, exports) {

$parcel$export(module.exports, "pad2d", () => $122cd56a84ed8dd5$export$38e9137d79715c2d);

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $4xBxs = parcelRequire("4xBxs");
/**
 * Pads a `tf.Tensor2D` with a given value and paddings. See `pad` for details.
 */ function $122cd56a84ed8dd5$var$pad2d_(x, paddings, constantValue = 0) {
    (0, $4tCOB.assert)(paddings.length === 2 && paddings[0].length === 2 && paddings[1].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $4xBxs.pad)(x, paddings, constantValue);
}
const $122cd56a84ed8dd5$export$38e9137d79715c2d = (0, $jKUCi.op)({
    pad2d_: $122cd56a84ed8dd5$var$pad2d_
});

});

parcelRegister("jGUcb", function(module, exports) {

$parcel$export(module.exports, "pad3d", () => $e55d87cf66b99bbd$export$880821ebecb16ceb);

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $4xBxs = parcelRequire("4xBxs");
/**
 * Pads a `tf.Tensor3D` with a given value and paddings. See `pad` for details.
 */ function $e55d87cf66b99bbd$var$pad3d_(x, paddings, constantValue = 0) {
    (0, $4tCOB.assert)(paddings.length === 3 && paddings[0].length === 2 && paddings[1].length === 2 && paddings[2].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $4xBxs.pad)(x, paddings, constantValue);
}
const $e55d87cf66b99bbd$export$880821ebecb16ceb = (0, $jKUCi.op)({
    pad3d_: $e55d87cf66b99bbd$var$pad3d_
});

});

parcelRegister("28oUY", function(module, exports) {

$parcel$export(module.exports, "pad4d", () => $18dfa84e45dc2b74$export$4aef6fb43f1346f4);

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $4xBxs = parcelRequire("4xBxs");
/**
 * Pads a `tf.Tensor4D` with a given value and paddings. See `pad` for details.
 */ function $18dfa84e45dc2b74$var$pad4d_(x, paddings, constantValue = 0) {
    (0, $4tCOB.assert)(paddings.length === 4 && paddings[0].length === 2 && paddings[1].length === 2 && paddings[2].length === 2 && paddings[3].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $4xBxs.pad)(x, paddings, constantValue);
}
const $18dfa84e45dc2b74$export$4aef6fb43f1346f4 = (0, $jKUCi.op)({
    pad4d_: $18dfa84e45dc2b74$var$pad4d_
});

});

parcelRegister("eahnV", function(module, exports) {

$parcel$export(module.exports, "pool", () => $02a9483206c5bcc4$export$7a0e2789ec54f0db);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jqmHD = parcelRequire("jqmHD");

var $7J0of = parcelRequire("7J0of");

var $yLVwv = parcelRequire("yLVwv");

var $jslkq = parcelRequire("jslkq");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");

var $95zUK = parcelRequire("95zUK");
/**
 * Performs an N-D pooling operation
 *
 * @param input The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param windowShape The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param poolingType The type of pooling, either 'max' or 'avg'.
 * @param pad The type of padding algorithm:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
 *         https://www.tensorflow.org/api_guides/python/nn#Convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in dilated pooling. Defaults to `[1, 1]`. If `dilationRate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $02a9483206c5bcc4$var$pool_(input, windowShape, poolingType, pad, dilations, strides, dimRoundingMode) {
    if (dilations == null) dilations = [
        1,
        1
    ];
    if (strides == null) strides = 1;
    if (pad === 0) pad = 'valid';
    const $x = (0, $5R1UY.convertToTensor)(input, 'x', 'maxPool');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $4tCOB.assert($yLVwv.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in pool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = $yLVwv.computePool2DInfo(x4D.shape, windowShape, strides, dilations, pad);
    const dilation = [
        convInfo.dilationHeight,
        convInfo.dilationWidth
    ];
    // The following implementation does batchToSpace(pool(spaceToBatch(x)))
    // whenever dilation > 1 since the TF kernels do not support dilation > 1.
    // tslint:disable-next-line:max-line-length
    // https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/nn_ops.py#L1037
    let basePadding;
    if (pad === 'same') basePadding = $02a9483206c5bcc4$var$withSpaceToBatchBasePaddings([
        convInfo.filterHeight,
        convInfo.filterWidth
    ], dilation);
    else basePadding = [
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    const isDilationOne = dilation[0] === 1 && dilation[1] === 1;
    const [adjustedPadding, adjustedCrops] = $02a9483206c5bcc4$var$requiredSpaceToBatchPaddings([
        convInfo.inHeight,
        convInfo.inWidth
    ], dilation, basePadding);
    const convertedPad = isDilationOne ? pad : 'valid';
    const convertedX = isDilationOne ? x4D : (0, $95zUK.spaceToBatchND)(x4D, dilation, adjustedPadding);
    const forwardOp = poolingType === 'avg' ? ()=>(0, $jqmHD.avgPool)(convertedX, windowShape, strides, convertedPad, dimRoundingMode) : ()=>(0, $jslkq.maxPool)(convertedX, windowShape, strides, convertedPad, dimRoundingMode);
    const y = forwardOp();
    const res = isDilationOne ? y : (0, $7J0of.batchToSpaceND)(y, dilation, adjustedCrops);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
// Helper function to compute crops and paddings for pool with dilation > 1.
// tslint:disable-next-line:max-line-length
// https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/array_ops.py#L2184
function $02a9483206c5bcc4$var$requiredSpaceToBatchPaddings(inputShape, blockShape, basePadding) {
    const padStart = basePadding.map((b)=>b[0]);
    const origPadEnd = basePadding.map((b)=>b[1]);
    const fullInputShape = inputShape.concat(padStart, origPadEnd);
    const padEndExtra = blockShape.map((b, i)=>(b - fullInputShape[i] % b) % b);
    const padEnd = origPadEnd.map((s, i)=>s + padEndExtra[i]);
    const paddings = blockShape.map((_, i)=>[
            padStart[i],
            padEnd[i]
        ]);
    const crops = blockShape.map((_, i)=>[
            0,
            padEndExtra[i]
        ]);
    return [
        paddings,
        crops
    ];
}
// Helper function to compute base paddings for pool with dilation > 1.
// tslint:disable-next-line:max-line-length
// https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/nn_ops.py#L524
function $02a9483206c5bcc4$var$withSpaceToBatchBasePaddings(filterShape, dilation) {
    // Spatial dimensions of the filters and the upsampled filters in which we
    // introduce (rate - 1) zeros between consecutive filter values.
    const dilatedFilterShape = filterShape.map((s, i)=>{
        return s + (s - 1) * (dilation[i] - 1);
    });
    const padExtraShape = dilatedFilterShape.map((s)=>s - 1);
    // When padding is odd, we pad more at end, following the same
    // convention as conv2d.
    const padExtraStart = padExtraShape.map((s)=>Math.floor(s / 2));
    const padExtraEnd = padExtraShape.map((s, i)=>s - padExtraStart[i]);
    return padExtraShape.map((_, i)=>{
        return [
            padExtraStart[i],
            padExtraEnd[i]
        ];
    });
}
const $02a9483206c5bcc4$export$7a0e2789ec54f0db = (0, $jKUCi.op)({
    pool_: $02a9483206c5bcc4$var$pool_
});

});
parcelRegister("95zUK", function(module, exports) {

$parcel$export(module.exports, "spaceToBatchND", () => $69e07082f2283926$export$effb9d7cae92012f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * This operation divides "spatial" dimensions `[1, ..., M]` of the input into
 * a grid of blocks of shape `blockShape`, and interleaves these blocks with
 * the "batch" dimension (0) such that in the output, the spatial
 * dimensions `[1, ..., M]` correspond to the position within the grid,
 * and the batch dimension combines both the position within a spatial block
 * and the original batch position. Prior to division into blocks,
 * the spatial dimensions of the input are optionally zero padded
 * according to `paddings`. See below for a precise description.
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [1, 2, 2, 1]);
 * const blockShape = [2, 2];
 * const paddings = [[0, 0], [0, 0]];
 *
 * x.spaceToBatchND(blockShape, paddings).print();
 * ```
 *
 * @param x A `tf.Tensor`. N-D with `x.shape` = `[batch] + spatialShape +
 * remainingShape`, where spatialShape has `M` dimensions.
 * @param blockShape A 1-D array. Must have shape `[M]`, all values must
 * be >= 1.
 * @param paddings A 2-D array. Must have shape `[M, 2]`, all values must be >=
 *     0. `paddings[i] = [padStart, padEnd]` specifies the amount to zero-pad
 * from input dimension `i + 1`, which corresponds to spatial dimension `i`. It
 * is required that
 * `(inputShape[i + 1] + padStart + padEnd) % blockShape[i] === 0`
 *
 * This operation is equivalent to the following steps:
 *
 * 1. Zero-pad the start and end of dimensions `[1, ..., M]` of the input
 * according to `paddings` to produce `padded` of shape paddedShape.
 *
 * 2. Reshape `padded` to `reshapedPadded` of shape:
 * `[batch] + [paddedShape[1] / blockShape[0], blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1], blockShape[M-1]] + remainingShape`
 *
 * 3. Permute dimensions of `reshapedPadded` to produce `permutedReshapedPadded`
 * of shape: `blockShape + [batch] + [paddedShape[1] / blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1]] + remainingShape`
 *
 * 4. Reshape `permutedReshapedPadded` to flatten `blockShape` into the
 * batch dimension, producing an output tensor of shape:
 * `[batch * prod(blockShape)] + [paddedShape[1] / blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1]] + remainingShape`
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $69e07082f2283926$var$spaceToBatchND_(x, blockShape, paddings) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'spaceToBatchND');
    $4tCOB.assert($x.rank >= 1 + blockShape.length, ()=>`input rank ${$x.rank} should be > than [blockShape] ${blockShape.length}`);
    $4tCOB.assert(paddings.length === blockShape.length, ()=>`paddings.shape[0] ${paddings.length} must be equal to [blockShape] ${blockShape.length}`);
    $4tCOB.assert($x.shape.reduce((a, b, i)=>{
        if (i > 0 && i <= blockShape.length) return a && (b + paddings[i - 1][0] + paddings[i - 1][1]) % blockShape[i - 1] === 0;
        return a;
    }, true), ()=>`input spatial dimensions ${$x.shape.slice(1)} with paddings ${paddings.toString()} must be divisible by blockShapes ${blockShape.toString()}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockShape: blockShape,
        paddings: paddings
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.SpaceToBatchND), inputs, attrs);
}
const $69e07082f2283926$export$effb9d7cae92012f = (0, $jKUCi.op)({
    spaceToBatchND_: $69e07082f2283926$var$spaceToBatchND_
});

});


parcelRegister("4Do8T", function(module, exports) {

$parcel$export(module.exports, "prelu", () => $35fd881b2a658470$export$5882f235222e6729);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes leaky rectified linear element-wise with parametric alphas.
 *
 * `x < 0 ? alpha * x : f(x) = x`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 * const alpha = tf.scalar(0.1);
 *
 * x.prelu(alpha).print();  // or tf.prelu(x, alpha)
 * ```
 * @param x The input tensor.
 * @param alpha Scaling factor for negative values.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $35fd881b2a658470$var$prelu_(x, alpha) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'prelu');
    const $alpha = (0, $5R1UY.convertToTensor)(alpha, 'alpha', 'prelu');
    const inputs = {
        x: $x,
        alpha: $alpha
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Prelu), inputs);
}
const $35fd881b2a658470$export$5882f235222e6729 = (0, $jKUCi.op)({
    prelu_: $35fd881b2a658470$var$prelu_
});

});

parcelRegister("5TfzT", function(module, exports) {

$parcel$export(module.exports, "prod", () => $449e2c4490028725$export$5e143010dea16c85);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $7qWZ5 = parcelRequire("7qWZ5");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the product of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.prod().print();  // or tf.prod(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.prod(axis).print();  // or tf.prod(x, axis)
 * ```
 *
 * @param x The input tensor to compute the product over. If the dtype is `bool`
 *   it will be converted to `int32` and the output dtype will be `int32`.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $449e2c4490028725$var$prod_(x, axis = null, keepDims = false) {
    let $x = (0, $5R1UY.convertToTensor)(x, 'x', 'prod');
    if ($x.dtype === 'bool') // bool is not an allowed type for the underlying kernel.
    $x = (0, $7qWZ5.cast)($x, 'int32');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Prod), inputs, attrs);
}
const $449e2c4490028725$export$5e143010dea16c85 = (0, $jKUCi.op)({
    prod_: $449e2c4490028725$var$prod_
});

});

parcelRegister("3E3zr", function(module, exports) {

$parcel$export(module.exports, "raggedGather", () => $2a77e08fbb1926a9$export$e7118f605df251dd);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
function $2a77e08fbb1926a9$var$raggedGather_(paramsNestedSplits, paramsDenseValues, indices, outputRaggedRank) {
    const $paramsNestedSplits = paramsNestedSplits.map((t, i)=>(0, $5R1UY.convertToTensor)(t, `tensors${i}`, 'raggedGather', 'int32'));
    const $paramsDenseValues = (0, $5R1UY.convertToTensor)(paramsDenseValues, 'paramsDenseValues', 'raggedGather');
    const $indices = (0, $5R1UY.convertToTensor)(indices, 'indices', 'raggedGather', 'int32');
    const inputs = {
        paramsNestedSplits: $paramsNestedSplits,
        paramsDenseValues: $paramsDenseValues,
        indices: $indices
    };
    const attrs = {
        outputRaggedRank: outputRaggedRank
    };
    const result = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.RaggedGather), inputs, attrs);
    return {
        outputNestedSplits: result.slice(0, result.length - 1),
        outputDenseValues: result[result.length - 1]
    };
}
const $2a77e08fbb1926a9$export$e7118f605df251dd = (0, $jKUCi.op)({
    raggedGather_: $2a77e08fbb1926a9$var$raggedGather_
});

});

parcelRegister("6D3aB", function(module, exports) {

$parcel$export(module.exports, "raggedTensorToTensor", () => $4d38d8167e8dcde6$export$621e390307cbbaa1);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Create a dense tensor from a ragged tensor, possibly altering its shape.
 *
 * The raggedTensorToTensor op creates a dense tensor from am array of row
 * partition tensors, a value vector, and default values. If the shape is
 * unspecified, the minimal shape required to contain all the elements in the
 * ragged tensor (the natural shape) will be used. If some dimensions are left
 * unspecified, then the size of the natural shape is used in that dimension.
 *
 * The defaultValue will be broadcast to the output shape. After that, the
 * values from the ragged tensor overwrite the default values. Note that the
 * defaultValue must have less dimensions than the value.
 *
 * The row partition tensors are in the order of the dimensions. At present, the
 * types can be: "ROW_SPLITS": the row_splits tensor from the ragged tensor.
 *   "VALUE_ROWIDS": the value_rowids tensor from the ragged tensor.
 *   "FIRST_DIM_SIZE": if value_rowids is used for the first dimension, then it
 * is preceded by "FIRST_DIM_SIZE".
 * ```
 * @param shape: A Tensor. Must be one of the following types: 'int32'. The
 *     desired shape of the output tensor. If left unspecified (empty), the
 *     minimal shape required to contain all the elements in the ragged tensor
 *     (the natural shape) will be used. If some dimensions are left
 *     unspecified, then the size of the natural shape is used in that
 *     dimension.
 *
 *     Note that dense dimensions cannot be modified by the shape argument.
 *     Trying to change the size of a dense dimension will cause the op to fail.
 *     Examples: natural shape: [4, 5, 6] shape: -1 output shape: [4, 5, 6]
 *
 *     natural shape: [4, 5, 6] shape: [3, -1, 2] output shape: [3, 5, 2]
 *
 *     natural shape: [4, 5, 6] shape: [3, 7, 2] output shape: [3, 7, 2]
 * @param values: A Tensor. A 1D tensor representing the values of the ragged
 *     tensor.
 * @param defaultValue: A Tensor. Must have the same type as values. The
 *     defaultValue when the shape is larger than the ragged tensor. The
 *     defaultValue is broadcast until it is the shape of the output tensor,
 *     and then overwritten by values in the ragged tensor. The default value
 *     must be compatible with this broadcast operation, and must have fewer
 *     dimensions than the value tensor.
 * @param rowPartitionTensors: A list of at least 1 Tensor objects with the same
 *     type in: 'int32'.
 * @param rowPartitionTypes: A list of strings. The types of the row partition
 *     tensors. At present, these can be:
 *     "ROW_SPLITS": the row_splits tensor from the ragged tensor.
 *     "VALUE_ROWIDS": the value_rowids tensor from the ragged tensor.
 *     "FIRST_DIM_SIZE": if value_rowids is used for the first dimension, then
 *         it is preceeded by "FIRST_DIM_SIZE". The tensors are in the order of
 *         the dimensions.
 * @return A Tensor. Has the same type as values.
 * @doc {heading: 'Operations', subheading: 'Ragged'}
 */ function $4d38d8167e8dcde6$var$raggedTensorToTensor_(shape, values, defaultValue, rowPartitionTensors, rowPartitionTypes) {
    const $shape = (0, $5R1UY.convertToTensor)(shape, 'shape', 'raggedTensorToTensor', 'int32');
    const $values = (0, $5R1UY.convertToTensor)(values, 'values', 'raggedTensorToTensor');
    const $defaultValue = (0, $5R1UY.convertToTensor)(defaultValue, 'defaultValue', 'raggedTensorToTensor', $values.dtype);
    const $rowPartitionTensors = rowPartitionTensors.map((t, i)=>(0, $5R1UY.convertToTensor)(t, `tensors${i}`, 'raggedTensorToTensor', 'int32'));
    const inputs = {
        shape: $shape,
        values: $values,
        defaultValue: $defaultValue,
        rowPartitionTensors: $rowPartitionTensors
    };
    const attrs = {
        rowPartitionTypes: rowPartitionTypes
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.RaggedTensorToTensor), inputs, attrs);
}
const $4d38d8167e8dcde6$export$621e390307cbbaa1 = (0, $jKUCi.op)({
    raggedTensorToTensor_: $4d38d8167e8dcde6$var$raggedTensorToTensor_
});

});

parcelRegister("9iMrt", function(module, exports) {

$parcel$export(module.exports, "rand", () => $6c5b5f1d3b428197$export$bb0a9c36cf454ea0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Creates a `tf.Tensor` with values sampled from a random number generator
 * function defined by the user.
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param randFunction A random number generator function which is called
 * for each element in the output tensor.
 * @param dtype The data type of the output tensor. Defaults to 'float32'.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $6c5b5f1d3b428197$var$rand_(shape, randFunction, dtype) {
    const size = (0, $4tCOB.sizeFromShape)(shape);
    let values = null;
    if (dtype == null || dtype === 'float32') values = new Float32Array(size);
    else if (dtype === 'int32') values = new Int32Array(size);
    else if (dtype === 'bool') values = new Uint8Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
    for(let i = 0; i < size; i++)values[i] = randFunction();
    return (0, $aHfUM.ENGINE).makeTensor(values, shape, dtype);
}
const $6c5b5f1d3b428197$export$bb0a9c36cf454ea0 = (0, $jKUCi.op)({
    rand_: $6c5b5f1d3b428197$var$rand_
});

});

parcelRegister("g5Npe", function(module, exports) {

$parcel$export(module.exports, "randomGamma", () => $bb736ff1479496b6$export$63a8048b65295cb7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $g81BN = parcelRequire("g81BN");

var $jKUCi = parcelRequire("jKUCi");

var $2K5fD = parcelRequire("2K5fD");
/**
 * Creates a `tf.Tensor` with values sampled from a gamma distribution.
 *
 * ```js
 * tf.randomGamma([2, 2], 1).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param alpha The shape parameter of the gamma distribution.
 * @param beta The inverse scale parameter of the gamma distribution. Defaults
 *     to 1.
 * @param dtype The data type of the output. Defaults to float32.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $bb736ff1479496b6$var$randomGamma_(shape, alpha, beta = 1, dtype = 'float32', seed) {
    if (beta == null) beta = 1;
    if (dtype == null) dtype = 'float32';
    if (dtype !== 'float32' && dtype !== 'int32') throw new Error(`Unsupported data type ${dtype}`);
    const rgamma = new (0, $2K5fD.RandGamma)(alpha, beta, dtype, seed);
    const res = (0, $g81BN.buffer)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = rgamma.nextValue();
    return res.toTensor();
}
const $bb736ff1479496b6$export$63a8048b65295cb7 = (0, $jKUCi.op)({
    randomGamma_: $bb736ff1479496b6$var$randomGamma_
});

});
parcelRegister("2K5fD", function(module, exports) {

$parcel$export(module.exports, "MPRandGauss", () => $1ff3f366454f01d5$export$d23b64058df0188a);
$parcel$export(module.exports, "RandGamma", () => $1ff3f366454f01d5$export$bffe1ad508acdb18);
$parcel$export(module.exports, "UniformRandom", () => $1ff3f366454f01d5$export$1e4a6d1367ace404);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ftPHE = parcelRequire("ftPHE");

var $jgvrL = parcelRequire("jgvrL");
class $1ff3f366454f01d5$export$d23b64058df0188a {
    constructor(mean, stdDeviation, dtype, truncated, seed){
        this.mean = mean;
        this.stdDev = stdDeviation;
        this.dtype = dtype;
        this.nextVal = NaN;
        this.truncated = truncated;
        if (this.truncated) {
            this.upper = this.mean + this.stdDev * 2;
            this.lower = this.mean - this.stdDev * 2;
        }
        const seedValue = seed ? seed : Math.random();
        this.random = $ftPHE.alea(seedValue.toString());
    }
    /** Returns next sample from a Gaussian distribution. */ nextValue() {
        if (!isNaN(this.nextVal)) {
            const value = this.nextVal;
            this.nextVal = NaN;
            return value;
        }
        let resultX, resultY;
        let isValid = false;
        while(!isValid){
            let v1, v2, s;
            do {
                v1 = 2 * this.random() - 1;
                v2 = 2 * this.random() - 1;
                s = v1 * v1 + v2 * v2;
            }while (s >= 1 || s === 0);
            const mul = Math.sqrt(-2 * Math.log(s) / s);
            resultX = this.mean + this.stdDev * v1 * mul;
            resultY = this.mean + this.stdDev * v2 * mul;
            if (!this.truncated || this.isValidTruncated(resultX)) isValid = true;
        }
        if (!this.truncated || this.isValidTruncated(resultY)) this.nextVal = this.convertValue(resultY);
        return this.convertValue(resultX);
    }
    /** Handles proper rounding for non-floating-point numbers. */ convertValue(value) {
        if (this.dtype == null || this.dtype === 'float32') return value;
        return Math.round(value);
    }
    /** Returns true if less than 2-standard-deviations from the mean. */ isValidTruncated(value) {
        return value <= this.upper && value >= this.lower;
    }
}
class $1ff3f366454f01d5$export$bffe1ad508acdb18 {
    constructor(alpha, beta, dtype, seed){
        this.alpha = alpha;
        this.beta = 1 / beta; // convert rate to scale parameter
        this.dtype = dtype;
        const seedValue = seed ? seed : Math.random();
        this.randu = $ftPHE.alea(seedValue.toString());
        this.randn = new $1ff3f366454f01d5$export$d23b64058df0188a(0, 1, dtype, false, this.randu());
        if (alpha < 1) this.d = alpha + 2 / 3;
        else this.d = alpha - 1 / 3;
        this.c = 1 / Math.sqrt(9 * this.d);
    }
    /** Returns next sample from a gamma distribution. */ nextValue() {
        let x2, v0, v1, x, u, v;
        while(true){
            do {
                x = this.randn.nextValue();
                v = 1 + this.c * x;
            }while (v <= 0);
            v *= v * v;
            x2 = x * x;
            v0 = 1 - 0.331 * x2 * x2;
            v1 = 0.5 * x2 + this.d * (1 - v + Math.log(v));
            u = this.randu();
            if (u < v0 || Math.log(u) < v1) break;
        }
        v = 1 / this.beta * this.d * v;
        if (this.alpha < 1) v *= Math.pow(this.randu(), 1 / this.alpha);
        return this.convertValue(v);
    }
    /** Handles proper rounding for non-floating-point numbers. */ convertValue(value) {
        if (this.dtype === 'float32') return value;
        return Math.round(value);
    }
}
class $1ff3f366454f01d5$export$1e4a6d1367ace404 {
    constructor(min = 0, max = 1, dtype, seed){
        /** Handles proper rounding for non floating point numbers. */ this.canReturnFloat = ()=>this.dtype == null || this.dtype === 'float32';
        this.min = min;
        this.range = max - min;
        this.dtype = dtype;
        if (seed == null) seed = Math.random();
        if (typeof seed === 'number') seed = seed.toString();
        if (!this.canReturnFloat() && this.range <= 1) throw new Error(`The difference between ${min} - ${max} <= 1 and dtype is not float`);
        this.random = $ftPHE.alea(seed);
    }
    convertValue(value) {
        if (this.canReturnFloat()) return value;
        return Math.round(value);
    }
    nextValue() {
        return this.convertValue(this.min + this.range * this.random());
    }
}
function $1ff3f366454f01d5$export$5f38b2eb2df54d68(values) {
    // https://en.wikipedia.org/wiki/Jarque%E2%80%93Bera_test
    const n = values.length;
    const s = $1ff3f366454f01d5$var$skewness(values);
    const k = $1ff3f366454f01d5$var$kurtosis(values);
    const jb = n / 6 * (Math.pow(s, 2) + 0.25 * Math.pow(k - 3, 2));
    // JB test requires 2-degress of freedom from Chi-Square @ 0.95:
    // http://www.itl.nist.gov/div898/handbook/eda/section3/eda3674.htm
    const CHI_SQUARE_2DEG = 5.991;
    if (jb > CHI_SQUARE_2DEG) throw new Error(`Invalid p-value for JB: ${jb}`);
}
function $1ff3f366454f01d5$export$3286e17febe230d(actual, expectedMean, expectedStdDev, epsilon) {
    if (epsilon == null) epsilon = (0, $jgvrL.testEpsilon)();
    const actualMean = $1ff3f366454f01d5$var$mean(actual);
    (0, $jgvrL.expectNumbersClose)(actualMean, expectedMean, epsilon);
    (0, $jgvrL.expectNumbersClose)($1ff3f366454f01d5$var$standardDeviation(actual, actualMean), expectedStdDev, epsilon);
}
function $1ff3f366454f01d5$var$mean(values) {
    let sum = 0;
    for(let i = 0; i < values.length; i++)sum += values[i];
    return sum / values.length;
}
function $1ff3f366454f01d5$var$standardDeviation(values, mean) {
    let squareDiffSum = 0;
    for(let i = 0; i < values.length; i++){
        const diff = values[i] - mean;
        squareDiffSum += diff * diff;
    }
    return Math.sqrt(squareDiffSum / values.length);
}
function $1ff3f366454f01d5$var$kurtosis(values) {
    // https://en.wikipedia.org/wiki/Kurtosis
    const valuesMean = $1ff3f366454f01d5$var$mean(values);
    const n = values.length;
    let sum2 = 0;
    let sum4 = 0;
    for(let i = 0; i < n; i++){
        const v = values[i] - valuesMean;
        sum2 += Math.pow(v, 2);
        sum4 += Math.pow(v, 4);
    }
    return 1 / n * sum4 / Math.pow(1 / n * sum2, 2);
}
function $1ff3f366454f01d5$var$skewness(values) {
    // https://en.wikipedia.org/wiki/Skewness
    const valuesMean = $1ff3f366454f01d5$var$mean(values);
    const n = values.length;
    let sum2 = 0;
    let sum3 = 0;
    for(let i = 0; i < n; i++){
        const v = values[i] - valuesMean;
        sum2 += Math.pow(v, 2);
        sum3 += Math.pow(v, 3);
    }
    return 1 / n * sum3 / Math.pow(1 / (n - 1) * sum2, 1.5);
}

});


parcelRegister("h5wle", function(module, exports) {

$parcel$export(module.exports, "randomNormal", () => $c70bfda01062ad59$export$a0ac5549a8bec918);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $g81BN = parcelRequire("g81BN");

var $jKUCi = parcelRequire("jKUCi");

var $2K5fD = parcelRequire("2K5fD");
/**
 * Creates a `tf.Tensor` with values sampled from a normal distribution.
 *
 * ```js
 * tf.randomNormal([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param mean The mean of the normal distribution.
 * @param stdDev The standard deviation of the normal distribution.
 * @param dtype The data type of the output.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $c70bfda01062ad59$var$randomNormal_(shape, mean = 0, stdDev = 1, dtype, seed) {
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type ${dtype}`);
    const randGauss = new (0, $2K5fD.MPRandGauss)(mean, stdDev, dtype, false, seed);
    const res = (0, $g81BN.buffer)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = randGauss.nextValue();
    return res.toTensor();
}
const $c70bfda01062ad59$export$a0ac5549a8bec918 = (0, $jKUCi.op)({
    randomNormal_: $c70bfda01062ad59$var$randomNormal_
});

});

parcelRegister("kww16", function(module, exports) {

$parcel$export(module.exports, "randomStandardNormal", () => $ef0fa1ae5327db6f$export$5a8aa20f8ebaee69);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jKUCi = parcelRequire("jKUCi");

var $h5wle = parcelRequire("h5wle");
/**
 * Creates a `tf.Tensor` with values sampled from a normal distribution.
 *
 * The generated values will have mean 0 and standard deviation 1.
 *
 * ```js
 * tf.randomStandardNormal([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param dtype The data type of the output.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $ef0fa1ae5327db6f$var$randomStandardNormal_(shape, dtype, seed) {
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type ${dtype}`);
    return (0, $h5wle.randomNormal)(shape, 0, 1, dtype, seed);
}
const $ef0fa1ae5327db6f$export$5a8aa20f8ebaee69 = (0, $jKUCi.op)({
    randomStandardNormal_: $ef0fa1ae5327db6f$var$randomStandardNormal_
});

});

parcelRegister("gOgMa", function(module, exports) {

$parcel$export(module.exports, "randomUniform", () => $c3ce543027e6395e$export$bd6fd37822e292fa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $g81BN = parcelRequire("g81BN");

var $jKUCi = parcelRequire("jKUCi");

var $2K5fD = parcelRequire("2K5fD");
/**
 * Creates a `tf.Tensor` with values sampled from a uniform distribution.
 *
 * The generated values follow a uniform distribution in the range [minval,
 * maxval). The lower bound minval is included in the range, while the upper
 * bound maxval is excluded.
 *
 * ```js
 * tf.randomUniform([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param minval The lower bound on the range of random values to generate.
 *   Defaults to 0.
 * @param maxval The upper bound on the range of random values to generate.
 *   Defaults to 1.
 * @param dtype The data type of the output tensor. Defaults to 'float32'.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $c3ce543027e6395e$var$randomUniform_(shape, minval = 0, maxval = 1, dtype = 'float32', seed) {
    const res = (0, $g81BN.buffer)(shape, dtype);
    const random = new (0, $2K5fD.UniformRandom)(minval, maxval, null, seed);
    for(let i = 0; i < res.values.length; i++)res.values[i] = random.nextValue();
    return res.toTensor();
}
const $c3ce543027e6395e$export$bd6fd37822e292fa = (0, $jKUCi.op)({
    randomUniform_: $c3ce543027e6395e$var$randomUniform_
});

});

parcelRegister("9qLoy", function(module, exports) {

$parcel$export(module.exports, "range", () => $6ddb4e72830860f3$export$d02631cccf789723);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");
function $6ddb4e72830860f3$export$d02631cccf789723(start, stop, step = 1, dtype = 'float32') {
    if (step === 0) throw new Error('Cannot have a step of zero');
    const attrs = {
        start: start,
        stop: stop,
        step: step,
        dtype: dtype
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Range), {} /* inputs */ , attrs);
}

});

parcelRegister("iseIE", function(module, exports) {

$parcel$export(module.exports, "reciprocal", () => $d6f64277072c555f$export$163bc8c839a1ac04);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes reciprocal of x element-wise: `1 / x`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, 2]);
 *
 * x.reciprocal().print();  // or tf.reciprocal(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $d6f64277072c555f$var$reciprocal_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'reciprocal');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Reciprocal), inputs);
}
const $d6f64277072c555f$export$163bc8c839a1ac04 = (0, $jKUCi.op)({
    reciprocal_: $d6f64277072c555f$var$reciprocal_
});

});

parcelRegister("1mZlL", function(module, exports) {

$parcel$export(module.exports, "relu", () => $0ff76f56e5df7096$export$16d1e4612cc0139f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes rectified linear element-wise: `max(x, 0)`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.relu().print();  // or tf.relu(x)
 * ```
 * @param x The input tensor. If the dtype is `bool`, the output dtype will be
 *     `int32`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $0ff76f56e5df7096$var$relu_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'relu');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Relu), inputs);
}
const $0ff76f56e5df7096$export$16d1e4612cc0139f = (0, $jKUCi.op)({
    relu_: $0ff76f56e5df7096$var$relu_
});

});

parcelRegister("4QFBe", function(module, exports) {

$parcel$export(module.exports, "relu6", () => $387c4988287b1d38$export$4a62bcb95e9c44c4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes rectified linear 6 element-wise: `min(max(x, 0), 6)`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 8]);
 *
 * x.relu6().print();  // or tf.relu6(x)
 * ```
 * @param x The input tensor. If the dtype is `bool`, the output dtype will be
 *     `int32`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $387c4988287b1d38$var$relu6_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'relu6');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Relu6), inputs);
}
const $387c4988287b1d38$export$4a62bcb95e9c44c4 = (0, $jKUCi.op)({
    relu6_: $387c4988287b1d38$var$relu6_
});

});

parcelRegister("do1MK", function(module, exports) {

$parcel$export(module.exports, "reverse", () => $9beee6bf0c9f72d9$export$66c1ae025e96b4bc);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Reverses a `tf.Tensor` along a specified axis.
 *
 * Also available are stricter rank-specific methods that assert that `x` is
 * of the given rank:
 *   - `tf.reverse1d`
 *   - `tf.reverse2d`
 *   - `tf.reverse3d`
 *   - `tf.reverse4d`
 *
 * Except `tf.reverse1d` (which does not have axis param), all methods have
 * same signature as this method.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.reverse().print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.reverse(axis).print();
 * ```
 * @param x The input tensor to be reversed.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $9beee6bf0c9f72d9$var$reverse_(x, axis) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'reverse');
    const inputs = {
        x: $x
    };
    const attrs = {
        dims: axis
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Reverse), inputs, attrs);
}
const $9beee6bf0c9f72d9$export$66c1ae025e96b4bc = (0, $jKUCi.op)({
    reverse_: $9beee6bf0c9f72d9$var$reverse_
});

});

parcelRegister("1vNdh", function(module, exports) {

$parcel$export(module.exports, "reverse1d", () => $119edc6f39accfe6$export$ec29ded9cbde7103);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $do1MK = parcelRequire("do1MK");
/**
 * Reverses a `tf.Tensor1D`.
 *
 * @param x The input tensor.
 */ function $119edc6f39accfe6$var$reverse1d_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'reverse');
    $4tCOB.assert($x.rank === 1, ()=>`Error in reverse1D: x must be rank 1 but got rank ${$x.rank}.`);
    return (0, $do1MK.reverse)($x, 0);
}
const $119edc6f39accfe6$export$ec29ded9cbde7103 = (0, $jKUCi.op)({
    reverse1d_: $119edc6f39accfe6$var$reverse1d_
});

});

parcelRegister("lNcpz", function(module, exports) {

$parcel$export(module.exports, "reverse2d", () => $fdd7cd384f0ff544$export$12170f5f8cb48014);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $do1MK = parcelRequire("do1MK");
/**
 * Reverses a `tf.Tensor2D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $fdd7cd384f0ff544$var$reverse2d_(x, axis) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'reverse');
    $4tCOB.assert($x.rank === 2, ()=>`Error in reverse2D: x must be rank 2 but got rank ${$x.rank}.`);
    return (0, $do1MK.reverse)($x, axis);
}
const $fdd7cd384f0ff544$export$12170f5f8cb48014 = (0, $jKUCi.op)({
    reverse2d_: $fdd7cd384f0ff544$var$reverse2d_
});

});

parcelRegister("lc66i", function(module, exports) {

$parcel$export(module.exports, "reverse3d", () => $f6df7363a5c4405e$export$1ecb65b2ca41f0e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $do1MK = parcelRequire("do1MK");
/**
 * Reverses a `tf.Tensor3D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $f6df7363a5c4405e$var$reverse3d_(x, axis) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'reverse');
    $4tCOB.assert($x.rank === 3, ()=>`Error in reverse3D: x must be rank 3 but got rank ${$x.rank}.`);
    return (0, $do1MK.reverse)($x, axis);
}
const $f6df7363a5c4405e$export$1ecb65b2ca41f0e = (0, $jKUCi.op)({
    reverse3d_: $f6df7363a5c4405e$var$reverse3d_
});

});

parcelRegister("d9lNy", function(module, exports) {

$parcel$export(module.exports, "reverse4d", () => $992d064fdcd23d45$export$76a1df46e0e42da4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $do1MK = parcelRequire("do1MK");
/**
 * Reverses a `tf.Tensor4D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $992d064fdcd23d45$var$reverse4d_(x, axis) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'reverse');
    $4tCOB.assert($x.rank === 4, ()=>`Error in reverse4D: x must be rank 4 but got rank ${$x.rank}.`);
    return (0, $do1MK.reverse)($x, axis);
}
const $992d064fdcd23d45$export$76a1df46e0e42da4 = (0, $jKUCi.op)({
    reverse4d_: $992d064fdcd23d45$var$reverse4d_
});

});

parcelRegister("9mGGG", function(module, exports) {

$parcel$export(module.exports, "round", () => $6d1747f50236780f$export$2077e0241d6afd3c);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes round of input `tf.Tensor` element-wise: `round(x)`.
 * It implements banker's rounding.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.round().print();  // or tf.round(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $6d1747f50236780f$var$round_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'round');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Round), inputs);
}
const $6d1747f50236780f$export$2077e0241d6afd3c = (0, $jKUCi.op)({
    round_: $6d1747f50236780f$var$round_
});

});

parcelRegister("bvzmJ", function(module, exports) {

$parcel$export(module.exports, "rsqrt", () => $860e05d3a9eb2ec1$export$1cc01d192953037e);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes reciprocal of square root of the input `tf.Tensor` element-wise:
 * `y = 1 / sqrt(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 4, -1]);
 *
 * x.rsqrt().print();  // or tf.rsqrt(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $860e05d3a9eb2ec1$var$rsqrt_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'rsqrt', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Rsqrt), inputs);
}
const $860e05d3a9eb2ec1$export$1cc01d192953037e = (0, $jKUCi.op)({
    rsqrt_: $860e05d3a9eb2ec1$var$rsqrt_
});

});

parcelRegister("fNXeh", function(module, exports) {

$parcel$export(module.exports, "selu", () => $b81960572f6a0f91$export$a5f8240d9e99b438);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes scaled exponential linear element-wise.
 *
 * `x < 0 ? scale * alpha * (exp(x) - 1) : scale * x`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.selu().print();  // or tf.selu(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $b81960572f6a0f91$var$selu_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'selu');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Selu), inputs);
}
const $b81960572f6a0f91$export$a5f8240d9e99b438 = (0, $jKUCi.op)({
    selu_: $b81960572f6a0f91$var$selu_
});

});

parcelRegister("iC1W9", function(module, exports) {

$parcel$export(module.exports, "separableConv2d", () => $d8cd4740db8a608f$export$2586c92899c2d0fb);

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jOBWR = parcelRequire("jOBWR");

var $kDOuZ = parcelRequire("kDOuZ");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * 2-D convolution with separable filters.
 *
 * Performs a depthwise convolution that acts separately on channels followed
 * by a pointwise convolution that mixes channels. Note that this is
 * separability between dimensions [1, 2] and 3, not spatial separability
 * between dimensions 1 and 2.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/separable_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/separable_conv2d)
 * for more details.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param depthwiseFilter The depthwise filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`. This is
 *     the filter used in the first step.
 * @param pointwiseFilter The pointwise filter tensor, rank 4, of shape
 *     `[1, 1, inChannels * channelMultiplier, outChannels]`. This is
 *     the filter used in the second step.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $d8cd4740db8a608f$var$separableConv2d_(x, depthwiseFilter, pointwiseFilter, strides, pad, dilation = [
    1,
    1
], dataFormat = 'NHWC') {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'separableConv2d');
    const $depthwiseFilter = (0, $5R1UY.convertToTensor)(depthwiseFilter, 'depthwiseFilter', 'separableConv2d');
    const $pointwiseFilter = (0, $5R1UY.convertToTensor)(pointwiseFilter, 'pointwiseFilter', 'separableConv2d');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    if (dataFormat === 'NCHW') throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");
    $4tCOB.assert(x4D.rank === 4, ()=>`Error in separableConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $4tCOB.assert($depthwiseFilter.rank === 4, ()=>`Error in separableConv2d: depthwise filter must be rank 4, but ` + `got rank ${$depthwiseFilter.rank}.`);
    $4tCOB.assert($pointwiseFilter.rank === 4, ()=>`Error in separableConv2d: pointwise filter must be rank 4, but ` + `got rank ${$depthwiseFilter.rank}.`);
    $4tCOB.assert($pointwiseFilter.shape[0] === 1, ()=>`Error in separableConv2d: the first dimension of pointwise filter ` + ` must be 1, but got ${$pointwiseFilter.shape[0]}.`);
    $4tCOB.assert($pointwiseFilter.shape[1] === 1, ()=>`Error in separableConv2d: the second dimension of pointwise ` + `filter must be 1, but got ${$pointwiseFilter.shape[1]}.`);
    const inChannels = $depthwiseFilter.shape[2];
    const channelMultiplier = $depthwiseFilter.shape[3];
    $4tCOB.assert($pointwiseFilter.shape[2] === inChannels * channelMultiplier, ()=>`Error in separableConv2d: the third dimension of pointwise filter ` + `must be ${inChannels * channelMultiplier}, ` + `but got ${$pointwiseFilter.shape[2]}.`);
    const depthwise = (0, $kDOuZ.depthwiseConv2d)(x4D, $depthwiseFilter, strides, pad, dataFormat, dilation);
    const pointwiseStride = 1;
    const res = (0, $jOBWR.conv2d)(depthwise, $pointwiseFilter, pointwiseStride, 'valid', dataFormat);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $d8cd4740db8a608f$export$2586c92899c2d0fb = (0, $jKUCi.op)({
    separableConv2d_: $d8cd4740db8a608f$var$separableConv2d_
});

});

parcelRegister("gLBco", function(module, exports) {

$parcel$export(module.exports, "setdiff1dAsync", () => $c34de406e8fca24b$export$cd50e5d116ec1774);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bVnU9 = parcelRequire("bVnU9");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");
/**
 * Computes the difference between two lists of numbers.
 *
 * Given a Tensor `x` and a Tensor `y`, this operation returns a Tensor `out`
 * that represents all values that are in `x` but not in `y`. The returned
 * Tensor `out` is sorted in the same order that the numbers appear in `x`
 * (duplicates are preserved). This operation also returns a Tensor indices that
 * represents the position of each out element in `x`. In other words:
 *
 * `out[i] = x[idx[i]] for i in [0, 1, ..., out.length - 1]`
 *
 * ```js
 * const x = [1, 2, 3, 4, 5, 6];
 * const y = [1, 3, 5];
 *
 * const [out, indices] = await tf.setdiff1dAsync(x, y);
 * out.print(); // [2, 4, 6]
 * indices.print(); // [1, 3, 5]
 * ```
 *
 * @param x 1-D Tensor. Values to keep.
 * @param y 1-D Tensor. Must have the same type as x. Values to exclude in the
 *     output.
 * @returns Promise of Tensor tuple [out, indices].
 *  out: Tensor with the same type as x.
 *  indices: A Tensor of type int32.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ async function $c34de406e8fca24b$var$setdiff1dAsync_(x, y) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'setdiff1d');
    const $y = (0, $5R1UY.convertToTensor)(y, 'y', 'setdiff1d');
    $4tCOB.assert($x.dtype === $y.dtype, ()=>`x and y should have the same dtype, but got x (${$x.dtype}) and y (${$y.dtype}).`);
    $4tCOB.assert($x.rank === 1, ()=>`x should be 1D tensor, but got x (${$x.shape}).`);
    $4tCOB.assert($y.rank === 1, ()=>`y should be 1D tensor, but got y (${$y.shape}).`);
    const xVals = await $x.data();
    const yVals = await $y.data();
    const ySet = new Set(yVals);
    let outputSize = 0;
    for(let i = 0; i < xVals.length; i++)if (!ySet.has(xVals[i])) outputSize++;
    const buffer = new (0, $bVnU9.TensorBuffer)([
        outputSize
    ], $x.dtype);
    const indices = new (0, $bVnU9.TensorBuffer)([
        outputSize
    ], 'int32');
    for(let i = 0, p = 0; i < xVals.length; i++)if (!ySet.has(xVals[i])) {
        buffer.values[p] = xVals[i];
        indices.values[p] = i;
        p++;
    }
    return [
        buffer.toTensor(),
        indices.toTensor()
    ];
}
const $c34de406e8fca24b$export$cd50e5d116ec1774 = $c34de406e8fca24b$var$setdiff1dAsync_;

});

parcelRegister("bJQkq", function(module, exports) {

$parcel$export(module.exports, "sign", () => $88bc7d04d795bc55$export$c5552dfdbc7cec71);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns an element-wise indication of the sign of a number.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3, NaN, 0]);
 *
 * x.sign().print();  // or tf.sign(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $88bc7d04d795bc55$var$sign_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'sign');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Sign), inputs);
}
const $88bc7d04d795bc55$export$c5552dfdbc7cec71 = (0, $jKUCi.op)({
    sign_: $88bc7d04d795bc55$var$sign_
});

});

parcelRegister("b37Kr", function(module, exports) {

$parcel$export(module.exports, "sin", () => $80b5fc212de3d500$export$5de3937cb4b592ed);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes sin of the input Tensor element-wise: `sin(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.sin().print();  // or tf.sin(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $80b5fc212de3d500$var$sin_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'sin', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Sin), inputs);
}
const $80b5fc212de3d500$export$5de3937cb4b592ed = (0, $jKUCi.op)({
    sin_: $80b5fc212de3d500$var$sin_
});

});

parcelRegister("8sXeR", function(module, exports) {

$parcel$export(module.exports, "sinh", () => $629ee3d889d91ddd$export$545004b505d7c555);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes hyperbolic sin of the input `tf.Tensor` element-wise: `sinh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.sinh().print();  // or tf.sinh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $629ee3d889d91ddd$var$sinh_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'sinh');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Sinh), inputs);
}
const $629ee3d889d91ddd$export$545004b505d7c555 = (0, $jKUCi.op)({
    sinh_: $629ee3d889d91ddd$var$sinh_
});

});

parcelRegister("5Uyxp", function(module, exports) {

$parcel$export(module.exports, "slice1d", () => $44dcf93474a557d9$export$95433662b275eb82);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $kvpGg = parcelRequire("kvpGg");
/**
 * Extracts a 1D slice from 1D array starting at coordinates `begin` and is
 * of length `size`. See `slice` for details.
 */ function $44dcf93474a557d9$var$slice1d_(x, begin, size) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'slice1d');
    $4tCOB.assert($x.rank === 1, ()=>`slice1d expects a rank-1 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $kvpGg.slice)($x, [
        begin
    ], [
        size
    ]);
}
const $44dcf93474a557d9$export$95433662b275eb82 = (0, $jKUCi.op)({
    slice1d_: $44dcf93474a557d9$var$slice1d_
});

});

parcelRegister("fhfPl", function(module, exports) {

$parcel$export(module.exports, "slice2d", () => $b1f4b880b31626cc$export$e5c6a6611cb43a9d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $kvpGg = parcelRequire("kvpGg");
/**
 * Extracts a 2D slice from a 2D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $b1f4b880b31626cc$var$slice2d_(x, begin, size) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'slice2d');
    $4tCOB.assert($x.rank === 2, ()=>`slice2d expects a rank-2 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $kvpGg.slice)($x, begin, size);
}
const $b1f4b880b31626cc$export$e5c6a6611cb43a9d = (0, $jKUCi.op)({
    slice2d_: $b1f4b880b31626cc$var$slice2d_
});

});

parcelRegister("eUdR5", function(module, exports) {

$parcel$export(module.exports, "slice3d", () => $ada10b029fd80738$export$dec56af20749d733);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $kvpGg = parcelRequire("kvpGg");
/**
 * Extracts a 3D slice from a 3D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $ada10b029fd80738$var$slice3d_(x, begin, size) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'slice3d');
    $4tCOB.assert($x.rank === 3, ()=>`slice3d expects a rank-3 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $kvpGg.slice)($x, begin, size);
}
const $ada10b029fd80738$export$dec56af20749d733 = (0, $jKUCi.op)({
    slice3d_: $ada10b029fd80738$var$slice3d_
});

});

parcelRegister("9y3CH", function(module, exports) {

$parcel$export(module.exports, "slice4d", () => $6f3a198819d3dfe7$export$9833e35e879da26c);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $kvpGg = parcelRequire("kvpGg");
/**
 * Extracts a 4D slice from a 4D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $6f3a198819d3dfe7$var$slice4d_(x, begin, size) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'slice4d');
    $4tCOB.assert($x.rank === 4, ()=>`slice4d expects a rank-4 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $kvpGg.slice)($x, begin, size);
}
const $6f3a198819d3dfe7$export$9833e35e879da26c = (0, $jKUCi.op)({
    slice4d_: $6f3a198819d3dfe7$var$slice4d_
});

});

parcelRegister("5q2Zg", function(module, exports) {

$parcel$export(module.exports, "softmax", () => $3f21b2a883aad40e$export$e008137e76238601);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the softmax normalized vector given the logits.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 *
 * a.softmax().print();  // or tf.softmax(a)
 * ```
 *
 * ```js
 * const a = tf.tensor2d([2, 4, 6, 1, 2, 3], [2, 3]);
 *
 * a.softmax().print();  // or tf.softmax(a)
 * ```
 *
 * @param logits The logits array.
 * @param dim The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $3f21b2a883aad40e$var$softmax_(logits, dim = -1) {
    const $logits = (0, $5R1UY.convertToTensor)(logits, 'logits', 'softmax', 'float32');
    if (dim === -1) dim = $logits.rank - 1;
    if (dim !== $logits.rank - 1) throw Error('Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${$logits.rank} and dim was ${dim}`);
    const inputs = {
        logits: $logits
    };
    const attrs = {
        dim: dim
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Softmax), inputs, attrs);
}
const $3f21b2a883aad40e$export$e008137e76238601 = (0, $jKUCi.op)({
    softmax_: $3f21b2a883aad40e$var$softmax_
});

});

parcelRegister("kY0nO", function(module, exports) {

$parcel$export(module.exports, "fft", () => $f439b55188e49d27$export$a535ef183b6128fa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Fast Fourier transform.
 *
 * Computes the 1-dimensional discrete Fourier transform over the inner-most
 * dimension of input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([1, 2, 3]);
 * const x = tf.complex(real, imag);
 *
 * x.fft().print();  // tf.spectral.fft(x).print();
 * ```
 * @param input The complex input to compute an fft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $f439b55188e49d27$var$fft_(input) {
    (0, $4tCOB.assert)(input.dtype === 'complex64', ()=>`The dtype for tf.spectral.fft() must be complex64 ` + `but got ${input.dtype}.`);
    const inputs = {
        input: input
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.FFT), inputs);
}
const $f439b55188e49d27$export$a535ef183b6128fa = (0, $jKUCi.op)({
    fft_: $f439b55188e49d27$var$fft_
});

});

parcelRegister("jxjwy", function(module, exports) {

$parcel$export(module.exports, "ifft", () => $e3903e76ad8b4453$export$776649b0bf8ce1fd);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Inverse fast Fourier transform.
 *
 * Computes the inverse 1-dimensional discrete Fourier transform over the
 * inner-most dimension of input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([1, 2, 3]);
 * const x = tf.complex(real, imag);
 *
 * x.ifft().print();  // tf.spectral.ifft(x).print();
 * ```
 * @param input The complex input to compute an ifft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $e3903e76ad8b4453$var$ifft_(input) {
    (0, $4tCOB.assert)(input.dtype === 'complex64', ()=>`The dtype for tf.spectral.ifft() must be complex64 ` + `but got ${input.dtype}.`);
    const inputs = {
        input: input
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.IFFT), inputs);
}
const $e3903e76ad8b4453$export$776649b0bf8ce1fd = (0, $jKUCi.op)({
    ifft_: $e3903e76ad8b4453$var$ifft_
});

});

parcelRegister("fiSk4", function(module, exports) {

$parcel$export(module.exports, "irfft", () => $b242acd0408cb147$export$f47f4e5bcd3d6a66);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bxdsK = parcelRequire("bxdsK");

var $6LWfo = parcelRequire("6LWfo");

var $7of6P = parcelRequire("7of6P");

var $r7fN6 = parcelRequire("r7fN6");

var $jKUCi = parcelRequire("jKUCi");

var $3XWb2 = parcelRequire("3XWb2");

var $eP0pM = parcelRequire("eP0pM");

var $do1MK = parcelRequire("do1MK");

var $j7yUF = parcelRequire("j7yUF");

var $kvpGg = parcelRequire("kvpGg");

var $jxjwy = parcelRequire("jxjwy");
/**
 * Inversed real value input fast Fourier transform.
 *
 * Computes the 1-dimensional inversed discrete Fourier transform over the
 * inner-most dimension of the real input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([0, 0, 0]);
 * const x = tf.complex(real, imag);
 *
 * x.irfft().print();
 * ```
 * @param input The real value input to compute an irfft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $b242acd0408cb147$var$irfft_(input) {
    const innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = input.size / innerDimensionSize;
    let ret;
    if (innerDimensionSize <= 2) {
        const complexInput = (0, $eP0pM.reshape)(input, [
            batch,
            innerDimensionSize
        ]);
        ret = (0, $jxjwy.ifft)(complexInput);
    } else {
        // The length of unique components of the DFT of a real-valued signal
        // is 2 * (input_len - 1)
        const outputShape = [
            batch,
            2 * (innerDimensionSize - 1)
        ];
        const realInput = (0, $eP0pM.reshape)((0, $3XWb2.real)(input), [
            batch,
            innerDimensionSize
        ]);
        const imagInput = (0, $eP0pM.reshape)((0, $7of6P.imag)(input), [
            batch,
            innerDimensionSize
        ]);
        const realConjugate = (0, $do1MK.reverse)((0, $kvpGg.slice)(realInput, [
            0,
            1
        ], [
            batch,
            innerDimensionSize - 2
        ]), 1);
        const imagConjugate = (0, $r7fN6.mul)((0, $do1MK.reverse)((0, $kvpGg.slice)(imagInput, [
            0,
            1
        ], [
            batch,
            innerDimensionSize - 2
        ]), 1), (0, $j7yUF.scalar)(-1));
        const r = (0, $6LWfo.concat)([
            realInput,
            realConjugate
        ], 1);
        const i = (0, $6LWfo.concat)([
            imagInput,
            imagConjugate
        ], 1);
        const complexInput = (0, $eP0pM.reshape)((0, $bxdsK.complex)(r, i), [
            outputShape[0],
            outputShape[1]
        ]);
        ret = (0, $jxjwy.ifft)(complexInput);
    }
    ret = (0, $3XWb2.real)(ret);
    // reshape the result if the input is 3D tensor.
    if (input.rank === 3 && input.shape[0] !== 0) {
        const temp = ret;
        const batch = input.shape[0];
        ret = (0, $eP0pM.reshape)(ret, [
            batch,
            ret.shape[0] / batch,
            ret.shape[1]
        ]);
        temp.dispose();
    }
    return ret;
}
const $b242acd0408cb147$export$f47f4e5bcd3d6a66 = (0, $jKUCi.op)({
    irfft_: $b242acd0408cb147$var$irfft_
});

});

parcelRegister("fBxya", function(module, exports) {

$parcel$export(module.exports, "rfft", () => $b5c45615f4cc634f$export$72aff1768917e9e5);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");

var $bxdsK = parcelRequire("bxdsK");

var $6LWfo = parcelRequire("6LWfo");

var $7of6P = parcelRequire("7of6P");

var $jKUCi = parcelRequire("jKUCi");

var $3XWb2 = parcelRequire("3XWb2");

var $eP0pM = parcelRequire("eP0pM");

var $kvpGg = parcelRequire("kvpGg");

var $9DjTt = parcelRequire("9DjTt");

var $7KCJq = parcelRequire("7KCJq");

var $k1Ozi = parcelRequire("k1Ozi");

var $kY0nO = parcelRequire("kY0nO");
/**
 * Real value input fast Fourier transform.
 *
 * Computes the 1-dimensional discrete Fourier transform over the
 * inner-most dimension of the real input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 *
 * real.rfft().print();
 * ```
 * @param input The real value input to compute an rfft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $b5c45615f4cc634f$var$rfft_(input, fftLength) {
    (0, $4tCOB.assert)(input.dtype === 'float32', ()=>`The dtype for rfft() must be real value but got ${input.dtype}`);
    let innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = input.size / innerDimensionSize;
    let adjustedInput;
    if (fftLength != null && fftLength < innerDimensionSize) {
        // Need to crop
        const begin = input.shape.map((v)=>0);
        const size = input.shape.map((v)=>v);
        size[input.shape.length - 1] = fftLength;
        adjustedInput = (0, $kvpGg.slice)(input, begin, size);
        innerDimensionSize = fftLength;
    } else if (fftLength != null && fftLength > innerDimensionSize) {
        // Need to pad with zeros
        const zerosShape = input.shape.map((v)=>v);
        zerosShape[input.shape.length - 1] = fftLength - innerDimensionSize;
        adjustedInput = (0, $6LWfo.concat)([
            input,
            (0, $7KCJq.zeros)(zerosShape)
        ], input.shape.length - 1);
        innerDimensionSize = fftLength;
    } else adjustedInput = input;
    // Complement the input with zero imaginary numbers.
    const zerosInput = (0, $k1Ozi.zerosLike)(adjustedInput);
    const complexInput = (0, $eP0pM.reshape)((0, $bxdsK.complex)(adjustedInput, zerosInput), [
        batch,
        innerDimensionSize
    ]);
    const ret = (0, $kY0nO.fft)(complexInput);
    // Exclude complex conjugations. These conjugations are put symmetrically.
    const half = Math.floor(innerDimensionSize / 2) + 1;
    const realValues = (0, $3XWb2.real)(ret);
    const imagValues = (0, $7of6P.imag)(ret);
    const realComplexConjugate = (0, $9DjTt.split)(realValues, [
        half,
        innerDimensionSize - half
    ], realValues.shape.length - 1);
    const imagComplexConjugate = (0, $9DjTt.split)(imagValues, [
        half,
        innerDimensionSize - half
    ], imagValues.shape.length - 1);
    const outputShape = adjustedInput.shape.slice();
    outputShape[adjustedInput.shape.length - 1] = half;
    return (0, $eP0pM.reshape)((0, $bxdsK.complex)(realComplexConjugate[0], imagComplexConjugate[0]), outputShape);
}
const $b5c45615f4cc634f$export$72aff1768917e9e5 = (0, $jKUCi.op)({
    rfft_: $b5c45615f4cc634f$var$rfft_
});

});
parcelRegister("9DjTt", function(module, exports) {

$parcel$export(module.exports, "split", () => $703730095965569b$export$65980d18b75784e2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Splits a `tf.Tensor` into sub tensors.
 *
 * If `numOrSizeSplits` is a number, splits `x` along dimension `axis`
 * into `numOrSizeSplits` smaller tensors.
 * Requires that `numOrSizeSplits` evenly divides `x.shape[axis]`.
 *
 * If `numOrSizeSplits` is a number array, splits `x` into
 * `numOrSizeSplits.length` pieces. The shape of the `i`-th piece has the
 * same size as `x` except along dimension `axis` where the size is
 * `numOrSizeSplits[i]`.
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4, 5, 6, 7, 8], [2, 4]);
 * const [a, b] = tf.split(x, 2, 1);
 * a.print();
 * b.print();
 *
 * const [c, d, e] = tf.split(x, [1, 2, 1], 1);
 * c.print();
 * d.print();
 * e.print();
 * ```
 *
 * @param x The input tensor to split.
 * @param numOrSizeSplits Either an integer indicating the number of
 * splits along the axis or an array of integers containing the sizes of
 * each output tensor along the axis. If a number then it must evenly divide
 * `x.shape[axis]`; otherwise the sum of sizes must match `x.shape[axis]`.
 * Can contain one -1 indicating that dimension is to be inferred.
 * @param axis The dimension along which to split. Defaults to 0 (the first
 * dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $703730095965569b$var$split_(x, numOrSizeSplits, axis = 0) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'split');
    const inputs = {
        x: $x
    };
    const attr = {
        numOrSizeSplits: numOrSizeSplits,
        axis: axis
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.SplitV), inputs, attr);
}
const $703730095965569b$export$65980d18b75784e2 = (0, $jKUCi.op)({
    split_: $703730095965569b$var$split_
});

});


parcelRegister("fRX4k", function(module, exports) {

$parcel$export(module.exports, "squaredDifference", () => $b8d9a0136abf82da$export$b178697fb6d0b37f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $eqTIO = parcelRequire("eqTIO");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Returns (a - b) * (a - b) element-wise.
 * Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.squaredDifference(b).print();  // or tf.squaredDifference(a, b)
 * ```
 *
 * ```js
 * // Broadcast squared difference  a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.squaredDifference(b).print();  // or tf.squaredDifference(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $b8d9a0136abf82da$var$squaredDifference_(a, b) {
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'squaredDifference');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'squaredDifference');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    (0, $eqTIO.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {};
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.SquaredDifference), inputs, attrs);
}
const $b8d9a0136abf82da$export$b178697fb6d0b37f = (0, $jKUCi.op)({
    squaredDifference_: $b8d9a0136abf82da$var$squaredDifference_
});

});

parcelRegister("wniip", function(module, exports) {

$parcel$export(module.exports, "squeeze", () => $06150efedd483728$export$889c931173b77c2f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Removes dimensions of size 1 from the shape of a `tf.Tensor`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4], [1, 1, 4]);
 * x.squeeze().print();
 * ```
 *
 * @param x The input tensor to be squeezed.
 * @param axis An optional list of numbers. If specified, only
 *     squeezes the dimensions listed. The dimension index starts at 0. It
 * is an error to squeeze a dimension that is not 1.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $06150efedd483728$var$squeeze_(x, axis) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'squeeze', 'string_or_numeric');
    return (0, $eP0pM.reshape)($x, (0, $4tCOB.squeezeShape)($x.shape, axis).newShape);
}
const $06150efedd483728$export$889c931173b77c2f = (0, $jKUCi.op)({
    squeeze_: $06150efedd483728$var$squeeze_
});

});

parcelRegister("iSKul", function(module, exports) {

$parcel$export(module.exports, "stack", () => $dbf154cb260d8be4$export$a57ab32f40f83ea9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Stacks a list of rank-`R` `tf.Tensor`s into one rank-`(R+1)` `tf.Tensor`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 * tf.stack([a, b, c]).print();
 * ```
 *
 * @param tensors A list of tensor objects with the same shape and dtype.
 * @param axis The axis to stack along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $dbf154cb260d8be4$var$stack_(tensors, axis = 0) {
    const $tensors = (0, $5R1UY.convertToTensorArray)(tensors, 'tensors', 'stack', 'string_or_numeric');
    $4tCOB.assert($tensors.length >= 1, ()=>'Pass at least one tensor to tf.stack');
    if ($tensors.length > 0) $4tCOB.assert(axis <= $tensors[0].rank, ()=>'Axis must be <= rank of the tensor');
    const inputs = $tensors;
    const attrs = {
        axis: axis
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Pack), inputs, attrs);
}
const $dbf154cb260d8be4$export$a57ab32f40f83ea9 = (0, $jKUCi.op)({
    stack_: $dbf154cb260d8be4$var$stack_
});

});

parcelRegister("4s2sX", function(module, exports) {

$parcel$export(module.exports, "step", () => $33dbb0a5b9bcbae9$export$35d34bc0ed591a92);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes step of the input `tf.Tensor` element-wise: `x > 0 ? 1 : alpha * x`
 *
 * ```js
 * const x = tf.tensor1d([0, 2, -1, -3]);
 *
 * x.step(.5).print();  // or tf.step(x, .5)
 * ```
 * @param x The input tensor.
 * @param alpha The gradient when input is negative.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $33dbb0a5b9bcbae9$var$step_(x, alpha = 0.0) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'step');
    const inputs = {
        x: $x
    };
    const attrs = {
        alpha: alpha
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Step), inputs, attrs);
}
const $33dbb0a5b9bcbae9$export$35d34bc0ed591a92 = (0, $jKUCi.op)({
    step_: $33dbb0a5b9bcbae9$var$step_
});

});

parcelRegister("lbPf7", function(module, exports) {

$parcel$export(module.exports, "stridedSlice", () => $f6d25fcb34d491a9$export$4ae57224f3b0605c);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Extracts a strided slice of a tensor.
 *
 * Roughly speaking, this op extracts a slice of size (end-begin)/stride from
 * the given input tensor (x). Starting at the location specified by begin the
 * slice continues by adding stride to the index until all dimensions are not
 * less than end. Note that a stride can be negative, which causes a reverse
 * slice.
 *
 * ```js
 * const t = tf.tensor3d([1, 1, 1 ,2, 2, 2, 3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6],
 *    [3, 2, 3]);
 * t.stridedSlice([1, 0, 0], [2, 1, 3], [1, 1, 1]).print()  // [[[3, 3, 3]]]
 * t.stridedSlice([1, 0, 0], [2, 2, 3], [1, 1, 1]).print()  // [[[3, 3, 3],
 *                                                     // [4, 4, 4]]]
 * t.stridedSlice([1, -1, 0], [2, -3, 3], [1, -1, 1]).print() // [[[4, 4, 4],
 *                                                     // [3, 3, 3]]]
 * ```
 *
 * @param x The tensor to stride slice.
 * @param begin The coordinates to start the slice from.
 * @param end: The coordinates to end the slice at.
 * @param strides: The size of the slice.
 * @param beginMask: If the ith bit of beginMask is set, begin[i] is ignored
 *      and the fullest possible range in that dimension is used instead.
 * @param endMask: If the ith bit of endMask is set, end[i] is ignored
 *      and the fullest possible range in that dimension is used instead.
 * @param shrinkAxisMask: a bitmask where bit i implies that
 * the ith specification should shrink the dimensionality. begin and end must
 * imply a slice of size 1 in the dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $f6d25fcb34d491a9$var$stridedSlice_(x, begin, end, strides, beginMask = 0, endMask = 0, ellipsisMask = 0, newAxisMask = 0, shrinkAxisMask = 0) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'stridedSlice', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    const attrs = {
        begin: begin,
        end: end,
        strides: strides,
        beginMask: beginMask,
        endMask: endMask,
        ellipsisMask: ellipsisMask,
        newAxisMask: newAxisMask,
        shrinkAxisMask: shrinkAxisMask
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.StridedSlice), inputs, attrs);
}
const $f6d25fcb34d491a9$export$4ae57224f3b0605c = (0, $jKUCi.op)({
    stridedSlice_: $f6d25fcb34d491a9$var$stridedSlice_
});

});

parcelRegister("1pSFt", function(module, exports) {

$parcel$export(module.exports, "tan", () => $1082882341239124$export$fcdd3b0b3246a325);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes tan of the input `tf.Tensor` element-wise, `tan(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.tan().print();  // or tf.tan(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $1082882341239124$var$tan_(x) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'tan', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Tan), inputs);
}
const $1082882341239124$export$fcdd3b0b3246a325 = (0, $jKUCi.op)({
    tan_: $1082882341239124$var$tan_
});

});

parcelRegister("jIDgY", function(module, exports) {

$parcel$export(module.exports, "tensor1d", () => $e5b0971c3ecdafe9$export$8133e3bf3cd8f464);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $lVIqi = parcelRequire("lVIqi");
function $e5b0971c3ecdafe9$export$8133e3bf3cd8f464(values, dtype) {
    (0, $4tCOB.assertNonNull)(values);
    const inferredShape = (0, $5R1UY.inferShape)(values, dtype);
    if (inferredShape.length !== 1) throw new Error('tensor1d() requires values to be a flat/TypedArray');
    const shape = null;
    return (0, $lVIqi.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("g4QpC", function(module, exports) {

$parcel$export(module.exports, "tensor2d", () => $bb45ad0c6f877eac$export$b5469a65e8732256);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $lVIqi = parcelRequire("lVIqi");
function $bb45ad0c6f877eac$export$b5469a65e8732256(values, shape, dtype) {
    (0, $4tCOB.assertNonNull)(values);
    if (shape != null && shape.length !== 2) throw new Error('tensor2d() requires shape to have two numbers');
    const inferredShape = (0, $5R1UY.inferShape)(values, dtype);
    if (inferredShape.length !== 2 && inferredShape.length !== 1) throw new Error('tensor2d() requires values to be number[][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");
    return (0, $lVIqi.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("RzdVf", function(module, exports) {

$parcel$export(module.exports, "tensor4d", () => $0a104604050b0c64$export$b43603ce4e7542a7);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $lVIqi = parcelRequire("lVIqi");
function $0a104604050b0c64$export$b43603ce4e7542a7(values, shape, dtype) {
    (0, $4tCOB.assertNonNull)(values);
    if (shape != null && shape.length !== 4) throw new Error('tensor4d() requires shape to have four numbers');
    const inferredShape = (0, $5R1UY.inferShape)(values, dtype);
    if (inferredShape.length !== 4 && inferredShape.length !== 1) throw new Error('tensor4d() requires values to be number[][][][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor4d() requires shape to be provided when `values` are a flat array");
    return (0, $lVIqi.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("7WV0q", function(module, exports) {

$parcel$export(module.exports, "tensor5d", () => $5c9a2b5a70356a10$export$ab0278981fc9e727);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $lVIqi = parcelRequire("lVIqi");
function $5c9a2b5a70356a10$export$ab0278981fc9e727(values, shape, dtype) {
    (0, $4tCOB.assertNonNull)(values);
    if (shape != null && shape.length !== 5) throw new Error('tensor5d() requires shape to have five numbers');
    const inferredShape = (0, $5R1UY.inferShape)(values, dtype);
    if (inferredShape.length !== 5 && inferredShape.length !== 1) throw new Error("tensor5d() requires values to be number[][][][][] or flat/TypedArray");
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor5d() requires shape to be provided when `values` are a flat array");
    return (0, $lVIqi.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("9lkzv", function(module, exports) {

$parcel$export(module.exports, "tensor6d", () => $6cd60859dab6a5cc$export$7b9f27dd2306a502);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $lVIqi = parcelRequire("lVIqi");
function $6cd60859dab6a5cc$export$7b9f27dd2306a502(values, shape, dtype) {
    (0, $4tCOB.assertNonNull)(values);
    if (shape != null && shape.length !== 6) throw new Error('tensor6d() requires shape to have six numbers');
    const inferredShape = (0, $5R1UY.inferShape)(values, dtype);
    if (inferredShape.length !== 6 && inferredShape.length !== 1) throw new Error("tensor6d() requires values to be number[][][][][][] or flat/TypedArray");
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor6d() requires shape to be provided when `values` are a flat array");
    shape = shape || inferredShape;
    return (0, $lVIqi.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("eW75q", function(module, exports) {

$parcel$export(module.exports, "topk", () => $adfbfab2c34d1cd7$export$4e6b28a600f8b4df);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Finds the values and indices of the `k` largest entries along the last
 * dimension.
 *
 * If the input is a vector (rank=1), finds the k largest entries in the vector
 * and outputs their values and indices as vectors. Thus values[j] is the j-th
 * largest entry in input, and its index is indices[j].
 * For higher rank inputs, computes the top k entries along the last dimension.
 *
 * If two elements are equal, the lower-index element appears first.
 *
 * ```js
 * const a = tf.tensor2d([[1, 5], [4, 3]]);
 * const {values, indices} = tf.topk(a);
 * values.print();
 * indices.print();
 * ```
 * @param x 1-D or higher `tf.Tensor` with last dimension being at least `k`.
 * @param k Number of top elements to look for along the last dimension.
 * @param sorted If true, the resulting `k` elements will be sorted by the
 *     values in descending order.
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $adfbfab2c34d1cd7$var$topk_(x, k = 1, sorted = true) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'topk');
    if ($x.rank === 0) throw new Error('topk() expects the input to be of rank 1 or higher');
    const lastDim = $x.shape[$x.shape.length - 1];
    if (k < 0) throw new Error(`'k' passed to topk() must be >= 0 but got ${k}`);
    if (k > lastDim) throw new Error(`'k' passed to topk() must be <= the last dimension (${lastDim}) ` + `but got ${k}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        k: k,
        sorted: sorted
    };
    const [values, indices] = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.TopK), inputs, attrs);
    return {
        values: values,
        indices: indices
    };
}
const $adfbfab2c34d1cd7$export$4e6b28a600f8b4df = (0, $jKUCi.op)({
    topk_: $adfbfab2c34d1cd7$var$topk_
});

});

parcelRegister("7y8Jw", function(module, exports) {

$parcel$export(module.exports, "truncatedNormal", () => $57f27ba271a74684$export$8ad5625727f3fa1d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $g81BN = parcelRequire("g81BN");

var $jKUCi = parcelRequire("jKUCi");

var $2K5fD = parcelRequire("2K5fD");
/**
 * Creates a `tf.Tensor` with values sampled from a truncated normal
 * distribution.
 *
 * ```js
 * tf.truncatedNormal([2, 2]).print();
 * ```
 *
 * The generated values follow a normal distribution with specified mean and
 * standard deviation, except that values whose magnitude is more than 2
 * standard deviations from the mean are dropped and re-picked.
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param mean The mean of the normal distribution.
 * @param stdDev The standard deviation of the normal distribution.
 * @param dtype The data type of the output tensor.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $57f27ba271a74684$var$truncatedNormal_(shape, mean = 0, stdDev = 1, dtype, seed) {
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type $ { dtype }`);
    const randGauss = new (0, $2K5fD.MPRandGauss)(mean, stdDev, dtype, true, seed);
    const res = (0, $g81BN.buffer)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = randGauss.nextValue();
    return res.toTensor();
}
const $57f27ba271a74684$export$8ad5625727f3fa1d = (0, $jKUCi.op)({
    truncatedNormal_: $57f27ba271a74684$var$truncatedNormal_
});

});

parcelRegister("gMT7b", function(module, exports) {

$parcel$export(module.exports, "unique", () => $c38be1affbb0409c$export$7a5d5c156e7dc406);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Finds unique elements along an axis of a tensor.
 *
 * It returns a tensor `values` containing all of the unique elements along the
 * `axis` of the given tensor `x` in the same order that they occur along the
 * `axis` in `x`; `x` does not need to be sorted. It also returns a tensor
 * `indices` the same size as the number of the elements in `x` along the `axis`
 * dimension. It contains the index in the unique output `values`.
 *
 * ```js
 * // A 1-D tensor
 * const a = tf.tensor1d([1, 1, 2, 4, 4, 4, 7, 8, 8]);
 * const {values, indices} = tf.unique(a);
 * values.print();   // [1, 2, 4, 7, 8,]
 * indices.print();  // [0, 0, 1, 2, 2, 2, 3, 4, 4]
 * ```
 *
 * ```js
 * // A 2-D tensor with axis=0
 * //
 * // 'a' is: [[1, 0, 0],
 * //          [1, 0, 0],
 * //          [2, 0, 0]]
 * const a = tf.tensor2d([[1, 0, 0], [1, 0, 0], [2, 0, 0]]);
 * const {values, indices} = tf.unique(a, 0)
 * values.print();   // [[1, 0, 0],
 *                   //  [2, 0, 0]]
 * indices.print();  // [0, 0, 1]
 * ```
 *
 * ```js
 * // A 2-D tensor with axis=1
 * //
 * // 'a' is: [[1, 0, 0],
 * //          [1, 0, 0],
 * //          [2, 0, 0]]
 * const a = tf.tensor2d([[1, 0, 0], [1, 0, 0], [2, 0, 0]]);
 * const {values, indices} = tf.unique(a, 1)
 * values.print();   // [[1, 0],
 *                   //  [1, 0],
 *                   //  [2, 0]]
 * indices.print();  // [0, 1, 1]
 * ```
 * @param x A tensor (int32, string, bool).
 * @param axis The axis of the tensor to find the unique elements.
 * @returns [uniqueElements, indices] (see above for details)
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $c38be1affbb0409c$var$unique_(x, axis = 0) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'unique', 'string_or_numeric');
    (0, $4tCOB.assert)($x.rank > 0, ()=>'The input tensor must be at least 1D');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    const [values, indices] = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Unique), inputs, attrs);
    return {
        values: values,
        indices: indices
    };
}
const $c38be1affbb0409c$export$7a5d5c156e7dc406 = (0, $jKUCi.op)({
    unique_: $c38be1affbb0409c$var$unique_
});

});

parcelRegister("grKBK", function(module, exports) {

$parcel$export(module.exports, "unsortedSegmentSum", () => $bf93525411cdd5cd$export$ba7c4d144d85a309);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the sum along segments of a `tf.Tensor`.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const segmentIds = tf.tensor1d([1, 2, 0, 1], 'int32');
 * const numSegments = 3;
 *
 * x.unsortedSegmentSum(segmentIds, numSegments).print()
 * //or tf.unsortedSegmentSum(x, segmentIds, numSegments)
 * ```
 * @param x The `tf.Tensor` that will be summed along its segments.
 * @param segmentIds A `tf.Tensor1D` whose rank is equal to the rank of `x`'s
 * dimension along the `axis`.  Maps each element of `x` to a segment.
 * @param numSegments The number of distinct `segmentIds`.
 *
 * @doc {heading: 'Operations', subheading: 'Segment'}
 */ function $bf93525411cdd5cd$var$unsortedSegmentSum_(x, segmentIds, numSegments) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'unsortedSegmentSum');
    const $segmentIds = (0, $5R1UY.convertToTensor)(segmentIds, 'segmentIds', 'unsortedSegmentSum', 'int32');
    (0, $4tCOB.assert)((0, $4tCOB.isInt)(numSegments), ()=>'numSegments must be of dtype int');
    const inputs = {
        x: $x,
        segmentIds: $segmentIds
    };
    const attrs = {
        numSegments: numSegments
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.UnsortedSegmentSum), inputs, attrs);
}
const $bf93525411cdd5cd$export$ba7c4d144d85a309 = (0, $jKUCi.op)({
    unsortedSegmentSum_: $bf93525411cdd5cd$var$unsortedSegmentSum_
});

});

parcelRegister("kDeMO", function(module, exports) {

$parcel$export(module.exports, "unstack", () => $f052eb7052241173$export$3c05285afa115eec);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Unstacks a `tf.Tensor` of rank-`R` into a list of rank-`(R-1)` `tf.Tensor`s.
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * tf.unstack(a).forEach(tensor => tensor.print());
 * ```
 *
 * @param x A tensor object.
 * @param axis The axis to unstack along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $f052eb7052241173$var$unstack_(x, axis = 0) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'unstack', 'string_or_numeric');
    $4tCOB.assert(axis >= -$x.shape.length && axis < $x.shape.length, ()=>`Axis = ${axis} is not in [-${$x.shape.length}, ${$x.shape.length})`);
    const inputs = {
        value: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Unpack), inputs, attrs);
}
const $f052eb7052241173$export$3c05285afa115eec = (0, $jKUCi.op)({
    unstack_: $f052eb7052241173$var$unstack_
});

});

parcelRegister("haXo2", function(module, exports) {

$parcel$export(module.exports, "upperBound", () => $c8116fcd6f1b243e$export$1e7f253df265a2ba);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $42FVE = parcelRequire("42FVE");
function $c8116fcd6f1b243e$export$1e7f253df265a2ba(sortedSequence, values) {
    return (0, $42FVE.searchSorted)(sortedSequence, values, 'right');
}

});

parcelRegister("3mBtj", function(module, exports) {

$parcel$export(module.exports, "variable", () => $27307e4b2b2c578e$export$3a9d57cefcd2c285);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");
function $27307e4b2b2c578e$export$3a9d57cefcd2c285(initialValue, trainable = true, name, dtype) {
    return (0, $aHfUM.ENGINE).makeVariable(initialValue, trainable, name, dtype);
}

});

parcelRegister("8waHC", function(module, exports) {

$parcel$export(module.exports, "whereAsync", () => $63399d332c769c30$export$b95962138b7a377d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e0fHM = parcelRequire("e0fHM");

var $5R1UY = parcelRequire("5R1UY");
/**
 * Returns the coordinates of true elements of condition.
 *
 * The coordinates are returned in a 2-D tensor where the first dimension (rows)
 * represents the number of true elements, and the second dimension (columns)
 * represents the coordinates of the true elements. Keep in mind, the shape of
 * the output tensor can vary depending on how many true values there are in
 * input. Indices are output in row-major order. The resulting tensor has the
 * shape `[numTrueElems, condition.rank]`.
 *
 * This is analogous to calling the python `tf.where(cond)` without an x or y.
 *
 * ```js
 * const cond = tf.tensor1d([false, false, true], 'bool');
 * const result = await tf.whereAsync(cond);
 * result.print();
 * ```
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ async function $63399d332c769c30$var$whereAsync_(condition) {
    const $condition = (0, $5R1UY.convertToTensor)(condition, 'condition', 'whereAsync', 'bool');
    const vals = await $condition.data();
    const res = (0, $e0fHM.whereImpl)($condition.shape, vals);
    if (condition !== $condition) $condition.dispose();
    return res;
}
const $63399d332c769c30$export$b95962138b7a377d = $63399d332c769c30$var$whereAsync_;

});
parcelRegister("e0fHM", function(module, exports) {

$parcel$export(module.exports, "whereImpl", () => $a31d3f7e07916a28$export$3a1005f93c3f4453);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /** An implementation of the Where kernel shared between cpu and webgl */ 
var $g81BN = parcelRequire("g81BN");
function $a31d3f7e07916a28$export$3a1005f93c3f4453(condShape, condVals) {
    const indices = [];
    for(let i = 0; i < condVals.length; i++)if (condVals[i]) indices.push(i);
    const inBuffer = (0, $g81BN.buffer)(condShape, 'int32');
    const out = (0, $g81BN.buffer)([
        indices.length,
        condShape.length
    ], 'int32');
    for(let i = 0; i < indices.length; i++){
        const loc = inBuffer.indexToLoc(indices[i]);
        const offset = i * condShape.length;
        out.values.set(loc, offset);
    }
    return out.toTensor();
}

});


parcelRegister("8ADzE", function(module, exports) {

$parcel$export(module.exports, "booleanMaskAsync", () => $641062195037a6a9$export$358a56c181f796b3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $kiLVE = parcelRequire("kiLVE");

var $eP0pM = parcelRequire("eP0pM");

var $wniip = parcelRequire("wniip");

var $8waHC = parcelRequire("8waHC");
/**
 * Apply boolean mask to tensor.
 *
 * ```js
 * const tensor = tf.tensor2d([1, 2, 3, 4, 5, 6], [3, 2]);
 * const mask = tf.tensor1d([1, 0, 1], 'bool');
 * const result = await tf.booleanMaskAsync(tensor, mask);
 * result.print();
 * ```
 *
 * @param tensor N-D tensor.
 * @param mask K-D boolean tensor, K <= N and K must be known statically.
 * @param axis A 0-D int Tensor representing the axis in tensor to mask from.
 *     By default, axis is 0 which will mask from the first dimension.
 *     Otherwise K + axis <= N.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ async function $641062195037a6a9$var$booleanMaskAsync_(tensor, mask, axis) {
    const $tensor = (0, $5R1UY.convertToTensor)(tensor, 'tensor', 'boolMask');
    const $mask = (0, $5R1UY.convertToTensor)(mask, 'mask', 'boolMask', 'bool');
    const axisFrom = axis == null ? 0 : axis;
    const maskDim = $mask.rank;
    const tensorShape = $tensor.shape;
    $4tCOB.assert(maskDim > 0, ()=>'mask cannot be scalar');
    $4tCOB.assertShapesMatch(tensorShape.slice(axisFrom, axisFrom + maskDim), $mask.shape, `mask's shape must match the first K dimensions of tensor's shape,`);
    let leadingSize = 1;
    for(let i = axisFrom; i < axisFrom + maskDim; i++)leadingSize *= tensorShape[i];
    const targetTensorShape = tensorShape.slice(0, axisFrom).concat([
        leadingSize
    ], tensorShape.slice(axisFrom + maskDim));
    const reshapedTensor = (0, $eP0pM.reshape)($tensor, targetTensorShape);
    const reshapedMask = (0, $eP0pM.reshape)($mask, [
        -1
    ]);
    const positivePositions = await (0, $8waHC.whereAsync)(reshapedMask);
    const indices = (0, $wniip.squeeze)(positivePositions, [
        1
    ]);
    const res = (0, $kiLVE.gather)(reshapedTensor, indices, axisFrom);
    // Ensure no memory leak.
    if (tensor !== $tensor) $tensor.dispose();
    if (mask !== $mask) $mask.dispose();
    indices.dispose();
    reshapedTensor.dispose();
    reshapedMask.dispose();
    positivePositions.dispose();
    return res;
}
const $641062195037a6a9$export$358a56c181f796b3 = $641062195037a6a9$var$booleanMaskAsync_;

});

parcelRegister("etmvs", function(module, exports) {

$parcel$export(module.exports, "movingAverage", () => $a8953b6db58b354c$export$e0ccbd22a5b3aab6);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $1ZrG5 = parcelRequire("1ZrG5");

var $gjFWY = parcelRequire("gjFWY");

var $r7fN6 = parcelRequire("r7fN6");

var $jKUCi = parcelRequire("jKUCi");

var $5MZxP = parcelRequire("5MZxP");

var $j7yUF = parcelRequire("j7yUF");

var $hkR0n = parcelRequire("hkR0n");
/**
 * Compute the moving average of a variable.
 *
 * Without zeroDebias, the moving average operation is defined by:
 *   `v += delta`
 * where
 *   `delta = (1 - decay) * (x - v)`
 *
 * With zeroDebias (default), the `delta` term is scaled to debias the
 * effect of the (assumed) zero-initialization of `v`.
 *   `delta /= (1 - decay ^ step)`
 *
 * For more details on the zero-debiasing algorithm, see:
 *   https://arxiv.org/abs/1412.6980
 *
 * Note that this function is completely stateless and does not keep track of
 * step count. The step count needs to be maintained by the caller and passed
 * in as `step`.
 *
 * @param v The current moving average value.
 * @param x New input value, must have the same shape and dtype as `v`.
 * @param decay The decay factor. Typical values are 0.95 and 0.99.
 * @param step Step count.
 * @param zeroDebias: Whether zeroDebias is to be performed (default: `true`).
 * @returns The new moving average value.
 *
 * @doc {heading: 'Operations', subheading: 'Moving Average'}
 */ function $a8953b6db58b354c$var$movingAverage_(v, x, decay, step, zeroDebias = true) {
    const $v = (0, $5R1UY.convertToTensor)(v, 'v', 'movingAverage');
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'movingAverage');
    const $decay = (0, $5R1UY.convertToTensor)(decay, 'decay', 'movingAverage');
    (0, $1vhox.assertTypesMatch)($v, $x);
    $4tCOB.assert($4tCOB.arraysEqual($v.shape, $x.shape), ()=>'Shape mismatch in v and x');
    const one = (0, $j7yUF.scalar)(1);
    const oneMinusDecay = (0, $hkR0n.sub)(one, $decay);
    let update = (0, $r7fN6.mul)((0, $hkR0n.sub)($x, $v), oneMinusDecay);
    if (zeroDebias) {
        $4tCOB.assert(step != null, ()=>'When using zeroDebias: true, step is required.');
        const $step = (0, $5R1UY.convertToTensor)(step, 'step', 'movingAverage');
        update = (0, $gjFWY.div)(update, (0, $hkR0n.sub)(one, (0, $5MZxP.pow)($decay, $step)));
    }
    return (0, $1ZrG5.add)($v, update);
}
const $a8953b6db58b354c$export$e0ccbd22a5b3aab6 = (0, $jKUCi.op)({
    movingAverage_: $a8953b6db58b354c$var$movingAverage_
});

});

parcelRegister("kXkoS", function(module, exports) {

$parcel$export(module.exports, "scatterND", () => $f419246a47cf84a3$export$5349ba4fee4e4c76);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");

var $bSeux = parcelRequire("bSeux");
/**
 * Creates a new tensor by applying sparse updates to individual
 * values or slices within a zero tensor of the given shape tensor according to
 * indices. This operator is the inverse of the `tf.gatherND` operator which
 * extracts values or slices from a given tensor.
 *
 * ```js
 * const indices = tf.tensor2d([4, 3, 1, 7], [4, 1], 'int32');
 * const updates = tf.tensor1d([9, 10, 11, 12]);
 * const shape = [8];
 * tf.scatterND(indices, updates, shape).print() //[0, 11, 0, 10, 9, 0, 0, 12]
 * ```
 *
 * @param indices The tensor contains the indices into the output tensor.
 * @param updates The tensor contains the value for the indices.
 * @param shape: The shape of the output tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $f419246a47cf84a3$var$scatterND_(indices, updates, shape) {
    const $indices = (0, $5R1UY.convertToTensor)(indices, 'indices', 'scatterND', 'int32');
    const $updates = (0, $5R1UY.convertToTensor)(updates, 'updates', 'scatterND');
    $bSeux.validateInput($updates, $indices, shape);
    const inputs = {
        indices: $indices,
        updates: $updates
    };
    const attrs = {
        shape: shape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.ScatterNd), inputs, attrs);
}
const $f419246a47cf84a3$export$5349ba4fee4e4c76 = (0, $jKUCi.op)({
    scatterND_: $f419246a47cf84a3$var$scatterND_
});

});

parcelRegister("gcdMR", function(module, exports) {

$parcel$export(module.exports, "sparseToDense", () => $bca87623d3878c9e$export$1be4b823dd1a3080);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $3CjZ7 = parcelRequire("3CjZ7");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Converts a sparse representation into a dense tensor.
 *
 * Builds an array dense with shape outputShape such that:
 *
 * // If sparseIndices is scalar
 * dense[i] = (i == sparseIndices ? sparseValues : defaultValue)
 *
 * // If sparseIndices is a vector, then for each i
 * dense[sparseIndices[i]] = sparseValues[i]
 *
 * // If sparseIndices is an n by d matrix, then for each i in [0, n)
 * dense[sparseIndices[i][0], ..., sparseIndices[i][d-1]] = sparseValues[i]
 * All other values in dense are set to defaultValue. If sparseValues is a
 * scalar, all sparse indices are set to this single value.
 *
 * If indices are repeated the final value is summed over all values for those
 * indices.
 *
 * ```js
 * const indices = tf.tensor1d([4, 5, 6, 1, 2, 3], 'int32');
 * const values = tf.tensor1d([10, 11, 12, 13, 14, 15], 'float32');
 * const shape = [8];
 * tf.sparseToDense(indices, values, shape).print();
 * ```
 *
 * @param sparseIndices A 0-D, 1-D, or 2-D Tensor of type int32.
 * sparseIndices[i] contains the complete index where sparseValues[i] will be
 * placed.
 * @param sparseValues A 0-D or 1-D Tensor. Values
 * corresponding to each row of sparseIndices, or a scalar value to be used for
 * all sparse indices.
 * @param outputShape Shape of the dense output tensor. The type is inferred.
 * @param defaultValue Scalar. Value to set for indices not specified in
 * sparseIndices. Defaults to zero.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $bca87623d3878c9e$var$sparseToDense_(sparseIndices, sparseValues, outputShape, defaultValue = 0) {
    const $sparseIndices = (0, $5R1UY.convertToTensor)(sparseIndices, 'sparseIndices', 'sparseToDense', 'int32');
    const $sparseValues = (0, $5R1UY.convertToTensor)(sparseValues, 'sparseValues', 'sparseToDense', 'string_or_numeric');
    const $defaultValue = (0, $5R1UY.convertToTensor)(defaultValue, 'defaultValue', 'sparseToDense', $sparseValues.dtype);
    $3CjZ7.validateInput($sparseIndices, $sparseValues, outputShape, $defaultValue);
    const inputs = {
        sparseIndices: $sparseIndices,
        sparseValues: $sparseValues,
        defaultValue: $defaultValue
    };
    const attrs = {
        outputShape: outputShape
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.SparseToDense), inputs, attrs);
}
const $bca87623d3878c9e$export$1be4b823dd1a3080 = (0, $jKUCi.op)({
    sparseToDense_: $bca87623d3878c9e$var$sparseToDense_
});

});
parcelRegister("3CjZ7", function(module, exports) {

$parcel$export(module.exports, "validateInput", () => $2a246c3fadef4941$export$4d09d4ac8ba225dd);
/**
 * Validate sparseToDense inputs.
 *
 * @param sparseIndices A 0-D, 1-D, or 2-D Tensor of type int32.
 * sparseIndices[i] contains the complete index where sparseValues[i] will be
 * placed.
 * @param sparseValues A 0-D or 1-D Tensor. Values
 * corresponding to each row of sparseIndices, or a scalar value to be used for
 * all sparse indices.
 * @param outputShape number[]. Shape of the dense output tensor.
 * @param validateIndices boolean. indice validation is not supported, error
 * will be thrown if it is set.
 */ function $2a246c3fadef4941$export$4d09d4ac8ba225dd(sparseIndices, sparseValues, outputShape, defaultValues) {
    if (sparseIndices.dtype !== 'int32') throw new Error('tf.sparseToDense() expects the indices to be int32 type,' + ` but the dtype was ${sparseIndices.dtype}.`);
    if (sparseIndices.rank > 2) throw new Error('sparseIndices should be a scalar, vector, or matrix,' + ` but got shape ${sparseIndices.shape}.`);
    const numElems = sparseIndices.rank > 0 ? sparseIndices.shape[0] : 1;
    const numDims = sparseIndices.rank > 1 ? sparseIndices.shape[1] : 1;
    if (outputShape.length !== numDims) throw new Error('outputShape has incorrect number of elements:,' + ` ${outputShape.length}, should be: ${numDims}.`);
    const numValues = sparseValues.size;
    if (!(sparseValues.rank === 0 || sparseValues.rank === 1 && numValues === numElems)) throw new Error('sparseValues has incorrect shape ' + `${sparseValues.shape}, should be [] or [${numElems}]`);
    if (sparseValues.dtype !== defaultValues.dtype) throw new Error('sparseValues.dtype must match defaultValues.dtype');
}

});


parcelRegister("4tNZf", function(module, exports) {

$parcel$export(module.exports, "gatherND", () => $3430a53b5fa08b9b$export$15ec1b40f43d319f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Gather slices from input tensor into a Tensor with shape specified by
 * `indices`.
 *
 * `indices` is a K-dimensional integer tensor, best thought of as a
 * (K-1)-dimensional tensor of indices into input, where each element defines a
 * slice of input:
 * output[\\(i_0, ..., i_{K-2}\\)] = input[indices[\\(i_0, ..., i_{K-2}\\)]]
 *
 * Whereas in `tf.gather`, `indices` defines slices into the first dimension of
 * input, in `tf.gatherND`, `indices` defines slices into the first N dimensions
 * of input, where N = indices.shape[-1].
 *
 * The last dimension of indices can be at most the rank of input:
 * indices.shape[-1] <= input.rank
 *
 * The last dimension of `indices` corresponds to elements
 * (if indices.shape[-1] == input.rank) or slices
 * (if indices.shape[-1] < input.rank) along dimension indices.shape[-1] of
 * input.
 * The output tensor has shape
 * indices.shape[:-1] + input.shape[indices.shape[-1]:]
 *
 * Note that on CPU, if an out of bound index is found, an error is returned. On
 * GPU, if an out of bound index is found, a 0 is stored in the corresponding
 * output value.
 *
 * ```js
 * const indices = tf.tensor2d([0, 1, 1, 0], [2,2], 'int32');
 * const input = tf.tensor2d([9, 10, 11, 12], [2, 2]);
 * tf.gatherND(input, indices).print() // [10, 11]
 * ```
 *
 * @param x The tensor from which to gather values.
 * @param indices Index tensor, must be of type int32.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $3430a53b5fa08b9b$var$gatherND_(x, indices) {
    const $indices = (0, $5R1UY.convertToTensor)(indices, 'indices', 'gatherND', 'int32');
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'gatherND', 'string_or_numeric');
    const inputs = {
        params: $x,
        indices: $indices
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.GatherNd), inputs);
}
const $3430a53b5fa08b9b$export$15ec1b40f43d319f = (0, $jKUCi.op)({
    gatherND_: $3430a53b5fa08b9b$var$gatherND_
});

});

parcelRegister("jJRIZ", function(module, exports) {

$parcel$export(module.exports, "dropout", () => $e5ebe4dd487ce709$export$fe05aa12367b4e47);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bVnU9 = parcelRequire("bVnU9");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $1ZrG5 = parcelRequire("1ZrG5");

var $gjFWY = parcelRequire("gjFWY");

var $jsTm3 = parcelRequire("jsTm3");

var $hnXfr = parcelRequire("hnXfr");

var $r7fN6 = parcelRequire("r7fN6");

var $jKUCi = parcelRequire("jKUCi");

var $gOgMa = parcelRequire("gOgMa");
/**
 * Computes dropout.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 2, 1]);
 * const rate = 0.75;
 * const output = tf.dropout(x, rate);
 * output.print();
 * ```
 *
 * @param x A floating point Tensor or TensorLike.
 * @param rate A float in the range [0, 1). The probability that each element
 *   of x is discarded.
 * @param noiseShape An array of numbers of type int32, representing the
 * shape for randomly generated keep/drop flags. If the noiseShape has null
 * value, it will be automatically replaced with the x's relative dimension
 * size. Optional.
 * @param seed Used to create random seeds. Optional.
 * @returns A Tensor of the same shape of x.
 *
 * @doc {heading: 'Operations', subheading: 'Dropout'}
 */ function $e5ebe4dd487ce709$var$dropout_(x, rate, noiseShape, seed) {
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'dropout');
    $4tCOB.assert($x.dtype === 'float32', ()=>`x has to be a floating point tensor since it's going to be ` + `scaled, but got a ${$x.dtype} tensor instead.`);
    $4tCOB.assert(rate >= 0 && rate < 1, ()=>`rate must be a float in the range [0, 1), but got ${rate}.`);
    if (rate === 0) return x instanceof (0, $bVnU9.Tensor) ? $x.clone() : $x;
    const $noiseShape = (0, $jsTm3.getNoiseShape)($x, noiseShape);
    const keepProb = 1 - rate;
    const multiplier = (0, $gjFWY.div)((0, $hnXfr.floor)((0, $1ZrG5.add)((0, $gOgMa.randomUniform)($noiseShape, 0, 1, 'float32', seed), keepProb)), keepProb);
    return (0, $r7fN6.mul)($x, multiplier);
}
const $e5ebe4dd487ce709$export$fe05aa12367b4e47 = (0, $jKUCi.op)({
    dropout_: $e5ebe4dd487ce709$var$dropout_
});

});
parcelRegister("jsTm3", function(module, exports) {

$parcel$export(module.exports, "getNoiseShape", () => $e2bb921f3e2a5f80$export$5cc59b1f6d856c8e);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
function $e2bb921f3e2a5f80$export$5cc59b1f6d856c8e(x, noiseShape) {
    if (noiseShape == null) return x.shape.slice();
    if ($4tCOB.arraysEqual(x.shape, noiseShape)) return noiseShape;
    if (x.shape.length === noiseShape.length) {
        const newDimension = [];
        for(let i = 0; i < x.shape.length; i++)if (noiseShape[i] == null && x.shape[i] != null) newDimension.push(x.shape[i]);
        else newDimension.push(noiseShape[i]);
        return newDimension;
    }
    return noiseShape;
}

});


parcelRegister("4w6Gi", function(module, exports) {

$parcel$export(module.exports, "enclosingPowerOfTwo", () => $349f555462da4703$export$6fc2fe3b19043bf3);
$parcel$export(module.exports, "cosineWindow", () => $349f555462da4703$export$e875398ce092ee45);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jIDgY = parcelRequire("jIDgY");
function $349f555462da4703$export$6fc2fe3b19043bf3(value) {
    // Return 2**N for integer N such that 2**N >= value.
    return Math.floor(Math.pow(2, Math.ceil(Math.log(value) / Math.log(2.0))));
}
function $349f555462da4703$export$e875398ce092ee45(windowLength, a, b) {
    const even = 1 - windowLength % 2;
    const newValues = new Float32Array(windowLength);
    for(let i = 0; i < windowLength; ++i){
        const cosArg = 2.0 * Math.PI * i / (windowLength + even - 1);
        newValues[i] = a - b * Math.cos(cosArg);
    }
    return (0, $jIDgY.tensor1d)(newValues, 'float32');
}

});

parcelRegister("jUv2e", function(module, exports) {

$parcel$export(module.exports, "inTopKAsync", () => $e7eb522b439e12cc$export$395be9a27e7de9f0);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $ec8bD = parcelRequire("ec8bD");
/**
 * Returns whether the targets are in the top K predictions.
 *
 * ```js
 * const predictions = tf.tensor2d([[20, 10, 40, 30], [30, 50, -20, 10]]);
 * const targets = tf.tensor1d([2, 0]);
 * const precision = await tf.inTopKAsync(predictions, targets);
 * precision.print();
 * ```
 * @param predictions 2-D or higher `tf.Tensor` with last dimension being
 *     at least `k`.
 * @param targets 1-D or higher `tf.Tensor`.
 * @param k Optional Number of top elements to look at for computing precision,
 *     default to 1.
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ async function $e7eb522b439e12cc$var$inTopKAsync_(predictions, targets, k = 1) {
    const $predictions = (0, $5R1UY.convertToTensor)(predictions, 'predictions', 'inTopK');
    const $targets = (0, $5R1UY.convertToTensor)(targets, 'targets', 'inTopK');
    (0, $4tCOB.assert)($predictions.rank > 1, ()=>'inTopK() expects the predictions to be of rank 2 or higher, ' + `but got ${$predictions.rank}`);
    (0, $4tCOB.assert)($predictions.rank - 1 === $targets.rank, ()=>`predictions rank should be 1 larger than ` + `targets rank, but got predictions rank ` + `${$predictions.rank} and targets rank ${$targets.rank}`);
    (0, $4tCOB.assertShapesMatch)($predictions.shape.slice(0, $predictions.shape.length - 1), $targets.shape, `predictions's shape should be align with the targets' shape, ` + 'except the last dimension.');
    const lastDim = $predictions.shape[$predictions.shape.length - 1];
    (0, $4tCOB.assert)(k > 0 && k <= lastDim, ()=>`'k' passed to inTopK() must be > 0 && <= the predictions last ` + `dimension (${lastDim}), but got ${k}`);
    const predictionsVals = await $predictions.data();
    const targetsVals = await $targets.data();
    // Reshape predictionsVals into a 2d tensor [batch, lastDim]
    // and look up topK along lastDim.
    const [batch, size] = [
        predictionsVals.length / lastDim,
        lastDim
    ];
    const precision = (0, $4tCOB.getTypedArrayFromDType)('bool', batch);
    for(let b = 0; b < batch; b++){
        const offset = b * size;
        const vals = predictionsVals.subarray(offset, offset + size);
        const valAndInd = [];
        for(let i = 0; i < vals.length; i++)valAndInd.push({
            value: vals[i],
            index: i
        });
        valAndInd.sort((a, b)=>b.value - a.value);
        precision[b] = 0;
        for(let i = 0; i < k; i++)if (valAndInd[i].index === targetsVals[b]) {
            precision[b] = 1;
            break;
        }
    }
    if (predictions !== $predictions) $predictions.dispose();
    if (targets !== $targets) $targets.dispose();
    // Output precision has the same shape as targets.
    return (0, $ec8bD.tensor)(precision, $targets.shape, 'bool');
}
const $e7eb522b439e12cc$export$395be9a27e7de9f0 = $e7eb522b439e12cc$var$inTopKAsync_;

});

parcelRegister("kyRlD", function(module, exports) {

$parcel$export(module.exports, "conv2d", () => (parcelRequire("fZ5Hc")).conv2d);
$parcel$export(module.exports, "depthwiseConv2d", () => (parcelRequire("5yYYx")).depthwiseConv2d);
$parcel$export(module.exports, "matMul", () => (parcelRequire("je0gK")).matMul);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fZ5Hc = parcelRequire("fZ5Hc");

var $5yYYx = parcelRequire("5yYYx");

var $je0gK = parcelRequire("je0gK");

});
parcelRegister("fZ5Hc", function(module, exports) {

$parcel$export(module.exports, "conv2d", () => $ba30f894ee5e728c$export$188f9215482e3db8);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $jFQG4 = parcelRequire("jFQG4");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $1ZrG5 = parcelRequire("1ZrG5");

var $eqTIO = parcelRequire("eqTIO");

var $jOBWR = parcelRequire("jOBWR");

var $26YQK = parcelRequire("26YQK");

var $f0966 = parcelRequire("f0966");

var $yLVwv = parcelRequire("yLVwv");

var $eg4Z1 = parcelRequire("eg4Z1");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes a 2D convolution over the input x, optionally fused with adding a
 * bias and applying an activation.
 *
 * ```js
 * const inputDepth = 2;
 * const inShape = [2, 2, 2, inputDepth];
 * const outputDepth = 2;
 * const fSize = 1;
 * const pad = 0;
 * const strides = 1;
 *
 * const x = tf.tensor4d( [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
 * 16], inShape);
 * const w = tf.tensor4d([-1, 1, -2, 0.5], [fSize, fSize, inputDepth,
 * outputDepth]);
 *
 * tf.fused.conv2d({ x, filter: w, strides, pad, dataFormat: 'NHWC',
 * dilations: [1, 1], bias: tf.scalar(5), activation: 'relu' }).print();
 * ```
 *
 * @param obj An object with the following properties:
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid` output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param bias Tensor to be added to the result.
 * @param activation Name of activation kernel (defaults to `linear`) to be
 *     applied
 *      after biasAdd.
 * @param preluActivationWeights Tensor of prelu weights to be applied as part
 *     of a `prelu` activation, typically the same shape as `x`.
 * @param leakyreluAlpha Optional. Alpha to be applied as part of a `leakyrelu`
 *     activation.
 */ function $ba30f894ee5e728c$var$fusedConv2d_({ x: x, filter: filter, strides: strides, pad: pad, dataFormat: dataFormat = 'NHWC', dilations: dilations = [
    1,
    1
], dimRoundingMode: dimRoundingMode, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha }) {
    activation = activation || 'linear';
    if ((0, $eg4Z1.shouldFuse)((0, $aHfUM.ENGINE).state.gradientDepth, activation) === false) {
        // TODO: Transpose bias and preluActivationWeights properly for NCHW
        // format before computation.
        $4tCOB.assert(dataFormat === 'NHWC', ()=>`Error in fused conv2d: got dataFormat of ${dataFormat} but ` + `only NHWC is currently supported for the case of gradient depth ` + `is 0 and the activation is not linear.`);
        let result = (0, $jOBWR.conv2d)(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
        if (bias != null) result = (0, $1ZrG5.add)(result, bias);
        return (0, $eg4Z1.applyActivation)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'conv2d', 'float32');
    const $filter = (0, $5R1UY.convertToTensor)(filter, 'filter', 'conv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $4tCOB.assert(x4D.rank === 4, ()=>`Error in fused conv2d: input must be rank 4, but got rank ` + `${x4D.rank}.`);
    $4tCOB.assert($filter.rank === 4, ()=>`Error in fused conv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    $yLVwv.checkPadOnDimRoundingMode('fused conv2d', pad, dimRoundingMode);
    const inputChannels = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $4tCOB.assert($filter.shape[2] === inputChannels, ()=>`Error in conv2d: depth of input (${inputChannels}) must match ` + `input depth for filter ${$filter.shape[2]}.`);
    $4tCOB.assert($yLVwv.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in conv2D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = $yLVwv.computeConv2DInfo(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode);
    let $bias;
    if (bias != null) {
        $bias = (0, $5R1UY.convertToTensor)(bias, 'bias', 'fused conv2d');
        [$bias] = (0, $1vhox.makeTypesMatch)($bias, $x);
        // According to TensorFlow, the bias is supposed be a 1-D tensor or a
        // scalar.
        //
        // 3-D or 4-D bias is not disabled for NHWC format, because they are
        // currently being used in some cases. For examplem in our code base,
        // https://github.com/tensorflow/tfjs/blob/b53bd47e880367ae57493f0ea628abaf08db2d5d/tfjs-core/src/ops/fused/fused_conv2d_test.ts#L1972.
        if (dataFormat === 'NHWC') $eqTIO.assertAndGetBroadcastShape(convInfo.outShape, $bias.shape);
        else {
            $4tCOB.assert($bias.shape.length <= 1, ()=>`Error in fused conv2d: only supports scalar or 1-D Tensor ` + `bias for NCHW format but got the bias of ` + `rank-${$bias.shape.length}.`);
            $4tCOB.assert($bias.shape.length === 0 || $bias.shape[0] === convInfo.outChannels || $bias.shape[0] === 1, ()=>`Error in fused conv2d: bias shape (${$bias.shape}) is not ` + `compatible with the number of output channels ` + `(${convInfo.outChannels})`);
        }
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) {
        // PReLU's activation weights could be a scalar, a 1-D tensor or a 3-D
        // tensor.
        const alphaShape = preluActivationWeights.shape;
        $4tCOB.assert(alphaShape.length <= 1 || alphaShape.length === 3, ()=>`Error in fused conv2d: only supports scalar, 1-D Tensor or ` + `3-D Tensor PReLU activation weights but got a tensor of ` + `rank-${alphaShape.length}.`);
        if (alphaShape.length === 1) // Whether the data format is NCHW or NHWC, the 1-D PReLU activation
        // weights tensor should be aligned with the output channels of conv2d
        // result.
        $4tCOB.assert(alphaShape[0] === 1 || alphaShape[0] === convInfo.outChannels, ()=>`Error in fused conv2d: PReLU activation weights ` + `(${alphaShape}) is not compatible with the number of output ` + `channels (${convInfo.outChannels}).`);
        else if (alphaShape.length === 3) // Whether the data format is NCHW or NHWC, the PReLU activation weights
        // tensor should has the compatible shape with the result of conv2d.
        try {
            $eqTIO.assertAndGetBroadcastShape(alphaShape, convInfo.outShape);
        } catch (e) {
            const errMsg = `Error in fused conv2d: PReLU activation weights (${alphaShape}) ` + `is not compatible with the output shape of the conv2d ` + `(${convInfo.outShape}).`;
            throw Error(errMsg);
        }
        $preluActivationWeights = (0, $5R1UY.convertToTensor)(preluActivationWeights, 'prelu weights', 'fused conv2d');
    }
    const grad = (dy, saved)=>{
        $4tCOB.assert(dataFormat === 'NHWC', ()=>`Error in gradient of fused conv2D: got dataFormat of ${dataFormat} but only NHWC is currently supported.`);
        const [$filter, x4D, y, $bias] = saved;
        const dyActivation = (0, $eg4Z1.getFusedDyActivation)(dy, y, activation);
        $4tCOB.assert($yLVwv.tupleValuesAreOne(dilations), ()=>'Error in gradient of fused conv2D: ' + `dilation rates greater than 1 ` + `are not yet supported in gradients. Got dilations '${dilations}'`);
        const xDer = (0, $f0966.conv2DBackpropInput)(x4D.shape, dyActivation, $filter, strides, pad);
        const filterDer = (0, $26YQK.conv2DBackpropFilter)(x4D, dyActivation, $filter.shape, strides, pad);
        const der = [
            xDer,
            filterDer
        ];
        if ($bias != null) {
            const biasDer = (0, $eg4Z1.getFusedBiasGradient)($bias, dyActivation);
            der.push(biasDer);
        }
        return der;
    };
    const inputs = {
        x: x4D,
        filter: $filter,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $jFQG4.customGrad)((x4D, filter, save)=>{
            let res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.FusedConv2D), inputs, attrs);
            save([
                filter,
                x4D,
                res
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $eP0pM.reshape)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOp(x4D, $filter);
    } else {
        const customOpWithBias = (0, $jFQG4.customGrad)((x4D, filter, bias, save)=>{
            let res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.FusedConv2D), inputs, attrs);
            save([
                filter,
                x4D,
                res,
                bias
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $eP0pM.reshape)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOpWithBias(x4D, $filter, $bias);
    }
}
const $ba30f894ee5e728c$export$188f9215482e3db8 = (0, $jKUCi.op)({
    fusedConv2d_: $ba30f894ee5e728c$var$fusedConv2d_
});

});
parcelRegister("26YQK", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropFilter", () => $189b57c84f0bc131$export$652a30c9379f3de7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $4tCOB = parcelRequire("4tCOB");

var $yLVwv = parcelRequire("yLVwv");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the derivative of the filter of a 2D convolution.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     [batch, height, width, inChannels]. If rank 3, batch of 1 is assumed.
 * @param dy The dy image, of rank 4 or rank 3, of shape
 *     [batch, height, width, outDepth]. If rank 3, batch of 1 is assumed.
 * @param filterShape The shape of the filter, length 4,
 *     [filterHeight, filterWidth, inDepth, outDepth].
 * @param strides The strides of the convolution: [strideHeight,
 * strideWidth].
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $189b57c84f0bc131$var$conv2DBackpropFilter_(x, dy, filterShape, strides, pad, dataFormat = 'NHWC', dimRoundingMode) {
    let x4D = x;
    if (x.rank === 3) x4D = (0, $eP0pM.reshape)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    let dy4D = dy;
    if (dy4D.rank === 3) dy4D = (0, $eP0pM.reshape)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2]
    ]);
    $4tCOB.assert(x4D.rank === 4, ()=>`Error in conv2dDerFilter: input must be rank 4, but got shape ` + `${x4D.shape}.`);
    $4tCOB.assert(dy4D.rank === 4, ()=>`Error in conv2dDerFilter: dy must be rank 4, but got shape ` + `${dy4D.shape}.`);
    $4tCOB.assert(filterShape.length === 4, ()=>`Error in conv2dDerFilter: filterShape must be length 4, but got ` + `${filterShape}.`);
    const inDepth = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    const outDepth = dataFormat === 'NHWC' ? dy4D.shape[3] : dy4D.shape[1];
    $4tCOB.assert(inDepth === filterShape[2], ()=>`Error in conv2dDerFilter: depth of input ${inDepth}) must ` + `match input depth in filter (${filterShape[2]}.`);
    $4tCOB.assert(outDepth === filterShape[3], ()=>`Error in conv2dDerFilter: depth of dy (${outDepth}) must ` + `match output depth for filter (${filterShape[3]}).`);
    $yLVwv.checkPadOnDimRoundingMode('conv2dDerFilter', pad, dimRoundingMode);
    const inputs = {
        x: x4D,
        dy: dy4D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dimRoundingMode: dimRoundingMode,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Conv2DBackpropFilter), inputs, attrs);
}
const $189b57c84f0bc131$export$652a30c9379f3de7 = (0, $jKUCi.op)({
    conv2DBackpropFilter_: $189b57c84f0bc131$var$conv2DBackpropFilter_
});

});

parcelRegister("eg4Z1", function(module, exports) {

$parcel$export(module.exports, "getFusedDyActivation", () => $a6166ce37bbec21c$export$a1905aed55f51aef);
$parcel$export(module.exports, "getFusedBiasGradient", () => $a6166ce37bbec21c$export$1a797e236ae09d1f);
$parcel$export(module.exports, "applyActivation", () => $a6166ce37bbec21c$export$a0f250a2ba84196);
$parcel$export(module.exports, "shouldFuse", () => $a6166ce37bbec21c$export$4904add493b957ab);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eqTIO = parcelRequire("eqTIO");

var $aYszp = parcelRequire("aYszp");

var $8XuOv = parcelRequire("8XuOv");

var $r7fN6 = parcelRequire("r7fN6");

var $4Do8T = parcelRequire("4Do8T");

var $1mZlL = parcelRequire("1mZlL");

var $4QFBe = parcelRequire("4QFBe");

var $eP0pM = parcelRequire("eP0pM");

var $5B3nT = parcelRequire("5B3nT");

var $4s2sX = parcelRequire("4s2sX");

var $fVwnn = parcelRequire("fVwnn");
function $a6166ce37bbec21c$export$a1905aed55f51aef(dy, y, activation) {
    if (activation == null || activation === 'linear') return dy;
    if (activation === 'relu') return (0, $r7fN6.mul)(dy, (0, $4s2sX.step)(y));
    throw new Error(`Cannot compute gradient for fused activation ${activation}.`);
}
function $a6166ce37bbec21c$export$1a797e236ae09d1f(bias, dyActivation) {
    let res = dyActivation;
    const reduceAxes = $eqTIO.getReductionAxes(bias.shape, dyActivation.shape);
    if (reduceAxes.length > 0) res = (0, $fVwnn.sum)(res, reduceAxes);
    return (0, $eP0pM.reshape)(res, bias.shape);
}
function $a6166ce37bbec21c$export$a0f250a2ba84196(x, activation, preluActivationWeights, leakyreluAlpha) {
    if (activation === 'linear') return x;
    else if (activation === 'relu') return (0, $1mZlL.relu)(x);
    else if (activation === 'elu') return (0, $aYszp.elu)(x);
    else if (activation === 'relu6') return (0, $4QFBe.relu6)(x);
    else if (activation === 'prelu') return (0, $4Do8T.prelu)(x, preluActivationWeights);
    else if (activation === 'leakyrelu') return (0, $8XuOv.leakyRelu)(x, leakyreluAlpha);
    else if (activation === 'sigmoid') return (0, $5B3nT.sigmoid)(x);
    throw new Error(`Unknown fused activation ${activation}.`);
}
const $a6166ce37bbec21c$export$4904add493b957ab = (gradientDepth, activation)=>{
    const gradientMode = gradientDepth > 0;
    return !gradientMode || activation === 'linear';
};

});


parcelRegister("5yYYx", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2d", () => $40cf6d2d5406a823$export$48a8ad9494a8fad8);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $jFQG4 = parcelRequire("jFQG4");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $1ZrG5 = parcelRequire("1ZrG5");

var $eqTIO = parcelRequire("eqTIO");

var $yLVwv = parcelRequire("yLVwv");

var $kDOuZ = parcelRequire("kDOuZ");

var $f6z1x = parcelRequire("f6z1x");

var $b9Kdj = parcelRequire("b9Kdj");

var $eg4Z1 = parcelRequire("eg4Z1");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes depthwise 2D convolution, optionally fused with adding a
 * bias and applying an activation.
 *
 * Given a 4D `input` array and a `filter` array of shape
 * `[filterHeight, filterWidth, inChannels, channelMultiplier]` containing
 * `inChannels` convolutional filters of depth 1, this op applies a
 * different filter to each input channel (expanding from 1 channel to
 * `channelMultiplier` channels for each), then concatenates the results
 * together. The output has `inChannels * channelMultiplier` channels.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d)
 * for more details.
 *
 * @param obj An object with the following properties:
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param bias Tensor to be added to the result.
 * @param activation Name of activation kernel (defaults to `linear`).
 * @param preluActivationWeights Tensor of prelu weights to be applied as part
 *     of a `prelu` activation, typically the same shape as `x`.
 * @param leakyreluAlpha Optional. Alpha to be applied as part of a `leakyrelu`
 *     activation.
 */ function $40cf6d2d5406a823$var$fusedDepthwiseConv2d_({ x: x, filter: filter, strides: strides, pad: pad, dataFormat: dataFormat = 'NHWC', dilations: dilations = [
    1,
    1
], dimRoundingMode: dimRoundingMode, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha }) {
    if ((0, $eg4Z1.shouldFuse)((0, $aHfUM.ENGINE).state.gradientDepth, activation) === false) {
        let result = (0, $kDOuZ.depthwiseConv2d)(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
        if (bias != null) result = (0, $1ZrG5.add)(result, bias);
        return (0, $eg4Z1.applyActivation)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    const $x = (0, $5R1UY.convertToTensor)(x, 'x', 'depthwiseConv2d', 'float32');
    const $filter = (0, $5R1UY.convertToTensor)(filter, 'filter', 'depthwiseConv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $eP0pM.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $4tCOB.assert(x4D.rank === 4, ()=>`Error in fused depthwiseConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $4tCOB.assert($filter.rank === 4, ()=>`Error in fused depthwiseConv2d: filter must be rank 4, ` + `but got rank ${$filter.rank}.`);
    $4tCOB.assert(x4D.shape[3] === $filter.shape[2], ()=>`Error in fused depthwiseConv2d: number of input channels ` + `(${x4D.shape[3]}) must match the inChannels dimension in ` + `filter ${$filter.shape[2]}.`);
    if (dilations == null) dilations = [
        1,
        1
    ];
    $4tCOB.assert($yLVwv.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in fused depthwiseConv2d: Either strides or dilations must ' + `be 1. Got strides ${strides} and dilations '${dilations}'`);
    $yLVwv.checkPadOnDimRoundingMode('fused depthwiseConv2d', pad, dimRoundingMode);
    const convInfo = $yLVwv.computeConv2DInfo(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode, true);
    let $bias;
    if (bias != null) {
        $bias = (0, $5R1UY.convertToTensor)(bias, 'bias', 'fused conv2d');
        [$bias] = (0, $1vhox.makeTypesMatch)($bias, $x);
        $eqTIO.assertAndGetBroadcastShape(convInfo.outShape, $bias.shape);
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) $preluActivationWeights = (0, $5R1UY.convertToTensor)(preluActivationWeights, 'prelu weights', 'fused depthwiseConv2d');
    const grad = (dy, saved)=>{
        $4tCOB.assert($yLVwv.tupleValuesAreOne(dilations), ()=>'Error in gradient of fused depthwiseConv2d: dilation rates ' + `greater than 1 are not yet supported. Got dilations ` + `'${dilations}'`);
        const [$filter, x4D, y, bias] = saved;
        const dyActivation = (0, $eg4Z1.getFusedDyActivation)(dy, y, activation);
        const xDer = (0, $b9Kdj.depthwiseConv2dNativeBackpropInput)(x4D.shape, dyActivation, $filter, strides, pad, dilations, dimRoundingMode);
        const filterDer = (0, $f6z1x.depthwiseConv2dNativeBackpropFilter)(x4D, dyActivation, $filter.shape, strides, pad, dilations, dimRoundingMode);
        if (bias != null) {
            const biasDer = (0, $eg4Z1.getFusedBiasGradient)($bias, dyActivation);
            return [
                xDer,
                filterDer,
                biasDer
            ];
        }
        return [
            xDer,
            filterDer
        ];
    };
    const inputs = {
        x: x4D,
        filter: $filter,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $jFQG4.customGrad)((x4D, filter, save)=>{
            // tslint:disable-next-line: no-unnecessary-type-assertion
            let res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.FusedDepthwiseConv2D), inputs, attrs);
            save([
                filter,
                x4D,
                res
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $eP0pM.reshape)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOp(x4D, $filter);
    } else {
        const customOpWithBias = (0, $jFQG4.customGrad)((x4D, filter, bias, save)=>{
            // tslint:disable-next-line: no-unnecessary-type-assertion
            let res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.FusedDepthwiseConv2D), inputs, attrs);
            save([
                filter,
                x4D,
                res,
                bias
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $eP0pM.reshape)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOpWithBias(x4D, $filter, $bias);
    }
}
const $40cf6d2d5406a823$export$48a8ad9494a8fad8 = (0, $jKUCi.op)({
    fusedDepthwiseConv2d_: $40cf6d2d5406a823$var$fusedDepthwiseConv2d_
});

});
parcelRegister("f6z1x", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropFilter", () => $aff295885fb65836$export$cc0ae65e9edc7e1a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
function $aff295885fb65836$var$depthwiseConv2dNativeBackpropFilter_(x, dy, filterShape, strides, pad, dilations = [
    1,
    1
], dimRoundingMode) {
    let x4D = x;
    if (x.rank === 3) x4D = (0, $eP0pM.reshape)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    let dy4D = dy;
    if (dy4D.rank === 3) dy4D = (0, $eP0pM.reshape)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2]
    ]);
    const inputs = {
        x: x4D,
        dy: dy4D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dilations: dilations,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.DepthwiseConv2dNativeBackpropFilter), inputs, attrs);
}
const $aff295885fb65836$export$cc0ae65e9edc7e1a = (0, $jKUCi.op)({
    depthwiseConv2dNativeBackpropFilter_: $aff295885fb65836$var$depthwiseConv2dNativeBackpropFilter_
});

});

parcelRegister("b9Kdj", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropInput", () => $81f4620a8229ccdb$export$37e2ab95a4a4c24b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
function $81f4620a8229ccdb$var$depthwiseConv2dNativeBackpropInput_(xShape, dy, filter, strides, pad, dilations = [
    1,
    1
], dimRoundingMode) {
    let dy4D = dy;
    let reshapedTo4D = false;
    if (dy.rank === 3) {
        reshapedTo4D = true;
        dy4D = (0, $eP0pM.reshape)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2]
        ]);
    }
    const inputs = {
        dy: dy4D,
        filter: filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dilations: dilations,
        inputShape: xShape
    };
    const res = // tslint:disable-next-line: no-unnecessary-type-assertion
    (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.DepthwiseConv2dNativeBackpropInput), inputs, attrs);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $81f4620a8229ccdb$export$37e2ab95a4a4c24b = (0, $jKUCi.op)({
    depthwiseConv2dNativeBackpropInput_: $81f4620a8229ccdb$var$depthwiseConv2dNativeBackpropInput_
});

});


parcelRegister("je0gK", function(module, exports) {

$parcel$export(module.exports, "matMul", () => $dfef8892806f536c$export$6706882a873e9a8f);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $jFQG4 = parcelRequire("jFQG4");

var $dCP8m = parcelRequire("dCP8m");

var $1vhox = parcelRequire("1vhox");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $1ZrG5 = parcelRequire("1ZrG5");

var $eqTIO = parcelRequire("eqTIO");

var $eg4Z1 = parcelRequire("eg4Z1");

var $clO9Z = parcelRequire("clO9Z");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the dot product of two matrices with optional activation and bias.
 *
 * ```js
 * const a = tf.tensor2d([-1, -2], [1, 2]);
 * const b = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 * const bias = tf.tensor2d([1, 2], [1, 2]);
 *
 * tf.fused.matMul({a, b, bias, activation: 'relu'}).print();
 * ```
 *
 * @param obj An object with the following properties:
 * - `a` First matrix in dot product operation.
 * - `b` Second matrix in dot product operation.
 * - `transposeA` If true, `a` is transposed before multiplication.
 * - `transposeB` If true, `b` is transposed before multiplication.
 * - `bias` Matrix to be added to the result.
 * - `activation` Name of activation kernel (defaults to `linear`).
 * - `preluActivationWeights` Tensor of prelu weights.
 * - `leakyreluAlpha` Alpha of leakyrelu.
 */ function $dfef8892806f536c$var$fusedMatMul_({ a: a, b: b, transposeA: transposeA = false, transposeB: transposeB = false, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha = 0.2 }) {
    if ((0, $eg4Z1.shouldFuse)((0, $aHfUM.ENGINE).state.gradientDepth, activation) === false) {
        let result = (0, $clO9Z.matMul)(a, b, transposeA, transposeB);
        if (bias != null) result = (0, $1ZrG5.add)(result, bias);
        return (0, $eg4Z1.applyActivation)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    let $a = (0, $5R1UY.convertToTensor)(a, 'a', 'fused matMul');
    let $b = (0, $5R1UY.convertToTensor)(b, 'b', 'fused matMul');
    [$a, $b] = (0, $1vhox.makeTypesMatch)($a, $b);
    const innerShapeA = transposeA ? $a.shape[$a.rank - 2] : $a.shape[$a.rank - 1];
    const innerShapeB = transposeB ? $b.shape[$b.rank - 1] : $b.shape[$b.rank - 2];
    const outerShapeA = transposeA ? $a.shape[$a.rank - 1] : $a.shape[$a.rank - 2];
    const outerShapeB = transposeB ? $b.shape[$b.rank - 2] : $b.shape[$b.rank - 1];
    const outerDimsA = $a.shape.slice(0, -2);
    const outerDimsB = $b.shape.slice(0, -2);
    const batchDimA = $4tCOB.sizeFromShape(outerDimsA);
    const batchDimB = $4tCOB.sizeFromShape(outerDimsB);
    $4tCOB.assert(innerShapeA === innerShapeB, ()=>`Error in fused matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${$a.shape} and ` + `${$b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const outShapeOuterDims = $eqTIO.assertAndGetBroadcastShape($a.shape.slice(0, -2), $b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    const a3D = transposeA ? (0, $eP0pM.reshape)($a, [
        batchDimA,
        innerShapeA,
        outerShapeA
    ]) : (0, $eP0pM.reshape)($a, [
        batchDimA,
        outerShapeA,
        innerShapeA
    ]);
    const b3D = transposeB ? (0, $eP0pM.reshape)($b, [
        batchDimB,
        outerShapeB,
        innerShapeB
    ]) : (0, $eP0pM.reshape)($b, [
        batchDimB,
        innerShapeB,
        outerShapeB
    ]);
    let $bias;
    if (bias != null) {
        $bias = (0, $5R1UY.convertToTensor)(bias, 'bias', 'fused matMul');
        [$bias] = (0, $1vhox.makeTypesMatch)($bias, $a);
        $eqTIO.assertAndGetBroadcastShape(outShape, $bias.shape);
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) $preluActivationWeights = (0, $5R1UY.convertToTensor)(preluActivationWeights, 'prelu weights', 'fused matMul');
    const grad = (dy, saved)=>{
        const [a3D, b3D, y, $bias] = saved;
        // we reshape dy because the result of the forward is not
        // necessarily going to be a 3d tensor due to a reshape done at the end of
        // the customOp.
        const dyActivation = (0, $eg4Z1.getFusedDyActivation)((0, $eP0pM.reshape)(dy, y.shape), y, activation);
        let aDer;
        let bDer;
        if (!transposeA && !transposeB) {
            aDer = (0, $clO9Z.matMul)(dyActivation, b3D, false, true);
            bDer = (0, $clO9Z.matMul)(a3D, dyActivation, true, false);
        } else if (!transposeA && transposeB) {
            aDer = (0, $clO9Z.matMul)(dyActivation, b3D, false, false);
            bDer = (0, $clO9Z.matMul)(dyActivation, a3D, true, false);
        } else if (transposeA && !transposeB) {
            aDer = (0, $clO9Z.matMul)(b3D, dyActivation, false, true);
            bDer = (0, $clO9Z.matMul)(a3D, dyActivation, false, false);
        } else {
            aDer = (0, $clO9Z.matMul)(b3D, dyActivation, true, true);
            bDer = (0, $clO9Z.matMul)(dyActivation, a3D, true, true);
        }
        if (bias != null) {
            const biasDer = (0, $eg4Z1.getFusedBiasGradient)($bias, dyActivation);
            return [
                aDer,
                bDer,
                biasDer
            ];
        } else return [
            aDer,
            bDer
        ];
    };
    const inputs = {
        a: a3D,
        b: b3D,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        transposeA: transposeA,
        transposeB: transposeB,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $jFQG4.customGrad)((a3D, b3D, save)=>{
            const res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $aHfUM.ENGINE).runKernel((0, $dCP8m._FusedMatMul), inputs, attrs);
            save([
                a3D,
                b3D,
                res
            ]);
            return {
                value: (0, $eP0pM.reshape)(res, outShape),
                gradFunc: grad
            };
        });
        return customOp(a3D, b3D);
    } else {
        const customOpWithBias = (0, $jFQG4.customGrad)((a3D, b3D, $bias, save)=>{
            const res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $aHfUM.ENGINE).runKernel((0, $dCP8m._FusedMatMul), inputs, attrs);
            save([
                a3D,
                b3D,
                res,
                $bias
            ]);
            return {
                value: (0, $eP0pM.reshape)(res, outShape),
                gradFunc: grad
            };
        });
        return customOpWithBias(a3D, b3D, $bias);
    }
}
const $dfef8892806f536c$export$6706882a873e9a8f = (0, $jKUCi.op)({
    fusedMatMul_: $dfef8892806f536c$var$fusedMatMul_
});

});


parcelRegister("1SE8c", function(module, exports) {

$parcel$export(module.exports, "hammingWindow", () => $15e9f6d352b5eb87$export$941eafcc99b559fa);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jKUCi = parcelRequire("jKUCi");

var $4w6Gi = parcelRequire("4w6Gi");
/**
 * Generate a hamming window.
 *
 * See: https://en.wikipedia.org/wiki/Window_function#Hann_and_Hamming_windows
 *
 * ```js
 * tf.signal.hammingWindow(10).print();
 * ```
 * @param The length of window
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $15e9f6d352b5eb87$var$hammingWindow_(windowLength) {
    return (0, $4w6Gi.cosineWindow)(windowLength, 0.54, 0.46);
}
const $15e9f6d352b5eb87$export$941eafcc99b559fa = (0, $jKUCi.op)({
    hammingWindow_: $15e9f6d352b5eb87$var$hammingWindow_
});

});

parcelRegister("bZaqB", function(module, exports) {

$parcel$export(module.exports, "hannWindow", () => $8b9d7b09b089d1f0$export$f498cfeee84e5e59);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jKUCi = parcelRequire("jKUCi");

var $4w6Gi = parcelRequire("4w6Gi");
/**
 * Generate a Hann window.
 *
 * See: https://en.wikipedia.org/wiki/Window_function#Hann_and_Hamming_windows
 *
 * ```js
 * tf.signal.hannWindow(10).print();
 * ```
 * @param The length of window
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $8b9d7b09b089d1f0$var$hannWindow_(windowLength) {
    return (0, $4w6Gi.cosineWindow)(windowLength, 0.5, 0.5);
}
const $8b9d7b09b089d1f0$export$f498cfeee84e5e59 = (0, $jKUCi.op)({
    hannWindow_: $8b9d7b09b089d1f0$var$hannWindow_
});

});

parcelRegister("ig8W0", function(module, exports) {

$parcel$export(module.exports, "frame", () => $d4b0a6dd36034ad9$export$2cef06c20297c17d);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6LWfo = parcelRequire("6LWfo");

var $3kNX7 = parcelRequire("3kNX7");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");

var $kvpGg = parcelRequire("kvpGg");

var $g4QpC = parcelRequire("g4QpC");
/**
 * Expands input into frames of frameLength.
 * Slides a window size with frameStep.
 *
 * ```js
 * tf.signal.frame([1, 2, 3], 2, 1).print();
 * ```
 * @param signal The input tensor to be expanded
 * @param frameLength Length of each frame
 * @param frameStep The frame hop size in samples.
 * @param padEnd Whether to pad the end of signal with padValue.
 * @param padValue A number to use where the input signal does
 *     not exist when padEnd is True.
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $d4b0a6dd36034ad9$var$frame_(signal, frameLength, frameStep, padEnd = false, padValue = 0) {
    let start = 0;
    const output = [];
    while(start + frameLength <= signal.size){
        output.push((0, $kvpGg.slice)(signal, start, frameLength));
        start += frameStep;
    }
    if (padEnd) while(start < signal.size){
        const padLen = start + frameLength - signal.size;
        const pad = (0, $6LWfo.concat)([
            (0, $kvpGg.slice)(signal, start, frameLength - padLen),
            (0, $3kNX7.fill)([
                padLen
            ], padValue)
        ]);
        output.push(pad);
        start += frameStep;
    }
    if (output.length === 0) return (0, $g4QpC.tensor2d)([], [
        0,
        frameLength
    ]);
    return (0, $eP0pM.reshape)((0, $6LWfo.concat)(output), [
        output.length,
        frameLength
    ]);
}
const $d4b0a6dd36034ad9$export$2cef06c20297c17d = (0, $jKUCi.op)({
    frame_: $d4b0a6dd36034ad9$var$frame_
});

});

parcelRegister("aUqBT", function(module, exports) {

$parcel$export(module.exports, "stft", () => $7f13c68e9cd48181$export$eb1cf9b274257b4a);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $r7fN6 = parcelRequire("r7fN6");

var $jKUCi = parcelRequire("jKUCi");

var $4w6Gi = parcelRequire("4w6Gi");

var $fBxya = parcelRequire("fBxya");

var $ig8W0 = parcelRequire("ig8W0");

var $bZaqB = parcelRequire("bZaqB");
/**
 * Computes the Short-time Fourier Transform of signals
 * See: https://en.wikipedia.org/wiki/Short-time_Fourier_transform
 *
 * ```js
 * const input = tf.tensor1d([1, 1, 1, 1, 1])
 * tf.signal.stft(input, 3, 1).print();
 * ```
 * @param signal 1-dimensional real value tensor.
 * @param frameLength The window length of samples.
 * @param frameStep The number of samples to step.
 * @param fftLength The size of the FFT to apply.
 * @param windowFn A callable that takes a window length and returns 1-d tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $7f13c68e9cd48181$var$stft_(signal, frameLength, frameStep, fftLength, windowFn = (0, $bZaqB.hannWindow)) {
    if (fftLength == null) fftLength = (0, $4w6Gi.enclosingPowerOfTwo)(frameLength);
    const framedSignal = (0, $ig8W0.frame)(signal, frameLength, frameStep);
    const windowedSignal = (0, $r7fN6.mul)(framedSignal, windowFn(frameLength));
    return (0, $fBxya.rfft)(windowedSignal, fftLength);
}
const $7f13c68e9cd48181$export$eb1cf9b274257b4a = (0, $jKUCi.op)({
    stft_: $7f13c68e9cd48181$var$stft_
});

});

parcelRegister("8GfHK", function(module, exports) {

$parcel$export(module.exports, "cropAndResize", () => $651e6d9b70341186$export$6f0f0090e1f6cd3c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Extracts crops from the input image tensor and resizes them using bilinear
 * sampling or nearest neighbor sampling (possibly with aspect ratio change)
 * to a common output size specified by cropSize.
 *
 * @param image 4d tensor of shape `[batch,imageHeight,imageWidth, depth]`,
 *     where imageHeight and imageWidth must be positive, specifying the
 *     batch of images from which to take crops
 * @param boxes 2d float32 tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the normalized
 *     coordinates of the box in the `boxInd[i]`th image in the batch
 * @param boxInd 1d int32 tensor of shape `[numBoxes]` with values in range
 *     `[0, batch)` that specifies the image that the `i`-th box refers to.
 * @param cropSize 1d int32 tensor of 2 elements `[cropHeigh, cropWidth]`
 *     specifying the size to which all crops are resized to.
 * @param method Optional string from `'bilinear' | 'nearest'`,
 *     defaults to bilinear, which specifies the sampling method for resizing
 * @param extrapolationValue A threshold for deciding when to remove boxes based
 *     on score. Defaults to 0.
 * @return A 4D tensor of the shape `[numBoxes,cropHeight,cropWidth,depth]`
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $651e6d9b70341186$var$cropAndResize_(image, boxes, boxInd, cropSize, method = 'bilinear', extrapolationValue = 0) {
    const $image = (0, $5R1UY.convertToTensor)(image, 'image', 'cropAndResize');
    const $boxes = (0, $5R1UY.convertToTensor)(boxes, 'boxes', 'cropAndResize', 'float32');
    const $boxInd = (0, $5R1UY.convertToTensor)(boxInd, 'boxInd', 'cropAndResize', 'int32');
    const numBoxes = $boxes.shape[0];
    $4tCOB.assert($image.rank === 4, ()=>'Error in cropAndResize: image must be rank 4,' + `but got rank ${$image.rank}.`);
    $4tCOB.assert($boxes.rank === 2 && $boxes.shape[1] === 4, ()=>`Error in cropAndResize: boxes must be have size [${numBoxes},4] ` + `but had shape ${$boxes.shape}.`);
    $4tCOB.assert($boxInd.rank === 1 && $boxInd.shape[0] === numBoxes, ()=>`Error in cropAndResize: boxInd must be have size [${numBoxes}] ` + `but had shape ${$boxes.shape}.`);
    $4tCOB.assert(cropSize.length === 2, ()=>`Error in cropAndResize: cropSize must be of length 2, but got ` + `length ${cropSize.length}.`);
    $4tCOB.assert(cropSize[0] >= 1 && cropSize[1] >= 1, ()=>`cropSize must be atleast [1,1], but was ${cropSize}`);
    $4tCOB.assert(method === 'bilinear' || method === 'nearest', ()=>`method must be bilinear or nearest, but was ${method}`);
    const inputs = {
        image: $image,
        boxes: $boxes,
        boxInd: $boxInd
    };
    const attrs = {
        method: method,
        extrapolationValue: extrapolationValue,
        cropSize: cropSize
    };
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.CropAndResize), inputs, attrs);
    return res;
}
const $651e6d9b70341186$export$6f0f0090e1f6cd3c = (0, $jKUCi.op)({
    cropAndResize_: $651e6d9b70341186$var$cropAndResize_
});

});

parcelRegister("4OCYa", function(module, exports) {

$parcel$export(module.exports, "flipLeftRight", () => $381a0f7a29457aaf$export$8358b9c43b687b22);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Flips the image left to right. Currently available in the CPU, WebGL, and
 * WASM backends.
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 */ /** @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'} */ function $381a0f7a29457aaf$var$flipLeftRight_(image) {
    const $image = (0, $5R1UY.convertToTensor)(image, 'image', 'flipLeftRight', 'float32');
    $4tCOB.assert($image.rank === 4, ()=>'Error in flipLeftRight: image must be rank 4,' + `but got rank ${$image.rank}.`);
    const inputs = {
        image: $image
    };
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.FlipLeftRight), inputs, {});
    return res;
}
const $381a0f7a29457aaf$export$8358b9c43b687b22 = (0, $jKUCi.op)({
    flipLeftRight_: $381a0f7a29457aaf$var$flipLeftRight_
});

});

parcelRegister("lom3x", function(module, exports) {

$parcel$export(module.exports, "grayscaleToRGB", () => $f92cf2bca06c16f0$export$f68e334bfd7e4be6);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $jIHaY = parcelRequire("jIHaY");
/**
 * Converts images from grayscale to RGB format.
 *
 * @param image A grayscale tensor to convert. The `image`'s last dimension must
 *     be size 1 with at least a two-dimensional shape.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $f92cf2bca06c16f0$var$grayscaleToRGB_(image) {
    const $image = (0, $5R1UY.convertToTensor)(image, 'image', 'grayscaleToRGB');
    const lastDimsIdx = $image.rank - 1;
    const lastDims = $image.shape[lastDimsIdx];
    $4tCOB.assert($image.rank >= 2, ()=>'Error in grayscaleToRGB: images must be at least rank 2, ' + `but got rank ${$image.rank}.`);
    $4tCOB.assert(lastDims === 1, ()=>'Error in grayscaleToRGB: last dimension of a grayscale image ' + `should be size 1, but got size ${lastDims}.`);
    const reps = new Array($image.rank);
    reps.fill(1, 0, lastDimsIdx);
    reps[lastDimsIdx] = 3;
    return (0, $jIHaY.tile)($image, reps);
}
const $f92cf2bca06c16f0$export$f68e334bfd7e4be6 = (0, $jKUCi.op)({
    grayscaleToRGB_: $f92cf2bca06c16f0$var$grayscaleToRGB_
});

});

parcelRegister("DWI8p", function(module, exports) {

$parcel$export(module.exports, "rotateWithOffset", () => $07812f628c10d5e3$export$66462c489f5f29d2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Rotates the input image tensor counter-clockwise with an optional offset
 * center of rotation. Currently available in the CPU, WebGL, and WASM backends.
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 * @param radians The amount of rotation.
 * @param fillValue The value to fill in the empty space leftover
 *     after rotation. Can be either a single grayscale value (0-255), or an
 *     array of three numbers `[red, green, blue]` specifying the red, green,
 *     and blue channels. Defaults to `0` (black).
 * @param center The center of rotation. Can be either a single value (0-1), or
 *     an array of two numbers `[centerX, centerY]`. Defaults to `0.5` (rotates
 *     the image around its center).
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $07812f628c10d5e3$var$rotateWithOffset_(image, radians, fillValue = 0, center = 0.5) {
    const $image = (0, $5R1UY.convertToTensor)(image, 'image', 'rotateWithOffset', 'float32');
    $4tCOB.assert($image.rank === 4, ()=>'Error in rotateWithOffset: image must be rank 4,' + `but got rank ${$image.rank}.`);
    const inputs = {
        image: $image
    };
    const attrs = {
        radians: radians,
        fillValue: fillValue,
        center: center
    };
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.RotateWithOffset), inputs, attrs);
    return res;
}
const $07812f628c10d5e3$export$66462c489f5f29d2 = (0, $jKUCi.op)({
    rotateWithOffset_: $07812f628c10d5e3$var$rotateWithOffset_
});

});

parcelRegister("3n8B6", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppression", () => $274a305ea8759aaa$export$b7d265b19ca1d628);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jGWWs = parcelRequire("jGWWs");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @return A 1D tensor with the selected box indices.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $274a305ea8759aaa$var$nonMaxSuppression_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY) {
    const $boxes = (0, $5R1UY.convertToTensor)(boxes, 'boxes', 'nonMaxSuppression', 'float32');
    const $scores = (0, $5R1UY.convertToTensor)(scores, 'scores', 'nonMaxSuppression', 'float32');
    const inputs = (0, $jGWWs.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
    maxOutputSize = inputs.maxOutputSize;
    iouThreshold = inputs.iouThreshold;
    scoreThreshold = inputs.scoreThreshold;
    const attrs = {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.NonMaxSuppressionV3), {
        boxes: $boxes,
        scores: $scores
    }, attrs);
}
const $274a305ea8759aaa$export$b7d265b19ca1d628 = (0, $jKUCi.op)({
    nonMaxSuppression_: $274a305ea8759aaa$var$nonMaxSuppression_
});

});
parcelRegister("jGWWs", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppSanityCheck", () => $e55fa930fba061f6$export$ccf61bcb3b4e6ac6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
function $e55fa930fba061f6$export$ccf61bcb3b4e6ac6(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
    if (iouThreshold == null) iouThreshold = 0.5;
    if (scoreThreshold == null) scoreThreshold = Number.NEGATIVE_INFINITY;
    if (softNmsSigma == null) softNmsSigma = 0.0;
    const numBoxes = boxes.shape[0];
    maxOutputSize = Math.min(maxOutputSize, numBoxes);
    $4tCOB.assert(0 <= iouThreshold && iouThreshold <= 1, ()=>`iouThreshold must be in [0, 1], but was '${iouThreshold}'`);
    $4tCOB.assert(boxes.rank === 2, ()=>`boxes must be a 2D tensor, but was of rank '${boxes.rank}'`);
    $4tCOB.assert(boxes.shape[1] === 4, ()=>`boxes must have 4 columns, but 2nd dimension was ${boxes.shape[1]}`);
    $4tCOB.assert(scores.rank === 1, ()=>'scores must be a 1D tensor');
    $4tCOB.assert(scores.shape[0] === numBoxes, ()=>`scores has incompatible shape with boxes. Expected ${numBoxes}, ` + `but was ${scores.shape[0]}`);
    $4tCOB.assert(0 <= softNmsSigma && softNmsSigma <= 1, ()=>`softNmsSigma must be in [0, 1], but was '${softNmsSigma}'`);
    return {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
}

});


parcelRegister("aSrgP", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionAsync", () => $7eb419df690d6f26$export$cc6d94dffac2ee1a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bCB0s = parcelRequire("bCB0s");

var $5R1UY = parcelRequire("5R1UY");

var $jGWWs = parcelRequire("jGWWs");

var $jIDgY = parcelRequire("jIDgY");
/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This is the async version of `nonMaxSuppression`
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @return A 1D tensor with the selected box indices.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $7eb419df690d6f26$var$nonMaxSuppressionAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY) {
    const $boxes = (0, $5R1UY.convertToTensor)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $5R1UY.convertToTensor)(scores, 'scores', 'nonMaxSuppressionAsync');
    const inputs = (0, $jGWWs.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
    maxOutputSize = inputs.maxOutputSize;
    iouThreshold = inputs.iouThreshold;
    scoreThreshold = inputs.scoreThreshold;
    const boxesAndScores = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    const boxesVals = boxesAndScores[0];
    const scoresVals = boxesAndScores[1];
    // We call a cpu based impl directly with the typedarray data  here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices } = (0, $bCB0s.nonMaxSuppressionV3Impl)(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return (0, $jIDgY.tensor1d)(selectedIndices, 'int32');
}
const $7eb419df690d6f26$export$cc6d94dffac2ee1a = $7eb419df690d6f26$var$nonMaxSuppressionAsync_;

});
parcelRegister("bCB0s", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV3Impl", () => $875ff309cbc84dea$export$89e22275998c2878);
$parcel$export(module.exports, "nonMaxSuppressionV4Impl", () => $875ff309cbc84dea$export$697e7a8cdfefe3a);
$parcel$export(module.exports, "nonMaxSuppressionV5Impl", () => $875ff309cbc84dea$export$4ff849794bce73c5);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jJEr4 = parcelRequire("jJEr4");
function $875ff309cbc84dea$export$89e22275998c2878(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
    return $875ff309cbc84dea$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, 0 /* softNmsSigma */ );
}
function $875ff309cbc84dea$export$697e7a8cdfefe3a(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize) {
    return $875ff309cbc84dea$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, 0 /* softNmsSigma */ , false, padToMaxOutputSize /* padToMaxOutputSize */ , true);
}
function $875ff309cbc84dea$export$4ff849794bce73c5(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
    return $875ff309cbc84dea$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, true);
}
function $875ff309cbc84dea$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, returnScoresTensor = false, padToMaxOutputSize = false, returnValidOutputs = false) {
    // The list is sorted in ascending order, so that we can always pop the
    // candidate with the largest score in O(1) time.
    const candidates = [];
    for(let i = 0; i < scores.length; i++)if (scores[i] > scoreThreshold) candidates.push({
        score: scores[i],
        boxIndex: i,
        suppressBeginIndex: 0
    });
    candidates.sort($875ff309cbc84dea$var$ascendingComparator);
    // If softNmsSigma is 0, the outcome of this algorithm is exactly same as
    // before.
    const scale = softNmsSigma > 0 ? -0.5 / softNmsSigma : 0.0;
    const selectedIndices = [];
    const selectedScores = [];
    while(selectedIndices.length < maxOutputSize && candidates.length > 0){
        const candidate = candidates.pop();
        const { score: originalScore, boxIndex: boxIndex, suppressBeginIndex: suppressBeginIndex } = candidate;
        if (originalScore < scoreThreshold) break;
        // Overlapping boxes are likely to have similar scores, therefore we
        // iterate through the previously selected boxes backwards in order to
        // see if candidate's score should be suppressed. We use
        // suppressBeginIndex to track and ensure a candidate can be suppressed
        // by a selected box no more than once. Also, if the overlap exceeds
        // iouThreshold, we simply ignore the candidate.
        let ignoreCandidate = false;
        for(let j = selectedIndices.length - 1; j >= suppressBeginIndex; --j){
            const iou = $875ff309cbc84dea$var$intersectionOverUnion(boxes, boxIndex, selectedIndices[j]);
            if (iou >= iouThreshold) {
                ignoreCandidate = true;
                break;
            }
            candidate.score = candidate.score * $875ff309cbc84dea$var$suppressWeight(iouThreshold, scale, iou);
            if (candidate.score <= scoreThreshold) break;
        }
        // At this point, if `candidate.score` has not dropped below
        // `scoreThreshold`, then we know that we went through all of the
        // previous selections and can safely update `suppressBeginIndex` to the
        // end of the selected array. Then we can re-insert the candidate with
        // the updated score and suppressBeginIndex back in the candidate list.
        // If on the other hand, `candidate.score` has dropped below the score
        // threshold, we will not add it back to the candidates list.
        candidate.suppressBeginIndex = selectedIndices.length;
        if (!ignoreCandidate) {
            // Candidate has passed all the tests, and is not suppressed, so
            // select the candidate.
            if (candidate.score === originalScore) {
                selectedIndices.push(boxIndex);
                selectedScores.push(candidate.score);
            } else if (candidate.score > scoreThreshold) // Candidate's score is suppressed but is still high enough to be
            // considered, so add back to the candidates list.
            (0, $jJEr4.binaryInsert)(candidates, candidate, $875ff309cbc84dea$var$ascendingComparator);
        }
    }
    // NonMaxSuppressionV4 feature: padding output to maxOutputSize.
    const validOutputs = selectedIndices.length;
    const elemsToPad = maxOutputSize - validOutputs;
    if (padToMaxOutputSize && elemsToPad > 0) {
        selectedIndices.push(...new Array(elemsToPad).fill(0));
        selectedScores.push(...new Array(elemsToPad).fill(0.0));
    }
    const result = {
        selectedIndices: selectedIndices
    };
    if (returnScoresTensor) result['selectedScores'] = selectedScores;
    if (returnValidOutputs) result['validOutputs'] = validOutputs;
    return result;
}
function $875ff309cbc84dea$var$intersectionOverUnion(boxes, i, j) {
    const iCoord = boxes.subarray(i * 4, i * 4 + 4);
    const jCoord = boxes.subarray(j * 4, j * 4 + 4);
    const yminI = Math.min(iCoord[0], iCoord[2]);
    const xminI = Math.min(iCoord[1], iCoord[3]);
    const ymaxI = Math.max(iCoord[0], iCoord[2]);
    const xmaxI = Math.max(iCoord[1], iCoord[3]);
    const yminJ = Math.min(jCoord[0], jCoord[2]);
    const xminJ = Math.min(jCoord[1], jCoord[3]);
    const ymaxJ = Math.max(jCoord[0], jCoord[2]);
    const xmaxJ = Math.max(jCoord[1], jCoord[3]);
    const areaI = (ymaxI - yminI) * (xmaxI - xminI);
    const areaJ = (ymaxJ - yminJ) * (xmaxJ - xminJ);
    if (areaI <= 0 || areaJ <= 0) return 0.0;
    const intersectionYmin = Math.max(yminI, yminJ);
    const intersectionXmin = Math.max(xminI, xminJ);
    const intersectionYmax = Math.min(ymaxI, ymaxJ);
    const intersectionXmax = Math.min(xmaxI, xmaxJ);
    const intersectionArea = Math.max(intersectionYmax - intersectionYmin, 0.0) * Math.max(intersectionXmax - intersectionXmin, 0.0);
    return intersectionArea / (areaI + areaJ - intersectionArea);
}
// A Gaussian penalty function, this method always returns values in [0, 1].
// The weight is a function of similarity, the more overlap two boxes are, the
// smaller the weight is, meaning highly overlapping boxe will be significantly
// penalized. On the other hand, a non-overlapping box will not be penalized.
function $875ff309cbc84dea$var$suppressWeight(iouThreshold, scale, iou) {
    const weight = Math.exp(scale * iou * iou);
    return iou <= iouThreshold ? weight : 0.0;
}
function $875ff309cbc84dea$var$ascendingComparator(c1, c2) {
    // For objects with same scores, we make the object with the larger index go
    // first. In an array that pops from the end, this means that the object with
    // the smaller index will be popped first. This ensures the same output as
    // the TensorFlow python version.
    return c1.score - c2.score || c1.score === c2.score && c2.boxIndex - c1.boxIndex;
}

});
parcelRegister("jJEr4", function(module, exports) {

$parcel$export(module.exports, "binaryInsert", () => $e5e195f456cf2e27$export$a64fad5e27f22af5);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Inserts a value into a sorted array. This method allows duplicate, meaning it
 * allows inserting duplicate value, in which case, the element will be inserted
 * at the lowest index of the value.
 * @param arr The array to modify.
 * @param element The element to insert.
 * @param comparator Optional. If no comparator is specified, elements are
 * compared using array_util.defaultComparator, which is suitable for Strings
 * and Numbers in ascending arrays. If the array contains multiple instances of
 * the target value, the left-most instance will be returned. To provide a
 * comparator, it should take 2 arguments to compare and return a negative,
 * zero, or a positive number.
 */ function $e5e195f456cf2e27$export$a64fad5e27f22af5(arr, element, comparator) {
    const index = $e5e195f456cf2e27$export$2e0ae67339d5f1ac(arr, element, comparator);
    const insertionPoint = index < 0 ? -(index + 1) : index;
    arr.splice(insertionPoint, 0, element);
}
function $e5e195f456cf2e27$export$2e0ae67339d5f1ac(arr, target, comparator) {
    return $e5e195f456cf2e27$var$binarySearch_(arr, target, comparator || $e5e195f456cf2e27$var$defaultComparator);
}
/**
 * Compares its two arguments for order.
 * @param a The first element to be compared.
 * @param b The second element to be compared.
 * @return A negative number, zero, or a positive number as the first
 *     argument is less than, equal to, or greater than the second.
 */ function $e5e195f456cf2e27$var$defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $e5e195f456cf2e27$var$binarySearch_(arr, target, comparator) {
    let left = 0;
    let right = arr.length;
    let middle = 0;
    let found = false;
    while(left < right){
        middle = left + (right - left >>> 1);
        const compareResult = comparator(target, arr[middle]);
        if (compareResult > 0) left = middle + 1;
        else {
            right = middle;
            // If compareResult is 0, the value is found. We record it is found,
            // and then keep looking because there may be duplicate.
            found = !compareResult;
        }
    }
    return found ? left : -left - 1;
}

});



parcelRegister("4WibO", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionWithScore", () => $398ab045992020e9$export$d65fe1460f8c5b4e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jGWWs = parcelRequire("jGWWs");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This op also supports a Soft-NMS mode (cf.
 * Bodla et al, https://arxiv.org/abs/1704.04503) where boxes reduce the score
 * of other overlapping boxes, therefore favoring different regions of the image
 * with high scores. To enable this Soft-NMS mode, set the `softNmsSigma`
 * parameter to be larger than 0.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param softNmsSigma A float representing the sigma parameter for Soft NMS.
 *     When sigma is 0, it falls back to nonMaxSuppression.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - selectedScores: A 1D tensor with the corresponding scores for each
 *       selected box.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $398ab045992020e9$var$nonMaxSuppressionWithScore_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, softNmsSigma = 0.0) {
    const $boxes = (0, $5R1UY.convertToTensor)(boxes, 'boxes', 'nonMaxSuppression');
    const $scores = (0, $5R1UY.convertToTensor)(scores, 'scores', 'nonMaxSuppression');
    const params = (0, $jGWWs.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    maxOutputSize = params.maxOutputSize;
    iouThreshold = params.iouThreshold;
    scoreThreshold = params.scoreThreshold;
    softNmsSigma = params.softNmsSigma;
    const inputs = {
        boxes: $boxes,
        scores: $scores
    };
    const attrs = {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.NonMaxSuppressionV5), inputs, attrs);
    return {
        selectedIndices: result[0],
        selectedScores: result[1]
    };
}
const $398ab045992020e9$export$d65fe1460f8c5b4e = (0, $jKUCi.op)({
    nonMaxSuppressionWithScore_: $398ab045992020e9$var$nonMaxSuppressionWithScore_
});

});

parcelRegister("ftDW7", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionWithScoreAsync", () => $b4488af95f1dfe75$export$d1826570c883f7cf);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bCB0s = parcelRequire("bCB0s");

var $5R1UY = parcelRequire("5R1UY");

var $jGWWs = parcelRequire("jGWWs");

var $jIDgY = parcelRequire("jIDgY");
/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This op also supports a Soft-NMS mode (cf.
 * Bodla et al, https://arxiv.org/abs/1704.04503) where boxes reduce the score
 * of other overlapping boxes, therefore favoring different regions of the image
 * with high scores. To enable this Soft-NMS mode, set the `softNmsSigma`
 * parameter to be larger than 0.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param softNmsSigma A float representing the sigma parameter for Soft NMS.
 *     When sigma is 0, it falls back to nonMaxSuppression.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - selectedScores: A 1D tensor with the corresponding scores for each
 *       selected box.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $b4488af95f1dfe75$var$nonMaxSuppressionWithScoreAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, softNmsSigma = 0.0) {
    const $boxes = (0, $5R1UY.convertToTensor)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $5R1UY.convertToTensor)(scores, 'scores', 'nonMaxSuppressionAsync');
    const params = (0, $jGWWs.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    maxOutputSize = params.maxOutputSize;
    iouThreshold = params.iouThreshold;
    scoreThreshold = params.scoreThreshold;
    softNmsSigma = params.softNmsSigma;
    const boxesAndScores = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    const boxesVals = boxesAndScores[0];
    const scoresVals = boxesAndScores[1];
    // We call a cpu based impl directly with the typedarray data  here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = (0, $bCB0s.nonMaxSuppressionV5Impl)(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return {
        selectedIndices: (0, $jIDgY.tensor1d)(selectedIndices, 'int32'),
        selectedScores: (0, $jIDgY.tensor1d)(selectedScores)
    };
}
const $b4488af95f1dfe75$export$d1826570c883f7cf = $b4488af95f1dfe75$var$nonMaxSuppressionWithScoreAsync_;

});

parcelRegister("lDfEo", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionPadded", () => $fbf96159458e904d$export$d8d10e31c41c95dc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jGWWs = parcelRequire("jGWWs");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union), with an option to pad results.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param padToMaxOutputSize Defaults to false. If true, size of output
 *     `selectedIndices` is padded to maxOutputSize.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - validOutputs: A scalar denoting how many elements in `selectedIndices`
 *       are valid. Valid elements occur first, then padding.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $fbf96159458e904d$var$nonMaxSuppressionPadded_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, padToMaxOutputSize = false) {
    const $boxes = (0, $5R1UY.convertToTensor)(boxes, 'boxes', 'nonMaxSuppression');
    const $scores = (0, $5R1UY.convertToTensor)(scores, 'scores', 'nonMaxSuppression');
    const params = (0, $jGWWs.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, null);
    const $maxOutputSize = params.maxOutputSize;
    const $iouThreshold = params.iouThreshold;
    const $scoreThreshold = params.scoreThreshold;
    const inputs = {
        boxes: $boxes,
        scores: $scores
    };
    const attrs = {
        maxOutputSize: $maxOutputSize,
        iouThreshold: $iouThreshold,
        scoreThreshold: $scoreThreshold,
        padToMaxOutputSize: padToMaxOutputSize
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.NonMaxSuppressionV4), inputs, attrs);
    return {
        selectedIndices: result[0],
        validOutputs: result[1]
    };
}
const $fbf96159458e904d$export$d8d10e31c41c95dc = (0, $jKUCi.op)({
    nonMaxSuppressionPadded_: $fbf96159458e904d$var$nonMaxSuppressionPadded_
});

});

parcelRegister("fhRdf", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionPaddedAsync", () => $b211b87c40b84c0e$export$4c5691f9710b88a8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bCB0s = parcelRequire("bCB0s");

var $5R1UY = parcelRequire("5R1UY");

var $jGWWs = parcelRequire("jGWWs");

var $j7yUF = parcelRequire("j7yUF");

var $jIDgY = parcelRequire("jIDgY");
/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union), with an option to pad results.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param padToMaxOutputSize Defaults to false. If true, size of output
 *     `selectedIndices` is padded to maxOutputSize.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - validOutputs: A scalar denoting how many elements in `selectedIndices`
 *       are valid. Valid elements occur first, then padding.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $b211b87c40b84c0e$var$nonMaxSuppressionPaddedAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, padToMaxOutputSize = false) {
    const $boxes = (0, $5R1UY.convertToTensor)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $5R1UY.convertToTensor)(scores, 'scores', 'nonMaxSuppressionAsync');
    const params = (0, $jGWWs.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, null);
    const $maxOutputSize = params.maxOutputSize;
    const $iouThreshold = params.iouThreshold;
    const $scoreThreshold = params.scoreThreshold;
    const [boxesVals, scoresVals] = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    // We call a cpu based impl directly with the typedarray data here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices, validOutputs: validOutputs } = (0, $bCB0s.nonMaxSuppressionV4Impl)(boxesVals, scoresVals, $maxOutputSize, $iouThreshold, $scoreThreshold, padToMaxOutputSize);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return {
        selectedIndices: (0, $jIDgY.tensor1d)(selectedIndices, 'int32'),
        validOutputs: (0, $j7yUF.scalar)(validOutputs, 'int32')
    };
}
const $b211b87c40b84c0e$export$4c5691f9710b88a8 = $b211b87c40b84c0e$var$nonMaxSuppressionPaddedAsync_;

});

parcelRegister("gswiT", function(module, exports) {

$parcel$export(module.exports, "resizeBilinear", () => $bfb851b52efcb497$export$1f1cbc7da93d06a0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Bilinear resize a single 3D image or a batch of 3D images to a new shape.
 *
 * @param images The images, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param size The new shape `[newHeight, newWidth]` to resize the
 *     images to. Each channel is resized individually.
 * @param alignCorners Defaults to `false`. If true, rescale
 *     input by `(new_height - 1) / (height - 1)`, which exactly aligns the 4
 *     corners of images and resized images. If false, rescale by
 *     `new_height / height`. Treat similarly the width dimension.
 * @param halfPixelCenters Defaults to `false`. Whether to assume pixel centers
 *     are at 0.5, which would make the floating point coordinates of the top
 *     left pixel 0.5, 0.5.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $bfb851b52efcb497$var$resizeBilinear_(images, size, alignCorners = false, halfPixelCenters = false) {
    const $images = (0, $5R1UY.convertToTensor)(images, 'images', 'resizeBilinear');
    $4tCOB.assert($images.rank === 3 || $images.rank === 4, ()=>`Error in resizeBilinear: x must be rank 3 or 4, but got ` + `rank ${$images.rank}.`);
    $4tCOB.assert(size.length === 2, ()=>`Error in resizeBilinear: new shape must 2D, but got shape ` + `${size}.`);
    $4tCOB.assert(halfPixelCenters === false || alignCorners === false, ()=>`Error in resizeBilinear: If halfPixelCenters is true, ` + `alignCorners must be false.`);
    let batchImages = $images;
    let reshapedTo4D = false;
    if ($images.rank === 3) {
        reshapedTo4D = true;
        batchImages = (0, $eP0pM.reshape)($images, [
            1,
            $images.shape[0],
            $images.shape[1],
            $images.shape[2]
        ]);
    }
    const [] = size;
    const inputs = {
        images: batchImages
    };
    const attrs = {
        alignCorners: alignCorners,
        halfPixelCenters: halfPixelCenters,
        size: size
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.ResizeBilinear), inputs, attrs);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $bfb851b52efcb497$export$1f1cbc7da93d06a0 = (0, $jKUCi.op)({
    resizeBilinear_: $bfb851b52efcb497$var$resizeBilinear_
});

});

parcelRegister("1sK56", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighbor", () => $110c26bc673dea5c$export$74a902ae74ac2560);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * NearestNeighbor resize a batch of 3D images to a new shape.
 *
 * @param images The images, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param size The new shape `[newHeight, newWidth]` to resize the
 *     images to. Each channel is resized individually.
 * @param alignCorners Defaults to False. If true, rescale
 *     input by `(new_height - 1) / (height - 1)`, which exactly aligns the 4
 *     corners of images and resized images. If false, rescale by
 *     `new_height / height`. Treat similarly the width dimension.
 * @param halfPixelCenters Defaults to `false`. Whether to assume pixels are of
 *      half the actual dimensions, and yield more accurate resizes. This flag
 *      would also make the floating point coordinates of the top left pixel
 *      0.5, 0.5.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $110c26bc673dea5c$var$resizeNearestNeighbor_(images, size, alignCorners = false, halfPixelCenters = false) {
    const $images = (0, $5R1UY.convertToTensor)(images, 'images', 'resizeNearestNeighbor');
    $4tCOB.assert($images.rank === 3 || $images.rank === 4, ()=>`Error in resizeNearestNeighbor: x must be rank 3 or 4, but got ` + `rank ${$images.rank}.`);
    $4tCOB.assert(size.length === 2, ()=>`Error in resizeNearestNeighbor: new shape must 2D, but got shape ` + `${size}.`);
    $4tCOB.assert($images.dtype === 'float32' || $images.dtype === 'int32', ()=>'`images` must have `int32` or `float32` as dtype');
    $4tCOB.assert(halfPixelCenters === false || alignCorners === false, ()=>`Error in resizeNearestNeighbor: If halfPixelCenters is true, ` + `alignCorners must be false.`);
    let batchImages = $images;
    let reshapedTo4D = false;
    if ($images.rank === 3) {
        reshapedTo4D = true;
        batchImages = (0, $eP0pM.reshape)($images, [
            1,
            $images.shape[0],
            $images.shape[1],
            $images.shape[2]
        ]);
    }
    const [] = size;
    const inputs = {
        images: batchImages
    };
    const attrs = {
        alignCorners: alignCorners,
        halfPixelCenters: halfPixelCenters,
        size: size
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.ResizeNearestNeighbor), inputs, attrs);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $110c26bc673dea5c$export$74a902ae74ac2560 = (0, $jKUCi.op)({
    resizeNearestNeighbor_: $110c26bc673dea5c$var$resizeNearestNeighbor_
});

});

parcelRegister("ipc44", function(module, exports) {

$parcel$export(module.exports, "threshold", () => $d663eb91cb4d90b6$export$454d09aca5f3ea63);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jIDgY = parcelRequire("jIDgY");

var $jKUCi = parcelRequire("jKUCi");

var $7qWZ5 = parcelRequire("7qWZ5");

var $9DjTt = parcelRequire("9DjTt");

var $5sha3 = parcelRequire("5sha3");

var $eXGUa = parcelRequire("eXGUa");

var $jUhqf = parcelRequire("jUhqf");

var $fVwnn = parcelRequire("fVwnn");

var $1ZrG5 = parcelRequire("1ZrG5");

var $r7fN6 = parcelRequire("r7fN6");

var $gjFWY = parcelRequire("gjFWY");

var $hkR0n = parcelRequire("hkR0n");

var $9mGGG = parcelRequire("9mGGG");

var $3dRh6 = parcelRequire("3dRh6");

var $3kNX7 = parcelRequire("3kNX7");

var $kvpGg = parcelRequire("kvpGg");

var $9qLoy = parcelRequire("9qLoy");

var $ec8bD = parcelRequire("ec8bD");

var $4tCOB = parcelRequire("4tCOB");

var $5R1UY = parcelRequire("5R1UY");
/**
 * Performs image binarization with corresponding threshold
 * (depends on the method)value, which creates a binary image from a grayscale.
 * @param image 3d tensor of shape [imageHeight,imageWidth, depth],
 * where imageHeight and imageWidth must be positive.The image color
 * range should be [0, 255].
 * @param method Optional string from `'binary' | 'otsu'`
 * which specifies the method for thresholding. Defaults to 'binary'.
 * @param inverted Optional boolean whichspecifies
 * if colours should be inverted. Defaults to false.
 * @param threshValue Optional number which defines threshold value from 0 to 1.
 * Defaults to 0.5.
 * @return A 3d tensor of shape [imageHeight,imageWidth, depth], which
 * contains binarized image.
 */ function $d663eb91cb4d90b6$var$threshold_(image, method = 'binary', inverted = false, threshValue = 0.5) {
    const $image = (0, $5R1UY.convertToTensor)(image, 'image', 'threshold');
    /* 0.2989, 0.5870, 0.1140 are represent luma coefficients in CCIR601.
    Reference for converting between RGB and grayscale: https://en.wikipedia.org/wiki/Luma_%28video%29  */ const RED_INTENCITY_COEF = 0.2989;
    const GREEN_INTENCITY_COEF = 0.5870;
    const BLUE_INTENCITY_COEF = 0.1140;
    const totalPixelsInImage = $image.shape[0] * $image.shape[1];
    let $threshold = (0, $r7fN6.mul)((0, $jIDgY.tensor1d)([
        threshValue
    ]), 255);
    let r, g, b, grayscale;
    $4tCOB.assert($image.rank === 3, ()=>'Error in threshold: image must be rank 3,' + `but got rank ${$image.rank}.`);
    $4tCOB.assert($image.shape[2] === 3 || $image.shape[2] === 1, ()=>"Error in threshold: image color channel must be equal to 3 or 1" + `but got ${$image.shape[2]}.`);
    $4tCOB.assert($image.dtype === 'int32' || $image.dtype === 'float32', ()=>'Error in dtype: image dtype must be int32 or float32,' + `but got dtype ${$image.dtype}.`);
    $4tCOB.assert(method === 'otsu' || method === 'binary', ()=>`Method must be binary or otsu, but was ${method}`);
    if ($image.shape[2] === 3) {
        [r, g, b] = (0, $9DjTt.split)($image, [
            1,
            1,
            1
        ], -1);
        const $r = (0, $r7fN6.mul)(r, RED_INTENCITY_COEF);
        const $g = (0, $r7fN6.mul)(g, GREEN_INTENCITY_COEF);
        const $b = (0, $r7fN6.mul)(b, BLUE_INTENCITY_COEF);
        grayscale = (0, $1ZrG5.add)((0, $1ZrG5.add)($r, $g), $b);
    } else grayscale = image;
    if (method === 'otsu') {
        const $histogram = (0, $5sha3.bincount)((0, $7qWZ5.cast)((0, $9mGGG.round)(grayscale), 'int32'), (0, $ec8bD.tensor)([]), 256);
        $threshold = $d663eb91cb4d90b6$var$otsu($histogram, totalPixelsInImage);
    }
    const invCondition = inverted ? (0, $eXGUa.lessEqual)(grayscale, $threshold) : (0, $jUhqf.greater)(grayscale, $threshold);
    const result = (0, $7qWZ5.cast)((0, $r7fN6.mul)(invCondition, 255), 'int32');
    return result;
}
function $d663eb91cb4d90b6$var$otsu(histogram, total) {
    let bestThresh = (0, $jIDgY.tensor1d)([
        -1
    ]);
    let bestInBetVar = (0, $jIDgY.tensor1d)([
        0
    ]);
    let cInBetVar = (0, $jIDgY.tensor1d)([
        0
    ]);
    let classFirst, classSecond, meanFirst, meanSec, weightForeground, weightBack;
    for(let index = 0; index < histogram.size - 1; index++){
        classFirst = (0, $kvpGg.slice)(histogram, 0, index + 1);
        classSecond = (0, $kvpGg.slice)(histogram, index + 1);
        weightForeground = (0, $gjFWY.div)((0, $fVwnn.sum)(classFirst), total);
        weightBack = (0, $gjFWY.div)((0, $fVwnn.sum)(classSecond), total);
        const meanFirstDivA = (0, $fVwnn.sum)((0, $r7fN6.mul)(classFirst, (0, $9qLoy.range)(0, classFirst.size)));
        meanFirst = (0, $gjFWY.div)(meanFirstDivA, (0, $fVwnn.sum)(classFirst));
        const meanSecFill = (0, $3kNX7.fill)(classSecond.shape, classFirst.size);
        const meanSecAdd = (0, $1ZrG5.add)((0, $9qLoy.range)(0, classSecond.size), meanSecFill);
        const meanSecMul = (0, $r7fN6.mul)(classSecond, meanSecAdd);
        meanSec = (0, $gjFWY.div)((0, $fVwnn.sum)(meanSecMul), (0, $fVwnn.sum)(classSecond));
        const cInBetVarSubA = (0, $hkR0n.sub)(meanFirst, meanSec);
        const cInBetVarSubB = (0, $hkR0n.sub)(meanFirst, meanSec);
        const cInBetVarMul = (0, $r7fN6.mul)(weightForeground, weightBack);
        cInBetVar = (0, $r7fN6.mul)((0, $r7fN6.mul)(cInBetVarMul, cInBetVarSubA), cInBetVarSubB);
        const condition = (0, $jUhqf.greater)(cInBetVar, bestInBetVar);
        bestInBetVar = (0, $3dRh6.where)(condition, cInBetVar, bestInBetVar);
        bestThresh = (0, $3dRh6.where)(condition, (0, $jIDgY.tensor1d)([
            index
        ]), bestThresh);
    }
    return bestThresh;
}
const $d663eb91cb4d90b6$export$454d09aca5f3ea63 = (0, $jKUCi.op)({
    threshold_: $d663eb91cb4d90b6$var$threshold_
});

});

parcelRegister("6bYuX", function(module, exports) {

$parcel$export(module.exports, "transform", () => $4822b2e15ae66e92$export$51186ad6e864892a);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Applies the given transform(s) to the image(s).
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 * @param transforms Projective transform matrix/matrices. A tensor1d of length
 *     8 or tensor of size N x 8. If one row of transforms is [a0, a1, a2, b0,
 *     b1, b2, c0, c1], then it maps the output point (x, y) to a transformed
 *     input point (x', y') = ((a0 x + a1 y + a2) / k, (b0 x + b1 y + b2) / k),
 *     where k = c0 x + c1 y + 1. The transforms are inverted compared to the
 *     transform mapping input points to output points.
 * @param interpolation Interpolation mode.
 *     Supported values: 'nearest', 'bilinear'. Default to 'nearest'.
 * @param fillMode Points outside the boundaries of the input are filled
 *     according to the given mode, one of 'constant', 'reflect', 'wrap',
 *     'nearest'. Default to 'constant'.
 *     'reflect': (d c b a | a b c d | d c b a ) The input is extended by
 *     reflecting about the edge of the last pixel.
 *     'constant': (k k k k | a b c d | k k k k) The input is extended by
 *     filling all values beyond the edge with the same constant value k.
 *     'wrap': (a b c d | a b c d | a b c d) The input is extended by
 *     wrapping around to the opposite edge.
 *     'nearest': (a a a a | a b c d | d d d d) The input is extended by
 *     the nearest pixel.
 * @param fillValue A float represents the value to be filled outside the
 *     boundaries when fillMode is 'constant'.
 * @param Output dimension after the transform, [height, width]. If undefined,
 *     output is the same size as input image.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $4822b2e15ae66e92$var$transform_(image, transforms, interpolation = 'nearest', fillMode = 'constant', fillValue = 0, outputShape) {
    const $image = (0, $5R1UY.convertToTensor)(image, 'image', 'transform', 'float32');
    const $transforms = (0, $5R1UY.convertToTensor)(transforms, 'transforms', 'transform', 'float32');
    $4tCOB.assert($image.rank === 4, ()=>'Error in transform: image must be rank 4,' + `but got rank ${$image.rank}.`);
    $4tCOB.assert($transforms.rank === 2 && ($transforms.shape[0] === $image.shape[0] || $transforms.shape[0] === 1) && $transforms.shape[1] === 8, ()=>`Error in transform: Input transform should be batch x 8 or 1 x 8`);
    $4tCOB.assert(outputShape == null || outputShape.length === 2, ()=>'Error in transform: outputShape must be [height, width] or null, ' + `but got ${outputShape}.`);
    const inputs = {
        image: $image,
        transforms: $transforms
    };
    const attrs = {
        interpolation: interpolation,
        fillMode: fillMode,
        fillValue: fillValue,
        outputShape: outputShape
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Transform), inputs, attrs);
}
const $4822b2e15ae66e92$export$51186ad6e864892a = (0, $jKUCi.op)({
    transform_: $4822b2e15ae66e92$var$transform_
});

});

parcelRegister("kwMSz", function(module, exports) {

$parcel$export(module.exports, "bandPart", () => $ef1cb62dce7e91a4$export$8a3da9cb9e5610a0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $cUuWi = parcelRequire("cUuWi");

var $eXGUa = parcelRequire("eXGUa");

var $jtRHJ = parcelRequire("jtRHJ");

var $jKUCi = parcelRequire("jKUCi");

var $9qLoy = parcelRequire("9qLoy");

var $eP0pM = parcelRequire("eP0pM");

var $j7yUF = parcelRequire("j7yUF");

var $iSKul = parcelRequire("iSKul");

var $hkR0n = parcelRequire("hkR0n");

var $kDeMO = parcelRequire("kDeMO");

var $3dRh6 = parcelRequire("3dRh6");

var $7KCJq = parcelRequire("7KCJq");
/**
 * Copy a tensor setting everything outside a central band in each innermost
 * matrix to zero.
 *
 * The band part is computed as follows: Assume input has `k` dimensions
 * `[I, J, K, ..., M, N]`, then the output is a tensor with the same shape where
 * `band[i, j, k, ..., m, n] = in_band(m, n) * input[i, j, k, ..., m, n]`.
 * The indicator function
 * `in_band(m, n) = (num_lower < 0 || (m-n) <= num_lower)`
 * `&& (num_upper < 0 || (n-m) <= num_upper)`
 *
 * ```js
 * const x = tf.tensor2d([[ 0,  1,  2, 3],
 *                        [-1,  0,  1, 2],
 *                        [-2, -1,  0, 1],
 *                        [-3, -2, -1, 0]]);
 * let y = tf.linalg.bandPart(x, 1, -1);
 * y.print(); // [[ 0,  1,  2, 3],
 *            //  [-1,  0,  1, 2],
 *            //  [ 0, -1,  0, 1],
 *            //  [ 0, 0 , -1, 0]]
 * let z = tf.linalg.bandPart(x, 2, 1);
 * z.print(); // [[ 0,  1,  0, 0],
 *            //  [-1,  0,  1, 0],
 *            //  [-2, -1,  0, 1],
 *            //  [ 0, -2, -1, 0]]
 * ```
 *
 * @param x Rank `k` tensor
 * @param numLower Number of subdiagonals to keep.
 *   If negative, keep entire lower triangle.
 * @param numUpper Number of subdiagonals to keep.
 *   If negative, keep entire upper triangle.
 * @returns Rank `k` tensor of the same shape as input.
 *   The extracted banded tensor.
 *
 * @doc {heading:'Operations', subheading:'Linear Algebra', namespace:'linalg'}
 */ function $ef1cb62dce7e91a4$var$bandPart_(a, numLower, numUpper) {
    (0, $4tCOB.assert)(numLower % 1 === 0, ()=>`bandPart(): numLower must be an integer, got ${numLower}.`);
    (0, $4tCOB.assert)(numUpper % 1 === 0, ()=>`bandPart(): numUpper must be an integer, got ${numUpper}.`);
    const $a = (0, $5R1UY.convertToTensor)(a, 'a', 'bandPart');
    (0, $4tCOB.assert)($a.rank >= 2, ()=>`bandPart(): Rank must be at least 2, got ${$a.rank}.`);
    const shape = $a.shape;
    const [M, N] = $a.shape.slice(-2);
    if (!(numLower <= M)) throw new Error(`bandPart(): numLower (${numLower})` + ` must not be greater than the number of rows (${M}).`);
    if (!(numUpper <= N)) throw new Error(`bandPart(): numUpper (${numUpper})` + ` must not be greater than the number of columns (${N}).`);
    if (numLower < 0) numLower = M;
    if (numUpper < 0) numUpper = N;
    const i = (0, $eP0pM.reshape)((0, $9qLoy.range)(0, M, 1, 'int32'), [
        -1,
        1
    ]);
    const j = (0, $9qLoy.range)(0, N, 1, 'int32');
    const ij = (0, $hkR0n.sub)(i, j);
    const inBand = (0, $jtRHJ.logicalAnd)((0, $eXGUa.lessEqual)(ij, (0, $j7yUF.scalar)(+numLower, 'int32')), (0, $cUuWi.greaterEqual)(ij, (0, $j7yUF.scalar)(-numUpper, 'int32')));
    const zero = (0, $7KCJq.zeros)([
        M,
        N
    ], $a.dtype);
    return (0, $eP0pM.reshape)((0, $iSKul.stack)((0, $kDeMO.unstack)((0, $eP0pM.reshape)($a, [
        -1,
        M,
        N
    ])).map((mat)=>(0, $3dRh6.where)(inBand, mat, zero))), shape);
}
const $ef1cb62dce7e91a4$export$8a3da9cb9e5610a0 = (0, $jKUCi.op)({
    bandPart_: $ef1cb62dce7e91a4$var$bandPart_
});

});

parcelRegister("oGh0c", function(module, exports) {

$parcel$export(module.exports, "gramSchmidt", () => $04a30896a13001d7$export$d505610386a600de);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $4tCOB = parcelRequire("4tCOB");

var $gjFWY = parcelRequire("gjFWY");

var $r7fN6 = parcelRequire("r7fN6");

var $eiMLq = parcelRequire("eiMLq");

var $jKUCi = parcelRequire("jKUCi");

var $9DjTt = parcelRequire("9DjTt");

var $wniip = parcelRequire("wniip");

var $iSKul = parcelRequire("iSKul");

var $hkR0n = parcelRequire("hkR0n");

var $fVwnn = parcelRequire("fVwnn");
/**
 * Gram-Schmidt orthogonalization.
 *
 * ```js
 * const x = tf.tensor2d([[1, 2], [3, 4]]);
 * let y = tf.linalg.gramSchmidt(x);
 * y.print();
 * console.log('Orthogonalized:');
 * y.dot(y.transpose()).print();  // should be nearly the identity matrix.
 * console.log('First row direction maintained:');
 * const data = await y.array();
 * console.log(data[0][1] / data[0][0]);  // should be nearly 2.
 * ```
 *
 * @param xs The vectors to be orthogonalized, in one of the two following
 *   formats:
 *   - An Array of `tf.Tensor1D`.
 *   - A `tf.Tensor2D`, i.e., a matrix, in which case the vectors are the rows
 *     of `xs`.
 *   In each case, all the vectors must have the same length and the length
 *   must be greater than or equal to the number of vectors.
 * @returns The orthogonalized and normalized vectors or matrix.
 *   Orthogonalization means that the vectors or the rows of the matrix
 *   are orthogonal (zero inner products). Normalization means that each
 *   vector or each row of the matrix has an L2 norm that equals `1`.
 *
 * @doc {heading:'Operations', subheading:'Linear Algebra', namespace:'linalg'}
 */ function $04a30896a13001d7$var$gramSchmidt_(xs) {
    let inputIsTensor2D;
    if (Array.isArray(xs)) {
        inputIsTensor2D = false;
        (0, $4tCOB.assert)(xs != null && xs.length > 0, ()=>"Gram-Schmidt process: input must not be null, undefined, or empty");
        const dim = xs[0].shape[0];
        for(let i = 1; i < xs.length; ++i)(0, $4tCOB.assert)(xs[i].shape[0] === dim, ()=>'Gram-Schmidt: Non-unique lengths found in the input vectors: ' + `(${xs[i].shape[0]} vs. ${dim})`);
    } else {
        inputIsTensor2D = true;
        xs = (0, $9DjTt.split)(xs, xs.shape[0], 0).map((x)=>(0, $wniip.squeeze)(x, [
                0
            ]));
    }
    (0, $4tCOB.assert)(xs.length <= xs[0].shape[0], ()=>`Gram-Schmidt: Number of vectors (${xs.length}) exceeds ` + `number of dimensions (${xs[0].shape[0]}).`);
    const ys = [];
    const xs1d = xs;
    for(let i = 0; i < xs.length; ++i)ys.push((0, $aHfUM.ENGINE).tidy(()=>{
        let x = xs1d[i];
        if (i > 0) for(let j = 0; j < i; ++j){
            const proj = (0, $r7fN6.mul)((0, $fVwnn.sum)((0, $r7fN6.mul)(ys[j], x)), ys[j]);
            x = (0, $hkR0n.sub)(x, proj);
        }
        return (0, $gjFWY.div)(x, (0, $eiMLq.norm)(x, 'euclidean'));
    }));
    if (inputIsTensor2D) return (0, $iSKul.stack)(ys, 0);
    else return ys;
}
const $04a30896a13001d7$export$d505610386a600de = (0, $jKUCi.op)({
    gramSchmidt_: $04a30896a13001d7$var$gramSchmidt_
});

});

parcelRegister("4kIb5", function(module, exports) {

$parcel$export(module.exports, "qr", () => $327b4c7ef908f73e$export$7c27fb47516129d9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $9c0Qr = parcelRequire("9c0Qr");

var $4tCOB = parcelRequire("4tCOB");

var $dnFj7 = parcelRequire("dnFj7");

var $6LWfo = parcelRequire("6LWfo");

var $gjFWY = parcelRequire("gjFWY");

var $dF7rq = parcelRequire("dF7rq");

var $jUhqf = parcelRequire("jUhqf");

var $clO9Z = parcelRequire("clO9Z");

var $r7fN6 = parcelRequire("r7fN6");

var $ifge7 = parcelRequire("ifge7");

var $eiMLq = parcelRequire("eiMLq");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");

var $kvpGg = parcelRequire("kvpGg");

var $iSKul = parcelRequire("iSKul");

var $hkR0n = parcelRequire("hkR0n");

var $g4QpC = parcelRequire("g4QpC");

var $9PEYs = parcelRequire("9PEYs");

var $kDeMO = parcelRequire("kDeMO");

var $3dRh6 = parcelRequire("3dRh6");
/**
 * Compute QR decomposition of m-by-n matrix using Householder transformation.
 *
 * Implementation based on
 *   [http://www.cs.cornell.edu/~bindel/class/cs6210-f09/lec18.pdf]
 * (http://www.cs.cornell.edu/~bindel/class/cs6210-f09/lec18.pdf)
 *
 * ```js
 * const a = tf.tensor2d([[1, 2], [3, 4]]);
 * let [q, r] = tf.linalg.qr(a);
 * console.log('Q');
 * q.print();
 * console.log('R');
 * r.print();
 * console.log('Orthogonalized');
 * q.dot(q.transpose()).print()  // should be nearly the identity matrix.
 * console.log('Reconstructed');
 * q.dot(r).print(); // should be nearly [[1, 2], [3, 4]];
 * ```
 *
 * @param x The `tf.Tensor` to be QR-decomposed. Must have rank >= 2. Suppose
 *   it has the shape `[..., M, N]`.
 * @param fullMatrices An optional boolean parameter. Defaults to `false`.
 *   If `true`, compute full-sized `Q`. If `false` (the default),
 *   compute only the leading N columns of `Q` and `R`.
 * @returns An `Array` of two `tf.Tensor`s: `[Q, R]`. `Q` is a unitary matrix,
 *   i.e., its columns all have unit norm and are mutually orthogonal.
 *   If `M >= N`,
 *     If `fullMatrices` is `false` (default),
 *       - `Q` has a shape of `[..., M, N]`,
 *       - `R` has a shape of `[..., N, N]`.
 *     If `fullMatrices` is `true` (default),
 *       - `Q` has a shape of `[..., M, M]`,
 *       - `R` has a shape of `[..., M, N]`.
 *   If `M < N`,
 *     - `Q` has a shape of `[..., M, M]`,
 *     - `R` has a shape of `[..., M, N]`.
 * @throws If the rank of `x` is less than 2.
 *
 * @doc {heading:'Operations',
 *       subheading:'Linear Algebra',
 *       namespace:'linalg'}
 */ function $327b4c7ef908f73e$var$qr_(x, fullMatrices = false) {
    (0, $4tCOB.assert)(x.rank >= 2, ()=>`qr() requires input tensor to have a rank >= 2, but got rank ${x.rank}`);
    if (x.rank === 2) return $327b4c7ef908f73e$var$qr2d(x, fullMatrices);
    else {
        // Rank > 2.
        // TODO(cais): Below we split the input into individual 2D tensors,
        //   perform QR decomposition on them and then stack the results back
        //   together. We should explore whether this can be parallelized.
        const outerDimsProd = x.shape.slice(0, x.shape.length - 2).reduce((value, prev)=>value * prev);
        const x2ds = (0, $kDeMO.unstack)((0, $eP0pM.reshape)(x, [
            outerDimsProd,
            x.shape[x.shape.length - 2],
            x.shape[x.shape.length - 1]
        ]), 0);
        const q2ds = [];
        const r2ds = [];
        x2ds.forEach((x2d)=>{
            const [q2d, r2d] = $327b4c7ef908f73e$var$qr2d(x2d, fullMatrices);
            q2ds.push(q2d);
            r2ds.push(r2d);
        });
        const q = (0, $eP0pM.reshape)((0, $iSKul.stack)(q2ds, 0), x.shape);
        const r = (0, $eP0pM.reshape)((0, $iSKul.stack)(r2ds, 0), x.shape);
        return [
            q,
            r
        ];
    }
}
function $327b4c7ef908f73e$var$qr2d(x, fullMatrices = false) {
    return (0, $aHfUM.ENGINE).tidy(()=>{
        (0, $4tCOB.assert)(x.shape.length === 2, ()=>`qr2d() requires a 2D Tensor, but got a ${x.shape.length}D Tensor.`);
        const m = x.shape[0];
        const n = x.shape[1];
        let q = (0, $dF7rq.eye)(m); // Orthogonal transform so far.
        let r = (0, $dnFj7.clone)(x); // Transformed matrix so far.
        const one2D = (0, $g4QpC.tensor2d)([
            [
                1
            ]
        ], [
            1,
            1
        ]);
        let w = (0, $dnFj7.clone)(one2D);
        const iters = m >= n ? n : m;
        for(let j = 0; j < iters; ++j){
            // This tidy within the for-loop ensures we clean up temporary
            // tensors as soon as they are no longer needed.
            const rTemp = r;
            const wTemp = w;
            const qTemp = q;
            [w, r, q] = (0, $aHfUM.ENGINE).tidy(()=>{
                // Find H = I - tau * w * w', to put zeros below R(j, j).
                const rjEnd1 = (0, $kvpGg.slice)(r, [
                    j,
                    j
                ], [
                    m - j,
                    1
                ]);
                const normX = (0, $eiMLq.norm)(rjEnd1);
                const rjj = (0, $kvpGg.slice)(r, [
                    j,
                    j
                ], [
                    1,
                    1
                ]);
                // The sign() function returns 0 on 0, which causes division by zero.
                const s = (0, $3dRh6.where)((0, $jUhqf.greater)(rjj, 0), (0, $g4QpC.tensor2d)([
                    [
                        -1
                    ]
                ]), (0, $g4QpC.tensor2d)([
                    [
                        1
                    ]
                ]));
                const u1 = (0, $hkR0n.sub)(rjj, (0, $r7fN6.mul)(s, normX));
                const wPre = (0, $gjFWY.div)(rjEnd1, u1);
                if (wPre.shape[0] === 1) w = (0, $dnFj7.clone)(one2D);
                else w = (0, $6LWfo.concat)([
                    one2D,
                    (0, $kvpGg.slice)(wPre, [
                        1,
                        0
                    ], [
                        wPre.shape[0] - 1,
                        wPre.shape[1]
                    ])
                ], 0);
                const tau = (0, $ifge7.neg)((0, $gjFWY.div)((0, $clO9Z.matMul)(s, u1), normX));
                // -- R := HR, Q := QH.
                const rjEndAll = (0, $kvpGg.slice)(r, [
                    j,
                    0
                ], [
                    m - j,
                    n
                ]);
                const tauTimesW = (0, $r7fN6.mul)(tau, w);
                const wT = (0, $9PEYs.transpose)(w);
                if (j === 0) r = (0, $hkR0n.sub)(rjEndAll, (0, $clO9Z.matMul)(tauTimesW, (0, $clO9Z.matMul)(wT, rjEndAll)));
                else {
                    const rTimesTau = (0, $hkR0n.sub)(rjEndAll, (0, $clO9Z.matMul)(tauTimesW, (0, $clO9Z.matMul)(wT, rjEndAll)));
                    r = (0, $6LWfo.concat)([
                        (0, $kvpGg.slice)(r, [
                            0,
                            0
                        ], [
                            j,
                            n
                        ]),
                        rTimesTau
                    ], 0);
                }
                const tawTimesWT = (0, $9PEYs.transpose)(tauTimesW);
                const qAllJEnd = (0, $kvpGg.slice)(q, [
                    0,
                    j
                ], [
                    m,
                    q.shape[1] - j
                ]);
                if (j === 0) q = (0, $hkR0n.sub)(qAllJEnd, (0, $clO9Z.matMul)((0, $clO9Z.matMul)(qAllJEnd, w), tawTimesWT));
                else {
                    const qTimesTau = (0, $hkR0n.sub)(qAllJEnd, (0, $clO9Z.matMul)((0, $clO9Z.matMul)(qAllJEnd, w), tawTimesWT));
                    q = (0, $6LWfo.concat)([
                        (0, $kvpGg.slice)(q, [
                            0,
                            0
                        ], [
                            m,
                            j
                        ]),
                        qTimesTau
                    ], 1);
                }
                return [
                    w,
                    r,
                    q
                ];
            });
            (0, $9c0Qr.dispose)([
                rTemp,
                wTemp,
                qTemp
            ]);
        }
        if (!fullMatrices && m > n) {
            q = (0, $kvpGg.slice)(q, [
                0,
                0
            ], [
                m,
                n
            ]);
            r = (0, $kvpGg.slice)(r, [
                0,
                0
            ], [
                n,
                n
            ]);
        }
        return [
            q,
            r
        ];
    });
}
const $327b4c7ef908f73e$export$7c27fb47516129d9 = (0, $jKUCi.op)({
    qr_: $327b4c7ef908f73e$var$qr_
});

});

parcelRegister("aL3Tc", function(module, exports) {

$parcel$export(module.exports, "absoluteDifference", () => $7d514f7fad08c37a$export$d81f35aebafd8971);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $6oc11 = parcelRequire("6oc11");

var $fsE65 = parcelRequire("fsE65");

var $jKUCi = parcelRequire("jKUCi");

var $hkR0n = parcelRequire("hkR0n");

var $dcP3m = parcelRequire("dcP3m");
/**
 * Computes the absolute difference loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $7d514f7fad08c37a$var$absoluteDifference_(labels, predictions, weights, reduction = (0, $fsE65.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $5R1UY.convertToTensor)(labels, 'labels', 'absoluteDifference');
    const $predictions = (0, $5R1UY.convertToTensor)(predictions, 'predictions', 'absoluteDifference');
    let $weights = null;
    if (weights != null) $weights = (0, $5R1UY.convertToTensor)(weights, 'weights', 'absoluteDifference');
    (0, $4tCOB.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in absoluteDifference: ');
    const losses = (0, $6oc11.abs)((0, $hkR0n.sub)($labels, $predictions));
    return (0, $dcP3m.computeWeightedLoss)(losses, $weights, reduction);
}
const $7d514f7fad08c37a$export$d81f35aebafd8971 = (0, $jKUCi.op)({
    absoluteDifference_: $7d514f7fad08c37a$var$absoluteDifference_
});

});
parcelRegister("fsE65", function(module, exports) {

$parcel$export(module.exports, "Reduction", () => $b418930137871a5c$export$cc9fa7113d70efba);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $b418930137871a5c$export$cc9fa7113d70efba;
(function(Reduction) {
    Reduction[Reduction["NONE"] = 0] = "NONE";
    Reduction[Reduction["MEAN"] = 1] = "MEAN";
    Reduction[Reduction["SUM"] = 2] = "SUM";
    Reduction[Reduction["SUM_BY_NONZERO_WEIGHTS"] = 3] = "SUM_BY_NONZERO_WEIGHTS";
})($b418930137871a5c$export$cc9fa7113d70efba || ($b418930137871a5c$export$cc9fa7113d70efba = {}));

});

parcelRegister("dcP3m", function(module, exports) {

$parcel$export(module.exports, "computeWeightedLoss", () => $99d3ff7070aef1fe$export$23bdc4cea2e28782);

var $5R1UY = parcelRequire("5R1UY");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gjFWY = parcelRequire("gjFWY");

var $fsE65 = parcelRequire("fsE65");

var $gr40e = parcelRequire("gr40e");

var $r7fN6 = parcelRequire("r7fN6");

var $i8e86 = parcelRequire("i8e86");

var $bhi4b = parcelRequire("bhi4b");

var $jKUCi = parcelRequire("jKUCi");

var $j7yUF = parcelRequire("j7yUF");

var $fVwnn = parcelRequire("fVwnn");
/**
 * Computes the weighted loss between two tensors.
 *
 * @param losses Tensor of shape `[batch_size, d1, ..., dN]`.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `losses`, and must be broadcastable to `losses` (i.e., all
 *    dimensions must be either `1`, or the same as the corresponding
 *    `losses` dimension).
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $99d3ff7070aef1fe$var$computeWeightedLoss_(losses, weights, reduction = (0, $fsE65.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $losses = (0, $5R1UY.convertToTensor)(losses, 'losses', 'computeWeightedLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $5R1UY.convertToTensor)(weights, 'weights', 'computeWeightedLoss');
    const weightedLoss = $weights == null ? $losses : (0, $r7fN6.mul)($losses, $weights);
    if (reduction === (0, $fsE65.Reduction).NONE) return weightedLoss;
    if (reduction === (0, $fsE65.Reduction).SUM) return (0, $fVwnn.sum)(weightedLoss);
    if (reduction === (0, $fsE65.Reduction).MEAN) {
        if ($weights == null) return (0, $gr40e.mean)(weightedLoss);
        else {
            const broadcastFactor = $losses.size / $weights.size;
            const result = (0, $gjFWY.div)((0, $fVwnn.sum)(weightedLoss), (0, $fVwnn.sum)($weights));
            return broadcastFactor > 1 ? (0, $gjFWY.div)(result, (0, $j7yUF.scalar)(broadcastFactor)) : result;
        }
    }
    if (reduction === (0, $fsE65.Reduction).SUM_BY_NONZERO_WEIGHTS) {
        if ($weights == null) return (0, $gjFWY.div)((0, $fVwnn.sum)(weightedLoss), (0, $j7yUF.scalar)($losses.size));
        else {
            const broadcastedWeights = (0, $r7fN6.mul)($weights, (0, $bhi4b.ones)($losses.shape));
            const numNonZeros = (0, $7qWZ5.cast)((0, $fVwnn.sum)((0, $i8e86.notEqual)(broadcastedWeights, (0, $j7yUF.scalar)(0))), 'float32');
            return (0, $gjFWY.div)((0, $fVwnn.sum)(weightedLoss), numNonZeros);
        }
    }
    throw Error(`Unknown reduction: ${reduction}`);
}
const $99d3ff7070aef1fe$export$23bdc4cea2e28782 = (0, $jKUCi.op)({
    computeWeightedLoss_: $99d3ff7070aef1fe$var$computeWeightedLoss_
});

});


parcelRegister("enJxP", function(module, exports) {

$parcel$export(module.exports, "cosineDistance", () => $a7868ae58a3780f3$export$6168ae03858f836b);

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $fsE65 = parcelRequire("fsE65");

var $r7fN6 = parcelRequire("r7fN6");

var $jKUCi = parcelRequire("jKUCi");

var $j7yUF = parcelRequire("j7yUF");

var $hkR0n = parcelRequire("hkR0n");

var $fVwnn = parcelRequire("fVwnn");

var $dcP3m = parcelRequire("dcP3m");
/**
 * Computes the cosine distance loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param axis The dimension along which the cosine distance is computed.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $a7868ae58a3780f3$var$cosineDistance_(labels, predictions, axis, weights, reduction = (0, $fsE65.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $5R1UY.convertToTensor)(labels, 'labels', 'cosineDistance');
    const $predictions = (0, $5R1UY.convertToTensor)(predictions, 'predictions', 'cosineDistance');
    let $weights = null;
    if (weights != null) $weights = (0, $5R1UY.convertToTensor)(weights, 'weights', 'cosineDistance');
    (0, $4tCOB.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in cosineDistance: ');
    const one = (0, $j7yUF.scalar)(1);
    const losses = (0, $hkR0n.sub)(one, (0, $fVwnn.sum)((0, $r7fN6.mul)($labels, $predictions), axis, true));
    return (0, $dcP3m.computeWeightedLoss)(losses, $weights, reduction);
}
const $a7868ae58a3780f3$export$6168ae03858f836b = (0, $jKUCi.op)({
    cosineDistance_: $a7868ae58a3780f3$var$cosineDistance_
});

});

parcelRegister("il8yL", function(module, exports) {

$parcel$export(module.exports, "hingeLoss", () => $d5a0d3eff2496482$export$fc7754731492f43f);

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $fsE65 = parcelRequire("fsE65");

var $r7fN6 = parcelRequire("r7fN6");

var $jKUCi = parcelRequire("jKUCi");

var $1mZlL = parcelRequire("1mZlL");

var $j7yUF = parcelRequire("j7yUF");

var $hkR0n = parcelRequire("hkR0n");

var $dcP3m = parcelRequire("dcP3m");
/**
 * Computes the Hinge loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $d5a0d3eff2496482$var$hingeLoss_(labels, predictions, weights, reduction = (0, $fsE65.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    let $labels = (0, $5R1UY.convertToTensor)(labels, 'labels', 'hingeLoss');
    const $predictions = (0, $5R1UY.convertToTensor)(predictions, 'predictions', 'hingeLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $5R1UY.convertToTensor)(weights, 'weights', 'hingeLoss');
    (0, $4tCOB.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in hingeLoss: ');
    const one = (0, $j7yUF.scalar)(1);
    // Convert binary labels to (-1, 1)
    $labels = (0, $hkR0n.sub)((0, $r7fN6.mul)((0, $j7yUF.scalar)(2), $labels), one);
    const losses = (0, $1mZlL.relu)((0, $hkR0n.sub)(one, (0, $r7fN6.mul)($labels, $predictions)));
    return (0, $dcP3m.computeWeightedLoss)(losses, $weights, reduction);
}
const $d5a0d3eff2496482$export$fc7754731492f43f = (0, $jKUCi.op)({
    hingeLoss_: $d5a0d3eff2496482$var$hingeLoss_
});

});

parcelRegister("jJ1jq", function(module, exports) {

$parcel$export(module.exports, "huberLoss", () => $e5c33ce9902a1785$export$ad2dd557b367bf2b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $6oc11 = parcelRequire("6oc11");

var $1ZrG5 = parcelRequire("1ZrG5");

var $fsE65 = parcelRequire("fsE65");

var $dlTNL = parcelRequire("dlTNL");

var $r7fN6 = parcelRequire("r7fN6");

var $jKUCi = parcelRequire("jKUCi");

var $j7yUF = parcelRequire("j7yUF");

var $gqriC = parcelRequire("gqriC");

var $hkR0n = parcelRequire("hkR0n");

var $dcP3m = parcelRequire("dcP3m");
/**
 * Computes the Huber loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param delta Point where Huber loss changes from quadratic to linear.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`.
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $e5c33ce9902a1785$var$huberLoss_(labels, predictions, weights, delta = 1.0, reduction = (0, $fsE65.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $5R1UY.convertToTensor)(labels, 'labels', 'huberLoss');
    const $predictions = (0, $5R1UY.convertToTensor)(predictions, 'predictions', 'huberLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $5R1UY.convertToTensor)(weights, 'weights', 'huberLoss');
    (0, $4tCOB.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in huberLoss: ');
    const deltaScalar = (0, $j7yUF.scalar)(delta);
    const error = (0, $6oc11.abs)((0, $hkR0n.sub)($predictions, $labels));
    const quadratic = (0, $dlTNL.minimum)(error, deltaScalar);
    const linear = (0, $hkR0n.sub)(error, quadratic);
    const losses = (0, $1ZrG5.add)((0, $r7fN6.mul)((0, $j7yUF.scalar)(0.5), (0, $gqriC.square)(quadratic)), (0, $r7fN6.mul)(deltaScalar, linear));
    return (0, $dcP3m.computeWeightedLoss)(losses, $weights, reduction);
}
const $e5c33ce9902a1785$export$ad2dd557b367bf2b = (0, $jKUCi.op)({
    huberLoss_: $e5c33ce9902a1785$var$huberLoss_
});

});

parcelRegister("djdi3", function(module, exports) {

$parcel$export(module.exports, "logLoss", () => $9b075be2d81b0932$export$5ca6937b99935214);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $1ZrG5 = parcelRequire("1ZrG5");

var $djEuh = parcelRequire("djEuh");

var $fsE65 = parcelRequire("fsE65");

var $r7fN6 = parcelRequire("r7fN6");

var $ifge7 = parcelRequire("ifge7");

var $jKUCi = parcelRequire("jKUCi");

var $j7yUF = parcelRequire("j7yUF");

var $hkR0n = parcelRequire("hkR0n");

var $dcP3m = parcelRequire("dcP3m");
/**
 * Computes the log loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param epsilon A small increment to avoid taking log of zero
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $9b075be2d81b0932$var$logLoss_(labels, predictions, weights, epsilon = 1e-7, reduction = (0, $fsE65.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $5R1UY.convertToTensor)(labels, 'labels', 'logLoss');
    const $predictions = (0, $5R1UY.convertToTensor)(predictions, 'predictions', 'logLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $5R1UY.convertToTensor)(weights, 'weights', 'logLoss');
    (0, $4tCOB.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in logLoss: ');
    const one = (0, $j7yUF.scalar)(1);
    const epsilonScalar = (0, $j7yUF.scalar)(epsilon);
    const l1 = (0, $ifge7.neg)((0, $r7fN6.mul)($labels, (0, $djEuh.log)((0, $1ZrG5.add)($predictions, epsilonScalar))));
    const l2 = (0, $r7fN6.mul)((0, $hkR0n.sub)(one, $labels), (0, $djEuh.log)((0, $1ZrG5.add)((0, $hkR0n.sub)(one, $predictions), epsilonScalar)));
    const losses = (0, $hkR0n.sub)(l1, l2);
    return (0, $dcP3m.computeWeightedLoss)(losses, $weights, reduction);
}
const $9b075be2d81b0932$export$5ca6937b99935214 = (0, $jKUCi.op)({
    logLoss_: $9b075be2d81b0932$var$logLoss_
});

});

parcelRegister("4Vmwx", function(module, exports) {

$parcel$export(module.exports, "meanSquaredError", () => $395df50d00864951$export$33de16355e97f7fb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $fsE65 = parcelRequire("fsE65");

var $jKUCi = parcelRequire("jKUCi");

var $fRX4k = parcelRequire("fRX4k");

var $dcP3m = parcelRequire("dcP3m");
/**
 * Computes the mean squared error between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $395df50d00864951$var$meanSquaredError_(labels, predictions, weights, reduction = (0, $fsE65.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $5R1UY.convertToTensor)(labels, 'labels', 'meanSquaredError');
    const $predictions = (0, $5R1UY.convertToTensor)(predictions, 'predictions', 'meanSquaredError');
    let $weights = null;
    if (weights != null) $weights = (0, $5R1UY.convertToTensor)(weights, 'weights', 'meanSquaredError');
    (0, $4tCOB.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in meanSquaredError: ');
    const losses = (0, $fRX4k.squaredDifference)($labels, $predictions);
    return (0, $dcP3m.computeWeightedLoss)(losses, $weights, reduction);
}
const $395df50d00864951$export$33de16355e97f7fb = (0, $jKUCi.op)({
    meanSquaredError_: $395df50d00864951$var$meanSquaredError_
});

});

parcelRegister("1A7rG", function(module, exports) {

$parcel$export(module.exports, "sigmoidCrossEntropy", () => $126eedc60b807c6d$export$d099e04c73e0aede);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $6oc11 = parcelRequire("6oc11");

var $1ZrG5 = parcelRequire("1ZrG5");

var $4NGnB = parcelRequire("4NGnB");

var $ibX5K = parcelRequire("ibX5K");

var $fsE65 = parcelRequire("fsE65");

var $r7fN6 = parcelRequire("r7fN6");

var $ifge7 = parcelRequire("ifge7");

var $jKUCi = parcelRequire("jKUCi");

var $1mZlL = parcelRequire("1mZlL");

var $j7yUF = parcelRequire("j7yUF");

var $hkR0n = parcelRequire("hkR0n");

var $dcP3m = parcelRequire("dcP3m");
function $126eedc60b807c6d$var$sigmoidCrossEntropyWithLogits_(labels, logits) {
    const $labels = (0, $5R1UY.convertToTensor)(labels, 'labels', 'sigmoidCrossEntropyWithLogits');
    const $logits = (0, $5R1UY.convertToTensor)(logits, 'logits', 'sigmoidCrossEntropyWithLogits');
    (0, $4tCOB.assertShapesMatch)($labels.shape, $logits.shape, 'Error in sigmoidCrossEntropyWithLogits: ');
    /**
     * Implementation Details:
     *
     * For brevity, let `x = logits`, `z = labels`.  The logistic loss is
     *     z * -log(sigmoid(x)) + (1 - z) * -log(1 - sigmoid(x))
     *   = z * -log(1 / (1 + exp(-x))) + (1 - z) * -log(exp(-x) / (1 + exp(-x)))
     *   = z * log(1 + exp(-x)) + (1 - z) * (-log(exp(-x)) + log(1 + exp(-x)))
     *   = z * log(1 + exp(-x)) + (1 - z) * (x + log(1 + exp(-x))
     *   = (1 - z) * x + log(1 + exp(-x))
     *   = x - x * z + log(1 + exp(-x))
     *
     *   For x < 0, to avoid overflow in exp(-x), we reformulate the above
     *     x - x * z + log(1 + exp(-x))
     *   = log(exp(x)) - x * z + log(1 + exp(-x))
     *   = - x * z + log(1 + exp(x))
     *
     * Hence, to ensure stability and avoid overflow, the implementation uses
     * this equivalent formulation:
     *     max(x, 0) - x * z + log(1 + exp(-abs(x)))
     */ const maxOutput = (0, $1mZlL.relu)($logits);
    const outputXTarget = (0, $r7fN6.mul)($logits, $labels);
    const sigmoidOutput = (0, $ibX5K.log1p)((0, $4NGnB.exp)((0, $ifge7.neg)((0, $6oc11.abs)($logits))));
    return (0, $1ZrG5.add)((0, $hkR0n.sub)(maxOutput, outputXTarget), sigmoidOutput);
}
/**
 * Computes the sigmoid cross entropy loss between two tensors.
 *
 * If labelSmoothing is nonzero, smooth the labels towards 1/2:
 *
 *   newMulticlassLabels = multiclassLabels * (1 - labelSmoothing)
 *                         + 0.5 * labelSmoothing
 *
 * @param multiClassLabels The ground truth output tensor of shape
 * [batch_size, num_classes], same dimensions as 'predictions'.
 * @param logits The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param labelSmoothing If greater than 0, then smooth the labels.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc { heading: 'Training', subheading: 'Losses', namespace: 'losses' }
 */ function $126eedc60b807c6d$var$sigmoidCrossEntropy_(multiClassLabels, logits, weights, labelSmoothing = 0, reduction = (0, $fsE65.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    let $multiClassLabels = (0, $5R1UY.convertToTensor)(multiClassLabels, 'multiClassLabels', 'sigmoidCrossEntropy');
    const $logits = (0, $5R1UY.convertToTensor)(logits, 'logits', 'sigmoidCrossEntropy');
    let $weights = null;
    if (weights != null) $weights = (0, $5R1UY.convertToTensor)(weights, 'weights', 'sigmoidCrossEntropy');
    (0, $4tCOB.assertShapesMatch)($multiClassLabels.shape, $logits.shape, 'Error in sigmoidCrossEntropy: ');
    if (labelSmoothing > 0) {
        const labelSmoothingScalar = (0, $j7yUF.scalar)(labelSmoothing);
        const one = (0, $j7yUF.scalar)(1);
        const half = (0, $j7yUF.scalar)(0.5);
        $multiClassLabels = (0, $1ZrG5.add)((0, $r7fN6.mul)($multiClassLabels, (0, $hkR0n.sub)(one, labelSmoothingScalar)), (0, $r7fN6.mul)(half, labelSmoothingScalar));
    }
    const losses = $126eedc60b807c6d$var$sigmoidCrossEntropyWithLogits_($multiClassLabels, $logits);
    return (0, $dcP3m.computeWeightedLoss)(losses, $weights, reduction);
}
const $126eedc60b807c6d$export$d099e04c73e0aede = (0, $jKUCi.op)({
    sigmoidCrossEntropy_: $126eedc60b807c6d$var$sigmoidCrossEntropy_
});

});

parcelRegister("3t3og", function(module, exports) {

$parcel$export(module.exports, "softmaxCrossEntropy", () => $2866b5c990b0d165$export$38869aa02829577);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jFQG4 = parcelRequire("jFQG4");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $1ZrG5 = parcelRequire("1ZrG5");

var $9k5Lx = parcelRequire("9k5Lx");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gjFWY = parcelRequire("gjFWY");

var $4NGnB = parcelRequire("4NGnB");

var $awUAx = parcelRequire("awUAx");

var $fsE65 = parcelRequire("fsE65");

var $r7fN6 = parcelRequire("r7fN6");

var $ifge7 = parcelRequire("ifge7");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");

var $j7yUF = parcelRequire("j7yUF");

var $hkR0n = parcelRequire("hkR0n");

var $fVwnn = parcelRequire("fVwnn");

var $dcP3m = parcelRequire("dcP3m");
/**
 * Computes softmax cross entropy between logits and labels.
 *
 * Measures the probability error in discrete classification tasks in which
 * the classes are mutually exclusive (each entry is in exactly one class).
 * For example, each CIFAR-10 image is labeled with one and only one label: an
 * image can be a dog or a truck, but not both.
 *
 * `NOTE`: While the classes are mutually exclusive, their probabilities need
 * not be. All that is required is that each row of labels is a valid
 * probability distribution. If they are not, the computation of the gradient
 * will be incorrect.
 *
 * `WARNING`: This op expects unscaled logits, since it performs a softmax on
 * logits internally for efficiency. Do not call this op with the output of
 * softmax, as it will produce incorrect results.
 *
 * logits and labels must have the same shape, e.g. [batch_size, num_classes]
 * and the same dtype.
 * @param labels The labels array.
 * @param logits The logits array.
 * @param dim The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 */ function $2866b5c990b0d165$var$softmaxCrossEntropyWithLogits_(labels, logits, dim = -1) {
    if (dim === -1) dim = logits.rank - 1;
    if (dim !== logits.rank - 1) throw Error(`Softmax cross entropy along a non-last dimension is not yet ` + `supported. Labels / logits was rank ${logits.rank} ` + `and dim was ${dim}`);
    // Use a custom gradient for numerical stability.
    const customOp = (0, $jFQG4.customGrad)((labels, logits, save)=>{
        // Reference:
        //   1. http://cs231n.github.io/linear-classify/#softmax
        //   2. https://blog.feedly.com/tricks-of-the-trade-logsumexp/
        const keepDims = true;
        const lse = (0, $awUAx.logSumExp)(logits, [
            dim
        ], keepDims);
        const logResult = (0, $hkR0n.sub)((0, $7qWZ5.cast)(logits, 'float32'), lse);
        save([
            labels,
            logResult
        ]);
        const costVector = (0, $ifge7.neg)((0, $r7fN6.mul)(logResult, labels));
        const value = (0, $fVwnn.sum)(costVector, [
            dim
        ]);
        const gradFunc = (dy, saved)=>{
            const [labels, logResult] = saved;
            const dyShape = (0, $9k5Lx.expandShapeToKeepDim)(dy.shape, [
                dim
            ]);
            return [
                (0, $r7fN6.mul)((0, $eP0pM.reshape)(dy, dyShape), (0, $hkR0n.sub)((0, $7qWZ5.cast)(labels, 'float32'), (0, $4NGnB.exp)(logResult))),
                (0, $r7fN6.mul)((0, $eP0pM.reshape)(dy, dyShape), (0, $hkR0n.sub)((0, $4NGnB.exp)(logResult), (0, $7qWZ5.cast)(labels, 'float32')))
            ];
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp(labels, logits);
}
/**
 * Computes the softmax cross entropy loss between two tensors.
 *
 * If labelSmoothing is nonzero, smooth the labels towards 1/2:
 *
 *   newOnehotLabels = onehotLabels * (1 - labelSmoothing)
 *                         + labelSmoothing / numClasses
 *
 * @param onehotLabels One hot encoded labels
 *    [batch_size, num_classes], same dimensions as 'predictions'.
 * @param logits The predicted outputs.
 * @param weights Tensor whose rank is either 0, or 1, and must be
 *    broadcastable to `loss`  of shape [batch_size]
 * @param labelSmoothing If greater than 0, then smooth the labels.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc { heading: 'Training', subheading: 'Losses', namespace: 'losses' }
 */ function $2866b5c990b0d165$var$softmaxCrossEntropy_(onehotLabels, logits, weights, labelSmoothing = 0, reduction = (0, $fsE65.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    let $onehotLabels = (0, $5R1UY.convertToTensor)(onehotLabels, 'onehotLabels', 'softmaxCrossEntropy');
    const $logits = (0, $5R1UY.convertToTensor)(logits, 'logits', 'softmaxCrossEntropy');
    let $weights = null;
    if (weights != null) $weights = (0, $5R1UY.convertToTensor)(weights, 'weights', 'softmaxCrossEntropy');
    (0, $4tCOB.assertShapesMatch)($onehotLabels.shape, $logits.shape, 'Error in softmaxCrossEntropy: ');
    if (labelSmoothing > 0) {
        const labelSmoothingScalar = (0, $j7yUF.scalar)(labelSmoothing);
        const one = (0, $j7yUF.scalar)(1);
        const numClasses = (0, $j7yUF.scalar)($onehotLabels.shape[1]);
        $onehotLabels = (0, $1ZrG5.add)((0, $r7fN6.mul)($onehotLabels, (0, $hkR0n.sub)(one, labelSmoothingScalar)), (0, $gjFWY.div)(labelSmoothingScalar, numClasses));
    }
    const losses = $2866b5c990b0d165$var$softmaxCrossEntropyWithLogits_($onehotLabels, $logits);
    return (0, $dcP3m.computeWeightedLoss)(losses, $weights, reduction);
}
const $2866b5c990b0d165$export$38869aa02829577 = (0, $jKUCi.op)({
    softmaxCrossEntropy_: $2866b5c990b0d165$var$softmaxCrossEntropy_
});

});

parcelRegister("3g4Gf", function(module, exports) {

$parcel$export(module.exports, "sparseFillEmptyRows", () => $25f67f2872d1fd19$export$c82a1904a15b5028);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * The input SparseTensor is represented via the map of inputs {`indices`,
 * `values`, `denseShape`}. The output SparseTensor has the same `denseShape`
 * but with indices `outputIndices` and values `outputValues`. This op inserts a
 * single entry for every row that doesn't have any values. The index is created
 * as `[row, 0, ..., 0]` and the inserted value is `defaultValue`.
 *
 * For example, suppose `spInput` has shape [5, 6] and non-empty values:
 * [0, 1]: a
 * [0, 3]: b
 * [2, 0]: c
 * [3, 1]: d
 *
 * Rows 1 and 4 are empty, so the output will be of shape [5, 6] with values:
 * [0, 1]: a
 * [0, 3]: b
 * [1, 0]: `defaultValue`
 * [2, 0]: c
 * [3, 1]: d
 * [4, 0]: `defaultValue`
 *
 * The output SparseTensor will be in row-major order and will have the same
 * shape as the input.
 *
 * This op also returns an indicator vector shaped [dense_shape[0]] such that
 * emptyRowIndicator[i] = True iff row i was an empty row.
 *
 * And a reverse index map vector shaped [indices.shape[0]] that is used during
 * backpropagation, reverseIndexMap[i] = outi s.t. indices[i, j] ==
 * outputIndices[outi, j] for all j
 *
 * ```js
 * const result = tf.sparse.sparseFillEmptyRows(
 *   [[0, 0], [1, 0], [1, 3], [1, 4], [3, 2], [3, 3]],
 *   [0, 10, 13, 14, 32, 33], [5, 6], -1);
 * console.log(result);
 * result['outputIndices'].print(); // [[0, 0], [1, 0], [1, 3], [1, 4],
 *                                  //  [2, 0], [3, 2], [3, 3], [4, 0]]
 * result['outputValues'].print(); // [0, 10, 13, 14,-1, 32, 33, -1]
 * result['emptyRowIndicator'].print(); // [false, false, true, false, true]
 * result['reverseIndexMap'].print(); // [0, 1, 2, 3, 5, 6]
 * ```
 * @param indices: 2-D. The indices of the sparse tensor.
 * @param values: 1-D. The values of the sparse tensor.
 * @param denseShape: 1-D. The shape of the sparse tensor.
 * @param defaultValue: 0-D. Default value to insert into location [row, 0, ...,
 *     0] for rows missing from the input sparse tensor.
 * @return A map with the following properties:
 *     - outputIndices
 *     - outputValues: 1-D. The values of the filled sparse tensor.
 *     - emptyRowIndicator: 1-D. Whether the dense row was missing in the input
 * sparse tensor.
 *     - reverseIndexMap: 1-D. A map from the input indices to the output
 * indices.
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $25f67f2872d1fd19$var$sparseFillEmptyRows_(indices, values, denseShape, defaultValue) {
    const $indices = (0, $5R1UY.convertToTensor)(indices, 'indices', 'sparseFillEmptyRows', 'int32');
    const $values = (0, $5R1UY.convertToTensor)(values, 'values', 'sparseFillEmptyRows');
    const $denseShape = (0, $5R1UY.convertToTensor)(denseShape, 'denseShape', 'sparseFillEmptyRows', 'int32');
    const $defaultValue = (0, $5R1UY.convertToTensor)(defaultValue, 'defaultValue', 'sparseFillEmptyRows', $values.dtype);
    if ($indices.rank !== 2) throw new Error(`Indices should be Tensor2D but received shape
        ${$indices.shape}`);
    if ($values.rank !== 1) throw new Error(`Values should be Tensor1D but received shape ${$values.shape}`);
    if ($denseShape.rank !== 1) throw new Error(`Dense shape should be Tensor1D but received shape ${$denseShape.shape}`);
    if ($defaultValue.rank !== 0) throw new Error(`Default value should be a scalar but received shape ${$defaultValue.shape}`);
    const inputs = {
        indices: $indices,
        values: $values,
        denseShape: $denseShape,
        defaultValue: $defaultValue
    };
    const result = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.SparseFillEmptyRows), inputs);
    return {
        outputIndices: result[0],
        outputValues: result[1],
        emptyRowIndicator: result[2],
        reverseIndexMap: result[3]
    };
}
const $25f67f2872d1fd19$export$c82a1904a15b5028 = (0, $jKUCi.op)({
    sparseFillEmptyRows_: $25f67f2872d1fd19$var$sparseFillEmptyRows_
});

});

parcelRegister("agocD", function(module, exports) {

$parcel$export(module.exports, "sparseReshape", () => $778e2c2fe249c963$export$1408c45865e11fc6);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * This operation has the same semantics as reshape on the represented dense
 * tensor. The `inputIndices` are recomputed based on the requested `newShape`.
 * If one component of `newShape` is the special value -1, the size of that
 * dimension is computed so that the total dense size remains constant. At most
 * one component of `newShape` can be -1. The number of dense elements implied
 * by `newShape` must be the same as the number of dense elements originally
 * implied by `inputShape`. Reshaping does not affect the order of values in the
 * SparseTensor. If the input tensor has rank R_in and N non-empty values, and
 * `newShape` has length R_out, then `inputIndices` has shape [N, R_in],
 * `inputShape` has length R_in, `outputIndices` has shape [N, R_out], and
 * `outputShape` has length R_out.
 *
 * ```js
 * const result = tf.sparse.sparseReshape(
 *   [[0, 0, 0], [0, 0, 1], [0, 1, 0], [1, 0, 0], [1, 2, 3]],
 *   [2, 3, 6], [9, -1]);
 * console.log(result);
 * result['outputIndices'].print(); //[[0, 0], [0, 1], [1, 2], [4, 2], [8, 1]]
 * result['outputShape'].print(); // [9, 4]
 * ```
 * @param inputIndices: 2-D. N x R_in matrix with the indices of non-empty
 * values in a SparseTensor.
 * @param inputShape: 1-D. R_in Tensor1D with the input SparseTensor's dense
 * shape.
 * @param newShape: 1-D. R_out Tensor1D with the requested new dense shape.
 * @return A map with the following properties:
 *     - outputIndices: 2-D. N x R_out matrix with the updated indices of
 *       non-empty values in the output SparseTensor.
 *     - outputShape: 1-D. R_out vector with the full dense shape of the output
 *       SparseTensor. This is the same as newShape but with any -1 dimensions
 *        filled in.
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $778e2c2fe249c963$var$sparseReshape_(inputIndices, inputShape, newShape) {
    const $inputIndices = (0, $5R1UY.convertToTensor)(inputIndices, 'inputIndices', 'sparseReshape', 'int32');
    const $inputShape = (0, $5R1UY.convertToTensor)(inputShape, 'inputShape', 'sparseReshape', 'int32');
    const $newShape = (0, $5R1UY.convertToTensor)(newShape, 'newShape', 'sparseReshape', 'int32');
    if ($inputIndices.rank !== 2) throw new Error(`Input indices should be Tensor2D but received shape
        ${$inputIndices.shape}`);
    if ($inputShape.rank !== 1) throw new Error(`Input shape should be Tensor1D but received shape ${$inputShape.shape}`);
    if ($newShape.rank !== 1) throw new Error(`New shape should be Tensor1D but received shape ${$newShape.shape}`);
    const inputs = {
        inputIndices: $inputIndices,
        inputShape: $inputShape,
        newShape: $newShape
    };
    const result = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.SparseReshape), inputs);
    return {
        outputIndices: result[0],
        outputShape: result[1]
    };
}
const $778e2c2fe249c963$export$1408c45865e11fc6 = (0, $jKUCi.op)({
    sparseReshape_: $778e2c2fe249c963$var$sparseReshape_
});

});

parcelRegister("hv4k2", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentMean", () => $cbd8af32641e4341$export$dbc0c9096869d04e);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the mean along sparse segments of a tensor.
 *
 * ```js
 * const c = tf.tensor2d([[1,2,3,4], [-1,-2,-3,-4], [6,7,8,9]]);
 * // Select two rows, one segment.
 * const result1 = tf.sparse.sparseSegmentMean(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 0], 'int32'));
 * result1.print(); // [[0, 0, 0, 0]]
 *
 * // Select two rows, two segments.
 * const result2 = tf.sparse.sparseSegmentMean(c,
 *                                             tf.tensor1d([0, 1], 'int32'),
 *                                             tf.tensor1d([0, 1], 'int32'));
 * result2.print(); // [[1, 2, 3, 4], [-1, -2, -3, -4]]
 *
 * // Select all rows, two segments.
 * const result3 = tf.sparse.sparseSegmentMean(c,
 *                                             tf.tensor1d([0, 1, 2], 'int32'),
 *                                             tf.tensor1d([0, 1, 1], 'int32'));
 * result3.print(); // [[1.0, 2.0, 3.0, 4.0], [2.5, 2.5, 2.5, 2.5]]
 * ```
 * @param data: A Tensor of at least one dimension with data that will be
 *     assembled in the output.
 * @param indices: A 1-D Tensor with indices into data. Has same rank as
 *     segmentIds.
 * @param segmentIds: A 1-D Tensor with indices into the output Tensor. Values
 *     should be sorted and can be repeated.
 * @return Has same shape as data, except for dimension 0 which has equal to
 *         the number of segments.
 *
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $cbd8af32641e4341$var$sparseSegmentMean_(data, indices, segmentIds) {
    const $data = (0, $5R1UY.convertToTensor)(data, 'data', 'sparseSegmentMean');
    const $indices = (0, $5R1UY.convertToTensor)(indices, 'indices', 'sparseSegmentMean', 'int32');
    const $segmentIds = (0, $5R1UY.convertToTensor)(segmentIds, 'segmentIds', 'sparseSegmentMean', 'int32');
    if ($data.rank < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if ($indices.rank !== 1) throw new Error(`Indices should be Tensor1D but received shape
          ${$indices.shape}`);
    if ($segmentIds.rank !== 1) throw new Error(`Segment ids should be Tensor1D but received shape
          ${$segmentIds.shape}`);
    const inputs = {
        data: $data,
        indices: $indices,
        segmentIds: $segmentIds
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.SparseSegmentMean), inputs);
}
const $cbd8af32641e4341$export$dbc0c9096869d04e = (0, $jKUCi.op)({
    sparseSegmentMean_: $cbd8af32641e4341$var$sparseSegmentMean_
});

});

parcelRegister("hVn6d", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentSum", () => $d0c9ad8eef90cc66$export$2255ce53fc777865);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the sum along sparse segments of a tensor.
 *
 * ```js
 * const c = tf.tensor2d([[1,2,3,4], [-1,-2,-3,-4], [5,6,7,8]]);
 * // Select two rows, one segment.
 * const result1 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 0], 'int32'));
 * result1.print(); // [[0, 0, 0, 0]]
 *
 * // Select two rows, two segments.
 * const result2 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 1], 'int32'));
 * result2.print(); // [[1, 2, 3, 4], [-1, -2, -3, -4]]
 *
 * // Select all rows, two segments.
 * const result3 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1, 2], 'int32'),
 *                                           tf.tensor1d([0, 0, 1], 'int32'));
 * result3.print(); // [[0, 0, 0, 0], [5, 6, 7, 8]]
 * ```
 * @param data: A Tensor of at least one dimension with data that will be
 *     assembled in the output.
 * @param indices: A 1-D Tensor with indices into data. Has same rank as
 *     segmentIds.
 * @param segmentIds: A 1-D Tensor with indices into the output Tensor. Values
 *     should be sorted and can be repeated.
 * @return Has same shape as data, except for dimension 0 which has equal to
 *         the number of segments.
 *
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $d0c9ad8eef90cc66$var$sparseSegmentSum_(data, indices, segmentIds) {
    const $data = (0, $5R1UY.convertToTensor)(data, 'data', 'sparseSegmentSum');
    const $indices = (0, $5R1UY.convertToTensor)(indices, 'indices', 'sparseSegmentSum', 'int32');
    const $segmentIds = (0, $5R1UY.convertToTensor)(segmentIds, 'segmentIds', 'sparseSegmentSum', 'int32');
    if ($data.rank < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if ($indices.rank !== 1) throw new Error(`Indices should be Tensor1D but received shape
         ${$indices.shape}`);
    if ($segmentIds.rank !== 1) throw new Error(`Segment ids should be Tensor1D but received shape
         ${$segmentIds.shape}`);
    const inputs = {
        data: $data,
        indices: $indices,
        segmentIds: $segmentIds
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.SparseSegmentSum), inputs);
}
const $d0c9ad8eef90cc66$export$2255ce53fc777865 = (0, $jKUCi.op)({
    sparseSegmentSum_: $d0c9ad8eef90cc66$var$sparseSegmentSum_
});

});

parcelRegister("fALN6", function(module, exports) {

$parcel$export(module.exports, "stringNGrams", () => $02edec8ccfb286c1$export$3490514dcc63b044);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Creates ngrams from ragged string data.
 *
 * This op accepts a ragged tensor with 1 ragged dimension containing only
 * strings and outputs a ragged tensor with 1 ragged dimension containing ngrams
 * of that string, joined along the innermost axis.
 *
 * ```js
 * const result = tf.string.stringNGrams(
 *   ['a', 'b', 'c', 'd'], tf.tensor1d([0, 2, 4], 'int32'),
 *   '|', [1, 2], 'LP', 'RP', -1, false);
 * result['nGrams'].print(); // ['a', 'b', 'LP|a', 'a|b', 'b|RP',
 *                           //  'c', 'd', 'LP|c', 'c|d', 'd|RP']
 * result['nGramsSplits'].print(); // [0, 5, 10]
 * ```
 * @param data: The values tensor of the ragged string tensor to make ngrams out
 *     of. Must be a 1D string tensor.
 * @param dataSplits: The splits tensor of the ragged string tensor to make
 *     ngrams out of.
 * @param separator: The string to append between elements of the token. Use ""
 *     for no separator.
 * @param nGramWidths: The sizes of the ngrams to create.
 * @param leftPad: The string to use to pad the left side of the ngram sequence.
 *     Only used if pad_width !== 0.
 * @param rightPad: The string to use to pad the right side of the ngram
 *     sequence. Only used if pad_width !== 0.
 * @param padWidth: The number of padding elements to add to each side of each
 *     sequence. Note that padding will never be greater than `nGramWidths`-1
 *     regardless of this value. If `padWidth`=-1, then add max(`nGramWidths`)-1
 *     elements.
 * @param preserveShortSequences: If true, then ensure that at least one ngram
 *     is generated for each input sequence. In particular, if an input sequence
 *     is shorter than min(ngramWidth) + 2*padWidth, then generate a single
 *     ngram containing the entire sequence. If false, then no ngrams are
 *     generated for these short input sequences.
 * @return A map with the following properties:
 *     - nGrams: The values tensor of the output ngrams ragged tensor.
 *     - nGramsSplits: The splits tensor of the output ngrams ragged tensor.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $02edec8ccfb286c1$var$stringNGrams_(data, dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences) {
    const $data = (0, $5R1UY.convertToTensor)(data, 'data', 'stringNGrams', 'string');
    if ($data.dtype !== 'string') throw new Error('Data must be of datatype string');
    if ($data.shape.length !== 1) throw new Error(`Data must be a vector, saw: ${$data.shape}`);
    const $dataSplits = (0, $5R1UY.convertToTensor)(dataSplits, 'dataSplits', 'stringNGrams');
    if ($dataSplits.dtype !== 'int32') throw new Error('Data splits must be of datatype int32');
    const attrs = {
        separator: separator,
        nGramWidths: nGramWidths,
        leftPad: leftPad,
        rightPad: rightPad,
        padWidth: padWidth,
        preserveShortSequences: preserveShortSequences
    };
    const inputs = {
        data: $data,
        dataSplits: $dataSplits
    };
    const result = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.StringNGrams), inputs, attrs);
    return {
        nGrams: result[0],
        nGramsSplits: result[1]
    };
}
const $02edec8ccfb286c1$export$3490514dcc63b044 = (0, $jKUCi.op)({
    stringNGrams_: $02edec8ccfb286c1$var$stringNGrams_
});

});

parcelRegister("kSqya", function(module, exports) {

$parcel$export(module.exports, "stringSplit", () => $f32d7212f566b7be$export$aa7f8babb17e7672);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Split elements of `input` based on `delimiter` into a SparseTensor .
 *
 * Let N be the size of source (typically N will be the batch size). Split each
 * element of `input` based on `delimiter` and return a SparseTensor containing
 * the splitted tokens. Empty tokens are ignored if `skipEmpty` is set to True.
 *
 * `delimiter` can be empty, or a string of split characters. If `delimiter` is
 * an empty string, each element of `input` is split into individual
 * character strings. Otherwise every character of `delimiter` is a potential
 * split point.
 *
 * ```js
 * const result = tf.string.stringSplit(['hello world',  'a b c'], ' ');
 * result['indices'].print(); // [[0, 0], [0, 1], [1, 0], [1, 1], [1, 2]]
 * result['values'].print(); // ['hello', 'world', 'a', 'b', 'c']
 * result['shape'].print(); // [2, 3]
 * ```
 * @param input: 1-D. Strings to split.
 * @param delimiter: 0-D. Delimiter characters, or empty string.
 * @param skipEmpty: Optional. If true, skip the empty strings from the result.
 *     Defaults to true.
 * @return A map with the following properties:
 *     - indices: A dense matrix of int32 representing the indices of the sparse
 *       tensor.
 *     - values: A vector of strings corresponding to the splited values.
 *     - shape: a length-2 vector of int32 representing the shape of the sparse
 * tensor, where the first value is N and the second value is the maximum number
 * of tokens in a single input entry.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $f32d7212f566b7be$var$stringSplit_(input, delimiter, skipEmpty = true) {
    const $input = (0, $5R1UY.convertToTensor)(input, 'input', 'stringSplit', 'string');
    const $delimiter = (0, $5R1UY.convertToTensor)(delimiter, 'delimiter', 'stringSplit', 'string');
    if ($input.rank !== 1) throw new Error(`Input should be Tensor1D but received shape ${$input.shape}`);
    if ($delimiter.rank !== 0) throw new Error(`Delimiter should be a scalar but received shape ${$delimiter.shape}`);
    const attrs = {
        skipEmpty: skipEmpty
    };
    const inputs = {
        input: $input,
        delimiter: $delimiter
    };
    const result = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.StringSplit), inputs, attrs);
    return {
        indices: result[0],
        values: result[1],
        shape: result[2]
    };
}
const $f32d7212f566b7be$export$aa7f8babb17e7672 = (0, $jKUCi.op)({
    stringSplit_: $f32d7212f566b7be$var$stringSplit_
});

});

parcelRegister("khO5h", function(module, exports) {

$parcel$export(module.exports, "stringToHashBucketFast", () => $ec4c3edc7c4ba460$export$6195616d6fd0c848);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Converts each string in the input Tensor to its hash mod by a number of
 * buckets.
 *
 * The hash function is deterministic on the content of the string within the
 * process and will never change. However, it is not suitable for cryptography.
 * This function may be used when CPU time is scarce and inputs are trusted or
 * unimportant. There is a risk of adversaries constructing inputs that all hash
 * to the same bucket.
 *
 * ```js
 * const result = tf.string.stringToHashBucketFast(
 *   ['Hello', 'TensorFlow', '2.x'], 3);
 * result.print(); // [0, 2, 2]
 * ```
 * @param input: The strings to assign a hash bucket.
 * @param numBuckets: The number of buckets.
 * @return A Tensor of the same shape as the input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $ec4c3edc7c4ba460$var$stringToHashBucketFast_(input, numBuckets) {
    const $input = (0, $5R1UY.convertToTensor)(input, 'input', 'stringToHashBucketFast', 'string');
    const attrs = {
        numBuckets: numBuckets
    };
    if (numBuckets <= 0) throw new Error(`Number of buckets must be at least 1`);
    const inputs = {
        input: $input
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.StringToHashBucketFast), inputs, attrs);
}
const $ec4c3edc7c4ba460$export$6195616d6fd0c848 = (0, $jKUCi.op)({
    stringToHashBucketFast_: $ec4c3edc7c4ba460$var$stringToHashBucketFast_
});

});


parcelRegister("bwWuH", function(module, exports) {

$parcel$export(module.exports, "train", () => $86500e916e97f2e0$export$9af937cf8bcbf96);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // So typings can propagate.






var $a7bcD = parcelRequire("a7bcD");


const $86500e916e97f2e0$export$9af937cf8bcbf96 = {
    sgd: (0, $a7bcD.OptimizerConstructors).sgd,
    momentum: (0, $a7bcD.OptimizerConstructors).momentum,
    adadelta: (0, $a7bcD.OptimizerConstructors).adadelta,
    adagrad: (0, $a7bcD.OptimizerConstructors).adagrad,
    rmsprop: (0, $a7bcD.OptimizerConstructors).rmsprop,
    adamax: (0, $a7bcD.OptimizerConstructors).adamax,
    adam: (0, $a7bcD.OptimizerConstructors).adam
};

});

parcelRegister("hy0Vl", function(module, exports) {

$parcel$export(module.exports, "nextFrame", () => $cc665420e258868d$export$68d2d147c928d1dd);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $cc665420e258868d$var$delayCallback = (()=>{
    if (typeof requestAnimationFrame !== 'undefined') return requestAnimationFrame;
    else if (typeof setImmediate !== 'undefined') return setImmediate;
    return (f)=>f(); // no delays
})();
/**
 * Returns a promise that resolves when a requestAnimationFrame has completed.
 *
 * On Node.js this uses setImmediate instead of requestAnimationFrame.
 *
 * This is simply a sugar method so that users can do the following:
 * `await tf.nextFrame();`
 *
 * @doc {heading: 'Performance', subheading: 'Timing'}
 */ function $cc665420e258868d$export$68d2d147c928d1dd() {
    return new Promise((resolve)=>$cc665420e258868d$var$delayCallback(()=>resolve()));
}

});

parcelRegister("lkN62", function(module, exports) {

$parcel$export(module.exports, "fromUint8ToStringArray", () => $f8818cbc70387983$export$debaff328bdca650);
$parcel$export(module.exports, "fromStringArrayToUint8", () => $f8818cbc70387983$export$ce1f4ec5bdd0ab9a);
$parcel$export(module.exports, "slice_util", () => (parcelRequire("1KPDG")));
$parcel$export(module.exports, "upcastType", () => (parcelRequire("bnEYl")).upcastType);
$parcel$export(module.exports, "segment_util", () => (parcelRequire("9UBZ0")));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $wx9lK = parcelRequire("wx9lK");

var $9k5Lx = parcelRequire("9k5Lx");

var $eqTIO = parcelRequire("eqTIO");

var $e2j1i = parcelRequire("e2j1i");

var $yLVwv = parcelRequire("yLVwv");

var $eg4Z1 = parcelRequire("eg4Z1");

var $5ZROo = parcelRequire("5ZROo");

var $btH58 = parcelRequire("btH58");

var $1KPDG = parcelRequire("1KPDG");

var $bnEYl = parcelRequire("bnEYl");

var $lxWyc = parcelRequire("lxWyc");

var $7nCsT = parcelRequire("7nCsT");

var $exBKX = parcelRequire("exBKX");

var $bSeux = parcelRequire("bSeux");

var $b8vU7 = parcelRequire("b8vU7");

var $eoONc = parcelRequire("eoONc");

var $1dbsU = parcelRequire("1dbsU");

var $9oI2K = parcelRequire("9oI2K");

var $jULKE = parcelRequire("jULKE");

var $fHUPl = parcelRequire("fHUPl");

var $fVXg8 = parcelRequire("fVXg8");

var $9Hizw = parcelRequire("9Hizw");

var $g7I6u = parcelRequire("g7I6u");

var $9UBZ0 = parcelRequire("9UBZ0");
function $f8818cbc70387983$export$debaff328bdca650(vals) {
    try {
        // Decode the bytes into string.
        return vals.map((val)=>(0, $wx9lK.decodeString)(val));
    } catch (err) {
        throw new Error(`Failed to decode encoded string bytes into utf-8, error: ${err}`);
    }
}
function $f8818cbc70387983$export$ce1f4ec5bdd0ab9a(strings) {
    return strings.map((s)=>(0, $wx9lK.encodeString)(s));
}
$parcel$exportWildcard(module.exports, $9k5Lx);
$parcel$exportWildcard(module.exports, $eqTIO);
$parcel$exportWildcard(module.exports, $e2j1i);
$parcel$exportWildcard(module.exports, $yLVwv);
$parcel$exportWildcard(module.exports, $eg4Z1);
$parcel$exportWildcard(module.exports, $5ZROo);
$parcel$exportWildcard(module.exports, $btH58);
$parcel$exportWildcard(module.exports, $lxWyc);
$parcel$exportWildcard(module.exports, $7nCsT);
$parcel$exportWildcard(module.exports, $exBKX);
$parcel$exportWildcard(module.exports, $bSeux);
$parcel$exportWildcard(module.exports, $b8vU7);
$parcel$exportWildcard(module.exports, $eoONc);
$parcel$exportWildcard(module.exports, $1dbsU);
$parcel$exportWildcard(module.exports, $9oI2K);
$parcel$exportWildcard(module.exports, $jULKE);
$parcel$exportWildcard(module.exports, $fHUPl);
$parcel$exportWildcard(module.exports, $fVXg8);
$parcel$exportWildcard(module.exports, $9Hizw);
$parcel$exportWildcard(module.exports, $g7I6u);

});
parcelRegister("e2j1i", function(module, exports) {

$parcel$export(module.exports, "assertParamsConsistent", () => $a3800191d3a156e2$export$ce1cccab5e7518dd);
$parcel$export(module.exports, "computeOutShape", () => $a3800191d3a156e2$export$22fa6b3b1305508e);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
function $a3800191d3a156e2$export$ce1cccab5e7518dd(shapes, axis) {
    const rank = shapes[0].length;
    shapes.forEach((shape, i)=>{
        $4tCOB.assert(shape.length === rank, ()=>`Error in concat${rank}D: rank of tensors[${i}] must be the same ` + `as the rank of the rest (${rank})`);
    });
    $4tCOB.assert(axis >= 0 && axis < rank, ()=>`Error in concat${rank}D: axis must be between 0 and ${rank - 1}.`);
    const firstShape = shapes[0];
    shapes.forEach((shape, i)=>{
        for(let r = 0; r < rank; r++)$4tCOB.assert(r === axis || shape[r] === firstShape[r], ()=>`Error in concat${rank}D: Shape of tensors[${i}] (${shape}) ` + `does not match the shape of the rest (${firstShape}) ` + `along the non-concatenated axis ${i}.`);
    });
}
function $a3800191d3a156e2$export$22fa6b3b1305508e(shapes, axis) {
    const outputShape = shapes[0].slice();
    for(let i = 1; i < shapes.length; i++)outputShape[axis] += shapes[i][axis];
    return outputShape;
}

});

parcelRegister("5ZROo", function(module, exports) {

$parcel$export(module.exports, "RowPartitionType", () => $45dc6422bcdfdaba$export$c56fa138ccffd243);
$parcel$export(module.exports, "combineRaggedTensorToTensorShapes", () => $45dc6422bcdfdaba$export$ab67507eda6e05cb);
$parcel$export(module.exports, "getRowPartitionTypesHelper", () => $45dc6422bcdfdaba$export$b8324e259bdd3daf);
$parcel$export(module.exports, "getRaggedRank", () => $45dc6422bcdfdaba$export$1cdd548e021d4109);
$parcel$export(module.exports, "validateDefaultValueShape", () => $45dc6422bcdfdaba$export$4170394182a906f5);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $45dc6422bcdfdaba$export$c56fa138ccffd243;
(function(RowPartitionType) {
    RowPartitionType[RowPartitionType["FIRST_DIM_SIZE"] = 0] = "FIRST_DIM_SIZE";
    RowPartitionType[RowPartitionType["VALUE_ROWIDS"] = 1] = "VALUE_ROWIDS";
    RowPartitionType[RowPartitionType["ROW_LENGTHS"] = 2] = "ROW_LENGTHS";
    RowPartitionType[RowPartitionType["ROW_SPLITS"] = 3] = "ROW_SPLITS";
    RowPartitionType[RowPartitionType["ROW_LIMITS"] = 4] = "ROW_LIMITS";
    RowPartitionType[RowPartitionType["ROW_STARTS"] = 5] = "ROW_STARTS";
})($45dc6422bcdfdaba$export$c56fa138ccffd243 || ($45dc6422bcdfdaba$export$c56fa138ccffd243 = {}));
function $45dc6422bcdfdaba$export$ab67507eda6e05cb(raggedRank, shape, valueShape) {
    // Test for consistency of valueShape and shape specified.
    // If shape is unspecified and valueShape is specified, then copy
    // over the size from the valueShape dimension.
    let outputShape = new Array();
    if (valueShape == null && shape == null) return outputShape;
    if (shape == null) // Here, value_shape must be of known size.
    while(outputShape.length < raggedRank + valueShape.length)outputShape.push(-1);
    else outputShape = shape.slice();
    if (valueShape == null) return outputShape;
    // At this point, valueShape and output_shape have known ranks.
    if (raggedRank + valueShape.length !== outputShape.length) throw new Error(`rt input.shape and shape=${shape} are incompatible: rt input.rank = ${raggedRank + valueShape.length}, but shape.rank = ${outputShape.length}`);
    for(let i = 1; i < valueShape.length; ++i){
        const valueDim = valueShape[i];
        const outputShapeDimIndex = outputShape[outputShape.length - valueShape.length + i];
        const outputShapeDim = outputShape[outputShapeDimIndex];
        if (valueDim >= 0) {
            if (outputShapeDim >= 0) {
                if (outputShapeDim !== valueDim) throw new Error(`rt input.shape and shape=${shape} are incompatible: rt input.shape[${i + raggedRank}] = ${valueDim} but shape[${i + raggedRank}] = ${outputShapeDim}`);
            } else outputShape[outputShapeDimIndex] = valueDim;
        }
    }
    return outputShape;
}
function $45dc6422bcdfdaba$export$b8324e259bdd3daf(rowPartitionTypeStrings) {
    const stringToType = {
        'FIRST_DIM_SIZE': $45dc6422bcdfdaba$export$c56fa138ccffd243.FIRST_DIM_SIZE,
        'VALUE_ROWIDS': $45dc6422bcdfdaba$export$c56fa138ccffd243.VALUE_ROWIDS,
        'ROW_LENGTHS': $45dc6422bcdfdaba$export$c56fa138ccffd243.ROW_LENGTHS,
        'ROW_SPLITS': $45dc6422bcdfdaba$export$c56fa138ccffd243.ROW_SPLITS,
        'ROW_LIMITS': $45dc6422bcdfdaba$export$c56fa138ccffd243.ROW_LIMITS,
        'ROW_STARTS': $45dc6422bcdfdaba$export$c56fa138ccffd243.ROW_STARTS
    };
    const result = [];
    for (const typeStr of rowPartitionTypeStrings){
        if (typeStr in stringToType) result.push(stringToType[typeStr]);
        else break;
    }
    return result;
}
function $45dc6422bcdfdaba$export$1cdd548e021d4109(rowPartitionTypes) {
    if (rowPartitionTypes.length === 0) return 0;
    if (rowPartitionTypes[0] === $45dc6422bcdfdaba$export$c56fa138ccffd243.FIRST_DIM_SIZE) return rowPartitionTypes.length - 1;
    return rowPartitionTypes.length;
}
function $45dc6422bcdfdaba$export$4170394182a906f5(defaultValueShape, valueShape) {
    if (defaultValueShape == null || valueShape == null) return;
    const defaultNDims = defaultValueShape.length;
    const valuesNDims = valueShape.length;
    if (defaultNDims >= valuesNDims) throw new Error(`defaultValue.shape=${defaultValueShape} and ragged tensor flatValues.shape=${valueShape}, are incompatible: defaultValue.rank = ${defaultNDims} must be less than ragged tensor input flatValues.rank = ${valuesNDims})`);
    for(let i = 0; i < Math.min(defaultNDims, valuesNDims - 1); ++i){
        const defaultDim = defaultValueShape[i];
        const valueDim = valueShape[i + 1];
        if (defaultDim >= 0 && valueDim >= 0 && defaultDim !== 1 && defaultDim !== valueDim) throw new Error(`defaultValue.shape=${defaultValueShape}, and ragged tensor input flatValues.shape=${valueShape} are incompatible: defaultValue.shape[${i - defaultValueShape.length}] = ${defaultDim} but ragged tensor input.flatValues.shape[${i - defaultValueShape.length}] = ${valueDim}`);
    }
}

});

parcelRegister("btH58", function(module, exports) {

$parcel$export(module.exports, "PARALLELIZE_THRESHOLD", () => $85b3d2509981513c$export$ee3544492fe530f6);
$parcel$export(module.exports, "computeOptimalWindowSize", () => $85b3d2509981513c$export$ee795473f4c8fb04);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Inputs of size above this threshold will be parallelized by calling multiple
 * shader programs.
 */ 
var $4tCOB = parcelRequire("4tCOB");
const $85b3d2509981513c$export$ee3544492fe530f6 = 30;
function $85b3d2509981513c$export$ee795473f4c8fb04(inSize) {
    if (inSize <= $85b3d2509981513c$export$ee3544492fe530f6) return inSize;
    return (0, $4tCOB.nearestDivisor)(inSize, Math.floor(Math.sqrt(inSize)));
}

});

parcelRegister("lxWyc", function(module, exports) {

$parcel$export(module.exports, "getImageCenter", () => $fafa18f48656ce59$export$3c8762d0dab347aa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Returns the image center in pixels.
function $fafa18f48656ce59$export$3c8762d0dab347aa(center, imageHeight, imageWidth) {
    const centerX = imageWidth * (typeof center === 'number' ? center : center[0]);
    const centerY = imageHeight * (typeof center === 'number' ? center : center[1]);
    return [
        centerX,
        centerY
    ];
}

});

parcelRegister("7nCsT", function(module, exports) {

$parcel$export(module.exports, "getReshaped", () => $55f884bbb10f52ec$export$4a6fd6a82dc667e2);
$parcel$export(module.exports, "getPermuted", () => $55f884bbb10f52ec$export$4def7dccf4cfc2e9);
$parcel$export(module.exports, "getReshapedPermuted", () => $55f884bbb10f52ec$export$2435a8b57f99e080);
$parcel$export(module.exports, "getSliceBeginCoords", () => $55f884bbb10f52ec$export$b9a01540baa98f86);
$parcel$export(module.exports, "getSliceSize", () => $55f884bbb10f52ec$export$2457416ec9e0c8d3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Gets the new shape of the input Tensor after it's been reshaped
 * to:
 * [blockShape[0], ..., blockShape[M-1], batch / prod(blockShape),
 * inputShape[1], ..., inputShape[N-1]]
 *
 * See step 1: https://www.tensorflow.org/api_docs/python/tf/batch_to_space_nd
 */ function $55f884bbb10f52ec$export$4a6fd6a82dc667e2(inputShape, blockShape, prod, batchToSpace = true) {
    let reshaped = [];
    if (batchToSpace) {
        reshaped = reshaped.concat(blockShape.slice(0));
        reshaped.push(inputShape[0] / prod);
        reshaped = reshaped.concat(inputShape.slice(1));
    } else {
        reshaped = reshaped.concat(inputShape[0]);
        const spatialLength = blockShape.length;
        for(let i = 0; i < spatialLength; ++i)reshaped = reshaped.concat([
            inputShape[i + 1] / blockShape[i],
            blockShape[i]
        ]);
        reshaped = reshaped.concat(inputShape.slice(spatialLength + 1));
    }
    return reshaped;
}
function $55f884bbb10f52ec$export$4def7dccf4cfc2e9(reshapedRank, blockShapeRank, batchToSpace = true) {
    const permuted = [];
    if (batchToSpace) {
        permuted.push(blockShapeRank);
        for(let i = blockShapeRank + 1; i < reshapedRank; ++i)if (i <= 2 * blockShapeRank) {
            permuted.push(i);
            permuted.push(i - (blockShapeRank + 1));
        } else permuted.push(i);
    } else {
        const permutedBeforeBatch = [];
        const permutedAfterBatch = [];
        for(let i = 1; i < reshapedRank; ++i)if (i >= blockShapeRank * 2 + 1 || i % 2 === 1) permutedAfterBatch.push(i);
        else permutedBeforeBatch.push(i);
        permuted.push(...permutedBeforeBatch);
        permuted.push(0);
        permuted.push(...permutedAfterBatch);
    }
    return permuted;
}
function $55f884bbb10f52ec$export$2435a8b57f99e080(inputShape, blockShape, prod, batchToSpace = true) {
    const reshapedPermuted = [];
    if (batchToSpace) reshapedPermuted.push(inputShape[0] / prod);
    else reshapedPermuted.push(inputShape[0] * prod);
    for(let i = 1; i < inputShape.length; ++i)if (i <= blockShape.length) {
        if (batchToSpace) reshapedPermuted.push(blockShape[i - 1] * inputShape[i]);
        else reshapedPermuted.push(inputShape[i] / blockShape[i - 1]);
    } else reshapedPermuted.push(inputShape[i]);
    return reshapedPermuted;
}
function $55f884bbb10f52ec$export$b9a01540baa98f86(crops, blockShape) {
    const sliceBeginCoords = [
        0
    ];
    for(let i = 0; i < blockShape; ++i)sliceBeginCoords.push(crops[i][0]);
    return sliceBeginCoords;
}
function $55f884bbb10f52ec$export$2457416ec9e0c8d3(uncroppedShape, crops, blockShape) {
    const sliceSize = uncroppedShape.slice(0, 1);
    for(let i = 0; i < blockShape; ++i)sliceSize.push(uncroppedShape[i + 1] - crops[i][0] - crops[i][1]);
    return sliceSize;
}

});

parcelRegister("b8vU7", function(module, exports) {

$parcel$export(module.exports, "SELU_SCALEALPHA", () => $81b9308b94b93393$export$49dc487a025ce2d0);
$parcel$export(module.exports, "SELU_SCALE", () => $81b9308b94b93393$export$e6ebc294ea9ea7e7);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $81b9308b94b93393$export$49dc487a025ce2d0 = 1.7580993408473768599402175208123;
const $81b9308b94b93393$export$e6ebc294ea9ea7e7 = 1.0507009873554804934193349852946;

});

parcelRegister("eoONc", function(module, exports) {

$parcel$export(module.exports, "ERF_P", () => $a7bab4e7a5e30fc0$export$5588b9ca3e514e43);
$parcel$export(module.exports, "ERF_A1", () => $a7bab4e7a5e30fc0$export$2ac384940e9cdd31);
$parcel$export(module.exports, "ERF_A2", () => $a7bab4e7a5e30fc0$export$db2d4485da836713);
$parcel$export(module.exports, "ERF_A3", () => $a7bab4e7a5e30fc0$export$644ec7b31d43803f);
$parcel$export(module.exports, "ERF_A4", () => $a7bab4e7a5e30fc0$export$904f8b3bbafadf78);
$parcel$export(module.exports, "ERF_A5", () => $a7bab4e7a5e30fc0$export$e40fe2da7629526);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $a7bab4e7a5e30fc0$export$5588b9ca3e514e43 = 0.3275911;
const $a7bab4e7a5e30fc0$export$2ac384940e9cdd31 = 0.254829592;
const $a7bab4e7a5e30fc0$export$db2d4485da836713 = -0.284496736;
const $a7bab4e7a5e30fc0$export$644ec7b31d43803f = 1.421413741;
const $a7bab4e7a5e30fc0$export$904f8b3bbafadf78 = -1.453152027;
const $a7bab4e7a5e30fc0$export$e40fe2da7629526 = 1.061405429;

});

parcelRegister("9oI2K", function(module, exports) {

$parcel$export(module.exports, "mergeRealAndImagArrays", () => $6d78850e5bed1f9d$export$e54cb13fcd32a531);
$parcel$export(module.exports, "splitRealAndImagArrays", () => $6d78850e5bed1f9d$export$fa0ac0984ed1da1c);
$parcel$export(module.exports, "complexWithEvenIndex", () => $6d78850e5bed1f9d$export$270b4351d25667e0);
$parcel$export(module.exports, "complexWithOddIndex", () => $6d78850e5bed1f9d$export$36193f08102303b4);
$parcel$export(module.exports, "getComplexWithIndex", () => $6d78850e5bed1f9d$export$628d071452d50aaf);
$parcel$export(module.exports, "assignToTypedArray", () => $6d78850e5bed1f9d$export$b7f57c25a82b9fba);
$parcel$export(module.exports, "exponents", () => $6d78850e5bed1f9d$export$7d98ee6b5f9e9f08);
$parcel$export(module.exports, "exponent", () => $6d78850e5bed1f9d$export$abde88043842a778);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Merges real and imaginary Float32Arrays into a single complex Float32Array.
 *
 * The memory layout is interleaved as follows:
 * real: [r0, r1, r2]
 * imag: [i0, i1, i2]
 * complex: [r0, i0, r1, i1, r2, i2]
 *
 * This is the inverse of splitRealAndImagArrays.
 *
 * @param real The real values of the complex tensor values.
 * @param imag The imag values of the complex tensor values.
 * @returns A complex tensor as a Float32Array with merged values.
 */ function $6d78850e5bed1f9d$export$e54cb13fcd32a531(real, imag) {
    if (real.length !== imag.length) throw new Error(`Cannot merge real and imag arrays of different lengths. real:` + `${real.length}, imag: ${imag.length}.`);
    const result = new Float32Array(real.length * 2);
    for(let i = 0; i < result.length; i += 2){
        result[i] = real[i / 2];
        result[i + 1] = imag[i / 2];
    }
    return result;
}
function $6d78850e5bed1f9d$export$fa0ac0984ed1da1c(complex) {
    const real = new Float32Array(complex.length / 2);
    const imag = new Float32Array(complex.length / 2);
    for(let i = 0; i < complex.length; i += 2){
        real[i / 2] = complex[i];
        imag[i / 2] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $6d78850e5bed1f9d$export$270b4351d25667e0(complex) {
    const len = Math.ceil(complex.length / 4);
    const real = new Float32Array(len);
    const imag = new Float32Array(len);
    for(let i = 0; i < complex.length; i += 4){
        real[Math.floor(i / 4)] = complex[i];
        imag[Math.floor(i / 4)] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $6d78850e5bed1f9d$export$36193f08102303b4(complex) {
    const len = Math.floor(complex.length / 4);
    const real = new Float32Array(len);
    const imag = new Float32Array(len);
    for(let i = 2; i < complex.length; i += 4){
        real[Math.floor(i / 4)] = complex[i];
        imag[Math.floor(i / 4)] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $6d78850e5bed1f9d$export$628d071452d50aaf(complex, index) {
    const real = complex[index * 2];
    const imag = complex[index * 2 + 1];
    return {
        real: real,
        imag: imag
    };
}
function $6d78850e5bed1f9d$export$b7f57c25a82b9fba(data, real, imag, index) {
    data[index * 2] = real;
    data[index * 2 + 1] = imag;
}
function $6d78850e5bed1f9d$export$7d98ee6b5f9e9f08(n, inverse) {
    const real = new Float32Array(n / 2);
    const imag = new Float32Array(n / 2);
    for(let i = 0; i < Math.ceil(n / 2); i++){
        const x = (inverse ? 2 : -2) * Math.PI * (i / n);
        real[i] = Math.cos(x);
        imag[i] = Math.sin(x);
    }
    return {
        real: real,
        imag: imag
    };
}
function $6d78850e5bed1f9d$export$abde88043842a778(k, n, inverse) {
    const x = (inverse ? 2 : -2) * Math.PI * (k / n);
    const real = Math.cos(x);
    const imag = Math.sin(x);
    return {
        real: real,
        imag: imag
    };
}

});

parcelRegister("jULKE", function(module, exports) {

$parcel$export(module.exports, "decodeEinsumEquation", () => $e7f849b4f29c3f39$export$2f615958577142db);
$parcel$export(module.exports, "getEinsumPermutation", () => $e7f849b4f29c3f39$export$ce55bd5175fdcdbf);
$parcel$export(module.exports, "checkEinsumDimSizes", () => $e7f849b4f29c3f39$export$40ac7c38e2986bbe);
$parcel$export(module.exports, "getEinsumComputePath", () => $e7f849b4f29c3f39$export$3f6835c0d48b762d);
$parcel$export(module.exports, "isIdentityPermutation", () => $e7f849b4f29c3f39$export$6a8a32f5fc3d978e);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
const $e7f849b4f29c3f39$var$ARROW = '->';
const $e7f849b4f29c3f39$var$ARROW_REGEX = /->/g;
const $e7f849b4f29c3f39$var$COMMA = ',';
const $e7f849b4f29c3f39$var$ELLIPSIS = '...';
function $e7f849b4f29c3f39$export$2f615958577142db(equation, numTensors) {
    equation = equation.replace(/\s/g, ''); // Remove witespace in equation.
    const numArrows = (equation.length - equation.replace($e7f849b4f29c3f39$var$ARROW_REGEX, '').length) / $e7f849b4f29c3f39$var$ARROW.length;
    if (numArrows < 1) throw new Error('Equations without an arrow are not supported.');
    else if (numArrows > 1) throw new Error(`Equation must contain exactly one arrow ("${$e7f849b4f29c3f39$var$ARROW}").`);
    const [inputString, outputString] = equation.split($e7f849b4f29c3f39$var$ARROW);
    (0, $4tCOB.assert)(inputString.indexOf($e7f849b4f29c3f39$var$ELLIPSIS) === -1, ()=>`The ellipsis notation ("${$e7f849b4f29c3f39$var$ELLIPSIS}") is not supported yet.`);
    const inputTerms = inputString.split($e7f849b4f29c3f39$var$COMMA);
    const numInputs = inputTerms.length;
    if (numTensors !== numInputs) throw new Error(`Expected ${numInputs} input tensors, received ${numTensors}`);
    if (numInputs > 2) throw new Error('Support for more than 2 input tensors is not implemented yet.');
    const allDims = [];
    for(let i = 0; i < outputString.length; ++i){
        const dimName = outputString[i];
        if (!inputTerms.some((inputTerm)=>inputTerm.indexOf(dimName) !== -1)) throw new Error(`Output subscripts contain the label ${dimName} ` + `not present in the input subscripts.`);
        if (allDims.indexOf(dimName) === -1) allDims.push(dimName);
    }
    for(let i = 0; i < inputString.length; ++i){
        const dimName = inputString[i];
        if (allDims.indexOf(dimName) === -1 && dimName !== $e7f849b4f29c3f39$var$COMMA) allDims.push(dimName);
    }
    const idDims = new Array(inputTerms.length);
    for(let i = 0; i < numInputs; ++i){
        if (new Set(inputTerms[i].split('')).size !== inputTerms[i].length) throw new Error(`Found duplicate axes in input component ${inputTerms[i]}. ` + `Support for duplicate axes in input is not implemented yet.`);
        idDims[i] = [];
        for(let j = 0; j < inputTerms[i].length; ++j)idDims[i].push(allDims.indexOf(inputTerms[i][j]));
    }
    const numDims = allDims.length; // Number of unique dimensions.
    const numOutDims = outputString.length; // Number of output dimensions.
    const summedDims = []; // Dimensions being summed over.
    for(let i = numOutDims; i < numDims; ++i)summedDims.push(i);
    return {
        allDims: allDims,
        summedDims: summedDims,
        idDims: idDims
    };
}
function $e7f849b4f29c3f39$export$ce55bd5175fdcdbf(nDims, idDims) {
    let permutationIndices = new Array(nDims);
    permutationIndices.fill(-1);
    for(let i = 0; i < idDims.length; ++i)permutationIndices[idDims[i]] = i;
    const expandDims = [];
    for(let i = 0; i < nDims; ++i)if (permutationIndices[i] === -1) expandDims.push(i);
    permutationIndices = permutationIndices.filter((d)=>d !== -1);
    return {
        permutationIndices: permutationIndices,
        expandDims: expandDims
    };
}
function $e7f849b4f29c3f39$export$40ac7c38e2986bbe(nDims, idDims, tensors) {
    const dimSizes = new Array(nDims);
    for(let i = 0; i < tensors.length; ++i){
        const shape = tensors[i].shape;
        for(let j = 0; j < idDims[i].length; ++j)if (dimSizes[idDims[i][j]] === undefined) dimSizes[idDims[i][j]] = shape[j];
        else (0, $4tCOB.assert)(dimSizes[idDims[i][j]] === shape[j], ()=>`Expected dimension ${dimSizes[idDims[i][j]]} at axis ${j} ` + `of input shaped ${JSON.stringify(shape)}, ` + `but got dimension ${shape[j]}`);
    }
}
function $e7f849b4f29c3f39$export$3f6835c0d48b762d(summedDims, idDims) {
    const path = summedDims;
    const steps = [];
    let nSteps = 0;
    if (summedDims.length === 0) // Einsum that involes no summing: e.g., transpose and outer product.
    path.push(-1);
    nSteps = summedDims.length + 1;
    for(let i = 0; i < nSteps; ++i)steps.push([]);
    const computedTermIndices = [];
    for(let i = 0; i < path.length; ++i){
        const summedDim = path[i];
        const termIndices = $e7f849b4f29c3f39$var$findTermsWithDim(idDims, summedDim);
        for (const termIndex of termIndices)if (computedTermIndices.indexOf(termIndex) === -1) {
            steps[i].push(termIndex);
            computedTermIndices.push(termIndex);
        }
    }
    return {
        path: path,
        steps: steps
    };
}
function $e7f849b4f29c3f39$export$6a8a32f5fc3d978e(perm) {
    return perm.every((dim, index)=>dim === index);
}
function $e7f849b4f29c3f39$var$findTermsWithDim(idDims, dim) {
    const termIndices = [];
    for(let i = 0; i < idDims.length; ++i)if (idDims[i].length === 0 || idDims[i].indexOf(dim) !== -1 || dim === -1) termIndices.push(i);
    return termIndices;
}

});

parcelRegister("fHUPl", function(module, exports) {

$parcel$export(module.exports, "prepareSplitSize", () => $b6f6f3db0765c9d7$export$b45a3b30df9d4b49);

var $4tCOB = parcelRequire("4tCOB");
function $b6f6f3db0765c9d7$export$b45a3b30df9d4b49(x, numOrSizeSplits, axis = 0) {
    let splitSizes = [];
    if (typeof numOrSizeSplits === 'number') {
        (0, $4tCOB.assert)(x.shape[axis] % numOrSizeSplits === 0, ()=>'Number of splits must evenly divide the axis.');
        splitSizes = new Array(numOrSizeSplits).fill(x.shape[axis] / numOrSizeSplits);
    } else {
        const numOfNegs = numOrSizeSplits.reduce((count, value)=>{
            if (value === -1) count += 1;
            return count;
        }, 0);
        (0, $4tCOB.assert)(numOfNegs <= 1, ()=>'There should be only one negative value in split array.');
        const negIndex = numOrSizeSplits.indexOf(-1);
        // Allow the number of split array to be -1, which indicates the rest
        // of dimension is allocated to that split.
        if (negIndex !== -1) {
            const total = numOrSizeSplits.reduce((a, b)=>b > 0 ? a + b : a);
            numOrSizeSplits[negIndex] = x.shape[axis] - total;
        }
        (0, $4tCOB.assert)(x.shape[axis] === numOrSizeSplits.reduce((a, b)=>a + b), ()=>'The sum of sizes must match the size of the axis dimension.');
        splitSizes = numOrSizeSplits;
    }
    return splitSizes;
}

});

parcelRegister("fVXg8", function(module, exports) {

$parcel$export(module.exports, "getSparseFillEmptyRowsIndicesDenseShapeMismatch", () => $b99a258405a218c9$export$afc2f2dec50723b1);
$parcel$export(module.exports, "getSparseFillEmptyRowsNegativeIndexErrorMessage", () => $b99a258405a218c9$export$69038529bd45dbce);
$parcel$export(module.exports, "getSparseFillEmptyRowsOutOfRangeIndexErrorMessage", () => $b99a258405a218c9$export$4179b115ac384c01);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Generates sparse fill empty rows indices, dense shape mismatch error message.
 *
 * @param indicesLength The first dimension of indices.
 */ function $b99a258405a218c9$export$afc2f2dec50723b1(indicesLength) {
    return `Received SparseTensor with denseShape[0] = 0 but
  indices.shape[0] = ${indicesLength}`;
}
function $b99a258405a218c9$export$69038529bd45dbce(index, value) {
    return `indices(${index}, 0) is invalid: ${value} < 0`;
}
function $b99a258405a218c9$export$4179b115ac384c01(index, value, limit) {
    return `indices(${index}, 0) is invalid: ${value} >= ${limit}`;
}

});

parcelRegister("9Hizw", function(module, exports) {

$parcel$export(module.exports, "getSparseReshapeMultipleNegativeOneOutputDimErrorMessage", () => $70f68938521321b9$export$22b04105649d1e3d);
$parcel$export(module.exports, "getSparseReshapeNegativeOutputDimErrorMessage", () => $70f68938521321b9$export$3350ee0ca4641eae);
$parcel$export(module.exports, "getSparseReshapeEmptyTensorZeroOutputDimErrorMessage", () => $70f68938521321b9$export$632a7731cfb4dc4b);
$parcel$export(module.exports, "getSparseReshapeInputOutputMultipleErrorMessage", () => $70f68938521321b9$export$6996eb40ec18f24);
$parcel$export(module.exports, "getSparseReshapeInputOutputMismatchErrorMessage", () => $70f68938521321b9$export$7c74c1672e7ca2d1);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");
function $70f68938521321b9$export$22b04105649d1e3d(dim1, dim2) {
    return `only one output dimension may be -1, not both ${dim1} and ${dim2}`;
}
function $70f68938521321b9$export$3350ee0ca4641eae(dim, value) {
    return `size ${dim} must be non-negative, not ${value}`;
}
function $70f68938521321b9$export$632a7731cfb4dc4b() {
    return "reshape cannot infer the missing input size for an empty tensor unless all specified input sizes are non-zero";
}
function $70f68938521321b9$export$6996eb40ec18f24(inputShape, outputShape) {
    const inputSize = (0, $4tCOB.sizeFromShape)(inputShape);
    const outputSize = (0, $4tCOB.sizeFromShape)(outputShape);
    return `Input to reshape is a SparseTensor with ${inputSize}
  dense values, but the requested shape requires a multiple of ${outputSize}. inputShape=${inputShape} outputShape= ${outputShape}`;
}
function $70f68938521321b9$export$7c74c1672e7ca2d1(inputShape, outputShape) {
    const inputSize = (0, $4tCOB.sizeFromShape)(inputShape);
    const outputSize = (0, $4tCOB.sizeFromShape)(outputShape);
    return `Input to reshape is a tensor with ${inputSize} dense values, but the requested shape has ${outputSize}. inputShape=${inputShape} outputShape=${outputShape}`;
}

});

parcelRegister("g7I6u", function(module, exports) {

$parcel$export(module.exports, "getSparseSegmentReductionNegativeSegmentIdsErrorMessage", () => $bbcf82dd99e04253$export$cb1b83ffdf66736);
$parcel$export(module.exports, "getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage", () => $bbcf82dd99e04253$export$6f5af72ace1661e1);
$parcel$export(module.exports, "getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage", () => $bbcf82dd99e04253$export$bdc282d2ae15e823);
$parcel$export(module.exports, "getSparseSegmentReductionIndicesOutOfRangeErrorMessage", () => $bbcf82dd99e04253$export$c470f477911f1cb7);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Generates sparse segment reduction negative segment ids error message.
 *
 */ function $bbcf82dd99e04253$export$cb1b83ffdf66736() {
    return `segment ids must be >= 0`;
}
function $bbcf82dd99e04253$export$6f5af72ace1661e1() {
    return `segment ids are not increasing`;
}
function $bbcf82dd99e04253$export$bdc282d2ae15e823(segmentId, outputRows) {
    return `Segment id ${segmentId} out of range [0, ${outputRows}), possibly because segmentIds input is not sorted.`;
}
function $bbcf82dd99e04253$export$c470f477911f1cb7(index, indexValue, inputRows) {
    return `Bad: indices[${index}] == ${indexValue} out of range [0, ${inputRows})`;
}

});

parcelRegister("9UBZ0", function(module, exports) {

$parcel$export(module.exports, "segOpComputeOptimalWindowSize", () => $7376ce9fccec19f9$export$6ef0c7b128709ff);
$parcel$export(module.exports, "computeOutShape", () => $7376ce9fccec19f9$export$22fa6b3b1305508e);
$parcel$export(module.exports, "collectGatherOpShapeInfo", () => $7376ce9fccec19f9$export$fa9ad97afacf8191);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4tCOB = parcelRequire("4tCOB");

var $btH58 = parcelRequire("btH58");
function $7376ce9fccec19f9$export$6ef0c7b128709ff(inSize, numSegments) {
    let done = false;
    let res;
    if (inSize <= (0, $btH58.PARALLELIZE_THRESHOLD)) {
        res = inSize;
        done = true;
    } else res = (0, $4tCOB.nearestDivisor)(inSize, Math.floor(Math.sqrt(inSize)));
    while(!done)if (res > numSegments || res === inSize) done = true;
    else res = (0, $4tCOB.nearestDivisor)(inSize, res + 1);
    return res;
}
function $7376ce9fccec19f9$export$22fa6b3b1305508e(aShape, axis, numSegments) {
    const outShape = [];
    const rank = aShape.length;
    for(let dim = 0; dim < rank; dim++)if (dim !== axis) outShape.push(aShape[dim]);
    else outShape.push(numSegments);
    return outShape;
}
function $7376ce9fccec19f9$export$fa9ad97afacf8191(x, indices, axis, batchDims) {
    const indicesRank = indices.shape.length;
    const xRank = x.shape.length;
    if (batchDims !== 0) {
        if (batchDims < -indicesRank || batchDims > indicesRank) throw new Error(`Expect batchDims in the range of [-${indicesRank}, ${indicesRank}], but got ${batchDims}`);
    }
    if (batchDims < 0) batchDims += indicesRank;
    if (batchDims > xRank) throw new Error(`batchDims (${batchDims}) must be less than rank(x) (
    ${xRank}).`);
    if (axis < batchDims) throw new Error(`batchDims (${batchDims}) must be less than or equal to axis (${axis}).`);
    for(let i = 0; i < batchDims; ++i){
        if (x.shape[i] !== indices.shape[i]) throw new Error(`x.shape[${i}]: ${x.shape[i]} should be equal to indices.shape[${i}]: ${indices.shape[i]}.`);
    }
    const dimSize = x.shape[axis];
    const outputShape = [];
    let batchSize = 1;
    let outerSize = 1;
    let sliceSize = 1;
    for(let i = 0; i < batchDims; ++i){
        outputShape.push(x.shape[i]);
        batchSize *= x.shape[i];
    }
    for(let i = batchDims; i < axis; i++){
        outputShape.push(x.shape[i]);
        outerSize *= x.shape[i];
    }
    for(let i = batchDims; i < indicesRank; i++)outputShape.push(indices.shape[i]);
    for(let i = axis + 1; i < xRank; i++){
        outputShape.push(x.shape[i]);
        sliceSize *= x.shape[i];
    }
    return {
        batchSize: batchSize,
        sliceSize: sliceSize,
        outerSize: outerSize,
        dimSize: dimSize,
        outputShape: outputShape
    };
}

});


parcelRegister("ff2I2", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV3Impl", () => (parcelRequire("bCB0s")).nonMaxSuppressionV3Impl);
$parcel$export(module.exports, "nonMaxSuppressionV4Impl", () => (parcelRequire("bCB0s")).nonMaxSuppressionV4Impl);
$parcel$export(module.exports, "nonMaxSuppressionV5Impl", () => (parcelRequire("bCB0s")).nonMaxSuppressionV5Impl);
$parcel$export(module.exports, "whereImpl", () => (parcelRequire("e0fHM")).whereImpl);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bCB0s = parcelRequire("bCB0s");

var $e0fHM = parcelRequire("e0fHM");

});



parcelRegister("9RnzO", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7kJu7 = parcelRequire("7kJu7");

var $2FRXS = parcelRequire("2FRXS");

var $9nfUF = parcelRequire("9nfUF");

var $ujYFM = parcelRequire("ujYFM");

var $aUcSU = parcelRequire("aUcSU");

var $fivJz = parcelRequire("fivJz");

var $1zh9I = parcelRequire("1zh9I");

var $fVPpW = parcelRequire("fVPpW");

var $7HhkD = parcelRequire("7HhkD");

var $1tRRk = parcelRequire("1tRRk");

var $ficBQ = parcelRequire("ficBQ");

var $lFrfV = parcelRequire("lFrfV");

var $iOP4U = parcelRequire("iOP4U");

var $h8J6q = parcelRequire("h8J6q");

var $acqOQ = parcelRequire("acqOQ");

var $71le5 = parcelRequire("71le5");

var $cjdPN = parcelRequire("cjdPN");

var $3FrLB = parcelRequire("3FrLB");

var $U9hkL = parcelRequire("U9hkL");

var $3hwpO = parcelRequire("3hwpO");

var $67KUb = parcelRequire("67KUb");

var $7TOE1 = parcelRequire("7TOE1");

var $3Ogu4 = parcelRequire("3Ogu4");

var $1Iv1U = parcelRequire("1Iv1U");

var $7UF0S = parcelRequire("7UF0S");

var $fapsP = parcelRequire("fapsP");

var $1CypV = parcelRequire("1CypV");

var $d5y2C = parcelRequire("d5y2C");

var $fJx29 = parcelRequire("fJx29");

var $37ISE = parcelRequire("37ISE");

var $4Lq7I = parcelRequire("4Lq7I");

var $gsnxJ = parcelRequire("gsnxJ");

var $fxHNI = parcelRequire("fxHNI");

var $9V7I1 = parcelRequire("9V7I1");

var $eVc1W = parcelRequire("eVc1W");

var $b2fpc = parcelRequire("b2fpc");

var $elIi3 = parcelRequire("elIi3");

var $e6use = parcelRequire("e6use");

var $2bGbC = parcelRequire("2bGbC");

var $hQ4ey = parcelRequire("hQ4ey");

var $j9gsC = parcelRequire("j9gsC");

var $7wXkF = parcelRequire("7wXkF");

var $2T4lz = parcelRequire("2T4lz");

var $287SG = parcelRequire("287SG");

var $3gcvm = parcelRequire("3gcvm");

var $cUNLd = parcelRequire("cUNLd");

var $7NOl8 = parcelRequire("7NOl8");

var $izGd7 = parcelRequire("izGd7");

var $lhali = parcelRequire("lhali");

var $iDkbt = parcelRequire("iDkbt");

var $3Vl8D = parcelRequire("3Vl8D");

var $4zVGk = parcelRequire("4zVGk");

var $if93r = parcelRequire("if93r");

var $iIcIn = parcelRequire("iIcIn");

var $eXIAD = parcelRequire("eXIAD");

var $69pTF = parcelRequire("69pTF");

var $bZeqS = parcelRequire("bZeqS");

var $1evEY = parcelRequire("1evEY");

var $k2OB8 = parcelRequire("k2OB8");

var $aV12x = parcelRequire("aV12x");

var $2Tx48 = parcelRequire("2Tx48");

var $eXfzX = parcelRequire("eXfzX");

var $8g7Fg = parcelRequire("8g7Fg");

var $lYpYr = parcelRequire("lYpYr");

var $1AfxD = parcelRequire("1AfxD");

var $3O3Uj = parcelRequire("3O3Uj");

var $6YeNK = parcelRequire("6YeNK");

var $MylSu = parcelRequire("MylSu");

var $afXhY = parcelRequire("afXhY");

var $5VvQZ = parcelRequire("5VvQZ");

var $fkjLo = parcelRequire("fkjLo");

var $lGH4O = parcelRequire("lGH4O");

var $iqDno = parcelRequire("iqDno");

var $6BSSD = parcelRequire("6BSSD");

var $bzPRl = parcelRequire("bzPRl");

var $2ujxj = parcelRequire("2ujxj");

var $lB3rm = parcelRequire("lB3rm");

var $3ovfU = parcelRequire("3ovfU");

var $g5UmC = parcelRequire("g5UmC");

var $aqPPP = parcelRequire("aqPPP");

var $7fedq = parcelRequire("7fedq");

var $dq6Hw = parcelRequire("dq6Hw");

var $8kl7J = parcelRequire("8kl7J");

var $dyO2z = parcelRequire("dyO2z");

var $14d0o = parcelRequire("14d0o");

var $d1aLH = parcelRequire("d1aLH");

var $fLsDn = parcelRequire("fLsDn");

var $k4vBa = parcelRequire("k4vBa");

var $iUeuJ = parcelRequire("iUeuJ");

var $5P3CM = parcelRequire("5P3CM");

var $1eEg3 = parcelRequire("1eEg3");

var $BY2Tn = parcelRequire("BY2Tn");

var $gLg7J = parcelRequire("gLg7J");

var $9SGk3 = parcelRequire("9SGk3");

var $7O3L6 = parcelRequire("7O3L6");

var $1nDjz = parcelRequire("1nDjz");

var $cd7YP = parcelRequire("cd7YP");

var $eyFzE = parcelRequire("eyFzE");

var $wHeAU = parcelRequire("wHeAU");

var $5cIWS = parcelRequire("5cIWS");

var $8qP4i = parcelRequire("8qP4i");

var $kaJSw = parcelRequire("kaJSw");
// Export all kernel configs here so that the package can auto register them
const $72db5a18a414d744$var$gradConfigs = [
    (0, $7kJu7.absGradConfig),
    (0, $2FRXS.acosGradConfig),
    (0, $9nfUF.acoshGradConfig),
    (0, $ujYFM.addGradConfig),
    (0, $aUcSU.addNGradConfig),
    (0, $fivJz.argMaxGradConfig),
    (0, $1zh9I.argMinGradConfig),
    (0, $fVPpW.asinGradConfig),
    (0, $7HhkD.asinhGradConfig),
    (0, $1tRRk.atan2GradConfig),
    (0, $ficBQ.atanGradConfig),
    (0, $lFrfV.atanhGradConfig),
    (0, $iOP4U.avgPool3DGradConfig),
    (0, $h8J6q.avgPoolGradConfig),
    (0, $acqOQ.batchMatMulGradConfig),
    (0, $71le5.batchToSpaceNDGradConfig),
    (0, $cjdPN.broadcastToGradConfig),
    (0, $3FrLB.castGradConfig),
    (0, $U9hkL.ceilGradConfig),
    (0, $3hwpO.clipByValueGradConfig),
    (0, $67KUb.complexAbsGradConfig),
    (0, $7TOE1.concatGradConfig),
    (0, $1Iv1U.conv2DBackpropInputGradConfig),
    (0, $3Ogu4.conv2DGradConfig),
    (0, $7UF0S.conv3DGradConfig),
    (0, $fapsP.cosGradConfig),
    (0, $1CypV.coshGradConfig),
    (0, $d5y2C.cumsumGradConfig),
    (0, $fJx29.depthwiseConv2dNativeGradConfig),
    (0, $37ISE.dilation2dGradConfig),
    (0, $MylSu.divGradConfig),
    (0, $4Lq7I.eluGradConfig),
    (0, $gsnxJ.erfGradConfig),
    (0, $fxHNI.expGradConfig),
    (0, $9V7I1.expandDimsGradConfig),
    (0, $eVc1W.expm1GradConfig),
    (0, $elIi3.floorDivGradConfig),
    (0, $b2fpc.floorGradConfig),
    (0, $e6use.fusedBatchNormGradConfig),
    (0, $2bGbC.gatherGradConfig),
    (0, $hQ4ey.greaterEqualGradConfig),
    (0, $j9gsC.identityGradConfig),
    (0, $7wXkF.isFiniteGradConfig),
    (0, $2T4lz.isInfGradConfig),
    (0, $287SG.isNanGradConfig),
    (0, $3gcvm.leakyReluGradConfig),
    (0, $cUNLd.log1pGradConfig),
    (0, $7NOl8.logGradConfig),
    (0, $izGd7.logSoftmaxGradConfig),
    (0, $lhali.lrnGradConfig),
    (0, $iDkbt.maxGradConfig),
    (0, $iDkbt.maxGradConfig),
    (0, $3Vl8D.maximumGradConfig),
    (0, $4zVGk.maxPool3DGradConfig),
    (0, $if93r.maxPoolGradConfig),
    (0, $iIcIn.meanGradConfig),
    (0, $eXIAD.minGradConfig),
    (0, $69pTF.minimumGradConfig),
    (0, $bZeqS.mirrorPadGradConfig),
    (0, $1evEY.modGradConfig),
    (0, $k2OB8.multiplyGradConfig),
    (0, $aV12x.negGradConfig),
    (0, $2Tx48.oneHotGradConfig),
    (0, $eXfzX.onesLikeGradConfig),
    (0, $8g7Fg.packGradConfig),
    (0, $lYpYr.padV2GradConfig),
    (0, $lYpYr.padV2GradConfig),
    (0, $1AfxD.powGradConfig),
    (0, $3O3Uj.preluGradConfig),
    (0, $6YeNK.prodGradConfig),
    (0, $afXhY.reciprocalGradConfig),
    (0, $5VvQZ.relu6GradConfig),
    (0, $fkjLo.reluGradConfig),
    (0, $lGH4O.reshapeGradConfig),
    (0, $iqDno.resizeBilinearGradConfig),
    (0, $6BSSD.resizeNearestNeighborGradConfig),
    (0, $bzPRl.reverseGradConfig),
    (0, $2ujxj.roundGradConfig),
    (0, $lB3rm.rsqrtGradConfig),
    (0, $3ovfU.selectGradConfig),
    (0, $g5UmC.seluGradConfig),
    (0, $aqPPP.sigmoidGradConfig),
    (0, $7fedq.signGradConfig),
    (0, $dq6Hw.sinGradConfig),
    (0, $8kl7J.sinhGradConfig),
    (0, $dyO2z.sliceGradConfig),
    (0, $14d0o.softmaxGradConfig),
    (0, $d1aLH.softplusGradConfig),
    (0, $fLsDn.spaceToBatchNDGradConfig),
    (0, $fLsDn.spaceToBatchNDGradConfig),
    (0, $k4vBa.splitVGradConfig),
    (0, $k4vBa.splitVGradConfig),
    (0, $iUeuJ.sqrtGradConfig),
    (0, $1eEg3.squaredDifferenceGradConfig),
    (0, $5P3CM.squareGradConfig),
    (0, $BY2Tn.stepGradConfig),
    (0, $gLg7J.subGradConfig),
    (0, $9SGk3.sumGradConfig),
    (0, $7O3L6.tanGradConfig),
    (0, $1nDjz.tanhGradConfig),
    (0, $cd7YP.tileGradConfig),
    (0, $eyFzE.transposeGradConfig),
    (0, $wHeAU.unpackGradConfig),
    (0, $5cIWS.unsortedSegmentSumGradConfig),
    (0, $8qP4i.zerosLikeGradConfig)
];
for (const gradientConfig of $72db5a18a414d744$var$gradConfigs)(0, $kaJSw.registerGradient)(gradientConfig);

});
parcelRegister("7kJu7", function(module, exports) {

$parcel$export(module.exports, "absGradConfig", () => $556daefe998bf34b$export$8311873a6069f3c6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $r7fN6 = parcelRequire("r7fN6");

var $4s2sX = parcelRequire("4s2sX");
const $556daefe998bf34b$export$8311873a6069f3c6 = {
    kernelName: (0, $dCP8m.Abs),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $r7fN6.mul)(dy, (0, $4s2sX.step)((0, $7qWZ5.cast)(x, 'float32'), -1))
        };
    }
};

});

parcelRegister("2FRXS", function(module, exports) {

$parcel$export(module.exports, "acosGradConfig", () => $1f29455ca126d0f3$export$25410aeefefd68e9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gjFWY = parcelRequire("gjFWY");

var $ifge7 = parcelRequire("ifge7");

var $j7yUF = parcelRequire("j7yUF");

var $lGdn1 = parcelRequire("lGdn1");

var $gqriC = parcelRequire("gqriC");

var $hkR0n = parcelRequire("hkR0n");
const $1f29455ca126d0f3$export$25410aeefefd68e9 = {
    kernelName: (0, $dCP8m.Acos),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>{
                const a = (0, $gqriC.square)((0, $7qWZ5.cast)(x, 'float32'));
                const b = (0, $lGdn1.sqrt)((0, $hkR0n.sub)((0, $j7yUF.scalar)(1), a));
                return (0, $ifge7.neg)((0, $gjFWY.div)(dy, b));
            }
        };
    }
};

});

parcelRegister("9nfUF", function(module, exports) {

$parcel$export(module.exports, "acoshGradConfig", () => $6d329b04751337d6$export$2ec6994297162d56);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gjFWY = parcelRequire("gjFWY");

var $lGdn1 = parcelRequire("lGdn1");

var $gqriC = parcelRequire("gqriC");

var $hkR0n = parcelRequire("hkR0n");
const $6d329b04751337d6$export$2ec6994297162d56 = {
    kernelName: (0, $dCP8m.Acosh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>{
                const a = (0, $lGdn1.sqrt)((0, $hkR0n.sub)((0, $gqriC.square)((0, $7qWZ5.cast)(x, 'float32')), 1));
                return (0, $gjFWY.div)(dy, a);
            }
        };
    }
};

});

parcelRegister("ujYFM", function(module, exports) {

$parcel$export(module.exports, "addGradConfig", () => $05b24c973f5ae2ae$export$817a98e7fbc08f69);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $eqTIO = parcelRequire("eqTIO");

var $eP0pM = parcelRequire("eP0pM");

var $fVwnn = parcelRequire("fVwnn");
const $05b24c973f5ae2ae$export$817a98e7fbc08f69 = {
    kernelName: (0, $dCP8m.Add),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = $eqTIO.assertAndGetBroadcastShape(a.shape, b.shape);
        const derA = ()=>{
            let res = dy;
            const reduceAxes = $eqTIO.getReductionAxes(a.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fVwnn.sum)(res, reduceAxes);
            return (0, $eP0pM.reshape)(res, a.shape);
        };
        const derB = ()=>{
            let res = dy;
            const reduceAxes = $eqTIO.getReductionAxes(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fVwnn.sum)(res, reduceAxes);
            return (0, $eP0pM.reshape)(res, b.shape);
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("aUcSU", function(module, exports) {

$parcel$export(module.exports, "addNGradConfig", () => $7f0920f3fbbf8672$export$9dda03cc9e4ef85c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");
const $7f0920f3fbbf8672$export$9dda03cc9e4ef85c = {
    kernelName: (0, $dCP8m.AddN),
    saveAllInputs: true,
    gradFunc: (dy, saved)=>{
        const ders = {};
        saved.forEach((_, i)=>{
            ders[i] = ()=>dy.clone();
        });
        return ders;
    }
};

});

parcelRegister("fivJz", function(module, exports) {

$parcel$export(module.exports, "argMaxGradConfig", () => $b231272a7fc72333$export$1d99392d6c64a702);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $b231272a7fc72333$export$1d99392d6c64a702 = {
    kernelName: (0, $dCP8m.ArgMax),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $k1Ozi.zerosLike)(x)
        };
    }
};

});

parcelRegister("1zh9I", function(module, exports) {

$parcel$export(module.exports, "argMinGradConfig", () => $12465e17422a8178$export$af12a090c1c7b332);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $12465e17422a8178$export$af12a090c1c7b332 = {
    kernelName: (0, $dCP8m.ArgMin),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $k1Ozi.zerosLike)(x)
        };
    }
};

});

parcelRegister("fVPpW", function(module, exports) {

$parcel$export(module.exports, "asinGradConfig", () => $b994104b8ed890b9$export$3f8c1d33cc0ed430);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gjFWY = parcelRequire("gjFWY");

var $j7yUF = parcelRequire("j7yUF");

var $lGdn1 = parcelRequire("lGdn1");

var $gqriC = parcelRequire("gqriC");

var $hkR0n = parcelRequire("hkR0n");
const $b994104b8ed890b9$export$3f8c1d33cc0ed430 = {
    kernelName: (0, $dCP8m.Asin),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $gjFWY.div)(dy, (0, $lGdn1.sqrt)((0, $hkR0n.sub)((0, $j7yUF.scalar)(1), (0, $gqriC.square)((0, $7qWZ5.cast)(x, 'float32')))))
        };
    }
};

});

parcelRegister("7HhkD", function(module, exports) {

$parcel$export(module.exports, "asinhGradConfig", () => $59a9fe49360a6dda$export$375f857062067cfd);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $1ZrG5 = parcelRequire("1ZrG5");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gjFWY = parcelRequire("gjFWY");

var $j7yUF = parcelRequire("j7yUF");

var $lGdn1 = parcelRequire("lGdn1");

var $gqriC = parcelRequire("gqriC");
const $59a9fe49360a6dda$export$375f857062067cfd = {
    kernelName: (0, $dCP8m.Asinh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>{
                const a = (0, $lGdn1.sqrt)((0, $1ZrG5.add)((0, $j7yUF.scalar)(1), (0, $gqriC.square)((0, $7qWZ5.cast)(x, 'float32'))));
                return (0, $gjFWY.div)(dy, a);
            }
        };
    }
};

});

parcelRegister("1tRRk", function(module, exports) {

$parcel$export(module.exports, "atan2GradConfig", () => $11424732f31fca79$export$cdf09477d70d7ce9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $1ZrG5 = parcelRequire("1ZrG5");

var $eqTIO = parcelRequire("eqTIO");

var $gjFWY = parcelRequire("gjFWY");

var $r7fN6 = parcelRequire("r7fN6");

var $ifge7 = parcelRequire("ifge7");

var $eP0pM = parcelRequire("eP0pM");

var $gqriC = parcelRequire("gqriC");

var $fVwnn = parcelRequire("fVwnn");
const $11424732f31fca79$export$cdf09477d70d7ce9 = {
    kernelName: (0, $dCP8m.Atan2),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = (0, $eqTIO.assertAndGetBroadcastShape)(a.shape, b.shape);
        const derA = ()=>{
            const d = (0, $1ZrG5.add)((0, $gqriC.square)(a), (0, $gqriC.square)(b));
            let res = (0, $r7fN6.mul)(dy, (0, $gjFWY.div)(b, d));
            const reduceAxes = (0, $eqTIO.getReductionAxes)(a.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fVwnn.sum)(res, reduceAxes);
            return (0, $eP0pM.reshape)(res, a.shape);
        };
        const derB = ()=>{
            const d = (0, $1ZrG5.add)((0, $gqriC.square)(a), (0, $gqriC.square)(b));
            let res = (0, $ifge7.neg)((0, $r7fN6.mul)(dy, (0, $gjFWY.div)(a, d)));
            const reduceAxes = (0, $eqTIO.getReductionAxes)(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fVwnn.sum)(res, reduceAxes);
            return (0, $eP0pM.reshape)(res, b.shape);
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("ficBQ", function(module, exports) {

$parcel$export(module.exports, "atanGradConfig", () => $b222516d950e5d5c$export$87ed559988dd857);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $1ZrG5 = parcelRequire("1ZrG5");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gjFWY = parcelRequire("gjFWY");

var $gqriC = parcelRequire("gqriC");
const $b222516d950e5d5c$export$87ed559988dd857 = {
    kernelName: (0, $dCP8m.Atan),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $gjFWY.div)(dy, (0, $1ZrG5.add)((0, $gqriC.square)((0, $7qWZ5.cast)(x, 'float32')), 1))
        };
    }
};

});

parcelRegister("lFrfV", function(module, exports) {

$parcel$export(module.exports, "atanhGradConfig", () => $fc6291c035eeee38$export$465efa1ebdf13d21);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gjFWY = parcelRequire("gjFWY");

var $gqriC = parcelRequire("gqriC");

var $hkR0n = parcelRequire("hkR0n");

var $j7yUF = parcelRequire("j7yUF");
const $fc6291c035eeee38$export$465efa1ebdf13d21 = {
    kernelName: (0, $dCP8m.Atanh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $gjFWY.div)(dy, (0, $hkR0n.sub)((0, $j7yUF.scalar)(1), (0, $gqriC.square)((0, $7qWZ5.cast)(x, 'float32'))))
        };
    }
};

});

parcelRegister("iOP4U", function(module, exports) {

$parcel$export(module.exports, "avgPool3DGradConfig", () => $db3484975a0dfba7$export$1eeb8780807d0508);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $ixkVU = parcelRequire("ixkVU");
const $db3484975a0dfba7$export$1eeb8780807d0508 = {
    kernelName: (0, $dCP8m.AvgPool3D),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
        return {
            x: ()=>(0, $ixkVU.avgPool3dGrad)(dy, x, filterSize, strides, pad, dimRoundingMode)
        };
    }
};

});
parcelRegister("ixkVU", function(module, exports) {

$parcel$export(module.exports, "avgPool3dGrad", () => $037b8a83b960e314$export$e8424a7f676b4e30);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $yLVwv = parcelRequire("yLVwv");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the backprop of a 3d avg pool.
 *
 * @param dy The dy error, of rank 5 of shape
 *     [batchSize, depth, height, width, channels].
 * assumed.
 * @param input The original input image, of rank 5 or rank4 of shape
 *     [batchSize, depth, height, width, channels].
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $037b8a83b960e314$var$avgPool3dGrad_(dy, input, filterSize, strides, pad, dimRoundingMode) {
    const $dy = (0, $5R1UY.convertToTensor)(dy, 'dy', 'avgPool3dGrad');
    const $input = (0, $5R1UY.convertToTensor)(input, 'input', 'avgPool3dGrad');
    let dy5D = $dy;
    let input5D = $input;
    let reshapedTo5D = false;
    if ($input.rank === 4) {
        reshapedTo5D = true;
        dy5D = (0, $eP0pM.reshape)($dy, [
            1,
            $dy.shape[0],
            $dy.shape[1],
            $dy.shape[2],
            $dy.shape[3]
        ]);
        input5D = (0, $eP0pM.reshape)($input, [
            1,
            $input.shape[0],
            $input.shape[1],
            $input.shape[2],
            $input.shape[3]
        ]);
    }
    $4tCOB.assert(dy5D.rank === 5, ()=>`Error in avgPool3dGrad: dy must be rank 5 but got rank ` + `${dy5D.rank}.`);
    $4tCOB.assert(input5D.rank === 5, ()=>`Error in avgPool3dGrad: input must be rank 5 but got rank ` + `${input5D.rank}.`);
    (0, $yLVwv.checkPadOnDimRoundingMode)('avgPool3dGrad', pad, dimRoundingMode);
    const inputs = {
        dy: dy5D,
        input: input5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.AvgPool3DGrad), inputs, attrs);
    if (reshapedTo5D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $037b8a83b960e314$export$e8424a7f676b4e30 = (0, $jKUCi.op)({
    avgPool3dGrad_: $037b8a83b960e314$var$avgPool3dGrad_
});

});


parcelRegister("h8J6q", function(module, exports) {

$parcel$export(module.exports, "avgPoolGradConfig", () => $c7a62b7c6e302021$export$ac3f8709351ab225);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $3kDju = parcelRequire("3kDju");
const $c7a62b7c6e302021$export$ac3f8709351ab225 = {
    kernelName: (0, $dCP8m.AvgPool),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
        return {
            x: ()=>(0, $3kDju.avgPoolGrad)(dy, x, filterSize, strides, pad)
        };
    }
};

});
parcelRegister("3kDju", function(module, exports) {

$parcel$export(module.exports, "avgPoolGrad", () => $26d1bc2f1375f699$export$2f098171d1c79aea);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the backprop of an 2D avg pool.
 *
 * @param dy The dy error, of rank 4 or rank 3 of shape
 *     [batchSize, height, width, channels]. If rank 3, batch of 1 is
 * assumed.
 * @param input The input image, of rank 4 or rank 3 of shape
 *     [batchSize, height, width, channels]. If rank 3, batch of 1 is
 * assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm used in the forward prop of the op.
 *     'same', 'valid', for more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *         https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 */ function $26d1bc2f1375f699$var$avgPoolGrad_(dy, input, filterSize, strides, pad) {
    const $dy = (0, $5R1UY.convertToTensor)(dy, 'dy', 'avgPoolGrad');
    const $input = (0, $5R1UY.convertToTensor)(input, 'input', 'avgPoolGrad');
    $4tCOB.assert($input.rank === $dy.rank, ()=>`Rank of input (${$input.rank}) does not match rank of dy (${$dy.rank})`);
    let input4D = $input;
    let dy4D = $dy;
    let reshapedTo4D = false;
    if ($input.rank === 3) {
        reshapedTo4D = true;
        input4D = (0, $eP0pM.reshape)($input, [
            1,
            $input.shape[0],
            $input.shape[1],
            $input.shape[2]
        ]);
        dy4D = (0, $eP0pM.reshape)($dy, [
            1,
            $dy.shape[0],
            $dy.shape[1],
            $dy.shape[2]
        ]);
    }
    $4tCOB.assert(dy4D.rank === 4, ()=>`Error in avgPoolGrad: dy must be rank 4 but got rank ` + `${dy4D.rank}.`);
    $4tCOB.assert(input4D.rank === 4, ()=>`Error in avgPoolGrad: input must be rank 4 but got rank ` + `${input4D.rank}.`);
    const inputs = {
        dy: dy4D,
        input: input4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.AvgPoolGrad), inputs, attrs);
    if (reshapedTo4D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $26d1bc2f1375f699$export$2f098171d1c79aea = (0, $jKUCi.op)({
    avgPoolGrad_: $26d1bc2f1375f699$var$avgPoolGrad_
});

});


parcelRegister("acqOQ", function(module, exports) {

$parcel$export(module.exports, "batchMatMulGradConfig", () => $76cfd40ec3805313$export$88221f1a5167c38c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $clO9Z = parcelRequire("clO9Z");
const $76cfd40ec3805313$export$88221f1a5167c38c = {
    kernelName: (0, $dCP8m.BatchMatMul),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [a, b] = saved;
        const { transposeA: transposeA, transposeB: transposeB } = attrs;
        if (!transposeA && !transposeB) return {
            a: ()=>(0, $clO9Z.matMul)(dy, b, false, true),
            b: ()=>(0, $clO9Z.matMul)(a, dy, true, false)
        };
        else if (!transposeA && transposeB) return {
            a: ()=>(0, $clO9Z.matMul)(dy, b, false, false),
            b: ()=>(0, $clO9Z.matMul)(dy, a, true, false)
        };
        else if (transposeA && !transposeB) return {
            a: ()=>(0, $clO9Z.matMul)(b, dy, false, true),
            b: ()=>(0, $clO9Z.matMul)(a, dy, false, false)
        };
        else return {
            a: ()=>(0, $clO9Z.matMul)(b, dy, true, true),
            b: ()=>(0, $clO9Z.matMul)(dy, a, true, true)
        };
    }
};

});

parcelRegister("71le5", function(module, exports) {

$parcel$export(module.exports, "batchToSpaceNDGradConfig", () => $0151b1ed449cbae1$export$b6582e1705c4f42d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $95zUK = parcelRequire("95zUK");
const $0151b1ed449cbae1$export$b6582e1705c4f42d = {
    kernelName: (0, $dCP8m.BatchToSpaceND),
    gradFunc: (dy, saved, attrs)=>{
        const { blockShape: blockShape, crops: crops } = attrs;
        return {
            x: ()=>(0, $95zUK.spaceToBatchND)(dy, blockShape, crops)
        };
    }
};

});

parcelRegister("cjdPN", function(module, exports) {

$parcel$export(module.exports, "broadcastToGradConfig", () => $8f61fda1f01b643a$export$1fc1d8b1fdae546a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $fVwnn = parcelRequire("fVwnn");
const $8f61fda1f01b643a$export$1fc1d8b1fdae546a = {
    kernelName: (0, $dCP8m.BroadcastTo),
    gradFunc: (dy, saved, attrs)=>{
        const broadCastToAttrs = attrs;
        const inputShape = broadCastToAttrs.inputShape;
        const outputShape = broadCastToAttrs.shape;
        const reps = Array.from(outputShape);
        for(let i = inputShape.length - 1; i >= 0; i--){
            if (inputShape[i] === outputShape[i]) reps[i] = 1;
            else if (inputShape[i] !== 1) throw new Error(`broadcastTo(): [${inputShape}] cannot be broadcast to [${outputShape}].`);
        }
        const axes = [];
        for(let i = 0; i < reps.length; i++)if (reps[i] > 1) axes.push(i);
        return {
            x: ()=>(0, $fVwnn.sum)(dy, axes, true)
        };
    }
};

});

parcelRegister("3FrLB", function(module, exports) {

$parcel$export(module.exports, "castGradConfig", () => $2ababd538481199f$export$77a4f6320d798df2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");
const $2ababd538481199f$export$77a4f6320d798df2 = {
    kernelName: (0, $dCP8m.Cast),
    gradFunc: (dy)=>{
        return {
            x: ()=>dy.clone()
        };
    }
};

});

parcelRegister("U9hkL", function(module, exports) {

$parcel$export(module.exports, "ceilGradConfig", () => $0a8c6d9c11a992ea$export$1789d8956379862a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $0a8c6d9c11a992ea$export$1789d8956379862a = {
    kernelName: (0, $dCP8m.Ceil),
    gradFunc: (dy)=>{
        // TODO(manrajgrover): Return null for gradients when backprop supports it.
        return {
            x: ()=>(0, $k1Ozi.zerosLike)(dy)
        };
    }
};

});

parcelRegister("3hwpO", function(module, exports) {

$parcel$export(module.exports, "clipByValueGradConfig", () => $263c1aa083abadee$export$3f1764b1eedfe2cb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $cUuWi = parcelRequire("cUuWi");

var $eXGUa = parcelRequire("eXGUa");

var $jtRHJ = parcelRequire("jtRHJ");

var $3dRh6 = parcelRequire("3dRh6");

var $k1Ozi = parcelRequire("k1Ozi");
const $263c1aa083abadee$export$3f1764b1eedfe2cb = {
    kernelName: (0, $dCP8m.ClipByValue),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { clipValueMin: clipValueMin, clipValueMax: clipValueMax } = attrs;
        return {
            x: ()=>(0, $3dRh6.where)((0, $jtRHJ.logicalAnd)((0, $cUuWi.greaterEqual)(x, clipValueMin), (0, $eXGUa.lessEqual)(x, clipValueMax)), dy, (0, $k1Ozi.zerosLike)(dy))
        };
    }
};

});

parcelRegister("67KUb", function(module, exports) {

$parcel$export(module.exports, "complexAbsGradConfig", () => $4757c7f06b071706$export$b8ff856642294896);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7kJu7 = parcelRequire("7kJu7");
const $4757c7f06b071706$export$b8ff856642294896 = {
    kernelName: (0, $dCP8m.ComplexAbs),
    inputsToSave: [
        'x'
    ],
    gradFunc: (0, $7kJu7.absGradConfig).gradFunc
};

});

parcelRegister("7TOE1", function(module, exports) {

$parcel$export(module.exports, "concatGradConfig", () => $5c04f467d2a4e0ba$export$ddda159860ceb06e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $9DjTt = parcelRequire("9DjTt");

var $4tCOB = parcelRequire("4tCOB");
const $5c04f467d2a4e0ba$export$ddda159860ceb06e = {
    kernelName: (0, $dCP8m.Concat),
    saveAllInputs: true,
    gradFunc: (dy, saved, attrs)=>{
        const shapes = saved.map((t)=>t.shape);
        const { axis: axis } = attrs;
        const $axis = (0, $4tCOB.parseAxisParam)(axis, saved[0].shape)[0];
        const sizeSplits = shapes.map((s)=>s[$axis]);
        const derTensors = (0, $9DjTt.split)(dy, sizeSplits, $axis);
        return derTensors.map((t)=>()=>t);
    }
};

});

parcelRegister("3Ogu4", function(module, exports) {

$parcel$export(module.exports, "conv2DGradConfig", () => $2c62d3f8b087b5b8$export$2fd622114dede0fc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $26YQK = parcelRequire("26YQK");

var $f0966 = parcelRequire("f0966");

var $yLVwv = parcelRequire("yLVwv");

var $4tCOB = parcelRequire("4tCOB");
const $2c62d3f8b087b5b8$export$2fd622114dede0fc = {
    kernelName: (0, $dCP8m.Conv2D),
    inputsToSave: [
        'x',
        'filter'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x4D, $filter] = saved;
        const { dilations: dilations, strides: strides, pad: pad, dataFormat: dataFormat } = attrs;
        $4tCOB.assert($yLVwv.tupleValuesAreOne(dilations), ()=>'Error in gradient of conv2D: dilation rates greater than 1 ' + `are not yet supported in gradients. Got dilations '${dilations}'`);
        return {
            x: ()=>(0, $f0966.conv2DBackpropInput)(x4D.shape, dy, $filter, strides, pad, dataFormat),
            filter: ()=>(0, $26YQK.conv2DBackpropFilter)(x4D, dy, $filter.shape, strides, pad, dataFormat)
        };
    }
};

});

parcelRegister("1Iv1U", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropInputGradConfig", () => $1401f863dd37ce89$export$cdb8a95f3d598a0d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $jOBWR = parcelRequire("jOBWR");

var $26YQK = parcelRequire("26YQK");
const $1401f863dd37ce89$export$cdb8a95f3d598a0d = {
    kernelName: (0, $dCP8m.Conv2DBackpropInput),
    inputsToSave: [
        'dy',
        'filter'
    ],
    gradFunc: (ddx, saved, attrs)=>{
        const [dy, filter] = saved;
        const { strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
        return {
            dy: ()=>(0, $jOBWR.conv2d)(ddx, filter, strides, pad, dataFormat, 1 /* dilations */ , dimRoundingMode),
            filter: ()=>(0, $26YQK.conv2DBackpropFilter)(ddx, dy, filter.shape, strides, pad, dataFormat, dimRoundingMode)
        };
    }
};

});

parcelRegister("7UF0S", function(module, exports) {

$parcel$export(module.exports, "conv3DGradConfig", () => $5c2d93b392d21926$export$2456b335ba19aa7b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $ijU8v = parcelRequire("ijU8v");

var $YRgVI = parcelRequire("YRgVI");

var $yLVwv = parcelRequire("yLVwv");

var $4tCOB = parcelRequire("4tCOB");
const $5c2d93b392d21926$export$2456b335ba19aa7b = {
    kernelName: (0, $dCP8m.Conv3D),
    inputsToSave: [
        'x',
        'filter'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const { dilations: dilations, strides: strides, pad: pad } = attrs;
        $4tCOB.assert((0, $yLVwv.tupleValuesAreOne)(dilations), ()=>'Error in gradient of conv3D: dilation rates greater than 1 are ' + `not yet supported in gradients. Got dilations '${dilations}'`);
        const [x5D, $filter] = saved;
        return {
            x: ()=>(0, $YRgVI.conv3DBackpropInput)(x5D.shape, dy, $filter, strides, pad),
            filter: ()=>(0, $ijU8v.conv3DBackpropFilter)(x5D, dy, $filter.shape, strides, pad)
        };
    }
};

});
parcelRegister("ijU8v", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropFilter", () => $d5658bd789eca4db$export$6119875a1cee531e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $4tCOB = parcelRequire("4tCOB");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the derivative of the filter of a 3D convolution.
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     [batch, depth, height, width, inChannels]. If rank 4, batch of 1 is
 *     assumed.
 * @param dy The dy image, of rank 5 or rank 4, of shape
 *     [batch, depth, height, width, outDepth]. If rank 4, batch of 1 is
 *     assumed.
 * @param filterShape The shape of the filter, length 5,
 *     [filterDepth, filterHeight, filterWidth, inDepth, outDepth].
 * @param strides The strides of the convolution: [strideDepth, strideHeight,
 * strideWidth].
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 */ function $d5658bd789eca4db$var$conv3DBackpropFilter_(x, dy, filterShape, strides, pad) {
    let x5D = x;
    if (x.rank === 4) x5D = (0, $eP0pM.reshape)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2],
        x.shape[3]
    ]);
    let dy5D = dy;
    if (dy5D.rank === 4) dy5D = (0, $eP0pM.reshape)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2],
        dy.shape[3]
    ]);
    $4tCOB.assert(x5D.rank === 5, ()=>`Error in conv3dDerFilter: input must be rank 5, but got shape ` + `${x5D.shape}.`);
    $4tCOB.assert(dy5D.rank === 5, ()=>`Error in conv3dDerFilter: dy must be rank 5, but got shape ` + `${dy5D.shape}.`);
    $4tCOB.assert(filterShape.length === 5, ()=>`Error in conv3dDerFilter: filterShape must be length 5, but got ` + `${filterShape}.`);
    $4tCOB.assert(x5D.shape[4] === filterShape[3], ()=>`Error in conv3dDerFilter: depth of input ${x5D.shape[4]}) must ` + `match input depth in filter (${filterShape[3]}.`);
    $4tCOB.assert(dy5D.shape[4] === filterShape[4], ()=>`Error in conv3dDerFilter: depth of dy (${dy5D.shape[4]}) must ` + `match output depth for filter (${filterShape[4]}).`);
    const inputs = {
        x: x5D,
        dy: dy5D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Conv3DBackpropFilterV2), inputs, attrs);
}
const $d5658bd789eca4db$export$6119875a1cee531e = (0, $jKUCi.op)({
    conv3DBackpropFilter_: $d5658bd789eca4db$var$conv3DBackpropFilter_
});

});


parcelRegister("fapsP", function(module, exports) {

$parcel$export(module.exports, "cosGradConfig", () => $b0ab8ad267fd517e$export$fc646268baa57098);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $r7fN6 = parcelRequire("r7fN6");

var $ifge7 = parcelRequire("ifge7");

var $b37Kr = parcelRequire("b37Kr");
const $b0ab8ad267fd517e$export$fc646268baa57098 = {
    kernelName: (0, $dCP8m.Cos),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $r7fN6.mul)((0, $ifge7.neg)((0, $b37Kr.sin)((0, $7qWZ5.cast)(x, 'float32'))), dy)
        };
    }
};

});

parcelRegister("1CypV", function(module, exports) {

$parcel$export(module.exports, "coshGradConfig", () => $12e40999a5dad3ac$export$bcde595585c16638);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $r7fN6 = parcelRequire("r7fN6");

var $8sXeR = parcelRequire("8sXeR");
const $12e40999a5dad3ac$export$bcde595585c16638 = {
    kernelName: (0, $dCP8m.Cosh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $r7fN6.mul)((0, $8sXeR.sinh)((0, $7qWZ5.cast)(x, 'float32')), dy)
        };
    }
};

});

parcelRegister("d5y2C", function(module, exports) {

$parcel$export(module.exports, "cumsumGradConfig", () => $987625e27e76199c$export$9f1ba0cc8e88cb76);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $9k5Lx = parcelRequire("9k5Lx");

var $6nQJI = parcelRequire("6nQJI");

var $9PEYs = parcelRequire("9PEYs");
const $987625e27e76199c$export$9f1ba0cc8e88cb76 = {
    kernelName: (0, $dCP8m.Cumsum),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
        return {
            x: ()=>{
                const permutation = (0, $9k5Lx.getAxesPermutation)([
                    axis
                ], x.rank);
                let out = (0, $6nQJI.cumsum)(dy, axis, exclusive, !reverse);
                if (permutation != null) out = (0, $9PEYs.transpose)(out, permutation);
                return out;
            }
        };
    }
};

});

parcelRegister("fJx29", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeGradConfig", () => $b744aecc85c9d640$export$66192798aa3d6196);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $yLVwv = parcelRequire("yLVwv");

var $f6z1x = parcelRequire("f6z1x");

var $b9Kdj = parcelRequire("b9Kdj");

var $4tCOB = parcelRequire("4tCOB");
const $b744aecc85c9d640$export$66192798aa3d6196 = {
    kernelName: (0, $dCP8m.DepthwiseConv2dNative),
    inputsToSave: [
        'x',
        'filter'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const { dilations: dilations, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
        const $dilations = dilations == null ? [
            1,
            1
        ] : dilations;
        $4tCOB.assert($yLVwv.tupleValuesAreOne($dilations), ()=>'Error in gradient of depthwiseConv2dNative: dilation rates ' + `greater than 1 are not yet supported. Got dilations ` + `'${$dilations}'`);
        const [x, filter] = saved;
        $4tCOB.assert(x.rank === 4, ()=>`Error in gradient of depthwiseConv2dNative: input must be ` + `rank 4, but got rank ${x.rank}.`);
        $4tCOB.assert(filter.rank === 4, ()=>`Error in gradient of depthwiseConv2dNative: filter must be ` + `rank 4, but got rank ${filter.rank}.`);
        $4tCOB.assert(x.shape[3] === filter.shape[2], ()=>`Error in gradient of depthwiseConv2d: number of input ` + `channels (${x.shape[3]}) must match the inChannels dimension ` + `in filter ${filter.shape[2]}.`);
        $4tCOB.assert($yLVwv.eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in gradient of depthwiseConv2d: Either strides or ' + `dilations must be  1. Got strides ${strides} and dilations ` + `'${$dilations}'.`);
        $yLVwv.checkPadOnDimRoundingMode('depthwiseConv2d', pad, dimRoundingMode);
        return {
            x: ()=>(0, $b9Kdj.depthwiseConv2dNativeBackpropInput)(x.shape, dy, filter, strides, pad, $dilations, dimRoundingMode),
            filter: ()=>(0, $f6z1x.depthwiseConv2dNativeBackpropFilter)(x, dy, filter.shape, strides, pad, $dilations, dimRoundingMode)
        };
    }
};

});

parcelRegister("37ISE", function(module, exports) {

$parcel$export(module.exports, "dilation2dGradConfig", () => $2464d6da5c7fbaa1$export$3d2aed5cf11b13ba);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");
const $2464d6da5c7fbaa1$export$3d2aed5cf11b13ba = {
    kernelName: (0, $dCP8m.Dilation2D),
    inputsToSave: [
        'x',
        'filter'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, filter] = saved;
        const inputInputs = {
            x: x,
            filter: filter,
            dy: dy
        };
        const filterInputs = {
            x: x,
            filter: filter,
            dy: dy
        };
        return {
            x: ()=>(0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Dilation2DBackpropInput), inputInputs, attrs),
            filter: ()=>(0, $aHfUM.ENGINE).runKernel((0, $dCP8m.Dilation2DBackpropFilter), filterInputs, attrs)
        };
    }
};

});

parcelRegister("4Lq7I", function(module, exports) {

$parcel$export(module.exports, "eluGradConfig", () => $377fd0cb3ba55985$export$59bb07dd04647a1d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");
const $377fd0cb3ba55985$export$59bb07dd04647a1d = {
    kernelName: (0, $dCP8m.Elu),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [y] = saved;
        const inputs = {
            dy: dy,
            y: y
        };
        return {
            x: ()=>(0, $aHfUM.ENGINE).runKernel((0, $dCP8m.EluGrad), inputs)
        };
    }
};

});

parcelRegister("gsnxJ", function(module, exports) {

$parcel$export(module.exports, "erfGradConfig", () => $bfb18607f59bc0c3$export$80bb9a361ec8d601);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $4NGnB = parcelRequire("4NGnB");

var $r7fN6 = parcelRequire("r7fN6");

var $ifge7 = parcelRequire("ifge7");

var $gqriC = parcelRequire("gqriC");
const $bfb18607f59bc0c3$export$80bb9a361ec8d601 = {
    kernelName: (0, $dCP8m.Erf),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        const a = (0, $r7fN6.mul)((0, $4NGnB.exp)((0, $ifge7.neg)((0, $gqriC.square)(x))), 2 / Math.sqrt(Math.PI));
        return {
            x: ()=>(0, $r7fN6.mul)(dy, a)
        };
    }
};

});

parcelRegister("fxHNI", function(module, exports) {

$parcel$export(module.exports, "expGradConfig", () => $b50bea0a5912295d$export$e3362b875cf81ebc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $r7fN6 = parcelRequire("r7fN6");
const $b50bea0a5912295d$export$e3362b875cf81ebc = {
    kernelName: (0, $dCP8m.Exp),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [y] = saved;
        return {
            x: ()=>(0, $r7fN6.mul)(dy, y)
        };
    }
};

});

parcelRegister("9V7I1", function(module, exports) {

$parcel$export(module.exports, "expandDimsGradConfig", () => $738f6ac8fe673760$export$27394e9fa8330490);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $eP0pM = parcelRequire("eP0pM");
const $738f6ac8fe673760$export$27394e9fa8330490 = {
    kernelName: (0, $dCP8m.ExpandDims),
    inputsToSave: [
        'input'
    ],
    gradFunc: (dy, saved)=>{
        const [input] = saved;
        return {
            input: ()=>(0, $eP0pM.reshape)(dy, input.shape)
        };
    }
};

});

parcelRegister("eVc1W", function(module, exports) {

$parcel$export(module.exports, "expm1GradConfig", () => $adcfb887fbf232a1$export$758f509582468c75);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $4NGnB = parcelRequire("4NGnB");

var $r7fN6 = parcelRequire("r7fN6");
const $adcfb887fbf232a1$export$758f509582468c75 = {
    kernelName: (0, $dCP8m.Expm1),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $r7fN6.mul)(dy, (0, $4NGnB.exp)(x))
        };
    }
};

});

parcelRegister("b2fpc", function(module, exports) {

$parcel$export(module.exports, "floorGradConfig", () => $808bd4d6c2bbd809$export$2a943001dbfa8fd1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $808bd4d6c2bbd809$export$2a943001dbfa8fd1 = {
    kernelName: (0, $dCP8m.Floor),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $k1Ozi.zerosLike)(dy)
        };
    }
};

});

parcelRegister("elIi3", function(module, exports) {

$parcel$export(module.exports, "floorDivGradConfig", () => $a72561fd939082b2$export$1f5798c5c4ca3f10);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $eqTIO = parcelRequire("eqTIO");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gjFWY = parcelRequire("gjFWY");

var $r7fN6 = parcelRequire("r7fN6");

var $ifge7 = parcelRequire("ifge7");

var $eP0pM = parcelRequire("eP0pM");

var $gqriC = parcelRequire("gqriC");

var $fVwnn = parcelRequire("fVwnn");
const $a72561fd939082b2$export$1f5798c5c4ca3f10 = {
    kernelName: (0, $dCP8m.FloorDiv),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = (0, $eqTIO.assertAndGetBroadcastShape)(a.shape, b.shape);
        const derA = ()=>{
            const res = (0, $gjFWY.div)(dy, (0, $7qWZ5.cast)(b, 'float32'));
            const reduceAxes = (0, $eqTIO.getReductionAxes)(a.shape, outShape);
            if (reduceAxes.length > 0) return (0, $eP0pM.reshape)((0, $fVwnn.sum)(res, reduceAxes), a.shape);
            return res;
        };
        const derB = ()=>{
            let res = (0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)(a, 'float32'));
            const reduceAxes = (0, $eqTIO.getReductionAxes)(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $eP0pM.reshape)((0, $fVwnn.sum)(res, reduceAxes), b.shape);
            const tmp = (0, $gqriC.square)(b);
            return (0, $ifge7.neg)((0, $gjFWY.div)(res, (0, $7qWZ5.cast)(tmp, 'float32')));
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("e6use", function(module, exports) {

$parcel$export(module.exports, "fusedBatchNormGradConfig", () => $a4493fcda24b0827$export$3b83e7a588d720e9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $1ZrG5 = parcelRequire("1ZrG5");

var $eqTIO = parcelRequire("eqTIO");

var $r7fN6 = parcelRequire("r7fN6");

var $eP0pM = parcelRequire("eP0pM");

var $bvzmJ = parcelRequire("bvzmJ");

var $j7yUF = parcelRequire("j7yUF");

var $hkR0n = parcelRequire("hkR0n");

var $fVwnn = parcelRequire("fVwnn");

var $jIHaY = parcelRequire("jIHaY");
const $a4493fcda24b0827$export$3b83e7a588d720e9 = {
    kernelName: (0, $dCP8m.FusedBatchNorm),
    inputsToSave: [
        'x',
        'mean',
        'variance',
        'scale'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const { varianceEpsilon: varianceEpsilon } = attrs;
        const [x, mean, variance, scale] = saved;
        const scaleValue = scale == null ? (0, $j7yUF.scalar)(1) : scale;
        const reductionAxes = (0, $eqTIO.getReductionAxes)(mean.shape, x.shape);
        const tileShape = [];
        if (mean.rank === 1) {
            for(let i = 0; i < x.shape.length - 1; ++i)tileShape.push(x.shape[i]);
            tileShape.push(1);
        }
        const xMinusMean = (0, $hkR0n.sub)(x, mean);
        const dyTimesScaleValue = (0, $r7fN6.mul)(dy, scaleValue);
        const oneOverSqrtVariance = (0, $bvzmJ.rsqrt)((0, $1ZrG5.add)(variance, (0, $j7yUF.scalar)(varianceEpsilon)));
        const minusHalfRCube = (0, $r7fN6.mul)((0, $r7fN6.mul)((0, $r7fN6.mul)(oneOverSqrtVariance, oneOverSqrtVariance), oneOverSqrtVariance), (0, $j7yUF.scalar)(-0.5));
        const derX = ()=>{
            if (mean.rank === 1) return (0, $eP0pM.reshape)((0, $r7fN6.mul)((0, $r7fN6.mul)(dy, (0, $jIHaY.tile)((0, $eP0pM.reshape)(oneOverSqrtVariance, [
                1,
                1,
                1,
                mean.shape[0]
            ]), tileShape)), scaleValue), x.shape);
            else return (0, $eP0pM.reshape)((0, $r7fN6.mul)((0, $r7fN6.mul)(dy, oneOverSqrtVariance), scaleValue), x.shape);
        };
        const derMean = ()=>{
            let meanDer = (0, $r7fN6.mul)((0, $r7fN6.mul)(oneOverSqrtVariance, (0, $j7yUF.scalar)(-1)), dyTimesScaleValue);
            if (mean.rank === 1) meanDer = (0, $fVwnn.sum)(meanDer, reductionAxes);
            return (0, $eP0pM.reshape)(meanDer, mean.shape);
        };
        const derVariance = ()=>{
            let varianceDer = (0, $r7fN6.mul)((0, $r7fN6.mul)(minusHalfRCube, xMinusMean), dyTimesScaleValue);
            if (mean.rank === 1) varianceDer = (0, $fVwnn.sum)(varianceDer, reductionAxes);
            return (0, $eP0pM.reshape)(varianceDer, mean.shape);
        };
        const derScale = ()=>{
            const xMinusMean2TimesRsqrt = (0, $r7fN6.mul)(xMinusMean, oneOverSqrtVariance);
            let scaleDer = (0, $r7fN6.mul)(dy, xMinusMean2TimesRsqrt);
            if (mean.rank === 1) scaleDer = (0, $fVwnn.sum)(scaleDer, reductionAxes);
            return (0, $eP0pM.reshape)(scaleDer, mean.shape);
        };
        const derOffset = ()=>{
            let offsetDer = dy;
            if (mean.rank === 1) offsetDer = (0, $fVwnn.sum)(offsetDer, reductionAxes);
            return (0, $eP0pM.reshape)(offsetDer, mean.shape);
        };
        return {
            x: derX,
            mean: derMean,
            variance: derVariance,
            scale: derScale,
            offset: derOffset
        };
    }
};

});

parcelRegister("2bGbC", function(module, exports) {

$parcel$export(module.exports, "gatherGradConfig", () => $197d552e6406aaed$export$793739cdccafd2d1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $9k5Lx = parcelRequire("9k5Lx");

var $eP0pM = parcelRequire("eP0pM");

var $9PEYs = parcelRequire("9PEYs");

var $grKBK = parcelRequire("grKBK");

var $4tCOB = parcelRequire("4tCOB");
const $197d552e6406aaed$export$793739cdccafd2d1 = {
    kernelName: (0, $dCP8m.GatherV2),
    inputsToSave: [
        'x',
        'indices'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, indices] = saved;
        const { axis: axis } = attrs;
        const parsedAxis = (0, $4tCOB.parseAxisParam)(axis, x.shape)[0];
        const derX = ()=>{
            const paramsShape = x.shape;
            const indicesSize = indices.size;
            const outerShape = paramsShape.slice(0, parsedAxis);
            const outerDims = outerShape.length;
            const innerShape = paramsShape.slice(axis, paramsShape.length).slice(1);
            const innerDims = innerShape.length;
            const outerAxesIndices = $197d552e6406aaed$var$arrayRange(0, outerDims);
            const innerAxesIndices = $197d552e6406aaed$var$arrayRange(outerDims + 1, outerDims + 1 + innerDims);
            const valuesShape = $197d552e6406aaed$var$arrayConcat([
                outerShape,
                [
                    indicesSize
                ],
                innerShape
            ]);
            const values = (0, $eP0pM.reshape)(dy, valuesShape);
            const reshapedIndices = (0, $eP0pM.reshape)(indices, [
                indicesSize
            ]);
            const transposeDims = $197d552e6406aaed$var$arrayConcat([
                [
                    outerDims
                ],
                outerAxesIndices,
                innerAxesIndices
            ]);
            const valuesTranspose = (0, $9PEYs.transpose)(values, transposeDims);
            let paramsGrad = (0, $grKBK.unsortedSegmentSum)(valuesTranspose, reshapedIndices, x.shape[parsedAxis]);
            const invertTransposeDims = (0, $9k5Lx.getUndoAxesPermutation)(transposeDims);
            paramsGrad = (0, $9PEYs.transpose)(paramsGrad, invertTransposeDims);
            return paramsGrad;
        };
        return {
            x: derX,
            indices: ()=>indices
        };
    }
};
function $197d552e6406aaed$var$arrayRange(start, stop) {
    const result = [];
    for(let i = start; i < stop; ++i)result.push(i);
    return result;
}
function $197d552e6406aaed$var$arrayConcat(arrays) {
    const result = [];
    for(let i = 0; i < arrays.length; ++i)for(let j = 0; j < arrays[i].length; ++j)result.push(arrays[i][j]);
    return result;
}

});

parcelRegister("hQ4ey", function(module, exports) {

$parcel$export(module.exports, "greaterEqualGradConfig", () => $cfca93c14da9f282$export$fba648816411e438);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $cfca93c14da9f282$export$fba648816411e438 = {
    kernelName: (0, $dCP8m.GreaterEqual),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        return {
            a: ()=>(0, $k1Ozi.zerosLike)(a),
            b: ()=>(0, $k1Ozi.zerosLike)(b)
        };
    }
};

});

parcelRegister("j9gsC", function(module, exports) {

$parcel$export(module.exports, "identityGradConfig", () => $df0ba054742cfb49$export$bddb155b34767c3a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");
const $df0ba054742cfb49$export$bddb155b34767c3a = {
    kernelName: (0, $dCP8m.Identity),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $7qWZ5.cast)(dy, 'float32')
        };
    }
};

});

parcelRegister("7wXkF", function(module, exports) {

$parcel$export(module.exports, "isFiniteGradConfig", () => $57b98bc08dfaf62d$export$108f33db0f535e77);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $57b98bc08dfaf62d$export$108f33db0f535e77 = {
    kernelName: (0, $dCP8m.IsFinite),
    gradFunc: (dy)=>{
        // TODO(nsthorat): Let gradients be null for cases where we want to stop
        // backpropgation.
        return {
            x: ()=>(0, $k1Ozi.zerosLike)(dy)
        };
    }
};

});

parcelRegister("2T4lz", function(module, exports) {

$parcel$export(module.exports, "isInfGradConfig", () => $21a41705ecd29959$export$af7d3cc575a3d37d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $21a41705ecd29959$export$af7d3cc575a3d37d = {
    kernelName: (0, $dCP8m.IsInf),
    gradFunc: (dy)=>{
        // TODO(nsthorat): Let gradients be null for cases where we want to stop
        // backpropgation.
        return {
            x: ()=>(0, $k1Ozi.zerosLike)(dy)
        };
    }
};

});

parcelRegister("287SG", function(module, exports) {

$parcel$export(module.exports, "isNanGradConfig", () => $18d2711bc546d93d$export$a2997336d9064f51);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $18d2711bc546d93d$export$a2997336d9064f51 = {
    kernelName: (0, $dCP8m.IsNan),
    gradFunc: (dy)=>{
        // TODO(nsthorat): Let gradients be null for cases where we want to stop
        // backpropgation.
        return {
            x: ()=>(0, $k1Ozi.zerosLike)(dy)
        };
    }
};

});

parcelRegister("3gcvm", function(module, exports) {

$parcel$export(module.exports, "leakyReluGradConfig", () => $25fc90f0af4e8594$export$8aba4169a7423780);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $jUhqf = parcelRequire("jUhqf");

var $r7fN6 = parcelRequire("r7fN6");

var $3dRh6 = parcelRequire("3dRh6");
const $25fc90f0af4e8594$export$8aba4169a7423780 = {
    kernelName: (0, $dCP8m.LeakyRelu),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { alpha: alpha } = attrs;
        const mask = (0, $jUhqf.greater)(x, 0);
        // Returns `gradients * (features > 0) + alpha * gradients * (features <=
        // 0)`.
        return {
            x: ()=>(0, $3dRh6.where)(mask, dy, (0, $r7fN6.mul)(dy, alpha))
        };
    }
};

});

parcelRegister("cUNLd", function(module, exports) {

$parcel$export(module.exports, "log1pGradConfig", () => $96715067e44000e1$export$2a0e1acd37a49488);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $1ZrG5 = parcelRequire("1ZrG5");

var $gjFWY = parcelRequire("gjFWY");
const $96715067e44000e1$export$2a0e1acd37a49488 = {
    kernelName: (0, $dCP8m.Log1p),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $gjFWY.div)(dy, (0, $1ZrG5.add)(x, 1))
        };
    }
};

});

parcelRegister("7NOl8", function(module, exports) {

$parcel$export(module.exports, "logGradConfig", () => $5ae4286f64696a5f$export$a6f98c34c79ddc6c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gjFWY = parcelRequire("gjFWY");
const $5ae4286f64696a5f$export$a6f98c34c79ddc6c = {
    kernelName: (0, $dCP8m.Log),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $gjFWY.div)(dy, (0, $7qWZ5.cast)(x, 'float32'))
        };
    }
};

});

parcelRegister("izGd7", function(module, exports) {

$parcel$export(module.exports, "logSoftmaxGradConfig", () => $d85c3d054d0b7a3b$export$556818e7703f08a6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $4NGnB = parcelRequire("4NGnB");

var $r7fN6 = parcelRequire("r7fN6");

var $hkR0n = parcelRequire("hkR0n");

var $fVwnn = parcelRequire("fVwnn");
const $d85c3d054d0b7a3b$export$556818e7703f08a6 = {
    kernelName: (0, $dCP8m.LogSoftmax),
    inputsToSave: [],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [value] = saved;
        const { axis: axis } = attrs;
        return {
            logits: ()=>{
                const keepDims = true;
                const softmax = (0, $4NGnB.exp)(value);
                return (0, $hkR0n.sub)(dy, (0, $r7fN6.mul)((0, $fVwnn.sum)(dy, axis, keepDims), softmax));
            }
        };
    }
};

});

parcelRegister("lhali", function(module, exports) {

$parcel$export(module.exports, "lrnGradConfig", () => $f7d3354c32064a88$export$9250622395b66a34);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $26nGp = parcelRequire("26nGp");
const $f7d3354c32064a88$export$9250622395b66a34 = {
    kernelName: (0, $dCP8m.LRN),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, y] = saved;
        const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
        return {
            x: ()=>(0, $26nGp.localResponseNormalizationBackprop)(x, y, dy, depthRadius, bias, alpha, beta)
        };
    }
};

});
parcelRegister("26nGp", function(module, exports) {

$parcel$export(module.exports, "localResponseNormalizationBackprop", () => $187e834103079fba$export$855c82875e6b50cd);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $jKUCi = parcelRequire("jKUCi");
function $187e834103079fba$var$localResponseNormalizationBackprop_(x, y, dy, depthRadius = 5, bias = 1, alpha = 1, beta = 0.5) {
    const inputs = {
        x: x,
        y: y,
        dy: dy
    };
    const attrs = {
        depthRadius: depthRadius,
        bias: bias,
        alpha: alpha,
        beta: beta
    };
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.LRNGrad), inputs, attrs);
}
const $187e834103079fba$export$855c82875e6b50cd = (0, $jKUCi.op)({
    localResponseNormalizationBackprop_: $187e834103079fba$var$localResponseNormalizationBackprop_
});

});


parcelRegister("iDkbt", function(module, exports) {

$parcel$export(module.exports, "maxGradConfig", () => $d90b86a8e152e810$export$c8c367f50d71c477);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $4tCOB = parcelRequire("4tCOB");

var $b0E29 = parcelRequire("b0E29");
const $d90b86a8e152e810$export$c8c367f50d71c477 = {
    kernelName: (0, $dCP8m.Max),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const maxAttrs = attrs;
        const { reductionIndices: reductionIndices } = maxAttrs;
        const x = saved[0];
        const y = saved[1];
        const origAxes = $4tCOB.parseAxisParam(reductionIndices, x.shape);
        const maxGrad = (0, $b0E29.gradForMinAndMax)(dy, y, x, origAxes);
        return {
            x: ()=>{
                return maxGrad['x']();
            }
        };
    }
};

});
parcelRegister("b0E29", function(module, exports) {

$parcel$export(module.exports, "gradForMinAndMax", () => $803ebfabdaf0ba40$export$c166528825895f87);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9k5Lx = parcelRequire("9k5Lx");

var $7qWZ5 = parcelRequire("7qWZ5");

var $5Py3O = parcelRequire("5Py3O");

var $r7fN6 = parcelRequire("r7fN6");

var $eP0pM = parcelRequire("eP0pM");
function $803ebfabdaf0ba40$export$c166528825895f87(dy, y, xOrig, origAxes) {
    if (y.rank < xOrig.rank) y = (0, $eP0pM.reshape)(y, $9k5Lx.expandShapeToKeepDim(y.shape, origAxes));
    if (dy.rank < xOrig.rank) dy = (0, $eP0pM.reshape)(dy, $9k5Lx.expandShapeToKeepDim(dy.shape, origAxes));
    return {
        x: ()=>{
            const dx = (0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)((0, $5Py3O.equal)(xOrig, y), dy.dtype));
            return dx;
        }
    };
}

});


parcelRegister("3Vl8D", function(module, exports) {

$parcel$export(module.exports, "maximumGradConfig", () => $2db7179ac8eb8e3e$export$b394285cea805997);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $cUuWi = parcelRequire("cUuWi");

var $6skdg = parcelRequire("6skdg");

var $r7fN6 = parcelRequire("r7fN6");
const $2db7179ac8eb8e3e$export$b394285cea805997 = {
    kernelName: (0, $dCP8m.Maximum),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const derA = ()=>(0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)((0, $cUuWi.greaterEqual)(a, b), 'float32'));
        const derB = ()=>(0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)((0, $6skdg.less)(a, b), 'float32'));
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("4zVGk", function(module, exports) {

$parcel$export(module.exports, "maxPool3DGradConfig", () => $35572cb731c60235$export$5201426bb10bd5eb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $2a7Wx = parcelRequire("2a7Wx");
const $35572cb731c60235$export$5201426bb10bd5eb = {
    kernelName: (0, $dCP8m.MaxPool3D),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, y] = saved;
        const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
        return {
            x: ()=>(0, $2a7Wx.maxPool3dGrad)(dy, x, y, filterSize, strides, pad, dimRoundingMode)
        };
    }
};

});
parcelRegister("2a7Wx", function(module, exports) {

$parcel$export(module.exports, "maxPool3dGrad", () => $1932ad4fce109990$export$aa5e236dfd3a66ef);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $yLVwv = parcelRequire("yLVwv");

var $jKUCi = parcelRequire("jKUCi");

var $eP0pM = parcelRequire("eP0pM");
/**
 * Computes the backprop of a 3d max pool.
 *
 * @param dy The dy error, of rank 5 of shape
 *     [batchSize, depth, height, width, channels].
 * assumed.
 * @param input The original input image, of rank 5 or rank 4 of shape
 *     [batchSize, depth, height, width, channels].
 * @param output The original output image, of rank 5 of shape
 *     [batchSize, outDepth, outHeight, outWidth, channels].
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $1932ad4fce109990$var$maxPool3dGrad_(dy, input, output, filterSize, strides, pad, dimRoundingMode) {
    const $dy = (0, $5R1UY.convertToTensor)(dy, 'dy', 'maxPool3dGrad');
    const $input = (0, $5R1UY.convertToTensor)(input, 'input', 'maxPool3dGrad');
    const $output = (0, $5R1UY.convertToTensor)(output, 'output', 'maxPool3dGrad');
    let dy5D = $dy;
    let input5D = $input;
    let output5D = $output;
    let reshapedTo5D = false;
    if ($input.rank === 4) {
        reshapedTo5D = true;
        dy5D = (0, $eP0pM.reshape)($dy, [
            1,
            $dy.shape[0],
            $dy.shape[1],
            $dy.shape[2],
            $dy.shape[3]
        ]);
        input5D = (0, $eP0pM.reshape)($input, [
            1,
            $input.shape[0],
            $input.shape[1],
            $input.shape[2],
            $input.shape[3]
        ]);
        output5D = (0, $eP0pM.reshape)($output, [
            1,
            $output.shape[0],
            $output.shape[1],
            $output.shape[2],
            $output.shape[3]
        ]);
    }
    $4tCOB.assert(dy5D.rank === 5, ()=>`Error in maxPool3dGrad: dy must be rank 5 but got rank ` + `${dy5D.rank}.`);
    $4tCOB.assert(input5D.rank === 5, ()=>`Error in maxPool3dGrad: input must be rank 5 but got rank ` + `${input5D.rank}.`);
    $4tCOB.assert(output5D.rank === 5, ()=>`Error in maxPool3dGrad: output must be rank 5 but got rank ` + `${output5D.rank}.`);
    (0, $yLVwv.checkPadOnDimRoundingMode)('maxPool3dGrad', pad, dimRoundingMode);
    const inputs = {
        dy: dy5D,
        input: input5D,
        output: output5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.MaxPool3DGrad), inputs, attrs);
    if (reshapedTo5D) return (0, $eP0pM.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $1932ad4fce109990$export$aa5e236dfd3a66ef = (0, $jKUCi.op)({
    maxPool3dGrad_: $1932ad4fce109990$var$maxPool3dGrad_
});

});


parcelRegister("if93r", function(module, exports) {

$parcel$export(module.exports, "maxPoolGradConfig", () => $d480a6ba1bf411ca$export$e01a7f8dbee29127);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $hRJsD = parcelRequire("hRJsD");
const $d480a6ba1bf411ca$export$e01a7f8dbee29127 = {
    kernelName: (0, $dCP8m.MaxPool),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, y] = saved;
        const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
        return {
            x: ()=>(0, $hRJsD.maxPoolGrad)(dy, x, y, filterSize, strides, pad)
        };
    }
};

});
parcelRegister("hRJsD", function(module, exports) {

$parcel$export(module.exports, "maxPoolGrad", () => $d01aa679f7323b54$export$85dfd1121f049514);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");

var $5R1UY = parcelRequire("5R1UY");

var $4tCOB = parcelRequire("4tCOB");

var $yLVwv = parcelRequire("yLVwv");

var $jKUCi = parcelRequire("jKUCi");
/**
 * Computes the backprop of a 2D max pool.
 *
 * @param dy The dy error, of rank 4 or rank 3 of shape
 *     [batchSize, height, width, channels]. If rank 3, batch of 1 is
 * assumed.
 * @param input The original input image, of rank 4, of shape
 *     [batchSize, height, width, channels].
 * @param output The original output image, of rank 4, of shape
 *     [batchSize, outHeight, outWidth, channels].
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm used in the forward prop of the op.
 *     'same', 'valid', for more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $d01aa679f7323b54$var$maxPoolGrad_(dy, input, output, filterSize, strides, pad, dimRoundingMode) {
    const $dy = (0, $5R1UY.convertToTensor)(dy, 'dy', 'maxPoolGrad');
    const $input = (0, $5R1UY.convertToTensor)(input, 'input', 'maxPoolGrad');
    const $output = (0, $5R1UY.convertToTensor)(output, 'output', 'maxPoolGrad');
    $4tCOB.assert($input.rank === $dy.rank, ()=>`Rank of input (${$input.rank}) does not match rank of dy ` + `(${$dy.rank})`);
    $4tCOB.assert($dy.rank === 4, ()=>`Error in maxPoolGrad: dy must be rank 4 but got rank ` + `${$dy.rank}.`);
    $4tCOB.assert($input.rank === 4, ()=>`Error in maxPoolGrad: input must be rank 4 but got rank ` + `${$input.rank}.`);
    $yLVwv.checkPadOnDimRoundingMode('maxPoolGrad', pad, dimRoundingMode);
    const inputs = {
        dy: $dy,
        input: $input,
        output: $output
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.MaxPoolGrad), inputs, attrs);
}
const $d01aa679f7323b54$export$85dfd1121f049514 = (0, $jKUCi.op)({
    maxPoolGrad_: $d01aa679f7323b54$var$maxPoolGrad_
});

});


parcelRegister("iIcIn", function(module, exports) {

$parcel$export(module.exports, "meanGradConfig", () => $d9f632ecf4df837c$export$ac394d88e62d3236);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $9k5Lx = parcelRequire("9k5Lx");

var $gjFWY = parcelRequire("gjFWY");

var $r7fN6 = parcelRequire("r7fN6");

var $bhi4b = parcelRequire("bhi4b");

var $eP0pM = parcelRequire("eP0pM");

var $4tCOB = parcelRequire("4tCOB");
const $d9f632ecf4df837c$export$ac394d88e62d3236 = {
    kernelName: (0, $dCP8m.Mean),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { axis: axis } = attrs;
        const axes = $4tCOB.parseAxisParam(axis, x.shape);
        const shapes = (0, $9k5Lx.computeOutAndReduceShapes)(x.shape, axes);
        const reduceShape = shapes[1];
        const reduceSize = $4tCOB.sizeFromShape(reduceShape);
        const derX = ()=>{
            const expandedDyShape = x.shape.slice();
            axes.forEach((axis)=>{
                expandedDyShape[axis] = 1;
            });
            const expandedDy = (0, $eP0pM.reshape)(dy, expandedDyShape);
            const res = (0, $gjFWY.div)((0, $r7fN6.mul)(expandedDy, (0, $bhi4b.ones)(x.shape, 'float32')), reduceSize);
            return res;
        };
        return {
            x: derX
        };
    }
};

});

parcelRegister("eXIAD", function(module, exports) {

$parcel$export(module.exports, "minGradConfig", () => $ae4929fb8af9f9e6$export$414be41faed05c5f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $4tCOB = parcelRequire("4tCOB");

var $b0E29 = parcelRequire("b0E29");
const $ae4929fb8af9f9e6$export$414be41faed05c5f = {
    kernelName: (0, $dCP8m.Min),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const minAttrs = attrs;
        const { axis: axis } = minAttrs;
        const [x, y] = saved;
        const origAxes = $4tCOB.parseAxisParam(axis, x.shape);
        const minGrad = (0, $b0E29.gradForMinAndMax)(dy, y, x, origAxes);
        return {
            x: ()=>{
                return minGrad['x']();
            }
        };
    }
};

});

parcelRegister("69pTF", function(module, exports) {

$parcel$export(module.exports, "minimumGradConfig", () => $47a7abefc4096317$export$6c859b9b59a13286);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $jUhqf = parcelRequire("jUhqf");

var $eXGUa = parcelRequire("eXGUa");

var $r7fN6 = parcelRequire("r7fN6");
const $47a7abefc4096317$export$6c859b9b59a13286 = {
    kernelName: (0, $dCP8m.Minimum),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const derA = ()=>(0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)((0, $eXGUa.lessEqual)(a, b), 'float32'));
        const derB = ()=>(0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)((0, $jUhqf.greater)(a, b), 'float32'));
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("bZeqS", function(module, exports) {

$parcel$export(module.exports, "mirrorPadGradConfig", () => $8ba096393116283b$export$83a1d4320d554b59);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $kvpGg = parcelRequire("kvpGg");
const $8ba096393116283b$export$83a1d4320d554b59 = {
    kernelName: (0, $dCP8m.MirrorPad),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        // Pad introduces values around the original tensor, so the gradient
        // slices the original shape out of the gradient.
        const x = saved[0];
        const { paddings: paddings } = attrs;
        const begin = paddings.map((p)=>p[0]);
        return {
            x: ()=>(0, $kvpGg.slice)(dy, begin, x.shape)
        };
    }
};

});

parcelRegister("1evEY", function(module, exports) {

$parcel$export(module.exports, "modGradConfig", () => $0e5fa83a0ec8fec8$export$6ef350a1f32ed6e2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $eqTIO = parcelRequire("eqTIO");

var $gjFWY = parcelRequire("gjFWY");

var $hnXfr = parcelRequire("hnXfr");

var $r7fN6 = parcelRequire("r7fN6");

var $ifge7 = parcelRequire("ifge7");

var $eP0pM = parcelRequire("eP0pM");

var $fVwnn = parcelRequire("fVwnn");
const $0e5fa83a0ec8fec8$export$6ef350a1f32ed6e2 = {
    kernelName: (0, $dCP8m.Mod),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = (0, $eqTIO.assertAndGetBroadcastShape)(a.shape, b.shape);
        const derA = ()=>{
            const reduceAxes = (0, $eqTIO.getReductionAxes)(a.shape, outShape);
            if (reduceAxes.length > 0) return (0, $eP0pM.reshape)((0, $fVwnn.sum)(dy, reduceAxes), a.shape);
            return dy;
        };
        const derB = ()=>{
            const res = (0, $r7fN6.mul)(dy, (0, $ifge7.neg)((0, $hnXfr.floor)((0, $gjFWY.div)(a, b))));
            const reduceAxes = (0, $eqTIO.getReductionAxes)(b.shape, outShape);
            if (reduceAxes.length > 0) return (0, $eP0pM.reshape)((0, $fVwnn.sum)(res, reduceAxes), b.shape);
            return res;
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("k2OB8", function(module, exports) {

$parcel$export(module.exports, "multiplyGradConfig", () => $e97b3e40743b02b8$export$13098dd2211fc557);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $eqTIO = parcelRequire("eqTIO");

var $7qWZ5 = parcelRequire("7qWZ5");

var $r7fN6 = parcelRequire("r7fN6");

var $eP0pM = parcelRequire("eP0pM");

var $fVwnn = parcelRequire("fVwnn");
const $e97b3e40743b02b8$export$13098dd2211fc557 = {
    kernelName: (0, $dCP8m.Multiply),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = (0, $eqTIO.assertAndGetBroadcastShape)(a.shape, b.shape);
        const derA = ()=>{
            const res = (0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)(b, 'float32'));
            const reduceAxes = (0, $eqTIO.getReductionAxes)(a.shape, outShape);
            if (reduceAxes.length > 0) return (0, $eP0pM.reshape)((0, $fVwnn.sum)(res, reduceAxes), a.shape);
            return res;
        };
        const derB = ()=>{
            const res = (0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)(a, 'float32'));
            const reduceAxes = (0, $eqTIO.getReductionAxes)(b.shape, outShape);
            if (reduceAxes.length > 0) return (0, $eP0pM.reshape)((0, $fVwnn.sum)(res, reduceAxes), b.shape);
            return res;
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("aV12x", function(module, exports) {

$parcel$export(module.exports, "negGradConfig", () => $7f3008c16d5a03ca$export$9c8adee9ba64cfc3);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $ifge7 = parcelRequire("ifge7");
const $7f3008c16d5a03ca$export$9c8adee9ba64cfc3 = {
    kernelName: (0, $dCP8m.Neg),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $ifge7.neg)(dy)
        };
    }
};

});

parcelRegister("2Tx48", function(module, exports) {

$parcel$export(module.exports, "oneHotGradConfig", () => $21ba5df608df3db4$export$fec82556b8ba1992);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7KCJq = parcelRequire("7KCJq");
const $21ba5df608df3db4$export$fec82556b8ba1992 = {
    kernelName: (0, $dCP8m.OneHot),
    inputsToSave: [
        'indices'
    ],
    gradFunc: (dy, saved)=>{
        const indices = saved[0];
        return {
            indices: ()=>(0, $7KCJq.zeros)(indices.shape, 'float32')
        };
    }
};

});

parcelRegister("eXfzX", function(module, exports) {

$parcel$export(module.exports, "onesLikeGradConfig", () => $ae32a90e6cd520d8$export$693d483aaf035f85);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $ae32a90e6cd520d8$export$693d483aaf035f85 = {
    kernelName: (0, $dCP8m.OnesLike),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $k1Ozi.zerosLike)(dy)
        };
    }
};

});

parcelRegister("8g7Fg", function(module, exports) {

$parcel$export(module.exports, "packGradConfig", () => $018d4116160da736$export$2deaaffbc5347dbd);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $kDeMO = parcelRequire("kDeMO");
const $018d4116160da736$export$2deaaffbc5347dbd = {
    kernelName: (0, $dCP8m.Pack),
    saveAllInputs: true,
    gradFunc: (dy, saved, attrs)=>{
        const { axis: axis } = attrs;
        const derTensors = (0, $kDeMO.unstack)(dy, axis);
        return derTensors.map((t)=>()=>t);
    }
};

});

parcelRegister("lYpYr", function(module, exports) {

$parcel$export(module.exports, "padV2GradConfig", () => $fff35973b57e4c74$export$beb610947bf972b5);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $kvpGg = parcelRequire("kvpGg");
const $fff35973b57e4c74$export$beb610947bf972b5 = {
    kernelName: (0, $dCP8m.PadV2),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        // Pad introduces values around the original tensor, so the gradient
        // slices the original shape out of the gradient.
        const x = saved[0];
        const { paddings: paddings } = attrs;
        const begin = paddings.map((p)=>p[0]);
        return {
            x: ()=>(0, $kvpGg.slice)(dy, begin, x.shape)
        };
    }
};

});

parcelRegister("1AfxD", function(module, exports) {

$parcel$export(module.exports, "powGradConfig", () => $12753572fcab3c69$export$2ca042d8bad66ff);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $eqTIO = parcelRequire("eqTIO");

var $7qWZ5 = parcelRequire("7qWZ5");

var $jUhqf = parcelRequire("jUhqf");

var $djEuh = parcelRequire("djEuh");

var $r7fN6 = parcelRequire("r7fN6");

var $5MZxP = parcelRequire("5MZxP");

var $eP0pM = parcelRequire("eP0pM");

var $j7yUF = parcelRequire("j7yUF");

var $hkR0n = parcelRequire("hkR0n");

var $fVwnn = parcelRequire("fVwnn");

var $3dRh6 = parcelRequire("3dRh6");

var $k1Ozi = parcelRequire("k1Ozi");
const $12753572fcab3c69$export$2ca042d8bad66ff = {
    kernelName: (0, $dCP8m.Pow),
    inputsToSave: [
        'a',
        'b'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [a, b, y] = saved;
        const base = a;
        const exp = b;
        const outShape = $eqTIO.assertAndGetBroadcastShape(base.shape, exp.shape);
        const derBase = ()=>{
            const expFloat = (0, $7qWZ5.cast)(exp, 'float32');
            let res = (0, $r7fN6.mul)(dy, (0, $r7fN6.mul)(expFloat, (0, $5MZxP.pow)(base, (0, $hkR0n.sub)(expFloat, (0, $j7yUF.scalar)(1)))));
            const reduceAxes = $eqTIO.getReductionAxes(base.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fVwnn.sum)(res, reduceAxes);
            return (0, $eP0pM.reshape)(res, base.shape);
        };
        const derExp = ()=>{
            const condition = (0, $jUhqf.greater)(base, 0);
            const logBase = (0, $3dRh6.where)(condition, (0, $djEuh.log)(base), (0, $k1Ozi.zerosLike)(base));
            let res = (0, $r7fN6.mul)(dy, (0, $r7fN6.mul)(y, logBase));
            const reduceAxes = $eqTIO.getReductionAxes(exp.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fVwnn.sum)(res, reduceAxes);
            return (0, $eP0pM.reshape)(res, exp.shape);
        };
        return {
            a: derBase,
            b: derExp
        };
    }
};

});

parcelRegister("3O3Uj", function(module, exports) {

$parcel$export(module.exports, "preluGradConfig", () => $2c59128679f1725a$export$737d9f7a914424e7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $eqTIO = parcelRequire("eqTIO");

var $jUhqf = parcelRequire("jUhqf");

var $r7fN6 = parcelRequire("r7fN6");

var $eP0pM = parcelRequire("eP0pM");

var $fVwnn = parcelRequire("fVwnn");

var $3dRh6 = parcelRequire("3dRh6");

var $k1Ozi = parcelRequire("k1Ozi");
const $2c59128679f1725a$export$737d9f7a914424e7 = {
    kernelName: (0, $dCP8m.Prelu),
    inputsToSave: [
        'x',
        'alpha'
    ],
    gradFunc: (dy, saved)=>{
        const [x, alpha] = saved;
        const mask = (0, $jUhqf.greater)(x, 0);
        return {
            x: ()=>(0, $3dRh6.where)(mask, dy, (0, $r7fN6.mul)(dy, alpha)),
            alpha: ()=>{
                let res = (0, $3dRh6.where)(mask, (0, $k1Ozi.zerosLike)(dy), (0, $r7fN6.mul)(dy, x));
                const reduceAxes = (0, $eqTIO.getReductionAxes)(alpha.shape, dy.shape);
                if (reduceAxes.length > 0) res = (0, $fVwnn.sum)(res, reduceAxes);
                return (0, $eP0pM.reshape)(res, alpha.shape);
            }
        };
    }
};

});

parcelRegister("6YeNK", function(module, exports) {

$parcel$export(module.exports, "prodGradConfig", () => $5133d3e97b4afd27$export$18b8f1986a9cc9fb);
/**
 * @license
 * Copyright 2022 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $lkN62 = parcelRequire("lkN62");

var $dCP8m = parcelRequire("dCP8m");

var $hlDAs = parcelRequire("hlDAs");

var $r7fN6 = parcelRequire("r7fN6");

var $eP0pM = parcelRequire("eP0pM");

var $9PEYs = parcelRequire("9PEYs");
// Gradient for product operation on a single axis.
function $5133d3e97b4afd27$var$prodGradFn_(x, dy, axis) {
    // The gradient tensor (dy) has a set of axes removed, so we create re-shaped
    // versions (of size 1) for the removed axis; this supports broadcasting over
    // those dimensions.
    const expandedYShape = x.shape.slice();
    expandedYShape[axis] = 1;
    // The actual gradient computation.
    const expandedDy = (0, $eP0pM.reshape)(dy, expandedYShape);
    const xCumProd = (0, $hlDAs.cumprod)(x, axis, true, false);
    const xCumRevProd = (0, $hlDAs.cumprod)(x, axis, true, true);
    const dx = (0, $r7fN6.mul)(xCumProd, xCumRevProd);
    return (0, $r7fN6.mul)(expandedDy, dx);
}
// Support gradients when the product is done on many axes at once.
// This done py pushing all the axes on which the product is applied into a
// single axis.
function $5133d3e97b4afd27$var$prodsGradFn_(x, dy, axis) {
    // Move all axes for doing prod over to the end of the tensor.
    const xRank = x.shape.length;
    const finalProdAxis = xRank - axis.length;
    const xPermutation = (0, $lkN62).getAxesPermutation(axis, xRank);
    let permutedX = x;
    if (xPermutation != null) permutedX = (0, $9PEYs.transpose)(x, xPermutation);
    // Reshape all the prod dimensions into a single one, and do compute prod
    // gradients on that.
    const newShape = permutedX.shape.slice();
    const removedShape = newShape.splice(xRank - axis.length, axis.length);
    const endPartShape = removedShape.reduce((p, c)=>p * c, 1);
    newShape.push(endPartShape);
    const reshapedPermutedX = permutedX.reshape(newShape);
    let prodGrad = $5133d3e97b4afd27$var$prodGradFn_(reshapedPermutedX, dy, finalProdAxis);
    // Undo the re-shaping now we have the dx vector, and permute back to
    // original axes order.
    prodGrad = prodGrad.reshape(permutedX.shape);
    if (xPermutation != null) {
        const undoPermutation = (0, $lkN62).getUndoAxesPermutation(xPermutation);
        prodGrad = (0, $9PEYs.transpose)(prodGrad, undoPermutation);
    }
    return prodGrad;
}
const $5133d3e97b4afd27$export$18b8f1986a9cc9fb = {
    kernelName: (0, $dCP8m.Prod),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { axis: axis } = attrs;
        let axisArr = [];
        if (axis === undefined || axis === null) axisArr = x.shape.map((_, i)=>i);
        else if (typeof axis === 'number') axisArr = [
            axis
        ];
        else axisArr = axis;
        return {
            x: ()=>$5133d3e97b4afd27$var$prodsGradFn_(x, dy, axisArr)
        };
    }
};

});

parcelRegister("MylSu", function(module, exports) {

$parcel$export(module.exports, "divGradConfig", () => $091f215ff63bddf8$export$9c51f12fdbfaf1a1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $eqTIO = parcelRequire("eqTIO");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gjFWY = parcelRequire("gjFWY");

var $r7fN6 = parcelRequire("r7fN6");

var $ifge7 = parcelRequire("ifge7");

var $eP0pM = parcelRequire("eP0pM");

var $gqriC = parcelRequire("gqriC");

var $fVwnn = parcelRequire("fVwnn");
const $091f215ff63bddf8$export$9c51f12fdbfaf1a1 = {
    kernelName: (0, $dCP8m.RealDiv),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = $eqTIO.assertAndGetBroadcastShape(a.shape, b.shape);
        const derA = ()=>{
            const res = (0, $gjFWY.div)(dy, (0, $7qWZ5.cast)(b, 'float32'));
            const reduceAxes = $eqTIO.getReductionAxes(a.shape, outShape);
            if (reduceAxes.length > 0) return (0, $eP0pM.reshape)((0, $fVwnn.sum)(res, reduceAxes), a.shape);
            return res;
        };
        const derB = ()=>{
            let res = (0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)(a, 'float32'));
            const reduceAxes = $eqTIO.getReductionAxes(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $eP0pM.reshape)((0, $fVwnn.sum)(res, reduceAxes), b.shape);
            const tmp = (0, $gqriC.square)(b);
            return (0, $ifge7.neg)((0, $gjFWY.div)(res, (0, $7qWZ5.cast)(tmp, 'float32')));
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("afXhY", function(module, exports) {

$parcel$export(module.exports, "reciprocalGradConfig", () => $77794b9e4c527b21$export$ae80392febfc338b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $gjFWY = parcelRequire("gjFWY");

var $ifge7 = parcelRequire("ifge7");

var $gqriC = parcelRequire("gqriC");
const $77794b9e4c527b21$export$ae80392febfc338b = {
    kernelName: (0, $dCP8m.Reciprocal),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $gjFWY.div)(dy, (0, $ifge7.neg)((0, $gqriC.square)(x)))
        };
    }
};

});

parcelRegister("5VvQZ", function(module, exports) {

$parcel$export(module.exports, "relu6GradConfig", () => $450afc1f1bfaa6ff$export$41de35156decb8c9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $eXGUa = parcelRequire("eXGUa");

var $r7fN6 = parcelRequire("r7fN6");

var $4s2sX = parcelRequire("4s2sX");
const $450afc1f1bfaa6ff$export$41de35156decb8c9 = {
    kernelName: (0, $dCP8m.Relu6),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        const mask = (0, $r7fN6.mul)((0, $eXGUa.lessEqual)(x, 6), (0, $4s2sX.step)(x));
        return {
            x: ()=>(0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)(mask, 'float32'))
        };
    }
};

});

parcelRegister("fkjLo", function(module, exports) {

$parcel$export(module.exports, "reluGradConfig", () => $b2880ddd8dd7fd18$export$a206627c8f00ffd0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $r7fN6 = parcelRequire("r7fN6");

var $4s2sX = parcelRequire("4s2sX");
const $b2880ddd8dd7fd18$export$a206627c8f00ffd0 = {
    kernelName: (0, $dCP8m.Relu),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)((0, $4s2sX.step)(x), 'float32'))
        };
    }
};

});

parcelRegister("lGH4O", function(module, exports) {

$parcel$export(module.exports, "reshapeGradConfig", () => $fc9eef5b7f04fc99$export$24950d669898f1bd);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $eP0pM = parcelRequire("eP0pM");
const $fc9eef5b7f04fc99$export$24950d669898f1bd = {
    kernelName: (0, $dCP8m.Reshape),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $eP0pM.reshape)(dy, x.shape)
        };
    }
};

});

parcelRegister("iqDno", function(module, exports) {

$parcel$export(module.exports, "resizeBilinearGradConfig", () => $d6a9330a4c008555$export$51f84ca614e84763);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");
const $d6a9330a4c008555$export$51f84ca614e84763 = {
    kernelName: (0, $dCP8m.ResizeBilinear),
    inputsToSave: [
        'images'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [images] = saved;
        const inputs = {
            dy: dy,
            images: images
        };
        const imagesDer = ()=>// tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.ResizeBilinearGrad), inputs, attrs);
        return {
            images: imagesDer
        };
    }
};

});

parcelRegister("6BSSD", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighborGradConfig", () => $4d00c4dabae2d8b6$export$2b08d810b5090fe1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aHfUM = parcelRequire("aHfUM");

var $dCP8m = parcelRequire("dCP8m");
const $4d00c4dabae2d8b6$export$2b08d810b5090fe1 = {
    kernelName: (0, $dCP8m.ResizeNearestNeighbor),
    inputsToSave: [
        'images'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [images] = saved;
        const inputs = {
            dy: dy,
            images: images
        };
        const imagesDer = ()=>// tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $aHfUM.ENGINE).runKernel((0, $dCP8m.ResizeNearestNeighborGrad), inputs, attrs);
        return {
            images: imagesDer
        };
    }
};

});

parcelRegister("bzPRl", function(module, exports) {

$parcel$export(module.exports, "reverseGradConfig", () => $86db30c9ef1033da$export$f990078b2a817279);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $do1MK = parcelRequire("do1MK");

var $4tCOB = parcelRequire("4tCOB");
const $86db30c9ef1033da$export$f990078b2a817279 = {
    kernelName: (0, $dCP8m.Reverse),
    gradFunc: (dy, saved, attrs)=>{
        const { dims: dims } = attrs;
        const axes = (0, $4tCOB.parseAxisParam)(dims, dy.shape);
        return {
            x: ()=>(0, $do1MK.reverse)(dy, axes)
        };
    }
};

});

parcelRegister("2ujxj", function(module, exports) {

$parcel$export(module.exports, "roundGradConfig", () => $1cfd8997ac095b11$export$f26d18fb6c60d7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $1cfd8997ac095b11$export$f26d18fb6c60d7 = {
    kernelName: (0, $dCP8m.Round),
    gradFunc: (dy)=>{
        // TODO(nsthorat): Let gradients be null for cases where we want to stop
        // backpropgation.
        return {
            x: ()=>(0, $k1Ozi.zerosLike)(dy)
        };
    }
};

});

parcelRegister("lB3rm", function(module, exports) {

$parcel$export(module.exports, "rsqrtGradConfig", () => $fb8fb8dbb3fc207a$export$925fbc88de33c42d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $gjFWY = parcelRequire("gjFWY");

var $r7fN6 = parcelRequire("r7fN6");

var $ifge7 = parcelRequire("ifge7");

var $5MZxP = parcelRequire("5MZxP");
const $fb8fb8dbb3fc207a$export$925fbc88de33c42d = {
    kernelName: (0, $dCP8m.Rsqrt),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $ifge7.neg)((0, $gjFWY.div)(dy, (0, $r7fN6.mul)((0, $5MZxP.pow)(x, 1.5), 2)))
        };
    }
};

});

parcelRegister("3ovfU", function(module, exports) {

$parcel$export(module.exports, "selectGradConfig", () => $278bdbacc3a9b31e$export$b017819c6a2a1f57);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $ifcdf = parcelRequire("ifcdf");

var $r7fN6 = parcelRequire("r7fN6");

var $k1Ozi = parcelRequire("k1Ozi");
const $278bdbacc3a9b31e$export$b017819c6a2a1f57 = {
    kernelName: (0, $dCP8m.Select),
    inputsToSave: [
        'condition'
    ],
    gradFunc: (dy, saved)=>{
        const [condition] = saved;
        return {
            // TODO(julianoks): Return null for condition gradient
            // when backprop supports it.
            condition: ()=>(0, $7qWZ5.cast)((0, $k1Ozi.zerosLike)(condition), 'float32'),
            t: ()=>(0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)(condition, dy.dtype)),
            e: ()=>(0, $r7fN6.mul)(dy, (0, $7qWZ5.cast)((0, $ifcdf.logicalNot)(condition), dy.dtype))
        };
    }
};

});

parcelRegister("g5UmC", function(module, exports) {

$parcel$export(module.exports, "seluGradConfig", () => $bb78d5a2e5ca1971$export$e1936da196fc058a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $4NGnB = parcelRequire("4NGnB");

var $jUhqf = parcelRequire("jUhqf");

var $r7fN6 = parcelRequire("r7fN6");

var $j7yUF = parcelRequire("j7yUF");

var $b8vU7 = parcelRequire("b8vU7");

var $3dRh6 = parcelRequire("3dRh6");
const $bb78d5a2e5ca1971$export$e1936da196fc058a = {
    kernelName: (0, $dCP8m.Selu),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>{
                const mask = (0, $jUhqf.greater)(x, (0, $j7yUF.scalar)(0));
                const scaleAlpha = (0, $j7yUF.scalar)((0, $b8vU7.SELU_SCALEALPHA));
                const scale = (0, $j7yUF.scalar)((0, $b8vU7.SELU_SCALE));
                const greaterThanZeroDer = (0, $r7fN6.mul)(dy, scale);
                const lessEqualZeroDer = (0, $r7fN6.mul)((0, $r7fN6.mul)(dy, scaleAlpha), (0, $4NGnB.exp)((0, $7qWZ5.cast)(x, 'float32')));
                return (0, $3dRh6.where)(mask, greaterThanZeroDer, lessEqualZeroDer);
            }
        };
    }
};

});

parcelRegister("aqPPP", function(module, exports) {

$parcel$export(module.exports, "sigmoidGradConfig", () => $79848a74b353afc5$export$a5acbf5a3558774b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $r7fN6 = parcelRequire("r7fN6");

var $j7yUF = parcelRequire("j7yUF");

var $hkR0n = parcelRequire("hkR0n");
const $79848a74b353afc5$export$a5acbf5a3558774b = {
    kernelName: (0, $dCP8m.Sigmoid),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [y] = saved;
        return {
            x: ()=>(0, $r7fN6.mul)(dy, (0, $r7fN6.mul)(y, (0, $hkR0n.sub)((0, $j7yUF.scalar)(1), y)))
        };
    }
};

});

parcelRegister("7fedq", function(module, exports) {

$parcel$export(module.exports, "signGradConfig", () => $5464f60a70a856d3$export$1d075457cdd4d64);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $5464f60a70a856d3$export$1d075457cdd4d64 = {
    kernelName: (0, $dCP8m.Sign),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $k1Ozi.zerosLike)(dy)
        };
    }
};

});

parcelRegister("dq6Hw", function(module, exports) {

$parcel$export(module.exports, "sinGradConfig", () => $9c52e6bc7c3f452c$export$e555a7ac73c36c03);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $hZQWd = parcelRequire("hZQWd");

var $r7fN6 = parcelRequire("r7fN6");
const $9c52e6bc7c3f452c$export$e555a7ac73c36c03 = {
    kernelName: (0, $dCP8m.Sin),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $r7fN6.mul)((0, $hZQWd.cos)((0, $7qWZ5.cast)(x, 'float32')), dy)
        };
    }
};

});

parcelRegister("8kl7J", function(module, exports) {

$parcel$export(module.exports, "sinhGradConfig", () => $610093b8234ff33d$export$441b7b34bae5ccc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $9p6CG = parcelRequire("9p6CG");

var $r7fN6 = parcelRequire("r7fN6");
const $610093b8234ff33d$export$441b7b34bae5ccc = {
    kernelName: (0, $dCP8m.Sinh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $r7fN6.mul)((0, $9p6CG.cosh)((0, $7qWZ5.cast)(x, 'float32')), dy)
        };
    }
};

});

parcelRegister("dyO2z", function(module, exports) {

$parcel$export(module.exports, "sliceGradConfig", () => $9df544586b1e10c7$export$df7b8be23ca4ae36);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $4xBxs = parcelRequire("4xBxs");

var $1KPDG = parcelRequire("1KPDG");
const $9df544586b1e10c7$export$df7b8be23ca4ae36 = {
    kernelName: (0, $dCP8m.Slice),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { begin: begin, size: size } = attrs;
        const inputShape = x.shape;
        const [begin_, size_] = (0, $1KPDG.parseSliceParams)(x, begin, size);
        // Create an Nx2 padding where the first column represents how many
        // zeros are prepended (at start) for each dimension, and the second
        // column indicates how many zeros are appended (at end).
        // The number of zeros to append is the shape of the input
        // elementwise-subtracted by both the begin vector and sizes vector.
        const paddings = [];
        for(let i = 0; i < dy.rank; i++)paddings.push([
            begin_[i],
            inputShape[i] - begin_[i] - size_[i]
        ]);
        return {
            x: ()=>(0, $4xBxs.pad)(dy, paddings)
        };
    }
};

});

parcelRegister("14d0o", function(module, exports) {

$parcel$export(module.exports, "softmaxGradConfig", () => $0c7040bae8062103$export$986b1eccb1e11659);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $r7fN6 = parcelRequire("r7fN6");

var $hkR0n = parcelRequire("hkR0n");

var $fVwnn = parcelRequire("fVwnn");
const $0c7040bae8062103$export$986b1eccb1e11659 = {
    kernelName: (0, $dCP8m.Softmax),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [y] = saved;
        const { dim: dim } = attrs;
        const keepDims = true;
        const dyTimesY = (0, $r7fN6.mul)(dy, y);
        return {
            logits: ()=>(0, $hkR0n.sub)(dyTimesY, (0, $r7fN6.mul)((0, $fVwnn.sum)(dyTimesY, [
                    dim
                ], keepDims), y))
        };
    }
};

});

parcelRegister("d1aLH", function(module, exports) {

$parcel$export(module.exports, "softplusGradConfig", () => $97a3b8b75aacc37b$export$25385fb73a9df5f0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $r7fN6 = parcelRequire("r7fN6");

var $5B3nT = parcelRequire("5B3nT");
const $97a3b8b75aacc37b$export$25385fb73a9df5f0 = {
    kernelName: (0, $dCP8m.Softplus),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $r7fN6.mul)(dy, (0, $5B3nT.sigmoid)(x))
        };
    }
};

});

parcelRegister("fLsDn", function(module, exports) {

$parcel$export(module.exports, "spaceToBatchNDGradConfig", () => $b7a174f50e7ab86e$export$384e163073b8980c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7J0of = parcelRequire("7J0of");
const $b7a174f50e7ab86e$export$384e163073b8980c = {
    kernelName: (0, $dCP8m.SpaceToBatchND),
    gradFunc: (dy, saved, attrs)=>{
        const { blockShape: blockShape, paddings: paddings } = attrs;
        return {
            x: ()=>(0, $7J0of.batchToSpaceND)(dy, blockShape, paddings)
        };
    }
};

});

parcelRegister("k4vBa", function(module, exports) {

$parcel$export(module.exports, "splitVGradConfig", () => $e9ccb12597f66310$export$4ad3bd16fe45e539);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $6LWfo = parcelRequire("6LWfo");
const $e9ccb12597f66310$export$4ad3bd16fe45e539 = {
    kernelName: (0, $dCP8m.SplitV),
    gradFunc: (dy, saved, attrs)=>{
        const { axis: axis } = attrs;
        return {
            x: ()=>(0, $6LWfo.concat)(dy, axis)
        };
    }
};

});

parcelRegister("iUeuJ", function(module, exports) {

$parcel$export(module.exports, "sqrtGradConfig", () => $dc38b34fbf9b8cff$export$e33c4e6eabff8df2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $gjFWY = parcelRequire("gjFWY");

var $r7fN6 = parcelRequire("r7fN6");

var $lGdn1 = parcelRequire("lGdn1");
const $dc38b34fbf9b8cff$export$e33c4e6eabff8df2 = {
    kernelName: (0, $dCP8m.Sqrt),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $gjFWY.div)(dy, (0, $r7fN6.mul)((0, $lGdn1.sqrt)((0, $7qWZ5.cast)(x, 'float32')), 2))
        };
    }
};

});

parcelRegister("5P3CM", function(module, exports) {

$parcel$export(module.exports, "squareGradConfig", () => $43d486e7bfbd7b1b$export$3fb060af275bf525);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $7qWZ5 = parcelRequire("7qWZ5");

var $r7fN6 = parcelRequire("r7fN6");
const $43d486e7bfbd7b1b$export$3fb060af275bf525 = {
    kernelName: (0, $dCP8m.Square),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $r7fN6.mul)(dy, (0, $r7fN6.mul)((0, $7qWZ5.cast)(x, 'float32'), 2))
        };
    }
};

});

parcelRegister("1eEg3", function(module, exports) {

$parcel$export(module.exports, "squaredDifferenceGradConfig", () => $0e6653aa01ea18fb$export$ac87edeb32ba1ce1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $r7fN6 = parcelRequire("r7fN6");

var $j7yUF = parcelRequire("j7yUF");

var $hkR0n = parcelRequire("hkR0n");
const $0e6653aa01ea18fb$export$ac87edeb32ba1ce1 = {
    kernelName: (0, $dCP8m.SquaredDifference),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const two = (0, $j7yUF.scalar)(2);
        const derA = ()=>(0, $r7fN6.mul)(dy, (0, $r7fN6.mul)(two, (0, $hkR0n.sub)(a, b)));
        const derB = ()=>(0, $r7fN6.mul)(dy, (0, $r7fN6.mul)(two, (0, $hkR0n.sub)(b, a)));
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("BY2Tn", function(module, exports) {

$parcel$export(module.exports, "stepGradConfig", () => $072208a19f37dee4$export$51a8fd534d085770);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $072208a19f37dee4$export$51a8fd534d085770 = {
    kernelName: (0, $dCP8m.Step),
    gradFunc: (dy)=>{
        // TODO(manrajgrover): Return null for gradients when backprop supports
        // it.
        return {
            x: ()=>(0, $k1Ozi.zerosLike)(dy)
        };
    }
};

});

parcelRegister("gLg7J", function(module, exports) {

$parcel$export(module.exports, "subGradConfig", () => $c33d8af1fe929454$export$7fa26ec41cd14ac);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $eqTIO = parcelRequire("eqTIO");

var $ifge7 = parcelRequire("ifge7");

var $eP0pM = parcelRequire("eP0pM");

var $fVwnn = parcelRequire("fVwnn");
const $c33d8af1fe929454$export$7fa26ec41cd14ac = {
    kernelName: (0, $dCP8m.Sub),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = $eqTIO.assertAndGetBroadcastShape(a.shape, b.shape);
        const derA = ()=>{
            let res = dy;
            const reduceAxes = $eqTIO.getReductionAxes(a.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fVwnn.sum)(res, reduceAxes);
            return (0, $eP0pM.reshape)(res, a.shape);
        };
        const derB = ()=>{
            let res = dy;
            const reduceAxes = $eqTIO.getReductionAxes(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fVwnn.sum)(res, reduceAxes);
            return (0, $eP0pM.reshape)((0, $ifge7.neg)(res), b.shape);
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("9SGk3", function(module, exports) {

$parcel$export(module.exports, "sumGradConfig", () => $7319fc94e7db68a9$export$5b5372b406109dcd);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $r7fN6 = parcelRequire("r7fN6");

var $bhi4b = parcelRequire("bhi4b");

var $eP0pM = parcelRequire("eP0pM");

var $4tCOB = parcelRequire("4tCOB");
const $7319fc94e7db68a9$export$5b5372b406109dcd = {
    kernelName: (0, $dCP8m.Sum),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const expandedDyShape = x.shape.slice();
        const { axis: axis } = attrs;
        const axes = (0, $4tCOB.parseAxisParam)(axis, x.shape);
        axes.forEach((axis)=>{
            expandedDyShape[axis] = 1;
        });
        const expandedDy = (0, $eP0pM.reshape)(dy, expandedDyShape);
        const derX = (0, $r7fN6.mul)(expandedDy, (0, $bhi4b.ones)(x.shape, 'float32'));
        return {
            x: ()=>derX
        };
    }
};

});

parcelRegister("7O3L6", function(module, exports) {

$parcel$export(module.exports, "tanGradConfig", () => $5af01e54a23e6820$export$26050e3e7c704591);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $hZQWd = parcelRequire("hZQWd");

var $gjFWY = parcelRequire("gjFWY");

var $gqriC = parcelRequire("gqriC");
const $5af01e54a23e6820$export$26050e3e7c704591 = {
    kernelName: (0, $dCP8m.Tan),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $gjFWY.div)(dy, (0, $gqriC.square)((0, $hZQWd.cos)(x)))
        };
    }
};

});

parcelRegister("1nDjz", function(module, exports) {

$parcel$export(module.exports, "tanhGradConfig", () => $10166f7b25fecfa5$export$50a7f4d5b41706bd);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $r7fN6 = parcelRequire("r7fN6");

var $j7yUF = parcelRequire("j7yUF");

var $gqriC = parcelRequire("gqriC");

var $hkR0n = parcelRequire("hkR0n");
const $10166f7b25fecfa5$export$50a7f4d5b41706bd = {
    kernelName: (0, $dCP8m.Tanh),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [y] = saved;
        return {
            x: ()=>(0, $r7fN6.mul)((0, $hkR0n.sub)((0, $j7yUF.scalar)(1), (0, $gqriC.square)(y)), dy)
        };
    }
};

});

parcelRegister("cd7YP", function(module, exports) {

$parcel$export(module.exports, "tileGradConfig", () => $8e3ce398559ac6a5$export$fd5cce480fa5176f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $1ZrG5 = parcelRequire("1ZrG5");

var $kvpGg = parcelRequire("kvpGg");

var $k1Ozi = parcelRequire("k1Ozi");
const $8e3ce398559ac6a5$export$fd5cce480fa5176f = {
    kernelName: (0, $dCP8m.Tile),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { reps: reps } = attrs;
        const derX = ()=>{
            let xGrad = (0, $k1Ozi.zerosLike)(x);
            // TODO(cais): Maybe reduce memory footprint by avoiding repeated
            // slicing.
            if (x.rank === 1) for(let i = 0; i < reps[0]; ++i)xGrad = (0, $1ZrG5.add)(xGrad, (0, $kvpGg.slice)(dy, [
                i * x.shape[0]
            ], [
                x.shape[0]
            ]));
            else if (x.rank === 2) {
                for(let i = 0; i < reps[0]; ++i)for(let j = 0; j < reps[1]; ++j)xGrad = (0, $1ZrG5.add)(xGrad, (0, $kvpGg.slice)(dy, [
                    i * x.shape[0],
                    j * x.shape[1]
                ], [
                    x.shape[0],
                    x.shape[1]
                ]));
            } else if (x.rank === 3) for(let i = 0; i < reps[0]; ++i){
                for(let j = 0; j < reps[1]; ++j)for(let k = 0; k < reps[2]; ++k)xGrad = (0, $1ZrG5.add)(xGrad, (0, $kvpGg.slice)(dy, [
                    i * x.shape[0],
                    j * x.shape[1],
                    k * x.shape[2]
                ], [
                    x.shape[0],
                    x.shape[1],
                    x.shape[2]
                ]));
            }
            else if (x.rank === 4) {
                for(let i = 0; i < reps[0]; ++i)for(let j = 0; j < reps[1]; ++j){
                    for(let k = 0; k < reps[2]; ++k)for(let l = 0; l < reps[3]; ++l)xGrad = (0, $1ZrG5.add)(xGrad, (0, $kvpGg.slice)(dy, [
                        i * x.shape[0],
                        j * x.shape[1],
                        k * x.shape[2],
                        l * x.shape[3]
                    ], [
                        x.shape[0],
                        x.shape[1],
                        x.shape[2],
                        x.shape[3]
                    ]));
                }
            } else throw new Error(`Gradient for tile operation is not implemented for rank-` + `${x.rank} tensors yet.`);
            return xGrad;
        };
        return {
            x: derX
        };
    }
};

});

parcelRegister("eyFzE", function(module, exports) {

$parcel$export(module.exports, "transposeGradConfig", () => $a9947d5fc9d3f513$export$c40368da30e9b1df);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $9k5Lx = parcelRequire("9k5Lx");

var $9PEYs = parcelRequire("9PEYs");
const $a9947d5fc9d3f513$export$c40368da30e9b1df = {
    kernelName: (0, $dCP8m.Transpose),
    gradFunc: (dy, saved, attrs)=>{
        const transposeAttrs = attrs;
        const { perm: perm } = transposeAttrs;
        const undoPerm = $9k5Lx.getUndoAxesPermutation(perm);
        return {
            x: ()=>(0, $9PEYs.transpose)(dy, undoPerm)
        };
    }
};

});

parcelRegister("wHeAU", function(module, exports) {

$parcel$export(module.exports, "unpackGradConfig", () => $062486b92b6d6344$export$e778502f377d32a9);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $iSKul = parcelRequire("iSKul");
const $062486b92b6d6344$export$e778502f377d32a9 = {
    kernelName: (0, $dCP8m.Unpack),
    gradFunc: (dy, saved, attrs)=>{
        const unpackAttrs = attrs;
        const { axis: axis } = unpackAttrs;
        return {
            value: ()=>(0, $iSKul.stack)(dy, axis)
        };
    }
};

});

parcelRegister("5cIWS", function(module, exports) {

$parcel$export(module.exports, "unsortedSegmentSumGradConfig", () => $3ca0f09b51c17d81$export$b02449f948377b8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $6mzQK = parcelRequire("6mzQK");

var $kiLVE = parcelRequire("kiLVE");

var $cUuWi = parcelRequire("cUuWi");

var $jtRHJ = parcelRequire("jtRHJ");

var $aW7Gb = parcelRequire("aW7Gb");

var $bhi4b = parcelRequire("bhi4b");

var $j7yUF = parcelRequire("j7yUF");

var $3dRh6 = parcelRequire("3dRh6");

var $k1Ozi = parcelRequire("k1Ozi");
const $3ca0f09b51c17d81$export$b02449f948377b8 = {
    kernelName: (0, $dCP8m.UnsortedSegmentSum),
    inputsToSave: [
        'segmentIds'
    ],
    gradFunc: (dy, saved)=>{
        const [segmentIds] = saved;
        const derX = ()=>{
            return $3ca0f09b51c17d81$var$gatherDropNegatives(dy, segmentIds);
        };
        return {
            x: derX
        };
    }
};
function $3ca0f09b51c17d81$var$gatherDropNegatives(x, indices) {
    // Helper function for unsorted segment ops. Gathers params for
    // positive segment ids and gathers 0 for inputs with negative segment id.
    // Mirrors _GatherDropNegatives from tensorflow/python/ops/math_grad.py
    const zeroClippedIndices = (0, $aW7Gb.maximum)(indices, (0, $k1Ozi.zerosLike)(indices));
    const gathered = (0, $kiLVE.gather)(x, zeroClippedIndices);
    let isPositive = (0, $cUuWi.greaterEqual)(indices, (0, $j7yUF.scalar)(0, 'int32'));
    const numIters = gathered.rank - isPositive.rank;
    for(let i = 0; i < numIters; ++i)isPositive = (0, $6mzQK.expandDims)(isPositive, i + 1);
    isPositive = (0, $jtRHJ.logicalAnd)(isPositive, (0, $bhi4b.ones)(gathered.shape, 'bool'));
    const zeroSlice = (0, $k1Ozi.zerosLike)(gathered);
    return (0, $3dRh6.where)(isPositive, gathered, zeroSlice);
}

});

parcelRegister("8qP4i", function(module, exports) {

$parcel$export(module.exports, "zerosLikeGradConfig", () => $62385d840c4dfb6d$export$33fce8206ddf321b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dCP8m = parcelRequire("dCP8m");

var $k1Ozi = parcelRequire("k1Ozi");
const $62385d840c4dfb6d$export$33fce8206ddf321b = {
    kernelName: (0, $dCP8m.ZerosLike),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $k1Ozi.zerosLike)(dy)
        };
    }
};

});


parcelRegister("l5obE", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("l1zT5");
parcelRequire("j0s6N");
parcelRequire("2k1W6");
parcelRequire("9yySn");
parcelRequire("caRhf");
parcelRequire("9Q5UN");
parcelRequire("hCOB0");
parcelRequire("2acOQ");
parcelRequire("4qiTQ");
parcelRequire("aEylD");
parcelRequire("eb9Gn");
parcelRequire("ef90g");
parcelRequire("er5pr");
parcelRequire("5XnNu");
parcelRequire("lAlCW");
parcelRequire("cQBlo");
parcelRequire("jEnIe");
parcelRequire("2jFqq");
parcelRequire("bO7YP");
parcelRequire("6Uuqx");
parcelRequire("8sRa6");
parcelRequire("8pimE");
parcelRequire("3eapo");
parcelRequire("66BBh");
parcelRequire("l75rY");
parcelRequire("ioViD");
parcelRequire("d57iO");
parcelRequire("dDnDx");
parcelRequire("kAlDI");
parcelRequire("3Y7VQ");
parcelRequire("9PaXE");
parcelRequire("dsP0W");
parcelRequire("98pkf");
parcelRequire("g6wOm");
parcelRequire("joiuP");
parcelRequire("72TYh");
parcelRequire("1qk4B");
parcelRequire("2N5ZT");
parcelRequire("kS0HR");
parcelRequire("asZW0");
parcelRequire("3IME0");
parcelRequire("8T7bI");
parcelRequire("bkAO3");
parcelRequire("lTYwF");
parcelRequire("2X3yt");
parcelRequire("6IsIM");
parcelRequire("7zB08");
parcelRequire("5HyGq");
parcelRequire("eudsc");
parcelRequire("3QlF1");
parcelRequire("hTyRP");
parcelRequire("gkTpr");
parcelRequire("h95xH");
parcelRequire("5l4Ub");
parcelRequire("DEAqV");
parcelRequire("8nLmg");
parcelRequire("gcTcI");
parcelRequire("4sx5z");
parcelRequire("lWnCu");
parcelRequire("eLoxT");
parcelRequire("a4Tbp");
parcelRequire("LkB50");
parcelRequire("7KxKB");
parcelRequire("bE2mx");
parcelRequire("b7dNS");
parcelRequire("herfJ");
parcelRequire("gh3Rq");
parcelRequire("ifAOr");
parcelRequire("1qL0E");
parcelRequire("2kz8U");
parcelRequire("2sj6m");
parcelRequire("4tyPi");
parcelRequire("6U8G7");
parcelRequire("4tP4z");
parcelRequire("jICZO");
parcelRequire("9XtmQ");
parcelRequire("3neZz");
parcelRequire("2MWel");
parcelRequire("f4t2f");
parcelRequire("hr38g");
parcelRequire("3yv9D");
parcelRequire("ehCSY");
parcelRequire("jWUw5");
parcelRequire("9vLxU");
parcelRequire("6wrVV");
parcelRequire("ifV4J");
parcelRequire("l8C7q");
parcelRequire("4Gtcz");
parcelRequire("iInvb");
parcelRequire("5Vsuq");
parcelRequire("10WAQ");
parcelRequire("f4Plq");
parcelRequire("l0mmJ");
parcelRequire("cNC8G");
parcelRequire("gCA0G");
parcelRequire("7H6EJ");
parcelRequire("kK36M");
parcelRequire("eKHCA");
parcelRequire("eEl7k");
parcelRequire("iEov5");
parcelRequire("BAS4D");
parcelRequire("1grRL");
parcelRequire("c2Eez");
parcelRequire("2bm29");
parcelRequire("cE08D");
parcelRequire("8NrTa");
parcelRequire("h50xi");
parcelRequire("c8sAG");
parcelRequire("l2TTJ");
parcelRequire("6PPNy");
parcelRequire("yzmTi");
parcelRequire("kEukz");
parcelRequire("bzPgc");
parcelRequire("imHgK");
parcelRequire("f5oge");
parcelRequire("6PNJs");
parcelRequire("9cbEd");
parcelRequire("3LUl3");
parcelRequire("4JbWM");
parcelRequire("37iBh");
parcelRequire("lRFOz");
parcelRequire("hln7v");
parcelRequire("9vljv");
parcelRequire("2rgO3");
parcelRequire("5jtDX");
parcelRequire("6n6wN");
parcelRequire("cHPhm");
parcelRequire("6shzE");
parcelRequire("hXLy3");
parcelRequire("8epsx");
parcelRequire("4U1KE");
parcelRequire("6DoKm");
parcelRequire("9VtK7");
parcelRequire("aLvQj");
parcelRequire("gqbs8");
parcelRequire("3v5UT");
parcelRequire("evl50");

});
parcelRegister("l1zT5", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $6oc11 = parcelRequire("6oc11");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.abs = function() {
    this.throwIfDisposed();
    return (0, $6oc11.abs)(this);
};

});

parcelRegister("j0s6N", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $8XlSR = parcelRequire("8XlSR");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.acos = function() {
    this.throwIfDisposed();
    return (0, $8XlSR.acos)(this);
};

});

parcelRegister("2k1W6", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $9dYpT = parcelRequire("9dYpT");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.acosh = function() {
    this.throwIfDisposed();
    return (0, $9dYpT.acosh)(this);
};

});

parcelRegister("9yySn", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1ZrG5 = parcelRequire("1ZrG5");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.add = function(b) {
    this.throwIfDisposed();
    return (0, $1ZrG5.add)(this, b);
};

});

parcelRegister("caRhf", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $br27u = parcelRequire("br27u");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.all = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $br27u.all)(this, axis, keepDims);
};

});

parcelRegister("9Q5UN", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $joFjq = parcelRequire("joFjq");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.any = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $joFjq.any)(this, axis, keepDims);
};

});

parcelRegister("hCOB0", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $iFZ6U = parcelRequire("iFZ6U");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.argMax = function(axis) {
    this.throwIfDisposed();
    return (0, $iFZ6U.argMax)(this, axis);
};

});

parcelRegister("2acOQ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $kXTu8 = parcelRequire("kXTu8");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.argMin = function(axis) {
    this.throwIfDisposed();
    return (0, $kXTu8.argMin)(this, axis);
};

});

parcelRegister("4qiTQ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eP0pM = parcelRequire("eP0pM");

var $bVnU9 = parcelRequire("bVnU9");

var $4tCOB = parcelRequire("4tCOB");
/**
 * Converts a size-1 `tf.Tensor` to a `tf.Scalar`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $bVnU9.getGlobalTensorClass)().prototype.asScalar = function() {
    this.throwIfDisposed();
    (0, $4tCOB.assert)(this.size === 1, ()=>'The array must have only 1 element.');
    return (0, $eP0pM.reshape)(this, []);
};

});

parcelRegister("aEylD", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $7qWZ5 = parcelRequire("7qWZ5");

var $bVnU9 = parcelRequire("bVnU9");
/**
 * Casts a `tf.Tensor` to a specified dtype.
 *
 * @param dtype Data-type to cast the tensor to.
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $bVnU9.getGlobalTensorClass)().prototype.asType = function(dtype) {
    this.throwIfDisposed();
    return (0, $7qWZ5.cast)(this, dtype);
};

});

parcelRegister("eb9Gn", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eP0pM = parcelRequire("eP0pM");

var $bVnU9 = parcelRequire("bVnU9");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor1D`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $bVnU9.getGlobalTensorClass)().prototype.as1D = function() {
    this.throwIfDisposed();
    return (0, $eP0pM.reshape)(this, [
        this.size
    ]);
};

});

parcelRegister("ef90g", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eP0pM = parcelRequire("eP0pM");

var $bVnU9 = parcelRequire("bVnU9");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor2D`.
 *
 * @param rows Number of rows in `tf.Tensor2D`.
 * @param columns Number of columns in `tf.Tensor2D`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $bVnU9.getGlobalTensorClass)().prototype.as2D = function(rows, columns) {
    this.throwIfDisposed();
    return (0, $eP0pM.reshape)(this, [
        rows,
        columns
    ]);
};

});

parcelRegister("er5pr", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eP0pM = parcelRequire("eP0pM");

var $bVnU9 = parcelRequire("bVnU9");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor3D`.
 *
 * @param rows Number of rows in `tf.Tensor3D`.
 * @param columns Number of columns in `tf.Tensor3D`.
 * @param depth Depth of `tf.Tensor3D`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $bVnU9.getGlobalTensorClass)().prototype.as3D = function(rows, columns, depth) {
    this.throwIfDisposed();
    return (0, $eP0pM.reshape)(this, [
        rows,
        columns,
        depth
    ]);
};

});

parcelRegister("5XnNu", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eP0pM = parcelRequire("eP0pM");

var $bVnU9 = parcelRequire("bVnU9");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor4D`.
 *
 * @param rows Number of rows in `tf.Tensor4D`.
 * @param columns Number of columns in `tf.Tensor4D`.
 * @param depth Depth of `tf.Tensor4D`.
 * @param depth2 4th dimension of `tf.Tensor4D`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $bVnU9.getGlobalTensorClass)().prototype.as4D = function(rows, columns, depth, depth2) {
    this.throwIfDisposed();
    return (0, $eP0pM.reshape)(this, [
        rows,
        columns,
        depth,
        depth2
    ]);
};

});

parcelRegister("lAlCW", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eP0pM = parcelRequire("eP0pM");

var $bVnU9 = parcelRequire("bVnU9");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor5D`.
 *
 * @param rows Number of rows in `tf.Tensor5D`.
 * @param columns Number of columns in `tf.Tensor5D`.
 * @param depth Depth of `tf.Tensor5D`.
 * @param depth2 4th dimension of `tf.Tensor5D`.
 * @param depth3 5th dimension of 'tf.Tensor5D'
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $bVnU9.getGlobalTensorClass)().prototype.as5D = function(rows, columns, depth, depth2, depth3) {
    this.throwIfDisposed();
    return (0, $eP0pM.reshape)(this, [
        rows,
        columns,
        depth,
        depth2,
        depth3
    ]);
};

});

parcelRegister("cQBlo", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $13fQN = parcelRequire("13fQN");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.asin = function() {
    this.throwIfDisposed();
    return (0, $13fQN.asin)(this);
};

});

parcelRegister("jEnIe", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $4RKl9 = parcelRequire("4RKl9");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.asinh = function() {
    this.throwIfDisposed();
    return (0, $4RKl9.asinh)(this);
};

});

parcelRegister("2jFqq", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $jiLKp = parcelRequire("jiLKp");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.atan = function() {
    this.throwIfDisposed();
    return (0, $jiLKp.atan)(this);
};

});

parcelRegister("bO7YP", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $f4jET = parcelRequire("f4jET");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.atan2 = function(b) {
    this.throwIfDisposed();
    return (0, $f4jET.atan2)(this, b);
};

});

parcelRegister("6Uuqx", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $2HRHM = parcelRequire("2HRHM");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.atanh = function() {
    this.throwIfDisposed();
    return (0, $2HRHM.atanh)(this);
};

});

parcelRegister("8sRa6", function(module, exports) {

var $jqmHD = parcelRequire("jqmHD");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.avgPool = function(filterSize, strides, pad, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $jqmHD.avgPool)(this, filterSize, strides, pad, dimRoundingMode);
};

});

parcelRegister("8pimE", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7J0of = parcelRequire("7J0of");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.batchToSpaceND = function(blockShape, crops) {
    this.throwIfDisposed();
    return (0, $7J0of.batchToSpaceND)(this, blockShape, crops);
};

});

parcelRegister("3eapo", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $vnJKw = parcelRequire("vnJKw");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.batchNorm = function(mean, variance, offset, scale, varianceEpsilon) {
    this.throwIfDisposed();
    return (0, $vnJKw.batchNorm)(this, mean, variance, offset, scale, varianceEpsilon);
};

});

parcelRegister("66BBh", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eJSTd = parcelRequire("eJSTd");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.broadcastTo = function(shape) {
    this.throwIfDisposed();
    return (0, $eJSTd.broadcastTo)(this, shape);
};

});

parcelRegister("l75rY", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $7qWZ5 = parcelRequire("7qWZ5");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.cast = function(dtype) {
    this.throwIfDisposed();
    return (0, $7qWZ5.cast)(this, dtype);
};

});

parcelRegister("ioViD", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $hoXwH = parcelRequire("hoXwH");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.ceil = function() {
    this.throwIfDisposed();
    return (0, $hoXwH.ceil)(this);
};

});

parcelRegister("d57iO", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $jU3Ej = parcelRequire("jU3Ej");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.clipByValue = function(min, max) {
    this.throwIfDisposed();
    return (0, $jU3Ej.clipByValue)(this, min, max);
};

});

parcelRegister("dDnDx", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6LWfo = parcelRequire("6LWfo");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.concat = function(x, axis) {
    this.throwIfDisposed();
    if (x instanceof (0, $bVnU9.Tensor)) x = [
        x
    ];
    return (0, $6LWfo.concat)([
        this,
        ...x
    ], axis);
};

});

parcelRegister("kAlDI", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $a6dzP = parcelRequire("a6dzP");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.conv1d = function(filter, stride, pad, dataFormat, dilation, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $a6dzP.conv1d)(this, filter, stride, pad, dataFormat, dilation, dimRoundingMode);
};

});

parcelRegister("3Y7VQ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $cKiMT = parcelRequire("cKiMT");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.conv2dTranspose = function(filter, outputShape, strides, pad, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $cKiMT.conv2dTranspose)(this, filter, outputShape, strides, pad, dimRoundingMode);
};

});

parcelRegister("9PaXE", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jOBWR = parcelRequire("jOBWR");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.conv2d = function(filter, strides, pad, dataFormat, dilations, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $jOBWR.conv2d)(this, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
};

});

parcelRegister("dsP0W", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $hZQWd = parcelRequire("hZQWd");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.cos = function() {
    this.throwIfDisposed();
    return (0, $hZQWd.cos)(this);
};

});

parcelRegister("98pkf", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $9p6CG = parcelRequire("9p6CG");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.cosh = function() {
    this.throwIfDisposed();
    return (0, $9p6CG.cosh)(this);
};

});

parcelRegister("g6wOm", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hlDAs = parcelRequire("hlDAs");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.cumprod = function(axis, exclusive, reverse) {
    this.throwIfDisposed();
    return (0, $hlDAs.cumprod)(this, axis, exclusive, reverse);
};

});

parcelRegister("joiuP", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6nQJI = parcelRequire("6nQJI");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.cumsum = function(axis, exclusive, reverse) {
    this.throwIfDisposed();
    return (0, $6nQJI.cumsum)(this, axis, exclusive, reverse);
};

});

parcelRegister("72TYh", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7Maa1 = parcelRequire("7Maa1");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.depthToSpace = function(blockSize, dataFormat) {
    this.throwIfDisposed();
    return (0, $7Maa1.depthToSpace)(this, blockSize, dataFormat);
};

});

parcelRegister("1qk4B", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $kDOuZ = parcelRequire("kDOuZ");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.depthwiseConv2d = function(filter, strides, pad, dataFormat, dilations, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $kDOuZ.depthwiseConv2d)(this, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
};

});

parcelRegister("2N5ZT", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $cPcCM = parcelRequire("cPcCM");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.dilation2d = function(filter, strides, pad, dilations, dataFormat) {
    this.throwIfDisposed();
    return (0, $cPcCM.dilation2d)(this, filter, strides, pad, dilations, dataFormat);
};

});

parcelRegister("kS0HR", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fFAAa = parcelRequire("fFAAa");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.divNoNan = function(b) {
    this.throwIfDisposed();
    return (0, $fFAAa.divNoNan)(this, b);
};

});

parcelRegister("asZW0", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $gjFWY = parcelRequire("gjFWY");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.div = function(b) {
    this.throwIfDisposed();
    return (0, $gjFWY.div)(this, b);
};

});

parcelRegister("3IME0", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8RVHb = parcelRequire("8RVHb");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.dot = function(b) {
    this.throwIfDisposed();
    return (0, $8RVHb.dot)(this, b);
};

});

parcelRegister("8T7bI", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aYszp = parcelRequire("aYszp");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.elu = function() {
    this.throwIfDisposed();
    return (0, $aYszp.elu)(this);
};

});

parcelRegister("bkAO3", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5Py3O = parcelRequire("5Py3O");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.equal = function(b) {
    this.throwIfDisposed();
    return (0, $5Py3O.equal)(this, b);
};

});

parcelRegister("lTYwF", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $44EES = parcelRequire("44EES");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.erf = function() {
    this.throwIfDisposed();
    return (0, $44EES.erf)(this);
};

});

parcelRegister("2X3yt", function(module, exports) {
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $evBPw = parcelRequire("evBPw");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.euclideanNorm = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $evBPw.euclideanNorm)(this, axis, keepDims);
};

});

parcelRegister("6IsIM", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $4NGnB = parcelRequire("4NGnB");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.exp = function() {
    this.throwIfDisposed();
    return (0, $4NGnB.exp)(this);
};

});

parcelRegister("7zB08", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6mzQK = parcelRequire("6mzQK");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.expandDims = function(axis) {
    this.throwIfDisposed();
    return (0, $6mzQK.expandDims)(this, axis);
};

});

parcelRegister("5HyGq", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $lMtcP = parcelRequire("lMtcP");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.expm1 = function() {
    this.throwIfDisposed();
    return (0, $lMtcP.expm1)(this);
};

});

parcelRegister("eudsc", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.
parcelRequire("iNZmA");
var $kY0nO = parcelRequire("kY0nO");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.fft = function() {
    this.throwIfDisposed();
    return (0, $kY0nO.fft)(this);
};

});

parcelRegister("3QlF1", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eP0pM = parcelRequire("eP0pM");

var $bVnU9 = parcelRequire("bVnU9");
/**
 * Flatten a Tensor to a 1D array.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $bVnU9.getGlobalTensorClass)().prototype.flatten = function() {
    this.throwIfDisposed();
    return (0, $eP0pM.reshape)(this, [
        this.size
    ]);
};

});

parcelRegister("hTyRP", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $hnXfr = parcelRequire("hnXfr");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.floor = function() {
    this.throwIfDisposed();
    return (0, $hnXfr.floor)(this);
};

});

parcelRegister("gkTpr", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6ktJw = parcelRequire("6ktJw");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.floorDiv = function(b) {
    this.throwIfDisposed();
    return (0, $6ktJw.floorDiv)(this, b);
};

});

parcelRegister("h95xH", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $kiLVE = parcelRequire("kiLVE");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.gather = function(indices, axis) {
    this.throwIfDisposed();
    return (0, $kiLVE.gather)(this, indices, axis);
};

});

parcelRegister("5l4Ub", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $cUuWi = parcelRequire("cUuWi");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.greaterEqual = function(b) {
    this.throwIfDisposed();
    return (0, $cUuWi.greaterEqual)(this, b);
};

});

parcelRegister("DEAqV", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jUhqf = parcelRequire("jUhqf");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.greater = function(b) {
    this.throwIfDisposed();
    return (0, $jUhqf.greater)(this, b);
};

});

parcelRegister("8nLmg", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.
parcelRequire("iNZmA");
var $jxjwy = parcelRequire("jxjwy");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.ifft = function() {
    this.throwIfDisposed();
    return (0, $jxjwy.ifft)(this);
};

});

parcelRegister("gcTcI", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.
parcelRequire("iNZmA");
var $fiSk4 = parcelRequire("fiSk4");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.irfft = function() {
    this.throwIfDisposed();
    return (0, $fiSk4.irfft)(this);
};

});

parcelRegister("4sx5z", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $63ReF = parcelRequire("63ReF");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.isFinite = function() {
    this.throwIfDisposed();
    return (0, $63ReF.isFinite)(this);
};

});

parcelRegister("lWnCu", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $bpcc2 = parcelRequire("bpcc2");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.isInf = function() {
    this.throwIfDisposed();
    return (0, $bpcc2.isInf)(this);
};

});

parcelRegister("eLoxT", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $grp09 = parcelRequire("grp09");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.isNaN = function() {
    this.throwIfDisposed();
    return (0, $grp09.isNaN)(this);
};

});

parcelRegister("a4Tbp", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8XuOv = parcelRequire("8XuOv");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.leakyRelu = function(alpha) {
    this.throwIfDisposed();
    return (0, $8XuOv.leakyRelu)(this, alpha);
};

});

parcelRegister("LkB50", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eXGUa = parcelRequire("eXGUa");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.lessEqual = function(b) {
    this.throwIfDisposed();
    return (0, $eXGUa.lessEqual)(this, b);
};

});

parcelRegister("7KxKB", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6skdg = parcelRequire("6skdg");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.less = function(b) {
    this.throwIfDisposed();
    return (0, $6skdg.less)(this, b);
};

});

parcelRegister("bE2mx", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOy3E = parcelRequire("eOy3E");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.localResponseNormalization = function(depthRadius, bias, alpha, beta) {
    this.throwIfDisposed();
    return (0, $eOy3E.localResponseNormalization)(this, depthRadius, bias, alpha, beta);
};

});

parcelRegister("b7dNS", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $Xpmxi = parcelRequire("Xpmxi");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.logSigmoid = function() {
    this.throwIfDisposed();
    return (0, $Xpmxi.logSigmoid)(this);
};

});

parcelRegister("herfJ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $1oQXI = parcelRequire("1oQXI");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.logSoftmax = function(axis) {
    this.throwIfDisposed();
    return (0, $1oQXI.logSoftmax)(this, axis);
};

});

parcelRegister("gh3Rq", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $awUAx = parcelRequire("awUAx");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.logSumExp = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $awUAx.logSumExp)(this, axis, keepDims);
};

});

parcelRegister("ifAOr", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $djEuh = parcelRequire("djEuh");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.log = function() {
    this.throwIfDisposed();
    return (0, $djEuh.log)(this);
};

});

parcelRegister("1qL0E", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $ibX5K = parcelRequire("ibX5K");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.log1p = function() {
    this.throwIfDisposed();
    return (0, $ibX5K.log1p)(this);
};

});

parcelRegister("2kz8U", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jtRHJ = parcelRequire("jtRHJ");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.logicalAnd = function(b) {
    this.throwIfDisposed();
    return (0, $jtRHJ.logicalAnd)(this, b);
};

});

parcelRegister("2sj6m", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ifcdf = parcelRequire("ifcdf");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.logicalNot = function() {
    this.throwIfDisposed();
    return (0, $ifcdf.logicalNot)(this);
};

});

parcelRegister("4tyPi", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eQZfy = parcelRequire("eQZfy");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.logicalOr = function(b) {
    this.throwIfDisposed();
    return (0, $eQZfy.logicalOr)(this, b);
};

});

parcelRegister("6U8G7", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $cKPSM = parcelRequire("cKPSM");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.logicalXor = function(b) {
    this.throwIfDisposed();
    return (0, $cKPSM.logicalXor)(this, b);
};

});

parcelRegister("4tP4z", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $clO9Z = parcelRequire("clO9Z");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.matMul = function(b, transposeA, transposeB) {
    this.throwIfDisposed();
    return (0, $clO9Z.matMul)(this, b, transposeA, transposeB);
};

});

parcelRegister("jICZO", function(module, exports) {

var $jslkq = parcelRequire("jslkq");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.maxPool = function(filterSize, strides, pad, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $jslkq.maxPool)(this, filterSize, strides, pad, dimRoundingMode);
};

});

parcelRegister("9XtmQ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $Fvpms = parcelRequire("Fvpms");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.max = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $Fvpms.max)(this, axis, keepDims);
};

});

parcelRegister("3neZz", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aW7Gb = parcelRequire("aW7Gb");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.maximum = function(b) {
    this.throwIfDisposed();
    return (0, $aW7Gb.maximum)(this, b);
};

});

parcelRegister("2MWel", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $gr40e = parcelRequire("gr40e");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.mean = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $gr40e.mean)(this, axis, keepDims);
};

});

parcelRegister("f4t2f", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8qxBf = parcelRequire("8qxBf");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.min = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $8qxBf.min)(this, axis, keepDims);
};

});

parcelRegister("hr38g", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dlTNL = parcelRequire("dlTNL");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.minimum = function(b) {
    this.throwIfDisposed();
    return (0, $dlTNL.minimum)(this, b);
};

});

parcelRegister("3yv9D", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5sP2j = parcelRequire("5sP2j");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.mirrorPad = function(paddings, mode) {
    this.throwIfDisposed();
    return (0, $5sP2j.mirrorPad)(this, paddings, mode);
};

});

parcelRegister("ehCSY", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $62Ung = parcelRequire("62Ung");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.mod = function(b) {
    this.throwIfDisposed();
    return (0, $62Ung.mod)(this, b);
};

});

parcelRegister("jWUw5", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $r7fN6 = parcelRequire("r7fN6");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.mul = function(b) {
    this.throwIfDisposed();
    return (0, $r7fN6.mul)(this, b);
};

});

parcelRegister("9vLxU", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $ifge7 = parcelRequire("ifge7");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.neg = function() {
    this.throwIfDisposed();
    return (0, $ifge7.neg)(this);
};

});

parcelRegister("6wrVV", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $eiMLq = parcelRequire("eiMLq");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.norm = function(ord, axis, keepDims) {
    this.throwIfDisposed();
    return (0, $eiMLq.norm)(this, ord, axis, keepDims);
};

});

parcelRegister("ifV4J", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i8e86 = parcelRequire("i8e86");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.notEqual = function(b) {
    this.throwIfDisposed();
    return (0, $i8e86.notEqual)(this, b);
};

});

parcelRegister("l8C7q", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8feEH = parcelRequire("8feEH");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.oneHot = function(depth, onValue = 1, offValue = 0) {
    this.throwIfDisposed();
    return (0, $8feEH.oneHot)(this, depth, onValue, offValue);
};

});

parcelRegister("4Gtcz", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $9u8DQ = parcelRequire("9u8DQ");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.onesLike = function() {
    this.throwIfDisposed();
    return (0, $9u8DQ.onesLike)(this);
};

});

parcelRegister("iInvb", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4xBxs = parcelRequire("4xBxs");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.pad = function(paddings, constantValue) {
    this.throwIfDisposed();
    return (0, $4xBxs.pad)(this, paddings, constantValue);
};

});

parcelRegister("5Vsuq", function(module, exports) {

var $eahnV = parcelRequire("eahnV");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.pool = function(windowShape, poolingType, padding, dilationRate, strides, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $eahnV.pool)(this, windowShape, poolingType, padding, dilationRate, strides, dimRoundingMode);
};

});

parcelRegister("10WAQ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5MZxP = parcelRequire("5MZxP");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.pow = function(exp) {
    this.throwIfDisposed();
    return (0, $5MZxP.pow)(this, exp);
};

});

parcelRegister("f4Plq", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4Do8T = parcelRequire("4Do8T");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.prelu = function(alpha) {
    this.throwIfDisposed();
    return (0, $4Do8T.prelu)(this, alpha);
};

});

parcelRegister("l0mmJ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5TfzT = parcelRequire("5TfzT");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.prod = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $5TfzT.prod)(this, axis, keepDims);
};

});

parcelRegister("cNC8G", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $iseIE = parcelRequire("iseIE");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.reciprocal = function() {
    this.throwIfDisposed();
    return (0, $iseIE.reciprocal)(this);
};

});

parcelRegister("gCA0G", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1mZlL = parcelRequire("1mZlL");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.relu = function() {
    this.throwIfDisposed();
    return (0, $1mZlL.relu)(this);
};

});

parcelRegister("7H6EJ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4QFBe = parcelRequire("4QFBe");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.relu6 = function() {
    this.throwIfDisposed();
    return (0, $4QFBe.relu6)(this);
};

});

parcelRegister("kK36M", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eP0pM = parcelRequire("eP0pM");

var $bVnU9 = parcelRequire("bVnU9");
/**
 * Reshapes the tensor into the shape of the provided tensor.
 *
 * @param x The tensor of required shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $bVnU9.getGlobalTensorClass)().prototype.reshapeAs = function(x) {
    this.throwIfDisposed();
    return (0, $eP0pM.reshape)(this, x.shape);
};

});

parcelRegister("eKHCA", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eP0pM = parcelRequire("eP0pM");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.reshape = function(shape) {
    this.throwIfDisposed();
    return (0, $eP0pM.reshape)(this, shape);
};

});

parcelRegister("eEl7k", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $gswiT = parcelRequire("gswiT");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.resizeBilinear = function(newShape2D, alignCorners, halfPixelCenters) {
    this.throwIfDisposed();
    return (0, $gswiT.resizeBilinear)(this, newShape2D, alignCorners, halfPixelCenters);
};

});

parcelRegister("iEov5", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1sK56 = parcelRequire("1sK56");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.resizeNearestNeighbor = function(newShape2D, alignCorners, halfFloatCenters) {
    this.throwIfDisposed();
    return (0, $1sK56.resizeNearestNeighbor)(this, newShape2D, alignCorners, halfFloatCenters);
};

});

parcelRegister("BAS4D", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $do1MK = parcelRequire("do1MK");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.reverse = function(axis) {
    this.throwIfDisposed();
    return (0, $do1MK.reverse)(this, axis);
};

});

parcelRegister("1grRL", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.
parcelRequire("iNZmA");
var $fBxya = parcelRequire("fBxya");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.rfft = function() {
    this.throwIfDisposed();
    return (0, $fBxya.rfft)(this);
};

});

parcelRegister("c2Eez", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $9mGGG = parcelRequire("9mGGG");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.round = function() {
    this.throwIfDisposed();
    return (0, $9mGGG.round)(this);
};

});

parcelRegister("2bm29", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $bvzmJ = parcelRequire("bvzmJ");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.rsqrt = function() {
    this.throwIfDisposed();
    return (0, $bvzmJ.rsqrt)(this);
};

});

parcelRegister("cE08D", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fNXeh = parcelRequire("fNXeh");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.selu = function() {
    this.throwIfDisposed();
    return (0, $fNXeh.selu)(this);
};

});

parcelRegister("8NrTa", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $iC1W9 = parcelRequire("iC1W9");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.separableConv2d = function(depthwiseFilter, pointwiseFilter, strides, pad, dilation, dataFormat) {
    this.throwIfDisposed();
    return (0, $iC1W9.separableConv2d)(this, depthwiseFilter, pointwiseFilter, strides, pad, dilation, dataFormat);
};

});

parcelRegister("h50xi", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $5B3nT = parcelRequire("5B3nT");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.sigmoid = function() {
    this.throwIfDisposed();
    return (0, $5B3nT.sigmoid)(this);
};

});

parcelRegister("c8sAG", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $bJQkq = parcelRequire("bJQkq");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.sign = function() {
    this.throwIfDisposed();
    return (0, $bJQkq.sign)(this);
};

});

parcelRegister("l2TTJ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $b37Kr = parcelRequire("b37Kr");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.sin = function() {
    this.throwIfDisposed();
    return (0, $b37Kr.sin)(this);
};

});

parcelRegister("6PPNy", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $8sXeR = parcelRequire("8sXeR");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.sinh = function() {
    this.throwIfDisposed();
    return (0, $8sXeR.sinh)(this);
};

});

parcelRegister("yzmTi", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $kvpGg = parcelRequire("kvpGg");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.slice = function(begin, size) {
    this.throwIfDisposed();
    return (0, $kvpGg.slice)(this, begin, size);
};

});

parcelRegister("kEukz", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $5q2Zg = parcelRequire("5q2Zg");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.softmax = function(dim) {
    this.throwIfDisposed();
    return (0, $5q2Zg.softmax)(this, dim);
};

});

parcelRegister("bzPgc", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $cvbcy = parcelRequire("cvbcy");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.softplus = function() {
    this.throwIfDisposed();
    return (0, $cvbcy.softplus)(this);
};

});

parcelRegister("imHgK", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $95zUK = parcelRequire("95zUK");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.spaceToBatchND = function(blockShape, paddings) {
    this.throwIfDisposed();
    return (0, $95zUK.spaceToBatchND)(this, blockShape, paddings);
};

});

parcelRegister("f5oge", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9DjTt = parcelRequire("9DjTt");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.split = function(numOrSizeSplits, axis) {
    this.throwIfDisposed();
    return (0, $9DjTt.split)(this, numOrSizeSplits, axis);
};

});

parcelRegister("6PNJs", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $lGdn1 = parcelRequire("lGdn1");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.sqrt = function() {
    this.throwIfDisposed();
    return (0, $lGdn1.sqrt)(this);
};

});

parcelRegister("9cbEd", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $gqriC = parcelRequire("gqriC");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.square = function() {
    this.throwIfDisposed();
    return (0, $gqriC.square)(this);
};

});

parcelRegister("3LUl3", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fRX4k = parcelRequire("fRX4k");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.squaredDifference = function(b) {
    this.throwIfDisposed();
    return (0, $fRX4k.squaredDifference)(this, b);
};

});

parcelRegister("4JbWM", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $wniip = parcelRequire("wniip");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.squeeze = function(axis) {
    this.throwIfDisposed();
    return (0, $wniip.squeeze)(this, axis);
};

});

parcelRegister("37iBh", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $iSKul = parcelRequire("iSKul");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.stack = function(x, axis) {
    this.throwIfDisposed();
    const tensorsToBeStacked = x instanceof (0, $bVnU9.Tensor) ? [
        this,
        x
    ] : [
        this,
        ...x
    ];
    return (0, $iSKul.stack)(tensorsToBeStacked, axis);
};

});

parcelRegister("lRFOz", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $4s2sX = parcelRequire("4s2sX");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.step = function(alpha) {
    this.throwIfDisposed();
    return (0, $4s2sX.step)(this, alpha);
};

});

parcelRegister("hln7v", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $lbPf7 = parcelRequire("lbPf7");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.stridedSlice = function(begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask) {
    this.throwIfDisposed();
    return (0, $lbPf7.stridedSlice)(this, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
};

});

parcelRegister("9vljv", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $hkR0n = parcelRequire("hkR0n");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.sub = function(b) {
    this.throwIfDisposed();
    return (0, $hkR0n.sub)(this, b);
};

});

parcelRegister("2rgO3", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fVwnn = parcelRequire("fVwnn");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.sum = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $fVwnn.sum)(this, axis, keepDims);
};

});

parcelRegister("5jtDX", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $1pSFt = parcelRequire("1pSFt");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.tan = function() {
    this.throwIfDisposed();
    return (0, $1pSFt.tan)(this);
};

});

parcelRegister("6n6wN", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $i3Kce = parcelRequire("i3Kce");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.tanh = function() {
    this.throwIfDisposed();
    return (0, $i3Kce.tanh)(this);
};

});

parcelRegister("cHPhm", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jIHaY = parcelRequire("jIHaY");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.tile = function(reps) {
    this.throwIfDisposed();
    return (0, $jIHaY.tile)(this, reps);
};

});

parcelRegister("6shzE", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $7qWZ5 = parcelRequire("7qWZ5");

var $bVnU9 = parcelRequire("bVnU9");
/**
 * Casts the array to type `bool`
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $bVnU9.getGlobalTensorClass)().prototype.toBool = function() {
    this.throwIfDisposed();
    return (0, $7qWZ5.cast)(this, 'bool');
};

});

parcelRegister("hXLy3", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $7qWZ5 = parcelRequire("7qWZ5");

var $bVnU9 = parcelRequire("bVnU9");
/**
 * Casts the array to type `float32`
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $bVnU9.getGlobalTensorClass)().prototype.toFloat = function() {
    this.throwIfDisposed();
    return (0, $7qWZ5.cast)(this, 'float32');
};

});

parcelRegister("8epsx", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $7qWZ5 = parcelRequire("7qWZ5");

var $bVnU9 = parcelRequire("bVnU9");
/**
 * Casts the array to type `int32`
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $bVnU9.getGlobalTensorClass)().prototype.toInt = function() {
    this.throwIfDisposed();
    return (0, $7qWZ5.cast)(this, 'int32');
};

});

parcelRegister("4U1KE", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eW75q = parcelRequire("eW75q");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.topk = function(k, sorted) {
    this.throwIfDisposed();
    return (0, $eW75q.topk)(this, k, sorted);
};

});

parcelRegister("6DoKm", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9PEYs = parcelRequire("9PEYs");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.transpose = function(perm) {
    this.throwIfDisposed();
    return (0, $9PEYs.transpose)(this, perm);
};

});

parcelRegister("9VtK7", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $gMT7b = parcelRequire("gMT7b");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.unique = function(axis) {
    this.throwIfDisposed();
    return (0, $gMT7b.unique)(this, axis);
};

});

parcelRegister("aLvQj", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $grKBK = parcelRequire("grKBK");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.unsortedSegmentSum = function(segmentIds, numSegments) {
    this.throwIfDisposed();
    return (0, $grKBK.unsortedSegmentSum)(this, segmentIds, numSegments);
};

});

parcelRegister("gqbs8", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $kDeMO = parcelRequire("kDeMO");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.unstack = function(axis) {
    this.throwIfDisposed();
    return (0, $kDeMO.unstack)(this, axis);
};

});

parcelRegister("3v5UT", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3dRh6 = parcelRequire("3dRh6");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.where = function(condition, x) {
    this.throwIfDisposed();
    return (0, $3dRh6.where)(condition, this, x);
};

});

parcelRegister("evl50", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $k1Ozi = parcelRequire("k1Ozi");

var $bVnU9 = parcelRequire("bVnU9");
(0, $bVnU9.getGlobalTensorClass)().prototype.zerosLike = function() {
    this.throwIfDisposed();
    return (0, $k1Ozi.zerosLike)(this);
};

});


parcelRegister("8ExUf", function(module, exports) {

$parcel$export(module.exports, "CallbackList", () => (parcelRequire("9fe8M")).CallbackList);
$parcel$export(module.exports, "CustomCallback", () => (parcelRequire("9fe8M")).CustomCallback);
$parcel$export(module.exports, "History", () => (parcelRequire("9fe8M")).History);
$parcel$export(module.exports, "Callback", () => (parcelRequire("9wnMD")).Callback);
$parcel$export(module.exports, "callbacks", () => (parcelRequire("9wnMD")).callbacks);
$parcel$export(module.exports, "EarlyStopping", () => (parcelRequire("9wnMD")).EarlyStopping);
$parcel$export(module.exports, "InputSpec", () => (parcelRequire("cm045")).InputSpec);
$parcel$export(module.exports, "SymbolicTensor", () => (parcelRequire("cm045")).SymbolicTensor);
$parcel$export(module.exports, "LayersModel", () => (parcelRequire("8foXR")).LayersModel);
$parcel$export(module.exports, "input", () => (parcelRequire("4uu9C")).input);
$parcel$export(module.exports, "loadLayersModel", () => (parcelRequire("4uu9C")).loadLayersModel);
$parcel$export(module.exports, "model", () => (parcelRequire("4uu9C")).model);
$parcel$export(module.exports, "registerCallbackConstructor", () => (parcelRequire("4uu9C")).registerCallbackConstructor);
$parcel$export(module.exports, "sequential", () => (parcelRequire("4uu9C")).sequential);
$parcel$export(module.exports, "RNN", () => (parcelRequire("ejY9c")).RNN);
$parcel$export(module.exports, "Sequential", () => (parcelRequire("31SiL")).Sequential);
$parcel$export(module.exports, "LayerVariable", () => (parcelRequire("7muWV")).LayerVariable);
$parcel$export(module.exports, "version_layers", () => (parcelRequire("3lFvz")).version);
$parcel$export(module.exports, "constraints", () => (parcelRequire("fVgvv")));
$parcel$export(module.exports, "initializers", () => (parcelRequire("ez5kB")));
$parcel$export(module.exports, "layers", () => (parcelRequire("f35gO")));
$parcel$export(module.exports, "metrics", () => (parcelRequire("3E6g6")));
$parcel$export(module.exports, "models", () => (parcelRequire("fn2RY")));
$parcel$export(module.exports, "regularizers", () => (parcelRequire("1pDta")));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("cN83l");
parcelRequire("5n9DG");
parcelRequire("9RnzO");

var $fVgvv = parcelRequire("fVgvv");

var $ez5kB = parcelRequire("ez5kB");

var $f35gO = parcelRequire("f35gO");

var $3E6g6 = parcelRequire("3E6g6");

var $fn2RY = parcelRequire("fn2RY");

var $1pDta = parcelRequire("1pDta");

var $9fe8M = parcelRequire("9fe8M");

var $9wnMD = parcelRequire("9wnMD");

var $cm045 = parcelRequire("cm045");

var $8foXR = parcelRequire("8foXR");

var $4uu9C = parcelRequire("4uu9C");

var $ejY9c = parcelRequire("ejY9c");

var $31SiL = parcelRequire("31SiL");

var $7muWV = parcelRequire("7muWV");

var $3lFvz = parcelRequire("3lFvz");

});
parcelRegister("cN83l", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");

var $ButqI = parcelRequire("ButqI");
const $95004ec5f55e07b7$export$83401e34d5e11bf4 = (0, $aymVi.env)();
/** The max number of entries for the caches of layers' topological sort. */ $95004ec5f55e07b7$export$83401e34d5e11bf4.registerFlag('TOPOLOGICAL_SORT_CACHE_MAX_ENTRIES', ()=>100, (0, $ButqI.updateCacheMaxEntries));

});
parcelRegister("ButqI", function(module, exports) {

$parcel$export(module.exports, "FeedDict", () => $070b1840d113bd39$export$1f554ac52b4b6917);
$parcel$export(module.exports, "updateCacheMaxEntries", () => $070b1840d113bd39$export$2dc27e9d70f80ac7);
$parcel$export(module.exports, "execute", () => $070b1840d113bd39$export$51396ec711da548b);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Executor: Evaluates SymbolicTensor based on feeds.
 */ parcelRequire("5n9DG");
var $7qWZ5 = parcelRequire("7qWZ5");
var $9c0Qr = parcelRequire("9c0Qr");
var $wx9lK = parcelRequire("wx9lK");

var $jVuYK = parcelRequire("jVuYK");

var $4tKtz = parcelRequire("4tKtz");

var $khD6O = parcelRequire("khD6O");

var $3gFUY = parcelRequire("3gFUY");

var $cm045 = parcelRequire("cm045");
/**
 * Helper function to check the dtype and shape compatibility of a feed value.
 */ function $070b1840d113bd39$var$assertFeedCompatibility(key, val) {
    // Check dtype compatibility.
    if (key.dtype == null || key.dtype === val.dtype) //  a.  If types match, return val tensor as is.
    return val;
    try {
        //  b. Attempt to convert to expected type.
        return (0, $7qWZ5.cast)(val, key.dtype);
    } catch (err) {
        //  c. If conversion fails, return helpful error.
        throw new (0, $jVuYK.ValueError)(`The dtype of the feed (${val.dtype}) can not be cast to the dtype ` + `of the key '${key.name}' (${key.dtype}).`);
    }
}
class $070b1840d113bd39$export$1f554ac52b4b6917 {
    /**
     * Constructor, optionally does copy-construction.
     * @param feeds An Array of `Feed`s, or another `FeedDict`, in which case
     *   copy-construction will be performed.
     */ constructor(feeds){
        this.id2Value = {};
        this.id2Mask = {};
        this.name2Id = {};
        if (feeds instanceof $070b1840d113bd39$export$1f554ac52b4b6917) for(const id in feeds.id2Value){
            this.id2Value[id] = feeds.id2Value[id];
            if (id in feeds.id2Mask) this.id2Mask[id] = feeds.id2Mask[id];
        }
        else {
            if (feeds == null) return;
            for (const feed of feeds)this.add(feed.key, feed.value);
        }
    }
    /**
     * Add a key-value pair to the FeedDict.
     *
     * @param key The key of the feed.
     * @param value The value of the tensor feed.
     * @param mask The value of the mask feed (optional).
     * @returns This `FeedDict`.
     * @throws ValueError: If the key `SymbolicTensor` already exists in the
     *   `FeedDict`.
     */ add(key, value, mask) {
        if (this.id2Value[key.id] == null) {
            this.id2Value[key.id] = $070b1840d113bd39$var$assertFeedCompatibility(key, value);
            this.name2Id[key.name] = key.id;
            if (mask != null) this.id2Mask[key.id] = mask;
        } else throw new (0, $jVuYK.ValueError)(`Duplicate key: name=${key.name}, id=${key.id}`);
        return this;
    }
    /**
     * Add a Feed to the FeedDict.
     * @param feed The new `Feed` to add.
     * @returns This `FeedDict`.
     */ addFeed(feed) {
        this.add(feed.key, feed.value);
    }
    /**
     * Probe whether a key already exists in the FeedDict.
     * @param key
     */ hasKey(key) {
        return this.id2Value[key.id] != null;
    }
    /**
     * Get all the SymbolicTensor available in this FeedDict.
     */ names() {
        return Object.keys(this.name2Id);
    }
    /**
     * Get the feed value for given key.
     * @param key The SymbolicTensor, or its name (as a string), of which the
     *     value is sought.
     * @returns If `key` exists, the corresponding feed value.
     * @throws ValueError: If `key` does not exist in this `FeedDict`.
     */ getValue(key) {
        if (key instanceof (0, $cm045.SymbolicTensor)) {
            if (this.id2Value[key.id] == null) throw new (0, $jVuYK.ValueError)(`Nonexistent key: ${key.name}`);
            else return this.id2Value[key.id];
        } else {
            const id = this.name2Id[key];
            if (id == null) throw new (0, $jVuYK.ValueError)(`Feed dict has no SymbolicTensor name: ${key}`);
            return this.id2Value[id];
        }
    }
    /**
     * Get the feed mask for given key.
     * @param key The SymbolicTensor, or its name (as a string), of which the
     *     value is sought.
     * @returns If `key` exists, the corresponding feed mask.
     * @throws ValueError: If `key` does not exist in this `FeedDict`.
     */ getMask(key) {
        if (key instanceof (0, $cm045.SymbolicTensor)) {
            if (this.id2Value[key.id] == null) throw new (0, $jVuYK.ValueError)(`Nonexistent key: ${key.name}`);
            else return this.id2Mask[key.id];
        } else {
            const id = this.name2Id[key];
            if (id == null) throw new (0, $jVuYK.ValueError)(`Feed dict has no SymbolicTensor name: ${key}`);
            return this.id2Mask[id];
        }
    }
    /** Dispose all mask Tensors held by this object. */ disposeMasks() {
        if (this.id2Mask != null) (0, $9c0Qr.dispose)(this.id2Mask);
    }
}
const $070b1840d113bd39$export$44a630df56e5b996 = new (0, $4tKtz.LruCache)();
const $070b1840d113bd39$export$f790425d308658ea = new (0, $4tKtz.LruCache)();
function $070b1840d113bd39$export$2dc27e9d70f80ac7(maxEntries) {
    if ($070b1840d113bd39$export$44a630df56e5b996 != null) $070b1840d113bd39$export$44a630df56e5b996.setMaxEntries(maxEntries);
    if ($070b1840d113bd39$export$f790425d308658ea != null) $070b1840d113bd39$export$f790425d308658ea.setMaxEntries(maxEntries);
}
function $070b1840d113bd39$export$51396ec711da548b(fetches, feedDict, kwargs, probe) {
    const training = kwargs == null ? false : kwargs['training'];
    const arrayFetches = Array.isArray(fetches);
    const fetchArray = arrayFetches ? fetches : [
        fetches
    ];
    const outputNames = fetchArray.map((t)=>t.name);
    const finalOutputs = [];
    const feedNames = feedDict.names();
    for (const outputName of outputNames)if (feedNames.indexOf(outputName) !== -1) finalOutputs.push(feedDict.getValue(outputName));
    else finalOutputs.push(null);
    if (probe != null) {
        // For optional probing of memory footprint during execution.
        probe.maxNumTensors = -Infinity;
        probe.minNumTensors = Infinity;
    }
    // Check cache.
    const fetchAndFeedKey = outputNames.join(',') + '|' + feedDict.names().sort().join(',');
    let sorted = $070b1840d113bd39$export$44a630df56e5b996.get(fetchAndFeedKey);
    let recipientCounts;
    if (sorted == null) {
        // Cache doesn't contain the desired combination of fetches. Compute
        // topological sort for the combination for the first time.
        const out = $070b1840d113bd39$var$getTopologicalSortAndRecipientCounts(fetchArray, feedDict);
        sorted = out.sorted;
        recipientCounts = out.recipientCounts;
        // Store results in cache for future use.
        $070b1840d113bd39$export$44a630df56e5b996.put(fetchAndFeedKey, sorted);
        $070b1840d113bd39$export$f790425d308658ea.put(fetchAndFeedKey, recipientCounts);
    }
    recipientCounts = {};
    if (!training) Object.assign(recipientCounts, $070b1840d113bd39$export$f790425d308658ea.get(fetchAndFeedKey));
    const internalFeedDict = new $070b1840d113bd39$export$1f554ac52b4b6917(feedDict);
    // Start iterative execution on the topologically-sorted SymbolicTensors.
    for(let i = 0; i < sorted.length; ++i){
        if (probe != null) {
            // For optional probing of memory usage during execution.
            const numTensors = (0, $9c0Qr.memory)().numTensors;
            if (numTensors > probe.maxNumTensors) probe.maxNumTensors = numTensors;
            if (numTensors < probe.minNumTensors) probe.minNumTensors = numTensors;
        }
        const symbolic = sorted[i];
        const srcLayer = symbolic.sourceLayer;
        if (srcLayer instanceof (0, $3gFUY.InputLayer)) continue;
        const inputValues = [];
        const inputMasks = [];
        const tensorsToDispose = [];
        let maskExists = false;
        for (const input of symbolic.inputs){
            const value = internalFeedDict.getValue(input);
            const mask = internalFeedDict.getMask(input);
            inputValues.push(value);
            inputMasks.push(mask);
            if (mask != null) maskExists = true;
            if (!training) {
                recipientCounts[input.name]--;
                if (recipientCounts[input.name] === 0 && !feedDict.hasKey(input) && outputNames.indexOf(input.name) === -1 && !value.isDisposed && input.sourceLayer.stateful !== true) tensorsToDispose.push(value);
            }
        }
        if (maskExists) {
            kwargs = kwargs || {};
            kwargs['mask'] = inputMasks[0];
        }
        const outputTensors = (0, $khD6O.toList)(srcLayer.apply(inputValues, kwargs));
        let outputMask = null;
        if (srcLayer.supportsMasking) outputMask = srcLayer.computeMask(inputValues, inputMasks);
        const layerOutputs = $070b1840d113bd39$var$getNodeOutputs(symbolic);
        const outputSymbolicTensors = Array.isArray(layerOutputs) ? layerOutputs : [
            layerOutputs
        ];
        for(let i = 0; i < outputSymbolicTensors.length; ++i){
            if (!internalFeedDict.hasKey(outputSymbolicTensors[i])) internalFeedDict.add(outputSymbolicTensors[i], outputTensors[i], Array.isArray(outputMask) ? outputMask[0] : outputMask);
            const index = outputNames.indexOf(outputSymbolicTensors[i].name);
            if (index !== -1) finalOutputs[index] = outputTensors[i];
        }
        if (!training) // Clean up Tensors that are no longer needed.
        (0, $9c0Qr.dispose)(tensorsToDispose);
    }
    // NOTE(cais): Unlike intermediate tensors, we don't discard mask
    // tensors as we go, because these tensors are sometimes passed over a
    // series of mutliple layers, i.e., not obeying the immediate input
    // relations in the graph. If this becomes a memory-usage concern,
    // we can improve this in the future.
    internalFeedDict.disposeMasks();
    return arrayFetches ? finalOutputs : finalOutputs[0];
}
/**
 * Sort the `SymbolicTensor`s topologically, for an array of fetches.
 *
 * This function calls getTopologicalSortAndRecipientCountsForOneFetch and
 * merges their results.
 *
 * @param fetch The array of fetches requested. Must be a non-empty array.
 * @param feedDict The dictionary of fed values.
 * @returns sorted: Topologically-sorted array of SymbolicTensors.
 *   recipientCounts: Recipient counts for all SymbolicTensors in `sorted`.
 */ function $070b1840d113bd39$var$getTopologicalSortAndRecipientCounts(fetches, feedDict) {
    (0, $wx9lK).assert(fetches != null && fetches.length > 0, ()=>`Expected at least one fetch, got none`);
    let finalSorted = [];
    let finalRecipientMap = {};
    if (fetches.length === 1) {
        // Special-casing 1 fetch for efficiency.
        const out = $070b1840d113bd39$export$a8bd8d591d4e6bd9(fetches[0], feedDict);
        finalSorted = out.sorted;
        finalRecipientMap = out.recipientMap;
    } else {
        const visited = new Set();
        for (const fetch of fetches){
            const { sorted: sorted, recipientMap: recipientMap } = $070b1840d113bd39$export$a8bd8d591d4e6bd9(fetch, feedDict);
            // Merge sorted SymbolicTensor Arrays.
            for (const symbolicTensor of sorted)if (!visited.has(symbolicTensor.name)) {
                finalSorted.push(symbolicTensor);
                visited.add(symbolicTensor.name);
            }
            // Merge recipient maps.
            for(const name in recipientMap){
                if (finalRecipientMap[name] == null) finalRecipientMap[name] = new Set();
                recipientMap[name].forEach((recipient)=>finalRecipientMap[name].add(recipient));
            }
        }
    }
    return {
        sorted: finalSorted,
        recipientCounts: $070b1840d113bd39$var$recipientMap2Counts(finalRecipientMap)
    };
}
function $070b1840d113bd39$var$recipientMap2Counts(recipientMap) {
    const recipientCounts = {};
    for(const name in recipientMap)recipientCounts[name] = recipientMap[name].size;
    return recipientCounts;
}
function $070b1840d113bd39$export$a8bd8d591d4e6bd9(fetch, feedDict) {
    const visited = new Set();
    const sorted = [];
    const recipientMap = {};
    // Put keys of the feedDict into visited first, so they don't have to be
    // walked. This is needed in case where there are feeds for intermediate
    // SymbolicTensors of the graph.
    for (const key of feedDict.names())visited.add(key);
    const stack = [];
    const marks = [];
    // Initial population of stack and marks.
    stack.push(fetch);
    while(stack.length > 0){
        const top = stack[stack.length - 1];
        if (visited.has(top.name)) {
            stack.pop();
            continue;
        }
        const topIsMarked = marks[marks.length - 1] === stack.length - 1;
        if (top.inputs.length === 0 || topIsMarked) {
            // Input SymbolicTensor or all children have been visited.
            stack.pop();
            sorted.push(top);
            visited.add(top.name);
            if (topIsMarked) marks.pop();
        } else {
            // A non-input SymbolicTensor whose upstream SymbolicTensors haven't
            // been visited yet. Push them onto the stack.
            marks.push(stack.length - 1);
            for (const input of top.inputs){
                // Increment the recipient count. Note that this needs to happen
                // regardless of whether the SymbolicTensor has been visited before.
                if (recipientMap[input.name] == null) recipientMap[input.name] = new Set();
                recipientMap[input.name].add(top.name);
                if (visited.has(input.name)) continue; // Avoid repeated visits to the same SymbolicTensor.
                stack.push(input);
            }
        }
    }
    return {
        sorted: sorted,
        recipientMap: recipientMap
    };
}
/**
 * Get the symbolic output tensors of the node to which a given fetch belongs.
 * @param fetch The fetched symbolic tensor.
 * @returns The Array of symbolic tensors output by the node to which `fetch`
 *   belongs.
 */ function $070b1840d113bd39$var$getNodeOutputs(fetch) {
    let layerOutputs;
    if (fetch.sourceLayer.inboundNodes.length === 1) layerOutputs = fetch.sourceLayer.output;
    else {
        let nodeIndex = null;
        for(let i = 0; i < fetch.sourceLayer.inboundNodes.length; ++i){
            for (const outputTensor of fetch.sourceLayer.inboundNodes[i].outputTensors)if (outputTensor.id === fetch.id) {
                nodeIndex = i;
                break;
            }
        }
        layerOutputs = fetch.sourceLayer.getOutputAt(nodeIndex);
    }
    return layerOutputs;
}

});
parcelRegister("jVuYK", function(module, exports) {

$parcel$export(module.exports, "AttributeError", () => $e81b5ef45cc9e877$export$3869bf0637a5d0ff);
$parcel$export(module.exports, "RuntimeError", () => $e81b5ef45cc9e877$export$4a24a86bdbcf02bb);
$parcel$export(module.exports, "ValueError", () => $e81b5ef45cc9e877$export$54d4c18dc78a26d4);
$parcel$export(module.exports, "NotImplementedError", () => $e81b5ef45cc9e877$export$e162153238934121);
$parcel$export(module.exports, "AssertionError", () => $e81b5ef45cc9e877$export$7750cdfb4db2c3d);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Explicit error types.
 *
 * See the following link for more information about why the code includes
 * calls to setPrototypeOf:
 *
 * https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
 */ // tslint:enable
/**
 * Equivalent of Python's AttributeError.
 */ class $e81b5ef45cc9e877$export$3869bf0637a5d0ff extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $e81b5ef45cc9e877$export$3869bf0637a5d0ff.prototype);
    }
}
class $e81b5ef45cc9e877$export$4a24a86bdbcf02bb extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $e81b5ef45cc9e877$export$4a24a86bdbcf02bb.prototype);
    }
}
class $e81b5ef45cc9e877$export$54d4c18dc78a26d4 extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $e81b5ef45cc9e877$export$54d4c18dc78a26d4.prototype);
    }
}
class $e81b5ef45cc9e877$export$e162153238934121 extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $e81b5ef45cc9e877$export$e162153238934121.prototype);
    }
}
class $e81b5ef45cc9e877$export$7750cdfb4db2c3d extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $e81b5ef45cc9e877$export$7750cdfb4db2c3d.prototype);
    }
}
class $e81b5ef45cc9e877$export$efa5eacb1304c464 extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $e81b5ef45cc9e877$export$efa5eacb1304c464.prototype);
    }
}

});

parcelRegister("4tKtz", function(module, exports) {

$parcel$export(module.exports, "LruCache", () => $342dec02e81b551c$export$ec63a4108685a0aa);
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * LruCache: A mapping from the String to T. If the number of the entries is
 * exceeding the `maxEntries`, the LruCache will delete the least recently
 * used entry.
 */ class $342dec02e81b551c$export$ec63a4108685a0aa {
    constructor(maxEntries){
        this.maxEntries = maxEntries || 100;
        this.cache = new Map();
    }
    /**
     * Get the entry for the key and mark it as used recently.
     */ get(key) {
        let entry;
        if (this.cache.has(key)) {
            entry = this.cache.get(key);
            this.cache.delete(key);
            this.cache.set(key, entry);
        }
        return entry;
    }
    /**
     * Put the entry into the cache. If the key already existed, mark the key as
     * used recently.
     */ put(key, value) {
        if (this.cache.has(key)) this.cache.delete(key);
        else if (this.cache.size >= this.maxEntries) {
            const keyToDelete = this.cache.keys().next().value;
            this.cache.delete(keyToDelete);
        }
        this.cache.set(key, value);
    }
    /**
     * Get the MaxEntries of the cache.
     */ getMaxEntries() {
        return this.maxEntries;
    }
    /**
     * Set the MaxEntries of the cache. If the maxEntries is decreased, reduce
     * entries in the cache.
     */ setMaxEntries(maxEntries) {
        if (maxEntries < 0) throw new Error(`The maxEntries of LRU caches must be at least 0, but got ${maxEntries}.`);
        if (this.maxEntries > maxEntries) for(let i = 0; i < this.maxEntries - maxEntries; i++){
            const keyToDelete = this.cache.keys().next().value;
            this.cache.delete(keyToDelete);
        }
        this.maxEntries = maxEntries;
    }
}

});

parcelRegister("khD6O", function(module, exports) {

$parcel$export(module.exports, "pyListRepeat", () => $ec43bb685511074e$export$f24d1f1e6cb42785);
$parcel$export(module.exports, "assert", () => $ec43bb685511074e$export$a7a9523472993e97);
$parcel$export(module.exports, "count", () => $ec43bb685511074e$export$85b9a36db797e02b);
$parcel$export(module.exports, "singletonOrArray", () => $ec43bb685511074e$export$8366660815493a21);
$parcel$export(module.exports, "toList", () => $ec43bb685511074e$export$effcdbd76139450);
$parcel$export(module.exports, "toSnakeCase", () => $ec43bb685511074e$export$cc8b315fc368b20a);
$parcel$export(module.exports, "toCamelCase", () => $ec43bb685511074e$export$86f54f62aa7a7514);
$parcel$export(module.exports, "serializeKerasObject", () => $ec43bb685511074e$export$78f846918d17a884);
$parcel$export(module.exports, "deserializeKerasObject", () => $ec43bb685511074e$export$c33061eb381c60f9);
$parcel$export(module.exports, "reverseNumberCompare", () => $ec43bb685511074e$export$964007bb9b7e1f75);
$parcel$export(module.exports, "unique", () => $ec43bb685511074e$export$7a5d5c156e7dc406);
$parcel$export(module.exports, "isObjectEmpty", () => $ec43bb685511074e$export$23cfe696632d10f4);
$parcel$export(module.exports, "checkStringTypeUnionValue", () => $ec43bb685511074e$export$f49e87e6cde0274b);
$parcel$export(module.exports, "checkArrayTypeAndLength", () => $ec43bb685511074e$export$9c1c2eaf0ddbb1d3);
$parcel$export(module.exports, "assertPositiveInteger", () => $ec43bb685511074e$export$7ac3b6580cbed983);
$parcel$export(module.exports, "debounce", () => $ec43bb685511074e$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "mapActivationToFusedKernel", () => $ec43bb685511074e$export$aa3e0e68e0c6329f);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: utils/generic_utils.py */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $jVuYK = parcelRequire("jVuYK");
function $ec43bb685511074e$export$f24d1f1e6cb42785(value, numValues) {
    if (Array.isArray(value)) {
        // tslint:disable-next-line:no-any
        let newArray = [];
        for(let i = 0; i < numValues; i++)newArray = newArray.concat(value);
        return newArray;
    } else {
        const newArray = new Array(numValues);
        newArray.fill(value);
        return newArray;
    }
}
function $ec43bb685511074e$export$a7a9523472993e97(val, message) {
    if (!val) throw new (0, $jVuYK.AssertionError)(message);
}
function $ec43bb685511074e$export$85b9a36db797e02b(array, refernce) {
    let counter = 0;
    for (const item of array)if (item === refernce) counter++;
    return counter;
}
function $ec43bb685511074e$export$8366660815493a21(xs) {
    if (xs.length === 1) return xs[0];
    return xs;
}
function $ec43bb685511074e$export$effcdbd76139450(x) {
    if (Array.isArray(x)) return x;
    return [
        x
    ];
}
function $ec43bb685511074e$export$a75d309e098886ab(objs) {
    const objectList = $ec43bb685511074e$export$effcdbd76139450(objs);
    let retVal = '';
    for (const obj of objectList){
        if (obj.id == null) throw new (0, $jVuYK.ValueError)(`Object ${obj} passed to objectListUid without an id`);
        if (retVal !== '') retVal = retVal + ', ';
        retVal = `${retVal}${Math.abs(obj.id)}`;
    }
    return retVal;
}
function $ec43bb685511074e$export$cc8b315fc368b20a(name) {
    const intermediate = name.replace(/(.)([A-Z][a-z0-9]+)/g, '$1_$2');
    const insecure = intermediate.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
    /*
     If the class is private the name starts with "_" which is not secure
     for creating scopes. We prefix the name with "private" in this case.
     */ if (insecure[0] !== '_') return insecure;
    return 'private' + insecure;
}
function $ec43bb685511074e$export$86f54f62aa7a7514(identifier) {
    // quick return for empty string or single character strings
    if (identifier.length <= 1) return identifier;
    // Check for the underscore indicating snake_case
    if (identifier.indexOf('_') === -1) return identifier;
    return identifier.replace(/[_]+(\w|$)/g, (m, p1)=>p1.toUpperCase());
}
// tslint:disable-next-line:no-any
let $ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS = {};
function $ec43bb685511074e$export$78f846918d17a884(instance) {
    if (instance === null || instance === undefined) return null;
    const dict = {};
    dict['className'] = instance.getClassName();
    dict['config'] = instance.getConfig();
    return dict;
}
/**
 * Replace ndarray-style scalar objects in serialization objects with numbers.
 *
 * Background: In some versions of tf.keras, certain scalar values in the HDF5
 * model save file can be serialized as: `{'type': 'ndarray', 'value': num}`,
 * where in `num` is a plain number. This method converts such serialization
 * to a `number`.
 *
 * @param config The keras-format serialization object to be processed
 *   (in place).
 */ function $ec43bb685511074e$var$convertNDArrayScalarsInConfig(config) {
    if (config == null || typeof config !== 'object') return;
    else if (Array.isArray(config)) config.forEach((configItem)=>$ec43bb685511074e$var$convertNDArrayScalarsInConfig(configItem));
    else {
        const fields = Object.keys(config);
        for (const field of fields){
            const value = config[field];
            if (value != null && typeof value === 'object') {
                if (!Array.isArray(value) && value['type'] === 'ndarray' && typeof value['value'] === 'number') config[field] = value['value'];
                else $ec43bb685511074e$var$convertNDArrayScalarsInConfig(value);
            }
        }
    }
}
function $ec43bb685511074e$export$c33061eb381c60f9(identifier, moduleObjects = {}, customObjects = {}, printableModuleName = 'object', fastWeightInit = false) {
    // tslint:enable
    if (typeof identifier === 'string') {
        const functionName = identifier;
        let fn;
        if (functionName in customObjects) fn = customObjects[functionName];
        else if (functionName in $ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS) fn = $ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS[functionName];
        else {
            fn = moduleObjects[functionName];
            if (fn == null) throw new (0, $jVuYK.ValueError)(`Unknown ${printableModuleName}: ${identifier}. ` + `This may be due to one of the following reasons:\n` + `1. The ${printableModuleName} is defined in Python, in which ` + `case it needs to be ported to TensorFlow.js or your JavaScript ` + `code.\n` + `2. The custom ${printableModuleName} is defined in JavaScript, ` + `but is not registered properly with ` + `tf.serialization.registerClass().`);
        }
        return fn;
    } else {
        // In this case we are dealing with a Keras config dictionary.
        const config = identifier;
        if (config['className'] == null || config['config'] == null) throw new (0, $jVuYK.ValueError)(`${printableModuleName}: Improper config format: ` + `${JSON.stringify(config)}.\n` + `'className' and 'config' must set.`);
        const className = config['className'];
        let cls, fromConfig;
        if (className in customObjects) [cls, fromConfig] = customObjects[className];
        else if (className in $ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS) [cls, fromConfig] = $ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS['className'];
        else if (className in moduleObjects) [cls, fromConfig] = moduleObjects[className];
        if (cls == null) throw new (0, $jVuYK.ValueError)(`Unknown ${printableModuleName}: ${className}. ` + `This may be due to one of the following reasons:\n` + `1. The ${printableModuleName} is defined in Python, in which ` + `case it needs to be ported to TensorFlow.js or your JavaScript ` + `code.\n` + `2. The custom ${printableModuleName} is defined in JavaScript, ` + `but is not registered properly with ` + `tf.serialization.registerClass().`);
        if (fromConfig != null) {
            // Porting notes: Instead of checking to see whether fromConfig accepts
            // customObjects, we create a customObjects dictionary and tack it on to
            // config['config'] as config['config'].customObjects. Objects can use it,
            // if they want.
            // tslint:disable-next-line:no-any
            const customObjectsCombined = {};
            for (const key of Object.keys($ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS))customObjectsCombined[key] = $ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS[key];
            for (const key of Object.keys(customObjects))customObjectsCombined[key] = customObjects[key];
            // Add the customObjects to config
            const nestedConfig = config['config'];
            nestedConfig['customObjects'] = customObjectsCombined;
            const backupCustomObjects = Object.assign({}, $ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS);
            for (const key of Object.keys(customObjects))$ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS[key] = customObjects[key];
            $ec43bb685511074e$var$convertNDArrayScalarsInConfig(config['config']);
            const returnObj = fromConfig(cls, config['config'], customObjects, fastWeightInit);
            $ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS = Object.assign({}, backupCustomObjects);
            return returnObj;
        } else {
            // Then `cls` may be a function returning a class.
            // In this case by convention `config` holds
            // the kwargs of the function.
            const backupCustomObjects = Object.assign({}, $ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS);
            for (const key of Object.keys(customObjects))$ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS[key] = customObjects[key];
            // In python this is **config['config'], for tfjs-layers we require
            // classes that use this fall-through construction method to take
            // a config interface that mimics the expansion of named parameters.
            const returnObj = new cls(config['config']);
            $ec43bb685511074e$var$_GLOBAL_CUSTOM_OBJECTS = Object.assign({}, backupCustomObjects);
            return returnObj;
        }
    }
}
function $ec43bb685511074e$export$d40c4ae552b5068b(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function $ec43bb685511074e$export$964007bb9b7e1f75(a, b) {
    return -1 * $ec43bb685511074e$export$d40c4ae552b5068b(a, b);
}
function $ec43bb685511074e$export$1502380f22ccb6a5(dtype) {
    switch(dtype){
        case 'float32':
            return 'float32';
        default:
            throw new (0, $jVuYK.ValueError)(`Invalid dtype: ${dtype}`);
    }
}
function $ec43bb685511074e$export$cc4775daf8d91b53(xs, ys) {
    if (xs == null || ys == null) return xs === ys;
    if (xs.length !== ys.length) return false;
    for(let i = 0; i < xs.length; ++i){
        if (xs[i] !== ys[i]) return false;
    }
    return true;
}
function $ec43bb685511074e$export$7a5d5c156e7dc406(xs) {
    if (xs == null) return xs;
    const out = [];
    // TODO(cais): Maybe improve performance by sorting.
    for (const x of xs)if (out.indexOf(x) === -1) out.push(x);
    return out;
}
function $ec43bb685511074e$export$23cfe696632d10f4(obj) {
    if (obj == null) throw new (0, $jVuYK.ValueError)(`Invalid value in obj: ${JSON.stringify(obj)}`);
    for(const key in obj){
        if (obj.hasOwnProperty(key)) return false;
    }
    return true;
}
function $ec43bb685511074e$export$f49e87e6cde0274b(values, label, value) {
    if (value == null) return;
    if (values.indexOf(value) < 0) throw new (0, $jVuYK.ValueError)(`${value} is not a valid ${label}.  Valid values are ${values} or null/undefined.`);
}
function $ec43bb685511074e$export$9c1c2eaf0ddbb1d3(x, expectedType, minLength = 0, maxLength = Infinity) {
    $ec43bb685511074e$export$a7a9523472993e97(minLength >= 0);
    $ec43bb685511074e$export$a7a9523472993e97(maxLength >= minLength);
    return Array.isArray(x) && x.length >= minLength && x.length <= maxLength && x.every((e)=>typeof e === expectedType);
}
function $ec43bb685511074e$export$7ac3b6580cbed983(value, name) {
    if (Array.isArray(value)) {
        (0, $wx9lK).assert(value.length > 0, ()=>`${name} is unexpectedly an empty array.`);
        value.forEach((v, i)=>$ec43bb685511074e$export$7ac3b6580cbed983(v, `element ${i + 1} of ${name}`));
    } else (0, $wx9lK).assert(Number.isInteger(value) && value > 0, ()=>`Expected ${name} to be a positive integer, but got ` + `${$ec43bb685511074e$export$7a0c59ae8d81831f(value)}.`);
}
function $ec43bb685511074e$export$7a0c59ae8d81831f(value) {
    if (value === null) return 'null';
    else if (Array.isArray(value)) return '[' + value.map((v)=>$ec43bb685511074e$export$7a0c59ae8d81831f(v)).join(',') + ']';
    else if (typeof value === 'string') return `"${value}"`;
    else return `${value}`;
}
function $ec43bb685511074e$export$61fc7d43ac8f84b0(f, waitMs, nowFunc) {
    let lastTime = nowFunc != null ? nowFunc() : (0, $wx9lK).now();
    let lastResult;
    const f2 = (...args)=>{
        const now = nowFunc != null ? nowFunc() : (0, $wx9lK).now();
        if (now - lastTime < waitMs) return lastResult;
        lastTime = now;
        lastResult = f(...args);
        return lastResult;
    };
    return f2;
}
function $ec43bb685511074e$export$aa3e0e68e0c6329f(activationName) {
    if (activationName === 'relu') return 'relu';
    if (activationName === 'linear') return 'linear';
    if (activationName === 'elu') return 'elu';
    return null;
}
function $ec43bb685511074e$export$a670de672a83f477(...arrayOfValues) {
    $ec43bb685511074e$export$a7a9523472993e97(arrayOfValues.length > 0, 'arrayOfValues is empty');
    for (const values of arrayOfValues){
        $ec43bb685511074e$export$a7a9523472993e97(Array.isArray(values), 'one of the values is not an array');
        $ec43bb685511074e$export$a7a9523472993e97(values.length > 0, 'one of the values is empty');
    }
    return arrayOfValues.reduce((products, values)=>{
        if (products.length === 0) return values.map((value)=>[
                value
            ]);
        return values.map((value)=>{
            return products.map((prevValue)=>[
                    ...prevValue,
                    value
                ]);
        }).reduce((flattenedProduct, unflattenedProduct)=>{
            return flattenedProduct.concat(unflattenedProduct);
        }, []);
    }, []);
}

});

parcelRegister("3gFUY", function(module, exports) {

$parcel$export(module.exports, "InputLayer", () => $261361be41ab2029$export$191123fdb608c9b4);
$parcel$export(module.exports, "Input", () => $261361be41ab2029$export$f5b8910cec6cf069);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $8AyuI = parcelRequire("8AyuI");

var $3qq1L = parcelRequire("3qq1L");

var $jVuYK = parcelRequire("jVuYK");

var $cm045 = parcelRequire("cm045");
class $261361be41ab2029$export$191123fdb608c9b4 extends (0, $cm045.Layer) {
    constructor(args){
        super({
            dtype: args.dtype,
            name: args.name != null ? args.name : (0, $3qq1L.getUid)('input').toString()
        });
        // Normalize config.batchSize and config.sparse
        if (args.batchSize == null) args.batchSize = null;
        if (args.sparse == null) args.sparse = false;
        this.trainable = false;
        this.built = true;
        this.sparse = args.sparse;
        if (args.inputShape != null && args.batchInputShape != null) throw new (0, $jVuYK.ValueError)("Only provide the inputShape OR batchInputShape argument to inputLayer, not both at the same time.");
        let batchInputShape = args.batchInputShape;
        if (batchInputShape == null) {
            if (args.inputShape == null) throw new (0, $jVuYK.ValueError)("An InputLayer should be passed either a `batchInputShape` or an `inputShape`.");
            else batchInputShape = [
                args.batchSize
            ].concat(args.inputShape);
        } else {
            // TODO(michaelterry): Backport to PyKeras
            if (args.batchSize != null) throw new (0, $jVuYK.ValueError)("Cannot specify batchSize if batchInputShape is specified when creating an InputLayer.");
        }
        const dtype = args.dtype || 'float32';
        this.batchInputShape = batchInputShape;
        this.dtype = dtype;
        // TODO(michaelterry): Backport this to PyKeras?
        this.inputSpec = [
            {
                shape: batchInputShape
            }
        ];
        const inputTensor = new (0, $cm045.SymbolicTensor)(this.dtype, this.batchInputShape, this, [], {}, this.name);
        inputTensor.nodeIndex = 0;
        inputTensor.tensorIndex = 0;
        // Create an input node to add to this.outboundNode.
        // (This call has side effects.)
        // tslint:disable-next-line:no-unused-expression
        new (0, $cm045.Node)({
            outboundLayer: this,
            inboundLayers: [],
            nodeIndices: [],
            tensorIndices: [],
            inputTensors: [
                inputTensor
            ],
            outputTensors: [
                inputTensor
            ],
            inputMasks: [
                null
            ],
            outputMasks: [
                null
            ],
            inputShapes: [
                batchInputShape
            ],
            outputShapes: [
                batchInputShape
            ]
        });
    }
    apply(inputs, kwargs) {
        throw new (0, $jVuYK.ValueError)('Cannot pass any input to an ' + `InputLayer's apply() method. InputLayer name: ${this.name}`);
    }
    dispose() {
        // dispose() for InputLayer is overridden as no-op.
        return {
            refCountAfterDispose: this._refCount,
            numDisposedVariables: 0
        };
    }
    getConfig() {
        return {
            batchInputShape: this.batchInputShape,
            dtype: this.dtype,
            sparse: this.sparse,
            name: this.name
        };
    }
}
/** @nocollapse */ $261361be41ab2029$export$191123fdb608c9b4.className = 'InputLayer';
(0, $8AyuI).registerClass($261361be41ab2029$export$191123fdb608c9b4);
function $261361be41ab2029$export$f5b8910cec6cf069(config) {
    if (config.batchShape == null && config.shape == null) throw new Error("Please provide to Input either a `shape` or a `batchShape` argument. Note that `shape` does not include the batch dimension.");
    if (config.batchShape != null && config.shape != null) // TODO(michaelterry): Backport to PyKeras.
    throw new (0, $jVuYK.ValueError)("Please provide either a `shape` or `batchShape` argument to Input, but not both.");
    let batchShape = config.batchShape;
    if (config.shape != null && batchShape == null) batchShape = [
        null
    ].concat(config.shape);
    let dtype = config.dtype;
    if (dtype == null) dtype = 'float32';
    const inputLayer = new $261361be41ab2029$export$191123fdb608c9b4({
        batchInputShape: batchShape,
        name: config.name,
        dtype: dtype,
        sparse: config.sparse
    });
    const outputs = inputLayer.inboundNodes[0].outputTensors;
    return outputs[0];
}

});
parcelRegister("3qq1L", function(module, exports) {

$parcel$export(module.exports, "getNextUniqueTensorId", () => $27e7fd54e271061a$export$b7ad53ecc0eccaf);
$parcel$export(module.exports, "getUid", () => $27e7fd54e271061a$export$5e82334337e0f204);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Utilities related to persistent state in the backend.
 */ /**
 * An ID to track `tf.SymbolicTensor`s and derived classes.
 * Required in different places in engine/topology.ts to identify unique
 * tensors.
 */ let $27e7fd54e271061a$var$_nextUniqueTensorId = 0;
function $27e7fd54e271061a$export$b7ad53ecc0eccaf() {
    return $27e7fd54e271061a$var$_nextUniqueTensorId++;
}
const $27e7fd54e271061a$var$_uidPrefixes = {};
function $27e7fd54e271061a$export$5e82334337e0f204(prefix = '') {
    if (!(prefix in $27e7fd54e271061a$var$_uidPrefixes)) $27e7fd54e271061a$var$_uidPrefixes[prefix] = 0;
    $27e7fd54e271061a$var$_uidPrefixes[prefix] += 1;
    return prefix + $27e7fd54e271061a$var$_uidPrefixes[prefix].toString();
}

});

parcelRegister("cm045", function(module, exports) {

$parcel$export(module.exports, "InputSpec", () => $8fe79700dcc8f26c$export$7705ee67def9d40a);
$parcel$export(module.exports, "SymbolicTensor", () => $8fe79700dcc8f26c$export$c6d6977640680568);
$parcel$export(module.exports, "Node", () => $8fe79700dcc8f26c$export$85c928794f8d04d4);
$parcel$export(module.exports, "Layer", () => $8fe79700dcc8f26c$export$936d0764594b6eb3);
$parcel$export(module.exports, "getSourceInputs", () => $8fe79700dcc8f26c$export$6d61b4ed0b6fb596);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/engine/topology.py */ parcelRequire("5n9DG");
var $8AyuI = parcelRequire("8AyuI");
var $9c0Qr = parcelRequire("9c0Qr");
var $wx9lK = parcelRequire("wx9lK");

var $3qq1L = parcelRequire("3qq1L");

var $hQ5cH = parcelRequire("hQ5cH");

var $jVuYK = parcelRequire("jVuYK");

var $fQ95p = parcelRequire("fQ95p");

var $khD6O = parcelRequire("khD6O");

var $5sw3q = parcelRequire("5sw3q");

var $5YCEz = parcelRequire("5YCEz");

var $7muWV = parcelRequire("7muWV");
class $8fe79700dcc8f26c$export$7705ee67def9d40a {
    constructor(args){
        this.dtype = args.dtype;
        this.shape = args.shape;
        /*
          TODO(michaelterry): Could throw error if ndim and shape are both defined
            (then backport).
        */ if (args.shape != null) this.ndim = args.shape.length;
        else this.ndim = args.ndim;
        this.maxNDim = args.maxNDim;
        this.minNDim = args.minNDim;
        this.axes = args.axes || {};
    }
}
class $8fe79700dcc8f26c$export$c6d6977640680568 {
    /**
     *
     * @param dtype
     * @param shape
     * @param sourceLayer The Layer that produced this symbolic tensor.
     * @param inputs The inputs passed to sourceLayer's __call__() method.
     * @param nodeIndex
     * @param tensorIndex
     * @param callArgs The keyword arguments passed to the __call__() method.
     * @param name
     * @param outputTensorIndex The index of this tensor in the list of outputs
     *   returned by apply().
     */ constructor(dtype, shape, sourceLayer, inputs, callArgs, name, outputTensorIndex){
        this.dtype = dtype;
        this.shape = shape;
        this.sourceLayer = sourceLayer;
        this.inputs = inputs;
        this.callArgs = callArgs;
        this.outputTensorIndex = outputTensorIndex;
        this.id = (0, $3qq1L.getNextUniqueTensorId)();
        if (name != null) {
            this.originalName = (0, $hQ5cH.getScopedTensorName)(name);
            this.name = (0, $hQ5cH.getUniqueTensorName)(this.originalName);
        }
        this.rank = shape.length;
    }
}
let $8fe79700dcc8f26c$var$_nextNodeID = 0;
class $8fe79700dcc8f26c$export$85c928794f8d04d4 {
    constructor(args, // TODO(michaelterry): Define actual type for this.
    callArgs){
        this.callArgs = callArgs;
        this.id = $8fe79700dcc8f26c$var$_nextNodeID++;
        /*
          Layer instance (NOT a list).
          this is the layer that takes a list of input tensors
          and turns them into a list of output tensors.
          the current node will be added to
          the inboundNodes of outboundLayer.
        */ this.outboundLayer = args.outboundLayer;
        /*
            The following 3 properties describe where
            the input tensors come from: which layers,
            and for each layer, which node and which
            tensor output of each node.
        */ // List of layer instances.
        this.inboundLayers = args.inboundLayers;
        // List of integers, 1:1 mapping with inboundLayers.
        this.nodeIndices = args.nodeIndices;
        // List of integers, 1:1 mapping with inboundLayers.
        this.tensorIndices = args.tensorIndices;
        /*
            Following 2 properties:
            tensor inputs and outputs of outboundLayer.
        */ // List of tensors. 1:1 mapping with inboundLayers.
        this.inputTensors = args.inputTensors;
        // List of tensors, created by outboundLayer.call().
        this.outputTensors = args.outputTensors;
        /*
            Following 2 properties: input and output masks.
            List of tensors, 1:1 mapping with inputTensor.
        */ this.inputMasks = args.inputMasks;
        // List of tensors, created by outboundLayer.computeMask().
        this.outputMasks = args.outputMasks;
        // Following 2 properties: input and output shapes.
        // List of shape tuples, shapes of inputTensors.
        this.inputShapes = args.inputShapes;
        // List of shape tuples, shapes of outputTensors.
        this.outputShapes = args.outputShapes;
        // Add nodes to all layers involved.
        for (const layer of args.inboundLayers)if (layer != null) layer.outboundNodes.push(this);
        args.outboundLayer.inboundNodes.push(this);
    }
    getConfig() {
        const inboundNames = [];
        for (const layer of this.inboundLayers)if (layer != null) inboundNames.push(layer.name);
        else inboundNames.push(null);
        return {
            outboundLayer: this.outboundLayer ? this.outboundLayer.name : null,
            inboundLayers: inboundNames,
            nodeIndices: this.nodeIndices,
            tensorIndices: this.tensorIndices
        };
    }
}
let $8fe79700dcc8f26c$var$_nextLayerID = 0;
class $8fe79700dcc8f26c$export$936d0764594b6eb3 extends (0, $8AyuI).Serializable {
    constructor(args = {}){
        super();
        this._callHook = null;
        this._addedWeightNames = [];
        // Porting Notes: PyKeras does not have this property in this base Layer
        //   class. Instead lets Layer subclass set it dynamically and checks the
        //   value with `hasattr`. In tfjs-layers, we let this be a member of this
        //   base class.
        this._stateful = false;
        this.id = $8fe79700dcc8f26c$var$_nextLayerID++;
        this.activityRegularizer = null;
        this.inputSpec = null;
        this.supportsMasking = false;
        // These properties will be set upon call of this.build()
        this._trainableWeights = [];
        this._nonTrainableWeights = [];
        this._losses = [];
        this._updates = [];
        this._built = false;
        /*
          These lists will be filled via successive calls
          to this.addInboundNode().
         */ this.inboundNodes = [];
        this.outboundNodes = [];
        let name = args.name;
        if (!name) {
            const prefix = this.getClassName();
            name = $khD6O.toSnakeCase(prefix) + '_' + (0, $3qq1L.getUid)(prefix);
        }
        this.name = name;
        this.trainable_ = args.trainable == null ? true : args.trainable;
        if (args.inputShape != null || args.batchInputShape != null) {
            /*
              In this case we will later create an input layer
              to insert before the current layer
             */ let batchInputShape;
            if (args.batchInputShape != null) batchInputShape = args.batchInputShape;
            else if (args.inputShape != null) {
                let batchSize = null;
                if (args.batchSize != null) batchSize = args.batchSize;
                batchInputShape = [
                    batchSize
                ].concat(args.inputShape);
            }
            this.batchInputShape = batchInputShape;
            // Set dtype.
            let dtype = args.dtype;
            if (dtype == null) dtype = args.inputDType;
            if (dtype == null) dtype = 'float32';
            this.dtype = dtype;
        }
        if (args.weights != null) this.initialWeights = args.weights;
        else this.initialWeights = null;
        // The value of `_refCount` is initialized to null. When the layer is used
        // in a symbolic way for the first time, it will be set to 1.
        this._refCount = null;
        this.fastWeightInitDuringBuild = false;
    }
    /**
     * Converts a layer and its index to a unique (immutable type) name.
     * This function is used internally with `this.containerNodes`.
     * @param layer The layer.
     * @param nodeIndex The layer's position (e.g. via enumerate) in a list of
     *   nodes.
     *
     * @returns The unique name.
     */ static nodeKey(layer, nodeIndex) {
        return layer.name + '_ib-' + nodeIndex.toString();
    }
    /**
     * Returns this.inboundNode at index nodeIndex.
     *
     * Porting note: This is a replacement for _get_node_attribute_at_index()
     * @param nodeIndex
     * @param attrName The name of the attribute related to request for this node.
     */ getNodeAtIndex(nodeIndex, attrName) {
        if (this.inboundNodes.length === 0) throw new (0, $jVuYK.RuntimeError)('The layer has never been called ' + `and thus has no defined ${attrName}.`);
        if (this.inboundNodes.length <= nodeIndex) throw new (0, $jVuYK.ValueError)(`Asked to get ${attrName} at node ${nodeIndex}, ` + `but the layer has only ${this.inboundNodes.length} inbound nodes.`);
        return this.inboundNodes[nodeIndex];
    }
    /**
     * Retrieves the input tensor(s) of a layer at a given node.
     *
     * @param nodeIndex Integer, index of the node from which to retrieve the
     *   attribute. E.g. `nodeIndex=0` will correspond to the first time the layer
     *   was called.
     *
     * @return A tensor (or list of tensors if the layer has multiple inputs).
     */ getInputAt(nodeIndex) {
        return $khD6O.singletonOrArray(this.getNodeAtIndex(nodeIndex, 'input').inputTensors);
    }
    /**
     * Retrieves the output tensor(s) of a layer at a given node.
     *
     * @param nodeIndex Integer, index of the node from which to retrieve the
     *   attribute. E.g. `nodeIndex=0` will correspond to the first time the layer
     *   was called.
     *
     * @return A tensor (or list of tensors if the layer has multiple outputs).
     */ getOutputAt(nodeIndex) {
        return $khD6O.singletonOrArray(this.getNodeAtIndex(nodeIndex, 'output').outputTensors);
    }
    // Properties
    /**
     * Retrieves the input tensor(s) of a layer.
     *
     * Only applicable if the layer has exactly one inbound node,
     * i.e. if it is connected to one incoming layer.
     *
     * @return Input tensor or list of input tensors.
     *
     * @exception AttributeError if the layer is connected to more than one
     *   incoming layers.
     */ get input() {
        if (this.inboundNodes.length > 1) throw new (0, $jVuYK.AttributeError)(`Layer ${this.name}` + ' has multiple inbound nodes, ' + 'hence the notion of "layer input" ' + 'is ill-defined. ' + 'Use `getInputAt(nodeIndex)` instead.');
        else if (this.inboundNodes.length === 0) throw new (0, $jVuYK.AttributeError)(`Layer ${this.name}` + ' is not connected, no input to return.');
        return $khD6O.singletonOrArray(this.getNodeAtIndex(0, 'input').inputTensors);
    }
    /**
     * Retrieves the output tensor(s) of a layer.
     *
     * Only applicable if the layer has exactly one inbound node,
     * i.e. if it is connected to one incoming layer.
     *
     * @return Output tensor or list of output tensors.
     *
     * @exception AttributeError if the layer is connected to more than one
     *   incoming layers.
     */ get output() {
        if (this.inboundNodes.length === 0) throw new (0, $jVuYK.AttributeError)(`Layer ${this.name}` + ' has no inbound nodes.');
        if (this.inboundNodes.length > 1) throw new (0, $jVuYK.AttributeError)(`Layer ${this.name}` + ' has multiple inbound nodes, ' + 'hence the notion of "layer output" ' + 'is ill-defined. ' + 'Use `getOutputAt(nodeIndex)` instead.');
        return $khD6O.singletonOrArray(this.getNodeAtIndex(0, 'output').outputTensors);
    }
    get losses() {
        return this._losses;
    }
    /**
     * Retrieves the Layer's current loss values.
     *
     * Used for regularizers during training.
     */ calculateLosses() {
        // Porting Node: This is an augmentation to Layer.loss in PyKeras.
        //   In PyKeras, Layer.loss returns symbolic tensors. Here a concrete
        //   Tensor (specifically Scalar) values are returned. This is due to the
        //   imperative backend.
        return this.losses.map((lossFn)=>lossFn());
    }
    get updates() {
        return this._updates;
    }
    get built() {
        return this._built;
    }
    set built(built) {
        this._built = built;
    }
    get trainable() {
        return this.trainable_;
    }
    set trainable(trainable) {
        this._trainableWeights.forEach((w)=>w.trainable = trainable);
        this.trainable_ = trainable;
    }
    get trainableWeights() {
        if (this.trainable_) return this._trainableWeights.filter((w)=>w.trainable);
        else return [];
    }
    set trainableWeights(weights) {
        this._trainableWeights = weights;
    }
    get nonTrainableWeights() {
        if (this.trainable) return this._trainableWeights.filter((w)=>!w.trainable).concat(this._nonTrainableWeights);
        else return this._trainableWeights.concat(this._nonTrainableWeights);
    }
    set nonTrainableWeights(weights) {
        this._nonTrainableWeights = weights;
    }
    /**
     * The concatenation of the lists trainableWeights and nonTrainableWeights
     * (in this order).
     */ get weights() {
        return this.trainableWeights.concat(this.nonTrainableWeights);
    }
    get stateful() {
        return this._stateful;
    }
    /**
     * Reset the states of the layer.
     *
     * This method of the base Layer class is essentially a no-op.
     * Subclasses that are stateful (e.g., stateful RNNs) should override this
     * method.
     */ resetStates() {
        if (!this.stateful) throw new Error("Cannot call the resetStates() method of a non-stateful Layer object.");
    }
    /**
     * Checks compatibility between the layer and provided inputs.
     *
     * This checks that the tensor(s) `input`
     * verify the input assumptions of the layer
     * (if any). If not, exceptions are raised.
     *
     * @param inputs Input tensor or list of input tensors.
     *
     * @exception ValueError in case of mismatch between
     *   the provided inputs and the expectations of the layer.
     */ assertInputCompatibility(inputs) {
        inputs = $khD6O.toList(inputs);
        if (this.inputSpec == null || this.inputSpec.length === 0) return;
        const inputSpec = $khD6O.toList(this.inputSpec);
        if (inputs.length !== inputSpec.length) throw new (0, $jVuYK.ValueError)(`Layer ${this.name} expects ${inputSpec.length} inputs, ` + `but it received ${inputs.length} input tensors. ` + `Input received: ${inputs}`);
        for(let inputIndex = 0; inputIndex < inputs.length; inputIndex++){
            const x = inputs[inputIndex];
            const spec = inputSpec[inputIndex];
            if (spec == null) continue;
            // Check ndim.
            const ndim = x.rank;
            if (spec.ndim != null) {
                if (ndim !== spec.ndim) throw new (0, $jVuYK.ValueError)(`Input ${inputIndex} is incompatible with layer ${this.name}: ` + `expected ndim=${spec.ndim}, found ndim=${ndim}`);
            }
            if (spec.maxNDim != null) {
                if (ndim > spec.maxNDim) throw new (0, $jVuYK.ValueError)(`Input ${inputIndex} is incompatible with layer ${this.name}` + `: expected max_ndim=${spec.maxNDim}, found ndim=${ndim}`);
            }
            if (spec.minNDim != null) {
                if (ndim < spec.minNDim) throw new (0, $jVuYK.ValueError)(`Input ${inputIndex} is incompatible with layer ${this.name}` + `: expected min_ndim=${spec.minNDim}, found ndim=${ndim}.`);
            }
            // Check dtype.
            if (spec.dtype != null) {
                if (x.dtype !== spec.dtype) throw new (0, $jVuYK.ValueError)(`Input ${inputIndex} is incompatible with layer ${this.name} ` + `: expected dtype=${spec.dtype}, found dtype=${x.dtype}.`);
            }
            // Check specific shape axes.
            if (spec.axes) {
                const xShape = x.shape;
                for(const key in spec.axes){
                    const axis = Number(key);
                    const value = spec.axes[key];
                    // Perform Python-style slicing in case axis < 0;
                    // TODO(cais): Use https://github.com/alvivi/typescript-underscore to
                    // ensure type safety through Underscore calls.
                    const xShapeAtAxis = axis >= 0 ? xShape[axis] : xShape[xShape.length + axis];
                    if (value != null && [
                        value,
                        null
                    ].indexOf(xShapeAtAxis) === -1) throw new (0, $jVuYK.ValueError)(`Input ${inputIndex} is incompatible with layer ` + `${this.name}: expected axis ${axis} of input shape to ` + `have value ${value} but got shape ${xShape}.`);
                }
            }
            // Check shape.
            if (spec.shape != null) for(let i = 0; i < spec.shape.length; ++i){
                const specDim = spec.shape[i];
                const dim = x.shape[i];
                if (specDim != null && dim != null) {
                    if (specDim !== dim) throw new (0, $jVuYK.ValueError)(`Input ${inputIndex} is incompatible with layer ` + `${this.name}: expected shape=${spec.shape}, ` + `found shape=${x.shape}.`);
                }
            }
        }
    }
    /**
     * This is where the layer's logic lives.
     *
     * @param inputs Input tensor, or list/tuple of input tensors.
     * @param kwargs Additional keyword arguments.
     *
     * @return A tensor or list/tuple of tensors.
     */ call(inputs, kwargs) {
        return inputs;
    }
    invokeCallHook(inputs, kwargs) {
        if (this._callHook != null) this._callHook(inputs, kwargs);
    }
    /**
     * Set call hook.
     * This is currently used for testing only.
     * @param callHook
     */ setCallHook(callHook) {
        this._callHook = callHook;
    }
    /**
     * Clear call hook.
     * This is currently used for testing only.
     */ clearCallHook() {
        this._callHook = null;
    }
    /**
     * Builds or executes a `Layer`'s logic.
     *
     * When called with `tf.Tensor`(s), execute the `Layer`'s computation and
     * return Tensor(s). For example:
     *
     * ```js
     * const denseLayer = tf.layers.dense({
     *   units: 1,
     *   kernelInitializer: 'zeros',
     *   useBias: false
     * });
     *
     * // Invoke the layer's apply() method with a `tf.Tensor` (with concrete
     * // numeric values).
     * const input = tf.ones([2, 2]);
     * const output = denseLayer.apply(input);
     *
     * // The output's value is expected to be [[0], [0]], due to the fact that
     * // the dense layer has a kernel initialized to all-zeros and does not have
     * // a bias.
     * output.print();
     * ```
     *
     * When called with `tf.SymbolicTensor`(s), this will prepare the layer for
     * future execution.  This entails internal book-keeping on shapes of
     * expected Tensors, wiring layers together, and initializing weights.
     *
     * Calling `apply` with `tf.SymbolicTensor`s are typically used during the
     * building of non-`tf.Sequential` models. For example:
     *
     * ```js
     * const flattenLayer = tf.layers.flatten();
     * const denseLayer = tf.layers.dense({units: 1});
     *
     * // Use tf.layers.input() to obtain a SymbolicTensor as input to apply().
     * const input = tf.input({shape: [2, 2]});
     * const output1 = flattenLayer.apply(input);
     *
     * // output1.shape is [null, 4]. The first dimension is the undetermined
     * // batch size. The second dimension comes from flattening the [2, 2]
     * // shape.
     * console.log(JSON.stringify(output1.shape));
     *
     * // The output SymbolicTensor of the flatten layer can be used to call
     * // the apply() of the dense layer:
     * const output2 = denseLayer.apply(output1);
     *
     * // output2.shape is [null, 1]. The first dimension is the undetermined
     * // batch size. The second dimension matches the number of units of the
     * // dense layer.
     * console.log(JSON.stringify(output2.shape));
     *
     * // The input and output can be used to construct a model that consists
     * // of the flatten and dense layers.
     * const model = tf.model({inputs: input, outputs: output2});
     * ```
     *
     * @param inputs a `tf.Tensor` or `tf.SymbolicTensor` or an Array of them.
     * @param kwargs Additional keyword arguments to be passed to `call()`.
     *
     * @return Output of the layer's `call` method.
     *
     * @exception ValueError error in case the layer is missing shape information
     *   for its `build` call.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ // Porting Note: This is a replacement for __call__() in Python.
    apply(inputs, kwargs) {
        kwargs = kwargs || {};
        this.assertNotDisposed();
        // Ensure inputs are all the same type.
        const inputsList = $khD6O.toList(inputs);
        let allAreSymbolic = true;
        for (const input of inputsList)if (!(input instanceof $8fe79700dcc8f26c$export$c6d6977640680568)) {
            allAreSymbolic = false;
            break;
        }
        let noneAreSymbolic = true;
        for (const input of inputsList)if (input instanceof $8fe79700dcc8f26c$export$c6d6977640680568) {
            noneAreSymbolic = false;
            break;
        }
        if (allAreSymbolic === noneAreSymbolic) throw new (0, $jVuYK.ValueError)("Arguments to apply() must be all SymbolicTensors or all Tensors");
        // TODO(michaelterry): nameScope() may not be necessary.
        return (0, $hQ5cH.nameScope)(this.name, ()=>{
            // Handle laying building (weight creating, input spec locking).
            if (!this.built) {
                /*
                  Throw exceptions in case the input is not compatible
                  with the inputSpec specified in the layer constructor.
                 */ this.assertInputCompatibility(inputs);
                // Collect input shapes to build layer.
                const inputShapes = [];
                for (const xElem of $khD6O.toList(inputs))inputShapes.push(xElem.shape);
                this.build($khD6O.singletonOrArray(inputShapes));
                this.built = true;
                // Load weights that were specified at layer instantiation.
                if (this.initialWeights) this.setWeights(this.initialWeights);
                if (this._refCount === null && noneAreSymbolic) // The first use of this layer is a non-symbolic call, set ref count
                // to 1 so the Layer can be properly disposed if its dispose() method
                // is called.
                this._refCount = 1;
            }
            /*
              Throw exceptions in case the input is not compatible
              with the inputSpec set at build time.
            */ this.assertInputCompatibility(inputs);
            // Handle mask propagation.
            // TODO(michaelterry): Mask propagation not currently implemented.
            // Actually call the layer, collecting output(s), mask(s), and shape(s).
            if (noneAreSymbolic) {
                let output = this.call(inputs, kwargs);
                // TODO(michaelterry): Compute the outputMask
                // If the layer returns tensors from its inputs, unmodified,
                // we copy them to avoid loss of tensor metadata.
                const outputList = $khD6O.toList(output);
                const outputListCopy = [];
                // TODO(michaelterry): This copying may not be necessary given our eager
                // backend.
                for (let x of outputList){
                    if (inputsList.indexOf(x) !== -1) x = x.clone();
                    outputListCopy.push(x);
                }
                output = $khD6O.singletonOrArray(outputListCopy);
                if (this.activityRegularizer != null) throw new (0, $jVuYK.NotImplementedError)("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
                // TODO(michaelterry): Call addInboundNode()?
                return output;
            } else {
                const inputShape = $8fe79700dcc8f26c$var$collectInputShape(inputs);
                const outputShape = this.computeOutputShape(inputShape);
                let output;
                const outputDType = $8fe79700dcc8f26c$var$guessOutputDType(inputs);
                this.warnOnIncompatibleInputShape(Array.isArray(inputs) ? inputShape[0] : inputShape);
                if (outputShape != null && outputShape.length > 0 && Array.isArray(outputShape[0])) // We have multiple output shapes. Create multiple output tensors.
                output = outputShape.map((shape, index)=>new $8fe79700dcc8f26c$export$c6d6977640680568(outputDType, shape, this, $khD6O.toList(inputs), kwargs, this.name, index));
                else output = new $8fe79700dcc8f26c$export$c6d6977640680568(outputDType, outputShape, this, $khD6O.toList(inputs), kwargs, this.name);
                /*
                  Add an inbound node to the layer, so that it keeps track
                  of the call and of all new variables created during the call.
                  This also updates the layer history of the output tensor(s).
                  If the input tensor(s) had no previous history,
                  this does nothing.
                */ this.addInboundNode(inputs, output, null, null, inputShape, outputShape, kwargs);
                this._refCount++;
                if (this.activityRegularizer != null) throw new (0, $jVuYK.NotImplementedError)("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
                return output;
            }
        });
    }
    /**
     * Check compatibility between input shape and this layer's batchInputShape.
     *
     * Print warning if any incompatibility is found.
     *
     * @param inputShape Input shape to be checked.
     */ warnOnIncompatibleInputShape(inputShape) {
        if (this.batchInputShape == null) return;
        else if (inputShape.length !== this.batchInputShape.length) console.warn(`The rank of the input tensor provided (shape: ` + `${JSON.stringify(inputShape)}) does not match that of the ` + `batchInputShape (${JSON.stringify(this.batchInputShape)}) ` + `of the layer ${this.name}`);
        else {
            let dimMismatch = false;
            this.batchInputShape.forEach((dimension, i)=>{
                if (dimension != null && inputShape[i] != null && inputShape[i] !== dimension) dimMismatch = true;
            });
            if (dimMismatch) console.warn(`The shape of the input tensor ` + `(${JSON.stringify(inputShape)}) does not ` + `match the expectation of layer ${this.name}: ` + `${JSON.stringify(this.batchInputShape)}`);
        }
    }
    /**
     * Retrieves the output shape(s) of a layer.
     *
     * Only applicable if the layer has only one inbound node, or if all inbound
     * nodes have the same output shape.
     *
     * @returns Output shape or shapes.
     * @throws AttributeError: if the layer is connected to more than one incoming
     *   nodes.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ get outputShape() {
        if (this.inboundNodes == null || this.inboundNodes.length === 0) throw new (0, $jVuYK.AttributeError)(`The layer ${this.name} has never been called and thus has no ` + `defined output shape.`);
        const allOutputShapes = [];
        for (const node of this.inboundNodes){
            const shapeString = JSON.stringify(node.outputShapes);
            if (allOutputShapes.indexOf(shapeString) === -1) allOutputShapes.push(shapeString);
        }
        if (allOutputShapes.length === 1) {
            const outputShapes = this.inboundNodes[0].outputShapes;
            if (Array.isArray(outputShapes) && Array.isArray(outputShapes[0]) && outputShapes.length === 1) return outputShapes[0];
            else return outputShapes;
        } else throw new (0, $jVuYK.AttributeError)(`The layer ${this.name} has multiple inbound nodes with different ` + `output shapes. Hence the notion of "output shape" is ill-defined ` + `for the layer.`);
    }
    /**
     * Counts the total number of numbers (e.g., float32, int32) in the
     * weights.
     *
     * @returns An integer count.
     * @throws RuntimeError: If the layer is not built yet (in which case its
     *   weights are not defined yet.)
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ countParams() {
        if (!this.built) throw new (0, $jVuYK.RuntimeError)(`You tried to call countParams() on ${this.name}, ` + `but the layer is not built yet. Build it first by calling ` + `build(batchInputShape).`);
        return $5YCEz.countParamsInWeights(this.weights);
    }
    /**
     * Creates the layer weights.
     *
     * Must be implemented on all layers that have weights.
     *
     * Called when apply() is called to construct the weights.
     *
     * @param inputShape A `Shape` or array of `Shape` (unused).
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ build(inputShape) {
        this.built = true;
    }
    /**
     * Returns the current values of the weights of the layer.
     *
     * @param trainableOnly Whether to get the values of only trainable weights.
     * @returns Weight values as an `Array` of `tf.Tensor`s.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ getWeights(trainableOnly = false) {
        return (0, $7muWV.batchGetValue)(trainableOnly ? this.trainableWeights : this.weights);
    }
    /**
     * Sets the weights of the layer, from Tensors.
     *
     * @param weights a list of Tensors. The number of arrays and their shape
     *   must match number of the dimensions of the weights of the layer (i.e.
     *   it should match the output of `getWeights`).
     *
     * @exception ValueError If the provided weights list does not match the
     *   layer's specifications.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ setWeights(weights) {
        (0, $9c0Qr.tidy)(()=>{
            const params = this.weights;
            if (params.length !== weights.length) // TODO(cais): Restore the following and use `providedWeights`, instead
            // of `weights` in the error message, once the deeplearn.js bug is
            // fixed: https://github.com/PAIR-code/deeplearnjs/issues/498 const
            // providedWeights = JSON.stringify(weights).slice(0, 50);
            throw new (0, $jVuYK.ValueError)(`You called setWeights(weights) on layer "${this.name}" ` + `with a weight list of length ${weights.length}, ` + `but the layer was expecting ${params.length} weights. ` + `Provided weights: ${weights}...`);
            if (params.length === 0) return;
            const weightValueTuples = [];
            const paramValues = (0, $7muWV.batchGetValue)(params);
            for(let i = 0; i < paramValues.length; ++i){
                const pv = paramValues[i];
                const p = params[i];
                const w = weights[i];
                if (!(0, $wx9lK).arraysEqual(pv.shape, w.shape)) throw new (0, $jVuYK.ValueError)(`Layer weight shape ${pv.shape} ` + `not compatible with provided weight shape ${w.shape}`);
                weightValueTuples.push([
                    p,
                    w
                ]);
            }
            (0, $7muWV.batchSetValue)(weightValueTuples);
        });
    }
    /**
     * Adds a weight variable to the layer.
     *
     * @param name Name of the new weight variable.
     * @param shape The shape of the weight.
     * @param dtype The dtype of the weight.
     * @param initializer An initializer instance.
     * @param regularizer A regularizer instance.
     * @param trainable Whether the weight should be trained via backprop or not
     *   (assuming that the layer itself is also trainable).
     * @param constraint An optional trainable.
     * @return The created weight variable.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ addWeight(name, shape, dtype, initializer, regularizer, trainable, constraint, getInitializerFunc) {
        // Reject duplicate weight names.
        if (this._addedWeightNames.indexOf(name) !== -1) throw new (0, $jVuYK.ValueError)(`Duplicate weight name ${name} for layer ${this.name}`);
        this._addedWeightNames.push(name);
        if (dtype == null) dtype = 'float32';
        if (this.fastWeightInitDuringBuild) initializer = getInitializerFunc != null ? getInitializerFunc() : (0, $fQ95p.getInitializer)('zeros');
        const initValue = initializer.apply(shape, dtype);
        const weight = new (0, $7muWV.LayerVariable)(initValue, dtype, name, trainable, constraint);
        initValue.dispose();
        // Request backend not to dispose the weights of the model on scope() exit.
        if (regularizer != null) this.addLoss(()=>regularizer.apply(weight.read()));
        if (trainable == null) trainable = true;
        if (trainable) this._trainableWeights.push(weight);
        else this._nonTrainableWeights.push(weight);
        return weight;
    }
    /**
     * Set the fast-weight-initialization flag.
     *
     * In cases where the initialized weight values will be immediately
     * overwritten by loaded weight values during model loading, setting
     * the flag to `true` saves unnecessary calls to potentially expensive
     * initializers and speeds up the loading process.
     *
     * @param value Target value of the flag.
     */ setFastWeightInitDuringBuild(value) {
        this.fastWeightInitDuringBuild = value;
    }
    /**
     * Add losses to the layer.
     *
     * The loss may potentially be conditional on some inputs tensors,
     * for instance activity losses are conditional on the layer's inputs.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ addLoss(losses) {
        if (losses == null || Array.isArray(losses) && losses.length === 0) return;
        // Update this.losses
        losses = $khD6O.toList(losses);
        if (this._losses !== undefined && this._losses !== null) this.losses.push(...losses);
    }
    /**
     * Computes the output shape of the layer.
     *
     * Assumes that the layer will be built to match that input shape provided.
     *
     * @param inputShape A shape (tuple of integers) or a list of shape tuples
     *   (one per output tensor of the layer). Shape tuples can include null for
     *   free dimensions, instead of an integer.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ computeOutputShape(inputShape) {
        return inputShape;
    }
    /**
     * Computes an output mask tensor.
     *
     * @param inputs Tensor or list of tensors.
     * @param mask Tensor or list of tensors.
     *
     * @return null or a tensor (or list of tensors, one per output tensor of the
     * layer).
     */ computeMask(inputs, mask) {
        if (!this.supportsMasking) {
            if (mask != null) {
                if (Array.isArray(mask)) mask.forEach((maskElement)=>{
                    if (maskElement != null) throw new TypeError(`Layer ${this.name} does not support masking, ` + 'but was passed an inputMask.');
                });
                else throw new TypeError(`Layer ${this.name} does not support masking, ` + 'but was passed an inputMask.');
            }
            // masking not explicitly supported: return null as mask
            return null;
        }
        // if masking is explictly supported, by default
        // carry over the input mask
        return mask;
    }
    /**
     * Internal method to create an inbound node for the layer.
     *
     * @param inputTensors List of input tensors.
     * @param outputTensors List of output tensors.
     * @param inputMasks List of input masks (a mask can be a tensor, or null).
     * @param outputMasks List of output masks (a mask can be a tensor, or null).
     * @param inputShapes List of input shape tuples.
     * @param outputShapes List of output shape tuples.
     * @param kwargs Dictionary of keyword arguments that were passed to the
     *   `call` method of the layer at the call that created the node.
     */ addInboundNode(inputTensors, outputTensors, inputMasks, outputMasks, inputShapes, outputShapes, kwargs = null) {
        const inputTensorList = $khD6O.toList(inputTensors);
        outputTensors = $khD6O.toList(outputTensors);
        inputMasks = $khD6O.toList(inputMasks);
        outputMasks = $khD6O.toList(outputMasks);
        inputShapes = $5sw3q.normalizeShapeList(inputShapes);
        outputShapes = $5sw3q.normalizeShapeList(outputShapes);
        // Collect input tensor(s) coordinates.
        const inboundLayers = [];
        const nodeIndices = [];
        const tensorIndices = [];
        for (const x of inputTensorList){
            /*
             * TODO(michaelterry): Keras adds this value to tensors; it's not
             * clear whether we'll use this or not.
             */ inboundLayers.push(x.sourceLayer);
            nodeIndices.push(x.nodeIndex);
            tensorIndices.push(x.tensorIndex);
        }
        // Create node, add it to inbound nodes.
        // (This call has side effects.)
        // tslint:disable-next-line:no-unused-expression
        new $8fe79700dcc8f26c$export$85c928794f8d04d4({
            outboundLayer: this,
            inboundLayers: inboundLayers,
            nodeIndices: nodeIndices,
            tensorIndices: tensorIndices,
            inputTensors: inputTensorList,
            outputTensors: outputTensors,
            inputMasks: inputMasks,
            outputMasks: outputMasks,
            inputShapes: inputShapes,
            outputShapes: outputShapes
        }, kwargs);
        // Update tensor history
        for(let i = 0; i < outputTensors.length; i++){
            // TODO(michaelterry: _uses_learning_phase not tracked.
            outputTensors[i].sourceLayer = this;
            outputTensors[i].nodeIndex = this.inboundNodes.length - 1;
            outputTensors[i].tensorIndex = i;
        }
    }
    /**
     * Returns the config of the layer.
     *
     * A layer config is a TS dictionary (serializable)
     * containing the configuration of a layer.
     * The same layer can be reinstantiated later
     * (without its trained weights) from this configuration.
     *
     * The config of a layer does not include connectivity
     * information, nor the layer class name.  These are handled
     * by 'Container' (one layer of abstraction above).
     *
     * Porting Note: The TS dictionary follows TS naming standards for
     * keys, and uses tfjs-layers type-safe Enums.  Serialization methods
     * should use a helper function to convert to the pythonic storage
     * standard. (see serialization_utils.convertTsToPythonic)
     *
     * @returns TS dictionary of configuration.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ getConfig() {
        const config = {
            name: this.name,
            trainable: this.trainable
        };
        if (this.batchInputShape != null) config['batchInputShape'] = this.batchInputShape;
        if (this.dtype != null) config['dtype'] = this.dtype;
        return config;
    }
    /**
     * Dispose the weight variables that this Layer instance holds.
     *
     * @returns {number} Number of disposed variables.
     */ disposeWeights() {
        this.weights.forEach((weight)=>weight.dispose());
        return this.weights.length;
    }
    assertNotDisposed() {
        if (this._refCount === 0) throw new Error(`Layer '${this.name}' is already disposed.`);
    }
    /**
     * Attempt to dispose layer's weights.
     *
     * This method decreases the reference count of the Layer object by 1.
     *
     * A Layer is reference-counted. Its reference count is incremented by 1
     * the first item its `apply()` method is called and when it becomes a part
     * of a new `Node` (through calling the `apply()` method on a
     * `tf.SymbolicTensor`).
     *
     * If the reference count of a Layer becomes 0, all the weights will be
     * disposed and the underlying memory (e.g., the textures allocated in WebGL)
     * will be freed.
     *
     * Note: If the reference count is greater than 0 after the decrement, the
     * weights of the Layer will *not* be disposed.
     *
     * After a Layer is disposed, it cannot be used in calls such as `apply()`,
     * `getWeights()` or `setWeights()` anymore.
     *
     * @returns A DisposeResult Object with the following fields:
     *   - refCountAfterDispose: The reference count of the Container after this
     *     `dispose()` call.
     *   - numDisposedVariables: Number of `tf.Variable`s (i.e., weights) disposed
     *     during this `dispose()` call.
     * @throws {Error} If the layer is not built yet, or if the layer has already
     *   been disposed.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ dispose() {
        if (!this.built) throw new Error(`Cannot dispose Layer ${this.name} because it has not been ` + `built yet.`);
        if (this._refCount === null) throw new Error(`Cannot dispose Layer ${this.name} because it has not been used ` + `yet.`);
        this.assertNotDisposed();
        let numDisposedVariables = 0;
        if (--this._refCount === 0) numDisposedVariables = this.disposeWeights();
        return {
            refCountAfterDispose: this._refCount,
            numDisposedVariables: numDisposedVariables
        };
    }
}
/**
 * Collects the input shape(s) of a list of `tf.Tensor`s or
 * `tf.SymbolicTensor`s.
 *
 * TODO(michaelterry): Update PyKeras docs (backport).
 *
 * @param inputTensors List of input tensors (or single input tensor).
 *
 * @return List of shape tuples (or single tuple), one tuple per input.
 */ function $8fe79700dcc8f26c$var$collectInputShape(inputTensors) {
    inputTensors = $khD6O.toList(inputTensors);
    const shapes = [];
    for (const x of inputTensors)shapes.push(x.shape);
    return $khD6O.singletonOrArray(shapes);
}
/**
 * Guesses output dtype based on inputs.
 *
 * At present, just returns 'float32' for any input.
 *
 * @param inputTensors List of input tensors (or single input tensor).
 *
 * @return The guessed DType. At present, always returns 'float32'.
 */ function $8fe79700dcc8f26c$var$guessOutputDType(inputTensors) {
    return 'float32';
}
function $8fe79700dcc8f26c$export$6d61b4ed0b6fb596(tensor, layer, nodeIndex) {
    if (layer == null || nodeIndex != null && nodeIndex > 0) {
        layer = tensor.sourceLayer;
        nodeIndex = tensor.nodeIndex;
    }
    if (layer.inboundNodes.length === 0) return [
        tensor
    ];
    else {
        const node = layer.inboundNodes[nodeIndex];
        if (node.inboundLayers.length === 0) return node.inputTensors;
        else {
            const sourceTensors = [];
            for(let i = 0; i < node.inboundLayers.length; i++){
                const x = node.inputTensors[i];
                const layer = node.inboundLayers[i];
                const nodeIndex = node.nodeIndices[i];
                const previousSources = $8fe79700dcc8f26c$export$6d61b4ed0b6fb596(x, layer, nodeIndex);
                // Avoid input redundancy.
                for (const x of previousSources)if (sourceTensors.indexOf(x) === -1) sourceTensors.push(x);
            }
            return sourceTensors;
        }
    }
}

});
parcelRegister("hQ5cH", function(module, exports) {

$parcel$export(module.exports, "checkDataFormat", () => $cfcb5459ee0cac95$export$f5f6472a2b993816);
$parcel$export(module.exports, "checkInterpolationFormat", () => $cfcb5459ee0cac95$export$2c8c51ca0cb16cd2);
$parcel$export(module.exports, "checkPaddingMode", () => $cfcb5459ee0cac95$export$a6c1e84f1d33d64d);
$parcel$export(module.exports, "checkPoolMode", () => $cfcb5459ee0cac95$export$4ac7885ddd005702);
$parcel$export(module.exports, "nameScope", () => $cfcb5459ee0cac95$export$e820b4f57a8e33d1);
$parcel$export(module.exports, "getScopedTensorName", () => $cfcb5459ee0cac95$export$ff30fd7baa750729);
$parcel$export(module.exports, "getUniqueTensorName", () => $cfcb5459ee0cac95$export$9227bff0c10d827e);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Common functions for TensorFlow.js Layers.
 */ 
var $iC0mP = parcelRequire("iC0mP");

var $khD6O = parcelRequire("khD6O");
// A map from the requested scoped name of a Tensor to the number of Tensors
// wanting that name so far.  This allows enforcing name uniqueness by appending
// an incrementing index, e.g. scope/name, scope/name_1, scope/name_2, etc.
const $cfcb5459ee0cac95$var$nameMap = new Map();
function $cfcb5459ee0cac95$export$f5f6472a2b993816(value) {
    (0, $khD6O.checkStringTypeUnionValue)((0, $iC0mP.VALID_DATA_FORMAT_VALUES), 'DataFormat', value);
}
function $cfcb5459ee0cac95$export$2c8c51ca0cb16cd2(value) {
    (0, $khD6O.checkStringTypeUnionValue)((0, $iC0mP.VALID_INTERPOLATION_FORMAT_VALUES), 'InterpolationFormat', value);
}
function $cfcb5459ee0cac95$export$a6c1e84f1d33d64d(value) {
    (0, $khD6O.checkStringTypeUnionValue)((0, $iC0mP.VALID_PADDING_MODE_VALUES), 'PaddingMode', value);
}
function $cfcb5459ee0cac95$export$4ac7885ddd005702(value) {
    (0, $khD6O.checkStringTypeUnionValue)((0, $iC0mP.VALID_POOL_MODE_VALUES), 'PoolMode', value);
}
const $cfcb5459ee0cac95$var$_nameScopeStack = [];
const $cfcb5459ee0cac95$var$_nameScopeDivider = '/';
function $cfcb5459ee0cac95$export$e820b4f57a8e33d1(name, fn) {
    $cfcb5459ee0cac95$var$_nameScopeStack.push(name);
    try {
        const val = fn();
        $cfcb5459ee0cac95$var$_nameScopeStack.pop();
        return val;
    } catch (e) {
        $cfcb5459ee0cac95$var$_nameScopeStack.pop();
        throw e;
    }
}
/**
 * Get the current namescope as a flat, concatenated string.
 */ function $cfcb5459ee0cac95$var$currentNameScopePrefix() {
    if ($cfcb5459ee0cac95$var$_nameScopeStack.length === 0) return '';
    else return $cfcb5459ee0cac95$var$_nameScopeStack.join($cfcb5459ee0cac95$var$_nameScopeDivider) + $cfcb5459ee0cac95$var$_nameScopeDivider;
}
function $cfcb5459ee0cac95$export$ff30fd7baa750729(tensorName) {
    if (!$cfcb5459ee0cac95$export$f372abc09dacf0d5(tensorName)) throw new Error('Not a valid tensor name: \'' + tensorName + '\'');
    return $cfcb5459ee0cac95$var$currentNameScopePrefix() + tensorName;
}
function $cfcb5459ee0cac95$export$9227bff0c10d827e(scopedName) {
    if (!$cfcb5459ee0cac95$export$f372abc09dacf0d5(scopedName)) throw new Error('Not a valid tensor name: \'' + scopedName + '\'');
    if (!$cfcb5459ee0cac95$var$nameMap.has(scopedName)) $cfcb5459ee0cac95$var$nameMap.set(scopedName, 0);
    const index = $cfcb5459ee0cac95$var$nameMap.get(scopedName);
    $cfcb5459ee0cac95$var$nameMap.set(scopedName, $cfcb5459ee0cac95$var$nameMap.get(scopedName) + 1);
    if (index > 0) {
        const result = `${scopedName}_${index}`;
        // Mark the composed name as used in case someone wants
        // to call getUniqueTensorName("name_1").
        $cfcb5459ee0cac95$var$nameMap.set(result, 1);
        return result;
    } else return scopedName;
}
const $cfcb5459ee0cac95$var$tensorNameRegex = new RegExp(/^[A-Za-z0-9][-A-Za-z0-9\._\/]*$/);
function $cfcb5459ee0cac95$export$f372abc09dacf0d5(name) {
    return !!name.match($cfcb5459ee0cac95$var$tensorNameRegex);
}

});
parcelRegister("iC0mP", function(module, exports) {

$parcel$export(module.exports, "VALID_DATA_FORMAT_VALUES", () => $d8cc0f86ad40fc4b$export$57a9e614626b5380);
$parcel$export(module.exports, "VALID_INTERPOLATION_FORMAT_VALUES", () => $d8cc0f86ad40fc4b$export$b8823bf7d44e4d59);
$parcel$export(module.exports, "VALID_PADDING_MODE_VALUES", () => $d8cc0f86ad40fc4b$export$48aea51acf1bce87);
$parcel$export(module.exports, "VALID_POOL_MODE_VALUES", () => $d8cc0f86ad40fc4b$export$f450a7a6767a84d4);
$parcel$export(module.exports, "VALID_BIDIRECTIONAL_MERGE_MODES", () => $d8cc0f86ad40fc4b$export$954d8bae11304008);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const $d8cc0f86ad40fc4b$export$57a9e614626b5380 = [
    'channelsFirst',
    'channelsLast'
];
const $d8cc0f86ad40fc4b$export$b8823bf7d44e4d59 = [
    'nearest',
    'bilinear'
];
const $d8cc0f86ad40fc4b$export$48aea51acf1bce87 = [
    'valid',
    'same',
    'causal'
];
const $d8cc0f86ad40fc4b$export$f450a7a6767a84d4 = [
    'max',
    'avg'
];
const $d8cc0f86ad40fc4b$export$954d8bae11304008 = [
    'sum',
    'mul',
    'concat',
    'ave'
];
const $d8cc0f86ad40fc4b$export$96db941b47dbf9ff = [
    'temporal'
];

});


parcelRegister("fQ95p", function(module, exports) {

$parcel$export(module.exports, "Initializer", () => $b882c2b55c65d68f$export$9e14a7677ef1423c);
$parcel$export(module.exports, "Zeros", () => $b882c2b55c65d68f$export$7a572cb9dc6aa81b);
$parcel$export(module.exports, "Ones", () => $b882c2b55c65d68f$export$30750dcb47d2f6b);
$parcel$export(module.exports, "Constant", () => $b882c2b55c65d68f$export$3c508fb3f8ac1ad4);
$parcel$export(module.exports, "RandomUniform", () => $b882c2b55c65d68f$export$29e2b6f5e4b82e2f);
$parcel$export(module.exports, "RandomNormal", () => $b882c2b55c65d68f$export$66e863738cfcc40);
$parcel$export(module.exports, "TruncatedNormal", () => $b882c2b55c65d68f$export$5f0e8a39027050d5);
$parcel$export(module.exports, "Identity", () => $b882c2b55c65d68f$export$544bf02140fa9a77);
$parcel$export(module.exports, "VarianceScaling", () => $b882c2b55c65d68f$export$c2ba607ca0c6b5b3);
$parcel$export(module.exports, "GlorotUniform", () => $b882c2b55c65d68f$export$c820ee55503e6df3);
$parcel$export(module.exports, "GlorotNormal", () => $b882c2b55c65d68f$export$dcc636dfa962cdc9);
$parcel$export(module.exports, "HeNormal", () => $b882c2b55c65d68f$export$399f315e5cbd5eed);
$parcel$export(module.exports, "HeUniform", () => $b882c2b55c65d68f$export$4799f50fbef71375);
$parcel$export(module.exports, "LeCunNormal", () => $b882c2b55c65d68f$export$f0843b4cb97b93f5);
$parcel$export(module.exports, "LeCunUniform", () => $b882c2b55c65d68f$export$41b487c9c7cedfae);
$parcel$export(module.exports, "Orthogonal", () => $b882c2b55c65d68f$export$7d101801017ddeaf);
$parcel$export(module.exports, "serializeInitializer", () => $b882c2b55c65d68f$export$68de06a18c23bdbc);
$parcel$export(module.exports, "getInitializer", () => $b882c2b55c65d68f$export$558b7d1a338df84b);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dF7rq = parcelRequire("dF7rq");
var $iNZmA = parcelRequire("iNZmA");
var $r7fN6 = parcelRequire("r7fN6");
var $bhi4b = parcelRequire("bhi4b");
var $gOgMa = parcelRequire("gOgMa");
var $j7yUF = parcelRequire("j7yUF");
var $8AyuI = parcelRequire("8AyuI");
var $9c0Qr = parcelRequire("9c0Qr");
var $9PEYs = parcelRequire("9PEYs");
var $7y8Jw = parcelRequire("7y8Jw");
var $7KCJq = parcelRequire("7KCJq");

var $luRak = parcelRequire("luRak");

var $hQ5cH = parcelRequire("hQ5cH");

var $jVuYK = parcelRequire("jVuYK");

var $5Uypa = parcelRequire("5Uypa");

var $khD6O = parcelRequire("khD6O");

var $jBJAM = parcelRequire("jBJAM");
function $b882c2b55c65d68f$export$c2c5543c407dbda7(value) {
    (0, $khD6O.checkStringTypeUnionValue)((0, $5Uypa.VALID_FAN_MODE_VALUES), 'FanMode', value);
}
function $b882c2b55c65d68f$export$46d720aa775f5a50(value) {
    (0, $khD6O.checkStringTypeUnionValue)((0, $5Uypa.VALID_DISTRIBUTION_VALUES), 'Distribution', value);
}
class $b882c2b55c65d68f$export$9e14a7677ef1423c extends (0, $8AyuI).Serializable {
    fromConfigUsesCustomObjects() {
        return false;
    }
    getConfig() {
        return {};
    }
}
class $b882c2b55c65d68f$export$7a572cb9dc6aa81b extends $b882c2b55c65d68f$export$9e14a7677ef1423c {
    apply(shape, dtype) {
        return (0, $7KCJq.zeros)(shape, dtype);
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$7a572cb9dc6aa81b.className = 'Zeros';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$7a572cb9dc6aa81b);
class $b882c2b55c65d68f$export$30750dcb47d2f6b extends $b882c2b55c65d68f$export$9e14a7677ef1423c {
    apply(shape, dtype) {
        return (0, $bhi4b.ones)(shape, dtype);
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$30750dcb47d2f6b.className = 'Ones';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$30750dcb47d2f6b);
class $b882c2b55c65d68f$export$3c508fb3f8ac1ad4 extends $b882c2b55c65d68f$export$9e14a7677ef1423c {
    constructor(args){
        super();
        if (typeof args !== 'object') throw new (0, $jVuYK.ValueError)(`Expected argument of type ConstantConfig but got ${args}`);
        if (args.value === undefined) throw new (0, $jVuYK.ValueError)(`config must have value set but got ${args}`);
        this.value = args.value;
    }
    apply(shape, dtype) {
        return (0, $9c0Qr.tidy)(()=>(0, $r7fN6.mul)((0, $j7yUF.scalar)(this.value), (0, $bhi4b.ones)(shape, dtype)));
    }
    getConfig() {
        return {
            value: this.value
        };
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$3c508fb3f8ac1ad4.className = 'Constant';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$3c508fb3f8ac1ad4);
class $b882c2b55c65d68f$export$29e2b6f5e4b82e2f extends $b882c2b55c65d68f$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.DEFAULT_MINVAL = -0.05;
        this.DEFAULT_MAXVAL = 0.05;
        this.minval = args.minval || this.DEFAULT_MINVAL;
        this.maxval = args.maxval || this.DEFAULT_MAXVAL;
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        return (0, $gOgMa.randomUniform)(shape, this.minval, this.maxval, dtype);
    }
    getConfig() {
        return {
            minval: this.minval,
            maxval: this.maxval,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$29e2b6f5e4b82e2f.className = 'RandomUniform';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$29e2b6f5e4b82e2f);
class $b882c2b55c65d68f$export$66e863738cfcc40 extends $b882c2b55c65d68f$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.DEFAULT_MEAN = 0.;
        this.DEFAULT_STDDEV = 0.05;
        this.mean = args.mean || this.DEFAULT_MEAN;
        this.stddev = args.stddev || this.DEFAULT_STDDEV;
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        dtype = dtype || 'float32';
        if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $jVuYK.NotImplementedError)(`randomNormal does not support dType ${dtype}.`);
        return $luRak.randomNormal(shape, this.mean, this.stddev, dtype, this.seed);
    }
    getConfig() {
        return {
            mean: this.mean,
            stddev: this.stddev,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$66e863738cfcc40.className = 'RandomNormal';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$66e863738cfcc40);
class $b882c2b55c65d68f$export$5f0e8a39027050d5 extends $b882c2b55c65d68f$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.DEFAULT_MEAN = 0.;
        this.DEFAULT_STDDEV = 0.05;
        this.mean = args.mean || this.DEFAULT_MEAN;
        this.stddev = args.stddev || this.DEFAULT_STDDEV;
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        dtype = dtype || 'float32';
        if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $jVuYK.NotImplementedError)(`truncatedNormal does not support dType ${dtype}.`);
        return (0, $7y8Jw.truncatedNormal)(shape, this.mean, this.stddev, dtype, this.seed);
    }
    getConfig() {
        return {
            mean: this.mean,
            stddev: this.stddev,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$5f0e8a39027050d5.className = 'TruncatedNormal';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$5f0e8a39027050d5);
class $b882c2b55c65d68f$export$544bf02140fa9a77 extends $b882c2b55c65d68f$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.gain = args.gain != null ? args.gain : 1.0;
    }
    apply(shape, dtype) {
        return (0, $9c0Qr.tidy)(()=>{
            if (shape.length !== 2 || shape[0] !== shape[1]) throw new (0, $jVuYK.ValueError)("Identity matrix initializer can only be used for 2D square matrices.");
            else return (0, $r7fN6.mul)(this.gain, (0, $dF7rq.eye)(shape[0]));
        });
    }
    getConfig() {
        return {
            gain: this.gain
        };
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$544bf02140fa9a77.className = 'Identity';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$544bf02140fa9a77);
/**
 * Computes the number of input and output units for a weight shape.
 * @param shape Shape of weight.
 * @param dataFormat data format to use for convolution kernels.
 *   Note that all kernels in Keras are standardized on the
 *   CHANNEL_LAST ordering (even when inputs are set to CHANNEL_FIRST).
 * @return An length-2 array: fanIn, fanOut.
 */ function $b882c2b55c65d68f$var$computeFans(shape, dataFormat = 'channelsLast') {
    let fanIn;
    let fanOut;
    (0, $hQ5cH.checkDataFormat)(dataFormat);
    if (shape.length === 2) {
        fanIn = shape[0];
        fanOut = shape[1];
    } else if ([
        3,
        4,
        5
    ].indexOf(shape.length) !== -1) {
        if (dataFormat === 'channelsFirst') {
            const receptiveFieldSize = (0, $jBJAM.arrayProd)(shape, 2);
            fanIn = shape[1] * receptiveFieldSize;
            fanOut = shape[0] * receptiveFieldSize;
        } else if (dataFormat === 'channelsLast') {
            const receptiveFieldSize = (0, $jBJAM.arrayProd)(shape, 0, shape.length - 2);
            fanIn = shape[shape.length - 2] * receptiveFieldSize;
            fanOut = shape[shape.length - 1] * receptiveFieldSize;
        }
    } else {
        const shapeProd = (0, $jBJAM.arrayProd)(shape);
        fanIn = Math.sqrt(shapeProd);
        fanOut = Math.sqrt(shapeProd);
    }
    return [
        fanIn,
        fanOut
    ];
}
class $b882c2b55c65d68f$export$c2ba607ca0c6b5b3 extends $b882c2b55c65d68f$export$9e14a7677ef1423c {
    /**
     * Constructor of VarianceScaling.
     * @throws ValueError for invalid value in scale.
     */ constructor(args){
        super();
        if (args.scale < 0.0) throw new (0, $jVuYK.ValueError)(`scale must be a positive float. Got: ${args.scale}`);
        this.scale = args.scale == null ? 1.0 : args.scale;
        this.mode = args.mode == null ? 'fanIn' : args.mode;
        $b882c2b55c65d68f$export$c2c5543c407dbda7(this.mode);
        this.distribution = args.distribution == null ? 'normal' : args.distribution;
        $b882c2b55c65d68f$export$46d720aa775f5a50(this.distribution);
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        const fans = $b882c2b55c65d68f$var$computeFans(shape);
        const fanIn = fans[0];
        const fanOut = fans[1];
        let scale = this.scale;
        if (this.mode === 'fanIn') scale /= Math.max(1, fanIn);
        else if (this.mode === 'fanOut') scale /= Math.max(1, fanOut);
        else scale /= Math.max(1, (fanIn + fanOut) / 2);
        if (this.distribution === 'normal') {
            const stddev = Math.sqrt(scale);
            dtype = dtype || 'float32';
            if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $jVuYK.NotImplementedError)(`${this.getClassName()} does not support dType ${dtype}.`);
            return (0, $7y8Jw.truncatedNormal)(shape, 0, stddev, dtype, this.seed);
        } else {
            const limit = Math.sqrt(3 * scale);
            return (0, $gOgMa.randomUniform)(shape, -limit, limit, dtype);
        }
    }
    getConfig() {
        return {
            scale: this.scale,
            mode: this.mode,
            distribution: this.distribution,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$c2ba607ca0c6b5b3.className = 'VarianceScaling';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$c2ba607ca0c6b5b3);
class $b882c2b55c65d68f$export$c820ee55503e6df3 extends $b882c2b55c65d68f$export$c2ba607ca0c6b5b3 {
    /**
     * Constructor of GlorotUniform
     * @param scale
     * @param mode
     * @param distribution
     * @param seed
     */ constructor(args){
        super({
            scale: 1.0,
            mode: 'fanAvg',
            distribution: 'uniform',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, GlorotUniform is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $b882c2b55c65d68f$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$c820ee55503e6df3.className = 'GlorotUniform';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$c820ee55503e6df3);
class $b882c2b55c65d68f$export$dcc636dfa962cdc9 extends $b882c2b55c65d68f$export$c2ba607ca0c6b5b3 {
    /**
     * Constructor of GlorotNormal.
     * @param scale
     * @param mode
     * @param distribution
     * @param seed
     */ constructor(args){
        super({
            scale: 1.0,
            mode: 'fanAvg',
            distribution: 'normal',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, GlorotNormal is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $b882c2b55c65d68f$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$dcc636dfa962cdc9.className = 'GlorotNormal';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$dcc636dfa962cdc9);
class $b882c2b55c65d68f$export$399f315e5cbd5eed extends $b882c2b55c65d68f$export$c2ba607ca0c6b5b3 {
    constructor(args){
        super({
            scale: 2.0,
            mode: 'fanIn',
            distribution: 'normal',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, HeNormal is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $b882c2b55c65d68f$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$399f315e5cbd5eed.className = 'HeNormal';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$399f315e5cbd5eed);
class $b882c2b55c65d68f$export$4799f50fbef71375 extends $b882c2b55c65d68f$export$c2ba607ca0c6b5b3 {
    constructor(args){
        super({
            scale: 2.0,
            mode: 'fanIn',
            distribution: 'uniform',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, HeUniform is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $b882c2b55c65d68f$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$4799f50fbef71375.className = 'HeUniform';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$4799f50fbef71375);
class $b882c2b55c65d68f$export$f0843b4cb97b93f5 extends $b882c2b55c65d68f$export$c2ba607ca0c6b5b3 {
    constructor(args){
        super({
            scale: 1.0,
            mode: 'fanIn',
            distribution: 'normal',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, LeCunNormal is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $b882c2b55c65d68f$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$f0843b4cb97b93f5.className = 'LeCunNormal';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$f0843b4cb97b93f5);
class $b882c2b55c65d68f$export$41b487c9c7cedfae extends $b882c2b55c65d68f$export$c2ba607ca0c6b5b3 {
    constructor(args){
        super({
            scale: 1.0,
            mode: 'fanIn',
            distribution: 'uniform',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, LeCunUniform is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $b882c2b55c65d68f$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$41b487c9c7cedfae.className = 'LeCunNormal';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$41b487c9c7cedfae);
class $b882c2b55c65d68f$export$7d101801017ddeaf extends $b882c2b55c65d68f$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.DEFAULT_GAIN = 1;
        this.gain = args.gain == null ? this.DEFAULT_GAIN : args.gain;
        this.seed = args.seed;
        if (this.seed != null) throw new (0, $jVuYK.NotImplementedError)('Random seed is not implemented for Orthogonal Initializer yet.');
    }
    apply(shape, dtype) {
        return (0, $9c0Qr.tidy)(()=>{
            if (shape.length < 2) throw new (0, $jVuYK.NotImplementedError)('Shape must be at least 2D.');
            if (shape[0] * shape[1] > 2000) console.warn(`Orthogonal initializer is being called on a matrix with more ` + `than 2000 (${shape[0] * shape[1]}) elements: ` + `Slowness may result.`);
            // TODO(cais): Add seed support.
            const normalizedShape = shape[0] > shape[1] ? [
                shape[1],
                shape[0]
            ] : shape;
            const a = $luRak.randomNormal(normalizedShape, 0, 1, 'float32');
            let q = (0, $iNZmA.linalg).gramSchmidt(a);
            if (shape[0] > shape[1]) q = (0, $9PEYs.transpose)(q);
            return (0, $r7fN6.mul)(this.gain, q);
        });
    }
    getConfig() {
        return {
            gain: this.gain,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $b882c2b55c65d68f$export$7d101801017ddeaf.className = 'Orthogonal';
(0, $8AyuI).registerClass($b882c2b55c65d68f$export$7d101801017ddeaf);
const $b882c2b55c65d68f$export$10005499b3b3c1de = {
    'constant': 'Constant',
    'glorotNormal': 'GlorotNormal',
    'glorotUniform': 'GlorotUniform',
    'heNormal': 'HeNormal',
    'heUniform': 'HeUniform',
    'identity': 'Identity',
    'leCunNormal': 'LeCunNormal',
    'leCunUniform': 'LeCunUniform',
    'ones': 'Ones',
    'orthogonal': 'Orthogonal',
    'randomNormal': 'RandomNormal',
    'randomUniform': 'RandomUniform',
    'truncatedNormal': 'TruncatedNormal',
    'varianceScaling': 'VarianceScaling',
    'zeros': 'Zeros'
};
function $b882c2b55c65d68f$var$deserializeInitializer(config, customObjects = {}) {
    return (0, $khD6O.deserializeKerasObject)(config, (0, $8AyuI).SerializationMap.getMap().classNameMap, customObjects, 'initializer');
}
function $b882c2b55c65d68f$export$68de06a18c23bdbc(initializer) {
    return (0, $khD6O.serializeKerasObject)(initializer);
}
function $b882c2b55c65d68f$export$558b7d1a338df84b(identifier) {
    if (typeof identifier === 'string') {
        const className = identifier in $b882c2b55c65d68f$export$10005499b3b3c1de ? $b882c2b55c65d68f$export$10005499b3b3c1de[identifier] : identifier;
        /* We have four 'helper' classes for common initializers that
        all get serialized as 'VarianceScaling' and shouldn't go through
        the deserializeInitializer pathway. */ if (className === 'GlorotNormal') return new $b882c2b55c65d68f$export$dcc636dfa962cdc9();
        else if (className === 'GlorotUniform') return new $b882c2b55c65d68f$export$c820ee55503e6df3();
        else if (className === 'HeNormal') return new $b882c2b55c65d68f$export$399f315e5cbd5eed();
        else if (className === 'HeUniform') return new $b882c2b55c65d68f$export$4799f50fbef71375();
        else if (className === 'LeCunNormal') return new $b882c2b55c65d68f$export$f0843b4cb97b93f5();
        else if (className === 'LeCunUniform') return new $b882c2b55c65d68f$export$41b487c9c7cedfae();
        else {
            const config = {};
            config['className'] = className;
            config['config'] = {};
            return $b882c2b55c65d68f$var$deserializeInitializer(config);
        }
    } else if (identifier instanceof $b882c2b55c65d68f$export$9e14a7677ef1423c) return identifier;
    else return $b882c2b55c65d68f$var$deserializeInitializer(identifier);
}

});
parcelRegister("luRak", function(module, exports) {

$parcel$export(module.exports, "cast", () => $fa65a3e62d49573e$export$f2db7d5238e1d23f);
$parcel$export(module.exports, "expandDims", () => $fa65a3e62d49573e$export$d660d8ed21f46635);
$parcel$export(module.exports, "repeat", () => $fa65a3e62d49573e$export$76d90c956114f2c2);
$parcel$export(module.exports, "tile", () => $fa65a3e62d49573e$export$3c17558da18e4d75);
$parcel$export(module.exports, "flatten", () => $fa65a3e62d49573e$export$bffa455ba8c619a6);
$parcel$export(module.exports, "batchFlatten", () => $fa65a3e62d49573e$export$6d182438241cb7ab);
$parcel$export(module.exports, "sliceAlongFirstAxis", () => $fa65a3e62d49573e$export$4f266636a9634575);
$parcel$export(module.exports, "sliceAlongAxis", () => $fa65a3e62d49573e$export$4f25f657b7083746);
$parcel$export(module.exports, "concatenate", () => $fa65a3e62d49573e$export$375c71d43969527d);
$parcel$export(module.exports, "concatAlongFirstAxis", () => $fa65a3e62d49573e$export$2c8a4d3eab2092a2);
$parcel$export(module.exports, "randomNormal", () => $fa65a3e62d49573e$export$a0ac5549a8bec918);
$parcel$export(module.exports, "dot", () => $fa65a3e62d49573e$export$94132a0e348806d4);
$parcel$export(module.exports, "gather", () => $fa65a3e62d49573e$export$9e05546f00427e8);
$parcel$export(module.exports, "square", () => $fa65a3e62d49573e$export$dd4f28cef696bc7d);
$parcel$export(module.exports, "biasAdd", () => $fa65a3e62d49573e$export$917ce53bce63bd4b);
$parcel$export(module.exports, "elu", () => $fa65a3e62d49573e$export$796b583dd79d8524);
$parcel$export(module.exports, "softsign", () => $fa65a3e62d49573e$export$6def925d7f33a45c);
$parcel$export(module.exports, "dropout", () => $fa65a3e62d49573e$export$fe05aa12367b4e47);
$parcel$export(module.exports, "hardSigmoid", () => $fa65a3e62d49573e$export$150f2d52960480ef);
$parcel$export(module.exports, "inTrainPhase", () => $fa65a3e62d49573e$export$5a6eea8e1dcefeb7);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * deeplearn.js backend.
 */ parcelRequire("5n9DG");
var $6oc11 = parcelRequire("6oc11");
var $1ZrG5 = parcelRequire("1ZrG5");
var $7qWZ5 = parcelRequire("7qWZ5");
var $jU3Ej = parcelRequire("jU3Ej");
var $6LWfo = parcelRequire("6LWfo");
var $ayCnc = parcelRequire("ayCnc");
var $iy8jW = parcelRequire("iy8jW");
var $3pVmi = parcelRequire("3pVmi");
var $cM6MZ = parcelRequire("cM6MZ");
var $gjFWY = parcelRequire("gjFWY");
var $jJRIZ = parcelRequire("jJRIZ");
var $aYszp = parcelRequire("aYszp");
var $5Py3O = parcelRequire("5Py3O");
var $kyRlD = parcelRequire("kyRlD");
var $kiLVE = parcelRequire("kiLVE");
var $jUhqf = parcelRequire("jUhqf");
var $r7fN6 = parcelRequire("r7fN6");
var $8feEH = parcelRequire("8feEH");
var $9u8DQ = parcelRequire("9u8DQ");
var $5MZxP = parcelRequire("5MZxP");
var $h5wle = parcelRequire("h5wle");
var $eP0pM = parcelRequire("eP0pM");
var $j7yUF = parcelRequire("j7yUF");
var $9c0Qr = parcelRequire("9c0Qr");
var $kvpGg = parcelRequire("kvpGg");
var $5Uyxp = parcelRequire("5Uyxp");
var $fhfPl = parcelRequire("fhfPl");
var $eUdR5 = parcelRequire("eUdR5");
var $9y3CH = parcelRequire("9y3CH");
var $jIDgY = parcelRequire("jIDgY");
var $jIHaY = parcelRequire("jIHaY");
var $9PEYs = parcelRequire("9PEYs");
var $3dRh6 = parcelRequire("3dRh6");
var $k1Ozi = parcelRequire("k1Ozi");

var $hQ5cH = parcelRequire("hQ5cH");

var $jVuYK = parcelRequire("jVuYK");

var $jBJAM = parcelRequire("jBJAM");

var $c51ox = parcelRequire("c51ox");
// tslint:enable
/* Setting and getting backend from deeplearn.js. */ // Default deeplearn.js backend is WebGL (GPU).
let $fa65a3e62d49573e$var$backend = 'webgl';
function $fa65a3e62d49573e$export$7953970fabc9c2(requestedBackend) {
    $9c0Qr.setBackend(requestedBackend);
    $fa65a3e62d49573e$var$backend = requestedBackend;
}
function $fa65a3e62d49573e$export$b098501f764cdf30() {
    return $fa65a3e62d49573e$var$backend;
}
function $fa65a3e62d49573e$export$c3a33bdbf7249794() {
    return false;
}
function $fa65a3e62d49573e$export$230bf2dc3171638d(x) {
    const shape = x.shape;
    if (shape.length > 0) return shape.reduce((a, b)=>a * b);
    else // Scalar.
    return 1;
}
function $fa65a3e62d49573e$export$f2db7d5238e1d23f(x, dtype) {
    return $7qWZ5.cast(x, dtype);
}
function $fa65a3e62d49573e$export$d660d8ed21f46635(x, axis = -1) {
    const outShape = x.shape.slice();
    if (axis < 0) axis = outShape.length + axis + 1;
    outShape.splice(axis, 0, 1);
    return $eP0pM.reshape(x, outShape);
}
function $fa65a3e62d49573e$export$76d90c956114f2c2(x, n) {
    return (0, $9c0Qr.tidy)(()=>{
        if (x.shape.length !== 2) throw new (0, $jVuYK.ValueError)(`repeat() expects a rank-2 tensor, but received a ` + `rank-${x.shape.length} tensor.`);
        const y = $fa65a3e62d49573e$export$d660d8ed21f46635(x, 1);
        return $fa65a3e62d49573e$export$3c17558da18e4d75(y, [
            1,
            n,
            1
        ]);
    });
}
function $fa65a3e62d49573e$export$bffa455ba8c619a6(x) {
    const newShape = [
        $jBJAM.arrayProd(x.shape)
    ];
    return $eP0pM.reshape(x, newShape);
}
function $fa65a3e62d49573e$export$6d182438241cb7ab(x) {
    if (x.rank <= 1) throw new (0, $jVuYK.ValueError)(`batchFlatten requires a minimum rank of 2. Got rank: ${x.rank}.`);
    const newShape = [
        x.shape[0],
        $jBJAM.arrayProd(x.shape, 1)
    ];
    return $eP0pM.reshape(x, newShape);
}
function $fa65a3e62d49573e$export$4f266636a9634575(array, start, size) {
    return (0, $9c0Qr.tidy)(()=>{
        switch(array.rank){
            case 1:
                return $5Uyxp.slice1d(array, start, size);
            case 2:
                return $fhfPl.slice2d(array, [
                    start,
                    0
                ], [
                    size,
                    array.shape[1]
                ]);
            case 3:
                return $eUdR5.slice3d(array, [
                    start,
                    0,
                    0
                ], [
                    size,
                    array.shape[1],
                    array.shape[2]
                ]);
            case 4:
                return $9y3CH.slice4d(array, [
                    start,
                    0,
                    0,
                    0
                ], [
                    size,
                    array.shape[1],
                    array.shape[2],
                    array.shape[3]
                ]);
            case 5:
                return $kvpGg.slice(array, [
                    start,
                    0,
                    0,
                    0,
                    0
                ], [
                    size,
                    array.shape[1],
                    array.shape[2],
                    array.shape[3],
                    array.shape[4]
                ]);
            case 6:
                return $kvpGg.slice(array, [
                    start,
                    0,
                    0,
                    0,
                    0,
                    0
                ], [
                    size,
                    array.shape[1],
                    array.shape[2],
                    array.shape[3],
                    array.shape[4],
                    array.shape[5]
                ]);
            default:
                throw new (0, $jVuYK.ValueError)(`sliceAlongFirstAxis() received an unsupported tensor rank: ` + `${array.rank}`);
        }
    });
}
function $fa65a3e62d49573e$export$7eb01d0ca77de013(array, start, size) {
    return (0, $9c0Qr.tidy)(()=>{
        switch(array.rank){
            case 1:
                return $5Uyxp.slice1d(array, start, size);
            case 2:
                return $fhfPl.slice2d(array, [
                    0,
                    start
                ], [
                    array.shape[0],
                    size
                ]);
            case 3:
                return $eUdR5.slice3d(array, [
                    0,
                    0,
                    start
                ], [
                    array.shape[0],
                    array.shape[1],
                    size
                ]);
            case 4:
                return $9y3CH.slice4d(array, [
                    0,
                    0,
                    0,
                    start
                ], [
                    array.shape[0],
                    array.shape[1],
                    array.shape[2],
                    size
                ]);
            default:
                throw new (0, $jVuYK.ValueError)(`sliceAlongLastAxis() received an unsupported tensor rank: ` + `${array.rank}`);
        }
    });
}
function $fa65a3e62d49573e$export$4f25f657b7083746(array, start, size, axis) {
    return (0, $9c0Qr.tidy)(()=>{
        switch(array.rank){
            case 1:
                return $5Uyxp.slice1d(array, start, size);
            case 2:
                switch(axis){
                    case 1:
                        return $fa65a3e62d49573e$export$4f266636a9634575(array, start, size);
                    case 2:
                        return $fa65a3e62d49573e$export$7eb01d0ca77de013(array, start, size);
                    default:
                        throw new (0, $jVuYK.ValueError)(`The axis is not within the rank of the tensor ` + `${axis}`);
                }
            case 3:
                switch(axis){
                    case 1:
                        return $fa65a3e62d49573e$export$4f266636a9634575(array, start, size);
                    case 2:
                        return $eUdR5.slice3d(array, [
                            0,
                            start,
                            0
                        ], [
                            array.shape[0],
                            size,
                            array.shape[2]
                        ]);
                    case 3:
                        return $fa65a3e62d49573e$export$7eb01d0ca77de013(array, start, size);
                    default:
                        throw new (0, $jVuYK.ValueError)(`The axis is not within the rank of the tensor ` + `${axis}`);
                }
            case 4:
                switch(axis){
                    case 1:
                        return $fa65a3e62d49573e$export$4f266636a9634575(array, start, size);
                    case 2:
                        return $9y3CH.slice4d(array, [
                            0,
                            start,
                            0,
                            0
                        ], [
                            array.shape[0],
                            size,
                            array.shape[2],
                            array.shape[3]
                        ]);
                    case 3:
                        return $9y3CH.slice4d(array, [
                            0,
                            0,
                            start,
                            0
                        ], [
                            array.shape[0],
                            array.shape[1],
                            size,
                            array.shape[3]
                        ]);
                    case 4:
                        return $fa65a3e62d49573e$export$7eb01d0ca77de013(array, start, size);
                    default:
                        throw new (0, $jVuYK.ValueError)(`The axis is not within the rank of the tensor ` + `${axis}`);
                }
            default:
                throw new (0, $jVuYK.ValueError)(`sliceAlongLastAxis() received an unsupported tensor rank: ` + `${array.rank}`);
        }
    });
}
function $fa65a3e62d49573e$export$375c71d43969527d(tensors, axis = -1) {
    let rank;
    if (axis < 0) {
        rank = tensors[0].rank;
        if (rank !== 0) axis = rank;
        else axis = 0;
    }
    if (axis === tensors[0].rank) // Porting Note: This is necessary because tfc.concat() requires axis to be
    //   in the interval [-rank, rank).
    axis = -1;
    // Porting Note: Sparse concat is not supported yet.
    return $6LWfo.concat(tensors, axis);
}
function $fa65a3e62d49573e$export$2c8a4d3eab2092a2(a, b) {
    switch(a.rank){
        case 1:
            return $ayCnc.concat1d([
                a,
                b
            ]);
        case 2:
            return $iy8jW.concat2d([
                a,
                b
            ], 0);
        case 3:
            return $3pVmi.concat3d([
                a,
                b
            ], 0);
        case 4:
            return $cM6MZ.concat4d([
                a,
                b
            ], 0);
        default:
            throw new (0, $jVuYK.ValueError)(`concatAlongFirstAxis() received an unsupported ` + `tensor rank: ${a.rank}`);
    }
}
function $fa65a3e62d49573e$export$3c17558da18e4d75(x, n) {
    if (!Array.isArray(n)) n = [
        n
    ];
    if (x.rank !== n.length) throw new (0, $jVuYK.ValueError)(`The length of input n (${n.length}) does not match ` + `the number of dimensions in input x (${x.rank})`);
    return $jIHaY.tile(x, n);
}
function $fa65a3e62d49573e$export$a0ac5549a8bec918(shape, mean = 0.0, stddev = 1.0, dtype, seed) {
    return $h5wle.randomNormal(shape, mean, stddev, dtype, seed);
}
function $fa65a3e62d49573e$export$94132a0e348806d4(a, b, activation, bias) {
    if (a.rank < 2 || b.rank < 2) throw new (0, $jVuYK.NotImplementedError)(`dot requires both inputs to be rank >= 2` + ` but got x shape = ${a.shape} and y shape = ${b.shape}`);
    if (b.rank >= 3) {
        const xLastDim = a.shape.slice(-1)[0];
        const ySecondLastDim = b.shape.slice(-2)[0];
        if (xLastDim !== ySecondLastDim) throw new (0, $jVuYK.NotImplementedError)(`If rank y >= 3, then the second last dim` + ` of y must equal the last dim of x but got x shape = ${a.shape} and ` + ` y shape = ${b.shape}`);
    }
    // Handle basic 2D x 2D case.
    if (a.rank === 2 && b.rank === 2) {
        const transposeA = false;
        const transposeB = false;
        // tfc.fused.matMul only fuses certain activation functions. Unsupported
        // activation functions are treated as 'linear' activations, which is
        // equivalent to a no-op.
        return $kyRlD.matMul({
            a: a,
            b: b,
            transposeA: transposeA,
            transposeB: transposeB,
            bias: bias ? $fa65a3e62d49573e$var$reshapeBias(a.rank, bias, (0, $c51ox.imageDataFormat)()) : null,
            activation: activation
        });
    } else {
        // Reshape x into the analogous 2D Tensor.
        const aFirstDims = a.shape.slice(); // Holds all but the last dim of x.
        const aLastDim = aFirstDims.pop();
        a = $eP0pM.reshape(a, [
            -1,
            aLastDim
        ]);
        // Reshape y into the analogous 2D Tensor, and keep track of the
        // required dimensions to reproduce the output shape.
        const bShape = b.shape.slice();
        const bLastDim = bShape.pop();
        const ySecondLastDim = bShape.pop();
        const yOtherDims = [
            ...bShape,
            bLastDim
        ];
        // permutation should be like [r-2, 0, 1, 2, ... r-4, r-3, r-1]
        // where r is the rank of y.
        const perm = Array.from({
            length: b.rank
        }, (_, i)=>{
            if (i === 0) return b.rank - 2;
            else if (i <= b.rank - 2) return i - 1;
            return i;
        });
        b = $eP0pM.reshape($9PEYs.transpose(b, perm), [
            ySecondLastDim,
            -1
        ]);
        // Multiply x and y as 2D Tensors, and then reshape back to original.
        const outputShape = [
            ...aFirstDims,
            ...yOtherDims
        ];
        const transposeA = false;
        const transposeB = false;
        return $eP0pM.reshape($kyRlD.matMul({
            a: a,
            b: b,
            transposeA: transposeA,
            transposeB: transposeB,
            bias: bias ? $fa65a3e62d49573e$var$reshapeBias(a.rank, bias, (0, $c51ox.imageDataFormat)()) : null,
            activation: activation
        }), outputShape);
    }
}
function $fa65a3e62d49573e$export$c5552dfdbc7cec71(x) {
    // TODO(cais): Move to the core.
    return (0, $9c0Qr.tidy)(()=>{
        const zerosLikeX = (0, $k1Ozi.zerosLike)(x);
        const onesLikeX = (0, $9u8DQ.onesLike)(x);
        return (0, $3dRh6.where)($5Py3O.equal(x, zerosLikeX), zerosLikeX, (0, $3dRh6.where)($jUhqf.greater(x, (0, $k1Ozi.zerosLike)(x)), onesLikeX, $r7fN6.mul(-1, onesLikeX)));
    });
}
function $fa65a3e62d49573e$export$341b5490a776d041(indices, numClasses) {
    return (0, $9c0Qr.tidy)(()=>{
        if (indices.rank !== 1) throw new Error("Only 1D one-hot tensors are supported in the deeplearn backend, at present.");
        indices = $7qWZ5.cast(indices, 'int32');
        return $7qWZ5.cast($8feEH.oneHot(indices, numClasses), 'float32');
    });
}
function $fa65a3e62d49573e$export$9e05546f00427e8(reference, indices, axis) {
    return (0, $9c0Qr.tidy)(()=>{
        if (Array.isArray(indices)) indices = (0, $jIDgY.tensor1d)(indices, 'int32');
        else indices = $7qWZ5.cast(indices, 'int32');
        return $kiLVE.gather(reference, indices, axis);
    });
}
function $fa65a3e62d49573e$export$dd4f28cef696bc7d(x) {
    return $r7fN6.mul(x, x);
}
function $fa65a3e62d49573e$export$9c297f60e22e3389(x, a) {
    return (0, $9c0Qr.tidy)(()=>{
        if (typeof a === 'number') a = (0, $j7yUF.scalar)(Math.round(a), 'int32');
        if (a.dtype !== 'int32') throw new (0, $jVuYK.NotImplementedError)(`Non-int32 dtype (${a.dtype}) is not supported by pow() yet`);
        return $5MZxP.pow(x, a);
    });
}
/**
 * Reshapes bias tensor according to rank of x.
 */ function $fa65a3e62d49573e$var$reshapeBias(xRank, bias, dataFormat) {
    const biasShape = bias.shape;
    if (bias.rank !== 1 && bias.rank !== xRank) throw new (0, $jVuYK.ValueError)(`Unexpected bias dimensions: ${bias.rank}` + `; expected it to be 1 or ${xRank}`);
    if (xRank === 5) {
        if (dataFormat === 'channelsFirst') {
            if (biasShape.length === 1) return $eP0pM.reshape(bias, [
                1,
                biasShape[0],
                1,
                1,
                1
            ]);
            else return $eP0pM.reshape(bias, [
                1,
                biasShape[3],
                biasShape[0],
                biasShape[1],
                biasShape[2]
            ]);
        } else if (dataFormat === 'channelsLast') {
            if (biasShape.length === 1) return $eP0pM.reshape(bias, [
                1,
                1,
                1,
                1,
                biasShape[0]
            ]);
            else return $eP0pM.reshape(bias, [
                1
            ].concat(biasShape));
        }
    } else if (xRank === 4) {
        if (dataFormat === 'channelsFirst') {
            if (biasShape.length === 1) return $eP0pM.reshape(bias, [
                1,
                biasShape[0],
                1,
                1
            ]);
            else return $eP0pM.reshape(bias, [
                1,
                biasShape[2],
                biasShape[0],
                biasShape[1]
            ]);
        } else if (dataFormat === 'channelsLast') {
            if (biasShape.length === 1) return $eP0pM.reshape(bias, [
                1,
                1,
                1,
                biasShape[0]
            ]);
            else return $eP0pM.reshape(bias, [
                1
            ].concat(biasShape));
        }
    } else if (xRank === 3) {
        if (dataFormat === 'channelsFirst') {
            if (biasShape.length === 1) return $eP0pM.reshape(bias, [
                1,
                biasShape[0],
                1
            ]);
            else return $eP0pM.reshape(bias, [
                1,
                biasShape[1],
                biasShape[0]
            ]);
        } else if (dataFormat === 'channelsLast') {
            if (biasShape.length === 1) return $eP0pM.reshape(bias, [
                1,
                1,
                biasShape[0]
            ]);
            else return $eP0pM.reshape(bias, [
                1
            ].concat(biasShape));
        }
    } else if (xRank < 3) return bias;
    throw new (0, $jVuYK.ValueError)(`Unsupported input rank by biasAdd: ${bias.rank}`);
}
function $fa65a3e62d49573e$export$917ce53bce63bd4b(x, bias, dataFormat) {
    return (0, $9c0Qr.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $c51ox.imageDataFormat)();
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        return $1ZrG5.add(x, $fa65a3e62d49573e$var$reshapeBias(x.rank, bias, dataFormat));
    });
}
function $fa65a3e62d49573e$export$796b583dd79d8524(x, alpha = 1) {
    // TODO(cais): Add support for alpha values other than 1.
    if (alpha !== 1) throw new (0, $jVuYK.NotImplementedError)(`Support for alpha values other than 1 (${alpha}) is not implemented ` + `yet.`);
    return $aYszp.elu(x);
}
function $fa65a3e62d49573e$export$6def925d7f33a45c(x) {
    return (0, $9c0Qr.tidy)(()=>$gjFWY.div(x, $1ZrG5.add($6oc11.abs(x), 1)));
}
function $fa65a3e62d49573e$export$fe05aa12367b4e47(x, level, noiseShape, seed) {
    return (0, $9c0Qr.tidy)(()=>$jJRIZ.dropout(x, level, noiseShape, seed));
}
function $fa65a3e62d49573e$export$150f2d52960480ef(x) {
    return (0, $9c0Qr.tidy)(()=>{
        const y = $1ZrG5.add(.5, $r7fN6.mul(.2, x));
        return $jU3Ej.clipByValue(y, 0, 1);
    });
}
function $fa65a3e62d49573e$export$5a6eea8e1dcefeb7(x, alt, training = false) {
    return training ? x() : alt();
}

});
parcelRegister("jBJAM", function(module, exports) {

$parcel$export(module.exports, "isInteger", () => $e464d6b5c8bf15ff$export$a287f47fed4544b8);
$parcel$export(module.exports, "arrayProd", () => $e464d6b5c8bf15ff$export$3b5d61e59fec5e86);
$parcel$export(module.exports, "min", () => $e464d6b5c8bf15ff$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $e464d6b5c8bf15ff$export$8960430cfd85939f);
$parcel$export(module.exports, "range", () => $e464d6b5c8bf15ff$export$d02631cccf789723);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Math utility functions.
 *
 * This file contains some frequently used math function that operates on
 * number[] or Float32Array and return a number. Many of these functions are
 * not-so-thick wrappers around TF.js Core functions. But they offer the
 * convenience of
 * 1) not having to convert the inputs into Tensors,
 * 2) not having to convert the returned Tensors to numbers.
 */ 
var $jVuYK = parcelRequire("jVuYK");
function $e464d6b5c8bf15ff$export$a287f47fed4544b8(x) {
    return x === parseInt(x.toString(), 10);
}
function $e464d6b5c8bf15ff$export$3b5d61e59fec5e86(array, begin, end) {
    if (begin == null) begin = 0;
    if (end == null) end = array.length;
    let prod = 1;
    for(let i = begin; i < end; ++i)prod *= array[i];
    return prod;
}
function $e464d6b5c8bf15ff$export$96ec731ed4dcb222(array) {
    // same behavior as tf.min()
    if (array.length === 0) return Number.NaN;
    let min = Number.POSITIVE_INFINITY;
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        if (value < min) min = value;
    }
    return min;
}
function $e464d6b5c8bf15ff$export$8960430cfd85939f(array) {
    // same behavior as tf.max()
    if (array.length === 0) return Number.NaN;
    let max = Number.NEGATIVE_INFINITY;
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        if (value > max) max = value;
    }
    return max;
}
function $e464d6b5c8bf15ff$export$8a63f25cc62965f1(array) {
    let sum = 0;
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        sum += value;
    }
    return sum;
}
function $e464d6b5c8bf15ff$export$1ce691f85baaa52(array) {
    return $e464d6b5c8bf15ff$export$8a63f25cc62965f1(array) / array.length;
}
function $e464d6b5c8bf15ff$export$9b77da0927470c3d(array) {
    const meanValue = $e464d6b5c8bf15ff$export$1ce691f85baaa52(array);
    const demeaned = array.map((value)=>value - meanValue);
    let sumSquare = 0;
    for(let i = 0; i < demeaned.length; i++){
        const value = demeaned[i];
        sumSquare += value * value;
    }
    return sumSquare / array.length;
}
function $e464d6b5c8bf15ff$export$9c490b34b2f16a34(array) {
    const arraySorted = array.slice().sort((a, b)=>a - b);
    const lowIdx = Math.floor((arraySorted.length - 1) / 2);
    const highIdx = Math.ceil((arraySorted.length - 1) / 2);
    if (lowIdx === highIdx) return arraySorted[lowIdx];
    return (arraySorted[lowIdx] + arraySorted[highIdx]) / 2;
}
function $e464d6b5c8bf15ff$export$d02631cccf789723(begin, end) {
    if (end < begin) throw new (0, $jVuYK.ValueError)(`end (${end}) < begin (${begin}) is forbidden.`);
    const out = [];
    for(let i = begin; i < end; ++i)out.push(i);
    return out;
}

});

parcelRegister("c51ox", function(module, exports) {

$parcel$export(module.exports, "epsilon", () => $8cb7089eb07c9ba5$export$6c421550c66a327d);
$parcel$export(module.exports, "imageDataFormat", () => $8cb7089eb07c9ba5$export$9cb785636e5e0d8);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $9c0Qr = parcelRequire("9c0Qr");
let $8cb7089eb07c9ba5$var$_epsilon;
function $8cb7089eb07c9ba5$export$6c421550c66a327d() {
    if ($8cb7089eb07c9ba5$var$_epsilon == null) $8cb7089eb07c9ba5$var$_epsilon = (0, $9c0Qr.backend)().epsilon();
    return $8cb7089eb07c9ba5$var$_epsilon;
}
function $8cb7089eb07c9ba5$export$15daaec7a0b3c780(e) {
    $8cb7089eb07c9ba5$var$_epsilon = e;
}
function $8cb7089eb07c9ba5$export$9cb785636e5e0d8() {
    return 'channelsLast';
}

});


parcelRegister("5Uypa", function(module, exports) {

$parcel$export(module.exports, "VALID_FAN_MODE_VALUES", () => $44dcded583e66ccb$export$6f4ea9ac290c463f);
$parcel$export(module.exports, "VALID_DISTRIBUTION_VALUES", () => $44dcded583e66ccb$export$a0651197744e50ce);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const $44dcded583e66ccb$export$6f4ea9ac290c463f = [
    'fanIn',
    'fanOut',
    'fanAvg'
];
const $44dcded583e66ccb$export$a0651197744e50ce = [
    'normal',
    'uniform',
    'truncatedNormal'
];
const $44dcded583e66ccb$export$989dbab10a7a8537 = [
    'Zeros',
    'Ones',
    'Constant',
    'RandomNormal',
    'RandomUniform',
    'TruncatedNormal',
    'VarianceScaling',
    'Orthogonal',
    'Identity'
];

});


parcelRegister("5sw3q", function(module, exports) {

$parcel$export(module.exports, "isArrayOfShapes", () => $3f986e95c6f2ade6$export$3297ca286d903db0);
$parcel$export(module.exports, "normalizeShapeList", () => $3f986e95c6f2ade6$export$4cdd3da5579ac4c4);
$parcel$export(module.exports, "getExactlyOneTensor", () => $3f986e95c6f2ade6$export$5327fe015af69a7b);
$parcel$export(module.exports, "getExactlyOneShape", () => $3f986e95c6f2ade6$export$25c35af872e8abca);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $jVuYK = parcelRequire("jVuYK");
function $3f986e95c6f2ade6$export$3297ca286d903db0(x) {
    return Array.isArray(x) && Array.isArray(x[0]);
}
function $3f986e95c6f2ade6$export$4cdd3da5579ac4c4(x) {
    if (x.length === 0) return [];
    if (!Array.isArray(x[0])) return [
        x
    ];
    return x;
}
function $3f986e95c6f2ade6$export$5327fe015af69a7b(xs) {
    let x;
    if (Array.isArray(xs)) {
        if (xs.length !== 1) throw new (0, $jVuYK.ValueError)(`Expected Tensor length to be 1; got ${xs.length}`);
        x = xs[0];
    } else x = xs;
    return x;
}
function $3f986e95c6f2ade6$export$25c35af872e8abca(shapes) {
    if (Array.isArray(shapes) && Array.isArray(shapes[0])) {
        if (shapes.length === 1) {
            shapes;
            return shapes[0];
        } else throw new (0, $jVuYK.ValueError)(`Expected exactly 1 Shape; got ${shapes.length}`);
    } else return shapes;
}

});

parcelRegister("5YCEz", function(module, exports) {

$parcel$export(module.exports, "countParamsInWeights", () => $45a08a17f56af4f9$export$2a41d41251f01d03);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Count the elements in an Array of LayerVariables.
 *
 * @param weights: The LayerVariables of which the constituent numbers are to
 *   be counted.
 * @returns A count of the elements in all the LayerVariables
 */ function $45a08a17f56af4f9$export$2a41d41251f01d03(weights) {
    let count = 0;
    for (const weight of weights)if (weight.shape.length === 0) count += 1;
    else count += weight.shape.reduce((a, b)=>a * b);
    return count;
}

});

parcelRegister("7muWV", function(module, exports) {

$parcel$export(module.exports, "LayerVariable", () => $55c29868c236e32f$export$25de78a5a5bf7257);
$parcel$export(module.exports, "batchGetValue", () => $55c29868c236e32f$export$3702262f615cc9f0);
$parcel$export(module.exports, "batchSetValue", () => $55c29868c236e32f$export$6b1a34257a4982e4);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $1ZrG5 = parcelRequire("1ZrG5");
var $dF7rq = parcelRequire("dF7rq");
var $bhi4b = parcelRequire("bhi4b");
var $9u8DQ = parcelRequire("9u8DQ");
var $h5wle = parcelRequire("h5wle");
var $gOgMa = parcelRequire("gOgMa");
var $hkR0n = parcelRequire("hkR0n");
var $7y8Jw = parcelRequire("7y8Jw");
var $3mBtj = parcelRequire("3mBtj");
var $jFQG4 = parcelRequire("jFQG4");
var $7KCJq = parcelRequire("7KCJq");
var $k1Ozi = parcelRequire("k1Ozi");

var $3qq1L = parcelRequire("3qq1L");

var $hQ5cH = parcelRequire("hQ5cH");

var $jVuYK = parcelRequire("jVuYK");
const $55c29868c236e32f$var$DEFAULT_VARIABLE_NAME_PREFIX = 'Variable';
class $55c29868c236e32f$export$25de78a5a5bf7257 {
    /**
     * Construct Variable from a `tf.Tensor`.
     *
     * If not explicitly named, the Variable will be given a name with the
     * prefix 'Variable'. Variable names are unique. In the case of name
     * collision, suffixies '_<num>' will be added to the name.
     *
     * @param val Initial value of the Variable.
     * @param name Name of the variable. If `null` or `undefined` is provided, it
     *   will default a name with the prefix 'Variable'.
     * @param constraint Optional, projection function to be applied to the
     * variable after optimize updates
     * @throws ValueError if `name` is `null` or `undefined`.
     */ constructor(val, dtype = 'float32', name = $55c29868c236e32f$var$DEFAULT_VARIABLE_NAME_PREFIX, trainable = true, constraint = null){
        this.dtype = dtype == null ? 'float32' : dtype;
        this.shape = val.shape;
        this.id = (0, $3qq1L.getNextUniqueTensorId)();
        name = name == null ? $55c29868c236e32f$var$DEFAULT_VARIABLE_NAME_PREFIX : name;
        this.originalName = (0, $hQ5cH.getScopedTensorName)(name);
        this.name = (0, $hQ5cH.getUniqueTensorName)(this.originalName);
        this.trainable_ = trainable;
        this.constraint = constraint;
        this.val = $3mBtj.variable(val, this.trainable_, this.name, this.dtype);
    }
    /**
     * Get a snapshot of the Variable's value.
     *
     * The returned value is a snapshot of the Variable's value at the time of
     * the invocation. Future mutations in the value of the tensor will only
     * be reflected by future calls to this method.
     */ read() {
        this.assertNotDisposed();
        return this.val;
    }
    /**
     * Update the value of the Variable.
     *
     * @param newVal: The new value to update to. Must be consistent with the
     *   dtype and shape of the Variable.
     * @return This Variable.
     */ write(newVal) {
        // TODO(cais): Once  TF.js Core supports Tensor.dtype, check dtype match.
        this.assertNotDisposed();
        $55c29868c236e32f$var$checkShapesMatch(this.val, newVal);
        // Skip updating if this is the exact same tensor.
        if (this.val.id !== newVal.id) {
            this.val.assign(newVal);
            if (this.constraint != null) this.val.assign(this.constraint.apply(this.val));
        }
        return this;
    }
    /**
     * Dispose this LayersVariable instance from memory.
     */ dispose() {
        this.assertNotDisposed();
        this.val.dispose();
    }
    assertNotDisposed() {
        if (this.val.isDisposed) throw new Error(`LayersVariable ${this.name} is already disposed.`);
    }
    get trainable() {
        return this.trainable_;
    }
    set trainable(trainable) {
        this.trainable_ = trainable;
        this.val.trainable = trainable;
    }
}
function $55c29868c236e32f$var$checkShapesMatch(x, y) {
    if (x.shape.toString() !== y.shape.toString()) throw new Error('Shape mismatch: ' + JSON.stringify(x.shape) + ' vs. ' + JSON.stringify(y.shape));
}
function $55c29868c236e32f$export$3a9d57cefcd2c285(x, dtype, name, constraint) {
    return new $55c29868c236e32f$export$25de78a5a5bf7257(x, dtype, name, true, constraint);
}
function $55c29868c236e32f$export$b57b9b034d1223d7(shape, dtype, name) {
    // TODO(cais): Implement logic for dtype.
    return new $55c29868c236e32f$export$25de78a5a5bf7257($7KCJq.zeros(shape), dtype, name);
}
function $55c29868c236e32f$export$cb1f824e7733584d(x, dtype, name) {
    return new $55c29868c236e32f$export$25de78a5a5bf7257($k1Ozi.zerosLike(x), dtype, name);
}
function $55c29868c236e32f$export$f21b2d0b36d5e3a3(shape, dtype, name) {
    // TODO(cais): Implement logic for dtype.
    const allocated = $bhi4b.ones(shape);
    return new $55c29868c236e32f$export$25de78a5a5bf7257(allocated, dtype, name);
}
function $55c29868c236e32f$export$fb6afd6214fee9e9(x, dtype, name) {
    const allocated = $9u8DQ.onesLike(x);
    return new $55c29868c236e32f$export$25de78a5a5bf7257(allocated, dtype, name);
}
function $55c29868c236e32f$export$a48ae747268ddcb4(size, dtype, name) {
    return new $55c29868c236e32f$export$25de78a5a5bf7257($dF7rq.eye(size), dtype, name);
}
function $55c29868c236e32f$export$53e488f964846878(shape, minval, maxval, dtype, seed, name = 'randomUniform') {
    return new $55c29868c236e32f$export$25de78a5a5bf7257($gOgMa.randomUniform(shape, minval, maxval, dtype), dtype, name);
}
function $55c29868c236e32f$export$6a7d47f4711fe0f5(shape, mean = 0.0, stddev = 1.0, dtype, seed, name = 'truncatedNormal') {
    // TODO(cais): Implement logic for dtype and seed once they are supported
    // by deeplearn.js.
    dtype = dtype || 'float32';
    if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $jVuYK.NotImplementedError)(`randomNormal does not support dType ${dtype}.`);
    return new $55c29868c236e32f$export$25de78a5a5bf7257($7y8Jw.truncatedNormal(shape, mean, stddev, dtype, seed), dtype, name);
}
function $55c29868c236e32f$export$3f33dee25c54e076(shape, mean = 0.0, stddev = 1.0, dtype, seed, name = 'randomNormal') {
    dtype = dtype || 'float32';
    if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $jVuYK.NotImplementedError)(`randomNormalVariable does not support dType ${dtype}.`);
    return new $55c29868c236e32f$export$25de78a5a5bf7257($h5wle.randomNormal(shape, mean, stddev, dtype, seed), dtype, name);
}
function $55c29868c236e32f$export$722fbec263ad908a(x, xNew) {
    return x.write(xNew);
}
function $55c29868c236e32f$export$35b829383d705ade(x, increment) {
    return x.write($1ZrG5.add(x.read(), increment));
}
function $55c29868c236e32f$export$f213ae8d294bd578(x, decrement) {
    return x.write($hkR0n.sub(x.read(), decrement));
}
function $55c29868c236e32f$export$3702262f615cc9f0(xs) {
    return xs.map((x)=>x.read());
}
function $55c29868c236e32f$export$6b1a34257a4982e4(variablesAndValues) {
    variablesAndValues.forEach((variableAndValue)=>{
        const variable = variableAndValue[0];
        variable.write(variableAndValue[1]);
    });
}
function $55c29868c236e32f$export$fc5727d09955ec17(lossFn, variables) {
    // TODO(cais): The return type signature can be simplified if deeplearn makes
    //   the corresponding type public.
    const variableList = variables.map((variable)=>variable.read());
    const valudAndGrads = (0, $jFQG4.variableGrads)(lossFn, variableList);
    return variables.map((variable)=>valudAndGrads.grads[variable.name]);
}

});





parcelRegister("fVgvv", function(module, exports) {

$parcel$export(module.exports, "maxNorm", () => $b978fbd8863aa3b6$export$72d88ae287ab22e0);
$parcel$export(module.exports, "unitNorm", () => $b978fbd8863aa3b6$export$4a1c05456842cde3);
$parcel$export(module.exports, "nonNeg", () => $b978fbd8863aa3b6$export$38cf945efb543ffe);
$parcel$export(module.exports, "minMaxNorm", () => $b978fbd8863aa3b6$export$a7a432272dbc707f);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ // tslint:disable-next-line:max-line-length

var $cn6Kc = parcelRequire("cn6Kc");
function $b978fbd8863aa3b6$export$72d88ae287ab22e0(args) {
    return new (0, $cn6Kc.MaxNorm)(args);
}
function $b978fbd8863aa3b6$export$4a1c05456842cde3(args) {
    return new (0, $cn6Kc.UnitNorm)(args);
}
function $b978fbd8863aa3b6$export$38cf945efb543ffe() {
    return new (0, $cn6Kc.NonNeg)();
}
function $b978fbd8863aa3b6$export$a7a432272dbc707f(config) {
    return new (0, $cn6Kc.MinMaxNorm)(config);
}

});
parcelRegister("cn6Kc", function(module, exports) {

$parcel$export(module.exports, "MaxNorm", () => $901cdd45bff937de$export$9bae576b4abeeb5b);
$parcel$export(module.exports, "UnitNorm", () => $901cdd45bff937de$export$d308398b296446e8);
$parcel$export(module.exports, "NonNeg", () => $901cdd45bff937de$export$e401f85674f409b);
$parcel$export(module.exports, "MinMaxNorm", () => $901cdd45bff937de$export$b6619aa7a63dac34);
$parcel$export(module.exports, "serializeConstraint", () => $901cdd45bff937de$export$e449710617725987);
$parcel$export(module.exports, "getConstraint", () => $901cdd45bff937de$export$492f40394cb58978);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/contraints.py */ parcelRequire("5n9DG");
var $1ZrG5 = parcelRequire("1ZrG5");
var $jU3Ej = parcelRequire("jU3Ej");
var $gjFWY = parcelRequire("gjFWY");
var $r7fN6 = parcelRequire("r7fN6");
var $1mZlL = parcelRequire("1mZlL");
var $8AyuI = parcelRequire("8AyuI");
var $lGdn1 = parcelRequire("lGdn1");
var $fVwnn = parcelRequire("fVwnn");
var $9c0Qr = parcelRequire("9c0Qr");

var $c51ox = parcelRequire("c51ox");

var $khD6O = parcelRequire("khD6O");
/**
 * Helper function used by many of the Constraints to find the L2Norms.
 */ function $901cdd45bff937de$var$calcL2Norms(w, axis) {
    return (0, $9c0Qr.tidy)(()=>$lGdn1.sqrt($fVwnn.sum($r7fN6.mul(w, w), axis, true)));
}
class $901cdd45bff937de$export$aec1359a0a40a615 extends (0, $8AyuI).Serializable {
    getConfig() {
        return {};
    }
}
class $901cdd45bff937de$export$9bae576b4abeeb5b extends $901cdd45bff937de$export$aec1359a0a40a615 {
    constructor(args){
        super();
        this.defaultMaxValue = 2;
        this.defaultAxis = 0;
        this.maxValue = args.maxValue != null ? args.maxValue : this.defaultMaxValue;
        this.axis = args.axis != null ? args.axis : this.defaultAxis;
    }
    apply(w) {
        return (0, $9c0Qr.tidy)(()=>{
            const norms = $901cdd45bff937de$var$calcL2Norms(w, this.axis);
            const desired = $jU3Ej.clipByValue(norms, 0, this.maxValue);
            return $r7fN6.mul(w, $gjFWY.div(desired, $1ZrG5.add((0, $c51ox.epsilon)(), norms)));
        });
    }
    getConfig() {
        return {
            maxValue: this.maxValue,
            axis: this.axis
        };
    }
}
/** @nocollapse */ $901cdd45bff937de$export$9bae576b4abeeb5b.className = 'MaxNorm';
(0, $8AyuI).registerClass($901cdd45bff937de$export$9bae576b4abeeb5b);
class $901cdd45bff937de$export$d308398b296446e8 extends $901cdd45bff937de$export$aec1359a0a40a615 {
    constructor(args){
        super();
        this.defaultAxis = 0;
        this.axis = args.axis != null ? args.axis : this.defaultAxis;
    }
    apply(w) {
        return (0, $9c0Qr.tidy)(()=>$gjFWY.div(w, $1ZrG5.add((0, $c51ox.epsilon)(), $901cdd45bff937de$var$calcL2Norms(w, this.axis))));
    }
    getConfig() {
        return {
            axis: this.axis
        };
    }
}
/** @nocollapse */ $901cdd45bff937de$export$d308398b296446e8.className = 'UnitNorm';
(0, $8AyuI).registerClass($901cdd45bff937de$export$d308398b296446e8);
class $901cdd45bff937de$export$e401f85674f409b extends $901cdd45bff937de$export$aec1359a0a40a615 {
    apply(w) {
        return $1mZlL.relu(w);
    }
}
/** @nocollapse */ $901cdd45bff937de$export$e401f85674f409b.className = 'NonNeg';
(0, $8AyuI).registerClass($901cdd45bff937de$export$e401f85674f409b);
class $901cdd45bff937de$export$b6619aa7a63dac34 extends $901cdd45bff937de$export$aec1359a0a40a615 {
    constructor(args){
        super();
        this.defaultMinValue = 0.0;
        this.defaultMaxValue = 1.0;
        this.defaultRate = 1.0;
        this.defaultAxis = 0;
        this.minValue = args.minValue != null ? args.minValue : this.defaultMinValue;
        this.maxValue = args.maxValue != null ? args.maxValue : this.defaultMaxValue;
        this.rate = args.rate != null ? args.rate : this.defaultRate;
        this.axis = args.axis != null ? args.axis : this.defaultAxis;
    }
    apply(w) {
        return (0, $9c0Qr.tidy)(()=>{
            const norms = $901cdd45bff937de$var$calcL2Norms(w, this.axis);
            const desired = $1ZrG5.add($r7fN6.mul(this.rate, $jU3Ej.clipByValue(norms, this.minValue, this.maxValue)), $r7fN6.mul(1.0 - this.rate, norms));
            return $r7fN6.mul(w, $gjFWY.div(desired, $1ZrG5.add((0, $c51ox.epsilon)(), norms)));
        });
    }
    getConfig() {
        return {
            minValue: this.minValue,
            maxValue: this.maxValue,
            rate: this.rate,
            axis: this.axis
        };
    }
}
/** @nocollapse */ $901cdd45bff937de$export$b6619aa7a63dac34.className = 'MinMaxNorm';
(0, $8AyuI).registerClass($901cdd45bff937de$export$b6619aa7a63dac34);
const $901cdd45bff937de$export$78360a76bbd2e9aa = {
    'maxNorm': 'MaxNorm',
    'minMaxNorm': 'MinMaxNorm',
    'nonNeg': 'NonNeg',
    'unitNorm': 'UnitNorm'
};
function $901cdd45bff937de$export$e449710617725987(constraint) {
    return (0, $khD6O.serializeKerasObject)(constraint);
}
function $901cdd45bff937de$export$20c8aa8a8b337f29(config, customObjects = {}) {
    return (0, $khD6O.deserializeKerasObject)(config, (0, $8AyuI).SerializationMap.getMap().classNameMap, customObjects, 'constraint');
}
function $901cdd45bff937de$export$492f40394cb58978(identifier) {
    if (identifier == null) return null;
    if (typeof identifier === 'string') {
        const className = identifier in $901cdd45bff937de$export$78360a76bbd2e9aa ? $901cdd45bff937de$export$78360a76bbd2e9aa[identifier] : identifier;
        const config = {
            className: className,
            config: {}
        };
        return $901cdd45bff937de$export$20c8aa8a8b337f29(config);
    } else if (identifier instanceof $901cdd45bff937de$export$aec1359a0a40a615) return identifier;
    else return $901cdd45bff937de$export$20c8aa8a8b337f29(identifier);
}

});


parcelRegister("ez5kB", function(module, exports) {

$parcel$export(module.exports, "zeros", () => $a9a8783d2cd6def0$export$4445a00dafa2633b);
$parcel$export(module.exports, "ones", () => $a9a8783d2cd6def0$export$21041dee6b8001b0);
$parcel$export(module.exports, "constant", () => $a9a8783d2cd6def0$export$c983f826f44ff86);
$parcel$export(module.exports, "randomUniform", () => $a9a8783d2cd6def0$export$bd6fd37822e292fa);
$parcel$export(module.exports, "randomNormal", () => $a9a8783d2cd6def0$export$a0ac5549a8bec918);
$parcel$export(module.exports, "truncatedNormal", () => $a9a8783d2cd6def0$export$8ad5625727f3fa1d);
$parcel$export(module.exports, "identity", () => $a9a8783d2cd6def0$export$f0954fd7d5368655);
$parcel$export(module.exports, "varianceScaling", () => $a9a8783d2cd6def0$export$206fc9a68431980);
$parcel$export(module.exports, "glorotUniform", () => $a9a8783d2cd6def0$export$28a06568c84ecf15);
$parcel$export(module.exports, "glorotNormal", () => $a9a8783d2cd6def0$export$92c012eb6ea18446);
$parcel$export(module.exports, "heNormal", () => $a9a8783d2cd6def0$export$61e5648a74c4c89d);
$parcel$export(module.exports, "heUniform", () => $a9a8783d2cd6def0$export$89cebdcf433bb1f3);
$parcel$export(module.exports, "leCunNormal", () => $a9a8783d2cd6def0$export$e6506404c2021f85);
$parcel$export(module.exports, "leCunUniform", () => $a9a8783d2cd6def0$export$fbc1aa9dab0cc647);
$parcel$export(module.exports, "orthogonal", () => $a9a8783d2cd6def0$export$92fddceccd4ce8b5);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ // tslint:disable-next-line:max-line-length

var $fQ95p = parcelRequire("fQ95p");
function $a9a8783d2cd6def0$export$4445a00dafa2633b() {
    return new (0, $fQ95p.Zeros)();
}
function $a9a8783d2cd6def0$export$21041dee6b8001b0() {
    return new (0, $fQ95p.Ones)();
}
function $a9a8783d2cd6def0$export$c983f826f44ff86(args) {
    return new (0, $fQ95p.Constant)(args);
}
function $a9a8783d2cd6def0$export$bd6fd37822e292fa(args) {
    return new (0, $fQ95p.RandomUniform)(args);
}
function $a9a8783d2cd6def0$export$a0ac5549a8bec918(args) {
    return new (0, $fQ95p.RandomNormal)(args);
}
function $a9a8783d2cd6def0$export$8ad5625727f3fa1d(args) {
    return new (0, $fQ95p.TruncatedNormal)(args);
}
function $a9a8783d2cd6def0$export$f0954fd7d5368655(args) {
    return new (0, $fQ95p.Identity)(args);
}
function $a9a8783d2cd6def0$export$206fc9a68431980(config) {
    return new (0, $fQ95p.VarianceScaling)(config);
}
function $a9a8783d2cd6def0$export$28a06568c84ecf15(args) {
    return new (0, $fQ95p.GlorotUniform)(args);
}
function $a9a8783d2cd6def0$export$92c012eb6ea18446(args) {
    return new (0, $fQ95p.GlorotNormal)(args);
}
function $a9a8783d2cd6def0$export$61e5648a74c4c89d(args) {
    return new (0, $fQ95p.HeNormal)(args);
}
function $a9a8783d2cd6def0$export$89cebdcf433bb1f3(args) {
    return new (0, $fQ95p.HeUniform)(args);
}
function $a9a8783d2cd6def0$export$e6506404c2021f85(args) {
    return new (0, $fQ95p.LeCunNormal)(args);
}
function $a9a8783d2cd6def0$export$fbc1aa9dab0cc647(args) {
    return new (0, $fQ95p.LeCunUniform)(args);
}
function $a9a8783d2cd6def0$export$92fddceccd4ce8b5(args) {
    return new (0, $fQ95p.Orthogonal)(args);
}

});

parcelRegister("f35gO", function(module, exports) {

$parcel$export(module.exports, "inputLayer", () => $af4b3961cc9a6d3c$export$d13ae670ceaa55be);
$parcel$export(module.exports, "elu", () => $af4b3961cc9a6d3c$export$796b583dd79d8524);
$parcel$export(module.exports, "reLU", () => $af4b3961cc9a6d3c$export$a65e70706ebcefb3);
$parcel$export(module.exports, "leakyReLU", () => $af4b3961cc9a6d3c$export$22dc2b3e145b90ac);
$parcel$export(module.exports, "prelu", () => $af4b3961cc9a6d3c$export$5882f235222e6729);
$parcel$export(module.exports, "softmax", () => $af4b3961cc9a6d3c$export$e008137e76238601);
$parcel$export(module.exports, "thresholdedReLU", () => $af4b3961cc9a6d3c$export$39138c8eaf72c4cb);
$parcel$export(module.exports, "conv1d", () => $af4b3961cc9a6d3c$export$d8aa844fa36b350e);
$parcel$export(module.exports, "conv2d", () => $af4b3961cc9a6d3c$export$188f9215482e3db8);
$parcel$export(module.exports, "conv2dTranspose", () => $af4b3961cc9a6d3c$export$d5e924cbc07fb966);
$parcel$export(module.exports, "conv3d", () => $af4b3961cc9a6d3c$export$c476b02bcf7b2def);
$parcel$export(module.exports, "conv3dTranspose", () => $af4b3961cc9a6d3c$export$5eac62031b3f449f);
$parcel$export(module.exports, "separableConv2d", () => $af4b3961cc9a6d3c$export$2586c92899c2d0fb);
$parcel$export(module.exports, "cropping2D", () => $af4b3961cc9a6d3c$export$285835edada5f19f);
$parcel$export(module.exports, "upSampling2d", () => $af4b3961cc9a6d3c$export$1bc6b6356b35b9d0);
$parcel$export(module.exports, "depthwiseConv2d", () => $af4b3961cc9a6d3c$export$48a8ad9494a8fad8);
$parcel$export(module.exports, "activation", () => $af4b3961cc9a6d3c$export$80175f455852d1e4);
$parcel$export(module.exports, "dense", () => $af4b3961cc9a6d3c$export$467fe43f0f8da2cc);
$parcel$export(module.exports, "dropout", () => $af4b3961cc9a6d3c$export$fe05aa12367b4e47);
$parcel$export(module.exports, "spatialDropout1d", () => $af4b3961cc9a6d3c$export$6ab26addce721936);
$parcel$export(module.exports, "flatten", () => $af4b3961cc9a6d3c$export$bffa455ba8c619a6);
$parcel$export(module.exports, "repeatVector", () => $af4b3961cc9a6d3c$export$1dcc9b52fbdb892c);
$parcel$export(module.exports, "reshape", () => $af4b3961cc9a6d3c$export$9eaad88cf88cee2b);
$parcel$export(module.exports, "permute", () => $af4b3961cc9a6d3c$export$95e62ad65da8b7d2);
$parcel$export(module.exports, "embedding", () => $af4b3961cc9a6d3c$export$ffae51527c311cac);
$parcel$export(module.exports, "add", () => $af4b3961cc9a6d3c$export$e16d8520af44a096);
$parcel$export(module.exports, "average", () => $af4b3961cc9a6d3c$export$cc6710ee5f037d57);
$parcel$export(module.exports, "concatenate", () => $af4b3961cc9a6d3c$export$375c71d43969527d);
$parcel$export(module.exports, "maximum", () => $af4b3961cc9a6d3c$export$b25e0be55f42c9a);
$parcel$export(module.exports, "minimum", () => $af4b3961cc9a6d3c$export$916782c1f0ddb132);
$parcel$export(module.exports, "multiply", () => $af4b3961cc9a6d3c$export$2060d2db72cce88f);
$parcel$export(module.exports, "dot", () => $af4b3961cc9a6d3c$export$94132a0e348806d4);
$parcel$export(module.exports, "batchNormalization", () => $af4b3961cc9a6d3c$export$598a795b5a50c0b5);
$parcel$export(module.exports, "layerNormalization", () => $af4b3961cc9a6d3c$export$d46ad5357bc3d7f6);
$parcel$export(module.exports, "zeroPadding2d", () => $af4b3961cc9a6d3c$export$34e2ef2c537eafd4);
$parcel$export(module.exports, "averagePooling1d", () => $af4b3961cc9a6d3c$export$e308d3e6c3deb4b5);
$parcel$export(module.exports, "avgPool1d", () => $af4b3961cc9a6d3c$export$b44f2e4690260fec);
$parcel$export(module.exports, "avgPooling1d", () => $af4b3961cc9a6d3c$export$42629f014f8228f7);
$parcel$export(module.exports, "averagePooling2d", () => $af4b3961cc9a6d3c$export$d5f09f295e795be0);
$parcel$export(module.exports, "avgPool2d", () => $af4b3961cc9a6d3c$export$18e398525949757);
$parcel$export(module.exports, "avgPooling2d", () => $af4b3961cc9a6d3c$export$3009909165cde72c);
$parcel$export(module.exports, "averagePooling3d", () => $af4b3961cc9a6d3c$export$a60791858ca3b1a2);
$parcel$export(module.exports, "avgPool3d", () => $af4b3961cc9a6d3c$export$ee1b0efb53eb29c3);
$parcel$export(module.exports, "avgPooling3d", () => $af4b3961cc9a6d3c$export$149ead6bf7dd851c);
$parcel$export(module.exports, "globalAveragePooling1d", () => $af4b3961cc9a6d3c$export$30e0dcdbab04acb);
$parcel$export(module.exports, "globalAveragePooling2d", () => $af4b3961cc9a6d3c$export$4ff10070d09b111d);
$parcel$export(module.exports, "globalMaxPooling1d", () => $af4b3961cc9a6d3c$export$52aa533ccda11c4c);
$parcel$export(module.exports, "globalMaxPooling2d", () => $af4b3961cc9a6d3c$export$e1bfae148b2f4ec8);
$parcel$export(module.exports, "maxPooling1d", () => $af4b3961cc9a6d3c$export$c49c691c8f72af06);
$parcel$export(module.exports, "maxPooling2d", () => $af4b3961cc9a6d3c$export$fcf913567033698f);
$parcel$export(module.exports, "maxPooling3d", () => $af4b3961cc9a6d3c$export$64421faebeee5ef8);
$parcel$export(module.exports, "gru", () => $af4b3961cc9a6d3c$export$e12d2defa419b53a);
$parcel$export(module.exports, "gruCell", () => $af4b3961cc9a6d3c$export$d3685ad59ec626a6);
$parcel$export(module.exports, "lstm", () => $af4b3961cc9a6d3c$export$fe5a22aa5359fc69);
$parcel$export(module.exports, "lstmCell", () => $af4b3961cc9a6d3c$export$79425027c2dd20e6);
$parcel$export(module.exports, "simpleRNN", () => $af4b3961cc9a6d3c$export$5ccbc90d85639fb9);
$parcel$export(module.exports, "simpleRNNCell", () => $af4b3961cc9a6d3c$export$8e8d4a6c4528553);
$parcel$export(module.exports, "convLstm2d", () => $af4b3961cc9a6d3c$export$807c24c535353095);
$parcel$export(module.exports, "convLstm2dCell", () => $af4b3961cc9a6d3c$export$e8d3b2ad5b300a03);
$parcel$export(module.exports, "rnn", () => $af4b3961cc9a6d3c$export$3e66d5ce8f778ebc);
$parcel$export(module.exports, "stackedRNNCells", () => $af4b3961cc9a6d3c$export$d977f05737668a6);
$parcel$export(module.exports, "bidirectional", () => $af4b3961cc9a6d3c$export$ad322fa54f969043);
$parcel$export(module.exports, "timeDistributed", () => $af4b3961cc9a6d3c$export$8b8f46f74cfe04dc);
$parcel$export(module.exports, "globalMaxPool1d", () => $af4b3961cc9a6d3c$export$2efd4c09521df503);
$parcel$export(module.exports, "globalMaxPool2d", () => $af4b3961cc9a6d3c$export$4a73421a2f7eceac);
$parcel$export(module.exports, "maxPool1d", () => $af4b3961cc9a6d3c$export$b4ce5850fd040d92);
$parcel$export(module.exports, "maxPool2d", () => $af4b3961cc9a6d3c$export$cb09112eb789ff08);
$parcel$export(module.exports, "gaussianNoise", () => $af4b3961cc9a6d3c$export$cd62c6b94cb3c213);
$parcel$export(module.exports, "gaussianDropout", () => $af4b3961cc9a6d3c$export$bc128cd40ed5bfda);
$parcel$export(module.exports, "alphaDropout", () => $af4b3961cc9a6d3c$export$d73d2c7da153e772);
$parcel$export(module.exports, "masking", () => $af4b3961cc9a6d3c$export$2918598f73ee1e32);
$parcel$export(module.exports, "rescaling", () => $af4b3961cc9a6d3c$export$a512ecbbed70f3e);
$parcel$export(module.exports, "Layer", () => (parcelRequire("cm045")).Layer);
$parcel$export(module.exports, "RNN", () => (parcelRequire("ejY9c")).RNN);
$parcel$export(module.exports, "RNNCell", () => (parcelRequire("ejY9c")).RNNCell);
$parcel$export(module.exports, "input", () => (parcelRequire("4uu9C")).input);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $3gFUY = parcelRequire("3gFUY");

var $cm045 = parcelRequire("cm045");

var $4uu9C = parcelRequire("4uu9C");

var $fbJ6w = parcelRequire("fbJ6w");

var $h6F8e = parcelRequire("h6F8e");

var $3dl56 = parcelRequire("3dl56");

var $52hJq = parcelRequire("52hJq");

var $4Drap = parcelRequire("4Drap");

var $7X54l = parcelRequire("7X54l");

var $4qVWd = parcelRequire("4qVWd");

var $438W2 = parcelRequire("438W2");

var $jbtPJ = parcelRequire("jbtPJ");

var $qNHFJ = parcelRequire("qNHFJ");

var $cNtDv = parcelRequire("cNtDv");

var $ejY9c = parcelRequire("ejY9c");

var $1oDpc = parcelRequire("1oDpc");

var $jjYrT = parcelRequire("jjYrT");
function $af4b3961cc9a6d3c$export$d13ae670ceaa55be(args) {
    return new (0, $3gFUY.InputLayer)(args);
}
function $af4b3961cc9a6d3c$export$796b583dd79d8524(args) {
    return new (0, $fbJ6w.ELU)(args);
}
function $af4b3961cc9a6d3c$export$a65e70706ebcefb3(args) {
    return new (0, $fbJ6w.ReLU)(args);
}
function $af4b3961cc9a6d3c$export$22dc2b3e145b90ac(args) {
    return new (0, $fbJ6w.LeakyReLU)(args);
}
function $af4b3961cc9a6d3c$export$5882f235222e6729(args) {
    return new (0, $fbJ6w.PReLU)(args);
}
function $af4b3961cc9a6d3c$export$e008137e76238601(args) {
    return new (0, $fbJ6w.Softmax)(args);
}
function $af4b3961cc9a6d3c$export$39138c8eaf72c4cb(args) {
    return new (0, $fbJ6w.ThresholdedReLU)(args);
}
function $af4b3961cc9a6d3c$export$d8aa844fa36b350e(args) {
    return new (0, $h6F8e.Conv1D)(args);
}
function $af4b3961cc9a6d3c$export$188f9215482e3db8(args) {
    return new (0, $h6F8e.Conv2D)(args);
}
function $af4b3961cc9a6d3c$export$d5e924cbc07fb966(args) {
    return new (0, $h6F8e.Conv2DTranspose)(args);
}
function $af4b3961cc9a6d3c$export$c476b02bcf7b2def(args) {
    return new (0, $h6F8e.Conv3D)(args);
}
function $af4b3961cc9a6d3c$export$5eac62031b3f449f(args) {
    return new (0, $h6F8e.Conv3DTranspose)(args);
}
function $af4b3961cc9a6d3c$export$2586c92899c2d0fb(args) {
    return new (0, $h6F8e.SeparableConv2D)(args);
}
function $af4b3961cc9a6d3c$export$285835edada5f19f(args) {
    return new (0, $h6F8e.Cropping2D)(args);
}
function $af4b3961cc9a6d3c$export$1bc6b6356b35b9d0(args) {
    return new (0, $h6F8e.UpSampling2D)(args);
}
function $af4b3961cc9a6d3c$export$48a8ad9494a8fad8(args) {
    return new (0, $3dl56.DepthwiseConv2D)(args);
}
function $af4b3961cc9a6d3c$export$80175f455852d1e4(args) {
    return new (0, $4Drap.Activation)(args);
}
function $af4b3961cc9a6d3c$export$467fe43f0f8da2cc(args) {
    return new (0, $4Drap.Dense)(args);
}
function $af4b3961cc9a6d3c$export$fe05aa12367b4e47(args) {
    return new (0, $4Drap.Dropout)(args);
}
function $af4b3961cc9a6d3c$export$6ab26addce721936(args) {
    return new (0, $4Drap.SpatialDropout1D)(args);
}
function $af4b3961cc9a6d3c$export$bffa455ba8c619a6(args) {
    return new (0, $4Drap.Flatten)(args);
}
function $af4b3961cc9a6d3c$export$1dcc9b52fbdb892c(args) {
    return new (0, $4Drap.RepeatVector)(args);
}
function $af4b3961cc9a6d3c$export$9eaad88cf88cee2b(args) {
    return new (0, $4Drap.Reshape)(args);
}
function $af4b3961cc9a6d3c$export$95e62ad65da8b7d2(args) {
    return new (0, $4Drap.Permute)(args);
}
function $af4b3961cc9a6d3c$export$ffae51527c311cac(args) {
    return new (0, $7X54l.Embedding)(args);
}
function $af4b3961cc9a6d3c$export$e16d8520af44a096(args) {
    return new (0, $4qVWd.Add)(args);
}
function $af4b3961cc9a6d3c$export$cc6710ee5f037d57(args) {
    return new (0, $4qVWd.Average)(args);
}
function $af4b3961cc9a6d3c$export$375c71d43969527d(args) {
    return new (0, $4qVWd.Concatenate)(args);
}
function $af4b3961cc9a6d3c$export$b25e0be55f42c9a(args) {
    return new (0, $4qVWd.Maximum)(args);
}
function $af4b3961cc9a6d3c$export$916782c1f0ddb132(args) {
    return new (0, $4qVWd.Minimum)(args);
}
function $af4b3961cc9a6d3c$export$2060d2db72cce88f(args) {
    return new (0, $4qVWd.Multiply)(args);
}
function $af4b3961cc9a6d3c$export$94132a0e348806d4(args) {
    return new (0, $4qVWd.Dot)(args);
}
function $af4b3961cc9a6d3c$export$598a795b5a50c0b5(args) {
    return new (0, $jbtPJ.BatchNormalization)(args);
}
function $af4b3961cc9a6d3c$export$d46ad5357bc3d7f6(args) {
    return new (0, $jbtPJ.LayerNormalization)(args);
}
function $af4b3961cc9a6d3c$export$34e2ef2c537eafd4(args) {
    return new (0, $qNHFJ.ZeroPadding2D)(args);
}
function $af4b3961cc9a6d3c$export$e308d3e6c3deb4b5(args) {
    return new (0, $cNtDv.AveragePooling1D)(args);
}
function $af4b3961cc9a6d3c$export$b44f2e4690260fec(args) {
    return $af4b3961cc9a6d3c$export$e308d3e6c3deb4b5(args);
}
function $af4b3961cc9a6d3c$export$42629f014f8228f7(args) {
    return $af4b3961cc9a6d3c$export$e308d3e6c3deb4b5(args);
}
function $af4b3961cc9a6d3c$export$d5f09f295e795be0(args) {
    return new (0, $cNtDv.AveragePooling2D)(args);
}
function $af4b3961cc9a6d3c$export$18e398525949757(args) {
    return $af4b3961cc9a6d3c$export$d5f09f295e795be0(args);
}
function $af4b3961cc9a6d3c$export$3009909165cde72c(args) {
    return $af4b3961cc9a6d3c$export$d5f09f295e795be0(args);
}
function $af4b3961cc9a6d3c$export$a60791858ca3b1a2(args) {
    return new (0, $cNtDv.AveragePooling3D)(args);
}
function $af4b3961cc9a6d3c$export$ee1b0efb53eb29c3(args) {
    return $af4b3961cc9a6d3c$export$a60791858ca3b1a2(args);
}
function $af4b3961cc9a6d3c$export$149ead6bf7dd851c(args) {
    return $af4b3961cc9a6d3c$export$a60791858ca3b1a2(args);
}
function $af4b3961cc9a6d3c$export$30e0dcdbab04acb(args) {
    return new (0, $cNtDv.GlobalAveragePooling1D)(args);
}
function $af4b3961cc9a6d3c$export$4ff10070d09b111d(args) {
    return new (0, $cNtDv.GlobalAveragePooling2D)(args);
}
function $af4b3961cc9a6d3c$export$52aa533ccda11c4c(args) {
    return new (0, $cNtDv.GlobalMaxPooling1D)(args);
}
function $af4b3961cc9a6d3c$export$e1bfae148b2f4ec8(args) {
    return new (0, $cNtDv.GlobalMaxPooling2D)(args);
}
function $af4b3961cc9a6d3c$export$c49c691c8f72af06(args) {
    return new (0, $cNtDv.MaxPooling1D)(args);
}
function $af4b3961cc9a6d3c$export$fcf913567033698f(args) {
    return new (0, $cNtDv.MaxPooling2D)(args);
}
function $af4b3961cc9a6d3c$export$64421faebeee5ef8(args) {
    return new (0, $cNtDv.MaxPooling3D)(args);
}
function $af4b3961cc9a6d3c$export$e12d2defa419b53a(args) {
    return new (0, $ejY9c.GRU)(args);
}
function $af4b3961cc9a6d3c$export$d3685ad59ec626a6(args) {
    return new (0, $ejY9c.GRUCell)(args);
}
function $af4b3961cc9a6d3c$export$fe5a22aa5359fc69(args) {
    return new (0, $ejY9c.LSTM)(args);
}
function $af4b3961cc9a6d3c$export$79425027c2dd20e6(args) {
    return new (0, $ejY9c.LSTMCell)(args);
}
function $af4b3961cc9a6d3c$export$5ccbc90d85639fb9(args) {
    return new (0, $ejY9c.SimpleRNN)(args);
}
function $af4b3961cc9a6d3c$export$8e8d4a6c4528553(args) {
    return new (0, $ejY9c.SimpleRNNCell)(args);
}
function $af4b3961cc9a6d3c$export$807c24c535353095(args) {
    return new (0, $52hJq.ConvLSTM2D)(args);
}
function $af4b3961cc9a6d3c$export$e8d3b2ad5b300a03(args) {
    return new (0, $52hJq.ConvLSTM2DCell)(args);
}
function $af4b3961cc9a6d3c$export$3e66d5ce8f778ebc(args) {
    return new (0, $ejY9c.RNN)(args);
}
function $af4b3961cc9a6d3c$export$d977f05737668a6(args) {
    return new (0, $ejY9c.StackedRNNCells)(args);
}
function $af4b3961cc9a6d3c$export$ad322fa54f969043(args) {
    return new (0, $1oDpc.Bidirectional)(args);
}
function $af4b3961cc9a6d3c$export$8b8f46f74cfe04dc(args) {
    return new (0, $1oDpc.TimeDistributed)(args);
}
const $af4b3961cc9a6d3c$export$2efd4c09521df503 = $af4b3961cc9a6d3c$export$52aa533ccda11c4c;
const $af4b3961cc9a6d3c$export$4a73421a2f7eceac = $af4b3961cc9a6d3c$export$e1bfae148b2f4ec8;
const $af4b3961cc9a6d3c$export$b4ce5850fd040d92 = $af4b3961cc9a6d3c$export$c49c691c8f72af06;
const $af4b3961cc9a6d3c$export$cb09112eb789ff08 = $af4b3961cc9a6d3c$export$fcf913567033698f;
function $af4b3961cc9a6d3c$export$cd62c6b94cb3c213(args) {
    return new (0, $438W2.GaussianNoise)(args);
}
function $af4b3961cc9a6d3c$export$bc128cd40ed5bfda(args) {
    return new (0, $438W2.GaussianDropout)(args);
}
function $af4b3961cc9a6d3c$export$d73d2c7da153e772(args) {
    return new (0, $438W2.AlphaDropout)(args);
}
function $af4b3961cc9a6d3c$export$2918598f73ee1e32(args) {
    return new (0, $4Drap.Masking)(args);
}
function $af4b3961cc9a6d3c$export$a512ecbbed70f3e(args) {
    return new (0, $jjYrT.Rescaling)(args);
}

});
parcelRegister("4uu9C", function(module, exports) {

$parcel$export(module.exports, "model", () => $34515abf7b4780d6$export$39a8f6bed6e94390);
$parcel$export(module.exports, "sequential", () => $34515abf7b4780d6$export$3c7b24ce1c81e349);
$parcel$export(module.exports, "loadLayersModel", () => $34515abf7b4780d6$export$f379ad49c680b84a);
$parcel$export(module.exports, "input", () => $34515abf7b4780d6$export$b7e3ae3d7c15e42e);
$parcel$export(module.exports, "registerCallbackConstructor", () => $34515abf7b4780d6$export$e4ead4e2d6e9b3fd);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $9fe8M = parcelRequire("9fe8M");

var $3gFUY = parcelRequire("3gFUY");

var $8foXR = parcelRequire("8foXR");

var $31SiL = parcelRequire("31SiL");
function $34515abf7b4780d6$export$39a8f6bed6e94390(args) {
    return new (0, $8foXR.LayersModel)(args);
}
function $34515abf7b4780d6$export$3c7b24ce1c81e349(config) {
    return new (0, $31SiL.Sequential)(config);
}
function $34515abf7b4780d6$export$f379ad49c680b84a(pathOrIOHandler, options) {
    if (options == null) options = {};
    return (0, $31SiL.loadLayersModelInternal)(pathOrIOHandler, options);
}
function $34515abf7b4780d6$export$b7e3ae3d7c15e42e(config) {
    return (0, $3gFUY.Input)(config);
}
function $34515abf7b4780d6$export$e4ead4e2d6e9b3fd(verbosityLevel, callbackConstructor) {
    (0, $9fe8M.CallbackConstructorRegistry).registerCallbackConstructor(verbosityLevel, callbackConstructor);
}

});
parcelRegister("9fe8M", function(module, exports) {

$parcel$export(module.exports, "BaseCallback", () => $6bb07bc897a87a7e$export$ac023a7995700a90);
$parcel$export(module.exports, "CallbackList", () => $6bb07bc897a87a7e$export$435cb83c816395fd);
$parcel$export(module.exports, "History", () => $6bb07bc897a87a7e$export$84202caead5689ba);
$parcel$export(module.exports, "CustomCallback", () => $6bb07bc897a87a7e$export$5682c09493042ec8);
$parcel$export(module.exports, "standardizeCallbacks", () => $6bb07bc897a87a7e$export$8ea03bd28ba7b2ff);
$parcel$export(module.exports, "CallbackConstructorRegistry", () => $6bb07bc897a87a7e$export$3b4f51c3fa9f338c);
$parcel$export(module.exports, "configureCallbacks", () => $6bb07bc897a87a7e$export$18b2cd3db6266dd9);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/callbacks.py */ parcelRequire("5n9DG");
var $1ZrG5 = parcelRequire("1ZrG5");
var $gjFWY = parcelRequire("gjFWY");
var $9c0Qr = parcelRequire("9c0Qr");
var $r7fN6 = parcelRequire("r7fN6");
var $hy0Vl = parcelRequire("hy0Vl");
var $wx9lK = parcelRequire("wx9lK");

var $jVuYK = parcelRequire("jVuYK");

var $7EFWn = parcelRequire("7EFWn");

var $khD6O = parcelRequire("khD6O");
var $6bb07bc897a87a7e$export$7770e64db700cbdd;
(function(ModelLoggingVerbosity) {
    ModelLoggingVerbosity[ModelLoggingVerbosity["SILENT"] = 0] = "SILENT";
    ModelLoggingVerbosity[ModelLoggingVerbosity["VERBOSE"] = 1] = "VERBOSE";
})($6bb07bc897a87a7e$export$7770e64db700cbdd || ($6bb07bc897a87a7e$export$7770e64db700cbdd = {}));
const $6bb07bc897a87a7e$export$2966f81b7af02452 = 125;
class $6bb07bc897a87a7e$export$ac023a7995700a90 {
    constructor(){
        // TODO(michaelterry): This type is a best guess.
        this.validationData = null;
    }
    setParams(params) {
        this.params = params;
    }
    async onEpochBegin(epoch, logs) {}
    async onEpochEnd(epoch, logs) {}
    async onBatchBegin(batch, logs) {}
    async onBatchEnd(batch, logs) {}
    async onTrainBegin(logs) {}
    async onTrainEnd(logs) {}
    // LayersModel needs to call Callback.setModel(), but cannot actually depend
    // on Callback because that creates a cyclic dependency.  Providing this no-op
    // method on BaseCallback breaks the cycle: this way LayersModel can depend on
    // BaseCallback but not on Callback.  The argument is typed as `Container`
    // (the superclass of LayersModel) to avoid recapitulating the cycle. Callback
    // overrides this method and enforces that the argument is really a
    // LayersModel.
    setModel(model) {
    // Do nothing. Use Callback instead of BaseCallback to track the model.
    }
}
class $6bb07bc897a87a7e$export$435cb83c816395fd {
    // TODO(cais): When the need arises, uncomment the following lines and
    // implement the queue for time values.
    // private deltaTBatch: number;
    // private deltaTsBatchBegin: Array<number>;
    // private deltaTsBatchEnd: Array<number>;
    /**
     * Constructor of CallbackList.
     * @param callbacks Array of `Callback` instances.
     * @param queueLength Queue length for keeping running statistics over
     *   callback execution time.
     */ constructor(callbacks, queueLength = 10){
        // TODO(cais): Make use of queueLength when implementing the queue for time
        // values.
        if (callbacks == null) callbacks = [];
        this.callbacks = callbacks;
        this.queueLength = queueLength;
    }
    append(callback) {
        this.callbacks.push(callback);
    }
    setParams(params) {
        for (const callback of this.callbacks)callback.setParams(params);
    }
    setModel(model) {
        for (const callback of this.callbacks)callback.setModel(model);
    }
    /**
     * Called at the start of an epoch.
     * @param epoch Index of epoch.
     * @param logs Dictionary of logs.
     */ async onEpochBegin(epoch, logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onEpochBegin(epoch, logs);
    }
    /**
     * Called at the end of an epoch.
     * @param epoch Index of epoch.
     * @param logs Dictionary of logs.
     */ async onEpochEnd(epoch, logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onEpochEnd(epoch, logs);
    }
    /**
     * Called  right before processing a batch.
     * @param batch Index of batch within the current epoch.
     * @param logs Dictionary of logs.
     */ async onBatchBegin(batch, logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onBatchBegin(batch, logs);
    }
    /**
     * Called at the end of a batch.
     * @param batch Index of batch within the current epoch.
     * @param logs Dictionary of logs.
     */ async onBatchEnd(batch, logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onBatchEnd(batch, logs);
    }
    /**
     * Called at the beginning of training.
     * @param logs Dictionary of logs.
     */ async onTrainBegin(logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onTrainBegin(logs);
    }
    /**
     * Called at the end of training.
     * @param logs Dictionary of logs.
     */ async onTrainEnd(logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onTrainEnd(logs);
    }
}
class $6bb07bc897a87a7e$export$bf796c2da54a4a40 extends $6bb07bc897a87a7e$export$ac023a7995700a90 {
    constructor(){
        super();
    }
    async onEpochBegin(epoch) {
        this.seen = 0;
        this.totals = {};
    }
    async onBatchEnd(batch, logs) {
        if (logs == null) logs = {};
        const batchSize = logs['size'] == null ? 0 : logs['size'];
        this.seen += batchSize;
        for(const key in logs){
            const value = logs[key];
            if (typeof value === 'number') {
                if (!this.totals.hasOwnProperty(key)) this.totals[key] = 0;
                this.totals[key] = this.totals[key] + value * batchSize;
            } else {
                let oldTotalsToDispose;
                if (key in this.totals) oldTotalsToDispose = this.totals[key];
                else this.totals[key] = 0;
                const total = (0, $9c0Qr.tidy)(()=>(0, $1ZrG5.add)(this.totals[key], (0, $r7fN6.mul)(value, batchSize)));
                this.totals[key] = total;
                if (oldTotalsToDispose != null) oldTotalsToDispose.dispose();
            }
        }
    }
    async onEpochEnd(epoch, logs) {
        if (logs != null) for (const key of this.params['metrics']){
            if (this.totals[key] == null) continue;
            if (typeof this.totals[key] === 'number') logs[key] = this.totals[key] / this.seen;
            else (0, $9c0Qr.tidy)(()=>{
                const log = (0, $r7fN6.mul)((0, $gjFWY.div)(1, this.seen), this.totals[key]);
                logs[key] = log;
                this.totals[key].dispose();
                (0, $9c0Qr.keep)(logs[key]);
            });
        }
    }
}
class $6bb07bc897a87a7e$export$84202caead5689ba extends $6bb07bc897a87a7e$export$ac023a7995700a90 {
    async onTrainBegin(logs) {
        this.epoch = [];
        this.history = {};
    }
    async onEpochEnd(epoch, logs) {
        if (logs == null) logs = {};
        this.epoch.push(epoch);
        for(const key in logs){
            if (this.history[key] == null) this.history[key] = [];
            this.history[key].push(logs[key]);
        }
    }
    /**
     * Await the values of all losses and metrics.
     */ async syncData() {
        const promises = [];
        const keys = [];
        const indices = [];
        for(const key in this.history){
            const valueArray = this.history[key];
            for(let i = 0; i < valueArray.length; ++i)if (typeof valueArray[i] !== 'number') {
                const valueScalar = valueArray[i];
                promises.push(valueScalar.data());
                keys.push(key);
                indices.push(i);
            }
        }
        const values = await Promise.all(promises);
        for(let n = 0; n < values.length; ++n){
            const tensorToDispose = this.history[keys[n]][indices[n]];
            tensorToDispose.dispose();
            this.history[keys[n]][indices[n]] = values[n][0];
        }
    }
}
class $6bb07bc897a87a7e$export$5682c09493042ec8 extends $6bb07bc897a87a7e$export$ac023a7995700a90 {
    constructor(args, yieldEvery){
        super();
        this.currentEpoch = 0;
        this.nowFunc = args.nowFunc;
        this.nextFrameFunc = args.nextFrameFunc || (0, $hy0Vl.nextFrame);
        this.yieldEvery = yieldEvery || 'auto';
        if (this.yieldEvery === 'auto') this.yieldEvery = $6bb07bc897a87a7e$export$2966f81b7af02452;
        if (this.yieldEvery === 'never' && args.onYield != null) throw new Error("yieldEvery is `never` but you provided an `onYield` callback. Either change `yieldEvery` or remove the callback");
        if ((0, $wx9lK).isNumber(this.yieldEvery)) // Decorate `maybeWait` so it will be called at most once every
        // `yieldEvery` ms.
        this.maybeWait = $khD6O.debounce(this.maybeWait.bind(this), this.yieldEvery, this.nowFunc);
        this.trainBegin = args.onTrainBegin;
        this.trainEnd = args.onTrainEnd;
        this.epochBegin = args.onEpochBegin;
        this.epochEnd = args.onEpochEnd;
        this.batchBegin = args.onBatchBegin;
        this.batchEnd = args.onBatchEnd;
        this.yield = args.onYield;
    }
    async maybeWait(epoch, batch, logs) {
        const ps = [];
        if (this.yield != null) {
            await (0, $7EFWn.resolveScalarsInLogs)(logs);
            ps.push(this.yield(epoch, batch, logs));
        }
        ps.push(this.nextFrameFunc());
        await Promise.all(ps);
    }
    async onEpochBegin(epoch, logs) {
        this.currentEpoch = epoch;
        if (this.epochBegin != null) {
            await (0, $7EFWn.resolveScalarsInLogs)(logs);
            await this.epochBegin(epoch, logs);
        }
    }
    async onEpochEnd(epoch, logs) {
        const ps = [];
        if (this.epochEnd != null) {
            await (0, $7EFWn.resolveScalarsInLogs)(logs);
            ps.push(this.epochEnd(epoch, logs));
        }
        if (this.yieldEvery === 'epoch') ps.push(this.nextFrameFunc());
        await Promise.all(ps);
    }
    async onBatchBegin(batch, logs) {
        if (this.batchBegin != null) {
            await (0, $7EFWn.resolveScalarsInLogs)(logs);
            await this.batchBegin(batch, logs);
        }
    }
    async onBatchEnd(batch, logs) {
        const ps = [];
        if (this.batchEnd != null) {
            await (0, $7EFWn.resolveScalarsInLogs)(logs);
            ps.push(this.batchEnd(batch, logs));
        }
        if (this.yieldEvery === 'batch') ps.push(this.nextFrameFunc());
        else if ((0, $wx9lK).isNumber(this.yieldEvery)) ps.push(this.maybeWait(this.currentEpoch, batch, logs));
        await Promise.all(ps);
    }
    async onTrainBegin(logs) {
        if (this.trainBegin != null) {
            await (0, $7EFWn.resolveScalarsInLogs)(logs);
            await this.trainBegin(logs);
        }
    }
    async onTrainEnd(logs) {
        if (this.trainEnd != null) {
            await (0, $7EFWn.resolveScalarsInLogs)(logs);
            await this.trainEnd(logs);
        }
    }
}
function $6bb07bc897a87a7e$export$8ea03bd28ba7b2ff(callbacks, yieldEvery) {
    if (callbacks == null) callbacks = {};
    if (callbacks instanceof $6bb07bc897a87a7e$export$ac023a7995700a90) return [
        callbacks
    ];
    if (Array.isArray(callbacks) && callbacks[0] instanceof $6bb07bc897a87a7e$export$ac023a7995700a90) return callbacks;
    // Convert custom callback configs to custom callback objects.
    const callbackConfigs = $khD6O.toList(callbacks);
    return callbackConfigs.map((callbackConfig)=>new $6bb07bc897a87a7e$export$5682c09493042ec8(callbackConfig, yieldEvery));
}
class $6bb07bc897a87a7e$export$3b4f51c3fa9f338c {
    /**
     * Blocks public access to constructor.
     */ constructor(){}
    /**
     * Register a tf.LayersModel.fit() callback constructor.
     *
     * The registered callback constructor will be used to instantiate
     * callbacks for every tf.LayersModel.fit() call afterwards.
     *
     * @param verbosityLevel Level of verbosity at which the `callbackConstructor`
     *   is to be reigstered.
     * @param callbackConstructor A no-arg constructor for `tf.Callback`.
     * @throws Error, if the same callbackConstructor has been registered before,
     *   either at the same or a different `verbosityLevel`.
     */ static registerCallbackConstructor(verbosityLevel, callbackConstructor) {
        (0, $wx9lK).assert(verbosityLevel >= 0 && Number.isInteger(verbosityLevel), ()=>`Verbosity level is expected to be an integer >= 0, ` + `but got ${verbosityLevel}`);
        $6bb07bc897a87a7e$export$3b4f51c3fa9f338c.checkForDuplicate(callbackConstructor);
        if ($6bb07bc897a87a7e$export$3b4f51c3fa9f338c.constructors[verbosityLevel] == null) $6bb07bc897a87a7e$export$3b4f51c3fa9f338c.constructors[verbosityLevel] = [];
        $6bb07bc897a87a7e$export$3b4f51c3fa9f338c.constructors[verbosityLevel].push(callbackConstructor);
    }
    static checkForDuplicate(callbackConstructor) {
        for(const levelName in $6bb07bc897a87a7e$export$3b4f51c3fa9f338c.constructors){
            const constructors = $6bb07bc897a87a7e$export$3b4f51c3fa9f338c.constructors[+levelName];
            constructors.forEach((ctor)=>{
                if (ctor === callbackConstructor) throw new (0, $jVuYK.ValueError)('Duplicate callback constructor.');
            });
        }
    }
    /**
     * Clear all registered callback constructors.
     */ static clear() {
        $6bb07bc897a87a7e$export$3b4f51c3fa9f338c.constructors = {};
    }
    /**
     * Create callbacks using the registered callback constructors.
     *
     * Given `verbosityLevel`, all constructors registered at that level or above
     * will be called and the instantiated callbacks will be used.
     *
     * @param verbosityLevel: Level of verbosity.
     */ static createCallbacks(verbosityLevel) {
        const constructors = [];
        for(const levelName in $6bb07bc897a87a7e$export$3b4f51c3fa9f338c.constructors){
            const level = +levelName;
            if (verbosityLevel >= level) constructors.push(...$6bb07bc897a87a7e$export$3b4f51c3fa9f338c.constructors[level]);
        }
        return constructors.map((ctor)=>new ctor());
    }
}
$6bb07bc897a87a7e$export$3b4f51c3fa9f338c.constructors = {};
function $6bb07bc897a87a7e$export$18b2cd3db6266dd9(callbacks, verbose, epochs, initialEpoch, numTrainSamples, stepsPerEpoch, batchSize, doValidation, callbackMetrics) {
    const history = new $6bb07bc897a87a7e$export$84202caead5689ba();
    const actualCallbacks = [
        new $6bb07bc897a87a7e$export$bf796c2da54a4a40(),
        ...$6bb07bc897a87a7e$export$3b4f51c3fa9f338c.createCallbacks(verbose)
    ];
    if (callbacks != null) actualCallbacks.push(...callbacks);
    actualCallbacks.push(history);
    const callbackList = new $6bb07bc897a87a7e$export$435cb83c816395fd(actualCallbacks);
    // TODO(cais): Figure out when this LayersModel instance can have a
    // dynamically
    //   set property called 'callback_model' as in PyKeras.
    callbackList.setParams({
        epochs: epochs,
        initialEpoch: initialEpoch,
        samples: numTrainSamples,
        steps: stepsPerEpoch,
        batchSize: batchSize,
        verbose: verbose,
        doValidation: doValidation,
        metrics: callbackMetrics
    });
    return {
        callbackList: callbackList,
        history: history
    };
}

});
parcelRegister("7EFWn", function(module, exports) {

$parcel$export(module.exports, "resolveScalarsInLogs", () => $592ccd54c4af57fd$export$edec74c62c989297);
$parcel$export(module.exports, "disposeTensorsInLogs", () => $592ccd54c4af57fd$export$f4920d82017cd044);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $9c0Qr = parcelRequire("9c0Qr");
async function $592ccd54c4af57fd$export$edec74c62c989297(logs) {
    if (logs == null) return;
    const promises = [];
    const keys = [];
    const scalarsToDispose = [];
    for(const key in logs){
        const value = logs[key];
        if (typeof value !== 'number') {
            const valueScalar = value;
            promises.push(valueScalar.data());
            keys.push(key);
            scalarsToDispose.push(valueScalar);
        }
    }
    if (promises.length > 0) {
        const values = await Promise.all(promises);
        for(let i = 0; i < values.length; ++i)logs[keys[i]] = values[i][0];
        // Dispose the original scalar tensors.
        (0, $9c0Qr.dispose)(scalarsToDispose);
    }
}
function $592ccd54c4af57fd$export$f4920d82017cd044(logs) {
    if (logs == null) return;
    for(const key in logs){
        const value = logs[key];
        if (typeof value !== 'number') value.dispose();
    }
}

});


parcelRegister("8foXR", function(module, exports) {

$parcel$export(module.exports, "LayersModel", () => $601316dbd6a97610$export$f8e130845653852b);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original Source: engine/training.py */ parcelRequire("5n9DG");
var $1ZrG5 = parcelRequire("1ZrG5");
var $6LWfo = parcelRequire("6LWfo");
var $9c0Qr = parcelRequire("9c0Qr");
var $gjFWY = parcelRequire("gjFWY");
var $1RJvL = parcelRequire("1RJvL");
var $gr40e = parcelRequire("gr40e");
var $r7fN6 = parcelRequire("r7fN6");
var $4tSgq = parcelRequire("4tSgq");
var $j7yUF = parcelRequire("j7yUF");
var $8AyuI = parcelRequire("8AyuI");
var $bVnU9 = parcelRequire("bVnU9");
var $jIDgY = parcelRequire("jIDgY");
var $wx9lK = parcelRequire("wx9lK");

var $luRak = parcelRequire("luRak");

var $hQ5cH = parcelRequire("hQ5cH");

var $jVuYK = parcelRequire("jVuYK");

var $dttI1 = parcelRequire("dttI1");

var $LJ7JU = parcelRequire("LJ7JU");

var $3ETNO = parcelRequire("3ETNO");

var $bIveH = parcelRequire("bIveH");

var $cKsXd = parcelRequire("cKsXd");

var $khD6O = parcelRequire("khD6O");

var $ahGe0 = parcelRequire("ahGe0");

var $jBJAM = parcelRequire("jBJAM");

var $4UVDw = parcelRequire("4UVDw");

var $3lFvz = parcelRequire("3lFvz");

var $doV3w = parcelRequire("doV3w");

var $ButqI = parcelRequire("ButqI");

var $imQP2 = parcelRequire("imQP2");

var $ks7Jh = parcelRequire("ks7Jh");

var $lKolL = parcelRequire("lKolL");
function $601316dbd6a97610$export$73ccac4188109750(x) {
    return x instanceof (0, $bVnU9.Tensor);
}
function $601316dbd6a97610$export$d011a650f00557e2(x) {
    return Array.isArray(x);
}
function $601316dbd6a97610$export$6af9d9020dbc362d(x) {
    return !$601316dbd6a97610$export$73ccac4188109750(x) && !$601316dbd6a97610$export$d011a650f00557e2(x);
}
function $601316dbd6a97610$export$69dd7486f5c87261(data, names, shapes, checkBatchAxis = true, exceptionPrefix = '') {
    if (names == null || names.length === 0) {
        // Check for the case where the model expected no data, but some data got
        // sent.
        if (data != null) {
            let gotUnexpectedData = false;
            if ($601316dbd6a97610$export$d011a650f00557e2(data) && data.length > 0) gotUnexpectedData = true;
            else if ($601316dbd6a97610$export$6af9d9020dbc362d(data)) {
                for(const key in data)if (data.hasOwnProperty(key)) {
                    gotUnexpectedData = true;
                    break;
                }
            } else // `data` is a singleton Tensor in this case.
            gotUnexpectedData = true;
            if (gotUnexpectedData) throw new (0, $jVuYK.ValueError)(`Error when checking model ${exceptionPrefix} expected no data, ` + `but got ${data}`);
        }
        return [];
    }
    if (data == null) return names.map((name)=>null);
    let arrays;
    if ($601316dbd6a97610$export$6af9d9020dbc362d(data)) {
        data;
        arrays = [];
        for (const name of names){
            if (data[name] == null) throw new (0, $jVuYK.ValueError)(`No data provided for "${name}". Need data for each key in: ` + `${names}`);
            arrays.push(data[name]);
        }
    } else if ($601316dbd6a97610$export$d011a650f00557e2(data)) {
        data;
        if (data.length !== names.length) throw new (0, $jVuYK.ValueError)(`Error when checking model ${exceptionPrefix}: the Array of ` + `Tensors that you are passing to your model is not the size the ` + `model expected. Expected to see ${names.length} Tensor(s), but ` + `instead got the following list of Tensor(s): ${data}`);
        arrays = data;
    } else {
        data;
        if (names.length > 1) throw new (0, $jVuYK.ValueError)(`The model ${exceptionPrefix} expects ${names.length} Tensor(s), ` + `but only received one Tensor. Found: Tensor with shape ${data.shape}`);
        arrays = [
            data
        ];
    }
    arrays = (0, $ks7Jh.ensureTensorsRank2OrHigher)(arrays);
    // Check shape compatibility.
    if (shapes != null) for(let i = 0; i < names.length; ++i){
        if (shapes[i] == null) continue;
        const array = arrays[i];
        if (array.shape.length !== shapes[i].length) throw new (0, $jVuYK.ValueError)(`Error when checking ${exceptionPrefix}: expected ${names[i]} ` + `to have ${shapes[i].length} dimension(s). but got array with ` + `shape ${array.shape}`);
        for(let j = 0; j < shapes[i].length; ++j){
            if (j === 0 && !checkBatchAxis) continue;
            const dim = array.shape[j];
            const refDim = shapes[i][j];
            if (refDim != null && refDim >= 0 && dim !== refDim) throw new (0, $jVuYK.ValueError)(`${exceptionPrefix} expected a batch of elements where each ` + `example has shape [${shapes[i].slice(1, shapes[i].length)}] ` + `(i.e.,tensor shape [*,${shapes[i].slice(1, shapes[i].length)}])` + ` but the ${exceptionPrefix} received an input with ${array.shape[0]}` + ` examples, each with shape [${array.shape.slice(1, array.shape.length)}]` + ` (tensor shape [${array.shape}])`);
        }
    }
    return arrays;
}
function $601316dbd6a97610$export$4b125fd48a812392(inputs, targets, weights) {
    const setX = (0, $khD6O.unique)(inputs.map((input)=>input.shape[0]));
    setX.sort();
    const setY = (0, $khD6O.unique)(targets.map((target)=>target.shape[0]));
    setY.sort();
    // TODO(cais): Check `weights` as well.
    if (setX.length > 1) throw new (0, $jVuYK.ValueError)(`All input Tensors (x) should have the same number of samples. ` + `Got array shapes: ` + `${JSON.stringify(inputs.map((input)=>input.shape))}`);
    if (setY.length > 1) throw new (0, $jVuYK.ValueError)(`All target Tensors (y) should have the same number of samples. ` + `Got array shapes: ` + `${JSON.stringify(targets.map((target)=>target.shape))}`);
    if (setX.length > 0 && setY.length > 0 && !(0, $wx9lK).arraysEqual(setX, setY)) throw new (0, $jVuYK.ValueError)(`Input Tensors should have the same number of samples as target ` + `Tensors. Found ${setX[0]} input sample(s) and ${setY[0]} target ` + `sample(s).`);
}
/**
 * Validation on the compatibility of targes and loss functions.
 *
 * This helps prevent users from using loss functions incorrectly.
 *
 * @param targets `Array` of `tf.Tensor`s of targets.
 * @param lossFns `Array` of loss functions.
 * @param outputShapes `Array` of shapes of model outputs.
 */ function $601316dbd6a97610$var$checkLossAndTargetCompatibility(targets, lossFns, outputShapes) {
    // TODO(cais): Dedicated test coverage?
    const keyLosses = [
        $LJ7JU.meanSquaredError,
        $LJ7JU.binaryCrossentropy,
        $LJ7JU.categoricalCrossentropy
    ];
    for(let i = 0; i < targets.length; ++i){
        const y = targets[i];
        const loss = lossFns[i];
        const shape = outputShapes[i];
        if (loss == null) continue;
        if (loss === $LJ7JU.categoricalCrossentropy) {
            if (y.shape[y.shape.length - 1] === 1) throw new (0, $jVuYK.ValueError)(`You are passing a target array of shape ${y.shape} while using ` + `a loss 'categorical_crossentropy'. 'categorical_crossentropy'` + `expects targets to be binary matrices (1s and 0s) of shape ` + `[samples, classes].`);
        }
        if (keyLosses.indexOf(loss) !== -1) {
            const slicedYShape = y.shape.slice(1);
            const slicedShape = shape.slice(1);
            for(let j = 0; j < slicedYShape.length; ++j){
                const targetDim = slicedYShape[j];
                const outDim = slicedShape[j];
                if (outDim != null && targetDim !== outDim) throw new (0, $jVuYK.ValueError)(`A target Tensor with shape ${y.shape} was passed for an ` + `output of shape ${shape}, while using a loss function that ` + `expects targets to have the same shape as the output.`);
            }
        }
    }
}
/**
 * Check inputs provided by the user.
 *
 * Porting Note: This corresponds to _standardize_input_data() in Python
 *   Keras. Because of the strong typing in TF.js, we do not need to convert
 *   the data. Specifically:
 *   1) in PyKeras, `data` can be `DataFrame` instances from pandas, for
 *      example. We don't need to worry about that here because there is no
 *      widely popular javascript/typesdcript equivalent of pandas (so far).
 *      If one becomes available in the future, we can add support.
 *   2) in PyKeras, inputs can be Python dict. But here we are stipulating
 * that the data is either a single `tf.Tensor` or an Array of `tf.Tensor`s. We
 * may add support for `Object` data inputs in the future when the need
 * arises.
 *
 * Instead, we perform basic checks for number of parameters and shapes.
 *
 * @param data: The input data.
 * @param names: Name for the inputs, from the model.
 * @param shapes: Expected shapes for the input data, from the model.
 * @param checkBatchAxis: Whether the size along the batch axis (i.e., the
 *   first dimension) will be checked for matching.
 * @param exceptionPrefix: Execption prefix message, used in generating error
 *   messages.
 * @throws ValueError: on incorrect number of inputs or mismatches in shapes.
 */ function $601316dbd6a97610$var$checkInputData(data, names, shapes, checkBatchAxis = true, exceptionPrefix = '') {
    let arrays;
    if (Array.isArray(data)) {
        if (data.length !== names.length) throw new (0, $jVuYK.ValueError)(`Error when checking model ${exceptionPrefix}: the Array of ` + `Tensors that you are passing to your model is not the size the ` + `the model expected. Expected to see ${names.length} Tensor(s),` + ` but instead got ${data.length} Tensors(s).`);
        arrays = data;
    } else {
        if (names.length > 1) throw new (0, $jVuYK.ValueError)(`The model expects ${names.length} ${exceptionPrefix} Tensors, ` + `but only received one Tensor. Found: array with shape ` + `${JSON.stringify(data.shape)}.`);
        arrays = [
            data
        ];
    }
    if (shapes != null) for(let i = 0; i < names.length; ++i){
        if (shapes[i] == null) continue;
        const array = arrays[i];
        if (array.shape.length !== shapes[i].length) throw new (0, $jVuYK.ValueError)(`Error when checking ${exceptionPrefix}: expected ${names[i]} ` + `to have ${shapes[i].length} dimension(s), but got array with ` + `shape ${JSON.stringify(array.shape)}`);
        for(let j = 0; j < shapes[i].length; ++j){
            if (j === 0 && !checkBatchAxis) continue;
            const dim = array.shape[j];
            const refDim = shapes[i][j];
            if (refDim != null) {
                if (refDim !== dim) throw new (0, $jVuYK.ValueError)(`Error when checking ${exceptionPrefix}: expected ` + `${names[i]} to have shape ${JSON.stringify(shapes[i])} but ` + `got array with shape ${JSON.stringify(array.shape)}.`);
            }
        }
    }
}
function $601316dbd6a97610$export$f17c6a7c45a213ae(metrics, outputNames) {
    if (metrics == null || Array.isArray(metrics) && metrics.length === 0) return outputNames.map((name)=>[]);
    let wrappedMetrics;
    if (typeof metrics === 'string' || typeof metrics === 'function') wrappedMetrics = [
        metrics
    ];
    else if (Array.isArray(metrics) || typeof metrics === 'object') wrappedMetrics = metrics;
    else throw new TypeError('Type of metrics argument not understood. Expected an string,' + `function, Array, or Object, found: ${metrics}`);
    if (Array.isArray(wrappedMetrics)) // We then apply all metrics to all outputs.
    return outputNames.map((name)=>wrappedMetrics);
    else {
        // In this case, metrics is a dict.
        const nestedMetrics = [];
        for (const name of outputNames){
            let outputMetrics = wrappedMetrics.hasOwnProperty(name) ? wrappedMetrics[name] : [];
            if (!Array.isArray(outputMetrics)) outputMetrics = [
                outputMetrics
            ];
            nestedMetrics.push(outputMetrics);
        }
        return nestedMetrics;
    }
}
const $601316dbd6a97610$var$LAYERS_MODEL_FORMAT_NAME = 'layers-model';
class $601316dbd6a97610$export$f8e130845653852b extends (0, $doV3w.Container) {
    constructor(args){
        super(args);
        this.isTraining = false;
    }
    /**
     * Print a text summary of the model's layers.
     *
     * The summary includes
     * - Name and type of all layers that comprise the model.
     * - Output shape(s) of the layers
     * - Number of weight parameters of each layer
     * - If the model has non-sequential-like topology, the inputs each layer
     *   receives
     * - The total number of trainable and non-trainable parameters of the model.
     *
     * ```js
     * const input1 = tf.input({shape: [10]});
     * const input2 = tf.input({shape: [20]});
     * const dense1 = tf.layers.dense({units: 4}).apply(input1);
     * const dense2 = tf.layers.dense({units: 8}).apply(input2);
     * const concat = tf.layers.concatenate().apply([dense1, dense2]);
     * const output =
     *     tf.layers.dense({units: 3, activation: 'softmax'}).apply(concat);
     *
     * const model = tf.model({inputs: [input1, input2], outputs: output});
     * model.summary();
     * ```
     *
     * @param lineLength Custom line length, in number of characters.
     * @param positions Custom widths of each of the columns, as either
     *   fractions of `lineLength` (e.g., `[0.5, 0.75, 1]`) or absolute number
     *   of characters (e.g., `[30, 50, 65]`). Each number corresponds to
     *   right-most (i.e., ending) position of a column.
     * @param printFn Custom print function. Can be used to replace the default
     *   `console.log`. For example, you can use `x => {}` to mute the printed
     *   messages in the console.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ summary(lineLength, positions, printFn = console.log) {
        if (!this.built) throw new (0, $jVuYK.ValueError)(`This model has never been called, thus its weights have not been ` + `created yet. So no summary can be displayed. Build the model ` + `first (e.g., by calling it on some test data).`);
        (0, $ahGe0.printSummary)(this, lineLength, positions, printFn);
    }
    /**
     * Configures and prepares the model for training and evaluation.  Compiling
     * outfits the model with an optimizer, loss, and/or metrics.  Calling `fit`
     * or `evaluate` on an un-compiled model will throw an error.
     *
     * @param args a `ModelCompileArgs` specifying the loss, optimizer, and
     * metrics to be used for fitting and evaluating this model.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ compile(args) {
        if (args.loss == null) args.loss = [];
        this.loss = args.loss;
        if (typeof args.optimizer === 'string') {
            this.optimizer_ = $bIveH.getOptimizer(args.optimizer);
            this.isOptimizerOwned = true;
        } else {
            if (!(args.optimizer instanceof (0, $4tSgq.Optimizer))) throw new (0, $jVuYK.ValueError)(`User-defined optimizer must be an instance of tf.Optimizer.`);
            this.optimizer_ = args.optimizer;
            this.isOptimizerOwned = false;
        }
        // TODO(cais): Add lossWeights.
        // TODO(cais): Add sampleWeightMode.
        // Prepare loss functions.
        let lossFunctions = [];
        if (!Array.isArray(args.loss) && typeof args.loss !== 'string' && typeof args.loss !== 'function') {
            args.loss = args.loss;
            for(const name in args.loss){
                if (this.outputNames.indexOf(name) === -1) throw new (0, $jVuYK.ValueError)(`Unknown entry in loss dictionary: "${name}". ` + `Only expected the following keys: ${this.outputNames}`);
            }
            for (const name of this.outputNames){
                if (args.loss[name] == null) console.warn(`Output "${name}" is missing from loss dictionary. We assume ` + `this was done on purpose, and we will not be expecting data ` + `to be passed to ${name} during training`);
                lossFunctions.push($LJ7JU.get(args.loss[name]));
            }
        } else if (Array.isArray(args.loss)) {
            if (args.loss.length !== this.outputs.length) throw new (0, $jVuYK.ValueError)(`When passing an Array as loss, it should have one entry per ` + `model output. The model has ${this.outputs.length} output(s), ` + `but you passed loss=${args.loss}.`);
            const theLosses = args.loss;
            lossFunctions = theLosses.map((l)=>$LJ7JU.get(l));
        } else {
            const lossFunction = $LJ7JU.get(args.loss);
            this.outputs.forEach((_)=>{
                lossFunctions.push(lossFunction);
            });
        }
        this.lossFunctions = lossFunctions;
        this.feedOutputNames = [];
        this.feedOutputShapes = [];
        this.feedLossFns = [];
        for(let i = 0; i < this.outputs.length; ++i){
            // TODO(cais): Logic for skipping target(s).
            const shape = this.internalOutputShapes[i];
            const name = this.outputNames[i];
            this.feedOutputNames.push(name);
            this.feedOutputShapes.push(shape);
            this.feedLossFns.push(this.lossFunctions[i]);
        }
        // TODO(cais): Add logic for output masks.
        // TODO(cais): Add logic for sample weights.
        const skipTargetIndices = [];
        // Prepare metrics.
        this.metrics = args.metrics;
        // TODO(cais): Add weightedMetrics.
        this.metricsNames = [
            'loss'
        ];
        this.metricsTensors = [];
        // Compute total loss.
        // Porting Note: In PyKeras, metrics_tensors are symbolic tensor objects.
        //   Here, metricsTensors are TypeScript functions. This difference is due
        //   to the difference in symbolic/imperative property of the backends.
        (0, $hQ5cH.nameScope)('loss', ()=>{
            for(let i = 0; i < this.outputs.length; ++i){
                if (skipTargetIndices.indexOf(i) !== -1) continue;
                // TODO(cais): Add weightedLoss, sampleWeight and mask.
                //   The following line should be weightedLoss
                const weightedLoss = this.lossFunctions[i];
                if (this.outputs.length > 1) {
                    this.metricsTensors.push([
                        weightedLoss,
                        i
                    ]);
                    this.metricsNames.push(this.outputNames[i] + '_loss');
                }
            }
        // Porting Note: Due to the imperative nature of the backend, we calculate
        //   the regularizer penalties in the totalLossFunction, instead of here.
        });
        const nestedMetrics = $601316dbd6a97610$export$f17c6a7c45a213ae(args.metrics, this.outputNames);
        // TODO(cais): Add nestedWeightedMetrics.
        /**
         * Helper function used in loop below.
         */ const appendMetric = (outputIndex, metricName, metricTensor)=>{
            if (this.outputNames.length > 1) metricName = this.outputNames[outputIndex] + '_' + metricName;
            this.metricsNames.push(metricName);
            this.metricsTensors.push([
                metricTensor,
                outputIndex
            ]);
        };
        (0, $hQ5cH.nameScope)('metric', ()=>{
            for(let i = 0; i < this.outputs.length; ++i){
                if (skipTargetIndices.indexOf(i) !== -1) continue;
                const outputMetrics = nestedMetrics[i];
                // TODO(cais): Add weights and outputWeightedMetrics.
                // TODO(cais): Add optional arg `weights` to the following function.
                const handleMetrics = (metrics)=>{
                    const metricNamePrefix = '';
                    let metricName;
                    let accFn;
                    let weightedMetricFn;
                    //  TODO(cais): Use 'weights_' for weighted metrics.
                    for (const metric of metrics){
                        if (typeof metric === 'string' && [
                            'accuracy',
                            'acc',
                            'crossentropy',
                            'ce'
                        ].indexOf(metric) !== -1) {
                            const outputShape = this.internalOutputShapes[i];
                            if (outputShape[outputShape.length - 1] === 1 || this.lossFunctions[i] === $LJ7JU.binaryCrossentropy) {
                                // case: binary accuracy/crossentropy.
                                if ([
                                    'accuracy',
                                    'acc'
                                ].indexOf(metric) !== -1) accFn = $3ETNO.binaryAccuracy;
                                else if ([
                                    'crossentropy',
                                    'ce'
                                ].indexOf(metric) !== -1) accFn = $3ETNO.binaryCrossentropy;
                            } else if (this.lossFunctions[i] === $LJ7JU.sparseCategoricalCrossentropy) {
                                // case: categorical accuracy / crossentropy with sparse
                                // targets.
                                if ([
                                    'accuracy',
                                    'acc'
                                ].indexOf(metric) !== -1) accFn = $3ETNO.sparseCategoricalAccuracy;
                                else if ([
                                    'crossentropy',
                                    'ce'
                                ].indexOf(metric) !== -1) accFn = $3ETNO.sparseCategoricalCrossentropy;
                            } else {
                                // case: categorical accuracy / crossentropy.
                                if ([
                                    'accuracy',
                                    'acc'
                                ].indexOf(metric) !== -1) accFn = $3ETNO.categoricalAccuracy;
                                else if ([
                                    'crossentropy',
                                    'ce'
                                ].indexOf(metric) !== -1) accFn = $3ETNO.categoricalCrossentropy;
                            }
                            let suffix;
                            if ([
                                'accuracy',
                                'acc'
                            ].indexOf(metric) !== -1) suffix = 'acc';
                            else if ([
                                'crossentropy',
                                'ce'
                            ].indexOf(metric) !== -1) suffix = 'ce';
                            // TODO(cais): Add weighting actually.
                            weightedMetricFn = accFn;
                            metricName = metricNamePrefix + suffix;
                        } else {
                            const metricFn = $3ETNO.get(metric);
                            // TODO(cais): Add weighting actually.
                            weightedMetricFn = metricFn;
                            metricName = metricNamePrefix + $3ETNO.getLossOrMetricName(metric);
                        }
                        // TODO(cais): Add weighting and masking to metricResult.
                        let metricResult;
                        (0, $hQ5cH.nameScope)(metricName, ()=>{
                            metricResult = weightedMetricFn;
                        });
                        appendMetric(i, metricName, metricResult);
                    }
                };
                handleMetrics(outputMetrics);
            // TODO(cais): Call handleMetrics with weights.
            }
        });
        // Porting Notes: Given the imperative backend of tfjs-core,
        //   there is no need for constructing the symbolic graph and placeholders.
        this.collectedTrainableWeights = this.trainableWeights;
    }
    /**
     * Check trainable weights count consistency.
     *
     * This will raise a warning if `this.trainableWeights` and
     * `this.collectedTrainableWeights` are inconsistent (i.e., have different
     * numbers of parameters).
     * Inconsistency will typically arise when one modifies `model.trainable`
     * without calling `model.compile()` again.
     */ checkTrainableWeightsConsistency() {
        if (this.collectedTrainableWeights == null) return;
        if (this.trainableWeights.length !== this.collectedTrainableWeights.length) console.warn("Discrepancy between trainableweights and collected trainable weights. Did you set `model.trainable` without calling `model.compile()` afterwards?");
    }
    /**
     * Returns the loss value & metrics values for the model in test mode.
     *
     * Loss and metrics are specified during `compile()`, which needs to happen
     * before calls to `evaluate()`.
     *
     * Computation is done in batches.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * const result = model.evaluate(
     *     tf.ones([8, 10]), tf.ones([8, 1]), {batchSize: 4});
     * result.print();
     * ```
     *
     * @param x `tf.Tensor` of test data, or an `Array` of `tf.Tensor`s if the
     * model has multiple inputs.
     * @param y `tf.Tensor` of target data, or an `Array` of `tf.Tensor`s if the
     * model has multiple outputs.
     * @param args A `ModelEvaluateArgs`, containing optional fields.
     *
     * @return `Scalar` test loss (if the model has a single output and no
     *   metrics) or `Array` of `Scalar`s (if the model has multiple outputs
     *   and/or metrics). The attribute `model.metricsNames`
     *   will give you the display labels for the scalar outputs.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ evaluate(x, y, args = {}) {
        const batchSize = args.batchSize == null ? 32 : args.batchSize;
        (0, $ks7Jh.checkBatchSize)(batchSize);
        // TODO(cais): Standardize `config.sampleWeights` as well.
        // Validate user data.
        const checkBatchAxis = true;
        const standardizedOuts = this.standardizeUserDataXY(x, y, checkBatchAxis, batchSize);
        try {
            // TODO(cais): If uses `useLearningPhase`, set the corresponding element
            // of the input to 0.
            const ins = standardizedOuts[0].concat(standardizedOuts[1]);
            this.makeTestFunction();
            const f = this.testFunction;
            const testOuts = this.testLoop(f, ins, batchSize, args.verbose, args.steps);
            return (0, $khD6O.singletonOrArray)(testOuts);
        } finally{
            (0, $ks7Jh.disposeNewTensors)(standardizedOuts[0], x);
            (0, $ks7Jh.disposeNewTensors)(standardizedOuts[1], y);
        }
    }
    // TODO(cais): Add code snippet below once real dataset objects are
    //   available.
    /**
     * Evaluate model using a dataset object.
     *
     * Note: Unlike `evaluate()`, this method is asynchronous (`async`).
     *
     * @param dataset A dataset object. Its `iterator()` method is expected
     *   to generate a dataset iterator object, the `next()` method of which
     *   is expected to produce data batches for evaluation. The return value
     *   of the `next()` call ought to contain a boolean `done` field and a
     *   `value` field. The `value` field is expected to be an array of two
     *   `tf.Tensor`s or an array of two nested `tf.Tensor` structures. The former
     *   case is for models with exactly one input and one output (e.g.
     *   a sequential model). The latter case is for models with multiple
     *   inputs and/or multiple outputs. Of the two items in the array, the
     *   first is the input feature(s) and the second is the output target(s).
     * @param args A configuration object for the dataset-based evaluation.
     * @returns Loss and metric values as an Array of `Scalar` objects.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async evaluateDataset(dataset, args) {
        this.makeTestFunction();
        return (0, $imQP2.evaluateDataset)(this, dataset, args);
    }
    /**
     * Get number of samples provided for training, evaluation or prediction.
     *
     * @param ins Input `tf.Tensor`.
     * @param batchSize Integer batch size, optional.
     * @param steps Total number of steps (batches of samples) before
     * declaring loop finished. Optional.
     * @param stepsName The public API's parameter name for `steps`.
     * @returns Number of samples provided.
     */ checkNumSamples(ins, batchSize, steps, stepsName = 'steps') {
        let numSamples;
        if (steps != null) {
            numSamples = null;
            if (batchSize != null) throw new (0, $jVuYK.ValueError)(`If ${stepsName} is set, batchSize must be null or undefined.` + `Got batchSize = ${batchSize}`);
        } else if (ins != null) {
            if (Array.isArray(ins)) numSamples = ins[0].shape[0];
            else numSamples = ins.shape[0];
        } else throw new (0, $jVuYK.ValueError)(`Either the input data should have a defined shape, or ` + `${stepsName} shoud be specified.`);
        return numSamples;
    }
    /**
     * Execute internal tensors of the model with input data feed.
     * @param inputs Input data feed. Must match the inputs of the model.
     * @param outputs Names of the output tensors to be fetched. Must match
     *   names of the SymbolicTensors that belong to the graph.
     * @returns Fetched values for `outputs`.
     */ execute(inputs, outputs) {
        if (Array.isArray(outputs) && outputs.length === 0) throw new (0, $jVuYK.ValueError)('`outputs` is an empty Array, which is not allowed.');
        const outputsIsArray = Array.isArray(outputs);
        const outputNames = outputsIsArray ? outputs : [
            outputs
        ];
        const outputSymbolicTensors = this.retrieveSymbolicTensors(outputNames);
        // Format the input into a FeedDict.
        const feedDict = new (0, $ButqI.FeedDict)();
        if (inputs instanceof (0, $bVnU9.Tensor)) inputs = [
            inputs
        ];
        if (Array.isArray(inputs)) {
            if (inputs.length !== this.inputs.length) throw new (0, $jVuYK.ValueError)(`The number of inputs provided (${inputs.length}) ` + `does not match the number of inputs of this model ` + `(${this.inputs.length}).`);
            for(let i = 0; i < this.inputs.length; ++i)feedDict.add(this.inputs[i], inputs[i]);
        } else for (const input of this.inputs){
            const tensorValue = inputs[input.name];
            if (tensorValue == null) throw new (0, $jVuYK.ValueError)(`No value is provided for the model's input ${input.name}`);
            feedDict.add(input, tensorValue);
        }
        // Run execution.
        const executeOutputs = (0, $ButqI.execute)(outputSymbolicTensors, feedDict);
        return outputsIsArray ? executeOutputs : executeOutputs[0];
    }
    /**
     * Retrieve the model's internal symbolic tensors from symbolic-tensor names.
     */ retrieveSymbolicTensors(symbolicTensorNames) {
        const outputSymbolicTensors = (0, $khD6O.pyListRepeat)(null, symbolicTensorNames.length);
        let outputsRemaining = symbolicTensorNames.length;
        for (const layer of this.layers){
            const layerOutputs = Array.isArray(layer.output) ? layer.output : [
                layer.output
            ];
            const layerOutputNames = layerOutputs.map((output)=>output.name);
            for(let i = 0; i < symbolicTensorNames.length; ++i){
                const index = layerOutputNames.indexOf(symbolicTensorNames[i]);
                if (index !== -1) {
                    outputSymbolicTensors[i] = layerOutputs[index];
                    outputsRemaining--;
                }
                if (outputsRemaining === 0) break;
            }
            if (outputsRemaining === 0) break;
        }
        if (outputsRemaining > 0) {
            const remainingNames = [];
            outputSymbolicTensors.forEach((tensor, i)=>{
                if (tensor == null) remainingNames.push(symbolicTensorNames[i]);
            });
            throw new (0, $jVuYK.ValueError)(`Cannot find SymbolicTensors for output name(s): ` + `${JSON.stringify(remainingNames)}`);
        }
        return outputSymbolicTensors;
    }
    /**
     * Helper method to loop over some data in batches.
     *
     * Porting Note: Not using the functional approach in the Python equivalent
     *   due to the imperative backend.
     * Porting Note: Does not support step mode currently.
     *
     * @param ins: input data
     * @param batchSize: integer batch size.
     * @param verbose: verbosity model
     * @returns: Predictions as `tf.Tensor` (if a single output) or an `Array` of
     *   `tf.Tensor` (if multipe outputs).
     */ predictLoop(ins, batchSize = 32, verbose = false) {
        return $9c0Qr.tidy(()=>{
            const numSamples = this.checkNumSamples(ins);
            if (verbose) throw new (0, $jVuYK.NotImplementedError)('Verbose predictLoop() is not implemented yet.');
            // Sample-based predictions.
            // Porting Note: Tensor currently does not support sliced assignments as
            //   in numpy, e.g., x[1:3] = y. Therefore we use concatenation while
            //   iterating over the batches.
            const batches = (0, $ks7Jh.makeBatches)(numSamples, batchSize);
            const outsBatches = this.outputs.map((output)=>[]);
            // TODO(cais): Can the scope() be pushed down inside the for loop?
            for(let batchIndex = 0; batchIndex < batches.length; ++batchIndex){
                const batchOuts = $9c0Qr.tidy(()=>{
                    const batchStart = batches[batchIndex][0];
                    const batchEnd = batches[batchIndex][1];
                    // TODO(cais): Take care of the case of the last element is a flag for
                    //   training/test.
                    const insBatch = (0, $ks7Jh.sliceArrays)(ins, batchStart, batchEnd);
                    // Construct the feeds for execute();
                    const feeds = [];
                    if (Array.isArray(insBatch)) for(let i = 0; i < insBatch.length; ++i)feeds.push({
                        key: this.inputs[i],
                        value: insBatch[i]
                    });
                    else feeds.push({
                        key: this.inputs[0],
                        value: insBatch
                    });
                    const feedDict = new (0, $ButqI.FeedDict)(feeds);
                    return (0, $ButqI.execute)(this.outputs, feedDict);
                });
                batchOuts.forEach((batchOut, i)=>outsBatches[i].push(batchOut));
            }
            return (0, $khD6O.singletonOrArray)(outsBatches.map((batches)=>$6LWfo.concat(batches, 0)));
        });
    }
    /**
     * Generates output predictions for the input samples.
     *
     * Computation is done in batches.
     *
     * Note: the "step" mode of predict() is currently not supported.
     *   This is because the TensorFlow.js core backend is imperative only.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.predict(tf.ones([8, 10]), {batchSize: 4}).print();
     * ```
     *
     * @param x The input data, as a Tensor, or an `Array` of `tf.Tensor`s if
     *   the model has multiple inputs.
     * @param args A `ModelPredictArgs` object containing optional fields.
     *
     * @return Prediction results as a `tf.Tensor`(s).
     *
     * @exception ValueError In case of mismatch between the provided input data
     *   and the model's expectations, or in case a stateful model receives a
     *   number of samples that is not a multiple of the batch size.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predict(x, args = {}) {
        const xsRank2OrHigher = (0, $ks7Jh.ensureTensorsRank2OrHigher)(x);
        $601316dbd6a97610$var$checkInputData(xsRank2OrHigher, this.inputNames, this.feedInputShapes, false);
        try {
            // TODO(cais): Take care of stateful models.
            //   if (this.stateful) ...
            // TODO(cais): Take care of the learning_phase boolean flag.
            //   if (this.useLearningPhase) ...
            const batchSize = args.batchSize == null ? 32 : args.batchSize;
            (0, $ks7Jh.checkBatchSize)(batchSize);
            return this.predictLoop(xsRank2OrHigher, batchSize);
        } finally{
            (0, $ks7Jh.disposeNewTensors)(xsRank2OrHigher, x);
        }
    }
    /**
     * Returns predictions for a single batch of samples.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.predictOnBatch(tf.ones([8, 10])).print();
     * ```
     * @param x: Input samples, as a Tensor (for models with exactly one
     *   input) or an array of Tensors (for models with more than one input).
     * @return Tensor(s) of predictions
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predictOnBatch(x) {
        $601316dbd6a97610$var$checkInputData(x, this.inputNames, this.feedInputShapes, true);
        // TODO(cais): Take care of the learning_phase boolean flag.
        //   if (this.useLearningPhase) ...
        const batchSize = (Array.isArray(x) ? x[0] : x).shape[0];
        return this.predictLoop(x, batchSize);
    }
    standardizeUserDataXY(x, y, checkBatchAxis = true, batchSize) {
        // TODO(cais): Add sampleWeight, classWeight
        if (this.optimizer_ == null) throw new (0, $jVuYK.RuntimeError)("You must compile a model before training/testing. Use LayersModel.compile(modelCompileArgs).");
        const outputShapes = [];
        for(let i = 0; i < this.feedOutputShapes.length; ++i){
            const outputShape = this.feedOutputShapes[i];
            const lossFn = this.feedLossFns[i];
            if (lossFn === $LJ7JU.sparseCategoricalCrossentropy) outputShapes.push(outputShape.slice(0, outputShape.length - 1).concat([
                1
            ]));
            else // Porting Note: Because of strong typing `lossFn` must be a function.
            outputShapes.push(outputShape);
        }
        x = $601316dbd6a97610$export$69dd7486f5c87261(x, this.feedInputNames, this.feedInputShapes, false, 'input');
        y = $601316dbd6a97610$export$69dd7486f5c87261(y, this.feedOutputNames, outputShapes, false, 'target');
        // TODO(cais): Standardize sampleWeights & classWeights.
        $601316dbd6a97610$export$4b125fd48a812392(x, y, null);
        // TODO(cais): Check sampleWeights as well.
        $601316dbd6a97610$var$checkLossAndTargetCompatibility(y, this.feedLossFns, this.feedOutputShapes);
        if (this.stateful && batchSize != null && batchSize > 0) {
            if (x[0].shape[0] % batchSize !== 0) throw new (0, $jVuYK.ValueError)(`In a stateful network, you should only pass inputs with a ` + `number of samples that is divisible by the batch size ` + `${batchSize}. Found: ${x[0].shape[0]} sample(s).`);
        }
        return [
            x,
            y
        ];
    }
    async standardizeUserData(x, y, sampleWeight, classWeight, checkBatchAxis = true, batchSize) {
        const [standardXs, standardYs] = this.standardizeUserDataXY(x, y, checkBatchAxis, batchSize);
        // TODO(cais): Handle sampleWeights.
        if (sampleWeight != null) throw new Error('sample weight is not supported yet.');
        let standardSampleWeights = null;
        if (classWeight != null) {
            const classWeights = (0, $lKolL.standardizeClassWeights)(classWeight, this.outputNames);
            standardSampleWeights = [];
            for(let i = 0; i < classWeights.length; ++i)standardSampleWeights.push(await (0, $lKolL.standardizeWeights)(standardYs[i], null, classWeights[i]));
        }
        // TODO(cais): Deal with the case of model.stateful == true.
        return [
            standardXs,
            standardYs,
            standardSampleWeights
        ];
    }
    /**
     * Loop over some test data in batches.
     * @param f A Function returning a list of tensors.
     * @param ins Array of tensors to be fed to `f`.
     * @param batchSize Integer batch size or `null` / `undefined`.
     * @param verbose verbosity mode.
     * @param steps Total number of steps (batches of samples) before
     * declaring test finished. Ignored with the default value of `null` /
     * `undefined`.
     * @returns Array of Scalars.
     */ testLoop(f, ins, batchSize, verbose = 0, steps) {
        return $9c0Qr.tidy(()=>{
            const numSamples = this.checkNumSamples(ins, batchSize, steps, 'steps');
            const outs = [];
            if (verbose > 0) throw new (0, $jVuYK.NotImplementedError)('Verbose mode is not implemented yet.');
            // TODO(cais): Use `indicesForConversionToDense' to prevent slow down.
            if (steps != null) throw new (0, $jVuYK.NotImplementedError)('steps mode in testLoop() is not implemented yet');
            else {
                const batches = (0, $ks7Jh.makeBatches)(numSamples, batchSize);
                const indexArray = (0, $jIDgY.tensor1d)((0, $jBJAM.range)(0, numSamples));
                for(let batchIndex = 0; batchIndex < batches.length; ++batchIndex){
                    const batchStart = batches[batchIndex][0];
                    const batchEnd = batches[batchIndex][1];
                    const batchIds = $luRak.sliceAlongFirstAxis(indexArray, batchStart, batchEnd - batchStart);
                    // TODO(cais): In ins, train flag can be a number, instead of an
                    //   Tensor? Do we need to handle this in tfjs-layers?
                    const insBatch = (0, $ks7Jh.sliceArraysByIndices)(ins, batchIds);
                    const batchOuts = f(insBatch);
                    if (batchIndex === 0) for(let i = 0; i < batchOuts.length; ++i)outs.push((0, $j7yUF.scalar)(0));
                    for(let i = 0; i < batchOuts.length; ++i){
                        const batchOut = batchOuts[i];
                        outs[i] = $1ZrG5.add(outs[i], $r7fN6.mul(batchEnd - batchStart, batchOut));
                    }
                }
                for(let i = 0; i < outs.length; ++i)outs[i] = $gjFWY.div(outs[i], numSamples);
            }
            return outs;
        });
    }
    getDedupedMetricsNames() {
        const outLabels = this.metricsNames;
        // Rename duplicated metrics names (can happen with an output layer
        // shared among multiple dataflows).
        const dedupedOutLabels = [];
        for(let i = 0; i < outLabels.length; ++i){
            const label = outLabels[i];
            let newLabel = label;
            if ((0, $khD6O.count)(outLabels, label) > 1) {
                const dupIndex = (0, $khD6O.count)(outLabels.slice(0, i), label);
                newLabel += `_${dupIndex}`;
            }
            dedupedOutLabels.push(newLabel);
        }
        return dedupedOutLabels;
    }
    /**
     * Creates a function that performs the following actions:
     *
     * 1. computes the losses
     * 2. sums them to get the total loss
     * 3. call the optimizer computes the gradients of the LayersModel's
     *    trainable weights w.r.t. the total loss and update the variables
     * 4. calculates the metrics
     * 5. returns the values of the losses and metrics.
     */ makeTrainFunction() {
        return (data)=>{
            const lossValues = [];
            const inputs = data.slice(0, this.inputs.length);
            const targets = data.slice(this.inputs.length, this.inputs.length + this.outputs.length);
            const sampleWeights = data.slice(this.inputs.length + this.outputs.length, this.inputs.length + this.outputs.length * 2);
            const metricsValues = [];
            // Create a function that computes the total loss based on the
            // inputs. This function is used for obtaining gradients through
            // backprop.
            const totalLossFunction = ()=>{
                const feeds = [];
                for(let i = 0; i < this.inputs.length; ++i)feeds.push({
                    key: this.inputs[i],
                    value: inputs[i]
                });
                const feedDict = new (0, $ButqI.FeedDict)(feeds);
                const outputs = (0, $ButqI.execute)(this.outputs, feedDict, {
                    'training': true
                });
                // TODO(cais): Take care of the case of multiple outputs from a
                //   single layer?
                let totalLoss;
                for(let i = 0; i < this.lossFunctions.length; ++i){
                    const lossFunction = this.lossFunctions[i];
                    let loss = lossFunction(targets[i], outputs[i]);
                    if (sampleWeights[i] != null) loss = (0, $lKolL.computeWeightedLoss)(loss, sampleWeights[i]);
                    // TODO(cais): push Scalar instead.
                    const meanLoss = $gr40e.mean(loss);
                    // TODO(cais): Use a scope() instead, to avoid ownership.
                    lossValues.push(meanLoss);
                    if (i === 0) totalLoss = loss;
                    else totalLoss = $1ZrG5.add(totalLoss, loss);
                }
                // Compute the metrics.
                // TODO(cais): These should probably be calculated outside
                //   totalLossFunction to benefit speed?
                for(let i = 0; i < this.metricsTensors.length; ++i){
                    let weightedMetric;
                    if (this.outputs.length > 1 && i < this.outputs.length) weightedMetric = lossValues[i];
                    else {
                        const metric = this.metricsTensors[i][0];
                        const outputIndex = this.metricsTensors[i][1];
                        weightedMetric = $gr40e.mean(metric(targets[outputIndex], outputs[outputIndex]));
                    }
                    $9c0Qr.keep(weightedMetric);
                    // TODO(cais): Use a scope() instead, to avoid ownership.
                    metricsValues.push(weightedMetric);
                }
                totalLoss = $gr40e.mean(totalLoss);
                // Add regularizer penalties.
                this.calculateLosses().forEach((regularizerLoss)=>{
                    totalLoss = $1ZrG5.add(totalLoss, regularizerLoss);
                });
                return totalLoss;
            };
            const variables = this.collectedTrainableWeights.map((param)=>param.read());
            const returnCost = true;
            const totalLossValue = this.optimizer_.minimize(totalLossFunction, returnCost, variables);
            return [
                totalLossValue
            ].concat(metricsValues);
        };
    }
    /**
     * Create a function which, when invoked with an array of `tf.Tensor`s as a
     * batch of inputs, returns the prespecified loss and metrics of the model
     * under the batch of input data.
     */ makeTestFunction() {
        this.testFunction = (data)=>{
            return $9c0Qr.tidy(()=>{
                const valOutputs = [];
                let totalLoss;
                const inputs = data.slice(0, this.inputs.length);
                const targets = data.slice(this.inputs.length, this.inputs.length + this.outputs.length);
                const feeds = [];
                for(let i = 0; i < this.inputs.length; ++i)feeds.push({
                    key: this.inputs[i],
                    value: inputs[i]
                });
                const feedDict = new (0, $ButqI.FeedDict)(feeds);
                const outputs = (0, $ButqI.execute)(this.outputs, feedDict);
                // Compute total loss.
                for(let i = 0; i < this.lossFunctions.length; ++i){
                    const lossFunction = this.lossFunctions[i];
                    // TODO(cais): Add sample weighting and replace the simple
                    // averaging.
                    const loss = $gr40e.mean(lossFunction(targets[i], outputs[i]));
                    if (i === 0) totalLoss = loss;
                    else totalLoss = $1ZrG5.add(totalLoss, loss);
                    valOutputs.push(totalLoss);
                }
                // Compute the metrics.
                for(let i = 0; i < this.metricsTensors.length; ++i){
                    const metric = this.metricsTensors[i][0];
                    const outputIndex = this.metricsTensors[i][1];
                    // TODO(cais): Replace K.mean() with a proper weighting function.
                    const meanMetric = $gr40e.mean(metric(targets[outputIndex], outputs[outputIndex]));
                    valOutputs.push(meanMetric);
                }
                return valOutputs;
            });
        };
    }
    /**
     * Trains the model for a fixed number of epochs (iterations on a
     * dataset).
     *
     * ```js
     * const model = tf.sequential({
     *     layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * for (let i = 1; i < 5 ; ++i) {
     *   const h = await model.fit(tf.ones([8, 10]), tf.ones([8, 1]), {
     *       batchSize: 4,
     *       epochs: 3
     *   });
     *   console.log("Loss after Epoch " + i + " : " + h.history.loss[0]);
     * }
     * ```
     *
     * @param x `tf.Tensor` of training data, or an array of `tf.Tensor`s if the
     * model has multiple inputs. If all inputs in the model are named, you
     * can also pass a dictionary mapping input names to `tf.Tensor`s.
     * @param y `tf.Tensor` of target (label) data, or an array of `tf.Tensor`s if
     * the model has multiple outputs. If all outputs in the model are named,
     * you can also pass a dictionary mapping output names to `tf.Tensor`s.
     * @param args A `ModelFitArgs`, containing optional fields.
     *
     * @return A `History` instance. Its `history` attribute contains all
     *   information collected during training.
     *
     * @exception ValueError In case of mismatch between the provided input
     * data and what the model expects.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async fit(x, y, args = {}) {
        return (0, $ks7Jh.fitTensors)(this, x, y, args);
    }
    // TODO(cais): Add code snippet below when it's possible to instantiate
    //   actual dataset objects.
    /**
     * Trains the model using a dataset object.
     *
     * @param dataset A dataset object. Its `iterator()` method is expected
     *   to generate a dataset iterator object, the `next()` method of which
     *   is expected to produce data batches for training. The return value
     *   of the `next()` call ought to contain a boolean `done` field and a
     *   `value` field. The `value` field is expected to be an array of two
     *   `tf.Tensor`s or an array of two nested `tf.Tensor` structures. The former
     *   case is for models with exactly one input and one output (e.g.
     *   a sequential model). The latter case is for models with multiple
     *   inputs and/or multiple outputs.
     *   Of the two items in the array, the first is the input feature(s) and
     *   the second is the output target(s).
     * @param args A `ModelFitDatasetArgs`, containing optional fields.
     *
     * @return A `History` instance. Its `history` attribute contains all
     *   information collected during training.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async fitDataset(dataset, args) {
        return (0, $imQP2.fitDataset)(this, dataset, args);
    }
    /**
     * Runs a single gradient update on a single batch of data.
     *
     * This method differs from `fit()` and `fitDataset()` in the following
     * regards:
     *   - It operates on exactly one batch of data.
     *   - It returns only the loss and metric values, instead of
     *     returning the batch-by-batch loss and metric values.
     *   - It doesn't support fine-grained options such as verbosity and
     *     callbacks.
     *
     * @param x Input data. It could be one of the following:
     *   - A `tf.Tensor`, or an Array of `tf.Tensor`s (in case the model has
     *     multiple inputs).
     *   - An Object mapping input names to corresponding `tf.Tensor` (if the
     *     model has named inputs).
     * @param y Target data. It could be either a `tf.Tensor` or multiple
     *   `tf.Tensor`s. It should be consistent with `x`.
     * @returns Training loss or losses (in case the model has
     *   multiple outputs), along with metrics (if any), as numbers.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async trainOnBatch(x, y) {
        // TODO(cais): Support sampleWeight and classWeight.
        // TODO(cais): Support Dataset objects.
        const standardizeOut = await this.standardizeUserData(x, y);
        const inputs = standardizeOut[0];
        const targets = standardizeOut[1];
        const trainFunction = this.makeTrainFunction();
        const losses = trainFunction(inputs.concat(targets));
        const lossValues = [];
        for (const loss of losses){
            const v = await loss.data();
            lossValues.push(v[0]);
        }
        $9c0Qr.dispose(losses);
        (0, $ks7Jh.disposeNewTensors)(standardizeOut[0], x);
        (0, $ks7Jh.disposeNewTensors)(standardizeOut[1], y);
        return (0, $khD6O.singletonOrArray)(lossValues);
    }
    /**
     * Extract weight values of the model.
     *
     * @param config: An instance of `io.SaveConfig`, which specifies
     * model-saving options such as whether only trainable weights are to be
     * saved.
     * @returns A `NamedTensorMap` mapping original weight names (i.e.,
     *   non-uniqueified weight names) to their values.
     */ getNamedWeights(config) {
        const namedWeights = [];
        const trainableOnly = config != null && config.trainableOnly;
        const weights = trainableOnly ? this.trainableWeights : this.weights;
        const weightValues = this.getWeights(trainableOnly);
        for(let i = 0; i < weights.length; ++i){
            if (trainableOnly && !weights[i].trainable) continue;
            namedWeights.push({
                name: weights[i].originalName,
                tensor: weightValues[i]
            });
        }
        return namedWeights;
    }
    /**
     * Setter used for force stopping of LayersModel.fit() (i.e., training).
     *
     * Example:
     *
     * ```js
     * const input = tf.input({shape: [10]});
     * const output = tf.layers.dense({units: 1}).apply(input);
     * const model = tf.model({inputs: [input], outputs: [output]});
     * model.compile({loss: 'meanSquaredError', optimizer: 'sgd'});
     * const xs = tf.ones([8, 10]);
     * const ys = tf.zeros([8, 1]);
     *
     * const history = await model.fit(xs, ys, {
     *   epochs: 10,
     *   callbacks: {
     *     onEpochEnd: async (epoch, logs) => {
     *       if (epoch === 2) {
     *         model.stopTraining = true;
     *       }
     *     }
     *   }
     * });
     *
     * // There should be only 3 values in the loss array, instead of 10
     * values,
     * // due to the stopping after 3 epochs.
     * console.log(history.history.loss);
     * ```
     */ set stopTraining(stop) {
        this.stopTraining_ = stop;
    }
    get stopTraining() {
        return this.stopTraining_;
    }
    get optimizer() {
        return this.optimizer_;
    }
    set optimizer(optimizer) {
        if (this.optimizer_ !== optimizer) {
            this.optimizer_ = optimizer;
            this.isOptimizerOwned = false;
        }
    }
    dispose() {
        const result = super.dispose();
        if (result.refCountAfterDispose === 0 && this.optimizer != null && this.isOptimizerOwned) {
            const numTensorsBeforeOptmizerDisposal = $9c0Qr.memory().numTensors;
            this.optimizer_.dispose();
            result.numDisposedVariables += numTensorsBeforeOptmizerDisposal - $9c0Qr.memory().numTensors;
        }
        return result;
    }
    getLossIdentifiers() {
        let lossNames;
        if (typeof this.loss === 'string') lossNames = (0, $khD6O.toSnakeCase)(this.loss);
        else if (Array.isArray(this.loss)) {
            for (const loss of this.loss){
                if (typeof loss !== 'string') throw new Error('Serialization of non-string loss is not supported.');
            }
            lossNames = this.loss.map((name)=>(0, $khD6O.toSnakeCase)(name));
        } else {
            const outputNames = Object.keys(this.loss);
            lossNames = {};
            const losses = this.loss;
            for (const outputName of outputNames){
                if (typeof losses[outputName] === 'string') lossNames[outputName] = (0, $khD6O.toSnakeCase)(losses[outputName]);
                else throw new Error('Serialization of non-string loss is not supported.');
            }
        }
        return lossNames;
    }
    getMetricIdentifiers() {
        if (typeof this.metrics === 'string' || typeof this.metrics === 'function') return [
            (0, $khD6O.toSnakeCase)($3ETNO.getLossOrMetricName(this.metrics))
        ];
        else if (Array.isArray(this.metrics)) return this.metrics.map((metric)=>(0, $khD6O.toSnakeCase)($3ETNO.getLossOrMetricName(metric)));
        else {
            const metricsIdentifiers = {};
            for(const key in this.metrics)metricsIdentifiers[key] = (0, $khD6O.toSnakeCase)($3ETNO.getLossOrMetricName(this.metrics[key]));
            return metricsIdentifiers;
        }
    }
    getTrainingConfig() {
        return {
            loss: this.getLossIdentifiers(),
            metrics: this.getMetricIdentifiers(),
            optimizer_config: {
                class_name: this.optimizer.getClassName(),
                config: this.optimizer.getConfig()
            }
        };
    // TODO(cais): Add weight_metrics when they are supported.
    // TODO(cais): Add sample_weight_mode when it's supported.
    // TODO(cais): Add loss_weights when it's supported.
    }
    loadTrainingConfig(trainingConfig) {
        if (trainingConfig.weighted_metrics != null) throw new Error('Loading weight_metrics is not supported yet.');
        if (trainingConfig.loss_weights != null) throw new Error('Loading loss_weights is not supported yet.');
        if (trainingConfig.sample_weight_mode != null) throw new Error('Loading sample_weight_mode is not supported yet.');
        const tsConfig = (0, $4UVDw.convertPythonicToTs)(trainingConfig.optimizer_config);
        const optimizer = (0, $dttI1.deserialize)(tsConfig);
        let loss;
        if (typeof trainingConfig.loss === 'string') loss = (0, $khD6O.toCamelCase)(trainingConfig.loss);
        else if (Array.isArray(trainingConfig.loss)) loss = trainingConfig.loss.map((lossEntry)=>(0, $khD6O.toCamelCase)(lossEntry));
        else if (trainingConfig.loss != null) {
            loss = {};
            for(const key in trainingConfig.loss)loss[key] = (0, $khD6O.toCamelCase)(trainingConfig.loss[key]);
        }
        let metrics;
        if (Array.isArray(trainingConfig.metrics)) metrics = trainingConfig.metrics.map((metric)=>(0, $khD6O.toCamelCase)(metric));
        else if (trainingConfig.metrics != null) {
            metrics = {};
            for(const key in trainingConfig.metrics)metrics[key] = (0, $khD6O.toCamelCase)(trainingConfig.metrics[key]);
        }
        this.compile({
            loss: loss,
            metrics: metrics,
            optimizer: optimizer
        });
    }
    /**
     * Save the configuration and/or weights of the LayersModel.
     *
     * An `IOHandler` is an object that has a `save` method of the proper
     * signature defined. The `save` method manages the storing or
     * transmission of serialized data ("artifacts") that represent the
     * model's topology and weights onto or via a specific medium, such as
     * file downloads, local storage, IndexedDB in the web browser and HTTP
     * requests to a server. TensorFlow.js provides `IOHandler`
     * implementations for a number of frequently used saving mediums, such as
     * `tf.io.browserDownloads` and `tf.io.browserLocalStorage`. See `tf.io`
     * for more details.
     *
     * This method also allows you to refer to certain types of `IOHandler`s
     * as URL-like string shortcuts, such as 'localstorage://' and
     * 'indexeddb://'.
     *
     * Example 1: Save `model`'s topology and weights to browser [local
     * storage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage);
     * then load it back.
     *
     * ```js
     * const model = tf.sequential(
     *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
     * console.log('Prediction from original model:');
     * model.predict(tf.ones([1, 3])).print();
     *
     * const saveResults = await model.save('localstorage://my-model-1');
     *
     * const loadedModel = await tf.loadLayersModel('localstorage://my-model-1');
     * console.log('Prediction from loaded model:');
     * loadedModel.predict(tf.ones([1, 3])).print();
     * ```
     *
     * Example 2. Saving `model`'s topology and weights to browser
     * [IndexedDB](https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API);
     * then load it back.
     *
     * ```js
     * const model = tf.sequential(
     *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
     * console.log('Prediction from original model:');
     * model.predict(tf.ones([1, 3])).print();
     *
     * const saveResults = await model.save('indexeddb://my-model-1');
     *
     * const loadedModel = await tf.loadLayersModel('indexeddb://my-model-1');
     * console.log('Prediction from loaded model:');
     * loadedModel.predict(tf.ones([1, 3])).print();
     * ```
     *
     * Example 3. Saving `model`'s topology and weights as two files
     * (`my-model-1.json` and `my-model-1.weights.bin`) downloaded from
     * browser.
     *
     * ```js
     * const model = tf.sequential(
     *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
     * const saveResults = await model.save('downloads://my-model-1');
     * ```
     *
     * Example 4. Send  `model`'s topology and weights to an HTTP server.
     * See the documentation of `tf.io.http` for more details
     * including specifying request parameters and implementation of the
     * server.
     *
     * ```js
     * const model = tf.sequential(
     *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
     * const saveResults = await model.save('http://my-server/model/upload');
     * ```
     *
     * @param handlerOrURL An instance of `IOHandler` or a URL-like,
     * scheme-based string shortcut for `IOHandler`.
     * @param config Options for saving the model.
     * @returns A `Promise` of `SaveResult`, which summarizes the result of
     * the saving, such as byte sizes of the saved artifacts for the model's
     *   topology and weight values.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ async save(handlerOrURL, config) {
        if (typeof handlerOrURL === 'string') {
            const handlers = (0, $1RJvL).getSaveHandlers(handlerOrURL);
            if (handlers.length === 0) throw new (0, $jVuYK.ValueError)(`Cannot find any save handlers for URL '${handlerOrURL}'`);
            else if (handlers.length > 1) throw new (0, $jVuYK.ValueError)(`Found more than one (${handlers.length}) save handlers for ` + `URL '${handlerOrURL}'`);
            handlerOrURL = handlers[0];
        }
        if (handlerOrURL.save == null) throw new (0, $jVuYK.ValueError)("LayersModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
        const weightDataAndSpecs = await (0, $1RJvL).encodeWeights(this.getNamedWeights(config));
        const returnString = false;
        const unusedArg = null;
        const modelConfig = this.toJSON(unusedArg, returnString);
        const modelArtifacts = {
            modelTopology: modelConfig,
            format: $601316dbd6a97610$var$LAYERS_MODEL_FORMAT_NAME,
            generatedBy: `TensorFlow.js tfjs-layers v${(0, $3lFvz.version)}`,
            convertedBy: null
        };
        const includeOptimizer = config == null ? false : config.includeOptimizer;
        if (includeOptimizer && this.optimizer != null) {
            modelArtifacts.trainingConfig = this.getTrainingConfig();
            const weightType = 'optimizer';
            const { data: optimizerWeightData, specs: optimizerWeightSpecs } = await (0, $1RJvL).encodeWeights(await this.optimizer.getWeights(), weightType);
            weightDataAndSpecs.specs.push(...optimizerWeightSpecs);
            weightDataAndSpecs.data = (0, $1RJvL).concatenateArrayBuffers([
                weightDataAndSpecs.data,
                optimizerWeightData
            ]);
        }
        if (this.userDefinedMetadata != null) {
            // Check serialized size of user-defined metadata.
            const checkSize = true;
            (0, $cKsXd.checkUserDefinedMetadata)(this.userDefinedMetadata, this.name, checkSize);
            modelArtifacts.userDefinedMetadata = this.userDefinedMetadata;
        }
        modelArtifacts.weightData = weightDataAndSpecs.data;
        modelArtifacts.weightSpecs = weightDataAndSpecs.specs;
        return handlerOrURL.save(modelArtifacts);
    }
    /**
     * Set user-defined metadata.
     *
     * The set metadata will be serialized together with the topology
     * and weights of the model during `save()` calls.
     *
     * @param setUserDefinedMetadata
     */ setUserDefinedMetadata(userDefinedMetadata) {
        (0, $cKsXd.checkUserDefinedMetadata)(userDefinedMetadata, this.name);
        this.userDefinedMetadata = userDefinedMetadata;
    }
    /**
     * Get user-defined metadata.
     *
     * The metadata is supplied via one of the two routes:
     *   1. By calling `setUserDefinedMetadata()`.
     *   2. Loaded during model loading (if the model is constructed
     *      via `tf.loadLayersModel()`.)
     *
     * If no user-defined metadata is available from either of the
     * two routes, this function will return `undefined`.
     */ getUserDefinedMetadata() {
        return this.userDefinedMetadata;
    }
}
// The class name is 'Model' rather than 'LayersModel' for backwards
// compatibility since this class name shows up in the serialization format.
/** @nocollapse */ $601316dbd6a97610$export$f8e130845653852b.className = 'Model';
(0, $8AyuI).registerClass($601316dbd6a97610$export$f8e130845653852b);
class $601316dbd6a97610$export$ab287cb77f6ba7e extends $601316dbd6a97610$export$f8e130845653852b {
}
$601316dbd6a97610$export$ab287cb77f6ba7e.className = 'Functional';
(0, $8AyuI).registerClass($601316dbd6a97610$export$ab287cb77f6ba7e);

});
parcelRegister("dttI1", function(module, exports) {

$parcel$export(module.exports, "deserialize", () => $9cf50763b08cf4d9$export$efcd34ab6248d3cd);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original Source layers/__init__.py */ parcelRequire("5n9DG");
var $8AyuI = parcelRequire("8AyuI");

var $khD6O = parcelRequire("khD6O");
function $9cf50763b08cf4d9$export$efcd34ab6248d3cd(config, customObjects = {}, fastWeightInit = false) {
    return (0, $khD6O.deserializeKerasObject)(config, (0, $8AyuI).SerializationMap.getMap().classNameMap, customObjects, 'layer', fastWeightInit);
}

});

parcelRegister("LJ7JU", function(module, exports) {

$parcel$export(module.exports, "l2Normalize", () => $08f7648dacc2d698$export$56804db0f45bf789);
$parcel$export(module.exports, "meanSquaredError", () => $08f7648dacc2d698$export$33de16355e97f7fb);
$parcel$export(module.exports, "meanAbsoluteError", () => $08f7648dacc2d698$export$607988531ba584e6);
$parcel$export(module.exports, "meanAbsolutePercentageError", () => $08f7648dacc2d698$export$29f745e8786a84d);
$parcel$export(module.exports, "categoricalCrossentropy", () => $08f7648dacc2d698$export$3d5544849562b631);
$parcel$export(module.exports, "sparseCategoricalCrossentropy", () => $08f7648dacc2d698$export$d02551222e9364f0);
$parcel$export(module.exports, "binaryCrossentropy", () => $08f7648dacc2d698$export$f9fa66c6bf49fbe1);
$parcel$export(module.exports, "cosineProximity", () => $08f7648dacc2d698$export$a39f0fc1fa1caacd);
$parcel$export(module.exports, "lossesMap", () => $08f7648dacc2d698$export$80c8fb006fb174f5);
$parcel$export(module.exports, "get", () => $08f7648dacc2d698$export$3988ae62b71be9a3);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original Source: losses.py */ parcelRequire("5n9DG");
var $6oc11 = parcelRequire("6oc11");
var $1ZrG5 = parcelRequire("1ZrG5");
var $7qWZ5 = parcelRequire("7qWZ5");
var $jU3Ej = parcelRequire("jU3Ej");
var $gjFWY = parcelRequire("gjFWY");
var $4NGnB = parcelRequire("4NGnB");
var $3kNX7 = parcelRequire("3kNX7");
var $hnXfr = parcelRequire("hnXfr");
var $djEuh = parcelRequire("djEuh");
var $ibX5K = parcelRequire("ibX5K");
var $Fvpms = parcelRequire("Fvpms");
var $aW7Gb = parcelRequire("aW7Gb");
var $gr40e = parcelRequire("gr40e");
var $r7fN6 = parcelRequire("r7fN6");
var $ifge7 = parcelRequire("ifge7");
var $8feEH = parcelRequire("8feEH");
var $1mZlL = parcelRequire("1mZlL");
var $eP0pM = parcelRequire("eP0pM");
var $5q2Zg = parcelRequire("5q2Zg");
var $cvbcy = parcelRequire("cvbcy");
var $lGdn1 = parcelRequire("lGdn1");
var $hkR0n = parcelRequire("hkR0n");
var $fVwnn = parcelRequire("fVwnn");
var $9c0Qr = parcelRequire("9c0Qr");
var $wx9lK = parcelRequire("wx9lK");

var $c51ox = parcelRequire("c51ox");

var $luRak = parcelRequire("luRak");

var $jVuYK = parcelRequire("jVuYK");
function $08f7648dacc2d698$export$56804db0f45bf789(x, axis) {
    return (0, $9c0Qr.tidy)(()=>{
        if (x.dtype !== 'float32') x = $7qWZ5.cast(x, 'float32');
        const squareSum = $fVwnn.sum($luRak.square(x), axis, true);
        const epsilonTensor = $3kNX7.fill(squareSum.shape, (0, $c51ox.epsilon)());
        const norm = $lGdn1.sqrt($aW7Gb.maximum(squareSum, epsilonTensor));
        return $gjFWY.div(x, norm);
    });
}
function $08f7648dacc2d698$export$33de16355e97f7fb(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>$gr40e.mean($luRak.square($hkR0n.sub(yPred, yTrue)), -1));
}
function $08f7648dacc2d698$export$607988531ba584e6(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>$gr40e.mean($6oc11.abs($hkR0n.sub(yPred, yTrue)), -1));
}
function $08f7648dacc2d698$export$29f745e8786a84d(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        const diff = $hkR0n.sub(yTrue, yPred);
        const clippedTrue = $jU3Ej.clipByValue($6oc11.abs(yTrue), (0, $c51ox.epsilon)(), Number.MAX_VALUE);
        const absResult = $6oc11.abs($gjFWY.div(diff, clippedTrue));
        return $r7fN6.mul(100, $gr40e.mean(absResult, -1));
    });
}
function $08f7648dacc2d698$export$6f3c2909d4934f8e(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        const clippedPred = $jU3Ej.clipByValue(yPred, (0, $c51ox.epsilon)(), Number.MAX_VALUE);
        const firstLog = $djEuh.log($1ZrG5.add(1, clippedPred));
        const clippedTrue = $jU3Ej.clipByValue(yTrue, (0, $c51ox.epsilon)(), Number.MAX_VALUE);
        const secondLog = $djEuh.log($1ZrG5.add(1, clippedTrue));
        return $gr40e.mean($luRak.square($hkR0n.sub(firstLog, secondLog)), -1);
    });
}
function $08f7648dacc2d698$export$6e9184938bd4bdfd(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        const maxResult = $aW7Gb.maximum(0, $hkR0n.sub(1, $r7fN6.mul(yTrue, yPred)));
        return $gr40e.mean($luRak.square(maxResult), -1);
    });
}
function $08f7648dacc2d698$export$321a3d0bf2c75(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        const maxResult = $aW7Gb.maximum(0, $hkR0n.sub(1, $r7fN6.mul(yTrue, yPred)));
        return $gr40e.mean(maxResult, -1);
    });
}
function $08f7648dacc2d698$export$21844282d987078(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        const pos = $fVwnn.sum($r7fN6.mul(yTrue, yPred), -1);
        const neg = $Fvpms.max($r7fN6.mul($hkR0n.sub(1, yTrue), yPred), -1);
        return $aW7Gb.maximum(0, $1ZrG5.add(1, $hkR0n.sub(neg, pos)));
    });
}
function $08f7648dacc2d698$export$d3a5506af1f5d4c0(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        const log2 = Math.log(2);
        const predictionDiff = $hkR0n.sub(yPred, yTrue);
        const logcoshResult = $hkR0n.sub($1ZrG5.add(predictionDiff, $cvbcy.softplus($r7fN6.mul(-2, predictionDiff))), log2);
        return $gr40e.mean(logcoshResult, -1);
    });
}
function $08f7648dacc2d698$export$3d5544849562b631(target, output, fromLogits = false) {
    return (0, $9c0Qr.tidy)(()=>{
        if (fromLogits) output = $5q2Zg.softmax(output);
        else {
            // scale preds so that the class probabilities of each sample sum to 1.
            const outputSum = $fVwnn.sum(output, output.shape.length - 1, true);
            output = $gjFWY.div(output, outputSum);
        }
        output = $jU3Ej.clipByValue(output, (0, $c51ox.epsilon)(), 1 - (0, $c51ox.epsilon)());
        return $ifge7.neg($fVwnn.sum($r7fN6.mul($7qWZ5.cast(target, 'float32'), $djEuh.log(output)), output.shape.length - 1));
    });
}
function $08f7648dacc2d698$export$d02551222e9364f0(target, output, fromLogits = false) {
    return (0, $9c0Qr.tidy)(()=>{
        const flatTarget = $7qWZ5.cast($hnXfr.floor($luRak.flatten(target)), 'int32');
        output = $jU3Ej.clipByValue(output, (0, $c51ox.epsilon)(), 1 - (0, $c51ox.epsilon)());
        const outputShape = output.shape;
        const oneHotTarget = $eP0pM.reshape($8feEH.oneHot(flatTarget, outputShape[outputShape.length - 1]), outputShape);
        return $08f7648dacc2d698$export$3d5544849562b631(oneHotTarget, output, fromLogits);
    });
}
function $08f7648dacc2d698$export$ba12332959c7f31a(labels, logits) {
    if (!(0, $wx9lK).arraysEqual(labels.shape, logits.shape)) throw new (0, $jVuYK.ValueError)(`logits and labels must have the same shape, but got shapes ` + `${JSON.stringify(labels.shape)} and ${JSON.stringify(logits.shape)}`);
    return (0, $9c0Qr.tidy)(()=>{
        // The logistic loss formula from above is
        //   x - x * z + log(1 + exp(-x))
        // For x < 0, a more numerically stable formula is
        //   -x * z + log(1 + exp(x))
        // Note that these two expressions can be combined into the following:
        //   max(x, 0) - x * z + log(1 + exp(-abs(x)))
        const reluLogits = $1mZlL.relu(logits);
        const negAbsLogits = $ifge7.neg($6oc11.abs(logits));
        return $1ZrG5.add($hkR0n.sub(reluLogits, $r7fN6.mul(logits, labels)), $ibX5K.log1p($4NGnB.exp(negAbsLogits)));
    });
}
function $08f7648dacc2d698$export$f9fa66c6bf49fbe1(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        let y;
        y = $jU3Ej.clipByValue(yPred, (0, $c51ox.epsilon)(), 1 - (0, $c51ox.epsilon)());
        y = $djEuh.log($gjFWY.div(y, $hkR0n.sub(1, y)));
        return $gr40e.mean($08f7648dacc2d698$export$ba12332959c7f31a(yTrue, y), -1);
    });
}
function $08f7648dacc2d698$export$ca6ae4762880179a(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        const clippedTrue = $jU3Ej.clipByValue(yTrue, (0, $c51ox.epsilon)(), 1);
        const clippedPred = $jU3Ej.clipByValue(yPred, (0, $c51ox.epsilon)(), 1);
        return $fVwnn.sum($r7fN6.mul(yTrue, $djEuh.log($gjFWY.div(clippedTrue, clippedPred))), -1);
    });
}
function $08f7648dacc2d698$export$e2342249434e96a8(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        const logPred = $djEuh.log($1ZrG5.add((0, $c51ox.epsilon)(), yPred));
        return $gr40e.mean($hkR0n.sub(yPred, $r7fN6.mul(yTrue, logPred)), -1);
    });
}
function $08f7648dacc2d698$export$a39f0fc1fa1caacd(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        const trueNormalized = $08f7648dacc2d698$export$56804db0f45bf789(yTrue, -1);
        const predNormalized = $08f7648dacc2d698$export$56804db0f45bf789(yPred, -1);
        const trueXPred = $r7fN6.mul(trueNormalized, predNormalized);
        return $ifge7.neg($fVwnn.sum(trueXPred, -1));
    });
}
const $08f7648dacc2d698$export$5af2a467647891e2 = $08f7648dacc2d698$export$33de16355e97f7fb;
const $08f7648dacc2d698$export$19fa95397f41c30f = $08f7648dacc2d698$export$33de16355e97f7fb;
const $08f7648dacc2d698$export$1d5f948d69c1bb9e = $08f7648dacc2d698$export$607988531ba584e6;
const $08f7648dacc2d698$export$5763e506e192f1c3 = $08f7648dacc2d698$export$607988531ba584e6;
const $08f7648dacc2d698$export$1d9e5626781fbee = $08f7648dacc2d698$export$29f745e8786a84d;
const $08f7648dacc2d698$export$520a6d354b1a7026 = $08f7648dacc2d698$export$29f745e8786a84d;
const $08f7648dacc2d698$export$863e9fcd25a63ca1 = $08f7648dacc2d698$export$6f3c2909d4934f8e;
const $08f7648dacc2d698$export$52f45e1331da5a2d = $08f7648dacc2d698$export$6f3c2909d4934f8e;
const $08f7648dacc2d698$export$832ecf683c672b43 = $08f7648dacc2d698$export$ca6ae4762880179a;
const $08f7648dacc2d698$export$cb1c1cc0b7255a = $08f7648dacc2d698$export$ca6ae4762880179a;
const $08f7648dacc2d698$export$c2a6cd60d490c7cc = $08f7648dacc2d698$export$a39f0fc1fa1caacd;
const $08f7648dacc2d698$export$80c8fb006fb174f5 = {
    meanSquaredError: $08f7648dacc2d698$export$33de16355e97f7fb,
    meanAbsoluteError: $08f7648dacc2d698$export$607988531ba584e6,
    meanAbsolutePercentageError: $08f7648dacc2d698$export$29f745e8786a84d,
    meanSquaredLogarithmicError: $08f7648dacc2d698$export$6f3c2909d4934f8e,
    squaredHinge: $08f7648dacc2d698$export$6e9184938bd4bdfd,
    hinge: $08f7648dacc2d698$export$321a3d0bf2c75,
    categoricalHinge: $08f7648dacc2d698$export$21844282d987078,
    logcosh: $08f7648dacc2d698$export$d3a5506af1f5d4c0,
    categoricalCrossentropy: $08f7648dacc2d698$export$3d5544849562b631,
    sparseCategoricalCrossentropy: $08f7648dacc2d698$export$d02551222e9364f0,
    binaryCrossentropy: $08f7648dacc2d698$export$f9fa66c6bf49fbe1,
    kullbackLeiblerDivergence: $08f7648dacc2d698$export$ca6ae4762880179a,
    poisson: $08f7648dacc2d698$export$e2342249434e96a8,
    cosineProximity: $08f7648dacc2d698$export$a39f0fc1fa1caacd
};
function $08f7648dacc2d698$export$3988ae62b71be9a3(identifierOrFn) {
    if (typeof identifierOrFn === 'string') {
        if (identifierOrFn in $08f7648dacc2d698$export$80c8fb006fb174f5) return $08f7648dacc2d698$export$80c8fb006fb174f5[identifierOrFn];
        let errMsg = `Unknown loss ${identifierOrFn}`;
        if (identifierOrFn.toLowerCase().includes('softmaxcrossentropy')) errMsg = `Unknown loss ${identifierOrFn}. ` + 'Use "categoricalCrossentropy" as the string name for ' + 'tf.losses.softmaxCrossEntropy';
        throw new (0, $jVuYK.ValueError)(errMsg);
    } else return identifierOrFn;
}

});

parcelRegister("3ETNO", function(module, exports) {

$parcel$export(module.exports, "binaryAccuracy", () => $2aa064b36694638a$export$7b3d02e9a01c1ca);
$parcel$export(module.exports, "categoricalAccuracy", () => $2aa064b36694638a$export$1365401eb6b7aeeb);
$parcel$export(module.exports, "precision", () => $2aa064b36694638a$export$b70eeb0e623ceb0d);
$parcel$export(module.exports, "recall", () => $2aa064b36694638a$export$479490328e25f530);
$parcel$export(module.exports, "binaryCrossentropy", () => $2aa064b36694638a$export$f9fa66c6bf49fbe1);
$parcel$export(module.exports, "sparseCategoricalAccuracy", () => $2aa064b36694638a$export$b35c43b77daa3523);
$parcel$export(module.exports, "categoricalCrossentropy", () => $2aa064b36694638a$export$3d5544849562b631);
$parcel$export(module.exports, "sparseCategoricalCrossentropy", () => $2aa064b36694638a$export$d02551222e9364f0);
$parcel$export(module.exports, "get", () => $2aa064b36694638a$export$3988ae62b71be9a3);
$parcel$export(module.exports, "getLossOrMetricName", () => $2aa064b36694638a$export$9fb8307a5eeccc76);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Built-in metrics.
 */ parcelRequire("5n9DG");
var $1ZrG5 = parcelRequire("1ZrG5");
var $iFZ6U = parcelRequire("iFZ6U");
var $7qWZ5 = parcelRequire("7qWZ5");
var $gjFWY = parcelRequire("gjFWY");
var $5Py3O = parcelRequire("5Py3O");
var $jUhqf = parcelRequire("jUhqf");
var $jtRHJ = parcelRequire("jtRHJ");
var $gr40e = parcelRequire("gr40e");
var $r7fN6 = parcelRequire("r7fN6");
var $9u8DQ = parcelRequire("9u8DQ");
var $wniip = parcelRequire("wniip");
var $fVwnn = parcelRequire("fVwnn");
var $9c0Qr = parcelRequire("9c0Qr");
var $3dRh6 = parcelRequire("3dRh6");

var $luRak = parcelRequire("luRak");

var $jVuYK = parcelRequire("jVuYK");

var $LJ7JU = parcelRequire("LJ7JU");

var $khD6O = parcelRequire("khD6O");
function $2aa064b36694638a$export$7b3d02e9a01c1ca(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        const threshold = $r7fN6.mul(.5, $9u8DQ.onesLike(yPred));
        const yPredThresholded = $luRak.cast($jUhqf.greater(yPred, threshold), yTrue.dtype);
        return $gr40e.mean($5Py3O.equal(yTrue, yPredThresholded), -1);
    });
}
function $2aa064b36694638a$export$1365401eb6b7aeeb(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>$luRak.cast($5Py3O.equal($iFZ6U.argMax(yTrue, -1), $iFZ6U.argMax(yPred, -1)), 'float32'));
}
function $2aa064b36694638a$var$truePositives(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        return $7qWZ5.cast($fVwnn.sum($jtRHJ.logicalAnd($5Py3O.equal(yTrue, 1), $5Py3O.equal(yPred, 1))), 'float32');
    });
}
function $2aa064b36694638a$var$falseNegatives(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        return $7qWZ5.cast($fVwnn.sum($jtRHJ.logicalAnd($5Py3O.equal(yTrue, 1), $5Py3O.equal(yPred, 0))), 'float32');
    });
}
function $2aa064b36694638a$var$falsePositives(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        return $7qWZ5.cast($fVwnn.sum($jtRHJ.logicalAnd($5Py3O.equal(yTrue, 0), $5Py3O.equal(yPred, 1))), 'float32');
    });
}
function $2aa064b36694638a$export$b70eeb0e623ceb0d(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        const tp = $2aa064b36694638a$var$truePositives(yTrue, yPred);
        const fp = $2aa064b36694638a$var$falsePositives(yTrue, yPred);
        const denominator = $1ZrG5.add(tp, fp);
        return $7qWZ5.cast($3dRh6.where($jUhqf.greater(denominator, 0), $gjFWY.div(tp, denominator), 0), 'float32');
    });
}
function $2aa064b36694638a$export$479490328e25f530(yTrue, yPred) {
    return (0, $9c0Qr.tidy)(()=>{
        const tp = $2aa064b36694638a$var$truePositives(yTrue, yPred);
        const fn = $2aa064b36694638a$var$falseNegatives(yTrue, yPred);
        const denominator = $1ZrG5.add(tp, fn);
        return $7qWZ5.cast($3dRh6.where($jUhqf.greater(denominator, 0), $gjFWY.div(tp, denominator), 0), 'float32');
    });
}
function $2aa064b36694638a$export$f9fa66c6bf49fbe1(yTrue, yPred) {
    return (0, $LJ7JU.binaryCrossentropy)(yTrue, yPred);
}
function $2aa064b36694638a$export$b35c43b77daa3523(yTrue, yPred) {
    if (yTrue.rank === yPred.rank) yTrue = $wniip.squeeze(yTrue, [
        yTrue.rank - 1
    ]);
    yPred = $iFZ6U.argMax(yPred, -1);
    if (yPred.dtype !== yTrue.dtype) yPred = $7qWZ5.cast(yPred, yTrue.dtype);
    return $7qWZ5.cast($5Py3O.equal(yTrue, yPred), 'float32');
}
function $2aa064b36694638a$export$1a189de14358fa71(yTrue, yPred) {
    throw new (0, $jVuYK.NotImplementedError)();
}
function $2aa064b36694638a$export$a15ee75d9e4cf4ae(yTrue, yPred) {
    throw new (0, $jVuYK.NotImplementedError)();
}
const $2aa064b36694638a$export$5af2a467647891e2 = (0, $LJ7JU.meanSquaredError);
const $2aa064b36694638a$export$19fa95397f41c30f = (0, $LJ7JU.meanSquaredError);
const $2aa064b36694638a$export$1d5f948d69c1bb9e = (0, $LJ7JU.meanAbsoluteError);
const $2aa064b36694638a$export$5763e506e192f1c3 = (0, $LJ7JU.meanAbsoluteError);
const $2aa064b36694638a$export$1d9e5626781fbee = (0, $LJ7JU.meanAbsolutePercentageError);
const $2aa064b36694638a$export$520a6d354b1a7026 = (0, $LJ7JU.meanAbsolutePercentageError);
const $2aa064b36694638a$export$3d5544849562b631 = (0, $LJ7JU.categoricalCrossentropy);
const $2aa064b36694638a$export$c2a6cd60d490c7cc = (0, $LJ7JU.cosineProximity);
const $2aa064b36694638a$export$d02551222e9364f0 = (0, $LJ7JU.sparseCategoricalCrossentropy);
const $2aa064b36694638a$export$17c75e85c6265c88 = {
    binaryAccuracy: $2aa064b36694638a$export$7b3d02e9a01c1ca,
    categoricalAccuracy: $2aa064b36694638a$export$1365401eb6b7aeeb,
    precision: $2aa064b36694638a$export$b70eeb0e623ceb0d,
    categoricalCrossentropy: $2aa064b36694638a$export$3d5544849562b631,
    sparseCategoricalCrossentropy: $2aa064b36694638a$export$d02551222e9364f0,
    mse: $2aa064b36694638a$export$5af2a467647891e2,
    MSE: $2aa064b36694638a$export$19fa95397f41c30f,
    mae: $2aa064b36694638a$export$1d5f948d69c1bb9e,
    MAE: $2aa064b36694638a$export$5763e506e192f1c3,
    mape: $2aa064b36694638a$export$1d9e5626781fbee,
    MAPE: $2aa064b36694638a$export$520a6d354b1a7026,
    cosine: $2aa064b36694638a$export$c2a6cd60d490c7cc
};
function $2aa064b36694638a$export$3988ae62b71be9a3(identifier) {
    if (typeof identifier === 'string' && identifier in $2aa064b36694638a$export$17c75e85c6265c88) return $2aa064b36694638a$export$17c75e85c6265c88[identifier];
    else if (typeof identifier !== 'string' && identifier != null) return identifier;
    else throw new (0, $jVuYK.ValueError)(`Unknown metric ${identifier}`);
}
function $2aa064b36694638a$export$9fb8307a5eeccc76(fn) {
    $khD6O.assert(fn !== null, `Unknown LossOrMetricFn ${fn}`);
    if (typeof fn === 'string') return fn;
    else {
        let fnName;
        for (const key of Object.keys((0, $LJ7JU.lossesMap)))if ((0, $LJ7JU.lossesMap)[key] === fn) {
            fnName = key;
            break;
        }
        if (fnName !== undefined) return fnName;
        for (const key of Object.keys($2aa064b36694638a$export$17c75e85c6265c88))if ($2aa064b36694638a$export$17c75e85c6265c88[key] === fn) {
            fnName = key;
            break;
        }
        if (fnName !== undefined) return fnName;
        return fn.name;
    }
}

});

parcelRegister("bIveH", function(module, exports) {

$parcel$export(module.exports, "getOptimizer", () => $887c08a10161617e$export$93a6cd925bf0fb14);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Optimizers.
 */ parcelRequire("5n9DG");
var $bwWuH = parcelRequire("bwWuH");

var $c51ox = parcelRequire("c51ox");

var $jVuYK = parcelRequire("jVuYK");
function $887c08a10161617e$export$93a6cd925bf0fb14(identifier) {
    const optimizerMap = {
        'Adagrad': ()=>(0, $bwWuH.train).adagrad(0.01),
        'Adadelta': ()=>(0, $bwWuH.train).adadelta(1, 0.95, (0, $c51ox.epsilon)()),
        'Adam': ()=>(0, $bwWuH.train).adam(0.001, 0.9, 0.999, (0, $c51ox.epsilon)()),
        'Adamax': ()=>(0, $bwWuH.train).adamax(0.002, 0.9, 0.999, (0, $c51ox.epsilon)(), 0),
        'RMSProp': ()=>(0, $bwWuH.train).rmsprop(0.001, 0.9, 0, (0, $c51ox.epsilon)()),
        'SGD': ()=>(0, $bwWuH.train).sgd(0.01)
    };
    optimizerMap['adagrad'] = optimizerMap['Adagrad'];
    optimizerMap['adadelta'] = optimizerMap['Adadelta'];
    optimizerMap['adam'] = optimizerMap['Adam'];
    optimizerMap['adamax'] = optimizerMap['Adamax'];
    optimizerMap['rmsprop'] = optimizerMap['RMSProp'];
    optimizerMap['sgd'] = optimizerMap['SGD'];
    if (identifier in optimizerMap) return optimizerMap[identifier]();
    throw new (0, $jVuYK.ValueError)(`Unknown Optimizer ${identifier}`);
}

});

parcelRegister("cKsXd", function(module, exports) {

$parcel$export(module.exports, "checkUserDefinedMetadata", () => $94803d9b25e5ba0a$export$5c1c8db6517969f5);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /** Utility functions related to user-defined metadata. */ // Maximum recommended serialized size for user-defined metadata.
// Beyond this limit, a warning message will be printed during model loading and
// saving.
const $94803d9b25e5ba0a$export$60e49adbc1213273 = 1048576;
function $94803d9b25e5ba0a$export$5c1c8db6517969f5(userDefinedMetadata, modelName, checkSize = false) {
    if (userDefinedMetadata == null || typeof userDefinedMetadata !== 'object' || Object.getPrototypeOf(userDefinedMetadata) !== Object.prototype || !$94803d9b25e5ba0a$export$62cb934243969363(userDefinedMetadata)) throw new Error('User-defined metadata is expected to be a JSON object, but is not.');
    if (checkSize) {
        const out = JSON.stringify(userDefinedMetadata);
        if (out.length > $94803d9b25e5ba0a$export$60e49adbc1213273) console.warn(`User-defined metadata of model "${modelName}" is too large in ` + `size (length=${out.length} when serialized). It is not ` + `recommended to store such large objects in user-defined metadata. ` + `Please make sure its serialized length is <= ` + `${$94803d9b25e5ba0a$export$60e49adbc1213273}.`);
    }
}
function $94803d9b25e5ba0a$export$62cb934243969363(x) {
    if (x === null) // Note: typeof `null` is 'object', and `null` is valid in JSON.
    return true;
    else if (typeof x === 'object') {
        if (Object.getPrototypeOf(x) === Object.prototype) {
            // `x` is a JavaScript object and its prototype is Object.
            const keys = Object.keys(x);
            for (const key of keys){
                if (typeof key !== 'string') // JSON keys must be strings.
                return false;
                if (!$94803d9b25e5ba0a$export$62cb934243969363(x[key])) return false;
            }
            return true;
        } else {
            // `x` is a JavaScript object but its prototype is not Object.
            if (Array.isArray(x)) {
                // `x` is a JavaScript array.
                for (const item of x){
                    if (!$94803d9b25e5ba0a$export$62cb934243969363(item)) return false;
                }
                return true;
            } else // `x` is a JavaScript object and its prototype is not Object,
            // and it's not an Array. I.e., it's a complex object such as
            // `Error` and `Date`.
            return false;
        }
    } else {
        // `x` is not a JavaScript object or `null`.
        const xType = typeof x;
        return xType === 'string' || xType === 'number' || xType === 'boolean';
    }
}

});

parcelRegister("ahGe0", function(module, exports) {

$parcel$export(module.exports, "printSummary", () => $77cc3ee0004c4f36$export$9b5fcd5d170a598e);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $5YCEz = parcelRequire("5YCEz");
function $77cc3ee0004c4f36$export$9b5fcd5d170a598e(model, lineLength, positions, // tslint:disable-next-line:no-any
printFn = console.log) {
    const sequentialLike = $77cc3ee0004c4f36$var$isModelSequentialLike(model);
    // Header names for different log elements.
    const toDisplay = [
        'Layer (type)',
        'Input Shape',
        'Output shape',
        'Param #'
    ];
    if (sequentialLike) {
        lineLength = lineLength || 90;
        positions = positions || [
            0.32,
            0.61,
            0.89,
            1
        ];
    } else {
        lineLength = lineLength || 115;
        positions = positions || [
            0.24,
            0.48,
            0.70,
            0.80,
            1
        ];
    // Header names for different log elements.
    }
    if (positions[positions.length - 1] <= 1) // `positions` is relative. Convert it to absolute positioning.
    positions = positions.map((p)=>Math.floor(lineLength * p));
    let relevantNodes;
    if (!sequentialLike) {
        toDisplay.push('Receives inputs');
        relevantNodes = [];
        for(const depth in model.nodesByDepth)relevantNodes.push(...model.nodesByDepth[depth]);
    }
    printFn('_'.repeat(lineLength));
    $77cc3ee0004c4f36$var$printRow(toDisplay, positions, printFn);
    printFn('='.repeat(lineLength));
    const layers = model.layers;
    for(let i = 0; i < layers.length; ++i){
        if (sequentialLike) $77cc3ee0004c4f36$var$printLayerSummary(layers[i], positions, printFn);
        else $77cc3ee0004c4f36$var$printLayerSummaryWithConnections(layers[i], positions, relevantNodes, printFn);
        printFn((i === layers.length - 1 ? '=' : '_').repeat(lineLength));
    }
    // tslint:disable-next-line:no-any
    model.checkTrainableWeightsConsistency();
    const trainableCount = $77cc3ee0004c4f36$var$countTrainableParams(model);
    const nonTrainableCount = (0, $5YCEz.countParamsInWeights)(model.nonTrainableWeights);
    printFn(`Total params: ${trainableCount + nonTrainableCount}`);
    printFn(`Trainable params: ${trainableCount}`);
    printFn(`Non-trainable params: ${nonTrainableCount}`);
    printFn('_'.repeat(lineLength));
}
function $77cc3ee0004c4f36$var$countTrainableParams(model) {
    let trainableCount;
    // tslint:disable:no-any
    if (model.collectedTrainableWeights != null) trainableCount = (0, $5YCEz.countParamsInWeights)(model.collectedTrainableWeights);
    else trainableCount = (0, $5YCEz.countParamsInWeights)(model.trainableWeights);
    // tslint:enable:no-any
    return trainableCount;
}
function $77cc3ee0004c4f36$var$isModelSequentialLike(model) {
    let sequentialLike = true;
    const nodesByDepth = [];
    const nodes = [];
    for(const depth in model.nodesByDepth)nodesByDepth.push(model.nodesByDepth[depth]);
    for (const depthNodes of nodesByDepth){
        if (depthNodes.length > 1 || depthNodes.length === 1 && depthNodes[0].inboundLayers.length > 1) {
            sequentialLike = false;
            break;
        }
        nodes.push(...depthNodes);
    }
    if (sequentialLike) // Search for shared layers.
    for (const layer of model.layers){
        let flag = false;
        for (const node of layer.inboundNodes)if (nodes.indexOf(node) !== -1) {
            if (flag) {
                sequentialLike = false;
                break;
            } else flag = true;
        }
        if (!sequentialLike) break;
    }
    return sequentialLike;
}
function $77cc3ee0004c4f36$var$printRow(fields, positions, // tslint:disable-next-line:no-any
printFn = console.log) {
    let line = '';
    for(let i = 0; i < fields.length; ++i){
        if (i > 0) line = line.slice(0, line.length - 1) + ' ';
        line += fields[i];
        line = line.slice(0, positions[i]);
        line += ' '.repeat(positions[i] - line.length);
    }
    printFn(line);
}
/**
 * Prints a summary for a single Layer, without connectivity information.
 *
 * @param layer: Layer instance to print.
 */ function $77cc3ee0004c4f36$var$printLayerSummary(layer, positions, // tslint:disable-next-line:no-any
printFn) {
    let outputShape;
    let inputShape;
    try {
        inputShape = layer.inboundNodes.map((x)=>JSON.stringify(x.inputShapes)).join(',');
    } catch (err) {
        inputShape = 'multiple';
    }
    try {
        outputShape = JSON.stringify(layer.outputShape);
    } catch (err) {
        outputShape = 'multiple';
    }
    const name = layer.name;
    const className = layer.getClassName();
    const fields = [
        `${name} (${className})`,
        inputShape,
        outputShape,
        layer.countParams().toString()
    ];
    $77cc3ee0004c4f36$var$printRow(fields, positions, printFn);
}
/**
 * Prints a summary for a single Layer, with connectivity information.
 */ function $77cc3ee0004c4f36$var$printLayerSummaryWithConnections(layer, positions, relevantNodes, // tslint:disable-next-line:no-any
printFn) {
    let outputShape;
    let inputShape;
    try {
        inputShape = layer.inboundNodes.map((x)=>JSON.stringify(x.inputShapes)).join(',');
    } catch (err) {
        inputShape = 'multiple';
    }
    try {
        outputShape = JSON.stringify(layer.outputShape);
    } catch (err) {
        outputShape = 'multiple';
    }
    const connections = [];
    for (const node of layer.inboundNodes){
        if (relevantNodes != null && relevantNodes.length > 0 && relevantNodes.indexOf(node) === -1) continue;
        for(let i = 0; i < node.inboundLayers.length; ++i){
            const inboundLayer = node.inboundLayers[i].name;
            const inboundLayerIndex = node.nodeIndices[i];
            const inboundTensorIndex = node.tensorIndices[i];
            connections.push(`${inboundLayer}[${inboundLayerIndex}][${inboundTensorIndex}]`);
        }
    }
    const name = layer.name;
    const className = layer.getClassName();
    const firstConnection = connections.length === 0 ? '' : connections[0];
    const fields = [
        `${name} (${className})`,
        inputShape,
        outputShape,
        layer.countParams().toString(),
        firstConnection
    ];
    $77cc3ee0004c4f36$var$printRow(fields, positions, printFn);
    for(let i = 1; i < connections.length; ++i)$77cc3ee0004c4f36$var$printRow([
        '',
        '',
        '',
        '',
        connections[i]
    ], positions, printFn);
}

});

parcelRegister("4UVDw", function(module, exports) {

$parcel$export(module.exports, "convertPythonicToTs", () => $394919c4c01292fc$export$c0fd0796420499e6);
$parcel$export(module.exports, "convertTsToPythonic", () => $394919c4c01292fc$export$b63a5d81d6846026);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $khD6O = parcelRequire("khD6O");
// tslint:enable
/**
 * Test whether a value in an array is the name of a LayersModel or Layer.
 * @param key The key name that the value is found under. Note that the key
 *   may not be at the level immediately above the value, if the value is in a
 *   nested array.
 * @param index Index of the value in the Array that it is found in.
 * @param value The value object.
 * @returns A boolean indicating whether value is a name.
 */ function $394919c4c01292fc$var$isArrayItemInputOrOutputName(key, index, value) {
    return (key === 'inboundNodes' || key === 'outputLayers' || key === 'inputLayers') && index === 0 && typeof value === 'string';
}
function $394919c4c01292fc$export$c0fd0796420499e6(pythonicConfig, key) {
    if (pythonicConfig === null) return null;
    else if (typeof pythonicConfig === 'string') return $khD6O.toCamelCase(pythonicConfig);
    else if (typeof pythonicConfig === 'number' || typeof pythonicConfig === 'boolean') return pythonicConfig;
    else if (pythonicConfig instanceof Array) {
        const tsArray = [];
        const arrayLength = pythonicConfig.length;
        for(let i = 0; i < arrayLength; ++i){
            const item = pythonicConfig[i];
            if ($394919c4c01292fc$var$isArrayItemInputOrOutputName(key, i, item)) tsArray.push(item);
            else tsArray.push($394919c4c01292fc$export$c0fd0796420499e6(item, key));
        }
        return tsArray;
    } else {
        const tsDict = {};
        for (const pythonicKey of Object.keys(pythonicConfig)){
            const pythonicValue = pythonicConfig[pythonicKey];
            if (pythonicKey === 'name' && typeof pythonicValue === 'string') // Special case the 'name' key with a string value. Name values, such as
            // the names of LayersModel and Layer instances, should not undergo the
            // camel-case conversion.
            tsDict[pythonicKey] = pythonicValue;
            else {
                const tsKey = $khD6O.toCamelCase(pythonicKey);
                tsDict[tsKey] = $394919c4c01292fc$export$c0fd0796420499e6(pythonicValue, tsKey);
            }
        }
        return tsDict;
    }
}
function $394919c4c01292fc$export$b63a5d81d6846026(tsConfig, key) {
    if (tsConfig === null || tsConfig === undefined) return null;
    else if (typeof tsConfig === 'string') return $khD6O.toSnakeCase(tsConfig);
    else if (typeof tsConfig === 'number' || typeof tsConfig === 'boolean') return tsConfig;
    else if (tsConfig instanceof Array) {
        const pyArray = [];
        const arrayLength = tsConfig.length;
        for(let i = 0; i < arrayLength; ++i){
            const item = tsConfig[i];
            if ($394919c4c01292fc$var$isArrayItemInputOrOutputName(key, i, item)) pyArray.push(item);
            else pyArray.push($394919c4c01292fc$export$b63a5d81d6846026(item, key));
        }
        return pyArray;
    } else {
        const pyDict = {};
        for (const tsKey of Object.keys(tsConfig)){
            const tsValue = tsConfig[tsKey];
            const pyKey = $khD6O.toSnakeCase(tsKey);
            if ((tsKey === 'name' || tsKey === 'className') && typeof tsValue === 'string') // Special case the 'name' key with a string value. Name values, such as
            // the names of LayersModel and Layer instances, should not undergo the
            // snake-case conversion.
            pyDict[pyKey] = tsValue;
            else pyDict[pyKey] = $394919c4c01292fc$export$b63a5d81d6846026(tsValue, tsKey);
        }
        return pyDict;
    }
}

});

parcelRegister("3lFvz", function(module, exports) {

$parcel$export(module.exports, "version", () => $270387f11d1cee2a$export$83d89fbfd8236492);
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $270387f11d1cee2a$export$83d89fbfd8236492 = '3.21.0';

});

parcelRegister("doV3w", function(module, exports) {

$parcel$export(module.exports, "Container", () => $9c19c6594b298ee0$export$42a852a2b6b56249);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/engine/topology.py */ parcelRequire("5n9DG");
var $9c0Qr = parcelRequire("9c0Qr");

var $3qq1L = parcelRequire("3qq1L");

var $jVuYK = parcelRequire("jVuYK");

var $dttI1 = parcelRequire("dttI1");

var $khD6O = parcelRequire("khD6O");

var $4UVDw = parcelRequire("4UVDw");

var $5sw3q = parcelRequire("5sw3q");

var $7muWV = parcelRequire("7muWV");

var $3lFvz = parcelRequire("3lFvz");

var $ButqI = parcelRequire("ButqI");

var $3gFUY = parcelRequire("3gFUY");

var $cm045 = parcelRequire("cm045");
class $9c19c6594b298ee0$export$42a852a2b6b56249 extends (0, $cm045.Layer) {
    constructor(args){
        // No args passed to super's constructor.
        super({});
        this.containerNodes = new Set();
        this.name = args.name;
        if (this.name == null) {
            const prefix = this.getClassName().toLowerCase();
            this.name = (0, $3qq1L.getUid)(prefix);
        }
        this.supportsMasking = false;
        this.trainable_ = true;
        // TODO(michaelterry): Initialize perInputLosses/Updates here.
        // Container-specific properties.
        if (Array.isArray(args.inputs)) this.inputs = args.inputs.slice();
        else this.inputs = [
            args.inputs
        ];
        if (Array.isArray(args.outputs)) this.outputs = args.outputs.slice();
        else this.outputs = [
            args.outputs
        ];
        // Check for redundancy in inputs.
        if ($khD6O.unique(this.inputs).length !== this.inputs.length) throw new (0, $jVuYK.ValueError)("The list of inputs passed to the model is redundant. All inputs should only appear once. Found: " + `${this.inputs.map((x)=>x.name)}`);
        // Check for redundancy in outputs.
        if ($khD6O.unique(this.outputs).length !== this.outputs.length) console.warn("The list of outputs passed to the model is redundant. All outputs should only appear once. Found: " + `${this.outputs.map((x)=>x.name)}`);
        /*
          List of initial layers (1 to 1 mapping with this.inputs, hence the same
          layer might appear twice)
        */ this.inputLayers = [];
        this.inputLayersNodeIndices = [];
        this.inputLayersTensorIndices = [];
        /*
          List of layers (1 to 1 mapping with this.outputs, hence the same layer
          might appear twice)
        */ this.outputLayers = [];
        this.outputLayersNodeIndices = [];
        this.outputLayersTensorIndices = [];
        /*
          All layers in order of horizontal graph traversal. Entries are unique.
          Includes input and output layers.
        */ this.layers = [];
        /*
          References to container layers that were constructed internally. We need
          these to properly dispose of tensors from nested containers.
        */ this.internalContainerRefs = [];
        // TODO(michaelterry): Determine if caching still needed with eager
        // backend.
        /*
          This is for performance optimization when calling the Container on new
          inputs. Every time the Container is called on a set on input tensors,
          we compute the output tensors, output masks and output shapes in one pass,
          then cache them here. When one of these outputs is queried later,
          we retrieve it from there instead of recomputing it.
        */ // this.outputTensorCache = {};
        // this.outputShapeCache = {};
        // Build this.outputLayers:
        for (const x of this.outputs){
            const layer = x.sourceLayer;
            const nodeIndex = x.nodeIndex;
            const tensorIndex = x.tensorIndex;
            this.outputLayers.push(layer);
            this.outputLayersNodeIndices.push(nodeIndex);
            this.outputLayersTensorIndices.push(tensorIndex);
        }
        // TODO(michaelterry): Add output mask cache code.
        // Build this.inputLayers:
        for (const x of this.inputs){
            const layer = x.sourceLayer;
            const nodeIndex = x.nodeIndex;
            const tensorIndex = x.tensorIndex;
            /*
              It's supposed to be an input layer, so only one node
              and one tensor output.
            */ $khD6O.assert(nodeIndex === 0, 'input layer has >1 nodes');
            $khD6O.assert(tensorIndex === 0, 'input layer has >1 tensors');
            this.inputLayers.push(layer);
            this.inputLayersNodeIndices.push(nodeIndex);
            this.inputLayersTensorIndices.push(tensorIndex);
        }
        // Build this.inputNames and this.outputNames.
        this.inputNames = [];
        this.outputNames = [];
        this.feedInputShapes = [];
        this.feedInputNames = [];
        this.feedOutputNames = [];
        for(let i = 0; i < this.inputLayers.length; i++){
            const layer = this.inputLayers[i];
            // Check that layer is an InputLayer.
            if (!(layer instanceof (0, $3gFUY.InputLayer))) throw new TypeError('Input layers to a LayersModel must be InputLayer objects. ' + `Received inputs: ${args.inputs}. ` + `Input ${i} (0-based) originates ` + `from layer type ${layer.getClassName()}.`);
            this.inputNames.push(layer.name);
            this.feedInputShapes.push(layer.batchInputShape);
            this.feedInputNames.push(layer.name);
        }
        for (const layer of this.outputLayers)this.outputNames.push(layer.name);
        this.internalInputShapes = this.inputs.map((x)=>x.shape);
        this.internalOutputShapes = this.outputs.map((x)=>x.shape);
        /*
          Container_nodes: set of nodes included in the graph (not all nodes
          included in the layers are relevant to the current graph).
        */ // ids of all nodes relevant to the Container:
        const nodesDepths = {};
        // To recover nodes from their ID.
        const nodeIDToNode = {};
        const layersDepths = {};
        // To layers from their ID.
        const layerIDToLayer = {};
        const layerIndices = {};
        const nodesInDecreasingDepth = [];
        /**
         * Builds a map of the graph of layers.
         *
         * This recursively updates the map `layerIndices`,
         * the list `nodesInDecreasingDepth` and the set `containerNodes`.
         *
         * @param tensor Some tensor in a graph.
         * @param finishedNodes Set of nodes whose subgraphs have been traversed
         *         completely. Useful to prevent duplicated work.
         * @param nodesInProgress Set of nodes that are currently active on the
         *         recursion stack. Useful to detect cycles.
         * @param layer Layer from which `tensor` comes from. If not provided,
         *   will be obtained from tensor.sourceLayer.
         * @param nodeIndex Node index from which `tensor` comes from.
         * @param tensorIndex TensorIndex from which `tensor` comes from.
         *
         * @exception RuntimeError if a cycle is detected.
         */ const buildMapOfGraph = (tensor, finishedNodes, nodesInProgress, layer, nodeIndex, tensorIndex)=>{
            if (layer == null || nodeIndex == null || tensorIndex == null) {
                layer = tensor.sourceLayer;
                nodeIndex = tensor.nodeIndex;
                tensorIndex = tensor.tensorIndex;
            }
            const node = layer.inboundNodes[nodeIndex];
            // Prevent cycles.
            if (nodesInProgress.indexOf(node) !== -1) throw new (0, $jVuYK.RuntimeError)(`The tensor ${tensor.name} at layer "${layer.name}" ` + 'is part of a cycle.');
            // Don't repeat work for shared subgraphs
            if (finishedNodes.indexOf(node) !== -1) return;
            // Update containerNodes.
            this.containerNodes.add($9c19c6594b298ee0$export$42a852a2b6b56249.nodeKey(layer, nodeIndex));
            // Store the traversal order for layer sorting.
            if (!(layer.id in layerIndices)) layerIndices[layer.id] = Object.keys(layerIndices).length;
            if (nodesInProgress.indexOf(node) === -1) nodesInProgress.push(node);
            // Propagate to all previous tensors connected to this node.
            const numInboundLayers = node.inboundLayers.length;
            for(let i = 0; i < numInboundLayers; i++){
                const x = node.inputTensors[i];
                const layer = node.inboundLayers[i];
                const nodeIndex = node.nodeIndices[i];
                const tensorIndex = node.tensorIndices[i];
                buildMapOfGraph(x, finishedNodes, nodesInProgress, layer, nodeIndex, tensorIndex);
            }
            finishedNodes.push(node);
            while(nodesInProgress.indexOf(node) >= 0)nodesInProgress.splice(nodesInProgress.indexOf(node), 1);
            nodesInDecreasingDepth.push(node);
        };
        const finishedNodes = [];
        const nodesInProgress = [];
        for (const x of this.outputs)buildMapOfGraph(x, finishedNodes, nodesInProgress);
        const reversedNodesInDecreasingDepth = nodesInDecreasingDepth.slice().reverse();
        for (const node of reversedNodesInDecreasingDepth){
            nodeIDToNode[node.id] = node;
            // If the depth is not set, the node has no outbound nodes (depth 0).
            if (!(node.id in nodesDepths)) nodesDepths[node.id] = 0;
            let depth = nodesDepths[node.id];
            // Update the depth of the corresponding layer
            const previousDepth = layersDepths[node.outboundLayer.id] == null ? 0 : layersDepths[node.outboundLayer.id];
            /*
              If we've seen this layer before at a higher depth, we should use that
              depth instead of the node depth.  This is necessary for shared layers
              that have inputs at different depth levels in the graph.
            */ depth = Math.max(depth, previousDepth);
            layersDepths[node.outboundLayer.id] = depth;
            layerIDToLayer[node.outboundLayer.id] = node.outboundLayer;
            nodesDepths[node.id] = depth;
            // Update the depth of inbound nodes.
            for(let i = 0; i < node.inboundLayers.length; i++){
                const inboundLayer = node.inboundLayers[i];
                const nodeIndex = node.nodeIndices[i];
                const inboundNode = inboundLayer.inboundNodes[nodeIndex];
                const previousDepth = nodesDepths[inboundNode.id] == null ? 0 : nodesDepths[inboundNode.id];
                nodesDepths[inboundNode.id] = Math.max(depth + 1, previousDepth);
                nodeIDToNode[inboundNode.id] = inboundNode;
            }
        }
        // Build a dict {depth: list of nodes with this depth}
        const nodesByDepth = {};
        for(const nodeID in nodesDepths){
            const depth = nodesDepths[nodeID];
            if (!(depth in nodesByDepth)) nodesByDepth[depth] = [];
            nodesByDepth[depth].push(nodeIDToNode[nodeID]);
        }
        // Build a dict {depth: list of layers with this depth}
        const layersByDepth = {};
        for(const layerID in layersDepths){
            const depth = layersDepths[layerID];
            if (!(depth in layersByDepth)) layersByDepth[depth] = [];
            layersByDepth[depth].push(layerIDToLayer[layerID]);
        }
        // Get sorted list of layer depths.
        let depthKeys = Object.keys(layersByDepth).map((x)=>parseInt(x, 10)).sort($khD6O.reverseNumberCompare);
        // Set this.layers and this.layersByDepth.
        this.layers = [];
        for (const depth of depthKeys){
            const layersForDepth = layersByDepth[depth];
            // Container.layers needs to have a deterministic order:
            // here we order them by traversal order.
            layersForDepth.sort((a, b)=>{
                const aIndex = layerIndices[a.id];
                const bIndex = layerIndices[b.id];
                if (aIndex < bIndex) return -1;
                if (aIndex > bIndex) return 1;
                return 0;
            });
            for (const layer of layersForDepth){
                if (layer instanceof $9c19c6594b298ee0$export$42a852a2b6b56249) this.internalContainerRefs.push(layer);
                this.layers.push(layer);
            }
        }
        this.layersByDepth = layersByDepth;
        // Get sorted list of node depths;
        depthKeys = Object.keys(nodesByDepth).map((x)=>parseInt(x, 10)).sort($khD6O.reverseNumberCompare);
        // Check that all tensors required are computable.
        // computable_tensors: all tensors in the graph
        // that can be computed from the inputs provided.
        const computableTensors = this.inputs.slice();
        // To provide a better error msg.
        const layersWithCompleteInput = [];
        for (const depth of depthKeys)for (const node of nodesByDepth[depth]){
            const layer = node.outboundLayer;
            if (layer != null) {
                for (const x of node.inputTensors){
                    if (computableTensors.indexOf(x) === -1) throw new (0, $jVuYK.RuntimeError)(`Graph disconnected: cannot obtain value for tensor ${x}` + ` at layer "${layer.name}". ` + 'The following previous layers were accessed without ' + `issue: ${layersWithCompleteInput}`);
                }
                for (const x of node.outputTensors)computableTensors.push(x);
                layersWithCompleteInput.push(layer.name);
            }
        }
        // Set this.containerNodes and this.nodesByDepth.
        this.nodesByDepth = nodesByDepth;
        // Ensure name unicity, which will be crucial for serialization
        // (since serialized nodes refer to layers by their name).
        const allNames = this.layers.map((x)=>x.name);
        for (const name of allNames){
            const numOccurrences = allNames.filter((x)=>x === name).length;
            if (numOccurrences !== 1) throw new (0, $jVuYK.RuntimeError)(`The name "${name}" is used ${numOccurrences} times ` + 'in the model. All layer names should be unique. Layer names: ' + JSON.stringify(allNames));
        }
        // Layer parameters.
        // The new container starts with a single inbound node
        // for its inputs, and no outbound nodes.
        // Will be appended to by future calls to apply().
        this.outboundNodes = [];
        // Will be appended to below, and by future calls to apply().
        this.inboundNodes = [];
        // Create the node linking internal inputs to internal outputs.
        // (This call has side effects.)
        // tslint:disable-next-line:no-unused-expression
        new (0, $cm045.Node)({
            outboundLayer: this,
            inboundLayers: [],
            nodeIndices: [],
            tensorIndices: [],
            inputTensors: this.inputs,
            outputTensors: this.outputs,
            inputMasks: this.inputs.map((x)=>null),
            outputMasks: this.outputs.map((x)=>null),
            inputShapes: this.inputs.map((x)=>x.shape),
            outputShapes: this.outputs.map((x)=>x.shape)
        });
        this.built = true;
        this._refCount = 1; // The ref count of a container always start at 1.
    }
    assertNotDisposed() {
        if (this._refCount === 0) throw new Error(`Container '${this.name}' is already disposed.`);
    }
    /**
     * Attempt to dispose a LayersModel's weights.
     *
     * This method decrease the reference count of the LayersModel object by 1.
     *
     * A LayersModel is reference-counted. Its reference count is incremented by 1
     * when it is first constructed and when it is used as a Layer of another
     * LayersModel.
     *
     * If the reference count of a LayersModel becomes 0, the `dispose` method of
     * all its constituent `Layer`s will be called.
     *
     * Note: If the reference count is greater than 0 after the decrement, the
     * `dispose` method of its constituent `Layer`s will *not* be called.
     *
     * After a LayersModel is disposed, it cannot be used in calls such as
     * 'predict`, `evaluate` or `fit` anymore.
     *
     * @returns A DisposeResult Object with the following fields:
     *   - refCountAfterDispose: The reference count of the LayersModel after this
     *     `dispose()` call.
     *   - numDisposedVariables: Number of `tf.Variable`s (i.e., weights) disposed
     *     during this `dispose()` call.
     * @throws {Error} If the layer is not built yet, or if the LayersModel has
     *   already been disposed.
     */ dispose() {
        this.assertNotDisposed();
        const result = {
            refCountAfterDispose: null,
            numDisposedVariables: 0
        };
        if (--this._refCount === 0) {
            for (const layer of this.layers)result.numDisposedVariables += layer.dispose().numDisposedVariables;
            // Call dispose on each internally created container layer again to ensure
            // their refCounts hit zero and their tensors are subsequently deleted.
            for (const container of this.internalContainerRefs)result.numDisposedVariables += container.dispose().numDisposedVariables;
        }
        result.refCountAfterDispose = this._refCount;
        return result;
    }
    get trainable() {
        return this.trainable_;
    }
    set trainable(trainable) {
        this.layers.forEach((layer)=>{
            // tslint:disable-next-line:no-any
            layer._trainableWeights.forEach((w)=>w.trainable = trainable);
        });
        this.trainable_ = trainable;
    }
    get trainableWeights() {
        // Porting Note: This check below is to prevent errors where the
        //   _trainableWeights inherited from the parent class (Layer) gets
        //   inadvertently used.
        if (this._trainableWeights.length > 0) throw new (0, $jVuYK.ValueError)("Container instance unexpectedly contains _trainableWeights.The trainable weights of a Container are a union of the trainable weights of its consituent Layers. Its own _trainableWeights must remain an empty Array.");
        if (!this.trainable) return [];
        let weights = [];
        for (const layer of this.layers)weights = weights.concat(layer.trainableWeights);
        return weights;
    }
    get nonTrainableWeights() {
        const weights = [];
        for (const layer of this.layers)weights.push(...layer.nonTrainableWeights);
        if (!this.trainable) {
            const trainableWeights = [];
            for (const layer of this.layers)trainableWeights.push(...layer.trainableWeights);
            return trainableWeights.concat(weights);
        }
        return weights;
    }
    get weights() {
        return this.trainableWeights.concat(this.nonTrainableWeights);
    }
    /**
     * Loads all layer weights from a JSON object.
     *
     * Porting Note: HDF5 weight files cannot be directly loaded in JavaScript /
     *   TypeScript. The utility script at `scripts/pykeras.py` offers means
     *   to convert them into JSON strings compatible with this method.
     * Porting Note: TensorFlow.js Layers supports only loading by name currently.
     *
     * @param weights A JSON mapping weight names to weight values as nested
     *   arrays of numbers, or a `NamedTensorMap`, i.e., a JSON mapping weight
     *   names to `tf.Tensor` objects.
     * @param strict Require that the provided weights exactly match those
     *   required by the container.  Default: `true`.  Passing `false` means that
     *   extra weights and missing weights will be silently ignored.
     */ loadWeights(weights, strict = true) {
        const nameToWeight = {};
        let totalWeightsCount = 0;
        for (const layer of this.layers)for (const weight of layer.weights){
            if (nameToWeight[weight.originalName] != null) throw new (0, $jVuYK.ValueError)(`Duplicate weight name: ${weight.originalName}`);
            nameToWeight[weight.originalName] = weight;
            totalWeightsCount++;
        }
        const weightValueTuples = [];
        for(const name in weights){
            // TF 2.2.0 added cell name to the weight name in the format of
            // layer_name/cell_name/weight_name, we need to remove
            // the inner cell name.
            let validatedName = name;
            if (nameToWeight[name] == null) {
                const tokens = name.split('/');
                const shortenNameArray = tokens.slice(0, -2).concat([
                    tokens[tokens.length - 1]
                ]);
                validatedName = shortenNameArray.join('/');
            }
            if (nameToWeight[validatedName] != null) weightValueTuples.push([
                nameToWeight[validatedName],
                weights[name]
            ]);
            else if (strict) throw new (0, $jVuYK.ValueError)(`Provided weight data has no target variable: ${name}`);
            delete nameToWeight[validatedName];
        }
        if (strict) {
            // Check that all weights are set.
            const unsetNames = [];
            for(const name in nameToWeight)unsetNames.push(name);
            if (unsetNames.length > 0) throw new (0, $jVuYK.ValueError)(`${unsetNames.length} of ${totalWeightsCount} weights are not set: ` + `${unsetNames}`);
        }
        (0, $7muWV.batchSetValue)(weightValueTuples);
    }
    /**
     * Util shared between different serialization methods.
     * @returns LayersModel config with Keras version information added.
     */ updatedConfig() {
        const theConfig = this.getConfig();
        const modelConfig = {};
        modelConfig['className'] = this.getClassName();
        modelConfig['config'] = theConfig;
        modelConfig['kerasVersion'] = `tfjs-layers ${0, $3lFvz.version}`;
        // TODO(nielsene): Replace something like K.backend() once
        // possible.
        modelConfig['backend'] = 'TensorFlow.js';
        return modelConfig;
    }
    /**
     * Returns a JSON string containing the network configuration.
     *
     * To load a network from a JSON save file, use
     * models.modelFromJSON(jsonString);
     * @param extraJsonArgs Unused in tfjs-layers, maintained for PyKeras
     * @param returnString Whether the return value should be stringified
     *    (default: `true`).
     * @returns a JSON string if `returnString` (default), or a JSON object if
     *   `!returnString`.
     */ // tslint:disable-next-line:no-any
    toJSON(unused, returnString = true) {
        const modelConfig = (0, $4UVDw.convertTsToPythonic)(this.updatedConfig());
        return returnString ? JSON.stringify(modelConfig) : modelConfig;
    }
    /**
     * Call the model on new inputs.
     *
     * In this case `call` just reapplies all ops in the graph to the new inputs
     * (e.g. build a new computational graph from the provided inputs).
     *
     * @param inputs A tensor or list of tensors.
     * @param mask A mask or list of masks. A mask can be either a tensor or null
     *   (no mask).
     *
     * @return A tensor if there is a single output, or a list of tensors if there
     *   are more than one outputs.
     */ call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            inputs = $khD6O.toList(inputs);
            const feedDict = new (0, $ButqI.FeedDict)();
            for(let i = 0; i < this.inputs.length; ++i)feedDict.add(this.inputs[i], inputs[i]);
            return (0, $ButqI.execute)(this.outputs, feedDict, kwargs);
        });
    }
    /**
     * Computes an output mask tensor.
     *
     * @param inputs Tensor or list of tensors.
     * @param mask Tensor or list of tensors.
     *
     * @return null or a tensor (or list of tensors, one per output tensor of the
     * layer).
     */ computeMask(inputs, mask) {
        return (0, $9c0Qr.tidy)(()=>{
            inputs = $khD6O.toList(inputs);
            let masks;
            if (mask == null) masks = $khD6O.pyListRepeat(null, inputs.length);
            else masks = $khD6O.toList(mask);
            // TODO(michaelterry): Add support for mask caching.
            return this.runInternalGraph(inputs, masks)[1];
        });
    }
    /**
     * Computes the output shape of the layer.
     *
     * Assumes that the layer will be built to match that input shape provided.
     *
     * @param inputShape A shape (tuple of integers) or a list of shape tuples
     *   (one per output tensor of the layer). Shape tuples can include null for
     *   free dimensions, instead of an integer.
     */ computeOutputShape(inputShape) {
        const inputShapes = $5sw3q.normalizeShapeList(inputShape);
        if (inputShapes.length !== this.inputLayers.length) throw new (0, $jVuYK.ValueError)(`Invalid inputShape argument ${inputShape}: ` + `model has ${this.inputLayers.length} tensor inputs.`);
        // TODO(michaelterry): Add caching
        const layersToOutputShapes = {};
        for(let i = 0; i < inputShapes.length; i++){
            const layer = this.inputLayers[i];
            const inputShape = inputShapes[i];
            // It's an input layer: computeOutputShape is identity,
            // and there is only one node and one tensor output.
            const shapeKey = layer.name + '_0_0';
            layersToOutputShapes[shapeKey] = inputShape;
        }
        const depthKeys = Object.keys(this.nodesByDepth).map((x)=>parseInt(x, 10)).sort($khD6O.reverseNumberCompare);
        // Iterate over nodes, by depth level.
        if (depthKeys.length > 1) for (const depth of depthKeys){
            const nodes = this.nodesByDepth[depth];
            for (const node of nodes){
                // This is always a single layer, never a list.
                const layer = node.outboundLayer;
                if (this.inputLayers.map((x)=>x.id).indexOf(layer.id) !== -1) continue;
                // Potentially redundant list, same size of node.inputTensors.
                const inputShapes = [];
                for(let j = 0; j < node.inboundLayers.length; j++){
                    const inboundLayer = node.inboundLayers[j];
                    const nodeIndex = node.nodeIndices[j];
                    const tensorIndex = node.tensorIndices[j];
                    const shapeKey = `${inboundLayer.name}_${nodeIndex}_${tensorIndex}`;
                    const inputShape = layersToOutputShapes[shapeKey];
                    inputShapes.push(inputShape);
                }
                const outputShape = layer.computeOutputShape($khD6O.singletonOrArray(inputShapes));
                const outputShapes = $5sw3q.normalizeShapeList(outputShape);
                const nodeIndex = layer.inboundNodes.indexOf(node);
                for(let j = 0; j < outputShapes.length; j++){
                    const shapeKey = `${layer.name}_${nodeIndex}_${j}`;
                    layersToOutputShapes[shapeKey] = outputShapes[j];
                }
            }
        }
        // Read final output shapes from layersToOutputShapes.
        const outputShapes = [];
        const outputShapeKeys = [];
        for(let i = 0; i < this.outputLayers.length; i++){
            const layer = this.outputLayers[i];
            const nodeIndex = this.outputLayersNodeIndices[i];
            const tensorIndex = this.outputLayersTensorIndices[i];
            const shapeKey = `${layer.name}_${nodeIndex}_${tensorIndex}`;
            outputShapeKeys.push(shapeKey);
        }
        for(let i = 0; i < outputShapeKeys.length; i++){
            const key = outputShapeKeys[i];
            $khD6O.assert(key in layersToOutputShapes);
            outputShapes.push(layersToOutputShapes[key]);
        }
        // TODO(michaelterry): Update cache
        return $khD6O.singletonOrArray(outputShapes);
    }
    /**
     * Computes output tensors for new inputs.
     *
     * Note:
     *   - Expects `inputs` to be a list (potentially with 1 element).
     *
     * @param inputs List of tensors
     * @param masks List of masks (tensors or null).
     * @return Three lists: outputTensors, outputMasks, outputShapes
     */ runInternalGraph(inputs, masks) {
        if (masks == null) masks = $khD6O.pyListRepeat(null, inputs.length);
        // Dictionary mapping reference tensors to tuples
        // (computed tensor, compute mask)
        // we assume a 1:1 mapping from tensor to mask
        // TODO: raise exception when a `.computeMask()` call
        // does not return a list the same size as `call`
        const tensorMap = {};
        for(let i = 0; i < this.inputs.length; ++i){
            const x = this.inputs[i];
            const y = inputs[i];
            const mask = masks[i];
            tensorMap[x.id] = [
                y,
                mask
            ];
        }
        const depthKeys = Object.keys(this.nodesByDepth).map((x)=>parseInt(x, 10)).sort($khD6O.reverseNumberCompare);
        for (const depth of depthKeys){
            const nodes = this.nodesByDepth[depth];
            for (const node of nodes){
                // This is always a single layer, never a list.
                const layer = node.outboundLayer;
                const referenceInputTensors = node.inputTensors;
                const referenceOutputTensors = node.outputTensors;
                // If all previous input tensors are available in tensorMap,
                // then call node.inboundLayer on them.
                // List of tuples [input, mask]:
                const computedData = new Array();
                for (const x of referenceInputTensors)if (x.id in tensorMap) computedData.push(tensorMap[x.id]);
                if (computedData.length === referenceInputTensors.length) {
                    // TODO(michaelterry): Add K.name_scope here, if we need it.
                    let kwargs = {};
                    let computedTensors;
                    let computedMasks;
                    let outputTensors;
                    let outputMasks;
                    // call layer
                    if (node.callArgs != null) kwargs = node.callArgs;
                    if (computedData.length === 1) {
                        const [computedTensor, computedMask] = computedData[0];
                        if (kwargs['mask'] == null) kwargs['mask'] = computedMask;
                        outputTensors = $khD6O.toList(layer.call(computedTensor, kwargs));
                        outputMasks = $khD6O.toList(layer.computeMask(computedTensor, computedMask));
                        computedTensors = [
                            computedTensor
                        ];
                        computedMasks = [
                            computedMask
                        ];
                    } else {
                        computedTensors = computedData.map((x)=>x[0]);
                        computedMasks = computedData.map((x)=>x[1]);
                        if (kwargs['mask'] == null) kwargs['mask'] = computedMasks;
                        outputTensors = $khD6O.toList(layer.call(computedTensors, kwargs));
                        outputMasks = $khD6O.toList(layer.computeMask(computedTensors, computedMasks));
                    }
                    if (layer.activityRegularizer) throw new (0, $jVuYK.NotImplementedError)("LayersModel invocation with concrete Tensor value(s) in the presence of activity regularizer(s) is not supported yet.");
                    // TODO(michaelterry): Add model updates and losses
                    // Update tensor map.
                    for(let i = 0; i < referenceOutputTensors.length; ++i){
                        const x = referenceOutputTensors[i];
                        const y = outputTensors[i];
                        const mask = outputMasks[i];
                        tensorMap[x.id] = [
                            y,
                            mask
                        ];
                    }
                }
            }
        }
        const outputTensors = [];
        const outputMasks = [];
        const outputShapes = [];
        for (const x of this.outputs){
            $khD6O.assert(x.id in tensorMap, `Could not compute output ${x.name} : ${x.id}`);
            const [tensor, mask] = tensorMap[x.id];
            outputShapes.push(tensor.shape);
            outputTensors.push(tensor);
            outputMasks.push(mask);
        }
        // TODO(michaelterry): Add support for caches.
        return [
            outputTensors,
            outputMasks,
            outputShapes
        ];
    }
    /**
     * Builds a map of internal node keys to node ordering.
     * Used in serializaion a node orderings may change as unused nodes are
     * dropped. Porting Note:  This helper method was pulled out of getConfig to
     * improve readability.
     * @param layers An array of Layers in the model.
     * @returns Map of Node Keys to index order within the layer.
     */ buildNodeConversionMap(layers) {
        const nodeConversionMap = {};
        let keptNodes;
        for (const layer of this.layers){
            keptNodes = layer instanceof $9c19c6594b298ee0$export$42a852a2b6b56249 ? 1 : 0;
            for(let originalNodeIndex = 0; originalNodeIndex < layer.inboundNodes.length; originalNodeIndex++){
                const nodeKey = $9c19c6594b298ee0$export$42a852a2b6b56249.nodeKey(layer, originalNodeIndex);
                if (this.containerNodes.has(nodeKey)) {
                    // i.e. we mark it to be saved
                    nodeConversionMap[nodeKey] = keptNodes;
                    keptNodes += 1;
                }
            }
        }
        return nodeConversionMap;
    }
    /**
     * Retrieves a layer based on either its name (unique) or index.
     *
     * Indices are based on order of horizontal graph traversal (bottom-up).
     *
     * If both `name` and `index` are specified, `index` takes precedence.
     *
     * @param name Name of layer.
     * @param index Index of layer.
     * @returns A Layer instance.
     * @throws ValueError: In case of invalid layer name or index.
     *
     * @doc {
     *    heading: 'Layers',
     *    subheading: 'Classes',
     *    namespace: 'layers',
     *    subclasses: ['LayersModel']
     * }
     */ getLayer(name, index) {
        if (index != null) {
            if (this.layers.length <= index) throw new (0, $jVuYK.ValueError)(`Was asked to retrieve layer at index ${index}, but model only ` + `has ${this.layers.length} layer(s).`);
            else return this.layers[index];
        } else {
            if (name == null) throw new (0, $jVuYK.ValueError)('Provide either a layer name or layer index');
        }
        for (const layer of this.layers){
            if (layer.name === name) return layer;
        }
        throw new (0, $jVuYK.ValueError)(`No such layer: ${name}`);
    }
    /**
     * Retrieves the Container's current loss values.
     *
     * Used for regularizers during training.
     */ calculateLosses() {
        // Porting Node: This is an augmentation to Container.loss in PyKeras.
        //   In PyKeras, Container.loss returns symbolic tensors. Here a concrete
        //   Tensor (specifically Scalar) values are returned. This is due to the
        //   imperative backend.
        return (0, $9c0Qr.tidy)(()=>{
            const losses = [];
            for (const layer of this.layers)for(let nodeIndex = 0; nodeIndex < layer.inboundNodes.length; ++nodeIndex){
                const nodeKey = $9c19c6594b298ee0$export$42a852a2b6b56249.nodeKey(layer, nodeIndex);
                if (this.containerNodes.has(nodeKey)) losses.push(...layer.calculateLosses());
            }
            // TODO(cais): Add any unconditional model-level losses?
            return losses;
        });
    }
    getConfig() {
        const config = {
            name: this.name
        };
        // Build a map from layer unique name (self._node_key)
        // to the index of the nodes that are saved in the config.
        // Only nodes in container_nodes are saved.
        const nodeConversionMap = this.buildNodeConversionMap(this.layers);
        // Serialize and save the layers in layerConfigs
        const layerConfigs = [];
        for (const layer of this.layers){
            const layerClassName = layer.getClassName();
            const layerConfig = layer.getConfig();
            const filteredInboundNodes = [];
            for(let originalNodeIndex = 0; originalNodeIndex < layer.inboundNodes.length; originalNodeIndex++){
                const node = layer.inboundNodes[originalNodeIndex];
                const nodeKey = $9c19c6594b298ee0$export$42a852a2b6b56249.nodeKey(layer, originalNodeIndex);
                let kwargs = {};
                if (this.containerNodes.has(nodeKey)) {
                    // The node is relevant to the model:
                    // add to filteredInboundNodes.
                    if (node.callArgs) try {
                        JSON.stringify(node.callArgs);
                        kwargs = node.callArgs;
                    } catch (err) {
                        console.warn(`Layer ${layer.name} was passed ` + `non-serializable keyword arguments: ` + `${node.callArgs}. They will not be included ` + `in the serialized model (and thus will be ` + `missing at deserialization time).`);
                        kwargs = {};
                    }
                    if (node.inboundLayers.length > 0) {
                        const nodeData = [];
                        for(let i = 0; i < node.inboundLayers.length; i++){
                            const inboundLayer = node.inboundLayers[i];
                            const nodeIndex = node.nodeIndices[i];
                            const tensorIndex = node.tensorIndices[i];
                            const nodeKey = $9c19c6594b298ee0$export$42a852a2b6b56249.nodeKey(inboundLayer, nodeIndex);
                            let newNodeIndex = nodeConversionMap[nodeKey];
                            if (newNodeIndex == null) newNodeIndex = 0;
                            nodeData.push([
                                inboundLayer.name,
                                newNodeIndex,
                                tensorIndex,
                                kwargs
                            ]);
                        }
                        filteredInboundNodes.push(nodeData);
                    }
                }
            }
            const dict = {};
            dict['name'] = layer.name;
            dict['className'] = layerClassName;
            dict['config'] = layerConfig;
            dict['inboundNodes'] = filteredInboundNodes;
            layerConfigs.push(dict);
        }
        config['layers'] = layerConfigs;
        // Gather info about inputs and outputs
        const modelInputs = [];
        for(let i = 0; i < this.inputLayers.length; i++){
            const layer = this.inputLayers[i];
            const nodeIndex = this.inputLayersNodeIndices[i];
            const nodeKey = $9c19c6594b298ee0$export$42a852a2b6b56249.nodeKey(layer, nodeIndex);
            if (!this.containerNodes.has(nodeKey)) continue;
            let newNodeIndex = nodeConversionMap[nodeKey];
            if (newNodeIndex === null || newNodeIndex === undefined) newNodeIndex = 0;
            const tensorIndex = this.inputLayersTensorIndices[i];
            modelInputs.push([
                layer.name,
                newNodeIndex,
                tensorIndex
            ]);
        }
        config['inputLayers'] = modelInputs;
        const modelOutputs = [];
        for(let i = 0; i < this.outputLayers.length; i++){
            const layer = this.outputLayers[i];
            const nodeIndex = this.outputLayersNodeIndices[i];
            const nodeKey = $9c19c6594b298ee0$export$42a852a2b6b56249.nodeKey(layer, nodeIndex);
            if (!this.containerNodes.has(nodeKey)) continue;
            let newNodeIndex = nodeConversionMap[nodeKey];
            if (newNodeIndex === null || newNodeIndex === undefined) newNodeIndex = 0;
            const tensorIndex = this.outputLayersTensorIndices[i];
            modelOutputs.push([
                layer.name,
                newNodeIndex,
                tensorIndex
            ]);
        }
        config['outputLayers'] = modelOutputs;
        return config;
    }
    /**
     * Instantiates a LayersModel from its config (output of `get_config()`).
     * @param cls the class to create
     * @param config LayersModel config dictionary.
     * @param customObjects An optional dictionary of custom objects.
     * @param fastWeightInit Optional flag to use fast weight initialization
     *   during deserialization. This is applicable to cases in which
     *   the initialization will be immediately overwritten by loaded weight
     *   values. Default: `false`.
     * @returns A LayersModel instance.
     * @throws ValueError: In case of improperly formatted config dict.
     */ /** @nocollapse */ static fromConfig(cls, config, customObjects = {}, fastWeightInit = false) {
        // Layer instances created during
        // the graph reconstruction process
        const createdLayers = {};
        // Dictionary mapping layer instances to
        // node data that specifies a layer call.
        // It acts as a queue that maintains any unprocessed
        // layer call until it becomes possible to process it
        // (i.e. until the input tensors to the call all exist).
        const unprocessedNodes = {};
        function addUnprocessedNode(layer, nodeData) {
            if (!(layer.name in unprocessedNodes)) unprocessedNodes[layer.name] = [
                nodeData
            ];
            else unprocessedNodes[layer.name].push(nodeData);
        }
        function processNode(layer, nodeData) {
            const inputTensors = [];
            let kwargs;
            for (const inputData of nodeData){
                const inboundLayerName = inputData[0];
                const inboundNodeIndex = inputData[1];
                const inboundTensorIndex = inputData[2];
                kwargs = inputData[3] == null ? {} : inputData[3];
                if (!(inboundLayerName in createdLayers)) {
                    addUnprocessedNode(layer, nodeData);
                    return;
                }
                const inboundLayer = createdLayers[inboundLayerName];
                if (inboundLayer.inboundNodes.length <= inboundNodeIndex) {
                    addUnprocessedNode(layer, nodeData);
                    return;
                }
                const inboundNode = inboundLayer.inboundNodes[inboundNodeIndex];
                inputTensors.push(inboundNode.outputTensors[inboundTensorIndex]);
            }
            // Call layer on its inputs, thus creating the node
            // and building the layer if needed.
            // Note: This has Eager vs Graph Implications.
            if (inputTensors.length > 0) layer.apply($khD6O.singletonOrArray(inputTensors), kwargs); // was ** kwargs
        }
        /**
         * Deserialize a layer, then call it on appropriate inputs.
         * @param layerData: layer config dict.
         * @throws ValueError: In case of improperly formatted `layer_data`
         * dict.
         */ function processLayer(layerData) {
            const layerName = layerData['name'];
            // Instantiate layer.
            const layer = (0, $dttI1.deserialize)(layerData, config['customObjects'] != null ? config['customObjects'] : {});
            layer.setFastWeightInitDuringBuild(fastWeightInit);
            createdLayers[layerName] = layer;
            // Gather layer inputs.
            const inboundNodesData = layerData['inboundNodes'];
            inboundNodesData.forEach((nodeData)=>{
                if (!(nodeData instanceof Array)) throw new (0, $jVuYK.ValueError)(`Corrupted configuration, expected array for nodeData: ${nodeData}`);
                // We don't process nodes (i.e. make layer calls)
                // on the fly because the inbound node may not yet exist,
                // in case of layer shared at different topological depths
                // (e.g.a model such as A(B(A(B(x)))))
                addUnprocessedNode(layer, nodeData);
            });
        }
        // First, we create all layers and enqueue nodes to be processed.
        const name = config['name'];
        const layersFromConfig = config['layers'];
        for (const layerData of layersFromConfig)processLayer(layerData);
        // Then we process nodes in order of layer depth.
        // Nodes that cannot yet be processed(if the inbound node
        // does not yet exist) are re - enqueued, and the process
        // is repeated until all nodes are processed.
        while(!$khD6O.isObjectEmpty(unprocessedNodes))for (const layerData of layersFromConfig){
            const layer = createdLayers[layerData['name']];
            if (layer.name in unprocessedNodes) {
                const currentUnprocessedNodesForLayer = unprocessedNodes[layer.name];
                delete unprocessedNodes[layer.name];
                for (const nodeData of currentUnprocessedNodesForLayer)processNode(layer, nodeData);
            }
        }
        const inputTensors = [];
        const outputTensors = [];
        const inputLayersFromConfig = config['inputLayers'];
        for (const layerData of inputLayersFromConfig){
            const layerName = layerData[0];
            const nodeIndex = layerData[1];
            const tensorIndex = layerData[2];
            $khD6O.assert(layerName in createdLayers);
            const layer = createdLayers[layerName];
            const layerOutputTensors = layer.inboundNodes[nodeIndex].outputTensors;
            inputTensors.push(layerOutputTensors[tensorIndex]);
        }
        const outputLayersFromConfig = config['outputLayers'];
        for (const layerData of outputLayersFromConfig){
            const layerName = layerData[0];
            const nodeIndex = layerData[1];
            const tensorIndex = layerData[2];
            $khD6O.assert(layerName in createdLayers);
            const layer = createdLayers[layerName];
            const layerOutputTensors = layer.inboundNodes[nodeIndex].outputTensors;
            outputTensors.push(layerOutputTensors[tensorIndex]);
        }
        return new cls({
            inputs: inputTensors,
            outputs: outputTensors,
            name: name
        });
    }
    /**
     * Determine whether the container is stateful.
     *
     * Porting Note: this is the equivalent of the stateful @property of
     *   the Container class in PyKeras.
     */ get stateful() {
        // Porting Note: This check is to prevent inadvertent setting of the
        //   _stateful property of the Container instance.
        if (this._stateful) throw new (0, $jVuYK.ValueError)("Container instance unexpectedly has _stateful = true. The statefulness of a Container is determined by the Layers it contains. Its _stateful property must remain the default false.");
        for (const layer of this.layers){
            if (layer.stateful) return true;
        }
        return false;
    }
    /**
     * Reset the state of all stateful constituent layers (if any).
     *
     * Examples of stateful layers include RNN layers whose `stateful` property
     * is set as `true`.
     */ resetStates() {
        (0, $9c0Qr.tidy)(()=>{
            this.layers.forEach((layer)=>{
                // tslint:disable:no-any
                if (layer.stateful) layer.resetStates();
            // tslint:enable:no-any
            });
        });
    }
}

});

parcelRegister("imQP2", function(module, exports) {

$parcel$export(module.exports, "fitDataset", () => $d5f341793ae44996$export$4e883c052383550c);
$parcel$export(module.exports, "evaluateDataset", () => $d5f341793ae44996$export$56e284faddc3ba42);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Interfaces and methods for training models using TensorFlow.js datasets.
 */ parcelRequire("5n9DG");
var $1ZrG5 = parcelRequire("1ZrG5");
var $9c0Qr = parcelRequire("9c0Qr");
var $gjFWY = parcelRequire("gjFWY");
var $r7fN6 = parcelRequire("r7fN6");
var $j7yUF = parcelRequire("j7yUF");
var $bVnU9 = parcelRequire("bVnU9");
var $wx9lK = parcelRequire("wx9lK");

var $9fe8M = parcelRequire("9fe8M");

var $jVuYK = parcelRequire("jVuYK");

var $7EFWn = parcelRequire("7EFWn");

var $khD6O = parcelRequire("khD6O");

var $lKolL = parcelRequire("lKolL");
// Default batch size used during tensor-based validation.
const $d5f341793ae44996$var$DEFAULT_VALIDATION_BATCH_SIZE = 32;
/**
 * Standardize the output of a dataset iterator for use by
 * LayersModel.fitDataset().
 *
 * @param model: A `tf.LayersModel` object.
 * @param iteratorOut The output of a dataset iterator. It is required to be
 *   an object of the form `{xs: TensorOrArrayOrMap, ys:
 * TensorOrArrayOrMap}`, where `TensorOrArrayOrMap` is a single `tf.Tensor`,
 * a `tf.Tensor[]`, or a flat map from string names to `tf.Tensor`s.
 * @returns A flat array of `tf.Tensor` objects: the input `tf.Tensor`s
 *   followed by the target `tf.Tensor`s.  When `tf.Tensor`s are provided
 *   as a map, the order in the resulting array is taken from the `inputNames`
 *   and `outputNames` of the model.
 */ function $d5f341793ae44996$var$standardizeDataIteratorOutput(// Type `model` as `any` here to avoid circular dependency w/
// training.ts.
// tslint:disable-next-line:no-any
model, iteratorOut) {
    let xs;
    let ys;
    const iteratorOutObj = iteratorOut;
    xs = iteratorOutObj['xs'];
    ys = iteratorOutObj['ys'];
    $wx9lK.assert(xs != null && ys != null, ()=>"A Dataset iterator for fitDataset() is expected to generate objects of the form `{xs: xVal, ys: yVal}`, where the two values may be `tf.Tensor`, an array of Tensors, or a map of string to Tensor.  The provided Dataset instead generates " + `${iteratorOut}`);
    const flattenedXs = $d5f341793ae44996$var$flattenTensorOrArrayOrMap('input', model.inputNames, xs);
    const flattenedYs = $d5f341793ae44996$var$flattenTensorOrArrayOrMap('output', model.outputNames, ys);
    const batchSize = flattenedXs[0].shape[0];
    $wx9lK.assert(flattenedXs.length === model.inputs.length, ()=>`LayersModel has ${model.inputs.length} inputs, but the dataset ` + `provides ${flattenedXs.length} inputs.  (Expected input keys: ` + `${JSON.stringify(model.inputNames)})`);
    $wx9lK.assert(flattenedYs.length === model.outputs.length, ()=>`LayersModel has ${model.outputs.length} outputs, but the dataset ` + `provides ${flattenedYs.length} outputs.  (Expected output keys: ` + `${JSON.stringify(model.outputNames)})`);
    for(let xIndex = 0; xIndex < flattenedXs.length; xIndex++)$wx9lK.assert(flattenedXs[xIndex].shape[0] === batchSize, ()=>`Batch size mismatch: input ` + `${model.inputNames[xIndex]} has ${flattenedXs[xIndex].shape[0]}; ` + `expected  ${batchSize} based on input ${model.inputNames[0]}.`);
    for(let yIndex = 0; yIndex < flattenedYs.length; yIndex++)$wx9lK.assert(flattenedYs[yIndex].shape[0] === batchSize, ()=>`Batch size mismatch: output ` + `${model.outputNames[yIndex]} has ${flattenedYs[yIndex].shape[0]}; ` + `expected  ${batchSize} based on input ${model.inputNames[0]}.`);
    return {
        xs: flattenedXs,
        ys: flattenedYs
    };
}
function $d5f341793ae44996$var$flattenTensorOrArrayOrMap(inputOrOutput, names, values) {
    if (values instanceof $bVnU9.Tensor) return [
        values
    ];
    else if (Array.isArray(values)) {
        $wx9lK.assert(values.length === names.length, ()=>`Received an array of ${values.length} Tensors, but expected ${names.length} to match the ${inputOrOutput} keys ${names}.`);
        return values;
    } else {
        const result = [];
        // Check that all the required keys are available.
        for (const name of names){
            if (values[name] == null) throw new (0, $jVuYK.ValueError)(`The feature data generated by the dataset lacks the required ` + `${inputOrOutput} key '${name}'.`);
            result.push(values[name]);
        }
        return result;
    }
}
function $d5f341793ae44996$var$standardizeTensorValidationData(data) {
    if (data.length === 3) throw new (0, $jVuYK.NotImplementedError)('Validation with sample weights is not implemented yet.');
    return {
        xs: data[0],
        ys: data[1]
    };
}
async function $d5f341793ae44996$export$4e883c052383550c(// Type `model` as `any` here to avoid circular dependency w/
// training.ts.
// tslint:disable-next-line:no-any
model, dataset, args) {
    const hasBatchesPerEpoch = args.batchesPerEpoch != null;
    $wx9lK.assert(model.optimizer != null, ()=>"You must compile a model before training/testing. Use LayersModel.compile(modelCompileConfig).");
    $wx9lK.assert(args != null, ()=>`For fitDataset(), the 2nd argument (config) is required, ` + `but it is not provided in this call.`);
    $wx9lK.assert(args.epochs != null && args.epochs > 0 && Number.isInteger(args.epochs), ()=>`For fitDataset(), config.epochs is expected to be a positive ` + `integer, but got ${args.epochs}`);
    $wx9lK.assert(!hasBatchesPerEpoch || args.batchesPerEpoch > 0 && Number.isInteger(args.batchesPerEpoch), ()=>`For fitDataset(), config.batchesPerEpoch is expected to be a ` + `positive integer if specified, but got ${args.batchesPerEpoch}`);
    $wx9lK.assert(// tslint:disable-next-line:no-any
    args['validationSplit'] == null, ()=>"`validationSplit` is not supported by `fitDataset()`. Use validationData instead.");
    if (model.isTraining) throw new Error('Cannot start training because another fit() call is ongoing.');
    model.isTraining = true;
    try {
        const doValidation = args.validationData != null;
        let valXs;
        let valYs;
        if (doValidation) {
            if ($d5f341793ae44996$var$isDatasetObject(args.validationData)) $wx9lK.assert(args.validationBatches == null || args.validationBatches > 0 && Number.isInteger(args.validationBatches), ()=>`For fitDataset() with dataset-based validation, ` + `config.validationBatches is expected not to be provided, ` + `or to be a positive integer, ` + `but got ${args.validationBatches}`);
            else {
                const validationData = $d5f341793ae44996$var$standardizeTensorValidationData(args.validationData);
                valXs = validationData.xs;
                valYs = validationData.ys;
            }
        }
        const trainFunction = model.makeTrainFunction();
        const outLabels = model.getDedupedMetricsNames();
        let callbackMetrics;
        if (doValidation) callbackMetrics = outLabels.slice().concat(outLabels.map((n)=>'val_' + n));
        else callbackMetrics = outLabels.slice();
        const callbacks = (0, $9fe8M.standardizeCallbacks)(args.callbacks, args.yieldEvery);
        const verbose = args.verbose == null ? 1 : args.verbose;
        const { callbackList: callbackList, history: history } = (0, $9fe8M.configureCallbacks)(callbacks, verbose, args.epochs, null, null, $d5f341793ae44996$var$getStepsPerEpoch(dataset, args), null, doValidation, callbackMetrics);
        callbackList.setModel(model);
        model.history = history;
        await callbackList.onTrainBegin();
        model.stopTraining_ = false;
        let epoch = args.initialEpoch == null ? 0 : args.initialEpoch;
        let dataIterator = await dataset.iterator();
        while(epoch < args.epochs){
            const epochLogs = {};
            await callbackList.onEpochBegin(epoch);
            let stepsDone = 0;
            let batchIndex = 0;
            if (!hasBatchesPerEpoch) dataIterator = await dataset.iterator();
            while(hasBatchesPerEpoch ? stepsDone < args.batchesPerEpoch : true){
                const iteratorOut = await dataIterator.next();
                // If `batchesPerEpoch` is specified, the dataset should not be
                // exhausted until all epoches are done.
                if (hasBatchesPerEpoch && iteratorOut.done) {
                    console.warn('You provided `batchesPerEpoch` as ' + `${args.batchesPerEpoch}, ` + 'but your dataset iterator ran out of data after ' + `${stepsDone} batches; ` + 'interrupting training. Make sure that your ' + 'dataset can generate at least `batchesPerEpoch * epochs` ' + 'batches (in this case, ' + `${args.batchesPerEpoch * args.epochs} batches). ` + 'You may need to use the repeat() function when building ' + 'your dataset.');
                    break;
                }
                if (iteratorOut.value != null) {
                    const { xs: xs, ys: ys } = $d5f341793ae44996$var$standardizeDataIteratorOutput(model, iteratorOut.value);
                    const batchLogs = {};
                    batchLogs['batch'] = batchIndex;
                    batchLogs['size'] = xs[0].shape[0];
                    await callbackList.onBatchBegin(batchIndex, batchLogs);
                    const sampleWeights = [];
                    if (args.classWeight != null) {
                        const standardClassWeights = (0, $lKolL.standardizeClassWeights)(args.classWeight, model.outputNames);
                        for(let i = 0; i < standardClassWeights.length; ++i)sampleWeights.push(await (0, $lKolL.standardizeWeights)(ys[i], null, standardClassWeights[i]));
                    }
                    // Train on batch.
                    const ins = xs.concat(ys).concat(sampleWeights);
                    const outs = trainFunction(ins);
                    $9c0Qr.dispose(ins);
                    for(let i = 0; i < outLabels.length; ++i){
                        const label = outLabels[i];
                        const out = outs[i];
                        batchLogs[label] = out;
                        $9c0Qr.keep(out);
                    }
                    await callbackList.onBatchEnd(batchIndex, batchLogs);
                    (0, $7EFWn.disposeTensorsInLogs)(batchLogs);
                    batchIndex++;
                    stepsDone++;
                }
                if (hasBatchesPerEpoch ? stepsDone >= args.batchesPerEpoch : iteratorOut.done) {
                    // Epoch finished. Perform validation.
                    if (doValidation) {
                        let valOuts;
                        if ($d5f341793ae44996$var$isDatasetObject(args.validationData)) valOuts = (0, $khD6O.toList)(await model.evaluateDataset(args.validationData, {
                            batches: args.validationBatches
                        }));
                        else valOuts = (0, $khD6O.toList)(model.evaluate(valXs, valYs, {
                            batchSize: args.validationBatchSize == null ? $d5f341793ae44996$var$DEFAULT_VALIDATION_BATCH_SIZE : args.validationBatchSize,
                            verbose: 0
                        }));
                        for(let i = 0; i < model.metricsNames.length; ++i)epochLogs[`val_${model.metricsNames[i]}`] = valOuts[i];
                    }
                    break;
                }
                if (model.stopTraining_) break;
            }
            await callbackList.onEpochEnd(epoch, epochLogs);
            epoch++;
            if (model.stopTraining_) break;
        }
        await callbackList.onTrainEnd();
        await model.history.syncData();
        return model.history;
    } finally{
        model.isTraining = false;
    }
}
/** Helper function that determines number of steps (batches) per epoch. */ function $d5f341793ae44996$var$getStepsPerEpoch(dataset, args) {
    // Attempt to determine # of batches in an epoch.
    let stepsPerEpoch = null;
    if (args.batchesPerEpoch != null) stepsPerEpoch = args.batchesPerEpoch;
    else if (Number.isFinite(dataset.size)) stepsPerEpoch = dataset.size;
    return stepsPerEpoch;
}
// Check if provided object is a Dataset object by checking its .iterator
// element.
function $d5f341793ae44996$var$isDatasetObject(dataset) {
    return typeof dataset.iterator === 'function';
}
// Check if provided object is a LazyIterator object by checking it's .next
// element.
function $d5f341793ae44996$var$isLazyIteratorObject(iterator) {
    return typeof iterator.next === 'function';
}
async function $d5f341793ae44996$export$56e284faddc3ba42(// Type `model` as `any` here to avoid circular dependency w/
// training.ts.
// tslint:disable-next-line:no-any
model, dataset, args) {
    args = args || {};
    const hasBatches = args.batches != null;
    const f = model.testFunction;
    let outs = [];
    if (args.verbose > 0) throw new (0, $jVuYK.NotImplementedError)('Verbose mode is not implemented yet.');
    $wx9lK.assert(!hasBatches || args.batches > 0 && Number.isInteger(args.batches), ()=>'Test loop expects `batches` to be a positive integer, but ' + `received ${JSON.stringify(args.batches)}`);
    const dataIterator = $d5f341793ae44996$var$isLazyIteratorObject(dataset) ? dataset : await dataset.iterator();
    // Keeps track of number of examples used in this evaluation.
    let numExamples = 0;
    let batch = 0;
    while(hasBatches ? batch < args.batches : true){
        const iteratorOut = await dataIterator.next();
        outs = $9c0Qr.tidy(()=>{
            if (iteratorOut.value) {
                // TODO(cais): Once real dataset is available, use
                //   `map(x => standardizeDataIteratorOutput(model, x).map(f)`.
                const { xs: xs, ys: ys } = $d5f341793ae44996$var$standardizeDataIteratorOutput(model, iteratorOut.value);
                const xsAndYs = xs.concat(ys);
                const batchOuts = $9c0Qr.tidy(()=>f(xsAndYs));
                $9c0Qr.dispose(xsAndYs);
                if (batch === 0) for(let i = 0; i < batchOuts.length; ++i)outs.push((0, $j7yUF.scalar)(0));
                const batchSize = xsAndYs[0].shape[0];
                for(let i = 0; i < batchOuts.length; ++i){
                    const batchOut = batchOuts[i];
                    const oldScalar = outs[i];
                    outs[i] = $9c0Qr.tidy(()=>$1ZrG5.add(outs[i], $r7fN6.mul(batchSize, batchOut)));
                    if (batch > 0) $9c0Qr.dispose(oldScalar);
                }
                $9c0Qr.dispose(batchOuts);
                numExamples += batchSize;
                ++batch;
            }
            return outs;
        });
        if (iteratorOut.done) {
            if (hasBatches) console.warn("Your dataset iterator ran out of data during evaluateDataset(). Interrupting evalution. Make sure that your dataset can generate at least `batches` " + `batches (in this case, ${args.batches} batches). ` + 'You may need to use the repeat() function when building ' + 'your dataset.');
            break;
        }
    }
    for(let i = 0; i < outs.length; ++i){
        const oldScalar = outs[i];
        outs[i] = $gjFWY.div(outs[i], numExamples);
        $9c0Qr.dispose(oldScalar);
    }
    return (0, $khD6O.singletonOrArray)(outs);
}

});
parcelRegister("lKolL", function(module, exports) {

$parcel$export(module.exports, "standardizeClassWeights", () => $fd50c83caeb9d461$export$9122f8f77cba9cbe);
$parcel$export(module.exports, "standardizeWeights", () => $fd50c83caeb9d461$export$cecca6094cb0d869);
$parcel$export(module.exports, "computeWeightedLoss", () => $fd50c83caeb9d461$export$23bdc4cea2e28782);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $iFZ6U = parcelRequire("iFZ6U");
var $dnFj7 = parcelRequire("dnFj7");
var $9c0Qr = parcelRequire("9c0Qr");
var $r7fN6 = parcelRequire("r7fN6");
var $eP0pM = parcelRequire("eP0pM");
var $jIDgY = parcelRequire("jIDgY");
function $fd50c83caeb9d461$var$standardizeSampleOrClassWeights(xWeight, outputNames, weightType) {
    const numOutputs = outputNames.length;
    if (xWeight == null || Array.isArray(xWeight) && xWeight.length === 0) return outputNames.map((name)=>null);
    if (numOutputs === 1) {
        if (Array.isArray(xWeight) && xWeight.length === 1) return xWeight;
        else if (typeof xWeight === 'object' && outputNames[0] in xWeight) return [
            xWeight[outputNames[0]]
        ];
        else return [
            xWeight
        ];
    }
    if (Array.isArray(xWeight)) {
        if (xWeight.length !== numOutputs) throw new Error(`Provided ${weightType} is an array of ${xWeight.length} ` + `element(s), but the model has ${numOutputs} outputs. ` + `Make sure a set of weights is provided for each model output.`);
        return xWeight;
    } else if (typeof xWeight === 'object' && Object.keys(xWeight).length > 0 && typeof xWeight[Object.keys(xWeight)[0]] === 'object') {
        const output = [];
        outputNames.forEach((outputName)=>{
            if (outputName in xWeight) output.push(xWeight[outputName]);
            else output.push(null);
        });
        return output;
    } else throw new Error(`The model has multiple (${numOutputs}) outputs, ` + `so ${weightType} must be either an array with ` + `${numOutputs} elements or an object with ${outputNames} keys. ` + `Provided ${weightType} not understood: ${JSON.stringify(xWeight)}`);
}
function $fd50c83caeb9d461$export$9122f8f77cba9cbe(classWeight, outputNames) {
    return $fd50c83caeb9d461$var$standardizeSampleOrClassWeights(classWeight, outputNames, 'classWeight');
}
function $fd50c83caeb9d461$export$bcbbad49dddf28d(classWeight, outputNames) {
    return $fd50c83caeb9d461$var$standardizeSampleOrClassWeights(classWeight, outputNames, 'sampleWeight');
}
async function $fd50c83caeb9d461$export$cecca6094cb0d869(y, sampleWeight, classWeight, sampleWeightMode) {
    if (sampleWeight != null || sampleWeightMode != null) // TODO(cais): Once 'temporal' mode is implemented, document it in the doc
    // string.
    throw new Error('Support sampleWeight is not implemented yet');
    if (classWeight != null) {
        // Apply class weights per sample.
        const yClasses = (0, $9c0Qr.tidy)(()=>{
            if (y.shape.length === 1) // Assume class indices.
            return (0, $dnFj7.clone)(y);
            else if (y.shape.length === 2) {
                if (y.shape[1] > 1) {
                    // Assume one-hot encoding of classes.
                    const axis = 1;
                    return (0, $iFZ6U.argMax)(y, axis);
                } else if (y.shape[1] === 1) // Class index.
                return (0, $eP0pM.reshape)(y, [
                    y.shape[0]
                ]);
                else throw new Error(`Encountered unexpected last-dimension size (${y.shape[1]}) ` + `during handling of class weights. The size is expected to be ` + `>= 1.`);
            } else throw new Error(`Unexpected rank of target (y) tensor (${y.rank}) during ` + `handling of class weights. The rank is expected to be 1 or 2.`);
        });
        const yClassIndices = Array.from(await yClasses.data());
        (0, $9c0Qr.dispose)(yClasses);
        const classSampleWeight = [];
        yClassIndices.forEach((classIndex)=>{
            if (classWeight[classIndex] == null) throw new Error(`classWeight must contain all classes in the training data. ` + `The class ${classIndex} exists in the data but not in ` + `classWeight`);
            else classSampleWeight.push(classWeight[classIndex]);
        });
        return (0, $jIDgY.tensor1d)(classSampleWeight, 'float32');
    } else return null;
}
function $fd50c83caeb9d461$export$23bdc4cea2e28782(losses, sampleWeights) {
    return (0, $r7fN6.mul)(losses, sampleWeights);
}

});


parcelRegister("ks7Jh", function(module, exports) {

$parcel$export(module.exports, "checkBatchSize", () => $ee3c6b0b6fc1161e$export$2f80f09f3b9f932e);
$parcel$export(module.exports, "sliceArrays", () => $ee3c6b0b6fc1161e$export$45b6cbb437b1b016);
$parcel$export(module.exports, "sliceArraysByIndices", () => $ee3c6b0b6fc1161e$export$4a7d2c6b9b0d590);
$parcel$export(module.exports, "makeBatches", () => $ee3c6b0b6fc1161e$export$7ce16f2471062005);
$parcel$export(module.exports, "fitTensors", () => $ee3c6b0b6fc1161e$export$a697f89ce8ba5315);
$parcel$export(module.exports, "disposeNewTensors", () => $ee3c6b0b6fc1161e$export$55dac70a20481db3);
$parcel$export(module.exports, "ensureTensorsRank2OrHigher", () => $ee3c6b0b6fc1161e$export$b2d45309fc343ee1);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Interfaces and methods for training models using tf.Tensor objects.
 */ parcelRequire("5n9DG");
var $7qWZ5 = parcelRequire("7qWZ5");
var $9c0Qr = parcelRequire("9c0Qr");
var $bVnU9 = parcelRequire("bVnU9");
var $jIDgY = parcelRequire("jIDgY");
var $wx9lK = parcelRequire("wx9lK");

var $luRak = parcelRequire("luRak");

var $9fe8M = parcelRequire("9fe8M");

var $jVuYK = parcelRequire("jVuYK");

var $7EFWn = parcelRequire("7EFWn");

var $jBJAM = parcelRequire("jBJAM");
function $ee3c6b0b6fc1161e$export$2f80f09f3b9f932e(batchSize) {
    $wx9lK.assert(batchSize > 0 && Number.isInteger(batchSize), ()=>`batchSize is required to be a positive integer, but got ${batchSize}`);
}
function $ee3c6b0b6fc1161e$export$45b6cbb437b1b016(arrays, start, stop) {
    if (arrays == null) return [
        null
    ];
    else if (Array.isArray(arrays)) return arrays.map((array)=>(0, $luRak.sliceAlongFirstAxis)(array, start, stop - start));
    else return (0, $luRak.sliceAlongFirstAxis)(arrays, start, stop - start);
}
function $ee3c6b0b6fc1161e$export$4a7d2c6b9b0d590(arrays, indices) {
    return $9c0Qr.tidy(()=>{
        if (arrays == null) return null;
        else if (Array.isArray(arrays)) return arrays.map((array)=>$ee3c6b0b6fc1161e$export$4a7d2c6b9b0d590(array, indices));
        else // TODO(cais): indices should be a pre-constructed Tensor1D to avoid
        //   tensor1d() calls.
        return (0, $luRak.gather)(arrays, indices.dtype === 'int32' ? indices : $7qWZ5.cast(indices, 'int32'));
    });
}
function $ee3c6b0b6fc1161e$export$7ce16f2471062005(size, batchSize) {
    const output = [];
    let batchStart = 0;
    let batchEnd = null;
    while(batchStart < size){
        batchEnd = batchStart + batchSize;
        if (batchEnd >= size) batchEnd = size;
        output.push([
            batchStart,
            batchEnd
        ]);
        batchStart = batchEnd;
    }
    return output;
}
/**
 * Abstract fit function for `f(ins)`.
 * @param f A Function returning a list of tensors. For training, this
 *   function is expected to perform the updates to the variables.
 * @param ins List of tensors to be fed to `f`.
 * @param outLabels List of strings, display names of the outputs of `f`.
 * @param batchSize Integer batch size or `== null` if unknown. Default : 32.
 * @param epochs Number of times to iterate over the data. Default : 1.
 * @param verbose Verbosity mode: 0, 1, or 2. Default: 1.
 * @param callbacks List of callbacks to be called during training.
 * @param valF Function to call for validation.
 * @param valIns List of tensors to be fed to `valF`.
 * @param shuffle Whether to shuffle the data at the beginning of every
 * epoch. Default : true.
 * @param callbackMetrics List of strings, the display names of the metrics
 *   passed to the callbacks. They should be the concatenation of the
 *   display names of the outputs of `f` and the list of display names
 *   of the outputs of `valF`.
 * @param initialEpoch Epoch at which to start training (useful for
 *   resuming a previous training run). Default : 0.
 * @param stepsPerEpoch Total number of steps (batches on samples) before
 *   declaring one epoch finished and starting the next epoch. Ignored with
 *   the default value of `undefined` or `null`.
 * @param validationSteps Number of steps to run validation for (only if
 *   doing validation from data tensors). Not applicable for tfjs-layers.
 * @returns A `History` object.
 */ async function $ee3c6b0b6fc1161e$var$fitLoop(// Type `model` as `any` here to avoid circular dependency w/ training.ts.
// tslint:disable-next-line:no-any
model, f, ins, outLabels, batchSize, epochs, verbose, callbacks, valF, valIns, shuffle, callbackMetrics, initialEpoch, stepsPerEpoch, validationSteps) {
    if (batchSize == null) batchSize = 32;
    if (epochs == null) epochs = 1;
    if (shuffle == null) shuffle = true;
    if (initialEpoch == null) initialEpoch = 0;
    // TODO(cais): Change const to let below when implementing validation.
    let doValidation = false;
    if (valF != null && valIns != null) doValidation = true;
    if (validationSteps != null) {
        doValidation = true;
        if (stepsPerEpoch == null) throw new (0, $jVuYK.ValueError)("Can only use `validationSteps` when doing step-wise training, i.e., `stepsPerEpoch` must be set.");
    }
    const numTrainSamples = model.checkNumSamples(ins, batchSize, stepsPerEpoch, 'steps_per_epoch');
    let indexArray;
    if (numTrainSamples != null) indexArray = (0, $jBJAM.range)(0, numTrainSamples);
    if (verbose == null) verbose = 1;
    const { callbackList: callbackList, history: history } = (0, $9fe8M.configureCallbacks)(callbacks, verbose, epochs, initialEpoch, numTrainSamples, stepsPerEpoch, batchSize, doValidation, callbackMetrics);
    callbackList.setModel(model);
    model.history = history;
    await callbackList.onTrainBegin();
    model.stopTraining_ = false;
    // TODO(cais): Take care of callbacks.validation_data as in PyKeras.
    // TODO(cais): Pre-convert feeds for performance as in PyKeras.
    for(let epoch = initialEpoch; epoch < epochs; ++epoch){
        await callbackList.onEpochBegin(epoch);
        const epochLogs = {};
        if (stepsPerEpoch != null) throw new (0, $jVuYK.NotImplementedError)('stepsPerEpoch mode is not implemented yet.');
        else {
            if (shuffle === 'batch') throw new (0, $jVuYK.NotImplementedError)('batch shuffling is not implemneted yet');
            else if (shuffle) (0, $wx9lK).shuffle(indexArray);
            // Convert the potentially shuffled indices to Tensor1D, to avoid the
            // cost of repeated creation of Array1Ds later on.
            const epochIndexArray1D = (0, $jIDgY.tensor1d)(indexArray);
            const batches = $ee3c6b0b6fc1161e$export$7ce16f2471062005(numTrainSamples, batchSize);
            for(let batchIndex = 0; batchIndex < batches.length; ++batchIndex){
                const batchLogs = {};
                await callbackList.onBatchBegin(batchIndex, batchLogs);
                $9c0Qr.tidy(()=>{
                    const batchStart = batches[batchIndex][0];
                    const batchEnd = batches[batchIndex][1];
                    const batchIds = (0, $luRak.sliceAlongFirstAxis)(epochIndexArray1D, batchStart, batchEnd - batchStart);
                    batchLogs['batch'] = batchIndex;
                    batchLogs['size'] = batchEnd - batchStart;
                    // TODO(cais): In ins, train flag can be a number, instead of an
                    //   Tensor? Do we need to handle this in tfjs-layers?
                    const insBatch = $ee3c6b0b6fc1161e$export$4a7d2c6b9b0d590(ins, batchIds);
                    const outs = f(insBatch);
                    for(let i = 0; i < outLabels.length; ++i){
                        const label = outLabels[i];
                        const out = outs[i];
                        batchLogs[label] = out;
                        $9c0Qr.keep(out);
                    // TODO(cais): Use scope() to avoid ownership.
                    }
                    if (batchIndex === batches.length - 1) {
                        if (doValidation) {
                            const valOuts = model.testLoop(valF, valIns, batchSize);
                            // Porting Notes: In tfjs-layers, valOuts is always an Array.
                            for(let i = 0; i < outLabels.length; ++i){
                                const label = outLabels[i];
                                const out = valOuts[i];
                                $9c0Qr.keep(out);
                                // TODO(cais): Use scope() to avoid ownership.
                                epochLogs['val_' + label] = out;
                            }
                        }
                    }
                });
                await callbackList.onBatchEnd(batchIndex, batchLogs);
                (0, $7EFWn.disposeTensorsInLogs)(batchLogs);
                if (model.stopTraining_) break;
            // TODO(cais): return outs as list of Tensor.
            }
            epochIndexArray1D.dispose();
        }
        // TODO(cais): Run validation at the end of the epoch.
        await callbackList.onEpochEnd(epoch, epochLogs);
        if (model.stopTraining_) break;
    }
    await callbackList.onTrainEnd();
    await model.history.syncData();
    return model.history;
}
async function $ee3c6b0b6fc1161e$export$a697f89ce8ba5315(// Type `model` as `any` here to avoid circular dependency w/ training.ts.
// tslint:disable-next-line:no-any
model, x, y, args = {}) {
    if (model.isTraining) throw new Error('Cannot start training because another fit() call is ongoing.');
    model.isTraining = true;
    let inputs;
    let targets;
    let originalInputs;
    let originalTargets;
    let inputValX;
    let inputValY;
    let valX;
    let valY;
    let sampleWeights;
    try {
        const batchSize = args.batchSize == null ? 32 : args.batchSize;
        $ee3c6b0b6fc1161e$export$2f80f09f3b9f932e(batchSize);
        // Validate user data.
        // TODO(cais): Support sampleWeight.
        const checkBatchAxis = false;
        const standardizedOuts = await model.standardizeUserData(x, y, args.sampleWeight, args.classWeight, checkBatchAxis, batchSize);
        inputs = standardizedOuts[0];
        targets = standardizedOuts[1];
        sampleWeights = standardizedOuts[2];
        // Prepare validation data.
        let doValidation = false;
        let valIns;
        if (args.validationData != null && args.validationData.length > 0) {
            doValidation = true;
            if (args.validationData.length === 2) {
                // config.validationData consists of valX and valY.
                inputValX = args.validationData[0];
                inputValY = args.validationData[1];
            } else if (args.validationData.length === 3) throw new (0, $jVuYK.NotImplementedError)('validationData including sample weights is not supported yet.');
            else throw new (0, $jVuYK.ValueError)(`When passing validation data, it must contain 2 (valX, valY) ` + `or 3 (valX, valY, valSampleWeight) items; ` + `${args.validationData} is invalid.`);
            const checkBatchAxis = true;
            const valStandardized = await model.standardizeUserData(inputValX, inputValY, null, /** Unused sample weights. */ null, /** Unused class weights. */ checkBatchAxis, batchSize);
            valX = valStandardized[0];
            valY = valStandardized[1];
            valIns = valX.concat(valY);
        // TODO(cais): Add useLearningPhase data properly.
        } else if (args.validationSplit != null && args.validationSplit > 0 && args.validationSplit < 1) {
            doValidation = true;
            // Porting Note: In tfjs-layers, inputs[0] is always a Tensor.
            const splitAt = Math.floor(inputs[0].shape[0] * (1 - args.validationSplit));
            const originalBatchSize = inputs[0].shape[0];
            valX = $ee3c6b0b6fc1161e$export$45b6cbb437b1b016(inputs, splitAt, originalBatchSize);
            originalInputs = inputs;
            inputs = $ee3c6b0b6fc1161e$export$45b6cbb437b1b016(inputs, 0, splitAt);
            valY = $ee3c6b0b6fc1161e$export$45b6cbb437b1b016(targets, splitAt, originalBatchSize);
            originalTargets = targets;
            targets = $ee3c6b0b6fc1161e$export$45b6cbb437b1b016(targets, 0, splitAt);
            // TODO(cais): Once sampleWeights becomes available, slice it to get
            //   valSampleWeights.
            valIns = valX.concat(valY);
        // TODO(cais): Add useLearningPhase data properly.
        } else if (args.validationSteps != null) doValidation = true;
        const ins = inputs.concat(targets).concat(sampleWeights);
        model.checkTrainableWeightsConsistency();
        // TODO(cais): Handle use_learning_phase and learning_phase?
        // Porting Note: Here we see a key deviation of tfjs-layers from
        // Keras.
        //  Due to the imperative nature of tfjs-layers' backend (tfjs-core),
        //  we do not construct symbolic computation graphs to embody the
        //  training process. Instead, we define a function that performs the
        //  training action. In PyKeras, the data (inputs and targets) are fed
        //  through graph placeholders. In tfjs-layers, the data are fed as
        //  function arguments. Since the function are defined below in the
        //  scope, we don't have equivalents of PyKeras's
        //  `_make_train_funciton`.
        const trainFunction = model.makeTrainFunction();
        const outLabels = model.getDedupedMetricsNames();
        let valFunction;
        let callbackMetrics;
        if (doValidation) {
            model.makeTestFunction();
            valFunction = model.testFunction;
            callbackMetrics = outLabels.slice().concat(outLabels.map((n)=>'val_' + n));
        } else {
            valFunction = null;
            valIns = [];
            callbackMetrics = outLabels.slice();
        }
        const callbacks = (0, $9fe8M.standardizeCallbacks)(args.callbacks, args.yieldEvery);
        const out = await $ee3c6b0b6fc1161e$var$fitLoop(model, trainFunction, ins, outLabels, batchSize, args.epochs, args.verbose, callbacks, valFunction, valIns, args.shuffle, callbackMetrics, args.initialEpoch, null, null);
        return out;
    } finally{
        model.isTraining = false;
        // Memory clean up.
        $ee3c6b0b6fc1161e$export$55dac70a20481db3(inputs, x);
        $ee3c6b0b6fc1161e$export$55dac70a20481db3(targets, y);
        $ee3c6b0b6fc1161e$export$55dac70a20481db3(originalInputs, x);
        $ee3c6b0b6fc1161e$export$55dac70a20481db3(originalTargets, y);
        $ee3c6b0b6fc1161e$export$55dac70a20481db3(valX, inputValX);
        $ee3c6b0b6fc1161e$export$55dac70a20481db3(valY, inputValY);
        if (sampleWeights != null) $9c0Qr.dispose(sampleWeights);
    }
// TODO(cais): Add value to outLabels.
}
function $ee3c6b0b6fc1161e$export$b2d45309fc343ee1(tensors) {
    const outs = [];
    if (tensors instanceof (0, $bVnU9.Tensor)) tensors = [
        tensors
    ];
    // Make Tensors at least 2D.
    for(let i = 0; i < tensors.length; ++i){
        const tensor = tensors[i];
        if (tensor.rank === 1) outs.push((0, $luRak.expandDims)(tensor, 1));
        else if (tensor.rank === 0) throw new Error("Expected tensor to be at least 1D, but received a 0D tensor (scalar).");
        else outs.push(tensor);
    }
    return outs;
}
function $ee3c6b0b6fc1161e$export$55dac70a20481db3(tensors, refTensors) {
    if (tensors == null) return;
    const oldTensorIds = [];
    if (refTensors instanceof (0, $bVnU9.Tensor)) oldTensorIds.push(refTensors.id);
    else if (Array.isArray(refTensors)) refTensors.forEach((t)=>oldTensorIds.push(t.id));
    else if (refTensors != null) // `oldTensors` is a map from string name to Tensor.
    for(const name in refTensors){
        const oldTensor = refTensors[name];
        oldTensorIds.push(oldTensor.id);
    }
    const tensorsToDispose = [];
    if (tensors instanceof (0, $bVnU9.Tensor)) {
        if (oldTensorIds.indexOf(tensors.id) === -1) tensorsToDispose.push(tensors);
    } else if (Array.isArray(tensors)) tensors.forEach((t)=>{
        if (oldTensorIds.indexOf(t.id) === -1) tensorsToDispose.push(t);
    });
    else if (tensors != null) // `oldTensors` is a map from string name to Tensor.
    for(const name in tensors){
        const tensor = tensors[name];
        if (oldTensorIds.indexOf(tensor.id) === -1) tensorsToDispose.push(tensor);
    }
    tensorsToDispose.forEach((t)=>{
        if (!t.isDisposed) t.dispose();
    });
}

});


parcelRegister("31SiL", function(module, exports) {

$parcel$export(module.exports, "modelFromJSON", () => $234b963f7948c191$export$6e76de3ed4e5bd6a);
$parcel$export(module.exports, "loadLayersModelInternal", () => $234b963f7948c191$export$a1dbbbf102c21534);
$parcel$export(module.exports, "Sequential", () => $234b963f7948c191$export$a77f6a295a72306);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source keras/models.py */ parcelRequire("5n9DG");
var $9c0Qr = parcelRequire("9c0Qr");
var $1RJvL = parcelRequire("1RJvL");
var $8AyuI = parcelRequire("8AyuI");
var $wx9lK = parcelRequire("wx9lK");

var $3qq1L = parcelRequire("3qq1L");

var $3gFUY = parcelRequire("3gFUY");

var $cm045 = parcelRequire("cm045");

var $8foXR = parcelRequire("8foXR");

var $jVuYK = parcelRequire("jVuYK");

var $dttI1 = parcelRequire("dttI1");

var $khD6O = parcelRequire("khD6O");

var $4UVDw = parcelRequire("4UVDw");

var $5sw3q = parcelRequire("5sw3q");
async function $234b963f7948c191$export$6e76de3ed4e5bd6a(modelAndWeightsConfig, customObjects) {
    if (!('modelTopology' in modelAndWeightsConfig)) modelAndWeightsConfig = {
        modelTopology: modelAndWeightsConfig
    };
    modelAndWeightsConfig;
    let modelTopology = modelAndWeightsConfig.modelTopology;
    if (modelTopology['model_config'] != null) // If the model-topology JSON contains a 'model_config' field, then it is
    // a full model JSON (e.g., from `keras.Model.save()`), which contains
    // not only the model's architecture in its 'model_config' field, but
    // additional information such as the model's optimizer. We use only the
    // 'model_config' field currently.
    modelTopology = modelTopology['model_config'];
    const tsConfig = (0, $4UVDw.convertPythonicToTs)(modelTopology);
    const model = (0, $dttI1.deserialize)(tsConfig, customObjects);
    if (modelAndWeightsConfig.weightsManifest != null) {
        // Load the weight values keyed by the original tensor names in the model
        // file that was loaded.  These should match the keys of the weight
        // manifest.
        const weightValues = await (0, $1RJvL).loadWeights(modelAndWeightsConfig.weightsManifest, modelAndWeightsConfig.pathPrefix, model.weights.map((weight)=>weight.originalName));
        // Map the weights to the unique tensor names generated during model loading
        const uniqueWeightValues = {};
        for (const weight of model.weights)uniqueWeightValues[weight.originalName] = weightValues[weight.originalName];
        model.loadWeights(uniqueWeightValues);
        // Dispose temporary weight values.
        (0, $9c0Qr.dispose)(weightValues);
    }
    return model;
}
async function $234b963f7948c191$export$a1dbbbf102c21534(pathOrIOHandler, options) {
    if (options == null) options = {};
    if (typeof pathOrIOHandler === 'string') {
        const handlers = (0, $1RJvL).getLoadHandlers(pathOrIOHandler, options);
        if (handlers.length === 0) // For backward compatibility: if no load handler can be found,
        // assume it is a relative http path.
        // TODO(cais): Reformat the args into a single `LoadOptions` once the core
        // is refactored.
        handlers.push((0, $1RJvL).browserHTTPRequest(pathOrIOHandler, options));
        else if (handlers.length > 1) throw new (0, $jVuYK.ValueError)(`Found more than one (${handlers.length}) load handlers for ` + `URL '${pathOrIOHandler}'`);
        pathOrIOHandler = handlers[0];
    }
    return $234b963f7948c191$export$fe68a3692f105118(pathOrIOHandler, undefined, options);
}
async function $234b963f7948c191$export$fe68a3692f105118(handler, customObjects, options) {
    if (options == null) options = {};
    if (handler.load == null) throw new (0, $jVuYK.ValueError)("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");
    const artifacts = await handler.load();
    let modelTopology = artifacts.modelTopology;
    if (modelTopology['model_config'] != null) modelTopology = modelTopology['model_config'];
    const strict = options.strict == null ? true : options.strict;
    // If weights are provided and the weight-loading mode is strict, use
    // fast weight initialization. This skips costly initializers such as
    // 'orthogonal' and saves unnecessary computation in cases where
    // the initialized weight values will immediately be overwritten by
    // loaded weight values.
    const fastWeightInit = artifacts.weightData != null && artifacts.weightSpecs != null && strict;
    const model = (0, $dttI1.deserialize)((0, $4UVDw.convertPythonicToTs)(modelTopology), customObjects, fastWeightInit);
    const trainingConfig = artifacts.trainingConfig;
    if (trainingConfig != null) model.loadTrainingConfig(trainingConfig);
    if (artifacts.userDefinedMetadata != null) model.setUserDefinedMetadata(artifacts.userDefinedMetadata);
    // If weightData is present, load the weights into the model.
    if (artifacts.weightData != null) {
        // Loading weights requires weightSpecs.
        if (artifacts.weightSpecs == null) throw new (0, $jVuYK.ValueError)("LayersModel artifacts contains weight data, but not weight specs. Therefore loading of weights cannot proceed.");
        const { modelWeights: modelWeights, optimizerWeights: optimizerWeights } = $234b963f7948c191$var$decodeModelAndOptimizerWeights(artifacts.weightData, artifacts.weightSpecs);
        model.loadWeights(modelWeights, strict);
        if (model.optimizer != null && optimizerWeights.length > 0) await model.optimizer.setWeights(optimizerWeights);
        // Dispose temporary weight values.
        (0, $9c0Qr.dispose)(modelWeights);
        (0, $9c0Qr.dispose)(optimizerWeights.map((w)=>w.tensor));
    }
    return model;
}
function $234b963f7948c191$var$decodeModelAndOptimizerWeights(buffer, specs) {
    const name2Tensor = (0, $1RJvL).decodeWeights(buffer, specs);
    const modelWeights = {};
    const optimizerWeights = [];
    specs.forEach((spec)=>{
        if (spec.group === 'optimizer') optimizerWeights.push({
            name: spec.name,
            tensor: name2Tensor[spec.name]
        });
        else modelWeights[spec.name] = name2Tensor[spec.name];
    });
    return {
        modelWeights: modelWeights,
        optimizerWeights: optimizerWeights
    };
}
class $234b963f7948c191$export$a77f6a295a72306 extends (0, $8foXR.LayersModel) {
    constructor(args){
        super({
            inputs: [],
            outputs: []
        });
        args = args || {};
        this.trainable = true;
        this.built = false;
        // Set model name.
        this.name = args.name != null ? args.name : (0, $3qq1L.getUid)('sequential_');
        // Add to the model any layers passed to the constructor.
        if (args.layers != null) for (const layer of args.layers)this.add(layer);
    }
    // Helper function to Sequential.add  Throws if the new output shape will be
    // invalid.
    checkShape(layer) {
        const shape = layer.inboundNodes[0].outputTensors[0].shape;
        if (shape.some((x)=>x < 0)) throw new (0, $jVuYK.ValueError)('Negative dimension size caused by adding layer ' + `${layer.name} with input shape [` + `${layer.inboundNodes[0].inputTensors[0].shape}]`);
    }
    /**
     * Adds a layer instance on top of the layer stack.
     *
     * ```js
     *  const model = tf.sequential();
     *  model.add(tf.layers.dense({units: 8, inputShape: [1]}));
     *  model.add(tf.layers.dense({units: 4, activation: 'relu6'}));
     *  model.add(tf.layers.dense({units: 1, activation: 'relu6'}));
     *  // Note that the untrained model is random at this point.
     *  model.predict(tf.randomNormal([10, 1])).print();
     * ```
     * @param layer Layer instance.
     *
     * @exception ValueError In case the `layer` argument does not know its
     * input shape.
     * @exception ValueError In case the `layer` argument has multiple output
     *   tensors, or is already connected somewhere else (forbidden in
     *   `Sequential` models).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ add(layer) {
        const isLayerModelInstance = layer instanceof $234b963f7948c191$export$a77f6a295a72306 || layer instanceof (0, $8foXR.LayersModel);
        let modelLayer;
        if (isLayerModelInstance) {
            modelLayer = layer;
            if (modelLayer.outputs.length !== 1) throw new (0, $jVuYK.ValueError)("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
            if (modelLayer.inputs.length !== 1) throw new (0, $jVuYK.ValueError)("All layers in a Sequential model should have a single input tensor. For multi-input layers, use the functional API.");
        }
        if (this.outputs.length === 0) {
            // first layer in model: check that it is an input layer
            if (layer.inboundNodes.length === 0) {
                // create an input layer
                if (layer.batchInputShape == null) throw new (0, $jVuYK.ValueError)("The first layer in a Sequential model must get an `inputShape` or `batchInputShape` argument.");
                // Instantiate the input layer.
                const x = (0, $3gFUY.Input)({
                    batchShape: layer.batchInputShape,
                    dtype: layer.dtype,
                    name: layer.name + '_input'
                });
                // This will build the current layer and create the node connecting
                // the current layer to the input layer we just created.
                layer.apply(x);
            }
            if (isLayerModelInstance) {
                this.outputs = modelLayer.outputs;
                this.inputs = modelLayer.inputs;
            } else {
                if (layer.inboundNodes.length !== 1) throw new (0, $jVuYK.ValueError)('A layer added to a Sequential model must not already be ' + `connected somewhere else. LayersModel received layer ${layer.name} ` + `which has ${layer.inboundNodes.length} pre-existing inbound ` + 'connections.');
                if (layer.inboundNodes[0].outputTensors.length !== 1) throw new (0, $jVuYK.ValueError)("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
                this.checkShape(layer);
                this.outputs = [
                    layer.inboundNodes[0].outputTensors[0]
                ];
                this.inputs = (0, $cm045.getSourceInputs)(this.outputs[0]);
            }
            this.inboundNodes = [];
            // We create an input node, which we will keep updated
            // as we add more layers.
            // (This call has side effects.)
            // tslint:disable-next-line:no-unused-expression
            new (0, $cm045.Node)({
                outboundLayer: this,
                inboundLayers: [],
                nodeIndices: [],
                tensorIndices: [],
                inputTensors: this.inputs,
                outputTensors: this.outputs,
                // no model-level masking for now
                inputMasks: $khD6O.pyListRepeat(null, this.inputs.length),
                outputMasks: [
                    null
                ],
                inputShapes: this.inputs.map((x)=>x.shape),
                outputShapes: this.outputs[0].shape
            });
        } else {
            const outputTensor = layer.apply(this.outputs[0]);
            if (Array.isArray(outputTensor)) throw new TypeError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
            this.checkShape(layer);
            this.outputs = [
                outputTensor
            ];
            // update self.inbound_nodes
            this.inboundNodes[0].outputTensors = this.outputs;
            this.inboundNodes[0].outputShapes = [
                this.outputs[0].shape
            ];
        }
        this.layers.push(layer);
        this.built = false;
    }
    /**
     * Removes the last layer in the model.
     *
     * @exception TypeError if there are no layers in the model.
     */ pop() {
        if (this.layers.length === 0) throw new TypeError('There are no layers in the model.');
        this.layers.pop();
        if (this.layers.length === 0) {
            this.outputs = [];
            this.inboundNodes = [];
            this.outboundNodes = [];
        } else {
            const lastLayerIndex = this.layers.length - 1;
            this.layers[lastLayerIndex].outboundNodes = [];
            this.outputs = [
                this.layers[lastLayerIndex].output
            ];
            // update self.inbound_nodes
            this.inboundNodes[0].outputTensors = this.outputs;
            this.inboundNodes[0].outputShapes = [
                this.outputs[0].shape
            ];
        }
    }
    call(inputs, kwargs) {
        if (this.model == null) this.build();
        return this.model.call(inputs, kwargs);
    }
    build(inputShape) {
        // Call `getExactlyOneShape` without using its return value,
        // to verify that exactly one input shape is provided.
        (0, $5sw3q.getExactlyOneShape)(inputShape);
        if (this.inputs.length === 0 || this.outputs.length === 0) throw new TypeError("Sequential model cannot be built: model is empty. Add some layers first.");
        // actually create the model
        this.model = new (0, $8foXR.LayersModel)({
            inputs: this.inputs,
            outputs: this.outputs[0],
            name: this.name + '_model'
        });
        this.model.trainable = this.trainable;
        // mirror model attributes
        this.supportsMasking = this.model.supportsMasking;
        // TODO(michaelterry): Add caches
        this.inputLayers = this.model.inputLayers;
        this.inputLayersNodeIndices = this.model.inputLayersNodeIndices;
        this.inputLayersTensorIndices = this.model.inputLayersTensorIndices;
        this.outputLayers = this.model.outputLayers;
        this.outputLayersNodeIndices = this.model.outputLayersNodeIndices;
        this.outputLayersTensorIndices = this.model.outputLayersTensorIndices;
        this.nodesByDepth = this.model.nodesByDepth;
        this.containerNodes = this.model.containerNodes;
        this.outputNames = this.model.outputNames;
        this.inputNames = this.model.inputNames;
        // TODO(michaelterry): Add feedInputNames, feedInputs, if needed.
        // TODO(michaelterry): Add callbackModel if needed.
        this.built = true;
    }
    countParams() {
        if (!this.built) this.build();
        return super.countParams();
    }
    /**
     * Print a text summary of the Sequential model's layers.
     *
     * The summary includes
     * - Name and type of all layers that comprise the model.
     * - Output shape(s) of the layers
     * - Number of weight parameters of each layer
     * - The total number of trainable and non-trainable parameters of the
     * model.
     *
     * ```js
     * const model = tf.sequential();
     * model.add(
     *     tf.layers.dense({units: 100, inputShape: [10], activation: 'relu'}));
     * model.add(tf.layers.dense({units: 1, activation: 'sigmoid'}));
     *
     * model.summary();
     * ```
     *
     * @param lineLength Custom line length, in number of characters.
     * @param positions Custom widths of each of the columns, as either
     *   fractions of `lineLength` (e.g., `[0.5, 0.75, 1]`) or absolute number
     *   of characters (e.g., `[30, 50, 65]`). Each number corresponds to
     *   right-most (i.e., ending) position of a column.
     * @param printFn Custom print function. Can be used to replace the default
     *   `console.log`. For example, you can use `x => {}` to mute the printed
     *   messages in the console.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ summary(lineLength, positions, printFn = console.log) {
        if (!this.built) this.build();
        super.summary(lineLength, positions, printFn);
    }
    /**
     * Sets the weights of the model.
     *
     * @param weights Should be a list of Tensors with shapes and types matching
     *   the output of `model.getWeights()`.
     */ setWeights(weights) {
        if (this.model == null) this.build();
        this.model.setWeights(weights);
    }
    /**
     * Returns the loss value & metrics values for the model in test mode.
     *
     * Loss and metrics are specified during `compile()`, which needs to happen
     * before calls to `evaluate()`.
     *
     * Computation is done in batches.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * const result = model.evaluate(tf.ones([8, 10]), tf.ones([8, 1]), {
     *   batchSize: 4,
     * });
     * result.print();
     * ```
     *
     * @param x `tf.Tensor` of test data, or an `Array` of `tf.Tensor`s if the
     * model has multiple inputs.
     * @param y `tf.Tensor` of target data, or an `Array` of `tf.Tensor`s if the
     * model has multiple outputs.
     * @param args A `ModelEvaluateConfig`, containing optional fields.
     *
     * @return `Scalar` test loss (if the model has a single output and no
     *   metrics) or `Array` of `Scalar`s (if the model has multiple outputs
     *   and/or metrics). The attribute `model.metricsNames`
     *   will give you the display labels for the scalar outputs.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ evaluate(x, y, args = {}) {
        if (!this.built) throw new (0, $jVuYK.RuntimeError)('The model needs to be compiled before being used.');
        return this.model.evaluate(x, y, args);
    }
    // TODO(cais): Add code snippet below once real dataset objects are
    //   available.
    /**
     * Evaluate model using a dataset object.
     *
     * Note: Unlike `evaluate()`, this method is asynchronous (`async`).
     *
     * @param dataset A dataset object. Its `iterator()` method is expected
     *   to generate a dataset iterator object, the `next()` method of which
     *   is expected to produce data batches for evaluation. The return value
     *   of the `next()` call ought to contain a boolean `done` field and a
     *   `value` field. The `value` field is expected to be an array of two
     *   `tf.Tensor`s or an array of two nested `tf.Tensor` structures. The former
     *   case is for models with exactly one input and one output (e.g.
     *   a sequential model). The latter case is for models with multiple
     *   inputs and/or multiple outputs. Of the two items in the array, the
     *   first is the input feature(s) and the second is the output target(s).
     * @param args A configuration object for the dataset-based evaluation.
     * @returns Loss and metric values as an Array of `Scalar` objects.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async evaluateDataset(dataset, args) {
        if (!this.built) throw new (0, $jVuYK.RuntimeError)('The model needs to be compiled before being used.');
        return this.model.evaluateDataset(dataset, args);
    }
    /**
     * Generates output predictions for the input samples.
     *
     * Computation is done in batches.
     *
     * Note: the "step" mode of predict() is currently not supported.
     *   This is because the TensorFlow.js core backend is imperative only.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.predict(tf.ones([2, 10])).print();
     * ```
     *
     * @param x The input data, as a Tensor, or an `Array` of `tf.Tensor`s if
     *   the model has multiple inputs.
     * @param conifg A `ModelPredictConfig` object containing optional fields.
     *
     * @return `tf.Tensor`(s) of predictions.
     *
     * @exception ValueError In case of mismatch between the provided input data
     *   and the model's expectations, or in case a stateful model receives a
     *   number of samples that is not a multiple of the batch size.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predict(x, args = {}) {
        if (this.model == null) this.build();
        return this.model.predict(x, args);
    }
    /**
     * Returns predictions for a single batch of samples.
     *
     * @param x: Input samples, as a Tensor, or list of Tensors (if the model
     *   has multiple inputs).
     * @return Tensor(s) of predictions
     */ predictOnBatch(x) {
        if (this.model == null) this.build();
        return this.model.predictOnBatch(x);
    }
    /**
     * See `LayersModel.compile`.
     *
     * @param args
     */ compile(args) {
        this.build();
        this.model.compile(args);
        this.optimizer_ = this.model.optimizer;
        // tslint:disable-next-line:no-any
        this.isOptimizerOwned = this.model.isOptimizerOwned;
        this.loss = this.model.loss;
        this.metrics = this.model.metrics;
        // TODO(cais): Add this.lossWeights, this.sampleWeightMode,
        //   this.weightedMetrics, this.targets.
        this.metricsTensors = this.model.metricsTensors;
        this.metricsNames = this.model.metricsNames;
    // TODO(cais): Add sampleWeights.
    }
    get optimizer() {
        return this.model == null ? undefined : this.model.optimizer;
    }
    set optimizer(optimizer) {
        this.model.optimizer = optimizer;
    }
    /**
     * Trains the model for a fixed number of epochs (iterations on a dataset).
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * const history = await model.fit(tf.ones([8, 10]), tf.ones([8, 1]), {
     *   batchSize: 4,
     *   epochs: 3
     * });
     * console.log(history.history.loss[0]);
     * ```
     *
     * @param x `tf.Tensor` of training data, or an array of `tf.Tensor`s if the
     * model has multiple inputs. If all inputs in the model are named, you can
     * also pass a dictionary mapping input names to `tf.Tensor`s.
     * @param y `tf.Tensor` of target (label) data, or an array of `tf.Tensor`s if
     * the model has multiple outputs. If all outputs in the model are named, you
     *  can also pass a dictionary mapping output names to `tf.Tensor`s.
     * @param args  A `ModelFitConfig`, containing optional fields.
     *
     * @return A `History` instance. Its `history` attribute contains all
     *   information collected during training.
     *
     * @exception ValueError In case of mismatch between the provided input data
     *   and what the model expects.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async fit(x, y, args = {}) {
        if (!this.built) throw new (0, $jVuYK.RuntimeError)("The model needs to be compiled before being used.");
        return this.model.fit(x, y, args);
    }
    /**
     * Trains the model using a dataset object.
     *
     * ```js
     * const xArray = [
     *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
     *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
     *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
     *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
     * ];
     * const yArray = [1, 1, 1, 1];
     * // Create a dataset from the JavaScript array.
     * const xDataset = tf.data.array(xArray);
     * const yDataset = tf.data.array(yArray);
     * // Zip combines the `x` and `y` Datasets into a single Dataset, the
     * // iterator of which will return an object containing of two tensors,
     * // corresponding to `x` and `y`.  The call to `batch(4)` will bundle
     * // four such samples into a single object, with the same keys now pointing
     * // to tensors that hold 4 examples, organized along the batch dimension.
     * // The call to `shuffle(4)` causes each iteration through the dataset to
     * // happen in a different order.  The size of the shuffle window is 4.
     * const xyDataset = tf.data.zip({xs: xDataset, ys: yDataset})
     *     .batch(4)
     *     .shuffle(4);
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [9]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * const history = await model.fitDataset(xyDataset, {
     *   epochs: 4,
     *   callbacks: {onEpochEnd: (epoch, logs) => console.log(logs.loss)}
     * });
     * ```
     *
     * @param dataset A dataset object. Its `iterator()` method is expected to
     *   generate a dataset iterator object, the `next()` method of which is
     *   expected to produce data batches for evaluation. The return value of the
     *   `next()` call ought to contain a boolean `done` field and a `value`
     *   field.
     *
     *   The `value` field is expected to be an object of with fields
     *   `xs` and `ys`, which point to the feature tensor and the target tensor,
     *   respectively. This case is for models with exactly one input and one
     *   output (e.g. a sequential model). For example:
     *   ```js
     *   {value: {xs: xsTensor, ys: ysTensor}, done: false}
     *   ```
     *
     *   If the model has multiple inputs, the `xs` field of `value` should
     *   be an object mapping input names to their respective feature tensors.
     *   For example:
     *   ```js
     *   {
     *     value: {
     *       xs: {
     *         input_1: xsTensor1,
     *         input_2: xsTensor2
     *       },
     *       ys: ysTensor
     *     },
     *     done: false
     *   }
     *   ```
     *   If the model has multiple outputs, the `ys` field of `value` should
     *   be an object mapping output names to their respective target tensors.
     *   For example:
     *   ```js
     *   {
     *     value: {
     *       xs: xsTensor,
     *       ys: {
     *         output_1: ysTensor1,
     *         output_2: ysTensor2
     *       },
     *     },
     *     done: false
     *   }
     *   ```
     * @param args A `ModelFitDatasetArgs`, containing optional fields.
     *
     * @return A `History` instance. Its `history` attribute contains all
     *   information collected during training.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ async fitDataset(dataset, args) {
        if (!this.built) throw new (0, $jVuYK.RuntimeError)("The model needs to be compiled before being used.");
        return this.model.fitDataset(dataset, args);
    }
    /**
     * Runs a single gradient update on a single batch of data.
     *
     * This method differs from `fit()` and `fitDataset()` in the following
     * regards:
     *   - It operates on exactly one batch of data.
     *   - It returns only the loss and metric values, instead of
     *     returning the batch-by-batch loss and metric values.
     *   - It doesn't support fine-grained options such as verbosity and
     *     callbacks.
     *
     * @param x Input data. It could be one of the following:
     *   - A `tf.Tensor`, or an Array of `tf.Tensor`s (in case the model has
     *     multiple inputs).
     *   - An Object mapping input names to corresponding `tf.Tensor` (if the
     *     model has named inputs).
     * @param y Target data. It could be either a `tf.Tensor` or multiple
     *   `tf.Tensor`s. It should be consistent with `x`.
     * @returns Training loss or losses (in case the model has
     *   multiple outputs), along with metrics (if any), as numbers.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async trainOnBatch(x, y) {
        return this.model.trainOnBatch(x, y);
    }
    /* See parent class for JsDoc */ /** @nocollapse */ static fromConfig(cls, config, customObjects = {}, fastWeightInit = false) {
        let configArray;
        let extraModelConfig = {};
        if (config instanceof Array) {
            if (!(config[0].className != null) || config[0]['className'] === 'Merge') throw new (0, $jVuYK.ValueError)('Legacy serialization format not supported yet.');
            configArray = config;
        } else {
            (0, $wx9lK).assert(config['layers'] != null, ()=>`When the config data for a Sequential model is not an Array, ` + `it must be an Object that contains the 'layers' field.`);
            configArray = config['layers'];
            delete config['layers'];
            extraModelConfig = config;
        }
        const model = new cls(extraModelConfig);
        if (!(model instanceof $234b963f7948c191$export$a77f6a295a72306)) throw new (0, $jVuYK.NotImplementedError)(`Sequential.fromConfig called on non-Sequential input: ${model}`);
        for (const conf of configArray){
            const customObjects = undefined;
            const layer = (0, $dttI1.deserialize)(conf, customObjects, fastWeightInit);
            if (fastWeightInit) layer.setFastWeightInitDuringBuild(true);
            model.add(layer);
        }
        return model;
    }
    /**
     * Setter used for force stopping of LayersModel.fit() (i.e., training).
     *
     * Example:
     *
     * ```js
     * const model = tf.sequential();
     * model.add(tf.layers.dense({units: 1, inputShape: [10]}));
     * model.compile({loss: 'meanSquaredError', optimizer: 'sgd'});
     * const xs = tf.ones([8, 10]);
     * const ys = tf.zeros([8, 1]);
     *
     * const history = await model.fit(xs, ys, {
     *   epochs: 10,
     *   callbacks: {
     *     onEpochEnd: async (epoch, logs) => {
     *       if (epoch === 2) {
     *         model.stopTraining = true;
     *       }
     *     }
     *   }
     * });
     *
     * // There should be only 3 values in the loss array, instead of 10 values,
     * // due to the stopping after 3 epochs.
     * console.log(history.history.loss);
     * ```
     */ set stopTraining(stop) {
        // TODO(cais): When refactoring to remove the composition pattern happens,
        // remove this method overriding.
        if (this.model == null) throw new (0, $jVuYK.ValueError)("Cannot set the stopTraining property of a sequential model before it is compiled.");
        this.model.stopTraining = stop;
    }
    get stopTraining() {
        if (this.model == null) throw new (0, $jVuYK.ValueError)("Cannot get the stopTraining property of a sequential model before it is compiled.");
        return this.model.stopTraining;
    }
    // TODO(cais): Override get trainableWeights() here
    // tslint:disable-next-line:no-any
    getConfig() {
        // NOTE(cais): We override the return type of getConfig() to `any` here,
        //   because the `Sequential` class is a special case among `Container`
        //   subtypes in that its getConfig() method returns an Array (not a
        //   dict).
        const layers = [];
        for (const layer of this.layers){
            const dict = {};
            dict['className'] = layer.getClassName();
            dict['config'] = layer.getConfig();
            layers.push(dict);
        }
        return {
            name: this.name,
            layers: layers
        };
    }
}
/** @nocollapse */ $234b963f7948c191$export$a77f6a295a72306.className = 'Sequential';
(0, $8AyuI).registerClass($234b963f7948c191$export$a77f6a295a72306);

});


parcelRegister("fbJ6w", function(module, exports) {

$parcel$export(module.exports, "ReLU", () => $b0eadedf6898d024$export$b6bead732c285ccc);
$parcel$export(module.exports, "LeakyReLU", () => $b0eadedf6898d024$export$aef2e2f253bc592f);
$parcel$export(module.exports, "PReLU", () => $b0eadedf6898d024$export$e8f536be4d0c9e9f);
$parcel$export(module.exports, "ELU", () => $b0eadedf6898d024$export$945a5ccf96adb3b2);
$parcel$export(module.exports, "ThresholdedReLU", () => $b0eadedf6898d024$export$e0ad929c946d21d1);
$parcel$export(module.exports, "Softmax", () => $b0eadedf6898d024$export$350a526055d3ca6e);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 *  Advanced activation layers.
 */ parcelRequire("5n9DG");
var $7qWZ5 = parcelRequire("7qWZ5");
var $jU3Ej = parcelRequire("jU3Ej");
var $aYszp = parcelRequire("aYszp");
var $jUhqf = parcelRequire("jUhqf");
var $8XuOv = parcelRequire("8XuOv");
var $r7fN6 = parcelRequire("r7fN6");
var $4Do8T = parcelRequire("4Do8T");
var $1mZlL = parcelRequire("1mZlL");
var $8AyuI = parcelRequire("8AyuI");

var $bDaSd = parcelRequire("bDaSd");

var $cn6Kc = parcelRequire("cn6Kc");

var $cm045 = parcelRequire("cm045");

var $jVuYK = parcelRequire("jVuYK");

var $fQ95p = parcelRequire("fQ95p");

var $4oHox = parcelRequire("4oHox");

var $5sw3q = parcelRequire("5sw3q");
class $b0eadedf6898d024$export$b6bead732c285ccc extends (0, $cm045.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.supportsMasking = true;
        if (args != null) this.maxValue = args.maxValue;
    }
    call(inputs, kwargs) {
        inputs = (0, $5sw3q.getExactlyOneTensor)(inputs);
        let output = (0, $1mZlL.relu)(inputs);
        if (this.maxValue != null) output = (0, $jU3Ej.clipByValue)(output, 0, this.maxValue);
        return output;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            maxValue: this.maxValue
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $b0eadedf6898d024$export$b6bead732c285ccc.className = 'ReLU';
(0, $8AyuI).registerClass($b0eadedf6898d024$export$b6bead732c285ccc);
class $b0eadedf6898d024$export$aef2e2f253bc592f extends (0, $cm045.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_ALPHA = 0.3;
        if (args == null) args = {};
        this.alpha = args.alpha == null ? this.DEFAULT_ALPHA : args.alpha;
    }
    call(inputs, kwargs) {
        const x = (0, $5sw3q.getExactlyOneTensor)(inputs);
        return (0, $8XuOv.leakyRelu)(x, this.alpha);
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            alpha: this.alpha
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $b0eadedf6898d024$export$aef2e2f253bc592f.className = 'LeakyReLU';
(0, $8AyuI).registerClass($b0eadedf6898d024$export$aef2e2f253bc592f);
class $b0eadedf6898d024$export$e8f536be4d0c9e9f extends (0, $cm045.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_ALPHA_INITIALIZER = 'zeros';
        if (args == null) args = {};
        this.supportsMasking = true;
        this.alphaInitializer = (0, $fQ95p.getInitializer)(args.alphaInitializer || this.DEFAULT_ALPHA_INITIALIZER);
        this.alphaRegularizer = (0, $4oHox.getRegularizer)(args.alphaRegularizer);
        this.alphaConstraint = (0, $cn6Kc.getConstraint)(args.alphaConstraint);
        if (args.sharedAxes == null) this.sharedAxes = null;
        else if (Array.isArray(args.sharedAxes)) this.sharedAxes = args.sharedAxes;
        else if (typeof args.sharedAxes === 'number') this.sharedAxes = [
            args.sharedAxes
        ];
        else throw new (0, $jVuYK.ValueError)(`Expected sharedAxes to be a number or an array of numbers, ` + `but got ${args.sharedAxes}`);
    }
    build(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const paramShape = inputShape.slice(1);
        if (this.sharedAxes != null) for (const i of this.sharedAxes)paramShape[i - 1] = 1;
        this.alpha = this.addWeight('alpha', paramShape, 'float32', this.alphaInitializer, this.alphaRegularizer, true, this.alphaConstraint);
        // Set input spec.
        const axes = {};
        if (this.sharedAxes != null) for(let i = 1; i < inputShape.length; ++i)axes[i] = inputShape[i];
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: inputShape.length,
                axes: axes
            })
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        inputs = (0, $5sw3q.getExactlyOneTensor)(inputs);
        return (0, $4Do8T.prelu)(inputs, this.alpha.read());
    }
    getConfig() {
        const config = {
            alphaInitializer: (0, $fQ95p.serializeInitializer)(this.alphaInitializer),
            alphaRegularizer: (0, $4oHox.serializeRegularizer)(this.alphaRegularizer),
            alphaConstraint: (0, $cn6Kc.serializeConstraint)(this.alphaConstraint),
            sharedAxes: this.sharedAxes
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $b0eadedf6898d024$export$e8f536be4d0c9e9f.className = 'PReLU';
(0, $8AyuI).registerClass($b0eadedf6898d024$export$e8f536be4d0c9e9f);
class $b0eadedf6898d024$export$945a5ccf96adb3b2 extends (0, $cm045.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_ALPHA = 1.0;
        if (args == null) args = {};
        if (args.alpha != null && args.alpha !== this.DEFAULT_ALPHA) throw new (0, $jVuYK.NotImplementedError)(`Non-default alpha value (${args.alpha}) is not supported by the ` + `ELU layer yet.`);
        this.alpha = args.alpha == null ? this.DEFAULT_ALPHA : args.alpha;
    }
    call(inputs, kwargs) {
        const x = (0, $5sw3q.getExactlyOneTensor)(inputs);
        return (0, $aYszp.elu)(x);
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            alpha: this.alpha
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $b0eadedf6898d024$export$945a5ccf96adb3b2.className = 'ELU';
(0, $8AyuI).registerClass($b0eadedf6898d024$export$945a5ccf96adb3b2);
class $b0eadedf6898d024$export$e0ad929c946d21d1 extends (0, $cm045.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_THETA = 1.0;
        if (args == null) args = {};
        this.theta = args.theta == null ? this.DEFAULT_THETA : args.theta;
    }
    call(inputs, kwargs) {
        const x = (0, $5sw3q.getExactlyOneTensor)(inputs);
        return (0, $r7fN6.mul)(x, (0, $7qWZ5.cast)((0, $jUhqf.greater)(x, this.theta), 'float32'));
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            theta: this.theta
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $b0eadedf6898d024$export$e0ad929c946d21d1.className = 'ThresholdedReLU';
(0, $8AyuI).registerClass($b0eadedf6898d024$export$e0ad929c946d21d1);
class $b0eadedf6898d024$export$350a526055d3ca6e extends (0, $cm045.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_AXIS = 1.0;
        if (args == null) args = {};
        this.softmax = new (0, $bDaSd.Softmax)().apply;
        this.axis = args.axis == null ? this.DEFAULT_AXIS : args.axis;
    }
    call(inputs, kwargs) {
        const x = (0, $5sw3q.getExactlyOneTensor)(inputs);
        return this.softmax(x, this.axis);
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            axis: this.axis
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $b0eadedf6898d024$export$350a526055d3ca6e.className = 'Softmax';
(0, $8AyuI).registerClass($b0eadedf6898d024$export$350a526055d3ca6e);

});
parcelRegister("bDaSd", function(module, exports) {

$parcel$export(module.exports, "Softmax", () => $877bc57b15dd6b5a$export$350a526055d3ca6e);
$parcel$export(module.exports, "serializeActivation", () => $877bc57b15dd6b5a$export$8a2c1643c67d0487);
$parcel$export(module.exports, "getActivation", () => $877bc57b15dd6b5a$export$ed84f867ffcf9364);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ // Layer activation functions
parcelRequire("5n9DG");
var $1oQXI = parcelRequire("1oQXI");
var $dlTNL = parcelRequire("dlTNL");
var $r7fN6 = parcelRequire("r7fN6");
var $1mZlL = parcelRequire("1mZlL");
var $fNXeh = parcelRequire("fNXeh");
var $8AyuI = parcelRequire("8AyuI");
var $5B3nT = parcelRequire("5B3nT");
var $5q2Zg = parcelRequire("5q2Zg");
var $cvbcy = parcelRequire("cvbcy");
var $i3Kce = parcelRequire("i3Kce");
var $9c0Qr = parcelRequire("9c0Qr");

var $luRak = parcelRequire("luRak");

var $khD6O = parcelRequire("khD6O");
class $877bc57b15dd6b5a$export$d4842319833f6f14 extends (0, $8AyuI).Serializable {
    getConfig() {
        return {};
    }
}
class $877bc57b15dd6b5a$export$64636e173424d83d extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x: Input.
     * @param alpha: Scaling factor the negative section.
     * @return Output of the ELU activation.
     */ apply(x, alpha = 1) {
        return $luRak.elu(x, alpha);
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$64636e173424d83d.className = 'elu';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$64636e173424d83d);
class $877bc57b15dd6b5a$export$6760d858e6f2594a extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    apply(x) {
        return $fNXeh.selu(x);
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$6760d858e6f2594a.className = 'selu';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$6760d858e6f2594a);
class $877bc57b15dd6b5a$export$9a6ff968bf961432 extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    apply(x) {
        return $1mZlL.relu(x);
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$9a6ff968bf961432.className = 'relu';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$9a6ff968bf961432);
class $877bc57b15dd6b5a$export$3be9e924f629054e extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    apply(x) {
        return (0, $9c0Qr.tidy)(()=>$dlTNL.minimum(6.0, $1mZlL.relu(x)));
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$3be9e924f629054e.className = 'relu6';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$3be9e924f629054e);
class $877bc57b15dd6b5a$export$cff00ccf6e2392de extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    apply(x) {
        return x;
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$cff00ccf6e2392de.className = 'linear';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$cff00ccf6e2392de);
class $877bc57b15dd6b5a$export$fde18c826dda6b1b extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    apply(x) {
        return $5B3nT.sigmoid(x);
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$fde18c826dda6b1b.className = 'sigmoid';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$fde18c826dda6b1b);
class $877bc57b15dd6b5a$export$6098198c337d3dd8 extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    apply(x) {
        return $luRak.hardSigmoid(x);
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$6098198c337d3dd8.className = 'hardSigmoid';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$6098198c337d3dd8);
class $877bc57b15dd6b5a$export$c5af433747f1fd0a extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    apply(x) {
        return $cvbcy.softplus(x);
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$c5af433747f1fd0a.className = 'softplus';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$c5af433747f1fd0a);
class $877bc57b15dd6b5a$export$abea6258cd16deb6 extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    apply(x) {
        return $luRak.softsign(x);
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$abea6258cd16deb6.className = 'softsign';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$abea6258cd16deb6);
class $877bc57b15dd6b5a$export$893b6e865e352c83 extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    apply(x) {
        return $i3Kce.tanh(x);
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$893b6e865e352c83.className = 'tanh';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$893b6e865e352c83);
class $877bc57b15dd6b5a$export$350a526055d3ca6e extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @param axis Integer, axis along which the softmax normalization is applied.
     * Invalid if < 2, as softmax across 1 (the batch dimension) is assumed to be
     * an error.
     *
     * @returns a Tensor of the same shape as x
     *
     * @throws ValueError: In case `dim(x) < 2`.
     */ apply(x, axis = -1) {
        return $5q2Zg.softmax(x, axis);
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$350a526055d3ca6e.className = 'softmax';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$350a526055d3ca6e);
class $877bc57b15dd6b5a$export$85b5bcbd60848a10 extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    /**
     * Calculate the activation function of log softmax:
     * log( exp(x_i) / sum(exp(x)) )
     *
     * @param x Tensor.
     * @param axis Integer, axis along which the softmax normalization is applied.
     * Invalid if < 2, as softmax across 1 (the batch dimension) is assumed to be
     * an error.
     *
     * @returns a Tensor of the same shape as x
     *
     * @throws ValueError: In case `dim(x) < 2`.
     */ apply(x, axis = -1) {
        return $1oQXI.logSoftmax(x, axis);
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$85b5bcbd60848a10.className = 'logSoftmax';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$85b5bcbd60848a10);
class $877bc57b15dd6b5a$export$ca163985819ed934 extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @param alpha Scaling factor for the sigmoid function.
     * @returns a Tensor of the same shape as x
     */ apply(x, alpha = 1) {
        return (0, $9c0Qr.tidy)(()=>$r7fN6.mul($5B3nT.sigmoid($r7fN6.mul(x, alpha)), x));
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$ca163985819ed934.className = 'swish';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$ca163985819ed934);
class $877bc57b15dd6b5a$export$61e2977e0c740f20 extends $877bc57b15dd6b5a$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @returns a Tensor of the same shape as x
     */ apply(x) {
        return (0, $9c0Qr.tidy)(()=>$r7fN6.mul(x, $i3Kce.tanh($cvbcy.softplus(x))));
    }
}
/** @nocollapse */ $877bc57b15dd6b5a$export$61e2977e0c740f20.className = 'mish';
(0, $8AyuI).registerClass($877bc57b15dd6b5a$export$61e2977e0c740f20);
function $877bc57b15dd6b5a$export$8a2c1643c67d0487(activation) {
    return activation.getClassName();
}
function $877bc57b15dd6b5a$export$3feed769d94b8fdf(config, customObjects = {}) {
    return (0, $khD6O.deserializeKerasObject)(config, (0, $8AyuI).SerializationMap.getMap().classNameMap, customObjects, 'activation');
}
function $877bc57b15dd6b5a$export$ed84f867ffcf9364(identifier) {
    if (identifier == null) {
        const config = {};
        config['className'] = 'linear';
        config['config'] = {};
        return $877bc57b15dd6b5a$export$3feed769d94b8fdf(config);
    }
    if (typeof identifier === 'string') {
        const config = {};
        config['className'] = identifier;
        config['config'] = {};
        return $877bc57b15dd6b5a$export$3feed769d94b8fdf(config);
    } else if (identifier instanceof $877bc57b15dd6b5a$export$d4842319833f6f14) return identifier;
    else return $877bc57b15dd6b5a$export$3feed769d94b8fdf(identifier);
}

});

parcelRegister("4oHox", function(module, exports) {

$parcel$export(module.exports, "L1L2", () => $333b1097991cab51$export$fb258565fa710653);
$parcel$export(module.exports, "l1", () => $333b1097991cab51$export$b35c4719d0ff29eb);
$parcel$export(module.exports, "l2", () => $333b1097991cab51$export$683828dad49492ec);
$parcel$export(module.exports, "serializeRegularizer", () => $333b1097991cab51$export$7e8cf5899b350405);
$parcel$export(module.exports, "getRegularizer", () => $333b1097991cab51$export$b3404716bfee324c);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* original source: keras/regularizers.py */ parcelRequire("5n9DG");
var $6oc11 = parcelRequire("6oc11");
var $1ZrG5 = parcelRequire("1ZrG5");
var $r7fN6 = parcelRequire("r7fN6");
var $eP0pM = parcelRequire("eP0pM");
var $8AyuI = parcelRequire("8AyuI");
var $fVwnn = parcelRequire("fVwnn");
var $9c0Qr = parcelRequire("9c0Qr");
var $7KCJq = parcelRequire("7KCJq");

var $luRak = parcelRequire("luRak");

var $khD6O = parcelRequire("khD6O");
function $333b1097991cab51$var$assertObjectArgs(args) {
    if (args != null && typeof args !== 'object') throw new Error(`Argument to L1L2 regularizer's constructor is expected to be an ` + `object, but received: ${args}`);
}
class $333b1097991cab51$export$49735e7db1366677 extends (0, $8AyuI).Serializable {
}
class $333b1097991cab51$export$fb258565fa710653 extends $333b1097991cab51$export$49735e7db1366677 {
    constructor(args){
        super();
        $333b1097991cab51$var$assertObjectArgs(args);
        this.l1 = args == null || args.l1 == null ? 0.01 : args.l1;
        this.l2 = args == null || args.l2 == null ? 0.01 : args.l2;
        this.hasL1 = this.l1 !== 0;
        this.hasL2 = this.l2 !== 0;
    }
    /**
     * Porting note: Renamed from __call__.
     * @param x Variable of which to calculate the regularization score.
     */ apply(x) {
        return (0, $9c0Qr.tidy)(()=>{
            let regularization = (0, $7KCJq.zeros)([
                1
            ]);
            if (this.hasL1) regularization = (0, $1ZrG5.add)(regularization, (0, $fVwnn.sum)($r7fN6.mul(this.l1, (0, $6oc11.abs)(x))));
            if (this.hasL2) regularization = (0, $1ZrG5.add)(regularization, (0, $fVwnn.sum)($r7fN6.mul(this.l2, $luRak.square(x))));
            return $eP0pM.reshape(regularization, []);
        });
    }
    getConfig() {
        return {
            'l1': this.l1,
            'l2': this.l2
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls({
            l1: config['l1'],
            l2: config['l2']
        });
    }
}
/** @nocollapse */ $333b1097991cab51$export$fb258565fa710653.className = 'L1L2';
(0, $8AyuI).registerClass($333b1097991cab51$export$fb258565fa710653);
function $333b1097991cab51$export$b35c4719d0ff29eb(args) {
    $333b1097991cab51$var$assertObjectArgs(args);
    return new $333b1097991cab51$export$fb258565fa710653({
        l1: args != null ? args.l1 : null,
        l2: 0
    });
}
function $333b1097991cab51$export$683828dad49492ec(args) {
    $333b1097991cab51$var$assertObjectArgs(args);
    return new $333b1097991cab51$export$fb258565fa710653({
        l2: args != null ? args.l2 : null,
        l1: 0
    });
}
const $333b1097991cab51$export$c242128098ecbfe1 = {
    'l1l2': 'L1L2'
};
function $333b1097991cab51$export$7e8cf5899b350405(constraint) {
    return (0, $khD6O.serializeKerasObject)(constraint);
}
function $333b1097991cab51$export$e53995a1d2fa3dd6(config, customObjects = {}) {
    return (0, $khD6O.deserializeKerasObject)(config, (0, $8AyuI).SerializationMap.getMap().classNameMap, customObjects, 'regularizer');
}
function $333b1097991cab51$export$b3404716bfee324c(identifier) {
    if (identifier == null) return null;
    if (typeof identifier === 'string') {
        const className = identifier in $333b1097991cab51$export$c242128098ecbfe1 ? $333b1097991cab51$export$c242128098ecbfe1[identifier] : identifier;
        const config = {
            className: className,
            config: {}
        };
        return $333b1097991cab51$export$e53995a1d2fa3dd6(config);
    } else if (identifier instanceof $333b1097991cab51$export$49735e7db1366677) return identifier;
    else return $333b1097991cab51$export$e53995a1d2fa3dd6(identifier);
}

});


parcelRegister("h6F8e", function(module, exports) {

$parcel$export(module.exports, "preprocessConv2DInput", () => $c742e71f6a41b7c6$export$8434bfc73196ab6c);
$parcel$export(module.exports, "preprocessConv3DInput", () => $c742e71f6a41b7c6$export$4ce11465fb76c4e6);
$parcel$export(module.exports, "BaseConv", () => $c742e71f6a41b7c6$export$ed9aa941a71a9fd2);
$parcel$export(module.exports, "Conv2D", () => $c742e71f6a41b7c6$export$57742e605d475795);
$parcel$export(module.exports, "Conv3D", () => $c742e71f6a41b7c6$export$9d3874201dd21933);
$parcel$export(module.exports, "Conv2DTranspose", () => $c742e71f6a41b7c6$export$7dbaf9916b0932fc);
$parcel$export(module.exports, "Conv3DTranspose", () => $c742e71f6a41b7c6$export$56aa8cf0209e38c1);
$parcel$export(module.exports, "SeparableConv2D", () => $c742e71f6a41b7c6$export$711e1c2609c1fbb3);
$parcel$export(module.exports, "Conv1D", () => $c742e71f6a41b7c6$export$34a445ae5c2580eb);
$parcel$export(module.exports, "Cropping2D", () => $c742e71f6a41b7c6$export$8c24c9344a3b8089);
$parcel$export(module.exports, "UpSampling2D", () => $c742e71f6a41b7c6$export$4b8be6e684923935);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Convolutional Layers
 */ parcelRequire("5n9DG");
var $a6dzP = parcelRequire("a6dzP");
var $cKiMT = parcelRequire("cKiMT");
var $7V1iv = parcelRequire("7V1iv");
var $jVkrH = parcelRequire("jVkrH");
var $kyRlD = parcelRequire("kyRlD");
var $iNZmA = parcelRequire("iNZmA");
var $iC1W9 = parcelRequire("iC1W9");
var $8AyuI = parcelRequire("8AyuI");
var $9c0Qr = parcelRequire("9c0Qr");
var $9PEYs = parcelRequire("9PEYs");

var $bDaSd = parcelRequire("bDaSd");

var $c51ox = parcelRequire("c51ox");

var $luRak = parcelRequire("luRak");

var $hQ5cH = parcelRequire("hQ5cH");

var $cn6Kc = parcelRequire("cn6Kc");

var $cm045 = parcelRequire("cm045");

var $jVuYK = parcelRequire("jVuYK");

var $fQ95p = parcelRequire("fQ95p");

var $4oHox = parcelRequire("4oHox");

var $4N5wj = parcelRequire("4N5wj");

var $khD6O = parcelRequire("khD6O");

var $5sw3q = parcelRequire("5sw3q");
function $c742e71f6a41b7c6$export$8434bfc73196ab6c(x, dataFormat) {
    // TODO(cais): Cast type to float32 if not.
    return (0, $9c0Qr.tidy)(()=>{
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        if (dataFormat === 'channelsFirst') return $9PEYs.transpose(x, [
            0,
            2,
            3,
            1
        ]); // NCHW -> NHWC.
        else return x;
    });
}
function $c742e71f6a41b7c6$export$4ce11465fb76c4e6(x, dataFormat) {
    return (0, $9c0Qr.tidy)(()=>{
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        if (dataFormat === 'channelsFirst') return $9PEYs.transpose(x, [
            0,
            2,
            3,
            4,
            1
        ]); // NCDHW -> NDHWC.
        else return x;
    });
}
function $c742e71f6a41b7c6$export$5e4c51f717878325(x, kernel, bias, strides = 1, padding = 'valid', dataFormat, dilationRate = 1) {
    return (0, $9c0Qr.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $c51ox.imageDataFormat)();
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        // Check the ranks of x, kernel and bias.
        if (x.shape.length !== 3) throw new (0, $jVuYK.ValueError)(`The input of a conv1dWithBias operation should be 3, but is ` + `${x.shape.length} instead.`);
        if (kernel.shape.length !== 3) throw new (0, $jVuYK.ValueError)(`The kernel for a conv1dWithBias operation should be 3, but is ` + `${kernel.shape.length} instead`);
        if (bias != null && bias.shape.length !== 1) throw new (0, $jVuYK.ValueError)(`The bias for a conv1dWithBias operation should be 1, but is ` + `${kernel.shape.length} instead`);
        // TODO(cais): Support CAUSAL padding mode.
        if (dataFormat === 'channelsFirst') x = $9PEYs.transpose(x, [
            0,
            2,
            1
        ]); // NCW -> NWC.
        if (padding === 'causal') throw new (0, $jVuYK.NotImplementedError)("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
        let y = $a6dzP.conv1d(x, kernel, strides, padding === 'same' ? 'same' : 'valid', 'NWC', dilationRate);
        if (bias != null) y = $luRak.biasAdd(y, bias);
        return y;
    });
}
function $c742e71f6a41b7c6$export$d8aa844fa36b350e(x, kernel, strides = 1, padding = 'valid', dataFormat, dilationRate = 1) {
    return (0, $9c0Qr.tidy)(()=>{
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        return $c742e71f6a41b7c6$export$5e4c51f717878325(x, kernel, null, strides, padding, dataFormat, dilationRate);
    });
}
function $c742e71f6a41b7c6$export$188f9215482e3db8(x, kernel, strides = [
    1,
    1
], padding = 'valid', dataFormat, dilationRate) {
    return (0, $9c0Qr.tidy)(()=>{
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        return $c742e71f6a41b7c6$export$8fcf8ce8bb1af9d(x, kernel, null, strides, padding, dataFormat, dilationRate);
    });
}
function $c742e71f6a41b7c6$export$8fcf8ce8bb1af9d(x, kernel, bias, strides = [
    1,
    1
], padding = 'valid', dataFormat, dilationRate, activation = null) {
    return (0, $9c0Qr.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $c51ox.imageDataFormat)();
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        if (x.rank !== 3 && x.rank !== 4) throw new (0, $jVuYK.ValueError)(`conv2dWithBiasActivation expects input to be of rank 3 or 4, ` + `but received ${x.rank}.`);
        if (kernel.rank !== 3 && kernel.rank !== 4) throw new (0, $jVuYK.ValueError)(`conv2dWithBiasActivation expects kernel to be of rank 3 or 4, ` + `but received ${x.rank}.`);
        let y = $c742e71f6a41b7c6$export$8434bfc73196ab6c(x, dataFormat);
        if (padding === 'causal') throw new (0, $jVuYK.NotImplementedError)("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
        y = $kyRlD.conv2d({
            x: y,
            filter: kernel,
            strides: strides,
            pad: padding === 'same' ? 'same' : 'valid',
            dilations: dilationRate,
            dataFormat: 'NHWC',
            bias: bias,
            activation: activation
        });
        if (dataFormat === 'channelsFirst') y = $9PEYs.transpose(y, [
            0,
            3,
            1,
            2
        ]);
        return y;
    });
}
function $c742e71f6a41b7c6$export$c476b02bcf7b2def(x, kernel, strides = [
    1,
    1,
    1
], padding = 'valid', dataFormat, dilationRate) {
    return (0, $9c0Qr.tidy)(()=>{
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        return $c742e71f6a41b7c6$export$cffde359467c6702(x, kernel, null, strides, padding, dataFormat, dilationRate);
    });
}
function $c742e71f6a41b7c6$export$cffde359467c6702(x, kernel, bias, strides = [
    1,
    1,
    1
], padding = 'valid', dataFormat, dilationRate) {
    return (0, $9c0Qr.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $c51ox.imageDataFormat)();
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        if (x.rank !== 4 && x.rank !== 5) throw new (0, $jVuYK.ValueError)(`conv3dWithBias expects input to be of rank 4 or 5, but received ` + `${x.rank}.`);
        if (kernel.rank !== 4 && kernel.rank !== 5) throw new (0, $jVuYK.ValueError)(`conv3dWithBias expects kernel to be of rank 4 or 5, but received ` + `${x.rank}.`);
        let y = $c742e71f6a41b7c6$export$4ce11465fb76c4e6(x, dataFormat);
        if (padding === 'causal') throw new (0, $jVuYK.NotImplementedError)("The support for CAUSAL padding mode in conv3dWithBias is not implemented yet.");
        y = $7V1iv.conv3d(y, kernel, strides, padding === 'same' ? 'same' : 'valid', 'NDHWC', dilationRate);
        if (bias != null) y = $luRak.biasAdd(y, bias);
        if (dataFormat === 'channelsFirst') y = $9PEYs.transpose(y, [
            0,
            4,
            1,
            2,
            3
        ]);
        return y;
    });
}
class $c742e71f6a41b7c6$export$ed9aa941a71a9fd2 extends (0, $cm045.Layer) {
    constructor(rank, args){
        super(args);
        this.bias = null;
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        $c742e71f6a41b7c6$export$ed9aa941a71a9fd2.verifyArgs(args);
        this.rank = rank;
        $khD6O.assertPositiveInteger(this.rank, 'rank');
        if (this.rank !== 1 && this.rank !== 2 && this.rank !== 3) throw new (0, $jVuYK.NotImplementedError)(`Convolution layer for rank other than 1, 2, or 3 (${this.rank}) is ` + `not implemented yet.`);
        this.kernelSize = (0, $4N5wj.normalizeArray)(args.kernelSize, rank, 'kernelSize');
        this.strides = (0, $4N5wj.normalizeArray)(args.strides == null ? 1 : args.strides, rank, 'strides');
        this.padding = args.padding == null ? 'valid' : args.padding;
        (0, $hQ5cH.checkPaddingMode)(this.padding);
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $hQ5cH.checkDataFormat)(this.dataFormat);
        this.activation = (0, $bDaSd.getActivation)(args.activation);
        this.useBias = args.useBias == null ? true : args.useBias;
        this.biasInitializer = (0, $fQ95p.getInitializer)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.biasConstraint = (0, $cn6Kc.getConstraint)(args.biasConstraint);
        this.biasRegularizer = (0, $4oHox.getRegularizer)(args.biasRegularizer);
        this.activityRegularizer = (0, $4oHox.getRegularizer)(args.activityRegularizer);
        this.dilationRate = (0, $4N5wj.normalizeArray)(args.dilationRate == null ? 1 : args.dilationRate, rank, 'dilationRate');
        if (this.rank === 1 && Array.isArray(this.dilationRate) && this.dilationRate.length !== 1) throw new (0, $jVuYK.ValueError)(`dilationRate must be a number or an array of a single number ` + `for 1D convolution, but received ` + `${JSON.stringify(this.dilationRate)}`);
        else if (this.rank === 2) {
            if (typeof this.dilationRate === 'number') this.dilationRate = [
                this.dilationRate,
                this.dilationRate
            ];
            else if (this.dilationRate.length !== 2) throw new (0, $jVuYK.ValueError)(`dilationRate must be a number or array of two numbers for 2D ` + `convolution, but received ${JSON.stringify(this.dilationRate)}`);
        } else if (this.rank === 3) {
            if (typeof this.dilationRate === 'number') this.dilationRate = [
                this.dilationRate,
                this.dilationRate,
                this.dilationRate
            ];
            else if (this.dilationRate.length !== 3) throw new (0, $jVuYK.ValueError)(`dilationRate must be a number or array of three numbers for 3D ` + `convolution, but received ${JSON.stringify(this.dilationRate)}`);
        }
    }
    static verifyArgs(args) {
        // Check config.kernelSize type and shape.
        $khD6O.assert('kernelSize' in args, `required key 'kernelSize' not in config`);
        if (typeof args.kernelSize !== 'number' && !$khD6O.checkArrayTypeAndLength(args.kernelSize, 'number', 1, 3)) throw new (0, $jVuYK.ValueError)(`BaseConv expects config.kernelSize to be number or number[] with ` + `length 1, 2, or 3, but received ${JSON.stringify(args.kernelSize)}.`);
    }
    getConfig() {
        const config = {
            kernelSize: this.kernelSize,
            strides: this.strides,
            padding: this.padding,
            dataFormat: this.dataFormat,
            dilationRate: this.dilationRate,
            activation: (0, $bDaSd.serializeActivation)(this.activation),
            useBias: this.useBias,
            biasInitializer: (0, $fQ95p.serializeInitializer)(this.biasInitializer),
            biasRegularizer: (0, $4oHox.serializeRegularizer)(this.biasRegularizer),
            activityRegularizer: (0, $4oHox.serializeRegularizer)(this.activityRegularizer),
            biasConstraint: (0, $cn6Kc.serializeConstraint)(this.biasConstraint)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $c742e71f6a41b7c6$export$d9f5537266743215 extends $c742e71f6a41b7c6$export$ed9aa941a71a9fd2 {
    constructor(rank, args){
        super(rank, args);
        this.kernel = null;
        $c742e71f6a41b7c6$export$d9f5537266743215.verifyArgs(args);
        this.filters = args.filters;
        $khD6O.assertPositiveInteger(this.filters, 'filters');
        this.kernelInitializer = (0, $fQ95p.getInitializer)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.kernelConstraint = (0, $cn6Kc.getConstraint)(args.kernelConstraint);
        this.kernelRegularizer = (0, $4oHox.getRegularizer)(args.kernelRegularizer);
    }
    build(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null) throw new (0, $jVuYK.ValueError)(`The channel dimension of the input should be defined. ` + `Found ${inputShape[channelAxis]}`);
        const inputDim = inputShape[channelAxis];
        const kernelShape = this.kernelSize.concat([
            inputDim,
            this.filters
        ]);
        this.kernel = this.addWeight('kernel', kernelShape, null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.filters
        ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        this.inputSpec = [
            {
                ndim: this.rank + 2,
                axes: {
                    [channelAxis]: inputDim
                }
            }
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            inputs = (0, $5sw3q.getExactlyOneTensor)(inputs);
            let outputs;
            const biasValue = this.bias == null ? null : this.bias.read();
            const fusedActivationName = $khD6O.mapActivationToFusedKernel(this.activation.getClassName());
            if (fusedActivationName != null && this.rank === 2) outputs = $c742e71f6a41b7c6$export$8fcf8ce8bb1af9d(inputs, this.kernel.read(), biasValue, this.strides, this.padding, this.dataFormat, this.dilationRate, fusedActivationName);
            else {
                if (this.rank === 1) outputs = $c742e71f6a41b7c6$export$5e4c51f717878325(inputs, this.kernel.read(), biasValue, this.strides[0], this.padding, this.dataFormat, this.dilationRate[0]);
                else if (this.rank === 2) // TODO(cais): Move up to constructor.
                outputs = $c742e71f6a41b7c6$export$8fcf8ce8bb1af9d(inputs, this.kernel.read(), biasValue, this.strides, this.padding, this.dataFormat, this.dilationRate);
                else if (this.rank === 3) outputs = $c742e71f6a41b7c6$export$cffde359467c6702(inputs, this.kernel.read(), biasValue, this.strides, this.padding, this.dataFormat, this.dilationRate);
                else throw new (0, $jVuYK.NotImplementedError)('convolutions greater than 3D are not implemented yet.');
                if (this.activation != null) outputs = this.activation.apply(outputs);
            }
            return outputs;
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const newSpace = [];
        const space = this.dataFormat === 'channelsLast' ? inputShape.slice(1, inputShape.length - 1) : inputShape.slice(2);
        for(let i = 0; i < space.length; ++i){
            const newDim = (0, $4N5wj.convOutputLength)(space[i], this.kernelSize[i], this.padding, this.strides[i], typeof this.dilationRate === 'number' ? this.dilationRate : this.dilationRate[i]);
            newSpace.push(newDim);
        }
        let outputShape = [
            inputShape[0]
        ];
        if (this.dataFormat === 'channelsLast') {
            outputShape = outputShape.concat(newSpace);
            outputShape.push(this.filters);
        } else {
            outputShape.push(this.filters);
            outputShape = outputShape.concat(newSpace);
        }
        return outputShape;
    }
    getConfig() {
        const config = {
            filters: this.filters,
            kernelInitializer: (0, $fQ95p.serializeInitializer)(this.kernelInitializer),
            kernelRegularizer: (0, $4oHox.serializeRegularizer)(this.kernelRegularizer),
            kernelConstraint: (0, $cn6Kc.serializeConstraint)(this.kernelConstraint)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    static verifyArgs(args) {
        // Check config.filters type, shape, and value.
        if (!('filters' in args) || typeof args.filters !== 'number' || args.filters < 1) throw new (0, $jVuYK.ValueError)(`Convolution layer expected config.filters to be a 'number' > 0 ` + `but got ${JSON.stringify(args.filters)}`);
    }
}
class $c742e71f6a41b7c6$export$57742e605d475795 extends $c742e71f6a41b7c6$export$d9f5537266743215 {
    constructor(args){
        super(2, args);
        $c742e71f6a41b7c6$export$57742e605d475795.verifyArgs(args);
    }
    getConfig() {
        const config = super.getConfig();
        delete config['rank'];
        return config;
    }
    static verifyArgs(args) {
        // config.kernelSize must be a number or array of numbers.
        if (typeof args.kernelSize !== 'number' && !$khD6O.checkArrayTypeAndLength(args.kernelSize, 'number', 1, 2)) throw new (0, $jVuYK.ValueError)(`Conv2D expects config.kernelSize to be number or number[] with ` + `length 1 or 2, but received ${JSON.stringify(args.kernelSize)}.`);
    }
}
/** @nocollapse */ $c742e71f6a41b7c6$export$57742e605d475795.className = 'Conv2D';
(0, $8AyuI).registerClass($c742e71f6a41b7c6$export$57742e605d475795);
class $c742e71f6a41b7c6$export$9d3874201dd21933 extends $c742e71f6a41b7c6$export$d9f5537266743215 {
    constructor(args){
        super(3, args);
        $c742e71f6a41b7c6$export$9d3874201dd21933.verifyArgs(args);
    }
    getConfig() {
        const config = super.getConfig();
        delete config['rank'];
        return config;
    }
    static verifyArgs(args) {
        // config.kernelSize must be a number or array of numbers.
        if (typeof args.kernelSize !== 'number') {
            if (!(Array.isArray(args.kernelSize) && (args.kernelSize.length === 1 || args.kernelSize.length === 3))) throw new (0, $jVuYK.ValueError)(`Conv3D expects config.kernelSize to be number or` + ` [number, number, number], but received ${JSON.stringify(args.kernelSize)}.`);
        }
    }
}
/** @nocollapse */ $c742e71f6a41b7c6$export$9d3874201dd21933.className = 'Conv3D';
(0, $8AyuI).registerClass($c742e71f6a41b7c6$export$9d3874201dd21933);
class $c742e71f6a41b7c6$export$7dbaf9916b0932fc extends $c742e71f6a41b7c6$export$57742e605d475795 {
    constructor(args){
        super(args);
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: 4
            })
        ];
        if (this.padding !== 'same' && this.padding !== 'valid') throw new (0, $jVuYK.ValueError)(`Conv2DTranspose currently supports only padding modes 'same' ` + `and 'valid', but received padding mode ${this.padding}`);
    }
    build(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        if (inputShape.length !== 4) throw new (0, $jVuYK.ValueError)('Input should have rank 4; Received input shape: ' + JSON.stringify(inputShape));
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null) throw new (0, $jVuYK.ValueError)("The channel dimension of the inputs should be defined. Found `None`.");
        const inputDim = inputShape[channelAxis];
        const kernelShape = this.kernelSize.concat([
            this.filters,
            inputDim
        ]);
        this.kernel = this.addWeight('kernel', kernelShape, 'float32', this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.filters
        ], 'float32', this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        // Set input spec.
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: 4,
                axes: {
                    [channelAxis]: inputDim
                }
            })
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        return $9c0Qr.tidy(()=>{
            let input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            if (input.shape.length !== 4) throw new (0, $jVuYK.ValueError)(`Conv2DTranspose.call() expects input tensor to be rank-4, but ` + `received a tensor of rank-${input.shape.length}`);
            const inputShape = input.shape;
            const batchSize = inputShape[0];
            let hAxis;
            let wAxis;
            if (this.dataFormat === 'channelsFirst') {
                hAxis = 2;
                wAxis = 3;
            } else {
                hAxis = 1;
                wAxis = 2;
            }
            const height = inputShape[hAxis];
            const width = inputShape[wAxis];
            const kernelH = this.kernelSize[0];
            const kernelW = this.kernelSize[1];
            const strideH = this.strides[0];
            const strideW = this.strides[1];
            // Infer the dynamic output shape.
            const outHeight = (0, $4N5wj.deconvLength)(height, strideH, kernelH, this.padding);
            const outWidth = (0, $4N5wj.deconvLength)(width, strideW, kernelW, this.padding);
            // Porting Note: We don't branch based on `this.dataFormat` here,
            // because
            //   the tjfs-core function `conv2dTranspose` called below always
            //   assumes channelsLast.
            const outputShape = [
                batchSize,
                outHeight,
                outWidth,
                this.filters
            ];
            if (this.dataFormat !== 'channelsLast') input = $9PEYs.transpose(input, [
                0,
                2,
                3,
                1
            ]);
            let outputs = $cKiMT.conv2dTranspose(input, this.kernel.read(), outputShape, this.strides, this.padding);
            if (this.dataFormat !== 'channelsLast') outputs = $9PEYs.transpose(outputs, [
                0,
                3,
                1,
                2
            ]);
            if (this.bias != null) outputs = $luRak.biasAdd(outputs, this.bias.read(), this.dataFormat);
            if (this.activation != null) outputs = this.activation.apply(outputs);
            return outputs;
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const outputShape = inputShape.slice();
        let channelAxis;
        let heightAxis;
        let widthAxis;
        if (this.dataFormat === 'channelsFirst') {
            channelAxis = 1;
            heightAxis = 2;
            widthAxis = 3;
        } else {
            channelAxis = 3;
            heightAxis = 1;
            widthAxis = 2;
        }
        const kernelH = this.kernelSize[0];
        const kernelW = this.kernelSize[1];
        const strideH = this.strides[0];
        const strideW = this.strides[1];
        outputShape[channelAxis] = this.filters;
        outputShape[heightAxis] = (0, $4N5wj.deconvLength)(outputShape[heightAxis], strideH, kernelH, this.padding);
        outputShape[widthAxis] = (0, $4N5wj.deconvLength)(outputShape[widthAxis], strideW, kernelW, this.padding);
        return outputShape;
    }
    getConfig() {
        const config = super.getConfig();
        delete config['dilationRate'];
        return config;
    }
}
/** @nocollapse */ $c742e71f6a41b7c6$export$7dbaf9916b0932fc.className = 'Conv2DTranspose';
(0, $8AyuI).registerClass($c742e71f6a41b7c6$export$7dbaf9916b0932fc);
class $c742e71f6a41b7c6$export$56aa8cf0209e38c1 extends $c742e71f6a41b7c6$export$9d3874201dd21933 {
    constructor(args){
        super(args);
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: 5
            })
        ];
        if (this.padding !== 'same' && this.padding !== 'valid') throw new (0, $jVuYK.ValueError)(`Conv3DTranspose currently supports only padding modes 'same' ` + `and 'valid', but received padding mode ${this.padding}`);
    }
    build(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        if (inputShape.length !== 5) throw new (0, $jVuYK.ValueError)('Input should have rank 5; Received input shape: ' + JSON.stringify(inputShape));
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null) throw new (0, $jVuYK.ValueError)("The channel dimension of the inputs should be defined. Found `None`.");
        const inputDim = inputShape[channelAxis];
        const kernelShape = this.kernelSize.concat([
            this.filters,
            inputDim
        ]);
        this.kernel = this.addWeight('kernel', kernelShape, 'float32', this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.filters
        ], 'float32', this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        // Set input spec.
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: 5,
                axes: {
                    [channelAxis]: inputDim
                }
            })
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        return $9c0Qr.tidy(()=>{
            let input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            if (input.shape.length !== 5) throw new (0, $jVuYK.ValueError)(`Conv3DTranspose.call() expects input tensor to be rank-4, but ` + `received a tensor of rank-${input.shape.length}`);
            const inputShape = input.shape;
            const batchSize = inputShape[0];
            let hAxis;
            let wAxis;
            let dAxis;
            if (this.dataFormat === 'channelsFirst') {
                dAxis = 2;
                hAxis = 3;
                wAxis = 4;
            } else {
                dAxis = 1;
                hAxis = 2;
                wAxis = 3;
            }
            const depth = inputShape[dAxis];
            const height = inputShape[hAxis];
            const width = inputShape[wAxis];
            const kernelD = this.kernelSize[0];
            const kernelH = this.kernelSize[1];
            const kernelW = this.kernelSize[2];
            const strideD = this.strides[0];
            const strideH = this.strides[1];
            const strideW = this.strides[2];
            // Infer the dynamic output shape.
            const outDepth = (0, $4N5wj.deconvLength)(depth, strideD, kernelD, this.padding);
            const outHeight = (0, $4N5wj.deconvLength)(height, strideH, kernelH, this.padding);
            const outWidth = (0, $4N5wj.deconvLength)(width, strideW, kernelW, this.padding);
            // Same as `conv2dTranspose`. We always assumes channelsLast.
            const outputShape = [
                batchSize,
                outDepth,
                outHeight,
                outWidth,
                this.filters
            ];
            if (this.dataFormat !== 'channelsLast') input = $9PEYs.transpose(input, [
                0,
                2,
                3,
                4,
                1
            ]);
            let outputs = $jVkrH.conv3dTranspose(input, this.kernel.read(), outputShape, this.strides, this.padding);
            if (this.dataFormat !== 'channelsLast') outputs = $9PEYs.transpose(outputs, [
                0,
                4,
                1,
                2,
                3
            ]);
            if (this.bias !== null) outputs = $luRak.biasAdd(outputs, this.bias.read(), this.dataFormat);
            if (this.activation !== null) outputs = this.activation.apply(outputs);
            return outputs;
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const outputShape = inputShape.slice();
        let channelAxis;
        let depthAxis;
        let heightAxis;
        let widthAxis;
        if (this.dataFormat === 'channelsFirst') {
            channelAxis = 1;
            depthAxis = 2;
            heightAxis = 3;
            widthAxis = 4;
        } else {
            channelAxis = 4;
            depthAxis = 1;
            heightAxis = 2;
            widthAxis = 3;
        }
        const kernelD = this.kernelSize[0];
        const kernelH = this.kernelSize[1];
        const kernelW = this.kernelSize[2];
        const strideD = this.strides[0];
        const strideH = this.strides[1];
        const strideW = this.strides[2];
        outputShape[channelAxis] = this.filters;
        outputShape[depthAxis] = (0, $4N5wj.deconvLength)(outputShape[depthAxis], strideD, kernelD, this.padding);
        outputShape[heightAxis] = (0, $4N5wj.deconvLength)(outputShape[heightAxis], strideH, kernelH, this.padding);
        outputShape[widthAxis] = (0, $4N5wj.deconvLength)(outputShape[widthAxis], strideW, kernelW, this.padding);
        return outputShape;
    }
    getConfig() {
        const config = super.getConfig();
        delete config['dilationRate'];
        return config;
    }
}
/** @nocollapse */ $c742e71f6a41b7c6$export$56aa8cf0209e38c1.className = 'Conv3DTranspose';
(0, $8AyuI).registerClass($c742e71f6a41b7c6$export$56aa8cf0209e38c1);
class $c742e71f6a41b7c6$export$1b7b94ed9bbc01d1 extends $c742e71f6a41b7c6$export$d9f5537266743215 {
    constructor(rank, config){
        super(rank, config);
        this.DEFAULT_DEPTHWISE_INITIALIZER = 'glorotUniform';
        this.DEFAULT_POINTWISE_INITIALIZER = 'glorotUniform';
        this.depthwiseKernel = null;
        this.pointwiseKernel = null;
        if (config.filters == null) throw new (0, $jVuYK.ValueError)("The `filters` configuration field is required by SeparableConv, but is unspecified.");
        if (config.kernelInitializer != null || config.kernelRegularizer != null || config.kernelConstraint != null) throw new (0, $jVuYK.ValueError)("Fields kernelInitializer, kernelRegularizer and kernelConstraint are invalid for SeparableConv2D. Use depthwiseInitializer, depthwiseRegularizer, depthwiseConstraint, pointwiseInitializer, pointwiseRegularizer and pointwiseConstraint instead.");
        if (config.padding != null && config.padding !== 'same' && config.padding !== 'valid') throw new (0, $jVuYK.ValueError)(`SeparableConv${this.rank}D supports only padding modes: ` + `'same' and 'valid', but received ${JSON.stringify(config.padding)}`);
        this.depthMultiplier = config.depthMultiplier == null ? 1 : config.depthMultiplier;
        this.depthwiseInitializer = (0, $fQ95p.getInitializer)(config.depthwiseInitializer || this.DEFAULT_DEPTHWISE_INITIALIZER);
        this.depthwiseRegularizer = (0, $4oHox.getRegularizer)(config.depthwiseRegularizer);
        this.depthwiseConstraint = (0, $cn6Kc.getConstraint)(config.depthwiseConstraint);
        this.pointwiseInitializer = (0, $fQ95p.getInitializer)(config.depthwiseInitializer || this.DEFAULT_POINTWISE_INITIALIZER);
        this.pointwiseRegularizer = (0, $4oHox.getRegularizer)(config.pointwiseRegularizer);
        this.pointwiseConstraint = (0, $cn6Kc.getConstraint)(config.pointwiseConstraint);
    }
    build(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        if (inputShape.length < this.rank + 2) throw new (0, $jVuYK.ValueError)(`Inputs to SeparableConv${this.rank}D should have rank ` + `${this.rank + 2}, but received input shape: ` + `${JSON.stringify(inputShape)}`);
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null || inputShape[channelAxis] < 0) throw new (0, $jVuYK.ValueError)(`The channel dimension of the inputs should be defined, ` + `but found ${JSON.stringify(inputShape[channelAxis])}`);
        const inputDim = inputShape[channelAxis];
        const depthwiseKernelShape = this.kernelSize.concat([
            inputDim,
            this.depthMultiplier
        ]);
        const pointwiseKernelShape = [];
        for(let i = 0; i < this.rank; ++i)pointwiseKernelShape.push(1);
        pointwiseKernelShape.push(inputDim * this.depthMultiplier, this.filters);
        const trainable = true;
        this.depthwiseKernel = this.addWeight('depthwise_kernel', depthwiseKernelShape, 'float32', this.depthwiseInitializer, this.depthwiseRegularizer, trainable, this.depthwiseConstraint);
        this.pointwiseKernel = this.addWeight('pointwise_kernel', pointwiseKernelShape, 'float32', this.pointwiseInitializer, this.pointwiseRegularizer, trainable, this.pointwiseConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.filters
        ], 'float32', this.biasInitializer, this.biasRegularizer, trainable, this.biasConstraint);
        else this.bias = null;
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: this.rank + 2,
                axes: {
                    [channelAxis]: inputDim
                }
            })
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            inputs = (0, $5sw3q.getExactlyOneTensor)(inputs);
            let output;
            if (this.rank === 1) throw new (0, $jVuYK.NotImplementedError)('1D separable convolution is not implemented yet.');
            else if (this.rank === 2) {
                if (this.dataFormat === 'channelsFirst') inputs = $9PEYs.transpose(inputs, [
                    0,
                    2,
                    3,
                    1
                ]); // NCHW -> NHWC.
                output = $iC1W9.separableConv2d(inputs, this.depthwiseKernel.read(), this.pointwiseKernel.read(), this.strides, this.padding, this.dilationRate, 'NHWC');
            }
            if (this.useBias) output = $luRak.biasAdd(output, this.bias.read(), this.dataFormat);
            if (this.activation != null) output = this.activation.apply(output);
            if (this.dataFormat === 'channelsFirst') output = $9PEYs.transpose(output, [
                0,
                3,
                1,
                2
            ]); // NHWC -> NCHW.
            return output;
        });
    }
    getConfig() {
        const config = super.getConfig();
        delete config['rank'];
        delete config['kernelInitializer'];
        delete config['kernelRegularizer'];
        delete config['kernelConstraint'];
        config['depthwiseInitializer'] = (0, $fQ95p.serializeInitializer)(this.depthwiseInitializer);
        config['pointwiseInitializer'] = (0, $fQ95p.serializeInitializer)(this.pointwiseInitializer);
        config['depthwiseRegularizer'] = (0, $4oHox.serializeRegularizer)(this.depthwiseRegularizer);
        config['pointwiseRegularizer'] = (0, $4oHox.serializeRegularizer)(this.pointwiseRegularizer);
        config['depthwiseConstraint'] = (0, $cn6Kc.serializeConstraint)(this.depthwiseConstraint);
        config['pointwiseConstraint'] = (0, $cn6Kc.serializeConstraint)(this.pointwiseConstraint);
        return config;
    }
}
/** @nocollapse */ $c742e71f6a41b7c6$export$1b7b94ed9bbc01d1.className = 'SeparableConv';
class $c742e71f6a41b7c6$export$711e1c2609c1fbb3 extends $c742e71f6a41b7c6$export$1b7b94ed9bbc01d1 {
    constructor(args){
        super(2, args);
    }
}
/** @nocollapse */ $c742e71f6a41b7c6$export$711e1c2609c1fbb3.className = 'SeparableConv2D';
(0, $8AyuI).registerClass($c742e71f6a41b7c6$export$711e1c2609c1fbb3);
class $c742e71f6a41b7c6$export$34a445ae5c2580eb extends $c742e71f6a41b7c6$export$d9f5537266743215 {
    constructor(args){
        super(1, args);
        $c742e71f6a41b7c6$export$34a445ae5c2580eb.verifyArgs(args);
        this.inputSpec = [
            {
                ndim: 3
            }
        ];
    }
    getConfig() {
        const config = super.getConfig();
        delete config['rank'];
        delete config['dataFormat'];
        return config;
    }
    static verifyArgs(args) {
        // config.kernelSize must be a number or array of numbers.
        if (typeof args.kernelSize !== 'number' && !$khD6O.checkArrayTypeAndLength(args.kernelSize, 'number', 1, 1)) throw new (0, $jVuYK.ValueError)(`Conv1D expects config.kernelSize to be number or number[] with ` + `length 1, but received ${JSON.stringify(args.kernelSize)}.`);
    }
}
/** @nocollapse */ $c742e71f6a41b7c6$export$34a445ae5c2580eb.className = 'Conv1D';
(0, $8AyuI).registerClass($c742e71f6a41b7c6$export$34a445ae5c2580eb);
class $c742e71f6a41b7c6$export$8c24c9344a3b8089 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        if (typeof args.cropping === 'number') this.cropping = [
            [
                args.cropping,
                args.cropping
            ],
            [
                args.cropping,
                args.cropping
            ]
        ];
        else if (typeof args.cropping[0] === 'number') this.cropping = [
            [
                args.cropping[0],
                args.cropping[0]
            ],
            [
                args.cropping[1],
                args.cropping[1]
            ]
        ];
        else this.cropping = args.cropping;
        this.dataFormat = args.dataFormat === undefined ? 'channelsLast' : args.dataFormat;
        this.inputSpec = [
            {
                ndim: 4
            }
        ];
    }
    computeOutputShape(inputShape) {
        if (this.dataFormat === 'channelsFirst') return [
            inputShape[0],
            inputShape[1],
            inputShape[2] - this.cropping[0][0] - this.cropping[0][1],
            inputShape[3] - this.cropping[1][0] - this.cropping[1][1]
        ];
        else return [
            inputShape[0],
            inputShape[1] - this.cropping[0][0] - this.cropping[0][1],
            inputShape[2] - this.cropping[1][0] - this.cropping[1][1],
            inputShape[3]
        ];
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            inputs = (0, $5sw3q.getExactlyOneTensor)(inputs);
            if (this.dataFormat === 'channelsLast') {
                const hSliced = $luRak.sliceAlongAxis(inputs, this.cropping[0][0], inputs.shape[1] - this.cropping[0][0] - this.cropping[0][1], 2);
                return $luRak.sliceAlongAxis(hSliced, this.cropping[1][0], inputs.shape[2] - this.cropping[1][1] - this.cropping[1][0], 3);
            } else {
                const hSliced = $luRak.sliceAlongAxis(inputs, this.cropping[0][0], inputs.shape[2] - this.cropping[0][0] - this.cropping[0][1], 3);
                return $luRak.sliceAlongAxis(hSliced, this.cropping[1][0], inputs.shape[3] - this.cropping[1][1] - this.cropping[1][0], 4);
            }
        });
    }
    getConfig() {
        const config = {
            cropping: this.cropping,
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c742e71f6a41b7c6$export$8c24c9344a3b8089.className = 'Cropping2D';
(0, $8AyuI).registerClass($c742e71f6a41b7c6$export$8c24c9344a3b8089);
class $c742e71f6a41b7c6$export$4b8be6e684923935 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        this.DEFAULT_SIZE = [
            2,
            2
        ];
        this.inputSpec = [
            {
                ndim: 4
            }
        ];
        this.size = args.size == null ? this.DEFAULT_SIZE : args.size;
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $hQ5cH.checkDataFormat)(this.dataFormat);
        this.interpolation = args.interpolation == null ? 'nearest' : args.interpolation;
        (0, $hQ5cH.checkInterpolationFormat)(this.interpolation);
    }
    computeOutputShape(inputShape) {
        if (this.dataFormat === 'channelsFirst') {
            const height = inputShape[2] == null ? null : this.size[0] * inputShape[2];
            const width = inputShape[3] == null ? null : this.size[1] * inputShape[3];
            return [
                inputShape[0],
                inputShape[1],
                height,
                width
            ];
        } else {
            const height = inputShape[1] == null ? null : this.size[0] * inputShape[1];
            const width = inputShape[2] == null ? null : this.size[1] * inputShape[2];
            return [
                inputShape[0],
                height,
                width,
                inputShape[3]
            ];
        }
    }
    call(inputs, kwargs) {
        return $9c0Qr.tidy(()=>{
            let input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            const inputShape = input.shape;
            if (this.dataFormat === 'channelsFirst') {
                input = $9PEYs.transpose(input, [
                    0,
                    2,
                    3,
                    1
                ]);
                const height = this.size[0] * inputShape[2];
                const width = this.size[1] * inputShape[3];
                const resized = this.interpolation === 'nearest' ? $iNZmA.image.resizeNearestNeighbor(input, [
                    height,
                    width
                ]) : $iNZmA.image.resizeBilinear(input, [
                    height,
                    width
                ]);
                return $9PEYs.transpose(resized, [
                    0,
                    3,
                    1,
                    2
                ]);
            } else {
                const height = this.size[0] * inputShape[1];
                const width = this.size[1] * inputShape[2];
                return this.interpolation === 'nearest' ? $iNZmA.image.resizeNearestNeighbor(input, [
                    height,
                    width
                ]) : $iNZmA.image.resizeBilinear(input, [
                    height,
                    width
                ]);
            }
        });
    }
    getConfig() {
        const config = {
            size: this.size,
            dataFormat: this.dataFormat,
            interpolation: this.interpolation
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $c742e71f6a41b7c6$export$4b8be6e684923935.className = 'UpSampling2D';
(0, $8AyuI).registerClass($c742e71f6a41b7c6$export$4b8be6e684923935);

});
parcelRegister("4N5wj", function(module, exports) {

$parcel$export(module.exports, "normalizeArray", () => $37d0053c29773c46$export$8f561980df117376);
$parcel$export(module.exports, "convOutputLength", () => $37d0053c29773c46$export$50b0adaed374172);
$parcel$export(module.exports, "deconvLength", () => $37d0053c29773c46$export$5a2f093e914c7860);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $jVuYK = parcelRequire("jVuYK");

var $khD6O = parcelRequire("khD6O");

var $jBJAM = parcelRequire("jBJAM");
function $37d0053c29773c46$export$8f561980df117376(value, n, name) {
    if (typeof value === 'number') return (0, $khD6O.pyListRepeat)(value, n);
    else {
        if (value.length !== n) throw new (0, $jVuYK.ValueError)(`The ${name} argument must be an integer or tuple of ${n} integers.` + ` Received: ${value.length} elements.`);
        for(let i = 0; i < n; ++i){
            const singleValue = value[i];
            if (!(0, $jBJAM.isInteger)(singleValue)) throw new (0, $jVuYK.ValueError)(`The ${name} argument must be an integer or tuple of ${n}` + ` integers. Received: ${JSON.stringify(value)} including a` + ` non-integer number ${singleValue}`);
        }
        return value;
    }
}
function $37d0053c29773c46$export$50b0adaed374172(inputLength, filterSize, padding, stride, dilation = 1) {
    if (inputLength == null) return inputLength;
    const dilatedFilterSize = filterSize + (filterSize - 1) * (dilation - 1);
    let outputLength;
    if (padding === 'same') outputLength = inputLength;
    else outputLength = inputLength - dilatedFilterSize + 1;
    return Math.floor((outputLength + stride - 1) / stride);
}
function $37d0053c29773c46$export$5a2f093e914c7860(dimSize, strideSize, kernelSize, padding) {
    if (dimSize == null) return null;
    if (padding === 'valid') dimSize = dimSize * strideSize + (0, $jBJAM.max)([
        kernelSize - strideSize,
        0
    ]);
    else if (padding === 'same') dimSize = dimSize * strideSize;
    else throw new (0, $jVuYK.ValueError)(`Unsupport padding mode: ${padding}.`);
    return dimSize;
}

});


parcelRegister("3dl56", function(module, exports) {

$parcel$export(module.exports, "DepthwiseConv2D", () => $2572f04ed0e9bef6$export$292dab92c4661cc4);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Depthwise Convolutional Layers
 */ parcelRequire("5n9DG");
var $kDOuZ = parcelRequire("kDOuZ");
var $8AyuI = parcelRequire("8AyuI");
var $9c0Qr = parcelRequire("9c0Qr");
var $9PEYs = parcelRequire("9PEYs");

var $c51ox = parcelRequire("c51ox");

var $luRak = parcelRequire("luRak");

var $hQ5cH = parcelRequire("hQ5cH");

var $cn6Kc = parcelRequire("cn6Kc");

var $jVuYK = parcelRequire("jVuYK");

var $fQ95p = parcelRequire("fQ95p");

var $4oHox = parcelRequire("4oHox");

var $4N5wj = parcelRequire("4N5wj");

var $5sw3q = parcelRequire("5sw3q");

var $h6F8e = parcelRequire("h6F8e");
function $2572f04ed0e9bef6$export$48a8ad9494a8fad8(x, depthwiseKernel, strides = [
    1,
    1
], padding = 'valid', dataFormat, dilationRate) {
    return (0, $9c0Qr.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $c51ox.imageDataFormat)();
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        let y = (0, $h6F8e.preprocessConv2DInput)(x, dataFormat);
        if (x.rank !== 4) throw new (0, $jVuYK.ValueError)(`Input for depthwiseConv2d is required to be 4-D, but is instead ` + `${x.rank}-D`);
        if (depthwiseKernel.rank !== 4) throw new (0, $jVuYK.ValueError)(`depthwiseKernel is required to be 4-D, but is instead ` + `${depthwiseKernel.rank}-D`);
        y = $kDOuZ.depthwiseConv2d(y, depthwiseKernel, strides, padding === 'same' ? 'same' : 'valid', 'NHWC', dilationRate);
        if (dataFormat === 'channelsFirst') y = $9PEYs.transpose(y, [
            0,
            3,
            1,
            2
        ]);
        return y;
    });
}
class $2572f04ed0e9bef6$export$292dab92c4661cc4 extends (0, $h6F8e.BaseConv) {
    constructor(args){
        super(2, args);
        this.depthwiseKernel = null;
        this.depthMultiplier = args.depthMultiplier == null ? 1 : args.depthMultiplier;
        this.depthwiseInitializer = (0, $fQ95p.getInitializer)(args.depthwiseInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.depthwiseConstraint = (0, $cn6Kc.getConstraint)(args.depthwiseConstraint);
        this.depthwiseRegularizer = (0, $4oHox.getRegularizer)(args.depthwiseRegularizer);
    }
    build(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        if (inputShape.length < 4) throw new (0, $jVuYK.ValueError)(`Inputs to DepthwiseConv2D should have rank 4. ` + `Received input shape: ${JSON.stringify(inputShape)}.`);
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : 3;
        if (inputShape[channelAxis] == null || inputShape[channelAxis] < 0) throw new (0, $jVuYK.ValueError)('The channel dimension of the inputs to DepthwiseConv2D should ' + `be defined, but is not (${inputShape[channelAxis]}).`);
        const inputDim = inputShape[channelAxis];
        const depthwiseKernelShape = [
            this.kernelSize[0],
            this.kernelSize[1],
            inputDim,
            this.depthMultiplier
        ];
        this.depthwiseKernel = this.addWeight('depthwise_kernel', depthwiseKernelShape, null, this.depthwiseInitializer, this.depthwiseRegularizer, true, this.depthwiseConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            inputDim * this.depthMultiplier
        ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        else this.bias = null;
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            inputs = (0, $5sw3q.getExactlyOneTensor)(inputs);
            let outputs = $2572f04ed0e9bef6$export$48a8ad9494a8fad8(inputs, this.depthwiseKernel.read(), this.strides, this.padding, this.dataFormat, null);
            // TODO(cais): Add support for dilation.
            if (this.useBias) outputs = $luRak.biasAdd(outputs, this.bias.read(), this.dataFormat);
            if (this.activation != null) outputs = this.activation.apply(outputs);
            return outputs;
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const rows = this.dataFormat === 'channelsFirst' ? inputShape[2] : inputShape[1];
        const cols = this.dataFormat === 'channelsFirst' ? inputShape[3] : inputShape[2];
        const outFilters = this.dataFormat === 'channelsFirst' ? inputShape[1] * this.depthMultiplier : inputShape[3] * this.depthMultiplier;
        const outRows = (0, $4N5wj.convOutputLength)(rows, this.kernelSize[0], this.padding, this.strides[0]);
        const outCols = (0, $4N5wj.convOutputLength)(cols, this.kernelSize[1], this.padding, this.strides[1]);
        if (this.dataFormat === 'channelsFirst') return [
            inputShape[0],
            outFilters,
            outRows,
            outCols
        ];
        else // In this case, assume 'channelsLast'.
        return [
            inputShape[0],
            outRows,
            outCols,
            outFilters
        ];
    }
    getConfig() {
        const config = super.getConfig();
        config['depthMultiplier'] = this.depthMultiplier;
        config['depthwiseInitializer'] = (0, $fQ95p.serializeInitializer)(this.depthwiseInitializer);
        config['depthwiseRegularizer'] = (0, $4oHox.serializeRegularizer)(this.depthwiseRegularizer);
        config['depthwiseConstraint'] = (0, $cn6Kc.serializeConstraint)(this.depthwiseRegularizer);
        return config;
    }
}
/** @nocollapse */ $2572f04ed0e9bef6$export$292dab92c4661cc4.className = 'DepthwiseConv2D';
(0, $8AyuI).registerClass($2572f04ed0e9bef6$export$292dab92c4661cc4);

});

parcelRegister("52hJq", function(module, exports) {

$parcel$export(module.exports, "ConvLSTM2DCell", () => $3aaae4c717d58908$export$6fd0801294342e82);
$parcel$export(module.exports, "ConvLSTM2D", () => $3aaae4c717d58908$export$d5828f4b24c3231);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $1ZrG5 = parcelRequire("1ZrG5");
var $jOBWR = parcelRequire("jOBWR");
var $9c0Qr = parcelRequire("9c0Qr");
var $r7fN6 = parcelRequire("r7fN6");
var $bhi4b = parcelRequire("bhi4b");
var $9u8DQ = parcelRequire("9u8DQ");
var $8AyuI = parcelRequire("8AyuI");
var $9DjTt = parcelRequire("9DjTt");
var $wx9lK = parcelRequire("wx9lK");
var $7KCJq = parcelRequire("7KCJq");

var $luRak = parcelRequire("luRak");

var $hQ5cH = parcelRequire("hQ5cH");

var $cm045 = parcelRequire("cm045");

var $jVuYK = parcelRequire("jVuYK");

var $fQ95p = parcelRequire("fQ95p");

var $4N5wj = parcelRequire("4N5wj");

var $khD6O = parcelRequire("khD6O");

var $5sw3q = parcelRequire("5sw3q");

var $ejY9c = parcelRequire("ejY9c");
var $3aaae4c717d58908$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $3aaae4c717d58908$var$ConvRNN2DCell extends (0, $ejY9c.RNNCell) {
}
/**
 * Base class for convolutional-recurrent layers.
 */ class $3aaae4c717d58908$var$ConvRNN2D extends (0, $ejY9c.RNN) {
    constructor(args){
        if (args.unroll) throw new (0, $jVuYK.NotImplementedError)('Unrolling is not possible with convolutional RNNs.');
        if (Array.isArray(args.cell)) throw new (0, $jVuYK.NotImplementedError)('It is not possible at the moment to stack convolutional cells.');
        super(args);
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: 5
            })
        ];
    }
    call(inputs, kwargs) {
        return $9c0Qr.tidy(()=>{
            if (this.cell.dropoutMask != null) {
                $9c0Qr.dispose(this.cell.dropoutMask);
                this.cell.dropoutMask = null;
            }
            if (this.cell.recurrentDropoutMask != null) {
                $9c0Qr.dispose(this.cell.recurrentDropoutMask);
                this.cell.recurrentDropoutMask = null;
            }
            if (kwargs && kwargs['constants']) throw new (0, $jVuYK.ValueError)('ConvRNN2D cell does not support constants');
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            const initialState = kwargs == null ? null : kwargs['initialState'];
            return super.call(inputs, {
                mask: mask,
                training: training,
                initialState: initialState
            });
        });
    }
    computeOutputShape(inputShape) {
        let outShape = this.computeSingleOutputShape(inputShape);
        if (!this.returnSequences) outShape = [
            outShape[0],
            ...outShape.slice(2)
        ];
        if (this.returnState) outShape = [
            outShape,
            ...Array(2).fill([
                inputShape[0],
                ...outShape.slice(-3)
            ])
        ];
        return outShape;
    }
    getInitialState(inputs) {
        return $9c0Qr.tidy(()=>{
            const { stateSize: stateSize } = this.cell;
            const inputShape = inputs.shape;
            const outputShape = this.computeSingleOutputShape(inputShape);
            const stateShape = [
                outputShape[0],
                ...outputShape.slice(2)
            ];
            const initialState = $7KCJq.zeros(stateShape);
            if (Array.isArray(stateSize)) return Array(stateSize.length).fill(initialState);
            return [
                initialState
            ];
        });
    }
    resetStates(states, training = false) {
        $9c0Qr.tidy(()=>{
            if (!this.stateful) throw new (0, $jVuYK.AttributeError)('Cannot call resetStates() on an RNN Layer that is not stateful.');
            const inputShape = this.inputSpec[0].shape;
            const outputShape = this.computeSingleOutputShape(inputShape);
            const stateShape = [
                outputShape[0],
                ...outputShape.slice(2)
            ];
            const batchSize = inputShape[0];
            if (batchSize == null) throw new (0, $jVuYK.ValueError)("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
            // Initialize state if null.
            if (this.getStates() == null) {
                if (Array.isArray(this.cell.stateSize)) this.states_ = this.cell.stateSize.map(()=>$7KCJq.zeros(stateShape));
                else this.states_ = [
                    $7KCJq.zeros(stateShape)
                ];
            } else if (states == null) {
                // Dispose old state tensors.
                $9c0Qr.dispose(this.states_);
                // For stateful RNNs, fully dispose kept old states.
                if (this.keptStates != null) {
                    $9c0Qr.dispose(this.keptStates);
                    this.keptStates = [];
                }
                if (Array.isArray(this.cell.stateSize)) this.states_ = this.cell.stateSize.map(()=>$7KCJq.zeros(stateShape));
                else this.states_[0] = $7KCJq.zeros(stateShape);
            } else {
                if (!Array.isArray(states)) states = [
                    states
                ];
                if (states.length !== this.states_.length) throw new (0, $jVuYK.ValueError)(`Layer ${this.name} expects ${this.states_.length} state(s), ` + `but it received ${states.length} state value(s). Input ` + `received: ${states}`);
                if (training) // Store old state tensors for complete disposal later, i.e., during
                // the next no-arg call to this method. We do not dispose the old
                // states immediately because that BPTT (among other things) require
                // them.
                this.keptStates.push(this.states_.slice());
                else $9c0Qr.dispose(this.states_);
                for(let index = 0; index < this.states_.length; ++index){
                    const value = states[index];
                    const expectedShape = stateShape;
                    if (!(0, $wx9lK).arraysEqual(value.shape, expectedShape)) throw new (0, $jVuYK.ValueError)(`State ${index} is incompatible with layer ${this.name}: ` + `expected shape=${expectedShape}, received shape=${value.shape}`);
                    this.states_[index] = value;
                }
            }
            this.states_ = this.states_.map((state)=>$9c0Qr.keep(state.clone()));
        });
    }
    computeSingleOutputShape(inputShape) {
        const { dataFormat: dataFormat, filters: filters, kernelSize: kernelSize, padding: padding, strides: strides, dilationRate: dilationRate } = this.cell;
        const isChannelsFirst = dataFormat === 'channelsFirst';
        const h = inputShape[isChannelsFirst ? 3 : 2];
        const w = inputShape[isChannelsFirst ? 4 : 3];
        const hOut = (0, $4N5wj.convOutputLength)(h, kernelSize[0], padding, strides[0], dilationRate[0]);
        const wOut = (0, $4N5wj.convOutputLength)(w, kernelSize[1], padding, strides[1], dilationRate[1]);
        const outShape = [
            ...inputShape.slice(0, 2),
            ...isChannelsFirst ? [
                filters,
                hOut,
                wOut
            ] : [
                hOut,
                wOut,
                filters
            ]
        ];
        return outShape;
    }
}
/** @nocollapse */ $3aaae4c717d58908$var$ConvRNN2D.className = 'ConvRNN2D';
class $3aaae4c717d58908$export$6fd0801294342e82 extends (0, $ejY9c.LSTMCell) {
    constructor(args){
        const { filters: filters, kernelSize: kernelSize, strides: strides, padding: padding, dataFormat: dataFormat, dilationRate: dilationRate } = args;
        super(Object.assign({}, args, {
            units: filters
        }));
        this.filters = filters;
        (0, $khD6O.assertPositiveInteger)(this.filters, 'filters');
        this.kernelSize = (0, $4N5wj.normalizeArray)(kernelSize, 2, 'kernelSize');
        this.kernelSize.forEach((size)=>(0, $khD6O.assertPositiveInteger)(size, 'kernelSize'));
        this.strides = (0, $4N5wj.normalizeArray)(strides || 1, 2, 'strides');
        this.strides.forEach((stride)=>(0, $khD6O.assertPositiveInteger)(stride, 'strides'));
        this.padding = padding || 'valid';
        (0, $hQ5cH.checkPaddingMode)(this.padding);
        this.dataFormat = dataFormat || 'channelsLast';
        (0, $hQ5cH.checkDataFormat)(this.dataFormat);
        this.dilationRate = (0, $4N5wj.normalizeArray)(dilationRate || 1, 2, 'dilationRate');
        this.dilationRate.forEach((rate)=>(0, $khD6O.assertPositiveInteger)(rate, 'dilationRate'));
    }
    build(inputShape) {
        var _a;
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null) throw new (0, $jVuYK.ValueError)(`The channel dimension of the input should be defined. ` + `Found ${inputShape[channelAxis]}`);
        const inputDim = inputShape[channelAxis];
        const numOfKernels = 4;
        const kernelShape = this.kernelSize.concat([
            inputDim,
            this.filters * numOfKernels
        ]);
        this.kernel = this.addWeight('kernel', kernelShape, null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        const recurrentKernelShape = this.kernelSize.concat([
            this.filters,
            this.filters * numOfKernels
        ]);
        this.recurrentKernel = this.addWeight('recurrent_kernel', recurrentKernelShape, null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
        if (this.useBias) {
            let biasInitializer;
            if (this.unitForgetBias) {
                const init = this.biasInitializer;
                const filters = this.filters;
                biasInitializer = new (_a = class CustomInit extends (0, $fQ95p.Initializer) {
                    apply(shape, dtype) {
                        const biasI = init.apply([
                            filters
                        ]);
                        const biasF = $bhi4b.ones([
                            filters
                        ]);
                        const biasCAndO = init.apply([
                            filters * 2
                        ]);
                        return $luRak.concatenate([
                            biasI,
                            biasF,
                            biasCAndO
                        ]);
                    }
                }, /** @nocollapse */ _a.className = 'CustomInit', _a)();
            } else biasInitializer = this.biasInitializer;
            this.bias = this.addWeight('bias', [
                this.filters * numOfKernels
            ], null, biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        }
        this.built = true;
    }
    call(inputs, kwargs) {
        return $9c0Qr.tidy(()=>{
            if (inputs.length !== 3) throw new (0, $jVuYK.ValueError)(`ConvLSTM2DCell expects 3 input Tensors (inputs, h, c), got ` + `${inputs.length}.`);
            const training = kwargs['training'] || false;
            const x = inputs[0]; // Current input
            const hTMinus1 = inputs[1]; // Previous memory state.
            const cTMinus1 = inputs[2]; // Previous carry state.
            const numOfKernels = 4;
            if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) this.dropoutMask = (0, $ejY9c.generateDropoutMask)({
                ones: ()=>$9u8DQ.onesLike(x),
                rate: this.dropout,
                training: training,
                count: numOfKernels,
                dropoutFunc: this.dropoutFunc
            });
            const dropoutMask = this.dropoutMask;
            const applyDropout = (x, mask, index)=>{
                if (!mask || !mask[index]) return x;
                return $r7fN6.mul(mask[index], x);
            };
            let xI = applyDropout(x, dropoutMask, 0);
            let xF = applyDropout(x, dropoutMask, 1);
            let xC = applyDropout(x, dropoutMask, 2);
            let xO = applyDropout(x, dropoutMask, 3);
            if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) this.recurrentDropoutMask = (0, $ejY9c.generateDropoutMask)({
                ones: ()=>$9u8DQ.onesLike(hTMinus1),
                rate: this.recurrentDropout,
                training: training,
                count: numOfKernels,
                dropoutFunc: this.dropoutFunc
            });
            const recDropoutMask = this.recurrentDropoutMask;
            let hI = applyDropout(hTMinus1, recDropoutMask, 0);
            let hF = applyDropout(hTMinus1, recDropoutMask, 1);
            let hC = applyDropout(hTMinus1, recDropoutMask, 2);
            let hO = applyDropout(hTMinus1, recDropoutMask, 3);
            const kernelChannelAxis = 3;
            const [kernelI, kernelF, kernelC, kernelO] = $9DjTt.split(this.kernel.read(), numOfKernels, kernelChannelAxis);
            const [biasI, biasF, biasC, biasO] = this.useBias ? $9DjTt.split(this.bias.read(), numOfKernels) : [
                null,
                null,
                null,
                null
            ];
            xI = this.inputConv(xI, kernelI, biasI, this.padding);
            xF = this.inputConv(xF, kernelF, biasF, this.padding);
            xC = this.inputConv(xC, kernelC, biasC, this.padding);
            xO = this.inputConv(xO, kernelO, biasO, this.padding);
            const [recKernelI, recKernelF, recKernelC, recKernelO] = $9DjTt.split(this.recurrentKernel.read(), numOfKernels, kernelChannelAxis);
            hI = this.recurrentConv(hI, recKernelI);
            hF = this.recurrentConv(hF, recKernelF);
            hC = this.recurrentConv(hC, recKernelC);
            hO = this.recurrentConv(hO, recKernelO);
            const i = this.recurrentActivation.apply($1ZrG5.add(xI, hI));
            const f = this.recurrentActivation.apply($1ZrG5.add(xF, hF));
            const c = $1ZrG5.add($r7fN6.mul(f, cTMinus1), $r7fN6.mul(i, this.activation.apply($1ZrG5.add(xC, hC))));
            const h = $r7fN6.mul(this.recurrentActivation.apply($1ZrG5.add(xO, hO)), this.activation.apply(c));
            return [
                h,
                h,
                c
            ];
        });
    }
    getConfig() {
        const _a = super.getConfig(), { 'units': _ } = _a, baseConfig = $3aaae4c717d58908$var$__rest(_a, [
            'units'
        ]);
        const config = {
            filters: this.filters,
            kernelSize: this.kernelSize,
            padding: this.padding,
            dataFormat: this.dataFormat,
            dilationRate: this.dilationRate,
            strides: this.strides
        };
        return Object.assign({}, baseConfig, config);
    }
    inputConv(x, w, b, padding) {
        const out = $jOBWR.conv2d(x, w, this.strides, padding || 'valid', this.dataFormat === 'channelsFirst' ? 'NCHW' : 'NHWC', this.dilationRate);
        if (b) return $luRak.biasAdd(out, b, this.dataFormat);
        return out;
    }
    recurrentConv(x, w) {
        const strides = 1;
        return $jOBWR.conv2d(x, w, strides, 'same', this.dataFormat === 'channelsFirst' ? 'NCHW' : 'NHWC');
    }
}
/** @nocollapse */ $3aaae4c717d58908$export$6fd0801294342e82.className = 'ConvLSTM2DCell';
$8AyuI.registerClass($3aaae4c717d58908$export$6fd0801294342e82);
class $3aaae4c717d58908$export$d5828f4b24c3231 extends $3aaae4c717d58908$var$ConvRNN2D {
    constructor(args){
        const cell = new $3aaae4c717d58908$export$6fd0801294342e82(args);
        super(Object.assign({}, args, {
            cell: cell
        }));
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config);
    }
}
/** @nocollapse */ $3aaae4c717d58908$export$d5828f4b24c3231.className = 'ConvLSTM2D';
$8AyuI.registerClass($3aaae4c717d58908$export$d5828f4b24c3231);

});
parcelRegister("ejY9c", function(module, exports) {

$parcel$export(module.exports, "standardizeArgs", () => $a6d17f0977e0e3c9$export$b9ab3f5c89688c2);
$parcel$export(module.exports, "rnn", () => $a6d17f0977e0e3c9$export$3e66d5ce8f778ebc);
$parcel$export(module.exports, "RNN", () => $a6d17f0977e0e3c9$export$2b97bcdf1d6f1b16);
$parcel$export(module.exports, "StackedRNNCells", () => $a6d17f0977e0e3c9$export$966a21a552328009);
$parcel$export(module.exports, "RNNCell", () => $a6d17f0977e0e3c9$export$405d8fca8f98aafd);
$parcel$export(module.exports, "SimpleRNNCell", () => $a6d17f0977e0e3c9$export$c8a45b8cd42f689);
$parcel$export(module.exports, "generateDropoutMask", () => $a6d17f0977e0e3c9$export$9eb0cce22b72569f);
$parcel$export(module.exports, "SimpleRNN", () => $a6d17f0977e0e3c9$export$9f3b0efd8738b035);
$parcel$export(module.exports, "GRUCell", () => $a6d17f0977e0e3c9$export$dad94e00e5c3737);
$parcel$export(module.exports, "GRU", () => $a6d17f0977e0e3c9$export$effa27cfcc4408f4);
$parcel$export(module.exports, "LSTMCell", () => $a6d17f0977e0e3c9$export$17aacc547a045ab0);
$parcel$export(module.exports, "LSTM", () => $a6d17f0977e0e3c9$export$c8c9213153497ce0);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Recurrent Neural Network Layers.
 */ parcelRequire("5n9DG");
var $1ZrG5 = parcelRequire("1ZrG5");
var $7qWZ5 = parcelRequire("7qWZ5");
var $9c0Qr = parcelRequire("9c0Qr");
var $6mzQK = parcelRequire("6mzQK");
var $r7fN6 = parcelRequire("r7fN6");
var $ifge7 = parcelRequire("ifge7");
var $9u8DQ = parcelRequire("9u8DQ");
var $do1MK = parcelRequire("do1MK");
var $8AyuI = parcelRequire("8AyuI");
var $9DjTt = parcelRequire("9DjTt");
var $iSKul = parcelRequire("iSKul");
var $hkR0n = parcelRequire("hkR0n");
var $fVwnn = parcelRequire("fVwnn");
var $9PEYs = parcelRequire("9PEYs");
var $kDeMO = parcelRequire("kDeMO");
var $wx9lK = parcelRequire("wx9lK");
var $7KCJq = parcelRequire("7KCJq");

var $bDaSd = parcelRequire("bDaSd");

var $luRak = parcelRequire("luRak");

var $hQ5cH = parcelRequire("hQ5cH");

var $cn6Kc = parcelRequire("cn6Kc");

var $cm045 = parcelRequire("cm045");

var $jVuYK = parcelRequire("jVuYK");

var $fQ95p = parcelRequire("fQ95p");

var $4oHox = parcelRequire("4oHox");

var $khD6O = parcelRequire("khD6O");

var $jBJAM = parcelRequire("jBJAM");

var $5sw3q = parcelRequire("5sw3q");

var $7muWV = parcelRequire("7muWV");

var $dttI1 = parcelRequire("dttI1");
function $a6d17f0977e0e3c9$export$b9ab3f5c89688c2(inputs, initialState, constants, numConstants) {
    if (Array.isArray(inputs)) {
        if (initialState != null || constants != null) throw new (0, $jVuYK.ValueError)("When inputs is an array, neither initialState or constants should be provided");
        if (numConstants != null) {
            constants = inputs.slice(inputs.length - numConstants, inputs.length);
            inputs = inputs.slice(0, inputs.length - numConstants);
        }
        if (inputs.length > 1) initialState = inputs.slice(1, inputs.length);
        inputs = inputs[0];
    }
    function toListOrNull(x) {
        if (x == null || Array.isArray(x)) return x;
        else return [
            x
        ];
    }
    initialState = toListOrNull(initialState);
    constants = toListOrNull(constants);
    return {
        inputs: inputs,
        initialState: initialState,
        constants: constants
    };
}
function $a6d17f0977e0e3c9$export$3e66d5ce8f778ebc(stepFunction, inputs, initialStates, goBackwards = false, mask, constants, unroll = false, needPerStepOutputs = false) {
    return $9c0Qr.tidy(()=>{
        const ndim = inputs.shape.length;
        if (ndim < 3) throw new (0, $jVuYK.ValueError)(`Input should be at least 3D, but is ${ndim}D.`);
        // Transpose to time-major, i.e., from [batch, time, ...] to [time, batch,
        // ...].
        const axes = [
            1,
            0
        ].concat($jBJAM.range(2, ndim));
        inputs = $9PEYs.transpose(inputs, axes);
        if (constants != null) throw new (0, $jVuYK.NotImplementedError)("The rnn() functoin of the deeplearn.js backend does not support constants yet.");
        // Porting Note: the unroll option is ignored by the imperative backend.
        if (unroll) console.warn("Backend rnn(): the unroll = true option is not applicable to the imperative deeplearn.js backend.");
        if (mask != null) {
            mask = $7qWZ5.cast($7qWZ5.cast(mask, 'bool'), 'float32');
            if (mask.rank === ndim - 1) mask = $6mzQK.expandDims(mask, -1);
            mask = $9PEYs.transpose(mask, axes);
        }
        if (goBackwards) {
            inputs = $do1MK.reverse(inputs, 0);
            if (mask != null) mask = $do1MK.reverse(mask, 0);
        }
        // Porting Note: PyKeras with TensorFlow backend uses a symbolic loop
        //   (tf.while_loop). But for the imperative deeplearn.js backend, we just
        //   use the usual TypeScript control flow to iterate over the time steps in
        //   the inputs.
        // Porting Note: PyKeras patches a "_use_learning_phase" attribute to
        // outputs.
        //   This is not idiomatic in TypeScript. The info regarding whether we are
        //   in a learning (i.e., training) phase for RNN is passed in a different
        //   way.
        const perStepOutputs = [];
        let lastOutput;
        let states = initialStates;
        const timeSteps = inputs.shape[0];
        const perStepInputs = $kDeMO.unstack(inputs);
        let perStepMasks;
        if (mask != null) perStepMasks = $kDeMO.unstack(mask);
        for(let t = 0; t < timeSteps; ++t){
            const currentInput = perStepInputs[t];
            const stepOutputs = $9c0Qr.tidy(()=>stepFunction(currentInput, states));
            if (mask == null) {
                lastOutput = stepOutputs[0];
                states = stepOutputs[1];
            } else {
                const maskedOutputs = $9c0Qr.tidy(()=>{
                    const stepMask = perStepMasks[t];
                    const negStepMask = $hkR0n.sub($9u8DQ.onesLike(stepMask), stepMask);
                    // TODO(cais): Would tfc.where() be better for performance?
                    const output = $1ZrG5.add($r7fN6.mul(stepOutputs[0], stepMask), $r7fN6.mul(states[0], negStepMask));
                    const newStates = states.map((state, i)=>{
                        return $1ZrG5.add($r7fN6.mul(stepOutputs[1][i], stepMask), $r7fN6.mul(state, negStepMask));
                    });
                    return {
                        output: output,
                        newStates: newStates
                    };
                });
                lastOutput = maskedOutputs.output;
                states = maskedOutputs.newStates;
            }
            if (needPerStepOutputs) perStepOutputs.push(lastOutput);
        }
        let outputs;
        if (needPerStepOutputs) {
            const axis = 1;
            outputs = $iSKul.stack(perStepOutputs, axis);
        }
        return [
            lastOutput,
            outputs,
            states
        ];
    });
}
class $a6d17f0977e0e3c9$export$2b97bcdf1d6f1b16 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        let cell;
        if (args.cell == null) throw new (0, $jVuYK.ValueError)('cell property is missing for the constructor of RNN.');
        else if (Array.isArray(args.cell)) cell = new $a6d17f0977e0e3c9$export$966a21a552328009({
            cells: args.cell
        });
        else cell = args.cell;
        if (cell.stateSize == null) throw new (0, $jVuYK.ValueError)("The RNN cell should have an attribute `stateSize` (tuple of integers, one integer per RNN state).");
        this.cell = cell;
        this.returnSequences = args.returnSequences == null ? false : args.returnSequences;
        this.returnState = args.returnState == null ? false : args.returnState;
        this.goBackwards = args.goBackwards == null ? false : args.goBackwards;
        this._stateful = args.stateful == null ? false : args.stateful;
        this.unroll = args.unroll == null ? false : args.unroll;
        this.supportsMasking = true;
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: 3
            })
        ];
        this.stateSpec = null;
        this.states_ = null;
        // TODO(cais): Add constantsSpec and numConstants.
        this.numConstants = null;
        // TODO(cais): Look into the use of initial_state in the kwargs of the
        //   constructor.
        this.keptStates = [];
    }
    // Porting Note: This is the equivalent of `RNN.states` property getter in
    //   PyKeras.
    getStates() {
        if (this.states_ == null) {
            const numStates = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
            return $jBJAM.range(0, numStates).map((x)=>null);
        } else return this.states_;
    }
    // Porting Note: This is the equivalent of the `RNN.states` property setter in
    //   PyKeras.
    setStates(states) {
        this.states_ = states;
    }
    computeOutputShape(inputShape) {
        if ((0, $5sw3q.isArrayOfShapes)(inputShape)) inputShape = inputShape[0];
        inputShape;
        // TODO(cais): Remove the casting once stacked RNN cells become supported.
        let stateSize = this.cell.stateSize;
        if (!Array.isArray(stateSize)) stateSize = [
            stateSize
        ];
        const outputDim = stateSize[0];
        let outputShape;
        if (this.returnSequences) outputShape = [
            inputShape[0],
            inputShape[1],
            outputDim
        ];
        else outputShape = [
            inputShape[0],
            outputDim
        ];
        if (this.returnState) {
            const stateShape = [];
            for (const dim of stateSize)stateShape.push([
                inputShape[0],
                dim
            ]);
            return [
                outputShape
            ].concat(stateShape);
        } else return outputShape;
    }
    computeMask(inputs, mask) {
        return $9c0Qr.tidy(()=>{
            if (Array.isArray(mask)) mask = mask[0];
            const outputMask = this.returnSequences ? mask : null;
            if (this.returnState) {
                const stateMask = this.states.map((s)=>null);
                return [
                    outputMask
                ].concat(stateMask);
            } else return outputMask;
        });
    }
    /**
     * Get the current state tensors of the RNN.
     *
     * If the state hasn't been set, return an array of `null`s of the correct
     * length.
     */ get states() {
        if (this.states_ == null) {
            const numStates = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
            const output = [];
            for(let i = 0; i < numStates; ++i)output.push(null);
            return output;
        } else return this.states_;
    }
    set states(s) {
        this.states_ = s;
    }
    build(inputShape) {
        // Note inputShape will be an Array of Shapes of initial states and
        // constants if these are passed in apply().
        const constantShape = null;
        if (this.numConstants != null) throw new (0, $jVuYK.NotImplementedError)('Constants support is not implemented in RNN yet.');
        if ((0, $5sw3q.isArrayOfShapes)(inputShape)) inputShape = inputShape[0];
        inputShape;
        const batchSize = this.stateful ? inputShape[0] : null;
        const inputDim = inputShape.slice(2);
        this.inputSpec[0] = new (0, $cm045.InputSpec)({
            shape: [
                batchSize,
                null,
                ...inputDim
            ]
        });
        // Allow cell (if RNNCell Layer) to build before we set or validate
        // stateSpec.
        const stepInputShape = [
            inputShape[0]
        ].concat(inputShape.slice(2));
        if (constantShape != null) throw new (0, $jVuYK.NotImplementedError)('Constants support is not implemented in RNN yet.');
        else this.cell.build(stepInputShape);
        // Set or validate stateSpec.
        let stateSize;
        if (Array.isArray(this.cell.stateSize)) stateSize = this.cell.stateSize;
        else stateSize = [
            this.cell.stateSize
        ];
        if (this.stateSpec != null) {
            if (!(0, $wx9lK).arraysEqual(this.stateSpec.map((spec)=>spec.shape[spec.shape.length - 1]), stateSize)) throw new (0, $jVuYK.ValueError)(`An initialState was passed that is not compatible with ` + `cell.stateSize. Received stateSpec=${this.stateSpec}; ` + `However cell.stateSize is ${this.cell.stateSize}`);
        } else this.stateSpec = stateSize.map((dim)=>new (0, $cm045.InputSpec)({
                shape: [
                    null,
                    dim
                ]
            }));
        if (this.stateful) this.resetStates();
    }
    /**
     * Reset the state tensors of the RNN.
     *
     * If the `states` argument is `undefined` or `null`, will set the
     * state tensor(s) of the RNN to all-zero tensors of the appropriate
     * shape(s).
     *
     * If `states` is provided, will set the state tensors of the RNN to its
     * value.
     *
     * @param states Optional externally-provided initial states.
     * @param training Whether this call is done during training. For stateful
     *   RNNs, this affects whether the old states are kept or discarded. In
     *   particular, if `training` is `true`, the old states will be kept so
     *   that subsequent backpropgataion through time (BPTT) may work properly.
     *   Else, the old states will be discarded.
     */ resetStates(states, training = false) {
        (0, $9c0Qr.tidy)(()=>{
            if (!this.stateful) throw new (0, $jVuYK.AttributeError)('Cannot call resetStates() on an RNN Layer that is not stateful.');
            const batchSize = this.inputSpec[0].shape[0];
            if (batchSize == null) throw new (0, $jVuYK.ValueError)("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
            // Initialize state if null.
            if (this.states_ == null) {
                if (Array.isArray(this.cell.stateSize)) this.states_ = this.cell.stateSize.map((dim)=>$7KCJq.zeros([
                        batchSize,
                        dim
                    ]));
                else this.states_ = [
                    $7KCJq.zeros([
                        batchSize,
                        this.cell.stateSize
                    ])
                ];
            } else if (states == null) {
                // Dispose old state tensors.
                $9c0Qr.dispose(this.states_);
                // For stateful RNNs, fully dispose kept old states.
                if (this.keptStates != null) {
                    $9c0Qr.dispose(this.keptStates);
                    this.keptStates = [];
                }
                if (Array.isArray(this.cell.stateSize)) this.states_ = this.cell.stateSize.map((dim)=>$7KCJq.zeros([
                        batchSize,
                        dim
                    ]));
                else this.states_[0] = $7KCJq.zeros([
                    batchSize,
                    this.cell.stateSize
                ]);
            } else {
                if (!Array.isArray(states)) states = [
                    states
                ];
                if (states.length !== this.states_.length) throw new (0, $jVuYK.ValueError)(`Layer ${this.name} expects ${this.states_.length} state(s), ` + `but it received ${states.length} state value(s). Input ` + `received: ${states}`);
                if (training === true) // Store old state tensors for complete disposal later, i.e., during
                // the next no-arg call to this method. We do not dispose the old
                // states immediately because that BPTT (among other things) require
                // them.
                this.keptStates.push(this.states_.slice());
                else $9c0Qr.dispose(this.states_);
                for(let index = 0; index < this.states_.length; ++index){
                    const value = states[index];
                    const dim = Array.isArray(this.cell.stateSize) ? this.cell.stateSize[index] : this.cell.stateSize;
                    const expectedShape = [
                        batchSize,
                        dim
                    ];
                    if (!(0, $wx9lK).arraysEqual(value.shape, expectedShape)) throw new (0, $jVuYK.ValueError)(`State ${index} is incompatible with layer ${this.name}: ` + `expected shape=${expectedShape}, received shape=${value.shape}`);
                    this.states_[index] = value;
                }
            }
            this.states_ = this.states_.map((state)=>$9c0Qr.keep(state.clone()));
        });
    }
    apply(inputs, kwargs) {
        // TODO(cais): Figure out whether initialState is in kwargs or inputs.
        let initialState = kwargs == null ? null : kwargs['initialState'];
        let constants = kwargs == null ? null : kwargs['constants'];
        if (kwargs == null) kwargs = {};
        const standardized = $a6d17f0977e0e3c9$export$b9ab3f5c89688c2(inputs, initialState, constants, this.numConstants);
        inputs = standardized.inputs;
        initialState = standardized.initialState;
        constants = standardized.constants;
        // If any of `initial_state` or `constants` are specified and are
        // `tf.SymbolicTensor`s, then add them to the inputs and temporarily modify
        // the input_spec to include them.
        let additionalInputs = [];
        let additionalSpecs = [];
        if (initialState != null) {
            kwargs['initialState'] = initialState;
            additionalInputs = additionalInputs.concat(initialState);
            this.stateSpec = [];
            for (const state of initialState)this.stateSpec.push(new (0, $cm045.InputSpec)({
                shape: state.shape
            }));
            // TODO(cais): Use the following instead.
            // this.stateSpec = initialState.map(state => new InputSpec({shape:
            // state.shape}));
            additionalSpecs = additionalSpecs.concat(this.stateSpec);
        }
        if (constants != null) {
            kwargs['constants'] = constants;
            additionalInputs = additionalInputs.concat(constants);
            // TODO(cais): Add this.constantsSpec.
            this.numConstants = constants.length;
        }
        const isTensor = additionalInputs[0] instanceof (0, $cm045.SymbolicTensor);
        if (isTensor) {
            // Compute full input spec, including state and constants.
            const fullInput = [
                inputs
            ].concat(additionalInputs);
            const fullInputSpec = this.inputSpec.concat(additionalSpecs);
            // Perform the call with temporarily replaced inputSpec.
            const originalInputSpec = this.inputSpec;
            this.inputSpec = fullInputSpec;
            const output = super.apply(fullInput, kwargs);
            this.inputSpec = originalInputSpec;
            return output;
        } else return super.apply(inputs, kwargs);
    }
    // tslint:disable-next-line:no-any
    call(inputs, kwargs) {
        // Input shape: `[samples, time (padded with zeros), input_dim]`.
        // Note that the .build() method of subclasses **must** define
        // this.inputSpec and this.stateSpec owith complete input shapes.
        return (0, $9c0Qr.tidy)(()=>{
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            let initialState = kwargs == null ? null : kwargs['initialState'];
            inputs = (0, $5sw3q.getExactlyOneTensor)(inputs);
            if (initialState == null) {
                if (this.stateful) initialState = this.states_;
                else initialState = this.getInitialState(inputs);
            }
            const numStates = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
            if (initialState.length !== numStates) throw new (0, $jVuYK.ValueError)(`RNN Layer has ${numStates} state(s) but was passed ` + `${initialState.length} initial state(s).`);
            if (this.unroll) console.warn('Ignoring unroll = true for RNN layer, due to imperative backend.');
            const cellCallKwargs = {
                training: training
            };
            // TODO(cais): Add support for constants.
            const step = (inputs, states)=>{
                // `inputs` and `states` are concatenated to form a single `Array` of
                // `tf.Tensor`s as the input to `cell.call()`.
                const outputs = this.cell.call([
                    inputs
                ].concat(states), cellCallKwargs);
                // Marshall the return value into output and new states.
                return [
                    outputs[0],
                    outputs.slice(1)
                ];
            };
            // TODO(cais): Add support for constants.
            const rnnOutputs = $a6d17f0977e0e3c9$export$3e66d5ce8f778ebc(step, inputs, initialState, this.goBackwards, mask, null, this.unroll, this.returnSequences);
            const lastOutput = rnnOutputs[0];
            const outputs = rnnOutputs[1];
            const states = rnnOutputs[2];
            if (this.stateful) this.resetStates(states, training);
            const output = this.returnSequences ? outputs : lastOutput;
            // TODO(cais): Porperty set learning phase flag.
            if (this.returnState) return [
                output
            ].concat(states);
            else return output;
        });
    }
    getInitialState(inputs) {
        return (0, $9c0Qr.tidy)(()=>{
            // Build an all-zero tensor of shape [samples, outputDim].
            // [Samples, timeSteps, inputDim].
            let initialState = $7KCJq.zeros(inputs.shape);
            // [Samples].
            initialState = $fVwnn.sum(initialState, [
                1,
                2
            ]);
            initialState = $luRak.expandDims(initialState); // [Samples, 1].
            if (Array.isArray(this.cell.stateSize)) return this.cell.stateSize.map((dim)=>dim > 1 ? $luRak.tile(initialState, [
                    1,
                    dim
                ]) : initialState);
            else return this.cell.stateSize > 1 ? [
                $luRak.tile(initialState, [
                    1,
                    this.cell.stateSize
                ])
            ] : [
                initialState
            ];
        });
    }
    get trainableWeights() {
        if (!this.trainable) return [];
        // Porting Note: In TypeScript, `this` is always an instance of `Layer`.
        return this.cell.trainableWeights;
    }
    get nonTrainableWeights() {
        // Porting Note: In TypeScript, `this` is always an instance of `Layer`.
        if (!this.trainable) return this.cell.weights;
        return this.cell.nonTrainableWeights;
    }
    setFastWeightInitDuringBuild(value) {
        super.setFastWeightInitDuringBuild(value);
        if (this.cell != null) this.cell.setFastWeightInitDuringBuild(value);
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            returnSequences: this.returnSequences,
            returnState: this.returnState,
            goBackwards: this.goBackwards,
            stateful: this.stateful,
            unroll: this.unroll
        };
        if (this.numConstants != null) config['numConstants'] = this.numConstants;
        const cellConfig = this.cell.getConfig();
        if (this.getClassName() === $a6d17f0977e0e3c9$export$2b97bcdf1d6f1b16.className) config['cell'] = {
            'className': this.cell.getClassName(),
            'config': cellConfig
        };
        // this order is necessary, to prevent cell name from replacing layer name
        return Object.assign({}, cellConfig, baseConfig, config);
    }
    /** @nocollapse */ static fromConfig(cls, config, customObjects = {}) {
        const cellConfig = config['cell'];
        const cell = (0, $dttI1.deserialize)(cellConfig, customObjects);
        return new cls(Object.assign(config, {
            cell: cell
        }));
    }
}
/** @nocollapse */ $a6d17f0977e0e3c9$export$2b97bcdf1d6f1b16.className = 'RNN';
(0, $8AyuI).registerClass($a6d17f0977e0e3c9$export$2b97bcdf1d6f1b16);
class $a6d17f0977e0e3c9$export$405d8fca8f98aafd extends (0, $cm045.Layer) {
}
class $a6d17f0977e0e3c9$export$c8a45b8cd42f689 extends $a6d17f0977e0e3c9$export$405d8fca8f98aafd {
    constructor(args){
        super(args);
        this.DEFAULT_ACTIVATION = 'tanh';
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_RECURRENT_INITIALIZER = 'orthogonal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        this.units = args.units;
        (0, $khD6O.assertPositiveInteger)(this.units, `units`);
        this.activation = (0, $bDaSd.getActivation)(args.activation == null ? this.DEFAULT_ACTIVATION : args.activation);
        this.useBias = args.useBias == null ? true : args.useBias;
        this.kernelInitializer = (0, $fQ95p.getInitializer)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.recurrentInitializer = (0, $fQ95p.getInitializer)(args.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER);
        this.biasInitializer = (0, $fQ95p.getInitializer)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.kernelRegularizer = (0, $4oHox.getRegularizer)(args.kernelRegularizer);
        this.recurrentRegularizer = (0, $4oHox.getRegularizer)(args.recurrentRegularizer);
        this.biasRegularizer = (0, $4oHox.getRegularizer)(args.biasRegularizer);
        this.kernelConstraint = (0, $cn6Kc.getConstraint)(args.kernelConstraint);
        this.recurrentConstraint = (0, $cn6Kc.getConstraint)(args.recurrentConstraint);
        this.biasConstraint = (0, $cn6Kc.getConstraint)(args.biasConstraint);
        this.dropout = $jBJAM.min([
            1,
            $jBJAM.max([
                0,
                args.dropout == null ? 0 : args.dropout
            ])
        ]);
        this.recurrentDropout = $jBJAM.min([
            1,
            $jBJAM.max([
                0,
                args.recurrentDropout == null ? 0 : args.recurrentDropout
            ])
        ]);
        this.dropoutFunc = args.dropoutFunc;
        this.stateSize = this.units;
        this.dropoutMask = null;
        this.recurrentDropoutMask = null;
    }
    build(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        // TODO(cais): Use regularizer.
        this.kernel = this.addWeight('kernel', [
            inputShape[inputShape.length - 1],
            this.units
        ], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        this.recurrentKernel = this.addWeight('recurrent_kernel', [
            this.units,
            this.units
        ], null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.units
        ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        else this.bias = null;
        this.built = true;
    }
    // Porting Note: PyKeras' equivalent of this method takes two tensor inputs:
    //   `inputs` and `states`. Here, the two tensors are combined into an
    //   `Tensor[]` Array as the first input argument.
    //   Similarly, PyKeras' equivalent of this method returns two values:
    //    `output` and `[output]`. Here the two are combined into one length-2
    //    `Tensor[]`, consisting of `output` repeated.
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            inputs;
            if (inputs.length !== 2) throw new (0, $jVuYK.ValueError)(`SimpleRNNCell expects 2 input Tensors, got ${inputs.length}.`);
            let prevOutput = inputs[1];
            inputs = inputs[0];
            const training = kwargs['training'] == null ? false : kwargs['training'];
            if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) this.dropoutMask = $a6d17f0977e0e3c9$export$9eb0cce22b72569f({
                ones: ()=>$9u8DQ.onesLike(inputs),
                rate: this.dropout,
                training: training,
                dropoutFunc: this.dropoutFunc
            });
            if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) this.recurrentDropoutMask = $a6d17f0977e0e3c9$export$9eb0cce22b72569f({
                ones: ()=>$9u8DQ.onesLike(prevOutput),
                rate: this.recurrentDropout,
                training: training,
                dropoutFunc: this.dropoutFunc
            });
            let h;
            const dpMask = this.dropoutMask;
            const recDpMask = this.recurrentDropoutMask;
            if (dpMask != null) h = $luRak.dot($r7fN6.mul(inputs, dpMask), this.kernel.read());
            else h = $luRak.dot(inputs, this.kernel.read());
            if (this.bias != null) h = $luRak.biasAdd(h, this.bias.read());
            if (recDpMask != null) prevOutput = $r7fN6.mul(prevOutput, recDpMask);
            let output = $1ZrG5.add(h, $luRak.dot(prevOutput, this.recurrentKernel.read()));
            if (this.activation != null) output = this.activation.apply(output);
            // TODO(cais): Properly set learning phase on output tensor?
            return [
                output,
                output
            ];
        });
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            units: this.units,
            activation: (0, $bDaSd.serializeActivation)(this.activation),
            useBias: this.useBias,
            kernelInitializer: (0, $fQ95p.serializeInitializer)(this.kernelInitializer),
            recurrentInitializer: (0, $fQ95p.serializeInitializer)(this.recurrentInitializer),
            biasInitializer: (0, $fQ95p.serializeInitializer)(this.biasInitializer),
            kernelRegularizer: (0, $4oHox.serializeRegularizer)(this.kernelRegularizer),
            recurrentRegularizer: (0, $4oHox.serializeRegularizer)(this.recurrentRegularizer),
            biasRegularizer: (0, $4oHox.serializeRegularizer)(this.biasRegularizer),
            activityRegularizer: (0, $4oHox.serializeRegularizer)(this.activityRegularizer),
            kernelConstraint: (0, $cn6Kc.serializeConstraint)(this.kernelConstraint),
            recurrentConstraint: (0, $cn6Kc.serializeConstraint)(this.recurrentConstraint),
            biasConstraint: (0, $cn6Kc.serializeConstraint)(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout
        };
        return Object.assign({}, baseConfig, config);
    }
}
/** @nocollapse */ $a6d17f0977e0e3c9$export$c8a45b8cd42f689.className = 'SimpleRNNCell';
(0, $8AyuI).registerClass($a6d17f0977e0e3c9$export$c8a45b8cd42f689);
class $a6d17f0977e0e3c9$export$9f3b0efd8738b035 extends $a6d17f0977e0e3c9$export$2b97bcdf1d6f1b16 {
    constructor(args){
        args.cell = new $a6d17f0977e0e3c9$export$c8a45b8cd42f689(args);
        super(args);
    // TODO(cais): Add activityRegularizer.
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            if (this.cell.dropoutMask != null) {
                $9c0Qr.dispose(this.cell.dropoutMask);
                this.cell.dropoutMask = null;
            }
            if (this.cell.recurrentDropoutMask != null) {
                $9c0Qr.dispose(this.cell.recurrentDropoutMask);
                this.cell.recurrentDropoutMask = null;
            }
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            const initialState = kwargs == null ? null : kwargs['initialState'];
            return super.call(inputs, {
                mask: mask,
                training: training,
                initialState: initialState
            });
        });
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config);
    }
}
/** @nocollapse */ $a6d17f0977e0e3c9$export$9f3b0efd8738b035.className = 'SimpleRNN';
(0, $8AyuI).registerClass($a6d17f0977e0e3c9$export$9f3b0efd8738b035);
class $a6d17f0977e0e3c9$export$dad94e00e5c3737 extends $a6d17f0977e0e3c9$export$405d8fca8f98aafd {
    constructor(args){
        super(args);
        this.DEFAULT_ACTIVATION = 'tanh';
        this.DEFAULT_RECURRENT_ACTIVATION = 'hardSigmoid';
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_RECURRENT_INITIALIZER = 'orthogonal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        if (args.resetAfter) throw new (0, $jVuYK.ValueError)(`GRUCell does not support reset_after parameter set to true.`);
        this.units = args.units;
        (0, $khD6O.assertPositiveInteger)(this.units, 'units');
        this.activation = (0, $bDaSd.getActivation)(args.activation === undefined ? this.DEFAULT_ACTIVATION : args.activation);
        this.recurrentActivation = (0, $bDaSd.getActivation)(args.recurrentActivation === undefined ? this.DEFAULT_RECURRENT_ACTIVATION : args.recurrentActivation);
        this.useBias = args.useBias == null ? true : args.useBias;
        this.kernelInitializer = (0, $fQ95p.getInitializer)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.recurrentInitializer = (0, $fQ95p.getInitializer)(args.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER);
        this.biasInitializer = (0, $fQ95p.getInitializer)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.kernelRegularizer = (0, $4oHox.getRegularizer)(args.kernelRegularizer);
        this.recurrentRegularizer = (0, $4oHox.getRegularizer)(args.recurrentRegularizer);
        this.biasRegularizer = (0, $4oHox.getRegularizer)(args.biasRegularizer);
        this.kernelConstraint = (0, $cn6Kc.getConstraint)(args.kernelConstraint);
        this.recurrentConstraint = (0, $cn6Kc.getConstraint)(args.recurrentConstraint);
        this.biasConstraint = (0, $cn6Kc.getConstraint)(args.biasConstraint);
        this.dropout = $jBJAM.min([
            1,
            $jBJAM.max([
                0,
                args.dropout == null ? 0 : args.dropout
            ])
        ]);
        this.recurrentDropout = $jBJAM.min([
            1,
            $jBJAM.max([
                0,
                args.recurrentDropout == null ? 0 : args.recurrentDropout
            ])
        ]);
        this.dropoutFunc = args.dropoutFunc;
        this.implementation = args.implementation;
        this.stateSize = this.units;
        this.dropoutMask = null;
        this.recurrentDropoutMask = null;
    }
    build(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const inputDim = inputShape[inputShape.length - 1];
        this.kernel = this.addWeight('kernel', [
            inputDim,
            this.units * 3
        ], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        this.recurrentKernel = this.addWeight('recurrent_kernel', [
            this.units,
            this.units * 3
        ], null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.units * 3
        ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        else this.bias = null;
        // Porting Notes: Unlike the PyKeras implementation, we perform slicing
        //   of the weights and bias in the call() method, at execution time.
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            inputs;
            if (inputs.length !== 2) throw new (0, $jVuYK.ValueError)(`GRUCell expects 2 input Tensors (inputs, h, c), got ` + `${inputs.length}.`);
            const training = kwargs['training'] == null ? false : kwargs['training'];
            let hTMinus1 = inputs[1]; // Previous memory state.
            inputs = inputs[0];
            // Note: For superior performance, TensorFlow.js always uses
            // implementation 2, regardless of the actual value of
            // config.implementation.
            if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) this.dropoutMask = $a6d17f0977e0e3c9$export$9eb0cce22b72569f({
                ones: ()=>$9u8DQ.onesLike(inputs),
                rate: this.dropout,
                training: training,
                count: 3,
                dropoutFunc: this.dropoutFunc
            });
            if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) this.recurrentDropoutMask = $a6d17f0977e0e3c9$export$9eb0cce22b72569f({
                ones: ()=>$9u8DQ.onesLike(hTMinus1),
                rate: this.recurrentDropout,
                training: training,
                count: 3,
                dropoutFunc: this.dropoutFunc
            });
            const dpMask = this.dropoutMask;
            const recDpMask = this.recurrentDropoutMask;
            let z;
            let r;
            let hh;
            if (0 < this.dropout && this.dropout < 1) inputs = $r7fN6.mul(inputs, dpMask[0]);
            let matrixX = $luRak.dot(inputs, this.kernel.read());
            if (this.useBias) matrixX = $luRak.biasAdd(matrixX, this.bias.read());
            if (0 < this.recurrentDropout && this.recurrentDropout < 1) hTMinus1 = $r7fN6.mul(hTMinus1, recDpMask[0]);
            const recurrentKernelValue = this.recurrentKernel.read();
            const [rk1, rk2] = $9DjTt.split(recurrentKernelValue, [
                2 * this.units,
                this.units
            ], recurrentKernelValue.rank - 1);
            const matrixInner = $luRak.dot(hTMinus1, rk1);
            const [xZ, xR, xH] = $9DjTt.split(matrixX, 3, matrixX.rank - 1);
            const [recurrentZ, recurrentR] = $9DjTt.split(matrixInner, 2, matrixInner.rank - 1);
            z = this.recurrentActivation.apply($1ZrG5.add(xZ, recurrentZ));
            r = this.recurrentActivation.apply($1ZrG5.add(xR, recurrentR));
            const recurrentH = $luRak.dot($r7fN6.mul(r, hTMinus1), rk2);
            hh = this.activation.apply($1ZrG5.add(xH, recurrentH));
            const h = $1ZrG5.add($r7fN6.mul(z, hTMinus1), $r7fN6.mul($1ZrG5.add(1, $ifge7.neg(z)), hh));
            // TODO(cais): Add use_learning_phase flag properly.
            return [
                h,
                h
            ];
        });
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            units: this.units,
            activation: (0, $bDaSd.serializeActivation)(this.activation),
            recurrentActivation: (0, $bDaSd.serializeActivation)(this.recurrentActivation),
            useBias: this.useBias,
            kernelInitializer: (0, $fQ95p.serializeInitializer)(this.kernelInitializer),
            recurrentInitializer: (0, $fQ95p.serializeInitializer)(this.recurrentInitializer),
            biasInitializer: (0, $fQ95p.serializeInitializer)(this.biasInitializer),
            kernelRegularizer: (0, $4oHox.serializeRegularizer)(this.kernelRegularizer),
            recurrentRegularizer: (0, $4oHox.serializeRegularizer)(this.recurrentRegularizer),
            biasRegularizer: (0, $4oHox.serializeRegularizer)(this.biasRegularizer),
            activityRegularizer: (0, $4oHox.serializeRegularizer)(this.activityRegularizer),
            kernelConstraint: (0, $cn6Kc.serializeConstraint)(this.kernelConstraint),
            recurrentConstraint: (0, $cn6Kc.serializeConstraint)(this.recurrentConstraint),
            biasConstraint: (0, $cn6Kc.serializeConstraint)(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout,
            implementation: this.implementation,
            resetAfter: false
        };
        return Object.assign({}, baseConfig, config);
    }
}
/** @nocollapse */ $a6d17f0977e0e3c9$export$dad94e00e5c3737.className = 'GRUCell';
(0, $8AyuI).registerClass($a6d17f0977e0e3c9$export$dad94e00e5c3737);
class $a6d17f0977e0e3c9$export$effa27cfcc4408f4 extends $a6d17f0977e0e3c9$export$2b97bcdf1d6f1b16 {
    constructor(args){
        if (args.implementation === 0) console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call.");
        args.cell = new $a6d17f0977e0e3c9$export$dad94e00e5c3737(args);
        super(args);
    // TODO(cais): Add activityRegularizer.
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            if (this.cell.dropoutMask != null) {
                $9c0Qr.dispose(this.cell.dropoutMask);
                this.cell.dropoutMask = null;
            }
            if (this.cell.recurrentDropoutMask != null) {
                $9c0Qr.dispose(this.cell.recurrentDropoutMask);
                this.cell.recurrentDropoutMask = null;
            }
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            const initialState = kwargs == null ? null : kwargs['initialState'];
            return super.call(inputs, {
                mask: mask,
                training: training,
                initialState: initialState
            });
        });
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        if (config['implmentation'] === 0) config['implementation'] = 1;
        return new cls(config);
    }
}
/** @nocollapse */ $a6d17f0977e0e3c9$export$effa27cfcc4408f4.className = 'GRU';
(0, $8AyuI).registerClass($a6d17f0977e0e3c9$export$effa27cfcc4408f4);
class $a6d17f0977e0e3c9$export$17aacc547a045ab0 extends $a6d17f0977e0e3c9$export$405d8fca8f98aafd {
    constructor(args){
        super(args);
        this.DEFAULT_ACTIVATION = 'tanh';
        this.DEFAULT_RECURRENT_ACTIVATION = 'hardSigmoid';
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_RECURRENT_INITIALIZER = 'orthogonal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        this.units = args.units;
        (0, $khD6O.assertPositiveInteger)(this.units, 'units');
        this.activation = (0, $bDaSd.getActivation)(args.activation === undefined ? this.DEFAULT_ACTIVATION : args.activation);
        this.recurrentActivation = (0, $bDaSd.getActivation)(args.recurrentActivation === undefined ? this.DEFAULT_RECURRENT_ACTIVATION : args.recurrentActivation);
        this.useBias = args.useBias == null ? true : args.useBias;
        this.kernelInitializer = (0, $fQ95p.getInitializer)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.recurrentInitializer = (0, $fQ95p.getInitializer)(args.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER);
        this.biasInitializer = (0, $fQ95p.getInitializer)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.unitForgetBias = args.unitForgetBias;
        this.kernelRegularizer = (0, $4oHox.getRegularizer)(args.kernelRegularizer);
        this.recurrentRegularizer = (0, $4oHox.getRegularizer)(args.recurrentRegularizer);
        this.biasRegularizer = (0, $4oHox.getRegularizer)(args.biasRegularizer);
        this.kernelConstraint = (0, $cn6Kc.getConstraint)(args.kernelConstraint);
        this.recurrentConstraint = (0, $cn6Kc.getConstraint)(args.recurrentConstraint);
        this.biasConstraint = (0, $cn6Kc.getConstraint)(args.biasConstraint);
        this.dropout = $jBJAM.min([
            1,
            $jBJAM.max([
                0,
                args.dropout == null ? 0 : args.dropout
            ])
        ]);
        this.recurrentDropout = $jBJAM.min([
            1,
            $jBJAM.max([
                0,
                args.recurrentDropout == null ? 0 : args.recurrentDropout
            ])
        ]);
        this.dropoutFunc = args.dropoutFunc;
        this.implementation = args.implementation;
        this.stateSize = [
            this.units,
            this.units
        ];
        this.dropoutMask = null;
        this.recurrentDropoutMask = null;
    }
    build(inputShape) {
        var _a;
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const inputDim = inputShape[inputShape.length - 1];
        this.kernel = this.addWeight('kernel', [
            inputDim,
            this.units * 4
        ], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        this.recurrentKernel = this.addWeight('recurrent_kernel', [
            this.units,
            this.units * 4
        ], null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
        let biasInitializer;
        if (this.useBias) {
            if (this.unitForgetBias) {
                const capturedBiasInit = this.biasInitializer;
                const capturedUnits = this.units;
                biasInitializer = new (_a = class CustomInit extends (0, $fQ95p.Initializer) {
                    apply(shape, dtype) {
                        // TODO(cais): More informative variable names?
                        const bI = capturedBiasInit.apply([
                            capturedUnits
                        ]);
                        const bF = new (0, $fQ95p.Ones)().apply([
                            capturedUnits
                        ]);
                        const bCAndH = capturedBiasInit.apply([
                            capturedUnits * 2
                        ]);
                        return $luRak.concatAlongFirstAxis($luRak.concatAlongFirstAxis(bI, bF), bCAndH);
                    }
                }, /** @nocollapse */ _a.className = 'CustomInit', _a)();
            } else biasInitializer = this.biasInitializer;
            this.bias = this.addWeight('bias', [
                this.units * 4
            ], null, biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        } else this.bias = null;
        // Porting Notes: Unlike the PyKeras implementation, we perform slicing
        //   of the weights and bias in the call() method, at execution time.
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            const training = kwargs['training'] == null ? false : kwargs['training'];
            inputs;
            if (inputs.length !== 3) throw new (0, $jVuYK.ValueError)(`LSTMCell expects 3 input Tensors (inputs, h, c), got ` + `${inputs.length}.`);
            let hTMinus1 = inputs[1]; // Previous memory state.
            const cTMinus1 = inputs[2]; // Previous carry state.
            inputs = inputs[0];
            if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) this.dropoutMask = $a6d17f0977e0e3c9$export$9eb0cce22b72569f({
                ones: ()=>$9u8DQ.onesLike(inputs),
                rate: this.dropout,
                training: training,
                count: 4,
                dropoutFunc: this.dropoutFunc
            });
            if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) this.recurrentDropoutMask = $a6d17f0977e0e3c9$export$9eb0cce22b72569f({
                ones: ()=>$9u8DQ.onesLike(hTMinus1),
                rate: this.recurrentDropout,
                training: training,
                count: 4,
                dropoutFunc: this.dropoutFunc
            });
            const dpMask = this.dropoutMask;
            const recDpMask = this.recurrentDropoutMask;
            // Note: For superior performance, TensorFlow.js always uses
            // implementation 2 regardless of the actual value of
            // config.implementation.
            let i;
            let f;
            let c;
            let o;
            if (0 < this.dropout && this.dropout < 1) inputs = $r7fN6.mul(inputs, dpMask[0]);
            let z = $luRak.dot(inputs, this.kernel.read());
            if (0 < this.recurrentDropout && this.recurrentDropout < 1) hTMinus1 = $r7fN6.mul(hTMinus1, recDpMask[0]);
            z = $1ZrG5.add(z, $luRak.dot(hTMinus1, this.recurrentKernel.read()));
            if (this.useBias) z = $luRak.biasAdd(z, this.bias.read());
            const [z0, z1, z2, z3] = $9DjTt.split(z, 4, z.rank - 1);
            i = this.recurrentActivation.apply(z0);
            f = this.recurrentActivation.apply(z1);
            c = $1ZrG5.add($r7fN6.mul(f, cTMinus1), $r7fN6.mul(i, this.activation.apply(z2)));
            o = this.recurrentActivation.apply(z3);
            const h = $r7fN6.mul(o, this.activation.apply(c));
            // TODO(cais): Add use_learning_phase flag properly.
            return [
                h,
                h,
                c
            ];
        });
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            units: this.units,
            activation: (0, $bDaSd.serializeActivation)(this.activation),
            recurrentActivation: (0, $bDaSd.serializeActivation)(this.recurrentActivation),
            useBias: this.useBias,
            kernelInitializer: (0, $fQ95p.serializeInitializer)(this.kernelInitializer),
            recurrentInitializer: (0, $fQ95p.serializeInitializer)(this.recurrentInitializer),
            biasInitializer: (0, $fQ95p.serializeInitializer)(this.biasInitializer),
            unitForgetBias: this.unitForgetBias,
            kernelRegularizer: (0, $4oHox.serializeRegularizer)(this.kernelRegularizer),
            recurrentRegularizer: (0, $4oHox.serializeRegularizer)(this.recurrentRegularizer),
            biasRegularizer: (0, $4oHox.serializeRegularizer)(this.biasRegularizer),
            activityRegularizer: (0, $4oHox.serializeRegularizer)(this.activityRegularizer),
            kernelConstraint: (0, $cn6Kc.serializeConstraint)(this.kernelConstraint),
            recurrentConstraint: (0, $cn6Kc.serializeConstraint)(this.recurrentConstraint),
            biasConstraint: (0, $cn6Kc.serializeConstraint)(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout,
            implementation: this.implementation
        };
        return Object.assign({}, baseConfig, config);
    }
}
/** @nocollapse */ $a6d17f0977e0e3c9$export$17aacc547a045ab0.className = 'LSTMCell';
(0, $8AyuI).registerClass($a6d17f0977e0e3c9$export$17aacc547a045ab0);
class $a6d17f0977e0e3c9$export$c8c9213153497ce0 extends $a6d17f0977e0e3c9$export$2b97bcdf1d6f1b16 {
    constructor(args){
        if (args.implementation === 0) console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call.");
        args.cell = new $a6d17f0977e0e3c9$export$17aacc547a045ab0(args);
        super(args);
    // TODO(cais): Add activityRegularizer.
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            if (this.cell.dropoutMask != null) {
                $9c0Qr.dispose(this.cell.dropoutMask);
                this.cell.dropoutMask = null;
            }
            if (this.cell.recurrentDropoutMask != null) {
                $9c0Qr.dispose(this.cell.recurrentDropoutMask);
                this.cell.recurrentDropoutMask = null;
            }
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            const initialState = kwargs == null ? null : kwargs['initialState'];
            return super.call(inputs, {
                mask: mask,
                training: training,
                initialState: initialState
            });
        });
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        if (config['implmentation'] === 0) config['implementation'] = 1;
        return new cls(config);
    }
}
/** @nocollapse */ $a6d17f0977e0e3c9$export$c8c9213153497ce0.className = 'LSTM';
(0, $8AyuI).registerClass($a6d17f0977e0e3c9$export$c8c9213153497ce0);
class $a6d17f0977e0e3c9$export$966a21a552328009 extends $a6d17f0977e0e3c9$export$405d8fca8f98aafd {
    constructor(args){
        super(args);
        this.cells = args.cells;
    }
    get stateSize() {
        // States are a flat list in reverse order of the cell stack.
        // This allows perserving the requirement `stack.statesize[0] ===
        // outputDim`. E.g., states of a 2-layer LSTM would be `[h2, c2, h1, c1]`,
        // assuming one LSTM has states `[h, c]`.
        const stateSize = [];
        for (const cell of this.cells.slice().reverse())if (Array.isArray(cell.stateSize)) stateSize.push(...cell.stateSize);
        else stateSize.push(cell.stateSize);
        return stateSize;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            inputs;
            let states = inputs.slice(1);
            // Recover per-cell states.
            const nestedStates = [];
            for (const cell of this.cells.slice().reverse())if (Array.isArray(cell.stateSize)) nestedStates.push(states.splice(0, cell.stateSize.length));
            else nestedStates.push(states.splice(0, 1));
            nestedStates.reverse();
            // Call the cells in order and store the returned states.
            const newNestedStates = [];
            let callInputs;
            for(let i = 0; i < this.cells.length; ++i){
                const cell = this.cells[i];
                states = nestedStates[i];
                // TODO(cais): Take care of constants.
                if (i === 0) callInputs = [
                    inputs[0]
                ].concat(states);
                else callInputs = [
                    callInputs[0]
                ].concat(states);
                callInputs = cell.call(callInputs, kwargs);
                newNestedStates.push(callInputs.slice(1));
            }
            // Format the new states as a flat list in reverse cell order.
            states = [];
            for (const cellStates of newNestedStates.slice().reverse())states.push(...cellStates);
            return [
                callInputs[0]
            ].concat(states);
        });
    }
    build(inputShape) {
        if ((0, $5sw3q.isArrayOfShapes)(inputShape)) // TODO(cais): Take care of input constants.
        // const constantShape = inputShape.slice(1);
        inputShape = inputShape[0];
        inputShape;
        let outputDim;
        this.cells.forEach((cell, i)=>{
            (0, $hQ5cH.nameScope)(`RNNCell_${i}`, ()=>{
                // TODO(cais): Take care of input constants.
                cell.build(inputShape);
                if (Array.isArray(cell.stateSize)) outputDim = cell.stateSize[0];
                else outputDim = cell.stateSize;
                inputShape = [
                    inputShape[0],
                    outputDim
                ];
            });
        });
        this.built = true;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const getCellConfig = (cell)=>{
            return {
                'className': cell.getClassName(),
                'config': cell.getConfig()
            };
        };
        const cellConfigs = this.cells.map(getCellConfig);
        const config = {
            'cells': cellConfigs
        };
        return Object.assign({}, baseConfig, config);
    }
    /** @nocollapse */ static fromConfig(cls, config, customObjects = {}) {
        const cells = [];
        for (const cellConfig of config['cells'])cells.push((0, $dttI1.deserialize)(cellConfig, customObjects));
        return new cls({
            cells: cells
        });
    }
    get trainableWeights() {
        if (!this.trainable) return [];
        const weights = [];
        for (const cell of this.cells)weights.push(...cell.trainableWeights);
        return weights;
    }
    get nonTrainableWeights() {
        const weights = [];
        for (const cell of this.cells)weights.push(...cell.nonTrainableWeights);
        if (!this.trainable) {
            const trainableWeights = [];
            for (const cell of this.cells)trainableWeights.push(...cell.trainableWeights);
            return trainableWeights.concat(weights);
        }
        return weights;
    }
    /**
     * Retrieve the weights of a the model.
     *
     * @returns A flat `Array` of `tf.Tensor`s.
     */ getWeights() {
        const weights = [];
        for (const cell of this.cells)weights.push(...cell.weights);
        return (0, $7muWV.batchGetValue)(weights);
    }
    /**
     * Set the weights of the model.
     *
     * @param weights An `Array` of `tf.Tensor`s with shapes and types matching
     *     the output of `getWeights()`.
     */ setWeights(weights) {
        const tuples = [];
        for (const cell of this.cells){
            const numParams = cell.weights.length;
            const inputWeights = weights.splice(numParams);
            for(let i = 0; i < cell.weights.length; ++i)tuples.push([
                cell.weights[i],
                inputWeights[i]
            ]);
        }
        (0, $7muWV.batchSetValue)(tuples);
    }
}
/** @nocollapse */ $a6d17f0977e0e3c9$export$966a21a552328009.className = 'StackedRNNCells';
(0, $8AyuI).registerClass($a6d17f0977e0e3c9$export$966a21a552328009);
function $a6d17f0977e0e3c9$export$9eb0cce22b72569f(args) {
    const { ones: ones, rate: rate, training: training = false, count: count = 1, dropoutFunc: dropoutFunc } = args;
    const droppedInputs = ()=>dropoutFunc != null ? dropoutFunc(ones(), rate) : $luRak.dropout(ones(), rate);
    const createMask = ()=>$luRak.inTrainPhase(droppedInputs, ones, training);
    // just in case count is provided with null or undefined
    if (!count || count <= 1) return $9c0Qr.keep(createMask().clone());
    const masks = Array(count).fill(undefined).map(createMask);
    return masks.map((m)=>$9c0Qr.keep(m.clone()));
}

});


parcelRegister("4Drap", function(module, exports) {

$parcel$export(module.exports, "Dropout", () => $35ffe0b8e276f4eb$export$bb75bf17e9ebd794);
$parcel$export(module.exports, "SpatialDropout1D", () => $35ffe0b8e276f4eb$export$f86f27a3d1240824);
$parcel$export(module.exports, "Dense", () => $35ffe0b8e276f4eb$export$7db6feeaf0335f8);
$parcel$export(module.exports, "Flatten", () => $35ffe0b8e276f4eb$export$929ed232258ef592);
$parcel$export(module.exports, "Activation", () => $35ffe0b8e276f4eb$export$d4842319833f6f14);
$parcel$export(module.exports, "RepeatVector", () => $35ffe0b8e276f4eb$export$6cf81e630ba27dd9);
$parcel$export(module.exports, "Reshape", () => $35ffe0b8e276f4eb$export$755ddd847e5abe03);
$parcel$export(module.exports, "Permute", () => $35ffe0b8e276f4eb$export$f107458f792fb62e);
$parcel$export(module.exports, "Masking", () => $35ffe0b8e276f4eb$export$b713323c862a70bd);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Basic Layers.
 */ parcelRequire("5n9DG");
var $joFjq = parcelRequire("joFjq");
var $7qWZ5 = parcelRequire("7qWZ5");
var $r7fN6 = parcelRequire("r7fN6");
var $i8e86 = parcelRequire("i8e86");
var $eP0pM = parcelRequire("eP0pM");
var $8AyuI = parcelRequire("8AyuI");
var $9c0Qr = parcelRequire("9c0Qr");
var $9PEYs = parcelRequire("9PEYs");
var $wx9lK = parcelRequire("wx9lK");

var $bDaSd = parcelRequire("bDaSd");

var $luRak = parcelRequire("luRak");

var $cn6Kc = parcelRequire("cn6Kc");

var $cm045 = parcelRequire("cm045");

var $jVuYK = parcelRequire("jVuYK");

var $fQ95p = parcelRequire("fQ95p");

var $4oHox = parcelRequire("4oHox");

var $khD6O = parcelRequire("khD6O");

var $jBJAM = parcelRequire("jBJAM");

var $5sw3q = parcelRequire("5sw3q");
class $35ffe0b8e276f4eb$export$bb75bf17e9ebd794 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        this.rate = Math.max(Math.min(args.rate, 1), 0);
        // So that the scalar doesn't get tidied up between executions.
        this.noiseShape = args.noiseShape;
        this.seed = args.seed;
        this.supportsMasking = true;
    }
    getNoiseShape(input) {
        if (this.noiseShape == null) return this.noiseShape;
        const inputShape = input.shape;
        const noiseShape = [];
        for(let i = 0; i < this.noiseShape.length; ++i)noiseShape.push(this.noiseShape[i] == null ? inputShape[i] : this.noiseShape[i]);
        return noiseShape;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            if (0 < this.rate && this.rate < 1) {
                const training = kwargs['training'] == null ? false : kwargs['training'];
                const noiseShape = this.getNoiseShape(input);
                const output = $luRak.inTrainPhase(()=>$luRak.dropout(input, this.rate, noiseShape, this.seed), ()=>input, training);
                return output;
            }
            return inputs;
        });
    }
    getConfig() {
        const config = {
            rate: this.rate,
            noiseShape: this.noiseShape,
            seed: this.seed
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    dispose() {
        return super.dispose();
    }
}
/** @nocollapse */ $35ffe0b8e276f4eb$export$bb75bf17e9ebd794.className = 'Dropout';
(0, $8AyuI).registerClass($35ffe0b8e276f4eb$export$bb75bf17e9ebd794);
class $35ffe0b8e276f4eb$export$f86f27a3d1240824 extends $35ffe0b8e276f4eb$export$bb75bf17e9ebd794 {
    constructor(args){
        super(args);
        this.inputSpec = [
            {
                ndim: 3
            }
        ];
    }
    getNoiseShape(input) {
        const inputShape = input.shape;
        return [
            inputShape[0],
            1,
            inputShape[2]
        ];
    }
}
/** @nocollapse */ $35ffe0b8e276f4eb$export$f86f27a3d1240824.className = 'SpatialDropout1D';
(0, $8AyuI).registerClass($35ffe0b8e276f4eb$export$f86f27a3d1240824);
class $35ffe0b8e276f4eb$export$7db6feeaf0335f8 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        // Default activation: Linear (none).
        this.activation = null;
        this.useBias = true;
        this.kernel = null;
        this.bias = null;
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        if (args.batchInputShape == null && args.inputShape == null && args.inputDim != null) {
            // This logic is copied from Layer's constructor, since we can't
            // do exactly what the Python constructor does for Dense().
            let batchSize = null;
            if (args.batchSize != null) batchSize = args.batchSize;
            this.batchInputShape = [
                batchSize,
                args.inputDim
            ];
        }
        this.units = args.units;
        (0, $khD6O.assertPositiveInteger)(this.units, 'units');
        this.activation = (0, $bDaSd.getActivation)(args.activation);
        if (args.useBias != null) this.useBias = args.useBias;
        this.kernelInitializer = (0, $fQ95p.getInitializer)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.biasInitializer = (0, $fQ95p.getInitializer)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.kernelConstraint = (0, $cn6Kc.getConstraint)(args.kernelConstraint);
        this.biasConstraint = (0, $cn6Kc.getConstraint)(args.biasConstraint);
        this.kernelRegularizer = (0, $4oHox.getRegularizer)(args.kernelRegularizer);
        this.biasRegularizer = (0, $4oHox.getRegularizer)(args.biasRegularizer);
        this.activityRegularizer = (0, $4oHox.getRegularizer)(args.activityRegularizer);
        this.supportsMasking = true;
        this.inputSpec = [
            {
                minNDim: 2
            }
        ];
    }
    build(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const inputLastDim = inputShape[inputShape.length - 1];
        if (this.kernel == null) {
            this.kernel = this.addWeight('kernel', [
                inputLastDim,
                this.units
            ], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
            if (this.useBias) this.bias = this.addWeight('bias', [
                this.units
            ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        }
        this.inputSpec = [
            {
                minNDim: 2,
                axes: {
                    [-1]: inputLastDim
                }
            }
        ];
        this.built = true;
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const outputShape = inputShape.slice();
        outputShape[outputShape.length - 1] = this.units;
        return outputShape;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            // Dense layer accepts only a single input.
            const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            const fusedActivationName = (0, $khD6O.mapActivationToFusedKernel)(this.activation.getClassName());
            let output;
            if (fusedActivationName != null) output = $luRak.dot(input, this.kernel.read(), fusedActivationName, this.bias ? this.bias.read() : null);
            else {
                output = $luRak.dot(input, this.kernel.read());
                if (this.bias != null) output = $luRak.biasAdd(output, this.bias.read());
                if (this.activation != null) output = this.activation.apply(output);
            }
            return output;
        });
    }
    getConfig() {
        const config = {
            units: this.units,
            activation: (0, $bDaSd.serializeActivation)(this.activation),
            useBias: this.useBias,
            kernelInitializer: (0, $fQ95p.serializeInitializer)(this.kernelInitializer),
            biasInitializer: (0, $fQ95p.serializeInitializer)(this.biasInitializer),
            kernelRegularizer: (0, $4oHox.serializeRegularizer)(this.kernelRegularizer),
            biasRegularizer: (0, $4oHox.serializeRegularizer)(this.biasRegularizer),
            activityRegularizer: (0, $4oHox.serializeRegularizer)(this.activityRegularizer),
            kernelConstraint: (0, $cn6Kc.serializeConstraint)(this.kernelConstraint),
            biasConstraint: (0, $cn6Kc.serializeConstraint)(this.biasConstraint)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $35ffe0b8e276f4eb$export$7db6feeaf0335f8.className = 'Dense';
(0, $8AyuI).registerClass($35ffe0b8e276f4eb$export$7db6feeaf0335f8);
class $35ffe0b8e276f4eb$export$929ed232258ef592 extends (0, $cm045.Layer) {
    constructor(args){
        args = args || {};
        super(args);
        this.inputSpec = [
            {
                minNDim: 3
            }
        ];
        this.dataFormat = args.dataFormat;
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        for (const dim of inputShape.slice(1)){
            if (dim == null) throw new (0, $jVuYK.ValueError)(`The shape of the input to "Flatten" is not fully defined ` + `(got ${inputShape.slice(1)}). Make sure to pass a complete ` + `"input_shape" or "batch_input_shape" argument to the first ` + `layer in your model.`);
        }
        return [
            inputShape[0],
            (0, $jBJAM.arrayProd)(inputShape, 1)
        ];
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            let input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            if (this.dataFormat === 'channelsFirst' && input.rank > 1) {
                const permutation = [
                    0
                ];
                for(let i = 2; i < input.rank; ++i)permutation.push(i);
                permutation.push(1);
                input = (0, $9PEYs.transpose)(input, permutation);
            }
            return $luRak.batchFlatten(input);
        });
    }
    getConfig() {
        const config = {};
        if (this.dataFormat != null) config['dataFormat'] = this.dataFormat;
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $35ffe0b8e276f4eb$export$929ed232258ef592.className = 'Flatten';
(0, $8AyuI).registerClass($35ffe0b8e276f4eb$export$929ed232258ef592);
class $35ffe0b8e276f4eb$export$d4842319833f6f14 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        this.supportsMasking = true;
        this.activation = (0, $bDaSd.getActivation)(args.activation);
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            return this.activation.apply(input);
        });
    }
    getConfig() {
        const config = {
            activation: (0, $bDaSd.serializeActivation)(this.activation)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $35ffe0b8e276f4eb$export$d4842319833f6f14.className = 'Activation';
(0, $8AyuI).registerClass($35ffe0b8e276f4eb$export$d4842319833f6f14);
class $35ffe0b8e276f4eb$export$6cf81e630ba27dd9 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        this.n = args.n;
        this.inputSpec = [
            {
                ndim: 2
            }
        ];
    }
    computeOutputShape(inputShape) {
        return [
            inputShape[0],
            this.n,
            inputShape[1]
        ];
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            inputs = (0, $5sw3q.getExactlyOneTensor)(inputs);
            return $luRak.repeat(inputs, this.n);
        });
    }
    getConfig() {
        const config = {
            n: this.n
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $35ffe0b8e276f4eb$export$6cf81e630ba27dd9.className = 'RepeatVector';
(0, $8AyuI).registerClass($35ffe0b8e276f4eb$export$6cf81e630ba27dd9);
class $35ffe0b8e276f4eb$export$755ddd847e5abe03 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        this.targetShape = args.targetShape;
        // Make sure that all unknown dimensions are represented as `null`.
        for(let i = 0; i < this.targetShape.length; ++i)if (this.isUnknown(this.targetShape[i])) this.targetShape[i] = null;
    }
    isUnknown(dim) {
        return dim < 0 || dim == null;
    }
    /**
     * Finds and replaces a missing dimension in output shape.
     *
     * This is a near direct port of the internal Numpy function
     * `_fix_unknown_dimension` in `numpy/core/src/multiarray/shape.c`.
     *
     * @param inputShape: Original shape of array begin reshape.
     * @param outputShape: Target shape of the array, with at most a single
     * `null` or negative number, which indicates an underdetermined dimension
     * that should be derived from `inputShape` and the known dimensions of
     *   `outputShape`.
     * @returns: The output shape with `null` replaced with its computed value.
     * @throws: ValueError: If `inputShape` and `outputShape` do not match.
     */ fixUnknownDimension(inputShape, outputShape) {
        const errorMsg = 'Total size of new array must be unchanged.';
        const finalShape = outputShape.slice();
        let known = 1;
        let unknown = null;
        for(let i = 0; i < finalShape.length; ++i){
            const dim = finalShape[i];
            if (this.isUnknown(dim)) {
                if (unknown === null) unknown = i;
                else throw new (0, $jVuYK.ValueError)('Can only specifiy one unknown dimension.');
            } else known *= dim;
        }
        const originalSize = (0, $jBJAM.arrayProd)(inputShape);
        if (unknown !== null) {
            if (known === 0 || originalSize % known !== 0) throw new (0, $jVuYK.ValueError)(errorMsg);
            finalShape[unknown] = originalSize / known;
        } else if (originalSize !== known) throw new (0, $jVuYK.ValueError)(errorMsg);
        return finalShape;
    }
    computeOutputShape(inputShape) {
        let anyUnknownDims = false;
        for(let i = 0; i < inputShape.length; ++i)if (this.isUnknown(inputShape[i])) {
            anyUnknownDims = true;
            break;
        }
        if (anyUnknownDims) return inputShape.slice(0, 1).concat(this.targetShape);
        else return inputShape.slice(0, 1).concat(this.fixUnknownDimension(inputShape.slice(1), this.targetShape));
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            const inputShape = input.shape;
            const outputShape = inputShape.slice(0, 1).concat(this.fixUnknownDimension(inputShape.slice(1), this.targetShape));
            return (0, $eP0pM.reshape)(input, outputShape);
        });
    }
    getConfig() {
        const config = {
            targetShape: this.targetShape
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $35ffe0b8e276f4eb$export$755ddd847e5abe03.className = 'Reshape';
(0, $8AyuI).registerClass($35ffe0b8e276f4eb$export$755ddd847e5abe03);
class $35ffe0b8e276f4eb$export$f107458f792fb62e extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        if (args.dims == null) throw new Error("Required configuration field `dims` is missing during Permute constructor call.");
        if (!Array.isArray(args.dims)) throw new Error('Permute constructor requires `dims` to be an Array, but received ' + `${args.dims} instead.`);
        // Check the validity of the permutation indices.
        const expectedSortedIndices = (0, $jBJAM.range)(1, args.dims.length + 1);
        if (!(0, $wx9lK).arraysEqual(args.dims.slice().sort(), expectedSortedIndices)) throw new Error('Invalid permutation `dims`: ' + JSON.stringify(args.dims) + ' `dims` must contain consecutive integers starting from 1.');
        this.dims = args.dims;
        this.dimsIncludingBatch = [
            0
        ].concat(this.dims);
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: this.dims.length + 1
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const outputShape = inputShape.slice();
        this.dims.forEach((dim, i)=>{
            outputShape[i + 1] = inputShape[dim];
        });
        return outputShape;
    }
    call(inputs, kwargs) {
        return (0, $9PEYs.transpose)((0, $5sw3q.getExactlyOneTensor)(inputs), this.dimsIncludingBatch);
    }
    getConfig() {
        const config = {
            dims: this.dims
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $35ffe0b8e276f4eb$export$f107458f792fb62e.className = 'Permute';
(0, $8AyuI).registerClass($35ffe0b8e276f4eb$export$f107458f792fb62e);
class $35ffe0b8e276f4eb$export$b713323c862a70bd extends (0, $cm045.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.supportsMasking = true;
        if (args != null) this.maskValue = args.maskValue == null ? 0 : args.maskValue;
        else this.maskValue = 0;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            maskValue: this.maskValue
        };
        Object.assign(config, baseConfig);
        return config;
    }
    computeMask(inputs, mask) {
        const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
        const axis = -1;
        return (0, $joFjq.any)((0, $i8e86.notEqual)(input, this.maskValue), axis);
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            const axis = -1;
            const keepDims = true;
            const booleanMask = (0, $joFjq.any)((0, $i8e86.notEqual)(input, this.maskValue), axis, keepDims);
            const output = (0, $r7fN6.mul)(input, (0, $7qWZ5.cast)(booleanMask, input.dtype));
            return output;
        });
    }
}
/** @nocollapse */ $35ffe0b8e276f4eb$export$b713323c862a70bd.className = 'Masking';
(0, $8AyuI).registerClass($35ffe0b8e276f4eb$export$b713323c862a70bd);

});

parcelRegister("7X54l", function(module, exports) {

$parcel$export(module.exports, "Embedding", () => $5ca1f9b3fcc03480$export$d4aa6cf23314fd52);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Embedding Layer.
 *
 * Original source: keras/constraints.py
 */ parcelRequire("5n9DG");
var $i8e86 = parcelRequire("i8e86");
var $eP0pM = parcelRequire("eP0pM");
var $8AyuI = parcelRequire("8AyuI");
var $9c0Qr = parcelRequire("9c0Qr");
var $k1Ozi = parcelRequire("k1Ozi");

var $luRak = parcelRequire("luRak");

var $cn6Kc = parcelRequire("cn6Kc");

var $cm045 = parcelRequire("cm045");

var $jVuYK = parcelRequire("jVuYK");

var $fQ95p = parcelRequire("fQ95p");

var $4oHox = parcelRequire("4oHox");

var $khD6O = parcelRequire("khD6O");

var $5sw3q = parcelRequire("5sw3q");
class $5ca1f9b3fcc03480$export$d4aa6cf23314fd52 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        this.embeddings = null;
        this.DEFAULT_EMBEDDINGS_INITIALIZER = 'randomUniform';
        if (args.batchInputShape == null && args.inputShape == null) {
            // Porting Note: This logic is copied from Layer's constructor, since we
            // can't do exactly what the Python constructor does for Embedding().
            // Specifically, the super constructor can not be called after the
            // mutation of the `config` argument.
            let batchSize = null;
            if (args.batchSize != null) batchSize = args.batchSize;
            if (args.inputLength == null) // Fix super-constructor to what it would have done if
            // 'config.inputShape' were (None, )
            this.batchInputShape = [
                batchSize,
                null
            ];
            else // Fix super-constructor to what it would have done if
            // 'config.inputShape' were (config.inputLength, )
            this.batchInputShape = [
                batchSize
            ].concat($khD6O.toList(args.inputLength));
        }
        this.inputDim = args.inputDim;
        $khD6O.assertPositiveInteger(this.inputDim, 'inputDim');
        this.outputDim = args.outputDim;
        $khD6O.assertPositiveInteger(this.outputDim, 'outputDim');
        this.embeddingsInitializer = (0, $fQ95p.getInitializer)(args.embeddingsInitializer || this.DEFAULT_EMBEDDINGS_INITIALIZER);
        this.embeddingsRegularizer = (0, $4oHox.getRegularizer)(args.embeddingsRegularizer);
        this.activityRegularizer = (0, $4oHox.getRegularizer)(args.activityRegularizer);
        this.embeddingsConstraint = (0, $cn6Kc.getConstraint)(args.embeddingsConstraint);
        this.maskZero = args.maskZero;
        this.supportsMasking = args.maskZero;
        this.inputLength = args.inputLength;
    }
    build(inputShape) {
        this.embeddings = this.addWeight('embeddings', [
            this.inputDim,
            this.outputDim
        ], this.dtype, this.embeddingsInitializer, this.embeddingsRegularizer, true, this.embeddingsConstraint);
        this.built = true;
    }
    // Override warnOnIncompatibleInputShape because an embedding layer allows
    // the input to have varying ranks.
    warnOnIncompatibleInputShape(inputShape) {}
    computeMask(inputs, mask) {
        return (0, $9c0Qr.tidy)(()=>{
            if (!this.maskZero) return null;
            else {
                inputs = (0, $5sw3q.getExactlyOneTensor)(inputs);
                return (0, $i8e86.notEqual)(inputs, (0, $k1Ozi.zerosLike)(inputs));
            }
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        if (this.inputLength == null) return [
            ...inputShape,
            this.outputDim
        ];
        // inputLength can be an array if input is 3D or higher.
        const inLens = $khD6O.toList(this.inputLength);
        if (inLens.length !== inputShape.length - 1) throw new (0, $jVuYK.ValueError)(`"inputLength" is ${this.inputLength}, but received ` + `input shape has shape ${inputShape}`);
        else {
            let i = 0;
            for(let k = 0; k < inLens.length; ++k){
                const s1 = inLens[k];
                const s2 = inputShape[k + 1];
                if (s1 != null && s2 != null && s1 !== s2) throw new (0, $jVuYK.ValueError)(`"inputLength" is ${this.inputLength}, but received ` + `input shape has shape ${inputShape}`);
                else if (s1 == null) inLens[i] = s2;
                i++;
            }
        }
        return [
            inputShape[0],
            ...inLens,
            this.outputDim
        ];
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            // Embedding layer accepts only a single input.
            let input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            if (input.dtype !== 'int32') input = $luRak.cast(input, 'int32');
            const output = $luRak.gather(this.embeddings.read(), (0, $eP0pM.reshape)(input, [
                input.size
            ]));
            return (0, $eP0pM.reshape)(output, (0, $5sw3q.getExactlyOneShape)(this.computeOutputShape(input.shape)));
        });
    }
    getConfig() {
        const config = {
            inputDim: this.inputDim,
            outputDim: this.outputDim,
            embeddingsInitializer: (0, $fQ95p.serializeInitializer)(this.embeddingsInitializer),
            embeddingsRegularizer: (0, $4oHox.serializeRegularizer)(this.embeddingsRegularizer),
            activityRegularizer: (0, $4oHox.serializeRegularizer)(this.activityRegularizer),
            embeddingsConstraint: (0, $cn6Kc.serializeConstraint)(this.embeddingsConstraint),
            maskZero: this.maskZero,
            inputLength: this.inputLength
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $5ca1f9b3fcc03480$export$d4aa6cf23314fd52.className = 'Embedding';
(0, $8AyuI).registerClass($5ca1f9b3fcc03480$export$d4aa6cf23314fd52);

});

parcelRegister("4qVWd", function(module, exports) {

$parcel$export(module.exports, "Add", () => $33a688647ac37d4d$export$d0265b2c425512d6);
$parcel$export(module.exports, "Multiply", () => $33a688647ac37d4d$export$f14f83b3b531d498);
$parcel$export(module.exports, "Average", () => $33a688647ac37d4d$export$7725e1a7540355cb);
$parcel$export(module.exports, "Maximum", () => $33a688647ac37d4d$export$d8d02ac92d161004);
$parcel$export(module.exports, "Minimum", () => $33a688647ac37d4d$export$23cb308301e89d6b);
$parcel$export(module.exports, "Concatenate", () => $33a688647ac37d4d$export$e55b597c359d82cd);
$parcel$export(module.exports, "Dot", () => $33a688647ac37d4d$export$d046b3c4a416f60d);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Merge Layers.
 */ parcelRequire("5n9DG");
var $1ZrG5 = parcelRequire("1ZrG5");
var $br27u = parcelRequire("br27u");
var $7qWZ5 = parcelRequire("7qWZ5");
var $6LWfo = parcelRequire("6LWfo");
var $6mzQK = parcelRequire("6mzQK");
var $jtRHJ = parcelRequire("jtRHJ");
var $clO9Z = parcelRequire("clO9Z");
var $aW7Gb = parcelRequire("aW7Gb");
var $dlTNL = parcelRequire("dlTNL");
var $r7fN6 = parcelRequire("r7fN6");
var $9u8DQ = parcelRequire("9u8DQ");
var $eP0pM = parcelRequire("eP0pM");
var $8AyuI = parcelRequire("8AyuI");
var $wniip = parcelRequire("wniip");
var $fVwnn = parcelRequire("fVwnn");
var $9c0Qr = parcelRequire("9c0Qr");
var $9PEYs = parcelRequire("9PEYs");
var $wx9lK = parcelRequire("wx9lK");

var $luRak = parcelRequire("luRak");

var $cm045 = parcelRequire("cm045");

var $jVuYK = parcelRequire("jVuYK");

var $LJ7JU = parcelRequire("LJ7JU");

var $khD6O = parcelRequire("khD6O");

var $jBJAM = parcelRequire("jBJAM");

var $5sw3q = parcelRequire("5sw3q");
class $33a688647ac37d4d$export$70ce1d34efd3b886 extends (0, $cm045.Layer) {
    constructor(args){
        super(args || {});
        this.supportsMasking = true;
    }
    /**
     * Logic for merging multiple tensors, to be overridden by subclasses.
     * @param inputs
     */ mergeFunction(inputs) {
        throw new (0, $jVuYK.NotImplementedError)();
    }
    /**
     * Computes the shape of the result of an elementwise operation.
     *
     * @param shape1: Shape of the first tensor.
     * @param shape2: Shape of the second tensor.
     * @returns Expected output shape when an elementwise operation is carried
     *   out on 2 tensors with shapes `shape1` and `shape2`.
     * @throws ValueError: If `shape1` and `shape2` are not compatible for
     *   element-wise operations.
     */ computeElementwiseOpOutputShape(shape1, shape2) {
        if (shape1 == null || shape2 == null) return null;
        else if (shape1.length < shape2.length) return this.computeElementwiseOpOutputShape(shape2, shape1);
        else if (shape2.length === 0) return shape1;
        const outputShape = shape1.slice(0, shape1.length - shape2.length);
        for(let k = 0; k < shape2.length; ++k){
            const i = shape1[shape1.length - shape2.length + k];
            const j = shape2[k];
            if (i == null || j == null || i < 0 || j < 0) outputShape.push(null);
            else if (i === 1) outputShape.push(j);
            else if (j === 1) outputShape.push(i);
            else {
                if (i !== j) throw new (0, $jVuYK.ValueError)('Operands could not be broadcast together with shapes ' + JSON.stringify(shape1) + ' ' + JSON.stringify(shape2));
                outputShape.push(i);
            }
        }
        return outputShape;
    }
    build(inputShape) {
        // Used purely for shape validation.
        if (Array.isArray(inputShape) && !Array.isArray(inputShape[0])) // Make sure that inputShape is an Array of shape.
        inputShape = [
            (0, $5sw3q.getExactlyOneShape)(inputShape)
        ];
        inputShape;
        if (inputShape.length < 2) throw new (0, $jVuYK.ValueError)('A merge layer should be called on an Array of at least 2 inputs.' + ` Got ${inputShape.length} input(s).`);
        // Make sure that there is at most one unique batch size among the input
        // shapes.
        let batchSizes = [];
        for (const shape of inputShape)if (shape != null && shape[0] !== null) batchSizes.push(shape[0]);
        batchSizes = $khD6O.unique(batchSizes);
        if (batchSizes.length > 1) throw new (0, $jVuYK.ValueError)(`Can not merge tensors with different batch sizes. ` + `Got tensors with shapes: ${JSON.stringify(inputShape)}.`);
        let outputShape = inputShape[0] == null ? null : inputShape[0].slice(1);
        for(let i = 1; i < inputShape.length; ++i){
            const shape = inputShape[i] == null ? null : inputShape[i].slice(1);
            outputShape = this.computeElementwiseOpOutputShape(outputShape, shape);
        }
        // If the inputs have different ranks, we have to reshape them to make them
        // broadcastable.
        const allRanks = inputShape.map((shape)=>shape.length);
        if (inputShape.indexOf(null) === -1 && $khD6O.unique(allRanks).length === 1) this.reshapeRequired = false;
        else this.reshapeRequired = true;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            inputs;
            if (this.reshapeRequired) {
                const reshapedInputs = [];
                const inputDims = inputs.map((input)=>input.rank);
                if (inputDims.indexOf(null) === -1) {
                    // If ranks of all inputs are available, we simply expand each of them
                    // at axis=1 until all of them have the same rank.
                    const maxNDim = $jBJAM.max(inputDims);
                    for (let x of inputs){
                        const xNDim = x.rank;
                        for(let k = 0; k < maxNDim - xNDim; ++k)x = $luRak.expandDims(x, 1);
                        reshapedInputs.push(x);
                    }
                    return this.mergeFunction(reshapedInputs);
                } else {
                    // Transpose all inputs so that batch size is the last dimension.
                    // [batchSize, dim1, dim2, ...] -> [dim1, dim2, ..., batchSize]
                    let transposed = false;
                    for (const x of inputs){
                        const xNDim = x.rank;
                        if (xNDim == null) {
                            const xShape = x.shape;
                            const batchSize = xShape[0];
                            const newShape = xShape.slice(1).concat([
                                batchSize
                            ]);
                            let xTransposed = $eP0pM.reshape(x, [
                                batchSize
                            ].concat($jBJAM.arrayProd(xShape.slice(1))));
                            xTransposed = $9PEYs.transpose(xTransposed, [
                                1,
                                0
                            ]);
                            xTransposed = $eP0pM.reshape(xTransposed, newShape);
                            reshapedInputs.push(xTransposed);
                            transposed = true;
                        } else if (xNDim > 1) {
                            const dims = $jBJAM.range(1, xNDim).concat([
                                0
                            ]);
                            reshapedInputs.push($9PEYs.transpose(x, dims));
                            transposed = true;
                        } else // We don't transpose inputs if they are 1D vectors or scalars.
                        reshapedInputs.push(x);
                    }
                    let y = this.mergeFunction(reshapedInputs);
                    const yNDim = y.rank;
                    if (transposed) {
                        // If inputs have been transposed, we have to transpose the output
                        // too.
                        if (yNDim == null) {
                            const yShape = y.shape;
                            const yNDim = yShape.length;
                            const batchSize = yShape[yNDim - 1];
                            const newShape = [
                                batchSize
                            ].concat(yShape.slice(0, yShape.length - 1));
                            y = $eP0pM.reshape($9PEYs.transpose($eP0pM.reshape(y, [
                                -1,
                                batchSize
                            ]), [
                                1,
                                0
                            ]), newShape);
                        } else if (yNDim > 1) {
                            const dims = [
                                yNDim - 1
                            ].concat($jBJAM.range(0, yNDim - 1));
                            y = $9PEYs.transpose(y, dims);
                        }
                    }
                    return y;
                }
            } else return this.mergeFunction(inputs);
        });
    }
    computeOutputShape(inputShape) {
        inputShape;
        let outputShape;
        if (inputShape[0] == null) outputShape = null;
        else outputShape = inputShape[0].slice(1);
        for(let i = 1; i < inputShape.length; ++i){
            const shape = inputShape[i] == null ? null : inputShape[i].slice(1);
            outputShape = this.computeElementwiseOpOutputShape(outputShape, shape);
        }
        let batchSizes = [];
        for (const shape of inputShape)if (shape != null && shape[0] !== null) batchSizes.push(shape[0]);
        batchSizes = $khD6O.unique(batchSizes);
        if (batchSizes.length === 1) outputShape = batchSizes.concat(outputShape);
        else outputShape = [
            null
        ].concat(outputShape);
        return outputShape;
    }
    computeMask(inputs, mask) {
        return $9c0Qr.tidy(()=>{
            if (mask == null) return null;
            if (!Array.isArray(mask)) throw new (0, $jVuYK.ValueError)('`mask` should be an Array');
            if (!Array.isArray(inputs)) throw new (0, $jVuYK.ValueError)('`inputs` should be an Array');
            if (mask.length !== inputs.length) throw new (0, $jVuYK.ValueError)(`The Array 'inputs' and 'mask' are expected to have the same ` + `length, but have different lengths ` + `(${inputs.length} vs ${mask.length})`);
            if (mask.every((m)=>m == null)) return null;
            mask = mask.map((m)=>m == null ? m : $6mzQK.expandDims(m, 0));
            let output = mask[0];
            for(let i = 1; i < mask.length - 1; ++i)output = $jtRHJ.logicalAnd(output, mask[i]);
            return output;
        });
    }
}
class $33a688647ac37d4d$export$d0265b2c425512d6 extends $33a688647ac37d4d$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $9c0Qr.tidy)(()=>{
            let output = inputs[0].clone();
            for(let i = 1; i < inputs.length; ++i)output = $1ZrG5.add(output, inputs[i]);
            return output;
        });
    }
}
/** @nocollapse */ $33a688647ac37d4d$export$d0265b2c425512d6.className = 'Add';
(0, $8AyuI).registerClass($33a688647ac37d4d$export$d0265b2c425512d6);
function $33a688647ac37d4d$export$e16d8520af44a096(config) {
    if (Array.isArray(config)) {
        const layer = new $33a688647ac37d4d$export$d0265b2c425512d6({});
        return layer.apply(config);
    } else return new $33a688647ac37d4d$export$d0265b2c425512d6(config);
}
class $33a688647ac37d4d$export$f14f83b3b531d498 extends $33a688647ac37d4d$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $9c0Qr.tidy)(()=>{
            let output = inputs[0].clone();
            for(let i = 1; i < inputs.length; ++i)output = $r7fN6.mul(output, inputs[i]);
            return output;
        });
    }
}
/** @nocollapse */ $33a688647ac37d4d$export$f14f83b3b531d498.className = 'Multiply';
(0, $8AyuI).registerClass($33a688647ac37d4d$export$f14f83b3b531d498);
function $33a688647ac37d4d$export$2060d2db72cce88f(config) {
    if (Array.isArray(config)) {
        const layer = new $33a688647ac37d4d$export$f14f83b3b531d498({});
        return layer.apply(config);
    } else return new $33a688647ac37d4d$export$f14f83b3b531d498(config);
}
class $33a688647ac37d4d$export$7725e1a7540355cb extends $33a688647ac37d4d$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $9c0Qr.tidy)(()=>{
            let output = inputs[0].clone();
            for(let i = 1; i < inputs.length; ++i)output = $1ZrG5.add(output, inputs[i]);
            return $r7fN6.mul(1 / inputs.length, output);
        });
    }
}
/** @nocollapse */ $33a688647ac37d4d$export$7725e1a7540355cb.className = 'Average';
(0, $8AyuI).registerClass($33a688647ac37d4d$export$7725e1a7540355cb);
function $33a688647ac37d4d$export$cc6710ee5f037d57(config) {
    if (Array.isArray(config)) {
        const layer = new $33a688647ac37d4d$export$7725e1a7540355cb({});
        return layer.apply(config);
    } else return new $33a688647ac37d4d$export$7725e1a7540355cb(config);
}
class $33a688647ac37d4d$export$d8d02ac92d161004 extends $33a688647ac37d4d$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $9c0Qr.tidy)(()=>{
            let output = inputs[0];
            for(let i = 1; i < inputs.length; ++i)output = $aW7Gb.maximum(output, inputs[i]);
            return output;
        });
    }
}
/** @nocollapse */ $33a688647ac37d4d$export$d8d02ac92d161004.className = 'Maximum';
(0, $8AyuI).registerClass($33a688647ac37d4d$export$d8d02ac92d161004);
function $33a688647ac37d4d$export$b25e0be55f42c9a(config) {
    if (Array.isArray(config)) {
        const layer = new $33a688647ac37d4d$export$d8d02ac92d161004({});
        return layer.apply(config);
    } else return new $33a688647ac37d4d$export$d8d02ac92d161004(config);
}
class $33a688647ac37d4d$export$23cb308301e89d6b extends $33a688647ac37d4d$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $9c0Qr.tidy)(()=>{
            let output = inputs[0];
            for(let i = 1; i < inputs.length; ++i)output = $dlTNL.minimum(output, inputs[i]);
            return output;
        });
    }
}
/** @nocollapse */ $33a688647ac37d4d$export$23cb308301e89d6b.className = 'Minimum';
(0, $8AyuI).registerClass($33a688647ac37d4d$export$23cb308301e89d6b);
function $33a688647ac37d4d$export$916782c1f0ddb132(config) {
    if (Array.isArray(config)) {
        const layer = new $33a688647ac37d4d$export$23cb308301e89d6b({});
        return layer.apply(config);
    } else return new $33a688647ac37d4d$export$23cb308301e89d6b(config);
}
class $33a688647ac37d4d$export$e55b597c359d82cd extends $33a688647ac37d4d$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
        this.DEFAULT_AXIS = -1;
        if (args == null) args = {};
        this.axis = args.axis == null ? this.DEFAULT_AXIS : args.axis;
        this.supportsMasking = true;
        this.reshapeRequired = false;
    }
    build(inputShape) {
        // Used purely for shape validation.]
        if (!(Array.isArray(inputShape) && Array.isArray(inputShape[0])) || inputShape.length === 1) throw new (0, $jVuYK.ValueError)("A `Concatenate` layer should be called on a list of at least 2 inputs");
        inputShape;
        let allNoneShape = true;
        for (const shape of inputShape)if (shape != null) {
            allNoneShape = false;
            break;
        }
        if (allNoneShape) return;
        const shapeSet = [];
        for(let i = 0; i < inputShape.length; ++i){
            const shapeWithoutConcatAxis = inputShape[i].slice();
            shapeWithoutConcatAxis.splice(this.axis, 1);
            let exists = false;
            for (const shape of shapeSet)if ((0, $wx9lK).arraysEqual(shape, shapeWithoutConcatAxis)) {
                exists = true;
                break;
            }
            if (!exists) shapeSet.push(shapeWithoutConcatAxis);
        }
        if (shapeSet.length > 1) throw new (0, $jVuYK.ValueError)("A `Concatenate` layer requires inputs with matching shapes except for the concat axis. Got input shapes: " + JSON.stringify(inputShape));
    }
    mergeFunction(inputs) {
        return (0, $9c0Qr.tidy)(()=>{
            return $luRak.concatenate(inputs, this.axis);
        });
    }
    computeOutputShape(inputShape) {
        if (!(Array.isArray(inputShape) && Array.isArray(inputShape[0]))) throw new (0, $jVuYK.ValueError)('A `Concatenate` layer should be called on a list of inputs.');
        const inputShapes = inputShape;
        const outputShape = inputShapes[0].slice();
        const axis = this.axis < 0 ? outputShape.length + this.axis : this.axis;
        // Porting Note: the line above is because TypeScript doesn't support
        //   negative indices.
        for (const shape of inputShapes.slice(1)){
            if (outputShape[axis] == null || shape[axis] == null) {
                outputShape[axis] = null;
                break;
            }
            outputShape[axis] += shape[axis];
        }
        return outputShape;
    }
    computeMask(inputs, mask) {
        if (mask == null) return null;
        if (!Array.isArray(mask)) throw new (0, $jVuYK.ValueError)('`mask` should be an array for Concatenate');
        if (!Array.isArray(inputs)) throw new (0, $jVuYK.ValueError)('`inputs` should be an array for Concatenate');
        if (mask.length !== inputs.length) throw new (0, $jVuYK.ValueError)(`Mismatch in the length of mask (${mask.length}) ` + `and the legnth of inputs (${inputs.length})`);
        return $9c0Qr.tidy(()=>{
            let allNullMasks = true;
            mask.forEach((m)=>{
                if (m != null) {
                    allNullMasks = false;
                    return;
                }
            });
            if (allNullMasks) return null;
            const outputMasks = [];
            for(let i = 0; i < inputs.length; ++i){
                if (mask[i] == null) // Input is unmasked. Append all 1's to masks.
                outputMasks.push($7qWZ5.cast($9u8DQ.onesLike(inputs[i]), 'bool'));
                else if (mask[i].rank < inputs[i].rank) // Mask is smaller than the input, expand it.
                outputMasks.push($6mzQK.expandDims(mask[i], -1));
                else outputMasks.push(mask[i]);
            }
            const concatenatedMasks = $6LWfo.concat(outputMasks, this.axis);
            return $br27u.all(concatenatedMasks, -1, false);
        });
    }
    getConfig() {
        const config = {
            'axis': this.axis
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $33a688647ac37d4d$export$e55b597c359d82cd.className = 'Concatenate';
(0, $8AyuI).registerClass($33a688647ac37d4d$export$e55b597c359d82cd);
function $33a688647ac37d4d$export$375c71d43969527d(config) {
    if (Array.isArray(config)) {
        const layer = new $33a688647ac37d4d$export$e55b597c359d82cd({});
        return layer.apply(config);
    } else return new $33a688647ac37d4d$export$e55b597c359d82cd(config);
}
/**
 * Interpretable potentially negative axis index.
 *
 * For example, given axis = -1, and dim = 3, this function will return 2.
 *
 * @param axis The axis index, may be a positive, zero or negative integer.
 * @param dim Total number of dimensions, a positive integer.
 * @returns A non-negative axis index equivalent to the input `axis`.
 */ function $33a688647ac37d4d$var$interpretAxis(axis, dim) {
    while(axis < 0)axis += dim;
    return axis;
}
function $33a688647ac37d4d$var$batchDot(x, y, axes) {
    if (x.shape.length > 3 || y.shape.length > 3) throw new (0, $jVuYK.NotImplementedError)('batchDot is not implemented for tensors of 4D or higher rank yet');
    $wx9lK.assert(x.shape.length >= 2, ()=>`batchDot requires the rank of x to be >= 2, ` + `but got ${x.shape.length}`);
    $wx9lK.assert(x.shape.length >= 2, ()=>`batchDot requires the rank of y to be >= 2, ` + `but got ${y.shape.length}`);
    if (typeof axes === 'number') axes = [
        axes,
        axes
    ];
    if (x.dtype === 'complex64' || y.dtype === 'complex64') throw new (0, $jVuYK.NotImplementedError)('batchDot is not implemented for complex64-type Tensors yet.');
    const xNDim = x.shape.length;
    const yNDim = y.shape.length;
    if (axes == null) // Behave like batchMatmul by default.
    axes = [
        xNDim - 1,
        yNDim - 2
    ];
    const axesArray = axes;
    return $9c0Qr.tidy(()=>{
        let diff;
        if (xNDim > yNDim) {
            diff = xNDim - yNDim;
            const diffShape = [];
            for(let i = 0; i < diff; ++i)diffShape.push(1);
            y = $eP0pM.reshape(y, y.shape.concat(diffShape));
        } else if (yNDim > xNDim) {
            diff = yNDim - xNDim;
            const diffShape = [];
            for(let i = 0; i < diff; ++i)diffShape.push(1);
            x = $eP0pM.reshape(x, x.shape.concat(diffShape));
        } else diff = 0;
        let out;
        if (x.shape.length === 2 && y.shape.length === 2) {
            if (axesArray[0] === axesArray[1]) out = $fVwnn.sum($r7fN6.mul(x, y), axesArray[0]);
            else out = $fVwnn.sum($r7fN6.mul($9PEYs.transpose(x, [
                1,
                0
            ]), y), axesArray[1]);
        } else {
            const adjX = axesArray[0] !== x.shape.length - 1;
            const adjY = axesArray[1] === y.shape.length - 1;
            out = $clO9Z.matMul(x, y, adjX, adjY);
        }
        if (diff > 0) {
            let idx;
            if (xNDim > yNDim) idx = xNDim + yNDim - 3;
            else idx = xNDim - 1;
            const squeezeAxes = [];
            for(let i = idx; i < idx + diff; ++i)squeezeAxes.push(i);
            out = $wniip.squeeze(out, squeezeAxes);
        }
        if (out.shape.length === 1) out = $6mzQK.expandDims(out, 1);
        return out;
    });
}
class $33a688647ac37d4d$export$d046b3c4a416f60d extends $33a688647ac37d4d$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
        this.axes = args.axes;
        this.normalize = args.normalize == null ? false : args.normalize;
        this.supportsMasking = true;
        this.reshapeRequired = false;
    }
    build(inputShape) {
        $wx9lK.assert(Array.isArray(inputShape) && inputShape.length === 2 && Array.isArray(inputShape[0]) && Array.isArray(inputShape[1]), ()=>'A `Dot` layer should be called on a list of exactly 2 inputs.');
        const shape1 = inputShape[0];
        const shape2 = inputShape[1];
        if (shape1.length > 3 || shape2.length > 3) throw new (0, $jVuYK.NotImplementedError)('Dot layer does not support tensors of 4D or higher rank yet.');
        const axes = this.interpretAxes(shape1, shape2);
        if (shape1[axes[0]] !== shape2[axes[1]]) throw new (0, $jVuYK.ValueError)(`Dimension incompatibility: ` + `${shape1[axes[0]]} !== ${shape2[axes[1]]}`);
    }
    mergeFunction(inputs) {
        if (inputs.length !== 2) throw new (0, $jVuYK.ValueError)('A `Dot` layer must be called on exactly 2 inputs, ' + `but received ${inputs.length} input(s).`);
        let x1 = inputs[0];
        let x2 = inputs[1];
        let axes;
        if (!Array.isArray(this.axes)) axes = [
            $33a688647ac37d4d$var$interpretAxis(this.axes, x1.shape.length),
            $33a688647ac37d4d$var$interpretAxis(this.axes, x2.shape.length)
        ];
        else axes = this.axes.map((axis, i)=>$33a688647ac37d4d$var$interpretAxis(axis, inputs[i].shape.length));
        if (this.normalize) {
            x1 = (0, $LJ7JU.l2Normalize)(x1, axes[0]);
            x2 = (0, $LJ7JU.l2Normalize)(x2, axes[1]);
        }
        return $33a688647ac37d4d$var$batchDot(x1, x2, axes);
    }
    interpretAxes(shape1, shape2) {
        let axes;
        if (!Array.isArray(this.axes)) // `this.axes` is a single integer.
        axes = [
            $33a688647ac37d4d$var$interpretAxis(this.axes, shape1.length),
            $33a688647ac37d4d$var$interpretAxis(this.axes, shape2.length)
        ];
        else // `this.axes` is an Array of integers.
        axes = this.axes;
        return axes;
    }
    computeOutputShape(inputShape) {
        $wx9lK.assert(Array.isArray(inputShape) && inputShape.length === 2 && Array.isArray(inputShape[0]) && Array.isArray(inputShape[1]), ()=>'A `Dot` layer should be called on a list of exactly 2 inputs.');
        const shape1 = inputShape[0].slice();
        const shape2 = inputShape[1].slice();
        if (shape1.length > 3 || shape2.length > 3) throw new (0, $jVuYK.NotImplementedError)('Dot layer does not support tensors of 4D or higher rank yet.');
        const axes = this.interpretAxes(shape1, shape2);
        shape1.splice(axes[0], 1);
        shape2.splice(axes[1], 1);
        shape2.splice(0, 1);
        const outputShape = shape1.concat(shape2);
        if (outputShape.length === 1) outputShape.push(1);
        return outputShape;
    }
    computeMask(inputs, mask) {
        return null;
    }
    getConfig() {
        const config = {
            'axes': this.axes,
            'normalize': this.normalize
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $33a688647ac37d4d$export$d046b3c4a416f60d.className = 'Dot';
(0, $8AyuI).registerClass($33a688647ac37d4d$export$d046b3c4a416f60d); // TODO(cais): Add functional interfaces for the merge layers.

});

parcelRegister("438W2", function(module, exports) {

$parcel$export(module.exports, "GaussianNoise", () => $2f2e5f9290384c5c$export$d18d3f770cea837e);
$parcel$export(module.exports, "GaussianDropout", () => $2f2e5f9290384c5c$export$c07c4bcc10d07979);
$parcel$export(module.exports, "AlphaDropout", () => $2f2e5f9290384c5c$export$8a44d71014be114);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Noise Layers.
 */ parcelRequire("5n9DG");
var $1ZrG5 = parcelRequire("1ZrG5");
var $cUuWi = parcelRequire("cUuWi");
var $r7fN6 = parcelRequire("r7fN6");
var $gOgMa = parcelRequire("gOgMa");
var $8AyuI = parcelRequire("8AyuI");
var $9c0Qr = parcelRequire("9c0Qr");

var $luRak = parcelRequire("luRak");

var $cm045 = parcelRequire("cm045");

var $5sw3q = parcelRequire("5sw3q");
class $2f2e5f9290384c5c$export$d18d3f770cea837e extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        this.supportsMasking = true;
        this.stddev = args.stddev;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            stddev: this.stddev
        };
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            const noised = ()=>(0, $1ZrG5.add)($luRak.randomNormal(input.shape, 0, this.stddev), input);
            const output = $luRak.inTrainPhase(noised, ()=>input, kwargs['training'] || false);
            return output;
        });
    }
}
/** @nocollapse */ $2f2e5f9290384c5c$export$d18d3f770cea837e.className = 'GaussianNoise';
(0, $8AyuI).registerClass($2f2e5f9290384c5c$export$d18d3f770cea837e);
class $2f2e5f9290384c5c$export$c07c4bcc10d07979 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        this.supportsMasking = true;
        this.rate = args.rate;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            rate: this.rate
        };
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            if (this.rate > 0 && this.rate < 1) {
                const noised = ()=>{
                    const stddev = Math.sqrt(this.rate / (1 - this.rate));
                    return (0, $r7fN6.mul)(input, $luRak.randomNormal(input.shape, 1, stddev));
                };
                return $luRak.inTrainPhase(noised, ()=>input, kwargs['training'] || false);
            }
            return input;
        });
    }
}
/** @nocollapse */ $2f2e5f9290384c5c$export$c07c4bcc10d07979.className = 'GaussianDropout';
(0, $8AyuI).registerClass($2f2e5f9290384c5c$export$c07c4bcc10d07979);
class $2f2e5f9290384c5c$export$8a44d71014be114 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        this.supportsMasking = true;
        this.rate = args.rate;
        this.noiseShape = args.noiseShape;
    }
    _getNoiseShape(inputs) {
        return this.noiseShape || (0, $5sw3q.getExactlyOneTensor)(inputs).shape;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            rate: this.rate
        };
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            if (this.rate < 1 && this.rate > 0) {
                const noiseShape = this._getNoiseShape(inputs);
                const droppedInputs = ()=>{
                    const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
                    const alpha = 1.6732632423543772848170429916717;
                    const scale = 1.0507009873554804934193349852946;
                    const alphaP = -alpha * scale;
                    let keptIdx = (0, $cUuWi.greaterEqual)((0, $gOgMa.randomUniform)(noiseShape), this.rate);
                    keptIdx = $luRak.cast(keptIdx, 'float32'); // get default dtype.
                    // Get affine transformation params.
                    const a = ((1 - this.rate) * (1 + this.rate * alphaP ** 2)) ** -0.5;
                    const b = -a * alphaP * this.rate;
                    // Apply mask.
                    const x = (0, $1ZrG5.add)((0, $r7fN6.mul)(input, keptIdx), (0, $r7fN6.mul)((0, $1ZrG5.add)(keptIdx, -1), alphaP));
                    return (0, $1ZrG5.add)((0, $r7fN6.mul)(x, a), b);
                };
                return $luRak.inTrainPhase(droppedInputs, ()=>(0, $5sw3q.getExactlyOneTensor)(inputs), kwargs['training'] || false);
            }
            return inputs;
        });
    }
}
/** @nocollapse */ $2f2e5f9290384c5c$export$8a44d71014be114.className = 'AlphaDropout';
(0, $8AyuI).registerClass($2f2e5f9290384c5c$export$8a44d71014be114);

});

parcelRegister("jbtPJ", function(module, exports) {

$parcel$export(module.exports, "BatchNormalization", () => $df762fb2e37a25ff$export$21e75adabb5b0994);
$parcel$export(module.exports, "LayerNormalization", () => $df762fb2e37a25ff$export$12bc76b160b1bdc);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Normalization layers.
 */ parcelRequire("5n9DG");
var $NUhQF = parcelRequire("NUhQF");
var $fACaf = parcelRequire("fACaf");
var $f6vw7 = parcelRequire("f6vw7");
var $9nuoC = parcelRequire("9nuoC");
var $r7fN6 = parcelRequire("r7fN6");
var $eP0pM = parcelRequire("eP0pM");
var $8AyuI = parcelRequire("8AyuI");
var $hkR0n = parcelRequire("hkR0n");
var $9c0Qr = parcelRequire("9c0Qr");
var $jIHaY = parcelRequire("jIHaY");
var $wx9lK = parcelRequire("wx9lK");

var $cn6Kc = parcelRequire("cn6Kc");

var $cm045 = parcelRequire("cm045");

var $jVuYK = parcelRequire("jVuYK");

var $fQ95p = parcelRequire("fQ95p");

var $4oHox = parcelRequire("4oHox");

var $khD6O = parcelRequire("khD6O");

var $jBJAM = parcelRequire("jBJAM");

var $5sw3q = parcelRequire("5sw3q");
function $df762fb2e37a25ff$export$598a795b5a50c0b5(x, mean, variance, beta, gamma, epsilon = 1e-3) {
    let out;
    if (x.rank === 2) out = $NUhQF.batchNorm2d(x, mean, variance, beta, gamma, epsilon);
    else if (x.rank === 3) // TODO(cais): Check rank; give proper error message.
    out = $fACaf.batchNorm3d(x, mean, variance, beta, gamma, epsilon);
    else if (x.rank === 4) out = $f6vw7.batchNorm4d(x, mean, variance, beta, gamma, epsilon);
    else throw new (0, $jVuYK.NotImplementedError)(`batchNormalization is not implemented for array of rank ${x.rank} ` + `yet`);
    return out;
}
/**
 * Non-broadcasting batch normalization for use in training (not inference).
 *
 * The input is normalized to zero mean and unit variance along the
 * `reductionAxes`, followed by scaling with `gamma` and shifted by `beta`.
 * The result of that is returned as the first element
 * of the returned `Array`. The other two elements are the mean and variance,
 * respectively.
 *
 * @param x Input tensor to be normalized.
 * @param gamma Tensor by which to scale the input.
 * @param beta Tensor by which to center the input.
 * @param reductionAxes Axes over which to normalize.
 * @param epsilon Fuzz factor.
 * @returns An `Array` of three `Tensors`:
 *   [normalized tensor, mean of input, variance of input].
 */ function $df762fb2e37a25ff$var$regularNormalizeBatchInTraining(x, gamma, beta, reductionAxes, epsilon = 1e-3) {
    return (0, $9c0Qr.tidy)(()=>{
        const meanAndVariance = $9nuoC.moments(x, reductionAxes);
        const mean = meanAndVariance.mean;
        const variance = meanAndVariance.variance;
        const normed = $df762fb2e37a25ff$export$598a795b5a50c0b5(x, mean, variance, beta, gamma, epsilon);
        return [
            normed,
            mean,
            variance
        ];
    });
}
/**
 * Broadcasting batch normalization for use in training (not inference).
 *
 * The input is normalized to zero mean and unit variance along the
 * `reductionAxes`, followed by scaling with `gamma` and shifted by `beta`.
 * The result of that is returned as the first element
 * of the returned `Array`. The other two elements are the mean and variance,
 * respectively.
 *
 * @param x Input tensor to be normalized.
 * @param gamma Tensor by which to scale the input.
 * @param beta Tensor by which to center the input.
 * @param reductionAxes Axes over which to normalize.
 * @param epsilon Fuzz factor.
 * @returns An `Array` of three `Tensors`:
 *   [normalized tensor, mean of input, variance of input].
 */ function $df762fb2e37a25ff$var$broadcastNormalizeBatchInTraining(x, gamma, beta, reductionAxes, epsilon = 1e-3) {
    return (0, $9c0Qr.tidy)(()=>{
        const meanAndVariance = $9nuoC.moments(x, reductionAxes);
        const mean = meanAndVariance.mean;
        const variance = meanAndVariance.variance;
        const targetShape = [];
        for (const axis of $jBJAM.range(0, x.rank))if (reductionAxes.indexOf(axis) !== -1) targetShape.push(1);
        else targetShape.push(x.shape[axis]);
        const broadcastMean = (0, $eP0pM.reshape)(mean, targetShape);
        const broadcastVariance = (0, $eP0pM.reshape)(variance, targetShape);
        const broadcastGamma = gamma == null ? null : (0, $eP0pM.reshape)(gamma, targetShape);
        const broadcastBeta = beta == null ? null : (0, $eP0pM.reshape)(beta, targetShape);
        const normed = $df762fb2e37a25ff$export$598a795b5a50c0b5(x, broadcastMean, broadcastVariance, broadcastBeta, broadcastGamma, epsilon);
        return [
            normed,
            mean,
            variance
        ];
    });
}
function $df762fb2e37a25ff$export$edbf80b9b58fbf69(x, gamma, beta, reductionAxes, epsilon = 1e-3) {
    if ((0, $wx9lK).arraysEqual(reductionAxes.slice().sort(), $jBJAM.range(0, x.rank - 1))) return $df762fb2e37a25ff$var$regularNormalizeBatchInTraining(x, gamma, beta, reductionAxes, epsilon);
    else return $df762fb2e37a25ff$var$broadcastNormalizeBatchInTraining(x, gamma, beta, reductionAxes, epsilon);
}
class $df762fb2e37a25ff$export$21e75adabb5b0994 extends (0, $cm045.Layer) {
    constructor(args){
        if (args == null) args = {};
        super(args);
        this.supportsMasking = true;
        this.axis = args.axis == null ? -1 : args.axis;
        this.momentum = args.momentum == null ? 0.99 : args.momentum;
        this.epsilon = args.epsilon == null ? 1e-3 : args.epsilon;
        this.center = args.center == null ? true : args.center;
        this.scale = args.scale == null ? true : args.scale;
        this.betaInitializer = (0, $fQ95p.getInitializer)(args.betaInitializer || 'zeros');
        this.gammaInitializer = (0, $fQ95p.getInitializer)(args.gammaInitializer || 'ones');
        this.movingMeanInitializer = (0, $fQ95p.getInitializer)(args.movingMeanInitializer || 'zeros');
        this.movingVarianceInitializer = (0, $fQ95p.getInitializer)(args.movingVarianceInitializer || 'ones');
        this.betaConstraint = (0, $cn6Kc.getConstraint)(args.betaConstraint);
        this.gammaConstraint = (0, $cn6Kc.getConstraint)(args.gammaConstraint);
        this.betaRegularizer = (0, $4oHox.getRegularizer)(args.betaRegularizer);
        this.gammaRegularizer = (0, $4oHox.getRegularizer)(args.gammaRegularizer);
    }
    build(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const axis = this.axis >= 0 ? this.axis : this.axis + inputShape.length;
        const dim = inputShape[axis];
        if (dim == null) throw new (0, $jVuYK.ValueError)(`Axis ${axis} of input tensor should have a defined dimension but ` + `the layer received an input with shape ` + `${JSON.stringify(inputShape)}.`);
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: inputShape.length,
                axes: {
                    [axis]: dim
                }
            })
        ];
        const shape = [
            dim
        ];
        if (this.scale) this.gamma = this.addWeight('gamma', shape, null, this.gammaInitializer, this.gammaRegularizer, true, this.gammaConstraint);
        if (this.center) this.beta = this.addWeight('beta', shape, null, this.betaInitializer, this.betaRegularizer, true, this.betaConstraint);
        this.movingMean = this.addWeight('moving_mean', shape, null, this.movingMeanInitializer, null, false);
        this.movingVariance = this.addWeight('moving_variance', shape, null, this.movingVarianceInitializer, null, false);
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            const training = kwargs['training'] == null ? false : kwargs['training'];
            const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            const inputShape = input.shape;
            const ndim = inputShape.length;
            const reductionAxes = $jBJAM.range(0, ndim);
            const axis = this.axis >= 0 ? this.axis : this.axis + ndim;
            reductionAxes.splice(axis, 1);
            const broadcastShape = $khD6O.pyListRepeat(1, ndim);
            broadcastShape[axis] = inputShape[axis];
            const sortedReductionAxes = reductionAxes.slice();
            sortedReductionAxes.sort();
            const needsBroadcasting = !(0, $wx9lK).arraysEqual(sortedReductionAxes, $jBJAM.range(0, ndim).slice(0, ndim - 1));
            const normalizeInference = ()=>{
                if (needsBroadcasting) {
                    const broadcastMovingMean = (0, $eP0pM.reshape)(this.movingMean.read(), broadcastShape);
                    const broadcastMovingVariance = (0, $eP0pM.reshape)(this.movingVariance.read(), broadcastShape);
                    const broadcastBeta = this.center ? (0, $eP0pM.reshape)(this.beta.read(), broadcastShape) : null;
                    const broadcastGamma = this.scale ? (0, $eP0pM.reshape)(this.gamma.read(), broadcastShape) : null;
                    return $df762fb2e37a25ff$export$598a795b5a50c0b5(input, broadcastMovingMean, broadcastMovingVariance, broadcastBeta, broadcastGamma, this.epsilon);
                } else return $df762fb2e37a25ff$export$598a795b5a50c0b5(input, this.movingMean.read(), this.movingVariance.read(), this.beta == null ? null : this.beta.read(), this.gamma == null ? null : this.gamma.read(), this.epsilon);
            };
            if (!training) return normalizeInference();
            const [normedTraining, mean, variance] = $df762fb2e37a25ff$export$edbf80b9b58fbf69(input, this.gamma.read(), this.beta.read(), reductionAxes, this.epsilon);
            const doMovingAverage = (variable, value, momentum)=>{
                $9c0Qr.tidy(()=>{
                    const decay = 1 - momentum;
                    const origValue = variable.read();
                    const updateDelta = $r7fN6.mul($hkR0n.sub(origValue, value), decay);
                    variable.write($hkR0n.sub(origValue, updateDelta));
                });
            };
            // Perform updates to moving mean and moving variance for training.
            // Porting Note: In PyKeras, these updates to `movingMean` and
            //   `movingAverage` are done as a deferred Graph, added to the `Layer`'s
            //   `update`s using the `add_update()` method. Here we do it imperatively
            //   and encapsulate the updates in a function that is invoked
            //   immediately.
            const updateMovingMeanAndVariance = ()=>{
                doMovingAverage(this.movingMean, mean, this.momentum);
                doMovingAverage(this.movingVariance, variance, this.momentum);
            };
            updateMovingMeanAndVariance();
            return normedTraining;
        });
    }
    getConfig() {
        const config = {
            axis: this.axis,
            momentum: this.momentum,
            epsilon: this.epsilon,
            center: this.center,
            scale: this.scale,
            betaInitializer: (0, $fQ95p.serializeInitializer)(this.betaInitializer),
            gammaInitializer: (0, $fQ95p.serializeInitializer)(this.gammaInitializer),
            movingMeanInitializer: (0, $fQ95p.serializeInitializer)(this.movingMeanInitializer),
            movingVarianceInitializer: (0, $fQ95p.serializeInitializer)(this.movingVarianceInitializer),
            betaRegularizer: (0, $4oHox.serializeRegularizer)(this.betaRegularizer),
            gammaRegularizer: (0, $4oHox.serializeRegularizer)(this.gammaRegularizer),
            betaConstraint: (0, $cn6Kc.serializeConstraint)(this.betaConstraint),
            gammaConstraint: (0, $cn6Kc.serializeConstraint)(this.gammaConstraint)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $df762fb2e37a25ff$export$21e75adabb5b0994.className = 'BatchNormalization';
(0, $8AyuI).registerClass($df762fb2e37a25ff$export$21e75adabb5b0994);
class $df762fb2e37a25ff$export$12bc76b160b1bdc extends (0, $cm045.Layer) {
    constructor(args){
        if (args == null) args = {};
        super(args);
        this.axis = args.axis == null ? -1 : args.axis;
        if (typeof this.axis === 'number') {
            if (!Number.isInteger(this.axis)) throw new Error(`Expected axis to be an integer, but received ${this.axis}`);
        } else if (Array.isArray(this.axis)) for (const axis of this.axis){
            if (!Number.isInteger(axis)) throw new Error(`Expected axis to be an array of integers, ` + `but received ${JSON.stringify(this.axis)}`);
        }
        else throw new Error(`Expected axis to be an integer or an array of integers, ` + `but received ${JSON.stringify(this.axis)}`);
        this.epsilon = args.epsilon == null ? 1e-3 : args.epsilon;
        this.center = args.center == null ? true : args.center;
        this.scale = args.scale == null ? true : args.scale;
        this.betaInitializer = (0, $fQ95p.getInitializer)(args.betaInitializer || 'zeros');
        this.gammaInitializer = (0, $fQ95p.getInitializer)(args.gammaInitializer || 'ones');
        this.betaRegularizer = (0, $4oHox.getRegularizer)(args.betaRegularizer);
        this.gammaRegularizer = (0, $4oHox.getRegularizer)(args.gammaRegularizer);
        this.supportsMasking = true;
    }
    build(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const nDims = inputShape.length;
        // Convert axis to array and resolve negatives.
        if (typeof this.axis === 'number') this.axis = [
            this.axis
        ];
        for(let i = 0; i < this.axis.length; ++i)if (this.axis[i] < 0) this.axis[i] += nDims;
        // Further validate axes.
        for (const axis of this.axis){
            if (axis < 0 || axis >= nDims) throw new Error(`Invalid axis: ${axis}`);
        }
        if (this.axis.length !== $khD6O.unique(this.axis).length) throw new Error(`Found duplicate axes in: ${this.axis}`);
        const paramShape = this.axis.map((axis)=>inputShape[axis]);
        const trainable = true;
        if (this.scale) this.gamma = this.addWeight('gamma', paramShape, 'float32', this.gammaInitializer, this.gammaRegularizer, trainable);
        else this.gamma = null;
        if (this.center) this.beta = this.addWeight('beta', paramShape, 'float32', this.betaInitializer, this.betaRegularizer, trainable);
        else this.beta = null;
        this.built = true;
    }
    call(inputs, kwargs) {
        const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
        const inputShape = input.shape;
        const nDims = inputShape.length;
        return (0, $9c0Qr.tidy)(()=>{
            const keepDims = true;
            let { mean: mean, variance: variance } = (0, $9nuoC.moments)(input, this.axis, keepDims);
            const broadcastShape = $khD6O.pyListRepeat(1, nDims);
            for (const dim of this.axis)broadcastShape[dim] = inputShape[dim];
            const broadcast = (v)=>{
                if (v != null && v.shape.length !== nDims) return $eP0pM.reshape(v, broadcastShape);
                else return v;
            };
            let scale = this.scale ? broadcast(this.gamma.read()) : null;
            let offset = this.center ? broadcast(this.beta.read()) : null;
            // TODO(https://github.com/tensorflow/tfjs/issues/2120): The tiling below
            // is a workaround for the limitation of core's batchNormalization?d don't
            // support broadcasting in their gradients. In addition, the tiling is
            // necessary to ensure correctness on the browser CPU backend regardless
            // of forward or backward computation. Remove this workaround once the
            // limitation is addressed. See .
            const momentsTiling = [];
            const scaleOffsetTiling = [];
            for(let i = 0; i < nDims; ++i)if (this.axis.indexOf(i) !== -1) {
                momentsTiling.push(inputShape[i]);
                scaleOffsetTiling.push(1);
            } else {
                momentsTiling.push(1);
                scaleOffsetTiling.push(inputShape[i]);
            }
            mean = $jIHaY.tile(mean, momentsTiling);
            variance = $jIHaY.tile(variance, momentsTiling);
            if (scale != null) scale = $jIHaY.tile(scale, scaleOffsetTiling);
            if (offset != null) offset = $jIHaY.tile(offset, scaleOffsetTiling);
            return $df762fb2e37a25ff$export$598a795b5a50c0b5(input, mean, variance, offset, scale, this.epsilon);
        });
    }
    getConfig() {
        const config = {
            axis: this.axis,
            epsilon: this.epsilon,
            center: this.center,
            scale: this.scale,
            betaInitializer: (0, $fQ95p.serializeInitializer)(this.betaInitializer),
            gammaInitializer: (0, $fQ95p.serializeInitializer)(this.gammaInitializer),
            betaRegularizer: (0, $4oHox.serializeRegularizer)(this.betaRegularizer),
            gammaRegularizer: (0, $4oHox.serializeRegularizer)(this.gammaRegularizer)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $df762fb2e37a25ff$export$12bc76b160b1bdc.className = 'LayerNormalization';
(0, $8AyuI).registerClass($df762fb2e37a25ff$export$12bc76b160b1bdc);

});

parcelRegister("qNHFJ", function(module, exports) {

$parcel$export(module.exports, "ZeroPadding2D", () => $0508fbe1428c0acc$export$3ae403604f7452b3);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Padding Layers.
 */ // Porting Note: In Python Keras, the padding layers are in convolutional.py,
//   but we decided to put them in a separate file (padding.ts) for clarity.
parcelRequire("5n9DG");
var $4xBxs = parcelRequire("4xBxs");
var $8AyuI = parcelRequire("8AyuI");
var $9c0Qr = parcelRequire("9c0Qr");

var $c51ox = parcelRequire("c51ox");

var $cm045 = parcelRequire("cm045");

var $jVuYK = parcelRequire("jVuYK");

var $5sw3q = parcelRequire("5sw3q");
function $0508fbe1428c0acc$export$cea7cd04e6f6329e(x, padding) {
    return (0, $9c0Qr.tidy)(()=>{
        if (x.rank !== 3) throw new (0, $jVuYK.ValueError)(`temporalPadding expects input tensor to be 3-D, but received a ` + `${x.rank}-D tensor.`);
        if (padding == null) padding = [
            1,
            1
        ];
        if (padding.length !== 2) throw new (0, $jVuYK.ValueError)(`temporalPadding expects input padding pattern to be a length-2 ` + `array, but received a length-${padding.length} array.`);
        const pattern = [
            [
                0,
                0
            ],
            padding,
            [
                0,
                0
            ]
        ];
        return $4xBxs.pad(x, pattern);
    });
}
function $0508fbe1428c0acc$export$c1e7b1f1a92c089a(x, padding, dataFormat) {
    return (0, $9c0Qr.tidy)(()=>{
        if (x.rank !== 4) throw new (0, $jVuYK.ValueError)(`temporalPadding expects input tensor to be 4-D, but received a ` + `${x.rank}-D tensor.`);
        if (padding == null) padding = [
            [
                1,
                1
            ],
            [
                1,
                1
            ]
        ];
        if (padding.length !== 2 || padding[0].length !== 2 || padding[1].length !== 2) throw new (0, $jVuYK.ValueError)("spatial2dPadding expects `padding` to be an Array of two Arrays, each of which is an Array of two integers.");
        if (dataFormat == null) dataFormat = (0, $c51ox.imageDataFormat)();
        if (dataFormat !== 'channelsLast' && dataFormat !== 'channelsFirst') throw new (0, $jVuYK.ValueError)(`Unknown data format: ${dataFormat}. ` + `Supported data formats are 'channelsLast' and 'channelsFirst.`);
        let pattern;
        if (dataFormat === 'channelsFirst') pattern = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            padding[0],
            padding[1]
        ];
        else pattern = [
            [
                0,
                0
            ],
            padding[0],
            padding[1],
            [
                0,
                0
            ]
        ];
        return $4xBxs.pad(x, pattern);
    });
}
class $0508fbe1428c0acc$export$3ae403604f7452b3 extends (0, $cm045.Layer) {
    constructor(args){
        if (args == null) args = {};
        super(args);
        this.dataFormat = args.dataFormat == null ? (0, $c51ox.imageDataFormat)() : args.dataFormat;
        // TODO(cais): Maybe refactor the following logic surrounding `padding`
        //   into a helper method.
        if (args.padding == null) this.padding = [
            [
                1,
                1
            ],
            [
                1,
                1
            ]
        ];
        else if (typeof args.padding === 'number') this.padding = [
            [
                args.padding,
                args.padding
            ],
            [
                args.padding,
                args.padding
            ]
        ];
        else {
            args.padding = args.padding;
            if (args.padding.length !== 2) throw new (0, $jVuYK.ValueError)(`ZeroPadding2D expects padding to be a length-2 array, but ` + `received a length-${args.padding.length} array.`);
            let heightPadding;
            let widthPadding;
            if (typeof args.padding[0] === 'number') {
                heightPadding = [
                    args.padding[0],
                    args.padding[0]
                ];
                widthPadding = [
                    args.padding[1],
                    args.padding[1]
                ];
            } else {
                args.padding = args.padding;
                if (args.padding[0].length !== 2) throw new (0, $jVuYK.ValueError)(`ZeroPadding2D expects height padding to be a length-2 array, ` + `but received a length-${args.padding[0].length} array.`);
                heightPadding = args.padding[0];
                if (args.padding[1].length !== 2) throw new (0, $jVuYK.ValueError)(`ZeroPadding2D expects width padding to be a length-2 array, ` + `but received a length-${args.padding[1].length} array.`);
                widthPadding = args.padding[1];
            }
            this.padding = [
                heightPadding,
                widthPadding
            ];
        }
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: 4
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        let rows;
        let cols;
        if (this.dataFormat === 'channelsFirst') {
            if (inputShape[2] != null && inputShape[2] >= 0) rows = inputShape[2] + this.padding[0][0] + this.padding[0][1];
            else rows = null;
            if (inputShape[3] != null && inputShape[3] >= 0) cols = inputShape[3] + this.padding[1][0] + this.padding[1][1];
            else cols = null;
            return [
                inputShape[0],
                inputShape[1],
                rows,
                cols
            ];
        } else {
            if (inputShape[1] != null && inputShape[1] >= 0) rows = inputShape[1] + this.padding[0][0] + this.padding[0][1];
            else rows = null;
            if (inputShape[2] != null && inputShape[2] >= 0) cols = inputShape[2] + this.padding[1][0] + this.padding[1][1];
            else cols = null;
            return [
                inputShape[0],
                rows,
                cols,
                inputShape[3]
            ];
        }
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>$0508fbe1428c0acc$export$c1e7b1f1a92c089a((0, $5sw3q.getExactlyOneTensor)(inputs), this.padding, this.dataFormat));
    }
    getConfig() {
        const config = {
            padding: this.padding,
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $0508fbe1428c0acc$export$3ae403604f7452b3.className = 'ZeroPadding2D';
(0, $8AyuI).registerClass($0508fbe1428c0acc$export$3ae403604f7452b3);

});

parcelRegister("cNtDv", function(module, exports) {

$parcel$export(module.exports, "MaxPooling1D", () => $95110cc5b6fe004b$export$ee33f1d34d09a0fd);
$parcel$export(module.exports, "AveragePooling1D", () => $95110cc5b6fe004b$export$abb9a5c13378a7fc);
$parcel$export(module.exports, "MaxPooling2D", () => $95110cc5b6fe004b$export$fae6981b13a5bc64);
$parcel$export(module.exports, "AveragePooling2D", () => $95110cc5b6fe004b$export$ba5e0a247bd733ca);
$parcel$export(module.exports, "MaxPooling3D", () => $95110cc5b6fe004b$export$5a12007b35aee0a);
$parcel$export(module.exports, "AveragePooling3D", () => $95110cc5b6fe004b$export$ee30b46b17aabb8f);
$parcel$export(module.exports, "GlobalAveragePooling1D", () => $95110cc5b6fe004b$export$2c6cc528d2786e91);
$parcel$export(module.exports, "GlobalMaxPooling1D", () => $95110cc5b6fe004b$export$ab40543f12b91a51);
$parcel$export(module.exports, "GlobalAveragePooling2D", () => $95110cc5b6fe004b$export$2bd55677c48d3dfa);
$parcel$export(module.exports, "GlobalMaxPooling2D", () => $95110cc5b6fe004b$export$46257bff79157c32);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Pooling Layers.
 */ parcelRequire("5n9DG");
var $jqmHD = parcelRequire("jqmHD");
var $iWtLR = parcelRequire("iWtLR");
var $Fvpms = parcelRequire("Fvpms");
var $jslkq = parcelRequire("jslkq");
var $1lAhs = parcelRequire("1lAhs");
var $gr40e = parcelRequire("gr40e");
var $8AyuI = parcelRequire("8AyuI");
var $wniip = parcelRequire("wniip");
var $9c0Qr = parcelRequire("9c0Qr");
var $9PEYs = parcelRequire("9PEYs");

var $c51ox = parcelRequire("c51ox");

var $luRak = parcelRequire("luRak");

var $hQ5cH = parcelRequire("hQ5cH");

var $cm045 = parcelRequire("cm045");

var $jVuYK = parcelRequire("jVuYK");

var $4N5wj = parcelRequire("4N5wj");

var $khD6O = parcelRequire("khD6O");

var $5sw3q = parcelRequire("5sw3q");

var $h6F8e = parcelRequire("h6F8e");
function $95110cc5b6fe004b$export$d27fa8d08ae02aab(x, poolSize, strides, padding, dataFormat, poolMode) {
    return (0, $9c0Qr.tidy)(()=>{
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        (0, $hQ5cH.checkPoolMode)(poolMode);
        (0, $hQ5cH.checkPaddingMode)(padding);
        if (strides == null) strides = [
            1,
            1
        ];
        if (padding == null) padding = 'valid';
        if (dataFormat == null) dataFormat = (0, $c51ox.imageDataFormat)();
        if (poolMode == null) poolMode = 'max';
        // TODO(cais): Remove the preprocessing step once deeplearn.js supports
        // dataFormat as an input argument.
        x = (0, $h6F8e.preprocessConv2DInput)(x, dataFormat); // x is NHWC after preprocessing.
        let y;
        const paddingString = padding === 'same' ? 'same' : 'valid';
        if (poolMode === 'max') // TODO(cais): Rank check?
        y = $jslkq.maxPool(x, poolSize, strides, paddingString);
        else // TODO(cais): Check the dtype and rank of x and give clear error message
        //   if those are incorrect.
        y = $jqmHD.avgPool(// TODO(cais): Rank check?
        x, poolSize, strides, paddingString);
        if (dataFormat === 'channelsFirst') y = $9PEYs.transpose(y, [
            0,
            3,
            1,
            2
        ]); // NHWC -> NCHW.
        return y;
    });
}
function $95110cc5b6fe004b$export$3712ebf21d29ff82(x, poolSize, strides, padding, dataFormat, poolMode) {
    return (0, $9c0Qr.tidy)(()=>{
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        (0, $hQ5cH.checkPoolMode)(poolMode);
        (0, $hQ5cH.checkPaddingMode)(padding);
        if (strides == null) strides = [
            1,
            1,
            1
        ];
        if (padding == null) padding = 'valid';
        if (dataFormat == null) dataFormat = (0, $c51ox.imageDataFormat)();
        if (poolMode == null) poolMode = 'max';
        // x is NDHWC after preprocessing.
        x = (0, $h6F8e.preprocessConv3DInput)(x, dataFormat);
        let y;
        const paddingString = padding === 'same' ? 'same' : 'valid';
        if (poolMode === 'max') y = $1lAhs.maxPool3d(x, poolSize, strides, paddingString);
        else y = $iWtLR.avgPool3d(x, poolSize, strides, paddingString);
        if (dataFormat === 'channelsFirst') y = $9PEYs.transpose(y, [
            0,
            4,
            1,
            2,
            3
        ]); // NDHWC -> NCDHW.
        return y;
    });
}
class $95110cc5b6fe004b$export$56e907da703e3750 extends (0, $cm045.Layer) {
    /**
     *
     * @param args Parameters for the Pooling layer.
     *
     * config.poolSize defaults to 2.
     */ constructor(args){
        if (args.poolSize == null) args.poolSize = 2;
        super(args);
        if (typeof args.poolSize === 'number') this.poolSize = [
            args.poolSize
        ];
        else if (Array.isArray(args.poolSize) && args.poolSize.length === 1 && typeof args.poolSize[0] === 'number') this.poolSize = args.poolSize;
        else throw new (0, $jVuYK.ValueError)(`poolSize for 1D convolutional layer must be a number or an ` + `Array of a single number, but received ` + `${JSON.stringify(args.poolSize)}`);
        (0, $khD6O.assertPositiveInteger)(this.poolSize, 'poolSize');
        if (args.strides == null) this.strides = this.poolSize;
        else {
            if (typeof args.strides === 'number') this.strides = [
                args.strides
            ];
            else if (Array.isArray(args.strides) && args.strides.length === 1 && typeof args.strides[0] === 'number') this.strides = args.strides;
            else throw new (0, $jVuYK.ValueError)(`strides for 1D convolutional layer must be a number or an ` + `Array of a single number, but received ` + `${JSON.stringify(args.strides)}`);
        }
        (0, $khD6O.assertPositiveInteger)(this.strides, 'strides');
        this.padding = args.padding == null ? 'valid' : args.padding;
        (0, $hQ5cH.checkPaddingMode)(this.padding);
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: 3
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const length = (0, $4N5wj.convOutputLength)(inputShape[1], this.poolSize[0], this.padding, this.strides[0]);
        return [
            inputShape[0],
            length,
            inputShape[2]
        ];
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            // Add dummy last dimension.
            inputs = $luRak.expandDims((0, $5sw3q.getExactlyOneTensor)(inputs), 2);
            const output = this.poolingFunction((0, $5sw3q.getExactlyOneTensor)(inputs), [
                this.poolSize[0],
                1
            ], [
                this.strides[0],
                1
            ], this.padding, 'channelsLast');
            // Remove dummy last dimension.
            return $wniip.squeeze(output, [
                2
            ]);
        });
    }
    getConfig() {
        const config = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $95110cc5b6fe004b$export$ee33f1d34d09a0fd extends $95110cc5b6fe004b$export$56e907da703e3750 {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        (0, $hQ5cH.checkPaddingMode)(padding);
        return $95110cc5b6fe004b$export$d27fa8d08ae02aab(inputs, poolSize, strides, padding, dataFormat, 'max');
    }
}
/** @nocollapse */ $95110cc5b6fe004b$export$ee33f1d34d09a0fd.className = 'MaxPooling1D';
(0, $8AyuI).registerClass($95110cc5b6fe004b$export$ee33f1d34d09a0fd);
class $95110cc5b6fe004b$export$abb9a5c13378a7fc extends $95110cc5b6fe004b$export$56e907da703e3750 {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        (0, $hQ5cH.checkPaddingMode)(padding);
        return $95110cc5b6fe004b$export$d27fa8d08ae02aab(inputs, poolSize, strides, padding, dataFormat, 'avg');
    }
}
/** @nocollapse */ $95110cc5b6fe004b$export$abb9a5c13378a7fc.className = 'AveragePooling1D';
(0, $8AyuI).registerClass($95110cc5b6fe004b$export$abb9a5c13378a7fc);
class $95110cc5b6fe004b$export$3f5b37e58ac9bb8f extends (0, $cm045.Layer) {
    constructor(args){
        if (args.poolSize == null) args.poolSize = [
            2,
            2
        ];
        super(args);
        this.poolSize = Array.isArray(args.poolSize) ? args.poolSize : [
            args.poolSize,
            args.poolSize
        ];
        if (args.strides == null) this.strides = this.poolSize;
        else if (Array.isArray(args.strides)) {
            if (args.strides.length !== 2) throw new (0, $jVuYK.ValueError)(`If the strides property of a 2D pooling layer is an Array, ` + `it is expected to have a length of 2, but received length ` + `${args.strides.length}.`);
            this.strides = args.strides;
        } else // `config.strides` is a number.
        this.strides = [
            args.strides,
            args.strides
        ];
        (0, $khD6O.assertPositiveInteger)(this.poolSize, 'poolSize');
        (0, $khD6O.assertPositiveInteger)(this.strides, 'strides');
        this.padding = args.padding == null ? 'valid' : args.padding;
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $hQ5cH.checkDataFormat)(this.dataFormat);
        (0, $hQ5cH.checkPaddingMode)(this.padding);
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: 4
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        let rows = this.dataFormat === 'channelsFirst' ? inputShape[2] : inputShape[1];
        let cols = this.dataFormat === 'channelsFirst' ? inputShape[3] : inputShape[2];
        rows = (0, $4N5wj.convOutputLength)(rows, this.poolSize[0], this.padding, this.strides[0]);
        cols = (0, $4N5wj.convOutputLength)(cols, this.poolSize[1], this.padding, this.strides[1]);
        if (this.dataFormat === 'channelsFirst') return [
            inputShape[0],
            inputShape[1],
            rows,
            cols
        ];
        else return [
            inputShape[0],
            rows,
            cols,
            inputShape[3]
        ];
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            return this.poolingFunction((0, $5sw3q.getExactlyOneTensor)(inputs), this.poolSize, this.strides, this.padding, this.dataFormat);
        });
    }
    getConfig() {
        const config = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides,
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $95110cc5b6fe004b$export$fae6981b13a5bc64 extends $95110cc5b6fe004b$export$3f5b37e58ac9bb8f {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        (0, $hQ5cH.checkPaddingMode)(padding);
        return $95110cc5b6fe004b$export$d27fa8d08ae02aab(inputs, poolSize, strides, padding, dataFormat, 'max');
    }
}
/** @nocollapse */ $95110cc5b6fe004b$export$fae6981b13a5bc64.className = 'MaxPooling2D';
(0, $8AyuI).registerClass($95110cc5b6fe004b$export$fae6981b13a5bc64);
class $95110cc5b6fe004b$export$ba5e0a247bd733ca extends $95110cc5b6fe004b$export$3f5b37e58ac9bb8f {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        (0, $hQ5cH.checkPaddingMode)(padding);
        return $95110cc5b6fe004b$export$d27fa8d08ae02aab(inputs, poolSize, strides, padding, dataFormat, 'avg');
    }
}
/** @nocollapse */ $95110cc5b6fe004b$export$ba5e0a247bd733ca.className = 'AveragePooling2D';
(0, $8AyuI).registerClass($95110cc5b6fe004b$export$ba5e0a247bd733ca);
class $95110cc5b6fe004b$export$d922ad75eee6c49f extends (0, $cm045.Layer) {
    constructor(args){
        if (args.poolSize == null) args.poolSize = [
            2,
            2,
            2
        ];
        super(args);
        this.poolSize = Array.isArray(args.poolSize) ? args.poolSize : [
            args.poolSize,
            args.poolSize,
            args.poolSize
        ];
        if (args.strides == null) this.strides = this.poolSize;
        else if (Array.isArray(args.strides)) {
            if (args.strides.length !== 3) throw new (0, $jVuYK.ValueError)(`If the strides property of a 3D pooling layer is an Array, ` + `it is expected to have a length of 3, but received length ` + `${args.strides.length}.`);
            this.strides = args.strides;
        } else // `config.strides` is a number.
        this.strides = [
            args.strides,
            args.strides,
            args.strides
        ];
        (0, $khD6O.assertPositiveInteger)(this.poolSize, 'poolSize');
        (0, $khD6O.assertPositiveInteger)(this.strides, 'strides');
        this.padding = args.padding == null ? 'valid' : args.padding;
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $hQ5cH.checkDataFormat)(this.dataFormat);
        (0, $hQ5cH.checkPaddingMode)(this.padding);
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: 5
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        let depths = this.dataFormat === 'channelsFirst' ? inputShape[2] : inputShape[1];
        let rows = this.dataFormat === 'channelsFirst' ? inputShape[3] : inputShape[2];
        let cols = this.dataFormat === 'channelsFirst' ? inputShape[4] : inputShape[3];
        depths = (0, $4N5wj.convOutputLength)(depths, this.poolSize[0], this.padding, this.strides[0]);
        rows = (0, $4N5wj.convOutputLength)(rows, this.poolSize[1], this.padding, this.strides[1]);
        cols = (0, $4N5wj.convOutputLength)(cols, this.poolSize[2], this.padding, this.strides[2]);
        if (this.dataFormat === 'channelsFirst') return [
            inputShape[0],
            inputShape[1],
            depths,
            rows,
            cols
        ];
        else return [
            inputShape[0],
            depths,
            rows,
            cols,
            inputShape[4]
        ];
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            return this.poolingFunction((0, $5sw3q.getExactlyOneTensor)(inputs), this.poolSize, this.strides, this.padding, this.dataFormat);
        });
    }
    getConfig() {
        const config = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides,
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $95110cc5b6fe004b$export$5a12007b35aee0a extends $95110cc5b6fe004b$export$d922ad75eee6c49f {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        (0, $hQ5cH.checkPaddingMode)(padding);
        return $95110cc5b6fe004b$export$3712ebf21d29ff82(inputs, poolSize, strides, padding, dataFormat, 'max');
    }
}
/** @nocollapse */ $95110cc5b6fe004b$export$5a12007b35aee0a.className = 'MaxPooling3D';
(0, $8AyuI).registerClass($95110cc5b6fe004b$export$5a12007b35aee0a);
class $95110cc5b6fe004b$export$ee30b46b17aabb8f extends $95110cc5b6fe004b$export$d922ad75eee6c49f {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $hQ5cH.checkDataFormat)(dataFormat);
        (0, $hQ5cH.checkPaddingMode)(padding);
        return $95110cc5b6fe004b$export$3712ebf21d29ff82(inputs, poolSize, strides, padding, dataFormat, 'avg');
    }
}
/** @nocollapse */ $95110cc5b6fe004b$export$ee30b46b17aabb8f.className = 'AveragePooling3D';
(0, $8AyuI).registerClass($95110cc5b6fe004b$export$ee30b46b17aabb8f);
class $95110cc5b6fe004b$export$ac2acb21ca818c40 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: 3
            })
        ];
    }
    computeOutputShape(inputShape) {
        return [
            inputShape[0],
            inputShape[2]
        ];
    }
    call(inputs, kwargs) {
        throw new (0, $jVuYK.NotImplementedError)();
    }
}
class $95110cc5b6fe004b$export$2c6cc528d2786e91 extends $95110cc5b6fe004b$export$ac2acb21ca818c40 {
    constructor(args){
        super(args || {});
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            return $gr40e.mean(input, 1);
        });
    }
}
/** @nocollapse */ $95110cc5b6fe004b$export$2c6cc528d2786e91.className = 'GlobalAveragePooling1D';
(0, $8AyuI).registerClass($95110cc5b6fe004b$export$2c6cc528d2786e91);
class $95110cc5b6fe004b$export$ab40543f12b91a51 extends $95110cc5b6fe004b$export$ac2acb21ca818c40 {
    constructor(args){
        super(args || {});
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            return $Fvpms.max(input, 1);
        });
    }
}
/** @nocollapse */ $95110cc5b6fe004b$export$ab40543f12b91a51.className = 'GlobalMaxPooling1D';
(0, $8AyuI).registerClass($95110cc5b6fe004b$export$ab40543f12b91a51);
class $95110cc5b6fe004b$export$5eafa45e8fcdd59f extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $hQ5cH.checkDataFormat)(this.dataFormat);
        this.inputSpec = [
            new (0, $cm045.InputSpec)({
                ndim: 4
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape;
        if (this.dataFormat === 'channelsLast') return [
            inputShape[0],
            inputShape[3]
        ];
        else return [
            inputShape[0],
            inputShape[1]
        ];
    }
    call(inputs, kwargs) {
        throw new (0, $jVuYK.NotImplementedError)();
    }
    getConfig() {
        const config = {
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $95110cc5b6fe004b$export$2bd55677c48d3dfa extends $95110cc5b6fe004b$export$5eafa45e8fcdd59f {
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            if (this.dataFormat === 'channelsLast') return $gr40e.mean(input, [
                1,
                2
            ]);
            else return $gr40e.mean(input, [
                2,
                3
            ]);
        });
    }
}
/** @nocollapse */ $95110cc5b6fe004b$export$2bd55677c48d3dfa.className = 'GlobalAveragePooling2D';
(0, $8AyuI).registerClass($95110cc5b6fe004b$export$2bd55677c48d3dfa);
class $95110cc5b6fe004b$export$46257bff79157c32 extends $95110cc5b6fe004b$export$5eafa45e8fcdd59f {
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            const input = (0, $5sw3q.getExactlyOneTensor)(inputs);
            if (this.dataFormat === 'channelsLast') return $Fvpms.max(input, [
                1,
                2
            ]);
            else return $Fvpms.max(input, [
                2,
                3
            ]);
        });
    }
}
/** @nocollapse */ $95110cc5b6fe004b$export$46257bff79157c32.className = 'GlobalMaxPooling2D';
(0, $8AyuI).registerClass($95110cc5b6fe004b$export$46257bff79157c32);

});

parcelRegister("1oDpc", function(module, exports) {

$parcel$export(module.exports, "TimeDistributed", () => $1046997150324d51$export$72d58104314bdbf3);
$parcel$export(module.exports, "Bidirectional", () => $1046997150324d51$export$edf712313f3d75dd);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Layers that augment the functionality of a base layer.
 */ parcelRequire("5n9DG");
var $1ZrG5 = parcelRequire("1ZrG5");
var $r7fN6 = parcelRequire("r7fN6");
var $do1MK = parcelRequire("do1MK");
var $8AyuI = parcelRequire("8AyuI");
var $9c0Qr = parcelRequire("9c0Qr");

var $luRak = parcelRequire("luRak");

var $hQ5cH = parcelRequire("hQ5cH");

var $cm045 = parcelRequire("cm045");

var $jVuYK = parcelRequire("jVuYK");

var $iC0mP = parcelRequire("iC0mP");

var $khD6O = parcelRequire("khD6O");

var $5sw3q = parcelRequire("5sw3q");

var $ejY9c = parcelRequire("ejY9c");

var $dttI1 = parcelRequire("dttI1");
class $1046997150324d51$export$e6dfd72ab29f8598 extends (0, $cm045.Layer) {
    constructor(args){
        // Porting Note: In PyKeras, `self.layer` is set prior to the calling
        //   `super()`. But we can't do that here due to TypeScript's restriction.
        //   See: https://github.com/Microsoft/TypeScript/issues/8277
        //   As a result, we have to add checks in `get trainable()` and
        //   `set trainable()` below in order to prevent using `this.layer` when
        //   its value is `undefined`. The super constructor does use the getter
        //   and the setter of `this.layer`.
        super(args);
        this.layer = args.layer;
    }
    build(inputShape) {
        this.built = true;
    }
    // TODO(cais): Implement activityRegularizer getter.
    get trainable() {
        // Porting Note: the check of `this.layer` here is necessary due to the
        //   way the `constructor` of this class is written (see Porting Note
        //   above).
        if (this.layer != null) return this.layer.trainable;
        else return false;
    }
    set trainable(value) {
        // Porting Note: the check of `this.layer` here is necessary due to the
        //   way the `constructor` of this class is written (see Porting Note
        //   above).
        if (this.layer != null) this.layer.trainable = value;
    }
    get trainableWeights() {
        return this.layer.trainableWeights;
    }
    // TODO(cais): Implement setter for trainableWeights.
    get nonTrainableWeights() {
        return this.layer.nonTrainableWeights;
    }
    // TODO(cais): Implement setter for nonTrainableWeights.
    get updates() {
        // tslint:disable-next-line:no-any
        return this.layer._updates;
    }
    // TODO(cais): Implement getUpdatesFor().
    get losses() {
        return this.layer.losses;
    }
    // TODO(cais): Implement getLossesFor().
    getWeights() {
        return this.layer.getWeights();
    }
    setWeights(weights) {
        this.layer.setWeights(weights);
    }
    getConfig() {
        const config = {
            'layer': {
                'className': this.layer.getClassName(),
                'config': this.layer.getConfig()
            }
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    setFastWeightInitDuringBuild(value) {
        super.setFastWeightInitDuringBuild(value);
        if (this.layer != null) this.layer.setFastWeightInitDuringBuild(value);
    }
    /** @nocollapse */ static fromConfig(cls, config, customObjects = {}) {
        const layerConfig = config['layer'];
        const layer = (0, $dttI1.deserialize)(layerConfig, customObjects);
        delete config['layer'];
        const newConfig = {
            layer: layer
        };
        Object.assign(newConfig, config);
        return new cls(newConfig);
    }
}
class $1046997150324d51$export$72d58104314bdbf3 extends $1046997150324d51$export$e6dfd72ab29f8598 {
    constructor(args){
        super(args);
        this.supportsMasking = true;
    }
    build(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        if (inputShape.length < 3) throw new (0, $jVuYK.ValueError)(`TimeDistributed layer expects an input shape >= 3D, but received ` + `input shape ${JSON.stringify(inputShape)}`);
        this.inputSpec = [
            {
                shape: inputShape
            }
        ];
        const childInputShape = [
            inputShape[0]
        ].concat(inputShape.slice(2));
        if (!this.layer.built) {
            this.layer.build(childInputShape);
            this.layer.built = true;
        }
        super.build(inputShape);
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $5sw3q.getExactlyOneShape)(inputShape);
        const childInputShape = [
            inputShape[0]
        ].concat(inputShape.slice(2));
        const childOutputShape = this.layer.computeOutputShape(childInputShape);
        const timesteps = inputShape[1];
        return [
            childOutputShape[0],
            timesteps
        ].concat(childOutputShape.slice(1));
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            // TODO(cais): Add 'training' and 'useLearningPhase' to kwargs.
            inputs = (0, $5sw3q.getExactlyOneTensor)(inputs);
            // Porting Note: In tfjs-layers, `inputs` are always concrete tensor
            // values. Hence the inputs can't have an undetermined first (batch)
            // dimension, which is why we always use the K.rnn approach here.
            const step = (inputs, states)=>{
                // TODO(cais): Add useLearningPhase.
                // NOTE(cais): `layer.call` may return a length-1 array of Tensor in
                //   some cases (e.g., `layer` is a `Sequential` instance), which is
                //   why `getExactlyOneTensor` is used below.
                const output = (0, $5sw3q.getExactlyOneTensor)(this.layer.call(inputs, kwargs));
                return [
                    output,
                    []
                ];
            };
            const rnnOutputs = (0, $ejY9c.rnn)(step, inputs, [], false, null, null, false, true);
            const y = rnnOutputs[1];
            // TODO(cais): Add activity regularization.
            // TODO(cais): Add useLearningPhase.
            return y;
        });
    }
}
/** @nocollapse */ $1046997150324d51$export$72d58104314bdbf3.className = 'TimeDistributed';
(0, $8AyuI).registerClass($1046997150324d51$export$72d58104314bdbf3);
function $1046997150324d51$export$8095babf98f3d922(value) {
    $khD6O.checkStringTypeUnionValue((0, $iC0mP.VALID_BIDIRECTIONAL_MERGE_MODES), 'BidirectionalMergeMode', value);
}
const $1046997150324d51$var$DEFAULT_BIDIRECTIONAL_MERGE_MODE = 'concat';
class $1046997150324d51$export$edf712313f3d75dd extends $1046997150324d51$export$e6dfd72ab29f8598 {
    constructor(args){
        super(args);
        // Note: When creating `this.forwardLayer`, the original Layer object
        //   (`config.layer`) ought to be cloned. This is why we call
        //   `getConfig()` followed by `deserialize()`. Without this cloning,
        //   the layer names saved during serialization will incorrectly contain
        //   the 'forward_' prefix. In Python Keras, this is done using
        //   `copy.copy` (shallow copy), which does not have a simple equivalent
        //   in JavaScript. JavaScript's `Object.assign()` does not copy
        //   methods.
        const layerConfig = args.layer.getConfig();
        const forwDict = {};
        forwDict['className'] = args.layer.getClassName();
        forwDict['config'] = layerConfig;
        this.forwardLayer = (0, $dttI1.deserialize)(forwDict);
        layerConfig['goBackwards'] = layerConfig['goBackwards'] === true ? false : true;
        const backDict = {};
        backDict['className'] = args.layer.getClassName();
        backDict['config'] = layerConfig;
        this.backwardLayer = (0, $dttI1.deserialize)(backDict);
        this.forwardLayer.name = 'forward_' + this.forwardLayer.name;
        this.backwardLayer.name = 'backward_' + this.backwardLayer.name;
        this.mergeMode = args.mergeMode === undefined ? $1046997150324d51$var$DEFAULT_BIDIRECTIONAL_MERGE_MODE : args.mergeMode;
        $1046997150324d51$export$8095babf98f3d922(this.mergeMode);
        if (args.weights) throw new (0, $jVuYK.NotImplementedError)('weights support is not implemented for Bidirectional layer yet.');
        this._stateful = args.layer.stateful;
        this.returnSequences = args.layer.returnSequences;
        this.returnState = args.layer.returnState;
        this.supportsMasking = true;
        this._trainable = true;
        this.inputSpec = args.layer.inputSpec;
        this.numConstants = null;
    }
    get trainable() {
        return this._trainable;
    }
    set trainable(value) {
        // Porting Note: the check of `this.layer` here is necessary due to the
        //   way the `constructor` of this class is written (see Porting Note
        //   above).
        this._trainable = value;
        if (this.forwardLayer != null) this.forwardLayer.trainable = value;
        if (this.backwardLayer != null) this.backwardLayer.trainable = value;
    }
    getWeights() {
        return this.forwardLayer.getWeights().concat(this.backwardLayer.getWeights());
    }
    setWeights(weights) {
        const numWeights = weights.length;
        const numeightsOver2 = Math.floor(numWeights / 2);
        this.forwardLayer.setWeights(weights.slice(0, numeightsOver2));
        this.backwardLayer.setWeights(weights.slice(numeightsOver2));
    }
    computeOutputShape(inputShape) {
        let layerShapes = this.forwardLayer.computeOutputShape(inputShape);
        if (!(Array.isArray(layerShapes) && Array.isArray(layerShapes[0]))) layerShapes = [
            layerShapes
        ];
        layerShapes;
        let outputShape;
        let outputShapes;
        let stateShape;
        if (this.returnState) {
            stateShape = layerShapes.slice(1);
            outputShape = layerShapes[0];
        } else outputShape = layerShapes[0];
        outputShape;
        if (this.mergeMode === 'concat') {
            outputShape[outputShape.length - 1] *= 2;
            outputShapes = [
                outputShape
            ];
        } else if (this.mergeMode == null) outputShapes = [
            outputShape,
            outputShape.slice()
        ];
        else outputShapes = [
            outputShape
        ];
        if (this.returnState) {
            if (this.mergeMode == null) return outputShapes.concat(stateShape).concat(stateShape.slice());
            return [
                outputShape
            ].concat(stateShape).concat(stateShape.slice());
        }
        return $khD6O.singletonOrArray(outputShapes);
    }
    apply(inputs, kwargs) {
        let initialState = kwargs == null ? null : kwargs['initialState'];
        let constants = kwargs == null ? null : kwargs['constants'];
        if (kwargs == null) kwargs = {};
        const standardized = (0, $ejY9c.standardizeArgs)(inputs, initialState, constants, this.numConstants);
        inputs = standardized.inputs;
        initialState = standardized.initialState;
        constants = standardized.constants;
        if (Array.isArray(inputs)) {
            initialState = inputs.slice(1);
            inputs = inputs[0];
        }
        if ((initialState == null || initialState.length === 0) && constants == null) return super.apply(inputs, kwargs);
        const additionalInputs = [];
        const additionalSpecs = [];
        if (initialState != null) {
            const numStates = initialState.length;
            if (numStates % 2 > 0) throw new (0, $jVuYK.ValueError)("When passing `initialState` to a Bidrectional RNN, the state should be an Array containing the states of the underlying RNNs.");
            kwargs['initialState'] = initialState;
            additionalInputs.push(...initialState);
            const stateSpecs = initialState.map((state)=>new (0, $cm045.InputSpec)({
                    shape: state.shape
                }));
            this.forwardLayer.stateSpec = stateSpecs.slice(0, numStates / 2);
            this.backwardLayer.stateSpec = stateSpecs.slice(numStates / 2);
            additionalSpecs.push(...stateSpecs);
        }
        if (constants != null) throw new (0, $jVuYK.NotImplementedError)("Support for constants in Bidirectional layers is not implemented yet.");
        const isSymbolicTensor = additionalInputs[0] instanceof (0, $cm045.SymbolicTensor);
        for (const tensor of additionalInputs){
            if (tensor instanceof (0, $cm045.SymbolicTensor) !== isSymbolicTensor) throw new (0, $jVuYK.ValueError)("The initial state of a Bidirectional layer cannot be specified as a mix of symbolic and non-symbolic tensors");
        }
        if (isSymbolicTensor) {
            // Compute the full input and specs, including the states.
            const fullInput = [
                inputs
            ].concat(additionalInputs);
            const fullInputSpec = this.inputSpec.concat(additionalSpecs);
            // Perform the call temporarily and replace inputSpec.
            // Note: with initial states symbolic calls and non-symbolic calls to
            // this method differ in how the initial states are passed. For
            // symbolic calls, the initial states are passed in the first arg, as
            // an Array of SymbolicTensors; for non-symbolic calls, they are
            // passed in the second arg as a part of the kwargs. Hence the need to
            // temporarily modify inputSpec here.
            // TODO(cais): Make refactoring so that this hacky code below is no
            // longer needed.
            const originalInputSpec = this.inputSpec;
            this.inputSpec = fullInputSpec;
            const output = super.apply(fullInput, kwargs);
            this.inputSpec = originalInputSpec;
            return output;
        } else return super.apply(inputs, kwargs);
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            const initialState = kwargs['initialState'];
            let y;
            let yRev;
            if (initialState == null) {
                y = this.forwardLayer.call(inputs, kwargs);
                yRev = this.backwardLayer.call(inputs, kwargs);
            } else {
                const forwardState = initialState.slice(0, initialState.length / 2);
                const backwardState = initialState.slice(initialState.length / 2);
                y = this.forwardLayer.call(inputs, Object.assign(kwargs, {
                    initialState: forwardState
                }));
                yRev = this.backwardLayer.call(inputs, Object.assign(kwargs, {
                    initialState: backwardState
                }));
            }
            let states;
            if (this.returnState) {
                if (Array.isArray(y)) states = y.slice(1).concat(yRev.slice(1));
                y = y[0];
                yRev = yRev[0];
            }
            if (this.returnSequences) yRev = $do1MK.reverse(yRev, 1);
            let output;
            if (this.mergeMode === 'concat') output = $luRak.concatenate([
                y,
                yRev
            ]);
            else if (this.mergeMode === 'sum') output = $1ZrG5.add(y, yRev);
            else if (this.mergeMode === 'ave') output = $r7fN6.mul(.5, $1ZrG5.add(y, yRev));
            else if (this.mergeMode === 'mul') output = $r7fN6.mul(y, yRev);
            else if (this.mergeMode == null) output = [
                y,
                yRev
            ];
            // TODO(cais): Properly set learning phase.
            if (this.returnState) {
                if (this.mergeMode == null) return output.concat(states);
                return [
                    output
                ].concat(states);
            }
            return output;
        });
    }
    resetStates(states) {
        this.forwardLayer.resetStates();
        this.backwardLayer.resetStates();
    }
    build(inputShape) {
        (0, $hQ5cH.nameScope)(this.forwardLayer.name, ()=>{
            this.forwardLayer.build(inputShape);
        });
        (0, $hQ5cH.nameScope)(this.backwardLayer.name, ()=>{
            this.backwardLayer.build(inputShape);
        });
        this.built = true;
    }
    computeMask(inputs, mask) {
        if (Array.isArray(mask)) mask = mask[0];
        let outputMask;
        if (this.returnSequences) {
            if (this.mergeMode == null) outputMask = [
                mask,
                mask
            ];
            else outputMask = mask;
        } else if (this.mergeMode == null) outputMask = [
            null,
            null
        ];
        else outputMask = null;
        if (this.returnState) {
            const states = this.forwardLayer.states;
            const stateMask = states.map((state)=>null);
            if (Array.isArray(outputMask)) return outputMask.concat(stateMask).concat(stateMask);
            else return [
                outputMask
            ].concat(stateMask).concat(stateMask);
        } else return outputMask;
    }
    get trainableWeights() {
        return this.forwardLayer.trainableWeights.concat(this.backwardLayer.trainableWeights);
    }
    get nonTrainableWeights() {
        return this.forwardLayer.nonTrainableWeights.concat(this.backwardLayer.nonTrainableWeights);
    }
    // TODO(cais): Implement constraints().
    setFastWeightInitDuringBuild(value) {
        super.setFastWeightInitDuringBuild(value);
        if (this.forwardLayer != null) this.forwardLayer.setFastWeightInitDuringBuild(value);
        if (this.backwardLayer != null) this.backwardLayer.setFastWeightInitDuringBuild(value);
    }
    getConfig() {
        const config = {
            'mergeMode': this.mergeMode
        };
        // TODO(cais): Add logic for `numConstants` once the property is added.
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        const rnnLayer = (0, $dttI1.deserialize)(config['layer']);
        delete config['layer'];
        // TODO(cais): Add logic for `numConstants` once the property is added.
        if (config['numConstants'] != null) throw new (0, $jVuYK.NotImplementedError)(`Deserialization of a Bidirectional layer with numConstants ` + `present is not supported yet.`);
        // tslint:disable-next-line:no-any
        const newConfig = config;
        newConfig['layer'] = rnnLayer;
        return new cls(newConfig);
    }
}
/** @nocollapse */ $1046997150324d51$export$edf712313f3d75dd.className = 'Bidirectional';
(0, $8AyuI).registerClass($1046997150324d51$export$edf712313f3d75dd);

});

parcelRegister("jjYrT", function(module, exports) {

$parcel$export(module.exports, "Rescaling", () => $e10eae8d39607b78$export$7dddadc545bab6c4);
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $cm045 = parcelRequire("cm045");
parcelRequire("5n9DG");
var $1ZrG5 = parcelRequire("1ZrG5");
var $r7fN6 = parcelRequire("r7fN6");
var $8AyuI = parcelRequire("8AyuI");
var $9c0Qr = parcelRequire("9c0Qr");

var $5sw3q = parcelRequire("5sw3q");

var $luRak = parcelRequire("luRak");
class $e10eae8d39607b78$export$7dddadc545bab6c4 extends (0, $cm045.Layer) {
    constructor(args){
        super(args);
        this.scale = args.scale;
        if (args.offset) this.offset = args.offset;
        else this.offset = 0;
    }
    getConfig() {
        const config = {
            'scale': this.scale,
            'offset': this.offset
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $9c0Qr.tidy)(()=>{
            inputs = (0, $5sw3q.getExactlyOneTensor)(inputs);
            if (inputs.dtype !== 'float32') inputs = $luRak.cast(inputs, 'float32');
            return (0, $1ZrG5.add)((0, $r7fN6.mul)(inputs, this.scale), this.offset);
        });
    }
}
/** @nocollapse */ $e10eae8d39607b78$export$7dddadc545bab6c4.className = 'Rescaling';
(0, $8AyuI).registerClass($e10eae8d39607b78$export$7dddadc545bab6c4);

});


parcelRegister("3E6g6", function(module, exports) {

$parcel$export(module.exports, "binaryAccuracy", () => $2a79f6609de1e9f5$export$7b3d02e9a01c1ca);
$parcel$export(module.exports, "binaryCrossentropy", () => $2a79f6609de1e9f5$export$f9fa66c6bf49fbe1);
$parcel$export(module.exports, "sparseCategoricalAccuracy", () => $2a79f6609de1e9f5$export$b35c43b77daa3523);
$parcel$export(module.exports, "categoricalAccuracy", () => $2a79f6609de1e9f5$export$1365401eb6b7aeeb);
$parcel$export(module.exports, "categoricalCrossentropy", () => $2a79f6609de1e9f5$export$3d5544849562b631);
$parcel$export(module.exports, "precision", () => $2a79f6609de1e9f5$export$b70eeb0e623ceb0d);
$parcel$export(module.exports, "recall", () => $2a79f6609de1e9f5$export$479490328e25f530);
$parcel$export(module.exports, "cosineProximity", () => $2a79f6609de1e9f5$export$a39f0fc1fa1caacd);
$parcel$export(module.exports, "meanAbsoluteError", () => $2a79f6609de1e9f5$export$607988531ba584e6);
$parcel$export(module.exports, "meanAbsolutePercentageError", () => $2a79f6609de1e9f5$export$29f745e8786a84d);
$parcel$export(module.exports, "MAPE", () => $2a79f6609de1e9f5$export$520a6d354b1a7026);
$parcel$export(module.exports, "mape", () => $2a79f6609de1e9f5$export$1d9e5626781fbee);
$parcel$export(module.exports, "meanSquaredError", () => $2a79f6609de1e9f5$export$33de16355e97f7fb);
$parcel$export(module.exports, "MSE", () => $2a79f6609de1e9f5$export$19fa95397f41c30f);
$parcel$export(module.exports, "mse", () => $2a79f6609de1e9f5$export$5af2a467647891e2);

var $LJ7JU = parcelRequire("LJ7JU");

var $3ETNO = parcelRequire("3ETNO");
function $2a79f6609de1e9f5$export$7b3d02e9a01c1ca(yTrue, yPred) {
    return $3ETNO.binaryAccuracy(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$f9fa66c6bf49fbe1(yTrue, yPred) {
    return $3ETNO.binaryCrossentropy(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$b35c43b77daa3523(yTrue, yPred) {
    return $3ETNO.sparseCategoricalAccuracy(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$1365401eb6b7aeeb(yTrue, yPred) {
    return $3ETNO.categoricalAccuracy(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$3d5544849562b631(yTrue, yPred) {
    return $3ETNO.categoricalCrossentropy(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$b70eeb0e623ceb0d(yTrue, yPred) {
    return $3ETNO.precision(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$479490328e25f530(yTrue, yPred) {
    return $3ETNO.recall(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$a39f0fc1fa1caacd(yTrue, yPred) {
    return $LJ7JU.cosineProximity(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$607988531ba584e6(yTrue, yPred) {
    return $LJ7JU.meanAbsoluteError(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$29f745e8786a84d(yTrue, yPred) {
    return $LJ7JU.meanAbsolutePercentageError(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$520a6d354b1a7026(yTrue, yPred) {
    return $LJ7JU.meanAbsolutePercentageError(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$1d9e5626781fbee(yTrue, yPred) {
    return $LJ7JU.meanAbsolutePercentageError(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$33de16355e97f7fb(yTrue, yPred) {
    return $LJ7JU.meanSquaredError(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$19fa95397f41c30f(yTrue, yPred) {
    return $LJ7JU.meanSquaredError(yTrue, yPred);
}
function $2a79f6609de1e9f5$export$5af2a467647891e2(yTrue, yPred) {
    return $LJ7JU.meanSquaredError(yTrue, yPred);
}

});

parcelRegister("fn2RY", function(module, exports) {

$parcel$export(module.exports, "modelFromJSON", () => (parcelRequire("31SiL")).modelFromJSON);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $31SiL = parcelRequire("31SiL");

});

parcelRegister("1pDta", function(module, exports) {

$parcel$export(module.exports, "l1l2", () => $1076be0a20b03bc3$export$19d549ef0ddd23b0);
$parcel$export(module.exports, "l1", () => $1076be0a20b03bc3$export$b35c4719d0ff29eb);
$parcel$export(module.exports, "l2", () => $1076be0a20b03bc3$export$683828dad49492ec);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $4oHox = parcelRequire("4oHox");
function $1076be0a20b03bc3$export$19d549ef0ddd23b0(config) {
    return new (0, $4oHox.L1L2)(config);
}
function $1076be0a20b03bc3$export$b35c4719d0ff29eb(config) {
    return $4oHox.l1(config);
}
function $1076be0a20b03bc3$export$683828dad49492ec(config) {
    return $4oHox.l2(config);
}

});

parcelRegister("9wnMD", function(module, exports) {

$parcel$export(module.exports, "Callback", () => $6ee98d1a22536e9d$export$78f58e2a70333412);
$parcel$export(module.exports, "EarlyStopping", () => $6ee98d1a22536e9d$export$be8b2554758a52cc);
$parcel$export(module.exports, "callbacks", () => $6ee98d1a22536e9d$export$b89c5c1b934d8237);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/callbacks.py */ 
var $9fe8M = parcelRequire("9fe8M");

var $8foXR = parcelRequire("8foXR");

var $jVuYK = parcelRequire("jVuYK");

var $7EFWn = parcelRequire("7EFWn");
class $6ee98d1a22536e9d$export$78f58e2a70333412 extends (0, $9fe8M.BaseCallback) {
    constructor(){
        super(...arguments);
        /** Instance of `keras.models.Model`. Reference of the model being trained. */ this.model = null;
    }
    setModel(model) {
        if (!(model instanceof (0, $8foXR.LayersModel))) throw new Error('model must be a LayersModel, not some other Container');
        this.model = model;
    }
}
function $6ee98d1a22536e9d$var$less(currVal, prevVal) {
    return currVal < prevVal;
}
function $6ee98d1a22536e9d$var$greater(currVal, prevVal) {
    return currVal > prevVal;
}
class $6ee98d1a22536e9d$export$be8b2554758a52cc extends $6ee98d1a22536e9d$export$78f58e2a70333412 {
    constructor(args){
        super();
        if (args == null) args = {};
        if (args.restoreBestWeights) throw new (0, $jVuYK.NotImplementedError)('restoreBestWeights = True is not implemented in EarlyStopping yet.');
        this.monitor = args.monitor || 'val_loss';
        this.minDelta = Math.abs(args.minDelta || 0);
        this.patience = args.patience || 0;
        this.verbose = args.verbose || 0;
        this.mode = args.mode || 'auto';
        this.baseline = args.baseline;
        if ([
            'auto',
            'min',
            'max'
        ].indexOf(this.mode) === -1) {
            console.warn(`EarlyStopping mode '${this.mode}' is invalid. ` + `Falling back to mode 'auto'.`);
            this.mode = 'auto';
        }
        if (this.mode === 'min') this.monitorFunc = $6ee98d1a22536e9d$var$less;
        else if (this.mode === 'max') this.monitorFunc = $6ee98d1a22536e9d$var$greater;
        else // For mode === 'auto'.
        if (this.monitor.indexOf('acc') !== -1) this.monitorFunc = $6ee98d1a22536e9d$var$greater;
        else this.monitorFunc = $6ee98d1a22536e9d$var$less;
        if (this.monitorFunc === $6ee98d1a22536e9d$var$less) this.minDelta *= -1;
    }
    async onTrainBegin(logs) {
        this.wait = 0;
        this.stoppedEpoch = 0;
        if (this.baseline != null) this.best = this.baseline;
        else this.best = this.monitorFunc === $6ee98d1a22536e9d$var$less ? Infinity : -Infinity;
    }
    async onEpochEnd(epoch, logs) {
        await (0, $7EFWn.resolveScalarsInLogs)(logs);
        const current = this.getMonitorValue(logs);
        if (current == null) return;
        if (this.monitorFunc(current - this.minDelta, this.best)) {
            this.best = current;
            this.wait = 0;
        // TODO(cais): Logic for restoreBestWeights.
        } else {
            this.wait++;
            if (this.wait >= this.patience) {
                this.stoppedEpoch = epoch;
                this.model.stopTraining = true;
            }
        // TODO(cais): Logic for restoreBestWeights.
        }
    }
    async onTrainEnd(logs) {
        if (this.stoppedEpoch > 0 && this.verbose) console.log(`Epoch ${this.stoppedEpoch}: early stopping.`);
    }
    getMonitorValue(logs) {
        if (logs == null) logs = {};
        const monitorValue = logs[this.monitor];
        if (monitorValue == null) console.warn(`Metric for EarlyStopping ${this.monitor} is not available. ` + `Available metrics are: ${Object.keys(logs)}`);
        return monitorValue;
    }
}
function $6ee98d1a22536e9d$export$f951bfa445288ab1(args) {
    return new $6ee98d1a22536e9d$export$be8b2554758a52cc(args);
}
const $6ee98d1a22536e9d$export$b89c5c1b934d8237 = {
    earlyStopping: $6ee98d1a22536e9d$export$f951bfa445288ab1
};

});


parcelRegister("dC75r", function(module, exports) {

$parcel$export(module.exports, "GraphModel", () => (parcelRequire("b7UvU")).GraphModel);
$parcel$export(module.exports, "loadGraphModel", () => (parcelRequire("b7UvU")).loadGraphModel);
$parcel$export(module.exports, "loadGraphModelSync", () => (parcelRequire("b7UvU")).loadGraphModelSync);
$parcel$export(module.exports, "deregisterOp", () => (parcelRequire("6XVuT")).deregisterOp);
$parcel$export(module.exports, "registerOp", () => (parcelRequire("6XVuT")).registerOp);
$parcel$export(module.exports, "version_converter", () => (parcelRequire("fdizF")).version);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("br7rM");

var $b7UvU = parcelRequire("b7UvU");

var $6XVuT = parcelRequire("6XVuT");

var $fdizF = parcelRequire("fdizF");

});
parcelRegister("br7rM", function(module, exports) {
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
const $8537fe2d4bc20d38$var$ENV = (0, $aymVi.env)();
/** Whether to keep intermediate tensors. */ $8537fe2d4bc20d38$var$ENV.registerFlag('KEEP_INTERMEDIATE_TENSORS', ()=>false, (debugValue)=>{
    if (debugValue) console.warn("Keep intermediate tensors is ON. This will print the values of all intermediate tensors during model inference. Not all models support this mode. For details, check e2e/benchmarks/ model_config.js. This significantly impacts performance.");
});

});

parcelRegister("b7UvU", function(module, exports) {

$parcel$export(module.exports, "GraphModel", () => $819c2f9c18b64d1a$export$357a78c279dfa8cf);
$parcel$export(module.exports, "loadGraphModel", () => $819c2f9c18b64d1a$export$f077572b5d896ffd);
$parcel$export(module.exports, "loadGraphModelSync", () => $819c2f9c18b64d1a$export$64fa41ef6cfbfdd7);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $1RJvL = parcelRequire("1RJvL");
var $bVnU9 = parcelRequire("bVnU9");
var $wx9lK = parcelRequire("wx9lK");

var $e8sDp = parcelRequire("e8sDp");

var $7zKYo = parcelRequire("7zKYo");

var $1OJox = parcelRequire("1OJox");
const $819c2f9c18b64d1a$export$a9bc79b23e178599 = '?tfjs-format=file';
const $819c2f9c18b64d1a$export$9ffb2eac80132860 = 'model.json';
class $819c2f9c18b64d1a$export$357a78c279dfa8cf {
    /**
     * @param modelUrl url for the model, or an `io.IOHandler`.
     * @param weightManifestUrl url for the weight file generated by
     * scripts/convert.py script.
     * @param requestOption options for Request, which allows to send credentials
     * and custom headers.
     * @param onProgress Optional, progress callback function, fired periodically
     * before the load is completed.
     */ constructor(modelUrl, loadOptions = {}, tfio = (0, $1RJvL)){
        this.modelUrl = modelUrl;
        this.loadOptions = loadOptions;
        this.version = 'n/a';
        this.io = tfio;
        if (loadOptions == null) this.loadOptions = {};
        this.resourceManager = new (0, $1OJox.ResourceManager)();
    }
    // Returns the version information for the tensorflow model GraphDef.
    get modelVersion() {
        return this.version;
    }
    get inputNodes() {
        return this.executor.inputNodes;
    }
    get outputNodes() {
        return this.executor.outputNodes;
    }
    get inputs() {
        return this.executor.inputs;
    }
    get outputs() {
        return this.executor.outputs;
    }
    get weights() {
        return this.executor.weightMap;
    }
    get metadata() {
        return this.artifacts.userDefinedMetadata;
    }
    get modelSignature() {
        return this.signature;
    }
    get modelStructuredOutputKeys() {
        return this.structuredOutputKeys;
    }
    findIOHandler() {
        const path = this.modelUrl;
        if (path.load != null) // Path is an IO Handler.
        this.handler = path;
        else if (this.loadOptions.requestInit != null) this.handler = this.io.browserHTTPRequest(path, this.loadOptions);
        else {
            const handlers = this.io.getLoadHandlers(path, this.loadOptions);
            if (handlers.length === 0) // For backward compatibility: if no load handler can be found,
            // assume it is a relative http path.
            handlers.push(this.io.browserHTTPRequest(path, this.loadOptions));
            else if (handlers.length > 1) throw new Error(`Found more than one (${handlers.length}) load handlers for ` + `URL '${[
                path
            ]}'`);
            this.handler = handlers[0];
        }
    }
    /**
     * Loads the model and weight files, construct the in memory weight map and
     * compile the inference graph.
     */ load() {
        this.findIOHandler();
        if (this.handler.load == null) throw new Error("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");
        const loadResult = this.handler.load();
        if ((0, $wx9lK).isPromise(loadResult)) return loadResult.then((artifacts)=>this.loadSync(artifacts));
        return this.loadSync(loadResult);
    }
    /**
     * Synchronously construct the in memory weight map and
     * compile the inference graph. Also initialize hashtable if any.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ loadSync(artifacts) {
        this.artifacts = artifacts;
        const graph = this.artifacts.modelTopology;
        let signature = this.artifacts.signature;
        if (this.artifacts.userDefinedMetadata != null) {
            const metadata = this.artifacts.userDefinedMetadata;
            if (metadata.signature != null) signature = metadata.signature;
            if (metadata.structuredOutputKeys != null) this.structuredOutputKeys = metadata.structuredOutputKeys;
        }
        this.signature = signature;
        this.version = `${graph.versions.producer}.${graph.versions.minConsumer}`;
        const weightMap = this.io.decodeWeights(this.artifacts.weightData, this.artifacts.weightSpecs);
        this.executor = new (0, $7zKYo.GraphExecutor)((0, $e8sDp.OperationMapper).Instance.transformGraph(graph, this.signature));
        this.executor.weightMap = this.convertTensorMapToTensorsMap(weightMap);
        // Attach a model-level resourceManager to each executor to share resources,
        // such as `HashTable`.
        this.executor.resourceManager = this.resourceManager;
        if (artifacts.modelInitializer != null && artifacts.modelInitializer.node != null) {
            const initializer = (0, $e8sDp.OperationMapper).Instance.transformGraph(artifacts.modelInitializer);
            this.initializer = new (0, $7zKYo.GraphExecutor)(initializer);
            this.initializer.weightMap = this.executor.weightMap;
            // Attach a model-level resourceManager to the initializer, the
            // hashTables created from when executing the initializer will be stored
            // in the resourceManager.
            this.initializer.resourceManager = this.resourceManager;
            this.initializer.executeAsync({}, []);
        }
        return true;
    }
    /**
     * Save the configuration and/or weights of the GraphModel.
     *
     * An `IOHandler` is an object that has a `save` method of the proper
     * signature defined. The `save` method manages the storing or
     * transmission of serialized data ("artifacts") that represent the
     * model's topology and weights onto or via a specific medium, such as
     * file downloads, local storage, IndexedDB in the web browser and HTTP
     * requests to a server. TensorFlow.js provides `IOHandler`
     * implementations for a number of frequently used saving mediums, such as
     * `tf.io.browserDownloads` and `tf.io.browserLocalStorage`. See `tf.io`
     * for more details.
     *
     * This method also allows you to refer to certain types of `IOHandler`s
     * as URL-like string shortcuts, such as 'localstorage://' and
     * 'indexeddb://'.
     *
     * Example 1: Save `model`'s topology and weights to browser [local
     * storage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage);
     * then load it back.
     *
     * ```js
     * const modelUrl =
     *    'https://storage.googleapis.com/tfjs-models/savedmodel/mobilenet_v2_1.0_224/model.json';
     * const model = await tf.loadGraphModel(modelUrl);
     * const zeros = tf.zeros([1, 224, 224, 3]);
     * model.predict(zeros).print();
     *
     * const saveResults = await model.save('localstorage://my-model-1');
     *
     * const loadedModel = await tf.loadGraphModel('localstorage://my-model-1');
     * console.log('Prediction from loaded model:');
     * model.predict(zeros).print();
     * ```
     *
     * @param handlerOrURL An instance of `IOHandler` or a URL-like,
     * scheme-based string shortcut for `IOHandler`.
     * @param config Options for saving the model.
     * @returns A `Promise` of `SaveResult`, which summarizes the result of
     * the saving, such as byte sizes of the saved artifacts for the model's
     *   topology and weight values.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ async save(handlerOrURL, config) {
        if (typeof handlerOrURL === 'string') {
            const handlers = this.io.getSaveHandlers(handlerOrURL);
            if (handlers.length === 0) throw new Error(`Cannot find any save handlers for URL '${handlerOrURL}'`);
            else if (handlers.length > 1) throw new Error(`Found more than one (${handlers.length}) save handlers for ` + `URL '${handlerOrURL}'`);
            handlerOrURL = handlers[0];
        }
        if (handlerOrURL.save == null) throw new Error("GraphModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
        return handlerOrURL.save(this.artifacts);
    }
    /**
     * Execute the inference for the input tensors.
     *
     * @param input The input tensors, when there is single input for the model,
     * inputs param should be a `tf.Tensor`. For models with mutliple inputs,
     * inputs params should be in either `tf.Tensor`[] if the input order is
     * fixed, or otherwise NamedTensorMap format.
     *
     * For model with multiple inputs, we recommend you use NamedTensorMap as the
     * input type, if you use `tf.Tensor`[], the order of the array needs to
     * follow the
     * order of inputNodes array. @see {@link GraphModel.inputNodes}
     *
     * You can also feed any intermediate nodes using the NamedTensorMap as the
     * input type. For example, given the graph
     *    InputNode => Intermediate => OutputNode,
     * you can execute the subgraph Intermediate => OutputNode by calling
     *    model.execute('IntermediateNode' : tf.tensor(...));
     *
     * This is useful for models that uses tf.dynamic_rnn, where the intermediate
     * state needs to be fed manually.
     *
     * For batch inference execution, the tensors for each input need to be
     * concatenated together. For example with mobilenet, the required input shape
     * is [1, 244, 244, 3], which represents the [batch, height, width, channel].
     * If we are provide a batched data of 100 images, the input tensor should be
     * in the shape of [100, 244, 244, 3].
     *
     * @param config Prediction configuration for specifying the batch size.
     * Currently the batch size option is ignored for graph model.
     *
     * @returns Inference result tensors. If the model is converted and it
     * originally had structured_outputs in tensorflow, then a NamedTensorMap
     * will be returned matching the structured_outputs. If no structured_outputs
     * are present, the output will be single `tf.Tensor` if the model has single
     * output node, otherwise Tensor[].
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predict(inputs, config) {
        const outputTensors = this.execute(inputs, this.outputNodes);
        if (this.structuredOutputKeys) {
            const outputTensorsArray = outputTensors instanceof (0, $bVnU9.Tensor) ? [
                outputTensors
            ] : outputTensors;
            const outputTensorMap = {};
            outputTensorsArray.forEach((outputTensor, i)=>outputTensorMap[this.structuredOutputKeys[i]] = outputTensor);
            return outputTensorMap;
        }
        return outputTensors;
    }
    normalizeInputs(inputs) {
        if (!(inputs instanceof (0, $bVnU9.Tensor)) && !Array.isArray(inputs)) // The input is already a NamedTensorMap.
        return inputs;
        inputs = Array.isArray(inputs) ? inputs : [
            inputs
        ];
        if (inputs.length !== this.inputNodes.length) throw new Error('Input tensor count mismatch,' + `the graph model has ${this.inputNodes.length} placeholders, ` + `while there are ${inputs.length} input tensors.`);
        return this.inputNodes.reduce((map, inputName, i)=>{
            map[inputName] = inputs[i];
            return map;
        }, {});
    }
    normalizeOutputs(outputs) {
        outputs = outputs || this.outputNodes;
        return !Array.isArray(outputs) ? [
            outputs
        ] : outputs;
    }
    /**
     * Executes inference for the model for given input tensors.
     * @param inputs tensor, tensor array or tensor map of the inputs for the
     * model, keyed by the input node names.
     * @param outputs output node name from the TensorFlow model, if no
     * outputs are specified, the default outputs of the model would be used.
     * You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     *
     * @returns A single tensor if provided with a single output or no outputs
     * are provided and there is only one default output, otherwise return a
     * tensor array. The order of the tensor array is the same as the outputs
     * if provided, otherwise the order of outputNodes attribute of the model.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ execute(inputs, outputs) {
        inputs = this.normalizeInputs(inputs);
        outputs = this.normalizeOutputs(outputs);
        const result = this.executor.execute(inputs, outputs);
        return result.length > 1 ? result : result[0];
    }
    /**
     * Executes inference for the model for given input tensors in async
     * fashion, use this method when your model contains control flow ops.
     * @param inputs tensor, tensor array or tensor map of the inputs for the
     * model, keyed by the input node names.
     * @param outputs output node name from the TensorFlow model, if no outputs
     * are specified, the default outputs of the model would be used. You can
     * inspect intermediate nodes of the model by adding them to the outputs
     * array.
     *
     * @returns A Promise of single tensor if provided with a single output or
     * no outputs are provided and there is only one default output, otherwise
     * return a tensor map.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async executeAsync(inputs, outputs) {
        inputs = this.normalizeInputs(inputs);
        outputs = this.normalizeOutputs(outputs);
        const result = await this.executor.executeAsync(inputs, outputs);
        return result.length > 1 ? result : result[0];
    }
    /**
     * Get intermediate tensors for model debugging mode (flag
     * KEEP_INTERMEDIATE_TENSORS is true).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ getIntermediateTensors() {
        return this.executor.getIntermediateTensors();
    }
    /**
     * Dispose intermediate tensors for model debugging mode (flag
     * KEEP_INTERMEDIATE_TENSORS is true).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ disposeIntermediateTensors() {
        this.executor.disposeIntermediateTensors();
    }
    convertTensorMapToTensorsMap(map) {
        return Object.keys(map).reduce((newMap, key)=>{
            newMap[key] = [
                map[key]
            ];
            return newMap;
        }, {});
    }
    /**
     * Releases the memory used by the weight tensors and resourceManager.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ dispose() {
        this.executor.dispose();
        if (this.initializer) this.initializer.dispose();
        this.resourceManager.dispose();
    }
}
async function $819c2f9c18b64d1a$export$f077572b5d896ffd(modelUrl, options = {}, tfio = (0, $1RJvL)) {
    if (modelUrl == null) throw new Error("modelUrl in loadGraphModel() cannot be null. Please provide a url or an IOHandler that loads the model");
    if (options == null) options = {};
    if (options.fromTFHub && typeof modelUrl === 'string') modelUrl = $819c2f9c18b64d1a$var$getTFHubUrl(modelUrl);
    const model = new $819c2f9c18b64d1a$export$357a78c279dfa8cf(modelUrl, options, tfio);
    await model.load();
    return model;
}
function $819c2f9c18b64d1a$export$64fa41ef6cfbfdd7(modelSource) {
    if (modelSource == null) throw new Error("modelUrl in loadGraphModelSync() cannot be null. Please provide model artifacts or an IOHandler that loads the model");
    let ioHandler;
    if (modelSource instanceof Array) {
        const [modelJSON, weights] = modelSource;
        if (!modelJSON) throw new Error('modelJSON must be the first element of the array');
        if (!weights || !(weights instanceof ArrayBuffer)) throw new Error("An ArrayBuffer of weights must be the second element of the array");
        if (!('modelTopology' in modelJSON)) throw new Error('Model JSON is missing \'modelTopology\'');
        if (!('weightsManifest' in modelJSON)) throw new Error('Model JSON is missing \'weightsManifest\'');
        const weightSpecs = (0, $1RJvL).getWeightSpecs(modelJSON.weightsManifest);
        const modelArtifacts = (0, $1RJvL).getModelArtifactsForJSONSync(modelJSON, weightSpecs, weights);
        ioHandler = (0, $1RJvL).fromMemorySync(modelArtifacts);
    } else if ('load' in modelSource) // Then modelSource is already an IOHandlerSync.
    ioHandler = modelSource;
    else if ('modelTopology' in modelSource && 'weightSpecs' in modelSource && 'weightData' in modelSource) // modelSource is of type ModelArtifacts.
    ioHandler = (0, $1RJvL).fromMemorySync(modelSource);
    else throw new Error('Unknown model format');
    const model = new $819c2f9c18b64d1a$export$357a78c279dfa8cf(ioHandler);
    model.load();
    return model;
}
function $819c2f9c18b64d1a$var$getTFHubUrl(modelUrl) {
    if (!modelUrl.endsWith('/')) modelUrl = modelUrl + '/';
    return `${modelUrl}${$819c2f9c18b64d1a$export$9ffb2eac80132860}${$819c2f9c18b64d1a$export$a9bc79b23e178599}`;
}

});
parcelRegister("e8sDp", function(module, exports) {

$parcel$export(module.exports, "OperationMapper", () => $a4a8064cd688a4ff$export$712e670bcbcf1315);
$parcel$export(module.exports, "getStringParam", () => $a4a8064cd688a4ff$export$88878e8ea979e9e0);
$parcel$export(module.exports, "getStringArrayParam", () => $a4a8064cd688a4ff$export$3ad7c1b82be1673b);
$parcel$export(module.exports, "getNumberParam", () => $a4a8064cd688a4ff$export$9bb8d6def7820923);
$parcel$export(module.exports, "getNumericArrayParam", () => $a4a8064cd688a4ff$export$a5181f35ff520ed9);
$parcel$export(module.exports, "getBoolParam", () => $a4a8064cd688a4ff$export$2dc362e9c5612e66);
$parcel$export(module.exports, "getBoolArrayParam", () => $a4a8064cd688a4ff$export$71dea7cc6cfe5d6);
$parcel$export(module.exports, "getTensorShapeParam", () => $a4a8064cd688a4ff$export$2f3f0447f2b6ba0c);
$parcel$export(module.exports, "getTensorShapeArrayParam", () => $a4a8064cd688a4ff$export$296050a88ff1b217);
$parcel$export(module.exports, "getDtypeParam", () => $a4a8064cd688a4ff$export$8ff555328ef39a1b);
$parcel$export(module.exports, "getDtypeArrayParam", () => $a4a8064cd688a4ff$export$4d8018dacba67c5a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");

var $bX1XU = parcelRequire("bX1XU");

var $6XVuT = parcelRequire("6XVuT");

var $l8IRh = parcelRequire("l8IRh");

var $hbDtm = parcelRequire("hbDtm");

var $3WtK3 = parcelRequire("3WtK3");

var $kv7Uy = parcelRequire("kv7Uy");

var $768gO = parcelRequire("768gO");

var $89mjK = parcelRequire("89mjK");

var $9snY1 = parcelRequire("9snY1");

var $4iR6k = parcelRequire("4iR6k");

var $jeYy0 = parcelRequire("jeYy0");

var $g6EIp = parcelRequire("g6EIp");

var $ihAwG = parcelRequire("ihAwG");

var $fqgCu = parcelRequire("fqgCu");

var $ekkNX = parcelRequire("ekkNX");

var $1px39 = parcelRequire("1px39");

var $jC5ph = parcelRequire("jC5ph");

var $bemwb = parcelRequire("bemwb");

var $e08Bo = parcelRequire("e08Bo");

var $4JziP = parcelRequire("4JziP");

var $kQDM0 = parcelRequire("kQDM0");

var $2r0u4 = parcelRequire("2r0u4");

var $cbQCu = parcelRequire("cbQCu");
var $a4a8064cd688a4ff$require$Buffer = $cbQCu.Buffer;
class $a4a8064cd688a4ff$export$712e670bcbcf1315 {
    // Singleton instance for the mapper
    static get Instance() {
        return this._instance || (this._instance = new this());
    }
    // Loads the op mapping from the JSON file.
    constructor(){
        const ops = [
            $hbDtm,
            $3WtK3,
            $kv7Uy,
            $768gO,
            $89mjK,
            $9snY1,
            $4iR6k,
            $jeYy0,
            $g6EIp,
            $ihAwG,
            $fqgCu,
            $ekkNX,
            $1px39,
            $jC5ph,
            $bemwb,
            $e08Bo,
            $4JziP,
            $kQDM0,
            $2r0u4
        ];
        const mappersJson = [].concat(...ops.map((op)=>op.json));
        this.opMappers = mappersJson.reduce((map, mapper)=>{
            map[mapper.tfOpName] = mapper;
            return map;
        }, {});
    }
    // Converts the model inference graph from Tensorflow GraphDef to local
    // representation for TensorFlow.js API
    transformGraph(graph, signature = {}) {
        const tfNodes = graph.node;
        const placeholders = [];
        const weights = [];
        const initNodes = [];
        const nodes = tfNodes.reduce((map, node)=>{
            map[node.name] = this.mapNode(node);
            if (node.op.startsWith('Placeholder')) placeholders.push(map[node.name]);
            else if (node.op === 'Const') weights.push(map[node.name]);
            else if (node.input == null || node.input.length === 0) initNodes.push(map[node.name]);
            return map;
        }, {});
        let inputs = [];
        const outputs = [];
        let inputNodeNameToKey = {};
        let outputNodeNameToKey = {};
        if (signature != null) {
            inputNodeNameToKey = this.mapSignatureEntries(signature.inputs);
            outputNodeNameToKey = this.mapSignatureEntries(signature.outputs);
        }
        const allNodes = Object.keys(nodes);
        allNodes.forEach((key)=>{
            const node = nodes[key];
            node.inputNames.forEach((name, index)=>{
                const [nodeName, , outputName] = (0, $l8IRh.getNodeNameAndIndex)(name);
                const inputNode = nodes[nodeName];
                if (inputNode.outputs != null) {
                    const outputIndex = inputNode.outputs.indexOf(outputName);
                    if (outputIndex !== -1) {
                        const inputName = `${nodeName}:${outputIndex}`;
                        // update the input name to use the mapped output index directly.
                        node.inputNames[index] = inputName;
                    }
                }
                node.inputs.push(inputNode);
                inputNode.children.push(node);
            });
        });
        // if signature has not outputs set, add any node that does not have
        // outputs.
        if (Object.keys(outputNodeNameToKey).length === 0) allNodes.forEach((key)=>{
            const node = nodes[key];
            if (node.children.length === 0) outputs.push(node);
        });
        else Object.keys(outputNodeNameToKey).forEach((name)=>{
            const [nodeName] = (0, $l8IRh.getNodeNameAndIndex)(name);
            const node = nodes[nodeName];
            if (node != null) {
                node.signatureKey = outputNodeNameToKey[name];
                outputs.push(node);
            }
        });
        if (Object.keys(inputNodeNameToKey).length > 0) Object.keys(inputNodeNameToKey).forEach((name)=>{
            const [nodeName] = (0, $l8IRh.getNodeNameAndIndex)(name);
            const node = nodes[nodeName];
            if (node) {
                node.signatureKey = inputNodeNameToKey[name];
                inputs.push(node);
            }
        });
        else inputs = placeholders;
        let functions = {};
        if (graph.library != null && graph.library.function != null) functions = graph.library.function.reduce((functions, func)=>{
            functions[func.signature.name] = this.mapFunction(func);
            return functions;
        }, {});
        const result = {
            nodes: nodes,
            inputs: inputs,
            outputs: outputs,
            weights: weights,
            placeholders: placeholders,
            signature: signature,
            functions: functions
        };
        if (initNodes.length > 0) result.initNodes = initNodes;
        return result;
    }
    mapSignatureEntries(entries) {
        return Object.keys(entries || {}).reduce((prev, curr)=>{
            prev[entries[curr].name] = curr;
            return prev;
        }, {});
    }
    mapNode(node) {
        // Unsupported ops will cause an error at run-time (not parse time), since
        // they may not be used by the actual execution subgraph.
        const mapper = (0, $6XVuT.getRegisteredOp)(node.op) || this.opMappers[node.op] || {};
        if (node.attr == null) node.attr = {};
        const newNode = {
            name: node.name,
            op: node.op,
            category: mapper.category,
            inputNames: (node.input || []).map((input)=>input.startsWith('^') ? input.slice(1) : input),
            inputs: [],
            children: [],
            inputParams: {},
            attrParams: {},
            rawAttrs: node.attr,
            outputs: mapper.outputs
        };
        if (mapper.inputs != null) newNode.inputParams = mapper.inputs.reduce((map, param)=>{
            map[param.name] = {
                type: param.type,
                inputIndexStart: param.start,
                inputIndexEnd: param.end
            };
            return map;
        }, {});
        if (mapper.attrs != null) newNode.attrParams = mapper.attrs.reduce((map, param)=>{
            const type = param.type;
            let value = undefined;
            switch(param.type){
                case 'string':
                    value = $a4a8064cd688a4ff$export$88878e8ea979e9e0(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $a4a8064cd688a4ff$export$88878e8ea979e9e0(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'string[]':
                    value = $a4a8064cd688a4ff$export$3ad7c1b82be1673b(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $a4a8064cd688a4ff$export$3ad7c1b82be1673b(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'number':
                    value = $a4a8064cd688a4ff$export$9bb8d6def7820923(node.attr, param.tfName, param.defaultValue || 0);
                    if (value === undefined && !!param.tfDeprecatedName) value = $a4a8064cd688a4ff$export$9bb8d6def7820923(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'number[]':
                    value = $a4a8064cd688a4ff$export$a5181f35ff520ed9(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $a4a8064cd688a4ff$export$a5181f35ff520ed9(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'bool':
                    value = $a4a8064cd688a4ff$export$2dc362e9c5612e66(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $a4a8064cd688a4ff$export$2dc362e9c5612e66(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'bool[]':
                    value = $a4a8064cd688a4ff$export$71dea7cc6cfe5d6(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $a4a8064cd688a4ff$export$71dea7cc6cfe5d6(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'shape':
                    value = $a4a8064cd688a4ff$export$2f3f0447f2b6ba0c(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $a4a8064cd688a4ff$export$2f3f0447f2b6ba0c(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'shape[]':
                    value = $a4a8064cd688a4ff$export$296050a88ff1b217(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $a4a8064cd688a4ff$export$296050a88ff1b217(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'dtype':
                    value = $a4a8064cd688a4ff$export$8ff555328ef39a1b(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $a4a8064cd688a4ff$export$8ff555328ef39a1b(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'dtype[]':
                    value = $a4a8064cd688a4ff$export$4d8018dacba67c5a(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $a4a8064cd688a4ff$export$4d8018dacba67c5a(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'func':
                    value = $a4a8064cd688a4ff$export$aafe7fbc7c8a8284(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $a4a8064cd688a4ff$export$aafe7fbc7c8a8284(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'tensor':
                case 'tensors':
                    break;
                default:
                    throw new Error(`Unsupported param type: ${param.type} for op: ${node.op}`);
            }
            map[param.name] = {
                value: value,
                type: type
            };
            return map;
        }, {});
        return newNode;
    }
    // map the TFunctionDef to TFJS graph object
    mapFunction(functionDef) {
        const tfNodes = functionDef.nodeDef;
        const placeholders = [];
        const weights = [];
        let nodes = {};
        if (tfNodes != null) nodes = tfNodes.reduce((map, node)=>{
            map[node.name] = this.mapNode(node);
            if (node.op === 'Const') weights.push(map[node.name]);
            return map;
        }, {});
        const inputs = [];
        const outputs = [];
        functionDef.signature.inputArg.forEach((arg)=>{
            const [nodeName] = (0, $l8IRh.getNodeNameAndIndex)(arg.name);
            const node = {
                name: nodeName,
                op: 'Placeholder',
                inputs: [],
                inputNames: [],
                category: 'graph',
                inputParams: {},
                attrParams: {
                    dtype: {
                        value: $a4a8064cd688a4ff$export$863992a6f00f04d8(arg.type),
                        type: 'dtype'
                    }
                },
                children: []
            };
            node.signatureKey = arg.name;
            inputs.push(node);
            nodes[nodeName] = node;
        });
        const allNodes = Object.keys(nodes);
        allNodes.forEach((key)=>{
            const node = nodes[key];
            node.inputNames.forEach((name, index)=>{
                const [nodeName, , outputName] = (0, $l8IRh.getNodeNameAndIndex)(name);
                const inputNode = nodes[nodeName];
                if (inputNode.outputs != null) {
                    const outputIndex = inputNode.outputs.indexOf(outputName);
                    if (outputIndex !== -1) {
                        const inputName = `${nodeName}:${outputIndex}`;
                        // update the input name to use the mapped output index directly.
                        node.inputNames[index] = inputName;
                    }
                }
                node.inputs.push(inputNode);
                inputNode.children.push(node);
            });
        });
        const returnNodeMap = functionDef.ret;
        functionDef.signature.outputArg.forEach((output)=>{
            const [nodeName, index] = (0, $l8IRh.getNodeNameAndIndex)(returnNodeMap[output.name]);
            const node = nodes[nodeName];
            if (node != null) {
                node.defaultOutput = index;
                outputs.push(node);
            }
        });
        const signature = this.mapArgsToSignature(functionDef);
        return {
            nodes: nodes,
            inputs: inputs,
            outputs: outputs,
            weights: weights,
            placeholders: placeholders,
            signature: signature
        };
    }
    mapArgsToSignature(functionDef) {
        return {
            methodName: functionDef.signature.name,
            inputs: functionDef.signature.inputArg.reduce((map, arg)=>{
                map[arg.name] = this.mapArgToTensorInfo(arg);
                return map;
            }, {}),
            outputs: functionDef.signature.outputArg.reduce((map, arg)=>{
                map[arg.name] = this.mapArgToTensorInfo(arg, functionDef.ret);
                return map;
            }, {})
        };
    }
    mapArgToTensorInfo(arg, nameMap) {
        let name = arg.name;
        if (nameMap != null) name = nameMap[name];
        return {
            name: name,
            dtype: arg.type
        };
    }
}
function $a4a8064cd688a4ff$export$94fdf11bafc8de6b(text) {
    const global = (0, $aymVi.env)().global;
    if (typeof global.atob !== 'undefined') return global.atob(text);
    else if (typeof $a4a8064cd688a4ff$require$Buffer !== 'undefined') return new $a4a8064cd688a4ff$require$Buffer(text, 'base64').toString();
    else throw new Error("Unable to decode base64 in this environment. Missing built-in atob() or Buffer()");
}
function $a4a8064cd688a4ff$export$a112ee1a9f1f58d1(s, keepCase) {
    const value = Array.isArray(s) ? String.fromCharCode.apply(null, s) : $a4a8064cd688a4ff$export$94fdf11bafc8de6b(s);
    return keepCase ? value : value.toLowerCase();
}
function $a4a8064cd688a4ff$export$88878e8ea979e9e0(attrs, name, def, keepCase = false) {
    const param = attrs[name];
    if (param != null) return $a4a8064cd688a4ff$export$a112ee1a9f1f58d1(param.s, keepCase);
    return def;
}
function $a4a8064cd688a4ff$export$2dc362e9c5612e66(attrs, name, def) {
    const param = attrs[name];
    return param ? param.b : def;
}
function $a4a8064cd688a4ff$export$9bb8d6def7820923(attrs, name, def) {
    const param = attrs[name] || {};
    const value = param['i'] != null ? param['i'] : param['f'] != null ? param['f'] : def;
    return typeof value === 'number' ? value : parseInt(value, 10);
}
function $a4a8064cd688a4ff$export$863992a6f00f04d8(value) {
    if (typeof value === 'string') // tslint:disable-next-line:no-any
    value = $bX1XU.DataType[value];
    switch(value){
        case $bX1XU.DataType.DT_FLOAT:
        case $bX1XU.DataType.DT_HALF:
            return 'float32';
        case $bX1XU.DataType.DT_INT32:
        case $bX1XU.DataType.DT_INT64:
        case $bX1XU.DataType.DT_INT8:
        case $bX1XU.DataType.DT_UINT8:
            return 'int32';
        case $bX1XU.DataType.DT_BOOL:
            return 'bool';
        case $bX1XU.DataType.DT_DOUBLE:
            return 'float32';
        case $bX1XU.DataType.DT_STRING:
            return 'string';
        default:
            // Unknown dtype error will happen at runtime (instead of parse time),
            // since these nodes might not be used by the actual subgraph execution.
            return null;
    }
}
function $a4a8064cd688a4ff$export$aafe7fbc7c8a8284(attrs, name, def) {
    const param = attrs[name];
    if (param && param.func) return param.func.name;
    return def;
}
function $a4a8064cd688a4ff$export$8ff555328ef39a1b(attrs, name, def) {
    const param = attrs[name];
    if (param && param.type) return $a4a8064cd688a4ff$export$863992a6f00f04d8(param.type);
    return def;
}
function $a4a8064cd688a4ff$export$4d8018dacba67c5a(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.type) return param.list.type.map((v)=>$a4a8064cd688a4ff$export$863992a6f00f04d8(v));
    return def;
}
function $a4a8064cd688a4ff$export$e22e6990f4767045(shape) {
    if (shape.unknownRank) return undefined;
    if (shape.dim != null) return shape.dim.map((dim)=>typeof dim.size === 'number' ? dim.size : parseInt(dim.size, 10));
    return [];
}
function $a4a8064cd688a4ff$export$2f3f0447f2b6ba0c(attrs, name, def) {
    const param = attrs[name];
    if (param && param.shape) return $a4a8064cd688a4ff$export$e22e6990f4767045(param.shape);
    return def;
}
function $a4a8064cd688a4ff$export$a5181f35ff520ed9(attrs, name, def) {
    const param = attrs[name];
    if (param) return ((param.list.f && param.list.f.length ? param.list.f : param.list.i) || []).map((v)=>typeof v === 'number' ? v : parseInt(v, 10));
    return def;
}
function $a4a8064cd688a4ff$export$3ad7c1b82be1673b(attrs, name, def, keepCase = false) {
    const param = attrs[name];
    if (param && param.list && param.list.s) return param.list.s.map((v)=>{
        return $a4a8064cd688a4ff$export$a112ee1a9f1f58d1(v, keepCase);
    });
    return def;
}
function $a4a8064cd688a4ff$export$296050a88ff1b217(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.shape) return param.list.shape.map((v)=>{
        return $a4a8064cd688a4ff$export$e22e6990f4767045(v);
    });
    return def;
}
function $a4a8064cd688a4ff$export$71dea7cc6cfe5d6(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.b) return param.list.b;
    return def;
}

});
parcelRegister("bX1XU", function(module, exports) {

$parcel$export(module.exports, "DataType", () => $8b36baaecca037d9$export$45c69700ee30a78c);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /** DataType enum. */ var $8b36baaecca037d9$export$45c69700ee30a78c;
(function(DataType) {
    // Not a legal value for DataType.  Used to indicate a DataType field
    // has not been set.
    DataType[DataType["DT_INVALID"] = 0] = "DT_INVALID";
    // Data types that all computation devices are expected to be
    // capable to support.
    DataType[DataType["DT_FLOAT"] = 1] = "DT_FLOAT";
    DataType[DataType["DT_DOUBLE"] = 2] = "DT_DOUBLE";
    DataType[DataType["DT_INT32"] = 3] = "DT_INT32";
    DataType[DataType["DT_UINT8"] = 4] = "DT_UINT8";
    DataType[DataType["DT_INT16"] = 5] = "DT_INT16";
    DataType[DataType["DT_INT8"] = 6] = "DT_INT8";
    DataType[DataType["DT_STRING"] = 7] = "DT_STRING";
    DataType[DataType["DT_COMPLEX64"] = 8] = "DT_COMPLEX64";
    DataType[DataType["DT_INT64"] = 9] = "DT_INT64";
    DataType[DataType["DT_BOOL"] = 10] = "DT_BOOL";
    DataType[DataType["DT_QINT8"] = 11] = "DT_QINT8";
    DataType[DataType["DT_QUINT8"] = 12] = "DT_QUINT8";
    DataType[DataType["DT_QINT32"] = 13] = "DT_QINT32";
    DataType[DataType["DT_BFLOAT16"] = 14] = "DT_BFLOAT16";
    DataType[DataType["DT_QINT16"] = 15] = "DT_QINT16";
    DataType[DataType["DT_QUINT16"] = 16] = "DT_QUINT16";
    DataType[DataType["DT_UINT16"] = 17] = "DT_UINT16";
    DataType[DataType["DT_COMPLEX128"] = 18] = "DT_COMPLEX128";
    DataType[DataType["DT_HALF"] = 19] = "DT_HALF";
    DataType[DataType["DT_RESOURCE"] = 20] = "DT_RESOURCE";
    DataType[DataType["DT_VARIANT"] = 21] = "DT_VARIANT";
    DataType[DataType["DT_UINT32"] = 22] = "DT_UINT32";
    DataType[DataType["DT_UINT64"] = 23] = "DT_UINT64";
    // Do not use!  These are only for parameters.  Every enum above
    // should have a corresponding value below (verified by types_test).
    DataType[DataType["DT_FLOAT_REF"] = 101] = "DT_FLOAT_REF";
    DataType[DataType["DT_DOUBLE_REF"] = 102] = "DT_DOUBLE_REF";
    DataType[DataType["DT_INT32_REF"] = 103] = "DT_INT32_REF";
    DataType[DataType["DT_UINT8_REF"] = 104] = "DT_UINT8_REF";
    DataType[DataType["DT_INT16_REF"] = 105] = "DT_INT16_REF";
    DataType[DataType["DT_INT8_REF"] = 106] = "DT_INT8_REF";
    DataType[DataType["DT_STRING_REF"] = 107] = "DT_STRING_REF";
    DataType[DataType["DT_COMPLEX64_REF"] = 108] = "DT_COMPLEX64_REF";
    DataType[DataType["DT_INT64_REF"] = 109] = "DT_INT64_REF";
    DataType[DataType["DT_BOOL_REF"] = 110] = "DT_BOOL_REF";
    DataType[DataType["DT_QINT8_REF"] = 111] = "DT_QINT8_REF";
    DataType[DataType["DT_QUINT8_REF"] = 112] = "DT_QUINT8_REF";
    DataType[DataType["DT_QINT32_REF"] = 113] = "DT_QINT32_REF";
    DataType[DataType["DT_BFLOAT16_REF"] = 114] = "DT_BFLOAT16_REF";
    DataType[DataType["DT_QINT16_REF"] = 115] = "DT_QINT16_REF";
    DataType[DataType["DT_QUINT16_REF"] = 116] = "DT_QUINT16_REF";
    DataType[DataType["DT_UINT16_REF"] = 117] = "DT_UINT16_REF";
    DataType[DataType["DT_COMPLEX128_REF"] = 118] = "DT_COMPLEX128_REF";
    DataType[DataType["DT_HALF_REF"] = 119] = "DT_HALF_REF";
    DataType[DataType["DT_RESOURCE_REF"] = 120] = "DT_RESOURCE_REF";
    DataType[DataType["DT_VARIANT_REF"] = 121] = "DT_VARIANT_REF";
    DataType[DataType["DT_UINT32_REF"] = 122] = "DT_UINT32_REF";
    DataType[DataType["DT_UINT64_REF"] = 123] = "DT_UINT64_REF";
})($8b36baaecca037d9$export$45c69700ee30a78c || ($8b36baaecca037d9$export$45c69700ee30a78c = {}));
var $8b36baaecca037d9$export$c7aebf4a33f92df2;
(function(SaverDef) {
    /** CheckpointFormatVersion enum. */ let CheckpointFormatVersion;
    (function(CheckpointFormatVersion) {
        CheckpointFormatVersion[CheckpointFormatVersion["LEGACY"] = 0] = "LEGACY";
        CheckpointFormatVersion[CheckpointFormatVersion["V1"] = 1] = "V1";
        CheckpointFormatVersion[CheckpointFormatVersion["V2"] = 2] = "V2";
    })(CheckpointFormatVersion = SaverDef.CheckpointFormatVersion || (SaverDef.CheckpointFormatVersion = {}));
})($8b36baaecca037d9$export$c7aebf4a33f92df2 || ($8b36baaecca037d9$export$c7aebf4a33f92df2 = {}));

});

parcelRegister("6XVuT", function(module, exports) {

$parcel$export(module.exports, "registerOp", () => $5124da8135e5eb18$export$670e5ae0b581ed28);
$parcel$export(module.exports, "getRegisteredOp", () => $5124da8135e5eb18$export$ad480e5d0b303fdc);
$parcel$export(module.exports, "deregisterOp", () => $5124da8135e5eb18$export$26ff69eae92eb5cb);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $5124da8135e5eb18$var$CUSTOM_OPS = {};
function $5124da8135e5eb18$export$670e5ae0b581ed28(name, opFunc) {
    const opMapper = {
        tfOpName: name,
        category: 'custom',
        inputs: [],
        attrs: [],
        customExecutor: opFunc
    };
    $5124da8135e5eb18$var$CUSTOM_OPS[name] = opMapper;
}
function $5124da8135e5eb18$export$ad480e5d0b303fdc(name) {
    return $5124da8135e5eb18$var$CUSTOM_OPS[name];
}
function $5124da8135e5eb18$export$26ff69eae92eb5cb(name) {
    delete $5124da8135e5eb18$var$CUSTOM_OPS[name];
}

});

parcelRegister("l8IRh", function(module, exports) {

$parcel$export(module.exports, "getParamValue", () => $f63d24410c139279$export$390042a9afe1baa5);
$parcel$export(module.exports, "getTensor", () => $f63d24410c139279$export$c5e50df225428195);
$parcel$export(module.exports, "parseNodeName", () => $f63d24410c139279$export$67aec20b8c372baf);
$parcel$export(module.exports, "getTensorsForCurrentContenxt", () => $f63d24410c139279$export$48d774fba6d4cc49);
$parcel$export(module.exports, "getNodeNameAndIndex", () => $f63d24410c139279$export$6cbb65bf9e07a72);
$parcel$export(module.exports, "getPadding", () => $f63d24410c139279$export$d7501e6bee71bfee);
$parcel$export(module.exports, "cloneTensor", () => $f63d24410c139279$export$c2185cfeaef7ba84);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dnFj7 = parcelRequire("dnFj7");
var $wx9lK = parcelRequire("wx9lK");
function $f63d24410c139279$export$390042a9afe1baa5(paramName, node, tensorMap, context, resourceManager) {
    const inputParam = node.inputParams[paramName];
    if (inputParam && inputParam.inputIndexStart !== undefined) {
        const start = inputParam.inputIndexStart;
        const end = inputParam.inputIndexEnd === 0 ? undefined : inputParam.inputIndexEnd === undefined ? start + 1 : inputParam.inputIndexEnd;
        if (inputParam.type === 'tensor') return $f63d24410c139279$export$c5e50df225428195(node.inputNames[inputParam.inputIndexStart], tensorMap, context, resourceManager);
        if (inputParam.type === 'tensors') {
            const inputs = node.inputNames.slice(start, end);
            return inputs.map((name)=>$f63d24410c139279$export$c5e50df225428195(name, tensorMap, context, resourceManager));
        }
        const tensor = $f63d24410c139279$export$c5e50df225428195(node.inputNames.slice(start)[0], tensorMap, context, resourceManager);
        const data = tensor.dataSync();
        return inputParam.type === 'number' ? data[0] : (0, $wx9lK).toNestedArray(tensor.shape, data);
    }
    const attrParam = node.attrParams[paramName];
    return attrParam && attrParam.value;
}
function $f63d24410c139279$export$c5e50df225428195(name, tensorsMap, context, resourceManager) {
    const [nodeName, index] = $f63d24410c139279$export$67aec20b8c372baf(name);
    if (resourceManager != null) {
        const tensor = resourceManager.getHashTableHandleByName(nodeName);
        if (tensor != null) return tensor;
    }
    const contextId = context.currentContextIds.find((contextId)=>{
        return !!tensorsMap[$f63d24410c139279$var$getNodeNameWithContextId(nodeName, contextId)];
    });
    return contextId !== undefined ? tensorsMap[$f63d24410c139279$var$getNodeNameWithContextId(nodeName, contextId)][index] : undefined;
}
function $f63d24410c139279$export$48d774fba6d4cc49(name, tensorsMap, context) {
    return tensorsMap[$f63d24410c139279$var$getNodeNameWithContextId(name, context.currentContextId)];
}
function $f63d24410c139279$export$6cbb65bf9e07a72(inputName, context) {
    const [nodeName, index, outputName] = $f63d24410c139279$export$67aec20b8c372baf(inputName);
    return [
        $f63d24410c139279$var$getNodeNameWithContextId(nodeName, context && context.currentContextId),
        index,
        outputName
    ];
}
function $f63d24410c139279$var$getNodeNameWithContextId(name, contextId) {
    return !!contextId ? `${name}-${contextId}` : name;
}
function $f63d24410c139279$export$67aec20b8c372baf(name) {
    const parts = name.split(':');
    if (parts.length === 1) return [
        name,
        0,
        undefined
    ];
    const nodeName = parts[0];
    const outputName = parts.length === 3 ? parts[1] : undefined;
    const index = Number(parts[parts.length - 1]);
    return [
        nodeName,
        index,
        outputName
    ];
}
function $f63d24410c139279$export$65980d18b75784e2(arr, size) {
    const res = [];
    for(let i = 0; i < arr.length; i += size)res.push(arr.slice(i, i + size));
    return res;
}
function $f63d24410c139279$export$d7501e6bee71bfee(node, tensorMap, context) {
    let pad = $f63d24410c139279$export$390042a9afe1baa5('pad', node, tensorMap, context);
    if (pad === 'explicit') {
        // This is 1d array, we need to convert it to 2d array
        pad = $f63d24410c139279$export$390042a9afe1baa5('explicitPaddings', node, tensorMap, context);
        const explicitPadding = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ];
        for(let i = 0; i < 4; i++){
            explicitPadding[i][0] = pad[i * 2];
            explicitPadding[i][1] = pad[i * 2 + 1];
        }
        return explicitPadding;
    }
    return pad;
}
function $f63d24410c139279$export$c2185cfeaef7ba84(tensor) {
    return tensor.kept ? tensor : (0, $dnFj7.clone)(tensor);
}

});

parcelRegister("hbDtm", function(module, exports) {

$parcel$export(module.exports, "json", () => $c832152f21032766$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $c832152f21032766$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Add',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AddV2',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AddN',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'BiasAdd',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sub',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RealDiv',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Div',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'DivNoNan',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FloorDiv',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Mul',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Maximum',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Minimum',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Pow',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SquaredDifference',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Mod',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FloorMod',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("3WtK3", function(module, exports) {

$parcel$export(module.exports, "json", () => $2deddc00b39aeab3$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $2deddc00b39aeab3$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Abs',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Acos',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Asin',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atan2',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Ceil',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ClipByValue',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'clipValueMin',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'clipValueMax',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Complex',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'real',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'imag',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ComplexAbs',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cos',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cosh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Elu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Exp',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Floor',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Log',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Imag',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'outputType',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Neg',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Real',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'outputType',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Prelu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'alpha',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Relu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Relu6',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Selu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sigmoid',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sin',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sinh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sqrt',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Rsqrt',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Square',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tanh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sign',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Round',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Expm1',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Log1p',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Reciprocal',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Softplus',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Asinh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Acosh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atanh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Erf',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Prod',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axes',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool',
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LeakyRelu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'alpha',
                'name': 'alpha',
                'type': 'number',
                'defaultValue': 0.2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsNan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("kv7Uy", function(module, exports) {

$parcel$export(module.exports, "json", () => $eeccd6e1751ed0b4$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $eeccd6e1751ed0b4$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'EmptyTensorList',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 1,
                'name': 'maxNumElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LoopCond',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'pred',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Switch',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'pred',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Merge',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Enter',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'frame_name',
                'name': 'frameName',
                'type': 'string'
            },
            {
                'tfName': 'is_constant',
                'name': 'isConstant',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Exit',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'NextIteration',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'size',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'dynamic_size',
                'name': 'dynamicSize',
                'type': 'bool'
            },
            {
                'tfName': 'clear_after_read',
                'name': 'clearAfterRead',
                'type': 'bool'
            },
            {
                'tfName': 'identical_element_shapes',
                'name': 'identicalElementShapes',
                'type': 'bool'
            },
            {
                'tfName': 'tensor_array_name',
                'name': 'name',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayWriteV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayReadV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayGatherV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayScatterV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayConcatV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape_except0',
                'name': 'elementShapeExcept0',
                'type': 'shape',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArraySplitV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'lengths',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorArraySizeV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'flowIn',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayCloseV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'StatelessIf',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'cond',
                'type': 'tensor'
            },
            {
                'start': 1,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'then_branch',
                'name': 'thenBranch',
                'type': 'func'
            },
            {
                'tfName': 'else_branch',
                'name': 'elseBranch',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'If',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'cond',
                'type': 'tensor'
            },
            {
                'start': 1,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'then_branch',
                'name': 'thenBranch',
                'type': 'func'
            },
            {
                'tfName': 'else_branch',
                'name': 'elseBranch',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'StatelessWhile',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'cond',
                'name': 'cond',
                'type': 'func'
            },
            {
                'tfName': 'body',
                'name': 'body',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'While',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'cond',
                'name': 'cond',
                'type': 'func'
            },
            {
                'tfName': 'body',
                'name': 'body',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'TensorListScatter',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListScatterV2',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 3,
                'name': 'numElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListGather',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListGetItem',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListSetItem',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListReserve',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 1,
                'name': 'numElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListFromTensor',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListStack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            },
            {
                'tfName': 'num_elements',
                'name': 'numElements',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListSplit',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 2,
                'name': 'lengths',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListConcat',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListConcatV2',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListPopBack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListPushBack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListLength',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'TensorListResize',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            }
        ]
    }
];

});

parcelRegister("768gO", function(module, exports) {

$parcel$export(module.exports, "json", () => $52af823ccab57160$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $52af823ccab57160$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'AvgPool',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPool',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': [],
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPoolWithArgmax',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'include_batch_in_index',
                'name': 'includeBatchInIndex',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AvgPool3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPool3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Conv1D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'stride',
                'name': 'stride',
                'type': 'number'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NWC'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'dilation',
                'name': 'dilation',
                'type': 'number',
                'defaultValue': 1
            }
        ]
    },
    {
        'tfOpName': 'Conv2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'useCudnnOnGpu',
                'name': 'useCudnnOnGpu',
                'type': 'bool'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': '_FusedConv2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'use_cudnn_on_gpu',
                'name': 'useCudnnOnGpu',
                'type': 'bool',
                'defaultValue': true
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'defaultValue': [
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.0001
            },
            {
                'tfName': 'leakyrelu_alpha',
                'name': 'leakyreluAlpha',
                'type': 'number',
                'defaultValue': 0.2
            }
        ]
    },
    {
        'tfOpName': 'Conv2DBackpropInput',
        'category': 'convolution',
        'inputs': [
            {
                'start': 2,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 0,
                'name': 'outputShape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'DepthwiseConv2d',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'DepthwiseConv2dNative',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'FusedDepthwiseConv2dNative',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'defaultValue': [
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            }
        ]
    },
    {
        'tfOpName': 'Conv3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Dilation2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'rates',
                'name': 'dilations',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            }
        ]
    }
];

});

parcelRegister("89mjK", function(module, exports) {

$parcel$export(module.exports, "json", () => $5ef079c534631a8b$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $5ef079c534631a8b$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Fill',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            },
            {
                'start': 1,
                'name': 'value',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LinSpace',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'start',
                'type': 'number'
            },
            {
                'start': 1,
                'name': 'stop',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'num',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'OneHot',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'depth',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'onValue',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'start': 3,
                'name': 'offValue',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Ones',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'OnesLike',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'RandomStandardNormal',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RandomUniform',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'minval',
                'name': 'minval',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'maxval',
                'name': 'maxval',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Range',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'start',
                'type': 'number'
            },
            {
                'start': 1,
                'name': 'stop',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'step',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'Tidx',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TruncatedNormal',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'means',
                'name': 'mean',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'stddev',
                'name': 'stdDev',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number'
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Zeros',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'ZerosLike',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Multinomial',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'logits',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numSamples',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number'
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'output_dtype',
                'name': 'output_dtype',
                'type': 'dtype'
            }
        ]
    }
];

});

parcelRegister("9snY1", function(module, exports) {

$parcel$export(module.exports, "json", () => $6e2951f0f1947957$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $6e2951f0f1947957$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'NonMaxSuppressionV2',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV3',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV4',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'T_threshold',
                'name': 'threshold',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'pad_to_max_output_size',
                'name': 'padToMaxOutputSize',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV5',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            },
            {
                'start': 5,
                'name': 'softNmsSigma',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'Where',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ListDiff',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("4iR6k", function(module, exports) {

$parcel$export(module.exports, "json", () => $322208a4d7c09a4a$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $322208a4d7c09a4a$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'LowerBound',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'sortedSequence',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'TopKV2',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'k',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'sorted',
                'name': 'sorted',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'UpperBound',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'sortedSequence',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Unique',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'UniqueV2',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    }
];

});

parcelRegister("jeYy0", function(module, exports) {

$parcel$export(module.exports, "json", () => $e01e4a92f9849427$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $e01e4a92f9849427$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'PlaceholderWithDefault',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'default',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'shape',
                'name': 'shape',
                'type': 'shape'
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Placeholder',
        'category': 'graph',
        'attrs': [
            {
                'tfName': 'shape',
                'name': 'shape',
                'type': 'shape'
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Const',
        'category': 'graph'
    },
    {
        'tfOpName': 'Identity',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'IdentityN',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'x',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Snapshot',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Rank',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Size',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Shape',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'ShapeN',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'x',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Print',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'data',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'message',
                'name': 'message',
                'type': 'string'
            },
            {
                'tfName': 'first_n',
                'name': 'firstN',
                'type': 'number',
                'notSupported': true
            },
            {
                'tfName': 'summarize',
                'name': 'summarize',
                'type': 'number',
                'defaultValue': 3
            }
        ]
    },
    {
        'tfOpName': 'NoOp',
        'category': 'graph',
        'inputs': []
    },
    {
        'tfOpName': 'StopGradient',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'FakeQuantWithMinMaxVars',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'min',
                'name': 'min',
                'type': 'number'
            },
            {
                'tfName': 'max',
                'name': 'max',
                'type': 'number'
            }
        ]
    }
];

});

parcelRegister("g6EIp", function(module, exports) {

$parcel$export(module.exports, "json", () => $bb9cca181490b866$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $bb9cca181490b866$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'HashTable',
        'category': 'hash_table',
        'inputs': [],
        'attrs': [
            {
                'tfName': 'shared_name',
                'name': 'sharedName',
                'type': 'string'
            },
            {
                'tfName': 'use_node_name_sharing',
                'name': 'useNodeNameSharing',
                'type': 'bool'
            },
            {
                'tfName': 'key_dtype',
                'name': 'keyDType',
                'type': 'dtype'
            },
            {
                'tfName': 'value_dtype',
                'name': 'valueDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'HashTableV2',
        'category': 'hash_table',
        'inputs': [],
        'attrs': [
            {
                'tfName': 'shared_name',
                'name': 'sharedName',
                'type': 'string'
            },
            {
                'tfName': 'use_node_name_sharing',
                'name': 'useNodeNameSharing',
                'type': 'bool'
            },
            {
                'tfName': 'key_dtype',
                'name': 'keyDType',
                'type': 'dtype'
            },
            {
                'tfName': 'value_dtype',
                'name': 'valueDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LookupTableImport',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableImportV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableFind',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableFindV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableSize',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'LookupTableSizeV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("ihAwG", function(module, exports) {

$parcel$export(module.exports, "json", () => $d4f625da365f52a6$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $d4f625da365f52a6$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'ResizeBilinear',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'align_corners',
                'name': 'alignCorners',
                'type': 'bool'
            },
            {
                'tfName': 'half_pixel_centers',
                'name': 'halfPixelCenters',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ResizeNearestNeighbor',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'align_corners',
                'name': 'alignCorners',
                'type': 'bool'
            },
            {
                'tfName': 'half_pixel_centers',
                'name': 'halfPixelCenters',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'CropAndResize',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'image',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'boxInd',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'cropSize',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'method',
                'name': 'method',
                'type': 'string'
            },
            {
                'tfName': 'extrapolation_value',
                'name': 'extrapolationValue',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'ImageProjectiveTransformV3',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'transforms',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'outputShape',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'fillValue',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'interpolation',
                'name': 'interpolation',
                'type': 'string'
            },
            {
                'tfName': 'fill_mode',
                'name': 'fillMode',
                'type': 'string'
            }
        ]
    }
];

});

parcelRegister("fqgCu", function(module, exports) {

$parcel$export(module.exports, "json", () => $b3a62d14b9f52236$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $b3a62d14b9f52236$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Equal',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'NotEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Greater',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'GreaterEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Less',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LessEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalAnd',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalNot',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalOr',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Select',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SelectV2',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("ekkNX", function(module, exports) {

$parcel$export(module.exports, "json", () => $a6e3125c2b094899$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $a6e3125c2b094899$export$7b419323e6ed4f31 = [
    {
        'tfOpName': '_FusedMatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.0001
            },
            {
                'tfName': 'transpose_a',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'transpose_b',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'leakyrelu_alpha',
                'name': 'leakyreluAlpha',
                'type': 'number',
                'defaultValue': 0.2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'transpose_a',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'transpose_b',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BatchMatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'adj_x',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'adj_y',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BatchMatMulV2',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'adj_x',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'adj_y',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Transpose',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'perm',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Einsum',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'equation',
                'name': 'equation',
                'type': 'string'
            },
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    }
];

});

parcelRegister("1px39", function(module, exports) {

$parcel$export(module.exports, "json", () => $1071c3451f31ba04$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $1071c3451f31ba04$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'EuclideanNorm',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool',
                'defaultValue': false
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNorm',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNormV2',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNormV3',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LRN',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'depth_radius',
                'name': 'radius',
                'type': 'number',
                'defaultValue': 5
            },
            {
                'tfName': 'bias',
                'name': 'bias',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'alpha',
                'name': 'alpha',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'beta',
                'name': 'beta',
                'type': 'number',
                'defaultValue': 0.5
            }
        ]
    },
    {
        'tfOpName': 'Softmax',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'LogSoftmax',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseToDense',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'sparseIndices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'outputShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'sparseValues',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'validate_indices',
                'name': 'validateIndices',
                'type': 'bool',
                'defaultValue': true,
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("jC5ph", function(module, exports) {

$parcel$export(module.exports, "json", () => $e475c29aedf30fcd$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $e475c29aedf30fcd$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Bincount',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'weights',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'DenseBincount',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'weights',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'binary_output',
                'name': 'binaryOutput',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Max',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Mean',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Min',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Sum',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'All',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Any',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'ArgMax',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'ArgMin',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'Prod',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Cumprod',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'exclusive',
                'name': 'exclusive',
                'type': 'bool'
            },
            {
                'tfName': 'reverse',
                'name': 'reverse',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Cumsum',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'exclusive',
                'name': 'exclusive',
                'type': 'bool'
            },
            {
                'tfName': 'reverse',
                'name': 'reverse',
                'type': 'bool'
            }
        ]
    }
];

});

parcelRegister("bemwb", function(module, exports) {

$parcel$export(module.exports, "json", () => $82d27821ce9c42cd$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $82d27821ce9c42cd$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'ConcatV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'end': -1,
                'name': 'tensors',
                'type': 'tensors'
            },
            {
                'start': -1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            }
        ]
    },
    {
        'tfOpName': 'Concat',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 1,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            },
            {
                'start': 0,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            }
        ]
    },
    {
        'tfOpName': 'GatherV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'batch_dims',
                'name': 'batchDims',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Gather',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'validate_indices',
                'name': 'validateIndices',
                'type': 'bool',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Reverse',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'dims',
                'type': 'bool[]'
            }
        ]
    },
    {
        'tfOpName': 'ReverseV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Slice',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'begin',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'size',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'StridedSlice',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'begin',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'end',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'strides',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'begin_mask',
                'name': 'beginMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'end_mask',
                'name': 'endMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'new_axis_mask',
                'name': 'newAxisMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'ellipsis_mask',
                'name': 'ellipsisMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'shrink_axis_mask',
                'name': 'shrinkAxisMask',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Pack',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Unpack',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'num',
                'name': 'num',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tile',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'reps',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Split',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'start': 1,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_split',
                'name': 'numOrSizeSplits',
                'type': 'number',
                'defaultValue': 1
            }
        ]
    },
    {
        'tfOpName': 'SplitV',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numOrSizeSplits',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'ScatterNd',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'GatherNd',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseToDense',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'sparseIndices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'outputShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'sparseValues',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'validate_indices',
                'name': 'validateIndices',
                'type': 'bool',
                'defaultValue': false,
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("e08Bo", function(module, exports) {

$parcel$export(module.exports, "json", () => $a317bcf8d1c6f164$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $a317bcf8d1c6f164$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'SparseFillEmptyRows',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'denseShape',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseReshape',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'inputIndices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'inputShape',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'newShape',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SparseSegmentMean',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'segmentIds',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseSegmentSum',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'segmentIds',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("4JziP", function(module, exports) {

$parcel$export(module.exports, "json", () => $3726bfcb671c2bcb$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $3726bfcb671c2bcb$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'FFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'IFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'RFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'fft_length',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IRFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'fft_length',
                'type': 'number',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("kQDM0", function(module, exports) {

$parcel$export(module.exports, "json", () => $f2d7841c492229e6$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $f2d7841c492229e6$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'StringNGrams',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'dataSplits',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'separator',
                'name': 'separator',
                'type': 'string'
            },
            {
                'tfName': 'ngram_widths',
                'name': 'nGramWidths',
                'type': 'number[]'
            },
            {
                'tfName': 'left_pad',
                'name': 'leftPad',
                'type': 'string'
            },
            {
                'tfName': 'right_pad',
                'name': 'rightPad',
                'type': 'string'
            },
            {
                'tfName': 'pad_width',
                'name': 'padWidth',
                'type': 'number'
            },
            {
                'tfName': 'preserve_short_sequences',
                'name': 'preserveShortSequences',
                'type': 'bool'
            }
        ],
        'outputs': [
            'ngrams',
            'ngrams_splits'
        ]
    },
    {
        'tfOpName': 'StringSplit',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'delimiter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'skip_empty',
                'name': 'skipEmpty',
                'type': 'bool'
            }
        ],
        'outputs': [
            'indices',
            'values',
            'shape'
        ]
    },
    {
        'tfOpName': 'StringToHashBucketFast',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_buckets',
                'name': 'numBuckets',
                'type': 'number'
            }
        ]
    }
];

});

parcelRegister("2r0u4", function(module, exports) {

$parcel$export(module.exports, "json", () => $1c5e7a81ea1c8173$export$7b419323e6ed4f31);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $1c5e7a81ea1c8173$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Cast',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'SrcT',
                'name': 'sdtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'DstT',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'ExpandDims',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'MirrorPad',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'mode',
                'name': 'mode',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'Pad',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'constant_value',
                'name': 'constantValue',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'PadV2',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'constantValue',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Reshape',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Squeeze',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'tfDeprecatedName': 'squeeze_dims',
                'name': 'axis',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'SpaceToBatchND',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'blockShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'paddings',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'BatchToSpaceND',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'blockShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'crops',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'DepthToSpace',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'block_size',
                'name': 'blockSize',
                'type': 'number'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'BroadcastTo',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': []
    },
    {
        'tfOpName': 'BroadcastArgs',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 's0',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 's1',
                'type': 'tensor'
            }
        ],
        'attrs': []
    }
];

});


parcelRegister("7zKYo", function(module, exports) {

$parcel$export(module.exports, "GraphExecutor", () => $58403d243efb204e$export$289b3892ec35f79a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $9c0Qr = parcelRequire("9c0Qr");
var $wx9lK = parcelRequire("wx9lK");

var $l8IRh = parcelRequire("l8IRh");

var $iOBU4 = parcelRequire("iOBU4");

var $fmNgT = parcelRequire("fmNgT");

var $aIXqN = parcelRequire("aIXqN");
class $58403d243efb204e$export$289b3892ec35f79a {
    /**
     *
     * @param graph Graph the model or function graph to be executed.
     * @param parent When building function exector you need to set the parent
     * executor. Since the weights and function executor maps are set at parant
     * level, that function executor can access the function maps and weight maps
     * through the parent.
     */ constructor(graph, parent){
        this.graph = graph;
        this.parent = parent;
        this.compiledMap = new Map();
        this._weightMap = {};
        this.SEPERATOR = ',';
        this._functions = {};
        this._functionExecutorMap = {};
        this.intermediateTensors = {};
        this.keepTensorForDebug = false;
        this._outputs = graph.outputs;
        this._inputs = graph.inputs;
        this._initNodes = graph.initNodes;
        this._signature = graph.signature;
        this._functions = graph.functions;
        // create sub-graph executors
        if (graph.functions != null) Object.keys(graph.functions).forEach((name)=>{
            this._functionExecutorMap[name] = new $58403d243efb204e$export$289b3892ec35f79a(graph.functions[name], this);
        });
    }
    get weightIds() {
        return this.parent ? this.parent.weightIds : this._weightIds;
    }
    get functionExecutorMap() {
        return this.parent ? this.parent.functionExecutorMap : this._functionExecutorMap;
    }
    get weightMap() {
        return this.parent ? this.parent.weightMap : this._weightMap;
    }
    set weightMap(weightMap) {
        const weightIds = Object.keys(weightMap).map((key)=>weightMap[key].map((tensor)=>tensor.id));
        this._weightIds = [].concat(...weightIds);
        this._weightMap = weightMap;
    }
    /**
     * Set `ResourceManager` shared by executors of a model.
     * @param resourceManager: `ResourceManager` of the `GraphModel`.
     */ set resourceManager(resourceManager) {
        this._resourceManager = resourceManager;
    }
    get inputs() {
        return this._inputs.map((node)=>{
            return {
                name: node.name,
                shape: node.attrParams['shape'] ? node.attrParams['shape'].value : undefined,
                dtype: node.attrParams['dtype'] ? node.attrParams['dtype'].value : undefined
            };
        });
    }
    get outputs() {
        return this._outputs.map((node)=>{
            return {
                name: node.name,
                shape: node.attrParams['shape'] ? node.attrParams['shape'].value : undefined,
                dtype: node.attrParams['dtype'] ? node.attrParams['dtype'].value : undefined
            };
        });
    }
    get inputNodes() {
        return this._inputs.map((node)=>node.signatureKey || node.name);
    }
    get outputNodes() {
        return this._outputs.map((node)=>{
            const name = node.signatureKey || node.name;
            return node.defaultOutput ? `${name}:${node.defaultOutput}` : name;
        });
    }
    get functions() {
        return Object.keys(this._functions).reduce((map, key)=>{
            map[key] = this._functions[key].signature;
            return map;
        }, {});
    }
    getCompilationKey(inputs, outputs) {
        const sortedInputs = inputs.map((node)=>node.name).sort();
        const sortedOutputs = outputs.map((node)=>node.name).sort();
        return sortedInputs.join(this.SEPERATOR) + '--' + sortedOutputs.join(this.SEPERATOR);
    }
    /**
     * Compiles the inference graph and returns the minimal set of nodes that are
     * required for execution, in the correct execution order.
     */ compile(inputs, outputs) {
        const executionInfo = (0, $aIXqN.getExecutionSubgraph)(inputs, outputs, this.weightMap, this._initNodes);
        const { missingInputs: missingInputs, dynamicNode: dynamicNode, syncInputs: syncInputs } = executionInfo;
        if (dynamicNode != null) throw new Error(`This execution contains the node '${dynamicNode.name}', which has ` + `the dynamic op '${dynamicNode.op}'. Please use ` + `model.executeAsync() instead. Alternatively, to avoid the ` + `dynamic ops, specify the inputs [${syncInputs}]`);
        if (missingInputs.length > 0) {
            const outNames = outputs.map((n)=>n.name);
            const inNames = Object.keys(inputs);
            throw new Error(`Cannot compute the outputs [${outNames}] from the provided inputs ` + `[${inNames}]. Missing the following inputs: [${missingInputs}]`);
        }
        return (0, $aIXqN.getNodesInTopologicalOrder)(this.graph, this.weightMap, executionInfo);
    }
    /**
     * Executes the inference for given input tensors.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs Optional. output node name from the Tensorflow model, if
     * no outputs are specified, the default outputs of the model would be used.
     * You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     */ execute(inputs, outputs) {
        inputs = this.mapInputs(inputs);
        const names = Object.keys(inputs).sort();
        this.checkInputs(inputs);
        this.checkInputShapeAndType(inputs);
        outputs = this.mapOutputs(outputs);
        this.checkOutputs(outputs);
        const inputNodes = names.map((name)=>this.graph.nodes[(0, $l8IRh.parseNodeName)(name)[0]]);
        const outputNodeNames = outputs.map((name)=>(0, $l8IRh.parseNodeName)(name)[0]);
        let outputNodes = outputNodeNames.map((name)=>this.graph.nodes[name]);
        this.resetIntermediateTensors();
        // If no outputs are specified, then use the default outputs of the model.
        if (outputNodes.length === 0) outputNodes = this._outputs;
        const compilationKey = this.getCompilationKey(inputNodes, outputNodes);
        // Do nothing if the compiled graph cache contains the input.
        let orderedNodes = this.compiledMap.get(compilationKey);
        if (orderedNodes == null) {
            orderedNodes = this.compile(inputs, outputNodes);
            this.compiledMap.set(compilationKey, orderedNodes);
        }
        const tensorArrayMap = {};
        const tensorListMap = {};
        return (0, $9c0Qr.tidy)(()=>{
            const context = new (0, $fmNgT.ExecutionContext)(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap);
            const tensorsMap = Object.assign({}, this.weightMap);
            Object.keys(inputs).forEach((name)=>{
                const [nodeName, index] = (0, $l8IRh.parseNodeName)(name);
                const tensors = [];
                tensors[index] = inputs[name];
                tensorsMap[nodeName] = tensors;
            });
            const tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
            const intermediateTensorConsumerCount = {};
            for(let i = 0; i < orderedNodes.length; i++){
                const node = orderedNodes[i];
                if (!tensorsMap[node.name]) {
                    const tensors = (0, $iOBU4.executeOp)(node, tensorsMap, context, this._resourceManager);
                    if ((0, $wx9lK).isPromise(tensors)) throw new Error(`The execution of the op '${node.op}' returned a promise. ` + `Please use model.executeAsync() instead.`);
                    tensorsMap[node.name] = tensors;
                    this.checkTensorForDisposal(node.name, node, tensorsMap, context, tensorsToKeep, outputNodeNames, intermediateTensorConsumerCount);
                }
            }
            // dispose the context for the root executor
            if (this.parent == null) context.dispose(tensorsToKeep);
            return outputs.map((name)=>(0, $l8IRh.getTensor)(name, tensorsMap, context));
        });
    }
    getFrozenTensorIds(tensorMap) {
        const ids = [].concat.apply([], Object.keys(tensorMap).map((key)=>tensorMap[key]).map((tensors)=>tensors.map((tensor)=>tensor.id)));
        return new Set(ids);
    }
    checkTensorForDisposal(nodeName, node, tensorMap, context, tensorsToKeep, outputNames, intermediateTensorConsumerCount) {
        // Skip output nodes and any control flow nodes, since its dependency is
        // tricky to track correctly.
        if (node.category === 'control' || outputNames.indexOf(nodeName) !== -1) return;
        tensorMap[nodeName].forEach((tensor)=>{
            if (tensor != null) intermediateTensorConsumerCount[tensor.id] = (intermediateTensorConsumerCount[tensor.id] || 0) + node.children.length;
        });
        node.inputs.forEach((input)=>{
            // Skip any control flow nodes, since its dependency is tricky to track
            // correctly.
            if (input.category !== 'control') {
                const tensors = (0, $l8IRh.getTensorsForCurrentContenxt)(input.name, tensorMap, context);
                if (tensors != null) tensors.forEach((tensor)=>{
                    if (tensor && !tensor.kept && !tensorsToKeep.has(tensor.id)) {
                        const count = intermediateTensorConsumerCount[tensor.id];
                        if (count === 1) {
                            if (!this.keepTensorForDebug) tensor.dispose();
                            else {
                                const [nodeName, index] = (0, $l8IRh.getNodeNameAndIndex)(node.name, context);
                                if (this.intermediateTensors[nodeName]) this.intermediateTensors[nodeName][index] = tensor;
                                else {
                                    this.intermediateTensors[nodeName] = [];
                                    this.intermediateTensors[nodeName][index] = tensor;
                                }
                            }
                            delete intermediateTensorConsumerCount[tensor.id];
                        } else if (count != null) // only intermediate nodes has count set, inputs and weights are
                        // not.
                        intermediateTensorConsumerCount[tensor.id]--;
                    }
                });
            }
        });
    }
    /**
     * Executes the inference for given input tensors in Async fashion.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs output node name from the Tensorflow model, if no outputs
     * are specified, the default outputs of the model would be used. You can
     * inspect intermediate nodes of the model by adding them to the outputs
     * array.
     */ async executeAsync(inputs, outputs) {
        return this._executeAsync(inputs, outputs);
    }
    disposeIntermediateTensors() {
        if (!this.intermediateTensors) return;
        Object.keys(this.intermediateTensors).forEach((key)=>this.intermediateTensors[key].forEach((tensor)=>tensor.dispose()));
        this.disposeTensorsMap();
    }
    disposeTensorsMap() {
        if (!this.tensorsMap) return;
        Object.keys(this.tensorsMap).forEach((key)=>{
            const tensorArray = this.tensorsMap[key];
            tensorArray.forEach((tensor)=>{
                if (tensor && !tensor.kept && !tensor.isDisposed && !this.keepIds.has(tensor.id)) tensor.dispose();
            });
        });
    }
    getIntermediateTensors() {
        return this.tensorsMap;
    }
    resetIntermediateTensors() {
        for(const key in this.intermediateTensors){
            this.intermediateTensors[key].forEach((tensor)=>tensor.dispose());
            delete this.intermediateTensors[key];
        }
    }
    /**
     * Executes the inference for given input tensors in Async fashion.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs Optional. output node name from the Tensorflow model,
     * if no outputs are specified, the default outputs of the model would be
     * used. You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     * @param isFunctionExecution Optional. Flag for executing a function.
     * @param tensorArrayMap Optional, global TensorArray map by id. Used for
     * function execution.
     * @param tensorArrayMap Optinal global TensorList map by id. Used for
     * function execution.
     */ async _executeAsync(inputs, outputs, isFunctionExecution = false, tensorArrayMap = {}, tensorListMap = {}) {
        if (!isFunctionExecution) {
            inputs = this.mapInputs(inputs);
            this.checkInputs(inputs);
            this.checkInputShapeAndType(inputs);
            outputs = this.mapOutputs(outputs);
            this.checkOutputs(outputs);
        }
        // For model debug.
        try {
            this.keepTensorForDebug = (0, $aymVi.env)().getBool('KEEP_INTERMEDIATE_TENSORS');
        } catch (e) {
            console.warn(e.message);
        }
        this.resetIntermediateTensors();
        const context = new (0, $fmNgT.ExecutionContext)(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap);
        // Graph with control flow op requires runtime evaluation of the execution
        // order, while without control flow the execution order is pre-determined
        // in the compile method.
        this.tensorsMap = await this.executeWithControlFlow(inputs, context, outputs, isFunctionExecution);
        const results = outputs.map((name)=>(0, $l8IRh.getTensor)(name, this.tensorsMap, context));
        // dispose all the intermediate tensors
        const outputIds = results.map((t)=>t.id);
        const inputIds = Object.keys(inputs).map((name)=>inputs[name].id);
        this.keepIds = new Set([
            ...outputIds,
            ...inputIds,
            ...this.weightIds
        ]);
        if (!this.keepTensorForDebug) this.disposeTensorsMap();
        // dispose the context for the root executor
        if (this.parent == null) context.dispose(this.keepIds);
        return results;
    }
    async executeFunctionAsync(inputs, tensorArrayMap, tensorListMap) {
        const mappedInputs = inputs.reduce((map, tensor, index)=>{
            map[this.inputs[index].name] = tensor;
            return map;
        }, {});
        return this._executeAsync(mappedInputs, this.outputNodes, true, tensorArrayMap, tensorListMap);
    }
    /**
     * When there are control flow nodes in the graph, the graph execution use
     * ExecutionContext to keep track of the frames and loop iterators.
     * @param inputs placeholder tensors for the graph.
     * @param context the execution context object for current execution.
     * @param outputNames Optional. output node name from the Tensorflow model,
     * if no outputs are specified, the default outputs of the model would be
     * used. You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     * @param isFunctionExecution Flag for executing a function.
     */ async executeWithControlFlow(inputs, context, outputNames, isFunctionExecution) {
        const names = Object.keys(inputs);
        const inputNodes = names.map((name)=>this.graph.nodes[(0, $l8IRh.parseNodeName)(name)[0]]);
        const outputNodeNames = outputNames.map((name)=>(0, $l8IRh.parseNodeName)(name)[0]);
        let outputNodes = outputNodeNames.map((name)=>this.graph.nodes[name]);
        // If no outputs are specified, then use the default outputs of the model.
        if (outputNodes.length === 0) outputNodes = this._outputs;
        const { usedNodes: usedNodes, missingInputs: missingInputs, dynamicNode: dynamicNode, syncInputs: syncInputs } = (0, $aIXqN.getExecutionSubgraph)(inputs, outputNodes, this.weightMap, this._initNodes);
        // First nodes to execute include inputNodes, weights, and initNodes.
        const stack = [
            ...inputNodes,
            ...this.graph.weights,
            ...this._initNodes || []
        ].map((node)=>{
            return {
                node: node,
                contexts: context.currentContext
            };
        });
        const tensorsMap = Object.assign({}, this.weightMap);
        Object.keys(inputs).forEach((name)=>{
            const [nodeName, index] = (0, $l8IRh.parseNodeName)(name);
            const tensors = [];
            tensors[index] = inputs[name];
            tensorsMap[nodeName] = tensors;
        });
        const intermediateTensorConsumerCount = {};
        const tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
        const added = {};
        while(stack.length > 0){
            const promises = this.processStack(inputNodes, stack, context, tensorsMap, added, tensorsToKeep, outputNodeNames, intermediateTensorConsumerCount, usedNodes);
            await Promise.all(promises);
        }
        if (dynamicNode == null && !isFunctionExecution) console.warn(`This model execution did not contain any nodes with control flow ` + `or dynamic output shapes. You can use model.execute() instead.`);
        const missingOutputs = outputNodes.filter((node)=>!(0, $aIXqN.isControlFlow)(node) && !(0, $l8IRh.getTensor)(node.name, tensorsMap, context)).map((node)=>node.name);
        if (missingOutputs.length > 0) {
            let alternativeMsg = '';
            if (dynamicNode != null) alternativeMsg = `Alternatively, to avoid the dynamic ops, use model.execute() ` + `and specify the inputs [${syncInputs}]`;
            throw new Error(`Cannot compute the outputs [${missingOutputs}] from the provided ` + `inputs [${names}]. Consider providing the following inputs: ` + `[${missingInputs}]. ${alternativeMsg}`);
        }
        return tensorsMap;
    }
    processStack(inputNodes, stack, context, tensorMap, added, tensorsToKeep, outputNames, intermediateTensorConsumerCount, usedNodes) {
        const promises = [];
        while(stack.length > 0){
            const item = stack.pop();
            context.currentContext = item.contexts;
            let nodeName = '';
            // The tensor of the Enter op with isConstant set should be set
            // in the parent scope, so it will be available as constant for the
            // whole loop.
            if (item.node.op === 'Enter' && (0, $l8IRh.getParamValue)('isConstant', item.node, tensorMap, context)) [nodeName] = (0, $l8IRh.getNodeNameAndIndex)(item.node.name, context);
            // only process nodes that are not in the tensorMap yet, this include
            // inputNodes and internal initNodes.
            if (tensorMap[item.node.name] == null) {
                const tensors = (0, $iOBU4.executeOp)(item.node, tensorMap, context, this._resourceManager);
                if (!nodeName) [nodeName] = (0, $l8IRh.getNodeNameAndIndex)(item.node.name, context);
                const currentContext = context.currentContext;
                if ((0, $wx9lK).isPromise(tensors)) promises.push(tensors.then((t)=>{
                    tensorMap[nodeName] = t;
                    context.currentContext = currentContext;
                    this.checkTensorForDisposal(nodeName, item.node, tensorMap, context, tensorsToKeep, outputNames, intermediateTensorConsumerCount);
                    this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
                    return t;
                }));
                else {
                    tensorMap[nodeName] = tensors;
                    this.checkTensorForDisposal(nodeName, item.node, tensorMap, context, tensorsToKeep, outputNames, intermediateTensorConsumerCount);
                    this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
                }
            } else this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
        }
        return promises;
    }
    processChildNodes(node, stack, context, tensorMap, added, usedNodes) {
        node.children.forEach((childNode)=>{
            const [nodeName] = (0, $l8IRh.getNodeNameAndIndex)(childNode.name, context);
            if (added[nodeName] || !usedNodes.has(childNode.name)) return;
            // Merge op can be pushed if any of its inputs has value.
            if (childNode.op === 'Merge') {
                if (childNode.inputNames.some((name)=>{
                    return !!(0, $l8IRh.getTensor)(name, tensorMap, context);
                })) {
                    added[nodeName] = true;
                    stack.push({
                        contexts: context.currentContext,
                        node: childNode
                    });
                }
            } else if (childNode.inputNames.every((name)=>{
                return !!(0, $l8IRh.getTensor)(name, tensorMap, context);
            })) {
                added[nodeName] = true;
                stack.push({
                    contexts: context.currentContext,
                    node: childNode
                });
            }
        });
    }
    /**
     * Releases the memory used by the weight tensors.
     */ dispose() {
        Object.keys(this.weightMap).forEach((key)=>this.weightMap[key].forEach((tensor)=>tensor.dispose()));
    }
    checkInputShapeAndType(inputs) {
        Object.keys(inputs).forEach((name)=>{
            const input = inputs[name];
            const [nodeName] = (0, $l8IRh.parseNodeName)(name);
            const node = this.graph.nodes[nodeName];
            if (node.attrParams['shape'] && node.attrParams['shape'].value) {
                const shape = node.attrParams['shape'].value;
                const match = shape.length === input.shape.length && input.shape.every((dim, index)=>shape[index] === -1 || shape[index] === dim);
                (0, $wx9lK).assert(match, ()=>`The shape of dict['${node.name}'] provided in ` + `model.execute(dict) must be [${shape}], but was ` + `[${input.shape}]`);
            }
            if (node.attrParams['dtype'] && node.attrParams['dtype'].value) (0, $wx9lK).assert(input.dtype === node.attrParams['dtype'].value, ()=>`The dtype of dict['${node.name}'] provided in ` + `model.execute(dict) must be ` + `${node.attrParams['dtype'].value}, but was ${input.dtype}`);
        });
    }
    mapInputs(inputs) {
        const result = {};
        for(const inputName in inputs)if (this._signature != null && this._signature.inputs != null && this._signature.inputs[inputName] != null) {
            const tensor = this._signature.inputs[inputName];
            result[tensor.name] = inputs[inputName];
        } else result[inputName] = inputs[inputName];
        return result;
    }
    checkInputs(inputs) {
        const notInGraph = Object.keys(inputs).filter((name)=>{
            const [nodeName] = (0, $l8IRh.parseNodeName)(name);
            return this.graph.nodes[nodeName] == null;
        });
        if (notInGraph.length > 0) throw new Error(`The dict provided in model.execute(dict) has ` + `keys: [${notInGraph}] that are not part of graph`);
    }
    mapOutputs(outputs) {
        return outputs.map((name)=>{
            if (this._signature != null && this._signature.outputs != null && this._signature.outputs[name] != null) {
                const tensor = this._signature.outputs[name];
                return tensor.name;
            }
            return name;
        }, {});
    }
    checkOutputs(outputs) {
        outputs.forEach((name)=>{
            const [normalizedName] = (0, $l8IRh.parseNodeName)(name);
            if (!this.graph.nodes[normalizedName]) throw new Error(`The output '${name}' is not found in the graph`);
        });
    }
}

});
parcelRegister("iOBU4", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $db2a4c4d0a29ce95$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $9c0Qr = parcelRequire("9c0Qr");
var $wx9lK = parcelRequire("wx9lK");

var $feXPc = parcelRequire("feXPc");

var $6XVuT = parcelRequire("6XVuT");

var $bXSUX = parcelRequire("bXSUX");

var $6Lsrq = parcelRequire("6Lsrq");

var $lvm7R = parcelRequire("lvm7R");

var $bhLqU = parcelRequire("bhLqU");

var $f0AFT = parcelRequire("f0AFT");

var $jojnZ = parcelRequire("jojnZ");

var $gGknH = parcelRequire("gGknH");

var $bsIvb = parcelRequire("bsIvb");

var $83zBs = parcelRequire("83zBs");

var $jT1Dw = parcelRequire("jT1Dw");

var $eZsKX = parcelRequire("eZsKX");

var $38tmr = parcelRequire("38tmr");

var $8YJja = parcelRequire("8YJja");

var $iAtXe = parcelRequire("iAtXe");

var $gXSbk = parcelRequire("gXSbk");

var $74IKF = parcelRequire("74IKF");

var $io0Wq = parcelRequire("io0Wq");

var $5Lwy2 = parcelRequire("5Lwy2");

var $9qMbz = parcelRequire("9qMbz");
function $db2a4c4d0a29ce95$export$7be88578e558e499(node, tensorMap, context, resourceManager, tidy = $9c0Qr.tidy) {
    const value = ((node, tensorMap, context)=>{
        switch(node.category){
            case 'arithmetic':
                return tidy(()=>$bXSUX.executeOp(node, tensorMap, context));
            case 'basic_math':
                return tidy(()=>$6Lsrq.executeOp(node, tensorMap, context));
            case 'control':
                return $lvm7R.executeOp(node, tensorMap, context);
            case 'convolution':
                return tidy(()=>$bhLqU.executeOp(node, tensorMap, context));
            case 'creation':
                return tidy(()=>$f0AFT.executeOp(node, tensorMap, context));
            case 'dynamic':
                return $jojnZ.executeOp(node, tensorMap, context);
            case 'evaluation':
                return tidy(()=>$gGknH.executeOp(node, tensorMap, context));
            case 'image':
                return tidy(()=>$jT1Dw.executeOp(node, tensorMap, context));
            case 'graph':
                return tidy(()=>$bsIvb.executeOp(node, tensorMap, context));
            case 'logical':
                return tidy(()=>$eZsKX.executeOp(node, tensorMap, context));
            case 'matrices':
                return tidy(()=>$38tmr.executeOp(node, tensorMap, context));
            case 'normalization':
                return tidy(()=>$8YJja.executeOp(node, tensorMap, context));
            case 'reduction':
                return tidy(()=>$iAtXe.executeOp(node, tensorMap, context));
            case 'slice_join':
                return tidy(()=>$gXSbk.executeOp(node, tensorMap, context));
            case 'sparse':
                return tidy(()=>$74IKF.executeOp(node, tensorMap, context));
            case 'spectral':
                return tidy(()=>$io0Wq.executeOp(node, tensorMap, context));
            case 'string':
                return tidy(()=>$5Lwy2.executeOp(node, tensorMap, context));
            case 'transformation':
                return tidy(()=>$9qMbz.executeOp(node, tensorMap, context));
            case 'hash_table':
                return $83zBs.executeOp(node, tensorMap, context, resourceManager);
            case 'custom':
                const opMapper = (0, $6XVuT.getRegisteredOp)(node.op);
                if (opMapper && opMapper.customExecutor) return opMapper.customExecutor(new (0, $feXPc.NodeValueImpl)(node, tensorMap, context));
                else throw TypeError(`Custom op ${node.op} is not registered.`);
            default:
                throw TypeError(`Unknown op '${node.op}'. File an issue at ` + `https://github.com/tensorflow/tfjs/issues so we can add it` + `, or register a custom execution with tf.registerOp()`);
        }
    })(node, tensorMap, context);
    if ($wx9lK.isPromise(value)) return value.then((data)=>[].concat(data));
    return [].concat(value);
}

});
parcelRegister("feXPc", function(module, exports) {

$parcel$export(module.exports, "NodeValueImpl", () => $b18691c7ceb4b07c$export$2964c493e854c8ad);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $l8IRh = parcelRequire("l8IRh");

var $e8sDp = parcelRequire("e8sDp");
class $b18691c7ceb4b07c$export$2964c493e854c8ad {
    constructor(node, tensorMap, context){
        this.node = node;
        this.tensorMap = tensorMap;
        this.context = context;
        this.inputs = [];
        this.attrs = {};
        this.inputs = node.inputNames.map((name)=>this.getInput(name));
        if (node.rawAttrs != null) this.attrs = Object.keys(node.rawAttrs).reduce((attrs, key)=>{
            attrs[key] = this.getAttr(key);
            return attrs;
        }, {});
    }
    /**
     * Return the value of the attribute or input param.
     * @param name String: name of attribute or input param.
     */ getInput(name) {
        return (0, $l8IRh.getTensor)(name, this.tensorMap, this.context);
    }
    /**
     * Return the value of the attribute or input param.
     * @param name String: name of attribute or input param.
     */ getAttr(name, defaultValue) {
        const value = this.node.rawAttrs[name];
        if (value.tensor != null) return (0, $l8IRh.getTensor)(name, this.tensorMap, this.context);
        if (value.i != null || value.f != null) return (0, $e8sDp.getNumberParam)(this.node.rawAttrs, name, defaultValue);
        if (value.s != null) return (0, $e8sDp.getStringParam)(this.node.rawAttrs, name, defaultValue);
        if (value.b != null) return (0, $e8sDp.getBoolParam)(this.node.rawAttrs, name, defaultValue);
        if (value.shape != null) return (0, $e8sDp.getTensorShapeParam)(this.node.rawAttrs, name, defaultValue);
        if (value.type != null) return (0, $e8sDp.getDtypeParam)(this.node.rawAttrs, name, defaultValue);
        if (value.list != null) {
            if (value.list.i != null || value.list.f != null) return (0, $e8sDp.getNumericArrayParam)(this.node.rawAttrs, name, defaultValue);
            if (value.list.s != null) return (0, $e8sDp.getStringArrayParam)(this.node.rawAttrs, name, defaultValue);
            if (value.list.shape != null) return (0, $e8sDp.getTensorShapeArrayParam)(this.node.rawAttrs, name, defaultValue);
            if (value.list.b != null) return (0, $e8sDp.getBoolArrayParam)(this.node.rawAttrs, name, defaultValue);
            if (value.list.type != null) return (0, $e8sDp.getDtypeArrayParam)(this.node.rawAttrs, name, defaultValue);
        }
        return defaultValue;
    }
}

});

parcelRegister("bXSUX", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $8b5fcdea99e8f8b0$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $8b5fcdea99e8f8b0$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'BiasAdd':
        case 'AddV2':
        case 'Add':
            return [
                ops.add((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'AddN':
            return [
                ops.addN((0, $l8IRh.getParamValue)('tensors', node, tensorMap, context))
            ];
        case 'FloorMod':
        case 'Mod':
            return [
                ops.mod((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Mul':
            return [
                ops.mul((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'RealDiv':
        case 'Div':
            return [
                ops.div((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'DivNoNan':
            return [
                ops.divNoNan((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'FloorDiv':
            return [
                ops.floorDiv((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Sub':
            return [
                ops.sub((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Minimum':
            return [
                ops.minimum((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Maximum':
            return [
                ops.maximum((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Pow':
            return [
                ops.pow((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'SquaredDifference':
            return [
                ops.squaredDifference((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $8b5fcdea99e8f8b0$export$2c04807512a22510 = 'arithmetic';

});
parcelRegister("1ShPG", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * This file exports ops used by the converters executors. By default it
 * re-exports all ops. In a custom build this is aliased to a file that will
 * only exports ops for a given model.json.
 */ 
var $iNZmA = parcelRequire("iNZmA");
$parcel$exportWildcard(module.exports, $iNZmA);

});


parcelRegister("6Lsrq", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $4ecd31b5f542865f$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $4ecd31b5f542865f$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'Abs':
        case 'ComplexAbs':
            return [
                ops.abs((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Acos':
            return [
                ops.acos((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Acosh':
            return [
                ops.acosh((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Asin':
            return [
                ops.asin((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Asinh':
            return [
                ops.asinh((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Atan':
            return [
                ops.atan((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Atan2':
            return [
                ops.atan2((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('y', node, tensorMap, context))
            ];
        case 'Atanh':
            return [
                ops.atanh((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Ceil':
            return [
                ops.ceil((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Complex':
            return [
                ops.complex((0, $l8IRh.getParamValue)('real', node, tensorMap, context), (0, $l8IRh.getParamValue)('imag', node, tensorMap, context))
            ];
        case 'Cos':
            return [
                ops.cos((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Cosh':
            return [
                ops.cosh((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Elu':
            return [
                ops.elu((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Erf':
            return [
                ops.erf((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Exp':
            return [
                ops.exp((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Expm1':
            return [
                ops.expm1((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Floor':
            return [
                ops.floor((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Log':
            return [
                ops.log((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Log1p':
            return [
                ops.log1p((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Imag':
            return [
                ops.imag((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Neg':
            return [
                ops.neg((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Reciprocal':
            return [
                ops.reciprocal((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Real':
            return [
                ops.real((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Relu':
            return [
                ops.relu((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Round':
            return [
                ops.round((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Selu':
            return [
                ops.selu((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sigmoid':
            return [
                ops.sigmoid((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sin':
            return [
                ops.sin((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sign':
            return [
                ops.sign((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sinh':
            return [
                ops.sinh((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Softplus':
            return [
                ops.softplus((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sqrt':
            return [
                ops.sqrt((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Square':
            return [
                ops.square((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Tanh':
            return [
                ops.tanh((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Tan':
            return [
                ops.tan((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'ClipByValue':
            return [
                ops.clipByValue((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('clipValueMin', node, tensorMap, context), (0, $l8IRh.getParamValue)('clipValueMax', node, tensorMap, context))
            ];
        case 'Relu6':
            return [
                ops.relu6((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Rsqrt':
            return [
                ops.rsqrt((0, $l8IRh.getTensor)(node.inputNames[0], tensorMap, context))
            ];
        case 'Prod':
            return [
                ops.prod((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('axes', node, tensorMap, context))
            ];
        case 'LeakyRelu':
            return [
                ops.leakyRelu((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('alpha', node, tensorMap, context))
            ];
        case 'Prelu':
            return [
                ops.prelu((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('alpha', node, tensorMap, context))
            ];
        case 'IsNan':
            return [
                ops.isNaN((0, $l8IRh.getTensor)(node.inputNames[0], tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $4ecd31b5f542865f$export$2c04807512a22510 = 'basic_math';

});

parcelRegister("lvm7R", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $fa7da7f07f341763$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $j7yUF = parcelRequire("j7yUF");

var $a6zRb = parcelRequire("a6zRb");

var $7eOpq = parcelRequire("7eOpq");

var $l8IRh = parcelRequire("l8IRh");
const $fa7da7f07f341763$export$7be88578e558e499 = async (node, tensorMap, context)=>{
    switch(node.op){
        case 'If':
        case 'StatelessIf':
            {
                const thenFunc = (0, $l8IRh.getParamValue)('thenBranch', node, tensorMap, context);
                const elseFunc = (0, $l8IRh.getParamValue)('elseBranch', node, tensorMap, context);
                const cond = (0, $l8IRh.getParamValue)('cond', node, tensorMap, context);
                const args = (0, $l8IRh.getParamValue)('args', node, tensorMap, context);
                const condValue = await cond.data();
                if (condValue[0]) return context.functionMap[thenFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
                else return context.functionMap[elseFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
            }
        case 'While':
        case 'StatelessWhile':
            {
                const bodyFunc = (0, $l8IRh.getParamValue)('body', node, tensorMap, context);
                const condFunc = (0, $l8IRh.getParamValue)('cond', node, tensorMap, context);
                const args = (0, $l8IRh.getParamValue)('args', node, tensorMap, context);
                // Calculate the condition of the loop
                const condResult = await context.functionMap[condFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
                const argIds = args.map((tensor)=>tensor.id);
                let condValue = await condResult[0].data();
                // Dispose the intermediate tensors for condition function
                condResult.forEach((tensor)=>{
                    if (!tensor.kept && argIds.indexOf(tensor.id) === -1) tensor.dispose();
                });
                let result = args;
                while(condValue[0]){
                    // Record the previous result for intermediate tensor tracking
                    const origResult = result;
                    // Execution the body of the loop
                    result = await context.functionMap[bodyFunc].executeFunctionAsync(result, context.tensorArrayMap, context.tensorListMap);
                    const resultIds = result.map((tensor)=>tensor.id);
                    // Dispose the intermediate tensor for body function that is not global
                    // kept, not input/output of the body function
                    origResult.forEach((tensor)=>{
                        if (!tensor.kept && argIds.indexOf(tensor.id) === -1 && resultIds.indexOf(tensor.id) === -1) tensor.dispose();
                    });
                    // Recalcuate the condition of the loop using the latest results.
                    const condResult = await context.functionMap[condFunc].executeFunctionAsync(result, context.tensorArrayMap, context.tensorListMap);
                    condValue = await condResult[0].data();
                    // Dispose the intermediate tensors for condition function
                    condResult.forEach((tensor)=>{
                        if (!tensor.kept && argIds.indexOf(tensor.id) === -1 && resultIds.indexOf(tensor.id) === -1) tensor.dispose();
                    });
                }
                return result;
            }
        case 'LoopCond':
            {
                const pred = (0, $l8IRh.getParamValue)('pred', node, tensorMap, context);
                return [
                    (0, $l8IRh.cloneTensor)(pred)
                ];
            }
        case 'Switch':
            {
                const pred = (0, $l8IRh.getParamValue)('pred', node, tensorMap, context);
                let data = (0, $l8IRh.getParamValue)('data', node, tensorMap, context);
                if (!data.kept) data = (0, $l8IRh.cloneTensor)(data);
                // Outputs nodes :0 => false, :1 => true
                return (await pred.data())[0] ? [
                    undefined,
                    data
                ] : [
                    data,
                    undefined
                ];
            }
        case 'Merge':
            {
                const inputName = node.inputNames.find((name)=>(0, $l8IRh.getTensor)(name, tensorMap, context) !== undefined);
                if (inputName) {
                    const data = (0, $l8IRh.getTensor)(inputName, tensorMap, context);
                    return [
                        (0, $l8IRh.cloneTensor)(data)
                    ];
                }
                return undefined;
            }
        case 'Enter':
            {
                const frameId = (0, $l8IRh.getParamValue)('frameName', node, tensorMap, context);
                const data = (0, $l8IRh.getParamValue)('tensor', node, tensorMap, context);
                context.enterFrame(frameId);
                return [
                    (0, $l8IRh.cloneTensor)(data)
                ];
            }
        case 'Exit':
            {
                const data = (0, $l8IRh.getParamValue)('tensor', node, tensorMap, context);
                context.exitFrame();
                return [
                    (0, $l8IRh.cloneTensor)(data)
                ];
            }
        case 'NextIteration':
            {
                const data = (0, $l8IRh.getParamValue)('tensor', node, tensorMap, context);
                context.nextIteration();
                return [
                    (0, $l8IRh.cloneTensor)(data)
                ];
            }
        case 'TensorArrayV3':
            {
                const size = (0, $l8IRh.getParamValue)('size', node, tensorMap, context);
                const dtype = (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context);
                const elementShape = (0, $l8IRh.getParamValue)('elementShape', node, tensorMap, context);
                const dynamicSize = (0, $l8IRh.getParamValue)('dynamicSize', node, tensorMap, context);
                const clearAfterRead = (0, $l8IRh.getParamValue)('clearAfterRead', node, tensorMap, context);
                const identicalElementShapes = (0, $l8IRh.getParamValue)('identicalElementShapes', node, tensorMap, context);
                const name = (0, $l8IRh.getParamValue)('name', node, tensorMap, context);
                const tensorArray = new (0, $a6zRb.TensorArray)(name, dtype, size, elementShape, identicalElementShapes, dynamicSize, clearAfterRead);
                context.addTensorArray(tensorArray);
                return [
                    tensorArray.idTensor,
                    (0, $j7yUF.scalar)(1.0)
                ];
            }
        case 'TensorArrayWriteV3':
            {
                const id = (0, $l8IRh.getParamValue)('tensorArrayId', node, tensorMap, context);
                const index = (0, $l8IRh.getParamValue)('index', node, tensorMap, context);
                const writeTensor = (0, $l8IRh.getParamValue)('tensor', node, tensorMap, context);
                const writeTensorArray = context.getTensorArray(id.id);
                writeTensorArray.write(index, writeTensor);
                return [
                    writeTensorArray.idTensor
                ];
            }
        case 'TensorArrayReadV3':
            {
                const readId = (0, $l8IRh.getParamValue)('tensorArrayId', node, tensorMap, context);
                const readIndex = (0, $l8IRh.getParamValue)('index', node, tensorMap, context);
                const readTensorArray = context.getTensorArray(readId.id);
                return [
                    readTensorArray.read(readIndex)
                ];
            }
        case 'TensorArrayGatherV3':
            {
                const gatherId = (0, $l8IRh.getParamValue)('tensorArrayId', node, tensorMap, context);
                const gatherIndices = (0, $l8IRh.getParamValue)('indices', node, tensorMap, context);
                const gatherDtype = (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context);
                const gatherTensorArray = context.getTensorArray(gatherId.id);
                return [
                    gatherTensorArray.gather(gatherIndices, gatherDtype)
                ];
            }
        case 'TensorArrayScatterV3':
            {
                const scatterId = (0, $l8IRh.getParamValue)('tensorArrayId', node, tensorMap, context);
                const scatterIndices = (0, $l8IRh.getParamValue)('indices', node, tensorMap, context);
                const scatterTensor = (0, $l8IRh.getParamValue)('tensor', node, tensorMap, context);
                const scatterTensorArray = context.getTensorArray(scatterId.id);
                scatterTensorArray.scatter(scatterIndices, scatterTensor);
                return [
                    scatterTensorArray.idTensor
                ];
            }
        case 'TensorArrayConcatV3':
            {
                const concatId = (0, $l8IRh.getParamValue)('tensorArrayId', node, tensorMap, context);
                const concatTensorArray = context.getTensorArray(concatId.id);
                const concatDtype = (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context);
                return [
                    concatTensorArray.concat(concatDtype)
                ];
            }
        case 'TensorArraySplitV3':
            {
                const splitId = (0, $l8IRh.getParamValue)('tensorArrayId', node, tensorMap, context);
                const splitTensor = (0, $l8IRh.getParamValue)('tensor', node, tensorMap, context);
                const lengths = (0, $l8IRh.getParamValue)('lengths', node, tensorMap, context);
                const splitTensorArray = context.getTensorArray(splitId.id);
                splitTensorArray.split(lengths, splitTensor);
                return [
                    splitTensorArray.idTensor
                ];
            }
        case 'TensorArraySizeV3':
            {
                const sizeId = (0, $l8IRh.getParamValue)('tensorArrayId', node, tensorMap, context);
                const sizeTensorArray = context.getTensorArray(sizeId.id);
                return [
                    (0, $j7yUF.scalar)(sizeTensorArray.size(), 'int32')
                ];
            }
        case 'TensorArrayCloseV3':
            {
                const closeId = (0, $l8IRh.getParamValue)('tensorArrayId', node, tensorMap, context);
                const closeTensorArray = context.getTensorArray(closeId.id);
                closeTensorArray.clearAndClose();
                return [
                    closeTensorArray.idTensor
                ];
            }
        case 'TensorListSetItem':
            {
                const idTensor = (0, $l8IRh.getParamValue)('tensorListId', node, tensorMap, context);
                const index = (0, $l8IRh.getParamValue)('index', node, tensorMap, context);
                const writeTensor = (0, $l8IRh.getParamValue)('tensor', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                tensorList.setItem(index, writeTensor);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListGetItem':
            {
                const idTensor = (0, $l8IRh.getParamValue)('tensorListId', node, tensorMap, context);
                const readIndex = (0, $l8IRh.getParamValue)('index', node, tensorMap, context);
                const elementShape = (0, $l8IRh.getParamValue)('elementShape', node, tensorMap, context);
                const elementDType = (0, $l8IRh.getParamValue)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.getItem(readIndex, elementShape, elementDType)
                ];
            }
        case 'TensorListScatterV2':
        case 'TensorListScatter':
            {
                const scatterIndices = (0, $l8IRh.getParamValue)('indices', node, tensorMap, context);
                const scatterTensor = (0, $l8IRh.getParamValue)('tensor', node, tensorMap, context);
                const elementShape = (0, $l8IRh.getParamValue)('elementShape', node, tensorMap, context);
                const numElements = (0, $l8IRh.getParamValue)('numElements', node, tensorMap, context);
                const tensorList = (0, $7eOpq.scatter)(scatterTensor, scatterIndices, elementShape, numElements);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListReserve':
        case 'EmptyTensorList':
            {
                const elementShape = (0, $l8IRh.getParamValue)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $l8IRh.getParamValue)('elementDType', node, tensorMap, context);
                let numElementsParam;
                if (node.op === 'TensorListReserve') numElementsParam = 'numElements';
                else numElementsParam = 'maxNumElements';
                const numElements = (0, $l8IRh.getParamValue)(numElementsParam, node, tensorMap, context);
                const maxNumElements = node.op === 'TensorListReserve' ? -1 : numElements;
                const tensorList = (0, $7eOpq.reserve)(elementShape, elementDtype, numElements, maxNumElements);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListGather':
            {
                const gatherId = (0, $l8IRh.getParamValue)('tensorListId', node, tensorMap, context);
                const gatherIndices = (0, $l8IRh.getParamValue)('indices', node, tensorMap, context);
                const elementShape = (0, $l8IRh.getParamValue)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $l8IRh.getParamValue)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(gatherId.id);
                return [
                    tensorList.gather(gatherIndices, elementDtype, elementShape)
                ];
            }
        case 'TensorListStack':
            {
                const idTensor = (0, $l8IRh.getParamValue)('tensorListId', node, tensorMap, context);
                const elementShape = (0, $l8IRh.getParamValue)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $l8IRh.getParamValue)('elementDType', node, tensorMap, context);
                const numElements = (0, $l8IRh.getParamValue)('numElements', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.stack(elementShape, elementDtype, numElements)
                ];
            }
        case 'TensorListFromTensor':
            {
                const tensor = (0, $l8IRh.getParamValue)('tensor', node, tensorMap, context);
                const elementShape = (0, $l8IRh.getParamValue)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $l8IRh.getParamValue)('elementDType', node, tensorMap, context);
                const tensorList = (0, $7eOpq.fromTensor)(tensor, elementShape, elementDtype);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListConcat':
        case 'TensorListConcatV2':
            {
                const concatId = (0, $l8IRh.getParamValue)('tensorListId', node, tensorMap, context);
                const tensorList = context.getTensorList(concatId.id);
                const concatDtype = (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context);
                const elementShape = (0, $l8IRh.getParamValue)('elementShape', node, tensorMap, context);
                return [
                    tensorList.concat(concatDtype, elementShape)
                ];
            }
        case 'TensorListPushBack':
            {
                const idTensor = (0, $l8IRh.getParamValue)('tensorListId', node, tensorMap, context);
                const writeTensor = (0, $l8IRh.getParamValue)('tensor', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                tensorList.pushBack(writeTensor);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListPopBack':
            {
                const idTensor = (0, $l8IRh.getParamValue)('tensorListId', node, tensorMap, context);
                const elementShape = (0, $l8IRh.getParamValue)('elementShape', node, tensorMap, context);
                const elementDType = (0, $l8IRh.getParamValue)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.popBack(elementShape, elementDType)
                ];
            }
        case 'TensorListSplit':
            {
                const splitTensor = (0, $l8IRh.getParamValue)('tensor', node, tensorMap, context);
                const elementShape = (0, $l8IRh.getParamValue)('elementShape', node, tensorMap, context);
                const lengths = (0, $l8IRh.getParamValue)('lengths', node, tensorMap, context);
                const tensorList = (0, $7eOpq.split)(splitTensor, lengths, elementShape);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListLength':
            {
                const idTensor = (0, $l8IRh.getParamValue)('tensorListId', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    (0, $j7yUF.scalar)(tensorList.size(), 'int32')
                ];
            }
        case 'TensorListResize':
            {
                const idTensor = (0, $l8IRh.getParamValue)('tensorListId', node, tensorMap, context);
                const size = (0, $l8IRh.getParamValue)('size', node, tensorMap, context);
                const srcTensorList = context.getTensorList(idTensor.id);
                const destTensorList = srcTensorList.resize(size);
                context.addTensorList(destTensorList);
                return [
                    destTensorList.idTensor
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $fa7da7f07f341763$export$2c04807512a22510 = 'control';

});
parcelRegister("a6zRb", function(module, exports) {

$parcel$export(module.exports, "TensorArray", () => $75b6474f03e3b9d7$export$854ca114072d2abc);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $6LWfo = parcelRequire("6LWfo");
var $9c0Qr = parcelRequire("9c0Qr");
var $eP0pM = parcelRequire("eP0pM");
var $j7yUF = parcelRequire("j7yUF");
var $kvpGg = parcelRequire("kvpGg");
var $iSKul = parcelRequire("iSKul");
var $ec8bD = parcelRequire("ec8bD");
var $kDeMO = parcelRequire("kDeMO");

var $fwATK = parcelRequire("fwATK");
class $75b6474f03e3b9d7$export$854ca114072d2abc {
    constructor(name, dtype, maxSize, elementShape, identicalElementShapes, dynamicSize, clearAfterRead){
        this.name = name;
        this.dtype = dtype;
        this.maxSize = maxSize;
        this.elementShape = elementShape;
        this.identicalElementShapes = identicalElementShapes;
        this.dynamicSize = dynamicSize;
        this.clearAfterRead = clearAfterRead;
        this.tensors = [];
        this.closed_ = false;
        this.idTensor = (0, $j7yUF.scalar)(0);
        (0, $9c0Qr.keep)(this.idTensor);
    }
    get id() {
        return this.idTensor.id;
    }
    get closed() {
        return this.closed_;
    }
    /**
     * Dispose the tensors and idTensor and mark the TensoryArray as closed.
     */ clearAndClose(keepIds) {
        this.tensors.forEach((tensor)=>{
            if (keepIds == null || !keepIds.has(tensor.tensor.id)) tensor.tensor.dispose();
        });
        this.tensors = [];
        this.closed_ = true;
        this.idTensor.dispose();
    }
    size() {
        return this.tensors.length;
    }
    /**
     * Read the value at location index in the TensorArray.
     * @param index Number the index to read from.
     */ read(index) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (index < 0 || index >= this.size()) throw new Error(`Tried to read from index ${index}, but array size is: ${this.size()}`);
        const tensorWithState = this.tensors[index];
        if (tensorWithState.cleared) throw new Error(`TensorArray ${this.name}: Could not read index ${index} twice because it was cleared after a previous read ` + `(perhaps try setting clear_after_read = false?).`);
        if (this.clearAfterRead) tensorWithState.cleared = true;
        tensorWithState.read = true;
        return tensorWithState.tensor;
    }
    /**
     * Helper method to read multiple tensors from the specified indices.
     */ readMany(indices) {
        return indices.map((index)=>this.read(index));
    }
    /**
     * Write value into the index of the TensorArray.
     * @param index number the index to write to.
     * @param tensor
     */ write(index, tensor) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (index < 0 || !this.dynamicSize && index >= this.maxSize) throw new Error(`Tried to write to index ${index}, but array is not resizeable and size is: ${this.maxSize}`);
        const t = this.tensors[index] || {};
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index},
          because the value dtype is ${tensor.dtype}, but TensorArray dtype is ${this.dtype}.`);
        // Set the shape for the first time write to unknow shape tensor array
        if (this.size() === 0 && (this.elementShape == null || this.elementShape.length === 0)) this.elementShape = tensor.shape;
        (0, $fwATK.assertShapesMatchAllowUndefinedSize)(this.elementShape, tensor.shape, `TensorArray ${this.name}: Could not write to TensorArray index ${index}.`);
        if (t.read) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index}, because it has already been read.`);
        if (t.written) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index}, because it has already been written.`);
        t.tensor = tensor;
        (0, $9c0Qr.keep)(tensor);
        t.written = true;
        this.tensors[index] = t;
    }
    /**
     * Helper method to write multiple tensors to the specified indices.
     */ writeMany(indices, tensors) {
        if (indices.length !== tensors.length) throw new Error(`TensorArray ${this.name}: could not write multiple tensors,` + `because the index size: ${indices.length} is not the same as tensors size: ${tensors.length}.`);
        indices.forEach((i, index)=>this.write(i, tensors[index]));
    }
    /**
     * Return selected values in the TensorArray as a packed Tensor. All of
     * selected values must have been written and their shapes must all match.
     * @param [indices] number[] Optional. Taking values in [0, max_value). If the
     *    TensorArray is not dynamic, max_value=size(). If not specified returns
     *    all tensors in the original order.
     * @param [dtype]
     */ gather(indices, dtype) {
        if (!!dtype && dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but gather requested dtype ${dtype}`);
        if (!indices) {
            indices = [];
            for(let i = 0; i < this.size(); i++)indices.push(i);
        } else indices = indices.slice(0, this.size());
        if (indices.length === 0) return (0, $ec8bD.tensor)([], [
            0
        ].concat(this.elementShape));
        // Read all the PersistentTensors into a vector to keep track of
        // their memory.
        const tensors = this.readMany(indices);
        (0, $fwATK.assertShapesMatchAllowUndefinedSize)(this.elementShape, tensors[0].shape, 'TensorArray shape mismatch: ');
        return (0, $iSKul.stack)(tensors, 0);
    }
    /**
     * Return the values in the TensorArray as a concatenated Tensor.
     */ concat(dtype) {
        if (!!dtype && dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but concat requested dtype ${dtype}`);
        if (this.size() === 0) return (0, $ec8bD.tensor)([], [
            0
        ].concat(this.elementShape));
        const indices = [];
        for(let i = 0; i < this.size(); i++)indices.push(i);
        // Collect all the tensors from the tensors array.
        const tensors = this.readMany(indices);
        (0, $fwATK.assertShapesMatchAllowUndefinedSize)(this.elementShape, tensors[0].shape, `TensorArray shape mismatch: tensor array shape (${this.elementShape}) vs first tensor shape (${tensors[0].shape})`);
        return (0, $6LWfo.concat)(tensors, 0);
    }
    /**
     * Scatter the values of a Tensor in specific indices of a TensorArray.
     * @param indices nummber[] values in [0, max_value). If the
     *    TensorArray is not dynamic, max_value=size().
     * @param tensor Tensor input tensor.
     */ scatter(indices, tensor) {
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${tensor.dtype}`);
        if (indices.length !== tensor.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${indices.length} vs. ${tensor.shape[0]}`);
        const maxIndex = Math.max(...indices);
        if (!this.dynamicSize && maxIndex >= this.maxSize) throw new Error(`Max index must be < array size (${maxIndex}  vs. ${this.maxSize})`);
        this.writeMany(indices, (0, $kDeMO.unstack)(tensor, 0));
    }
    /**
     * Split the values of a Tensor into the TensorArray.
     * @param length number[] with the lengths to use when splitting value along
     *    its first dimension.
     * @param tensor Tensor, the tensor to split.
     */ split(length, tensor) {
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${tensor.dtype}`);
        let totalLength = 0;
        const cumulativeLengths = length.map((len)=>{
            totalLength += len;
            return totalLength;
        });
        if (totalLength !== tensor.shape[0]) throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${totalLength}, and tensor's shape is: ${tensor.shape}`);
        if (!this.dynamicSize && length.length !== this.maxSize) throw new Error(`TensorArray's size is not equal to the size of lengths (${this.maxSize} vs. ${length.length}), ` + 'and the TensorArray is not marked as dynamically resizeable');
        const elementPerRow = totalLength === 0 ? 0 : tensor.size / totalLength;
        const tensors = [];
        (0, $9c0Qr.tidy)(()=>{
            tensor = (0, $eP0pM.reshape)(tensor, [
                1,
                totalLength,
                elementPerRow
            ]);
            for(let i = 0; i < length.length; ++i){
                const previousLength = i === 0 ? 0 : cumulativeLengths[i - 1];
                const indices = [
                    0,
                    previousLength,
                    0
                ];
                const sizes = [
                    1,
                    length[i],
                    elementPerRow
                ];
                tensors[i] = (0, $eP0pM.reshape)((0, $kvpGg.slice)(tensor, indices, sizes), this.elementShape);
            }
            return tensors;
        });
        const indices = [];
        for(let i = 0; i < length.length; i++)indices[i] = i;
        this.writeMany(indices, tensors);
    }
}

});
parcelRegister("fwATK", function(module, exports) {

$parcel$export(module.exports, "assertShapesMatchAllowUndefinedSize", () => $b4d677611f6747a7$export$c20af1b3c2621826);
$parcel$export(module.exports, "inferElementShape", () => $b4d677611f6747a7$export$48aa6d00714ed79b);
$parcel$export(module.exports, "mergeElementShape", () => $b4d677611f6747a7$export$455cf61aa434d74b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * This differs from util.assertShapesMatch in that it allows values of
 * negative one, an undefined size of a dimensinon, in a shape to match
 * anything.
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
function $b4d677611f6747a7$export$c20af1b3c2621826(shapeA, shapeB, errorMessagePrefix = '') {
    // constant shape means unknown rank
    if (typeof shapeA === 'number' || typeof shapeB === 'number') return;
    (0, $wx9lK).assert(shapeA.length === shapeB.length, ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
    for(let i = 0; i < shapeA.length; i++){
        const dim0 = shapeA[i];
        const dim1 = shapeB[i];
        (0, $wx9lK).assert(dim0 < 0 || dim1 < 0 || dim0 === dim1, ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
    }
}
function $b4d677611f6747a7$export$caa10238f73d8dc2(elementShape) {
    if (typeof elementShape === 'number' || elementShape.some((dim)=>dim < 0)) return false;
    return true;
}
function $b4d677611f6747a7$export$48aa6d00714ed79b(listElementShape, tensors, elementShape) {
    let partialShape = $b4d677611f6747a7$export$455cf61aa434d74b(listElementShape, elementShape);
    const notfullDefinedShape = !$b4d677611f6747a7$export$caa10238f73d8dc2(partialShape);
    if (notfullDefinedShape && tensors.length === 0) throw new Error(`Tried to calculate elements of an empty list` + ` with non-fully-defined elementShape: ${partialShape}`);
    if (notfullDefinedShape) tensors.forEach((tensor)=>{
        partialShape = $b4d677611f6747a7$export$455cf61aa434d74b(tensor.shape, partialShape);
    });
    if (!$b4d677611f6747a7$export$caa10238f73d8dc2(partialShape)) throw new Error(`Non-fully-defined elementShape: ${partialShape}`);
    return partialShape;
}
function $b4d677611f6747a7$export$455cf61aa434d74b(elementShapeA, elementShapeB) {
    if (typeof elementShapeA === 'number') return elementShapeB;
    if (typeof elementShapeB === 'number') return elementShapeA;
    if (elementShapeA.length !== elementShapeB.length) throw new Error(`Incompatible ranks during merge: ${elementShapeA} vs. ${elementShapeB}`);
    const result = [];
    for(let i = 0; i < elementShapeA.length; ++i){
        const dim0 = elementShapeA[i];
        const dim1 = elementShapeB[i];
        if (dim0 >= 0 && dim1 >= 0 && dim0 !== dim1) throw new Error(`Incompatible shape during merge: ${elementShapeA} vs. ${elementShapeB}`);
        result[i] = dim0 >= 0 ? dim0 : dim1;
    }
    return result;
}

});


parcelRegister("7eOpq", function(module, exports) {

$parcel$export(module.exports, "fromTensor", () => $5450f16cd40fe1a4$export$1bc9ee297bacb6e5);
$parcel$export(module.exports, "reserve", () => $5450f16cd40fe1a4$export$12d6b2bf497a6811);
$parcel$export(module.exports, "scatter", () => $5450f16cd40fe1a4$export$c97954fff4307550);
$parcel$export(module.exports, "split", () => $5450f16cd40fe1a4$export$65980d18b75784e2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $6LWfo = parcelRequire("6LWfo");
var $9c0Qr = parcelRequire("9c0Qr");
var $eP0pM = parcelRequire("eP0pM");
var $j7yUF = parcelRequire("j7yUF");
var $kvpGg = parcelRequire("kvpGg");
var $iSKul = parcelRequire("iSKul");
var $ec8bD = parcelRequire("ec8bD");
var $kDeMO = parcelRequire("kDeMO");

var $fwATK = parcelRequire("fwATK");
class $5450f16cd40fe1a4$export$97d48a41015c8fa8 {
    /**
     *
     * @param tensors list of tensors
     * @param elementShape shape of each tensor, this can be a single number (any
     * shape is allowed) or partial shape (dim = -1).
     * @param elementDtype data type of each tensor
     * @param maxNumElements The maximum allowed size of `tensors`. Defaults to -1
     *   meaning that the size of `tensors` is unbounded.
     */ constructor(tensors, elementShape, elementDtype, maxNumElements = -1){
        this.tensors = tensors;
        this.elementShape = elementShape;
        this.elementDtype = elementDtype;
        if (tensors != null) tensors.forEach((tensor)=>{
            if (elementDtype !== tensor.dtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${tensor.dtype}`);
            (0, $fwATK.assertShapesMatchAllowUndefinedSize)(elementShape, tensor.shape, 'TensorList shape mismatch: ');
            (0, $9c0Qr.keep)(tensor);
        });
        this.idTensor = (0, $j7yUF.scalar)(0);
        this.maxNumElements = maxNumElements;
        (0, $9c0Qr.keep)(this.idTensor);
    }
    get id() {
        return this.idTensor.id;
    }
    /**
     * Get a new TensorList containing a copy of the underlying tensor container.
     */ copy() {
        return new $5450f16cd40fe1a4$export$97d48a41015c8fa8([
            ...this.tensors
        ], this.elementShape, this.elementDtype);
    }
    /**
     * Dispose the tensors and idTensor and clear the tensor list.
     */ clearAndClose(keepIds) {
        this.tensors.forEach((tensor)=>{
            if (keepIds == null || !keepIds.has(tensor.id)) tensor.dispose();
        });
        this.tensors.length = 0;
        this.idTensor.dispose();
    }
    /**
     * The size of the tensors in the tensor list.
     */ size() {
        return this.tensors.length;
    }
    /**
     * Return a tensor that stacks a list of rank-R tf.Tensors into one rank-(R+1)
     * tf.Tensor.
     * @param elementShape shape of each tensor
     * @param elementDtype data type of each tensor
     * @param numElements the number of elements to stack
     */ stack(elementShape, elementDtype, numElements = -1) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (numElements !== -1 && this.tensors.length !== numElements) throw new Error(`Operation expected a list with ${numElements} elements but got a list with ${this.tensors.length} elements.`);
        (0, $fwATK.assertShapesMatchAllowUndefinedSize)(elementShape, this.elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $fwATK.inferElementShape)(this.elementShape, this.tensors, elementShape);
        return (0, $9c0Qr.tidy)(()=>{
            const reshapedTensors = this.tensors.map((tensor)=>(0, $eP0pM.reshape)(tensor, outputElementShape));
            return (0, $iSKul.stack)(reshapedTensors, 0);
        });
    }
    /**
     * Pop a tensor from the end of the list.
     * @param elementShape shape of the tensor
     * @param elementDtype data type of the tensor
     */ popBack(elementShape, elementDtype) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (this.size() === 0) throw new Error('Trying to pop from an empty list.');
        const outputElementShape = (0, $fwATK.inferElementShape)(this.elementShape, this.tensors, elementShape);
        const tensor = this.tensors.pop();
        tensor.kept = false;
        (0, $fwATK.assertShapesMatchAllowUndefinedSize)(tensor.shape, elementShape, 'TensorList shape mismatch: ');
        return (0, $eP0pM.reshape)(tensor, outputElementShape);
    }
    /**
     * Push a tensor to the end of the list.
     * @param tensor Tensor to be pushed.
     */ pushBack(tensor) {
        if (tensor.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${this.elementDtype}`);
        (0, $fwATK.assertShapesMatchAllowUndefinedSize)(tensor.shape, this.elementShape, 'TensorList shape mismatch: ');
        if (this.maxNumElements === this.size()) throw new Error(`Trying to push element into a full list.`);
        (0, $9c0Qr.keep)(tensor);
        this.tensors.push(tensor);
    }
    /**
     * Update the size of the list.
     * @param size the new size of the list.
     */ resize(size) {
        if (size < 0) throw new Error(`TensorListResize expects size to be non-negative. Got: ${size}`);
        if (this.maxNumElements !== -1 && size > this.maxNumElements) throw new Error(`TensorListResize input size ${size} is greater maxNumElement ${this.maxNumElements}.`);
        const destTensorList = new $5450f16cd40fe1a4$export$97d48a41015c8fa8([], this.elementShape, this.elementDtype, this.maxNumElements);
        destTensorList.tensors.length = size;
        for(let i = 0; i < Math.min(this.tensors.length, size); ++i)destTensorList.tensors[i] = this.tensors[i];
        return destTensorList;
    }
    /**
     * Retrieve the element at the provided index
     * @param elementShape shape of the tensor
     * @param elementDtype dtype of the tensor
     * @param elementIndex index of the tensor
     */ getItem(elementIndex, elementShape, elementDtype) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (elementIndex < 0 || elementIndex > this.tensors.length) throw new Error(`Trying to access element ${elementIndex} in a list with ${this.tensors.length} elements.`);
        if (this.tensors[elementIndex] == null) throw new Error(`element at index ${elementIndex} is null.`);
        (0, $fwATK.assertShapesMatchAllowUndefinedSize)(this.tensors[elementIndex].shape, elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $fwATK.inferElementShape)(this.elementShape, this.tensors, elementShape);
        return (0, $eP0pM.reshape)(this.tensors[elementIndex], outputElementShape);
    }
    /**
     * Set the tensor at the index
     * @param elementIndex index of the tensor
     * @param tensor the tensor to be inserted into the list
     */ setItem(elementIndex, tensor) {
        if (tensor.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${this.elementDtype}`);
        if (elementIndex < 0 || this.maxNumElements !== -1 && elementIndex >= this.maxNumElements) throw new Error(`Trying to set element ${elementIndex} in a list with max ${this.maxNumElements} elements.`);
        (0, $fwATK.assertShapesMatchAllowUndefinedSize)(this.elementShape, tensor.shape, 'TensorList shape mismatch: ');
        (0, $9c0Qr.keep)(tensor);
        // dispose the previous value if it is replacing.
        if (this.tensors[elementIndex] != null) this.tensors[elementIndex].kept = false;
        this.tensors[elementIndex] = tensor;
    }
    /**
     * Return selected values in the TensorList as a stacked Tensor. All of
     * selected values must have been written and their shapes must all match.
     * @param indices indices of tensors to gather
     * @param elementDtype output tensor dtype
     * @param elementShape output tensor element shape
     */ gather(indices, elementDtype, elementShape) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        (0, $fwATK.assertShapesMatchAllowUndefinedSize)(this.elementShape, elementShape, 'TensorList shape mismatch: ');
        // When indices is greater than the size of the list, indices beyond the
        // size of the list are ignored.
        indices = indices.slice(0, this.size());
        const outputElementShape = (0, $fwATK.inferElementShape)(this.elementShape, this.tensors, elementShape);
        if (indices.length === 0) return (0, $ec8bD.tensor)([], [
            0
        ].concat(outputElementShape));
        return (0, $9c0Qr.tidy)(()=>{
            const tensors = indices.map((i)=>(0, $eP0pM.reshape)(this.tensors[i], outputElementShape));
            return (0, $iSKul.stack)(tensors, 0);
        });
    }
    /**
     * Return the values in the TensorList as a concatenated Tensor.
     * @param elementDtype output tensor dtype
     * @param elementShape output tensor element shape
     */ concat(elementDtype, elementShape) {
        if (!!elementDtype && elementDtype !== this.elementDtype) throw new Error(`TensorList dtype is ${this.elementDtype} but concat requested dtype ${elementDtype}`);
        (0, $fwATK.assertShapesMatchAllowUndefinedSize)(this.elementShape, elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $fwATK.inferElementShape)(this.elementShape, this.tensors, elementShape);
        if (this.size() === 0) return (0, $ec8bD.tensor)([], [
            0
        ].concat(outputElementShape));
        return (0, $9c0Qr.tidy)(()=>{
            const tensors = this.tensors.map((t)=>(0, $eP0pM.reshape)(t, outputElementShape));
            return (0, $6LWfo.concat)(tensors, 0);
        });
    }
}
function $5450f16cd40fe1a4$export$1bc9ee297bacb6e5(tensor, elementShape, elementDtype) {
    const dtype = tensor.dtype;
    if (tensor.shape.length < 1) throw new Error(`Tensor must be at least a vector, but saw shape: ${tensor.shape}`);
    if (tensor.dtype !== elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${elementDtype}`);
    const tensorElementShape = tensor.shape.slice(1);
    (0, $fwATK.assertShapesMatchAllowUndefinedSize)(tensorElementShape, elementShape, 'TensorList shape mismatch: ');
    const tensorList = (0, $kDeMO.unstack)(tensor);
    return new $5450f16cd40fe1a4$export$97d48a41015c8fa8(tensorList, elementShape, dtype);
}
function $5450f16cd40fe1a4$export$12d6b2bf497a6811(elementShape, elementDtype, numElements, maxNumElements) {
    return new $5450f16cd40fe1a4$export$97d48a41015c8fa8([], elementShape, elementDtype, maxNumElements);
}
function $5450f16cd40fe1a4$export$c97954fff4307550(tensor, indices, elementShape, numElements) {
    if (indices.length !== tensor.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${indices.length} vs. ${tensor.shape[0]}`);
    const maxIndex = Math.max(...indices);
    if (numElements != null && numElements !== -1 && maxIndex >= numElements) throw new Error(`Max index must be < array size (${maxIndex}  vs. ${numElements})`);
    const list = new $5450f16cd40fe1a4$export$97d48a41015c8fa8([], elementShape, tensor.dtype, numElements);
    const tensors = (0, $kDeMO.unstack)(tensor, 0);
    indices.forEach((value, index)=>{
        list.setItem(value, tensors[index]);
    });
    return list;
}
function $5450f16cd40fe1a4$export$65980d18b75784e2(tensor, length, elementShape) {
    let totalLength = 0;
    const cumulativeLengths = length.map((len)=>{
        totalLength += len;
        return totalLength;
    });
    if (totalLength !== tensor.shape[0]) throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${totalLength}, and tensor's shape is: ${tensor.shape}`);
    const shapeWithoutFirstDim = tensor.shape.slice(1);
    const outputElementShape = (0, $fwATK.mergeElementShape)(shapeWithoutFirstDim, elementShape);
    const elementPerRow = totalLength === 0 ? 0 : tensor.size / totalLength;
    const tensors = (0, $9c0Qr.tidy)(()=>{
        const tensors = [];
        tensor = (0, $eP0pM.reshape)(tensor, [
            1,
            totalLength,
            elementPerRow
        ]);
        for(let i = 0; i < length.length; ++i){
            const previousLength = i === 0 ? 0 : cumulativeLengths[i - 1];
            const indices = [
                0,
                previousLength,
                0
            ];
            const sizes = [
                1,
                length[i],
                elementPerRow
            ];
            tensors[i] = (0, $eP0pM.reshape)((0, $kvpGg.slice)(tensor, indices, sizes), outputElementShape);
        }
        tensor.dispose();
        return tensors;
    });
    const list = new $5450f16cd40fe1a4$export$97d48a41015c8fa8([], elementShape, tensor.dtype, length.length);
    for(let i = 0; i < tensors.length; i++)list.setItem(i, tensors[i]);
    return list;
}

});


parcelRegister("bhLqU", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $837613758233f074$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
function $837613758233f074$var$fusedConvAndDepthWiseParams(node, tensorMap, context) {
    const [extraOp, activationFunc] = (0, $l8IRh.getParamValue)('fusedOps', node, tensorMap, context);
    const isBiasAdd = extraOp === 'biasadd';
    const noBiasAdd = !isBiasAdd;
    const isPrelu = activationFunc === 'prelu';
    const isBatchNorm = extraOp === 'fusedbatchnorm';
    const numArgs = (0, $l8IRh.getParamValue)('numArgs', node, tensorMap, context);
    if (isBiasAdd) {
        if (isPrelu && numArgs !== 2) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
        if (!isPrelu && isBiasAdd && numArgs !== 1) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd must have one extra argument: bias.");
    }
    if (isBatchNorm) throw new Error('FusedConv2d and DepthwiseConv2d with FusedBatchNorm is not supported');
    const stride = (0, $l8IRh.getParamValue)('strides', node, tensorMap, context);
    const pad = (0, $l8IRh.getPadding)(node, tensorMap, context);
    const dataFormat = (0, $l8IRh.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
    const dilations = (0, $l8IRh.getParamValue)('dilations', node, tensorMap, context);
    let [biasArg, preluArg] = (0, $l8IRh.getParamValue)('args', node, tensorMap, context);
    if (noBiasAdd) {
        preluArg = biasArg;
        biasArg = undefined;
    }
    const leakyreluAlpha = (0, $l8IRh.getParamValue)('leakyreluAlpha', node, tensorMap, context);
    return {
        stride: stride,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        biasArg: biasArg,
        preluArg: preluArg,
        activationFunc: activationFunc,
        leakyreluAlpha: leakyreluAlpha
    };
}
const $837613758233f074$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'Conv1D':
            {
                const stride = (0, $l8IRh.getParamValue)('stride', node, tensorMap, context);
                const pad = (0, $l8IRh.getParamValue)('pad', node, tensorMap, context);
                const dataFormat = (0, $l8IRh.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilation = (0, $l8IRh.getParamValue)('dilation', node, tensorMap, context);
                return [
                    ops.conv1d((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('filter', node, tensorMap, context), stride, pad, dataFormat, dilation)
                ];
            }
        case 'Conv2D':
            {
                const stride = (0, $l8IRh.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $l8IRh.getPadding)(node, tensorMap, context);
                const dataFormat = (0, $l8IRh.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilations = (0, $l8IRh.getParamValue)('dilations', node, tensorMap, context);
                return [
                    ops.conv2d((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2]
                    ])
                ];
            }
        case '_FusedConv2D':
            {
                const { stride: stride, pad: pad, dataFormat: dataFormat, dilations: dilations, biasArg: biasArg, preluArg: preluArg, activationFunc: activationFunc, leakyreluAlpha: leakyreluAlpha } = $837613758233f074$var$fusedConvAndDepthWiseParams(node, tensorMap, context);
                return [
                    ops.fused.conv2d({
                        x: (0, $l8IRh.getParamValue)('x', node, tensorMap, context),
                        filter: (0, $l8IRh.getParamValue)('filter', node, tensorMap, context),
                        strides: [
                            stride[1],
                            stride[2]
                        ],
                        pad: pad,
                        dataFormat: dataFormat,
                        dilations: [
                            dilations[1],
                            dilations[2]
                        ],
                        bias: biasArg,
                        activation: activationFunc,
                        preluActivationWeights: preluArg,
                        leakyreluAlpha: leakyreluAlpha
                    })
                ];
            }
        case 'FusedDepthwiseConv2dNative':
            {
                const { stride: stride, pad: pad, dataFormat: dataFormat, dilations: dilations, biasArg: biasArg, preluArg: preluArg, activationFunc: activationFunc, leakyreluAlpha: leakyreluAlpha } = $837613758233f074$var$fusedConvAndDepthWiseParams(node, tensorMap, context);
                return [
                    ops.fused.depthwiseConv2d({
                        x: (0, $l8IRh.getParamValue)('x', node, tensorMap, context),
                        filter: (0, $l8IRh.getParamValue)('filter', node, tensorMap, context),
                        strides: [
                            stride[1],
                            stride[2]
                        ],
                        pad: pad,
                        dataFormat: dataFormat,
                        dilations: [
                            dilations[1],
                            dilations[2]
                        ],
                        bias: biasArg,
                        activation: activationFunc,
                        preluActivationWeights: preluArg,
                        leakyreluAlpha: leakyreluAlpha
                    })
                ];
            }
        case 'Conv2DBackpropInput':
        case 'Conv2dTranspose':
            {
                const shape = (0, $l8IRh.getParamValue)('outputShape', node, tensorMap, context);
                const stride = (0, $l8IRh.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $l8IRh.getPadding)(node, tensorMap, context);
                return [
                    ops.conv2dTranspose((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('filter', node, tensorMap, context), shape, [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'DepthwiseConv2dNative':
        case 'DepthwiseConv2d':
            {
                const stride = (0, $l8IRh.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $l8IRh.getPadding)(node, tensorMap, context);
                const dilations = (0, $l8IRh.getParamValue)('dilations', node, tensorMap, context);
                const dataFormat = (0, $l8IRh.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                return [
                    ops.depthwiseConv2d((0, $l8IRh.getParamValue)('input', node, tensorMap, context), (0, $l8IRh.getParamValue)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2]
                    ])
                ];
            }
        case 'Conv3D':
            {
                const stride = (0, $l8IRh.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $l8IRh.getParamValue)('pad', node, tensorMap, context);
                const dataFormat = (0, $l8IRh.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilations = (0, $l8IRh.getParamValue)('dilations', node, tensorMap, context);
                return [
                    ops.conv3d((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2],
                        dilations[3]
                    ])
                ];
            }
        case 'AvgPool':
            {
                const stride = (0, $l8IRh.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $l8IRh.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $l8IRh.getParamValue)('kernelSize', node, tensorMap, context);
                return [
                    ops.avgPool((0, $l8IRh.getParamValue)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2]
                    ], [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'MaxPool':
            {
                const stride = (0, $l8IRh.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $l8IRh.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $l8IRh.getParamValue)('kernelSize', node, tensorMap, context);
                return [
                    ops.maxPool((0, $l8IRh.getParamValue)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2]
                    ], [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'MaxPoolWithArgmax':
            {
                const stride = (0, $l8IRh.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $l8IRh.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $l8IRh.getParamValue)('kernelSize', node, tensorMap, context);
                const includeBatchInIndex = (0, $l8IRh.getParamValue)('includeBatchInIndex', node, tensorMap, context);
                const { result: result, indexes: indexes } = ops.maxPoolWithArgmax((0, $l8IRh.getParamValue)('x', node, tensorMap, context), [
                    kernelSize[1],
                    kernelSize[2]
                ], [
                    stride[1],
                    stride[2]
                ], pad, includeBatchInIndex);
                return [
                    result,
                    indexes
                ];
            }
        case 'AvgPool3D':
            {
                const stride = (0, $l8IRh.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $l8IRh.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $l8IRh.getParamValue)('kernelSize', node, tensorMap, context);
                return [
                    ops.avgPool3d((0, $l8IRh.getParamValue)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2],
                        kernelSize[3]
                    ], [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad)
                ];
            }
        case 'MaxPool3D':
            {
                const stride = (0, $l8IRh.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $l8IRh.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $l8IRh.getParamValue)('kernelSize', node, tensorMap, context);
                return [
                    ops.maxPool3d((0, $l8IRh.getParamValue)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2],
                        kernelSize[3]
                    ], [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad)
                ];
            }
        case 'Dilation2D':
            {
                const strides = (0, $l8IRh.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $l8IRh.getParamValue)('pad', node, tensorMap, context);
                const dilations = (0, $l8IRh.getParamValue)('dilations', node, tensorMap, context);
                // strides: [1, stride_height, stride_width, 1].
                const strideHeight = strides[1];
                const strideWidth = strides[2];
                // dilations: [1, dilation_height, dilation_width, 1].
                const dilationHeight = dilations[1];
                const dilationWidth = dilations[2];
                return [
                    ops.dilation2d((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('filter', node, tensorMap, context), [
                        strideHeight,
                        strideWidth
                    ], pad, [
                        dilationHeight,
                        dilationWidth
                    ], 'NHWC' /* dataFormat */ )
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $837613758233f074$export$2c04807512a22510 = 'convolution';

});

parcelRegister("f0AFT", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $aed34def0d01978c$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $aed34def0d01978c$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'Fill':
            {
                const shape = (0, $l8IRh.getParamValue)('shape', node, tensorMap, context);
                const dtype = (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context);
                const value = (0, $l8IRh.getParamValue)('value', node, tensorMap, context);
                return [
                    ops.fill(shape, value, dtype)
                ];
            }
        case 'LinSpace':
            {
                const start = (0, $l8IRh.getParamValue)('start', node, tensorMap, context);
                const stop = (0, $l8IRh.getParamValue)('stop', node, tensorMap, context);
                const num = (0, $l8IRh.getParamValue)('num', node, tensorMap, context);
                return [
                    ops.linspace(start, stop, num)
                ];
            }
        case 'Multinomial':
            {
                const logits = (0, $l8IRh.getParamValue)('logits', node, tensorMap, context);
                const numSamples = (0, $l8IRh.getParamValue)('numSamples', node, tensorMap, context);
                const seed = (0, $l8IRh.getParamValue)('seed', node, tensorMap, context);
                return [
                    ops.multinomial(logits, numSamples, seed)
                ];
            }
        case 'OneHot':
            {
                const indices = (0, $l8IRh.getParamValue)('indices', node, tensorMap, context);
                const depth = (0, $l8IRh.getParamValue)('depth', node, tensorMap, context);
                const onValue = (0, $l8IRh.getParamValue)('onValue', node, tensorMap, context);
                const offValue = (0, $l8IRh.getParamValue)('offValue', node, tensorMap, context);
                const dtype = (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context);
                return [
                    ops.oneHot(indices, depth, onValue, offValue, dtype)
                ];
            }
        case 'Ones':
            return [
                ops.ones((0, $l8IRh.getParamValue)('shape', node, tensorMap, context), (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context))
            ];
        case 'OnesLike':
            return [
                ops.onesLike((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'RandomStandardNormal':
            return [
                ops.randomStandardNormal((0, $l8IRh.getParamValue)('shape', node, tensorMap, context), (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context), (0, $l8IRh.getParamValue)('seed', node, tensorMap, context))
            ];
        case 'RandomUniform':
            return [
                ops.randomUniform(// tslint:disable-next-line:no-any
                (0, $l8IRh.getParamValue)('shape', node, tensorMap, context), (0, $l8IRh.getParamValue)('minval', node, tensorMap, context), (0, $l8IRh.getParamValue)('maxval', node, tensorMap, context), (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context))
            ];
        case 'Range':
            {
                const start = (0, $l8IRh.getParamValue)('start', node, tensorMap, context);
                const stop = (0, $l8IRh.getParamValue)('stop', node, tensorMap, context);
                const step = (0, $l8IRh.getParamValue)('step', node, tensorMap, context);
                return [
                    ops.range(start, stop, step, (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context))
                ];
            }
        case 'TruncatedNormal':
            {
                const shape = (0, $l8IRh.getParamValue)('shape', node, tensorMap, context);
                const mean = (0, $l8IRh.getParamValue)('mean', node, tensorMap, context);
                const stdDev = (0, $l8IRh.getParamValue)('stdDev', node, tensorMap, context);
                const seed = (0, $l8IRh.getParamValue)('seed', node, tensorMap, context);
                return [
                    ops.truncatedNormal(shape, mean, stdDev, (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context), seed)
                ];
            }
        case 'Zeros':
            return [
                ops.zeros((0, $l8IRh.getParamValue)('shape', node, tensorMap, context), (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context))
            ];
        case 'ZerosLike':
            return [
                ops.zerosLike((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $aed34def0d01978c$export$2c04807512a22510 = 'creation';

});

parcelRegister("jojnZ", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $e1df4bd902dde9e4$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
function $e1df4bd902dde9e4$var$nmsParams(node, tensorMap, context) {
    const boxes = (0, $l8IRh.getParamValue)('boxes', node, tensorMap, context);
    const scores = (0, $l8IRh.getParamValue)('scores', node, tensorMap, context);
    const maxOutputSize = (0, $l8IRh.getParamValue)('maxOutputSize', node, tensorMap, context);
    const iouThreshold = (0, $l8IRh.getParamValue)('iouThreshold', node, tensorMap, context);
    const scoreThreshold = (0, $l8IRh.getParamValue)('scoreThreshold', node, tensorMap, context);
    const softNmsSigma = (0, $l8IRh.getParamValue)('softNmsSigma', node, tensorMap, context);
    return {
        boxes: boxes,
        scores: scores,
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
}
const $e1df4bd902dde9e4$export$7be88578e558e499 = async (node, tensorMap, context, resourceManager, ops = $1ShPG)=>{
    switch(node.op){
        case 'NonMaxSuppressionV5':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = $e1df4bd902dde9e4$var$nmsParams(node, tensorMap, context);
                const result = await ops.image.nonMaxSuppressionWithScoreAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
                return [
                    result.selectedIndices,
                    result.selectedScores
                ];
            }
        case 'NonMaxSuppressionV4':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = $e1df4bd902dde9e4$var$nmsParams(node, tensorMap, context);
                const padToMaxOutputSize = (0, $l8IRh.getParamValue)('padToMaxOutputSize', node, tensorMap, context);
                const result = await ops.image.nonMaxSuppressionPaddedAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
                return [
                    result.selectedIndices,
                    result.validOutputs
                ];
            }
        case 'NonMaxSuppressionV3':
        case 'NonMaxSuppressionV2':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = $e1df4bd902dde9e4$var$nmsParams(node, tensorMap, context);
                return [
                    await ops.image.nonMaxSuppressionAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold)
                ];
            }
        case 'Where':
            {
                const condition = ops.cast((0, $l8IRh.getParamValue)('condition', node, tensorMap, context), 'bool');
                const result = [
                    await ops.whereAsync(condition)
                ];
                condition.dispose();
                return result;
            }
        case 'ListDiff':
            return ops.setdiff1dAsync((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('y', node, tensorMap, context));
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $e1df4bd902dde9e4$export$2c04807512a22510 = 'dynamic';

});

parcelRegister("gGknH", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $c25060e4754c3bf7$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $c25060e4754c3bf7$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'LowerBound':
            {
                const sortedSequence = (0, $l8IRh.getParamValue)('sortedSequence', node, tensorMap, context);
                const values = (0, $l8IRh.getParamValue)('values', node, tensorMap, context);
                return [
                    ops.lowerBound(sortedSequence, values)
                ];
            }
        case 'TopKV2':
            {
                const x = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
                const k = (0, $l8IRh.getParamValue)('k', node, tensorMap, context);
                const sorted = (0, $l8IRh.getParamValue)('sorted', node, tensorMap, context);
                const result = ops.topk(x, k, sorted);
                return [
                    result.values,
                    result.indices
                ];
            }
        case 'UpperBound':
            {
                const sortedSequence = (0, $l8IRh.getParamValue)('sortedSequence', node, tensorMap, context);
                const values = (0, $l8IRh.getParamValue)('values', node, tensorMap, context);
                return [
                    ops.upperBound(sortedSequence, values)
                ];
            }
        case 'Unique':
            {
                const x = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
                const result = ops.unique(x);
                return [
                    result.values,
                    result.indices
                ];
            }
        case 'UniqueV2':
            {
                const x = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const result = ops.unique(x, axis);
                return [
                    result.values,
                    result.indices
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $c25060e4754c3bf7$export$2c04807512a22510 = 'evaluation';

});

parcelRegister("bsIvb", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $02274dbf9aa7a6af$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $02274dbf9aa7a6af$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'Const':
            return tensorMap[node.name];
        case 'PlaceholderWithDefault':
            const def = (0, $l8IRh.getParamValue)('default', node, tensorMap, context);
            return [
                (0, $l8IRh.getTensor)(node.name, tensorMap, context) || def
            ];
        case 'Placeholder':
            return [
                (0, $l8IRh.getTensor)(node.name, tensorMap, context)
            ];
        case 'Identity':
        case 'StopGradient':
        case 'FakeQuantWithMinMaxVars':
            {
                const data = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
                return [
                    (0, $l8IRh.cloneTensor)(data)
                ];
            }
        case 'IdentityN':
            return (0, $l8IRh.getParamValue)('x', node, tensorMap, context).map((t)=>(0, $l8IRh.cloneTensor)(t));
        case 'Snapshot':
            const snapshot = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
            return [
                (0, $l8IRh.cloneTensor)(snapshot)
            ];
        case 'Shape':
            return [
                ops.tensor1d((0, $l8IRh.getParamValue)('x', node, tensorMap, context).shape, 'int32')
            ];
        case 'ShapeN':
            return (0, $l8IRh.getParamValue)('x', node, tensorMap, context).map((t)=>ops.tensor1d(t.shape));
        case 'Size':
            return [
                ops.scalar((0, $l8IRh.getParamValue)('x', node, tensorMap, context).size, 'int32')
            ];
        case 'Rank':
            return [
                ops.scalar((0, $l8IRh.getParamValue)('x', node, tensorMap, context).rank, 'int32')
            ];
        case 'NoOp':
            return [
                ops.scalar(1)
            ];
        case 'Print':
            const input = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
            const data = (0, $l8IRh.getParamValue)('data', node, tensorMap, context);
            const message = (0, $l8IRh.getParamValue)('message', node, tensorMap, context);
            const summarize = (0, $l8IRh.getParamValue)('summarize', node, tensorMap, context);
            console.warn("The graph has a tf.print() operation,usually used for debugging, which slows down performance.");
            console.log(message);
            for(let i = 0; i < data.length; i++)console.log(Array.prototype.slice.call(data[i].dataSync()).slice(0, summarize));
            return [
                input
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $02274dbf9aa7a6af$export$2c04807512a22510 = 'graph';

});

parcelRegister("83zBs", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $5dda3896e902c614$export$7be88578e558e499);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dBmuL = parcelRequire("dBmuL");

var $l8IRh = parcelRequire("l8IRh");
const $5dda3896e902c614$export$7be88578e558e499 = async (node, tensorMap, context, resourceManager)=>{
    switch(node.op){
        case 'HashTable':
        case 'HashTableV2':
            {
                const keyDType = (0, $l8IRh.getParamValue)('keyDType', node, tensorMap, context);
                const valueDType = (0, $l8IRh.getParamValue)('valueDType', node, tensorMap, context);
                const hashTable = new (0, $dBmuL.HashTable)(keyDType, valueDType);
                resourceManager.addHashTable(node.name, hashTable);
                return [
                    hashTable.handle
                ];
            }
        case 'LookupTableImport':
        case 'LookupTableImportV2':
            {
                const handle = (0, $l8IRh.getParamValue)('tableHandle', node, tensorMap, context, resourceManager);
                const keys = (0, $l8IRh.getParamValue)('keys', node, tensorMap, context);
                const values = (0, $l8IRh.getParamValue)('values', node, tensorMap, context);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    await hashTable.import(keys, values)
                ];
            }
        case 'LookupTableFind':
        case 'LookupTableFindV2':
            {
                const handle = (0, $l8IRh.getParamValue)('tableHandle', node, tensorMap, context, resourceManager);
                const keys = (0, $l8IRh.getParamValue)('keys', node, tensorMap, context);
                const defaultValue = (0, $l8IRh.getParamValue)('defaultValue', node, tensorMap, context);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    await hashTable.find(keys, defaultValue)
                ];
            }
        case 'LookupTableSize':
        case 'LookupTableSizeV2':
            {
                const handle = (0, $l8IRh.getParamValue)('tableHandle', node, tensorMap, context, resourceManager);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    hashTable.tensorSize()
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $5dda3896e902c614$export$2c04807512a22510 = 'hash_table';

});
parcelRegister("dBmuL", function(module, exports) {

$parcel$export(module.exports, "HashTable", () => $9e702e2283a04172$export$b3bcf29b77543c46);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $9c0Qr = parcelRequire("9c0Qr");
var $j7yUF = parcelRequire("j7yUF");
var $iSKul = parcelRequire("iSKul");
var $kDeMO = parcelRequire("kDeMO");
var $wx9lK = parcelRequire("wx9lK");

var $j7yUF = parcelRequire("j7yUF");
class $9e702e2283a04172$export$b3bcf29b77543c46 {
    /**
     * Constructor of HashTable. Creates a hash table.
     *
     * @param keyDType `dtype` of the table keys.
     * @param valueDType `dtype` of the table values.
     */ constructor(keyDType, valueDType){
        this.keyDType = keyDType;
        this.valueDType = valueDType;
        this.handle = (0, $j7yUF.scalar)(0);
        // tslint:disable-next-line: no-any
        this.tensorMap = new Map();
        (0, $9c0Qr.keep)(this.handle);
    }
    get id() {
        return this.handle.id;
    }
    /**
     * Dispose the tensors and handle and clear the hashtable.
     */ clearAndClose() {
        this.tensorMap.forEach((value)=>value.dispose());
        this.tensorMap.clear();
        this.handle.dispose();
    }
    /**
     * The number of items in the hash table.
     */ size() {
        return this.tensorMap.size;
    }
    /**
     * The number of items in the hash table as a rank-0 tensor.
     */ tensorSize() {
        return $j7yUF.scalar(this.size(), 'int32');
    }
    /**
     * Replaces the contents of the table with the specified keys and values.
     * @param keys Keys to store in the hashtable.
     * @param values Values to store in the hashtable.
     */ async import(keys, values) {
        this.checkKeyAndValueTensor(keys, values);
        // We only store the primitive values of the keys, this allows lookup
        // to be O(1).
        const $keys = await keys.data();
        // Clear the hashTable before inserting new values.
        this.tensorMap.forEach((value)=>value.dispose());
        this.tensorMap.clear();
        return (0, $9c0Qr.tidy)(()=>{
            const $values = (0, $kDeMO.unstack)(values);
            const keysLength = $keys.length;
            const valuesLength = $values.length;
            (0, $wx9lK).assert(keysLength === valuesLength, ()=>`The number of elements doesn't match, keys has ` + `${keysLength} elements, the values has ${valuesLength} ` + `elements.`);
            for(let i = 0; i < keysLength; i++){
                const key = $keys[i];
                const value = $values[i];
                (0, $9c0Qr.keep)(value);
                this.tensorMap.set(key, value);
            }
            return this.handle;
        });
    }
    /**
     * Looks up keys in a hash table, outputs the corresponding values.
     *
     * Performs batch lookups, for every element in the key tensor, `find`
     * stacks the corresponding value into the return tensor.
     *
     * If an element is not present in the table, the given `defaultValue` is
     * used.
     *
     * @param keys Keys to look up. Must have the same type as the keys of the
     *     table.
     * @param defaultValue The scalar `defaultValue` is the value output for keys
     *     not present in the table. It must also be of the same type as the
     *     table values.
     */ async find(keys, defaultValue) {
        this.checkKeyAndValueTensor(keys, defaultValue);
        const $keys = await keys.data();
        return (0, $9c0Qr.tidy)(()=>{
            const result = [];
            for(let i = 0; i < $keys.length; i++){
                const key = $keys[i];
                const value = this.findWithDefault(key, defaultValue);
                result.push(value);
            }
            return (0, $iSKul.stack)(result);
        });
    }
    // tslint:disable-next-line: no-any
    findWithDefault(key, defaultValue) {
        const result = this.tensorMap.get(key);
        return result != null ? result : defaultValue;
    }
    checkKeyAndValueTensor(key, value) {
        if (key.dtype !== this.keyDType) throw new Error(`Expect key dtype ${this.keyDType}, but got ` + `${key.dtype}`);
        if (value.dtype !== this.valueDType) throw new Error(`Expect value dtype ${this.valueDType}, but got ` + `${value.dtype}`);
    }
}

});


parcelRegister("jT1Dw", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $e7a46c526fed1e39$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $e7a46c526fed1e39$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'ResizeBilinear':
            {
                const images = (0, $l8IRh.getParamValue)('images', node, tensorMap, context);
                const size = (0, $l8IRh.getParamValue)('size', node, tensorMap, context);
                const alignCorners = (0, $l8IRh.getParamValue)('alignCorners', node, tensorMap, context);
                const halfPixelCenters = (0, $l8IRh.getParamValue)('halfPixelCenters', node, tensorMap, context);
                return [
                    ops.image.resizeBilinear(images, [
                        size[0],
                        size[1]
                    ], alignCorners, halfPixelCenters)
                ];
            }
        case 'ResizeNearestNeighbor':
            {
                const images = (0, $l8IRh.getParamValue)('images', node, tensorMap, context);
                const size = (0, $l8IRh.getParamValue)('size', node, tensorMap, context);
                const alignCorners = (0, $l8IRh.getParamValue)('alignCorners', node, tensorMap, context);
                const halfPixelCenters = (0, $l8IRh.getParamValue)('halfPixelCenters', node, tensorMap, context);
                return [
                    ops.image.resizeNearestNeighbor(images, [
                        size[0],
                        size[1]
                    ], alignCorners, halfPixelCenters)
                ];
            }
        case 'CropAndResize':
            {
                const image = (0, $l8IRh.getParamValue)('image', node, tensorMap, context);
                const boxes = (0, $l8IRh.getParamValue)('boxes', node, tensorMap, context);
                const boxInd = (0, $l8IRh.getParamValue)('boxInd', node, tensorMap, context);
                const cropSize = (0, $l8IRh.getParamValue)('cropSize', node, tensorMap, context);
                const method = (0, $l8IRh.getParamValue)('method', node, tensorMap, context);
                const extrapolationValue = (0, $l8IRh.getParamValue)('extrapolationValue', node, tensorMap, context);
                return [
                    ops.image.cropAndResize(image, boxes, boxInd, cropSize, method, extrapolationValue)
                ];
            }
        case 'ImageProjectiveTransformV3':
            {
                const images = (0, $l8IRh.getParamValue)('images', node, tensorMap, context);
                const transforms = (0, $l8IRh.getParamValue)('transforms', node, tensorMap, context);
                const outputShape = (0, $l8IRh.getParamValue)('outputShape', node, tensorMap, context);
                const fillValue = (0, $l8IRh.getParamValue)('fillValue', node, tensorMap, context);
                const interpolation = (0, $l8IRh.getParamValue)('interpolation', node, tensorMap, context);
                const fillMode = (0, $l8IRh.getParamValue)('fillMode', node, tensorMap, context);
                return [
                    ops.image.transform(images, transforms, interpolation.toLowerCase(), fillMode.toLowerCase(), fillValue, outputShape)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $e7a46c526fed1e39$export$2c04807512a22510 = 'image';

});

parcelRegister("eZsKX", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $ae9d11982d3903b9$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $ae9d11982d3903b9$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'Equal':
            return [
                ops.equal((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'NotEqual':
            return [
                ops.notEqual((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Greater':
            return [
                ops.greater((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'GreaterEqual':
            return [
                ops.greaterEqual((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Less':
            return [
                ops.less((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'LessEqual':
            return [
                ops.lessEqual((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'LogicalAnd':
            return [
                ops.logicalAnd((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'LogicalNot':
            return [
                ops.logicalNot((0, $l8IRh.getParamValue)('a', node, tensorMap, context))
            ];
        case 'LogicalOr':
            return [
                ops.logicalOr((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Select':
        case 'SelectV2':
            return [
                ops.where((0, $l8IRh.getParamValue)('condition', node, tensorMap, context), (0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $ae9d11982d3903b9$export$2c04807512a22510 = 'logical';

});

parcelRegister("38tmr", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $2488e4ecc340e124$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $2488e4ecc340e124$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'BatchMatMul':
        case 'BatchMatMulV2':
        case 'MatMul':
            return [
                ops.matMul((0, $l8IRh.getParamValue)('a', node, tensorMap, context), (0, $l8IRh.getParamValue)('b', node, tensorMap, context), (0, $l8IRh.getParamValue)('transposeA', node, tensorMap, context), (0, $l8IRh.getParamValue)('transposeB', node, tensorMap, context))
            ];
        case 'Einsum':
            return [
                ops.einsum((0, $l8IRh.getParamValue)('equation', node, tensorMap, context), ...(0, $l8IRh.getParamValue)('tensors', node, tensorMap, context))
            ];
        case 'Transpose':
            return [
                ops.transpose((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('perm', node, tensorMap, context))
            ];
        case '_FusedMatMul':
            const [extraOp, activationFunc] = (0, $l8IRh.getParamValue)('fusedOps', node, tensorMap, context);
            const isBiasAdd = extraOp === 'biasadd';
            const isPrelu = activationFunc === 'prelu';
            const numArgs = (0, $l8IRh.getParamValue)('numArgs', node, tensorMap, context);
            const leakyreluAlpha = (0, $l8IRh.getParamValue)('leakyreluAlpha', node, tensorMap, context);
            if (isBiasAdd) {
                if (isPrelu && numArgs !== 2) throw new Error("Fused MatMul with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
                if (!isPrelu && numArgs !== 1) throw new Error('Fused MatMul with BiasAdd must have one extra argument: bias.');
            }
            const [biasArg, preluArg] = (0, $l8IRh.getParamValue)('args', node, tensorMap, context);
            return [
                ops.fused.matMul({
                    a: (0, $l8IRh.getParamValue)('a', node, tensorMap, context),
                    b: (0, $l8IRh.getParamValue)('b', node, tensorMap, context),
                    transposeA: (0, $l8IRh.getParamValue)('transposeA', node, tensorMap, context),
                    transposeB: (0, $l8IRh.getParamValue)('transposeB', node, tensorMap, context),
                    bias: biasArg,
                    activation: activationFunc,
                    preluActivationWeights: preluArg,
                    leakyreluAlpha: leakyreluAlpha
                })
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $2488e4ecc340e124$export$2c04807512a22510 = 'matrices';

});

parcelRegister("8YJja", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $6897128f100a8df2$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $6897128f100a8df2$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'EuclideanNorm':
            return [
                ops.euclideanNorm((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('axis', node, tensorMap, context), (0, $l8IRh.getParamValue)('keepDims', node, tensorMap, context))
            ];
        case 'FusedBatchNorm':
        case 'FusedBatchNormV2':
            return [
                ops.batchNorm((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('mean', node, tensorMap, context), (0, $l8IRh.getParamValue)('variance', node, tensorMap, context), (0, $l8IRh.getParamValue)('offset', node, tensorMap, context), (0, $l8IRh.getParamValue)('scale', node, tensorMap, context), (0, $l8IRh.getParamValue)('epsilon', node, tensorMap, context))
            ];
        case 'FusedBatchNormV3':
            return [
                ops.batchNorm((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('mean', node, tensorMap, context), (0, $l8IRh.getParamValue)('variance', node, tensorMap, context), (0, $l8IRh.getParamValue)('offset', node, tensorMap, context), (0, $l8IRh.getParamValue)('scale', node, tensorMap, context), (0, $l8IRh.getParamValue)('epsilon', node, tensorMap, context))
            ];
        case 'LRN':
            return [
                ops.localResponseNormalization((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('radius', node, tensorMap, context), (0, $l8IRh.getParamValue)('bias', node, tensorMap, context), (0, $l8IRh.getParamValue)('alpha', node, tensorMap, context), (0, $l8IRh.getParamValue)('beta', node, tensorMap, context))
            ];
        case 'Softmax':
            return [
                ops.softmax((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'LogSoftmax':
            return [
                ops.logSoftmax((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'SparseToDense':
            return [
                ops.sparseToDense((0, $l8IRh.getParamValue)('sparseIndices', node, tensorMap, context), (0, $l8IRh.getParamValue)('outputShape', node, tensorMap, context), (0, $l8IRh.getParamValue)('sparseValues', node, tensorMap, context), (0, $l8IRh.getParamValue)('defaultValue', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $6897128f100a8df2$export$2c04807512a22510 = 'normalization';

});

parcelRegister("iAtXe", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $d882d31eda67b6df$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $d882d31eda67b6df$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'Max':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $l8IRh.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.max((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Mean':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $l8IRh.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.mean((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Min':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $l8IRh.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.min((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Sum':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $l8IRh.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.sum((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'All':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $l8IRh.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.all((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Any':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $l8IRh.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.any((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'ArgMax':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                return [
                    ops.argMax((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis)
                ];
            }
        case 'ArgMin':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                return [
                    ops.argMin((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Prod':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $l8IRh.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.prod((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Cumprod':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const exclusive = (0, $l8IRh.getParamValue)('exclusive', node, tensorMap, context);
                const reverse = (0, $l8IRh.getParamValue)('reverse', node, tensorMap, context);
                return [
                    ops.cumprod((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis, exclusive, reverse)
                ];
            }
        case 'Cumsum':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const exclusive = (0, $l8IRh.getParamValue)('exclusive', node, tensorMap, context);
                const reverse = (0, $l8IRh.getParamValue)('reverse', node, tensorMap, context);
                return [
                    ops.cumsum((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis, exclusive, reverse)
                ];
            }
        case 'Bincount':
            const x = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
            const weights = (0, $l8IRh.getParamValue)('weights', node, tensorMap, context);
            const size = (0, $l8IRh.getParamValue)('size', node, tensorMap, context);
            return [
                ops.bincount(x, weights, size)
            ];
        case 'DenseBincount':
            {
                const x = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
                const weights = (0, $l8IRh.getParamValue)('weights', node, tensorMap, context);
                const size = (0, $l8IRh.getParamValue)('size', node, tensorMap, context);
                const binaryOutput = (0, $l8IRh.getParamValue)('binaryOutput', node, tensorMap, context);
                return [
                    ops.denseBincount(x, weights, size, binaryOutput)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $d882d31eda67b6df$export$2c04807512a22510 = 'reduction';

});

parcelRegister("gXSbk", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $c59c2f60aaaa3746$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $9c0Qr = parcelRequire("9c0Qr");
var $wx9lK = parcelRequire("wx9lK");

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $c59c2f60aaaa3746$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'ConcatV2':
        case 'Concat':
            {
                const n = (0, $l8IRh.getParamValue)('n', node, tensorMap, context);
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                let inputs = (0, $l8IRh.getParamValue)('tensors', node, tensorMap, context);
                inputs = inputs.slice(0, n);
                return [
                    ops.concat(inputs, axis)
                ];
            }
        case 'Gather':
            {
                const input = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
                const indices = (0, $l8IRh.getParamValue)('indices', node, tensorMap, context);
                return [
                    ops.gather(input, ops.cast(indices, 'int32'), 0)
                ];
            }
        case 'GatherV2':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const batchDims = (0, $l8IRh.getParamValue)('batchDims', node, tensorMap, context);
                const input = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
                const indices = (0, $l8IRh.getParamValue)('indices', node, tensorMap, context);
                return [
                    ops.gather(input, ops.cast(indices, 'int32'), axis, batchDims)
                ];
            }
        case 'Reverse':
            {
                const dims = (0, $l8IRh.getParamValue)('dims', node, tensorMap, context);
                const axis = [];
                for(let i = 0; i < dims.length; i++)if (dims[i]) axis.push(i);
                const input = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
                return [
                    ops.reverse(input, axis)
                ];
            }
        case 'ReverseV2':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const input = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
                return [
                    ops.reverse(input, axis)
                ];
            }
        case 'Slice':
            {
                // tslint:disable-next-line:no-any
                const begin = (0, $l8IRh.getParamValue)('begin', node, tensorMap, context);
                // tslint:disable-next-line:no-any
                const size = (0, $l8IRh.getParamValue)('size', node, tensorMap, context);
                return [
                    ops.slice((0, $l8IRh.getParamValue)('x', node, tensorMap, context), begin, size)
                ];
            }
        case 'StridedSlice':
            {
                const begin = (0, $l8IRh.getParamValue)('begin', node, tensorMap, context);
                const end = (0, $l8IRh.getParamValue)('end', node, tensorMap, context);
                const strides = (0, $l8IRh.getParamValue)('strides', node, tensorMap, context);
                const beginMask = (0, $l8IRh.getParamValue)('beginMask', node, tensorMap, context);
                const endMask = (0, $l8IRh.getParamValue)('endMask', node, tensorMap, context);
                const ellipsisMask = (0, $l8IRh.getParamValue)('ellipsisMask', node, tensorMap, context);
                const newAxisMask = (0, $l8IRh.getParamValue)('newAxisMask', node, tensorMap, context);
                const shrinkAxisMask = (0, $l8IRh.getParamValue)('shrinkAxisMask', node, tensorMap, context);
                const tensor = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
                return [
                    ops.stridedSlice(tensor, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask)
                ];
            }
        case 'Pack':
            return (0, $9c0Qr.tidy)(()=>{
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const tensors = (0, $l8IRh.getParamValue)('tensors', node, tensorMap, context);
                // Reshape the tensors to the first tensor's shape if they don't
                // match.
                const shape = tensors[0].shape;
                const squeezedShape = ops.squeeze(tensors[0]).shape;
                const mapped = tensors.map((tensor)=>{
                    const sameShape = (0, $wx9lK).arraysEqual(tensor.shape, shape);
                    if (!sameShape && !(0, $wx9lK).arraysEqual(ops.squeeze(tensor).shape, squeezedShape)) throw new Error('the input tensors shape does not match');
                    return sameShape ? tensor : ops.reshape(tensor, shape);
                });
                return [
                    ops.stack(mapped, axis)
                ];
            });
        case 'Unpack':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const tensor = (0, $l8IRh.getParamValue)('tensor', node, tensorMap, context);
                return ops.unstack(tensor, axis);
            }
        case 'Tile':
            {
                const reps = (0, $l8IRh.getParamValue)('reps', node, tensorMap, context);
                return [
                    ops.tile((0, $l8IRh.getParamValue)('x', node, tensorMap, context), reps)
                ];
            }
        case 'Split':
        case 'SplitV':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                const numOrSizeSplits = (0, $l8IRh.getParamValue)('numOrSizeSplits', node, tensorMap, context);
                const tensor = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
                return ops.split(tensor, numOrSizeSplits, axis);
            }
        case 'ScatterNd':
            {
                const indices = (0, $l8IRh.getParamValue)('indices', node, tensorMap, context);
                const values = (0, $l8IRh.getParamValue)('values', node, tensorMap, context);
                const shape = (0, $l8IRh.getParamValue)('shape', node, tensorMap, context);
                return [
                    ops.scatterND(indices, values, shape)
                ];
            }
        case 'GatherNd':
            {
                const x = (0, $l8IRh.getParamValue)('x', node, tensorMap, context);
                const indices = (0, $l8IRh.getParamValue)('indices', node, tensorMap, context);
                return [
                    ops.gatherND(x, indices)
                ];
            }
        case 'SparseToDense':
            {
                const indices = (0, $l8IRh.getParamValue)('sparseIndices', node, tensorMap, context);
                const shape = (0, $l8IRh.getParamValue)('outputShape', node, tensorMap, context);
                const sparseValues = (0, $l8IRh.getParamValue)('sparseValues', node, tensorMap, context);
                const defaultValue = (0, $l8IRh.getParamValue)('defaultValue', node, tensorMap, context);
                return [
                    ops.sparseToDense(indices, sparseValues, shape, sparseValues.dtype === defaultValue.dtype ? defaultValue : ops.cast(defaultValue, sparseValues.dtype))
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $c59c2f60aaaa3746$export$2c04807512a22510 = 'slice_join';

});

parcelRegister("74IKF", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $526b9ee0612a4505$export$7be88578e558e499);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $526b9ee0612a4505$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'SparseFillEmptyRows':
            {
                const { outputIndices: outputIndices, outputValues: outputValues, emptyRowIndicator: emptyRowIndicator, reverseIndexMap: reverseIndexMap } = ops.sparse.sparseFillEmptyRows((0, $l8IRh.getParamValue)('indices', node, tensorMap, context), (0, $l8IRh.getParamValue)('values', node, tensorMap, context), (0, $l8IRh.getParamValue)('denseShape', node, tensorMap, context), (0, $l8IRh.getParamValue)('defaultValue', node, tensorMap, context));
                return [
                    outputIndices,
                    outputValues,
                    emptyRowIndicator,
                    reverseIndexMap
                ];
            }
        case 'SparseReshape':
            {
                const { outputIndices: outputIndices, outputShape: outputShape } = ops.sparse.sparseReshape((0, $l8IRh.getParamValue)('inputIndices', node, tensorMap, context), (0, $l8IRh.getParamValue)('inputShape', node, tensorMap, context), (0, $l8IRh.getParamValue)('newShape', node, tensorMap, context));
                return [
                    outputIndices,
                    outputShape
                ];
            }
        case 'SparseSegmentMean':
            {
                const outputData = ops.sparse.sparseSegmentMean((0, $l8IRh.getParamValue)('data', node, tensorMap, context), (0, $l8IRh.getParamValue)('indices', node, tensorMap, context), (0, $l8IRh.getParamValue)('segmentIds', node, tensorMap, context));
                return [
                    outputData
                ];
            }
        case 'SparseSegmentSum':
            {
                const outputData = ops.sparse.sparseSegmentSum((0, $l8IRh.getParamValue)('data', node, tensorMap, context), (0, $l8IRh.getParamValue)('indices', node, tensorMap, context), (0, $l8IRh.getParamValue)('segmentIds', node, tensorMap, context));
                return [
                    outputData
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $526b9ee0612a4505$export$2c04807512a22510 = 'sparse';

});

parcelRegister("io0Wq", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $d62b32d400400f6c$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $d62b32d400400f6c$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'FFT':
            return [
                ops.fft((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'IFFT':
            return [
                ops.ifft((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'RFFT':
            return [
                ops.rfft((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        case 'IRFFT':
            return [
                ops.irfft((0, $l8IRh.getParamValue)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $d62b32d400400f6c$export$2c04807512a22510 = 'spectral';

});

parcelRegister("5Lwy2", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $432a96e25f96e5d6$export$7be88578e558e499);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $432a96e25f96e5d6$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'StringNGrams':
            {
                const { nGrams: nGrams, nGramsSplits: nGramsSplits } = ops.string.stringNGrams((0, $l8IRh.getParamValue)('data', node, tensorMap, context), (0, $l8IRh.getParamValue)('dataSplits', node, tensorMap, context), (0, $l8IRh.getParamValue)('separator', node, tensorMap, context), (0, $l8IRh.getParamValue)('nGramWidths', node, tensorMap, context), (0, $l8IRh.getParamValue)('leftPad', node, tensorMap, context), (0, $l8IRh.getParamValue)('rightPad', node, tensorMap, context), (0, $l8IRh.getParamValue)('padWidth', node, tensorMap, context), (0, $l8IRh.getParamValue)('preserveShortSequences', node, tensorMap, context));
                return [
                    nGrams,
                    nGramsSplits
                ];
            }
        case 'StringSplit':
            {
                const { indices: indices, values: values, shape: shape } = ops.string.stringSplit((0, $l8IRh.getParamValue)('input', node, tensorMap, context), (0, $l8IRh.getParamValue)('delimiter', node, tensorMap, context), (0, $l8IRh.getParamValue)('skipEmpty', node, tensorMap, context));
                return [
                    indices,
                    values,
                    shape
                ];
            }
        case 'StringToHashBucketFast':
            {
                const output = ops.string.stringToHashBucketFast((0, $l8IRh.getParamValue)('input', node, tensorMap, context), (0, $l8IRh.getParamValue)('numBuckets', node, tensorMap, context));
                return [
                    output
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $432a96e25f96e5d6$export$2c04807512a22510 = 'string';

});

parcelRegister("9qMbz", function(module, exports) {

$parcel$export(module.exports, "executeOp", () => $6ddbeb67daf01072$export$7be88578e558e499);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $1ShPG = parcelRequire("1ShPG");

var $l8IRh = parcelRequire("l8IRh");
const $6ddbeb67daf01072$export$7be88578e558e499 = (node, tensorMap, context, ops = $1ShPG)=>{
    switch(node.op){
        case 'Cast':
            return [
                ops.cast((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('dtype', node, tensorMap, context))
            ];
        case 'ExpandDims':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                return [
                    ops.expandDims((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Squeeze':
            {
                const axis = (0, $l8IRh.getParamValue)('axis', node, tensorMap, context);
                return [
                    ops.squeeze((0, $l8IRh.getParamValue)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Reshape':
            return [
                ops.reshape((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('shape', node, tensorMap, context))
            ];
        case 'MirrorPad':
            return [
                ops.mirrorPad((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('padding', node, tensorMap, context), (0, $l8IRh.getParamValue)('mode', node, tensorMap, context))
            ];
        case 'PadV2':
        case 'Pad':
            return [
                ops.pad((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('padding', node, tensorMap, context), (0, $l8IRh.getParamValue)('constantValue', node, tensorMap, context))
            ];
        case 'SpaceToBatchND':
            {
                const blockShape = (0, $l8IRh.getParamValue)('blockShape', node, tensorMap, context);
                const paddings = (0, $l8IRh.getParamValue)('paddings', node, tensorMap, context);
                return [
                    ops.spaceToBatchND((0, $l8IRh.getParamValue)('x', node, tensorMap, context), blockShape, paddings)
                ];
            }
        case 'BatchToSpaceND':
            {
                const blockShape = (0, $l8IRh.getParamValue)('blockShape', node, tensorMap, context);
                const crops = (0, $l8IRh.getParamValue)('crops', node, tensorMap, context);
                return [
                    ops.batchToSpaceND((0, $l8IRh.getParamValue)('x', node, tensorMap, context), blockShape, crops)
                ];
            }
        case 'DepthToSpace':
            {
                const blockSize = (0, $l8IRh.getParamValue)('blockSize', node, tensorMap, context);
                const dataFormat = (0, $l8IRh.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                return [
                    ops.depthToSpace((0, $l8IRh.getParamValue)('x', node, tensorMap, context), blockSize, dataFormat)
                ];
            }
        case 'BroadcastTo':
            return [
                ops.broadcastTo((0, $l8IRh.getParamValue)('x', node, tensorMap, context), (0, $l8IRh.getParamValue)('shape', node, tensorMap, context))
            ];
        case 'BroadcastArgs':
            return [
                ops.broadcastArgs((0, $l8IRh.getParamValue)('s0', node, tensorMap, context), (0, $l8IRh.getParamValue)('s1', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $6ddbeb67daf01072$export$2c04807512a22510 = 'transformation';

});


parcelRegister("fmNgT", function(module, exports) {

$parcel$export(module.exports, "ExecutionContext", () => $b2ff2163874b4a5c$export$f7c638676c8af91d);
/**
 * ExecutionContext captures the runtime environment of the node. It keeps
 * track of the current frame and iteration for the control flow ops.
 *
 * For example, typical Dynamic RNN model may contain loops, for which
 * TensorFlow will generate graphs with Enter/Exit nodes to control the
 * current execution frame, and NextIteration Nodes for iteration id increment.
 * For model with branch logic, TensorFLow will generate Switch/Merge ops.
 */ class $b2ff2163874b4a5c$export$f7c638676c8af91d {
    constructor(weightMap = {}, tensorArrayMap = {}, tensorListMap = {}, functionMap = {}){
        this.weightMap = weightMap;
        this.tensorArrayMap = tensorArrayMap;
        this.tensorListMap = tensorListMap;
        this.functionMap = functionMap;
        this.rootContext = {
            id: 0,
            frameName: '',
            iterationId: 0
        };
        this.contexts = [
            this.rootContext
        ];
        this.lastId = 0;
        this.generateCurrentContextIds();
    }
    newFrame(id, frameName) {
        return {
            id: id,
            frameName: frameName,
            iterationId: 0
        };
    }
    /**
     * Set the current context
     * @param contexts: ExecutionContextInfo[] the current path of execution
     * frames
     */ set currentContext(contexts) {
        if (this.contexts !== contexts) {
            this.contexts = contexts;
            this.generateCurrentContextIds();
        }
    }
    get currentContext() {
        return this.contexts;
    }
    /**
     * Returns the current context in string format.
     */ get currentContextId() {
        return this._currentContextIds[0];
    }
    /**
     * Returns the current context and all parent contexts in string format.
     * This allow access to the nodes in the current and parent frames.
     */ get currentContextIds() {
        return this._currentContextIds;
    }
    generateCurrentContextIds() {
        const names = [];
        for(let i = 0; i < this.contexts.length - 1; i++){
            const contexts = this.contexts.slice(0, this.contexts.length - i);
            names.push(this.contextIdforContexts(contexts));
        }
        names.push('');
        this._currentContextIds = names;
    }
    contextIdforContexts(contexts) {
        return contexts ? contexts.map((context)=>context.id === 0 && context.iterationId === 0 ? '' : `${context.frameName}-${context.iterationId}`).join('/') : '';
    }
    /**
     * Enter a new frame, a new context is pushed on the current context list.
     * @param frameId new frame id
     */ enterFrame(frameId) {
        if (this.contexts) {
            this.lastId++;
            this.contexts = this.contexts.slice();
            this.contexts.push(this.newFrame(this.lastId, frameId));
            this._currentContextIds.unshift(this.contextIdforContexts(this.contexts));
        }
    }
    /**
     * Exit the current frame, the last context is removed from the current
     * context list.
     */ exitFrame() {
        if (this.contexts && this.contexts.length > 1) {
            this.contexts = this.contexts.slice();
            this.contexts.splice(-1);
            this.currentContextIds.shift();
        } else throw new Error('Cannot exit frame, the context is empty');
    }
    /**
     * Enter the next iteration of a loop, the iteration id of last context is
     * increased.
     */ nextIteration() {
        if (this.contexts && this.contexts.length > 0) {
            this.contexts = this.contexts.slice();
            this.lastId++;
            const context = Object.assign({}, this.contexts[this.contexts.length - 1]);
            context.iterationId += 1;
            context.id = this.lastId;
            this.contexts.splice(-1, 1, context);
            this._currentContextIds.splice(0, 1, this.contextIdforContexts(this.contexts));
        } else throw new Error('Cannot increase frame iteration, the context is empty');
    }
    getWeight(name) {
        return this.weightMap[name];
    }
    addTensorArray(tensorArray) {
        this.tensorArrayMap[tensorArray.id] = tensorArray;
    }
    getTensorArray(id) {
        return this.tensorArrayMap[id];
    }
    addTensorList(tensorList) {
        this.tensorListMap[tensorList.id] = tensorList;
    }
    getTensorList(id) {
        return this.tensorListMap[id];
    }
    dispose(keepIds) {
        for(const key in this.tensorArrayMap)this.tensorArrayMap[key].clearAndClose(keepIds);
        for(const key in this.tensorListMap)this.tensorListMap[key].clearAndClose(keepIds);
    }
}

});

parcelRegister("aIXqN", function(module, exports) {

$parcel$export(module.exports, "getExecutionSubgraph", () => $7cec1d3e66d1fdcf$export$73c2416e6ab509c5);
$parcel$export(module.exports, "isControlFlow", () => $7cec1d3e66d1fdcf$export$683ae22d42a16fd1);
$parcel$export(module.exports, "getNodesInTopologicalOrder", () => $7cec1d3e66d1fdcf$export$66747854b63761e1);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $l8IRh = parcelRequire("l8IRh");
function $7cec1d3e66d1fdcf$export$73c2416e6ab509c5(inputs, outputs, weightMap, initNodes) {
    const usedNodes = new Set();
    const missingInputs = [];
    let dynamicNode = null;
    let syncInputs = null;
    // Start with the outputs, going backwards and find all the nodes that are
    // needed to compute those outputs.
    const seen = new Set();
    const inputNodeNames = Object.keys(inputs).map((name)=>(0, $l8IRh.parseNodeName)(name)[0]);
    let initNodeNames = [];
    if (initNodes != null) initNodeNames = initNodes.map((node)=>(0, $l8IRh.parseNodeName)(node.name)[0]);
    const frontier = [
        ...outputs
    ];
    while(frontier.length > 0){
        const node = frontier.pop();
        if ($7cec1d3e66d1fdcf$export$683ae22d42a16fd1(node) || $7cec1d3e66d1fdcf$export$eee9c104bd05368d(node) || $7cec1d3e66d1fdcf$export$ad7e54a7e645a447(node)) {
            if (dynamicNode == null) {
                dynamicNode = node;
                syncInputs = dynamicNode.children.map((child)=>child.name).filter((name)=>usedNodes.has(name));
            }
        }
        usedNodes.add(node.name);
        // Weights are dead end since we already have their values.
        if (weightMap[node.name] != null) continue;
        // This node is a dead end since it's one of the user-provided inputs.
        if (inputNodeNames.indexOf(node.name) !== -1) continue;
        // This node is a dead end since it doesn't have any inputs.
        if (initNodeNames.indexOf(node.name) !== -1) continue;
        if (node.inputs.length === 0) {
            missingInputs.push(node.name);
            continue;
        }
        node.inputs.forEach((input)=>{
            // Don't add to the frontier if it is already there.
            if (seen.has(input.name)) return;
            seen.add(input.name);
            frontier.push(input);
        });
    }
    return {
        inputs: inputs,
        outputs: outputs,
        usedNodes: usedNodes,
        missingInputs: missingInputs,
        dynamicNode: dynamicNode,
        syncInputs: syncInputs
    };
}
function $7cec1d3e66d1fdcf$export$66747854b63761e1(graph, weightMap, executionInfo) {
    const { usedNodes: usedNodes, inputs: inputs } = executionInfo;
    const frontier = [];
    const inputNodes = Object.keys(inputs).map((name)=>(0, $l8IRh.parseNodeName)(name)[0]).map((name)=>graph.nodes[name]);
    const initNodes = graph.initNodes;
    inputNodes.forEach((input)=>{
        if (usedNodes.has(input.name)) frontier.push(input);
    });
    graph.weights.forEach((weight)=>{
        if (usedNodes.has(weight.name)) frontier.push(weight);
    });
    if (initNodes != null) initNodes.forEach((node)=>{
        if (usedNodes.has(node.name)) frontier.push(node);
    });
    const seen = new Set();
    const orderedNodes = [];
    while(frontier.length > 0){
        const node = frontier.pop();
        seen.add(node.name);
        if (!weightMap[node.name]) orderedNodes.push(node);
        node.children.forEach((child)=>{
            if (!seen.has(child.name) && usedNodes.has(child.name) && child.inputs.every((input)=>seen.has(input.name))) frontier.push(child);
        });
    }
    return orderedNodes;
}
const $7cec1d3e66d1fdcf$var$CONTROL_FLOW_OPS = [
    'Switch',
    'Merge',
    'Enter',
    'Exit',
    'NextIteration',
    'StatelessIf',
    'StatelessWhile',
    'if',
    'While'
];
const $7cec1d3e66d1fdcf$var$DYNAMIC_SHAPE_OPS = [
    'NonMaxSuppressionV2',
    'NonMaxSuppressionV3',
    'NonMaxSuppressionV5',
    'Where'
];
const $7cec1d3e66d1fdcf$var$HASH_TABLE_OPS = [
    'HashTable',
    'HashTableV2',
    'LookupTableImport',
    'LookupTableImportV2',
    'LookupTableFind',
    'LookupTableFindV2',
    'LookupTableSize',
    'LookupTableSizeV2'
];
function $7cec1d3e66d1fdcf$export$683ae22d42a16fd1(node) {
    return $7cec1d3e66d1fdcf$var$CONTROL_FLOW_OPS.indexOf(node.op) >= 0;
}
function $7cec1d3e66d1fdcf$export$eee9c104bd05368d(node) {
    return $7cec1d3e66d1fdcf$var$DYNAMIC_SHAPE_OPS.indexOf(node.op) >= 0;
}
function $7cec1d3e66d1fdcf$export$ad7e54a7e645a447(node) {
    return $7cec1d3e66d1fdcf$var$HASH_TABLE_OPS.indexOf(node.op) >= 0;
}

});


parcelRegister("1OJox", function(module, exports) {

$parcel$export(module.exports, "ResourceManager", () => $152dac69213944f2$export$60667f9de734e56);
/**
 * Contains global resources of a model.
 */ class $152dac69213944f2$export$60667f9de734e56 {
    constructor(hashTableNameToHandle = {}, hashTableMap = {}){
        this.hashTableNameToHandle = hashTableNameToHandle;
        this.hashTableMap = hashTableMap;
    }
    /**
     * Register a `HashTable` in the resource manager.
     *
     * The `HashTable` can be retrieved by `resourceManager.getHashTableById`,
     * where id is the table handle tensor's id.
     *
     * @param name Op node name that creates the `HashTable`.
     * @param hashTable The `HashTable` to be added to resource manager.
     */ addHashTable(name, hashTable) {
        this.hashTableNameToHandle[name] = hashTable.handle;
        this.hashTableMap[hashTable.id] = hashTable;
    }
    /**
     * Get the table handle by node name.
     * @param name Op node name that creates the `HashTable`. This name is also
     *     used in the inputs list of lookup and import `HashTable` ops.
     */ getHashTableHandleByName(name) {
        return this.hashTableNameToHandle[name];
    }
    /**
     * Get the actual `HashTable` by its handle tensor's id.
     * @param id The id of the handle tensor.
     */ getHashTableById(id) {
        return this.hashTableMap[id];
    }
    /**
     * Dispose `ResourceManager`, including its hashTables and tensors in them.
     */ dispose() {
        for(const key in this.hashTableMap){
            this.hashTableMap[key].clearAndClose();
            delete this.hashTableMap[key];
        }
        for(const name in this.hashTableNameToHandle){
            this.hashTableNameToHandle[name].dispose();
            delete this.hashTableNameToHandle[name];
        }
    }
}

});


parcelRegister("fdizF", function(module, exports) {

$parcel$export(module.exports, "version", () => $b1367a65baf75e8a$export$83d89fbfd8236492);
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $b1367a65baf75e8a$export$83d89fbfd8236492 = '3.21.0';

});


parcelRegister("2gsxU", function(module, exports) {

$parcel$export(module.exports, "array", () => (parcelRequire("3M2Rw")).array);
$parcel$export(module.exports, "Dataset", () => (parcelRequire("3M2Rw")).Dataset);
$parcel$export(module.exports, "zip", () => (parcelRequire("3M2Rw")).zip);
$parcel$export(module.exports, "CSVDataset", () => (parcelRequire("7kP9G")).CSVDataset);
$parcel$export(module.exports, "TextLineDataset", () => (parcelRequire("7EcID")).TextLineDataset);
$parcel$export(module.exports, "csv", () => (parcelRequire("2xHCu")).csv);
$parcel$export(module.exports, "func", () => (parcelRequire("2xHCu")).func);
$parcel$export(module.exports, "generator", () => (parcelRequire("2xHCu")).generator);
$parcel$export(module.exports, "microphone", () => (parcelRequire("2xHCu")).microphone);
$parcel$export(module.exports, "webcam", () => (parcelRequire("2xHCu")).webcam);
$parcel$export(module.exports, "FileDataSource", () => (parcelRequire("krOnM")).FileDataSource);
$parcel$export(module.exports, "URLDataSource", () => (parcelRequire("2X1jl")).URLDataSource);
$parcel$export(module.exports, "version_data", () => (parcelRequire("5JRhQ")).version);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3M2Rw = parcelRequire("3M2Rw");

var $7kP9G = parcelRequire("7kP9G");

var $7EcID = parcelRequire("7EcID");

var $2xHCu = parcelRequire("2xHCu");

var $krOnM = parcelRequire("krOnM");

var $2X1jl = parcelRequire("2X1jl");

var $5JRhQ = parcelRequire("5JRhQ");

});
parcelRegister("3M2Rw", function(module, exports) {

$parcel$export(module.exports, "Dataset", () => $2bf8132c96a703ca$export$827063163a0a89f5);
$parcel$export(module.exports, "datasetFromIteratorFn", () => $2bf8132c96a703ca$export$3a70158aa38bbd76);
$parcel$export(module.exports, "array", () => $2bf8132c96a703ca$export$2f23118c22fb2630);
$parcel$export(module.exports, "zip", () => $2bf8132c96a703ca$export$8901015135f2fb22);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("5n9DG");
var $iSKul = parcelRequire("iSKul");
var $ec8bD = parcelRequire("ec8bD");
var $bVnU9 = parcelRequire("bVnU9");
var $9c0Qr = parcelRequire("9c0Qr");
var $wx9lK = parcelRequire("wx9lK");

var $ftPHE = parcelRequire("ftPHE");

var $6bIfc = parcelRequire("6bIfc");

var $61DqE = parcelRequire("61DqE");
class $2bf8132c96a703ca$export$827063163a0a89f5 {
    constructor(){
        this.size = null;
    }
    // TODO(soergel): Make Datasets report whether repeated iterator() calls
    // produce the same result (e.g., reading from a file) or different results
    // (e.g., from the webcam).  Currently we don't make this distinction but it
    // could be important for the user to know.
    // abstract isDeterministic(): boolean;
    /**
     * Groups elements into batches.
     *
     * It is assumed that each of the incoming dataset elements has the same
     * structure -- i.e. the same set of keys at each location in an object
     * hierarchy.  For each key, the resulting `Dataset` provides a batched
     * element collecting all of the incoming values for that key.
     *
     *  * Incoming primitives are grouped into a 1-D Tensor.
     *  * Incoming Tensors are grouped into a new Tensor where the 0th axis is
     *    the batch dimension.
     *  * Incoming arrays are converted to Tensor and then batched.
     *  * A nested array is interpreted as an n-D Tensor, so the batched result
     *    has n+1 dimensions.
     *  * An array that cannot be converted to Tensor produces an error.
     *
     * If an array should not be batched as a unit, it should first be converted
     * to an object with integer keys.
     *
     * Here are a few examples:
     *
     * Batch a dataset of numbers:
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6, 7, 8]).batch(4);
     * await a.forEachAsync(e => e.print());
     * ```
     *
     * Batch a dataset of arrays:
     * ```js
     * const b = tf.data.array([[1], [2], [3], [4], [5], [6], [7], [8]]).batch(4);
     * await b.forEachAsync(e => e.print());
     * ```
     *
     * Batch a dataset of objects:
     * ```js
     * const c = tf.data.array([{a: 1, b: 11}, {a: 2, b: 12}, {a: 3, b: 13},
     *   {a: 4, b: 14}, {a: 5, b: 15}, {a: 6, b: 16}, {a: 7, b: 17},
     *   {a: 8, b: 18}]).batch(4);
     * await c.forEachAsync(e => {
     *   console.log('{');
     *   for(var key in e) {
     *     console.log(key+':');
     *     e[key].print();
     *   }
     *   console.log('}');
     * })
     * ```
     *
     * @param batchSize The number of elements desired per batch.
     * @param smallLastBatch Whether to emit the final batch when it has fewer
     *   than batchSize elements. Default true.
     * @returns A `Dataset`, from which a stream of batches can be obtained.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ batch(batchSize, smallLastBatch = true) {
        const base = this;
        $wx9lK.assert(batchSize > 0, ()=>`batchSize needs to be positive, but it is
      ${batchSize}`);
        let size;
        if (this.size === Infinity || this.size == null) // If the size of this dataset is infinity or null, the new size keeps the
        // same.
        size = this.size;
        else if (smallLastBatch) // If the size of this dataset is known and include small last batch, the
        // new size is full batch count plus last batch.
        size = Math.ceil(this.size / batchSize);
        else // If the size of this dataset is known and not include small last batch,
        // the new size is full batch count.
        size = Math.floor(this.size / batchSize);
        return $2bf8132c96a703ca$export$3a70158aa38bbd76(async ()=>{
            return (await base.iterator()).columnMajorBatch(batchSize, smallLastBatch, $2bf8132c96a703ca$var$deepBatchConcat);
        }, size);
    }
    /**
     * Concatenates this `Dataset` with another.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3]);
     * const b = tf.data.array([4, 5, 6]);
     * const c = a.concatenate(b);
     * await c.forEachAsync(e => console.log(e));
     * ```
     *
     * @param dataset A `Dataset` to be concatenated onto this one.
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ concatenate(dataset) {
        const base = this;
        let size;
        if (this.size === Infinity || dataset.size === Infinity) // If the size of any of these two dataset is infinity, new size is
        // infinity.
        size = Infinity;
        else if (this.size != null && dataset.size != null) // If the size of both datasets are known and not infinity, new size is
        // sum the size of these two datasets.
        size = this.size + dataset.size;
        else // If neither of these two datasets has infinite size and any of these two
        // datasets' size is null, the new size is null.
        size = null;
        return $2bf8132c96a703ca$export$3a70158aa38bbd76(async ()=>(await base.iterator()).concatenate(await dataset.iterator()), size);
    }
    /**
     * Filters this dataset according to `predicate`.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
     *   .filter(x => x%2 === 0);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param predicate A function mapping a dataset element to a boolean or a
     * `Promise` for one.
     *
     * @returns A `Dataset` of elements for which the predicate was true.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ filter(predicate) {
        const base = this;
        let size;
        if (this.size === Infinity) // If the size of this dataset is infinity, new size is infinity
        size = Infinity;
        else // If this dataset has limited elements, new size is null because it might
        // exhausted randomly.
        size = null;
        return $2bf8132c96a703ca$export$3a70158aa38bbd76(async ()=>{
            return (await base.iterator()).filter((x)=>$9c0Qr.tidy(()=>predicate(x)));
        }, size);
    }
    /**
     * Apply a function to every element of the dataset.
     *
     * After the function is applied to a dataset element, any Tensors contained
     * within that element are disposed.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3]);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param f A function to apply to each dataset element.
     * @returns A `Promise` that resolves after all elements have been processed.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ async forEachAsync(f) {
        return (await this.iterator()).forEachAsync(f);
    }
    /**
     * Maps this dataset through a 1-to-1 transform.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3]).map(x => x*x);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param transform A function mapping a dataset element to a transformed
     *   dataset element.
     *
     * @returns A `Dataset` of transformed elements.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ map(transform) {
        const base = this;
        return $2bf8132c96a703ca$export$3a70158aa38bbd76(async ()=>{
            return (await base.iterator()).map((x)=>$9c0Qr.tidy(()=>transform(x)));
        }, this.size);
    }
    /**
     * Maps this dataset through an async 1-to-1 transform.
     *
     * ```js
     * const a =
     *  tf.data.array([1, 2, 3]).mapAsync(x => new Promise(function(resolve){
     *    setTimeout(() => {
     *      resolve(x * x);
     *    }, Math.random()*1000 + 500);
     *  }));
     * console.log(await a.toArray());
     * ```
     *
     * @param transform A function mapping a dataset element to a `Promise` for a
     *   transformed dataset element.  This transform is responsible for disposing
     *   any intermediate `Tensor`s, i.e. by wrapping its computation in
     *   `tf.tidy()`; that cannot be automated here (as it is in the synchronous
     *   `map()` case).
     *
     * @returns A `Dataset` of transformed elements.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ mapAsync(transform) {
        const base = this;
        return $2bf8132c96a703ca$export$3a70158aa38bbd76(async ()=>{
            return (await base.iterator()).mapAsync(transform);
        }, this.size);
    }
    /**
     *  Creates a `Dataset` that prefetches elements from this dataset.
     *
     * @param bufferSize: An integer specifying the number of elements to be
     *   prefetched.
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ prefetch(bufferSize) {
        if (bufferSize == null) throw new RangeError('`Dataset.prefetch()` requires bufferSize to be specified.');
        const base = this;
        return $2bf8132c96a703ca$export$3a70158aa38bbd76(async ()=>(await base.iterator()).prefetch(bufferSize), this.size);
    }
    /**
     * Repeats this dataset `count` times.
     *
     * NOTE: If this dataset is a function of global state (e.g. a random number
     * generator), then different repetitions may produce different elements.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3]).repeat(3);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param count: (Optional) An integer, representing the number of times
     *   the dataset should be repeated. The default behavior (if `count` is
     *   `undefined` or negative) is for the dataset be repeated indefinitely.
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ repeat(count) {
        const base = this;
        let size;
        if (this.size != null && count > 0) // If this dataset has size and count is positive, new size is current
        // size multiply count. This also covers the case that current size is
        // infinity.
        size = this.size * count;
        else if (count === 0) // If count is 0, new size is 0.
        size = 0;
        else if (this.size != null && (count === undefined || count < 0)) // If this dataset has size and count is undefined or negative, the
        // dataset will be repeated indefinitely and new size is infinity.
        size = Infinity;
        else // If the size of this dataset is null, the new dataset's size is null.
        size = null;
        return $2bf8132c96a703ca$export$3a70158aa38bbd76(async ()=>{
            const iteratorIterator = (0, $6bIfc.iteratorFromFunction)(async ()=>({
                    value: await base.iterator(),
                    done: false
                }));
            return (0, $6bIfc.iteratorFromConcatenated)(iteratorIterator.take(count));
        }, size);
    }
    /**
     * Creates a `Dataset` that skips `count` initial elements from this dataset.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6]).skip(3);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param count: The number of elements of this dataset that should be skipped
     *   to form the new dataset.  If `count` is greater than the size of this
     *   dataset, the new dataset will contain no elements.  If `count`
     *   is `undefined` or negative, skips the entire dataset.
     *
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ skip(count) {
        const base = this;
        let size;
        if (this.size != null && count >= 0 && this.size >= count) // If the size of this dataset is greater than count, the new dataset's
        // size is current size minus skipped size.This also covers the case that
        // current size is infinity.
        size = this.size - count;
        else if (this.size != null && (this.size < count || count === undefined || count < 0)) // If the size of this dataset is smaller than count, or count is
        // undefined or negative, skips the entire dataset and the new size is 0.
        size = 0;
        else // If the size of this dataset is null, the new dataset's size is null.
        size = null;
        return $2bf8132c96a703ca$export$3a70158aa38bbd76(async ()=>(await base.iterator()).skip(count), size);
    }
    /**
     * Pseudorandomly shuffles the elements of this dataset. This is done in a
     * streaming manner, by sampling from a given number of prefetched elements.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6]).shuffle(3);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param bufferSize: An integer specifying the number of elements from this
     *   dataset from which the new dataset will sample.
     * @param seed: (Optional) An integer specifying the random seed that will
     *   be used to create the distribution.
     * @param reshuffleEachIteration: (Optional) A boolean, which if true
     *   indicates that the dataset should be pseudorandomly reshuffled each time
     *   it is iterated over. If false, elements will be returned in the same
     *   shuffled order on each iteration. (Defaults to `true`.)
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ shuffle(bufferSize, seed, reshuffleEachIteration = true) {
        if (bufferSize == null || bufferSize < 0) {
            if (this.size == null) throw new RangeError('`Dataset.shuffle()` requires bufferSize to be specified.');
            else throw new RangeError("`Dataset.shuffle()` requires bufferSize to be specified.  If your data fits in main memory (for regular JS objects), and/or GPU memory (for `tf.Tensor`s), consider setting " + `bufferSize to the dataset size (${this.size} elements)`);
        }
        const base = this;
        const random = $ftPHE.alea(seed || $wx9lK.now().toString());
        return $2bf8132c96a703ca$export$3a70158aa38bbd76(async ()=>{
            let seed2 = random.int32();
            if (reshuffleEachIteration) seed2 += random.int32();
            return (await base.iterator()).shuffle(bufferSize, seed2.toString());
        }, this.size);
    }
    /**
     * Creates a `Dataset` with at most `count` initial elements from this
     * dataset.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6]).take(3);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param count: The number of elements of this dataset that should be taken
     *   to form the new dataset.  If `count` is `undefined` or negative, or if
     *   `count` is greater than the size of this dataset, the new dataset will
     *   contain all elements of this dataset.
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ take(count) {
        const base = this;
        let size;
        if (this.size != null && this.size > count) // If the size of this dataset is greater than count, the new dataset's
        // size is count.
        size = count;
        else if (this.size != null && this.size <= count) // If the size of this dataset is equal or smaller than count, the new
        // dataset's size is the size of this dataset.
        size = this.size;
        else // If the size of this dataset is null, the new dataset's size is null.
        size = null;
        return $2bf8132c96a703ca$export$3a70158aa38bbd76(async ()=>(await base.iterator()).take(count), size);
    }
    /**
     * Collect all elements of this dataset into an array.
     *
     * Obviously this will succeed only for small datasets that fit in memory.
     * Useful for testing and generally should be avoided if possible.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6]);
     * console.log(await a.toArray());
     * ```
     *
     * @returns A Promise for an array of elements, which will resolve
     *   when a new stream has been obtained and fully consumed.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ async toArray() {
        if (this.size === Infinity) throw new Error('Can not convert infinite data stream to array.');
        return (await this.iterator()).toArray();
    }
    /**
     * Collect all elements of this dataset into an array with prefetching 100
     * elements. This is useful for testing, because the prefetch changes the
     * order in which the Promises are resolved along the processing pipeline.
     * This may help expose bugs where results are dependent on the order of
     * Promise resolution rather than on the logical order of the stream (i.e.,
     * due to hidden mutable state).
     *
     * @returns A Promise for an array of elements, which will resolve
     *   when a new stream has been obtained and fully consumed.
     */ async toArrayForTest() {
        if (this.size === Infinity) throw new Error('Can not convert infinite data stream to array.');
        return (await this.iterator()).toArrayForTest();
    }
}
// TODO(soergel): deep sharded shuffle, where supported
$2bf8132c96a703ca$export$827063163a0a89f5.MAX_BUFFER_SIZE = 10000;
function $2bf8132c96a703ca$export$3a70158aa38bbd76(iteratorFn, size = null) {
    return new class extends $2bf8132c96a703ca$export$827063163a0a89f5 {
        constructor(){
            super(...arguments);
            this.size = size;
        }
        /*
         * Provide a new stream of elements.  Note this will also start new streams
         * from any underlying `Dataset`s.
         */ async iterator() {
            return iteratorFn();
        }
    }();
}
function $2bf8132c96a703ca$export$2f23118c22fb2630(items) {
    return $2bf8132c96a703ca$export$3a70158aa38bbd76(async ()=>(0, $6bIfc.iteratorFromItems)(items), items.length);
}
function $2bf8132c96a703ca$export$8901015135f2fb22(datasets) {
    // manually type-check the argument for JS users
    if (!(0, $61DqE.isIterable)(datasets)) throw new Error('The argument to zip() must be an object or array.');
    let size;
    if (Array.isArray(datasets)) for(let i = 0; i < datasets.length; i++)size = size == null ? datasets[i].size : Math.min(size, datasets[i].size);
    else if (datasets instanceof Object) for(const ds in datasets)size = size == null ? datasets[ds].size : Math.min(size, datasets[ds].size);
    return $2bf8132c96a703ca$export$3a70158aa38bbd76(async ()=>{
        const streams = await (0, $61DqE.deepMapAndAwaitAll)(datasets, (d)=>{
            if (d instanceof $2bf8132c96a703ca$export$827063163a0a89f5) return {
                value: d.iterator(),
                recurse: false
            };
            else if ((0, $61DqE.isIterable)(d)) return {
                value: null,
                recurse: true
            };
            else throw new Error("Leaves of the structure passed to zip() must be Datasets, not primitives.");
        });
        return (0, $6bIfc.iteratorFromZipped)(streams, (0, $6bIfc.ZipMismatchMode).SHORTEST);
    }, size);
}
/**
 * A zip function for use with deepZip, passed via the columnMajorBatch call.
 *
 * Accepts an array of identically-structured nested elements and either batches
 * them (if they are primitives, numeric arrays, or Tensors) or requests
 * recursion (if not).
 */ // tslint:disable-next-line:no-any
function $2bf8132c96a703ca$var$deepBatchConcat(rows) {
    if (rows === null) return null;
    // use the first item to decide whether to recurse or batch here.
    const exampleRow = rows[0];
    if ((0, $61DqE.canTensorify)(exampleRow)) {
        // rows is an array of primitives, Tensors, or arrays.  Batch them.
        const value = $2bf8132c96a703ca$var$batchConcat(rows);
        return {
            value: value,
            recurse: false
        };
    }
    // the example row is an object, so recurse into it.
    return {
        value: null,
        recurse: true
    };
}
/**
 * Assembles a list of same-shaped numbers, number arrays, or Tensors
 * into a single new Tensor where axis 0 is the batch dimension.
 */ function $2bf8132c96a703ca$var$batchConcat(arrays) {
    if (arrays.length === 0) // We can't return an empty Tensor because we don't know the element shape.
    throw new Error('Can\'t make a batch of zero elements.');
    if (arrays[0] instanceof $bVnU9.Tensor) // Input is an array of Tensors
    return $iSKul.stack(arrays);
    else // Input is a possibly-nested array of numbers.
    return $ec8bD.tensor(arrays);
}

});
parcelRegister("6bIfc", function(module, exports) {

$parcel$export(module.exports, "iteratorFromItems", () => $4816172002f04658$export$313b11d04150405f);
$parcel$export(module.exports, "iteratorFromFunction", () => $4816172002f04658$export$392feaf09f7ef035);
$parcel$export(module.exports, "iteratorFromConcatenated", () => $4816172002f04658$export$a9a63cf863a3bed5);
$parcel$export(module.exports, "iteratorFromZipped", () => $4816172002f04658$export$5ecdf828f976b66e);
$parcel$export(module.exports, "ZipMismatchMode", () => $4816172002f04658$export$4b13032c4dd08391);
$parcel$export(module.exports, "LazyIterator", () => $4816172002f04658$export$b7f78d762925efef);
$parcel$export(module.exports, "OneToManyIterator", () => $4816172002f04658$export$3c2cec00242a8bd8);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("5n9DG");
var $9c0Qr = parcelRequire("9c0Qr");
var $1vhox = parcelRequire("1vhox");
var $wx9lK = parcelRequire("wx9lK");

var $ftPHE = parcelRequire("ftPHE");

var $lao7V = parcelRequire("lao7V");

var $61DqE = parcelRequire("61DqE");

var $io0F6 = parcelRequire("io0F6");

var $6SoL7 = parcelRequire("6SoL7");
function $4816172002f04658$export$313b11d04150405f(items) {
    return new $4816172002f04658$var$ArrayIterator(items);
}
function $4816172002f04658$export$8dc48c1840268a(start) {
    let i = start;
    return $4816172002f04658$export$392feaf09f7ef035(()=>({
            value: i++,
            done: false
        }));
}
function $4816172002f04658$export$392feaf09f7ef035(func) {
    return new $4816172002f04658$var$FunctionCallIterator(func);
}
function $4816172002f04658$export$a9a63cf863a3bed5(baseIterators, baseErrorHandler) {
    return new $4816172002f04658$export$22a7cbb11e3b9068(baseIterators, baseErrorHandler);
}
function $4816172002f04658$export$89912d30bab1596b(iteratorFunc, count, baseErrorHandler) {
    return $4816172002f04658$export$a9a63cf863a3bed5($4816172002f04658$export$392feaf09f7ef035(iteratorFunc).take(count), baseErrorHandler);
}
function $4816172002f04658$export$5ecdf828f976b66e(iterators, mismatchMode = $4816172002f04658$export$4b13032c4dd08391.FAIL) {
    return new $4816172002f04658$var$ZipIterator(iterators, mismatchMode);
}
class $4816172002f04658$export$b7f78d762925efef {
    /**
     * Collect all remaining elements of a bounded stream into an array.
     * Obviously this will succeed only for small streams that fit in memory.
     * Useful for testing.
     *
     * @returns A Promise for an array of stream elements, which will resolve
     *   when the stream is exhausted.
     */ async toArray() {
        const result = [];
        let x = await this.next();
        while(!x.done){
            result.push(x.value);
            x = await this.next();
        }
        return result;
    }
    /**
     * Collect all elements of this dataset into an array with prefetching 100
     * elements. This is useful for testing, because the prefetch changes the
     * order in which the Promises are resolved along the processing pipeline.
     * This may help expose bugs where results are dependent on the order of
     * Promise resolution rather than on the logical order of the stream (i.e.,
     * due to hidden mutable state).
     *
     * @returns A Promise for an array of stream elements, which will resolve
     *   when the stream is exhausted.
     */ async toArrayForTest() {
        const stream = this.prefetch(100);
        const result = [];
        let x = await stream.next();
        while(!x.done){
            result.push(x.value);
            x = await stream.next();
        }
        return result;
    }
    /**
     * Draw items from the stream until it is exhausted.
     *
     * This can be useful when the stream has side effects but no output.  In
     * that case, calling this function guarantees that the stream will be
     * fully processed.
     */ async resolveFully() {
        let x = await this.next();
        while(!x.done)x = await this.next();
    }
    /**
     * Draw items from the stream until it is exhausted, or a predicate fails.
     *
     * This can be useful when the stream has side effects but no output.  In
     * that case, calling this function guarantees that the stream will be
     * fully processed.
     */ async resolveWhile(predicate) {
        let x = await this.next();
        let shouldContinue = predicate(x.value);
        while(!x.done && shouldContinue){
            x = await this.next();
            shouldContinue = predicate(x.value);
        }
    }
    /**
     * Handles errors thrown on this stream using a provided handler function.
     *
     * @param handler A function that handles any `Error` thrown during a `next()`
     *   call and returns true if the stream should continue (dropping the failed
     *   call) or false if the stream should quietly terminate.  If the handler
     *   itself throws (or rethrows) an `Error`, that will be propagated.
     *
     * @returns A `LazyIterator` of elements passed through from upstream,
     *   possibly filtering or terminating on upstream `next()` calls that
     *   throw an `Error`.
     */ handleErrors(handler) {
        return new $4816172002f04658$var$ErrorHandlingLazyIterator(this, handler);
    }
    // TODO(soergel): Implement reduce() etc.
    /**
     * Filters this stream according to `predicate`.
     *
     * @param predicate A function mapping a stream element to a boolean or a
     * `Promise` for one.
     *
     * @returns A `LazyIterator` of elements for which the predicate was true.
     */ filter(predicate) {
        return new $4816172002f04658$var$FilterIterator(this, predicate);
    }
    /**
     * Maps this stream through a 1-to-1 transform.
     *
     * @param transform A function mapping a stream element to a transformed
     *   element.
     *
     * @returns A `LazyIterator` of transformed elements.
     */ map(transform) {
        return new $4816172002f04658$var$MapIterator(this, transform);
    }
    /**
     * Maps this stream through an async 1-to-1 transform.
     *
     * @param transform A function mapping a stream element to a `Promise` for a
     *   transformed stream element.
     *
     * @returns A `LazyIterator` of transformed elements.
     */ mapAsync(transform) {
        return new $4816172002f04658$var$AsyncMapIterator(this, transform);
    }
    /**
     * Maps this stream through a 1-to-1 transform, forcing serial execution.
     *
     * @param transform A function mapping a stream element to a transformed
     *   element.
     *
     * @returns A `LazyIterator` of transformed elements.
     */ serialMapAsync(transform) {
        return new $4816172002f04658$var$AsyncMapIterator(this, transform).serial();
    }
    /**
     * Maps this stream through a 1-to-many transform.
     *
     * @param transform A function mapping a stream element to an array of
     *   transformed elements.
     *
     * @returns A `DataStream` of transformed elements.
     */ flatmap(transform) {
        return new $4816172002f04658$var$FlatmapIterator(this, transform);
    }
    /**
     * Apply a function to every element of the stream.
     *
     * @param f A function to apply to each stream element.
     */ async forEachAsync(f) {
        return this.map(f).resolveFully();
    }
    /**
     * Apply a function to every element of the stream, forcing serial execution.
     *
     * @param f A function to apply to each stream element.  Should return 'true'
     *   to indicate that the stream should continue, or 'false' to cause it to
     *   terminate.
     */ async serialForEach(f) {
        return this.serialMapAsync(f).resolveWhile((x)=>x === true);
    }
    /**
     * Groups elements into batches, represented as arrays of elements.
     *
     * We can think of the elements of this iterator as 'rows' (even if they are
     * nested structures).  By the same token, consecutive values for a given
     * key within the elements form a 'column'.  This matches the usual sense of
     * 'row' and 'column' when processing tabular data (e.g., parsing a CSV).
     *
     * Thus, "Row-major" means that the resulting batch is simply a collection of
     * rows: `[row1, row2, row3, ...]`.  This is contrast to the column-major
     * form, which is needed for vectorized computation.
     *
     * @param batchSize The number of elements desired per batch.
     * @param smallLastBatch Whether to emit the final batch when it has fewer
     *   than batchSize elements. Default true.
     * @returns A `LazyIterator` of batches of elements, represented as arrays
     *   of the original element type.
     */ rowMajorBatch(batchSize, smallLastBatch = true) {
        return new $4816172002f04658$var$RowMajorBatchIterator(this, batchSize, smallLastBatch);
    }
    /**
     * Groups elements into batches, represented in column-major form.
     *
     * We can think of the elements of this iterator as 'rows' (even if they are
     * nested structures).  By the same token, consecutive values for a given
     * key within the elements form a 'column'.  This matches the usual sense of
     * 'row' and 'column' when processing tabular data (e.g., parsing a CSV).
     *
     * Thus, "column-major" means that the resulting batch is a (potentially
     * nested) structure representing the columns.  Each column entry, then,
     * contains a collection of the values found in that column for a range of
     * input elements.  This representation allows for vectorized computation, in
     * contrast to the row-major form.
     *
     * The inputs should all have the same nested structure (i.e., of arrays and
     * dicts).  The result is a single object with the same nested structure,
     * where the leaves are arrays collecting the values of the inputs at that
     * location (or, optionally, the result of a custom function applied to those
     * arrays).
     *
     * @param batchSize The number of elements desired per batch.
     * @param smallLastBatch Whether to emit the final batch when it has fewer
     *   than batchSize elements. Default true.
     * @param zipFn: (optional) A function that expects an array of elements at a
     *   single node of the object tree, and returns a `DeepMapResult`.  The
     *   `DeepMapResult` either provides a result value for that node (i.e.,
     *   representing the subtree), or indicates that the node should be processed
     *   recursively.  The default zipFn recurses as far as possible and places
     *   arrays at the leaves.
     * @returns A `LazyIterator` of batches of elements, represented as an object
     *   with collections at the leaves.
     */ columnMajorBatch(batchSize, smallLastBatch = true, // tslint:disable-next-line:no-any
    zipFn = (0, $61DqE.zipToList)) {
        // First collect the desired number of input elements as a row-major batch.
        const rowBatches = this.rowMajorBatch(batchSize, smallLastBatch);
        // Now 'rotate' or 'pivot' the data, collecting all values from each column
        // in the batch (i.e., for each key within the elements) into an array.
        return rowBatches.map((x)=>(0, $61DqE.deepZip)(x, zipFn));
    }
    /**
     * Concatenate this `LazyIterator` with another.
     *
     * @param iterator A `LazyIterator` to be concatenated onto this one.
     * @param baseErrorHandler An optional function that can intercept `Error`s
     *   raised during a `next()` call on the base stream.  This function can
     *   decide whether the error should be propagated, whether the error should
     *   be ignored, or whether the base stream should be terminated.
     * @returns A `LazyIterator`.
     */ concatenate(iterator, baseErrorHandler) {
        return new $4816172002f04658$export$22a7cbb11e3b9068($4816172002f04658$export$313b11d04150405f([
            this,
            iterator
        ]), baseErrorHandler);
    }
    /**
     * Limits this stream to return at most `count` items.
     *
     * @param count The maximum number of items to provide from the stream. If
     * a negative or undefined value is given, the entire stream is returned
     *   unaltered.
     */ take(count) {
        if (count < 0 || count == null) return this;
        return new $4816172002f04658$var$TakeIterator(this, count);
    }
    /**
     * Skips the first `count` items in this stream.
     *
     * @param count The number of items to skip.  If a negative or undefined
     * value is given, the entire stream is returned unaltered.
     */ skip(count) {
        if (count < 0 || count == null) return this;
        return new $4816172002f04658$var$SkipIterator(this, count);
    }
    /**
     * Prefetch the first `bufferSize` items in this stream.
     *
     * Note this prefetches Promises, but makes no guarantees about when those
     * Promises resolve.
     *
     * @param bufferSize: An integer specifying the number of elements to be
     *   prefetched.
     */ prefetch(bufferSize) {
        return new $4816172002f04658$export$7126304418df8697(this, bufferSize);
    }
    // TODO(soergel): deep sharded shuffle, where supported
    /**
     * Randomly shuffles the elements of this stream.
     *
     * @param bufferSize: An integer specifying the number of elements from
     * this stream from which the new stream will sample.
     * @param seed: (Optional.) An integer specifying the random seed that
     * will be used to create the distribution.
     */ shuffle(windowSize, seed) {
        return new $4816172002f04658$export$50d642f401310a09(this, windowSize, seed);
    }
    /**
     * Force an iterator to execute serially: each next() call will await the
     * prior one, so that they cannot execute concurrently.
     */ serial() {
        return new $4816172002f04658$var$SerialIterator(this);
    }
}
// ============================================================================
// The following private classes serve to implement the chainable methods
// on LazyIterator.  Unfortunately they can't be placed in separate files,
// due to resulting trouble with circular imports.
// ============================================================================
// Iterators that just extend LazyIterator directly
// ============================================================================
class $4816172002f04658$var$ArrayIterator extends $4816172002f04658$export$b7f78d762925efef {
    constructor(items){
        super();
        this.items = items;
        this.trav = 0;
    }
    summary() {
        return `Array of ${this.items.length} items`;
    }
    async next() {
        if (this.trav >= this.items.length) return {
            value: null,
            done: true
        };
        const item = this.items[this.trav];
        this.trav++;
        return {
            value: (0, $lao7V.deepClone)(item),
            done: false
        };
    }
}
class $4816172002f04658$var$FunctionCallIterator extends $4816172002f04658$export$b7f78d762925efef {
    constructor(nextFn){
        super();
        this.nextFn = nextFn;
    }
    summary() {
        return `Function call`;
    }
    async next() {
        try {
            return this.nextFn();
        } catch (e) {
            // Modify the error message but leave the stack trace intact
            e.message = `Error thrown while iterating through a dataset: ${e.message}`;
            throw e;
        }
    }
}
class $4816172002f04658$var$SerialIterator extends $4816172002f04658$export$b7f78d762925efef {
    constructor(upstream){
        super();
        this.upstream = upstream;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> Serial`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        return this.upstream.next();
    }
}
class $4816172002f04658$var$SkipIterator extends $4816172002f04658$export$b7f78d762925efef {
    constructor(upstream, maxCount){
        super();
        this.upstream = upstream;
        this.maxCount = maxCount;
        // Local state that should not be clobbered by out-of-order execution.
        this.count = 0;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> Skip`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        // TODO(soergel): consider tradeoffs of reading in parallel, eg.
        // collecting next() promises in an Array and then waiting for
        // Promise.all() of those. Benefit: pseudo-parallel execution.  Drawback:
        // maybe delayed GC.
        while(this.count++ < this.maxCount){
            const skipped = await this.upstream.next();
            // short-circuit if upstream is already empty
            if (skipped.done) return skipped;
            $9c0Qr.dispose(skipped.value);
        }
        return this.upstream.next();
    }
}
class $4816172002f04658$var$TakeIterator extends $4816172002f04658$export$b7f78d762925efef {
    constructor(upstream, maxCount){
        super();
        this.upstream = upstream;
        this.maxCount = maxCount;
        this.count = 0;
    }
    summary() {
        return `${this.upstream.summary()} -> Take`;
    }
    async next() {
        if (this.count++ >= this.maxCount) return {
            value: null,
            done: true
        };
        return this.upstream.next();
    }
}
// Note this batch just groups items into row-wise element arrays.
// Rotating these to a column-wise representation happens only at the dataset
// level.
class $4816172002f04658$var$RowMajorBatchIterator extends $4816172002f04658$export$b7f78d762925efef {
    constructor(upstream, batchSize, enableSmallLastBatch = true){
        super();
        this.upstream = upstream;
        this.batchSize = batchSize;
        this.enableSmallLastBatch = enableSmallLastBatch;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> RowMajorBatch`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        const batch = [];
        while(batch.length < this.batchSize){
            const item = await this.upstream.next();
            if (item.done) {
                if (this.enableSmallLastBatch && batch.length > 0) return {
                    value: batch,
                    done: false
                };
                return {
                    value: null,
                    done: true
                };
            }
            batch.push(item.value);
        }
        return {
            value: batch,
            done: false
        };
    }
}
class $4816172002f04658$var$FilterIterator extends $4816172002f04658$export$b7f78d762925efef {
    constructor(upstream, predicate){
        super();
        this.upstream = upstream;
        this.predicate = predicate;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> Filter`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        while(true){
            const item = await this.upstream.next();
            if (item.done || this.predicate(item.value)) return item;
            $9c0Qr.dispose(item.value);
        }
    }
}
class $4816172002f04658$var$MapIterator extends $4816172002f04658$export$b7f78d762925efef {
    constructor(upstream, transform){
        super();
        this.upstream = upstream;
        this.transform = transform;
    }
    summary() {
        return `${this.upstream.summary()} -> Map`;
    }
    async next() {
        const item = await this.upstream.next();
        if (item.done) return {
            value: null,
            done: true
        };
        const inputTensors = $1vhox.getTensorsInContainer(item.value);
        // Careful: the transform may mutate the item in place.
        // That's why we have to remember the input Tensors above, and then
        // below dispose only those that were not passed through to the output.
        // Note too that the transform function is responsible for tidying
        // any intermediate Tensors.  Here we are concerned only about the
        // inputs.
        const mapped = this.transform(item.value);
        const outputTensors = $1vhox.getTensorsInContainer(mapped);
        // TODO(soergel) faster intersection
        // TODO(soergel) move to tf.disposeExcept(in, out)?
        for (const t of inputTensors)if (!$1vhox.isTensorInList(t, outputTensors)) t.dispose();
        return {
            value: mapped,
            done: false
        };
    }
}
class $4816172002f04658$var$ErrorHandlingLazyIterator extends $4816172002f04658$export$b7f78d762925efef {
    constructor(upstream, handler){
        super();
        this.upstream = upstream;
        this.handler = handler;
        this.count = 0;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> handleErrors`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        while(true)try {
            return await this.upstream.next();
        } catch (e) {
            if (!this.handler(e)) return {
                value: null,
                done: true
            };
        // If the handler returns true, loop and fetch the next upstream item.
        // If the upstream iterator throws an endless stream of errors, and if
        // the handler says to ignore them, then we loop forever here.  That is
        // the correct behavior-- it's up to the handler to decide when to stop.
        }
    }
}
class $4816172002f04658$var$AsyncMapIterator extends $4816172002f04658$export$b7f78d762925efef {
    constructor(upstream, transform){
        super();
        this.upstream = upstream;
        this.transform = transform;
    }
    summary() {
        return `${this.upstream.summary()} -> AsyncMap`;
    }
    async next() {
        const item = await this.upstream.next();
        if (item.done) return {
            value: null,
            done: true
        };
        const inputTensors = $1vhox.getTensorsInContainer(item.value);
        // Careful: the transform may mutate the item in place.
        // That's why we have to remember the input Tensors above, and then
        // below dispose only those that were not passed through to the output.
        // Note too that the transform function is responsible for tidying
        // any intermediate Tensors.  Here we are concerned only about the
        // inputs.
        const mapped = await this.transform(item.value);
        const outputTensors = $1vhox.getTensorsInContainer(mapped);
        // TODO(soergel) faster intersection
        // TODO(soergel) move to tf.disposeExcept(in, out)?
        for (const t of inputTensors)if (!$1vhox.isTensorInList(t, outputTensors)) t.dispose();
        return {
            value: mapped,
            done: false
        };
    }
}
class $4816172002f04658$export$3c2cec00242a8bd8 extends $4816172002f04658$export$b7f78d762925efef {
    constructor(){
        super();
        this.outputQueue = new (0, $io0F6.GrowingRingBuffer)();
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        // Fetch so that the queue contains at least one item if possible.
        // If the upstream source is exhausted, AND there are no items left in
        // the output queue, then this stream is also exhausted.
        while(this.outputQueue.length() === 0){
            // TODO(soergel): consider parallel reads.
            if (!await this.pump()) return {
                value: null,
                done: true
            };
        }
        return {
            value: this.outputQueue.shift(),
            done: false
        };
    }
}
class $4816172002f04658$var$FlatmapIterator extends $4816172002f04658$export$3c2cec00242a8bd8 {
    constructor(upstream, transform){
        super();
        this.upstream = upstream;
        this.transform = transform;
    }
    summary() {
        return `${this.upstream.summary()} -> Flatmap`;
    }
    async pump() {
        const item = await this.upstream.next();
        if (item.done) return false;
        const inputTensors = $1vhox.getTensorsInContainer(item.value);
        // Careful: the transform may mutate the item in place.
        // that's why we have to remember the input Tensors above, and then
        // below dispose only those that were not passed through to the output.
        // Note too that the transform function is responsible for tidying any
        // intermediate Tensors.  Here we are concerned only about the inputs.
        const mappedArray = this.transform(item.value);
        const outputTensors = $1vhox.getTensorsInContainer(mappedArray);
        this.outputQueue.pushAll(mappedArray);
        // TODO(soergel) faster intersection, and deduplicate outputTensors
        // TODO(soergel) move to tf.disposeExcept(in, out)?
        for (const t of inputTensors)if (!$1vhox.isTensorInList(t, outputTensors)) t.dispose();
        return true;
    }
}
class $4816172002f04658$export$22a7cbb11e3b9068 extends $4816172002f04658$export$b7f78d762925efef {
    constructor(iterators, baseErrorHandler){
        super();
        this.baseErrorHandler = baseErrorHandler;
        // Strict Promise execution order:
        // a next() call may not even begin until the previous one completes.
        this.lastRead = null;
        // Local state that should not be clobbered by out-of-order execution.
        this.iterator = null;
        this.moreIterators = iterators;
    }
    summary() {
        const upstreamSummaries = 'TODO: fill in upstream of chained summaries';
        return `${upstreamSummaries} -> Chained`;
    }
    async next() {
        this.lastRead = this.readFromChain(this.lastRead);
        return this.lastRead;
    }
    async readFromChain(lastRead) {
        // Must await on the previous read since the previous read may have advanced
        // the stream of streams, from which we need to read.
        // This is unfortunate since we can't parallelize reads. Which means
        // prefetching of chained streams is a no-op.
        // One solution is to prefetch immediately upstream of this.
        await lastRead;
        if (this.iterator == null) {
            const iteratorResult = await this.moreIterators.next();
            if (iteratorResult.done) // No more streams to stream from.
            return {
                value: null,
                done: true
            };
            this.iterator = iteratorResult.value;
            if (this.baseErrorHandler != null) this.iterator = this.iterator.handleErrors(this.baseErrorHandler);
        }
        const itemResult = await this.iterator.next();
        if (itemResult.done) {
            this.iterator = null;
            return this.readFromChain(lastRead);
        }
        return itemResult;
    }
}
var $4816172002f04658$export$4b13032c4dd08391;
(function(ZipMismatchMode) {
    ZipMismatchMode[ZipMismatchMode["FAIL"] = 0] = "FAIL";
    ZipMismatchMode[ZipMismatchMode["SHORTEST"] = 1] = "SHORTEST";
    ZipMismatchMode[ZipMismatchMode["LONGEST"] = 2] = "LONGEST"; // use nulls for exhausted streams; use up the longest stream.
})($4816172002f04658$export$4b13032c4dd08391 || ($4816172002f04658$export$4b13032c4dd08391 = {}));
/**
 * Provides a `LazyIterator` that zips together an array, dict, or nested
 * structure of `LazyIterator`s (and perhaps additional constants).
 *
 * The underlying streams must provide elements in a consistent order such
 * that they correspond.
 *
 * Typically, the underlying streams should have the same number of
 * elements. If they do not, the behavior is determined by the
 * `mismatchMode` argument.
 *
 * The nested structure of the `iterators` argument determines the
 * structure of elements in the resulting iterator.
 *
 * Doing this in a concurrency-safe way requires some trickery.  In
 * particular, we want this stream to return the elements from the
 * underlying streams in the correct order according to when next() was
 * called, even if the resulting Promises resolve in a different order.
 *
 * @param iterators: An array or object containing LazyIterators at the
 * leaves.
 * @param mismatchMode: Determines what to do when one underlying iterator
 * is exhausted before the others.  `ZipMismatchMode.FAIL` (the default)
 * causes an error to be thrown in this case.  `ZipMismatchMode.SHORTEST`
 * causes the zipped iterator to terminate with the furst underlying
 * streams, so elements remaining on the longer streams are ignored.
 * `ZipMismatchMode.LONGEST` causes the zipped stream to continue, filling
 * in nulls for the exhausted streams, until all streams are exhausted.
 */ class $4816172002f04658$var$ZipIterator extends $4816172002f04658$export$b7f78d762925efef {
    constructor(iterators, mismatchMode = $4816172002f04658$export$4b13032c4dd08391.FAIL){
        super();
        this.iterators = iterators;
        this.mismatchMode = mismatchMode;
        this.count = 0;
        this.currentPromise = null;
    }
    summary() {
        const upstreamSummaries = 'TODO: fill in upstream of zip summaries';
        return `{${upstreamSummaries}} -> Zip`;
    }
    async nextState(afterState) {
        // This chaining ensures that the underlying next() are not even called
        // before the previous ones have resolved.
        await afterState;
        // Collect underlying iterator "done" signals as a side effect in
        // getNext()
        let numIterators = 0;
        let iteratorsDone = 0;
        function getNext(container) {
            if (container instanceof $4816172002f04658$export$b7f78d762925efef) {
                const result = container.next();
                return {
                    value: result.then((x)=>{
                        numIterators++;
                        if (x.done) iteratorsDone++;
                        return x.value;
                    }),
                    recurse: false
                };
            } else return {
                value: null,
                recurse: true
            };
        }
        const mapped = await (0, $61DqE.deepMapAndAwaitAll)(this.iterators, getNext);
        if (numIterators === iteratorsDone) // The streams have all ended.
        return {
            value: null,
            done: true
        };
        if (iteratorsDone > 0) switch(this.mismatchMode){
            case $4816172002f04658$export$4b13032c4dd08391.FAIL:
                throw new Error('Zipped streams should have the same length. ' + `Mismatched at element ${this.count}.`);
            case $4816172002f04658$export$4b13032c4dd08391.SHORTEST:
                return {
                    value: null,
                    done: true
                };
            case $4816172002f04658$export$4b13032c4dd08391.LONGEST:
            default:
        }
        this.count++;
        return {
            value: mapped,
            done: false
        };
    }
    async next() {
        this.currentPromise = this.nextState(this.currentPromise);
        return this.currentPromise;
    }
}
class $4816172002f04658$export$7126304418df8697 extends $4816172002f04658$export$b7f78d762925efef {
    constructor(upstream, bufferSize){
        super();
        this.upstream = upstream;
        this.bufferSize = bufferSize;
        this.buffer = new (0, $6SoL7.RingBuffer)(bufferSize);
    }
    summary() {
        return `${this.upstream.summary()} -> Prefetch`;
    }
    /**
     * Refill the prefetch buffer.  Returns only after the buffer is full, or
     * the upstream source is exhausted.
     */ refill() {
        while(!this.buffer.isFull()){
            const v = this.upstream.next();
            this.buffer.push(v);
        }
    }
    next() {
        this.refill();
        // This shift will never throw an error because the buffer is always
        // full after a refill. If the stream is exhausted, the buffer will be
        // full of Promises that will resolve to the end-of-stream signal.
        return this.buffer.shift();
    }
}
class $4816172002f04658$export$50d642f401310a09 extends $4816172002f04658$export$7126304418df8697 {
    constructor(upstream, windowSize, seed){
        super(upstream, windowSize);
        this.upstream = upstream;
        this.windowSize = windowSize;
        // Local state that should not be clobbered by out-of-order execution.
        this.upstreamExhausted = false;
        this.random = $ftPHE.alea(seed || $wx9lK.now().toString());
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    randomInt(max) {
        return Math.floor(this.random() * max);
    }
    chooseIndex() {
        return this.randomInt(this.buffer.length());
    }
    async serialNext() {
        // TODO(soergel): consider performance
        if (!this.upstreamExhausted) this.refill();
        while(!this.buffer.isEmpty()){
            const chosenIndex = this.chooseIndex();
            const result = await this.buffer.shuffleExcise(chosenIndex);
            if (result.done) this.upstreamExhausted = true;
            else {
                this.refill();
                return result;
            }
        }
        return {
            value: null,
            done: true
        };
    }
}

});
parcelRegister("lao7V", function(module, exports) {

$parcel$export(module.exports, "deepClone", () => $f68d3f3804d9e69b$export$b7d58db314e0ac27);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("5n9DG");
var $bVnU9 = parcelRequire("bVnU9");

var $61DqE = parcelRequire("61DqE");
function $f68d3f3804d9e69b$export$b7d58db314e0ac27(container) {
    return (0, $61DqE.deepMap)(container, $f68d3f3804d9e69b$var$cloneIfTensor);
}
// tslint:disable-next-line: no-any
function $f68d3f3804d9e69b$var$cloneIfTensor(item) {
    if (item instanceof $bVnU9.Tensor) return {
        value: item.clone(),
        recurse: false
    };
    else if ((0, $61DqE.isIterable)(item)) return {
        value: null,
        recurse: true
    };
    else return {
        value: item,
        recurse: false
    };
}

});
parcelRegister("61DqE", function(module, exports) {

$parcel$export(module.exports, "deepMap", () => $46316bcfa50690a1$export$ce7eaaed37329a1b);
$parcel$export(module.exports, "isIterable", () => $46316bcfa50690a1$export$9652023d9040757);
$parcel$export(module.exports, "deepZip", () => $46316bcfa50690a1$export$de254daced10325b);
$parcel$export(module.exports, "zipToList", () => $46316bcfa50690a1$export$5af6628663604bcb);
$parcel$export(module.exports, "deepMapAndAwaitAll", () => $46316bcfa50690a1$export$20eea0c38ad5b6db);
$parcel$export(module.exports, "canTensorify", () => $46316bcfa50690a1$export$2714d9e1645b25ab);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $bVnU9 = parcelRequire("bVnU9");
var $wx9lK = parcelRequire("wx9lK");
function $46316bcfa50690a1$export$ce7eaaed37329a1b(input, mapFn) {
    return $46316bcfa50690a1$var$deepMapInternal(input, mapFn);
}
/**
 * @param seen: A Map of known object mappings (i.e., memoized results of
 *   `mapFn()`)
 * @param containedIn: An set containing objects on the reference path currently
 *   being processed (used to detect cycles).
 */ function $46316bcfa50690a1$var$deepMapInternal(input, mapFn, seen = new Map(), containedIn = new Set()) {
    if (input == null) return null;
    if (typeof Blob === 'function' && input instanceof Blob) return input.slice();
    if (containedIn.has(input)) throw new Error('Circular references are not supported.');
    if (seen.has(input)) return seen.get(input);
    const result = mapFn(input);
    if (result.recurse && result.value !== null) throw new Error('A deep map function may not return both a value and recurse=true.');
    if (!result.recurse) {
        seen.set(input, result.value);
        return result.value;
    } else if ($46316bcfa50690a1$export$9652023d9040757(input)) {
        // tslint:disable-next-line:no-any
        const mappedIterable = Array.isArray(input) ? [] : {};
        containedIn.add(input);
        for(const k in input){
            const child = input[k];
            const childResult = $46316bcfa50690a1$var$deepMapInternal(child, mapFn, seen, containedIn);
            mappedIterable[k] = childResult;
        }
        containedIn.delete(input);
        if (input.__proto__) mappedIterable.__proto__ = input.__proto__;
        return mappedIterable;
    } else throw new Error(`Can't recurse into non-iterable type: ${input}`);
}
function $46316bcfa50690a1$export$de254daced10325b(inputs, zipFn = $46316bcfa50690a1$export$5af6628663604bcb) {
    return $46316bcfa50690a1$var$deepZipInternal(inputs, zipFn);
}
/**
 * @param containedIn: An set containing objects on the reference path currently
 *   being processed (used to detect cycles).
 */ function $46316bcfa50690a1$var$deepZipInternal(inputs, zipFn, containedIn = new Set()) {
    // The recursion follows the structure of input 0; it's assumed that all the
    // other inputs have the same structure.
    const input = inputs[0];
    if (containedIn.has(input)) throw new Error('Circular references are not supported.');
    const result = zipFn(inputs);
    if (result.recurse && result.value !== null) throw new Error('A deep zip function may not return both a value and recurse=true.');
    if (!result.recurse) return result.value;
    else if ($46316bcfa50690a1$export$9652023d9040757(input)) {
        // tslint:disable-next-line:no-any
        const mappedIterable = Array.isArray(input) ? [] : {};
        containedIn.add(input);
        for(const k in input){
            const children = inputs.map((x)=>x[k]);
            const childResult = $46316bcfa50690a1$var$deepZipInternal(children, zipFn, containedIn);
            mappedIterable[k] = childResult;
        }
        containedIn.delete(input);
        return mappedIterable;
    } else throw new Error(`Can't recurse into non-iterable type: ${input}`);
}
function $46316bcfa50690a1$export$5af6628663604bcb(x) {
    if (x === null) return null;
    // TODO(soergel): validate array type?
    if ($46316bcfa50690a1$export$9652023d9040757(x[0])) return {
        value: null,
        recurse: true
    };
    else return {
        value: x,
        recurse: false
    };
}
async function $46316bcfa50690a1$export$20eea0c38ad5b6db(input, mapFn) {
    const seen = new Map();
    // First do a normal deepMap, collecting Promises in 'seen' as a side effect.
    $46316bcfa50690a1$var$deepMapInternal(input, mapFn, seen);
    // Replace the Promises in 'seen' in place.
    // Note TypeScript provides no async map iteration, and regular map iteration
    // is broken too, so sadly we have to do Array.from() to make it work.
    // (There's no advantage to Promise.all(), and that would be tricky anyway.)
    for (const key of Array.from(seen.keys())){
        const value = seen.get(key);
        if ($wx9lK.isPromise(value)) {
            const mappedValue = await value;
            seen.set(key, mappedValue);
        }
    }
    // Normal deepMap again, this time filling in the resolved values.
    // It's unfortunate that we have to do two passes.
    // TODO(soergel): test performance and think harder about a fast solution.
    const result = $46316bcfa50690a1$var$deepMapInternal(input, mapFn, seen);
    return result;
}

function $46316bcfa50690a1$export$9652023d9040757(obj) {
    let isTextDecoder = false;
    if ($aymVi.env().get('IS_BROWSER')) isTextDecoder = obj instanceof TextDecoder;
    else {
        // tslint:disable-next-line:no-require-imports
        const { StringDecoder: StringDecoder } = (parcelRequire("1frus"));
        isTextDecoder = obj instanceof StringDecoder;
    }
    return obj != null && !ArrayBuffer.isView(obj) && (Array.isArray(obj) || typeof obj === 'object' && !(obj instanceof $bVnU9.Tensor) && !(obj instanceof Promise) && !isTextDecoder);
}
function $46316bcfa50690a1$export$2714d9e1645b25ab(obj) {
    return obj == null || $46316bcfa50690a1$var$isPrimitive(obj) || Array.isArray(obj) || typeof obj === 'object' && obj instanceof $bVnU9.Tensor || $wx9lK.isTypedArray(obj);
}
/**
 * Returns true if the given `value` is a primitive type. Otherwise returns
 * false. This is equivalant to node util.isPrimitive
 */ function $46316bcfa50690a1$var$isPrimitive(value) {
    return value === null || typeof value !== 'object' && typeof value !== 'function';
}

});


parcelRegister("io0F6", function(module, exports) {

$parcel$export(module.exports, "GrowingRingBuffer", () => $d62afb57c0513ff2$export$bd4eb95ce427db4d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $6SoL7 = parcelRequire("6SoL7");
class $d62afb57c0513ff2$export$bd4eb95ce427db4d extends (0, $6SoL7.RingBuffer) {
    /**
     * Constructs a `GrowingRingBuffer`.
     */ constructor(){
        super($d62afb57c0513ff2$export$bd4eb95ce427db4d.INITIAL_CAPACITY);
    }
    isFull() {
        return false;
    }
    push(value) {
        if (super.isFull()) this.expand();
        super.push(value);
    }
    unshift(value) {
        if (super.isFull()) this.expand();
        super.unshift(value);
    }
    /**
     * Doubles the capacity of the buffer.
     */ expand() {
        const newCapacity = this.capacity * 2;
        const newData = new Array(newCapacity);
        const len = this.length();
        // Rotate the buffer to start at index 0 again, since we can't just
        // allocate more space at the end.
        for(let i = 0; i < len; i++)newData[i] = this.get(this.wrap(this.begin + i));
        this.data = newData;
        this.capacity = newCapacity;
        this.doubledCapacity = 2 * this.capacity;
        this.begin = 0;
        this.end = len;
    }
}
$d62afb57c0513ff2$export$bd4eb95ce427db4d.INITIAL_CAPACITY = 32;

});
parcelRegister("6SoL7", function(module, exports) {

$parcel$export(module.exports, "RingBuffer", () => $501afdd57b566715$export$575ef0eeec6e42f5);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /**
 * A ring buffer, providing O(1) FIFO, LIFO, and related operations.
 */ class $501afdd57b566715$export$575ef0eeec6e42f5 {
    /**
     * Constructs a `RingBuffer`.
     * @param capacity The number of items that the buffer can accomodate.
     */ constructor(capacity){
        this.capacity = capacity;
        // Note we store the indices in the range 0 <= index < 2*capacity.
        // This allows us to distinguish the full from the empty case.
        // See https://www.snellman.net/blog/archive/2016-12-13-ring-buffers/
        this.begin = 0; // inclusive
        this.end = 0; // exclusive
        if (capacity == null) throw new RangeError('Can\'t create a ring buffer of unknown capacity.');
        if (capacity < 1) throw new RangeError('Can\'t create ring buffer of capacity < 1.');
        this.data = new Array(capacity);
        this.doubledCapacity = 2 * capacity;
    }
    /**
     * Map any index into the range 0 <= index < 2*capacity.
     */ wrap(index) {
        // don't trust % on negative numbers
        while(index < 0)index += this.doubledCapacity;
        return index % this.doubledCapacity;
    }
    get(index) {
        if (index < 0) throw new RangeError('Can\'t get item at a negative index.');
        return this.data[index % this.capacity];
    }
    set(index, value) {
        if (index < 0) throw new RangeError('Can\'t set item at a negative index.');
        this.data[index % this.capacity] = value;
    }
    /**
     * Returns the current number of items in the buffer.
     */ length() {
        let length = this.end - this.begin;
        if (length < 0) length = this.doubledCapacity + length;
        return length;
    }
    /**
     * Reports whether the buffer is full.
     * @returns true if the number of items in the buffer equals its capacity, and
     *   false otherwise.
     */ isFull() {
        return this.length() === this.capacity;
    }
    /**
     * Reports whether the buffer is empty.
     * @returns true if the number of items in the buffer equals zero, and
     *   false otherwise.
     */ isEmpty() {
        return this.length() === 0;
    }
    /**
     * Adds an item to the end of the buffer.
     */ push(value) {
        if (this.isFull()) throw new RangeError('Ring buffer is full.');
        this.set(this.end, value);
        this.end = this.wrap(this.end + 1);
    }
    /**
     * Adds many items to the end of the buffer, in order.
     */ pushAll(values) {
        for (const value of values)this.push(value);
    }
    /**
     * Removes and returns the last item in the buffer.
     */ pop() {
        if (this.isEmpty()) throw new RangeError('Ring buffer is empty.');
        this.end = this.wrap(this.end - 1);
        const result = this.get(this.end);
        this.set(this.end, undefined);
        return result;
    }
    /**
     * Adds an item to the beginning of the buffer.
     */ unshift(value) {
        if (this.isFull()) throw new RangeError('Ring buffer is full.');
        this.begin = this.wrap(this.begin - 1);
        this.set(this.begin, value);
    }
    /**
     * Removes and returns the first item in the buffer.
     */ shift() {
        if (this.isEmpty()) throw new RangeError('Ring buffer is empty.');
        const result = this.get(this.begin);
        this.set(this.begin, undefined);
        this.begin = this.wrap(this.begin + 1);
        return result;
    }
    /**
     * Removes and returns a specific item in the buffer, and moves the last item
     * to the vacated slot.  This is useful for implementing a shuffling stream.
     * Note that this operation necessarily scrambles the original order.
     *
     * @param relativeIndex: the index of the item to remove, relative to the
     *   first item in the buffer (e.g., hiding the ring nature of the underlying
     *   storage).
     */ shuffleExcise(relativeIndex) {
        if (this.isEmpty()) throw new RangeError('Ring buffer is empty.');
        const index = this.wrap(this.begin + relativeIndex);
        const result = this.get(index);
        this.set(index, this.pop());
        return result;
    }
}

});




parcelRegister("7kP9G", function(module, exports) {

$parcel$export(module.exports, "CSVDataset", () => $55721507d1de047f$export$1e441948ffa5f20a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $3M2Rw = parcelRequire("3M2Rw");

var $7EcID = parcelRequire("7EcID");
const $55721507d1de047f$var$CODE_QUOTE = '"';
const $55721507d1de047f$var$STATE_OUT = Symbol('out');
const $55721507d1de047f$var$STATE_FIELD = Symbol('field');
const $55721507d1de047f$var$STATE_QUOTE = Symbol('quote');
const $55721507d1de047f$var$STATE_QUOTE_AFTER_QUOTE = Symbol('quoteafterquote');
const $55721507d1de047f$var$STATE_WITHIN_QUOTE_IN_QUOTE = Symbol('quoteinquote');
class $55721507d1de047f$export$1e441948ffa5f20a extends (0, $3M2Rw.Dataset) {
    /**
     * Create a `CSVDataset`.
     *
     * @param input A `DataSource` providing a chunked, UTF8-encoded byte stream.
     * @param csvConfig (Optional) A CSVConfig object that contains configurations
     *     of reading and decoding from CSV file(s).
     *
     *     hasHeader: (Optional) A boolean value that indicates whether the first
     *     row of provided CSV file is a header line with column names, and should
     *     not be included in the data. Defaults to `true`.
     *
     *     columnNames: (Optional) A list of strings that corresponds to
     *     the CSV column names, in order. If provided, it ignores the column
     *     names inferred from the header row. If not provided, infers the column
     *     names from the first row of the records. If hasHeader is false and
     *     columnNames is not provided, this method throws an error.
     *
     *     columnConfigs: (Optional) A dictionary whose key is column names, value
     *     is an object stating if this column is required, column's data type,
     *     default value, and if this column is label. If provided, keys must
     *     correspond to names provided in columnNames or inferred from the file
     *     header lines. If isLabel is true any column, returns an array of two
     *     items: the first item is a dict of features key/value pairs, the second
     *     item is a dict of labels key/value pairs. If no feature is marked as
     *     label, returns a dict of features only.
     *
     *     configuredColumnsOnly (Optional) If true, only columns provided in
     *     columnConfigs will be parsed and provided during iteration.
     *
     *     delimiter (Optional) The string used to parse each line of the input
     *     file. Defaults to `,`.
     */ constructor(input, csvConfig){
        super();
        this.input = input;
        this.hasHeader = true;
        this.fullColumnNames = null;
        this.columnNamesValidated = false;
        this.columnConfigs = null;
        this.configuredColumnsOnly = false;
        this.delimiter = ',';
        this.delimWhitespace = false;
        this.base = new (0, $7EcID.TextLineDataset)(input);
        if (!csvConfig) csvConfig = {};
        this.hasHeader = csvConfig.hasHeader === false ? false : true;
        this.fullColumnNames = csvConfig.columnNames;
        this.columnConfigs = csvConfig.columnConfigs;
        this.configuredColumnsOnly = csvConfig.configuredColumnsOnly;
        if (csvConfig.delimWhitespace) {
            (0, $wx9lK).assert(csvConfig.delimiter == null, ()=>'Delimiter should not be provided when delimWhitespace is true.');
            this.delimWhitespace = true;
            this.delimiter = ' ';
        } else this.delimiter = csvConfig.delimiter ? csvConfig.delimiter : ',';
    }
    /**
     * Returns column names of the csv dataset. If `configuredColumnsOnly` is
     * true, return column names in `columnConfigs`. If `configuredColumnsOnly` is
     * false and `columnNames` is provided, `columnNames`. If
     * `configuredColumnsOnly` is false and `columnNames` is not provided, return
     * all column names parsed from the csv file. For example usage please go to
     * `tf.data.csv`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ async columnNames() {
        if (!this.columnNamesValidated) await this.setColumnNames();
        return this.configuredColumnsOnly ? Object.keys(this.columnConfigs) : this.fullColumnNames;
    }
    /* 1) If `columnNames` is provided as string[], use this string[] as output
     * keys in corresponding order. The length must match the number of inferred
     * columns if `hasHeader` is true .
     * 2) If `columnNames` is not provided, parse header line as `columnNames` if
     * hasHeader is true. If `hasHeader` is false, throw an error.
     * 3) If `columnConfigs` is provided, all the keys in `columnConfigs` must
     * exist in parsed `columnNames`.
     */ async setColumnNames() {
        const columnNamesFromFile = await this.maybeReadHeaderLine();
        if (!this.fullColumnNames && !columnNamesFromFile) // Throw an error if columnNames is not provided and no header line.
        throw new Error('Column names must be provided if there is no header line.');
        else if (this.fullColumnNames && columnNamesFromFile) // Check provided columnNames match header line.
        (0, $wx9lK).assert(columnNamesFromFile.length === this.fullColumnNames.length, ()=>'The length of provided columnNames (' + this.fullColumnNames.length.toString() + ') does not match the length of the header line read from ' + 'file (' + columnNamesFromFile.length.toString() + ').');
        if (!this.fullColumnNames) this.fullColumnNames = columnNamesFromFile;
        // Check if there are duplicate column names.
        const counts = this.fullColumnNames.reduce((countAcc, name)=>{
            countAcc[name] = countAcc[name] + 1 || 1;
            return countAcc;
        }, {});
        const duplicateNames = Object.keys(counts).filter((name)=>counts[name] > 1);
        (0, $wx9lK).assert(duplicateNames.length === 0, ()=>'Duplicate column names found: ' + duplicateNames.toString());
        // Check if keys in columnConfigs match columnNames.
        if (this.columnConfigs) for (const key of Object.keys(this.columnConfigs)){
            const index = this.fullColumnNames.indexOf(key);
            if (index === -1) throw new Error('The key "' + key + '" provided in columnConfigs does not match any of the column ' + 'names (' + this.fullColumnNames.toString() + ').');
        }
        this.columnNamesValidated = true;
    }
    async maybeReadHeaderLine() {
        if (this.hasHeader) {
            const iter = await this.base.iterator();
            const firstElement = await iter.next();
            if (firstElement.done) throw new Error('No data was found for CSV parsing.');
            const firstLine = firstElement.value;
            const headers = this.parseRow(firstLine, false);
            return headers;
        } else return null;
    }
    async iterator() {
        if (!this.columnNamesValidated) await this.setColumnNames();
        let lines = await this.base.iterator();
        if (this.hasHeader) // We previously read the first line to get the columnNames.
        // Now that we're providing data, skip it.
        lines = lines.skip(1);
        return lines.map((x)=>this.makeDataElement(x));
    }
    makeDataElement(line) {
        const values = this.parseRow(line);
        const features = {};
        const labels = {};
        for(let i = 0; i < this.fullColumnNames.length; i++){
            const key = this.fullColumnNames[i];
            const config = this.columnConfigs ? this.columnConfigs[key] : null;
            if (this.configuredColumnsOnly && !config) continue;
            else {
                const value = values[i];
                let parsedValue = null;
                if (value === '') {
                    // If default value is provided, use it. If default value is not
                    // provided, set as undefined.
                    if (config && config.default !== undefined) parsedValue = config.default;
                    else if (config && (config.required || config.isLabel)) throw new Error(`Required column ${key} is empty in this line: ${line}`);
                    else parsedValue = undefined;
                } else {
                    // A value is present, so parse it based on type
                    const valueAsNum = Number(value);
                    if (isNaN(valueAsNum)) {
                        // The value is a string and this column is declared as boolean
                        // in config, parse it as boolean.
                        if (config && config.dtype === 'bool') parsedValue = this.getBoolean(value);
                        else // Set value as string
                        parsedValue = value;
                    } else if (!config || !config.dtype) // If this value is a number and no type config is provided, return
                    // it as number.
                    parsedValue = valueAsNum;
                    else // If this value is a number and data type is provided, parse it
                    // according to provided data type.
                    switch(config.dtype){
                        case 'float32':
                            parsedValue = valueAsNum;
                            break;
                        case 'int32':
                            parsedValue = Math.floor(valueAsNum);
                            break;
                        case 'bool':
                            parsedValue = this.getBoolean(value);
                            break;
                        default:
                            parsedValue = valueAsNum;
                    }
                }
                // Check if this column is label.
                config && config.isLabel ? labels[key] = parsedValue : features[key] = parsedValue;
            }
        }
        // If label exists, return an object of features and labels as {xs:features,
        // ys:labels}, otherwise return features only.
        if (Object.keys(labels).length === 0) return features;
        else return {
            xs: features,
            ys: labels
        };
    }
    getBoolean(value) {
        if (value === '1' || value.toLowerCase() === 'true') return 1;
        else return 0;
    }
    // adapted from https://beta.observablehq.com/@mbostock/streaming-csv
    parseRow(line, validateElementCount = true) {
        const result = [];
        let readOffset = 0;
        const readLength = line.length;
        let currentState = $55721507d1de047f$var$STATE_OUT;
        // Goes through the line to parse quote.
        for(let i = 0; i < readLength; i++)switch(currentState){
            // Before enter a new field
            case $55721507d1de047f$var$STATE_OUT:
                switch(line.charAt(i)){
                    // Enter a quoted field
                    case $55721507d1de047f$var$CODE_QUOTE:
                        readOffset = i + 1;
                        currentState = $55721507d1de047f$var$STATE_QUOTE;
                        break;
                    // Read an empty field
                    case this.delimiter:
                        readOffset = i + 1;
                        // If delimiter is white space and configured to collapse
                        // multiple white spaces, ignore this white space.
                        if (this.delimiter === ' ' && this.delimWhitespace) break;
                        result.push('');
                        currentState = $55721507d1de047f$var$STATE_OUT;
                        break;
                    // Enter an unquoted field
                    default:
                        currentState = $55721507d1de047f$var$STATE_FIELD;
                        readOffset = i;
                        break;
                }
                break;
            // In an unquoted field
            case $55721507d1de047f$var$STATE_FIELD:
                switch(line.charAt(i)){
                    // Exit an unquoted field, add it to result
                    case this.delimiter:
                        result.push(line.substring(readOffset, i));
                        currentState = $55721507d1de047f$var$STATE_OUT;
                        readOffset = i + 1;
                        break;
                    default:
                }
                break;
            // In a quoted field
            case $55721507d1de047f$var$STATE_QUOTE:
                switch(line.charAt(i)){
                    // Read a quote after a quote
                    case $55721507d1de047f$var$CODE_QUOTE:
                        currentState = $55721507d1de047f$var$STATE_QUOTE_AFTER_QUOTE;
                        break;
                    default:
                }
                break;
            // This state means it's right after a second quote in a field
            case $55721507d1de047f$var$STATE_QUOTE_AFTER_QUOTE:
                switch(line.charAt(i)){
                    // Finished a quoted field
                    case this.delimiter:
                        result.push(line.substring(readOffset, i - 1));
                        currentState = $55721507d1de047f$var$STATE_OUT;
                        readOffset = i + 1;
                        break;
                    // Finished a quoted part in a quoted field
                    case $55721507d1de047f$var$CODE_QUOTE:
                        currentState = $55721507d1de047f$var$STATE_QUOTE;
                        break;
                    // In a quoted part in a quoted field
                    default:
                        currentState = $55721507d1de047f$var$STATE_WITHIN_QUOTE_IN_QUOTE;
                        break;
                }
                break;
            case $55721507d1de047f$var$STATE_WITHIN_QUOTE_IN_QUOTE:
                switch(line.charAt(i)){
                    // Exit a quoted part in a quoted field
                    case $55721507d1de047f$var$CODE_QUOTE:
                        currentState = $55721507d1de047f$var$STATE_QUOTE;
                        break;
                    default:
                }
                break;
            default:
        }
        // Adds last item based on if it is quoted.
        if (currentState === $55721507d1de047f$var$STATE_QUOTE_AFTER_QUOTE) result.push(line.substring(readOffset, readLength - 1));
        else result.push(line.substring(readOffset));
        // Check if each row has the same number of elements as column names.
        if (validateElementCount && result.length !== this.fullColumnNames.length) throw new Error(`Invalid row in csv file. Should have ${this.fullColumnNames.length} elements in a row, but got ${result}`);
        return result;
    }
} // TODO(soergel): add more basic datasets for parity with tf.data
 // tf.data.FixedLengthRecordDataset()
 // tf.data.TFRecordDataset()

});
parcelRegister("7EcID", function(module, exports) {

$parcel$export(module.exports, "TextLineDataset", () => $59162288dddefe1c$export$e3ec11e2ed15d2cb);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $3M2Rw = parcelRequire("3M2Rw");
class $59162288dddefe1c$export$e3ec11e2ed15d2cb extends (0, $3M2Rw.Dataset) {
    /**
     * Create a `TextLineDataset`.
     *
     * @param input A `DataSource` providing a chunked, UTF8-encoded byte stream.
     */ constructor(input){
        super();
        this.input = input;
    }
    async iterator() {
        const inputIterator = await this.input.iterator();
        const utf8Iterator = inputIterator.decodeUTF8();
        const lineIterator = utf8Iterator.split('\n').map((line)=>{
            // Windows/DOS format text file has extra line breaker at the end of line.
            if (line.endsWith('\r')) line = line.slice(0, -1);
            return line;
        });
        return lineIterator;
    }
}

});


parcelRegister("2xHCu", function(module, exports) {

$parcel$export(module.exports, "csv", () => $1da07fcd31670996$export$901ba78aa04f49da);
$parcel$export(module.exports, "func", () => $1da07fcd31670996$export$86951950244e2001);
$parcel$export(module.exports, "generator", () => $1da07fcd31670996$export$2b513308e642d699);
$parcel$export(module.exports, "webcam", () => $1da07fcd31670996$export$62c2c555d8a25fb5);
$parcel$export(module.exports, "microphone", () => $1da07fcd31670996$export$e852da8bac022cf9);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $3M2Rw = parcelRequire("3M2Rw");

var $7kP9G = parcelRequire("7kP9G");

var $6bIfc = parcelRequire("6bIfc");

var $1bsZV = parcelRequire("1bsZV");

var $bP87Q = parcelRequire("bP87Q");

var $2X1jl = parcelRequire("2X1jl");
function $1da07fcd31670996$export$901ba78aa04f49da(source, csvConfig = {}) {
    return new (0, $7kP9G.CSVDataset)(new (0, $2X1jl.URLDataSource)(source), csvConfig);
}
function $1da07fcd31670996$export$86951950244e2001(f) {
    const iter = (0, $6bIfc.iteratorFromFunction)(f);
    return (0, $3M2Rw.datasetFromIteratorFn)(async ()=>iter);
}
function $1da07fcd31670996$export$2b513308e642d699(generator) {
    return (0, $3M2Rw.datasetFromIteratorFn)(async ()=>{
        const gen = await generator();
        return (0, $6bIfc.iteratorFromFunction)(()=>gen.next());
    });
}
async function $1da07fcd31670996$export$62c2c555d8a25fb5(webcamVideoElement, webcamConfig) {
    return (0, $bP87Q.WebcamIterator).create(webcamVideoElement, webcamConfig);
}
async function $1da07fcd31670996$export$e852da8bac022cf9(microphoneConfig) {
    return (0, $1bsZV.MicrophoneIterator).create(microphoneConfig);
}

});
parcelRegister("1bsZV", function(module, exports) {

$parcel$export(module.exports, "MicrophoneIterator", () => $0dcd4fe4520473e2$export$e44e755604080137);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $ec8bD = parcelRequire("ec8bD");
var $wx9lK = parcelRequire("wx9lK");

var $6bIfc = parcelRequire("6bIfc");
class $0dcd4fe4520473e2$export$e44e755604080137 extends (0, $6bIfc.LazyIterator) {
    constructor(microphoneConfig){
        super();
        this.microphoneConfig = microphoneConfig;
        this.isClosed = false;
        this.fftSize = microphoneConfig.fftSize || 1024;
        const fftSizeLog2 = Math.log2(this.fftSize);
        if (this.fftSize < 0 || fftSizeLog2 < 4 || fftSizeLog2 > 14 || !Number.isInteger(fftSizeLog2)) throw new Error(`Invalid fftSize: it must be a power of 2 between ` + `2 to 4 and 2 to 14, but got ${this.fftSize}`);
        this.numFrames = microphoneConfig.numFramesPerSpectrogram || 43;
        this.sampleRateHz = microphoneConfig.sampleRateHz;
        this.columnTruncateLength = microphoneConfig.columnTruncateLength || this.fftSize;
        this.audioTrackConstraints = microphoneConfig.audioTrackConstraints;
        this.smoothingTimeConstant = microphoneConfig.smoothingTimeConstant || 0;
        this.includeSpectrogram = microphoneConfig.includeSpectrogram === false ? false : true;
        this.includeWaveform = microphoneConfig.includeWaveform === true ? true : false;
        if (!this.includeSpectrogram && !this.includeWaveform) throw new Error("Both includeSpectrogram and includeWaveform are false. At least one type of data should be returned.");
    }
    summary() {
        return `microphone`;
    }
    // Construct a MicrophoneIterator and start the audio stream.
    static async create(microphoneConfig = {}) {
        if (!(0, $aymVi.env)().get('IS_BROWSER')) throw new Error('microphone API is only supported in browser environment.');
        const microphoneIterator = new $0dcd4fe4520473e2$export$e44e755604080137(microphoneConfig);
        // Call async function start() to initialize the audio stream.
        await microphoneIterator.start();
        return microphoneIterator;
    }
    // Start the audio stream and FFT.
    async start() {
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                audio: this.audioTrackConstraints == null ? true : this.audioTrackConstraints,
                video: false
            });
        } catch (e) {
            throw new Error(`Error thrown while initializing video stream: ${e.message}`);
        }
        if (!this.stream) throw new Error('Could not obtain audio from microphone.');
        const ctxConstructor = // tslint:disable-next-line:no-any
        window.AudioContext || window.webkitAudioContext;
        this.audioContext = new ctxConstructor();
        if (!this.sampleRateHz) // If sample rate is not provided, use the available sample rate on
        // device.
        this.sampleRateHz = this.audioContext.sampleRate;
        else if (this.audioContext.sampleRate !== this.sampleRateHz) throw new Error(`Mismatch in sampling rate: ` + `Expected: ${this.sampleRateHz}; ` + `Actual: ${this.audioContext.sampleRate}`);
        const streamSource = this.audioContext.createMediaStreamSource(this.stream);
        this.analyser = this.audioContext.createAnalyser();
        this.analyser.fftSize = this.fftSize * 2;
        this.analyser.smoothingTimeConstant = this.smoothingTimeConstant;
        streamSource.connect(this.analyser);
        this.freqData = new Float32Array(this.fftSize);
        this.timeData = new Float32Array(this.fftSize);
        return;
    }
    async next() {
        if (this.isClosed) return {
            value: null,
            done: true
        };
        let spectrogramTensor;
        let waveformTensor;
        const audioDataQueue = await this.getAudioData();
        if (this.includeSpectrogram) {
            const freqData = this.flattenQueue(audioDataQueue.freqDataQueue);
            spectrogramTensor = this.getTensorFromAudioDataArray(freqData, [
                this.numFrames,
                this.columnTruncateLength,
                1
            ]);
        }
        if (this.includeWaveform) {
            const timeData = this.flattenQueue(audioDataQueue.timeDataQueue);
            waveformTensor = this.getTensorFromAudioDataArray(timeData, [
                this.numFrames * this.fftSize,
                1
            ]);
        }
        return {
            value: {
                'spectrogram': spectrogramTensor,
                'waveform': waveformTensor
            },
            done: false
        };
    }
    // Capture one result from the audio stream, and extract the value from
    // iterator.next() result.
    async capture() {
        return (await this.next()).value;
    }
    async getAudioData() {
        const freqDataQueue = [];
        const timeDataQueue = [];
        let currentFrames = 0;
        return new Promise((resolve)=>{
            const intervalID = setInterval(()=>{
                if (this.includeSpectrogram) {
                    this.analyser.getFloatFrequencyData(this.freqData);
                    // If the audio stream is initializing, return empty queue.
                    if (this.freqData[0] === -Infinity) resolve({
                        freqDataQueue: freqDataQueue,
                        timeDataQueue: timeDataQueue
                    });
                    freqDataQueue.push(this.freqData.slice(0, this.columnTruncateLength));
                }
                if (this.includeWaveform) {
                    this.analyser.getFloatTimeDomainData(this.timeData);
                    timeDataQueue.push(this.timeData.slice());
                }
                // Clean interval and return when all frames have been collected
                if (++currentFrames === this.numFrames) {
                    clearInterval(intervalID);
                    resolve({
                        freqDataQueue: freqDataQueue,
                        timeDataQueue: timeDataQueue
                    });
                }
            }, this.fftSize / this.sampleRateHz * 1e3);
        });
    }
    // Stop the audio stream and pause the iterator.
    stop() {
        if (!this.isClosed) {
            this.isClosed = true;
            this.analyser.disconnect();
            this.audioContext.close();
            if (this.stream != null && this.stream.getTracks().length > 0) this.stream.getTracks()[0].stop();
        }
    }
    // Override toArray() function to prevent collecting.
    toArray() {
        throw new Error('Can not convert infinite audio stream to array.');
    }
    // Return audio sampling rate in Hz
    getSampleRate() {
        return this.sampleRateHz;
    }
    flattenQueue(queue) {
        const frameSize = queue[0].length;
        const freqData = new Float32Array(queue.length * frameSize);
        queue.forEach((data, i)=>freqData.set(data, i * frameSize));
        return freqData;
    }
    getTensorFromAudioDataArray(freqData, shape) {
        const vals = new Float32Array((0, $wx9lK).sizeFromShape(shape));
        // If the data is less than the output shape, the rest is padded with zeros.
        vals.set(freqData, vals.length - freqData.length);
        return (0, $ec8bD.tensor)(vals, shape);
    }
}

});

parcelRegister("bP87Q", function(module, exports) {

$parcel$export(module.exports, "WebcamIterator", () => $89bac2aeef5d7d8f$export$da055602df533e23);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aIDUZ = parcelRequire("aIDUZ");
var $7qWZ5 = parcelRequire("7qWZ5");
var $aymVi = parcelRequire("aymVi");
var $6mzQK = parcelRequire("6mzQK");
var $iNZmA = parcelRequire("iNZmA");
var $eP0pM = parcelRequire("eP0pM");
var $jIDgY = parcelRequire("jIDgY");
var $g4QpC = parcelRequire("g4QpC");
var $9c0Qr = parcelRequire("9c0Qr");
var $wx9lK = parcelRequire("wx9lK");

var $6bIfc = parcelRequire("6bIfc");
class $89bac2aeef5d7d8f$export$da055602df533e23 extends (0, $6bIfc.LazyIterator) {
    constructor(webcamVideoElement, webcamConfig){
        super();
        this.webcamVideoElement = webcamVideoElement;
        this.webcamConfig = webcamConfig;
        this.isClosed = true;
        this.resize = false;
        if (this.needToResize()) {
            this.resize = true;
            this.cropSize = [
                this.webcamConfig.resizeHeight,
                this.webcamConfig.resizeWidth
            ];
            this.cropBoxInd = (0, $jIDgY.tensor1d)([
                0
            ], 'int32');
            if (this.webcamConfig.centerCrop) {
                // Calculate the box based on resizing shape.
                const widthCroppingRatio = this.webcamConfig.resizeWidth * 1.0 / this.webcamVideoElement.width;
                const heightCroppingRatio = this.webcamConfig.resizeHeight * 1.0 / this.webcamVideoElement.height;
                const widthCropStart = (1 - widthCroppingRatio) / 2;
                const heightCropStart = (1 - heightCroppingRatio) / 2;
                const widthCropEnd = widthCropStart + widthCroppingRatio;
                const heightCropEnd = heightCroppingRatio + heightCropStart;
                this.cropBox = (0, $g4QpC.tensor2d)([
                    heightCropStart,
                    widthCropStart,
                    heightCropEnd,
                    widthCropEnd
                ], [
                    1,
                    4
                ]);
            } else this.cropBox = (0, $g4QpC.tensor2d)([
                0,
                0,
                1,
                1
            ], [
                1,
                4
            ]);
        }
    }
    summary() {
        return `webcam`;
    }
    // Construct a WebcamIterator and start it's video stream.
    static async create(webcamVideoElement, webcamConfig = {}) {
        if (!(0, $aymVi.env)().get('IS_BROWSER')) throw new Error('tf.data.webcam is only supported in browser environment.');
        if (!webcamVideoElement) {
            // If webcam video element is not provided, create a hidden video element
            // with provided width and height.
            webcamVideoElement = document.createElement('video');
            if (!webcamConfig.resizeWidth || !webcamConfig.resizeHeight) throw new Error("Please provide webcam video element, or resizeWidth and resizeHeight to create a hidden video element.");
            webcamVideoElement.width = webcamConfig.resizeWidth;
            webcamVideoElement.height = webcamConfig.resizeHeight;
        }
        const webcamIterator = new $89bac2aeef5d7d8f$export$da055602df533e23(webcamVideoElement, webcamConfig);
        // Call async function to initialize the video stream.
        await webcamIterator.start();
        return webcamIterator;
    }
    // Async function to start video stream.
    async start() {
        if (this.webcamConfig.facingMode) (0, $wx9lK).assert(this.webcamConfig.facingMode === 'user' || this.webcamConfig.facingMode === 'environment', ()=>`Invalid webcam facing mode: ${this.webcamConfig.facingMode}. ` + `Please provide 'user' or 'environment'`);
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: this.webcamConfig.deviceId,
                    facingMode: this.webcamConfig.facingMode ? this.webcamConfig.facingMode : 'user',
                    width: this.webcamVideoElement.width,
                    height: this.webcamVideoElement.height
                }
            });
        } catch (e) {
            // Modify the error message but leave the stack trace intact
            e.message = `Error thrown while initializing video stream: ${e.message}`;
            throw e;
        }
        if (!this.stream) throw new Error('Could not obtain video from webcam.');
        // Older browsers may not have srcObject
        try {
            this.webcamVideoElement.srcObject = this.stream;
        } catch (error) {
            console.log(error);
            this.webcamVideoElement.src = window.URL.createObjectURL(this.stream);
        }
        // Start the webcam video stream
        this.webcamVideoElement.play();
        this.isClosed = false;
        return new Promise((resolve)=>{
            // Add event listener to make sure the webcam has been fully initialized.
            this.webcamVideoElement.onloadedmetadata = ()=>{
                resolve();
            };
        });
    }
    async next() {
        if (this.isClosed) return {
            value: null,
            done: true
        };
        let img;
        try {
            img = (0, $aIDUZ).fromPixels(this.webcamVideoElement);
        } catch (e) {
            throw new Error(`Error thrown converting video to pixels: ${JSON.stringify(e)}`);
        }
        if (this.resize) try {
            return {
                value: this.cropAndResizeFrame(img),
                done: false
            };
        } catch (e) {
            throw new Error(`Error thrown cropping the video: ${e.message}`);
        } finally{
            img.dispose();
        }
        else return {
            value: img,
            done: false
        };
    }
    needToResize() {
        // If resizeWidth and resizeHeight are provided, and different from the
        // width and height of original HTMLVideoElement, then resizing and cropping
        // is required.
        if (this.webcamConfig.resizeWidth && this.webcamConfig.resizeHeight && (this.webcamVideoElement.width !== this.webcamConfig.resizeWidth || this.webcamVideoElement.height !== this.webcamConfig.resizeHeight)) return true;
        return false;
    }
    // Cropping and resizing each frame based on config
    cropAndResizeFrame(img) {
        return (0, $9c0Qr.tidy)(()=>{
            const expandedImage = (0, $6mzQK.expandDims)((0, $7qWZ5.cast)(img, 'float32'), 0);
            let resizedImage;
            resizedImage = (0, $iNZmA.image).cropAndResize(expandedImage, this.cropBox, this.cropBoxInd, this.cropSize, 'bilinear');
            // Extract image from batch cropping.
            const shape = resizedImage.shape;
            return (0, $eP0pM.reshape)(resizedImage, shape.slice(1));
        });
    }
    // Capture one frame from the video stream, and extract the value from
    // iterator.next() result.
    async capture() {
        return (await this.next()).value;
    }
    // Stop the video stream and pause webcam iterator.
    stop() {
        const tracks = this.stream.getTracks();
        tracks.forEach((track)=>track.stop());
        try {
            this.webcamVideoElement.srcObject = null;
        } catch (error) {
            console.log(error);
            this.webcamVideoElement.src = null;
        }
        this.isClosed = true;
    }
    // Override toArray() function to prevent collecting.
    toArray() {
        throw new Error('Can not convert infinite video stream to array.');
    }
}

});

parcelRegister("2X1jl", function(module, exports) {

$parcel$export(module.exports, "URLDataSource", () => $22621bc9d5563656$export$d8d4d86de1937e34);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $4ioCU = parcelRequire("4ioCU");

var $1De0k = parcelRequire("1De0k");

var $ljwig = parcelRequire("ljwig");

var $krOnM = parcelRequire("krOnM");
class $22621bc9d5563656$export$d8d4d86de1937e34 extends (0, $4ioCU.DataSource) {
    /**
     * Create a `URLDataSource`.
     *
     * @param url A source URL string, or a `Request` object.
     * @param options Options passed to the underlying `FileChunkIterator`s,
     *   such as {chunksize: 1024}.
     */ constructor(url, fileOptions = {}){
        super();
        this.url = url;
        this.fileOptions = fileOptions;
    }
    // TODO(soergel): provide appropriate caching options.  Currently this
    // will download the URL anew for each call to iterator().  Since we have
    // to treat the downloaded file as a blob/buffer anyway, we may as well retain
    // it-- but that raises GC issues.  Also we may want a persistent disk cache.
    async iterator() {
        if ((0, $ljwig.isLocalPath)(this.url)) return new (0, $krOnM.FileDataSource)(this.url, this.fileOptions).iterator();
        else return (0, $1De0k.urlChunkIterator)(this.url, this.fileOptions);
    }
}

});
parcelRegister("4ioCU", function(module, exports) {

$parcel$export(module.exports, "DataSource", () => $320bf22cfff2d4e4$export$accd73d198d77d2f);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /**
 * Represents a data source readable as a stream of binary data chunks.
 *
 * Because `Dataset`s can be read repeatedly (via `Dataset.iterator()`), this
 * provides a means to repeatedly create streams from the underlying data
 * sources.
 */ class $320bf22cfff2d4e4$export$accd73d198d77d2f {
} // TODO(soergel): consider convenience factory functions here
 // in combination with chainable source->dataset above, e.g.:
 // tf.data.url(...).asCsvDataset().shuffle().batch()

});

parcelRegister("1De0k", function(module, exports) {

$parcel$export(module.exports, "urlChunkIterator", () => $13044bf3465517b1$export$158ba3195ecace84);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $7WuKb = parcelRequire("7WuKb");
async function $13044bf3465517b1$export$158ba3195ecace84(url, options = {}, fetchFunc) {
    let urlString;
    let requestInit;
    if (typeof url === 'string') urlString = url;
    else {
        urlString = url.url;
        requestInit = $13044bf3465517b1$var$getRequestInitFromRequest(url);
    }
    const response = await (fetchFunc || (0, $wx9lK).fetch)(urlString, requestInit);
    if (response.ok) {
        const uint8Array = new Uint8Array(await response.arrayBuffer());
        return new (0, $7WuKb.FileChunkIterator)(uint8Array, options);
    } else throw new Error(response.statusText);
}
// Generate RequestInit from Request to match tf.util.fetch signature.
const $13044bf3465517b1$var$getRequestInitFromRequest = (request)=>{
    const init = {
        method: request.method,
        headers: request.headers,
        body: request.body,
        mode: request.mode,
        credentials: request.credentials,
        cache: request.cache,
        redirect: request.redirect,
        referrer: request.referrer,
        integrity: request.integrity
    };
    return init;
};

});
parcelRegister("7WuKb", function(module, exports) {

$parcel$export(module.exports, "FileChunkIterator", () => $5c85cc4414822238$export$2624998eee2e5c56);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ // inspired by https://github.com/maxogden/filereader-stream
parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $wx9lK = parcelRequire("wx9lK");

var $b8csz = parcelRequire("b8csz");
class $5c85cc4414822238$export$2624998eee2e5c56 extends (0, $b8csz.ByteChunkIterator) {
    constructor(file, options = {}){
        super();
        this.file = file;
        this.options = options;
        (0, $wx9lK).assert(file instanceof Uint8Array || ((0, $aymVi.env)().get('IS_BROWSER') ? file instanceof File || file instanceof Blob : false), ()=>"FileChunkIterator only supports File, Blob and Uint8Array right now.");
        this.offset = options.offset || 0;
        // default 1MB chunk has tolerable perf on large files
        this.chunkSize = options.chunkSize || 1048576;
    }
    summary() {
        return `FileChunks ${this.file}`;
    }
    async next() {
        if (this.offset >= (this.file instanceof Uint8Array ? this.file.byteLength : this.file.size)) return {
            value: null,
            done: true
        };
        const chunk = new Promise((resolve, reject)=>{
            const end = this.offset + this.chunkSize;
            if (this.file instanceof Uint8Array) // Note if end > this.uint8Array.byteLength, we just get a small last
            // chunk.
            resolve(new Uint8Array(this.file.slice(this.offset, end)));
            else {
                // This branch assumes that this.file type is File or Blob, which
                // means it is in the browser environment.
                // TODO(soergel): is this a performance issue?
                const fileReader = new FileReader();
                fileReader.onload = (event)=>{
                    let data = fileReader.result;
                    // Not sure we can trust the return type of
                    // FileReader.readAsArrayBuffer See e.g.
                    // https://github.com/node-file-api/FileReader/issues/2
                    if (data instanceof ArrayBuffer) data = new Uint8Array(data);
                    if (!(data instanceof Uint8Array)) return reject(new TypeError('FileReader returned unknown type.'));
                    resolve(data);
                };
                fileReader.onabort = (event)=>{
                    return reject(new Error('Aborted'));
                };
                fileReader.onerror = (event)=>{
                    return reject(new Error(event.type));
                };
                // TODO(soergel): better handle onabort, onerror
                // Note if end > this.file.size, we just get a small last chunk.
                const slice = this.file.slice(this.offset, end);
                // We can't use readAsText here (even if we know the file is text)
                // because the slice boundary may fall within a multi-byte character.
                fileReader.readAsArrayBuffer(slice);
            }
            this.offset = end;
        });
        return {
            value: await chunk,
            done: false
        };
    }
}

});
parcelRegister("b8csz", function(module, exports) {

$parcel$export(module.exports, "ByteChunkIterator", () => $0217638993b0ccfa$export$6a47bd14492beb24);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");

var $6bIfc = parcelRequire("6bIfc");

var $gzk9G = parcelRequire("gzk9G");

var $cbQCu = parcelRequire("cbQCu");
var $0217638993b0ccfa$require$Buffer = $cbQCu.Buffer;
class $0217638993b0ccfa$export$6a47bd14492beb24 extends (0, $6bIfc.LazyIterator) {
    /**
     * Decode a stream of UTF8-encoded byte arrays to a stream of strings.
     *
     * The byte arrays producetd from the ByteChunkIterator on which this is
     * called will be interpreted as concatenated.  No assumptions are made about
     * the boundaries of the incoming chunks, so a multi-byte UTF8 encoding of a
     * character may span the boundary between chunks.  This naturally happens,
     * for instance, when reading fixed-size byte arrays from a file.
     */ decodeUTF8() {
        return new $0217638993b0ccfa$var$Utf8Iterator(this);
    }
}
// ============================================================================
// The following private classes serve to implement the chainable methods
// on ByteChunkIterator.  Unfortunately they can't be placed in separate files,
// due to resulting trouble with circular imports.
// ============================================================================
// We wanted multiple inheritance, e.g.
//   class Utf8Iterator extends QueueIterator<string>, StringIterator
// but the TypeScript mixin approach is a bit hacky, so we take this adapter
// approach instead.
class $0217638993b0ccfa$var$Utf8Iterator extends (0, $gzk9G.StringIterator) {
    constructor(upstream){
        super();
        this.upstream = upstream;
        this.impl = new $0217638993b0ccfa$var$Utf8IteratorImpl(upstream);
    }
    summary() {
        return this.impl.summary();
    }
    async next() {
        return this.impl.next();
    }
}

/**
 * Decode a stream of UTF8-encoded byte arrays to a stream of strings.
 *
 * This is tricky because the incoming byte array boundaries may disrupt a
 * multi-byte UTF8 character. Thus any incomplete character data at the end of
 * a chunk must be carried over and prepended to the next chunk before
 * decoding. Luckily with native decoder, TextDecoder in browser and
 * string_decoder in node, byte array boundaries are handled automatically.
 *
 * In the context of an input pipeline for machine learning, UTF8 decoding is
 * needed to parse text files containing training examples or prediction
 * requests (e.g., formatted as CSV or JSON). We cannot use the built-in
 * decoding provided by FileReader.readAsText() because here we are in a
 * streaming context, which FileReader does not support.
 *
 * @param upstream A `LazyIterator` of `Uint8Arrays` containing UTF8-encoded
 *   text, which should be interpreted as concatenated.  No assumptions are
 *   made about the boundaries of the incoming chunks, so a multi-byte UTF8
 *   encoding of a character may span the boundary between chunks.  This
 *   naturally happens, for instance, when reading fixed-size byte arrays from a
 *   file.
 */ class $0217638993b0ccfa$var$Utf8IteratorImpl extends (0, $6bIfc.OneToManyIterator) {
    constructor(upstream){
        super();
        this.upstream = upstream;
        if ((0, $aymVi.env)().get('IS_BROWSER')) this.decoder = new TextDecoder('utf-8');
        else {
            // tslint:disable-next-line:no-require-imports
            const { StringDecoder: StringDecoder } = (parcelRequire("1frus"));
            this.decoder = new StringDecoder('utf8');
        }
    }
    summary() {
        return `${this.upstream.summary()} -> Utf8`;
    }
    async pump() {
        const chunkResult = await this.upstream.next();
        let chunk;
        if (chunkResult.done) return false;
        else chunk = chunkResult.value;
        let text;
        if ((0, $aymVi.env)().get('IS_BROWSER')) text = this.decoder.decode(chunk, {
            stream: true
        });
        else text = this.decoder.write($0217638993b0ccfa$require$Buffer.from(chunk.buffer));
        this.outputQueue.push(text);
        return true;
    }
}

});
parcelRegister("gzk9G", function(module, exports) {

$parcel$export(module.exports, "StringIterator", () => $c0ff8c9af3376323$export$fa893445807b0b3b);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $6bIfc = parcelRequire("6bIfc");
class $c0ff8c9af3376323$export$fa893445807b0b3b extends (0, $6bIfc.LazyIterator) {
    /**
     * Splits a string stream on a given separator.
     *
     * It is assumed that the incoming chunk boundaries have no semantic meaning,
     * so conceptually the incoming stream is treated simply as the concatenation
     * of its elements.
     *
     * The outgoing stream provides chunks corresponding to the results of the
     * standard string split() operation (even if such a chunk spanned incoming
     * chunks).  The separators are not included.
     *
     * A typical usage is to split a text file (represented as a stream with
     * arbitrary chunk boundaries) into lines.
     *
     * @param upstream A readable stream of strings that can be treated as
     *   concatenated.
     * @param separator A character to split on.
     */ split(separator) {
        return new $c0ff8c9af3376323$var$SplitIterator(this, separator);
    }
}
// ============================================================================
// The following private classes serve to implement the chainable methods
// on StringIterator.  Unfortunately they can't be placed in separate files, due
// to resulting trouble with circular imports.
// ============================================================================
// We wanted multiple inheritance, e.g.
//   class SplitIterator extends QueueIterator<string>, StringIterator
// but the TypeScript mixin approach is a bit hacky, so we take this adapter
// approach instead.
class $c0ff8c9af3376323$var$SplitIterator extends $c0ff8c9af3376323$export$fa893445807b0b3b {
    constructor(upstream, separator){
        super();
        this.upstream = upstream;
        this.impl = new $c0ff8c9af3376323$var$SplitIteratorImpl(upstream, separator);
    }
    summary() {
        return this.impl.summary();
    }
    async next() {
        return this.impl.next();
    }
}
class $c0ff8c9af3376323$var$SplitIteratorImpl extends (0, $6bIfc.OneToManyIterator) {
    constructor(upstream, separator){
        super();
        this.upstream = upstream;
        this.separator = separator;
        // A partial string at the end of an upstream chunk
        this.carryover = '';
    }
    summary() {
        return `${this.upstream.summary()} -> Split('${this.separator}')`;
    }
    async pump() {
        const chunkResult = await this.upstream.next();
        if (chunkResult.done) {
            if (this.carryover === '') return false;
            // Pretend that the pump succeeded in order to emit the small last batch.
            // The next pump() call will actually fail.
            this.outputQueue.push(this.carryover);
            this.carryover = '';
            return true;
        }
        const lines = chunkResult.value.split(this.separator);
        // Note the behavior: " ab ".split(' ') === ['', 'ab', '']
        // Thus the carryover may be '' if the separator falls on a chunk
        // boundary; this produces the correct result.
        lines[0] = this.carryover + lines[0];
        for (const line of lines.slice(0, -1))this.outputQueue.push(line);
        this.carryover = lines[lines.length - 1];
        return true;
    }
}

});




parcelRegister("ljwig", function(module, exports) {

$parcel$export(module.exports, "isLocalPath", () => $f8446c2dbeaa2893$export$9fce4fde36401560);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ // Skip tslint any type check cause this method is aiming to check type of
// input.
// tslint:disable-next-line:no-any
function $f8446c2dbeaa2893$export$9fce4fde36401560(source) {
    return typeof source === 'string' && source.slice(0, 7) === 'file://';
}

});

parcelRegister("krOnM", function(module, exports) {

$parcel$export(module.exports, "FileDataSource", () => $ee2d6936d06f8044$export$e7de913bc6153b84);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");

var $4ioCU = parcelRequire("4ioCU");

var $7WuKb = parcelRequire("7WuKb");

var $ljwig = parcelRequire("ljwig");

class $ee2d6936d06f8044$export$e7de913bc6153b84 extends (0, $4ioCU.DataSource) {
    /**
     * Create a `FileDataSource`.
     *
     * @param input Local file path, or `File`/`Blob`/`Uint8Array` object to
     *     read. Local file only works in node environment.
     * @param options Options passed to the underlying `FileChunkIterator`s,
     *   such as {chunksize: 1024}.
     */ constructor(input, options = {}){
        super();
        this.input = input;
        this.options = options;
    }
    async iterator() {
        if ((0, $ljwig.isLocalPath)(this.input) && (0, $aymVi.env)().get('IS_NODE')) {
            // tslint:disable-next-line:no-require-imports
            const fs = (parcelRequire("1frus"));
            this.input = fs.readFileSync(this.input.slice(7));
        }
        // TODO(kangyizhang): Add LocalFileChunkIterator to split local streaming
        // with file in browser.
        return new (0, $7WuKb.FileChunkIterator)(this.input, this.options);
    }
}

});



parcelRegister("5JRhQ", function(module, exports) {

$parcel$export(module.exports, "version", () => $42da7d61693caf40$export$83d89fbfd8236492);
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $42da7d61693caf40$export$83d89fbfd8236492 = '3.21.0';

});


parcelRegister("3IrH1", function(module, exports) {
$parcel$export(module.exports, "version_cpu", () => (parcelRequire("cwaBk")).version);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // All exports from this package should be in base.
parcelRequire("bPDbP");
parcelRequire("dofnb");

});
parcelRegister("bPDbP", function(module, exports) {

$parcel$export(module.exports, "version_cpu", () => (parcelRequire("cwaBk")).version);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /*
 * base.ts contains all the exports from tfjs-backend-cpu
 * without auto-kernel registration
 */ parcelRequire("5n9DG");
var $9c0Qr = parcelRequire("9c0Qr");

var $3Wx8z = parcelRequire("3Wx8z");


var $cwaBk = parcelRequire("cwaBk");
// Side effects for default initialization of MathBackendCPU
(0, $9c0Qr.registerBackend)('cpu', ()=>new (0, $3Wx8z.MathBackendCPU)(), 1 /* priority */ );

});
parcelRegister("3Wx8z", function(module, exports) {

$parcel$export(module.exports, "MathBackendCPU", () => $2df07e378b801dfa$export$65286aecbd5a8de9);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $g81BN = parcelRequire("g81BN");
var $3PHpx = parcelRequire("3PHpx");
var $9c0Qr = parcelRequire("9c0Qr");
var $aymVi = parcelRequire("aymVi");
var $ff2I2 = parcelRequire("ff2I2");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
const $2df07e378b801dfa$var$whereImpl = (0, $ff2I2).whereImpl;
class $2df07e378b801dfa$export$65286aecbd5a8de9 extends (0, $3PHpx.KernelBackend) {
    constructor(){
        super();
        this.blockSize = 48;
        this.firstUse = true;
        this.data = new (0, $3PHpx.DataStorage)(this, (0, $9c0Qr.engine)());
    }
    nextDataId() {
        return $2df07e378b801dfa$export$65286aecbd5a8de9.nextDataId++;
    }
    write(values, shape, dtype) {
        if (this.firstUse) {
            this.firstUse = false;
            if ((0, $aymVi.env)().get('IS_NODE')) (0, $lkN62).warn("\n============================\nHi, looks like you are running TensorFlow.js in Node.js. To speed things up dramatically, install our node backend, visit https://github.com/tensorflow/tfjs-node for more details. \n============================");
        }
        const dataId = {
            id: this.nextDataId()
        };
        this.data.set(dataId, {
            values: values,
            dtype: dtype,
            refCount: 1
        });
        return dataId;
    }
    /**
     * Create a data bucket in cpu backend.
     * @param shape Shape of the `TensorInfo`.
     * @param dtype DType of the `TensorInfo`.
     * @param values The value of the `TensorInfo` stored as a flattened array.
     */ makeTensorInfo(shape, dtype, values) {
        let outId;
        if (dtype === 'string' && values != null && values.length > 0 && (0, $wx9lK).isString(values[0])) {
            const encodedValues = values.map((d)=>(0, $wx9lK).encodeString(d));
            outId = this.write(encodedValues, shape, dtype);
        } else outId = this.write(values, shape, dtype);
        return {
            dataId: outId,
            shape: shape,
            dtype: dtype
        };
    }
    /** Return refCount of a `TensorData`. */ refCount(dataId) {
        if (this.data.has(dataId)) {
            const tensorData = this.data.get(dataId);
            return tensorData.refCount;
        }
        return 0;
    }
    /** Increase refCount of a `TensorData`. */ incRef(dataId) {
        const tensorData = this.data.get(dataId);
        tensorData.refCount++;
    }
    /** Decrease refCount of a `TensorData`. */ decRef(dataId) {
        if (this.data.has(dataId)) {
            const tensorData = this.data.get(dataId);
            tensorData.refCount--;
        }
    }
    move(dataId, values, shape, dtype, refCount) {
        this.data.set(dataId, {
            values: values,
            dtype: dtype,
            refCount: refCount
        });
    }
    numDataIds() {
        return this.data.numDataIds();
    }
    async read(dataId) {
        return this.readSync(dataId);
    }
    readSync(dataId) {
        const { dtype: dtype, complexTensorInfos: complexTensorInfos } = this.data.get(dataId);
        if (dtype === 'complex64') {
            const realValues = this.readSync(complexTensorInfos.real.dataId);
            const imagValues = this.readSync(complexTensorInfos.imag.dataId);
            return (0, $lkN62).mergeRealAndImagArrays(realValues, imagValues);
        }
        return this.data.get(dataId).values;
    }
    bufferSync(t) {
        const data = this.readSync(t.dataId);
        if (t.dtype === 'string') try {
            // Decode the bytes into string.
            const strings = data.map((d)=>(0, $wx9lK).decodeString(d));
            return (0, $g81BN.buffer)(t.shape, t.dtype, strings);
        } catch (_a) {
            throw new Error('Failed to decode encoded string bytes into utf-8');
        }
        return (0, $g81BN.buffer)(t.shape, t.dtype, data);
    }
    makeOutput(values, shape, dtype) {
        return (0, $9c0Qr.engine)().makeTensorFromTensorInfo(this.makeTensorInfo(shape, dtype, values), this);
    }
    /**
     * Dispose the memory if the dataId has 0 refCount. Return true if the memory
     * is released or memory is not managed in this backend, false if memory is
     * not cleared.
     * @param dataId
     * @oaram force Optional, remove the data regardless of refCount
     */ disposeData(dataId, force = false) {
        if (this.data.has(dataId)) {
            this.data.get(dataId).refCount--;
            if (!force && this.data.get(dataId).refCount > 0) return false;
            const { complexTensorInfos: complexTensorInfos } = this.data.get(dataId);
            if (complexTensorInfos != null) {
                this.disposeData(complexTensorInfos.real.dataId, true);
                this.disposeData(complexTensorInfos.imag.dataId, true);
            }
            this.data.delete(dataId);
        }
        return true;
    }
    disposeIntermediateTensorInfo(tensorInfo) {
        this.disposeData(tensorInfo.dataId);
    }
    async time(f) {
        const start = (0, $wx9lK).now();
        f();
        const kernelMs = (0, $wx9lK).now() - start;
        return {
            kernelMs: kernelMs
        };
    }
    memory() {
        return {
            // Unreliable due to automatic gc. The numbers above are cumulative.
            unreliable: true,
            reasons: [
                "The reported memory is an upper bound. Due to automatic garbage collection, the true allocated memory may be less."
            ]
        };
    }
    where(condition) {
        (0, $aPHJu.assertNotComplex)([
            condition
        ], 'where');
        const condVals = this.readSync(condition.dataId);
        return $2df07e378b801dfa$var$whereImpl(condition.shape, condVals);
    }
    dispose() {}
    floatPrecision() {
        return 32;
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return super.epsilon();
    }
}
$2df07e378b801dfa$export$65286aecbd5a8de9.nextDataId = 0;

});
parcelRegister("aPHJu", function(module, exports) {

$parcel$export(module.exports, "assertNotComplex", () => $7e3097321a63c368$export$1412c17b2531581a);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
function $7e3097321a63c368$export$1412c17b2531581a(tensor, opName) {
    if (!Array.isArray(tensor)) tensor = [
        tensor
    ];
    tensor.forEach((t)=>{
        if (t != null) (0, $wx9lK).assert(t.dtype !== 'complex64', ()=>`${opName} does not support complex64 tensors in the CPU backend.`);
    });
}

});


parcelRegister("cwaBk", function(module, exports) {

$parcel$export(module.exports, "version", () => $91d0b25392a5d2f2$export$83d89fbfd8236492);
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $91d0b25392a5d2f2$export$83d89fbfd8236492 = '3.21.0';

});


parcelRegister("dofnb", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // We explicitly import the modular kernels so they get registered in the
// global registry when we compile the library. A modular build would replace
// the contents of this file and import only the kernels that are needed.
parcelRequire("5n9DG");
var $kaJSw = parcelRequire("kaJSw");

var $8FwEB = parcelRequire("8FwEB");

var $Hrrqa = parcelRequire("Hrrqa");

var $fYFG5 = parcelRequire("fYFG5");

var $dEMhX = parcelRequire("dEMhX");

var $5Cfhf = parcelRequire("5Cfhf");

var $6XRJM = parcelRequire("6XRJM");

var $2U0Mn = parcelRequire("2U0Mn");

var $cV4BO = parcelRequire("cV4BO");

var $falTI = parcelRequire("falTI");

var $gwOnn = parcelRequire("gwOnn");

var $iTuSy = parcelRequire("iTuSy");

var $jW55p = parcelRequire("jW55p");

var $yFlGZ = parcelRequire("yFlGZ");

var $aPhyZ = parcelRequire("aPhyZ");

var $drHj6 = parcelRequire("drHj6");

var $8kRhb = parcelRequire("8kRhb");

var $1daUE = parcelRequire("1daUE");

var $8Cdlq = parcelRequire("8Cdlq");

var $j0uZZ = parcelRequire("j0uZZ");

var $eTNzV = parcelRequire("eTNzV");

var $5GKaj = parcelRequire("5GKaj");

var $fErkc = parcelRequire("fErkc");

var $alm5B = parcelRequire("alm5B");

var $DqinA = parcelRequire("DqinA");

var $gSA6r = parcelRequire("gSA6r");

var $aKVzR = parcelRequire("aKVzR");

var $gMhpT = parcelRequire("gMhpT");

var $78AN7 = parcelRequire("78AN7");

var $ktPhX = parcelRequire("ktPhX");

var $kFVXg = parcelRequire("kFVXg");

var $6dsRw = parcelRequire("6dsRw");

var $gSo52 = parcelRequire("gSo52");

var $jmBKl = parcelRequire("jmBKl");

var $imWt5 = parcelRequire("imWt5");

var $avqb8 = parcelRequire("avqb8");

var $k0KNW = parcelRequire("k0KNW");

var $g17KM = parcelRequire("g17KM");

var $e79dG = parcelRequire("e79dG");

var $bfIOA = parcelRequire("bfIOA");

var $dS1Vh = parcelRequire("dS1Vh");

var $jPTZ1 = parcelRequire("jPTZ1");

var $jotxZ = parcelRequire("jotxZ");

var $hVgL7 = parcelRequire("hVgL7");

var $eUWGR = parcelRequire("eUWGR");

var $h1fh8 = parcelRequire("h1fh8");

var $kP87u = parcelRequire("kP87u");

var $eQTnz = parcelRequire("eQTnz");

var $bQVlb = parcelRequire("bQVlb");

var $kc4JX = parcelRequire("kc4JX");

var $4Q01k = parcelRequire("4Q01k");

var $7XGiG = parcelRequire("7XGiG");

var $guXy6 = parcelRequire("guXy6");

var $93uTy = parcelRequire("93uTy");

var $2nwON = parcelRequire("2nwON");

var $hFhzp = parcelRequire("hFhzp");

var $1DFii = parcelRequire("1DFii");

var $8Du0y = parcelRequire("8Du0y");

var $hyNQ9 = parcelRequire("hyNQ9");

var $kwQg5 = parcelRequire("kwQg5");

var $2ttNt = parcelRequire("2ttNt");

var $hBw1y = parcelRequire("hBw1y");

var $aWTGU = parcelRequire("aWTGU");

var $jLAh1 = parcelRequire("jLAh1");

var $6IVrx = parcelRequire("6IVrx");

var $afIPx = parcelRequire("afIPx");

var $42Zfk = parcelRequire("42Zfk");

var $ejUqf = parcelRequire("ejUqf");

var $3tNXZ = parcelRequire("3tNXZ");

var $liIvF = parcelRequire("liIvF");

var $6mG8q = parcelRequire("6mG8q");

var $2W9O3 = parcelRequire("2W9O3");

var $cG2uv = parcelRequire("cG2uv");

var $kEFa4 = parcelRequire("kEFa4");

var $rz1Ey = parcelRequire("rz1Ey");

var $1fhiF = parcelRequire("1fhiF");

var $cA4qv = parcelRequire("cA4qv");

var $lDTkj = parcelRequire("lDTkj");

var $4aSq5 = parcelRequire("4aSq5");

var $4TVnY = parcelRequire("4TVnY");

var $5uPRc = parcelRequire("5uPRc");

var $l3uQk = parcelRequire("l3uQk");

var $S038D = parcelRequire("S038D");

var $93IXG = parcelRequire("93IXG");

var $j6Gq4 = parcelRequire("j6Gq4");

var $3vGxY = parcelRequire("3vGxY");

var $5vZME = parcelRequire("5vZME");

var $lPDl4 = parcelRequire("lPDl4");

var $3q5fk = parcelRequire("3q5fk");

var $ecrNM = parcelRequire("ecrNM");

var $d4iYA = parcelRequire("d4iYA");

var $6CJS2 = parcelRequire("6CJS2");

var $fWWLW = parcelRequire("fWWLW");

var $ga261 = parcelRequire("ga261");

var $a3ZcZ = parcelRequire("a3ZcZ");

var $jN09m = parcelRequire("jN09m");

var $4zebw = parcelRequire("4zebw");

var $aMPRM = parcelRequire("aMPRM");

var $h70lW = parcelRequire("h70lW");

var $aJkrV = parcelRequire("aJkrV");

var $h9fuR = parcelRequire("h9fuR");

var $6Pysf = parcelRequire("6Pysf");

var $fOQaD = parcelRequire("fOQaD");

var $5zE1X = parcelRequire("5zE1X");

var $inyB0 = parcelRequire("inyB0");

var $gGCqu = parcelRequire("gGCqu");

var $kcYhR = parcelRequire("kcYhR");

var $2SsCU = parcelRequire("2SsCU");

var $7gEB2 = parcelRequire("7gEB2");

var $flmof = parcelRequire("flmof");

var $k8NQv = parcelRequire("k8NQv");

var $i325F = parcelRequire("i325F");

var $k2KEG = parcelRequire("k2KEG");

var $bczmc = parcelRequire("bczmc");

var $1lo4h = parcelRequire("1lo4h");

var $4fSxJ = parcelRequire("4fSxJ");

var $9B72G = parcelRequire("9B72G");

var $9MYjt = parcelRequire("9MYjt");

var $6XsUn = parcelRequire("6XsUn");

var $dvZMq = parcelRequire("dvZMq");

var $7boLi = parcelRequire("7boLi");

var $3qzJ7 = parcelRequire("3qzJ7");

var $7G1P4 = parcelRequire("7G1P4");

var $4gZOF = parcelRequire("4gZOF");

var $g8J1f = parcelRequire("g8J1f");

var $cGN1v = parcelRequire("cGN1v");

var $g5GUB = parcelRequire("g5GUB");

var $ksji9 = parcelRequire("ksji9");

var $ckZSW = parcelRequire("ckZSW");

var $1JZ4H = parcelRequire("1JZ4H");

var $eDNPr = parcelRequire("eDNPr");

var $7UpTW = parcelRequire("7UpTW");

var $faIEI = parcelRequire("faIEI");

var $9goGn = parcelRequire("9goGn");

var $ZHRjA = parcelRequire("ZHRjA");

var $7lqVU = parcelRequire("7lqVU");

var $fUXIH = parcelRequire("fUXIH");

var $9BvTb = parcelRequire("9BvTb");

var $fyKXa = parcelRequire("fyKXa");

var $lngaC = parcelRequire("lngaC");

var $i3TxW = parcelRequire("i3TxW");

var $eEwtc = parcelRequire("eEwtc");

var $5otIo = parcelRequire("5otIo");

var $bRUg4 = parcelRequire("bRUg4");

var $dLrGP = parcelRequire("dLrGP");

var $4GlIz = parcelRequire("4GlIz");

var $6Y5WS = parcelRequire("6Y5WS");

var $eBscM = parcelRequire("eBscM");

var $9CCZl = parcelRequire("9CCZl");

var $hsc7d = parcelRequire("hsc7d");

var $gigoF = parcelRequire("gigoF");

var $iXcUV = parcelRequire("iXcUV");

var $cm4jn = parcelRequire("cm4jn");

var $pFryv = parcelRequire("pFryv");

var $8jAly = parcelRequire("8jAly");

var $fcSQq = parcelRequire("fcSQq");

var $gUzQw = parcelRequire("gUzQw");

var $jPjnE = parcelRequire("jPjnE");

var $kFBKH = parcelRequire("kFBKH");

var $fHBqI = parcelRequire("fHBqI");

var $atfy0 = parcelRequire("atfy0");

var $6wFel = parcelRequire("6wFel");

var $5hkfO = parcelRequire("5hkfO");

var $9buNR = parcelRequire("9buNR");

var $ghozF = parcelRequire("ghozF");

var $36DtR = parcelRequire("36DtR");

var $8OH5n = parcelRequire("8OH5n");

var $axSMP = parcelRequire("axSMP");
// List all kernel configs here
const $9bf970fb67d034bc$var$kernelConfigs = [
    (0, $8FwEB._fusedMatMulConfig),
    (0, $Hrrqa.absConfig),
    (0, $fYFG5.acosConfig),
    (0, $dEMhX.acoshConfig),
    (0, $5Cfhf.addConfig),
    (0, $6XRJM.addNConfig),
    (0, $2U0Mn.allConfig),
    (0, $cV4BO.anyConfig),
    (0, $falTI.argMaxConfig),
    (0, $gwOnn.argMinConfig),
    (0, $iTuSy.asinConfig),
    (0, $jW55p.asinhConfig),
    (0, $yFlGZ.atanConfig),
    (0, $aPhyZ.atan2Config),
    (0, $drHj6.atanhConfig),
    (0, $8kRhb.avgPoolConfig),
    (0, $1daUE.avgPool3DConfig),
    (0, $8Cdlq.avgPool3DGradConfig),
    (0, $j0uZZ.avgPoolGradConfig),
    (0, $eTNzV.batchMatMulConfig),
    (0, $5GKaj.batchNormConfig),
    (0, $fErkc.batchToSpaceNDConfig),
    (0, $alm5B.bincountConfig),
    (0, $DqinA.broadcastArgsConfig),
    (0, $gSA6r.castConfig),
    (0, $aKVzR.ceilConfig),
    (0, $gMhpT.clipByValueConfig),
    (0, $78AN7.complexConfig),
    (0, $ktPhX.complexAbsConfig),
    (0, $kFVXg.concatConfig),
    (0, $6dsRw.conv2DConfig),
    (0, $gSo52.conv2DBackpropFilterConfig),
    (0, $jmBKl.conv2DBackpropInputConfig),
    (0, $imWt5.conv3DConfig),
    (0, $avqb8.conv3DBackpropFilterV2Config),
    (0, $k0KNW.conv3DBackpropInputV2Config),
    (0, $g17KM.cosConfig),
    (0, $e79dG.coshConfig),
    (0, $bfIOA.cropAndResizeConfig),
    (0, $dS1Vh.cumprodConfig),
    (0, $jPTZ1.cumsumConfig),
    (0, $jotxZ.denseBincountConfig),
    (0, $hVgL7.depthToSpaceConfig),
    (0, $eUWGR.depthwiseConv2dNativeConfig),
    (0, $h1fh8.depthwiseConv2dNativeBackpropFilterConfig),
    (0, $kP87u.depthwiseConv2dNativeBackpropInputConfig),
    (0, $eQTnz.diagConfig),
    (0, $bQVlb.dilation2DConfig),
    (0, $kc4JX.dilation2DBackpropFilterConfig),
    (0, $4Q01k.dilation2DBackpropInputConfig),
    (0, $7XGiG.einsumConfig),
    (0, $guXy6.eluConfig),
    (0, $93uTy.eluGradConfig),
    (0, $2nwON.equalConfig),
    (0, $hFhzp.erfConfig),
    (0, $1DFii.expConfig),
    (0, $8Du0y.expandDimsConfig),
    (0, $hyNQ9.expm1Config),
    (0, $kwQg5.fftConfig),
    (0, $2ttNt.fillConfig),
    (0, $hBw1y.flipLeftRightConfig),
    (0, $aWTGU.floorConfig),
    (0, $jLAh1.floorDivConfig),
    (0, $6IVrx.fusedConv2DConfig),
    (0, $afIPx.fusedDepthwiseConv2DConfig),
    (0, $42Zfk.gatherNdConfig),
    (0, $ejUqf.gatherV2Config),
    (0, $3tNXZ.greaterConfig),
    (0, $liIvF.greaterEqualConfig),
    (0, $6mG8q.identityConfig),
    (0, $2W9O3.ifftConfig),
    (0, $cG2uv.imagConfig),
    (0, $kEFa4.isFiniteConfig),
    (0, $rz1Ey.isInfConfig),
    (0, $1fhiF.isNaNConfig),
    (0, $cA4qv.leakyReluConfig),
    (0, $lDTkj.lessConfig),
    (0, $4aSq5.lessEqualConfig),
    (0, $4TVnY.linSpaceConfig),
    (0, $5uPRc.logConfig),
    (0, $l3uQk.log1pConfig),
    (0, $S038D.logicalAndConfig),
    (0, $93IXG.logicalNotConfig),
    (0, $j6Gq4.logicalOrConfig),
    (0, $3vGxY.LRNConfig),
    (0, $5vZME.LRNGradConfig),
    (0, $lPDl4.maxConfig),
    (0, $3q5fk.maximumConfig),
    (0, $ecrNM.maxPoolConfig),
    (0, $d4iYA.maxPool3DConfig),
    (0, $6CJS2.maxPool3DGradConfig),
    (0, $fWWLW.maxPoolGradConfig),
    (0, $ga261.maxPoolWithArgmaxConfig),
    (0, $a3ZcZ.meanConfig),
    (0, $jN09m.minConfig),
    (0, $4zebw.minimumConfig),
    (0, $aMPRM.mirrorPadConfig),
    (0, $h70lW.modConfig),
    (0, $aJkrV.multinomialConfig),
    (0, $h9fuR.multiplyConfig),
    (0, $6Pysf.negConfig),
    (0, $fOQaD.nonMaxSuppressionV3Config),
    (0, $5zE1X.nonMaxSuppressionV4Config),
    (0, $inyB0.nonMaxSuppressionV5Config),
    (0, $gGCqu.notEqualConfig),
    (0, $kcYhR.oneHotConfig),
    (0, $2SsCU.onesLikeConfig),
    (0, $7gEB2.packConfig),
    (0, $flmof.padV2Config),
    (0, $k8NQv.powConfig),
    (0, $i325F.preluConfig),
    (0, $k2KEG.prodConfig),
    (0, $bczmc.raggedGatherConfig),
    (0, $1lo4h.raggedTensorToTensorConfig),
    (0, $4fSxJ.rangeConfig),
    (0, $9B72G.realConfig),
    (0, $9MYjt.realDivConfig),
    (0, $6XsUn.reciprocalConfig),
    (0, $dvZMq.reluConfig),
    (0, $7boLi.relu6Config),
    (0, $3qzJ7.reshapeConfig),
    (0, $7G1P4.resizeBilinearConfig),
    (0, $4gZOF.resizeBilinearGradConfig),
    (0, $g8J1f.resizeNearestNeighborConfig),
    (0, $cGN1v.resizeNearestNeighborGradConfig),
    (0, $g5GUB.reverseConfig),
    (0, $ksji9.rotateWithOffsetConfig),
    (0, $ckZSW.roundConfig),
    (0, $1JZ4H.rsqrtConfig),
    (0, $eDNPr.scatterNdConfig),
    (0, $7UpTW.searchSortedConfig),
    (0, $faIEI.selectConfig),
    (0, $9goGn.seluConfig),
    (0, $ZHRjA.sigmoidConfig),
    (0, $7lqVU.signConfig),
    (0, $fUXIH.sinConfig),
    (0, $9BvTb.sinhConfig),
    (0, $fyKXa.sliceConfig),
    (0, $lngaC.softmaxConfig),
    (0, $i3TxW.softplusConfig),
    (0, $eEwtc.spaceToBatchNDConfig),
    (0, $5otIo.sparseFillEmptyRowsConfig),
    (0, $bRUg4.sparseReshapeConfig),
    (0, $dLrGP.sparseSegmentMeanConfig),
    (0, $4GlIz.sparseSegmentSumConfig),
    (0, $6Y5WS.sparseToDenseConfig),
    (0, $eBscM.splitVConfig),
    (0, $9CCZl.sqrtConfig),
    (0, $hsc7d.squareConfig),
    (0, $gigoF.squaredDifferenceConfig),
    (0, $iXcUV.stepConfig),
    (0, $cm4jn.stridedSliceConfig),
    (0, $pFryv.stringNGramsConfig),
    (0, $8jAly.stringSplitConfig),
    (0, $fcSQq.stringToHashBucketFastConfig),
    (0, $gUzQw.subConfig),
    (0, $jPjnE.sumConfig),
    (0, $kFBKH.tanConfig),
    (0, $fHBqI.tanhConfig),
    (0, $atfy0.tileConfig),
    (0, $6wFel.topKConfig),
    (0, $5hkfO.transformConfig),
    (0, $9buNR.transposeConfig),
    (0, $ghozF.uniqueConfig),
    (0, $36DtR.unpackConfig),
    (0, $8OH5n.unsortedSegmentSumConfig),
    (0, $axSMP.zerosLikeConfig)
];
for (const kernelConfig of $9bf970fb67d034bc$var$kernelConfigs)(0, $kaJSw.registerKernel)(kernelConfig);

});
parcelRegister("8FwEB", function(module, exports) {

$parcel$export(module.exports, "_fusedMatMulConfig", () => $64fb7b72a50e3f74$export$f70d36da1c218f84);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $5jh5u = parcelRequire("5jh5u");

var $5Cfhf = parcelRequire("5Cfhf");

var $eTNzV = parcelRequire("eTNzV");
function $64fb7b72a50e3f74$export$d86ca0bbe0236889(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { transposeA: transposeA, transposeB: transposeB, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    let current;
    let addRes;
    let activationRes;
    const intermediates = [];
    const matMulRes = (0, $eTNzV.batchMatMul)({
        inputs: {
            a: a,
            b: b
        },
        attrs: {
            transposeA: transposeA,
            transposeB: transposeB
        },
        backend: backend
    });
    current = matMulRes;
    if (bias) {
        addRes = (0, $5Cfhf.add)({
            inputs: {
                a: current,
                b: bias
            },
            backend: backend
        });
        intermediates.push(current);
        current = addRes;
    }
    if (activation) {
        activationRes = (0, $5jh5u.applyActivation)(backend, current, activation, preluActivationWeights, leakyreluAlpha);
        intermediates.push(current);
        current = activationRes;
    }
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return current;
}
const $64fb7b72a50e3f74$export$f70d36da1c218f84 = {
    kernelName: (0, $dCP8m._FusedMatMul),
    backendName: 'cpu',
    kernelFunc: $64fb7b72a50e3f74$export$d86ca0bbe0236889
};

});
parcelRegister("5jh5u", function(module, exports) {

$parcel$export(module.exports, "applyActivation", () => $3ddbfb50bf533abc$export$a0f250a2ba84196);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $guXy6 = parcelRequire("guXy6");

var $6mG8q = parcelRequire("6mG8q");

var $cA4qv = parcelRequire("cA4qv");

var $i325F = parcelRequire("i325F");

var $dvZMq = parcelRequire("dvZMq");

var $7boLi = parcelRequire("7boLi");

var $ZHRjA = parcelRequire("ZHRjA");
function $3ddbfb50bf533abc$export$a0f250a2ba84196(backend, x, activation, preluActivationWeights, leakyreluAlpha) {
    if (activation === 'linear') return (0, $6mG8q.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else if (activation === 'relu') return (0, $dvZMq.relu)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else if (activation === 'elu') return (0, $guXy6.elu)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else if (activation === 'relu6') return (0, $7boLi.relu6)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else if (activation === 'prelu') return (0, $i325F.prelu)({
        inputs: {
            x: x,
            alpha: preluActivationWeights
        },
        backend: backend
    });
    else if (activation === 'leakyrelu') return (0, $cA4qv.leakyRelu)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            alpha: leakyreluAlpha
        }
    });
    else if (activation === 'sigmoid') return (0, $ZHRjA.sigmoid)({
        inputs: {
            x: x
        },
        backend: backend
    });
    throw new Error(`Activation ${activation} has not been implemented for the CPU backend.`);
}

});
parcelRegister("guXy6", function(module, exports) {

$parcel$export(module.exports, "elu", () => $c02da3e3dd0eb156$export$796b583dd79d8524);
$parcel$export(module.exports, "eluConfig", () => $c02da3e3dd0eb156$export$b990686634ee3cce);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $c02da3e3dd0eb156$export$796b583dd79d8524 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Elu), (xi)=>xi >= 0 ? xi : Math.exp(xi) - 1);
const $c02da3e3dd0eb156$export$b990686634ee3cce = {
    kernelName: (0, $dCP8m.Elu),
    backendName: 'cpu',
    kernelFunc: $c02da3e3dd0eb156$export$796b583dd79d8524
};

});
parcelRegister("lfZyz", function(module, exports) {

$parcel$export(module.exports, "unaryKernelFunc", () => $f79abf8c6a5265c3$export$ba4daf5748026fba);
$parcel$export(module.exports, "unaryKernelFuncFromImpl", () => $f79abf8c6a5265c3$export$34f6865a07ad09b6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $f79abf8c6a5265c3$export$ba4daf5748026fba(name, op, dtype) {
    return ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        (0, $aPHJu.assertNotComplex)(x, name);
        if (x.dtype === 'string' || dtype === 'string') throw new Error('unaryKernelFunc does not support string input/output');
        const cpuBackend = backend;
        const values = cpuBackend.data.get(x.dataId).values;
        const xSize = (0, $wx9lK).sizeFromShape(x.shape);
        const $dtype = dtype || x.dtype;
        const newValues = (0, $wx9lK).getArrayFromDType($dtype, xSize);
        for(let i = 0; i < xSize; ++i)newValues[i] = op(values[i], attrs);
        return cpuBackend.makeTensorInfo(x.shape, $dtype, newValues);
    };
}
function $f79abf8c6a5265c3$export$34f6865a07ad09b6(name, unaryImpl, dtype) {
    return ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        (0, $aPHJu.assertNotComplex)(x, name);
        if (x.dtype === 'string' || dtype === 'string') throw new Error('unaryKernelFunc does not support string input/output');
        const cpuBackend = backend;
        const values = cpuBackend.data.get(x.dataId).values;
        const $dtype = dtype || x.dtype;
        const newValues = unaryImpl(values, $dtype, attrs);
        return cpuBackend.makeTensorInfo(x.shape, $dtype, newValues);
    };
}

});


parcelRegister("6mG8q", function(module, exports) {

$parcel$export(module.exports, "identity", () => $4a257b41b48326a3$export$f0954fd7d5368655);
$parcel$export(module.exports, "identityConfig", () => $4a257b41b48326a3$export$c426d3942537ad84);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
function $4a257b41b48326a3$export$f0954fd7d5368655(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    backend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: x.shape,
        dtype: x.dtype
    };
}
const $4a257b41b48326a3$export$c426d3942537ad84 = {
    kernelName: (0, $dCP8m.Identity),
    backendName: 'cpu',
    kernelFunc: $4a257b41b48326a3$export$f0954fd7d5368655
};

});

parcelRegister("cA4qv", function(module, exports) {

$parcel$export(module.exports, "leakyRelu", () => $928c47d3e3da1f03$export$23a860e40a2c6b61);
$parcel$export(module.exports, "leakyReluConfig", () => $928c47d3e3da1f03$export$aa04ab963fdf437f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $928c47d3e3da1f03$export$23a860e40a2c6b61(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { alpha: alpha } = attrs;
    (0, $aPHJu.assertNotComplex)([
        x
    ], 'leakyRelu');
    const xSize = (0, $wx9lK).sizeFromShape(x.shape);
    const xVals = backend.data.get(x.dataId).values;
    const outVals = (0, $wx9lK).getTypedArrayFromDType('float32', xSize);
    for(let i = 0; i < xVals.length; i++)outVals[i] = xVals[i] < 0 ? alpha * xVals[i] : xVals[i];
    return backend.makeTensorInfo(x.shape, 'float32', outVals);
}
const $928c47d3e3da1f03$export$aa04ab963fdf437f = {
    kernelName: (0, $dCP8m.LeakyRelu),
    backendName: 'cpu',
    kernelFunc: $928c47d3e3da1f03$export$23a860e40a2c6b61
};

});

parcelRegister("i325F", function(module, exports) {

$parcel$export(module.exports, "prelu", () => $d23a20ecb2449b3a$export$5882f235222e6729);
$parcel$export(module.exports, "preluConfig", () => $d23a20ecb2449b3a$export$a5c4a9b694579636);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");

var $aRRHO = parcelRequire("aRRHO");
const $d23a20ecb2449b3a$var$preluImpl = (0, $aRRHO.createSimpleBinaryKernelImpl)((xValue, aValue)=>xValue < 0 ? aValue * xValue : xValue);
function $d23a20ecb2449b3a$export$5882f235222e6729(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x, alpha: alpha } = inputs;
    (0, $aPHJu.assertNotComplex)([
        x,
        alpha
    ], 'prelu');
    const aVals = backend.data.get(x.dataId).values;
    const bVals = backend.data.get(alpha.dataId).values;
    const [resultData, resultShape] = $d23a20ecb2449b3a$var$preluImpl(x.shape, alpha.shape, aVals, bVals, 'float32');
    return backend.makeTensorInfo(resultShape, 'float32', resultData);
}
const $d23a20ecb2449b3a$export$a5c4a9b694579636 = {
    kernelName: (0, $dCP8m.Prelu),
    backendName: 'cpu',
    kernelFunc: $d23a20ecb2449b3a$export$5882f235222e6729
};

});
parcelRegister("aRRHO", function(module, exports) {

$parcel$export(module.exports, "createSimpleBinaryKernelImpl", () => $7e98836eb502fc08$export$28de919591fae5d9);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");
function $7e98836eb502fc08$export$28de919591fae5d9(op) {
    return (aShape, bShape, aVals, bVals, dtype)=>{
        const newShape = (0, $lkN62).assertAndGetBroadcastShape(aShape, bShape);
        const resultRank = newShape.length;
        const resultStrides = (0, $wx9lK).computeStrides(newShape);
        const resultSize = (0, $wx9lK).sizeFromShape(newShape);
        const result = (0, $wx9lK).getTypedArrayFromDType(dtype, resultSize);
        const aRank = aShape.length;
        const bRank = bShape.length;
        const aStrides = (0, $wx9lK).computeStrides(aShape);
        const bStrides = (0, $wx9lK).computeStrides(bShape);
        const aBroadcastDims = (0, $lkN62).getBroadcastDims(aShape, newShape);
        const bBroadcastDims = (0, $lkN62).getBroadcastDims(bShape, newShape);
        if (aBroadcastDims.length + bBroadcastDims.length === 0) for(let i = 0; i < result.length; ++i)result[i] = op(aVals[i % aVals.length], bVals[i % bVals.length]);
        else for(let i = 0; i < result.length; ++i){
            const loc = (0, $wx9lK).indexToLoc(i, resultRank, resultStrides);
            const aLoc = loc.slice(-aRank);
            aBroadcastDims.forEach((d)=>aLoc[d] = 0);
            const aIndex = (0, $wx9lK).locToIndex(aLoc, aRank, aStrides);
            const bLoc = loc.slice(-bRank);
            bBroadcastDims.forEach((d)=>bLoc[d] = 0);
            const bIndex = (0, $wx9lK).locToIndex(bLoc, bRank, bStrides);
            result[i] = op(aVals[aIndex], bVals[bIndex]);
        }
        return [
            result,
            newShape
        ];
    };
}

});


parcelRegister("dvZMq", function(module, exports) {

$parcel$export(module.exports, "relu", () => $9d6e17d7534869bd$export$16d1e4612cc0139f);
$parcel$export(module.exports, "reluConfig", () => $9d6e17d7534869bd$export$731f9199bde068eb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $9d6e17d7534869bd$export$16d1e4612cc0139f = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Relu), (xi)=>Math.max(0, xi));
const $9d6e17d7534869bd$export$731f9199bde068eb = {
    kernelName: (0, $dCP8m.Relu),
    backendName: 'cpu',
    kernelFunc: $9d6e17d7534869bd$export$16d1e4612cc0139f
};

});

parcelRegister("7boLi", function(module, exports) {

$parcel$export(module.exports, "relu6", () => $53acc4a7eb474779$export$4a62bcb95e9c44c4);
$parcel$export(module.exports, "relu6Config", () => $53acc4a7eb474779$export$92c30890ad649d53);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $53acc4a7eb474779$export$4a62bcb95e9c44c4 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Relu6), (xi)=>Math.min(Math.max(0, xi), 6));
const $53acc4a7eb474779$export$92c30890ad649d53 = {
    kernelName: (0, $dCP8m.Relu6),
    backendName: 'cpu',
    kernelFunc: $53acc4a7eb474779$export$4a62bcb95e9c44c4
};

});

parcelRegister("ZHRjA", function(module, exports) {

$parcel$export(module.exports, "sigmoidImpl", () => $0b97b81652d70479$export$e31bae35ce8238b3);
$parcel$export(module.exports, "sigmoid", () => $0b97b81652d70479$export$3b295495ca3cad7c);
$parcel$export(module.exports, "sigmoidConfig", () => $0b97b81652d70479$export$195d1cf7c59f3ef);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $021b6 = parcelRequire("021b6");

var $lfZyz = parcelRequire("lfZyz");
const $0b97b81652d70479$export$e31bae35ce8238b3 = (0, $021b6.createSimpleUnaryImpl)((xi)=>1 / (1 + Math.exp(-xi)));
const $0b97b81652d70479$export$3b295495ca3cad7c = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Sigmoid), (xi)=>1 / (1 + Math.exp(-xi)));
const $0b97b81652d70479$export$195d1cf7c59f3ef = {
    kernelName: (0, $dCP8m.Sigmoid),
    backendName: 'cpu',
    kernelFunc: $0b97b81652d70479$export$3b295495ca3cad7c
};

});
parcelRegister("021b6", function(module, exports) {

$parcel$export(module.exports, "createSimpleUnaryImpl", () => $006119f067f22add$export$ef8b4452872ef3fc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
function $006119f067f22add$export$ef8b4452872ef3fc(op) {
    return (values, dtype, attrs)=>{
        const newValues = (0, $wx9lK).getTypedArrayFromDType(dtype, values.length);
        for(let i = 0; i < values.length; ++i)newValues[i] = op(values[i], attrs);
        return newValues;
    };
}

});



parcelRegister("5Cfhf", function(module, exports) {

$parcel$export(module.exports, "addImpl", () => $416c5a166494dd40$export$da57353b24bb5e2);
$parcel$export(module.exports, "add", () => $416c5a166494dd40$export$e16d8520af44a096);
$parcel$export(module.exports, "addConfig", () => $416c5a166494dd40$export$b1f3a580afb68e4c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $416c5a166494dd40$export$da57353b24bb5e2 = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>a + b);
const $416c5a166494dd40$export$ace1d0de36b43ba2 = (0, $3Zasd.createComplexBinaryKernelImpl)((aReal, aImag, bReal, bImag)=>{
    return {
        real: aReal + bReal,
        imag: aImag + bImag
    };
});
const $416c5a166494dd40$export$e16d8520af44a096 = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.Add), $416c5a166494dd40$export$da57353b24bb5e2, $416c5a166494dd40$export$ace1d0de36b43ba2);
const $416c5a166494dd40$export$b1f3a580afb68e4c = {
    kernelName: (0, $dCP8m.Add),
    backendName: 'cpu',
    kernelFunc: $416c5a166494dd40$export$e16d8520af44a096
};

});
parcelRegister("3Zasd", function(module, exports) {

$parcel$export(module.exports, "binaryKernelFunc", () => $2e6f2d8cefa22199$export$29353c66e70e3e16);
$parcel$export(module.exports, "createComplexBinaryKernelImpl", () => $2e6f2d8cefa22199$export$79261d982c3c14a7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $gSA6r = parcelRequire("gSA6r");

var $78AN7 = parcelRequire("78AN7");
function $2e6f2d8cefa22199$export$29353c66e70e3e16(name, simpleImpl, complexImpl, dtype) {
    if (complexImpl == null) return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const cpuBackend = backend;
        (0, $aPHJu.assertNotComplex)([
            a,
            b
        ], name);
        const aVals = cpuBackend.data.get(a.dataId).values;
        const bVals = cpuBackend.data.get(b.dataId).values;
        const decodedAVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
        (0, $lkN62).fromUint8ToStringArray(aVals) : aVals;
        const decodedBVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
        (0, $lkN62).fromUint8ToStringArray(bVals) : bVals;
        const $dtype = dtype || a.dtype;
        const [resultData, resultShape] = simpleImpl(a.shape, b.shape, decodedAVals, decodedBVals, $dtype);
        return cpuBackend.makeTensorInfo(resultShape, $dtype, resultData);
    };
    return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const cpuBackend = backend;
        if (a.dtype === 'complex64' || b.dtype === 'complex64') {
            const $aComplex = (0, $gSA6r.cast)({
                inputs: {
                    x: a
                },
                backend: cpuBackend,
                attrs: {
                    dtype: 'complex64'
                }
            });
            const $aComplexVals = cpuBackend.data.get($aComplex.dataId);
            const aReal = $aComplexVals.complexTensorInfos.real;
            const aImag = $aComplexVals.complexTensorInfos.imag;
            const aRealVals = cpuBackend.data.get(aReal.dataId).values;
            const aImagVals = cpuBackend.data.get(aImag.dataId).values;
            const $bComplex = (0, $gSA6r.cast)({
                inputs: {
                    x: b
                },
                backend: cpuBackend,
                attrs: {
                    dtype: 'complex64'
                }
            });
            const $bComplexVals = cpuBackend.data.get($bComplex.dataId);
            const bReal = $bComplexVals.complexTensorInfos.real;
            const bImag = $bComplexVals.complexTensorInfos.imag;
            const bRealVals = cpuBackend.data.get(bReal.dataId).values;
            const bImagVals = cpuBackend.data.get(bImag.dataId).values;
            const [resultRealData, resultImagData, resultShape] = complexImpl(a.shape, b.shape, aRealVals, aImagVals, bRealVals, bImagVals);
            const resultReal = cpuBackend.makeTensorInfo(resultShape, 'float32', resultRealData);
            const resultImag = cpuBackend.makeTensorInfo(resultShape, 'float32', resultImagData);
            const result = (0, $78AN7.complex)({
                inputs: {
                    real: resultReal,
                    imag: resultImag
                },
                backend: cpuBackend
            });
            cpuBackend.disposeIntermediateTensorInfo($aComplex);
            cpuBackend.disposeIntermediateTensorInfo($bComplex);
            cpuBackend.disposeIntermediateTensorInfo(resultReal);
            cpuBackend.disposeIntermediateTensorInfo(resultImag);
            return result;
        } else {
            const aVals = cpuBackend.data.get(a.dataId).values;
            const bVals = cpuBackend.data.get(b.dataId).values;
            const $dtype = dtype || a.dtype;
            const [resultData, resultShape] = simpleImpl(a.shape, b.shape, aVals, bVals, $dtype);
            return cpuBackend.makeTensorInfo(resultShape, $dtype, resultData);
        }
    };
}
function $2e6f2d8cefa22199$export$79261d982c3c14a7(op) {
    return (aShape, bShape, aRealVals, aImagVals, bRealVals, bImagVals)=>{
        const resultShape = (0, $lkN62).assertAndGetBroadcastShape(aShape, bShape);
        const resultSize = (0, $wx9lK).sizeFromShape(resultShape);
        const resultRank = resultShape.length;
        const resultStrides = (0, $wx9lK).computeStrides(resultShape);
        const resultRealVals = (0, $wx9lK).getTypedArrayFromDType('float32', resultSize);
        const resultImagVals = (0, $wx9lK).getTypedArrayFromDType('float32', resultSize);
        const aBroadcastDims = (0, $lkN62).getBroadcastDims(aShape, resultShape);
        const bBroadcastDims = (0, $lkN62).getBroadcastDims(bShape, resultShape);
        const aVals = (0, $lkN62).mergeRealAndImagArrays(aRealVals, aImagVals);
        const bVals = (0, $lkN62).mergeRealAndImagArrays(bRealVals, bImagVals);
        const aRank = aShape.length;
        const aStrides = (0, $wx9lK).computeStrides(aShape);
        const bRank = bShape.length;
        const bStrides = (0, $wx9lK).computeStrides(bShape);
        if (aBroadcastDims.length + bBroadcastDims.length === 0) for(let i = 0; i < resultRealVals.length; i++){
            const aIdx = i % aVals.length;
            const bIdx = i % bVals.length;
            const result = op(aVals[aIdx * 2], aVals[aIdx * 2 + 1], bVals[bIdx * 2], bVals[bIdx * 2 + 1]);
            resultRealVals[i] = result.real;
            resultImagVals[i] = result.imag;
        }
        else for(let i = 0; i < resultRealVals.length; i++){
            const loc = (0, $wx9lK).indexToLoc(i, resultRank, resultStrides);
            const aLoc = loc.slice(-aRank);
            aBroadcastDims.forEach((d)=>aLoc[d] = 0);
            const aIndex = (0, $wx9lK).locToIndex(aLoc, aRank, aStrides);
            const bLoc = loc.slice(-bRank);
            bBroadcastDims.forEach((d)=>bLoc[d] = 0);
            const bIndex = (0, $wx9lK).locToIndex(bLoc, bRank, bStrides);
            const opResult = op(aVals[aIndex * 2], aVals[aIndex * 2 + 1], bVals[bIndex * 2], bVals[bIndex * 2 + 1]);
            resultRealVals[i] = opResult.real;
            resultImagVals[i] = opResult.imag;
        }
        return [
            resultRealVals,
            resultImagVals,
            resultShape
        ];
    };
}

});
parcelRegister("gSA6r", function(module, exports) {

$parcel$export(module.exports, "castImpl", () => $c49db1c911c7c874$export$aeeb3b33e2cee0c5);
$parcel$export(module.exports, "cast", () => $c49db1c911c7c874$export$f2db7d5238e1d23f);
$parcel$export(module.exports, "castConfig", () => $c49db1c911c7c874$export$ac4d0f0f3927a8f3);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aRRHO = parcelRequire("aRRHO");

var $iwsxi = parcelRequire("iwsxi");

var $78AN7 = parcelRequire("78AN7");

var $6mG8q = parcelRequire("6mG8q");

var $9B72G = parcelRequire("9B72G");
function $c49db1c911c7c874$export$aeeb3b33e2cee0c5(values, shape, inputType, dtype) {
    if (dtype === 'int32') {
        const resultValues = Int32Array.from(values);
        return [
            shape,
            'int32',
            resultValues
        ];
    }
    if (dtype === 'bool') {
        // This is essentially the result of notEqual(x, 0). We avoid using
        // kernel notEqual to avoid circular dependency, i.e. binary_utils ->
        // cast -> notEqual -> binary_utils.
        const zero = (0, $wx9lK).toTypedArray([
            0
        ], inputType);
        const [resultData, resultShape] = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>a !== b ? 1 : 0)(shape, [], values, zero, 'bool');
        return [
            resultShape,
            'bool',
            resultData
        ];
    }
    throw new Error(`Error in Cast: failed to cast ${inputType} to ${dtype}`);
}
function $c49db1c911c7c874$export$f2db7d5238e1d23f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dtype: dtype } = attrs;
    // Casting to complex64.
    if (dtype === 'complex64') {
        if (x.dtype === 'complex64') return (0, $6mG8q.identity)({
            inputs: {
                x: x
            },
            backend: backend
        });
        const zerosTensorInfo = (0, $iwsxi.zeros)(backend, x.shape, x.dtype);
        const floatX = $c49db1c911c7c874$export$f2db7d5238e1d23f({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const result = (0, $78AN7.complex)({
            inputs: {
                real: floatX,
                imag: zerosTensorInfo
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(zerosTensorInfo);
        backend.disposeIntermediateTensorInfo(floatX);
        return result;
    }
    // Casting from complex64
    if (x.dtype === 'complex64') {
        const realPart = (0, $9B72G.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const result = $c49db1c911c7c874$export$f2db7d5238e1d23f({
            inputs: {
                x: realPart
            },
            backend: backend,
            attrs: {
                dtype: dtype
            }
        });
        backend.disposeIntermediateTensorInfo(realPart);
        return result;
    }
    if (!(0, $wx9lK).hasEncodingLoss(x.dtype, dtype)) {
        // We don't change the underlying data, since we cast to higher
        // precision.
        const result = (0, $6mG8q.identity)({
            inputs: {
                x: x
            },
            backend: backend
        });
        return {
            dataId: result.dataId,
            shape: result.shape,
            dtype: dtype
        };
    }
    const values = backend.data.get(x.dataId).values;
    const [resultShape, resultType, resultData] = $c49db1c911c7c874$export$aeeb3b33e2cee0c5(values, x.shape, x.dtype, dtype);
    return backend.makeTensorInfo(resultShape, resultType, resultData);
}
const $c49db1c911c7c874$export$ac4d0f0f3927a8f3 = {
    kernelName: (0, $dCP8m.Cast),
    backendName: 'cpu',
    kernelFunc: $c49db1c911c7c874$export$f2db7d5238e1d23f
};

});
parcelRegister("iwsxi", function(module, exports) {

$parcel$export(module.exports, "zeros", () => $d7c159ca92db37f8$export$4445a00dafa2633b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $78AN7 = parcelRequire("78AN7");
function $d7c159ca92db37f8$export$4445a00dafa2633b(backend, shape, dtype = 'float32') {
    if (dtype === 'complex64') {
        const real = $d7c159ca92db37f8$export$4445a00dafa2633b(backend, shape, 'float32');
        const imag = $d7c159ca92db37f8$export$4445a00dafa2633b(backend, shape, 'float32');
        return (0, $78AN7.complex)({
            inputs: {
                real: real,
                imag: imag
            },
            backend: backend
        });
    }
    const values = (0, $wx9lK).makeZerosTypedArray((0, $wx9lK).sizeFromShape(shape), dtype);
    return backend.makeTensorInfo(shape, dtype, values);
}

});
parcelRegister("78AN7", function(module, exports) {

$parcel$export(module.exports, "complex", () => $5325d1beea0b7cb3$export$83a0e34f1302825b);
$parcel$export(module.exports, "complexConfig", () => $5325d1beea0b7cb3$export$67917f7910d27fd8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
function $5325d1beea0b7cb3$export$83a0e34f1302825b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { real: real, imag: imag } = inputs;
    const realVals = backend.data.get(real.dataId).values;
    const imagVals = backend.data.get(imag.dataId).values;
    const complexInfo = backend.makeTensorInfo(real.shape, 'complex64');
    const complex = backend.data.get(complexInfo.dataId);
    // The complex tensor owns the underlying real and imag tensorInfos, only the
    // complex tensor tracks refCount, when complexData is disposed the
    // underlying tensorData will be disposed.
    complex.complexTensorInfos = {
        real: backend.makeTensorInfo(real.shape, 'float32', realVals),
        imag: backend.makeTensorInfo(imag.shape, 'float32', imagVals)
    };
    return complexInfo;
}
const $5325d1beea0b7cb3$export$67917f7910d27fd8 = {
    kernelName: (0, $dCP8m.Complex),
    backendName: 'cpu',
    kernelFunc: $5325d1beea0b7cb3$export$83a0e34f1302825b
};

});


parcelRegister("9B72G", function(module, exports) {

$parcel$export(module.exports, "real", () => $6fcd08384205da0c$export$9fc57fb453bdbd67);
$parcel$export(module.exports, "realConfig", () => $6fcd08384205da0c$export$4b7bce57557ae68b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
function $6fcd08384205da0c$export$9fc57fb453bdbd67(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const real = backend.data.get(input.dataId).complexTensorInfos.real;
    const realVal = backend.data.get(real.dataId).values;
    // When complex tensor is disposed, its underlying parts will be disposed too.
    // Make new tensor out of the real value of the complex. This makes sure the
    // value is still accessible even if complex tensor is disposed.
    return backend.makeTensorInfo(real.shape, real.dtype, realVal);
}
const $6fcd08384205da0c$export$4b7bce57557ae68b = {
    kernelName: (0, $dCP8m.Real),
    backendName: 'cpu',
    kernelFunc: $6fcd08384205da0c$export$9fc57fb453bdbd67
};

});




parcelRegister("eTNzV", function(module, exports) {

$parcel$export(module.exports, "batchMatMul", () => $ad8ca8f9feabe2bd$export$8f97894b482227f0);
$parcel$export(module.exports, "batchMatMulConfig", () => $ad8ca8f9feabe2bd$export$d0dd993198185538);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $eqTIO = parcelRequire("eqTIO");
var $g81BN = parcelRequire("g81BN");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $3qzJ7 = parcelRequire("3qzJ7");
function $ad8ca8f9feabe2bd$export$8f97894b482227f0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b } = inputs;
    const { transposeA: transposeA, transposeB: transposeB } = attrs;
    (0, $aPHJu.assertNotComplex)([
        a,
        b
    ], 'matMul');
    const aRank = a.shape.length;
    const bRank = b.shape.length;
    const innerShapeA = transposeA ? a.shape[aRank - 2] : a.shape[aRank - 1];
    const innerShapeB = transposeB ? b.shape[bRank - 1] : b.shape[bRank - 2];
    const outerShapeA = transposeA ? a.shape[aRank - 1] : a.shape[aRank - 2];
    const outerShapeB = transposeB ? b.shape[bRank - 2] : b.shape[bRank - 1];
    const outerDimsA = a.shape.slice(0, -2);
    const outerDimsB = b.shape.slice(0, -2);
    const batchDimA = (0, $wx9lK).sizeFromShape(outerDimsA);
    const batchDimB = (0, $wx9lK).sizeFromShape(outerDimsB);
    const outShapeOuterDims = (0, $eqTIO).assertAndGetBroadcastShape(a.shape.slice(0, -2), b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    (0, $wx9lK).assert(innerShapeA === innerShapeB, ()=>`Error in matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${a.shape} and ` + `${b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const a3dShape = transposeA ? [
        batchDimA,
        innerShapeA,
        outerShapeA
    ] : [
        batchDimA,
        outerShapeA,
        innerShapeA
    ];
    const b3dShape = transposeB ? [
        batchDimB,
        outerShapeB,
        innerShapeB
    ] : [
        batchDimB,
        innerShapeB,
        outerShapeB
    ];
    // The rest of the implementation is designed to operate on rank-3 tensors
    const a3d = (0, $3qzJ7.reshape)({
        inputs: {
            x: a
        },
        backend: backend,
        attrs: {
            shape: a3dShape
        }
    });
    const b3d = (0, $3qzJ7.reshape)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            shape: b3dShape
        }
    });
    const sharedDim = transposeA ? a3d.shape[1] : a3d.shape[2];
    const leftDim = transposeA ? a3d.shape[2] : a3d.shape[1];
    const rightDim = transposeB ? b3d.shape[1] : b3d.shape[2];
    const batchDim = Math.max(batchDimA, batchDimB);
    const a3dValues = backend.data.get(a3d.dataId).values;
    const b3dValues = backend.data.get(b3d.dataId).values;
    const a3dStrides = (0, $wx9lK).computeStrides(a3d.shape);
    const b3dStrides = (0, $wx9lK).computeStrides(b3d.shape);
    const [aBatch, aOuterStep, aInnerStep] = transposeA ? [
        a3dStrides[0],
        1,
        a3dStrides[1]
    ] : [
        a3dStrides[0],
        a3dStrides[1],
        1
    ];
    const [bInnerStep, bOuterStep, bBatch] = transposeB ? [
        1,
        b3dStrides[1],
        b3dStrides[0]
    ] : [
        b3dStrides[1],
        1,
        b3dStrides[0]
    ];
    const size = leftDim * rightDim;
    const result = (0, $g81BN.buffer)([
        batchDim,
        leftDim,
        rightDim
    ], a3d.dtype);
    const resVals = result.values;
    const blockSize = backend.blockSize;
    for(let bi = 0; bi < batchDim; bi++)for(let i0 = 0; i0 < leftDim; i0 += blockSize){
        for(let j0 = 0; j0 < rightDim; j0 += blockSize)for(let k0 = 0; k0 < sharedDim; k0 += blockSize){
            // for when blockSize doesn't evenly divide the input
            const iBlock = Math.min(i0 + blockSize, leftDim);
            const jBlock = Math.min(j0 + blockSize, rightDim);
            const kBlock = Math.min(k0 + blockSize, sharedDim);
            for(let i = i0; i < iBlock; i++)for(let j = j0; j < jBlock; j++){
                let sum = 0.0;
                for(let k = k0; k < kBlock; k++){
                    const batchOffsetA = Math.min(bi, batchDimA - 1) * aBatch;
                    const batchOffsetB = Math.min(bi, batchDimB - 1) * bBatch;
                    const aVal = a3dValues[batchOffsetA + i * aOuterStep + k * aInnerStep];
                    const bVal = b3dValues[k * bInnerStep + j * bOuterStep + batchOffsetB];
                    sum += aVal * bVal;
                }
                resVals[bi * size + (i * rightDim + j)] += sum;
            }
        }
    }
    backend.disposeIntermediateTensorInfo(a3d);
    backend.disposeIntermediateTensorInfo(b3d);
    // set correct shape on output.
    return backend.makeTensorInfo(outShape, result.dtype, result.values);
}
const $ad8ca8f9feabe2bd$export$d0dd993198185538 = {
    kernelName: (0, $dCP8m.BatchMatMul),
    backendName: 'cpu',
    kernelFunc: $ad8ca8f9feabe2bd$export$8f97894b482227f0
};

});
parcelRegister("3qzJ7", function(module, exports) {

$parcel$export(module.exports, "reshape", () => $27ef8362541809fd$export$9eaad88cf88cee2b);
$parcel$export(module.exports, "reshapeConfig", () => $27ef8362541809fd$export$cfa02e698602aca2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
function $27ef8362541809fd$export$9eaad88cf88cee2b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { shape: shape } = attrs;
    const xSize = (0, $wx9lK).sizeFromShape(x.shape);
    const $shape = (0, $wx9lK).inferFromImplicitShape(shape, xSize);
    const $xSize = (0, $wx9lK).sizeFromShape($shape);
    (0, $wx9lK).assert(xSize === $xSize, ()=>`The new shape (${$shape}) has ${$xSize} elements and the old ` + `shape (${x.shape}) has ${xSize} elements. The new shape and old ` + `shape must have the same number of elements.`);
    backend.incRef(x.dataId);
    const xData = backend.data.get(x.dataId);
    if (xData.complexTensorInfos != null) {
        const real = xData.complexTensorInfos.real;
        const imag = xData.complexTensorInfos.imag;
        real.shape = $shape;
        imag.shape = $shape;
    }
    return {
        dataId: x.dataId,
        shape: $shape,
        dtype: x.dtype
    };
}
const $27ef8362541809fd$export$cfa02e698602aca2 = {
    kernelName: (0, $dCP8m.Reshape),
    backendName: 'cpu',
    kernelFunc: $27ef8362541809fd$export$9eaad88cf88cee2b
};

});



parcelRegister("Hrrqa", function(module, exports) {

$parcel$export(module.exports, "simpleAbsImpl", () => $08294d886a112707$export$9e7ee8a1798ec2d5);
$parcel$export(module.exports, "absConfig", () => $08294d886a112707$export$d66f48648b9d5ec7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $08294d886a112707$export$9e7ee8a1798ec2d5(vals) {
    const resultValues = new Float32Array(vals.length);
    for(let i = 0; i < vals.length; ++i)resultValues[i] = Math.abs(vals[i]);
    return resultValues;
}
const $08294d886a112707$export$2335f513bbd82c6d = (args)=>{
    const { x: x } = args.inputs;
    const cpuBackend = args.backend;
    (0, $aPHJu.assertNotComplex)(x, 'abs');
    let resultValues = new Float32Array((0, $wx9lK).sizeFromShape(x.shape));
    const values = cpuBackend.data.get(x.dataId).values;
    resultValues = $08294d886a112707$export$9e7ee8a1798ec2d5(values);
    return cpuBackend.makeOutput(resultValues, x.shape, x.dtype);
};
const $08294d886a112707$export$d66f48648b9d5ec7 = {
    kernelName: (0, $dCP8m.Abs),
    backendName: 'cpu',
    kernelFunc: $08294d886a112707$export$2335f513bbd82c6d
};

});

parcelRegister("fYFG5", function(module, exports) {

$parcel$export(module.exports, "acosConfig", () => $ba1cc9f8d318d5de$export$255826ca70737275);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $ba1cc9f8d318d5de$export$fd6306be3fde5b04 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Acos), (xi)=>Math.acos(xi));
const $ba1cc9f8d318d5de$export$255826ca70737275 = {
    kernelName: (0, $dCP8m.Acos),
    backendName: 'cpu',
    kernelFunc: $ba1cc9f8d318d5de$export$fd6306be3fde5b04
};

});

parcelRegister("dEMhX", function(module, exports) {

$parcel$export(module.exports, "acoshConfig", () => $9f1477ea8f75ed04$export$3f520b71a56c9e70);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $9f1477ea8f75ed04$export$b26caf0f29211d08 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Acosh), (xi)=>Math.acosh(xi));
const $9f1477ea8f75ed04$export$3f520b71a56c9e70 = {
    kernelName: (0, $dCP8m.Acosh),
    backendName: 'cpu',
    kernelFunc: $9f1477ea8f75ed04$export$b26caf0f29211d08
};

});

parcelRegister("6XRJM", function(module, exports) {

$parcel$export(module.exports, "addNConfig", () => $5121efe9840286e4$export$ff8000bc6f0313e1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $g81BN = parcelRequire("g81BN");

var $aPHJu = parcelRequire("aPHJu");
function $5121efe9840286e4$export$37b75d0026f96b8d(args) {
    const { inputs: inputs, backend: backend } = args;
    const tensors = inputs;
    (0, $aPHJu.assertNotComplex)(inputs, 'addN');
    const vals = tensors.map((t)=>backend.data.get(t.dataId).values);
    const outBuf = (0, $g81BN.buffer)(tensors[0].shape, tensors[0].dtype);
    const outVals = outBuf.values;
    for(let i = 0; i < tensors.length; i++){
        const currVals = vals[i];
        for(let j = 0; j < outVals.length; j++)outVals[j] += currVals[j];
    }
    return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
}
const $5121efe9840286e4$export$ff8000bc6f0313e1 = {
    kernelName: (0, $dCP8m.AddN),
    backendName: 'cpu',
    kernelFunc: $5121efe9840286e4$export$37b75d0026f96b8d
};

});

parcelRegister("2U0Mn", function(module, exports) {

$parcel$export(module.exports, "allConfig", () => $21d16a75795244b0$export$4e3f081eb1a330fa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $3qzJ7 = parcelRequire("3qzJ7");

var $9buNR = parcelRequire("9buNR");
function $21d16a75795244b0$export$84bf76cd7afc7469(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'all');
    const origAxes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    if (permutedAxes != null) {
        $x = (0, $9buNR.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $lkN62).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $lkN62).assertAxesAreInnerMostDims('all', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes($x.shape, axes);
    const reduceSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const vals = (0, $wx9lK).makeZerosTypedArray((0, $wx9lK).sizeFromShape(outShape), $x.dtype);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let all = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            all = all && value;
        }
        vals[i] = all;
    }
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo($x);
    const result = backend.makeTensorInfo(outShape, $x.dtype, vals);
    if (keepDims) {
        const expandedShape = (0, $lkN62).expandShapeToKeepDim(outShape, origAxes);
        const reshapedResult = (0, $3qzJ7.reshape)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: expandedShape
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        return reshapedResult;
    }
    return result;
}
const $21d16a75795244b0$export$4e3f081eb1a330fa = {
    kernelName: (0, $dCP8m.All),
    backendName: 'cpu',
    kernelFunc: $21d16a75795244b0$export$84bf76cd7afc7469
};

});
parcelRegister("9buNR", function(module, exports) {

$parcel$export(module.exports, "transpose", () => $6afd090129ca490d$export$9cb09a71b7d66923);
$parcel$export(module.exports, "transposeConfig", () => $6afd090129ca490d$export$895a002a39b774be);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");

var $4SJWC = parcelRequire("4SJWC");
function $6afd090129ca490d$export$9cb09a71b7d66923(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { x: x } = inputs;
    const { perm: perm } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'transpose');
    const xRank = x.shape.length;
    const newShape = new Array(xRank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[perm[i]];
    const values = backend.data.get(x.dataId).values;
    const result = (0, $4SJWC.transposeImpl)(values, x.shape, x.dtype, perm, newShape);
    const dataId = backend.write(result, newShape, x.dtype);
    return {
        dataId: dataId,
        shape: newShape,
        dtype: x.dtype
    };
}
const $6afd090129ca490d$export$895a002a39b774be = {
    kernelName: (0, $dCP8m.Transpose),
    backendName: 'cpu',
    kernelFunc: $6afd090129ca490d$export$9cb09a71b7d66923
};

});
parcelRegister("4SJWC", function(module, exports) {

$parcel$export(module.exports, "transposeImpl", () => $38dfd82d0fa924b5$export$986b9e65182e08d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
function $38dfd82d0fa924b5$export$986b9e65182e08d(xVals, xShape, dtype, perm, newShape) {
    const xRank = xShape.length;
    const xSize = (0, $wx9lK).sizeFromShape(xShape);
    const xStrides = (0, $wx9lK).computeStrides(xShape);
    const newStrides = (0, $wx9lK).computeStrides(newShape);
    const result = (0, $wx9lK).getTypedArrayFromDType(dtype, (0, $wx9lK).sizeFromShape(newShape));
    for(let i = 0; i < xSize; ++i){
        const loc = (0, $wx9lK).indexToLoc(i, xRank, xStrides);
        // Permute location.
        const newLoc = new Array(loc.length);
        for(let i = 0; i < newLoc.length; i++)newLoc[i] = loc[perm[i]];
        const newIndex = (0, $wx9lK).locToIndex(newLoc, xRank, newStrides);
        result[newIndex] = xVals[i];
    }
    return result;
}

});



parcelRegister("cV4BO", function(module, exports) {

$parcel$export(module.exports, "anyConfig", () => $967e621d78298252$export$1a8ff634f2df3da6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $3qzJ7 = parcelRequire("3qzJ7");

var $9buNR = parcelRequire("9buNR");
function $967e621d78298252$export$4154a199d7d90455(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'any');
    const origAxes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    if (permutedAxes != null) {
        $x = (0, $9buNR.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $lkN62).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $lkN62).assertAxesAreInnerMostDims('any', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes($x.shape, axes);
    const reduceSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const vals = (0, $wx9lK).makeZerosTypedArray((0, $wx9lK).sizeFromShape(outShape), $x.dtype);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let anyVal = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            anyVal = anyVal || value;
        }
        vals[i] = anyVal;
    }
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo($x);
    const result = backend.makeTensorInfo(outShape, $x.dtype, vals);
    if (keepDims) {
        const expandedShape = (0, $lkN62).expandShapeToKeepDim(outShape, origAxes);
        const reshapedResult = (0, $3qzJ7.reshape)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: expandedShape
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        return reshapedResult;
    }
    return result;
}
const $967e621d78298252$export$1a8ff634f2df3da6 = {
    kernelName: (0, $dCP8m.Any),
    backendName: 'cpu',
    kernelFunc: $967e621d78298252$export$4154a199d7d90455
};

});

parcelRegister("falTI", function(module, exports) {

$parcel$export(module.exports, "argMaxConfig", () => $b0a8c69c32ec1067$export$ec7419fc9ad0069e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $9buNR = parcelRequire("9buNR");
function $b0a8c69c32ec1067$export$7980a683c1b852b4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'argMax');
    let axes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $9buNR.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $lkN62).getInnerMostAxes(axes.length, $x.shape.length);
    }
    axes = [
        axes[0]
    ];
    (0, $lkN62).assertAxesAreInnerMostDims('argMax', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes($x.shape, axes);
    const outSize = (0, $wx9lK).sizeFromShape(outShape);
    const vals = (0, $wx9lK).makeZerosTypedArray(outSize, 'int32');
    const reduceSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let max = aVals[offset];
        let maxIndex = 0;
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (value > max) {
                max = value;
                maxIndex = j;
            }
        }
        vals[i] = maxIndex;
    }
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return backend.makeTensorInfo(outShape, 'int32', vals);
}
const $b0a8c69c32ec1067$export$ec7419fc9ad0069e = {
    kernelName: (0, $dCP8m.ArgMax),
    backendName: 'cpu',
    kernelFunc: $b0a8c69c32ec1067$export$7980a683c1b852b4
};

});

parcelRegister("gwOnn", function(module, exports) {

$parcel$export(module.exports, "argMinConfig", () => $c086b6254f644a2e$export$21836a5e5fa09eb4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $9buNR = parcelRequire("9buNR");
function $c086b6254f644a2e$export$ec99a91cddfb29a2(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'argMin');
    let axes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $9buNR.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $lkN62).getInnerMostAxes(axes.length, $x.shape.length);
    }
    axes = [
        axes[0]
    ];
    (0, $lkN62).assertAxesAreInnerMostDims('argMin', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes($x.shape, axes);
    const outSize = (0, $wx9lK).sizeFromShape(outShape);
    const vals = (0, $wx9lK).makeZerosTypedArray(outSize, 'int32');
    const reduceSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let min = aVals[offset];
        let minIndex = 0;
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (value < min) {
                min = value;
                minIndex = j;
            }
        }
        vals[i] = minIndex;
    }
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return backend.makeTensorInfo(outShape, 'int32', vals);
}
const $c086b6254f644a2e$export$21836a5e5fa09eb4 = {
    kernelName: (0, $dCP8m.ArgMin),
    backendName: 'cpu',
    kernelFunc: $c086b6254f644a2e$export$ec99a91cddfb29a2
};

});

parcelRegister("iTuSy", function(module, exports) {

$parcel$export(module.exports, "asinConfig", () => $dc1550fb14f6aa6d$export$de5cb0ef95dd6700);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $dc1550fb14f6aa6d$export$41726bdb1fc63f = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Asin), (xi)=>Math.asin(xi));
const $dc1550fb14f6aa6d$export$de5cb0ef95dd6700 = {
    kernelName: (0, $dCP8m.Asin),
    backendName: 'cpu',
    kernelFunc: $dc1550fb14f6aa6d$export$41726bdb1fc63f
};

});

parcelRegister("jW55p", function(module, exports) {

$parcel$export(module.exports, "asinhConfig", () => $e8376120ec0935df$export$20d424616c76166);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $e8376120ec0935df$export$839d8a01b6af4fc0 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Asinh), (xi)=>Math.asinh(xi));
const $e8376120ec0935df$export$20d424616c76166 = {
    kernelName: (0, $dCP8m.Asinh),
    backendName: 'cpu',
    kernelFunc: $e8376120ec0935df$export$839d8a01b6af4fc0
};

});

parcelRegister("yFlGZ", function(module, exports) {

$parcel$export(module.exports, "atanConfig", () => $0683401db5ad8323$export$159d632e3ff13624);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $0683401db5ad8323$export$628dc4eed22b0fbd = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Atan), (xi)=>Math.atan(xi));
const $0683401db5ad8323$export$159d632e3ff13624 = {
    kernelName: (0, $dCP8m.Atan),
    backendName: 'cpu',
    kernelFunc: $0683401db5ad8323$export$628dc4eed22b0fbd
};

});

parcelRegister("aPhyZ", function(module, exports) {

$parcel$export(module.exports, "atan2Config", () => $7e1c4a89b4933a02$export$c53c7ab019edb8a0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $7e1c4a89b4933a02$export$2420f4f902e099a2 = (0, $aRRHO.createSimpleBinaryKernelImpl)((aValue, bValue)=>Math.atan2(aValue, bValue));
const $7e1c4a89b4933a02$export$b8b770ee6a0d9760 = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.Atan2), $7e1c4a89b4933a02$export$2420f4f902e099a2);
const $7e1c4a89b4933a02$export$c53c7ab019edb8a0 = {
    kernelName: (0, $dCP8m.Atan2),
    backendName: 'cpu',
    kernelFunc: $7e1c4a89b4933a02$export$b8b770ee6a0d9760
};

});

parcelRegister("drHj6", function(module, exports) {

$parcel$export(module.exports, "atanhConfig", () => $9c9f63dd30b37691$export$e9ce1ba75fc9b746);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $9c9f63dd30b37691$export$21ea955025ceb08b = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Atanh), (xi)=>Math.atanh(xi));
const $9c9f63dd30b37691$export$e9ce1ba75fc9b746 = {
    kernelName: (0, $dCP8m.Atanh),
    backendName: 'cpu',
    kernelFunc: $9c9f63dd30b37691$export$21ea955025ceb08b
};

});

parcelRegister("8kRhb", function(module, exports) {

$parcel$export(module.exports, "avgPoolConfig", () => $61198489ed12e653$export$6c901824a23e6150);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $8by9c = parcelRequire("8by9c");

var $6mG8q = parcelRequire("6mG8q");
function $61198489ed12e653$export$d5c65a2abd3d97dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $aPHJu.assertNotComplex)(x, 'avgPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $wx9lK).assert((0, $lkN62).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in avgPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $lkN62).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    let res;
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $wx9lK).arraysEqual(convInfo.inShape, convInfo.outShape)) res = (0, $6mG8q.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else {
        const xValues = backend.data.get(x.dataId).values;
        const strides = (0, $wx9lK).computeStrides(x.shape);
        const buffer = (0, $8by9c.pool)(xValues, x.shape, x.dtype, strides, convInfo, 'avg');
        res = backend.makeTensorInfo(convInfo.outShape, x.dtype, buffer.values);
    }
    return res;
}
const $61198489ed12e653$export$6c901824a23e6150 = {
    kernelName: (0, $dCP8m.AvgPool),
    backendName: 'cpu',
    kernelFunc: $61198489ed12e653$export$d5c65a2abd3d97dc
};

});
parcelRegister("8by9c", function(module, exports) {

$parcel$export(module.exports, "pool", () => $5f59d6c1a4cef0cd$export$7a0e2789ec54f0db);
$parcel$export(module.exports, "maxPoolPositions", () => $5f59d6c1a4cef0cd$export$60b78444d0fe518d);
$parcel$export(module.exports, "pool3d", () => $5f59d6c1a4cef0cd$export$3712ebf21d29ff82);
$parcel$export(module.exports, "maxPool3dPositions", () => $5f59d6c1a4cef0cd$export$e389a84eda2bb69e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $g81BN = parcelRequire("g81BN");
function $5f59d6c1a4cef0cd$export$7a0e2789ec54f0db(xValues, xShape, dtype, strides, convInfo, poolType) {
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const initialValue = poolType === 'max' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    const output = (0, $g81BN.buffer)(convInfo.outShape, dtype);
    const outputVals = output.values;
    const outputBatchStrides = convInfo.outShape[1] * convInfo.outShape[2] * convInfo.outShape[3];
    const outputRowStrides = convInfo.outShape[2] * convInfo.outShape[3];
    const outputColStrides = convInfo.outShape[3];
    for(let b = 0; b < convInfo.batchSize; ++b){
        const outputBatchOffset = b * outputBatchStrides;
        const inputBatchOffset = b * strides[0];
        for(let d = 0; d < convInfo.inChannels; ++d)for(let yR = 0; yR < convInfo.outHeight; ++yR){
            const xRCorner = yR * strideHeight - padTop;
            const xRMin = Math.max(0, xRCorner);
            const xRMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRCorner);
            const outputRowOffset = outputBatchOffset + yR * outputRowStrides;
            for(let yC = 0; yC < convInfo.outWidth; ++yC){
                const xCCorner = yC * strideWidth - padLeft;
                const xCMin = Math.max(0, xCCorner);
                const xCMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xCCorner);
                let minMaxValue = initialValue;
                let avgValue = 0;
                let count = 0;
                for(let xR = xRMin; xR < xRMax; xR += dilationHeight){
                    const xROffset = inputBatchOffset + xR * strides[1];
                    for(let xC = xCMin; xC < xCMax; xC += dilationWidth){
                        const xCOffset = xROffset + xC * strides[2];
                        const pixel = xValues[xCOffset + d];
                        if (poolType === 'max' && pixel > minMaxValue) minMaxValue = pixel;
                        else if (poolType === 'avg') {
                            avgValue += pixel;
                            count++;
                        }
                    }
                    if (isNaN(minMaxValue)) break;
                }
                const outputOffset = outputRowOffset + yC * outputColStrides + d;
                outputVals[outputOffset] = poolType === 'avg' ? avgValue / count : minMaxValue;
            }
        }
    }
    return output;
}
function $5f59d6c1a4cef0cd$export$60b78444d0fe518d(xValues, xShape, dtype, convInfo, flattenPositions = false, includeBatchInIndex = false) {
    const maxPositions = (0, $g81BN.buffer)(convInfo.outShape, 'int32');
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const xBuf = (0, $g81BN.buffer)(xShape, dtype, xValues);
    for(let b = 0; b < convInfo.batchSize; ++b){
        for(let d = 0; d < convInfo.inChannels; ++d)for(let yR = 0; yR < convInfo.outHeight; ++yR){
            const xRCorner = yR * strideHeight - padTop;
            let xRMin = xRCorner;
            while(xRMin < 0)xRMin += dilationHeight;
            // const xRMin = Math.max(0, xRCorner);
            const xRMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRCorner);
            for(let yC = 0; yC < convInfo.outWidth; ++yC){
                const xCCorner = yC * strideWidth - padLeft;
                let xCMin = xCCorner;
                while(xCMin < 0)xCMin += dilationWidth;
                const xCMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xCCorner);
                let maxValue = Number.NEGATIVE_INFINITY;
                let maxPosition = -1;
                for(let xR = xRMin; xR < xRMax; xR += dilationHeight){
                    const wR = xR - xRCorner;
                    for(let xC = xCMin; xC < xCMax; xC += dilationWidth){
                        const wC = xC - xCCorner;
                        const pixel = xBuf.get(b, xR, xC, d);
                        if (pixel > maxValue) {
                            maxValue = pixel;
                            if (flattenPositions) maxPosition = includeBatchInIndex ? ((b * convInfo.inHeight + xR) * convInfo.inWidth + xC) * convInfo.inChannels + d : (xR * convInfo.inWidth + xC) * convInfo.inChannels + d;
                            else maxPosition = wR * effectiveFilterWidth + wC;
                        }
                    }
                }
                maxPositions.set(maxPosition, b, yR, yC, d);
            }
        }
    }
    return maxPositions;
}
function $5f59d6c1a4cef0cd$export$3712ebf21d29ff82(xValues, xShape, dtype, strides, convInfo, poolType) {
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = convInfo.padInfo.front;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const initialValue = poolType === 'max' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    const output = (0, $g81BN.buffer)(convInfo.outShape, dtype);
    const outputVals = output.values;
    const outputBatchStrides = convInfo.outShape[1] * convInfo.outShape[2] * convInfo.outShape[3] * convInfo.outShape[4];
    const outputDepthStrides = convInfo.outShape[2] * convInfo.outShape[3] * convInfo.outShape[4];
    const outputRowStrides = convInfo.outShape[3] * convInfo.outShape[4];
    const outputColStrides = convInfo.outShape[4];
    for(let batch = 0; batch < convInfo.batchSize; ++batch){
        const outputBatchOffset = batch * outputBatchStrides;
        const inputBatchOffset = batch * strides[0];
        for(let channel = 0; channel < convInfo.inChannels; ++channel)for(let yDepth = 0; yDepth < convInfo.outDepth; ++yDepth){
            const xDepthCorner = yDepth * strideDepth - padFront;
            let xDepthMin = xDepthCorner;
            while(xDepthMin < 0)xDepthMin += dilationDepth;
            const xDepthMax = Math.min(convInfo.inDepth, effectiveFilterDepth + xDepthCorner);
            const outputDepthOffset = outputBatchOffset + yDepth * outputDepthStrides;
            for(let yRow = 0; yRow < convInfo.outHeight; ++yRow){
                const xRowCorner = yRow * strideHeight - padTop;
                let xRowMin = xRowCorner;
                while(xRowMin < 0)xRowMin += dilationHeight;
                const xRowMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRowCorner);
                const outputRowOffset = outputDepthOffset + yRow * outputRowStrides;
                for(let yCol = 0; yCol < convInfo.outWidth; ++yCol){
                    const xColCorner = yCol * strideWidth - padLeft;
                    let xColMin = xColCorner;
                    while(xColMin < 0)xColMin += dilationWidth;
                    const xColMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xColCorner);
                    // Shader code begins
                    const outputColOffset = outputRowOffset + yCol * outputColStrides;
                    let minMaxValue = initialValue;
                    let avgValue = 0;
                    let count = 0;
                    for(let xDepth = xDepthMin; xDepth < xDepthMax; xDepth += dilationDepth){
                        const xDepthOffset = inputBatchOffset + xDepth * strides[1];
                        for(let xRow = xRowMin; xRow < xRowMax; xRow += dilationHeight){
                            const xRowOffset = xDepthOffset + xRow * strides[2];
                            for(let xCol = xColMin; xCol < xColMax; xCol += dilationWidth){
                                const xColOffset = xRowOffset + xCol * strides[3];
                                const pixel = xValues[xColOffset + channel];
                                if (poolType === 'max' && pixel > minMaxValue) minMaxValue = pixel;
                                else if (poolType === 'avg') {
                                    avgValue += pixel;
                                    count++;
                                }
                                if (isNaN(minMaxValue)) break;
                            }
                            if (isNaN(minMaxValue)) break;
                        }
                        if (isNaN(minMaxValue)) break;
                    }
                    const outputOffset = outputColOffset + channel;
                    outputVals[outputOffset] = poolType === 'avg' ? avgValue / count : minMaxValue;
                }
            }
        }
    }
    return output;
}
function $5f59d6c1a4cef0cd$export$e389a84eda2bb69e(xBuf, convInfo) {
    const maxPositions = (0, $g81BN.buffer)(convInfo.outShape, 'int32');
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = convInfo.padInfo.front;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    for(let batch = 0; batch < convInfo.batchSize; ++batch){
        for(let channel = 0; channel < convInfo.inChannels; ++channel)for(let yDepth = 0; yDepth < convInfo.outDepth; ++yDepth){
            const xDepthCorner = yDepth * strideDepth - padFront;
            let xDepthMin = xDepthCorner;
            while(xDepthMin < 0)xDepthMin += dilationDepth;
            const xDepthMax = Math.min(convInfo.inDepth, effectiveFilterDepth + xDepthCorner);
            for(let yRow = 0; yRow < convInfo.outHeight; ++yRow){
                const xRowCorner = yRow * strideHeight - padTop;
                let xRowMin = xRowCorner;
                while(xRowMin < 0)xRowMin += dilationHeight;
                const xRowMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRowCorner);
                for(let yCol = 0; yCol < convInfo.outWidth; ++yCol){
                    const xColCorner = yCol * strideWidth - padLeft;
                    let xColMin = xColCorner;
                    while(xColMin < 0)xColMin += dilationWidth;
                    const xColMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xColCorner);
                    // Shader code begins
                    let maxValue = Number.NEGATIVE_INFINITY;
                    let maxPosition = -1;
                    for(let xDepth = xDepthMin; xDepth < xDepthMax; xDepth += dilationDepth){
                        const wDepth = xDepth - xDepthCorner;
                        for(let xRow = xRowMin; xRow < xRowMax; xRow += dilationHeight){
                            const wRow = xRow - xRowCorner;
                            for(let xCol = xColMin; xCol < xColMax; xCol += dilationWidth){
                                const wCol = xCol - xColCorner;
                                const pixel = xBuf.get(batch, xDepth, xRow, xCol, channel);
                                if (pixel >= maxValue) {
                                    maxValue = pixel;
                                    maxPosition = wDepth * effectiveFilterHeight * effectiveFilterWidth + wRow * effectiveFilterHeight + wCol;
                                }
                            }
                        }
                    }
                    maxPositions.set(maxPosition, batch, yDepth, yRow, yCol, channel);
                }
            }
        }
    }
    return maxPositions;
}

});


parcelRegister("1daUE", function(module, exports) {

$parcel$export(module.exports, "avgPool3DConfig", () => $0e1f7864a8f0f960$export$5a9c81d240244392);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $8by9c = parcelRequire("8by9c");
function $0e1f7864a8f0f960$export$8e92f7d23b27f144(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode, dataFormat: dataFormat } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'avgPool3d');
    const convInfo = (0, $lkN62).computePool3DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode, dataFormat);
    const xValues = backend.data.get(x.dataId).values;
    const outBuf = (0, $8by9c.pool3d)(xValues, x.shape, x.dtype, (0, $wx9lK).computeStrides(x.shape), convInfo, 'avg');
    return backend.makeTensorInfo(outBuf.shape, 'float32', outBuf.values);
}
const $0e1f7864a8f0f960$export$5a9c81d240244392 = {
    kernelName: (0, $dCP8m.AvgPool3D),
    backendName: 'cpu',
    kernelFunc: $0e1f7864a8f0f960$export$8e92f7d23b27f144
};

});

parcelRegister("8Cdlq", function(module, exports) {

$parcel$export(module.exports, "avgPool3DGradConfig", () => $645c394a8aac1259$export$1eeb8780807d0508);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $g81BN = parcelRequire("g81BN");

var $aPHJu = parcelRequire("aPHJu");
function $645c394a8aac1259$export$798cb4034e996ff4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $aPHJu.assertNotComplex)([
        dy,
        input
    ], 'avgPool3DGrad');
    const convInfo = (0, $lkN62).computePool3DInfo(input.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const filterDepth = convInfo.filterDepth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const dx = (0, $g81BN.buffer)(input.shape, 'float32');
    const avgMultiplier = 1 / (filterDepth * filterHeight * filterWidth);
    const dyBuf = backend.bufferSync(dy);
    for(let batch = 0; batch < convInfo.batchSize; ++batch){
        for(let channel = 0; channel < convInfo.inChannels; ++channel)for(let dxDepth = 0; dxDepth < convInfo.inDepth; ++dxDepth){
            for(let dxRow = 0; dxRow < convInfo.inHeight; ++dxRow)for(let dxCol = 0; dxCol < convInfo.inWidth; ++dxCol){
                // Shader code begins.
                const dyDepthCorner = dxDepth - padFront;
                const dyRowCorner = dxRow - padTop;
                const dyColCorner = dxCol - padLeft;
                let dotProd = 0;
                for(let wDepth = 0; wDepth < effectiveFilterDepth; wDepth += dilationDepth){
                    const dyDepth = (dyDepthCorner + wDepth) / strideDepth;
                    if (dyDepth < 0 || dyDepth >= convInfo.outDepth || Math.floor(dyDepth) !== dyDepth) continue;
                    for(let wRow = 0; wRow < effectiveFilterHeight; wRow += dilationHeight){
                        const dyRow = (dyRowCorner + wRow) / strideHeight;
                        if (dyRow < 0 || dyRow >= convInfo.outHeight || Math.floor(dyRow) !== dyRow) continue;
                        for(let wCol = 0; wCol < effectiveFilterWidth; wCol += dilationWidth){
                            const dyCol = (dyColCorner + wCol) / strideWidth;
                            if (dyCol < 0 || dyCol >= convInfo.outWidth || Math.floor(dyCol) !== dyCol) continue;
                            const pixel = dyBuf.get(batch, dyDepth, dyRow, dyCol, channel);
                            dotProd += pixel;
                        }
                    }
                }
                dx.set(dotProd * avgMultiplier, batch, dxDepth, dxRow, dxCol, channel);
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $645c394a8aac1259$export$1eeb8780807d0508 = {
    kernelName: (0, $dCP8m.AvgPool3DGrad),
    backendName: 'cpu',
    kernelFunc: $645c394a8aac1259$export$798cb4034e996ff4
};

});

parcelRegister("j0uZZ", function(module, exports) {

$parcel$export(module.exports, "avgPoolGradConfig", () => $dd66101e44d089ab$export$ac3f8709351ab225);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $g81BN = parcelRequire("g81BN");

var $aPHJu = parcelRequire("aPHJu");
function $dd66101e44d089ab$export$2f098171d1c79aea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    (0, $aPHJu.assertNotComplex)([
        dy,
        input
    ], 'avgPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
    const convInfo = (0, $lkN62).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad);
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const dx = (0, $g81BN.buffer)(x.shape, 'float32');
    const avgMultiplier = 1 / (filterHeight * filterWidth);
    const dyData = backend.data.get(dy.dataId).values;
    const dyBuf = (0, $g81BN.buffer)(dy.shape, 'float32', dyData);
    for(let b = 0; b < convInfo.batchSize; ++b)for(let d = 0; d < convInfo.inChannels; ++d){
        for(let dxR = 0; dxR < convInfo.inHeight; ++dxR)for(let dxC = 0; dxC < convInfo.inWidth; ++dxC){
            // Shader code begins.
            const dyRCorner = dxR - padTop;
            const dyCCorner = dxC - padLeft;
            let dotProd = 0;
            for(let wR = 0; wR < effectiveFilterHeight; wR += dilationHeight){
                const dyR = (dyRCorner + wR) / strideHeight;
                if (dyR < 0 || dyR >= convInfo.outHeight || Math.floor(dyR) !== dyR) continue;
                for(let wC = 0; wC < effectiveFilterWidth; wC += dilationWidth){
                    const dyC = (dyCCorner + wC) / strideWidth;
                    if (dyC < 0 || dyC >= convInfo.outWidth || Math.floor(dyC) !== dyC) continue;
                    const pixel = dyBuf.get(b, dyR, dyC, d);
                    dotProd += pixel;
                }
            }
            dx.set(dotProd * avgMultiplier, b, dxR, dxC, d);
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $dd66101e44d089ab$export$ac3f8709351ab225 = {
    kernelName: (0, $dCP8m.AvgPoolGrad),
    backendName: 'cpu',
    kernelFunc: $dd66101e44d089ab$export$2f098171d1c79aea
};

});

parcelRegister("5GKaj", function(module, exports) {

$parcel$export(module.exports, "batchNormConfig", () => $4244af7a2fd66afe$export$df2dc5c7a755e418);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $4244af7a2fd66afe$export$8ea8088e6d0cdd02(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, scale: scale, offset: offset, mean: mean, variance: variance } = inputs;
    (0, $wx9lK).assert(mean.shape.length === variance.shape.length, ()=>"Batch normalization gradient requires mean and variance to have equal ranks.");
    (0, $wx9lK).assert(offset == null || mean.shape.length === offset.shape.length, ()=>"Batch normalization gradient requires mean and offset to have equal ranks.");
    (0, $wx9lK).assert(scale == null || mean.shape.length === scale.shape.length, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    (0, $aPHJu.assertNotComplex)([
        x,
        mean,
        variance,
        scale,
        offset
    ], 'batchNorm');
    let { varianceEpsilon: varianceEpsilon } = attrs;
    if (varianceEpsilon == null) varianceEpsilon = 0.001;
    const xVals = backend.data.get(x.dataId).values;
    const mVals = backend.data.get(mean.dataId).values;
    const varVals = backend.data.get(variance.dataId).values;
    const sVals = scale ? backend.data.get(scale.dataId).values : new Float32Array([
        1
    ]);
    const offVals = offset ? backend.data.get(offset.dataId).values : new Float32Array([
        0
    ]);
    const outVals = new Float32Array(xVals.length);
    const offValsLength = offVals.length;
    const sValsLength = sVals.length;
    const varValsLength = varVals.length;
    const mValsLength = mVals.length;
    let offi = 0;
    let mi = 0;
    let si = 0;
    let vi = 0;
    for(let i = 0; i < xVals.length; ++i){
        outVals[i] = offVals[offi++] + (xVals[i] - mVals[mi++]) * sVals[si++] / Math.sqrt(varVals[vi++] + varianceEpsilon);
        if (offi >= offValsLength) offi = 0;
        if (mi >= mValsLength) mi = 0;
        if (si >= sValsLength) si = 0;
        if (vi >= varValsLength) vi = 0;
    }
    return backend.makeTensorInfo(x.shape, x.dtype, outVals);
}
const $4244af7a2fd66afe$export$df2dc5c7a755e418 = {
    kernelName: (0, $dCP8m.FusedBatchNorm),
    backendName: 'cpu',
    kernelFunc: $4244af7a2fd66afe$export$8ea8088e6d0cdd02
};

});

parcelRegister("fErkc", function(module, exports) {

$parcel$export(module.exports, "batchToSpaceNDConfig", () => $b64fc98d556a8cb6$export$44e08e19f97e5513);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");

var $3qzJ7 = parcelRequire("3qzJ7");

var $fyKXa = parcelRequire("fyKXa");

var $9buNR = parcelRequire("9buNR");
function $b64fc98d556a8cb6$export$ea37d960c1808536(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, crops: crops } = attrs;
    (0, $aPHJu.assertNotComplex)([
        x
    ], 'batchToSpaceND');
    const prod = blockShape.reduce((a, b)=>a * b);
    const reshaped = (0, $lkN62).getReshaped(x.shape, blockShape, prod);
    const permuted = (0, $lkN62).getPermuted(reshaped.length, blockShape.length);
    const reshapedPermuted = (0, $lkN62).getReshapedPermuted(x.shape, blockShape, prod);
    const sliceBeginCoords = (0, $lkN62).getSliceBeginCoords(crops, blockShape.length);
    const sliceSize = (0, $lkN62).getSliceSize(reshapedPermuted, crops, blockShape.length);
    const xReshaped = (0, $3qzJ7.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: reshaped
        }
    });
    const xTransposed = (0, $9buNR.transpose)({
        inputs: {
            x: xReshaped
        },
        backend: backend,
        attrs: {
            perm: permuted
        }
    });
    const xTransposedReshaped = (0, $3qzJ7.reshape)({
        inputs: {
            x: xTransposed
        },
        backend: backend,
        attrs: {
            shape: reshapedPermuted
        }
    });
    const result = (0, $fyKXa.slice)({
        inputs: {
            x: xTransposedReshaped
        },
        backend: backend,
        attrs: {
            begin: sliceBeginCoords,
            size: sliceSize
        }
    });
    backend.disposeIntermediateTensorInfo(xReshaped);
    backend.disposeIntermediateTensorInfo(xTransposed);
    backend.disposeIntermediateTensorInfo(xTransposedReshaped);
    return result;
}
const $b64fc98d556a8cb6$export$44e08e19f97e5513 = {
    kernelName: (0, $dCP8m.BatchToSpaceND),
    backendName: 'cpu',
    kernelFunc: $b64fc98d556a8cb6$export$ea37d960c1808536
};

});
parcelRegister("fyKXa", function(module, exports) {

$parcel$export(module.exports, "sliceImpl", () => $b53e73f2886adab4$export$4bdf1ac3fa5d3d6a);
$parcel$export(module.exports, "slice", () => $b53e73f2886adab4$export$58adb3bec8346d0f);
$parcel$export(module.exports, "sliceConfig", () => $b53e73f2886adab4$export$8d8a1e11dd2cc6c4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $g81BN = parcelRequire("g81BN");
var $dCP8m = parcelRequire("dCP8m");
var $1KPDG = parcelRequire("1KPDG");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $b53e73f2886adab4$export$4bdf1ac3fa5d3d6a(vals, begin, size, shape, dtype) {
    const isContinous = (0, $1KPDG).isSliceContinous(shape, begin, size);
    const length = (0, $wx9lK).sizeFromShape(size);
    const xStrides = (0, $wx9lK).computeStrides(shape);
    if (isContinous) {
        const flatOffset = (0, $1KPDG).computeFlatOffset(begin, xStrides);
        if (dtype === 'string') return vals.slice(flatOffset, flatOffset + length);
        return vals.subarray(flatOffset, flatOffset + length);
    }
    const decodedData = dtype === 'string' ? (0, $lkN62).fromUint8ToStringArray(vals) : vals;
    const inBuf = (0, $g81BN.buffer)(shape, dtype, decodedData);
    const outBuf = (0, $g81BN.buffer)(size, dtype);
    for(let i = 0; i < outBuf.size; ++i){
        const outLoc = outBuf.indexToLoc(i);
        const inLoc = outLoc.map((idx, j)=>idx + begin[j]);
        outBuf.set(inBuf.get(...inLoc), ...outLoc);
    }
    if (dtype === 'string') return (0, $lkN62).fromStringArrayToUint8(outBuf.values);
    return outBuf.values;
}
function $b53e73f2886adab4$export$58adb3bec8346d0f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, size: size } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'slice');
    const [$begin, $size] = (0, $1KPDG).parseSliceParams(x, begin, size);
    (0, $1KPDG).assertParamsValid(x, $begin, $size);
    const vals = backend.data.get(x.dataId).values;
    const outVals = $b53e73f2886adab4$export$4bdf1ac3fa5d3d6a(vals, $begin, $size, x.shape, x.dtype);
    return backend.makeTensorInfo($size, x.dtype, outVals);
}
const $b53e73f2886adab4$export$8d8a1e11dd2cc6c4 = {
    kernelName: (0, $dCP8m.Slice),
    backendName: 'cpu',
    kernelFunc: $b53e73f2886adab4$export$58adb3bec8346d0f
};

});


parcelRegister("alm5B", function(module, exports) {

$parcel$export(module.exports, "bincountConfig", () => $787d000ac5107b58$export$af9f0093738840fb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $gKVCB = parcelRequire("gKVCB");
function $787d000ac5107b58$export$7e474bab088ed182(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size } = attrs;
    const xVals = backend.data.get(x.dataId).values;
    const weightsVals = backend.data.get(weights.dataId).values;
    const outVals = (0, $gKVCB.bincountImpl)(xVals, weightsVals, weights.dtype, weights.shape, size);
    return backend.makeTensorInfo([
        size
    ], weights.dtype, outVals);
}
const $787d000ac5107b58$export$af9f0093738840fb = {
    kernelName: (0, $dCP8m.Bincount),
    backendName: 'cpu',
    kernelFunc: $787d000ac5107b58$export$7e474bab088ed182
};

});
parcelRegister("gKVCB", function(module, exports) {

$parcel$export(module.exports, "bincountImpl", () => $c32da3a895e8e1f8$export$8e4da6ec633bf0a6);
$parcel$export(module.exports, "bincountReduceImpl", () => $c32da3a895e8e1f8$export$486b8d48edd28ba5);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $g81BN = parcelRequire("g81BN");
var $wx9lK = parcelRequire("wx9lK");
function $c32da3a895e8e1f8$export$8e4da6ec633bf0a6(xVals, weightsVals, weightsDtype, weightsShape, size) {
    const weightsSize = (0, $wx9lK).sizeFromShape(weightsShape);
    const outVals = (0, $wx9lK).makeZerosTypedArray(size, weightsDtype);
    for(let i = 0; i < xVals.length; i++){
        const value = xVals[i];
        if (value < 0) throw new Error('Input x must be non-negative!');
        if (value >= size) continue;
        if (weightsSize > 0) outVals[value] += weightsVals[i];
        else outVals[value] += 1;
    }
    return outVals;
}
function $c32da3a895e8e1f8$export$486b8d48edd28ba5(xBuf, weightsBuf, size, binaryOutput = false) {
    const numRows = xBuf.shape[0];
    const numCols = xBuf.shape[1];
    const outBuf = (0, $g81BN.buffer)([
        numRows,
        size
    ], weightsBuf.dtype);
    for(let i = 0; i < numRows; i++)for(let j = 0; j < numCols; j++){
        const value = xBuf.get(i, j);
        if (value < 0) throw new Error('Input x must be non-negative!');
        if (value >= size) continue;
        if (binaryOutput) outBuf.set(1, i, value);
        else if (weightsBuf.size > 0) outBuf.set(outBuf.get(i, value) + weightsBuf.get(i, j), i, value);
        else outBuf.set(outBuf.get(i, value) + 1, i, value);
    }
    return outBuf;
}

});


parcelRegister("DqinA", function(module, exports) {

$parcel$export(module.exports, "broadcastArgsConfig", () => $07680a5c1c1f9f0e$export$8f7b2ec0c6f08fb2);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
function $07680a5c1c1f9f0e$export$d226d344aedce941(args) {
    const { inputs: inputs, backend: backend } = args;
    const { s0: s0, s1: s1 } = inputs;
    const s0Vals = backend.data.get(s0.dataId).values;
    const s1Vals = backend.data.get(s1.dataId).values;
    const broadcastShape = (0, $lkN62).assertAndGetBroadcastShape(Array.from(s0Vals), Array.from(s1Vals));
    return backend.makeTensorInfo([
        broadcastShape.length
    ], 'int32', Int32Array.from(broadcastShape));
}
const $07680a5c1c1f9f0e$export$8f7b2ec0c6f08fb2 = {
    kernelName: (0, $dCP8m.BroadcastArgs),
    backendName: 'cpu',
    kernelFunc: $07680a5c1c1f9f0e$export$d226d344aedce941
};

});

parcelRegister("aKVzR", function(module, exports) {

$parcel$export(module.exports, "ceilImpl", () => $7d4adced804cb0c5$export$72486f20c97f6da8);
$parcel$export(module.exports, "ceilConfig", () => $7d4adced804cb0c5$export$df387212b1898306);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $021b6 = parcelRequire("021b6");

var $lfZyz = parcelRequire("lfZyz");
const $7d4adced804cb0c5$export$72486f20c97f6da8 = (0, $021b6.createSimpleUnaryImpl)((xi)=>Math.ceil(xi));
const $7d4adced804cb0c5$export$803ce6b71a0a94b2 = (0, $lfZyz.unaryKernelFuncFromImpl)((0, $dCP8m.Ceil), $7d4adced804cb0c5$export$72486f20c97f6da8);
const $7d4adced804cb0c5$export$df387212b1898306 = {
    kernelName: (0, $dCP8m.Ceil),
    backendName: 'cpu',
    kernelFunc: $7d4adced804cb0c5$export$803ce6b71a0a94b2
};

});

parcelRegister("gMhpT", function(module, exports) {

$parcel$export(module.exports, "clipByValueConfig", () => $c36ea39c20f1ab57$export$f7ee8f07ce0ff4e1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $c36ea39c20f1ab57$export$fa97baf70ad024c0 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.ClipByValue), (xi, attrs)=>{
    const clipAttrs = attrs;
    if (xi > clipAttrs.clipValueMax) return clipAttrs.clipValueMax;
    return xi < clipAttrs.clipValueMin ? clipAttrs.clipValueMin : xi;
});
const $c36ea39c20f1ab57$export$f7ee8f07ce0ff4e1 = {
    kernelName: (0, $dCP8m.ClipByValue),
    backendName: 'cpu',
    kernelFunc: $c36ea39c20f1ab57$export$fa97baf70ad024c0
};

});

parcelRegister("ktPhX", function(module, exports) {

$parcel$export(module.exports, "complexAbsConfig", () => $ee8e4ceab4aa6b9c$export$a4817d2978acc054);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
const $ee8e4ceab4aa6b9c$export$2837bc62566f8808 = (args)=>{
    const { x: x } = args.inputs;
    const cpuBackend = args.backend;
    const resultValues = new Float32Array((0, $wx9lK).sizeFromShape(x.shape));
    const complexVals = cpuBackend.data.get(x.dataId);
    const real = complexVals.complexTensorInfos.real;
    const imag = complexVals.complexTensorInfos.imag;
    const realVals = cpuBackend.data.get(real.dataId).values;
    const imagVals = cpuBackend.data.get(imag.dataId).values;
    for(let i = 0; i < realVals.length; i++){
        const real = realVals[i];
        const imag = imagVals[i];
        resultValues[i] = Math.hypot(real, imag);
    }
    return cpuBackend.makeOutput(resultValues, x.shape, 'float32');
};
const $ee8e4ceab4aa6b9c$export$a4817d2978acc054 = {
    kernelName: (0, $dCP8m.ComplexAbs),
    backendName: 'cpu',
    kernelFunc: $ee8e4ceab4aa6b9c$export$2837bc62566f8808
};

});

parcelRegister("kFVXg", function(module, exports) {

$parcel$export(module.exports, "concat", () => $f0d4979a1168075b$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "concatConfig", () => $f0d4979a1168075b$export$c8cf96dae25282e5);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $78AN7 = parcelRequire("78AN7");

var $ku4Up = parcelRequire("ku4Up");

var $6mG8q = parcelRequire("6mG8q");

var $cG2uv = parcelRequire("cG2uv");

var $9B72G = parcelRequire("9B72G");

var $3qzJ7 = parcelRequire("3qzJ7");
function $f0d4979a1168075b$export$ee1b3e54f0441b22(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    const $axis = (0, $wx9lK).parseAxisParam(axis, inputs[0].shape)[0];
    const shapes = inputs.map((t)=>t.shape);
    (0, $lkN62).assertParamsConsistent(shapes, $axis);
    let outShape = (0, $lkN62).computeOutShape(inputs.map((t)=>t.shape), $axis);
    if ((0, $wx9lK).sizeFromShape(outShape) === 0) return backend.makeTensorInfo(outShape, inputs[0].dtype, []);
    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
    const $inputs = inputs.filter((t)=>(0, $wx9lK).sizeFromShape(t.shape) > 0);
    if ($inputs.length === 1) return (0, $6mG8q.identity)({
        inputs: {
            x: $inputs[0]
        },
        backend: backend
    });
    if ($inputs[0].dtype === 'complex64') {
        const reals = $inputs.map((t)=>(0, $9B72G.real)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const imags = $inputs.map((t)=>(0, $cG2uv.imag)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const realConcated = $f0d4979a1168075b$export$ee1b3e54f0441b22({
            inputs: reals,
            backend: backend,
            attrs: {
                axis: $axis
            }
        });
        const imagConcated = $f0d4979a1168075b$export$ee1b3e54f0441b22({
            inputs: imags,
            backend: backend,
            attrs: {
                axis: $axis
            }
        });
        const result = (0, $78AN7.complex)({
            inputs: {
                real: realConcated,
                imag: imagConcated
            },
            backend: backend
        });
        reals.forEach((r)=>backend.disposeIntermediateTensorInfo(r));
        imags.forEach((i)=>backend.disposeIntermediateTensorInfo(i));
        backend.disposeIntermediateTensorInfo(realConcated);
        backend.disposeIntermediateTensorInfo(imagConcated);
        return result;
    }
    // Any concat of n-dimensional tensors across any axis can be reduced to
    // a concatenation of two-dimensional tensors across the axis 1 by first
    // partitioning the axes of the original tensors into those less than the
    // axis to be concatenated and the rest. Then reshape the tensors
    // into a two-dimensional tensor by collapsing these two sets of axes and
    // concatenate the resulting matrices across the axis 1, finally reshaping
    // the result to have the proper shape.
    const inputs2D = $inputs.map((t)=>{
        const innerSize = (0, $wx9lK).sizeFromShape(t.shape.slice($axis));
        const shape = [
            -1,
            innerSize
        ];
        return (0, $3qzJ7.reshape)({
            inputs: {
                x: t
            },
            backend: backend,
            attrs: {
                shape: shape
            }
        });
    });
    const inputsValShapes = inputs2D.map((t)=>{
        return {
            vals: backend.data.get(t.dataId).values,
            shape: t.shape
        };
    });
    // Concats 2d tensors along axis=1.
    outShape = (0, $lkN62).computeOutShape(inputs2D.map((t)=>t.shape), 1 /* axis */ );
    const simplyConcat = inputs2D[0].shape[0] === 1;
    const outVals = (0, $ku4Up.concatImpl)(inputsValShapes, outShape, inputs[0].dtype, simplyConcat);
    const finalOutShape = (0, $lkN62).computeOutShape($inputs.map((t)=>t.shape), $axis);
    const outInfo = backend.makeTensorInfo(finalOutShape, inputs[0].dtype, outVals);
    inputs2D.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return outInfo;
}
const $f0d4979a1168075b$export$c8cf96dae25282e5 = {
    kernelName: (0, $dCP8m.Concat),
    backendName: 'cpu',
    kernelFunc: $f0d4979a1168075b$export$ee1b3e54f0441b22
};

});
parcelRegister("ku4Up", function(module, exports) {

$parcel$export(module.exports, "concatImpl", () => $ee9a6ac8eac8e4bc$export$777da59f594f497d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");
function $ee9a6ac8eac8e4bc$export$777da59f594f497d(inputs, outShape, dtype, simplyConcat) {
    const outVals = (0, $wx9lK).getArrayFromDType(dtype, (0, $wx9lK).sizeFromShape(outShape));
    if (simplyConcat && dtype !== 'string') {
        // Use built-in TypedArray.set() method for speed.
        let offset = 0;
        inputs.forEach((input)=>{
            const size = (0, $wx9lK).sizeFromShape(input.shape);
            outVals.set(input.vals, offset);
            offset += size;
        });
    } else {
        let colOffset = 0;
        inputs.forEach((input)=>{
            const decodedData = dtype === 'string' ? (0, $lkN62).fromUint8ToStringArray(input.vals) : input.vals;
            let tIdx = 0;
            for(let row = 0; row < input.shape[0]; ++row){
                const resIdx = row * outShape[1] + colOffset;
                for(let col = 0; col < input.shape[1]; ++col)outVals[resIdx + col] = decodedData[tIdx++];
            }
            colOffset += input.shape[1];
        });
    }
    return outVals;
}

});

parcelRegister("cG2uv", function(module, exports) {

$parcel$export(module.exports, "imag", () => $93ab56f568cf8ab6$export$d78fab5778ab392b);
$parcel$export(module.exports, "imagConfig", () => $93ab56f568cf8ab6$export$ddfc128c2801add7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
function $93ab56f568cf8ab6$export$d78fab5778ab392b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const imag = backend.data.get(input.dataId).complexTensorInfos.imag;
    const imagVal = backend.data.get(imag.dataId).values;
    // When complex tensor is disposed, its underlying parts will be disposed too.
    // Make new tensor out of the imag value of the complex. This makes sure the
    // value is still accessible even if complex tensor is disposed.
    return backend.makeTensorInfo(imag.shape, imag.dtype, imagVal);
}
const $93ab56f568cf8ab6$export$ddfc128c2801add7 = {
    kernelName: (0, $dCP8m.Imag),
    backendName: 'cpu',
    kernelFunc: $93ab56f568cf8ab6$export$d78fab5778ab392b
};

});


parcelRegister("6dsRw", function(module, exports) {

$parcel$export(module.exports, "conv2D", () => $486a586753733135$export$5a2ce5b05041d9e4);
$parcel$export(module.exports, "conv2DConfig", () => $486a586753733135$export$4a39bf13b4378042);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bVnU9 = parcelRequire("bVnU9");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $486a586753733135$export$5a2ce5b05041d9e4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $aPHJu.assertNotComplex)([
        x,
        filter
    ], 'conv2d');
    const $dataFormat = (0, $lkN62).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $lkN62).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const padLeft = convInfo.padInfo.left;
    const padTop = convInfo.padInfo.top;
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const y = new (0, $bVnU9.TensorBuffer)(convInfo.outShape, x.dtype);
    const xStrides = (0, $wx9lK).computeStrides(x.shape);
    const filterStrides = (0, $wx9lK).computeStrides(filter.shape);
    const xBatchStride = xStrides[0];
    const xRowStride = isChannelsLast ? xStrides[1] : xStrides[2];
    const xColStride = isChannelsLast ? xStrides[2] : 1;
    const xChannelStride = isChannelsLast ? 1 : xStrides[1];
    const yBatchStride = y.strides[0];
    const yRowStride = isChannelsLast ? y.strides[1] : y.strides[2];
    const yColStride = isChannelsLast ? y.strides[2] : 1;
    const yChannelStride = isChannelsLast ? 1 : y.strides[1];
    const xVals = backend.data.get(x.dataId).values;
    const wVals = backend.data.get(filter.dataId).values;
    const yVals = y.values;
    for(let b = 0; b < convInfo.batchSize; ++b){
        const xOffset1 = b * xBatchStride;
        const yOffset1 = b * yBatchStride;
        for(let yR = 0; yR < convInfo.outHeight; ++yR){
            const yOffset2 = yOffset1 + yR * yRowStride;
            const xRCorner = yR * convInfo.strideHeight - padTop;
            for(let wR = 0; wR < filterHeight; ++wR){
                const xR = xRCorner + wR * dilationHeight;
                if (xR < 0 || xR >= convInfo.inHeight) continue;
                const wOffset1 = wR * filterStrides[0];
                const xOffset2 = xOffset1 + xR * xRowStride;
                for(let yC = 0; yC < convInfo.outWidth; ++yC){
                    const yOffset3 = yOffset2 + yC * yColStride;
                    const xCCorner = yC * convInfo.strideWidth - padLeft;
                    for(let wC = 0; wC < filterWidth; ++wC){
                        const xC = xCCorner + wC * dilationWidth;
                        if (xC < 0 || xC >= convInfo.inWidth) continue;
                        const wOffset2 = wOffset1 + wC * filterStrides[1];
                        const xOffset3 = xOffset2 + xC * xColStride;
                        let wOffset3 = wOffset2;
                        for(let d1 = 0; d1 < convInfo.inChannels; ++d1){
                            const xVal = xVals[xOffset3 + d1 * xChannelStride];
                            for(let d2 = 0; d2 < convInfo.outChannels; ++d2)yVals[yOffset3 + d2 * yChannelStride] += xVal * wVals[wOffset3 + d2];
                            wOffset3 += convInfo.outChannels;
                        }
                    }
                }
            }
        }
    }
    return backend.makeTensorInfo(y.shape, y.dtype, yVals);
}
const $486a586753733135$export$4a39bf13b4378042 = {
    kernelName: (0, $dCP8m.Conv2D),
    backendName: 'cpu',
    kernelFunc: $486a586753733135$export$5a2ce5b05041d9e4
};

});

parcelRegister("gSo52", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropFilterConfig", () => $c4945e5404c69750$export$7a95f55d2d2e7d24);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bVnU9 = parcelRequire("bVnU9");

var $aPHJu = parcelRequire("aPHJu");
function $c4945e5404c69750$export$652a30c9379f3de7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    (0, $aPHJu.assertNotComplex)([
        x,
        dy
    ], 'conv2dBackpropFilter');
    const $dataFormat = (0, $lkN62).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $lkN62).computeConv2DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const { strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth } = convInfo;
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const dW = new (0, $bVnU9.TensorBuffer)(convInfo.filterShape, 'float32');
    const leftPad = convInfo.padInfo.left;
    const topPad = convInfo.padInfo.top;
    const xVals = backend.data.get(x.dataId).values;
    const dyVals = backend.data.get(dy.dataId).values;
    const xBuf = new (0, $bVnU9.TensorBuffer)(x.shape, x.dtype, xVals);
    const dyBuf = new (0, $bVnU9.TensorBuffer)(dy.shape, dy.dtype, dyVals);
    for(let wR = 0; wR < filterHeight; ++wR){
        const yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
        const yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
        for(let wC = 0; wC < filterWidth; ++wC){
            const yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
            const yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
            for(let d1 = 0; d1 < convInfo.inChannels; ++d1)for(let d2 = 0; d2 < convInfo.outChannels; ++d2){
                let dotProd = 0;
                for(let b = 0; b < convInfo.batchSize; ++b)for(let yR = yRMin; yR < yRMax; ++yR){
                    const xR = wR + yR * strideHeight - topPad;
                    for(let yC = yCMin; yC < yCMax; ++yC){
                        const xC = wC + yC * strideWidth - leftPad;
                        if (isChannelsLast) dotProd += xBuf.get(b, xR, xC, d1) * dyBuf.get(b, yR, yC, d2);
                        else dotProd += xBuf.get(b, d1, xR, xC) * dyBuf.get(b, d2, yR, yC);
                    }
                }
                dW.set(dotProd, wR, wC, d1, d2);
            }
        }
    }
    return backend.makeTensorInfo(dW.shape, dW.dtype, dW.values);
}
const $c4945e5404c69750$export$7a95f55d2d2e7d24 = {
    kernelName: (0, $dCP8m.Conv2DBackpropFilter),
    backendName: 'cpu',
    kernelFunc: $c4945e5404c69750$export$652a30c9379f3de7
};

});

parcelRegister("jmBKl", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropInputConfig", () => $e18d5a13b78d93b8$export$19bbc19fff1ed26f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bVnU9 = parcelRequire("bVnU9");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $e18d5a13b78d93b8$export$633310eed0c26e72(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { inputShape: inputShape, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $aPHJu.assertNotComplex)([
        dy,
        filter
    ], 'conv2dBackpropInput');
    const filterStrides = (0, $wx9lK).computeStrides(filter.shape);
    const dyStrides = (0, $wx9lK).computeStrides(dy.shape);
    let $dataFormat = (0, $lkN62).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $lkN62).computeConv2DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const dx = new (0, $bVnU9.TensorBuffer)(convInfo.inShape, 'float32');
    const dxValues = dx.values;
    const dyValues = backend.data.get(dy.dataId).values;
    const fltValues = backend.data.get(filter.dataId).values;
    const [fltS0, fltS1, fltS2] = filterStrides;
    const { batchSize: batchSize, filterHeight: filterHeight, filterWidth: filterWidth, inChannels: inChannels, inHeight: inHeight, inWidth: inWidth, outChannels: outChannels, outHeight: outHeight, outWidth: outWidth, strideHeight: strideHeight, strideWidth: strideWidth } = convInfo;
    $dataFormat = convInfo.dataFormat;
    const topPad = filterHeight - 1 - convInfo.padInfo.top;
    const leftPad = filterWidth - 1 - convInfo.padInfo.left;
    const isChannelsLast = $dataFormat === 'channelsLast';
    const xBatchStride = dx.strides[0];
    const xRowStride = isChannelsLast ? dx.strides[1] : dx.strides[2];
    const xColStride = isChannelsLast ? dx.strides[2] : 1;
    const xChannelStride = isChannelsLast ? 1 : dx.strides[1];
    const yBatchStride = dyStrides[0];
    const yRowStride = isChannelsLast ? dyStrides[1] : dyStrides[2];
    const yColStride = isChannelsLast ? dyStrides[2] : 1;
    const yChannelStride = isChannelsLast ? 1 : dyStrides[1];
    for(let b = 0; b < batchSize; ++b){
        for(let d1 = 0; d1 < inChannels; ++d1)for(let xR = 0; xR < inHeight; ++xR){
            const xRCorner = xR - topPad;
            const xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
            const yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
            for(let xC = 0; xC < inWidth; ++xC){
                const xCCorner = xC - leftPad;
                const xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
                const yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
                let dotProd = 0;
                for(let yR = xRMin; yR < yRMax; ++yR){
                    const wR = yR * strideHeight - xRCorner;
                    for(let yC = xCMin; yC < yCMax; ++yC){
                        const wC = yC * strideWidth - xCCorner;
                        const dyOffset = yBatchStride * b + yRowStride * yR + yColStride * yC;
                        const fltOffset = fltS0 * (filterHeight - 1 - wR) + fltS1 * (filterWidth - 1 - wC) + fltS2 * d1;
                        for(let d2 = 0; d2 < outChannels; ++d2){
                            const pixel = dyValues[dyOffset + yChannelStride * d2];
                            const weight = fltValues[fltOffset + d2];
                            dotProd += pixel * weight;
                        }
                    }
                }
                const dxOffset = xBatchStride * b + xRowStride * xR + xColStride * xC + xChannelStride * d1;
                dxValues[dxOffset] = dotProd;
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $e18d5a13b78d93b8$export$19bbc19fff1ed26f = {
    kernelName: (0, $dCP8m.Conv2DBackpropInput),
    backendName: 'cpu',
    kernelFunc: $e18d5a13b78d93b8$export$633310eed0c26e72
};

});

parcelRegister("imWt5", function(module, exports) {

$parcel$export(module.exports, "conv3DConfig", () => $d5f7a2a49206e156$export$1fe590fda0829040);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bVnU9 = parcelRequire("bVnU9");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $d5f7a2a49206e156$export$1929932f31d07956(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    (0, $aPHJu.assertNotComplex)([
        x,
        filter
    ], 'conv3d');
    const convInfo = (0, $lkN62).computeConv3DInfo(x.shape, filter.shape, strides, dilations, pad);
    const { filterDepth: filterDepth, filterHeight: filterHeight, filterWidth: filterWidth, dilationDepth: dilationDepth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, padInfo: padInfo } = convInfo;
    const padFront = padInfo.front;
    const padLeft = padInfo.left;
    const padTop = padInfo.top;
    const y = new (0, $bVnU9.TensorBuffer)(convInfo.outShape, x.dtype);
    const xVals = backend.data.get(x.dataId).values;
    const wVals = backend.data.get(filter.dataId).values;
    const yVals = y.values;
    const xStrides = (0, $wx9lK).computeStrides(x.shape);
    const filterStrides = (0, $wx9lK).computeStrides(filter.shape);
    for(let b = 0; b < convInfo.batchSize; ++b){
        const xOffset1 = b * xStrides[0];
        const yOffset1 = b * y.strides[0];
        for(let yF = 0; yF < convInfo.outDepth; ++yF){
            const yOffset2 = yOffset1 + yF * y.strides[1];
            const xFCorner = yF * convInfo.strideDepth - padFront;
            for(let wF = 0; wF < filterDepth; ++wF){
                const xF = xFCorner + wF * dilationDepth;
                if (xF < 0 || xF >= convInfo.inDepth) continue;
                const wOffset1 = wF * filterStrides[0];
                const xOffset2 = xOffset1 + xF * xStrides[1];
                for(let yR = 0; yR < convInfo.outHeight; ++yR){
                    const yOffset3 = yOffset2 + yR * y.strides[2];
                    const xRCorner = yR * convInfo.strideHeight - padTop;
                    for(let wR = 0; wR < filterHeight; ++wR){
                        const xR = xRCorner + wR * dilationHeight;
                        if (xR < 0 || xR >= convInfo.inHeight) continue;
                        const wOffset2 = wOffset1 + wR * filterStrides[1];
                        const xOffset3 = xOffset2 + xR * xStrides[2];
                        for(let yC = 0; yC < convInfo.outWidth; ++yC){
                            const yOffset4 = yOffset3 + yC * convInfo.outChannels;
                            const xCCorner = yC * convInfo.strideWidth - padLeft;
                            for(let wC = 0; wC < filterWidth; ++wC){
                                const xC = xCCorner + wC * dilationWidth;
                                if (xC < 0 || xC >= convInfo.inWidth) continue;
                                const wOffset3 = wOffset2 + wC * filterStrides[2];
                                const xOffset4 = xOffset3 + xC * convInfo.inChannels;
                                let wOffset4 = wOffset3;
                                for(let d1 = 0; d1 < convInfo.inChannels; ++d1){
                                    const xVal = xVals[xOffset4 + d1];
                                    for(let d2 = 0; d2 < convInfo.outChannels; ++d2)yVals[yOffset4 + d2] += xVal * wVals[wOffset4 + d2];
                                    wOffset4 += convInfo.outChannels;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return backend.makeTensorInfo(y.shape, y.dtype, y.values);
}
const $d5f7a2a49206e156$export$1fe590fda0829040 = {
    kernelName: (0, $dCP8m.Conv3D),
    backendName: 'cpu',
    kernelFunc: $d5f7a2a49206e156$export$1929932f31d07956
};

});

parcelRegister("avqb8", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropFilterV2Config", () => $7a611b2310c690f8$export$6dce9169640850fa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bVnU9 = parcelRequire("bVnU9");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $7a611b2310c690f8$export$b57760dc3101cea7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, filterShape: filterShape } = attrs;
    (0, $aPHJu.assertNotComplex)([
        x,
        dy
    ], 'conv3dBackpropFilterV2');
    const xStrides = (0, $wx9lK).computeStrides(x.shape);
    const dyStrides = (0, $wx9lK).computeStrides(dy.shape);
    const convInfo = (0, $lkN62).computeConv3DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad);
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const filterDepth = convInfo.filterDepth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const dw = new (0, $bVnU9.TensorBuffer)(convInfo.filterShape, 'float32');
    const dwValues = dw.values;
    const [dwS0, dwS1, dwS2, dwS3] = dw.strides;
    const dyValues = backend.data.get(dy.dataId).values;
    const [dyS0, dyS1, dyS2, dyS3] = dyStrides;
    const xValues = backend.data.get(x.dataId).values;
    const [xS0, xS1, xS2, xS3] = xStrides;
    const frontPad = convInfo.padInfo.front;
    const leftPad = convInfo.padInfo.left;
    const topPad = convInfo.padInfo.top;
    for(let wF = 0; wF < filterDepth; ++wF){
        const yFMin = Math.max(0, Math.ceil((frontPad - wF) / strideDepth));
        const yFMax = Math.min(convInfo.outDepth, (convInfo.inDepth + frontPad - wF) / strideDepth);
        const wOffset1 = wF * dwS0;
        for(let wR = 0; wR < filterHeight; ++wR){
            const yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
            const yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
            const wOffset2 = wR * dwS1 + wOffset1;
            for(let wC = 0; wC < filterWidth; ++wC){
                const yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
                const yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
                const wOffset3 = wC * dwS2 + wOffset2;
                for(let d1 = 0; d1 < convInfo.inChannels; ++d1){
                    const wOffset4 = d1 * dwS3 + wOffset3;
                    for(let d2 = 0; d2 < convInfo.outChannels; ++d2){
                        let dotProd = 0;
                        for(let b = 0; b < convInfo.batchSize; ++b){
                            const xOffset1 = b * xS0;
                            const yOffset1 = b * dyS0;
                            for(let yF = yFMin; yF < yFMax; ++yF){
                                const xF = wF + yF * strideDepth - frontPad;
                                const xOffset2 = xF * xS1 + xOffset1;
                                const yOffset2 = yF * dyS1 + yOffset1;
                                for(let yR = yRMin; yR < yRMax; ++yR){
                                    const xR = wR + yR * strideHeight - topPad;
                                    const xOffset3 = xR * xS2 + xOffset2;
                                    const yOffset3 = yR * dyS2 + yOffset2;
                                    for(let yC = yCMin; yC < yCMax; ++yC){
                                        const xC = wC + yC * strideWidth - leftPad;
                                        const xOffset4 = xC * xS3 + xOffset3;
                                        const yOffset4 = yC * dyS3 + yOffset3;
                                        dotProd += xValues[xOffset4 + d1] * dyValues[yOffset4 + d2];
                                    }
                                }
                            }
                        }
                        dwValues[wOffset4 + d2] = dotProd;
                    }
                }
            }
        }
    }
    return backend.makeTensorInfo(dw.shape, dw.dtype, dw.values);
}
const $7a611b2310c690f8$export$6dce9169640850fa = {
    kernelName: (0, $dCP8m.Conv3DBackpropFilterV2),
    backendName: 'cpu',
    kernelFunc: $7a611b2310c690f8$export$b57760dc3101cea7
};

});

parcelRegister("k0KNW", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropInputV2Config", () => $e9181d21333bd961$export$40ece1caaaf084b2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bVnU9 = parcelRequire("bVnU9");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $e9181d21333bd961$export$ab31b884dc9f0971(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { pad: pad, strides: strides, inputShape: inputShape } = attrs;
    (0, $aPHJu.assertNotComplex)([
        dy
    ], 'conv3dBackpropInputV2');
    const dyStrides = (0, $wx9lK).computeStrides(dy.shape);
    const filterStrides = (0, $wx9lK).computeStrides(filter.shape);
    const convInfo = (0, $lkN62).computeConv3DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad);
    const dx = new (0, $bVnU9.TensorBuffer)(convInfo.inShape, 'float32');
    const dxValues = dx.values;
    const [dxS0, dxS1, dxS2, dxS3] = dx.strides;
    const dyValues = backend.data.get(dy.dataId).values;
    const [dyS0, dyS1, dyS2, dyS3] = dyStrides;
    const fltValues = backend.data.get(filter.dataId).values;
    const [fltS0, fltS1, fltS2, fltS3] = filterStrides;
    const { batchSize: batchSize, filterDepth: filterDepth, filterHeight: filterHeight, filterWidth: filterWidth, inChannels: inChannels, inDepth: inDepth, inHeight: inHeight, inWidth: inWidth, outChannels: outChannels, outDepth: outDepth, outHeight: outHeight, outWidth: outWidth, strideDepth: strideDepth, strideHeight: strideHeight, strideWidth: strideWidth } = convInfo;
    const frontPad = filterDepth - 1 - convInfo.padInfo.front;
    const topPad = filterHeight - 1 - convInfo.padInfo.top;
    const leftPad = filterWidth - 1 - convInfo.padInfo.left;
    for(let b = 0; b < batchSize; ++b){
        for(let d1 = 0; d1 < inChannels; ++d1)// Frames of depth
        for(let xF = 0; xF < inDepth; ++xF){
            const xFCorner = xF - frontPad;
            const xFMin = Math.max(0, Math.ceil(xFCorner / strideDepth));
            const yFMax = Math.min(outDepth, (filterDepth + xFCorner) / strideDepth);
            // Rows as per standard 2d matrix notation
            for(let xR = 0; xR < inHeight; ++xR){
                const xRCorner = xR - topPad;
                const xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
                const yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
                // Columns as per standard 2d matrix notation
                for(let xC = 0; xC < inWidth; ++xC){
                    const xCCorner = xC - leftPad;
                    const xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
                    const yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
                    let dotProd = 0;
                    for(let yF = xFMin; yF < yFMax; ++yF){
                        const wF = yF * strideDepth - xFCorner;
                        for(let yR = xRMin; yR < yRMax; ++yR){
                            const wR = yR * strideHeight - xRCorner;
                            for(let yC = xCMin; yC < yCMax; ++yC){
                                const wC = yC * strideWidth - xCCorner;
                                const dyOffset = dyS0 * b + dyS1 * yF + dyS2 * yR + dyS3 * yC;
                                const fltOffset = fltS0 * (filterDepth - 1 - wF) + fltS1 * (filterHeight - 1 - wR) + fltS2 * (filterWidth - 1 - wC) + fltS3 * d1;
                                for(let d2 = 0; d2 < outChannels; ++d2){
                                    const pixel = dyValues[dyOffset + d2];
                                    const weight = fltValues[fltOffset + d2];
                                    dotProd += pixel * weight;
                                }
                            }
                        }
                    }
                    dxValues[dxS0 * b + dxS1 * xF + dxS2 * xR + dxS3 * xC + d1] = dotProd;
                }
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $e9181d21333bd961$export$40ece1caaaf084b2 = {
    kernelName: (0, $dCP8m.Conv3DBackpropInputV2),
    backendName: 'cpu',
    kernelFunc: $e9181d21333bd961$export$ab31b884dc9f0971
};

});

parcelRegister("g17KM", function(module, exports) {

$parcel$export(module.exports, "cosConfig", () => $ba92c10c6836d4f4$export$ff099a1da5235a7e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $ba92c10c6836d4f4$export$50d414a77b60d802 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Cos), (xi)=>Math.cos(xi));
const $ba92c10c6836d4f4$export$ff099a1da5235a7e = {
    kernelName: (0, $dCP8m.Cos),
    backendName: 'cpu',
    kernelFunc: $ba92c10c6836d4f4$export$50d414a77b60d802
};

});

parcelRegister("e79dG", function(module, exports) {

$parcel$export(module.exports, "coshConfig", () => $a468defbc773a35b$export$c5824052b09ba0ed);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $a468defbc773a35b$export$2e2fd1ad24e4d350 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Cosh), (xi)=>Math.cosh(xi));
const $a468defbc773a35b$export$c5824052b09ba0ed = {
    kernelName: (0, $dCP8m.Cosh),
    backendName: 'cpu',
    kernelFunc: $a468defbc773a35b$export$2e2fd1ad24e4d350
};

});

parcelRegister("bfIOA", function(module, exports) {

$parcel$export(module.exports, "cropAndResizeConfig", () => $8313dbbeed56ac67$export$f7086edcf0050c7f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $g81BN = parcelRequire("g81BN");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
function $8313dbbeed56ac67$export$6f0f0090e1f6cd3c(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, boxes: boxes, boxInd: boxInd } = inputs;
    const { cropSize: cropSize, method: method, extrapolationValue: extrapolationValue } = attrs;
    const [batch, imageHeight, imageWidth, numChannels] = image.shape;
    const numBoxes = boxes.shape[0];
    const [cropHeight, cropWidth] = cropSize;
    const output = (0, $g81BN.buffer)([
        numBoxes,
        cropHeight,
        cropWidth,
        numChannels
    ], 'float32');
    const boxVals = backend.data.get(boxes.dataId).values;
    const boxIndVals = backend.data.get(boxInd.dataId).values;
    const imageVals = backend.data.get(image.dataId).values;
    const inStride = (0, $wx9lK).computeStrides(image.shape); // to calculate flat indexes into image
    const outStride = (0, $wx9lK).computeStrides(output.shape); // to calculate flat indexes into output
    // Reference implementation
    // tslint:disable-next-line:max-line-length
    // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/crop_and_resize_op.cc
    for(let b = 0; b < numBoxes; b++){
        const startInd = b * 4;
        const y1 = boxVals[startInd];
        const x1 = boxVals[startInd + 1];
        const y2 = boxVals[startInd + 2];
        const x2 = boxVals[startInd + 3];
        const bInd = boxIndVals[b];
        if (bInd >= batch) continue;
        const heightScale = cropHeight > 1 ? (y2 - y1) * (imageHeight - 1) / (cropHeight - 1) : 0;
        const widthScale = cropWidth > 1 ? (x2 - x1) * (imageWidth - 1) / (cropWidth - 1) : 0;
        for(let y = 0; y < cropHeight; y++){
            const yInd = cropHeight > 1 ? y1 * (imageHeight - 1) + y * heightScale : 0.5 * (y1 + y2) * (imageHeight - 1);
            if (yInd < 0 || yInd > imageHeight - 1) {
                for(let x = 0; x < cropWidth; x++)for(let c = 0; c < numChannels; c++){
                    const ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                    output.values[ind] = extrapolationValue;
                }
                continue;
            }
            if (method === 'bilinear') {
                const topInd = Math.floor(yInd);
                const bottomInd = Math.ceil(yInd);
                const yLerp = yInd - topInd;
                for(let x = 0; x < cropWidth; x++){
                    const xInd = cropWidth > 1 ? x1 * (imageWidth - 1) + x * widthScale : 0.5 * (x1 + x2) * (imageWidth - 1);
                    if (xInd < 0 || xInd > imageWidth - 1) {
                        for(let c = 0; c < numChannels; c++){
                            const ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                            output.values[ind] = extrapolationValue;
                        }
                        continue;
                    }
                    const leftInd = Math.floor(xInd);
                    const rightInd = Math.ceil(xInd);
                    const xLerp = xInd - leftInd;
                    for(let c = 0; c < numChannels; c++){
                        let ind = c + leftInd * inStride[2] + topInd * inStride[1] + bInd * inStride[0];
                        const topLeft = imageVals[ind];
                        ind = c + rightInd * inStride[2] + topInd * inStride[1] + bInd * inStride[0];
                        const topRight = imageVals[ind];
                        ind = c + leftInd * inStride[2] + bottomInd * inStride[1] + bInd * inStride[0];
                        const bottomLeft = imageVals[ind];
                        ind = c + rightInd * inStride[2] + bottomInd * inStride[1] + bInd * inStride[0];
                        const bottomRight = imageVals[ind];
                        const top = topLeft + (topRight - topLeft) * xLerp;
                        const bottom = bottomLeft + (bottomRight - bottomLeft) * xLerp;
                        ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                        output.values[ind] = top + (bottom - top) * yLerp;
                    }
                }
            } else for(let x = 0; x < cropWidth; ++x){
                const xInd = cropWidth > 1 ? x1 * (imageWidth - 1) + x * widthScale : 0.5 * (x1 + x2) * (imageWidth - 1);
                if (xInd < 0 || xInd > imageWidth - 1) {
                    for(let c = 0; c < numChannels; c++){
                        const ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                        output.values[ind] = extrapolationValue;
                    }
                    continue;
                }
                const closestX = Math.round(xInd);
                const closestY = Math.round(yInd);
                for(let c = 0; c < numChannels; c++){
                    const inInd = c + closestX * inStride[2] + closestY * inStride[1] + bInd * inStride[0];
                    const outInd = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                    output.values[outInd] = imageVals[inInd];
                }
            }
        }
    }
    return backend.makeTensorInfo(output.shape, output.dtype, output.values);
}
const $8313dbbeed56ac67$export$f7086edcf0050c7f = {
    kernelName: (0, $dCP8m.CropAndResize),
    backendName: 'cpu',
    kernelFunc: $8313dbbeed56ac67$export$6f0f0090e1f6cd3c
};

});

parcelRegister("dS1Vh", function(module, exports) {

$parcel$export(module.exports, "cumprodConfig", () => $a191cf5d3d7c7fe3$export$db50d81ed60c5a35);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bnEYl = parcelRequire("bnEYl");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $9buNR = parcelRequire("9buNR");
function $a191cf5d3d7c7fe3$export$dc7513e907e94b8d(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'cumprod');
    const permutation = (0, $lkN62).getAxesPermutation([
        axis
    ], x.shape.length);
    let $x = x;
    if (permutation != null) $x = (0, $9buNR.transpose)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            perm: permutation
        }
    });
    const permutedAxis = (0, $lkN62).getInnerMostAxes(1, x.shape.length)[0];
    if (permutedAxis !== $x.shape.length - 1) throw new Error(`backend.cumprod in CPU expects an inner-most ` + `axis=${$x.shape.length - 1} but got axis=${permutedAxis}`);
    const resultDtype = (0, $bnEYl.upcastType)($x.dtype, 'int32');
    const vals = (0, $wx9lK).makeOnesTypedArray((0, $wx9lK).sizeFromShape($x.shape), resultDtype);
    const aVals = backend.data.get($x.dataId).values;
    const finalDim = $x.shape[$x.shape.length - 1];
    const indexAdjuster = reverse ? (i, j)=>i + finalDim - j - 1 : (i, j)=>i + j;
    for(let i = 0; i < aVals.length; i += finalDim)for(let j = 0; j < finalDim; j++){
        const idx = indexAdjuster(i, j);
        if (j === 0) vals[idx] = exclusive ? 1 : aVals[idx];
        else {
            const prevIdx = indexAdjuster(i, j - 1);
            vals[idx] = exclusive ? aVals[prevIdx] * vals[prevIdx] : aVals[idx] * vals[prevIdx];
        }
    }
    const result = backend.makeTensorInfo($x.shape, resultDtype, vals);
    if (permutation != null) {
        const reversePermutation = (0, $lkN62).getUndoAxesPermutation(permutation);
        const reverseTransposedResult = (0, $9buNR.transpose)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: reversePermutation
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        backend.disposeIntermediateTensorInfo($x);
        return reverseTransposedResult;
    }
    return result;
}
const $a191cf5d3d7c7fe3$export$db50d81ed60c5a35 = {
    kernelName: (0, $dCP8m.Cumprod),
    backendName: 'cpu',
    kernelFunc: $a191cf5d3d7c7fe3$export$dc7513e907e94b8d
};

});

parcelRegister("jPTZ1", function(module, exports) {

$parcel$export(module.exports, "cumsumConfig", () => $e70e34d6fa71861e$export$2f6196f3316e7ed2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bnEYl = parcelRequire("bnEYl");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $9buNR = parcelRequire("9buNR");
function $e70e34d6fa71861e$export$71990b1e1c4912fe(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'cumsum');
    const permutation = (0, $lkN62).getAxesPermutation([
        axis
    ], x.shape.length);
    let $x = x;
    if (permutation != null) $x = (0, $9buNR.transpose)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            perm: permutation
        }
    });
    const permutedAxis = (0, $lkN62).getInnerMostAxes(1, x.shape.length)[0];
    if (permutedAxis !== $x.shape.length - 1) throw new Error(`backend.cumsum in CPU expects an inner-most ` + `axis=${$x.shape.length - 1} but got axis=${permutedAxis}`);
    const resultDtype = (0, $bnEYl.upcastType)($x.dtype, 'int32');
    const vals = (0, $wx9lK).makeZerosTypedArray((0, $wx9lK).sizeFromShape($x.shape), resultDtype);
    const aVals = backend.data.get($x.dataId).values;
    const finalDim = $x.shape[$x.shape.length - 1];
    const indexAdjuster = reverse ? (i, j)=>i + finalDim - j - 1 : (i, j)=>i + j;
    for(let i = 0; i < aVals.length; i += finalDim)for(let j = 0; j < finalDim; j++){
        const idx = indexAdjuster(i, j);
        if (j === 0) vals[idx] = exclusive ? 0 : aVals[idx];
        else {
            const prevIdx = indexAdjuster(i, j - 1);
            vals[idx] = exclusive ? aVals[prevIdx] + vals[prevIdx] : aVals[idx] + vals[prevIdx];
        }
    }
    const result = backend.makeTensorInfo($x.shape, resultDtype, vals);
    if (permutation != null) {
        const reversePermutation = (0, $lkN62).getUndoAxesPermutation(permutation);
        const reverseTransposedResult = (0, $9buNR.transpose)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: reversePermutation
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        backend.disposeIntermediateTensorInfo($x);
        return reverseTransposedResult;
    }
    return result;
}
const $e70e34d6fa71861e$export$2f6196f3316e7ed2 = {
    kernelName: (0, $dCP8m.Cumsum),
    backendName: 'cpu',
    kernelFunc: $e70e34d6fa71861e$export$71990b1e1c4912fe
};

});

parcelRegister("jotxZ", function(module, exports) {

$parcel$export(module.exports, "denseBincountConfig", () => $e1e72da970ff4fb5$export$88ba267b84334692);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $gKVCB = parcelRequire("gKVCB");
function $e1e72da970ff4fb5$export$436934e6cf1946f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size, binaryOutput: binaryOutput } = attrs;
    if (x.shape.length === 1) {
        const xVals = backend.data.get(x.dataId).values;
        const weightsVals = backend.data.get(weights.dataId).values;
        const outVals = (0, $gKVCB.bincountImpl)(xVals, weightsVals, weights.dtype, weights.shape, size);
        return backend.makeTensorInfo([
            size
        ], weights.dtype, outVals);
    } else if (x.shape.length === 2) {
        const xBuf = backend.bufferSync(x);
        const weightsBuf = backend.bufferSync(weights);
        const outBuf = (0, $gKVCB.bincountReduceImpl)(xBuf, weightsBuf, size, binaryOutput);
        return backend.makeTensorInfo(outBuf.shape, weights.dtype, outBuf.values);
    }
    throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank` + `${x.shape.length}.`);
}
const $e1e72da970ff4fb5$export$88ba267b84334692 = {
    kernelName: (0, $dCP8m.DenseBincount),
    backendName: 'cpu',
    kernelFunc: $e1e72da970ff4fb5$export$436934e6cf1946f1
};

});

parcelRegister("hVgL7", function(module, exports) {

$parcel$export(module.exports, "depthToSpaceConfig", () => $d0c4c2837a006089$export$9c5b88dcb1d2008b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
function $d0c4c2837a006089$export$3b50daec0f185f12(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockSize: blockSize, dataFormat: dataFormat } = attrs;
    (0, $wx9lK).assert(dataFormat === 'NHWC', ()=>`Only NHWC dataFormat supported on CPU for depthToSpace. Got ${dataFormat}`);
    const batchSize = x.shape[0];
    const inputHeight = x.shape[1];
    const inputWidth = x.shape[2];
    const inputDepth = x.shape[3];
    const outputHeight = inputHeight * blockSize;
    const outputWidth = inputWidth * blockSize;
    const outputDepth = inputDepth / (blockSize * blockSize);
    const xValues = backend.data.get(x.dataId).values;
    const result = new Float32Array(batchSize * outputHeight * outputWidth * outputDepth);
    let outputIdx = 0;
    for(let b = 0; b < batchSize; ++b)for(let h = 0; h < outputHeight; ++h){
        const inH = Math.floor(h / blockSize);
        const offsetH = h % blockSize;
        for(let w = 0; w < outputWidth; ++w){
            const inW = Math.floor(w / blockSize);
            const offsetW = w % blockSize;
            const offsetD = (offsetH * blockSize + offsetW) * outputDepth;
            for(let d = 0; d < outputDepth; ++d){
                const inD = d + offsetD;
                const inputIdx = inD + inputDepth * (inW + inputWidth * (inH + inputHeight * b));
                result[outputIdx++] = xValues[inputIdx];
            }
        }
    }
    return backend.makeTensorInfo([
        batchSize,
        outputHeight,
        outputWidth,
        outputDepth
    ], x.dtype, result);
}
const $d0c4c2837a006089$export$9c5b88dcb1d2008b = {
    kernelName: (0, $dCP8m.DepthToSpace),
    backendName: 'cpu',
    kernelFunc: $d0c4c2837a006089$export$3b50daec0f185f12
};

});

parcelRegister("eUWGR", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNative", () => $adc3d24ed5a95d66$export$14e793fe8822afd1);
$parcel$export(module.exports, "depthwiseConv2dNativeConfig", () => $adc3d24ed5a95d66$export$240667804b7c390e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bVnU9 = parcelRequire("bVnU9");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $adc3d24ed5a95d66$export$14e793fe8822afd1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $aPHJu.assertNotComplex)([
        x,
        filter
    ], 'depthwiseConv2DNative');
    const xStrides = (0, $wx9lK).computeStrides(x.shape);
    const filterStrides = (0, $wx9lK).computeStrides(filter.shape);
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $wx9lK).assert((0, $lkN62).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $lkN62).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    const { filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, padInfo: padInfo } = convInfo;
    const padLeft = padInfo.left;
    const padTop = padInfo.top;
    const chMul = convInfo.outChannels / convInfo.inChannels;
    const y = new (0, $bVnU9.TensorBuffer)(convInfo.outShape, x.dtype);
    const xVals = backend.data.get(x.dataId).values;
    const wVals = backend.data.get(filter.dataId).values;
    const yVals = y.values;
    for(let b = 0; b < convInfo.batchSize; ++b){
        const xOffset1 = b * xStrides[0];
        const yOffset1 = b * y.strides[0];
        for(let yR = 0; yR < convInfo.outHeight; ++yR){
            const yOffset2 = yOffset1 + yR * y.strides[1];
            const xRCorner = yR * convInfo.strideHeight - padTop;
            for(let wR = 0; wR < filterHeight; ++wR){
                const xR = xRCorner + wR * dilationHeight;
                if (xR < 0 || xR >= convInfo.inHeight) continue;
                const wOffset1 = wR * filterStrides[0];
                const xOffset2 = xOffset1 + xR * xStrides[1];
                for(let yC = 0; yC < convInfo.outWidth; ++yC){
                    const yOffset3 = yOffset2 + yC * y.strides[2];
                    const xCCorner = yC * convInfo.strideWidth - padLeft;
                    for(let wC = 0; wC < filterWidth; ++wC){
                        const xC = xCCorner + wC * dilationWidth;
                        if (xC < 0 || xC >= convInfo.inWidth) continue;
                        const wOffset2 = wOffset1 + wC * filterStrides[1];
                        const xOffset3 = xOffset2 + xC * convInfo.inChannels;
                        let yOffset4 = yOffset3;
                        let wOffset3 = wOffset2;
                        for(let d1 = 0; d1 < convInfo.inChannels; ++d1){
                            const xVal = xVals[xOffset3 + d1];
                            for(let q = 0; q < chMul; ++q)yVals[yOffset4 + q] += xVal * wVals[wOffset3 + q];
                            yOffset4 += chMul;
                            wOffset3 += chMul;
                        }
                    }
                }
            }
        }
    }
    return backend.makeTensorInfo(y.shape, y.dtype, y.values);
}
const $adc3d24ed5a95d66$export$240667804b7c390e = {
    kernelName: (0, $dCP8m.DepthwiseConv2dNative),
    backendName: 'cpu',
    kernelFunc: $adc3d24ed5a95d66$export$14e793fe8822afd1
};

});

parcelRegister("h1fh8", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropFilterConfig", () => $c63e610df39ac830$export$30bc0ac3775583fc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bVnU9 = parcelRequire("bVnU9");

var $aPHJu = parcelRequire("aPHJu");
function $c63e610df39ac830$export$cc0ae65e9edc7e1a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    (0, $aPHJu.assertNotComplex)([
        x,
        dy
    ], 'depthwiseConv2dNativeBackpropFilter');
    const convInfo = (0, $lkN62).computeConv2DInfo(x.shape, filterShape, strides, dilations, pad, dimRoundingMode, true);
    const { strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth } = convInfo;
    const dW = new (0, $bVnU9.TensorBuffer)(convInfo.filterShape, 'float32');
    const leftPad = convInfo.padInfo.left;
    const topPad = convInfo.padInfo.top;
    const chMul = convInfo.outChannels / convInfo.inChannels;
    const xVals = backend.data.get(x.dataId).values;
    const xBuf = new (0, $bVnU9.TensorBuffer)(x.shape, x.dtype, xVals);
    const dyVals = backend.data.get(dy.dataId).values;
    const dyBuf = new (0, $bVnU9.TensorBuffer)(dy.shape, dy.dtype, dyVals);
    for(let wR = 0; wR < filterHeight; ++wR){
        const yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
        const yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
        for(let wC = 0; wC < filterWidth; ++wC){
            const yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
            const yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
            for(let d2 = 0; d2 < convInfo.outChannels; ++d2){
                const d1 = Math.trunc(d2 / chMul);
                const dm = d2 % chMul;
                let dotProd = 0;
                for(let b = 0; b < convInfo.batchSize; ++b)for(let yR = yRMin; yR < yRMax; ++yR){
                    const xR = wR + yR * strideHeight - topPad;
                    for(let yC = yCMin; yC < yCMax; ++yC){
                        const xC = wC + yC * strideWidth - leftPad;
                        dotProd += xBuf.get(b, xR, xC, d1) * dyBuf.get(b, yR, yC, d2);
                    }
                }
                dW.set(dotProd, wR, wC, d1, dm);
            }
        }
    }
    return backend.makeTensorInfo(dW.shape, dW.dtype, dW.values);
}
const $c63e610df39ac830$export$30bc0ac3775583fc = {
    kernelName: (0, $dCP8m.DepthwiseConv2dNativeBackpropFilter),
    backendName: 'cpu',
    kernelFunc: $c63e610df39ac830$export$cc0ae65e9edc7e1a
};

});

parcelRegister("kP87u", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropInputConfig", () => $03e987b7a70512ac$export$55d12409e744bebe);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bVnU9 = parcelRequire("bVnU9");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $03e987b7a70512ac$export$37e2ab95a4a4c24b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, inputShape: inputShape } = attrs;
    (0, $aPHJu.assertNotComplex)([
        dy,
        filter
    ], 'depthwiseConv2DNativeBackpropInput');
    const dyStrides = (0, $wx9lK).computeStrides(dy.shape);
    const filterStrides = (0, $wx9lK).computeStrides(filter.shape);
    const convInfo = (0, $lkN62).computeConv2DInfo(inputShape, filter.shape, strides, dilations, pad, dimRoundingMode, true);
    const dx = new (0, $bVnU9.TensorBuffer)(convInfo.inShape, 'float32');
    const dxValues = dx.values;
    const [dxS0, dxS1, dxS2] = dx.strides;
    const dyValues = backend.data.get(dy.dataId).values;
    const [dyS0, dyS1, dyS2] = dyStrides;
    const fltValues = backend.data.get(filter.dataId).values;
    const [fltS0, fltS1, fltS2] = filterStrides;
    const { batchSize: batchSize, filterHeight: filterHeight, filterWidth: filterWidth, inChannels: inChannels, inHeight: inHeight, inWidth: inWidth, outChannels: outChannels, outHeight: outHeight, outWidth: outWidth, strideHeight: strideHeight, strideWidth: strideWidth } = convInfo;
    const topPad = filterHeight - 1 - convInfo.padInfo.top;
    const leftPad = filterWidth - 1 - convInfo.padInfo.left;
    const chMul = outChannels / inChannels;
    for(let b = 0; b < batchSize; ++b){
        for(let d1 = 0; d1 < inChannels; ++d1)for(let xR = 0; xR < inHeight; ++xR){
            const xRCorner = xR - topPad;
            const xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
            const yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
            for(let xC = 0; xC < inWidth; ++xC){
                const xCCorner = xC - leftPad;
                const xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
                const yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
                let dotProd = 0;
                for(let yR = xRMin; yR < yRMax; ++yR){
                    const wR = yR * strideHeight - xRCorner;
                    for(let yC = xCMin; yC < yCMax; ++yC){
                        const wC = yC * strideWidth - xCCorner;
                        const dyOffset = dyS0 * b + dyS1 * yR + dyS2 * yC;
                        const fltOffset = fltS0 * (filterHeight - 1 - wR) + fltS1 * (filterWidth - 1 - wC) + fltS2 * d1;
                        for(let dm = 0; dm < chMul; ++dm){
                            const d2 = d1 * chMul + dm;
                            const pixel = dyValues[dyOffset + d2];
                            const weight = fltValues[fltOffset + dm];
                            dotProd += pixel * weight;
                        }
                    }
                }
                dxValues[dxS0 * b + dxS1 * xR + dxS2 * xC + d1] = dotProd;
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $03e987b7a70512ac$export$55d12409e744bebe = {
    kernelName: (0, $dCP8m.DepthwiseConv2dNativeBackpropInput),
    backendName: 'cpu',
    kernelFunc: $03e987b7a70512ac$export$37e2ab95a4a4c24b
};

});

parcelRegister("eQTnz", function(module, exports) {

$parcel$export(module.exports, "diagConfig", () => $ad00e1273716aa7b$export$56dc5d812a22748f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $g81BN = parcelRequire("g81BN");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
function $ad00e1273716aa7b$export$c042e7c2f59bc046(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const xSize = (0, $wx9lK).sizeFromShape(x.shape);
    const xVals = backend.data.get(x.dataId).values;
    const outBuf = (0, $g81BN.buffer)([
        xSize,
        xSize
    ], x.dtype);
    const vals = outBuf.values;
    for(let i = 0; i < xVals.length; i++)vals[i * xSize + i] = xVals[i];
    const outShape = [
        ...x.shape,
        ...x.shape
    ];
    return backend.makeTensorInfo(outShape, outBuf.dtype, outBuf.values);
}
const $ad00e1273716aa7b$export$56dc5d812a22748f = {
    kernelName: (0, $dCP8m.Diag),
    backendName: 'cpu',
    kernelFunc: $ad00e1273716aa7b$export$c042e7c2f59bc046
};

});

parcelRegister("bQVlb", function(module, exports) {

$parcel$export(module.exports, "dilation2DConfig", () => $8a1107b0b7786002$export$36d3c11f61a8891a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
const $8a1107b0b7786002$export$36d3c11f61a8891a = {
    kernelName: (0, $dCP8m.Dilation2D),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, backend: backend, attrs: attrs })=>{
        const { x: x, filter: filter } = inputs;
        const { strides: strides, pad: pad, dilations: dilations } = attrs;
        const cpuBackend = backend;
        const xVals = cpuBackend.data.get(x.dataId).values;
        const xRank = x.shape.length;
        const filterVals = cpuBackend.data.get(filter.dataId).values;
        const filterRank = filter.shape.length;
        const { batchSize: batchSize, inHeight: inHeight, inWidth: inWidth, inChannels: inChannels, outHeight: outHeight, outWidth: outWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, outShape: outShape } = (0, $lkN62).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
        const outSize = (0, $wx9lK).sizeFromShape(outShape);
        const outRank = outShape.length;
        const outputVals = (0, $wx9lK).getArrayFromDType(x.dtype, outSize);
        // Upsampling the input by fill in `dilation size - 1` values between each
        // input value.
        // This implementation follows the TF c++ implementation:
        // https://github.com/tensorflow/tensorflow/blob/d9a3a849edc198e90172bc58eb293de457f9d986/tensorflow/core/kernels/dilation_ops.cc
        for(let b = 0; b < batchSize; ++b)for(let hOut = 0; hOut < outHeight; ++hOut){
            const hBeg = hOut * strideHeight - padInfo.top;
            for(let wOut = 0; wOut < outWidth; ++wOut){
                const wBeg = wOut * strideWidth - padInfo.left;
                for(let d = 0; d < inChannels; ++d){
                    let curVal = Number.MIN_SAFE_INTEGER;
                    for(let h = 0; h < filterHeight; ++h){
                        const hIn = hBeg + h * dilationHeight;
                        if (hIn >= 0 && hIn < inHeight) for(let w = 0; w < filterWidth; ++w){
                            const wIn = wBeg + w * dilationWidth;
                            if (wIn >= 0 && wIn < inWidth) {
                                const xIndex = (0, $wx9lK).locToIndex([
                                    b,
                                    hIn,
                                    wIn,
                                    d
                                ], xRank, (0, $wx9lK).computeStrides(x.shape));
                                const filterIndex = (0, $wx9lK).locToIndex([
                                    h,
                                    w,
                                    d
                                ], filterRank, (0, $wx9lK).computeStrides(filter.shape));
                                const val = xVals[xIndex] + filterVals[filterIndex];
                                if (val > curVal) curVal = val;
                            }
                        }
                    }
                    const outputIndex = (0, $wx9lK).locToIndex([
                        b,
                        hOut,
                        wOut,
                        d
                    ], outRank, (0, $wx9lK).computeStrides(outShape));
                    outputVals[outputIndex] = curVal;
                }
            }
        }
        const dataId = cpuBackend.write((0, $wx9lK).toTypedArray(outputVals, x.dtype), outShape, x.dtype);
        return {
            dataId: dataId,
            shape: outShape,
            dtype: x.dtype
        };
    }
};

});

parcelRegister("kc4JX", function(module, exports) {

$parcel$export(module.exports, "dilation2DBackpropFilterConfig", () => $eb389af87d00a609$export$cf83abe0e8c87ce8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
const $eb389af87d00a609$export$cf83abe0e8c87ce8 = {
    kernelName: (0, $dCP8m.Dilation2DBackpropFilter),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, backend: backend, attrs: attrs })=>{
        const { x: x, filter: filter, dy: dy } = inputs;
        const { strides: strides, pad: pad, dilations: dilations } = attrs;
        const cpuBackend = backend;
        const $x = (0, $wx9lK).toNestedArray(x.shape, cpuBackend.data.get(x.dataId).values);
        const $filter = (0, $wx9lK).toNestedArray(filter.shape, cpuBackend.data.get(filter.dataId).values);
        const { batchSize: batchSize, inHeight: inHeight, inWidth: inWidth, inChannels: inChannels, outHeight: outHeight, outWidth: outWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, outShape: outShape } = (0, $lkN62).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
        (0, $wx9lK).assert(dy.rank === outShape.length, ()=>`Error in ${0, $dCP8m.Dilation2DBackpropFilter}, dy ` + `must have the same rank as output ${outShape.length}, but got ` + `${dy.rank}`);
        const $dy = (0, $wx9lK).toNestedArray(outShape, cpuBackend.data.get(dy.dataId).values);
        // The computed filter gradients has the same dimensions as the filter:
        // [filterHeight, filterWidth, depth]
        const gradients = (0, $wx9lK).makeZerosNestedTypedArray(filter.shape, filter.dtype);
        // In the case of multiple argmax branches, we only back-propagate along the
        // last branch, i.e., the one with largest value of `h * filter_cols + w`,
        // similarly to the max-pooling backward routines.
        // This implementation follows the TF c++ implementation:
        // https://github.com/tensorflow/tensorflow/blob/d9a3a849edc198e90172bc58eb293de457f9d986/tensorflow/core/kernels/dilation_ops.cc
        for(let b = 0; b < batchSize; ++b)for(let hOut = 0; hOut < outHeight; ++hOut){
            const hBeg = hOut * strideHeight - padInfo.top;
            for(let wOut = 0; wOut < outWidth; ++wOut){
                const wBeg = wOut * strideWidth - padInfo.left;
                for(let d = 0; d < inChannels; ++d){
                    let curVal = Number.MIN_SAFE_INTEGER;
                    let hMax = 0;
                    let wMax = 0;
                    for(let h = 0; h < filterHeight; ++h){
                        const hIn = hBeg + h * dilationHeight;
                        if (hIn >= 0 && hIn < inHeight) for(let w = 0; w < filterWidth; ++w){
                            const wIn = wBeg + w * dilationWidth;
                            if (wIn >= 0 && wIn < inWidth) {
                                const val = $x[b][hIn][wIn][d] + $filter[h][w][d];
                                if (val > curVal) {
                                    curVal = val;
                                    hMax = h;
                                    wMax = w;
                                }
                            }
                        }
                    }
                    gradients[hMax][wMax][d] += $dy[b][hOut][wOut][d];
                }
            }
        }
        const dataId = cpuBackend.write((0, $wx9lK).toTypedArray(gradients, x.dtype), filter.shape, filter.dtype);
        return {
            dataId: dataId,
            shape: filter.shape,
            dtype: filter.dtype
        };
    }
};

});

parcelRegister("4Q01k", function(module, exports) {

$parcel$export(module.exports, "dilation2DBackpropInputConfig", () => $385c08cae83a0715$export$42e4451417dc5ea0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
const $385c08cae83a0715$export$42e4451417dc5ea0 = {
    kernelName: (0, $dCP8m.Dilation2DBackpropInput),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, backend: backend, attrs: attrs })=>{
        const { x: x, filter: filter, dy: dy } = inputs;
        const { strides: strides, pad: pad, dilations: dilations } = attrs;
        const cpuBackend = backend;
        const $x = (0, $wx9lK).toNestedArray(x.shape, cpuBackend.data.get(x.dataId).values);
        const $filter = (0, $wx9lK).toNestedArray(filter.shape, cpuBackend.data.get(filter.dataId).values);
        const { batchSize: batchSize, inHeight: inHeight, inWidth: inWidth, inChannels: inChannels, outHeight: outHeight, outWidth: outWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, outShape: outShape } = (0, $lkN62).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
        (0, $wx9lK).assert(dy.rank === outShape.length, ()=>`Error in ${0, $dCP8m.Dilation2DBackpropInput}, dy ` + `must have the same rank as output ${outShape.length}, but got ` + `${dy.rank}`);
        const $dy = (0, $wx9lK).toNestedArray(outShape, cpuBackend.data.get(dy.dataId).values);
        // The computed gradients has the same dimensions as the input:
        // [batch, inputHeight, inputCols, inChannel]
        const gradients = (0, $wx9lK).makeZerosNestedTypedArray(x.shape, x.dtype);
        // In the case of multiple argmax branches, we only back-propagate along the
        // last branch, i.e., the one with largest value of `h * filter_cols + w`,
        // similarly to the max-pooling backward routines.
        // This implementation follows the TF c++ implementation:
        // https://github.com/tensorflow/tensorflow/blob/d9a3a849edc198e90172bc58eb293de457f9d986/tensorflow/core/kernels/dilation_ops.cc
        for(let b = 0; b < batchSize; ++b)for(let hOut = 0; hOut < outHeight; ++hOut){
            const hBeg = hOut * strideHeight - padInfo.top;
            for(let wOut = 0; wOut < outWidth; ++wOut){
                const wBeg = wOut * strideWidth - padInfo.left;
                for(let d = 0; d < inChannels; ++d){
                    let curVal = Number.MIN_SAFE_INTEGER;
                    let hInMax = hBeg < 0 ? 0 : hBeg;
                    let wInMax = wBeg < 0 ? 0 : wBeg;
                    for(let h = 0; h < filterHeight; ++h){
                        const hIn = hBeg + h * dilationHeight;
                        if (hIn >= 0 && hIn < inHeight) for(let w = 0; w < filterWidth; ++w){
                            const wIn = wBeg + w * dilationWidth;
                            if (wIn >= 0 && wIn < inWidth) {
                                const val = $x[b][hIn][wIn][d] + $filter[h][w][d];
                                if (val > curVal) {
                                    curVal = val;
                                    hInMax = hIn;
                                    wInMax = wIn;
                                }
                            }
                        }
                    }
                    gradients[b][hInMax][wInMax][d] += $dy[b][hOut][wOut][d];
                }
            }
        }
        const dataId = cpuBackend.write((0, $wx9lK).toTypedArray(gradients, x.dtype), x.shape, x.dtype);
        return {
            dataId: dataId,
            shape: x.shape,
            dtype: x.dtype
        };
    }
};

});

parcelRegister("7XGiG", function(module, exports) {

$parcel$export(module.exports, "einsumConfig", () => $5cbedb0f44804a42$export$40bbf341885a23b7);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $h9fuR = parcelRequire("h9fuR");

var $3qzJ7 = parcelRequire("3qzJ7");

var $jPjnE = parcelRequire("jPjnE");

var $9buNR = parcelRequire("9buNR");
function $5cbedb0f44804a42$export$27265e7daac5c403(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { equation: equation } = attrs;
    const tensors = inputs;
    const { allDims: allDims, summedDims: summedDims, idDims: idDims } = (0, $lkN62).decodeEinsumEquation(equation, tensors.length);
    (0, $lkN62).checkEinsumDimSizes(allDims.length, idDims, tensors);
    const { path: path, steps: steps } = (0, $lkN62).getEinsumComputePath(summedDims, idDims);
    const nSteps = steps.length;
    let out = null;
    let numDimsRemaining = allDims.length;
    const tensorsToDispose = [];
    for(let i = 0; i < nSteps; ++i){
        for (const idTerm of steps[i]){
            const { permutationIndices: perm, expandDims: dimsToExpand } = (0, $lkN62).getEinsumPermutation(numDimsRemaining, idDims[idTerm]);
            let x;
            if ((0, $lkN62).isIdentityPermutation(perm)) x = tensors[idTerm];
            else {
                x = (0, $9buNR.transpose)({
                    inputs: {
                        x: tensors[idTerm]
                    },
                    backend: backend,
                    attrs: {
                        perm: perm
                    }
                });
                tensorsToDispose.push(x);
            }
            const targetShape = x.shape.slice();
            for(let k = 0; k < dimsToExpand.length; ++k)targetShape.splice(dimsToExpand[k], 0, 1);
            if (!(0, $wx9lK).arraysEqual(x.shape, targetShape)) {
                x = (0, $3qzJ7.reshape)({
                    inputs: {
                        x: x
                    },
                    backend: backend,
                    attrs: {
                        shape: targetShape
                    }
                });
                tensorsToDispose.push(x);
            }
            if (out === null) out = x;
            else {
                // tslint:disable-next-line: no-unnecessary-type-assertion
                out = (0, $h9fuR.multiply)({
                    inputs: {
                        a: x,
                        b: out
                    },
                    backend: backend
                });
                tensorsToDispose.push(out);
            }
        }
        if (i < nSteps - 1) {
            if (path[i] >= 0) {
                out = (0, $jPjnE.sum)({
                    inputs: {
                        x: out
                    },
                    backend: backend,
                    attrs: {
                        axis: path[i] - (allDims.length - numDimsRemaining),
                        keepDims: false
                    }
                });
                tensorsToDispose.push(out);
            }
            numDimsRemaining--;
        }
    }
    // Clean up intermediate tensors.
    for (const tensorInfo of tensorsToDispose){
        if (tensorInfo === out) continue;
        backend.disposeIntermediateTensorInfo(tensorInfo);
    }
    return out;
}
const $5cbedb0f44804a42$export$40bbf341885a23b7 = {
    kernelName: (0, $dCP8m.Einsum),
    backendName: 'cpu',
    kernelFunc: $5cbedb0f44804a42$export$27265e7daac5c403
};

});
parcelRegister("h9fuR", function(module, exports) {

$parcel$export(module.exports, "multiplyImpl", () => $c7bf4c4987c05b62$export$ac59ae2be94ddda3);
$parcel$export(module.exports, "multiply", () => $c7bf4c4987c05b62$export$2060d2db72cce88f);
$parcel$export(module.exports, "multiplyConfig", () => $c7bf4c4987c05b62$export$745576778aafee88);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $c7bf4c4987c05b62$export$ac59ae2be94ddda3 = (0, $aRRHO.createSimpleBinaryKernelImpl)((aValue, bValue)=>aValue * bValue);
const $c7bf4c4987c05b62$export$93ff634b9c7cb5b9 = (0, $3Zasd.createComplexBinaryKernelImpl)((aReal, aImag, bReal, bImag)=>{
    return {
        real: aReal * bReal - aImag * bImag,
        imag: aReal * bImag + aImag * bReal
    };
});
const $c7bf4c4987c05b62$export$2060d2db72cce88f = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.Multiply), $c7bf4c4987c05b62$export$ac59ae2be94ddda3, $c7bf4c4987c05b62$export$93ff634b9c7cb5b9);
const $c7bf4c4987c05b62$export$745576778aafee88 = {
    kernelName: (0, $dCP8m.Multiply),
    backendName: 'cpu',
    kernelFunc: $c7bf4c4987c05b62$export$2060d2db72cce88f
};

});

parcelRegister("jPjnE", function(module, exports) {

$parcel$export(module.exports, "sum", () => $e6f1d046d758ae23$export$8a63f25cc62965f1);
$parcel$export(module.exports, "sumConfig", () => $e6f1d046d758ae23$export$47edea402251c258);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $iwsxi = parcelRequire("iwsxi");

var $gSA6r = parcelRequire("gSA6r");

var $6mG8q = parcelRequire("6mG8q");

var $3qzJ7 = parcelRequire("3qzJ7");

var $9buNR = parcelRequire("9buNR");
function $e6f1d046d758ae23$export$8a63f25cc62965f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'sum');
    let $x;
    if (x.dtype === 'bool') $x = (0, $gSA6r.cast)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            dtype: 'int32'
        }
    });
    else $x = (0, $6mG8q.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const xRank = $x.shape.length;
    const axes = (0, $wx9lK).parseAxisParam(axis, $x.shape);
    const permutation = (0, $lkN62).getAxesPermutation(axes, xRank);
    let reductionAxes = axes;
    let permutedX = $x;
    if (permutation != null) {
        permutedX = (0, $9buNR.transpose)({
            inputs: {
                x: $x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        reductionAxes = (0, $lkN62).getInnerMostAxes(reductionAxes.length, xRank);
    }
    (0, $lkN62).assertAxesAreInnerMostDims('sum', reductionAxes, permutedX.shape.length);
    const [outShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes(permutedX.shape, reductionAxes);
    const resultDtype = (0, $lkN62).upcastType(permutedX.dtype, 'int32');
    let result = (0, $iwsxi.zeros)(backend, outShape, resultDtype);
    const reduceSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const vals = backend.data.get(result.dataId).values;
    const aVals = backend.data.get(permutedX.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let sum = 0;
        for(let j = 0; j < reduceSize; ++j)sum += aVals[offset + j];
        vals[i] = sum;
    }
    if (keepDims) {
        const newShape = (0, $lkN62).expandShapeToKeepDim(result.shape, axes);
        const oldResult = result;
        result = (0, $3qzJ7.reshape)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
        backend.disposeIntermediateTensorInfo(oldResult);
    }
    backend.disposeIntermediateTensorInfo($x);
    if (permutation != null) backend.disposeIntermediateTensorInfo(permutedX);
    return result;
}
const $e6f1d046d758ae23$export$47edea402251c258 = {
    kernelName: (0, $dCP8m.Sum),
    backendName: 'cpu',
    kernelFunc: $e6f1d046d758ae23$export$8a63f25cc62965f1
};

});


parcelRegister("93uTy", function(module, exports) {

$parcel$export(module.exports, "eluGradConfig", () => $697c5bf7befe5f4f$export$59bb07dd04647a1d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $697c5bf7befe5f4f$export$a346244024505ff9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { dy: dy, y: y } = inputs;
    (0, $aPHJu.assertNotComplex)([
        dy,
        y
    ], 'eluGrad');
    const resultValues = new Float32Array((0, $wx9lK).sizeFromShape(y.shape));
    const values = backend.data.get(y.dataId).values;
    const dyValues = backend.data.get(dy.dataId).values;
    for(let i = 0; i < values.length; ++i){
        const v = values[i];
        if (v >= 1) resultValues[i] = dyValues[i];
        else resultValues[i] = dyValues[i] * (v + 1);
    }
    return backend.makeTensorInfo(y.shape, 'float32', resultValues);
}
const $697c5bf7befe5f4f$export$59bb07dd04647a1d = {
    kernelName: (0, $dCP8m.EluGrad),
    backendName: 'cpu',
    kernelFunc: $697c5bf7befe5f4f$export$a346244024505ff9
};

});

parcelRegister("2nwON", function(module, exports) {

$parcel$export(module.exports, "equalImpl", () => $1bb72fc7e5ed536f$export$437b1c87795f120c);
$parcel$export(module.exports, "equal", () => $1bb72fc7e5ed536f$export$411ce8e5a71e3069);
$parcel$export(module.exports, "equalConfig", () => $1bb72fc7e5ed536f$export$3c8bc3d8ee318217);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $1bb72fc7e5ed536f$export$437b1c87795f120c = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>a === b ? 1 : 0);
const $1bb72fc7e5ed536f$export$411ce8e5a71e3069 = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.Equal), $1bb72fc7e5ed536f$export$437b1c87795f120c, null, 'bool');
const $1bb72fc7e5ed536f$export$3c8bc3d8ee318217 = {
    kernelName: (0, $dCP8m.Equal),
    backendName: 'cpu',
    kernelFunc: $1bb72fc7e5ed536f$export$411ce8e5a71e3069
};

});

parcelRegister("hFhzp", function(module, exports) {

$parcel$export(module.exports, "erfConfig", () => $cdc3e51587005e39$export$d044ffef16079bd);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $cdc3e51587005e39$var$p = (0, $lkN62).ERF_P;
const $cdc3e51587005e39$var$a1 = (0, $lkN62).ERF_A1;
const $cdc3e51587005e39$var$a2 = (0, $lkN62).ERF_A2;
const $cdc3e51587005e39$var$a3 = (0, $lkN62).ERF_A3;
const $cdc3e51587005e39$var$a4 = (0, $lkN62).ERF_A4;
const $cdc3e51587005e39$var$a5 = (0, $lkN62).ERF_A5;
const $cdc3e51587005e39$export$d3896f355fc09423 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Erf), (xi)=>{
    const sign = Math.sign(xi);
    const v = Math.abs(xi);
    const t = 1.0 / (1.0 + $cdc3e51587005e39$var$p * v);
    return sign * (1.0 - (((($cdc3e51587005e39$var$a5 * t + $cdc3e51587005e39$var$a4) * t + $cdc3e51587005e39$var$a3) * t + $cdc3e51587005e39$var$a2) * t + $cdc3e51587005e39$var$a1) * t * Math.exp(-v * v));
});
const $cdc3e51587005e39$export$d044ffef16079bd = {
    kernelName: (0, $dCP8m.Erf),
    backendName: 'cpu',
    kernelFunc: $cdc3e51587005e39$export$d3896f355fc09423
};

});

parcelRegister("1DFii", function(module, exports) {

$parcel$export(module.exports, "expImpl", () => $13197719bb920a21$export$823000b70594f385);
$parcel$export(module.exports, "exp", () => $13197719bb920a21$export$b310ec824aaee37f);
$parcel$export(module.exports, "expConfig", () => $13197719bb920a21$export$2fd7ea0fcf021f34);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $021b6 = parcelRequire("021b6");

var $lfZyz = parcelRequire("lfZyz");
const $13197719bb920a21$export$823000b70594f385 = (0, $021b6.createSimpleUnaryImpl)((xi)=>Math.exp(xi));
const $13197719bb920a21$export$b310ec824aaee37f = (0, $lfZyz.unaryKernelFuncFromImpl)((0, $dCP8m.Exp), $13197719bb920a21$export$823000b70594f385, 'float32');
const $13197719bb920a21$export$2fd7ea0fcf021f34 = {
    kernelName: (0, $dCP8m.Exp),
    backendName: 'cpu',
    kernelFunc: $13197719bb920a21$export$b310ec824aaee37f
};

});

parcelRegister("8Du0y", function(module, exports) {

$parcel$export(module.exports, "expandDims", () => $64993e30a17828a5$export$d660d8ed21f46635);
$parcel$export(module.exports, "expandDimsConfig", () => $64993e30a17828a5$export$86341ba0ce5d8e60);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $3qzJ7 = parcelRequire("3qzJ7");
function $64993e30a17828a5$export$d660d8ed21f46635(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { input: input } = inputs;
    const { dim: dim } = attrs;
    const inputRank = input.shape.length;
    const newShape = input.shape.slice();
    let $dim = dim;
    if (dim < 0) {
        // Negative value is counted from the tail of rank.
        (0, $wx9lK).assert(-(inputRank + 1) <= dim, ()=>`Axis must be in the interval [${-(inputRank + 1)}, ${inputRank}]`);
        $dim = inputRank + dim + 1;
    }
    newShape.splice($dim, 0, 1);
    return (0, $3qzJ7.reshape)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: newShape
        }
    });
}
const $64993e30a17828a5$export$86341ba0ce5d8e60 = {
    kernelName: (0, $dCP8m.ExpandDims),
    backendName: 'cpu',
    kernelFunc: $64993e30a17828a5$export$d660d8ed21f46635
};

});

parcelRegister("hyNQ9", function(module, exports) {

$parcel$export(module.exports, "expm1Impl", () => $cc8c45d95f5a0305$export$44f6c1b1ff8db911);
$parcel$export(module.exports, "expm1Config", () => $cc8c45d95f5a0305$export$16db8a08b36f938);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $021b6 = parcelRequire("021b6");

var $lfZyz = parcelRequire("lfZyz");
const $cc8c45d95f5a0305$export$44f6c1b1ff8db911 = (0, $021b6.createSimpleUnaryImpl)((xi)=>Math.expm1(xi));
const $cc8c45d95f5a0305$export$b6c0a80d46d3391d = (0, $lfZyz.unaryKernelFuncFromImpl)((0, $dCP8m.Expm1), $cc8c45d95f5a0305$export$44f6c1b1ff8db911);
const $cc8c45d95f5a0305$export$16db8a08b36f938 = {
    kernelName: (0, $dCP8m.Expm1),
    backendName: 'cpu',
    kernelFunc: $cc8c45d95f5a0305$export$b6c0a80d46d3391d
};

});

parcelRegister("kwQg5", function(module, exports) {

$parcel$export(module.exports, "fftConfig", () => $ef1f553e89722cca$export$a4d564e380763c78);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $c7efQ = parcelRequire("c7efQ");

var $3qzJ7 = parcelRequire("3qzJ7");
function $ef1f553e89722cca$export$a535ef183b6128fa(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputSize = (0, $wx9lK).sizeFromShape(input.shape);
    // Collapse all outer dimensions to a single batch dimension.
    const innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = inputSize / innerDimensionSize;
    const input2D = (0, $3qzJ7.reshape)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: [
                batch,
                innerDimensionSize
            ]
        }
    });
    const result = (0, $c7efQ.fftBatch)(input2D, false, backend);
    const resultReshaped = (0, $3qzJ7.reshape)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: input.shape
        }
    });
    backend.disposeIntermediateTensorInfo(input2D);
    backend.disposeIntermediateTensorInfo(result);
    return resultReshaped;
}
const $ef1f553e89722cca$export$a4d564e380763c78 = {
    kernelName: (0, $dCP8m.FFT),
    backendName: 'cpu',
    kernelFunc: $ef1f553e89722cca$export$a535ef183b6128fa
};

});
parcelRegister("c7efQ", function(module, exports) {

$parcel$export(module.exports, "fftBatch", () => $8d2132283a21fca3$export$3f1645f616cf26f8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $5Cfhf = parcelRequire("5Cfhf");

var $78AN7 = parcelRequire("78AN7");

var $kFVXg = parcelRequire("kFVXg");

var $6mG8q = parcelRequire("6mG8q");

var $cG2uv = parcelRequire("cG2uv");

var $h9fuR = parcelRequire("h9fuR");

var $9B72G = parcelRequire("9B72G");

var $9MYjt = parcelRequire("9MYjt");

var $fyKXa = parcelRequire("fyKXa");

var $gUzQw = parcelRequire("gUzQw");
function $8d2132283a21fca3$export$3f1645f616cf26f8(input, inverse, cpuBackend) {
    const inputShape = input.shape;
    const batch = inputShape[0];
    const innerDim = inputShape[1];
    const inputVals = cpuBackend.data.get(input.dataId);
    const real2D = inputVals.complexTensorInfos.real;
    const imag2D = inputVals.complexTensorInfos.imag;
    // Collects real and imaginary values separately.
    const resultShape = [
        batch,
        innerDim
    ];
    const resultSize = (0, $wx9lK).sizeFromShape(resultShape);
    const resultReal = (0, $wx9lK).getTypedArrayFromDType('float32', resultSize);
    const resultImag = (0, $wx9lK).getTypedArrayFromDType('float32', resultSize);
    for(let b = 0; b < batch; b++){
        // TODO: Support slice ops for complex type.
        const r = (0, $fyKXa.slice)({
            inputs: {
                x: real2D
            },
            backend: cpuBackend,
            attrs: {
                begin: [
                    b,
                    0
                ],
                size: [
                    1,
                    innerDim
                ]
            }
        });
        const i = (0, $fyKXa.slice)({
            inputs: {
                x: imag2D
            },
            backend: cpuBackend,
            attrs: {
                begin: [
                    b,
                    0
                ],
                size: [
                    1,
                    innerDim
                ]
            }
        });
        const input = (0, $78AN7.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: cpuBackend
        });
        // Run FFT by batch element.
        const { real: real, imag: imag } = $8d2132283a21fca3$export$75d3742a7578721e(input, inverse, cpuBackend);
        const res = (0, $lkN62).mergeRealAndImagArrays(real, imag);
        for(let d = 0; d < innerDim; d++){
            const c = (0, $lkN62).getComplexWithIndex(res, d);
            resultReal[b * innerDim + d] = c.real;
            resultImag[b * innerDim + d] = c.imag;
        }
        cpuBackend.disposeIntermediateTensorInfo(r);
        cpuBackend.disposeIntermediateTensorInfo(i);
        cpuBackend.disposeIntermediateTensorInfo(input);
    }
    const $realInfo = cpuBackend.makeTensorInfo(resultShape, 'float32', resultReal);
    const $imagInfo = cpuBackend.makeTensorInfo(resultShape, 'float32', resultImag);
    const result = (0, $78AN7.complex)({
        inputs: {
            real: $realInfo,
            imag: $imagInfo
        },
        backend: cpuBackend
    });
    cpuBackend.disposeIntermediateTensorInfo($realInfo);
    cpuBackend.disposeIntermediateTensorInfo($imagInfo);
    return result;
}
function $8d2132283a21fca3$export$75d3742a7578721e(input, inverse, cpuBackend) {
    const inputSize = (0, $wx9lK).sizeFromShape(input.shape);
    const inputVals = cpuBackend.data.get(input.dataId);
    const realVals = cpuBackend.data.get(inputVals.complexTensorInfos.real.dataId).values;
    const imagVals = cpuBackend.data.get(inputVals.complexTensorInfos.imag.dataId).values;
    if ($8d2132283a21fca3$var$isExponentOf2(inputSize)) {
        const result = $8d2132283a21fca3$var$fftRadix2(realVals, imagVals, inputSize, inverse, cpuBackend);
        const resultShape = [
            input.shape[0],
            input.shape[1]
        ];
        if (inverse) {
            const realInfo = cpuBackend.makeTensorInfo(resultShape, 'float32', result.real);
            const imagInfo = cpuBackend.makeTensorInfo(resultShape, 'float32', result.imag);
            const sizeInfo = cpuBackend.makeTensorInfo([], 'float32', (0, $wx9lK).createScalarValue(inputSize, 'float32'));
            const sizeInfoCopy = (0, $6mG8q.identity)({
                inputs: {
                    x: sizeInfo
                },
                backend: cpuBackend
            });
            const divRealInfo = (0, $9MYjt.realDivConfig).kernelFunc({
                inputs: {
                    a: realInfo,
                    b: sizeInfo
                },
                backend: cpuBackend
            });
            const divImagInfo = (0, $9MYjt.realDivConfig).kernelFunc({
                inputs: {
                    a: imagInfo,
                    b: sizeInfoCopy
                },
                backend: cpuBackend
            });
            const divRealVals = cpuBackend.data.get(divRealInfo.dataId).values;
            const divImagVals = cpuBackend.data.get(divImagInfo.dataId).values;
            cpuBackend.disposeIntermediateTensorInfo(realInfo);
            cpuBackend.disposeIntermediateTensorInfo(imagInfo);
            cpuBackend.disposeIntermediateTensorInfo(sizeInfo);
            cpuBackend.disposeIntermediateTensorInfo(sizeInfoCopy);
            cpuBackend.disposeIntermediateTensorInfo(divRealInfo);
            cpuBackend.disposeIntermediateTensorInfo(divImagInfo);
            return {
                real: divRealVals,
                imag: divImagVals
            };
        }
        return result;
    } else {
        const data = (0, $lkN62).mergeRealAndImagArrays(realVals, imagVals);
        const rawOutput = $8d2132283a21fca3$var$fourierTransformByMatmul(data, inputSize, inverse);
        return (0, $lkN62).splitRealAndImagArrays(rawOutput);
    }
}
function $8d2132283a21fca3$var$isExponentOf2(size) {
    return (size & size - 1) === 0;
}
// FFT using Cooley-Tukey algorithm on radix 2 dimensional input.
function $8d2132283a21fca3$var$fftRadix2(realVals, imagVals, size, inverse, cpuBackend) {
    if (size === 1) return {
        real: realVals,
        imag: imagVals
    };
    const data = (0, $lkN62).mergeRealAndImagArrays(realVals, imagVals);
    const half = size / 2;
    const evenComplex = (0, $lkN62).complexWithEvenIndex(data);
    const evenRealVals = evenComplex.real;
    const evenImagVals = evenComplex.imag;
    const evenShape = [
        evenRealVals.length
    ];
    const evenRealInfo = cpuBackend.makeTensorInfo(evenShape, 'float32', evenRealVals);
    const evenImagInfo = cpuBackend.makeTensorInfo(evenShape, 'float32', evenImagVals);
    const evenTensorInfo = (0, $78AN7.complex)({
        inputs: {
            real: evenRealInfo,
            imag: evenImagInfo
        },
        backend: cpuBackend
    });
    const oddComplex = (0, $lkN62).complexWithOddIndex(data);
    const oddRealVals = oddComplex.real;
    const oddImagVals = oddComplex.imag;
    const oddShape = [
        oddRealVals.length
    ];
    const oddRealInfo = cpuBackend.makeTensorInfo(oddShape, 'float32', oddRealVals);
    const oddImagInfo = cpuBackend.makeTensorInfo(oddShape, 'float32', oddImagVals);
    const oddTensorInfo = (0, $78AN7.complex)({
        inputs: {
            real: oddRealInfo,
            imag: oddImagInfo
        },
        backend: cpuBackend
    });
    // Recursive call for half part of original input.
    const $evenComplex = $8d2132283a21fca3$var$fftRadix2(evenRealVals, evenImagVals, half, inverse, cpuBackend);
    const $evenRealVals = $evenComplex.real;
    const $evenImagVals = $evenComplex.imag;
    const $evenShape = [
        $evenRealVals.length
    ];
    const $evenRealInfo = cpuBackend.makeTensorInfo($evenShape, 'float32', $evenRealVals);
    const $evenImagInfo = cpuBackend.makeTensorInfo($evenShape, 'float32', $evenImagVals);
    const $evenTensorInfo = (0, $78AN7.complex)({
        inputs: {
            real: $evenRealInfo,
            imag: $evenImagInfo
        },
        backend: cpuBackend
    });
    const $oddComplex = $8d2132283a21fca3$var$fftRadix2(oddRealVals, oddImagVals, half, inverse, cpuBackend);
    const $oddRealVals = $oddComplex.real;
    const $oddImagVals = $oddComplex.imag;
    const $oddShape = [
        $oddRealVals.length
    ];
    const $oddRealInfo = cpuBackend.makeTensorInfo($oddShape, 'float32', $oddRealVals);
    const $oddImagInfo = cpuBackend.makeTensorInfo($oddShape, 'float32', $oddImagVals);
    const $oddTensorInfo = (0, $78AN7.complex)({
        inputs: {
            real: $oddRealInfo,
            imag: $oddImagInfo
        },
        backend: cpuBackend
    });
    const e = (0, $lkN62).exponents(size, inverse);
    const eShape = [
        e.real.length
    ];
    const eRealInfo = cpuBackend.makeTensorInfo(eShape, 'float32', e.real);
    const eImagInfo = cpuBackend.makeTensorInfo(eShape, 'float32', e.imag);
    const complexInfo = (0, $78AN7.complex)({
        inputs: {
            real: eRealInfo,
            imag: eImagInfo
        },
        backend: cpuBackend
    });
    const exponentInfo = (0, $h9fuR.multiply)({
        inputs: {
            a: complexInfo,
            b: $oddTensorInfo
        },
        backend: cpuBackend
    });
    const addPart = (0, $5Cfhf.add)({
        inputs: {
            a: $evenTensorInfo,
            b: exponentInfo
        },
        backend: cpuBackend
    });
    const subPart = (0, $gUzQw.sub)({
        inputs: {
            a: $evenTensorInfo,
            b: exponentInfo
        },
        backend: cpuBackend
    });
    const addPartReal = (0, $9B72G.real)({
        inputs: {
            input: addPart
        },
        backend: cpuBackend
    });
    const subPartReal = (0, $9B72G.real)({
        inputs: {
            input: subPart
        },
        backend: cpuBackend
    });
    const addPartImag = (0, $cG2uv.imag)({
        inputs: {
            input: addPart
        },
        backend: cpuBackend
    });
    const subPartImag = (0, $cG2uv.imag)({
        inputs: {
            input: subPart
        },
        backend: cpuBackend
    });
    const $real = (0, $kFVXg.concat)({
        inputs: [
            addPartReal,
            subPartReal
        ],
        backend: cpuBackend,
        attrs: {
            axis: 0
        }
    });
    const $imag = (0, $kFVXg.concat)({
        inputs: [
            addPartImag,
            subPartImag
        ],
        backend: cpuBackend,
        attrs: {
            axis: 0
        }
    });
    const $realVals = cpuBackend.data.get($real.dataId).values;
    const $imagVals = cpuBackend.data.get($imag.dataId).values;
    cpuBackend.disposeIntermediateTensorInfo(evenRealInfo);
    cpuBackend.disposeIntermediateTensorInfo(evenImagInfo);
    cpuBackend.disposeIntermediateTensorInfo(evenTensorInfo);
    cpuBackend.disposeIntermediateTensorInfo(oddRealInfo);
    cpuBackend.disposeIntermediateTensorInfo(oddImagInfo);
    cpuBackend.disposeIntermediateTensorInfo(oddTensorInfo);
    cpuBackend.disposeIntermediateTensorInfo($evenRealInfo);
    cpuBackend.disposeIntermediateTensorInfo($evenImagInfo);
    cpuBackend.disposeIntermediateTensorInfo($evenTensorInfo);
    cpuBackend.disposeIntermediateTensorInfo($oddRealInfo);
    cpuBackend.disposeIntermediateTensorInfo($oddImagInfo);
    cpuBackend.disposeIntermediateTensorInfo($oddTensorInfo);
    cpuBackend.disposeIntermediateTensorInfo(eRealInfo);
    cpuBackend.disposeIntermediateTensorInfo(eImagInfo);
    cpuBackend.disposeIntermediateTensorInfo(complexInfo);
    cpuBackend.disposeIntermediateTensorInfo(exponentInfo);
    cpuBackend.disposeIntermediateTensorInfo(addPart);
    cpuBackend.disposeIntermediateTensorInfo(subPart);
    cpuBackend.disposeIntermediateTensorInfo(addPartReal);
    cpuBackend.disposeIntermediateTensorInfo(addPartImag);
    cpuBackend.disposeIntermediateTensorInfo(subPartReal);
    cpuBackend.disposeIntermediateTensorInfo(subPartImag);
    cpuBackend.disposeIntermediateTensorInfo($real);
    cpuBackend.disposeIntermediateTensorInfo($imag);
    return {
        real: $realVals,
        imag: $imagVals
    };
}
// Calculate fourier transform by multplying sinusoid matrix.
function $8d2132283a21fca3$var$fourierTransformByMatmul(data, size, inverse) {
    const ret = new Float32Array(size * 2);
    // TODO: Use matmul instead once it supports complex64 type.
    for(let r = 0; r < size; r++){
        let real = 0.0;
        let imag = 0.0;
        for(let c = 0; c < size; c++){
            const e = (0, $lkN62).exponent(r * c, size, inverse);
            const term = (0, $lkN62).getComplexWithIndex(data, c);
            real += term.real * e.real - term.imag * e.imag;
            imag += term.real * e.imag + term.imag * e.real;
        }
        if (inverse) {
            real /= size;
            imag /= size;
        }
        (0, $lkN62).assignToTypedArray(ret, real, imag, r);
    }
    return ret;
}

});
parcelRegister("9MYjt", function(module, exports) {

$parcel$export(module.exports, "div", () => $720761a72699d9b9$export$159d9494db57879b);
$parcel$export(module.exports, "realDivConfig", () => $720761a72699d9b9$export$15c5d6176b30b9a6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $720761a72699d9b9$export$967709f6160bacde = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>a / b);
const $720761a72699d9b9$export$159d9494db57879b = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.RealDiv), $720761a72699d9b9$export$967709f6160bacde);
const $720761a72699d9b9$export$15c5d6176b30b9a6 = {
    kernelName: (0, $dCP8m.RealDiv),
    backendName: 'cpu',
    kernelFunc: $720761a72699d9b9$export$159d9494db57879b
};

});

parcelRegister("gUzQw", function(module, exports) {

$parcel$export(module.exports, "subImpl", () => $c4fdae977a45543d$export$ad8defe68e22c8c1);
$parcel$export(module.exports, "sub", () => $c4fdae977a45543d$export$f93b5905241a7cca);
$parcel$export(module.exports, "subConfig", () => $c4fdae977a45543d$export$5d068476dad60c4d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $c4fdae977a45543d$export$ad8defe68e22c8c1 = (0, $aRRHO.createSimpleBinaryKernelImpl)((aValue, bValue)=>aValue - bValue);
const $c4fdae977a45543d$export$e56bd24b892e7ec5 = (0, $3Zasd.createComplexBinaryKernelImpl)((aReal, aImag, bReal, bImag)=>{
    return {
        real: aReal - bReal,
        imag: aImag - bImag
    };
});
const $c4fdae977a45543d$export$f93b5905241a7cca = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.Sub), $c4fdae977a45543d$export$ad8defe68e22c8c1, $c4fdae977a45543d$export$e56bd24b892e7ec5);
const $c4fdae977a45543d$export$5d068476dad60c4d = {
    kernelName: (0, $dCP8m.Sub),
    backendName: 'cpu',
    kernelFunc: $c4fdae977a45543d$export$f93b5905241a7cca
};

});



parcelRegister("2ttNt", function(module, exports) {

$parcel$export(module.exports, "fill", () => $1cd567433df8e549$export$9563e054e6f787fb);
$parcel$export(module.exports, "fillConfig", () => $1cd567433df8e549$export$c953bf474b2bde62);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
function $1cd567433df8e549$export$9563e054e6f787fb(args) {
    const { backend: backend, attrs: attrs } = args;
    const { shape: shape, value: value, dtype: dtype } = attrs;
    const $dtype = dtype || (0, $wx9lK).inferDtype(value);
    const values = (0, $wx9lK).getArrayFromDType($dtype, (0, $wx9lK).sizeFromShape(shape));
    $1cd567433df8e549$var$fillValues(values, value, $dtype);
    return backend.makeTensorInfo(shape, $dtype, values);
}
const $1cd567433df8e549$export$c953bf474b2bde62 = {
    kernelName: (0, $dCP8m.Fill),
    backendName: 'cpu',
    kernelFunc: $1cd567433df8e549$export$9563e054e6f787fb
};
function $1cd567433df8e549$var$fillValues(values, value, dtype) {
    if (dtype === 'string') values.fill(value);
    else values.fill(value);
}

});

parcelRegister("hBw1y", function(module, exports) {

$parcel$export(module.exports, "flipLeftRightConfig", () => $cd0ebbab5297afd8$export$c9ec83cb23304466);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
const $cd0ebbab5297afd8$export$c9ec83cb23304466 = {
    kernelName: (0, $dCP8m.FlipLeftRight),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { image: image } = inputs;
        const cpuBackend = backend;
        const output = (0, $wx9lK).getTypedArrayFromDType(image.dtype, (0, $wx9lK).sizeFromShape(image.shape));
        const [batch, imageHeight, imageWidth, numChannels] = image.shape;
        const imageVals = cpuBackend.data.get(image.dataId).values;
        for(let batchIdx = 0; batchIdx < batch; batchIdx++){
            const batchOffset = batchIdx * imageWidth * imageHeight * numChannels;
            for(let row = 0; row < imageHeight; row++){
                const rowOffset = row * (imageWidth * numChannels);
                for(let col = 0; col < imageWidth; col++){
                    const colOffset = col * numChannels;
                    for(let channel = 0; channel < numChannels; channel++){
                        const coordX = Math.round(imageWidth - col - 1);
                        const outIdx = batchOffset + rowOffset + colOffset + channel;
                        let outputValue = imageVals[outIdx];
                        // If the coordinate position falls within the image boundaries...
                        if (coordX >= 0 && coordX < imageWidth) {
                            // set the output to the image value at the coordinate position.
                            const rotatedColOffset = coordX * numChannels;
                            const imageIdx = batchOffset + rowOffset + rotatedColOffset + channel;
                            outputValue = imageVals[imageIdx];
                        }
                        output[outIdx] = outputValue;
                    }
                }
            }
        }
        const dataId = cpuBackend.write(output, image.shape, image.dtype);
        return {
            dataId: dataId,
            shape: image.shape,
            dtype: image.dtype
        };
    }
};

});

parcelRegister("aWTGU", function(module, exports) {

$parcel$export(module.exports, "floorImpl", () => $7f8a8544937737eb$export$c365361068e97c87);
$parcel$export(module.exports, "floorConfig", () => $7f8a8544937737eb$export$7e9a0f96fa6bd01c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $021b6 = parcelRequire("021b6");

var $lfZyz = parcelRequire("lfZyz");
const $7f8a8544937737eb$export$c365361068e97c87 = (0, $021b6.createSimpleUnaryImpl)((xi)=>Math.floor(xi));
const $7f8a8544937737eb$export$a3fe094919f356fd = (0, $lfZyz.unaryKernelFuncFromImpl)((0, $dCP8m.Floor), $7f8a8544937737eb$export$c365361068e97c87);
const $7f8a8544937737eb$export$7e9a0f96fa6bd01c = {
    kernelName: (0, $dCP8m.Floor),
    backendName: 'cpu',
    kernelFunc: $7f8a8544937737eb$export$a3fe094919f356fd
};

});

parcelRegister("jLAh1", function(module, exports) {

$parcel$export(module.exports, "floorDivConfig", () => $e63e8b47040e36ed$export$7eac933a0c7fd37f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $e63e8b47040e36ed$export$9b7f64e28e98c78e = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>Math.floor(a / b));
const $e63e8b47040e36ed$export$112397bc52715a8 = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.FloorDiv), $e63e8b47040e36ed$export$9b7f64e28e98c78e, null, 'int32');
const $e63e8b47040e36ed$export$7eac933a0c7fd37f = {
    kernelName: (0, $dCP8m.FloorDiv),
    backendName: 'cpu',
    kernelFunc: $e63e8b47040e36ed$export$112397bc52715a8
};

});

parcelRegister("6IVrx", function(module, exports) {

$parcel$export(module.exports, "fusedConv2DConfig", () => $4e536928f88a62e5$export$5b64efa829ddf94e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $5jh5u = parcelRequire("5jh5u");

var $5Cfhf = parcelRequire("5Cfhf");

var $6dsRw = parcelRequire("6dsRw");

var $3qzJ7 = parcelRequire("3qzJ7");
function $4e536928f88a62e5$export$8db45c19fd28b6b8(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    let result = (0, $6dsRw.conv2D)({
        inputs: {
            x: x,
            filter: filter
        },
        backend: backend,
        attrs: {
            strides: strides,
            pad: pad,
            dataFormat: dataFormat,
            dilations: dilations,
            dimRoundingMode: dimRoundingMode
        }
    });
    if (bias) {
        const resultOld = result;
        // For NCHW format, if bias is a 1-D tensor, it is supposed to be aligned
        // to the channel of the conv2d's result; if the bias is a scalar, the
        // bias_add is computed as if the bias was broadcasted to the shape of the
        // conv2d's result.
        if (dataFormat === 'NCHW' && bias.shape.length === 1 && bias.shape[0] !== 1) {
            const reshapedBias = (0, $3qzJ7.reshape)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: [
                        bias.shape[0],
                        1,
                        1
                    ]
                }
            });
            result = (0, $5Cfhf.add)({
                inputs: {
                    a: result,
                    b: reshapedBias
                },
                backend: backend
            });
            backend.disposeIntermediateTensorInfo(reshapedBias);
        } else // This condition handles NHWC and NCHW (scalar case). The only other case
        // for NCHW (1D case) is handled above.
        result = (0, $5Cfhf.add)({
            inputs: {
                a: result,
                b: bias
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(resultOld);
    }
    if (activation) {
        const resultOld = result;
        // For NCHW format, if PReLu activation weights is a 1-D tensor, it is
        // supposed to be aligned with the channel of the conv2d's result. For other
        // cases, whether NCHW or NHWC data format, the conv2d result is
        // already aligned with the activation weights.
        if (dataFormat === 'NCHW' && activation === 'prelu' && preluActivationWeights.shape.length === 1 && preluActivationWeights.shape[0] !== 1) {
            const reshapedAlpha = (0, $3qzJ7.reshape)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: [
                        preluActivationWeights.shape[0],
                        1,
                        1
                    ]
                }
            });
            result = (0, $5jh5u.applyActivation)(backend, result, activation, reshapedAlpha, leakyreluAlpha);
            backend.disposeIntermediateTensorInfo(reshapedAlpha);
        } else result = (0, $5jh5u.applyActivation)(backend, result, activation, preluActivationWeights, leakyreluAlpha);
        backend.disposeIntermediateTensorInfo(resultOld);
    }
    return result;
}
const $4e536928f88a62e5$export$5b64efa829ddf94e = {
    kernelName: (0, $dCP8m.FusedConv2D),
    backendName: 'cpu',
    kernelFunc: $4e536928f88a62e5$export$8db45c19fd28b6b8
};

});

parcelRegister("afIPx", function(module, exports) {

$parcel$export(module.exports, "fusedDepthwiseConv2DConfig", () => $776e146f117af33e$export$58481cc3409b412c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $5jh5u = parcelRequire("5jh5u");

var $5Cfhf = parcelRequire("5Cfhf");

var $eUWGR = parcelRequire("eUWGR");
function $776e146f117af33e$export$d61de7729228094b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    let result = (0, $eUWGR.depthwiseConv2dNative)({
        inputs: {
            x: x,
            filter: filter
        },
        backend: backend,
        attrs: {
            strides: strides,
            pad: pad,
            dataFormat: dataFormat,
            dilations: dilations,
            dimRoundingMode: dimRoundingMode
        }
    });
    if (bias) {
        const oldResult = result;
        result = (0, $5Cfhf.add)({
            inputs: {
                a: result,
                b: bias
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(oldResult);
    }
    if (activation) {
        const oldResult = result;
        result = (0, $5jh5u.applyActivation)(backend, result, activation, preluActivationWeights, leakyreluAlpha);
        backend.disposeIntermediateTensorInfo(oldResult);
    }
    return result;
}
const $776e146f117af33e$export$58481cc3409b412c = {
    kernelName: (0, $dCP8m.FusedDepthwiseConv2D),
    backendName: 'cpu',
    kernelFunc: $776e146f117af33e$export$d61de7729228094b
};

});

parcelRegister("42Zfk", function(module, exports) {

$parcel$export(module.exports, "gatherNdConfig", () => $2f26db8f76665b3d$export$d9700eb1c7f5c969);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $2aDKt = parcelRequire("2aDKt");
function $2f26db8f76665b3d$export$3c586830e482d2b9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { params: params, indices: indices } = inputs;
    const paramsSize = (0, $wx9lK).sizeFromShape(params.shape);
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    const [resultShape, numSlices, sliceSize, strides] = (0, $lkN62).prepareAndValidate(params, indices);
    if (numSlices === 0) return backend.makeTensorInfo(resultShape, params.dtype, []);
    const indicesData = backend.data.get(indices.dataId).values;
    const paramsBuf = backend.bufferSync(params);
    const outBuf = (0, $2aDKt.gatherNdImpl)(indicesData, paramsBuf, params.dtype, numSlices, sliceRank, sliceSize, strides, params.shape, paramsSize);
    return backend.makeTensorInfo(resultShape, params.dtype, outBuf.values);
}
const $2f26db8f76665b3d$export$d9700eb1c7f5c969 = {
    kernelName: (0, $dCP8m.GatherNd),
    backendName: 'cpu',
    kernelFunc: $2f26db8f76665b3d$export$3c586830e482d2b9
};

});
parcelRegister("2aDKt", function(module, exports) {

$parcel$export(module.exports, "gatherNdImpl", () => $194b592d7f7fb6fc$export$eed1912b07a3c4d5);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $g81BN = parcelRequire("g81BN");
function $194b592d7f7fb6fc$export$eed1912b07a3c4d5(indicesData, paramsBuf, dtype, numSlices, sliceRank, sliceSize, strides, paramsShape, paramsSize) {
    const outBuf = (0, $g81BN.buffer)([
        numSlices,
        sliceSize
    ], dtype);
    for(let i = 0; i < numSlices; i++){
        const index = [];
        let flattenIndex = 0;
        for(let j = 0; j < sliceRank; j++){
            const dim = indicesData[i * sliceRank + j];
            flattenIndex += dim * strides[j];
            index.push(dim);
        }
        if (flattenIndex < 0 || flattenIndex >= paramsSize / sliceSize) throw new Error(`Invalid indices: ${index} does not index into ${paramsShape}`);
        for(let k = 0; k < sliceSize; k++)outBuf.values[i * sliceSize + k] = paramsBuf.get(...paramsBuf.indexToLoc(flattenIndex * sliceSize + k));
    }
    return outBuf;
}

});


parcelRegister("ejUqf", function(module, exports) {

$parcel$export(module.exports, "gatherV2Config", () => $a6ce9b5b4f4f0c59$export$b1bd3139c91d8765);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $bXTQe = parcelRequire("bXTQe");

var $3qzJ7 = parcelRequire("3qzJ7");
function $a6ce9b5b4f4f0c59$export$3d75b4295ded9925(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, indices: indices } = inputs;
    const { axis: axis, batchDims: batchDims } = attrs;
    (0, $aPHJu.assertNotComplex)([
        x,
        indices
    ], 'gatherV2');
    // Throw error when any index is out of bound.
    const parsedAxis = (0, $wx9lK).parseAxisParam(axis, x.shape)[0];
    const indicesVals = backend.data.get(indices.dataId).values;
    const axisDim = x.shape[parsedAxis];
    for(let i = 0; i < indicesVals.length; ++i){
        const index = indicesVals[i];
        (0, $wx9lK).assert(index <= axisDim - 1 && index >= 0, ()=>`GatherV2: the index value ${index} is not in [0, ${axisDim - 1}]`);
    }
    let $batchDims = batchDims;
    if (batchDims == null) $batchDims = 0;
    const indicesSize = (0, $wx9lK).sizeFromShape(indices.shape);
    const shapeInfo = (0, $lkN62).segment_util.collectGatherOpShapeInfo(x, indices, parsedAxis, $batchDims);
    const flattenX = (0, $3qzJ7.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                shapeInfo.outerSize,
                shapeInfo.dimSize,
                shapeInfo.sliceSize
            ]
        }
    });
    const flattenIndex = (0, $3qzJ7.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                indicesSize / shapeInfo.batchSize
            ]
        }
    });
    const flattenOutputShape = [
        shapeInfo.batchSize,
        shapeInfo.outerSize,
        indicesSize / shapeInfo.batchSize,
        shapeInfo.sliceSize
    ];
    const indicesBuf = backend.bufferSync(flattenIndex);
    const xBuf = backend.bufferSync(flattenX);
    const outBuf = (0, $bXTQe.gatherV2Impl)(xBuf, indicesBuf, flattenOutputShape);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(flattenIndex);
    return backend.makeTensorInfo(shapeInfo.outputShape, outBuf.dtype, outBuf.values);
}
const $a6ce9b5b4f4f0c59$export$b1bd3139c91d8765 = {
    kernelName: (0, $dCP8m.GatherV2),
    backendName: 'cpu',
    kernelFunc: $a6ce9b5b4f4f0c59$export$3d75b4295ded9925
};

});
parcelRegister("bXTQe", function(module, exports) {

$parcel$export(module.exports, "gatherV2Impl", () => $8b608559d27f0ae2$export$d7b732f2e62ccc09);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $g81BN = parcelRequire("g81BN");
function $8b608559d27f0ae2$export$d7b732f2e62ccc09(xBuf, indicesBuf, flattenOutputShape) {
    const outBuf = (0, $g81BN.buffer)(flattenOutputShape, xBuf.dtype);
    for(let i = 0; i < outBuf.size; ++i){
        const newLoc = outBuf.indexToLoc(i);
        const originalLoc = newLoc.slice();
        const batchIdx = originalLoc[0];
        const indicesIdx = originalLoc[2];
        const indicesIndex = indicesBuf.locToIndex([
            batchIdx,
            indicesIdx
        ]);
        originalLoc[2] = indicesBuf.values[indicesIndex];
        const originalIndex = xBuf.locToIndex(originalLoc);
        if (0 <= originalIndex && originalIndex < xBuf.values.length) outBuf.values[i] = xBuf.values[originalIndex];
         // Else, index is out of bounds, so leave the default zero val in outBuf.
    }
    return outBuf;
}

});


parcelRegister("3tNXZ", function(module, exports) {

$parcel$export(module.exports, "greaterImpl", () => $288ad6dbc5603fcc$export$bec57aa1d63b78bc);
$parcel$export(module.exports, "greaterConfig", () => $288ad6dbc5603fcc$export$8c4f7e92d92310f8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $288ad6dbc5603fcc$export$bec57aa1d63b78bc = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>a > b ? 1 : 0);
const $288ad6dbc5603fcc$export$9dca161faaf6308b = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.Greater), $288ad6dbc5603fcc$export$bec57aa1d63b78bc, null, 'bool');
const $288ad6dbc5603fcc$export$8c4f7e92d92310f8 = {
    kernelName: (0, $dCP8m.Greater),
    backendName: 'cpu',
    kernelFunc: $288ad6dbc5603fcc$export$9dca161faaf6308b
};

});

parcelRegister("liIvF", function(module, exports) {

$parcel$export(module.exports, "greaterEqualImpl", () => $f81dce1e7a6b3ff6$export$3cea60aeb61ae586);
$parcel$export(module.exports, "greaterEqualConfig", () => $f81dce1e7a6b3ff6$export$7a6926f9fcac24ca);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $f81dce1e7a6b3ff6$export$3cea60aeb61ae586 = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>a >= b ? 1 : 0);
const $f81dce1e7a6b3ff6$export$c2fd4164cadc1fa2 = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.GreaterEqual), $f81dce1e7a6b3ff6$export$3cea60aeb61ae586, null, 'bool');
const $f81dce1e7a6b3ff6$export$7a6926f9fcac24ca = {
    kernelName: (0, $dCP8m.GreaterEqual),
    backendName: 'cpu',
    kernelFunc: $f81dce1e7a6b3ff6$export$c2fd4164cadc1fa2
};

});

parcelRegister("2W9O3", function(module, exports) {

$parcel$export(module.exports, "ifftConfig", () => $22389adc13cc3adf$export$dc267425bf21b465);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $c7efQ = parcelRequire("c7efQ");

var $3qzJ7 = parcelRequire("3qzJ7");
function $22389adc13cc3adf$export$776649b0bf8ce1fd(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputSize = (0, $wx9lK).sizeFromShape(input.shape);
    // Collapse all outer dimensions to a single batch dimension.
    const innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = inputSize / innerDimensionSize;
    const input2D = (0, $3qzJ7.reshape)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: [
                batch,
                innerDimensionSize
            ]
        }
    });
    const result = (0, $c7efQ.fftBatch)(input2D, true, backend);
    const resultReshaped = (0, $3qzJ7.reshape)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: input.shape
        }
    });
    backend.disposeIntermediateTensorInfo(input2D);
    backend.disposeIntermediateTensorInfo(result);
    return resultReshaped;
}
const $22389adc13cc3adf$export$dc267425bf21b465 = {
    kernelName: (0, $dCP8m.IFFT),
    backendName: 'cpu',
    kernelFunc: $22389adc13cc3adf$export$776649b0bf8ce1fd
};

});

parcelRegister("kEFa4", function(module, exports) {

$parcel$export(module.exports, "isFiniteConfig", () => $f09778e14dd7d3eb$export$4d45c8f7b9ffdaf1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $f09778e14dd7d3eb$export$65f0b13f2f82375a = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.IsFinite), (xi)=>Number.isFinite(xi) ? 1 : 0, 'bool');
const $f09778e14dd7d3eb$export$4d45c8f7b9ffdaf1 = {
    kernelName: (0, $dCP8m.IsFinite),
    backendName: 'cpu',
    kernelFunc: $f09778e14dd7d3eb$export$65f0b13f2f82375a
};

});

parcelRegister("rz1Ey", function(module, exports) {

$parcel$export(module.exports, "isInfConfig", () => $052db11932c97f69$export$bc383b82282e9b5a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $052db11932c97f69$export$e5d3415c656f7096 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.IsInf), (xi)=>Math.abs(xi) === Infinity ? 1 : 0, 'bool');
const $052db11932c97f69$export$bc383b82282e9b5a = {
    kernelName: (0, $dCP8m.IsInf),
    backendName: 'cpu',
    kernelFunc: $052db11932c97f69$export$e5d3415c656f7096
};

});

parcelRegister("1fhiF", function(module, exports) {

$parcel$export(module.exports, "isNaNConfig", () => $0e849c9b2c69d0a4$export$d58ff790c765c1f0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $0e849c9b2c69d0a4$export$c9f5652083b8129d = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.IsNan), (xi)=>Number.isNaN(xi) ? 1 : 0, 'bool');
const $0e849c9b2c69d0a4$export$d58ff790c765c1f0 = {
    kernelName: (0, $dCP8m.IsNan),
    backendName: 'cpu',
    kernelFunc: $0e849c9b2c69d0a4$export$c9f5652083b8129d
};

});

parcelRegister("lDTkj", function(module, exports) {

$parcel$export(module.exports, "lessImpl", () => $fc1828366fb9ab93$export$d4d22ddbe6cd91a5);
$parcel$export(module.exports, "lessConfig", () => $fc1828366fb9ab93$export$8d4530ce8b6ffc3c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $fc1828366fb9ab93$export$d4d22ddbe6cd91a5 = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>a < b ? 1 : 0);
const $fc1828366fb9ab93$export$bb1a638da8ad190f = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.Less), $fc1828366fb9ab93$export$d4d22ddbe6cd91a5, null, 'bool');
const $fc1828366fb9ab93$export$8d4530ce8b6ffc3c = {
    kernelName: (0, $dCP8m.Less),
    backendName: 'cpu',
    kernelFunc: $fc1828366fb9ab93$export$bb1a638da8ad190f
};

});

parcelRegister("4aSq5", function(module, exports) {

$parcel$export(module.exports, "lessEqualImpl", () => $30a24f396b2e7314$export$27397851733876fa);
$parcel$export(module.exports, "lessEqualConfig", () => $30a24f396b2e7314$export$9f26bd257393dd8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $30a24f396b2e7314$export$27397851733876fa = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>a <= b ? 1 : 0);
const $30a24f396b2e7314$export$c24ad19a692bb92 = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.LessEqual), $30a24f396b2e7314$export$27397851733876fa, null, 'bool');
const $30a24f396b2e7314$export$9f26bd257393dd8 = {
    kernelName: (0, $dCP8m.LessEqual),
    backendName: 'cpu',
    kernelFunc: $30a24f396b2e7314$export$c24ad19a692bb92
};

});

parcelRegister("4TVnY", function(module, exports) {

$parcel$export(module.exports, "linSpaceConfig", () => $3918d011593e150b$export$46b96f742c70959b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $ebjt0 = parcelRequire("ebjt0");
function $3918d011593e150b$export$865a19adce4d7a46(args) {
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, num: num } = attrs;
    const outVals = (0, $ebjt0.linSpaceImpl)(start, stop, num);
    return backend.makeTensorInfo([
        outVals.length
    ], 'float32', outVals);
}
const $3918d011593e150b$export$46b96f742c70959b = {
    kernelName: (0, $dCP8m.LinSpace),
    backendName: 'cpu',
    kernelFunc: $3918d011593e150b$export$865a19adce4d7a46
};

});
parcelRegister("ebjt0", function(module, exports) {

$parcel$export(module.exports, "linSpaceImpl", () => $a531317ebf3f97e6$export$31412d657cd1cc08);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
function $a531317ebf3f97e6$export$31412d657cd1cc08(start, stop, num) {
    const step = (stop - start) / (num - 1);
    const values = (0, $wx9lK).makeZerosTypedArray(num, 'float32');
    values[0] = start;
    for(let i = 1; i < values.length; i++)values[i] = values[i - 1] + step;
    return values;
}

});


parcelRegister("5uPRc", function(module, exports) {

$parcel$export(module.exports, "logImpl", () => $4007fad420b3fd28$export$8a107ec4d5b0e907);
$parcel$export(module.exports, "logConfig", () => $4007fad420b3fd28$export$a4ae1f00643ddd14);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $021b6 = parcelRequire("021b6");

var $lfZyz = parcelRequire("lfZyz");
const $4007fad420b3fd28$export$8a107ec4d5b0e907 = (0, $021b6.createSimpleUnaryImpl)((xi)=>Math.log(xi));
const $4007fad420b3fd28$export$bef1f36f5486a6a3 = (0, $lfZyz.unaryKernelFuncFromImpl)((0, $dCP8m.Log), $4007fad420b3fd28$export$8a107ec4d5b0e907);
const $4007fad420b3fd28$export$a4ae1f00643ddd14 = {
    kernelName: (0, $dCP8m.Log),
    backendName: 'cpu',
    kernelFunc: $4007fad420b3fd28$export$bef1f36f5486a6a3
};

});

parcelRegister("l3uQk", function(module, exports) {

$parcel$export(module.exports, "log1pConfig", () => $f541cd955fd31571$export$c458b9e5ba980198);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $f541cd955fd31571$export$144dcf16adfb9698 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Log1p), (xi)=>Math.log1p(xi));
const $f541cd955fd31571$export$c458b9e5ba980198 = {
    kernelName: (0, $dCP8m.Log1p),
    backendName: 'cpu',
    kernelFunc: $f541cd955fd31571$export$144dcf16adfb9698
};

});

parcelRegister("S038D", function(module, exports) {

$parcel$export(module.exports, "logicalAndConfig", () => $0a25151d03dd2940$export$257f1e82e69113fb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $0a25151d03dd2940$export$e75adbe8a6aa8c40 = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>a && b);
const $0a25151d03dd2940$export$db5dd0ef9d505f = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.LogicalAnd), $0a25151d03dd2940$export$e75adbe8a6aa8c40, null, 'bool');
const $0a25151d03dd2940$export$257f1e82e69113fb = {
    kernelName: (0, $dCP8m.LogicalAnd),
    backendName: 'cpu',
    kernelFunc: $0a25151d03dd2940$export$db5dd0ef9d505f
};

});

parcelRegister("93IXG", function(module, exports) {

$parcel$export(module.exports, "logicalNotConfig", () => $6987454a6cb0a983$export$68e2dd0840056271);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $6987454a6cb0a983$export$c836ff7b605b1617 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.LogicalNot), (xi)=>xi ? 0 : 1, 'bool');
const $6987454a6cb0a983$export$68e2dd0840056271 = {
    kernelName: (0, $dCP8m.LogicalNot),
    backendName: 'cpu',
    kernelFunc: $6987454a6cb0a983$export$c836ff7b605b1617
};

});

parcelRegister("j6Gq4", function(module, exports) {

$parcel$export(module.exports, "logicalOrConfig", () => $de8f7b7fa0099538$export$ce04b6546987ef43);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $de8f7b7fa0099538$export$9b10f32fda33cd6f = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>a || b);
const $de8f7b7fa0099538$export$e2a73975983cadd8 = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.LogicalOr), $de8f7b7fa0099538$export$9b10f32fda33cd6f, null, 'bool');
const $de8f7b7fa0099538$export$ce04b6546987ef43 = {
    kernelName: (0, $dCP8m.LogicalOr),
    backendName: 'cpu',
    kernelFunc: $de8f7b7fa0099538$export$e2a73975983cadd8
};

});

parcelRegister("3vGxY", function(module, exports) {

$parcel$export(module.exports, "LRNConfig", () => $28e545483a8649d7$export$6fb124d5a6994734);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $28e545483a8649d7$export$ac78e832c121c629(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'LRN');
    const channels = x.shape[3];
    const maxD = channels - 1;
    const xValues = backend.data.get(x.dataId).values;
    const size = (0, $wx9lK).sizeFromShape(x.shape);
    const result = new Float32Array(size);
    function sumAcrossChannels(offset) {
        const currentChannel = offset % channels;
        let beginSumOffset = offset - currentChannel + Math.max(0, currentChannel - depthRadius);
        const endSumOffset = offset - currentChannel + Math.min(currentChannel + depthRadius, maxD);
        let sum = 0.0;
        for(; beginSumOffset <= endSumOffset; beginSumOffset++){
            const z = xValues[beginSumOffset];
            sum += z * z;
        }
        return sum;
    }
    for(let offset = 0; offset < size; offset++){
        const sum = sumAcrossChannels(offset);
        const val = xValues[offset] * Math.pow(bias + alpha * sum, -beta);
        result[offset] = val;
    }
    return backend.makeTensorInfo(x.shape, x.dtype, result);
}
const $28e545483a8649d7$export$6fb124d5a6994734 = {
    kernelName: (0, $dCP8m.LRN),
    backendName: 'cpu',
    kernelFunc: $28e545483a8649d7$export$ac78e832c121c629
};

});

parcelRegister("5vZME", function(module, exports) {

$parcel$export(module.exports, "LRNGradConfig", () => $403fc5f4a11cdd1d$export$99a62fc039d7aca0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $403fc5f4a11cdd1d$export$c4c981cfebdcf90(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, y: y, dy: dy } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    (0, $aPHJu.assertNotComplex)(dy, 'LRNGrad');
    const dySize = (0, $wx9lK).sizeFromShape(dy.shape);
    const channels = dy.shape[3];
    const dyValues = backend.data.get(dy.dataId).values;
    const xValues = backend.data.get(x.dataId).values;
    const yValues = backend.data.get(y.dataId).values;
    const result = new Float32Array(dySize);
    const size = dySize;
    for(let offset = 0; offset < size; offset++){
        const currentChannel = offset % channels;
        const depthBegin = offset - currentChannel + Math.max(0, currentChannel - depthRadius);
        const depthEnd = offset - currentChannel + Math.min(channels, currentChannel + depthRadius + 1);
        let norm = 0;
        for(let k = depthBegin; k < depthEnd; k++)norm += Math.pow(xValues[k], 2);
        norm = alpha * norm + bias;
        for(let k = depthBegin; k < depthEnd; k++){
            let dyi = -2 * alpha * beta * xValues[k] * yValues[offset] / norm;
            if (offset === k) dyi += Math.pow(norm, -beta);
            dyi *= dyValues[offset];
            result[k] += dyi;
        }
    }
    return backend.makeTensorInfo(dy.shape, x.dtype, result);
}
const $403fc5f4a11cdd1d$export$99a62fc039d7aca0 = {
    kernelName: (0, $dCP8m.LRNGrad),
    backendName: 'cpu',
    kernelFunc: $403fc5f4a11cdd1d$export$c4c981cfebdcf90
};

});

parcelRegister("lPDl4", function(module, exports) {

$parcel$export(module.exports, "max", () => $fe4ce03ee37a2381$export$8960430cfd85939f);
$parcel$export(module.exports, "maxConfig", () => $fe4ce03ee37a2381$export$7d79147246e312bb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $4f6RY = parcelRequire("4f6RY");

var $4SJWC = parcelRequire("4SJWC");
function $fe4ce03ee37a2381$export$8960430cfd85939f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { reductionIndices: reductionIndices, keepDims: keepDims } = attrs;
    const cpuBackend = backend;
    let xShape = x.shape;
    const xRank = xShape.length;
    const origAxes = (0, $wx9lK).parseAxisParam(reductionIndices, xShape);
    let axes = origAxes;
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, xRank);
    let xVals = cpuBackend.data.get(x.dataId).values;
    if (permutedAxes != null) {
        const newShape = new Array(xRank);
        for(let i = 0; i < newShape.length; i++)newShape[i] = xShape[permutedAxes[i]];
        xVals = (0, $4SJWC.transposeImpl)(xVals, xShape, x.dtype, permutedAxes, newShape);
        axes = (0, $lkN62).getInnerMostAxes(axes.length, xRank);
        xShape = newShape;
    }
    (0, $aPHJu.assertNotComplex)(x, 'max');
    (0, $lkN62).assertAxesAreInnerMostDims('max', axes, xRank);
    const [maxOutShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes(xShape, axes);
    const reduceSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const result = (0, $4f6RY.maxImpl)(xVals, reduceSize, maxOutShape, x.dtype);
    const dataId = cpuBackend.write(result, maxOutShape, x.dtype);
    let outShape = maxOutShape;
    if (keepDims) {
        // reshape
        const newShape = (0, $lkN62).expandShapeToKeepDim(maxOutShape, origAxes);
        outShape = newShape;
    }
    return {
        dataId: dataId,
        shape: outShape,
        dtype: x.dtype
    };
}
const $fe4ce03ee37a2381$export$7d79147246e312bb = {
    kernelName: (0, $dCP8m.Max),
    backendName: 'cpu',
    kernelFunc: $fe4ce03ee37a2381$export$8960430cfd85939f
};

});
parcelRegister("4f6RY", function(module, exports) {

$parcel$export(module.exports, "maxImpl", () => $316de4442fe8b228$export$23c9b99bdac85be0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
function $316de4442fe8b228$export$23c9b99bdac85be0(aVals, reduceSize, outShape, dtype) {
    const vals = (0, $wx9lK).getTypedArrayFromDType(dtype, (0, $wx9lK).sizeFromShape(outShape));
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let max = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (Number.isNaN(value) || value > max) max = value;
        }
        vals[i] = max;
    }
    return vals;
}

});


parcelRegister("3q5fk", function(module, exports) {

$parcel$export(module.exports, "maximumImpl", () => $27d7de93f74d6f90$export$4e233ba825c9b60e);
$parcel$export(module.exports, "maximumConfig", () => $27d7de93f74d6f90$export$45b97bdc342e72a2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $27d7de93f74d6f90$export$4e233ba825c9b60e = (0, $aRRHO.createSimpleBinaryKernelImpl)((aValue, bValue)=>Math.max(aValue, bValue));
const $27d7de93f74d6f90$export$b25e0be55f42c9a = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.Maximum), $27d7de93f74d6f90$export$4e233ba825c9b60e);
const $27d7de93f74d6f90$export$45b97bdc342e72a2 = {
    kernelName: (0, $dCP8m.Maximum),
    backendName: 'cpu',
    kernelFunc: $27d7de93f74d6f90$export$b25e0be55f42c9a
};

});

parcelRegister("ecrNM", function(module, exports) {

$parcel$export(module.exports, "maxPoolConfig", () => $a567c08bb550c3cf$export$45c8263b38f19e33);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $8by9c = parcelRequire("8by9c");

var $6mG8q = parcelRequire("6mG8q");
function $a567c08bb550c3cf$export$e4aadcf115842782(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $aPHJu.assertNotComplex)(x, 'maxPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $wx9lK).assert((0, $lkN62).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $lkN62).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    let res;
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $wx9lK).arraysEqual(convInfo.inShape, convInfo.outShape)) res = (0, $6mG8q.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else {
        const xValues = backend.data.get(x.dataId).values;
        const strides = (0, $wx9lK).computeStrides(x.shape);
        const buffer = (0, $8by9c.pool)(xValues, x.shape, x.dtype, strides, convInfo, 'max');
        res = backend.makeTensorInfo(convInfo.outShape, x.dtype, buffer.values);
    }
    return res;
}
const $a567c08bb550c3cf$export$45c8263b38f19e33 = {
    kernelName: (0, $dCP8m.MaxPool),
    backendName: 'cpu',
    kernelFunc: $a567c08bb550c3cf$export$e4aadcf115842782
};

});

parcelRegister("d4iYA", function(module, exports) {

$parcel$export(module.exports, "maxPool3DConfig", () => $983a5e5640d88a48$export$91a8fc5da39ec855);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $8by9c = parcelRequire("8by9c");
function $983a5e5640d88a48$export$bf5a4705068838e7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode, dataFormat: dataFormat } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'maxPool3d');
    const convInfo = (0, $lkN62).computePool3DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode, dataFormat);
    const xValues = backend.data.get(x.dataId).values;
    const outBuf = (0, $8by9c.pool3d)(xValues, x.shape, x.dtype, (0, $wx9lK).computeStrides(x.shape), convInfo, 'max');
    return backend.makeTensorInfo(outBuf.shape, 'float32', outBuf.values);
}
const $983a5e5640d88a48$export$91a8fc5da39ec855 = {
    kernelName: (0, $dCP8m.MaxPool3D),
    backendName: 'cpu',
    kernelFunc: $983a5e5640d88a48$export$bf5a4705068838e7
};

});

parcelRegister("6CJS2", function(module, exports) {

$parcel$export(module.exports, "maxPool3DGradConfig", () => $4d29df9c0529088b$export$5201426bb10bd5eb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $g81BN = parcelRequire("g81BN");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");

var $8by9c = parcelRequire("8by9c");
function $4d29df9c0529088b$export$e68b9bef571dd4ea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $aPHJu.assertNotComplex)([
        dy,
        input
    ], 'maxPool3DGrad');
    const convInfo = (0, $lkN62).computePool3DInfo(input.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const inputBuf = backend.bufferSync(input);
    const maxPosBuf = (0, $8by9c.maxPool3dPositions)(inputBuf, convInfo);
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const dx = (0, $g81BN.buffer)(input.shape, 'float32');
    const dyBuf = backend.bufferSync(dy);
    for(let batch = 0; batch < convInfo.batchSize; ++batch){
        for(let channel = 0; channel < convInfo.inChannels; ++channel)for(let dxDepth = 0; dxDepth < convInfo.inDepth; ++dxDepth){
            for(let dxRow = 0; dxRow < convInfo.inHeight; ++dxRow)for(let dxCol = 0; dxCol < convInfo.inWidth; ++dxCol){
                // Shader code begins
                const dyDepthCorner = dxDepth - padFront;
                const dyRowCorner = dxRow - padTop;
                const dyColCorner = dxCol - padLeft;
                let dotProd = 0;
                for(let wDepth = 0; wDepth < effectiveFilterDepth; wDepth += dilationDepth){
                    const dyDepth = (dyDepthCorner + wDepth) / strideDepth;
                    if (dyDepth < 0 || dyDepth >= convInfo.outDepth || Math.floor(dyDepth) !== dyDepth) continue;
                    for(let wRow = 0; wRow < effectiveFilterHeight; wRow += dilationHeight){
                        const dyRow = (dyRowCorner + wRow) / strideHeight;
                        if (dyRow < 0 || dyRow >= convInfo.outHeight || Math.floor(dyRow) !== dyRow) continue;
                        for(let wCol = 0; wCol < effectiveFilterWidth; wCol += dilationWidth){
                            const dyCol = (dyColCorner + wCol) / strideWidth;
                            if (dyCol < 0 || dyCol >= convInfo.outWidth || Math.floor(dyCol) !== dyCol) continue;
                            const maxPos = effectiveFilterDepth * effectiveFilterHeight * effectiveFilterWidth - 1 - maxPosBuf.get(batch, dyDepth, dyRow, dyCol, channel);
                            const curPos = wDepth * effectiveFilterHeight * effectiveFilterWidth + wRow * effectiveFilterWidth + wCol;
                            const mask = maxPos === curPos ? 1 : 0;
                            if (mask === 0) continue;
                            const pixel = dyBuf.get(batch, dyDepth, dyRow, dyCol, channel);
                            dotProd += pixel * mask;
                        }
                    }
                }
                dx.set(dotProd, batch, dxDepth, dxRow, dxCol, channel);
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $4d29df9c0529088b$export$5201426bb10bd5eb = {
    kernelName: (0, $dCP8m.MaxPool3DGrad),
    backendName: 'cpu',
    kernelFunc: $4d29df9c0529088b$export$e68b9bef571dd4ea
};

});

parcelRegister("fWWLW", function(module, exports) {

$parcel$export(module.exports, "maxPoolGradConfig", () => $b9c9dcb7942cf5a2$export$e01a7f8dbee29127);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $g81BN = parcelRequire("g81BN");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");

var $8by9c = parcelRequire("8by9c");
function $b9c9dcb7942cf5a2$export$85dfd1121f049514(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input, output: output } = inputs;
    const x = input;
    (0, $aPHJu.assertNotComplex)([
        input,
        output
    ], 'maxPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const convInfo = (0, $lkN62).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const xValues = backend.data.get(x.dataId).values;
    const maxPosBuf = (0, $g81BN.buffer)(convInfo.outShape, x.dtype, (0, $8by9c.maxPoolPositions)(xValues, x.shape, x.dtype, convInfo).values);
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const dx = (0, $g81BN.buffer)(x.shape, 'float32');
    const dyData = backend.data.get(dy.dataId).values;
    const dyBuf = (0, $g81BN.buffer)(dy.shape, 'float32', dyData);
    for(let b = 0; b < convInfo.batchSize; ++b)for(let d = 0; d < convInfo.inChannels; ++d){
        for(let dxR = 0; dxR < convInfo.inHeight; ++dxR)for(let dxC = 0; dxC < convInfo.inWidth; ++dxC){
            // Shader code begins.
            const dyRCorner = dxR - padTop;
            const dyCCorner = dxC - padLeft;
            let dotProd = 0;
            for(let wR = 0; wR < effectiveFilterHeight; wR += dilationHeight){
                const dyR = (dyRCorner + wR) / strideHeight;
                if (dyR < 0 || dyR >= convInfo.outHeight || Math.floor(dyR) !== dyR) continue;
                for(let wC = 0; wC < effectiveFilterWidth; wC += dilationWidth){
                    const dyC = (dyCCorner + wC) / strideWidth;
                    if (dyC < 0 || dyC >= convInfo.outWidth || Math.floor(dyC) !== dyC) continue;
                    const maxPos = effectiveFilterHeight * effectiveFilterWidth - 1 - maxPosBuf.get(b, dyR, dyC, d);
                    const curPos = wR * effectiveFilterWidth + wC;
                    const mask = maxPos === curPos ? 1 : 0;
                    if (mask === 0) continue;
                    const pixel = dyBuf.get(b, dyR, dyC, d);
                    dotProd += pixel * mask;
                }
            }
            dx.set(dotProd, b, dxR, dxC, d);
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $b9c9dcb7942cf5a2$export$e01a7f8dbee29127 = {
    kernelName: (0, $dCP8m.MaxPoolGrad),
    backendName: 'cpu',
    kernelFunc: $b9c9dcb7942cf5a2$export$85dfd1121f049514
};

});

parcelRegister("ga261", function(module, exports) {

$parcel$export(module.exports, "maxPoolWithArgmaxConfig", () => $bc3f34bddc1da478$export$a069ee2247a7d1ce);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");

var $dh2mG = parcelRequire("dh2mG");
const $bc3f34bddc1da478$export$a069ee2247a7d1ce = {
    kernelName: (0, $dCP8m.MaxPoolWithArgmax),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { filterSize: filterSize, strides: strides, pad: pad, includeBatchInIndex: includeBatchInIndex } = attrs;
        const cpuBackend = backend;
        (0, $aPHJu.assertNotComplex)(x, 'MaxPoolWithArgmax');
        const values = cpuBackend.data.get(x.dataId).values;
        const convInfo = (0, $lkN62).computePool2DInfo(x.shape, filterSize, strides, [
            1,
            1
        ], pad);
        const [pooled, indexes] = (0, $dh2mG.maxPoolWithArgmaxImpl)(values, x.shape, x.dtype, includeBatchInIndex, convInfo);
        const pooledDataId = cpuBackend.write(pooled, convInfo.outShape, x.dtype);
        const indexesDataId = cpuBackend.write(indexes, convInfo.outShape, x.dtype);
        return [
            {
                dataId: pooledDataId,
                shape: convInfo.outShape,
                dtype: x.dtype
            },
            {
                dataId: indexesDataId,
                shape: convInfo.outShape,
                dtype: 'int32'
            }
        ];
    }
};

});
parcelRegister("dh2mG", function(module, exports) {

$parcel$export(module.exports, "maxPoolWithArgmaxImpl", () => $9a9eb27d545b7cc9$export$3cc34964a47e7a3f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $8by9c = parcelRequire("8by9c");
function $9a9eb27d545b7cc9$export$3cc34964a47e7a3f(xValues, xShape, dtype, includeBatchInIndex, convInfo) {
    const strides = (0, $wx9lK).computeStrides(xShape);
    const maxPools = (0, $8by9c.pool)(xValues, xShape, dtype, strides, convInfo, 'max');
    const maxPositions = (0, $8by9c.maxPoolPositions)(xValues, xShape, dtype, convInfo, true, includeBatchInIndex);
    return [
        maxPools.values,
        maxPositions.values
    ];
}

});


parcelRegister("a3ZcZ", function(module, exports) {

$parcel$export(module.exports, "meanConfig", () => $7539a9ec39f7dc51$export$b934af0ccd0cdbe1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $gSA6r = parcelRequire("gSA6r");

var $9MYjt = parcelRequire("9MYjt");

var $jPjnE = parcelRequire("jPjnE");
function $7539a9ec39f7dc51$export$1ce691f85baaa52(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const axes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    const shapes = (0, $lkN62).computeOutAndReduceShapes(x.shape, axes);
    const reduceShape = shapes[1];
    const reduceSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const toDispose = [];
    const reduceSizeScalar = backend.makeTensorInfo([], 'float32', new Float32Array([
        reduceSize
    ]));
    toDispose.push(reduceSizeScalar);
    const $x = (0, $gSA6r.cast)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            dtype: 'float32'
        }
    });
    toDispose.push($x);
    const res = (0, $9MYjt.div)({
        inputs: {
            a: $x,
            b: reduceSizeScalar
        },
        backend: backend
    });
    toDispose.push(res);
    const result = (0, $jPjnE.sum)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            axis: axis,
            keepDims: keepDims
        }
    });
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $7539a9ec39f7dc51$export$b934af0ccd0cdbe1 = {
    kernelName: (0, $dCP8m.Mean),
    backendName: 'cpu',
    kernelFunc: $7539a9ec39f7dc51$export$1ce691f85baaa52
};

});

parcelRegister("jN09m", function(module, exports) {

$parcel$export(module.exports, "minConfig", () => $e682b5b05917a178$export$3cd9f9a31b38cf18);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $3qzJ7 = parcelRequire("3qzJ7");

var $9buNR = parcelRequire("9buNR");
function $e682b5b05917a178$export$96ec731ed4dcb222(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'min');
    const origAxes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    if (permutedAxes != null) {
        $x = (0, $9buNR.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $lkN62).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $lkN62).assertAxesAreInnerMostDims('min', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes($x.shape, axes);
    const reduceSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const vals = (0, $wx9lK).makeZerosTypedArray((0, $wx9lK).sizeFromShape(outShape), $x.dtype);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let min = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (Number.isNaN(value) || value < min) min = value;
        }
        vals[i] = min;
    }
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo($x);
    const result = backend.makeTensorInfo(outShape, $x.dtype, vals);
    if (keepDims) {
        const expandedShape = (0, $lkN62).expandShapeToKeepDim(outShape, origAxes);
        const reshapedResult = (0, $3qzJ7.reshape)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: expandedShape
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        return reshapedResult;
    }
    return result;
}
const $e682b5b05917a178$export$3cd9f9a31b38cf18 = {
    kernelName: (0, $dCP8m.Min),
    backendName: 'cpu',
    kernelFunc: $e682b5b05917a178$export$96ec731ed4dcb222
};

});

parcelRegister("4zebw", function(module, exports) {

$parcel$export(module.exports, "minimumImpl", () => $35356f21ceb0791e$export$756c08a3fa64d43);
$parcel$export(module.exports, "minimumConfig", () => $35356f21ceb0791e$export$ea24ffbbbce8d546);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $35356f21ceb0791e$export$756c08a3fa64d43 = (0, $aRRHO.createSimpleBinaryKernelImpl)((aValue, bValue)=>Math.min(aValue, bValue));
const $35356f21ceb0791e$export$916782c1f0ddb132 = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.Minimum), $35356f21ceb0791e$export$756c08a3fa64d43);
const $35356f21ceb0791e$export$ea24ffbbbce8d546 = {
    kernelName: (0, $dCP8m.Minimum),
    backendName: 'cpu',
    kernelFunc: $35356f21ceb0791e$export$916782c1f0ddb132
};

});

parcelRegister("aMPRM", function(module, exports) {

$parcel$export(module.exports, "mirrorPadConfig", () => $7da69ea9217c0400$export$2cfd6c6c7daeb5fc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $7da69ea9217c0400$export$c0b11600e90b86ae(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { paddings: paddings, mode: mode } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'mirrorPad');
    const outShape = paddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
    const start = paddings.map((p)=>p[0]);
    const end = paddings.map((p, i)=>p[0] + x.shape[i]);
    const offset = mode === 'reflect' ? 0 : 1;
    const xVals = backend.data.get(x.dataId).values;
    const xRank = x.shape.length;
    const xStrides = (0, $wx9lK).computeStrides(x.shape);
    const resultSize = (0, $wx9lK).sizeFromShape(outShape);
    const resultRank = outShape.length;
    const resultStrides = (0, $wx9lK).computeStrides(outShape);
    const resVals = (0, $wx9lK).getTypedArrayFromDType(x.dtype, resultSize);
    for(let i = 0; i < resultSize; i++){
        let coords = (0, $wx9lK).indexToLoc(i, resultRank, resultStrides);
        for(let i = 0; i < resultRank; i++){
            if (coords[i] < start[i]) coords[i] = start[i] * 2 - coords[i] - offset;
            else if (coords[i] >= end[i]) coords[i] = (end[i] - 1) * 2 - coords[i] + offset;
        }
        coords = coords.map((c, i)=>c - start[i]);
        const inIndex = (0, $wx9lK).locToIndex(coords, xRank, xStrides);
        resVals[i] = xVals[inIndex];
    }
    const outId = backend.write(resVals, outShape, x.dtype);
    return {
        dataId: outId,
        shape: outShape,
        dtype: x.dtype
    };
}
const $7da69ea9217c0400$export$2cfd6c6c7daeb5fc = {
    kernelName: (0, $dCP8m.MirrorPad),
    backendName: 'cpu',
    kernelFunc: $7da69ea9217c0400$export$c0b11600e90b86ae
};

});

parcelRegister("h70lW", function(module, exports) {

$parcel$export(module.exports, "modConfig", () => $c7535d2fa6ae80fd$export$9037685a81180a9c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $c7535d2fa6ae80fd$export$fc31b6ef8ca4db11 = (0, $aRRHO.createSimpleBinaryKernelImpl)((aValue, bValue)=>{
    const rem = aValue % bValue;
    if (aValue < 0 && bValue < 0 || aValue >= 0 && bValue >= 0) return rem;
    else return (rem + bValue) % bValue;
});
const $c7535d2fa6ae80fd$export$842a2cf37af977e1 = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.Mod), $c7535d2fa6ae80fd$export$fc31b6ef8ca4db11);
const $c7535d2fa6ae80fd$export$9037685a81180a9c = {
    kernelName: (0, $dCP8m.Mod),
    backendName: 'cpu',
    kernelFunc: $c7535d2fa6ae80fd$export$842a2cf37af977e1
};

});

parcelRegister("aJkrV", function(module, exports) {

$parcel$export(module.exports, "multinomialConfig", () => $7cfdf8312d63fa04$export$ad960e364767f0e2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $ftPHE = parcelRequire("ftPHE");

var $aPHJu = parcelRequire("aPHJu");

var $lngaC = parcelRequire("lngaC");
function $7cfdf8312d63fa04$export$f4d580f3101a1c7e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { numSamples: numSamples, seed: seed, normalized: normalized } = attrs;
    (0, $aPHJu.assertNotComplex)(logits, 'multinomial');
    const probabilities = normalized ? logits : (0, $lngaC.softmax)({
        inputs: {
            logits: logits
        },
        backend: backend,
        attrs: {
            dim: -1
        }
    });
    const batchSize = probabilities.shape[0];
    const numEvents = probabilities.shape[1];
    const probVals = backend.data.get(probabilities.dataId).values;
    const resShape = [
        batchSize,
        numSamples
    ];
    const resVals = (0, $wx9lK).makeZerosTypedArray((0, $wx9lK).sizeFromShape(resShape), 'int32');
    for(let b = 0; b < batchSize; ++b){
        const offset = b * numEvents;
        // The cdf won't include the last event. It will be implicit if no other
        // event happened.
        const cdf = new Float32Array(numEvents - 1);
        cdf[0] = probVals[offset];
        for(let event = 1; event < cdf.length; ++event)cdf[event] = cdf[event - 1] + probVals[offset + event];
        const random = $ftPHE.alea(seed.toString());
        const outOffset = b * numSamples;
        for(let sampleId = 0; sampleId < numSamples; ++sampleId){
            const r = random();
            // Assume last event happened by default.
            resVals[outOffset + sampleId] = cdf.length;
            for(let event = 0; event < cdf.length; event++)if (r < cdf[event]) {
                resVals[outOffset + sampleId] = event;
                break;
            }
        }
    }
    if (!normalized) backend.disposeIntermediateTensorInfo(probabilities);
    return backend.makeTensorInfo(resShape, 'int32', resVals);
}
const $7cfdf8312d63fa04$export$ad960e364767f0e2 = {
    kernelName: (0, $dCP8m.Multinomial),
    backendName: 'cpu',
    kernelFunc: $7cfdf8312d63fa04$export$f4d580f3101a1c7e
};

});
parcelRegister("lngaC", function(module, exports) {

$parcel$export(module.exports, "softmax", () => $f8f84a0b26469603$export$e008137e76238601);
$parcel$export(module.exports, "softmaxConfig", () => $f8f84a0b26469603$export$c022691f23e2ee69);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $1DFii = parcelRequire("1DFii");

var $lPDl4 = parcelRequire("lPDl4");

var $9MYjt = parcelRequire("9MYjt");

var $3qzJ7 = parcelRequire("3qzJ7");

var $gUzQw = parcelRequire("gUzQw");

var $jPjnE = parcelRequire("jPjnE");
function $f8f84a0b26469603$export$e008137e76238601(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { dim: dim } = attrs;
    const logitsRank = logits.shape.length;
    let $dim = dim;
    if ($dim === -1) $dim = logitsRank - 1;
    if ($dim !== logitsRank - 1) throw Error('Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${logitsRank} and dim was ${$dim}`);
    const axes = (0, $wx9lK).parseAxisParam([
        $dim
    ], logits.shape);
    const maxLogit = (0, $lPDl4.max)({
        inputs: {
            x: logits
        },
        backend: backend,
        attrs: {
            reductionIndices: axes,
            keepDims: false
        }
    });
    const expandedShape = (0, $lkN62).expandShapeToKeepDim(maxLogit.shape, axes);
    const maxLogitReshaped = (0, $3qzJ7.reshape)({
        inputs: {
            x: maxLogit
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const a = (0, $gUzQw.sub)({
        inputs: {
            a: logits,
            b: maxLogitReshaped
        },
        backend: backend
    });
    const b = (0, $1DFii.exp)({
        inputs: {
            x: a
        },
        backend: backend
    });
    const sumExp = (0, $jPjnE.sum)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            axis: axes,
            keepDims: false
        }
    });
    const sumReshaped = (0, $3qzJ7.reshape)({
        inputs: {
            x: sumExp
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const result = (0, $9MYjt.div)({
        inputs: {
            a: b,
            b: sumReshaped
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(maxLogit);
    backend.disposeIntermediateTensorInfo(maxLogitReshaped);
    backend.disposeIntermediateTensorInfo(a);
    backend.disposeIntermediateTensorInfo(b);
    backend.disposeIntermediateTensorInfo(sumExp);
    backend.disposeIntermediateTensorInfo(sumReshaped);
    return result;
}
const $f8f84a0b26469603$export$c022691f23e2ee69 = {
    kernelName: (0, $dCP8m.Softmax),
    backendName: 'cpu',
    kernelFunc: $f8f84a0b26469603$export$e008137e76238601
};

});


parcelRegister("6Pysf", function(module, exports) {

$parcel$export(module.exports, "negImpl", () => $4f923b75c52fbe74$export$e9053236ce0e659b);
$parcel$export(module.exports, "negConfig", () => $4f923b75c52fbe74$export$cc7b18b8229c3db);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $h9fuR = parcelRequire("h9fuR");
function $4f923b75c52fbe74$export$e9053236ce0e659b(xVals, xShape, xDtype) {
    const minusOne = (0, $wx9lK).createScalarValue(-1, xDtype);
    return (0, $h9fuR.multiplyImpl)([], xShape, minusOne, xVals, xDtype);
}
function $4f923b75c52fbe74$export$d9493ff0dfa0fdd5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    (0, $aPHJu.assertNotComplex)(x, 'neg');
    const xVals = backend.data.get(x.dataId).values;
    const [res, newShape] = $4f923b75c52fbe74$export$e9053236ce0e659b(xVals, x.shape, x.dtype);
    return backend.makeTensorInfo(newShape, x.dtype, res);
}
const $4f923b75c52fbe74$export$cc7b18b8229c3db = {
    kernelName: (0, $dCP8m.Neg),
    backendName: 'cpu',
    kernelFunc: $4f923b75c52fbe74$export$d9493ff0dfa0fdd5
};

});

parcelRegister("fOQaD", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV3Config", () => $b843fe847fc203bc$export$549561cd158f260a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $ff2I2 = parcelRequire("ff2I2");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");
const $b843fe847fc203bc$var$nonMaxSuppressionV3Impl = (0, $ff2I2).nonMaxSuppressionV3Impl;
function $b843fe847fc203bc$export$8917e4bf7f7f5d42(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = attrs;
    (0, $aPHJu.assertNotComplex)(boxes, 'NonMaxSuppression');
    const boxesVals = backend.data.get(boxes.dataId).values;
    const scoresVals = backend.data.get(scores.dataId).values;
    const { selectedIndices: selectedIndices } = $b843fe847fc203bc$var$nonMaxSuppressionV3Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    return backend.makeTensorInfo([
        selectedIndices.length
    ], 'int32', new Int32Array(selectedIndices));
}
const $b843fe847fc203bc$export$549561cd158f260a = {
    kernelName: (0, $dCP8m.NonMaxSuppressionV3),
    backendName: 'cpu',
    kernelFunc: $b843fe847fc203bc$export$8917e4bf7f7f5d42
};

});

parcelRegister("5zE1X", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV4Config", () => $40ef45dccc0150a0$export$906b8fb32c570e9d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $ff2I2 = parcelRequire("ff2I2");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");
const $40ef45dccc0150a0$var$nonMaxSuppressionV4Impl = (0, $ff2I2).nonMaxSuppressionV4Impl;
function $40ef45dccc0150a0$export$ad519bdebe8f4dcf(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, padToMaxOutputSize: padToMaxOutputSize } = attrs;
    (0, $aPHJu.assertNotComplex)(boxes, 'NonMaxSuppressionPadded');
    const boxesVals = backend.data.get(boxes.dataId).values;
    const scoresVals = backend.data.get(scores.dataId).values;
    const { selectedIndices: selectedIndices, validOutputs: validOutputs } = $40ef45dccc0150a0$var$nonMaxSuppressionV4Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([], 'int32', new Int32Array([
            validOutputs
        ]))
    ];
}
const $40ef45dccc0150a0$export$906b8fb32c570e9d = {
    kernelName: (0, $dCP8m.NonMaxSuppressionV4),
    backendName: 'cpu',
    kernelFunc: $40ef45dccc0150a0$export$ad519bdebe8f4dcf
};

});

parcelRegister("inyB0", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV5Config", () => $d6153602f82fca25$export$4c00b682f309701d);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $ff2I2 = parcelRequire("ff2I2");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");
const $d6153602f82fca25$var$nonMaxSuppressionV5Impl = (0, $ff2I2).nonMaxSuppressionV5Impl;
function $d6153602f82fca25$export$49e389fdbe01a534(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = attrs;
    (0, $aPHJu.assertNotComplex)(boxes, 'NonMaxSuppressionWithScore');
    const boxesVals = backend.data.get(boxes.dataId).values;
    const scoresVals = backend.data.get(scores.dataId).values;
    const maxOutputSizeVal = maxOutputSize;
    const iouThresholdVal = iouThreshold;
    const scoreThresholdVal = scoreThreshold;
    const softNmsSigmaVal = softNmsSigma;
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = $d6153602f82fca25$var$nonMaxSuppressionV5Impl(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([
            selectedScores.length
        ], 'float32', new Float32Array(selectedScores))
    ];
}
const $d6153602f82fca25$export$4c00b682f309701d = {
    kernelName: (0, $dCP8m.NonMaxSuppressionV5),
    backendName: 'cpu',
    kernelFunc: $d6153602f82fca25$export$49e389fdbe01a534
};

});

parcelRegister("gGCqu", function(module, exports) {

$parcel$export(module.exports, "notEqualImpl", () => $c25e604074b57a14$export$eaea354630818ed4);
$parcel$export(module.exports, "notEqualConfig", () => $c25e604074b57a14$export$d003d4d7e1500775);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $c25e604074b57a14$export$eaea354630818ed4 = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>a !== b ? 1 : 0);
const $c25e604074b57a14$export$53a6892c50694894 = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.NotEqual), $c25e604074b57a14$export$eaea354630818ed4, null, 'bool');
const $c25e604074b57a14$export$d003d4d7e1500775 = {
    kernelName: (0, $dCP8m.NotEqual),
    backendName: 'cpu',
    kernelFunc: $c25e604074b57a14$export$53a6892c50694894
};

});

parcelRegister("kcYhR", function(module, exports) {

$parcel$export(module.exports, "oneHotConfig", () => $eb63b16a40d0b4b9$export$dde5645b472b80b2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $eb63b16a40d0b4b9$export$341b5490a776d041(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices } = inputs;
    const { dtype: dtype, depth: depth, onValue: onValue, offValue: offValue } = attrs;
    (0, $aPHJu.assertNotComplex)(indices, 'oneHot');
    const indicesSize = (0, $wx9lK).sizeFromShape(indices.shape);
    const res = new Float32Array(indicesSize * depth);
    res.fill(offValue);
    const indicesVal = backend.data.get(indices.dataId).values;
    for(let event = 0; event < indicesSize; ++event)if (indicesVal[event] >= 0 && indicesVal[event] < depth) res[event * depth + indicesVal[event]] = onValue;
    return backend.makeTensorInfo([
        ...indices.shape,
        depth
    ], dtype, res);
}
const $eb63b16a40d0b4b9$export$dde5645b472b80b2 = {
    kernelName: (0, $dCP8m.OneHot),
    backendName: 'cpu',
    kernelFunc: $eb63b16a40d0b4b9$export$341b5490a776d041
};

});

parcelRegister("2SsCU", function(module, exports) {

$parcel$export(module.exports, "onesLikeConfig", () => $2186d4941a5d4bfd$export$d8d7015eb6ab37d0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $78AN7 = parcelRequire("78AN7");

var $2ttNt = parcelRequire("2ttNt");

var $cG2uv = parcelRequire("cG2uv");

var $9B72G = parcelRequire("9B72G");

var $axSMP = parcelRequire("axSMP");
function $2186d4941a5d4bfd$export$fb6afd6214fee9e9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'string') throw new Error('onesLike is not supported for string tensors');
    else if (x.dtype === 'complex64') {
        const realPart = (0, $9B72G.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $2186d4941a5d4bfd$export$fb6afd6214fee9e9({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $cG2uv.imag)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = (0, $axSMP.zerosLike)({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $78AN7.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else return (0, $2ttNt.fill)({
        backend: backend,
        attrs: {
            shape: x.shape,
            value: 1,
            dtype: x.dtype
        }
    });
}
const $2186d4941a5d4bfd$export$d8d7015eb6ab37d0 = {
    kernelName: (0, $dCP8m.OnesLike),
    backendName: 'cpu',
    kernelFunc: $2186d4941a5d4bfd$export$fb6afd6214fee9e9
};

});
parcelRegister("axSMP", function(module, exports) {

$parcel$export(module.exports, "zerosLike", () => $7ad77bedd78a09f2$export$cb1f824e7733584d);
$parcel$export(module.exports, "zerosLikeConfig", () => $7ad77bedd78a09f2$export$15368df05c479e41);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $78AN7 = parcelRequire("78AN7");

var $2ttNt = parcelRequire("2ttNt");

var $cG2uv = parcelRequire("cG2uv");

var $9B72G = parcelRequire("9B72G");
function $7ad77bedd78a09f2$export$cb1f824e7733584d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'string') throw new Error('zerosLike is not supported for string tensors');
    else if (x.dtype === 'complex64') {
        const realPart = (0, $9B72G.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $7ad77bedd78a09f2$export$cb1f824e7733584d({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $cG2uv.imag)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = $7ad77bedd78a09f2$export$cb1f824e7733584d({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $78AN7.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else return (0, $2ttNt.fill)({
        backend: backend,
        attrs: {
            shape: x.shape,
            value: 0,
            dtype: x.dtype
        }
    });
}
const $7ad77bedd78a09f2$export$15368df05c479e41 = {
    kernelName: (0, $dCP8m.ZerosLike),
    backendName: 'cpu',
    kernelFunc: $7ad77bedd78a09f2$export$cb1f824e7733584d
};

});


parcelRegister("7gEB2", function(module, exports) {

$parcel$export(module.exports, "pack", () => $54a984a13804e47e$export$2a703dbb0cb35339);
$parcel$export(module.exports, "packConfig", () => $54a984a13804e47e$export$1645fa8803aa1f86);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $kFVXg = parcelRequire("kFVXg");

var $8Du0y = parcelRequire("8Du0y");
function $54a984a13804e47e$export$2a703dbb0cb35339(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    if (inputs.length === 1) return (0, $8Du0y.expandDims)({
        inputs: {
            input: inputs[0]
        },
        backend: backend,
        attrs: {
            dim: axis
        }
    });
    const shape = inputs[0].shape;
    const dtype = inputs[0].dtype;
    inputs.forEach((t)=>{
        (0, $wx9lK).assertShapesMatch(shape, t.shape, 'All tensors passed to stack must have matching shapes');
        (0, $wx9lK).assert(dtype === t.dtype, ()=>'All tensors passed to stack must have matching dtypes');
    });
    const intermediateTensorInfos = [];
    const expandedTensors = inputs.map((t)=>{
        const expandedT = (0, $8Du0y.expandDims)({
            inputs: {
                input: t
            },
            backend: backend,
            attrs: {
                dim: axis
            }
        });
        intermediateTensorInfos.push(expandedT);
        return expandedT;
    });
    const result = (0, $kFVXg.concat)({
        inputs: expandedTensors,
        backend: backend,
        attrs: {
            axis: axis
        }
    });
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $54a984a13804e47e$export$1645fa8803aa1f86 = {
    kernelName: (0, $dCP8m.Pack),
    backendName: 'cpu',
    kernelFunc: $54a984a13804e47e$export$2a703dbb0cb35339
};

});

parcelRegister("flmof", function(module, exports) {

$parcel$export(module.exports, "padV2Config", () => $b2ba2f607842f33b$export$b0317e720bfd61fc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $b2ba2f607842f33b$export$f676d6ad4f38bb89(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { paddings: paddings, constantValue: constantValue } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'pad');
    const outShape = paddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
    const start = paddings.map((p)=>p[0]);
    const xVals = backend.data.get(x.dataId).values;
    const xSize = (0, $wx9lK).sizeFromShape(x.shape);
    const xRank = x.shape.length;
    const xStrides = (0, $wx9lK).computeStrides(x.shape);
    const resultSize = (0, $wx9lK).sizeFromShape(outShape);
    const resultRank = outShape.length;
    const resultStrides = (0, $wx9lK).computeStrides(outShape);
    const resVals = (0, $wx9lK).getTypedArrayFromDType(x.dtype, resultSize);
    if (constantValue !== 0) resVals.fill(constantValue);
    for(let i = 0; i < xSize; i++){
        const coords = (0, $wx9lK).indexToLoc(i, xRank, xStrides);
        const outCoords = coords.map((c, i)=>c + start[i]);
        const outIndex = (0, $wx9lK).locToIndex(outCoords, resultRank, resultStrides);
        resVals[outIndex] = xVals[i];
    }
    const outId = backend.write(resVals, outShape, x.dtype);
    return {
        dataId: outId,
        shape: outShape,
        dtype: x.dtype
    };
}
const $b2ba2f607842f33b$export$b0317e720bfd61fc = {
    kernelName: (0, $dCP8m.PadV2),
    backendName: 'cpu',
    kernelFunc: $b2ba2f607842f33b$export$f676d6ad4f38bb89
};

});

parcelRegister("k8NQv", function(module, exports) {

$parcel$export(module.exports, "powConfig", () => $ea9b385c1e7ee4bb$export$b823d49786719761);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $ea9b385c1e7ee4bb$export$92051c71bb41bd8a = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>Math.pow(a, b));
const $ea9b385c1e7ee4bb$export$9c297f60e22e3389 = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.Pow), $ea9b385c1e7ee4bb$export$92051c71bb41bd8a);
const $ea9b385c1e7ee4bb$export$b823d49786719761 = {
    kernelName: (0, $dCP8m.Pow),
    backendName: 'cpu',
    kernelFunc: $ea9b385c1e7ee4bb$export$9c297f60e22e3389
};

});

parcelRegister("k2KEG", function(module, exports) {

$parcel$export(module.exports, "prodImpl", () => $e9782f5105ab1caa$export$a3c8a5271f6bb700);
$parcel$export(module.exports, "prodConfig", () => $e9782f5105ab1caa$export$d556aa935cef5c0c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bnEYl = parcelRequire("bnEYl");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $9buNR = parcelRequire("9buNR");
function $e9782f5105ab1caa$export$a3c8a5271f6bb700(xShape, xDtype, xVals, reductionAxes) {
    const [outShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes(xShape, reductionAxes);
    const outDtype = (0, $bnEYl.upcastType)(xDtype, 'int32');
    const outVals = (0, $wx9lK).makeZerosTypedArray((0, $wx9lK).sizeFromShape(outShape), outDtype);
    const reduceSize = (0, $wx9lK).sizeFromShape(reduceShape);
    for(let i = 0; i < outVals.length; ++i){
        const offset = i * reduceSize;
        let prod = 1;
        for(let j = 0; j < reduceSize; ++j)prod *= xVals[offset + j];
        outVals[i] = prod;
    }
    return {
        outVals: outVals,
        outShape: outShape,
        outDtype: outDtype
    };
}
function $e9782f5105ab1caa$export$5e143010dea16c85(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'prod');
    const xRank = x.shape.length;
    const axes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    const permutation = (0, $lkN62).getAxesPermutation(axes, xRank);
    let reductionAxes = axes;
    let permutedX = x;
    const intermediateTensorInfos = [];
    if (permutation != null) {
        permutedX = (0, $9buNR.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        intermediateTensorInfos.push(permutedX);
        reductionAxes = (0, $lkN62).getInnerMostAxes(reductionAxes.length, xRank);
    }
    const xVals = backend.data.get(permutedX.dataId).values;
    const { outVals: outVals, outShape: outShape, outDtype: outDtype } = $e9782f5105ab1caa$export$a3c8a5271f6bb700(permutedX.shape, permutedX.dtype, xVals, reductionAxes);
    let resultShape = outShape;
    if (keepDims) resultShape = (0, $lkN62).expandShapeToKeepDim(outShape, axes);
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return backend.makeTensorInfo(resultShape, outDtype, outVals);
}
const $e9782f5105ab1caa$export$d556aa935cef5c0c = {
    kernelName: (0, $dCP8m.Prod),
    backendName: 'cpu',
    kernelFunc: $e9782f5105ab1caa$export$5e143010dea16c85
};

});

parcelRegister("bczmc", function(module, exports) {

$parcel$export(module.exports, "raggedGatherConfig", () => $827c3ddf3f52d617$export$cebb8a7d5932c7e8);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $4J33f = parcelRequire("4J33f");
function $827c3ddf3f52d617$export$e7118f605df251dd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { paramsNestedSplits: paramsNestedSplits, paramsDenseValues: paramsDenseValues, indices: indices } = inputs;
    const { outputRaggedRank: outputRaggedRank } = attrs;
    const $paramsNestedSplits = paramsNestedSplits.map((t)=>backend.data.get(t.dataId).values);
    const $paramsNestedSplitsShapes = paramsNestedSplits.map((t)=>t.shape);
    const $paramsDenseValues = backend.data.get(paramsDenseValues.dataId).values;
    const $indices = backend.data.get(indices.dataId).values;
    const [outputNestedSplits, outputDenseValues, outputDenseValuesShape] = (0, $4J33f.raggedGatherImpl)($paramsNestedSplits, $paramsNestedSplitsShapes, $paramsDenseValues, paramsDenseValues.shape, paramsDenseValues.dtype, $indices, indices.shape, outputRaggedRank);
    const outputNestedSplitsTensors = outputNestedSplits.map((splits)=>backend.makeTensorInfo([
            splits.length
        ], 'int32', splits));
    const outputDenseValuesTensor = backend.makeTensorInfo(outputDenseValuesShape, paramsDenseValues.dtype, outputDenseValues);
    return outputNestedSplitsTensors.concat([
        outputDenseValuesTensor
    ]);
}
const $827c3ddf3f52d617$export$cebb8a7d5932c7e8 = {
    kernelName: (0, $dCP8m.RaggedGather),
    backendName: 'cpu',
    kernelFunc: $827c3ddf3f52d617$export$e7118f605df251dd
};

});
parcelRegister("4J33f", function(module, exports) {

$parcel$export(module.exports, "raggedGatherImpl", () => $370dbb537ca10e14$export$4104e3de41455909);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
function $370dbb537ca10e14$var$validateIndices(indices, indicesShape, numParams) {
    indices.forEach((index, i)=>{
        if (index < 0 || index >= numParams) {
            const locString = (0, $wx9lK).indexToLoc(i, indicesShape.length, (0, $wx9lK).computeStrides(indicesShape)).join(',');
            throw new Error(`indices[${locString}] = ${index} is not in [0, ${numParams})`);
        }
    });
}
function $370dbb537ca10e14$var$validateSplits(paramsNestedSplits, numParamsDenseValues) {
    // Validate
    for(let dim = 0; dim < paramsNestedSplits.length; ++dim){
        const splits = paramsNestedSplits[dim];
        const lastSplit = dim === paramsNestedSplits.length - 1 ? numParamsDenseValues : paramsNestedSplits[dim + 1].length;
        if (splits.length === 0) throw new Error('Ragged splits may not be empty');
        if (splits[0] < 0) throw new Error('Ragged splits must be non-negative');
        if (splits[splits.length - 1] > lastSplit) throw new Error('Ragged splits must not point past values');
        for(let i = 1; i < splits.length; ++i){
            if (splits[i - 1] > splits[i]) throw new Error('Ragged splits must be sorted in ascending order');
        }
    }
}
// Construct the `splits` output tensors, encoded using a nested vector.
// Also find the slices of values that need to be copied, and store them
// in `valueSlices`.  The total number of values that will be copied (which
// we need for allocating the output values tensor) is stored in `numValues`.
function $370dbb537ca10e14$var$makeSplits(indices, indicesShape, paramsNestedSplits, numParamsDenseValues) {
    const valueSlices = [];
    let numValues = 0;
    const numSplits = indicesShape.length - 1 + paramsNestedSplits.length;
    const outSplits = new Array(numSplits).fill(null).map(()=>[
            0
        ]);
    $370dbb537ca10e14$var$validateSplits(paramsNestedSplits, numParamsDenseValues);
    // Add `splits` that come from all but the last dimension of the dense
    // Tensor `indices`.  In particular, for each dimension D, we add a
    // splits tensor whose values are:
    //   range(reduceProd(splits.shape[:D]) + 1) * splits.shape[D+1]
    // E.g., if indices.shape=[2, 3, 4] then we will add splits tensors:
    //   [0, 3, 6]                    # length=2+1, stride=3
    //   [0, 4, 8, 12, 16, 20, 24]    # length=2*3+1, stride=4
    let nrows = 1;
    for(let dim = 0; dim < indicesShape.length - 1; ++dim){
        nrows *= indicesShape[dim];
        const rowLength = indicesShape[dim + 1];
        for(let i = 1; i < nrows + 1; ++i)outSplits[dim].push(i * rowLength);
    }
    // Add `splits` that come from `paramsNestedSplits`.  Starting with the
    // outermost ragged dimension (i.e., the first `splits` tensor), we work
    // our way in, finding the range of values that should be copied.  As we
    // go, we update the output `splits` for each dimension with the appropriate
    // values.  In particular, the *lengths* of the slices from `param_splits`
    // should be copied to generate corresponding slice lengths in the output
    // splits.  E.g., if we are copying a ragged row with length 4, then we
    // should add a new split point to outSplits that is 4 greater than the
    // previous split point in outSplits.
    for(let i = 0; i < indices.length; ++i){
        let start = indices[i];
        let limit = indices[i] + 1;
        // Copy splits.
        for(let dim = 0; dim < paramsNestedSplits.length; ++dim){
            const splits = paramsNestedSplits[dim];
            const outDim = dim + indicesShape.length - 1;
            if (outDim >= 0) {
                const outSplitsOutDim = outSplits[outDim];
                const delta = outSplitsOutDim[outSplitsOutDim.length - 1] - splits[start];
                for(let j = start; j < limit; ++j)outSplits[outDim].push(splits[j + 1] + delta);
            }
            start = splits[start];
            limit = splits[limit];
        }
        if (limit !== start) {
            valueSlices.push([
                start,
                limit
            ]);
            numValues += limit - start;
        }
    }
    return {
        outSplits: outSplits,
        valueSlices: valueSlices,
        numValues: numValues
    };
}
function $370dbb537ca10e14$var$getSplits(outSplits) {
    const splitsOut = [];
    for(let i = 0; i < outSplits.length; ++i){
        const numSplits = outSplits[i].length;
        const splits = (0, $wx9lK).getArrayFromDType('int32', numSplits);
        splitsOut.push(splits);
        outSplits[i].forEach((value, j)=>splits[j] = value);
    }
    return splitsOut;
}
function $370dbb537ca10e14$var$computeFlatOuterDims(orig, numOutDims) {
    const outDims = orig.slice(0, numOutDims);
    while(outDims.length < numOutDims)outDims.push(1);
    for(let inDim = numOutDims; inDim < orig.length; inDim++)outDims[numOutDims - 1] *= orig[inDim];
    return outDims;
}
// For each slice in `(start, limit)` in `valueSlices`, append
// `paramsDenseValues[start,...,limit] to `values`.  `valueSize` indicates
// the number of scalars contained in each value paramsDenseValues[i].
function $370dbb537ca10e14$var$writeValueSlices(paramsDenseValues, paramsDenseValuesShape, valueSlices, valueSize, values, valuesShape) {
    const denseM = $370dbb537ca10e14$var$computeFlatOuterDims(paramsDenseValuesShape, 2)[1];
    const valuesM = $370dbb537ca10e14$var$computeFlatOuterDims(valuesShape, 2)[1];
    let outPos = 0;
    for (const slice of valueSlices)for(let i = slice[0]; i < slice[1]; ++i){
        for(let j = 0; j < valueSize; ++j)values[outPos * valuesM + j] = paramsDenseValues[i * denseM + j];
        ++outPos;
    }
}
function $370dbb537ca10e14$var$getValues(paramsDenseValues, paramsDenseValuesShape, paramsDenseValuesDType, valueSlices, numValues) {
    const valuesShape = paramsDenseValuesShape.slice();
    valuesShape[0] = numValues;
    const valuesOut = (0, $wx9lK).getArrayFromDType(paramsDenseValuesDType, (0, $wx9lK).sizeFromShape(valuesShape));
    const numElements = paramsDenseValues.length;
    const valueSize = numElements === 0 ? 0 : numElements / paramsDenseValuesShape[0];
    $370dbb537ca10e14$var$writeValueSlices(paramsDenseValues, paramsDenseValuesShape, valueSlices, valueSize, valuesOut, valuesShape);
    return [
        valuesOut,
        valuesShape
    ];
}
function $370dbb537ca10e14$export$4104e3de41455909(paramsNestedSplits, paramsNestedSplitsShapes, paramsDenseValues, paramsDenseValuesShape, paramsDenseValuesDType, indices, indicesShape, outputRaggedRank) {
    if (paramsNestedSplits.length === 0) throw new Error('paramsNestedSplits must be non empty');
    if (paramsNestedSplitsShapes[0].length === 0) throw new Error('Split tensors must not be scalars');
    const numParams = paramsNestedSplitsShapes[0][0] - 1;
    $370dbb537ca10e14$var$validateIndices(indices, indicesShape, numParams);
    if (paramsDenseValuesShape.length === 0) throw new Error('params.rank must be nonzero');
    const numParamsDenseValues = paramsDenseValuesShape[0];
    // Calculate the `splits`, and store the value slices that we need to
    // copy in `valueSlices`.
    const { outSplits: outSplits, valueSlices: valueSlices, numValues: numValues } = $370dbb537ca10e14$var$makeSplits(indices, indicesShape, paramsNestedSplits, numParamsDenseValues);
    // Write the output tensors.
    const outputNestedSplits = $370dbb537ca10e14$var$getSplits(outSplits);
    const outputDenseValues = $370dbb537ca10e14$var$getValues(paramsDenseValues, paramsDenseValuesShape, paramsDenseValuesDType, valueSlices, numValues);
    return [
        outputNestedSplits,
        outputDenseValues[0],
        outputDenseValues[1]
    ];
}

});


parcelRegister("1lo4h", function(module, exports) {

$parcel$export(module.exports, "raggedTensorToTensorConfig", () => $0faa6c02ef5dbd43$export$792f441e33dcdf26);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $as1Mo = parcelRequire("as1Mo");
function $0faa6c02ef5dbd43$export$621e390307cbbaa1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { shape: shape, values: values, defaultValue: defaultValue, rowPartitionTensors: rowPartitionTensors } = inputs;
    const { rowPartitionTypes: rowPartitionTypes } = attrs;
    const $shape = backend.data.get(shape.dataId).values;
    const $values = backend.data.get(values.dataId).values;
    const $defaultValue = backend.data.get(defaultValue.dataId).values;
    const $rowPartitionValues = rowPartitionTensors.map((t)=>backend.data.get(t.dataId).values);
    const rowPartitionValuesShapes = rowPartitionTensors.map((t)=>t.shape);
    const [outputShape, output] = (0, $as1Mo.raggedTensorToTensorImpl)($shape, shape.shape, $values, values.shape, values.dtype, $defaultValue, defaultValue.shape, $rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes);
    return backend.makeTensorInfo(outputShape, values.dtype, output);
}
const $0faa6c02ef5dbd43$export$792f441e33dcdf26 = {
    kernelName: (0, $dCP8m.RaggedTensorToTensor),
    backendName: 'cpu',
    kernelFunc: $0faa6c02ef5dbd43$export$621e390307cbbaa1
};

});
parcelRegister("as1Mo", function(module, exports) {

$parcel$export(module.exports, "raggedTensorToTensorImpl", () => $79bde649960f191b$export$8194a77b1066327a);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $eJSTd = parcelRequire("eJSTd");
var $eP0pM = parcelRequire("eP0pM");
var $9c0Qr = parcelRequire("9c0Qr");
var $wx9lK = parcelRequire("wx9lK");
var $79bde649960f191b$var$RowPartitionType = (0, $lkN62).RowPartitionType;
// Based on
// https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/ragged_tensor_to_tensor_op.cc
class $79bde649960f191b$var$RaggedTensorToTensorOp {
    constructor(shape, shapeShape, values, valuesShape, valuesDType, defaultValue, defaultValueShape, rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypeStrings){
        this.shape = shape;
        this.shapeShape = shapeShape;
        this.values = values;
        this.valuesShape = valuesShape;
        this.valuesDType = valuesDType;
        this.defaultValue = defaultValue;
        this.defaultValueShape = defaultValueShape;
        this.rowPartitionValues = rowPartitionValues;
        this.rowPartitionValuesShapes = rowPartitionValuesShapes;
        this.rowPartitionTypes = (0, $lkN62).getRowPartitionTypesHelper(rowPartitionTypeStrings);
        this.raggedRank = (0, $lkN62).getRaggedRank(this.rowPartitionTypes);
    }
    getRowPartitionTypeByDimension(dimension) {
        if (this.rowPartitionTypes[0] === $79bde649960f191b$var$RowPartitionType.FIRST_DIM_SIZE) return this.rowPartitionTypes[dimension + 1];
        else return this.rowPartitionTypes[dimension];
    }
    // Returns the relationship between dimension and dimension + 1.
    getRowPartitionTensor(dimension) {
        if (this.rowPartitionTypes[0] === $79bde649960f191b$var$RowPartitionType.FIRST_DIM_SIZE) return this.rowPartitionValues[dimension + 1];
        else return this.rowPartitionValues[dimension];
    }
    getMaxWidth(dimension) {
        const rowPartitionTensor = this.getRowPartitionTensor(dimension - 1);
        switch(this.getRowPartitionTypeByDimension(dimension - 1)){
            case $79bde649960f191b$var$RowPartitionType.VALUE_ROWIDS:
                return $79bde649960f191b$var$RaggedTensorToTensorOp.getMaxWidthValueRowID(rowPartitionTensor);
            case $79bde649960f191b$var$RowPartitionType.ROW_SPLITS:
                return $79bde649960f191b$var$RaggedTensorToTensorOp.getMaxWidthRowSplit(rowPartitionTensor);
            default:
                throw new Error(`Cannot handle partition type ${$79bde649960f191b$var$RowPartitionType[this.getRowPartitionTypeByDimension(dimension - 1)]}`);
        }
    }
    static getMaxWidthRowSplit(rowSplit) {
        const tensorLength = rowSplit.length;
        if (tensorLength === 0 || tensorLength === 1) return 0;
        let maxWidth = 0;
        for(let i = 0; i < tensorLength - 1; ++i){
            const currentWidth = rowSplit[i + 1] - rowSplit[i];
            if (currentWidth > maxWidth) maxWidth = currentWidth;
        }
        return maxWidth;
    }
    static getMaxWidthValueRowID(valueRowIds) {
        const indexLength = valueRowIds.length;
        if (indexLength === 0) return 0;
        let firstEqualIndex = 0;
        let firstEqualIndexValue = valueRowIds[0];
        let maxWidth = 0;
        for(let i = 1; i < indexLength; ++i){
            const value = valueRowIds[i];
            if (value !== firstEqualIndexValue) {
                firstEqualIndexValue = value;
                maxWidth = Math.max(i - firstEqualIndex, maxWidth);
                firstEqualIndex = i;
            }
        }
        return Math.max(indexLength - firstEqualIndex, maxWidth);
    }
    tensorShapeFromTensor(t, tShape, isPartial = true) {
        if (tShape.length === 0) {
            if (t[0] === -1) return [];
            throw new Error(`The only valid scalar shape tensor is the fully unknown shape specified as -1.`);
        }
        // MakePartialShape/MakeShapeHelper.
        return $79bde649960f191b$var$makeShape(t, isPartial);
    }
    calculateOutputSize(firstDim) {
        const valueShape = this.valuesShape;
        const defaultValueShape = this.defaultValueShape;
        (0, $lkN62).validateDefaultValueShape(defaultValueShape, valueShape);
        const shape = this.tensorShapeFromTensor(this.shape, this.shapeShape);
        const outputShape = (0, $lkN62).combineRaggedTensorToTensorShapes(this.raggedRank, shape, valueShape);
        const result = outputShape;
        if (result[0] < 0) result[0] = firstDim;
        for(let i = 1; i <= this.raggedRank; ++i)if (result[i] < 0) result[i] = this.getMaxWidth(i);
        return result;
    }
    /**
     * The outputIndex represents the index in the output tensor
     * where the first element of a particular dimension would be written.
     * If it is -1, it indicates that the index is out of scope.
     * Example, given firstDimension = 10, firstDimensionOutput = 6,
     * and outputIndexMultiplier = 100:
     * result = [0 100 200 300 400 500 -1 -1 -1 -1]
     * If firstDimensionOutput = 11 instead, then:
     * result = [0 100 200 300 400 500 600 700 800 900]
     */ calculateFirstParentOutputIndex(firstDimension, outputIndexMultiplier, firstDimensionOutput) {
        const minDimension = Math.min(firstDimension, firstDimensionOutput);
        const result = [];
        let currentOutputIndex = 0;
        for(let i = 0; i < minDimension; ++i, currentOutputIndex += outputIndexMultiplier)result.push(currentOutputIndex);
        for(let i = minDimension; i < firstDimension; ++i)result.push(-1);
        (0, $wx9lK).assert(result.length === firstDimension, ()=>'Final length of result must be equal to firstDimension.');
        return result;
    }
    calculateOutputIndexRowSplit(rowSplit, parentOutputIndex, outputIndexMultiplier, outputSize) {
        const rowSplitSize = rowSplit.length;
        const result = [];
        for(let i = 0; i < rowSplitSize - 1; ++i){
            const rowLength = rowSplit[i + 1] - rowSplit[i];
            let realLength = Math.min(outputSize, rowLength);
            let parentOutputIndexCurrent = parentOutputIndex[i];
            if (parentOutputIndexCurrent === -1) realLength = 0;
            for(let j = 0; j < realLength; ++j){
                result.push(parentOutputIndexCurrent);
                parentOutputIndexCurrent += outputIndexMultiplier;
            }
            for(let j = 0; j < rowLength - realLength; ++j)result.push(-1);
        }
        if (rowSplitSize > 0 && result.length !== rowSplit[rowSplitSize - 1]) throw new Error('Invalid row split size.');
        return result;
    }
    // Calculate the output index of the first element of a list.
    // The parentOutputIndex is the same computation for the previous list.
    // -1 indicates an element or list that is out of range.
    // The outputIndexMultiplier is the number of output indices one moves
    // forward for each column.
    // E.g., given:
    // valueRowIds:[0 1 2 2 2 3 5 5 6]
    // parentOutputIndex:[1000 1100 2000 2100 -1 3000 4000]
    // outputIndexMultiplier: 10
    // outputSize: 2
    // You get:
    // result = [1000 1100 2000 2010 -1 2100 -1 -1 3000]
    // result[0] = parentOutputIndex[valueRowIds[0]]
    // result[1] = parentOutputIndex[valueRowIds[1]]
    // result[2] = parentOutputIndex[valueRowIds[2]]
    // result[3] = parentOutputIndex[valueRowIds[2] + 10]
    // result[4] = -1 because it is the third element the size is 2.
    // result[5] = parentOutputIndex[valueRowIds[3]]
    // result[6] = -1 because parentOutputIndex[valueRowIds[6]] == -1
    // result[7] = -1 because parentOutputIndex[valueRowIds[6]] == -1
    // result[8] = parentOutputIndex[valueRowIds[7]]
    calculateOutputIndexValueRowID(valueRowIds, parentOutputIndex, outputIndexMultiplier, outputSize) {
        const indexSize = valueRowIds.length;
        const result = [];
        if (indexSize === 0) return [];
        let currentOutputColumn = 0;
        let currentValueRowId = valueRowIds[0];
        if (currentValueRowId >= parentOutputIndex.length) throw new Error(`Got currentValueRowId=${currentValueRowId}, which is not less than ${parentOutputIndex.length}`);
        let currentOutputIndex = parentOutputIndex[currentValueRowId];
        result.push(currentOutputIndex);
        for(let i = 1; i < indexSize; ++i){
            const nextValueRowId = valueRowIds[i];
            if (nextValueRowId === currentValueRowId) {
                if (currentOutputIndex >= 0) {
                    ++currentOutputColumn;
                    if (currentOutputColumn < outputSize) currentOutputIndex += outputIndexMultiplier;
                    else currentOutputIndex = -1;
                }
            } else {
                currentOutputColumn = 0;
                currentValueRowId = nextValueRowId;
                if (nextValueRowId >= parentOutputIndex.length) throw new Error(`Got nextValueRowId=${nextValueRowId} which is not less than ${parentOutputIndex.length}`);
                currentOutputIndex = parentOutputIndex[nextValueRowId];
            }
            result.push(currentOutputIndex);
        }
        if (result.length !== valueRowIds.length) throw new Error('Invalid row ids.');
        return result;
    }
    calculateOutputIndex(dimension, parentOutputIndex, outputIndexMultiplier, outputSize) {
        const rowPartitionTensor = this.getRowPartitionTensor(dimension);
        const partitionType = this.getRowPartitionTypeByDimension(dimension);
        switch(partitionType){
            case $79bde649960f191b$var$RowPartitionType.VALUE_ROWIDS:
                return this.calculateOutputIndexValueRowID(rowPartitionTensor, parentOutputIndex, outputIndexMultiplier, outputSize);
            case $79bde649960f191b$var$RowPartitionType.ROW_SPLITS:
                if (rowPartitionTensor.length - 1 > parentOutputIndex.length) throw new Error(`Row partition size is greater than output size: ${rowPartitionTensor.length - 1} > ${parentOutputIndex.length}`);
                return this.calculateOutputIndexRowSplit(rowPartitionTensor, parentOutputIndex, outputIndexMultiplier, outputSize);
            default:
                throw new Error(`Unsupported partition type: ${$79bde649960f191b$var$RowPartitionType[partitionType]}`);
        }
    }
    getFirstDimensionSize() {
        const firstPartitionTensor = this.rowPartitionValues[0];
        if (this.rowPartitionTypes.length === 0) throw new Error('No row_partition_types given.');
        const firstPartitionType = this.rowPartitionTypes[0];
        switch(firstPartitionType){
            case $79bde649960f191b$var$RowPartitionType.FIRST_DIM_SIZE:
                return firstPartitionTensor[0];
            case $79bde649960f191b$var$RowPartitionType.VALUE_ROWIDS:
                throw new Error('Cannot handle VALUE_ROWIDS in first dimension.');
            case $79bde649960f191b$var$RowPartitionType.ROW_SPLITS:
                return this.rowPartitionValuesShapes[0][0] - 1;
            default:
                throw new Error(`Cannot handle type ${$79bde649960f191b$var$RowPartitionType[firstPartitionType]}`);
        }
    }
    compute() {
        const firstPartitionTensor = this.rowPartitionValues[0];
        if (firstPartitionTensor.length <= 0) throw new Error("Invalid first partition input. Tensor requires at least one element.");
        const firstDimension = this.getFirstDimensionSize();
        const outputSize = this.calculateOutputSize(firstDimension);
        const multiplier = new Array(this.raggedRank + 1);
        multiplier[multiplier.length - 1] = 1;
        for(let i = multiplier.length - 2; i >= 0; --i)multiplier[i] = multiplier[i + 1] * outputSize[i + 1];
        // Full size of the tensor.
        const outputShape = $79bde649960f191b$var$makeShape(outputSize, false);
        const outputTensor = (0, $wx9lK).getArrayFromDType(this.valuesDType, (0, $wx9lK).sizeFromShape(outputShape));
        const fullSize = multiplier[0] * outputSize[0];
        if (fullSize > 0) {
            let outputIndex = this.calculateFirstParentOutputIndex(firstDimension, multiplier[0], outputSize[0]);
            for(let i = 1; i <= this.raggedRank; ++i){
                const newOutputIndex = this.calculateOutputIndex(i - 1, outputIndex, multiplier[i], outputSize[i]);
                outputIndex = newOutputIndex;
            }
            this.setOutput(this.raggedRank, outputIndex, outputTensor, outputShape);
        }
        return [
            outputShape,
            outputTensor
        ];
    }
    setOutput(raggedRank, outputIndex, outputTensor, outputShape) {
        if (outputTensor.length === 0) return;
        const valuesBase = this.values;
        const outputBase = outputTensor;
        let elementShape = outputShape.slice();
        elementShape = elementShape.slice(raggedRank + 1);
        const valueElementSize = (0, $wx9lK).sizeFromShape(elementShape);
        const outputIndexSize = outputIndex.length;
        // Broadcast the default value to value_element_size.  (We can skip this
        // if defaultValueTensor.size == 1, since we use fill when that's true.)
        let defaultValue = this.defaultValue;
        if (defaultValue.length !== valueElementSize && defaultValue.length !== 1) {
            const srcShape = this.defaultValueShape;
            (0, $9c0Qr.tidy)(()=>{
                const defaultValueTensor = (0, $eP0pM.reshape)(defaultValue, srcShape);
                const bCastDefault = (0, $eJSTd.broadcastTo)(defaultValueTensor, elementShape);
                defaultValue = bCastDefault.dataSync();
            });
        }
        // Loop through the outputIndex array, finding contiguous regions that
        // should be copied.  Once we find the end of a contiguous region, copy it
        // and add any necessary padding (with defaultValue).
        let srcStart = 0; // Start of contiguous region (in values)
        let dstStart = 0; // Destination for contiguous region (in output)
        let dstEnd = 0; // Destination for contiguous region (in output)
        for(let srcI = 0; srcI <= outputIndexSize; ++srcI){
            // dstI is the destination where the value at srcI should be copied.
            let dstI = srcI < outputIndexSize ? outputIndex[srcI] : -1;
            // If we're still in a contiguous region, then update dstEnd go to the
            // next srcI.
            if (dstI === dstEnd) {
                ++dstEnd;
                continue;
            }
            // We found the end of contiguous region.  This can be because we found
            // a gap (dstI > dstEnd), or a source value that shouldn't be copied
            // because it's out-of-bounds (dstI == -1), or the end of the tensor
            // (dstI === -1).
            if (dstStart < dstEnd) {
                // Copy the contiguous region.
                const src = valuesBase.subarray(srcStart * valueElementSize);
                const dst = outputBase.subarray(dstStart * valueElementSize);
                const nVals = (dstEnd - dstStart) * valueElementSize;
                $79bde649960f191b$var$copyArray(dst, src, nVals);
            }
            // Add any necessary padding (w/ defaultValue).
            if (srcI >= outputIndexSize) {
                // We reached the end of values: pad to the end of output.
                const outputSize = outputTensor.length;
                dstI = Math.floor(outputSize / valueElementSize);
            }
            if (dstI > dstEnd) {
                if (this.defaultValue.length === 1) {
                    outputBase.subarray(dstEnd * valueElementSize, dstI * valueElementSize).fill(this.defaultValue[0]);
                    dstEnd = dstI;
                } else while(dstI > dstEnd){
                    const dst = outputBase.slice(dstEnd * valueElementSize);
                    $79bde649960f191b$var$copyArray(dst, defaultValue, valueElementSize);
                    ++dstEnd;
                }
            }
            // Update indices.
            if (dstI < 0) {
                // srcI should be skipped -- leave it out of the contiguous region.
                srcStart = srcI + 1;
                dstStart = dstEnd;
            } else {
                // srcI should be copied -- include it in the contiguous region.
                srcStart = srcI;
                dstStart = dstEnd;
                dstEnd = dstStart + 1;
            }
        }
    }
}
function $79bde649960f191b$var$copyArray(dst, src, size) {
    for(let i = 0; i < size; i++)dst[i] = src[i];
}
function $79bde649960f191b$var$makeShape(shape, isPartial) {
    const out = [];
    for (let dim of shape){
        if (dim < 0) {
            if (!isPartial) throw new Error(`Dimension ${dim} must be >= 0`);
            if (dim < -1) throw new Error(`Dimension ${dim} must be >= -1`);
            dim = -1;
        }
        out.push(dim);
    }
    return out;
}
function $79bde649960f191b$export$8194a77b1066327a(shape, shapesShape, values, valuesShape, valuesDType, defaultValue, defaultValueShape, rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes) {
    return new $79bde649960f191b$var$RaggedTensorToTensorOp(shape, shapesShape, values, valuesShape, valuesDType, defaultValue, defaultValueShape, rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes).compute();
}

});


parcelRegister("4fSxJ", function(module, exports) {

$parcel$export(module.exports, "rangeConfig", () => $3192df44edb59fc2$export$361c4075706e31c2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $5QeAM = parcelRequire("5QeAM");
function $3192df44edb59fc2$export$d02631cccf789723(args) {
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, dtype: dtype, step: step } = attrs;
    const values = (0, $5QeAM.rangeImpl)(start, stop, step, dtype);
    return backend.makeTensorInfo([
        values.length
    ], dtype, values);
}
const $3192df44edb59fc2$export$361c4075706e31c2 = {
    kernelName: (0, $dCP8m.Range),
    backendName: 'cpu',
    kernelFunc: $3192df44edb59fc2$export$d02631cccf789723
};

});
parcelRegister("5QeAM", function(module, exports) {

$parcel$export(module.exports, "rangeImpl", () => $440d20cf8b79e6f1$export$3561205b7dff20bf);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
function $440d20cf8b79e6f1$export$3561205b7dff20bf(start, stop, step, dtype) {
    const sameStartStop = start === stop;
    const increasingRangeNegativeStep = start < stop && step < 0;
    const decreasingRangePositiveStep = stop < start && step > 1;
    if (sameStartStop || increasingRangeNegativeStep || decreasingRangePositiveStep) return (0, $wx9lK).makeZerosTypedArray(0, dtype);
    const numElements = Math.abs(Math.ceil((stop - start) / step));
    const values = (0, $wx9lK).makeZerosTypedArray(numElements, dtype);
    if (stop < start && step === 1) // Auto adjust the step's sign if it hasn't been set
    // (or was set to 1)
    step = -1;
    values[0] = start;
    for(let i = 1; i < values.length; i++)values[i] = values[i - 1] + step;
    return values;
}

});


parcelRegister("6XsUn", function(module, exports) {

$parcel$export(module.exports, "reciprocalConfig", () => $510ead5d8770b105$export$412a6b66203fdf72);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $510ead5d8770b105$export$163bc8c839a1ac04 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Reciprocal), (xi)=>1 / xi);
const $510ead5d8770b105$export$412a6b66203fdf72 = {
    kernelName: (0, $dCP8m.Reciprocal),
    backendName: 'cpu',
    kernelFunc: $510ead5d8770b105$export$163bc8c839a1ac04
};

});

parcelRegister("7G1P4", function(module, exports) {

$parcel$export(module.exports, "resizeBilinearConfig", () => $596dde975a4fef71$export$a37a56137abc1357);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $596dde975a4fef71$export$1f1cbc7da93d06a0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    (0, $aPHJu.assertNotComplex)(images, 'resizeBilinear');
    const imagesStrides = (0, $wx9lK).computeStrides(images.shape);
    const [newHeight, newWidth] = size;
    const [batch, oldHeight, oldWidth, numChannels] = images.shape;
    const xValues = backend.data.get(images.dataId).values;
    const result = new Float32Array((0, $wx9lK).sizeFromShape([
        batch,
        newHeight,
        newWidth,
        numChannels
    ]));
    const effectiveInputSize = [
        alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
        alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
    ];
    const effectiveOutputSize = [
        alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
        alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
    ];
    let outputIdx = 0;
    const effectiveRowSizeRatio = effectiveInputSize[0] / effectiveOutputSize[0];
    const effectiveColSizeRatio = effectiveInputSize[1] / effectiveOutputSize[1];
    for(let b = 0; b < batch; b++)for(let r = 0; r < newHeight; r++){
        let sourceFracRow;
        if (halfPixelCenters) sourceFracRow = effectiveRowSizeRatio * (r + 0.5) - 0.5;
        else sourceFracRow = effectiveRowSizeRatio * r;
        const sourceRowFloor = Math.max(0, Math.floor(sourceFracRow));
        const rowFrac = sourceFracRow - sourceRowFloor;
        const sourceRowCeil = Math.min(oldHeight - 1, Math.ceil(sourceFracRow));
        const topRowOffset = b * imagesStrides[0] + sourceRowFloor * imagesStrides[1];
        const botRowOffset = b * imagesStrides[0] + sourceRowCeil * imagesStrides[1];
        for(let c = 0; c < newWidth; c++){
            let sourceFracCol;
            if (halfPixelCenters) sourceFracCol = effectiveColSizeRatio * (c + 0.5) - 0.5;
            else sourceFracCol = effectiveColSizeRatio * c;
            const sourceColFloor = Math.max(0, Math.floor(sourceFracCol));
            const colFrac = sourceFracCol - sourceColFloor;
            const sourceColCeil = Math.min(oldWidth - 1, Math.ceil(sourceFracCol));
            const topLeftOffest = topRowOffset + sourceColFloor * imagesStrides[2];
            const botLeftOffset = botRowOffset + sourceColFloor * imagesStrides[2];
            const topRightOffset = topRowOffset + sourceColCeil * imagesStrides[2];
            const botRightOffest = botRowOffset + sourceColCeil * imagesStrides[2];
            for(let d = 0; d < numChannels; d++){
                // Begin shader.
                // Compute the fractional index of the source.
                const topLeft = xValues[topLeftOffest + d];
                const bottomLeft = xValues[botLeftOffset + d];
                const topRight = xValues[topRightOffset + d];
                const bottomRight = xValues[botRightOffest + d];
                const top = topLeft + (topRight - topLeft) * colFrac;
                const bottom = bottomLeft + (bottomRight - bottomLeft) * colFrac;
                const newValue = top + (bottom - top) * rowFrac;
                result[outputIdx++] = newValue;
            }
        }
    }
    return backend.makeTensorInfo([
        batch,
        newHeight,
        newWidth,
        numChannels
    ], 'float32', result);
}
const $596dde975a4fef71$export$a37a56137abc1357 = {
    kernelName: (0, $dCP8m.ResizeBilinear),
    backendName: 'cpu',
    kernelFunc: $596dde975a4fef71$export$1f1cbc7da93d06a0
};

});

parcelRegister("4gZOF", function(module, exports) {

$parcel$export(module.exports, "resizeBilinearGradConfig", () => $31c89b789d47bf8d$export$51f84ca614e84763);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $31c89b789d47bf8d$export$8899506794ec394(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    (0, $aPHJu.assertNotComplex)([
        dy,
        images
    ], 'resizeBilinearGrad');
    const imagesStrides = (0, $wx9lK).computeStrides(images.shape);
    const [batch, xHeight, xWidth, depth] = images.shape;
    const [, yHeight, yWidth] = dy.shape;
    const output = new Float32Array(batch * xHeight * xWidth * depth);
    // In the backwards pass, we want to find the pixels that were generated
    // for each pixel in the input image the forward pass and add the
    // corresponding coefficient from dy to the gradient (with some
    // interpolation).
    const effectiveXSize = [
        alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
        alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
    ];
    const effectiveYSize = [
        alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
        alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
    ];
    const heightScale = effectiveXSize[0] / effectiveYSize[0];
    const widthScale = effectiveXSize[1] / effectiveYSize[1];
    // Reference implementation
    // tslint:disable-next-line:max-line-length
    // https://github.com/tensorflow/tensorflow/blob/3039375c86a5bbc9610c7725dcaa95d635f87ba2/tensorflow/core/kernels/resize_bilinear_op.cc#L275
    const dyValues = backend.data.get(dy.dataId).values;
    let offset = 0;
    for(let b = 0; b < batch; b++){
        const bOffset = b * imagesStrides[0];
        for(let r = 0; r < yHeight; r++){
            const dxR = r * heightScale;
            const topDxRIndex = Math.floor(dxR);
            const bottomDxRIndex = Math.min(Math.ceil(dxR), xHeight - 1);
            const topDxROffset = bOffset + topDxRIndex * imagesStrides[1];
            const bottomDxROffset = bOffset + bottomDxRIndex * imagesStrides[1];
            const dxRLerp = dxR - topDxRIndex;
            const inverseDxRLerp = 1.0 - dxRLerp;
            for(let c = 0; c < yWidth; c++){
                const dxC = c * widthScale;
                const leftDxCIndex = Math.floor(dxC);
                const rightDxCIndex = Math.min(Math.ceil(dxC), xWidth - 1);
                const dxCLerp = dxC - leftDxCIndex;
                const inverseDxCLerp = 1.0 - dxCLerp;
                const topLeftRCOffset = topDxROffset + leftDxCIndex * imagesStrides[2];
                const topRightRCOffset = topDxROffset + rightDxCIndex * imagesStrides[2];
                const bottomLeftRCOffset = bottomDxROffset + leftDxCIndex * imagesStrides[2];
                const bottomRightRCOffset = bottomDxROffset + rightDxCIndex * imagesStrides[2];
                const inverseDxRLerpTimesInverseDxCLerp = inverseDxRLerp * inverseDxCLerp;
                const inverseDxRLerpTimesDxCLerp = inverseDxRLerp * dxCLerp;
                const dxRLerpTimesInverseDxCLerp = dxRLerp * inverseDxCLerp;
                const dxRLerpTimesDxCLerp = dxRLerp * dxCLerp;
                for(let d = 0; d < depth; d++){
                    const dyVal = dyValues[offset++];
                    output[topLeftRCOffset + d] += dyVal * inverseDxRLerpTimesInverseDxCLerp;
                    output[topRightRCOffset + d] += dyVal * inverseDxRLerpTimesDxCLerp;
                    output[bottomLeftRCOffset + d] += dyVal * dxRLerpTimesInverseDxCLerp;
                    output[bottomRightRCOffset + d] += dyVal * dxRLerpTimesDxCLerp;
                }
            }
        }
    }
    return backend.makeTensorInfo([
        batch,
        xWidth,
        xHeight,
        depth
    ], 'float32', output);
}
const $31c89b789d47bf8d$export$51f84ca614e84763 = {
    kernelName: (0, $dCP8m.ResizeBilinearGrad),
    backendName: 'cpu',
    kernelFunc: $31c89b789d47bf8d$export$8899506794ec394
};

});

parcelRegister("g8J1f", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighborConfig", () => $bc00509528bf9115$export$2b6a92caba113b89);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $bc00509528bf9115$export$74a902ae74ac2560(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    (0, $aPHJu.assertNotComplex)(images, 'resizeNearestNeighbor');
    const imagesStrides = (0, $wx9lK).computeStrides(images.shape);
    const [newHeight, newWidth] = size;
    const [batch, oldHeight, oldWidth, numChannels] = images.shape;
    const xValues = backend.data.get(images.dataId).values;
    const output = new Float32Array(batch * newHeight * newWidth * numChannels);
    const effectiveInputSize = [
        alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
        alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
    ];
    const effectiveOutputSize = [
        alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
        alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
    ];
    const effectiveRowSizeRatio = effectiveInputSize[0] / effectiveOutputSize[0];
    const effectiveColSizeRatio = effectiveInputSize[1] / effectiveOutputSize[1];
    let outputOffset = 0;
    for(let b = 0; b < batch; b++){
        const batchOffset = b * imagesStrides[0];
        for(let r = 0; r < newHeight; r++){
            const sourceFracRow = halfPixelCenters ? effectiveRowSizeRatio * (r + 0.5) : effectiveRowSizeRatio * r;
            let sourceNearestRow = Math.min(oldHeight - 1, alignCorners ? Math.round(sourceFracRow) : Math.floor(sourceFracRow));
            if (halfPixelCenters) sourceNearestRow = Math.max(0, sourceNearestRow);
            const rowOffset = batchOffset + sourceNearestRow * imagesStrides[1];
            for(let c = 0; c < newWidth; c++){
                const sourceFracCol = halfPixelCenters ? effectiveColSizeRatio * (c + 0.5) : effectiveColSizeRatio * c;
                let sourceNearestCol = Math.min(oldWidth - 1, alignCorners ? Math.round(sourceFracCol) : Math.floor(sourceFracCol));
                if (halfPixelCenters) sourceNearestCol = Math.max(0, sourceNearestCol);
                const colOffset = rowOffset + sourceNearestCol * imagesStrides[2];
                for(let d = 0; d < numChannels; d++){
                    // Begin shader.
                    // Compute the fractional index of the source.
                    const newVal = xValues[colOffset + d];
                    output[outputOffset++] = newVal;
                }
            }
        }
    }
    return backend.makeTensorInfo([
        batch,
        newHeight,
        newWidth,
        numChannels
    ], images.dtype, output);
}
const $bc00509528bf9115$export$2b6a92caba113b89 = {
    kernelName: (0, $dCP8m.ResizeNearestNeighbor),
    backendName: 'cpu',
    kernelFunc: $bc00509528bf9115$export$74a902ae74ac2560
};

});

parcelRegister("cGN1v", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighborGradConfig", () => $93cf6f48414f776b$export$2b08d810b5090fe1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $93cf6f48414f776b$export$2b75795f158f1b18(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    (0, $aPHJu.assertNotComplex)([
        dy,
        images
    ], 'resizeNearestNeighborGrad');
    const imagesStrides = (0, $wx9lK).computeStrides(images.shape);
    const dyStrides = (0, $wx9lK).computeStrides(dy.shape);
    const [batch, xHeight, xWidth, depth] = images.shape;
    const [, yHeight, yWidth] = dy.shape;
    const output = new Float32Array(batch * xHeight * xWidth * depth);
    const dyValues = backend.data.get(dy.dataId).values;
    // In the backwards pass, we want to find the pixels that were generated
    // for each pixel in the input image the forward pass
    const effectiveXSize = [
        alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
        alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
    ];
    const effectiveYSize = [
        alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
        alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
    ];
    const heightScale = effectiveXSize[0] / effectiveYSize[0];
    const widthScale = effectiveXSize[1] / effectiveYSize[1];
    const invHeightScale = 1 / heightScale;
    const invWidthScale = 1 / widthScale;
    // This defines the size of the window of values around a particular
    // index in dy that we want to search for contributions to dx.
    const winHeight = Math.ceil(invHeightScale) * 2 + 2;
    const winWidth = Math.ceil(invWidthScale) * 2 + 2;
    // Loop over the output space.
    for(let b = 0; b < batch; b++){
        const batchOffset = b * imagesStrides[0];
        for(let r = 0; r < xHeight; r++){
            const rowOffset = batchOffset + r * imagesStrides[1];
            // Compute bounds for where in dy we will look
            const startRLerp = Math.floor(r * invHeightScale);
            const startDyR = Math.floor(startRLerp - winHeight / 2);
            for(let c = 0; c < xWidth; c++){
                const colOffset = rowOffset + c * imagesStrides[2];
                // Compute bounds for where in dy we will look
                const startCLerp = Math.floor(c * invWidthScale);
                const startDyC = Math.floor(startCLerp - winWidth / 2);
                for(let d = 0; d < depth; d++){
                    let accum = 0;
                    // loop over dy
                    for(let dyRIndex = 0; dyRIndex < winHeight; dyRIndex++){
                        const dyR = dyRIndex + startDyR;
                        // Guard against the window exceeding the bounds of dy
                        if (dyR < 0 || dyR >= yHeight) continue;
                        const dyROffset = batchOffset + dyR * dyStrides[1];
                        const sourceFracRow = dyR * heightScale;
                        const sourceNearestRow = Math.min(xHeight - 1, alignCorners ? Math.round(sourceFracRow) : Math.floor(sourceFracRow));
                        if (r !== sourceNearestRow) continue;
                        for(let dyCIndex = 0; dyCIndex < winWidth; dyCIndex++){
                            const dyC = dyCIndex + startDyC;
                            // Guard against the window exceeding the bounds of dy
                            if (dyC < 0 || dyC >= yWidth) continue;
                            const dyCOffset = dyROffset + dyC * dyStrides[2];
                            const sourceFracCol = dyC * widthScale;
                            const sourceNearestCol = Math.min(xWidth - 1, alignCorners ? Math.round(sourceFracCol) : Math.floor(sourceFracCol));
                            if (c === sourceNearestCol) accum += dyValues[dyCOffset + d];
                        }
                    }
                    output[colOffset + d] = accum;
                }
            }
        }
    }
    return backend.makeTensorInfo(images.shape, images.dtype, output);
}
const $93cf6f48414f776b$export$2b08d810b5090fe1 = {
    kernelName: (0, $dCP8m.ResizeNearestNeighborGrad),
    backendName: 'cpu',
    kernelFunc: $93cf6f48414f776b$export$2b75795f158f1b18
};

});

parcelRegister("g5GUB", function(module, exports) {

$parcel$export(module.exports, "reverseConfig", () => $bb6e665efbc28694$export$cab6a4e8d2ed8e8d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $bVnU9 = parcelRequire("bVnU9");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $6mG8q = parcelRequire("6mG8q");
function $bb6e665efbc28694$export$66c1ae025e96b4bc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dims: dims } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'reverse');
    const xRank = x.shape.length;
    const $dims = (0, $wx9lK).parseAxisParam(dims, x.shape);
    if (xRank === 0) return (0, $6mG8q.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const outBuf = new (0, $bVnU9.TensorBuffer)(x.shape, x.dtype);
    const xBuf = backend.bufferSync(x);
    for(let i = 0; i < outBuf.size; i++){
        const outLoc = outBuf.indexToLoc(i);
        const inLoc = outLoc.slice();
        $dims.forEach((d)=>inLoc[d] = x.shape[d] - 1 - inLoc[d]);
        outBuf.set(xBuf.get(...inLoc), ...outLoc);
    }
    return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
}
const $bb6e665efbc28694$export$cab6a4e8d2ed8e8d = {
    kernelName: (0, $dCP8m.Reverse),
    backendName: 'cpu',
    kernelFunc: $bb6e665efbc28694$export$66c1ae025e96b4bc
};

});

parcelRegister("ksji9", function(module, exports) {

$parcel$export(module.exports, "rotateWithOffsetConfig", () => $ee456320bab9a13a$export$44ba8c83417ab668);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
const $ee456320bab9a13a$export$44ba8c83417ab668 = {
    kernelName: (0, $dCP8m.RotateWithOffset),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { image: image } = inputs;
        const { radians: radians, fillValue: fillValue, center: center } = attrs;
        const cpuBackend = backend;
        const output = (0, $wx9lK).getTypedArrayFromDType(image.dtype, (0, $wx9lK).sizeFromShape(image.shape));
        const [batch, imageHeight, imageWidth, numChannels] = image.shape;
        const [centerX, centerY] = (0, $lkN62).getImageCenter(center, imageHeight, imageWidth);
        const fullOpacityValue = 255;
        const sinFactor = Math.sin(radians);
        const cosFactor = Math.cos(radians);
        const imageVals = cpuBackend.data.get(image.dataId).values;
        for(let batchIdx = 0; batchIdx < batch; batchIdx++){
            const batchOffset = batchIdx * imageWidth * imageHeight * numChannels;
            for(let row = 0; row < imageHeight; row++){
                const rowOffset = row * (imageWidth * numChannels);
                for(let col = 0; col < imageWidth; col++){
                    const colOffset = col * numChannels;
                    for(let channel = 0; channel < numChannels; channel++){
                        const coords = [
                            batch,
                            row,
                            col,
                            channel
                        ];
                        const x = coords[2];
                        const y = coords[1];
                        // coordX/coordY are the result of rotating and translating x/y.
                        let coordX = (x - centerX) * cosFactor - (y - centerY) * sinFactor;
                        let coordY = (x - centerX) * sinFactor + (y - centerY) * cosFactor;
                        coordX = Math.round(coordX + centerX);
                        coordY = Math.round(coordY + centerY);
                        let outputValue = fillValue;
                        if (typeof fillValue !== 'number') {
                            if (channel === 3) outputValue = fullOpacityValue;
                            else outputValue = fillValue[channel];
                        }
                        // If the coordinate position falls within the image boundaries...
                        if (coordX >= 0 && coordX < imageWidth && coordY >= 0 && coordY < imageHeight) {
                            // set the output to the image value at the coordinate position.
                            const rotatedRowOffset = coordY * (imageWidth * numChannels);
                            const rotatedColOffset = coordX * numChannels;
                            const imageIdx = batchOffset + rotatedRowOffset + rotatedColOffset + channel;
                            outputValue = imageVals[imageIdx];
                        }
                        const outIdx = batchOffset + rowOffset + colOffset + channel;
                        output[outIdx] = outputValue;
                    }
                }
            }
        }
        const dataId = cpuBackend.write(output, image.shape, image.dtype);
        return {
            dataId: dataId,
            shape: image.shape,
            dtype: image.dtype
        };
    }
};

});

parcelRegister("ckZSW", function(module, exports) {

$parcel$export(module.exports, "roundConfig", () => $8fb75b64b3b54333$export$6c09e3291f636503);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $8fb75b64b3b54333$export$2077e0241d6afd3c = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Round), (xi)=>{
    // The algorithm is based on banker's rounding.
    const base = Math.floor(xi);
    if (xi - base < 0.5) return Math.floor(xi);
    else if (xi - base > 0.5) return Math.ceil(xi);
    else {
        if (base % 2.0 === 0.0) return base;
        else return base + 1.0;
    }
});
const $8fb75b64b3b54333$export$6c09e3291f636503 = {
    kernelName: (0, $dCP8m.Round),
    backendName: 'cpu',
    kernelFunc: $8fb75b64b3b54333$export$2077e0241d6afd3c
};

});

parcelRegister("1JZ4H", function(module, exports) {

$parcel$export(module.exports, "rsqrtImpl", () => $14495e940c44efa1$export$7ec24de9bffc6b90);
$parcel$export(module.exports, "rsqrtConfig", () => $14495e940c44efa1$export$941104b789956ef6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $021b6 = parcelRequire("021b6");

var $lfZyz = parcelRequire("lfZyz");
const $14495e940c44efa1$export$7ec24de9bffc6b90 = (0, $021b6.createSimpleUnaryImpl)((xi)=>1 / Math.sqrt(xi));
const $14495e940c44efa1$export$1cc01d192953037e = (0, $lfZyz.unaryKernelFuncFromImpl)((0, $dCP8m.Rsqrt), $14495e940c44efa1$export$7ec24de9bffc6b90);
const $14495e940c44efa1$export$941104b789956ef6 = {
    kernelName: (0, $dCP8m.Rsqrt),
    backendName: 'cpu',
    kernelFunc: $14495e940c44efa1$export$1cc01d192953037e
};

});

parcelRegister("eDNPr", function(module, exports) {

$parcel$export(module.exports, "scatterNdConfig", () => $aa8b5c26280ea292$export$573371744f044f5);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $89Bm1 = parcelRequire("89Bm1");
function $aa8b5c26280ea292$export$b6f42038a536d877(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices, updates: updates } = inputs;
    const { shape: shape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $lkN62).calculateShapes(updates, indices, shape);
    const sumDupeIndices = true;
    const indicesBuf = backend.bufferSync(indices);
    const updatesBuf = backend.bufferSync(updates);
    const outBuf = (0, $89Bm1.scatterImpl)(indicesBuf, updatesBuf, shape, outputSize, sliceSize, numUpdates, sliceRank, strides, 0 /* defaultValue */ , sumDupeIndices);
    return backend.makeTensorInfo(shape, outBuf.dtype, outBuf.values);
}
const $aa8b5c26280ea292$export$573371744f044f5 = {
    kernelName: (0, $dCP8m.ScatterNd),
    backendName: 'cpu',
    kernelFunc: $aa8b5c26280ea292$export$b6f42038a536d877
};

});
parcelRegister("89Bm1", function(module, exports) {

$parcel$export(module.exports, "scatterImpl", () => $5efc23bb8e11f8e6$export$5fc9b0358a19bd54);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $g81BN = parcelRequire("g81BN");
function $5efc23bb8e11f8e6$export$5fc9b0358a19bd54(indices, updates, shape, outputSize, sliceSize, numUpdates, sliceRank, strides, defaultValue, sumDupeIndices) {
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    const indicesData = indices.values;
    const updatesData = updates.values;
    if (outputSize === 0) return (0, $g81BN.buffer)(shape, updates.dtype);
    const outBuf = (0, $g81BN.buffer)(flattenShape, updates.dtype);
    if (typeof defaultValue === 'string') outBuf.values.fill(defaultValue);
    else if (typeof defaultValue === 'number') outBuf.values.fill(defaultValue);
    else if (typeof defaultValue === 'boolean') outBuf.values.fill(+defaultValue);
    for(let i = 0; i < numUpdates; i++){
        const index = [];
        let flattenIndex = 0;
        for(let j = 0; j < sliceRank; j++){
            const dim = indicesData[i * sliceRank + j];
            index.push(dim);
            flattenIndex += dim * strides[j];
        }
        if (flattenIndex < 0 || flattenIndex >= outputSize / sliceSize) throw new Error(`Invalid indices: ${index} does not index into ${shape}`);
        for(let k = 0; k < sliceSize; k++)if (sumDupeIndices) outBuf.values[flattenIndex * sliceSize + k] += updatesData[i * sliceSize + k];
        else outBuf.values[flattenIndex * sliceSize + k] = updates.rank === 0 ? updatesData[0] : updatesData[i * sliceSize + k];
    }
    return outBuf;
}

});


parcelRegister("7UpTW", function(module, exports) {

$parcel$export(module.exports, "searchSortedConfig", () => $5c21dad300c5b6f8$export$4b437b1a1aa6472f);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $ePrLk = parcelRequire("ePrLk");
function $5c21dad300c5b6f8$export$56fad8d65b0adbdd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sortedSequence: sortedSequence, values: values } = inputs;
    const { side: side } = attrs;
    const $sortedSequence = backend.data.get(sortedSequence.dataId).values;
    const $values = backend.data.get(values.dataId).values;
    const output = (0, $ePrLk.searchSortedImpl)($sortedSequence, $values, sortedSequence.shape[0], sortedSequence.shape[1], values.shape[1], side);
    return backend.makeTensorInfo(values.shape, 'int32', output);
}
const $5c21dad300c5b6f8$export$4b437b1a1aa6472f = {
    kernelName: (0, $dCP8m.SearchSorted),
    backendName: 'cpu',
    kernelFunc: $5c21dad300c5b6f8$export$56fad8d65b0adbdd
};

});
parcelRegister("ePrLk", function(module, exports) {

$parcel$export(module.exports, "searchSortedImpl", () => $acbb5d1e5fca10f6$export$dbd5299c7ff33b30);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
function $acbb5d1e5fca10f6$var$lowerBound(array, value) {
    let left = 0;
    let right = array.length;
    let mid = 0;
    while(left < right){
        mid = Math.floor((left + right) / 2);
        if (array[mid] < value) left = mid + 1;
        else right = mid;
    }
    return right;
}
function $acbb5d1e5fca10f6$var$upperBound(array, value) {
    let left = 0;
    let right = array.length;
    let mid = 0;
    while(left < right){
        mid = Math.floor((left + right) / 2);
        if (array[mid] <= value) left = mid + 1;
        else right = mid;
    }
    return right;
}
function $acbb5d1e5fca10f6$export$dbd5299c7ff33b30(sortedInputs, values, batchSize, numInputs, numValues, side) {
    const output = (0, $wx9lK).getArrayFromDType('int32', batchSize * numValues);
    for(let b = 0; b < batchSize; ++b){
        const sortedInputsSlice = sortedInputs.slice(b * numInputs, (b + 1) * numInputs);
        const outputOffset = b * numValues;
        for(let i = 0; i < numValues; ++i)output[outputOffset + i] = side === 'left' ? $acbb5d1e5fca10f6$var$lowerBound(sortedInputsSlice, values[i + outputOffset]) : $acbb5d1e5fca10f6$var$upperBound(sortedInputsSlice, values[i + outputOffset]);
    }
    return output;
}

});


parcelRegister("faIEI", function(module, exports) {

$parcel$export(module.exports, "selectConfig", () => $b0ba6de7a7388f1a$export$7ff911e710ee72fc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $bnEYl = parcelRequire("bnEYl");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");
function $b0ba6de7a7388f1a$export$2e6c959c16ff56b8(args) {
    const { inputs: inputs, backend: backend } = args;
    const { condition: condition, t: t, e: e } = inputs;
    (0, $aPHJu.assertNotComplex)([
        condition,
        t,
        e
    ], 'select');
    const conditionRank = condition.shape.length;
    const values = backend.data.get(condition.dataId).values;
    const tValues = backend.data.get(t.dataId).values;
    const eValues = backend.data.get(e.dataId).values;
    const resultDtype = (0, $bnEYl.upcastType)(t.dtype, e.dtype);
    const newValues = (0, $wx9lK).makeZerosTypedArray((0, $wx9lK).sizeFromShape(t.shape), resultDtype);
    let index = 0;
    const offset = conditionRank === 0 || conditionRank > 1 || t.shape.length === 1 ? 1 : (0, $wx9lK).sizeFromShape(t.shape.slice(1));
    for(let i = 0; i < values.length; i++){
        for(let j = 0; j < offset; j++)if (values[i] === 1) newValues[index++] = tValues[i];
        else newValues[index++] = eValues[i];
    }
    return backend.makeTensorInfo(t.shape, resultDtype, newValues);
}
const $b0ba6de7a7388f1a$export$7ff911e710ee72fc = {
    kernelName: (0, $dCP8m.Select),
    backendName: 'cpu',
    kernelFunc: $b0ba6de7a7388f1a$export$2e6c959c16ff56b8
};

});

parcelRegister("9goGn", function(module, exports) {

$parcel$export(module.exports, "seluConfig", () => $6be8c11ab19351d5$export$8afc8558705c1a39);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $6be8c11ab19351d5$var$scaleAlpha = (0, $lkN62).SELU_SCALEALPHA;
const $6be8c11ab19351d5$var$scale = (0, $lkN62).SELU_SCALE;
const $6be8c11ab19351d5$export$a5f8240d9e99b438 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Selu), (xi)=>{
    if (xi >= 0) return $6be8c11ab19351d5$var$scale * xi;
    else return $6be8c11ab19351d5$var$scaleAlpha * (Math.exp(xi) - 1);
});
const $6be8c11ab19351d5$export$8afc8558705c1a39 = {
    kernelName: (0, $dCP8m.Selu),
    backendName: 'cpu',
    kernelFunc: $6be8c11ab19351d5$export$a5f8240d9e99b438
};

});

parcelRegister("7lqVU", function(module, exports) {

$parcel$export(module.exports, "signConfig", () => $558f62e6226e9862$export$9c0fb3eb2124ceb7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $558f62e6226e9862$export$c5552dfdbc7cec71 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Sign), (xi)=>{
    if (xi < 0) return -1;
    else if (xi > 0) return 1;
    else return 0;
});
const $558f62e6226e9862$export$9c0fb3eb2124ceb7 = {
    kernelName: (0, $dCP8m.Sign),
    backendName: 'cpu',
    kernelFunc: $558f62e6226e9862$export$c5552dfdbc7cec71
};

});

parcelRegister("fUXIH", function(module, exports) {

$parcel$export(module.exports, "sinConfig", () => $b96a6921ed647df8$export$d993ec4e5c253b66);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $b96a6921ed647df8$export$5de3937cb4b592ed = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Sin), (xi)=>Math.sin(xi));
const $b96a6921ed647df8$export$d993ec4e5c253b66 = {
    kernelName: (0, $dCP8m.Sin),
    backendName: 'cpu',
    kernelFunc: $b96a6921ed647df8$export$5de3937cb4b592ed
};

});

parcelRegister("9BvTb", function(module, exports) {

$parcel$export(module.exports, "sinhConfig", () => $6fe04e448efc0cf5$export$b92766b47f18ac85);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $6fe04e448efc0cf5$export$545004b505d7c555 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Sinh), (xi)=>Math.sinh(xi));
const $6fe04e448efc0cf5$export$b92766b47f18ac85 = {
    kernelName: (0, $dCP8m.Sinh),
    backendName: 'cpu',
    kernelFunc: $6fe04e448efc0cf5$export$545004b505d7c555
};

});

parcelRegister("i3TxW", function(module, exports) {

$parcel$export(module.exports, "softplusConfig", () => $d2639832c4c4bc25$export$d9bcfe553d12d9e3);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
// mirrors the implementation of tf.nn.softplus: https://goo.gl/vkcvwX
// epsilon is the difference between 1.0 and the next representable float.
// For a single precision 32 bit float this should be 2^-23, see:
// https://math.byu.edu/~schow/work/IEEEFloatingPoint.htm
const $d2639832c4c4bc25$var$epsilon = 1.1920928955078125e-7;
const $d2639832c4c4bc25$var$threshold = Math.log($d2639832c4c4bc25$var$epsilon) + 2.0;
const $d2639832c4c4bc25$export$76aa560a8c2b0055 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Softplus), (xi)=>{
    // Value above which exp(x) may overflow, but softplus(x) == x
    // is within machine epsilon.
    const tooLarge = xi > -$d2639832c4c4bc25$var$threshold;
    // Value below which exp(x) may underflow, but softplus(x) == exp(x)
    // is within machine epsilon.
    const tooSmall = xi < $d2639832c4c4bc25$var$threshold;
    const expX = Math.exp(xi);
    let result;
    if (tooSmall) result = expX;
    else if (tooLarge) result = xi;
    else result = Math.log(1.0 + expX);
    return result;
});
const $d2639832c4c4bc25$export$d9bcfe553d12d9e3 = {
    kernelName: (0, $dCP8m.Softplus),
    backendName: 'cpu',
    kernelFunc: $d2639832c4c4bc25$export$76aa560a8c2b0055
};

});

parcelRegister("eEwtc", function(module, exports) {

$parcel$export(module.exports, "spaceToBatchNDConfig", () => $aaadfcf611f7b9cf$export$2f85417863d2050b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $flmof = parcelRequire("flmof");

var $3qzJ7 = parcelRequire("3qzJ7");

var $9buNR = parcelRequire("9buNR");
function $aaadfcf611f7b9cf$export$effb9d7cae92012f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, paddings: paddings } = attrs;
    (0, $aPHJu.assertNotComplex)([
        x
    ], 'spaceToBatchND');
    const prod = (0, $wx9lK).sizeFromShape(blockShape);
    const completePaddings = [
        [
            0,
            0
        ]
    ];
    completePaddings.push(...paddings);
    for(let i = 1 + blockShape.length; i < x.shape.length; ++i)completePaddings.push([
        0,
        0
    ]);
    const paddedX = (0, $flmof.padV2Config).kernelFunc({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            paddings: completePaddings,
            constantValue: 0
        }
    });
    const reshapedPaddedShape = (0, $lkN62).getReshaped(paddedX.shape, blockShape, prod, false);
    const permutedReshapedPaddedPermutation = (0, $lkN62).getPermuted(reshapedPaddedShape.length, blockShape.length, false);
    const flattenShape = (0, $lkN62).getReshapedPermuted(paddedX.shape, blockShape, prod, false);
    const reshapeInputs = {
        x: paddedX
    };
    const reshapeAttrs = {
        shape: reshapedPaddedShape
    };
    const paddedXReshaped = (0, $3qzJ7.reshape)({
        inputs: reshapeInputs,
        backend: backend,
        attrs: reshapeAttrs
    });
    const transposeInputs = {
        x: paddedXReshaped
    };
    const transposeAttrs = {
        perm: permutedReshapedPaddedPermutation
    };
    const paddedXT = (0, $9buNR.transpose)({
        inputs: transposeInputs,
        backend: backend,
        attrs: transposeAttrs
    });
    const resultReshapeInputs = {
        x: paddedXT
    };
    const resultReshapeAttrs = {
        shape: flattenShape
    };
    const result = (0, $3qzJ7.reshape)({
        inputs: resultReshapeInputs,
        backend: backend,
        attrs: resultReshapeAttrs
    });
    backend.disposeIntermediateTensorInfo(paddedX);
    backend.disposeIntermediateTensorInfo(paddedXReshaped);
    backend.disposeIntermediateTensorInfo(paddedXT);
    return result;
}
const $aaadfcf611f7b9cf$export$2f85417863d2050b = {
    kernelName: (0, $dCP8m.SpaceToBatchND),
    backendName: 'cpu',
    kernelFunc: $aaadfcf611f7b9cf$export$effb9d7cae92012f
};

});

parcelRegister("5otIo", function(module, exports) {

$parcel$export(module.exports, "sparseFillEmptyRowsConfig", () => $3ed63e6a41caed4c$export$818286c593224d1a);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lMkFK = parcelRequire("lMkFK");
function $3ed63e6a41caed4c$export$c82a1904a15b5028(args) {
    const { inputs: inputs, backend: backend } = args;
    const { indices: indices, values: values, denseShape: denseShape, defaultValue: defaultValue } = inputs;
    if (denseShape.shape.length !== 1) throw new Error(`Dense shape must be a vector, saw:
        ${denseShape.shape}`);
    if (indices.shape.length !== 2) throw new Error(`Indices must be a matrix, saw:
        ${indices.shape}`);
    if (values.shape.length !== 1) throw new Error(`Values must be a vector, saw:
        ${values.shape}`);
    if (defaultValue.shape.length !== 0) throw new Error(`Default value must be a scalar, saw:
        ${defaultValue.shape}`);
    const $indices = backend.data.get(indices.dataId).values;
    const $values = backend.data.get(values.dataId).values;
    const $denseShape = backend.data.get(denseShape.dataId).values;
    const $defaultValue = backend.data.get(defaultValue.dataId).values[0];
    const [outputIndices, outputIndicesShape, outputValues, emptyRowIndicator, reverseIndexMap] = (0, $lMkFK.sparseFillEmptyRowsImpl)($indices, indices.shape, indices.dtype, $values, values.dtype, $denseShape, $defaultValue);
    return [
        backend.makeTensorInfo(outputIndicesShape, indices.dtype, outputIndices),
        backend.makeTensorInfo([
            outputIndicesShape[0]
        ], values.dtype, outputValues),
        backend.makeTensorInfo([
            emptyRowIndicator.length
        ], 'bool', new Uint8Array(emptyRowIndicator.map((value)=>Number(value)))),
        backend.makeTensorInfo([
            reverseIndexMap.length
        ], indices.dtype, new Int32Array(reverseIndexMap))
    ];
}
const $3ed63e6a41caed4c$export$818286c593224d1a = {
    kernelName: (0, $dCP8m.SparseFillEmptyRows),
    backendName: 'cpu',
    kernelFunc: $3ed63e6a41caed4c$export$c82a1904a15b5028
};

});
parcelRegister("lMkFK", function(module, exports) {

$parcel$export(module.exports, "sparseFillEmptyRowsImpl", () => $fdae1dca2b09b116$export$9db01208a1bec190);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");
function $fdae1dca2b09b116$export$9db01208a1bec190(indices, indicesShape, indicesDType, values, valuesDType, denseShape, defaultValue) {
    const indicesCount = indicesShape[0];
    const denseRows = denseShape[0];
    const emptyRowIndicator = new Array(denseRows);
    const reverseIndexMap = new Array(indicesCount);
    const rank = indicesShape[1];
    if (denseRows === 0) {
        if (indicesCount !== 0) throw new Error((0, $lkN62).getSparseFillEmptyRowsIndicesDenseShapeMismatch(indicesCount));
        const outputIndices = (0, $wx9lK).getArrayFromDType(indicesDType, 0);
        const outputValues = (0, $wx9lK).getArrayFromDType(valuesDType, 0);
        return [
            outputIndices,
            [
                0,
                rank
            ],
            outputValues,
            emptyRowIndicator,
            reverseIndexMap
        ];
    }
    let rowsAreOrdered = true;
    let lastIndicesRow = 0;
    const csrOffset = new Array(denseRows).fill(0);
    for(let i = 0; i < indicesCount; ++i){
        // indices is a 2d tensor with shape of [N, rank]
        const row = indices[i * rank];
        if (row < 0) throw new Error((0, $lkN62).getSparseFillEmptyRowsNegativeIndexErrorMessage(i, row));
        if (row >= denseRows) throw new Error((0, $lkN62).getSparseFillEmptyRowsOutOfRangeIndexErrorMessage(i, row, denseRows));
        ++csrOffset[row];
        rowsAreOrdered = rowsAreOrdered && row >= lastIndicesRow;
        lastIndicesRow = row;
    }
    let allRowsFull = true;
    for(let row = 0; row < denseRows; ++row){
        // csrOffset here describes the number of elements in this dense row
        const rowEmpty = csrOffset[row] === 0;
        emptyRowIndicator[row] = rowEmpty;
        allRowsFull = allRowsFull && !rowEmpty;
        // In filled version, each row has at least one element.
        csrOffset[row] = Math.max(csrOffset[row], 1);
        // Update csrOffset to represent the number of elements up to and
        // including denseRows + 1:
        //  csrOffset[0] == #{elements of row 0}
        //  csrOffset[1] == #{elements of row 1} + #{elements of row 0}
        //  ..
        //  csrOffset[i] == starting index for elements in row i + 1.
        if (row > 0) csrOffset[row] += csrOffset[row - 1];
    }
    if (allRowsFull && rowsAreOrdered) {
        const outputIndices = indices;
        const outputValues = values;
        for(let i = 0; i < indicesCount; ++i)reverseIndexMap[i] = i;
        return [
            outputIndices,
            [
                indicesCount,
                rank
            ],
            outputValues,
            emptyRowIndicator,
            reverseIndexMap
        ];
    } else {
        const fullIndicesCount = csrOffset[denseRows - 1];
        const outputIndices = (0, $wx9lK).getArrayFromDType(indicesDType, fullIndicesCount * rank);
        const outputValues = (0, $wx9lK).getArrayFromDType(valuesDType, fullIndicesCount);
        const filledCount = new Array(denseRows).fill(0);
        // Fill in values for rows that are not missing
        for(let i = 0; i < indicesCount; ++i){
            // indices is a 2d tensor with shape of [N, rank]
            const row = indices[i * rank];
            const offset = filledCount[row];
            const outputI = (row === 0 ? 0 : csrOffset[row - 1]) + offset;
            filledCount[row]++; // Increment the filled count for this row.
            for(let j = 0; j < rank; ++j)// indices and outputIndices are 2d tensors with shape of [N, rank]
            outputIndices[outputI * rank + j] = indices[i * rank + j];
            outputValues[outputI] = values[i];
            // We'll need this reverse index map to backprop correctly.
            reverseIndexMap[i] = outputI;
        }
        // Fill in values for rows that are missing
        for(let row = 0; row < denseRows; ++row){
            const rowCount = filledCount[row];
            if (rowCount === 0) {
                const startingIndex = row === 0 ? 0 : csrOffset[row - 1];
                // Remaining index values were set to zero already.
                // Just need to set the row index in the right location.
                // outputIndices is a 2d tensor with shape of [N, rank]
                outputIndices[startingIndex * rank + 0] = row;
                for(let col = 1; col < rank; ++col)outputIndices[startingIndex * rank + col] = 0;
                outputValues[startingIndex] = defaultValue;
            }
        }
        return [
            outputIndices,
            [
                fullIndicesCount,
                rank
            ],
            outputValues,
            emptyRowIndicator,
            reverseIndexMap
        ];
    }
}

});


parcelRegister("bRUg4", function(module, exports) {

$parcel$export(module.exports, "sparseReshapeConfig", () => $8a4048aa6f7e3c75$export$eb106efc10374803);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $j5oV1 = parcelRequire("j5oV1");
function $8a4048aa6f7e3c75$export$1408c45865e11fc6(args) {
    const { inputs: inputs, backend: backend } = args;
    const { inputIndices: inputIndices, inputShape: inputShape, newShape: newShape } = inputs;
    if (inputIndices.shape.length !== 2) throw new Error(`Input indices should be a matrix but received shape
        ${inputIndices.shape}`);
    if (inputShape.shape.length !== 1) throw new Error(`Input shape should be a vector but received shape
        ${inputShape.shape}`);
    if (newShape.shape.length !== 1) throw new Error(`Target shape should be a vector but received shape ${newShape.shape}`);
    const $inputShape = Array.from(backend.data.get(inputShape.dataId).values);
    const $inputIndices = backend.data.get(inputIndices.dataId).values;
    const targetShape = Array.from(backend.data.get(newShape.dataId).values);
    const [newIndices, indicesShape, outputShape] = (0, $j5oV1.sparseReshapeImpl)($inputIndices, inputIndices.shape, inputIndices.dtype, $inputShape, targetShape);
    return [
        backend.makeTensorInfo(indicesShape, inputIndices.dtype, newIndices),
        backend.makeTensorInfo([
            outputShape.length
        ], newShape.dtype, new Int32Array(outputShape))
    ];
}
const $8a4048aa6f7e3c75$export$eb106efc10374803 = {
    kernelName: (0, $dCP8m.SparseReshape),
    backendName: 'cpu',
    kernelFunc: $8a4048aa6f7e3c75$export$1408c45865e11fc6
};

});
parcelRegister("j5oV1", function(module, exports) {

$parcel$export(module.exports, "sparseReshapeImpl", () => $de51d043a5b5c5ab$export$a65a15ebab81f5cd);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");
function $de51d043a5b5c5ab$export$a65a15ebab81f5cd(inputIndices, inputIndicesShape, inputDType, inputShape, targetShape) {
    const denseSize = (0, $wx9lK).sizeFromShape(inputShape);
    const nnz = inputIndicesShape[0];
    const outputRank = targetShape.length;
    // Compute the output shape. Determine product of specified dimensions, and
    // find the index of the unspecified one.
    const outputShape = [];
    let product = 1;
    let unknownIndex = -1;
    for(let d = 0; d < outputRank; ++d){
        const size = targetShape[d];
        if (size === -1) {
            if (unknownIndex !== -1) throw new Error((0, $lkN62).getSparseReshapeMultipleNegativeOneOutputDimErrorMessage(unknownIndex, d));
            unknownIndex = d;
            outputShape.push(1);
        } else {
            if (size < 0) throw new Error((0, $lkN62).getSparseReshapeNegativeOutputDimErrorMessage(d, size));
            product *= size;
            outputShape.push(size);
        }
    }
    if (unknownIndex !== -1) {
        if (product <= 0) throw new Error((0, $lkN62).getSparseReshapeEmptyTensorZeroOutputDimErrorMessage());
        const missing = Math.trunc(denseSize / product);
        if (product * missing !== denseSize) throw new Error((0, $lkN62).getSparseReshapeInputOutputMultipleErrorMessage(inputShape, outputShape));
        outputShape[unknownIndex] = missing;
    }
    const outputSize = (0, $wx9lK).sizeFromShape(outputShape);
    if (outputSize !== denseSize) throw new Error((0, $lkN62).getSparseReshapeInputOutputMismatchErrorMessage(inputShape, outputShape));
    const inputRank = inputShape.length;
    const inputStrides = [];
    if (inputRank > 0) {
        inputStrides[inputRank - 1] = 1;
        for(let d = inputRank - 2; d >= 0; --d)inputStrides[d] = inputStrides[d + 1] * inputShape[d + 1];
    }
    const outputStrides = [];
    if (outputRank > 0) {
        outputStrides[outputRank - 1] = 1;
        for(let d = outputRank - 2; d >= 0; --d)outputStrides[d] = outputStrides[d + 1] * outputShape[d + 1];
    }
    const newIndices = (0, $wx9lK).getArrayFromDType(inputDType, nnz * outputRank);
    for(let i = 0; i < nnz; ++i){
        let id = 0;
        for(let j = 0; j < inputRank; ++j)// inputIndices is a 2d tensor with shape of [nnz, inputRank]
        id += inputIndices[i * inputRank + j] * inputStrides[j];
        for(let j = 0; j < outputRank; ++j){
            // newIndices is a 2d tensor with shape of [nnz, outputRank]
            newIndices[i * outputRank + j] = Math.trunc(id / outputStrides[j]);
            id %= outputStrides[j];
        }
    }
    return [
        newIndices,
        [
            nnz,
            outputRank
        ],
        outputShape
    ];
}

});


parcelRegister("dLrGP", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentMeanConfig", () => $a05524c5b757b4d2$export$51e7224ae14d7f78);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $4Nytd = parcelRequire("4Nytd");
function $a05524c5b757b4d2$export$dbc0c9096869d04e(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
          ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
          ${segmentIds.shape}`);
    if (indices.shape[0] !== segmentIds.shape[0]) throw new Error(`segmentIds and indices should have same size.`);
    const $data = backend.data.get(data.dataId).values;
    const $indices = backend.data.get(indices.dataId).values;
    const $segmentIds = backend.data.get(segmentIds.dataId).values;
    const [outputData, outputDataShape] = (0, $4Nytd.sparseSegmentReductionImpl)($data, data.shape, data.dtype, $indices, $segmentIds, true);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $a05524c5b757b4d2$export$51e7224ae14d7f78 = {
    kernelName: (0, $dCP8m.SparseSegmentMean),
    backendName: 'cpu',
    kernelFunc: $a05524c5b757b4d2$export$dbc0c9096869d04e
};

});
parcelRegister("4Nytd", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentReductionImpl", () => $37e67a15cc1825c8$export$7d3f7130c4245e65);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");
function $37e67a15cc1825c8$export$7d3f7130c4245e65(input, inputShape, inputDType, indices, segmentIds, isMean = false, defaultValue = 0) {
    const numIndices = indices.length;
    // Flatten the array to two dimensions
    const inputFlat = [
        inputShape[0],
        input.length / inputShape[0]
    ];
    const numCol = inputFlat[1];
    // Note that the current implementation assumes that segmentIds values are
    // sorted.
    const lastSegmentIdPlusOne = numIndices > 0 ? segmentIds[numIndices - 1] + 1 : 0;
    const outputRows = lastSegmentIdPlusOne;
    if (outputRows < 0) throw new Error((0, $lkN62).getSparseSegmentReductionNegativeSegmentIdsErrorMessage());
    const outputShape = inputShape.slice();
    outputShape[0] = outputRows;
    const outputLength = outputShape.reduce((product, value)=>product * value, 1);
    // Output array is initialized with the value 0 by default.
    const output = (0, $wx9lK).getArrayFromDType(inputDType, outputLength);
    // Note that we do not initialize the output buffer with a default value, so
    // we need to explicitly set missing indices to the default value.
    if (numIndices === 0) {
        if (outputRows > 0) output.fill(defaultValue);
        return [
            output,
            outputShape
        ];
    }
    if (outputRows <= 0) throw new Error((0, $lkN62).getSparseSegmentReductionNegativeSegmentIdsErrorMessage());
    let start = 0, end = 1;
    // Index from which the output is not initialized.
    let uninitializedIndex = 0;
    let outIndex = segmentIds[start];
    while(true){
        // We initialize nextIndex to 0 to avoid may be uninitialized warning
        let nextIndex = 0;
        if (end < numIndices) {
            nextIndex = segmentIds[end];
            if (outIndex === nextIndex) {
                ++end;
                continue;
            }
            // We have a new segment here.  Verify that the segment ids are growing.
            if (outIndex >= nextIndex) throw new Error((0, $lkN62).getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage());
        }
        if (outIndex < 0 || outIndex >= outputRows) throw new Error((0, $lkN62).getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage(outIndex, outputRows));
        // If there is a gap between two indices, we need to set that gap to the
        // default value.
        if (outIndex > uninitializedIndex) output.fill(defaultValue, uninitializedIndex * numCol, outIndex * numCol);
        for(let i = start; i < end; ++i){
            const index = indices[i];
            if (index < 0 || index >= inputFlat[0]) throw new Error((0, $lkN62).getSparseSegmentReductionIndicesOutOfRangeErrorMessage(i, indices[i], inputFlat[0]));
            for(let j = 0; j < numCol; j++)output[outIndex * numCol + j] += input[index * numCol + j];
        }
        if (isMean) for(let j = 0; j < numCol; j++)output[outIndex * numCol + j] /= end - start;
        start = end;
        ++end;
        uninitializedIndex = outIndex + 1;
        outIndex = nextIndex;
        if (end > numIndices) break;
    }
    // Fill the gap at the end with the default value.
    if (uninitializedIndex < outputRows) output.fill(defaultValue, uninitializedIndex * numCol, outputRows * numCol);
    return [
        output,
        outputShape
    ];
}

});


parcelRegister("4GlIz", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentSumConfig", () => $368bee66dac1da42$export$73fa0270f28b9555);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $4Nytd = parcelRequire("4Nytd");
function $368bee66dac1da42$export$2255ce53fc777865(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
         ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
         ${segmentIds.shape}`);
    if (indices.shape[0] !== segmentIds.shape[0]) throw new Error(`segmentIds and indices should have same size.`);
    const $data = backend.data.get(data.dataId).values;
    const $indices = backend.data.get(indices.dataId).values;
    const $segmentIds = backend.data.get(segmentIds.dataId).values;
    const [outputData, outputDataShape] = (0, $4Nytd.sparseSegmentReductionImpl)($data, data.shape, data.dtype, $indices, $segmentIds);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $368bee66dac1da42$export$73fa0270f28b9555 = {
    kernelName: (0, $dCP8m.SparseSegmentSum),
    backendName: 'cpu',
    kernelFunc: $368bee66dac1da42$export$2255ce53fc777865
};

});

parcelRegister("6Y5WS", function(module, exports) {

$parcel$export(module.exports, "sparseToDenseConfig", () => $512cf5f401059a82$export$7bc088f8ad44ef99);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $89Bm1 = parcelRequire("89Bm1");
function $512cf5f401059a82$export$1be4b823dd1a3080(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sparseIndices: sparseIndices, sparseValues: sparseValues, defaultValue: defaultValue } = inputs;
    const { outputShape: outputShape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $lkN62).calculateShapes(sparseValues, sparseIndices, outputShape);
    const sumDupeIndices = false;
    const indicesBuf = backend.bufferSync(sparseIndices);
    let outBuf;
    switch(sparseValues.dtype){
        case 'bool':
            {
                const updatesBuf = backend.bufferSync(sparseValues);
                const $defaultValue = Boolean(backend.data.get(defaultValue.dataId).values[0]);
                outBuf = (0, $89Bm1.scatterImpl)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
                break;
            }
        case 'float32':
            {
                const updatesBuf = backend.bufferSync(sparseValues);
                const $defaultValue = backend.data.get(defaultValue.dataId).values[0];
                outBuf = (0, $89Bm1.scatterImpl)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
                break;
            }
        case 'int32':
            {
                const updatesBuf = backend.bufferSync(sparseValues);
                const $defaultValue = backend.data.get(defaultValue.dataId).values[0];
                outBuf = (0, $89Bm1.scatterImpl)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
                break;
            }
        case 'string':
            {
                const updatesBuf = backend.bufferSync(sparseValues);
                const $defaultValue = (0, $wx9lK).decodeString(backend.data.get(defaultValue.dataId).values[0]);
                outBuf = (0, $89Bm1.scatterImpl)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
                break;
            }
        default:
            throw new Error(`Unsupported type ${sparseValues.dtype}`);
    }
    return backend.makeTensorInfo(outputShape, outBuf.dtype, outBuf.values);
}
const $512cf5f401059a82$export$7bc088f8ad44ef99 = {
    kernelName: (0, $dCP8m.SparseToDense),
    backendName: 'cpu',
    kernelFunc: $512cf5f401059a82$export$1be4b823dd1a3080
};

});

parcelRegister("eBscM", function(module, exports) {

$parcel$export(module.exports, "splitVConfig", () => $aa1a6655dc108d70$export$317be24be3af9ea0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $fyKXa = parcelRequire("fyKXa");
function $aa1a6655dc108d70$export$c0085d48b0a75d8f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { numOrSizeSplits: numOrSizeSplits, axis: axis } = attrs;
    const $axis = (0, $wx9lK).parseAxisParam(axis, x.shape)[0];
    const splitSizes = (0, $lkN62).prepareSplitSize(x, numOrSizeSplits, $axis);
    const begin = new Array(x.shape.length).fill(0);
    const size = x.shape.slice();
    return splitSizes.map((s)=>{
        const sliceSize = [
            ...size
        ];
        sliceSize[$axis] = s;
        const sliceT = (0, $fyKXa.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: sliceSize
            }
        });
        begin[$axis] += s;
        return sliceT;
    });
}
const $aa1a6655dc108d70$export$317be24be3af9ea0 = {
    kernelName: (0, $dCP8m.SplitV),
    backendName: 'cpu',
    kernelFunc: $aa1a6655dc108d70$export$c0085d48b0a75d8f
};

});

parcelRegister("9CCZl", function(module, exports) {

$parcel$export(module.exports, "sqrtImpl", () => $7015e7f4e11f90f7$export$c6f4fdf945028fb);
$parcel$export(module.exports, "sqrtConfig", () => $7015e7f4e11f90f7$export$a592ba9268f10eeb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $021b6 = parcelRequire("021b6");

var $lfZyz = parcelRequire("lfZyz");
const $7015e7f4e11f90f7$export$c6f4fdf945028fb = (0, $021b6.createSimpleUnaryImpl)((xi)=>Math.sqrt(xi));
const $7015e7f4e11f90f7$export$eba8049fb5020b81 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Sqrt), (xi)=>Math.sqrt(xi));
const $7015e7f4e11f90f7$export$a592ba9268f10eeb = {
    kernelName: (0, $dCP8m.Sqrt),
    backendName: 'cpu',
    kernelFunc: $7015e7f4e11f90f7$export$eba8049fb5020b81
};

});

parcelRegister("hsc7d", function(module, exports) {

$parcel$export(module.exports, "squareConfig", () => $cb4e730ac4ffcb5e$export$7c77bece4d51efc4);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");
const $cb4e730ac4ffcb5e$export$7c77bece4d51efc4 = {
    kernelName: (0, $dCP8m.Square),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, backend: backend })=>{
        const { x: x } = inputs;
        const cpuBackend = backend;
        (0, $aPHJu.assertNotComplex)(x, 'square');
        const values = cpuBackend.data.get(x.dataId).values;
        const newValues = new Float32Array(values.length);
        for(let i = 0; i < values.length; ++i){
            const value = values[i];
            newValues[i] = value * value;
        }
        const dataId = cpuBackend.write(newValues, x.shape, x.dtype);
        return {
            dataId: dataId,
            shape: x.shape,
            dtype: x.dtype
        };
    }
};

});

parcelRegister("gigoF", function(module, exports) {

$parcel$export(module.exports, "squaredDifferenceImpl", () => $bdcb0bd798312cf3$export$11806d7b3158c032);
$parcel$export(module.exports, "squaredDifferenceConfig", () => $bdcb0bd798312cf3$export$9ed4691d69db8a43);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aRRHO = parcelRequire("aRRHO");

var $3Zasd = parcelRequire("3Zasd");
const $bdcb0bd798312cf3$export$11806d7b3158c032 = (0, $aRRHO.createSimpleBinaryKernelImpl)((a, b)=>{
    const diff = a - b;
    return diff * diff;
});
const $bdcb0bd798312cf3$export$b178697fb6d0b37f = (0, $3Zasd.binaryKernelFunc)((0, $dCP8m.SquaredDifference), $bdcb0bd798312cf3$export$11806d7b3158c032);
const $bdcb0bd798312cf3$export$9ed4691d69db8a43 = {
    kernelName: (0, $dCP8m.SquaredDifference),
    backendName: 'cpu',
    kernelFunc: $bdcb0bd798312cf3$export$b178697fb6d0b37f
};

});

parcelRegister("iXcUV", function(module, exports) {

$parcel$export(module.exports, "stepConfig", () => $dcc7c1c193b1175a$export$c42ffaf52eb2647);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $dcc7c1c193b1175a$export$35d34bc0ed591a92 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Step), (xi, attrs)=>{
    const stepAttrs = attrs;
    if (isNaN(xi)) return NaN;
    else return xi > 0 ? 1 : stepAttrs.alpha;
});
const $dcc7c1c193b1175a$export$c42ffaf52eb2647 = {
    kernelName: (0, $dCP8m.Step),
    backendName: 'cpu',
    kernelFunc: $dcc7c1c193b1175a$export$35d34bc0ed591a92
};

});

parcelRegister("cm4jn", function(module, exports) {

$parcel$export(module.exports, "stridedSliceConfig", () => $8feae24480b0f3b4$export$81773633114187bd);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $1KPDG = parcelRequire("1KPDG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $3qzJ7 = parcelRequire("3qzJ7");

var $fyKXa = parcelRequire("fyKXa");

var $cDXl8 = parcelRequire("cDXl8");
function $8feae24480b0f3b4$export$4ae57224f3b0605c(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, end: end, strides: strides, beginMask: beginMask, endMask: endMask, ellipsisMask: ellipsisMask, newAxisMask: newAxisMask, shrinkAxisMask: shrinkAxisMask } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'stridedSlice');
    const { finalShapeSparse: finalShapeSparse, finalShape: finalShape, isIdentity: isIdentity, sliceDim0: sliceDim0, isSimpleSlice: isSimpleSlice, begin: $begin, end: $end, strides: $strides } = (0, $1KPDG).sliceInfo(x.shape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
    let result;
    // ref:
    // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/strided_slice_op.cc
    if (isIdentity) // Optimization #1, slice is a no-op plus reshape
    result = (0, $3qzJ7.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    else if (sliceDim0 || isSimpleSlice) {
        // Optimization #2, slice is memory contiguous (only occurs in dim 0)
        (0, $wx9lK).assert(x.shape.length >= 1, ()=>`Input must have rank at least 1, got: ${x.shape.length}`);
        const size = (0, $1KPDG).computeOutShape($begin, $end, $strides);
        // To tolerate begin[0] > end[0] (a 0-output slice), we min(begin, end).
        const sliced = (0, $fyKXa.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: $begin,
                size: size
            }
        });
        result = (0, $3qzJ7.reshape)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: finalShape
            }
        });
        backend.disposeIntermediateTensorInfo(sliced);
    } else {
        const xBuf = backend.bufferSync(x);
        const outBuf = (0, $cDXl8.stridedSliceImpl)(finalShapeSparse, xBuf, $strides, $begin);
        result = backend.makeTensorInfo(finalShape, outBuf.dtype, outBuf.values);
    }
    return result;
}
const $8feae24480b0f3b4$export$81773633114187bd = {
    kernelName: (0, $dCP8m.StridedSlice),
    backendName: 'cpu',
    kernelFunc: $8feae24480b0f3b4$export$4ae57224f3b0605c
};

});
parcelRegister("cDXl8", function(module, exports) {

$parcel$export(module.exports, "stridedSliceImpl", () => $934728350846a424$export$b7c450ffe7e10d88);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $g81BN = parcelRequire("g81BN");
function $934728350846a424$export$b7c450ffe7e10d88(outShape, xBuf, strides, begin) {
    const outBuf = (0, $g81BN.buffer)(outShape, xBuf.dtype);
    for(let i = 0; i < outBuf.size; i++){
        const loc = outBuf.indexToLoc(i);
        const newLoc = new Array(loc.length);
        for(let j = 0; j < newLoc.length; j++)newLoc[j] = loc[j] * strides[j] + begin[j];
        outBuf.set(xBuf.get(...newLoc), ...loc);
    }
    return outBuf;
}

});


parcelRegister("pFryv", function(module, exports) {

$parcel$export(module.exports, "stringNGramsConfig", () => $04d27bb8041feff5$export$35e13284eed34c22);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $bYAEr = parcelRequire("bYAEr");
function $04d27bb8041feff5$export$3490514dcc63b044(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { separator: separator, nGramWidths: nGramWidths, leftPad: leftPad, rightPad: rightPad, padWidth: padWidth, preserveShortSequences: preserveShortSequences } = attrs;
    const { data: data, dataSplits: dataSplits } = inputs;
    const $data = backend.data.get(data.dataId).values;
    const $dataSplits = backend.data.get(dataSplits.dataId).values;
    const [nGrams, nGramsSplits] = (0, $bYAEr.stringNGramsImpl)($data, $dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences);
    return [
        backend.makeTensorInfo([
            nGrams.length
        ], 'string', nGrams),
        backend.makeTensorInfo(dataSplits.shape, 'int32', nGramsSplits)
    ];
}
const $04d27bb8041feff5$export$35e13284eed34c22 = {
    kernelName: (0, $dCP8m.StringNGrams),
    backendName: 'cpu',
    kernelFunc: $04d27bb8041feff5$export$3490514dcc63b044
};

});
parcelRegister("bYAEr", function(module, exports) {

$parcel$export(module.exports, "stringNGramsImpl", () => $8b81ba760d2a02a1$export$67c0958e8184138b);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
/**
 * The StringNGramsOp class creates ngrams from ragged string data.
 * The constructor contains all attributes related to the operation such as
 * padding widths and strings, and the compute function can be used to
 * compute the ngrams for different ragged tensor inputs.
 */ class $8b81ba760d2a02a1$var$StringNGramsOp {
    constructor(separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences){
        this.separator = (0, $wx9lK).encodeString(separator);
        this.nGramWidths = nGramWidths;
        this.leftPad = (0, $wx9lK).encodeString(leftPad);
        this.rightPad = (0, $wx9lK).encodeString(rightPad);
        this.padWidth = padWidth;
        this.preserveShort = preserveShortSequences;
    }
    getPadWidth(nGramWidth) {
        // Ngrams can be padded with either a fixed pad width or a dynamic pad
        // width depending on the 'padWidth' arg, but in no case should the padding
        // ever be wider than 'nGramWidth' - 1.
        return Math.min(this.padWidth < 0 ? nGramWidth - 1 : this.padWidth, nGramWidth - 1);
    }
    getNumNGrams(length, nGramWidth) {
        const padWidth = this.getPadWidth(nGramWidth);
        return Math.max(0, length + 2 * padWidth - nGramWidth + 1);
    }
    createNGrams(data, splitIndex, output, outputStartIndex, numNGrams, nGramWidth) {
        for(let nGramIndex = 0; nGramIndex < numNGrams; ++nGramIndex){
            const padWidth = this.getPadWidth(nGramWidth);
            const leftPadding = Math.max(0, padWidth - nGramIndex);
            const rightPadding = Math.max(0, padWidth - (numNGrams - (nGramIndex + 1)));
            const numTokens = nGramWidth - (leftPadding + rightPadding);
            const dataStartIndex = splitIndex + (leftPadding > 0 ? 0 : nGramIndex - padWidth);
            // Calculate the total expected size of the nGram so we can reserve the
            // correct amount of space in the string.
            let nGramSize = 0;
            // Size of the left padding.
            nGramSize += leftPadding * this.leftPad.length;
            // Size of the tokens.
            for(let n = 0; n < numTokens; ++n)nGramSize += data[dataStartIndex + n].length;
            // Size of the right padding.
            nGramSize += rightPadding * this.rightPad.length;
            // Size of the separators.
            const numSeparators = leftPadding + rightPadding + numTokens - 1;
            nGramSize += numSeparators * this.separator.length;
            // Build the nGram.
            output[outputStartIndex + nGramIndex] = new Uint8Array(nGramSize);
            const nGram = output[outputStartIndex + nGramIndex];
            let nextNGramIndex = 0;
            const appendToNGram = (str)=>str.forEach((value)=>nGram[nextNGramIndex++] = value);
            for(let n = 0; n < leftPadding; ++n){
                appendToNGram(this.leftPad);
                appendToNGram(this.separator);
            }
            // Only output first numTokens - 1 pairs of data and separator
            for(let n = 0; n < numTokens - 1; ++n){
                appendToNGram(data[dataStartIndex + n]);
                appendToNGram(this.separator);
            }
            // Handle case when there are no tokens or no right padding as these
            // can result in consecutive separators.
            if (numTokens > 0) {
                // If we have tokens, then output last and then pair each separator
                // with the right padding that follows, to ensure nGram ends either with
                // the token or with the right pad.
                appendToNGram(data[dataStartIndex + numTokens - 1]);
                for(let n = 0; n < rightPadding; ++n){
                    appendToNGram(this.separator);
                    appendToNGram(this.rightPad);
                }
            } else {
                // If we don't have tokens, then the last item inserted into the nGram
                // has been the separator from the left padding loop above. Hence,
                // output right pad and separator and make sure to finish with a
                // padding, not a separator.
                for(let n = 0; n < rightPadding - 1; ++n){
                    appendToNGram(this.rightPad);
                    appendToNGram(this.separator);
                }
                appendToNGram(this.rightPad);
            }
        }
    }
    // Data and splits together form the definition of the ragged tensor,
    // where data is 1 dimensional and contains the values of the tensor
    // and splits denotes the indices at which each row starts.
    compute(data, splits) {
        // Validate that the splits are valid indices into data, only if there are
        // splits specified.
        const inputDataSize = data.length;
        const splitsSize = splits.length;
        if (splitsSize > 0) {
            let prevSplit = splits[0];
            if (prevSplit !== 0) throw new Error(`First split value must be 0, got ${prevSplit}`);
            for(let i = 1; i < splitsSize; ++i){
                let validSplits = splits[i] >= prevSplit;
                validSplits = validSplits && splits[i] <= inputDataSize;
                if (!validSplits) throw new Error(`Invalid split value ${splits[i]}, must be in [${prevSplit}, ${inputDataSize}]`);
                prevSplit = splits[i];
            }
            if (prevSplit !== inputDataSize) throw new Error(`Last split value must be data size. Expected ${inputDataSize}, got ${prevSplit}`);
        }
        const numBatchItems = splitsSize - 1;
        const nGramsSplits = (0, $wx9lK).getArrayFromDType('int32', splitsSize);
        // If there is no data or size, return an empty ragged tensor.
        if (inputDataSize === 0 || splitsSize === 0) {
            const empty = new Array(inputDataSize);
            for(let i = 0; i <= numBatchItems; ++i)nGramsSplits[i] = 0;
            return [
                empty,
                nGramsSplits
            ];
        }
        nGramsSplits[0] = 0;
        for(let i = 1; i <= numBatchItems; ++i){
            const length = splits[i] - splits[i - 1];
            let numNGrams = 0;
            this.nGramWidths.forEach((nGramWidth)=>{
                numNGrams += this.getNumNGrams(length, nGramWidth);
            });
            if (this.preserveShort && length > 0 && numNGrams === 0) numNGrams = 1;
            nGramsSplits[i] = nGramsSplits[i - 1] + numNGrams;
        }
        const nGrams = new Array(nGramsSplits[numBatchItems]);
        for(let i = 0; i < numBatchItems; ++i){
            const splitIndex = splits[i];
            let outputStartIdx = nGramsSplits[i];
            this.nGramWidths.forEach((nGramWidth)=>{
                const length = splits[i + 1] - splits[i];
                const numNGrams = this.getNumNGrams(length, nGramWidth);
                this.createNGrams(data, splitIndex, nGrams, outputStartIdx, numNGrams, nGramWidth);
                outputStartIdx += numNGrams;
            });
            // If we're preserving short sequences, check to see if no sequence was
            // generated by comparing the current output start idx to the original
            // one (nGramSplitsdata). If no ngrams were generated, then they will
            // be equal (since we increment outputStartIdx by numNGrams every
            // time we create a set of ngrams.)
            if (this.preserveShort && outputStartIdx === nGramsSplits[i]) {
                const dataLength = splits[i + 1] - splits[i];
                // One legitimate reason to not have any ngrams when this.preserveShort
                // is true is if the sequence itself is empty. In that case, move on.
                if (dataLength === 0) continue;
                // We don't have to worry about dynamic padding sizes here: if padding
                // was dynamic, every sequence would have had sufficient padding to
                // generate at least one nGram.
                const nGramWidth = dataLength + 2 * this.padWidth;
                const numNGrams = 1;
                this.createNGrams(data, splitIndex, nGrams, outputStartIdx, numNGrams, nGramWidth);
            }
        }
        return [
            nGrams,
            nGramsSplits
        ];
    }
}
function $8b81ba760d2a02a1$export$67c0958e8184138b(data, dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences) {
    return new $8b81ba760d2a02a1$var$StringNGramsOp(separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences).compute(data, dataSplits);
}

});


parcelRegister("8jAly", function(module, exports) {

$parcel$export(module.exports, "stringSplitConfig", () => $60dc4ac15c3395f0$export$c51cbbd627a96532);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eoFVx = parcelRequire("eoFVx");
function $60dc4ac15c3395f0$export$aa7f8babb17e7672(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { skipEmpty: skipEmpty } = attrs;
    const { input: input, delimiter: delimiter } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (input.shape.length !== 1) throw new Error(`Input must be a vector, got shape: ${input.shape}`);
    if (delimiter.shape.length !== 0) throw new Error(`Delimiter must be a scalar, got shape: ${delimiter.shape}`);
    const $input = backend.data.get(input.dataId).values;
    const $delimiter = backend.data.get(delimiter.dataId).values[0];
    const [indices, values, shape] = (0, $eoFVx.stringSplitImpl)($input, $delimiter, skipEmpty);
    const outputSize = values.length;
    return [
        backend.makeTensorInfo([
            outputSize,
            2
        ], 'int32', indices),
        backend.makeTensorInfo([
            outputSize
        ], 'string', values),
        backend.makeTensorInfo([
            2
        ], 'int32', new Int32Array(shape))
    ];
}
const $60dc4ac15c3395f0$export$c51cbbd627a96532 = {
    kernelName: (0, $dCP8m.StringSplit),
    backendName: 'cpu',
    kernelFunc: $60dc4ac15c3395f0$export$aa7f8babb17e7672
};

});
parcelRegister("eoFVx", function(module, exports) {

$parcel$export(module.exports, "stringSplitImpl", () => $a7b3d4655bdf8410$export$c3b08e43aa36d65d);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
function $a7b3d4655bdf8410$var$split(str, delimiters, skipEmpty, result) {
    if (!str.length) return;
    // When the delimiter is empty, the input is split into individual characters.
    if (delimiters.length === 0) {
        for(let i = 0; i < str.length; ++i)result.push(str.subarray(i, i + 1));
        return;
    }
    // When there is one delimiter, the input is split only at that delimiter.
    if (delimiters.length === 1) {
        const delimiter = delimiters[0];
        let f = str.indexOf(delimiter);
        while(f !== -1){
            const token = str.subarray(0, f);
            if (!skipEmpty || token.length !== 0) result.push(token);
            str = str.subarray(f + 1);
            f = str.indexOf(delimiter);
        }
        if (!skipEmpty || str.length !== 0) result.push(str);
        return;
    }
    // When there are multiple delimiters, the input is split at every instance
    // one of the delimiters appears.
    let tokenStart = 0;
    for(let i = 0; i < str.length + 1; i++)if (i === str.length || delimiters.indexOf(str[i]) !== -1) {
        const token = str.subarray(tokenStart, i);
        if (!skipEmpty || token.length !== 0) result.push(token);
        tokenStart = i + 1;
    }
}
function $a7b3d4655bdf8410$export$c3b08e43aa36d65d(input, delimiter, skipEmpty) {
    const batchSize = input.length;
    // Empty delimiter means split the input character by character.
    const tokens = [];
    let outputSize = 0;
    let maxNumEntries = 0;
    const numIndices = new Array(batchSize);
    for(let i = 0; i < batchSize; ++i){
        const prevTokensLength = tokens.length;
        $a7b3d4655bdf8410$var$split(input[i], delimiter, skipEmpty, tokens);
        const nEntries = tokens.length - prevTokensLength;
        numIndices[i] = nEntries;
        outputSize += nEntries;
        maxNumEntries = Math.max(maxNumEntries, nEntries);
    }
    const indices = (0, $wx9lK).getArrayFromDType('int32', outputSize * 2);
    const values = new Array(outputSize);
    const shape = [
        batchSize,
        maxNumEntries
    ];
    let c = 0;
    for(let i = 0; i < batchSize; ++i)for(let j = 0; j < numIndices[i]; ++j){
        // indices is a 2d tensor with shape of [outputSize, 2]
        indices[c * 2] = i;
        indices[c * 2 + 1] = j;
        values[c] = tokens[c];
        ++c;
    }
    return [
        indices,
        values,
        shape
    ];
}

});


parcelRegister("fcSQq", function(module, exports) {

$parcel$export(module.exports, "stringToHashBucketFastConfig", () => $b12284f9b872dc62$export$a88a78b2b233f507);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $hLQPX = parcelRequire("hLQPX");
function $b12284f9b872dc62$export$6195616d6fd0c848(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { numBuckets: numBuckets } = attrs;
    const { input: input } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (numBuckets <= 0) throw new Error(`Number of buckets must be at least 1`);
    const $input = backend.data.get(input.dataId).values;
    const output = (0, $hLQPX.stringToHashBucketFastImpl)($input, numBuckets);
    return backend.makeTensorInfo(input.shape, 'int32', output);
}
const $b12284f9b872dc62$export$a88a78b2b233f507 = {
    kernelName: (0, $dCP8m.StringToHashBucketFast),
    backendName: 'cpu',
    kernelFunc: $b12284f9b872dc62$export$6195616d6fd0c848
};

});
parcelRegister("hLQPX", function(module, exports) {

$parcel$export(module.exports, "stringToHashBucketFastImpl", () => $0356b4e6717323be$export$37cbed4d0b2fe56a);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
function $0356b4e6717323be$export$37cbed4d0b2fe56a(input, numBuckets) {
    const output = (0, $wx9lK).getArrayFromDType('int32', input.length);
    for(let i = 0; i < input.length; ++i)output[i] = (0, $wx9lK).fingerPrint64(input[i]).modulo(numBuckets).getLowBitsUnsigned();
    return output;
}

});


parcelRegister("kFBKH", function(module, exports) {

$parcel$export(module.exports, "tanConfig", () => $f0c4ebc81abb5ed5$export$97648844df7611f3);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $f0c4ebc81abb5ed5$export$fcdd3b0b3246a325 = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Tan), (xi)=>Math.tan(xi));
const $f0c4ebc81abb5ed5$export$97648844df7611f3 = {
    kernelName: (0, $dCP8m.Tan),
    backendName: 'cpu',
    kernelFunc: $f0c4ebc81abb5ed5$export$fcdd3b0b3246a325
};

});

parcelRegister("fHBqI", function(module, exports) {

$parcel$export(module.exports, "tanhConfig", () => $b6e7e7f490d3985b$export$a2fc7de1a1e4eee0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $lfZyz = parcelRequire("lfZyz");
const $b6e7e7f490d3985b$export$7128670e45beef9a = (0, $lfZyz.unaryKernelFunc)((0, $dCP8m.Tanh), (xi)=>Math.tanh(xi));
const $b6e7e7f490d3985b$export$a2fc7de1a1e4eee0 = {
    kernelName: (0, $dCP8m.Tanh),
    backendName: 'cpu',
    kernelFunc: $b6e7e7f490d3985b$export$7128670e45beef9a
};

});

parcelRegister("atfy0", function(module, exports) {

$parcel$export(module.exports, "tileConfig", () => $79f8ac36b05fd58a$export$a5a9f8050ba7f41e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");

var $jyDpx = parcelRequire("jyDpx");
function $79f8ac36b05fd58a$export$3c17558da18e4d75(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { reps: reps } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'tile');
    const outBuf = (0, $jyDpx.tileImpl)(backend.bufferSync(x), reps);
    return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
}
const $79f8ac36b05fd58a$export$a5a9f8050ba7f41e = {
    kernelName: (0, $dCP8m.Tile),
    backendName: 'cpu',
    kernelFunc: $79f8ac36b05fd58a$export$3c17558da18e4d75
};

});
parcelRegister("jyDpx", function(module, exports) {

$parcel$export(module.exports, "tileImpl", () => $e3cfc37f286e2773$export$f3e554b937559516);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $g81BN = parcelRequire("g81BN");
function $e3cfc37f286e2773$export$f3e554b937559516(xBuf, reps) {
    const newShape = new Array(xBuf.rank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = xBuf.shape[i] * reps[i];
    const result = (0, $g81BN.buffer)(newShape, xBuf.dtype);
    for(let i = 0; i < result.values.length; ++i){
        const newLoc = result.indexToLoc(i);
        const originalLoc = new Array(xBuf.rank);
        for(let j = 0; j < originalLoc.length; j++)originalLoc[j] = newLoc[j] % xBuf.shape[j];
        const originalIndex = xBuf.locToIndex(originalLoc);
        result.values[i] = xBuf.values[originalIndex];
    }
    return result;
}

});


parcelRegister("6wFel", function(module, exports) {

$parcel$export(module.exports, "topKConfig", () => $4c05b6bbdce6753d$export$cffaee31213314ce);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");

var $ijnI0 = parcelRequire("ijnI0");
function $4c05b6bbdce6753d$export$7e641efc73a2d81(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { k: k, sorted: sorted } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'topk');
    const xVals = backend.data.get(x.dataId).values;
    const [allTopKVals, allTopKIndices] = (0, $ijnI0.topKImpl)(xVals, x.shape, x.dtype, k, sorted);
    return [
        backend.makeTensorInfo(allTopKVals.shape, allTopKVals.dtype, allTopKVals.values),
        backend.makeTensorInfo(allTopKIndices.shape, allTopKIndices.dtype, allTopKIndices.values)
    ];
}
const $4c05b6bbdce6753d$export$cffaee31213314ce = {
    kernelName: (0, $dCP8m.TopK),
    backendName: 'cpu',
    kernelFunc: $4c05b6bbdce6753d$export$7e641efc73a2d81
};

});
parcelRegister("ijnI0", function(module, exports) {

$parcel$export(module.exports, "topKImpl", () => $d54c646a66591a3c$export$b083239978762299);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /** An implementation of the TopK kernel shared between webgl and cpu. */ parcelRequire("5n9DG");
var $g81BN = parcelRequire("g81BN");
var $wx9lK = parcelRequire("wx9lK");
const $d54c646a66591a3c$var$comparePair = (a, b)=>{
    const valueDiff = b.value - a.value;
    return valueDiff === 0 ? a.index - b.index : valueDiff;
};
/**
 * Partitions array where all elements smaller than the (k+1) smallest element
 * are found to the left of it, and all larger to the right of it.
 * Based on the Floyd-Rivest Algorithm, ref:
 * https://en.wikipedia.org/wiki/Floyd%E2%80%93Rivest_algorithm
 * @param array: Array to partition
 * @param left: Left index for the interval
 * @param right: Right index for the interval
 * @param k: Desired index value, where array[k] is the (k+1)th smallest element
 *           when left = 0
 */ function $d54c646a66591a3c$var$select(array, k, left = 0, right = array.length - 1) {
    while(right > left){
        // Use select recursively to sample a smaller set of size s
        // the arbitrary constants 600 and 0.5 are used in the original
        // version to minimize execution time.
        if (right - left > 600) {
            const n = right - left + 1;
            const i = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * Math.sign(i - n / 2);
            const newLeft = Math.max(left, Math.floor(k - i * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - i) * s / n + sd));
            $d54c646a66591a3c$var$select(array, k, newLeft, newRight);
        }
        // partition the elements between left and right around t
        const t = array[k];
        let i = left;
        let j = right;
        (0, $wx9lK).swap(array, left, k);
        if ($d54c646a66591a3c$var$comparePair(array[right], t) > 0) (0, $wx9lK).swap(array, left, right);
        while(i < j){
            (0, $wx9lK).swap(array, i, j);
            i++;
            j--;
            while($d54c646a66591a3c$var$comparePair(array[i], t) < 0)i = i + 1;
            while($d54c646a66591a3c$var$comparePair(array[j], t) > 0)j = j - 1;
        }
        if ($d54c646a66591a3c$var$comparePair(array[left], t) === 0) (0, $wx9lK).swap(array, left, j);
        else {
            j = j + 1;
            (0, $wx9lK).swap(array, j, right);
        }
        // Adjust left and right towards the boundaries of the subset
        // containing the (k - left + 1)th smallest element.
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
function $d54c646a66591a3c$export$b083239978762299(x, xShape, xDtype, k, sorted) {
    // Reshape into a 2d tensor [batch, lastDim] and compute topk along lastDim.
    const lastDim = xShape[xShape.length - 1];
    const [batch, size] = [
        x.length / lastDim,
        lastDim
    ];
    const allTopKVals = (0, $wx9lK).getTypedArrayFromDType(xDtype, batch * k);
    const allTopKIndices = (0, $wx9lK).getTypedArrayFromDType('int32', batch * k);
    for(let b = 0; b < batch; b++){
        const offset = b * size;
        const vals = x.subarray(offset, offset + size);
        let valAndInd = new Array(vals.length);
        vals.forEach((value, index)=>valAndInd[index] = {
                value: value,
                index: index
            });
        if (k < valAndInd.length) {
            $d54c646a66591a3c$var$select(valAndInd, k);
            valAndInd = valAndInd.slice(0, k);
        }
        if (sorted) valAndInd.sort($d54c646a66591a3c$var$comparePair);
        const outOffset = b * k;
        const topKVals = allTopKVals.subarray(outOffset, outOffset + k);
        const topKIndices = allTopKIndices.subarray(outOffset, outOffset + k);
        for(let i = 0; i < k; i++){
            topKVals[i] = valAndInd[i].value;
            topKIndices[i] = valAndInd[i].index;
        }
    }
    // Reshape back to the original input shape, except that the last
    // dimension is k.
    const outputShape = xShape.slice();
    outputShape[outputShape.length - 1] = k;
    return [
        (0, $g81BN.buffer)(outputShape, xDtype, allTopKVals),
        (0, $g81BN.buffer)(outputShape, 'int32', allTopKIndices)
    ];
}

});


parcelRegister("5hkfO", function(module, exports) {

$parcel$export(module.exports, "transformConfig", () => $3d7e404f735f1f30$export$1c7a3de6335954ed);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
function $3d7e404f735f1f30$export$51186ad6e864892a(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { image: image, transforms: transforms } = inputs;
    const { interpolation: interpolation, fillMode: fillMode, fillValue: fillValue, outputShape: outputShape } = attrs;
    const [batch, imageHeight, imageWidth, numChannels] = image.shape;
    const [outHeight, outWidth] = outputShape != null ? outputShape : [
        imageHeight,
        imageWidth
    ];
    const outShape = [
        batch,
        outHeight,
        outWidth,
        numChannels
    ];
    const inStrides = (0, $wx9lK).computeStrides(image.shape);
    const batchInStride = inStrides[0];
    const rowInStride = inStrides[1];
    const colInStride = inStrides[2];
    const outStrides = (0, $wx9lK).computeStrides(outShape);
    const batchOutStride = outStrides[0];
    const rowOutStride = outStrides[1];
    const colOutStride = outStrides[2];
    const outVals = (0, $wx9lK).getTypedArrayFromDType(image.dtype, (0, $wx9lK).sizeFromShape(outShape));
    outVals.fill(fillValue);
    const imageVals = backend.data.get(image.dataId).values;
    const transformVals = backend.data.get(transforms.dataId).values;
    // Ref TF implementation:
    // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/image/image_ops.h
    for(let b = 0; b < batch; ++b){
        const transform = transforms.shape[0] === 1 ? transformVals : transformVals.subarray(b * 8, b * 8 + 8);
        for(let outY = 0; outY < outHeight; ++outY){
            for(let outX = 0; outX < outWidth; ++outX)for(let channel = 0; channel < numChannels; ++channel){
                let val;
                const projection = transform[6] * outX + transform[7] * outY + 1;
                if (projection === 0) continue;
                const inX = (transform[0] * outX + transform[1] * outY + transform[2]) / projection;
                const inY = (transform[3] * outX + transform[4] * outY + transform[5]) / projection;
                const x = $3d7e404f735f1f30$var$mapCoord(inX, imageWidth, fillMode);
                const y = $3d7e404f735f1f30$var$mapCoord(inY, imageHeight, fillMode);
                switch(interpolation){
                    case 'nearest':
                        val = $3d7e404f735f1f30$var$nearestInterpolation(imageVals, imageHeight, imageWidth, batchInStride, rowInStride, colInStride, b, y, x, channel, fillValue);
                        break;
                    case 'bilinear':
                        val = $3d7e404f735f1f30$var$bilinearInterpolation(imageVals, imageHeight, imageWidth, batchInStride, rowInStride, colInStride, b, y, x, channel, fillValue);
                        break;
                    default:
                        throw new Error(`Error in Transform: Expect 'nearest' or ` + `'bilinear', but got ${interpolation}`);
                }
                const ind = b * batchOutStride + outY * rowOutStride + outX * colOutStride + channel;
                outVals[ind] = val;
            }
        }
        return backend.makeTensorInfo(outShape, image.dtype, outVals);
    }
    const dataId = backend.write(outVals, outShape, image.dtype);
    return {
        dataId: dataId,
        shape: image.shape,
        dtype: image.dtype
    };
}
const $3d7e404f735f1f30$export$1c7a3de6335954ed = {
    kernelName: (0, $dCP8m.Transform),
    backendName: 'cpu',
    kernelFunc: $3d7e404f735f1f30$export$51186ad6e864892a
};
function $3d7e404f735f1f30$var$mapCoord(outCoord, len, mode) {
    switch(mode){
        case 'reflect':
            return $3d7e404f735f1f30$var$mapCoordReflect(outCoord, len);
        case 'wrap':
            return $3d7e404f735f1f30$var$mapCoordWrap(outCoord, len);
        case 'nearest':
            return $3d7e404f735f1f30$var$mapCoordNearest(outCoord, len);
        case 'constant':
        default:
            return $3d7e404f735f1f30$var$mapCoordConstant(outCoord, len);
    }
}
function $3d7e404f735f1f30$var$mapCoordReflect(outCoord, len) {
    // Reflect [abcd] to [dcba|abcd|dcba].
    let inCoord = outCoord;
    if (inCoord < 0) {
        if (len <= 1) inCoord = 0;
        else {
            const sz2 = 2 * len;
            if (inCoord < sz2) inCoord = sz2 * Math.trunc(-inCoord / sz2) + inCoord;
            inCoord = inCoord < -len ? inCoord + sz2 : -inCoord - 1;
        }
    } else if (inCoord > len - 1) {
        if (len <= 1) inCoord = 0;
        else {
            const sz2 = 2 * len;
            inCoord -= sz2 * Math.trunc(inCoord / sz2);
            if (inCoord >= len) inCoord = sz2 - inCoord - 1;
        }
    }
    // clamp is necessary because when outCoord = 3.5 and len = 4,
    // inCoord = 3.5 and will be rounded to 4 in nearest interpolation.
    return (0, $wx9lK).clamp(0, inCoord, len - 1);
}
function $3d7e404f735f1f30$var$mapCoordWrap(outCoord, len) {
    // Wrap [abcd] to [abcd|abcd|abcd].
    let inCoord = outCoord;
    if (inCoord < 0) {
        if (len <= 1) inCoord = 0;
        else {
            const sz = len - 1;
            inCoord += len * (Math.trunc(-inCoord / sz) + 1);
        }
    } else if (inCoord > len - 1) {
        if (len <= 1) inCoord = 0;
        else {
            const sz = len - 1;
            inCoord -= len * Math.trunc(inCoord / sz);
        }
    }
    // clamp is necessary because when outCoord = -0.5 and len = 4,
    // inCoord = 3.5 and will be rounded to 4 in nearest interpolation.
    return (0, $wx9lK).clamp(0, inCoord, len - 1);
}
function $3d7e404f735f1f30$var$mapCoordConstant(outCoord, len) {
    return outCoord;
}
function $3d7e404f735f1f30$var$mapCoordNearest(outCoord, len) {
    return (0, $wx9lK).clamp(0, outCoord, len - 1);
}
function $3d7e404f735f1f30$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, y, x, channel, fillValue) {
    const ind = batch * batchStride + y * rowStride + x * colStride + channel;
    if (0 <= y && y < imageHeight && 0 <= x && x < imageWidth) return imageVals[ind];
    else return fillValue;
}
function $3d7e404f735f1f30$var$nearestInterpolation(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, y, x, channel, fillValue) {
    const $y = Math.round(y);
    const $x = Math.round(x);
    return $3d7e404f735f1f30$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, $y, $x, channel, fillValue);
}
function $3d7e404f735f1f30$var$bilinearInterpolation(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, y, x, channel, fillValue) {
    const yFloor = Math.floor(y);
    const xFloor = Math.floor(x);
    const yCeil = yFloor + 1;
    const xCeil = xFloor + 1;
    // f(x, yFloor) = (xCeil - x) / (xCeil - xFloor) * f(xFloor, yFloor)
    //               + (x - xFloor) / (xCeil - xFloor) * f(xCeil, yFloor)
    const valueYFloor = (xCeil - x) * $3d7e404f735f1f30$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yFloor, xFloor, channel, fillValue) + (x - xFloor) * $3d7e404f735f1f30$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yFloor, xCeil, channel, fillValue);
    // f(x, yCeil) = (xCeil - x) / (xCeil - xFloor) * f(xFloor, yCeil)
    //             + (x - xFloor) / (xCeil - xFloor) * f(xCeil, yCeil)
    const valueYCeil = (xCeil - x) * $3d7e404f735f1f30$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yCeil, xFloor, channel, fillValue) + (x - xFloor) * $3d7e404f735f1f30$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yCeil, xCeil, channel, fillValue);
    // f(x, y) = (yCeil - y) / (yCeil - yFloor) * f(x, yFloor)
    //         + (y - yFloor) / (yCeil - yFloor) * f(x, yCeil)
    return (yCeil - y) * valueYFloor + (y - yFloor) * valueYCeil;
}

});

parcelRegister("ghozF", function(module, exports) {

$parcel$export(module.exports, "uniqueConfig", () => $bda14bc9f0035d86$export$78cd70dcd092910e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $aPHJu = parcelRequire("aPHJu");

var $cnCce = parcelRequire("cnCce");
function $bda14bc9f0035d86$export$7a5d5c156e7dc406(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { axis: axis } = attrs;
    const { x: x } = inputs;
    (0, $aPHJu.assertNotComplex)(x, 'unique');
    const values = backend.data.get(x.dataId).values;
    const { outputValues: outputValues, outputShape: outputShape, indices: indices } = (0, $cnCce.uniqueImpl)(values, axis, x.shape, x.dtype);
    return [
        backend.makeTensorInfo(outputShape, x.dtype, outputValues),
        backend.makeTensorInfo([
            indices.length
        ], 'int32', indices)
    ];
}
const $bda14bc9f0035d86$export$78cd70dcd092910e = {
    kernelName: (0, $dCP8m.Unique),
    backendName: 'cpu',
    kernelFunc: $bda14bc9f0035d86$export$7a5d5c156e7dc406
};

});
parcelRegister("cnCce", function(module, exports) {

$parcel$export(module.exports, "uniqueImpl", () => $903542fd92418437$export$58be9cc013c994e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $bVnU9 = parcelRequire("bVnU9");
var $wx9lK = parcelRequire("wx9lK");
function $903542fd92418437$export$58be9cc013c994e(values, axis, shape, dtype) {
    // Normalize and validate axis.
    const $axis = (0, $wx9lK).parseAxisParam(axis, shape)[0];
    // Calculate the new shape that is suitable for extracting data along the
    // given axis.
    //
    // The rank is 3.
    // The size of the 1st dimension is the size of all the axes < the given axis.
    // The size of the 2nd dimension is the same as the size of the given axis.
    // The size of the 3rd dimension is the size of all the axes > the given axis.
    //
    // For example, for a 4D tensor with shape=[2, 3, 5, 4] and axis=2, the
    // newShape would be: [2*3, 5, 4].
    //
    // Note that this is not the final output shape. This will be the shape for an
    // intermediate TensorBuffer (see inputBuffer below) to allow us to extract
    // values along the given axis. To demonstrate how it works, consider the
    // following example:
    //
    // Input: a 3D tensor, with shape [1, 2, 3]
    // [
    //   [
    //      [1,2,3],
    //      [4,5,6]
    //   ]
    // ]
    // Axis: 2 (the last axis).
    // Along axis 2, we expect to extract 3 tensors: [1,4], [2,5], [3,6].
    //
    // For this example, newShape would be: [2, 3, 1], where 2 is calculated from
    // 1*2. The re-shaped data would look like:
    //
    // [
    //   [
    //     [1], [2], [3]
    //   ],
    //   [
    //     [4], [5], [6]
    //   ]
    // ]
    //
    // Then, we can construct a 3-level nested loop by the following dimension
    // order to extract the values along the axis (dimension1):
    // i: dimension1       // 0,1,2 (newShape[1])
    //   m: dimension0     // 0,1   (newShape[0])
    //     n: dimension2   // 0     (newShape[2])
    //
    //                       m, i, n
    //                      ---------
    // Iteration 0: data at [0, 0, 0] => "1"
    // Iteration 1: data at [1, 0, 0] => "4"
    // We got [1,4].
    // Iteration 2: data at [0, 1, 0] => "2"
    // Iteration 3: data at [1, 1, 0] => "5"
    // We got [2,5].
    // Iteration 4: data at [0, 2, 0] => "3"
    // Iteration 5: data at [1, 2, 0] => "6"
    // We got [3,6].
    const newShape = [
        1,
        shape[0],
        1
    ];
    for(let i = 0; i < $axis; i++)newShape[0] *= shape[i];
    newShape[1] = shape[$axis];
    for(let i = $axis + 1; i < shape.length; i++)newShape[2] *= shape[i];
    // A map from unique elements (their string representations) to their values
    // in "indices" (below).
    const uniqueElements = {};
    // The indices of each unique element in the original tensor along the given
    // axis. It is 1D and has the same size as the given axis.
    const indices = new Int32Array(shape[$axis]);
    // Create a buffer so we can easily extract value at a given location.
    const inputBuffer = new (0, $bVnU9.TensorBuffer)(newShape, dtype, values);
    // The indices along the given axis that have unique elements. This is a
    // de-duped version of "indices" above.
    const uniqueIndices = [];
    const is1DTensor = newShape[0] === 1 && newShape[2] === 1;
    for(let i = 0; i < shape[$axis]; i++){
        // Extract values along the axis.
        let element;
        if (is1DTensor) // Fast path for 1D tensor input.
        element = values[i].toString();
        else {
            const axisValues = [];
            for(let m = 0; m < newShape[0]; m++)for(let n = 0; n < newShape[2]; n++)axisValues.push(inputBuffer.get(m, i, n));
            element = axisValues.join(',');
        }
        // Dedup and update various indices.
        if (uniqueElements[element] !== undefined) indices[i] = uniqueElements[element];
        else {
            const uniqueIndex = Object.keys(uniqueElements).length;
            uniqueElements[element] = uniqueIndex;
            indices[i] = uniqueIndex;
            uniqueIndices.push(i);
        }
    }
    // Now we know where each of the unique elements are located along the axis
    // (uniqueIndices). Extract them from input buffer and store them in the
    // output buffer.
    const outputTmpShape = newShape.slice();
    outputTmpShape[1] = Object.keys(uniqueElements).length;
    const outputBuffer = new (0, $bVnU9.TensorBuffer)(outputTmpShape, dtype);
    uniqueIndices.forEach((uniqueElementIndex, i)=>{
        for(let m = 0; m < newShape[0]; m++)for(let n = 0; n < newShape[2]; n++)outputBuffer.set(inputBuffer.get(m, uniqueElementIndex, n), m, i, n);
    });
    // The output shape can be calculated from the input shape with the size of
    // the given axis replaced by the number of unique elements along that axis.
    const outputShape = shape.slice();
    outputShape[$axis] = outputTmpShape[1];
    return {
        outputValues: outputBuffer.values,
        outputShape: outputShape,
        indices: indices
    };
}

});


parcelRegister("36DtR", function(module, exports) {

$parcel$export(module.exports, "unpackConfig", () => $24308ea5ccdf540c$export$d06292128cae50d6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $3qzJ7 = parcelRequire("3qzJ7");

var $fyKXa = parcelRequire("fyKXa");
function $24308ea5ccdf540c$export$417857010dc9287f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { value: value } = inputs;
    let { axis: axis } = attrs;
    if (axis < 0) axis += value.shape.length;
    const valueRank = value.shape.length;
    const num = value.shape[axis];
    const outShape = new Array(valueRank - 1);
    let outIndex = 0;
    for(let i = 0; i < valueRank; i++)if (i !== axis) outShape[outIndex++] = value.shape[i];
    const begin = new Array(valueRank).fill(0);
    const size = value.shape.slice();
    size[axis] = 1;
    const res = new Array(num);
    for(let i = 0; i < res.length; i++){
        begin[axis] = i;
        const tempRes = (0, $fyKXa.slice)({
            inputs: {
                x: value
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: size
            }
        });
        res[i] = (0, $3qzJ7.reshape)({
            inputs: {
                x: tempRes
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        backend.disposeIntermediateTensorInfo(tempRes);
    }
    return res;
}
const $24308ea5ccdf540c$export$d06292128cae50d6 = {
    kernelName: (0, $dCP8m.Unpack),
    backendName: 'cpu',
    kernelFunc: $24308ea5ccdf540c$export$417857010dc9287f
};

});

parcelRegister("8OH5n", function(module, exports) {

$parcel$export(module.exports, "unsortedSegmentSumConfig", () => $66b46a251839c995$export$71e3626a4ca29968);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $aPHJu = parcelRequire("aPHJu");

var $gSA6r = parcelRequire("gSA6r");

var $2nwON = parcelRequire("2nwON");

var $8Du0y = parcelRequire("8Du0y");

var $h9fuR = parcelRequire("h9fuR");

var $7gEB2 = parcelRequire("7gEB2");

var $jPjnE = parcelRequire("jPjnE");
function $66b46a251839c995$export$ba7c4d144d85a309(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, segmentIds: segmentIds } = inputs;
    const { numSegments: numSegments } = attrs;
    (0, $aPHJu.assertNotComplex)(x, 'unsortedSegmentSum');
    const xRank = x.shape.length;
    const segmentIdsRank = segmentIds.shape.length;
    const res = [];
    const intermediates = [];
    // Reshape the segment id's so that they can be broadcast with
    // x. The new shape should be [segmentIds.shape, 1, ..., 1]
    const numIters = xRank - segmentIdsRank;
    let $segmentIds = segmentIds;
    for(let i = 0; i < numIters; ++i){
        const expanded = (0, $8Du0y.expandDims)({
            inputs: {
                input: $segmentIds
            },
            backend: backend,
            attrs: {
                dim: i + 1
            }
        });
        $segmentIds = expanded;
        intermediates.push(expanded);
    }
    for(let i = 0; i < numSegments; ++i){
        const scalarValue = (0, $wx9lK).createScalarValue(i, 'int32');
        const segmentId = backend.makeTensorInfo([], 'int32', scalarValue);
        const mask = (0, $2nwON.equal)({
            inputs: {
                a: segmentId,
                b: $segmentIds
            },
            backend: backend
        });
        const maskCasted = (0, $gSA6r.cast)({
            inputs: {
                x: mask
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const mul = (0, $h9fuR.multiply)({
            inputs: {
                a: maskCasted,
                b: x
            },
            backend: backend
        });
        const sumTensorInfo = (0, $jPjnE.sum)({
            inputs: {
                x: mul
            },
            backend: backend,
            attrs: {
                axis: 0,
                keepDims: false
            }
        });
        res.push(sumTensorInfo);
        intermediates.push(segmentId);
        intermediates.push(mask);
        intermediates.push(maskCasted);
        intermediates.push(mul);
        intermediates.push(sumTensorInfo);
    }
    const result = (0, $7gEB2.pack)({
        inputs: res,
        backend: backend,
        attrs: {
            axis: 0
        }
    });
    intermediates.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $66b46a251839c995$export$71e3626a4ca29968 = {
    kernelName: (0, $dCP8m.UnsortedSegmentSum),
    backendName: 'cpu',
    kernelFunc: $66b46a251839c995$export$ba7c4d144d85a309
};

});



parcelRegister("7VUST", function(module, exports) {
$parcel$export(module.exports, "version_webgl", () => (parcelRequire("kdLMe")).version);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // All exports from this package should be in base.
parcelRequire("l3ztN");
parcelRequire("Arnwk");

});
parcelRegister("l3ztN", function(module, exports) {

$parcel$export(module.exports, "version_webgl", () => (parcelRequire("kdLMe")).version);
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // base.ts is the webgl backend without auto kernel registration.
parcelRequire("5n9DG");
var $7L9WU = parcelRequire("7L9WU");
var $9c0Qr = parcelRequire("9c0Qr");

var $ix9eE = parcelRequire("ix9eE");

var $kdLMe = parcelRequire("kdLMe");

var $fT52R = parcelRequire("fT52R");
if ((0, $7L9WU).isBrowser()) (0, $9c0Qr.registerBackend)('webgl', ()=>new (0, $ix9eE.MathBackendWebGL)(), 2 /* priority */ );
const $f5456648f1d3c7ff$export$d55298c9efc5ed14 = {
    forceHalfFloat: $fT52R.forceHalfFloat
};

});
parcelRegister("ix9eE", function(module, exports) {

$parcel$export(module.exports, "MathBackendWebGL", () => $d7e279048eea3b47$export$33567d88bc7c6249);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Import webgl flags.
parcelRequire("i11mb");
parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $g81BN = parcelRequire("g81BN");
var $3PHpx = parcelRequire("3PHpx");
var $9c0Qr = parcelRequire("9c0Qr");
var $aymVi = parcelRequire("aymVi");
var $ff2I2 = parcelRequire("ff2I2");
var $hy0Vl = parcelRequire("hy0Vl");
var $j7yUF = parcelRequire("j7yUF");
var $wx9lK = parcelRequire("wx9lK");

var $jYI8Q = parcelRequire("jYI8Q");

var $akZ7H = parcelRequire("akZ7H");

var $auraC = parcelRequire("auraC");

var $gbYDR = parcelRequire("gbYDR");

var $a9Naf = parcelRequire("a9Naf");

var $iwdC3 = parcelRequire("iwdC3");

var $eoRA9 = parcelRequire("eoRA9");

var $1i8cx = parcelRequire("1i8cx");

var $i88bA = parcelRequire("i88bA");

var $fIVdF = parcelRequire("fIVdF");

var $6ljdK = parcelRequire("6ljdK");

var $48uvZ = parcelRequire("48uvZ");

var $lE6VE = parcelRequire("lE6VE");

var $8doPJ = parcelRequire("8doPJ");

var $2sCkP = parcelRequire("2sCkP");

var $2RjWv = parcelRequire("2RjWv");

var $QPOIZ = parcelRequire("QPOIZ");

var $4rulI = parcelRequire("4rulI");
const $d7e279048eea3b47$var$whereImpl = (0, $ff2I2).whereImpl;
const $d7e279048eea3b47$export$76e53a66c52b6d4d = 1e-7;
const $d7e279048eea3b47$export$49716d145771e6a2 = 1e-4;
const $d7e279048eea3b47$var$binaryCaches = {};
function $d7e279048eea3b47$export$5863a14c5c829662(webGLVersion) {
    if (webGLVersion in $d7e279048eea3b47$var$binaryCaches) return $d7e279048eea3b47$var$binaryCaches[webGLVersion];
    $d7e279048eea3b47$var$binaryCaches[webGLVersion] = {};
    return $d7e279048eea3b47$var$binaryCaches[webGLVersion];
}
// Empirically determined constant used to determine size threshold for handing
// off execution to the CPU.
const $d7e279048eea3b47$var$CPU_HANDOFF_SIZE_THRESHOLD = (0, $aymVi.env)().getNumber('CPU_HANDOFF_SIZE_THRESHOLD');
// Empirically determined constant used to decide the number of MB on GPU
// before we warn about high memory use. The MB are this constant * screen area
// * dpi / 1024 / 1024.
const $d7e279048eea3b47$var$BEFORE_PAGING_CONSTANT = 600;
function $d7e279048eea3b47$var$numMBBeforeWarning() {
    if ((0, $aymVi.env)().global.screen == null) return 1024; // 1 GB.
    return (0, $aymVi.env)().global.screen.height * (0, $aymVi.env)().global.screen.width * window.devicePixelRatio * $d7e279048eea3b47$var$BEFORE_PAGING_CONSTANT / 1024 / 1024;
}
class $d7e279048eea3b47$export$33567d88bc7c6249 extends (0, $3PHpx.KernelBackend) {
    constructor(gpuResource){
        super();
        // Maps data ids that have a pending read operation, to list of subscribers.
        this.pendingRead = new WeakMap();
        // List of data ids that are scheduled for disposal, but are waiting on a
        // pending read operation.
        this.pendingDisposal = new WeakSet();
        // Used to count the number of 'shallow' sliced tensors that point to the
        // same data id.
        this.dataRefCount = new WeakMap();
        this.numBytesInGPU = 0;
        // Accumulated time spent (including blocking) in uploading data to webgl.
        this.uploadWaitMs = 0;
        // Accumulated time spent (including blocking in downloading data from webgl.
        this.downloadWaitMs = 0;
        // record the last manual GL Flush time.
        this.lastGlFlushTime = 0;
        this.warnedAboutMemory = false;
        this.pendingDeletes = 0;
        this.disposed = false;
        if (!(0, $aymVi.env)().getBool('HAS_WEBGL')) throw new Error('WebGL is not supported on this device');
        let newGPGPU;
        if (gpuResource != null) {
            if (gpuResource instanceof (0, $1i8cx.GPGPUContext)) newGPGPU = gpuResource;
            else {
                const gl = (0, $jYI8Q.getWebGLContext)((0, $aymVi.env)().getNumber('WEBGL_VERSION'), gpuResource);
                newGPGPU = new (0, $1i8cx.GPGPUContext)(gl);
            }
            this.binaryCache = {};
            this.gpgpuCreatedLocally = false;
        } else {
            const gl = (0, $jYI8Q.getWebGLContext)((0, $aymVi.env)().getNumber('WEBGL_VERSION'));
            newGPGPU = new (0, $1i8cx.GPGPUContext)(gl);
            this.binaryCache = $d7e279048eea3b47$export$5863a14c5c829662((0, $aymVi.env)().getNumber('WEBGL_VERSION'));
            this.gpgpuCreatedLocally = true;
        }
        this.gpgpu = newGPGPU;
        this.canvas = this.gpgpu.gl.canvas;
        this.textureManager = new (0, $8doPJ.TextureManager)(this.gpgpu);
        this.numMBBeforeWarning = $d7e279048eea3b47$var$numMBBeforeWarning();
        this.texData = new (0, $3PHpx.DataStorage)(this, (0, $9c0Qr.engine)());
    }
    nextDataId() {
        return $d7e279048eea3b47$export$33567d88bc7c6249.nextDataId++;
    }
    numDataIds() {
        return this.texData.numDataIds() - this.pendingDeletes;
    }
    write(values, shape, dtype) {
        if ((0, $aymVi.env)().getBool('WEBGL_CHECK_NUMERICAL_PROBLEMS') || (0, $aymVi.env)().getBool('DEBUG')) this.checkNumericalProblems(values);
        if (dtype === 'complex64' && values != null) throw new Error(`Cannot write to a complex64 dtype. ` + `Please use tf.complex(real, imag).`);
        const dataId = {
            id: this.nextDataId()
        };
        this.texData.set(dataId, {
            shape: shape,
            dtype: dtype,
            values: values,
            usage: (0, $lE6VE.TextureUsage).UPLOAD,
            refCount: 1
        });
        return dataId;
    }
    /** Return refCount of a `TensorData`. */ refCount(dataId) {
        if (this.texData.has(dataId)) {
            const tensorData = this.texData.get(dataId);
            return tensorData.refCount;
        }
        return 0;
    }
    /** Increase refCount of a `TextureData`. */ incRef(dataId) {
        const texData = this.texData.get(dataId);
        texData.refCount++;
    }
    /** Decrease refCount of a `TextureData`. */ decRef(dataId) {
        if (this.texData.has(dataId)) {
            const texData = this.texData.get(dataId);
            texData.refCount--;
        }
    }
    move(dataId, values, shape, dtype, refCount) {
        if ((0, $aymVi.env)().getBool('DEBUG')) this.checkNumericalProblems(values);
        if (dtype === 'complex64') throw new Error(`Cannot write to a complex64 dtype. ` + `Please use tf.complex(real, imag).`);
        this.texData.set(dataId, {
            shape: shape,
            dtype: dtype,
            values: values,
            usage: (0, $lE6VE.TextureUsage).UPLOAD,
            refCount: refCount
        });
    }
    disposeIntermediateTensorInfo(tensorInfo) {
        this.disposeData(tensorInfo.dataId);
    }
    readSync(dataId) {
        const texData = this.texData.get(dataId);
        const { values: values, dtype: dtype, complexTensorInfos: complexTensorInfos, slice: slice, shape: shape, isPacked: isPacked } = texData;
        // The presence of `slice` indicates this tensor is a shallow slice of a
        // different tensor, and is using that original tensor's texture. Run
        // `clone` in order to copy that texture and read from it.
        if (slice != null) {
            let program;
            if (isPacked) program = new (0, $2RjWv.UnaryOpPackedProgram)(shape, $2sCkP.CLONE);
            else program = new (0, $2sCkP.UnaryOpProgram)(shape, $2sCkP.CLONE);
            const res = this.runWebGLProgram(program, [
                {
                    dataId: dataId,
                    shape: shape,
                    dtype: dtype
                }
            ], dtype);
            const data = this.readSync(res.dataId);
            this.disposeIntermediateTensorInfo(res);
            return data;
        }
        if (values != null) return this.convertAndCacheOnCPU(dataId);
        if (dtype === 'string') return values;
        const shouldTimeProgram = this.activeTimers != null;
        let start;
        if (shouldTimeProgram) start = (0, $wx9lK).now();
        let result;
        if (dtype === 'complex64') {
            const realValues = this.readSync(complexTensorInfos.real.dataId);
            const imagValues = this.readSync(complexTensorInfos.imag.dataId);
            result = (0, $lkN62).mergeRealAndImagArrays(realValues, imagValues);
        } else result = this.getValuesFromTexture(dataId);
        if (shouldTimeProgram) this.downloadWaitMs += (0, $wx9lK).now() - start;
        return this.convertAndCacheOnCPU(dataId, result);
    }
    async read(dataId) {
        if (this.pendingRead.has(dataId)) {
            const subscribers = this.pendingRead.get(dataId);
            return new Promise((resolve)=>subscribers.push(resolve));
        }
        const texData = this.texData.get(dataId);
        const { values: values, shape: shape, slice: slice, dtype: dtype, complexTensorInfos: complexTensorInfos, isPacked: isPacked } = texData;
        // The presence of `slice` indicates this tensor is a shallow slice of a
        // different tensor, and is using that original tensor's texture. Run
        // `clone` in order to copy that texture and read from it.
        if (slice != null) {
            let program;
            if (isPacked) program = new (0, $2RjWv.UnaryOpPackedProgram)(shape, $2sCkP.CLONE);
            else program = new (0, $2sCkP.UnaryOpProgram)(shape, $2sCkP.CLONE);
            const res = this.runWebGLProgram(program, [
                {
                    dataId: dataId,
                    shape: shape,
                    dtype: dtype
                }
            ], dtype);
            const data = this.read(res.dataId);
            this.disposeIntermediateTensorInfo(res);
            return data;
        }
        if (values != null) return this.convertAndCacheOnCPU(dataId);
        if ((0, $aymVi.env)().getBool('DEBUG')) {
            // getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED') caused a blocking GPU call.
            // For performance reason, only check it for debugging. In production,
            // it doesn't handle this use case anyway, so behavior is not changed.
            if (!(0, $aymVi.env)().getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED') && (0, $aymVi.env)().getNumber('WEBGL_VERSION') === 2) throw new Error(`tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and ` + `WEBGL_VERSION=2 not yet supported.`);
        }
        let buffer = null;
        let tmpDownloadTarget;
        if (dtype !== 'complex64' && (0, $aymVi.env)().get('WEBGL_BUFFER_SUPPORTED')) {
            // Possibly copy the texture into a buffer before inserting a fence.
            tmpDownloadTarget = this.decode(dataId);
            const tmpData = this.texData.get(tmpDownloadTarget.dataId);
            buffer = this.gpgpu.createBufferFromTexture(tmpData.texture.texture, ...$lE6VE.getDenseTexShape(shape));
        }
        this.pendingRead.set(dataId, []);
        if (dtype !== 'complex64') // Create a fence and wait for it to resolve.
        await this.gpgpu.createAndWaitForFence();
        // Download the values from the GPU.
        let vals;
        if (dtype === 'complex64') {
            const ps = await Promise.all([
                this.read(complexTensorInfos.real.dataId),
                this.read(complexTensorInfos.imag.dataId)
            ]);
            const realValues = ps[0];
            const imagValues = ps[1];
            vals = (0, $lkN62).mergeRealAndImagArrays(realValues, imagValues);
        } else if (buffer == null) vals = this.getValuesFromTexture(dataId);
        else {
            const size = (0, $wx9lK).sizeFromShape(shape);
            vals = this.gpgpu.downloadFloat32MatrixFromBuffer(buffer, size);
        }
        if (tmpDownloadTarget != null) this.disposeIntermediateTensorInfo(tmpDownloadTarget);
        if (buffer != null) {
            const gl = this.gpgpu.gl;
            $4rulI.callAndCheck(gl, ()=>gl.deleteBuffer(buffer));
        }
        const dTypeVals = this.convertAndCacheOnCPU(dataId, vals);
        const subscribers = this.pendingRead.get(dataId);
        this.pendingRead.delete(dataId);
        // Notify all pending reads.
        subscribers.forEach((resolve)=>resolve(dTypeVals));
        if (this.pendingDisposal.has(dataId)) {
            this.pendingDisposal.delete(dataId);
            if (this.disposeData(dataId)) (0, $9c0Qr.engine)().removeDataId(dataId, this);
            this.pendingDeletes--;
        }
        return dTypeVals;
    }
    /**
     * Read tensor to a new texture that is densely packed for ease of use.
     * @param dataId The source tensor.
     * @param options
     *     customTexShape: Optional. If set, will use the user defined texture
     *     shape to create the texture.
     */ readToGPU(dataId, options = {}) {
        const texData = this.texData.get(dataId);
        const { values: values, shape: shape, slice: slice, dtype: dtype, isPacked: isPacked, texture: texture } = texData;
        if (dtype === 'complex64') throw new Error('Does not support reading texture for complex64 dtype.');
        // The presence of `slice` indicates this tensor is a shallow slice of a
        // different tensor, and is using that original tensor's texture. Run
        // `clone` in order to copy that texture and read from it.
        if (slice != null) {
            let program;
            if (isPacked) program = new (0, $2RjWv.UnaryOpPackedProgram)(shape, $2sCkP.CLONE);
            else program = new (0, $2sCkP.UnaryOpProgram)(shape, $2sCkP.CLONE);
            const res = this.runWebGLProgram(program, [
                {
                    dataId: dataId,
                    shape: shape,
                    dtype: dtype
                }
            ], dtype);
            const gpuResouorce = this.readToGPU(res, options);
            this.disposeIntermediateTensorInfo(res);
            return gpuResouorce;
        }
        if (texture == null) {
            if (values != null) throw new Error('Data is not on GPU but on CPU.');
            else throw new Error('There is no data on GPU or CPU.');
        }
        // Decode the texture so that it is stored densely (using four channels).
        const tmpTarget = this.decode(dataId, options.customTexShape);
        // Make engine track this tensor, so that we can dispose it later.
        const tensorRef = (0, $9c0Qr.engine)().makeTensorFromTensorInfo(tmpTarget);
        const tmpData = this.texData.get(tmpTarget.dataId);
        return Object.assign({
            tensorRef: tensorRef
        }, tmpData.texture);
    }
    bufferSync(t) {
        const data = this.readSync(t.dataId);
        if (t.dtype === 'string') try {
            // Decode the bytes into string.
            const strings = data.map((d)=>(0, $wx9lK).decodeString(d));
            return (0, $g81BN.buffer)(t.shape, t.dtype, strings);
        } catch (_a) {
            throw new Error('Failed to decode encoded string bytes into utf-8');
        }
        return (0, $g81BN.buffer)(t.shape, t.dtype, data);
    }
    checkNumericalProblems(values) {
        if (values == null) return;
        for(let i = 0; i < values.length; i++){
            const num = values[i];
            if (!$4rulI.canBeRepresented(num)) {
                if ((0, $aymVi.env)().getBool('WEBGL_RENDER_FLOAT32_CAPABLE')) throw Error(`The value ${num} cannot be represented with your ` + `current settings. Consider enabling float32 rendering: ` + `'tf.env().set('WEBGL_RENDER_FLOAT32_ENABLED', true);'`);
                throw Error(`The value ${num} cannot be represented on this device.`);
            }
        }
    }
    getValuesFromTexture(dataId) {
        const { shape: shape, dtype: dtype, isPacked: isPacked } = this.texData.get(dataId);
        const size = (0, $wx9lK).sizeFromShape(shape);
        if ((0, $aymVi.env)().getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED')) {
            const tmpTarget = this.decode(dataId);
            const tmpData = this.texData.get(tmpTarget.dataId);
            const vals = this.gpgpu.downloadMatrixFromPackedTexture(tmpData.texture.texture, ...$lE6VE.getDenseTexShape(shape)).subarray(0, size);
            this.disposeIntermediateTensorInfo(tmpTarget);
            return vals;
        }
        const shouldUsePackedProgram = (0, $aymVi.env)().getBool('WEBGL_PACK') && isPacked === true;
        const outputShape = shouldUsePackedProgram ? $4rulI.getShapeAs3D(shape) : shape;
        const program = shouldUsePackedProgram ? new (0, $a9Naf.EncodeFloatPackedProgram)(outputShape) : new (0, $gbYDR.EncodeFloatProgram)(outputShape);
        const output = this.runWebGLProgram(program, [
            {
                shape: outputShape,
                dtype: dtype,
                dataId: dataId
            }
        ], 'float32');
        const tmpData = this.texData.get(output.dataId);
        const vals = this.gpgpu.downloadByteEncodedFloatMatrixFromOutputTexture(tmpData.texture.texture, tmpData.texShape[0], tmpData.texShape[1]).subarray(0, size);
        this.disposeIntermediateTensorInfo(output);
        return vals;
    }
    timerAvailable() {
        return (0, $aymVi.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0;
    }
    time(f) {
        const oldActiveTimers = this.activeTimers;
        const newActiveTimers = [];
        let outerMostTime = false;
        if (this.programTimersStack == null) {
            this.programTimersStack = newActiveTimers;
            outerMostTime = true;
        } else this.activeTimers.push(newActiveTimers);
        this.activeTimers = newActiveTimers;
        f();
        // needing to split these up because util.flatten only accepts certain types
        const flattenedActiveTimerQueries = (0, $wx9lK).flatten(this.activeTimers.map((d)=>d.query)).filter((d)=>d != null);
        const flattenedActiveTimerNames = (0, $wx9lK).flatten(this.activeTimers.map((d)=>d.name)).filter((d)=>d != null);
        this.activeTimers = oldActiveTimers;
        if (outerMostTime) this.programTimersStack = null;
        const res = {
            uploadWaitMs: this.uploadWaitMs,
            downloadWaitMs: this.downloadWaitMs,
            kernelMs: null,
            wallMs: null // will be filled by the engine
        };
        return (async ()=>{
            if ((0, $aymVi.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) {
                const kernelMs = await Promise.all(flattenedActiveTimerQueries);
                res['kernelMs'] = (0, $wx9lK).sum(kernelMs);
                res['getExtraProfileInfo'] = ()=>kernelMs.map((d, i)=>({
                            name: flattenedActiveTimerNames[i],
                            ms: d
                        })).map((d)=>`${d.name}: ${d.ms}`).join(', ');
            } else res['kernelMs'] = {
                error: 'WebGL query timers are not supported in this environment.'
            };
            this.uploadWaitMs = 0;
            this.downloadWaitMs = 0;
            return res;
        })();
    }
    memory() {
        return {
            unreliable: false,
            numBytesInGPU: this.numBytesInGPU,
            numBytesInGPUAllocated: this.textureManager.numBytesAllocated,
            numBytesInGPUFree: this.textureManager.numBytesFree
        };
    }
    startTimer() {
        if ((0, $aymVi.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) return this.gpgpu.beginQuery();
        return {
            startMs: (0, $wx9lK).now(),
            endMs: null
        };
    }
    endTimer(query) {
        if ((0, $aymVi.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) {
            this.gpgpu.endQuery();
            return query;
        }
        query.endMs = (0, $wx9lK).now();
        return query;
    }
    async getQueryTime(query) {
        if ((0, $aymVi.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) return this.gpgpu.waitForQueryAndGetTime(query);
        const timerQuery = query;
        return timerQuery.endMs - timerQuery.startMs;
    }
    /**
     * Decrease the RefCount on the dataId and dispose the memory if the dataId
     * has 0 refCount. If there are pending read on the data, the disposal would
     * added to the pending delete queue. Return true if the dataId is removed
     * from backend or the backend does not contain the dataId, false if the
     * dataId is not removed. Memory may or may not be released even when dataId
     * is removed, which also depends on dataRefCount, see `releaseGPU`.
     * @param dataId
     * @oaram force Optional, remove the data regardless of refCount
     */ disposeData(dataId, force = false) {
        if (this.pendingDisposal.has(dataId)) return false;
        // No-op if already disposed.
        if (!this.texData.has(dataId)) return true;
        // if force flag is set, change refCount to 0, this would ensure disposal
        // when added to the pendingDisposal queue. Memory may or may not be
        // released, which also depends on dataRefCount, see `releaseGPU`.
        if (force) this.texData.get(dataId).refCount = 0;
        else this.texData.get(dataId).refCount--;
        if (!force && this.texData.get(dataId).refCount > 0) return false;
        if (this.pendingRead.has(dataId)) {
            this.pendingDisposal.add(dataId);
            this.pendingDeletes++;
            return false;
        }
        this.releaseGPUData(dataId);
        const { complexTensorInfos: complexTensorInfos } = this.texData.get(dataId);
        if (complexTensorInfos != null) {
            this.disposeData(complexTensorInfos.real.dataId, force);
            this.disposeData(complexTensorInfos.imag.dataId, force);
        }
        this.texData.delete(dataId);
        return true;
    }
    releaseGPUData(dataId) {
        const { texture: texture, dtype: dtype, texShape: texShape, usage: usage, isPacked: isPacked, slice: slice } = this.texData.get(dataId);
        const key = slice && slice.origDataId || dataId;
        const refCount = this.dataRefCount.get(key);
        if (refCount > 1) this.dataRefCount.set(key, refCount - 1);
        else {
            this.dataRefCount.delete(key);
            if (texture != null) {
                this.numBytesInGPU -= this.computeBytes(texShape, dtype);
                this.textureManager.releaseTexture(texture, texShape, usage, isPacked);
            }
        }
        const texData = this.texData.get(dataId);
        texData.texture = null;
        texData.texShape = null;
        texData.isPacked = false;
        texData.slice = null;
    }
    getTexture(dataId) {
        this.uploadToGPU(dataId);
        return this.texData.get(dataId).texture.texture;
    }
    /**
     * Returns internal information for the specific data bucket. Used in unit
     * tests.
     */ getDataInfo(dataId) {
        return this.texData.get(dataId);
    }
    /*
    Tests whether all the inputs to an op are small and on the CPU. This heuristic
    determines when it would be faster to execute a kernel on the CPU. WebGL
    kernels opt into running this check and forwarding when appropriate.
    TODO(https://github.com/tensorflow/tfjs/issues/872): Develop a more
    sustainable strategy for optimizing backend execution of ops.
     */ shouldExecuteOnCPU(inputs, sizeThreshold = $d7e279048eea3b47$var$CPU_HANDOFF_SIZE_THRESHOLD) {
        return (0, $aymVi.env)().getBool('WEBGL_CPU_FORWARD') && inputs.every((input)=>this.texData.get(input.dataId).texture == null && (0, $wx9lK).sizeFromShape(input.shape) < sizeThreshold);
    }
    getGPGPUContext() {
        return this.gpgpu;
    }
    where(condition) {
        (0, $lkN62).warn("tf.where() in webgl locks the UI thread. Call tf.whereAsync() instead");
        const condVals = condition.dataSync();
        return $d7e279048eea3b47$var$whereImpl(condition.shape, condVals);
    }
    packedUnaryOp(x, op, dtype) {
        const program = new (0, $2RjWv.UnaryOpPackedProgram)(x.shape, op);
        const outInfo = this.compileAndRun(program, [
            x
        ], dtype);
        return (0, $9c0Qr.engine)().makeTensorFromTensorInfo(outInfo);
    }
    // TODO(msoulanille) remove this once the backend has been modularized
    // a copy is needed here to break a circular dependency.
    // Also remove the op from unary_op.
    abs(x) {
        // TODO: handle cases when x is complex.
        if (this.shouldExecuteOnCPU([
            x
        ]) && x.dtype !== 'complex64') {
            const outValues = (0, $fIVdF.simpleAbsImplCPU)(this.texData.get(x.dataId).values);
            return this.makeOutput(x.shape, x.dtype, outValues);
        }
        if ((0, $aymVi.env)().getBool('WEBGL_PACK_UNARY_OPERATIONS')) return this.packedUnaryOp(x, $2sCkP.ABS, x.dtype);
        const program = new (0, $2sCkP.UnaryOpProgram)(x.shape, $2sCkP.ABS);
        const outInfo = this.compileAndRun(program, [
            x
        ]);
        return (0, $9c0Qr.engine)().makeTensorFromTensorInfo(outInfo);
    }
    makeTensorInfo(shape, dtype, values) {
        let dataId;
        if (dtype === 'string' && values != null && values.length > 0 && (0, $wx9lK).isString(values[0])) {
            const encodedValues = values.map((d)=>(0, $wx9lK).encodeString(d));
            dataId = this.write(encodedValues, shape, dtype);
        } else dataId = this.write(values, shape, dtype);
        this.texData.get(dataId).usage = null;
        return {
            dataId: dataId,
            shape: shape,
            dtype: dtype
        };
    }
    makeOutput(shape, dtype, values) {
        return (0, $9c0Qr.engine)().makeTensorFromTensorInfo(this.makeTensorInfo(shape, dtype, values), this);
    }
    unpackTensor(input) {
        const program = new (0, $QPOIZ.UnpackProgram)(input.shape);
        return this.runWebGLProgram(program, [
            input
        ], input.dtype);
    }
    packTensor(input) {
        const program = new (0, $6ljdK.PackProgram)(input.shape);
        const preventEagerUnpackingOutput = true;
        return this.runWebGLProgram(program, [
            input
        ], input.dtype, null, preventEagerUnpackingOutput);
    }
    packedReshape(input, afterShape) {
        const input3DShape = [
            $4rulI.getBatchDim(input.shape),
            ...$4rulI.getRowsCols(input.shape)
        ];
        const input3D = {
            dtype: input.dtype,
            shape: input3DShape,
            dataId: input.dataId
        };
        const afterShapeAs3D = [
            $4rulI.getBatchDim(afterShape),
            ...$4rulI.getRowsCols(afterShape)
        ];
        const program = new (0, $48uvZ.ReshapePackedProgram)(afterShapeAs3D, input3DShape);
        const preventEagerUnpackingOfOutput = true;
        const customValues = [
            input3DShape
        ];
        const output = this.runWebGLProgram(program, [
            input3D
        ], input.dtype, customValues, preventEagerUnpackingOfOutput);
        return {
            dataId: output.dataId,
            shape: afterShape,
            dtype: output.dtype
        };
    }
    decode(dataId, customTexShape) {
        const texData = this.texData.get(dataId);
        const { isPacked: isPacked, shape: shape, dtype: dtype } = texData;
        if (customTexShape != null) {
            const size = (0, $wx9lK).sizeFromShape(shape);
            const texSize = customTexShape[0] * customTexShape[1] * 4;
            (0, $wx9lK).assert(size <= texSize, ()=>"customTexShape is too small. Row * Column * 4 should be equal or larger than the size of the tensor data.");
        }
        const shapeAs3D = $4rulI.getShapeAs3D(shape);
        let program;
        if (isPacked) program = new (0, $auraC.DecodeMatrixPackedProgram)(shapeAs3D);
        else program = new (0, $akZ7H.DecodeMatrixProgram)(shapeAs3D);
        const preventEagerUnpackingOfOutput = true;
        const customValues = [
            customTexShape != null ? customTexShape : $lE6VE.getDenseTexShape(shapeAs3D)
        ];
        const out = this.runWebGLProgram(program, [
            {
                shape: shapeAs3D,
                dtype: dtype,
                dataId: dataId
            }
        ], dtype, customValues, preventEagerUnpackingOfOutput, customTexShape);
        return {
            dtype: dtype,
            shape: shape,
            dataId: out.dataId
        };
    }
    runWebGLProgram(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput = false, customTexShape) {
        const output = this.makeTensorInfo(program.outputShape, outputDtype);
        const outData = this.texData.get(output.dataId);
        if (program.packedOutput) outData.isPacked = true;
        if (program.outPackingScheme === $lE6VE.PackingScheme.DENSE) {
            const texelShape = customTexShape != null ? customTexShape : $lE6VE.getDenseTexShape(program.outputShape);
            // For a densely packed output, we explicitly set texShape
            // so it doesn't get assigned later according to our typical packing
            // scheme wherein a single texel can only contain values from adjacent
            // rows/cols.
            outData.texShape = texelShape.map((d)=>d * 2);
        }
        if (program.outTexUsage != null) outData.usage = program.outTexUsage;
        if ((0, $wx9lK).sizeFromShape(output.shape) === 0) {
            // Short-circuit the computation since the result is empty (has 0 in its
            // shape).
            outData.values = (0, $wx9lK).getTypedArrayFromDType(output.dtype, 0);
            return output;
        }
        const dataToDispose = [];
        const inputsData = inputs.map((input)=>{
            if (input.dtype === 'complex64') throw new Error(`GPGPUProgram does not support complex64 input. For complex64 ` + `dtypes, please separate the program into real and imaginary ` + `parts.`);
            let texData = this.texData.get(input.dataId);
            if (texData.texture == null) {
                if (!program.packedInputs && (0, $wx9lK).sizeFromShape(input.shape) <= (0, $aymVi.env)().getNumber('WEBGL_SIZE_UPLOAD_UNIFORM')) // Upload small tensors that live on the CPU as uniforms, not as
                // textures. Do this only when the environment supports 32bit floats
                // due to problems when comparing 16bit floats with 32bit floats.
                // TODO(https://github.com/tensorflow/tfjs/issues/821): Make it
                // possible for packed shaders to sample from uniforms.
                return {
                    shape: input.shape,
                    texData: null,
                    isUniform: true,
                    uniformValues: texData.values
                };
                // This ensures that if a packed program's inputs have not yet been
                // uploaded to the GPU, they get uploaded as packed right off the bat.
                if (program.packedInputs) {
                    texData.isPacked = true;
                    texData.shape = input.shape;
                }
            }
            this.uploadToGPU(input.dataId);
            if (!!texData.isPacked !== !!program.packedInputs) {
                input = texData.isPacked ? this.unpackTensor(input) : this.packTensor(input);
                dataToDispose.push(input);
                texData = this.texData.get(input.dataId);
            } else if (texData.isPacked && !$4rulI.isReshapeFree(texData.shape, input.shape)) {
                // This is a special case where a texture exists for a tensor
                // but the shapes are incompatible (due to packing constraints) because
                // the tensor did not have a chance to go through the packed reshape
                // shader. This only happens when we reshape the *same* tensor to form
                // *distinct* inputs to an op, e.g. dotting a vector with itself. This
                // case will disappear once packed uploading is the default.
                const savedInput = input;
                const targetShape = input.shape;
                input.shape = texData.shape;
                input = this.packedReshape(input, targetShape);
                dataToDispose.push(input);
                texData = this.texData.get(input.dataId);
                savedInput.shape = targetShape;
            }
            return {
                shape: input.shape,
                texData: texData,
                isUniform: false
            };
        });
        this.uploadToGPU(output.dataId);
        const outputData = {
            shape: output.shape,
            texData: outData,
            isUniform: false
        };
        const key = $i88bA.makeShaderKey(program, inputsData, outputData);
        const binary = this.getAndSaveBinary(key, ()=>{
            return $i88bA.compileProgram(this.gpgpu, program, inputsData, outputData);
        });
        const shouldTimeProgram = this.activeTimers != null;
        let query;
        if (shouldTimeProgram) query = this.startTimer();
        if (!(0, $aymVi.env)().get('ENGINE_COMPILE_ONLY')) $i88bA.runProgram(this.gpgpu, binary, inputsData, outputData, customUniformValues);
        dataToDispose.forEach((info)=>this.disposeIntermediateTensorInfo(info));
        if (shouldTimeProgram) {
            query = this.endTimer(query);
            this.activeTimers.push({
                name: program.constructor.name,
                query: this.getQueryTime(query)
            });
        }
        const glFlushThreshold = (0, $aymVi.env)().get('WEBGL_FLUSH_THRESHOLD');
        // Manually GL flush requested
        if (glFlushThreshold > 0) {
            const time = (0, $wx9lK).now();
            if (time - this.lastGlFlushTime > glFlushThreshold) {
                this.gpgpu.gl.flush();
                this.lastGlFlushTime = time;
            }
        }
        if (!(0, $aymVi.env)().getBool('WEBGL_LAZILY_UNPACK') && outData.isPacked && preventEagerUnpackingOfOutput === false) {
            const unpacked = this.unpackTensor(output);
            this.disposeIntermediateTensorInfo(output);
            return unpacked;
        }
        return output;
    }
    compileAndRun(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput = false) {
        outputDtype = outputDtype || inputs[0].dtype;
        const outInfo = this.runWebGLProgram(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput);
        return outInfo;
    }
    getAndSaveBinary(key, getBinary) {
        if (!(key in this.binaryCache)) this.binaryCache[key] = getBinary();
        return this.binaryCache[key];
    }
    getTextureManager() {
        return this.textureManager;
    }
    dispose() {
        if (this.disposed) return;
        // Avoid disposing the compiled webgl programs during unit testing because
        // it slows down test execution.
        if (!(0, $aymVi.env)().getBool('IS_TEST')) {
            const allKeys = Object.keys(this.binaryCache);
            allKeys.forEach((key)=>{
                this.gpgpu.deleteProgram(this.binaryCache[key].webGLProgram);
                delete this.binaryCache[key];
            });
        }
        this.textureManager.dispose();
        if (this.canvas != null && typeof HTMLCanvasElement !== 'undefined' && this.canvas instanceof HTMLCanvasElement) this.canvas.remove();
        else this.canvas = null;
        if (this.gpgpuCreatedLocally) {
            this.gpgpu.program = null;
            this.gpgpu.dispose();
        }
        this.disposed = true;
    }
    floatPrecision() {
        if (this.floatPrecisionValue == null) this.floatPrecisionValue = (0, $9c0Qr.tidy)(()=>{
            if (!(0, $aymVi.env)().get('WEBGL_RENDER_FLOAT32_ENABLED')) {
                // Momentarily switching DEBUG flag to false so we don't throw an
                // error trying to upload a small value.
                const debugFlag = (0, $aymVi.env)().getBool('DEBUG');
                (0, $aymVi.env)().set('DEBUG', false);
                const underflowCheckValue = this.abs((0, $j7yUF.scalar)(1e-8)).dataSync()[0];
                (0, $aymVi.env)().set('DEBUG', debugFlag);
                if (underflowCheckValue > 0) return 32;
            }
            return 16;
        });
        return this.floatPrecisionValue;
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return this.floatPrecision() === 32 ? $d7e279048eea3b47$export$76e53a66c52b6d4d : $d7e279048eea3b47$export$49716d145771e6a2;
    }
    uploadToGPU(dataId) {
        const texData = this.texData.get(dataId);
        const { shape: shape, dtype: dtype, values: values, texture: texture, usage: usage, isPacked: isPacked } = texData;
        if (texture != null) // Array is already on GPU. No-op.
        return;
        const shouldTimeProgram = this.activeTimers != null;
        let start;
        if (shouldTimeProgram) start = (0, $wx9lK).now();
        let texShape = texData.texShape;
        if (texShape == null) {
            // This texShape may not be the final texture shape. For packed or dense
            // textures, the texShape will be changed when textures are created.
            texShape = $4rulI.getTextureShapeFromLogicalShape(shape, isPacked);
            texData.texShape = texShape;
        }
        if (values != null) {
            const shapeAs3D = $4rulI.getShapeAs3D(shape);
            let program;
            let width = texShape[1], height = texShape[0];
            const isByteArray = values instanceof Uint8Array || values instanceof Uint8ClampedArray;
            // texture for float array is PhysicalTextureType.PACKED_2X2_FLOAT32, we
            // need to make sure the upload uses the same packed size
            if (isPacked || !isByteArray) [width, height] = $lE6VE.getPackedMatrixTextureShapeWidthHeight(texShape[0], texShape[1]);
            if (isPacked) program = new (0, $eoRA9.EncodeMatrixPackedProgram)(shapeAs3D, isByteArray);
            else program = new (0, $iwdC3.EncodeMatrixProgram)(shapeAs3D, isByteArray);
            // TexShape for float array needs to be the original shape, which byte
            // array needs to be packed size. This allow the data upload shape to be
            // matched with texture creation logic.
            const tempDenseInputTexShape = isByteArray ? [
                height,
                width
            ] : texShape;
            const tempDenseInputHandle = this.makeTensorInfo(tempDenseInputTexShape, dtype);
            const tempDenseInputTexData = this.texData.get(tempDenseInputHandle.dataId);
            if (isByteArray) tempDenseInputTexData.usage = (0, $lE6VE.TextureUsage).PIXELS;
            else tempDenseInputTexData.usage = (0, $lE6VE.TextureUsage).UPLOAD;
            tempDenseInputTexData.texShape = tempDenseInputTexShape;
            this.gpgpu.uploadDenseMatrixToTexture(this.getTexture(tempDenseInputHandle.dataId), width, height, values);
            const customValues = [
                [
                    height,
                    width
                ]
            ];
            // We want the output to remain packed regardless of the value of
            // WEBGL_PACK.
            const preventEagerUnpacking = true;
            const encodedOutputTarget = this.runWebGLProgram(program, [
                tempDenseInputHandle
            ], dtype, customValues, preventEagerUnpacking);
            // Have the original texture assume the identity of the encoded output.
            const outputTexData = this.texData.get(encodedOutputTarget.dataId);
            texData.texShape = outputTexData.texShape;
            texData.isPacked = outputTexData.isPacked;
            texData.usage = outputTexData.usage;
            if (!(0, $aymVi.env)().get('ENGINE_COMPILE_ONLY')) {
                texData.texture = outputTexData.texture;
                // Once uploaded, don't store the values on cpu.
                texData.values = null;
                this.texData.delete(encodedOutputTarget.dataId);
            } else this.disposeData(encodedOutputTarget.dataId);
            this.disposeIntermediateTensorInfo(tempDenseInputHandle);
            if (shouldTimeProgram) this.uploadWaitMs += (0, $wx9lK).now() - start;
        } else {
            const newTexture = this.acquireTexture(texShape, usage, dtype, isPacked);
            texData.texture = newTexture;
        }
    }
    convertAndCacheOnCPU(dataId, float32Values) {
        const texData = this.texData.get(dataId);
        const { dtype: dtype } = texData;
        this.releaseGPUData(dataId);
        if (float32Values != null) texData.values = $d7e279048eea3b47$var$float32ToTypedArray(float32Values, dtype);
        return texData.values;
    }
    acquireTexture(texShape, texType, dtype, isPacked) {
        this.numBytesInGPU += this.computeBytes(texShape, dtype);
        if (!this.warnedAboutMemory && this.numBytesInGPU > this.numMBBeforeWarning * 1048576) {
            const mb = (this.numBytesInGPU / 1024 / 1024).toFixed(2);
            this.warnedAboutMemory = true;
            console.warn(`High memory usage in GPU: ${mb} MB, ` + `most likely due to a memory leak`);
        }
        return this.textureManager.acquireTexture(texShape, texType, isPacked);
    }
    computeBytes(shape, dtype) {
        return shape[0] * shape[1] * (0, $wx9lK).bytesPerElement(dtype);
    }
    checkCompileCompletion() {
        for (const [, binary] of Object.entries(this.binaryCache))this.checkCompletion_(binary);
    }
    async checkCompileCompletionAsync() {
        const ps = [];
        if (this.gpgpu.parallelCompilationExtension) {
            for (const [, binary] of Object.entries(this.binaryCache))ps.push(this.checkCompletionAsync_(binary));
            return Promise.all(ps);
        } else {
            for (const [, binary] of Object.entries(this.binaryCache)){
                const p = new Promise((resolve)=>{
                    try {
                        this.checkCompletion_(binary);
                        resolve(true);
                    } catch (error) {
                        throw error;
                    }
                });
                ps.push(p);
            }
            return Promise.all(ps);
        }
    }
    async checkCompletionAsync_(binary) {
        if (this.gpgpu.gl.getProgramParameter(binary.webGLProgram, this.gpgpu.parallelCompilationExtension.COMPLETION_STATUS_KHR)) return this.checkCompletion_(binary);
        else {
            await (0, $hy0Vl.nextFrame)();
            return this.checkCompletionAsync_(binary);
        }
    }
    checkCompletion_(binary) {
        if (this.gpgpu.gl.getProgramParameter(binary.webGLProgram, this.gpgpu.gl.LINK_STATUS) === false) {
            console.log(this.gpgpu.gl.getProgramInfoLog(binary.webGLProgram));
            if (this.gpgpu.gl.getShaderParameter(binary.fragmentShader, this.gpgpu.gl.COMPILE_STATUS) === false) {
                $4rulI.logShaderSourceAndInfoLog(binary.source, this.gpgpu.gl.getShaderInfoLog(binary.fragmentShader));
                throw new Error('Failed to compile fragment shader.');
            }
            throw new Error('Failed to link vertex and fragment shaders.');
        }
        return true;
    }
    getUniformLocations() {
        for (const [, binary] of Object.entries(this.binaryCache)){
            const { uniformLocations: uniformLocations, customUniformLocations: customUniformLocations, infLoc: infLoc, nanLoc: nanLoc, inShapesLocations: inShapesLocations, inTexShapesLocations: inTexShapesLocations, outShapeLocation: outShapeLocation, outShapeStridesLocation: outShapeStridesLocation, outTexShapeLocation: outTexShapeLocation } = (0, $i88bA.getUniformLocations)(this.gpgpu, binary.program, binary.webGLProgram);
            binary.uniformLocations = uniformLocations;
            binary.customUniformLocations = customUniformLocations;
            binary.infLoc = infLoc;
            binary.nanLoc = nanLoc;
            binary.inShapesLocations = inShapesLocations;
            binary.inTexShapesLocations = inTexShapesLocations;
            binary.outShapeLocation = outShapeLocation;
            binary.outShapeStridesLocation = outShapeStridesLocation;
            binary.outTexShapeLocation = outTexShapeLocation;
        }
    }
}
$d7e279048eea3b47$export$33567d88bc7c6249.nextDataId = 0;
function $d7e279048eea3b47$var$float32ToTypedArray(a, dtype) {
    if (dtype === 'float32' || dtype === 'complex64') return a;
    else if (dtype === 'int32' || dtype === 'bool') {
        const result = dtype === 'int32' ? new Int32Array(a.length) : new Uint8Array(a.length);
        for(let i = 0; i < result.length; ++i)result[i] = Math.round(a[i]);
        return result;
    } else throw new Error(`Unknown dtype ${dtype}`);
}

});
parcelRegister("i11mb", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $7L9WU = parcelRequire("7L9WU");
var $aymVi = parcelRequire("aymVi");

var $4rulI = parcelRequire("4rulI");
const $d1d95f6e470f42c2$var$ENV = (0, $aymVi.env)();
/**
 * This file contains WebGL-specific flag registrations.
 */ /**
 * True if WebGL is supported.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('HAS_WEBGL', ()=>$d1d95f6e470f42c2$var$ENV.getNumber('WEBGL_VERSION') > 0);
/** 0: No WebGL, 1: WebGL 1.0, 2: WebGL 2.0. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_VERSION', ()=>{
    if ((0, $4rulI.isWebGLVersionEnabled)(2)) return 2;
    else if ((0, $4rulI.isWebGLVersionEnabled)(1)) return 1;
    return 0;
});
/** Whether to check for numerical representation problems. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_CHECK_NUMERICAL_PROBLEMS', ()=>false);
$d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_BUFFER_SUPPORTED', ()=>$d1d95f6e470f42c2$var$ENV.get('WEBGL_VERSION') === 2);
/** Whether the WebGL backend will sometimes forward ops to the CPU. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_CPU_FORWARD', ()=>true);
/** Whether the WebGL backend will always use f16 textures for rendering. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_FORCE_F16_TEXTURES', ()=>false);
/** Whether to turn all packing related flags on. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_PACK', ()=>$d1d95f6e470f42c2$var$ENV.getBool('HAS_WEBGL'));
/** Whether we will pack the batchnormalization op. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_PACK_NORMALIZATION', ()=>$d1d95f6e470f42c2$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack the clip op. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_PACK_CLIP', ()=>$d1d95f6e470f42c2$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack the depthwise conv op. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_PACK_DEPTHWISECONV', ()=>$d1d95f6e470f42c2$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack binary ops. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_PACK_BINARY_OPERATIONS', ()=>$d1d95f6e470f42c2$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack unary ops. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_PACK_UNARY_OPERATIONS', ()=>$d1d95f6e470f42c2$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack array ops. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_PACK_ARRAY_OPERATIONS', ()=>$d1d95f6e470f42c2$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack image ops. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_PACK_IMAGE_OPERATIONS', ()=>$d1d95f6e470f42c2$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack reduce ops. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_PACK_REDUCE', ()=>$d1d95f6e470f42c2$var$ENV.getBool('WEBGL_PACK'));
/** Whether packed WebGL kernels lazily unpack their outputs. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_LAZILY_UNPACK', ()=>$d1d95f6e470f42c2$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will use the im2col algorithm to speed up convolutions. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_CONV_IM2COL', ()=>$d1d95f6e470f42c2$var$ENV.getBool('WEBGL_PACK'));
/** The maximum texture dimension. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_MAX_TEXTURE_SIZE', ()=>(0, $4rulI.getWebGLMaxTextureSize)($d1d95f6e470f42c2$var$ENV.getNumber('WEBGL_VERSION')));
/** The maximum texture dimension. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_MAX_TEXTURES_IN_SHADER', ()=>(0, $4rulI.getMaxTexturesInShader)($d1d95f6e470f42c2$var$ENV.getNumber('WEBGL_VERSION')));
/**
 * The disjoint_query_timer extension version.
 * 0: disabled, 1: EXT_disjoint_timer_query, 2:
 * EXT_disjoint_timer_query_webgl2.
 * In Firefox with WebGL 2.0,
 * EXT_disjoint_timer_query_webgl2 is not available, so we must use the
 * WebGL 1.0 extension.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION', ()=>{
    const webGLVersion = $d1d95f6e470f42c2$var$ENV.getNumber('WEBGL_VERSION');
    if (webGLVersion === 0) return 0;
    return (0, $4rulI.getWebGLDisjointQueryTimerVersion)(webGLVersion);
});
/**
 * Whether the timer object from the disjoint_query_timer extension gives
 * timing information that is reliable.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE', ()=>$d1d95f6e470f42c2$var$ENV.getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') > 0 && !(0, $7L9WU).isMobile());
/**
 * Whether the device is physically capable of rendering to float32 textures.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_RENDER_FLOAT32_CAPABLE', ()=>(0, $4rulI.isCapableOfRenderingToFloatTexture)($d1d95f6e470f42c2$var$ENV.getNumber('WEBGL_VERSION')));
/**
 * Whether rendering to float32 textures is enabled. If disabled, renders to
 * float16 textures.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_RENDER_FLOAT32_ENABLED', ()=>{
    return $d1d95f6e470f42c2$var$ENV.getBool('WEBGL_FORCE_F16_TEXTURES') ? false : $d1d95f6e470f42c2$var$ENV.getBool('WEBGL_RENDER_FLOAT32_CAPABLE');
});
/**
 * Whether downloading float textures is enabled (16 or 32 bit). If disabled,
 * uses IEEE 754 encoding of the float32 values to 4 uint8 when downloading.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_DOWNLOAD_FLOAT_ENABLED', ()=>(0, $4rulI.isDownloadFloatTextureEnabled)($d1d95f6e470f42c2$var$ENV.getNumber('WEBGL_VERSION')));
/** Whether the fence API is available. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_FENCE_API_ENABLED', ()=>(0, $4rulI.isWebGLFenceEnabled)($d1d95f6e470f42c2$var$ENV.getNumber('WEBGL_VERSION')));
/**
 * Tensors with size <= than this will be uploaded as uniforms, not textures.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_SIZE_UPLOAD_UNIFORM', ()=>{
    // Use uniform uploads only when 32bit floats are supported. In
    // 16bit
    // environments there are problems with comparing a 16bit texture value
    // with a 32bit uniform value.
    const useUniforms = $d1d95f6e470f42c2$var$ENV.getBool('WEBGL_RENDER_FLOAT32_ENABLED');
    return useUniforms ? 4 : 0;
});
/**
 * If the total number of bytes allocated on the GPU is greater than this
 * number, we will aggressively delete textures upon disposal with
 * gl.deleteMatrixTexture, rather than making them available for reuse.
 *
 * Default value -1 indicates that we will never aggressively delete textures.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_DELETE_TEXTURE_THRESHOLD', ()=>{
    return -1;
}, (threshold)=>{
    if (threshold < 0 && threshold !== -1) throw new Error(`WEBGL_DELETE_TEXTURE_THRESHOLD must be -1 (indicating never ` + `delete) or at least 0, but got ${threshold}.`);
});
/**
 * Trigger a manual GL command flush if the threshold of time has passed since
 * previous Kernel execution. This can be useful for Andorid device where GL
 * command flush are delayed un til the end of javascript task. This value is
 * measured in millisecond. Typically you want to set this value to close to 1.
 *
 * Default value 1 for mobile chrome, and -1 for rest cases. -1 indicates that
 * we will not enforce manual flush and depend on system default flush schedule.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_FLUSH_THRESHOLD', ()=>{
    return (0, $7L9WU).isMobile() ? 1 : -1;
}, (threshold)=>{
    if (threshold < 0 && threshold !== -1) throw new Error(`WEBGL_FLUSH_THRESHOLD must be -1 (indicating never ` + `manual flush) or at least 0, but got ${threshold}.`);
});
/**
 * Threshold for input tensor size that determines whether WebGL backend will
 * delegate computation to CPU.
 *
 * Default value is 128.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('CPU_HANDOFF_SIZE_THRESHOLD', ()=>128);
/** Whether we will use shapes uniforms. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_USE_SHAPES_UNIFORMS', ()=>false);
/**
 * Threshold for last dimension of input tensor that determines whether
 * WebGL backend for the Top K op will delegate computation to CPU. If input
 * is smaller than threshold then CPU will be used
 *
 * Default value is 100000.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD', ()=>100000);
/**
 * Threshold for K that determines whether
 * WebGL backend for the Top K op will delegate computation to CPU. If k
 * is larger than threshold then CPU will be used
 *
 * Default value is 128.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('TOPK_K_CPU_HANDOFF_THRESHOLD', ()=>128);
/** Whether we will use the experimental conv op. */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_EXP_CONV', ()=>false);
/**
 * If the device performance is low or if no hardware GPU is available, whether
 * software WebGL will be used.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('SOFTWARE_WEBGL_ENABLED', ()=>$d1d95f6e470f42c2$var$ENV.getBool('IS_TEST'));
/**
 * For narrow texture (physical height or physical width is 1), if the length of
 * any texture edges exceed the threshold, the texture will be reshaped to be
 * more squarish.
 *
 * This flag is used to help some GPUs that could not provide correct
 * interpolations for long skinny triangles. We found Mali GPU probably has this
 * problem: https://github.com/tensorflow/tfjs/issues/6775.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_MAX_SIZE_FOR_NARROW_TEXTURE', ()=>Infinity);
/**
 * If the flag is set to true, the max size of the narrow texture will be auto
 * computed and it will be considerred as a threshold to reshape the narrow
 * texture to be more squarish.
 *
 * This flag is used to help some GPUs that could not provide correct
 * interpolations for long skinny triangles. We found Mali GPU probably has this
 * problem: https://github.com/tensorflow/tfjs/issues/6775.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL_AUTO_SQUARIFY_NARROW_TEXTURE_SHAPE', ()=>false);
/**
 * Whether to use the customized isnan. It's only useful for webgl2 since webgl1
 * doesn't have the builtin isnan.
 */ $d1d95f6e470f42c2$var$ENV.registerFlag('WEBGL2_ISNAN_CUSTOM', ()=>false);

});
parcelRegister("4rulI", function(module, exports) {

$parcel$export(module.exports, "callAndCheck", () => $33c139c966088a4b$export$7642ac97981532b8);
$parcel$export(module.exports, "canBeRepresented", () => $33c139c966088a4b$export$829768a5b7625879);
$parcel$export(module.exports, "getExtensionOrThrow", () => $33c139c966088a4b$export$3a5e7a891790a26c);
$parcel$export(module.exports, "createVertexShader", () => $33c139c966088a4b$export$4ca6704ce1875929);
$parcel$export(module.exports, "createFragmentShader", () => $33c139c966088a4b$export$a8ab0e04b20572c0);
$parcel$export(module.exports, "logShaderSourceAndInfoLog", () => $33c139c966088a4b$export$f7b23987b58d218);
$parcel$export(module.exports, "createProgram", () => $33c139c966088a4b$export$327d24a04cd0dc17);
$parcel$export(module.exports, "linkProgram", () => $33c139c966088a4b$export$d879afae78b531a5);
$parcel$export(module.exports, "validateProgram", () => $33c139c966088a4b$export$e2dfaf93681cde16);
$parcel$export(module.exports, "createStaticVertexBuffer", () => $33c139c966088a4b$export$3871e1d1e28ac6cb);
$parcel$export(module.exports, "createStaticIndexBuffer", () => $33c139c966088a4b$export$f9b26b97ca2b25e9);
$parcel$export(module.exports, "createTexture", () => $33c139c966088a4b$export$37b981a8c575f415);
$parcel$export(module.exports, "validateTextureSize", () => $33c139c966088a4b$export$3543950a45505554);
$parcel$export(module.exports, "createFramebuffer", () => $33c139c966088a4b$export$366d1e3e32f5a700);
$parcel$export(module.exports, "bindVertexBufferToProgramAttribute", () => $33c139c966088a4b$export$4c858b3c953a013f);
$parcel$export(module.exports, "getProgramUniformLocationOrThrow", () => $33c139c966088a4b$export$748cafa2cdf50d8);
$parcel$export(module.exports, "getProgramUniformLocation", () => $33c139c966088a4b$export$d27256445dd7e8dd);
$parcel$export(module.exports, "bindTextureToProgramUniformSampler", () => $33c139c966088a4b$export$f9ffd997f3c8b98f);
$parcel$export(module.exports, "bindColorTextureToFramebuffer", () => $33c139c966088a4b$export$4e154f0d71f19013);
$parcel$export(module.exports, "unbindColorTextureFromFramebuffer", () => $33c139c966088a4b$export$d3c809959a3c24fa);
$parcel$export(module.exports, "validateFramebuffer", () => $33c139c966088a4b$export$ca09b577525e6519);
$parcel$export(module.exports, "getBatchDim", () => $33c139c966088a4b$export$4dfd7bc0667970e0);
$parcel$export(module.exports, "getRowsCols", () => $33c139c966088a4b$export$e8f6c350b57b8270);
$parcel$export(module.exports, "getShapeAs3D", () => $33c139c966088a4b$export$f944c0101b593a79);
$parcel$export(module.exports, "getTextureShapeFromLogicalShape", () => $33c139c966088a4b$export$80bf57c6927be1d9);
$parcel$export(module.exports, "isReshapeFree", () => $33c139c966088a4b$export$951b388203a0422d);
$parcel$export(module.exports, "getWebGLMaxTextureSize", () => $33c139c966088a4b$export$9dbf32263e41ec5);
$parcel$export(module.exports, "getMaxTexturesInShader", () => $33c139c966088a4b$export$ce91baf6aebded89);
$parcel$export(module.exports, "getWebGLDisjointQueryTimerVersion", () => $33c139c966088a4b$export$8a49d28f4bb7b8a0);
$parcel$export(module.exports, "hasExtension", () => $33c139c966088a4b$export$4f402f57c05c9ec3);
$parcel$export(module.exports, "isWebGLVersionEnabled", () => $33c139c966088a4b$export$9232c111e2230c00);
$parcel$export(module.exports, "isCapableOfRenderingToFloatTexture", () => $33c139c966088a4b$export$d571cb60e9b5ec74);
$parcel$export(module.exports, "isDownloadFloatTextureEnabled", () => $33c139c966088a4b$export$9cd61c8662dbbc66);
$parcel$export(module.exports, "isWebGLFenceEnabled", () => $33c139c966088a4b$export$77efcdc20b17e5f2);
$parcel$export(module.exports, "assertNotComplex", () => $33c139c966088a4b$export$1412c17b2531581a);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $wx9lK = parcelRequire("wx9lK");

var $jYI8Q = parcelRequire("jYI8Q");

var $lE6VE = parcelRequire("lE6VE");
function $33c139c966088a4b$export$7642ac97981532b8(gl, func) {
    const returnValue = func();
    if ((0, $aymVi.env)().getBool('DEBUG')) $33c139c966088a4b$var$checkWebGLError(gl);
    return returnValue;
}
function $33c139c966088a4b$var$checkWebGLError(gl) {
    const error = gl.getError();
    if (error !== gl.NO_ERROR) throw new Error('WebGL Error: ' + $33c139c966088a4b$export$ee3c7ff80964e13e(gl, error));
}
// https://en.wikipedia.org/wiki/Half-precision_floating-point_format
const $33c139c966088a4b$var$MIN_FLOAT16 = 5.96e-8;
const $33c139c966088a4b$var$MAX_FLOAT16 = 65504;
function $33c139c966088a4b$export$829768a5b7625879(num) {
    if ((0, $aymVi.env)().getBool('WEBGL_RENDER_FLOAT32_ENABLED') || num === 0 || $33c139c966088a4b$var$MIN_FLOAT16 < Math.abs(num) && Math.abs(num) < $33c139c966088a4b$var$MAX_FLOAT16) return true;
    return false;
}
function $33c139c966088a4b$export$ee3c7ff80964e13e(gl, status) {
    switch(status){
        case gl.NO_ERROR:
            return 'NO_ERROR';
        case gl.INVALID_ENUM:
            return 'INVALID_ENUM';
        case gl.INVALID_VALUE:
            return 'INVALID_VALUE';
        case gl.INVALID_OPERATION:
            return 'INVALID_OPERATION';
        case gl.INVALID_FRAMEBUFFER_OPERATION:
            return 'INVALID_FRAMEBUFFER_OPERATION';
        case gl.OUT_OF_MEMORY:
            return 'OUT_OF_MEMORY';
        case gl.CONTEXT_LOST_WEBGL:
            return 'CONTEXT_LOST_WEBGL';
        default:
            return `Unknown error code ${status}`;
    }
}
function $33c139c966088a4b$export$3a5e7a891790a26c(gl, extensionName) {
    return $33c139c966088a4b$var$throwIfNull(gl, ()=>gl.getExtension(extensionName), 'Extension "' + extensionName + '" not supported on this browser.');
}
function $33c139c966088a4b$export$4ca6704ce1875929(gl, vertexShaderSource) {
    const vertexShader = $33c139c966088a4b$var$throwIfNull(gl, ()=>gl.createShader(gl.VERTEX_SHADER), 'Unable to create vertex WebGLShader.');
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.shaderSource(vertexShader, vertexShaderSource));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.compileShader(vertexShader));
    if (gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS) === false) {
        console.log(gl.getShaderInfoLog(vertexShader));
        throw new Error('Failed to compile vertex shader.');
    }
    return vertexShader;
}
function $33c139c966088a4b$export$a8ab0e04b20572c0(gl, fragmentShaderSource) {
    const fragmentShader = $33c139c966088a4b$var$throwIfNull(gl, ()=>gl.createShader(gl.FRAGMENT_SHADER), 'Unable to create fragment WebGLShader.');
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.shaderSource(fragmentShader, fragmentShaderSource));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.compileShader(fragmentShader));
    if ((0, $aymVi.env)().get('ENGINE_COMPILE_ONLY')) return fragmentShader;
    if (gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS) === false) {
        $33c139c966088a4b$export$f7b23987b58d218(fragmentShaderSource, gl.getShaderInfoLog(fragmentShader));
        throw new Error('Failed to compile fragment shader.');
    }
    return fragmentShader;
}
const $33c139c966088a4b$var$lineNumberRegex = /ERROR: [0-9]+:([0-9]+):/g;
function $33c139c966088a4b$export$f7b23987b58d218(shaderSource, shaderInfoLog) {
    const lineNumberRegexResult = $33c139c966088a4b$var$lineNumberRegex.exec(shaderInfoLog);
    if (lineNumberRegexResult == null) {
        console.log(`Couldn't parse line number in error: ${shaderInfoLog}`);
        console.log(shaderSource);
        return;
    }
    const lineNumber = +lineNumberRegexResult[1];
    const shaderLines = shaderSource.split('\n');
    const pad = shaderLines.length.toString().length + 2;
    const linesWithLineNumbers = shaderLines.map((line, lineNumber)=>(0, $wx9lK).rightPad((lineNumber + 1).toString(), pad) + line);
    let maxLineLength = 0;
    for(let i = 0; i < linesWithLineNumbers.length; i++)maxLineLength = Math.max(linesWithLineNumbers[i].length, maxLineLength);
    const beforeErrorLines = linesWithLineNumbers.slice(0, lineNumber - 1);
    const errorLine = linesWithLineNumbers.slice(lineNumber - 1, lineNumber);
    const afterErrorLines = linesWithLineNumbers.slice(lineNumber);
    console.log(beforeErrorLines.join('\n'));
    console.log(shaderInfoLog.split('\n')[0]);
    console.log(`%c ${(0, $wx9lK).rightPad(errorLine[0], maxLineLength)}`, 'border:1px solid red; background-color:#e3d2d2; color:#a61717');
    console.log(afterErrorLines.join('\n'));
}
function $33c139c966088a4b$export$327d24a04cd0dc17(gl) {
    return $33c139c966088a4b$var$throwIfNull(gl, ()=>gl.createProgram(), 'Unable to create WebGLProgram.');
}
function $33c139c966088a4b$export$d879afae78b531a5(gl, program) {
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.linkProgram(program));
    if ((0, $aymVi.env)().get('ENGINE_COMPILE_ONLY')) return;
    if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
        console.log(gl.getProgramInfoLog(program));
        throw new Error('Failed to link vertex and fragment shaders.');
    }
}
function $33c139c966088a4b$export$e2dfaf93681cde16(gl, program) {
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.validateProgram(program));
    if (gl.getProgramParameter(program, gl.VALIDATE_STATUS) === false) {
        console.log(gl.getProgramInfoLog(program));
        throw new Error('Shader program validation failed.');
    }
}
function $33c139c966088a4b$export$3871e1d1e28ac6cb(gl, data) {
    const buffer = $33c139c966088a4b$var$throwIfNull(gl, ()=>gl.createBuffer(), 'Unable to create WebGLBuffer');
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, buffer));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW));
    return buffer;
}
function $33c139c966088a4b$export$f9b26b97ca2b25e9(gl, data) {
    const buffer = $33c139c966088a4b$var$throwIfNull(gl, ()=>gl.createBuffer(), 'Unable to create WebGLBuffer');
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffer));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, data, gl.STATIC_DRAW));
    return buffer;
}
function $33c139c966088a4b$export$45c2ce5fe87dcf0f() {
    if ((0, $aymVi.env)().getNumber('WEBGL_VERSION') === 2) return 1;
    return 4;
}
function $33c139c966088a4b$export$37b981a8c575f415(gl) {
    return $33c139c966088a4b$var$throwIfNull(gl, ()=>gl.createTexture(), 'Unable to create WebGLTexture.');
}
function $33c139c966088a4b$export$3543950a45505554(width, height) {
    const maxTextureSize = (0, $aymVi.env)().getNumber('WEBGL_MAX_TEXTURE_SIZE');
    if (width <= 0 || height <= 0) {
        const requested = `[${width}x${height}]`;
        throw new Error('Requested texture size ' + requested + ' is invalid.');
    }
    if (width > maxTextureSize || height > maxTextureSize) {
        const requested = `[${width}x${height}]`;
        const max = `[${maxTextureSize}x${maxTextureSize}]`;
        throw new Error('Requested texture size ' + requested + ' greater than WebGL maximum on this browser / GPU ' + max + '.');
    }
}
function $33c139c966088a4b$export$366d1e3e32f5a700(gl) {
    return $33c139c966088a4b$var$throwIfNull(gl, ()=>gl.createFramebuffer(), 'Unable to create WebGLFramebuffer.');
}
function $33c139c966088a4b$export$4c858b3c953a013f(gl, program, attribute, buffer, arrayEntriesPerItem, itemStrideInBytes, itemOffsetInBytes) {
    const loc = gl.getAttribLocation(program, attribute);
    if (loc === -1) // The GPU compiler decided to strip out this attribute because it's unused,
    // thus no need to bind.
    return false;
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, buffer));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.vertexAttribPointer(loc, arrayEntriesPerItem, gl.FLOAT, false, itemStrideInBytes, itemOffsetInBytes));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.enableVertexAttribArray(loc));
    return true;
}
function $33c139c966088a4b$export$520907fe7b2c7a2d(gl, texture, textureUnit) {
    $33c139c966088a4b$var$validateTextureUnit(gl, textureUnit);
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.activeTexture(gl.TEXTURE0 + textureUnit));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, texture));
}
function $33c139c966088a4b$export$9bed01c46f4769b6(gl, textureUnit) {
    $33c139c966088a4b$var$validateTextureUnit(gl, textureUnit);
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.activeTexture(gl.TEXTURE0 + textureUnit));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
}
function $33c139c966088a4b$export$748cafa2cdf50d8(gl, program, uniformName) {
    return $33c139c966088a4b$var$throwIfNull(gl, ()=>gl.getUniformLocation(program, uniformName), 'uniform "' + uniformName + '" not present in program.');
}
function $33c139c966088a4b$export$d27256445dd7e8dd(gl, program, uniformName) {
    return gl.getUniformLocation(program, uniformName);
}
function $33c139c966088a4b$export$f9ffd997f3c8b98f(gl, texture, uniformSamplerLocation, textureUnit) {
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>$33c139c966088a4b$export$520907fe7b2c7a2d(gl, texture, textureUnit));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.uniform1i(uniformSamplerLocation, textureUnit));
}
function $33c139c966088a4b$export$2e43f6b5d575e241(gl) {
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, null));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.viewport(0, 0, gl.canvas.width, gl.canvas.height));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.scissor(0, 0, gl.canvas.width, gl.canvas.height));
}
function $33c139c966088a4b$export$4e154f0d71f19013(gl, texture, framebuffer) {
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0));
}
function $33c139c966088a4b$export$d3c809959a3c24fa(gl, framebuffer) {
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer));
    $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, null, 0));
}
function $33c139c966088a4b$export$ca09b577525e6519(gl) {
    const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
    if (status !== gl.FRAMEBUFFER_COMPLETE) throw new Error('Error binding framebuffer: ' + $33c139c966088a4b$export$851c7fde035f5bf6(gl, status));
}
function $33c139c966088a4b$export$851c7fde035f5bf6(gl, status) {
    switch(status){
        case gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
            return 'FRAMEBUFFER_INCOMPLETE_ATTACHMENT';
        case gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
            return 'FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT';
        case gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
            return 'FRAMEBUFFER_INCOMPLETE_DIMENSIONS';
        case gl.FRAMEBUFFER_UNSUPPORTED:
            return 'FRAMEBUFFER_UNSUPPORTED';
        default:
            return `unknown error ${status}`;
    }
}
function $33c139c966088a4b$var$throwIfNull(gl, returnTOrNull, failureMessage) {
    const tOrNull = $33c139c966088a4b$export$7642ac97981532b8(gl, ()=>returnTOrNull());
    if (tOrNull == null) throw new Error(failureMessage);
    return tOrNull;
}
function $33c139c966088a4b$var$validateTextureUnit(gl, textureUnit) {
    const maxTextureUnit = gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS - 1;
    const glTextureUnit = textureUnit + gl.TEXTURE0;
    if (glTextureUnit < gl.TEXTURE0 || glTextureUnit > maxTextureUnit) {
        const textureUnitRange = `[gl.TEXTURE0, gl.TEXTURE${maxTextureUnit}]`;
        throw new Error(`textureUnit must be in ${textureUnitRange}.`);
    }
}
function $33c139c966088a4b$export$4dfd7bc0667970e0(shape, dimsToSkip = 2) {
    return (0, $wx9lK).sizeFromShape(shape.slice(0, shape.length - dimsToSkip));
}
function $33c139c966088a4b$export$e8f6c350b57b8270(shape) {
    if (shape.length === 0) throw Error('Cannot get rows and columns of an empty shape array.');
    return [
        shape.length > 1 ? shape[shape.length - 2] : 1,
        shape[shape.length - 1]
    ];
}
function $33c139c966088a4b$export$f944c0101b593a79(shape) {
    let shapeAs3D = [
        1,
        1,
        1
    ];
    const isScalar = shape.length === 0 || shape.length === 1 && shape[0] === 1;
    if (!isScalar) shapeAs3D = [
        $33c139c966088a4b$export$4dfd7bc0667970e0(shape),
        ...$33c139c966088a4b$export$e8f6c350b57b8270(shape)
    ];
    return shapeAs3D;
}
function $33c139c966088a4b$export$80bf57c6927be1d9(logShape, isPacked = false) {
    let maxTexSize = (0, $aymVi.env)().getNumber('WEBGL_MAX_TEXTURE_SIZE');
    let maxSizeForNarrowTex = (0, $aymVi.env)().getNumber('WEBGL_MAX_SIZE_FOR_NARROW_TEXTURE');
    if (maxSizeForNarrowTex === Infinity && (0, $aymVi.env)().getBool('WEBGL_AUTO_SQUARIFY_NARROW_TEXTURE_SHAPE')) maxSizeForNarrowTex = maxTexSize / 2;
    if (isPacked) {
        maxTexSize = maxTexSize * 2;
        maxSizeForNarrowTex = maxSizeForNarrowTex * 2;
        // This logic ensures we accurately count the number of packed texels needed
        // to accommodate the tensor. We can only pack values in the same texel if
        // they are from adjacent pairs of rows/cols within the same batch. So if a
        // tensor has 3 rows, we pretend it has 4 rows in order to account for the
        // fact that the texels containing the third row are half empty.
        logShape = logShape.map((d, i)=>i >= logShape.length - 2 ? (0, $wx9lK).nearestLargerEven(logShape[i]) : logShape[i]);
        // Packed texture height is at least 2 (the channel height of a single
        // texel).
        if (logShape.length === 1) logShape = [
            2,
            logShape[0]
        ];
    }
    // If logical shape is 2, we don't squeeze, since we want to match physical.
    if (logShape.length !== 2) {
        const squeezeResult = (0, $wx9lK).squeezeShape(logShape);
        logShape = squeezeResult.newShape;
    }
    let size = (0, $wx9lK).sizeFromShape(logShape);
    let textureShape = null;
    if (logShape.length <= 1 && size <= maxTexSize) textureShape = [
        1,
        size
    ];
    else if (logShape.length === 2 && logShape[0] <= maxTexSize && logShape[1] <= maxTexSize) textureShape = logShape;
    else if (logShape.length === 3 && logShape[0] * logShape[1] <= maxTexSize && logShape[2] <= maxTexSize) textureShape = [
        logShape[0] * logShape[1],
        logShape[2]
    ];
    else if (logShape.length === 3 && logShape[0] <= maxTexSize && logShape[1] * logShape[2] <= maxTexSize) textureShape = [
        logShape[0],
        logShape[1] * logShape[2]
    ];
    else if (logShape.length === 4 && logShape[0] * logShape[1] * logShape[2] <= maxTexSize && logShape[3] <= maxTexSize) textureShape = [
        logShape[0] * logShape[1] * logShape[2],
        logShape[3]
    ];
    else if (logShape.length === 4 && logShape[0] <= maxTexSize && logShape[1] * logShape[2] * logShape[3] <= maxTexSize) textureShape = [
        logShape[0],
        logShape[1] * logShape[2] * logShape[3]
    ];
    // true if one edge length is 1 (1 or 2, if packed), while another edge
    // length exceeds maxSizeForNarrowTex.
    const isLongNarrowTex = textureShape != null && Math.max(...textureShape) > maxSizeForNarrowTex && Math.min(...textureShape) <= (isPacked ? 2 : 1) && Math.min(...textureShape) > 0;
    if (textureShape == null || isLongNarrowTex) {
        if (isPacked) {
            // For packed textures size equals the number of channels required to
            // accommodate the texture data. However in order to squarify such that
            // inner dimensions stay even, we rewrite size to equal the number of
            // texels. Then in the return statement we rehydrate the squarified
            // dimensions to channel units.
            const batchDim = $33c139c966088a4b$export$4dfd7bc0667970e0(logShape);
            let rows = 2, cols = 2;
            if (logShape.length) [rows, cols] = $33c139c966088a4b$export$e8f6c350b57b8270(logShape);
            size = batchDim * (rows / 2) * (cols / 2);
            textureShape = (0, $wx9lK).sizeToSquarishShape(size).map((d)=>d * 2);
        } else textureShape = (0, $wx9lK).sizeToSquarishShape(size);
    }
    return textureShape;
}
function $33c139c966088a4b$var$isEven(n) {
    return n % 2 === 0;
}
function $33c139c966088a4b$export$951b388203a0422d(shape1, shape2) {
    shape1 = shape1.slice(-2);
    shape2 = shape2.slice(-2);
    if ((0, $wx9lK).arraysEqual(shape1, shape2)) return true;
    if (!shape1.length || !shape2.length) return true;
    if (shape1[0] === 0 || shape1[1] === 0 || shape2[0] === 0 || shape2[1] === 0) return true;
    if (shape1.length !== shape2.length) {
        const shape1Cols = shape1.slice(-1)[0];
        const shape2Cols = shape2.slice(-1)[0];
        if (shape1Cols === shape2Cols) return true;
        if ($33c139c966088a4b$var$isEven(shape1Cols) && $33c139c966088a4b$var$isEven(shape2Cols) && (shape1[0] === 1 || shape2[0] === 1)) return true;
    }
    return shape1[1] === shape2[1] && $33c139c966088a4b$var$isEven(shape1[0]) && $33c139c966088a4b$var$isEven(shape2[0]);
}
// We cache webgl params because the environment gets reset between
// unit tests and we don't want to constantly query the WebGLContext for
// MAX_TEXTURE_SIZE.
let $33c139c966088a4b$var$MAX_TEXTURE_SIZE;
let $33c139c966088a4b$var$MAX_TEXTURES_IN_SHADER;
function $33c139c966088a4b$export$9dbf32263e41ec5(webGLVersion) {
    if ($33c139c966088a4b$var$MAX_TEXTURE_SIZE == null) {
        const gl = (0, $jYI8Q.getWebGLContext)(webGLVersion);
        $33c139c966088a4b$var$MAX_TEXTURE_SIZE = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    }
    return $33c139c966088a4b$var$MAX_TEXTURE_SIZE;
}
function $33c139c966088a4b$export$3bb3363a1d77ce11() {
    $33c139c966088a4b$var$MAX_TEXTURE_SIZE = null;
}
function $33c139c966088a4b$export$295b7d11bb89e671() {
    $33c139c966088a4b$var$MAX_TEXTURES_IN_SHADER = null;
}
function $33c139c966088a4b$export$ce91baf6aebded89(webGLVersion) {
    if ($33c139c966088a4b$var$MAX_TEXTURES_IN_SHADER == null) {
        const gl = (0, $jYI8Q.getWebGLContext)(webGLVersion);
        $33c139c966088a4b$var$MAX_TEXTURES_IN_SHADER = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    }
    // We cap at 16 to avoid spurious runtime "memory exhausted" error.
    return Math.min(16, $33c139c966088a4b$var$MAX_TEXTURES_IN_SHADER);
}
function $33c139c966088a4b$export$8a49d28f4bb7b8a0(webGLVersion) {
    if (webGLVersion === 0) return 0;
    let queryTimerVersion;
    const gl = (0, $jYI8Q.getWebGLContext)(webGLVersion);
    if ($33c139c966088a4b$export$4f402f57c05c9ec3(gl, 'EXT_disjoint_timer_query_webgl2') && webGLVersion === 2) queryTimerVersion = 2;
    else if ($33c139c966088a4b$export$4f402f57c05c9ec3(gl, 'EXT_disjoint_timer_query')) queryTimerVersion = 1;
    else queryTimerVersion = 0;
    return queryTimerVersion;
}
function $33c139c966088a4b$export$4f402f57c05c9ec3(gl, extensionName) {
    const ext = gl.getExtension(extensionName);
    return ext != null;
}
function $33c139c966088a4b$export$9232c111e2230c00(webGLVersion) {
    try {
        const gl = (0, $jYI8Q.getWebGLContext)(webGLVersion);
        if (gl != null) return true;
    } catch (e) {
        console.log('Error when getting WebGL context: ', e);
        return false;
    }
    return false;
}
function $33c139c966088a4b$export$d571cb60e9b5ec74(webGLVersion) {
    if (webGLVersion === 0) return false;
    const gl = (0, $jYI8Q.getWebGLContext)(webGLVersion);
    if (webGLVersion === 1) {
        if (!$33c139c966088a4b$export$4f402f57c05c9ec3(gl, 'OES_texture_float')) return false;
    } else {
        if (!$33c139c966088a4b$export$4f402f57c05c9ec3(gl, 'EXT_color_buffer_float')) return false;
    }
    const isFrameBufferComplete = $33c139c966088a4b$var$createFloatTextureAndBindToFramebuffer(gl);
    return isFrameBufferComplete;
}
function $33c139c966088a4b$export$9cd61c8662dbbc66(webGLVersion) {
    if (webGLVersion === 0) return false;
    const gl = (0, $jYI8Q.getWebGLContext)(webGLVersion);
    if (webGLVersion === 1) {
        if (!$33c139c966088a4b$export$4f402f57c05c9ec3(gl, 'OES_texture_float')) return false;
        if (!$33c139c966088a4b$export$4f402f57c05c9ec3(gl, 'WEBGL_color_buffer_float')) return false;
    } else {
        if ($33c139c966088a4b$export$4f402f57c05c9ec3(gl, 'EXT_color_buffer_float')) return $33c139c966088a4b$var$createFloatTextureAndBindToFramebuffer(gl);
        const COLOR_BUFFER_HALF_FLOAT = 'EXT_color_buffer_half_float';
        if ($33c139c966088a4b$export$4f402f57c05c9ec3(gl, COLOR_BUFFER_HALF_FLOAT)) {
            const textureHalfFloatExtension = gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
            return $33c139c966088a4b$var$createHalfFloatTextureAndBindToFramebuffer(gl, textureHalfFloatExtension);
        }
        return false;
    }
    const isFrameBufferComplete = $33c139c966088a4b$var$createFloatTextureAndBindToFramebuffer(gl);
    return isFrameBufferComplete;
}
function $33c139c966088a4b$var$createFloatTextureAndBindToFramebuffer(gl) {
    const texConfig = (0, $lE6VE.getTextureConfig)(gl);
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    const width = 1;
    const height = 1;
    gl.texImage2D(gl.TEXTURE_2D, 0, texConfig.internalFormatFloat, width, height, 0, texConfig.textureFormatFloat, texConfig.textureTypeFloat, null);
    const frameBuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
    const isFrameBufferComplete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.deleteTexture(texture);
    gl.deleteFramebuffer(frameBuffer);
    return isFrameBufferComplete;
}
function $33c139c966088a4b$var$createHalfFloatTextureAndBindToFramebuffer(// tslint:disable-next-line:no-any
gl, textureHalfFloatExtension) {
    const texConfig = (0, $lE6VE.getTextureConfig)(gl, textureHalfFloatExtension);
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    const width = 1;
    const height = 1;
    gl.texImage2D(gl.TEXTURE_2D, 0, texConfig.internalFormatHalfFloat, width, height, 0, texConfig.textureFormatFloat, texConfig.textureTypeHalfFloat, null);
    const frameBuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
    const isFrameBufferComplete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.deleteTexture(texture);
    gl.deleteFramebuffer(frameBuffer);
    return isFrameBufferComplete;
}
function $33c139c966088a4b$export$77efcdc20b17e5f2(webGLVersion) {
    if (webGLVersion !== 2) return false;
    const gl = (0, $jYI8Q.getWebGLContext)(webGLVersion);
    // tslint:disable-next-line:no-any
    const isEnabled = gl.fenceSync != null;
    return isEnabled;
}
function $33c139c966088a4b$export$1412c17b2531581a(tensor, opName) {
    if (!Array.isArray(tensor)) tensor = [
        tensor
    ];
    tensor.forEach((t)=>{
        if (t != null) (0, $wx9lK).assert(t.dtype !== 'complex64', ()=>`${opName} does not support complex64 tensors ` + 'in the WebGL backend.');
    });
}

});
parcelRegister("jYI8Q", function(module, exports) {

$parcel$export(module.exports, "setWebGLContext", () => $e8b5dc89f4486009$export$4b8d5e1525955c68);
$parcel$export(module.exports, "getWebGLContext", () => $e8b5dc89f4486009$export$c7a808a518b9a146);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
const $e8b5dc89f4486009$var$contexts = {};
const $e8b5dc89f4486009$var$WEBGL_ATTRIBUTES = {
    alpha: false,
    antialias: false,
    premultipliedAlpha: false,
    preserveDrawingBuffer: false,
    depth: false,
    stencil: false,
    failIfMajorPerformanceCaveat: true
};
function $e8b5dc89f4486009$export$c5302deff3a07920(webGLVersion) {
    delete $e8b5dc89f4486009$var$contexts[webGLVersion];
}
function $e8b5dc89f4486009$export$4b8d5e1525955c68(webGLVersion, gl) {
    $e8b5dc89f4486009$var$contexts[webGLVersion] = gl;
}
function $e8b5dc89f4486009$export$c7a808a518b9a146(webGLVersion, customCanvas) {
    if (!(webGLVersion in $e8b5dc89f4486009$var$contexts) || customCanvas != null) {
        const newCtx = $e8b5dc89f4486009$var$getWebGLRenderingContext(webGLVersion, customCanvas);
        if (newCtx !== null) $e8b5dc89f4486009$var$contexts[webGLVersion] = newCtx;
        else {
            console.log('Could not get context for WebGL version', webGLVersion);
            return null;
        }
    }
    const gl = $e8b5dc89f4486009$var$contexts[webGLVersion];
    if (gl == null || gl.isContextLost()) {
        delete $e8b5dc89f4486009$var$contexts[webGLVersion];
        return $e8b5dc89f4486009$export$c7a808a518b9a146(webGLVersion);
    }
    gl.disable(gl.DEPTH_TEST);
    gl.disable(gl.STENCIL_TEST);
    gl.disable(gl.BLEND);
    gl.disable(gl.DITHER);
    gl.disable(gl.POLYGON_OFFSET_FILL);
    gl.disable(gl.SAMPLE_COVERAGE);
    gl.enable(gl.SCISSOR_TEST);
    gl.enable(gl.CULL_FACE);
    gl.cullFace(gl.BACK);
    return $e8b5dc89f4486009$var$contexts[webGLVersion];
}
function $e8b5dc89f4486009$var$createCanvas(webGLVersion) {
    if (typeof OffscreenCanvas !== 'undefined' && webGLVersion === 2) return new OffscreenCanvas(300, 150);
    else if (typeof document !== 'undefined') return document.createElement('canvas');
    else throw new Error('Cannot create a canvas in this context');
}
function $e8b5dc89f4486009$var$getWebGLRenderingContext(webGLVersion, customCanvas) {
    if (webGLVersion !== 1 && webGLVersion !== 2) throw new Error('Cannot get WebGL rendering context, WebGL is disabled.');
    const canvas = customCanvas == null ? $e8b5dc89f4486009$var$createCanvas(webGLVersion) : customCanvas;
    canvas.addEventListener('webglcontextlost', (ev)=>{
        ev.preventDefault();
        delete $e8b5dc89f4486009$var$contexts[webGLVersion];
    }, false);
    if ((0, $aymVi.env)().getBool('SOFTWARE_WEBGL_ENABLED')) $e8b5dc89f4486009$var$WEBGL_ATTRIBUTES.failIfMajorPerformanceCaveat = false;
    if (webGLVersion === 1) return canvas.getContext('webgl', $e8b5dc89f4486009$var$WEBGL_ATTRIBUTES) || canvas.getContext('experimental-webgl', $e8b5dc89f4486009$var$WEBGL_ATTRIBUTES);
    return canvas.getContext('webgl2', $e8b5dc89f4486009$var$WEBGL_ATTRIBUTES);
}

});

parcelRegister("lE6VE", function(module, exports) {

$parcel$export(module.exports, "PackingScheme", () => $fc22b54f03f7fd1d$export$81d5c79efa1086f2);
$parcel$export(module.exports, "TextureUsage", () => $fc22b54f03f7fd1d$export$6bf4bd1b6beb0bfd);
$parcel$export(module.exports, "PhysicalTextureType", () => $fc22b54f03f7fd1d$export$bde70ab3692e385c);
$parcel$export(module.exports, "getUnpackedMatrixTextureShapeWidthHeight", () => $fc22b54f03f7fd1d$export$95fb8493b25f77a4);
$parcel$export(module.exports, "getUnpackedArraySizeFromMatrixSize", () => $fc22b54f03f7fd1d$export$9427543edb6e188a);
$parcel$export(module.exports, "getDenseTexShape", () => $fc22b54f03f7fd1d$export$2cc7cc972aa2533d);
$parcel$export(module.exports, "getPackedMatrixTextureShapeWidthHeight", () => $fc22b54f03f7fd1d$export$2754e02fa98f5582);
$parcel$export(module.exports, "getPackedRGBAArraySizeFromMatrixShape", () => $fc22b54f03f7fd1d$export$12d4e412f879b1d4);
$parcel$export(module.exports, "getTextureConfig", () => $fc22b54f03f7fd1d$export$129d92ae6e74c416);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $wx9lK = parcelRequire("wx9lK");
var $fc22b54f03f7fd1d$export$81d5c79efa1086f2;
(function(PackingScheme) {
    /**
     * All values in a single texel are densely packed without any constraints.
     *
     * This is how the shader encodes a tensor with shape = [2, 3, 4]
     * (indices are [batch, row, col]).
     *
     * 000|001   010|011   020|021
     * -------   -------   -------
     * 002|003   012|013   022|023
     *
     * 100|101   110|111   120|121
     * -------   -------   -------
     * 102|103   112|113   122|123
     *
     */ PackingScheme[PackingScheme["DENSE"] = 0] = "DENSE";
    /**
     * Single texels contain only values from the same batch, and from adjacent
     * rows and columns.
     *
     * This is how the shader encodes a tensor with shape = [2, 3, 5]
     * (indices are [batch, row, col]).
     *
     * 000|001   002|003   004|xxx   020|021   022|023   024|xxx
     * -------   -------   -------   -------   -------   -------
     * 010|011   012|013   014|xxx   xxx|xxx   xxx|xxx   xxx|xxx
     *
     * 100|101   102|103   104|xxx   120|121   122|123   124|xxx
     * -------   -------   -------   -------   -------   -------
     * 110|111   112|113   114|xxx   xxx|xxx   xxx|xxx   xxx|xxx
     *
     */ PackingScheme[PackingScheme["SHARED_BATCH"] = 1] = "SHARED_BATCH";
})($fc22b54f03f7fd1d$export$81d5c79efa1086f2 || ($fc22b54f03f7fd1d$export$81d5c79efa1086f2 = {}));
var $fc22b54f03f7fd1d$export$6bf4bd1b6beb0bfd;
(function(TextureUsage) {
    TextureUsage[TextureUsage["RENDER"] = 0] = "RENDER";
    TextureUsage[TextureUsage["UPLOAD"] = 1] = "UPLOAD";
    TextureUsage[TextureUsage["PIXELS"] = 2] = "PIXELS";
    TextureUsage[TextureUsage["DOWNLOAD"] = 3] = "DOWNLOAD";
})($fc22b54f03f7fd1d$export$6bf4bd1b6beb0bfd || ($fc22b54f03f7fd1d$export$6bf4bd1b6beb0bfd = {}));
var $fc22b54f03f7fd1d$export$bde70ab3692e385c;
(function(PhysicalTextureType) {
    PhysicalTextureType[PhysicalTextureType["UNPACKED_FLOAT16"] = 0] = "UNPACKED_FLOAT16";
    PhysicalTextureType[PhysicalTextureType["UNPACKED_FLOAT32"] = 1] = "UNPACKED_FLOAT32";
    PhysicalTextureType[PhysicalTextureType["PACKED_4X1_UNSIGNED_BYTE"] = 2] = "PACKED_4X1_UNSIGNED_BYTE";
    PhysicalTextureType[PhysicalTextureType["PACKED_2X2_FLOAT32"] = 3] = "PACKED_2X2_FLOAT32";
    PhysicalTextureType[PhysicalTextureType["PACKED_2X2_FLOAT16"] = 4] = "PACKED_2X2_FLOAT16";
})($fc22b54f03f7fd1d$export$bde70ab3692e385c || ($fc22b54f03f7fd1d$export$bde70ab3692e385c = {}));
function $fc22b54f03f7fd1d$export$95fb8493b25f77a4(rows, columns) {
    return [
        columns,
        rows
    ];
}
function $fc22b54f03f7fd1d$export$9427543edb6e188a(matrixSize, channelsPerTexture) {
    return matrixSize * channelsPerTexture;
}
function $fc22b54f03f7fd1d$export$bb1043669f490840(rows, columns) {
    return [
        columns * 4,
        rows
    ];
}
function $fc22b54f03f7fd1d$export$2cc7cc972aa2533d(shape) {
    const size = (0, $wx9lK).sizeFromShape(shape);
    const texelsNeeded = Math.ceil(size / 4);
    return (0, $wx9lK).sizeToSquarishShape(texelsNeeded);
}
function $fc22b54f03f7fd1d$export$4c2d3be5c837367c(unpackedSize, channelsPerTexture) {
    if (unpackedSize % channelsPerTexture !== 0) throw new Error(`unpackedSize (${unpackedSize}) must be a multiple of ` + `${channelsPerTexture}`);
    return unpackedSize / channelsPerTexture;
}
function $fc22b54f03f7fd1d$export$ccf59730cad262bd(unpackedArray, matrix, channels) {
    const requiredSize = unpackedArray.length * channels / 4;
    if (matrix.length < requiredSize) throw new Error(`matrix length (${matrix.length}) must be >= ${requiredSize}`);
    let dst = 0;
    for(let src = 0; src < unpackedArray.length; src += 4)for(let c = 0; c < channels; c++)matrix[dst++] = unpackedArray[src + c];
}
function $fc22b54f03f7fd1d$export$2754e02fa98f5582(rows, columns) {
    return [
        Math.max(1, Math.ceil(columns / 2)),
        Math.max(1, Math.ceil(rows / 2))
    ];
}
function $fc22b54f03f7fd1d$export$12d4e412f879b1d4(rows, columns) {
    const [w, h] = $fc22b54f03f7fd1d$export$2754e02fa98f5582(rows, columns);
    return w * h * 4;
}
function $fc22b54f03f7fd1d$export$129d92ae6e74c416(// tslint:disable-next-line:no-any
gl, textureHalfFloatExtension) {
    // tslint:disable-next-line:no-any
    const glany = gl;
    let internalFormatFloat;
    let internalFormatHalfFloat;
    let internalFormatPackedHalfFloat;
    let internalFormatPackedFloat;
    let textureFormatFloat;
    let downloadTextureFormat;
    let downloadUnpackNumChannels;
    let defaultNumChannels;
    let textureTypeHalfFloat;
    let textureTypeFloat;
    if ((0, $aymVi.env)().getNumber('WEBGL_VERSION') === 2) {
        internalFormatFloat = glany.R32F;
        internalFormatHalfFloat = glany.R16F;
        internalFormatPackedHalfFloat = glany.RGBA16F;
        internalFormatPackedFloat = glany.RGBA32F;
        textureFormatFloat = glany.RED;
        downloadUnpackNumChannels = 4;
        defaultNumChannels = 1;
        textureTypeHalfFloat = glany.HALF_FLOAT;
        textureTypeFloat = glany.FLOAT;
        downloadTextureFormat = glany.RGBA8;
    } else {
        internalFormatFloat = gl.RGBA;
        internalFormatHalfFloat = gl.RGBA;
        internalFormatPackedHalfFloat = gl.RGBA;
        internalFormatPackedFloat = glany.RGBA;
        textureFormatFloat = gl.RGBA;
        downloadUnpackNumChannels = 4;
        defaultNumChannels = 4;
        textureTypeHalfFloat = textureHalfFloatExtension != null ? textureHalfFloatExtension.HALF_FLOAT_OES : null;
        textureTypeFloat = gl.FLOAT;
        downloadTextureFormat = gl.RGBA;
    }
    return {
        internalFormatFloat: internalFormatFloat,
        internalFormatHalfFloat: internalFormatHalfFloat,
        internalFormatPackedHalfFloat: internalFormatPackedHalfFloat,
        internalFormatPackedFloat: internalFormatPackedFloat,
        textureFormatFloat: textureFormatFloat,
        downloadTextureFormat: downloadTextureFormat,
        downloadUnpackNumChannels: downloadUnpackNumChannels,
        defaultNumChannels: defaultNumChannels,
        textureTypeHalfFloat: textureTypeHalfFloat,
        textureTypeFloat: textureTypeFloat
    };
}

});



parcelRegister("akZ7H", function(module, exports) {

$parcel$export(module.exports, "DecodeMatrixProgram", () => $786b2f6a7f724736$export$f6ee51c6efbee026);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $f7Ffe = parcelRequire("f7Ffe");

var $i88bA = parcelRequire("i88bA");

var $asYVE = parcelRequire("asYVE");

var $lE6VE = parcelRequire("lE6VE");
class $786b2f6a7f724736$export$f6ee51c6efbee026 {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        this.outPackingScheme = (0, $lE6VE.PackingScheme).DENSE;
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $f7Ffe.getGlslDifferences)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        this.userCode = `
      ivec3 outCoordsFromFlatIndex(int index) {
        ${this.enableShapeUniforms ? $asYVE.getOutputLogicalCoordinatesFromFlatIndexByUniform([
            'r',
            'c',
            'd'
        ], outputShape) : $asYVE.getLogicalCoordinatesFromFlatIndex([
            'r',
            'c',
            'd'
        ], outputShape)}
        return ivec3(r, c, d);
      }

      void main() {
        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));
        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);

        vec4 result = vec4(0.);

        for (int i=0; i<4; i++) {
          int flatIndex = index + i;
          ivec3 rc = outCoordsFromFlatIndex(flatIndex);
          result[i] = getA(rc.x, rc.y, rc.z);
        }

        ${glsl.output} = result;
      }
    `;
    }
}

});
parcelRegister("f7Ffe", function(module, exports) {

$parcel$export(module.exports, "getGlslDifferences", () => $b02780ce799b5cce$export$3ebf4a18d6319f7a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
function $b02780ce799b5cce$export$3ebf4a18d6319f7a() {
    let version;
    let attribute;
    let varyingVs;
    let varyingFs;
    let texture2D;
    let output;
    let defineOutput;
    let defineSpecialNaN;
    let defineSpecialInf;
    let defineRound;
    if ((0, $aymVi.env)().getNumber('WEBGL_VERSION') === 2) {
        version = '#version 300 es';
        attribute = 'in';
        varyingVs = 'out';
        varyingFs = 'in';
        texture2D = 'texture';
        output = 'outputColor';
        defineOutput = 'out vec4 outputColor;';
        // Use custom isnan definition to work across differences between
        // implementations on various platforms. While this should happen in ANGLE
        // we still see differences between android and windows (on chrome) when
        // using isnan directly. Since WebGL2 supports uint type and
        // floatBitsToUinT built-in function, we could implment isnan following
        // IEEE 754 rules.
        // NaN defination in IEEE 754-1985 is :
        //   - sign = either 0 or 1.
        //   - biased exponent = all 1 bits.
        //   - fraction = anything except all 0 bits (since all 0 bits represents
        //   infinity).
        // https://en.wikipedia.org/wiki/IEEE_754-1985#Representation_of_non-numbers
        defineSpecialNaN = (0, $aymVi.env)().getBool('WEBGL2_ISNAN_CUSTOM') ? `
      bool isnan_custom(float val) {
        uint floatToUint = floatBitsToUint(val);
        return (floatToUint & 0x7fffffffu) > 0x7f800000u;
      }

      bvec4 isnan_custom(vec4 val) {
        return bvec4(isnan_custom(val.x),
          isnan_custom(val.y), isnan_custom(val.z), isnan_custom(val.w));
      }

      #define isnan(value) isnan_custom(value)
    ` : '';
        // In webgl 2 we do not need to specify a custom isinf so there is no
        // need for a special INFINITY constant.
        defineSpecialInf = ``;
        defineRound = `
      #define round(value) newRound(value)
      int newRound(float value) {
        return int(floor(value + 0.5));
      }

      ivec4 newRound(vec4 value) {
        return ivec4(floor(value + vec4(0.5)));
      }
    `;
    } else {
        version = '';
        attribute = 'attribute';
        varyingVs = 'varying';
        varyingFs = 'varying';
        texture2D = 'texture2D';
        output = 'gl_FragColor';
        defineOutput = '';
        // WebGL1 has no built in isnan so we define one here.
        defineSpecialNaN = `
      #define isnan(value) isnan_custom(value)
      bool isnan_custom(float val) {
        return (val > 0. || val < 1. || val == 0.) ? false : true;
      }
      bvec4 isnan_custom(vec4 val) {
        return bvec4(isnan(val.x), isnan(val.y), isnan(val.z), isnan(val.w));
      }
    `;
        defineSpecialInf = `
      uniform float INFINITY;

      bool isinf(float val) {
        return abs(val) == INFINITY;
      }
      bvec4 isinf(vec4 val) {
        return equal(abs(val), vec4(INFINITY));
      }
    `;
        defineRound = `
      int round(float value) {
        return int(floor(value + 0.5));
      }

      ivec4 round(vec4 value) {
        return ivec4(floor(value + vec4(0.5)));
      }
    `;
    }
    return {
        version: version,
        attribute: attribute,
        varyingVs: varyingVs,
        varyingFs: varyingFs,
        texture2D: texture2D,
        output: output,
        defineOutput: defineOutput,
        defineSpecialNaN: defineSpecialNaN,
        defineSpecialInf: defineSpecialInf,
        defineRound: defineRound
    };
}

});

parcelRegister("i88bA", function(module, exports) {

$parcel$export(module.exports, "compileProgram", () => $0367fd3530e22eb2$export$5ca2cb6073dd12df);
$parcel$export(module.exports, "getUniformLocations", () => $0367fd3530e22eb2$export$d421ceceafba9cc0);
$parcel$export(module.exports, "runProgram", () => $0367fd3530e22eb2$export$4e01d2c5eea12ae3);
$parcel$export(module.exports, "makeShaderKey", () => $0367fd3530e22eb2$export$2a17a6d53fe6f5d9);
$parcel$export(module.exports, "useShapeUniforms", () => $0367fd3530e22eb2$export$5acc770fc06a0138);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $aymVi = parcelRequire("aymVi");
var $wx9lK = parcelRequire("wx9lK");

var $7svrP = parcelRequire("7svrP");

var $4rulI = parcelRequire("4rulI");
function $0367fd3530e22eb2$export$5ca2cb6073dd12df(gpgpu, program, inputs, output) {
    const inputInfos = inputs.map((input, i)=>{
        const shapeInfo = {
            logicalShape: input.shape,
            texShape: input.isUniform ? null : input.texData.texShape,
            isUniform: input.isUniform,
            isPacked: input.isUniform ? false : input.texData.isPacked,
            flatOffset: null
        };
        if (input.texData != null && input.texData.slice != null && input.texData.slice.flatOffset > 0) shapeInfo.flatOffset = input.texData.slice.flatOffset;
        return {
            name: program.variableNames[i],
            shapeInfo: shapeInfo
        };
    });
    const inShapeInfos = inputInfos.map((x)=>x.shapeInfo);
    const outShapeInfo = {
        logicalShape: output.shape,
        texShape: output.texData.texShape,
        isUniform: false,
        isPacked: output.texData.isPacked,
        flatOffset: null
    };
    const source = $7svrP.makeShader(inputInfos, outShapeInfo, program);
    const fragmentShader = (0, $4rulI.createFragmentShader)(gpgpu.gl, source);
    const webGLProgram = gpgpu.createProgram(fragmentShader);
    if (!(0, $aymVi.env)().get('ENGINE_COMPILE_ONLY')) return Object.assign({
        program: program,
        fragmentShader: fragmentShader,
        source: source,
        webGLProgram: webGLProgram,
        inShapeInfos: inShapeInfos,
        outShapeInfo: outShapeInfo
    }, $0367fd3530e22eb2$export$d421ceceafba9cc0(gpgpu, program, webGLProgram));
    else return {
        program: program,
        fragmentShader: fragmentShader,
        source: source,
        webGLProgram: webGLProgram,
        inShapeInfos: inShapeInfos,
        outShapeInfo: outShapeInfo,
        uniformLocations: null,
        customUniformLocations: null,
        infLoc: null,
        nanLoc: null,
        inShapesLocations: null,
        inTexShapesLocations: null,
        outShapeLocation: null,
        outShapeStridesLocation: null,
        outTexShapeLocation: null
    };
}
function $0367fd3530e22eb2$export$d421ceceafba9cc0(gpgpu, program, webGLProgram) {
    const uniformLocations = {};
    const inShapesLocations = {};
    const inTexShapesLocations = {};
    const customUniformLocations = [];
    let outShapeLocation;
    let outTexShapeLocation;
    let outShapeStridesLocation;
    let infLoc = null;
    let nanLoc = null;
    // Add special uniforms (NAN, INFINITY)
    nanLoc = gpgpu.getUniformLocation(webGLProgram, 'NAN', false);
    if ((0, $aymVi.env)().getNumber('WEBGL_VERSION') === 1) infLoc = gpgpu.getUniformLocation(webGLProgram, 'INFINITY', false);
    // Add user-defined uniforms
    const shouldThrow = false;
    for(let i = 0; i < program.variableNames.length; i++){
        const varName = program.variableNames[i];
        uniformLocations[varName] = gpgpu.getUniformLocation(webGLProgram, varName, shouldThrow);
        uniformLocations[`offset${varName}`] = gpgpu.getUniformLocation(webGLProgram, `offset${varName}`, shouldThrow);
        if (program.enableShapeUniforms) {
            inShapesLocations[`${varName}Shape`] = gpgpu.getUniformLocation(webGLProgram, `${varName}Shape`, shouldThrow);
            inTexShapesLocations[`${varName}TexShape`] = gpgpu.getUniformLocation(webGLProgram, `${varName}TexShape`, shouldThrow);
        }
    }
    if (program.enableShapeUniforms) {
        outShapeLocation = gpgpu.getUniformLocation(webGLProgram, 'outShape', shouldThrow);
        outShapeStridesLocation = gpgpu.getUniformLocation(webGLProgram, 'outShapeStrides', shouldThrow);
        outTexShapeLocation = gpgpu.getUniformLocation(webGLProgram, 'outTexShape', shouldThrow);
    }
    if (program.customUniforms) program.customUniforms.forEach((d, i)=>{
        customUniformLocations[i] = gpgpu.getUniformLocation(webGLProgram, d.name, shouldThrow);
    });
    return {
        uniformLocations: uniformLocations,
        customUniformLocations: customUniformLocations,
        infLoc: infLoc,
        nanLoc: nanLoc,
        inShapesLocations: inShapesLocations,
        inTexShapesLocations: inTexShapesLocations,
        outShapeLocation: outShapeLocation,
        outShapeStridesLocation: outShapeStridesLocation,
        outTexShapeLocation: outTexShapeLocation
    };
}
function $0367fd3530e22eb2$var$validateBinaryAndProgram(shapeInfos, inputs) {
    if (shapeInfos.length !== inputs.length) throw Error(`Binary was compiled with ${shapeInfos.length} inputs, but ` + `was executed with ${inputs.length} inputs`);
    shapeInfos.forEach((s, i)=>{
        const shapeA = s.logicalShape;
        const input = inputs[i];
        const shapeB = input.shape;
        if (!(0, $wx9lK).arraysEqual(shapeA, shapeB)) throw Error(`Binary was compiled with different shapes than ` + `the current args. Shapes ${shapeA} and ${shapeB} must match`);
        // The input is uploaded as uniform.
        if (s.isUniform && input.isUniform) return;
        const texShapeA = s.texShape;
        const texShapeB = input.isUniform ? null : input.texData.texShape;
        if (!(0, $wx9lK).arraysEqual(texShapeA, texShapeB)) throw Error(`Binary was compiled with different texture shapes than the` + ` current args. Shape ${texShapeA} and ${texShapeB} must match`);
    });
}
function $0367fd3530e22eb2$export$4e01d2c5eea12ae3(gpgpu, binary, inputs, output, customUniformValues) {
    if (!binary.program.enableShapeUniforms) {
        $0367fd3530e22eb2$var$validateBinaryAndProgram(binary.inShapeInfos, inputs);
        $0367fd3530e22eb2$var$validateBinaryAndProgram([
            binary.outShapeInfo
        ], [
            output
        ]);
    }
    const outTex = output.texData.texture;
    const outTexShape = output.texData.texShape;
    if (output.texData.isPacked) gpgpu.setOutputPackedMatrixTexture(outTex.texture, outTexShape[0], outTexShape[1]);
    else gpgpu.setOutputMatrixTexture(outTex.texture, outTexShape[0], outTexShape[1]);
    gpgpu.setProgram(binary.webGLProgram);
    // Set special uniforms (NAN, INFINITY)
    if ((0, $aymVi.env)().getNumber('WEBGL_VERSION') === 1) {
        if (binary.infLoc !== null) gpgpu.gl.uniform1f(binary.infLoc, Infinity);
    }
    if (binary.nanLoc !== null) gpgpu.gl.uniform1f(binary.nanLoc, NaN);
    // Set user-defined inputs
    inputs.forEach((input, i)=>{
        const varName = binary.program.variableNames[i];
        const varLoc = binary.uniformLocations[varName];
        const varOffsetLoc = binary.uniformLocations[`offset${varName}`];
        const varShapeLoc = binary.inShapesLocations[`${varName}Shape`];
        const varTexShapeLoc = binary.inTexShapesLocations[`${varName}TexShape`];
        if (varShapeLoc) {
            const { uniformShape: uniformShape } = $7svrP.getUniformInfoFromShape(binary.program.packedInputs, input.shape, input.texData.texShape);
            switch(uniformShape.length){
                case 1:
                    gpgpu.gl.uniform1iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                case 2:
                    gpgpu.gl.uniform2iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                case 3:
                    gpgpu.gl.uniform3iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                case 4:
                    gpgpu.gl.uniform4iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                default:
                    break;
            }
        }
        if (varTexShapeLoc) gpgpu.gl.uniform2i(varTexShapeLoc, input.texData.texShape[0], input.texData.texShape[1]);
        if (varLoc == null) // The compiler inferred that this variable is not used in this shader.
        return;
        if (input.isUniform) {
            // Upload the values of the tensor as uniform.
            if ((0, $wx9lK).sizeFromShape(input.shape) < 2) gpgpu.gl.uniform1f(varLoc, input.uniformValues[0]);
            else {
                let vals = input.uniformValues;
                if (!(vals instanceof Float32Array)) vals = new Float32Array(vals);
                gpgpu.gl.uniform1fv(varLoc, vals);
            }
            return;
        }
        // If the input was sliced, upload the flat offset index.
        if (input.texData.slice != null && varOffsetLoc != null) gpgpu.gl.uniform1i(varOffsetLoc, input.texData.slice.flatOffset);
        gpgpu.setInputMatrixTexture(input.texData.texture.texture, varLoc, i);
    });
    const outShapeLoc = binary.outShapeLocation;
    if (outShapeLoc) switch(output.shape.length){
        case 1:
            gpgpu.gl.uniform1iv(outShapeLoc, new Int32Array(output.shape));
            break;
        case 2:
            gpgpu.gl.uniform2iv(outShapeLoc, new Int32Array(output.shape));
            break;
        case 3:
            gpgpu.gl.uniform3iv(outShapeLoc, new Int32Array(output.shape));
            break;
        case 4:
            gpgpu.gl.uniform4iv(outShapeLoc, new Int32Array(output.shape));
            break;
        default:
            break;
    }
    if (binary.outShapeStridesLocation) {
        const strides = (0, $wx9lK).computeStrides(output.shape);
        switch(output.shape.length){
            case 2:
                gpgpu.gl.uniform1iv(binary.outShapeStridesLocation, new Int32Array(strides));
                break;
            case 3:
                gpgpu.gl.uniform2iv(binary.outShapeStridesLocation, new Int32Array(strides));
                break;
            case 4:
                gpgpu.gl.uniform3iv(binary.outShapeStridesLocation, new Int32Array(strides));
                break;
            default:
                break;
        }
    }
    if (binary.outTexShapeLocation) gpgpu.gl.uniform2i(binary.outTexShapeLocation, output.texData.texShape[0], output.texData.texShape[1]);
    if (binary.program.customUniforms && customUniformValues) binary.program.customUniforms.forEach((d, i)=>{
        const customLoc = binary.customUniformLocations[i];
        const customValue = customUniformValues[i];
        if (d.type === 'float') gpgpu.gl.uniform1fv(customLoc, customValue);
        else if (d.type === 'vec2') gpgpu.gl.uniform2fv(customLoc, customValue);
        else if (d.type === 'vec3') gpgpu.gl.uniform3fv(customLoc, customValue);
        else if (d.type === 'vec4') gpgpu.gl.uniform4fv(customLoc, customValue);
        else if (d.type === 'int') gpgpu.gl.uniform1iv(customLoc, customValue);
        else if (d.type === 'ivec2') gpgpu.gl.uniform2iv(customLoc, customValue);
        else if (d.type === 'ivec3') gpgpu.gl.uniform3iv(customLoc, customValue);
        else if (d.type === 'ivec4') gpgpu.gl.uniform4iv(customLoc, customValue);
        else throw Error(`uniform type ${d.type} is not supported yet.`);
    });
    gpgpu.executeProgram();
}
function $0367fd3530e22eb2$export$2a17a6d53fe6f5d9(program, inputs, output) {
    let keyInputs = '';
    inputs.concat(output).forEach((x)=>{
        const hasOffset = x.texData != null && x.texData.slice != null && x.texData.slice.flatOffset > 0;
        // TODO: Remove the condition of !x.isUniform.
        if (program.enableShapeUniforms && !x.isUniform) {
            const xTexShape = x.texData.texShape;
            const { useSqueezeShape: useSqueezeShape, uniformShape: uniformShape, keptDims: keptDims } = $7svrP.getUniformInfoFromShape(program.packedInputs, x.shape, xTexShape);
            let rank1 = '', rank2 = '', rank34 = '';
            if (uniformShape.length === 1 && program.packedInputs) {
                const packedTexShape = [
                    Math.ceil(xTexShape[0] / 2),
                    Math.ceil(xTexShape[1] / 2)
                ];
                rank1 = `${packedTexShape[0] > 1}_${packedTexShape[1] > 1}`;
            } else if (uniformShape.length === 2 && !program.packedInputs) rank2 = `${uniformShape[0] > 1}_${uniformShape[1] > 1}`;
            else if (uniformShape.length > 2 && !program.packedInputs) {
                const strides = (0, $wx9lK).computeStrides(uniformShape);
                rank34 = `${strides[0] === xTexShape[1]}_${strides[strides.length - 1] === xTexShape[1]}`;
            }
            const xRank = x.shape.length;
            const isLogicalShapTexShapeEqual = uniformShape.length === 2 && (0, $wx9lK).arraysEqual(x.shape, xTexShape);
            const isScalar = (0, $wx9lK).sizeFromShape(x.shape) === 1;
            const broadcastDims = (0, $lkN62).getBroadcastDims(x.shape, output.shape);
            const isInOutTexShapeEqual = !program.packedInputs && xRank === output.shape.length && (0, $wx9lK).arraysEqual(xTexShape, output.texData.texShape);
            const isTexShapeGreaterThanOne = program.packedInputs || uniformShape.length > 2 ? '' : `${xTexShape[0] > 1}_${xTexShape[1] > 1}`;
            // These key components are needed due to shader_compiler is embedding
            // them in the shader.
            // |xRank| is used to determine the coords length. See
            // get[Packed]SamplerAtOutputCoords.
            // |isInOutTexShapeEqual| is used to determine whether going to an
            // optimization path in getSamplerAtOutputCoords.
            // |useSqueezeShape| is extracted from squeezeInputInfo of
            // getSampler[2|3|4]D/getPackedSampler3D.
            // |isScalar| is extracted from isInputScalar/isOutputScalar in
            // getPackedSamplerAtOutputCoords.
            // |broadcastDims| is extracted from get[Packed]SamplerAtOutputCoords.
            // |isLogicalShapTexShapeEqual| is used in
            // getOutput[Packed]2DCoords/get[Packed]Sampler2D.
            // |rank1| is used in getOutputPacked1DCoords.
            // |rank2| is used in getOutput2DCoords.
            // |rank34| is used in getSampler3D/getSampler4D.
            // |isTexShapeGreaterThanOne| are used in
            // getSampler[Scalar|1D|2D]/getOutput1DCoords.
            keyInputs += `${xRank}_${isInOutTexShapeEqual}_${useSqueezeShape ? keptDims : ''}_${uniformShape.length}_${isScalar}_${broadcastDims}_${isLogicalShapTexShapeEqual}_${rank1}_${rank2}_${rank34}_${isTexShapeGreaterThanOne}_${hasOffset}`;
        } else {
            const texShape = x.isUniform ? 'uniform' : x.texData.texShape;
            keyInputs += `${x.shape}_${texShape}_${hasOffset}`;
        }
    });
    const keyUserCode = program.userCode;
    let key = program.constructor.name;
    // Fast string concat. See https://jsperf.com/string-concatenation/14.
    key += '_' + keyInputs + '_' + keyUserCode + `${(0, $aymVi.env)().getNumber('WEBGL_VERSION')}`;
    return key;
}
function $0367fd3530e22eb2$export$5acc770fc06a0138(rank) {
    // TODO: Remove the limitaion of rank <= 4.
    return (0, $aymVi.env)().getBool('WEBGL_USE_SHAPES_UNIFORMS') && rank <= 4;
}

});
parcelRegister("7svrP", function(module, exports) {

$parcel$export(module.exports, "makeShader", () => $56e38accf4ca0869$export$37f33ba844563dd2);
$parcel$export(module.exports, "getUniformInfoFromShape", () => $56e38accf4ca0869$export$19e35a0844e29cf9);
$parcel$export(module.exports, "getCoordsDataType", () => $56e38accf4ca0869$export$859efd105c10c755);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Please make sure the shaker key in makeShaderKey in gpgpu_math.ts is well
// mapped if any shader source code is changed in this file.
parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $f7Ffe = parcelRequire("f7Ffe");

var $asYVE = parcelRequire("asYVE");
const { getBroadcastDims: $56e38accf4ca0869$var$getBroadcastDims } = (0, $lkN62);
function $56e38accf4ca0869$export$37f33ba844563dd2(inputsInfo, outputShape, program) {
    const prefixSnippets = [];
    inputsInfo.forEach((x)=>{
        const size = (0, $wx9lK).sizeFromShape(x.shapeInfo.logicalShape);
        // Snippet when we decided to upload the values as uniform.
        if (x.shapeInfo.isUniform) prefixSnippets.push(`uniform float ${x.name}${size > 1 ? `[${size}]` : ''};`);
        else {
            prefixSnippets.push(`uniform sampler2D ${x.name};`);
            prefixSnippets.push(`uniform int offset${x.name};`);
        }
        if (program.enableShapeUniforms) {
            const { uniformShape: uniformShape } = $56e38accf4ca0869$export$19e35a0844e29cf9(program.packedInputs, x.shapeInfo.logicalShape, x.shapeInfo.texShape);
            switch(uniformShape.length){
                case 1:
                    prefixSnippets.push(`uniform int ${x.name}Shape;`);
                    break;
                case 2:
                    prefixSnippets.push(`uniform ivec2 ${x.name}Shape;`);
                    break;
                case 3:
                    prefixSnippets.push(`uniform ivec3 ${x.name}Shape;`);
                    break;
                case 4:
                    prefixSnippets.push(`uniform ivec4 ${x.name}Shape;`);
                    break;
                default:
                    break;
            }
            prefixSnippets.push(`uniform ivec2 ${x.name}TexShape;`);
        }
    });
    if (program.enableShapeUniforms) {
        switch(outputShape.logicalShape.length){
            case 1:
                prefixSnippets.push(`uniform int outShape;`);
                break;
            case 2:
                prefixSnippets.push(`uniform ivec2 outShape;`);
                prefixSnippets.push(`uniform int outShapeStrides;`);
                break;
            case 3:
                prefixSnippets.push(`uniform ivec3 outShape;`);
                prefixSnippets.push(`uniform ivec2 outShapeStrides;`);
                break;
            case 4:
                prefixSnippets.push(`uniform ivec4 outShape;`);
                prefixSnippets.push(`uniform ivec3 outShapeStrides;`);
                break;
            default:
                break;
        }
        prefixSnippets.push(`uniform ivec2 outTexShape;`);
    }
    if (program.customUniforms) program.customUniforms.forEach((d)=>{
        prefixSnippets.push(`uniform ${d.type} ${d.name}${d.arrayIndex ? `[${d.arrayIndex}]` : ''};`);
    });
    const inputPrefixSnippet = prefixSnippets.join('\n');
    const inputSamplingSnippet = inputsInfo.map((x)=>$56e38accf4ca0869$var$getInputSamplingSnippet(x, outputShape, program.packedInputs, program.enableShapeUniforms)).join('\n');
    const outTexShape = outputShape.texShape;
    const glsl = (0, $f7Ffe.getGlslDifferences)();
    const floatTextureSampleSnippet = $56e38accf4ca0869$var$getFloatTextureSampleSnippet(glsl);
    let outputSamplingSnippet;
    let floatTextureSetOutputSnippet;
    let shaderPrefix = $56e38accf4ca0869$var$getShaderPrefix(glsl);
    if (outputShape.isPacked) {
        outputSamplingSnippet = $56e38accf4ca0869$var$getPackedOutputSamplingSnippet(outputShape.logicalShape, outTexShape, program.enableShapeUniforms);
        floatTextureSetOutputSnippet = $56e38accf4ca0869$var$getFloatTextureSetRGBASnippet(glsl);
    } else {
        outputSamplingSnippet = $56e38accf4ca0869$var$getOutputSamplingSnippet(outputShape.logicalShape, outTexShape, program.enableShapeUniforms);
        floatTextureSetOutputSnippet = $56e38accf4ca0869$var$getFloatTextureSetRSnippet(glsl);
    }
    if (program.packedInputs) shaderPrefix += $56e38accf4ca0869$var$SHADER_PACKED_PREFIX;
    const source = [
        shaderPrefix,
        floatTextureSampleSnippet,
        floatTextureSetOutputSnippet,
        inputPrefixSnippet,
        outputSamplingSnippet,
        inputSamplingSnippet,
        program.userCode
    ].join('\n');
    return source;
}
function $56e38accf4ca0869$var$getSamplerFromInInfo(inInfo, enableShapeUniforms = false) {
    const shape = inInfo.shapeInfo.logicalShape;
    switch(shape.length){
        case 0:
            return $56e38accf4ca0869$var$getSamplerScalar(inInfo, enableShapeUniforms);
        case 1:
            return $56e38accf4ca0869$var$getSampler1D(inInfo, enableShapeUniforms);
        case 2:
            return $56e38accf4ca0869$var$getSampler2D(inInfo, enableShapeUniforms);
        case 3:
            return $56e38accf4ca0869$var$getSampler3D(inInfo, enableShapeUniforms);
        case 4:
            return $56e38accf4ca0869$var$getSampler4D(inInfo, enableShapeUniforms);
        case 5:
            return $56e38accf4ca0869$var$getSampler5D(inInfo);
        case 6:
            return $56e38accf4ca0869$var$getSampler6D(inInfo);
        default:
            throw new Error(`${shape.length}-D input sampling` + ` is not yet supported`);
    }
}
function $56e38accf4ca0869$var$getPackedSamplerFromInInfo(inInfo, enableShapeUniforms) {
    const shape = inInfo.shapeInfo.logicalShape;
    switch(shape.length){
        case 0:
            return $56e38accf4ca0869$var$getPackedSamplerScalar(inInfo);
        case 1:
            return $56e38accf4ca0869$var$getPackedSampler1D(inInfo, enableShapeUniforms);
        case 2:
            return $56e38accf4ca0869$var$getPackedSampler2D(inInfo, enableShapeUniforms);
        case 3:
            return $56e38accf4ca0869$var$getPackedSampler3D(inInfo, enableShapeUniforms);
        default:
            return $56e38accf4ca0869$var$getPackedSamplerND(inInfo, enableShapeUniforms);
    }
}
function $56e38accf4ca0869$var$getInputSamplingSnippet(inInfo, outShapeInfo, usesPackedTextures = false, enableShapeUniforms) {
    let res = '';
    if (usesPackedTextures) res += $56e38accf4ca0869$var$getPackedSamplerFromInInfo(inInfo, enableShapeUniforms);
    else res += $56e38accf4ca0869$var$getSamplerFromInInfo(inInfo, enableShapeUniforms);
    const inShape = inInfo.shapeInfo.logicalShape;
    const outShape = outShapeInfo.logicalShape;
    if (inShape.length <= outShape.length) {
        if (usesPackedTextures) res += $56e38accf4ca0869$var$getPackedSamplerAtOutputCoords(inInfo, outShapeInfo);
        else res += $56e38accf4ca0869$var$getSamplerAtOutputCoords(inInfo, outShapeInfo);
    }
    return res;
}
function $56e38accf4ca0869$var$getPackedOutputSamplingSnippet(outShape, outTexShape, enableShapeUniforms) {
    switch(outShape.length){
        case 0:
            return $56e38accf4ca0869$var$getOutputScalarCoords();
        case 1:
            return $56e38accf4ca0869$var$getOutputPacked1DCoords(outShape, outTexShape, enableShapeUniforms);
        case 2:
            return $56e38accf4ca0869$var$getOutputPacked2DCoords(outShape, outTexShape, enableShapeUniforms);
        case 3:
            return $56e38accf4ca0869$var$getOutputPacked3DCoords(outShape, outTexShape, enableShapeUniforms);
        default:
            return $56e38accf4ca0869$var$getOutputPackedNDCoords(outShape, outTexShape, enableShapeUniforms);
    }
}
function $56e38accf4ca0869$var$getOutputSamplingSnippet(outShape, outTexShape, enableShapeUniforms) {
    switch(outShape.length){
        case 0:
            return $56e38accf4ca0869$var$getOutputScalarCoords();
        case 1:
            return $56e38accf4ca0869$var$getOutput1DCoords(outShape, outTexShape, enableShapeUniforms);
        case 2:
            return $56e38accf4ca0869$var$getOutput2DCoords(outShape, outTexShape, enableShapeUniforms);
        case 3:
            return $56e38accf4ca0869$var$getOutput3DCoords(outShape, outTexShape, enableShapeUniforms);
        case 4:
            return $56e38accf4ca0869$var$getOutput4DCoords(outShape, outTexShape, enableShapeUniforms);
        case 5:
            return $56e38accf4ca0869$var$getOutput5DCoords(outShape, outTexShape);
        case 6:
            return $56e38accf4ca0869$var$getOutput6DCoords(outShape, outTexShape);
        default:
            throw new Error(`${outShape.length}-D output sampling is not yet supported`);
    }
}
function $56e38accf4ca0869$var$getFloatTextureSampleSnippet(glsl) {
    return `
    float sampleTexture(sampler2D textureSampler, vec2 uv) {
      return ${glsl.texture2D}(textureSampler, uv).r;
    }
  `;
}
function $56e38accf4ca0869$var$getFloatTextureSetRSnippet(glsl) {
    return `
    void setOutput(float val) {
      ${glsl.output} = vec4(val, 0, 0, 0);
    }
  `;
}
function $56e38accf4ca0869$var$getFloatTextureSetRGBASnippet(glsl) {
    return `
    void setOutput(vec4 val) {
      ${glsl.output} = val;
    }
  `;
}
function $56e38accf4ca0869$var$getShaderPrefix(glsl) {
    const SHADER_PREFIX = `${glsl.version}
    precision highp float;
    precision highp int;
    precision highp sampler2D;
    ${glsl.varyingFs} vec2 resultUV;
    ${glsl.defineOutput}
    const vec2 halfCR = vec2(0.5, 0.5);

    struct ivec5
    {
      int x;
      int y;
      int z;
      int w;
      int u;
    };

    struct ivec6
    {
      int x;
      int y;
      int z;
      int w;
      int u;
      int v;
    };

    uniform float NAN;
    ${glsl.defineSpecialNaN}
    ${glsl.defineSpecialInf}
    ${glsl.defineRound}

    int imod(int x, int y) {
      return x - y * (x / y);
    }

    int idiv(int a, int b, float sign) {
      int res = a / b;
      int mod = imod(a, b);
      if (sign < 0. && mod != 0) {
        res -= 1;
      }
      return res;
    }

    //Based on the work of Dave Hoskins
    //https://www.shadertoy.com/view/4djSRW
    #define HASHSCALE1 443.8975
    float random(float seed){
      vec2 p = resultUV * seed;
      vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);
      p3 += dot(p3, p3.yzx + 19.19);
      return fract((p3.x + p3.y) * p3.z);
    }

    ${$56e38accf4ca0869$var$SAMPLE_1D_SNIPPET}
    ${$56e38accf4ca0869$var$SAMPLE_2D_SNIPPET}
    ${$56e38accf4ca0869$var$SAMPLE_3D_SNIPPET}
  `;
    return SHADER_PREFIX;
}
const $56e38accf4ca0869$var$SAMPLE_1D_SNIPPET = `
vec2 uvFromFlat(int texNumR, int texNumC, int index) {
  int texR = index / texNumC;
  int texC = index - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
vec2 packedUVfrom1D(int texNumR, int texNumC, int index) {
  int texelIndex = index / 2;
  int texR = texelIndex / texNumC;
  int texC = texelIndex - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const $56e38accf4ca0869$var$SAMPLE_2D_SNIPPET = `
vec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,
  int texNumC, int row, int col) {
  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);
  int texR = texelIndex / texNumC;
  int texC = texelIndex - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const $56e38accf4ca0869$var$SAMPLE_3D_SNIPPET = `
vec2 packedUVfrom3D(int texNumR, int texNumC,
    int texelsInBatch, int texelsInLogicalRow, int b,
    int row, int col) {
  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);
  int texR = index / texNumC;
  int texC = index - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const $56e38accf4ca0869$var$SHADER_PACKED_PREFIX = `
  float getChannel(vec4 frag, vec2 innerDims) {
    vec2 modCoord = mod(innerDims, 2.);
    return modCoord.x == 0. ?
      (modCoord.y == 0. ? frag.r : frag.g) :
      (modCoord.y == 0. ? frag.b : frag.a);
  }
  float getChannel(vec4 frag, int dim) {
    float modCoord = mod(float(dim), 2.);
    return modCoord == 0. ? frag.r : frag.g;
  }
`;
function $56e38accf4ca0869$var$getOutputScalarCoords() {
    return `
    int getOutputCoords() {
      return 0;
    }
  `;
}
function $56e38accf4ca0869$var$getOutputPacked1DCoords(shape, texShape, enableShapeUniforms) {
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    if (packedTexShape[0] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return 2 * int(resultUV.x * ceil(float(outTexShape[1]) / 2.0));
      }
    `;
        return `
      int getOutputCoords() {
        return 2 * int(resultUV.x * ${packedTexShape[1]}.0);
      }
    `;
    }
    if (packedTexShape[1] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return 2 * int(resultUV.y * ceil(float(outTexShape[0]) / 2.0));
      }
    `;
        return `
      int getOutputCoords() {
        return 2 * int(resultUV.y * ${packedTexShape[0]}.0);
      }
    `;
    }
    if (enableShapeUniforms) return `
    int getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      return 2 * (resTexRC.x * packedTexShape[1] + resTexRC.y);
    }
  `;
    return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      return 2 * (resTexRC.x * ${packedTexShape[1]} + resTexRC.y);
    }
  `;
}
function $56e38accf4ca0869$var$getOutput1DCoords(shape, texShape, enableShapeUniforms) {
    if (texShape[0] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return int(resultUV.x * float(outTexShape[1]));
      }
    `;
        return `
      int getOutputCoords() {
        return int(resultUV.x * ${texShape[1]}.0);
      }
    `;
    }
    if (texShape[1] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return int(resultUV.y * float(outTexShape[0]));
      }
    `;
        return `
      int getOutputCoords() {
        return int(resultUV.y * ${texShape[0]}.0);
      }
    `;
    }
    if (enableShapeUniforms) return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(outTexShape[0], outTexShape[1]));
      return resTexRC.x * outTexShape[1] + resTexRC.y;
    }
  `;
    return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      return resTexRC.x * ${texShape[1]} + resTexRC.y;
    }
  `;
}
function $56e38accf4ca0869$var$getOutputPacked3DCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) return `
    ivec3 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      int texelsInLogicalRow = int(ceil(float(outShape[2]) / 2.0));
      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;

      int b = index / texelsInBatch;
      index -= b * texelsInBatch;

      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec3(b, r, c);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const texelsInLogicalRow = Math.ceil(shape[2] / 2);
    const texelsInBatch = texelsInLogicalRow * Math.ceil(shape[1] / 2);
    return `
    ivec3 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;

      int b = index / ${texelsInBatch};
      index -= b * ${texelsInBatch};

      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec3(b, r, c);
    }
  `;
}
function $56e38accf4ca0869$var$getOutput3DCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) {
        const coordsFromIndexSnippet = $asYVE.getOutputLogicalCoordinatesFromFlatIndexByUniform([
            'r',
            'c',
            'd'
        ], shape);
        return `
  ivec3 getOutputCoords() {
    ivec2 resTexRC = ivec2(resultUV.yx *
                           vec2(outTexShape[0], outTexShape[1]));
    int index = resTexRC.x * outTexShape[1] + resTexRC.y;
    ${coordsFromIndexSnippet}
    return ivec3(r, c, d);
  }
`;
    }
    const coordsFromIndexSnippet = $asYVE.getLogicalCoordinatesFromFlatIndex([
        'r',
        'c',
        'd'
    ], shape);
    return `
    ivec3 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec3(r, c, d);
    }
  `;
}
function $56e38accf4ca0869$var$getOutputPackedNDCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) // TODO: support 5d and 6d
    return `
    ivec4 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;

      int texelsInLogicalRow = int(ceil(float(outShape[3]) / 2.0));
      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[2]) / 2.0));
      int texelsInBatchN = texelsInBatch * outShape[1];

      int b2 = index / texelsInBatchN;
      index -= b2 * texelsInBatchN;

      int b = index / texelsInBatch;
      index -= b * texelsInBatch;

      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec4(b2, b, r, c);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const texelsInLogicalRow = Math.ceil(shape[shape.length - 1] / 2);
    const texelsInBatch = texelsInLogicalRow * Math.ceil(shape[shape.length - 2] / 2);
    let texelsInBatchN = texelsInBatch;
    let batches = ``;
    let coords = 'b, r, c';
    for(let b = 2; b < shape.length - 1; b++){
        texelsInBatchN *= shape[shape.length - b - 1];
        batches = `
      int b${b} = index / ${texelsInBatchN};
      index -= b${b} * ${texelsInBatchN};
    ` + batches;
        coords = `b${b}, ` + coords;
    }
    return `
    ivec${shape.length} getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;

      ${batches}

      int b = index / ${texelsInBatch};
      index -= b * ${texelsInBatch};

      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec${shape.length}(${coords});
    }
  `;
}
function $56e38accf4ca0869$var$getOutput4DCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) {
        const coordsFromIndexSnippet = $asYVE.getOutputLogicalCoordinatesFromFlatIndexByUniform([
            'r',
            'c',
            'd',
            'd2'
        ], shape);
        return `
    ivec4 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(outTexShape[0], outTexShape[1]));
      int index = resTexRC.x * outTexShape[1] + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec4(r, c, d, d2);
    }
  `;
    }
    const coordsFromIndexSnippet = $asYVE.getLogicalCoordinatesFromFlatIndex([
        'r',
        'c',
        'd',
        'd2'
    ], shape);
    return `
    ivec4 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec4(r, c, d, d2);
    }
  `;
}
function $56e38accf4ca0869$var$getOutput5DCoords(shape, texShape) {
    const coordsFromIndexSnippet = $asYVE.getLogicalCoordinatesFromFlatIndex([
        'r',
        'c',
        'd',
        'd2',
        'd3'
    ], shape);
    return `
    ivec5 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx * vec2(${texShape[0]},
                             ${texShape[1]}));

      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;

      ${coordsFromIndexSnippet}

      ivec5 outShape = ivec5(r, c, d, d2, d3);
      return outShape;
    }
  `;
}
function $56e38accf4ca0869$var$getOutput6DCoords(shape, texShape) {
    const coordsFromIndexSnippet = $asYVE.getLogicalCoordinatesFromFlatIndex([
        'r',
        'c',
        'd',
        'd2',
        'd3',
        'd4'
    ], shape);
    return `
    ivec6 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;

      ${coordsFromIndexSnippet}

      ivec6 result = ivec6(r, c, d, d2, d3, d4);
      return result;
    }
  `;
}
function $56e38accf4ca0869$var$getOutputPacked2DCoords(shape, texShape, enableShapeUniforms) {
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    if ((0, $wx9lK).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
        return 2 * ivec2(resultUV.yx * vec2(packedTexShape[0], packedTexShape[1]));
      }
    `;
        return `
      ivec2 getOutputCoords() {
        return 2 * ivec2(resultUV.yx * vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      }
    `;
    }
    // texels needed to accommodate a logical row
    const texelsInLogicalRow = Math.ceil(shape[1] / 2);
    /**
     * getOutputCoords
     *
     * resTexRC: The rows and columns of the texels. If you move over one
     * texel to the right in the packed texture, you are moving over one column
     * (not two).
     *
     * index: The texel index
     */ if (enableShapeUniforms) return `
    ivec2 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      int texelsInLogicalRow = int(ceil(float(outShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));

      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;
      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec2(r, c);
    }
  `;
    return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));

      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;
      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec2(r, c);
    }
  `;
}
function $56e38accf4ca0869$var$getOutput2DCoords(shape, texShape, enableShapeUniforms) {
    if ((0, $wx9lK).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        return ivec2(resultUV.yx * vec2(outTexShape[0], outTexShape[1]));
      }
    `;
        return `
      ivec2 getOutputCoords() {
        return ivec2(resultUV.yx * vec2(${texShape[0]}, ${texShape[1]}));
      }
    `;
    }
    if (shape[1] === 1) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(outTexShape[0], outTexShape[1]));
        int index = resTexRC.x * outTexShape[1] + resTexRC.y;
        return ivec2(index, 0);
      }
    `;
        return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(${texShape[0]}, ${texShape[1]}));
        int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
        return ivec2(index, 0);
      }
    `;
    }
    if (shape[0] === 1) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(outTexShape[0], outTexShape[1]));
        int index = resTexRC.x * outTexShape[1] + resTexRC.y;
        return ivec2(0, index);
      }
    `;
        return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(${texShape[0]}, ${texShape[1]}));
        int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
        return ivec2(0, index);
      }
    `;
    }
    if (enableShapeUniforms) return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(outTexShape[0], outTexShape[1]));
      int index = resTexRC.x * outTexShape[1] + resTexRC.y;
      int r = index / outShape[1];
      int c = index - r * outShape[1];
      return ivec2(r, c);
    }
  `;
    return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      int r = index / ${shape[1]};
      int c = index - r * ${shape[1]};
      return ivec2(r, c);
    }
  `;
}
function $56e38accf4ca0869$var$getFlatOffsetUniformName(texName) {
    return `offset${texName}`;
}
function $56e38accf4ca0869$var$getPackedSamplerScalar(inputInfo) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const glsl = (0, $f7Ffe.getGlslDifferences)();
    return `
    vec4 ${funcName}() {
      return ${glsl.texture2D}(${texName}, halfCR);
    }
  `;
}
function $56e38accf4ca0869$var$getSamplerScalar(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    if (inputInfo.shapeInfo.isUniform) return `float ${funcName}() {return ${texName};}`;
    const [texNumR, texNumC] = inputInfo.shapeInfo.texShape;
    if (texNumR === 1 && texNumC === 1) return `
      float ${funcName}() {
        return sampleTexture(${texName}, halfCR);
      }
    `;
    const offset = $56e38accf4ca0869$var$getFlatOffsetUniformName(texName);
    if (enableShapeUniforms) return `
    float ${funcName}() {
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
    const [tNumR, tNumC] = inputInfo.shapeInfo.texShape;
    return `
    float ${funcName}() {
      vec2 uv = uvFromFlat(${tNumR}, ${tNumC}, ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $56e38accf4ca0869$var$getPackedSampler1D(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    const glsl = (0, $f7Ffe.getGlslDifferences)();
    if (enableShapeUniforms) return `
    vec4 ${funcName}(int index) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      vec2 uv = packedUVfrom1D(
        packedTexShape[0], packedTexShape[1], index);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    return `
    vec4 ${funcName}(int index) {
      vec2 uv = packedUVfrom1D(
        ${packedTexShape[0]}, ${packedTexShape[1]}, index);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $56e38accf4ca0869$var$getSampler1D(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int index) {
        ${$56e38accf4ca0869$var$getUniformSampler(inputInfo)}
      }
    `;
    const texShape = inputInfo.shapeInfo.texShape;
    const tNumR = texShape[0];
    const tNumC = texShape[1];
    if (tNumC === 1 && tNumR === 1) return `
      float ${funcName}(int index) {
        return sampleTexture(${texName}, halfCR);
      }
    `;
    const offset = $56e38accf4ca0869$var$getFlatOffsetUniformName(texName);
    if (tNumC === 1) {
        if (enableShapeUniforms) return `
      float ${funcName}(int index) {
        vec2 uv = vec2(0.5, (float(index + ${offset}) + 0.5) / float(${texName}TexShape[0]));
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int index) {
        vec2 uv = vec2(0.5, (float(index + ${offset}) + 0.5) / ${tNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    if (tNumR === 1) {
        if (enableShapeUniforms) return `
      float ${funcName}(int index) {
        vec2 uv = vec2((float(index + ${offset}) + 0.5) / float(${texName}TexShape[1]), 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int index) {
        vec2 uv = vec2((float(index + ${offset}) + 0.5) / ${tNumC}.0, 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    if (enableShapeUniforms) return `
    float ${funcName}(int index) {
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
    return `
    float ${funcName}(int index) {
      vec2 uv = uvFromFlat(${tNumR}, ${tNumC}, index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $56e38accf4ca0869$var$getPackedSampler2D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const glsl = (0, $f7Ffe.getGlslDifferences)();
    if (texShape != null && (0, $wx9lK).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      vec4 ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);

        return ${glsl.texture2D}(${texName}, uv);
      }
    `;
        return `
      vec4 ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);

        return ${glsl.texture2D}(${texName}, uv);
      }
    `;
    }
    if (enableShapeUniforms) return `
    vec4 ${funcName}(int row, int col) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int valuesPerRow = int(ceil(float(${texName}Shape[1]) / 2.0));
      vec2 uv = packedUVfrom2D(valuesPerRow, packedTexShape[0], packedTexShape[1], row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const valuesPerRow = Math.ceil(shape[1] / 2);
    return `
    vec4 ${funcName}(int row, int col) {
      vec2 uv = packedUVfrom2D(${valuesPerRow}, ${packedTexShape[0]}, ${packedTexShape[1]}, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $56e38accf4ca0869$var$getSampler2D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    if (texShape != null && (0, $wx9lK).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        const texNumR = texShape[0];
        const texNumC = texShape[1];
        return `
    float ${funcName}(int row, int col) {
      vec2 uv = (vec2(col, row) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    const { newShape: newShape, keptDims: keptDims } = (0, $wx9lK).squeezeShape(shape);
    const squeezedShape = newShape;
    if (squeezedShape.length < shape.length) {
        const newInputInfo = $56e38accf4ca0869$export$5d06d3f48295bf13(inputInfo, squeezedShape);
        const params = [
            'row',
            'col'
        ];
        return `
      ${$56e38accf4ca0869$var$getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
      float ${funcName}(int row, int col) {
        return ${funcName}(${$56e38accf4ca0869$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col) {
        int index = round(dot(vec2(row, col), vec2(${shape[1]}, 1)));
        ${$56e38accf4ca0869$var$getUniformSampler(inputInfo)}
      }
    `;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const offset = $56e38accf4ca0869$var$getFlatOffsetUniformName(texName);
    if (texNumC === 1) {
        // index is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        float index = dot(vec3(row, col, ${offset}), vec3(${texName}Shape[1], 1, 1));
        vec2 uv = vec2(0.5, (index + 0.5) / float(${texName}TexShape[0]));
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
    float ${funcName}(int row, int col) {
      float index = dot(vec3(row, col, ${offset}), vec3(${shape[1]}, 1, 1));
      vec2 uv = vec2(0.5, (index + 0.5) / ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    if (texNumR === 1) {
        // index is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        float index = dot(vec3(row, col, ${offset}), vec3(${texName}Shape[1], 1, 1));
        vec2 uv = vec2((index + 0.5) / float(${texName}TexShape[1]), 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
    float ${funcName}(int row, int col) {
      float index = dot(vec3(row, col, ${offset}), vec3(${shape[1]}, 1, 1));
      vec2 uv = vec2((index + 0.5) / ${texNumC}.0, 0.5);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        // Explicitly use integer operations as dot() only works on floats.
        int index = row * ${texName}Shape[1] + col + ${offset};
        vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index);
        return sampleTexture(${texName}, uv);
      }
    `;
    return `
  float ${funcName}(int row, int col) {
    // Explicitly use integer operations as dot() only works on floats.
    int index = row * ${shape[1]} + col + ${offset};
    vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
    return sampleTexture(${texName}, uv);
  }
`;
}
function $56e38accf4ca0869$var$getPackedSampler3D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    if (shape[0] === 1) {
        const squeezedShape = shape.slice(1);
        const keptDims = [
            1,
            2
        ];
        const newInputInfo = $56e38accf4ca0869$export$5d06d3f48295bf13(inputInfo, squeezedShape);
        const params = [
            'b',
            'row',
            'col'
        ];
        return `
        ${$56e38accf4ca0869$var$getPackedSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
        vec4 ${funcName}(int b, int row, int col) {
          return ${funcName}(${$56e38accf4ca0869$var$getSqueezedParams(params, keptDims)});
        }
      `;
    }
    const glsl = (0, $f7Ffe.getGlslDifferences)();
    if (enableShapeUniforms) return `
    vec4 ${funcName}(int b, int row, int col) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int valuesPerRow = int(ceil(float(${texName}Shape[2]) / 2.0));
      int texelsInBatch = valuesPerRow * int(ceil(float(${texName}Shape[1]) / 2.0));
      vec2 uv = packedUVfrom3D(
        packedTexShape[0], packedTexShape[1], texelsInBatch, valuesPerRow, b, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const texNumR = packedTexShape[0];
    const texNumC = packedTexShape[1];
    const valuesPerRow = Math.ceil(shape[2] / 2);
    const texelsInBatch = valuesPerRow * Math.ceil(shape[1] / 2);
    return `
    vec4 ${funcName}(int b, int row, int col) {
      vec2 uv = packedUVfrom3D(
        ${texNumR}, ${texNumC}, ${texelsInBatch}, ${valuesPerRow}, b, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $56e38accf4ca0869$var$getSampler3D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const stride0 = shape[1] * shape[2];
    const stride1 = shape[2];
    const { newShape: newShape, keptDims: keptDims } = (0, $wx9lK).squeezeShape(shape);
    const squeezedShape = newShape;
    if (squeezedShape.length < shape.length) {
        const newInputInfo = $56e38accf4ca0869$export$5d06d3f48295bf13(inputInfo, squeezedShape);
        const params = [
            'row',
            'col',
            'depth'
        ];
        return `
        ${$56e38accf4ca0869$var$getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
        float ${funcName}(int row, int col, int depth) {
          return ${funcName}(${$56e38accf4ca0869$var$getSqueezedParams(params, keptDims)});
        }
      `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth) {
        int index = round(dot(vec3(row, col, depth),
                          vec3(${stride0}, ${stride1}, 1)));
        ${$56e38accf4ca0869$var$getUniformSampler(inputInfo)}
      }
    `;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    if (texNumC === stride0 && flatOffset == null) {
        // texC is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth) {
        int stride1 = ${texName}Shape[2];
        float texR = float(row);
        float texC = dot(vec2(col, depth), vec2(stride1, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
        float ${funcName}(int row, int col, int depth) {
          float texR = float(row);
          float texC = dot(vec2(col, depth), vec2(${stride1}, 1));
          vec2 uv = (vec2(texC, texR) + halfCR) /
                     vec2(${texNumC}.0, ${texNumR}.0);
          return sampleTexture(${texName}, uv);
        }
      `;
    }
    if (texNumC === stride1 && flatOffset == null) {
        // texR is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth) {
        float texR = dot(vec2(row, col), vec2(${texName}Shape[1], 1));
        float texC = float(depth);
        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
    float ${funcName}(int row, int col, int depth) {
      float texR = dot(vec2(row, col), vec2(${shape[1]}, 1));
      float texC = float(depth);
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    const offset = $56e38accf4ca0869$var$getFlatOffsetUniformName(texName);
    if (enableShapeUniforms) return `
    float ${funcName}(int row, int col, int depth) {
      // Explicitly use integer operations as dot() only works on floats.
      int stride0 = ${texName}Shape[1] * ${texName}Shape[2];
      int stride1 = ${texName}Shape[2];
      int index = row * stride0 + col * stride1 + depth + ${offset};
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index);
      return sampleTexture(${texName}, uv);
    }
    `;
    return `
      float ${funcName}(int row, int col, int depth) {
        // Explicitly use integer operations as dot() only works on floats.
        int index = row * ${stride0} + col * ${stride1} + depth + ${offset};
        vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
        return sampleTexture(${texName}, uv);
      }
  `;
}
function $56e38accf4ca0869$var$getPackedSamplerND(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const glsl = (0, $f7Ffe.getGlslDifferences)();
    if (enableShapeUniforms) // TODO: support 5d and 6d
    return `
    vec4 ${funcName}(int b2, int b, int row, int col) {
      int valuesPerRow = int(ceil(float(${texName}Shape[3]) / 2.0));
      int texelsInBatch = valuesPerRow * int(ceil(float(${texName}Shape[2]) / 2.0));
      int index = b * texelsInBatch + (row / 2) * valuesPerRow + (col / 2);
      texelsInBatch *= ${texName}Shape[1];
      index = b2 * texelsInBatch + index;
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int texR = index / packedTexShape[1];
      int texC = index - texR * packedTexShape[1];
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(packedTexShape[1], packedTexShape[0]); return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const shape = inputInfo.shapeInfo.logicalShape;
    const rank = shape.length;
    const texShape = inputInfo.shapeInfo.texShape;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const texNumR = packedTexShape[0];
    const texNumC = packedTexShape[1];
    const valuesPerRow = Math.ceil(shape[rank - 1] / 2);
    let texelsInBatch = valuesPerRow * Math.ceil(shape[rank - 2] / 2);
    let params = `int b, int row, int col`;
    let index = `b * ${texelsInBatch} + (row / 2) * ${valuesPerRow} + (col / 2)`;
    for(let b = 2; b < rank - 1; b++){
        params = `int b${b}, ` + params;
        texelsInBatch *= shape[rank - b - 1];
        index = `b${b} * ${texelsInBatch} + ` + index;
    }
    return `
    vec4 ${funcName}(${params}) {
      int index = ${index};
      int texR = index / ${texNumC};
      int texC = index - texR * ${texNumC};
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texNumC}, ${texNumR});
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $56e38accf4ca0869$var$getSampler4D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const stride2 = shape[3];
    const stride1 = shape[2] * stride2;
    const stride0 = shape[1] * stride1;
    const { newShape: newShape, keptDims: keptDims } = (0, $wx9lK).squeezeShape(shape);
    if (newShape.length < shape.length) {
        const newInputInfo = $56e38accf4ca0869$export$5d06d3f48295bf13(inputInfo, newShape);
        const params = [
            'row',
            'col',
            'depth',
            'depth2'
        ];
        return `
      ${$56e38accf4ca0869$var$getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
      float ${funcName}(int row, int col, int depth, int depth2) {
        return ${funcName}(${$56e38accf4ca0869$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        int index = round(dot(vec4(row, col, depth, depth2),
                          vec4(${stride0}, ${stride1}, ${stride2}, 1)));
        ${$56e38accf4ca0869$var$getUniformSampler(inputInfo)}
      }
    `;
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const stride2Str = `int stride2 = ${texName}Shape[3];`;
    const stride1Str = `int stride1 = ${texName}Shape[2] * stride2;`;
    const stride0Str = `int stride0 = ${texName}Shape[1] * stride1;`;
    if (texNumC === stride0 && flatOffset == null) {
        // texC is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        ${stride2Str}
        ${stride1Str}
        float texR = float(row);
        float texC =
            dot(vec3(col, depth, depth2),
                vec3(stride1, stride2, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = float(row);
        float texC =
            dot(vec3(col, depth, depth2),
                vec3(${stride1}, ${stride2}, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    if (texNumC === stride2 && flatOffset == null) {
        // texR is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = dot(vec3(row, col, depth),
                         vec3(${texName}Shape[1] * ${texName}Shape[2], ${texName}Shape[2], 1));
        float texC = float(depth2);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = dot(vec3(row, col, depth),
                         vec3(${shape[1] * shape[2]}, ${shape[2]}, 1));
        float texC = float(depth2);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    const offset = $56e38accf4ca0869$var$getFlatOffsetUniformName(texName);
    if (enableShapeUniforms) return `
    float ${funcName}(int row, int col, int depth, int depth2) {
      // Explicitly use integer operations as dot() only works on floats.
      ${stride2Str}
      ${stride1Str}
      ${stride0Str}
      int index = row * stride0 + col * stride1 +
          depth * stride2 + depth2;
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
    return `
    float ${funcName}(int row, int col, int depth, int depth2) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} +
          depth * ${stride2} + depth2;
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $56e38accf4ca0869$var$getSampler5D(inputInfo) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const stride3 = shape[4];
    const stride2 = shape[3] * stride3;
    const stride1 = shape[2] * stride2;
    const stride0 = shape[1] * stride1;
    const { newShape: newShape, keptDims: keptDims } = (0, $wx9lK).squeezeShape(shape);
    if (newShape.length < shape.length) {
        const newInputInfo = $56e38accf4ca0869$export$5d06d3f48295bf13(inputInfo, newShape);
        const params = [
            'row',
            'col',
            'depth',
            'depth2',
            'depth3'
        ];
        return `
      ${$56e38accf4ca0869$var$getSamplerFromInInfo(newInputInfo)}
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        return ${funcName}(${$56e38accf4ca0869$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        float index = dot(
          vec4(row, col, depth, depth2),
          vec4(${stride0}, ${stride1}, ${stride2}, ${stride3})) +
          depth3;
        ${$56e38accf4ca0869$var$getUniformSampler(inputInfo)}
      }
    `;
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    if (texNumC === stride0 && flatOffset == null) // texC is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        int texR = row;
        float texC = dot(vec4(col, depth, depth2, depth3),
                         vec4(${stride1}, ${stride2}, ${stride3}, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    if (texNumC === stride3 && flatOffset == null) // texR is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        float texR = dot(
          vec4(row, col, depth, depth2),
          vec4(${shape[1] * shape[2] * shape[3]},
               ${shape[2] * shape[3]}, ${shape[3]}, 1));
        int texC = depth3;
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    const offset = $56e38accf4ca0869$var$getFlatOffsetUniformName(texName);
    return `
    float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} + depth * ${stride2} +
          depth2 * ${stride3} + depth3 + ${offset};
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $56e38accf4ca0869$var$getSampler6D(inputInfo) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const { newShape: newShape, keptDims: keptDims } = (0, $wx9lK).squeezeShape(shape);
    if (newShape.length < shape.length) {
        const newInputInfo = $56e38accf4ca0869$export$5d06d3f48295bf13(inputInfo, newShape);
        const params = [
            'row',
            'col',
            'depth',
            'depth2',
            'depth3',
            'depth4'
        ];
        return `
      ${$56e38accf4ca0869$var$getSamplerFromInInfo(newInputInfo)}
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        return ${funcName}(${$56e38accf4ca0869$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    const stride4 = shape[5];
    const stride3 = shape[4] * stride4;
    const stride2 = shape[3] * stride3;
    const stride1 = shape[2] * stride2;
    const stride0 = shape[1] * stride1;
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth,
                  int depth2, int depth3, int depth4) {
        int index = round(dot(
          vec4(row, col, depth, depth2),
          vec4(${stride0}, ${stride1}, ${stride2}, ${stride3})) +
          dot(
            vec2(depth3, depth4),
            vec2(${stride4}, 1)));
        ${$56e38accf4ca0869$var$getUniformSampler(inputInfo)}
      }
    `;
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    if (texNumC === stride0 && flatOffset == null) // texC is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        int texR = row;
        float texC = dot(vec4(col, depth, depth2, depth3),
          vec4(${stride1}, ${stride2}, ${stride3}, ${stride4})) +
               float(depth4);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    if (texNumC === stride4 && flatOffset == null) // texR is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        float texR = dot(vec4(row, col, depth, depth2),
          vec4(${shape[1] * shape[2] * shape[3] * shape[4]},
               ${shape[2] * shape[3] * shape[4]},
               ${shape[3] * shape[4]},
               ${shape[4]})) + float(depth3);
        int texC = depth4;
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    const offset = $56e38accf4ca0869$var$getFlatOffsetUniformName(texName);
    return `
    float ${funcName}(int row, int col, int depth,
                  int depth2, int depth3, int depth4) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} + depth * ${stride2} +
          depth2 * ${stride3} + depth3 * ${stride4} + depth4 + ${offset};
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $56e38accf4ca0869$var$getUniformSampler(inputInfo) {
    const texName = inputInfo.name;
    const inSize = (0, $wx9lK).sizeFromShape(inputInfo.shapeInfo.logicalShape);
    if (inSize < 2) return `return ${texName};`;
    return `
    for (int i = 0; i < ${inSize}; i++) {
      if (i == index) {
        return ${texName}[i];
      }
    }
  `;
}
function $56e38accf4ca0869$var$getPackedSamplerAtOutputCoords(inputInfo, outShapeInfo) {
    const texName = inputInfo.name;
    const texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
    const funcName = 'get' + texFuncSnippet + 'AtOutCoords';
    const inRank = inputInfo.shapeInfo.logicalShape.length;
    const outRank = outShapeInfo.logicalShape.length;
    const broadcastDims = $56e38accf4ca0869$var$getBroadcastDims(inputInfo.shapeInfo.logicalShape, outShapeInfo.logicalShape);
    const type = $56e38accf4ca0869$export$859efd105c10c755(outRank);
    const rankDiff = outRank - inRank;
    let coordsSnippet;
    const fields = [
        'x',
        'y',
        'z',
        'w',
        'u',
        'v'
    ];
    if (inRank === 0) coordsSnippet = '';
    else if (outRank < 2 && broadcastDims.length >= 1) coordsSnippet = 'coords = 0;';
    else coordsSnippet = broadcastDims.map((d)=>`coords.${fields[d + rankDiff]} = 0;`).join('\n');
    let unpackedCoordsSnippet = '';
    if (outRank < 2 && inRank > 0) unpackedCoordsSnippet = 'coords';
    else unpackedCoordsSnippet = inputInfo.shapeInfo.logicalShape.map((s, i)=>`coords.${fields[i + rankDiff]}`).join(', ');
    let output = `return outputValue;`;
    const inSize = (0, $wx9lK).sizeFromShape(inputInfo.shapeInfo.logicalShape);
    const isInputScalar = inSize === 1;
    const outSize = (0, $wx9lK).sizeFromShape(outShapeInfo.logicalShape);
    const isOutputScalar = outSize === 1;
    if (inRank === 1 && !isInputScalar && !isOutputScalar) output = `
      return vec4(outputValue.xy, outputValue.xy);
    `;
    else if (isInputScalar && !isOutputScalar) {
        if (outRank === 1) output = `
        return vec4(outputValue.x, outputValue.x, 0., 0.);
      `;
        else output = `
        return vec4(outputValue.x);
      `;
    } else if (broadcastDims.length) {
        const rows = inRank - 2;
        const cols = inRank - 1;
        if (broadcastDims.indexOf(rows) > -1 && broadcastDims.indexOf(cols) > -1) output = `return vec4(outputValue.x);`;
        else if (broadcastDims.indexOf(rows) > -1) output = `return vec4(outputValue.x, outputValue.y, ` + `outputValue.x, outputValue.y);`;
        else if (broadcastDims.indexOf(cols) > -1) output = `return vec4(outputValue.xx, outputValue.zz);`;
    }
    return `
    vec4 ${funcName}() {
      ${type} coords = getOutputCoords();
      ${coordsSnippet}
      vec4 outputValue = get${texFuncSnippet}(${unpackedCoordsSnippet});
      ${output}
    }
  `;
}
function $56e38accf4ca0869$var$getSamplerAtOutputCoords(inputInfo, outShapeInfo) {
    const texName = inputInfo.name;
    const texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
    const funcName = 'get' + texFuncSnippet + 'AtOutCoords';
    const outTexShape = outShapeInfo.texShape;
    const inTexShape = inputInfo.shapeInfo.texShape;
    const inRank = inputInfo.shapeInfo.logicalShape.length;
    const outRank = outShapeInfo.logicalShape.length;
    if (!inputInfo.shapeInfo.isUniform && inRank === outRank && inputInfo.shapeInfo.flatOffset == null && (0, $wx9lK).arraysEqual(inTexShape, outTexShape)) return `
      float ${funcName}() {
        return sampleTexture(${texName}, resultUV);
      }
    `;
    const type = $56e38accf4ca0869$export$859efd105c10c755(outRank);
    const broadcastDims = $56e38accf4ca0869$var$getBroadcastDims(inputInfo.shapeInfo.logicalShape, outShapeInfo.logicalShape);
    const rankDiff = outRank - inRank;
    let coordsSnippet;
    const fields = [
        'x',
        'y',
        'z',
        'w',
        'u',
        'v'
    ];
    if (inRank === 0) coordsSnippet = '';
    else if (outRank < 2 && broadcastDims.length >= 1) coordsSnippet = 'coords = 0;';
    else coordsSnippet = broadcastDims.map((d)=>`coords.${fields[d + rankDiff]} = 0;`).join('\n');
    let unpackedCoordsSnippet = '';
    if (outRank < 2 && inRank > 0) unpackedCoordsSnippet = 'coords';
    else unpackedCoordsSnippet = inputInfo.shapeInfo.logicalShape.map((s, i)=>`coords.${fields[i + rankDiff]}`).join(', ');
    return `
    float ${funcName}() {
      ${type} coords = getOutputCoords();
      ${coordsSnippet}
      return get${texFuncSnippet}(${unpackedCoordsSnippet});
    }
  `;
}
function $56e38accf4ca0869$export$859efd105c10c755(rank) {
    if (rank <= 1) return 'int';
    else if (rank === 2) return 'ivec2';
    else if (rank === 3) return 'ivec3';
    else if (rank === 4) return 'ivec4';
    else if (rank === 5) return 'ivec5';
    else if (rank === 6) return 'ivec6';
    else throw Error(`GPU for rank ${rank} is not yet supported`);
}
function $56e38accf4ca0869$export$19e35a0844e29cf9(isPacked, shape, texShape) {
    const { newShape: newShape, keptDims: keptDims } = (0, $wx9lK).squeezeShape(shape);
    const rank = shape.length;
    const useSqueezePackedShape = isPacked && rank === 3 && shape[0] === 1;
    const squeezeShape = useSqueezePackedShape ? shape.slice(1) : newShape;
    const useSqueezeShape = !isPacked && rank > 1 && !(0, $wx9lK).arraysEqual(shape, texShape) && newShape.length < rank || useSqueezePackedShape;
    const uniformShape = useSqueezeShape ? squeezeShape : shape;
    return {
        useSqueezeShape: useSqueezeShape,
        uniformShape: uniformShape,
        keptDims: keptDims
    };
}
function $56e38accf4ca0869$export$5d06d3f48295bf13(inInfo, squeezedShape) {
    // Deep copy.
    const newInputInfo = JSON.parse(JSON.stringify(inInfo));
    newInputInfo.shapeInfo.logicalShape = squeezedShape;
    return newInputInfo;
}
function $56e38accf4ca0869$var$getSqueezedParams(params, keptDims) {
    return keptDims.map((d)=>params[d]).join(', ');
}

});
parcelRegister("asYVE", function(module, exports) {

$parcel$export(module.exports, "getLogicalCoordinatesFromFlatIndex", () => $79ebc8205ff39a8b$export$53c37f67510642ce);
$parcel$export(module.exports, "getOutputLogicalCoordinatesFromFlatIndexByUniform", () => $79ebc8205ff39a8b$export$ae684ebb20c3e80c);
$parcel$export(module.exports, "getLogicalCoordinatesFromFlatIndexByUniform", () => $79ebc8205ff39a8b$export$a1b266196cc2d8ea);
$parcel$export(module.exports, "getFlatIndexFrom3D", () => $79ebc8205ff39a8b$export$4c68558c71205a01);
$parcel$export(module.exports, "getFlatIndexFrom3DOutput", () => $79ebc8205ff39a8b$export$4ec1e3f6361de451);
$parcel$export(module.exports, "ENCODE_FLOAT_SNIPPET", () => $79ebc8205ff39a8b$export$2ac12a308a563905);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
function $79ebc8205ff39a8b$export$53c37f67510642ce(coords, shape, index = 'index') {
    const strides = (0, $wx9lK).computeStrides(shape);
    return strides.map((stride, i)=>{
        const line1 = `int ${coords[i]} = ${index} / ${stride}`;
        const line2 = i === strides.length - 1 ? `int ${coords[i + 1]} = ${index} - ${coords[i]} * ${stride}` : `index -= ${coords[i]} * ${stride}`;
        return `${line1}; ${line2};`;
    }).join('');
}
function $79ebc8205ff39a8b$export$ae684ebb20c3e80c(coords, shape, index = 'index') {
    const strides = (0, $wx9lK).computeStrides(shape);
    return strides.map((_, i)=>{
        const line1 = `int ${coords[i]} = ${index} / outShapeStrides[${i}]`;
        const line2 = i === strides.length - 1 ? `int ${coords[i + 1]} = ${index} - ${coords[i]} * outShapeStrides[${i}]` : `index -= ${coords[i]} * outShapeStrides[${i}]`;
        return `${line1}; ${line2};`;
    }).join('');
}
// Produces GLSL code that computes strides.
function $79ebc8205ff39a8b$var$symbolicallyComputeStrides(indicesArr, variableName) {
    const numCoords = indicesArr.length;
    const shape = indicesArr.map((d)=>`${variableName}[${d}]`);
    const strides = new Array(numCoords - 1);
    strides[numCoords - 2] = shape[numCoords - 1];
    for(let i = numCoords - 3; i >= 0; --i)strides[i] = `(${strides[i + 1]} * ${shape[i + 1]})`;
    return strides;
}
function $79ebc8205ff39a8b$export$a1b266196cc2d8ea(coords, variableName, index = 'index') {
    const indicesArray = coords.map((_, i)=>i);
    const strides = $79ebc8205ff39a8b$var$symbolicallyComputeStrides(indicesArray, variableName);
    return strides.map((_, i)=>{
        const line1 = `int ${coords[i]} = ${index} / ${strides[i]}`;
        const line2 = i === strides.length - 1 ? `int ${coords[i + 1]} = ${index} - ${coords[i]} * ${strides[i]}` : `index -= ${coords[i]} * ${strides[i]}`;
        return `${line1}; ${line2};`;
    }).join('');
}
function $79ebc8205ff39a8b$var$buildVec(x) {
    if (x.length === 1) return `${x[0]}`;
    return `vec${x.length}(${x.join(',')})`;
}
function $79ebc8205ff39a8b$export$fe4cd89a7b9cb48b(x, y) {
    if (x.length !== y.length) throw new Error(`Vectors to be dotted must be of the same length -` + `got ${x.length} and ${y.length}`);
    const slices = [];
    const nearestVec4 = Math.floor(x.length / 4);
    const nearestVec4Remainder = x.length % 4;
    for(let i = 0; i < nearestVec4; i++){
        const xSlice = x.slice(i * 4, i * 4 + 4);
        const ySlice = y.slice(i * 4, i * 4 + 4);
        slices.push(`${$79ebc8205ff39a8b$var$buildVec(xSlice)}, ${$79ebc8205ff39a8b$var$buildVec(ySlice)}`);
    }
    if (nearestVec4Remainder !== 0) {
        let xSlice = x.slice(nearestVec4 * 4);
        let ySlice = y.slice(nearestVec4 * 4);
        if (xSlice.length === 1) {
            xSlice = xSlice.map((d)=>`float(${d})`);
            ySlice = ySlice.map((d)=>`float(${d})`);
        }
        slices.push(`${$79ebc8205ff39a8b$var$buildVec(xSlice)}, ${$79ebc8205ff39a8b$var$buildVec(ySlice)}`);
    }
    return slices.map((d, i)=>`dot(${d})`).join('+');
}
function $79ebc8205ff39a8b$export$4c68558c71205a01(shape) {
    const strides = (0, $wx9lK).computeStrides(shape).map((d)=>d.toString());
    return `
  int getFlatIndex(ivec3 coords) {
    return coords.x * ${strides[0]} + coords.y * ${strides[1]} + coords.z;
  }
`;
}
function $79ebc8205ff39a8b$export$4ec1e3f6361de451() {
    return `
  int getFlatIndex(ivec3 coords) {
    return coords.x * outShapeStrides[0] + coords.y * outShapeStrides[1] + coords.z;
  }
`;
}
const $79ebc8205ff39a8b$export$2ac12a308a563905 = `
  const float FLOAT_MAX = 1.70141184e38;
  const float FLOAT_MIN = 1.17549435e-38;

  lowp vec4 encode_float(highp float v) {
    if (isnan(v)) {
      return vec4(255, 255, 255, 255);
    }

    highp float av = abs(v);

    if(av < FLOAT_MIN) {
      return vec4(0.0, 0.0, 0.0, 0.0);
    } else if(v > FLOAT_MAX) {
      return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;
    } else if(v < -FLOAT_MAX) {
      return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;
    }

    highp vec4 c = vec4(0,0,0,0);

    highp float e = floor(log2(av));
    highp float m = exp2(fract(log2(av))) - 1.0;

    c[2] = floor(128.0 * m);
    m -= c[2] / 128.0;
    c[1] = floor(32768.0 * m);
    m -= c[1] / 32768.0;
    c[0] = floor(8388608.0 * m);

    highp float ebias = e + 127.0;
    c[3] = floor(ebias / 2.0);
    ebias -= c[3] * 2.0;
    c[2] += floor(ebias) * 128.0;

    c[3] += 128.0 * step(0.0, -v);

    return c / 255.0;
  }
`;

});




parcelRegister("auraC", function(module, exports) {

$parcel$export(module.exports, "DecodeMatrixPackedProgram", () => $7a31c831610ac38c$export$4434db41c70879cb);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $f7Ffe = parcelRequire("f7Ffe");

var $i88bA = parcelRequire("i88bA");

var $asYVE = parcelRequire("asYVE");

var $lE6VE = parcelRequire("lE6VE");
class $7a31c831610ac38c$export$4434db41c70879cb {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outPackingScheme = (0, $lE6VE.PackingScheme).DENSE;
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $f7Ffe.getGlslDifferences)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        this.userCode = `
      ivec3 outCoordsFromFlatIndex(int index) {
        ${this.enableShapeUniforms ? $asYVE.getOutputLogicalCoordinatesFromFlatIndexByUniform([
            'r',
            'c',
            'd'
        ], outputShape) : $asYVE.getLogicalCoordinatesFromFlatIndex([
            'r',
            'c',
            'd'
        ], outputShape)}
        return ivec3(r, c, d);
      }

      void main() {
        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));
        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);

        vec4 result = vec4(0.);

        for (int i=0; i<4; i++) {
          int flatIndex = index + i;
          ivec3 rc = outCoordsFromFlatIndex(flatIndex);
          result[i] = getChannel(getA(rc.x, rc.y, rc.z), vec2(rc.y, rc.z));
        }

        ${glsl.output} = result;
      }
    `;
    }
}

});

parcelRegister("gbYDR", function(module, exports) {

$parcel$export(module.exports, "EncodeFloatProgram", () => $bc9cb6a0366b9457$export$dae4f112167b5aac);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $f7Ffe = parcelRequire("f7Ffe");

var $asYVE = parcelRequire("asYVE");

var $lE6VE = parcelRequire("lE6VE");
class $bc9cb6a0366b9457$export$dae4f112167b5aac {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.outTexUsage = (0, $lE6VE.TextureUsage).DOWNLOAD;
        const glsl = (0, $f7Ffe.getGlslDifferences)();
        this.outputShape = outputShape;
        this.userCode = `
      ${0, $asYVE.ENCODE_FLOAT_SNIPPET}

      void main() {
        float x = getAAtOutCoords();
        ${glsl.output} = encode_float(x);
      }
    `;
    }
}

});

parcelRegister("a9Naf", function(module, exports) {

$parcel$export(module.exports, "EncodeFloatPackedProgram", () => $7650e1aaeb6744e4$export$97e262e8a4818e2e);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $f7Ffe = parcelRequire("f7Ffe");

var $asYVE = parcelRequire("asYVE");

var $lE6VE = parcelRequire("lE6VE");
class $7650e1aaeb6744e4$export$97e262e8a4818e2e {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = false;
        this.outTexUsage = (0, $lE6VE.TextureUsage).DOWNLOAD;
        const glsl = (0, $f7Ffe.getGlslDifferences)();
        this.outputShape = outputShape;
        this.userCode = `
      ${0, $asYVE.ENCODE_FLOAT_SNIPPET}

      void main() {
        ivec3 coords = getOutputCoords();
        float x = getChannel(getAAtOutCoords(), vec2(coords.y, coords.z));
        ${glsl.output} = encode_float(x);
      }
    `;
    }
}

});

parcelRegister("iwdC3", function(module, exports) {

$parcel$export(module.exports, "EncodeMatrixProgram", () => $d7b5c65cb7f6c388$export$b2e063313033aeab);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $f7Ffe = parcelRequire("f7Ffe");

var $i88bA = parcelRequire("i88bA");

var $asYVE = parcelRequire("asYVE");
class $d7b5c65cb7f6c388$export$b2e063313033aeab {
    constructor(outputShape, inputIsUnsignedByte = false){
        this.variableNames = [
            'A'
        ];
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $f7Ffe.getGlslDifferences)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        let output = `result`;
        if (inputIsUnsignedByte) output = `floor(result * 255. + 0.5)`;
        this.userCode = `
      ${this.enableShapeUniforms ? $asYVE.getFlatIndexFrom3DOutput() : $asYVE.getFlatIndexFrom3D(outputShape)}

      void main() {
        ivec3 coords = getOutputCoords();

        int flatIndex = getFlatIndex(coords);
        int offset = imod(flatIndex, 4);

        flatIndex = idiv(flatIndex, 4, 1.);

        int r = flatIndex / texShape[1];
        int c = imod(flatIndex, texShape[1]);
        vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);
        vec4 values = ${glsl.texture2D}(A, uv);

        float result;

        if(offset == 0) {
          result = values[0];
        } else if(offset == 1) {
          result = values[1];
        } else if(offset == 2) {
          result = values[2];
        } else {
          result = values[3];
        }

        ${glsl.output} = vec4(${output}, 0., 0., 0.);
      }
    `;
    }
}

});

parcelRegister("eoRA9", function(module, exports) {

$parcel$export(module.exports, "EncodeMatrixPackedProgram", () => $a7bcdedac38c7aa9$export$3b3e6b1f67c8c4d5);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $f7Ffe = parcelRequire("f7Ffe");

var $i88bA = parcelRequire("i88bA");

var $asYVE = parcelRequire("asYVE");
class $a7bcdedac38c7aa9$export$3b3e6b1f67c8c4d5 {
    constructor(outputShape, inputIsUnsignedByte = false){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $f7Ffe.getGlslDifferences)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        let mainLoop = '';
        let output = 'result';
        if (inputIsUnsignedByte) output = 'floor(result * 255. + 0.5)';
        for(let row = 0; row <= 1; row++)for(let col = 0; col <= 1; col++){
            const channel = row * 2 + col;
            mainLoop += `
          localCoords = coords;
          if(localCoords[2] + ${col} < ${this.enableShapeUniforms ? 'outShape[2]' : `${outputShape[2]}`}) {
          localCoords[2] += ${col};
          if (localCoords[1] + ${row} < ${this.enableShapeUniforms ? 'outShape[1]' : `${outputShape[1]}`}) {
            localCoords[1] += ${row};

            flatIndex = getFlatIndex(localCoords);
            offset = imod(flatIndex, 4);

            flatIndex = idiv(flatIndex, 4, 1.);

            int r = flatIndex / texShape[1];
            int c = imod(flatIndex, texShape[1]);
            vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);
            values = ${glsl.texture2D}(A, uv);

            if (offset == 0) {
              result[${channel}] = values[0];
            } else if (offset == 1) {
              result[${channel}] = values[1];
            } else if (offset == 2) {
              result[${channel}] = values[2];
            } else {
              result[${channel}] = values[3];
            }
          }
        }
        `;
        }
        this.userCode = `
        ${this.enableShapeUniforms ? $asYVE.getFlatIndexFrom3DOutput() : $asYVE.getFlatIndexFrom3D(outputShape)}

        void main() {
          ivec3 coords = getOutputCoords();

          vec4 result = vec4(0.);
          int flatIndex, r, c, offset;
          ivec3 localCoords;
          vec2 uv;
          vec4 values;

          ${mainLoop}

          ${glsl.output} = ${output};
        }
    `;
    }
}

});

parcelRegister("1i8cx", function(module, exports) {

$parcel$export(module.exports, "GPGPUContext", () => $0f0dd5808917fbdb$export$fa7a74a0ce382ac5);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $wx9lK = parcelRequire("wx9lK");

var $jYI8Q = parcelRequire("jYI8Q");

var $jmm54 = parcelRequire("jmm54");

var $lE6VE = parcelRequire("lE6VE");

var $4rulI = parcelRequire("4rulI");
class $0f0dd5808917fbdb$export$fa7a74a0ce382ac5 {
    constructor(gl){
        this.outputTexture = null;
        this.program = null;
        this.disposed = false;
        this.vertexAttrsAreBound = false;
        this.itemsToPoll = [];
        const glVersion = (0, $aymVi.env)().getNumber('WEBGL_VERSION');
        if (gl != null) {
            this.gl = gl;
            (0, $jYI8Q.setWebGLContext)(glVersion, gl);
        } else this.gl = (0, $jYI8Q.getWebGLContext)(glVersion);
        // WebGL 2.0 enables texture floats without an extension.
        let COLOR_BUFFER_FLOAT = 'WEBGL_color_buffer_float';
        const COLOR_BUFFER_HALF_FLOAT = 'EXT_color_buffer_half_float';
        this.parallelCompilationExtension = this.gl.getExtension('KHR_parallel_shader_compile');
        if ((0, $aymVi.env)().getNumber('WEBGL_VERSION') === 1) {
            const TEXTURE_FLOAT = 'OES_texture_float';
            const TEXTURE_HALF_FLOAT = 'OES_texture_half_float';
            this.textureFloatExtension = $4rulI.getExtensionOrThrow(this.gl, TEXTURE_FLOAT);
            if ($4rulI.hasExtension(this.gl, TEXTURE_HALF_FLOAT)) this.textureHalfFloatExtension = $4rulI.getExtensionOrThrow(this.gl, TEXTURE_HALF_FLOAT);
            else if ((0, $aymVi.env)().get('WEBGL_FORCE_F16_TEXTURES')) throw new Error("GL context does not support half float textures, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
            this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
            if ($4rulI.hasExtension(this.gl, COLOR_BUFFER_HALF_FLOAT)) this.colorBufferHalfFloatExtension = $4rulI.getExtensionOrThrow(this.gl, COLOR_BUFFER_HALF_FLOAT);
            else if ((0, $aymVi.env)().get('WEBGL_FORCE_F16_TEXTURES')) throw new Error("GL context does not support color renderable half floats, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
        } else {
            COLOR_BUFFER_FLOAT = 'EXT_color_buffer_float';
            if ($4rulI.hasExtension(this.gl, COLOR_BUFFER_FLOAT)) this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
            else if ($4rulI.hasExtension(this.gl, COLOR_BUFFER_HALF_FLOAT)) this.colorBufferHalfFloatExtension = this.gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
            else throw new Error('GL context does not support color renderable floats');
        }
        this.vertexBuffer = $jmm54.createVertexBuffer(this.gl);
        this.indexBuffer = $jmm54.createIndexBuffer(this.gl);
        this.framebuffer = $4rulI.createFramebuffer(this.gl);
        this.textureConfig = $lE6VE.getTextureConfig(this.gl, this.textureHalfFloatExtension);
    }
    get debug() {
        return (0, $aymVi.env)().getBool('DEBUG');
    }
    dispose() {
        if (this.disposed) return;
        if (this.program != null) console.warn("Disposing a GPGPUContext that still has a bound WebGLProgram. This is probably a resource leak, delete the program with GPGPUContext.deleteProgram before disposing.");
        if (this.outputTexture != null) console.warn("Disposing a GPGPUContext that still has a bound output matrix texture.  This is probably a resource leak, delete the output matrix texture with GPGPUContext.deleteMatrixTexture before disposing.");
        const gl = this.gl;
        $4rulI.callAndCheck(gl, ()=>gl.finish());
        $4rulI.callAndCheck(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, null));
        $4rulI.callAndCheck(gl, ()=>gl.deleteFramebuffer(this.framebuffer));
        $4rulI.callAndCheck(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, null));
        $4rulI.callAndCheck(gl, ()=>gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null));
        $4rulI.callAndCheck(gl, ()=>gl.deleteBuffer(this.indexBuffer));
        this.disposed = true;
    }
    createFloat32MatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $jmm54.createFloat32MatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
    createFloat16MatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $jmm54.createFloat16MatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
    createUnsignedBytesMatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $jmm54.createUnsignedBytesMatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
    uploadPixelDataToTexture(texture, pixels) {
        this.throwIfDisposed();
        $jmm54.uploadPixelDataToTexture(this.gl, texture, pixels);
    }
    uploadDenseMatrixToTexture(texture, width, height, data) {
        this.throwIfDisposed();
        $jmm54.uploadDenseMatrixToTexture(this.gl, texture, width, height, data, this.textureConfig);
    }
    createFloat16PackedMatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $jmm54.createFloat16PackedMatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
    createPackedMatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $jmm54.createPackedMatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
    deleteMatrixTexture(texture) {
        this.throwIfDisposed();
        if (this.outputTexture === texture) {
            $4rulI.unbindColorTextureFromFramebuffer(this.gl, this.framebuffer);
            this.outputTexture = null;
        }
        $4rulI.callAndCheck(this.gl, ()=>this.gl.deleteTexture(texture));
    }
    downloadByteEncodedFloatMatrixFromOutputTexture(texture, rows, columns) {
        return this.downloadMatrixDriver(texture, ()=>$jmm54.downloadByteEncodedFloatMatrixFromOutputTexture(this.gl, rows, columns, this.textureConfig));
    }
    downloadPackedMatrixFromBuffer(buffer, batch, rows, columns, physicalRows, physicalCols) {
        return $jmm54.downloadPackedMatrixFromBuffer(this.gl, buffer, batch, rows, columns, physicalRows, physicalCols, this.textureConfig);
    }
    downloadFloat32MatrixFromBuffer(buffer, size) {
        return $jmm54.downloadFloat32MatrixFromBuffer(this.gl, buffer, size);
    }
    createBufferFromTexture(texture, rows, columns) {
        this.bindTextureToFrameBuffer(texture);
        const result = $jmm54.createBufferFromOutputTexture(this.gl, rows, columns, this.textureConfig);
        this.unbindTextureToFrameBuffer();
        return result;
    }
    createAndWaitForFence() {
        const fenceContext = this.createFence(this.gl);
        return this.pollFence(fenceContext);
    }
    createFence(gl) {
        let query;
        let isFencePassed;
        if ((0, $aymVi.env)().getBool('WEBGL_FENCE_API_ENABLED')) {
            const gl2 = gl;
            const sync = gl2.fenceSync(gl2.SYNC_GPU_COMMANDS_COMPLETE, 0);
            gl.flush();
            isFencePassed = ()=>{
                const status = gl2.clientWaitSync(sync, 0, 0);
                return status === gl2.ALREADY_SIGNALED || status === gl2.CONDITION_SATISFIED;
            };
            query = sync;
        } else if ((0, $aymVi.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') > 0) {
            query = this.beginQuery();
            this.endQuery();
            isFencePassed = ()=>this.isQueryAvailable(query, (0, $aymVi.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION'));
        } else // If we have no way to fence, return true immediately. This will fire in
        // WebGL 1.0 when there is no disjoint query timer. In this case, because
        // the fence passes immediately, we'll immediately ask for a download of
        // the texture, which will cause the UI thread to hang.
        isFencePassed = ()=>true;
        return {
            query: query,
            isFencePassed: isFencePassed
        };
    }
    downloadMatrixFromPackedTexture(texture, physicalRows, physicalCols) {
        return this.downloadMatrixDriver(texture, ()=>$jmm54.downloadMatrixFromPackedOutputTexture(this.gl, physicalRows, physicalCols));
    }
    createProgram(fragmentShader) {
        this.throwIfDisposed();
        const gl = this.gl;
        if (this.vertexShader == null) this.vertexShader = $jmm54.createVertexShader(gl);
        const program = $4rulI.createProgram(gl);
        $4rulI.callAndCheck(gl, ()=>gl.attachShader(program, this.vertexShader));
        $4rulI.callAndCheck(gl, ()=>gl.attachShader(program, fragmentShader));
        $4rulI.linkProgram(gl, program);
        if (this.debug) $4rulI.validateProgram(gl, program);
        if (!this.vertexAttrsAreBound) {
            this.setProgram(program);
            this.vertexAttrsAreBound = $jmm54.bindVertexProgramAttributeStreams(gl, this.program, this.vertexBuffer);
        }
        return program;
    }
    deleteProgram(program) {
        this.throwIfDisposed();
        if (program === this.program) this.program = null;
        if (program != null) $4rulI.callAndCheck(this.gl, ()=>this.gl.deleteProgram(program));
    }
    setProgram(program) {
        this.throwIfDisposed();
        this.program = program;
        if (this.program != null && this.debug) $4rulI.validateProgram(this.gl, this.program);
        $4rulI.callAndCheck(this.gl, ()=>this.gl.useProgram(program));
    }
    getUniformLocation(program, uniformName, shouldThrow = true) {
        this.throwIfDisposed();
        if (shouldThrow) return $4rulI.getProgramUniformLocationOrThrow(this.gl, program, uniformName);
        else return $4rulI.getProgramUniformLocation(this.gl, program, uniformName);
    }
    getAttributeLocation(program, attribute) {
        this.throwIfDisposed();
        return $4rulI.callAndCheck(this.gl, ()=>this.gl.getAttribLocation(program, attribute));
    }
    getUniformLocationNoThrow(program, uniformName) {
        this.throwIfDisposed();
        return this.gl.getUniformLocation(program, uniformName);
    }
    setInputMatrixTexture(inputMatrixTexture, uniformLocation, textureUnit) {
        this.throwIfDisposed();
        this.throwIfNoProgram();
        $4rulI.bindTextureToProgramUniformSampler(this.gl, inputMatrixTexture, uniformLocation, textureUnit);
    }
    setOutputMatrixTexture(outputMatrixTexture, rows, columns) {
        this.setOutputMatrixTextureDriver(outputMatrixTexture, columns, rows);
    }
    setOutputPackedMatrixTexture(outputPackedMatrixTexture, rows, columns) {
        this.throwIfDisposed();
        const [width, height] = $lE6VE.getPackedMatrixTextureShapeWidthHeight(rows, columns);
        this.setOutputMatrixTextureDriver(outputPackedMatrixTexture, width, height);
    }
    setOutputMatrixWriteRegion(startRow, numRows, startColumn, numColumns) {
        this.setOutputMatrixWriteRegionDriver(startColumn, startRow, numColumns, numRows);
    }
    setOutputPackedMatrixWriteRegion(startRow, numRows, startColumn, numColumns) {
        throw new Error('setOutputPackedMatrixWriteRegion not implemented.');
    }
    debugValidate() {
        if (this.program != null) $4rulI.validateProgram(this.gl, this.program);
        $4rulI.validateFramebuffer(this.gl);
    }
    executeProgram() {
        this.throwIfDisposed();
        this.throwIfNoProgram();
        const gl = this.gl;
        if (this.debug) this.debugValidate();
        $4rulI.callAndCheck(gl, ()=>gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0));
    }
    blockUntilAllProgramsCompleted() {
        this.throwIfDisposed();
        $4rulI.callAndCheck(this.gl, ()=>this.gl.finish());
    }
    getQueryTimerExtension() {
        if (this.disjointQueryTimerExtension == null) this.disjointQueryTimerExtension = $4rulI.getExtensionOrThrow(this.gl, (0, $aymVi.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2 ? 'EXT_disjoint_timer_query_webgl2' : 'EXT_disjoint_timer_query');
        return this.disjointQueryTimerExtension;
    }
    getQueryTimerExtensionWebGL2() {
        return this.getQueryTimerExtension();
    }
    getQueryTimerExtensionWebGL1() {
        return this.getQueryTimerExtension();
    }
    beginQuery() {
        if ((0, $aymVi.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2) {
            const gl2 = this.gl;
            const ext = this.getQueryTimerExtensionWebGL2();
            const query = gl2.createQuery();
            gl2.beginQuery(ext.TIME_ELAPSED_EXT, query);
            return query;
        }
        const ext = this.getQueryTimerExtensionWebGL1();
        const query = ext.createQueryEXT();
        ext.beginQueryEXT(ext.TIME_ELAPSED_EXT, query);
        return query;
    }
    endQuery() {
        if ((0, $aymVi.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2) {
            const gl2 = this.gl;
            const ext = this.getQueryTimerExtensionWebGL2();
            gl2.endQuery(ext.TIME_ELAPSED_EXT);
            return;
        }
        const ext = this.getQueryTimerExtensionWebGL1();
        ext.endQueryEXT(ext.TIME_ELAPSED_EXT);
    }
    async waitForQueryAndGetTime(query) {
        await (0, $wx9lK).repeatedTry(()=>this.disposed || // while testing contexts are created / disposed
            // in rapid succession, so without this check we
            // may poll for the query timer indefinitely
            this.isQueryAvailable(query, (0, $aymVi.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION')));
        return this.getQueryTime(query, (0, $aymVi.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION'));
    }
    getQueryTime(query, queryTimerVersion) {
        if (queryTimerVersion === 0) return null;
        if (queryTimerVersion === 2) {
            const gl2 = this.gl;
            const timeElapsedNanos = gl2.getQueryParameter(query, gl2.QUERY_RESULT);
            // Return milliseconds.
            return timeElapsedNanos / 1000000;
        } else {
            const ext = this.getQueryTimerExtensionWebGL1();
            const timeElapsedNanos = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_EXT);
            // Return milliseconds.
            return timeElapsedNanos / 1000000;
        }
    }
    isQueryAvailable(query, queryTimerVersion) {
        if (queryTimerVersion === 0) return true;
        if (queryTimerVersion === 2) {
            const gl2 = this.gl;
            const ext = this.getQueryTimerExtensionWebGL2();
            const available = gl2.getQueryParameter(query, gl2.QUERY_RESULT_AVAILABLE);
            if (this.disjoint == null) this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
            return available && !this.disjoint;
        } else {
            const ext = this.getQueryTimerExtensionWebGL1();
            const available = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_AVAILABLE_EXT);
            if (this.disjoint == null) this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
            return available && !this.disjoint;
        }
    }
    pollFence(fenceContext) {
        return new Promise((resolve)=>{
            this.addItemToPoll(()=>fenceContext.isFencePassed(), ()=>resolve());
        });
    }
    pollItems() {
        // Find the last query that has finished.
        const index = $0f0dd5808917fbdb$export$4a09b41294052731(this.itemsToPoll.map((x)=>x.isDoneFn));
        for(let i = 0; i <= index; ++i){
            const { resolveFn: resolveFn } = this.itemsToPoll[i];
            resolveFn();
        }
        this.itemsToPoll = this.itemsToPoll.slice(index + 1);
    }
    addItemToPoll(isDoneFn, resolveFn) {
        this.itemsToPoll.push({
            isDoneFn: isDoneFn,
            resolveFn: resolveFn
        });
        if (this.itemsToPoll.length > 1) // We already have a running loop that polls.
        return;
        // Start a new loop that polls.
        let scheduleFn = undefined;
        if ('setTimeoutCustom' in (0, $aymVi.env)().platform) scheduleFn = (0, $aymVi.env)().platform.setTimeoutCustom.bind((0, $aymVi.env)().platform);
        (0, $wx9lK).repeatedTry(()=>{
            this.pollItems();
            // End the loop if no more items to poll.
            return this.itemsToPoll.length === 0;
        }, ()=>0, null, scheduleFn);
    }
    bindTextureToFrameBuffer(texture) {
        this.throwIfDisposed();
        $4rulI.bindColorTextureToFramebuffer(this.gl, texture, this.framebuffer);
        if (this.debug) $4rulI.validateFramebuffer(this.gl);
    }
    unbindTextureToFrameBuffer() {
        if (this.outputTexture != null) {
            $4rulI.bindColorTextureToFramebuffer(this.gl, this.outputTexture, this.framebuffer);
            if (this.debug) $4rulI.validateFramebuffer(this.gl);
        } else $4rulI.unbindColorTextureFromFramebuffer(this.gl, this.framebuffer);
    }
    downloadMatrixDriver(texture, downloadAndDecode) {
        this.bindTextureToFrameBuffer(texture);
        const result = downloadAndDecode();
        this.unbindTextureToFrameBuffer();
        return result;
    }
    setOutputMatrixTextureDriver(outputMatrixTextureMaybePacked, width, height) {
        this.throwIfDisposed();
        const gl = this.gl;
        $4rulI.bindColorTextureToFramebuffer(gl, outputMatrixTextureMaybePacked, this.framebuffer);
        if (this.debug) $4rulI.validateFramebuffer(gl);
        this.outputTexture = outputMatrixTextureMaybePacked;
        $4rulI.callAndCheck(gl, ()=>gl.viewport(0, 0, width, height));
        $4rulI.callAndCheck(gl, ()=>gl.scissor(0, 0, width, height));
    }
    setOutputMatrixWriteRegionDriver(x, y, width, height) {
        this.throwIfDisposed();
        $4rulI.callAndCheck(this.gl, ()=>this.gl.scissor(x, y, width, height));
    }
    throwIfDisposed() {
        if (this.disposed) throw new Error('Attempted to use disposed GPGPUContext.');
    }
    throwIfNoProgram() {
        if (this.program == null) throw new Error('No GPU program is currently set.');
    }
}
function $0f0dd5808917fbdb$export$4a09b41294052731(arr) {
    let i = 0;
    for(; i < arr.length; ++i){
        const isDone = arr[i]();
        if (!isDone) break;
    }
    return i - 1;
}

});
parcelRegister("jmm54", function(module, exports) {

$parcel$export(module.exports, "createVertexShader", () => $e181332d02a4c96f$export$4ca6704ce1875929);
$parcel$export(module.exports, "createVertexBuffer", () => $e181332d02a4c96f$export$8ddd35f9c5bd5634);
$parcel$export(module.exports, "createIndexBuffer", () => $e181332d02a4c96f$export$2be7df49658092d0);
$parcel$export(module.exports, "getInternalFormatForFloat32MatrixTexture", () => $e181332d02a4c96f$export$46e83db9ed4a55ec);
$parcel$export(module.exports, "createFloat32MatrixTexture", () => $e181332d02a4c96f$export$b6545ebc87bceaba);
$parcel$export(module.exports, "getInternalFormatForFloat16MatrixTexture", () => $e181332d02a4c96f$export$c3c5df7eccaed480);
$parcel$export(module.exports, "createFloat16MatrixTexture", () => $e181332d02a4c96f$export$3e231b7a052616c2);
$parcel$export(module.exports, "getInternalFormatForUnsignedBytesMatrixTexture", () => $e181332d02a4c96f$export$ed62004e3546feef);
$parcel$export(module.exports, "createUnsignedBytesMatrixTexture", () => $e181332d02a4c96f$export$23456bef7917c292);
$parcel$export(module.exports, "getInternalFormatForPackedMatrixTexture", () => $e181332d02a4c96f$export$dcae4a9709a9d6);
$parcel$export(module.exports, "createPackedMatrixTexture", () => $e181332d02a4c96f$export$9edab265a05c8d3a);
$parcel$export(module.exports, "getInternalFormatForFloat16PackedMatrixTexture", () => $e181332d02a4c96f$export$9b8d6c2b6b2037b0);
$parcel$export(module.exports, "createFloat16PackedMatrixTexture", () => $e181332d02a4c96f$export$9c51ae7c3160b50c);
$parcel$export(module.exports, "bindVertexProgramAttributeStreams", () => $e181332d02a4c96f$export$9080d84e4e2d38c9);
$parcel$export(module.exports, "uploadDenseMatrixToTexture", () => $e181332d02a4c96f$export$fe948dd2858cae63);
$parcel$export(module.exports, "uploadPixelDataToTexture", () => $e181332d02a4c96f$export$2d42c33b8625a8d7);
$parcel$export(module.exports, "createBufferFromOutputTexture", () => $e181332d02a4c96f$export$2983fc3c819070e9);
$parcel$export(module.exports, "downloadFloat32MatrixFromBuffer", () => $e181332d02a4c96f$export$3d2780ea6b3027ca);
$parcel$export(module.exports, "downloadByteEncodedFloatMatrixFromOutputTexture", () => $e181332d02a4c96f$export$6bc5a1ce24b8dc6c);
$parcel$export(module.exports, "downloadPackedMatrixFromBuffer", () => $e181332d02a4c96f$export$4fe1bc4caaf85c22);
$parcel$export(module.exports, "downloadMatrixFromPackedOutputTexture", () => $e181332d02a4c96f$export$7287c6a301610ce2);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");

var $f7Ffe = parcelRequire("f7Ffe");

var $lE6VE = parcelRequire("lE6VE");

var $4rulI = parcelRequire("4rulI");
function $e181332d02a4c96f$export$4ca6704ce1875929(gl) {
    const glsl = (0, $f7Ffe.getGlslDifferences)();
    const vertexShaderSource = `${glsl.version}
    precision highp float;
    ${glsl.attribute} vec3 clipSpacePos;
    ${glsl.attribute} vec2 uv;
    ${glsl.varyingVs} vec2 resultUV;

    void main() {
      gl_Position = vec4(clipSpacePos, 1);
      resultUV = uv;
    }`;
    return $4rulI.createVertexShader(gl, vertexShaderSource);
}
function $e181332d02a4c96f$export$8ddd35f9c5bd5634(gl) {
    // [x y z u v] * [upper-left, lower-left, upper-right, lower-right]
    const vertexArray = new Float32Array([
        -1,
        1,
        0,
        0,
        1,
        -1,
        -1,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        -1,
        0,
        1,
        0
    ]);
    return $4rulI.createStaticVertexBuffer(gl, vertexArray);
}
function $e181332d02a4c96f$export$2be7df49658092d0(gl) {
    // OpenGL (and WebGL) have "CCW == front" winding
    const triangleVertexIndices = new Uint16Array([
        0,
        1,
        2,
        2,
        1,
        3
    ]);
    return $4rulI.createStaticIndexBuffer(gl, triangleVertexIndices);
}
function $e181332d02a4c96f$var$createAndConfigureTexture(gl, width, height, internalFormat, textureFormat, textureType) {
    $4rulI.validateTextureSize(width, height);
    const texture = $4rulI.createTexture(gl);
    const tex2d = gl.TEXTURE_2D;
    $4rulI.callAndCheck(gl, ()=>gl.bindTexture(tex2d, texture));
    $4rulI.callAndCheck(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE));
    $4rulI.callAndCheck(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE));
    $4rulI.callAndCheck(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_MIN_FILTER, gl.NEAREST));
    $4rulI.callAndCheck(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_MAG_FILTER, gl.NEAREST));
    if ((0, $aymVi.env)().getNumber('WEBGL_VERSION') === 1) $4rulI.callAndCheck(gl, ()=>gl.texImage2D(tex2d, 0, internalFormat, width, height, 0, textureFormat, textureType, null));
    else $4rulI.callAndCheck(gl, ()=>gl.texStorage2D(tex2d, 1, internalFormat, width, height));
    $4rulI.callAndCheck(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
    return {
        texture: texture,
        texShape: [
            height,
            width
        ]
    };
}
function $e181332d02a4c96f$export$46e83db9ed4a55ec(textureConfig) {
    return textureConfig.internalFormatFloat;
}
function $e181332d02a4c96f$export$b6545ebc87bceaba(gl, rows, columns, textureConfig) {
    const [width, height] = $lE6VE.getUnpackedMatrixTextureShapeWidthHeight(rows, columns);
    return $e181332d02a4c96f$var$createAndConfigureTexture(gl, width, height, $e181332d02a4c96f$export$46e83db9ed4a55ec(textureConfig), textureConfig.textureFormatFloat, gl.FLOAT);
}
function $e181332d02a4c96f$export$c3c5df7eccaed480(textureConfig) {
    return textureConfig.internalFormatHalfFloat;
}
function $e181332d02a4c96f$export$3e231b7a052616c2(gl, rows, columns, textureConfig) {
    const [width, height] = $lE6VE.getUnpackedMatrixTextureShapeWidthHeight(rows, columns);
    return $e181332d02a4c96f$var$createAndConfigureTexture(gl, width, height, $e181332d02a4c96f$export$c3c5df7eccaed480(textureConfig), textureConfig.textureFormatFloat, textureConfig.textureTypeHalfFloat);
}
function $e181332d02a4c96f$export$ed62004e3546feef(textureConfig) {
    return textureConfig.downloadTextureFormat;
}
function $e181332d02a4c96f$export$23456bef7917c292(gl, rows, columns, textureConfig) {
    const [width, height] = $lE6VE.getUnpackedMatrixTextureShapeWidthHeight(rows, columns);
    return $e181332d02a4c96f$var$createAndConfigureTexture(gl, width, height, $e181332d02a4c96f$export$ed62004e3546feef(textureConfig), gl.RGBA, gl.UNSIGNED_BYTE);
}
function $e181332d02a4c96f$export$dcae4a9709a9d6(textureConfig) {
    return textureConfig.internalFormatPackedFloat;
}
function $e181332d02a4c96f$export$9edab265a05c8d3a(gl, rows, columns, textureConfig) {
    const [width, height] = $lE6VE.getPackedMatrixTextureShapeWidthHeight(rows, columns);
    return $e181332d02a4c96f$var$createAndConfigureTexture(gl, width, height, $e181332d02a4c96f$export$dcae4a9709a9d6(textureConfig), gl.RGBA, gl.FLOAT);
}
function $e181332d02a4c96f$export$9b8d6c2b6b2037b0(textureConfig) {
    return textureConfig.internalFormatPackedHalfFloat;
}
function $e181332d02a4c96f$export$9c51ae7c3160b50c(gl, rows, columns, textureConfig) {
    const [width, height] = $lE6VE.getPackedMatrixTextureShapeWidthHeight(rows, columns);
    return $e181332d02a4c96f$var$createAndConfigureTexture(gl, width, height, $e181332d02a4c96f$export$9b8d6c2b6b2037b0(textureConfig), gl.RGBA, textureConfig.textureTypeHalfFloat);
}
function $e181332d02a4c96f$export$9080d84e4e2d38c9(gl, program, vertexBuffer) {
    const posOffset = 0; // x is the first buffer element
    const uvOffset = 12; // uv comes after [x y z]
    const stride = 20; // xyz + uv, each entry is 4-byte float.
    $4rulI.callAndCheck(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer));
    const success = $4rulI.bindVertexBufferToProgramAttribute(gl, program, 'clipSpacePos', vertexBuffer, 3, stride, posOffset);
    return success && $4rulI.bindVertexBufferToProgramAttribute(gl, program, 'uv', vertexBuffer, 2, stride, uvOffset);
}
function $e181332d02a4c96f$export$fe948dd2858cae63(gl, texture, width, height, data, textureConfig) {
    $4rulI.callAndCheck(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, texture));
    let dataForUpload, texelDataType, internalFormat;
    if (data instanceof Uint8Array) {
        dataForUpload = new Uint8Array(width * height * 4);
        texelDataType = gl.UNSIGNED_BYTE;
        internalFormat = gl.RGBA;
    } else {
        dataForUpload = new Float32Array(width * height * 4);
        texelDataType = gl.FLOAT;
        internalFormat = textureConfig.internalFormatPackedFloat;
    }
    dataForUpload.set(data);
    if ((0, $aymVi.env)().getNumber('WEBGL_VERSION') === 2) $4rulI.callAndCheck(gl, ()=>gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, width, height, gl.RGBA, texelDataType, dataForUpload));
    else $4rulI.callAndCheck(gl, ()=>gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, width, height, 0, gl.RGBA, texelDataType, dataForUpload));
    $4rulI.callAndCheck(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
}
function $e181332d02a4c96f$export$2d42c33b8625a8d7(gl, texture, pixels) {
    $4rulI.callAndCheck(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, texture));
    if (pixels.data instanceof Uint8Array) {
        if ((0, $aymVi.env)().getNumber('WEBGL_VERSION') === 2) $4rulI.callAndCheck(gl, ()=>gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, pixels.width, pixels.height, gl.RGBA, gl.UNSIGNED_BYTE, pixels.data));
        else $4rulI.callAndCheck(gl, ()=>gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, pixels.width, pixels.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixels.data));
    } else if ((0, $aymVi.env)().getNumber('WEBGL_VERSION') === 2) $4rulI.callAndCheck(gl, ()=>gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixels));
    else $4rulI.callAndCheck(gl, ()=>gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, pixels));
    $4rulI.callAndCheck(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
}
function $e181332d02a4c96f$export$2983fc3c819070e9(gl2, rows, columns, textureConfig) {
    // Create and bind the buffer.
    const buffer = gl2.createBuffer();
    $4rulI.callAndCheck(gl2, ()=>gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer));
    // Initialize the buffer to the size of the texture in bytes.
    const bytesPerFloat = 4;
    const valuesPerTexel = 4;
    const bufferSizeBytes = bytesPerFloat * valuesPerTexel * rows * columns;
    $4rulI.callAndCheck(gl2, ()=>gl2.bufferData(gl2.PIXEL_PACK_BUFFER, bufferSizeBytes, gl2.STREAM_READ));
    // Enqueue a command on the GPU command queue to copy of texture into the
    // buffer.
    $4rulI.callAndCheck(gl2, ()=>gl2.readPixels(0, 0, columns, rows, gl2.RGBA, gl2.FLOAT, 0));
    $4rulI.callAndCheck(gl2, ()=>gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null));
    return buffer;
}
function $e181332d02a4c96f$export$3d2780ea6b3027ca(gl, buffer, size) {
    const gl2 = gl;
    const downloadTarget = new Float32Array(size);
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer);
    gl2.getBufferSubData(gl2.PIXEL_PACK_BUFFER, 0, downloadTarget);
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null);
    return downloadTarget;
}
function $e181332d02a4c96f$export$6bc5a1ce24b8dc6c(gl, rows, columns, textureConfig) {
    const [w, h] = $lE6VE.getUnpackedMatrixTextureShapeWidthHeight(rows, columns);
    const numChannels = 4;
    const downloadTarget = new Uint8Array($lE6VE.getUnpackedArraySizeFromMatrixSize(rows * columns, numChannels));
    $4rulI.callAndCheck(gl, ()=>gl.readPixels(0, 0, w, h, textureConfig.downloadTextureFormat, gl.UNSIGNED_BYTE, downloadTarget));
    // By wrapping the buffer in a Float32Array, we use native browser IEEE 754
    // decoding of the 4 bytes that back each 32 bit float.
    return new Float32Array(downloadTarget.buffer);
}
function $e181332d02a4c96f$export$4fe1bc4caaf85c22(gl, buffer, batch, rows, cols, physicalRows, physicalCols, textureConfig) {
    const gl2 = gl;
    const downloadTarget = new Float32Array($lE6VE.getPackedRGBAArraySizeFromMatrixShape(physicalRows, physicalCols));
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer);
    gl2.getBufferSubData(gl2.PIXEL_PACK_BUFFER, 0, downloadTarget);
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null);
    return downloadTarget;
}
function $e181332d02a4c96f$export$7287c6a301610ce2(gl, physicalRows, physicalCols) {
    const packedRGBA = new Float32Array(physicalRows * physicalCols * 4);
    $4rulI.callAndCheck(gl, ()=>gl.readPixels(0, 0, physicalCols, physicalRows, gl.RGBA, gl.FLOAT, packedRGBA));
    return packedRGBA;
}

});


parcelRegister("fIVdF", function(module, exports) {

$parcel$export(module.exports, "addImplCPU", () => $b72759abecbc7a5a$export$c7f405723b4a93e7);
$parcel$export(module.exports, "bincountImplCPU", () => $b72759abecbc7a5a$export$566def819e5d4601);
$parcel$export(module.exports, "bincountReduceImplCPU", () => $b72759abecbc7a5a$export$447b89266e53682e);
$parcel$export(module.exports, "castImplCPU", () => $b72759abecbc7a5a$export$babf602309dd6292);
$parcel$export(module.exports, "ceilImplCPU", () => $b72759abecbc7a5a$export$bb3ce81256fe261b);
$parcel$export(module.exports, "concatImplCPU", () => $b72759abecbc7a5a$export$95e7342d25849d64);
$parcel$export(module.exports, "equalImplCPU", () => $b72759abecbc7a5a$export$13d1298222b29d06);
$parcel$export(module.exports, "expImplCPU", () => $b72759abecbc7a5a$export$f72e179c9610cb8c);
$parcel$export(module.exports, "expm1ImplCPU", () => $b72759abecbc7a5a$export$5903785c29f035f5);
$parcel$export(module.exports, "floorImplCPU", () => $b72759abecbc7a5a$export$195a28e6add8ab7e);
$parcel$export(module.exports, "gatherNdImplCPU", () => $b72759abecbc7a5a$export$e3196a12dce24214);
$parcel$export(module.exports, "gatherV2ImplCPU", () => $b72759abecbc7a5a$export$cffe0fde89e98de6);
$parcel$export(module.exports, "greaterImplCPU", () => $b72759abecbc7a5a$export$eabb8927944259dd);
$parcel$export(module.exports, "greaterEqualImplCPU", () => $b72759abecbc7a5a$export$a3d2e203d979d298);
$parcel$export(module.exports, "lessImplCPU", () => $b72759abecbc7a5a$export$74c893b3c5e74e60);
$parcel$export(module.exports, "lessEqualImplCPU", () => $b72759abecbc7a5a$export$6d1533a3ea9565f);
$parcel$export(module.exports, "linSpaceImplCPU", () => $b72759abecbc7a5a$export$c86a2be8970d7a7d);
$parcel$export(module.exports, "logImplCPU", () => $b72759abecbc7a5a$export$e88dde64a338f813);
$parcel$export(module.exports, "maxImplCPU", () => $b72759abecbc7a5a$export$a94164c9f637858e);
$parcel$export(module.exports, "maximumImplCPU", () => $b72759abecbc7a5a$export$b3afdc53a543e175);
$parcel$export(module.exports, "minimumImplCPU", () => $b72759abecbc7a5a$export$1f01be3f637863fa);
$parcel$export(module.exports, "multiplyImplCPU", () => $b72759abecbc7a5a$export$598d1d66b05a298f);
$parcel$export(module.exports, "negImplCPU", () => $b72759abecbc7a5a$export$1cbcde7624effb15);
$parcel$export(module.exports, "notEqualImplCPU", () => $b72759abecbc7a5a$export$b91372753635df24);
$parcel$export(module.exports, "prodImplCPU", () => $b72759abecbc7a5a$export$2d654219115cec80);
$parcel$export(module.exports, "raggedGatherImplCPU", () => $b72759abecbc7a5a$export$7cf38d50772f4bbc);
$parcel$export(module.exports, "raggedTensorToTensorImplCPU", () => $b72759abecbc7a5a$export$b3c4ab635ddc431f);
$parcel$export(module.exports, "rangeImplCPU", () => $b72759abecbc7a5a$export$fbee6deed7e76443);
$parcel$export(module.exports, "rsqrtImplCPU", () => $b72759abecbc7a5a$export$431ccb02913a1aee);
$parcel$export(module.exports, "scatterImplCPU", () => $b72759abecbc7a5a$export$2295c910080b5ca7);
$parcel$export(module.exports, "sigmoidImplCPU", () => $b72759abecbc7a5a$export$9b816377c2ca1f1f);
$parcel$export(module.exports, "simpleAbsImplCPU", () => $b72759abecbc7a5a$export$d7efa3585619eabe);
$parcel$export(module.exports, "sliceImplCPU", () => $b72759abecbc7a5a$export$45812d0d8578899);
$parcel$export(module.exports, "sparseFillEmptyRowsImplCPU", () => $b72759abecbc7a5a$export$6cee5fb970d08428);
$parcel$export(module.exports, "sparseReshapeImplCPU", () => $b72759abecbc7a5a$export$d17b3360054ff370);
$parcel$export(module.exports, "sparseSegmentReductionImplCPU", () => $b72759abecbc7a5a$export$a503222c03b33888);
$parcel$export(module.exports, "sqrtImplCPU", () => $b72759abecbc7a5a$export$548a22b20eeaf85b);
$parcel$export(module.exports, "stridedSliceImplCPU", () => $b72759abecbc7a5a$export$efd4e188e5de0188);
$parcel$export(module.exports, "stringNGramsImplCPU", () => $b72759abecbc7a5a$export$bb9e83cb65884ef3);
$parcel$export(module.exports, "stringSplitImplCPU", () => $b72759abecbc7a5a$export$bb4b4a9a1db97dea);
$parcel$export(module.exports, "stringToHashBucketFastImplCPU", () => $b72759abecbc7a5a$export$d7d8a9bba3df6e63);
$parcel$export(module.exports, "subImplCPU", () => $b72759abecbc7a5a$export$be7474e96b733333);
$parcel$export(module.exports, "tileImplCPU", () => $b72759abecbc7a5a$export$349e02a266ab3131);
$parcel$export(module.exports, "topKImplCPU", () => $b72759abecbc7a5a$export$cc4aa6851cf96e2b);
$parcel$export(module.exports, "transposeImplCPU", () => $b72759abecbc7a5a$export$a0105d4a7143676c);
$parcel$export(module.exports, "uniqueImplCPU", () => $b72759abecbc7a5a$export$c417de669ad2e148);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Import shared functionality from tfjs-backend-cpu without triggering
// side effects.
// tslint:disable-next-line: no-imports-from-dist

var $9JZx7 = parcelRequire("9JZx7");
const { addImpl: $b72759abecbc7a5a$export$c7f405723b4a93e7, bincountImpl: $b72759abecbc7a5a$export$566def819e5d4601, bincountReduceImpl: $b72759abecbc7a5a$export$447b89266e53682e, castImpl: $b72759abecbc7a5a$export$babf602309dd6292, ceilImpl: $b72759abecbc7a5a$export$bb3ce81256fe261b, concatImpl: $b72759abecbc7a5a$export$95e7342d25849d64, equalImpl: $b72759abecbc7a5a$export$13d1298222b29d06, expImpl: $b72759abecbc7a5a$export$f72e179c9610cb8c, expm1Impl: $b72759abecbc7a5a$export$5903785c29f035f5, floorImpl: $b72759abecbc7a5a$export$195a28e6add8ab7e, gatherNdImpl: $b72759abecbc7a5a$export$e3196a12dce24214, gatherV2Impl: $b72759abecbc7a5a$export$cffe0fde89e98de6, greaterImpl: $b72759abecbc7a5a$export$eabb8927944259dd, greaterEqualImpl: $b72759abecbc7a5a$export$a3d2e203d979d298, lessImpl: $b72759abecbc7a5a$export$74c893b3c5e74e60, lessEqualImpl: $b72759abecbc7a5a$export$6d1533a3ea9565f, linSpaceImpl: $b72759abecbc7a5a$export$c86a2be8970d7a7d, logImpl: $b72759abecbc7a5a$export$e88dde64a338f813, maxImpl: $b72759abecbc7a5a$export$a94164c9f637858e, maximumImpl: $b72759abecbc7a5a$export$b3afdc53a543e175, minimumImpl: $b72759abecbc7a5a$export$1f01be3f637863fa, multiplyImpl: $b72759abecbc7a5a$export$598d1d66b05a298f, negImpl: $b72759abecbc7a5a$export$1cbcde7624effb15, notEqualImpl: $b72759abecbc7a5a$export$b91372753635df24, prodImpl: $b72759abecbc7a5a$export$2d654219115cec80, raggedGatherImpl: $b72759abecbc7a5a$export$7cf38d50772f4bbc, raggedTensorToTensorImpl: $b72759abecbc7a5a$export$b3c4ab635ddc431f, rangeImpl: $b72759abecbc7a5a$export$fbee6deed7e76443, rsqrtImpl: $b72759abecbc7a5a$export$431ccb02913a1aee, scatterImpl: $b72759abecbc7a5a$export$2295c910080b5ca7, sigmoidImpl: $b72759abecbc7a5a$export$9b816377c2ca1f1f, simpleAbsImpl: $b72759abecbc7a5a$export$d7efa3585619eabe, sliceImpl: $b72759abecbc7a5a$export$45812d0d8578899, sparseFillEmptyRowsImpl: $b72759abecbc7a5a$export$6cee5fb970d08428, sparseReshapeImpl: $b72759abecbc7a5a$export$d17b3360054ff370, sparseSegmentReductionImpl: $b72759abecbc7a5a$export$a503222c03b33888, sqrtImpl: $b72759abecbc7a5a$export$548a22b20eeaf85b, stridedSliceImpl: $b72759abecbc7a5a$export$efd4e188e5de0188, stringNGramsImpl: $b72759abecbc7a5a$export$bb9e83cb65884ef3, stringSplitImpl: $b72759abecbc7a5a$export$bb4b4a9a1db97dea, stringToHashBucketFastImpl: $b72759abecbc7a5a$export$d7d8a9bba3df6e63, subImpl: $b72759abecbc7a5a$export$be7474e96b733333, tileImpl: $b72759abecbc7a5a$export$349e02a266ab3131, topKImpl: $b72759abecbc7a5a$export$cc4aa6851cf96e2b, transposeImpl: $b72759abecbc7a5a$export$a0105d4a7143676c, uniqueImpl: $b72759abecbc7a5a$export$c417de669ad2e148 } = $9JZx7;

});
parcelRegister("9JZx7", function(module, exports) {

$parcel$export(module.exports, "simpleAbsImpl", () => (parcelRequire("Hrrqa")).simpleAbsImpl);
$parcel$export(module.exports, "addImpl", () => (parcelRequire("5Cfhf")).addImpl);
$parcel$export(module.exports, "bincountImpl", () => (parcelRequire("gKVCB")).bincountImpl);
$parcel$export(module.exports, "bincountReduceImpl", () => (parcelRequire("gKVCB")).bincountReduceImpl);
$parcel$export(module.exports, "castImpl", () => (parcelRequire("gSA6r")).castImpl);
$parcel$export(module.exports, "ceilImpl", () => (parcelRequire("aKVzR")).ceilImpl);
$parcel$export(module.exports, "concatImpl", () => (parcelRequire("ku4Up")).concatImpl);
$parcel$export(module.exports, "equalImpl", () => (parcelRequire("2nwON")).equalImpl);
$parcel$export(module.exports, "expImpl", () => (parcelRequire("1DFii")).expImpl);
$parcel$export(module.exports, "expm1Impl", () => (parcelRequire("hyNQ9")).expm1Impl);
$parcel$export(module.exports, "floorImpl", () => (parcelRequire("aWTGU")).floorImpl);
$parcel$export(module.exports, "gatherNdImpl", () => (parcelRequire("2aDKt")).gatherNdImpl);
$parcel$export(module.exports, "gatherV2Impl", () => (parcelRequire("bXTQe")).gatherV2Impl);
$parcel$export(module.exports, "greaterImpl", () => (parcelRequire("3tNXZ")).greaterImpl);
$parcel$export(module.exports, "greaterEqualImpl", () => (parcelRequire("liIvF")).greaterEqualImpl);
$parcel$export(module.exports, "lessImpl", () => (parcelRequire("lDTkj")).lessImpl);
$parcel$export(module.exports, "lessEqualImpl", () => (parcelRequire("4aSq5")).lessEqualImpl);
$parcel$export(module.exports, "linSpaceImpl", () => (parcelRequire("ebjt0")).linSpaceImpl);
$parcel$export(module.exports, "logImpl", () => (parcelRequire("5uPRc")).logImpl);
$parcel$export(module.exports, "maxImpl", () => (parcelRequire("4f6RY")).maxImpl);
$parcel$export(module.exports, "maximumImpl", () => (parcelRequire("3q5fk")).maximumImpl);
$parcel$export(module.exports, "minimumImpl", () => (parcelRequire("4zebw")).minimumImpl);
$parcel$export(module.exports, "multiplyImpl", () => (parcelRequire("h9fuR")).multiplyImpl);
$parcel$export(module.exports, "negImpl", () => (parcelRequire("6Pysf")).negImpl);
$parcel$export(module.exports, "notEqualImpl", () => (parcelRequire("gGCqu")).notEqualImpl);
$parcel$export(module.exports, "prodImpl", () => (parcelRequire("k2KEG")).prodImpl);
$parcel$export(module.exports, "raggedGatherImpl", () => (parcelRequire("4J33f")).raggedGatherImpl);
$parcel$export(module.exports, "raggedTensorToTensorImpl", () => (parcelRequire("as1Mo")).raggedTensorToTensorImpl);
$parcel$export(module.exports, "rangeImpl", () => (parcelRequire("5QeAM")).rangeImpl);
$parcel$export(module.exports, "rsqrtImpl", () => (parcelRequire("1JZ4H")).rsqrtImpl);
$parcel$export(module.exports, "scatterImpl", () => (parcelRequire("89Bm1")).scatterImpl);
$parcel$export(module.exports, "sigmoidImpl", () => (parcelRequire("ZHRjA")).sigmoidImpl);
$parcel$export(module.exports, "sliceImpl", () => (parcelRequire("fyKXa")).sliceImpl);
$parcel$export(module.exports, "sparseFillEmptyRowsImpl", () => (parcelRequire("lMkFK")).sparseFillEmptyRowsImpl);
$parcel$export(module.exports, "sparseReshapeImpl", () => (parcelRequire("j5oV1")).sparseReshapeImpl);
$parcel$export(module.exports, "sparseSegmentReductionImpl", () => (parcelRequire("4Nytd")).sparseSegmentReductionImpl);
$parcel$export(module.exports, "sqrtImpl", () => (parcelRequire("9CCZl")).sqrtImpl);
$parcel$export(module.exports, "squaredDifferenceImpl", () => (parcelRequire("gigoF")).squaredDifferenceImpl);
$parcel$export(module.exports, "stridedSliceImpl", () => (parcelRequire("cDXl8")).stridedSliceImpl);
$parcel$export(module.exports, "stringNGramsImpl", () => (parcelRequire("bYAEr")).stringNGramsImpl);
$parcel$export(module.exports, "stringSplitImpl", () => (parcelRequire("eoFVx")).stringSplitImpl);
$parcel$export(module.exports, "stringToHashBucketFastImpl", () => (parcelRequire("hLQPX")).stringToHashBucketFastImpl);
$parcel$export(module.exports, "subImpl", () => (parcelRequire("gUzQw")).subImpl);
$parcel$export(module.exports, "tileImpl", () => (parcelRequire("jyDpx")).tileImpl);
$parcel$export(module.exports, "topKImpl", () => (parcelRequire("ijnI0")).topKImpl);
$parcel$export(module.exports, "transposeImpl", () => (parcelRequire("4SJWC")).transposeImpl);
$parcel$export(module.exports, "uniqueImpl", () => (parcelRequire("cnCce")).uniqueImpl);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Shared functionality among backends.

var $Hrrqa = parcelRequire("Hrrqa");

var $5Cfhf = parcelRequire("5Cfhf");

var $gKVCB = parcelRequire("gKVCB");

var $gSA6r = parcelRequire("gSA6r");

var $aKVzR = parcelRequire("aKVzR");

var $ku4Up = parcelRequire("ku4Up");

var $2nwON = parcelRequire("2nwON");

var $1DFii = parcelRequire("1DFii");

var $hyNQ9 = parcelRequire("hyNQ9");

var $aWTGU = parcelRequire("aWTGU");

var $2aDKt = parcelRequire("2aDKt");

var $bXTQe = parcelRequire("bXTQe");

var $3tNXZ = parcelRequire("3tNXZ");

var $liIvF = parcelRequire("liIvF");

var $lDTkj = parcelRequire("lDTkj");

var $4aSq5 = parcelRequire("4aSq5");

var $ebjt0 = parcelRequire("ebjt0");

var $5uPRc = parcelRequire("5uPRc");

var $4f6RY = parcelRequire("4f6RY");

var $3q5fk = parcelRequire("3q5fk");

var $4zebw = parcelRequire("4zebw");

var $h9fuR = parcelRequire("h9fuR");

var $6Pysf = parcelRequire("6Pysf");

var $gGCqu = parcelRequire("gGCqu");

var $k2KEG = parcelRequire("k2KEG");

var $4J33f = parcelRequire("4J33f");

var $as1Mo = parcelRequire("as1Mo");

var $5QeAM = parcelRequire("5QeAM");

var $1JZ4H = parcelRequire("1JZ4H");

var $89Bm1 = parcelRequire("89Bm1");

var $ZHRjA = parcelRequire("ZHRjA");

var $fyKXa = parcelRequire("fyKXa");

var $lMkFK = parcelRequire("lMkFK");

var $j5oV1 = parcelRequire("j5oV1");

var $4Nytd = parcelRequire("4Nytd");

var $9CCZl = parcelRequire("9CCZl");

var $gigoF = parcelRequire("gigoF");

var $cDXl8 = parcelRequire("cDXl8");

var $bYAEr = parcelRequire("bYAEr");

var $eoFVx = parcelRequire("eoFVx");

var $hLQPX = parcelRequire("hLQPX");

var $gUzQw = parcelRequire("gUzQw");

var $jyDpx = parcelRequire("jyDpx");

var $ijnI0 = parcelRequire("ijnI0");

var $4SJWC = parcelRequire("4SJWC");

var $cnCce = parcelRequire("cnCce");

});


parcelRegister("6ljdK", function(module, exports) {

$parcel$export(module.exports, "PackProgram", () => $49e39d177a1c8729$export$5ebf74a9a135ce1d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i88bA = parcelRequire("i88bA");

var $2351m = parcelRequire("2351m");

var $7svrP = parcelRequire("7svrP");
class $49e39d177a1c8729$export$5ebf74a9a135ce1d {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        // Only input / output 3D tensors.
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        if (this.rank === 0) this.userCode = `
        void main() {
          setOutput(vec4(getA(), 0., 0., 0.));
        }
      `;
        else {
            const channels = (0, $2351m.getChannels)('rc', this.rank);
            const dtype = (0, $7svrP.getCoordsDataType)(this.rank);
            const outOfBoundsCondition = this.getOutOfBoundsCondition(channels);
            const setup = this.getSetup(channels);
            const output = this.getOutput(channels);
            this.userCode = `
        void main() {
          ${dtype} rc = getOutputCoords();

          if(${outOfBoundsCondition}) {
            setOutput(vec4(0));
          } else {
            ${setup}

            setOutput(vec4(${output}));
          }
        }
      `;
        }
    }
    getSourceCoordsArr(dims) {
        const coords = [];
        for(let row = 0; row <= 1; row++)for(let col = 0; col <= 1; col++){
            let coord = `${row === 0 ? 'r' : 'rp1'}, ${col === 0 ? 'c' : 'cp1'}`;
            for(let d = 2; d < this.rank; d++)coord = `${dims[dims.length - 1 - d]},` + coord;
            coords.push(coord);
        }
        return coords;
    }
    getOutOfBoundsCondition(dims) {
        if (this.rank === 1) return `rc > ${this.enableShapeUniforms ? 'outShape' : this.outputShape[0]}`;
        let cond = '';
        for(let i = this.rank - 2; i < this.rank; i++){
            cond += `${dims[i]} >= ${this.enableShapeUniforms ? `outShape[${i}]` : this.outputShape[i]}`;
            if (i < this.rank - 1) cond += '||';
        }
        return cond;
    }
    getSetup(dims) {
        if (this.rank === 1) return '';
        const innerDims = dims.slice(-2);
        const col = this.enableShapeUniforms ? `outShape[${this.rank} - 1]` : this.outputShape[this.rank - 1];
        const row = this.enableShapeUniforms ? `outShape[${this.rank} - 2]` : this.outputShape[this.rank - 2];
        return `
      int r = ${innerDims[0]};
      int c = ${innerDims[1]};
      int rp1 = r + 1;
      int cp1 = c + 1;

      bool cEdge = cp1 >= ${col};
      bool rEdge = rp1 >= ${row};
    `;
    }
    getOutput(dims) {
        const sourceCoords = this.getSourceCoordsArr(dims);
        if (this.rank === 1) {
            const outShape = this.enableShapeUniforms ? 'outShape' : this.outputShape[0];
            return `getA(rc), (rc + 1 >= ${outShape} ? 0. : getA(rc + 1)), 0, 0`;
        }
        return `getA(${sourceCoords[0]}),
            cEdge ? 0. : getA(${sourceCoords[1]}),
            rEdge ? 0. : getA(${sourceCoords[2]}),
            rEdge || cEdge ? 0. : getA(${sourceCoords[3]})`;
    }
}

});
parcelRegister("2351m", function(module, exports) {

$parcel$export(module.exports, "getVecChannels", () => $17dfc19ec06cfcd1$export$a7c2113d79df2971);
$parcel$export(module.exports, "getChannels", () => $17dfc19ec06cfcd1$export$7a4d1d0d17b69972);
$parcel$export(module.exports, "getSourceCoords", () => $17dfc19ec06cfcd1$export$8f96407d418c6727);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $17dfc19ec06cfcd1$export$a7c2113d79df2971(name, rank) {
    return [
        'x',
        'y',
        'z',
        'w',
        'u',
        'v'
    ].slice(0, rank).map((d)=>`${name}.${d}`);
}
function $17dfc19ec06cfcd1$export$7a4d1d0d17b69972(name, rank) {
    if (rank === 1) return [
        name
    ];
    return $17dfc19ec06cfcd1$export$a7c2113d79df2971(name, rank);
}
function $17dfc19ec06cfcd1$export$8f96407d418c6727(rank, dims) {
    if (rank === 1) return 'rc';
    let coords = '';
    for(let i = 0; i < rank; i++){
        coords += dims[i];
        if (i < rank - 1) coords += ',';
    }
    return coords;
}

});


parcelRegister("48uvZ", function(module, exports) {

$parcel$export(module.exports, "ReshapePackedProgram", () => $302f9466b2849f6c$export$ce249f6fedcc44de);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i88bA = parcelRequire("i88bA");

var $asYVE = parcelRequire("asYVE");
class $302f9466b2849f6c$export$ce249f6fedcc44de {
    constructor(outputShape, inputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'inputShape',
                type: 'ivec3'
            }
        ];
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        let mainLoop = ``;
        for(let i = 0; i < 4; i++){
            let thisRC = `thisRC = rc;`;
            if (i % 2 === 1) thisRC += `thisRC.z += 1;`;
            if (i > 1) thisRC += `thisRC.y += 1;`;
            mainLoop += `
        ${thisRC}
        ${i > 0 ? `if(thisRC.y < rows && thisRC.z < cols){` : ''}
          int flatIndex = getFlatIndex(thisRC);

          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);
          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));

          result[${i}] =
            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);
        ${i > 0 ? '}' : ''}
      `;
        }
        this.userCode = `
      ${$302f9466b2849f6c$var$getReshapedInputCoords(inputShape, this.enableShapeUniforms)}
      ${this.enableShapeUniforms ? $asYVE.getFlatIndexFrom3DOutput() : $asYVE.getFlatIndexFrom3D(outputShape)}

      void main() {
        ivec3 rc = getOutputCoords();

        vec4 result = vec4(0.);

        ivec3 thisRC;
        int rows = ${this.enableShapeUniforms ? 'outShape[1]' : outputShape[1]};
        int cols = ${this.enableShapeUniforms ? 'outShape[2]' : outputShape[2]};

        ${mainLoop}

        setOutput(result);
      }
    `;
    }
}
function $302f9466b2849f6c$var$getReshapedInputCoords(shape, enableShapeUniforms) {
    const coordsFromIndexSnippet = enableShapeUniforms ? $asYVE.getLogicalCoordinatesFromFlatIndexByUniform([
        'r',
        'c',
        'd'
    ], 'inputShape') : $asYVE.getLogicalCoordinatesFromFlatIndex([
        'r',
        'c',
        'd'
    ], shape);
    return `
    ivec3 inputCoordsFromReshapedOutCoords(int index) {
      ${coordsFromIndexSnippet}
      return ivec3(r, c, d);
    }
  `;
}

});

parcelRegister("8doPJ", function(module, exports) {

$parcel$export(module.exports, "TextureManager", () => $5fb2cd07e729f2e1$export$337f59f8fd79d24f);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");

var $jmm54 = parcelRequire("jmm54");

var $lE6VE = parcelRequire("lE6VE");
class $5fb2cd07e729f2e1$export$337f59f8fd79d24f {
    constructor(gpgpu){
        this.gpgpu = gpgpu;
        this.numUsedTextures = 0;
        this.numFreeTextures = 0;
        this._numBytesAllocated = 0;
        this._numBytesFree = 0; // How many bytes that have been allocated
        // are available for reuse.
        this.freeTextures = {};
        this.logEnabled = false;
        this.usedTextures = {};
    }
    acquireTexture(shapeRC, usage, isPacked) {
        const physicalTexType = $5fb2cd07e729f2e1$var$getPhysicalFromLogicalTextureType(usage, isPacked);
        const shapeKey = $5fb2cd07e729f2e1$var$getKeyFromTextureShape(shapeRC, physicalTexType, isPacked);
        if (!(shapeKey in this.freeTextures)) this.freeTextures[shapeKey] = [];
        if (!(shapeKey in this.usedTextures)) this.usedTextures[shapeKey] = [];
        const texBytes = $5fb2cd07e729f2e1$export$66c19e55ce03e099(shapeRC, physicalTexType, this.gpgpu.gl, this.gpgpu.textureConfig, isPacked);
        if (this.freeTextures[shapeKey].length > 0) {
            this.numFreeTextures--;
            this.numUsedTextures++;
            this._numBytesFree -= texBytes;
            this.log();
            const newTexture = this.freeTextures[shapeKey].shift();
            this.usedTextures[shapeKey].push(newTexture);
            return newTexture;
        }
        let newTexture;
        if (physicalTexType === (0, $lE6VE.PhysicalTextureType).PACKED_2X2_FLOAT32) newTexture = this.gpgpu.createPackedMatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $lE6VE.PhysicalTextureType).PACKED_2X2_FLOAT16) newTexture = this.gpgpu.createFloat16PackedMatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $lE6VE.PhysicalTextureType).UNPACKED_FLOAT32) newTexture = this.gpgpu.createFloat32MatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $lE6VE.PhysicalTextureType).UNPACKED_FLOAT16) newTexture = this.gpgpu.createFloat16MatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $lE6VE.PhysicalTextureType).PACKED_4X1_UNSIGNED_BYTE) newTexture = this.gpgpu.createUnsignedBytesMatrixTexture(shapeRC[0], shapeRC[1]);
        this.usedTextures[shapeKey].push(newTexture);
        this.numUsedTextures++;
        this._numBytesAllocated += texBytes;
        this.log();
        return newTexture;
    }
    releaseTexture(texture, shape, logicalTexType, isPacked) {
        if (this.freeTextures == null) // Already disposed.
        return;
        const physicalTexType = $5fb2cd07e729f2e1$var$getPhysicalFromLogicalTextureType(logicalTexType, isPacked);
        const shapeKey = $5fb2cd07e729f2e1$var$getKeyFromTextureShape(shape, physicalTexType, isPacked);
        if (!(shapeKey in this.freeTextures)) this.freeTextures[shapeKey] = [];
        const texBytes = $5fb2cd07e729f2e1$export$66c19e55ce03e099(shape, physicalTexType, this.gpgpu.gl, this.gpgpu.textureConfig, isPacked);
        const deleteTexThreshold = (0, $aymVi.env)().get('WEBGL_DELETE_TEXTURE_THRESHOLD');
        if (deleteTexThreshold !== -1 && this._numBytesAllocated > deleteTexThreshold) {
            this.gpgpu.deleteMatrixTexture(texture.texture);
            this._numBytesAllocated -= texBytes;
        } else {
            this.freeTextures[shapeKey].push(texture);
            this.numFreeTextures++;
            this._numBytesFree += texBytes;
        }
        this.numUsedTextures--;
        const texList = this.usedTextures[shapeKey];
        const texIndex = texList.indexOf(texture);
        if (texIndex < 0) throw new Error("Cannot release a texture that was never provided by this texture manager");
        texList.splice(texIndex, 1);
        this.log();
    }
    log() {
        if (!this.logEnabled) return;
        const total = this.numFreeTextures + this.numUsedTextures;
        console.log('Free/Used', `${this.numFreeTextures} / ${this.numUsedTextures}`, `(${total})`);
        const freeRatio = this._numBytesFree / this._numBytesAllocated;
        console.log(`Bytes allocated: ${this._numBytesAllocated}`);
        console.log(`Bytes unused: ${this._numBytesFree} (${Math.round(100 * freeRatio)}%)`);
    }
    get numBytesAllocated() {
        return this._numBytesAllocated;
    }
    get numBytesFree() {
        return this._numBytesFree;
    }
    getNumUsedTextures() {
        return this.numUsedTextures;
    }
    getNumFreeTextures() {
        return this.numFreeTextures;
    }
    dispose() {
        if (this.freeTextures == null) // Already disposed.
        return;
        for(const texShape in this.freeTextures)this.freeTextures[texShape].forEach((tex)=>{
            this.gpgpu.deleteMatrixTexture(tex.texture);
        });
        for(const texShape in this.usedTextures)this.usedTextures[texShape].forEach((tex)=>{
            this.gpgpu.deleteMatrixTexture(tex.texture);
        });
        this.freeTextures = null;
        this.usedTextures = null;
        this.numUsedTextures = 0;
        this.numFreeTextures = 0;
        this._numBytesAllocated = 0;
        this._numBytesFree = 0;
    }
}
function $5fb2cd07e729f2e1$var$numBytesForInternalFormat(gl, internalFormat) {
    // tslint:disable-next-line:no-any
    const glany = gl;
    if (internalFormat === glany.R32F) return 4;
    else if (internalFormat === glany.R16F) return 2;
    else if (internalFormat === glany.RGBA32F) return 16;
    else if (internalFormat === gl.RGBA) return 16;
    else if (internalFormat === glany.RGBA16F) return 8;
    else if (internalFormat === glany.RGBA8) return 4;
    throw new Error(`Unknown internal format ${internalFormat}`);
}
function $5fb2cd07e729f2e1$export$66c19e55ce03e099(shape, physicalTexType, gl, textureConfig, isPacked) {
    // It is not possible to infer packed status from the texture type because
    // depending on the textureConfig, different  texture types may resolve to the
    // same internal format (e.g. in WebGL1, the internal format for
    // UNPACKED_FLOAT16 textures is gl.RGBA). Therefore we pass in `isPacked`
    // explicitly.
    const internalFormat = $5fb2cd07e729f2e1$var$internalFormatForPhysicalTexType(physicalTexType, textureConfig);
    let numElements;
    if (isPacked) {
        const [packedWidth, packedHeight] = (0, $lE6VE.getPackedMatrixTextureShapeWidthHeight)(shape[0], shape[1]);
        numElements = packedWidth * packedHeight;
    } else {
        const [width, height] = (0, $lE6VE.getUnpackedMatrixTextureShapeWidthHeight)(shape[0], shape[1]);
        numElements = width * height;
    }
    const bytesPerElement = $5fb2cd07e729f2e1$var$numBytesForInternalFormat(gl, internalFormat);
    return numElements * bytesPerElement;
}
function $5fb2cd07e729f2e1$var$internalFormatForPhysicalTexType(physicalTexType, textureConfig) {
    switch(physicalTexType){
        case (0, $lE6VE.PhysicalTextureType).PACKED_2X2_FLOAT32:
            return (0, $jmm54.getInternalFormatForPackedMatrixTexture)(textureConfig);
        case (0, $lE6VE.PhysicalTextureType).PACKED_2X2_FLOAT16:
            return (0, $jmm54.getInternalFormatForFloat16PackedMatrixTexture)(textureConfig);
        case (0, $lE6VE.PhysicalTextureType).UNPACKED_FLOAT32:
            return (0, $jmm54.getInternalFormatForFloat32MatrixTexture)(textureConfig);
        case (0, $lE6VE.PhysicalTextureType).UNPACKED_FLOAT16:
            return (0, $jmm54.getInternalFormatForFloat16MatrixTexture)(textureConfig);
        case (0, $lE6VE.PhysicalTextureType).PACKED_4X1_UNSIGNED_BYTE:
            return (0, $jmm54.getInternalFormatForUnsignedBytesMatrixTexture)(textureConfig);
        default:
            throw new Error(`Unknown physical texture type ${physicalTexType}`);
    }
}
function $5fb2cd07e729f2e1$var$getPhysicalTextureForRendering(isPacked) {
    if ((0, $aymVi.env)().getBool('WEBGL_RENDER_FLOAT32_ENABLED')) {
        if (isPacked) return (0, $lE6VE.PhysicalTextureType).PACKED_2X2_FLOAT32;
        return (0, $lE6VE.PhysicalTextureType).UNPACKED_FLOAT32;
    }
    if (isPacked) return (0, $lE6VE.PhysicalTextureType).PACKED_2X2_FLOAT16;
    return (0, $lE6VE.PhysicalTextureType).UNPACKED_FLOAT16;
}
function $5fb2cd07e729f2e1$var$getPhysicalFromLogicalTextureType(logicalTexType, isPacked) {
    if (logicalTexType === (0, $lE6VE.TextureUsage).UPLOAD) return (0, $lE6VE.PhysicalTextureType).PACKED_2X2_FLOAT32;
    else if (logicalTexType === (0, $lE6VE.TextureUsage).RENDER || logicalTexType == null) return $5fb2cd07e729f2e1$var$getPhysicalTextureForRendering(isPacked);
    else if (logicalTexType === (0, $lE6VE.TextureUsage).DOWNLOAD || logicalTexType === (0, $lE6VE.TextureUsage).PIXELS) return (0, $lE6VE.PhysicalTextureType).PACKED_4X1_UNSIGNED_BYTE;
    throw new Error(`Unknown logical texture type ${logicalTexType}`);
}
function $5fb2cd07e729f2e1$var$getKeyFromTextureShape(shapeRowsCol, physicalTexType, isPacked) {
    return `${shapeRowsCol[0]}_${shapeRowsCol[1]}_${physicalTexType}_${isPacked}`;
}

});

parcelRegister("2sCkP", function(module, exports) {

$parcel$export(module.exports, "UnaryOpProgram", () => $1cabeece189affb1$export$f93811a5a466fd42);
$parcel$export(module.exports, "CHECK_NAN_SNIPPET", () => $1cabeece189affb1$export$39f0cca2b63399f6);
$parcel$export(module.exports, "LINEAR", () => $1cabeece189affb1$export$8244104593af74a6);
$parcel$export(module.exports, "ABS", () => $1cabeece189affb1$export$3f020f6dcff67a1b);
$parcel$export(module.exports, "ELU", () => $1cabeece189affb1$export$945a5ccf96adb3b2);
$parcel$export(module.exports, "RELU", () => $1cabeece189affb1$export$27041fe53e1ee6da);
$parcel$export(module.exports, "RELU6", () => $1cabeece189affb1$export$94bf29e9c85fc840);
$parcel$export(module.exports, "CLONE", () => $1cabeece189affb1$export$c07b68c109124fe2);
$parcel$export(module.exports, "SIGMOID", () => $1cabeece189affb1$export$f95dbffd98d0457a);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i88bA = parcelRequire("i88bA");
class $1cabeece189affb1$export$f93811a5a466fd42 {
    constructor(aShape, opSnippet){
        this.variableNames = [
            'A'
        ];
        this.outputShape = aShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        this.userCode = `
      float unaryOperation(float x) {
        ${opSnippet}
      }

      void main() {
        float x = getAAtOutCoords();
        float y = unaryOperation(x);

        setOutput(y);
      }
    `;
    }
}
const $1cabeece189affb1$export$39f0cca2b63399f6 = `if (isnan(x)) return x;`;
const $1cabeece189affb1$export$8244104593af74a6 = `return x;`;
const $1cabeece189affb1$export$3f020f6dcff67a1b = `return abs(x);`;
function $1cabeece189affb1$export$8a2ed3f7f077984e(alpha = 0.0) {
    return $1cabeece189affb1$export$39f0cca2b63399f6 + `
    return x > 0.0 ? 1.0 : float(${alpha});
  `;
}
const $1cabeece189affb1$export$945a5ccf96adb3b2 = `return (x >= 0.0) ? x : (exp(x) - 1.0);`;
const $1cabeece189affb1$export$27041fe53e1ee6da = $1cabeece189affb1$export$39f0cca2b63399f6 + `
  return (x < 0.0) ? 0.0 : x;
`;
const $1cabeece189affb1$export$94bf29e9c85fc840 = $1cabeece189affb1$export$39f0cca2b63399f6 + `
  return (x < 0.0) ? 0.0 : min(6.0, x);
`;
const $1cabeece189affb1$export$c07b68c109124fe2 = 'return x;';
const $1cabeece189affb1$export$f95dbffd98d0457a = `return 1.0 / (1.0 + exp(-1.0 * x));`;

});

parcelRegister("2RjWv", function(module, exports) {

$parcel$export(module.exports, "LINEAR", () => $2150003209fb1238$export$8244104593af74a6);
$parcel$export(module.exports, "ELU", () => $2150003209fb1238$export$945a5ccf96adb3b2);
$parcel$export(module.exports, "RELU", () => $2150003209fb1238$export$27041fe53e1ee6da);
$parcel$export(module.exports, "RELU6", () => $2150003209fb1238$export$94bf29e9c85fc840);
$parcel$export(module.exports, "SIGMOID", () => $2150003209fb1238$export$f95dbffd98d0457a);
$parcel$export(module.exports, "UnaryOpPackedProgram", () => $2150003209fb1238$export$4d8daca4f85ed73d);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i88bA = parcelRequire("i88bA");
const $2150003209fb1238$export$8244104593af74a6 = `return x;`;
const $2150003209fb1238$export$945a5ccf96adb3b2 = `
  vec4 result;

  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);
  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);
  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);
  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);

  return result;
`;
const $2150003209fb1238$export$27041fe53e1ee6da = `
  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $2150003209fb1238$export$94bf29e9c85fc840 = `
  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $2150003209fb1238$export$f95dbffd98d0457a = `return 1.0 / (1.0 + exp(-1.0 * x));`;
class $2150003209fb1238$export$4d8daca4f85ed73d {
    constructor(aShape, opSnippet){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = aShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        this.userCode = `
      vec4 unaryOperation(vec4 x) {
        ${opSnippet}
      }

      void main() {
        vec4 x = getAAtOutCoords();
        vec4 y = unaryOperation(x);

        setOutput(y);
      }
    `;
    }
}

});

parcelRegister("QPOIZ", function(module, exports) {

$parcel$export(module.exports, "UnpackProgram", () => $09ed0d3f9230548f$export$c457dd67217cb5eb);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i88bA = parcelRequire("i88bA");

var $2351m = parcelRequire("2351m");

var $7svrP = parcelRequire("7svrP");
class $09ed0d3f9230548f$export$c457dd67217cb5eb {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = false;
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        const rank = outputShape.length;
        const channels = (0, $2351m.getChannels)('rc', rank);
        const dtype = (0, $7svrP.getCoordsDataType)(rank);
        const sourceCoords = (0, $2351m.getSourceCoords)(rank, channels);
        const innerDims = channels.slice(-2);
        const coords = rank <= 1 ? 'rc' : `vec2(${innerDims.join(',')})`;
        this.userCode = `
      void main() {
        ${dtype} rc = getOutputCoords();
        vec4 packedInput = getA(${sourceCoords});

        setOutput(getChannel(packedInput, ${coords}));
      }
    `;
    }
}

});


parcelRegister("kdLMe", function(module, exports) {

$parcel$export(module.exports, "version", () => $eb8a15072e6e9a01$export$83d89fbfd8236492);
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $eb8a15072e6e9a01$export$83d89fbfd8236492 = '3.21.0';

});

parcelRegister("fT52R", function(module, exports) {

$parcel$export(module.exports, "forceHalfFloat", () => $b90fe7ee7b4e20e6$export$3f638ed94e6c5baa);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");





function $b90fe7ee7b4e20e6$export$3f638ed94e6c5baa() {
    (0, $aymVi.env)().set('WEBGL_FORCE_F16_TEXTURES', true);
}

});


parcelRegister("Arnwk", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $kaJSw = parcelRequire("kaJSw");

var $ewN9L = parcelRequire("ewN9L");

var $4PmUs = parcelRequire("4PmUs");

var $bbqWe = parcelRequire("bbqWe");

var $jCriu = parcelRequire("jCriu");

var $7Cev2 = parcelRequire("7Cev2");

var $lVoNH = parcelRequire("lVoNH");

var $eKIRi = parcelRequire("eKIRi");

var $a4ODc = parcelRequire("a4ODc");

var $gqBLo = parcelRequire("gqBLo");

var $bI2qd = parcelRequire("bI2qd");

var $7v0dT = parcelRequire("7v0dT");

var $k4iSM = parcelRequire("k4iSM");

var $9MT8i = parcelRequire("9MT8i");

var $6opwh = parcelRequire("6opwh");

var $keEiO = parcelRequire("keEiO");

var $5L8mC = parcelRequire("5L8mC");

var $7LLgD = parcelRequire("7LLgD");

var $6QKGO = parcelRequire("6QKGO");

var $jSyv2 = parcelRequire("jSyv2");

var $6xZz2 = parcelRequire("6xZz2");

var $fCB5Q = parcelRequire("fCB5Q");

var $8fAez = parcelRequire("8fAez");

var $1zuvT = parcelRequire("1zuvT");

var $caYPG = parcelRequire("caYPG");

var $3kRxy = parcelRequire("3kRxy");

var $hUZPk = parcelRequire("hUZPk");

var $2CZf9 = parcelRequire("2CZf9");

var $3GoRo = parcelRequire("3GoRo");

var $6dlLT = parcelRequire("6dlLT");

var $k5Is6 = parcelRequire("k5Is6");

var $4IWIa = parcelRequire("4IWIa");

var $4Up8q = parcelRequire("4Up8q");

var $x4CZq = parcelRequire("x4CZq");

var $5YHui = parcelRequire("5YHui");

var $1fu2C = parcelRequire("1fu2C");

var $dzXYH = parcelRequire("dzXYH");

var $gYwzT = parcelRequire("gYwzT");

var $ffhHr = parcelRequire("ffhHr");

var $dCV7c = parcelRequire("dCV7c");

var $am6Ok = parcelRequire("am6Ok");

var $jq0Fn = parcelRequire("jq0Fn");

var $fiqgU = parcelRequire("fiqgU");

var $5c0Ik = parcelRequire("5c0Ik");

var $dl01A = parcelRequire("dl01A");

var $1KKc6 = parcelRequire("1KKc6");

var $3PCmF = parcelRequire("3PCmF");

var $eV0Th = parcelRequire("eV0Th");

var $9rEKP = parcelRequire("9rEKP");

var $iQYlA = parcelRequire("iQYlA");

var $75A1N = parcelRequire("75A1N");

var $cYGyJ = parcelRequire("cYGyJ");

var $7NcYQ = parcelRequire("7NcYQ");

var $85jqi = parcelRequire("85jqi");

var $5Byii = parcelRequire("5Byii");

var $cFwC0 = parcelRequire("cFwC0");

var $924kU = parcelRequire("924kU");

var $e4obH = parcelRequire("e4obH");

var $hOLpE = parcelRequire("hOLpE");

var $leJGm = parcelRequire("leJGm");

var $Tu8Z2 = parcelRequire("Tu8Z2");

var $alLlV = parcelRequire("alLlV");

var $gUFoD = parcelRequire("gUFoD");

var $aEWcT = parcelRequire("aEWcT");

var $1EinK = parcelRequire("1EinK");

var $1DTVB = parcelRequire("1DTVB");

var $8uyHu = parcelRequire("8uyHu");

var $jaeXb = parcelRequire("jaeXb");

var $h0dxl = parcelRequire("h0dxl");

var $fAHbJ = parcelRequire("fAHbJ");

var $1F6W7 = parcelRequire("1F6W7");

var $j8iVA = parcelRequire("j8iVA");

var $gppXN = parcelRequire("gppXN");

var $fuljV = parcelRequire("fuljV");

var $ksGNf = parcelRequire("ksGNf");

var $1UrOK = parcelRequire("1UrOK");

var $lNGGi = parcelRequire("lNGGi");

var $aRtJv = parcelRequire("aRtJv");

var $epJ7u = parcelRequire("epJ7u");

var $b9JOX = parcelRequire("b9JOX");

var $4eX36 = parcelRequire("4eX36");

var $eqj8a = parcelRequire("eqj8a");

var $fqfCD = parcelRequire("fqfCD");

var $brOEW = parcelRequire("brOEW");

var $lWVrs = parcelRequire("lWVrs");

var $fWlRS = parcelRequire("fWlRS");

var $a1jCN = parcelRequire("a1jCN");

var $cv7S0 = parcelRequire("cv7S0");

var $jG0Fa = parcelRequire("jG0Fa");

var $hLK7Y = parcelRequire("hLK7Y");

var $cBf2m = parcelRequire("cBf2m");

var $besyT = parcelRequire("besyT");

var $eBDOT = parcelRequire("eBDOT");

var $2JGHe = parcelRequire("2JGHe");

var $9OOuP = parcelRequire("9OOuP");

var $f1ibJ = parcelRequire("f1ibJ");

var $6HGp5 = parcelRequire("6HGp5");

var $6KFwE = parcelRequire("6KFwE");

var $zu6y2 = parcelRequire("zu6y2");

var $5hV6I = parcelRequire("5hV6I");

var $apetE = parcelRequire("apetE");

var $hqSlq = parcelRequire("hqSlq");

var $eTC0B = parcelRequire("eTC0B");

var $87Hah = parcelRequire("87Hah");

var $b03VH = parcelRequire("b03VH");

var $6eZ89 = parcelRequire("6eZ89");

var $7QjhI = parcelRequire("7QjhI");

var $kNvvR = parcelRequire("kNvvR");

var $2skRq = parcelRequire("2skRq");

var $hP3m7 = parcelRequire("hP3m7");

var $aDlCL = parcelRequire("aDlCL");

var $k3HfJ = parcelRequire("k3HfJ");

var $h5jLz = parcelRequire("h5jLz");

var $gcS3b = parcelRequire("gcS3b");

var $hiwUp = parcelRequire("hiwUp");

var $7H3BA = parcelRequire("7H3BA");

var $9JmCz = parcelRequire("9JmCz");

var $aA9Uc = parcelRequire("aA9Uc");

var $5CN1a = parcelRequire("5CN1a");

var $8z3BW = parcelRequire("8z3BW");

var $9gI7w = parcelRequire("9gI7w");

var $8MYqv = parcelRequire("8MYqv");

var $k7Maw = parcelRequire("k7Maw");

var $2lU4p = parcelRequire("2lU4p");

var $dO1OD = parcelRequire("dO1OD");

var $8lMqM = parcelRequire("8lMqM");

var $1gTcY = parcelRequire("1gTcY");

var $bzpEI = parcelRequire("bzpEI");

var $ceFbd = parcelRequire("ceFbd");

var $1EamF = parcelRequire("1EamF");

var $5d1ZL = parcelRequire("5d1ZL");

var $cDGzo = parcelRequire("cDGzo");

var $dI8QC = parcelRequire("dI8QC");

var $iaFFN = parcelRequire("iaFFN");

var $5TazQ = parcelRequire("5TazQ");

var $iv65B = parcelRequire("iv65B");

var $uIBXw = parcelRequire("uIBXw");

var $agNmS = parcelRequire("agNmS");

var $jd3Mu = parcelRequire("jd3Mu");

var $3Ldmc = parcelRequire("3Ldmc");

var $721fl = parcelRequire("721fl");

var $erKnV = parcelRequire("erKnV");

var $jGLww = parcelRequire("jGLww");

var $fSUZr = parcelRequire("fSUZr");

var $hG3uK = parcelRequire("hG3uK");

var $aww4b = parcelRequire("aww4b");

var $x6OHK = parcelRequire("x6OHK");

var $hwc4z = parcelRequire("hwc4z");

var $dMzPN = parcelRequire("dMzPN");

var $dY7vX = parcelRequire("dY7vX");

var $8u4CC = parcelRequire("8u4CC");

var $kFKju = parcelRequire("kFKju");

var $jIJUC = parcelRequire("jIJUC");

var $3bryn = parcelRequire("3bryn");

var $2tEax = parcelRequire("2tEax");

var $cxLue = parcelRequire("cxLue");

var $jS2yk = parcelRequire("jS2yk");

var $2qgzi = parcelRequire("2qgzi");

var $64sK6 = parcelRequire("64sK6");

var $hcuAt = parcelRequire("hcuAt");

var $9mIku = parcelRequire("9mIku");

var $1ylbW = parcelRequire("1ylbW");

var $lHu0m = parcelRequire("lHu0m");

var $ajP4f = parcelRequire("ajP4f");

var $4vA0p = parcelRequire("4vA0p");

var $baTE7 = parcelRequire("baTE7");

var $g2t6I = parcelRequire("g2t6I");
// List all kernel configs here
const $06d899adf615eb9a$var$kernelConfigs = [
    (0, $ewN9L._fusedMatMulConfig),
    (0, $4PmUs.absConfig),
    (0, $bbqWe.acosConfig),
    (0, $jCriu.acoshConfig),
    (0, $7Cev2.addConfig),
    (0, $lVoNH.addNConfig),
    (0, $eKIRi.allConfig),
    (0, $a4ODc.anyConfig),
    (0, $gqBLo.argMaxConfig),
    (0, $bI2qd.argMinConfig),
    (0, $7v0dT.asinConfig),
    (0, $k4iSM.asinhConfig),
    (0, $9MT8i.atanConfig),
    (0, $6opwh.atan2Config),
    (0, $keEiO.atanhConfig),
    (0, $5L8mC.avgPoolConfig),
    (0, $7LLgD.avgPool3DConfig),
    (0, $6QKGO.avgPool3DGradConfig),
    (0, $jSyv2.avgPoolGradConfig),
    (0, $6xZz2.batchMatMulConfig),
    (0, $fCB5Q.batchNormConfig),
    (0, $8fAez.batchToSpaceNDConfig),
    (0, $1zuvT.bincountConfig),
    (0, $caYPG.broadcastArgsConfig),
    (0, $3kRxy.castConfig),
    (0, $hUZPk.ceilConfig),
    (0, $2CZf9.clipByValueConfig),
    (0, $3GoRo.complexConfig),
    (0, $6dlLT.complexAbsConfig),
    (0, $k5Is6.concatConfig),
    (0, $4IWIa.conv2DConfig),
    (0, $4Up8q.conv2DBackpropFilterConfig),
    (0, $x4CZq.conv2DBackpropInputConfig),
    (0, $5YHui.conv3DConfig),
    (0, $1fu2C.conv3DBackpropFilterV2Config),
    (0, $dzXYH.conv3DBackpropInputConfig),
    (0, $gYwzT.cosConfig),
    (0, $ffhHr.coshConfig),
    (0, $dCV7c.cropAndResizeConfig),
    (0, $am6Ok.cumprodConfig),
    (0, $jq0Fn.cumsumConfig),
    (0, $fiqgU.denseBincountConfig),
    (0, $5c0Ik.depthToSpaceConfig),
    (0, $dl01A.depthwiseConv2dNativeConfig),
    (0, $1KKc6.depthwiseConv2dNativeBackpropFilterConfig),
    (0, $3PCmF.depthwiseConv2dNativeBackpropInputConfig),
    (0, $eV0Th.diagConfig),
    (0, $9rEKP.dilation2DConfig),
    (0, $iQYlA.einsumConfig),
    (0, $75A1N.eluConfig),
    (0, $cYGyJ.eluGradConfig),
    (0, $7NcYQ.equalConfig),
    (0, $85jqi.erfConfig),
    (0, $5Byii.expConfig),
    (0, $cFwC0.expandDimsConfig),
    (0, $924kU.expm1Config),
    (0, $e4obH.fftConfig),
    (0, $hOLpE.fillConfig),
    (0, $leJGm.flipLeftRightConfig),
    (0, $Tu8Z2.floorConfig),
    (0, $alLlV.floorDivConfig),
    (0, $gUFoD.fromPixelsConfig),
    (0, $aEWcT.fusedConv2DConfig),
    (0, $1EinK.fusedDepthwiseConv2DConfig),
    (0, $1DTVB.gatherNdConfig),
    (0, $8uyHu.gatherV2Config),
    (0, $jaeXb.greaterConfig),
    (0, $h0dxl.greaterEqualConfig),
    (0, $fAHbJ.identityConfig),
    (0, $1F6W7.ifftConfig),
    (0, $j8iVA.imagConfig),
    (0, $gppXN.isFiniteConfig),
    (0, $fuljV.isInfConfig),
    (0, $ksGNf.isNaNConfig),
    (0, $1UrOK.leakyReluConfig),
    (0, $lNGGi.lessConfig),
    (0, $aRtJv.lessEqualConfig),
    (0, $epJ7u.linSpaceConfig),
    (0, $b9JOX.logConfig),
    (0, $4eX36.log1pConfig),
    (0, $eqj8a.logicalAndConfig),
    (0, $fqfCD.logicalNotConfig),
    (0, $brOEW.logicalOrConfig),
    (0, $lWVrs.LRNConfig),
    (0, $fWlRS.LRNGradConfig),
    (0, $a1jCN.maxConfig),
    (0, $cv7S0.maximumConfig),
    (0, $jG0Fa.maxPoolConfig),
    (0, $hLK7Y.maxPool3DConfig),
    (0, $cBf2m.maxPool3DGradConfig),
    (0, $besyT.maxPoolGradConfig),
    (0, $eBDOT.maxPoolWithArgmaxConfig),
    (0, $2JGHe.meanConfig),
    (0, $9OOuP.minConfig),
    (0, $f1ibJ.minimumConfig),
    (0, $6HGp5.mirrorPadConfig),
    (0, $6KFwE.modConfig),
    (0, $zu6y2.multinomialConfig),
    (0, $5hV6I.multiplyConfig),
    (0, $apetE.negConfig),
    (0, $hqSlq.nonMaxSuppressionV3Config),
    (0, $eTC0B.nonMaxSuppressionV4Config),
    (0, $87Hah.nonMaxSuppressionV5Config),
    (0, $b03VH.notEqualConfig),
    (0, $6eZ89.oneHotConfig),
    (0, $7QjhI.onesLikeConfig),
    (0, $kNvvR.packConfig),
    (0, $2skRq.padV2Config),
    (0, $hP3m7.powConfig),
    (0, $aDlCL.preluConfig),
    (0, $k3HfJ.prodConfig),
    (0, $h5jLz.raggedGatherConfig),
    (0, $gcS3b.raggedTensorToTensorConfig),
    (0, $hiwUp.rangeConfig),
    (0, $7H3BA.realConfig),
    (0, $9JmCz.realDivConfig),
    (0, $aA9Uc.reciprocalConfig),
    (0, $5CN1a.reluConfig),
    (0, $8z3BW.relu6Config),
    (0, $9gI7w.reshapeConfig),
    (0, $8MYqv.resizeBilinearConfig),
    (0, $k7Maw.resizeBilinearGradConfig),
    (0, $2lU4p.resizeNearestNeighborConfig),
    (0, $dO1OD.resizeNearestNeighborGradConfig),
    (0, $8lMqM.reverseConfig),
    (0, $1gTcY.rotateWithOffsetConfig),
    (0, $bzpEI.roundConfig),
    (0, $ceFbd.rsqrtConfig),
    (0, $1EamF.scatterNdConfig),
    (0, $5d1ZL.searchSortedConfig),
    (0, $cDGzo.selectConfig),
    (0, $dI8QC.seluConfig),
    (0, $iaFFN.sigmoidConfig),
    (0, $5TazQ.signConfig),
    (0, $iv65B.sinConfig),
    (0, $uIBXw.sinhConfig),
    (0, $agNmS.sliceConfig),
    (0, $jd3Mu.softmaxConfig),
    (0, $3Ldmc.softplusConfig),
    (0, $721fl.spaceToBatchNDConfig),
    (0, $erKnV.sparseFillEmptyRowsConfig),
    (0, $jGLww.sparseReshapeConfig),
    (0, $fSUZr.sparseSegmentMeanConfig),
    (0, $hG3uK.sparseSegmentSumConfig),
    (0, $aww4b.sparseToDenseConfig),
    (0, $x6OHK.splitVConfig),
    (0, $hwc4z.sqrtConfig),
    (0, $dMzPN.squareConfig),
    (0, $dY7vX.squaredDifferenceConfig),
    (0, $8u4CC.stepConfig),
    (0, $kFKju.stridedSliceConfig),
    (0, $jIJUC.stringNGramsConfig),
    (0, $3bryn.stringSplitConfig),
    (0, $2tEax.stringToHashBucketFastConfig),
    (0, $cxLue.subConfig),
    (0, $jS2yk.sumConfig),
    (0, $2qgzi.tanConfig),
    (0, $64sK6.tanhConfig),
    (0, $hcuAt.tileConfig),
    (0, $9mIku.topKConfig),
    (0, $1ylbW.transformConfig),
    (0, $lHu0m.transposeConfig),
    (0, $ajP4f.uniqueConfig),
    (0, $4vA0p.unpackConfig),
    (0, $baTE7.unsortedSegmentSumConfig),
    (0, $g2t6I.zerosLikeConfig)
];
for (const kernelConfig of $06d899adf615eb9a$var$kernelConfigs)(0, $kaJSw.registerKernel)(kernelConfig);

});
parcelRegister("ewN9L", function(module, exports) {

$parcel$export(module.exports, "_fusedMatMulConfig", () => $a93a2f4b1e48f25a$export$f70d36da1c218f84);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $bxbCN = parcelRequire("bxbCN");
function $a93a2f4b1e48f25a$export$d86ca0bbe0236889(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { transposeA: transposeA, transposeB: transposeB, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    return (0, $bxbCN.batchMatMulImpl)({
        a: a,
        b: b,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend,
        bias: bias,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha,
        activation: activation
    });
}
const $a93a2f4b1e48f25a$export$f70d36da1c218f84 = {
    kernelName: (0, $dCP8m._FusedMatMul),
    backendName: 'webgl',
    kernelFunc: $a93a2f4b1e48f25a$export$d86ca0bbe0236889
};

});
parcelRegister("bxbCN", function(module, exports) {

$parcel$export(module.exports, "MATMUL_SHARED_DIM_THRESHOLD", () => $865bcb3c098ec510$export$42c1ddb439199e73);
$parcel$export(module.exports, "batchMatMulImpl", () => $865bcb3c098ec510$export$d524d65e88e1168b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $eqTIO = parcelRequire("eqTIO");
var $bnEYl = parcelRequire("bnEYl");
var $wx9lK = parcelRequire("wx9lK");

var $eWZon = parcelRequire("eWZon");

var $HxxM1 = parcelRequire("HxxM1");

var $5hV6I = parcelRequire("5hV6I");

var $9gI7w = parcelRequire("9gI7w");

var $jS2yk = parcelRequire("jS2yk");

var $lHu0m = parcelRequire("lHu0m");
const $865bcb3c098ec510$export$42c1ddb439199e73 = 1000;
function $865bcb3c098ec510$export$d524d65e88e1168b({ a: a, b: b, transposeA: transposeA, transposeB: transposeB, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    const aRank = a.shape.length;
    const bRank = b.shape.length;
    const innerShapeA = transposeA ? a.shape[aRank - 2] : a.shape[aRank - 1];
    const innerShapeB = transposeB ? b.shape[bRank - 1] : b.shape[bRank - 2];
    const outerShapeA = transposeA ? a.shape[aRank - 1] : a.shape[aRank - 2];
    const outerShapeB = transposeB ? b.shape[bRank - 2] : b.shape[bRank - 1];
    const outerDimsA = a.shape.slice(0, -2);
    const outerDimsB = b.shape.slice(0, -2);
    const batchDimA = (0, $wx9lK).sizeFromShape(outerDimsA);
    const batchDimB = (0, $wx9lK).sizeFromShape(outerDimsB);
    const outShapeOuterDims = (0, $eqTIO).assertAndGetBroadcastShape(a.shape.slice(0, -2), b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    (0, $wx9lK).assert(innerShapeA === innerShapeB, ()=>`Error in matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${a.shape} and ` + `${b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const a3dShape = transposeA ? [
        batchDimA,
        innerShapeA,
        outerShapeA
    ] : [
        batchDimA,
        outerShapeA,
        innerShapeA
    ];
    const b3dShape = transposeB ? [
        batchDimB,
        outerShapeB,
        innerShapeB
    ] : [
        batchDimB,
        innerShapeB,
        outerShapeB
    ];
    // The rest of the implementation is designed to operate on rank-3 tensors
    const a3d = (0, $9gI7w.reshape)({
        inputs: {
            x: a
        },
        backend: backend,
        attrs: {
            shape: a3dShape
        }
    });
    const b3d = (0, $9gI7w.reshape)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            shape: b3dShape
        }
    });
    const intermediates = [
        a3d,
        b3d
    ];
    const batchDim = Math.max(batchDimA, batchDimB);
    const sharedDim = transposeA ? a3d.shape[1] : a3d.shape[2];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    const fusedActivation = activation != null ? (0, $eWZon.mapActivationToShaderProgram)(activation, true) : null;
    const containsFusedOps = hasBias || hasPreluActivationWeights || hasLeakyreluAlpha || fusedActivation != null;
    let out;
    // Since the matrices are vectors, it is faster to call mul().sum()
    // because sum() is O(sqrt(N)) due to divide-and-conquer.
    if ((outerShapeA === 1 || outerShapeB === 1) && sharedDim > $865bcb3c098ec510$export$42c1ddb439199e73 && containsFusedOps === false) {
        let aVec = a3d;
        let bVec = b3d;
        if (transposeA) {
            aVec = (0, $lHu0m.transpose)({
                inputs: {
                    x: a3d
                },
                backend: backend,
                attrs: {
                    perm: [
                        0,
                        2,
                        1
                    ]
                }
            });
            intermediates.push(aVec);
        }
        if (transposeB) {
            bVec = (0, $lHu0m.transpose)({
                inputs: {
                    x: b3d
                },
                backend: backend,
                attrs: {
                    perm: [
                        0,
                        2,
                        1
                    ]
                }
            });
            intermediates.push(bVec);
        }
        const shouldReshapeA = outerShapeB !== 1;
        const shouldReshapeB = outerShapeB === 1;
        let aVec3d = aVec;
        if (shouldReshapeA) {
            aVec3d = (0, $9gI7w.reshape)({
                inputs: {
                    x: aVec
                },
                backend: backend,
                attrs: {
                    shape: [
                        batchDim,
                        sharedDim,
                        1
                    ]
                }
            });
            intermediates.push(aVec3d);
        }
        const axis = outerShapeB === 1 ? 2 : 1;
        let bVec3d = bVec;
        if (shouldReshapeB) {
            bVec3d = (0, $9gI7w.reshape)({
                inputs: {
                    x: bVec
                },
                backend: backend,
                attrs: {
                    shape: [
                        batchDim,
                        1,
                        sharedDim
                    ]
                }
            });
            intermediates.push(bVec3d);
        }
        const product = (0, $5hV6I.multiply)({
            inputs: {
                a: aVec3d,
                b: bVec3d
            },
            backend: backend
        });
        out = (0, $jS2yk.sum)({
            inputs: {
                x: product
            },
            backend: backend,
            attrs: {
                axis: axis,
                keepDims: true
            }
        });
        intermediates.push(product);
    } else {
        const dtype = (0, $bnEYl.upcastType)(a.dtype, b.dtype);
        const program = new (0, $HxxM1.MatMulPackedProgram)(a3dShape, b3dShape, [
            batchDim,
            outerShapeA,
            outerShapeB
        ], transposeA, transposeB, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
        const inputs = [
            a3d,
            b3d
        ];
        if (bias != null) inputs.push(bias);
        if (hasPreluActivationWeights) inputs.push(preluActivationWeights);
        if (hasLeakyreluAlpha) {
            const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $wx9lK).createScalarValue(leakyreluAlpha, 'float32'));
            inputs.push($leakyreluAlpha);
            intermediates.push($leakyreluAlpha);
        }
        out = backend.runWebGLProgram(program, inputs, dtype);
    }
    const outReshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    intermediates.push(out);
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return outReshaped;
}

});
parcelRegister("eWZon", function(module, exports) {

$parcel$export(module.exports, "CHECK_NAN_SNIPPET_UNARY", () => $ae261aab49cdf6dc$export$bf39b1cb254b6187);
$parcel$export(module.exports, "unaryKernelFunc", () => $ae261aab49cdf6dc$export$ba4daf5748026fba);
$parcel$export(module.exports, "binaryKernelFunc", () => $ae261aab49cdf6dc$export$29353c66e70e3e16);
$parcel$export(module.exports, "mapActivationToShaderProgram", () => $ae261aab49cdf6dc$export$445d43a4039ec7b7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $aymVi = parcelRequire("aymVi");
var $bnEYl = parcelRequire("bnEYl");

var $Ngeff = parcelRequire("Ngeff");

var $bMo9e = parcelRequire("bMo9e");

var $3GoRo = parcelRequire("3GoRo");

var $1UrOK = parcelRequire("1UrOK");

var $aDlCL = parcelRequire("aDlCL");

var $2sCkP = parcelRequire("2sCkP");

var $2RjWv = parcelRequire("2RjWv");
const $ae261aab49cdf6dc$export$bf39b1cb254b6187 = `if (isnan(x)) return x;`;
function $ae261aab49cdf6dc$export$ba4daf5748026fba({ opSnippet: opSnippet, packedOpSnippet: packedOpSnippet, cpuKernelImpl: cpuKernelImpl, dtype: dtype }) {
    return ({ inputs: inputs, backend: backend })=>{
        const { x: x } = inputs;
        const webglBackend = backend;
        const $dtype = dtype || x.dtype;
        if (webglBackend.shouldExecuteOnCPU([
            x
        ]) && cpuKernelImpl != null) {
            const xData = webglBackend.texData.get(x.dataId);
            const outValues = cpuKernelImpl(xData.values, $dtype);
            return webglBackend.makeTensorInfo(x.shape, $dtype, outValues);
        }
        const shouldUsePackedProgram = (0, $aymVi.env)().getBool('WEBGL_PACK_UNARY_OPERATIONS') && packedOpSnippet != null;
        let program;
        if (shouldUsePackedProgram) program = new (0, $2RjWv.UnaryOpPackedProgram)(x.shape, packedOpSnippet);
        else program = new (0, $2sCkP.UnaryOpProgram)(x.shape, opSnippet);
        return webglBackend.runWebGLProgram(program, [
            x
        ], $dtype);
    };
}
function $ae261aab49cdf6dc$export$29353c66e70e3e16({ opSnippet: opSnippet, packedOpSnippet: packedOpSnippet, checkOutOfBounds: checkOutOfBounds = false, supportsComplex: supportsComplex = false, cpuKernelImpl: cpuKernelImpl, dtype: dtype }) {
    return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const webglBackend = backend;
        if (supportsComplex && a.dtype === 'complex64') {
            const aData = webglBackend.texData.get(a.dataId);
            const bData = webglBackend.texData.get(b.dataId);
            const [real, imag] = [
                [
                    aData.complexTensorInfos.real,
                    bData.complexTensorInfos.real
                ],
                [
                    aData.complexTensorInfos.imag,
                    bData.complexTensorInfos.imag
                ]
            ].map((complexParts)=>{
                const [aPart, bPart] = complexParts;
                const aHandle = {
                    dataId: aPart.dataId,
                    dtype: aPart.dtype,
                    shape: a.shape
                };
                const bHandle = {
                    dataId: bPart.dataId,
                    dtype: bPart.dtype,
                    shape: b.shape
                };
                const program = new (0, $Ngeff.BinaryOpProgram)(opSnippet, a.shape, b.shape);
                return webglBackend.runWebGLProgram(program, [
                    aHandle,
                    bHandle
                ], (0, $bnEYl.upcastType)(aPart.dtype, bPart.dtype));
            });
            const complexOutput = (0, $3GoRo.complex)({
                inputs: {
                    real: real,
                    imag: imag
                },
                backend: webglBackend
            });
            webglBackend.disposeIntermediateTensorInfo(real);
            webglBackend.disposeIntermediateTensorInfo(imag);
            // TODO(annxingyuan): Implement CPU forwarding for complex inputs.
            return complexOutput;
        }
        const $dtype = dtype || (0, $bnEYl.upcastType)(a.dtype, b.dtype);
        if ((a.dtype === 'string' || b.dtype === 'string' || webglBackend.shouldExecuteOnCPU([
            a,
            b
        ])) && cpuKernelImpl != null) {
            const aVals = webglBackend.texData.get(a.dataId).values;
            const bVals = webglBackend.texData.get(b.dataId).values;
            const decodedAVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
            (0, $lkN62).fromUint8ToStringArray(aVals) : aVals;
            const decodedBVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
            (0, $lkN62).fromUint8ToStringArray(bVals) : bVals;
            const [outValues, outShape] = cpuKernelImpl(a.shape, b.shape, decodedAVals, decodedBVals, $dtype);
            const out = webglBackend.makeTensorInfo(outShape, $dtype);
            const outData = webglBackend.texData.get(out.dataId);
            outData.values = outValues;
            return out;
        }
        const shouldUsePackedProgram = (0, $aymVi.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS') && packedOpSnippet != null;
        let program;
        if (shouldUsePackedProgram) program = new (0, $bMo9e.BinaryOpPackedProgram)(packedOpSnippet, a.shape, b.shape, checkOutOfBounds);
        else program = new (0, $Ngeff.BinaryOpProgram)(opSnippet, a.shape, b.shape);
        return webglBackend.runWebGLProgram(program, [
            a,
            b
        ], $dtype);
    };
}
function $ae261aab49cdf6dc$export$445d43a4039ec7b7(activation, packed = false) {
    if (activation === 'linear') {
        if (packed) return $2RjWv.LINEAR;
        return $2sCkP.LINEAR;
    } else if (activation === 'relu') {
        if (packed) return $2RjWv.RELU;
        return $2sCkP.RELU;
    } else if (activation === 'elu') {
        if (packed) return $2RjWv.ELU;
        return $2sCkP.ELU;
    } else if (activation === 'relu6') {
        if (packed) return $2RjWv.RELU6;
        return $2sCkP.RELU6;
    } else if (activation === 'prelu') {
        if (packed) return 0, $aDlCL.PRELU_PACKED;
        return 0, $aDlCL.PRELU;
    } else if (activation === 'leakyrelu') {
        if (packed) return 0, $1UrOK.LEAKYRELU_PACKED;
        return 0, $1UrOK.LEAKYRELU;
    } else if (activation === 'sigmoid') {
        if (packed) return $2RjWv.SIGMOID;
        return $2sCkP.SIGMOID;
    }
    throw new Error(`Activation ${activation} has not been implemented for the WebGL backend.`);
}

});
parcelRegister("Ngeff", function(module, exports) {

$parcel$export(module.exports, "CHECK_NAN_SNIPPET", () => $09412a6952e5bca3$export$39f0cca2b63399f6);
$parcel$export(module.exports, "BinaryOpProgram", () => $09412a6952e5bca3$export$9045e9161086790b);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");

var $i88bA = parcelRequire("i88bA");
const $09412a6952e5bca3$export$39f0cca2b63399f6 = `
  if (isnan(a)) return a;
  if (isnan(b)) return b;
`;
const $09412a6952e5bca3$export$1e6d79ff8c3b3c83 = 'return (a - b) * (a - b);';
class $09412a6952e5bca3$export$9045e9161086790b {
    constructor(op, aShape, bShape){
        this.variableNames = [
            'A',
            'B'
        ];
        this.outputShape = (0, $lkN62).assertAndGetBroadcastShape(aShape, bShape);
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        this.userCode = `
      float binaryOperation(float a, float b) {
        ${op}
      }

      void main() {
        float a = getAAtOutCoords();
        float b = getBAtOutCoords();
        setOutput(binaryOperation(a, b));
      }
    `;
    }
}

});

parcelRegister("bMo9e", function(module, exports) {

$parcel$export(module.exports, "CHECK_NAN_SNIPPET_PACKED", () => $8936e8ae84ef823b$export$2b4d5cee4bd7b2dd);
$parcel$export(module.exports, "BinaryOpPackedProgram", () => $8936e8ae84ef823b$export$7ef3bdc75c177be0);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $i88bA = parcelRequire("i88bA");

var $2351m = parcelRequire("2351m");

var $7svrP = parcelRequire("7svrP");
const $8936e8ae84ef823b$export$2b4d5cee4bd7b2dd = `
  result.r = isNaN.r ? NAN : result.r;
  result.g = isNaN.g ? NAN : result.g;
  result.b = isNaN.b ? NAN : result.b;
  result.a = isNaN.a ? NAN : result.a;
`;
const $8936e8ae84ef823b$export$54f9164222714c69 = `
  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));
  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));
`;
const $8936e8ae84ef823b$export$fd75136f014548e = `
  return vec4(notEqual(a, b));
`;
class $8936e8ae84ef823b$export$7ef3bdc75c177be0 {
    constructor(op, aShape, bShape, checkOutOfBounds = false){
        this.variableNames = [
            'A',
            'B'
        ];
        this.supportsBroadcasting = true;
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = (0, $lkN62).assertAndGetBroadcastShape(aShape, bShape);
        const rank = this.outputShape.length;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(rank);
        let checkOutOfBoundsString = '';
        if (checkOutOfBounds) {
            if (rank === 0 || (0, $wx9lK).sizeFromShape(this.outputShape) === 1) checkOutOfBoundsString = `
          result.y = 0.;
          result.z = 0.;
          result.w = 0.;
        `;
            else {
                const dtype = (0, $7svrP.getCoordsDataType)(rank);
                checkOutOfBoundsString = `
          ${dtype} coords = getOutputCoords();
        `;
                if (rank === 1) {
                    if (this.enableShapeUniforms) checkOutOfBoundsString += `
            result.y = (coords + 1) >= outShape ? 0. : result.y;
            result.z = 0.;
            result.w = 0.;
          `;
                    else checkOutOfBoundsString += `
            result.y = (coords + 1) >= ${this.outputShape[0]} ? 0. : result.y;
            result.z = 0.;
            result.w = 0.;
          `;
                } else {
                    const channels = (0, $2351m.getChannels)('coords', rank);
                    if (this.enableShapeUniforms) checkOutOfBoundsString += `
            bool nextRowOutOfBounds =
              (${channels[rank - 2]} + 1) >= outShape[${rank} - 2];
            bool nextColOutOfBounds =
              (${channels[rank - 1]} + 1) >= outShape[${rank} - 1];
            result.y = nextColOutOfBounds ? 0. : result.y;
            result.z = nextRowOutOfBounds ? 0. : result.z;
            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;
          `;
                    else checkOutOfBoundsString += `
            bool nextRowOutOfBounds =
              (${channels[rank - 2]} + 1) >= ${this.outputShape[rank - 2]};
            bool nextColOutOfBounds =
              (${channels[rank - 1]} + 1) >= ${this.outputShape[rank - 1]};
            result.y = nextColOutOfBounds ? 0. : result.y;
            result.z = nextRowOutOfBounds ? 0. : result.z;
            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;
          `;
                }
            }
        }
        this.userCode = `
      vec4 binaryOperation(vec4 a, vec4 b) {
        ${op}
      }

      void main() {
        vec4 a = getAAtOutCoords();
        vec4 b = getBAtOutCoords();

        vec4 result = binaryOperation(a, b);
        ${checkOutOfBoundsString}

        setOutput(result);
      }
    `;
    }
}

});

parcelRegister("3GoRo", function(module, exports) {

$parcel$export(module.exports, "complex", () => $2ae89413b3cb5aca$export$83a0e34f1302825b);
$parcel$export(module.exports, "complexConfig", () => $2ae89413b3cb5aca$export$67917f7910d27fd8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fAHbJ = parcelRequire("fAHbJ");
function $2ae89413b3cb5aca$export$83a0e34f1302825b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { real: real, imag: imag } = inputs;
    const complexInfo = backend.makeTensorInfo(real.shape, 'complex64');
    const complex = backend.texData.get(complexInfo.dataId);
    const realTensorInfo = (0, $fAHbJ.identity)({
        inputs: {
            x: real
        },
        backend: backend
    });
    const imagTensorInfo = (0, $fAHbJ.identity)({
        inputs: {
            x: imag
        },
        backend: backend
    });
    complex.complexTensorInfos = {
        real: realTensorInfo,
        imag: imagTensorInfo
    };
    return complexInfo;
}
const $2ae89413b3cb5aca$export$67917f7910d27fd8 = {
    kernelName: (0, $dCP8m.Complex),
    backendName: 'webgl',
    kernelFunc: $2ae89413b3cb5aca$export$83a0e34f1302825b
};

});
parcelRegister("fAHbJ", function(module, exports) {

$parcel$export(module.exports, "identity", () => $b59bb81aa0fd0e3e$export$f0954fd7d5368655);
$parcel$export(module.exports, "identityConfig", () => $b59bb81aa0fd0e3e$export$c426d3942537ad84);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
function $b59bb81aa0fd0e3e$export$f0954fd7d5368655(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    backend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: x.shape,
        dtype: x.dtype
    };
}
const $b59bb81aa0fd0e3e$export$c426d3942537ad84 = {
    kernelName: (0, $dCP8m.Identity),
    backendName: 'webgl',
    kernelFunc: $b59bb81aa0fd0e3e$export$f0954fd7d5368655
};

});


parcelRegister("1UrOK", function(module, exports) {

$parcel$export(module.exports, "LEAKYRELU", () => $1640996147639c02$export$92ed4431d8daa517);
$parcel$export(module.exports, "LEAKYRELU_PACKED", () => $1640996147639c02$export$e86410c26dcc9bb1);
$parcel$export(module.exports, "leakyReluConfig", () => $1640996147639c02$export$aa04ab963fdf437f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $Ngeff = parcelRequire("Ngeff");

var $bMo9e = parcelRequire("bMo9e");
const $1640996147639c02$export$92ed4431d8daa517 = `return (a < 0.) ? b * a : a;`;
const $1640996147639c02$export$e86410c26dcc9bb1 = `
  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));
  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);
`;
function $1640996147639c02$export$23a860e40a2c6b61(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { alpha: alpha } = attrs;
    const $alpha = backend.makeTensorInfo([], 'float32', (0, $wx9lK).createScalarValue(alpha, 'float32'));
    const program = (0, $aymVi.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS') ? new (0, $bMo9e.BinaryOpPackedProgram)($1640996147639c02$export$e86410c26dcc9bb1, x.shape, $alpha.shape) : new (0, $Ngeff.BinaryOpProgram)($1640996147639c02$export$92ed4431d8daa517, x.shape, $alpha.shape);
    const result = backend.runWebGLProgram(program, [
        x,
        $alpha
    ], 'float32');
    backend.disposeIntermediateTensorInfo($alpha);
    return result;
}
const $1640996147639c02$export$aa04ab963fdf437f = {
    kernelName: (0, $dCP8m.LeakyRelu),
    backendName: 'webgl',
    kernelFunc: $1640996147639c02$export$23a860e40a2c6b61
};

});

parcelRegister("aDlCL", function(module, exports) {

$parcel$export(module.exports, "PRELU", () => $7bde5204b8a4dac3$export$97f8593018a4b737);
$parcel$export(module.exports, "PRELU_PACKED", () => $7bde5204b8a4dac3$export$4cc182bd80c9848a);
$parcel$export(module.exports, "preluConfig", () => $7bde5204b8a4dac3$export$a5c4a9b694579636);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");

var $Ngeff = parcelRequire("Ngeff");

var $bMo9e = parcelRequire("bMo9e");
const $7bde5204b8a4dac3$export$97f8593018a4b737 = `return (a < 0.) ? b * a : a;`;
const $7bde5204b8a4dac3$export$4cc182bd80c9848a = `
  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));
  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);
`;
function $7bde5204b8a4dac3$export$5882f235222e6729(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x, alpha: alpha } = inputs;
    const program = (0, $aymVi.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS') ? new (0, $bMo9e.BinaryOpPackedProgram)($7bde5204b8a4dac3$export$4cc182bd80c9848a, x.shape, alpha.shape) : new (0, $Ngeff.BinaryOpProgram)($7bde5204b8a4dac3$export$97f8593018a4b737, x.shape, alpha.shape);
    return backend.runWebGLProgram(program, [
        x,
        alpha
    ], 'float32');
}
const $7bde5204b8a4dac3$export$a5c4a9b694579636 = {
    kernelName: (0, $dCP8m.Prelu),
    backendName: 'webgl',
    kernelFunc: $7bde5204b8a4dac3$export$5882f235222e6729
};

});


parcelRegister("HxxM1", function(module, exports) {

$parcel$export(module.exports, "MatMulPackedProgram", () => $082e095aa63a9109$export$21e5f112101779d8);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i88bA = parcelRequire("i88bA");
class $082e095aa63a9109$export$21e5f112101779d8 {
    constructor(aShape, bShape, outputShape, transposeA = false, transposeB = false, addBias = false, activation = null, hasPreluActivation = false, hasLeakyreluActivation = false){
        this.variableNames = [
            'matrixA',
            'matrixB'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        const sharedDim = transposeA ? aShape[1] : aShape[2];
        const sharedDimensionPacked = Math.ceil(sharedDim / 2);
        const aSample = transposeA ? 'i * 2, rc.y' : 'rc.y, i * 2';
        const bSample = transposeB ? 'rc.z, i * 2' : 'i * 2, rc.z';
        const aSwizzle = transposeA ? [
            'a.xxyy',
            'a.zzww'
        ] : [
            'a.xxzz',
            'a.yyww'
        ];
        const bSwizzle = transposeB ? [
            'b.xzxz',
            'b.ywyw'
        ] : [
            'b.xyxy',
            'b.zwzw'
        ];
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyreluActivation) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `vec4 activation(vec4 x) {
          ${activation}
        }`;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyreluActivation) this.variableNames.push('leakyreluAlpha');
        let batchASnippet = 'rc.x';
        let batchBSnippet = 'rc.x';
        if (aShape[0] < bShape[0]) batchASnippet = `int(min(float(rc.x), ${aShape[0] - 1}.))`;
        else if (bShape[0] < aShape[0]) batchBSnippet = `int(min(float(rc.x), ${bShape[0] - 1}.))`;
        this.userCode = `
      ${activationSnippet}
      // Don't use uniform for sharedDimensionPacked for performance.
      const float sharedDimension = ${sharedDimensionPacked}.0;

      vec4 dot2x2ARowBCol(ivec3 rc) {
        vec4 result = vec4(0);
        for (int i = 0; i < ${sharedDimensionPacked}; i++) {
          int batchA = ${batchASnippet};
          int batchB = ${batchBSnippet};
          vec4 a = getMatrixA(batchA, ${aSample});
          vec4 b = getMatrixB(batchB, ${bSample});

          // These swizzled products need to be separately added.
          // See: https://github.com/tensorflow/tfjs/issues/1735
          result += (${aSwizzle[0]} * ${bSwizzle[0]});
          result += (${aSwizzle[1]} * ${bSwizzle[1]});
        }
        return result;
      }

      void main() {
        ivec3 rc = getOutputCoords();
        vec4 result = dot2x2ARowBCol(rc);

        ${addBiasSnippet}

        ${applyActivationSnippet}

        setOutput(result);
      }
    `;
    }
}

});

parcelRegister("5hV6I", function(module, exports) {

$parcel$export(module.exports, "multiply", () => $3d9ad69db41a1808$export$2060d2db72cce88f);
$parcel$export(module.exports, "multiplyConfig", () => $3d9ad69db41a1808$export$745576778aafee88);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");

var $c6nF2 = parcelRequire("c6nF2");

var $Ngeff = parcelRequire("Ngeff");

var $bMo9e = parcelRequire("bMo9e");

var $fIVdF = parcelRequire("fIVdF");

var $3GoRo = parcelRequire("3GoRo");
const $3d9ad69db41a1808$var$MUL = 'return a * b;';
function $3d9ad69db41a1808$export$2060d2db72cce88f(args) {
    const { inputs: inputs, backend: backend } = args;
    const { a: a, b: b } = inputs;
    const dtype = (0, $lkN62).upcastType(a.dtype, b.dtype);
    if (a.dtype === 'complex64') {
        const aData = backend.texData.get(a.dataId);
        const bData = backend.texData.get(b.dataId);
        const realProgram = new (0, $c6nF2.BinaryOpComplexProgram)($c6nF2.COMPLEX_MULTIPLY.REAL, a.shape, b.shape);
        const imagProgram = new (0, $c6nF2.BinaryOpComplexProgram)($c6nF2.COMPLEX_MULTIPLY.IMAG, a.shape, b.shape);
        const inputs = [
            {
                dataId: aData.complexTensorInfos.real.dataId,
                dtype: aData.complexTensorInfos.real.dtype,
                shape: a.shape
            },
            {
                dataId: aData.complexTensorInfos.imag.dataId,
                dtype: aData.complexTensorInfos.imag.dtype,
                shape: a.shape
            },
            {
                dataId: bData.complexTensorInfos.real.dataId,
                dtype: bData.complexTensorInfos.real.dtype,
                shape: b.shape
            },
            {
                dataId: bData.complexTensorInfos.imag.dataId,
                dtype: bData.complexTensorInfos.imag.dtype,
                shape: b.shape
            }
        ];
        const realPart = backend.runWebGLProgram(realProgram, inputs, 'float32');
        const imagPart = backend.runWebGLProgram(imagProgram, inputs, 'float32');
        const complexOutput = (0, $3GoRo.complex)({
            inputs: {
                real: realPart,
                imag: imagPart
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(imagPart);
        // TODO(annxingyuan): CPU forwarding for complex inputs.
        return complexOutput;
    }
    if (backend.shouldExecuteOnCPU([
        a,
        b
    ])) {
        const aData = backend.texData.get(a.dataId);
        const bData = backend.texData.get(b.dataId);
        const [outValues, outShape] = (0, $fIVdF.multiplyImplCPU)(a.shape, b.shape, aData.values, bData.values, dtype);
        const out = backend.makeTensorInfo(outShape, dtype);
        const outData = backend.texData.get(out.dataId);
        outData.values = outValues;
        return out;
    }
    let program;
    if ((0, $aymVi.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS')) program = new (0, $bMo9e.BinaryOpPackedProgram)($3d9ad69db41a1808$var$MUL, a.shape, b.shape);
    else program = new (0, $Ngeff.BinaryOpProgram)($3d9ad69db41a1808$var$MUL, a.shape, b.shape);
    return backend.runWebGLProgram(program, [
        a,
        b
    ], dtype);
}
const $3d9ad69db41a1808$export$745576778aafee88 = {
    kernelName: (0, $dCP8m.Multiply),
    backendName: 'webgl',
    kernelFunc: $3d9ad69db41a1808$export$2060d2db72cce88f
};

});
parcelRegister("c6nF2", function(module, exports) {

$parcel$export(module.exports, "COMPLEX_MULTIPLY", () => $8cf866284b08fd5b$export$51b2b2579375d8b0);
$parcel$export(module.exports, "BinaryOpComplexProgram", () => $8cf866284b08fd5b$export$d4e4851a08b0c91);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
const $8cf866284b08fd5b$export$51b2b2579375d8b0 = {
    REAL: 'return areal * breal - aimag * bimag;',
    IMAG: 'return areal * bimag + aimag * breal;'
};
class $8cf866284b08fd5b$export$d4e4851a08b0c91 {
    constructor(op, aShape, bShape){
        this.variableNames = [
            'AReal',
            'AImag',
            'BReal',
            'BImag'
        ];
        this.outputShape = (0, $lkN62).assertAndGetBroadcastShape(aShape, bShape);
        this.userCode = `
      float binaryOpComplex(
          float areal, float aimag, float breal, float bimag) {
        ${op}
      }

      void main() {
        float areal = getARealAtOutCoords();
        float aimag = getAImagAtOutCoords();
        float breal = getBRealAtOutCoords();
        float bimag = getBImagAtOutCoords();
        setOutput(binaryOpComplex(areal, aimag, breal, bimag));
      }
    `;
    }
}

});


parcelRegister("9gI7w", function(module, exports) {

$parcel$export(module.exports, "reshape", () => $6bf7d5101e671a13$export$9eaad88cf88cee2b);
$parcel$export(module.exports, "reshapeConfig", () => $6bf7d5101e671a13$export$cfa02e698602aca2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $709U1 = parcelRequire("709U1");

var $4rulI = parcelRequire("4rulI");
function $6bf7d5101e671a13$export$9eaad88cf88cee2b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { shape: shape } = attrs;
    const webglBackend = backend;
    const xSize = (0, $wx9lK).sizeFromShape(x.shape);
    const $shape = (0, $wx9lK).inferFromImplicitShape(shape, xSize);
    const $xSize = (0, $wx9lK).sizeFromShape($shape);
    (0, $wx9lK).assert(xSize === $xSize, ()=>`The new shape (${$shape}) has ${$xSize} elements and the old ` + `shape (${x.shape}) has ${xSize} elements. The new shape and old ` + `shape must have the same number of elements.`);
    const xTexData = webglBackend.texData.get(x.dataId);
    if (xTexData.isPacked && !(0, $4rulI.isReshapeFree)(x.shape, $shape) && !(xTexData.texture !== null && (0, $4rulI.isReshapeFree)(xTexData.shape, $shape))) return (0, $709U1.packedReshape)(x, $shape, webglBackend);
    webglBackend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: $shape,
        dtype: x.dtype
    };
}
const $6bf7d5101e671a13$export$cfa02e698602aca2 = {
    kernelName: (0, $dCP8m.Reshape),
    backendName: 'webgl',
    kernelFunc: $6bf7d5101e671a13$export$9eaad88cf88cee2b
};

});
parcelRegister("709U1", function(module, exports) {

$parcel$export(module.exports, "packedReshape", () => $519036f22cc7c48f$export$2ae2c9dd4c61df98);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $48uvZ = parcelRequire("48uvZ");

var $4rulI = parcelRequire("4rulI");
function $519036f22cc7c48f$export$2ae2c9dd4c61df98(input, afterShape, backend) {
    const input3DShape = [
        (0, $4rulI.getBatchDim)(input.shape),
        ...(0, $4rulI.getRowsCols)(input.shape)
    ];
    const input3D = {
        dtype: input.dtype,
        shape: input3DShape,
        dataId: input.dataId
    };
    const afterShapeAs3D = [
        (0, $4rulI.getBatchDim)(afterShape),
        ...(0, $4rulI.getRowsCols)(afterShape)
    ];
    const program = new (0, $48uvZ.ReshapePackedProgram)(afterShapeAs3D, input3DShape);
    const preventEagerUnpackingOfOutput = true;
    const customValues = [
        input3DShape
    ];
    const output = backend.runWebGLProgram(program, [
        input3D
    ], input.dtype, customValues, preventEagerUnpackingOfOutput);
    return {
        dataId: output.dataId,
        shape: afterShape,
        dtype: output.dtype
    };
}

});


parcelRegister("jS2yk", function(module, exports) {

$parcel$export(module.exports, "sum", () => $e7750a63ce617576$export$8a63f25cc62965f1);
$parcel$export(module.exports, "sumConfig", () => $e7750a63ce617576$export$47edea402251c258);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $9yP66 = parcelRequire("9yP66");
function $e7750a63ce617576$export$8a63f25cc62965f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    return (0, $9yP66.sumImpl)(x, axis, keepDims, backend);
}
const $e7750a63ce617576$export$47edea402251c258 = {
    kernelName: (0, $dCP8m.Sum),
    backendName: 'webgl',
    kernelFunc: $e7750a63ce617576$export$8a63f25cc62965f1
};

});
parcelRegister("9yP66", function(module, exports) {

$parcel$export(module.exports, "sumImpl", () => $6f5eecec891066e2$export$c29f6d05a9b60dfa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $bnEYl = parcelRequire("bnEYl");
var $wx9lK = parcelRequire("wx9lK");

var $cojUQ = parcelRequire("cojUQ");

var $9gI7w = parcelRequire("9gI7w");

var $5wAPM = parcelRequire("5wAPM");
function $6f5eecec891066e2$export$c29f6d05a9b60dfa(x, axis, keepDims, backend) {
    const reductionIndices = axis;
    const xRank = x.shape.length;
    const origAxes = (0, $wx9lK).parseAxisParam(reductionIndices, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, xRank);
    const sumInputIsTransposed = permutedAxes != null;
    let sumInput = x;
    if (sumInputIsTransposed) {
        sumInput = (0, $5wAPM.transposeImpl)(x, permutedAxes, backend);
        axes = (0, $lkN62).getInnerMostAxes(axes.length, xRank);
    }
    (0, $lkN62).assertAxesAreInnerMostDims('sum', axes, xRank);
    const [sumOutShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes(sumInput.shape, axes);
    let outShape = sumOutShape;
    if (keepDims) // rather than reshape at the end, set the target shape here.
    outShape = (0, $lkN62).expandShapeToKeepDim(sumOutShape, origAxes);
    const inSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const xSize = (0, $wx9lK).sizeFromShape(x.shape);
    const batchSize = xSize / inSize;
    const reshapedInput = (0, $9gI7w.reshape)({
        inputs: {
            x: sumInput
        },
        attrs: {
            shape: [
                batchSize,
                inSize
            ]
        },
        backend: backend
    });
    const outType = (0, $bnEYl.sumOutType)(x.dtype);
    const reduced = (0, $cojUQ.reduce)(reshapedInput, outType, 'sum', backend);
    const out = (0, $9gI7w.reshape)({
        inputs: {
            x: reduced
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(reshapedInput);
    backend.disposeIntermediateTensorInfo(reduced);
    if (sumInputIsTransposed) backend.disposeIntermediateTensorInfo(sumInput);
    return out;
}

});
parcelRegister("cojUQ", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $90572cc9879b9e6c$export$533b26079ad0b4b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");

var $7tr2O = parcelRequire("7tr2O");

var $fwQcS = parcelRequire("fwQcS");
// Returns an array of configuration objects that describe each stage of the
// reduction.
function $90572cc9879b9e6c$var$getReductionStages(inShape) {
    const stages = [];
    while(stages.length === 0 || stages[stages.length - 1].outSize !== 1){
        const outSize = stages.length ? stages[stages.length - 1].outSize : inShape[1];
        const windowSize = (0, $lkN62).computeOptimalWindowSize(outSize);
        stages.push({
            inSize: outSize,
            windowSize: windowSize,
            outSize: Math.ceil(outSize / windowSize)
        });
    }
    return stages;
}
function $90572cc9879b9e6c$export$533b26079ad0b4b(x, dtype, reductionType, backend) {
    const reductionStages = $90572cc9879b9e6c$var$getReductionStages(x.shape);
    let result = x;
    for(let i = 0; i < reductionStages.length; i++){
        const { inSize: inSize, windowSize: windowSize, outSize: outSize } = reductionStages[i];
        let program;
        let previousResult;
        if (reductionType === 'mean') program = i === 0 ? new (0, $7tr2O.MeanProgram)({
            windowSize: windowSize,
            inSize: inSize,
            batchSize: x.shape[0],
            outSize: outSize
        }, inSize) : new (0, $7tr2O.MeanProgram)({
            windowSize: windowSize,
            inSize: inSize,
            batchSize: x.shape[0],
            outSize: outSize
        });
        else program = new (0, $fwQcS.ReduceProgram)({
            windowSize: windowSize,
            inSize: inSize,
            batchSize: x.shape[0],
            outSize: outSize
        }, reductionType);
        previousResult = result;
        result = backend.runWebGLProgram(program, [
            result
        ], dtype);
        if (previousResult.dataId !== x.dataId) backend.disposeIntermediateTensorInfo(previousResult);
    }
    return result;
}

});
parcelRegister("7tr2O", function(module, exports) {

$parcel$export(module.exports, "MeanProgram", () => $57103845530ad557$export$a1460fd06abdca4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");
class $57103845530ad557$export$a1460fd06abdca4 {
    constructor(reduceInfo, divisor){
        this.variableNames = [
            'x'
        ];
        const { windowSize: windowSize, batchSize: batchSize, inSize: inSize, outSize: outSize } = reduceInfo;
        this.outputShape = [
            batchSize,
            outSize
        ];
        const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
        const windowSizeVec4Remainder = windowSize % 4;
        let updateSnippet = `sumValue += dot(values, ones);`;
        if (divisor != null) {
            const denominator = 1 / divisor;
            updateSnippet = `sumValue += dot(values * ${(0, $wx9lK).isInt(denominator) ? denominator.toPrecision(2) : denominator}, ones);`;
        }
        let checkOutOfBounds = '';
        if (inSize % windowSize > 0) checkOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return 0.0;
        }
      `;
        this.userCode = `
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float getValue(int batch, int inIdx) {
        ${checkOutOfBounds}
        return getX(batch, inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        float sumValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          vec4 values = vec4(getValue(batch, inIdx), 0.0, 0.0, 0.0);

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1), 0.0, 0.0);

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2), 0.0);

          ${updateSnippet}
        }
        setOutput(sumValue);
      }
    `;
    }
}

});

parcelRegister("fwQcS", function(module, exports) {

$parcel$export(module.exports, "ReduceProgram", () => $b4e25756e03c8306$export$14f07173aed228a5);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $b4e25756e03c8306$export$14f07173aed228a5 {
    constructor(reduceInfo, reduceType){
        this.variableNames = [
            'x'
        ];
        const { windowSize: windowSize, batchSize: batchSize, inSize: inSize, outSize: outSize } = reduceInfo;
        this.outputShape = [
            batchSize,
            outSize
        ];
        let initializationValue = '0.0';
        let compareOp = ``;
        if (reduceType === 'prod') initializationValue = '1.0';
        else if (reduceType === 'min') {
            // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
            initializationValue = '1.0 / 1e-20';
            compareOp = `min`;
        } else if (reduceType === 'max') {
            // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
            initializationValue = '-1.0 / 1e-20';
            compareOp = `max`;
        }
        let returnValue = `${reduceType}(${reduceType}(${reduceType}(` + 'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
        if (reduceType === 'sum') returnValue = `sumValue`;
        else if (reduceType === 'prod') returnValue = `prodValue`;
        else if (reduceType === 'all') returnValue = `allValue`;
        else if (reduceType === 'any') returnValue = `anyValue`;
        const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
        const windowSizeVec4Remainder = windowSize % 4;
        let updateSnippet = `
      if (${reduceType === 'sum'}) {
        sumValue += dot(values, ones);
      } else if (${reduceType === 'prod'}) {
        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);
        prodValue *= tmp[0] * tmp[1];
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
        if (${reduceType === 'min'} || ${reduceType === 'max'}) {
          minMaxValue = ${compareOp}(values, minMaxValue);
          bvec4 isNaN = isnan(values);
          if (isNaN.r || isNaN.g || isNaN.b || isNaN.a) {
            minMaxValue = vec4(NAN);
          }
        }
      }
    `;
        let vecType = `vec4`;
        if (reduceType === 'all') {
            initializationValue = '1.0';
            updateSnippet = `
        bool reducedAllValue = all(values);
        float floatedReducedAllValue = float(reducedAllValue);
        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);
      `;
            vecType = `bvec4`;
        } else if (reduceType === 'any') {
            initializationValue = '0.0';
            updateSnippet = `
        bool reducedAnyValue = any(values);
        float floatedReducedAnyValue = float(reducedAnyValue);
        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);
      `;
            vecType = `bvec4`;
        }
        let checkOutOfBounds = '';
        if (inSize % windowSize > 0) checkOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return initializationValue;
        }
      `;
        this.userCode = `
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float getValue(int batch, int inIdx) {
        ${checkOutOfBounds}
        return getX(batch, inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        vec4 minMaxValue = vec4(${initializationValue});
        float prodValue = 1.0;
        float sumValue = 0.0;
        float allValue = 1.0;
        float anyValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            initializationValue,
            initializationValue,
            initializationValue
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            initializationValue,
            initializationValue
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            initializationValue
          );

          ${updateSnippet}
        }
        setOutput(${returnValue});
      }
    `;
    }
}

});


parcelRegister("5wAPM", function(module, exports) {

$parcel$export(module.exports, "transposeImpl", () => $405c8368b1295bdb$export$986b9e65182e08d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");

var $fIVdF = parcelRequire("fIVdF");

var $gWaZr = parcelRequire("gWaZr");

var $akUIZ = parcelRequire("akUIZ");
function $405c8368b1295bdb$export$986b9e65182e08d(x, perm, backend) {
    const program = (0, $aymVi.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $akUIZ.TransposePackedProgram)(x.shape, perm) : new (0, $gWaZr.TransposeProgram)(x.shape, perm);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}

});
parcelRegister("gWaZr", function(module, exports) {

$parcel$export(module.exports, "TransposeProgram", () => $c54a96867a911075$export$e48ac6bd7e0ddfac);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7svrP = parcelRequire("7svrP");
class $c54a96867a911075$export$e48ac6bd7e0ddfac {
    constructor(aShape, newDim){
        this.variableNames = [
            'A'
        ];
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[newDim[i]];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        const dtype = (0, $7svrP.getCoordsDataType)(this.rank);
        const switched = $c54a96867a911075$var$getSwitchedCoords(newDim);
        this.userCode = `
    void main() {
      ${dtype} resRC = getOutputCoords();
      setOutput(getA(${switched}));
    }
    `;
    }
}
function $c54a96867a911075$var$getSwitchedCoords(newDim) {
    const rank = newDim.length;
    if (rank > 6) throw Error(`Transpose for rank ${rank} is not yet supported`);
    const originalOrder = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w',
        'resRC.u',
        'resRC.v'
    ];
    const switchedCoords = new Array(rank);
    for(let i = 0; i < newDim.length; i++)switchedCoords[newDim[i]] = originalOrder[i];
    return switchedCoords.join();
}

});

parcelRegister("akUIZ", function(module, exports) {

$parcel$export(module.exports, "TransposePackedProgram", () => $7867c5fd54e82774$export$4daa0c968248fb58);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $2351m = parcelRequire("2351m");

var $7svrP = parcelRequire("7svrP");
class $7867c5fd54e82774$export$4daa0c968248fb58 {
    constructor(aShape, newDim){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[newDim[i]];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        if (this.rank > 6) throw Error(`Packed transpose for rank ${this.rank} is not yet supported.`);
        const dtype = (0, $7svrP.getCoordsDataType)(this.rank);
        const outputOrder = (0, $2351m.getVecChannels)('rc', this.rank);
        const switchedOrder = new Array(this.rank);
        for(let i = 0; i < newDim.length; i++)switchedOrder[newDim[i]] = outputOrder[i];
        const innerDims = `vec2(${switchedOrder.slice(-2).join()})`;
        const nextColumn = `++${outputOrder[this.rank - 1]} < ${outputShape[this.rank - 1]}`;
        const getc = `getChannel(getA(${switchedOrder.join()}), ${innerDims})`;
        this.userCode = `
    void main() {
      ${dtype} rc = getOutputCoords();
      vec4 result = vec4(0.);
      result[0] = ${getc};
      if(${nextColumn}) {
        result[1] = ${getc};
      }
      --${outputOrder[this.rank - 1]};
      if(++${outputOrder[this.rank - 2]} < ${outputShape[this.rank - 2]}) {
        result[2] = ${getc};
        if(${nextColumn}) {
          result[3] = ${getc};
        }
      }
      setOutput(result);
    }
    `;
    }
}

});




parcelRegister("lHu0m", function(module, exports) {

$parcel$export(module.exports, "transpose", () => $fcc4e37468b592ed$export$9cb09a71b7d66923);
$parcel$export(module.exports, "transposeConfig", () => $fcc4e37468b592ed$export$895a002a39b774be);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $5wAPM = parcelRequire("5wAPM");
var $fIVdF = parcelRequire("fIVdF");
function $fcc4e37468b592ed$export$9cb09a71b7d66923(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { perm: perm } = attrs;
    const webglBackend = backend;
    const xRank = x.shape.length;
    const newShape = new Array(xRank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[perm[i]];
    let out;
    if (webglBackend.shouldExecuteOnCPU([
        x
    ])) {
        const xTexData = webglBackend.texData.get(x.dataId);
        const values = xTexData.values;
        const outValues = (0, $fIVdF.transposeImplCPU)(values, x.shape, x.dtype, perm, newShape);
        out = webglBackend.makeTensorInfo(newShape, x.dtype);
        const outData = webglBackend.texData.get(out.dataId);
        outData.values = outValues;
    } else out = (0, $5wAPM.transposeImpl)(x, perm, webglBackend);
    return out;
}
const $fcc4e37468b592ed$export$895a002a39b774be = {
    kernelName: (0, $dCP8m.Transpose),
    backendName: 'webgl',
    kernelFunc: $fcc4e37468b592ed$export$9cb09a71b7d66923
};

});



parcelRegister("4PmUs", function(module, exports) {

$parcel$export(module.exports, "absConfig", () => $383db231b2feb873$export$d66f48648b9d5ec7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $aymVi = parcelRequire("aymVi");

var $fIVdF = parcelRequire("fIVdF");

var $2sCkP = parcelRequire("2sCkP");

var $2RjWv = parcelRequire("2RjWv");
const $383db231b2feb873$var$ABS = `return abs(x);`;
function $383db231b2feb873$export$2335f513bbd82c6d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    // TODO: handle cases when x is complex. Once the cpu implementation
    // can handle complex values, refactor to use unaryKernelFunc.
    if (backend.shouldExecuteOnCPU([
        x
    ]) && x.dtype !== 'complex64') {
        const xData = backend.texData.get(x.dataId);
        const outValues = (0, $fIVdF.simpleAbsImplCPU)(xData.values);
        return backend.makeTensorInfo(x.shape, x.dtype, outValues);
    }
    let program;
    if ((0, $aymVi.env)().getBool('WEBGL_PACK_UNARY_OPERATIONS')) program = new (0, $2RjWv.UnaryOpPackedProgram)(x.shape, $383db231b2feb873$var$ABS);
    else program = new (0, $2sCkP.UnaryOpProgram)(x.shape, $383db231b2feb873$var$ABS);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $383db231b2feb873$export$d66f48648b9d5ec7 = {
    kernelName: (0, $dCP8m.Abs),
    backendName: 'webgl',
    kernelFunc: $383db231b2feb873$export$2335f513bbd82c6d
};

});

parcelRegister("bbqWe", function(module, exports) {

$parcel$export(module.exports, "acosConfig", () => $82459e2d899d5a14$export$255826ca70737275);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $2sCkP = parcelRequire("2sCkP");
const $82459e2d899d5a14$var$ACOS = (0, $2sCkP.CHECK_NAN_SNIPPET) + `
  if (abs(x) > 1.) {
    return NAN;
  }
  return acos(x);
`;
const $82459e2d899d5a14$export$fd6306be3fde5b04 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $82459e2d899d5a14$var$ACOS
});
const $82459e2d899d5a14$export$255826ca70737275 = {
    kernelName: (0, $dCP8m.Acos),
    backendName: 'webgl',
    kernelFunc: $82459e2d899d5a14$export$fd6306be3fde5b04
};

});

parcelRegister("jCriu", function(module, exports) {

$parcel$export(module.exports, "acoshConfig", () => $e486bd92d29d497b$export$3f520b71a56c9e70);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $2sCkP = parcelRequire("2sCkP");
const $e486bd92d29d497b$var$ACOSH = (0, $2sCkP.CHECK_NAN_SNIPPET) + `
  if (x < 1.0) return NAN;
return log(x + sqrt(x * x - 1.0));`;
const $e486bd92d29d497b$export$b26caf0f29211d08 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $e486bd92d29d497b$var$ACOSH
});
const $e486bd92d29d497b$export$3f520b71a56c9e70 = {
    kernelName: (0, $dCP8m.Acosh),
    backendName: 'webgl',
    kernelFunc: $e486bd92d29d497b$export$b26caf0f29211d08
};

});

parcelRegister("7Cev2", function(module, exports) {

$parcel$export(module.exports, "addConfig", () => $58b75451a704f44d$export$b1f3a580afb68e4c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $58b75451a704f44d$var$ADD = 'return a + b;';
const $58b75451a704f44d$export$d50bf7e4980f70a9 = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $58b75451a704f44d$var$ADD,
    packedOpSnippet: $58b75451a704f44d$var$ADD,
    supportsComplex: true,
    cpuKernelImpl: (0, $fIVdF.addImplCPU)
});
const $58b75451a704f44d$export$b1f3a580afb68e4c = {
    kernelName: (0, $dCP8m.Add),
    backendName: 'webgl',
    kernelFunc: $58b75451a704f44d$export$d50bf7e4980f70a9
};

});

parcelRegister("lVoNH", function(module, exports) {

$parcel$export(module.exports, "addNConfig", () => $ff6228b9aff6af1d$export$ff8000bc6f0313e1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $aymVi = parcelRequire("aymVi");
var $bnEYl = parcelRequire("bnEYl");

var $fWbtL = parcelRequire("fWbtL");

var $hMX44 = parcelRequire("hMX44");

var $fAHbJ = parcelRequire("fAHbJ");
function $ff6228b9aff6af1d$export$37b75d0026f96b8d(args) {
    const { inputs: inputs, backend: backend } = args;
    const tensors = inputs;
    if (tensors.length === 1) return (0, $fAHbJ.identity)({
        inputs: {
            x: tensors[0]
        },
        backend: backend
    });
    // Limit the number of uploaded textures for optimization.
    if (tensors.length > (0, $aymVi.env)().get('WEBGL_MAX_TEXTURES_IN_SHADER')) {
        const midIndex = Math.floor(tensors.length / 2);
        const leftSide = $ff6228b9aff6af1d$export$37b75d0026f96b8d({
            inputs: tensors.slice(0, midIndex),
            backend: backend
        });
        const rightSide = $ff6228b9aff6af1d$export$37b75d0026f96b8d({
            inputs: tensors.slice(midIndex),
            backend: backend
        });
        return $ff6228b9aff6af1d$export$37b75d0026f96b8d({
            inputs: [
                leftSide,
                rightSide
            ],
            backend: backend
        });
    }
    const dtype = tensors.map((t)=>t.dtype).reduce((d1, d2)=>(0, $bnEYl.upcastType)(d1, d2));
    const shapes = tensors.map((t)=>t.shape);
    // We can make sure shapes are identical in op level.
    const usePackedOp = (0, $aymVi.env)().getBool('WEBGL_PACK');
    const program = usePackedOp ? new (0, $hMX44.AddNPackedProgram)(tensors[0].shape, shapes) : new (0, $fWbtL.AddNProgram)(tensors[0].shape, shapes);
    return backend.runWebGLProgram(program, tensors, dtype);
}
const $ff6228b9aff6af1d$export$ff8000bc6f0313e1 = {
    kernelName: (0, $dCP8m.AddN),
    backendName: 'webgl',
    kernelFunc: $ff6228b9aff6af1d$export$37b75d0026f96b8d
};

});
parcelRegister("fWbtL", function(module, exports) {

$parcel$export(module.exports, "AddNProgram", () => $b9a52d4fc7a49feb$export$9d269fc8eb4783d5);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $b9a52d4fc7a49feb$export$9d269fc8eb4783d5 {
    constructor(outputShape, shapes){
        this.outputShape = [];
        this.outputShape = outputShape;
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const snippets = [];
        // Get target elements from every input tensor.
        this.variableNames.forEach((variable)=>{
            snippets.push(`float v${variable} = get${variable}AtOutCoords();`);
        });
        // Calculate the sum of all elements.
        const operation = this.variableNames.map((variable)=>{
            return `v${variable}`;
        }).join(' + ');
        this.userCode = `
      void main() {
        ${snippets.join('\n        ')}

        float result = ${operation};
        setOutput(result);
      }
    `;
    }
}

});

parcelRegister("hMX44", function(module, exports) {

$parcel$export(module.exports, "AddNPackedProgram", () => $cf34bc5a038a3c11$export$156b01c0aab97d90);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $cf34bc5a038a3c11$export$156b01c0aab97d90 {
    constructor(outputShape, shapes){
        this.outputShape = [];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = outputShape;
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const snippets = [];
        // Get target elements from every input tensor.
        this.variableNames.forEach((variable)=>{
            snippets.push(`vec4 v${variable} = get${variable}AtOutCoords();`);
        });
        // Calculate the sum of all elements.
        const operation = this.variableNames.map((variable)=>{
            return `v${variable}`;
        }).join(' + ');
        this.userCode = `
      void main() {
        ${snippets.join('\n        ')}

        vec4 result = ${operation};
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("eKIRi", function(module, exports) {

$parcel$export(module.exports, "allConfig", () => $abd8288ada822776$export$4e3f081eb1a330fa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $cojUQ = parcelRequire("cojUQ");

var $9gI7w = parcelRequire("9gI7w");

var $lHu0m = parcelRequire("lHu0m");
function $abd8288ada822776$export$84bf76cd7afc7469(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $lHu0m.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $lkN62).getInnerMostAxes(axes.length, xRank);
    }
    (0, $lkN62).assertAxesAreInnerMostDims('all', axes, xRank);
    const [outShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const a2D = (0, $9gI7w.reshape)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    const reduced = (0, $cojUQ.reduce)(a2D, a2D.dtype, 'all', backend);
    let res;
    if (keepDims) {
        const newShape = (0, $lkN62).expandShapeToKeepDim(outShape, origAxes);
        res = (0, $9gI7w.reshape)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    } else res = (0, $9gI7w.reshape)({
        inputs: {
            x: reduced
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(a2D);
    backend.disposeIntermediateTensorInfo(reduced);
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo(permutedX);
    return res;
}
const $abd8288ada822776$export$4e3f081eb1a330fa = {
    kernelName: (0, $dCP8m.All),
    backendName: 'webgl',
    kernelFunc: $abd8288ada822776$export$84bf76cd7afc7469
};

});

parcelRegister("a4ODc", function(module, exports) {

$parcel$export(module.exports, "anyConfig", () => $75618d6416dad1a2$export$1a8ff634f2df3da6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $cojUQ = parcelRequire("cojUQ");

var $9gI7w = parcelRequire("9gI7w");

var $lHu0m = parcelRequire("lHu0m");
function $75618d6416dad1a2$export$4154a199d7d90455(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $lHu0m.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $lkN62).getInnerMostAxes(axes.length, xRank);
    }
    (0, $lkN62).assertAxesAreInnerMostDims('any', axes, xRank);
    const [outShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const a2D = (0, $9gI7w.reshape)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    const reduced = (0, $cojUQ.reduce)(a2D, a2D.dtype, 'any', backend);
    let res;
    if (keepDims) {
        const newShape = (0, $lkN62).expandShapeToKeepDim(outShape, origAxes);
        res = (0, $9gI7w.reshape)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    } else res = (0, $9gI7w.reshape)({
        inputs: {
            x: reduced
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(a2D);
    backend.disposeIntermediateTensorInfo(reduced);
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo(permutedX);
    return res;
}
const $75618d6416dad1a2$export$1a8ff634f2df3da6 = {
    kernelName: (0, $dCP8m.Any),
    backendName: 'webgl',
    kernelFunc: $75618d6416dad1a2$export$4154a199d7d90455
};

});

parcelRegister("gqBLo", function(module, exports) {

$parcel$export(module.exports, "argMaxConfig", () => $bf5c5e0cad446858$export$ec7419fc9ad0069e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $czEd5 = parcelRequire("czEd5");

var $lHu0m = parcelRequire("lHu0m");
function $bf5c5e0cad446858$export$7980a683c1b852b4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    let axes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $lHu0m.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $lkN62).getInnerMostAxes(axes.length, $x.shape.length);
    }
    (0, $lkN62).assertAxesAreInnerMostDims('argMax', [
        axes[0]
    ], $x.shape.length);
    const out = (0, $czEd5.argMinMaxReduce)(backend, $x, axes[0], 'max');
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return out;
}
const $bf5c5e0cad446858$export$ec7419fc9ad0069e = {
    kernelName: (0, $dCP8m.ArgMax),
    backendName: 'webgl',
    kernelFunc: $bf5c5e0cad446858$export$7980a683c1b852b4
};

});
parcelRegister("czEd5", function(module, exports) {

$parcel$export(module.exports, "argMinMaxReduce", () => $9277f1cc3ccaf34c$export$63dee7a356b9210b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $aymVi = parcelRequire("aymVi");
var $wx9lK = parcelRequire("wx9lK");

var $4X6pU = parcelRequire("4X6pU");

var $gvA7w = parcelRequire("gvA7w");

var $9gI7w = parcelRequire("9gI7w");
function $9277f1cc3ccaf34c$var$argReduce(backend, x, reduceType, bestIndicesA = null) {
    let batchSize = x.shape[0];
    let inSize = x.shape[1];
    if (bestIndicesA != null) {
        batchSize = bestIndicesA.shape[0];
        inSize = bestIndicesA.shape[1];
    }
    const windowSize = (0, $lkN62).computeOptimalWindowSize(inSize);
    const reduceInfo = {
        windowSize: windowSize,
        inSize: inSize,
        batchSize: batchSize,
        outSize: Math.ceil(inSize / windowSize)
    };
    const program = new (0, $4X6pU.ArgMinMaxProgram)(reduceInfo, reduceType, bestIndicesA == null);
    const inputs = [
        x
    ];
    if (bestIndicesA != null) inputs.push(bestIndicesA);
    const output = backend.runWebGLProgram(program, inputs, 'int32');
    // No need to run another GPGPU program.
    if (output.shape[1] === 1) return output;
    const result = $9277f1cc3ccaf34c$var$argReduce(backend, x, reduceType, output);
    backend.disposeIntermediateTensorInfo(output);
    return result;
}
function $9277f1cc3ccaf34c$var$argReducePacked(backend, x, reduceType, bestIndicesA = null) {
    const inShape = bestIndicesA != null ? bestIndicesA.shape : x.shape;
    const inSize = inShape[inShape.length - 1];
    const windowSize = (0, $lkN62).computeOptimalWindowSize(inSize);
    const program = new (0, $gvA7w.ArgMinMaxPackedProgram)(inShape, windowSize, reduceType, bestIndicesA == null);
    const inputs = bestIndicesA == null ? [
        x
    ] : [
        x,
        bestIndicesA
    ];
    const output = backend.runWebGLProgram(program, inputs, 'int32');
    if (output.shape.length === x.shape.length) {
        const result = $9277f1cc3ccaf34c$var$argReducePacked(backend, x, reduceType, output);
        backend.disposeIntermediateTensorInfo(output);
        return result;
    }
    return output;
}
function $9277f1cc3ccaf34c$export$63dee7a356b9210b(backend, x, axis, reduceType) {
    const axes = [
        axis
    ];
    (0, $lkN62).assertAxesAreInnerMostDims('arg' + reduceType.charAt(0).toUpperCase() + reduceType.slice(1), axes, x.shape.length);
    if (!(0, $aymVi.env)().getBool('WEBGL_PACK_REDUCE') || x.shape.length <= 2) {
        const intermediateTensorInfos = [];
        // Eagerly unpack x input since it is passed in to all the shaders which
        // require unpacked inputs.
        const xtexData = backend.texData.get(x.dataId);
        const xIsPacked = xtexData !== null && xtexData.isPacked;
        let xUnPacked = x;
        if (xIsPacked) {
            xUnPacked = backend.unpackTensor(x);
            intermediateTensorInfos.push(xUnPacked);
        }
        const [outShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes(xUnPacked.shape, axes);
        const inSize = (0, $wx9lK).sizeFromShape(reduceShape);
        const a2D = (0, $9gI7w.reshape)({
            inputs: {
                x: xUnPacked
            },
            backend: backend,
            attrs: {
                shape: [
                    -1,
                    inSize
                ]
            }
        });
        intermediateTensorInfos.push(a2D);
        const reduced = $9277f1cc3ccaf34c$var$argReduce(backend, a2D, reduceType);
        intermediateTensorInfos.push(reduced);
        const reshaped = (0, $9gI7w.reshape)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
        return reshaped;
    }
    return $9277f1cc3ccaf34c$var$argReducePacked(backend, x, reduceType);
}

});
parcelRegister("4X6pU", function(module, exports) {

$parcel$export(module.exports, "ArgMinMaxProgram", () => $39b1a65c279f4e5b$export$7fa5759722b57eba);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $39b1a65c279f4e5b$export$7fa5759722b57eba {
    constructor(reduceInfo, op, firstPass){
        this.variableNames = [
            'A'
        ];
        const { windowSize: windowSize, batchSize: batchSize, outSize: outSize } = reduceInfo;
        if (!firstPass) this.variableNames.push('bestIndicesA');
        this.outputShape = [
            batchSize,
            outSize
        ];
        const compOp = op === 'max' ? '>' : '<';
        const indexSnippet = firstPass ? 'inOffset + i;' : 'round(getBestIndicesA(batch, inOffset + i));';
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        int bestIndex = inOffset;
        float bestValue = getA(batch, bestIndex);

        for (int i = 0; i < ${windowSize}; i++) {
          int inIdx = ${indexSnippet};
          float candidate = getA(batch, inIdx);
          if (candidate ${compOp} bestValue) {
            bestValue = candidate;
            bestIndex = inIdx;
          }
        }
        setOutput(float(bestIndex));
      }
    `;
    }
}

});

parcelRegister("gvA7w", function(module, exports) {

$parcel$export(module.exports, "ArgMinMaxPackedProgram", () => $c04b8f536b7b88ce$export$6b02cde2348cc418);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $2351m = parcelRequire("2351m");

var $7svrP = parcelRequire("7svrP");
class $c04b8f536b7b88ce$export$6b02cde2348cc418 {
    constructor(shape, windowSize, op, firstPass){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        (0, $wx9lK).assert(shape.length > 2, ()=>`Packed arg${op.charAt(0).toUpperCase() + op.slice(1)} supports only inputs with rank above 2.`);
        const inSize = shape[shape.length - 1];
        const outSize = Math.ceil(inSize / windowSize);
        this.outputShape = shape.slice(0, -1);
        if (outSize > 1) this.outputShape.push(outSize);
        if (!firstPass) this.variableNames.push('bestIndicesA');
        const outShape = this.outputShape;
        const rank = outShape.length;
        const dtype = (0, $7svrP.getCoordsDataType)(rank);
        const coords = (0, $2351m.getChannels)('coords', rank);
        let sourceLocSetup;
        let sourceRank;
        if (outSize === 1) {
            sourceRank = rank + 1;
            const sourceLocDType = (0, $7svrP.getCoordsDataType)(sourceRank);
            sourceLocSetup = `
        ${sourceLocDType} sourceLocR = ${sourceLocDType}(${coords.join()}, 0);
        ++${coords[rank - 1]};
        ${sourceLocDType} sourceLocG = ${sourceLocDType}(${coords.join()}, 0);
        ++${coords[rank - 2]};
        ${sourceLocDType} sourceLocA = ${sourceLocDType}(${coords.join()}, 0);
        --${coords[rank - 1]};
        ${sourceLocDType} sourceLocB = ${sourceLocDType}(${coords.join()}, 0);
        --${coords[rank - 2]};`;
        } else {
            sourceRank = rank;
            sourceLocSetup = `
        ${dtype} sourceLocR = coords;
        ++${coords[rank - 1]};
        ${dtype} sourceLocG = coords;
        ++${coords[rank - 2]};
        ${dtype} sourceLocA = coords;
        --${coords[rank - 1]};
        ${dtype} sourceLocB = coords;
        --${coords[rank - 2]};`;
        }
        const channels = [
            'x',
            'y',
            'z',
            'w',
            'u',
            'v'
        ].slice(0, sourceRank);
        const inChannel = '.' + channels[sourceRank - 1]; // e.g. ".b" for rank 3.
        const intChannels = channels.map((x)=>'int ' + x);
        const srcRCoords = (0, $2351m.getChannels)('sourceLocR', sourceRank - 1).concat('inIdx.r');
        const srcGCoords = (0, $2351m.getChannels)('sourceLocG', sourceRank - 1).concat('inIdx.g');
        const srcBCoords = (0, $2351m.getChannels)('sourceLocB', sourceRank - 1).concat('inIdx.b');
        const srcACoords = (0, $2351m.getChannels)('sourceLocA', sourceRank - 1).concat('inIdx.a');
        const compOp = op === 'max' ? 'greaterThan' : 'lessThan';
        const fetchCandidateIdx = firstPass ? '' : `
          inIdx = round(vec4(getBestIndicesAChannel(${srcRCoords.join()}),
                             getBestIndicesAChannel(${srcGCoords.join()}),
                             getBestIndicesAChannel(${srcBCoords.join()}),
                             getBestIndicesAChannel(${srcACoords.join()})));`;
        const fetchValue = `vec4(
            getAChannel(${srcRCoords.join()}),
            hasNextCol ? getAChannel(${srcGCoords.join()}) : 0.,
            hasNextRow ? getAChannel(${srcBCoords.join()}) : 0.,
            hasNextRow && hasNextCol ? getAChannel(${srcACoords.join()}) : 0.)`;
        const getBestIndicesAChannelSnippet = firstPass ? '' : `
      float getBestIndicesAChannel(${intChannels.join()}) {
        return getChannel(getBestIndicesA(${channels.join()}),
                                          vec2(${channels.slice(-2).join()}));
      }`;
        this.userCode = `
      float getAChannel(${intChannels.join()}) {
        return getChannel(getA(${channels.join()}),
                               vec2(${channels.slice(-2).join()}));
      }
      ${getBestIndicesAChannelSnippet}
      void main() {
        ${dtype} coords = getOutputCoords();
        bool hasNextCol = ${coords[rank - 1]} < ${outShape[rank - 1] - 1};
        bool hasNextRow = ${coords[rank - 2]} < ${outShape[rank - 2] - 1};
        ${sourceLocSetup}
        ivec4 srcIdx = ivec4(sourceLocR${inChannel}, sourceLocG${inChannel},
          sourceLocB${inChannel}, sourceLocA${inChannel}) * ${windowSize};
        ivec4 inIdx = srcIdx;
        vec4 bestIndex = vec4(inIdx);
        vec4 bestValue = ${fetchValue};

        for (int i = 0; i < ${windowSize}; i++) {
          inIdx = srcIdx;
          ${fetchCandidateIdx}
          vec4 candidate = ${fetchValue};
          bvec4 nan = isnan(candidate);
          bvec4 replace = bvec4(
            vec4(${compOp}(candidate, bestValue)) * (vec4(1.0) - vec4(nan)));

          bestValue = vec4(replace.x  ? candidate.x : bestValue.x,
                           replace.y  ? candidate.y : bestValue.y,
                           replace.z  ? candidate.z : bestValue.z,
                           replace.w  ? candidate.w : bestValue.w);
          bestIndex = mix(bestIndex, vec4(inIdx), vec4(replace));
          srcIdx++;
        }
        setOutput(bestIndex);
      }
    `;
    }
}

});



parcelRegister("bI2qd", function(module, exports) {

$parcel$export(module.exports, "argMinConfig", () => $8865aeb73196640f$export$21836a5e5fa09eb4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $czEd5 = parcelRequire("czEd5");

var $lHu0m = parcelRequire("lHu0m");
function $8865aeb73196640f$export$ec99a91cddfb29a2(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    let axes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $lHu0m.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $lkN62).getInnerMostAxes(axes.length, $x.shape.length);
    }
    (0, $lkN62).assertAxesAreInnerMostDims('argMin', [
        axes[0]
    ], $x.shape.length);
    const out = (0, $czEd5.argMinMaxReduce)(backend, $x, axes[0], 'min');
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return out;
}
const $8865aeb73196640f$export$21836a5e5fa09eb4 = {
    kernelName: (0, $dCP8m.ArgMin),
    backendName: 'webgl',
    kernelFunc: $8865aeb73196640f$export$ec99a91cddfb29a2
};

});

parcelRegister("7v0dT", function(module, exports) {

$parcel$export(module.exports, "asinConfig", () => $575b99f30e81bb06$export$de5cb0ef95dd6700);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $2sCkP = parcelRequire("2sCkP");
const $575b99f30e81bb06$var$ASIN = (0, $2sCkP.CHECK_NAN_SNIPPET) + `
  if (abs(x) > 1.) {
    return NAN;
  }
  return asin(x);
`;
const $575b99f30e81bb06$export$41726bdb1fc63f = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $575b99f30e81bb06$var$ASIN
});
const $575b99f30e81bb06$export$de5cb0ef95dd6700 = {
    kernelName: (0, $dCP8m.Asin),
    backendName: 'webgl',
    kernelFunc: $575b99f30e81bb06$export$41726bdb1fc63f
};

});

parcelRegister("k4iSM", function(module, exports) {

$parcel$export(module.exports, "asinhConfig", () => $e9c2d41336851676$export$20d424616c76166);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $2sCkP = parcelRequire("2sCkP");
const $e9c2d41336851676$var$ASINH = (0, $2sCkP.CHECK_NAN_SNIPPET) + `return log(x + sqrt(x * x + 1.0));`;
const $e9c2d41336851676$export$839d8a01b6af4fc0 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $e9c2d41336851676$var$ASINH
});
const $e9c2d41336851676$export$20d424616c76166 = {
    kernelName: (0, $dCP8m.Asinh),
    backendName: 'webgl',
    kernelFunc: $e9c2d41336851676$export$839d8a01b6af4fc0
};

});

parcelRegister("9MT8i", function(module, exports) {

$parcel$export(module.exports, "atanConfig", () => $72035cf55cb171e1$export$159d632e3ff13624);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $2sCkP = parcelRequire("2sCkP");
const $72035cf55cb171e1$var$ATAN = (0, $2sCkP.CHECK_NAN_SNIPPET) + `
  return atan(x);
`;
const $72035cf55cb171e1$export$628dc4eed22b0fbd = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $72035cf55cb171e1$var$ATAN
});
const $72035cf55cb171e1$export$159d632e3ff13624 = {
    kernelName: (0, $dCP8m.Atan),
    backendName: 'webgl',
    kernelFunc: $72035cf55cb171e1$export$628dc4eed22b0fbd
};

});

parcelRegister("6opwh", function(module, exports) {

$parcel$export(module.exports, "atan2Config", () => $4a78c79ce56f2004$export$c53c7ab019edb8a0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $Ngeff = parcelRequire("Ngeff");

var $bMo9e = parcelRequire("bMo9e");

var $eWZon = parcelRequire("eWZon");
const $4a78c79ce56f2004$var$ATAN2 = (0, $Ngeff.CHECK_NAN_SNIPPET) + `
  return atan(a, b);
`;
const $4a78c79ce56f2004$var$ATAN2_PACKED = `
  vec4 result = atan(a, b);
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + (0, $bMo9e.CHECK_NAN_SNIPPET_PACKED) + `
  return result;
`;
const $4a78c79ce56f2004$export$b8b770ee6a0d9760 = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $4a78c79ce56f2004$var$ATAN2,
    packedOpSnippet: $4a78c79ce56f2004$var$ATAN2_PACKED
});
const $4a78c79ce56f2004$export$c53c7ab019edb8a0 = {
    kernelName: (0, $dCP8m.Atan2),
    backendName: 'webgl',
    kernelFunc: $4a78c79ce56f2004$export$b8b770ee6a0d9760
};

});

parcelRegister("keEiO", function(module, exports) {

$parcel$export(module.exports, "atanhConfig", () => $ebb460b268e0e06e$export$e9ce1ba75fc9b746);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $2sCkP = parcelRequire("2sCkP");
const $ebb460b268e0e06e$var$ATANH = (0, $2sCkP.CHECK_NAN_SNIPPET) + `
  if ((x < -1.0) || (x > 1.0)) return NAN;
return (log(1.0 + x) - log(1.0 - x)) / 2.0;`;
const $ebb460b268e0e06e$export$21ea955025ceb08b = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $ebb460b268e0e06e$var$ATANH
});
const $ebb460b268e0e06e$export$e9ce1ba75fc9b746 = {
    kernelName: (0, $dCP8m.Atanh),
    backendName: 'webgl',
    kernelFunc: $ebb460b268e0e06e$export$21ea955025ceb08b
};

});

parcelRegister("5L8mC", function(module, exports) {

$parcel$export(module.exports, "avgPoolConfig", () => $4317d46fcd755ad5$export$6c901824a23e6150);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");
var $wx9lK = parcelRequire("wx9lK");

var $9LJEi = parcelRequire("9LJEi");

var $4rulI = parcelRequire("4rulI");

var $fAHbJ = parcelRequire("fAHbJ");
function $4317d46fcd755ad5$export$d5c65a2abd3d97dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $4rulI.assertNotComplex)(x, 'avgPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $wx9lK).assert((0, $lkN62).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in avgPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $lkN62).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $wx9lK).arraysEqual(convInfo.inShape, convInfo.outShape)) return (0, $fAHbJ.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const avgPoolProgram = new (0, $9LJEi.Pool2DProgram)(convInfo, 'avg', false);
    return backend.runWebGLProgram(avgPoolProgram, [
        x
    ], 'float32');
}
const $4317d46fcd755ad5$export$6c901824a23e6150 = {
    kernelName: (0, $dCP8m.AvgPool),
    backendName: 'webgl',
    kernelFunc: $4317d46fcd755ad5$export$d5c65a2abd3d97dc
};

});
parcelRegister("9LJEi", function(module, exports) {

$parcel$export(module.exports, "Pool2DProgram", () => $71cbe9c721d3b7cf$export$ddaa65439647a5ac);
$parcel$export(module.exports, "Pool3DProgram", () => $71cbe9c721d3b7cf$export$a835a97097fdbb0f);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $71cbe9c721d3b7cf$export$ddaa65439647a5ac {
    constructor(convInfo, poolType, computePositions, flattenPositions = false, includeBatchInIndex = false){
        this.variableNames = [
            'x'
        ];
        if (poolType === 'avg' && computePositions) throw new Error('Cannot compute positions for average pool.');
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        this.outputShape = convInfo.outShape;
        const isAvgPool = poolType === 'avg';
        const batchFlattenPositionStr = `((batch  * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + d`;
        const flattenPositionStr = `(xR * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + d`;
        let initializationValue = '0.0';
        if (!isAvgPool) // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
        initializationValue = '-1.0 / 1e-20';
        if (computePositions) {
            const compareOp = '>=';
            this.userCode = `
        const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
        const ivec2 pads = ivec2(${padTop}, ${padLeft});

        void main() {
          ivec4 coords = getOutputCoords();
          int batch = coords[0];
          int d = coords[3];

          ivec2 xRCCorner = coords.yz * strides - pads;
          int xRCorner = xRCCorner.x;
          int xCCorner = xRCCorner.y;

          // max/min x(?, ?, d) to get y(yR, yC, d).
          // ? = to be determined
          float minMaxValue = 0.0;
          float minMaxValueFound = 0.0;
          int minMaxPosition = 0;
          float avgValue = 0.0;

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            int xR = xRCorner + wR;

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              int xC = xCCorner + wC;

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              float value = getX(batch, xR, xC, d);

              // If a min / max value has already been found, use it. If not,
              // use the current value.
              float currMinMaxValue = mix(
                  value, minMaxValue, minMaxValueFound);
              if (value ${compareOp} currMinMaxValue) {
                minMaxValue = value;
                minMaxValueFound = 1.0;
                minMaxPosition = ${flattenPositions ? includeBatchInIndex ? batchFlattenPositionStr : flattenPositionStr : `wR * ${effectiveFilterWidth} + wC`};
              }
            }
          }
          setOutput(float(minMaxPosition));
        }
      `;
            return;
        }
        const compareOp = 'max';
        let returnValue = `${poolType}(${poolType}(${poolType}(` + 'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
        if (poolType === 'avg') returnValue = `avgValue / count`;
        const filterWidthNearestVec4 = Math.floor(filterWidth / 4) * 4;
        const filterWidthVec4Remainder = filterWidth % 4;
        const updateSnippet = `
      if (${isAvgPool}) {
        avgValue += dot(values, ones);
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
      }
    `;
        this.userCode = `
      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float count = 0.0;

      float getValue(int batch, int xR, int xC, int d) {
        if (xC < 0 || xC >= ${convInfo.inWidth}) {
          return initializationValue;
        }
        count += 1.0;
        return getX(batch, xR, xC, d);
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d = coords[3];

        ivec2 xRCCorner = coords.yz * strides - pads;
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // max/min x(?, ?, d) to get y(yR, yC, d).
        // ? = to be determined
        vec4 minMaxValue = vec4(${initializationValue});
        float avgValue = 0.0;
        count = 0.0;

        for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
          int xR = xRCorner + wR;

          if (xR < 0 || xR >= ${convInfo.inHeight}) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidthNearestVec4}; wC += 4) {
            int xC = xCCorner + wC * ${dilationWidth};

            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              getValue(batch, xR, xC + 2 * ${dilationWidth}, d),
              getValue(batch, xR, xC + 3 * ${dilationWidth}, d)
            );

            ${updateSnippet}
          }

          int xC = xCCorner + ${filterWidthNearestVec4};
          if (${filterWidthVec4Remainder === 1}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              initializationValue,
              initializationValue,
              initializationValue
            );

            ${updateSnippet}
          } else if (${filterWidthVec4Remainder === 2}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              initializationValue,
              initializationValue
            );

            ${updateSnippet}
          } else if (${filterWidthVec4Remainder === 3}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              getValue(batch, xR, xC + 2 * ${dilationWidth}, d),
              initializationValue
            );

            ${updateSnippet}
          }
        }
        setOutput(${returnValue});
      }
    `;
    }
}
class $71cbe9c721d3b7cf$export$a835a97097fdbb0f {
    constructor(convInfo, poolType, computePositions, flattenPositions = false, includeBatchInIndex = false){
        this.variableNames = [
            'x'
        ];
        if (poolType === 'avg' && computePositions) throw new Error('Cannot compute positions for average pool.');
        const filterWidth = convInfo.filterWidth;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterDepth = convInfo.effectiveFilterDepth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padFront = convInfo.padInfo.front;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        this.outputShape = convInfo.outShape;
        const isAvgPool = poolType === 'avg';
        let initializationValue = '0.0';
        if (!isAvgPool) // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
        initializationValue = '-1.0 / 1e-20';
        if (computePositions) {
            const compareOp = '>=';
            this.userCode = `
        const ivec3 strides =
            ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
        const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

        void main() {
          ivec5 coords = getOutputCoords();
          int batch = coords.x;
          int ch = coords.u;

          ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
          int xDCorner = xCorner.x;
          int xRCorner = xCorner.y;
          int xCCorner = xCorner.z;

          // max/min x(?, ?, ?, ch) to get y(yD, yR, yC, ch).
          // ? = to be determined
          float minMaxValue = 0.0;
          float minMaxValueFound = 0.0;
          int minMaxPosition = 0;

          for (int wD = 0; wD < ${effectiveFilterDepth};
              wD += ${dilationDepth}) {
            int xD = xDCorner + wD;

            if (xD < 0 || xD >= ${convInfo.inDepth}) {
              continue;
            }

            for (int wR = 0; wR < ${effectiveFilterHeight};
                wR += ${dilationHeight}) {
              int xR = xRCorner + wR;

              if (xR < 0 || xR >= ${convInfo.inHeight}) {
                continue;
              }

              for (int wC = 0; wC < ${effectiveFilterWidth};
                  wC += ${dilationWidth}) {
                int xC = xCCorner + wC;

                if (xC < 0 || xC >= ${convInfo.inWidth}) {
                  continue;
                }

                float value = getX(batch, xD, xR, xC, ch);

                // If a min / max value has already been found, use it. If not,
                // use the current value.
                float currMinMaxValue = mix(
                    value, minMaxValue, minMaxValueFound);
                if (value ${compareOp} currMinMaxValue) {
                  minMaxValue = value;
                  minMaxValueFound = 1.0;
                  minMaxPosition = ${flattenPositions ? includeBatchInIndex ? `(((batch * ${convInfo.inDepth} + xD) * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + ch` : `((xD * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + ch` : `wD * ${effectiveFilterHeight} * ${effectiveFilterWidth} +
                      wR * ${effectiveFilterWidth} + wC`};
                }
              }
            }
          }
          setOutput(float(minMaxPosition));
        }
      `;
            return;
        }
        const compareOp = 'max';
        let returnValue = `${poolType}(${poolType}(${poolType}(` + 'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
        if (poolType === 'avg') returnValue = `avgValue / count`;
        const filterWidthNearestVec4 = Math.floor(filterWidth / 4) * 4;
        const filterWidthVec4Remainder = filterWidth % 4;
        const updateSnippet = `
      if (${isAvgPool}) {
        avgValue += dot(values, ones);
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
      }
    `;
        this.userCode = `
      const ivec3 strides =
        ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float count = 0.0;

      float getValue(int batch, int xD, int xR, int xC, int ch) {
        if (xC < 0 || xC >= ${convInfo.inWidth}) {
          return initializationValue;
        }
        count += 1.0;
        return getX(batch, xD, xR, xC, ch);
      }

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
        int xDCorner = xCorner.x;
        int xRCorner = xCorner.y;
        int xCCorner = xCorner.z;

        // max/min x(?, ?, ?, d) to get y(yD, yR, yC, ch).
        // ? = to be determined
        vec4 minMaxValue = vec4(${initializationValue});
        float avgValue = 0.0;
        count = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
            wD += ${dilationDepth}) {
          int xD = xDCorner + wD;

          if (xD < 0 || xD >= ${convInfo.inDepth}) {
            continue;
          }

          for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
            int xR = xRCorner + wR;

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${filterWidthNearestVec4}; wC += 4) {
              int xC = xCCorner + wC * ${dilationWidth};

              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 2 * ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 3 * ${dilationWidth}, ch)
              );

              ${updateSnippet}
            }

            int xC = xCCorner + ${filterWidthNearestVec4};
            if (${filterWidthVec4Remainder === 1}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                initializationValue,
                initializationValue,
                initializationValue
              );

              ${updateSnippet}
            } else if (${filterWidthVec4Remainder === 2}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                initializationValue,
                initializationValue
              );

              ${updateSnippet}
            } else if (${filterWidthVec4Remainder === 3}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 2 * ${dilationWidth}, ch),
                initializationValue
              );

              ${updateSnippet}
            }
          }
          setOutput(${returnValue});
        }
      }
    `;
    }
}

});


parcelRegister("7LLgD", function(module, exports) {

$parcel$export(module.exports, "avgPool3DConfig", () => $5a81967abd1651f2$export$5a9c81d240244392);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");

var $9LJEi = parcelRequire("9LJEi");
function $5a81967abd1651f2$export$8e92f7d23b27f144(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode, dataFormat: dataFormat } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $lkN62).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
    const avgPoolProgram = new (0, $9LJEi.Pool3DProgram)(convInfo, 'avg', false);
    return backend.runWebGLProgram(avgPoolProgram, [
        x
    ], 'float32');
}
const $5a81967abd1651f2$export$5a9c81d240244392 = {
    kernelName: (0, $dCP8m.AvgPool3D),
    backendName: 'webgl',
    kernelFunc: $5a81967abd1651f2$export$8e92f7d23b27f144
};

});

parcelRegister("6QKGO", function(module, exports) {

$parcel$export(module.exports, "avgPool3DGradConfig", () => $4fcbd0f767bb8198$export$1eeb8780807d0508);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");

var $hf6dT = parcelRequire("hf6dT");
function $4fcbd0f767bb8198$export$798cb4034e996ff4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $lkN62).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    const avgPoolBackpropProgram = new (0, $hf6dT.AvgPool3DBackpropProgram)(convInfo);
    return backend.runWebGLProgram(avgPoolBackpropProgram, [
        dy
    ], x.dtype);
}
const $4fcbd0f767bb8198$export$1eeb8780807d0508 = {
    kernelName: (0, $dCP8m.AvgPool3DGrad),
    backendName: 'webgl',
    kernelFunc: $4fcbd0f767bb8198$export$798cb4034e996ff4
};

});
parcelRegister("hf6dT", function(module, exports) {

$parcel$export(module.exports, "AvgPool2DBackpropProgram", () => $c8d8aa23429b6e37$export$5dc4ec478e6759de);
$parcel$export(module.exports, "AvgPool3DBackpropProgram", () => $c8d8aa23429b6e37$export$f166702869bc274f);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $c8d8aa23429b6e37$export$5dc4ec478e6759de {
    constructor(convInfo){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = convInfo.inShape;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const avgMultiplier = 1 / (filterHeight * filterWidth);
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float avgMultiplier = float(${avgMultiplier});

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];

        ivec2 dyRCCorner = coords.yz - pads;
        int dyRCorner = dyRCCorner.x;
        int dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          for (int wC = 0; wC < ${effectiveFilterWidth};
            wC+= ${dilationWidth}) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            float dyValue = getDy(b, idyR, idyC, d);

            dotProd += dyValue * avgMultiplier;
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $c8d8aa23429b6e37$export$f166702869bc274f {
    constructor(convInfo){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = convInfo.inShape;
        const filterDepth = convInfo.filterDepth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterDepth = convInfo.effectiveFilterDepth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const avgMultiplier = 1 / (filterDepth * filterHeight * filterWidth);
        this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});
      const float avgMultiplier = float(${avgMultiplier});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyDCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, d) with pos mask(:, :, :, ch) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
            wD += ${dilationDepth}) {
          float dyD = float(dyDCorner + wD) / ${strideDepth}.0;

          if (dyD < 0.0 || dyD >= ${convInfo.outDepth}.0 || fract(dyD) > 0.0) {
            continue;
          }
          int idyD = int(dyD);

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
                fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              float dyValue = getDy(batch, idyD, idyR, idyC, ch);

              dotProd += dyValue * avgMultiplier;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}

});


parcelRegister("jSyv2", function(module, exports) {

$parcel$export(module.exports, "avgPoolGradConfig", () => $e78dd25d9781d065$export$ac3f8709351ab225);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $lkN62 = parcelRequire("lkN62");

var $hf6dT = parcelRequire("hf6dT");

var $4rulI = parcelRequire("4rulI");
function $e78dd25d9781d065$export$2f098171d1c79aea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    (0, $4rulI.assertNotComplex)([
        dy,
        input
    ], 'avgPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
    const convInfo = (0, $lkN62).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad);
    const avgPoolBackpropProgram = new (0, $hf6dT.AvgPool2DBackpropProgram)(convInfo);
    return backend.runWebGLProgram(avgPoolBackpropProgram, [
        dy
    ], x.dtype);
}
const $e78dd25d9781d065$export$ac3f8709351ab225 = {
    kernelName: (0, $dCP8m.AvgPoolGrad),
    backendName: 'webgl',
    kernelFunc: $e78dd25d9781d065$export$2f098171d1c79aea
};

});

parcelRegister("6xZz2", function(module, exports) {

$parcel$export(module.exports, "batchMatMulConfig", () => $4c459479455f5090$export$d0dd993198185538);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $bxbCN = parcelRequire("bxbCN");
function $4c459479455f5090$export$8f97894b482227f0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b } = inputs;
    const { transposeA: transposeA, transposeB: transposeB } = attrs;
    return (0, $bxbCN.batchMatMulImpl)({
        a: a,
        b: b,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend
    });
}
const $4c459479455f5090$export$d0dd993198185538 = {
    kernelName: (0, $dCP8m.BatchMatMul),
    backendName: 'webgl',
    kernelFunc: $4c459479455f5090$export$8f97894b482227f0
};

});

parcelRegister("fCB5Q", function(module, exports) {

$parcel$export(module.exports, "batchNormConfig", () => $b5f72d8cd41e3293$export$df2dc5c7a755e418);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $dNJ9x = parcelRequire("dNJ9x");

var $fdYTP = parcelRequire("fdYTP");
const $b5f72d8cd41e3293$export$8ea8088e6d0cdd02 = ({ inputs: inputs, backend: backend, attrs: attrs })=>{
    const { x: x, mean: mean, variance: variance, offset: offset, scale: scale } = inputs;
    (0, $wx9lK).assert(mean.shape.length === variance.shape.length, ()=>"Batch normalization gradient requires mean and variance to have equal ranks.");
    (0, $wx9lK).assert(offset == null || mean.shape.length === offset.shape.length, ()=>"Batch normalization gradient requires mean and offset to have equal ranks.");
    (0, $wx9lK).assert(scale == null || mean.shape.length === scale.shape.length, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    let { varianceEpsilon: varianceEpsilon } = attrs;
    if (varianceEpsilon == null) varianceEpsilon = 0.001;
    const finalInputs = [
        x,
        mean,
        variance
    ];
    let offsetShape = null;
    if (offset != null) {
        offsetShape = offset.shape;
        finalInputs.push(offset);
    }
    let scaleShape = null;
    if (scale != null) {
        scaleShape = scale.shape;
        finalInputs.push(scale);
    }
    const program = (0, $aymVi.env)().getBool('WEBGL_PACK_NORMALIZATION') ? new (0, $fdYTP.BatchNormPackedProgram)(x.shape, mean.shape, variance.shape, offsetShape, scaleShape, varianceEpsilon) : new (0, $dNJ9x.BatchNormProgram)(x.shape, mean.shape, variance.shape, offsetShape, scaleShape, varianceEpsilon);
    const output = backend.runWebGLProgram(program, finalInputs, finalInputs[0].dtype);
    return output;
};
const $b5f72d8cd41e3293$export$df2dc5c7a755e418 = {
    kernelName: (0, $dCP8m.FusedBatchNorm),
    backendName: 'webgl',
    kernelFunc: $b5f72d8cd41e3293$export$8ea8088e6d0cdd02
};

});
parcelRegister("dNJ9x", function(module, exports) {

$parcel$export(module.exports, "BatchNormProgram", () => $a0c2e0651762cefd$export$bd15a4172044baef);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
class $a0c2e0651762cefd$export$bd15a4172044baef {
    constructor(xShape, meanShape, varianceShape, offsetShape, scaleShape, varianceEpsilon){
        this.outputShape = [];
        this.variableNames = [
            'x',
            'mean',
            'variance'
        ];
        (0, $lkN62).assertAndGetBroadcastShape(xShape, meanShape);
        (0, $lkN62).assertAndGetBroadcastShape(xShape, varianceShape);
        let offsetSnippet = '0.0';
        if (offsetShape != null) {
            (0, $lkN62).assertAndGetBroadcastShape(xShape, offsetShape);
            this.variableNames.push('offset');
            offsetSnippet = 'getOffsetAtOutCoords()';
        }
        let scaleSnippet = '1.0';
        if (scaleShape != null) {
            (0, $lkN62).assertAndGetBroadcastShape(xShape, scaleShape);
            this.variableNames.push('scale');
            scaleSnippet = 'getScaleAtOutCoords()';
        }
        this.outputShape = xShape;
        this.userCode = `
      void main() {
        float x = getXAtOutCoords();
        float mean = getMeanAtOutCoords();
        float variance = getVarianceAtOutCoords();
        float offset = ${offsetSnippet};
        float scale = ${scaleSnippet};
        float inv = scale * inversesqrt(variance + float(${varianceEpsilon}));
        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));
      }
    `;
    }
}

});

parcelRegister("fdYTP", function(module, exports) {

$parcel$export(module.exports, "BatchNormPackedProgram", () => $b1574f4b895941e7$export$cfdd4076f282cff6);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
class $b1574f4b895941e7$export$cfdd4076f282cff6 {
    constructor(xShape, meanShape, varianceShape, offsetShape, scaleShape, varianceEpsilon){
        this.packedInputs = true;
        this.packedOutput = true;
        this.variableNames = [
            'x',
            'mean',
            'variance'
        ];
        (0, $lkN62).assertAndGetBroadcastShape(xShape, meanShape);
        (0, $lkN62).assertAndGetBroadcastShape(xShape, varianceShape);
        let offsetSnippet = 'vec4(0.0)';
        if (offsetShape != null) {
            (0, $lkN62).assertAndGetBroadcastShape(xShape, offsetShape);
            this.variableNames.push('offset');
            offsetSnippet = 'getOffsetAtOutCoords()';
        }
        let scaleSnippet = 'vec4(1.0)';
        if (scaleShape != null) {
            (0, $lkN62).assertAndGetBroadcastShape(xShape, scaleShape);
            this.variableNames.push('scale');
            scaleSnippet = 'getScaleAtOutCoords()';
        }
        this.outputShape = xShape;
        this.userCode = `
      void main() {
        vec4 offset = ${offsetSnippet};
        vec4 scale = ${scaleSnippet};

        vec4 x = getXAtOutCoords();
        vec4 mean = getMeanAtOutCoords();
        vec4 variance = getVarianceAtOutCoords();

        vec4 inv = scale * inversesqrt(variance + vec4(${varianceEpsilon}));

        setOutput((x - mean) * inv + offset);
      }
    `;
    }
}

});


parcelRegister("8fAez", function(module, exports) {

$parcel$export(module.exports, "batchToSpaceNDConfig", () => $601bd4bf185921bf$export$44e08e19f97e5513);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $9gI7w = parcelRequire("9gI7w");

var $agNmS = parcelRequire("agNmS");

var $lHu0m = parcelRequire("lHu0m");
const $601bd4bf185921bf$export$ea37d960c1808536 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, crops: crops } = attrs;
    (0, $wx9lK).assert(x.shape.length <= 4, ()=>"batchToSpaceND for rank > 4 with a WebGL backend not implemented yet");
    const prod = blockShape.reduce((a, b)=>a * b);
    const reshaped = (0, $lkN62).getReshaped(x.shape, blockShape, prod);
    const permuted = (0, $lkN62).getPermuted(reshaped.length, blockShape.length);
    const reshapedPermuted = (0, $lkN62).getReshapedPermuted(x.shape, blockShape, prod);
    const sliceBeginCoords = (0, $lkN62).getSliceBeginCoords(crops, blockShape.length);
    const sliceSize = (0, $lkN62).getSliceSize(reshapedPermuted, crops, blockShape.length);
    const toDispose = [];
    const reshapedIntermediate = (0, $9gI7w.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: reshaped
        }
    });
    const transposedIntermediate = (0, $lHu0m.transpose)({
        inputs: {
            x: reshapedIntermediate
        },
        backend: backend,
        attrs: {
            perm: permuted
        }
    });
    const reshapedIntermediate2 = (0, $9gI7w.reshape)({
        inputs: {
            x: transposedIntermediate
        },
        backend: backend,
        attrs: {
            shape: reshapedPermuted
        }
    });
    const sliced = (0, $agNmS.slice)({
        inputs: {
            x: reshapedIntermediate2
        },
        backend: backend,
        attrs: {
            begin: sliceBeginCoords,
            size: sliceSize
        }
    });
    toDispose.push(reshapedIntermediate);
    toDispose.push(transposedIntermediate);
    toDispose.push(reshapedIntermediate2);
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return sliced;
};
const $601bd4bf185921bf$export$44e08e19f97e5513 = {
    kernelName: (0, $dCP8m.BatchToSpaceND),
    backendName: 'webgl',
    kernelFunc: $601bd4bf185921bf$export$ea37d960c1808536
};

});
parcelRegister("agNmS", function(module, exports) {

$parcel$export(module.exports, "slice", () => $77a1b16f5eca75e2$export$58adb3bec8346d0f);
$parcel$export(module.exports, "sliceConfig", () => $77a1b16f5eca75e2$export$8d8a1e11dd2cc6c4);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");
var $1KPDG = parcelRequire("1KPDG");
var $wx9lK = parcelRequire("wx9lK");

var $fIVdF = parcelRequire("fIVdF");

var $jySO5 = parcelRequire("jySO5");

var $6xg3Z = parcelRequire("6xg3Z");
function $77a1b16f5eca75e2$var$shallowSlice(x, begin, size, backend) {
    const xTexData = backend.texData.get(x.dataId);
    const t = backend.makeTensorInfo(size, x.dtype);
    const newTexData = backend.texData.get(t.dataId);
    // Copy texture data from the original tensor.
    Object.assign(newTexData, xTexData);
    newTexData.refCount = 1;
    newTexData.shape = size;
    newTexData.dtype = x.dtype;
    let flatOffset = (0, $1KPDG).computeFlatOffset(begin, (0, $wx9lK).computeStrides(x.shape));
    if (xTexData.slice) // We are slicing an already sliced tensor, so we have to accumulate
    // the offset.
    flatOffset += xTexData.slice.flatOffset;
    newTexData.slice = {
        flatOffset: flatOffset,
        // Point to the original dataId, which is used to do ref counting.
        origDataId: xTexData.slice && xTexData.slice.origDataId || x.dataId
    };
    // Increase the ref count for that data bucket.
    const refCount = backend.dataRefCount.get(newTexData.slice.origDataId) || 1;
    backend.dataRefCount.set(newTexData.slice.origDataId, refCount + 1);
    return t;
}
function $77a1b16f5eca75e2$export$58adb3bec8346d0f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, size: size } = attrs;
    const [$begin, $size] = (0, $1KPDG).parseSliceParams(x, begin, size);
    (0, $1KPDG).assertParamsValid(x, $begin, $size);
    if ((0, $wx9lK).sizeFromShape($size) === 0) return backend.makeTensorInfo($size, x.dtype, []);
    // Run on cpu if dtype is string. For string, the backend represents it
    // as Uint8Array[], where each Uint8Array is a character. Given that the
    // computation is only on the outer array, uploading the whole data onto
    // gpu is wasteful. Also, currently webgl doesn't have a design to
    // upload and retrieve Uint8Array[] between cpu and gpu. Therefore, we
    // just run the kernel on cpu if dtype is string.
    if (backend.shouldExecuteOnCPU([
        x
    ]) || x.dtype === 'string') {
        const xTexData = backend.texData.get(x.dataId);
        const outValues = (0, $fIVdF.sliceImplCPU)(xTexData.values, $begin, $size, x.shape, x.dtype);
        return backend.makeTensorInfo($size, x.dtype, outValues);
    }
    const { isPacked: isPacked } = backend.texData.get(x.dataId);
    const isContinous = (0, $1KPDG).isSliceContinous(x.shape, $begin, $size);
    if (isPacked || !isContinous) {
        const program = (0, $aymVi.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $6xg3Z.SlicePackedProgram)($size) : new (0, $jySO5.SliceProgram)($size);
        const customValues = [
            $begin
        ];
        return backend.runWebGLProgram(program, [
            x
        ], x.dtype, customValues);
    }
    backend.uploadToGPU(x.dataId);
    return $77a1b16f5eca75e2$var$shallowSlice(x, $begin, $size, backend);
}
const $77a1b16f5eca75e2$export$8d8a1e11dd2cc6c4 = {
    kernelName: (0, $dCP8m.Slice),
    backendName: 'webgl',
    kernelFunc: $77a1b16f5eca75e2$export$58adb3bec8346d0f
};

});
parcelRegister("jySO5", function(module, exports) {

$parcel$export(module.exports, "SliceProgram", () => $e3dbb4cbd752f159$export$ef8bf52bc4951c85);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7svrP = parcelRequire("7svrP");
class $e3dbb4cbd752f159$export$ef8bf52bc4951c85 {
    constructor(destSize){
        this.variableNames = [
            'source'
        ];
        this.outputShape = destSize;
        this.rank = destSize.length;
        const dtype = (0, $7svrP.getCoordsDataType)(this.rank);
        this.customUniforms = [
            {
                name: 'start',
                arrayIndex: this.rank,
                type: 'int'
            }
        ];
        const sourceCoords = $e3dbb4cbd752f159$var$getCoords(this.rank);
        let body;
        const coordSum = destSize.map((_, i)=>{
            return `sourceLoc.${$e3dbb4cbd752f159$var$coords[i]} = start[${i}] + coords.${$e3dbb4cbd752f159$var$coords[i]};`;
        });
        body = `
        ${dtype} sourceLoc;
        ${dtype} coords = getOutputCoords();
        ${coordSum.join('\n')}
      `;
        this.userCode = `
      void main() {
        ${body}
        setOutput(getSource(${sourceCoords}));
      }
    `;
    }
}
const $e3dbb4cbd752f159$var$coords = [
    'x',
    'y',
    'z',
    'w',
    'u',
    'v'
];
function $e3dbb4cbd752f159$var$getCoords(rank) {
    if (rank === 1) return 'sourceLoc';
    else if (rank <= 6) return $e3dbb4cbd752f159$var$coords.slice(0, rank).map((x)=>'sourceLoc.' + x).join(',');
    else throw Error(`Slicing for rank ${rank} is not yet supported`);
}

});

parcelRegister("6xg3Z", function(module, exports) {

$parcel$export(module.exports, "SlicePackedProgram", () => $4c2248ff9c9dacca$export$a6c6101de259f77);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $2351m = parcelRequire("2351m");

var $7svrP = parcelRequire("7svrP");
class $4c2248ff9c9dacca$export$a6c6101de259f77 {
    constructor(destSize){
        this.variableNames = [
            'source'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = destSize;
        this.rank = destSize.length;
        this.customUniforms = [
            {
                name: 'start',
                arrayIndex: this.rank,
                type: 'int'
            }
        ];
        const dtype = (0, $7svrP.getCoordsDataType)(this.rank);
        const coords = (0, $2351m.getChannels)('coords', this.rank);
        const sourceLoc = (0, $2351m.getChannels)('sourceLoc', this.rank);
        const innerDims = this.rank === 1 ? 'sourceLoc' : `vec2(${sourceLoc.slice(-2).join()})`;
        const getChannel = `getChannel(getSource(${sourceLoc.join()}), ${innerDims})`;
        const upperRow = `
      result.x = ${getChannel};
      if (++${coords[this.rank - 1]} < ${destSize[this.rank - 1]}) {
        ++${sourceLoc[this.rank - 1]};
        result.y = ${getChannel};
        --${sourceLoc[this.rank - 1]};
      }
    `;
        const lowerRow = this.rank === 1 ? '' : `
      --${coords[this.rank - 1]};
      if (++${coords[this.rank - 2]} < ${destSize[this.rank - 2]}) {
        ++${sourceLoc[this.rank - 2]};
        result.z = ${getChannel};
        if (++${coords[this.rank - 1]} < ${destSize[this.rank - 1]}) {
          ++${sourceLoc[this.rank - 1]};
          result.w = ${getChannel};
        }
      }
    `;
        const sourceLocSetup = this.rank <= 4 ? `sourceLoc = coords +
            ${dtype}(${destSize.map((_, i)=>`start[${i}]`).join()});` : destSize.map((_, i)=>`${sourceLoc[i]} = ${coords[i]} + start[${i}];`).join('\n');
        this.userCode = `
      void main() {
        ${dtype} coords = getOutputCoords();
        ${dtype} sourceLoc;
        ${sourceLocSetup}
        vec4 result = vec4(0.);
        ${upperRow}
        ${lowerRow}
        setOutput(result);
      }
    `;
    }
}

});



parcelRegister("1zuvT", function(module, exports) {

$parcel$export(module.exports, "bincountConfig", () => $1250baa223e598b1$export$af9f0093738840fb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
function $1250baa223e598b1$export$7e474bab088ed182(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size } = attrs;
    const xVals = backend.readSync(x.dataId);
    const weightsVals = backend.readSync(weights.dataId);
    const outVals = (0, $fIVdF.bincountImplCPU)(xVals, weightsVals, weights.dtype, weights.shape, size);
    return backend.makeTensorInfo([
        size
    ], weights.dtype, outVals);
}
const $1250baa223e598b1$export$af9f0093738840fb = {
    kernelName: (0, $dCP8m.Bincount),
    backendName: 'webgl',
    kernelFunc: $1250baa223e598b1$export$7e474bab088ed182
};

});

parcelRegister("caYPG", function(module, exports) {

$parcel$export(module.exports, "broadcastArgsConfig", () => $8dd59b4b53944d3c$export$8f7b2ec0c6f08fb2);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
function $8dd59b4b53944d3c$export$d226d344aedce941(args) {
    const { inputs: inputs, backend: backend } = args;
    const { s0: s0, s1: s1 } = inputs;
    const s0Vals = backend.readSync(s0.dataId);
    const s1Vals = backend.readSync(s1.dataId);
    const broadcastShape = (0, $lkN62).assertAndGetBroadcastShape(Array.from(s0Vals), Array.from(s1Vals));
    return backend.makeTensorInfo([
        broadcastShape.length
    ], 'int32', Int32Array.from(broadcastShape));
}
const $8dd59b4b53944d3c$export$8f7b2ec0c6f08fb2 = {
    kernelName: (0, $dCP8m.BroadcastArgs),
    backendName: 'webgl',
    kernelFunc: $8dd59b4b53944d3c$export$d226d344aedce941
};

});

parcelRegister("3kRxy", function(module, exports) {

$parcel$export(module.exports, "castConfig", () => $26dcc5557a631a1a$export$ac4d0f0f3927a8f3);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");
var $7KCJq = parcelRequire("7KCJq");

var $fIVdF = parcelRequire("fIVdF");

var $3GoRo = parcelRequire("3GoRo");

var $fAHbJ = parcelRequire("fAHbJ");

var $b03VH = parcelRequire("b03VH");

var $7H3BA = parcelRequire("7H3BA");

var $93SYc = parcelRequire("93SYc");
function $26dcc5557a631a1a$export$f2db7d5238e1d23f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dtype: dtype } = attrs;
    // Casting to complex64.
    if (dtype === 'complex64') {
        if (x.dtype === 'complex64') return (0, $fAHbJ.identity)({
            inputs: {
                x: x
            },
            backend: backend
        });
        // TODO(annxingyuan): Import kernel function once zeros is modularized.
        const zerosTensor = $7KCJq.zeros(x.shape);
        const floatX = $26dcc5557a631a1a$export$f2db7d5238e1d23f({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const result = (0, $3GoRo.complex)({
            inputs: {
                real: floatX,
                imag: zerosTensor
            },
            backend: backend
        });
        zerosTensor.dispose();
        backend.disposeIntermediateTensorInfo(floatX);
        return result;
    }
    // Casting from complex64
    if (x.dtype === 'complex64') {
        const realPart = (0, $7H3BA.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const result = $26dcc5557a631a1a$export$f2db7d5238e1d23f({
            inputs: {
                x: realPart
            },
            backend: backend,
            attrs: {
                dtype: dtype
            }
        });
        backend.disposeIntermediateTensorInfo(realPart);
        return result;
    }
    if (!(0, $wx9lK).hasEncodingLoss(x.dtype, dtype)) {
        // We don't change the underlying data, since we cast to higher
        // precision.
        const result = (0, $fAHbJ.identity)({
            inputs: {
                x: x
            },
            backend: backend
        });
        return {
            dataId: result.dataId,
            shape: result.shape,
            dtype: dtype
        };
    }
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const values = backend.texData.get(x.dataId).values;
        const [resultShape, resultType, resultData] = (0, $fIVdF.castImplCPU)(values, x.shape, x.dtype, dtype);
        return backend.makeTensorInfo(resultShape, resultType, resultData);
    }
    if (dtype === 'int32') return (0, $93SYc.int)(x, backend);
    if (dtype === 'bool') {
        const zerosTensorInfo = backend.makeTensorInfo([], 'bool', (0, $wx9lK).getTypedArrayFromDType('bool', 1));
        const binaryInputs = {
            a: x,
            b: zerosTensorInfo
        };
        const result = (0, $b03VH.notEqual)({
            inputs: binaryInputs,
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(zerosTensorInfo);
        return result;
    }
    throw new Error(`Error in Cast: failed to cast ${x.dtype} to ${dtype}`);
}
const $26dcc5557a631a1a$export$ac4d0f0f3927a8f3 = {
    kernelName: (0, $dCP8m.Cast),
    backendName: 'webgl',
    kernelFunc: $26dcc5557a631a1a$export$f2db7d5238e1d23f
};

});
parcelRegister("b03VH", function(module, exports) {

$parcel$export(module.exports, "notEqual", () => $8022be26d0526379$export$53a6892c50694894);
$parcel$export(module.exports, "notEqualConfig", () => $8022be26d0526379$export$d003d4d7e1500775);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $8022be26d0526379$var$NOT_EQUAL = `return float(a != b);`;
const $8022be26d0526379$export$53a6892c50694894 = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $8022be26d0526379$var$NOT_EQUAL,
    cpuKernelImpl: (0, $fIVdF.notEqualImplCPU),
    dtype: 'bool'
});
const $8022be26d0526379$export$d003d4d7e1500775 = {
    kernelName: (0, $dCP8m.NotEqual),
    backendName: 'webgl',
    kernelFunc: $8022be26d0526379$export$53a6892c50694894
};

});

parcelRegister("7H3BA", function(module, exports) {

$parcel$export(module.exports, "real", () => $599f5879f1c6f389$export$9fc57fb453bdbd67);
$parcel$export(module.exports, "realConfig", () => $599f5879f1c6f389$export$4b7bce57557ae68b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fAHbJ = parcelRequire("fAHbJ");
function $599f5879f1c6f389$export$9fc57fb453bdbd67(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputData = backend.texData.get(input.dataId);
    return (0, $fAHbJ.identity)({
        inputs: {
            x: inputData.complexTensorInfos.real
        },
        backend: backend
    });
}
const $599f5879f1c6f389$export$4b7bce57557ae68b = {
    kernelName: (0, $dCP8m.Real),
    backendName: 'webgl',
    kernelFunc: $599f5879f1c6f389$export$9fc57fb453bdbd67
};

});

parcelRegister("93SYc", function(module, exports) {

$parcel$export(module.exports, "int", () => $698f08c6b6db9b6e$export$7d260a2a5f8bc19e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $2sCkP = parcelRequire("2sCkP");
const $698f08c6b6db9b6e$var$TO_INT = `return float(int(x));`;
function $698f08c6b6db9b6e$export$7d260a2a5f8bc19e(input, backend) {
    const program = new (0, $2sCkP.UnaryOpProgram)(input.shape, $698f08c6b6db9b6e$var$TO_INT);
    const output = backend.runWebGLProgram(program, [
        input
    ], 'int32');
    return {
        dataId: output.dataId,
        shape: output.shape,
        dtype: output.dtype
    };
}

});


parcelRegister("hUZPk", function(module, exports) {

$parcel$export(module.exports, "ceilConfig", () => $d0b7a024737c9d5b$export$df387212b1898306);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $d0b7a024737c9d5b$var$CEIL = `return ceil(x);`;
const $d0b7a024737c9d5b$export$803ce6b71a0a94b2 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $d0b7a024737c9d5b$var$CEIL,
    packedOpSnippet: $d0b7a024737c9d5b$var$CEIL,
    cpuKernelImpl: (0, $fIVdF.ceilImplCPU)
});
const $d0b7a024737c9d5b$export$df387212b1898306 = {
    kernelName: (0, $dCP8m.Ceil),
    backendName: 'webgl',
    kernelFunc: $d0b7a024737c9d5b$export$803ce6b71a0a94b2
};

});

parcelRegister("2CZf9", function(module, exports) {

$parcel$export(module.exports, "clipByValueConfig", () => $1e9ea306a664a5ee$export$f7ee8f07ce0ff4e1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $aymVi = parcelRequire("aymVi");

var $8XX9S = parcelRequire("8XX9S");

var $eV84P = parcelRequire("eV84P");
function $1e9ea306a664a5ee$export$fa97baf70ad024c0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { clipValueMin: clipValueMin, clipValueMax: clipValueMax } = attrs;
    let program;
    if ((0, $aymVi.env)().getBool('WEBGL_PACK_CLIP')) program = new (0, $eV84P.ClipPackedProgram)(x.shape);
    else program = new (0, $8XX9S.ClipProgram)(x.shape);
    const customValues = [
        [
            clipValueMin
        ],
        [
            clipValueMax
        ]
    ];
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype, customValues);
}
const $1e9ea306a664a5ee$export$f7ee8f07ce0ff4e1 = {
    kernelName: (0, $dCP8m.ClipByValue),
    backendName: 'webgl',
    kernelFunc: $1e9ea306a664a5ee$export$fa97baf70ad024c0
};

});
parcelRegister("8XX9S", function(module, exports) {

$parcel$export(module.exports, "ClipProgram", () => $6871b9008d433b2a$export$ce48b7c79e7985d1);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $6871b9008d433b2a$export$ce48b7c79e7985d1 {
    constructor(aShape){
        this.variableNames = [
            'A'
        ];
        this.customUniforms = [
            {
                name: 'minVal',
                type: 'float'
            },
            {
                name: 'maxVal',
                type: 'float'
            }
        ];
        this.outputShape = aShape;
        this.userCode = `

      void main() {
        float value = getAAtOutCoords();
        if (isnan(value)) {
          setOutput(value);
          return;
        }

        setOutput(clamp(value, minVal, maxVal));
      }
    `;
    }
}

});

parcelRegister("eV84P", function(module, exports) {

$parcel$export(module.exports, "ClipPackedProgram", () => $adcca773148e1801$export$812909708a626d33);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $adcca773148e1801$export$812909708a626d33 {
    constructor(aShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'minVal',
                type: 'float'
            },
            {
                name: 'maxVal',
                type: 'float'
            }
        ];
        this.outputShape = aShape;
        this.userCode = `
      void main() {
        vec4 value = getAAtOutCoords();

        if (any(isnan(value))) {
          setOutput(value);
          return;
        }

        setOutput(clamp(value, vec4(minVal), vec4(maxVal)));
      }
    `;
    }
}

});


parcelRegister("6dlLT", function(module, exports) {

$parcel$export(module.exports, "complexAbsConfig", () => $4864d850580faef1$export$a4817d2978acc054);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fvrqi = parcelRequire("fvrqi");
// Returns a TensorInfo with the complex shape and the dataId of the
// underlying part. We need to do this because a reshaped complex tensor is
// not reflected in its parts.
function $4864d850580faef1$var$makeComplexComponentTensorInfo(complexTensor, complexPart) {
    return {
        dataId: complexPart.dataId,
        dtype: complexPart.dtype,
        shape: complexTensor.shape
    };
}
function $4864d850580faef1$export$2837bc62566f8808(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const xData = backend.texData.get(x.dataId);
    const program = new (0, $fvrqi.ComplexAbsProgram)(x.shape);
    const programInputs = [
        $4864d850580faef1$var$makeComplexComponentTensorInfo(x, xData.complexTensorInfos.real),
        $4864d850580faef1$var$makeComplexComponentTensorInfo(x, xData.complexTensorInfos.imag)
    ];
    return backend.runWebGLProgram(program, programInputs, programInputs[0].dtype);
}
const $4864d850580faef1$export$a4817d2978acc054 = {
    kernelName: (0, $dCP8m.ComplexAbs),
    backendName: 'webgl',
    kernelFunc: $4864d850580faef1$export$2837bc62566f8808
};

});
parcelRegister("fvrqi", function(module, exports) {

$parcel$export(module.exports, "ComplexAbsProgram", () => $b49f05e863d68442$export$d03dbc86862098f5);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $b49f05e863d68442$export$d03dbc86862098f5 {
    constructor(shape){
        this.variableNames = [
            'real',
            'imag'
        ];
        this.outputShape = shape;
        this.userCode = `
      void main() {
        float re = abs(getRealAtOutCoords());
        float im = abs(getImagAtOutCoords());
        float mx = max(re, im);

        // sadly the length function in glsl is not underflow-safe
        // (at least not on Intel GPUs). So the safe solution is
        // to ensure underflow-safety in all cases.
        setOutput(
          mx == 0.0 ? 0.0 : mx * length(vec2(1, min(re, im)/mx))
        );
      }
    `;
    }
}

});


parcelRegister("k5Is6", function(module, exports) {

$parcel$export(module.exports, "concat", () => $ea06c190d1cda489$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "concatConfig", () => $ea06c190d1cda489$export$c8cf96dae25282e5);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $5emvl = parcelRequire("5emvl");

var $fAHbJ = parcelRequire("fAHbJ");
function $ea06c190d1cda489$export$ee1b3e54f0441b22(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    const $axis = (0, $wx9lK).parseAxisParam(axis, inputs[0].shape)[0];
    const shapes = inputs.map((t)=>t.shape);
    (0, $lkN62).assertParamsConsistent(shapes, $axis);
    const outShape = (0, $lkN62).computeOutShape(inputs.map((t)=>t.shape), $axis);
    if ((0, $wx9lK).sizeFromShape(outShape) === 0) return backend.makeTensorInfo(outShape, inputs[0].dtype, []);
    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
    const $inputs = inputs.filter((t)=>(0, $wx9lK).sizeFromShape(t.shape) > 0);
    if ($inputs.length === 1) return (0, $fAHbJ.identity)({
        inputs: {
            x: $inputs[0]
        },
        backend: backend
    });
    return (0, $5emvl.concatImpl)($inputs, $axis, backend);
}
const $ea06c190d1cda489$export$c8cf96dae25282e5 = {
    kernelName: (0, $dCP8m.Concat),
    backendName: 'webgl',
    kernelFunc: $ea06c190d1cda489$export$ee1b3e54f0441b22
};

});
parcelRegister("5emvl", function(module, exports) {

$parcel$export(module.exports, "concatImpl", () => $3cefb77eea96e1eb$export$777da59f594f497d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $aymVi = parcelRequire("aymVi");
var $wx9lK = parcelRequire("wx9lK");

var $1d80r = parcelRequire("1d80r");

var $lvoID = parcelRequire("lvoID");

var $fIVdF = parcelRequire("fIVdF");

var $3GoRo = parcelRequire("3GoRo");

var $j8iVA = parcelRequire("j8iVA");

var $7H3BA = parcelRequire("7H3BA");

var $9gI7w = parcelRequire("9gI7w");
function $3cefb77eea96e1eb$export$777da59f594f497d(inputs, axis, backend) {
    const dtype = inputs[0].dtype;
    if (dtype === 'complex64') {
        const reals = inputs.map((t)=>(0, $7H3BA.real)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const imags = inputs.map((t)=>(0, $j8iVA.imag)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const realConcated = $3cefb77eea96e1eb$export$777da59f594f497d(reals, axis, backend);
        const imagConcated = $3cefb77eea96e1eb$export$777da59f594f497d(imags, axis, backend);
        const result = (0, $3GoRo.complex)({
            inputs: {
                real: realConcated,
                imag: imagConcated
            },
            backend: backend
        });
        reals.forEach((r)=>backend.disposeIntermediateTensorInfo(r));
        imags.forEach((i)=>backend.disposeIntermediateTensorInfo(i));
        backend.disposeIntermediateTensorInfo(realConcated);
        backend.disposeIntermediateTensorInfo(imagConcated);
        return result;
    }
    let runOnCpu = backend.shouldExecuteOnCPU(inputs);
    // Run on cpu if dtype is string. For string, the backend represents it
    // as Uint8Array[], where each Uint8Array is a character. Given that the
    // computation is only on the outer array, uploading the whole data onto
    // gpu is wasteful. Also, currently webgl doesn't have a design to
    // upload and retrieve Uint8Array[] between cpu and gpu. Therefore, we
    // just run the kernel on cpu if dtype is string.
    if (dtype === 'string') runOnCpu = true;
    if (runOnCpu) {
        // Any concat of n-dimensional tensors across any axis can be reduced to
        // a concatenation of two-dimensional tensors across the axis 1 by first
        // partitioning the axes of the original tensors into those less than the
        // axis to be concatenated and the rest. Then reshape the tensors
        // into a two-dimensional tensor by collapsing these two sets of axes and
        // concatenate the resulting matrices across the axis 1, finally reshaping
        // the result to have the proper shape.
        const tensors2D = inputs.map((t)=>{
            const innerSize = (0, $wx9lK).sizeFromShape(t.shape.slice(axis));
            const shape = [
                -1,
                innerSize
            ];
            return (0, $9gI7w.reshape)({
                inputs: {
                    x: t
                },
                backend: backend,
                attrs: {
                    shape: shape
                }
            });
        });
        const inputsValShapes = tensors2D.map((t)=>{
            return {
                vals: backend.readSync(t.dataId),
                shape: t.shape
            };
        });
        // Concats 2d tensors along axis=1.
        const outShape = (0, $lkN62).computeOutShape(tensors2D.map((t)=>t.shape), 1 /* axis */ );
        const simplyConcat = tensors2D[0].shape[0] === 1;
        const outVals = (0, $fIVdF.concatImplCPU)(inputsValShapes, outShape, dtype, simplyConcat);
        const finalOutShape = (0, $lkN62).computeOutShape(inputs.map((t)=>t.shape), axis);
        const outInfo = backend.makeTensorInfo(finalOutShape, dtype, outVals);
        tensors2D.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
        return outInfo;
    }
    const maxTexturesInShader = (0, $aymVi.env)().getNumber('WEBGL_MAX_TEXTURES_IN_SHADER');
    if (inputs.length > maxTexturesInShader) {
        const reducedInputs = [];
        for(let i = 0; i < inputs.length; i += maxTexturesInShader){
            const subArray = inputs.slice(i, i + maxTexturesInShader);
            reducedInputs.push($3cefb77eea96e1eb$export$777da59f594f497d(subArray, axis, backend));
        }
        const result = $3cefb77eea96e1eb$export$777da59f594f497d(reducedInputs, axis, backend);
        for (const i of reducedInputs)backend.disposeIntermediateTensorInfo(i);
        return result;
    }
    if ((0, $aymVi.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') && inputs[0].shape.length > 1) {
        const program = new (0, $lvoID.ConcatPackedProgram)(inputs.map((t)=>t.shape), axis);
        return backend.runWebGLProgram(program, inputs, dtype);
    }
    const { tensors2D: tensors2D, outShape: outShape } = $3cefb77eea96e1eb$var$computeTensors2D(inputs, axis, backend);
    const program = new (0, $1d80r.ConcatProgram)(tensors2D.map((t)=>t.shape));
    const result = backend.runWebGLProgram(program, tensors2D, dtype);
    tensors2D.forEach((r)=>backend.disposeIntermediateTensorInfo(r));
    const reshapedResult = (0, $9gI7w.reshape)({
        inputs: {
            x: result
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(result);
    return reshapedResult;
}
function $3cefb77eea96e1eb$var$computeTensors2D(inputs, axis, backend) {
    // Any concat of n-dimensional tensors across any axis can be reduced to
    // a concatenation of two-dimensional tensors across the axis 1 by first
    // partitioning the axes of the original tensors into those less than the
    // axis to be concatenated and the rest. Then reshape the tensors
    // into a two-dimensional tensor by collapsing these two sets of axes and
    // concatenate the resulting matrices across the axis 1, finally reshaping
    // the result to have the proper shape.
    const outShape = (0, $lkN62).computeOutShape(inputs.map((t)=>t.shape), axis);
    const tensors2D = inputs.map((x)=>(0, $9gI7w.reshape)({
            inputs: {
                x: x
            },
            attrs: {
                shape: [
                    -1,
                    (0, $wx9lK).sizeFromShape(x.shape.slice(axis))
                ]
            },
            backend: backend
        }));
    return {
        tensors2D: tensors2D,
        outShape: outShape
    };
}

});
parcelRegister("1d80r", function(module, exports) {

$parcel$export(module.exports, "ConcatProgram", () => $0e1d372f88ef655b$export$9059cb52ee2cb142);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
class $0e1d372f88ef655b$export$9059cb52ee2cb142 {
    // Concats 2d tensors along axis=1. See comments in MathBackendWebGL.concat().
    constructor(shapes){
        this.outputShape = [];
        this.outputShape = (0, $lkN62).computeOutShape(shapes, 1 /* axis */ );
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const offsets = new Array(shapes.length - 1);
        offsets[0] = shapes[0][1];
        for(let i = 1; i < offsets.length; i++)offsets[i] = offsets[i - 1] + shapes[i][1];
        const snippets = [
            `if (yC < ${offsets[0]}) setOutput(getT0(yR, yC));`
        ];
        for(let i = 1; i < offsets.length; i++){
            const shift = offsets[i - 1];
            snippets.push(`else if (yC < ${offsets[i]}) ` + `setOutput(getT${i}(yR, yC-${shift}));`);
        }
        const lastIndex = offsets.length;
        const lastShift = offsets[offsets.length - 1];
        snippets.push(`else setOutput(getT${lastIndex}(yR, yC-${lastShift}));`);
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int yR = coords.x;
        int yC = coords.y;

        ${snippets.join('\n        ')}
      }
    `;
    }
}

});

parcelRegister("lvoID", function(module, exports) {

$parcel$export(module.exports, "ConcatPackedProgram", () => $fa7faae751feaa97$export$e91e551248cfdb97);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");

var $2351m = parcelRequire("2351m");

var $7svrP = parcelRequire("7svrP");
class $fa7faae751feaa97$export$e91e551248cfdb97 {
    constructor(shapes, axis){
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = [];
        this.outputShape = (0, $lkN62).computeOutShape(shapes, axis);
        const shape = this.outputShape;
        const rank = shape.length;
        const dtype = (0, $7svrP.getCoordsDataType)(rank);
        const coords = (0, $2351m.getChannels)('coords', rank);
        const channels = [
            'x',
            'y',
            'z',
            'w',
            'u',
            'v'
        ].slice(0, rank);
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const offsets = new Array(shapes.length - 1);
        offsets[0] = shapes[0][axis];
        for(let i = 1; i < offsets.length; i++)offsets[i] = offsets[i - 1] + shapes[i][axis];
        const channel = channels[axis];
        const lastChannels = channels.slice(-2);
        const allChannels = channels.join();
        let getValueSnippet = `if (${channel} < ${offsets[0]}) {
        return getChannel(
            getT0(${allChannels}), vec2(${lastChannels.join()}));
        }`;
        for(let i = 1; i < offsets.length; i++){
            const shift = offsets[i - 1];
            // Note: the >= comparison below may seem unnecessary given the check
            // above but is needed to workaround branch execution issues on some
            // devices. It makes all the conditions exclusive without relying on
            // execution order.
            getValueSnippet += `
        if (${channel} < ${offsets[i]}  && ${channel} >= ${offsets[i - 1]}) {
          return getChannel(
            getT${i}(${$fa7faae751feaa97$var$shiftedChannels(channels, channel, shift)}),
            vec2(${$fa7faae751feaa97$var$shiftedChannels(lastChannels, channel, shift)}));
        }`;
        }
        const lastIndex = offsets.length;
        const shift = offsets[offsets.length - 1];
        getValueSnippet += `
        return getChannel(
          getT${lastIndex}(${$fa7faae751feaa97$var$shiftedChannels(channels, channel, shift)}),
          vec2(${$fa7faae751feaa97$var$shiftedChannels(lastChannels, channel, shift)}));`;
        this.userCode = `
      float getValue(${channels.map((x)=>'int ' + x)}) {
        ${getValueSnippet}
      }

      void main() {
        ${dtype} coords = getOutputCoords();
        vec4 result = vec4(getValue(${coords}), 0., 0., 0.);

        ${coords[rank - 1]} = ${coords[rank - 1]} + 1;
        if (${coords[rank - 1]} < ${shape[rank - 1]}) {
          result.g = getValue(${coords});
        }

        ${coords[rank - 2]} = ${coords[rank - 2]} + 1;
        if (${coords[rank - 2]} < ${shape[rank - 2]}) {
          result.a = getValue(${coords});
        }

        ${coords[rank - 1]} = ${coords[rank - 1]} - 1;
        if (${coords[rank - 2]} < ${shape[rank - 2]} &&
            ${coords[rank - 1]} < ${shape[rank - 1]}) {
          result.b = getValue(${coords});
        }
        setOutput(result);
      }
    `;
    }
}
/**
 * Return an expression for coordinates into a vector where a given channel
 * will be offset by [shift].
 *
 * @param channels the channels to consider
 * @param channel the channel we want shifted
 * @param shift  the amount to subtract from the channel.
 *
 * @returns a string of the form 'x, y-[shift], z' where any one channel can
 * have the shift applied.
 */ function $fa7faae751feaa97$var$shiftedChannels(channels, channel, shift) {
    const channelIdx = channels.indexOf(channel);
    const res = channels.map((c, idx)=>{
        if (idx === channelIdx) return `${c} - ${shift}`;
        else return c;
    });
    return res.join();
}

});

parcelRegister("j8iVA", function(module, exports) {

$parcel$export(module.exports, "imag", () => $dedd72533563b0eb$export$d78fab5778ab392b);
$parcel$export(module.exports, "imagConfig", () => $dedd72533563b0eb$export$ddfc128c2801add7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fAHbJ = parcelRequire("fAHbJ");
function $dedd72533563b0eb$export$d78fab5778ab392b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputData = backend.texData.get(input.dataId);
    return (0, $fAHbJ.identity)({
        inputs: {
            x: inputData.complexTensorInfos.imag
        },
        backend: backend
    });
}
const $dedd72533563b0eb$export$ddfc128c2801add7 = {
    kernelName: (0, $dCP8m.Imag),
    backendName: 'webgl',
    kernelFunc: $dedd72533563b0eb$export$d78fab5778ab392b
};

});



parcelRegister("4IWIa", function(module, exports) {

$parcel$export(module.exports, "conv2DConfig", () => $3708d055609479fd$export$4a39bf13b4378042);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $aymVi = parcelRequire("aymVi");

var $cmVzC = parcelRequire("cmVzC");

var $ORp2G = parcelRequire("ORp2G");

var $h2EAr = parcelRequire("h2EAr");

var $9gI7w = parcelRequire("9gI7w");
function $3708d055609479fd$export$188f9215482e3db8(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $lkN62).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $lkN62).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    let out;
    if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1 && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && (convInfo.padInfo.type === 'SAME' || convInfo.padInfo.type === 'VALID')) out = (0, $h2EAr.conv2dByMatMul)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend
    });
    else if (convInfo.strideWidth <= 2 && $dataFormat === 'channelsLast' && (0, $aymVi.env)().getBool('WEBGL_EXP_CONV')) {
        const program = new (0, $ORp2G.Conv2DPackedProgram)(convInfo);
        const customValues = [
            [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ],
            [
                convInfo.strideHeight,
                convInfo.strideWidth
            ],
            [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ],
            [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        ];
        out = backend.runWebGLProgram(program, [
            x,
            filter
        ], 'float32', customValues);
    } else if ((0, $aymVi.env)().getBool('WEBGL_CONV_IM2COL')) out = (0, $h2EAr.conv2dWithIm2Row)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend
    });
    else {
        const program = new (0, $cmVzC.Conv2DProgram)(convInfo);
        out = backend.runWebGLProgram(program, [
            x,
            filter
        ], 'float32');
    }
    const outReshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    backend.disposeIntermediateTensorInfo(out);
    return outReshaped;
}
const $3708d055609479fd$export$4a39bf13b4378042 = {
    kernelName: (0, $dCP8m.Conv2D),
    backendName: 'webgl',
    kernelFunc: $3708d055609479fd$export$188f9215482e3db8
};

});
parcelRegister("cmVzC", function(module, exports) {

$parcel$export(module.exports, "Conv2DProgram", () => $901432fc1d75e45b$export$8dc36706147178e9);
$parcel$export(module.exports, "Conv3DProgram", () => $901432fc1d75e45b$export$67aff94cf1ececaf);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $901432fc1d75e45b$export$8dc36706147178e9 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivationWeights = false, hasLeakyreluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.outputShape = convInfo.outShape;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const inputDepthNearestVec4 = Math.floor(convInfo.inChannels / 4) * 4;
        const inputDepthVec4Remainder = convInfo.inChannels % 4;
        const isChannelsLast = convInfo.dataFormat === 'channelsLast';
        const rowDim = isChannelsLast ? 1 : 2;
        const colDim = isChannelsLast ? 2 : 3;
        const channelDim = isChannelsLast ? 3 : 1;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivationWeights) activationSnippet = `float activation(float a) {
          float b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyreluAlpha) activationSnippet = `float activation(float a) {
          float b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `
          float activation(float x) {
            ${activation}
          }
        `;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        if (hasLeakyreluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
      ${activationSnippet}

      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d2 = coords[${channelDim}];

        ivec2 xRCCorner =
            ivec2(coords[${rowDim}], coords[${colDim}]) * strides - pads;
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          int xR = xRCorner + wR * ${dilationHeight};

          if (xR < 0 || xR >= ${convInfo.inHeight}) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int xC = xCCorner + wC * ${dilationWidth};

            if (xC < 0 || xC >= ${convInfo.inWidth}) {
              continue;
            }

            for (int d1 = 0; d1 < ${inputDepthNearestVec4}; d1 += 4) {
              vec4 wValues = vec4(
                getW(wR, wC, d1, d2),
                getW(wR, wC, d1 + 1, d2),
                getW(wR, wC, d1 + 2, d2),
                getW(wR, wC, d1 + 3, d2)
              );

              if (${isChannelsLast}) {
                vec4 xValues = vec4(
                  getX(batch, xR, xC, d1),
                  getX(batch, xR, xC, d1 + 1),
                  getX(batch, xR, xC, d1 + 2),
                  getX(batch, xR, xC, d1 + 3)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec4 xValues = vec4(
                  getX(batch, d1, xR, xC),
                  getX(batch, d1 + 1, xR, xC),
                  getX(batch, d1 + 2, xR, xC),
                  getX(batch, d1 + 3, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }
            }

            if (${inputDepthVec4Remainder === 1}) {

              if (${isChannelsLast}) {
                dotProd +=
                    getX(batch, xR, xC, ${inputDepthNearestVec4}) *
                    getW(wR, wC, ${inputDepthNearestVec4}, d2);
              } else {
                dotProd +=
                    getX(batch, ${inputDepthNearestVec4}, xR, xC) *
                    getW(wR, wC, ${inputDepthNearestVec4}, d2);
              }

            } else if (${inputDepthVec4Remainder === 2}) {
              vec2 wValues = vec2(
                getW(wR, wC, ${inputDepthNearestVec4}, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 1, d2)
              );

              if (${isChannelsLast}) {
                vec2 xValues = vec2(
                  getX(batch, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 1)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec2 xValues = vec2(
                  getX(batch, ${inputDepthNearestVec4}, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 1, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }

            } else if (${inputDepthVec4Remainder === 3}) {
              vec3 wValues = vec3(
                getW(wR, wC, ${inputDepthNearestVec4}, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 1, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 2, d2)
              );

              if (${isChannelsLast}) {
                vec3 xValues = vec3(
                  getX(batch, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 1),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 2)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec3 xValues = vec3(
                  getX(batch, ${inputDepthNearestVec4}, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 1, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 2, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }

            }
          }
        }

        float result = dotProd;
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
    }
}
class $901432fc1d75e45b$export$67aff94cf1ececaf {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'W'
        ];
        this.outputShape = convInfo.outShape;
        const padFront = convInfo.padInfo.front;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const filterDepth = convInfo.filterDepth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const inputDepthNearestVec4 = Math.floor(convInfo.inChannels / 4) * 4;
        const inputDepthVec4Remainder = convInfo.inChannels % 4;
        this.userCode = `
      const ivec3 strides = ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int d2 = coords.u;

        ivec3 xFRCCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
        int xFCorner = xFRCCorner.x;
        int xRCorner = xFRCCorner.y;
        int xCCorner = xFRCCorner.z;

        // Convolve x(?, ?, ?, d1) with w(:, :, :, d1, d2) to get
        // y(yF, yR, yC, d2). ? = to be determined. : = across all
        // values in that axis.
        float dotProd = 0.0;
        for (int wF = 0; wF < ${filterDepth}; wF++) {
          int xF = xFCorner + wF * ${dilationDepth};

          if (xF < 0 || xF >= ${convInfo.inDepth}) {
            continue;
          }

          for (int wR = 0; wR < ${filterHeight}; wR++) {
            int xR = xRCorner + wR * ${dilationHeight};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${filterWidth}; wC++) {
              int xC = xCCorner + wC * ${dilationWidth};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              for (int d1 = 0; d1 < ${inputDepthNearestVec4}; d1 += 4) {
                vec4 xValues = vec4(
                  getX(batch, xF, xR, xC, d1),
                  getX(batch, xF, xR, xC, d1 + 1),
                  getX(batch, xF, xR, xC, d1 + 2),
                  getX(batch, xF, xR, xC, d1 + 3)
                );
                vec4 wValues = vec4(
                  getW(wF, wR, wC, d1, d2),
                  getW(wF, wR, wC, d1 + 1, d2),
                  getW(wF, wR, wC, d1 + 2, d2),
                  getW(wF, wR, wC, d1 + 3, d2)
                );

                dotProd += dot(xValues, wValues);
              }

              if (${inputDepthVec4Remainder === 1}) {
                dotProd +=
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}) *
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2);
              } else if (${inputDepthVec4Remainder === 2}) {
                vec2 xValues = vec2(
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 1)
                );
                vec2 wValues = vec2(
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 1, d2)
                );
                dotProd += dot(xValues, wValues);
              } else if (${inputDepthVec4Remainder === 3}) {
                vec3 xValues = vec3(
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 1),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 2)
                );
                vec3 wValues = vec3(
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 1, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 2, d2)
                );
                dotProd += dot(xValues, wValues);
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}

});

parcelRegister("ORp2G", function(module, exports) {

$parcel$export(module.exports, "Conv2DPackedProgram", () => $098e1854e7a72e13$export$20f35e9a79361289);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $i88bA = parcelRequire("i88bA");
class $098e1854e7a72e13$export$20f35e9a79361289 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'pads',
                type: 'ivec2'
            },
            {
                name: 'strides',
                type: 'ivec2'
            },
            {
                name: 'dilations',
                type: 'ivec2'
            },
            {
                name: 'inDims',
                type: 'ivec2'
            }
        ];
        this.outputShape = convInfo.outShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        const padLeft = convInfo.padInfo.left;
        const strideWidth = convInfo.strideWidth;
        const dilationWidth = convInfo.dilationWidth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const texelsAcross = filterWidth;
        let mainLoop = `
       int xR; int xC; int xCOffset;
       vec4 wTexel; vec4 previous; vec4 final;`;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
           vec4 xTexelC${c * 2};
           int xTexelC${c * 2}Ready;
           vec4 xTexelC${c * 2 + 1};
           int xTexelC${c * 2 + 1}Ready;
           vec4 xC${c};`;
        /**
         * This vectorized implementation works by gathering the values needed for
         * each output channel's dot product into vec4's and then multiplying them
         * all together (this happens in the final double for-loop below). Most of
         * the main loop consists of constructing these vec4's with the minimum
         * number of texture2D calls, which means making use of all four returned
         * values from a texture2D call at once.
         */ mainLoop += `
     for (int r = 0; r < ${filterHeight}; r++) {
      for (int d1 = 0; d1 < ${convInfo.inChannels}; d1 += 2) {
       `;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
           xTexelC${c * 2} = vec4(0.0);
           xTexelC${c * 2}Ready = 0;
           xTexelC${c * 2 + 1} = vec4(0.0);
           xTexelC${c * 2 + 1}Ready = 0;
           xC${c} = vec4(0.0);`;
        mainLoop += `
         xR = xRCorner + r * dilations[0];
         if (xR >=0 && xR < inDims[0]) {
       `;
        for(let texelC = 0; texelC < (texelsAcross + 1) / 2; texelC++){
            const colIndex = texelC * 2;
            mainLoop += `
           xC = xCCorner + ${colIndex * dilationWidth};
           `;
            if (strideWidth === 1) {
                if (colIndex < filterWidth) {
                    // If padding is odd, the outer texels have to be composed.
                    if (padLeft % 2 === 1) {
                        // TODO: Ensure vec4 previous does not result in redundant sample,
                        // and avoid setting xTexelRC's that exceed the boundary in the
                        // first place rather than resetting them to vec4(0)).
                        // To compute xCOffset:
                        // - If padding is odd, we must add 1 to ensure we ask for an
                        // even-numbered row.
                        // - We subtract 2 to access the previous texel.
                        mainLoop += `
                 xCOffset = xC + 1;
                 if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);

                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }
               `;
                        // This texel has been read in previous iteration if the dilation
                        // is 1.
                        if (dilationWidth === 1 && colIndex > 0) mainLoop += `
                 xC${colIndex} = vec4(xTexelC${colIndex - 2}.zw, xTexelC${colIndex}.xy);
                 `;
                        else mainLoop += `
                   xCOffset = xC + 1 - 2;

                   if (xCOffset >= 0 && xCOffset < inDims[1]) {
                     previous = getX(batch, xR, xCOffset, d1);

                     // Need to manually clear unused channels in case
                     // we're reading from recycled texture.
                     if (xCOffset + 1 >= inDims[1]) {
                       previous.zw = vec2(0.0);
                     }

                     xC${colIndex} = vec4(previous.zw, xTexelC${colIndex}.xy);
                   } else {
                     xC${colIndex} = vec4(0.0, 0.0, xTexelC${colIndex}.xy);
                   }
                   `;
                    } else // Padding is even, so xRC corresponds to a single texel.
                    mainLoop += `
                 if (xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xC, d1);
                   if (xC + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }

                 xC${colIndex} = xTexelC${colIndex};
                 `;
                    if (colIndex + 1 < filterWidth) {
                        // If dilation is even, the second entry should match the first
                        // (either both are composed or both are single samples). But if
                        // dilation is odd, then the second entry should be the opposite
                        // of the first (if the first is composed, the second is a single
                        // sample, and vice versa.)
                        const nextTexelOffset = padLeft % 2 === 0 ? (0, $wx9lK).nearestLargerEven(dilationWidth) : dilationWidth;
                        if (dilationWidth % 2 === 0 && padLeft % 2 === 1 || dilationWidth % 2 !== 0 && padLeft % 2 !== 1) {
                            mainLoop += `
                   xCOffset = xC + imod(pads[1], 2) + ${nextTexelOffset};

                   if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                     xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);

                     // Need to manually clear unused channels in case
                     // we're reading from recycled texture.
                     if (xCOffset + 1 >= inDims[1]) {
                       xTexelC${colIndex + 1}.zw = vec2(0.0);
                     }
                     xTexelC${colIndex + 1}Ready = 1;
                   }
                   `;
                            // If dilation > 1 then the xRC's will not be able to share any
                            // values, so each xRC will require two unique calls to getX.
                            if (dilationWidth > 1) mainLoop += `
                     xCOffset -= 2;
                     if (xCOffset >= 0 && xCOffset < inDims[1]) {
                      previous = getX(batch, xR, xCOffset, d1);
                      xC${colIndex + 1} = vec4(previous.zw, xTexelC${colIndex + 1}.xy);
                     } else {
                      xC${colIndex + 1} = vec4(0.0, 0.0, xTexelC${colIndex + 1}.xy);
                     }
                     `;
                            else mainLoop += `
                     xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.xy);
                     `;
                        } else // If dilation is 1 and padding is odd, we have already read the
                        // texel when constructing the previous x value. Here we can
                        // simply skip the texture read.
                        if (nextTexelOffset === 1) mainLoop += `
                     xC${colIndex + 1} = xTexelC${colIndex};
                     `;
                        else mainLoop += `
                     xCOffset = xC + ${nextTexelOffset};

                     if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                       xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                       if (xCOffset + 1 >= inDims[1]) {
                         xTexelC${colIndex + 1}.zw = vec2(0.0);
                       }
                       xTexelC${colIndex + 1}Ready = 1;
                     }

                     xC${colIndex + 1} = xTexelC${colIndex + 1};
                     `;
                    }
                }
            } else if (colIndex < filterWidth) {
                // Depending on whether padLeft is even or odd, we want either the
                // xy or zw channels from X texels for xC${colIndex}. If padLeft is
                // even, xC${colIndex +1} is simply the zw channels of texels we've
                // already sampled. But if padLeft is odd, xC{$c + 1}.zw will
                // need to come from the xy channels of a new texel, hence the `
                // vec4
                // final` initialized below.
                if (padLeft % 2 === 1) {
                    mainLoop += `
                 xCOffset = xC + 1 - strides[1];
                 if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);
                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }

                 if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                   xTexelC${colIndex + 1} = getX(batch, xR, xC + 1, d1);
                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xC + 2 >= inDims[1]) {
                     xTexelC${colIndex + 1}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex + 1}Ready = 1;
                 }

                 xC${colIndex} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
               `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                   final = vec4(0.0);
                   xCOffset = xC + 1 + strides[1];
                   if(xCOffset >= 0 && xCOffset < inDims[1]) {
                     final = getX(batch, xR, xCOffset, d1);
                   }
                   xC${colIndex + 1} = vec4(xTexelC${colIndex + 1}.xy, final.xy);
                 `;
                } else {
                    mainLoop += `
                 if(xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xC, d1);
                   if (xC + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }

                 xCOffset = xC + strides[1];
                 if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                   xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${colIndex + 1}.zw = vec2(0.);
                   }
                   xTexelC${colIndex + 1}Ready = 1;
                 }

                 xC${colIndex} = vec4(
                   xTexelC${colIndex}.xy, xTexelC${colIndex + 1}.xy);
               `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                   xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
                 `;
                }
            }
            // localize the dotProd accumulation within the loop, the theory is for
            // GPU with limited cache, accumulate sum across large amount of
            // veriables will cause lots of cache misses. (i.e. 5x5 filter will have
            // 50 variables)
            if (colIndex < filterWidth) {
                mainLoop += `
             wTexel = getW(r, ${colIndex}, d1, d2);
             dotProd += xC${colIndex}.xxzz * vec4(wTexel.xy, wTexel.xy);
             if(d1 + 1 < ${convInfo.inChannels}) {
               dotProd += xC${colIndex}.yyww * vec4(wTexel.zw, wTexel.zw);
             }
           `;
                if (colIndex + 1 < filterWidth) mainLoop += `
               wTexel = getW(r, ${colIndex + 1}, d1, d2);
               dotProd += xC${colIndex + 1}.xxzz * vec4(wTexel.xy, wTexel.xy);
               if(d1 + 1 < ${convInfo.inChannels}) {
                 dotProd += xC${colIndex + 1}.yyww * vec4(wTexel.zw, wTexel.zw);
               }
             `;
            }
        }
        mainLoop += `
     }
   `;
        mainLoop += `
     }
   `;
        mainLoop += `
     }
   `;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `vec4 activation(vec4 a) {
           vec4 b = getPreluActivationWeightsAtOutCoords();
           ${activation}
         }`;
            else if (hasLeakyReluAlpha) activationSnippet = `vec4 activation(vec4 a) {
           vec4 b = getLeakyreluAlphaAtOutCoords();
           ${activation}
         }`;
            else activationSnippet = `vec4 activation(vec4 x) {
           ${activation}
         }`;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyReluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
       ${activationSnippet}

       void main() {
         ivec4 coords = getOutputCoords();
         int batch = coords.x;
         ivec2 xRCCorner = coords.yz * strides - pads;
         int d2 = coords.w;
         int xRCorner = xRCCorner.x;
         int xCCorner = xRCCorner.y;

         //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.
         vec4 dotProd = vec4(0.000000000000001);

         ${mainLoop}

         vec4 result = dotProd - vec4(0.000000000000001);
         ${addBiasSnippet}
         ${applyActivationSnippet}
         setOutput(result);
       }
     `;
    }
}

});

parcelRegister("h2EAr", function(module, exports) {

$parcel$export(module.exports, "conv2dByMatMul", () => $c6821b449d97cc19$export$fe56ce0f8b4bfd45);
$parcel$export(module.exports, "conv2dWithIm2Row", () => $c6821b449d97cc19$export$65b699e5c77381b8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $amvo6 = parcelRequire("amvo6");

var $eWZon = parcelRequire("eWZon");

var $HxxM1 = parcelRequire("HxxM1");

var $4rulI = parcelRequire("4rulI");

var $bxbCN = parcelRequire("bxbCN");

var $fAHbJ = parcelRequire("fAHbJ");

var $9gI7w = parcelRequire("9gI7w");
// Both conv2dByMatMul and conv2dWithIm2Row fuse height and width into one
// dimension to compute batchMatMul, so bias and activation weights are also
// supposed to fuse the two dimensions into one.
//
// This function computes the target shape for fusing height and width
// dimensions. Returning null means the shape is already compatible.
//
// Even though the bias is not supposed to be a 3-D or a 4-D (including
// batch) tensor and PReLU activiation weights is not supposed to be a 4-D
// tensor, we still need to support them, because we haven't disabled
// them for NHWC format.
// https://github.com/tensorflow/tfjs/blob/b53bd47e880367ae57493f0ea628abaf08db2d5d/tfjs-core/src/ops/fused/conv2d.ts#L181-L196
function $c6821b449d97cc19$var$getShapeForBatchMatMul(shape, isChannelsLast) {
    const length = shape.length;
    if (length >= 3) return isChannelsLast ? [
        ...shape.slice(0, -3),
        shape[length - 3] * shape[length - 2],
        shape[length - 1]
    ] : [
        ...shape.slice(0, -3),
        shape[length - 3],
        shape[length - 2] * shape[length - 1]
    ];
    else if (!isChannelsLast && length === 1 && shape[0] > 1) return [
        shape[0],
        1
    ];
    else return null;
}
function $c6821b449d97cc19$export$fe56ce0f8b4bfd45({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    // Reshapes conv2D input to 2D tensors, uses matMul and then reshape the
    // result from 2D to 4D.
    const xShape = x.shape;
    const xTexData = backend.texData.get(x.dataId);
    const sharedMatMulDim = convInfo.inChannels;
    const outerShapeX = xShape[0] * xShape[1] * xShape[2];
    const outerShapeFilter = convInfo.outChannels;
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const transposeA = false;
    const transposeB = false;
    let out;
    const intermediates = [];
    if (preluActivationWeights != null) {
        const targetShape = $c6821b449d97cc19$var$getShapeForBatchMatMul(preluActivationWeights.shape, isChannelsLast);
        if (targetShape != null) {
            preluActivationWeights = (0, $9gI7w.reshape)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(preluActivationWeights);
        }
    }
    if (bias != null) {
        const targetShape = $c6821b449d97cc19$var$getShapeForBatchMatMul(bias.shape, isChannelsLast);
        if (targetShape != null) {
            bias = (0, $9gI7w.reshape)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(bias);
        }
    }
    // TODO: Once reduction ops are packed, batchMatMul will always be packed
    // and we can remove this condition.
    const batchMatMulWillBeUnpacked = (outerShapeX === 1 || outerShapeFilter === 1) && sharedMatMulDim > (0, $bxbCN.MATMUL_SHARED_DIM_THRESHOLD);
    // The algorithm in the if condition assumes (1) the output will be packed,
    // (2) x is packed, (3) x isChannelsLast, (4)  x's packed texture is already
    // on GPU, (5) col is odd, (6) the width, height and inChannels are the same
    // for xTexData.shape and xShape.
    const canOptimize = !batchMatMulWillBeUnpacked && xTexData.isPacked && isChannelsLast && xTexData.texture != null && xShape[2] % 2 !== 0 && (0, $wx9lK).arraysEqual(xTexData.shape.slice(-3), xShape.slice(-3));
    if (canOptimize) {
        // We avoid expensive packed 2x2 reshape by padding col count to next,
        // even number. When col is odd, the result of packed batchMatMul is
        // the same (has the same texture layout and and values in the texture) as
        // it is for next even col. We make the odd-cols tensor to look like
        // even-cols tensor before the operation and, after the batchMatMul,
        // fix the even-cols result to have odd number of cols.
        const targetShape = xShape[0] * xShape[1] * (xShape[2] + 1);
        const xReshaped = {
            dataId: x.dataId,
            shape: [
                1,
                targetShape,
                convInfo.inChannels
            ],
            dtype: x.dtype
        };
        // xTexData.shape gets referenced from GPGPUBinary.inShapeInfos.
        // Decrementing col count, after batchMatMul->...->compileProgram leads to
        // invalid col count within the reference in GPGPUBinary.inShapeInfos.
        // Alternative fix would be to provide a copy to GPGPUBinary.inShapeInfos
        // in compileProgram method, but that would affect compilation of all
        // programs - instead, provide a copy here, with even col count, before
        // calling batchMatMul->...->compileProgram and after that, the original
        // xTexData.shape is restored.
        const originalXTexDataShape = xTexData.shape;
        xTexData.shape = xTexData.shape.slice();
        xTexData.shape[xTexData.shape.length - 2]++;
        (0, $wx9lK).assert($4rulI.isReshapeFree(xTexData.shape, xReshaped.shape), ()=>`packed reshape ${xTexData.shape} to ${xReshaped.shape} isn't free`);
        const filterReshaped = (0, $9gI7w.reshape)({
            inputs: {
                x: filter
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    convInfo.inChannels,
                    convInfo.outChannels
                ]
            }
        });
        intermediates.push(filterReshaped);
        const pointwiseConv = (0, $bxbCN.batchMatMulImpl)({
            a: xReshaped,
            b: filterReshaped,
            backend: backend,
            transposeA: transposeA,
            transposeB: transposeB,
            bias: bias,
            activation: activation,
            preluActivationWeights: preluActivationWeights,
            leakyreluAlpha: leakyreluAlpha
        });
        const pointwiseConvTexData = backend.texData.get(pointwiseConv.dataId);
        (0, $wx9lK).assert(pointwiseConvTexData.isPacked, ()=>'batchMatMul result is expected to be packed');
        // Restore the input shape to original.
        xTexData.shape = originalXTexDataShape;
        // Set the output shape - there is no need for expensive reshape as data
        // layout is already correct.
        pointwiseConvTexData.shape = convInfo.outShape;
        out = (0, $fAHbJ.identity)({
            inputs: {
                x: pointwiseConv
            },
            backend: backend
        });
        out.shape = convInfo.outShape;
        intermediates.push(pointwiseConv);
    } else {
        const numCols = convInfo.outHeight * convInfo.outWidth;
        const xReshaped = (0, $9gI7w.reshape)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                shape: isChannelsLast ? [
                    convInfo.batchSize,
                    numCols,
                    convInfo.inChannels
                ] : [
                    convInfo.batchSize,
                    convInfo.inChannels,
                    numCols
                ]
            }
        });
        const filterReshaped = (0, $9gI7w.reshape)({
            inputs: {
                x: filter
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    convInfo.inChannels,
                    convInfo.outChannels
                ]
            }
        });
        const result = (0, $bxbCN.batchMatMulImpl)({
            a: isChannelsLast ? xReshaped : filterReshaped,
            b: isChannelsLast ? filterReshaped : xReshaped,
            transposeA: !isChannelsLast,
            transposeB: transposeB,
            backend: backend,
            bias: bias,
            activation: activation,
            preluActivationWeights: preluActivationWeights,
            leakyreluAlpha: leakyreluAlpha
        });
        out = (0, $9gI7w.reshape)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: convInfo.outShape
            }
        });
        intermediates.push(xReshaped);
        intermediates.push(filterReshaped);
        intermediates.push(result);
    }
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return out;
}
function $c6821b449d97cc19$export$65b699e5c77381b8({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    // Rearranges conv2d input so each block to be convolved over forms the
    // column of a new matrix with shape [filterWidth * filterHeight *
    // inChannels, outHeight * outWidth]. The filter is also rearranged so each
    // output channel forms a row of a new matrix with shape [outChannels,
    // filterWidth * filterHeight * inChannels]. The convolution is then
    // computed by multiplying these matrices and reshaping the result.
    const { filterWidth: filterWidth, filterHeight: filterHeight, inChannels: inChannels, outWidth: outWidth, outHeight: outHeight, dataFormat: dataFormat } = convInfo;
    const isChannelsLast = dataFormat === 'channelsLast';
    const sharedDim = filterWidth * filterHeight * inChannels;
    const numCols = outHeight * outWidth;
    const x2ColShape = [
        convInfo.batchSize,
        sharedDim,
        numCols
    ];
    const transposeA = true;
    const transposeB = false;
    const intermediates = [];
    if (preluActivationWeights != null) {
        const targetShape = $c6821b449d97cc19$var$getShapeForBatchMatMul(preluActivationWeights.shape, isChannelsLast);
        if (targetShape != null) {
            preluActivationWeights = (0, $9gI7w.reshape)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(preluActivationWeights);
        }
    }
    if (bias != null) {
        const targetShape = $c6821b449d97cc19$var$getShapeForBatchMatMul(bias.shape, isChannelsLast);
        if (targetShape != null) {
            bias = (0, $9gI7w.reshape)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(bias);
        }
    }
    const w2Row = (0, $9gI7w.reshape)({
        inputs: {
            x: filter
        },
        backend: backend,
        attrs: {
            shape: [
                1,
                sharedDim,
                (0, $wx9lK).sizeFromShape(filter.shape) / sharedDim
            ]
        }
    });
    intermediates.push(w2Row);
    const im2ColProgram = new (0, $amvo6.Im2ColPackedProgram)(x2ColShape, convInfo);
    const customValues = [
        x.shape,
        [
            convInfo.padInfo.top,
            convInfo.padInfo.left
        ],
        [
            convInfo.strideHeight,
            convInfo.strideWidth
        ],
        [
            convInfo.dilationHeight,
            convInfo.dilationWidth
        ],
        [
            convInfo.inChannels
        ],
        [
            convInfo.filterWidth * convInfo.inChannels
        ],
        [
            convInfo.outWidth
        ]
    ];
    const im2Col = backend.runWebGLProgram(im2ColProgram, [
        x
    ], 'float32', customValues);
    const im2ColReshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: im2Col
        },
        backend: backend,
        attrs: {
            shape: x2ColShape
        }
    });
    intermediates.push(im2Col);
    intermediates.push(im2ColReshaped);
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    const fusedActivation = activation ? (0, $eWZon.mapActivationToShaderProgram)(activation, true) : null;
    const matmulProgram = new (0, $HxxM1.MatMulPackedProgram)(isChannelsLast ? im2ColReshaped.shape : w2Row.shape, isChannelsLast ? w2Row.shape : im2ColReshaped.shape, isChannelsLast ? [
        convInfo.batchSize,
        numCols,
        convInfo.outChannels
    ] : [
        convInfo.batchSize,
        convInfo.outChannels,
        numCols
    ], transposeA, transposeB, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    const inputs = isChannelsLast ? [
        im2ColReshaped,
        w2Row
    ] : [
        w2Row,
        im2ColReshaped
    ];
    if (bias) inputs.push(bias);
    if (hasPreluActivationWeights) inputs.push(preluActivationWeights);
    if (hasLeakyreluAlpha) {
        const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $wx9lK).createScalarValue(leakyreluAlpha, 'float32'));
        inputs.push($leakyreluAlpha);
        intermediates.push($leakyreluAlpha);
    }
    const product = backend.runWebGLProgram(matmulProgram, inputs, 'float32');
    const out = (0, $9gI7w.reshape)({
        inputs: {
            x: product
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    intermediates.push(product);
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return out;
}

});
parcelRegister("amvo6", function(module, exports) {

$parcel$export(module.exports, "Im2ColPackedProgram", () => $78b44e656898be22$export$d76a638e68b7f211);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $f7Ffe = parcelRequire("f7Ffe");

var $i88bA = parcelRequire("i88bA");
class $78b44e656898be22$export$d76a638e68b7f211 {
    constructor(outputShape, convInfo){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'inputShape',
                type: 'ivec4'
            },
            {
                name: 'pad',
                type: 'ivec2'
            },
            {
                name: 'stride',
                type: 'ivec2'
            },
            {
                name: 'dilation',
                type: 'ivec2'
            },
            {
                name: 'inChannels',
                type: 'int'
            },
            {
                name: 'itemsPerBlockRow',
                type: 'int'
            },
            {
                name: 'outWidth',
                type: 'int'
            }
        ];
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        const { dataFormat: dataFormat } = convInfo;
        const glsl = (0, $f7Ffe.getGlslDifferences)();
        const isChannelsLast = dataFormat === 'channelsLast';
        const rowDim = isChannelsLast ? 1 : 2;
        const colDim = isChannelsLast ? 2 : 3;
        const boundsCheckingSnippet = this.enableShapeUniforms ? 'if(blockIndex < outShape[2] && pos < outShape[1]) {' : `if(blockIndex < ${outputShape[2]} && pos < ${outputShape[1]}) {`;
        let unrolled = ``;
        for(let row = 0; row <= 1; row++)for(let col = 0; col <= 1; col++)unrolled += `
          blockIndex = rc.z + ${col};
          pos = rc.y + ${row};

          ${boundsCheckingSnippet}
            offsetY = int(blockIndex / outWidth) * stride[0] - pad[0];
            d0 = offsetY + dilation[0] * (pos / itemsPerBlockRow);

            if(d0 < inputShape[${rowDim}] && d0 >= 0) {
              // Use custom imod instead mod. On Intel GPU, mod may generate
              // unexpected value.
              // https://github.com/tensorflow/tfjs/issues/5447
              offsetX = imod(blockIndex, outWidth) * stride[1] - pad[1];
              d1 = offsetX + dilation[1] * (imod(pos, itemsPerBlockRow) /
                  inChannels);

              if(d1 < inputShape[${colDim}] && d1 >= 0) {

                ch = imod(pos, inChannels);

                if (${isChannelsLast}) {
                  innerDims = vec2(d1, ch);
                  result[${row * 2 + col}] = getChannel(
                    getA(rc.x, d0, int(innerDims.x),
                    int(innerDims.y)), innerDims);
                } else {
                  innerDims = vec2(d0, d1);
                  result[${row * 2 + col}] = getChannel(
                    getA(rc.x, ch, int(innerDims.x),
                    int(innerDims.y)), innerDims);
                }
              }
            }
          }
        `;
        this.userCode = `
      void main() {
        ivec3 rc = getOutputCoords();

        vec4 result = vec4(0);

        int blockIndex, pos, offsetY, d0, offsetX, d1, ch;
        vec2 innerDims;

        ${unrolled}

        ${glsl.output} = result;
      }
    `;
    }
}

});



parcelRegister("4Up8q", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropFilterConfig", () => $392fe3a37bee9ffe$export$7a95f55d2d2e7d24);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $a0bFg = parcelRequire("a0bFg");
function $392fe3a37bee9ffe$export$652a30c9379f3de7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    const $dataFormat = (0, $lkN62).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $lkN62).computeConv2DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const program = new (0, $a0bFg.Conv2DDerFilterProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        dy
    ], 'float32');
}
const $392fe3a37bee9ffe$export$7a95f55d2d2e7d24 = {
    kernelName: (0, $dCP8m.Conv2DBackpropFilter),
    backendName: 'webgl',
    kernelFunc: $392fe3a37bee9ffe$export$652a30c9379f3de7
};

});
parcelRegister("a0bFg", function(module, exports) {

$parcel$export(module.exports, "Conv2DDerFilterProgram", () => $7482f3d105a42b95$export$1223560f67be2f2d);
$parcel$export(module.exports, "Conv2DDerInputProgram", () => $7482f3d105a42b95$export$5dc650171c0f6623);
$parcel$export(module.exports, "Conv3DDerFilterProgram", () => $7482f3d105a42b95$export$932d18866f409cf3);
$parcel$export(module.exports, "Conv3DDerInputProgram", () => $7482f3d105a42b95$export$acda329ff653a25);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $7482f3d105a42b95$export$1223560f67be2f2d {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.outputShape = convInfo.filterShape;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const isChannelsLast = convInfo.dataFormat === 'channelsLast';
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int wR = coords.x;
        int wC = coords.y;
        int d1 = coords.z;
        int d2 = coords.w;

        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
            int xR = wR + yR * ${strideHeight} - ${padTop};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
              int xC = wC + yC * ${strideWidth} - ${padLeft};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              if (${isChannelsLast}) {
                float dyValue = getDy(b, yR, yC, d2);
                float xValue = getX(b, xR, xC, d1);
                dotProd += (xValue * dyValue);
              } else {
                float dyValue = getDy(b, d2, yR, yC);
                float xValue = getX(b, d1, xR, xC);
                dotProd += (xValue * dyValue);
              }

            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $7482f3d105a42b95$export$5dc650171c0f6623 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.outputShape = convInfo.inShape;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const isChannelsLast = convInfo.dataFormat === 'channelsLast';
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        const rowDim = isChannelsLast ? 1 : 2;
        const colDim = isChannelsLast ? 2 : 3;
        const channelDim = isChannelsLast ? 3 : 1;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[${channelDim}];

        ivec2 dyCorner = ivec2(coords[${rowDim}], coords[${colDim}]) - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            int wCPerm = ${filterWidth} - 1 - wC;

            for (int d2 = 0; d2 < ${convInfo.outChannels}; d2++) {

              if (${isChannelsLast}) {
                float xValue = getDy(batch, idyR, idyC, d2);
                float wValue = getW(wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              } else {
                float xValue = getDy(batch, d2, idyR, idyC);
                float wValue = getW(wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }

            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $7482f3d105a42b95$export$932d18866f409cf3 {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.outputShape = convInfo.filterShape;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padFront = convInfo.padInfo.front;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        this.userCode = `
      void main() {
        ivec5 coords = getOutputCoords();
        int wF = coords.x;
        int wR = coords.y;
        int wC = coords.z;
        int d1 = coords.w;
        int d2 = coords.u;

        float dotProd = 0.0;

        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yF = 0; yF < ${convInfo.outDepth}; yF++) {
            int xF = wF + yF * ${strideDepth} - ${padFront};

            if (xF < 0 || xF >= ${convInfo.inDepth}) {
              continue;
            }

            for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
              int xR = wR + yR * ${strideHeight} - ${padTop};

              if (xR < 0 || xR >= ${convInfo.inHeight}) {
                continue;
              }

              for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
                int xC = wC + yC * ${strideWidth} - ${padLeft};

                if (xC < 0 || xC >= ${convInfo.inWidth}) {
                  continue;
                }

                float dyValue = getDy(b, yF, yR, yC, d2);
                float xValue = getX(b, xF, xR, xC, d1);
                dotProd += (xValue * dyValue);
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $7482f3d105a42b95$export$acda329ff653a25 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.outputShape = convInfo.inShape;
        const filterDepth = convInfo.filterDepth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padFront = filterDepth - 1 - convInfo.padInfo.front;
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int d1 = coords.u;


        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyFCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        float dotProd = 0.0;
        for (int wF = 0; wF < ${filterDepth}; wF++) {
          float dyF = float(dyFCorner + wF) / ${strideDepth}.0;

          if (dyF < 0.0 || dyF >= ${convInfo.outDepth}.0 || fract(dyF) > 0.0) {
            continue;
          }
          int idyF = int(dyF);

          int wFPerm = ${filterDepth} - 1 - wF;

          for (int wR = 0; wR < ${filterHeight}; wR++) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
              fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            int wRPerm = ${filterHeight} - 1 - wR;

            for (int wC = 0; wC < ${filterWidth}; wC++) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              int wCPerm = ${filterWidth} - 1 - wC;

              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2++) {
                float xValue = getDy(batch, idyF, idyR, idyC, d2);
                float wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}

});


parcelRegister("x4CZq", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropInputConfig", () => $0636ac2e1a5a667d$export$19bbc19fff1ed26f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $a0bFg = parcelRequire("a0bFg");
function $0636ac2e1a5a667d$export$633310eed0c26e72(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { inputShape: inputShape, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $lkN62).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $lkN62).computeConv2DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const program = new (0, $a0bFg.Conv2DDerInputProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        dy,
        filter
    ], 'float32');
}
const $0636ac2e1a5a667d$export$19bbc19fff1ed26f = {
    kernelName: (0, $dCP8m.Conv2DBackpropInput),
    backendName: 'webgl',
    kernelFunc: $0636ac2e1a5a667d$export$633310eed0c26e72
};

});

parcelRegister("5YHui", function(module, exports) {

$parcel$export(module.exports, "conv3DConfig", () => $45a44a158870cd91$export$1fe590fda0829040);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $cmVzC = parcelRequire("cmVzC");
function $45a44a158870cd91$export$1929932f31d07956(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $lkN62).computeConv3DInfo(x.shape, filter.shape, strides, dilations, pad);
    const program = new (0, $cmVzC.Conv3DProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        filter
    ], 'float32');
}
const $45a44a158870cd91$export$1fe590fda0829040 = {
    kernelName: (0, $dCP8m.Conv3D),
    backendName: 'webgl',
    kernelFunc: $45a44a158870cd91$export$1929932f31d07956
};

});

parcelRegister("1fu2C", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropFilterV2Config", () => $0e8e7eb5c96b4b9e$export$6dce9169640850fa);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $a0bFg = parcelRequire("a0bFg");
function $0e8e7eb5c96b4b9e$export$b57760dc3101cea7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, filterShape: filterShape } = attrs;
    const convInfo = (0, $lkN62).computeConv3DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad);
    const program = new (0, $a0bFg.Conv3DDerFilterProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        dy
    ], 'float32');
}
const $0e8e7eb5c96b4b9e$export$6dce9169640850fa = {
    kernelName: (0, $dCP8m.Conv3DBackpropFilterV2),
    backendName: 'webgl',
    kernelFunc: $0e8e7eb5c96b4b9e$export$b57760dc3101cea7
};

});

parcelRegister("dzXYH", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropInputConfig", () => $9e2d119f41cfbb66$export$cdcac766a3ef1744);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $a0bFg = parcelRequire("a0bFg");
function $9e2d119f41cfbb66$export$deb6d1ca1fa2977b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { pad: pad, strides: strides, inputShape: inputShape } = attrs;
    const convInfo = (0, $lkN62).computeConv3DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad);
    const program = new (0, $a0bFg.Conv3DDerInputProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        dy,
        filter
    ], 'float32');
}
const $9e2d119f41cfbb66$export$cdcac766a3ef1744 = {
    kernelName: (0, $dCP8m.Conv3DBackpropInputV2),
    backendName: 'webgl',
    kernelFunc: $9e2d119f41cfbb66$export$deb6d1ca1fa2977b
};

});

parcelRegister("gYwzT", function(module, exports) {

$parcel$export(module.exports, "cosConfig", () => $c5bb853f732f3a55$export$ff099a1da5235a7e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $c5bb853f732f3a55$var$COS = (0, $eWZon.CHECK_NAN_SNIPPET_UNARY) + `
  return cos(x);
`;
const $c5bb853f732f3a55$export$50d414a77b60d802 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $c5bb853f732f3a55$var$COS
});
const $c5bb853f732f3a55$export$ff099a1da5235a7e = {
    kernelName: (0, $dCP8m.Cos),
    backendName: 'webgl',
    kernelFunc: $c5bb853f732f3a55$export$50d414a77b60d802
};

});

parcelRegister("ffhHr", function(module, exports) {

$parcel$export(module.exports, "coshConfig", () => $b195fc8483f73029$export$c5824052b09ba0ed);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $b195fc8483f73029$var$COSH = `
  float e2x = exp(-x);
  return (e2x + 1.0 / e2x) / 2.0;
`;
const $b195fc8483f73029$export$2e2fd1ad24e4d350 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $b195fc8483f73029$var$COSH
});
const $b195fc8483f73029$export$c5824052b09ba0ed = {
    kernelName: (0, $dCP8m.Cosh),
    backendName: 'webgl',
    kernelFunc: $b195fc8483f73029$export$2e2fd1ad24e4d350
};

});

parcelRegister("dCV7c", function(module, exports) {

$parcel$export(module.exports, "cropAndResizeConfig", () => $9ebb20d264c6b14f$export$f7086edcf0050c7f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eMoca = parcelRequire("eMoca");
const $9ebb20d264c6b14f$export$6f0f0090e1f6cd3c = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, boxes: boxes, boxInd: boxInd } = inputs;
    const { cropSize: cropSize, method: method, extrapolationValue: extrapolationValue } = attrs;
    const program = new (0, $eMoca.CropAndResizeProgram)(image.shape, boxes.shape, cropSize, method, extrapolationValue);
    return backend.runWebGLProgram(program, [
        image,
        boxes,
        boxInd
    ], 'float32');
};
const $9ebb20d264c6b14f$export$f7086edcf0050c7f = {
    kernelName: (0, $dCP8m.CropAndResize),
    backendName: 'webgl',
    kernelFunc: $9ebb20d264c6b14f$export$6f0f0090e1f6cd3c
};

});
parcelRegister("eMoca", function(module, exports) {

$parcel$export(module.exports, "CropAndResizeProgram", () => $ac28510f710280ae$export$c889a58f7ea63106);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $ac28510f710280ae$export$c889a58f7ea63106 {
    constructor(imageShape, boxShape, cropSize, method, extrapolationValue){
        this.variableNames = [
            'Image',
            'Boxes',
            'BoxInd'
        ];
        this.outputShape = [];
        const [batch, imageHeight, imageWidth, depth] = imageShape;
        const [numBoxes] = boxShape;
        const [cropHeight, cropWidth] = cropSize;
        this.outputShape = [
            numBoxes,
            cropHeight,
            cropWidth,
            depth
        ];
        const methodId = method === 'bilinear' ? 1 : 0;
        const [inputHeightFloat, inputWidthFloat] = [
            `${imageHeight - 1}.0`,
            `${imageWidth - 1}.0`
        ];
        const [heightRatio, heightScale, inY] = cropHeight > 1 ? [
            `${(imageHeight - 1) / (cropHeight - 1)}`,
            '(y2-y1) * height_ratio',
            `y1*${inputHeightFloat} + float(y)*(height_scale)`
        ] : [
            '0.0',
            '0.0',
            `0.5 * (y1+y2) * ${inputHeightFloat}`
        ];
        const [widthRatio, widthScale, inX] = cropWidth > 1 ? [
            `${(imageWidth - 1) / (cropWidth - 1)}`,
            '(x2-x1) * width_ratio',
            `x1*${inputWidthFloat} + float(x)*(width_scale)`
        ] : [
            '0.0',
            '0.0',
            `0.5 * (x1+x2) * ${inputWidthFloat}`
        ];
        // Reference implementation
        // tslint:disable-next-line:max-line-length
        // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/crop_and_resize_op_gpu.cu.cc
        this.userCode = `
      const float height_ratio = float(${heightRatio});
      const float width_ratio = float(${widthRatio});
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int y = coords[1];
        int x = coords[2];
        int d = coords[3];

        // get box vals
        float y1 = getBoxes(b,0);
        float x1 = getBoxes(b,1);
        float y2 = getBoxes(b,2);
        float x2 = getBoxes(b,3);

        // get image in batch index
        int bInd = round(getBoxInd(b));
        if(bInd < 0 || bInd >= ${batch}) {
          return;
        }

        float height_scale = ${heightScale};
        float width_scale = ${widthScale};

        float in_y = ${inY};
        if( in_y < 0.0 || in_y > ${inputHeightFloat} ) {
          setOutput(float(${extrapolationValue}));
          return;
        }
        float in_x = ${inX};
        if( in_x < 0.0 || in_x > ${inputWidthFloat} ) {
          setOutput(float(${extrapolationValue}));
          return;
        }

        vec2 sourceFracIndexCR = vec2(in_x,in_y);
        if(${methodId} == 1) {
          // Compute the four integer indices.
          ivec2 sourceFloorCR = ivec2(sourceFracIndexCR);
          ivec2 sourceCeilCR = ivec2(ceil(sourceFracIndexCR));

          float topLeft = getImage(b, sourceFloorCR.y, sourceFloorCR.x, d);
          float bottomLeft = getImage(b, sourceCeilCR.y, sourceFloorCR.x, d);
          float topRight = getImage(b, sourceFloorCR.y, sourceCeilCR.x, d);
          float bottomRight = getImage(b, sourceCeilCR.y, sourceCeilCR.x, d);

          vec2 fracCR = sourceFracIndexCR - vec2(sourceFloorCR);

          float top = topLeft + (topRight - topLeft) * fracCR.x;
          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracCR.x;
          float newValue = top + (bottom - top) * fracCR.y;
          setOutput(newValue);
        } else {
          // Compute the coordinators of nearest neighbor point.
          ivec2 sourceNearestCR = ivec2(floor(
            sourceFracIndexCR + vec2(0.5,0.5)));
          float newValue = getImage(b, sourceNearestCR.y, sourceNearestCR.x, d);
          setOutput(newValue);
        }
      }
    `;
    }
}

});


parcelRegister("am6Ok", function(module, exports) {

$parcel$export(module.exports, "cumprodConfig", () => $78a13de97f90acbe$export$db50d81ed60c5a35);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $i9iBT = parcelRequire("i9iBT");

var $bi7yk = parcelRequire("bi7yk");
function $78a13de97f90acbe$export$dc7513e907e94b8d(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    return (0, $bi7yk.cumImpl)((0, $i9iBT.CumOpType).Prod, x, backend, axis, exclusive, reverse);
}
const $78a13de97f90acbe$export$db50d81ed60c5a35 = {
    kernelName: (0, $dCP8m.Cumprod),
    backendName: 'webgl',
    kernelFunc: $78a13de97f90acbe$export$dc7513e907e94b8d
};

});
parcelRegister("i9iBT", function(module, exports) {

$parcel$export(module.exports, "CumOpType", () => $d36780deb3a7d695$export$5245168906ddd3d9);
$parcel$export(module.exports, "CumProgram", () => $d36780deb3a7d695$export$6788a4605888e813);

var $7svrP = parcelRequire("7svrP");
var $d36780deb3a7d695$export$5245168906ddd3d9;
(function(CumOpType) {
    CumOpType["Prod"] = "*";
    CumOpType["Sum"] = "+";
})($d36780deb3a7d695$export$5245168906ddd3d9 || ($d36780deb3a7d695$export$5245168906ddd3d9 = {}));
class $d36780deb3a7d695$export$6788a4605888e813 {
    constructor(op, outputShape, exclusive, reverse){
        this.op = op;
        this.outputShape = outputShape;
        this.variableNames = [
            'x'
        ];
        this.customUniforms = [
            {
                name: 'index',
                type: 'float'
            }
        ];
        const rank = this.outputShape.length;
        const initVal = this.op === $d36780deb3a7d695$export$5245168906ddd3d9.Prod ? '1.0' : '0.0';
        const val = exclusive ? initVal : `getX(${$d36780deb3a7d695$var$getCoords(rank, 'coords', this.op)})`;
        const length = this.outputShape[this.outputShape.length - 1];
        let condition = '';
        let idxString = '';
        // When exclusive is set, the cum op becomes roll op that copies the
        // value from the previous index based on the direction specified by the
        // reverse flag.
        if (exclusive) {
            condition = reverse ? `end != ${length - 1}` : 'end != 0';
            idxString = reverse ? 'end + 1' : 'end - 1';
        } else {
            condition = reverse ? `end + pow2 < ${length}` : 'end >= pow2';
            idxString = reverse ? 'end + pow2' : 'end - pow2';
        }
        this.userCode = `
      void main() {
        ${(0, $7svrP.getCoordsDataType)(rank)} coords = getOutputCoords();
        int end = ${$d36780deb3a7d695$var$getFinalCoord(rank, 'coords', this.op)};
        float val = ${val};
        int pow2 = int(pow(2.0, index));
        if (${condition}) {
          int idx = ${idxString};
          ${$d36780deb3a7d695$var$getFinalCoord(rank, 'coords', this.op)} = idx;
          val ${this.op}= getX(${$d36780deb3a7d695$var$getCoords(rank, 'coords', this.op)});
        }
        setOutput(val);
      }
    `;
    }
}
function $d36780deb3a7d695$var$getCoords(rank, name, op) {
    if (rank === 1) return `${name}`;
    else if (rank === 2) return `${name}.x, ${name}.y`;
    else if (rank === 3) return `${name}.x, ${name}.y, ${name}.z`;
    else if (rank === 4) return `${name}.x, ${name}.y, ${name}.z, ${name}.w`;
    else throw new Error(`Cumulative ${op} for rank ${rank} is not yet supported`);
}
function $d36780deb3a7d695$var$getFinalCoord(rank, name, op) {
    if (rank === 1) return `${name}`;
    else if (rank === 2) return `${name}.y`;
    else if (rank === 3) return `${name}.z`;
    else if (rank === 4) return `${name}.w`;
    else throw new Error(`Cumulative ${op} for rank ${rank} is not yet supported`);
}

});

parcelRegister("bi7yk", function(module, exports) {

$parcel$export(module.exports, "cumImpl", () => $83873bf4e592189f$export$88973bdd32b5a724);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");

var $i9iBT = parcelRequire("i9iBT");

var $fAHbJ = parcelRequire("fAHbJ");

var $lHu0m = parcelRequire("lHu0m");
function $83873bf4e592189f$export$88973bdd32b5a724(op, x, backend, axis, exclusive, reverse) {
    const xRank = x.shape.length;
    const permutation = (0, $lkN62).getAxesPermutation([
        axis
    ], xRank);
    let permutedX = x;
    if (permutation != null) permutedX = (0, $lHu0m.transpose)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            perm: permutation
        }
    });
    const permutedAxis = (0, $lkN62).getInnerMostAxes(1, xRank)[0];
    if (permutedAxis !== xRank - 1) throw new Error(`WebGL cumprod shader expects an inner-most axis=${x.shape.length - 1} ` + `but got axis=${axis}`);
    const size = permutedX.shape[permutedAxis];
    let result = (0, $fAHbJ.identity)({
        inputs: {
            x: permutedX
        },
        backend: backend
    });
    // Use cum parallel algorithm, inspired by:
    // https://developer.nvidia.com/gpugems/gpugems3/part-vi-gpu-computing/chapter-39-parallel-prefix-sum-scan-cuda
    // Note: although the algorithm is called sum, it works for any associtative
    // operator with an identity.
    for(let i = 0; i <= Math.ceil(Math.log2(size)) - 1; i++){
        const program = new (0, $i9iBT.CumProgram)(op, permutedX.shape, false, reverse);
        const customValues = [
            [
                i
            ]
        ];
        const prevResult = result;
        result = backend.runWebGLProgram(program, [
            result
        ], result.dtype, customValues);
        backend.disposeIntermediateTensorInfo(prevResult);
    }
    // For exclusive cum, shift the end result in the direction of product or sum
    // and add 1 for product or 0 for sum to the front index.
    if (exclusive) {
        const program = new (0, $i9iBT.CumProgram)(op, permutedX.shape, exclusive, reverse);
        const prevResult = result;
        result = backend.runWebGLProgram(program, [
            result
        ], result.dtype);
        backend.disposeIntermediateTensorInfo(prevResult);
    }
    if (permutation != null) {
        const reversePermutation = (0, $lkN62).getUndoAxesPermutation(permutation);
        const reverseTransposedResult = (0, $lHu0m.transpose)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: reversePermutation
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        backend.disposeIntermediateTensorInfo(permutedX);
        return reverseTransposedResult;
    }
    return result;
}

});


parcelRegister("jq0Fn", function(module, exports) {

$parcel$export(module.exports, "cumsumConfig", () => $e230f6608bc094d2$export$2f6196f3316e7ed2);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $i9iBT = parcelRequire("i9iBT");

var $bi7yk = parcelRequire("bi7yk");
function $e230f6608bc094d2$export$71990b1e1c4912fe(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    return (0, $bi7yk.cumImpl)((0, $i9iBT.CumOpType).Sum, x, backend, axis, exclusive, reverse);
}
const $e230f6608bc094d2$export$2f6196f3316e7ed2 = {
    kernelName: (0, $dCP8m.Cumsum),
    backendName: 'webgl',
    kernelFunc: $e230f6608bc094d2$export$71990b1e1c4912fe
};

});

parcelRegister("fiqgU", function(module, exports) {

$parcel$export(module.exports, "denseBincountConfig", () => $b22cea7e09430d08$export$88ba267b84334692);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
function $b22cea7e09430d08$export$436934e6cf1946f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size, binaryOutput: binaryOutput } = attrs;
    if (x.shape.length === 1) {
        const xVals = backend.readSync(x.dataId);
        const weightsVals = backend.readSync(weights.dataId);
        const outVals = (0, $fIVdF.bincountImplCPU)(xVals, weightsVals, weights.dtype, weights.shape, size);
        return backend.makeTensorInfo([
            size
        ], weights.dtype, outVals);
    } else if (x.shape.length === 2) {
        const xBuf = backend.bufferSync(x);
        const weightsBuf = backend.bufferSync(weights);
        const outBuf = (0, $fIVdF.bincountReduceImplCPU)(xBuf, weightsBuf, size, binaryOutput);
        return backend.makeTensorInfo(outBuf.shape, weights.dtype, outBuf.values);
    }
    throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank` + `${x.shape.length}.`);
}
const $b22cea7e09430d08$export$88ba267b84334692 = {
    kernelName: (0, $dCP8m.DenseBincount),
    backendName: 'webgl',
    kernelFunc: $b22cea7e09430d08$export$436934e6cf1946f1
};

});

parcelRegister("5c0Ik", function(module, exports) {

$parcel$export(module.exports, "depthToSpaceConfig", () => $3c7ea08195b26b92$export$9c5b88dcb1d2008b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $8WiOe = parcelRequire("8WiOe");
function $3c7ea08195b26b92$export$3b50daec0f185f12(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockSize: blockSize, dataFormat: dataFormat } = attrs;
    const batchSize = x.shape[0];
    const inputHeight = dataFormat === 'NHWC' ? x.shape[1] : x.shape[2];
    const inputWidth = dataFormat === 'NHWC' ? x.shape[2] : x.shape[3];
    const inputDepth = dataFormat === 'NHWC' ? x.shape[3] : x.shape[1];
    const outputHeight = inputHeight * blockSize;
    const outputWidth = inputWidth * blockSize;
    const outputDepth = inputDepth / (blockSize * blockSize);
    const outputShape = dataFormat === 'NHWC' ? [
        batchSize,
        outputHeight,
        outputWidth,
        outputDepth
    ] : [
        batchSize,
        outputDepth,
        outputHeight,
        outputWidth
    ];
    const program = new (0, $8WiOe.DepthToSpaceProgram)(outputShape, blockSize, dataFormat);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $3c7ea08195b26b92$export$9c5b88dcb1d2008b = {
    kernelName: (0, $dCP8m.DepthToSpace),
    backendName: 'webgl',
    kernelFunc: $3c7ea08195b26b92$export$3b50daec0f185f12
};

});
parcelRegister("8WiOe", function(module, exports) {

$parcel$export(module.exports, "DepthToSpaceProgram", () => $6822549bc2aeed1f$export$eb07f17369165f28);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $6822549bc2aeed1f$export$eb07f17369165f28 {
    constructor(outputShape, blockSize, dataFormat){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        this.outputShape = outputShape;
        this.blockSize = blockSize;
        this.dataFormat = dataFormat;
        this.userCode = `
    void main() {
      ivec4 coords = getOutputCoords();
      int b = coords[0];
      int h = ${this.getHeightCoordString()};
      int w = ${this.getWidthCoordString()};
      int d = ${this.getDepthCoordString()};

      int in_h = h / ${blockSize};
      int offset_h = imod(h, ${blockSize});
      int in_w = w / ${blockSize};
      int offset_w = imod(w, ${blockSize});
      int offset_d = (offset_h * ${blockSize} + offset_w) *
        ${this.getOutputDepthSize()};
      int in_d = d + offset_d;

      float result = ${this.getInputSamplingString()};
      setOutput(result);
    }
  `;
    }
    getHeightCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[1]`;
        else return `coords[2]`;
    }
    getWidthCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[2]`;
        else return `coords[3]`;
    }
    getDepthCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[3]`;
        else return `coords[1]`;
    }
    getOutputDepthSize() {
        if (this.dataFormat === 'NHWC') return this.outputShape[3];
        else return this.outputShape[1];
    }
    getInputSamplingString() {
        if (this.dataFormat === 'NHWC') return `getX(b, in_h, in_w, in_d)`;
        else return `getX(b, in_d, in_h, in_w)`;
    }
}

});


parcelRegister("dl01A", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeConfig", () => $9b5d416b55f69a0d$export$240667804b7c390e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $aymVi = parcelRequire("aymVi");
var $wx9lK = parcelRequire("wx9lK");

var $ixl0a = parcelRequire("ixl0a");

var $h9Y03 = parcelRequire("h9Y03");
function $9b5d416b55f69a0d$export$14e793fe8822afd1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $wx9lK).assert((0, $lkN62).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $lkN62).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    let program;
    if ((0, $aymVi.env)().getBool('WEBGL_PACK_DEPTHWISECONV') && convInfo.strideWidth <= 2 && convInfo.outChannels / convInfo.inChannels === 1) program = new (0, $h9Y03.DepthwiseConvPacked2DProgram)(convInfo);
    else program = new (0, $ixl0a.DepthwiseConv2DProgram)(convInfo);
    const customValues = [
        [
            convInfo.padInfo.top,
            convInfo.padInfo.left
        ],
        [
            convInfo.strideHeight,
            convInfo.strideWidth
        ],
        [
            convInfo.dilationHeight,
            convInfo.dilationWidth
        ],
        [
            convInfo.inHeight,
            convInfo.inWidth
        ]
    ];
    return backend.runWebGLProgram(program, [
        x,
        filter
    ], 'float32', customValues);
}
const $9b5d416b55f69a0d$export$240667804b7c390e = {
    kernelName: (0, $dCP8m.DepthwiseConv2dNative),
    backendName: 'webgl',
    kernelFunc: $9b5d416b55f69a0d$export$14e793fe8822afd1
};

});
parcelRegister("ixl0a", function(module, exports) {

$parcel$export(module.exports, "DepthwiseConv2DProgram", () => $d7eb998e31b27f22$export$4ead5a4ba22ede40);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i88bA = parcelRequire("i88bA");
class $d7eb998e31b27f22$export$4ead5a4ba22ede40 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.customUniforms = [
            {
                name: 'pads',
                type: 'ivec2'
            },
            {
                name: 'strides',
                type: 'ivec2'
            },
            {
                name: 'dilations',
                type: 'ivec2'
            },
            {
                name: 'inDims',
                type: 'ivec2'
            }
        ];
        this.outputShape = convInfo.outShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `float activation(float a) {
          float b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyReluAlpha) activationSnippet = `float activation(float a) {
          float b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `
          float activation(float x) {
            ${activation}
          }
        `;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyReluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
      ${activationSnippet}

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        ivec2 xRCCorner = coords.yz * strides - pads;
        int d2 = coords.w;
        int d1 = d2 / ${channelMul};
        int q = d2 - d1 * ${channelMul};

        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        // TO DO(dsmilkov): Flatten the two for loops and vec4 the operations.
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          int xR = xRCorner + wR * dilations[0];

          if (xR < 0 || xR >= inDims[0]) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int xC = xCCorner + wC * dilations[1];

            if (xC < 0 || xC >= inDims[1]) {
              continue;
            }

            float xVal = getX(batch, xR, xC, d1);
            float wVal = getW(wR, wC, d1, q);
            dotProd += xVal * wVal;
          }
        }

        float result = dotProd;
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
    }
}

});

parcelRegister("h9Y03", function(module, exports) {

$parcel$export(module.exports, "DepthwiseConvPacked2DProgram", () => $c7e1d1a218ca89d0$export$acb9287627a2b170);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $i88bA = parcelRequire("i88bA");
class $c7e1d1a218ca89d0$export$acb9287627a2b170 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'pads',
                type: 'ivec2'
            },
            {
                name: 'strides',
                type: 'ivec2'
            },
            {
                name: 'dilations',
                type: 'ivec2'
            },
            {
                name: 'inDims',
                type: 'ivec2'
            }
        ];
        this.outputShape = convInfo.outShape;
        this.enableShapeUniforms = (0, $i88bA.useShapeUniforms)(this.outputShape.length);
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        const padLeft = convInfo.padInfo.left;
        const strideWidth = convInfo.strideWidth;
        const dilationWidth = convInfo.dilationWidth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const texelsAcross = filterWidth;
        let mainLoop = `
      int xR; int xC; int xCOffset;
      vec4 wTexel; vec4 previous; vec4 final;`;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
          vec4 xTexelC${c * 2};
          int xTexelC${c * 2}Ready;
          vec4 xTexelC${c * 2 + 1};
          int xTexelC${c * 2 + 1}Ready;
          vec4 xC${c};`;
        /**
         * This vectorized implementation works by gathering the values needed for
         * each output channel's dot product into vec4's and then multiplying them
         * all together (this happens in the final double for-loop below). Most of
         * the main loop consists of constructing these vec4's with the minimum
         * number of texture2D calls, which means making use of all four returned
         * values from a texture2D call at once.
         */ mainLoop += `
    for (int r = 0; r < ${filterHeight}; r++) {
      `;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
          xTexelC${c * 2} = vec4(0.0);
          xTexelC${c * 2}Ready = 0;
          xTexelC${c * 2 + 1} = vec4(0.0);
          xTexelC${c * 2 + 1}Ready = 0;
          xC${c} = vec4(0.0);`;
        mainLoop += `
        xR = xRCorner + r * dilations[0];
        if (xR >=0 && xR < inDims[0]) {
      `;
        for(let texelC = 0; texelC < (texelsAcross + 1) / 2; texelC++){
            const colIndex = texelC * 2;
            mainLoop += `
          xC = xCCorner + ${colIndex * dilationWidth};
          `;
            if (strideWidth === 1) {
                if (colIndex < filterWidth) {
                    // If padding is odd, the outer texels have to be composed.
                    if (padLeft % 2 === 1) {
                        // TODO: Ensure vec4 previous does not result in redundant sample,
                        // and avoid setting xTexelRC's that exceed the boundary in the
                        // first place rather than resetting them to vec4(0)).
                        // To compute xCOffset:
                        // - If padding is odd, we must add 1 to ensure we ask for an
                        // even-numbered row.
                        // - We subtract 2 to access the previous texel.
                        mainLoop += `
                xCOffset = xC + 1;
                if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);

                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }
              `;
                        // This texel has been read in previous iteration if the dilation
                        // is 1.
                        if (dilationWidth === 1 && colIndex > 0) mainLoop += `
                xC${colIndex} = vec4(xTexelC${colIndex - 2}.zw, xTexelC${colIndex}.xy);
                `;
                        else mainLoop += `
                  xCOffset = xC + 1 - 2;

                  if (xCOffset >= 0 && xCOffset < inDims[1]) {
                    previous = getX(batch, xR, xCOffset, d1);

                    // Need to manually clear unused channels in case
                    // we're reading from recycled texture.
                    if (xCOffset + 1 >= inDims[1]) {
                      previous.zw = vec2(0.0);
                    }

                    xC${colIndex} = vec4(previous.zw, xTexelC${colIndex}.xy);
                  } else {
                    xC${colIndex} = vec4(0.0, 0.0, xTexelC${colIndex}.xy);
                  }
                  `;
                    } else // Padding is even, so xRC corresponds to a single texel.
                    mainLoop += `
                if (xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xC, d1);
                  if (xC + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                xC${colIndex} = xTexelC${colIndex};
                `;
                    if (colIndex + 1 < filterWidth) {
                        // If dilation is even, the second entry should match the first
                        // (either both are composed or both are single samples). But if
                        // dilation is odd, then the second entry should be the opposite
                        // of the first (if the first is composed, the second is a single
                        // sample, and vice versa.)
                        const nextTexelOffset = padLeft % 2 === 0 ? (0, $wx9lK).nearestLargerEven(dilationWidth) : dilationWidth;
                        if (dilationWidth % 2 === 0 && padLeft % 2 === 1 || dilationWidth % 2 !== 0 && padLeft % 2 !== 1) {
                            mainLoop += `
                  xCOffset = xC + imod(pads[1], 2) + ${nextTexelOffset};

                  if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                    xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);

                    // Need to manually clear unused channels in case
                    // we're reading from recycled texture.
                    if (xCOffset + 1 >= inDims[1]) {
                      xTexelC${colIndex + 1}.zw = vec2(0.0);
                    }
                    xTexelC${colIndex + 1}Ready = 1;
                  }
                  `;
                            // If dilation > 1 then the xRC's will not be able to share any
                            // values, so each xRC will require two unique calls to getX.
                            if (dilationWidth > 1) mainLoop += `
                    xCOffset -= 2;
                    if (xCOffset >= 0 && xCOffset < inDims[1]) {
                     previous = getX(batch, xR, xCOffset, d1);
                     xC${colIndex + 1} = vec4(previous.zw, xTexelC${colIndex + 1}.xy);
                    } else {
                     xC${colIndex + 1} = vec4(0.0, 0.0, xTexelC${colIndex + 1}.xy);
                    }
                    `;
                            else mainLoop += `
                    xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.xy);
                    `;
                        } else // If dilation is 1 and padding is odd, we have already read the
                        // texel when constructing the previous x value. Here we can
                        // simply skip the texture read.
                        if (nextTexelOffset === 1) mainLoop += `
                    xC${colIndex + 1} = xTexelC${colIndex};
                    `;
                        else mainLoop += `
                    xCOffset = xC + ${nextTexelOffset};

                    if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                      xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                      if (xCOffset + 1 >= inDims[1]) {
                        xTexelC${colIndex + 1}.zw = vec2(0.0);
                      }
                      xTexelC${colIndex + 1}Ready = 1;
                    }

                    xC${colIndex + 1} = xTexelC${colIndex + 1};
                    `;
                    }
                }
            } else if (colIndex < filterWidth) {
                // Depending on whether padLeft is even or odd, we want either the
                // xy or zw channels from X texels for xC${colIndex}. If padLeft is
                // even, xC${colIndex +1} is simply the zw channels of texels we've
                // already sampled. But if padLeft is odd, xC{$c + 1}.zw will
                // need to come from the xy channels of a new texel, hence the `
                // vec4
                // final` initialized below.
                if (padLeft % 2 === 1) {
                    mainLoop += `
                xCOffset = xC + 1 - strides[1];
                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);
                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                  xTexelC${colIndex + 1} = getX(batch, xR, xC + 1, d1);
                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xC + 2 >= inDims[1]) {
                    xTexelC${colIndex + 1}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex + 1}Ready = 1;
                }

                xC${colIndex} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
              `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                  final = vec4(0.0);
                  xCOffset = xC + 1 + strides[1];
                  if(xCOffset >= 0 && xCOffset < inDims[1]) {
                    final = getX(batch, xR, xCOffset, d1);
                  }
                  xC${colIndex + 1} = vec4(xTexelC${colIndex + 1}.xy, final.xy);
                `;
                } else {
                    mainLoop += `
                if(xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xC, d1);
                  if (xC + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                xCOffset = xC + strides[1];
                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                  xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex + 1}.zw = vec2(0.);
                  }
                  xTexelC${colIndex + 1}Ready = 1;
                }

                xC${colIndex} = vec4(
                  xTexelC${colIndex}.xy, xTexelC${colIndex + 1}.xy);
              `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                  xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
                `;
                }
            }
            // localize the dotProd accumulation within the loop, the theory is for
            // GPU with limited cache, accumulate sum across large amount of
            // veriables will cause lots of cache misses. (i.e. 5x5 filter will have
            // 50 variables)
            if (colIndex < filterWidth) {
                mainLoop += `
            wTexel = getW(r, ${colIndex}, d1, q);
            dotProd += xC${colIndex} * vec4(wTexel.xz, wTexel.xz);
          `;
                if (colIndex + 1 < filterWidth) mainLoop += `
              wTexel = getW(r, ${colIndex + 1}, d1, q);
              dotProd += xC${colIndex + 1} * vec4(wTexel.xz, wTexel.xz);
            `;
            }
        }
        mainLoop += `
    }
  `;
        mainLoop += `
      }
    `;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyReluAlpha) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `vec4 activation(vec4 x) {
          ${activation}
        }`;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyReluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
      ${activationSnippet}

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        ivec2 xRCCorner = coords.yz * strides - pads;
        int d2 = coords.w;
        int d1 = d2 / ${channelMul};
        int q = d2 - d1 * ${channelMul};
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.
        vec4 dotProd = vec4(0.000000000000001);

        ${mainLoop}

        vec4 result = dotProd - vec4(0.000000000000001);
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("1KKc6", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropFilterConfig", () => $146deb8a01c1e847$export$30bc0ac3775583fc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $d3Vni = parcelRequire("d3Vni");
function $146deb8a01c1e847$export$cc0ae65e9edc7e1a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    const convInfo = (0, $lkN62).computeConv2DInfo(x.shape, filterShape, strides, dilations, pad, dimRoundingMode, true);
    const program = new (0, $d3Vni.DepthwiseConv2DDerFilterProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        dy
    ], 'float32');
}
const $146deb8a01c1e847$export$30bc0ac3775583fc = {
    kernelName: (0, $dCP8m.DepthwiseConv2dNativeBackpropFilter),
    backendName: 'webgl',
    kernelFunc: $146deb8a01c1e847$export$cc0ae65e9edc7e1a
};

});
parcelRegister("d3Vni", function(module, exports) {

$parcel$export(module.exports, "DepthwiseConv2DDerFilterProgram", () => $98280f98db35f986$export$9f5b7866589daeae);
$parcel$export(module.exports, "DepthwiseConv2DDerInputProgram", () => $98280f98db35f986$export$9b7e054f73b1374b);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $98280f98db35f986$export$9f5b7866589daeae {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.outputShape = convInfo.filterShape;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int wR = coords.x;
        int wC = coords.y;
        int d1 = coords.z;
        int dm = coords.w;
        int d2 = d1 * ${channelMul} + dm;

        float dotProd = 0.0;

        // TO DO: Vec4 over the batch size
        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
            int xR = wR + yR * ${strideHeight} - ${padTop};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
              int xC = wC + yC * ${strideWidth} - ${padLeft};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              float dyValue = getDy(b, yR, yC, d2);
              float xValue = getX(b, xR, xC, d1);
              dotProd += (xValue * dyValue);
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $98280f98db35f986$export$9b7e054f73b1374b {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.outputShape = convInfo.inShape;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[3];
        ivec2 dyCorner = coords.yz - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        float dotProd = 0.0;

        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            int wCPerm = ${filterWidth} - 1 - wC;

            // TO DO: Vec4 over the channelMul
            for (int dm = 0; dm < ${channelMul}; dm++) {
              int d2 = d1 * ${channelMul} + dm;
              float xValue = getDy(batch, idyR, idyC, d2);
              float wValue = getW(wRPerm, wCPerm, d1, dm);
              dotProd += xValue * wValue;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}

});


parcelRegister("3PCmF", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropInputConfig", () => $2ca3e4f29104f738$export$55d12409e744bebe);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $d3Vni = parcelRequire("d3Vni");
function $2ca3e4f29104f738$export$37e2ab95a4a4c24b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, inputShape: inputShape } = attrs;
    const convInfo = (0, $lkN62).computeConv2DInfo(inputShape, filter.shape, strides, dilations, pad, dimRoundingMode, true);
    const program = new (0, $d3Vni.DepthwiseConv2DDerInputProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        dy,
        filter
    ], 'float32');
}
const $2ca3e4f29104f738$export$55d12409e744bebe = {
    kernelName: (0, $dCP8m.DepthwiseConv2dNativeBackpropInput),
    backendName: 'webgl',
    kernelFunc: $2ca3e4f29104f738$export$37e2ab95a4a4c24b
};

});

parcelRegister("eV0Th", function(module, exports) {

$parcel$export(module.exports, "diagConfig", () => $adc71467984afa37$export$56dc5d812a22748f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $lABry = parcelRequire("lABry");

var $9gI7w = parcelRequire("9gI7w");
function $adc71467984afa37$export$c042e7c2f59bc046(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const outShape = [
        ...x.shape,
        ...x.shape
    ];
    const xSize = (0, $wx9lK).sizeFromShape(x.shape);
    const flat = (0, $9gI7w.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                xSize
            ]
        }
    });
    const program = new (0, $lABry.DiagProgram)(xSize);
    const res = backend.runWebGLProgram(program, [
        flat
    ], flat.dtype);
    const out = (0, $9gI7w.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(flat);
    backend.disposeIntermediateTensorInfo(res);
    return out;
}
const $adc71467984afa37$export$56dc5d812a22748f = {
    kernelName: (0, $dCP8m.Diag),
    backendName: 'webgl',
    kernelFunc: $adc71467984afa37$export$c042e7c2f59bc046
};

});
parcelRegister("lABry", function(module, exports) {

$parcel$export(module.exports, "DiagProgram", () => $fb7a013d93dcfd4c$export$d3d3824ae4245092);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $fb7a013d93dcfd4c$export$d3d3824ae4245092 {
    constructor(size){
        this.variableNames = [
            'X'
        ];
        this.outputShape = [
            size,
            size
        ];
        this.userCode = `
      void main() {
          ivec2 coords = getOutputCoords();
          float val = coords[0] == coords[1] ? getX(coords[0]) : 0.0;
          setOutput(val);
      }
    `;
    }
}

});


parcelRegister("9rEKP", function(module, exports) {

$parcel$export(module.exports, "dilation2DConfig", () => $6e063fa6e72a4774$export$36d3c11f61a8891a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $2eqi0 = parcelRequire("2eqi0");

var $9gI7w = parcelRequire("9gI7w");
function $6e063fa6e72a4774$export$544ec6096a7ab30(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $lkN62).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
    let out;
    const program = new (0, $2eqi0.Dilation2DProgram)(convInfo);
    out = backend.runWebGLProgram(program, [
        x,
        filter
    ], 'float32');
    const outReshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    backend.disposeIntermediateTensorInfo(out);
    return outReshaped;
}
const $6e063fa6e72a4774$export$36d3c11f61a8891a = {
    kernelName: (0, $dCP8m.Dilation2D),
    backendName: 'webgl',
    kernelFunc: $6e063fa6e72a4774$export$544ec6096a7ab30
};

});
parcelRegister("2eqi0", function(module, exports) {

$parcel$export(module.exports, "Dilation2DProgram", () => $1a014819df25ac63$export$b3acfd0493b4c03e);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $1a014819df25ac63$export$b3acfd0493b4c03e {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'W'
        ];
        this.outputShape = convInfo.outShape;
        const { inHeight: inHeight, inWidth: inWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth } = convInfo;
        const { top: padTop, left: padLeft } = padInfo;
        this.userCode = `
      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float neg_infinity = -3.4e38;

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        int d1 = coords.w;
        ivec2 outTopLeftCorner =
            coords.yz * strides - pads;
        int hBeg = outTopLeftCorner.x;
        int wBeg = outTopLeftCorner.y;

        float curVal = neg_infinity;
        for (int h = 0; h < ${filterHeight}; h++) {
          int hIn = hBeg + h * ${dilationHeight};

          if (hIn >= 0 && hIn < ${inHeight}) {
            for (int w = 0; w < ${filterWidth}; w++) {
              int wIn = wBeg + w * ${dilationWidth};

              if (wIn >= 0 && wIn < ${inWidth}) {
                float xVal = getX(batch, hIn, wIn, d1);
                float wVal = getW(h, w, d1);

                float val = xVal + wVal;
                if (val > curVal) {
                  curVal = val;
                }
              }
            }
          }
        }

        float result = curVal;
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("iQYlA", function(module, exports) {

$parcel$export(module.exports, "einsumConfig", () => $db9be5084537a713$export$40bbf341885a23b7);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $5hV6I = parcelRequire("5hV6I");

var $9gI7w = parcelRequire("9gI7w");

var $jS2yk = parcelRequire("jS2yk");

var $lHu0m = parcelRequire("lHu0m");
function $db9be5084537a713$export$27265e7daac5c403(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { equation: equation } = attrs;
    const tensors = inputs;
    const { allDims: allDims, summedDims: summedDims, idDims: idDims } = (0, $lkN62).decodeEinsumEquation(equation, tensors.length);
    (0, $lkN62).checkEinsumDimSizes(allDims.length, idDims, tensors);
    const { path: path, steps: steps } = (0, $lkN62).getEinsumComputePath(summedDims, idDims);
    const nSteps = steps.length;
    let out = null;
    let numDimsRemaining = allDims.length;
    const tensorsToDispose = [];
    for(let i = 0; i < nSteps; ++i){
        for (const idTerm of steps[i]){
            const { permutationIndices: perm, expandDims: dimsToExpand } = (0, $lkN62).getEinsumPermutation(numDimsRemaining, idDims[idTerm]);
            let x;
            if ((0, $lkN62).isIdentityPermutation(perm)) x = tensors[idTerm];
            else {
                x = (0, $lHu0m.transpose)({
                    inputs: {
                        x: tensors[idTerm]
                    },
                    backend: backend,
                    attrs: {
                        perm: perm
                    }
                });
                tensorsToDispose.push(x);
            }
            const targetShape = x.shape.slice();
            for(let k = 0; k < dimsToExpand.length; ++k)targetShape.splice(dimsToExpand[k], 0, 1);
            if (!(0, $wx9lK).arraysEqual(x.shape, targetShape)) {
                x = (0, $9gI7w.reshape)({
                    inputs: {
                        x: x
                    },
                    backend: backend,
                    attrs: {
                        shape: targetShape
                    }
                });
                tensorsToDispose.push(x);
            }
            if (out === null) out = x;
            else {
                // tslint:disable-next-line: no-unnecessary-type-assertion
                out = (0, $5hV6I.multiply)({
                    inputs: {
                        a: x,
                        b: out
                    },
                    backend: backend
                });
                tensorsToDispose.push(out);
            }
        }
        if (i < nSteps - 1) {
            if (path[i] >= 0) {
                out = (0, $jS2yk.sum)({
                    inputs: {
                        x: out
                    },
                    backend: backend,
                    attrs: {
                        axis: path[i] - (allDims.length - numDimsRemaining),
                        keepDims: false
                    }
                });
                tensorsToDispose.push(out);
            }
            numDimsRemaining--;
        }
    }
    // Clean up intermediate tensors.
    for (const tensorInfo of tensorsToDispose){
        if (tensorInfo === out) continue;
        backend.disposeIntermediateTensorInfo(tensorInfo);
    }
    return out;
}
const $db9be5084537a713$export$40bbf341885a23b7 = {
    kernelName: (0, $dCP8m.Einsum),
    backendName: 'webgl',
    kernelFunc: $db9be5084537a713$export$27265e7daac5c403
};

});

parcelRegister("75A1N", function(module, exports) {

$parcel$export(module.exports, "eluConfig", () => $5294f2721c5e13b6$export$b990686634ee3cce);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $5294f2721c5e13b6$var$ELU = `return (x >= 0.0) ? x : (exp(x) - 1.0);`;
const $5294f2721c5e13b6$var$ELU_PACKED = `
  vec4 result;

  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);
  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);
  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);
  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);

  return result;
`;
const $5294f2721c5e13b6$var$elu = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $5294f2721c5e13b6$var$ELU,
    packedOpSnippet: $5294f2721c5e13b6$var$ELU_PACKED
});
const $5294f2721c5e13b6$export$b990686634ee3cce = {
    kernelName: (0, $dCP8m.Elu),
    backendName: 'webgl',
    kernelFunc: $5294f2721c5e13b6$var$elu
};

});

parcelRegister("cYGyJ", function(module, exports) {

$parcel$export(module.exports, "eluGradConfig", () => $972c1a029409d488$export$59bb07dd04647a1d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $aymVi = parcelRequire("aymVi");

var $Ngeff = parcelRequire("Ngeff");

var $bMo9e = parcelRequire("bMo9e");
const $972c1a029409d488$var$ELU_DER = `return (b >= 1.0) ? a : a * (b + 1.0);`;
const $972c1a029409d488$var$ELU_DER_PACKED = `
  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));
  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));
`;
const $972c1a029409d488$export$a346244024505ff9 = (args)=>{
    const { inputs: inputs, backend: backend } = args;
    const { dy: dy, y: y } = inputs;
    const program = (0, $aymVi.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS') ? new (0, $bMo9e.BinaryOpPackedProgram)($972c1a029409d488$var$ELU_DER_PACKED, dy.shape, y.shape) : new (0, $Ngeff.BinaryOpProgram)($972c1a029409d488$var$ELU_DER, dy.shape, y.shape);
    return backend.runWebGLProgram(program, [
        dy,
        y
    ], dy.dtype);
};
const $972c1a029409d488$export$59bb07dd04647a1d = {
    kernelName: (0, $dCP8m.EluGrad),
    backendName: 'webgl',
    kernelFunc: $972c1a029409d488$export$a346244024505ff9
};

});

parcelRegister("7NcYQ", function(module, exports) {

$parcel$export(module.exports, "equalConfig", () => $5ac72da8a8e11024$export$3c8bc3d8ee318217);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $5ac72da8a8e11024$var$PACKED_EQUAL = `
  return vec4(equal(a, b));
`;
const $5ac72da8a8e11024$var$EQUAL = `return float(a == b);`;
const $5ac72da8a8e11024$export$411ce8e5a71e3069 = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $5ac72da8a8e11024$var$EQUAL,
    packedOpSnippet: $5ac72da8a8e11024$var$PACKED_EQUAL,
    dtype: 'bool',
    cpuKernelImpl: (0, $fIVdF.equalImplCPU)
});
const $5ac72da8a8e11024$export$3c8bc3d8ee318217 = {
    kernelName: (0, $dCP8m.Equal),
    backendName: 'webgl',
    kernelFunc: $5ac72da8a8e11024$export$411ce8e5a71e3069
};

});

parcelRegister("85jqi", function(module, exports) {

$parcel$export(module.exports, "erfConfig", () => $5e2ddb67ae0a1238$export$d044ffef16079bd);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $5e2ddb67ae0a1238$var$ERF = `
  // Error function is calculated approximately with elementary function.
  // See "Handbook of Mathematical Functions with Formulas,
  // Graphs, and Mathematical Tables", Abramowitz and Stegun.
  float p = ${(0, $lkN62).ERF_P};
  float a1 = ${(0, $lkN62).ERF_A1};
  float a2 = ${(0, $lkN62).ERF_A2};
  float a3 = ${(0, $lkN62).ERF_A3};
  float a4 = ${(0, $lkN62).ERF_A4};
  float a5 = ${(0, $lkN62).ERF_A5};

  float sign = sign(x);
  x = abs(x);
  float t = 1.0 / (1.0 + p * x);
  return sign * (1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x));
`;
const $5e2ddb67ae0a1238$export$d3896f355fc09423 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $5e2ddb67ae0a1238$var$ERF
});
const $5e2ddb67ae0a1238$export$d044ffef16079bd = {
    kernelName: (0, $dCP8m.Erf),
    backendName: 'webgl',
    kernelFunc: $5e2ddb67ae0a1238$export$d3896f355fc09423
};

});

parcelRegister("5Byii", function(module, exports) {

$parcel$export(module.exports, "exp", () => $010d98d09da45ffc$export$b310ec824aaee37f);
$parcel$export(module.exports, "expConfig", () => $010d98d09da45ffc$export$2fd7ea0fcf021f34);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $010d98d09da45ffc$export$e17bfbab9ca97165 = (0, $eWZon.CHECK_NAN_SNIPPET_UNARY) + `
  return exp(x);
`;
const $010d98d09da45ffc$var$EXP_PACKED = `
  vec4 result = exp(x);
  bvec4 isNaN = isnan(x);
  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $010d98d09da45ffc$export$b310ec824aaee37f = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $010d98d09da45ffc$export$e17bfbab9ca97165,
    packedOpSnippet: $010d98d09da45ffc$var$EXP_PACKED,
    cpuKernelImpl: (0, $fIVdF.expImplCPU),
    dtype: 'float32'
});
const $010d98d09da45ffc$export$2fd7ea0fcf021f34 = {
    kernelName: (0, $dCP8m.Exp),
    backendName: 'webgl',
    kernelFunc: $010d98d09da45ffc$export$b310ec824aaee37f
};

});

parcelRegister("cFwC0", function(module, exports) {

$parcel$export(module.exports, "expandDims", () => $93929c6dadf98d59$export$d660d8ed21f46635);
$parcel$export(module.exports, "expandDimsConfig", () => $93929c6dadf98d59$export$86341ba0ce5d8e60);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $9gI7w = parcelRequire("9gI7w");
function $93929c6dadf98d59$export$d660d8ed21f46635(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { dim: dim } = attrs;
    const { input: input } = inputs;
    const inputRank = input.shape.length;
    const newShape = input.shape.slice();
    let $dim = dim;
    if (dim < 0) {
        // Negative value is counted from the tail of rank.
        (0, $wx9lK).assert(-(inputRank + 1) <= dim, ()=>`Axis must be in the interval [${-(inputRank + 1)}, ${inputRank}]`);
        $dim = inputRank + dim + 1;
    }
    newShape.splice($dim, 0, 1);
    return (0, $9gI7w.reshape)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: newShape
        }
    });
}
const $93929c6dadf98d59$export$86341ba0ce5d8e60 = {
    kernelName: (0, $dCP8m.ExpandDims),
    backendName: 'webgl',
    kernelFunc: $93929c6dadf98d59$export$d660d8ed21f46635
};

});

parcelRegister("924kU", function(module, exports) {

$parcel$export(module.exports, "expm1Config", () => $6937aa0e360945e0$export$16db8a08b36f938);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $6937aa0e360945e0$var$EXPM1 = `return exp(x) - 1.0;`;
const $6937aa0e360945e0$export$b6c0a80d46d3391d = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $6937aa0e360945e0$var$EXPM1,
    packedOpSnippet: $6937aa0e360945e0$var$EXPM1,
    cpuKernelImpl: (0, $fIVdF.expm1ImplCPU)
});
const $6937aa0e360945e0$export$16db8a08b36f938 = {
    kernelName: (0, $dCP8m.Expm1),
    backendName: 'webgl',
    kernelFunc: $6937aa0e360945e0$export$b6c0a80d46d3391d
};

});

parcelRegister("e4obH", function(module, exports) {

$parcel$export(module.exports, "fftConfig", () => $a3e43397022251fa$export$a4d564e380763c78);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $ghrrK = parcelRequire("ghrrK");
function $a3e43397022251fa$export$a535ef183b6128fa(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    return (0, $ghrrK.fftImpl)(input, false, backend);
}
const $a3e43397022251fa$export$a4d564e380763c78 = {
    kernelName: (0, $dCP8m.FFT),
    backendName: 'webgl',
    kernelFunc: $a3e43397022251fa$export$a535ef183b6128fa
};

});
parcelRegister("ghrrK", function(module, exports) {

$parcel$export(module.exports, "fftImpl", () => $bda386308befe622$export$75d3742a7578721e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $h47BT = parcelRequire("h47BT");

var $3GoRo = parcelRequire("3GoRo");

var $9gI7w = parcelRequire("9gI7w");
function $bda386308befe622$export$75d3742a7578721e(x, inverse, backend) {
    const xData = backend.texData.get(x.dataId);
    const inputSize = (0, $wx9lK).sizeFromShape(x.shape);
    // Collapse all outer dimensions to a single batch dimension.
    const innerDimensionSize = x.shape[x.shape.length - 1];
    const batch = inputSize / innerDimensionSize;
    const input2D = (0, $9gI7w.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                batch,
                innerDimensionSize
            ]
        }
    });
    const xShape = input2D.shape;
    const realProgram = new (0, $h47BT.FFTProgram)('real', xShape, inverse);
    const imagProgram = new (0, $h47BT.FFTProgram)('imag', xShape, inverse);
    const inputs = [
        {
            dataId: xData.complexTensorInfos.real.dataId,
            dtype: xData.complexTensorInfos.real.dtype,
            shape: xShape
        },
        {
            dataId: xData.complexTensorInfos.imag.dataId,
            dtype: xData.complexTensorInfos.imag.dtype,
            shape: xShape
        }
    ];
    const realPart = backend.runWebGLProgram(realProgram, inputs, 'float32');
    const imagPart = backend.runWebGLProgram(imagProgram, inputs, 'float32');
    const complexOutput = (0, $3GoRo.complex)({
        inputs: {
            real: realPart,
            imag: imagPart
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(realPart);
    backend.disposeIntermediateTensorInfo(imagPart);
    const complexOutputReshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: complexOutput
        },
        backend: backend,
        attrs: {
            shape: x.shape
        }
    });
    backend.disposeIntermediateTensorInfo(input2D);
    backend.disposeIntermediateTensorInfo(complexOutput);
    return complexOutputReshaped;
}

});
parcelRegister("h47BT", function(module, exports) {

$parcel$export(module.exports, "FFTProgram", () => $c6c8b697011da55e$export$234ba885e3a114f6);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $c6c8b697011da55e$export$234ba885e3a114f6 {
    constructor(component, inputShape, inverse){
        this.variableNames = [
            'real',
            'imag'
        ];
        const innerDim = inputShape[1];
        this.outputShape = inputShape;
        const exponentMultiplierSnippet = inverse ? `2.0 * ${Math.PI}` : `-2.0 * ${Math.PI}`;
        const resultDenominator = inverse ? `${innerDim}.0` : '1.0';
        let opString;
        if (component === 'real') opString = 'return real * expR - imag * expI;';
        else if (component === 'imag') opString = 'return real * expI + imag * expR;';
        else throw new Error(`FFT component must be either "real" or "imag", got ${component}.`);
        this.userCode = `
      const float exponentMultiplier = ${exponentMultiplierSnippet};

      float unaryOpComplex(float real, float expR, float imag, float expI) {
        ${opString}
      }

      float mulMatDFT(int batch, int index) {
        float indexRatio = float(index) / float(${innerDim});
        float exponentMultiplierTimesIndexRatio =
            exponentMultiplier * indexRatio;

        float result = 0.0;

        for (int i = 0; i < ${innerDim}; i++) {
          // x = (-2|2 * PI / N) * index * i;
          float x = exponentMultiplierTimesIndexRatio * float(i);
          float expR = cos(x);
          float expI = sin(x);
          float real = getReal(batch, i);
          float imag = getImag(batch, i);

          result +=
              unaryOpComplex(real, expR, imag, expI) / ${resultDenominator};
        }

        return result;
      }

      void main() {
        ivec2 coords = getOutputCoords();
        setOutput(mulMatDFT(coords[0], coords[1]));
      }
    `;
    }
}

});



parcelRegister("hOLpE", function(module, exports) {

$parcel$export(module.exports, "fill", () => $cf8be259a8223d9b$export$9563e054e6f787fb);
$parcel$export(module.exports, "fillConfig", () => $cf8be259a8223d9b$export$c953bf474b2bde62);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $4Jl1a = parcelRequire("4Jl1a");
function $cf8be259a8223d9b$export$9563e054e6f787fb(args) {
    const { backend: backend, attrs: attrs } = args;
    const { shape: shape, value: value } = attrs;
    let { dtype: dtype } = attrs;
    dtype = dtype || (0, $wx9lK).inferDtype(value);
    if (dtype === 'string') {
        // String type should be handled in CPU memory.
        const values = (0, $wx9lK).getArrayFromDType(dtype, (0, $wx9lK).sizeFromShape(shape));
        values.fill(value);
        return backend.makeTensorInfo(shape, dtype, values);
    } else {
        const program = new (0, $4Jl1a.FillProgram)(shape, value);
        const customValues = [
            [
                value
            ]
        ];
        return backend.runWebGLProgram(program, [], dtype, customValues);
    }
}
const $cf8be259a8223d9b$export$c953bf474b2bde62 = {
    kernelName: (0, $dCP8m.Fill),
    backendName: 'webgl',
    kernelFunc: $cf8be259a8223d9b$export$9563e054e6f787fb
};

});
parcelRegister("4Jl1a", function(module, exports) {

$parcel$export(module.exports, "FillProgram", () => $371bab1947df49c6$export$758181b12323e997);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $371bab1947df49c6$export$758181b12323e997 {
    constructor(shape, value){
        this.outputShape = [];
        this.customUniforms = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        this.variableNames = [
            'x'
        ];
        this.outputShape = shape;
        this.userCode = `
      void main() {
        // Input can be obtained from uniform value.
        setOutput(value);
      }
    `;
    }
}

});


parcelRegister("leJGm", function(module, exports) {

$parcel$export(module.exports, "flipLeftRightConfig", () => $f75e575855cb7769$export$c9ec83cb23304466);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $bSLl9 = parcelRequire("bSLl9");
const $f75e575855cb7769$export$c9ec83cb23304466 = {
    kernelName: (0, $dCP8m.FlipLeftRight),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, backend: backend })=>{
        const { image: image } = inputs;
        const webglBackend = backend;
        const program = new (0, $bSLl9.FlipLeftRightProgram)(image.shape);
        const output = webglBackend.runWebGLProgram(program, [
            image
        ], image.dtype);
        return output;
    }
};

});
parcelRegister("bSLl9", function(module, exports) {

$parcel$export(module.exports, "FlipLeftRightProgram", () => $8a69759e08d86f84$export$872622c1de722f28);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $8a69759e08d86f84$export$872622c1de722f28 {
    constructor(imageShape){
        this.variableNames = [
            'Image'
        ];
        this.outputShape = [];
        const imageWidth = imageShape[2];
        this.outputShape = imageShape;
        this.userCode = `
        void main() {
          ivec4 coords = getOutputCoords();
          int x = coords[2];

          int coordX = ${imageWidth} - x - 1;
          float outputValue;
          if(coordX >= 0 && coordX < ${imageWidth}) {
            outputValue = getImage(coords[0], coords[1], coordX, coords[3]);
          } else {
            outputValue = getImage(coords[0], coords[1], coords[2], coords[3]);
          }
          setOutput(outputValue);
        }
    `;
    }
}

});


parcelRegister("Tu8Z2", function(module, exports) {

$parcel$export(module.exports, "floorConfig", () => $0a6c851e44bcaed2$export$7e9a0f96fa6bd01c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $0a6c851e44bcaed2$var$FLOOR = `return floor(x);`;
const $0a6c851e44bcaed2$export$a3fe094919f356fd = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $0a6c851e44bcaed2$var$FLOOR,
    packedOpSnippet: $0a6c851e44bcaed2$var$FLOOR,
    cpuKernelImpl: (0, $fIVdF.floorImplCPU)
});
const $0a6c851e44bcaed2$export$7e9a0f96fa6bd01c = {
    kernelName: (0, $dCP8m.Floor),
    backendName: 'webgl',
    kernelFunc: $0a6c851e44bcaed2$export$a3fe094919f356fd
};

});

parcelRegister("alLlV", function(module, exports) {

$parcel$export(module.exports, "floorDivConfig", () => $789098ca78b42823$export$7eac933a0c7fd37f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
// We use native integer division to deal with floating point imprecision. Since
// we implement floor division and glsl implements truncated division, we
// correct for this by subtracting 1 from result when the result is negative and
// there is a remainder.
const $789098ca78b42823$var$INT_DIV = `
  float s = sign(a) * sign(b);
  int ia = round(a);
  int ib = round(b);
  if (ib != 0) {
    // Windows (D3D) wants guaranteed non-zero int division at compile-time.
    return float(idiv(ia, ib, s));
  } else {
    return NAN;
  }
`;
const $789098ca78b42823$var$INT_DIV_PACKED = `
  ivec4 ia = round(a);
  ivec4 ib = round(b);
  bvec4 cond = notEqual(ib, ivec4(0));
  ivec4 result = ivec4(0);
  vec4 s = sign(a) * sign(b);

  // Windows (D3D) wants guaranteed non-zero int division at compile-time.
  if (cond[0]) {
    result[0] = idiv(ia[0], ib[0], s[0]);
  }
  if (cond[1]) {
    result[1] = idiv(ia[1], ib[1], s[1]);
  }
  if (cond[2]) {
    result[2] = idiv(ia[2], ib[2], s[2]);
  }
  if (cond[3]) {
    result[3] = idiv(ia[3], ib[3], s[3]);
  }
  return vec4(result);
`;
const $789098ca78b42823$export$112397bc52715a8 = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $789098ca78b42823$var$INT_DIV,
    packedOpSnippet: $789098ca78b42823$var$INT_DIV_PACKED,
    dtype: 'int32'
});
const $789098ca78b42823$export$7eac933a0c7fd37f = {
    kernelName: (0, $dCP8m.FloorDiv),
    backendName: 'webgl',
    kernelFunc: $789098ca78b42823$export$112397bc52715a8
};

});

parcelRegister("gUFoD", function(module, exports) {

$parcel$export(module.exports, "fromPixelsConfig", () => $c501fcc0a825f2d4$export$b22e14d614fc7178);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");

var $lE6VE = parcelRequire("lE6VE");

var $2mNXj = parcelRequire("2mNXj");

var $8KA3l = parcelRequire("8KA3l");
const $c501fcc0a825f2d4$export$b22e14d614fc7178 = {
    kernelName: (0, $dCP8m.FromPixels),
    backendName: 'webgl',
    kernelFunc: $c501fcc0a825f2d4$var$fromPixels
};
let $c501fcc0a825f2d4$var$fromPixels2DContext;
let $c501fcc0a825f2d4$var$willReadFrequently = (0, $aymVi.env)().getBool('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU');
function $c501fcc0a825f2d4$var$fromPixels(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    let { pixels: pixels } = inputs;
    const { numChannels: numChannels } = attrs;
    const isVideo = typeof HTMLVideoElement !== 'undefined' && pixels instanceof HTMLVideoElement;
    const isImage = typeof HTMLImageElement !== 'undefined' && pixels instanceof HTMLImageElement;
    const [width, height] = isVideo ? [
        pixels.videoWidth,
        pixels.videoHeight
    ] : [
        pixels.width,
        pixels.height
    ];
    const texShape = [
        height,
        width
    ];
    const outShape = [
        height,
        width,
        numChannels
    ];
    if (isImage || isVideo) {
        const newWillReadFrequently = (0, $aymVi.env)().getBool('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU');
        if ($c501fcc0a825f2d4$var$fromPixels2DContext == null || newWillReadFrequently !== $c501fcc0a825f2d4$var$willReadFrequently) {
            $c501fcc0a825f2d4$var$willReadFrequently = newWillReadFrequently;
            $c501fcc0a825f2d4$var$fromPixels2DContext = document.createElement('canvas').getContext('2d', {
                willReadFrequently: $c501fcc0a825f2d4$var$willReadFrequently
            });
        }
        $c501fcc0a825f2d4$var$fromPixels2DContext.canvas.width = width;
        $c501fcc0a825f2d4$var$fromPixels2DContext.canvas.height = height;
        $c501fcc0a825f2d4$var$fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
        pixels = $c501fcc0a825f2d4$var$fromPixels2DContext.canvas;
    }
    const tempPixelHandle = backend.makeTensorInfo(texShape, 'int32');
    // This is a byte texture with pixels.
    backend.texData.get(tempPixelHandle.dataId).usage = (0, $lE6VE.TextureUsage).PIXELS;
    backend.gpgpu.uploadPixelDataToTexture(backend.getTexture(tempPixelHandle.dataId), pixels);
    const program = (0, $aymVi.env)().getBool('WEBGL_PACK') ? new (0, $8KA3l.FromPixelsPackedProgram)(outShape) : new (0, $2mNXj.FromPixelsProgram)(outShape);
    const res = backend.runWebGLProgram(program, [
        tempPixelHandle
    ], 'int32');
    backend.disposeData(tempPixelHandle.dataId);
    return res;
}

});
parcelRegister("2mNXj", function(module, exports) {

$parcel$export(module.exports, "FromPixelsProgram", () => $1b9462fd0dccd1f6$export$7ffba7be7a218615);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $f7Ffe = parcelRequire("f7Ffe");
class $1b9462fd0dccd1f6$export$7ffba7be7a218615 {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        const glsl = (0, $f7Ffe.getGlslDifferences)();
        const [height, width] = outputShape;
        this.outputShape = outputShape;
        this.userCode = `
      void main() {
        ivec3 coords = getOutputCoords();
        int texR = coords[0];
        int texC = coords[1];
        int depth = coords[2];
        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${width}.0, ${height}.0);

        vec4 values = ${glsl.texture2D}(A, uv);
        float value;
        if (depth == 0) {
          value = values.r;
        } else if (depth == 1) {
          value = values.g;
        } else if (depth == 2) {
          value = values.b;
        } else if (depth == 3) {
          value = values.a;
        }

        setOutput(floor(value * 255.0 + 0.5));
      }
    `;
    }
}

});

parcelRegister("8KA3l", function(module, exports) {

$parcel$export(module.exports, "FromPixelsPackedProgram", () => $65ee95fd0ce4727a$export$5f4cf05de268f9cf);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $f7Ffe = parcelRequire("f7Ffe");
class $65ee95fd0ce4727a$export$5f4cf05de268f9cf {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        const glsl = (0, $f7Ffe.getGlslDifferences)();
        const [height, width] = outputShape;
        this.outputShape = outputShape;
        this.userCode = `
      void main() {
        ivec3 coords = getOutputCoords();
        int texR = coords[0];
        int texC = coords[1];
        int depth = coords[2];

        vec4 result = vec4(0.);

        for(int row=0; row<=1; row++) {
          for(int col=0; col<=1; col++) {
            texC = coords[1] + row;
            depth = coords[2] + col;

            vec2 uv = (vec2(texC, texR) + halfCR) /
                       vec2(${width}.0, ${height}.0);
            vec4 values = ${glsl.texture2D}(A, uv);
            float value;
            if (depth == 0) {
              value = values.r;
            } else if (depth == 1) {
              value = values.g;
            } else if (depth == 2) {
              value = values.b;
            } else if (depth == 3) {
              value = values.a;
            }

            result[row * 2 + col] = floor(value * 255.0 + 0.5);
          }
        }

        ${glsl.output} = result;
      }
    `;
    }
}

});


parcelRegister("aEWcT", function(module, exports) {

$parcel$export(module.exports, "fusedConv2DConfig", () => $7c2aca7a43c416e3$export$5b64efa829ddf94e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $cmVzC = parcelRequire("cmVzC");

var $ORp2G = parcelRequire("ORp2G");

var $eWZon = parcelRequire("eWZon");

var $h2EAr = parcelRequire("h2EAr");

var $9gI7w = parcelRequire("9gI7w");
function $7c2aca7a43c416e3$export$b4f4a900a93010a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    const $dataFormat = (0, $lkN62).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $lkN62).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    let out;
    const intermediates = [];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    const prepareInputs = ()=>{
        const inputs = [
            x,
            filter
        ];
        // If the input is a 1-D tensor, align it with the channels.
        //
        // For fusedConv2d, the inputs (x, W, bias, preluActivationWeights) are
        // supposed to be aligned with the dataFormat. The 4-D tensor inputs or
        // scalar inputs are originally aligned, but the 1-D tensor inputs are
        // supposed to be aligned with the channels (only bias and PReLU activation
        // weights could be a 1-D tensor).
        const alignInputWithDataFormat = (input, dataFormat)=>{
            if (dataFormat === 'NCHW' && input.shape.length === 1 && input.shape[0] !== 1) {
                const alignedInput = (0, $9gI7w.reshape)({
                    inputs: {
                        x: input
                    },
                    backend: backend,
                    attrs: {
                        shape: [
                            input.shape[0],
                            1,
                            1
                        ]
                    }
                });
                intermediates.push(alignedInput);
                return alignedInput;
            }
            return input;
        };
        if (hasBias) inputs.push(alignInputWithDataFormat(bias, dataFormat));
        if (hasPreluActivationWeights) inputs.push(alignInputWithDataFormat(preluActivationWeights, dataFormat));
        if (hasLeakyreluAlpha) {
            const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $wx9lK).createScalarValue(leakyreluAlpha, 'float32'));
            inputs.push($leakyreluAlpha);
            intermediates.push($leakyreluAlpha);
        }
        return inputs;
    };
    if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1 && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && (convInfo.padInfo.type === 'SAME' || convInfo.padInfo.type === 'VALID')) out = (0, $h2EAr.conv2dByMatMul)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    else if (convInfo.strideWidth <= 2 && $dataFormat === 'channelsLast' && (0, $aymVi.env)().getBool('WEBGL_EXP_CONV')) {
        const fusedActivation = activation ? (0, $eWZon.mapActivationToShaderProgram)(activation, true) : null;
        const program = new (0, $ORp2G.Conv2DPackedProgram)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
        const customValues = [
            [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ],
            [
                convInfo.strideHeight,
                convInfo.strideWidth
            ],
            [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ],
            [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        ];
        const inputs = prepareInputs();
        out = backend.runWebGLProgram(program, inputs, 'float32', customValues);
    } else if ((0, $aymVi.env)().getBool('WEBGL_CONV_IM2COL')) out = (0, $h2EAr.conv2dWithIm2Row)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    else {
        const fusedActivation = activation ? (0, $eWZon.mapActivationToShaderProgram)(activation, false) : null;
        const program = new (0, $cmVzC.Conv2DProgram)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
        const inputs = prepareInputs();
        out = backend.runWebGLProgram(program, inputs, 'float32');
    }
    const outReshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    intermediates.push(out);
    intermediates.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return outReshaped;
}
const $7c2aca7a43c416e3$export$5b64efa829ddf94e = {
    kernelName: (0, $dCP8m.FusedConv2D),
    backendName: 'webgl',
    kernelFunc: $7c2aca7a43c416e3$export$b4f4a900a93010a
};

});

parcelRegister("1EinK", function(module, exports) {

$parcel$export(module.exports, "fusedDepthwiseConv2DConfig", () => $1337c9258aa6f6dc$export$58481cc3409b412c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $ixl0a = parcelRequire("ixl0a");

var $h9Y03 = parcelRequire("h9Y03");

var $eWZon = parcelRequire("eWZon");
function $1337c9258aa6f6dc$export$d61de7729228094b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    const intermediates = [];
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $wx9lK).assert((0, $lkN62).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $lkN62).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    const shouldPackDepthwiseConv = (0, $aymVi.env)().getBool('WEBGL_PACK_DEPTHWISECONV') && convInfo.strideWidth <= 2 && convInfo.outChannels / convInfo.inChannels === 1;
    const fusedActivation = activation ? (0, $eWZon.mapActivationToShaderProgram)(activation, shouldPackDepthwiseConv) : null;
    const programInputs = [
        x,
        filter
    ];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    if (hasBias) programInputs.push(bias);
    if (hasPreluActivationWeights) programInputs.push(preluActivationWeights);
    if (hasLeakyreluAlpha) {
        const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $wx9lK).createScalarValue(leakyreluAlpha, 'float32'));
        programInputs.push($leakyreluAlpha);
        intermediates.push($leakyreluAlpha);
    }
    let program;
    if (shouldPackDepthwiseConv) program = new (0, $h9Y03.DepthwiseConvPacked2DProgram)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    else program = new (0, $ixl0a.DepthwiseConv2DProgram)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    const customValues = [
        [
            convInfo.padInfo.top,
            convInfo.padInfo.left
        ],
        [
            convInfo.strideHeight,
            convInfo.strideWidth
        ],
        [
            convInfo.dilationHeight,
            convInfo.dilationWidth
        ],
        [
            convInfo.inHeight,
            convInfo.inWidth
        ]
    ];
    const result = backend.runWebGLProgram(program, programInputs, 'float32', customValues);
    intermediates.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $1337c9258aa6f6dc$export$58481cc3409b412c = {
    kernelName: (0, $dCP8m.FusedDepthwiseConv2D),
    backendName: 'webgl',
    kernelFunc: $1337c9258aa6f6dc$export$d61de7729228094b
};

});

parcelRegister("1DTVB", function(module, exports) {

$parcel$export(module.exports, "gatherNdConfig", () => $1324d11efc1f3957$export$d9700eb1c7f5c969);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $kWNUM = parcelRequire("kWNUM");

var $fIVdF = parcelRequire("fIVdF");

var $9gI7w = parcelRequire("9gI7w");
function $1324d11efc1f3957$export$3c586830e482d2b9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { params: params, indices: indices } = inputs;
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    const paramsSize = (0, $wx9lK).sizeFromShape(params.shape);
    const [resultShape, numSlices, sliceSize, strides] = (0, $lkN62).prepareAndValidate(params, indices);
    const flattenIndices = (0, $9gI7w.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numSlices,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $9gI7w.reshape)({
        inputs: {
            x: params
        },
        backend: backend,
        attrs: {
            shape: [
                (0, $wx9lK).sizeFromShape(params.shape) / sliceSize,
                sliceSize
            ]
        }
    });
    if (backend.shouldExecuteOnCPU([
        params,
        indices
    ]) || params.dtype === 'string') {
        const indicesData = backend.readSync(indices.dataId);
        const paramsBuf = backend.bufferSync(params);
        const outValue = (0, $fIVdF.gatherNdImplCPU)(indicesData, paramsBuf, params.dtype, numSlices, sliceRank, sliceSize, strides, params.shape, paramsSize);
        return backend.makeTensorInfo(resultShape, params.dtype, outValue.values);
    }
    const program = new (0, $kWNUM.GatherNDProgram)(sliceRank, strides, [
        numSlices,
        sliceSize
    ], params.shape);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndices
    ], flattenX.dtype);
    const reshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: resultShape
        }
    });
    backend.disposeIntermediateTensorInfo(flattenIndices);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(res);
    return reshaped;
}
const $1324d11efc1f3957$export$d9700eb1c7f5c969 = {
    kernelName: (0, $dCP8m.GatherNd),
    backendName: 'webgl',
    kernelFunc: $1324d11efc1f3957$export$3c586830e482d2b9
};

});
parcelRegister("kWNUM", function(module, exports) {

$parcel$export(module.exports, "GatherNDProgram", () => $f3fff17680185e05$export$ffd508d535a7dba1);

var $7svrP = parcelRequire("7svrP");
class $f3fff17680185e05$export$ffd508d535a7dba1 {
    constructor(sliceDim, strides, shape, paramsShape){
        this.sliceDim = sliceDim;
        this.strides = strides;
        this.paramsShape = paramsShape;
        this.variableNames = [
            'x',
            'indices'
        ];
        this.outputShape = shape;
        const dtype = (0, $7svrP.getCoordsDataType)(shape.length);
        let mainLoop = `
    int index;`;
        for(let j = 0; j < this.sliceDim; j++)mainLoop += `
          index = round(getIndices(coords[0], ${j}));
          out_of_bounds = out_of_bounds || index < 0;
          out_of_bounds = out_of_bounds || index >= ${this.paramsShape[j]};
          flattenIndex += index * ${this.strides[j]};`;
        this.userCode = `
         void main() {
          ${dtype} coords = getOutputCoords();
          int flattenIndex = 0;
          bool out_of_bounds = false;

          ${mainLoop}

          setOutput(out_of_bounds ? 0.0 : getX(flattenIndex, coords[1]));
        }
      `;
    }
}

});


parcelRegister("8uyHu", function(module, exports) {

$parcel$export(module.exports, "gatherV2", () => $62ec0ae1bae9f45b$export$3d75b4295ded9925);
$parcel$export(module.exports, "gatherV2Config", () => $62ec0ae1bae9f45b$export$b1bd3139c91d8765);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $5b1L2 = parcelRequire("5b1L2");

var $fIVdF = parcelRequire("fIVdF");

var $9gI7w = parcelRequire("9gI7w");
function $62ec0ae1bae9f45b$export$3d75b4295ded9925(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, indices: indices } = inputs;
    const { axis: axis, batchDims: batchDims } = attrs;
    const parsedAxis = (0, $wx9lK).parseAxisParam(axis, x.shape)[0];
    if ((0, $aymVi.env)().get('DEBUG')) {
        // In debug mode, throw error when any index is out of bound.
        // Otherwise, just fill out of bounds with zeroes.
        const indicesVals = backend.readSync(indices.dataId);
        const axisDim = x.shape[parsedAxis];
        for(let i = 0; i < indicesVals.length; ++i){
            const index = indicesVals[i];
            (0, $wx9lK).assert(index <= axisDim - 1 && index >= 0, ()=>`GatherV2: the index value ${index} is not in [0, ${axisDim - 1}]`);
        }
    }
    const shapeInfo = (0, $lkN62).segment_util.collectGatherOpShapeInfo(x, indices, parsedAxis, batchDims);
    const indicesSize = (0, $wx9lK).sizeFromShape(indices.shape);
    const toDispose = [];
    const flattenX = (0, $9gI7w.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                shapeInfo.outerSize,
                shapeInfo.dimSize,
                shapeInfo.sliceSize
            ]
        }
    });
    const flattenIndex = (0, $9gI7w.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                indicesSize / shapeInfo.batchSize
            ]
        }
    });
    toDispose.push(flattenX);
    toDispose.push(flattenIndex);
    const flattenOutputShape = [
        shapeInfo.batchSize,
        shapeInfo.outerSize,
        indicesSize / shapeInfo.batchSize,
        shapeInfo.sliceSize
    ];
    if (backend.shouldExecuteOnCPU([
        x,
        indices
    ]) || x.dtype === 'string') {
        const indicesBuf = backend.bufferSync(flattenIndex);
        const xBuf = backend.bufferSync(flattenX);
        const outBuf = (0, $fIVdF.gatherV2ImplCPU)(xBuf, indicesBuf, flattenOutputShape);
        toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
        return backend.makeTensorInfo(shapeInfo.outputShape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $5b1L2.GatherProgram)(flattenX.shape, flattenOutputShape);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndex
    ], flattenX.dtype);
    toDispose.push(res);
    const reshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: shapeInfo.outputShape
        }
    });
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return reshaped;
}
const $62ec0ae1bae9f45b$export$b1bd3139c91d8765 = {
    kernelName: (0, $dCP8m.GatherV2),
    backendName: 'webgl',
    kernelFunc: $62ec0ae1bae9f45b$export$3d75b4295ded9925
};

});
parcelRegister("5b1L2", function(module, exports) {

$parcel$export(module.exports, "GatherProgram", () => $3c4f57db76469b98$export$e8921930334c8ed5);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7svrP = parcelRequire("7svrP");
class $3c4f57db76469b98$export$e8921930334c8ed5 {
    constructor(aShape, outputShape){
        this.variableNames = [
            'A',
            'indices'
        ];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        const dtype = (0, $7svrP.getCoordsDataType)(this.rank);
        const sourceCoords = $3c4f57db76469b98$var$getSourceCoords(aShape, 2);
        this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        int index = int(getIndices(resRC.x, resRC.z));
        float inBounds = (index >= 0) && (index < ${aShape[2]}) ? 1.0 : 0.0;
        setOutput(inBounds * getA(${sourceCoords}));
      }
    `;
    }
}
// The input and output are always flattened into rank 4 tensors.
function $3c4f57db76469b98$var$getSourceCoords(aShape, axis) {
    const currentCoords = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w'
    ];
    const sourceCoords = [];
    for(let i = 0; i < aShape.length; i++)if (i === 2) sourceCoords.push('index');
    else sourceCoords.push(`${currentCoords[i]}`);
    return sourceCoords.join();
}

});


parcelRegister("jaeXb", function(module, exports) {

$parcel$export(module.exports, "greaterConfig", () => $df3a8cf51113b700$export$8c4f7e92d92310f8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $df3a8cf51113b700$var$GREATER = `return float(a > b);`;
const $df3a8cf51113b700$var$GREATER_PACKED = `
  return vec4(greaterThan(a, b));
`;
const $df3a8cf51113b700$export$9dca161faaf6308b = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $df3a8cf51113b700$var$GREATER,
    packedOpSnippet: $df3a8cf51113b700$var$GREATER_PACKED,
    cpuKernelImpl: (0, $fIVdF.greaterImplCPU),
    dtype: 'bool'
});
const $df3a8cf51113b700$export$8c4f7e92d92310f8 = {
    kernelName: (0, $dCP8m.Greater),
    backendName: 'webgl',
    kernelFunc: $df3a8cf51113b700$export$9dca161faaf6308b
};

});

parcelRegister("h0dxl", function(module, exports) {

$parcel$export(module.exports, "greaterEqualConfig", () => $c60cefe3f23ec407$export$7a6926f9fcac24ca);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $c60cefe3f23ec407$var$GREATER_EQUAL = `return float(a >= b);`;
const $c60cefe3f23ec407$var$GREATER_EQUAL_PACKED = `
  return vec4(greaterThanEqual(a, b));
`;
const $c60cefe3f23ec407$export$c2fd4164cadc1fa2 = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $c60cefe3f23ec407$var$GREATER_EQUAL,
    packedOpSnippet: $c60cefe3f23ec407$var$GREATER_EQUAL_PACKED,
    dtype: 'bool',
    cpuKernelImpl: (0, $fIVdF.greaterEqualImplCPU)
});
const $c60cefe3f23ec407$export$7a6926f9fcac24ca = {
    kernelName: (0, $dCP8m.GreaterEqual),
    backendName: 'webgl',
    kernelFunc: $c60cefe3f23ec407$export$c2fd4164cadc1fa2
};

});

parcelRegister("1F6W7", function(module, exports) {

$parcel$export(module.exports, "ifftConfig", () => $135f003367969354$export$dc267425bf21b465);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $ghrrK = parcelRequire("ghrrK");
function $135f003367969354$export$776649b0bf8ce1fd(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    return (0, $ghrrK.fftImpl)(input, true, backend);
}
const $135f003367969354$export$dc267425bf21b465 = {
    kernelName: (0, $dCP8m.IFFT),
    backendName: 'webgl',
    kernelFunc: $135f003367969354$export$776649b0bf8ce1fd
};

});

parcelRegister("gppXN", function(module, exports) {

$parcel$export(module.exports, "isFiniteConfig", () => $bf231ef4bbc6e94c$export$4d45c8f7b9ffdaf1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $bf231ef4bbc6e94c$var$IS_FINITE = `return float(!isnan(x) && !isinf(x));`;
const $bf231ef4bbc6e94c$export$65f0b13f2f82375a = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $bf231ef4bbc6e94c$var$IS_FINITE,
    dtype: 'bool'
});
const $bf231ef4bbc6e94c$export$4d45c8f7b9ffdaf1 = {
    kernelName: (0, $dCP8m.IsFinite),
    backendName: 'webgl',
    kernelFunc: $bf231ef4bbc6e94c$export$65f0b13f2f82375a
};

});

parcelRegister("fuljV", function(module, exports) {

$parcel$export(module.exports, "isInfConfig", () => $b46a3228af688bb0$export$bc383b82282e9b5a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $b46a3228af688bb0$var$IS_INF = `return float(isinf(x));`;
const $b46a3228af688bb0$export$e5d3415c656f7096 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $b46a3228af688bb0$var$IS_INF,
    dtype: 'bool'
});
const $b46a3228af688bb0$export$bc383b82282e9b5a = {
    kernelName: (0, $dCP8m.IsInf),
    backendName: 'webgl',
    kernelFunc: $b46a3228af688bb0$export$e5d3415c656f7096
};

});

parcelRegister("ksGNf", function(module, exports) {

$parcel$export(module.exports, "isNaNConfig", () => $ee579e0c1e50c8ea$export$d58ff790c765c1f0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $ee579e0c1e50c8ea$var$IS_NAN = `return float(isnan(x));`;
const $ee579e0c1e50c8ea$export$c9f5652083b8129d = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $ee579e0c1e50c8ea$var$IS_NAN,
    dtype: 'bool'
});
const $ee579e0c1e50c8ea$export$d58ff790c765c1f0 = {
    kernelName: (0, $dCP8m.IsNan),
    backendName: 'webgl',
    kernelFunc: $ee579e0c1e50c8ea$export$c9f5652083b8129d
};

});

parcelRegister("lNGGi", function(module, exports) {

$parcel$export(module.exports, "lessConfig", () => $fdef4827ed557c9a$export$8d4530ce8b6ffc3c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $fdef4827ed557c9a$var$LESS = `return float(a < b);`;
const $fdef4827ed557c9a$var$LESS_PACKED = `
  return vec4(lessThan(a, b));
`;
const $fdef4827ed557c9a$export$bb1a638da8ad190f = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $fdef4827ed557c9a$var$LESS,
    packedOpSnippet: $fdef4827ed557c9a$var$LESS_PACKED,
    cpuKernelImpl: (0, $fIVdF.lessImplCPU),
    dtype: 'bool'
});
const $fdef4827ed557c9a$export$8d4530ce8b6ffc3c = {
    kernelName: (0, $dCP8m.Less),
    backendName: 'webgl',
    kernelFunc: $fdef4827ed557c9a$export$bb1a638da8ad190f
};

});

parcelRegister("aRtJv", function(module, exports) {

$parcel$export(module.exports, "lessEqualConfig", () => $7e85eaf3f9075162$export$9f26bd257393dd8);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $7e85eaf3f9075162$export$8342242c3b80421d = `return float(a <= b);`;
const $7e85eaf3f9075162$export$b12559c17f42d056 = `
  return vec4(lessThanEqual(a, b));
`;
const $7e85eaf3f9075162$export$c24ad19a692bb92 = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $7e85eaf3f9075162$export$8342242c3b80421d,
    packedOpSnippet: $7e85eaf3f9075162$export$b12559c17f42d056,
    cpuKernelImpl: (0, $fIVdF.lessEqualImplCPU),
    dtype: 'bool'
});
const $7e85eaf3f9075162$export$9f26bd257393dd8 = {
    kernelName: (0, $dCP8m.LessEqual),
    backendName: 'webgl',
    kernelFunc: $7e85eaf3f9075162$export$c24ad19a692bb92
};

});

parcelRegister("epJ7u", function(module, exports) {

$parcel$export(module.exports, "linSpaceConfig", () => $a7e6665ae0746f64$export$46b96f742c70959b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
function $a7e6665ae0746f64$export$865a19adce4d7a46(args) {
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, num: num } = attrs;
    // TODO: Use CPU implementation due to the precision problem in Safari.
    const outVals = (0, $fIVdF.linSpaceImplCPU)(start, stop, num);
    return backend.makeTensorInfo([
        outVals.length
    ], 'float32', outVals);
}
const $a7e6665ae0746f64$export$46b96f742c70959b = {
    kernelName: (0, $dCP8m.LinSpace),
    backendName: 'webgl',
    kernelFunc: $a7e6665ae0746f64$export$865a19adce4d7a46
};

});

parcelRegister("b9JOX", function(module, exports) {

$parcel$export(module.exports, "logConfig", () => $81f4140bde5eac64$export$a4ae1f00643ddd14);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
// Windows chrome return 0 if the input is negative value. We will specifically
// return NaN if the input is 0 to solve compatiblity issue.
const $81f4140bde5eac64$var$LOG = (0, $eWZon.CHECK_NAN_SNIPPET_UNARY) + `
  return x < 0.0 ? 0./0. : log(x);
`;
const $81f4140bde5eac64$var$LOG_PACKED = `
  vec4 result = log(x);
  bvec4 isNaN = isnan(x);
  result.r = isNaN.r ? x.r : (x.r < 0.0 ? 0./0. : result.r);
  result.g = isNaN.g ? x.g : (x.g < 0.0 ? 0./0. : result.g);
  result.b = isNaN.b ? x.b : (x.b < 0.0 ? 0./0. : result.b);
  result.a = isNaN.a ? x.a : (x.a < 0.0 ? 0./0. : result.a);
  return result;
`;
const $81f4140bde5eac64$export$bef1f36f5486a6a3 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $81f4140bde5eac64$var$LOG,
    packedOpSnippet: $81f4140bde5eac64$var$LOG_PACKED,
    cpuKernelImpl: (0, $fIVdF.logImplCPU)
});
const $81f4140bde5eac64$export$a4ae1f00643ddd14 = {
    kernelName: (0, $dCP8m.Log),
    backendName: 'webgl',
    kernelFunc: $81f4140bde5eac64$export$bef1f36f5486a6a3
};

});

parcelRegister("4eX36", function(module, exports) {

$parcel$export(module.exports, "log1pConfig", () => $31664622bc106317$export$c458b9e5ba980198);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $31664622bc106317$var$LOG1P = (0, $eWZon.CHECK_NAN_SNIPPET_UNARY) + `
  return log(1.0 + x);
`;
const $31664622bc106317$export$144dcf16adfb9698 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $31664622bc106317$var$LOG1P
});
const $31664622bc106317$export$c458b9e5ba980198 = {
    kernelName: (0, $dCP8m.Log1p),
    backendName: 'webgl',
    kernelFunc: $31664622bc106317$export$144dcf16adfb9698
};

});

parcelRegister("eqj8a", function(module, exports) {

$parcel$export(module.exports, "logicalAndConfig", () => $a802555d908239a4$export$257f1e82e69113fb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $a802555d908239a4$var$LOGICAL_AND = `return float(a >= 1.0 && b >= 1.0);`;
const $a802555d908239a4$var$LOGICAL_AND_PACKED = `
  return vec4(
    vec4(greaterThanEqual(a, vec4(1.0))) *
    vec4(greaterThanEqual(b, vec4(1.0))));
`;
const $a802555d908239a4$export$db5dd0ef9d505f = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $a802555d908239a4$var$LOGICAL_AND,
    packedOpSnippet: $a802555d908239a4$var$LOGICAL_AND_PACKED,
    dtype: 'bool'
});
const $a802555d908239a4$export$257f1e82e69113fb = {
    kernelName: (0, $dCP8m.LogicalAnd),
    backendName: 'webgl',
    kernelFunc: $a802555d908239a4$export$db5dd0ef9d505f
};

});

parcelRegister("fqfCD", function(module, exports) {

$parcel$export(module.exports, "logicalNotConfig", () => $b3a566f130d8354b$export$68e2dd0840056271);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $b3a566f130d8354b$var$LOGICAL_NOT = `return float(!(x >= 1.0));`;
const $b3a566f130d8354b$export$c836ff7b605b1617 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $b3a566f130d8354b$var$LOGICAL_NOT
});
const $b3a566f130d8354b$export$68e2dd0840056271 = {
    kernelName: (0, $dCP8m.LogicalNot),
    backendName: 'webgl',
    kernelFunc: $b3a566f130d8354b$export$c836ff7b605b1617
};

});

parcelRegister("brOEW", function(module, exports) {

$parcel$export(module.exports, "logicalOrConfig", () => $85598338da8861f9$export$ce04b6546987ef43);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $85598338da8861f9$var$LOGICAL_OR = `return float(a >= 1.0 || b >= 1.0);`;
const $85598338da8861f9$var$LOGICAL_OR_PACKED = `
  return min(
    vec4(greaterThanEqual(a, vec4(1.0))) +
    vec4(greaterThanEqual(b, vec4(1.0))),
    vec4(1.0));
`;
const $85598338da8861f9$export$e2a73975983cadd8 = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $85598338da8861f9$var$LOGICAL_OR,
    packedOpSnippet: $85598338da8861f9$var$LOGICAL_OR_PACKED,
    dtype: 'bool'
});
const $85598338da8861f9$export$ce04b6546987ef43 = {
    kernelName: (0, $dCP8m.LogicalOr),
    backendName: 'webgl',
    kernelFunc: $85598338da8861f9$export$e2a73975983cadd8
};

});

parcelRegister("lWVrs", function(module, exports) {

$parcel$export(module.exports, "LRNConfig", () => $ffab92802a55d7e2$export$6fb124d5a6994734);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");

var $bfwUI = parcelRequire("bfwUI");

var $8WHh8 = parcelRequire("8WHh8");
const $ffab92802a55d7e2$export$4e4a7896ae51c2f1 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    const program = (0, $aymVi.env)().getBool('WEBGL_PACK_NORMALIZATION') ? new (0, $8WHh8.LRNPackedProgram)(x.shape, depthRadius, bias, alpha, beta) : new (0, $bfwUI.LRNProgram)(x.shape, depthRadius, bias, alpha, beta);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
};
const $ffab92802a55d7e2$export$6fb124d5a6994734 = {
    kernelName: (0, $dCP8m.LRN),
    backendName: 'webgl',
    kernelFunc: $ffab92802a55d7e2$export$4e4a7896ae51c2f1
};

});
parcelRegister("bfwUI", function(module, exports) {

$parcel$export(module.exports, "LRNProgram", () => $830aa06ee759712c$export$2214c2ca22968528);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $830aa06ee759712c$export$2214c2ca22968528 {
    constructor(xShape, radius, bias, alpha, beta){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        const rad = radius;
        const maxD = xShape[3] - 1;
        this.outputShape = xShape;
        // optimize pow(bias + alpha * sum, -beta)
        // src: https://github.com/tensorflow/tensorflow/..
        // blob/26033a1644a9c4a5fbe3170ab2e864b6a4ccd4ca/..
        // tensorflow/core/kernels/mkl_lrn_op.cc#L320
        let powOperator;
        const basis = `float(${bias}) + float(${alpha}) * sum`;
        if (beta === 0.5) powOperator = `inversesqrt(${basis})`;
        else if (beta === 1.0) powOperator = `1.0/(${basis})`;
        else powOperator = `exp(log(${basis}) * float(-${beta}));`;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int r = coords[1];
        int c = coords[2];
        int d = coords[3];
        float x = getX(b, r, c, d);
        float sum = 0.0;
        for (int j = -${rad}; j <= ${rad}; j++) {
          int idx = d + j;
          if (idx >= 0 && idx <=  ${maxD}) {
            float z = getX(b, r, c, idx);
            sum += z * z;
          }
        }
        float val = x * ${powOperator};
        setOutput(val);
      }
    `;
    }
}

});

parcelRegister("8WHh8", function(module, exports) {

$parcel$export(module.exports, "LRNPackedProgram", () => $68354f1daad33c47$export$3942340f6b6d7fe9);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $68354f1daad33c47$export$3942340f6b6d7fe9 {
    constructor(xShape, radius, bias, alpha, beta){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        this.packedInputs = true;
        this.packedOutput = true;
        const rad = radius;
        const maxD = xShape[3] - 1;
        this.outputShape = xShape;
        // optimize pow(bias + alpha * sum, -beta)
        // src: https://github.com/tensorflow/tensorflow/..
        // blob/26033a1644a9c4a5fbe3170ab2e864b6a4ccd4ca/..
        // tensorflow/core/kernels/mkl_lrn_op.cc#L320
        let powOperator;
        const basis = `float(${bias}) + float(${alpha}) * sum`;
        if (beta === 0.5) powOperator = `inversesqrt(${basis})`;
        else if (beta === 1.0) powOperator = `1.0/(${basis})`;
        else powOperator = `exp(log(${basis}) * float(-${beta}));`;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords.x;
        int r = coords.y;
        int c = coords.z;
        int d = coords.w;

        bool hasNextCol = d < ${this.outputShape[3]};
        bool hasNextRow = c < ${this.outputShape[2]};

        vec4 sum = vec4(0.);
        vec4 xFragAtOutputCoords = getX(b, r, c, d);

        vec4 xAtOutputCoords = vec4(
          getChannel(xFragAtOutputCoords, vec2(c, d)),
          hasNextCol ?
            getChannel(xFragAtOutputCoords, vec2(c, d + 1)) : 0.0,
          hasNextRow ?
            getChannel(xFragAtOutputCoords , vec2(c + 1, d)) : 0.0,
          (hasNextRow && hasNextCol) ?
            getChannel(xFragAtOutputCoords, vec2(c + 1, d + 1)) : 0.0
        );

        int firstChannel = d - ${rad};
        vec2 cache = vec2(0.);
        if(firstChannel >= 0){
          vec4 firstChannelFrag = getX(b, r, c, firstChannel);
          cache.x = getChannel(firstChannelFrag, vec2(c, firstChannel));
            if(hasNextRow){
              cache.y = getChannel(firstChannelFrag, vec2(c + 1, firstChannel));
            }
        }

        ivec2 depth = ivec2(d, d + 1);
        for (int j = - ${rad}; j <= ${rad}; j++) {
          ivec2 idx = depth + j;
          bvec2 aboveLowerBound = greaterThanEqual(idx, ivec2(0));
          bvec2 belowUpperBound = lessThanEqual(idx, ivec2(${maxD}));

          bool depthInRange = aboveLowerBound.x && belowUpperBound.x;
          bool depthPlusOneInRange = aboveLowerBound.y && belowUpperBound.y;

          if(depthInRange || depthPlusOneInRange){
            vec4 z = vec4(0.);
            vec4 xFragAtCurrentDepth;
            z.xz = cache.xy;
            if(depthPlusOneInRange && hasNextCol){
              xFragAtCurrentDepth = idx.y != d ?
                getX(b, r, c, idx.y) : xFragAtOutputCoords;
              z.y = getChannel(xFragAtCurrentDepth, vec2(c, idx.y));
              if(hasNextRow){
                z.w = getChannel(xFragAtCurrentDepth, vec2(c + 1, idx.y));
              }
            }
            cache.xy = z.yw;
            sum += z * z;
          }
        }
        vec4 result = xAtOutputCoords * ${powOperator};
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("fWlRS", function(module, exports) {

$parcel$export(module.exports, "LRNGradConfig", () => $b9ad3c5694d3470a$export$99a62fc039d7aca0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $1NXsM = parcelRequire("1NXsM");
const $b9ad3c5694d3470a$export$c1529e4348811bb5 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, y: y, dy: dy } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    const program = new (0, $1NXsM.LRNGradProgram)(x.shape, depthRadius, bias, alpha, beta);
    return backend.runWebGLProgram(program, [
        x,
        y,
        dy
    ], x.dtype);
};
const $b9ad3c5694d3470a$export$99a62fc039d7aca0 = {
    kernelName: (0, $dCP8m.LRNGrad),
    backendName: 'webgl',
    kernelFunc: $b9ad3c5694d3470a$export$c1529e4348811bb5
};

});
parcelRegister("1NXsM", function(module, exports) {

$parcel$export(module.exports, "LRNGradProgram", () => $15087e3663cd297d$export$f121c71e68d75e);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $15087e3663cd297d$export$f121c71e68d75e {
    constructor(inputShape, depthRadius, bias, alpha, beta){
        this.variableNames = [
            'inputImage',
            'outputImage',
            'dy'
        ];
        this.outputShape = [];
        this.outputShape = inputShape;
        this.depth = inputShape[3];
        this.depthRadius = depthRadius;
        this.bias = bias;
        this.alpha = alpha;
        this.beta = beta;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int r = coords[1];
        int c = coords[2];

        float result = 0.0;
        for (int d = 0; d < ${this.depth}; ++d) {
          int depthBegin = int(max(0.0, float(d - ${depthRadius})));
          int depthEnd = int(min(float(${this.depth}),
              float(d + ${depthRadius} + 1)));

          const int MIN_DEPTH_BEGIN = 0;
          const int MAX_DEPTH_END = ${this.depth};

          float norm = 0.0;
          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {
            if (k < depthBegin){
              continue;
            }
            else if (k >= depthBegin && k < depthEnd) {
              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);
            }
            else {
              break;
            }
          }

          norm = float(${alpha}) * norm + float(${bias});

          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){
            if (k < depthBegin){
              continue;
            }
            else if (k >= depthBegin && k < depthEnd){
              float dyi = -2.0 * float(${alpha})
                * float(${beta})
                * getInputImage(b ,r ,c, k) * getOutputImage(b, r, c, d)
                / norm;
              if (k == d) {
                dyi += pow(norm, -1.0 * ${beta});
              }
              if (k == coords[3]) {
                dyi *= getDy(b, r, c, d);
                result += dyi;
              }
            }
            else {
              break;
            }
          }
      }
      setOutput(result);
      }
    `;
    }
}

});


parcelRegister("a1jCN", function(module, exports) {

$parcel$export(module.exports, "max", () => $74b9387782f7a475$export$8960430cfd85939f);
$parcel$export(module.exports, "maxConfig", () => $74b9387782f7a475$export$7d79147246e312bb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $fIVdF = parcelRequire("fIVdF");

var $cmXIc = parcelRequire("cmXIc");

var $5wAPM = parcelRequire("5wAPM");
var $fIVdF = parcelRequire("fIVdF");
function $74b9387782f7a475$export$8960430cfd85939f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { reductionIndices: reductionIndices, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $wx9lK).parseAxisParam(reductionIndices, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, xRank);
    const maxInputIsTransposed = permutedAxes != null;
    const shouldExecuteOnCPU = backend.shouldExecuteOnCPU([
        x
    ]);
    let maxInput = x;
    if (maxInputIsTransposed) {
        if (shouldExecuteOnCPU) {
            const xTexData = backend.texData.get(maxInput.dataId);
            const values = xTexData.values;
            const newShape = new Array(xRank);
            for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[permutedAxes[i]];
            const maxInputValues = (0, $fIVdF.transposeImplCPU)(values, x.shape, x.dtype, permutedAxes, newShape);
            maxInput = backend.makeTensorInfo(newShape, x.dtype);
            const maxInputData = backend.texData.get(maxInput.dataId);
            maxInputData.values = maxInputValues;
        } else maxInput = (0, $5wAPM.transposeImpl)(x, permutedAxes, backend);
        axes = (0, $lkN62).getInnerMostAxes(axes.length, xRank);
    }
    (0, $lkN62).assertAxesAreInnerMostDims('max', axes, xRank);
    const [maxOutShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes(maxInput.shape, axes);
    let outShape = maxOutShape;
    if (keepDims) // rather than reshape at the end, set the target shape here.
    outShape = (0, $lkN62).expandShapeToKeepDim(maxOutShape, origAxes);
    let out;
    if (shouldExecuteOnCPU) {
        const xTexData = backend.texData.get(maxInput.dataId);
        const values = xTexData.values;
        const outValues = (0, $fIVdF.maxImplCPU)(values, (0, $wx9lK).sizeFromShape(reduceShape), outShape, x.dtype);
        out = backend.makeTensorInfo(outShape, x.dtype);
        const outData = backend.texData.get(out.dataId);
        outData.values = outValues;
    } else out = (0, $cmXIc.maxImpl)(maxInput, reduceShape, outShape, backend);
    if (maxInputIsTransposed) backend.disposeIntermediateTensorInfo(maxInput);
    return out;
}
const $74b9387782f7a475$export$7d79147246e312bb = {
    kernelName: (0, $dCP8m.Max),
    backendName: 'webgl',
    kernelFunc: $74b9387782f7a475$export$8960430cfd85939f
};

});
parcelRegister("cmXIc", function(module, exports) {

$parcel$export(module.exports, "maxImpl", () => $9015dbaa4fa7e72a$export$23c9b99bdac85be0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $cojUQ = parcelRequire("cojUQ");

var $9gI7w = parcelRequire("9gI7w");
function $9015dbaa4fa7e72a$export$23c9b99bdac85be0(x, reduceShape, outShape, backend) {
    const inSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const xSize = (0, $wx9lK).sizeFromShape(x.shape);
    const batchSize = xSize / inSize;
    const reshapedInput = (0, $9gI7w.reshape)({
        inputs: {
            x: x
        },
        attrs: {
            shape: [
                batchSize,
                inSize
            ]
        },
        backend: backend
    });
    const reduced = (0, $cojUQ.reduce)(reshapedInput, x.dtype, 'max', backend);
    const reshapedOutput = (0, $9gI7w.reshape)({
        inputs: {
            x: reduced
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(reshapedInput);
    backend.disposeIntermediateTensorInfo(reduced);
    return reshapedOutput;
}

});


parcelRegister("cv7S0", function(module, exports) {

$parcel$export(module.exports, "maximumConfig", () => $919e7c2153546cf0$export$45b97bdc342e72a2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $Ngeff = parcelRequire("Ngeff");

var $bMo9e = parcelRequire("bMo9e");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $919e7c2153546cf0$var$MAXIMUM = (0, $Ngeff.CHECK_NAN_SNIPPET) + `
  return max(a, b);
`;
const $919e7c2153546cf0$var$MAXIMUM_PACKED = `
  vec4 result = vec4(max(a, b));
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + (0, $bMo9e.CHECK_NAN_SNIPPET_PACKED) + `
  return result;
`;
const $919e7c2153546cf0$export$b25e0be55f42c9a = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $919e7c2153546cf0$var$MAXIMUM,
    packedOpSnippet: $919e7c2153546cf0$var$MAXIMUM_PACKED,
    cpuKernelImpl: (0, $fIVdF.maximumImplCPU)
});
const $919e7c2153546cf0$export$45b97bdc342e72a2 = {
    kernelName: (0, $dCP8m.Maximum),
    backendName: 'webgl',
    kernelFunc: $919e7c2153546cf0$export$b25e0be55f42c9a
};

});

parcelRegister("jG0Fa", function(module, exports) {

$parcel$export(module.exports, "maxPoolConfig", () => $e532743d8f6d6ada$export$45c8263b38f19e33);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $9LJEi = parcelRequire("9LJEi");

var $4rulI = parcelRequire("4rulI");

var $fAHbJ = parcelRequire("fAHbJ");
function $e532743d8f6d6ada$export$e4aadcf115842782(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $4rulI.assertNotComplex)(x, 'maxPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $wx9lK).assert((0, $lkN62).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $lkN62).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $wx9lK).arraysEqual(convInfo.inShape, convInfo.outShape)) return (0, $fAHbJ.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const maxPoolProgram = new (0, $9LJEi.Pool2DProgram)(convInfo, 'max', false);
    return backend.runWebGLProgram(maxPoolProgram, [
        x
    ], x.dtype);
}
const $e532743d8f6d6ada$export$45c8263b38f19e33 = {
    kernelName: (0, $dCP8m.MaxPool),
    backendName: 'webgl',
    kernelFunc: $e532743d8f6d6ada$export$e4aadcf115842782
};

});

parcelRegister("hLK7Y", function(module, exports) {

$parcel$export(module.exports, "maxPool3DConfig", () => $cefa9b7212cd00f5$export$91a8fc5da39ec855);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $9LJEi = parcelRequire("9LJEi");
function $cefa9b7212cd00f5$export$822a6e53be1125f9(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $lkN62).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
    const maxPoolProgram = new (0, $9LJEi.Pool3DProgram)(convInfo, 'max', false);
    return backend.runWebGLProgram(maxPoolProgram, [
        x
    ], x.dtype);
}
const $cefa9b7212cd00f5$export$91a8fc5da39ec855 = {
    kernelName: (0, $dCP8m.MaxPool3D),
    backendName: 'webgl',
    kernelFunc: $cefa9b7212cd00f5$export$822a6e53be1125f9
};

});

parcelRegister("cBf2m", function(module, exports) {

$parcel$export(module.exports, "maxPool3DGradConfig", () => $92c49ac9eb38d6ab$export$5201426bb10bd5eb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $azKYs = parcelRequire("azKYs");

var $9LJEi = parcelRequire("9LJEi");
function $92c49ac9eb38d6ab$export$e68b9bef571dd4ea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $lkN62).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    const maxPool3dPositionsProgram = new (0, $9LJEi.Pool3DProgram)(convInfo, 'max', true);
    const maxPool3dPositions = backend.runWebGLProgram(maxPool3dPositionsProgram, [
        x
    ], x.dtype);
    const maxPoolBackpropProgram = new (0, $azKYs.MaxPool3DBackpropProgram)(convInfo);
    const result = backend.runWebGLProgram(maxPoolBackpropProgram, [
        dy,
        maxPool3dPositions
    ], x.dtype);
    backend.disposeIntermediateTensorInfo(maxPool3dPositions);
    return result;
}
const $92c49ac9eb38d6ab$export$5201426bb10bd5eb = {
    kernelName: (0, $dCP8m.MaxPool3DGrad),
    backendName: 'webgl',
    kernelFunc: $92c49ac9eb38d6ab$export$e68b9bef571dd4ea
};

});
parcelRegister("azKYs", function(module, exports) {

$parcel$export(module.exports, "MaxPool2DBackpropProgram", () => $7b319c5c5a2d07bc$export$ab6144ed51884dd);
$parcel$export(module.exports, "MaxPool3DBackpropProgram", () => $7b319c5c5a2d07bc$export$ae61ae287bf9d719);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $7b319c5c5a2d07bc$export$ab6144ed51884dd {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'maxPos'
        ];
        this.outputShape = convInfo.inShape;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const lastIndex = effectiveFilterHeight * effectiveFilterWidth - 1;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];

        ivec2 dyRCCorner = coords.yz - pads;
        int dyRCorner = dyRCCorner.x;
        int dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${effectiveFilterHeight};
          wR += ${dilationHeight}) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          for (int wC = 0; wC < ${effectiveFilterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            float dyValue = getDy(b, idyR, idyC, d);
            int maxPosValue = ${lastIndex} - int(getMaxPos(b, idyR, idyC, d));

            // Get the current value, check it against the value from the
            // position matrix.
            int curPosValue = wR * ${effectiveFilterWidth} + wC;
            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);

            dotProd += dyValue * mask;
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $7b319c5c5a2d07bc$export$ae61ae287bf9d719 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'maxPos'
        ];
        this.outputShape = convInfo.inShape;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterDepth = convInfo.effectiveFilterDepth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const lastIndex = effectiveFilterDepth * effectiveFilterHeight * effectiveFilterWidth - 1;
        this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyDCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, ch) with pos mask(:, :, :, d) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
           wD += ${dilationDepth}) {
          float dyD = float(dyDCorner + wD) / ${strideDepth}.0;

          if (dyD < 0.0 || dyD >= ${convInfo.outDepth}.0 || fract(dyD) > 0.0) {
            continue;
          }
          int idyD = int(dyD);

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
                fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              float dyValue = getDy(batch, idyD, idyR, idyC, ch);
              int maxPosValue = ${lastIndex} -
                  int(getMaxPos(batch, idyD, idyR, idyC, ch));

              // Get the current value, check it against the value from the
              // position matrix.
              int curPosValue =
                  wD * ${effectiveFilterHeight} * ${effectiveFilterWidth} +
                  wR * ${effectiveFilterWidth} + wC;
              float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);

              dotProd += dyValue * mask;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}

});


parcelRegister("besyT", function(module, exports) {

$parcel$export(module.exports, "maxPoolGradConfig", () => $82d7284f2432d3ca$export$e01a7f8dbee29127);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $azKYs = parcelRequire("azKYs");

var $9LJEi = parcelRequire("9LJEi");

var $4rulI = parcelRequire("4rulI");
function $82d7284f2432d3ca$export$85dfd1121f049514(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input, output: output } = inputs;
    const x = input;
    (0, $4rulI.assertNotComplex)([
        input,
        output
    ], 'maxPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const convInfo = (0, $lkN62).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const getPositions = true;
    const maxPoolPositionsProgram = new (0, $9LJEi.Pool2DProgram)(convInfo, 'max', getPositions);
    const maxPoolPositions = backend.runWebGLProgram(maxPoolPositionsProgram, [
        x
    ], x.dtype);
    const maxPoolBackPropProgram = new (0, $azKYs.MaxPool2DBackpropProgram)(convInfo);
    const result = backend.runWebGLProgram(maxPoolBackPropProgram, [
        dy,
        maxPoolPositions
    ], x.dtype);
    backend.disposeIntermediateTensorInfo(maxPoolPositions);
    return result;
}
const $82d7284f2432d3ca$export$e01a7f8dbee29127 = {
    kernelName: (0, $dCP8m.MaxPoolGrad),
    backendName: 'webgl',
    kernelFunc: $82d7284f2432d3ca$export$85dfd1121f049514
};

});

parcelRegister("eBDOT", function(module, exports) {

$parcel$export(module.exports, "maxPoolWithArgmaxConfig", () => $aa2368c87be3124b$export$a069ee2247a7d1ce);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $9QqXY = parcelRequire("9QqXY");
const $aa2368c87be3124b$export$a069ee2247a7d1ce = {
    kernelName: (0, $dCP8m.MaxPoolWithArgmax),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { filterSize: filterSize, strides: strides, pad: pad, includeBatchInIndex: includeBatchInIndex } = attrs;
        const webglBackend = backend;
        (0, $wx9lK).assert(x.shape.length === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${x.shape.length}.`);
        const dilations = [
            1,
            1
        ];
        (0, $wx9lK).assert((0, $lkN62).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
        const convInfo = (0, $lkN62).computePool2DInfo(x.shape, filterSize, strides, dilations, pad);
        const [result, indexes] = (0, $9QqXY.maxPoolWithArgmaxImpl)(x, includeBatchInIndex, convInfo, webglBackend);
        return [
            result,
            indexes
        ];
    }
};

});
parcelRegister("9QqXY", function(module, exports) {

$parcel$export(module.exports, "maxPoolWithArgmaxImpl", () => $72ade35b946855e1$export$3cc34964a47e7a3f);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9LJEi = parcelRequire("9LJEi");
function $72ade35b946855e1$export$3cc34964a47e7a3f(x, includeBatchInIndex, convInfo, backend) {
    let program = new (0, $9LJEi.Pool2DProgram)(convInfo, 'max', false);
    const poolOutput = backend.runWebGLProgram(program, [
        x
    ], 'float32');
    program = new (0, $9LJEi.Pool2DProgram)(convInfo, 'max', true, true, includeBatchInIndex);
    const indexOutput = backend.runWebGLProgram(program, [
        x
    ], 'float32');
    return [
        poolOutput,
        indexOutput
    ];
}

});


parcelRegister("2JGHe", function(module, exports) {

$parcel$export(module.exports, "meanConfig", () => $1fe0e756ef5f46ce$export$b934af0ccd0cdbe1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $d13Me = parcelRequire("d13Me");

var $5wAPM = parcelRequire("5wAPM");
var $fIVdF = parcelRequire("fIVdF");
const $1fe0e756ef5f46ce$export$b934af0ccd0cdbe1 = {
    kernelName: (0, $dCP8m.Mean),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { keepDims: keepDims, axis: axis } = attrs;
        const webglBackend = backend;
        const xRank = x.shape.length;
        const origAxes = (0, $wx9lK).parseAxisParam(axis, x.shape);
        let axes = origAxes;
        const permutedAxes = (0, $lkN62).getAxesPermutation(axes, xRank);
        const meanInputIsTransposed = permutedAxes != null;
        const shouldExecuteOnCPU = webglBackend.shouldExecuteOnCPU([
            x
        ]);
        const intermediates = [];
        let meanInput = x;
        if (meanInputIsTransposed) {
            if (shouldExecuteOnCPU) {
                const xTexData = webglBackend.texData.get(meanInput.dataId);
                const values = xTexData.values;
                const newShape = new Array(xRank);
                for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[permutedAxes[i]];
                const meanInputValues = (0, $fIVdF.transposeImplCPU)(values, x.shape, x.dtype, permutedAxes, newShape);
                meanInput = webglBackend.makeTensorInfo(newShape, x.dtype);
                const meanInputData = webglBackend.texData.get(meanInput.dataId);
                meanInputData.values = meanInputValues;
            } else meanInput = (0, $5wAPM.transposeImpl)(x, permutedAxes, webglBackend);
            intermediates.push(meanInput);
            axes = (0, $lkN62).getInnerMostAxes(axes.length, xRank);
        }
        (0, $lkN62).assertAxesAreInnerMostDims('sum', axes, xRank);
        const [meanOutShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes(meanInput.shape, axes);
        let outShape = meanOutShape;
        if (keepDims) // rather than reshape at the end, set the target shape here.
        outShape = (0, $lkN62).expandShapeToKeepDim(meanOutShape, origAxes);
        const out = (0, $d13Me.meanImpl)(meanInput, reduceShape, outShape, webglBackend);
        for (const i of intermediates)webglBackend.disposeIntermediateTensorInfo(i);
        return out;
    }
};

});
parcelRegister("d13Me", function(module, exports) {

$parcel$export(module.exports, "meanImpl", () => $979e4c621dc275d1$export$320c6ab5e6e7bcef);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $wx9lK = parcelRequire("wx9lK");

var $cojUQ = parcelRequire("cojUQ");

var $9gI7w = parcelRequire("9gI7w");
function $979e4c621dc275d1$export$320c6ab5e6e7bcef(x, reduceShape, outShape, backend) {
    const inSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const xSize = (0, $wx9lK).sizeFromShape(x.shape);
    const batchSize = xSize / inSize;
    const reshapedInput = (0, $9gI7w.reshape)({
        inputs: {
            x: x
        },
        attrs: {
            shape: [
                batchSize,
                inSize
            ]
        },
        backend: backend
    });
    const reduced = (0, $cojUQ.reduce)(reshapedInput, 'float32', 'mean', backend);
    const reshapedOutput = (0, $9gI7w.reshape)({
        inputs: {
            x: reduced
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(reshapedInput);
    backend.disposeIntermediateTensorInfo(reduced);
    return reshapedOutput;
}

});


parcelRegister("9OOuP", function(module, exports) {

$parcel$export(module.exports, "minConfig", () => $725ff40e4473b289$export$3cd9f9a31b38cf18);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $cojUQ = parcelRequire("cojUQ");

var $9gI7w = parcelRequire("9gI7w");

var $lHu0m = parcelRequire("lHu0m");
function $725ff40e4473b289$export$96ec731ed4dcb222(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $lHu0m.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $lkN62).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $lkN62).assertAxesAreInnerMostDims('min', axes, xRank);
    const [outShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = (0, $wx9lK).sizeFromShape(reduceShape);
    const a2D = (0, $9gI7w.reshape)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    const reduced = (0, $cojUQ.reduce)(a2D, a2D.dtype, 'min', backend);
    let res;
    if (keepDims) {
        const newShape = (0, $lkN62).expandShapeToKeepDim(outShape, origAxes);
        res = (0, $9gI7w.reshape)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    } else res = (0, $9gI7w.reshape)({
        inputs: {
            x: reduced
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(a2D);
    backend.disposeIntermediateTensorInfo(reduced);
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo(permutedX);
    return res;
}
const $725ff40e4473b289$export$3cd9f9a31b38cf18 = {
    kernelName: (0, $dCP8m.Min),
    backendName: 'webgl',
    kernelFunc: $725ff40e4473b289$export$96ec731ed4dcb222
};

});

parcelRegister("f1ibJ", function(module, exports) {

$parcel$export(module.exports, "minimumConfig", () => $aef50ecd03e48362$export$ea24ffbbbce8d546);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $Ngeff = parcelRequire("Ngeff");

var $bMo9e = parcelRequire("bMo9e");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $aef50ecd03e48362$var$MINIMUM = (0, $Ngeff.CHECK_NAN_SNIPPET) + `
  return min(a, b);
`;
const $aef50ecd03e48362$var$MINIMUM_PACKED = `
  vec4 result = vec4(min(a, b));
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + (0, $bMo9e.CHECK_NAN_SNIPPET_PACKED) + `
  return result;
`;
const $aef50ecd03e48362$export$916782c1f0ddb132 = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $aef50ecd03e48362$var$MINIMUM,
    packedOpSnippet: $aef50ecd03e48362$var$MINIMUM_PACKED,
    cpuKernelImpl: (0, $fIVdF.minimumImplCPU)
});
const $aef50ecd03e48362$export$ea24ffbbbce8d546 = {
    kernelName: (0, $dCP8m.Minimum),
    backendName: 'webgl',
    kernelFunc: $aef50ecd03e48362$export$916782c1f0ddb132
};

});

parcelRegister("6HGp5", function(module, exports) {

$parcel$export(module.exports, "mirrorPadConfig", () => $4e17a6b2307c2bd0$export$2cfd6c6c7daeb5fc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");

var $dImao = parcelRequire("dImao");

var $6hZDu = parcelRequire("6hZDu");
const $4e17a6b2307c2bd0$export$cd4ff5cd9b95abe8 = ({ inputs: inputs, backend: backend, attrs: attrs })=>{
    const { x: x } = inputs;
    const { paddings: paddings, mode: mode } = attrs;
    const program = (0, $aymVi.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $6hZDu.MirrorPadPackedProgram)(x.shape, paddings, mode) : new (0, $dImao.MirrorPadProgram)(x.shape, paddings, mode);
    const output = backend.runWebGLProgram(program, [
        x
    ], x.dtype);
    return output;
};
const $4e17a6b2307c2bd0$export$2cfd6c6c7daeb5fc = {
    kernelName: (0, $dCP8m.MirrorPad),
    backendName: 'webgl',
    kernelFunc: $4e17a6b2307c2bd0$export$cd4ff5cd9b95abe8
};

});
parcelRegister("dImao", function(module, exports) {

$parcel$export(module.exports, "MirrorPadProgram", () => $9fc094456a3457e7$export$284b676bb83fc2a7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7svrP = parcelRequire("7svrP");
class $9fc094456a3457e7$export$284b676bb83fc2a7 {
    constructor(xShape, paddings, mode){
        this.variableNames = [
            'x'
        ];
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const dtype = (0, $7svrP.getCoordsDataType)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const unpackedCoords = [
            'coords[0]',
            'coords[1]',
            'coords[2]',
            'coords[3]'
        ].slice(0, rank);
        const offset = mode === 'reflect' ? 0 : 1;
        if (rank === 1) {
            this.userCode = `
        int start = ${start};
        int end = ${end};

        void main() {
          int outC = getOutputCoords();
          if (outC < start) {
            outC = start * 2 - outC - ${offset};
          } else if(outC >= end) {
            outC = (end - 1) * 2 - outC + ${offset};
          }
          setOutput(getX(outC - start));
        }
      `;
            return;
        }
        this.userCode = `
      ${dtype} start = ${dtype}(${start});
      ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outC = getOutputCoords();
        for (int i = 0; i < ${rank}; i++) {
          if (outC[i] < start[i]) {
            outC[i] = start[i] * 2 - outC[i] - ${offset};
          } else if(outC[i] >= end[i]) {
            outC[i] = (end[i] - 1) * 2 - outC[i] + ${offset};
          }
        }
        ${dtype} coords = outC - start;
        setOutput(getX(${unpackedCoords}));
      }
    `;
    }
}

});

parcelRegister("6hZDu", function(module, exports) {

$parcel$export(module.exports, "MirrorPadPackedProgram", () => $494424329844b211$export$8b179cde16652b52);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $2351m = parcelRequire("2351m");

var $7svrP = parcelRequire("7svrP");
class $494424329844b211$export$8b179cde16652b52 {
    constructor(xShape, paddings, mode){
        this.variableNames = [
            'x'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const dtype = (0, $7svrP.getCoordsDataType)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const coords = (0, $2351m.getChannels)('rc', rank);
        const source = (0, $2351m.getChannels)('source', rank);
        const cLimit = `${coords[rank - 1]} < ${this.outputShape[rank - 1]}`;
        const innerDims = rank === 1 ? 'source' : `vec2(${source.slice(-2).join()})`;
        const offset = mode === 'reflect' ? 0 : 1;
        let mainLoop = '';
        if (rank === 1) {
            const padSetup = `
        ${dtype} source = rc;
        if (source < start) {
          source = start * 2 - source - ${offset};
        } else if (source >= end) {
          source = (end - 1) * 2 - source + ${offset};
        }
        source -= start;
      `;
            mainLoop = `
        ${dtype} rc = outputLoc;
        ${padSetup}
        result[0] = getChannel(getX(${source.join()}), ${innerDims});
        ${coords[rank - 1]} += 1;
        if(${cLimit}) {
          ${padSetup}
          result[1] = getChannel(getX(${source.join()}), ${innerDims});
        }
      `;
        } else {
            const padSetup = `
        ${dtype} source = rc;
        ${dtype} lt = ${dtype}(lessThan(source, start));
        ${dtype} gte = ${dtype}(greaterThanEqual(source, end));
        ${dtype} orig = 1 - (lt + gte);
        source = orig * source +
                lt * (start * 2 - source - ${offset}) +
                gte * ((end - 1) * 2 - source + ${offset});
        source -= start;
      `;
            mainLoop = `
        ${dtype} rc = outputLoc;
        ${padSetup}
        result[0] = getChannel(getX(${source.join()}), ${innerDims});
        ${coords[rank - 1]} += 1;
        if(${cLimit}) {
          ${padSetup}
          result[1] = getChannel(getX(${source.join()}), ${innerDims});
        }
        rc = outputLoc;
        ${coords[rank - 2]} += 1;
        if(${coords[rank - 2]} < ${this.outputShape[rank - 2]}) {
          ${padSetup}
          result[2] = getChannel(getX(${source.join()}), ${innerDims});
          ${coords[rank - 1]} += 1;
          if(${cLimit}) {
            ${padSetup}
            result[3] = getChannel(getX(${source.join()}), ${innerDims});
          }
        }
      `;
        }
        this.userCode = `
      const ${dtype} start = ${dtype}(${start});
      const ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outputLoc = getOutputCoords();
        vec4 result = vec4(0.);
        ${mainLoop}
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("6KFwE", function(module, exports) {

$parcel$export(module.exports, "modConfig", () => $4ea74010c88c5495$export$9037685a81180a9c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $bMo9e = parcelRequire("bMo9e");

var $eWZon = parcelRequire("eWZon");
const $4ea74010c88c5495$var$MOD = `if (b == 0.0) return NAN;
  return mod(a, b);`;
const $4ea74010c88c5495$var$MOD_PACKED = `
  vec4 result = mod(a, b);
  bvec4 isNaN = equal(b, vec4(0.0));
  ` + (0, $bMo9e.CHECK_NAN_SNIPPET_PACKED) + `
  return result;
`;
const $4ea74010c88c5495$export$842a2cf37af977e1 = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $4ea74010c88c5495$var$MOD,
    packedOpSnippet: $4ea74010c88c5495$var$MOD_PACKED
});
const $4ea74010c88c5495$export$9037685a81180a9c = {
    kernelName: (0, $dCP8m.Mod),
    backendName: 'webgl',
    kernelFunc: $4ea74010c88c5495$export$842a2cf37af977e1
};

});

parcelRegister("zu6y2", function(module, exports) {

$parcel$export(module.exports, "multinomialConfig", () => $06aa9f25f98e7614$export$ad960e364767f0e2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $91UlK = parcelRequire("91UlK");

var $jd3Mu = parcelRequire("jd3Mu");
function $06aa9f25f98e7614$export$f4d580f3101a1c7e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { numSamples: numSamples, seed: seed, normalized: normalized } = attrs;
    const probs = normalized ? logits : (0, $jd3Mu.softmax)({
        inputs: {
            logits: logits
        },
        backend: backend,
        attrs: {
            dim: logits.shape.length - 1
        }
    });
    const batchSize = probs.shape[0];
    const numOutcomes = probs.shape[1];
    const program = new (0, $91UlK.MultinomialProgram)(batchSize, numOutcomes, numSamples);
    const customValues = [
        [
            seed
        ]
    ];
    const res = backend.runWebGLProgram(program, [
        probs
    ], 'int32', customValues);
    if (!normalized) backend.disposeIntermediateTensorInfo(probs);
    return res;
}
const $06aa9f25f98e7614$export$ad960e364767f0e2 = {
    kernelName: (0, $dCP8m.Multinomial),
    backendName: 'webgl',
    kernelFunc: $06aa9f25f98e7614$export$f4d580f3101a1c7e
};

});
parcelRegister("91UlK", function(module, exports) {

$parcel$export(module.exports, "MultinomialProgram", () => $692feaed3b94d98a$export$f8cda6c8ea4f2110);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $692feaed3b94d98a$export$f8cda6c8ea4f2110 {
    constructor(batchSize, numOutcomes, numSamples){
        this.variableNames = [
            'probs'
        ];
        this.customUniforms = [
            {
                name: 'seed',
                type: 'float'
            }
        ];
        this.outputShape = [
            batchSize,
            numSamples
        ];
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];

        float r = random(seed);
        float cdf = 0.0;

        for (int i = 0; i < ${numOutcomes - 1}; i++) {
          cdf += getProbs(batch, i);

          if (r < cdf) {
            setOutput(float(i));
            return;
          }
        }

        // If no other event happened, last event happened.
        setOutput(float(${numOutcomes - 1}));
      }
    `;
    }
}

});

parcelRegister("jd3Mu", function(module, exports) {

$parcel$export(module.exports, "softmax", () => $dfc22a142bb8d13a$export$e008137e76238601);
$parcel$export(module.exports, "softmaxConfig", () => $dfc22a142bb8d13a$export$c022691f23e2ee69);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $5Byii = parcelRequire("5Byii");

var $a1jCN = parcelRequire("a1jCN");

var $9JmCz = parcelRequire("9JmCz");

var $9gI7w = parcelRequire("9gI7w");

var $cxLue = parcelRequire("cxLue");

var $jS2yk = parcelRequire("jS2yk");
function $dfc22a142bb8d13a$export$e008137e76238601(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { dim: dim } = attrs;
    const axes = (0, $wx9lK).parseAxisParam([
        dim
    ], logits.shape);
    const maxLogit = (0, $a1jCN.max)({
        inputs: {
            x: logits
        },
        backend: backend,
        attrs: {
            reductionIndices: axes,
            keepDims: false
        }
    });
    const expandedShape = (0, $lkN62).expandShapeToKeepDim(maxLogit.shape, axes);
    const maxLogitsReshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: maxLogit
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const a = (0, $cxLue.sub)({
        inputs: {
            a: logits,
            b: maxLogitsReshaped
        },
        backend: backend
    });
    const b = (0, $5Byii.exp)({
        inputs: {
            x: a
        },
        backend: backend
    });
    const sumExp = (0, $jS2yk.sum)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            axis: axes,
            keepDims: false
        }
    });
    const sumExpReshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: sumExp
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const res = (0, $9JmCz.realDiv)({
        inputs: {
            a: b,
            b: sumExpReshaped
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(maxLogit);
    backend.disposeIntermediateTensorInfo(maxLogitsReshaped);
    backend.disposeIntermediateTensorInfo(a);
    backend.disposeIntermediateTensorInfo(b);
    backend.disposeIntermediateTensorInfo(sumExp);
    backend.disposeIntermediateTensorInfo(sumExpReshaped);
    return res;
}
const $dfc22a142bb8d13a$export$c022691f23e2ee69 = {
    kernelName: (0, $dCP8m.Softmax),
    backendName: 'webgl',
    kernelFunc: $dfc22a142bb8d13a$export$e008137e76238601
};

});
parcelRegister("9JmCz", function(module, exports) {

$parcel$export(module.exports, "realDiv", () => $7159dd16e5dc036c$export$f76766520aabd67);
$parcel$export(module.exports, "realDivConfig", () => $7159dd16e5dc036c$export$15c5d6176b30b9a6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
// Without the equality check div produces 0.9999 for a = b, which when
// floored can cause errors.
const $7159dd16e5dc036c$var$DIV = `
if (a == b) {
  return 1.0;
};
return a / b;`;
// We do the same as in ./binaryop_gpu, with vec4 and ivec4.
// On Linux, the vectorized implementation produces NaNs when a and b are 0.
const $7159dd16e5dc036c$var$DIV_PACKED = `
  // vec4 one = vec4(equal(a, b));
  // return one + (vec4(1.0) - one) * a / b;
  vec4 result = a / b;
  if(a.x == b.x) {
    result.x = 1.;
  }
  if(a.y == b.y) {
    result.y = 1.;
  }
  if(a.z == b.z) {
    result.z = 1.;
  }
  if(a.w == b.w) {
    result.w = 1.;
  }

  return result;
`;
const $7159dd16e5dc036c$export$f76766520aabd67 = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $7159dd16e5dc036c$var$DIV,
    packedOpSnippet: $7159dd16e5dc036c$var$DIV_PACKED,
    checkOutOfBounds: true
});
const $7159dd16e5dc036c$export$15c5d6176b30b9a6 = {
    kernelName: (0, $dCP8m.RealDiv),
    backendName: 'webgl',
    kernelFunc: $7159dd16e5dc036c$export$f76766520aabd67
};

});

parcelRegister("cxLue", function(module, exports) {

$parcel$export(module.exports, "sub", () => $921d66f9e839948d$export$f93b5905241a7cca);
$parcel$export(module.exports, "subConfig", () => $921d66f9e839948d$export$5d068476dad60c4d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $921d66f9e839948d$var$SUB = 'return a - b;';
const $921d66f9e839948d$export$f93b5905241a7cca = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $921d66f9e839948d$var$SUB,
    packedOpSnippet: $921d66f9e839948d$var$SUB,
    supportsComplex: true,
    cpuKernelImpl: (0, $fIVdF.subImplCPU)
});
const $921d66f9e839948d$export$5d068476dad60c4d = {
    kernelName: (0, $dCP8m.Sub),
    backendName: 'webgl',
    kernelFunc: $921d66f9e839948d$export$f93b5905241a7cca
};

});



parcelRegister("apetE", function(module, exports) {

$parcel$export(module.exports, "negConfig", () => $793778140195f105$export$cc7b18b8229c3db);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");

var $2sCkP = parcelRequire("2sCkP");

var $2RjWv = parcelRequire("2RjWv");
const $793778140195f105$var$NEG = (0, $2sCkP.CHECK_NAN_SNIPPET) + `
  return -x;
`;
const $793778140195f105$var$NEG_PACKED = `
  vec4 result = -x;
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
function $793778140195f105$export$d9493ff0dfa0fdd5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const xData = backend.texData.get(x.dataId);
        const [outValues, newShape] = (0, $fIVdF.negImplCPU)(xData.values, x.shape, x.dtype);
        return backend.makeTensorInfo(newShape, x.dtype, outValues);
    }
    let program;
    if ((0, $aymVi.env)().getBool('WEBGL_PACK_UNARY_OPERATIONS')) program = new (0, $2RjWv.UnaryOpPackedProgram)(x.shape, $793778140195f105$var$NEG_PACKED);
    else program = new (0, $2sCkP.UnaryOpProgram)(x.shape, $793778140195f105$var$NEG);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $793778140195f105$export$cc7b18b8229c3db = {
    kernelName: (0, $dCP8m.Neg),
    backendName: 'webgl',
    kernelFunc: $793778140195f105$export$d9493ff0dfa0fdd5
};

});

parcelRegister("hqSlq", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV3Config", () => $cb0f05161bfa99a1$export$549561cd158f260a);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $ff2I2 = parcelRequire("ff2I2");
var $dCP8m = parcelRequire("dCP8m");
const $cb0f05161bfa99a1$var$nonMaxSuppressionV3Impl = (0, $ff2I2).nonMaxSuppressionV3Impl;
function $cb0f05161bfa99a1$export$8917e4bf7f7f5d42(args) {
    (0, $lkN62).warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const { selectedIndices: selectedIndices } = $cb0f05161bfa99a1$var$nonMaxSuppressionV3Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    return backend.makeTensorInfo([
        selectedIndices.length
    ], 'int32', new Int32Array(selectedIndices));
}
const $cb0f05161bfa99a1$export$549561cd158f260a = {
    kernelName: (0, $dCP8m.NonMaxSuppressionV3),
    backendName: 'webgl',
    kernelFunc: $cb0f05161bfa99a1$export$8917e4bf7f7f5d42
};

});

parcelRegister("eTC0B", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV4Config", () => $ad83af7b4a92fbf7$export$906b8fb32c570e9d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $ff2I2 = parcelRequire("ff2I2");
var $dCP8m = parcelRequire("dCP8m");
const $ad83af7b4a92fbf7$var$nonMaxSuppressionV4Impl = (0, $ff2I2).nonMaxSuppressionV4Impl;
function $ad83af7b4a92fbf7$export$ad519bdebe8f4dcf(args) {
    (0, $lkN62).warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, padToMaxOutputSize: padToMaxOutputSize } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const { selectedIndices: selectedIndices, validOutputs: validOutputs } = $ad83af7b4a92fbf7$var$nonMaxSuppressionV4Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([], 'int32', new Int32Array([
            validOutputs
        ]))
    ];
}
const $ad83af7b4a92fbf7$export$906b8fb32c570e9d = {
    kernelName: (0, $dCP8m.NonMaxSuppressionV4),
    backendName: 'webgl',
    kernelFunc: $ad83af7b4a92fbf7$export$ad519bdebe8f4dcf
};

});

parcelRegister("87Hah", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV5Config", () => $5ea075d1af453370$export$4c00b682f309701d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $ff2I2 = parcelRequire("ff2I2");
var $dCP8m = parcelRequire("dCP8m");
const $5ea075d1af453370$var$nonMaxSuppressionV5Impl = (0, $ff2I2).nonMaxSuppressionV5Impl;
function $5ea075d1af453370$export$49e389fdbe01a534(args) {
    (0, $lkN62).warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const maxOutputSizeVal = maxOutputSize;
    const iouThresholdVal = iouThreshold;
    const scoreThresholdVal = scoreThreshold;
    const softNmsSigmaVal = softNmsSigma;
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = $5ea075d1af453370$var$nonMaxSuppressionV5Impl(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([
            selectedScores.length
        ], 'float32', new Float32Array(selectedScores))
    ];
}
const $5ea075d1af453370$export$4c00b682f309701d = {
    kernelName: (0, $dCP8m.NonMaxSuppressionV5),
    backendName: 'webgl',
    kernelFunc: $5ea075d1af453370$export$49e389fdbe01a534
};

});

parcelRegister("6eZ89", function(module, exports) {

$parcel$export(module.exports, "oneHotConfig", () => $48b37824c3dec43f$export$dde5645b472b80b2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $9Ny1n = parcelRequire("9Ny1n");

var $9gI7w = parcelRequire("9gI7w");
const $48b37824c3dec43f$export$341b5490a776d041 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices } = inputs;
    const { dtype: dtype, depth: depth, onValue: onValue, offValue: offValue } = attrs;
    const indicesSize = (0, $wx9lK).sizeFromShape(indices.shape);
    const program = new (0, $9Ny1n.OneHotProgram)(indicesSize, depth, onValue, offValue);
    const reshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                indicesSize
            ]
        }
    });
    const result = backend.runWebGLProgram(program, [
        reshaped
    ], dtype);
    backend.disposeIntermediateTensorInfo(reshaped);
    const outShape = [
        ...indices.shape,
        depth
    ];
    const out = (0, $9gI7w.reshape)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(result);
    return out;
};
const $48b37824c3dec43f$export$dde5645b472b80b2 = {
    kernelName: (0, $dCP8m.OneHot),
    backendName: 'webgl',
    kernelFunc: $48b37824c3dec43f$export$341b5490a776d041
};

});
parcelRegister("9Ny1n", function(module, exports) {

$parcel$export(module.exports, "OneHotProgram", () => $72231493b369c991$export$314e506cf5800fc5);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $72231493b369c991$export$314e506cf5800fc5 {
    constructor(numIndices, depth, onValue, offValue){
        this.variableNames = [
            'indices'
        ];
        this.outputShape = [
            numIndices,
            depth
        ];
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int index = round(getIndices(coords.x));
        setOutput(mix(float(${offValue}), float(${onValue}),
                      float(index == coords.y)));
      }
    `;
    }
}

});


parcelRegister("7QjhI", function(module, exports) {

$parcel$export(module.exports, "onesLikeConfig", () => $5b5c594d9158cdd8$export$d8d7015eb6ab37d0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $3GoRo = parcelRequire("3GoRo");

var $hOLpE = parcelRequire("hOLpE");

var $j8iVA = parcelRequire("j8iVA");

var $7H3BA = parcelRequire("7H3BA");

var $g2t6I = parcelRequire("g2t6I");
function $5b5c594d9158cdd8$export$fb6afd6214fee9e9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'string') throw new Error('onesLike is not supported under string dtype');
    else if (x.dtype === 'complex64') {
        const realPart = (0, $7H3BA.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $5b5c594d9158cdd8$export$fb6afd6214fee9e9({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $j8iVA.imag)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = (0, $g2t6I.zerosLike)({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $3GoRo.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else // TODO(cais, smilkov): Add WebGL shader for onesLike:
    //   https://github.com/tensorflow/tfjs/issues/1293
    return (0, $hOLpE.fill)({
        attrs: {
            shape: x.shape,
            dtype: x.dtype,
            value: 1
        },
        backend: backend
    });
}
const $5b5c594d9158cdd8$export$d8d7015eb6ab37d0 = {
    kernelName: (0, $dCP8m.OnesLike),
    backendName: 'webgl',
    kernelFunc: $5b5c594d9158cdd8$export$fb6afd6214fee9e9
};

});
parcelRegister("g2t6I", function(module, exports) {

$parcel$export(module.exports, "zerosLike", () => $bad3695812949dc2$export$cb1f824e7733584d);
$parcel$export(module.exports, "zerosLikeConfig", () => $bad3695812949dc2$export$15368df05c479e41);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $3GoRo = parcelRequire("3GoRo");

var $hOLpE = parcelRequire("hOLpE");

var $j8iVA = parcelRequire("j8iVA");

var $7H3BA = parcelRequire("7H3BA");
function $bad3695812949dc2$export$cb1f824e7733584d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'complex64') {
        const realPart = (0, $7H3BA.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $bad3695812949dc2$export$cb1f824e7733584d({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $j8iVA.imag)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = $bad3695812949dc2$export$cb1f824e7733584d({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $3GoRo.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else return (0, $hOLpE.fill)({
        attrs: {
            shape: x.shape,
            dtype: x.dtype,
            value: x.dtype === 'string' ? '' : 0
        },
        backend: backend
    });
}
const $bad3695812949dc2$export$15368df05c479e41 = {
    kernelName: (0, $dCP8m.ZerosLike),
    backendName: 'webgl',
    kernelFunc: $bad3695812949dc2$export$cb1f824e7733584d
};

});


parcelRegister("kNvvR", function(module, exports) {

$parcel$export(module.exports, "packConfig", () => $f240d4093338cdbd$export$1645fa8803aa1f86);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $k5Is6 = parcelRequire("k5Is6");

var $cFwC0 = parcelRequire("cFwC0");
function $f240d4093338cdbd$export$2a703dbb0cb35339(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    if (inputs.length === 1) return (0, $cFwC0.expandDims)({
        inputs: {
            input: inputs[0]
        },
        backend: backend,
        attrs: {
            dim: axis
        }
    });
    const shape = inputs[0].shape;
    const dtype = inputs[0].dtype;
    inputs.forEach((t)=>{
        (0, $wx9lK).assertShapesMatch(shape, t.shape, 'All tensors passed to stack must have matching shapes');
        (0, $wx9lK).assert(dtype === t.dtype, ()=>'All tensors passed to stack must have matching dtypes');
    });
    const intermediateTensorInfos = [];
    const expandedTensors = inputs.map((t)=>{
        const expandedT = (0, $cFwC0.expandDims)({
            inputs: {
                input: t
            },
            backend: backend,
            attrs: {
                dim: axis
            }
        });
        intermediateTensorInfos.push(expandedT);
        return expandedT;
    });
    const result = (0, $k5Is6.concat)({
        inputs: expandedTensors,
        backend: backend,
        attrs: {
            axis: axis
        }
    });
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $f240d4093338cdbd$export$1645fa8803aa1f86 = {
    kernelName: (0, $dCP8m.Pack),
    backendName: 'webgl',
    kernelFunc: $f240d4093338cdbd$export$2a703dbb0cb35339
};

});

parcelRegister("2skRq", function(module, exports) {

$parcel$export(module.exports, "padV2", () => $1c9e60cb8cf0b92e$export$f676d6ad4f38bb89);
$parcel$export(module.exports, "padV2Config", () => $1c9e60cb8cf0b92e$export$b0317e720bfd61fc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $348Dh = parcelRequire("348Dh");

var $7Cf9H = parcelRequire("7Cf9H");

var $hOLpE = parcelRequire("hOLpE");
const $1c9e60cb8cf0b92e$export$f676d6ad4f38bb89 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { paddings: paddings, constantValue: constantValue } = attrs;
    if ((0, $wx9lK).sizeFromShape(x.shape) === 0) {
        // Short-circuit the computation, since x doesn't have value, only
        // the shape is used to compute output shape to pad.
        const outputShape = paddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
        return (0, $hOLpE.fill)({
            backend: backend,
            attrs: {
                shape: outputShape,
                value: constantValue,
                dtype: x.dtype
            }
        });
    }
    const program = (0, $aymVi.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $7Cf9H.PadPackedProgram)(x.shape, paddings, constantValue) : new (0, $348Dh.PadProgram)(x.shape, paddings, constantValue);
    const customValues = [
        [
            constantValue
        ]
    ];
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype, customValues);
};
const $1c9e60cb8cf0b92e$export$b0317e720bfd61fc = {
    kernelName: (0, $dCP8m.PadV2),
    backendName: 'webgl',
    kernelFunc: $1c9e60cb8cf0b92e$export$f676d6ad4f38bb89
};

});
parcelRegister("348Dh", function(module, exports) {

$parcel$export(module.exports, "PadProgram", () => $23b87110f47178eb$export$15f19b307ce21f0a);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7svrP = parcelRequire("7svrP");
class $23b87110f47178eb$export$15f19b307ce21f0a {
    constructor(xShape, paddings, constantValue){
        this.variableNames = [
            'x'
        ];
        this.customUniforms = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const type = (0, $7svrP.getCoordsDataType)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const unpackedCoords = [
            'coords[0]',
            'coords[1]',
            'coords[2]',
            'coords[3]'
        ].slice(0, rank);
        if (rank === 1) {
            this.userCode = `
        int start = ${start};
        int end = ${end};

        void main() {
          int outC = getOutputCoords();
          if (outC < start || outC >= end) {
            setOutput(value);
          } else {
            setOutput(getX(outC - start));
          }
        }
      `;
            return;
        }
        this.userCode = `
      ${type} start = ${type}(${start});
      ${type} end = ${type}(${end});

      void main() {
        ${type} outC = getOutputCoords();
        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {
          setOutput(value);
        } else {
          ${type} coords = outC - start;
          setOutput(getX(${unpackedCoords}));
        }
      }
    `;
    }
}

});

parcelRegister("7Cf9H", function(module, exports) {

$parcel$export(module.exports, "PadPackedProgram", () => $58b7d68ce1fa1006$export$ed21e062cfba77c5);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $2351m = parcelRequire("2351m");

var $7svrP = parcelRequire("7svrP");
class $58b7d68ce1fa1006$export$ed21e062cfba77c5 {
    constructor(xShape, paddings, constantValue){
        this.variableNames = [
            'x'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const dtype = (0, $7svrP.getCoordsDataType)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const coords = (0, $2351m.getChannels)('rc', rank);
        const source = (0, $2351m.getChannels)('source', rank);
        const cLimit = `${coords[rank - 1]} < ${this.outputShape[rank - 1]}`;
        const innerDims = rank === 1 ? 'source' : `vec2(${source.slice(-2).join()})`;
        const componentSetup = [
            `${dtype} rc = outputLoc;`,
            `${coords[rank - 1]} += 1;
       if(${cLimit}) {
      `,
            rank === 1 ? '' : `}
       rc = outputLoc;
       ${coords[rank - 2]} += 1;
       if(${coords[rank - 2]} < ${this.outputShape[rank - 2]}) {`,
            rank === 1 ? '' : `  ${coords[rank - 1]} += 1;
         if(${cLimit}) {`
        ];
        const paddingArea = rank === 1 ? 'rc < start || rc >= end' : 'any(lessThan(rc, start)) || any(greaterThanEqual(rc, end))';
        let mainLoop = '';
        for(let i = 0, j = rank === 1 ? 2 : 4; i < j; i++)mainLoop += `
        ${componentSetup[i]}
        if (${paddingArea}) {
          result[${i}] = float(value);
        } else {
          ${dtype} source = rc - start;
          result[${i}] = getChannel(getX(${source.join()}), ${innerDims});
        }
      `;
        mainLoop += rank === 1 ? `} ` : `}}`;
        this.userCode = `
      const ${dtype} start = ${dtype}(${start});
      const ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outputLoc = getOutputCoords();
        vec4 result = vec4(0.);
        ${mainLoop}
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("hP3m7", function(module, exports) {

$parcel$export(module.exports, "powConfig", () => $cf99cd72fa89653f$export$b823d49786719761);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $bMo9e = parcelRequire("bMo9e");

var $eWZon = parcelRequire("eWZon");
const $cf99cd72fa89653f$var$POW = `
  if(a < 0.0 && floor(b) < b){
    return NAN;
  }
  if (b == 0.0) {
    return 1.0;
  }
  return (round(mod(b, 2.0)) != 1) ?
      pow(abs(a), b) : sign(a) * pow(abs(a), b);
`;
const $cf99cd72fa89653f$var$POW_PACKED = `
  // isModRound1 has 1 for components with round(mod(b, 2.0)) == 1, 0 otherwise.
  vec4 isModRound1 = vec4(equal(round(mod(b, 2.0)), ivec4(1)));
  vec4 multiplier = sign(a) * isModRound1 + (vec4(1.0) - isModRound1);
  vec4 result = multiplier * pow(abs(a), b);

  // Ensure that a^0 = 1, including 0^0 = 1 as this correspond to TF and JS
  bvec4 isExpZero = equal(b, vec4(0.0));
  result.r = isExpZero.r ? 1.0 : result.r;
  result.g = isExpZero.g ? 1.0 : result.g;
  result.b = isExpZero.b ? 1.0 : result.b;
  result.a = isExpZero.a ? 1.0 : result.a;

  bvec4 isNaN1 = lessThan(a, vec4(0.0));
  bvec4 isNaN2 = lessThan(floor(b), b);
  bvec4 isNaN = bvec4(isNaN1.x && isNaN2.x, isNaN1.y && isNaN2.y, isNaN1.z && isNaN2.z, isNaN1.w && isNaN2.w);
  ` + (0, $bMo9e.CHECK_NAN_SNIPPET_PACKED) + `
  return result;
`;
const $cf99cd72fa89653f$export$9c297f60e22e3389 = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $cf99cd72fa89653f$var$POW,
    packedOpSnippet: $cf99cd72fa89653f$var$POW_PACKED
});
const $cf99cd72fa89653f$export$b823d49786719761 = {
    kernelName: (0, $dCP8m.Pow),
    backendName: 'webgl',
    kernelFunc: $cf99cd72fa89653f$export$9c297f60e22e3389
};

});

parcelRegister("k3HfJ", function(module, exports) {

$parcel$export(module.exports, "prodConfig", () => $e9a5a38b6c1f9690$export$d556aa935cef5c0c);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $bnEYl = parcelRequire("bnEYl");
var $wx9lK = parcelRequire("wx9lK");

var $cojUQ = parcelRequire("cojUQ");

var $fIVdF = parcelRequire("fIVdF");

var $9gI7w = parcelRequire("9gI7w");

var $lHu0m = parcelRequire("lHu0m");
function $e9a5a38b6c1f9690$export$5e143010dea16c85(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const toDispose = [];
    const origAxes = (0, $wx9lK).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $lkN62).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $lHu0m.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $lkN62).getInnerMostAxes(axes.length, xRank);
        toDispose.push(permutedX);
    }
    (0, $lkN62).assertAxesAreInnerMostDims('prod', axes, xRank);
    let res;
    if (backend.shouldExecuteOnCPU([
        permutedX
    ])) {
        const xVals = backend.texData.get(permutedX.dataId).values;
        const { outVals: outVals, outShape: outShape, outDtype: outDtype } = (0, $fIVdF.prodImplCPU)(permutedX.shape, permutedX.dtype, xVals, axes);
        res = backend.makeTensorInfo(outShape, outDtype, outVals);
    } else {
        const [outShape, reduceShape] = (0, $lkN62).computeOutAndReduceShapes(permutedX.shape, axes);
        const inSize = (0, $wx9lK).sizeFromShape(reduceShape);
        const a2D = (0, $9gI7w.reshape)({
            inputs: {
                x: permutedX
            },
            backend: backend,
            attrs: {
                shape: [
                    -1,
                    inSize
                ]
            }
        });
        const outputDType = (0, $bnEYl.sumOutType)(x.dtype);
        const reduced = (0, $cojUQ.reduce)(a2D, outputDType, 'prod', backend);
        res = (0, $9gI7w.reshape)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        toDispose.push(a2D);
        toDispose.push(reduced);
    }
    if (keepDims) {
        toDispose.push(res);
        const newShape = (0, $lkN62).expandShapeToKeepDim(res.shape, origAxes);
        res = (0, $9gI7w.reshape)({
            inputs: {
                x: res
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    }
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return res;
}
const $e9a5a38b6c1f9690$export$d556aa935cef5c0c = {
    kernelName: (0, $dCP8m.Prod),
    backendName: 'webgl',
    kernelFunc: $e9a5a38b6c1f9690$export$5e143010dea16c85
};

});

parcelRegister("h5jLz", function(module, exports) {

$parcel$export(module.exports, "raggedGatherConfig", () => $c7023c7cc6788433$export$cebb8a7d5932c7e8);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
function $c7023c7cc6788433$export$e7118f605df251dd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { paramsNestedSplits: paramsNestedSplits, paramsDenseValues: paramsDenseValues, indices: indices } = inputs;
    const { outputRaggedRank: outputRaggedRank } = attrs;
    const $paramsNestedSplits = paramsNestedSplits.map((t)=>backend.readSync(t.dataId));
    const $paramsNestedSplitsShapes = paramsNestedSplits.map((t)=>t.shape);
    const $paramsDenseValues = backend.readSync(paramsDenseValues.dataId);
    const $indices = backend.readSync(indices.dataId);
    const [outputNestedSplits, outputDenseValues, outputDenseValuesShape] = (0, $fIVdF.raggedGatherImplCPU)($paramsNestedSplits, $paramsNestedSplitsShapes, $paramsDenseValues, paramsDenseValues.shape, paramsDenseValues.dtype, $indices, indices.shape, outputRaggedRank);
    const outputNestedSplitsTensors = outputNestedSplits.map((splits)=>backend.makeTensorInfo([
            splits.length
        ], 'int32', splits));
    const outputDenseValuesTensor = backend.makeTensorInfo(outputDenseValuesShape, paramsDenseValues.dtype, outputDenseValues);
    return outputNestedSplitsTensors.concat([
        outputDenseValuesTensor
    ]);
}
const $c7023c7cc6788433$export$cebb8a7d5932c7e8 = {
    kernelName: (0, $dCP8m.RaggedGather),
    backendName: 'webgl',
    kernelFunc: $c7023c7cc6788433$export$e7118f605df251dd
};

});

parcelRegister("gcS3b", function(module, exports) {

$parcel$export(module.exports, "raggedTensorToTensorConfig", () => $bcc7b1993447a601$export$792f441e33dcdf26);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
function $bcc7b1993447a601$export$621e390307cbbaa1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { shape: shape, values: values, defaultValue: defaultValue, rowPartitionTensors: rowPartitionTensors } = inputs;
    const { rowPartitionTypes: rowPartitionTypes } = attrs;
    const $shape = backend.readSync(shape.dataId);
    const $values = backend.readSync(values.dataId);
    const $defaultValue = backend.readSync(defaultValue.dataId);
    const $rowPartitionValues = rowPartitionTensors.map((t)=>backend.readSync(t.dataId));
    const rowPartitionValuesShapes = rowPartitionTensors.map((t)=>t.shape);
    const [outputShape, output] = (0, $fIVdF.raggedTensorToTensorImplCPU)($shape, shape.shape, $values, values.shape, values.dtype, $defaultValue, defaultValue.shape, $rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes);
    return backend.makeTensorInfo(outputShape, values.dtype, output);
}
const $bcc7b1993447a601$export$792f441e33dcdf26 = {
    kernelName: (0, $dCP8m.RaggedTensorToTensor),
    backendName: 'webgl',
    kernelFunc: $bcc7b1993447a601$export$621e390307cbbaa1
};

});

parcelRegister("hiwUp", function(module, exports) {

$parcel$export(module.exports, "range", () => $c97da51d29d0820f$export$d02631cccf789723);
$parcel$export(module.exports, "rangeConfig", () => $c97da51d29d0820f$export$361c4075706e31c2);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
const $c97da51d29d0820f$export$d02631cccf789723 = (args)=>{
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, step: step, dtype: dtype } = attrs;
    const values = (0, $fIVdF.rangeImplCPU)(start, stop, step, dtype);
    return backend.makeTensorInfo([
        values.length
    ], dtype, values);
};
const $c97da51d29d0820f$export$361c4075706e31c2 = {
    kernelName: (0, $dCP8m.Range),
    backendName: 'webgl',
    kernelFunc: $c97da51d29d0820f$export$d02631cccf789723
};

});

parcelRegister("aA9Uc", function(module, exports) {

$parcel$export(module.exports, "reciprocalConfig", () => $7b44f3313301f157$export$412a6b66203fdf72);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $7b44f3313301f157$var$RECIPROCAL = `return 1.0 / x;`;
const $7b44f3313301f157$export$163bc8c839a1ac04 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $7b44f3313301f157$var$RECIPROCAL
});
const $7b44f3313301f157$export$412a6b66203fdf72 = {
    kernelName: (0, $dCP8m.Reciprocal),
    backendName: 'webgl',
    kernelFunc: $7b44f3313301f157$export$163bc8c839a1ac04
};

});

parcelRegister("5CN1a", function(module, exports) {

$parcel$export(module.exports, "reluConfig", () => $41868648e6a94f1f$export$731f9199bde068eb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $2sCkP = parcelRequire("2sCkP");
const $41868648e6a94f1f$var$RELU = (0, $2sCkP.CHECK_NAN_SNIPPET) + `
  return (x < 0.0) ? 0.0 : x;
`;
const $41868648e6a94f1f$var$RELU_PACKED = `
  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $41868648e6a94f1f$export$16d1e4612cc0139f = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $41868648e6a94f1f$var$RELU,
    packedOpSnippet: $41868648e6a94f1f$var$RELU_PACKED
});
const $41868648e6a94f1f$export$731f9199bde068eb = {
    kernelName: (0, $dCP8m.Relu),
    backendName: 'webgl',
    kernelFunc: $41868648e6a94f1f$export$16d1e4612cc0139f
};

});

parcelRegister("8z3BW", function(module, exports) {

$parcel$export(module.exports, "relu6Config", () => $63c464a6d89dffcc$export$92c30890ad649d53);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $2sCkP = parcelRequire("2sCkP");
const $63c464a6d89dffcc$var$RELU6 = (0, $2sCkP.CHECK_NAN_SNIPPET) + `
  return (x < 0.0) ? 0.0 : min(6.0, x);
`;
const $63c464a6d89dffcc$var$RELU6_PACKED = `
  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $63c464a6d89dffcc$export$4a62bcb95e9c44c4 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $63c464a6d89dffcc$var$RELU6,
    packedOpSnippet: $63c464a6d89dffcc$var$RELU6_PACKED
});
const $63c464a6d89dffcc$export$92c30890ad649d53 = {
    kernelName: (0, $dCP8m.Relu6),
    backendName: 'webgl',
    kernelFunc: $63c464a6d89dffcc$export$4a62bcb95e9c44c4
};

});

parcelRegister("8MYqv", function(module, exports) {

$parcel$export(module.exports, "resizeBilinearConfig", () => $6661ade3bcb42220$export$a37a56137abc1357);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");

var $84kiZ = parcelRequire("84kiZ");

var $9SSR7 = parcelRequire("9SSR7");
function $6661ade3bcb42220$export$1f1cbc7da93d06a0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    const [newHeight, newWidth] = size;
    const program = (0, $aymVi.env)().getBool('WEBGL_PACK_IMAGE_OPERATIONS') ? new (0, $9SSR7.ResizeBilinearPackedProgram)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters) : new (0, $84kiZ.ResizeBilinearProgram)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters);
    return backend.runWebGLProgram(program, [
        images
    ], 'float32');
}
const $6661ade3bcb42220$export$a37a56137abc1357 = {
    kernelName: (0, $dCP8m.ResizeBilinear),
    backendName: 'webgl',
    kernelFunc: $6661ade3bcb42220$export$1f1cbc7da93d06a0
};

});
parcelRegister("84kiZ", function(module, exports) {

$parcel$export(module.exports, "ResizeBilinearProgram", () => $5dfe72a847b19fa6$export$52b2ccd78b972549);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $5dfe72a847b19fa6$export$52b2ccd78b972549 {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `(vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC` + ` - vec2(0.5)`;
        else sourceFracIndexRC = `vec2(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec2 effectiveInputOverOutputRatioRC = vec2(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec2 inputShapeRC = vec2(${oldHeight}.0, ${oldWidth}.0);

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        ivec2 yRC = coords.yz;

        // Fractional source index.
        vec2 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the four integer indices.
        ivec2 sourceFloorRC = ivec2(max(sourceFracIndexRC, vec2(0.0)));
        ivec2 sourceCeilRC = ivec2(
          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));

        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);
        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);
        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);
        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);

        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);

        float top = topLeft + (topRight - topLeft) * fracRC.y;
        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;
        float newValue = top + (bottom - top) * fracRC.x;

        setOutput(newValue);
      }
    `;
    }
}

});

parcelRegister("9SSR7", function(module, exports) {

$parcel$export(module.exports, "ResizeBilinearPackedProgram", () => $7323b563f9d1f5b6$export$b334a0f2524628a);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $7323b563f9d1f5b6$export$b334a0f2524628a {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `(vec3(yRC) + vec3(0.5)) * ` + `effectiveInputOverOutputRatioRC - vec3(0.5)`;
        else sourceFracIndexRC = `vec3(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec3 effectiveInputOverOutputRatioRC = vec3(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec3 inputShapeRC = vec3(${oldHeight}.0, ${oldWidth}.0,
                                     ${oldWidth}.0);

      float getAValue(int b, int r, int c, int d) {
        return getChannel(getA(b, r, c, d), vec2(c, d));
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        // Calculate values for next column in yRC.z.
        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);

        // Fractional source index.
        vec3 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the four integer indices.
        ivec3 sourceFloorRC = ivec3(max(sourceFracIndexRC, vec3(0.0)));
        ivec3 sourceCeilRC = ivec3(
          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));

        // Should we calculate next column and row elements in 2x2 packed cell.
        bool hasNextCol = d < ${depth - 1};
        bool hasNextRow = coords.z < ${newWidth - 1};

        // In parallel, construct four corners for all four components in
        // packed 2x2 cell.
        vec4 topLeft = vec4(
          getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d),
          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d + 1) : 0.0);

        vec4 bottomLeft = vec4(
          getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d),
          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d + 1) : 0.0);

        vec4 topRight = vec4(
          getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d),
          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d + 1) : 0.0);

        vec4 bottomRight = vec4(
          getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d),
          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d + 1) : 0.0);

        vec3 fracRC = sourceFracIndexRC - vec3(sourceFloorRC);

        vec4 top = mix(topLeft, topRight, fracRC.yyzz);
        vec4 bottom = mix(bottomLeft, bottomRight, fracRC.yyzz);
        vec4 newValue = mix(top, bottom, fracRC.x);

        setOutput(newValue);
      }
    `;
    }
}

});


parcelRegister("k7Maw", function(module, exports) {

$parcel$export(module.exports, "resizeBilinearGradConfig", () => $ea69d366676b0ee3$export$51f84ca614e84763);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $9NEuL = parcelRequire("9NEuL");
function $ea69d366676b0ee3$export$8899506794ec394(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    const program = new (0, $9NEuL.ResizeBilinearBackpropProgram)(dy.shape, images.shape, alignCorners);
    return backend.runWebGLProgram(program, [
        dy
    ], dy.dtype);
}
const $ea69d366676b0ee3$export$51f84ca614e84763 = {
    kernelName: (0, $dCP8m.ResizeBilinearGrad),
    backendName: 'webgl',
    kernelFunc: $ea69d366676b0ee3$export$8899506794ec394
};

});
parcelRegister("9NEuL", function(module, exports) {

$parcel$export(module.exports, "ResizeBilinearBackpropProgram", () => $72281a2ef386f5af$export$dd552814323a3592);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $72281a2ef386f5af$export$dd552814323a3592 {
    constructor(dyShape, inputShape, alignCorners){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = [];
        this.outputShape = inputShape;
        const [, xHeight, xWidth] = inputShape;
        const [, yHeight, yWidth] = dyShape;
        // In the backwards pass, we want to find the pixels that were generated for
        // each pixel in the input image the forward pass and add the corresponding
        // coefficient from dy to the gradient (with some interpolation).
        const effectiveXSize = [
            alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
            alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
        ];
        const effectiveYSize = [
            alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
            alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
        ];
        const heightScale = effectiveXSize[0] / effectiveYSize[0];
        const widthScale = effectiveXSize[1] / effectiveYSize[1];
        const invHeightScale = 1 / heightScale;
        const invWidthScale = 1 / widthScale;
        // This defines the size of the window of values around a particular
        // index in dy that we want to search for contributions to dx.
        const winHeight = Math.ceil(invHeightScale) * 2 + 2;
        const winWidth = Math.ceil(invWidthScale) * 2 + 2;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        int r = coords[1];
        int c = coords[2];

        float accumulator = 0.0;

        const float heightScale = float(${heightScale});
        const float widthScale = float(${widthScale});

        const float invHeightScale = float(${invHeightScale});
        const float invWidthScale = float(${invWidthScale});

        const int winHeight = int(${winHeight});
        const int winWidth = int(${winWidth});

        // Compute bounds for where in dy we will look
        float startRLerp = floor(float(r) * invHeightScale);
        int startDyR = int(startRLerp - float(winHeight / 2));

        float startCLerp = floor(float(c) * invWidthScale);
        int startDyC = int(startCLerp - float(winWidth / 2));

        // Loop over dy
        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {
          int dyR = dyROffset + startDyR;

          // Guard against the window exceeding the bounds of dy
          if (dyR < 0 || dyR >= ${yHeight}) {
            continue;
          }

          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {
            int dyC = dyCOffset + startDyC;

            // Guard against the window exceeding the bounds of dy
            if (dyC < 0 || dyC >= ${yWidth}) {
              continue;
            }

            float dxR = float(dyR) * heightScale;
            int topDxRIndex = int(floor(dxR));
            int bottomDxRIndex = int(min(ceil(dxR), ${xHeight - 1}.0));
            float dxRLerp = dxR - float(topDxRIndex);
            float inverseDxRLerp = 1.0 - dxRLerp;

            float dxC = float(dyC) * widthScale;
            int leftDxCIndex = int(floor(dxC));
            int rightDxCIndex = int(min(ceil(dxC), ${xWidth - 1}.0));
            float dxCLerp = dxC - float(leftDxCIndex);
            float inverseDxCLerp = 1.0 - dxCLerp;

            if (r == topDxRIndex && c == leftDxCIndex) {
              // topLeft
              accumulator +=
                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;
            }

            if (r == topDxRIndex && c == rightDxCIndex) {
              // topRight
              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;
            }

            if (r == bottomDxRIndex && c == leftDxCIndex) {
              // bottomLeft
              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;
            }

            if (r == bottomDxRIndex && c == rightDxCIndex) {
              // bottomRight
              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;
            }
          }
        }
        // End loop over dy

        setOutput(accumulator);
      }
    `;
    }
}

});


parcelRegister("2lU4p", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighborConfig", () => $1b69094cb7147fb8$export$2b6a92caba113b89);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");

var $f8ttj = parcelRequire("f8ttj");

var $dF8Np = parcelRequire("dF8Np");
function $1b69094cb7147fb8$export$74a902ae74ac2560(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    const [newHeight, newWidth] = size;
    const program = (0, $aymVi.env)().getBool('WEBGL_PACK_IMAGE_OPERATIONS') ? new (0, $dF8Np.ResizeNearestNeighborPackedProgram)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters) : new (0, $f8ttj.ResizeNearestNeighborProgram)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters);
    return backend.runWebGLProgram(program, [
        images
    ], images.dtype);
}
const $1b69094cb7147fb8$export$2b6a92caba113b89 = {
    kernelName: (0, $dCP8m.ResizeNearestNeighbor),
    backendName: 'webgl',
    kernelFunc: $1b69094cb7147fb8$export$74a902ae74ac2560
};

});
parcelRegister("f8ttj", function(module, exports) {

$parcel$export(module.exports, "ResizeNearestNeighborProgram", () => $b04e76d920b523f0$export$2218952be90fb74a);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $b04e76d920b523f0$export$2218952be90fb74a {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        // When align corners is false, we rounds the value with floor.
        const roundBase = alignCorners ? '0.5' : '0.0';
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `max((vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC` + `, vec2(0.0))`;
        else sourceFracIndexRC = `vec2(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec2 effectiveInputOverOutputRatioRC = vec2(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec2 inputShapeRC = vec2(${oldHeight}.0, ${oldWidth}.0);

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        ivec2 yRC = coords.yz;

        // Fractional source index.
        vec2 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the coordinators of nearest neighbor point.
        ivec2 sourceNearestRC = ivec2(
          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${roundBase})));
        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);

        setOutput(newValue);
      }
    `;
    }
}

});

parcelRegister("dF8Np", function(module, exports) {

$parcel$export(module.exports, "ResizeNearestNeighborPackedProgram", () => $9f25ed5f3cf127ef$export$a616f6d9a33abf84);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $9f25ed5f3cf127ef$export$a616f6d9a33abf84 {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        // When align corners is false, we rounds the value with floor.
        const roundBase = alignCorners ? '0.5' : '0.0';
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `max((vec3(yRC) + vec3(0.5)) * ` + `effectiveInputOverOutputRatioRC, vec3(0.0))`;
        else sourceFracIndexRC = `vec3(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec3 effectiveInputOverOutputRatioRC = vec3(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec3 inputShapeRC = vec3(${oldHeight}.0, ${oldWidth}.0,
                                     ${oldWidth}.0);

      float getAValue(int b, int r, int c, int d) {
        return getChannel(getA(b, r, c, d), vec2(c, d));
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        // Calculate values for next column in yRC.z.
        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);

        // Fractional source index.
        vec3 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the coordinators of nearest neighbor point.
        ivec3 sourceNearestRC = ivec3(
          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${roundBase})));

        // Should we calculate next column and row elements in 2x2 packed cell.
        bool hasNextCol = d < ${depth - 1};
        bool hasNextRow = coords.z < ${newWidth - 1};

        vec4 newValue = vec4(
          getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d),
          hasNextCol ? getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d + 1) : 0.0);

        setOutput(newValue);
      }
    `;
    }
}

});


parcelRegister("dO1OD", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighborGradConfig", () => $a0d15a70c8bcecf8$export$2b08d810b5090fe1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $2lByg = parcelRequire("2lByg");
function $a0d15a70c8bcecf8$export$2b75795f158f1b18(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    const program = new (0, $2lByg.ResizeNearestNeigborBackpropProgram)(dy.shape, images.shape, alignCorners);
    return backend.runWebGLProgram(program, [
        dy
    ], dy.dtype);
}
const $a0d15a70c8bcecf8$export$2b08d810b5090fe1 = {
    kernelName: (0, $dCP8m.ResizeNearestNeighborGrad),
    backendName: 'webgl',
    kernelFunc: $a0d15a70c8bcecf8$export$2b75795f158f1b18
};

});
parcelRegister("2lByg", function(module, exports) {

$parcel$export(module.exports, "ResizeNearestNeigborBackpropProgram", () => $1b5aabe951ef3cd5$export$b6671a84abe827c4);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $1b5aabe951ef3cd5$export$b6671a84abe827c4 {
    constructor(dyShape, inputShape, alignCorners){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = [];
        this.outputShape = inputShape;
        const [, xHeight, xWidth] = inputShape;
        const [, yHeight, yWidth] = dyShape;
        // In the backwards pass, we want to find the pixels that were generated for
        // each pixel in the input image the forward pass and add the corresponding
        // coefficient from dy to the gradient (with some interpolation).
        const effectiveXSize = [
            alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
            alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
        ];
        const effectiveYSize = [
            alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
            alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
        ];
        const heightScale = effectiveXSize[0] / effectiveYSize[0];
        const widthScale = effectiveXSize[1] / effectiveYSize[1];
        const invHeightScale = 1 / heightScale;
        const invWidthScale = 1 / widthScale;
        // This defines the size of the window of values around a particular
        // index in dy that we want to search for contributions to dx.
        const winHeight = Math.ceil(invHeightScale) * 2 + 2;
        const winWidth = Math.ceil(invWidthScale) * 2 + 2;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        int r = coords[1];
        int c = coords[2];

        float accumulator = 0.0;

        const float heightScale = float(${heightScale});
        const float widthScale = float(${widthScale});

        const float invHeightScale = float(${invHeightScale});
        const float invWidthScale = float(${invWidthScale});

        const int winHeight = int(${winHeight});
        const int winWidth = int(${winWidth});

        // Compute bounds for where in dy we will look
        float startRLerp = floor(float(r) * invHeightScale);
        int startDyR = int(floor(startRLerp - float(winHeight / 2)));

        float startCLerp = floor(float(c) * invWidthScale);
        int startDyC = int(floor(startCLerp - float(winWidth / 2)));

        // Loop over dy
        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {
          int dyR = dyROffset + startDyR;

          // Guard against the window exceeding the bounds of dy
          if (dyR < 0 || dyR >= ${yHeight}) {
            continue;
          }

          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {
            int dyC = dyCOffset + startDyC;

            // Guard against the window exceeding the bounds of dy
            if (dyC < 0 || dyC >= ${yWidth}) {
              continue;
            }

            float sourceFracRow =
              float(${effectiveXSize[0]}) *
                (float(dyR) / float(${effectiveYSize[0]}));

            float sourceFracCol =
                float(${effectiveXSize[1]}) *
                  (float(dyC) / float(${effectiveYSize[1]}));

            int sourceNearestRow = int(min(
                float(int(${xHeight}) - 1),
                ${alignCorners} ? float(round(sourceFracRow)) :
                                  float(floor(sourceFracRow))));

            int sourceNearestCol = int(min(
                float(int(${xWidth}) - 1),
                ${alignCorners} ? float(round(sourceFracCol)) :
                                  float(floor(sourceFracCol))));

            if (r == sourceNearestRow && c == sourceNearestCol) {
              accumulator += getDy(b, dyR, dyC, d);
            }
          }
        }
        // End loop over dy

        setOutput(accumulator);
      }
    `;
    }
}

});


parcelRegister("8lMqM", function(module, exports) {

$parcel$export(module.exports, "reverseConfig", () => $6145da44f1483d13$export$cab6a4e8d2ed8e8d);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $a9aAp = parcelRequire("a9aAp");

var $7j8lr = parcelRequire("7j8lr");

var $fAHbJ = parcelRequire("fAHbJ");
function $6145da44f1483d13$export$66c1ae025e96b4bc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dims: dims } = attrs;
    const xRank = x.shape.length;
    const $dims = (0, $wx9lK).parseAxisParam(dims, x.shape);
    if (xRank === 0) return (0, $fAHbJ.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const program = (0, $aymVi.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $7j8lr.ReversePackedProgram)(x.shape, $dims) : new (0, $a9aAp.ReverseProgram)(x.shape, $dims);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $6145da44f1483d13$export$cab6a4e8d2ed8e8d = {
    kernelName: (0, $dCP8m.Reverse),
    backendName: 'webgl',
    kernelFunc: $6145da44f1483d13$export$66c1ae025e96b4bc
};

});
parcelRegister("a9aAp", function(module, exports) {

$parcel$export(module.exports, "ReverseProgram", () => $7632f4d7ecc8292f$export$abc2effa29e77e92);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7svrP = parcelRequire("7svrP");
class $7632f4d7ecc8292f$export$abc2effa29e77e92 {
    constructor(xShape, axis){
        this.variableNames = [
            'x'
        ];
        const rank = xShape.length;
        if (rank > 4) throw new Error(`WebGL backend: Reverse of rank-${rank} tensor is not yet supported`);
        this.outputShape = xShape;
        if (rank === 1) {
            this.userCode = `
        void main() {
          int coord = getOutputCoords();
          setOutput(getX(${xShape[0]} - coord - 1));
        }
      `;
            return;
        }
        const getInCoord = (i)=>{
            if (axis.indexOf(i) !== -1 && xShape[i] !== 1) return `${xShape[i]} - coords[${i}] - 1`;
            return `coords[${i}]`;
        };
        const inCoords = xShape.map((_, i)=>getInCoord(i)).join(',');
        const type = (0, $7svrP.getCoordsDataType)(rank);
        this.userCode = `
      void main() {
        ${type} coords = getOutputCoords();
        setOutput(getX(${inCoords}));
      }
    `;
    }
}

});

parcelRegister("7j8lr", function(module, exports) {

$parcel$export(module.exports, "ReversePackedProgram", () => $5520c7dafa77e5e7$export$e427e51a4a356956);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $2351m = parcelRequire("2351m");

var $7svrP = parcelRequire("7svrP");
class $5520c7dafa77e5e7$export$e427e51a4a356956 {
    constructor(xShape, axis){
        this.variableNames = [
            'x'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        const rank = xShape.length;
        if (rank > 4) throw new Error(`WebGL backend: Reverse of rank-${rank} tensor is not yet supported`);
        this.outputShape = xShape;
        const channels = (0, $2351m.getChannels)('rc', rank);
        const nextColumn = `${channels[rank - 1]} + 1 < ${this.outputShape[rank - 1]}`;
        const nextRow = `${channels[rank - 2]} + 1 < ${this.outputShape[rank - 2]}`;
        const type = (0, $7svrP.getCoordsDataType)(rank);
        if (rank === 1) this.userCode = `
        void main(){
          int rc = getOutputCoords();
          vec4 result = vec4(0.);
          result.r = getChannel(getX(${xShape[0]} - rc - 1),
            ${xShape[0]} - rc - 1);
          if(${nextColumn}){
              result.g = getChannel(getX(${xShape[0]} - (rc  + 1) - 1),
                ${xShape[0]} - (rc  + 1) - 1);
          }
          setOutput(result);
        }
      `;
        else this.userCode = `
        void main() {
          ${type} rc = getOutputCoords();
          vec4 result = vec4(0.);
          result.r = ${getR(channels.slice())};
          if(${nextColumn}){
            result.g = ${getG(channels.slice())};
          }
          if(${nextRow}) {
            result.b = ${getB(channels.slice())};
            if(${nextColumn}) {
              result.a = ${getA(channels.slice())};
            }
          }
          setOutput(result);
        }
    `;
        function getR(channels) {
            return getChannel(channels);
        }
        function getG(channels) {
            channels[rank - 1] = '(' + channels[rank - 1] + ` + 1)`;
            return getChannel(channels);
        }
        function getB(channels) {
            channels[rank - 2] = '(' + channels[rank - 2] + ` + 1)`;
            return getChannel(channels);
        }
        function getA(channels) {
            channels[rank - 1] = '(' + channels[rank - 1] + ` + 1)`;
            channels[rank - 2] = '(' + channels[rank - 2] + ` + 1)`;
            return getChannel(channels);
        }
        function getChannel(channels) {
            const inCoordsArray = xShape.map((_, i)=>getInCoord(i, channels));
            const inCoords = inCoordsArray.join(',');
            const innerDims = inCoordsArray.slice(-2).join(',');
            return `getChannel(getX(${inCoords}), vec2(${innerDims}))`;
        }
        function getInCoord(i, channels1) {
            if (axis.indexOf(i) !== -1 && xShape[i] !== 1) return `${xShape[i]} - ${channels1[i]} - 1`;
            else return `${channels1[i]}`;
        }
    }
}

});


parcelRegister("1gTcY", function(module, exports) {

$parcel$export(module.exports, "rotateWithOffsetConfig", () => $0ed21c49a838ee1c$export$44ba8c83417ab668);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $iIFgq = parcelRequire("iIFgq");
const $0ed21c49a838ee1c$export$44ba8c83417ab668 = {
    kernelName: (0, $dCP8m.RotateWithOffset),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { image: image } = inputs;
        const { radians: radians, fillValue: fillValue, center: center } = attrs;
        const webglBackend = backend;
        const program = new (0, $iIFgq.RotateProgram)(image.shape, fillValue);
        const [centerX, centerY] = (0, $lkN62).getImageCenter(center, image.shape[1], image.shape[2]);
        const customValues = [
            [
                centerX,
                centerY,
                Math.sin(radians),
                Math.cos(radians)
            ]
        ];
        const output = webglBackend.runWebGLProgram(program, [
            image
        ], image.dtype, customValues);
        return output;
    }
};

});
parcelRegister("iIFgq", function(module, exports) {

$parcel$export(module.exports, "RotateProgram", () => $da0c583c403d2600$export$a37df1d4e69844e7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $da0c583c403d2600$export$a37df1d4e69844e7 {
    constructor(imageShape, fillValue){
        this.variableNames = [
            'Image'
        ];
        this.outputShape = [];
        this.customUniforms = [
            {
                name: 'params',
                type: 'vec4'
            }
        ];
        const imageHeight = imageShape[1];
        const imageWidth = imageShape[2];
        this.outputShape = imageShape;
        let fillSnippet = '';
        if (typeof fillValue === 'number') fillSnippet = `float outputValue = ${fillValue.toFixed(2)};`;
        else fillSnippet = `
        vec3 fill = vec3(${fillValue.join(',')});
        float outputValue = fill[coords[3]];`;
        this.userCode = `
        void main() {
          ivec4 coords = getOutputCoords();
          int x = coords[2];
          int y = coords[1];
          float coordXFloat = (float(x) - params[0]) * params[3] -
            (float(y) - params[1]) * params[2];
          float coordYFloat = (float(x) - params[0]) * params[2] +
            (float(y) - params[1]) * params[3];
          int coordX = int(round(coordXFloat + params[0]));
          int coordY = int(round(coordYFloat + params[1]));
          ${fillSnippet}
          if(coordX >= 0 && coordX < ${imageWidth} && coordY >= 0 && coordY < ${imageHeight}) {
            outputValue = getImage(coords[0], coordY, coordX, coords[3]);
          }
          setOutput(outputValue);
        }
    `;
    }
}

});


parcelRegister("bzpEI", function(module, exports) {

$parcel$export(module.exports, "roundConfig", () => $86c6dd48041d9d89$export$6c09e3291f636503);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $86c6dd48041d9d89$var$ROUND = `
  // OpenGL ES does not support round function.
  // The algorithm is based on banker's rounding.
  float base = floor(x);
  if ((x - base) < 0.5) {
    return floor(x);
  } else if ((x - base) > 0.5) {
    return ceil(x);
  } else {
    if (mod(base, 2.0) == 0.0) {
      return base;
    } else {
      return base + 1.0;
    }
  }
`;
const $86c6dd48041d9d89$export$2077e0241d6afd3c = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $86c6dd48041d9d89$var$ROUND
});
const $86c6dd48041d9d89$export$6c09e3291f636503 = {
    kernelName: (0, $dCP8m.Round),
    backendName: 'webgl',
    kernelFunc: $86c6dd48041d9d89$export$2077e0241d6afd3c
};

});

parcelRegister("ceFbd", function(module, exports) {

$parcel$export(module.exports, "rsqrtConfig", () => $8e86bc51a52b26ab$export$941104b789956ef6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $8e86bc51a52b26ab$var$RSQRT = `return inversesqrt(x);`;
const $8e86bc51a52b26ab$export$1cc01d192953037e = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $8e86bc51a52b26ab$var$RSQRT,
    cpuKernelImpl: (0, $fIVdF.rsqrtImplCPU)
});
const $8e86bc51a52b26ab$export$941104b789956ef6 = {
    kernelName: (0, $dCP8m.Rsqrt),
    backendName: 'webgl',
    kernelFunc: $8e86bc51a52b26ab$export$1cc01d192953037e
};

});

parcelRegister("1EamF", function(module, exports) {

$parcel$export(module.exports, "scatterNdConfig", () => $1331910ba69d4d10$export$573371744f044f5);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $ggQh2 = parcelRequire("ggQh2");

var $9gI7w = parcelRequire("9gI7w");
function $1331910ba69d4d10$export$b6f42038a536d877(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices, updates: updates } = inputs;
    const { shape: shape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $lkN62).calculateShapes(updates, indices, shape);
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    if (outputSize === 0) return backend.makeTensorInfo(shape, indices.dtype);
    const flattenIndices = (0, $9gI7w.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $9gI7w.reshape)({
        inputs: {
            x: updates
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    });
    const defaultValue = backend.makeTensorInfo([], 'float32', new Float32Array([
        0
    ])); // scalar(0)
    const program = new (0, $ggQh2.ScatterProgram)(numUpdates, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndices,
        defaultValue
    ], flattenX.dtype);
    const reshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: shape
        }
    });
    backend.disposeIntermediateTensorInfo(flattenIndices);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(res);
    backend.disposeIntermediateTensorInfo(defaultValue);
    return reshaped;
}
const $1331910ba69d4d10$export$573371744f044f5 = {
    kernelName: (0, $dCP8m.ScatterNd),
    backendName: 'webgl',
    kernelFunc: $1331910ba69d4d10$export$b6f42038a536d877
};

});
parcelRegister("ggQh2", function(module, exports) {

$parcel$export(module.exports, "ScatterProgram", () => $030e8f3bbd135bcc$export$8d0317f5c5cbc1ac);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7svrP = parcelRequire("7svrP");
class $030e8f3bbd135bcc$export$8d0317f5c5cbc1ac {
    constructor(updateSize, sliceDim, indicesRank, updatesRank, strides, shape, summingDupeIndex = true){
        this.variableNames = [
            'updates',
            'indices',
            'defaultValue'
        ];
        this.outputShape = shape;
        const stridesType = (0, $7svrP.getCoordsDataType)(strides.length);
        const dtype = (0, $7svrP.getCoordsDataType)(shape.length);
        let indicesString = '';
        if (indicesRank === 1) indicesString = 'i';
        else if (indicesRank === 2) indicesString = 'i, j';
        const indicesSnippet = `getIndices(${indicesString})`;
        let updatesString = '';
        if (updatesRank === 1) updatesString = 'i';
        else if (updatesRank === 2) updatesString = 'i, coords[1]';
        const updatesSnippet = `getUpdates(${updatesString})`;
        const strideString = sliceDim > 1 ? 'strides[j]' : 'strides';
        this.userCode = `
        ${stridesType} strides = ${stridesType}(${strides});

        void main() {
          ${dtype} coords = getOutputCoords();
          float sum = 0.0;
          bool found = false;
          for (int i = 0; i < ${updateSize}; i++) {
            int flattenedIndex = 0;
            for (int j = 0; j < ${sliceDim}; j++) {
              int index = round(${indicesSnippet});
              flattenedIndex += index * ${strideString};
            }
            if (flattenedIndex == coords[0]) {
              sum += ${updatesSnippet};
              found = true;
            }
          }
          setOutput(mix(getDefaultValue(), sum, float(found)));
        }
      `;
    }
}

});


parcelRegister("5d1ZL", function(module, exports) {

$parcel$export(module.exports, "searchSortedConfig", () => $3cafb6db121e2da2$export$4b437b1a1aa6472f);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $h7ymK = parcelRequire("h7ymK");
function $3cafb6db121e2da2$export$56fad8d65b0adbdd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sortedSequence: sortedSequence, values: values } = inputs;
    const { side: side } = attrs;
    const program = new (0, $h7ymK.SearchSortedProgram)(sortedSequence.shape[0], sortedSequence.shape[1], values.shape[1], side);
    const customValues = [
        [
            sortedSequence.shape[1]
        ]
    ];
    return backend.runWebGLProgram(program, [
        sortedSequence,
        values
    ], 'int32', customValues);
}
const $3cafb6db121e2da2$export$4b437b1a1aa6472f = {
    kernelName: (0, $dCP8m.SearchSorted),
    backendName: 'webgl',
    kernelFunc: $3cafb6db121e2da2$export$56fad8d65b0adbdd
};

});
parcelRegister("h7ymK", function(module, exports) {

$parcel$export(module.exports, "SearchSortedProgram", () => $033772928771a770$export$2511b5550383de5c);
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
class $033772928771a770$export$2511b5550383de5c {
    constructor(batchSize, numInputs, numValues, side){
        this.variableNames = [
            'sortedSequence',
            'values'
        ];
        this.customUniforms = [
            {
                name: 'numInputs',
                type: 'int'
            }
        ];
        this.outputShape = [
            batchSize,
            numValues
        ];
        const webGL2LoopHead = 'while (left < right) {';
        // WebGL1 doesn't accept non constant loop conditions, so upper bound loop
        // iterations.
        const webGL1LoopHead = `for (int i = 0; i < ${Math.ceil(Math.log2(numInputs + 1))}; ++i) { if (left >= right) break;`;
        const loopHead = (0, $aymVi.env)().getNumber('WEBGL_VERSION') === 2 ? webGL2LoopHead : webGL1LoopHead;
        // left corresponds to lower bound and right to upper bound.
        const boundComparator = side === 'left' ? '<' : '<=';
        this.userCode = `
       int findBound(int batch, float value) {
         int left = 0;
         int right = numInputs;
         int mid;
         ${loopHead}
           mid = (left + right) / 2;
           if (getSortedSequence(batch, mid) ${boundComparator} value) {
             left = mid + 1;
           } else {
             right = mid;
           }
         }
         return right;
       }

       void main() {
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int valueIndex = coords[1];

         float value = getValues(batch, valueIndex);

         setOutput(float(findBound(batch, value)));
       }
     `;
    }
}

});


parcelRegister("cDGzo", function(module, exports) {

$parcel$export(module.exports, "selectConfig", () => $933a2604a1e7036e$export$7ff911e710ee72fc);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");
var $bnEYl = parcelRequire("bnEYl");

var $7UWjg = parcelRequire("7UWjg");
function $933a2604a1e7036e$export$2e6c959c16ff56b8(args) {
    const { inputs: inputs, backend: backend } = args;
    const { condition: condition, t: t, e: e } = inputs;
    const program = new (0, $7UWjg.SelectProgram)(condition.shape.length, t.shape, t.shape.length);
    return backend.runWebGLProgram(program, [
        condition,
        t,
        e
    ], (0, $bnEYl.upcastType)(t.dtype, e.dtype));
}
const $933a2604a1e7036e$export$7ff911e710ee72fc = {
    kernelName: (0, $dCP8m.Select),
    backendName: 'webgl',
    kernelFunc: $933a2604a1e7036e$export$2e6c959c16ff56b8
};

});
parcelRegister("7UWjg", function(module, exports) {

$parcel$export(module.exports, "SelectProgram", () => $5c3afe7bb31da312$export$845ed2d1f74ef297);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7svrP = parcelRequire("7svrP");
class $5c3afe7bb31da312$export$845ed2d1f74ef297 {
    constructor(cRank, shape, rank){
        this.variableNames = [
            'c',
            'a',
            'b'
        ];
        this.outputShape = shape;
        let cCoords;
        let abCoords;
        if (rank > 4) throw Error(`Where for rank ${rank} is not yet supported`);
        if (rank === 1) {
            abCoords = `resRC`;
            cCoords = `resRC`;
        } else {
            const currentCoords = [
                'resRC.x',
                'resRC.y',
                'resRC.z',
                'resRC.w'
            ];
            const cCoordVars = [];
            const abCoordVars = [];
            for(let i = 0; i < shape.length; i++){
                abCoordVars.push(`${currentCoords[i]}`);
                if (i < cRank) cCoordVars.push(`${currentCoords[i]}`);
            }
            cCoords = cCoordVars.join();
            abCoords = abCoordVars.join();
        }
        const dtype = (0, $7svrP.getCoordsDataType)(rank);
        this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        float cVal = getC(${cCoords});
        if (cVal >= 1.0) {
          setOutput(getA(${abCoords}));
        } else {
          setOutput(getB(${abCoords}));
        }
      }
    `;
    }
}

});


parcelRegister("dI8QC", function(module, exports) {

$parcel$export(module.exports, "seluConfig", () => $9fb63f5e07a9598d$export$8afc8558705c1a39);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $9fb63f5e07a9598d$var$SELU = `
  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.
  // see: https://arxiv.org/abs/1706.02515
  float scaleAlpha = ${(0, $lkN62).SELU_SCALEALPHA};
  float scale = ${(0, $lkN62).SELU_SCALE};
  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);
`;
const $9fb63f5e07a9598d$export$a5f8240d9e99b438 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $9fb63f5e07a9598d$var$SELU
});
const $9fb63f5e07a9598d$export$8afc8558705c1a39 = {
    kernelName: (0, $dCP8m.Selu),
    backendName: 'webgl',
    kernelFunc: $9fb63f5e07a9598d$export$a5f8240d9e99b438
};

});

parcelRegister("iaFFN", function(module, exports) {

$parcel$export(module.exports, "sigmoidConfig", () => $d3a97c93fca122cd$export$195d1cf7c59f3ef);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $d3a97c93fca122cd$var$SIGMOID = (0, $eWZon.CHECK_NAN_SNIPPET_UNARY) + `
  return 1.0 / (1.0 + exp(-1.0 * x));
`;
const $d3a97c93fca122cd$var$SIGMOID_PACKED = `
  vec4 result = 1.0 / (1.0 + exp(-1.0 * x));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $d3a97c93fca122cd$export$3b295495ca3cad7c = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $d3a97c93fca122cd$var$SIGMOID,
    packedOpSnippet: $d3a97c93fca122cd$var$SIGMOID_PACKED,
    cpuKernelImpl: (0, $fIVdF.sigmoidImplCPU)
});
const $d3a97c93fca122cd$export$195d1cf7c59f3ef = {
    kernelName: (0, $dCP8m.Sigmoid),
    backendName: 'webgl',
    kernelFunc: $d3a97c93fca122cd$export$3b295495ca3cad7c
};

});

parcelRegister("5TazQ", function(module, exports) {

$parcel$export(module.exports, "signConfig", () => $449a4b37c9799d69$export$9c0fb3eb2124ceb7);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
// Sign does not propagate NANs.
const $449a4b37c9799d69$var$SIGN = `
  if (isnan(x)) { return 0.0; }
  return sign(x);
`;
const $449a4b37c9799d69$export$c5552dfdbc7cec71 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $449a4b37c9799d69$var$SIGN
});
const $449a4b37c9799d69$export$9c0fb3eb2124ceb7 = {
    kernelName: (0, $dCP8m.Sign),
    backendName: 'webgl',
    kernelFunc: $449a4b37c9799d69$export$c5552dfdbc7cec71
};

});

parcelRegister("iv65B", function(module, exports) {

$parcel$export(module.exports, "sinConfig", () => $d77fd873137937db$export$d993ec4e5c253b66);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $d77fd873137937db$var$SIN = (0, $eWZon.CHECK_NAN_SNIPPET_UNARY) + `
  return sin(x);
`;
const $d77fd873137937db$export$5de3937cb4b592ed = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $d77fd873137937db$var$SIN
});
const $d77fd873137937db$export$d993ec4e5c253b66 = {
    kernelName: (0, $dCP8m.Sin),
    backendName: 'webgl',
    kernelFunc: $d77fd873137937db$export$5de3937cb4b592ed
};

});

parcelRegister("uIBXw", function(module, exports) {

$parcel$export(module.exports, "sinhConfig", () => $05c56851eee86e2e$export$b92766b47f18ac85);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $05c56851eee86e2e$var$SINH = `
  float e2x = exp(x);
  return (e2x - 1.0 / e2x) / 2.0;
`;
const $05c56851eee86e2e$export$545004b505d7c555 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $05c56851eee86e2e$var$SINH
});
const $05c56851eee86e2e$export$b92766b47f18ac85 = {
    kernelName: (0, $dCP8m.Sinh),
    backendName: 'webgl',
    kernelFunc: $05c56851eee86e2e$export$545004b505d7c555
};

});

parcelRegister("3Ldmc", function(module, exports) {

$parcel$export(module.exports, "softplusConfig", () => $2bd01f558508667a$export$d9bcfe553d12d9e3);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $2bd01f558508667a$var$SOFTPLUS = `
  float epsilon = 1.1920928955078125e-7;
  float threshold = log(epsilon) + 2.0;

  bool too_large = x > -threshold;
  bool too_small = x < threshold;

  float result;
  float exp_x = exp(x);

  if (too_large){
    result = x;
  }
  else if (too_small){
    result = exp_x;
  }
  else{
    result = log(exp_x + 1.0);
  }
  return result;
`;
const $2bd01f558508667a$export$76aa560a8c2b0055 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $2bd01f558508667a$var$SOFTPLUS
});
const $2bd01f558508667a$export$d9bcfe553d12d9e3 = {
    kernelName: (0, $dCP8m.Softplus),
    backendName: 'webgl',
    kernelFunc: $2bd01f558508667a$export$76aa560a8c2b0055
};

});

parcelRegister("721fl", function(module, exports) {

$parcel$export(module.exports, "spaceToBatchNDConfig", () => $51e9afd4df8ab2b5$export$2f85417863d2050b);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $2skRq = parcelRequire("2skRq");

var $9gI7w = parcelRequire("9gI7w");

var $lHu0m = parcelRequire("lHu0m");
const $51e9afd4df8ab2b5$export$effb9d7cae92012f = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, paddings: paddings } = attrs;
    (0, $wx9lK).assert(x.shape.length <= 4, ()=>"spaceToBatchND for rank > 4 with a WebGL backend not implemented yet");
    const prod = blockShape.reduce((a, b)=>a * b);
    const completePaddings = [
        [
            0,
            0
        ]
    ];
    completePaddings.push(...paddings);
    for(let i = 1 + blockShape.length; i < x.shape.length; ++i)completePaddings.push([
        0,
        0
    ]);
    const toDispose = [];
    const paddedX = (0, $2skRq.padV2)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            paddings: completePaddings,
            constantValue: 0
        }
    });
    const reshapedPaddedShape = (0, $lkN62).getReshaped(paddedX.shape, blockShape, prod, false);
    const permutedReshapedPaddedPermutation = (0, $lkN62).getPermuted(reshapedPaddedShape.length, blockShape.length, false);
    const flattenShape = (0, $lkN62).getReshapedPermuted(paddedX.shape, blockShape, prod, false);
    const reshapedPaddedX = (0, $9gI7w.reshape)({
        inputs: {
            x: paddedX
        },
        backend: backend,
        attrs: {
            shape: reshapedPaddedShape
        }
    });
    const paddedXT = (0, $lHu0m.transpose)({
        inputs: {
            x: reshapedPaddedX
        },
        backend: backend,
        attrs: {
            perm: permutedReshapedPaddedPermutation
        }
    });
    const result = (0, $9gI7w.reshape)({
        inputs: {
            x: paddedXT
        },
        backend: backend,
        attrs: {
            shape: flattenShape
        }
    });
    toDispose.push(paddedX);
    toDispose.push(reshapedPaddedX);
    toDispose.push(paddedXT);
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
};
const $51e9afd4df8ab2b5$export$2f85417863d2050b = {
    kernelName: (0, $dCP8m.SpaceToBatchND),
    backendName: 'webgl',
    kernelFunc: $51e9afd4df8ab2b5$export$effb9d7cae92012f
};

});

parcelRegister("erKnV", function(module, exports) {

$parcel$export(module.exports, "sparseFillEmptyRowsConfig", () => $a84791656b329b15$export$818286c593224d1a);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
function $a84791656b329b15$export$c82a1904a15b5028(args) {
    const { inputs: inputs, backend: backend } = args;
    const { indices: indices, values: values, denseShape: denseShape, defaultValue: defaultValue } = inputs;
    if (denseShape.shape.length !== 1) throw new Error(`Dense shape must be a vector, saw:
         ${denseShape.shape}`);
    if (indices.shape.length !== 2) throw new Error(`Indices must be a matrix, saw:
         ${indices.shape}`);
    if (values.shape.length !== 1) throw new Error(`Values must be a vector, saw:
         ${values.shape}`);
    if (defaultValue.shape.length !== 0) throw new Error(`Default value must be a scalar, saw:
        ${defaultValue.shape}`);
    const $indices = backend.readSync(indices.dataId);
    const $values = backend.readSync(values.dataId);
    const $denseShape = backend.readSync(denseShape.dataId);
    const $defaultValue = backend.readSync(defaultValue.dataId)[0];
    const [outputIndices, outputIndicesShape, outputValues, emptyRowIndicator, reverseIndexMap] = (0, $fIVdF.sparseFillEmptyRowsImplCPU)($indices, indices.shape, indices.dtype, $values, values.dtype, $denseShape, $defaultValue);
    return [
        backend.makeTensorInfo(outputIndicesShape, indices.dtype, outputIndices),
        backend.makeTensorInfo([
            outputIndicesShape[0]
        ], values.dtype, outputValues),
        backend.makeTensorInfo([
            emptyRowIndicator.length
        ], 'bool', new Uint8Array(emptyRowIndicator.map((value)=>Number(value)))),
        backend.makeTensorInfo([
            reverseIndexMap.length
        ], indices.dtype, new Int32Array(reverseIndexMap))
    ];
}
const $a84791656b329b15$export$818286c593224d1a = {
    kernelName: (0, $dCP8m.SparseFillEmptyRows),
    backendName: 'webgl',
    kernelFunc: $a84791656b329b15$export$c82a1904a15b5028
};

});

parcelRegister("jGLww", function(module, exports) {

$parcel$export(module.exports, "sparseReshapeConfig", () => $e556cdc2e7d82b19$export$eb106efc10374803);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
function $e556cdc2e7d82b19$export$1408c45865e11fc6(args) {
    const { inputs: inputs, backend: backend } = args;
    const { inputIndices: inputIndices, inputShape: inputShape, newShape: newShape } = inputs;
    if (inputIndices.shape.length !== 2) throw new Error(`Input indices should be a matrix but received shape ${inputIndices.shape}`);
    if (inputShape.shape.length !== 1) throw new Error(`Input shape should be a vector but received shape ${inputShape.shape}`);
    if (newShape.shape.length !== 1) throw new Error(`Target shape should be a vector but received shape ${newShape.shape}`);
    const $inputShape = Array.from(backend.readSync(inputShape.dataId));
    const $inputIndices = backend.readSync(inputIndices.dataId);
    const targetShape = Array.from(backend.readSync(newShape.dataId));
    const [newIndices, indicesShape, outputShape] = (0, $fIVdF.sparseReshapeImplCPU)($inputIndices, inputIndices.shape, inputIndices.dtype, $inputShape, targetShape);
    return [
        backend.makeTensorInfo(indicesShape, inputIndices.dtype, newIndices),
        backend.makeTensorInfo([
            outputShape.length
        ], newShape.dtype, new Int32Array(outputShape))
    ];
}
const $e556cdc2e7d82b19$export$eb106efc10374803 = {
    kernelName: (0, $dCP8m.SparseReshape),
    backendName: 'webgl',
    kernelFunc: $e556cdc2e7d82b19$export$1408c45865e11fc6
};

});

parcelRegister("fSUZr", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentMeanConfig", () => $b9081b2ae6c10237$export$51e7224ae14d7f78);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
function $b9081b2ae6c10237$export$dbc0c9096869d04e(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
              ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
              ${segmentIds.shape}`);
    const $data = backend.readSync(data.dataId);
    const $indices = backend.readSync(indices.dataId);
    const $segmentIds = backend.readSync(segmentIds.dataId);
    const [outputData, outputDataShape] = (0, $fIVdF.sparseSegmentReductionImplCPU)($data, data.shape, data.dtype, $indices, $segmentIds, true);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $b9081b2ae6c10237$export$51e7224ae14d7f78 = {
    kernelName: (0, $dCP8m.SparseSegmentMean),
    backendName: 'webgl',
    kernelFunc: $b9081b2ae6c10237$export$dbc0c9096869d04e
};

});

parcelRegister("hG3uK", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentSumConfig", () => $cde911f1506f0941$export$73fa0270f28b9555);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
function $cde911f1506f0941$export$2255ce53fc777865(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
             ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
             ${segmentIds.shape}`);
    const $data = backend.readSync(data.dataId);
    const $indices = backend.readSync(indices.dataId);
    const $segmentIds = backend.readSync(segmentIds.dataId);
    const [outputData, outputDataShape] = (0, $fIVdF.sparseSegmentReductionImplCPU)($data, data.shape, data.dtype, $indices, $segmentIds);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $cde911f1506f0941$export$73fa0270f28b9555 = {
    kernelName: (0, $dCP8m.SparseSegmentSum),
    backendName: 'webgl',
    kernelFunc: $cde911f1506f0941$export$2255ce53fc777865
};

});

parcelRegister("aww4b", function(module, exports) {

$parcel$export(module.exports, "sparseToDenseConfig", () => $7a95c44ceec4e197$export$7bc088f8ad44ef99);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $fIVdF = parcelRequire("fIVdF");

var $ggQh2 = parcelRequire("ggQh2");

var $9gI7w = parcelRequire("9gI7w");
function $7a95c44ceec4e197$export$1be4b823dd1a3080(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sparseIndices: sparseIndices, sparseValues: sparseValues, defaultValue: defaultValue } = inputs;
    const { outputShape: outputShape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $lkN62).calculateShapes(sparseValues, sparseIndices, outputShape);
    const sumDupeIndices = false;
    if (sparseValues.dtype === 'string') {
        const indicesBuf = backend.bufferSync(sparseIndices);
        const updatesBuf = backend.bufferSync(sparseValues);
        const $defaultValue = (0, $wx9lK).decodeString(backend.readSync(defaultValue.dataId)[0]);
        const outBuf = (0, $fIVdF.scatterImplCPU)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
        return backend.makeTensorInfo(outputShape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $ggQh2.ScatterProgram)(numUpdates, sliceRank, sparseIndices.shape.length, sparseValues.shape.length, strides, [
        outputSize,
        1
    ], sumDupeIndices);
    const res = backend.runWebGLProgram(program, [
        sparseValues,
        sparseIndices,
        defaultValue
    ], sparseValues.dtype);
    const reshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: outputShape
        }
    });
    backend.disposeIntermediateTensorInfo(res);
    return reshaped;
}
const $7a95c44ceec4e197$export$7bc088f8ad44ef99 = {
    kernelName: (0, $dCP8m.SparseToDense),
    backendName: 'webgl',
    kernelFunc: $7a95c44ceec4e197$export$1be4b823dd1a3080
};

});

parcelRegister("x6OHK", function(module, exports) {

$parcel$export(module.exports, "splitVConfig", () => $06385edc30e7c12a$export$317be24be3af9ea0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $agNmS = parcelRequire("agNmS");
function $06385edc30e7c12a$export$c0085d48b0a75d8f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { numOrSizeSplits: numOrSizeSplits, axis: axis } = attrs;
    const $axis = (0, $wx9lK).parseAxisParam(axis, x.shape)[0];
    const splitSizes = (0, $lkN62).prepareSplitSize(x, numOrSizeSplits, $axis);
    const xRank = x.shape.length;
    const begin = new Array(xRank).fill(0);
    const size = x.shape.slice();
    return splitSizes.map((s)=>{
        const sliceSize = [
            ...size
        ];
        sliceSize[$axis] = s;
        const sliceT = (0, $agNmS.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: sliceSize
            }
        });
        begin[$axis] += s;
        return sliceT;
    });
}
const $06385edc30e7c12a$export$317be24be3af9ea0 = {
    kernelName: (0, $dCP8m.SplitV),
    backendName: 'webgl',
    kernelFunc: $06385edc30e7c12a$export$c0085d48b0a75d8f
};

});

parcelRegister("hwc4z", function(module, exports) {

$parcel$export(module.exports, "sqrtConfig", () => $cc0eca3684a64e95$export$a592ba9268f10eeb);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");

var $fIVdF = parcelRequire("fIVdF");
const $cc0eca3684a64e95$var$SQRT = `return sqrt(x);`;
const $cc0eca3684a64e95$export$eba8049fb5020b81 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $cc0eca3684a64e95$var$SQRT,
    packedOpSnippet: $cc0eca3684a64e95$var$SQRT,
    cpuKernelImpl: (0, $fIVdF.sqrtImplCPU)
});
const $cc0eca3684a64e95$export$a592ba9268f10eeb = {
    kernelName: (0, $dCP8m.Sqrt),
    backendName: 'webgl',
    kernelFunc: $cc0eca3684a64e95$export$eba8049fb5020b81
};

});

parcelRegister("dMzPN", function(module, exports) {

$parcel$export(module.exports, "squareConfig", () => $a08b8e034ac22ed5$export$7c77bece4d51efc4);
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $a08b8e034ac22ed5$var$SQUARE = `return x * x;`;
const $a08b8e034ac22ed5$export$dd4f28cef696bc7d = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $a08b8e034ac22ed5$var$SQUARE
});
const $a08b8e034ac22ed5$export$7c77bece4d51efc4 = {
    kernelName: (0, $dCP8m.Square),
    backendName: 'webgl',
    kernelFunc: $a08b8e034ac22ed5$export$dd4f28cef696bc7d
};

});

parcelRegister("dY7vX", function(module, exports) {

$parcel$export(module.exports, "squaredDifferenceConfig", () => $a2b6b52534974424$export$9ed4691d69db8a43);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $a2b6b52534974424$var$SQUARED_DIFFERENCE = 'return (a - b) * (a - b);';
const $a2b6b52534974424$export$b178697fb6d0b37f = (0, $eWZon.binaryKernelFunc)({
    opSnippet: $a2b6b52534974424$var$SQUARED_DIFFERENCE,
    packedOpSnippet: $a2b6b52534974424$var$SQUARED_DIFFERENCE
});
const $a2b6b52534974424$export$9ed4691d69db8a43 = {
    kernelName: (0, $dCP8m.SquaredDifference),
    backendName: 'webgl',
    kernelFunc: $a2b6b52534974424$export$b178697fb6d0b37f
};

});

parcelRegister("8u4CC", function(module, exports) {

$parcel$export(module.exports, "stepConfig", () => $62d4b5de0dd5b447$export$c42ffaf52eb2647);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $2sCkP = parcelRequire("2sCkP");
function $62d4b5de0dd5b447$export$35d34bc0ed591a92({ inputs: inputs, attrs: attrs, backend: backend }) {
    const { x: x } = inputs;
    const opSnippet = (0, $2sCkP.CHECK_NAN_SNIPPET) + `
    return x > 0.0 ? 1.0 : float(${attrs.alpha});
  `;
    const program = new (0, $2sCkP.UnaryOpProgram)(x.shape, opSnippet);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $62d4b5de0dd5b447$export$c42ffaf52eb2647 = {
    kernelName: (0, $dCP8m.Step),
    backendName: 'webgl',
    kernelFunc: $62d4b5de0dd5b447$export$35d34bc0ed591a92
};

});

parcelRegister("kFKju", function(module, exports) {

$parcel$export(module.exports, "stridedSliceConfig", () => $f0cb8fd495799c6e$export$81773633114187bd);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $g81BN = parcelRequire("g81BN");
var $1KPDG = parcelRequire("1KPDG");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $fIVdF = parcelRequire("fIVdF");

var $gb0jk = parcelRequire("gb0jk");

var $9gI7w = parcelRequire("9gI7w");

var $agNmS = parcelRequire("agNmS");
function $f0cb8fd495799c6e$export$4ae57224f3b0605c(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, end: end, strides: strides, beginMask: beginMask, endMask: endMask, ellipsisMask: ellipsisMask, newAxisMask: newAxisMask, shrinkAxisMask: shrinkAxisMask } = attrs;
    const { finalShapeSparse: finalShapeSparse, finalShape: finalShape, isIdentity: isIdentity, sliceDim0: sliceDim0, isSimpleSlice: isSimpleSlice, begin: $begin, end: $end, strides: $strides } = (0, $1KPDG).sliceInfo(x.shape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
    let result;
    if (isIdentity) // Optimization #1, slice is a no-op plus reshape
    result = (0, $9gI7w.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    else if (sliceDim0 || isSimpleSlice) {
        // Optimization #2, slice is memory contiguous (only occurs in dim 0)
        (0, $wx9lK).assert(x.shape.length >= 1, ()=>`Input must have rank at least 1, got: ${x.shape.length}`);
        const size = (0, $1KPDG).computeOutShape($begin, $end, $strides);
        // To tolerate begin[0] > end[0] (a 0-output slice), we min(begin, end).
        const sliced = (0, $agNmS.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: $begin,
                size: size
            }
        });
        result = (0, $9gI7w.reshape)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: finalShape
            }
        });
        backend.disposeIntermediateTensorInfo(sliced);
    } else {
        const shouldExecuteOnCPU = backend.shouldExecuteOnCPU([
            x
        ]);
        if (shouldExecuteOnCPU) {
            // tslint:disable-next-line: no-unnecessary-type-assertion
            const values = backend.readSync(x.dataId);
            // tslint:disable-next-line: no-unnecessary-type-assertion
            const xBuf = (0, $g81BN.buffer)(x.shape, x.dtype, values);
            const resultValues = (0, $fIVdF.stridedSliceImplCPU)(finalShapeSparse, xBuf, $strides, $begin);
            result = backend.makeTensorInfo(finalShape, x.dtype, resultValues.values);
        } else {
            const program = new (0, $gb0jk.StridedSliceProgram)($begin, $strides, finalShapeSparse);
            result = backend.runWebGLProgram(program, [
                x
            ], x.dtype);
        }
    }
    const resultReshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    backend.disposeIntermediateTensorInfo(result);
    return resultReshaped;
}
const $f0cb8fd495799c6e$export$81773633114187bd = {
    kernelName: (0, $dCP8m.StridedSlice),
    backendName: 'webgl',
    kernelFunc: $f0cb8fd495799c6e$export$4ae57224f3b0605c
};

});
parcelRegister("gb0jk", function(module, exports) {

$parcel$export(module.exports, "StridedSliceProgram", () => $bc6dea1c03d7b59d$export$335c52ce94f359f6);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7svrP = parcelRequire("7svrP");
class $bc6dea1c03d7b59d$export$335c52ce94f359f6 {
    constructor(begin, strides, size){
        this.variableNames = [
            'x'
        ];
        this.outputShape = size;
        const rank = size.length;
        const inputDtype = (0, $7svrP.getCoordsDataType)(size.length);
        const dtype = (0, $7svrP.getCoordsDataType)(size.length);
        let newCoords = '';
        if (rank === 1) newCoords = 'coords * strides + begin';
        else {
            let outputAxis = 0;
            newCoords = size.map((_, i)=>{
                outputAxis++;
                return size.length === 1 ? `coords * strides[${i}] + begin[${i}]` : `coords[${outputAxis - 1}] * strides[${i}] + begin[${i}]`;
            }).join(',');
        }
        this.userCode = `
      ${inputDtype} begin = ${inputDtype}(${begin});
      ${inputDtype} strides = ${inputDtype}(${strides});

      void main() {
        ${dtype} coords = getOutputCoords();
        setOutput(getX(${newCoords}));
      }
    `;
    }
}

});


parcelRegister("jIJUC", function(module, exports) {

$parcel$export(module.exports, "stringNGramsConfig", () => $e5b5bd93d9f9c5ee$export$35e13284eed34c22);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
function $e5b5bd93d9f9c5ee$export$3490514dcc63b044(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { separator: separator, nGramWidths: nGramWidths, leftPad: leftPad, rightPad: rightPad, padWidth: padWidth, preserveShortSequences: preserveShortSequences } = attrs;
    const { data: data, dataSplits: dataSplits } = inputs;
    const $data = backend.readSync(data.dataId);
    const $dataSplits = backend.readSync(dataSplits.dataId);
    const [nGrams, nGramsSplits] = (0, $fIVdF.stringNGramsImplCPU)($data, $dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences);
    return [
        backend.makeTensorInfo([
            nGrams.length
        ], 'string', nGrams),
        backend.makeTensorInfo(dataSplits.shape, 'int32', nGramsSplits)
    ];
}
const $e5b5bd93d9f9c5ee$export$35e13284eed34c22 = {
    kernelName: (0, $dCP8m.StringNGrams),
    backendName: 'webgl',
    kernelFunc: $e5b5bd93d9f9c5ee$export$3490514dcc63b044
};

});

parcelRegister("3bryn", function(module, exports) {

$parcel$export(module.exports, "stringSplitConfig", () => $2517c5b7701ef3c3$export$c51cbbd627a96532);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
function $2517c5b7701ef3c3$export$aa7f8babb17e7672(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { skipEmpty: skipEmpty } = attrs;
    const { input: input, delimiter: delimiter } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (input.shape.length !== 1) throw new Error(`Input must be a vector, got shape: ${input.shape}`);
    if (delimiter.shape.length !== 0) throw new Error(`Delimiter must be a scalar, got shape: ${delimiter.shape}`);
    const $input = backend.readSync(input.dataId);
    const $delimiter = backend.readSync(delimiter.dataId)[0];
    const [indices, values, shape] = (0, $fIVdF.stringSplitImplCPU)($input, $delimiter, skipEmpty);
    const outputSize = values.length;
    return [
        backend.makeTensorInfo([
            outputSize,
            2
        ], 'int32', indices),
        backend.makeTensorInfo([
            outputSize
        ], 'string', values),
        backend.makeTensorInfo([
            2
        ], 'int32', new Int32Array(shape))
    ];
}
const $2517c5b7701ef3c3$export$c51cbbd627a96532 = {
    kernelName: (0, $dCP8m.StringSplit),
    backendName: 'webgl',
    kernelFunc: $2517c5b7701ef3c3$export$aa7f8babb17e7672
};

});

parcelRegister("2tEax", function(module, exports) {

$parcel$export(module.exports, "stringToHashBucketFastConfig", () => $1cdd72f2e339ca5c$export$a88a78b2b233f507);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");
function $1cdd72f2e339ca5c$export$6195616d6fd0c848(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { numBuckets: numBuckets } = attrs;
    const { input: input } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (numBuckets <= 0) throw new Error(`Number of buckets must be at least 1`);
    const $input = backend.readSync(input.dataId);
    const output = (0, $fIVdF.stringToHashBucketFastImplCPU)($input, numBuckets);
    return backend.makeTensorInfo(input.shape, 'int32', output);
}
const $1cdd72f2e339ca5c$export$a88a78b2b233f507 = {
    kernelName: (0, $dCP8m.StringToHashBucketFast),
    backendName: 'webgl',
    kernelFunc: $1cdd72f2e339ca5c$export$6195616d6fd0c848
};

});

parcelRegister("2qgzi", function(module, exports) {

$parcel$export(module.exports, "tanConfig", () => $1c3adc9e9b8708f8$export$97648844df7611f3);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $1c3adc9e9b8708f8$var$TAN = `return tan(x);`;
const $1c3adc9e9b8708f8$export$fcdd3b0b3246a325 = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $1c3adc9e9b8708f8$var$TAN
});
const $1c3adc9e9b8708f8$export$97648844df7611f3 = {
    kernelName: (0, $dCP8m.Tan),
    backendName: 'webgl',
    kernelFunc: $1c3adc9e9b8708f8$export$fcdd3b0b3246a325
};

});

parcelRegister("64sK6", function(module, exports) {

$parcel$export(module.exports, "tanhConfig", () => $46b96979ab24e0c1$export$a2fc7de1a1e4eee0);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $eWZon = parcelRequire("eWZon");
const $46b96979ab24e0c1$var$TANH = `
  float e2x = exp(-2.0 * abs(x));
  return sign(x) * (1.0 - e2x) / (1.0 + e2x);
`;
const $46b96979ab24e0c1$export$7128670e45beef9a = (0, $eWZon.unaryKernelFunc)({
    opSnippet: $46b96979ab24e0c1$var$TANH
});
const $46b96979ab24e0c1$export$a2fc7de1a1e4eee0 = {
    kernelName: (0, $dCP8m.Tanh),
    backendName: 'webgl',
    kernelFunc: $46b96979ab24e0c1$export$7128670e45beef9a
};

});

parcelRegister("hcuAt", function(module, exports) {

$parcel$export(module.exports, "tile", () => $c85b48a38f32ff7b$export$3c17558da18e4d75);
$parcel$export(module.exports, "tileConfig", () => $c85b48a38f32ff7b$export$a5a9f8050ba7f41e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $g81BN = parcelRequire("g81BN");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $fIVdF = parcelRequire("fIVdF");

var $hIzvB = parcelRequire("hIzvB");
function $c85b48a38f32ff7b$export$3c17558da18e4d75(params) {
    const { inputs: inputs, backend: backend, attrs: attrs } = params;
    const { x: x } = inputs;
    const { reps: reps } = attrs;
    // tile gpu program cannot handle rank > 5 case.
    if (x.dtype === 'string' || x.shape.length > 5) {
        // Even thought string tensor is always on CPU, just to be consistent on how
        // to access tensor data.
        const data = backend.readSync(x.dataId);
        const value = x.dtype === 'string' ? data.map((d)=>(0, $wx9lK).decodeString(d)) : data;
        const buf = (0, $g81BN.buffer)(x.shape, x.dtype, value);
        const outBuf = (0, $fIVdF.tileImplCPU)(buf, reps);
        return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $hIzvB.TileProgram)(x.shape, reps);
    const output = backend.runWebGLProgram(program, [
        x
    ], x.dtype);
    return output;
}
const $c85b48a38f32ff7b$export$a5a9f8050ba7f41e = {
    kernelName: (0, $dCP8m.Tile),
    backendName: 'webgl',
    kernelFunc: $c85b48a38f32ff7b$export$3c17558da18e4d75
};

});
parcelRegister("hIzvB", function(module, exports) {

$parcel$export(module.exports, "TileProgram", () => $ce6217009d64a645$export$215140f0ab19f420);
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7svrP = parcelRequire("7svrP");
class $ce6217009d64a645$export$215140f0ab19f420 {
    constructor(aShape, reps){
        this.variableNames = [
            'A'
        ];
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[i] * reps[i];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        const dtype = (0, $7svrP.getCoordsDataType)(this.rank);
        const sourceCoords = $ce6217009d64a645$var$getSourceCoords(aShape);
        this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        setOutput(getA(${sourceCoords}));
      }
    `;
    }
}
function $ce6217009d64a645$var$getSourceCoords(aShape) {
    const rank = aShape.length;
    if (rank > 5) throw Error(`Tile for rank ${rank} is not yet supported`);
    if (rank === 1) return `imod(resRC, ${aShape[0]})`;
    const currentCoords = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w',
        'resRC.u'
    ];
    const sourceCoords = [];
    for(let i = 0; i < aShape.length; i++)sourceCoords.push(`imod(${currentCoords[i]}, ${aShape[i]})`);
    return sourceCoords.join();
}

});


parcelRegister("9mIku", function(module, exports) {

$parcel$export(module.exports, "topKConfig", () => $6d188e0f894e7c21$export$cffaee31213314ce);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $aymVi = parcelRequire("aymVi");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $fIVdF = parcelRequire("fIVdF");

var $djbas = parcelRequire("djbas");

var $hOLpE = parcelRequire("hOLpE");

var $8uyHu = parcelRequire("8uyHu");

var $9gI7w = parcelRequire("9gI7w");

var $agNmS = parcelRequire("agNmS");
function $6d188e0f894e7c21$var$disposeIntermediateTensorInfoOrNull(backend, tensorInfo) {
    if (tensorInfo !== null) backend.disposeIntermediateTensorInfo(tensorInfo);
}
function $6d188e0f894e7c21$var$roundUpToPow2(num) {
    let pow2 = 1;
    while(pow2 < num)pow2 *= 2;
    return pow2;
}
function $6d188e0f894e7c21$export$7e641efc73a2d81(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { k: k, sorted: sorted } = attrs;
    // Empirically determined constant used to determine last dim threshold for
    // handing off execution to the CPU.
    const TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD = (0, $aymVi.env)().getNumber('TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD');
    // Empirically determined constant used to determine k threshold for handing
    // off execution to the CPU.
    const TOPK_K_CPU_HANDOFF_THRESHOLD = (0, $aymVi.env)().getNumber('TOPK_K_CPU_HANDOFF_THRESHOLD');
    const xShape = x.shape;
    const lastDim = xShape[xShape.length - 1];
    if (backend.shouldExecuteOnCPU([
        x
    ]) || lastDim < TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD || k > TOPK_K_CPU_HANDOFF_THRESHOLD) {
        const xVals = backend.readSync(x.dataId);
        const [allTopKVals, allTopKIndices] = (0, $fIVdF.topKImplCPU)(xVals, xShape, x.dtype, k, sorted);
        return [
            backend.makeTensorInfo(allTopKVals.shape, allTopKVals.dtype, allTopKVals.values),
            backend.makeTensorInfo(allTopKIndices.shape, allTopKIndices.dtype, allTopKIndices.values)
        ];
    }
    if (k === 0) {
        xShape[xShape.length - 1] = 0;
        return [
            backend.makeTensorInfo(xShape, x.dtype, []),
            backend.makeTensorInfo(xShape, 'int32', [])
        ];
    }
    if (lastDim === 1 /* firstPass */ ) return [
        x,
        (0, $hOLpE.fill)({
            attrs: {
                shape: xShape,
                dtype: 'int32',
                value: 0
            },
            backend: backend
        })
    ];
    // Eagerly unpack x input since it is passed in to all the shaders which
    // require unpacked inputs.
    const xtexData = backend.texData.get(x.dataId);
    const xIsPacked = xtexData !== null && xtexData.isPacked;
    const xUnPacked = xIsPacked ? backend.unpackTensor(x) : x;
    // Reshape into a 2d tensor [batch, lastDim] and compute topk along lastDim.
    const xSize = (0, $wx9lK).sizeFromShape(xShape);
    const batch = xSize / lastDim;
    const x2D = (0, $9gI7w.reshape)({
        inputs: {
            x: xUnPacked
        },
        attrs: {
            shape: [
                batch,
                lastDim
            ]
        },
        backend: backend
    });
    if (xIsPacked) $6d188e0f894e7c21$var$disposeIntermediateTensorInfoOrNull(backend, xUnPacked);
    const kPow2 = $6d188e0f894e7c21$var$roundUpToPow2(k);
    const lastDimPow2 = $6d188e0f894e7c21$var$roundUpToPow2(lastDim);
    // Only the indices containing the top K are kept at every step to reduce
    // number of outputs in the GPU algorithms, so once the final set of indices
    // is computed then gather is used to grab the corresponding values
    // from the original input.
    let indices = null;
    // GPU algorithm always takes in an indices input but this input is not used
    // on the first run of a GPU algorithm, therefore if indices is null we simply
    // pass in x2D instead of it but the value will not actually be used
    const getInputs = ()=>indices === null ? [
            x2D,
            x2D
        ] : [
            x2D,
            indices
        ];
    const runSwap = (dir, inc, shape)=>{
        const inputs = getInputs();
        const program = new (0, $djbas.SwapProgram)(shape);
        const fistPass = indices === null ? 1 : 0;
        const customValues = [
            [
                lastDim
            ],
            [
                fistPass
            ],
            [
                Number.NEGATIVE_INFINITY
            ],
            [
                dir
            ],
            [
                inc
            ]
        ];
        const prevIndices = indices;
        indices = backend.runWebGLProgram(program, inputs, 'int32', customValues);
        $6d188e0f894e7c21$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    };
    // Step 1: local sort
    for(let len = 1; len < kPow2; len *= 2){
        const dir = len * 2;
        for(let inc = len; inc >= 1; inc /= 2)runSwap(dir, inc, [
            batch,
            lastDimPow2
        ]);
    }
    // Step 2: merge
    for(let indicesSize = lastDimPow2; indicesSize > kPow2; indicesSize /= 2){
        const inputs = getInputs();
        const mergeProgram = new (0, $djbas.MergeProgram)([
            batch,
            indicesSize / 2
        ]);
        const firstPass = indices === null ? 1 : 0;
        const customValues = [
            [
                lastDim
            ],
            [
                firstPass
            ],
            [
                kPow2
            ]
        ];
        const prevIndices = indices;
        indices = backend.runWebGLProgram(mergeProgram, inputs, 'int32', customValues);
        $6d188e0f894e7c21$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
        // Step 3: rebuild
        const len = kPow2 / 2;
        const dir = len * 2;
        for(let inc = len; inc >= 1; inc /= 2)runSwap(dir, inc, indices.shape);
    }
    // Keep only the requested top K results instead of kPow2
    let prevIndices = indices;
    indices = (0, $agNmS.slice)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            begin: 0,
            size: [
                batch,
                k
            ]
        }
    });
    $6d188e0f894e7c21$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    // Gather values on last dimension
    let values = (0, $8uyHu.gatherV2)({
        inputs: {
            x: x2D,
            indices: indices
        },
        backend: backend,
        attrs: {
            axis: 1,
            batchDims: 1
        }
    });
    $6d188e0f894e7c21$var$disposeIntermediateTensorInfoOrNull(backend, x2D);
    // Reshape back to the original input shape, except that the last
    // dimension is k.
    const newShape = xShape.slice(0, -1);
    newShape.push(k);
    prevIndices = indices;
    indices = (0, $9gI7w.reshape)({
        inputs: {
            x: indices
        },
        attrs: {
            shape: newShape
        },
        backend: backend
    });
    $6d188e0f894e7c21$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    const prevValues = values;
    values = (0, $9gI7w.reshape)({
        inputs: {
            x: values
        },
        attrs: {
            shape: newShape
        },
        backend: backend
    });
    $6d188e0f894e7c21$var$disposeIntermediateTensorInfoOrNull(backend, prevValues);
    return [
        values,
        indices
    ];
}
const $6d188e0f894e7c21$export$cffaee31213314ce = {
    kernelName: (0, $dCP8m.TopK),
    backendName: 'webgl',
    kernelFunc: $6d188e0f894e7c21$export$7e641efc73a2d81
};

});
parcelRegister("djbas", function(module, exports) {

$parcel$export(module.exports, "SwapProgram", () => $9b05b65ffa9cfbf5$export$5ee54e3c81d6f6e7);
$parcel$export(module.exports, "MergeProgram", () => $9b05b65ffa9cfbf5$export$c3fbf8b38d821ac9);
// Based on Algorithm 2 of Bitonic Top K, ref:
// https://anilshanbhag.in/static/papers/gputopk_sigmod18.pdf
// The original algorithm is based on computing the top K only, however
// since for TFJS we require the indices of the top K values as well then the
// algorithm found here is a bit modified. Rather than producing the values
// at each step, the indices containing the top K are generated instead.
// The output values are not generated to reduce the number of outputs in the
// GPU, the values can easily be retrieved from the indices using a gather
// op.
class $9b05b65ffa9cfbf5$export$5ee54e3c81d6f6e7 {
    /**
     * @param shape desired output shape (can be larger than input shape, output
     *                                    will be padded with -Infinity)
     */ constructor(shape){
        this.variableNames = [
            'x',
            'indices'
        ];
        // |n| Size of the original input of TopK.
        // |firstPass|indicates if this is the first time swap is being used which
        // means no indices input containing the top K is present yet.
        // |inc| Swaps pairs of indices (0, inc), (1, inc + 1), (2, inc + 2) ...
        this.customUniforms = [
            {
                name: 'n',
                type: 'int'
            },
            {
                name: 'firstPass',
                type: 'int'
            },
            {
                name: 'negativeInf',
                type: 'float'
            },
            {
                name: 'dir',
                type: 'int'
            },
            {
                name: 'inc',
                type: 'int'
            }
        ];
        this.outputShape = shape;
        this.userCode = `
       void main() {
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int elemIdx = coords[1];

         // We compare elements pair-wise within a group of size 2 * inc.
         // The comparing rule for each group alternates between ascending
         // and descending. Within each group, we compare each pair at
         // positions i and i+inc. To decide whether an element at position i
         // is x0 or x1, we mod it by 2 * inc, if the result is smaller than
         // inc, it is in the first half of the group, we denote it as x0,
         // otherwise we denote it as x1.
         // For example, as shown in the Bitonic top K paper referenced above,
         // Figure5(a) shows that element[1] is in the
         // second half of the group when group size is 2, but it is in the
         // first half of the group when group size is 4.

         bool isFirstInPair = imod(elemIdx, 2 * inc) < inc;
         int i = isFirstInPair ? elemIdx : elemIdx - inc;

         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));
         int i1 = firstPass == 1 ? i + inc : int(getIndices(batch, i + inc));
         float x0 = i0 < n ? getX(batch, i0) : negativeInf;
         float x1 = i1 < n ? getX(batch, i1) : negativeInf;

         // Denotes which direction indices are in (ascending or descending).
         bool reverse = imod(elemIdx, 2 * dir) >= dir;
         bool isGreater = x0 > x1 || (x0 == x1 && i1 > i0);
         if (reverse == isGreater) { // Elements in opposite order of direction
           int iTemp = i0;
           i0 = i1;
           i1 = iTemp;
         }
         if (isFirstInPair) {
            setOutput(float(i0));
         } else {
            setOutput(float(i1));
         }
       }
     `;
    }
}
class $9b05b65ffa9cfbf5$export$c3fbf8b38d821ac9 {
    /**
     * @param shape desired output shape (must be half of the input size)
     */ constructor(shape){
        this.variableNames = [
            'x',
            'indices'
        ];
        // |n| Size of the original input of TopK
        // |firstPass| indicates if this is the first time swap is being used which
        // means no indices input containing the top K is present yet.
        // |k| Top k elements desired
        this.customUniforms = [
            {
                name: 'n',
                type: 'int'
            },
            {
                name: 'firstPass',
                type: 'int'
            },
            {
                name: 'k',
                type: 'int'
            }
        ];
        this.outputShape = shape;
        this.userCode = `
    void main() {
         // Takes max of indices (0, k), (1, k + 1), (2, k + 2) ...
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int elemIdx = coords[1];

         // The output size is half of the previous size.
         // If the previous sequence is | | | | _ _ _ _  | | | |  _ _ _ _ (k=4),
         // we only need to output the indices at positions |, the indices at
         // positions _ can be thrown away, see Figure5(b) After Phase 2
         // (Merge phase) in the Bitonic Top K paper referenced above.
         // For example, the paper shows we only need to output the orange bars.
         // The output sequence should look like this | | | | | | | |.
         // Because the sequence is halved, to map the output index back
         // to the previous sequence to find the corresponding value,
         // we need to double the index. When we double the index,
         // we basically interpolate a position, so 2i looks like
         // | _ | _ | _ | _ | _ | _ | _. We move the | to the first k position
         // of each 2k positions by - elemIdx % k. E.g. for output at
         // index 4,5,6,7, we want to get the corresponding element at
         // original index 8,9,10,11, for output at index 8,9,10,11,
         // we want to get the corresponding element at original index
         // 16,17,18,19, so on and so forth.

         int i = elemIdx < k ? elemIdx : (elemIdx * 2 - imod(elemIdx, k));
         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));
         int i1 = firstPass == 1 ? i + k : int(getIndices(batch, i + k));

         float x0 = getX(batch, i0);
         float x1 = i1 < n ? getX(batch, i1) : x0;

         setOutput(x0 >= x1 ? float(i0) : float(i1));
       }
     `;
    }
}

});


parcelRegister("1ylbW", function(module, exports) {

$parcel$export(module.exports, "transformConfig", () => $1219679b5bac6dbb$export$1c7a3de6335954ed);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $2K0vC = parcelRequire("2K0vC");
function $1219679b5bac6dbb$export$51186ad6e864892a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, transforms: transforms } = inputs;
    const { interpolation: interpolation, fillMode: fillMode, fillValue: fillValue, outputShape: outputShape } = attrs;
    const [batch, imageHeight, imageWidth, numChannels] = image.shape;
    const [outHeight, outWidth] = outputShape != null ? outputShape : [
        imageHeight,
        imageWidth
    ];
    const outShape = [
        batch,
        outHeight,
        outWidth,
        numChannels
    ];
    const program = new (0, $2K0vC.TransformProgram)(imageHeight, imageWidth, interpolation, fillMode, fillValue, outShape);
    return backend.runWebGLProgram(program, [
        image,
        transforms
    ], 'float32');
}
const $1219679b5bac6dbb$export$1c7a3de6335954ed = {
    kernelName: (0, $dCP8m.Transform),
    backendName: 'webgl',
    kernelFunc: $1219679b5bac6dbb$export$51186ad6e864892a
};

});
parcelRegister("2K0vC", function(module, exports) {

$parcel$export(module.exports, "TransformProgram", () => $1ff045bed8854172$export$c83a293baf8f269d);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $1ff045bed8854172$export$c83a293baf8f269d {
    constructor(imageHeight, imageWidth, interpolation, fillMode, fillValue, outShape){
        this.variableNames = [
            'Image',
            'Transforms'
        ];
        this.outputShape = outShape;
        const interpolationModeId = interpolation === 'nearest' ? 1 : 2;
        let fillModeId;
        switch(fillMode){
            case 'constant':
                fillModeId = 1;
                break;
            case 'reflect':
                fillModeId = 2;
                break;
            case 'wrap':
                fillModeId = 3;
                break;
            case 'nearest':
                fillModeId = 4;
                break;
            default:
                fillModeId = 1;
                break;
        }
        this.userCode = `
            float mapCoord(float outCoord, float len) {
              float inCoord = outCoord;
              if(${fillModeId} == 2) {
                if (inCoord < 0.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz2 = 2.0 * len;
                    if (inCoord < sz2) {
                      inCoord = sz2 * float(int(float(-inCoord / sz2))) +
                      inCoord;
                    }
                    inCoord = inCoord < -len ? inCoord + sz2 : -inCoord - 1.0;
                  }
                } else if (inCoord > len - 1.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz2 = 2.0 * len;
                    inCoord -= sz2 * float(int(float(inCoord / sz2)));
                    if (inCoord >= len) {
                      inCoord = sz2 - inCoord - 1.0;
                    }
                  }
                }
                return clamp(inCoord, 0.0, len - 1.0);
              } else if (${fillModeId} == 3) {
                if (inCoord < 0.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz = len - 1.0;
                    inCoord += len * (float(int(float(-inCoord / sz))) + 1.0);
                  }
                } else if (inCoord > len - 1.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz = len - 1.0;
                    inCoord -= len * float(int(float(inCoord / sz)));
                  }
                }
                return clamp(inCoord, 0.0, len - 1.0);
              } else if (${fillModeId} == 4) {
                return clamp(outCoord, 0.0, len - 1.0);
              } else {
                return outCoord;
              }
            }

            float readWithFillValue(int batch, int coordY, int coordX,
              int channel) {
              float outputValue;
              if (0 <= coordY && coordY < ${imageHeight} && 0 <= coordX && coordX < ${imageWidth}) {
                  outputValue = getImage(batch, coordY, coordX, channel);
              } else {
                outputValue = float(${fillValue});
              }
              return outputValue;
            }

            void main() {
              ivec4 coords = getOutputCoords();
              float outputValue;
              int batch = coords[0];
              int x = coords[2];
              int y = coords[1];
              int channel = coords[3];
              float xf = float(x);
              float yf = float(y);
              float a1 = getTransforms(batch, 0);
              float a2 = getTransforms(batch, 1);
              float a3 = getTransforms(batch, 2);
              float b1 = getTransforms(batch, 3);
              float b2 = getTransforms(batch, 4);
              float b3 = getTransforms(batch, 5);
              float c1 = getTransforms(batch, 6);
              float c2 = getTransforms(batch, 7);
              float projection = c1 * xf + c2 * yf + 1.0;
              if (projection == 0.0) {
                outputValue = float(${fillValue});
              } else {
                float inX = (a1 * xf + a2 * yf + a3) / projection;
                float inY = (b1 * xf + b2 * yf + b3) / projection;
                float mapX = mapCoord(inX, float(${imageWidth}));
                float mapY = mapCoord(inY, float(${imageHeight}));

                if (${interpolationModeId} == 1) {
                  int coordY = int(round(mapY));
                  int coordX = int(round(mapX));
                  outputValue = readWithFillValue(batch, coordY, coordX,
                    channel);
                } else {
                  float yFloor = floor(mapY);
                  float xFloor = floor(mapX);
                  float yCeil = yFloor + 1.0;
                  float xCeil = xFloor + 1.0;
                  float valueYFloor = (xCeil - mapX) *
                  readWithFillValue(batch, int(yFloor), int(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, int(yFloor), int(xCeil), channel);
                  float valueYCeil = (xCeil - mapX) *
                  readWithFillValue(batch, int(yCeil), int(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, int(yCeil), int(xCeil), channel);
                  outputValue = (yCeil - mapY) * valueYFloor +
                  (mapY - yFloor) * valueYCeil;
                }
              }
              setOutput(outputValue);
            }
        `;
    }
}

});


parcelRegister("ajP4f", function(module, exports) {

$parcel$export(module.exports, "uniqueConfig", () => $78334aaf50bf2ba8$export$78cd70dcd092910e);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $fIVdF = parcelRequire("fIVdF");

var $4rulI = parcelRequire("4rulI");
function $78334aaf50bf2ba8$export$7a5d5c156e7dc406(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { axis: axis } = attrs;
    const { x: x } = inputs;
    (0, $4rulI.assertNotComplex)(x, 'unique');
    // For now, always forward calculation to the CPU backend.
    console.warn('WARNING: ', 'UI might be locked temporarily as data is being downloaded');
    const values = backend.readSync(x.dataId);
    const { outputValues: outputValues, outputShape: outputShape, indices: indices } = (0, $fIVdF.uniqueImplCPU)(values, axis, x.shape, x.dtype);
    return [
        backend.makeTensorInfo(outputShape, x.dtype, outputValues),
        backend.makeTensorInfo([
            indices.length
        ], 'int32', indices)
    ];
}
const $78334aaf50bf2ba8$export$78cd70dcd092910e = {
    kernelName: (0, $dCP8m.Unique),
    backendName: 'webgl',
    kernelFunc: $78334aaf50bf2ba8$export$7a5d5c156e7dc406
};

});

parcelRegister("4vA0p", function(module, exports) {

$parcel$export(module.exports, "unpackConfig", () => $3485fc9e02ec923f$export$d06292128cae50d6);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $dCP8m = parcelRequire("dCP8m");

var $9gI7w = parcelRequire("9gI7w");

var $agNmS = parcelRequire("agNmS");
function $3485fc9e02ec923f$export$417857010dc9287f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { value: value } = inputs;
    let { axis: axis } = attrs;
    if (axis < 0) axis += value.shape.length;
    const x = value;
    const xRank = x.shape.length;
    const num = value.shape[axis];
    const outShape = new Array(xRank - 1);
    let outIndex = 0;
    for(let i = 0; i < xRank; i++)if (i !== axis) outShape[outIndex++] = x.shape[i];
    const toDispose = [];
    const begin = new Array(xRank).fill(0);
    const size = x.shape.slice();
    size[axis] = 1;
    const res = new Array(num);
    for(let i = 0; i < res.length; i++){
        begin[axis] = i;
        const sliced = (0, $agNmS.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: size
            }
        });
        const reshaped = (0, $9gI7w.reshape)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        res[i] = reshaped;
        toDispose.push(sliced);
    }
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return res;
}
const $3485fc9e02ec923f$export$d06292128cae50d6 = {
    kernelName: (0, $dCP8m.Unpack),
    backendName: 'webgl',
    kernelFunc: $3485fc9e02ec923f$export$417857010dc9287f
};

});

parcelRegister("baTE7", function(module, exports) {

$parcel$export(module.exports, "unsortedSegmentSumConfig", () => $822bcb02edec0a2b$export$71e3626a4ca29968);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("5n9DG");
var $lkN62 = parcelRequire("lkN62");
var $bnEYl = parcelRequire("bnEYl");
var $dCP8m = parcelRequire("dCP8m");
var $wx9lK = parcelRequire("wx9lK");

var $kw08u = parcelRequire("kw08u");

var $hiwUp = parcelRequire("hiwUp");

var $9gI7w = parcelRequire("9gI7w");

var $hcuAt = parcelRequire("hcuAt");

var $lHu0m = parcelRequire("lHu0m");
function $822bcb02edec0a2b$export$ba7c4d144d85a309(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, segmentIds: segmentIds } = inputs;
    const { numSegments: numSegments } = attrs;
    const xRank = x.shape.length;
    const toDispose = [];
    let axis = 0;
    const permutation = (0, $lkN62).getAxesPermutation([
        axis
    ], xRank);
    let permutedX = x;
    if (permutation != null) {
        permutedX = (0, $lHu0m.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        toDispose.push(permutedX);
        axis = (0, $lkN62).getInnerMostAxes(1, xRank)[0];
    }
    const outShape = (0, $lkN62).segment_util.computeOutShape(permutedX.shape, axis, numSegments);
    const inSize = (0, $wx9lK).sizeFromShape([
        permutedX.shape[axis]
    ]);
    const a2D = (0, $9gI7w.reshape)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    toDispose.push(a2D);
    const outputDType = (0, $bnEYl.sumOutType)(x.dtype);
    const segOpCompute = (x, segOpType, segmentIds, dtype, numSegments)=>{
        const batchSize = x.shape[0];
        const inSize = x.shape[1];
        const windowSize = (0, $lkN62).segment_util.segOpComputeOptimalWindowSize(inSize, numSegments);
        const segOpInfo = {
            windowSize: windowSize,
            inSize: inSize,
            batchSize: batchSize,
            numSegments: numSegments
        };
        const program = new (0, $kw08u.SegmentOpProgram)(segOpInfo, segOpType);
        const output = backend.compileAndRun(program, [
            x,
            segmentIds
        ], dtype);
        toDispose.push(output);
        // No need to run another GPGPU program.
        if (output.shape[1] === numSegments) return output;
        const rangeInfo = (0, $hiwUp.range)({
            backend: backend,
            attrs: {
                start: 0,
                stop: numSegments,
                step: 1,
                dtype: 'float32'
            }
        });
        const tileInfo = (0, $hcuAt.tile)({
            inputs: {
                x: rangeInfo
            },
            backend: backend,
            attrs: {
                reps: [
                    inSize / windowSize
                ]
            }
        });
        toDispose.push(rangeInfo);
        toDispose.push(tileInfo);
        const result = segOpCompute(output, segOpType, tileInfo, dtype, numSegments);
        return result;
    };
    const segOpResult = segOpCompute(a2D, 'unsortedSegmentSum', segmentIds, outputDType, numSegments);
    const reshaped = (0, $9gI7w.reshape)({
        inputs: {
            x: segOpResult
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    let result = reshaped;
    if (permutation != null) {
        toDispose.push(reshaped);
        const perm = (0, $lkN62).getUndoAxesPermutation(permutation);
        result = (0, $lHu0m.transpose)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: perm
            }
        });
    }
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $822bcb02edec0a2b$export$71e3626a4ca29968 = {
    kernelName: (0, $dCP8m.UnsortedSegmentSum),
    backendName: 'webgl',
    kernelFunc: $822bcb02edec0a2b$export$ba7c4d144d85a309
};

});
parcelRegister("kw08u", function(module, exports) {

$parcel$export(module.exports, "SegmentOpProgram", () => $eef6e6cb1c5bbf36$export$543f739d986d05c3);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $eef6e6cb1c5bbf36$export$543f739d986d05c3 {
    constructor(segOpInfo, segOpType){
        this.variableNames = [
            'x',
            'segmentIds'
        ];
        const windowSize = segOpInfo.windowSize;
        const batchSize = segOpInfo.batchSize;
        const inSize = segOpInfo.inSize;
        const numSegments = segOpInfo.numSegments;
        const outSize = numSegments * Math.ceil(inSize / windowSize);
        this.outputShape = [
            batchSize,
            outSize
        ];
        const initializationValue = '0.0';
        const returnValue = `sumValue`;
        const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
        const windowSizeVec4Remainder = windowSize % 4;
        const updateSnippet = `
        sumValue += dot(values, segFilter);
    `;
        let checkValueOutOfBounds = '';
        if (inSize % windowSize > 0) checkValueOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return initializationValue;
        }
      `;
        let checkSegmentIdOutOfBounds = '';
        if (inSize % windowSize > 0) checkSegmentIdOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return -1.0;
        }
      `;
        this.userCode = `
      const float initializationValue = ${initializationValue};

      float getValue(int batch, int inIdx) {
        ${checkValueOutOfBounds}
        return getX(batch, inIdx);
      }

      float getSegmentIdAtIndex(int inIdx) {
        ${checkSegmentIdOutOfBounds}
        return getSegmentIds(inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = int(floor(float(outIdx) / float(
          ${numSegments})) * float(${windowSize}));
        int currentSeg = int(mod(float(outIdx), float(${numSegments})));

        float sumValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            initializationValue,
            initializationValue,
            initializationValue
          );

          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            0,
            0,
            0
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            initializationValue,
            initializationValue
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
              0,
              0
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            initializationValue
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,
            0
          );

          ${updateSnippet}
        }
        setOutput(${returnValue});
      }
    `;
    }
}

});




parcelRegister("4Aqjf", function(module, exports) {

$parcel$export(module.exports, "version", () => $356eeeb89e4fc972$export$83d89fbfd8236492);
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $356eeeb89e4fc972$export$83d89fbfd8236492 = '3.21.0';

});



parcelRegister("7hVND", function(module, exports) {
"use strict";
var $54e6f4b392b1efa6$var$__assign = module.exports && module.exports.__assign || function() {
    $54e6f4b392b1efa6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $54e6f4b392b1efa6$var$__assign.apply(this, arguments);
};
var $54e6f4b392b1efa6$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $54e6f4b392b1efa6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $54e6f4b392b1efa6$var$frame_1 = $54e6f4b392b1efa6$var$__importDefault((parcelRequire("6QWdY")));

var $j3dDi = parcelRequire("j3dDi");

var $54e6f4b392b1efa6$var$concat_1 = $54e6f4b392b1efa6$var$__importDefault((parcelRequire("hlO5L")));

var $54e6f4b392b1efa6$var$series_1 = $54e6f4b392b1efa6$var$__importDefault((parcelRequire("hIkcL")));
/**
 * The class performs all groupby operation on a dataframe
 * involving all aggregate funciton
 * @param {colDict} colDict Object of unique keys in the group by column
 * @param {keyCol} keyCol Array contains the column names
 * @param {data} Array the dataframe data
 * @param {columnName} Array of all column name in the dataframe.
 * @param {colDtype} Array columns dtype
 */ var $54e6f4b392b1efa6$var$Groupby = /** @class */ function() {
    function Groupby(keyCol, data, columnName, colDtype, colIndex) {
        this.colDict = {};
        this.keyToValue = {};
        this.keyCol = keyCol;
        this.data = data;
        this.columnName = columnName;
        //this.dataTensors = {}; //store the tensor version of the groupby data
        this.colDtype = colDtype;
        this.colIndex = colIndex;
    }
    /**
     * Generate group object data needed for group operations
     * let data = [ [ 1, 2, 3 ], [ 4, 5, 6 ], [ 20, 30, 40 ], [ 39, 89, 78 ] ];
     * let cols = [ "A", "B", "C" ];
     * let df = new dfd.DataFrame(data, { columns: cols });
     * let groupDf = df.groupby([ "A" ]);
     * The following internal object is generated and save to this.colDict
     * {
     *  '1': { A: [ 1 ], B: [ 2 ], C: [ 3 ] },
     *  '4': { A: [ 4 ], B: [ 5 ], C: [ 6 ] },
     *  '20': { A: [ 20 ], B: [ 30 ], C: [ 40 ] },
     *  '39': { A: [ 39 ], B: [ 89 ], C: [ 78 ] }
     * }
     * Since for groupby using more than one columns is index via '-'
     * e.g for df.groupby(['A','B'])
     * the result will look like this
     * {
     *  '1-2': {A: [ 1 ], B: [ 2 ], C: [ 3 ]},
     *  '4-5': {A: [ 4 ], B: [ 5 ], C: [ 6 ]}
     * }
     * but in doing analysis on a specific column like this
     * df.groupby(['A','B']).col(['C'])
     * will have the following set of internal result
     * {
     *  '1-2': { C: [ 3 ]},
     *  '4-5': {C: [ 6 ]}
     * }
     * In building our multindex type of DataFrame for this data,
     * we've somehow loose track of value for column A and B.
     * This could actually be generated by using split('-') on the object keys
     * e.g '1-2'.split('-') will give us the value for A and B.
     * But we might have weird case scenerio where A and B value has '-`
     * e.g
     * {
     *  '1--2-': { C: [ 3 ]},
     *  '4--5-': {C: [ 6 ]}
     * }
     * using `.split('-') might not work well
     * Hence we create a key-value `keyToValue` object to store index and their
     * associated value
     * NOTE: In the previous implementation we made use of Graph representation
     * for the group by data and Depth First search (DFS). But we decided to use key-value
     * object in javascript as an hashmap to reduce search time compared to using Grpah and DFS
     */ Groupby.prototype.group = function() {
        var _a;
        var self = this;
        var keyToValue = {};
        var group = (_a = this.data) === null || _a === void 0 ? void 0 : _a.reduce(function(prev, current) {
            var indexes = [];
            for(var i in self.colIndex){
                var index_1 = self.colIndex[i];
                indexes.push(current[index_1]);
            }
            var index = indexes.join('-');
            if (!keyToValue[index]) keyToValue[index] = indexes;
            if (prev[index]) {
                var data = prev[index];
                for(var i in self.columnName){
                    var colName = self.columnName[i];
                    data[colName].push(current[i]);
                }
            } else {
                prev[index] = {};
                for(var i in self.columnName){
                    var colName = self.columnName[i];
                    prev[index][colName] = [
                        current[i]
                    ];
                }
            }
            return prev;
        }, {});
        this.colDict = group;
        this.keyToValue = keyToValue;
        return this;
    };
    /**
     * Generate new internal groupby data
     * group = df.groupby(['A', 'B']).col('C')
     * This filter the colDict property as generated by `.group()`
     * it filter each group to contain only column `C` in their internal object
     * e.g
     * {
     *  '1-2': {A: [ 1 ], B: [ 2 ], C: [ 3 ]},
     *  '4-5': {A: [ 4 ], B: [ 5 ], C: [ 6 ]}
     * }
     * to
     * {
     *  '1-2': { C: [ 3 ]},
     *  '4-5': {C: [ 6 ]}
     * }
     * @param colNames column names
     * @return Groupby
     */ Groupby.prototype.col = function(colNames) {
        var _this = this;
        if (typeof colNames === "undefined") colNames = this.columnName.filter(function(_, index) {
            return !_this.colIndex.includes(index);
        });
        var self = this;
        colNames.forEach(function(val) {
            if (!self.columnName.includes(val)) throw new Error("Column " + val + " does not exist in groups");
        });
        var colDict = $54e6f4b392b1efa6$var$__assign({}, this.colDict);
        for(var _i = 0, _a = Object.entries(colDict); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], values = _b[1];
            var c = {};
            var keyVal = $54e6f4b392b1efa6$var$__assign({}, values);
            for(var colKey in colNames){
                var colName = colNames[colKey];
                c[colName] = keyVal[colName];
            }
            colDict[key] = c;
        }
        var gp = new Groupby(this.keyCol, null, this.columnName, this.colDtype, this.colIndex);
        gp.colDict = colDict;
        gp.groupColNames = colNames;
        gp.keyToValue = this.keyToValue;
        return gp;
    };
    /**
     * Perform all groupby arithmetic operations
     * In the previous implementation all groups data are
     * stord as DataFrame, which involve lot of memory usage
     * Hence each groups are just pure javascrit object
     * and all arithmetic operation is done directly on javascript
     * arrays.
     * e.g
     * using this internal data
     * {
     *  '1-2': {A: [ 1,3 ], B: [ 2,5 ], C: [ 3, 5 ]},
     *  '4-5': {A: [ 4,1 ], B: [ 5,0 ], C: [ 6, 12 ]}
     * }
     * 1) using groupby(['A', 'B']).arithmetic("mean")
     * result: * {
     *  '1-2': {A_mean: [ 2 ], B_mean: [ 3.5 ], C_mean: [ 4 ]},
     *  '4-5': {A_mean: [ 2.5 ], B: [ 2.5 ], C_mean: [ 9 ]}
     * }
     * 2) .arithmetic({
     *    A: 'mean',
     *    B: 'sum',
     *    C: 'min'
     * })
     * result:
     * {
     *  '1-2': {A_mean: [ 2 ], B_sum: [ 7 ], C_min: [ 3 ]},
     *  '4-5': {A_mean: [ 2.5 ], B_sum: [ 5 ], C_min: [ 6 ]}
     * }
     * 3) .arithmetic({
     *    A: 'mean',
     *    B: 'sum',
     *    C: ['min', 'max']
     * })
     * result:
     * {
     *  '1-2': {A_mean: [ 2 ], B_sum: [ 7 ], C_min: [ 3 ], C_max: [5]},
     *  '4-5': {A_mean: [ 2.5 ], B_sum: [ 5 ], C_min: [ 6 ], C_max: [12]}
     * }
     * @param operation
     */ Groupby.prototype.arithemetic = function(operation) {
        var opsName = [
            "mean",
            "sum",
            "count",
            "mode",
            "std",
            "var",
            "cumsum",
            "cumprod",
            "cummax",
            "cummin",
            "median",
            "min",
            "max"
        ];
        if (typeof operation === "string") {
            if (!opsName.includes(operation)) throw new Error("group operation: " + operation + " is not valid");
        } else Object.keys(operation).forEach(function(key) {
            var ops = operation[key];
            if (Array.isArray(ops)) for(var _i = 0, ops_1 = ops; _i < ops_1.length; _i++){
                var op = ops_1[_i];
                if (!opsName.includes(op)) throw new Error("group operation: " + op + " for column " + key + " is not valid");
            }
            else {
                if (!opsName.includes(ops)) throw new Error("group operation: " + ops + " for column " + key + " is not valid");
            }
        });
        var colDict = $54e6f4b392b1efa6$var$__assign({}, this.colDict);
        for(var _i = 0, _a = Object.entries(colDict); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], values = _b[1];
            var colVal = {};
            var keyVal = $54e6f4b392b1efa6$var$__assign({}, values);
            var groupColNames = this.groupColNames;
            for(var colKey = 0; colKey < groupColNames.length; colKey++){
                var colName = groupColNames[colKey];
                var colIndex = this.columnName.indexOf(colName);
                var colDtype = this.colDtype[colIndex];
                var operationVal = typeof operation === "string" ? operation : operation[colName];
                if (colDtype === "string" && operationVal !== "count") throw new Error("Can't perform math operation on column " + colName);
                if (typeof operation === "string") {
                    var colName2 = colName + "_" + operation;
                    colVal[colName2] = this.groupMathLog(keyVal[colName], operation);
                } else {
                    if (Array.isArray(operation[colName])) for(var _c = 0, _d = operation[colName]; _c < _d.length; _c++){
                        var ops = _d[_c];
                        var colName2 = colName + "_" + ops;
                        colVal[colName2] = this.groupMathLog(keyVal[colName], ops);
                    }
                    else {
                        var ops = operation[colName];
                        var colName2 = colName + "_" + ops;
                        colVal[colName2] = this.groupMathLog(keyVal[colName], ops);
                    }
                }
            }
            colDict[key] = colVal;
        }
        return colDict;
    };
    /**
     * Peform all arithmetic logic
     * @param colVal
     * @param ops
     */ Groupby.prototype.groupMathLog = function(colVal, ops) {
        var data = [];
        switch(ops){
            case "max":
                var max = colVal.reduce(function(prev, curr) {
                    if (prev > curr) return prev;
                    return curr;
                });
                data.push(max);
                break;
            case "min":
                var min = colVal.reduce(function(prev, curr) {
                    if (prev < curr) return prev;
                    return curr;
                });
                data.push(min);
                break;
            case "sum":
                var sum = colVal.reduce(function(prev, curr) {
                    return prev + curr;
                });
                data.push(sum);
                break;
            case "count":
                data.push(colVal.length);
                break;
            case "mean":
                var sumMean = colVal.reduce(function(prev, curr) {
                    return prev + curr;
                });
                data.push(sumMean / colVal.length);
                break;
            case "std":
                data.push((0, $j3dDi.std)(colVal));
                break;
            case "var":
                data.push((0, $j3dDi.variance)(colVal));
                break;
            case "median":
                data.push((0, $j3dDi.median)(colVal));
                break;
            case "mode":
                data.push((0, $j3dDi.mode)(colVal));
                break;
            case "cumsum":
                colVal.reduce(function(prev, curr) {
                    var sum = prev + curr;
                    data.push(sum);
                    return sum;
                }, 0);
                break;
            case "cummin":
                data = [
                    colVal[0]
                ];
                colVal.slice(1).reduce(function(prev, curr) {
                    if (prev < curr) {
                        data.push(prev);
                        return prev;
                    }
                    data.push(curr);
                    return curr;
                }, data[0]);
                break;
            case "cummax":
                data = [
                    colVal[0]
                ];
                colVal.slice(1).reduce(function(prev, curr) {
                    if (prev > curr) {
                        data.push(prev);
                        return prev;
                    }
                    data.push(curr);
                    return curr;
                }, data[0]);
                break;
            case "cumprod":
                colVal.reduce(function(prev, curr) {
                    var sum = prev * curr;
                    data.push(sum);
                    return sum;
                }, 1);
                break;
        }
        return data;
    };
    /**
     * Takes in internal groupby internal data and convert
     * them to a single data frame.
     * @param colDict
     */ Groupby.prototype.toDataFrame = function(colDict) {
        var data = {};
        for(var _i = 0, _a = this.colKeyDict(colDict); _i < _a.length; _i++){
            var key = _a[_i];
            var value = colDict[key];
            var keyDict = {};
            var oneValue = Object.values(value)[0];
            var valueLen = oneValue.length;
            for(var key1 in this.keyCol){
                var keyName = this.keyCol[key1];
                var keyValue = this.keyToValue[key][key1];
                keyDict[keyName] = Array(valueLen).fill(keyValue);
            }
            var combine = $54e6f4b392b1efa6$var$__assign($54e6f4b392b1efa6$var$__assign({}, keyDict), value);
            if (Object.keys(data).length < 1) data = combine;
            else for(var _b = 0, _c = Object.keys(data); _b < _c.length; _b++){
                var dataKey = _c[_b];
                var dataValue = combine[dataKey];
                data[dataKey] = $54e6f4b392b1efa6$var$__spreadArray($54e6f4b392b1efa6$var$__spreadArray([], data[dataKey], true), dataValue, true);
            }
        }
        return new $54e6f4b392b1efa6$var$frame_1.default(data);
    };
    Groupby.prototype.operations = function(ops) {
        if (!this.groupColNames) {
            var colGroup = this.col(undefined);
            var colDict_1 = colGroup.arithemetic(ops);
            var df_1 = colGroup.toDataFrame(colDict_1);
            return df_1;
        }
        var colDict = this.arithemetic(ops);
        var df = this.toDataFrame(colDict);
        return df;
    };
    /**
     * Obtain the count for each group
     * @returns DataFrame
     *
     */ Groupby.prototype.count = function() {
        return this.operations("count");
    };
    /**
     * Obtain the sum of columns for each group
     * @returns DataFrame
     *
     */ Groupby.prototype.sum = function() {
        return this.operations("sum");
    };
    /**
     * Obtain the standard deviation of columns for each group
     * @returns DataFrame
     */ Groupby.prototype.std = function() {
        return this.operations("std");
    };
    /**
     * Obtain the variance of columns for each group
     * @returns DataFrame
     */ Groupby.prototype.var = function() {
        return this.operations("var");
    };
    /**
     * Obtain the mean of columns for each group
     * @returns DataFrame
     */ Groupby.prototype.mean = function() {
        return this.operations("mean");
    };
    /**
     * Obtain the cumsum of columns for each group
     * @returns DataFrame
     *
     */ Groupby.prototype.cumSum = function() {
        return this.operations("cumsum");
    };
    /**
     * Obtain the cummax of columns for each group
     * @returns DataFrame
     */ Groupby.prototype.cumMax = function() {
        return this.operations("cummax");
    };
    /**
     * Obtain the cumprod of columns for each group
     * @returns DataFrame
     */ Groupby.prototype.cumProd = function() {
        return this.operations("cumprod");
    };
    /**
     * Obtain the cummin of columns for each group
     * @returns DataFrame
     */ Groupby.prototype.cumMin = function() {
        return this.operations("cummin");
    };
    /**
     * Obtain the max value of columns for each group
     * @returns DataFrame
     *
     */ Groupby.prototype.max = function() {
        return this.operations("max");
    };
    /**
     * Obtain the min of columns for each group
     * @returns DataFrame
     */ Groupby.prototype.min = function() {
        return this.operations("min");
    };
    /**
     * Obtain a specific group
     * @param keys Array<string | number>
     * @returns DataFrame
     */ Groupby.prototype.getGroup = function(keys) {
        var dictKey = keys.join("-");
        var colDict = {};
        colDict[dictKey] = $54e6f4b392b1efa6$var$__assign({}, this.colDict[dictKey]);
        return this.toDataFrame(colDict);
    };
    /**
     * Perform aggregation on all groups
     * @param ops
     * @returns DataFrame
     */ Groupby.prototype.agg = function(ops) {
        var columns = Object.keys(ops);
        var col_gp = this.col(columns);
        var data = col_gp.arithemetic(ops);
        var df = col_gp.toDataFrame(data);
        return df;
    };
    /**
     * Apply custom aggregator function
     * to each group
     * @param callable
     * @returns DataFrame
     * @example
     * let grp = df.groupby(['A'])
     * grp.apply((x) => x.count())
     */ Groupby.prototype.apply = function(callable) {
        var colDict = {};
        for(var _i = 0, _a = this.colKeyDict(this.colDict); _i < _a.length; _i++){
            var key = _a[_i];
            var valDataframe = new $54e6f4b392b1efa6$var$frame_1.default(this.colDict[key]);
            colDict[key] = callable(valDataframe);
        }
        return this.concatGroups(colDict);
    };
    Groupby.prototype.concatGroups = function(colDict) {
        var data = [];
        for(var _i = 0, _a = Object.entries(colDict); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], values = _b[1];
            var copyDf = void 0;
            if (values instanceof $54e6f4b392b1efa6$var$frame_1.default) copyDf = values.copy();
            else {
                var columns = values.index;
                columns = columns.length > 1 ? columns : [
                    'applyOps'
                ];
                copyDf = new $54e6f4b392b1efa6$var$frame_1.default([
                    values.values
                ], {
                    columns: columns
                });
            }
            var len = copyDf.shape[0];
            var key1 = void 0;
            for(key1 in this.keyCol){
                var keyName = this.keyCol[key1];
                var keyValue = this.keyToValue[key][key1];
                var dfValue = Array(len).fill(keyValue);
                var atIndex = parseInt(key1);
                if (this.groupColNames) copyDf.addColumn(keyName, dfValue, {
                    inplace: true,
                    atIndex: atIndex
                });
                else copyDf.addColumn(keyName + "_Group", dfValue, {
                    inplace: true,
                    atIndex: atIndex
                });
            }
            data.push(copyDf);
        }
        return (0, $54e6f4b392b1efa6$var$concat_1.default)({
            dfList: data,
            axis: 0
        });
    };
    Object.defineProperty(Groupby.prototype, "ngroups", {
        /**
         * obtain the total number of groups
         * @returns number
         */ get: function() {
            var keys = Object.keys(this.colDict);
            return keys.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Groupby.prototype, "groups", {
        /**
         * obtaind the internal group data
         * @returns  {[keys: string]: {}}
         */ get: function() {
            return this.colDict;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Obtain the first row of each group
     * @returns DataFrame
     */ Groupby.prototype.first = function() {
        return this.apply(function(x) {
            return x.head(1);
        });
    };
    /**
     * Obtain the last row of each group
     * @returns DataFrame
     */ Groupby.prototype.last = function() {
        return this.apply(function(x) {
            return x.tail(1);
        });
    };
    /**
     * Obtains the dataframe se of each groups
     * @returns DataFrame
     */ Groupby.prototype.size = function() {
        return this.apply(function(x) {
            return new $54e6f4b392b1efa6$var$series_1.default([
                x.shape[0]
            ]);
        });
    };
    Groupby.prototype.colKeyDict = function(colDict) {
        var keyDict = {};
        for(var _i = 0, _a = Object.keys(colDict); _i < _a.length; _i++){
            var key = _a[_i];
            var firstKey = key.split("-")[0];
            if (firstKey in keyDict) keyDict[firstKey].push(key);
            else keyDict[firstKey] = [
                key
            ];
        }
        var keys = [];
        for(var _b = 0, _c = Object.keys(keyDict); _b < _c.length; _b++){
            var key = _c[_b];
            keys.push.apply(keys, keyDict[key]);
        }
        return keys;
    };
    return Groupby;
}();
module.exports.default = $54e6f4b392b1efa6$var$Groupby;

});
parcelRegister("hlO5L", function(module, exports) {
"use strict";
/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $ca1b4113014cd3dd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ca1b4113014cd3dd$var$series_1 = $ca1b4113014cd3dd$var$__importDefault((parcelRequire("hIkcL")));

var $ca1b4113014cd3dd$var$frame_1 = $ca1b4113014cd3dd$var$__importDefault((parcelRequire("6QWdY")));
/**
 *
 * @param dfList Array<DataFrame | Series>
 * @param axis number
 * @returns DataFrame
 */ function $ca1b4113014cd3dd$var$processColumn(dfList, axis) {
    var allDf = {};
    var dublicateColumns = {};
    var maxLen = 0;
    for(var i = 0; i < dfList.length; i++){
        var df = dfList[i];
        var columnData = void 0;
        if (df instanceof $ca1b4113014cd3dd$var$frame_1.default) columnData = df.getColumnData;
        else columnData = [
            df.values
        ];
        var columns = df.columns;
        for(var j = 0; j < columns.length; j++){
            var column = columns[j];
            var colData = columnData[j];
            if (colData.length > maxLen) maxLen = colData.length;
            if (!(column in allDf)) {
                allDf[column] = colData;
                dublicateColumns[column] = 0;
            } else {
                dublicateColumns[column] += 1;
                column += dublicateColumns[column];
                allDf[column] = colData;
            }
        }
    }
    Object.keys(allDf).forEach(function(value) {
        var _a;
        var colLength = allDf[value].length;
        if (colLength < maxLen) {
            var residualLen = maxLen - colLength;
            var nanList = new Array(residualLen).fill(NaN);
            (_a = allDf[value]).push.apply(_a, nanList);
        }
    });
    return new $ca1b4113014cd3dd$var$frame_1.default(allDf);
}
/**
 * Concat data along rows
 * @param dfList Array<DataFrame | Series>
 * @param axis  Array<DataFrame | Series>
 * @returns DataFrame
 */ function $ca1b4113014cd3dd$var$processRow(dfList, axis) {
    var allDf = {};
    var maxLen = 0;
    var _loop_1 = function(i) {
        var _a, _b;
        var df = dfList[i];
        var columns = df.columns;
        var columnData = void 0;
        if (df instanceof $ca1b4113014cd3dd$var$frame_1.default) columnData = df.getColumnData;
        else columnData = [
            df.values
        ];
        if (i === 0) for(var j = 0; j < columns.length; j++){
            var column = columns[j];
            var colData = columnData[j];
            allDf[column] = colData;
        }
        else {
            var nonColumn = Object.keys(allDf).filter(function(key) {
                return !columns.includes(key);
            });
            for(var j = 0; j < columns.length; j++){
                var column = columns[j];
                var colData = columnData[j];
                if (Object.keys(allDf).includes(column)) (_a = allDf[column]).push.apply(_a, colData);
                else {
                    var residualArray = new Array(maxLen).fill(NaN);
                    residualArray.push.apply(residualArray, colData);
                    allDf[column] = residualArray;
                }
            }
            if (nonColumn.length > 0) {
                var currentDfLen = columnData[0].length;
                for(var j = 0; j < nonColumn.length; j++){
                    var column = nonColumn[j];
                    var residualArray = new Array(currentDfLen).fill(NaN);
                    (_b = allDf[column]).push.apply(_b, residualArray);
                }
            }
        }
        maxLen += columnData[0].length;
    };
    for(var i = 0; i < dfList.length; i++)_loop_1(i);
    if (Object.keys(allDf).length === 1) return new $ca1b4113014cd3dd$var$series_1.default(Object.values(allDf)[0]);
    return new $ca1b4113014cd3dd$var$frame_1.default(allDf);
}
/**
* Concatenate pandas objects along a particular axis.
* @param object
* dfList: Array of DataFrame or Series
* axis: axis of concatenation 1 or 0
* @returns {DataFrame}
* @example
* concat({dfList: [df1, df2, df3], axis: 1})
*/ function $ca1b4113014cd3dd$var$concat(_a) {
    var dfList = _a.dfList, axis = _a.axis;
    if (axis === 1) return $ca1b4113014cd3dd$var$processColumn(dfList, axis);
    return $ca1b4113014cd3dd$var$processRow(dfList, 0);
}
module.exports.default = $ca1b4113014cd3dd$var$concat;

});


parcelRegister("2n9qH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $oCdZL = parcelRequire("oCdZL");
/**
 * Package wide error throwing class
 */ var $1ba50b46b02d0c0a$var$ErrorThrower = /** @class */ function() {
    function ErrorThrower() {
        this.throwColumnNamesLengthError = function(ndframe, columns) {
            var msg = "ParamError: Column names length mismatch. You provided a column of length " + columns.length + " but Ndframe columns has length of " + ndframe.shape[1];
            throw new Error(msg);
        };
        this.throwIndexLengthError = function(ndframe, index) {
            var msg = "IndexError: You provided an index of length " + index.length + " but Ndframe rows has length of " + ndframe.shape[0];
            throw new Error(msg);
        };
        this.throwIndexDuplicateError = function() {
            var msg = "IndexError: Row index must contain unique values";
            throw new Error(msg);
        };
        this.throwColumnDuplicateError = function() {
            var msg = "ColumnIndexError: Column index must contain unique values";
            throw new Error(msg);
        };
        this.throwDtypesLengthError = function(ndframe, dtypes) {
            var msg = "DtypeError: You provided a dtype array of length " + dtypes.length + " but Ndframe columns has length of " + ndframe.shape[1];
            throw new Error(msg);
        };
        this.throwDtypeNotSupportedError = function(dtype) {
            var msg = "DtypeError: Dtype \"" + dtype + "\" not supported. dtype must be one of \"" + $oCdZL.DATA_TYPES + "\"";
            throw new Error(msg);
        };
        this.throwDtypeWithoutColumnError = function() {
            var msg = "DtypeError: columns parameter must be provided when dtypes parameter is provided";
            throw new Error(msg);
        };
        this.throwColumnLengthError = function(ndframe, arrLen) {
            var msg = "ParamError: Column data length mismatch. You provided data with length " + arrLen + " but Ndframe has column of length " + ndframe.shape[0];
            throw new Error(msg);
        };
        this.throwRowLengthError = function(ndframe, arrLen) {
            var msg = "ParamError: Row data length mismatch. You provided data with length " + arrLen + " but Ndframe has row of length " + ndframe.shape[0];
            throw new Error(msg);
        };
        this.throwColumnNotFoundError = function(ndframe) {
            var msg = "ParamError: Column not found!. Column name must be one of " + ndframe.columns;
            throw new Error(msg);
        };
        this.throwNotImplementedError = function() {
            var msg = "Method not implemented";
            throw new Error(msg);
        };
        this.throwIlocRowIndexError = function() {
            var msg = "ParamError: rows parameter must be a Array. For example: rows: [1,2] or rows: [\"0:10\"]";
            throw new Error(msg);
        };
        this.throwIlocColumnsIndexError = function() {
            var msg = "ParamError: columns parameter must be a Array. For example: columns: [1,2] or columns: [\"0:10\"]";
            throw new Error(msg);
        };
        this.throwStringDtypeOperationError = function(operation) {
            var msg = "DtypeError: String data type does not support " + operation + " operation";
            throw new Error(msg);
        };
        this.throwSeriesMathOpLengthError = function(ndframe, other) {
            var msg = "ParamError: Row length mismatch. Length of other (" + other.shape[0] + "), must be the same as Ndframe (" + ndframe.shape[0] + ")";
            throw new Error(msg);
        };
    }
    return ErrorThrower;
}();
module.exports.default = new $1ba50b46b02d0c0a$var$ErrorThrower();

});

parcelRegister("36CW2", function(module, exports) {
"use strict";
/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $2430224f797fca68$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._loc = module.exports._iloc = void 0;

var $2430224f797fca68$var$series_1 = $2430224f797fca68$var$__importDefault((parcelRequire("hIkcL")));

var $2430224f797fca68$var$utils_1 = $2430224f797fca68$var$__importDefault((parcelRequire("5MA6C")));

var $2430224f797fca68$var$frame_1 = $2430224f797fca68$var$__importDefault((parcelRequire("6QWdY")));
var $2430224f797fca68$var$utils = new $2430224f797fca68$var$utils_1.default();
/**
* Internal function to slice a Series/DataFrame by index based labels
* @param Object
*/ function $2430224f797fca68$var$_iloc(_a) {
    var ndFrame = _a.ndFrame, rows = _a.rows, columns = _a.columns;
    var _rowIndexes;
    var _columnIndexes;
    var _data = ndFrame.values;
    var _index = ndFrame.index;
    if (rows instanceof $2430224f797fca68$var$series_1.default) rows = rows.values;
    if (rows !== undefined && !Array.isArray(rows)) throw new Error("rows parameter must be an Array. For example: rows: [1,2] or rows: [\"0:10\"]");
    if (columns !== undefined && !Array.isArray(columns)) throw new Error("columns parameter must be an Array. For example: columns: [1,2] or columns: [\"0:10\"]");
    if (!rows) _rowIndexes = $2430224f797fca68$var$utils.range(0, ndFrame.shape[0] - 1);
    else if (rows.length == 1 && typeof rows[0] == "string") {
        var rowSplit = rows[0].split(":");
        if (rowSplit.length != 2) throw new Error("Invalid row split parameter: If using row split string, it must be of the form; rows: [\"start:end\"]");
        if (isNaN(parseInt(rowSplit[0])) && rowSplit[0] != "") throw new Error("Invalid row split parameter. Split parameter must be a number");
        if (isNaN(parseInt(rowSplit[1])) && rowSplit[1] != "") throw new Error("Invalid row split parameter. Split parameter must be a number");
        var start = rowSplit[0] == "" ? 0 : parseInt(rowSplit[0]);
        var end = rowSplit[1] == "" ? ndFrame.shape[0] : parseInt(rowSplit[1]);
        if (start < 0) throw new Error("row slice [start] index cannot be less than 0");
        if (end > ndFrame.shape[0]) throw new Error("row slice [end] index cannot be bigger than " + ndFrame.shape[0]);
        _rowIndexes = $2430224f797fca68$var$utils.range(start, end - 1);
    } else {
        var _formatedRows = [];
        for(var i = 0; i < rows.length; i++){
            var _indexToUse = rows[i];
            if (_indexToUse > ndFrame.shape[0]) throw new Error("Invalid row parameter: Specified index " + _indexToUse + " cannot be bigger than index length " + ndFrame.shape[0]);
            if (typeof _indexToUse !== "number" && typeof _indexToUse !== "boolean") throw new Error("Invalid row parameter: row index " + _indexToUse + " must be a number or boolean");
            if (typeof _indexToUse === "boolean" && _indexToUse === true) _formatedRows.push(_index[i]);
            if (typeof _indexToUse === "number") _formatedRows.push(_indexToUse);
        }
        _rowIndexes = _formatedRows;
    }
    if (!columns) _columnIndexes = $2430224f797fca68$var$utils.range(0, ndFrame.shape[1] - 1);
    else if (columns.length == 1 && typeof columns[0] == "string") {
        var columnSplit = columns[0].split(":");
        if (columnSplit.length != 2) throw new Error("Invalid column split parameter: If using column split string, it must be of the form; columns: [\"start:end\"]");
        if (isNaN(parseInt(columnSplit[0])) && columnSplit[0] != "") throw new Error("Invalid column split parameter. Split parameter must be a number");
        if (isNaN(parseInt(columnSplit[1])) && columnSplit[1] != "") throw new Error("Invalid column split parameter. Split parameter must be a number");
        var start = columnSplit[0] == "" ? 0 : parseInt(columnSplit[0]);
        var end = columnSplit[1] == "" ? ndFrame.shape[1] : parseInt(columnSplit[1]);
        if (start < 0) throw new Error("column slice [start] index cannot be less than 0");
        if (end > ndFrame.shape[1]) throw new Error("column slice [end] index cannot be bigger than " + ndFrame.shape[1]);
        _columnIndexes = $2430224f797fca68$var$utils.range(start, end - 1);
    } else {
        for(var i = 0; i < columns.length; i++){
            var _indexToUse = columns[i];
            if (_indexToUse > ndFrame.shape[1]) throw new Error("Invalid column parameter: Specified index " + _indexToUse + " cannot be bigger than index length " + ndFrame.shape[1]);
            if (typeof _indexToUse != "number") throw new Error("Invalid column parameter: column index " + _indexToUse + " must be a number");
        }
        _columnIndexes = columns;
    }
    if (ndFrame instanceof $2430224f797fca68$var$series_1.default) {
        var newData = [];
        var newIndex = [];
        for(var i = 0; i < _rowIndexes.length; i++){
            var rowIndx = _rowIndexes[i];
            newData.push(_data[rowIndx]);
            newIndex.push(_index[rowIndx]);
        }
        var sf = new $2430224f797fca68$var$series_1.default(newData, {
            index: newIndex,
            columns: ndFrame.columns,
            dtypes: ndFrame.dtypes,
            config: ndFrame.config
        });
        return sf;
    } else {
        var newData = [];
        var newIndex = [];
        var newColumnNames = [];
        var newDtypes = [];
        for(var i = 0; i < _rowIndexes.length; i++){
            var rowIndx = _rowIndexes[i];
            var rowData = _data[rowIndx];
            var newRowDataWithRequiredCols = [];
            for(var j = 0; j < _columnIndexes.length; j++){
                var colIndx = _columnIndexes[j];
                newRowDataWithRequiredCols.push(rowData[colIndx]);
            }
            newData.push(newRowDataWithRequiredCols);
            newIndex.push(_index[rowIndx]);
        }
        for(var i = 0; i < _columnIndexes.length; i++){
            var colIndx = _columnIndexes[i];
            newColumnNames.push(ndFrame.columns[colIndx]);
            newDtypes.push(ndFrame.dtypes[colIndx]);
        }
        var df = new $2430224f797fca68$var$frame_1.default(newData, {
            index: newIndex,
            columns: newColumnNames,
            dtypes: newDtypes,
            config: ndFrame.config
        });
        return df;
    }
}
module.exports._iloc = $2430224f797fca68$var$_iloc;
/**
* Internal function to slice a Series/DataFrame by specified string location based labels
* @param Object
*/ function $2430224f797fca68$var$_loc(_a) {
    var ndFrame = _a.ndFrame, rows = _a.rows, columns = _a.columns;
    var _rowIndexes;
    var _columnIndexes;
    var _data = ndFrame.values;
    var _index = ndFrame.index;
    if (rows instanceof $2430224f797fca68$var$series_1.default) rows = rows.values;
    if (rows !== undefined && !Array.isArray(rows)) throw new Error("rows parameter must be an Array. For example: rows: [1,2] or rows: [\"0:10\"]");
    if (columns !== undefined && !Array.isArray(columns)) throw new Error("columns parameter must be an Array. For example: columns: [\"a\",\"b\"] or columns: [\"a:c\"]");
    if (!rows) _rowIndexes = _index.map(function(indexValue) {
        return _index.indexOf(indexValue);
    }); // Return all row index
    else if (rows.length == 1 && typeof rows[0] == "string") {
        if (rows[0].indexOf(":") === -1) {
            var temp = void 0;
            if (rows[0].startsWith("\"") || rows[0].startsWith("'") || rows[0].startsWith("`")) temp = _index.indexOf(rows[0].replace(/['"`]/g, ''));
            else temp = _index.indexOf(Number(rows[0]));
            if (temp === -1) throw new Error("IndexError: Specified index (" + rows[0] + ") not found");
            _rowIndexes = [
                temp
            ];
        } else {
            // Input type ==> ["1:2"] or [`"1":"4"`]
            var rowSplit = rows[0].split(":");
            if (rowSplit.length != 2) throw new Error("Invalid row split parameter: If using row split string, it must be of the form; rows: [\"start:end\"]");
            var start = void 0;
            var end = void 0;
            if (rowSplit[0] === "") start = _index.indexOf(_index[0]);
            else if (rowSplit[0].startsWith("\"") || rowSplit[0].startsWith("'") || rowSplit[0].startsWith("`")) start = _index.indexOf(rowSplit[0].replace(/['"`]/g, ''));
            else start = _index.indexOf(Number(rowSplit[0]));
            if (rowSplit[1] === "") end = _index.indexOf(_index[_index.length - 1]) + 1;
            else if (rowSplit[0].startsWith("\"") || rowSplit[0].startsWith("'") || rowSplit[0].startsWith("`")) end = _index.indexOf(rowSplit[1].replace(/['"`]/g, ''));
            else end = _index.indexOf(Number(rowSplit[1]));
            if (start === -1) throw new Error("IndexError: Specified start index not found");
            if (end === -1) throw new Error("IndexError: Specified end index not found");
            _rowIndexes = _index.slice(start, end).map(function(indexValue) {
                return _index.indexOf(indexValue);
            });
        }
    } else {
        // Input type ==> ["1", "2"] or [1, 5] or [true, false]
        var rowsIndexToUse = [];
        for(var i = 0; i < rows.length; i++){
            var isBoolean = typeof rows[i] === "boolean";
            if (isBoolean && rows[i]) rowsIndexToUse.push(_index.indexOf(_index[i]));
            if (!isBoolean) {
                var rowIndex = _index.indexOf(rows[i]);
                if (rowIndex === -1) throw new Error("IndexError: Specified index (" + rows[i] + ") not found");
                rowsIndexToUse.push(rowIndex);
            }
        }
        _rowIndexes = rowsIndexToUse;
    }
    var _columnNames = ndFrame.columns;
    if (!columns) _columnIndexes = _columnNames.map(function(columnName) {
        return _columnNames.indexOf(columnName);
    }); // Return all column index
    else if (columns.length == 1) {
        if (typeof columns[0] !== "string") throw new Error("ColumnIndexError: columns parameter must be an array of a string name. For example: columns: [\"b\"]");
        if (columns[0].indexOf(":") == -1) _columnIndexes = [
            _columnNames.indexOf(columns[0])
        ];
        else {
            var columnSplit = columns[0].split(":");
            if (columnSplit.length != 2) throw new Error("ColumnIndexError: Invalid row split parameter. If using row split string, it must be of the form; rows: [\"start:end\"]");
            var start = columnSplit[0] == "" ? _columnNames.indexOf(_columnNames[0]) : _columnNames.indexOf(columnSplit[0]);
            var end = columnSplit[1] == "" ? _columnNames.indexOf(_columnNames[_columnNames.length - 1]) : _columnNames.indexOf(columnSplit[1]);
            if (start === -1) throw new Error("ColumnIndexError: Specified start index not found");
            if (end === -1) throw new Error("ColumnIndexError: Specified end index not found");
            _columnIndexes = _columnNames.slice(start, end + 1).map(function(columnName) {
                return _columnNames.indexOf(columnName);
            });
            _columnIndexes.pop(); //Remove the last element
        }
    } else {
        for(var i = 0; i < columns.length; i++){
            if (_columnNames.indexOf(columns[i]) === -1) throw new Error("ColumnIndexError: Specified column (" + columns[i] + ") not found");
        }
        _columnIndexes = columns.map(function(columnName) {
            return _columnNames.indexOf(columnName);
        });
    }
    if (ndFrame instanceof $2430224f797fca68$var$series_1.default) {
        var newData = [];
        var newIndex = [];
        for(var i = 0; i < _rowIndexes.length; i++){
            var rowIndx = _rowIndexes[i];
            newData.push(_data[rowIndx]);
            newIndex.push(_index[rowIndx]);
        }
        var sf = new $2430224f797fca68$var$series_1.default(newData, {
            index: newIndex,
            columns: ndFrame.columns,
            dtypes: ndFrame.dtypes,
            config: ndFrame.config
        });
        return sf;
    } else {
        var newData = [];
        var newIndex = [];
        var newColumnNames = [];
        var newDtypes = [];
        for(var i = 0; i < _rowIndexes.length; i++){
            var rowIndx = _rowIndexes[i];
            var rowData = _data[rowIndx];
            var newRowDataWithRequiredCols = [];
            for(var j = 0; j < _columnIndexes.length; j++){
                var colIndx = _columnIndexes[j];
                newRowDataWithRequiredCols.push(rowData[colIndx]);
            }
            newData.push(newRowDataWithRequiredCols);
            newIndex.push(_index[rowIndx]);
        }
        for(var i = 0; i < _columnIndexes.length; i++){
            var colIndx = _columnIndexes[i];
            newColumnNames.push(ndFrame.columns[colIndx]);
            newDtypes.push(ndFrame.dtypes[colIndx]);
        }
        var df = new $2430224f797fca68$var$frame_1.default(newData, {
            index: newIndex,
            columns: newColumnNames,
            dtypes: newDtypes,
            config: ndFrame.config
        });
        return df;
    }
}
module.exports._loc = $2430224f797fca68$var$_loc;

});

parcelRegister("4qjR5", function(module, exports) {
"use strict";
var $3388fdf3527d0719$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3388fdf3527d0719$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3388fdf3527d0719$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBorderCharacters = module.exports.createStream = module.exports.table = void 0;

var $29Id6 = parcelRequire("29Id6");
Object.defineProperty(module.exports, "createStream", {
    enumerable: true,
    get: function() {
        return $29Id6.createStream;
    }
});

var $gYvPu = parcelRequire("gYvPu");
Object.defineProperty(module.exports, "getBorderCharacters", {
    enumerable: true,
    get: function() {
        return $gYvPu.getBorderCharacters;
    }
});

var $9adaX = parcelRequire("9adaX");
Object.defineProperty(module.exports, "table", {
    enumerable: true,
    get: function() {
        return $9adaX.table;
    }
});

$3388fdf3527d0719$var$__exportStar((parcelRequire("7mBHe")), module.exports);

});
parcelRegister("29Id6", function(module, exports) {

var $4Jj9n = parcelRequire("4Jj9n");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createStream = void 0;

var $rEdea = parcelRequire("rEdea");

var $1Ld2N = parcelRequire("1Ld2N");

var $k4NxI = parcelRequire("k4NxI");

var $kQHic = parcelRequire("kQHic");

var $kuOrd = parcelRequire("kuOrd");

var $dxIRG = parcelRequire("dxIRG");

var $apKKk = parcelRequire("apKKk");

var $2xaoB = parcelRequire("2xaoB");

var $4igab = parcelRequire("4igab");
const $191eb745155142f6$var$prepareData = (data, config)=>{
    let rows = $2xaoB.stringifyTableData(data);
    rows = $4igab.truncateTableData(rows, config);
    const rowHeights = $1Ld2N.calculateRowHeights(rows, config);
    rows = $dxIRG.mapDataUsingRowHeights(rows, rowHeights, config);
    rows = $rEdea.alignTableData(rows, config);
    rows = $apKKk.padTableData(rows, config);
    return rows;
};
const $191eb745155142f6$var$create = (row, columnWidths, config)=>{
    const rows = $191eb745155142f6$var$prepareData([
        row
    ], config);
    const body = rows.map((literalRow)=>{
        return $kQHic.drawRow(literalRow, config);
    }).join('');
    let output;
    output = '';
    output += $k4NxI.drawBorderTop(columnWidths, config);
    output += body;
    output += $k4NxI.drawBorderBottom(columnWidths, config);
    output = output.trimEnd();
    $4Jj9n.stdout.write(output);
};
const $191eb745155142f6$var$append = (row, columnWidths, config)=>{
    const rows = $191eb745155142f6$var$prepareData([
        row
    ], config);
    const body = rows.map((literalRow)=>{
        return $kQHic.drawRow(literalRow, config);
    }).join('');
    let output = '';
    const bottom = $k4NxI.drawBorderBottom(columnWidths, config);
    if (bottom !== '\n') output = '\r\u001B[K';
    output += $k4NxI.drawBorderJoin(columnWidths, config);
    output += body;
    output += bottom;
    output = output.trimEnd();
    $4Jj9n.stdout.write(output);
};
const $191eb745155142f6$var$createStream = (userConfig)=>{
    const config = $kuOrd.makeStreamConfig(userConfig);
    const columnWidths = Object.values(config.columns).map((column)=>{
        return column.width + column.paddingLeft + column.paddingRight;
    });
    let empty = true;
    return {
        write: (row)=>{
            if (row.length !== config.columnCount) throw new Error('Row cell count does not match the config.columnCount.');
            if (empty) {
                empty = false;
                $191eb745155142f6$var$create(row, columnWidths, config);
            } else $191eb745155142f6$var$append(row, columnWidths, config);
        }
    };
};
module.exports.createStream = $191eb745155142f6$var$createStream;

});
parcelRegister("rEdea", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alignTableData = void 0;

var $hpX81 = parcelRequire("hpX81");
const $0531b710b10ac6fb$var$alignTableData = (rows, config)=>{
    return rows.map((row)=>{
        return row.map((cell, cellIndex)=>{
            const { width: width, alignment: alignment } = config.columns[cellIndex];
            return $hpX81.alignString(cell, width, alignment);
        });
    });
};
module.exports.alignTableData = $0531b710b10ac6fb$var$alignTableData;

});
parcelRegister("hpX81", function(module, exports) {
"use strict";
var $cae2a31cddfec263$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alignString = void 0;

const $cae2a31cddfec263$var$string_width_1 = $cae2a31cddfec263$var$__importDefault((parcelRequire("8be7k")));

var $9JRBw = parcelRequire("9JRBw");
const $cae2a31cddfec263$var$alignLeft = (subject, width)=>{
    return subject + ' '.repeat(width);
};
const $cae2a31cddfec263$var$alignRight = (subject, width)=>{
    return ' '.repeat(width) + subject;
};
const $cae2a31cddfec263$var$alignCenter = (subject, width)=>{
    return ' '.repeat(Math.floor(width / 2)) + subject + ' '.repeat(Math.ceil(width / 2));
};
const $cae2a31cddfec263$var$alignJustify = (subject, width)=>{
    const spaceSequenceCount = $9JRBw.countSpaceSequence(subject);
    if (spaceSequenceCount === 0) return $cae2a31cddfec263$var$alignLeft(subject, width);
    const addingSpaces = $9JRBw.distributeUnevenly(width, spaceSequenceCount);
    if (Math.max(...addingSpaces) > 3) return $cae2a31cddfec263$var$alignLeft(subject, width);
    let spaceSequenceIndex = 0;
    return subject.replace(/\s+/g, (groupSpace)=>{
        return groupSpace + ' '.repeat(addingSpaces[spaceSequenceIndex++]);
    });
};
/**
 * Pads a string to the left and/or right to position the subject
 * text in a desired alignment within a container.
 */ const $cae2a31cddfec263$var$alignString = (subject, containerWidth, alignment)=>{
    const subjectWidth = $cae2a31cddfec263$var$string_width_1.default(subject);
    if (subjectWidth === containerWidth) return subject;
    if (subjectWidth > containerWidth) throw new Error('Subject parameter value width cannot be greater than the container width.');
    if (subjectWidth === 0) return ' '.repeat(containerWidth);
    const availableWidth = containerWidth - subjectWidth;
    if (alignment === 'left') return $cae2a31cddfec263$var$alignLeft(subject, availableWidth);
    if (alignment === 'right') return $cae2a31cddfec263$var$alignRight(subject, availableWidth);
    if (alignment === 'justify') return $cae2a31cddfec263$var$alignJustify(subject, availableWidth);
    return $cae2a31cddfec263$var$alignCenter(subject, availableWidth);
};
module.exports.alignString = $cae2a31cddfec263$var$alignString;

});
parcelRegister("8be7k", function(module, exports) {
'use strict';

var $aLnyn = parcelRequire("aLnyn");

var $fJl99 = parcelRequire("fJl99");

var $7etu1 = parcelRequire("7etu1");
const $018974db8d4018f9$var$stringWidth = (string)=>{
    if (typeof string !== 'string' || string.length === 0) return 0;
    string = $aLnyn(string);
    if (string.length === 0) return 0;
    string = string.replace($7etu1(), '  ');
    let width = 0;
    for(let i = 0; i < string.length; i++){
        const code = string.codePointAt(i);
        // Ignore control characters
        if (code <= 0x1F || code >= 0x7F && code <= 0x9F) continue;
        // Ignore combining characters
        if (code >= 0x300 && code <= 0x36F) continue;
        // Surrogates
        if (code > 0xFFFF) i++;
        width += $fJl99(code) ? 2 : 1;
    }
    return width;
};
module.exports = $018974db8d4018f9$var$stringWidth;
// TODO: remove this in the next major version
module.exports.default = $018974db8d4018f9$var$stringWidth;

});
parcelRegister("aLnyn", function(module, exports) {
'use strict';

var $6Njxp = parcelRequire("6Njxp");
module.exports = (string)=>typeof string === 'string' ? string.replace($6Njxp(), '') : string;

});
parcelRegister("6Njxp", function(module, exports) {
'use strict';
module.exports = ({ onlyFirst: onlyFirst = false } = {})=>{
    const pattern = [
        '[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)',
        '(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))'
    ].join('|');
    return new RegExp(pattern, onlyFirst ? undefined : 'g');
};

});


parcelRegister("fJl99", function(module, exports) {
/* eslint-disable yoda */ 'use strict';
const $b73b764583d5589f$var$isFullwidthCodePoint = (codePoint)=>{
    if (Number.isNaN(codePoint)) return false;
    // Code points are derived from:
    // http://www.unix.org/Public/UNIDATA/EastAsianWidth.txt
    if (codePoint >= 0x1100 && (codePoint <= 0x115F || // Hangul Jamo
    codePoint === 0x2329 || // LEFT-POINTING ANGLE BRACKET
    codePoint === 0x232A || // RIGHT-POINTING ANGLE BRACKET
    // CJK Radicals Supplement .. Enclosed CJK Letters and Months
    0x2E80 <= codePoint && codePoint <= 0x3247 && codePoint !== 0x303F || // Enclosed CJK Letters and Months .. CJK Unified Ideographs Extension A
    0x3250 <= codePoint && codePoint <= 0x4DBF || // CJK Unified Ideographs .. Yi Radicals
    0x4E00 <= codePoint && codePoint <= 0xA4C6 || // Hangul Jamo Extended-A
    0xA960 <= codePoint && codePoint <= 0xA97C || // Hangul Syllables
    0xAC00 <= codePoint && codePoint <= 0xD7A3 || // CJK Compatibility Ideographs
    0xF900 <= codePoint && codePoint <= 0xFAFF || // Vertical Forms
    0xFE10 <= codePoint && codePoint <= 0xFE19 || // CJK Compatibility Forms .. Small Form Variants
    0xFE30 <= codePoint && codePoint <= 0xFE6B || // Halfwidth and Fullwidth Forms
    0xFF01 <= codePoint && codePoint <= 0xFF60 || 0xFFE0 <= codePoint && codePoint <= 0xFFE6 || // Kana Supplement
    0x1B000 <= codePoint && codePoint <= 0x1B001 || // Enclosed Ideographic Supplement
    0x1F200 <= codePoint && codePoint <= 0x1F251 || // CJK Unified Ideographs Extension B .. Tertiary Ideographic Plane
    0x20000 <= codePoint && codePoint <= 0x3FFFD)) return true;
    return false;
};
module.exports = $b73b764583d5589f$var$isFullwidthCodePoint;
module.exports.default = $b73b764583d5589f$var$isFullwidthCodePoint;

});

parcelRegister("7etu1", function(module, exports) {
"use strict";
module.exports = function() {
    // https://mths.be/emoji
    return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
};

});


parcelRegister("9JRBw", function(module, exports) {
"use strict";
var $7171e5aefab2dbb4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.distributeUnevenly = module.exports.countSpaceSequence = module.exports.groupBySizes = module.exports.makeBorderConfig = module.exports.splitAnsi = module.exports.normalizeString = void 0;

const $7171e5aefab2dbb4$var$slice_ansi_1 = $7171e5aefab2dbb4$var$__importDefault((parcelRequire("lELeW")));

const $7171e5aefab2dbb4$var$string_width_1 = $7171e5aefab2dbb4$var$__importDefault((parcelRequire("8be7k")));

const $7171e5aefab2dbb4$var$strip_ansi_1 = $7171e5aefab2dbb4$var$__importDefault((parcelRequire("aLnyn")));

var $gYvPu = parcelRequire("gYvPu");
/**
 * Converts Windows-style newline to Unix-style
 *
 * @internal
 */ const $7171e5aefab2dbb4$var$normalizeString = (input)=>{
    return input.replace(/\r\n/g, '\n');
};
module.exports.normalizeString = $7171e5aefab2dbb4$var$normalizeString;
/**
 * Splits ansi string by newlines
 *
 * @internal
 */ const $7171e5aefab2dbb4$var$splitAnsi = (input)=>{
    const lengths = $7171e5aefab2dbb4$var$strip_ansi_1.default(input).split('\n').map($7171e5aefab2dbb4$var$string_width_1.default);
    const result = [];
    let startIndex = 0;
    lengths.forEach((length)=>{
        result.push(length === 0 ? '' : $7171e5aefab2dbb4$var$slice_ansi_1.default(input, startIndex, startIndex + length));
        // Plus 1 for the newline character itself
        startIndex += length + 1;
    });
    return result;
};
module.exports.splitAnsi = $7171e5aefab2dbb4$var$splitAnsi;
/**
 * Merges user provided border characters with the default border ("honeywell") characters.
 *
 * @internal
 */ const $7171e5aefab2dbb4$var$makeBorderConfig = (border)=>{
    return {
        ...$gYvPu.getBorderCharacters('honeywell'),
        ...border
    };
};
module.exports.makeBorderConfig = $7171e5aefab2dbb4$var$makeBorderConfig;
/**
 * Groups the array into sub-arrays by sizes.
 *
 * @internal
 * @example
 * groupBySizes(['a', 'b', 'c', 'd', 'e'], [2, 1, 2]) = [ ['a', 'b'], ['c'], ['d', 'e'] ]
 */ const $7171e5aefab2dbb4$var$groupBySizes = (array, sizes)=>{
    let startIndex = 0;
    return sizes.map((size)=>{
        const group = array.slice(startIndex, startIndex + size);
        startIndex += size;
        return group;
    });
};
module.exports.groupBySizes = $7171e5aefab2dbb4$var$groupBySizes;
/**
 * Counts the number of continuous spaces in a string
 *
 * @internal
 * @example
 * countGroupSpaces('a  bc  de f') = 3
 */ const $7171e5aefab2dbb4$var$countSpaceSequence = (input)=>{
    var _a, _b;
    return (_b = (_a = input.match(/\s+/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
};
module.exports.countSpaceSequence = $7171e5aefab2dbb4$var$countSpaceSequence;
/**
 * Creates the non-increasing number array given sum and length
 * whose the difference between maximum and minimum is not greater than 1
 *
 * @internal
 * @example
 * distributeUnevenly(6, 3) = [2, 2, 2]
 * distributeUnevenly(8, 3) = [3, 3, 2]
 */ const $7171e5aefab2dbb4$var$distributeUnevenly = (sum, length)=>{
    const result = Array.from({
        length: length
    }).fill(Math.floor(sum / length));
    return result.map((element, index)=>{
        return element + (index < sum % length ? 1 : 0);
    });
};
module.exports.distributeUnevenly = $7171e5aefab2dbb4$var$distributeUnevenly;

});
parcelRegister("lELeW", function(module, exports) {
'use strict';

var $fJl99 = parcelRequire("fJl99");

var $akY1q = parcelRequire("akY1q");

var $ivEGA = parcelRequire("ivEGA");
const $fc41fa4df1d54742$var$ESCAPES = [
    '\u001B',
    '\u009B'
];
const $fc41fa4df1d54742$var$wrapAnsi = (code)=>`${$fc41fa4df1d54742$var$ESCAPES[0]}[${code}m`;
const $fc41fa4df1d54742$var$checkAnsi = (ansiCodes, isEscapes, endAnsiCode)=>{
    let output = [];
    ansiCodes = [
        ...ansiCodes
    ];
    for (let ansiCode of ansiCodes){
        const ansiCodeOrigin = ansiCode;
        if (ansiCode.includes(';')) ansiCode = ansiCode.split(';')[0][0] + '0';
        const item = $ivEGA.codes.get(Number.parseInt(ansiCode, 10));
        if (item) {
            const indexEscape = ansiCodes.indexOf(item.toString());
            if (indexEscape === -1) output.push($fc41fa4df1d54742$var$wrapAnsi(isEscapes ? item : ansiCodeOrigin));
            else ansiCodes.splice(indexEscape, 1);
        } else if (isEscapes) {
            output.push($fc41fa4df1d54742$var$wrapAnsi(0));
            break;
        } else output.push($fc41fa4df1d54742$var$wrapAnsi(ansiCodeOrigin));
    }
    if (isEscapes) {
        output = output.filter((element, index)=>output.indexOf(element) === index);
        if (endAnsiCode !== undefined) {
            const fistEscapeCode = $fc41fa4df1d54742$var$wrapAnsi($ivEGA.codes.get(Number.parseInt(endAnsiCode, 10)));
            output = output.reduce((current, next)=>next === fistEscapeCode ? [
                    next,
                    ...current
                ] : [
                    ...current,
                    next
                ], []);
        }
    }
    return output.join('');
};
module.exports = (string, begin, end)=>{
    const characters = [
        ...string
    ];
    const ansiCodes = [];
    let stringEnd = typeof end === 'number' ? end : characters.length;
    let isInsideEscape = false;
    let ansiCode;
    let visible = 0;
    let output = '';
    for (const [index, character] of characters.entries()){
        let leftEscape = false;
        if ($fc41fa4df1d54742$var$ESCAPES.includes(character)) {
            const code = /\d[^m]*/.exec(string.slice(index, index + 18));
            ansiCode = code && code.length > 0 ? code[0] : undefined;
            if (visible < stringEnd) {
                isInsideEscape = true;
                if (ansiCode !== undefined) ansiCodes.push(ansiCode);
            }
        } else if (isInsideEscape && character === 'm') {
            isInsideEscape = false;
            leftEscape = true;
        }
        if (!isInsideEscape && !leftEscape) visible++;
        if (!$akY1q({
            exact: true
        }).test(character) && $fJl99(character.codePointAt())) {
            visible++;
            if (typeof end !== 'number') stringEnd++;
        }
        if (visible > begin && visible <= stringEnd) output += character;
        else if (visible === begin && !isInsideEscape && ansiCode !== undefined) output = $fc41fa4df1d54742$var$checkAnsi(ansiCodes);
        else if (visible >= stringEnd) {
            output += $fc41fa4df1d54742$var$checkAnsi(ansiCodes, true, ansiCode);
            break;
        }
    }
    return output;
};

});
parcelRegister("akY1q", function(module, exports) {
'use strict';
const $786a54bf0cdc7eff$var$regex = '[\uD800-\uDBFF][\uDC00-\uDFFF]';
const $786a54bf0cdc7eff$var$astralRegex = (options)=>options && options.exact ? new RegExp(`^${$786a54bf0cdc7eff$var$regex}$`) : new RegExp($786a54bf0cdc7eff$var$regex, 'g');
module.exports = $786a54bf0cdc7eff$var$astralRegex;

});

parcelRegister("ivEGA", function(module, exports) {
'use strict';
const wrapAnsi16 = (fn, offset)=>(...args)=>{
        const code = fn(...args);
        return `\u001B[${code + offset}m`;
    };
const wrapAnsi256 = (fn, offset)=>(...args)=>{
        const code = fn(...args);
        return `\u001B[${38 + offset};5;${code}m`;
    };
const wrapAnsi16m = (fn, offset)=>(...args)=>{
        const rgb = fn(...args);
        return `\u001B[${38 + offset};2;${rgb[0]};${rgb[1]};${rgb[2]}m`;
    };
const ansi2ansi = (n)=>n;
const rgb2rgb = (r, g, b)=>[
        r,
        g,
        b
    ];
const setLazyProperty = (object, property, get)=>{
    Object.defineProperty(object, property, {
        get: ()=>{
            const value = get();
            Object.defineProperty(object, property, {
                value: value,
                enumerable: true,
                configurable: true
            });
            return value;
        },
        enumerable: true,
        configurable: true
    });
};
/** @type {typeof import('color-convert')} */ let colorConvert;

const makeDynamicStyles = (wrap, targetSpace, identity, isBackground)=>{
    if (colorConvert === undefined) colorConvert = (parcelRequire("3JNfW"));
    const offset = isBackground ? 10 : 0;
    const styles = {};
    for (const [sourceSpace, suite] of Object.entries(colorConvert)){
        const name = sourceSpace === 'ansi16' ? 'ansi' : sourceSpace;
        if (sourceSpace === targetSpace) styles[name] = wrap(identity, offset);
        else if (typeof suite === 'object') styles[name] = wrap(suite[targetSpace], offset);
    }
    return styles;
};
function assembleStyles() {
    const codes = new Map();
    const styles = {
        modifier: {
            reset: [
                0,
                0
            ],
            // 21 isn't widely supported and 22 does the same thing
            bold: [
                1,
                22
            ],
            dim: [
                2,
                22
            ],
            italic: [
                3,
                23
            ],
            underline: [
                4,
                24
            ],
            inverse: [
                7,
                27
            ],
            hidden: [
                8,
                28
            ],
            strikethrough: [
                9,
                29
            ]
        },
        color: {
            black: [
                30,
                39
            ],
            red: [
                31,
                39
            ],
            green: [
                32,
                39
            ],
            yellow: [
                33,
                39
            ],
            blue: [
                34,
                39
            ],
            magenta: [
                35,
                39
            ],
            cyan: [
                36,
                39
            ],
            white: [
                37,
                39
            ],
            // Bright color
            blackBright: [
                90,
                39
            ],
            redBright: [
                91,
                39
            ],
            greenBright: [
                92,
                39
            ],
            yellowBright: [
                93,
                39
            ],
            blueBright: [
                94,
                39
            ],
            magentaBright: [
                95,
                39
            ],
            cyanBright: [
                96,
                39
            ],
            whiteBright: [
                97,
                39
            ]
        },
        bgColor: {
            bgBlack: [
                40,
                49
            ],
            bgRed: [
                41,
                49
            ],
            bgGreen: [
                42,
                49
            ],
            bgYellow: [
                43,
                49
            ],
            bgBlue: [
                44,
                49
            ],
            bgMagenta: [
                45,
                49
            ],
            bgCyan: [
                46,
                49
            ],
            bgWhite: [
                47,
                49
            ],
            // Bright color
            bgBlackBright: [
                100,
                49
            ],
            bgRedBright: [
                101,
                49
            ],
            bgGreenBright: [
                102,
                49
            ],
            bgYellowBright: [
                103,
                49
            ],
            bgBlueBright: [
                104,
                49
            ],
            bgMagentaBright: [
                105,
                49
            ],
            bgCyanBright: [
                106,
                49
            ],
            bgWhiteBright: [
                107,
                49
            ]
        }
    };
    // Alias bright black as gray (and grey)
    styles.color.gray = styles.color.blackBright;
    styles.bgColor.bgGray = styles.bgColor.bgBlackBright;
    styles.color.grey = styles.color.blackBright;
    styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;
    for (const [groupName, group] of Object.entries(styles)){
        for (const [styleName, style] of Object.entries(group)){
            styles[styleName] = {
                open: `\u001B[${style[0]}m`,
                close: `\u001B[${style[1]}m`
            };
            group[styleName] = styles[styleName];
            codes.set(style[0], style[1]);
        }
        Object.defineProperty(styles, groupName, {
            value: group,
            enumerable: false
        });
    }
    Object.defineProperty(styles, 'codes', {
        value: codes,
        enumerable: false
    });
    styles.color.close = '\u001B[39m';
    styles.bgColor.close = '\u001B[49m';
    setLazyProperty(styles.color, 'ansi', ()=>makeDynamicStyles(wrapAnsi16, 'ansi16', ansi2ansi, false));
    setLazyProperty(styles.color, 'ansi256', ()=>makeDynamicStyles(wrapAnsi256, 'ansi256', ansi2ansi, false));
    setLazyProperty(styles.color, 'ansi16m', ()=>makeDynamicStyles(wrapAnsi16m, 'rgb', rgb2rgb, false));
    setLazyProperty(styles.bgColor, 'ansi', ()=>makeDynamicStyles(wrapAnsi16, 'ansi16', ansi2ansi, true));
    setLazyProperty(styles.bgColor, 'ansi256', ()=>makeDynamicStyles(wrapAnsi256, 'ansi256', ansi2ansi, true));
    setLazyProperty(styles.bgColor, 'ansi16m', ()=>makeDynamicStyles(wrapAnsi16m, 'rgb', rgb2rgb, true));
    return styles;
}
// Make the export immutable
Object.defineProperty(module, 'exports', {
    enumerable: true,
    get: assembleStyles
});

});
parcelRegister("3JNfW", function(module, exports) {

var $34eeA = parcelRequire("34eeA");

var $lIrBP = parcelRequire("lIrBP");
const $2b8bc8511c5c8bbe$var$convert = {};
const $2b8bc8511c5c8bbe$var$models = Object.keys($34eeA);
function $2b8bc8511c5c8bbe$var$wrapRaw(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $2b8bc8511c5c8bbe$var$wrapRounded(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        const result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === 'object') for(let len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$2b8bc8511c5c8bbe$var$models.forEach((fromModel)=>{
    $2b8bc8511c5c8bbe$var$convert[fromModel] = {};
    Object.defineProperty($2b8bc8511c5c8bbe$var$convert[fromModel], 'channels', {
        value: $34eeA[fromModel].channels
    });
    Object.defineProperty($2b8bc8511c5c8bbe$var$convert[fromModel], 'labels', {
        value: $34eeA[fromModel].labels
    });
    const routes = $lIrBP(fromModel);
    const routeModels = Object.keys(routes);
    routeModels.forEach((toModel)=>{
        const fn = routes[toModel];
        $2b8bc8511c5c8bbe$var$convert[fromModel][toModel] = $2b8bc8511c5c8bbe$var$wrapRounded(fn);
        $2b8bc8511c5c8bbe$var$convert[fromModel][toModel].raw = $2b8bc8511c5c8bbe$var$wrapRaw(fn);
    });
});
module.exports = $2b8bc8511c5c8bbe$var$convert;

});
parcelRegister("34eeA", function(module, exports) {
/* MIT license */ /* eslint-disable no-mixed-operators */ 
var $iXgRS = parcelRequire("iXgRS");
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
const $23bcc96f08b27157$var$reverseKeywords = {};
for (const key of Object.keys($iXgRS))$23bcc96f08b27157$var$reverseKeywords[$iXgRS[key]] = key;
const $23bcc96f08b27157$var$convert = {
    rgb: {
        channels: 3,
        labels: 'rgb'
    },
    hsl: {
        channels: 3,
        labels: 'hsl'
    },
    hsv: {
        channels: 3,
        labels: 'hsv'
    },
    hwb: {
        channels: 3,
        labels: 'hwb'
    },
    cmyk: {
        channels: 4,
        labels: 'cmyk'
    },
    xyz: {
        channels: 3,
        labels: 'xyz'
    },
    lab: {
        channels: 3,
        labels: 'lab'
    },
    lch: {
        channels: 3,
        labels: 'lch'
    },
    hex: {
        channels: 1,
        labels: [
            'hex'
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            'keyword'
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            'ansi16'
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            'ansi256'
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            'h',
            'c',
            'g'
        ]
    },
    apple: {
        channels: 3,
        labels: [
            'r16',
            'g16',
            'b16'
        ]
    },
    gray: {
        channels: 1,
        labels: [
            'gray'
        ]
    }
};
module.exports = $23bcc96f08b27157$var$convert;
// Hide .channels and .labels properties
for (const model of Object.keys($23bcc96f08b27157$var$convert)){
    if (!('channels' in $23bcc96f08b27157$var$convert[model])) throw new Error('missing channels property: ' + model);
    if (!('labels' in $23bcc96f08b27157$var$convert[model])) throw new Error('missing channel labels property: ' + model);
    if ($23bcc96f08b27157$var$convert[model].labels.length !== $23bcc96f08b27157$var$convert[model].channels) throw new Error('channel and label counts mismatch: ' + model);
    const { channels: channels, labels: labels } = $23bcc96f08b27157$var$convert[model];
    delete $23bcc96f08b27157$var$convert[model].channels;
    delete $23bcc96f08b27157$var$convert[model].labels;
    Object.defineProperty($23bcc96f08b27157$var$convert[model], 'channels', {
        value: channels
    });
    Object.defineProperty($23bcc96f08b27157$var$convert[model], 'labels', {
        value: labels
    });
}
$23bcc96f08b27157$var$convert.rgb.hsl = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const delta = max - min;
    let h;
    let s;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    const l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$23bcc96f08b27157$var$convert.rgb.hsv = function(rgb) {
    let rdif;
    let gdif;
    let bdif;
    let h;
    let s;
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const v = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$23bcc96f08b27157$var$convert.rgb.hwb = function(rgb) {
    const r = rgb[0];
    const g = rgb[1];
    let b = rgb[2];
    const h = $23bcc96f08b27157$var$convert.rgb.hsl(rgb)[0];
    const w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$23bcc96f08b27157$var$convert.rgb.cmyk = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const k = Math.min(1 - r, 1 - g, 1 - b);
    const c = (1 - r - k) / (1 - k) || 0;
    const m = (1 - g - k) / (1 - k) || 0;
    const y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $23bcc96f08b27157$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
$23bcc96f08b27157$var$convert.rgb.keyword = function(rgb) {
    const reversed = $23bcc96f08b27157$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    let currentClosestDistance = Infinity;
    let currentClosestKeyword;
    for (const keyword of Object.keys($iXgRS)){
        const value = $iXgRS[keyword];
        // Compute comparative distance
        const distance = $23bcc96f08b27157$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$23bcc96f08b27157$var$convert.keyword.rgb = function(keyword) {
    return $iXgRS[keyword];
};
$23bcc96f08b27157$var$convert.rgb.xyz = function(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
    g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
    b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
    const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$23bcc96f08b27157$var$convert.rgb.lab = function(rgb) {
    const xyz = $23bcc96f08b27157$var$convert.rgb.xyz(rgb);
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$23bcc96f08b27157$var$convert.hsl.rgb = function(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    let t2;
    let t3;
    let val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    const t1 = 2 * l - t2;
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$23bcc96f08b27157$var$convert.hsl.hsv = function(hsl) {
    const h = hsl[0];
    let s = hsl[1] / 100;
    let l = hsl[2] / 100;
    let smin = s;
    const lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    const v = (l + s) / 2;
    const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$23bcc96f08b27157$var$convert.hsv.rgb = function(hsv) {
    const h = hsv[0] / 60;
    const s = hsv[1] / 100;
    let v = hsv[2] / 100;
    const hi = Math.floor(h) % 6;
    const f = h - Math.floor(h);
    const p = 255 * v * (1 - s);
    const q = 255 * v * (1 - s * f);
    const t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$23bcc96f08b27157$var$convert.hsv.hsl = function(hsv) {
    const h = hsv[0];
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const vmin = Math.max(v, 0.01);
    let sl;
    let l;
    l = (2 - s) * v;
    const lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$23bcc96f08b27157$var$convert.hwb.rgb = function(hwb) {
    const h = hwb[0] / 360;
    let wh = hwb[1] / 100;
    let bl = hwb[2] / 100;
    const ratio = wh + bl;
    let f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    const i = Math.floor(6 * h);
    const v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    const n = wh + f * (v - wh); // Linear interpolation
    let r;
    let g;
    let b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$23bcc96f08b27157$var$convert.cmyk.rgb = function(cmyk) {
    const c = cmyk[0] / 100;
    const m = cmyk[1] / 100;
    const y = cmyk[2] / 100;
    const k = cmyk[3] / 100;
    const r = 1 - Math.min(1, c * (1 - k) + k);
    const g = 1 - Math.min(1, m * (1 - k) + k);
    const b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$23bcc96f08b27157$var$convert.xyz.rgb = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    let r;
    let g;
    let b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * r ** (1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * g ** (1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * b ** (1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$23bcc96f08b27157$var$convert.xyz.lab = function(xyz) {
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$23bcc96f08b27157$var$convert.lab.xyz = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let x;
    let y;
    let z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    const y2 = y ** 3;
    const x2 = x ** 3;
    const z2 = z ** 3;
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$23bcc96f08b27157$var$convert.lab.lch = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let h;
    const hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    const c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$23bcc96f08b27157$var$convert.lch.lab = function(lch) {
    const l = lch[0];
    const c = lch[1];
    const h = lch[2];
    const hr = h / 360 * 2 * Math.PI;
    const a = c * Math.cos(hr);
    const b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$23bcc96f08b27157$var$convert.rgb.ansi16 = function(args, saturation = null) {
    const [r, g, b] = args;
    let value = saturation === null ? $23bcc96f08b27157$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$23bcc96f08b27157$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $23bcc96f08b27157$var$convert.rgb.ansi16($23bcc96f08b27157$var$convert.hsv.rgb(args), args[2]);
};
$23bcc96f08b27157$var$convert.rgb.ansi256 = function(args) {
    const r = args[0];
    const g = args[1];
    const b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$23bcc96f08b27157$var$convert.ansi16.rgb = function(args) {
    let color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    const mult = (~~(args > 50) + 1) * 0.5;
    const r = (color & 1) * mult * 255;
    const g = (color >> 1 & 1) * mult * 255;
    const b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$23bcc96f08b27157$var$convert.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        const c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    let rem;
    const r = Math.floor(args / 36) / 5 * 255;
    const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    const b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$23bcc96f08b27157$var$convert.rgb.hex = function(args) {
    const integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    const string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
$23bcc96f08b27157$var$convert.hex.rgb = function(args) {
    const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    let colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split('').map((char)=>{
        return char + char;
    }).join('');
    const integer = parseInt(colorString, 16);
    const r = integer >> 16 & 0xFF;
    const g = integer >> 8 & 0xFF;
    const b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$23bcc96f08b27157$var$convert.rgb.hcg = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(Math.max(r, g), b);
    const min = Math.min(Math.min(r, g), b);
    const chroma = max - min;
    let grayscale;
    let hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$23bcc96f08b27157$var$convert.hsl.hcg = function(hsl) {
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    let f = 0;
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$23bcc96f08b27157$var$convert.hsv.hcg = function(hsv) {
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const c = s * v;
    let f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$23bcc96f08b27157$var$convert.hcg.rgb = function(hcg) {
    const h = hcg[0] / 360;
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    const pure = [
        0,
        0,
        0
    ];
    const hi = h % 1 * 6;
    const v = hi % 1;
    const w = 1 - v;
    let mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$23bcc96f08b27157$var$convert.hcg.hsv = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    let f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$23bcc96f08b27157$var$convert.hcg.hsl = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const l = g * (1.0 - c) + 0.5 * c;
    let s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$23bcc96f08b27157$var$convert.hcg.hwb = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$23bcc96f08b27157$var$convert.hwb.hcg = function(hwb) {
    const w = hwb[1] / 100;
    const b = hwb[2] / 100;
    const v = 1 - b;
    const c = v - w;
    let g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$23bcc96f08b27157$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$23bcc96f08b27157$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$23bcc96f08b27157$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$23bcc96f08b27157$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$23bcc96f08b27157$var$convert.gray.hsv = $23bcc96f08b27157$var$convert.gray.hsl;
$23bcc96f08b27157$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$23bcc96f08b27157$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$23bcc96f08b27157$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$23bcc96f08b27157$var$convert.gray.hex = function(gray) {
    const val = Math.round(gray[0] / 100 * 255) & 0xFF;
    const integer = (val << 16) + (val << 8) + val;
    const string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
$23bcc96f08b27157$var$convert.rgb.gray = function(rgb) {
    const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};

});
parcelRegister("iXgRS", function(module, exports) {
'use strict';
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

});


parcelRegister("lIrBP", function(module, exports) {

var $34eeA = parcelRequire("34eeA");
/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $fcf31fa4f4290ffc$var$buildGraph() {
    const graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    const models = Object.keys($34eeA);
    for(let len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $fcf31fa4f4290ffc$var$deriveBFS(fromModel) {
    const graph = $fcf31fa4f4290ffc$var$buildGraph();
    const queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        const current = queue.pop();
        const adjacents = Object.keys($34eeA[current]);
        for(let len = adjacents.length, i = 0; i < len; i++){
            const adjacent = adjacents[i];
            const node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $fcf31fa4f4290ffc$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $fcf31fa4f4290ffc$var$wrapConversion(toModel, graph) {
    const path = [
        graph[toModel].parent,
        toModel
    ];
    let fn = $34eeA[graph[toModel].parent][toModel];
    let cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $fcf31fa4f4290ffc$var$link($34eeA[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
module.exports = function(fromModel) {
    const graph = $fcf31fa4f4290ffc$var$deriveBFS(fromModel);
    const conversion = {};
    const models = Object.keys(graph);
    for(let len = models.length, i = 0; i < len; i++){
        const toModel = models[i];
        const node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $fcf31fa4f4290ffc$var$wrapConversion(toModel, graph);
    }
    return conversion;
};

});




parcelRegister("gYvPu", function(module, exports) {
"use strict";
/* eslint-disable sort-keys-fix/sort-keys-fix */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBorderCharacters = void 0;
const $c5baf0a2039f01dd$var$getBorderCharacters = (name)=>{
    if (name === 'honeywell') return {
        topBody: "\u2550",
        topJoin: "\u2564",
        topLeft: "\u2554",
        topRight: "\u2557",
        bottomBody: "\u2550",
        bottomJoin: "\u2567",
        bottomLeft: "\u255A",
        bottomRight: "\u255D",
        bodyLeft: "\u2551",
        bodyRight: "\u2551",
        bodyJoin: "\u2502",
        headerJoin: "\u252C",
        joinBody: "\u2500",
        joinLeft: "\u255F",
        joinRight: "\u2562",
        joinJoin: "\u253C"
    };
    if (name === 'norc') return {
        topBody: "\u2500",
        topJoin: "\u252C",
        topLeft: "\u250C",
        topRight: "\u2510",
        bottomBody: "\u2500",
        bottomJoin: "\u2534",
        bottomLeft: "\u2514",
        bottomRight: "\u2518",
        bodyLeft: "\u2502",
        bodyRight: "\u2502",
        bodyJoin: "\u2502",
        headerJoin: "\u252C",
        joinBody: "\u2500",
        joinLeft: "\u251C",
        joinRight: "\u2524",
        joinJoin: "\u253C"
    };
    if (name === 'ramac') return {
        topBody: '-',
        topJoin: '+',
        topLeft: '+',
        topRight: '+',
        bottomBody: '-',
        bottomJoin: '+',
        bottomLeft: '+',
        bottomRight: '+',
        bodyLeft: '|',
        bodyRight: '|',
        bodyJoin: '|',
        headerJoin: '+',
        joinBody: '-',
        joinLeft: '|',
        joinRight: '|',
        joinJoin: '|'
    };
    if (name === 'void') return {
        topBody: '',
        topJoin: '',
        topLeft: '',
        topRight: '',
        bottomBody: '',
        bottomJoin: '',
        bottomLeft: '',
        bottomRight: '',
        bodyLeft: '',
        bodyRight: '',
        bodyJoin: '',
        headerJoin: '',
        joinBody: '',
        joinLeft: '',
        joinRight: '',
        joinJoin: ''
    };
    throw new Error('Unknown border template "' + name + '".');
};
module.exports.getBorderCharacters = $c5baf0a2039f01dd$var$getBorderCharacters;

});




parcelRegister("1Ld2N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateRowHeights = void 0;

var $ejgVe = parcelRequire("ejgVe");
/**
 * Produces an array of values that describe the largest value length (height) in every row.
 */ const $14844c82ca93ff20$var$calculateRowHeights = (rows, config)=>{
    return rows.map((row)=>{
        let rowHeight = 1;
        row.forEach((cell, cellIndex)=>{
            const cellHeight = $ejgVe.calculateCellHeight(cell, config.columns[cellIndex].width, config.columns[cellIndex].wrapWord);
            rowHeight = Math.max(rowHeight, cellHeight);
        });
        return rowHeight;
    });
};
module.exports.calculateRowHeights = $14844c82ca93ff20$var$calculateRowHeights;

});
parcelRegister("ejgVe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateCellHeight = void 0;

var $luZCz = parcelRequire("luZCz");
/**
 * Calculates height of cell content in regard to its width and word wrapping.
 */ const $a6aff767e39d2b08$var$calculateCellHeight = (value, columnWidth, useWrapWord = false)=>{
    return $luZCz.wrapCell(value, columnWidth, useWrapWord).length;
};
module.exports.calculateCellHeight = $a6aff767e39d2b08$var$calculateCellHeight;

});
parcelRegister("luZCz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wrapCell = void 0;

var $9JRBw = parcelRequire("9JRBw");

var $f762q = parcelRequire("f762q");

var $i4tiZ = parcelRequire("i4tiZ");
/**
 * Wrap a single cell value into a list of lines
 *
 * Always wraps on newlines, for the remainder uses either word or string wrapping
 * depending on user configuration.
 *
 */ const $fa6c32f790feba23$var$wrapCell = (cellValue, cellWidth, useWrapWord)=>{
    // First split on literal newlines
    const cellLines = $9JRBw.splitAnsi(cellValue);
    // Then iterate over the list and word-wrap every remaining line if necessary.
    for(let lineNr = 0; lineNr < cellLines.length;){
        let lineChunks;
        if (useWrapWord) lineChunks = $i4tiZ.wrapWord(cellLines[lineNr], cellWidth);
        else lineChunks = $f762q.wrapString(cellLines[lineNr], cellWidth);
        // Replace our original array element with whatever the wrapping returned
        cellLines.splice(lineNr, 1, ...lineChunks);
        lineNr += lineChunks.length;
    }
    return cellLines;
};
module.exports.wrapCell = $fa6c32f790feba23$var$wrapCell;

});
parcelRegister("f762q", function(module, exports) {
"use strict";
var $b00c31818c4f927a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wrapString = void 0;

const $b00c31818c4f927a$var$slice_ansi_1 = $b00c31818c4f927a$var$__importDefault((parcelRequire("lELeW")));

const $b00c31818c4f927a$var$string_width_1 = $b00c31818c4f927a$var$__importDefault((parcelRequire("8be7k")));
/**
 * Creates an array of strings split into groups the length of size.
 * This function works with strings that contain ASCII characters.
 *
 * wrapText is different from would-be "chunk" implementation
 * in that whitespace characters that occur on a chunk size limit are trimmed.
 *
 */ const $b00c31818c4f927a$var$wrapString = (subject, size)=>{
    let subjectSlice = subject;
    const chunks = [];
    do {
        chunks.push($b00c31818c4f927a$var$slice_ansi_1.default(subjectSlice, 0, size));
        subjectSlice = $b00c31818c4f927a$var$slice_ansi_1.default(subjectSlice, size).trim();
    }while ($b00c31818c4f927a$var$string_width_1.default(subjectSlice));
    return chunks;
};
module.exports.wrapString = $b00c31818c4f927a$var$wrapString;

});

parcelRegister("i4tiZ", function(module, exports) {
"use strict";
var $d27f55290dac8e3d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wrapWord = void 0;

const $d27f55290dac8e3d$var$slice_ansi_1 = $d27f55290dac8e3d$var$__importDefault((parcelRequire("lELeW")));

const $d27f55290dac8e3d$var$strip_ansi_1 = $d27f55290dac8e3d$var$__importDefault((parcelRequire("aLnyn")));
const $d27f55290dac8e3d$var$calculateStringLengths = (input, size)=>{
    let subject = $d27f55290dac8e3d$var$strip_ansi_1.default(input);
    const chunks = [];
    // https://regex101.com/r/gY5kZ1/1
    const re = new RegExp('(^.{1,' + String(size) + '}(\\s+|$))|(^.{1,' + String(size - 1) + '}(\\\\|/|_|\\.|,|;|-))');
    do {
        let chunk;
        const match = re.exec(subject);
        if (match) {
            chunk = match[0];
            subject = subject.slice(chunk.length);
            const trimmedLength = chunk.trim().length;
            const offset = chunk.length - trimmedLength;
            chunks.push([
                trimmedLength,
                offset
            ]);
        } else {
            chunk = subject.slice(0, size);
            subject = subject.slice(size);
            chunks.push([
                chunk.length,
                0
            ]);
        }
    }while (subject.length);
    return chunks;
};
const $d27f55290dac8e3d$var$wrapWord = (input, size)=>{
    const result = [];
    let startIndex = 0;
    $d27f55290dac8e3d$var$calculateStringLengths(input, size).forEach(([length, offset])=>{
        result.push($d27f55290dac8e3d$var$slice_ansi_1.default(input, startIndex, startIndex + length));
        startIndex += length + offset;
    });
    return result;
};
module.exports.wrapWord = $d27f55290dac8e3d$var$wrapWord;

});




parcelRegister("k4NxI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.drawBorderTop = module.exports.drawBorderJoin = module.exports.drawBorderBottom = module.exports.drawBorder = module.exports.createTableBorderGetter = void 0;

var $4Cfi3 = parcelRequire("4Cfi3");
const $e9da9c85c5c50659$var$drawBorder = (columnWidths, config)=>{
    const { separator: separator, drawVerticalLine: drawVerticalLine } = config;
    const columns = columnWidths.map((size)=>{
        return config.separator.body.repeat(size);
    });
    return $4Cfi3.drawContent(columns, {
        drawSeparator: drawVerticalLine,
        separatorGetter: (index, columnCount)=>{
            if (index === 0) return separator.left;
            if (index === columnCount) return separator.right;
            return separator.join;
        }
    }) + '\n';
};
module.exports.drawBorder = $e9da9c85c5c50659$var$drawBorder;
const $e9da9c85c5c50659$var$drawBorderTop = (columnWidths, config)=>{
    const result = $e9da9c85c5c50659$var$drawBorder(columnWidths, {
        ...config,
        separator: {
            body: config.border.topBody,
            join: config.border.topJoin,
            left: config.border.topLeft,
            right: config.border.topRight
        }
    });
    if (result === '\n') return '';
    return result;
};
module.exports.drawBorderTop = $e9da9c85c5c50659$var$drawBorderTop;
const $e9da9c85c5c50659$var$drawBorderJoin = (columnWidths, config)=>{
    return $e9da9c85c5c50659$var$drawBorder(columnWidths, {
        ...config,
        separator: {
            body: config.border.joinBody,
            join: config.border.joinJoin,
            left: config.border.joinLeft,
            right: config.border.joinRight
        }
    });
};
module.exports.drawBorderJoin = $e9da9c85c5c50659$var$drawBorderJoin;
const $e9da9c85c5c50659$var$drawBorderBottom = (columnWidths, config)=>{
    return $e9da9c85c5c50659$var$drawBorder(columnWidths, {
        ...config,
        separator: {
            body: config.border.bottomBody,
            join: config.border.bottomJoin,
            left: config.border.bottomLeft,
            right: config.border.bottomRight
        }
    });
};
module.exports.drawBorderBottom = $e9da9c85c5c50659$var$drawBorderBottom;
const $e9da9c85c5c50659$var$createTableBorderGetter = (columnWidths, config)=>{
    return (index, size)=>{
        if (!config.header) {
            if (index === 0) return $e9da9c85c5c50659$var$drawBorderTop(columnWidths, config);
            if (index === size) return $e9da9c85c5c50659$var$drawBorderBottom(columnWidths, config);
            return $e9da9c85c5c50659$var$drawBorderJoin(columnWidths, config);
        }
        // Deal with the header
        if (index === 0) return $e9da9c85c5c50659$var$drawBorderTop(columnWidths, {
            ...config,
            border: {
                ...config.border,
                topJoin: config.border.topBody
            }
        });
        if (index === 1) return $e9da9c85c5c50659$var$drawBorderJoin(columnWidths, {
            ...config,
            border: {
                ...config.border,
                joinJoin: config.border.headerJoin
            }
        });
        if (index === size) return $e9da9c85c5c50659$var$drawBorderBottom(columnWidths, config);
        return $e9da9c85c5c50659$var$drawBorderJoin(columnWidths, config);
    };
};
module.exports.createTableBorderGetter = $e9da9c85c5c50659$var$createTableBorderGetter;

});
parcelRegister("4Cfi3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.drawContent = void 0;
/**
 * Shared function to draw horizontal borders, rows or the entire table
 */ const $35c6925d07a0c1a1$var$drawContent = (contents, separatorConfig)=>{
    const { separatorGetter: separatorGetter, drawSeparator: drawSeparator } = separatorConfig;
    const contentSize = contents.length;
    const result = [];
    if (drawSeparator(0, contentSize)) result.push(separatorGetter(0, contentSize));
    contents.forEach((content, contentIndex)=>{
        result.push(content);
        // Only append the middle separator if the content is not the last
        if (contentIndex + 1 < contentSize && drawSeparator(contentIndex + 1, contentSize)) result.push(separatorGetter(contentIndex + 1, contentSize));
    });
    if (drawSeparator(contentSize, contentSize)) result.push(separatorGetter(contentSize, contentSize));
    return result.join('');
};
module.exports.drawContent = $35c6925d07a0c1a1$var$drawContent;

});


parcelRegister("kQHic", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.drawRow = void 0;

var $4Cfi3 = parcelRequire("4Cfi3");
const $f2da3efcfa72f4f7$var$drawRow = (row, config)=>{
    const { border: border, drawVerticalLine: drawVerticalLine } = config;
    return $4Cfi3.drawContent(row, {
        drawSeparator: drawVerticalLine,
        separatorGetter: (index, columnCount)=>{
            if (index === 0) return border.bodyLeft;
            if (index === columnCount) return border.bodyRight;
            return border.bodyJoin;
        }
    }) + '\n';
};
module.exports.drawRow = $f2da3efcfa72f4f7$var$drawRow;

});

parcelRegister("kuOrd", function(module, exports) {
"use strict";
var $eebdbbefd49a2ee3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeStreamConfig = void 0;

const $eebdbbefd49a2ee3$var$lodash_clonedeep_1 = $eebdbbefd49a2ee3$var$__importDefault((parcelRequire("3vein")));

var $9JRBw = parcelRequire("9JRBw");

var $hjFj1 = parcelRequire("hjFj1");
/**
 * Creates a configuration for every column using default
 * values for the missing configuration properties.
 */ const $eebdbbefd49a2ee3$var$makeColumnsConfig = (columnCount, columns = {}, columnDefault)=>{
    return Array.from({
        length: columnCount
    }).map((_, index)=>{
        return {
            alignment: 'left',
            paddingLeft: 1,
            paddingRight: 1,
            truncate: Number.POSITIVE_INFINITY,
            verticalAlignment: 'top',
            wrapWord: false,
            ...columnDefault,
            ...columns[index]
        };
    });
};
/**
 * Makes a new configuration object out of the userConfig object
 * using default values for the missing configuration properties.
 */ const $eebdbbefd49a2ee3$var$makeStreamConfig = (userConfig)=>{
    $hjFj1.validateConfig('streamConfig.json', userConfig);
    const config = $eebdbbefd49a2ee3$var$lodash_clonedeep_1.default(userConfig);
    if (config.columnDefault.width === undefined) throw new Error('Must provide config.columnDefault.width when creating a stream.');
    return {
        drawVerticalLine: ()=>{
            return true;
        },
        ...config,
        border: $9JRBw.makeBorderConfig(config.border),
        columns: $eebdbbefd49a2ee3$var$makeColumnsConfig(config.columnCount, config.columns, config.columnDefault)
    };
};
module.exports.makeStreamConfig = $eebdbbefd49a2ee3$var$makeStreamConfig;

});
parcelRegister("3vein", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("hjFj1", function(module, exports) {
"use strict";
var $c9b4407733d51dd6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateConfig = void 0;

const $c9b4407733d51dd6$var$validators_1 = $c9b4407733d51dd6$var$__importDefault((parcelRequire("iU5yt")));
const $c9b4407733d51dd6$var$validateConfig = (schemaId, config)=>{
    const validate = $c9b4407733d51dd6$var$validators_1.default[schemaId];
    if (!validate(config) && validate.errors) {
        const errors = validate.errors.map((error)=>{
            return {
                message: error.message,
                params: error.params,
                schemaPath: error.schemaPath
            };
        });
        /* eslint-disable no-console */ console.log('config', config);
        console.log('errors', errors);
        /* eslint-enable no-console */ throw new Error('Invalid config.');
    }
};
module.exports.validateConfig = $c9b4407733d51dd6$var$validateConfig;

});
parcelRegister("iU5yt", function(module, exports) {

$parcel$export(module.exports, "config.json", () => $dc31c40beef9e211$export$4da8a2512b41e691, (v) => $dc31c40beef9e211$export$4da8a2512b41e691 = v);
$parcel$export(module.exports, "streamConfig.json", () => $dc31c40beef9e211$export$53562eca3991d1be, (v) => $dc31c40beef9e211$export$53562eca3991d1be = v);
var $dc31c40beef9e211$export$4da8a2512b41e691;
var $dc31c40beef9e211$export$53562eca3991d1be;
"use strict";
$dc31c40beef9e211$export$4da8a2512b41e691 = $dc31c40beef9e211$var$validate43;
const $dc31c40beef9e211$var$schema13 = {
    "$id": "config.json",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "type": "object",
    "properties": {
        "border": {
            "$ref": "shared.json#/definitions/borders"
        },
        "header": {
            "type": "object",
            "properties": {
                "content": {
                    "type": "string"
                },
                "alignment": {
                    "$ref": "shared.json#/definitions/alignment"
                },
                "wrapWord": {
                    "type": "boolean"
                },
                "truncate": {
                    "type": "integer"
                },
                "paddingLeft": {
                    "type": "integer"
                },
                "paddingRight": {
                    "type": "integer"
                }
            },
            "required": [
                "content"
            ],
            "additionalProperties": false
        },
        "columns": {
            "$ref": "shared.json#/definitions/columns"
        },
        "columnDefault": {
            "$ref": "shared.json#/definitions/column"
        },
        "drawVerticalLine": {
            "typeof": "function"
        },
        "drawHorizontalLine": {
            "typeof": "function"
        },
        "singleLine": {
            "typeof": "boolean"
        }
    },
    "additionalProperties": false
};
const $dc31c40beef9e211$var$schema15 = {
    "type": "object",
    "properties": {
        "topBody": {
            "$ref": "#/definitions/border"
        },
        "topJoin": {
            "$ref": "#/definitions/border"
        },
        "topLeft": {
            "$ref": "#/definitions/border"
        },
        "topRight": {
            "$ref": "#/definitions/border"
        },
        "bottomBody": {
            "$ref": "#/definitions/border"
        },
        "bottomJoin": {
            "$ref": "#/definitions/border"
        },
        "bottomLeft": {
            "$ref": "#/definitions/border"
        },
        "bottomRight": {
            "$ref": "#/definitions/border"
        },
        "bodyLeft": {
            "$ref": "#/definitions/border"
        },
        "bodyRight": {
            "$ref": "#/definitions/border"
        },
        "bodyJoin": {
            "$ref": "#/definitions/border"
        },
        "headerJoin": {
            "$ref": "#/definitions/border"
        },
        "joinBody": {
            "$ref": "#/definitions/border"
        },
        "joinLeft": {
            "$ref": "#/definitions/border"
        },
        "joinRight": {
            "$ref": "#/definitions/border"
        },
        "joinJoin": {
            "$ref": "#/definitions/border"
        }
    },
    "additionalProperties": false
};
const $dc31c40beef9e211$var$func8 = Object.prototype.hasOwnProperty;
const $dc31c40beef9e211$var$schema16 = {
    "type": "string"
};
function $dc31c40beef9e211$var$validate46(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (typeof data !== "string") {
        const err0 = {
            instancePath: instancePath,
            schemaPath: "#/type",
            keyword: "type",
            params: {
                type: "string"
            },
            message: "must be string"
        };
        if (vErrors === null) vErrors = [
            err0
        ];
        else vErrors.push(err0);
        errors++;
    }
    $dc31c40beef9e211$var$validate46.errors = vErrors;
    return errors === 0;
}
function $dc31c40beef9e211$var$validate45(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for(const key0 in data)if (!$dc31c40beef9e211$var$func8.call($dc31c40beef9e211$var$schema15.properties, key0)) {
            const err0 = {
                instancePath: instancePath,
                schemaPath: "#/additionalProperties",
                keyword: "additionalProperties",
                params: {
                    additionalProperty: key0
                },
                message: "must NOT have additional properties"
            };
            if (vErrors === null) vErrors = [
                err0
            ];
            else vErrors.push(err0);
            errors++;
        }
        if (data.topBody !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.topBody, {
                instancePath: instancePath + "/topBody",
                parentData: data,
                parentDataProperty: "topBody",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.topJoin !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.topJoin, {
                instancePath: instancePath + "/topJoin",
                parentData: data,
                parentDataProperty: "topJoin",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.topLeft !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.topLeft, {
                instancePath: instancePath + "/topLeft",
                parentData: data,
                parentDataProperty: "topLeft",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.topRight !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.topRight, {
                instancePath: instancePath + "/topRight",
                parentData: data,
                parentDataProperty: "topRight",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bottomBody !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bottomBody, {
                instancePath: instancePath + "/bottomBody",
                parentData: data,
                parentDataProperty: "bottomBody",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bottomJoin !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bottomJoin, {
                instancePath: instancePath + "/bottomJoin",
                parentData: data,
                parentDataProperty: "bottomJoin",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bottomLeft !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bottomLeft, {
                instancePath: instancePath + "/bottomLeft",
                parentData: data,
                parentDataProperty: "bottomLeft",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bottomRight !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bottomRight, {
                instancePath: instancePath + "/bottomRight",
                parentData: data,
                parentDataProperty: "bottomRight",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bodyLeft !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bodyLeft, {
                instancePath: instancePath + "/bodyLeft",
                parentData: data,
                parentDataProperty: "bodyLeft",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bodyRight !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bodyRight, {
                instancePath: instancePath + "/bodyRight",
                parentData: data,
                parentDataProperty: "bodyRight",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bodyJoin !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bodyJoin, {
                instancePath: instancePath + "/bodyJoin",
                parentData: data,
                parentDataProperty: "bodyJoin",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.headerJoin !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.headerJoin, {
                instancePath: instancePath + "/headerJoin",
                parentData: data,
                parentDataProperty: "headerJoin",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.joinBody !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.joinBody, {
                instancePath: instancePath + "/joinBody",
                parentData: data,
                parentDataProperty: "joinBody",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.joinLeft !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.joinLeft, {
                instancePath: instancePath + "/joinLeft",
                parentData: data,
                parentDataProperty: "joinLeft",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.joinRight !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.joinRight, {
                instancePath: instancePath + "/joinRight",
                parentData: data,
                parentDataProperty: "joinRight",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.joinJoin !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.joinJoin, {
                instancePath: instancePath + "/joinJoin",
                parentData: data,
                parentDataProperty: "joinJoin",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
    } else {
        const err1 = {
            instancePath: instancePath,
            schemaPath: "#/type",
            keyword: "type",
            params: {
                type: "object"
            },
            message: "must be object"
        };
        if (vErrors === null) vErrors = [
            err1
        ];
        else vErrors.push(err1);
        errors++;
    }
    $dc31c40beef9e211$var$validate45.errors = vErrors;
    return errors === 0;
}
const $dc31c40beef9e211$var$schema17 = {
    "type": "string",
    "enum": [
        "left",
        "right",
        "center",
        "justify"
    ]
};

var $aCmek = parcelRequire("aCmek");
var $dc31c40beef9e211$require$func0 = $aCmek.default;
function $dc31c40beef9e211$var$validate64(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (typeof data !== "string") {
        const err0 = {
            instancePath: instancePath,
            schemaPath: "#/type",
            keyword: "type",
            params: {
                type: "string"
            },
            message: "must be string"
        };
        if (vErrors === null) vErrors = [
            err0
        ];
        else vErrors.push(err0);
        errors++;
    }
    if (!(data === "left" || data === "right" || data === "center" || data === "justify")) {
        const err1 = {
            instancePath: instancePath,
            schemaPath: "#/enum",
            keyword: "enum",
            params: {
                allowedValues: $dc31c40beef9e211$var$schema17.enum
            },
            message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) vErrors = [
            err1
        ];
        else vErrors.push(err1);
        errors++;
    }
    $dc31c40beef9e211$var$validate64.errors = vErrors;
    return errors === 0;
}
const $dc31c40beef9e211$var$schema18 = {
    "oneOf": [
        {
            "type": "object",
            "patternProperties": {
                "^[0-9]+$": {
                    "$ref": "#/definitions/column"
                }
            },
            "additionalProperties": false
        },
        {
            "type": "array",
            "items": {
                "$ref": "#/definitions/column"
            }
        }
    ]
};
const $dc31c40beef9e211$var$pattern0 = new RegExp("^[0-9]+$", "u");
const $dc31c40beef9e211$var$schema19 = {
    "type": "object",
    "properties": {
        "alignment": {
            "$ref": "#/definitions/alignment"
        },
        "verticalAlignment": {
            "type": "string",
            "enum": [
                "top",
                "middle",
                "bottom"
            ]
        },
        "width": {
            "type": "integer",
            "minimum": 1
        },
        "wrapWord": {
            "type": "boolean"
        },
        "truncate": {
            "type": "integer"
        },
        "paddingLeft": {
            "type": "integer"
        },
        "paddingRight": {
            "type": "integer"
        }
    },
    "additionalProperties": false
};
function $dc31c40beef9e211$var$validate68(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (typeof data !== "string") {
        const err0 = {
            instancePath: instancePath,
            schemaPath: "#/type",
            keyword: "type",
            params: {
                type: "string"
            },
            message: "must be string"
        };
        if (vErrors === null) vErrors = [
            err0
        ];
        else vErrors.push(err0);
        errors++;
    }
    if (!(data === "left" || data === "right" || data === "center" || data === "justify")) {
        const err1 = {
            instancePath: instancePath,
            schemaPath: "#/enum",
            keyword: "enum",
            params: {
                allowedValues: $dc31c40beef9e211$var$schema17.enum
            },
            message: "must be equal to one of the allowed values"
        };
        if (vErrors === null) vErrors = [
            err1
        ];
        else vErrors.push(err1);
        errors++;
    }
    $dc31c40beef9e211$var$validate68.errors = vErrors;
    return errors === 0;
}
function $dc31c40beef9e211$var$validate67(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for(const key0 in data)if (!(key0 === "alignment" || key0 === "verticalAlignment" || key0 === "width" || key0 === "wrapWord" || key0 === "truncate" || key0 === "paddingLeft" || key0 === "paddingRight")) {
            const err0 = {
                instancePath: instancePath,
                schemaPath: "#/additionalProperties",
                keyword: "additionalProperties",
                params: {
                    additionalProperty: key0
                },
                message: "must NOT have additional properties"
            };
            if (vErrors === null) vErrors = [
                err0
            ];
            else vErrors.push(err0);
            errors++;
        }
        if (data.alignment !== undefined) {
            if (!$dc31c40beef9e211$var$validate68(data.alignment, {
                instancePath: instancePath + "/alignment",
                parentData: data,
                parentDataProperty: "alignment",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate68.errors : vErrors.concat($dc31c40beef9e211$var$validate68.errors);
                errors = vErrors.length;
            }
        }
        if (data.verticalAlignment !== undefined) {
            let data1 = data.verticalAlignment;
            if (typeof data1 !== "string") {
                const err1 = {
                    instancePath: instancePath + "/verticalAlignment",
                    schemaPath: "#/properties/verticalAlignment/type",
                    keyword: "type",
                    params: {
                        type: "string"
                    },
                    message: "must be string"
                };
                if (vErrors === null) vErrors = [
                    err1
                ];
                else vErrors.push(err1);
                errors++;
            }
            if (!(data1 === "top" || data1 === "middle" || data1 === "bottom")) {
                const err2 = {
                    instancePath: instancePath + "/verticalAlignment",
                    schemaPath: "#/properties/verticalAlignment/enum",
                    keyword: "enum",
                    params: {
                        allowedValues: $dc31c40beef9e211$var$schema19.properties.verticalAlignment.enum
                    },
                    message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) vErrors = [
                    err2
                ];
                else vErrors.push(err2);
                errors++;
            }
        }
        if (data.width !== undefined) {
            let data2 = data.width;
            if (!(typeof data2 == "number" && !(data2 % 1) && !isNaN(data2) && isFinite(data2))) {
                const err3 = {
                    instancePath: instancePath + "/width",
                    schemaPath: "#/properties/width/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err3
                ];
                else vErrors.push(err3);
                errors++;
            }
            if (typeof data2 == "number" && isFinite(data2)) {
                if (data2 < 1 || isNaN(data2)) {
                    const err4 = {
                        instancePath: instancePath + "/width",
                        schemaPath: "#/properties/width/minimum",
                        keyword: "minimum",
                        params: {
                            comparison: ">=",
                            limit: 1
                        },
                        message: "must be >= 1"
                    };
                    if (vErrors === null) vErrors = [
                        err4
                    ];
                    else vErrors.push(err4);
                    errors++;
                }
            }
        }
        if (data.wrapWord !== undefined) {
            if (typeof data.wrapWord !== "boolean") {
                const err5 = {
                    instancePath: instancePath + "/wrapWord",
                    schemaPath: "#/properties/wrapWord/type",
                    keyword: "type",
                    params: {
                        type: "boolean"
                    },
                    message: "must be boolean"
                };
                if (vErrors === null) vErrors = [
                    err5
                ];
                else vErrors.push(err5);
                errors++;
            }
        }
        if (data.truncate !== undefined) {
            let data4 = data.truncate;
            if (!(typeof data4 == "number" && !(data4 % 1) && !isNaN(data4) && isFinite(data4))) {
                const err6 = {
                    instancePath: instancePath + "/truncate",
                    schemaPath: "#/properties/truncate/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err6
                ];
                else vErrors.push(err6);
                errors++;
            }
        }
        if (data.paddingLeft !== undefined) {
            let data5 = data.paddingLeft;
            if (!(typeof data5 == "number" && !(data5 % 1) && !isNaN(data5) && isFinite(data5))) {
                const err7 = {
                    instancePath: instancePath + "/paddingLeft",
                    schemaPath: "#/properties/paddingLeft/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err7
                ];
                else vErrors.push(err7);
                errors++;
            }
        }
        if (data.paddingRight !== undefined) {
            let data6 = data.paddingRight;
            if (!(typeof data6 == "number" && !(data6 % 1) && !isNaN(data6) && isFinite(data6))) {
                const err8 = {
                    instancePath: instancePath + "/paddingRight",
                    schemaPath: "#/properties/paddingRight/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err8
                ];
                else vErrors.push(err8);
                errors++;
            }
        }
    } else {
        const err9 = {
            instancePath: instancePath,
            schemaPath: "#/type",
            keyword: "type",
            params: {
                type: "object"
            },
            message: "must be object"
        };
        if (vErrors === null) vErrors = [
            err9
        ];
        else vErrors.push(err9);
        errors++;
    }
    $dc31c40beef9e211$var$validate67.errors = vErrors;
    return errors === 0;
}
function $dc31c40beef9e211$var$validate66(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for(const key0 in data)if (!$dc31c40beef9e211$var$pattern0.test(key0)) {
            const err0 = {
                instancePath: instancePath,
                schemaPath: "#/oneOf/0/additionalProperties",
                keyword: "additionalProperties",
                params: {
                    additionalProperty: key0
                },
                message: "must NOT have additional properties"
            };
            if (vErrors === null) vErrors = [
                err0
            ];
            else vErrors.push(err0);
            errors++;
        }
        for(const key1 in data){
            if ($dc31c40beef9e211$var$pattern0.test(key1)) {
                if (!$dc31c40beef9e211$var$validate67(data[key1], {
                    instancePath: instancePath + "/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                    parentData: data,
                    parentDataProperty: key1,
                    rootData: rootData
                })) {
                    vErrors = vErrors === null ? $dc31c40beef9e211$var$validate67.errors : vErrors.concat($dc31c40beef9e211$var$validate67.errors);
                    errors = vErrors.length;
                }
            }
        }
    } else {
        const err1 = {
            instancePath: instancePath,
            schemaPath: "#/oneOf/0/type",
            keyword: "type",
            params: {
                type: "object"
            },
            message: "must be object"
        };
        if (vErrors === null) vErrors = [
            err1
        ];
        else vErrors.push(err1);
        errors++;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    const _errs5 = errors;
    if (Array.isArray(data)) {
        const len0 = data.length;
        for(let i0 = 0; i0 < len0; i0++)if (!$dc31c40beef9e211$var$validate67(data[i0], {
            instancePath: instancePath + "/" + i0,
            parentData: data,
            parentDataProperty: i0,
            rootData: rootData
        })) {
            vErrors = vErrors === null ? $dc31c40beef9e211$var$validate67.errors : vErrors.concat($dc31c40beef9e211$var$validate67.errors);
            errors = vErrors.length;
        }
    } else {
        const err2 = {
            instancePath: instancePath,
            schemaPath: "#/oneOf/1/type",
            keyword: "type",
            params: {
                type: "array"
            },
            message: "must be array"
        };
        if (vErrors === null) vErrors = [
            err2
        ];
        else vErrors.push(err2);
        errors++;
    }
    var _valid0 = _errs5 === errors;
    if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [
            passing0,
            1
        ];
    } else if (_valid0) {
        valid0 = true;
        passing0 = 1;
    }
    if (!valid0) {
        const err3 = {
            instancePath: instancePath,
            schemaPath: "#/oneOf",
            keyword: "oneOf",
            params: {
                passingSchemas: passing0
            },
            message: "must match exactly one schema in oneOf"
        };
        if (vErrors === null) vErrors = [
            err3
        ];
        else vErrors.push(err3);
        errors++;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) vErrors.length = _errs0;
            else vErrors = null;
        }
    }
    $dc31c40beef9e211$var$validate66.errors = vErrors;
    return errors === 0;
}
function $dc31c40beef9e211$var$validate73(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for(const key0 in data)if (!(key0 === "alignment" || key0 === "verticalAlignment" || key0 === "width" || key0 === "wrapWord" || key0 === "truncate" || key0 === "paddingLeft" || key0 === "paddingRight")) {
            const err0 = {
                instancePath: instancePath,
                schemaPath: "#/additionalProperties",
                keyword: "additionalProperties",
                params: {
                    additionalProperty: key0
                },
                message: "must NOT have additional properties"
            };
            if (vErrors === null) vErrors = [
                err0
            ];
            else vErrors.push(err0);
            errors++;
        }
        if (data.alignment !== undefined) {
            if (!$dc31c40beef9e211$var$validate68(data.alignment, {
                instancePath: instancePath + "/alignment",
                parentData: data,
                parentDataProperty: "alignment",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate68.errors : vErrors.concat($dc31c40beef9e211$var$validate68.errors);
                errors = vErrors.length;
            }
        }
        if (data.verticalAlignment !== undefined) {
            let data1 = data.verticalAlignment;
            if (typeof data1 !== "string") {
                const err1 = {
                    instancePath: instancePath + "/verticalAlignment",
                    schemaPath: "#/properties/verticalAlignment/type",
                    keyword: "type",
                    params: {
                        type: "string"
                    },
                    message: "must be string"
                };
                if (vErrors === null) vErrors = [
                    err1
                ];
                else vErrors.push(err1);
                errors++;
            }
            if (!(data1 === "top" || data1 === "middle" || data1 === "bottom")) {
                const err2 = {
                    instancePath: instancePath + "/verticalAlignment",
                    schemaPath: "#/properties/verticalAlignment/enum",
                    keyword: "enum",
                    params: {
                        allowedValues: $dc31c40beef9e211$var$schema19.properties.verticalAlignment.enum
                    },
                    message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) vErrors = [
                    err2
                ];
                else vErrors.push(err2);
                errors++;
            }
        }
        if (data.width !== undefined) {
            let data2 = data.width;
            if (!(typeof data2 == "number" && !(data2 % 1) && !isNaN(data2) && isFinite(data2))) {
                const err3 = {
                    instancePath: instancePath + "/width",
                    schemaPath: "#/properties/width/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err3
                ];
                else vErrors.push(err3);
                errors++;
            }
            if (typeof data2 == "number" && isFinite(data2)) {
                if (data2 < 1 || isNaN(data2)) {
                    const err4 = {
                        instancePath: instancePath + "/width",
                        schemaPath: "#/properties/width/minimum",
                        keyword: "minimum",
                        params: {
                            comparison: ">=",
                            limit: 1
                        },
                        message: "must be >= 1"
                    };
                    if (vErrors === null) vErrors = [
                        err4
                    ];
                    else vErrors.push(err4);
                    errors++;
                }
            }
        }
        if (data.wrapWord !== undefined) {
            if (typeof data.wrapWord !== "boolean") {
                const err5 = {
                    instancePath: instancePath + "/wrapWord",
                    schemaPath: "#/properties/wrapWord/type",
                    keyword: "type",
                    params: {
                        type: "boolean"
                    },
                    message: "must be boolean"
                };
                if (vErrors === null) vErrors = [
                    err5
                ];
                else vErrors.push(err5);
                errors++;
            }
        }
        if (data.truncate !== undefined) {
            let data4 = data.truncate;
            if (!(typeof data4 == "number" && !(data4 % 1) && !isNaN(data4) && isFinite(data4))) {
                const err6 = {
                    instancePath: instancePath + "/truncate",
                    schemaPath: "#/properties/truncate/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err6
                ];
                else vErrors.push(err6);
                errors++;
            }
        }
        if (data.paddingLeft !== undefined) {
            let data5 = data.paddingLeft;
            if (!(typeof data5 == "number" && !(data5 % 1) && !isNaN(data5) && isFinite(data5))) {
                const err7 = {
                    instancePath: instancePath + "/paddingLeft",
                    schemaPath: "#/properties/paddingLeft/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err7
                ];
                else vErrors.push(err7);
                errors++;
            }
        }
        if (data.paddingRight !== undefined) {
            let data6 = data.paddingRight;
            if (!(typeof data6 == "number" && !(data6 % 1) && !isNaN(data6) && isFinite(data6))) {
                const err8 = {
                    instancePath: instancePath + "/paddingRight",
                    schemaPath: "#/properties/paddingRight/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err8
                ];
                else vErrors.push(err8);
                errors++;
            }
        }
    } else {
        const err9 = {
            instancePath: instancePath,
            schemaPath: "#/type",
            keyword: "type",
            params: {
                type: "object"
            },
            message: "must be object"
        };
        if (vErrors === null) vErrors = [
            err9
        ];
        else vErrors.push(err9);
        errors++;
    }
    $dc31c40beef9e211$var$validate73.errors = vErrors;
    return errors === 0;
}
function $dc31c40beef9e211$var$validate43(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for(const key0 in data)if (!(key0 === "border" || key0 === "header" || key0 === "columns" || key0 === "columnDefault" || key0 === "drawVerticalLine" || key0 === "drawHorizontalLine" || key0 === "singleLine")) {
            const err0 = {
                instancePath: instancePath,
                schemaPath: "#/additionalProperties",
                keyword: "additionalProperties",
                params: {
                    additionalProperty: key0
                },
                message: "must NOT have additional properties"
            };
            if (vErrors === null) vErrors = [
                err0
            ];
            else vErrors.push(err0);
            errors++;
        }
        if (data.border !== undefined) {
            if (!$dc31c40beef9e211$var$validate45(data.border, {
                instancePath: instancePath + "/border",
                parentData: data,
                parentDataProperty: "border",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate45.errors : vErrors.concat($dc31c40beef9e211$var$validate45.errors);
                errors = vErrors.length;
            }
        }
        if (data.header !== undefined) {
            let data1 = data.header;
            if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                if (data1.content === undefined) {
                    const err1 = {
                        instancePath: instancePath + "/header",
                        schemaPath: "#/properties/header/required",
                        keyword: "required",
                        params: {
                            missingProperty: "content"
                        },
                        message: "must have required property 'content'"
                    };
                    if (vErrors === null) vErrors = [
                        err1
                    ];
                    else vErrors.push(err1);
                    errors++;
                }
                for(const key1 in data1)if (!(key1 === "content" || key1 === "alignment" || key1 === "wrapWord" || key1 === "truncate" || key1 === "paddingLeft" || key1 === "paddingRight")) {
                    const err2 = {
                        instancePath: instancePath + "/header",
                        schemaPath: "#/properties/header/additionalProperties",
                        keyword: "additionalProperties",
                        params: {
                            additionalProperty: key1
                        },
                        message: "must NOT have additional properties"
                    };
                    if (vErrors === null) vErrors = [
                        err2
                    ];
                    else vErrors.push(err2);
                    errors++;
                }
                if (data1.content !== undefined) {
                    if (typeof data1.content !== "string") {
                        const err3 = {
                            instancePath: instancePath + "/header/content",
                            schemaPath: "#/properties/header/properties/content/type",
                            keyword: "type",
                            params: {
                                type: "string"
                            },
                            message: "must be string"
                        };
                        if (vErrors === null) vErrors = [
                            err3
                        ];
                        else vErrors.push(err3);
                        errors++;
                    }
                }
                if (data1.alignment !== undefined) {
                    if (!$dc31c40beef9e211$var$validate64(data1.alignment, {
                        instancePath: instancePath + "/header/alignment",
                        parentData: data1,
                        parentDataProperty: "alignment",
                        rootData: rootData
                    })) {
                        vErrors = vErrors === null ? $dc31c40beef9e211$var$validate64.errors : vErrors.concat($dc31c40beef9e211$var$validate64.errors);
                        errors = vErrors.length;
                    }
                }
                if (data1.wrapWord !== undefined) {
                    if (typeof data1.wrapWord !== "boolean") {
                        const err4 = {
                            instancePath: instancePath + "/header/wrapWord",
                            schemaPath: "#/properties/header/properties/wrapWord/type",
                            keyword: "type",
                            params: {
                                type: "boolean"
                            },
                            message: "must be boolean"
                        };
                        if (vErrors === null) vErrors = [
                            err4
                        ];
                        else vErrors.push(err4);
                        errors++;
                    }
                }
                if (data1.truncate !== undefined) {
                    let data5 = data1.truncate;
                    if (!(typeof data5 == "number" && !(data5 % 1) && !isNaN(data5) && isFinite(data5))) {
                        const err5 = {
                            instancePath: instancePath + "/header/truncate",
                            schemaPath: "#/properties/header/properties/truncate/type",
                            keyword: "type",
                            params: {
                                type: "integer"
                            },
                            message: "must be integer"
                        };
                        if (vErrors === null) vErrors = [
                            err5
                        ];
                        else vErrors.push(err5);
                        errors++;
                    }
                }
                if (data1.paddingLeft !== undefined) {
                    let data6 = data1.paddingLeft;
                    if (!(typeof data6 == "number" && !(data6 % 1) && !isNaN(data6) && isFinite(data6))) {
                        const err6 = {
                            instancePath: instancePath + "/header/paddingLeft",
                            schemaPath: "#/properties/header/properties/paddingLeft/type",
                            keyword: "type",
                            params: {
                                type: "integer"
                            },
                            message: "must be integer"
                        };
                        if (vErrors === null) vErrors = [
                            err6
                        ];
                        else vErrors.push(err6);
                        errors++;
                    }
                }
                if (data1.paddingRight !== undefined) {
                    let data7 = data1.paddingRight;
                    if (!(typeof data7 == "number" && !(data7 % 1) && !isNaN(data7) && isFinite(data7))) {
                        const err7 = {
                            instancePath: instancePath + "/header/paddingRight",
                            schemaPath: "#/properties/header/properties/paddingRight/type",
                            keyword: "type",
                            params: {
                                type: "integer"
                            },
                            message: "must be integer"
                        };
                        if (vErrors === null) vErrors = [
                            err7
                        ];
                        else vErrors.push(err7);
                        errors++;
                    }
                }
            } else {
                const err8 = {
                    instancePath: instancePath + "/header",
                    schemaPath: "#/properties/header/type",
                    keyword: "type",
                    params: {
                        type: "object"
                    },
                    message: "must be object"
                };
                if (vErrors === null) vErrors = [
                    err8
                ];
                else vErrors.push(err8);
                errors++;
            }
        }
        if (data.columns !== undefined) {
            if (!$dc31c40beef9e211$var$validate66(data.columns, {
                instancePath: instancePath + "/columns",
                parentData: data,
                parentDataProperty: "columns",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate66.errors : vErrors.concat($dc31c40beef9e211$var$validate66.errors);
                errors = vErrors.length;
            }
        }
        if (data.columnDefault !== undefined) {
            if (!$dc31c40beef9e211$var$validate73(data.columnDefault, {
                instancePath: instancePath + "/columnDefault",
                parentData: data,
                parentDataProperty: "columnDefault",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate73.errors : vErrors.concat($dc31c40beef9e211$var$validate73.errors);
                errors = vErrors.length;
            }
        }
        if (data.drawVerticalLine !== undefined) {
            if (typeof data.drawVerticalLine != "function") {
                const err9 = {
                    instancePath: instancePath + "/drawVerticalLine",
                    schemaPath: "#/properties/drawVerticalLine/typeof",
                    keyword: "typeof",
                    params: {},
                    message: "should pass \"typeof\" keyword validation"
                };
                if (vErrors === null) vErrors = [
                    err9
                ];
                else vErrors.push(err9);
                errors++;
            }
        }
        if (data.drawHorizontalLine !== undefined) {
            if (typeof data.drawHorizontalLine != "function") {
                const err10 = {
                    instancePath: instancePath + "/drawHorizontalLine",
                    schemaPath: "#/properties/drawHorizontalLine/typeof",
                    keyword: "typeof",
                    params: {},
                    message: "should pass \"typeof\" keyword validation"
                };
                if (vErrors === null) vErrors = [
                    err10
                ];
                else vErrors.push(err10);
                errors++;
            }
        }
        if (data.singleLine !== undefined) {
            if (typeof data.singleLine != "boolean") {
                const err11 = {
                    instancePath: instancePath + "/singleLine",
                    schemaPath: "#/properties/singleLine/typeof",
                    keyword: "typeof",
                    params: {},
                    message: "should pass \"typeof\" keyword validation"
                };
                if (vErrors === null) vErrors = [
                    err11
                ];
                else vErrors.push(err11);
                errors++;
            }
        }
    } else {
        const err12 = {
            instancePath: instancePath,
            schemaPath: "#/type",
            keyword: "type",
            params: {
                type: "object"
            },
            message: "must be object"
        };
        if (vErrors === null) vErrors = [
            err12
        ];
        else vErrors.push(err12);
        errors++;
    }
    $dc31c40beef9e211$var$validate43.errors = vErrors;
    return errors === 0;
}
$dc31c40beef9e211$export$53562eca3991d1be = $dc31c40beef9e211$var$validate76;
const $dc31c40beef9e211$var$schema22 = {
    "$id": "streamConfig.json",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "type": "object",
    "properties": {
        "border": {
            "$ref": "shared.json#/definitions/borders"
        },
        "columns": {
            "$ref": "shared.json#/definitions/columns"
        },
        "columnDefault": {
            "$ref": "shared.json#/definitions/column"
        },
        "columnCount": {
            "type": "integer",
            "minimum": 1
        },
        "drawVerticalLine": {
            "typeof": "function"
        }
    },
    "required": [
        "columnDefault",
        "columnCount"
    ],
    "additionalProperties": false
};
function $dc31c40beef9e211$var$validate77(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for(const key0 in data)if (!$dc31c40beef9e211$var$func8.call($dc31c40beef9e211$var$schema15.properties, key0)) {
            const err0 = {
                instancePath: instancePath,
                schemaPath: "#/additionalProperties",
                keyword: "additionalProperties",
                params: {
                    additionalProperty: key0
                },
                message: "must NOT have additional properties"
            };
            if (vErrors === null) vErrors = [
                err0
            ];
            else vErrors.push(err0);
            errors++;
        }
        if (data.topBody !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.topBody, {
                instancePath: instancePath + "/topBody",
                parentData: data,
                parentDataProperty: "topBody",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.topJoin !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.topJoin, {
                instancePath: instancePath + "/topJoin",
                parentData: data,
                parentDataProperty: "topJoin",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.topLeft !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.topLeft, {
                instancePath: instancePath + "/topLeft",
                parentData: data,
                parentDataProperty: "topLeft",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.topRight !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.topRight, {
                instancePath: instancePath + "/topRight",
                parentData: data,
                parentDataProperty: "topRight",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bottomBody !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bottomBody, {
                instancePath: instancePath + "/bottomBody",
                parentData: data,
                parentDataProperty: "bottomBody",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bottomJoin !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bottomJoin, {
                instancePath: instancePath + "/bottomJoin",
                parentData: data,
                parentDataProperty: "bottomJoin",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bottomLeft !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bottomLeft, {
                instancePath: instancePath + "/bottomLeft",
                parentData: data,
                parentDataProperty: "bottomLeft",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bottomRight !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bottomRight, {
                instancePath: instancePath + "/bottomRight",
                parentData: data,
                parentDataProperty: "bottomRight",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bodyLeft !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bodyLeft, {
                instancePath: instancePath + "/bodyLeft",
                parentData: data,
                parentDataProperty: "bodyLeft",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bodyRight !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bodyRight, {
                instancePath: instancePath + "/bodyRight",
                parentData: data,
                parentDataProperty: "bodyRight",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.bodyJoin !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.bodyJoin, {
                instancePath: instancePath + "/bodyJoin",
                parentData: data,
                parentDataProperty: "bodyJoin",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.headerJoin !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.headerJoin, {
                instancePath: instancePath + "/headerJoin",
                parentData: data,
                parentDataProperty: "headerJoin",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.joinBody !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.joinBody, {
                instancePath: instancePath + "/joinBody",
                parentData: data,
                parentDataProperty: "joinBody",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.joinLeft !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.joinLeft, {
                instancePath: instancePath + "/joinLeft",
                parentData: data,
                parentDataProperty: "joinLeft",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.joinRight !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.joinRight, {
                instancePath: instancePath + "/joinRight",
                parentData: data,
                parentDataProperty: "joinRight",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
        if (data.joinJoin !== undefined) {
            if (!$dc31c40beef9e211$var$validate46(data.joinJoin, {
                instancePath: instancePath + "/joinJoin",
                parentData: data,
                parentDataProperty: "joinJoin",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate46.errors : vErrors.concat($dc31c40beef9e211$var$validate46.errors);
                errors = vErrors.length;
            }
        }
    } else {
        const err1 = {
            instancePath: instancePath,
            schemaPath: "#/type",
            keyword: "type",
            params: {
                type: "object"
            },
            message: "must be object"
        };
        if (vErrors === null) vErrors = [
            err1
        ];
        else vErrors.push(err1);
        errors++;
    }
    $dc31c40beef9e211$var$validate77.errors = vErrors;
    return errors === 0;
}
function $dc31c40beef9e211$var$validate95(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for(const key0 in data)if (!$dc31c40beef9e211$var$pattern0.test(key0)) {
            const err0 = {
                instancePath: instancePath,
                schemaPath: "#/oneOf/0/additionalProperties",
                keyword: "additionalProperties",
                params: {
                    additionalProperty: key0
                },
                message: "must NOT have additional properties"
            };
            if (vErrors === null) vErrors = [
                err0
            ];
            else vErrors.push(err0);
            errors++;
        }
        for(const key1 in data){
            if ($dc31c40beef9e211$var$pattern0.test(key1)) {
                if (!$dc31c40beef9e211$var$validate67(data[key1], {
                    instancePath: instancePath + "/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),
                    parentData: data,
                    parentDataProperty: key1,
                    rootData: rootData
                })) {
                    vErrors = vErrors === null ? $dc31c40beef9e211$var$validate67.errors : vErrors.concat($dc31c40beef9e211$var$validate67.errors);
                    errors = vErrors.length;
                }
            }
        }
    } else {
        const err1 = {
            instancePath: instancePath,
            schemaPath: "#/oneOf/0/type",
            keyword: "type",
            params: {
                type: "object"
            },
            message: "must be object"
        };
        if (vErrors === null) vErrors = [
            err1
        ];
        else vErrors.push(err1);
        errors++;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    const _errs5 = errors;
    if (Array.isArray(data)) {
        const len0 = data.length;
        for(let i0 = 0; i0 < len0; i0++)if (!$dc31c40beef9e211$var$validate67(data[i0], {
            instancePath: instancePath + "/" + i0,
            parentData: data,
            parentDataProperty: i0,
            rootData: rootData
        })) {
            vErrors = vErrors === null ? $dc31c40beef9e211$var$validate67.errors : vErrors.concat($dc31c40beef9e211$var$validate67.errors);
            errors = vErrors.length;
        }
    } else {
        const err2 = {
            instancePath: instancePath,
            schemaPath: "#/oneOf/1/type",
            keyword: "type",
            params: {
                type: "array"
            },
            message: "must be array"
        };
        if (vErrors === null) vErrors = [
            err2
        ];
        else vErrors.push(err2);
        errors++;
    }
    var _valid0 = _errs5 === errors;
    if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [
            passing0,
            1
        ];
    } else if (_valid0) {
        valid0 = true;
        passing0 = 1;
    }
    if (!valid0) {
        const err3 = {
            instancePath: instancePath,
            schemaPath: "#/oneOf",
            keyword: "oneOf",
            params: {
                passingSchemas: passing0
            },
            message: "must match exactly one schema in oneOf"
        };
        if (vErrors === null) vErrors = [
            err3
        ];
        else vErrors.push(err3);
        errors++;
    } else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) vErrors.length = _errs0;
            else vErrors = null;
        }
    }
    $dc31c40beef9e211$var$validate95.errors = vErrors;
    return errors === 0;
}
function $dc31c40beef9e211$var$validate99(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for(const key0 in data)if (!(key0 === "alignment" || key0 === "verticalAlignment" || key0 === "width" || key0 === "wrapWord" || key0 === "truncate" || key0 === "paddingLeft" || key0 === "paddingRight")) {
            const err0 = {
                instancePath: instancePath,
                schemaPath: "#/additionalProperties",
                keyword: "additionalProperties",
                params: {
                    additionalProperty: key0
                },
                message: "must NOT have additional properties"
            };
            if (vErrors === null) vErrors = [
                err0
            ];
            else vErrors.push(err0);
            errors++;
        }
        if (data.alignment !== undefined) {
            if (!$dc31c40beef9e211$var$validate68(data.alignment, {
                instancePath: instancePath + "/alignment",
                parentData: data,
                parentDataProperty: "alignment",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate68.errors : vErrors.concat($dc31c40beef9e211$var$validate68.errors);
                errors = vErrors.length;
            }
        }
        if (data.verticalAlignment !== undefined) {
            let data1 = data.verticalAlignment;
            if (typeof data1 !== "string") {
                const err1 = {
                    instancePath: instancePath + "/verticalAlignment",
                    schemaPath: "#/properties/verticalAlignment/type",
                    keyword: "type",
                    params: {
                        type: "string"
                    },
                    message: "must be string"
                };
                if (vErrors === null) vErrors = [
                    err1
                ];
                else vErrors.push(err1);
                errors++;
            }
            if (!(data1 === "top" || data1 === "middle" || data1 === "bottom")) {
                const err2 = {
                    instancePath: instancePath + "/verticalAlignment",
                    schemaPath: "#/properties/verticalAlignment/enum",
                    keyword: "enum",
                    params: {
                        allowedValues: $dc31c40beef9e211$var$schema19.properties.verticalAlignment.enum
                    },
                    message: "must be equal to one of the allowed values"
                };
                if (vErrors === null) vErrors = [
                    err2
                ];
                else vErrors.push(err2);
                errors++;
            }
        }
        if (data.width !== undefined) {
            let data2 = data.width;
            if (!(typeof data2 == "number" && !(data2 % 1) && !isNaN(data2) && isFinite(data2))) {
                const err3 = {
                    instancePath: instancePath + "/width",
                    schemaPath: "#/properties/width/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err3
                ];
                else vErrors.push(err3);
                errors++;
            }
            if (typeof data2 == "number" && isFinite(data2)) {
                if (data2 < 1 || isNaN(data2)) {
                    const err4 = {
                        instancePath: instancePath + "/width",
                        schemaPath: "#/properties/width/minimum",
                        keyword: "minimum",
                        params: {
                            comparison: ">=",
                            limit: 1
                        },
                        message: "must be >= 1"
                    };
                    if (vErrors === null) vErrors = [
                        err4
                    ];
                    else vErrors.push(err4);
                    errors++;
                }
            }
        }
        if (data.wrapWord !== undefined) {
            if (typeof data.wrapWord !== "boolean") {
                const err5 = {
                    instancePath: instancePath + "/wrapWord",
                    schemaPath: "#/properties/wrapWord/type",
                    keyword: "type",
                    params: {
                        type: "boolean"
                    },
                    message: "must be boolean"
                };
                if (vErrors === null) vErrors = [
                    err5
                ];
                else vErrors.push(err5);
                errors++;
            }
        }
        if (data.truncate !== undefined) {
            let data4 = data.truncate;
            if (!(typeof data4 == "number" && !(data4 % 1) && !isNaN(data4) && isFinite(data4))) {
                const err6 = {
                    instancePath: instancePath + "/truncate",
                    schemaPath: "#/properties/truncate/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err6
                ];
                else vErrors.push(err6);
                errors++;
            }
        }
        if (data.paddingLeft !== undefined) {
            let data5 = data.paddingLeft;
            if (!(typeof data5 == "number" && !(data5 % 1) && !isNaN(data5) && isFinite(data5))) {
                const err7 = {
                    instancePath: instancePath + "/paddingLeft",
                    schemaPath: "#/properties/paddingLeft/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err7
                ];
                else vErrors.push(err7);
                errors++;
            }
        }
        if (data.paddingRight !== undefined) {
            let data6 = data.paddingRight;
            if (!(typeof data6 == "number" && !(data6 % 1) && !isNaN(data6) && isFinite(data6))) {
                const err8 = {
                    instancePath: instancePath + "/paddingRight",
                    schemaPath: "#/properties/paddingRight/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err8
                ];
                else vErrors.push(err8);
                errors++;
            }
        }
    } else {
        const err9 = {
            instancePath: instancePath,
            schemaPath: "#/type",
            keyword: "type",
            params: {
                type: "object"
            },
            message: "must be object"
        };
        if (vErrors === null) vErrors = [
            err9
        ];
        else vErrors.push(err9);
        errors++;
    }
    $dc31c40beef9e211$var$validate99.errors = vErrors;
    return errors === 0;
}
function $dc31c40beef9e211$var$validate76(data, { instancePath: instancePath = "", parentData: parentData, parentDataProperty: parentDataProperty, rootData: rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.columnDefault === undefined) {
            const err0 = {
                instancePath: instancePath,
                schemaPath: "#/required",
                keyword: "required",
                params: {
                    missingProperty: "columnDefault"
                },
                message: "must have required property 'columnDefault'"
            };
            if (vErrors === null) vErrors = [
                err0
            ];
            else vErrors.push(err0);
            errors++;
        }
        if (data.columnCount === undefined) {
            const err1 = {
                instancePath: instancePath,
                schemaPath: "#/required",
                keyword: "required",
                params: {
                    missingProperty: "columnCount"
                },
                message: "must have required property 'columnCount'"
            };
            if (vErrors === null) vErrors = [
                err1
            ];
            else vErrors.push(err1);
            errors++;
        }
        for(const key0 in data)if (!(key0 === "border" || key0 === "columns" || key0 === "columnDefault" || key0 === "columnCount" || key0 === "drawVerticalLine")) {
            const err2 = {
                instancePath: instancePath,
                schemaPath: "#/additionalProperties",
                keyword: "additionalProperties",
                params: {
                    additionalProperty: key0
                },
                message: "must NOT have additional properties"
            };
            if (vErrors === null) vErrors = [
                err2
            ];
            else vErrors.push(err2);
            errors++;
        }
        if (data.border !== undefined) {
            if (!$dc31c40beef9e211$var$validate77(data.border, {
                instancePath: instancePath + "/border",
                parentData: data,
                parentDataProperty: "border",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate77.errors : vErrors.concat($dc31c40beef9e211$var$validate77.errors);
                errors = vErrors.length;
            }
        }
        if (data.columns !== undefined) {
            if (!$dc31c40beef9e211$var$validate95(data.columns, {
                instancePath: instancePath + "/columns",
                parentData: data,
                parentDataProperty: "columns",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate95.errors : vErrors.concat($dc31c40beef9e211$var$validate95.errors);
                errors = vErrors.length;
            }
        }
        if (data.columnDefault !== undefined) {
            if (!$dc31c40beef9e211$var$validate99(data.columnDefault, {
                instancePath: instancePath + "/columnDefault",
                parentData: data,
                parentDataProperty: "columnDefault",
                rootData: rootData
            })) {
                vErrors = vErrors === null ? $dc31c40beef9e211$var$validate99.errors : vErrors.concat($dc31c40beef9e211$var$validate99.errors);
                errors = vErrors.length;
            }
        }
        if (data.columnCount !== undefined) {
            let data3 = data.columnCount;
            if (!(typeof data3 == "number" && !(data3 % 1) && !isNaN(data3) && isFinite(data3))) {
                const err3 = {
                    instancePath: instancePath + "/columnCount",
                    schemaPath: "#/properties/columnCount/type",
                    keyword: "type",
                    params: {
                        type: "integer"
                    },
                    message: "must be integer"
                };
                if (vErrors === null) vErrors = [
                    err3
                ];
                else vErrors.push(err3);
                errors++;
            }
            if (typeof data3 == "number" && isFinite(data3)) {
                if (data3 < 1 || isNaN(data3)) {
                    const err4 = {
                        instancePath: instancePath + "/columnCount",
                        schemaPath: "#/properties/columnCount/minimum",
                        keyword: "minimum",
                        params: {
                            comparison: ">=",
                            limit: 1
                        },
                        message: "must be >= 1"
                    };
                    if (vErrors === null) vErrors = [
                        err4
                    ];
                    else vErrors.push(err4);
                    errors++;
                }
            }
        }
        if (data.drawVerticalLine !== undefined) {
            if (typeof data.drawVerticalLine != "function") {
                const err5 = {
                    instancePath: instancePath + "/drawVerticalLine",
                    schemaPath: "#/properties/drawVerticalLine/typeof",
                    keyword: "typeof",
                    params: {},
                    message: "should pass \"typeof\" keyword validation"
                };
                if (vErrors === null) vErrors = [
                    err5
                ];
                else vErrors.push(err5);
                errors++;
            }
        }
    } else {
        const err6 = {
            instancePath: instancePath,
            schemaPath: "#/type",
            keyword: "type",
            params: {
                type: "object"
            },
            message: "must be object"
        };
        if (vErrors === null) vErrors = [
            err6
        ];
        else vErrors.push(err6);
        errors++;
    }
    $dc31c40beef9e211$var$validate76.errors = vErrors;
    return errors === 0;
}

});
parcelRegister("aCmek", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h9WuO = parcelRequire("h9WuO");
$h9WuO.code = 'require("ajv/dist/runtime/equal").default';
module.exports.default = $h9WuO;

});
parcelRegister("h9WuO", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});





parcelRegister("dxIRG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapDataUsingRowHeights = void 0;

var $luZCz = parcelRequire("luZCz");
const $9dc128a811c7509d$var$createEmptyStrings = (length)=>{
    return new Array(length).fill('');
};
const $9dc128a811c7509d$var$padCellVertically = (lines, rowHeight, columnConfig)=>{
    const { verticalAlignment: verticalAlignment } = columnConfig;
    const availableLines = rowHeight - lines.length;
    if (verticalAlignment === 'top') return [
        ...lines,
        ...$9dc128a811c7509d$var$createEmptyStrings(availableLines)
    ];
    if (verticalAlignment === 'bottom') return [
        ...$9dc128a811c7509d$var$createEmptyStrings(availableLines),
        ...lines
    ];
    return [
        ...$9dc128a811c7509d$var$createEmptyStrings(Math.floor(availableLines / 2)),
        ...lines,
        ...$9dc128a811c7509d$var$createEmptyStrings(Math.ceil(availableLines / 2))
    ];
};
const $9dc128a811c7509d$var$flatten = (array)=>{
    return [].concat(...array);
};
const $9dc128a811c7509d$var$mapDataUsingRowHeights = (unmappedRows, rowHeights, config)=>{
    const tableWidth = unmappedRows[0].length;
    const mappedRows = unmappedRows.map((unmappedRow, unmappedRowIndex)=>{
        const outputRowHeight = rowHeights[unmappedRowIndex];
        const outputRow = Array.from({
            length: outputRowHeight
        }, ()=>{
            return new Array(tableWidth).fill('');
        });
        unmappedRow.forEach((cell, cellIndex)=>{
            const cellLines = $luZCz.wrapCell(cell, config.columns[cellIndex].width, config.columns[cellIndex].wrapWord);
            const paddedCellLines = $9dc128a811c7509d$var$padCellVertically(cellLines, outputRowHeight, config.columns[cellIndex]);
            paddedCellLines.forEach((cellLine, cellLineIndex)=>{
                outputRow[cellLineIndex][cellIndex] = cellLine;
            });
        });
        return outputRow;
    });
    return $9dc128a811c7509d$var$flatten(mappedRows);
};
module.exports.mapDataUsingRowHeights = $9dc128a811c7509d$var$mapDataUsingRowHeights;

});

parcelRegister("apKKk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.padTableData = module.exports.padString = void 0;
const $79507ffd8aefc70a$var$padString = (input, paddingLeft, paddingRight)=>{
    return ' '.repeat(paddingLeft) + input + ' '.repeat(paddingRight);
};
module.exports.padString = $79507ffd8aefc70a$var$padString;
const $79507ffd8aefc70a$var$padTableData = (rows, config)=>{
    return rows.map((cells)=>{
        return cells.map((cell, cellIndex)=>{
            const { paddingLeft: paddingLeft, paddingRight: paddingRight } = config.columns[cellIndex];
            return module.exports.padString(cell, paddingLeft, paddingRight);
        });
    });
};
module.exports.padTableData = $79507ffd8aefc70a$var$padTableData;

});

parcelRegister("2xaoB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringifyTableData = void 0;

var $9JRBw = parcelRequire("9JRBw");
const $1d86ba3d30aa900b$var$stringifyTableData = (rows)=>{
    return rows.map((cells)=>{
        return cells.map((cell)=>{
            return $9JRBw.normalizeString(String(cell));
        });
    });
};
module.exports.stringifyTableData = $1d86ba3d30aa900b$var$stringifyTableData;

});

parcelRegister("4igab", function(module, exports) {
"use strict";
var $32056189fa837862$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.truncateTableData = module.exports.truncateString = void 0;

const $32056189fa837862$var$lodash_truncate_1 = $32056189fa837862$var$__importDefault((parcelRequire("jneth")));
const $32056189fa837862$var$truncateString = (input, length)=>{
    return $32056189fa837862$var$lodash_truncate_1.default(input, {
        length: length,
        omission: "\u2026"
    });
};
module.exports.truncateString = $32056189fa837862$var$truncateString;
/**
 * @todo Make it work with ASCII content.
 */ const $32056189fa837862$var$truncateTableData = (rows, config)=>{
    return rows.map((cells)=>{
        return cells.map((cell, cellIndex)=>{
            return module.exports.truncateString(cell, config.columns[cellIndex].truncate);
        });
    });
};
module.exports.truncateTableData = $32056189fa837862$var$truncateTableData;

});
parcelRegister("jneth", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
/** `Object#toString` result references. */ var regexpTag = '[object RegExp]', symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23', rsComboSymbolsRange = '\\u20d0-\\u20f0', rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsAstral = '[' + rsAstralRange + ']', rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsOptVar + reOptMod + ')*', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = '(?:' + [
    rsNonAstral + rsCombo + '?',
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var asciiSize = baseProperty('length');
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
    return string.split('');
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function stringSize(string) {
    return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while(reUnicode.test(string))result++;
    return result;
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Built-in value references. */ var Symbol = root.Symbol;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function baseIsRegExp(value) {
    return isObject(value) && objectToString.call(value) == regexpTag;
}
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */ function truncate(string, options) {
    var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
    if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
    }
    string = toString(string);
    var strLength = string.length;
    if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
    }
    if (length >= strLength) return string;
    var end = length - stringSize(omission);
    if (end < 1) return omission;
    var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
    if (separator === undefined) return result + omission;
    if (strSymbols) end += result.length - end;
    if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
            var match, substring = result;
            if (!separator.global) separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
            separator.lastIndex = 0;
            while(match = separator.exec(substring))var newEnd = match.index;
            result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
    } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) result = result.slice(0, index);
    }
    return result + omission;
}
module.exports = truncate;

});



parcelRegister("9adaX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.table = void 0;

var $rEdea = parcelRequire("rEdea");

var $bJeLm = parcelRequire("bJeLm");

var $1Ld2N = parcelRequire("1Ld2N");

var $hdgzO = parcelRequire("hdgzO");

var $hWKKk = parcelRequire("hWKKk");

var $dxIRG = parcelRequire("dxIRG");

var $apKKk = parcelRequire("apKKk");

var $2xaoB = parcelRequire("2xaoB");

var $4igab = parcelRequire("4igab");

var $1oyBw = parcelRequire("1oyBw");
const $6abf44a61f975491$var$table = (data, userConfig = {})=>{
    $1oyBw.validateTableData(data);
    let rows = $2xaoB.stringifyTableData(data);
    const config = $hWKKk.makeTableConfig(rows, userConfig);
    rows = $4igab.truncateTableData(rows, config);
    const rowHeights = $1Ld2N.calculateRowHeights(rows, config);
    rows = $dxIRG.mapDataUsingRowHeights(rows, rowHeights, config);
    rows = $rEdea.alignTableData(rows, config);
    rows = $apKKk.padTableData(rows, config);
    const cellWidths = $bJeLm.calculateCellWidths(rows[0]);
    return $hdgzO.drawTable(rows, cellWidths, rowHeights, config);
};
module.exports.table = $6abf44a61f975491$var$table;

});
parcelRegister("bJeLm", function(module, exports) {
"use strict";
var $889f594b89ef8f34$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateCellWidths = void 0;

const $889f594b89ef8f34$var$string_width_1 = $889f594b89ef8f34$var$__importDefault((parcelRequire("8be7k")));
/**
 * Calculates width of each cell contents in a row.
 */ const $889f594b89ef8f34$var$calculateCellWidths = (cells)=>{
    return cells.map((cell)=>{
        return Math.max(...cell.split('\n').map($889f594b89ef8f34$var$string_width_1.default));
    });
};
module.exports.calculateCellWidths = $889f594b89ef8f34$var$calculateCellWidths;

});

parcelRegister("hdgzO", function(module, exports) {
"use strict";
var $c88082527ef399c7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.drawTable = void 0;

const $c88082527ef399c7$var$string_width_1 = $c88082527ef399c7$var$__importDefault((parcelRequire("8be7k")));

var $k4NxI = parcelRequire("k4NxI");

var $4Cfi3 = parcelRequire("4Cfi3");

var $9BHLQ = parcelRequire("9BHLQ");

var $kQHic = parcelRequire("kQHic");

var $9JRBw = parcelRequire("9JRBw");
const $c88082527ef399c7$var$drawTable = (rows, columnWidths, rowHeights, config)=>{
    const { drawHorizontalLine: drawHorizontalLine, singleLine: singleLine } = config;
    const contents = $9JRBw.groupBySizes(rows, rowHeights).map((group)=>{
        return group.map((row)=>{
            return $kQHic.drawRow(row, config);
        }).join('');
    });
    if (config.header) {
        // assume that topLeft/right border have width = 1
        const headerWidth = $c88082527ef399c7$var$string_width_1.default($kQHic.drawRow(rows[0], config)) - 2 - config.header.paddingLeft - config.header.paddingRight;
        const header = $9BHLQ.drawHeader(headerWidth, config);
        contents.unshift(header);
    }
    return $4Cfi3.drawContent(contents, {
        drawSeparator: (index, size)=>{
            // Top/bottom border
            if (index === 0 || index === size) return drawHorizontalLine(index, size);
            return !singleLine && drawHorizontalLine(index, size);
        },
        separatorGetter: $k4NxI.createTableBorderGetter(columnWidths, config)
    });
};
module.exports.drawTable = $c88082527ef399c7$var$drawTable;

});
parcelRegister("9BHLQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.drawHeader = void 0;

var $hpX81 = parcelRequire("hpX81");

var $kQHic = parcelRequire("kQHic");

var $apKKk = parcelRequire("apKKk");

var $4igab = parcelRequire("4igab");

var $luZCz = parcelRequire("luZCz");
const $6fe985b49d97ea59$var$drawHeader = (width, config)=>{
    if (!config.header) throw new Error('Can not draw header without header configuration');
    const { alignment: alignment, paddingRight: paddingRight, paddingLeft: paddingLeft, wrapWord: wrapWord } = config.header;
    let content = config.header.content;
    content = $4igab.truncateString(content, config.header.truncate);
    const headerLines = $luZCz.wrapCell(content, width, wrapWord);
    return headerLines.map((headerLine)=>{
        let line = $hpX81.alignString(headerLine, width, alignment);
        line = $apKKk.padString(line, paddingLeft, paddingRight);
        return $kQHic.drawRow([
            line
        ], {
            ...config,
            drawVerticalLine: (index)=>{
                const columnCount = config.columns.length;
                return config.drawVerticalLine(index === 0 ? 0 : columnCount, columnCount);
            }
        });
    }).join('');
};
module.exports.drawHeader = $6fe985b49d97ea59$var$drawHeader;

});


parcelRegister("hWKKk", function(module, exports) {
"use strict";
var $d10c1d4a820c7e9e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeTableConfig = void 0;

const $d10c1d4a820c7e9e$var$lodash_clonedeep_1 = $d10c1d4a820c7e9e$var$__importDefault((parcelRequire("3vein")));

const $d10c1d4a820c7e9e$var$calculateColumnWidths_1 = $d10c1d4a820c7e9e$var$__importDefault((parcelRequire("4EANR")));

var $9JRBw = parcelRequire("9JRBw");

var $hjFj1 = parcelRequire("hjFj1");
/**
 * Creates a configuration for every column using default
 * values for the missing configuration properties.
 */ const $d10c1d4a820c7e9e$var$makeColumnsConfig = (rows, columns, columnDefault)=>{
    const columnWidths = $d10c1d4a820c7e9e$var$calculateColumnWidths_1.default(rows);
    return rows[0].map((_, columnIndex)=>{
        return {
            alignment: 'left',
            paddingLeft: 1,
            paddingRight: 1,
            truncate: Number.POSITIVE_INFINITY,
            verticalAlignment: 'top',
            width: columnWidths[columnIndex],
            wrapWord: false,
            ...columnDefault,
            ...columns === null || columns === void 0 ? void 0 : columns[columnIndex]
        };
    });
};
const $d10c1d4a820c7e9e$var$makeHeaderConfig = (config)=>{
    if (!config.header) return undefined;
    return {
        alignment: 'center',
        paddingLeft: 1,
        paddingRight: 1,
        truncate: Number.POSITIVE_INFINITY,
        wrapWord: false,
        ...config.header
    };
};
/**
 * Makes a new configuration object out of the userConfig object
 * using default values for the missing configuration properties.
 */ const $d10c1d4a820c7e9e$var$makeTableConfig = (rows, userConfig = {})=>{
    var _a, _b, _c;
    $hjFj1.validateConfig('config.json', userConfig);
    const config = $d10c1d4a820c7e9e$var$lodash_clonedeep_1.default(userConfig);
    return {
        ...config,
        border: $9JRBw.makeBorderConfig(config.border),
        columns: $d10c1d4a820c7e9e$var$makeColumnsConfig(rows, config.columns, config.columnDefault),
        drawHorizontalLine: (_a = config.drawHorizontalLine) !== null && _a !== void 0 ? _a : ()=>{
            return true;
        },
        drawVerticalLine: (_b = config.drawVerticalLine) !== null && _b !== void 0 ? _b : ()=>{
            return true;
        },
        header: $d10c1d4a820c7e9e$var$makeHeaderConfig(config),
        singleLine: (_c = config.singleLine) !== null && _c !== void 0 ? _c : false
    };
};
module.exports.makeTableConfig = $d10c1d4a820c7e9e$var$makeTableConfig;

});
parcelRegister("4EANR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bJeLm = parcelRequire("bJeLm");
/**
 * Produces an array of values that describe the largest value length (width) in every column.
 */ module.exports.default = (rows)=>{
    const columnWidths = new Array(rows[0].length).fill(0);
    rows.forEach((row)=>{
        const cellWidths = $bJeLm.calculateCellWidths(row);
        cellWidths.forEach((cellWidth, cellIndex)=>{
            columnWidths[cellIndex] = Math.max(columnWidths[cellIndex], cellWidth);
        });
    });
    return columnWidths;
};

});


parcelRegister("1oyBw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTableData = void 0;

var $9JRBw = parcelRequire("9JRBw");
const $1042dffe70bfdc24$var$validateTableData = (rows)=>{
    if (!Array.isArray(rows)) throw new TypeError('Table data must be an array.');
    if (rows.length === 0) throw new Error('Table must define at least one row.');
    if (rows[0].length === 0) throw new Error('Table must define at least one column.');
    const columnNumber = rows[0].length;
    for (const row of rows){
        if (!Array.isArray(row)) throw new TypeError('Table row data must be an array.');
        if (row.length !== columnNumber) throw new Error('Table must have a consistent number of cells.');
        for (const cell of row){
            // eslint-disable-next-line no-control-regex
            if (/[\u0001-\u0006\u0008\u0009\u000B-\u001A]/.test($9JRBw.normalizeString(String(cell)))) throw new Error('Table data must not contain control characters.');
        }
    }
};
module.exports.validateTableData = $1042dffe70bfdc24$var$validateTableData;

});


parcelRegister("7mBHe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("hmLMy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlotlyLib = void 0;

var $9ilgM = parcelRequire("9ilgM");
var $ca498e4af64b55c0$var$Plotly;

if (typeof window !== "undefined") //check if in browser environment and require "plotly.js-dist-min" module
$ca498e4af64b55c0$var$Plotly = (parcelRequire("1X4Za"));
var $ca498e4af64b55c0$var$PlotlyLib = /** @class */ function() {
    function PlotlyLib(ndframe, divId) {
        this.ndframe = ndframe;
        this.divId = divId;
    }
    PlotlyLib.prototype.getPlotConfig = function(plotConfig) {
        var _plotConfig = {
            config: plotConfig && plotConfig.config ? plotConfig.config : {},
            layout: plotConfig && plotConfig.layout ? plotConfig.layout : {}
        };
        return _plotConfig;
    };
    /**
     * Plot Series or DataFrame as lines.
     * Uses Plotly library as backend, so supports Plotly's configuration parameters
     * @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
    */ PlotlyLib.prototype.line = function(plotConfig) {
        var _plotConfig = this.getPlotConfig(plotConfig);
        (0, $9ilgM.linePlot)(this.ndframe, this.divId, _plotConfig, $ca498e4af64b55c0$var$Plotly);
    };
    /**
     * Plot Series or DataFrame as bars.
     * Uses Plotly library as backend, so supports Plotly's configuration parameters
     * @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
    */ PlotlyLib.prototype.bar = function(plotConfig) {
        var _plotConfig = this.getPlotConfig(plotConfig);
        (0, $9ilgM.barPlot)(this.ndframe, this.divId, _plotConfig, $ca498e4af64b55c0$var$Plotly);
    };
    /**
     * Plot Series or DataFrame as scatter.
     * Uses Plotly library as backend, so supports Plotly's configuration parameters
     * @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
    */ PlotlyLib.prototype.scatter = function(plotConfig) {
        var _plotConfig = this.getPlotConfig(plotConfig);
        (0, $9ilgM.scatterPlot)(this.ndframe, this.divId, _plotConfig, $ca498e4af64b55c0$var$Plotly);
    };
    /**
     * Plot Series or DataFrame as histogram.
     * Uses Plotly library as backend, so supports Plotly's configuration parameters
     * @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
    */ PlotlyLib.prototype.hist = function(plotConfig) {
        var _plotConfig = this.getPlotConfig(plotConfig);
        (0, $9ilgM.histPlot)(this.ndframe, this.divId, _plotConfig, $ca498e4af64b55c0$var$Plotly);
    };
    /**
     * Plot Series or DataFrame as pie.
     * Uses Plotly library as backend, so supports Plotly's configuration parameters
     * @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
    */ PlotlyLib.prototype.pie = function(plotConfig) {
        var _plotConfig = this.getPlotConfig(plotConfig);
        (0, $9ilgM.piePlot)(this.ndframe, this.divId, _plotConfig, $ca498e4af64b55c0$var$Plotly);
    };
    /**
     * Plot Series or DataFrame as boxplot.
     * Uses Plotly library as backend, so supports Plotly's configuration parameters
     * @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
    */ PlotlyLib.prototype.box = function(plotConfig) {
        var _plotConfig = this.getPlotConfig(plotConfig);
        (0, $9ilgM.boxPlot)(this.ndframe, this.divId, _plotConfig, $ca498e4af64b55c0$var$Plotly);
    };
    /**
     * Plot Series or DataFrame as violinplot.
     * Uses Plotly library as backend, so supports Plotly's configuration parameters
     * @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
     */ PlotlyLib.prototype.violin = function(plotConfig) {
        var _plotConfig = this.getPlotConfig(plotConfig);
        (0, $9ilgM.violinPlot)(this.ndframe, this.divId, _plotConfig, $ca498e4af64b55c0$var$Plotly);
    };
    /**
     * Plot Series or DataFrame as table.
     * Uses Plotly library as backend, so supports Plotly's configuration parameters
     * @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
     */ PlotlyLib.prototype.table = function(plotConfig) {
        var _plotConfig = this.getPlotConfig(plotConfig);
        (0, $9ilgM.tablePlot)(this.ndframe, this.divId, _plotConfig, $ca498e4af64b55c0$var$Plotly);
    };
    return PlotlyLib;
}();
module.exports.PlotlyLib = $ca498e4af64b55c0$var$PlotlyLib;

});
parcelRegister("9ilgM", function(module, exports) {
"use strict";
/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tablePlot = module.exports.violinPlot = module.exports.boxPlot = module.exports.piePlot = module.exports.histPlot = module.exports.scatterPlot = module.exports.barPlot = module.exports.linePlot = void 0;

var $lhFy2 = parcelRequire("lhFy2");
Object.defineProperty(module.exports, "linePlot", {
    enumerable: true,
    get: function() {
        return $lhFy2.linePlot;
    }
});

var $gxbzo = parcelRequire("gxbzo");
Object.defineProperty(module.exports, "barPlot", {
    enumerable: true,
    get: function() {
        return $gxbzo.barPlot;
    }
});

var $gdsa4 = parcelRequire("gdsa4");
Object.defineProperty(module.exports, "scatterPlot", {
    enumerable: true,
    get: function() {
        return $gdsa4.scatterPlot;
    }
});

var $1GL6C = parcelRequire("1GL6C");
Object.defineProperty(module.exports, "histPlot", {
    enumerable: true,
    get: function() {
        return $1GL6C.histPlot;
    }
});

var $1L4bM = parcelRequire("1L4bM");
Object.defineProperty(module.exports, "piePlot", {
    enumerable: true,
    get: function() {
        return $1L4bM.piePlot;
    }
});

var $imLaB = parcelRequire("imLaB");
Object.defineProperty(module.exports, "boxPlot", {
    enumerable: true,
    get: function() {
        return $imLaB.boxPlot;
    }
});

var $kwhwX = parcelRequire("kwhwX");
Object.defineProperty(module.exports, "violinPlot", {
    enumerable: true,
    get: function() {
        return $kwhwX.violinPlot;
    }
});

var $bop59 = parcelRequire("bop59");
Object.defineProperty(module.exports, "tablePlot", {
    enumerable: true,
    get: function() {
        return $bop59.tablePlot;
    }
});

});
parcelRegister("lhFy2", function(module, exports) {
"use strict";
var $f7eb6a11ad507864$var$__assign = module.exports && module.exports.__assign || function() {
    $f7eb6a11ad507864$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f7eb6a11ad507864$var$__assign.apply(this, arguments);
};
var $f7eb6a11ad507864$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.linePlot = void 0;

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $f7eb6a11ad507864$var$series_1 = $f7eb6a11ad507864$var$__importDefault((parcelRequire("hIkcL")));

var $8qPKa = parcelRequire("8qPKa");
/**
* Plot Series or DataFrame as lines.
* Uses the Plotly as backend, so supoorts Plotly's configuration parameters,
* Line plot supports different types of parameters, and the behavior will depend on data specified.
* The precedence of columns to plot is: (x and y => x => y => columns).
* @param ndframe Series or DataFrame to plot
* @param divId HTML div id to plot in.
* @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
* @param Plotly Plotly package passed from the class.
*/ var $f7eb6a11ad507864$var$linePlot = function(ndframe, divId, plotConfig, Plotly) {
    var config = plotConfig["config"];
    var layout = plotConfig["layout"];
    if (ndframe instanceof $f7eb6a11ad507864$var$series_1.default) {
        var y = ndframe.values;
        var trace = {
            x: ndframe.index,
            y: y,
            type: 'scatter',
            mode: 'lines'
        };
        Plotly.newPlot(divId, [
            trace
        ], layout, config);
    } else {
        if (config["x"] && config["y"]) {
            //Plotting two columns against each other, when user specifies x and y column names in configuration
            (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config["x"]);
            (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config["y"]);
            var x = ndframe[config.x].values;
            var y = ndframe[config.y].values;
            var trace = {
                x: x,
                y: y
            };
            var _layout = $f7eb6a11ad507864$var$__assign({
                xaxis: {
                    title: config.x
                },
                yaxis: {
                    title: config.y
                }
            }, layout);
            Plotly.newPlot(divId, [
                trace
            ], _layout, config);
        } else if (config["x"] || config["y"]) {
            //plot single column specified in either of param [x | y] against index
            if (config["x"]) {
                (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config.x);
                var x = ndframe[config.x].values;
                var y = ndframe.index;
                var trace = {
                    x: x,
                    y: y
                };
                var _layout = $f7eb6a11ad507864$var$__assign({
                    xaxis: {
                        title: config.x
                    },
                    yaxis: {
                        title: "Index"
                    }
                }, layout);
                Plotly.newPlot(divId, [
                    trace
                ], _layout, config);
            }
            if (config["y"]) {
                (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config.y);
                var x = ndframe.index;
                var y = ndframe[config.y].values;
                var trace = {
                    x: x,
                    y: y
                };
                var _layout = $f7eb6a11ad507864$var$__assign({
                    xaxis: {
                        title: "Index"
                    },
                    yaxis: {
                        title: config.y
                    }
                }, layout);
                Plotly.newPlot(divId, [
                    trace
                ], _layout, config);
            }
        } else {
            //plot specified columns in config param against index
            // if columns is not specified in config, then plot all columns
            var cols = config["columns"] ? (0, $8qPKa.checkIfColsExist)(ndframe, config['columns']) : ndframe.columns;
            var traces_1 = [];
            cols.forEach(function(col) {
                var x = ndframe.index;
                var y = ndframe[col].values;
                var trace = {
                    x: x,
                    y: y,
                    name: col
                };
                traces_1.push(trace);
            });
            Plotly.newPlot(divId, traces_1, layout, config);
        }
    }
};
module.exports.linePlot = $f7eb6a11ad507864$var$linePlot;

});
parcelRegister("8qPKa", function(module, exports) {
"use strict";
/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.throwErrorOnWrongColName = module.exports.checkIfColsExist = void 0;
var $6238e3a316e36795$var$checkIfColsExist = function(ndframe, cols) {
    cols.forEach(function(col) {
        if (!ndframe.columns.includes(col)) throw Error("Column Error: " + col + " not found in columns. Columns should be one of [ " + ndframe.columns + " ]");
    });
    return cols;
};
module.exports.checkIfColsExist = $6238e3a316e36795$var$checkIfColsExist;
var $6238e3a316e36795$var$throwErrorOnWrongColName = function(ndframe, colName) {
    if (!ndframe.columns.includes(colName)) throw Error("ParamError: specified column " + colName + " not found in columns");
};
module.exports.throwErrorOnWrongColName = $6238e3a316e36795$var$throwErrorOnWrongColName;

});


parcelRegister("gxbzo", function(module, exports) {
"use strict";
var $c098b3eb5f3b02ee$var$__assign = module.exports && module.exports.__assign || function() {
    $c098b3eb5f3b02ee$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c098b3eb5f3b02ee$var$__assign.apply(this, arguments);
};
var $c098b3eb5f3b02ee$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.barPlot = void 0;

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $c098b3eb5f3b02ee$var$series_1 = $c098b3eb5f3b02ee$var$__importDefault((parcelRequire("hIkcL")));

var $8qPKa = parcelRequire("8qPKa");
/**
* Plot Series or DataFrame as bar.
* Uses the Plotly as backend, so supoorts Plotly's configuration parameters,
* Line plot supports different types of parameters, and the behavior will depend on data specified.
* The precedence of columns to plot is: (x and y => x => y => columns).
* @param ndframe Series or DataFrame to plot
* @param divId HTML div id to plot in.
* @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
*/ var $c098b3eb5f3b02ee$var$barPlot = function(ndframe, divId, plotConfig, Plotly) {
    var config = plotConfig["config"];
    var layout = plotConfig["layout"];
    if (ndframe instanceof $c098b3eb5f3b02ee$var$series_1.default) {
        var trace = {
            x: ndframe.index,
            y: ndframe.values,
            type: 'bar'
        };
        Plotly.newPlot(divId, [
            trace
        ], layout, config);
    } else {
        if (config["x"] && config["y"]) {
            //Plotting two columns against each other, when user specifies x and y column names in configuration
            (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config["x"]);
            (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config["y"]);
            var x = ndframe[config.x].values;
            var y = ndframe[config.y].values;
            var trace = {
                x: x,
                y: y,
                type: 'bar'
            };
            var _layout = $c098b3eb5f3b02ee$var$__assign({
                xaxis: {
                    title: config.x
                },
                yaxis: {
                    title: config.y
                }
            }, layout);
            Plotly.newPlot(divId, [
                trace
            ], _layout, config);
        } else if (config["x"] || config["y"]) {
            //plot single column specified in either of param [x | y] against index
            if (config["x"]) {
                (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config.x);
                var x = ndframe[config.x].values;
                var y = ndframe.index;
                var trace = {
                    x: x,
                    y: y,
                    type: 'bar'
                };
                var _layout = $c098b3eb5f3b02ee$var$__assign({
                    xaxis: {
                        title: config.x
                    },
                    yaxis: {
                        title: "Index"
                    }
                }, layout);
                Plotly.newPlot(divId, [
                    trace
                ], _layout, config);
            }
            if (config["y"]) {
                (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config.y);
                var x = ndframe.index;
                var y = ndframe[config.y].values;
                var trace = {
                    x: x,
                    y: y,
                    type: 'bar'
                };
                var _layout = $c098b3eb5f3b02ee$var$__assign({
                    xaxis: {
                        title: "Index"
                    },
                    yaxis: {
                        title: config.y
                    }
                }, layout);
                Plotly.newPlot(divId, [
                    trace
                ], _layout, config);
            }
        } else {
            //plot specified columns in config param against index
            // if columns is not specified in config, then plot all columns
            var cols = config["columns"] ? (0, $8qPKa.checkIfColsExist)(ndframe, config['columns']) : ndframe.columns;
            var traces_1 = [];
            cols.forEach(function(col) {
                var x = ndframe.index;
                var y = ndframe[col].values;
                var trace = {
                    x: x,
                    y: y,
                    name: col,
                    type: 'bar'
                };
                traces_1.push(trace);
            });
            Plotly.newPlot(divId, traces_1, layout, config);
        }
    }
};
module.exports.barPlot = $c098b3eb5f3b02ee$var$barPlot;

});

parcelRegister("gdsa4", function(module, exports) {
"use strict";
var $bce3b483610eaafe$var$__assign = module.exports && module.exports.__assign || function() {
    $bce3b483610eaafe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bce3b483610eaafe$var$__assign.apply(this, arguments);
};
var $bce3b483610eaafe$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scatterPlot = void 0;

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $bce3b483610eaafe$var$series_1 = $bce3b483610eaafe$var$__importDefault((parcelRequire("hIkcL")));

var $8qPKa = parcelRequire("8qPKa");
/**
* Plot Series or DataFrame as scatter points.
* Uses the Plotly as backend, so supoorts Plotly's configuration parameters,
* Line plot supports different types of parameters, and the behavior will depend on data specified.
* The precedence of columns to plot is: (x and y => x => y => columns).
* @param ndframe Series or DataFrame to plot
* @param divId HTML div id to plot in.
* @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
*/ var $bce3b483610eaafe$var$scatterPlot = function(ndframe, divId, plotConfig, Plotly) {
    var config = plotConfig["config"];
    var layout = plotConfig["layout"];
    if (ndframe instanceof $bce3b483610eaafe$var$series_1.default) {
        var y = ndframe.values;
        var trace = {
            x: ndframe.index,
            y: y,
            type: 'scatter',
            mode: 'markers'
        };
        Plotly.newPlot(divId, [
            trace
        ], layout, config);
    } else {
        if (config["x"] && config["y"]) {
            //Plotting two columns against each other, when user specifies x and y column names in configuration
            (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config["x"]);
            (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config["y"]);
            var x = ndframe[config.x].values;
            var y = ndframe[config.y].values;
            var trace = {
                x: x,
                y: y,
                type: 'scatter',
                mode: 'markers'
            };
            var _layout = $bce3b483610eaafe$var$__assign({
                xaxis: {
                    title: config.x
                },
                yaxis: {
                    title: config.y
                }
            }, layout);
            Plotly.newPlot(divId, [
                trace
            ], _layout, config);
        } else if (config["x"] || config["y"]) {
            //plot single column specified in either of param [x | y] against index
            if (config["x"]) {
                (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config.x);
                var x = ndframe[config.x].values;
                var y = ndframe.index;
                var trace = {
                    x: x,
                    y: y,
                    type: 'scatter',
                    mode: 'markers'
                };
                var _layout = $bce3b483610eaafe$var$__assign({
                    xaxis: {
                        title: config.x
                    },
                    yaxis: {
                        title: "Index"
                    }
                }, layout);
                Plotly.newPlot(divId, [
                    trace
                ], _layout, config);
            }
            if (config["y"]) {
                (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config.y);
                var x = ndframe.index;
                var y = ndframe[config.y].values;
                var trace = {
                    x: x,
                    y: y,
                    type: 'scatter',
                    mode: 'markers'
                };
                var _layout = $bce3b483610eaafe$var$__assign({
                    xaxis: {
                        title: "Index"
                    },
                    yaxis: {
                        title: config.y
                    }
                }, layout);
                Plotly.newPlot(divId, [
                    trace
                ], _layout, config);
            }
        } else {
            //plot specified columns in config param against index
            // if columns is not specified in config, then plot all columns
            var cols = config["columns"] ? (0, $8qPKa.checkIfColsExist)(ndframe, config['columns']) : ndframe.columns;
            var traces_1 = [];
            cols.forEach(function(col) {
                var y = ndframe.index;
                var x = ndframe[col].values;
                var trace = {
                    x: x,
                    y: y,
                    name: col,
                    type: 'scatter',
                    mode: 'markers'
                };
                traces_1.push(trace);
            });
            Plotly.newPlot(divId, traces_1, layout, config);
        }
    }
};
module.exports.scatterPlot = $bce3b483610eaafe$var$scatterPlot;

});

parcelRegister("1GL6C", function(module, exports) {
"use strict";
var $13ae40ed6bc308db$var$__assign = module.exports && module.exports.__assign || function() {
    $13ae40ed6bc308db$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $13ae40ed6bc308db$var$__assign.apply(this, arguments);
};
var $13ae40ed6bc308db$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.histPlot = void 0;

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $13ae40ed6bc308db$var$series_1 = $13ae40ed6bc308db$var$__importDefault((parcelRequire("hIkcL")));

var $8qPKa = parcelRequire("8qPKa");
/**
* Plot Series or DataFrame as histogram.
* Uses the Plotly as backend, so supoorts Plotly's configuration parameters,
* Line plot supports different types of parameters, and the behavior will depend on data specified.
* The precedence of columns to plot is: (x and y => x => y => columns).
* @param ndframe Series or DataFrame to plot
* @param divId HTML div id to plot in.
* @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
*/ var $13ae40ed6bc308db$var$histPlot = function(ndframe, divId, plotConfig, Plotly) {
    var config = plotConfig["config"];
    var layout = plotConfig["layout"];
    if (ndframe instanceof $13ae40ed6bc308db$var$series_1.default) {
        var trace = {
            x: ndframe.values,
            type: 'histogram'
        };
        Plotly.newPlot(divId, [
            trace
        ], layout, config);
    } else if (config["x"] || config["y"]) {
        //plot single column specified in either of param [x | y] against index
        if (config["x"]) {
            (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config.x);
            var x = ndframe[config.x].values;
            var trace = {
                x: x,
                type: 'histogram'
            };
            var _layout = $13ae40ed6bc308db$var$__assign({
                xaxis: {
                    title: config.x
                }
            }, layout);
            Plotly.newPlot(divId, [
                trace
            ], _layout, config);
        }
        if (config["y"]) {
            (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config.y);
            var y = ndframe[config.y].values;
            var trace = {
                y: y,
                type: 'histogram'
            };
            var _layout = $13ae40ed6bc308db$var$__assign({
                yaxis: {
                    title: config.y
                }
            }, layout);
            Plotly.newPlot(divId, [
                trace
            ], _layout, config);
        }
    } else {
        //plot specified columns in config param against index
        // if columns is not specified in config, then plot all columns
        var cols = config["columns"] ? (0, $8qPKa.checkIfColsExist)(ndframe, config['columns']) : ndframe.columns;
        var traces_1 = [];
        cols.forEach(function(col) {
            var y = ndframe.index;
            var x = ndframe[col].values;
            var trace = {
                x: x,
                y: y,
                name: col,
                type: 'histogram'
            };
            traces_1.push(trace);
        });
        Plotly.newPlot(divId, traces_1, layout, config);
    }
};
module.exports.histPlot = $13ae40ed6bc308db$var$histPlot;

});

parcelRegister("1L4bM", function(module, exports) {
"use strict";
// @ts-nocheck
var $147d6e0fc98d446a$var$__assign = module.exports && module.exports.__assign || function() {
    $147d6e0fc98d446a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $147d6e0fc98d446a$var$__assign.apply(this, arguments);
};
var $147d6e0fc98d446a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.piePlot = void 0;

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $147d6e0fc98d446a$var$series_1 = $147d6e0fc98d446a$var$__importDefault((parcelRequire("hIkcL")));

var $8qPKa = parcelRequire("8qPKa");
/**
* Plot Series or DataFrame as pie chart.
* Uses the Plotly as backend, so supoorts Plotly's configuration parameters,
* Line plot supports different types of parameters, and the behavior will depend on data specified.
* @param ndframe Series or DataFrame to plot
* @param divId HTML div id to plot in.
* @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
*/ var $147d6e0fc98d446a$var$piePlot = function(ndframe, divId, plotConfig, Plotly) {
    var config = plotConfig["config"];
    var layout = plotConfig["layout"];
    if (ndframe instanceof $147d6e0fc98d446a$var$series_1.default) {
        var trace = {
            values: ndframe.values,
            labels: config["labels"] || ndframe.index,
            type: 'pie',
            name: config.labels,
            hoverinfo: 'label+percent+name',
            automargin: true
        };
        Plotly.newPlot(divId, [
            trace
        ], layout, config);
    } else {
        if (config["labels"]) {
            if (!ndframe.columns.includes(config['labels'])) throw Error("Column Error: " + config['labels'] + " not found in columns. Param \"labels\" name must be one of [ " + ndframe.columns + "]");
            if (config["values"]) {
                if (!ndframe.columns.includes(config['values'])) throw Error("Column Error: " + config['values'] + " not found in columns. Param \"values\" name must be one of [ " + ndframe.columns + "]");
                var trace = {
                    values: ndframe[config['values']].values,
                    labels: ndframe[config["labels"]].values,
                    type: 'pie',
                    name: config.labels,
                    hoverinfo: 'label+percent+name',
                    automargin: true
                };
                Plotly.newPlot(divId, [
                    trace
                ], layout, config);
            } else {
                // if columns is not specified in config, then plot all columns
                var cols = config["columns"] ? (0, $8qPKa.checkIfColsExist)(ndframe, config['columns']) : ndframe.columns;
                if (config['rowPositions']) {
                    if (config['rowPositions'].length != cols.length) throw Error("length of rowPositions array must be equal to number of columns. Got " + config['rowPositions'].length + ", expected " + (cols.length - 1));
                } else {
                    var tempArr = [];
                    for(var i = 0; i < cols.length - 1; i++)tempArr.push(0);
                    config['rowPositions'] = tempArr;
                }
                if (config['columnPositions']) {
                    if (config['columnPositions'].length != cols.length) throw Error("length of columnPositions array must be equal to number of columns. Got " + config['columnPositions'].length + ", expected " + (cols.length - 1));
                } else {
                    var tempArr = [];
                    for(var i = 0; i < cols.length - 1; i++)tempArr.push(i);
                    config['columnPositions'] = tempArr;
                }
                var traces_1 = [];
                cols.forEach(function(col, i) {
                    var labels = ndframe[config["labels"]].values;
                    var values = ndframe[col].values;
                    var trace = {
                        labels: labels,
                        values: values,
                        name: col,
                        type: 'pie',
                        domain: {
                            row: config['rowPositions'][i],
                            column: config['columnPositions'][i]
                        },
                        hoverinfo: 'label+percent+name',
                        automargin: true,
                        textposition: 'outside'
                    };
                    traces_1.push(trace);
                });
                var _layout = $147d6e0fc98d446a$var$__assign({}, layout);
                if (!config["grid"]) {
                    //set default grid
                    var size = Number((ndframe.shape[1] / 2).toFixed()) + 1;
                    _layout["grid"] = {
                        rows: size,
                        columns: size
                    };
                } else _layout["grid"] = config["grid"];
                Plotly.newPlot(divId, traces_1, _layout, config);
            }
        } else throw new Error("Param Error: Please provide a column name for \"labels\" param");
    }
};
module.exports.piePlot = $147d6e0fc98d446a$var$piePlot;

});

parcelRegister("imLaB", function(module, exports) {
"use strict";
var $d5eedf0c551e2996$var$__assign = module.exports && module.exports.__assign || function() {
    $d5eedf0c551e2996$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d5eedf0c551e2996$var$__assign.apply(this, arguments);
};
var $d5eedf0c551e2996$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.boxPlot = void 0;

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $d5eedf0c551e2996$var$series_1 = $d5eedf0c551e2996$var$__importDefault((parcelRequire("hIkcL")));

var $8qPKa = parcelRequire("8qPKa");
/**
* Plot Series or DataFrame as box chart.
* Uses the Plotly as backend, so supoorts Plotly's configuration parameters,
* Line plot supports different types of parameters, and the behavior will depend on data specified.
* The precedence of columns to plot is: (x and y => x => y => columns).
* @param ndframe Series or DataFrame to plot
* @param divId HTML div id to plot in.
* @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
*/ var $d5eedf0c551e2996$var$boxPlot = function(ndframe, divId, plotConfig, Plotly) {
    var config = plotConfig["config"];
    var layout = plotConfig["layout"];
    if (ndframe instanceof $d5eedf0c551e2996$var$series_1.default) {
        var trace = {
            y: ndframe.values,
            type: 'box'
        };
        Plotly.newPlot(divId, [
            trace
        ], layout, config);
    } else {
        if (config["x"] && config["y"]) {
            //Plotting two columns against each other, when user specifies x and y column names in configuration
            (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config["x"]);
            (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config["y"]);
            var x = ndframe[config.x].values;
            var y = ndframe[config.y].values;
            var trace = {
                x: x,
                y: y,
                type: 'box'
            };
            var _layout = $d5eedf0c551e2996$var$__assign({
                xaxis: {
                    title: config.x
                },
                yaxis: {
                    title: config.y
                }
            }, layout);
            Plotly.newPlot(divId, [
                trace
            ], _layout, config);
        } else if (config["x"] || config["y"]) {
            //plot single column specified in either of param [x | y] against index
            if (config["x"]) {
                (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config.x);
                var x = ndframe[config.x].values;
                var y = ndframe.index;
                var trace = {
                    x: x,
                    y: y,
                    type: 'box'
                };
                var _layout = $d5eedf0c551e2996$var$__assign({
                    xaxis: {
                        title: config.x
                    },
                    yaxis: {
                        title: "Index"
                    }
                }, layout);
                Plotly.newPlot(divId, [
                    trace
                ], _layout, config);
            }
            if (config["y"]) {
                (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config.y);
                var x = ndframe.index;
                var y = ndframe[config.y].values;
                var trace = {
                    x: x,
                    y: y,
                    type: 'box'
                };
                var _layout = $d5eedf0c551e2996$var$__assign({
                    xaxis: {
                        title: "Index"
                    },
                    yaxis: {
                        title: config.y
                    }
                }, layout);
                Plotly.newPlot(divId, [
                    trace
                ], _layout, config);
            }
        } else {
            //plot specified columns in config param against index
            // if columns is not specified in config, then plot all columns
            var cols = config["columns"] ? (0, $8qPKa.checkIfColsExist)(ndframe, config['columns']) : ndframe.columns;
            var traces_1 = [];
            cols.forEach(function(col) {
                var y = ndframe[col].values;
                var trace = {
                    y: y,
                    name: col,
                    type: 'box'
                };
                traces_1.push(trace);
            });
            Plotly.newPlot(divId, traces_1, layout, config);
        }
    }
};
module.exports.boxPlot = $d5eedf0c551e2996$var$boxPlot;

});

parcelRegister("kwhwX", function(module, exports) {
"use strict";
var $ef04650071e6ee2b$var$__assign = module.exports && module.exports.__assign || function() {
    $ef04650071e6ee2b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ef04650071e6ee2b$var$__assign.apply(this, arguments);
};
var $ef04650071e6ee2b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.violinPlot = void 0;

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $ef04650071e6ee2b$var$series_1 = $ef04650071e6ee2b$var$__importDefault((parcelRequire("hIkcL")));

var $8qPKa = parcelRequire("8qPKa");
/**
* Plot Series or DataFrame as violin chart.
* Uses the Plotly as backend, so supoorts Plotly's configuration parameters,
* Line plot supports different types of parameters, and the behavior will depend on data specified.
* The precedence of columns to plot is: (x and y => x => y => columns).
* @param ndframe Series or DataFrame to plot
* @param divId HTML div id to plot in.
* @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
*/ var $ef04650071e6ee2b$var$violinPlot = function(ndframe, divId, plotConfig, Plotly) {
    var config = plotConfig["config"];
    var layout = plotConfig["layout"];
    if (ndframe instanceof $ef04650071e6ee2b$var$series_1.default) {
        var trace = {
            y: ndframe.values,
            type: 'violin'
        };
        Plotly.newPlot(divId, [
            trace
        ], layout, config);
    } else {
        if (config["x"] && config["y"]) {
            //Plotting two columns against each other, when user specifies x and y column names in configuration
            (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config["x"]);
            (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config["y"]);
            var x = ndframe[config.x].values;
            var y = ndframe[config.y].values;
            var trace = {
                x: x,
                y: y,
                type: 'violin'
            };
            var _layout = $ef04650071e6ee2b$var$__assign({
                xaxis: {
                    title: config.x
                },
                yaxis: {
                    title: config.y
                }
            }, layout);
            Plotly.newPlot(divId, [
                trace
            ], _layout, config);
        } else if (config["x"] || config["y"]) {
            //plot single column specified in either of param [x | y] against index
            if (config["x"]) {
                (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config.x);
                var x = ndframe[config.x].values;
                var y = ndframe.index;
                var trace = {
                    x: x,
                    y: y,
                    type: 'violin'
                };
                var _layout = $ef04650071e6ee2b$var$__assign({
                    xaxis: {
                        title: config.x
                    },
                    yaxis: {
                        title: "Index"
                    }
                }, layout);
                Plotly.newPlot(divId, [
                    trace
                ], _layout, config);
            }
            if (config["y"]) {
                (0, $8qPKa.throwErrorOnWrongColName)(ndframe, config.y);
                var x = ndframe.index;
                var y = ndframe[config.y].values;
                var trace = {
                    x: x,
                    y: y,
                    type: 'violin'
                };
                var _layout = $ef04650071e6ee2b$var$__assign({
                    xaxis: {
                        title: "Index"
                    },
                    yaxis: {
                        title: config.y
                    }
                }, layout);
                Plotly.newPlot(divId, [
                    trace
                ], _layout, config);
            }
        } else {
            //plot specified columns in config param against index
            // if columns is not specified in config, then plot all columns
            var cols = config["columns"] ? (0, $8qPKa.checkIfColsExist)(ndframe, config['columns']) : ndframe.columns;
            var traces_1 = [];
            cols.forEach(function(col) {
                var y = ndframe[col].values;
                var trace = {
                    y: y,
                    name: col,
                    type: 'violin'
                };
                traces_1.push(trace);
            });
            Plotly.newPlot(divId, traces_1, layout, config);
        }
    }
};
module.exports.violinPlot = $ef04650071e6ee2b$var$violinPlot;

});

parcelRegister("bop59", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tablePlot = void 0;
/**
* Display Series or DataFrame as table.
* Uses the Plotly as backend, so supoorts Plotly's configuration parameters,
* @param ndframe Series or DataFrame to plot
* @param divId HTML div id to plot in.
* @param plotConfig configuration options for making Plots, supports Plotly.js Config and Layout parameters.
*/ var $84b5645b4822c82f$var$tablePlot = function(ndframe, divId, plotConfig, Plotly) {
    var config = plotConfig["config"];
    var layout = plotConfig["layout"];
    var header = {};
    var cells = {};
    var colsData = [];
    var cols2Show = [];
    if (config['columns']) {
        config['columns'].forEach(function(cname) {
            if (!ndframe.columns.includes(cname)) throw Error("Column Error: " + cname + " not found in columns. Columns should be one of [ " + ndframe.columns + " ]");
            var idx = ndframe.columns.indexOf(cname);
            colsData.push(ndframe.getColumnData[idx]);
        });
        cols2Show = config['columns'];
    } else {
        cols2Show = ndframe.columns;
        colsData = ndframe.getColumnData;
    }
    header['values'] = cols2Show.map(function(col) {
        return [
            col
        ];
    });
    cells['values'] = colsData;
    if (config['tableHeaderStyle']) Object.keys(config['tableHeaderStyle']).forEach(function(param) {
        header[param] = config['tableHeaderStyle'][param];
    });
    if (config['tableCellStyle']) Object.keys(config['tableCellStyle']).forEach(function(param) {
        cells[param] = config['tableCellStyle'][param];
    });
    var trace = {
        type: 'table',
        header: header,
        cells: cells
    };
    /* @ts-ignore */ Plotly.newPlot(divId, [
        trace
    ], layout, config);
};
module.exports.tablePlot = $84b5645b4822c82f$var$tablePlot;

});


parcelRegister("1X4Za", function(module, exports) {
/**
* plotly.js v2.8.0
* Copyright 2012-2021, Plotly, Inc.
* All rights reserved.
* Licensed under the MIT license
*/ !function(t1) {
    module.exports = t1();
}(function() {
    return (function t1(e1, r, n) {
        function i(o, s) {
            if (!r[o]) {
                if (!e1[o]) {
                    var l = undefined;
                    if (!s && l) return l(o, !0);
                    if (a) return a(o, !0);
                    var c = new Error("Cannot find module '" + o + "'");
                    throw c.code = "MODULE_NOT_FOUND", c;
                }
                var u = r[o] = {
                    exports: {}
                };
                e1[o][0].call(u.exports, function(t1) {
                    return i(e1[o][1][t1] || t1);
                }, u, u.exports, t1, e1, r, n);
            }
            return r[o].exports;
        }
        for(var a = undefined, o = 0; o < n.length; o++)i(n[o]);
        return i;
    })({
        1: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../src/lib"), i = {
                    "X,X div": 'direction:ltr;font-family:"Open Sans",verdana,arial,sans-serif;margin:0;padding:0;',
                    "X input,X button": 'font-family:"Open Sans",verdana,arial,sans-serif;',
                    "X input:focus,X button:focus": "outline:none;",
                    "X a": "text-decoration:none;",
                    "X a:hover": "text-decoration:none;",
                    "X .crisp": "shape-rendering:crispEdges;",
                    "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
                    "X svg": "overflow:hidden;",
                    "X svg a": "fill:#447adb;",
                    "X svg a:hover": "fill:#3c6dc5;",
                    "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
                    "X .main-svg .draglayer": "pointer-events:all;",
                    "X .cursor-default": "cursor:default;",
                    "X .cursor-pointer": "cursor:pointer;",
                    "X .cursor-crosshair": "cursor:crosshair;",
                    "X .cursor-move": "cursor:move;",
                    "X .cursor-col-resize": "cursor:col-resize;",
                    "X .cursor-row-resize": "cursor:row-resize;",
                    "X .cursor-ns-resize": "cursor:ns-resize;",
                    "X .cursor-ew-resize": "cursor:ew-resize;",
                    "X .cursor-sw-resize": "cursor:sw-resize;",
                    "X .cursor-s-resize": "cursor:s-resize;",
                    "X .cursor-se-resize": "cursor:se-resize;",
                    "X .cursor-w-resize": "cursor:w-resize;",
                    "X .cursor-e-resize": "cursor:e-resize;",
                    "X .cursor-nw-resize": "cursor:nw-resize;",
                    "X .cursor-n-resize": "cursor:n-resize;",
                    "X .cursor-ne-resize": "cursor:ne-resize;",
                    "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
                    "X .modebar": "position:absolute;top:2px;right:2px;",
                    "X .ease-bg": "-webkit-transition:background-color .3s ease 0s;-moz-transition:background-color .3s ease 0s;-ms-transition:background-color .3s ease 0s;-o-transition:background-color .3s ease 0s;transition:background-color .3s ease 0s;",
                    "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity .3s ease 0s;-moz-transition:opacity .3s ease 0s;-ms-transition:opacity .3s ease 0s;-o-transition:opacity .3s ease 0s;transition:opacity .3s ease 0s;",
                    "X:hover .modebar--hover .modebar-group": "opacity:1;",
                    "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
                    "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
                    "X .modebar-btn svg": "position:relative;top:2px;",
                    "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
                    "X .modebar.vertical svg": "top:-1px;",
                    "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
                    "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
                    "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
                    "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
                    "X [data-title]:before": 'content:"";position:absolute;background:transparent;border:6px solid transparent;z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;',
                    "X [data-title]:after": "content:attr(data-title);background:#69738a;color:#fff;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
                    "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
                    "X .vertical [data-title]:before": "border:6px solid transparent;border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
                    "X .select-outline": "fill:none;stroke-width:1;shape-rendering:crispEdges;",
                    "X .select-outline-1": "stroke:#fff;",
                    "X .select-outline-2": "stroke:#000;stroke-dasharray:2px 2px;",
                    Y: 'font-family:"Open Sans",verdana,arial,sans-serif;position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;',
                    "Y p": "margin:0;",
                    "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
                    "Y .notifier-close": "color:#fff;opacity:.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
                    "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
                };
                for(var a in i){
                    var o = a.replace(/^,/, " ,").replace(/X/g, ".js-plotly-plot .plotly").replace(/Y/g, ".plotly-notifier");
                    n.addStyleRule(o, i[a]);
                }
            },
            {
                "../src/lib": 503
            }
        ],
        2: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/transforms/aggregate");
            },
            {
                "../src/transforms/aggregate": 1114
            }
        ],
        3: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/bar");
            },
            {
                "../src/traces/bar": 656
            }
        ],
        4: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/barpolar");
            },
            {
                "../src/traces/barpolar": 669
            }
        ],
        5: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/box");
            },
            {
                "../src/traces/box": 679
            }
        ],
        6: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/components/calendars");
            },
            {
                "../src/components/calendars": 364
            }
        ],
        7: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/candlestick");
            },
            {
                "../src/traces/candlestick": 688
            }
        ],
        8: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/carpet");
            },
            {
                "../src/traces/carpet": 707
            }
        ],
        9: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/choropleth");
            },
            {
                "../src/traces/choropleth": 721
            }
        ],
        10: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/choroplethmapbox");
            },
            {
                "../src/traces/choroplethmapbox": 728
            }
        ],
        11: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/cone");
            },
            {
                "../src/traces/cone": 734
            }
        ],
        12: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/contour");
            },
            {
                "../src/traces/contour": 749
            }
        ],
        13: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/contourcarpet");
            },
            {
                "../src/traces/contourcarpet": 760
            }
        ],
        14: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/core");
            },
            {
                "../src/core": 481
            }
        ],
        15: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/densitymapbox");
            },
            {
                "../src/traces/densitymapbox": 768
            }
        ],
        16: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/transforms/filter");
            },
            {
                "../src/transforms/filter": 1115
            }
        ],
        17: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/funnel");
            },
            {
                "../src/traces/funnel": 778
            }
        ],
        18: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/funnelarea");
            },
            {
                "../src/traces/funnelarea": 787
            }
        ],
        19: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/transforms/groupby");
            },
            {
                "../src/transforms/groupby": 1116
            }
        ],
        20: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/heatmap");
            },
            {
                "../src/traces/heatmap": 800
            }
        ],
        21: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/heatmapgl");
            },
            {
                "../src/traces/heatmapgl": 811
            }
        ],
        22: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/histogram");
            },
            {
                "../src/traces/histogram": 823
            }
        ],
        23: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/histogram2d");
            },
            {
                "../src/traces/histogram2d": 829
            }
        ],
        24: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/histogram2dcontour");
            },
            {
                "../src/traces/histogram2dcontour": 833
            }
        ],
        25: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/icicle");
            },
            {
                "../src/traces/icicle": 839
            }
        ],
        26: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/image");
            },
            {
                "../src/traces/image": 852
            }
        ],
        27: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./core");
                n.register([
                    t1("./bar"),
                    t1("./box"),
                    t1("./heatmap"),
                    t1("./histogram"),
                    t1("./histogram2d"),
                    t1("./histogram2dcontour"),
                    t1("./contour"),
                    t1("./scatterternary"),
                    t1("./violin"),
                    t1("./funnel"),
                    t1("./waterfall"),
                    t1("./image"),
                    t1("./pie"),
                    t1("./sunburst"),
                    t1("./treemap"),
                    t1("./icicle"),
                    t1("./funnelarea"),
                    t1("./scatter3d"),
                    t1("./surface"),
                    t1("./isosurface"),
                    t1("./volume"),
                    t1("./mesh3d"),
                    t1("./cone"),
                    t1("./streamtube"),
                    t1("./scattergeo"),
                    t1("./choropleth"),
                    t1("./scattergl"),
                    t1("./splom"),
                    t1("./pointcloud"),
                    t1("./heatmapgl"),
                    t1("./parcoords"),
                    t1("./parcats"),
                    t1("./scattermapbox"),
                    t1("./choroplethmapbox"),
                    t1("./densitymapbox"),
                    t1("./sankey"),
                    t1("./indicator"),
                    t1("./table"),
                    t1("./carpet"),
                    t1("./scattercarpet"),
                    t1("./contourcarpet"),
                    t1("./ohlc"),
                    t1("./candlestick"),
                    t1("./scatterpolar"),
                    t1("./scatterpolargl"),
                    t1("./barpolar"),
                    t1("./scattersmith"),
                    t1("./aggregate"),
                    t1("./filter"),
                    t1("./groupby"),
                    t1("./sort"),
                    t1("./calendars")
                ]), e1.exports = n;
            },
            {
                "./aggregate": 2,
                "./bar": 3,
                "./barpolar": 4,
                "./box": 5,
                "./calendars": 6,
                "./candlestick": 7,
                "./carpet": 8,
                "./choropleth": 9,
                "./choroplethmapbox": 10,
                "./cone": 11,
                "./contour": 12,
                "./contourcarpet": 13,
                "./core": 14,
                "./densitymapbox": 15,
                "./filter": 16,
                "./funnel": 17,
                "./funnelarea": 18,
                "./groupby": 19,
                "./heatmap": 20,
                "./heatmapgl": 21,
                "./histogram": 22,
                "./histogram2d": 23,
                "./histogram2dcontour": 24,
                "./icicle": 25,
                "./image": 26,
                "./indicator": 28,
                "./isosurface": 29,
                "./mesh3d": 30,
                "./ohlc": 31,
                "./parcats": 32,
                "./parcoords": 33,
                "./pie": 34,
                "./pointcloud": 35,
                "./sankey": 36,
                "./scatter3d": 37,
                "./scattercarpet": 38,
                "./scattergeo": 39,
                "./scattergl": 40,
                "./scattermapbox": 41,
                "./scatterpolar": 42,
                "./scatterpolargl": 43,
                "./scattersmith": 44,
                "./scatterternary": 45,
                "./sort": 46,
                "./splom": 47,
                "./streamtube": 48,
                "./sunburst": 49,
                "./surface": 50,
                "./table": 51,
                "./treemap": 52,
                "./violin": 53,
                "./volume": 54,
                "./waterfall": 55
            }
        ],
        28: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/indicator");
            },
            {
                "../src/traces/indicator": 860
            }
        ],
        29: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/isosurface");
            },
            {
                "../src/traces/isosurface": 866
            }
        ],
        30: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/mesh3d");
            },
            {
                "../src/traces/mesh3d": 871
            }
        ],
        31: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/ohlc");
            },
            {
                "../src/traces/ohlc": 876
            }
        ],
        32: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/parcats");
            },
            {
                "../src/traces/parcats": 885
            }
        ],
        33: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/parcoords");
            },
            {
                "../src/traces/parcoords": 895
            }
        ],
        34: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/pie");
            },
            {
                "../src/traces/pie": 906
            }
        ],
        35: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/pointcloud");
            },
            {
                "../src/traces/pointcloud": 915
            }
        ],
        36: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/sankey");
            },
            {
                "../src/traces/sankey": 921
            }
        ],
        37: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/scatter3d");
            },
            {
                "../src/traces/scatter3d": 959
            }
        ],
        38: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/scattercarpet");
            },
            {
                "../src/traces/scattercarpet": 966
            }
        ],
        39: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/scattergeo");
            },
            {
                "../src/traces/scattergeo": 974
            }
        ],
        40: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/scattergl");
            },
            {
                "../src/traces/scattergl": 987
            }
        ],
        41: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/scattermapbox");
            },
            {
                "../src/traces/scattermapbox": 997
            }
        ],
        42: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/scatterpolar");
            },
            {
                "../src/traces/scatterpolar": 1005
            }
        ],
        43: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/scatterpolargl");
            },
            {
                "../src/traces/scatterpolargl": 1012
            }
        ],
        44: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/scattersmith");
            },
            {
                "../src/traces/scattersmith": 1019
            }
        ],
        45: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/scatterternary");
            },
            {
                "../src/traces/scatterternary": 1027
            }
        ],
        46: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/transforms/sort");
            },
            {
                "../src/transforms/sort": 1118
            }
        ],
        47: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/splom");
            },
            {
                "../src/traces/splom": 1036
            }
        ],
        48: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/streamtube");
            },
            {
                "../src/traces/streamtube": 1044
            }
        ],
        49: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/sunburst");
            },
            {
                "../src/traces/sunburst": 1052
            }
        ],
        50: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/surface");
            },
            {
                "../src/traces/surface": 1061
            }
        ],
        51: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/table");
            },
            {
                "../src/traces/table": 1069
            }
        ],
        52: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/treemap");
            },
            {
                "../src/traces/treemap": 1080
            }
        ],
        53: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/violin");
            },
            {
                "../src/traces/violin": 1093
            }
        ],
        54: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/volume");
            },
            {
                "../src/traces/volume": 1101
            }
        ],
        55: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("../src/traces/waterfall");
            },
            {
                "../src/traces/waterfall": 1109
            }
        ],
        56: [
            function(t1, e1, r) {
                !function(n, i) {
                    "object" == typeof r && void 0 !== e1 ? i(r, t1("d3-array"), t1("d3-collection"), t1("d3-shape"), t1("elementary-circuits-directed-graph")) : i(n.d3 = n.d3 || {}, n.d3, n.d3, n.d3, null);
                }(this, function(t1, e1, r, n, i) {
                    "use strict";
                    function a(t1) {
                        return t1.target.depth;
                    }
                    function o(t1, e1) {
                        return t1.sourceLinks.length ? t1.depth : e1 - 1;
                    }
                    function s(t1) {
                        return function() {
                            return t1;
                        };
                    }
                    i = i && i.hasOwnProperty("default") ? i.default : i;
                    var l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                        return typeof t1;
                    } : function(t1) {
                        return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                    };
                    function c(t1, e1) {
                        return f(t1.source, e1.source) || t1.index - e1.index;
                    }
                    function u(t1, e1) {
                        return f(t1.target, e1.target) || t1.index - e1.index;
                    }
                    function f(t1, e1) {
                        return t1.partOfCycle === e1.partOfCycle ? t1.y0 - e1.y0 : "top" === t1.circularLinkType || "bottom" === e1.circularLinkType ? -1 : 1;
                    }
                    function h(t1) {
                        return t1.value;
                    }
                    function p(t1) {
                        return (t1.y0 + t1.y1) / 2;
                    }
                    function d(t1) {
                        return p(t1.source);
                    }
                    function m(t1) {
                        return p(t1.target);
                    }
                    function g(t1) {
                        return t1.index;
                    }
                    function v(t1) {
                        return t1.nodes;
                    }
                    function y(t1) {
                        return t1.links;
                    }
                    function x(t1, e1) {
                        var r = t1.get(e1);
                        if (!r) throw new Error("missing: " + e1);
                        return r;
                    }
                    function b(t1, e1) {
                        return e1(t1);
                    }
                    function _(t1, e1, r) {
                        var n = 0;
                        if (null === r) {
                            for(var a = [], o = 0; o < t1.links.length; o++){
                                var s = t1.links[o], l = s.source.index, c = s.target.index;
                                a[l] || (a[l] = []), a[c] || (a[c] = []), -1 === a[l].indexOf(c) && a[l].push(c);
                            }
                            var u = i(a);
                            u.sort(function(t1, e1) {
                                return t1.length - e1.length;
                            });
                            var f = {};
                            for(o = 0; o < u.length; o++){
                                var h = u[o].slice(-2);
                                f[h[0]] || (f[h[0]] = {}), f[h[0]][h[1]] = !0;
                            }
                            t1.links.forEach(function(t1) {
                                var e1 = t1.target.index, r = t1.source.index;
                                e1 === r || f[r] && f[r][e1] ? (t1.circular = !0, t1.circularLinkID = n, n += 1) : t1.circular = !1;
                            });
                        } else t1.links.forEach(function(t1) {
                            t1.source[r] < t1.target[r] ? t1.circular = !1 : (t1.circular = !0, t1.circularLinkID = n, n += 1);
                        });
                    }
                    function w(t1, e1) {
                        var r = 0, n = 0;
                        t1.links.forEach(function(i) {
                            i.circular && (i.source.circularLinkType || i.target.circularLinkType ? i.circularLinkType = i.source.circularLinkType ? i.source.circularLinkType : i.target.circularLinkType : i.circularLinkType = r < n ? "top" : "bottom", "top" == i.circularLinkType ? r += 1 : n += 1, t1.nodes.forEach(function(t1) {
                                b(t1, e1) != b(i.source, e1) && b(t1, e1) != b(i.target, e1) || (t1.circularLinkType = i.circularLinkType);
                            }));
                        }), t1.links.forEach(function(t1) {
                            t1.circular && (t1.source.circularLinkType == t1.target.circularLinkType && (t1.circularLinkType = t1.source.circularLinkType), q(t1, e1) && (t1.circularLinkType = t1.source.circularLinkType));
                        });
                    }
                    function T(t1) {
                        var e1 = Math.abs(t1.y1 - t1.y0), r = Math.abs(t1.target.x0 - t1.source.x1);
                        return Math.atan(r / e1);
                    }
                    function k(t1, e1) {
                        var r = 0;
                        t1.sourceLinks.forEach(function(t1) {
                            r = t1.circular && !q(t1, e1) ? r + 1 : r;
                        });
                        var n = 0;
                        return t1.targetLinks.forEach(function(t1) {
                            n = t1.circular && !q(t1, e1) ? n + 1 : n;
                        }), r + n;
                    }
                    function A(t1) {
                        var e1 = t1.source.sourceLinks, r = 0;
                        e1.forEach(function(t1) {
                            r = t1.circular ? r + 1 : r;
                        });
                        var n = t1.target.targetLinks, i = 0;
                        return n.forEach(function(t1) {
                            i = t1.circular ? i + 1 : i;
                        }), !(r > 1 || i > 1);
                    }
                    function M(t1, e1, r) {
                        return t1.sort(E), t1.forEach(function(n, i) {
                            var a, o, s = 0;
                            if (q(n, r) && A(n)) n.circularPathData.verticalBuffer = s + n.width / 2;
                            else {
                                for(var l = 0; l < i; l++)if (a = t1[i], o = t1[l], !(a.source.column < o.target.column || a.target.column > o.source.column)) {
                                    var c = t1[l].circularPathData.verticalBuffer + t1[l].width / 2 + e1;
                                    s = c > s ? c : s;
                                }
                                n.circularPathData.verticalBuffer = s + n.width / 2;
                            }
                        }), t1;
                    }
                    function S(t1, r, i, a) {
                        var o = e1.min(t1.links, function(t1) {
                            return t1.source.y0;
                        });
                        t1.links.forEach(function(t1) {
                            t1.circular && (t1.circularPathData = {});
                        }), M(t1.links.filter(function(t1) {
                            return "top" == t1.circularLinkType;
                        }), r, a), M(t1.links.filter(function(t1) {
                            return "bottom" == t1.circularLinkType;
                        }), r, a), t1.links.forEach(function(e1) {
                            if (e1.circular) {
                                if (e1.circularPathData.arcRadius = e1.width + 10, e1.circularPathData.leftNodeBuffer = 5, e1.circularPathData.rightNodeBuffer = 5, e1.circularPathData.sourceWidth = e1.source.x1 - e1.source.x0, e1.circularPathData.sourceX = e1.source.x0 + e1.circularPathData.sourceWidth, e1.circularPathData.targetX = e1.target.x0, e1.circularPathData.sourceY = e1.y0, e1.circularPathData.targetY = e1.y1, q(e1, a) && A(e1)) e1.circularPathData.leftSmallArcRadius = 10 + e1.width / 2, e1.circularPathData.leftLargeArcRadius = 10 + e1.width / 2, e1.circularPathData.rightSmallArcRadius = 10 + e1.width / 2, e1.circularPathData.rightLargeArcRadius = 10 + e1.width / 2, "bottom" == e1.circularLinkType ? (e1.circularPathData.verticalFullExtent = e1.source.y1 + 25 + e1.circularPathData.verticalBuffer, e1.circularPathData.verticalLeftInnerExtent = e1.circularPathData.verticalFullExtent - e1.circularPathData.leftLargeArcRadius, e1.circularPathData.verticalRightInnerExtent = e1.circularPathData.verticalFullExtent - e1.circularPathData.rightLargeArcRadius) : (e1.circularPathData.verticalFullExtent = e1.source.y0 - 25 - e1.circularPathData.verticalBuffer, e1.circularPathData.verticalLeftInnerExtent = e1.circularPathData.verticalFullExtent + e1.circularPathData.leftLargeArcRadius, e1.circularPathData.verticalRightInnerExtent = e1.circularPathData.verticalFullExtent + e1.circularPathData.rightLargeArcRadius);
                                else {
                                    var s = e1.source.column, l = e1.circularLinkType, c = t1.links.filter(function(t1) {
                                        return t1.source.column == s && t1.circularLinkType == l;
                                    });
                                    "bottom" == e1.circularLinkType ? c.sort(C) : c.sort(L);
                                    var u = 0;
                                    c.forEach(function(t1, n) {
                                        t1.circularLinkID == e1.circularLinkID && (e1.circularPathData.leftSmallArcRadius = 10 + e1.width / 2 + u, e1.circularPathData.leftLargeArcRadius = 10 + e1.width / 2 + n * r + u), u += t1.width;
                                    }), s = e1.target.column, c = t1.links.filter(function(t1) {
                                        return t1.target.column == s && t1.circularLinkType == l;
                                    }), "bottom" == e1.circularLinkType ? c.sort(I) : c.sort(P), u = 0, c.forEach(function(t1, n) {
                                        t1.circularLinkID == e1.circularLinkID && (e1.circularPathData.rightSmallArcRadius = 10 + e1.width / 2 + u, e1.circularPathData.rightLargeArcRadius = 10 + e1.width / 2 + n * r + u), u += t1.width;
                                    }), "bottom" == e1.circularLinkType ? (e1.circularPathData.verticalFullExtent = Math.max(i, e1.source.y1, e1.target.y1) + 25 + e1.circularPathData.verticalBuffer, e1.circularPathData.verticalLeftInnerExtent = e1.circularPathData.verticalFullExtent - e1.circularPathData.leftLargeArcRadius, e1.circularPathData.verticalRightInnerExtent = e1.circularPathData.verticalFullExtent - e1.circularPathData.rightLargeArcRadius) : (e1.circularPathData.verticalFullExtent = o - 25 - e1.circularPathData.verticalBuffer, e1.circularPathData.verticalLeftInnerExtent = e1.circularPathData.verticalFullExtent + e1.circularPathData.leftLargeArcRadius, e1.circularPathData.verticalRightInnerExtent = e1.circularPathData.verticalFullExtent + e1.circularPathData.rightLargeArcRadius);
                                }
                                e1.circularPathData.leftInnerExtent = e1.circularPathData.sourceX + e1.circularPathData.leftNodeBuffer, e1.circularPathData.rightInnerExtent = e1.circularPathData.targetX - e1.circularPathData.rightNodeBuffer, e1.circularPathData.leftFullExtent = e1.circularPathData.sourceX + e1.circularPathData.leftLargeArcRadius + e1.circularPathData.leftNodeBuffer, e1.circularPathData.rightFullExtent = e1.circularPathData.targetX - e1.circularPathData.rightLargeArcRadius - e1.circularPathData.rightNodeBuffer;
                            }
                            if (e1.circular) e1.path = function(t1) {
                                var e1 = "";
                                e1 = "top" == t1.circularLinkType ? "M" + t1.circularPathData.sourceX + " " + t1.circularPathData.sourceY + " L" + t1.circularPathData.leftInnerExtent + " " + t1.circularPathData.sourceY + " A" + t1.circularPathData.leftLargeArcRadius + " " + t1.circularPathData.leftSmallArcRadius + " 0 0 0 " + t1.circularPathData.leftFullExtent + " " + (t1.circularPathData.sourceY - t1.circularPathData.leftSmallArcRadius) + " L" + t1.circularPathData.leftFullExtent + " " + t1.circularPathData.verticalLeftInnerExtent + " A" + t1.circularPathData.leftLargeArcRadius + " " + t1.circularPathData.leftLargeArcRadius + " 0 0 0 " + t1.circularPathData.leftInnerExtent + " " + t1.circularPathData.verticalFullExtent + " L" + t1.circularPathData.rightInnerExtent + " " + t1.circularPathData.verticalFullExtent + " A" + t1.circularPathData.rightLargeArcRadius + " " + t1.circularPathData.rightLargeArcRadius + " 0 0 0 " + t1.circularPathData.rightFullExtent + " " + t1.circularPathData.verticalRightInnerExtent + " L" + t1.circularPathData.rightFullExtent + " " + (t1.circularPathData.targetY - t1.circularPathData.rightSmallArcRadius) + " A" + t1.circularPathData.rightLargeArcRadius + " " + t1.circularPathData.rightSmallArcRadius + " 0 0 0 " + t1.circularPathData.rightInnerExtent + " " + t1.circularPathData.targetY + " L" + t1.circularPathData.targetX + " " + t1.circularPathData.targetY : "M" + t1.circularPathData.sourceX + " " + t1.circularPathData.sourceY + " L" + t1.circularPathData.leftInnerExtent + " " + t1.circularPathData.sourceY + " A" + t1.circularPathData.leftLargeArcRadius + " " + t1.circularPathData.leftSmallArcRadius + " 0 0 1 " + t1.circularPathData.leftFullExtent + " " + (t1.circularPathData.sourceY + t1.circularPathData.leftSmallArcRadius) + " L" + t1.circularPathData.leftFullExtent + " " + t1.circularPathData.verticalLeftInnerExtent + " A" + t1.circularPathData.leftLargeArcRadius + " " + t1.circularPathData.leftLargeArcRadius + " 0 0 1 " + t1.circularPathData.leftInnerExtent + " " + t1.circularPathData.verticalFullExtent + " L" + t1.circularPathData.rightInnerExtent + " " + t1.circularPathData.verticalFullExtent + " A" + t1.circularPathData.rightLargeArcRadius + " " + t1.circularPathData.rightLargeArcRadius + " 0 0 1 " + t1.circularPathData.rightFullExtent + " " + t1.circularPathData.verticalRightInnerExtent + " L" + t1.circularPathData.rightFullExtent + " " + (t1.circularPathData.targetY + t1.circularPathData.rightSmallArcRadius) + " A" + t1.circularPathData.rightLargeArcRadius + " " + t1.circularPathData.rightSmallArcRadius + " 0 0 1 " + t1.circularPathData.rightInnerExtent + " " + t1.circularPathData.targetY + " L" + t1.circularPathData.targetX + " " + t1.circularPathData.targetY;
                                return e1;
                            }(e1);
                            else {
                                var f = n.linkHorizontal().source(function(t1) {
                                    return [
                                        t1.source.x0 + (t1.source.x1 - t1.source.x0),
                                        t1.y0
                                    ];
                                }).target(function(t1) {
                                    return [
                                        t1.target.x0,
                                        t1.y1
                                    ];
                                });
                                e1.path = f(e1);
                            }
                        });
                    }
                    function E(t1, e1) {
                        return O(t1) == O(e1) ? "bottom" == t1.circularLinkType ? C(t1, e1) : L(t1, e1) : O(e1) - O(t1);
                    }
                    function L(t1, e1) {
                        return t1.y0 - e1.y0;
                    }
                    function C(t1, e1) {
                        return e1.y0 - t1.y0;
                    }
                    function P(t1, e1) {
                        return t1.y1 - e1.y1;
                    }
                    function I(t1, e1) {
                        return e1.y1 - t1.y1;
                    }
                    function O(t1) {
                        return t1.target.column - t1.source.column;
                    }
                    function z(t1) {
                        return t1.target.x0 - t1.source.x1;
                    }
                    function D(t1, e1) {
                        var r = T(t1), n = z(e1) / Math.tan(r);
                        return "up" == H(t1) ? t1.y1 + n : t1.y1 - n;
                    }
                    function R(t1, e1) {
                        var r = T(t1), n = z(e1) / Math.tan(r);
                        return "up" == H(t1) ? t1.y1 - n : t1.y1 + n;
                    }
                    function F(t1, e1, r, n) {
                        t1.links.forEach(function(i) {
                            if (!i.circular && i.target.column - i.source.column > 1) {
                                var a = i.source.column + 1, o = i.target.column - 1, s = 1, l = o - a + 1;
                                for(s = 1; a <= o; a++, s++)t1.nodes.forEach(function(o) {
                                    if (o.column == a) {
                                        var c, u = s / (l + 1), f = Math.pow(1 - u, 3), h = 3 * u * Math.pow(1 - u, 2), p = 3 * Math.pow(u, 2) * (1 - u), d = Math.pow(u, 3), m = f * i.y0 + h * i.y0 + p * i.y1 + d * i.y1, g = m - i.width / 2, v = m + i.width / 2;
                                        g > o.y0 && g < o.y1 ? (c = o.y1 - g + 10, c = "bottom" == o.circularLinkType ? c : -c, o = N(o, c, e1, r), t1.nodes.forEach(function(t1) {
                                            b(t1, n) != b(o, n) && t1.column == o.column && B(o, t1) && N(t1, c, e1, r);
                                        })) : (v > o.y0 && v < o.y1 || g < o.y0 && v > o.y1) && (c = v - o.y0 + 10, o = N(o, c, e1, r), t1.nodes.forEach(function(t1) {
                                            b(t1, n) != b(o, n) && t1.column == o.column && t1.y0 < o.y1 && t1.y1 > o.y1 && N(t1, c, e1, r);
                                        }));
                                    }
                                });
                            }
                        });
                    }
                    function B(t1, e1) {
                        return t1.y0 > e1.y0 && t1.y0 < e1.y1 || t1.y1 > e1.y0 && t1.y1 < e1.y1 || t1.y0 < e1.y0 && t1.y1 > e1.y1;
                    }
                    function N(t1, e1, r, n) {
                        return t1.y0 + e1 >= r && t1.y1 + e1 <= n && (t1.y0 = t1.y0 + e1, t1.y1 = t1.y1 + e1, t1.targetLinks.forEach(function(t1) {
                            t1.y1 = t1.y1 + e1;
                        }), t1.sourceLinks.forEach(function(t1) {
                            t1.y0 = t1.y0 + e1;
                        })), t1;
                    }
                    function j(t1, e1, r, n) {
                        t1.nodes.forEach(function(i) {
                            n && i.y + (i.y1 - i.y0) > e1 && (i.y = i.y - (i.y + (i.y1 - i.y0) - e1));
                            var a = t1.links.filter(function(t1) {
                                return b(t1.source, r) == b(i, r);
                            }), o = a.length;
                            o > 1 && a.sort(function(t1, e1) {
                                if (!t1.circular && !e1.circular) {
                                    if (t1.target.column == e1.target.column) return t1.y1 - e1.y1;
                                    if (!V(t1, e1)) return t1.y1 - e1.y1;
                                    if (t1.target.column > e1.target.column) {
                                        var r = R(e1, t1);
                                        return t1.y1 - r;
                                    }
                                    if (e1.target.column > t1.target.column) return R(t1, e1) - e1.y1;
                                }
                                return t1.circular && !e1.circular ? "top" == t1.circularLinkType ? -1 : 1 : e1.circular && !t1.circular ? "top" == e1.circularLinkType ? 1 : -1 : t1.circular && e1.circular ? t1.circularLinkType === e1.circularLinkType && "top" == t1.circularLinkType ? t1.target.column === e1.target.column ? t1.target.y1 - e1.target.y1 : e1.target.column - t1.target.column : t1.circularLinkType === e1.circularLinkType && "bottom" == t1.circularLinkType ? t1.target.column === e1.target.column ? e1.target.y1 - t1.target.y1 : t1.target.column - e1.target.column : "top" == t1.circularLinkType ? -1 : 1 : void 0;
                            });
                            var s = i.y0;
                            a.forEach(function(t1) {
                                t1.y0 = s + t1.width / 2, s += t1.width;
                            }), a.forEach(function(t1, e1) {
                                if ("bottom" == t1.circularLinkType) {
                                    for(var r = e1 + 1, n = 0; r < o; r++)n += a[r].width;
                                    t1.y0 = i.y1 - n - t1.width / 2;
                                }
                            });
                        });
                    }
                    function U(t1, e1, r) {
                        t1.nodes.forEach(function(e1) {
                            var n = t1.links.filter(function(t1) {
                                return b(t1.target, r) == b(e1, r);
                            }), i = n.length;
                            i > 1 && n.sort(function(t1, e1) {
                                if (!t1.circular && !e1.circular) {
                                    if (t1.source.column == e1.source.column) return t1.y0 - e1.y0;
                                    if (!V(t1, e1)) return t1.y0 - e1.y0;
                                    if (e1.source.column < t1.source.column) {
                                        var r = D(e1, t1);
                                        return t1.y0 - r;
                                    }
                                    if (t1.source.column < e1.source.column) return D(t1, e1) - e1.y0;
                                }
                                return t1.circular && !e1.circular ? "top" == t1.circularLinkType ? -1 : 1 : e1.circular && !t1.circular ? "top" == e1.circularLinkType ? 1 : -1 : t1.circular && e1.circular ? t1.circularLinkType === e1.circularLinkType && "top" == t1.circularLinkType ? t1.source.column === e1.source.column ? t1.source.y1 - e1.source.y1 : t1.source.column - e1.source.column : t1.circularLinkType === e1.circularLinkType && "bottom" == t1.circularLinkType ? t1.source.column === e1.source.column ? t1.source.y1 - e1.source.y1 : e1.source.column - t1.source.column : "top" == t1.circularLinkType ? -1 : 1 : void 0;
                            });
                            var a = e1.y0;
                            n.forEach(function(t1) {
                                t1.y1 = a + t1.width / 2, a += t1.width;
                            }), n.forEach(function(t1, r) {
                                if ("bottom" == t1.circularLinkType) {
                                    for(var a = r + 1, o = 0; a < i; a++)o += n[a].width;
                                    t1.y1 = e1.y1 - o - t1.width / 2;
                                }
                            });
                        });
                    }
                    function V(t1, e1) {
                        return H(t1) == H(e1);
                    }
                    function H(t1) {
                        return t1.y0 - t1.y1 > 0 ? "up" : "down";
                    }
                    function q(t1, e1) {
                        return b(t1.source, e1) == b(t1.target, e1);
                    }
                    function G(t1, r, n) {
                        var i = t1.nodes, a = t1.links, o = !1, s = !1;
                        if (a.forEach(function(t1) {
                            "top" == t1.circularLinkType ? o = !0 : "bottom" == t1.circularLinkType && (s = !0);
                        }), 0 == o || 0 == s) {
                            var l = e1.min(i, function(t1) {
                                return t1.y0;
                            }), c = (n - r) / (e1.max(i, function(t1) {
                                return t1.y1;
                            }) - l);
                            i.forEach(function(t1) {
                                var e1 = (t1.y1 - t1.y0) * c;
                                t1.y0 = (t1.y0 - l) * c, t1.y1 = t1.y0 + e1;
                            }), a.forEach(function(t1) {
                                t1.y0 = (t1.y0 - l) * c, t1.y1 = (t1.y1 - l) * c, t1.width = t1.width * c;
                            });
                        }
                    }
                    t1.sankeyCircular = function() {
                        var t1, n, i = 0, a = 0, b = 1, T = 1, A = 24, M = g, E = o, L = v, C = y, P = 32, I = 2, O = null;
                        function z() {
                            var t1 = {
                                nodes: L.apply(null, arguments),
                                links: C.apply(null, arguments)
                            };
                            D(t1), _(t1, M, O), R(t1), B(t1), w(t1, M), N(t1, P, M), V(t1);
                            for(var e1 = 4, r = 0; r < e1; r++)j(t1, T, M), U(t1, T, M), F(t1, a, T, M), j(t1, T, M), U(t1, T, M);
                            return G(t1, a, T), S(t1, I, T, M), t1;
                        }
                        function D(t1) {
                            t1.nodes.forEach(function(t1, e1) {
                                t1.index = e1, t1.sourceLinks = [], t1.targetLinks = [];
                            });
                            var e1 = r.map(t1.nodes, M);
                            return t1.links.forEach(function(t1, r) {
                                t1.index = r;
                                var n = t1.source, i = t1.target;
                                "object" !== (void 0 === n ? "undefined" : l(n)) && (n = t1.source = x(e1, n)), "object" !== (void 0 === i ? "undefined" : l(i)) && (i = t1.target = x(e1, i)), n.sourceLinks.push(t1), i.targetLinks.push(t1);
                            }), t1;
                        }
                        function R(t1) {
                            t1.nodes.forEach(function(t1) {
                                t1.partOfCycle = !1, t1.value = Math.max(e1.sum(t1.sourceLinks, h), e1.sum(t1.targetLinks, h)), t1.sourceLinks.forEach(function(e1) {
                                    e1.circular && (t1.partOfCycle = !0, t1.circularLinkType = e1.circularLinkType);
                                }), t1.targetLinks.forEach(function(e1) {
                                    e1.circular && (t1.partOfCycle = !0, t1.circularLinkType = e1.circularLinkType);
                                });
                            });
                        }
                        function B(t1) {
                            var e1, r, n;
                            for(e1 = t1.nodes, r = [], n = 0; e1.length; ++n, e1 = r, r = [])e1.forEach(function(t1) {
                                t1.depth = n, t1.sourceLinks.forEach(function(t1) {
                                    r.indexOf(t1.target) < 0 && !t1.circular && r.push(t1.target);
                                });
                            });
                            for(e1 = t1.nodes, r = [], n = 0; e1.length; ++n, e1 = r, r = [])e1.forEach(function(t1) {
                                t1.height = n, t1.targetLinks.forEach(function(t1) {
                                    r.indexOf(t1.source) < 0 && !t1.circular && r.push(t1.source);
                                });
                            });
                            t1.nodes.forEach(function(t1) {
                                t1.column = Math.floor(E.call(null, t1, n));
                            });
                        }
                        function N(o, s, l) {
                            var c = r.nest().key(function(t1) {
                                return t1.column;
                            }).sortKeys(e1.ascending).entries(o.nodes).map(function(t1) {
                                return t1.values;
                            });
                            !function(r) {
                                if (n) {
                                    var s = 1 / 0;
                                    c.forEach(function(t1) {
                                        var e1 = T * n / (t1.length + 1);
                                        s = e1 < s ? e1 : s;
                                    }), t1 = s;
                                }
                                var l = e1.min(c, function(r) {
                                    return (T - a - (r.length - 1) * t1) / e1.sum(r, h);
                                });
                                l *= .3, o.links.forEach(function(t1) {
                                    t1.width = t1.value * l;
                                });
                                var u = function(t1) {
                                    var r = 0, n = 0, i = 0, a = 0, o = e1.max(t1.nodes, function(t1) {
                                        return t1.column;
                                    });
                                    return t1.links.forEach(function(t1) {
                                        t1.circular && ("top" == t1.circularLinkType ? r += t1.width : n += t1.width, 0 == t1.target.column && (a += t1.width), t1.source.column == o && (i += t1.width));
                                    }), {
                                        top: r = r > 0 ? r + 25 + 10 : r,
                                        bottom: n = n > 0 ? n + 25 + 10 : n,
                                        left: a = a > 0 ? a + 25 + 10 : a,
                                        right: i = i > 0 ? i + 25 + 10 : i
                                    };
                                }(o), f = function(t1, r) {
                                    var n = e1.max(t1.nodes, function(t1) {
                                        return t1.column;
                                    }), o = b - i, s = T - a, l = o / (o + r.right + r.left), c = s / (s + r.top + r.bottom);
                                    return i = i * l + r.left, b = 0 == r.right ? b : b * l, a = a * c + r.top, T *= c, t1.nodes.forEach(function(t1) {
                                        t1.x0 = i + t1.column * ((b - i - A) / n), t1.x1 = t1.x0 + A;
                                    }), c;
                                }(o, u);
                                l *= f, o.links.forEach(function(t1) {
                                    t1.width = t1.value * l;
                                }), c.forEach(function(t1) {
                                    var e1 = t1.length;
                                    t1.forEach(function(t1, n) {
                                        t1.depth == c.length - 1 && 1 == e1 || 0 == t1.depth && 1 == e1 ? (t1.y0 = T / 2 - t1.value * l, t1.y1 = t1.y0 + t1.value * l) : t1.partOfCycle ? 0 == k(t1, r) ? (t1.y0 = T / 2 + n, t1.y1 = t1.y0 + t1.value * l) : "top" == t1.circularLinkType ? (t1.y0 = a + n, t1.y1 = t1.y0 + t1.value * l) : (t1.y0 = T - t1.value * l - n, t1.y1 = t1.y0 + t1.value * l) : 0 == u.top || 0 == u.bottom ? (t1.y0 = (T - a) / e1 * n, t1.y1 = t1.y0 + t1.value * l) : (t1.y0 = (T - a) / 2 - e1 / 2 + n, t1.y1 = t1.y0 + t1.value * l);
                                    });
                                });
                            }(l), y();
                            for(var u = 1, g = s; g > 0; --g)v(u *= .99, l), y();
                            function v(t1, r) {
                                var n = c.length;
                                c.forEach(function(i) {
                                    var a = i.length, o = i[0].depth;
                                    i.forEach(function(i) {
                                        var s;
                                        if (i.sourceLinks.length || i.targetLinks.length) {
                                            if (i.partOfCycle && k(i, r) > 0) ;
                                            else if (0 == o && 1 == a) s = i.y1 - i.y0, i.y0 = T / 2 - s / 2, i.y1 = T / 2 + s / 2;
                                            else if (o == n - 1 && 1 == a) s = i.y1 - i.y0, i.y0 = T / 2 - s / 2, i.y1 = T / 2 + s / 2;
                                            else {
                                                var l = e1.mean(i.sourceLinks, m), c = e1.mean(i.targetLinks, d), u = ((l && c ? (l + c) / 2 : l || c) - p(i)) * t1;
                                                i.y0 += u, i.y1 += u;
                                            }
                                        }
                                    });
                                });
                            }
                            function y() {
                                c.forEach(function(e1) {
                                    var r, n, i, o = a, s = e1.length;
                                    for(e1.sort(f), i = 0; i < s; ++i)(n = o - (r = e1[i]).y0) > 0 && (r.y0 += n, r.y1 += n), o = r.y1 + t1;
                                    if ((n = o - t1 - T) > 0) for(o = r.y0 -= n, r.y1 -= n, i = s - 2; i >= 0; --i)(n = (r = e1[i]).y1 + t1 - o) > 0 && (r.y0 -= n, r.y1 -= n), o = r.y0;
                                });
                            }
                        }
                        function V(t1) {
                            t1.nodes.forEach(function(t1) {
                                t1.sourceLinks.sort(u), t1.targetLinks.sort(c);
                            }), t1.nodes.forEach(function(t1) {
                                var e1 = t1.y0, r = e1, n = t1.y1, i = n;
                                t1.sourceLinks.forEach(function(t1) {
                                    t1.circular ? (t1.y0 = n - t1.width / 2, n -= t1.width) : (t1.y0 = e1 + t1.width / 2, e1 += t1.width);
                                }), t1.targetLinks.forEach(function(t1) {
                                    t1.circular ? (t1.y1 = i - t1.width / 2, i -= t1.width) : (t1.y1 = r + t1.width / 2, r += t1.width);
                                });
                            });
                        }
                        return z.nodeId = function(t1) {
                            return arguments.length ? (M = "function" == typeof t1 ? t1 : s(t1), z) : M;
                        }, z.nodeAlign = function(t1) {
                            return arguments.length ? (E = "function" == typeof t1 ? t1 : s(t1), z) : E;
                        }, z.nodeWidth = function(t1) {
                            return arguments.length ? (A = +t1, z) : A;
                        }, z.nodePadding = function(e1) {
                            return arguments.length ? (t1 = +e1, z) : t1;
                        }, z.nodes = function(t1) {
                            return arguments.length ? (L = "function" == typeof t1 ? t1 : s(t1), z) : L;
                        }, z.links = function(t1) {
                            return arguments.length ? (C = "function" == typeof t1 ? t1 : s(t1), z) : C;
                        }, z.size = function(t1) {
                            return arguments.length ? (i = a = 0, b = +t1[0], T = +t1[1], z) : [
                                b - i,
                                T - a
                            ];
                        }, z.extent = function(t1) {
                            return arguments.length ? (i = +t1[0][0], b = +t1[1][0], a = +t1[0][1], T = +t1[1][1], z) : [
                                [
                                    i,
                                    a
                                ],
                                [
                                    b,
                                    T
                                ]
                            ];
                        }, z.iterations = function(t1) {
                            return arguments.length ? (P = +t1, z) : P;
                        }, z.circularLinkGap = function(t1) {
                            return arguments.length ? (I = +t1, z) : I;
                        }, z.nodePaddingRatio = function(t1) {
                            return arguments.length ? (n = +t1, z) : n;
                        }, z.sortNodes = function(t1) {
                            return arguments.length ? (O = t1, z) : O;
                        }, z.update = function(t1) {
                            return w(t1, M), V(t1), t1.links.forEach(function(t1) {
                                t1.circular && (t1.circularLinkType = t1.y0 + t1.y1 < T ? "top" : "bottom", t1.source.circularLinkType = t1.circularLinkType, t1.target.circularLinkType = t1.circularLinkType);
                            }), j(t1, T, M, !1), U(t1, T, M), S(t1, I, T, M), t1;
                        }, z;
                    }, t1.sankeyCenter = function(t1) {
                        return t1.targetLinks.length ? t1.depth : t1.sourceLinks.length ? e1.min(t1.sourceLinks, a) - 1 : 0;
                    }, t1.sankeyLeft = function(t1) {
                        return t1.depth;
                    }, t1.sankeyRight = function(t1, e1) {
                        return e1 - 1 - t1.height;
                    }, t1.sankeyJustify = o, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {
                "d3-array": 107,
                "d3-collection": 108,
                "d3-shape": 119,
                "elementary-circuits-directed-graph": 130
            }
        ],
        57: [
            function(t1, e1, r) {
                !function(n, i) {
                    "object" == typeof r && void 0 !== e1 ? i(r, t1("d3-array"), t1("d3-collection"), t1("d3-shape")) : i(n.d3 = n.d3 || {}, n.d3, n.d3, n.d3);
                }(this, function(t1, e1, r, n) {
                    "use strict";
                    function i(t1) {
                        return t1.target.depth;
                    }
                    function a(t1, e1) {
                        return t1.sourceLinks.length ? t1.depth : e1 - 1;
                    }
                    function o(t1) {
                        return function() {
                            return t1;
                        };
                    }
                    function s(t1, e1) {
                        return c(t1.source, e1.source) || t1.index - e1.index;
                    }
                    function l(t1, e1) {
                        return c(t1.target, e1.target) || t1.index - e1.index;
                    }
                    function c(t1, e1) {
                        return t1.y0 - e1.y0;
                    }
                    function u(t1) {
                        return t1.value;
                    }
                    function f(t1) {
                        return (t1.y0 + t1.y1) / 2;
                    }
                    function h(t1) {
                        return f(t1.source) * t1.value;
                    }
                    function p(t1) {
                        return f(t1.target) * t1.value;
                    }
                    function d(t1) {
                        return t1.index;
                    }
                    function m(t1) {
                        return t1.nodes;
                    }
                    function g(t1) {
                        return t1.links;
                    }
                    function v(t1, e1) {
                        var r = t1.get(e1);
                        if (!r) throw new Error("missing: " + e1);
                        return r;
                    }
                    function y(t1) {
                        return [
                            t1.source.x1,
                            t1.y0
                        ];
                    }
                    function x(t1) {
                        return [
                            t1.target.x0,
                            t1.y1
                        ];
                    }
                    t1.sankey = function() {
                        var t1 = 0, n = 0, i = 1, y = 1, x = 24, b = 8, _ = d, w = a, T = m, k = g, A = 32;
                        function M() {
                            var t1 = {
                                nodes: T.apply(null, arguments),
                                links: k.apply(null, arguments)
                            };
                            return S(t1), E(t1), L(t1), C(t1), P(t1), t1;
                        }
                        function S(t1) {
                            t1.nodes.forEach(function(t1, e1) {
                                t1.index = e1, t1.sourceLinks = [], t1.targetLinks = [];
                            });
                            var e1 = r.map(t1.nodes, _);
                            t1.links.forEach(function(t1, r) {
                                t1.index = r;
                                var n = t1.source, i = t1.target;
                                "object" != typeof n && (n = t1.source = v(e1, n)), "object" != typeof i && (i = t1.target = v(e1, i)), n.sourceLinks.push(t1), i.targetLinks.push(t1);
                            });
                        }
                        function E(t1) {
                            t1.nodes.forEach(function(t1) {
                                t1.value = Math.max(e1.sum(t1.sourceLinks, u), e1.sum(t1.targetLinks, u));
                            });
                        }
                        function L(e1) {
                            var r, n, a;
                            for(r = e1.nodes, n = [], a = 0; r.length; ++a, r = n, n = [])r.forEach(function(t1) {
                                t1.depth = a, t1.sourceLinks.forEach(function(t1) {
                                    n.indexOf(t1.target) < 0 && n.push(t1.target);
                                });
                            });
                            for(r = e1.nodes, n = [], a = 0; r.length; ++a, r = n, n = [])r.forEach(function(t1) {
                                t1.height = a, t1.targetLinks.forEach(function(t1) {
                                    n.indexOf(t1.source) < 0 && n.push(t1.source);
                                });
                            });
                            var o = (i - t1 - x) / (a - 1);
                            e1.nodes.forEach(function(e1) {
                                e1.x1 = (e1.x0 = t1 + Math.max(0, Math.min(a - 1, Math.floor(w.call(null, e1, a)))) * o) + x;
                            });
                        }
                        function C(t1) {
                            var i = r.nest().key(function(t1) {
                                return t1.x0;
                            }).sortKeys(e1.ascending).entries(t1.nodes).map(function(t1) {
                                return t1.values;
                            });
                            !function() {
                                var r = e1.max(i, function(t1) {
                                    return t1.length;
                                }), a = 2 / 3 * (y - n) / (r - 1);
                                b > a && (b = a);
                                var o = e1.min(i, function(t1) {
                                    return (y - n - (t1.length - 1) * b) / e1.sum(t1, u);
                                });
                                i.forEach(function(t1) {
                                    t1.forEach(function(t1, e1) {
                                        t1.y1 = (t1.y0 = e1) + t1.value * o;
                                    });
                                }), t1.links.forEach(function(t1) {
                                    t1.width = t1.value * o;
                                });
                            }(), d();
                            for(var a = 1, o = A; o > 0; --o)l(a *= .99), d(), s(a), d();
                            function s(t1) {
                                i.forEach(function(r) {
                                    r.forEach(function(r) {
                                        if (r.targetLinks.length) {
                                            var n = (e1.sum(r.targetLinks, h) / e1.sum(r.targetLinks, u) - f(r)) * t1;
                                            r.y0 += n, r.y1 += n;
                                        }
                                    });
                                });
                            }
                            function l(t1) {
                                i.slice().reverse().forEach(function(r) {
                                    r.forEach(function(r) {
                                        if (r.sourceLinks.length) {
                                            var n = (e1.sum(r.sourceLinks, p) / e1.sum(r.sourceLinks, u) - f(r)) * t1;
                                            r.y0 += n, r.y1 += n;
                                        }
                                    });
                                });
                            }
                            function d() {
                                i.forEach(function(t1) {
                                    var e1, r, i, a = n, o = t1.length;
                                    for(t1.sort(c), i = 0; i < o; ++i)(r = a - (e1 = t1[i]).y0) > 0 && (e1.y0 += r, e1.y1 += r), a = e1.y1 + b;
                                    if ((r = a - b - y) > 0) for(a = e1.y0 -= r, e1.y1 -= r, i = o - 2; i >= 0; --i)(r = (e1 = t1[i]).y1 + b - a) > 0 && (e1.y0 -= r, e1.y1 -= r), a = e1.y0;
                                });
                            }
                        }
                        function P(t1) {
                            t1.nodes.forEach(function(t1) {
                                t1.sourceLinks.sort(l), t1.targetLinks.sort(s);
                            }), t1.nodes.forEach(function(t1) {
                                var e1 = t1.y0, r = e1;
                                t1.sourceLinks.forEach(function(t1) {
                                    t1.y0 = e1 + t1.width / 2, e1 += t1.width;
                                }), t1.targetLinks.forEach(function(t1) {
                                    t1.y1 = r + t1.width / 2, r += t1.width;
                                });
                            });
                        }
                        return M.update = function(t1) {
                            return P(t1), t1;
                        }, M.nodeId = function(t1) {
                            return arguments.length ? (_ = "function" == typeof t1 ? t1 : o(t1), M) : _;
                        }, M.nodeAlign = function(t1) {
                            return arguments.length ? (w = "function" == typeof t1 ? t1 : o(t1), M) : w;
                        }, M.nodeWidth = function(t1) {
                            return arguments.length ? (x = +t1, M) : x;
                        }, M.nodePadding = function(t1) {
                            return arguments.length ? (b = +t1, M) : b;
                        }, M.nodes = function(t1) {
                            return arguments.length ? (T = "function" == typeof t1 ? t1 : o(t1), M) : T;
                        }, M.links = function(t1) {
                            return arguments.length ? (k = "function" == typeof t1 ? t1 : o(t1), M) : k;
                        }, M.size = function(e1) {
                            return arguments.length ? (t1 = n = 0, i = +e1[0], y = +e1[1], M) : [
                                i - t1,
                                y - n
                            ];
                        }, M.extent = function(e1) {
                            return arguments.length ? (t1 = +e1[0][0], i = +e1[1][0], n = +e1[0][1], y = +e1[1][1], M) : [
                                [
                                    t1,
                                    n
                                ],
                                [
                                    i,
                                    y
                                ]
                            ];
                        }, M.iterations = function(t1) {
                            return arguments.length ? (A = +t1, M) : A;
                        }, M;
                    }, t1.sankeyCenter = function(t1) {
                        return t1.targetLinks.length ? t1.depth : t1.sourceLinks.length ? e1.min(t1.sourceLinks, i) - 1 : 0;
                    }, t1.sankeyLeft = function(t1) {
                        return t1.depth;
                    }, t1.sankeyRight = function(t1, e1) {
                        return e1 - 1 - t1.height;
                    }, t1.sankeyJustify = a, t1.sankeyLinkHorizontal = function() {
                        return n.linkHorizontal().source(y).target(x);
                    }, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {
                "d3-array": 107,
                "d3-collection": 108,
                "d3-shape": 119
            }
        ],
        58: [
            function(t1, e1, r) {
                (function() {
                    var t1 = {
                        version: "3.8.0"
                    }, r = [].slice, n = function(t1) {
                        return r.call(t1);
                    }, i = self.document;
                    function a(t1) {
                        return t1 && (t1.ownerDocument || t1.document || t1).documentElement;
                    }
                    function o(t1) {
                        return t1 && (t1.ownerDocument && t1.ownerDocument.defaultView || t1.document && t1 || t1.defaultView);
                    }
                    if (i) try {
                        n(i.documentElement.childNodes)[0].nodeType;
                    } catch (t1) {
                        n = function(t1) {
                            for(var e1 = t1.length, r = new Array(e1); e1--;)r[e1] = t1[e1];
                            return r;
                        };
                    }
                    if (Date.now || (Date.now = function() {
                        return +new Date;
                    }), i) try {
                        i.createElement("DIV").style.setProperty("opacity", 0, "");
                    } catch (t1) {
                        var s = this.Element.prototype, l = s.setAttribute, c = s.setAttributeNS, u = this.CSSStyleDeclaration.prototype, f = u.setProperty;
                        s.setAttribute = function(t1, e1) {
                            l.call(this, t1, e1 + "");
                        }, s.setAttributeNS = function(t1, e1, r) {
                            c.call(this, t1, e1, r + "");
                        }, u.setProperty = function(t1, e1, r) {
                            f.call(this, t1, e1 + "", r);
                        };
                    }
                    function h(t1, e1) {
                        return t1 < e1 ? -1 : t1 > e1 ? 1 : t1 >= e1 ? 0 : NaN;
                    }
                    function p(t1) {
                        return null === t1 ? NaN : +t1;
                    }
                    function d(t1) {
                        return !isNaN(t1);
                    }
                    function m(t1) {
                        return {
                            left: function(e1, r, n, i) {
                                for(arguments.length < 3 && (n = 0), arguments.length < 4 && (i = e1.length); n < i;){
                                    var a = n + i >>> 1;
                                    t1(e1[a], r) < 0 ? n = a + 1 : i = a;
                                }
                                return n;
                            },
                            right: function(e1, r, n, i) {
                                for(arguments.length < 3 && (n = 0), arguments.length < 4 && (i = e1.length); n < i;){
                                    var a = n + i >>> 1;
                                    t1(e1[a], r) > 0 ? i = a : n = a + 1;
                                }
                                return n;
                            }
                        };
                    }
                    t1.ascending = h, t1.descending = function(t1, e1) {
                        return e1 < t1 ? -1 : e1 > t1 ? 1 : e1 >= t1 ? 0 : NaN;
                    }, t1.min = function(t1, e1) {
                        var r, n, i = -1, a = t1.length;
                        if (1 === arguments.length) {
                            for(; ++i < a;)if (null != (n = t1[i]) && n >= n) {
                                r = n;
                                break;
                            }
                            for(; ++i < a;)null != (n = t1[i]) && r > n && (r = n);
                        } else {
                            for(; ++i < a;)if (null != (n = e1.call(t1, t1[i], i)) && n >= n) {
                                r = n;
                                break;
                            }
                            for(; ++i < a;)null != (n = e1.call(t1, t1[i], i)) && r > n && (r = n);
                        }
                        return r;
                    }, t1.max = function(t1, e1) {
                        var r, n, i = -1, a = t1.length;
                        if (1 === arguments.length) {
                            for(; ++i < a;)if (null != (n = t1[i]) && n >= n) {
                                r = n;
                                break;
                            }
                            for(; ++i < a;)null != (n = t1[i]) && n > r && (r = n);
                        } else {
                            for(; ++i < a;)if (null != (n = e1.call(t1, t1[i], i)) && n >= n) {
                                r = n;
                                break;
                            }
                            for(; ++i < a;)null != (n = e1.call(t1, t1[i], i)) && n > r && (r = n);
                        }
                        return r;
                    }, t1.extent = function(t1, e1) {
                        var r, n, i, a = -1, o = t1.length;
                        if (1 === arguments.length) {
                            for(; ++a < o;)if (null != (n = t1[a]) && n >= n) {
                                r = i = n;
                                break;
                            }
                            for(; ++a < o;)null != (n = t1[a]) && (r > n && (r = n), i < n && (i = n));
                        } else {
                            for(; ++a < o;)if (null != (n = e1.call(t1, t1[a], a)) && n >= n) {
                                r = i = n;
                                break;
                            }
                            for(; ++a < o;)null != (n = e1.call(t1, t1[a], a)) && (r > n && (r = n), i < n && (i = n));
                        }
                        return [
                            r,
                            i
                        ];
                    }, t1.sum = function(t1, e1) {
                        var r, n = 0, i = t1.length, a = -1;
                        if (1 === arguments.length) for(; ++a < i;)d(r = +t1[a]) && (n += r);
                        else for(; ++a < i;)d(r = +e1.call(t1, t1[a], a)) && (n += r);
                        return n;
                    }, t1.mean = function(t1, e1) {
                        var r, n = 0, i = t1.length, a = -1, o = i;
                        if (1 === arguments.length) for(; ++a < i;)d(r = p(t1[a])) ? n += r : --o;
                        else for(; ++a < i;)d(r = p(e1.call(t1, t1[a], a))) ? n += r : --o;
                        if (o) return n / o;
                    }, t1.quantile = function(t1, e1) {
                        var r = (t1.length - 1) * e1 + 1, n = Math.floor(r), i = +t1[n - 1], a = r - n;
                        return a ? i + a * (t1[n] - i) : i;
                    }, t1.median = function(e1, r) {
                        var n, i = [], a = e1.length, o = -1;
                        if (1 === arguments.length) for(; ++o < a;)d(n = p(e1[o])) && i.push(n);
                        else for(; ++o < a;)d(n = p(r.call(e1, e1[o], o))) && i.push(n);
                        if (i.length) return t1.quantile(i.sort(h), .5);
                    }, t1.variance = function(t1, e1) {
                        var r, n, i = t1.length, a = 0, o = 0, s = -1, l = 0;
                        if (1 === arguments.length) for(; ++s < i;)d(r = p(t1[s])) && (o += (n = r - a) * (r - (a += n / ++l)));
                        else for(; ++s < i;)d(r = p(e1.call(t1, t1[s], s))) && (o += (n = r - a) * (r - (a += n / ++l)));
                        if (l > 1) return o / (l - 1);
                    }, t1.deviation = function() {
                        var e1 = t1.variance.apply(this, arguments);
                        return e1 ? Math.sqrt(e1) : e1;
                    };
                    var g = m(h);
                    function v(t1) {
                        return t1.length;
                    }
                    t1.bisectLeft = g.left, t1.bisect = t1.bisectRight = g.right, t1.bisector = function(t1) {
                        return m(1 === t1.length ? function(e1, r) {
                            return h(t1(e1), r);
                        } : t1);
                    }, t1.shuffle = function(t1, e1, r) {
                        (a = arguments.length) < 3 && (r = t1.length, a < 2 && (e1 = 0));
                        for(var n, i, a = r - e1; a;)i = Math.random() * a-- | 0, n = t1[a + e1], t1[a + e1] = t1[i + e1], t1[i + e1] = n;
                        return t1;
                    }, t1.permute = function(t1, e1) {
                        for(var r = e1.length, n = new Array(r); r--;)n[r] = t1[e1[r]];
                        return n;
                    }, t1.pairs = function(t1) {
                        for(var e1 = 0, r = t1.length - 1, n = t1[0], i = new Array(r < 0 ? 0 : r); e1 < r;)i[e1] = [
                            n,
                            n = t1[++e1]
                        ];
                        return i;
                    }, t1.transpose = function(e1) {
                        if (!(a = e1.length)) return [];
                        for(var r = -1, n = t1.min(e1, v), i = new Array(n); ++r < n;)for(var a, o = -1, s = i[r] = new Array(a); ++o < a;)s[o] = e1[o][r];
                        return i;
                    }, t1.zip = function() {
                        return t1.transpose(arguments);
                    }, t1.keys = function(t1) {
                        var e1 = [];
                        for(var r in t1)e1.push(r);
                        return e1;
                    }, t1.values = function(t1) {
                        var e1 = [];
                        for(var r in t1)e1.push(t1[r]);
                        return e1;
                    }, t1.entries = function(t1) {
                        var e1 = [];
                        for(var r in t1)e1.push({
                            key: r,
                            value: t1[r]
                        });
                        return e1;
                    }, t1.merge = function(t1) {
                        for(var e1, r, n, i = t1.length, a = -1, o = 0; ++a < i;)o += t1[a].length;
                        for(r = new Array(o); --i >= 0;)for(e1 = (n = t1[i]).length; --e1 >= 0;)r[--o] = n[e1];
                        return r;
                    };
                    var y = Math.abs;
                    function x(t1) {
                        for(var e1 = 1; t1 * e1 % 1;)e1 *= 10;
                        return e1;
                    }
                    function b(t1, e1) {
                        for(var r in e1)Object.defineProperty(t1.prototype, r, {
                            value: e1[r],
                            enumerable: !1
                        });
                    }
                    function _() {
                        this._ = Object.create(null);
                    }
                    t1.range = function(t1, e1, r) {
                        if (arguments.length < 3 && (r = 1, arguments.length < 2 && (e1 = t1, t1 = 0)), (e1 - t1) / r == 1 / 0) throw new Error("infinite range");
                        var n, i = [], a = x(y(r)), o = -1;
                        if (t1 *= a, e1 *= a, (r *= a) < 0) for(; (n = t1 + r * ++o) > e1;)i.push(n / a);
                        else for(; (n = t1 + r * ++o) < e1;)i.push(n / a);
                        return i;
                    }, t1.map = function(t1, e1) {
                        var r = new _;
                        if (t1 instanceof _) t1.forEach(function(t1, e1) {
                            r.set(t1, e1);
                        });
                        else if (Array.isArray(t1)) {
                            var n, i = -1, a = t1.length;
                            if (1 === arguments.length) for(; ++i < a;)r.set(i, t1[i]);
                            else for(; ++i < a;)r.set(e1.call(t1, n = t1[i], i), n);
                        } else for(var o in t1)r.set(o, t1[o]);
                        return r;
                    };
                    function w(t1) {
                        return "__proto__" == (t1 += "") || "\0" === t1[0] ? "\0" + t1 : t1;
                    }
                    function T(t1) {
                        return "\0" === (t1 += "")[0] ? t1.slice(1) : t1;
                    }
                    function k(t1) {
                        return w(t1) in this._;
                    }
                    function A(t1) {
                        return (t1 = w(t1)) in this._ && delete this._[t1];
                    }
                    function M() {
                        var t1 = [];
                        for(var e1 in this._)t1.push(T(e1));
                        return t1;
                    }
                    function S() {
                        var t1 = 0;
                        for(var e1 in this._)++t1;
                        return t1;
                    }
                    function E() {
                        for(var t1 in this._)return !1;
                        return !0;
                    }
                    function L() {
                        this._ = Object.create(null);
                    }
                    function C(t1) {
                        return t1;
                    }
                    function P(t1, e1, r) {
                        return function() {
                            var n = r.apply(e1, arguments);
                            return n === e1 ? t1 : n;
                        };
                    }
                    function I(t1, e1) {
                        if (e1 in t1) return e1;
                        e1 = e1.charAt(0).toUpperCase() + e1.slice(1);
                        for(var r = 0, n = O.length; r < n; ++r){
                            var i = O[r] + e1;
                            if (i in t1) return i;
                        }
                    }
                    b(_, {
                        has: k,
                        get: function(t1) {
                            return this._[w(t1)];
                        },
                        set: function(t1, e1) {
                            return this._[w(t1)] = e1;
                        },
                        remove: A,
                        keys: M,
                        values: function() {
                            var t1 = [];
                            for(var e1 in this._)t1.push(this._[e1]);
                            return t1;
                        },
                        entries: function() {
                            var t1 = [];
                            for(var e1 in this._)t1.push({
                                key: T(e1),
                                value: this._[e1]
                            });
                            return t1;
                        },
                        size: S,
                        empty: E,
                        forEach: function(t1) {
                            for(var e1 in this._)t1.call(this, T(e1), this._[e1]);
                        }
                    }), t1.nest = function() {
                        var e1, r, n = {}, i = [], a = [];
                        function o(t1, a, s) {
                            if (s >= i.length) return r ? r.call(n, a) : e1 ? a.sort(e1) : a;
                            for(var l, c, u, f, h = -1, p = a.length, d = i[s++], m = new _; ++h < p;)(f = m.get(l = d(c = a[h]))) ? f.push(c) : m.set(l, [
                                c
                            ]);
                            return t1 ? (c = t1(), u = function(e1, r) {
                                c.set(e1, o(t1, r, s));
                            }) : (c = {}, u = function(e1, r) {
                                c[e1] = o(t1, r, s);
                            }), m.forEach(u), c;
                        }
                        return n.map = function(t1, e1) {
                            return o(e1, t1, 0);
                        }, n.entries = function(e1) {
                            return function t1(e1, r) {
                                if (r >= i.length) return e1;
                                var n = [], o = a[r++];
                                return e1.forEach(function(e1, i) {
                                    n.push({
                                        key: e1,
                                        values: t1(i, r)
                                    });
                                }), o ? n.sort(function(t1, e1) {
                                    return o(t1.key, e1.key);
                                }) : n;
                            }(o(t1.map, e1, 0), 0);
                        }, n.key = function(t1) {
                            return i.push(t1), n;
                        }, n.sortKeys = function(t1) {
                            return a[i.length - 1] = t1, n;
                        }, n.sortValues = function(t1) {
                            return e1 = t1, n;
                        }, n.rollup = function(t1) {
                            return r = t1, n;
                        }, n;
                    }, t1.set = function(t1) {
                        var e1 = new L;
                        if (t1) for(var r = 0, n = t1.length; r < n; ++r)e1.add(t1[r]);
                        return e1;
                    }, b(L, {
                        has: k,
                        add: function(t1) {
                            return this._[w(t1 += "")] = !0, t1;
                        },
                        remove: A,
                        values: M,
                        size: S,
                        empty: E,
                        forEach: function(t1) {
                            for(var e1 in this._)t1.call(this, T(e1));
                        }
                    }), t1.behavior = {}, t1.rebind = function(t1, e1) {
                        for(var r, n = 1, i = arguments.length; ++n < i;)t1[r = arguments[n]] = P(t1, e1, e1[r]);
                        return t1;
                    };
                    var O = [
                        "webkit",
                        "ms",
                        "moz",
                        "Moz",
                        "o",
                        "O"
                    ];
                    function z() {}
                    function D() {}
                    function R(t1) {
                        var e1 = [], r = new _;
                        function n() {
                            for(var r, n = e1, i = -1, a = n.length; ++i < a;)(r = n[i].on) && r.apply(this, arguments);
                            return t1;
                        }
                        return n.on = function(n, i) {
                            var a, o = r.get(n);
                            return arguments.length < 2 ? o && o.on : (o && (o.on = null, e1 = e1.slice(0, a = e1.indexOf(o)).concat(e1.slice(a + 1)), r.remove(n)), i && e1.push(r.set(n, {
                                on: i
                            })), t1);
                        }, n;
                    }
                    function F() {
                        t1.event.preventDefault();
                    }
                    function B() {
                        for(var e1, r = t1.event; e1 = r.sourceEvent;)r = e1;
                        return r;
                    }
                    function N(e1) {
                        for(var r = new D, n = 0, i = arguments.length; ++n < i;)r[arguments[n]] = R(r);
                        return r.of = function(n, i) {
                            return function(a) {
                                try {
                                    var o = a.sourceEvent = t1.event;
                                    a.target = e1, t1.event = a, r[a.type].apply(n, i);
                                } finally{
                                    t1.event = o;
                                }
                            };
                        }, r;
                    }
                    t1.dispatch = function() {
                        for(var t1 = new D, e1 = -1, r = arguments.length; ++e1 < r;)t1[arguments[e1]] = R(t1);
                        return t1;
                    }, D.prototype.on = function(t1, e1) {
                        var r = t1.indexOf("."), n = "";
                        if (r >= 0 && (n = t1.slice(r + 1), t1 = t1.slice(0, r)), t1) return arguments.length < 2 ? this[t1].on(n) : this[t1].on(n, e1);
                        if (2 === arguments.length) {
                            if (null == e1) for(t1 in this)this.hasOwnProperty(t1) && this[t1].on(n, null);
                            return this;
                        }
                    }, t1.event = null, t1.requote = function(t1) {
                        return t1.replace(j, "\\$&");
                    };
                    var j = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g, U = {}.__proto__ ? function(t1, e1) {
                        t1.__proto__ = e1;
                    } : function(t1, e1) {
                        for(var r in e1)t1[r] = e1[r];
                    };
                    function V(t1) {
                        return U(t1, Y), t1;
                    }
                    var H = function(t1, e1) {
                        return e1.querySelector(t1);
                    }, q = function(t1, e1) {
                        return e1.querySelectorAll(t1);
                    }, G = function(t1, e1) {
                        var r = t1.matches || t1[I(t1, "matchesSelector")];
                        return (G = function(t1, e1) {
                            return r.call(t1, e1);
                        })(t1, e1);
                    };
                    "function" == typeof Sizzle && (H = function(t1, e1) {
                        return Sizzle(t1, e1)[0] || null;
                    }, q = Sizzle, G = Sizzle.matchesSelector), t1.selection = function() {
                        return t1.select(i.documentElement);
                    };
                    var Y = t1.selection.prototype = [];
                    function W(t1) {
                        return "function" == typeof t1 ? t1 : function() {
                            return H(t1, this);
                        };
                    }
                    function X(t1) {
                        return "function" == typeof t1 ? t1 : function() {
                            return q(t1, this);
                        };
                    }
                    Y.select = function(t1) {
                        var e1, r, n, i, a = [];
                        t1 = W(t1);
                        for(var o = -1, s = this.length; ++o < s;){
                            a.push(e1 = []), e1.parentNode = (n = this[o]).parentNode;
                            for(var l = -1, c = n.length; ++l < c;)(i = n[l]) ? (e1.push(r = t1.call(i, i.__data__, l, o)), r && "__data__" in i && (r.__data__ = i.__data__)) : e1.push(null);
                        }
                        return V(a);
                    }, Y.selectAll = function(t1) {
                        var e1, r, i = [];
                        t1 = X(t1);
                        for(var a = -1, o = this.length; ++a < o;)for(var s = this[a], l = -1, c = s.length; ++l < c;)(r = s[l]) && (i.push(e1 = n(t1.call(r, r.__data__, l, a))), e1.parentNode = r);
                        return V(i);
                    };
                    var Z = "http://www.w3.org/1999/xhtml", J = {
                        svg: "http://www.w3.org/2000/svg",
                        xhtml: Z,
                        xlink: "http://www.w3.org/1999/xlink",
                        xml: "http://www.w3.org/XML/1998/namespace",
                        xmlns: "http://www.w3.org/2000/xmlns/"
                    };
                    function K(e1, r) {
                        return e1 = t1.ns.qualify(e1), null == r ? e1.local ? function() {
                            this.removeAttributeNS(e1.space, e1.local);
                        } : function() {
                            this.removeAttribute(e1);
                        } : "function" == typeof r ? e1.local ? function() {
                            var t1 = r.apply(this, arguments);
                            null == t1 ? this.removeAttributeNS(e1.space, e1.local) : this.setAttributeNS(e1.space, e1.local, t1);
                        } : function() {
                            var t1 = r.apply(this, arguments);
                            null == t1 ? this.removeAttribute(e1) : this.setAttribute(e1, t1);
                        } : e1.local ? function() {
                            this.setAttributeNS(e1.space, e1.local, r);
                        } : function() {
                            this.setAttribute(e1, r);
                        };
                    }
                    function Q(t1) {
                        return t1.trim().replace(/\s+/g, " ");
                    }
                    function $(e1) {
                        return new RegExp("(?:^|\\s+)" + t1.requote(e1) + "(?:\\s+|$)", "g");
                    }
                    function tt(t1) {
                        return (t1 + "").trim().split(/^|\s+/);
                    }
                    function et(t1, e1) {
                        var r = (t1 = tt(t1).map(rt)).length;
                        return "function" == typeof e1 ? function() {
                            for(var n = -1, i = e1.apply(this, arguments); ++n < r;)t1[n](this, i);
                        } : function() {
                            for(var n = -1; ++n < r;)t1[n](this, e1);
                        };
                    }
                    function rt(t1) {
                        var e1 = $(t1);
                        return function(r, n) {
                            if (i = r.classList) return n ? i.add(t1) : i.remove(t1);
                            var i = r.getAttribute("class") || "";
                            n ? (e1.lastIndex = 0, e1.test(i) || r.setAttribute("class", Q(i + " " + t1))) : r.setAttribute("class", Q(i.replace(e1, " ")));
                        };
                    }
                    function nt(t1, e1, r) {
                        return null == e1 ? function() {
                            this.style.removeProperty(t1);
                        } : "function" == typeof e1 ? function() {
                            var n = e1.apply(this, arguments);
                            null == n ? this.style.removeProperty(t1) : this.style.setProperty(t1, n, r);
                        } : function() {
                            this.style.setProperty(t1, e1, r);
                        };
                    }
                    function it(t1, e1) {
                        return null == e1 ? function() {
                            delete this[t1];
                        } : "function" == typeof e1 ? function() {
                            var r = e1.apply(this, arguments);
                            null == r ? delete this[t1] : this[t1] = r;
                        } : function() {
                            this[t1] = e1;
                        };
                    }
                    function at(e1) {
                        return "function" == typeof e1 ? e1 : (e1 = t1.ns.qualify(e1)).local ? function() {
                            return this.ownerDocument.createElementNS(e1.space, e1.local);
                        } : function() {
                            var t1 = this.ownerDocument, r = this.namespaceURI;
                            return r === Z && t1.documentElement.namespaceURI === Z ? t1.createElement(e1) : t1.createElementNS(r, e1);
                        };
                    }
                    function ot() {
                        var t1 = this.parentNode;
                        t1 && t1.removeChild(this);
                    }
                    function st(t1) {
                        return {
                            __data__: t1
                        };
                    }
                    function lt(t1) {
                        return function() {
                            return G(this, t1);
                        };
                    }
                    function ct(t1) {
                        return arguments.length || (t1 = h), function(e1, r) {
                            return e1 && r ? t1(e1.__data__, r.__data__) : !e1 - !r;
                        };
                    }
                    function ut(t1, e1) {
                        for(var r = 0, n = t1.length; r < n; r++)for(var i, a = t1[r], o = 0, s = a.length; o < s; o++)(i = a[o]) && e1(i, o, r);
                        return t1;
                    }
                    function ft(t1) {
                        return U(t1, ht), t1;
                    }
                    t1.ns = {
                        prefix: J,
                        qualify: function(t1) {
                            var e1 = t1.indexOf(":"), r = t1;
                            return e1 >= 0 && "xmlns" !== (r = t1.slice(0, e1)) && (t1 = t1.slice(e1 + 1)), J.hasOwnProperty(r) ? {
                                space: J[r],
                                local: t1
                            } : t1;
                        }
                    }, Y.attr = function(e1, r) {
                        if (arguments.length < 2) {
                            if ("string" == typeof e1) {
                                var n = this.node();
                                return (e1 = t1.ns.qualify(e1)).local ? n.getAttributeNS(e1.space, e1.local) : n.getAttribute(e1);
                            }
                            for(r in e1)this.each(K(r, e1[r]));
                            return this;
                        }
                        return this.each(K(e1, r));
                    }, Y.classed = function(t1, e1) {
                        if (arguments.length < 2) {
                            if ("string" == typeof t1) {
                                var r = this.node(), n = (t1 = tt(t1)).length, i = -1;
                                if (e1 = r.classList) {
                                    for(; ++i < n;)if (!e1.contains(t1[i])) return !1;
                                } else for(e1 = r.getAttribute("class"); ++i < n;)if (!$(t1[i]).test(e1)) return !1;
                                return !0;
                            }
                            for(e1 in t1)this.each(et(e1, t1[e1]));
                            return this;
                        }
                        return this.each(et(t1, e1));
                    }, Y.style = function(t1, e1, r) {
                        var n = arguments.length;
                        if (n < 3) {
                            if ("string" != typeof t1) {
                                for(r in n < 2 && (e1 = ""), t1)this.each(nt(r, t1[r], e1));
                                return this;
                            }
                            if (n < 2) {
                                var i = this.node();
                                return o(i).getComputedStyle(i, null).getPropertyValue(t1);
                            }
                            r = "";
                        }
                        return this.each(nt(t1, e1, r));
                    }, Y.property = function(t1, e1) {
                        if (arguments.length < 2) {
                            if ("string" == typeof t1) return this.node()[t1];
                            for(e1 in t1)this.each(it(e1, t1[e1]));
                            return this;
                        }
                        return this.each(it(t1, e1));
                    }, Y.text = function(t1) {
                        return arguments.length ? this.each("function" == typeof t1 ? function() {
                            var e1 = t1.apply(this, arguments);
                            this.textContent = null == e1 ? "" : e1;
                        } : null == t1 ? function() {
                            this.textContent = "";
                        } : function() {
                            this.textContent = t1;
                        }) : this.node().textContent;
                    }, Y.html = function(t1) {
                        return arguments.length ? this.each("function" == typeof t1 ? function() {
                            var e1 = t1.apply(this, arguments);
                            this.innerHTML = null == e1 ? "" : e1;
                        } : null == t1 ? function() {
                            this.innerHTML = "";
                        } : function() {
                            this.innerHTML = t1;
                        }) : this.node().innerHTML;
                    }, Y.append = function(t1) {
                        return t1 = at(t1), this.select(function() {
                            return this.appendChild(t1.apply(this, arguments));
                        });
                    }, Y.insert = function(t1, e1) {
                        return t1 = at(t1), e1 = W(e1), this.select(function() {
                            return this.insertBefore(t1.apply(this, arguments), e1.apply(this, arguments) || null);
                        });
                    }, Y.remove = function() {
                        return this.each(ot);
                    }, Y.data = function(t1, e1) {
                        var r, n, i = -1, a = this.length;
                        if (!arguments.length) {
                            for(t1 = new Array(a = (r = this[0]).length); ++i < a;)(n = r[i]) && (t1[i] = n.__data__);
                            return t1;
                        }
                        function o(t1, r) {
                            var n, i, a, o = t1.length, u = r.length, f = Math.min(o, u), h = new Array(u), p = new Array(u), d = new Array(o);
                            if (e1) {
                                var m, g = new _, v = new Array(o);
                                for(n = -1; ++n < o;)(i = t1[n]) && (g.has(m = e1.call(i, i.__data__, n)) ? d[n] = i : g.set(m, i), v[n] = m);
                                for(n = -1; ++n < u;)(i = g.get(m = e1.call(r, a = r[n], n))) ? !0 !== i && (h[n] = i, i.__data__ = a) : p[n] = st(a), g.set(m, !0);
                                for(n = -1; ++n < o;)n in v && !0 !== g.get(v[n]) && (d[n] = t1[n]);
                            } else {
                                for(n = -1; ++n < f;)i = t1[n], a = r[n], i ? (i.__data__ = a, h[n] = i) : p[n] = st(a);
                                for(; n < u; ++n)p[n] = st(r[n]);
                                for(; n < o; ++n)d[n] = t1[n];
                            }
                            p.update = h, p.parentNode = h.parentNode = d.parentNode = t1.parentNode, s.push(p), l.push(h), c.push(d);
                        }
                        var s = ft([]), l = V([]), c = V([]);
                        if ("function" == typeof t1) for(; ++i < a;)o(r = this[i], t1.call(r, r.parentNode.__data__, i));
                        else for(; ++i < a;)o(r = this[i], t1);
                        return l.enter = function() {
                            return s;
                        }, l.exit = function() {
                            return c;
                        }, l;
                    }, Y.datum = function(t1) {
                        return arguments.length ? this.property("__data__", t1) : this.property("__data__");
                    }, Y.filter = function(t1) {
                        var e1, r, n, i = [];
                        "function" != typeof t1 && (t1 = lt(t1));
                        for(var a = 0, o = this.length; a < o; a++){
                            i.push(e1 = []), e1.parentNode = (r = this[a]).parentNode;
                            for(var s = 0, l = r.length; s < l; s++)(n = r[s]) && t1.call(n, n.__data__, s, a) && e1.push(n);
                        }
                        return V(i);
                    }, Y.order = function() {
                        for(var t1 = -1, e1 = this.length; ++t1 < e1;)for(var r, n = this[t1], i = n.length - 1, a = n[i]; --i >= 0;)(r = n[i]) && (a && a !== r.nextSibling && a.parentNode.insertBefore(r, a), a = r);
                        return this;
                    }, Y.sort = function(t1) {
                        t1 = ct.apply(this, arguments);
                        for(var e1 = -1, r = this.length; ++e1 < r;)this[e1].sort(t1);
                        return this.order();
                    }, Y.each = function(t1) {
                        return ut(this, function(e1, r, n) {
                            t1.call(e1, e1.__data__, r, n);
                        });
                    }, Y.call = function(t1) {
                        var e1 = n(arguments);
                        return t1.apply(e1[0] = this, e1), this;
                    }, Y.empty = function() {
                        return !this.node();
                    }, Y.node = function() {
                        for(var t1 = 0, e1 = this.length; t1 < e1; t1++)for(var r = this[t1], n = 0, i = r.length; n < i; n++){
                            var a = r[n];
                            if (a) return a;
                        }
                        return null;
                    }, Y.size = function() {
                        var t1 = 0;
                        return ut(this, function() {
                            ++t1;
                        }), t1;
                    };
                    var ht = [];
                    function pt(t1) {
                        var e1, r;
                        return function(n, i, a) {
                            var o, s = t1[a].update, l = s.length;
                            for(a != r && (r = a, e1 = 0), i >= e1 && (e1 = i + 1); !(o = s[e1]) && ++e1 < l;);
                            return o;
                        };
                    }
                    function dt(e1, r, i) {
                        var a = "__on" + e1, o = e1.indexOf("."), s = gt;
                        o > 0 && (e1 = e1.slice(0, o));
                        var l = mt.get(e1);
                        function c() {
                            var t1 = this[a];
                            t1 && (this.removeEventListener(e1, t1, t1.$), delete this[a]);
                        }
                        return l && (e1 = l, s = vt), o ? r ? function() {
                            var t1 = s(r, n(arguments));
                            c.call(this), this.addEventListener(e1, this[a] = t1, t1.$ = i), t1._ = r;
                        } : c : r ? z : function() {
                            var r, n = new RegExp("^__on([^.]+)" + t1.requote(e1) + "$");
                            for(var i in this)if (r = i.match(n)) {
                                var a = this[i];
                                this.removeEventListener(r[1], a, a.$), delete this[i];
                            }
                        };
                    }
                    t1.selection.enter = ft, t1.selection.enter.prototype = ht, ht.append = Y.append, ht.empty = Y.empty, ht.node = Y.node, ht.call = Y.call, ht.size = Y.size, ht.select = function(t1) {
                        for(var e1, r, n, i, a, o = [], s = -1, l = this.length; ++s < l;){
                            n = (i = this[s]).update, o.push(e1 = []), e1.parentNode = i.parentNode;
                            for(var c = -1, u = i.length; ++c < u;)(a = i[c]) ? (e1.push(n[c] = r = t1.call(i.parentNode, a.__data__, c, s)), r.__data__ = a.__data__) : e1.push(null);
                        }
                        return V(o);
                    }, ht.insert = function(t1, e1) {
                        return arguments.length < 2 && (e1 = pt(this)), Y.insert.call(this, t1, e1);
                    }, t1.select = function(t1) {
                        var e1;
                        return "string" == typeof t1 ? (e1 = [
                            H(t1, i)
                        ]).parentNode = i.documentElement : (e1 = [
                            t1
                        ]).parentNode = a(t1), V([
                            e1
                        ]);
                    }, t1.selectAll = function(t1) {
                        var e1;
                        return "string" == typeof t1 ? (e1 = n(q(t1, i))).parentNode = i.documentElement : (e1 = n(t1)).parentNode = null, V([
                            e1
                        ]);
                    }, Y.on = function(t1, e1, r) {
                        var n = arguments.length;
                        if (n < 3) {
                            if ("string" != typeof t1) {
                                for(r in n < 2 && (e1 = !1), t1)this.each(dt(r, t1[r], e1));
                                return this;
                            }
                            if (n < 2) return (n = this.node()["__on" + t1]) && n._;
                            r = !1;
                        }
                        return this.each(dt(t1, e1, r));
                    };
                    var mt = t1.map({
                        mouseenter: "mouseover",
                        mouseleave: "mouseout"
                    });
                    function gt(e1, r) {
                        return function(n) {
                            var i = t1.event;
                            t1.event = n, r[0] = this.__data__;
                            try {
                                e1.apply(this, r);
                            } finally{
                                t1.event = i;
                            }
                        };
                    }
                    function vt(t1, e1) {
                        var r = gt(t1, e1);
                        return function(t1) {
                            var e1 = t1.relatedTarget;
                            e1 && (e1 === this || 8 & e1.compareDocumentPosition(this)) || r.call(this, t1);
                        };
                    }
                    i && mt.forEach(function(t1) {
                        "on" + t1 in i && mt.remove(t1);
                    });
                    var yt, xt = 0;
                    function bt(e1) {
                        var r = ".dragsuppress-" + ++xt, n = "click" + r, i = t1.select(o(e1)).on("touchmove" + r, F).on("dragstart" + r, F).on("selectstart" + r, F);
                        if (null == yt && (yt = !("onselectstart" in e1) && I(e1.style, "userSelect")), yt) {
                            var s = a(e1).style, l = s[yt];
                            s[yt] = "none";
                        }
                        return function(t1) {
                            if (i.on(r, null), yt && (s[yt] = l), t1) {
                                var e1 = function() {
                                    i.on(n, null);
                                };
                                i.on(n, function() {
                                    F(), e1();
                                }, !0), setTimeout(e1, 0);
                            }
                        };
                    }
                    t1.mouse = function(t1) {
                        return wt(t1, B());
                    };
                    var _t = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
                    function wt(e1, r) {
                        r.changedTouches && (r = r.changedTouches[0]);
                        var n = e1.ownerSVGElement || e1;
                        if (n.createSVGPoint) {
                            var i = n.createSVGPoint();
                            if (_t < 0) {
                                var a = o(e1);
                                if (a.scrollX || a.scrollY) {
                                    var s = (n = t1.select("body").append("svg").style({
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        margin: 0,
                                        padding: 0,
                                        border: "none"
                                    }, "important"))[0][0].getScreenCTM();
                                    _t = !(s.f || s.e), n.remove();
                                }
                            }
                            return _t ? (i.x = r.pageX, i.y = r.pageY) : (i.x = r.clientX, i.y = r.clientY), [
                                (i = i.matrixTransform(e1.getScreenCTM().inverse())).x,
                                i.y
                            ];
                        }
                        var l = e1.getBoundingClientRect();
                        return [
                            r.clientX - l.left - e1.clientLeft,
                            r.clientY - l.top - e1.clientTop
                        ];
                    }
                    function Tt() {
                        return t1.event.changedTouches[0].identifier;
                    }
                    t1.touch = function(t1, e1, r) {
                        if (arguments.length < 3 && (r = e1, e1 = B().changedTouches), e1) {
                            for(var n, i = 0, a = e1.length; i < a; ++i)if ((n = e1[i]).identifier === r) return wt(t1, n);
                        }
                    }, t1.behavior.drag = function() {
                        var e1 = N(a, "drag", "dragstart", "dragend"), r = null, n = s(z, t1.mouse, o, "mousemove", "mouseup"), i = s(Tt, t1.touch, C, "touchmove", "touchend");
                        function a() {
                            this.on("mousedown.drag", n).on("touchstart.drag", i);
                        }
                        function s(n, i, a, o, s) {
                            return function() {
                                var l, c = this, u = t1.event.target.correspondingElement || t1.event.target, f = c.parentNode, h = e1.of(c, arguments), p = 0, d = n(), m = ".drag" + (null == d ? "" : "-" + d), g = t1.select(a(u)).on(o + m, x).on(s + m, b), v = bt(u), y = i(f, d);
                                function x() {
                                    var t1, e1, r = i(f, d);
                                    r && (t1 = r[0] - y[0], e1 = r[1] - y[1], p |= t1 | e1, y = r, h({
                                        type: "drag",
                                        x: r[0] + l[0],
                                        y: r[1] + l[1],
                                        dx: t1,
                                        dy: e1
                                    }));
                                }
                                function b() {
                                    i(f, d) && (g.on(o + m, null).on(s + m, null), v(p), h({
                                        type: "dragend"
                                    }));
                                }
                                l = r ? [
                                    (l = r.apply(c, arguments)).x - y[0],
                                    l.y - y[1]
                                ] : [
                                    0,
                                    0
                                ], h({
                                    type: "dragstart"
                                });
                            };
                        }
                        return a.origin = function(t1) {
                            return arguments.length ? (r = t1, a) : r;
                        }, t1.rebind(a, e1, "on");
                    }, t1.touches = function(t1, e1) {
                        return arguments.length < 2 && (e1 = B().touches), e1 ? n(e1).map(function(e1) {
                            var r = wt(t1, e1);
                            return r.identifier = e1.identifier, r;
                        }) : [];
                    };
                    var kt = 1e-6, At = Math.PI, Mt = 2 * At, St = Mt - kt, Et = At / 2, Lt = At / 180, Ct = 180 / At;
                    function Pt(t1) {
                        return t1 > 1 ? Et : t1 < -1 ? -Et : Math.asin(t1);
                    }
                    function It(t1) {
                        return ((t1 = Math.exp(t1)) + 1 / t1) / 2;
                    }
                    var Ot = Math.SQRT2;
                    t1.interpolateZoom = function(t1, e1) {
                        var r, n, i = t1[0], a = t1[1], o = t1[2], s = e1[0], l = e1[1], c = e1[2], u = s - i, f = l - a, h = u * u + f * f;
                        if (h < 1e-12) n = Math.log(c / o) / Ot, r = function(t1) {
                            return [
                                i + t1 * u,
                                a + t1 * f,
                                o * Math.exp(Ot * t1 * n)
                            ];
                        };
                        else {
                            var p = Math.sqrt(h), d = (c * c - o * o + 4 * h) / (2 * o * 2 * p), m = (c * c - o * o - 4 * h) / (2 * c * 2 * p), g = Math.log(Math.sqrt(d * d + 1) - d), v = Math.log(Math.sqrt(m * m + 1) - m);
                            n = (v - g) / Ot, r = function(t1) {
                                var e1, r = t1 * n, s = It(g), l = o / (2 * p) * (s * (e1 = Ot * r + g, ((e1 = Math.exp(2 * e1)) - 1) / (e1 + 1)) - function(t1) {
                                    return ((t1 = Math.exp(t1)) - 1 / t1) / 2;
                                }(g));
                                return [
                                    i + l * u,
                                    a + l * f,
                                    o * s / It(Ot * r + g)
                                ];
                            };
                        }
                        return r.duration = 1e3 * n, r;
                    }, t1.behavior.zoom = function() {
                        var e1, r, n, a, s, l, c, u, f, h = {
                            x: 0,
                            y: 0,
                            k: 1
                        }, p = [
                            960,
                            500
                        ], d = Rt, m = 250, g = 0, v = "mousedown.zoom", y = "mousemove.zoom", x = "mouseup.zoom", b = "touchstart.zoom", _ = N(w, "zoomstart", "zoom", "zoomend");
                        function w(t1) {
                            t1.on(v, P).on(Dt + ".zoom", O).on("dblclick.zoom", z).on(b, I);
                        }
                        function T(t1) {
                            return [
                                (t1[0] - h.x) / h.k,
                                (t1[1] - h.y) / h.k
                            ];
                        }
                        function k(t1) {
                            h.k = Math.max(d[0], Math.min(d[1], t1));
                        }
                        function A(t1, e1) {
                            e1 = function(t1) {
                                return [
                                    t1[0] * h.k + h.x,
                                    t1[1] * h.k + h.y
                                ];
                            }(e1), h.x += t1[0] - e1[0], h.y += t1[1] - e1[1];
                        }
                        function M(e1, n, i, a) {
                            e1.__chart__ = {
                                x: h.x,
                                y: h.y,
                                k: h.k
                            }, k(Math.pow(2, a)), A(r = n, i), e1 = t1.select(e1), m > 0 && (e1 = e1.transition().duration(m)), e1.call(w.event);
                        }
                        function S() {
                            c && c.domain(l.range().map(function(t1) {
                                return (t1 - h.x) / h.k;
                            }).map(l.invert)), f && f.domain(u.range().map(function(t1) {
                                return (t1 - h.y) / h.k;
                            }).map(u.invert));
                        }
                        function E(t1) {
                            g++ || t1({
                                type: "zoomstart"
                            });
                        }
                        function L(t1) {
                            S(), t1({
                                type: "zoom",
                                scale: h.k,
                                translate: [
                                    h.x,
                                    h.y
                                ]
                            });
                        }
                        function C(t1) {
                            --g || (t1({
                                type: "zoomend"
                            }), r = null);
                        }
                        function P() {
                            var e1 = this, r = _.of(e1, arguments), n = 0, i = t1.select(o(e1)).on(y, l).on(x, c), a = T(t1.mouse(e1)), s = bt(e1);
                            function l() {
                                n = 1, A(t1.mouse(e1), a), L(r);
                            }
                            function c() {
                                i.on(y, null).on(x, null), s(n), C(r);
                            }
                            Di.call(e1), E(r);
                        }
                        function I() {
                            var e1, r = this, n = _.of(r, arguments), i = {}, a = 0, o = ".zoom-" + t1.event.changedTouches[0].identifier, l = "touchmove" + o, c = "touchend" + o, u = [], f = t1.select(r), p = bt(r);
                            function d() {
                                var n = t1.touches(r);
                                return e1 = h.k, n.forEach(function(t1) {
                                    t1.identifier in i && (i[t1.identifier] = T(t1));
                                }), n;
                            }
                            function m() {
                                var e1 = t1.event.target;
                                t1.select(e1).on(l, g).on(c, y), u.push(e1);
                                for(var n = t1.event.changedTouches, o = 0, f = n.length; o < f; ++o)i[n[o].identifier] = null;
                                var p = d(), m = Date.now();
                                if (1 === p.length) {
                                    if (m - s < 500) {
                                        var v = p[0];
                                        M(r, v, i[v.identifier], Math.floor(Math.log(h.k) / Math.LN2) + 1), F();
                                    }
                                    s = m;
                                } else if (p.length > 1) {
                                    v = p[0];
                                    var x = p[1], b = v[0] - x[0], _ = v[1] - x[1];
                                    a = b * b + _ * _;
                                }
                            }
                            function g() {
                                var o, l, c, u, f = t1.touches(r);
                                Di.call(r);
                                for(var h = 0, p = f.length; h < p; ++h, u = null)if (c = f[h], u = i[c.identifier]) {
                                    if (l) break;
                                    o = c, l = u;
                                }
                                if (u) {
                                    var d = (d = c[0] - o[0]) * d + (d = c[1] - o[1]) * d, m = a && Math.sqrt(d / a);
                                    o = [
                                        (o[0] + c[0]) / 2,
                                        (o[1] + c[1]) / 2
                                    ], l = [
                                        (l[0] + u[0]) / 2,
                                        (l[1] + u[1]) / 2
                                    ], k(m * e1);
                                }
                                s = null, A(o, l), L(n);
                            }
                            function y() {
                                if (t1.event.touches.length) {
                                    for(var e1 = t1.event.changedTouches, r = 0, a = e1.length; r < a; ++r)delete i[e1[r].identifier];
                                    for(var s in i)return void d();
                                }
                                t1.selectAll(u).on(o, null), f.on(v, P).on(b, I), p(), C(n);
                            }
                            m(), E(n), f.on(v, null).on(b, m);
                        }
                        function O() {
                            var i = _.of(this, arguments);
                            a ? clearTimeout(a) : (Di.call(this), e1 = T(r = n || t1.mouse(this)), E(i)), a = setTimeout(function() {
                                a = null, C(i);
                            }, 50), F(), k(Math.pow(2, .002 * zt()) * h.k), A(r, e1), L(i);
                        }
                        function z() {
                            var e1 = t1.mouse(this), r = Math.log(h.k) / Math.LN2;
                            M(this, e1, T(e1), t1.event.shiftKey ? Math.ceil(r) - 1 : Math.floor(r) + 1);
                        }
                        return Dt || (Dt = "onwheel" in i ? (zt = function() {
                            return -t1.event.deltaY * (t1.event.deltaMode ? 120 : 1);
                        }, "wheel") : "onmousewheel" in i ? (zt = function() {
                            return t1.event.wheelDelta;
                        }, "mousewheel") : (zt = function() {
                            return -t1.event.detail;
                        }, "MozMousePixelScroll")), w.event = function(e1) {
                            e1.each(function() {
                                var e1 = _.of(this, arguments), n = h;
                                Bi ? t1.select(this).transition().each("start.zoom", function() {
                                    h = this.__chart__ || {
                                        x: 0,
                                        y: 0,
                                        k: 1
                                    }, E(e1);
                                }).tween("zoom:zoom", function() {
                                    var i = p[0], a = p[1], o = r ? r[0] : i / 2, s = r ? r[1] : a / 2, l = t1.interpolateZoom([
                                        (o - h.x) / h.k,
                                        (s - h.y) / h.k,
                                        i / h.k
                                    ], [
                                        (o - n.x) / n.k,
                                        (s - n.y) / n.k,
                                        i / n.k
                                    ]);
                                    return function(t1) {
                                        var r = l(t1), n = i / r[2];
                                        this.__chart__ = h = {
                                            x: o - r[0] * n,
                                            y: s - r[1] * n,
                                            k: n
                                        }, L(e1);
                                    };
                                }).each("interrupt.zoom", function() {
                                    C(e1);
                                }).each("end.zoom", function() {
                                    C(e1);
                                }) : (this.__chart__ = h, E(e1), L(e1), C(e1));
                            });
                        }, w.translate = function(t1) {
                            return arguments.length ? (h = {
                                x: +t1[0],
                                y: +t1[1],
                                k: h.k
                            }, S(), w) : [
                                h.x,
                                h.y
                            ];
                        }, w.scale = function(t1) {
                            return arguments.length ? (h = {
                                x: h.x,
                                y: h.y,
                                k: null
                            }, k(+t1), S(), w) : h.k;
                        }, w.scaleExtent = function(t1) {
                            return arguments.length ? (d = null == t1 ? Rt : [
                                +t1[0],
                                +t1[1]
                            ], w) : d;
                        }, w.center = function(t1) {
                            return arguments.length ? (n = t1 && [
                                +t1[0],
                                +t1[1]
                            ], w) : n;
                        }, w.size = function(t1) {
                            return arguments.length ? (p = t1 && [
                                +t1[0],
                                +t1[1]
                            ], w) : p;
                        }, w.duration = function(t1) {
                            return arguments.length ? (m = +t1, w) : m;
                        }, w.x = function(t1) {
                            return arguments.length ? (c = t1, l = t1.copy(), h = {
                                x: 0,
                                y: 0,
                                k: 1
                            }, w) : c;
                        }, w.y = function(t1) {
                            return arguments.length ? (f = t1, u = t1.copy(), h = {
                                x: 0,
                                y: 0,
                                k: 1
                            }, w) : f;
                        }, t1.rebind(w, _, "on");
                    };
                    var zt, Dt, Rt = [
                        0,
                        1 / 0
                    ];
                    function Ft() {}
                    function Bt(t1, e1, r) {
                        return this instanceof Bt ? (this.h = +t1, this.s = +e1, void (this.l = +r)) : arguments.length < 2 ? t1 instanceof Bt ? new Bt(t1.h, t1.s, t1.l) : ne("" + t1, ie, Bt) : new Bt(t1, e1, r);
                    }
                    t1.color = Ft, Ft.prototype.toString = function() {
                        return this.rgb() + "";
                    }, t1.hsl = Bt;
                    var Nt = Bt.prototype = new Ft;
                    function jt(t1, e1, r) {
                        var n, i;
                        function a(t1) {
                            return Math.round(255 * function(t1) {
                                return t1 > 360 ? t1 -= 360 : t1 < 0 && (t1 += 360), t1 < 60 ? n + (i - n) * t1 / 60 : t1 < 180 ? i : t1 < 240 ? n + (i - n) * (240 - t1) / 60 : n;
                            }(t1));
                        }
                        return t1 = isNaN(t1) ? 0 : (t1 %= 360) < 0 ? t1 + 360 : t1, e1 = isNaN(e1) || e1 < 0 ? 0 : e1 > 1 ? 1 : e1, n = 2 * (r = r < 0 ? 0 : r > 1 ? 1 : r) - (i = r <= .5 ? r * (1 + e1) : r + e1 - r * e1), new Qt(a(t1 + 120), a(t1), a(t1 - 120));
                    }
                    function Ut(e1, r, n) {
                        return this instanceof Ut ? (this.h = +e1, this.c = +r, void (this.l = +n)) : arguments.length < 2 ? e1 instanceof Ut ? new Ut(e1.h, e1.c, e1.l) : Xt(e1 instanceof qt ? e1.l : (e1 = ae((e1 = t1.rgb(e1)).r, e1.g, e1.b)).l, e1.a, e1.b) : new Ut(e1, r, n);
                    }
                    Nt.brighter = function(t1) {
                        return t1 = Math.pow(.7, arguments.length ? t1 : 1), new Bt(this.h, this.s, this.l / t1);
                    }, Nt.darker = function(t1) {
                        return t1 = Math.pow(.7, arguments.length ? t1 : 1), new Bt(this.h, this.s, t1 * this.l);
                    }, Nt.rgb = function() {
                        return jt(this.h, this.s, this.l);
                    }, t1.hcl = Ut;
                    var Vt = Ut.prototype = new Ft;
                    function Ht(t1, e1, r) {
                        return isNaN(t1) && (t1 = 0), isNaN(e1) && (e1 = 0), new qt(r, Math.cos(t1 *= Lt) * e1, Math.sin(t1) * e1);
                    }
                    function qt(t1, e1, r) {
                        return this instanceof qt ? (this.l = +t1, this.a = +e1, void (this.b = +r)) : arguments.length < 2 ? t1 instanceof qt ? new qt(t1.l, t1.a, t1.b) : t1 instanceof Ut ? Ht(t1.h, t1.c, t1.l) : ae((t1 = Qt(t1)).r, t1.g, t1.b) : new qt(t1, e1, r);
                    }
                    Vt.brighter = function(t1) {
                        return new Ut(this.h, this.c, Math.min(100, this.l + Gt * (arguments.length ? t1 : 1)));
                    }, Vt.darker = function(t1) {
                        return new Ut(this.h, this.c, Math.max(0, this.l - Gt * (arguments.length ? t1 : 1)));
                    }, Vt.rgb = function() {
                        return Ht(this.h, this.c, this.l).rgb();
                    }, t1.lab = qt;
                    var Gt = 18, Yt = qt.prototype = new Ft;
                    function Wt(t1, e1, r) {
                        var n = (t1 + 16) / 116, i = n + e1 / 500, a = n - r / 200;
                        return new Qt(Kt(3.2404542 * (i = .95047 * Zt(i)) - 1.5371385 * (n = 1 * Zt(n)) - .4985314 * (a = 1.08883 * Zt(a))), Kt(-0.969266 * i + 1.8760108 * n + .041556 * a), Kt(.0556434 * i - .2040259 * n + 1.0572252 * a));
                    }
                    function Xt(t1, e1, r) {
                        return t1 > 0 ? new Ut(Math.atan2(r, e1) * Ct, Math.sqrt(e1 * e1 + r * r), t1) : new Ut(NaN, NaN, t1);
                    }
                    function Zt(t1) {
                        return t1 > .206893034 ? t1 * t1 * t1 : (t1 - 4 / 29) / 7.787037;
                    }
                    function Jt(t1) {
                        return t1 > .008856 ? Math.pow(t1, 1 / 3) : 7.787037 * t1 + 4 / 29;
                    }
                    function Kt(t1) {
                        return Math.round(255 * (t1 <= .00304 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055));
                    }
                    function Qt(t1, e1, r) {
                        return this instanceof Qt ? (this.r = ~~t1, this.g = ~~e1, void (this.b = ~~r)) : arguments.length < 2 ? t1 instanceof Qt ? new Qt(t1.r, t1.g, t1.b) : ne("" + t1, Qt, jt) : new Qt(t1, e1, r);
                    }
                    function $t(t1) {
                        return new Qt(t1 >> 16, t1 >> 8 & 255, 255 & t1);
                    }
                    function te(t1) {
                        return $t(t1) + "";
                    }
                    Yt.brighter = function(t1) {
                        return new qt(Math.min(100, this.l + Gt * (arguments.length ? t1 : 1)), this.a, this.b);
                    }, Yt.darker = function(t1) {
                        return new qt(Math.max(0, this.l - Gt * (arguments.length ? t1 : 1)), this.a, this.b);
                    }, Yt.rgb = function() {
                        return Wt(this.l, this.a, this.b);
                    }, t1.rgb = Qt;
                    var ee = Qt.prototype = new Ft;
                    function re(t1) {
                        return t1 < 16 ? "0" + Math.max(0, t1).toString(16) : Math.min(255, t1).toString(16);
                    }
                    function ne(t1, e1, r) {
                        var n, i, a, o = 0, s = 0, l = 0;
                        if (n = /([a-z]+)\((.*)\)/.exec(t1 = t1.toLowerCase())) switch(i = n[2].split(","), n[1]){
                            case "hsl":
                                return r(parseFloat(i[0]), parseFloat(i[1]) / 100, parseFloat(i[2]) / 100);
                            case "rgb":
                                return e1(se(i[0]), se(i[1]), se(i[2]));
                        }
                        return (a = le.get(t1)) ? e1(a.r, a.g, a.b) : (null == t1 || "#" !== t1.charAt(0) || isNaN(a = parseInt(t1.slice(1), 16)) || (4 === t1.length ? (o = (3840 & a) >> 4, o |= o >> 4, s = 240 & a, s |= s >> 4, l = 15 & a, l |= l << 4) : 7 === t1.length && (o = (16711680 & a) >> 16, s = (65280 & a) >> 8, l = 255 & a)), e1(o, s, l));
                    }
                    function ie(t1, e1, r) {
                        var n, i, a = Math.min(t1 /= 255, e1 /= 255, r /= 255), o = Math.max(t1, e1, r), s = o - a, l = (o + a) / 2;
                        return s ? (i = l < .5 ? s / (o + a) : s / (2 - o - a), n = t1 == o ? (e1 - r) / s + (e1 < r ? 6 : 0) : e1 == o ? (r - t1) / s + 2 : (t1 - e1) / s + 4, n *= 60) : (n = NaN, i = l > 0 && l < 1 ? 0 : n), new Bt(n, i, l);
                    }
                    function ae(t1, e1, r) {
                        var n = Jt((.4124564 * (t1 = oe(t1)) + .3575761 * (e1 = oe(e1)) + .1804375 * (r = oe(r))) / .95047), i = Jt((.2126729 * t1 + .7151522 * e1 + .072175 * r) / 1);
                        return qt(116 * i - 16, 500 * (n - i), 200 * (i - Jt((.0193339 * t1 + .119192 * e1 + .9503041 * r) / 1.08883)));
                    }
                    function oe(t1) {
                        return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
                    }
                    function se(t1) {
                        var e1 = parseFloat(t1);
                        return "%" === t1.charAt(t1.length - 1) ? Math.round(2.55 * e1) : e1;
                    }
                    ee.brighter = function(t1) {
                        t1 = Math.pow(.7, arguments.length ? t1 : 1);
                        var e1 = this.r, r = this.g, n = this.b, i = 30;
                        return e1 || r || n ? (e1 && e1 < i && (e1 = i), r && r < i && (r = i), n && n < i && (n = i), new Qt(Math.min(255, e1 / t1), Math.min(255, r / t1), Math.min(255, n / t1))) : new Qt(i, i, i);
                    }, ee.darker = function(t1) {
                        return new Qt((t1 = Math.pow(.7, arguments.length ? t1 : 1)) * this.r, t1 * this.g, t1 * this.b);
                    }, ee.hsl = function() {
                        return ie(this.r, this.g, this.b);
                    }, ee.toString = function() {
                        return "#" + re(this.r) + re(this.g) + re(this.b);
                    };
                    var le = t1.map({
                        aliceblue: 15792383,
                        antiquewhite: 16444375,
                        aqua: 65535,
                        aquamarine: 8388564,
                        azure: 15794175,
                        beige: 16119260,
                        bisque: 16770244,
                        black: 0,
                        blanchedalmond: 16772045,
                        blue: 255,
                        blueviolet: 9055202,
                        brown: 10824234,
                        burlywood: 14596231,
                        cadetblue: 6266528,
                        chartreuse: 8388352,
                        chocolate: 13789470,
                        coral: 16744272,
                        cornflowerblue: 6591981,
                        cornsilk: 16775388,
                        crimson: 14423100,
                        cyan: 65535,
                        darkblue: 139,
                        darkcyan: 35723,
                        darkgoldenrod: 12092939,
                        darkgray: 11119017,
                        darkgreen: 25600,
                        darkgrey: 11119017,
                        darkkhaki: 12433259,
                        darkmagenta: 9109643,
                        darkolivegreen: 5597999,
                        darkorange: 16747520,
                        darkorchid: 10040012,
                        darkred: 9109504,
                        darksalmon: 15308410,
                        darkseagreen: 9419919,
                        darkslateblue: 4734347,
                        darkslategray: 3100495,
                        darkslategrey: 3100495,
                        darkturquoise: 52945,
                        darkviolet: 9699539,
                        deeppink: 16716947,
                        deepskyblue: 49151,
                        dimgray: 6908265,
                        dimgrey: 6908265,
                        dodgerblue: 2003199,
                        firebrick: 11674146,
                        floralwhite: 16775920,
                        forestgreen: 2263842,
                        fuchsia: 16711935,
                        gainsboro: 14474460,
                        ghostwhite: 16316671,
                        gold: 16766720,
                        goldenrod: 14329120,
                        gray: 8421504,
                        green: 32768,
                        greenyellow: 11403055,
                        grey: 8421504,
                        honeydew: 15794160,
                        hotpink: 16738740,
                        indianred: 13458524,
                        indigo: 4915330,
                        ivory: 16777200,
                        khaki: 15787660,
                        lavender: 15132410,
                        lavenderblush: 16773365,
                        lawngreen: 8190976,
                        lemonchiffon: 16775885,
                        lightblue: 11393254,
                        lightcoral: 15761536,
                        lightcyan: 14745599,
                        lightgoldenrodyellow: 16448210,
                        lightgray: 13882323,
                        lightgreen: 9498256,
                        lightgrey: 13882323,
                        lightpink: 16758465,
                        lightsalmon: 16752762,
                        lightseagreen: 2142890,
                        lightskyblue: 8900346,
                        lightslategray: 7833753,
                        lightslategrey: 7833753,
                        lightsteelblue: 11584734,
                        lightyellow: 16777184,
                        lime: 65280,
                        limegreen: 3329330,
                        linen: 16445670,
                        magenta: 16711935,
                        maroon: 8388608,
                        mediumaquamarine: 6737322,
                        mediumblue: 205,
                        mediumorchid: 12211667,
                        mediumpurple: 9662683,
                        mediumseagreen: 3978097,
                        mediumslateblue: 8087790,
                        mediumspringgreen: 64154,
                        mediumturquoise: 4772300,
                        mediumvioletred: 13047173,
                        midnightblue: 1644912,
                        mintcream: 16121850,
                        mistyrose: 16770273,
                        moccasin: 16770229,
                        navajowhite: 16768685,
                        navy: 128,
                        oldlace: 16643558,
                        olive: 8421376,
                        olivedrab: 7048739,
                        orange: 16753920,
                        orangered: 16729344,
                        orchid: 14315734,
                        palegoldenrod: 15657130,
                        palegreen: 10025880,
                        paleturquoise: 11529966,
                        palevioletred: 14381203,
                        papayawhip: 16773077,
                        peachpuff: 16767673,
                        peru: 13468991,
                        pink: 16761035,
                        plum: 14524637,
                        powderblue: 11591910,
                        purple: 8388736,
                        rebeccapurple: 6697881,
                        red: 16711680,
                        rosybrown: 12357519,
                        royalblue: 4286945,
                        saddlebrown: 9127187,
                        salmon: 16416882,
                        sandybrown: 16032864,
                        seagreen: 3050327,
                        seashell: 16774638,
                        sienna: 10506797,
                        silver: 12632256,
                        skyblue: 8900331,
                        slateblue: 6970061,
                        slategray: 7372944,
                        slategrey: 7372944,
                        snow: 16775930,
                        springgreen: 65407,
                        steelblue: 4620980,
                        tan: 13808780,
                        teal: 32896,
                        thistle: 14204888,
                        tomato: 16737095,
                        turquoise: 4251856,
                        violet: 15631086,
                        wheat: 16113331,
                        white: 16777215,
                        whitesmoke: 16119285,
                        yellow: 16776960,
                        yellowgreen: 10145074
                    });
                    function ce(t1) {
                        return "function" == typeof t1 ? t1 : function() {
                            return t1;
                        };
                    }
                    function ue(t1) {
                        return function(e1, r, n) {
                            return 2 === arguments.length && "function" == typeof r && (n = r, r = null), fe(e1, r, t1, n);
                        };
                    }
                    function fe(e1, r, i, a) {
                        var o = {}, s = t1.dispatch("beforesend", "progress", "load", "error"), l = {}, c = new XMLHttpRequest, u = null;
                        function f() {
                            var t1, e1 = c.status;
                            if (!e1 && function(t1) {
                                var e1 = t1.responseType;
                                return e1 && "text" !== e1 ? t1.response : t1.responseText;
                            }(c) || e1 >= 200 && e1 < 300 || 304 === e1) {
                                try {
                                    t1 = i.call(o, c);
                                } catch (t1) {
                                    return void s.error.call(o, t1);
                                }
                                s.load.call(o, t1);
                            } else s.error.call(o, c);
                        }
                        return self.XDomainRequest && !("withCredentials" in c) && /^(http(s)?:)?\/\//.test(e1) && (c = new XDomainRequest), "onload" in c ? c.onload = c.onerror = f : c.onreadystatechange = function() {
                            c.readyState > 3 && f();
                        }, c.onprogress = function(e1) {
                            var r = t1.event;
                            t1.event = e1;
                            try {
                                s.progress.call(o, c);
                            } finally{
                                t1.event = r;
                            }
                        }, o.header = function(t1, e1) {
                            return t1 = (t1 + "").toLowerCase(), arguments.length < 2 ? l[t1] : (null == e1 ? delete l[t1] : l[t1] = e1 + "", o);
                        }, o.mimeType = function(t1) {
                            return arguments.length ? (r = null == t1 ? null : t1 + "", o) : r;
                        }, o.responseType = function(t1) {
                            return arguments.length ? (u = t1, o) : u;
                        }, o.response = function(t1) {
                            return i = t1, o;
                        }, [
                            "get",
                            "post"
                        ].forEach(function(t1) {
                            o[t1] = function() {
                                return o.send.apply(o, [
                                    t1
                                ].concat(n(arguments)));
                            };
                        }), o.send = function(t1, n, i) {
                            if (2 === arguments.length && "function" == typeof n && (i = n, n = null), c.open(t1, e1, !0), null == r || "accept" in l || (l.accept = r + ",*/*"), c.setRequestHeader) for(var a in l)c.setRequestHeader(a, l[a]);
                            return null != r && c.overrideMimeType && c.overrideMimeType(r), null != u && (c.responseType = u), null != i && o.on("error", i).on("load", function(t1) {
                                i(null, t1);
                            }), s.beforesend.call(o, c), c.send(null == n ? null : n), o;
                        }, o.abort = function() {
                            return c.abort(), o;
                        }, t1.rebind(o, s, "on"), null == a ? o : o.get(function(t1) {
                            return 1 === t1.length ? function(e1, r) {
                                t1(null == e1 ? r : null);
                            } : t1;
                        }(a));
                    }
                    le.forEach(function(t1, e1) {
                        le.set(t1, $t(e1));
                    }), t1.functor = ce, t1.xhr = ue(C), t1.dsv = function(t1, e1) {
                        var r = new RegExp('["' + t1 + "\n]"), n = t1.charCodeAt(0);
                        function i(t1, r, n) {
                            arguments.length < 3 && (n = r, r = null);
                            var i = fe(t1, e1, null == r ? a : o(r), n);
                            return i.row = function(t1) {
                                return arguments.length ? i.response(null == (r = t1) ? a : o(t1)) : r;
                            }, i;
                        }
                        function a(t1) {
                            return i.parse(t1.responseText);
                        }
                        function o(t1) {
                            return function(e1) {
                                return i.parse(e1.responseText, t1);
                            };
                        }
                        function s(e1) {
                            return e1.map(l).join(t1);
                        }
                        function l(t1) {
                            return r.test(t1) ? '"' + t1.replace(/\"/g, '""') + '"' : t1;
                        }
                        return i.parse = function(t1, e1) {
                            var r;
                            return i.parseRows(t1, function(t1, n) {
                                if (r) return r(t1, n - 1);
                                var i = function(e1) {
                                    for(var r = {}, n = t1.length, i = 0; i < n; ++i)r[t1[i]] = e1[i];
                                    return r;
                                };
                                r = e1 ? function(t1, r) {
                                    return e1(i(t1), r);
                                } : i;
                            });
                        }, i.parseRows = function(t1, e1) {
                            var r, i, a = {}, o = {}, s = [], l = t1.length, c = 0, u = 0;
                            function f() {
                                if (c >= l) return o;
                                if (i) return i = !1, a;
                                var e1 = c;
                                if (34 === t1.charCodeAt(e1)) {
                                    for(var r = e1; r++ < l;)if (34 === t1.charCodeAt(r)) {
                                        if (34 !== t1.charCodeAt(r + 1)) break;
                                        ++r;
                                    }
                                    return c = r + 2, 13 === (s = t1.charCodeAt(r + 1)) ? (i = !0, 10 === t1.charCodeAt(r + 2) && ++c) : 10 === s && (i = !0), t1.slice(e1 + 1, r).replace(/""/g, '"');
                                }
                                for(; c < l;){
                                    var s, u = 1;
                                    if (10 === (s = t1.charCodeAt(c++))) i = !0;
                                    else if (13 === s) i = !0, 10 === t1.charCodeAt(c) && (++c, ++u);
                                    else if (s !== n) continue;
                                    return t1.slice(e1, c - u);
                                }
                                return t1.slice(e1);
                            }
                            for(; (r = f()) !== o;){
                                for(var h = []; r !== a && r !== o;)h.push(r), r = f();
                                e1 && null == (h = e1(h, u++)) || s.push(h);
                            }
                            return s;
                        }, i.format = function(e1) {
                            if (Array.isArray(e1[0])) return i.formatRows(e1);
                            var r = new L, n = [];
                            return e1.forEach(function(t1) {
                                for(var e1 in t1)r.has(e1) || n.push(r.add(e1));
                            }), [
                                n.map(l).join(t1)
                            ].concat(e1.map(function(e1) {
                                return n.map(function(t1) {
                                    return l(e1[t1]);
                                }).join(t1);
                            })).join("\n");
                        }, i.formatRows = function(t1) {
                            return t1.map(s).join("\n");
                        }, i;
                    }, t1.csv = t1.dsv(",", "text/csv"), t1.tsv = t1.dsv("\t", "text/tab-separated-values");
                    var he, pe, de, me, ge = this[I(this, "requestAnimationFrame")] || function(t1) {
                        setTimeout(t1, 17);
                    };
                    function ve(t1, e1, r) {
                        var n = arguments.length;
                        n < 2 && (e1 = 0), n < 3 && (r = Date.now());
                        var i = r + e1, a = {
                            c: t1,
                            t: i,
                            n: null
                        };
                        return pe ? pe.n = a : he = a, pe = a, de || (me = clearTimeout(me), de = 1, ge(ye)), a;
                    }
                    function ye() {
                        var t1 = xe(), e1 = be() - t1;
                        e1 > 24 ? (isFinite(e1) && (clearTimeout(me), me = setTimeout(ye, e1)), de = 0) : (de = 1, ge(ye));
                    }
                    function xe() {
                        for(var t1 = Date.now(), e1 = he; e1;)t1 >= e1.t && e1.c(t1 - e1.t) && (e1.c = null), e1 = e1.n;
                        return t1;
                    }
                    function be() {
                        for(var t1, e1 = he, r = 1 / 0; e1;)e1.c ? (e1.t < r && (r = e1.t), e1 = (t1 = e1).n) : e1 = t1 ? t1.n = e1.n : he = e1.n;
                        return pe = t1, r;
                    }
                    function _e(t1) {
                        return t1[0];
                    }
                    function we(t1) {
                        return t1[1];
                    }
                    function Te(t1) {
                        for(var e1, r, n, i = t1.length, a = [
                            0,
                            1
                        ], o = 2, s = 2; s < i; s++){
                            for(; o > 1 && (e1 = t1[a[o - 2]], r = t1[a[o - 1]], n = t1[s], (r[0] - e1[0]) * (n[1] - e1[1]) - (r[1] - e1[1]) * (n[0] - e1[0]) <= 0);)--o;
                            a[o++] = s;
                        }
                        return a.slice(0, o);
                    }
                    function ke(t1, e1) {
                        return t1[0] - e1[0] || t1[1] - e1[1];
                    }
                    t1.timer = function() {
                        ve.apply(this, arguments);
                    }, t1.timer.flush = function() {
                        xe(), be();
                    }, t1.round = function(t1, e1) {
                        return e1 ? Math.round(t1 * (e1 = Math.pow(10, e1))) / e1 : Math.round(t1);
                    }, t1.geom = {}, t1.geom.hull = function(t1) {
                        var e1 = _e, r = we;
                        if (arguments.length) return n(t1);
                        function n(t1) {
                            if (t1.length < 3) return [];
                            var n, i = ce(e1), a = ce(r), o = t1.length, s = [], l = [];
                            for(n = 0; n < o; n++)s.push([
                                +i.call(this, t1[n], n),
                                +a.call(this, t1[n], n),
                                n
                            ]);
                            for(s.sort(ke), n = 0; n < o; n++)l.push([
                                s[n][0],
                                -s[n][1]
                            ]);
                            var c = Te(s), u = Te(l), f = u[0] === c[0], h = u[u.length - 1] === c[c.length - 1], p = [];
                            for(n = c.length - 1; n >= 0; --n)p.push(t1[s[c[n]][2]]);
                            for(n = +f; n < u.length - h; ++n)p.push(t1[s[u[n]][2]]);
                            return p;
                        }
                        return n.x = function(t1) {
                            return arguments.length ? (e1 = t1, n) : e1;
                        }, n.y = function(t1) {
                            return arguments.length ? (r = t1, n) : r;
                        }, n;
                    }, t1.geom.polygon = function(t1) {
                        return U(t1, Ae), t1;
                    };
                    var Ae = t1.geom.polygon.prototype = [];
                    function Me(t1, e1, r) {
                        return (r[0] - e1[0]) * (t1[1] - e1[1]) < (r[1] - e1[1]) * (t1[0] - e1[0]);
                    }
                    function Se(t1, e1, r, n) {
                        var i = t1[0], a = r[0], o = e1[0] - i, s = n[0] - a, l = t1[1], c = r[1], u = e1[1] - l, f = n[1] - c, h = (s * (l - c) - f * (i - a)) / (f * o - s * u);
                        return [
                            i + h * o,
                            l + h * u
                        ];
                    }
                    function Ee(t1) {
                        var e1 = t1[0], r = t1[t1.length - 1];
                        return !(e1[0] - r[0] || e1[1] - r[1]);
                    }
                    Ae.area = function() {
                        for(var t1, e1 = -1, r = this.length, n = this[r - 1], i = 0; ++e1 < r;)t1 = n, n = this[e1], i += t1[1] * n[0] - t1[0] * n[1];
                        return .5 * i;
                    }, Ae.centroid = function(t1) {
                        var e1, r, n = -1, i = this.length, a = 0, o = 0, s = this[i - 1];
                        for(arguments.length || (t1 = -1 / (6 * this.area())); ++n < i;)e1 = s, s = this[n], r = e1[0] * s[1] - s[0] * e1[1], a += (e1[0] + s[0]) * r, o += (e1[1] + s[1]) * r;
                        return [
                            a * t1,
                            o * t1
                        ];
                    }, Ae.clip = function(t1) {
                        for(var e1, r, n, i, a, o, s = Ee(t1), l = -1, c = this.length - Ee(this), u = this[c - 1]; ++l < c;){
                            for(e1 = t1.slice(), t1.length = 0, i = this[l], a = e1[(n = e1.length - s) - 1], r = -1; ++r < n;)Me(o = e1[r], u, i) ? (Me(a, u, i) || t1.push(Se(a, o, u, i)), t1.push(o)) : Me(a, u, i) && t1.push(Se(a, o, u, i)), a = o;
                            s && t1.push(t1[0]), u = i;
                        }
                        return t1;
                    };
                    var Le, Ce, Pe, Ie, Oe, ze = [], De = [];
                    function Re() {
                        er(this), this.edge = this.site = this.circle = null;
                    }
                    function Fe(t1) {
                        var e1 = ze.pop() || new Re;
                        return e1.site = t1, e1;
                    }
                    function Be(t1) {
                        We(t1), Pe.remove(t1), ze.push(t1), er(t1);
                    }
                    function Ne(t1) {
                        var e1 = t1.circle, r = e1.x, n = e1.cy, i = {
                            x: r,
                            y: n
                        }, a = t1.P, o = t1.N, s = [
                            t1
                        ];
                        Be(t1);
                        for(var l = a; l.circle && y(r - l.circle.x) < kt && y(n - l.circle.cy) < kt;)a = l.P, s.unshift(l), Be(l), l = a;
                        s.unshift(l), We(l);
                        for(var c = o; c.circle && y(r - c.circle.x) < kt && y(n - c.circle.cy) < kt;)o = c.N, s.push(c), Be(c), c = o;
                        s.push(c), We(c);
                        var u, f = s.length;
                        for(u = 1; u < f; ++u)c = s[u], l = s[u - 1], Qe(c.edge, l.site, c.site, i);
                        l = s[0], (c = s[f - 1]).edge = Je(l.site, c.site, null, i), Ye(l), Ye(c);
                    }
                    function je(t1) {
                        for(var e1, r, n, i, a = t1.x, o = t1.y, s = Pe._; s;)if ((n = Ue(s, o) - a) > kt) s = s.L;
                        else {
                            if (!((i = a - Ve(s, o)) > kt)) {
                                n > -kt ? (e1 = s.P, r = s) : i > -kt ? (e1 = s, r = s.N) : e1 = r = s;
                                break;
                            }
                            if (!s.R) {
                                e1 = s;
                                break;
                            }
                            s = s.R;
                        }
                        var l = Fe(t1);
                        if (Pe.insert(e1, l), e1 || r) {
                            if (e1 === r) return We(e1), r = Fe(e1.site), Pe.insert(l, r), l.edge = r.edge = Je(e1.site, l.site), Ye(e1), void Ye(r);
                            if (r) {
                                We(e1), We(r);
                                var c = e1.site, u = c.x, f = c.y, h = t1.x - u, p = t1.y - f, d = r.site, m = d.x - u, g = d.y - f, v = 2 * (h * g - p * m), y = h * h + p * p, x = m * m + g * g, b = {
                                    x: (g * y - p * x) / v + u,
                                    y: (h * x - m * y) / v + f
                                };
                                Qe(r.edge, c, d, b), l.edge = Je(c, t1, null, b), r.edge = Je(t1, d, null, b), Ye(e1), Ye(r);
                            } else l.edge = Je(e1.site, l.site);
                        }
                    }
                    function Ue(t1, e1) {
                        var r = t1.site, n = r.x, i = r.y, a = i - e1;
                        if (!a) return n;
                        var o = t1.P;
                        if (!o) return -1 / 0;
                        var s = (r = o.site).x, l = r.y, c = l - e1;
                        if (!c) return s;
                        var u = s - n, f = 1 / a - 1 / c, h = u / c;
                        return f ? (-h + Math.sqrt(h * h - 2 * f * (u * u / (-2 * c) - l + c / 2 + i - a / 2))) / f + n : (n + s) / 2;
                    }
                    function Ve(t1, e1) {
                        var r = t1.N;
                        if (r) return Ue(r, e1);
                        var n = t1.site;
                        return n.y === e1 ? n.x : 1 / 0;
                    }
                    function He(t1) {
                        this.site = t1, this.edges = [];
                    }
                    function qe(t1, e1) {
                        return e1.angle - t1.angle;
                    }
                    function Ge() {
                        er(this), this.x = this.y = this.arc = this.site = this.cy = null;
                    }
                    function Ye(t1) {
                        var e1 = t1.P, r = t1.N;
                        if (e1 && r) {
                            var n = e1.site, i = t1.site, a = r.site;
                            if (n !== a) {
                                var o = i.x, s = i.y, l = n.x - o, c = n.y - s, u = a.x - o, f = 2 * (l * (g = a.y - s) - c * u);
                                if (!(f >= -0.000000000001)) {
                                    var h = l * l + c * c, p = u * u + g * g, d = (g * h - c * p) / f, m = (l * p - u * h) / f, g = m + s, v = De.pop() || new Ge;
                                    v.arc = t1, v.site = i, v.x = d + o, v.y = g + Math.sqrt(d * d + m * m), v.cy = g, t1.circle = v;
                                    for(var y = null, x = Oe._; x;)if (v.y < x.y || v.y === x.y && v.x <= x.x) {
                                        if (!x.L) {
                                            y = x.P;
                                            break;
                                        }
                                        x = x.L;
                                    } else {
                                        if (!x.R) {
                                            y = x;
                                            break;
                                        }
                                        x = x.R;
                                    }
                                    Oe.insert(y, v), y || (Ie = v);
                                }
                            }
                        }
                    }
                    function We(t1) {
                        var e1 = t1.circle;
                        e1 && (e1.P || (Ie = e1.N), Oe.remove(e1), De.push(e1), er(e1), t1.circle = null);
                    }
                    function Xe(t1, e1) {
                        var r = t1.b;
                        if (r) return !0;
                        var n, i, a = t1.a, o = e1[0][0], s = e1[1][0], l = e1[0][1], c = e1[1][1], u = t1.l, f = t1.r, h = u.x, p = u.y, d = f.x, m = f.y, g = (h + d) / 2, v = (p + m) / 2;
                        if (m === p) {
                            if (g < o || g >= s) return;
                            if (h > d) {
                                if (a) {
                                    if (a.y >= c) return;
                                } else a = {
                                    x: g,
                                    y: l
                                };
                                r = {
                                    x: g,
                                    y: c
                                };
                            } else {
                                if (a) {
                                    if (a.y < l) return;
                                } else a = {
                                    x: g,
                                    y: c
                                };
                                r = {
                                    x: g,
                                    y: l
                                };
                            }
                        } else if (i = v - (n = (h - d) / (m - p)) * g, n < -1 || n > 1) {
                            if (h > d) {
                                if (a) {
                                    if (a.y >= c) return;
                                } else a = {
                                    x: (l - i) / n,
                                    y: l
                                };
                                r = {
                                    x: (c - i) / n,
                                    y: c
                                };
                            } else {
                                if (a) {
                                    if (a.y < l) return;
                                } else a = {
                                    x: (c - i) / n,
                                    y: c
                                };
                                r = {
                                    x: (l - i) / n,
                                    y: l
                                };
                            }
                        } else if (p < m) {
                            if (a) {
                                if (a.x >= s) return;
                            } else a = {
                                x: o,
                                y: n * o + i
                            };
                            r = {
                                x: s,
                                y: n * s + i
                            };
                        } else {
                            if (a) {
                                if (a.x < o) return;
                            } else a = {
                                x: s,
                                y: n * s + i
                            };
                            r = {
                                x: o,
                                y: n * o + i
                            };
                        }
                        return t1.a = a, t1.b = r, !0;
                    }
                    function Ze(t1, e1) {
                        this.l = t1, this.r = e1, this.a = this.b = null;
                    }
                    function Je(t1, e1, r, n) {
                        var i = new Ze(t1, e1);
                        return Le.push(i), r && Qe(i, t1, e1, r), n && Qe(i, e1, t1, n), Ce[t1.i].edges.push(new $e(i, t1, e1)), Ce[e1.i].edges.push(new $e(i, e1, t1)), i;
                    }
                    function Ke(t1, e1, r) {
                        var n = new Ze(t1, null);
                        return n.a = e1, n.b = r, Le.push(n), n;
                    }
                    function Qe(t1, e1, r, n) {
                        t1.a || t1.b ? t1.l === r ? t1.b = n : t1.a = n : (t1.a = n, t1.l = e1, t1.r = r);
                    }
                    function $e(t1, e1, r) {
                        var n = t1.a, i = t1.b;
                        this.edge = t1, this.site = e1, this.angle = r ? Math.atan2(r.y - e1.y, r.x - e1.x) : t1.l === e1 ? Math.atan2(i.x - n.x, n.y - i.y) : Math.atan2(n.x - i.x, i.y - n.y);
                    }
                    function tr() {
                        this._ = null;
                    }
                    function er(t1) {
                        t1.U = t1.C = t1.L = t1.R = t1.P = t1.N = null;
                    }
                    function rr(t1, e1) {
                        var r = e1, n = e1.R, i = r.U;
                        i ? i.L === r ? i.L = n : i.R = n : t1._ = n, n.U = i, r.U = n, r.R = n.L, r.R && (r.R.U = r), n.L = r;
                    }
                    function nr(t1, e1) {
                        var r = e1, n = e1.L, i = r.U;
                        i ? i.L === r ? i.L = n : i.R = n : t1._ = n, n.U = i, r.U = n, r.L = n.R, r.L && (r.L.U = r), n.R = r;
                    }
                    function ir(t1) {
                        for(; t1.L;)t1 = t1.L;
                        return t1;
                    }
                    function ar(t1, e1) {
                        var r, n, i, a = t1.sort(or).pop();
                        for(Le = [], Ce = new Array(t1.length), Pe = new tr, Oe = new tr;;)if (i = Ie, a && (!i || a.y < i.y || a.y === i.y && a.x < i.x)) a.x === r && a.y === n || (Ce[a.i] = new He(a), je(a), r = a.x, n = a.y), a = t1.pop();
                        else {
                            if (!i) break;
                            Ne(i.arc);
                        }
                        e1 && (function(t1) {
                            for(var e1, r, n, i, a, o = Le, s = (r = t1[0][0], n = t1[0][1], i = t1[1][0], a = t1[1][1], function(t1) {
                                var e1, o = t1.a, s = t1.b, l = o.x, c = o.y, u = 0, f = 1, h = s.x - l, p = s.y - c;
                                if (e1 = r - l, h || !(e1 > 0)) {
                                    if (e1 /= h, h < 0) {
                                        if (e1 < u) return;
                                        e1 < f && (f = e1);
                                    } else if (h > 0) {
                                        if (e1 > f) return;
                                        e1 > u && (u = e1);
                                    }
                                    if (e1 = i - l, h || !(e1 < 0)) {
                                        if (e1 /= h, h < 0) {
                                            if (e1 > f) return;
                                            e1 > u && (u = e1);
                                        } else if (h > 0) {
                                            if (e1 < u) return;
                                            e1 < f && (f = e1);
                                        }
                                        if (e1 = n - c, p || !(e1 > 0)) {
                                            if (e1 /= p, p < 0) {
                                                if (e1 < u) return;
                                                e1 < f && (f = e1);
                                            } else if (p > 0) {
                                                if (e1 > f) return;
                                                e1 > u && (u = e1);
                                            }
                                            if (e1 = a - c, p || !(e1 < 0)) {
                                                if (e1 /= p, p < 0) {
                                                    if (e1 > f) return;
                                                    e1 > u && (u = e1);
                                                } else if (p > 0) {
                                                    if (e1 < u) return;
                                                    e1 < f && (f = e1);
                                                }
                                                return u > 0 && (t1.a = {
                                                    x: l + u * h,
                                                    y: c + u * p
                                                }), f < 1 && (t1.b = {
                                                    x: l + f * h,
                                                    y: c + f * p
                                                }), t1;
                                            }
                                        }
                                    }
                                }
                            }), l = o.length; l--;)(!Xe(e1 = o[l], t1) || !s(e1) || y(e1.a.x - e1.b.x) < kt && y(e1.a.y - e1.b.y) < kt) && (e1.a = e1.b = null, o.splice(l, 1));
                        }(e1), function(t1) {
                            for(var e1, r, n, i, a, o, s, l, c, u, f = t1[0][0], h = t1[1][0], p = t1[0][1], d = t1[1][1], m = Ce, g = m.length; g--;)if ((a = m[g]) && a.prepare()) for(l = (s = a.edges).length, o = 0; o < l;)n = (u = s[o].end()).x, i = u.y, e1 = (c = s[++o % l].start()).x, r = c.y, (y(n - e1) > kt || y(i - r) > kt) && (s.splice(o, 0, new $e(Ke(a.site, u, y(n - f) < kt && d - i > kt ? {
                                x: f,
                                y: y(e1 - f) < kt ? r : d
                            } : y(i - d) < kt && h - n > kt ? {
                                x: y(r - d) < kt ? e1 : h,
                                y: d
                            } : y(n - h) < kt && i - p > kt ? {
                                x: h,
                                y: y(e1 - h) < kt ? r : p
                            } : y(i - p) < kt && n - f > kt ? {
                                x: y(r - p) < kt ? e1 : f,
                                y: p
                            } : null), a.site, null)), ++l);
                        }(e1));
                        var o = {
                            cells: Ce,
                            edges: Le
                        };
                        return Pe = Oe = Le = Ce = null, o;
                    }
                    function or(t1, e1) {
                        return e1.y - t1.y || e1.x - t1.x;
                    }
                    He.prototype.prepare = function() {
                        for(var t1, e1 = this.edges, r = e1.length; r--;)(t1 = e1[r].edge).b && t1.a || e1.splice(r, 1);
                        return e1.sort(qe), e1.length;
                    }, $e.prototype = {
                        start: function() {
                            return this.edge.l === this.site ? this.edge.a : this.edge.b;
                        },
                        end: function() {
                            return this.edge.l === this.site ? this.edge.b : this.edge.a;
                        }
                    }, tr.prototype = {
                        insert: function(t1, e1) {
                            var r, n, i;
                            if (t1) {
                                if (e1.P = t1, e1.N = t1.N, t1.N && (t1.N.P = e1), t1.N = e1, t1.R) {
                                    for(t1 = t1.R; t1.L;)t1 = t1.L;
                                    t1.L = e1;
                                } else t1.R = e1;
                                r = t1;
                            } else this._ ? (t1 = ir(this._), e1.P = null, e1.N = t1, t1.P = t1.L = e1, r = t1) : (e1.P = e1.N = null, this._ = e1, r = null);
                            for(e1.L = e1.R = null, e1.U = r, e1.C = !0, t1 = e1; r && r.C;)r === (n = r.U).L ? (i = n.R) && i.C ? (r.C = i.C = !1, n.C = !0, t1 = n) : (t1 === r.R && (rr(this, r), r = (t1 = r).U), r.C = !1, n.C = !0, nr(this, n)) : (i = n.L) && i.C ? (r.C = i.C = !1, n.C = !0, t1 = n) : (t1 === r.L && (nr(this, r), r = (t1 = r).U), r.C = !1, n.C = !0, rr(this, n)), r = t1.U;
                            this._.C = !1;
                        },
                        remove: function(t1) {
                            t1.N && (t1.N.P = t1.P), t1.P && (t1.P.N = t1.N), t1.N = t1.P = null;
                            var e1, r, n, i = t1.U, a = t1.L, o = t1.R;
                            if (r = a ? o ? ir(o) : a : o, i ? i.L === t1 ? i.L = r : i.R = r : this._ = r, a && o ? (n = r.C, r.C = t1.C, r.L = a, a.U = r, r !== o ? (i = r.U, r.U = t1.U, t1 = r.R, i.L = t1, r.R = o, o.U = r) : (r.U = i, i = r, t1 = r.R)) : (n = t1.C, t1 = r), t1 && (t1.U = i), !n) {
                                if (t1 && t1.C) t1.C = !1;
                                else {
                                    do {
                                        if (t1 === this._) break;
                                        if (t1 === i.L) {
                                            if ((e1 = i.R).C && (e1.C = !1, i.C = !0, rr(this, i), e1 = i.R), e1.L && e1.L.C || e1.R && e1.R.C) {
                                                e1.R && e1.R.C || (e1.L.C = !1, e1.C = !0, nr(this, e1), e1 = i.R), e1.C = i.C, i.C = e1.R.C = !1, rr(this, i), t1 = this._;
                                                break;
                                            }
                                        } else if ((e1 = i.L).C && (e1.C = !1, i.C = !0, nr(this, i), e1 = i.L), e1.L && e1.L.C || e1.R && e1.R.C) {
                                            e1.L && e1.L.C || (e1.R.C = !1, e1.C = !0, rr(this, e1), e1 = i.L), e1.C = i.C, i.C = e1.L.C = !1, nr(this, i), t1 = this._;
                                            break;
                                        }
                                        e1.C = !0, t1 = i, i = i.U;
                                    }while (!t1.C);
                                    t1 && (t1.C = !1);
                                }
                            }
                        }
                    }, t1.geom.voronoi = function(t1) {
                        var e1 = _e, r = we, n = e1, i = r, a = sr;
                        if (t1) return o(t1);
                        function o(t1) {
                            var e1 = new Array(t1.length), r = a[0][0], n = a[0][1], i = a[1][0], o = a[1][1];
                            return ar(s(t1), a).cells.forEach(function(a, s) {
                                var l = a.edges, c = a.site;
                                (e1[s] = l.length ? l.map(function(t1) {
                                    var e1 = t1.start();
                                    return [
                                        e1.x,
                                        e1.y
                                    ];
                                }) : c.x >= r && c.x <= i && c.y >= n && c.y <= o ? [
                                    [
                                        r,
                                        o
                                    ],
                                    [
                                        i,
                                        o
                                    ],
                                    [
                                        i,
                                        n
                                    ],
                                    [
                                        r,
                                        n
                                    ]
                                ] : []).point = t1[s];
                            }), e1;
                        }
                        function s(t1) {
                            return t1.map(function(t1, e1) {
                                return {
                                    x: Math.round(n(t1, e1) / kt) * kt,
                                    y: Math.round(i(t1, e1) / kt) * kt,
                                    i: e1
                                };
                            });
                        }
                        return o.links = function(t1) {
                            return ar(s(t1)).edges.filter(function(t1) {
                                return t1.l && t1.r;
                            }).map(function(e1) {
                                return {
                                    source: t1[e1.l.i],
                                    target: t1[e1.r.i]
                                };
                            });
                        }, o.triangles = function(t1) {
                            var e1 = [];
                            return ar(s(t1)).cells.forEach(function(r, n) {
                                for(var i, a, o, s, l = r.site, c = r.edges.sort(qe), u = -1, f = c.length, h = c[f - 1].edge, p = h.l === l ? h.r : h.l; ++u < f;)h, i = p, p = (h = c[u].edge).l === l ? h.r : h.l, n < i.i && n < p.i && (o = i, s = p, ((a = l).x - s.x) * (o.y - a.y) - (a.x - o.x) * (s.y - a.y) < 0) && e1.push([
                                    t1[n],
                                    t1[i.i],
                                    t1[p.i]
                                ]);
                            }), e1;
                        }, o.x = function(t1) {
                            return arguments.length ? (n = ce(e1 = t1), o) : e1;
                        }, o.y = function(t1) {
                            return arguments.length ? (i = ce(r = t1), o) : r;
                        }, o.clipExtent = function(t1) {
                            return arguments.length ? (a = null == t1 ? sr : t1, o) : a === sr ? null : a;
                        }, o.size = function(t1) {
                            return arguments.length ? o.clipExtent(t1 && [
                                [
                                    0,
                                    0
                                ],
                                t1
                            ]) : a === sr ? null : a && a[1];
                        }, o;
                    };
                    var sr = [
                        [
                            -1000000,
                            -1000000
                        ],
                        [
                            1e6,
                            1e6
                        ]
                    ];
                    function lr(t1) {
                        return t1.x;
                    }
                    function cr(t1) {
                        return t1.y;
                    }
                    function ur(t1, e1, r, n, i, a) {
                        if (!t1(e1, r, n, i, a)) {
                            var o = .5 * (r + i), s = .5 * (n + a), l = e1.nodes;
                            l[0] && ur(t1, l[0], r, n, o, s), l[1] && ur(t1, l[1], o, n, i, s), l[2] && ur(t1, l[2], r, s, o, a), l[3] && ur(t1, l[3], o, s, i, a);
                        }
                    }
                    function fr(t1, e1, r, n, i, a, o) {
                        var s, l = 1 / 0;
                        return function t1(c, u, f, h, p) {
                            if (!(u > a || f > o || h < n || p < i)) {
                                if (d = c.point) {
                                    var d, m = e1 - c.x, g = r - c.y, v = m * m + g * g;
                                    if (v < l) {
                                        var y = Math.sqrt(l = v);
                                        n = e1 - y, i = r - y, a = e1 + y, o = r + y, s = d;
                                    }
                                }
                                for(var x = c.nodes, b = .5 * (u + h), _ = .5 * (f + p), w = (r >= _) << 1 | e1 >= b, T = w + 4; w < T; ++w)if (c = x[3 & w]) switch(3 & w){
                                    case 0:
                                        t1(c, u, f, b, _);
                                        break;
                                    case 1:
                                        t1(c, b, f, h, _);
                                        break;
                                    case 2:
                                        t1(c, u, _, b, p);
                                        break;
                                    case 3:
                                        t1(c, b, _, h, p);
                                }
                            }
                        }(t1, n, i, a, o), s;
                    }
                    function hr(e1, r) {
                        e1 = t1.rgb(e1), r = t1.rgb(r);
                        var n = e1.r, i = e1.g, a = e1.b, o = r.r - n, s = r.g - i, l = r.b - a;
                        return function(t1) {
                            return "#" + re(Math.round(n + o * t1)) + re(Math.round(i + s * t1)) + re(Math.round(a + l * t1));
                        };
                    }
                    function pr(t1, e1) {
                        var r, n = {}, i = {};
                        for(r in t1)r in e1 ? n[r] = yr(t1[r], e1[r]) : i[r] = t1[r];
                        for(r in e1)r in t1 || (i[r] = e1[r]);
                        return function(t1) {
                            for(r in n)i[r] = n[r](t1);
                            return i;
                        };
                    }
                    function dr(t1, e1) {
                        return t1 = +t1, e1 = +e1, function(r) {
                            return t1 * (1 - r) + e1 * r;
                        };
                    }
                    function mr(t1, e1) {
                        var r, n, i, a = gr.lastIndex = vr.lastIndex = 0, o = -1, s = [], l = [];
                        for(t1 += "", e1 += ""; (r = gr.exec(t1)) && (n = vr.exec(e1));)(i = n.index) > a && (i = e1.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (r = r[0]) === (n = n[0]) ? s[o] ? s[o] += n : s[++o] = n : (s[++o] = null, l.push({
                            i: o,
                            x: dr(r, n)
                        })), a = vr.lastIndex;
                        return a < e1.length && (i = e1.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? l[0] ? (e1 = l[0].x, function(t1) {
                            return e1(t1) + "";
                        }) : function() {
                            return e1;
                        } : (e1 = l.length, function(t1) {
                            for(var r, n = 0; n < e1; ++n)s[(r = l[n]).i] = r.x(t1);
                            return s.join("");
                        });
                    }
                    t1.geom.delaunay = function(e1) {
                        return t1.geom.voronoi().triangles(e1);
                    }, t1.geom.quadtree = function(t1, e1, r, n, i) {
                        var a, o = _e, s = we;
                        if (a = arguments.length) return o = lr, s = cr, 3 === a && (i = r, n = e1, r = e1 = 0), l(t1);
                        function l(t1) {
                            var l, c, u, f, h, p, d, m, g, v = ce(o), x = ce(s);
                            if (null != e1) p = e1, d = r, m = n, g = i;
                            else if (m = g = -(p = d = 1 / 0), c = [], u = [], h = t1.length, a) for(f = 0; f < h; ++f)(l = t1[f]).x < p && (p = l.x), l.y < d && (d = l.y), l.x > m && (m = l.x), l.y > g && (g = l.y), c.push(l.x), u.push(l.y);
                            else for(f = 0; f < h; ++f){
                                var b = +v(l = t1[f], f), _ = +x(l, f);
                                b < p && (p = b), _ < d && (d = _), b > m && (m = b), _ > g && (g = _), c.push(b), u.push(_);
                            }
                            var w = m - p, T = g - d;
                            function k(t1, e1, r, n, i, a, o, s) {
                                if (!isNaN(r) && !isNaN(n)) {
                                    if (t1.leaf) {
                                        var l = t1.x, c = t1.y;
                                        if (null != l) {
                                            if (y(l - r) + y(c - n) < .01) A(t1, e1, r, n, i, a, o, s);
                                            else {
                                                var u = t1.point;
                                                t1.x = t1.y = t1.point = null, A(t1, u, l, c, i, a, o, s), A(t1, e1, r, n, i, a, o, s);
                                            }
                                        } else t1.x = r, t1.y = n, t1.point = e1;
                                    } else A(t1, e1, r, n, i, a, o, s);
                                }
                            }
                            function A(t1, e1, r, n, i, a, o, s) {
                                var l = .5 * (i + o), c = .5 * (a + s), u = r >= l, f = n >= c, h = f << 1 | u;
                                t1.leaf = !1, u ? i = l : o = l, f ? a = c : s = c, k(t1 = t1.nodes[h] || (t1.nodes[h] = {
                                    leaf: !0,
                                    nodes: [],
                                    point: null,
                                    x: null,
                                    y: null
                                }), e1, r, n, i, a, o, s);
                            }
                            w > T ? g = d + w : m = p + T;
                            var M = {
                                leaf: !0,
                                nodes: [],
                                point: null,
                                x: null,
                                y: null,
                                add: function(t1) {
                                    k(M, t1, +v(t1, ++f), +x(t1, f), p, d, m, g);
                                },
                                visit: function(t1) {
                                    ur(t1, M, p, d, m, g);
                                },
                                find: function(t1) {
                                    return fr(M, t1[0], t1[1], p, d, m, g);
                                }
                            };
                            if (f = -1, null == e1) {
                                for(; ++f < h;)k(M, t1[f], c[f], u[f], p, d, m, g);
                                --f;
                            } else t1.forEach(M.add);
                            return c = u = t1 = l = null, M;
                        }
                        return l.x = function(t1) {
                            return arguments.length ? (o = t1, l) : o;
                        }, l.y = function(t1) {
                            return arguments.length ? (s = t1, l) : s;
                        }, l.extent = function(t1) {
                            return arguments.length ? (null == t1 ? e1 = r = n = i = null : (e1 = +t1[0][0], r = +t1[0][1], n = +t1[1][0], i = +t1[1][1]), l) : null == e1 ? null : [
                                [
                                    e1,
                                    r
                                ],
                                [
                                    n,
                                    i
                                ]
                            ];
                        }, l.size = function(t1) {
                            return arguments.length ? (null == t1 ? e1 = r = n = i = null : (e1 = r = 0, n = +t1[0], i = +t1[1]), l) : null == e1 ? null : [
                                n - e1,
                                i - r
                            ];
                        }, l;
                    }, t1.interpolateRgb = hr, t1.interpolateObject = pr, t1.interpolateNumber = dr, t1.interpolateString = mr;
                    var gr = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, vr = new RegExp(gr.source, "g");
                    function yr(e1, r) {
                        for(var n, i = t1.interpolators.length; --i >= 0 && !(n = t1.interpolators[i](e1, r)););
                        return n;
                    }
                    function xr(t1, e1) {
                        var r, n = [], i = [], a = t1.length, o = e1.length, s = Math.min(t1.length, e1.length);
                        for(r = 0; r < s; ++r)n.push(yr(t1[r], e1[r]));
                        for(; r < a; ++r)i[r] = t1[r];
                        for(; r < o; ++r)i[r] = e1[r];
                        return function(t1) {
                            for(r = 0; r < s; ++r)i[r] = n[r](t1);
                            return i;
                        };
                    }
                    t1.interpolate = yr, t1.interpolators = [
                        function(t1, e1) {
                            var r = typeof e1;
                            return ("string" === r ? le.has(e1.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(e1) ? hr : mr : e1 instanceof Ft ? hr : Array.isArray(e1) ? xr : "object" === r && isNaN(e1) ? pr : dr)(t1, e1);
                        }
                    ], t1.interpolateArray = xr;
                    var br = function() {
                        return C;
                    }, _r = t1.map({
                        linear: br,
                        poly: function(t1) {
                            return function(e1) {
                                return Math.pow(e1, t1);
                            };
                        },
                        quad: function() {
                            return Mr;
                        },
                        cubic: function() {
                            return Sr;
                        },
                        sin: function() {
                            return Lr;
                        },
                        exp: function() {
                            return Cr;
                        },
                        circle: function() {
                            return Pr;
                        },
                        elastic: function(t1, e1) {
                            var r;
                            arguments.length < 2 && (e1 = .45);
                            arguments.length ? r = e1 / Mt * Math.asin(1 / t1) : (t1 = 1, r = e1 / 4);
                            return function(n) {
                                return 1 + t1 * Math.pow(2, -10 * n) * Math.sin((n - r) * Mt / e1);
                            };
                        },
                        back: function(t1) {
                            t1 || (t1 = 1.70158);
                            return function(e1) {
                                return e1 * e1 * ((t1 + 1) * e1 - t1);
                            };
                        },
                        bounce: function() {
                            return Ir;
                        }
                    }), wr = t1.map({
                        in: C,
                        out: kr,
                        "in-out": Ar,
                        "out-in": function(t1) {
                            return Ar(kr(t1));
                        }
                    });
                    function Tr(t1) {
                        return function(e1) {
                            return e1 <= 0 ? 0 : e1 >= 1 ? 1 : t1(e1);
                        };
                    }
                    function kr(t1) {
                        return function(e1) {
                            return 1 - t1(1 - e1);
                        };
                    }
                    function Ar(t1) {
                        return function(e1) {
                            return .5 * (e1 < .5 ? t1(2 * e1) : 2 - t1(2 - 2 * e1));
                        };
                    }
                    function Mr(t1) {
                        return t1 * t1;
                    }
                    function Sr(t1) {
                        return t1 * t1 * t1;
                    }
                    function Er(t1) {
                        if (t1 <= 0) return 0;
                        if (t1 >= 1) return 1;
                        var e1 = t1 * t1, r = e1 * t1;
                        return 4 * (t1 < .5 ? r : 3 * (t1 - e1) + r - .75);
                    }
                    function Lr(t1) {
                        return 1 - Math.cos(t1 * Et);
                    }
                    function Cr(t1) {
                        return Math.pow(2, 10 * (t1 - 1));
                    }
                    function Pr(t1) {
                        return 1 - Math.sqrt(1 - t1 * t1);
                    }
                    function Ir(t1) {
                        return t1 < 1 / 2.75 ? 7.5625 * t1 * t1 : t1 < 2 / 2.75 ? 7.5625 * (t1 -= 1.5 / 2.75) * t1 + .75 : t1 < 2.5 / 2.75 ? 7.5625 * (t1 -= 2.25 / 2.75) * t1 + .9375 : 7.5625 * (t1 -= 2.625 / 2.75) * t1 + .984375;
                    }
                    function Or(t1, e1) {
                        return e1 -= t1, function(r) {
                            return Math.round(t1 + e1 * r);
                        };
                    }
                    function zr(t1) {
                        var e1, r, n, i = [
                            t1.a,
                            t1.b
                        ], a = [
                            t1.c,
                            t1.d
                        ], o = Rr(i), s = Dr(i, a), l = Rr(((e1 = a)[0] += (n = -s) * (r = i)[0], e1[1] += n * r[1], e1)) || 0;
                        i[0] * a[1] < a[0] * i[1] && (i[0] *= -1, i[1] *= -1, o *= -1, s *= -1), this.rotate = (o ? Math.atan2(i[1], i[0]) : Math.atan2(-a[0], a[1])) * Ct, this.translate = [
                            t1.e,
                            t1.f
                        ], this.scale = [
                            o,
                            l
                        ], this.skew = l ? Math.atan2(s, l) * Ct : 0;
                    }
                    function Dr(t1, e1) {
                        return t1[0] * e1[0] + t1[1] * e1[1];
                    }
                    function Rr(t1) {
                        var e1 = Math.sqrt(Dr(t1, t1));
                        return e1 && (t1[0] /= e1, t1[1] /= e1), e1;
                    }
                    t1.ease = function(t1) {
                        var e1 = t1.indexOf("-"), n = e1 >= 0 ? t1.slice(0, e1) : t1, i = e1 >= 0 ? t1.slice(e1 + 1) : "in";
                        return n = _r.get(n) || br, Tr((i = wr.get(i) || C)(n.apply(null, r.call(arguments, 1))));
                    }, t1.interpolateHcl = function(e1, r) {
                        e1 = t1.hcl(e1), r = t1.hcl(r);
                        var n = e1.h, i = e1.c, a = e1.l, o = r.h - n, s = r.c - i, l = r.l - a;
                        isNaN(s) && (s = 0, i = isNaN(i) ? r.c : i);
                        isNaN(o) ? (o = 0, n = isNaN(n) ? r.h : n) : o > 180 ? o -= 360 : o < -180 && (o += 360);
                        return function(t1) {
                            return Ht(n + o * t1, i + s * t1, a + l * t1) + "";
                        };
                    }, t1.interpolateHsl = function(e1, r) {
                        e1 = t1.hsl(e1), r = t1.hsl(r);
                        var n = e1.h, i = e1.s, a = e1.l, o = r.h - n, s = r.s - i, l = r.l - a;
                        isNaN(s) && (s = 0, i = isNaN(i) ? r.s : i);
                        isNaN(o) ? (o = 0, n = isNaN(n) ? r.h : n) : o > 180 ? o -= 360 : o < -180 && (o += 360);
                        return function(t1) {
                            return jt(n + o * t1, i + s * t1, a + l * t1) + "";
                        };
                    }, t1.interpolateLab = function(e1, r) {
                        e1 = t1.lab(e1), r = t1.lab(r);
                        var n = e1.l, i = e1.a, a = e1.b, o = r.l - n, s = r.a - i, l = r.b - a;
                        return function(t1) {
                            return Wt(n + o * t1, i + s * t1, a + l * t1) + "";
                        };
                    }, t1.interpolateRound = Or, t1.transform = function(e1) {
                        var r = i.createElementNS(t1.ns.prefix.svg, "g");
                        return (t1.transform = function(t1) {
                            if (null != t1) {
                                r.setAttribute("transform", t1);
                                var e1 = r.transform.baseVal.consolidate();
                            }
                            return new zr(e1 ? e1.matrix : Fr);
                        })(e1);
                    }, zr.prototype.toString = function() {
                        return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
                    };
                    var Fr = {
                        a: 1,
                        b: 0,
                        c: 0,
                        d: 1,
                        e: 0,
                        f: 0
                    };
                    function Br(t1) {
                        return t1.length ? t1.pop() + "," : "";
                    }
                    function Nr(e1, r) {
                        var n = [], i = [];
                        return e1 = t1.transform(e1), r = t1.transform(r), function(t1, e1, r, n) {
                            if (t1[0] !== e1[0] || t1[1] !== e1[1]) {
                                var i = r.push("translate(", null, ",", null, ")");
                                n.push({
                                    i: i - 4,
                                    x: dr(t1[0], e1[0])
                                }, {
                                    i: i - 2,
                                    x: dr(t1[1], e1[1])
                                });
                            } else (e1[0] || e1[1]) && r.push("translate(" + e1 + ")");
                        }(e1.translate, r.translate, n, i), function(t1, e1, r, n) {
                            t1 !== e1 ? (t1 - e1 > 180 ? e1 += 360 : e1 - t1 > 180 && (t1 += 360), n.push({
                                i: r.push(Br(r) + "rotate(", null, ")") - 2,
                                x: dr(t1, e1)
                            })) : e1 && r.push(Br(r) + "rotate(" + e1 + ")");
                        }(e1.rotate, r.rotate, n, i), function(t1, e1, r, n) {
                            t1 !== e1 ? n.push({
                                i: r.push(Br(r) + "skewX(", null, ")") - 2,
                                x: dr(t1, e1)
                            }) : e1 && r.push(Br(r) + "skewX(" + e1 + ")");
                        }(e1.skew, r.skew, n, i), function(t1, e1, r, n) {
                            if (t1[0] !== e1[0] || t1[1] !== e1[1]) {
                                var i = r.push(Br(r) + "scale(", null, ",", null, ")");
                                n.push({
                                    i: i - 4,
                                    x: dr(t1[0], e1[0])
                                }, {
                                    i: i - 2,
                                    x: dr(t1[1], e1[1])
                                });
                            } else 1 === e1[0] && 1 === e1[1] || r.push(Br(r) + "scale(" + e1 + ")");
                        }(e1.scale, r.scale, n, i), e1 = r = null, function(t1) {
                            for(var e1, r = -1, a = i.length; ++r < a;)n[(e1 = i[r]).i] = e1.x(t1);
                            return n.join("");
                        };
                    }
                    function jr(t1, e1) {
                        return e1 = (e1 -= t1 = +t1) || 1 / e1, function(r) {
                            return (r - t1) / e1;
                        };
                    }
                    function Ur(t1, e1) {
                        return e1 = (e1 -= t1 = +t1) || 1 / e1, function(r) {
                            return Math.max(0, Math.min(1, (r - t1) / e1));
                        };
                    }
                    function Vr(t1) {
                        for(var e1 = t1.source, r = t1.target, n = function(t1, e1) {
                            if (t1 === e1) return t1;
                            var r = Hr(t1), n = Hr(e1), i = r.pop(), a = n.pop(), o = null;
                            for(; i === a;)o = i, i = r.pop(), a = n.pop();
                            return o;
                        }(e1, r), i = [
                            e1
                        ]; e1 !== n;)e1 = e1.parent, i.push(e1);
                        for(var a = i.length; r !== n;)i.splice(a, 0, r), r = r.parent;
                        return i;
                    }
                    function Hr(t1) {
                        for(var e1 = [], r = t1.parent; null != r;)e1.push(t1), t1 = r, r = r.parent;
                        return e1.push(t1), e1;
                    }
                    function qr(t1) {
                        t1.fixed |= 2;
                    }
                    function Gr(t1) {
                        t1.fixed &= -7;
                    }
                    function Yr(t1) {
                        t1.fixed |= 4, t1.px = t1.x, t1.py = t1.y;
                    }
                    function Wr(t1) {
                        t1.fixed &= -5;
                    }
                    t1.interpolateTransform = Nr, t1.layout = {}, t1.layout.bundle = function() {
                        return function(t1) {
                            for(var e1 = [], r = -1, n = t1.length; ++r < n;)e1.push(Vr(t1[r]));
                            return e1;
                        };
                    }, t1.layout.chord = function() {
                        var e1, r, n, i, a, o, s, l = {}, c = 0;
                        function u() {
                            var l, u, h, p, d, m = {}, g = [], v = t1.range(i), y = [];
                            for(e1 = [], r = [], l = 0, p = -1; ++p < i;){
                                for(u = 0, d = -1; ++d < i;)u += n[p][d];
                                g.push(u), y.push(t1.range(i)), l += u;
                            }
                            for(a && v.sort(function(t1, e1) {
                                return a(g[t1], g[e1]);
                            }), o && y.forEach(function(t1, e1) {
                                t1.sort(function(t1, r) {
                                    return o(n[e1][t1], n[e1][r]);
                                });
                            }), l = (Mt - c * i) / l, u = 0, p = -1; ++p < i;){
                                for(h = u, d = -1; ++d < i;){
                                    var x = v[p], b = y[x][d], _ = n[x][b], w = u, T = u += _ * l;
                                    m[x + "-" + b] = {
                                        index: x,
                                        subindex: b,
                                        startAngle: w,
                                        endAngle: T,
                                        value: _
                                    };
                                }
                                r[x] = {
                                    index: x,
                                    startAngle: h,
                                    endAngle: u,
                                    value: g[x]
                                }, u += c;
                            }
                            for(p = -1; ++p < i;)for(d = p - 1; ++d < i;){
                                var k = m[p + "-" + d], A = m[d + "-" + p];
                                (k.value || A.value) && e1.push(k.value < A.value ? {
                                    source: A,
                                    target: k
                                } : {
                                    source: k,
                                    target: A
                                });
                            }
                            s && f();
                        }
                        function f() {
                            e1.sort(function(t1, e1) {
                                return s((t1.source.value + t1.target.value) / 2, (e1.source.value + e1.target.value) / 2);
                            });
                        }
                        return l.matrix = function(t1) {
                            return arguments.length ? (i = (n = t1) && n.length, e1 = r = null, l) : n;
                        }, l.padding = function(t1) {
                            return arguments.length ? (c = t1, e1 = r = null, l) : c;
                        }, l.sortGroups = function(t1) {
                            return arguments.length ? (a = t1, e1 = r = null, l) : a;
                        }, l.sortSubgroups = function(t1) {
                            return arguments.length ? (o = t1, e1 = null, l) : o;
                        }, l.sortChords = function(t1) {
                            return arguments.length ? (s = t1, e1 && f(), l) : s;
                        }, l.chords = function() {
                            return e1 || u(), e1;
                        }, l.groups = function() {
                            return r || u(), r;
                        }, l;
                    }, t1.layout.force = function() {
                        var e1, r, n, i, a, o, s = {}, l = t1.dispatch("start", "tick", "end"), c = [
                            1,
                            1
                        ], u = .9, f = Xr, h = Zr, p = -30, d = Jr, m = .1, g = .64, v = [], y = [];
                        function x(t1) {
                            return function(e1, r, n, i) {
                                if (e1.point !== t1) {
                                    var a = e1.cx - t1.x, o = e1.cy - t1.y, s = i - r, l = a * a + o * o;
                                    if (s * s / g < l) {
                                        if (l < d) {
                                            var c = e1.charge / l;
                                            t1.px -= a * c, t1.py -= o * c;
                                        }
                                        return !0;
                                    }
                                    if (e1.point && l && l < d) {
                                        c = e1.pointCharge / l;
                                        t1.px -= a * c, t1.py -= o * c;
                                    }
                                }
                                return !e1.charge;
                            };
                        }
                        function b(e1) {
                            e1.px = t1.event.x, e1.py = t1.event.y, s.resume();
                        }
                        return s.tick = function() {
                            if ((n *= .99) < .005) return e1 = null, l.end({
                                type: "end",
                                alpha: n = 0
                            }), !0;
                            var r, s, f, h, d, g, b, _, w, T = v.length, k = y.length;
                            for(s = 0; s < k; ++s)h = (f = y[s]).source, (g = (_ = (d = f.target).x - h.x) * _ + (w = d.y - h.y) * w) && (_ *= g = n * a[s] * ((g = Math.sqrt(g)) - i[s]) / g, w *= g, d.x -= _ * (b = h.weight + d.weight ? h.weight / (h.weight + d.weight) : .5), d.y -= w * b, h.x += _ * (b = 1 - b), h.y += w * b);
                            if ((b = n * m) && (_ = c[0] / 2, w = c[1] / 2, s = -1, b)) for(; ++s < T;)(f = v[s]).x += (_ - f.x) * b, f.y += (w - f.y) * b;
                            if (p) for(!function t1(e1, r, n) {
                                var i = 0, a = 0;
                                if (e1.charge = 0, !e1.leaf) for(var o, s = e1.nodes, l = s.length, c = -1; ++c < l;)null != (o = s[c]) && (t1(o, r, n), e1.charge += o.charge, i += o.charge * o.cx, a += o.charge * o.cy);
                                if (e1.point) {
                                    e1.leaf || (e1.point.x += Math.random() - .5, e1.point.y += Math.random() - .5);
                                    var u = r * n[e1.point.index];
                                    e1.charge += e1.pointCharge = u, i += u * e1.point.x, a += u * e1.point.y;
                                }
                                e1.cx = i / e1.charge, e1.cy = a / e1.charge;
                            }(r = t1.geom.quadtree(v), n, o), s = -1; ++s < T;)(f = v[s]).fixed || r.visit(x(f));
                            for(s = -1; ++s < T;)(f = v[s]).fixed ? (f.x = f.px, f.y = f.py) : (f.x -= (f.px - (f.px = f.x)) * u, f.y -= (f.py - (f.py = f.y)) * u);
                            l.tick({
                                type: "tick",
                                alpha: n
                            });
                        }, s.nodes = function(t1) {
                            return arguments.length ? (v = t1, s) : v;
                        }, s.links = function(t1) {
                            return arguments.length ? (y = t1, s) : y;
                        }, s.size = function(t1) {
                            return arguments.length ? (c = t1, s) : c;
                        }, s.linkDistance = function(t1) {
                            return arguments.length ? (f = "function" == typeof t1 ? t1 : +t1, s) : f;
                        }, s.distance = s.linkDistance, s.linkStrength = function(t1) {
                            return arguments.length ? (h = "function" == typeof t1 ? t1 : +t1, s) : h;
                        }, s.friction = function(t1) {
                            return arguments.length ? (u = +t1, s) : u;
                        }, s.charge = function(t1) {
                            return arguments.length ? (p = "function" == typeof t1 ? t1 : +t1, s) : p;
                        }, s.chargeDistance = function(t1) {
                            return arguments.length ? (d = t1 * t1, s) : Math.sqrt(d);
                        }, s.gravity = function(t1) {
                            return arguments.length ? (m = +t1, s) : m;
                        }, s.theta = function(t1) {
                            return arguments.length ? (g = t1 * t1, s) : Math.sqrt(g);
                        }, s.alpha = function(t1) {
                            return arguments.length ? (t1 = +t1, n ? t1 > 0 ? n = t1 : (e1.c = null, e1.t = NaN, e1 = null, l.end({
                                type: "end",
                                alpha: n = 0
                            })) : t1 > 0 && (l.start({
                                type: "start",
                                alpha: n = t1
                            }), e1 = ve(s.tick)), s) : n;
                        }, s.start = function() {
                            var t1, e1, r, n = v.length, l = y.length, u = c[0], d = c[1];
                            for(t1 = 0; t1 < n; ++t1)(r = v[t1]).index = t1, r.weight = 0;
                            for(t1 = 0; t1 < l; ++t1)"number" == typeof (r = y[t1]).source && (r.source = v[r.source]), "number" == typeof r.target && (r.target = v[r.target]), ++r.source.weight, ++r.target.weight;
                            for(t1 = 0; t1 < n; ++t1)r = v[t1], isNaN(r.x) && (r.x = m("x", u)), isNaN(r.y) && (r.y = m("y", d)), isNaN(r.px) && (r.px = r.x), isNaN(r.py) && (r.py = r.y);
                            if (i = [], "function" == typeof f) for(t1 = 0; t1 < l; ++t1)i[t1] = +f.call(this, y[t1], t1);
                            else for(t1 = 0; t1 < l; ++t1)i[t1] = f;
                            if (a = [], "function" == typeof h) for(t1 = 0; t1 < l; ++t1)a[t1] = +h.call(this, y[t1], t1);
                            else for(t1 = 0; t1 < l; ++t1)a[t1] = h;
                            if (o = [], "function" == typeof p) for(t1 = 0; t1 < n; ++t1)o[t1] = +p.call(this, v[t1], t1);
                            else for(t1 = 0; t1 < n; ++t1)o[t1] = p;
                            function m(r, i) {
                                if (!e1) {
                                    for(e1 = new Array(n), c = 0; c < n; ++c)e1[c] = [];
                                    for(c = 0; c < l; ++c){
                                        var a = y[c];
                                        e1[a.source.index].push(a.target), e1[a.target.index].push(a.source);
                                    }
                                }
                                for(var o, s = e1[t1], c = -1, u = s.length; ++c < u;)if (!isNaN(o = s[c][r])) return o;
                                return Math.random() * i;
                            }
                            return s.resume();
                        }, s.resume = function() {
                            return s.alpha(.1);
                        }, s.stop = function() {
                            return s.alpha(0);
                        }, s.drag = function() {
                            if (r || (r = t1.behavior.drag().origin(C).on("dragstart.force", qr).on("drag.force", b).on("dragend.force", Gr)), !arguments.length) return r;
                            this.on("mouseover.force", Yr).on("mouseout.force", Wr).call(r);
                        }, t1.rebind(s, l, "on");
                    };
                    var Xr = 20, Zr = 1, Jr = 1 / 0;
                    function Kr(e1, r) {
                        return t1.rebind(e1, r, "sort", "children", "value"), e1.nodes = e1, e1.links = nn, e1;
                    }
                    function Qr(t1, e1) {
                        for(var r = [
                            t1
                        ]; null != (t1 = r.pop());)if (e1(t1), (i = t1.children) && (n = i.length)) for(var n, i; --n >= 0;)r.push(i[n]);
                    }
                    function $r(t1, e1) {
                        for(var r = [
                            t1
                        ], n = []; null != (t1 = r.pop());)if (n.push(t1), (a = t1.children) && (i = a.length)) for(var i, a, o = -1; ++o < i;)r.push(a[o]);
                        for(; null != (t1 = n.pop());)e1(t1);
                    }
                    function tn(t1) {
                        return t1.children;
                    }
                    function en(t1) {
                        return t1.value;
                    }
                    function rn(t1, e1) {
                        return e1.value - t1.value;
                    }
                    function nn(e1) {
                        return t1.merge(e1.map(function(t1) {
                            return (t1.children || []).map(function(e1) {
                                return {
                                    source: t1,
                                    target: e1
                                };
                            });
                        }));
                    }
                    t1.layout.hierarchy = function() {
                        var t1 = rn, e1 = tn, r = en;
                        function n(i) {
                            var a, o = [
                                i
                            ], s = [];
                            for(i.depth = 0; null != (a = o.pop());)if (s.push(a), (c = e1.call(n, a, a.depth)) && (l = c.length)) {
                                for(var l, c, u; --l >= 0;)o.push(u = c[l]), u.parent = a, u.depth = a.depth + 1;
                                r && (a.value = 0), a.children = c;
                            } else r && (a.value = +r.call(n, a, a.depth) || 0), delete a.children;
                            return $r(i, function(e1) {
                                var n, i;
                                t1 && (n = e1.children) && n.sort(t1), r && (i = e1.parent) && (i.value += e1.value);
                            }), s;
                        }
                        return n.sort = function(e1) {
                            return arguments.length ? (t1 = e1, n) : t1;
                        }, n.children = function(t1) {
                            return arguments.length ? (e1 = t1, n) : e1;
                        }, n.value = function(t1) {
                            return arguments.length ? (r = t1, n) : r;
                        }, n.revalue = function(t1) {
                            return r && (Qr(t1, function(t1) {
                                t1.children && (t1.value = 0);
                            }), $r(t1, function(t1) {
                                var e1;
                                t1.children || (t1.value = +r.call(n, t1, t1.depth) || 0), (e1 = t1.parent) && (e1.value += t1.value);
                            })), t1;
                        }, n;
                    }, t1.layout.partition = function() {
                        var e1 = t1.layout.hierarchy(), r = [
                            1,
                            1
                        ];
                        function n(t1, n) {
                            var i = e1.call(this, t1, n);
                            return function t1(e1, r, n, i) {
                                var a = e1.children;
                                if (e1.x = r, e1.y = e1.depth * i, e1.dx = n, e1.dy = i, a && (o = a.length)) {
                                    var o, s, l, c = -1;
                                    for(n = e1.value ? n / e1.value : 0; ++c < o;)t1(s = a[c], r, l = s.value * n, i), r += l;
                                }
                            }(i[0], 0, r[0], r[1] / function t1(e1) {
                                var r = e1.children, n = 0;
                                if (r && (i = r.length)) for(var i, a = -1; ++a < i;)n = Math.max(n, t1(r[a]));
                                return 1 + n;
                            }(i[0])), i;
                        }
                        return n.size = function(t1) {
                            return arguments.length ? (r = t1, n) : r;
                        }, Kr(n, e1);
                    }, t1.layout.pie = function() {
                        var e1 = Number, r = an, n = 0, i = Mt, a = 0;
                        function o(s) {
                            var l, c = s.length, u = s.map(function(t1, r) {
                                return +e1.call(o, t1, r);
                            }), f = +("function" == typeof n ? n.apply(this, arguments) : n), h = ("function" == typeof i ? i.apply(this, arguments) : i) - f, p = Math.min(Math.abs(h) / c, +("function" == typeof a ? a.apply(this, arguments) : a)), d = p * (h < 0 ? -1 : 1), m = t1.sum(u), g = m ? (h - c * d) / m : 0, v = t1.range(c), y = [];
                            return null != r && v.sort(r === an ? function(t1, e1) {
                                return u[e1] - u[t1];
                            } : function(t1, e1) {
                                return r(s[t1], s[e1]);
                            }), v.forEach(function(t1) {
                                y[t1] = {
                                    data: s[t1],
                                    value: l = u[t1],
                                    startAngle: f,
                                    endAngle: f += l * g + d,
                                    padAngle: p
                                };
                            }), y;
                        }
                        return o.value = function(t1) {
                            return arguments.length ? (e1 = t1, o) : e1;
                        }, o.sort = function(t1) {
                            return arguments.length ? (r = t1, o) : r;
                        }, o.startAngle = function(t1) {
                            return arguments.length ? (n = t1, o) : n;
                        }, o.endAngle = function(t1) {
                            return arguments.length ? (i = t1, o) : i;
                        }, o.padAngle = function(t1) {
                            return arguments.length ? (a = t1, o) : a;
                        }, o;
                    };
                    var an = {};
                    function on(t1) {
                        return t1.x;
                    }
                    function sn(t1) {
                        return t1.y;
                    }
                    function ln(t1, e1, r) {
                        t1.y0 = e1, t1.y = r;
                    }
                    t1.layout.stack = function() {
                        var e1 = C, r = fn, n = hn, i = ln, a = on, o = sn;
                        function s(l, c) {
                            if (!(p = l.length)) return l;
                            var u = l.map(function(t1, r) {
                                return e1.call(s, t1, r);
                            }), f = u.map(function(t1) {
                                return t1.map(function(t1, e1) {
                                    return [
                                        a.call(s, t1, e1),
                                        o.call(s, t1, e1)
                                    ];
                                });
                            }), h = r.call(s, f, c);
                            u = t1.permute(u, h), f = t1.permute(f, h);
                            var p, d, m, g, v = n.call(s, f, c), y = u[0].length;
                            for(m = 0; m < y; ++m)for(i.call(s, u[0][m], g = v[m], f[0][m][1]), d = 1; d < p; ++d)i.call(s, u[d][m], g += f[d - 1][m][1], f[d][m][1]);
                            return l;
                        }
                        return s.values = function(t1) {
                            return arguments.length ? (e1 = t1, s) : e1;
                        }, s.order = function(t1) {
                            return arguments.length ? (r = "function" == typeof t1 ? t1 : cn.get(t1) || fn, s) : r;
                        }, s.offset = function(t1) {
                            return arguments.length ? (n = "function" == typeof t1 ? t1 : un.get(t1) || hn, s) : n;
                        }, s.x = function(t1) {
                            return arguments.length ? (a = t1, s) : a;
                        }, s.y = function(t1) {
                            return arguments.length ? (o = t1, s) : o;
                        }, s.out = function(t1) {
                            return arguments.length ? (i = t1, s) : i;
                        }, s;
                    };
                    var cn = t1.map({
                        "inside-out": function(e1) {
                            var r, n, i = e1.length, a = e1.map(pn), o = e1.map(dn), s = t1.range(i).sort(function(t1, e1) {
                                return a[t1] - a[e1];
                            }), l = 0, c = 0, u = [], f = [];
                            for(r = 0; r < i; ++r)n = s[r], l < c ? (l += o[n], u.push(n)) : (c += o[n], f.push(n));
                            return f.reverse().concat(u);
                        },
                        reverse: function(e1) {
                            return t1.range(e1.length).reverse();
                        },
                        default: fn
                    }), un = t1.map({
                        silhouette: function(t1) {
                            var e1, r, n, i = t1.length, a = t1[0].length, o = [], s = 0, l = [];
                            for(r = 0; r < a; ++r){
                                for(e1 = 0, n = 0; e1 < i; e1++)n += t1[e1][r][1];
                                n > s && (s = n), o.push(n);
                            }
                            for(r = 0; r < a; ++r)l[r] = (s - o[r]) / 2;
                            return l;
                        },
                        wiggle: function(t1) {
                            var e1, r, n, i, a, o, s, l, c, u = t1.length, f = t1[0], h = f.length, p = [];
                            for(p[0] = l = c = 0, r = 1; r < h; ++r){
                                for(e1 = 0, i = 0; e1 < u; ++e1)i += t1[e1][r][1];
                                for(e1 = 0, a = 0, s = f[r][0] - f[r - 1][0]; e1 < u; ++e1){
                                    for(n = 0, o = (t1[e1][r][1] - t1[e1][r - 1][1]) / (2 * s); n < e1; ++n)o += (t1[n][r][1] - t1[n][r - 1][1]) / s;
                                    a += o * t1[e1][r][1];
                                }
                                p[r] = l -= i ? a / i * s : 0, l < c && (c = l);
                            }
                            for(r = 0; r < h; ++r)p[r] -= c;
                            return p;
                        },
                        expand: function(t1) {
                            var e1, r, n, i = t1.length, a = t1[0].length, o = 1 / i, s = [];
                            for(r = 0; r < a; ++r){
                                for(e1 = 0, n = 0; e1 < i; e1++)n += t1[e1][r][1];
                                if (n) for(e1 = 0; e1 < i; e1++)t1[e1][r][1] /= n;
                                else for(e1 = 0; e1 < i; e1++)t1[e1][r][1] = o;
                            }
                            for(r = 0; r < a; ++r)s[r] = 0;
                            return s;
                        },
                        zero: hn
                    });
                    function fn(e1) {
                        return t1.range(e1.length);
                    }
                    function hn(t1) {
                        for(var e1 = -1, r = t1[0].length, n = []; ++e1 < r;)n[e1] = 0;
                        return n;
                    }
                    function pn(t1) {
                        for(var e1, r = 1, n = 0, i = t1[0][1], a = t1.length; r < a; ++r)(e1 = t1[r][1]) > i && (n = r, i = e1);
                        return n;
                    }
                    function dn(t1) {
                        return t1.reduce(mn, 0);
                    }
                    function mn(t1, e1) {
                        return t1 + e1[1];
                    }
                    function gn(t1, e1) {
                        return vn(t1, Math.ceil(Math.log(e1.length) / Math.LN2 + 1));
                    }
                    function vn(t1, e1) {
                        for(var r = -1, n = +t1[0], i = (t1[1] - n) / e1, a = []; ++r <= e1;)a[r] = i * r + n;
                        return a;
                    }
                    function yn(e1) {
                        return [
                            t1.min(e1),
                            t1.max(e1)
                        ];
                    }
                    function xn(t1, e1) {
                        return t1.value - e1.value;
                    }
                    function bn(t1, e1) {
                        var r = t1._pack_next;
                        t1._pack_next = e1, e1._pack_prev = t1, e1._pack_next = r, r._pack_prev = e1;
                    }
                    function _n(t1, e1) {
                        t1._pack_next = e1, e1._pack_prev = t1;
                    }
                    function wn(t1, e1) {
                        var r = e1.x - t1.x, n = e1.y - t1.y, i = t1.r + e1.r;
                        return .999 * i * i > r * r + n * n;
                    }
                    function Tn(t1) {
                        if ((e1 = t1.children) && (l = e1.length)) {
                            var e1, r, n, i, a, o, s, l, c = 1 / 0, u = -1 / 0, f = 1 / 0, h = -1 / 0;
                            if (e1.forEach(kn), (r = e1[0]).x = -r.r, r.y = 0, x(r), l > 1 && ((n = e1[1]).x = n.r, n.y = 0, x(n), l > 2)) for(Mn(r, n, i = e1[2]), x(i), bn(r, i), r._pack_prev = i, bn(i, n), n = r._pack_next, a = 3; a < l; a++){
                                Mn(r, n, i = e1[a]);
                                var p = 0, d = 1, m = 1;
                                for(o = n._pack_next; o !== n; o = o._pack_next, d++)if (wn(o, i)) {
                                    p = 1;
                                    break;
                                }
                                if (1 == p) for(s = r._pack_prev; s !== o._pack_prev && !wn(s, i); s = s._pack_prev, m++);
                                p ? (d < m || d == m && n.r < r.r ? _n(r, n = o) : _n(r = s, n), a--) : (bn(r, i), n = i, x(i));
                            }
                            var g = (c + u) / 2, v = (f + h) / 2, y = 0;
                            for(a = 0; a < l; a++)(i = e1[a]).x -= g, i.y -= v, y = Math.max(y, i.r + Math.sqrt(i.x * i.x + i.y * i.y));
                            t1.r = y, e1.forEach(An);
                        }
                        function x(t1) {
                            c = Math.min(t1.x - t1.r, c), u = Math.max(t1.x + t1.r, u), f = Math.min(t1.y - t1.r, f), h = Math.max(t1.y + t1.r, h);
                        }
                    }
                    function kn(t1) {
                        t1._pack_next = t1._pack_prev = t1;
                    }
                    function An(t1) {
                        delete t1._pack_next, delete t1._pack_prev;
                    }
                    function Mn(t1, e1, r) {
                        var n = t1.r + r.r, i = e1.x - t1.x, a = e1.y - t1.y;
                        if (n && (i || a)) {
                            var o = e1.r + r.r, s = i * i + a * a, l = .5 + ((n *= n) - (o *= o)) / (2 * s), c = Math.sqrt(Math.max(0, 2 * o * (n + s) - (n -= s) * n - o * o)) / (2 * s);
                            r.x = t1.x + l * i + c * a, r.y = t1.y + l * a - c * i;
                        } else r.x = t1.x + n, r.y = t1.y;
                    }
                    function Sn(t1, e1) {
                        return t1.parent == e1.parent ? 1 : 2;
                    }
                    function En(t1) {
                        var e1 = t1.children;
                        return e1.length ? e1[0] : t1.t;
                    }
                    function Ln(t1) {
                        var e1, r = t1.children;
                        return (e1 = r.length) ? r[e1 - 1] : t1.t;
                    }
                    function Cn(t1, e1, r) {
                        var n = r / (e1.i - t1.i);
                        e1.c -= n, e1.s += r, t1.c += n, e1.z += r, e1.m += r;
                    }
                    function Pn(t1, e1, r) {
                        return t1.a.parent === e1.parent ? t1.a : r;
                    }
                    function In(t1) {
                        return {
                            x: t1.x,
                            y: t1.y,
                            dx: t1.dx,
                            dy: t1.dy
                        };
                    }
                    function On(t1, e1) {
                        var r = t1.x + e1[3], n = t1.y + e1[0], i = t1.dx - e1[1] - e1[3], a = t1.dy - e1[0] - e1[2];
                        return i < 0 && (r += i / 2, i = 0), a < 0 && (n += a / 2, a = 0), {
                            x: r,
                            y: n,
                            dx: i,
                            dy: a
                        };
                    }
                    function zn(t1) {
                        var e1 = t1[0], r = t1[t1.length - 1];
                        return e1 < r ? [
                            e1,
                            r
                        ] : [
                            r,
                            e1
                        ];
                    }
                    function Dn(t1) {
                        return t1.rangeExtent ? t1.rangeExtent() : zn(t1.range());
                    }
                    function Rn(t1, e1, r, n) {
                        var i = r(t1[0], t1[1]), a = n(e1[0], e1[1]);
                        return function(t1) {
                            return a(i(t1));
                        };
                    }
                    function Fn(t1, e1) {
                        var r, n = 0, i = t1.length - 1, a = t1[n], o = t1[i];
                        return o < a && (r = n, n = i, i = r, r = a, a = o, o = r), t1[n] = e1.floor(a), t1[i] = e1.ceil(o), t1;
                    }
                    function Bn(t1) {
                        return t1 ? {
                            floor: function(e1) {
                                return Math.floor(e1 / t1) * t1;
                            },
                            ceil: function(e1) {
                                return Math.ceil(e1 / t1) * t1;
                            }
                        } : Nn;
                    }
                    t1.layout.histogram = function() {
                        var e1 = !0, r = Number, n = yn, i = gn;
                        function a(a, o) {
                            for(var s, l, c = [], u = a.map(r, this), f = n.call(this, u, o), h = i.call(this, f, u, o), p = (o = -1, u.length), d = h.length - 1, m = e1 ? 1 : 1 / p; ++o < d;)(s = c[o] = []).dx = h[o + 1] - (s.x = h[o]), s.y = 0;
                            if (d > 0) for(o = -1; ++o < p;)(l = u[o]) >= f[0] && l <= f[1] && ((s = c[t1.bisect(h, l, 1, d) - 1]).y += m, s.push(a[o]));
                            return c;
                        }
                        return a.value = function(t1) {
                            return arguments.length ? (r = t1, a) : r;
                        }, a.range = function(t1) {
                            return arguments.length ? (n = ce(t1), a) : n;
                        }, a.bins = function(t1) {
                            return arguments.length ? (i = "number" == typeof t1 ? function(e1) {
                                return vn(e1, t1);
                            } : ce(t1), a) : i;
                        }, a.frequency = function(t1) {
                            return arguments.length ? (e1 = !!t1, a) : e1;
                        }, a;
                    }, t1.layout.pack = function() {
                        var e1, r = t1.layout.hierarchy().sort(xn), n = 0, i = [
                            1,
                            1
                        ];
                        function a(t1, a) {
                            var o = r.call(this, t1, a), s = o[0], l = i[0], c = i[1], u = null == e1 ? Math.sqrt : "function" == typeof e1 ? e1 : function() {
                                return e1;
                            };
                            if (s.x = s.y = 0, $r(s, function(t1) {
                                t1.r = +u(t1.value);
                            }), $r(s, Tn), n) {
                                var f = n * (e1 ? 1 : Math.max(2 * s.r / l, 2 * s.r / c)) / 2;
                                $r(s, function(t1) {
                                    t1.r += f;
                                }), $r(s, Tn), $r(s, function(t1) {
                                    t1.r -= f;
                                });
                            }
                            return function t1(e1, r, n, i) {
                                var a = e1.children;
                                if (e1.x = r += i * e1.x, e1.y = n += i * e1.y, e1.r *= i, a) for(var o = -1, s = a.length; ++o < s;)t1(a[o], r, n, i);
                            }(s, l / 2, c / 2, e1 ? 1 : 1 / Math.max(2 * s.r / l, 2 * s.r / c)), o;
                        }
                        return a.size = function(t1) {
                            return arguments.length ? (i = t1, a) : i;
                        }, a.radius = function(t1) {
                            return arguments.length ? (e1 = null == t1 || "function" == typeof t1 ? t1 : +t1, a) : e1;
                        }, a.padding = function(t1) {
                            return arguments.length ? (n = +t1, a) : n;
                        }, Kr(a, r);
                    }, t1.layout.tree = function() {
                        var e1 = t1.layout.hierarchy().sort(null).value(null), r = Sn, n = [
                            1,
                            1
                        ], i = null;
                        function a(t1, a) {
                            var c = e1.call(this, t1, a), u = c[0], f = function(t1) {
                                var e1, r = {
                                    A: null,
                                    children: [
                                        t1
                                    ]
                                }, n = [
                                    r
                                ];
                                for(; null != (e1 = n.pop());)for(var i, a = e1.children, o = 0, s = a.length; o < s; ++o)n.push((a[o] = i = {
                                    _: a[o],
                                    parent: e1,
                                    children: (i = a[o].children) && i.slice() || [],
                                    A: null,
                                    a: null,
                                    z: 0,
                                    m: 0,
                                    c: 0,
                                    s: 0,
                                    t: null,
                                    i: o
                                }).a = i);
                                return r.children[0];
                            }(u);
                            if ($r(f, o), f.parent.m = -f.z, Qr(f, s), i) Qr(u, l);
                            else {
                                var h = u, p = u, d = u;
                                Qr(u, function(t1) {
                                    t1.x < h.x && (h = t1), t1.x > p.x && (p = t1), t1.depth > d.depth && (d = t1);
                                });
                                var m = r(h, p) / 2 - h.x, g = n[0] / (p.x + r(p, h) / 2 + m), v = n[1] / (d.depth || 1);
                                Qr(u, function(t1) {
                                    t1.x = (t1.x + m) * g, t1.y = t1.depth * v;
                                });
                            }
                            return c;
                        }
                        function o(t1) {
                            var e1 = t1.children, n = t1.parent.children, i = t1.i ? n[t1.i - 1] : null;
                            if (e1.length) {
                                !function(t1) {
                                    var e1, r = 0, n = 0, i = t1.children, a = i.length;
                                    for(; --a >= 0;)(e1 = i[a]).z += r, e1.m += r, r += e1.s + (n += e1.c);
                                }(t1);
                                var a = (e1[0].z + e1[e1.length - 1].z) / 2;
                                i ? (t1.z = i.z + r(t1._, i._), t1.m = t1.z - a) : t1.z = a;
                            } else i && (t1.z = i.z + r(t1._, i._));
                            t1.parent.A = function(t1, e1, n) {
                                if (e1) {
                                    for(var i, a = t1, o = t1, s = e1, l = a.parent.children[0], c = a.m, u = o.m, f = s.m, h = l.m; s = Ln(s), a = En(a), s && a;)l = En(l), (o = Ln(o)).a = t1, (i = s.z + f - a.z - c + r(s._, a._)) > 0 && (Cn(Pn(s, t1, n), t1, i), c += i, u += i), f += s.m, c += a.m, h += l.m, u += o.m;
                                    s && !Ln(o) && (o.t = s, o.m += f - u), a && !En(l) && (l.t = a, l.m += c - h, n = t1);
                                }
                                return n;
                            }(t1, i, t1.parent.A || n[0]);
                        }
                        function s(t1) {
                            t1._.x = t1.z + t1.parent.m, t1.m += t1.parent.m;
                        }
                        function l(t1) {
                            t1.x *= n[0], t1.y = t1.depth * n[1];
                        }
                        return a.separation = function(t1) {
                            return arguments.length ? (r = t1, a) : r;
                        }, a.size = function(t1) {
                            return arguments.length ? (i = null == (n = t1) ? l : null, a) : i ? null : n;
                        }, a.nodeSize = function(t1) {
                            return arguments.length ? (i = null == (n = t1) ? null : l, a) : i ? n : null;
                        }, Kr(a, e1);
                    }, t1.layout.cluster = function() {
                        var e1 = t1.layout.hierarchy().sort(null).value(null), r = Sn, n = [
                            1,
                            1
                        ], i = !1;
                        function a(a, o) {
                            var s, l = e1.call(this, a, o), c = l[0], u = 0;
                            $r(c, function(e1) {
                                var n = e1.children;
                                n && n.length ? (e1.x = function(t1) {
                                    return t1.reduce(function(t1, e1) {
                                        return t1 + e1.x;
                                    }, 0) / t1.length;
                                }(n), e1.y = function(e1) {
                                    return 1 + t1.max(e1, function(t1) {
                                        return t1.y;
                                    });
                                }(n)) : (e1.x = s ? u += r(e1, s) : 0, e1.y = 0, s = e1);
                            });
                            var f = function t1(e1) {
                                var r = e1.children;
                                return r && r.length ? t1(r[0]) : e1;
                            }(c), h = function t1(e1) {
                                var r, n = e1.children;
                                return n && (r = n.length) ? t1(n[r - 1]) : e1;
                            }(c), p = f.x - r(f, h) / 2, d = h.x + r(h, f) / 2;
                            return $r(c, i ? function(t1) {
                                t1.x = (t1.x - c.x) * n[0], t1.y = (c.y - t1.y) * n[1];
                            } : function(t1) {
                                t1.x = (t1.x - p) / (d - p) * n[0], t1.y = (1 - (c.y ? t1.y / c.y : 1)) * n[1];
                            }), l;
                        }
                        return a.separation = function(t1) {
                            return arguments.length ? (r = t1, a) : r;
                        }, a.size = function(t1) {
                            return arguments.length ? (i = null == (n = t1), a) : i ? null : n;
                        }, a.nodeSize = function(t1) {
                            return arguments.length ? (i = null != (n = t1), a) : i ? n : null;
                        }, Kr(a, e1);
                    }, t1.layout.treemap = function() {
                        var e1, r = t1.layout.hierarchy(), n = Math.round, i = [
                            1,
                            1
                        ], a = null, o = In, s = !1, l = "squarify", c = .5 * (1 + Math.sqrt(5));
                        function u(t1, e1) {
                            for(var r, n, i = -1, a = t1.length; ++i < a;)n = (r = t1[i]).value * (e1 < 0 ? 0 : e1), r.area = isNaN(n) || n <= 0 ? 0 : n;
                        }
                        function f(t1) {
                            var e1 = t1.children;
                            if (e1 && e1.length) {
                                var r, n, i, a = o(t1), s = [], c = e1.slice(), h = 1 / 0, m = "slice" === l ? a.dx : "dice" === l ? a.dy : "slice-dice" === l ? 1 & t1.depth ? a.dy : a.dx : Math.min(a.dx, a.dy);
                                for(u(c, a.dx * a.dy / t1.value), s.area = 0; (i = c.length) > 0;)s.push(r = c[i - 1]), s.area += r.area, "squarify" !== l || (n = p(s, m)) <= h ? (c.pop(), h = n) : (s.area -= s.pop().area, d(s, m, a, !1), m = Math.min(a.dx, a.dy), s.length = s.area = 0, h = 1 / 0);
                                s.length && (d(s, m, a, !0), s.length = s.area = 0), e1.forEach(f);
                            }
                        }
                        function h(t1) {
                            var e1 = t1.children;
                            if (e1 && e1.length) {
                                var r, n = o(t1), i = e1.slice(), a = [];
                                for(u(i, n.dx * n.dy / t1.value), a.area = 0; r = i.pop();)a.push(r), a.area += r.area, null != r.z && (d(a, r.z ? n.dx : n.dy, n, !i.length), a.length = a.area = 0);
                                e1.forEach(h);
                            }
                        }
                        function p(t1, e1) {
                            for(var r, n = t1.area, i = 0, a = 1 / 0, o = -1, s = t1.length; ++o < s;)(r = t1[o].area) && (r < a && (a = r), r > i && (i = r));
                            return e1 *= e1, (n *= n) ? Math.max(e1 * i * c / n, n / (e1 * a * c)) : 1 / 0;
                        }
                        function d(t1, e1, r, i) {
                            var a, o = -1, s = t1.length, l = r.x, c = r.y, u = e1 ? n(t1.area / e1) : 0;
                            if (e1 == r.dx) {
                                for((i || u > r.dy) && (u = r.dy); ++o < s;)(a = t1[o]).x = l, a.y = c, a.dy = u, l += a.dx = Math.min(r.x + r.dx - l, u ? n(a.area / u) : 0);
                                a.z = !0, a.dx += r.x + r.dx - l, r.y += u, r.dy -= u;
                            } else {
                                for((i || u > r.dx) && (u = r.dx); ++o < s;)(a = t1[o]).x = l, a.y = c, a.dx = u, c += a.dy = Math.min(r.y + r.dy - c, u ? n(a.area / u) : 0);
                                a.z = !1, a.dy += r.y + r.dy - c, r.x += u, r.dx -= u;
                            }
                        }
                        function m(t1) {
                            var n = e1 || r(t1), a = n[0];
                            return a.x = a.y = 0, a.value ? (a.dx = i[0], a.dy = i[1]) : a.dx = a.dy = 0, e1 && r.revalue(a), u([
                                a
                            ], a.dx * a.dy / a.value), (e1 ? h : f)(a), s && (e1 = n), n;
                        }
                        return m.size = function(t1) {
                            return arguments.length ? (i = t1, m) : i;
                        }, m.padding = function(t1) {
                            if (!arguments.length) return a;
                            function e1(e1) {
                                var r = t1.call(m, e1, e1.depth);
                                return null == r ? In(e1) : On(e1, "number" == typeof r ? [
                                    r,
                                    r,
                                    r,
                                    r
                                ] : r);
                            }
                            function r(e1) {
                                return On(e1, t1);
                            }
                            var n;
                            return o = null == (a = t1) ? In : "function" == (n = typeof t1) ? e1 : "number" === n ? (t1 = [
                                t1,
                                t1,
                                t1,
                                t1
                            ], r) : r, m;
                        }, m.round = function(t1) {
                            return arguments.length ? (n = t1 ? Math.round : Number, m) : n != Number;
                        }, m.sticky = function(t1) {
                            return arguments.length ? (s = t1, e1 = null, m) : s;
                        }, m.ratio = function(t1) {
                            return arguments.length ? (c = t1, m) : c;
                        }, m.mode = function(t1) {
                            return arguments.length ? (l = t1 + "", m) : l;
                        }, Kr(m, r);
                    }, t1.random = {
                        normal: function(t1, e1) {
                            var r = arguments.length;
                            return r < 2 && (e1 = 1), r < 1 && (t1 = 0), function() {
                                var r, n, i;
                                do i = (r = 2 * Math.random() - 1) * r + (n = 2 * Math.random() - 1) * n;
                                while (!i || i > 1);
                                return t1 + e1 * r * Math.sqrt(-2 * Math.log(i) / i);
                            };
                        },
                        logNormal: function() {
                            var e1 = t1.random.normal.apply(t1, arguments);
                            return function() {
                                return Math.exp(e1());
                            };
                        },
                        bates: function(e1) {
                            var r = t1.random.irwinHall(e1);
                            return function() {
                                return r() / e1;
                            };
                        },
                        irwinHall: function(t1) {
                            return function() {
                                for(var e1 = 0, r = 0; r < t1; r++)e1 += Math.random();
                                return e1;
                            };
                        }
                    }, t1.scale = {};
                    var Nn = {
                        floor: C,
                        ceil: C
                    };
                    function jn(e1, r, n, i) {
                        var a = [], o = [], s = 0, l = Math.min(e1.length, r.length) - 1;
                        for(e1[l] < e1[0] && (e1 = e1.slice().reverse(), r = r.slice().reverse()); ++s <= l;)a.push(n(e1[s - 1], e1[s])), o.push(i(r[s - 1], r[s]));
                        return function(r) {
                            var n = t1.bisect(e1, r, 1, l) - 1;
                            return o[n](a[n](r));
                        };
                    }
                    function Un(e1, r) {
                        return t1.rebind(e1, r, "range", "rangeRound", "interpolate", "clamp");
                    }
                    function Vn(t1, e1) {
                        return Fn(t1, Bn(Hn(t1, e1)[2])), Fn(t1, Bn(Hn(t1, e1)[2])), t1;
                    }
                    function Hn(t1, e1) {
                        null == e1 && (e1 = 10);
                        var r = zn(t1), n = r[1] - r[0], i = Math.pow(10, Math.floor(Math.log(n / e1) / Math.LN10)), a = e1 / n * i;
                        return a <= .15 ? i *= 10 : a <= .35 ? i *= 5 : a <= .75 && (i *= 2), r[0] = Math.ceil(r[0] / i) * i, r[1] = Math.floor(r[1] / i) * i + .5 * i, r[2] = i, r;
                    }
                    function qn(e1, r) {
                        return t1.range.apply(t1, Hn(e1, r));
                    }
                    t1.scale.linear = function() {
                        return function t1(e1, r, n, i) {
                            var a, o;
                            function s() {
                                var t1 = Math.min(e1.length, r.length) > 2 ? jn : Rn, s = i ? Ur : jr;
                                return a = t1(e1, r, s, n), o = t1(r, e1, s, yr), l;
                            }
                            function l(t1) {
                                return a(t1);
                            }
                            return l.invert = function(t1) {
                                return o(t1);
                            }, l.domain = function(t1) {
                                return arguments.length ? (e1 = t1.map(Number), s()) : e1;
                            }, l.range = function(t1) {
                                return arguments.length ? (r = t1, s()) : r;
                            }, l.rangeRound = function(t1) {
                                return l.range(t1).interpolate(Or);
                            }, l.clamp = function(t1) {
                                return arguments.length ? (i = t1, s()) : i;
                            }, l.interpolate = function(t1) {
                                return arguments.length ? (n = t1, s()) : n;
                            }, l.ticks = function(t1) {
                                return qn(e1, t1);
                            }, l.tickFormat = function(t1, r) {
                                return d3_scale_linearTickFormat(e1, t1, r);
                            }, l.nice = function(t1) {
                                return Vn(e1, t1), s();
                            }, l.copy = function() {
                                return t1(e1, r, n, i);
                            }, s();
                        }([
                            0,
                            1
                        ], [
                            0,
                            1
                        ], yr, !1);
                    };
                    t1.scale.log = function() {
                        return function t1(e1, r, n, i) {
                            function a(t1) {
                                return (n ? Math.log(t1 < 0 ? 0 : t1) : -Math.log(t1 > 0 ? 0 : -t1)) / Math.log(r);
                            }
                            function o(t1) {
                                return n ? Math.pow(r, t1) : -Math.pow(r, -t1);
                            }
                            function s(t1) {
                                return e1(a(t1));
                            }
                            return s.invert = function(t1) {
                                return o(e1.invert(t1));
                            }, s.domain = function(t1) {
                                return arguments.length ? (n = t1[0] >= 0, e1.domain((i = t1.map(Number)).map(a)), s) : i;
                            }, s.base = function(t1) {
                                return arguments.length ? (r = +t1, e1.domain(i.map(a)), s) : r;
                            }, s.nice = function() {
                                var t1 = Fn(i.map(a), n ? Math : Gn);
                                return e1.domain(t1), i = t1.map(o), s;
                            }, s.ticks = function() {
                                var t1 = zn(i), e1 = [], s = t1[0], l = t1[1], c = Math.floor(a(s)), u = Math.ceil(a(l)), f = r % 1 ? 2 : r;
                                if (isFinite(u - c)) {
                                    if (n) {
                                        for(; c < u; c++)for(var h = 1; h < f; h++)e1.push(o(c) * h);
                                        e1.push(o(c));
                                    } else for(e1.push(o(c)); c++ < u;)for(h = f - 1; h > 0; h--)e1.push(o(c) * h);
                                    for(c = 0; e1[c] < s; c++);
                                    for(u = e1.length; e1[u - 1] > l; u--);
                                    e1 = e1.slice(c, u);
                                }
                                return e1;
                            }, s.copy = function() {
                                return t1(e1.copy(), r, n, i);
                            }, Un(s, e1);
                        }(t1.scale.linear().domain([
                            0,
                            1
                        ]), 10, !0, [
                            1,
                            10
                        ]);
                    };
                    var Gn = {
                        floor: function(t1) {
                            return -Math.ceil(-t1);
                        },
                        ceil: function(t1) {
                            return -Math.floor(-t1);
                        }
                    };
                    function Yn(t1) {
                        return function(e1) {
                            return e1 < 0 ? -Math.pow(-e1, t1) : Math.pow(e1, t1);
                        };
                    }
                    t1.scale.pow = function() {
                        return function t1(e1, r, n) {
                            var i = Yn(r), a = Yn(1 / r);
                            function o(t1) {
                                return e1(i(t1));
                            }
                            return o.invert = function(t1) {
                                return a(e1.invert(t1));
                            }, o.domain = function(t1) {
                                return arguments.length ? (e1.domain((n = t1.map(Number)).map(i)), o) : n;
                            }, o.ticks = function(t1) {
                                return qn(n, t1);
                            }, o.tickFormat = function(t1, e1) {
                                return d3_scale_linearTickFormat(n, t1, e1);
                            }, o.nice = function(t1) {
                                return o.domain(Vn(n, t1));
                            }, o.exponent = function(t1) {
                                return arguments.length ? (i = Yn(r = t1), a = Yn(1 / r), e1.domain(n.map(i)), o) : r;
                            }, o.copy = function() {
                                return t1(e1.copy(), r, n);
                            }, Un(o, e1);
                        }(t1.scale.linear(), 1, [
                            0,
                            1
                        ]);
                    }, t1.scale.sqrt = function() {
                        return t1.scale.pow().exponent(.5);
                    }, t1.scale.ordinal = function() {
                        return function e1(r, n) {
                            var i, a, o;
                            function s(t1) {
                                return a[((i.get(t1) || ("range" === n.t ? i.set(t1, r.push(t1)) : NaN)) - 1) % a.length];
                            }
                            function l(e1, n) {
                                return t1.range(r.length).map(function(t1) {
                                    return e1 + n * t1;
                                });
                            }
                            return s.domain = function(t1) {
                                if (!arguments.length) return r;
                                r = [], i = new _;
                                for(var e1, a = -1, o = t1.length; ++a < o;)i.has(e1 = t1[a]) || i.set(e1, r.push(e1));
                                return s[n.t].apply(s, n.a);
                            }, s.range = function(t1) {
                                return arguments.length ? (a = t1, o = 0, n = {
                                    t: "range",
                                    a: arguments
                                }, s) : a;
                            }, s.rangePoints = function(t1, e1) {
                                arguments.length < 2 && (e1 = 0);
                                var i = t1[0], c = t1[1], u = r.length < 2 ? (i = (i + c) / 2, 0) : (c - i) / (r.length - 1 + e1);
                                return a = l(i + u * e1 / 2, u), o = 0, n = {
                                    t: "rangePoints",
                                    a: arguments
                                }, s;
                            }, s.rangeRoundPoints = function(t1, e1) {
                                arguments.length < 2 && (e1 = 0);
                                var i = t1[0], c = t1[1], u = r.length < 2 ? (i = c = Math.round((i + c) / 2), 0) : (c - i) / (r.length - 1 + e1) | 0;
                                return a = l(i + Math.round(u * e1 / 2 + (c - i - (r.length - 1 + e1) * u) / 2), u), o = 0, n = {
                                    t: "rangeRoundPoints",
                                    a: arguments
                                }, s;
                            }, s.rangeBands = function(t1, e1, i) {
                                arguments.length < 2 && (e1 = 0), arguments.length < 3 && (i = e1);
                                var c = t1[1] < t1[0], u = t1[c - 0], f = t1[1 - c], h = (f - u) / (r.length - e1 + 2 * i);
                                return a = l(u + h * i, h), c && a.reverse(), o = h * (1 - e1), n = {
                                    t: "rangeBands",
                                    a: arguments
                                }, s;
                            }, s.rangeRoundBands = function(t1, e1, i) {
                                arguments.length < 2 && (e1 = 0), arguments.length < 3 && (i = e1);
                                var c = t1[1] < t1[0], u = t1[c - 0], f = t1[1 - c], h = Math.floor((f - u) / (r.length - e1 + 2 * i));
                                return a = l(u + Math.round((f - u - (r.length - e1) * h) / 2), h), c && a.reverse(), o = Math.round(h * (1 - e1)), n = {
                                    t: "rangeRoundBands",
                                    a: arguments
                                }, s;
                            }, s.rangeBand = function() {
                                return o;
                            }, s.rangeExtent = function() {
                                return zn(n.a[0]);
                            }, s.copy = function() {
                                return e1(r, n);
                            }, s.domain(r);
                        }([], {
                            t: "range",
                            a: [
                                []
                            ]
                        });
                    }, t1.scale.category10 = function() {
                        return t1.scale.ordinal().range(Wn);
                    }, t1.scale.category20 = function() {
                        return t1.scale.ordinal().range(Xn);
                    }, t1.scale.category20b = function() {
                        return t1.scale.ordinal().range(Zn);
                    }, t1.scale.category20c = function() {
                        return t1.scale.ordinal().range(Jn);
                    };
                    var Wn = [
                        2062260,
                        16744206,
                        2924588,
                        14034728,
                        9725885,
                        9197131,
                        14907330,
                        8355711,
                        12369186,
                        1556175
                    ].map(te), Xn = [
                        2062260,
                        11454440,
                        16744206,
                        16759672,
                        2924588,
                        10018698,
                        14034728,
                        16750742,
                        9725885,
                        12955861,
                        9197131,
                        12885140,
                        14907330,
                        16234194,
                        8355711,
                        13092807,
                        12369186,
                        14408589,
                        1556175,
                        10410725
                    ].map(te), Zn = [
                        3750777,
                        5395619,
                        7040719,
                        10264286,
                        6519097,
                        9216594,
                        11915115,
                        13556636,
                        9202993,
                        12426809,
                        15186514,
                        15190932,
                        8666169,
                        11356490,
                        14049643,
                        15177372,
                        8077683,
                        10834324,
                        13528509,
                        14589654
                    ].map(te), Jn = [
                        3244733,
                        7057110,
                        10406625,
                        13032431,
                        15095053,
                        16616764,
                        16625259,
                        16634018,
                        3253076,
                        7652470,
                        10607003,
                        13101504,
                        7695281,
                        10394312,
                        12369372,
                        14342891,
                        6513507,
                        9868950,
                        12434877,
                        14277081
                    ].map(te);
                    function Kn() {
                        return 0;
                    }
                    t1.scale.quantile = function() {
                        return function e1(r, n) {
                            var i;
                            function a() {
                                var e1 = 0, a = n.length;
                                for(i = []; ++e1 < a;)i[e1 - 1] = t1.quantile(r, e1 / a);
                                return o;
                            }
                            function o(e1) {
                                if (!isNaN(e1 = +e1)) return n[t1.bisect(i, e1)];
                            }
                            return o.domain = function(t1) {
                                return arguments.length ? (r = t1.map(p).filter(d).sort(h), a()) : r;
                            }, o.range = function(t1) {
                                return arguments.length ? (n = t1, a()) : n;
                            }, o.quantiles = function() {
                                return i;
                            }, o.invertExtent = function(t1) {
                                return (t1 = n.indexOf(t1)) < 0 ? [
                                    NaN,
                                    NaN
                                ] : [
                                    t1 > 0 ? i[t1 - 1] : r[0],
                                    t1 < i.length ? i[t1] : r[r.length - 1]
                                ];
                            }, o.copy = function() {
                                return e1(r, n);
                            }, a();
                        }([], []);
                    }, t1.scale.quantize = function() {
                        return function t1(e1, r, n) {
                            var i, a;
                            function o(t1) {
                                return n[Math.max(0, Math.min(a, Math.floor(i * (t1 - e1))))];
                            }
                            function s() {
                                return i = n.length / (r - e1), a = n.length - 1, o;
                            }
                            return o.domain = function(t1) {
                                return arguments.length ? (e1 = +t1[0], r = +t1[t1.length - 1], s()) : [
                                    e1,
                                    r
                                ];
                            }, o.range = function(t1) {
                                return arguments.length ? (n = t1, s()) : n;
                            }, o.invertExtent = function(t1) {
                                return [
                                    t1 = (t1 = n.indexOf(t1)) < 0 ? NaN : t1 / i + e1,
                                    t1 + 1 / i
                                ];
                            }, o.copy = function() {
                                return t1(e1, r, n);
                            }, s();
                        }(0, 1, [
                            0,
                            1
                        ]);
                    }, t1.scale.threshold = function() {
                        return function e1(r, n) {
                            function i(e1) {
                                if (e1 <= e1) return n[t1.bisect(r, e1)];
                            }
                            return i.domain = function(t1) {
                                return arguments.length ? (r = t1, i) : r;
                            }, i.range = function(t1) {
                                return arguments.length ? (n = t1, i) : n;
                            }, i.invertExtent = function(t1) {
                                return t1 = n.indexOf(t1), [
                                    r[t1 - 1],
                                    r[t1]
                                ];
                            }, i.copy = function() {
                                return e1(r, n);
                            }, i;
                        }([
                            .5
                        ], [
                            0,
                            1
                        ]);
                    }, t1.scale.identity = function() {
                        return function t1(e1) {
                            function r(t1) {
                                return +t1;
                            }
                            return r.invert = r, r.domain = r.range = function(t1) {
                                return arguments.length ? (e1 = t1.map(r), r) : e1;
                            }, r.ticks = function(t1) {
                                return qn(e1, t1);
                            }, r.tickFormat = function(t1, r) {
                                return d3_scale_linearTickFormat(e1, t1, r);
                            }, r.copy = function() {
                                return t1(e1);
                            }, r;
                        }([
                            0,
                            1
                        ]);
                    }, t1.svg = {}, t1.svg.arc = function() {
                        var t1 = $n, e1 = ti, r = Kn, n = Qn, i = ei, a = ri, o = ni;
                        function s() {
                            var s = Math.max(0, +t1.apply(this, arguments)), c = Math.max(0, +e1.apply(this, arguments)), u = i.apply(this, arguments) - Et, f = a.apply(this, arguments) - Et, h = Math.abs(f - u), p = u > f ? 0 : 1;
                            if (c < s && (d = c, c = s, s = d), h >= St) return l(c, p) + (s ? l(s, 1 - p) : "") + "Z";
                            var d, m, g, v, y, x, b, _, w, T, k, A, M = 0, S = 0, E = [];
                            if ((v = (+o.apply(this, arguments) || 0) / 2) && (g = n === Qn ? Math.sqrt(s * s + c * c) : +n.apply(this, arguments), p || (S *= -1), c && (S = Pt(g / c * Math.sin(v))), s && (M = Pt(g / s * Math.sin(v)))), c) {
                                y = c * Math.cos(u + S), x = c * Math.sin(u + S), b = c * Math.cos(f - S), _ = c * Math.sin(f - S);
                                var L = Math.abs(f - u - 2 * S) <= At ? 0 : 1;
                                if (S && ii(y, x, b, _) === p ^ L) {
                                    var C = (u + f) / 2;
                                    y = c * Math.cos(C), x = c * Math.sin(C), b = _ = null;
                                }
                            } else y = x = 0;
                            if (s) {
                                w = s * Math.cos(f - M), T = s * Math.sin(f - M), k = s * Math.cos(u + M), A = s * Math.sin(u + M);
                                var P = Math.abs(u - f + 2 * M) <= At ? 0 : 1;
                                if (M && ii(w, T, k, A) === 1 - p ^ P) {
                                    var I = (u + f) / 2;
                                    w = s * Math.cos(I), T = s * Math.sin(I), k = A = null;
                                }
                            } else w = T = 0;
                            if (h > kt && (d = Math.min(Math.abs(c - s) / 2, +r.apply(this, arguments))) > .001) {
                                m = s < c ^ p ? 0 : 1;
                                var O = d, z = d;
                                if (h < At) {
                                    var D = null == k ? [
                                        w,
                                        T
                                    ] : null == b ? [
                                        y,
                                        x
                                    ] : Se([
                                        y,
                                        x
                                    ], [
                                        k,
                                        A
                                    ], [
                                        b,
                                        _
                                    ], [
                                        w,
                                        T
                                    ]), R = y - D[0], F = x - D[1], B = b - D[0], N = _ - D[1], j = 1 / Math.sin(Math.acos((R * B + F * N) / (Math.sqrt(R * R + F * F) * Math.sqrt(B * B + N * N))) / 2), U = Math.sqrt(D[0] * D[0] + D[1] * D[1]);
                                    z = Math.min(d, (s - U) / (j - 1)), O = Math.min(d, (c - U) / (j + 1));
                                }
                                if (null != b) {
                                    var V = ai(null == k ? [
                                        w,
                                        T
                                    ] : [
                                        k,
                                        A
                                    ], [
                                        y,
                                        x
                                    ], c, O, p), H = ai([
                                        b,
                                        _
                                    ], [
                                        w,
                                        T
                                    ], c, O, p);
                                    d === O ? E.push("M", V[0], "A", O, ",", O, " 0 0,", m, " ", V[1], "A", c, ",", c, " 0 ", 1 - p ^ ii(V[1][0], V[1][1], H[1][0], H[1][1]), ",", p, " ", H[1], "A", O, ",", O, " 0 0,", m, " ", H[0]) : E.push("M", V[0], "A", O, ",", O, " 0 1,", m, " ", H[0]);
                                } else E.push("M", y, ",", x);
                                if (null != k) {
                                    var q = ai([
                                        y,
                                        x
                                    ], [
                                        k,
                                        A
                                    ], s, -z, p), G = ai([
                                        w,
                                        T
                                    ], null == b ? [
                                        y,
                                        x
                                    ] : [
                                        b,
                                        _
                                    ], s, -z, p);
                                    d === z ? E.push("L", G[0], "A", z, ",", z, " 0 0,", m, " ", G[1], "A", s, ",", s, " 0 ", p ^ ii(G[1][0], G[1][1], q[1][0], q[1][1]), ",", 1 - p, " ", q[1], "A", z, ",", z, " 0 0,", m, " ", q[0]) : E.push("L", G[0], "A", z, ",", z, " 0 0,", m, " ", q[0]);
                                } else E.push("L", w, ",", T);
                            } else E.push("M", y, ",", x), null != b && E.push("A", c, ",", c, " 0 ", L, ",", p, " ", b, ",", _), E.push("L", w, ",", T), null != k && E.push("A", s, ",", s, " 0 ", P, ",", 1 - p, " ", k, ",", A);
                            return E.push("Z"), E.join("");
                        }
                        function l(t1, e1) {
                            return "M0," + t1 + "A" + t1 + "," + t1 + " 0 1," + e1 + " 0," + -t1 + "A" + t1 + "," + t1 + " 0 1," + e1 + " 0," + t1;
                        }
                        return s.innerRadius = function(e1) {
                            return arguments.length ? (t1 = ce(e1), s) : t1;
                        }, s.outerRadius = function(t1) {
                            return arguments.length ? (e1 = ce(t1), s) : e1;
                        }, s.cornerRadius = function(t1) {
                            return arguments.length ? (r = ce(t1), s) : r;
                        }, s.padRadius = function(t1) {
                            return arguments.length ? (n = t1 == Qn ? Qn : ce(t1), s) : n;
                        }, s.startAngle = function(t1) {
                            return arguments.length ? (i = ce(t1), s) : i;
                        }, s.endAngle = function(t1) {
                            return arguments.length ? (a = ce(t1), s) : a;
                        }, s.padAngle = function(t1) {
                            return arguments.length ? (o = ce(t1), s) : o;
                        }, s.centroid = function() {
                            var r = (+t1.apply(this, arguments) + +e1.apply(this, arguments)) / 2, n = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - Et;
                            return [
                                Math.cos(n) * r,
                                Math.sin(n) * r
                            ];
                        }, s;
                    };
                    var Qn = "auto";
                    function $n(t1) {
                        return t1.innerRadius;
                    }
                    function ti(t1) {
                        return t1.outerRadius;
                    }
                    function ei(t1) {
                        return t1.startAngle;
                    }
                    function ri(t1) {
                        return t1.endAngle;
                    }
                    function ni(t1) {
                        return t1 && t1.padAngle;
                    }
                    function ii(t1, e1, r, n) {
                        return (t1 - r) * e1 - (e1 - n) * t1 > 0 ? 0 : 1;
                    }
                    function ai(t1, e1, r, n, i) {
                        var a = t1[0] - e1[0], o = t1[1] - e1[1], s = (i ? n : -n) / Math.sqrt(a * a + o * o), l = s * o, c = -s * a, u = t1[0] + l, f = t1[1] + c, h = e1[0] + l, p = e1[1] + c, d = (u + h) / 2, m = (f + p) / 2, g = h - u, v = p - f, y = g * g + v * v, x = r - n, b = u * p - h * f, _ = (v < 0 ? -1 : 1) * Math.sqrt(Math.max(0, x * x * y - b * b)), w = (b * v - g * _) / y, T = (-b * g - v * _) / y, k = (b * v + g * _) / y, A = (-b * g + v * _) / y, M = w - d, S = T - m, E = k - d, L = A - m;
                        return M * M + S * S > E * E + L * L && (w = k, T = A), [
                            [
                                w - l,
                                T - c
                            ],
                            [
                                w * r / x,
                                T * r / x
                            ]
                        ];
                    }
                    function oi() {
                        return !0;
                    }
                    function si(t1) {
                        var e1 = _e, r = we, n = oi, i = ci, a = i.key, o = .7;
                        function s(a) {
                            var s, l = [], c = [], u = -1, f = a.length, h = ce(e1), p = ce(r);
                            function d() {
                                l.push("M", i(t1(c), o));
                            }
                            for(; ++u < f;)n.call(this, s = a[u], u) ? c.push([
                                +h.call(this, s, u),
                                +p.call(this, s, u)
                            ]) : c.length && (d(), c = []);
                            return c.length && d(), l.length ? l.join("") : null;
                        }
                        return s.x = function(t1) {
                            return arguments.length ? (e1 = t1, s) : e1;
                        }, s.y = function(t1) {
                            return arguments.length ? (r = t1, s) : r;
                        }, s.defined = function(t1) {
                            return arguments.length ? (n = t1, s) : n;
                        }, s.interpolate = function(t1) {
                            return arguments.length ? (a = "function" == typeof t1 ? i = t1 : (i = li.get(t1) || ci).key, s) : a;
                        }, s.tension = function(t1) {
                            return arguments.length ? (o = t1, s) : o;
                        }, s;
                    }
                    t1.svg.line = function() {
                        return si(C);
                    };
                    var li = t1.map({
                        linear: ci,
                        "linear-closed": ui,
                        step: function(t1) {
                            var e1 = 0, r = t1.length, n = t1[0], i = [
                                n[0],
                                ",",
                                n[1]
                            ];
                            for(; ++e1 < r;)i.push("H", (n[0] + (n = t1[e1])[0]) / 2, "V", n[1]);
                            r > 1 && i.push("H", n[0]);
                            return i.join("");
                        },
                        "step-before": fi,
                        "step-after": hi,
                        basis: mi,
                        "basis-open": function(t1) {
                            if (t1.length < 4) return ci(t1);
                            var e1, r = [], n = -1, i = t1.length, a = [
                                0
                            ], o = [
                                0
                            ];
                            for(; ++n < 3;)e1 = t1[n], a.push(e1[0]), o.push(e1[1]);
                            r.push(gi(xi, a) + "," + gi(xi, o)), --n;
                            for(; ++n < i;)e1 = t1[n], a.shift(), a.push(e1[0]), o.shift(), o.push(e1[1]), bi(r, a, o);
                            return r.join("");
                        },
                        "basis-closed": function(t1) {
                            var e1, r, n = -1, i = t1.length, a = i + 4, o = [], s = [];
                            for(; ++n < 4;)r = t1[n % i], o.push(r[0]), s.push(r[1]);
                            e1 = [
                                gi(xi, o),
                                ",",
                                gi(xi, s)
                            ], --n;
                            for(; ++n < a;)r = t1[n % i], o.shift(), o.push(r[0]), s.shift(), s.push(r[1]), bi(e1, o, s);
                            return e1.join("");
                        },
                        bundle: function(t1, e1) {
                            var r = t1.length - 1;
                            if (r) for(var n, i, a = t1[0][0], o = t1[0][1], s = t1[r][0] - a, l = t1[r][1] - o, c = -1; ++c <= r;)n = t1[c], i = c / r, n[0] = e1 * n[0] + (1 - e1) * (a + i * s), n[1] = e1 * n[1] + (1 - e1) * (o + i * l);
                            return mi(t1);
                        },
                        cardinal: function(t1, e1) {
                            return t1.length < 3 ? ci(t1) : t1[0] + pi(t1, di(t1, e1));
                        },
                        "cardinal-open": function(t1, e1) {
                            return t1.length < 4 ? ci(t1) : t1[1] + pi(t1.slice(1, -1), di(t1, e1));
                        },
                        "cardinal-closed": function(t1, e1) {
                            return t1.length < 3 ? ui(t1) : t1[0] + pi((t1.push(t1[0]), t1), di([
                                t1[t1.length - 2]
                            ].concat(t1, [
                                t1[1]
                            ]), e1));
                        },
                        monotone: function(t1) {
                            return t1.length < 3 ? ci(t1) : t1[0] + pi(t1, function(t1) {
                                var e1, r, n, i, a = [], o = function(t1) {
                                    var e1 = 0, r = t1.length - 1, n = [], i = t1[0], a = t1[1], o = n[0] = _i(i, a);
                                    for(; ++e1 < r;)n[e1] = (o + (o = _i(i = a, a = t1[e1 + 1]))) / 2;
                                    return n[e1] = o, n;
                                }(t1), s = -1, l = t1.length - 1;
                                for(; ++s < l;)e1 = _i(t1[s], t1[s + 1]), y(e1) < kt ? o[s] = o[s + 1] = 0 : (r = o[s] / e1, n = o[s + 1] / e1, (i = r * r + n * n) > 9 && (i = 3 * e1 / Math.sqrt(i), o[s] = i * r, o[s + 1] = i * n));
                                s = -1;
                                for(; ++s <= l;)i = (t1[Math.min(l, s + 1)][0] - t1[Math.max(0, s - 1)][0]) / (6 * (1 + o[s] * o[s])), a.push([
                                    i || 0,
                                    o[s] * i || 0
                                ]);
                                return a;
                            }(t1));
                        }
                    });
                    function ci(t1) {
                        return t1.length > 1 ? t1.join("L") : t1 + "Z";
                    }
                    function ui(t1) {
                        return t1.join("L") + "Z";
                    }
                    function fi(t1) {
                        for(var e1 = 0, r = t1.length, n = t1[0], i = [
                            n[0],
                            ",",
                            n[1]
                        ]; ++e1 < r;)i.push("V", (n = t1[e1])[1], "H", n[0]);
                        return i.join("");
                    }
                    function hi(t1) {
                        for(var e1 = 0, r = t1.length, n = t1[0], i = [
                            n[0],
                            ",",
                            n[1]
                        ]; ++e1 < r;)i.push("H", (n = t1[e1])[0], "V", n[1]);
                        return i.join("");
                    }
                    function pi(t1, e1) {
                        if (e1.length < 1 || t1.length != e1.length && t1.length != e1.length + 2) return ci(t1);
                        var r = t1.length != e1.length, n = "", i = t1[0], a = t1[1], o = e1[0], s = o, l = 1;
                        if (r && (n += "Q" + (a[0] - 2 * o[0] / 3) + "," + (a[1] - 2 * o[1] / 3) + "," + a[0] + "," + a[1], i = t1[1], l = 2), e1.length > 1) {
                            s = e1[1], a = t1[l], l++, n += "C" + (i[0] + o[0]) + "," + (i[1] + o[1]) + "," + (a[0] - s[0]) + "," + (a[1] - s[1]) + "," + a[0] + "," + a[1];
                            for(var c = 2; c < e1.length; c++, l++)a = t1[l], s = e1[c], n += "S" + (a[0] - s[0]) + "," + (a[1] - s[1]) + "," + a[0] + "," + a[1];
                        }
                        if (r) {
                            var u = t1[l];
                            n += "Q" + (a[0] + 2 * s[0] / 3) + "," + (a[1] + 2 * s[1] / 3) + "," + u[0] + "," + u[1];
                        }
                        return n;
                    }
                    function di(t1, e1) {
                        for(var r, n = [], i = (1 - e1) / 2, a = t1[0], o = t1[1], s = 1, l = t1.length; ++s < l;)r = a, a = o, o = t1[s], n.push([
                            i * (o[0] - r[0]),
                            i * (o[1] - r[1])
                        ]);
                        return n;
                    }
                    function mi(t1) {
                        if (t1.length < 3) return ci(t1);
                        var e1 = 1, r = t1.length, n = t1[0], i = n[0], a = n[1], o = [
                            i,
                            i,
                            i,
                            (n = t1[1])[0]
                        ], s = [
                            a,
                            a,
                            a,
                            n[1]
                        ], l = [
                            i,
                            ",",
                            a,
                            "L",
                            gi(xi, o),
                            ",",
                            gi(xi, s)
                        ];
                        for(t1.push(t1[r - 1]); ++e1 <= r;)n = t1[e1], o.shift(), o.push(n[0]), s.shift(), s.push(n[1]), bi(l, o, s);
                        return t1.pop(), l.push("L", n), l.join("");
                    }
                    function gi(t1, e1) {
                        return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2] + t1[3] * e1[3];
                    }
                    li.forEach(function(t1, e1) {
                        e1.key = t1, e1.closed = /-closed$/.test(t1);
                    });
                    var vi = [
                        0,
                        2 / 3,
                        1 / 3,
                        0
                    ], yi = [
                        0,
                        1 / 3,
                        2 / 3,
                        0
                    ], xi = [
                        0,
                        1 / 6,
                        2 / 3,
                        1 / 6
                    ];
                    function bi(t1, e1, r) {
                        t1.push("C", gi(vi, e1), ",", gi(vi, r), ",", gi(yi, e1), ",", gi(yi, r), ",", gi(xi, e1), ",", gi(xi, r));
                    }
                    function _i(t1, e1) {
                        return (e1[1] - t1[1]) / (e1[0] - t1[0]);
                    }
                    function wi(t1) {
                        for(var e1, r, n, i = -1, a = t1.length; ++i < a;)r = (e1 = t1[i])[0], n = e1[1] - Et, e1[0] = r * Math.cos(n), e1[1] = r * Math.sin(n);
                        return t1;
                    }
                    function Ti(t1) {
                        var e1 = _e, r = _e, n = 0, i = we, a = oi, o = ci, s = o.key, l = o, c = "L", u = .7;
                        function f(s) {
                            var f, h, p, d = [], m = [], g = [], v = -1, y = s.length, x = ce(e1), b = ce(n), _ = e1 === r ? function() {
                                return h;
                            } : ce(r), w = n === i ? function() {
                                return p;
                            } : ce(i);
                            function T() {
                                d.push("M", o(t1(g), u), c, l(t1(m.reverse()), u), "Z");
                            }
                            for(; ++v < y;)a.call(this, f = s[v], v) ? (m.push([
                                h = +x.call(this, f, v),
                                p = +b.call(this, f, v)
                            ]), g.push([
                                +_.call(this, f, v),
                                +w.call(this, f, v)
                            ])) : m.length && (T(), m = [], g = []);
                            return m.length && T(), d.length ? d.join("") : null;
                        }
                        return f.x = function(t1) {
                            return arguments.length ? (e1 = r = t1, f) : r;
                        }, f.x0 = function(t1) {
                            return arguments.length ? (e1 = t1, f) : e1;
                        }, f.x1 = function(t1) {
                            return arguments.length ? (r = t1, f) : r;
                        }, f.y = function(t1) {
                            return arguments.length ? (n = i = t1, f) : i;
                        }, f.y0 = function(t1) {
                            return arguments.length ? (n = t1, f) : n;
                        }, f.y1 = function(t1) {
                            return arguments.length ? (i = t1, f) : i;
                        }, f.defined = function(t1) {
                            return arguments.length ? (a = t1, f) : a;
                        }, f.interpolate = function(t1) {
                            return arguments.length ? (s = "function" == typeof t1 ? o = t1 : (o = li.get(t1) || ci).key, l = o.reverse || o, c = o.closed ? "M" : "L", f) : s;
                        }, f.tension = function(t1) {
                            return arguments.length ? (u = t1, f) : u;
                        }, f;
                    }
                    function ki(t1) {
                        return t1.source;
                    }
                    function Ai(t1) {
                        return t1.target;
                    }
                    function Mi(t1) {
                        return t1.radius;
                    }
                    function Si(t1) {
                        return [
                            t1.x,
                            t1.y
                        ];
                    }
                    function Ei(t1) {
                        return function() {
                            var e1 = t1.apply(this, arguments), r = e1[0], n = e1[1] - Et;
                            return [
                                r * Math.cos(n),
                                r * Math.sin(n)
                            ];
                        };
                    }
                    function Li() {
                        return 64;
                    }
                    function Ci() {
                        return "circle";
                    }
                    function Pi(t1) {
                        var e1 = Math.sqrt(t1 / At);
                        return "M0," + e1 + "A" + e1 + "," + e1 + " 0 1,1 0," + -e1 + "A" + e1 + "," + e1 + " 0 1,1 0," + e1 + "Z";
                    }
                    t1.svg.line.radial = function() {
                        var t1 = si(wi);
                        return t1.radius = t1.x, delete t1.x, t1.angle = t1.y, delete t1.y, t1;
                    }, fi.reverse = hi, hi.reverse = fi, t1.svg.area = function() {
                        return Ti(C);
                    }, t1.svg.area.radial = function() {
                        var t1 = Ti(wi);
                        return t1.radius = t1.x, delete t1.x, t1.innerRadius = t1.x0, delete t1.x0, t1.outerRadius = t1.x1, delete t1.x1, t1.angle = t1.y, delete t1.y, t1.startAngle = t1.y0, delete t1.y0, t1.endAngle = t1.y1, delete t1.y1, t1;
                    }, t1.svg.chord = function() {
                        var t1 = ki, e1 = Ai, r = Mi, n = ei, i = ri;
                        function a(r, n) {
                            var i, a, c = o(this, t1, r, n), u = o(this, e1, r, n);
                            return "M" + c.p0 + s(c.r, c.p1, c.a1 - c.a0) + (a = u, ((i = c).a0 == a.a0 && i.a1 == a.a1 ? l(c.r, c.p1, c.r, c.p0) : l(c.r, c.p1, u.r, u.p0) + s(u.r, u.p1, u.a1 - u.a0) + l(u.r, u.p1, c.r, c.p0)) + "Z");
                        }
                        function o(t1, e1, a, o) {
                            var s = e1.call(t1, a, o), l = r.call(t1, s, o), c = n.call(t1, s, o) - Et, u = i.call(t1, s, o) - Et;
                            return {
                                r: l,
                                a0: c,
                                a1: u,
                                p0: [
                                    l * Math.cos(c),
                                    l * Math.sin(c)
                                ],
                                p1: [
                                    l * Math.cos(u),
                                    l * Math.sin(u)
                                ]
                            };
                        }
                        function s(t1, e1, r) {
                            return "A" + t1 + "," + t1 + " 0 " + +(r > At) + ",1 " + e1;
                        }
                        function l(t1, e1, r, n) {
                            return "Q 0,0 " + n;
                        }
                        return a.radius = function(t1) {
                            return arguments.length ? (r = ce(t1), a) : r;
                        }, a.source = function(e1) {
                            return arguments.length ? (t1 = ce(e1), a) : t1;
                        }, a.target = function(t1) {
                            return arguments.length ? (e1 = ce(t1), a) : e1;
                        }, a.startAngle = function(t1) {
                            return arguments.length ? (n = ce(t1), a) : n;
                        }, a.endAngle = function(t1) {
                            return arguments.length ? (i = ce(t1), a) : i;
                        }, a;
                    }, t1.svg.diagonal = function() {
                        var t1 = ki, e1 = Ai, r = Si;
                        function n(n, i) {
                            var a = t1.call(this, n, i), o = e1.call(this, n, i), s = (a.y + o.y) / 2, l = [
                                a,
                                {
                                    x: a.x,
                                    y: s
                                },
                                {
                                    x: o.x,
                                    y: s
                                },
                                o
                            ];
                            return "M" + (l = l.map(r))[0] + "C" + l[1] + " " + l[2] + " " + l[3];
                        }
                        return n.source = function(e1) {
                            return arguments.length ? (t1 = ce(e1), n) : t1;
                        }, n.target = function(t1) {
                            return arguments.length ? (e1 = ce(t1), n) : e1;
                        }, n.projection = function(t1) {
                            return arguments.length ? (r = t1, n) : r;
                        }, n;
                    }, t1.svg.diagonal.radial = function() {
                        var e1 = t1.svg.diagonal(), r = Si, n = e1.projection;
                        return e1.projection = function(t1) {
                            return arguments.length ? n(Ei(r = t1)) : r;
                        }, e1;
                    }, t1.svg.symbol = function() {
                        var t1 = Ci, e1 = Li;
                        function r(r, n) {
                            return (Ii.get(t1.call(this, r, n)) || Pi)(e1.call(this, r, n));
                        }
                        return r.type = function(e1) {
                            return arguments.length ? (t1 = ce(e1), r) : t1;
                        }, r.size = function(t1) {
                            return arguments.length ? (e1 = ce(t1), r) : e1;
                        }, r;
                    };
                    var Ii = t1.map({
                        circle: Pi,
                        cross: function(t1) {
                            var e1 = Math.sqrt(t1 / 5) / 2;
                            return "M" + -3 * e1 + "," + -e1 + "H" + -e1 + "V" + -3 * e1 + "H" + e1 + "V" + -e1 + "H" + 3 * e1 + "V" + e1 + "H" + e1 + "V" + 3 * e1 + "H" + -e1 + "V" + e1 + "H" + -3 * e1 + "Z";
                        },
                        diamond: function(t1) {
                            var e1 = Math.sqrt(t1 / (2 * zi)), r = e1 * zi;
                            return "M0," + -e1 + "L" + r + ",0 0," + e1 + " " + -r + ",0Z";
                        },
                        square: function(t1) {
                            var e1 = Math.sqrt(t1) / 2;
                            return "M" + -e1 + "," + -e1 + "L" + e1 + "," + -e1 + " " + e1 + "," + e1 + " " + -e1 + "," + e1 + "Z";
                        },
                        "triangle-down": function(t1) {
                            var e1 = Math.sqrt(t1 / Oi), r = e1 * Oi / 2;
                            return "M0," + r + "L" + e1 + "," + -r + " " + -e1 + "," + -r + "Z";
                        },
                        "triangle-up": function(t1) {
                            var e1 = Math.sqrt(t1 / Oi), r = e1 * Oi / 2;
                            return "M0," + -r + "L" + e1 + "," + r + " " + -e1 + "," + r + "Z";
                        }
                    });
                    t1.svg.symbolTypes = Ii.keys();
                    var Oi = Math.sqrt(3), zi = Math.tan(30 * Lt);
                    Y.transition = function(t1) {
                        for(var e1, r, n = Bi || ++Ui, i = qi(t1), a = [], o = Ni || {
                            time: Date.now(),
                            ease: Er,
                            delay: 0,
                            duration: 250
                        }, s = -1, l = this.length; ++s < l;){
                            a.push(e1 = []);
                            for(var c = this[s], u = -1, f = c.length; ++u < f;)(r = c[u]) && Gi(r, u, i, n, o), e1.push(r);
                        }
                        return Fi(a, i, n);
                    }, Y.interrupt = function(t1) {
                        return this.each(null == t1 ? Di : Ri(qi(t1)));
                    };
                    var Di = Ri(qi());
                    function Ri(t1) {
                        return function() {
                            var e1, r, n;
                            (e1 = this[t1]) && (n = e1[r = e1.active]) && (n.timer.c = null, n.timer.t = NaN, --e1.count ? delete e1[r] : delete this[t1], e1.active += .5, n.event && n.event.interrupt.call(this, this.__data__, n.index));
                        };
                    }
                    function Fi(t1, e1, r) {
                        return U(t1, ji), t1.namespace = e1, t1.id = r, t1;
                    }
                    var Bi, Ni, ji = [], Ui = 0;
                    function Vi(t1, e1, r, n) {
                        var i = t1.id, a = t1.namespace;
                        return ut(t1, "function" == typeof r ? function(t1, o, s) {
                            t1[a][i].tween.set(e1, n(r.call(t1, t1.__data__, o, s)));
                        } : (r = n(r), function(t1) {
                            t1[a][i].tween.set(e1, r);
                        }));
                    }
                    function Hi(t1) {
                        return null == t1 && (t1 = ""), function() {
                            this.textContent = t1;
                        };
                    }
                    function qi(t1) {
                        return null == t1 ? "__transition__" : "__transition_" + t1 + "__";
                    }
                    function Gi(t1, e1, r, n, i) {
                        var a, o, s, l, c, u = t1[r] || (t1[r] = {
                            active: 0,
                            count: 0
                        }), f = u[n];
                        function h(r) {
                            var i = u.active, h = u[i];
                            for(var d in h && (h.timer.c = null, h.timer.t = NaN, --u.count, delete u[i], h.event && h.event.interrupt.call(t1, t1.__data__, h.index)), u)if (+d < n) {
                                var m = u[d];
                                m.timer.c = null, m.timer.t = NaN, --u.count, delete u[d];
                            }
                            o.c = p, ve(function() {
                                return o.c && p(r || 1) && (o.c = null, o.t = NaN), 1;
                            }, 0, a), u.active = n, f.event && f.event.start.call(t1, t1.__data__, e1), c = [], f.tween.forEach(function(r, n) {
                                (n = n.call(t1, t1.__data__, e1)) && c.push(n);
                            }), l = f.ease, s = f.duration;
                        }
                        function p(i) {
                            for(var a = i / s, o = l(a), h = c.length; h > 0;)c[--h].call(t1, o);
                            if (a >= 1) return f.event && f.event.end.call(t1, t1.__data__, e1), --u.count ? delete u[n] : delete t1[r], 1;
                        }
                        f || (a = i.time, o = ve(function(t1) {
                            var e1 = f.delay;
                            if (o.t = e1 + a, e1 <= t1) return h(t1 - e1);
                            o.c = h;
                        }, 0, a), f = u[n] = {
                            tween: new _,
                            time: a,
                            timer: o,
                            delay: i.delay,
                            duration: i.duration,
                            ease: i.ease,
                            index: e1
                        }, i = null, ++u.count);
                    }
                    ji.call = Y.call, ji.empty = Y.empty, ji.node = Y.node, ji.size = Y.size, t1.transition = function(e1, r) {
                        return e1 && e1.transition ? Bi ? e1.transition(r) : e1 : t1.selection().transition(e1);
                    }, t1.transition.prototype = ji, ji.select = function(t1) {
                        var e1, r, n, i = this.id, a = this.namespace, o = [];
                        t1 = W(t1);
                        for(var s = -1, l = this.length; ++s < l;){
                            o.push(e1 = []);
                            for(var c = this[s], u = -1, f = c.length; ++u < f;)(n = c[u]) && (r = t1.call(n, n.__data__, u, s)) ? ("__data__" in n && (r.__data__ = n.__data__), Gi(r, u, a, i, n[a][i]), e1.push(r)) : e1.push(null);
                        }
                        return Fi(o, a, i);
                    }, ji.selectAll = function(t1) {
                        var e1, r, n, i, a, o = this.id, s = this.namespace, l = [];
                        t1 = X(t1);
                        for(var c = -1, u = this.length; ++c < u;)for(var f = this[c], h = -1, p = f.length; ++h < p;)if (n = f[h]) {
                            a = n[s][o], r = t1.call(n, n.__data__, h, c), l.push(e1 = []);
                            for(var d = -1, m = r.length; ++d < m;)(i = r[d]) && Gi(i, d, s, o, a), e1.push(i);
                        }
                        return Fi(l, s, o);
                    }, ji.filter = function(t1) {
                        var e1, r, n = [];
                        "function" != typeof t1 && (t1 = lt(t1));
                        for(var i = 0, a = this.length; i < a; i++){
                            n.push(e1 = []);
                            for(var o, s = 0, l = (o = this[i]).length; s < l; s++)(r = o[s]) && t1.call(r, r.__data__, s, i) && e1.push(r);
                        }
                        return Fi(n, this.namespace, this.id);
                    }, ji.tween = function(t1, e1) {
                        var r = this.id, n = this.namespace;
                        return arguments.length < 2 ? this.node()[n][r].tween.get(t1) : ut(this, null == e1 ? function(e1) {
                            e1[n][r].tween.remove(t1);
                        } : function(i) {
                            i[n][r].tween.set(t1, e1);
                        });
                    }, ji.attr = function(e1, r) {
                        if (arguments.length < 2) {
                            for(r in e1)this.attr(r, e1[r]);
                            return this;
                        }
                        var n = "transform" == e1 ? Nr : yr, i = t1.ns.qualify(e1);
                        function a() {
                            this.removeAttribute(i);
                        }
                        function o() {
                            this.removeAttributeNS(i.space, i.local);
                        }
                        function s(t1) {
                            return null == t1 ? a : (t1 += "", function() {
                                var e1, r = this.getAttribute(i);
                                return r !== t1 && (e1 = n(r, t1), function(t1) {
                                    this.setAttribute(i, e1(t1));
                                });
                            });
                        }
                        function l(t1) {
                            return null == t1 ? o : (t1 += "", function() {
                                var e1, r = this.getAttributeNS(i.space, i.local);
                                return r !== t1 && (e1 = n(r, t1), function(t1) {
                                    this.setAttributeNS(i.space, i.local, e1(t1));
                                });
                            });
                        }
                        return Vi(this, "attr." + e1, r, i.local ? l : s);
                    }, ji.attrTween = function(e1, r) {
                        var n = t1.ns.qualify(e1);
                        return this.tween("attr." + e1, n.local ? function(t1, e1) {
                            var i = r.call(this, t1, e1, this.getAttributeNS(n.space, n.local));
                            return i && function(t1) {
                                this.setAttributeNS(n.space, n.local, i(t1));
                            };
                        } : function(t1, e1) {
                            var i = r.call(this, t1, e1, this.getAttribute(n));
                            return i && function(t1) {
                                this.setAttribute(n, i(t1));
                            };
                        });
                    }, ji.style = function(t1, e1, r) {
                        var n = arguments.length;
                        if (n < 3) {
                            if ("string" != typeof t1) {
                                for(r in n < 2 && (e1 = ""), t1)this.style(r, t1[r], e1);
                                return this;
                            }
                            r = "";
                        }
                        function i() {
                            this.style.removeProperty(t1);
                        }
                        function a(e1) {
                            return null == e1 ? i : (e1 += "", function() {
                                var n, i = o(this).getComputedStyle(this, null).getPropertyValue(t1);
                                return i !== e1 && (n = yr(i, e1), function(e1) {
                                    this.style.setProperty(t1, n(e1), r);
                                });
                            });
                        }
                        return Vi(this, "style." + t1, e1, a);
                    }, ji.styleTween = function(t1, e1, r) {
                        function n(n, i) {
                            var a = e1.call(this, n, i, o(this).getComputedStyle(this, null).getPropertyValue(t1));
                            return a && function(e1) {
                                this.style.setProperty(t1, a(e1), r);
                            };
                        }
                        return arguments.length < 3 && (r = ""), this.tween("style." + t1, n);
                    }, ji.text = function(t1) {
                        return Vi(this, "text", t1, Hi);
                    }, ji.remove = function() {
                        var t1 = this.namespace;
                        return this.each("end.transition", function() {
                            var e1;
                            this[t1].count < 2 && (e1 = this.parentNode) && e1.removeChild(this);
                        });
                    }, ji.ease = function(e1) {
                        var r = this.id, n = this.namespace;
                        return arguments.length < 1 ? this.node()[n][r].ease : ("function" != typeof e1 && (e1 = t1.ease.apply(t1, arguments)), ut(this, function(t1) {
                            t1[n][r].ease = e1;
                        }));
                    }, ji.delay = function(t1) {
                        var e1 = this.id, r = this.namespace;
                        return arguments.length < 1 ? this.node()[r][e1].delay : ut(this, "function" == typeof t1 ? function(n, i, a) {
                            n[r][e1].delay = +t1.call(n, n.__data__, i, a);
                        } : (t1 = +t1, function(n) {
                            n[r][e1].delay = t1;
                        }));
                    }, ji.duration = function(t1) {
                        var e1 = this.id, r = this.namespace;
                        return arguments.length < 1 ? this.node()[r][e1].duration : ut(this, "function" == typeof t1 ? function(n, i, a) {
                            n[r][e1].duration = Math.max(1, t1.call(n, n.__data__, i, a));
                        } : (t1 = Math.max(1, t1), function(n) {
                            n[r][e1].duration = t1;
                        }));
                    }, ji.each = function(e1, r) {
                        var n = this.id, i = this.namespace;
                        if (arguments.length < 2) {
                            var a = Ni, o = Bi;
                            try {
                                Bi = n, ut(this, function(t1, r, a) {
                                    Ni = t1[i][n], e1.call(t1, t1.__data__, r, a);
                                });
                            } finally{
                                Ni = a, Bi = o;
                            }
                        } else ut(this, function(a) {
                            var o = a[i][n];
                            (o.event || (o.event = t1.dispatch("start", "end", "interrupt"))).on(e1, r);
                        });
                        return this;
                    }, ji.transition = function() {
                        for(var t1, e1, r, n = this.id, i = ++Ui, a = this.namespace, o = [], s = 0, l = this.length; s < l; s++){
                            o.push(t1 = []);
                            for(var c, u = 0, f = (c = this[s]).length; u < f; u++)(e1 = c[u]) && Gi(e1, u, a, i, {
                                time: (r = e1[a][n]).time,
                                ease: r.ease,
                                delay: r.delay + r.duration,
                                duration: r.duration
                            }), t1.push(e1);
                        }
                        return Fi(o, a, i);
                    }, t1.svg.axis = function() {
                        var e1, r = t1.scale.linear(), i = Yi, a = 6, o = 6, s = 3, l = [
                            10
                        ], c = null;
                        function u(n) {
                            n.each(function() {
                                var n, u = t1.select(this), f = this.__chart__ || r, h = this.__chart__ = r.copy(), p = null == c ? h.ticks ? h.ticks.apply(h, l) : h.domain() : c, d = null == e1 ? h.tickFormat ? h.tickFormat.apply(h, l) : C : e1, m = u.selectAll(".tick").data(p, h), g = m.enter().insert("g", ".domain").attr("class", "tick").style("opacity", kt), v = t1.transition(m.exit()).style("opacity", kt).remove(), y = t1.transition(m.order()).style("opacity", 1), x = Math.max(a, 0) + s, b = Dn(h), _ = u.selectAll(".domain").data([
                                    0
                                ]), w = (_.enter().append("path").attr("class", "domain"), t1.transition(_));
                                g.append("line"), g.append("text");
                                var T, k, A, M, S = g.select("line"), E = y.select("line"), L = m.select("text").text(d), P = g.select("text"), I = y.select("text"), O = "top" === i || "left" === i ? -1 : 1;
                                if ("bottom" === i || "top" === i ? (n = Xi, T = "x", A = "y", k = "x2", M = "y2", L.attr("dy", O < 0 ? "0em" : ".71em").style("text-anchor", "middle"), w.attr("d", "M" + b[0] + "," + O * o + "V0H" + b[1] + "V" + O * o)) : (n = Zi, T = "y", A = "x", k = "y2", M = "x2", L.attr("dy", ".32em").style("text-anchor", O < 0 ? "end" : "start"), w.attr("d", "M" + O * o + "," + b[0] + "H0V" + b[1] + "H" + O * o)), S.attr(M, O * a), P.attr(A, O * x), E.attr(k, 0).attr(M, O * a), I.attr(T, 0).attr(A, O * x), h.rangeBand) {
                                    var z = h, D = z.rangeBand() / 2;
                                    f = h = function(t1) {
                                        return z(t1) + D;
                                    };
                                } else f.rangeBand ? f = h : v.call(n, h, f);
                                g.call(n, f, h), y.call(n, h, h);
                            });
                        }
                        return u.scale = function(t1) {
                            return arguments.length ? (r = t1, u) : r;
                        }, u.orient = function(t1) {
                            return arguments.length ? (i = t1 in Wi ? t1 + "" : Yi, u) : i;
                        }, u.ticks = function() {
                            return arguments.length ? (l = n(arguments), u) : l;
                        }, u.tickValues = function(t1) {
                            return arguments.length ? (c = t1, u) : c;
                        }, u.tickFormat = function(t1) {
                            return arguments.length ? (e1 = t1, u) : e1;
                        }, u.tickSize = function(t1) {
                            var e1 = arguments.length;
                            return e1 ? (a = +t1, o = +arguments[e1 - 1], u) : a;
                        }, u.innerTickSize = function(t1) {
                            return arguments.length ? (a = +t1, u) : a;
                        }, u.outerTickSize = function(t1) {
                            return arguments.length ? (o = +t1, u) : o;
                        }, u.tickPadding = function(t1) {
                            return arguments.length ? (s = +t1, u) : s;
                        }, u.tickSubdivide = function() {
                            return arguments.length && u;
                        }, u;
                    };
                    var Yi = "bottom", Wi = {
                        top: 1,
                        right: 1,
                        bottom: 1,
                        left: 1
                    };
                    function Xi(t1, e1, r) {
                        t1.attr("transform", function(t1) {
                            var n = e1(t1);
                            return "translate(" + (isFinite(n) ? n : r(t1)) + ",0)";
                        });
                    }
                    function Zi(t1, e1, r) {
                        t1.attr("transform", function(t1) {
                            var n = e1(t1);
                            return "translate(0," + (isFinite(n) ? n : r(t1)) + ")";
                        });
                    }
                    t1.svg.brush = function() {
                        var e1, r, n = N(h, "brushstart", "brush", "brushend"), i = null, a = null, s = [
                            0,
                            0
                        ], l = [
                            0,
                            0
                        ], c = !0, u = !0, f = Ki[0];
                        function h(e1) {
                            e1.each(function() {
                                var e1 = t1.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", g).on("touchstart.brush", g), r = e1.selectAll(".background").data([
                                    0
                                ]);
                                r.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair"), e1.selectAll(".extent").data([
                                    0
                                ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
                                var n = e1.selectAll(".resize").data(f, C);
                                n.exit().remove(), n.enter().append("g").attr("class", function(t1) {
                                    return "resize " + t1;
                                }).style("cursor", function(t1) {
                                    return Ji[t1];
                                }).append("rect").attr("x", function(t1) {
                                    return /[ew]$/.test(t1) ? -3 : null;
                                }).attr("y", function(t1) {
                                    return /^[ns]/.test(t1) ? -3 : null;
                                }).attr("width", 6).attr("height", 6).style("visibility", "hidden"), n.style("display", h.empty() ? "none" : null);
                                var o, s = t1.transition(e1), l = t1.transition(r);
                                i && (o = Dn(i), l.attr("x", o[0]).attr("width", o[1] - o[0]), d(s)), a && (o = Dn(a), l.attr("y", o[0]).attr("height", o[1] - o[0]), m(s)), p(s);
                            });
                        }
                        function p(t1) {
                            t1.selectAll(".resize").attr("transform", function(t1) {
                                return "translate(" + s[+/e$/.test(t1)] + "," + l[+/^s/.test(t1)] + ")";
                            });
                        }
                        function d(t1) {
                            t1.select(".extent").attr("x", s[0]), t1.selectAll(".extent,.n>rect,.s>rect").attr("width", s[1] - s[0]);
                        }
                        function m(t1) {
                            t1.select(".extent").attr("y", l[0]), t1.selectAll(".extent,.e>rect,.w>rect").attr("height", l[1] - l[0]);
                        }
                        function g() {
                            var f, g, v = this, y = t1.select(t1.event.target), x = n.of(v, arguments), b = t1.select(v), _ = y.datum(), w = !/^(n|s)$/.test(_) && i, T = !/^(e|w)$/.test(_) && a, k = y.classed("extent"), A = bt(v), M = t1.mouse(v), S = t1.select(o(v)).on("keydown.brush", C).on("keyup.brush", P);
                            if (t1.event.changedTouches ? S.on("touchmove.brush", I).on("touchend.brush", z) : S.on("mousemove.brush", I).on("mouseup.brush", z), b.interrupt().selectAll("*").interrupt(), k) M[0] = s[0] - M[0], M[1] = l[0] - M[1];
                            else if (_) {
                                var E = +/w$/.test(_), L = +/^n/.test(_);
                                g = [
                                    s[1 - E] - M[0],
                                    l[1 - L] - M[1]
                                ], M[0] = s[E], M[1] = l[L];
                            } else t1.event.altKey && (f = M.slice());
                            function C() {
                                32 == t1.event.keyCode && (k || (f = null, M[0] -= s[1], M[1] -= l[1], k = 2), F());
                            }
                            function P() {
                                32 == t1.event.keyCode && 2 == k && (M[0] += s[1], M[1] += l[1], k = 0, F());
                            }
                            function I() {
                                var e1 = t1.mouse(v), r = !1;
                                g && (e1[0] += g[0], e1[1] += g[1]), k || (t1.event.altKey ? (f || (f = [
                                    (s[0] + s[1]) / 2,
                                    (l[0] + l[1]) / 2
                                ]), M[0] = s[+(e1[0] < f[0])], M[1] = l[+(e1[1] < f[1])]) : f = null), w && O(e1, i, 0) && (d(b), r = !0), T && O(e1, a, 1) && (m(b), r = !0), r && (p(b), x({
                                    type: "brush",
                                    mode: k ? "move" : "resize"
                                }));
                            }
                            function O(t1, n, i) {
                                var a, o, h = Dn(n), p = h[0], d = h[1], m = M[i], g = i ? l : s, v = g[1] - g[0];
                                if (k && (p -= m, d -= v + m), a = (i ? u : c) ? Math.max(p, Math.min(d, t1[i])) : t1[i], k ? o = (a += m) + v : (f && (m = Math.max(p, Math.min(d, 2 * f[i] - a))), m < a ? (o = a, a = m) : o = m), g[0] != a || g[1] != o) return i ? r = null : e1 = null, g[0] = a, g[1] = o, !0;
                            }
                            function z() {
                                I(), b.style("pointer-events", "all").selectAll(".resize").style("display", h.empty() ? "none" : null), t1.select("body").style("cursor", null), S.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null), A(), x({
                                    type: "brushend"
                                });
                            }
                            b.style("pointer-events", "none").selectAll(".resize").style("display", null), t1.select("body").style("cursor", y.style("cursor")), x({
                                type: "brushstart"
                            }), I();
                        }
                        return h.event = function(i) {
                            i.each(function() {
                                var i = n.of(this, arguments), a = {
                                    x: s,
                                    y: l,
                                    i: e1,
                                    j: r
                                }, o = this.__chart__ || a;
                                this.__chart__ = a, Bi ? t1.select(this).transition().each("start.brush", function() {
                                    e1 = o.i, r = o.j, s = o.x, l = o.y, i({
                                        type: "brushstart"
                                    });
                                }).tween("brush:brush", function() {
                                    var t1 = xr(s, a.x), n = xr(l, a.y);
                                    return e1 = r = null, function(e1) {
                                        s = a.x = t1(e1), l = a.y = n(e1), i({
                                            type: "brush",
                                            mode: "resize"
                                        });
                                    };
                                }).each("end.brush", function() {
                                    e1 = a.i, r = a.j, i({
                                        type: "brush",
                                        mode: "resize"
                                    }), i({
                                        type: "brushend"
                                    });
                                }) : (i({
                                    type: "brushstart"
                                }), i({
                                    type: "brush",
                                    mode: "resize"
                                }), i({
                                    type: "brushend"
                                }));
                            });
                        }, h.x = function(t1) {
                            return arguments.length ? (f = Ki[!(i = t1) << 1 | !a], h) : i;
                        }, h.y = function(t1) {
                            return arguments.length ? (f = Ki[!i << 1 | !(a = t1)], h) : a;
                        }, h.clamp = function(t1) {
                            return arguments.length ? (i && a ? (c = !!t1[0], u = !!t1[1]) : i ? c = !!t1 : a && (u = !!t1), h) : i && a ? [
                                c,
                                u
                            ] : i ? c : a ? u : null;
                        }, h.extent = function(t1) {
                            var n, o, c, u, f;
                            return arguments.length ? (i && (n = t1[0], o = t1[1], a && (n = n[0], o = o[0]), e1 = [
                                n,
                                o
                            ], i.invert && (n = i(n), o = i(o)), o < n && (f = n, n = o, o = f), n == s[0] && o == s[1] || (s = [
                                n,
                                o
                            ])), a && (c = t1[0], u = t1[1], i && (c = c[1], u = u[1]), r = [
                                c,
                                u
                            ], a.invert && (c = a(c), u = a(u)), u < c && (f = c, c = u, u = f), c == l[0] && u == l[1] || (l = [
                                c,
                                u
                            ])), h) : (i && (e1 ? (n = e1[0], o = e1[1]) : (n = s[0], o = s[1], i.invert && (n = i.invert(n), o = i.invert(o)), o < n && (f = n, n = o, o = f))), a && (r ? (c = r[0], u = r[1]) : (c = l[0], u = l[1], a.invert && (c = a.invert(c), u = a.invert(u)), u < c && (f = c, c = u, u = f))), i && a ? [
                                [
                                    n,
                                    c
                                ],
                                [
                                    o,
                                    u
                                ]
                            ] : i ? [
                                n,
                                o
                            ] : a && [
                                c,
                                u
                            ]);
                        }, h.clear = function() {
                            return h.empty() || (s = [
                                0,
                                0
                            ], l = [
                                0,
                                0
                            ], e1 = r = null), h;
                        }, h.empty = function() {
                            return !!i && s[0] == s[1] || !!a && l[0] == l[1];
                        }, t1.rebind(h, n, "on");
                    };
                    var Ji = {
                        n: "ns-resize",
                        e: "ew-resize",
                        s: "ns-resize",
                        w: "ew-resize",
                        nw: "nwse-resize",
                        ne: "nesw-resize",
                        se: "nwse-resize",
                        sw: "nesw-resize"
                    }, Ki = [
                        [
                            "n",
                            "e",
                            "s",
                            "w",
                            "nw",
                            "ne",
                            "se",
                            "sw"
                        ],
                        [
                            "e",
                            "w"
                        ],
                        [
                            "n",
                            "s"
                        ],
                        []
                    ];
                    function Qi(t1) {
                        return JSON.parse(t1.responseText);
                    }
                    function $i(t1) {
                        var e1 = i.createRange();
                        return e1.selectNode(i.body), e1.createContextualFragment(t1.responseText);
                    }
                    t1.text = ue(function(t1) {
                        return t1.responseText;
                    }), t1.json = function(t1, e1) {
                        return fe(t1, "application/json", Qi, e1);
                    }, t1.html = function(t1, e1) {
                        return fe(t1, "text/html", $i, e1);
                    }, t1.xml = ue(function(t1) {
                        return t1.responseXML;
                    }), "object" == typeof e1 && e1.exports ? e1.exports = t1 : this.d3 = t1;
                }).apply(self);
            },
            {}
        ],
        59: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("./quad");
            },
            {
                "./quad": 60
            }
        ],
        60: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("binary-search-bounds"), i = t1("clamp"), a = t1("parse-rect"), o = t1("array-bounds"), s = t1("pick-by-alias"), l = t1("defined"), c = t1("flatten-vertex-data"), u = t1("is-obj"), f = t1("dtype"), h = t1("math-log2");
                function p(t1, e1) {
                    for(var r = e1[0], n = e1[1], a = 1 / (e1[2] - r), o = 1 / (e1[3] - n), s = new Array(t1.length), l = 0, c = t1.length / 2; l < c; l++)s[2 * l] = i((t1[2 * l] - r) * a, 0, 1), s[2 * l + 1] = i((t1[2 * l + 1] - n) * o, 0, 1);
                    return s;
                }
                e1.exports = function(t1, e1) {
                    e1 || (e1 = {}), t1 = c(t1, "float64"), e1 = s(e1, {
                        bounds: "range bounds dataBox databox",
                        maxDepth: "depth maxDepth maxdepth level maxLevel maxlevel levels",
                        dtype: "type dtype format out dst output destination"
                    });
                    var r = l(e1.maxDepth, 255), i = l(e1.bounds, o(t1, 2));
                    i[0] === i[2] && i[2]++, i[1] === i[3] && i[3]++;
                    var d, m = p(t1, i), g = t1.length >>> 1;
                    e1.dtype || (e1.dtype = "array"), "string" == typeof e1.dtype ? d = new (f(e1.dtype))(g) : e1.dtype && (d = e1.dtype, Array.isArray(d) && (d.length = g));
                    for(var v = 0; v < g; ++v)d[v] = v;
                    var y = [], x = [], b = [], _ = [];
                    !function t1(e1, n, i, a, o, s) {
                        if (!a.length) return null;
                        var l = y[o] || (y[o] = []), c = b[o] || (b[o] = []), u = x[o] || (x[o] = []), f = l.length;
                        if (++o > r || s > 1073741824) {
                            for(var h = 0; h < a.length; h++)l.push(a[h]), c.push(s), u.push(null, null, null, null);
                            return f;
                        }
                        if (l.push(a[0]), c.push(s), a.length <= 1) return u.push(null, null, null, null), f;
                        for(var p = .5 * i, d = e1 + p, g = n + p, v = [], _ = [], w = [], T = [], k = 1, A = a.length; k < A; k++){
                            var M = a[k], S = m[2 * M], E = m[2 * M + 1];
                            S < d ? E < g ? v.push(M) : _.push(M) : E < g ? w.push(M) : T.push(M);
                        }
                        return s <<= 2, u.push(t1(e1, n, p, v, o, s), t1(e1, g, p, _, o, s + 1), t1(d, n, p, w, o, s + 2), t1(d, g, p, T, o, s + 3)), f;
                    }(0, 0, 1, d, 0, 1);
                    for(var w = 0, T = 0; T < y.length; T++){
                        var k = y[T];
                        if (d.set) d.set(k, w);
                        else for(var A = 0, M = k.length; A < M; A++)d[A + w] = k[A];
                        var S = w + y[T].length;
                        _[T] = [
                            w,
                            S
                        ], w = S;
                    }
                    return d.range = function() {
                        var e1, r = [], n = arguments.length;
                        for(; n--;)r[n] = arguments[n];
                        if (u(r[r.length - 1])) {
                            var o = r.pop();
                            r.length || null == o.x && null == o.l && null == o.left || (r = [
                                o
                            ], e1 = {}), e1 = s(o, {
                                level: "level maxLevel",
                                d: "d diam diameter r radius px pxSize pixel pixelSize maxD size minSize",
                                lod: "lod details ranges offsets"
                            });
                        } else e1 = {};
                        r.length || (r = i);
                        var c = a.apply(void 0, r), f = [
                            Math.min(c.x, c.x + c.width),
                            Math.min(c.y, c.y + c.height),
                            Math.max(c.x, c.x + c.width),
                            Math.max(c.y, c.y + c.height)
                        ], d = f[0], m = f[1], g = f[2], v = f[3], b = p([
                            d,
                            m,
                            g,
                            v
                        ], i), _ = b[0], w = b[1], T = b[2], k = b[3], A = l(e1.level, y.length);
                        if (null != e1.d) {
                            var M;
                            "number" == typeof e1.d ? M = [
                                e1.d,
                                e1.d
                            ] : e1.d.length && (M = e1.d), A = Math.min(Math.max(Math.ceil(-h(Math.abs(M[0]) / (i[2] - i[0]))), Math.ceil(-h(Math.abs(M[1]) / (i[3] - i[1])))), A);
                        }
                        if (A = Math.min(A, y.length), e1.lod) return E(_, w, T, k, A);
                        var S = [];
                        function L(e1, r, n, i, a, o) {
                            if (null !== a && null !== o && !(_ > e1 + n || w > r + n || T < e1 || k < r || i >= A || a === o)) {
                                var s = y[i];
                                void 0 === o && (o = s.length);
                                for(var l = a; l < o; l++){
                                    var c = s[l], u = t1[2 * c], f = t1[2 * c + 1];
                                    u >= d && u <= g && f >= m && f <= v && S.push(c);
                                }
                                var h = x[i], p = h[4 * a + 0], b = h[4 * a + 1], M = h[4 * a + 2], E = h[4 * a + 3], P = C(h, a + 1), I = .5 * n, O = i + 1;
                                L(e1, r, I, O, p, b || M || E || P), L(e1, r + I, I, O, b, M || E || P), L(e1 + I, r, I, O, M, E || P), L(e1 + I, r + I, I, O, E, P);
                            }
                        }
                        function C(t1, e1) {
                            for(var r = null, n = 0; null === r;)if (r = t1[4 * e1 + n], ++n > t1.length) return null;
                            return r;
                        }
                        return L(0, 0, 1, 0, 0, 1), S;
                    }, d;
                    function E(t1, e1, r, i, a) {
                        for(var o = [], s = 0; s < a; s++){
                            var l = b[s], c = _[s][0], u = L(t1, e1, s), f = L(r, i, s), h = n.ge(l, u), p = n.gt(l, f, h, l.length - 1);
                            o[s] = [
                                h + c,
                                p + c
                            ];
                        }
                        return o;
                    }
                    function L(t1, e1, r) {
                        for(var n = 1, i = .5, a = .5, o = .5, s = 0; s < r; s++)n <<= 2, n += t1 < i ? e1 < a ? 0 : 1 : e1 < a ? 2 : 3, o *= .5, i += t1 < i ? -o : o, a += e1 < a ? -o : o;
                        return n;
                    }
                };
            },
            {
                "array-bounds": 71,
                "binary-search-bounds": 80,
                clamp: 86,
                defined: 124,
                dtype: 127,
                "flatten-vertex-data": 191,
                "is-obj": 235,
                "math-log2": 240,
                "parse-rect": 249,
                "pick-by-alias": 253
            }
        ],
        61: [
            function(t1, e1, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
                var n = t1("@turf/meta");
                function i(t1) {
                    var e1 = 0;
                    if (t1 && t1.length > 0) {
                        e1 += Math.abs(a(t1[0]));
                        for(var r = 1; r < t1.length; r++)e1 -= Math.abs(a(t1[r]));
                    }
                    return e1;
                }
                function a(t1) {
                    var e1, r, n, i, a, s, l = 0, c = t1.length;
                    if (c > 2) {
                        for(s = 0; s < c; s++)s === c - 2 ? (n = c - 2, i = c - 1, a = 0) : s === c - 1 ? (n = c - 1, i = 0, a = 1) : (n = s, i = s + 1, a = s + 2), e1 = t1[n], r = t1[i], l += (o(t1[a][0]) - o(e1[0])) * Math.sin(o(r[1]));
                        l = 6378137 * l * 6378137 / 2;
                    }
                    return l;
                }
                function o(t1) {
                    return t1 * Math.PI / 180;
                }
                r.default = function(t1) {
                    return n.geomReduce(t1, function(t1, e1) {
                        return t1 + function(t1) {
                            var e1, r = 0;
                            switch(t1.type){
                                case "Polygon":
                                    return i(t1.coordinates);
                                case "MultiPolygon":
                                    for(e1 = 0; e1 < t1.coordinates.length; e1++)r += i(t1.coordinates[e1]);
                                    return r;
                                case "Point":
                                case "MultiPoint":
                                case "LineString":
                                case "MultiLineString":
                                    return 0;
                            }
                            return 0;
                        }(e1);
                    }, 0);
                };
            },
            {
                "@turf/meta": 63
            }
        ],
        62: [
            function(t1, e1, r) {
                "use strict";
                function n(t1, e1, r) {
                    void 0 === r && (r = {});
                    var n = {
                        type: "Feature"
                    };
                    return (0 === r.id || r.id) && (n.id = r.id), r.bbox && (n.bbox = r.bbox), n.properties = e1 || {}, n.geometry = t1, n;
                }
                function i(t1, e1, r) {
                    if (void 0 === r && (r = {}), !t1) throw new Error("coordinates is required");
                    if (!Array.isArray(t1)) throw new Error("coordinates must be an Array");
                    if (t1.length < 2) throw new Error("coordinates must be at least 2 numbers long");
                    if (!d(t1[0]) || !d(t1[1])) throw new Error("coordinates must contain numbers");
                    return n({
                        type: "Point",
                        coordinates: t1
                    }, e1, r);
                }
                function a(t1, e1, r) {
                    void 0 === r && (r = {});
                    for(var i = 0, a = t1; i < a.length; i++){
                        var o = a[i];
                        if (o.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
                        for(var s = 0; s < o[o.length - 1].length; s++)if (o[o.length - 1][s] !== o[0][s]) throw new Error("First and last Position are not equivalent.");
                    }
                    return n({
                        type: "Polygon",
                        coordinates: t1
                    }, e1, r);
                }
                function o(t1, e1, r) {
                    if (void 0 === r && (r = {}), t1.length < 2) throw new Error("coordinates must be an array of two or more positions");
                    return n({
                        type: "LineString",
                        coordinates: t1
                    }, e1, r);
                }
                function s(t1, e1) {
                    void 0 === e1 && (e1 = {});
                    var r = {
                        type: "FeatureCollection"
                    };
                    return e1.id && (r.id = e1.id), e1.bbox && (r.bbox = e1.bbox), r.features = t1, r;
                }
                function l(t1, e1, r) {
                    return void 0 === r && (r = {}), n({
                        type: "MultiLineString",
                        coordinates: t1
                    }, e1, r);
                }
                function c(t1, e1, r) {
                    return void 0 === r && (r = {}), n({
                        type: "MultiPoint",
                        coordinates: t1
                    }, e1, r);
                }
                function u(t1, e1, r) {
                    return void 0 === r && (r = {}), n({
                        type: "MultiPolygon",
                        coordinates: t1
                    }, e1, r);
                }
                function f(t1, e1) {
                    void 0 === e1 && (e1 = "kilometers");
                    var n = r.factors[e1];
                    if (!n) throw new Error(e1 + " units is invalid");
                    return t1 * n;
                }
                function h(t1, e1) {
                    void 0 === e1 && (e1 = "kilometers");
                    var n = r.factors[e1];
                    if (!n) throw new Error(e1 + " units is invalid");
                    return t1 / n;
                }
                function p(t1) {
                    return 180 * (t1 % (2 * Math.PI)) / Math.PI;
                }
                function d(t1) {
                    return !isNaN(t1) && null !== t1 && !Array.isArray(t1);
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.earthRadius = 6371008.8, r.factors = {
                    centimeters: 100 * r.earthRadius,
                    centimetres: 100 * r.earthRadius,
                    degrees: r.earthRadius / 111325,
                    feet: 3.28084 * r.earthRadius,
                    inches: 39.37 * r.earthRadius,
                    kilometers: r.earthRadius / 1e3,
                    kilometres: r.earthRadius / 1e3,
                    meters: r.earthRadius,
                    metres: r.earthRadius,
                    miles: r.earthRadius / 1609.344,
                    millimeters: 1e3 * r.earthRadius,
                    millimetres: 1e3 * r.earthRadius,
                    nauticalmiles: r.earthRadius / 1852,
                    radians: 1,
                    yards: 1.0936 * r.earthRadius
                }, r.unitsFactors = {
                    centimeters: 100,
                    centimetres: 100,
                    degrees: 1 / 111325,
                    feet: 3.28084,
                    inches: 39.37,
                    kilometers: .001,
                    kilometres: .001,
                    meters: 1,
                    metres: 1,
                    miles: 1 / 1609.344,
                    millimeters: 1e3,
                    millimetres: 1e3,
                    nauticalmiles: 1 / 1852,
                    radians: 1 / r.earthRadius,
                    yards: 1.0936133
                }, r.areaFactors = {
                    acres: 247105e-9,
                    centimeters: 1e4,
                    centimetres: 1e4,
                    feet: 10.763910417,
                    hectares: 1e-4,
                    inches: 1550.003100006,
                    kilometers: 1e-6,
                    kilometres: 1e-6,
                    meters: 1,
                    metres: 1,
                    miles: 386e-9,
                    millimeters: 1e6,
                    millimetres: 1e6,
                    yards: 1.195990046
                }, r.feature = n, r.geometry = function(t1, e1, r) {
                    switch(void 0 === r && (r = {}), t1){
                        case "Point":
                            return i(e1).geometry;
                        case "LineString":
                            return o(e1).geometry;
                        case "Polygon":
                            return a(e1).geometry;
                        case "MultiPoint":
                            return c(e1).geometry;
                        case "MultiLineString":
                            return l(e1).geometry;
                        case "MultiPolygon":
                            return u(e1).geometry;
                        default:
                            throw new Error(t1 + " is invalid");
                    }
                }, r.point = i, r.points = function(t1, e1, r) {
                    return void 0 === r && (r = {}), s(t1.map(function(t1) {
                        return i(t1, e1);
                    }), r);
                }, r.polygon = a, r.polygons = function(t1, e1, r) {
                    return void 0 === r && (r = {}), s(t1.map(function(t1) {
                        return a(t1, e1);
                    }), r);
                }, r.lineString = o, r.lineStrings = function(t1, e1, r) {
                    return void 0 === r && (r = {}), s(t1.map(function(t1) {
                        return o(t1, e1);
                    }), r);
                }, r.featureCollection = s, r.multiLineString = l, r.multiPoint = c, r.multiPolygon = u, r.geometryCollection = function(t1, e1, r) {
                    return void 0 === r && (r = {}), n({
                        type: "GeometryCollection",
                        geometries: t1
                    }, e1, r);
                }, r.round = function(t1, e1) {
                    if (void 0 === e1 && (e1 = 0), e1 && !(e1 >= 0)) throw new Error("precision must be a positive number");
                    var r = Math.pow(10, e1 || 0);
                    return Math.round(t1 * r) / r;
                }, r.radiansToLength = f, r.lengthToRadians = h, r.lengthToDegrees = function(t1, e1) {
                    return p(h(t1, e1));
                }, r.bearingToAzimuth = function(t1) {
                    var e1 = t1 % 360;
                    return e1 < 0 && (e1 += 360), e1;
                }, r.radiansToDegrees = p, r.degreesToRadians = function(t1) {
                    return t1 % 360 * Math.PI / 180;
                }, r.convertLength = function(t1, e1, r) {
                    if (void 0 === e1 && (e1 = "kilometers"), void 0 === r && (r = "kilometers"), !(t1 >= 0)) throw new Error("length must be a positive number");
                    return f(h(t1, e1), r);
                }, r.convertArea = function(t1, e1, n) {
                    if (void 0 === e1 && (e1 = "meters"), void 0 === n && (n = "kilometers"), !(t1 >= 0)) throw new Error("area must be a positive number");
                    var i = r.areaFactors[e1];
                    if (!i) throw new Error("invalid original units");
                    var a = r.areaFactors[n];
                    if (!a) throw new Error("invalid final units");
                    return t1 / i * a;
                }, r.isNumber = d, r.isObject = function(t1) {
                    return !!t1 && t1.constructor === Object;
                }, r.validateBBox = function(t1) {
                    if (!t1) throw new Error("bbox is required");
                    if (!Array.isArray(t1)) throw new Error("bbox must be an Array");
                    if (4 !== t1.length && 6 !== t1.length) throw new Error("bbox must be an Array of 4 or 6 numbers");
                    t1.forEach(function(t1) {
                        if (!d(t1)) throw new Error("bbox must only contain numbers");
                    });
                }, r.validateId = function(t1) {
                    if (!t1) throw new Error("id is required");
                    if (-1 === [
                        "string",
                        "number"
                    ].indexOf(typeof t1)) throw new Error("id must be a number or a string");
                };
            },
            {}
        ],
        63: [
            function(t1, e1, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
                var n = t1("@turf/helpers");
                function i(t1, e1, r) {
                    if (null !== t1) for(var n, a, o, s, l, c, u, f, h = 0, p = 0, d = t1.type, m = "FeatureCollection" === d, g = "Feature" === d, v = m ? t1.features.length : 1, y = 0; y < v; y++){
                        l = (f = !!(u = m ? t1.features[y].geometry : g ? t1.geometry : t1) && "GeometryCollection" === u.type) ? u.geometries.length : 1;
                        for(var x = 0; x < l; x++){
                            var b = 0, _ = 0;
                            if (null !== (s = f ? u.geometries[x] : u)) {
                                c = s.coordinates;
                                var w = s.type;
                                switch(h = !r || "Polygon" !== w && "MultiPolygon" !== w ? 0 : 1, w){
                                    case null:
                                        break;
                                    case "Point":
                                        if (!1 === e1(c, p, y, b, _)) return !1;
                                        p++, b++;
                                        break;
                                    case "LineString":
                                    case "MultiPoint":
                                        for(n = 0; n < c.length; n++){
                                            if (!1 === e1(c[n], p, y, b, _)) return !1;
                                            p++, "MultiPoint" === w && b++;
                                        }
                                        "LineString" === w && b++;
                                        break;
                                    case "Polygon":
                                    case "MultiLineString":
                                        for(n = 0; n < c.length; n++){
                                            for(a = 0; a < c[n].length - h; a++){
                                                if (!1 === e1(c[n][a], p, y, b, _)) return !1;
                                                p++;
                                            }
                                            "MultiLineString" === w && b++, "Polygon" === w && _++;
                                        }
                                        "Polygon" === w && b++;
                                        break;
                                    case "MultiPolygon":
                                        for(n = 0; n < c.length; n++){
                                            for(_ = 0, a = 0; a < c[n].length; a++){
                                                for(o = 0; o < c[n][a].length - h; o++){
                                                    if (!1 === e1(c[n][a][o], p, y, b, _)) return !1;
                                                    p++;
                                                }
                                                _++;
                                            }
                                            b++;
                                        }
                                        break;
                                    case "GeometryCollection":
                                        for(n = 0; n < s.geometries.length; n++)if (!1 === i(s.geometries[n], e1, r)) return !1;
                                        break;
                                    default:
                                        throw new Error("Unknown Geometry Type");
                                }
                            }
                        }
                    }
                }
                function a(t1, e1) {
                    var r;
                    switch(t1.type){
                        case "FeatureCollection":
                            for(r = 0; r < t1.features.length && !1 !== e1(t1.features[r].properties, r); r++);
                            break;
                        case "Feature":
                            e1(t1.properties, 0);
                    }
                }
                function o(t1, e1) {
                    if ("Feature" === t1.type) e1(t1, 0);
                    else if ("FeatureCollection" === t1.type) for(var r = 0; r < t1.features.length && !1 !== e1(t1.features[r], r); r++);
                }
                function s(t1, e1) {
                    var r, n, i, a, o, s, l, c, u, f, h = 0, p = "FeatureCollection" === t1.type, d = "Feature" === t1.type, m = p ? t1.features.length : 1;
                    for(r = 0; r < m; r++){
                        for(s = p ? t1.features[r].geometry : d ? t1.geometry : t1, c = p ? t1.features[r].properties : d ? t1.properties : {}, u = p ? t1.features[r].bbox : d ? t1.bbox : void 0, f = p ? t1.features[r].id : d ? t1.id : void 0, o = (l = !!s && "GeometryCollection" === s.type) ? s.geometries.length : 1, i = 0; i < o; i++)if (null !== (a = l ? s.geometries[i] : s)) switch(a.type){
                            case "Point":
                            case "LineString":
                            case "MultiPoint":
                            case "Polygon":
                            case "MultiLineString":
                            case "MultiPolygon":
                                if (!1 === e1(a, h, c, u, f)) return !1;
                                break;
                            case "GeometryCollection":
                                for(n = 0; n < a.geometries.length; n++)if (!1 === e1(a.geometries[n], h, c, u, f)) return !1;
                                break;
                            default:
                                throw new Error("Unknown Geometry Type");
                        }
                        else if (!1 === e1(null, h, c, u, f)) return !1;
                        h++;
                    }
                }
                function l(t1, e1) {
                    s(t1, function(t1, r, i, a, o) {
                        var s, l = null === t1 ? null : t1.type;
                        switch(l){
                            case null:
                            case "Point":
                            case "LineString":
                            case "Polygon":
                                return !1 !== e1(n.feature(t1, i, {
                                    bbox: a,
                                    id: o
                                }), r, 0) && void 0;
                        }
                        switch(l){
                            case "MultiPoint":
                                s = "Point";
                                break;
                            case "MultiLineString":
                                s = "LineString";
                                break;
                            case "MultiPolygon":
                                s = "Polygon";
                        }
                        for(var c = 0; c < t1.coordinates.length; c++){
                            var u = {
                                type: s,
                                coordinates: t1.coordinates[c]
                            };
                            if (!1 === e1(n.feature(u, i), r, c)) return !1;
                        }
                    });
                }
                function c(t1, e1) {
                    l(t1, function(t1, r, a) {
                        var o = 0;
                        if (t1.geometry) {
                            var s = t1.geometry.type;
                            if ("Point" !== s && "MultiPoint" !== s) {
                                var l, c = 0, u = 0, f = 0;
                                return !1 !== i(t1, function(i, s, h, p, d) {
                                    if (void 0 === l || r > c || p > u || d > f) return l = i, c = r, u = p, f = d, void (o = 0);
                                    var m = n.lineString([
                                        l,
                                        i
                                    ], t1.properties);
                                    if (!1 === e1(m, r, a, d, o)) return !1;
                                    o++, l = i;
                                }) && void 0;
                            }
                        }
                    });
                }
                function u(t1, e1) {
                    if (!t1) throw new Error("geojson is required");
                    l(t1, function(t1, r, i) {
                        if (null !== t1.geometry) {
                            var a = t1.geometry.type, o = t1.geometry.coordinates;
                            switch(a){
                                case "LineString":
                                    if (!1 === e1(t1, r, i, 0, 0)) return !1;
                                    break;
                                case "Polygon":
                                    for(var s = 0; s < o.length; s++)if (!1 === e1(n.lineString(o[s], t1.properties), r, i, s)) return !1;
                            }
                        }
                    });
                }
                r.coordEach = i, r.coordReduce = function(t1, e1, r, n) {
                    var a = r;
                    return i(t1, function(t1, n, i, o, s) {
                        a = 0 === n && void 0 === r ? t1 : e1(a, t1, n, i, o, s);
                    }, n), a;
                }, r.propEach = a, r.propReduce = function(t1, e1, r) {
                    var n = r;
                    return a(t1, function(t1, i) {
                        n = 0 === i && void 0 === r ? t1 : e1(n, t1, i);
                    }), n;
                }, r.featureEach = o, r.featureReduce = function(t1, e1, r) {
                    var n = r;
                    return o(t1, function(t1, i) {
                        n = 0 === i && void 0 === r ? t1 : e1(n, t1, i);
                    }), n;
                }, r.coordAll = function(t1) {
                    var e1 = [];
                    return i(t1, function(t1) {
                        e1.push(t1);
                    }), e1;
                }, r.geomEach = s, r.geomReduce = function(t1, e1, r) {
                    var n = r;
                    return s(t1, function(t1, i, a, o, s) {
                        n = 0 === i && void 0 === r ? t1 : e1(n, t1, i, a, o, s);
                    }), n;
                }, r.flattenEach = l, r.flattenReduce = function(t1, e1, r) {
                    var n = r;
                    return l(t1, function(t1, i, a) {
                        n = 0 === i && 0 === a && void 0 === r ? t1 : e1(n, t1, i, a);
                    }), n;
                }, r.segmentEach = c, r.segmentReduce = function(t1, e1, r) {
                    var n = r, i = !1;
                    return c(t1, function(t1, a, o, s, l) {
                        n = !1 === i && void 0 === r ? t1 : e1(n, t1, a, o, s, l), i = !0;
                    }), n;
                }, r.lineEach = u, r.lineReduce = function(t1, e1, r) {
                    var n = r;
                    return u(t1, function(t1, i, a, o) {
                        n = 0 === i && void 0 === r ? t1 : e1(n, t1, i, a, o);
                    }), n;
                }, r.findSegment = function(t1, e1) {
                    if (e1 = e1 || {}, !n.isObject(e1)) throw new Error("options is invalid");
                    var r, i = e1.featureIndex || 0, a = e1.multiFeatureIndex || 0, o = e1.geometryIndex || 0, s = e1.segmentIndex || 0, l = e1.properties;
                    switch(t1.type){
                        case "FeatureCollection":
                            i < 0 && (i = t1.features.length + i), l = l || t1.features[i].properties, r = t1.features[i].geometry;
                            break;
                        case "Feature":
                            l = l || t1.properties, r = t1.geometry;
                            break;
                        case "Point":
                        case "MultiPoint":
                            return null;
                        case "LineString":
                        case "Polygon":
                        case "MultiLineString":
                        case "MultiPolygon":
                            r = t1;
                            break;
                        default:
                            throw new Error("geojson is invalid");
                    }
                    if (null === r) return null;
                    var c = r.coordinates;
                    switch(r.type){
                        case "Point":
                        case "MultiPoint":
                            return null;
                        case "LineString":
                            return s < 0 && (s = c.length + s - 1), n.lineString([
                                c[s],
                                c[s + 1]
                            ], l, e1);
                        case "Polygon":
                            return o < 0 && (o = c.length + o), s < 0 && (s = c[o].length + s - 1), n.lineString([
                                c[o][s],
                                c[o][s + 1]
                            ], l, e1);
                        case "MultiLineString":
                            return a < 0 && (a = c.length + a), s < 0 && (s = c[a].length + s - 1), n.lineString([
                                c[a][s],
                                c[a][s + 1]
                            ], l, e1);
                        case "MultiPolygon":
                            return a < 0 && (a = c.length + a), o < 0 && (o = c[a].length + o), s < 0 && (s = c[a][o].length - s - 1), n.lineString([
                                c[a][o][s],
                                c[a][o][s + 1]
                            ], l, e1);
                    }
                    throw new Error("geojson is invalid");
                }, r.findPoint = function(t1, e1) {
                    if (e1 = e1 || {}, !n.isObject(e1)) throw new Error("options is invalid");
                    var r, i = e1.featureIndex || 0, a = e1.multiFeatureIndex || 0, o = e1.geometryIndex || 0, s = e1.coordIndex || 0, l = e1.properties;
                    switch(t1.type){
                        case "FeatureCollection":
                            i < 0 && (i = t1.features.length + i), l = l || t1.features[i].properties, r = t1.features[i].geometry;
                            break;
                        case "Feature":
                            l = l || t1.properties, r = t1.geometry;
                            break;
                        case "Point":
                        case "MultiPoint":
                            return null;
                        case "LineString":
                        case "Polygon":
                        case "MultiLineString":
                        case "MultiPolygon":
                            r = t1;
                            break;
                        default:
                            throw new Error("geojson is invalid");
                    }
                    if (null === r) return null;
                    var c = r.coordinates;
                    switch(r.type){
                        case "Point":
                            return n.point(c, l, e1);
                        case "MultiPoint":
                            return a < 0 && (a = c.length + a), n.point(c[a], l, e1);
                        case "LineString":
                            return s < 0 && (s = c.length + s), n.point(c[s], l, e1);
                        case "Polygon":
                            return o < 0 && (o = c.length + o), s < 0 && (s = c[o].length + s), n.point(c[o][s], l, e1);
                        case "MultiLineString":
                            return a < 0 && (a = c.length + a), s < 0 && (s = c[a].length + s), n.point(c[a][s], l, e1);
                        case "MultiPolygon":
                            return a < 0 && (a = c.length + a), o < 0 && (o = c[a].length + o), s < 0 && (s = c[a][o].length - s), n.point(c[a][o][s], l, e1);
                    }
                    throw new Error("geojson is invalid");
                };
            },
            {
                "@turf/helpers": 62
            }
        ],
        64: [
            function(t1, e1, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
                var n = t1("@turf/meta");
                function i(t1) {
                    var e1 = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    return n.coordEach(t1, function(t1) {
                        e1[0] > t1[0] && (e1[0] = t1[0]), e1[1] > t1[1] && (e1[1] = t1[1]), e1[2] < t1[0] && (e1[2] = t1[0]), e1[3] < t1[1] && (e1[3] = t1[1]);
                    }), e1;
                }
                i.default = i, r.default = i;
            },
            {
                "@turf/meta": 66
            }
        ],
        65: [
            function(t1, e1, r) {
                arguments[4][62][0].apply(r, arguments);
            },
            {
                dup: 62
            }
        ],
        66: [
            function(t1, e1, r) {
                arguments[4][63][0].apply(r, arguments);
            },
            {
                "@turf/helpers": 65,
                dup: 63
            }
        ],
        67: [
            function(t1, e1, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
                var n = t1("@turf/meta"), i = t1("@turf/helpers");
                r.default = function(t1, e1) {
                    void 0 === e1 && (e1 = {});
                    var r = 0, a = 0, o = 0;
                    return n.coordEach(t1, function(t1) {
                        r += t1[0], a += t1[1], o++;
                    }), i.point([
                        r / o,
                        a / o
                    ], e1.properties);
                };
            },
            {
                "@turf/helpers": 68,
                "@turf/meta": 69
            }
        ],
        68: [
            function(t1, e1, r) {
                "use strict";
                function n(t1, e1, r) {
                    void 0 === r && (r = {});
                    var n = {
                        type: "Feature"
                    };
                    return (0 === r.id || r.id) && (n.id = r.id), r.bbox && (n.bbox = r.bbox), n.properties = e1 || {}, n.geometry = t1, n;
                }
                function i(t1, e1, r) {
                    return void 0 === r && (r = {}), n({
                        type: "Point",
                        coordinates: t1
                    }, e1, r);
                }
                function a(t1, e1, r) {
                    void 0 === r && (r = {});
                    for(var i = 0, a = t1; i < a.length; i++){
                        var o = a[i];
                        if (o.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
                        for(var s = 0; s < o[o.length - 1].length; s++)if (o[o.length - 1][s] !== o[0][s]) throw new Error("First and last Position are not equivalent.");
                    }
                    return n({
                        type: "Polygon",
                        coordinates: t1
                    }, e1, r);
                }
                function o(t1, e1, r) {
                    if (void 0 === r && (r = {}), t1.length < 2) throw new Error("coordinates must be an array of two or more positions");
                    return n({
                        type: "LineString",
                        coordinates: t1
                    }, e1, r);
                }
                function s(t1, e1) {
                    void 0 === e1 && (e1 = {});
                    var r = {
                        type: "FeatureCollection"
                    };
                    return e1.id && (r.id = e1.id), e1.bbox && (r.bbox = e1.bbox), r.features = t1, r;
                }
                function l(t1, e1, r) {
                    return void 0 === r && (r = {}), n({
                        type: "MultiLineString",
                        coordinates: t1
                    }, e1, r);
                }
                function c(t1, e1, r) {
                    return void 0 === r && (r = {}), n({
                        type: "MultiPoint",
                        coordinates: t1
                    }, e1, r);
                }
                function u(t1, e1, r) {
                    return void 0 === r && (r = {}), n({
                        type: "MultiPolygon",
                        coordinates: t1
                    }, e1, r);
                }
                function f(t1, e1) {
                    void 0 === e1 && (e1 = "kilometers");
                    var n = r.factors[e1];
                    if (!n) throw new Error(e1 + " units is invalid");
                    return t1 * n;
                }
                function h(t1, e1) {
                    void 0 === e1 && (e1 = "kilometers");
                    var n = r.factors[e1];
                    if (!n) throw new Error(e1 + " units is invalid");
                    return t1 / n;
                }
                function p(t1) {
                    return 180 * (t1 % (2 * Math.PI)) / Math.PI;
                }
                function d(t1) {
                    return !isNaN(t1) && null !== t1 && !Array.isArray(t1) && !/^\s*$/.test(t1);
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.earthRadius = 6371008.8, r.factors = {
                    centimeters: 100 * r.earthRadius,
                    centimetres: 100 * r.earthRadius,
                    degrees: r.earthRadius / 111325,
                    feet: 3.28084 * r.earthRadius,
                    inches: 39.37 * r.earthRadius,
                    kilometers: r.earthRadius / 1e3,
                    kilometres: r.earthRadius / 1e3,
                    meters: r.earthRadius,
                    metres: r.earthRadius,
                    miles: r.earthRadius / 1609.344,
                    millimeters: 1e3 * r.earthRadius,
                    millimetres: 1e3 * r.earthRadius,
                    nauticalmiles: r.earthRadius / 1852,
                    radians: 1,
                    yards: r.earthRadius / 1.0936
                }, r.unitsFactors = {
                    centimeters: 100,
                    centimetres: 100,
                    degrees: 1 / 111325,
                    feet: 3.28084,
                    inches: 39.37,
                    kilometers: .001,
                    kilometres: .001,
                    meters: 1,
                    metres: 1,
                    miles: 1 / 1609.344,
                    millimeters: 1e3,
                    millimetres: 1e3,
                    nauticalmiles: 1 / 1852,
                    radians: 1 / r.earthRadius,
                    yards: 1 / 1.0936
                }, r.areaFactors = {
                    acres: 247105e-9,
                    centimeters: 1e4,
                    centimetres: 1e4,
                    feet: 10.763910417,
                    inches: 1550.003100006,
                    kilometers: 1e-6,
                    kilometres: 1e-6,
                    meters: 1,
                    metres: 1,
                    miles: 386e-9,
                    millimeters: 1e6,
                    millimetres: 1e6,
                    yards: 1.195990046
                }, r.feature = n, r.geometry = function(t1, e1, r) {
                    switch(void 0 === r && (r = {}), t1){
                        case "Point":
                            return i(e1).geometry;
                        case "LineString":
                            return o(e1).geometry;
                        case "Polygon":
                            return a(e1).geometry;
                        case "MultiPoint":
                            return c(e1).geometry;
                        case "MultiLineString":
                            return l(e1).geometry;
                        case "MultiPolygon":
                            return u(e1).geometry;
                        default:
                            throw new Error(t1 + " is invalid");
                    }
                }, r.point = i, r.points = function(t1, e1, r) {
                    return void 0 === r && (r = {}), s(t1.map(function(t1) {
                        return i(t1, e1);
                    }), r);
                }, r.polygon = a, r.polygons = function(t1, e1, r) {
                    return void 0 === r && (r = {}), s(t1.map(function(t1) {
                        return a(t1, e1);
                    }), r);
                }, r.lineString = o, r.lineStrings = function(t1, e1, r) {
                    return void 0 === r && (r = {}), s(t1.map(function(t1) {
                        return o(t1, e1);
                    }), r);
                }, r.featureCollection = s, r.multiLineString = l, r.multiPoint = c, r.multiPolygon = u, r.geometryCollection = function(t1, e1, r) {
                    return void 0 === r && (r = {}), n({
                        type: "GeometryCollection",
                        geometries: t1
                    }, e1, r);
                }, r.round = function(t1, e1) {
                    if (void 0 === e1 && (e1 = 0), e1 && !(e1 >= 0)) throw new Error("precision must be a positive number");
                    var r = Math.pow(10, e1 || 0);
                    return Math.round(t1 * r) / r;
                }, r.radiansToLength = f, r.lengthToRadians = h, r.lengthToDegrees = function(t1, e1) {
                    return p(h(t1, e1));
                }, r.bearingToAzimuth = function(t1) {
                    var e1 = t1 % 360;
                    return e1 < 0 && (e1 += 360), e1;
                }, r.radiansToDegrees = p, r.degreesToRadians = function(t1) {
                    return t1 % 360 * Math.PI / 180;
                }, r.convertLength = function(t1, e1, r) {
                    if (void 0 === e1 && (e1 = "kilometers"), void 0 === r && (r = "kilometers"), !(t1 >= 0)) throw new Error("length must be a positive number");
                    return f(h(t1, e1), r);
                }, r.convertArea = function(t1, e1, n) {
                    if (void 0 === e1 && (e1 = "meters"), void 0 === n && (n = "kilometers"), !(t1 >= 0)) throw new Error("area must be a positive number");
                    var i = r.areaFactors[e1];
                    if (!i) throw new Error("invalid original units");
                    var a = r.areaFactors[n];
                    if (!a) throw new Error("invalid final units");
                    return t1 / i * a;
                }, r.isNumber = d, r.isObject = function(t1) {
                    return !!t1 && t1.constructor === Object;
                }, r.validateBBox = function(t1) {
                    if (!t1) throw new Error("bbox is required");
                    if (!Array.isArray(t1)) throw new Error("bbox must be an Array");
                    if (4 !== t1.length && 6 !== t1.length) throw new Error("bbox must be an Array of 4 or 6 numbers");
                    t1.forEach(function(t1) {
                        if (!d(t1)) throw new Error("bbox must only contain numbers");
                    });
                }, r.validateId = function(t1) {
                    if (!t1) throw new Error("id is required");
                    if (-1 === [
                        "string",
                        "number"
                    ].indexOf(typeof t1)) throw new Error("id must be a number or a string");
                }, r.radians2degrees = function() {
                    throw new Error("method has been renamed to `radiansToDegrees`");
                }, r.degrees2radians = function() {
                    throw new Error("method has been renamed to `degreesToRadians`");
                }, r.distanceToDegrees = function() {
                    throw new Error("method has been renamed to `lengthToDegrees`");
                }, r.distanceToRadians = function() {
                    throw new Error("method has been renamed to `lengthToRadians`");
                }, r.radiansToDistance = function() {
                    throw new Error("method has been renamed to `radiansToLength`");
                }, r.bearingToAngle = function() {
                    throw new Error("method has been renamed to `bearingToAzimuth`");
                }, r.convertDistance = function() {
                    throw new Error("method has been renamed to `convertLength`");
                };
            },
            {}
        ],
        69: [
            function(t1, e1, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
                var n = t1("@turf/helpers");
                function i(t1, e1, r) {
                    if (null !== t1) for(var n, a, o, s, l, c, u, f, h = 0, p = 0, d = t1.type, m = "FeatureCollection" === d, g = "Feature" === d, v = m ? t1.features.length : 1, y = 0; y < v; y++){
                        l = (f = !!(u = m ? t1.features[y].geometry : g ? t1.geometry : t1) && "GeometryCollection" === u.type) ? u.geometries.length : 1;
                        for(var x = 0; x < l; x++){
                            var b = 0, _ = 0;
                            if (null !== (s = f ? u.geometries[x] : u)) {
                                c = s.coordinates;
                                var w = s.type;
                                switch(h = !r || "Polygon" !== w && "MultiPolygon" !== w ? 0 : 1, w){
                                    case null:
                                        break;
                                    case "Point":
                                        if (!1 === e1(c, p, y, b, _)) return !1;
                                        p++, b++;
                                        break;
                                    case "LineString":
                                    case "MultiPoint":
                                        for(n = 0; n < c.length; n++){
                                            if (!1 === e1(c[n], p, y, b, _)) return !1;
                                            p++, "MultiPoint" === w && b++;
                                        }
                                        "LineString" === w && b++;
                                        break;
                                    case "Polygon":
                                    case "MultiLineString":
                                        for(n = 0; n < c.length; n++){
                                            for(a = 0; a < c[n].length - h; a++){
                                                if (!1 === e1(c[n][a], p, y, b, _)) return !1;
                                                p++;
                                            }
                                            "MultiLineString" === w && b++, "Polygon" === w && _++;
                                        }
                                        "Polygon" === w && b++;
                                        break;
                                    case "MultiPolygon":
                                        for(n = 0; n < c.length; n++){
                                            for(_ = 0, a = 0; a < c[n].length; a++){
                                                for(o = 0; o < c[n][a].length - h; o++){
                                                    if (!1 === e1(c[n][a][o], p, y, b, _)) return !1;
                                                    p++;
                                                }
                                                _++;
                                            }
                                            b++;
                                        }
                                        break;
                                    case "GeometryCollection":
                                        for(n = 0; n < s.geometries.length; n++)if (!1 === i(s.geometries[n], e1, r)) return !1;
                                        break;
                                    default:
                                        throw new Error("Unknown Geometry Type");
                                }
                            }
                        }
                    }
                }
                function a(t1, e1) {
                    var r;
                    switch(t1.type){
                        case "FeatureCollection":
                            for(r = 0; r < t1.features.length && !1 !== e1(t1.features[r].properties, r); r++);
                            break;
                        case "Feature":
                            e1(t1.properties, 0);
                    }
                }
                function o(t1, e1) {
                    if ("Feature" === t1.type) e1(t1, 0);
                    else if ("FeatureCollection" === t1.type) for(var r = 0; r < t1.features.length && !1 !== e1(t1.features[r], r); r++);
                }
                function s(t1, e1) {
                    var r, n, i, a, o, s, l, c, u, f, h = 0, p = "FeatureCollection" === t1.type, d = "Feature" === t1.type, m = p ? t1.features.length : 1;
                    for(r = 0; r < m; r++){
                        for(s = p ? t1.features[r].geometry : d ? t1.geometry : t1, c = p ? t1.features[r].properties : d ? t1.properties : {}, u = p ? t1.features[r].bbox : d ? t1.bbox : void 0, f = p ? t1.features[r].id : d ? t1.id : void 0, o = (l = !!s && "GeometryCollection" === s.type) ? s.geometries.length : 1, i = 0; i < o; i++)if (null !== (a = l ? s.geometries[i] : s)) switch(a.type){
                            case "Point":
                            case "LineString":
                            case "MultiPoint":
                            case "Polygon":
                            case "MultiLineString":
                            case "MultiPolygon":
                                if (!1 === e1(a, h, c, u, f)) return !1;
                                break;
                            case "GeometryCollection":
                                for(n = 0; n < a.geometries.length; n++)if (!1 === e1(a.geometries[n], h, c, u, f)) return !1;
                                break;
                            default:
                                throw new Error("Unknown Geometry Type");
                        }
                        else if (!1 === e1(null, h, c, u, f)) return !1;
                        h++;
                    }
                }
                function l(t1, e1) {
                    s(t1, function(t1, r, i, a, o) {
                        var s, l = null === t1 ? null : t1.type;
                        switch(l){
                            case null:
                            case "Point":
                            case "LineString":
                            case "Polygon":
                                return !1 !== e1(n.feature(t1, i, {
                                    bbox: a,
                                    id: o
                                }), r, 0) && void 0;
                        }
                        switch(l){
                            case "MultiPoint":
                                s = "Point";
                                break;
                            case "MultiLineString":
                                s = "LineString";
                                break;
                            case "MultiPolygon":
                                s = "Polygon";
                        }
                        for(var c = 0; c < t1.coordinates.length; c++){
                            var u = {
                                type: s,
                                coordinates: t1.coordinates[c]
                            };
                            if (!1 === e1(n.feature(u, i), r, c)) return !1;
                        }
                    });
                }
                function c(t1, e1) {
                    l(t1, function(t1, r, a) {
                        var o = 0;
                        if (t1.geometry) {
                            var s = t1.geometry.type;
                            if ("Point" !== s && "MultiPoint" !== s) {
                                var l, c = 0, u = 0, f = 0;
                                return !1 !== i(t1, function(i, s, h, p, d) {
                                    if (void 0 === l || r > c || p > u || d > f) return l = i, c = r, u = p, f = d, void (o = 0);
                                    var m = n.lineString([
                                        l,
                                        i
                                    ], t1.properties);
                                    if (!1 === e1(m, r, a, d, o)) return !1;
                                    o++, l = i;
                                }) && void 0;
                            }
                        }
                    });
                }
                function u(t1, e1) {
                    if (!t1) throw new Error("geojson is required");
                    l(t1, function(t1, r, i) {
                        if (null !== t1.geometry) {
                            var a = t1.geometry.type, o = t1.geometry.coordinates;
                            switch(a){
                                case "LineString":
                                    if (!1 === e1(t1, r, i, 0, 0)) return !1;
                                    break;
                                case "Polygon":
                                    for(var s = 0; s < o.length; s++)if (!1 === e1(n.lineString(o[s], t1.properties), r, i, s)) return !1;
                            }
                        }
                    });
                }
                r.coordEach = i, r.coordReduce = function(t1, e1, r, n) {
                    var a = r;
                    return i(t1, function(t1, n, i, o, s) {
                        a = 0 === n && void 0 === r ? t1 : e1(a, t1, n, i, o, s);
                    }, n), a;
                }, r.propEach = a, r.propReduce = function(t1, e1, r) {
                    var n = r;
                    return a(t1, function(t1, i) {
                        n = 0 === i && void 0 === r ? t1 : e1(n, t1, i);
                    }), n;
                }, r.featureEach = o, r.featureReduce = function(t1, e1, r) {
                    var n = r;
                    return o(t1, function(t1, i) {
                        n = 0 === i && void 0 === r ? t1 : e1(n, t1, i);
                    }), n;
                }, r.coordAll = function(t1) {
                    var e1 = [];
                    return i(t1, function(t1) {
                        e1.push(t1);
                    }), e1;
                }, r.geomEach = s, r.geomReduce = function(t1, e1, r) {
                    var n = r;
                    return s(t1, function(t1, i, a, o, s) {
                        n = 0 === i && void 0 === r ? t1 : e1(n, t1, i, a, o, s);
                    }), n;
                }, r.flattenEach = l, r.flattenReduce = function(t1, e1, r) {
                    var n = r;
                    return l(t1, function(t1, i, a) {
                        n = 0 === i && 0 === a && void 0 === r ? t1 : e1(n, t1, i, a);
                    }), n;
                }, r.segmentEach = c, r.segmentReduce = function(t1, e1, r) {
                    var n = r, i = !1;
                    return c(t1, function(t1, a, o, s, l) {
                        n = !1 === i && void 0 === r ? t1 : e1(n, t1, a, o, s, l), i = !0;
                    }), n;
                }, r.lineEach = u, r.lineReduce = function(t1, e1, r) {
                    var n = r;
                    return u(t1, function(t1, i, a, o) {
                        n = 0 === i && void 0 === r ? t1 : e1(n, t1, i, a, o);
                    }), n;
                }, r.findSegment = function(t1, e1) {
                    if (e1 = e1 || {}, !n.isObject(e1)) throw new Error("options is invalid");
                    var r, i = e1.featureIndex || 0, a = e1.multiFeatureIndex || 0, o = e1.geometryIndex || 0, s = e1.segmentIndex || 0, l = e1.properties;
                    switch(t1.type){
                        case "FeatureCollection":
                            i < 0 && (i = t1.features.length + i), l = l || t1.features[i].properties, r = t1.features[i].geometry;
                            break;
                        case "Feature":
                            l = l || t1.properties, r = t1.geometry;
                            break;
                        case "Point":
                        case "MultiPoint":
                            return null;
                        case "LineString":
                        case "Polygon":
                        case "MultiLineString":
                        case "MultiPolygon":
                            r = t1;
                            break;
                        default:
                            throw new Error("geojson is invalid");
                    }
                    if (null === r) return null;
                    var c = r.coordinates;
                    switch(r.type){
                        case "Point":
                        case "MultiPoint":
                            return null;
                        case "LineString":
                            return s < 0 && (s = c.length + s - 1), n.lineString([
                                c[s],
                                c[s + 1]
                            ], l, e1);
                        case "Polygon":
                            return o < 0 && (o = c.length + o), s < 0 && (s = c[o].length + s - 1), n.lineString([
                                c[o][s],
                                c[o][s + 1]
                            ], l, e1);
                        case "MultiLineString":
                            return a < 0 && (a = c.length + a), s < 0 && (s = c[a].length + s - 1), n.lineString([
                                c[a][s],
                                c[a][s + 1]
                            ], l, e1);
                        case "MultiPolygon":
                            return a < 0 && (a = c.length + a), o < 0 && (o = c[a].length + o), s < 0 && (s = c[a][o].length - s - 1), n.lineString([
                                c[a][o][s],
                                c[a][o][s + 1]
                            ], l, e1);
                    }
                    throw new Error("geojson is invalid");
                }, r.findPoint = function(t1, e1) {
                    if (e1 = e1 || {}, !n.isObject(e1)) throw new Error("options is invalid");
                    var r, i = e1.featureIndex || 0, a = e1.multiFeatureIndex || 0, o = e1.geometryIndex || 0, s = e1.coordIndex || 0, l = e1.properties;
                    switch(t1.type){
                        case "FeatureCollection":
                            i < 0 && (i = t1.features.length + i), l = l || t1.features[i].properties, r = t1.features[i].geometry;
                            break;
                        case "Feature":
                            l = l || t1.properties, r = t1.geometry;
                            break;
                        case "Point":
                        case "MultiPoint":
                            return null;
                        case "LineString":
                        case "Polygon":
                        case "MultiLineString":
                        case "MultiPolygon":
                            r = t1;
                            break;
                        default:
                            throw new Error("geojson is invalid");
                    }
                    if (null === r) return null;
                    var c = r.coordinates;
                    switch(r.type){
                        case "Point":
                            return n.point(c, l, e1);
                        case "MultiPoint":
                            return a < 0 && (a = c.length + a), n.point(c[a], l, e1);
                        case "LineString":
                            return s < 0 && (s = c.length + s), n.point(c[s], l, e1);
                        case "Polygon":
                            return o < 0 && (o = c.length + o), s < 0 && (s = c[o].length + s), n.point(c[o][s], l, e1);
                        case "MultiLineString":
                            return a < 0 && (a = c.length + a), s < 0 && (s = c[a].length + s), n.point(c[a][s], l, e1);
                        case "MultiPolygon":
                            return a < 0 && (a = c.length + a), o < 0 && (o = c[a].length + o), s < 0 && (s = c[a][o].length - s), n.point(c[a][o][s], l, e1);
                    }
                    throw new Error("geojson is invalid");
                };
            },
            {
                "@turf/helpers": 68
            }
        ],
        70: [
            function(t1, e1, r) {
                e1.exports = function(t1) {
                    var e1 = 0, r = 0, n = 0, i = 0;
                    return t1.map(function(t1) {
                        var a = (t1 = t1.slice())[0], o = a.toUpperCase();
                        if (a != o) switch(t1[0] = o, a){
                            case "a":
                                t1[6] += n, t1[7] += i;
                                break;
                            case "v":
                                t1[1] += i;
                                break;
                            case "h":
                                t1[1] += n;
                                break;
                            default:
                                for(var s = 1; s < t1.length;)t1[s++] += n, t1[s++] += i;
                        }
                        switch(o){
                            case "Z":
                                n = e1, i = r;
                                break;
                            case "H":
                                n = t1[1];
                                break;
                            case "V":
                                i = t1[1];
                                break;
                            case "M":
                                n = e1 = t1[1], i = r = t1[2];
                                break;
                            default:
                                n = t1[t1.length - 2], i = t1[t1.length - 1];
                        }
                        return t1;
                    });
                };
            },
            {}
        ],
        71: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    if (!t1 || null == t1.length) throw Error("Argument should be an array");
                    e1 = null == e1 ? 1 : Math.floor(e1);
                    for(var r = Array(2 * e1), n = 0; n < e1; n++){
                        for(var i = -1 / 0, a = 1 / 0, o = n, s = t1.length; o < s; o += e1)t1[o] > i && (i = t1[o]), t1[o] < a && (a = t1[o]);
                        r[n] = a, r[e1 + n] = i;
                    }
                    return r;
                };
            },
            {}
        ],
        72: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r) {
                    if ("function" == typeof Array.prototype.findIndex) return t1.findIndex(e1, r);
                    if ("function" != typeof e1) throw new TypeError("predicate must be a function");
                    var n = Object(t1), i = n.length;
                    if (0 === i) return -1;
                    for(var a = 0; a < i; a++)if (e1.call(r, n[a], a, n)) return a;
                    return -1;
                };
            },
            {}
        ],
        73: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("array-bounds");
                e1.exports = function(t1, e1, r) {
                    if (!t1 || null == t1.length) throw Error("Argument should be an array");
                    null == e1 && (e1 = 1);
                    null == r && (r = n(t1, e1));
                    for(var i = 0; i < e1; i++){
                        var a = r[e1 + i], o = r[i], s = i, l = t1.length;
                        if (a === 1 / 0 && o === -1 / 0) for(s = i; s < l; s += e1)t1[s] = t1[s] === a ? 1 : t1[s] === o ? 0 : .5;
                        else if (a === 1 / 0) for(s = i; s < l; s += e1)t1[s] = t1[s] === a ? 1 : 0;
                        else if (o === -1 / 0) for(s = i; s < l; s += e1)t1[s] = t1[s] === o ? 0 : 1;
                        else {
                            var c = a - o;
                            for(s = i; s < l; s += e1)isNaN(t1[s]) || (t1[s] = 0 === c ? .5 : (t1[s] - o) / c);
                        }
                    }
                    return t1;
                };
            },
            {
                "array-bounds": 71
            }
        ],
        74: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    var r = "number" == typeof t1, n = "number" == typeof e1;
                    r && !n ? (e1 = t1, t1 = 0) : r || n || (t1 = 0, e1 = 0);
                    var i = (e1 |= 0) - (t1 |= 0);
                    if (i < 0) throw new Error("array length must be positive");
                    for(var a = new Array(i), o = 0, s = t1; o < i; o++, s++)a[o] = s;
                    return a;
                };
            },
            {}
        ],
        75: [
            function(t1, e1, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = t1("object-assign");
                        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function i(t1, e1) {
                            if (t1 === e1) return 0;
                            for(var r = t1.length, n = e1.length, i = 0, a = Math.min(r, n); i < a; ++i)if (t1[i] !== e1[i]) {
                                r = t1[i], n = e1[i];
                                break;
                            }
                            return r < n ? -1 : n < r ? 1 : 0;
                        }
                        function a(t1) {
                            return r.Buffer && "function" == typeof r.Buffer.isBuffer ? r.Buffer.isBuffer(t1) : !(null == t1 || !t1._isBuffer);
                        }
                        var o = t1("util/"), s = Object.prototype.hasOwnProperty, l = Array.prototype.slice, c = "foo" === (function() {}).name;
                        function u(t1) {
                            return Object.prototype.toString.call(t1);
                        }
                        function f(t1) {
                            return !a(t1) && "function" == typeof r.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(t1) : !!t1 && (t1 instanceof DataView || !!(t1.buffer && t1.buffer instanceof ArrayBuffer)));
                        }
                        var h = e1.exports = y, p = /\s*function\s+([^\(\s]*)\s*/;
                        function d(t1) {
                            if (o.isFunction(t1)) {
                                if (c) return t1.name;
                                var e1 = t1.toString().match(p);
                                return e1 && e1[1];
                            }
                        }
                        function m(t1, e1) {
                            return "string" == typeof t1 ? t1.length < e1 ? t1 : t1.slice(0, e1) : t1;
                        }
                        function g(t1) {
                            if (c || !o.isFunction(t1)) return o.inspect(t1);
                            var e1 = d(t1);
                            return "[Function" + (e1 ? ": " + e1 : "") + "]";
                        }
                        function v(t1, e1, r, n, i) {
                            throw new h.AssertionError({
                                message: r,
                                actual: t1,
                                expected: e1,
                                operator: n,
                                stackStartFunction: i
                            });
                        }
                        function y(t1, e1) {
                            t1 || v(t1, !0, e1, "==", h.ok);
                        }
                        function x(t1, e1, r, n) {
                            if (t1 === e1) return !0;
                            if (a(t1) && a(e1)) return 0 === i(t1, e1);
                            if (o.isDate(t1) && o.isDate(e1)) return t1.getTime() === e1.getTime();
                            if (o.isRegExp(t1) && o.isRegExp(e1)) return t1.source === e1.source && t1.global === e1.global && t1.multiline === e1.multiline && t1.lastIndex === e1.lastIndex && t1.ignoreCase === e1.ignoreCase;
                            if (null !== t1 && "object" == typeof t1 || null !== e1 && "object" == typeof e1) {
                                if (f(t1) && f(e1) && u(t1) === u(e1) && !(t1 instanceof Float32Array || t1 instanceof Float64Array)) return 0 === i(new Uint8Array(t1.buffer), new Uint8Array(e1.buffer));
                                if (a(t1) !== a(e1)) return !1;
                                var s = (n = n || {
                                    actual: [],
                                    expected: []
                                }).actual.indexOf(t1);
                                return -1 !== s && s === n.expected.indexOf(e1) || (n.actual.push(t1), n.expected.push(e1), function(t1, e1, r, n) {
                                    if (null == t1 || null == e1) return !1;
                                    if (o.isPrimitive(t1) || o.isPrimitive(e1)) return t1 === e1;
                                    if (r && Object.getPrototypeOf(t1) !== Object.getPrototypeOf(e1)) return !1;
                                    var i = b(t1), a = b(e1);
                                    if (i && !a || !i && a) return !1;
                                    if (i) return t1 = l.call(t1), e1 = l.call(e1), x(t1, e1, r);
                                    var s, c, u = T(t1), f = T(e1);
                                    if (u.length !== f.length) return !1;
                                    for(u.sort(), f.sort(), c = u.length - 1; c >= 0; c--)if (u[c] !== f[c]) return !1;
                                    for(c = u.length - 1; c >= 0; c--)if (s = u[c], !x(t1[s], e1[s], r, n)) return !1;
                                    return !0;
                                }(t1, e1, r, n));
                            }
                            return r ? t1 === e1 : t1 == e1;
                        }
                        function b(t1) {
                            return "[object Arguments]" == Object.prototype.toString.call(t1);
                        }
                        function _(t1, e1) {
                            if (!t1 || !e1) return !1;
                            if ("[object RegExp]" == Object.prototype.toString.call(e1)) return e1.test(t1);
                            try {
                                if (t1 instanceof e1) return !0;
                            } catch (t1) {}
                            return !Error.isPrototypeOf(e1) && !0 === e1.call({}, t1);
                        }
                        function w(t1, e1, r, n) {
                            var i;
                            if ("function" != typeof e1) throw new TypeError('"block" argument must be a function');
                            "string" == typeof r && (n = r, r = null), i = function(t1) {
                                var e1;
                                try {
                                    t1();
                                } catch (t1) {
                                    e1 = t1;
                                }
                                return e1;
                            }(e1), n = (r && r.name ? " (" + r.name + ")." : ".") + (n ? " " + n : "."), t1 && !i && v(i, r, "Missing expected exception" + n);
                            var a = "string" == typeof n, s = !t1 && i && !r;
                            if ((!t1 && o.isError(i) && a && _(i, r) || s) && v(i, r, "Got unwanted exception" + n), t1 && i && r && !_(i, r) || !t1 && i) throw i;
                        }
                        h.AssertionError = function(t1) {
                            this.name = "AssertionError", this.actual = t1.actual, this.expected = t1.expected, this.operator = t1.operator, t1.message ? (this.message = t1.message, this.generatedMessage = !1) : (this.message = function(t1) {
                                return m(g(t1.actual), 128) + " " + t1.operator + " " + m(g(t1.expected), 128);
                            }(this), this.generatedMessage = !0);
                            var e1 = t1.stackStartFunction || v;
                            if (Error.captureStackTrace) Error.captureStackTrace(this, e1);
                            else {
                                var r = new Error;
                                if (r.stack) {
                                    var n = r.stack, i = d(e1), a = n.indexOf("\n" + i);
                                    if (a >= 0) {
                                        var o = n.indexOf("\n", a + 1);
                                        n = n.substring(o + 1);
                                    }
                                    this.stack = n;
                                }
                            }
                        }, o.inherits(h.AssertionError, Error), h.fail = v, h.ok = y, h.equal = function(t1, e1, r) {
                            t1 != e1 && v(t1, e1, r, "==", h.equal);
                        }, h.notEqual = function(t1, e1, r) {
                            t1 == e1 && v(t1, e1, r, "!=", h.notEqual);
                        }, h.deepEqual = function(t1, e1, r) {
                            x(t1, e1, !1) || v(t1, e1, r, "deepEqual", h.deepEqual);
                        }, h.deepStrictEqual = function(t1, e1, r) {
                            x(t1, e1, !0) || v(t1, e1, r, "deepStrictEqual", h.deepStrictEqual);
                        }, h.notDeepEqual = function(t1, e1, r) {
                            x(t1, e1, !1) && v(t1, e1, r, "notDeepEqual", h.notDeepEqual);
                        }, h.notDeepStrictEqual = function t1(e1, r, n) {
                            x(e1, r, !0) && v(e1, r, n, "notDeepStrictEqual", t1);
                        }, h.strictEqual = function(t1, e1, r) {
                            t1 !== e1 && v(t1, e1, r, "===", h.strictEqual);
                        }, h.notStrictEqual = function(t1, e1, r) {
                            t1 === e1 && v(t1, e1, r, "!==", h.notStrictEqual);
                        }, h.throws = function(t1, e1, r) {
                            w(!0, t1, e1, r);
                        }, h.doesNotThrow = function(t1, e1, r) {
                            w(!1, t1, e1, r);
                        }, h.ifError = function(t1) {
                            if (t1) throw t1;
                        }, h.strict = n(function t1(e1, r) {
                            e1 || v(e1, !0, r, "==", t1);
                        }, h, {
                            equal: h.strictEqual,
                            deepEqual: h.deepStrictEqual,
                            notEqual: h.notStrictEqual,
                            notDeepEqual: h.notDeepStrictEqual
                        }), h.strict.strict = h.strict;
                        var T = Object.keys || function(t1) {
                            var e1 = [];
                            for(var r in t1)s.call(t1, r) && e1.push(r);
                            return e1;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "object-assign": 247,
                "util/": 78
            }
        ],
        76: [
            function(t1, e1, r) {
                "function" == typeof Object.create ? e1.exports = function(t1, e1) {
                    t1.super_ = e1, t1.prototype = Object.create(e1.prototype, {
                        constructor: {
                            value: t1,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    });
                } : e1.exports = function(t1, e1) {
                    t1.super_ = e1;
                    var r = function() {};
                    r.prototype = e1.prototype, t1.prototype = new r, t1.prototype.constructor = t1;
                };
            },
            {}
        ],
        77: [
            function(t1, e1, r) {
                e1.exports = function(t1) {
                    return t1 && "object" == typeof t1 && "function" == typeof t1.copy && "function" == typeof t1.fill && "function" == typeof t1.readUInt8;
                };
            },
            {}
        ],
        78: [
            function(t1, e1, r) {
                (function(e1, n) {
                    (function() {
                        var i = /%[sdj%]/g;
                        r.format = function(t1) {
                            if (!v(t1)) {
                                for(var e1 = [], r = 0; r < arguments.length; r++)e1.push(s(arguments[r]));
                                return e1.join(" ");
                            }
                            r = 1;
                            for(var n = arguments, a = n.length, o = String(t1).replace(i, function(t1) {
                                if ("%%" === t1) return "%";
                                if (r >= a) return t1;
                                switch(t1){
                                    case "%s":
                                        return String(n[r++]);
                                    case "%d":
                                        return Number(n[r++]);
                                    case "%j":
                                        try {
                                            return JSON.stringify(n[r++]);
                                        } catch (t1) {
                                            return "[Circular]";
                                        }
                                    default:
                                        return t1;
                                }
                            }), l = n[r]; r < a; l = n[++r])m(l) || !b(l) ? o += " " + l : o += " " + s(l);
                            return o;
                        }, r.deprecate = function(t1, i) {
                            if (y(n.process)) return function() {
                                return r.deprecate(t1, i).apply(this, arguments);
                            };
                            if (!0 === e1.noDeprecation) return t1;
                            var a = !1;
                            return function() {
                                if (!a) {
                                    if (e1.throwDeprecation) throw new Error(i);
                                    e1.traceDeprecation ? console.trace(i) : console.error(i), a = !0;
                                }
                                return t1.apply(this, arguments);
                            };
                        };
                        var a, o = {};
                        function s(t1, e1) {
                            var n = {
                                seen: [],
                                stylize: c
                            };
                            return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), d(e1) ? n.showHidden = e1 : e1 && r._extend(n, e1), y(n.showHidden) && (n.showHidden = !1), y(n.depth) && (n.depth = 2), y(n.colors) && (n.colors = !1), y(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = l), u(n, t1, n.depth);
                        }
                        function l(t1, e1) {
                            var r = s.styles[e1];
                            return r ? "\x1b[" + s.colors[r][0] + "m" + t1 + "\x1b[" + s.colors[r][1] + "m" : t1;
                        }
                        function c(t1, e1) {
                            return t1;
                        }
                        function u(t1, e1, n) {
                            if (t1.customInspect && e1 && T(e1.inspect) && e1.inspect !== r.inspect && (!e1.constructor || e1.constructor.prototype !== e1)) {
                                var i = e1.inspect(n, t1);
                                return v(i) || (i = u(t1, i, n)), i;
                            }
                            var a = function(t1, e1) {
                                if (y(e1)) return t1.stylize("undefined", "undefined");
                                if (v(e1)) {
                                    var r = "'" + JSON.stringify(e1).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                                    return t1.stylize(r, "string");
                                }
                                if (g(e1)) return t1.stylize("" + e1, "number");
                                if (d(e1)) return t1.stylize("" + e1, "boolean");
                                if (m(e1)) return t1.stylize("null", "null");
                            }(t1, e1);
                            if (a) return a;
                            var o = Object.keys(e1), s = function(t1) {
                                var e1 = {};
                                return t1.forEach(function(t1, r) {
                                    e1[t1] = !0;
                                }), e1;
                            }(o);
                            if (t1.showHidden && (o = Object.getOwnPropertyNames(e1)), w(e1) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return f(e1);
                            if (0 === o.length) {
                                if (T(e1)) {
                                    var l = e1.name ? ": " + e1.name : "";
                                    return t1.stylize("[Function" + l + "]", "special");
                                }
                                if (x(e1)) return t1.stylize(RegExp.prototype.toString.call(e1), "regexp");
                                if (_(e1)) return t1.stylize(Date.prototype.toString.call(e1), "date");
                                if (w(e1)) return f(e1);
                            }
                            var c, b = "", k = !1, A = [
                                "{",
                                "}"
                            ];
                            (p(e1) && (k = !0, A = [
                                "[",
                                "]"
                            ]), T(e1)) && (b = " [Function" + (e1.name ? ": " + e1.name : "") + "]");
                            return x(e1) && (b = " " + RegExp.prototype.toString.call(e1)), _(e1) && (b = " " + Date.prototype.toUTCString.call(e1)), w(e1) && (b = " " + f(e1)), 0 !== o.length || k && 0 != e1.length ? n < 0 ? x(e1) ? t1.stylize(RegExp.prototype.toString.call(e1), "regexp") : t1.stylize("[Object]", "special") : (t1.seen.push(e1), c = k ? function(t1, e1, r, n, i) {
                                for(var a = [], o = 0, s = e1.length; o < s; ++o)E(e1, String(o)) ? a.push(h(t1, e1, r, n, String(o), !0)) : a.push("");
                                return i.forEach(function(i) {
                                    i.match(/^\d+$/) || a.push(h(t1, e1, r, n, i, !0));
                                }), a;
                            }(t1, e1, n, s, o) : o.map(function(r) {
                                return h(t1, e1, n, s, r, k);
                            }), t1.seen.pop(), function(t1, e1, r) {
                                if (t1.reduce(function(t1, e1) {
                                    return e1.indexOf("\n"), t1 + e1.replace(/\u001b\[\d\d?m/g, "").length + 1;
                                }, 0) > 60) return r[0] + ("" === e1 ? "" : e1 + "\n ") + " " + t1.join(",\n  ") + " " + r[1];
                                return r[0] + e1 + " " + t1.join(", ") + " " + r[1];
                            }(c, b, A)) : A[0] + b + A[1];
                        }
                        function f(t1) {
                            return "[" + Error.prototype.toString.call(t1) + "]";
                        }
                        function h(t1, e1, r, n, i, a) {
                            var o, s, l;
                            if ((l = Object.getOwnPropertyDescriptor(e1, i) || {
                                value: e1[i]
                            }).get ? s = l.set ? t1.stylize("[Getter/Setter]", "special") : t1.stylize("[Getter]", "special") : l.set && (s = t1.stylize("[Setter]", "special")), E(n, i) || (o = "[" + i + "]"), s || (t1.seen.indexOf(l.value) < 0 ? (s = m(r) ? u(t1, l.value, null) : u(t1, l.value, r - 1)).indexOf("\n") > -1 && (s = a ? s.split("\n").map(function(t1) {
                                return "  " + t1;
                            }).join("\n").substr(2) : "\n" + s.split("\n").map(function(t1) {
                                return "   " + t1;
                            }).join("\n")) : s = t1.stylize("[Circular]", "special")), y(o)) {
                                if (a && i.match(/^\d+$/)) return s;
                                (o = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = t1.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = t1.stylize(o, "string"));
                            }
                            return o + ": " + s;
                        }
                        function p(t1) {
                            return Array.isArray(t1);
                        }
                        function d(t1) {
                            return "boolean" == typeof t1;
                        }
                        function m(t1) {
                            return null === t1;
                        }
                        function g(t1) {
                            return "number" == typeof t1;
                        }
                        function v(t1) {
                            return "string" == typeof t1;
                        }
                        function y(t1) {
                            return void 0 === t1;
                        }
                        function x(t1) {
                            return b(t1) && "[object RegExp]" === k(t1);
                        }
                        function b(t1) {
                            return "object" == typeof t1 && null !== t1;
                        }
                        function _(t1) {
                            return b(t1) && "[object Date]" === k(t1);
                        }
                        function w(t1) {
                            return b(t1) && ("[object Error]" === k(t1) || t1 instanceof Error);
                        }
                        function T(t1) {
                            return "function" == typeof t1;
                        }
                        function k(t1) {
                            return Object.prototype.toString.call(t1);
                        }
                        function A(t1) {
                            return t1 < 10 ? "0" + t1.toString(10) : t1.toString(10);
                        }
                        r.debuglog = function(t1) {
                            if (y(a) && (a = e1.env.NODE_DEBUG || ""), t1 = t1.toUpperCase(), !o[t1]) {
                                if (new RegExp("\\b" + t1 + "\\b", "i").test(a)) {
                                    var n = e1.pid;
                                    o[t1] = function() {
                                        var e1 = r.format.apply(r, arguments);
                                        console.error("%s %d: %s", t1, n, e1);
                                    };
                                } else o[t1] = function() {};
                            }
                            return o[t1];
                        }, r.inspect = s, s.colors = {
                            bold: [
                                1,
                                22
                            ],
                            italic: [
                                3,
                                23
                            ],
                            underline: [
                                4,
                                24
                            ],
                            inverse: [
                                7,
                                27
                            ],
                            white: [
                                37,
                                39
                            ],
                            grey: [
                                90,
                                39
                            ],
                            black: [
                                30,
                                39
                            ],
                            blue: [
                                34,
                                39
                            ],
                            cyan: [
                                36,
                                39
                            ],
                            green: [
                                32,
                                39
                            ],
                            magenta: [
                                35,
                                39
                            ],
                            red: [
                                31,
                                39
                            ],
                            yellow: [
                                33,
                                39
                            ]
                        }, s.styles = {
                            special: "cyan",
                            number: "yellow",
                            boolean: "yellow",
                            undefined: "grey",
                            null: "bold",
                            string: "green",
                            date: "magenta",
                            regexp: "red"
                        }, r.isArray = p, r.isBoolean = d, r.isNull = m, r.isNullOrUndefined = function(t1) {
                            return null == t1;
                        }, r.isNumber = g, r.isString = v, r.isSymbol = function(t1) {
                            return "symbol" == typeof t1;
                        }, r.isUndefined = y, r.isRegExp = x, r.isObject = b, r.isDate = _, r.isError = w, r.isFunction = T, r.isPrimitive = function(t1) {
                            return null === t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || "symbol" == typeof t1 || void 0 === t1;
                        }, r.isBuffer = t1("./support/isBuffer");
                        var M = [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ];
                        function S() {
                            var t1 = new Date, e1 = [
                                A(t1.getHours()),
                                A(t1.getMinutes()),
                                A(t1.getSeconds())
                            ].join(":");
                            return [
                                t1.getDate(),
                                M[t1.getMonth()],
                                e1
                            ].join(" ");
                        }
                        function E(t1, e1) {
                            return Object.prototype.hasOwnProperty.call(t1, e1);
                        }
                        r.log = function() {
                            console.log("%s - %s", S(), r.format.apply(r, arguments));
                        }, r.inherits = t1("inherits"), r._extend = function(t1, e1) {
                            if (!e1 || !b(e1)) return t1;
                            for(var r = Object.keys(e1), n = r.length; n--;)t1[r[n]] = e1[r[n]];
                            return t1;
                        };
                    }).call(this);
                }).call(this, t1("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./support/isBuffer": 77,
                _process: 277,
                inherits: 76
            }
        ],
        79: [
            function(t1, e1, r) {
                "use strict";
                r.byteLength = function(t1) {
                    var e1 = c(t1), r = e1[0], n = e1[1];
                    return 3 * (r + n) / 4 - n;
                }, r.toByteArray = function(t1) {
                    var e1, r, n = c(t1), o = n[0], s = n[1], l = new a(function(t1, e1, r) {
                        return 3 * (e1 + r) / 4 - r;
                    }(0, o, s)), u = 0, f = s > 0 ? o - 4 : o;
                    for(r = 0; r < f; r += 4)e1 = i[t1.charCodeAt(r)] << 18 | i[t1.charCodeAt(r + 1)] << 12 | i[t1.charCodeAt(r + 2)] << 6 | i[t1.charCodeAt(r + 3)], l[u++] = e1 >> 16 & 255, l[u++] = e1 >> 8 & 255, l[u++] = 255 & e1;
                    2 === s && (e1 = i[t1.charCodeAt(r)] << 2 | i[t1.charCodeAt(r + 1)] >> 4, l[u++] = 255 & e1);
                    1 === s && (e1 = i[t1.charCodeAt(r)] << 10 | i[t1.charCodeAt(r + 1)] << 4 | i[t1.charCodeAt(r + 2)] >> 2, l[u++] = e1 >> 8 & 255, l[u++] = 255 & e1);
                    return l;
                }, r.fromByteArray = function(t1) {
                    for(var e1, r = t1.length, i = r % 3, a = [], o = 0, s = r - i; o < s; o += 16383)a.push(u(t1, o, o + 16383 > s ? s : o + 16383));
                    1 === i ? (e1 = t1[r - 1], a.push(n[e1 >> 2] + n[e1 << 4 & 63] + "==")) : 2 === i && (e1 = (t1[r - 2] << 8) + t1[r - 1], a.push(n[e1 >> 10] + n[e1 >> 4 & 63] + n[e1 << 2 & 63] + "="));
                    return a.join("");
                };
                for(var n = [], i = [], a = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, l = o.length; s < l; ++s)n[s] = o[s], i[o.charCodeAt(s)] = s;
                function c(t1) {
                    var e1 = t1.length;
                    if (e1 % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    var r = t1.indexOf("=");
                    return -1 === r && (r = e1), [
                        r,
                        r === e1 ? 0 : 4 - r % 4
                    ];
                }
                function u(t1, e1, r) {
                    for(var i, a, o = [], s = e1; s < r; s += 3)i = (t1[s] << 16 & 16711680) + (t1[s + 1] << 8 & 65280) + (255 & t1[s + 2]), o.push(n[(a = i) >> 18 & 63] + n[a >> 12 & 63] + n[a >> 6 & 63] + n[63 & a]);
                    return o.join("");
                }
                i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
            },
            {}
        ],
        80: [
            function(t1, e1, r) {
                "use strict";
                function n(t1, e1, r, n, i) {
                    for(var a = i + 1; n <= i;){
                        var o = n + i >>> 1, s = t1[o];
                        (void 0 !== r ? r(s, e1) : s - e1) >= 0 ? (a = o, i = o - 1) : n = o + 1;
                    }
                    return a;
                }
                function i(t1, e1, r, n, i) {
                    for(var a = i + 1; n <= i;){
                        var o = n + i >>> 1, s = t1[o];
                        (void 0 !== r ? r(s, e1) : s - e1) > 0 ? (a = o, i = o - 1) : n = o + 1;
                    }
                    return a;
                }
                function a(t1, e1, r, n, i) {
                    for(var a = n - 1; n <= i;){
                        var o = n + i >>> 1, s = t1[o];
                        (void 0 !== r ? r(s, e1) : s - e1) < 0 ? (a = o, n = o + 1) : i = o - 1;
                    }
                    return a;
                }
                function o(t1, e1, r, n, i) {
                    for(var a = n - 1; n <= i;){
                        var o = n + i >>> 1, s = t1[o];
                        (void 0 !== r ? r(s, e1) : s - e1) <= 0 ? (a = o, n = o + 1) : i = o - 1;
                    }
                    return a;
                }
                function s(t1, e1, r, n, i) {
                    for(; n <= i;){
                        var a = n + i >>> 1, o = t1[a], s = void 0 !== r ? r(o, e1) : o - e1;
                        if (0 === s) return a;
                        s <= 0 ? n = a + 1 : i = a - 1;
                    }
                    return -1;
                }
                function l(t1, e1, r, n, i, a) {
                    return "function" == typeof r ? a(t1, e1, r, void 0 === n ? 0 : 0 | n, void 0 === i ? t1.length - 1 : 0 | i) : a(t1, e1, void 0, void 0 === r ? 0 : 0 | r, void 0 === n ? t1.length - 1 : 0 | n);
                }
                e1.exports = {
                    ge: function(t1, e1, r, i, a) {
                        return l(t1, e1, r, i, a, n);
                    },
                    gt: function(t1, e1, r, n, a) {
                        return l(t1, e1, r, n, a, i);
                    },
                    lt: function(t1, e1, r, n, i) {
                        return l(t1, e1, r, n, i, a);
                    },
                    le: function(t1, e1, r, n, i) {
                        return l(t1, e1, r, n, i, o);
                    },
                    eq: function(t1, e1, r, n, i) {
                        return l(t1, e1, r, n, i, s);
                    }
                };
            },
            {}
        ],
        81: [
            function(t1, e1, r) {
                "use strict";
                function n(t1) {
                    var e1 = 32;
                    return (t1 &= -t1) && e1--, 65535 & t1 && (e1 -= 16), 16711935 & t1 && (e1 -= 8), 252645135 & t1 && (e1 -= 4), 858993459 & t1 && (e1 -= 2), 1431655765 & t1 && (e1 -= 1), e1;
                }
                r.INT_BITS = 32, r.INT_MAX = 2147483647, r.INT_MIN = -2147483648, r.sign = function(t1) {
                    return (t1 > 0) - (t1 < 0);
                }, r.abs = function(t1) {
                    var e1 = t1 >> 31;
                    return (t1 ^ e1) - e1;
                }, r.min = function(t1, e1) {
                    return e1 ^ (t1 ^ e1) & -(t1 < e1);
                }, r.max = function(t1, e1) {
                    return t1 ^ (t1 ^ e1) & -(t1 < e1);
                }, r.isPow2 = function(t1) {
                    return !(t1 & t1 - 1 || !t1);
                }, r.log2 = function(t1) {
                    var e1, r;
                    return e1 = (t1 > 65535) << 4, e1 |= r = ((t1 >>>= e1) > 255) << 3, e1 |= r = ((t1 >>>= r) > 15) << 2, (e1 |= r = ((t1 >>>= r) > 3) << 1) | (t1 >>>= r) >> 1;
                }, r.log10 = function(t1) {
                    return t1 >= 1e9 ? 9 : t1 >= 1e8 ? 8 : t1 >= 1e7 ? 7 : t1 >= 1e6 ? 6 : t1 >= 1e5 ? 5 : t1 >= 1e4 ? 4 : t1 >= 1e3 ? 3 : t1 >= 100 ? 2 : t1 >= 10 ? 1 : 0;
                }, r.popCount = function(t1) {
                    return 16843009 * ((t1 = (858993459 & (t1 -= t1 >>> 1 & 1431655765)) + (t1 >>> 2 & 858993459)) + (t1 >>> 4) & 252645135) >>> 24;
                }, r.countTrailingZeros = n, r.nextPow2 = function(t1) {
                    return t1 += 0 === t1, --t1, t1 |= t1 >>> 1, t1 |= t1 >>> 2, t1 |= t1 >>> 4, t1 |= t1 >>> 8, (t1 |= t1 >>> 16) + 1;
                }, r.prevPow2 = function(t1) {
                    return t1 |= t1 >>> 1, t1 |= t1 >>> 2, t1 |= t1 >>> 4, t1 |= t1 >>> 8, (t1 |= t1 >>> 16) - (t1 >>> 1);
                }, r.parity = function(t1) {
                    return t1 ^= t1 >>> 16, t1 ^= t1 >>> 8, t1 ^= t1 >>> 4, 27030 >>> (t1 &= 15) & 1;
                };
                var i = new Array(256);
                !function(t1) {
                    for(var e1 = 0; e1 < 256; ++e1){
                        var r = e1, n = e1, i = 7;
                        for(r >>>= 1; r; r >>>= 1)n <<= 1, n |= 1 & r, --i;
                        t1[e1] = n << i & 255;
                    }
                }(i), r.reverse = function(t1) {
                    return i[255 & t1] << 24 | i[t1 >>> 8 & 255] << 16 | i[t1 >>> 16 & 255] << 8 | i[t1 >>> 24 & 255];
                }, r.interleave2 = function(t1, e1) {
                    return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 &= 65535) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 &= 65535) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
                }, r.deinterleave2 = function(t1, e1) {
                    return (t1 = 65535 & ((t1 = 16711935 & ((t1 = 252645135 & ((t1 = 858993459 & ((t1 = t1 >>> e1 & 1431655765) | t1 >>> 1)) | t1 >>> 2)) | t1 >>> 4)) | t1 >>> 16)) << 16 >> 16;
                }, r.interleave3 = function(t1, e1, r) {
                    return t1 = 1227133513 & ((t1 = 3272356035 & ((t1 = 251719695 & ((t1 = 4278190335 & ((t1 &= 1023) | t1 << 16)) | t1 << 8)) | t1 << 4)) | t1 << 2), (t1 |= (e1 = 1227133513 & ((e1 = 3272356035 & ((e1 = 251719695 & ((e1 = 4278190335 & ((e1 &= 1023) | e1 << 16)) | e1 << 8)) | e1 << 4)) | e1 << 2)) << 1) | (r = 1227133513 & ((r = 3272356035 & ((r = 251719695 & ((r = 4278190335 & ((r &= 1023) | r << 16)) | r << 8)) | r << 4)) | r << 2)) << 2;
                }, r.deinterleave3 = function(t1, e1) {
                    return (t1 = 1023 & ((t1 = 4278190335 & ((t1 = 251719695 & ((t1 = 3272356035 & ((t1 = t1 >>> e1 & 1227133513) | t1 >>> 2)) | t1 >>> 4)) | t1 >>> 8)) | t1 >>> 16)) << 22 >> 22;
                }, r.nextCombination = function(t1) {
                    var e1 = t1 | t1 - 1;
                    return e1 + 1 | (~e1 & -~e1) - 1 >>> n(t1) + 1;
                };
            },
            {}
        ],
        82: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("clamp");
                e1.exports = function(t1, e1) {
                    e1 || (e1 = {});
                    var r, o, s, l, c, u, f, h, p, d, m, g = null == e1.cutoff ? .25 : e1.cutoff, v = null == e1.radius ? 8 : e1.radius, y = e1.channel || 0;
                    if (ArrayBuffer.isView(t1) || Array.isArray(t1)) {
                        if (!e1.width || !e1.height) throw Error("For raw data width and height should be provided by options");
                        r = e1.width, o = e1.height, l = t1, u = e1.stride ? e1.stride : Math.floor(t1.length / r / o);
                    } else window.HTMLCanvasElement && t1 instanceof window.HTMLCanvasElement ? (f = (h = t1).getContext("2d"), r = h.width, o = h.height, p = f.getImageData(0, 0, r, o), l = p.data, u = 4) : window.CanvasRenderingContext2D && t1 instanceof window.CanvasRenderingContext2D ? (h = t1.canvas, f = t1, r = h.width, o = h.height, p = f.getImageData(0, 0, r, o), l = p.data, u = 4) : window.ImageData && t1 instanceof window.ImageData && (p = t1, r = t1.width, o = t1.height, l = p.data, u = 4);
                    if (s = Math.max(r, o), window.Uint8ClampedArray && l instanceof window.Uint8ClampedArray || window.Uint8Array && l instanceof window.Uint8Array) for(c = l, l = Array(r * o), d = 0, m = c.length; d < m; d++)l[d] = c[d * u + y] / 255;
                    else if (1 !== u) throw Error("Raw data can have only 1 value per pixel");
                    var x = Array(r * o), b = Array(r * o), _ = Array(s), w = Array(s), T = Array(s + 1), k = Array(s);
                    for(d = 0, m = r * o; d < m; d++){
                        var A = l[d];
                        x[d] = 1 === A ? 0 : 0 === A ? i : Math.pow(Math.max(0, .5 - A), 2), b[d] = 1 === A ? i : 0 === A ? 0 : Math.pow(Math.max(0, A - .5), 2);
                    }
                    a(x, r, o, _, w, k, T), a(b, r, o, _, w, k, T);
                    var M = window.Float32Array ? new Float32Array(r * o) : new Array(r * o);
                    for(d = 0, m = r * o; d < m; d++)M[d] = n(1 - ((x[d] - b[d]) / v + g), 0, 1);
                    return M;
                };
                var i = 1e20;
                function a(t1, e1, r, n, i, a, s) {
                    for(var l = 0; l < e1; l++){
                        for(var c = 0; c < r; c++)n[c] = t1[c * e1 + l];
                        for(o(n, i, a, s, r), c = 0; c < r; c++)t1[c * e1 + l] = i[c];
                    }
                    for(c = 0; c < r; c++){
                        for(l = 0; l < e1; l++)n[l] = t1[c * e1 + l];
                        for(o(n, i, a, s, e1), l = 0; l < e1; l++)t1[c * e1 + l] = Math.sqrt(i[l]);
                    }
                }
                function o(t1, e1, r, n, a) {
                    r[0] = 0, n[0] = -i, n[1] = +i;
                    for(var o = 1, s = 0; o < a; o++){
                        for(var l = (t1[o] + o * o - (t1[r[s]] + r[s] * r[s])) / (2 * o - 2 * r[s]); l <= n[s];)s--, l = (t1[o] + o * o - (t1[r[s]] + r[s] * r[s])) / (2 * o - 2 * r[s]);
                        r[++s] = o, n[s] = l, n[s + 1] = +i;
                    }
                    for(o = 0, s = 0; o < a; o++){
                        for(; n[s + 1] < o;)s++;
                        e1[o] = (o - r[s]) * (o - r[s]) + t1[r[s]];
                    }
                }
            },
            {
                clamp: 86
            }
        ],
        83: [
            function(t1, e1, r) {},
            {}
        ],
        84: [
            function(t1, e1, r) {
                "use strict";
                var n, i = "object" == typeof Reflect ? Reflect : null, a = i && "function" == typeof i.apply ? i.apply : function(t1, e1, r) {
                    return Function.prototype.apply.call(t1, e1, r);
                };
                n = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function(t1) {
                    return Object.getOwnPropertyNames(t1).concat(Object.getOwnPropertySymbols(t1));
                } : function(t1) {
                    return Object.getOwnPropertyNames(t1);
                };
                var o = Number.isNaN || function(t1) {
                    return t1 != t1;
                };
                function s() {
                    s.init.call(this);
                }
                e1.exports = s, e1.exports.once = function(t1, e1) {
                    return new Promise(function(r, n) {
                        function i() {
                            void 0 !== a && t1.removeListener("error", a), r([].slice.call(arguments));
                        }
                        var a;
                        "error" !== e1 && (a = function(r) {
                            t1.removeListener(e1, i), n(r);
                        }, t1.once("error", a)), t1.once(e1, i);
                    });
                }, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
                var l = 10;
                function c(t1) {
                    if ("function" != typeof t1) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t1);
                }
                function u(t1) {
                    return void 0 === t1._maxListeners ? s.defaultMaxListeners : t1._maxListeners;
                }
                function f(t1, e1, r, n) {
                    var i, a, o, s;
                    if (c(r), void 0 === (a = t1._events) ? (a = t1._events = Object.create(null), t1._eventsCount = 0) : (void 0 !== a.newListener && (t1.emit("newListener", e1, r.listener ? r.listener : r), a = t1._events), o = a[e1]), void 0 === o) o = a[e1] = r, ++t1._eventsCount;
                    else if ("function" == typeof o ? o = a[e1] = n ? [
                        r,
                        o
                    ] : [
                        o,
                        r
                    ] : n ? o.unshift(r) : o.push(r), (i = u(t1)) > 0 && o.length > i && !o.warned) {
                        o.warned = !0;
                        var l = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(e1) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                        l.name = "MaxListenersExceededWarning", l.emitter = t1, l.type = e1, l.count = o.length, s = l, console && console.warn && console.warn(s);
                    }
                    return t1;
                }
                function h() {
                    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                }
                function p(t1, e1, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: t1,
                        type: e1,
                        listener: r
                    }, i = h.bind(n);
                    return i.listener = r, n.wrapFn = i, i;
                }
                function d(t1, e1, r) {
                    var n = t1._events;
                    if (void 0 === n) return [];
                    var i = n[e1];
                    return void 0 === i ? [] : "function" == typeof i ? r ? [
                        i.listener || i
                    ] : [
                        i
                    ] : r ? function(t1) {
                        for(var e1 = new Array(t1.length), r = 0; r < e1.length; ++r)e1[r] = t1[r].listener || t1[r];
                        return e1;
                    }(i) : g(i, i.length);
                }
                function m(t1) {
                    var e1 = this._events;
                    if (void 0 !== e1) {
                        var r = e1[t1];
                        if ("function" == typeof r) return 1;
                        if (void 0 !== r) return r.length;
                    }
                    return 0;
                }
                function g(t1, e1) {
                    for(var r = new Array(e1), n = 0; n < e1; ++n)r[n] = t1[n];
                    return r;
                }
                Object.defineProperty(s, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return l;
                    },
                    set: function(t1) {
                        if ("number" != typeof t1 || t1 < 0 || o(t1)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t1 + ".");
                        l = t1;
                    }
                }), s.init = function() {
                    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }, s.prototype.setMaxListeners = function(t1) {
                    if ("number" != typeof t1 || t1 < 0 || o(t1)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t1 + ".");
                    return this._maxListeners = t1, this;
                }, s.prototype.getMaxListeners = function() {
                    return u(this);
                }, s.prototype.emit = function(t1) {
                    for(var e1 = [], r = 1; r < arguments.length; r++)e1.push(arguments[r]);
                    var n = "error" === t1, i = this._events;
                    if (void 0 !== i) n = n && void 0 === i.error;
                    else if (!n) return !1;
                    if (n) {
                        var o;
                        if (e1.length > 0 && (o = e1[0]), o instanceof Error) throw o;
                        var s = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
                        throw s.context = o, s;
                    }
                    var l = i[t1];
                    if (void 0 === l) return !1;
                    if ("function" == typeof l) a(l, this, e1);
                    else {
                        var c = l.length, u = g(l, c);
                        for(r = 0; r < c; ++r)a(u[r], this, e1);
                    }
                    return !0;
                }, s.prototype.addListener = function(t1, e1) {
                    return f(this, t1, e1, !1);
                }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function(t1, e1) {
                    return f(this, t1, e1, !0);
                }, s.prototype.once = function(t1, e1) {
                    return c(e1), this.on(t1, p(this, t1, e1)), this;
                }, s.prototype.prependOnceListener = function(t1, e1) {
                    return c(e1), this.prependListener(t1, p(this, t1, e1)), this;
                }, s.prototype.removeListener = function(t1, e1) {
                    var r, n, i, a, o;
                    if (c(e1), void 0 === (n = this._events)) return this;
                    if (void 0 === (r = n[t1])) return this;
                    if (r === e1 || r.listener === e1) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t1], n.removeListener && this.emit("removeListener", t1, r.listener || e1));
                    else if ("function" != typeof r) {
                        for(i = -1, a = r.length - 1; a >= 0; a--)if (r[a] === e1 || r[a].listener === e1) {
                            o = r[a].listener, i = a;
                            break;
                        }
                        if (i < 0) return this;
                        0 === i ? r.shift() : function(t1, e1) {
                            for(; e1 + 1 < t1.length; e1++)t1[e1] = t1[e1 + 1];
                            t1.pop();
                        }(r, i), 1 === r.length && (n[t1] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", t1, o || e1);
                    }
                    return this;
                }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function(t1) {
                    var e1, r, n;
                    if (void 0 === (r = this._events)) return this;
                    if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[t1] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[t1]), this;
                    if (0 === arguments.length) {
                        var i, a = Object.keys(r);
                        for(n = 0; n < a.length; ++n)"removeListener" !== (i = a[n]) && this.removeAllListeners(i);
                        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (e1 = r[t1])) this.removeListener(t1, e1);
                    else if (void 0 !== e1) for(n = e1.length - 1; n >= 0; n--)this.removeListener(t1, e1[n]);
                    return this;
                }, s.prototype.listeners = function(t1) {
                    return d(this, t1, !0);
                }, s.prototype.rawListeners = function(t1) {
                    return d(this, t1, !1);
                }, s.listenerCount = function(t1, e1) {
                    return "function" == typeof t1.listenerCount ? t1.listenerCount(e1) : m.call(t1, e1);
                }, s.prototype.listenerCount = m, s.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? n(this._events) : [];
                };
            },
            {}
        ],
        85: [
            function(t1, e1, r) {
                (function(e1) {
                    (function() {
                        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ "use strict";
                        var e1 = t1("base64-js"), n = t1("ieee754");
                        r.Buffer = a, r.SlowBuffer = function(t1) {
                            +t1 != t1 && (t1 = 0);
                            return a.alloc(+t1);
                        }, r.INSPECT_MAX_BYTES = 50;
                        function i(t1) {
                            if (t1 > 2147483647) throw new RangeError('The value "' + t1 + '" is invalid for option "size"');
                            var e1 = new Uint8Array(t1);
                            return e1.__proto__ = a.prototype, e1;
                        }
                        function a(t1, e1, r) {
                            if ("number" == typeof t1) {
                                if ("string" == typeof e1) throw new TypeError('The "string" argument must be of type string. Received type number');
                                return l(t1);
                            }
                            return o(t1, e1, r);
                        }
                        function o(t1, e1, r) {
                            if ("string" == typeof t1) return function(t1, e1) {
                                "string" == typeof e1 && "" !== e1 || (e1 = "utf8");
                                if (!a.isEncoding(e1)) throw new TypeError("Unknown encoding: " + e1);
                                var r = 0 | f(t1, e1), n = i(r), o = n.write(t1, e1);
                                o !== r && (n = n.slice(0, o));
                                return n;
                            }(t1, e1);
                            if (ArrayBuffer.isView(t1)) return c(t1);
                            if (null == t1) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t1);
                            if (B(t1, ArrayBuffer) || t1 && B(t1.buffer, ArrayBuffer)) return function(t1, e1, r) {
                                if (e1 < 0 || t1.byteLength < e1) throw new RangeError('"offset" is outside of buffer bounds');
                                if (t1.byteLength < e1 + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                var n;
                                n = void 0 === e1 && void 0 === r ? new Uint8Array(t1) : void 0 === r ? new Uint8Array(t1, e1) : new Uint8Array(t1, e1, r);
                                return n.__proto__ = a.prototype, n;
                            }(t1, e1, r);
                            if ("number" == typeof t1) throw new TypeError('The "value" argument must not be of type number. Received type number');
                            var n = t1.valueOf && t1.valueOf();
                            if (null != n && n !== t1) return a.from(n, e1, r);
                            var o = function(t1) {
                                if (a.isBuffer(t1)) {
                                    var e1 = 0 | u(t1.length), r = i(e1);
                                    return 0 === r.length || t1.copy(r, 0, 0, e1), r;
                                }
                                if (void 0 !== t1.length) return "number" != typeof t1.length || N(t1.length) ? i(0) : c(t1);
                                if ("Buffer" === t1.type && Array.isArray(t1.data)) return c(t1.data);
                            }(t1);
                            if (o) return o;
                            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof t1[Symbol.toPrimitive]) return a.from(t1[Symbol.toPrimitive]("string"), e1, r);
                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t1);
                        }
                        function s(t1) {
                            if ("number" != typeof t1) throw new TypeError('"size" argument must be of type number');
                            if (t1 < 0) throw new RangeError('The value "' + t1 + '" is invalid for option "size"');
                        }
                        function l(t1) {
                            return s(t1), i(t1 < 0 ? 0 : 0 | u(t1));
                        }
                        function c(t1) {
                            for(var e1 = t1.length < 0 ? 0 : 0 | u(t1.length), r = i(e1), n = 0; n < e1; n += 1)r[n] = 255 & t1[n];
                            return r;
                        }
                        function u(t1) {
                            if (t1 >= 2147483647) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + 2147483647..toString(16) + " bytes");
                            return 0 | t1;
                        }
                        function f(t1, e1) {
                            if (a.isBuffer(t1)) return t1.length;
                            if (ArrayBuffer.isView(t1) || B(t1, ArrayBuffer)) return t1.byteLength;
                            if ("string" != typeof t1) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof t1);
                            var r = t1.length, n = arguments.length > 2 && !0 === arguments[2];
                            if (!n && 0 === r) return 0;
                            for(var i = !1;;)switch(e1){
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return r;
                                case "utf8":
                                case "utf-8":
                                    return D(t1).length;
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return 2 * r;
                                case "hex":
                                    return r >>> 1;
                                case "base64":
                                    return R(t1).length;
                                default:
                                    if (i) return n ? -1 : D(t1).length;
                                    e1 = ("" + e1).toLowerCase(), i = !0;
                            }
                        }
                        function h(t1, e1, r) {
                            var n = !1;
                            if ((void 0 === e1 || e1 < 0) && (e1 = 0), e1 > this.length) return "";
                            if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                            if ((r >>>= 0) <= (e1 >>>= 0)) return "";
                            for(t1 || (t1 = "utf8");;)switch(t1){
                                case "hex":
                                    return M(this, e1, r);
                                case "utf8":
                                case "utf-8":
                                    return T(this, e1, r);
                                case "ascii":
                                    return k(this, e1, r);
                                case "latin1":
                                case "binary":
                                    return A(this, e1, r);
                                case "base64":
                                    return w(this, e1, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return S(this, e1, r);
                                default:
                                    if (n) throw new TypeError("Unknown encoding: " + t1);
                                    t1 = (t1 + "").toLowerCase(), n = !0;
                            }
                        }
                        function p(t1, e1, r) {
                            var n = t1[e1];
                            t1[e1] = t1[r], t1[r] = n;
                        }
                        function d(t1, e1, r, n, i) {
                            if (0 === t1.length) return -1;
                            if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), N(r = +r) && (r = i ? 0 : t1.length - 1), r < 0 && (r = t1.length + r), r >= t1.length) {
                                if (i) return -1;
                                r = t1.length - 1;
                            } else if (r < 0) {
                                if (!i) return -1;
                                r = 0;
                            }
                            if ("string" == typeof e1 && (e1 = a.from(e1, n)), a.isBuffer(e1)) return 0 === e1.length ? -1 : m(t1, e1, r, n, i);
                            if ("number" == typeof e1) return e1 &= 255, "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t1, e1, r) : Uint8Array.prototype.lastIndexOf.call(t1, e1, r) : m(t1, [
                                e1
                            ], r, n, i);
                            throw new TypeError("val must be string, number or Buffer");
                        }
                        function m(t1, e1, r, n, i) {
                            var a, o = 1, s = t1.length, l = e1.length;
                            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                                if (t1.length < 2 || e1.length < 2) return -1;
                                o = 2, s /= 2, l /= 2, r /= 2;
                            }
                            function c(t1, e1) {
                                return 1 === o ? t1[e1] : t1.readUInt16BE(e1 * o);
                            }
                            if (i) {
                                var u = -1;
                                for(a = r; a < s; a++)if (c(t1, a) === c(e1, -1 === u ? 0 : a - u)) {
                                    if (-1 === u && (u = a), a - u + 1 === l) return u * o;
                                } else -1 !== u && (a -= a - u), u = -1;
                            } else for(r + l > s && (r = s - l), a = r; a >= 0; a--){
                                for(var f = !0, h = 0; h < l; h++)if (c(t1, a + h) !== c(e1, h)) {
                                    f = !1;
                                    break;
                                }
                                if (f) return a;
                            }
                            return -1;
                        }
                        function g(t1, e1, r, n) {
                            r = Number(r) || 0;
                            var i = t1.length - r;
                            n ? (n = Number(n)) > i && (n = i) : n = i;
                            var a = e1.length;
                            n > a / 2 && (n = a / 2);
                            for(var o = 0; o < n; ++o){
                                var s = parseInt(e1.substr(2 * o, 2), 16);
                                if (N(s)) return o;
                                t1[r + o] = s;
                            }
                            return o;
                        }
                        function v(t1, e1, r, n) {
                            return F(D(e1, t1.length - r), t1, r, n);
                        }
                        function y(t1, e1, r, n) {
                            return F(function(t1) {
                                for(var e1 = [], r = 0; r < t1.length; ++r)e1.push(255 & t1.charCodeAt(r));
                                return e1;
                            }(e1), t1, r, n);
                        }
                        function x(t1, e1, r, n) {
                            return y(t1, e1, r, n);
                        }
                        function b(t1, e1, r, n) {
                            return F(R(e1), t1, r, n);
                        }
                        function _(t1, e1, r, n) {
                            return F(function(t1, e1) {
                                for(var r, n, i, a = [], o = 0; o < t1.length && !((e1 -= 2) < 0); ++o)r = t1.charCodeAt(o), n = r >> 8, i = r % 256, a.push(i), a.push(n);
                                return a;
                            }(e1, t1.length - r), t1, r, n);
                        }
                        function w(t1, r, n) {
                            return 0 === r && n === t1.length ? e1.fromByteArray(t1) : e1.fromByteArray(t1.slice(r, n));
                        }
                        function T(t1, e1, r) {
                            r = Math.min(t1.length, r);
                            for(var n = [], i = e1; i < r;){
                                var a, o, s, l, c = t1[i], u = null, f = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
                                if (i + f <= r) switch(f){
                                    case 1:
                                        c < 128 && (u = c);
                                        break;
                                    case 2:
                                        128 == (192 & (a = t1[i + 1])) && (l = (31 & c) << 6 | 63 & a) > 127 && (u = l);
                                        break;
                                    case 3:
                                        a = t1[i + 1], o = t1[i + 2], 128 == (192 & a) && 128 == (192 & o) && (l = (15 & c) << 12 | (63 & a) << 6 | 63 & o) > 2047 && (l < 55296 || l > 57343) && (u = l);
                                        break;
                                    case 4:
                                        a = t1[i + 1], o = t1[i + 2], s = t1[i + 3], 128 == (192 & a) && 128 == (192 & o) && 128 == (192 & s) && (l = (15 & c) << 18 | (63 & a) << 12 | (63 & o) << 6 | 63 & s) > 65535 && l < 1114112 && (u = l);
                                }
                                null === u ? (u = 65533, f = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += f;
                            }
                            return function(t1) {
                                var e1 = t1.length;
                                if (e1 <= 4096) return String.fromCharCode.apply(String, t1);
                                var r = "", n = 0;
                                for(; n < e1;)r += String.fromCharCode.apply(String, t1.slice(n, n += 4096));
                                return r;
                            }(n);
                        }
                        r.kMaxLength = 2147483647, a.TYPED_ARRAY_SUPPORT = function() {
                            try {
                                var t1 = new Uint8Array(1);
                                return t1.__proto__ = {
                                    __proto__: Uint8Array.prototype,
                                    foo: function() {
                                        return 42;
                                    }
                                }, 42 === t1.foo();
                            } catch (t1) {
                                return !1;
                            }
                        }(), a.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(a.prototype, "parent", {
                            enumerable: !0,
                            get: function() {
                                if (a.isBuffer(this)) return this.buffer;
                            }
                        }), Object.defineProperty(a.prototype, "offset", {
                            enumerable: !0,
                            get: function() {
                                if (a.isBuffer(this)) return this.byteOffset;
                            }
                        }), "undefined" != typeof Symbol && null != Symbol.species && a[Symbol.species] === a && Object.defineProperty(a, Symbol.species, {
                            value: null,
                            configurable: !0,
                            enumerable: !1,
                            writable: !1
                        }), a.poolSize = 8192, a.from = function(t1, e1, r) {
                            return o(t1, e1, r);
                        }, a.prototype.__proto__ = Uint8Array.prototype, a.__proto__ = Uint8Array, a.alloc = function(t1, e1, r) {
                            return function(t1, e1, r) {
                                return s(t1), t1 <= 0 ? i(t1) : void 0 !== e1 ? "string" == typeof r ? i(t1).fill(e1, r) : i(t1).fill(e1) : i(t1);
                            }(t1, e1, r);
                        }, a.allocUnsafe = function(t1) {
                            return l(t1);
                        }, a.allocUnsafeSlow = function(t1) {
                            return l(t1);
                        }, a.isBuffer = function(t1) {
                            return null != t1 && !0 === t1._isBuffer && t1 !== a.prototype;
                        }, a.compare = function(t1, e1) {
                            if (B(t1, Uint8Array) && (t1 = a.from(t1, t1.offset, t1.byteLength)), B(e1, Uint8Array) && (e1 = a.from(e1, e1.offset, e1.byteLength)), !a.isBuffer(t1) || !a.isBuffer(e1)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                            if (t1 === e1) return 0;
                            for(var r = t1.length, n = e1.length, i = 0, o = Math.min(r, n); i < o; ++i)if (t1[i] !== e1[i]) {
                                r = t1[i], n = e1[i];
                                break;
                            }
                            return r < n ? -1 : n < r ? 1 : 0;
                        }, a.isEncoding = function(t1) {
                            switch(String(t1).toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "latin1":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }, a.concat = function(t1, e1) {
                            if (!Array.isArray(t1)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (0 === t1.length) return a.alloc(0);
                            var r;
                            if (void 0 === e1) for(e1 = 0, r = 0; r < t1.length; ++r)e1 += t1[r].length;
                            var n = a.allocUnsafe(e1), i = 0;
                            for(r = 0; r < t1.length; ++r){
                                var o = t1[r];
                                if (B(o, Uint8Array) && (o = a.from(o)), !a.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
                                o.copy(n, i), i += o.length;
                            }
                            return n;
                        }, a.byteLength = f, a.prototype._isBuffer = !0, a.prototype.swap16 = function() {
                            var t1 = this.length;
                            if (t1 % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                            for(var e1 = 0; e1 < t1; e1 += 2)p(this, e1, e1 + 1);
                            return this;
                        }, a.prototype.swap32 = function() {
                            var t1 = this.length;
                            if (t1 % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                            for(var e1 = 0; e1 < t1; e1 += 4)p(this, e1, e1 + 3), p(this, e1 + 1, e1 + 2);
                            return this;
                        }, a.prototype.swap64 = function() {
                            var t1 = this.length;
                            if (t1 % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                            for(var e1 = 0; e1 < t1; e1 += 8)p(this, e1, e1 + 7), p(this, e1 + 1, e1 + 6), p(this, e1 + 2, e1 + 5), p(this, e1 + 3, e1 + 4);
                            return this;
                        }, a.prototype.toString = function() {
                            var t1 = this.length;
                            return 0 === t1 ? "" : 0 === arguments.length ? T(this, 0, t1) : h.apply(this, arguments);
                        }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(t1) {
                            if (!a.isBuffer(t1)) throw new TypeError("Argument must be a Buffer");
                            return this === t1 || 0 === a.compare(this, t1);
                        }, a.prototype.inspect = function() {
                            var t1 = "", e1 = r.INSPECT_MAX_BYTES;
                            return t1 = this.toString("hex", 0, e1).replace(/(.{2})/g, "$1 ").trim(), this.length > e1 && (t1 += " ... "), "<Buffer " + t1 + ">";
                        }, a.prototype.compare = function(t1, e1, r, n, i) {
                            if (B(t1, Uint8Array) && (t1 = a.from(t1, t1.offset, t1.byteLength)), !a.isBuffer(t1)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof t1);
                            if (void 0 === e1 && (e1 = 0), void 0 === r && (r = t1 ? t1.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e1 < 0 || r > t1.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                            if (n >= i && e1 >= r) return 0;
                            if (n >= i) return -1;
                            if (e1 >= r) return 1;
                            if (this === t1) return 0;
                            for(var o = (i >>>= 0) - (n >>>= 0), s = (r >>>= 0) - (e1 >>>= 0), l = Math.min(o, s), c = this.slice(n, i), u = t1.slice(e1, r), f = 0; f < l; ++f)if (c[f] !== u[f]) {
                                o = c[f], s = u[f];
                                break;
                            }
                            return o < s ? -1 : s < o ? 1 : 0;
                        }, a.prototype.includes = function(t1, e1, r) {
                            return -1 !== this.indexOf(t1, e1, r);
                        }, a.prototype.indexOf = function(t1, e1, r) {
                            return d(this, t1, e1, r, !0);
                        }, a.prototype.lastIndexOf = function(t1, e1, r) {
                            return d(this, t1, e1, r, !1);
                        }, a.prototype.write = function(t1, e1, r, n) {
                            if (void 0 === e1) n = "utf8", r = this.length, e1 = 0;
                            else if (void 0 === r && "string" == typeof e1) n = e1, r = this.length, e1 = 0;
                            else {
                                if (!isFinite(e1)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                e1 >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                            }
                            var i = this.length - e1;
                            if ((void 0 === r || r > i) && (r = i), t1.length > 0 && (r < 0 || e1 < 0) || e1 > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                            n || (n = "utf8");
                            for(var a = !1;;)switch(n){
                                case "hex":
                                    return g(this, t1, e1, r);
                                case "utf8":
                                case "utf-8":
                                    return v(this, t1, e1, r);
                                case "ascii":
                                    return y(this, t1, e1, r);
                                case "latin1":
                                case "binary":
                                    return x(this, t1, e1, r);
                                case "base64":
                                    return b(this, t1, e1, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return _(this, t1, e1, r);
                                default:
                                    if (a) throw new TypeError("Unknown encoding: " + n);
                                    n = ("" + n).toLowerCase(), a = !0;
                            }
                        }, a.prototype.toJSON = function() {
                            return {
                                type: "Buffer",
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        };
                        function k(t1, e1, r) {
                            var n = "";
                            r = Math.min(t1.length, r);
                            for(var i = e1; i < r; ++i)n += String.fromCharCode(127 & t1[i]);
                            return n;
                        }
                        function A(t1, e1, r) {
                            var n = "";
                            r = Math.min(t1.length, r);
                            for(var i = e1; i < r; ++i)n += String.fromCharCode(t1[i]);
                            return n;
                        }
                        function M(t1, e1, r) {
                            var n = t1.length;
                            (!e1 || e1 < 0) && (e1 = 0), (!r || r < 0 || r > n) && (r = n);
                            for(var i = "", a = e1; a < r; ++a)i += z(t1[a]);
                            return i;
                        }
                        function S(t1, e1, r) {
                            for(var n = t1.slice(e1, r), i = "", a = 0; a < n.length; a += 2)i += String.fromCharCode(n[a] + 256 * n[a + 1]);
                            return i;
                        }
                        function E(t1, e1, r) {
                            if (t1 % 1 != 0 || t1 < 0) throw new RangeError("offset is not uint");
                            if (t1 + e1 > r) throw new RangeError("Trying to access beyond buffer length");
                        }
                        function L(t1, e1, r, n, i, o) {
                            if (!a.isBuffer(t1)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (e1 > i || e1 < o) throw new RangeError('"value" argument is out of bounds');
                            if (r + n > t1.length) throw new RangeError("Index out of range");
                        }
                        function C(t1, e1, r, n, i, a) {
                            if (r + n > t1.length) throw new RangeError("Index out of range");
                            if (r < 0) throw new RangeError("Index out of range");
                        }
                        function P(t1, e1, r, i, a) {
                            return e1 = +e1, r >>>= 0, a || C(t1, 0, r, 4), n.write(t1, e1, r, i, 23, 4), r + 4;
                        }
                        function I(t1, e1, r, i, a) {
                            return e1 = +e1, r >>>= 0, a || C(t1, 0, r, 8), n.write(t1, e1, r, i, 52, 8), r + 8;
                        }
                        a.prototype.slice = function(t1, e1) {
                            var r = this.length;
                            (t1 = ~~t1) < 0 ? (t1 += r) < 0 && (t1 = 0) : t1 > r && (t1 = r), (e1 = void 0 === e1 ? r : ~~e1) < 0 ? (e1 += r) < 0 && (e1 = 0) : e1 > r && (e1 = r), e1 < t1 && (e1 = t1);
                            var n = this.subarray(t1, e1);
                            return n.__proto__ = a.prototype, n;
                        }, a.prototype.readUIntLE = function(t1, e1, r) {
                            t1 >>>= 0, e1 >>>= 0, r || E(t1, e1, this.length);
                            for(var n = this[t1], i = 1, a = 0; ++a < e1 && (i *= 256);)n += this[t1 + a] * i;
                            return n;
                        }, a.prototype.readUIntBE = function(t1, e1, r) {
                            t1 >>>= 0, e1 >>>= 0, r || E(t1, e1, this.length);
                            for(var n = this[t1 + --e1], i = 1; e1 > 0 && (i *= 256);)n += this[t1 + --e1] * i;
                            return n;
                        }, a.prototype.readUInt8 = function(t1, e1) {
                            return t1 >>>= 0, e1 || E(t1, 1, this.length), this[t1];
                        }, a.prototype.readUInt16LE = function(t1, e1) {
                            return t1 >>>= 0, e1 || E(t1, 2, this.length), this[t1] | this[t1 + 1] << 8;
                        }, a.prototype.readUInt16BE = function(t1, e1) {
                            return t1 >>>= 0, e1 || E(t1, 2, this.length), this[t1] << 8 | this[t1 + 1];
                        }, a.prototype.readUInt32LE = function(t1, e1) {
                            return t1 >>>= 0, e1 || E(t1, 4, this.length), (this[t1] | this[t1 + 1] << 8 | this[t1 + 2] << 16) + 16777216 * this[t1 + 3];
                        }, a.prototype.readUInt32BE = function(t1, e1) {
                            return t1 >>>= 0, e1 || E(t1, 4, this.length), 16777216 * this[t1] + (this[t1 + 1] << 16 | this[t1 + 2] << 8 | this[t1 + 3]);
                        }, a.prototype.readIntLE = function(t1, e1, r) {
                            t1 >>>= 0, e1 >>>= 0, r || E(t1, e1, this.length);
                            for(var n = this[t1], i = 1, a = 0; ++a < e1 && (i *= 256);)n += this[t1 + a] * i;
                            return n >= (i *= 128) && (n -= Math.pow(2, 8 * e1)), n;
                        }, a.prototype.readIntBE = function(t1, e1, r) {
                            t1 >>>= 0, e1 >>>= 0, r || E(t1, e1, this.length);
                            for(var n = e1, i = 1, a = this[t1 + --n]; n > 0 && (i *= 256);)a += this[t1 + --n] * i;
                            return a >= (i *= 128) && (a -= Math.pow(2, 8 * e1)), a;
                        }, a.prototype.readInt8 = function(t1, e1) {
                            return t1 >>>= 0, e1 || E(t1, 1, this.length), 128 & this[t1] ? -1 * (255 - this[t1] + 1) : this[t1];
                        }, a.prototype.readInt16LE = function(t1, e1) {
                            t1 >>>= 0, e1 || E(t1, 2, this.length);
                            var r = this[t1] | this[t1 + 1] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, a.prototype.readInt16BE = function(t1, e1) {
                            t1 >>>= 0, e1 || E(t1, 2, this.length);
                            var r = this[t1 + 1] | this[t1] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, a.prototype.readInt32LE = function(t1, e1) {
                            return t1 >>>= 0, e1 || E(t1, 4, this.length), this[t1] | this[t1 + 1] << 8 | this[t1 + 2] << 16 | this[t1 + 3] << 24;
                        }, a.prototype.readInt32BE = function(t1, e1) {
                            return t1 >>>= 0, e1 || E(t1, 4, this.length), this[t1] << 24 | this[t1 + 1] << 16 | this[t1 + 2] << 8 | this[t1 + 3];
                        }, a.prototype.readFloatLE = function(t1, e1) {
                            return t1 >>>= 0, e1 || E(t1, 4, this.length), n.read(this, t1, !0, 23, 4);
                        }, a.prototype.readFloatBE = function(t1, e1) {
                            return t1 >>>= 0, e1 || E(t1, 4, this.length), n.read(this, t1, !1, 23, 4);
                        }, a.prototype.readDoubleLE = function(t1, e1) {
                            return t1 >>>= 0, e1 || E(t1, 8, this.length), n.read(this, t1, !0, 52, 8);
                        }, a.prototype.readDoubleBE = function(t1, e1) {
                            return t1 >>>= 0, e1 || E(t1, 8, this.length), n.read(this, t1, !1, 52, 8);
                        }, a.prototype.writeUIntLE = function(t1, e1, r, n) {
                            (t1 = +t1, e1 >>>= 0, r >>>= 0, n) || L(this, t1, e1, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = 1, a = 0;
                            for(this[e1] = 255 & t1; ++a < r && (i *= 256);)this[e1 + a] = t1 / i & 255;
                            return e1 + r;
                        }, a.prototype.writeUIntBE = function(t1, e1, r, n) {
                            (t1 = +t1, e1 >>>= 0, r >>>= 0, n) || L(this, t1, e1, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = r - 1, a = 1;
                            for(this[e1 + i] = 255 & t1; --i >= 0 && (a *= 256);)this[e1 + i] = t1 / a & 255;
                            return e1 + r;
                        }, a.prototype.writeUInt8 = function(t1, e1, r) {
                            return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 1, 255, 0), this[e1] = 255 & t1, e1 + 1;
                        }, a.prototype.writeUInt16LE = function(t1, e1, r) {
                            return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 2, 65535, 0), this[e1] = 255 & t1, this[e1 + 1] = t1 >>> 8, e1 + 2;
                        }, a.prototype.writeUInt16BE = function(t1, e1, r) {
                            return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 2, 65535, 0), this[e1] = t1 >>> 8, this[e1 + 1] = 255 & t1, e1 + 2;
                        }, a.prototype.writeUInt32LE = function(t1, e1, r) {
                            return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 4, 4294967295, 0), this[e1 + 3] = t1 >>> 24, this[e1 + 2] = t1 >>> 16, this[e1 + 1] = t1 >>> 8, this[e1] = 255 & t1, e1 + 4;
                        }, a.prototype.writeUInt32BE = function(t1, e1, r) {
                            return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 4, 4294967295, 0), this[e1] = t1 >>> 24, this[e1 + 1] = t1 >>> 16, this[e1 + 2] = t1 >>> 8, this[e1 + 3] = 255 & t1, e1 + 4;
                        }, a.prototype.writeIntLE = function(t1, e1, r, n) {
                            if (t1 = +t1, e1 >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                L(this, t1, e1, r, i - 1, -i);
                            }
                            var a = 0, o = 1, s = 0;
                            for(this[e1] = 255 & t1; ++a < r && (o *= 256);)t1 < 0 && 0 === s && 0 !== this[e1 + a - 1] && (s = 1), this[e1 + a] = (t1 / o >> 0) - s & 255;
                            return e1 + r;
                        }, a.prototype.writeIntBE = function(t1, e1, r, n) {
                            if (t1 = +t1, e1 >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                L(this, t1, e1, r, i - 1, -i);
                            }
                            var a = r - 1, o = 1, s = 0;
                            for(this[e1 + a] = 255 & t1; --a >= 0 && (o *= 256);)t1 < 0 && 0 === s && 0 !== this[e1 + a + 1] && (s = 1), this[e1 + a] = (t1 / o >> 0) - s & 255;
                            return e1 + r;
                        }, a.prototype.writeInt8 = function(t1, e1, r) {
                            return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 1, 127, -128), t1 < 0 && (t1 = 255 + t1 + 1), this[e1] = 255 & t1, e1 + 1;
                        }, a.prototype.writeInt16LE = function(t1, e1, r) {
                            return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 2, 32767, -32768), this[e1] = 255 & t1, this[e1 + 1] = t1 >>> 8, e1 + 2;
                        }, a.prototype.writeInt16BE = function(t1, e1, r) {
                            return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 2, 32767, -32768), this[e1] = t1 >>> 8, this[e1 + 1] = 255 & t1, e1 + 2;
                        }, a.prototype.writeInt32LE = function(t1, e1, r) {
                            return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 4, 2147483647, -2147483648), this[e1] = 255 & t1, this[e1 + 1] = t1 >>> 8, this[e1 + 2] = t1 >>> 16, this[e1 + 3] = t1 >>> 24, e1 + 4;
                        }, a.prototype.writeInt32BE = function(t1, e1, r) {
                            return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 4, 2147483647, -2147483648), t1 < 0 && (t1 = 4294967295 + t1 + 1), this[e1] = t1 >>> 24, this[e1 + 1] = t1 >>> 16, this[e1 + 2] = t1 >>> 8, this[e1 + 3] = 255 & t1, e1 + 4;
                        }, a.prototype.writeFloatLE = function(t1, e1, r) {
                            return P(this, t1, e1, !0, r);
                        }, a.prototype.writeFloatBE = function(t1, e1, r) {
                            return P(this, t1, e1, !1, r);
                        }, a.prototype.writeDoubleLE = function(t1, e1, r) {
                            return I(this, t1, e1, !0, r);
                        }, a.prototype.writeDoubleBE = function(t1, e1, r) {
                            return I(this, t1, e1, !1, r);
                        }, a.prototype.copy = function(t1, e1, r, n) {
                            if (!a.isBuffer(t1)) throw new TypeError("argument should be a Buffer");
                            if (r || (r = 0), n || 0 === n || (n = this.length), e1 >= t1.length && (e1 = t1.length), e1 || (e1 = 0), n > 0 && n < r && (n = r), n === r) return 0;
                            if (0 === t1.length || 0 === this.length) return 0;
                            if (e1 < 0) throw new RangeError("targetStart out of bounds");
                            if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                            if (n < 0) throw new RangeError("sourceEnd out of bounds");
                            n > this.length && (n = this.length), t1.length - e1 < n - r && (n = t1.length - e1 + r);
                            var i = n - r;
                            if (this === t1 && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(e1, r, n);
                            else if (this === t1 && r < e1 && e1 < n) for(var o = i - 1; o >= 0; --o)t1[o + e1] = this[o + r];
                            else Uint8Array.prototype.set.call(t1, this.subarray(r, n), e1);
                            return i;
                        }, a.prototype.fill = function(t1, e1, r, n) {
                            if ("string" == typeof t1) {
                                if ("string" == typeof e1 ? (n = e1, e1 = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                                if ("string" == typeof n && !a.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                                if (1 === t1.length) {
                                    var i = t1.charCodeAt(0);
                                    ("utf8" === n && i < 128 || "latin1" === n) && (t1 = i);
                                }
                            } else "number" == typeof t1 && (t1 &= 255);
                            if (e1 < 0 || this.length < e1 || this.length < r) throw new RangeError("Out of range index");
                            if (r <= e1) return this;
                            var o;
                            if (e1 >>>= 0, r = void 0 === r ? this.length : r >>> 0, t1 || (t1 = 0), "number" == typeof t1) for(o = e1; o < r; ++o)this[o] = t1;
                            else {
                                var s = a.isBuffer(t1) ? t1 : a.from(t1, n), l = s.length;
                                if (0 === l) throw new TypeError('The value "' + t1 + '" is invalid for argument "value"');
                                for(o = 0; o < r - e1; ++o)this[o + e1] = s[o % l];
                            }
                            return this;
                        };
                        var O = /[^+/0-9A-Za-z-_]/g;
                        function z(t1) {
                            return t1 < 16 ? "0" + t1.toString(16) : t1.toString(16);
                        }
                        function D(t1, e1) {
                            var r;
                            e1 = e1 || 1 / 0;
                            for(var n = t1.length, i = null, a = [], o = 0; o < n; ++o){
                                if ((r = t1.charCodeAt(o)) > 55295 && r < 57344) {
                                    if (!i) {
                                        if (r > 56319) {
                                            (e1 -= 3) > -1 && a.push(239, 191, 189);
                                            continue;
                                        }
                                        if (o + 1 === n) {
                                            (e1 -= 3) > -1 && a.push(239, 191, 189);
                                            continue;
                                        }
                                        i = r;
                                        continue;
                                    }
                                    if (r < 56320) {
                                        (e1 -= 3) > -1 && a.push(239, 191, 189), i = r;
                                        continue;
                                    }
                                    r = 65536 + (i - 55296 << 10 | r - 56320);
                                } else i && (e1 -= 3) > -1 && a.push(239, 191, 189);
                                if (i = null, r < 128) {
                                    if ((e1 -= 1) < 0) break;
                                    a.push(r);
                                } else if (r < 2048) {
                                    if ((e1 -= 2) < 0) break;
                                    a.push(r >> 6 | 192, 63 & r | 128);
                                } else if (r < 65536) {
                                    if ((e1 -= 3) < 0) break;
                                    a.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                                } else {
                                    if (!(r < 1114112)) throw new Error("Invalid code point");
                                    if ((e1 -= 4) < 0) break;
                                    a.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                                }
                            }
                            return a;
                        }
                        function R(t1) {
                            return e1.toByteArray(function(t1) {
                                if ((t1 = (t1 = t1.split("=")[0]).trim().replace(O, "")).length < 2) return "";
                                for(; t1.length % 4 != 0;)t1 += "=";
                                return t1;
                            }(t1));
                        }
                        function F(t1, e1, r, n) {
                            for(var i = 0; i < n && !(i + r >= e1.length || i >= t1.length); ++i)e1[i + r] = t1[i];
                            return i;
                        }
                        function B(t1, e1) {
                            return t1 instanceof e1 || null != t1 && null != t1.constructor && null != t1.constructor.name && t1.constructor.name === e1.name;
                        }
                        function N(t1) {
                            return t1 != t1;
                        }
                    }).call(this);
                }).call(this, t1("buffer").Buffer);
            },
            {
                "base64-js": 79,
                buffer: 85,
                ieee754: 230
            }
        ],
        86: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r) {
                    return e1 < r ? t1 < e1 ? e1 : t1 > r ? r : t1 : t1 < r ? r : t1 > e1 ? e1 : t1;
                };
            },
            {}
        ],
        87: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("clamp");
                function i(t1, e1) {
                    null == e1 && (e1 = !0);
                    var r = t1[0], i = t1[1], a = t1[2], o = t1[3];
                    return null == o && (o = e1 ? 1 : 255), e1 && (r *= 255, i *= 255, a *= 255, o *= 255), 16777216 * (r = 255 & n(r, 0, 255)) + ((i = 255 & n(i, 0, 255)) << 16) + ((a = 255 & n(a, 0, 255)) << 8) + (o = 255 & n(o, 0, 255));
                }
                e1.exports = i, e1.exports.to = i, e1.exports.from = function(t1, e1) {
                    var r = (t1 = +t1) >>> 24, n = (16711680 & t1) >>> 16, i = (65280 & t1) >>> 8, a = 255 & t1;
                    return !1 === e1 ? [
                        r,
                        n,
                        i,
                        a
                    ] : [
                        r / 255,
                        n / 255,
                        i / 255,
                        a / 255
                    ];
                };
            },
            {
                clamp: 86
            }
        ],
        88: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    aliceblue: [
                        240,
                        248,
                        255
                    ],
                    antiquewhite: [
                        250,
                        235,
                        215
                    ],
                    aqua: [
                        0,
                        255,
                        255
                    ],
                    aquamarine: [
                        127,
                        255,
                        212
                    ],
                    azure: [
                        240,
                        255,
                        255
                    ],
                    beige: [
                        245,
                        245,
                        220
                    ],
                    bisque: [
                        255,
                        228,
                        196
                    ],
                    black: [
                        0,
                        0,
                        0
                    ],
                    blanchedalmond: [
                        255,
                        235,
                        205
                    ],
                    blue: [
                        0,
                        0,
                        255
                    ],
                    blueviolet: [
                        138,
                        43,
                        226
                    ],
                    brown: [
                        165,
                        42,
                        42
                    ],
                    burlywood: [
                        222,
                        184,
                        135
                    ],
                    cadetblue: [
                        95,
                        158,
                        160
                    ],
                    chartreuse: [
                        127,
                        255,
                        0
                    ],
                    chocolate: [
                        210,
                        105,
                        30
                    ],
                    coral: [
                        255,
                        127,
                        80
                    ],
                    cornflowerblue: [
                        100,
                        149,
                        237
                    ],
                    cornsilk: [
                        255,
                        248,
                        220
                    ],
                    crimson: [
                        220,
                        20,
                        60
                    ],
                    cyan: [
                        0,
                        255,
                        255
                    ],
                    darkblue: [
                        0,
                        0,
                        139
                    ],
                    darkcyan: [
                        0,
                        139,
                        139
                    ],
                    darkgoldenrod: [
                        184,
                        134,
                        11
                    ],
                    darkgray: [
                        169,
                        169,
                        169
                    ],
                    darkgreen: [
                        0,
                        100,
                        0
                    ],
                    darkgrey: [
                        169,
                        169,
                        169
                    ],
                    darkkhaki: [
                        189,
                        183,
                        107
                    ],
                    darkmagenta: [
                        139,
                        0,
                        139
                    ],
                    darkolivegreen: [
                        85,
                        107,
                        47
                    ],
                    darkorange: [
                        255,
                        140,
                        0
                    ],
                    darkorchid: [
                        153,
                        50,
                        204
                    ],
                    darkred: [
                        139,
                        0,
                        0
                    ],
                    darksalmon: [
                        233,
                        150,
                        122
                    ],
                    darkseagreen: [
                        143,
                        188,
                        143
                    ],
                    darkslateblue: [
                        72,
                        61,
                        139
                    ],
                    darkslategray: [
                        47,
                        79,
                        79
                    ],
                    darkslategrey: [
                        47,
                        79,
                        79
                    ],
                    darkturquoise: [
                        0,
                        206,
                        209
                    ],
                    darkviolet: [
                        148,
                        0,
                        211
                    ],
                    deeppink: [
                        255,
                        20,
                        147
                    ],
                    deepskyblue: [
                        0,
                        191,
                        255
                    ],
                    dimgray: [
                        105,
                        105,
                        105
                    ],
                    dimgrey: [
                        105,
                        105,
                        105
                    ],
                    dodgerblue: [
                        30,
                        144,
                        255
                    ],
                    firebrick: [
                        178,
                        34,
                        34
                    ],
                    floralwhite: [
                        255,
                        250,
                        240
                    ],
                    forestgreen: [
                        34,
                        139,
                        34
                    ],
                    fuchsia: [
                        255,
                        0,
                        255
                    ],
                    gainsboro: [
                        220,
                        220,
                        220
                    ],
                    ghostwhite: [
                        248,
                        248,
                        255
                    ],
                    gold: [
                        255,
                        215,
                        0
                    ],
                    goldenrod: [
                        218,
                        165,
                        32
                    ],
                    gray: [
                        128,
                        128,
                        128
                    ],
                    green: [
                        0,
                        128,
                        0
                    ],
                    greenyellow: [
                        173,
                        255,
                        47
                    ],
                    grey: [
                        128,
                        128,
                        128
                    ],
                    honeydew: [
                        240,
                        255,
                        240
                    ],
                    hotpink: [
                        255,
                        105,
                        180
                    ],
                    indianred: [
                        205,
                        92,
                        92
                    ],
                    indigo: [
                        75,
                        0,
                        130
                    ],
                    ivory: [
                        255,
                        255,
                        240
                    ],
                    khaki: [
                        240,
                        230,
                        140
                    ],
                    lavender: [
                        230,
                        230,
                        250
                    ],
                    lavenderblush: [
                        255,
                        240,
                        245
                    ],
                    lawngreen: [
                        124,
                        252,
                        0
                    ],
                    lemonchiffon: [
                        255,
                        250,
                        205
                    ],
                    lightblue: [
                        173,
                        216,
                        230
                    ],
                    lightcoral: [
                        240,
                        128,
                        128
                    ],
                    lightcyan: [
                        224,
                        255,
                        255
                    ],
                    lightgoldenrodyellow: [
                        250,
                        250,
                        210
                    ],
                    lightgray: [
                        211,
                        211,
                        211
                    ],
                    lightgreen: [
                        144,
                        238,
                        144
                    ],
                    lightgrey: [
                        211,
                        211,
                        211
                    ],
                    lightpink: [
                        255,
                        182,
                        193
                    ],
                    lightsalmon: [
                        255,
                        160,
                        122
                    ],
                    lightseagreen: [
                        32,
                        178,
                        170
                    ],
                    lightskyblue: [
                        135,
                        206,
                        250
                    ],
                    lightslategray: [
                        119,
                        136,
                        153
                    ],
                    lightslategrey: [
                        119,
                        136,
                        153
                    ],
                    lightsteelblue: [
                        176,
                        196,
                        222
                    ],
                    lightyellow: [
                        255,
                        255,
                        224
                    ],
                    lime: [
                        0,
                        255,
                        0
                    ],
                    limegreen: [
                        50,
                        205,
                        50
                    ],
                    linen: [
                        250,
                        240,
                        230
                    ],
                    magenta: [
                        255,
                        0,
                        255
                    ],
                    maroon: [
                        128,
                        0,
                        0
                    ],
                    mediumaquamarine: [
                        102,
                        205,
                        170
                    ],
                    mediumblue: [
                        0,
                        0,
                        205
                    ],
                    mediumorchid: [
                        186,
                        85,
                        211
                    ],
                    mediumpurple: [
                        147,
                        112,
                        219
                    ],
                    mediumseagreen: [
                        60,
                        179,
                        113
                    ],
                    mediumslateblue: [
                        123,
                        104,
                        238
                    ],
                    mediumspringgreen: [
                        0,
                        250,
                        154
                    ],
                    mediumturquoise: [
                        72,
                        209,
                        204
                    ],
                    mediumvioletred: [
                        199,
                        21,
                        133
                    ],
                    midnightblue: [
                        25,
                        25,
                        112
                    ],
                    mintcream: [
                        245,
                        255,
                        250
                    ],
                    mistyrose: [
                        255,
                        228,
                        225
                    ],
                    moccasin: [
                        255,
                        228,
                        181
                    ],
                    navajowhite: [
                        255,
                        222,
                        173
                    ],
                    navy: [
                        0,
                        0,
                        128
                    ],
                    oldlace: [
                        253,
                        245,
                        230
                    ],
                    olive: [
                        128,
                        128,
                        0
                    ],
                    olivedrab: [
                        107,
                        142,
                        35
                    ],
                    orange: [
                        255,
                        165,
                        0
                    ],
                    orangered: [
                        255,
                        69,
                        0
                    ],
                    orchid: [
                        218,
                        112,
                        214
                    ],
                    palegoldenrod: [
                        238,
                        232,
                        170
                    ],
                    palegreen: [
                        152,
                        251,
                        152
                    ],
                    paleturquoise: [
                        175,
                        238,
                        238
                    ],
                    palevioletred: [
                        219,
                        112,
                        147
                    ],
                    papayawhip: [
                        255,
                        239,
                        213
                    ],
                    peachpuff: [
                        255,
                        218,
                        185
                    ],
                    peru: [
                        205,
                        133,
                        63
                    ],
                    pink: [
                        255,
                        192,
                        203
                    ],
                    plum: [
                        221,
                        160,
                        221
                    ],
                    powderblue: [
                        176,
                        224,
                        230
                    ],
                    purple: [
                        128,
                        0,
                        128
                    ],
                    rebeccapurple: [
                        102,
                        51,
                        153
                    ],
                    red: [
                        255,
                        0,
                        0
                    ],
                    rosybrown: [
                        188,
                        143,
                        143
                    ],
                    royalblue: [
                        65,
                        105,
                        225
                    ],
                    saddlebrown: [
                        139,
                        69,
                        19
                    ],
                    salmon: [
                        250,
                        128,
                        114
                    ],
                    sandybrown: [
                        244,
                        164,
                        96
                    ],
                    seagreen: [
                        46,
                        139,
                        87
                    ],
                    seashell: [
                        255,
                        245,
                        238
                    ],
                    sienna: [
                        160,
                        82,
                        45
                    ],
                    silver: [
                        192,
                        192,
                        192
                    ],
                    skyblue: [
                        135,
                        206,
                        235
                    ],
                    slateblue: [
                        106,
                        90,
                        205
                    ],
                    slategray: [
                        112,
                        128,
                        144
                    ],
                    slategrey: [
                        112,
                        128,
                        144
                    ],
                    snow: [
                        255,
                        250,
                        250
                    ],
                    springgreen: [
                        0,
                        255,
                        127
                    ],
                    steelblue: [
                        70,
                        130,
                        180
                    ],
                    tan: [
                        210,
                        180,
                        140
                    ],
                    teal: [
                        0,
                        128,
                        128
                    ],
                    thistle: [
                        216,
                        191,
                        216
                    ],
                    tomato: [
                        255,
                        99,
                        71
                    ],
                    turquoise: [
                        64,
                        224,
                        208
                    ],
                    violet: [
                        238,
                        130,
                        238
                    ],
                    wheat: [
                        245,
                        222,
                        179
                    ],
                    white: [
                        255,
                        255,
                        255
                    ],
                    whitesmoke: [
                        245,
                        245,
                        245
                    ],
                    yellow: [
                        255,
                        255,
                        0
                    ],
                    yellowgreen: [
                        154,
                        205,
                        50
                    ]
                };
            },
            {}
        ],
        89: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("color-rgba"), i = t1("clamp"), a = t1("dtype");
                e1.exports = function(t1, e1) {
                    "float" !== e1 && e1 || (e1 = "array"), "uint" === e1 && (e1 = "uint8"), "uint_clamped" === e1 && (e1 = "uint8_clamped");
                    var r = new (a(e1))(4), o = "uint8" !== e1 && "uint8_clamped" !== e1;
                    return t1.length && "string" != typeof t1 || ((t1 = n(t1))[0] /= 255, t1[1] /= 255, t1[2] /= 255), function(t1) {
                        return t1 instanceof Uint8Array || t1 instanceof Uint8ClampedArray || !!(Array.isArray(t1) && (t1[0] > 1 || 0 === t1[0]) && (t1[1] > 1 || 0 === t1[1]) && (t1[2] > 1 || 0 === t1[2]) && (!t1[3] || t1[3] > 1));
                    }(t1) ? (r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = null != t1[3] ? t1[3] : 255, o && (r[0] /= 255, r[1] /= 255, r[2] /= 255, r[3] /= 255), r) : (o ? (r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = null != t1[3] ? t1[3] : 1) : (r[0] = i(Math.floor(255 * t1[0]), 0, 255), r[1] = i(Math.floor(255 * t1[1]), 0, 255), r[2] = i(Math.floor(255 * t1[2]), 0, 255), r[3] = null == t1[3] ? 255 : i(Math.floor(255 * t1[3]), 0, 255)), r);
                };
            },
            {
                clamp: 86,
                "color-rgba": 91,
                dtype: 127
            }
        ],
        90: [
            function(t1, e1, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = t1("color-name"), i = t1("is-plain-obj"), a = t1("defined");
                        e1.exports = function(t1) {
                            var e1, s, l = [], c = 1;
                            if ("string" == typeof t1) {
                                if (n[t1]) l = n[t1].slice(), s = "rgb";
                                else if ("transparent" === t1) c = 0, s = "rgb", l = [
                                    0,
                                    0,
                                    0
                                ];
                                else if (/^#[A-Fa-f0-9]+$/.test(t1)) {
                                    var u = (p = t1.slice(1)).length;
                                    c = 1, u <= 4 ? (l = [
                                        parseInt(p[0] + p[0], 16),
                                        parseInt(p[1] + p[1], 16),
                                        parseInt(p[2] + p[2], 16)
                                    ], 4 === u && (c = parseInt(p[3] + p[3], 16) / 255)) : (l = [
                                        parseInt(p[0] + p[1], 16),
                                        parseInt(p[2] + p[3], 16),
                                        parseInt(p[4] + p[5], 16)
                                    ], 8 === u && (c = parseInt(p[6] + p[7], 16) / 255)), l[0] || (l[0] = 0), l[1] || (l[1] = 0), l[2] || (l[2] = 0), s = "rgb";
                                } else if (e1 = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(t1)) {
                                    var f = e1[1], h = "rgb" === f, p = f.replace(/a$/, "");
                                    s = p;
                                    u = "cmyk" === p ? 4 : "gray" === p ? 1 : 3;
                                    l = e1[2].trim().split(/\s*,\s*/).map(function(t1, e1) {
                                        if (/%$/.test(t1)) return e1 === u ? parseFloat(t1) / 100 : "rgb" === p ? 255 * parseFloat(t1) / 100 : parseFloat(t1);
                                        if ("h" === p[e1]) {
                                            if (/deg$/.test(t1)) return parseFloat(t1);
                                            if (void 0 !== o[t1]) return o[t1];
                                        }
                                        return parseFloat(t1);
                                    }), f === p && l.push(1), c = h || void 0 === l[u] ? 1 : l[u], l = l.slice(0, u);
                                } else t1.length > 10 && /[0-9](?:\s|\/)/.test(t1) && (l = t1.match(/([0-9]+)/g).map(function(t1) {
                                    return parseFloat(t1);
                                }), s = t1.match(/([a-z])/gi).join("").toLowerCase());
                            } else if (isNaN(t1)) {
                                if (i(t1)) {
                                    var d = a(t1.r, t1.red, t1.R, null);
                                    null !== d ? (s = "rgb", l = [
                                        d,
                                        a(t1.g, t1.green, t1.G),
                                        a(t1.b, t1.blue, t1.B)
                                    ]) : (s = "hsl", l = [
                                        a(t1.h, t1.hue, t1.H),
                                        a(t1.s, t1.saturation, t1.S),
                                        a(t1.l, t1.lightness, t1.L, t1.b, t1.brightness)
                                    ]), c = a(t1.a, t1.alpha, t1.opacity, 1), null != t1.opacity && (c /= 100);
                                } else (Array.isArray(t1) || r.ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(t1)) && (l = [
                                    t1[0],
                                    t1[1],
                                    t1[2]
                                ], s = "rgb", c = 4 === t1.length ? t1[3] : 1);
                            } else s = "rgb", l = [
                                t1 >>> 16,
                                (65280 & t1) >>> 8,
                                255 & t1
                            ];
                            return {
                                space: s,
                                values: l,
                                alpha: c
                            };
                        };
                        var o = {
                            red: 0,
                            orange: 60,
                            yellow: 120,
                            green: 180,
                            blue: 240,
                            purple: 300
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "color-name": 88,
                defined: 124,
                "is-plain-obj": 236
            }
        ],
        91: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("color-parse"), i = t1("color-space/hsl"), a = t1("clamp");
                e1.exports = function(t1) {
                    var e1, r = n(t1);
                    return r.space ? ((e1 = Array(3))[0] = a(r.values[0], 0, 255), e1[1] = a(r.values[1], 0, 255), e1[2] = a(r.values[2], 0, 255), "h" === r.space[0] && (e1 = i.rgb(e1)), e1.push(a(r.alpha, 0, 1)), e1) : [];
                };
            },
            {
                clamp: 86,
                "color-parse": 90,
                "color-space/hsl": 92
            }
        ],
        92: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./rgb");
                e1.exports = {
                    name: "hsl",
                    min: [
                        0,
                        0,
                        0
                    ],
                    max: [
                        360,
                        100,
                        100
                    ],
                    channel: [
                        "hue",
                        "saturation",
                        "lightness"
                    ],
                    alias: [
                        "HSL"
                    ],
                    rgb: function(t1) {
                        var e1, r, n, i, a, o = t1[0] / 360, s = t1[1] / 100, l = t1[2] / 100;
                        if (0 === s) return [
                            a = 255 * l,
                            a,
                            a
                        ];
                        e1 = 2 * l - (r = l < .5 ? l * (1 + s) : l + s - l * s), i = [
                            0,
                            0,
                            0
                        ];
                        for(var c = 0; c < 3; c++)(n = o + 1 / 3 * -(c - 1)) < 0 ? n++ : n > 1 && n--, a = 6 * n < 1 ? e1 + 6 * (r - e1) * n : 2 * n < 1 ? r : 3 * n < 2 ? e1 + (r - e1) * (2 / 3 - n) * 6 : e1, i[c] = 255 * a;
                        return i;
                    }
                }, n.hsl = function(t1) {
                    var e1, r, n = t1[0] / 255, i = t1[1] / 255, a = t1[2] / 255, o = Math.min(n, i, a), s = Math.max(n, i, a), l = s - o;
                    return s === o ? e1 = 0 : n === s ? e1 = (i - a) / l : i === s ? e1 = 2 + (a - n) / l : a === s && (e1 = 4 + (n - i) / l), (e1 = Math.min(60 * e1, 360)) < 0 && (e1 += 360), r = (o + s) / 2, [
                        e1,
                        100 * (s === o ? 0 : r <= .5 ? l / (s + o) : l / (2 - s - o)),
                        100 * r
                    ];
                };
            },
            {
                "./rgb": 93
            }
        ],
        93: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    name: "rgb",
                    min: [
                        0,
                        0,
                        0
                    ],
                    max: [
                        255,
                        255,
                        255
                    ],
                    channel: [
                        "red",
                        "green",
                        "blue"
                    ],
                    alias: [
                        "RGB"
                    ]
                };
            },
            {}
        ],
        94: [
            function(t1, e1, r) {
                e1.exports = {
                    AFG: "afghan",
                    ALA: "\\b\\wland",
                    ALB: "albania",
                    DZA: "algeria",
                    ASM: "^(?=.*americ).*samoa",
                    AND: "andorra",
                    AGO: "angola",
                    AIA: "anguill?a",
                    ATA: "antarctica",
                    ATG: "antigua",
                    ARG: "argentin",
                    ARM: "armenia",
                    ABW: "^(?!.*bonaire).*\\baruba",
                    AUS: "australia",
                    AUT: "^(?!.*hungary).*austria|\\baustri.*\\bemp",
                    AZE: "azerbaijan",
                    BHS: "bahamas",
                    BHR: "bahrain",
                    BGD: "bangladesh|^(?=.*east).*paki?stan",
                    BRB: "barbados",
                    BLR: "belarus|byelo",
                    BEL: "^(?!.*luxem).*belgium",
                    BLZ: "belize|^(?=.*british).*honduras",
                    BEN: "benin|dahome",
                    BMU: "bermuda",
                    BTN: "bhutan",
                    BOL: "bolivia",
                    BES: "^(?=.*bonaire).*eustatius|^(?=.*carib).*netherlands|\\bbes.?islands",
                    BIH: "herzegovina|bosnia",
                    BWA: "botswana|bechuana",
                    BVT: "bouvet",
                    BRA: "brazil",
                    IOT: "british.?indian.?ocean",
                    BRN: "brunei",
                    BGR: "bulgaria",
                    BFA: "burkina|\\bfaso|upper.?volta",
                    BDI: "burundi",
                    CPV: "verde",
                    KHM: "cambodia|kampuchea|khmer",
                    CMR: "cameroon",
                    CAN: "canada",
                    CYM: "cayman",
                    CAF: "\\bcentral.african.republic",
                    TCD: "\\bchad",
                    CHL: "\\bchile",
                    CHN: "^(?!.*\\bmac)(?!.*\\bhong)(?!.*\\btai)(?!.*\\brep).*china|^(?=.*peo)(?=.*rep).*china",
                    CXR: "christmas",
                    CCK: "\\bcocos|keeling",
                    COL: "colombia",
                    COM: "comoro",
                    COG: "^(?!.*\\bdem)(?!.*\\bd[\\.]?r)(?!.*kinshasa)(?!.*zaire)(?!.*belg)(?!.*l.opoldville)(?!.*free).*\\bcongo",
                    COK: "\\bcook",
                    CRI: "costa.?rica",
                    CIV: "ivoire|ivory",
                    HRV: "croatia",
                    CUB: "\\bcuba",
                    CUW: "^(?!.*bonaire).*\\bcura(c|\xe7)ao",
                    CYP: "cyprus",
                    CSK: "czechoslovakia",
                    CZE: "^(?=.*rep).*czech|czechia|bohemia",
                    COD: "\\bdem.*congo|congo.*\\bdem|congo.*\\bd[\\.]?r|\\bd[\\.]?r.*congo|belgian.?congo|congo.?free.?state|kinshasa|zaire|l.opoldville|drc|droc|rdc",
                    DNK: "denmark",
                    DJI: "djibouti",
                    DMA: "dominica(?!n)",
                    DOM: "dominican.rep",
                    ECU: "ecuador",
                    EGY: "egypt",
                    SLV: "el.?salvador",
                    GNQ: "guine.*eq|eq.*guine|^(?=.*span).*guinea",
                    ERI: "eritrea",
                    EST: "estonia",
                    ETH: "ethiopia|abyssinia",
                    FLK: "falkland|malvinas",
                    FRO: "faroe|faeroe",
                    FJI: "fiji",
                    FIN: "finland",
                    FRA: "^(?!.*\\bdep)(?!.*martinique).*france|french.?republic|\\bgaul",
                    GUF: "^(?=.*french).*guiana",
                    PYF: "french.?polynesia|tahiti",
                    ATF: "french.?southern",
                    GAB: "gabon",
                    GMB: "gambia",
                    GEO: "^(?!.*south).*georgia",
                    DDR: "german.?democratic.?republic|democratic.?republic.*germany|east.germany",
                    DEU: "^(?!.*east).*germany|^(?=.*\\bfed.*\\brep).*german",
                    GHA: "ghana|gold.?coast",
                    GIB: "gibraltar",
                    GRC: "greece|hellenic|hellas",
                    GRL: "greenland",
                    GRD: "grenada",
                    GLP: "guadeloupe",
                    GUM: "\\bguam",
                    GTM: "guatemala",
                    GGY: "guernsey",
                    GIN: "^(?!.*eq)(?!.*span)(?!.*bissau)(?!.*portu)(?!.*new).*guinea",
                    GNB: "bissau|^(?=.*portu).*guinea",
                    GUY: "guyana|british.?guiana",
                    HTI: "haiti",
                    HMD: "heard.*mcdonald",
                    VAT: "holy.?see|vatican|papal.?st",
                    HND: "^(?!.*brit).*honduras",
                    HKG: "hong.?kong",
                    HUN: "^(?!.*austr).*hungary",
                    ISL: "iceland",
                    IND: "india(?!.*ocea)",
                    IDN: "indonesia",
                    IRN: "\\biran|persia",
                    IRQ: "\\biraq|mesopotamia",
                    IRL: "(^ireland)|(^republic.*ireland)",
                    IMN: "^(?=.*isle).*\\bman",
                    ISR: "israel",
                    ITA: "italy",
                    JAM: "jamaica",
                    JPN: "japan",
                    JEY: "jersey",
                    JOR: "jordan",
                    KAZ: "kazak",
                    KEN: "kenya|british.?east.?africa|east.?africa.?prot",
                    KIR: "kiribati",
                    PRK: "^(?=.*democrat|people|north|d.*p.*.r).*\\bkorea|dprk|korea.*(d.*p.*r)",
                    KWT: "kuwait",
                    KGZ: "kyrgyz|kirghiz",
                    LAO: "\\blaos?\\b",
                    LVA: "latvia",
                    LBN: "lebanon",
                    LSO: "lesotho|basuto",
                    LBR: "liberia",
                    LBY: "libya",
                    LIE: "liechtenstein",
                    LTU: "lithuania",
                    LUX: "^(?!.*belg).*luxem",
                    MAC: "maca(o|u)",
                    MDG: "madagascar|malagasy",
                    MWI: "malawi|nyasa",
                    MYS: "malaysia",
                    MDV: "maldive",
                    MLI: "\\bmali\\b",
                    MLT: "\\bmalta",
                    MHL: "marshall",
                    MTQ: "martinique",
                    MRT: "mauritania",
                    MUS: "mauritius",
                    MYT: "\\bmayotte",
                    MEX: "\\bmexic",
                    FSM: "fed.*micronesia|micronesia.*fed",
                    MCO: "monaco",
                    MNG: "mongolia",
                    MNE: "^(?!.*serbia).*montenegro",
                    MSR: "montserrat",
                    MAR: "morocco|\\bmaroc",
                    MOZ: "mozambique",
                    MMR: "myanmar|burma",
                    NAM: "namibia",
                    NRU: "nauru",
                    NPL: "nepal",
                    NLD: "^(?!.*\\bant)(?!.*\\bcarib).*netherlands",
                    ANT: "^(?=.*\\bant).*(nether|dutch)",
                    NCL: "new.?caledonia",
                    NZL: "new.?zealand",
                    NIC: "nicaragua",
                    NER: "\\bniger(?!ia)",
                    NGA: "nigeria",
                    NIU: "niue",
                    NFK: "norfolk",
                    MNP: "mariana",
                    NOR: "norway",
                    OMN: "\\boman|trucial",
                    PAK: "^(?!.*east).*paki?stan",
                    PLW: "palau",
                    PSE: "palestin|\\bgaza|west.?bank",
                    PAN: "panama",
                    PNG: "papua|new.?guinea",
                    PRY: "paraguay",
                    PER: "peru",
                    PHL: "philippines",
                    PCN: "pitcairn",
                    POL: "poland",
                    PRT: "portugal",
                    PRI: "puerto.?rico",
                    QAT: "qatar",
                    KOR: "^(?!.*d.*p.*r)(?!.*democrat)(?!.*people)(?!.*north).*\\bkorea(?!.*d.*p.*r)",
                    MDA: "moldov|b(a|e)ssarabia",
                    REU: "r(e|\xe9)union",
                    ROU: "r(o|u|ou)mania",
                    RUS: "\\brussia|soviet.?union|u\\.?s\\.?s\\.?r|socialist.?republics",
                    RWA: "rwanda",
                    BLM: "barth(e|\xe9)lemy",
                    SHN: "helena",
                    KNA: "kitts|\\bnevis",
                    LCA: "\\blucia",
                    MAF: "^(?=.*collectivity).*martin|^(?=.*france).*martin(?!ique)|^(?=.*french).*martin(?!ique)",
                    SPM: "miquelon",
                    VCT: "vincent",
                    WSM: "^(?!.*amer).*samoa",
                    SMR: "san.?marino",
                    STP: "\\bs(a|\xe3)o.?tom(e|\xe9)",
                    SAU: "\\bsa\\w*.?arabia",
                    SEN: "senegal",
                    SRB: "^(?!.*monte).*serbia",
                    SYC: "seychell",
                    SLE: "sierra",
                    SGP: "singapore",
                    SXM: "^(?!.*martin)(?!.*saba).*maarten",
                    SVK: "^(?!.*cze).*slovak",
                    SVN: "slovenia",
                    SLB: "solomon",
                    SOM: "somali",
                    ZAF: "south.africa|s\\\\..?africa",
                    SGS: "south.?georgia|sandwich",
                    SSD: "\\bs\\w*.?sudan",
                    ESP: "spain",
                    LKA: "sri.?lanka|ceylon",
                    SDN: "^(?!.*\\bs(?!u)).*sudan",
                    SUR: "surinam|dutch.?guiana",
                    SJM: "svalbard",
                    SWZ: "swaziland",
                    SWE: "sweden",
                    CHE: "switz|swiss",
                    SYR: "syria",
                    TWN: "taiwan|taipei|formosa|^(?!.*peo)(?=.*rep).*china",
                    TJK: "tajik",
                    THA: "thailand|\\bsiam",
                    MKD: "macedonia|fyrom",
                    TLS: "^(?=.*leste).*timor|^(?=.*east).*timor",
                    TGO: "togo",
                    TKL: "tokelau",
                    TON: "tonga",
                    TTO: "trinidad|tobago",
                    TUN: "tunisia",
                    TUR: "turkey",
                    TKM: "turkmen",
                    TCA: "turks",
                    TUV: "tuvalu",
                    UGA: "uganda",
                    UKR: "ukrain",
                    ARE: "emirates|^u\\.?a\\.?e\\.?$|united.?arab.?em",
                    GBR: "united.?kingdom|britain|^u\\.?k\\.?$",
                    TZA: "tanzania",
                    USA: "united.?states\\b(?!.*islands)|\\bu\\.?s\\.?a\\.?\\b|^\\s*u\\.?s\\.?\\b(?!.*islands)",
                    UMI: "minor.?outlying.?is",
                    URY: "uruguay",
                    UZB: "uzbek",
                    VUT: "vanuatu|new.?hebrides",
                    VEN: "venezuela",
                    VNM: "^(?!.*republic).*viet.?nam|^(?=.*socialist).*viet.?nam",
                    VGB: "^(?=.*\\bu\\.?\\s?k).*virgin|^(?=.*brit).*virgin|^(?=.*kingdom).*virgin",
                    VIR: "^(?=.*\\bu\\.?\\s?s).*virgin|^(?=.*states).*virgin",
                    WLF: "futuna|wallis",
                    ESH: "western.sahara",
                    YEM: "^(?!.*arab)(?!.*north)(?!.*sana)(?!.*peo)(?!.*dem)(?!.*south)(?!.*aden)(?!.*\\bp\\.?d\\.?r).*yemen",
                    YMD: "^(?=.*peo).*yemen|^(?!.*rep)(?=.*dem).*yemen|^(?=.*south).*yemen|^(?=.*aden).*yemen|^(?=.*\\bp\\.?d\\.?r).*yemen",
                    YUG: "yugoslavia",
                    ZMB: "zambia|northern.?rhodesia",
                    EAZ: "zanzibar",
                    ZWE: "zimbabwe|^(?!.*northern).*rhodesia"
                };
            },
            {}
        ],
        95: [
            function(t1, e1, r) {
                e1.exports = [
                    "xx-small",
                    "x-small",
                    "small",
                    "medium",
                    "large",
                    "x-large",
                    "xx-large",
                    "larger",
                    "smaller"
                ];
            },
            {}
        ],
        96: [
            function(t1, e1, r) {
                e1.exports = [
                    "normal",
                    "condensed",
                    "semi-condensed",
                    "extra-condensed",
                    "ultra-condensed",
                    "expanded",
                    "semi-expanded",
                    "extra-expanded",
                    "ultra-expanded"
                ];
            },
            {}
        ],
        97: [
            function(t1, e1, r) {
                e1.exports = [
                    "normal",
                    "italic",
                    "oblique"
                ];
            },
            {}
        ],
        98: [
            function(t1, e1, r) {
                e1.exports = [
                    "normal",
                    "bold",
                    "bolder",
                    "lighter",
                    "100",
                    "200",
                    "300",
                    "400",
                    "500",
                    "600",
                    "700",
                    "800",
                    "900"
                ];
            },
            {}
        ],
        99: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    parse: t1("./parse"),
                    stringify: t1("./stringify")
                };
            },
            {
                "./parse": 101,
                "./stringify": 102
            }
        ],
        100: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("css-font-size-keywords");
                e1.exports = {
                    isSize: function(t1) {
                        return /^[\d\.]/.test(t1) || -1 !== t1.indexOf("/") || -1 !== n.indexOf(t1);
                    }
                };
            },
            {
                "css-font-size-keywords": 95
            }
        ],
        101: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("unquote"), i = t1("css-global-keywords"), a = t1("css-system-font-keywords"), o = t1("css-font-weight-keywords"), s = t1("css-font-style-keywords"), l = t1("css-font-stretch-keywords"), c = t1("string-split-by"), u = t1("./lib/util").isSize;
                e1.exports = h;
                var f = h.cache = {};
                function h(t1) {
                    if ("string" != typeof t1) throw new Error("Font argument must be a string.");
                    if (f[t1]) return f[t1];
                    if ("" === t1) throw new Error("Cannot parse an empty string.");
                    if (-1 !== a.indexOf(t1)) return f[t1] = {
                        system: t1
                    };
                    for(var e1, r = {
                        style: "normal",
                        variant: "normal",
                        weight: "normal",
                        stretch: "normal",
                        lineHeight: "normal",
                        size: "1rem",
                        family: [
                            "serif"
                        ]
                    }, h = c(t1, /\s+/); e1 = h.shift();){
                        if (-1 !== i.indexOf(e1)) return [
                            "style",
                            "variant",
                            "weight",
                            "stretch"
                        ].forEach(function(t1) {
                            r[t1] = e1;
                        }), f[t1] = r;
                        if (-1 === s.indexOf(e1)) {
                            if ("normal" !== e1 && "small-caps" !== e1) {
                                if (-1 === l.indexOf(e1)) {
                                    if (-1 === o.indexOf(e1)) {
                                        if (u(e1)) {
                                            var d = c(e1, "/");
                                            if (r.size = d[0], null != d[1] ? r.lineHeight = p(d[1]) : "/" === h[0] && (h.shift(), r.lineHeight = p(h.shift())), !h.length) throw new Error("Missing required font-family.");
                                            return r.family = c(h.join(" "), /\s*,\s*/).map(n), f[t1] = r;
                                        }
                                        throw new Error("Unknown or unsupported font token: " + e1);
                                    }
                                    r.weight = e1;
                                } else r.stretch = e1;
                            } else r.variant = e1;
                        } else r.style = e1;
                    }
                    throw new Error("Missing required font-size.");
                }
                function p(t1) {
                    var e1 = parseFloat(t1);
                    return e1.toString() === t1 ? e1 : t1;
                }
            },
            {
                "./lib/util": 100,
                "css-font-stretch-keywords": 96,
                "css-font-style-keywords": 97,
                "css-font-weight-keywords": 98,
                "css-global-keywords": 103,
                "css-system-font-keywords": 104,
                "string-split-by": 305,
                unquote: 328
            }
        ],
        102: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("pick-by-alias"), i = t1("./lib/util").isSize, a = m(t1("css-global-keywords")), o = m(t1("css-system-font-keywords")), s = m(t1("css-font-weight-keywords")), l = m(t1("css-font-style-keywords")), c = m(t1("css-font-stretch-keywords")), u = {
                    normal: 1,
                    "small-caps": 1
                }, f = {
                    serif: 1,
                    "sans-serif": 1,
                    monospace: 1,
                    cursive: 1,
                    fantasy: 1,
                    "system-ui": 1
                }, h = "1rem", p = "serif";
                function d(t1, e1) {
                    if (t1 && !e1[t1] && !a[t1]) throw Error("Unknown keyword `" + t1 + "`");
                    return t1;
                }
                function m(t1) {
                    for(var e1 = {}, r = 0; r < t1.length; r++)e1[t1[r]] = 1;
                    return e1;
                }
                e1.exports = function(t1) {
                    if ((t1 = n(t1, {
                        style: "style fontstyle fontStyle font-style slope distinction",
                        variant: "variant font-variant fontVariant fontvariant var capitalization",
                        weight: "weight w font-weight fontWeight fontweight",
                        stretch: "stretch font-stretch fontStretch fontstretch width",
                        size: "size s font-size fontSize fontsize height em emSize",
                        lineHeight: "lh line-height lineHeight lineheight leading",
                        family: "font family fontFamily font-family fontfamily type typeface face",
                        system: "system reserved default global"
                    })).system) return t1.system && d(t1.system, o), t1.system;
                    if (d(t1.style, l), d(t1.variant, u), d(t1.weight, s), d(t1.stretch, c), null == t1.size && (t1.size = h), "number" == typeof t1.size && (t1.size += "px"), !i) throw Error("Bad size value `" + t1.size + "`");
                    t1.family || (t1.family = p), Array.isArray(t1.family) && (t1.family.length || (t1.family = [
                        p
                    ]), t1.family = t1.family.map(function(t1) {
                        return f[t1] ? t1 : '"' + t1 + '"';
                    }).join(", "));
                    var e1 = [];
                    return e1.push(t1.style), t1.variant !== t1.style && e1.push(t1.variant), t1.weight !== t1.variant && t1.weight !== t1.style && e1.push(t1.weight), t1.stretch !== t1.weight && t1.stretch !== t1.variant && t1.stretch !== t1.style && e1.push(t1.stretch), e1.push(t1.size + (null == t1.lineHeight || "normal" === t1.lineHeight || t1.lineHeight + "" == "1" ? "" : "/" + t1.lineHeight)), e1.push(t1.family), e1.filter(Boolean).join(" ");
                };
            },
            {
                "./lib/util": 100,
                "css-font-stretch-keywords": 96,
                "css-font-style-keywords": 97,
                "css-font-weight-keywords": 98,
                "css-global-keywords": 103,
                "css-system-font-keywords": 104,
                "pick-by-alias": 253
            }
        ],
        103: [
            function(t1, e1, r) {
                e1.exports = [
                    "inherit",
                    "initial",
                    "unset"
                ];
            },
            {}
        ],
        104: [
            function(t1, e1, r) {
                e1.exports = [
                    "caption",
                    "icon",
                    "menu",
                    "message-box",
                    "small-caption",
                    "status-bar"
                ];
            },
            {}
        ],
        105: [
            function(t1, e1, r) {
                "use strict";
                var n, i = t1("type/value/is"), a = t1("type/value/ensure"), o = t1("type/plain-function/ensure"), s = t1("es5-ext/object/copy"), l = t1("es5-ext/object/normalize-options"), c = t1("es5-ext/object/map"), u = Function.prototype.bind, f = Object.defineProperty, h = Object.prototype.hasOwnProperty;
                n = function(t1, e1, r) {
                    var n, i = a(e1) && o(e1.value);
                    return delete (n = s(e1)).writable, delete n.value, n.get = function() {
                        return !r.overwriteDefinition && h.call(this, t1) ? i : (e1.value = u.call(i, r.resolveContext ? r.resolveContext(this) : this), f(this, t1, e1), this[t1]);
                    }, n;
                }, e1.exports = function(t1) {
                    var e1 = l(arguments[1]);
                    return i(e1.resolveContext) && o(e1.resolveContext), c(t1, function(t1, r) {
                        return n(r, t1, e1);
                    });
                };
            },
            {
                "es5-ext/object/copy": 147,
                "es5-ext/object/map": 155,
                "es5-ext/object/normalize-options": 156,
                "type/plain-function/ensure": 321,
                "type/value/ensure": 325,
                "type/value/is": 326
            }
        ],
        106: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("type/value/is"), i = t1("type/plain-function/is"), a = t1("es5-ext/object/assign"), o = t1("es5-ext/object/normalize-options"), s = t1("es5-ext/string/#/contains");
                (e1.exports = function(t1, e1) {
                    var r, i, l, c, u;
                    return arguments.length < 2 || "string" != typeof t1 ? (c = e1, e1 = t1, t1 = null) : c = arguments[2], n(t1) ? (r = s.call(t1, "c"), i = s.call(t1, "e"), l = s.call(t1, "w")) : (r = l = !0, i = !1), u = {
                        value: e1,
                        configurable: r,
                        enumerable: i,
                        writable: l
                    }, c ? a(o(c), u) : u;
                }).gs = function(t1, e1, r) {
                    var l, c, u, f;
                    return "string" != typeof t1 ? (u = r, r = e1, e1 = t1, t1 = null) : u = arguments[3], n(e1) ? i(e1) ? n(r) ? i(r) || (u = r, r = void 0) : r = void 0 : (u = e1, e1 = r = void 0) : e1 = void 0, n(t1) ? (l = s.call(t1, "c"), c = s.call(t1, "e")) : (l = !0, c = !1), f = {
                        get: e1,
                        set: r,
                        configurable: l,
                        enumerable: c
                    }, u ? a(o(u), f) : f;
                };
            },
            {
                "es5-ext/object/assign": 144,
                "es5-ext/object/normalize-options": 156,
                "es5-ext/string/#/contains": 163,
                "type/plain-function/is": 322,
                "type/value/is": 326
            }
        ],
        107: [
            function(t1, e1, r) {
                !function(t1, n) {
                    n("object" == typeof r && void 0 !== e1 ? r : t1.d3 = t1.d3 || {});
                }(this, function(t1) {
                    "use strict";
                    function e1(t1, e1) {
                        return t1 < e1 ? -1 : t1 > e1 ? 1 : t1 >= e1 ? 0 : NaN;
                    }
                    function r(t1) {
                        var r;
                        return 1 === t1.length && (r = t1, t1 = function(t1, n) {
                            return e1(r(t1), n);
                        }), {
                            left: function(e1, r, n, i) {
                                for(null == n && (n = 0), null == i && (i = e1.length); n < i;){
                                    var a = n + i >>> 1;
                                    t1(e1[a], r) < 0 ? n = a + 1 : i = a;
                                }
                                return n;
                            },
                            right: function(e1, r, n, i) {
                                for(null == n && (n = 0), null == i && (i = e1.length); n < i;){
                                    var a = n + i >>> 1;
                                    t1(e1[a], r) > 0 ? i = a : n = a + 1;
                                }
                                return n;
                            }
                        };
                    }
                    var n = r(e1), i = n.right, a = n.left;
                    function o(t1, e1) {
                        return [
                            t1,
                            e1
                        ];
                    }
                    function s(t1) {
                        return null === t1 ? NaN : +t1;
                    }
                    function l(t1, e1) {
                        var r, n, i = t1.length, a = 0, o = -1, l = 0, c = 0;
                        if (null == e1) for(; ++o < i;)isNaN(r = s(t1[o])) || (c += (n = r - l) * (r - (l += n / ++a)));
                        else for(; ++o < i;)isNaN(r = s(e1(t1[o], o, t1))) || (c += (n = r - l) * (r - (l += n / ++a)));
                        if (a > 1) return c / (a - 1);
                    }
                    function c(t1, e1) {
                        var r = l(t1, e1);
                        return r ? Math.sqrt(r) : r;
                    }
                    function u(t1, e1) {
                        var r, n, i, a = t1.length, o = -1;
                        if (null == e1) {
                            for(; ++o < a;)if (null != (r = t1[o]) && r >= r) for(n = i = r; ++o < a;)null != (r = t1[o]) && (n > r && (n = r), i < r && (i = r));
                        } else for(; ++o < a;)if (null != (r = e1(t1[o], o, t1)) && r >= r) for(n = i = r; ++o < a;)null != (r = e1(t1[o], o, t1)) && (n > r && (n = r), i < r && (i = r));
                        return [
                            n,
                            i
                        ];
                    }
                    var f = Array.prototype, h = f.slice, p = f.map;
                    function d(t1) {
                        return function() {
                            return t1;
                        };
                    }
                    function m(t1) {
                        return t1;
                    }
                    function g(t1, e1, r) {
                        t1 = +t1, e1 = +e1, r = (i = arguments.length) < 2 ? (e1 = t1, t1 = 0, 1) : i < 3 ? 1 : +r;
                        for(var n = -1, i = 0 | Math.max(0, Math.ceil((e1 - t1) / r)), a = new Array(i); ++n < i;)a[n] = t1 + n * r;
                        return a;
                    }
                    var v = Math.sqrt(50), y = Math.sqrt(10), x = Math.sqrt(2);
                    function b(t1, e1, r) {
                        var n = (e1 - t1) / Math.max(0, r), i = Math.floor(Math.log(n) / Math.LN10), a = n / Math.pow(10, i);
                        return i >= 0 ? (a >= v ? 10 : a >= y ? 5 : a >= x ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (a >= v ? 10 : a >= y ? 5 : a >= x ? 2 : 1);
                    }
                    function _(t1, e1, r) {
                        var n = Math.abs(e1 - t1) / Math.max(0, r), i = Math.pow(10, Math.floor(Math.log(n) / Math.LN10)), a = n / i;
                        return a >= v ? i *= 10 : a >= y ? i *= 5 : a >= x && (i *= 2), e1 < t1 ? -i : i;
                    }
                    function w(t1) {
                        return Math.ceil(Math.log(t1.length) / Math.LN2) + 1;
                    }
                    function T(t1, e1, r) {
                        if (null == r && (r = s), n = t1.length) {
                            if ((e1 = +e1) <= 0 || n < 2) return +r(t1[0], 0, t1);
                            if (e1 >= 1) return +r(t1[n - 1], n - 1, t1);
                            var n, i = (n - 1) * e1, a = Math.floor(i), o = +r(t1[a], a, t1);
                            return o + (+r(t1[a + 1], a + 1, t1) - o) * (i - a);
                        }
                    }
                    function k(t1, e1) {
                        var r, n, i = t1.length, a = -1;
                        if (null == e1) {
                            for(; ++a < i;)if (null != (r = t1[a]) && r >= r) for(n = r; ++a < i;)null != (r = t1[a]) && n > r && (n = r);
                        } else for(; ++a < i;)if (null != (r = e1(t1[a], a, t1)) && r >= r) for(n = r; ++a < i;)null != (r = e1(t1[a], a, t1)) && n > r && (n = r);
                        return n;
                    }
                    function A(t1) {
                        if (!(i = t1.length)) return [];
                        for(var e1 = -1, r = k(t1, M), n = new Array(r); ++e1 < r;)for(var i, a = -1, o = n[e1] = new Array(i); ++a < i;)o[a] = t1[a][e1];
                        return n;
                    }
                    function M(t1) {
                        return t1.length;
                    }
                    t1.bisect = i, t1.bisectRight = i, t1.bisectLeft = a, t1.ascending = e1, t1.bisector = r, t1.cross = function(t1, e1, r) {
                        var n, i, a, s, l = t1.length, c = e1.length, u = new Array(l * c);
                        for(null == r && (r = o), n = a = 0; n < l; ++n)for(s = t1[n], i = 0; i < c; ++i, ++a)u[a] = r(s, e1[i]);
                        return u;
                    }, t1.descending = function(t1, e1) {
                        return e1 < t1 ? -1 : e1 > t1 ? 1 : e1 >= t1 ? 0 : NaN;
                    }, t1.deviation = c, t1.extent = u, t1.histogram = function() {
                        var t1 = m, e1 = u, r = w;
                        function n(n) {
                            var a, o, s = n.length, l = new Array(s);
                            for(a = 0; a < s; ++a)l[a] = t1(n[a], a, n);
                            var c = e1(l), u = c[0], f = c[1], h = r(l, u, f);
                            Array.isArray(h) || (h = _(u, f, h), h = g(Math.ceil(u / h) * h, f, h));
                            for(var p = h.length; h[0] <= u;)h.shift(), --p;
                            for(; h[p - 1] > f;)h.pop(), --p;
                            var d, m = new Array(p + 1);
                            for(a = 0; a <= p; ++a)(d = m[a] = []).x0 = a > 0 ? h[a - 1] : u, d.x1 = a < p ? h[a] : f;
                            for(a = 0; a < s; ++a)u <= (o = l[a]) && o <= f && m[i(h, o, 0, p)].push(n[a]);
                            return m;
                        }
                        return n.value = function(e1) {
                            return arguments.length ? (t1 = "function" == typeof e1 ? e1 : d(e1), n) : t1;
                        }, n.domain = function(t1) {
                            return arguments.length ? (e1 = "function" == typeof t1 ? t1 : d([
                                t1[0],
                                t1[1]
                            ]), n) : e1;
                        }, n.thresholds = function(t1) {
                            return arguments.length ? (r = "function" == typeof t1 ? t1 : Array.isArray(t1) ? d(h.call(t1)) : d(t1), n) : r;
                        }, n;
                    }, t1.thresholdFreedmanDiaconis = function(t1, r, n) {
                        return t1 = p.call(t1, s).sort(e1), Math.ceil((n - r) / (2 * (T(t1, .75) - T(t1, .25)) * Math.pow(t1.length, -1 / 3)));
                    }, t1.thresholdScott = function(t1, e1, r) {
                        return Math.ceil((r - e1) / (3.5 * c(t1) * Math.pow(t1.length, -1 / 3)));
                    }, t1.thresholdSturges = w, t1.max = function(t1, e1) {
                        var r, n, i = t1.length, a = -1;
                        if (null == e1) {
                            for(; ++a < i;)if (null != (r = t1[a]) && r >= r) for(n = r; ++a < i;)null != (r = t1[a]) && r > n && (n = r);
                        } else for(; ++a < i;)if (null != (r = e1(t1[a], a, t1)) && r >= r) for(n = r; ++a < i;)null != (r = e1(t1[a], a, t1)) && r > n && (n = r);
                        return n;
                    }, t1.mean = function(t1, e1) {
                        var r, n = t1.length, i = n, a = -1, o = 0;
                        if (null == e1) for(; ++a < n;)isNaN(r = s(t1[a])) ? --i : o += r;
                        else for(; ++a < n;)isNaN(r = s(e1(t1[a], a, t1))) ? --i : o += r;
                        if (i) return o / i;
                    }, t1.median = function(t1, r) {
                        var n, i = t1.length, a = -1, o = [];
                        if (null == r) for(; ++a < i;)isNaN(n = s(t1[a])) || o.push(n);
                        else for(; ++a < i;)isNaN(n = s(r(t1[a], a, t1))) || o.push(n);
                        return T(o.sort(e1), .5);
                    }, t1.merge = function(t1) {
                        for(var e1, r, n, i = t1.length, a = -1, o = 0; ++a < i;)o += t1[a].length;
                        for(r = new Array(o); --i >= 0;)for(e1 = (n = t1[i]).length; --e1 >= 0;)r[--o] = n[e1];
                        return r;
                    }, t1.min = k, t1.pairs = function(t1, e1) {
                        null == e1 && (e1 = o);
                        for(var r = 0, n = t1.length - 1, i = t1[0], a = new Array(n < 0 ? 0 : n); r < n;)a[r] = e1(i, i = t1[++r]);
                        return a;
                    }, t1.permute = function(t1, e1) {
                        for(var r = e1.length, n = new Array(r); r--;)n[r] = t1[e1[r]];
                        return n;
                    }, t1.quantile = T, t1.range = g, t1.scan = function(t1, r) {
                        if (n = t1.length) {
                            var n, i, a = 0, o = 0, s = t1[o];
                            for(null == r && (r = e1); ++a < n;)(r(i = t1[a], s) < 0 || 0 !== r(s, s)) && (s = i, o = a);
                            return 0 === r(s, s) ? o : void 0;
                        }
                    }, t1.shuffle = function(t1, e1, r) {
                        for(var n, i, a = (null == r ? t1.length : r) - (e1 = null == e1 ? 0 : +e1); a;)i = Math.random() * a-- | 0, n = t1[a + e1], t1[a + e1] = t1[i + e1], t1[i + e1] = n;
                        return t1;
                    }, t1.sum = function(t1, e1) {
                        var r, n = t1.length, i = -1, a = 0;
                        if (null == e1) for(; ++i < n;)(r = +t1[i]) && (a += r);
                        else for(; ++i < n;)(r = +e1(t1[i], i, t1)) && (a += r);
                        return a;
                    }, t1.ticks = function(t1, e1, r) {
                        var n, i, a, o, s = -1;
                        if (r = +r, (t1 = +t1) === (e1 = +e1) && r > 0) return [
                            t1
                        ];
                        if ((n = e1 < t1) && (i = t1, t1 = e1, e1 = i), 0 === (o = b(t1, e1, r)) || !isFinite(o)) return [];
                        if (o > 0) for(t1 = Math.ceil(t1 / o), e1 = Math.floor(e1 / o), a = new Array(i = Math.ceil(e1 - t1 + 1)); ++s < i;)a[s] = (t1 + s) * o;
                        else for(t1 = Math.floor(t1 * o), e1 = Math.ceil(e1 * o), a = new Array(i = Math.ceil(t1 - e1 + 1)); ++s < i;)a[s] = (t1 - s) / o;
                        return n && a.reverse(), a;
                    }, t1.tickIncrement = b, t1.tickStep = _, t1.transpose = A, t1.variance = l, t1.zip = function() {
                        return A(arguments);
                    }, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {}
        ],
        108: [
            function(t1, e1, r) {
                !function(t1, n) {
                    n("object" == typeof r && void 0 !== e1 ? r : t1.d3 = t1.d3 || {});
                }(this, function(t1) {
                    "use strict";
                    function e1() {}
                    function r(t1, r) {
                        var n = new e1;
                        if (t1 instanceof e1) t1.each(function(t1, e1) {
                            n.set(e1, t1);
                        });
                        else if (Array.isArray(t1)) {
                            var i, a = -1, o = t1.length;
                            if (null == r) for(; ++a < o;)n.set(a, t1[a]);
                            else for(; ++a < o;)n.set(r(i = t1[a], a, t1), i);
                        } else if (t1) for(var s in t1)n.set(s, t1[s]);
                        return n;
                    }
                    function n() {
                        return {};
                    }
                    function i(t1, e1, r) {
                        t1[e1] = r;
                    }
                    function a() {
                        return r();
                    }
                    function o(t1, e1, r) {
                        t1.set(e1, r);
                    }
                    function s() {}
                    e1.prototype = r.prototype = {
                        constructor: e1,
                        has: function(t1) {
                            return "$" + t1 in this;
                        },
                        get: function(t1) {
                            return this["$" + t1];
                        },
                        set: function(t1, e1) {
                            return this["$" + t1] = e1, this;
                        },
                        remove: function(t1) {
                            var e1 = "$" + t1;
                            return e1 in this && delete this[e1];
                        },
                        clear: function() {
                            for(var t1 in this)"$" === t1[0] && delete this[t1];
                        },
                        keys: function() {
                            var t1 = [];
                            for(var e1 in this)"$" === e1[0] && t1.push(e1.slice(1));
                            return t1;
                        },
                        values: function() {
                            var t1 = [];
                            for(var e1 in this)"$" === e1[0] && t1.push(this[e1]);
                            return t1;
                        },
                        entries: function() {
                            var t1 = [];
                            for(var e1 in this)"$" === e1[0] && t1.push({
                                key: e1.slice(1),
                                value: this[e1]
                            });
                            return t1;
                        },
                        size: function() {
                            var t1 = 0;
                            for(var e1 in this)"$" === e1[0] && ++t1;
                            return t1;
                        },
                        empty: function() {
                            for(var t1 in this)if ("$" === t1[0]) return !1;
                            return !0;
                        },
                        each: function(t1) {
                            for(var e1 in this)"$" === e1[0] && t1(this[e1], e1.slice(1), this);
                        }
                    };
                    var l = r.prototype;
                    function c(t1, e1) {
                        var r = new s;
                        if (t1 instanceof s) t1.each(function(t1) {
                            r.add(t1);
                        });
                        else if (t1) {
                            var n = -1, i = t1.length;
                            if (null == e1) for(; ++n < i;)r.add(t1[n]);
                            else for(; ++n < i;)r.add(e1(t1[n], n, t1));
                        }
                        return r;
                    }
                    s.prototype = c.prototype = {
                        constructor: s,
                        has: l.has,
                        add: function(t1) {
                            return this["$" + (t1 += "")] = t1, this;
                        },
                        remove: l.remove,
                        clear: l.clear,
                        values: l.keys,
                        size: l.size,
                        empty: l.empty,
                        each: l.each
                    }, t1.nest = function() {
                        var t1, e1, s, l = [], c = [];
                        function u(n, i, a, o) {
                            if (i >= l.length) return null != t1 && n.sort(t1), null != e1 ? e1(n) : n;
                            for(var s, c, f, h = -1, p = n.length, d = l[i++], m = r(), g = a(); ++h < p;)(f = m.get(s = d(c = n[h]) + "")) ? f.push(c) : m.set(s, [
                                c
                            ]);
                            return m.each(function(t1, e1) {
                                o(g, e1, u(t1, i, a, o));
                            }), g;
                        }
                        return s = {
                            object: function(t1) {
                                return u(t1, 0, n, i);
                            },
                            map: function(t1) {
                                return u(t1, 0, a, o);
                            },
                            entries: function(t1) {
                                return function t1(r, n) {
                                    if (++n > l.length) return r;
                                    var i, a = c[n - 1];
                                    return null != e1 && n >= l.length ? i = r.entries() : (i = [], r.each(function(e1, r) {
                                        i.push({
                                            key: r,
                                            values: t1(e1, n)
                                        });
                                    })), null != a ? i.sort(function(t1, e1) {
                                        return a(t1.key, e1.key);
                                    }) : i;
                                }(u(t1, 0, a, o), 0);
                            },
                            key: function(t1) {
                                return l.push(t1), s;
                            },
                            sortKeys: function(t1) {
                                return c[l.length - 1] = t1, s;
                            },
                            sortValues: function(e1) {
                                return t1 = e1, s;
                            },
                            rollup: function(t1) {
                                return e1 = t1, s;
                            }
                        };
                    }, t1.set = c, t1.map = r, t1.keys = function(t1) {
                        var e1 = [];
                        for(var r in t1)e1.push(r);
                        return e1;
                    }, t1.values = function(t1) {
                        var e1 = [];
                        for(var r in t1)e1.push(t1[r]);
                        return e1;
                    }, t1.entries = function(t1) {
                        var e1 = [];
                        for(var r in t1)e1.push({
                            key: r,
                            value: t1[r]
                        });
                        return e1;
                    }, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {}
        ],
        109: [
            function(t1, e1, r) {
                !function(t1, n) {
                    "object" == typeof r && void 0 !== e1 ? n(r) : n((t1 = t1 || self).d3 = t1.d3 || {});
                }(this, function(t1) {
                    "use strict";
                    function e1(t1, e1, r) {
                        t1.prototype = e1.prototype = r, r.constructor = t1;
                    }
                    function r(t1, e1) {
                        var r = Object.create(t1.prototype);
                        for(var n in e1)r[n] = e1[n];
                        return r;
                    }
                    function n() {}
                    var i = "\\s*([+-]?\\d+)\\s*", a = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", o = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", s = /^#([0-9a-f]{3,8})$/, l = new RegExp("^rgb\\(" + [
                        i,
                        i,
                        i
                    ] + "\\)$"), c = new RegExp("^rgb\\(" + [
                        o,
                        o,
                        o
                    ] + "\\)$"), u = new RegExp("^rgba\\(" + [
                        i,
                        i,
                        i,
                        a
                    ] + "\\)$"), f = new RegExp("^rgba\\(" + [
                        o,
                        o,
                        o,
                        a
                    ] + "\\)$"), h = new RegExp("^hsl\\(" + [
                        a,
                        o,
                        o
                    ] + "\\)$"), p = new RegExp("^hsla\\(" + [
                        a,
                        o,
                        o,
                        a
                    ] + "\\)$"), d = {
                        aliceblue: 15792383,
                        antiquewhite: 16444375,
                        aqua: 65535,
                        aquamarine: 8388564,
                        azure: 15794175,
                        beige: 16119260,
                        bisque: 16770244,
                        black: 0,
                        blanchedalmond: 16772045,
                        blue: 255,
                        blueviolet: 9055202,
                        brown: 10824234,
                        burlywood: 14596231,
                        cadetblue: 6266528,
                        chartreuse: 8388352,
                        chocolate: 13789470,
                        coral: 16744272,
                        cornflowerblue: 6591981,
                        cornsilk: 16775388,
                        crimson: 14423100,
                        cyan: 65535,
                        darkblue: 139,
                        darkcyan: 35723,
                        darkgoldenrod: 12092939,
                        darkgray: 11119017,
                        darkgreen: 25600,
                        darkgrey: 11119017,
                        darkkhaki: 12433259,
                        darkmagenta: 9109643,
                        darkolivegreen: 5597999,
                        darkorange: 16747520,
                        darkorchid: 10040012,
                        darkred: 9109504,
                        darksalmon: 15308410,
                        darkseagreen: 9419919,
                        darkslateblue: 4734347,
                        darkslategray: 3100495,
                        darkslategrey: 3100495,
                        darkturquoise: 52945,
                        darkviolet: 9699539,
                        deeppink: 16716947,
                        deepskyblue: 49151,
                        dimgray: 6908265,
                        dimgrey: 6908265,
                        dodgerblue: 2003199,
                        firebrick: 11674146,
                        floralwhite: 16775920,
                        forestgreen: 2263842,
                        fuchsia: 16711935,
                        gainsboro: 14474460,
                        ghostwhite: 16316671,
                        gold: 16766720,
                        goldenrod: 14329120,
                        gray: 8421504,
                        green: 32768,
                        greenyellow: 11403055,
                        grey: 8421504,
                        honeydew: 15794160,
                        hotpink: 16738740,
                        indianred: 13458524,
                        indigo: 4915330,
                        ivory: 16777200,
                        khaki: 15787660,
                        lavender: 15132410,
                        lavenderblush: 16773365,
                        lawngreen: 8190976,
                        lemonchiffon: 16775885,
                        lightblue: 11393254,
                        lightcoral: 15761536,
                        lightcyan: 14745599,
                        lightgoldenrodyellow: 16448210,
                        lightgray: 13882323,
                        lightgreen: 9498256,
                        lightgrey: 13882323,
                        lightpink: 16758465,
                        lightsalmon: 16752762,
                        lightseagreen: 2142890,
                        lightskyblue: 8900346,
                        lightslategray: 7833753,
                        lightslategrey: 7833753,
                        lightsteelblue: 11584734,
                        lightyellow: 16777184,
                        lime: 65280,
                        limegreen: 3329330,
                        linen: 16445670,
                        magenta: 16711935,
                        maroon: 8388608,
                        mediumaquamarine: 6737322,
                        mediumblue: 205,
                        mediumorchid: 12211667,
                        mediumpurple: 9662683,
                        mediumseagreen: 3978097,
                        mediumslateblue: 8087790,
                        mediumspringgreen: 64154,
                        mediumturquoise: 4772300,
                        mediumvioletred: 13047173,
                        midnightblue: 1644912,
                        mintcream: 16121850,
                        mistyrose: 16770273,
                        moccasin: 16770229,
                        navajowhite: 16768685,
                        navy: 128,
                        oldlace: 16643558,
                        olive: 8421376,
                        olivedrab: 7048739,
                        orange: 16753920,
                        orangered: 16729344,
                        orchid: 14315734,
                        palegoldenrod: 15657130,
                        palegreen: 10025880,
                        paleturquoise: 11529966,
                        palevioletred: 14381203,
                        papayawhip: 16773077,
                        peachpuff: 16767673,
                        peru: 13468991,
                        pink: 16761035,
                        plum: 14524637,
                        powderblue: 11591910,
                        purple: 8388736,
                        rebeccapurple: 6697881,
                        red: 16711680,
                        rosybrown: 12357519,
                        royalblue: 4286945,
                        saddlebrown: 9127187,
                        salmon: 16416882,
                        sandybrown: 16032864,
                        seagreen: 3050327,
                        seashell: 16774638,
                        sienna: 10506797,
                        silver: 12632256,
                        skyblue: 8900331,
                        slateblue: 6970061,
                        slategray: 7372944,
                        slategrey: 7372944,
                        snow: 16775930,
                        springgreen: 65407,
                        steelblue: 4620980,
                        tan: 13808780,
                        teal: 32896,
                        thistle: 14204888,
                        tomato: 16737095,
                        turquoise: 4251856,
                        violet: 15631086,
                        wheat: 16113331,
                        white: 16777215,
                        whitesmoke: 16119285,
                        yellow: 16776960,
                        yellowgreen: 10145074
                    };
                    function m() {
                        return this.rgb().formatHex();
                    }
                    function g() {
                        return this.rgb().formatRgb();
                    }
                    function v(t1) {
                        var e1, r;
                        return t1 = (t1 + "").trim().toLowerCase(), (e1 = s.exec(t1)) ? (r = e1[1].length, e1 = parseInt(e1[1], 16), 6 === r ? y(e1) : 3 === r ? new w(e1 >> 8 & 15 | e1 >> 4 & 240, e1 >> 4 & 15 | 240 & e1, (15 & e1) << 4 | 15 & e1, 1) : 8 === r ? x(e1 >> 24 & 255, e1 >> 16 & 255, e1 >> 8 & 255, (255 & e1) / 255) : 4 === r ? x(e1 >> 12 & 15 | e1 >> 8 & 240, e1 >> 8 & 15 | e1 >> 4 & 240, e1 >> 4 & 15 | 240 & e1, ((15 & e1) << 4 | 15 & e1) / 255) : null) : (e1 = l.exec(t1)) ? new w(e1[1], e1[2], e1[3], 1) : (e1 = c.exec(t1)) ? new w(255 * e1[1] / 100, 255 * e1[2] / 100, 255 * e1[3] / 100, 1) : (e1 = u.exec(t1)) ? x(e1[1], e1[2], e1[3], e1[4]) : (e1 = f.exec(t1)) ? x(255 * e1[1] / 100, 255 * e1[2] / 100, 255 * e1[3] / 100, e1[4]) : (e1 = h.exec(t1)) ? M(e1[1], e1[2] / 100, e1[3] / 100, 1) : (e1 = p.exec(t1)) ? M(e1[1], e1[2] / 100, e1[3] / 100, e1[4]) : d.hasOwnProperty(t1) ? y(d[t1]) : "transparent" === t1 ? new w(NaN, NaN, NaN, 0) : null;
                    }
                    function y(t1) {
                        return new w(t1 >> 16 & 255, t1 >> 8 & 255, 255 & t1, 1);
                    }
                    function x(t1, e1, r, n) {
                        return n <= 0 && (t1 = e1 = r = NaN), new w(t1, e1, r, n);
                    }
                    function b(t1) {
                        return t1 instanceof n || (t1 = v(t1)), t1 ? new w((t1 = t1.rgb()).r, t1.g, t1.b, t1.opacity) : new w;
                    }
                    function _(t1, e1, r, n) {
                        return 1 === arguments.length ? b(t1) : new w(t1, e1, r, null == n ? 1 : n);
                    }
                    function w(t1, e1, r, n) {
                        this.r = +t1, this.g = +e1, this.b = +r, this.opacity = +n;
                    }
                    function T() {
                        return "#" + A(this.r) + A(this.g) + A(this.b);
                    }
                    function k() {
                        var t1 = this.opacity;
                        return (1 === (t1 = isNaN(t1) ? 1 : Math.max(0, Math.min(1, t1))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t1 ? ")" : ", " + t1 + ")");
                    }
                    function A(t1) {
                        return ((t1 = Math.max(0, Math.min(255, Math.round(t1) || 0))) < 16 ? "0" : "") + t1.toString(16);
                    }
                    function M(t1, e1, r, n) {
                        return n <= 0 ? t1 = e1 = r = NaN : r <= 0 || r >= 1 ? t1 = e1 = NaN : e1 <= 0 && (t1 = NaN), new L(t1, e1, r, n);
                    }
                    function S(t1) {
                        if (t1 instanceof L) return new L(t1.h, t1.s, t1.l, t1.opacity);
                        if (t1 instanceof n || (t1 = v(t1)), !t1) return new L;
                        if (t1 instanceof L) return t1;
                        var e1 = (t1 = t1.rgb()).r / 255, r = t1.g / 255, i = t1.b / 255, a = Math.min(e1, r, i), o = Math.max(e1, r, i), s = NaN, l = o - a, c = (o + a) / 2;
                        return l ? (s = e1 === o ? (r - i) / l + 6 * (r < i) : r === o ? (i - e1) / l + 2 : (e1 - r) / l + 4, l /= c < .5 ? o + a : 2 - o - a, s *= 60) : l = c > 0 && c < 1 ? 0 : s, new L(s, l, c, t1.opacity);
                    }
                    function E(t1, e1, r, n) {
                        return 1 === arguments.length ? S(t1) : new L(t1, e1, r, null == n ? 1 : n);
                    }
                    function L(t1, e1, r, n) {
                        this.h = +t1, this.s = +e1, this.l = +r, this.opacity = +n;
                    }
                    function C(t1, e1, r) {
                        return 255 * (t1 < 60 ? e1 + (r - e1) * t1 / 60 : t1 < 180 ? r : t1 < 240 ? e1 + (r - e1) * (240 - t1) / 60 : e1);
                    }
                    e1(n, v, {
                        copy: function(t1) {
                            return Object.assign(new this.constructor, this, t1);
                        },
                        displayable: function() {
                            return this.rgb().displayable();
                        },
                        hex: m,
                        formatHex: m,
                        formatHsl: function() {
                            return S(this).formatHsl();
                        },
                        formatRgb: g,
                        toString: g
                    }), e1(w, _, r(n, {
                        brighter: function(t1) {
                            return t1 = null == t1 ? 1 / .7 : Math.pow(1 / .7, t1), new w(this.r * t1, this.g * t1, this.b * t1, this.opacity);
                        },
                        darker: function(t1) {
                            return t1 = null == t1 ? .7 : Math.pow(.7, t1), new w(this.r * t1, this.g * t1, this.b * t1, this.opacity);
                        },
                        rgb: function() {
                            return this;
                        },
                        displayable: function() {
                            return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
                        },
                        hex: T,
                        formatHex: T,
                        formatRgb: k,
                        toString: k
                    })), e1(L, E, r(n, {
                        brighter: function(t1) {
                            return t1 = null == t1 ? 1 / .7 : Math.pow(1 / .7, t1), new L(this.h, this.s, this.l * t1, this.opacity);
                        },
                        darker: function(t1) {
                            return t1 = null == t1 ? .7 : Math.pow(.7, t1), new L(this.h, this.s, this.l * t1, this.opacity);
                        },
                        rgb: function() {
                            var t1 = this.h % 360 + 360 * (this.h < 0), e1 = isNaN(t1) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < .5 ? r : 1 - r) * e1, i = 2 * r - n;
                            return new w(C(t1 >= 240 ? t1 - 240 : t1 + 120, i, n), C(t1, i, n), C(t1 < 120 ? t1 + 240 : t1 - 120, i, n), this.opacity);
                        },
                        displayable: function() {
                            return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
                        },
                        formatHsl: function() {
                            var t1 = this.opacity;
                            return (1 === (t1 = isNaN(t1) ? 1 : Math.max(0, Math.min(1, t1))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t1 ? ")" : ", " + t1 + ")");
                        }
                    }));
                    var P = Math.PI / 180, I = 180 / Math.PI, O = 6 / 29, z = 3 * O * O;
                    function D(t1) {
                        if (t1 instanceof F) return new F(t1.l, t1.a, t1.b, t1.opacity);
                        if (t1 instanceof q) return G(t1);
                        t1 instanceof w || (t1 = b(t1));
                        var e1, r, n = U(t1.r), i = U(t1.g), a = U(t1.b), o = B((.2225045 * n + .7168786 * i + .0606169 * a) / 1);
                        return n === i && i === a ? e1 = r = o : (e1 = B((.4360747 * n + .3850649 * i + .1430804 * a) / .96422), r = B((.0139322 * n + .0971045 * i + .7141733 * a) / .82521)), new F(116 * o - 16, 500 * (e1 - o), 200 * (o - r), t1.opacity);
                    }
                    function R(t1, e1, r, n) {
                        return 1 === arguments.length ? D(t1) : new F(t1, e1, r, null == n ? 1 : n);
                    }
                    function F(t1, e1, r, n) {
                        this.l = +t1, this.a = +e1, this.b = +r, this.opacity = +n;
                    }
                    function B(t1) {
                        return t1 > .008856451679035631 ? Math.pow(t1, 1 / 3) : t1 / z + 4 / 29;
                    }
                    function N(t1) {
                        return t1 > O ? t1 * t1 * t1 : z * (t1 - 4 / 29);
                    }
                    function j(t1) {
                        return 255 * (t1 <= .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055);
                    }
                    function U(t1) {
                        return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
                    }
                    function V(t1) {
                        if (t1 instanceof q) return new q(t1.h, t1.c, t1.l, t1.opacity);
                        if (t1 instanceof F || (t1 = D(t1)), 0 === t1.a && 0 === t1.b) return new q(NaN, 0 < t1.l && t1.l < 100 ? 0 : NaN, t1.l, t1.opacity);
                        var e1 = Math.atan2(t1.b, t1.a) * I;
                        return new q(e1 < 0 ? e1 + 360 : e1, Math.sqrt(t1.a * t1.a + t1.b * t1.b), t1.l, t1.opacity);
                    }
                    function H(t1, e1, r, n) {
                        return 1 === arguments.length ? V(t1) : new q(t1, e1, r, null == n ? 1 : n);
                    }
                    function q(t1, e1, r, n) {
                        this.h = +t1, this.c = +e1, this.l = +r, this.opacity = +n;
                    }
                    function G(t1) {
                        if (isNaN(t1.h)) return new F(t1.l, 0, 0, t1.opacity);
                        var e1 = t1.h * P;
                        return new F(t1.l, Math.cos(e1) * t1.c, Math.sin(e1) * t1.c, t1.opacity);
                    }
                    e1(F, R, r(n, {
                        brighter: function(t1) {
                            return new F(this.l + 18 * (null == t1 ? 1 : t1), this.a, this.b, this.opacity);
                        },
                        darker: function(t1) {
                            return new F(this.l - 18 * (null == t1 ? 1 : t1), this.a, this.b, this.opacity);
                        },
                        rgb: function() {
                            var t1 = (this.l + 16) / 116, e1 = isNaN(this.a) ? t1 : t1 + this.a / 500, r = isNaN(this.b) ? t1 : t1 - this.b / 200;
                            return new w(j(3.1338561 * (e1 = .96422 * N(e1)) - 1.6168667 * (t1 = 1 * N(t1)) - .4906146 * (r = .82521 * N(r))), j(-0.9787684 * e1 + 1.9161415 * t1 + .033454 * r), j(.0719453 * e1 - .2289914 * t1 + 1.4052427 * r), this.opacity);
                        }
                    })), e1(q, H, r(n, {
                        brighter: function(t1) {
                            return new q(this.h, this.c, this.l + 18 * (null == t1 ? 1 : t1), this.opacity);
                        },
                        darker: function(t1) {
                            return new q(this.h, this.c, this.l - 18 * (null == t1 ? 1 : t1), this.opacity);
                        },
                        rgb: function() {
                            return G(this).rgb();
                        }
                    }));
                    var Y = -0.14861, W = 1.78277, X = -0.29227, Z = -0.90649, J = 1.97294, K = J * Z, Q = J * W, $ = W * X - Z * Y;
                    function tt(t1) {
                        if (t1 instanceof rt) return new rt(t1.h, t1.s, t1.l, t1.opacity);
                        t1 instanceof w || (t1 = b(t1));
                        var e1 = t1.r / 255, r = t1.g / 255, n = t1.b / 255, i = ($ * n + K * e1 - Q * r) / ($ + K - Q), a = n - i, o = (J * (r - i) - X * a) / Z, s = Math.sqrt(o * o + a * a) / (J * i * (1 - i)), l = s ? Math.atan2(o, a) * I - 120 : NaN;
                        return new rt(l < 0 ? l + 360 : l, s, i, t1.opacity);
                    }
                    function et(t1, e1, r, n) {
                        return 1 === arguments.length ? tt(t1) : new rt(t1, e1, r, null == n ? 1 : n);
                    }
                    function rt(t1, e1, r, n) {
                        this.h = +t1, this.s = +e1, this.l = +r, this.opacity = +n;
                    }
                    e1(rt, et, r(n, {
                        brighter: function(t1) {
                            return t1 = null == t1 ? 1 / .7 : Math.pow(1 / .7, t1), new rt(this.h, this.s, this.l * t1, this.opacity);
                        },
                        darker: function(t1) {
                            return t1 = null == t1 ? .7 : Math.pow(.7, t1), new rt(this.h, this.s, this.l * t1, this.opacity);
                        },
                        rgb: function() {
                            var t1 = isNaN(this.h) ? 0 : (this.h + 120) * P, e1 = +this.l, r = isNaN(this.s) ? 0 : this.s * e1 * (1 - e1), n = Math.cos(t1), i = Math.sin(t1);
                            return new w(255 * (e1 + r * (Y * n + W * i)), 255 * (e1 + r * (X * n + Z * i)), 255 * (e1 + r * (J * n)), this.opacity);
                        }
                    })), t1.color = v, t1.cubehelix = et, t1.gray = function(t1, e1) {
                        return new F(t1, 0, 0, null == e1 ? 1 : e1);
                    }, t1.hcl = H, t1.hsl = E, t1.lab = R, t1.lch = function(t1, e1, r, n) {
                        return 1 === arguments.length ? V(t1) : new q(r, e1, t1, null == n ? 1 : n);
                    }, t1.rgb = _, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {}
        ],
        110: [
            function(t1, e1, r) {
                !function(t1, n) {
                    "object" == typeof r && void 0 !== e1 ? n(r) : n((t1 = t1 || self).d3 = t1.d3 || {});
                }(this, function(t1) {
                    "use strict";
                    var e1 = {
                        value: function() {}
                    };
                    function r() {
                        for(var t1, e1 = 0, r = arguments.length, i = {}; e1 < r; ++e1){
                            if (!(t1 = arguments[e1] + "") || t1 in i || /[\s.]/.test(t1)) throw new Error("illegal type: " + t1);
                            i[t1] = [];
                        }
                        return new n(i);
                    }
                    function n(t1) {
                        this._ = t1;
                    }
                    function i(t1, e1) {
                        return t1.trim().split(/^|\s+/).map(function(t1) {
                            var r = "", n = t1.indexOf(".");
                            if (n >= 0 && (r = t1.slice(n + 1), t1 = t1.slice(0, n)), t1 && !e1.hasOwnProperty(t1)) throw new Error("unknown type: " + t1);
                            return {
                                type: t1,
                                name: r
                            };
                        });
                    }
                    function a(t1, e1) {
                        for(var r, n = 0, i = t1.length; n < i; ++n)if ((r = t1[n]).name === e1) return r.value;
                    }
                    function o(t1, r, n) {
                        for(var i = 0, a = t1.length; i < a; ++i)if (t1[i].name === r) {
                            t1[i] = e1, t1 = t1.slice(0, i).concat(t1.slice(i + 1));
                            break;
                        }
                        return null != n && t1.push({
                            name: r,
                            value: n
                        }), t1;
                    }
                    n.prototype = r.prototype = {
                        constructor: n,
                        on: function(t1, e1) {
                            var r, n = this._, s = i(t1 + "", n), l = -1, c = s.length;
                            if (!(arguments.length < 2)) {
                                if (null != e1 && "function" != typeof e1) throw new Error("invalid callback: " + e1);
                                for(; ++l < c;)if (r = (t1 = s[l]).type) n[r] = o(n[r], t1.name, e1);
                                else if (null == e1) for(r in n)n[r] = o(n[r], t1.name, null);
                                return this;
                            }
                            for(; ++l < c;)if ((r = (t1 = s[l]).type) && (r = a(n[r], t1.name))) return r;
                        },
                        copy: function() {
                            var t1 = {}, e1 = this._;
                            for(var r in e1)t1[r] = e1[r].slice();
                            return new n(t1);
                        },
                        call: function(t1, e1) {
                            if ((r = arguments.length - 2) > 0) for(var r, n, i = new Array(r), a = 0; a < r; ++a)i[a] = arguments[a + 2];
                            if (!this._.hasOwnProperty(t1)) throw new Error("unknown type: " + t1);
                            for(a = 0, r = (n = this._[t1]).length; a < r; ++a)n[a].value.apply(e1, i);
                        },
                        apply: function(t1, e1, r) {
                            if (!this._.hasOwnProperty(t1)) throw new Error("unknown type: " + t1);
                            for(var n = this._[t1], i = 0, a = n.length; i < a; ++i)n[i].value.apply(e1, r);
                        }
                    }, t1.dispatch = r, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {}
        ],
        111: [
            function(t1, e1, r) {
                !function(n, i) {
                    "object" == typeof r && void 0 !== e1 ? i(r, t1("d3-quadtree"), t1("d3-collection"), t1("d3-dispatch"), t1("d3-timer")) : i(n.d3 = n.d3 || {}, n.d3, n.d3, n.d3, n.d3);
                }(this, function(t1, e1, r, n, i) {
                    "use strict";
                    function a(t1) {
                        return function() {
                            return t1;
                        };
                    }
                    function o() {
                        return 1e-6 * (Math.random() - .5);
                    }
                    function s(t1) {
                        return t1.x + t1.vx;
                    }
                    function l(t1) {
                        return t1.y + t1.vy;
                    }
                    function c(t1) {
                        return t1.index;
                    }
                    function u(t1, e1) {
                        var r = t1.get(e1);
                        if (!r) throw new Error("missing: " + e1);
                        return r;
                    }
                    function f(t1) {
                        return t1.x;
                    }
                    function h(t1) {
                        return t1.y;
                    }
                    var p = Math.PI * (3 - Math.sqrt(5));
                    t1.forceCenter = function(t1, e1) {
                        var r;
                        function n() {
                            var n, i, a = r.length, o = 0, s = 0;
                            for(n = 0; n < a; ++n)o += (i = r[n]).x, s += i.y;
                            for(o = o / a - t1, s = s / a - e1, n = 0; n < a; ++n)(i = r[n]).x -= o, i.y -= s;
                        }
                        return null == t1 && (t1 = 0), null == e1 && (e1 = 0), n.initialize = function(t1) {
                            r = t1;
                        }, n.x = function(e1) {
                            return arguments.length ? (t1 = +e1, n) : t1;
                        }, n.y = function(t1) {
                            return arguments.length ? (e1 = +t1, n) : e1;
                        }, n;
                    }, t1.forceCollide = function(t1) {
                        var r, n, i = 1, c = 1;
                        function u() {
                            for(var t1, a, u, h, p, d, m, g = r.length, v = 0; v < c; ++v)for(a = e1.quadtree(r, s, l).visitAfter(f), t1 = 0; t1 < g; ++t1)u = r[t1], d = n[u.index], m = d * d, h = u.x + u.vx, p = u.y + u.vy, a.visit(y);
                            function y(t1, e1, r, n, a) {
                                var s = t1.data, l = t1.r, c = d + l;
                                if (!s) return e1 > h + c || n < h - c || r > p + c || a < p - c;
                                if (s.index > u.index) {
                                    var f = h - s.x - s.vx, g = p - s.y - s.vy, v = f * f + g * g;
                                    v < c * c && (0 === f && (v += (f = o()) * f), 0 === g && (v += (g = o()) * g), v = (c - (v = Math.sqrt(v))) / v * i, u.vx += (f *= v) * (c = (l *= l) / (m + l)), u.vy += (g *= v) * c, s.vx -= f * (c = 1 - c), s.vy -= g * c);
                                }
                            }
                        }
                        function f(t1) {
                            if (t1.data) return t1.r = n[t1.data.index];
                            for(var e1 = t1.r = 0; e1 < 4; ++e1)t1[e1] && t1[e1].r > t1.r && (t1.r = t1[e1].r);
                        }
                        function h() {
                            if (r) {
                                var e1, i, a = r.length;
                                for(n = new Array(a), e1 = 0; e1 < a; ++e1)i = r[e1], n[i.index] = +t1(i, e1, r);
                            }
                        }
                        return "function" != typeof t1 && (t1 = a(null == t1 ? 1 : +t1)), u.initialize = function(t1) {
                            r = t1, h();
                        }, u.iterations = function(t1) {
                            return arguments.length ? (c = +t1, u) : c;
                        }, u.strength = function(t1) {
                            return arguments.length ? (i = +t1, u) : i;
                        }, u.radius = function(e1) {
                            return arguments.length ? (t1 = "function" == typeof e1 ? e1 : a(+e1), h(), u) : t1;
                        }, u;
                    }, t1.forceLink = function(t1) {
                        var e1, n, i, s, l, f = c, h = function(t1) {
                            return 1 / Math.min(s[t1.source.index], s[t1.target.index]);
                        }, p = a(30), d = 1;
                        function m(r) {
                            for(var i = 0, a = t1.length; i < d; ++i)for(var s, c, u, f, h, p, m, g = 0; g < a; ++g)c = (s = t1[g]).source, f = (u = s.target).x + u.vx - c.x - c.vx || o(), h = u.y + u.vy - c.y - c.vy || o(), f *= p = ((p = Math.sqrt(f * f + h * h)) - n[g]) / p * r * e1[g], h *= p, u.vx -= f * (m = l[g]), u.vy -= h * m, c.vx += f * (m = 1 - m), c.vy += h * m;
                        }
                        function g() {
                            if (i) {
                                var a, o, c = i.length, h = t1.length, p = r.map(i, f);
                                for(a = 0, s = new Array(c); a < h; ++a)(o = t1[a]).index = a, "object" != typeof o.source && (o.source = u(p, o.source)), "object" != typeof o.target && (o.target = u(p, o.target)), s[o.source.index] = (s[o.source.index] || 0) + 1, s[o.target.index] = (s[o.target.index] || 0) + 1;
                                for(a = 0, l = new Array(h); a < h; ++a)o = t1[a], l[a] = s[o.source.index] / (s[o.source.index] + s[o.target.index]);
                                e1 = new Array(h), v(), n = new Array(h), y();
                            }
                        }
                        function v() {
                            if (i) for(var r = 0, n = t1.length; r < n; ++r)e1[r] = +h(t1[r], r, t1);
                        }
                        function y() {
                            if (i) for(var e1 = 0, r = t1.length; e1 < r; ++e1)n[e1] = +p(t1[e1], e1, t1);
                        }
                        return null == t1 && (t1 = []), m.initialize = function(t1) {
                            i = t1, g();
                        }, m.links = function(e1) {
                            return arguments.length ? (t1 = e1, g(), m) : t1;
                        }, m.id = function(t1) {
                            return arguments.length ? (f = t1, m) : f;
                        }, m.iterations = function(t1) {
                            return arguments.length ? (d = +t1, m) : d;
                        }, m.strength = function(t1) {
                            return arguments.length ? (h = "function" == typeof t1 ? t1 : a(+t1), v(), m) : h;
                        }, m.distance = function(t1) {
                            return arguments.length ? (p = "function" == typeof t1 ? t1 : a(+t1), y(), m) : p;
                        }, m;
                    }, t1.forceManyBody = function() {
                        var t1, r, n, i, s = a(-30), l = 1, c = 1 / 0, u = .81;
                        function p(i) {
                            var a, o = t1.length, s = e1.quadtree(t1, f, h).visitAfter(m);
                            for(n = i, a = 0; a < o; ++a)r = t1[a], s.visit(g);
                        }
                        function d() {
                            if (t1) {
                                var e1, r, n = t1.length;
                                for(i = new Array(n), e1 = 0; e1 < n; ++e1)r = t1[e1], i[r.index] = +s(r, e1, t1);
                            }
                        }
                        function m(t1) {
                            var e1, r, n, a, o, s = 0, l = 0;
                            if (t1.length) {
                                for(n = a = o = 0; o < 4; ++o)(e1 = t1[o]) && (r = Math.abs(e1.value)) && (s += e1.value, l += r, n += r * e1.x, a += r * e1.y);
                                t1.x = n / l, t1.y = a / l;
                            } else {
                                (e1 = t1).x = e1.data.x, e1.y = e1.data.y;
                                do s += i[e1.data.index];
                                while (e1 = e1.next);
                            }
                            t1.value = s;
                        }
                        function g(t1, e1, a, s) {
                            if (!t1.value) return !0;
                            var f = t1.x - r.x, h = t1.y - r.y, p = s - e1, d = f * f + h * h;
                            if (p * p / u < d) return d < c && (0 === f && (d += (f = o()) * f), 0 === h && (d += (h = o()) * h), d < l && (d = Math.sqrt(l * d)), r.vx += f * t1.value * n / d, r.vy += h * t1.value * n / d), !0;
                            if (!(t1.length || d >= c)) {
                                (t1.data !== r || t1.next) && (0 === f && (d += (f = o()) * f), 0 === h && (d += (h = o()) * h), d < l && (d = Math.sqrt(l * d)));
                                do t1.data !== r && (p = i[t1.data.index] * n / d, r.vx += f * p, r.vy += h * p);
                                while (t1 = t1.next);
                            }
                        }
                        return p.initialize = function(e1) {
                            t1 = e1, d();
                        }, p.strength = function(t1) {
                            return arguments.length ? (s = "function" == typeof t1 ? t1 : a(+t1), d(), p) : s;
                        }, p.distanceMin = function(t1) {
                            return arguments.length ? (l = t1 * t1, p) : Math.sqrt(l);
                        }, p.distanceMax = function(t1) {
                            return arguments.length ? (c = t1 * t1, p) : Math.sqrt(c);
                        }, p.theta = function(t1) {
                            return arguments.length ? (u = t1 * t1, p) : Math.sqrt(u);
                        }, p;
                    }, t1.forceRadial = function(t1, e1, r) {
                        var n, i, o, s = a(.1);
                        function l(t1) {
                            for(var a = 0, s = n.length; a < s; ++a){
                                var l = n[a], c = l.x - e1 || 1e-6, u = l.y - r || 1e-6, f = Math.sqrt(c * c + u * u), h = (o[a] - f) * i[a] * t1 / f;
                                l.vx += c * h, l.vy += u * h;
                            }
                        }
                        function c() {
                            if (n) {
                                var e1, r = n.length;
                                for(i = new Array(r), o = new Array(r), e1 = 0; e1 < r; ++e1)o[e1] = +t1(n[e1], e1, n), i[e1] = isNaN(o[e1]) ? 0 : +s(n[e1], e1, n);
                            }
                        }
                        return "function" != typeof t1 && (t1 = a(+t1)), null == e1 && (e1 = 0), null == r && (r = 0), l.initialize = function(t1) {
                            n = t1, c();
                        }, l.strength = function(t1) {
                            return arguments.length ? (s = "function" == typeof t1 ? t1 : a(+t1), c(), l) : s;
                        }, l.radius = function(e1) {
                            return arguments.length ? (t1 = "function" == typeof e1 ? e1 : a(+e1), c(), l) : t1;
                        }, l.x = function(t1) {
                            return arguments.length ? (e1 = +t1, l) : e1;
                        }, l.y = function(t1) {
                            return arguments.length ? (r = +t1, l) : r;
                        }, l;
                    }, t1.forceSimulation = function(t1) {
                        var e1, a = 1, o = .001, s = 1 - Math.pow(o, 1 / 300), l = 0, c = .6, u = r.map(), f = i.timer(d), h = n.dispatch("tick", "end");
                        function d() {
                            m(), h.call("tick", e1), a < o && (f.stop(), h.call("end", e1));
                        }
                        function m(r) {
                            var n, i, o = t1.length;
                            void 0 === r && (r = 1);
                            for(var f = 0; f < r; ++f)for(a += (l - a) * s, u.each(function(t1) {
                                t1(a);
                            }), n = 0; n < o; ++n)null == (i = t1[n]).fx ? i.x += i.vx *= c : (i.x = i.fx, i.vx = 0), null == i.fy ? i.y += i.vy *= c : (i.y = i.fy, i.vy = 0);
                            return e1;
                        }
                        function g() {
                            for(var e1, r = 0, n = t1.length; r < n; ++r){
                                if ((e1 = t1[r]).index = r, null != e1.fx && (e1.x = e1.fx), null != e1.fy && (e1.y = e1.fy), isNaN(e1.x) || isNaN(e1.y)) {
                                    var i = 10 * Math.sqrt(r), a = r * p;
                                    e1.x = i * Math.cos(a), e1.y = i * Math.sin(a);
                                }
                                (isNaN(e1.vx) || isNaN(e1.vy)) && (e1.vx = e1.vy = 0);
                            }
                        }
                        function v(e1) {
                            return e1.initialize && e1.initialize(t1), e1;
                        }
                        return null == t1 && (t1 = []), g(), e1 = {
                            tick: m,
                            restart: function() {
                                return f.restart(d), e1;
                            },
                            stop: function() {
                                return f.stop(), e1;
                            },
                            nodes: function(r) {
                                return arguments.length ? (t1 = r, g(), u.each(v), e1) : t1;
                            },
                            alpha: function(t1) {
                                return arguments.length ? (a = +t1, e1) : a;
                            },
                            alphaMin: function(t1) {
                                return arguments.length ? (o = +t1, e1) : o;
                            },
                            alphaDecay: function(t1) {
                                return arguments.length ? (s = +t1, e1) : +s;
                            },
                            alphaTarget: function(t1) {
                                return arguments.length ? (l = +t1, e1) : l;
                            },
                            velocityDecay: function(t1) {
                                return arguments.length ? (c = 1 - t1, e1) : 1 - c;
                            },
                            force: function(t1, r) {
                                return arguments.length > 1 ? (null == r ? u.remove(t1) : u.set(t1, v(r)), e1) : u.get(t1);
                            },
                            find: function(e1, r, n) {
                                var i, a, o, s, l, c = 0, u = t1.length;
                                for(null == n ? n = 1 / 0 : n *= n, c = 0; c < u; ++c)(o = (i = e1 - (s = t1[c]).x) * i + (a = r - s.y) * a) < n && (l = s, n = o);
                                return l;
                            },
                            on: function(t1, r) {
                                return arguments.length > 1 ? (h.on(t1, r), e1) : h.on(t1);
                            }
                        };
                    }, t1.forceX = function(t1) {
                        var e1, r, n, i = a(.1);
                        function o(t1) {
                            for(var i, a = 0, o = e1.length; a < o; ++a)(i = e1[a]).vx += (n[a] - i.x) * r[a] * t1;
                        }
                        function s() {
                            if (e1) {
                                var a, o = e1.length;
                                for(r = new Array(o), n = new Array(o), a = 0; a < o; ++a)r[a] = isNaN(n[a] = +t1(e1[a], a, e1)) ? 0 : +i(e1[a], a, e1);
                            }
                        }
                        return "function" != typeof t1 && (t1 = a(null == t1 ? 0 : +t1)), o.initialize = function(t1) {
                            e1 = t1, s();
                        }, o.strength = function(t1) {
                            return arguments.length ? (i = "function" == typeof t1 ? t1 : a(+t1), s(), o) : i;
                        }, o.x = function(e1) {
                            return arguments.length ? (t1 = "function" == typeof e1 ? e1 : a(+e1), s(), o) : t1;
                        }, o;
                    }, t1.forceY = function(t1) {
                        var e1, r, n, i = a(.1);
                        function o(t1) {
                            for(var i, a = 0, o = e1.length; a < o; ++a)(i = e1[a]).vy += (n[a] - i.y) * r[a] * t1;
                        }
                        function s() {
                            if (e1) {
                                var a, o = e1.length;
                                for(r = new Array(o), n = new Array(o), a = 0; a < o; ++a)r[a] = isNaN(n[a] = +t1(e1[a], a, e1)) ? 0 : +i(e1[a], a, e1);
                            }
                        }
                        return "function" != typeof t1 && (t1 = a(null == t1 ? 0 : +t1)), o.initialize = function(t1) {
                            e1 = t1, s();
                        }, o.strength = function(t1) {
                            return arguments.length ? (i = "function" == typeof t1 ? t1 : a(+t1), s(), o) : i;
                        }, o.y = function(e1) {
                            return arguments.length ? (t1 = "function" == typeof e1 ? e1 : a(+e1), s(), o) : t1;
                        }, o;
                    }, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {
                "d3-collection": 108,
                "d3-dispatch": 110,
                "d3-quadtree": 118,
                "d3-timer": 123
            }
        ],
        112: [
            function(t1, e1, r) {
                !function(t1, n) {
                    "object" == typeof r && void 0 !== e1 ? n(r) : n((t1 = "undefined" != typeof globalThis ? globalThis : t1 || self).d3 = t1.d3 || {});
                }(this, function(t1) {
                    "use strict";
                    function e1(t1, e1) {
                        if ((r = (t1 = e1 ? t1.toExponential(e1 - 1) : t1.toExponential()).indexOf("e")) < 0) return null;
                        var r, n = t1.slice(0, r);
                        return [
                            n.length > 1 ? n[0] + n.slice(2) : n,
                            +t1.slice(r + 1)
                        ];
                    }
                    function r(t1) {
                        return (t1 = e1(Math.abs(t1))) ? t1[1] : NaN;
                    }
                    var n, i = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
                    function a(t1) {
                        if (!(e1 = i.exec(t1))) throw new Error("invalid format: " + t1);
                        var e1;
                        return new o({
                            fill: e1[1],
                            align: e1[2],
                            sign: e1[3],
                            symbol: e1[4],
                            zero: e1[5],
                            width: e1[6],
                            comma: e1[7],
                            precision: e1[8] && e1[8].slice(1),
                            trim: e1[9],
                            type: e1[10]
                        });
                    }
                    function o(t1) {
                        this.fill = void 0 === t1.fill ? " " : t1.fill + "", this.align = void 0 === t1.align ? ">" : t1.align + "", this.sign = void 0 === t1.sign ? "-" : t1.sign + "", this.symbol = void 0 === t1.symbol ? "" : t1.symbol + "", this.zero = !!t1.zero, this.width = void 0 === t1.width ? void 0 : +t1.width, this.comma = !!t1.comma, this.precision = void 0 === t1.precision ? void 0 : +t1.precision, this.trim = !!t1.trim, this.type = void 0 === t1.type ? "" : t1.type + "";
                    }
                    function s(t1, r) {
                        var n = e1(t1, r);
                        if (!n) return t1 + "";
                        var i = n[0], a = n[1];
                        return a < 0 ? "0." + new Array(-a).join("0") + i : i.length > a + 1 ? i.slice(0, a + 1) + "." + i.slice(a + 1) : i + new Array(a - i.length + 2).join("0");
                    }
                    a.prototype = o.prototype, o.prototype.toString = function() {
                        return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
                    };
                    var l = {
                        "%": function(t1, e1) {
                            return (100 * t1).toFixed(e1);
                        },
                        b: function(t1) {
                            return Math.round(t1).toString(2);
                        },
                        c: function(t1) {
                            return t1 + "";
                        },
                        d: function(t1) {
                            return Math.abs(t1 = Math.round(t1)) >= 1e21 ? t1.toLocaleString("en").replace(/,/g, "") : t1.toString(10);
                        },
                        e: function(t1, e1) {
                            return t1.toExponential(e1);
                        },
                        f: function(t1, e1) {
                            return t1.toFixed(e1);
                        },
                        g: function(t1, e1) {
                            return t1.toPrecision(e1);
                        },
                        o: function(t1) {
                            return Math.round(t1).toString(8);
                        },
                        p: function(t1, e1) {
                            return s(100 * t1, e1);
                        },
                        r: s,
                        s: function(t1, r) {
                            var i = e1(t1, r);
                            if (!i) return t1 + "";
                            var a = i[0], o = i[1], s = o - (n = 3 * Math.max(-8, Math.min(8, Math.floor(o / 3)))) + 1, l = a.length;
                            return s === l ? a : s > l ? a + new Array(s - l + 1).join("0") : s > 0 ? a.slice(0, s) + "." + a.slice(s) : "0." + new Array(1 - s).join("0") + e1(t1, Math.max(0, r + s - 1))[0];
                        },
                        X: function(t1) {
                            return Math.round(t1).toString(16).toUpperCase();
                        },
                        x: function(t1) {
                            return Math.round(t1).toString(16);
                        }
                    };
                    function c(t1) {
                        return t1;
                    }
                    var u, f = Array.prototype.map, h = [
                        "y",
                        "z",
                        "a",
                        "f",
                        "p",
                        "n",
                        "\xb5",
                        "m",
                        "",
                        "k",
                        "M",
                        "G",
                        "T",
                        "P",
                        "E",
                        "Z",
                        "Y"
                    ];
                    function p(t1) {
                        var e1, i, o = void 0 === t1.grouping || void 0 === t1.thousands ? c : (e1 = f.call(t1.grouping, Number), i = t1.thousands + "", function(t1, r) {
                            for(var n = t1.length, a = [], o = 0, s = e1[0], l = 0; n > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), a.push(t1.substring(n -= s, n + s)), !((l += s + 1) > r));)s = e1[o = (o + 1) % e1.length];
                            return a.reverse().join(i);
                        }), s = void 0 === t1.currency ? "" : t1.currency[0] + "", u = void 0 === t1.currency ? "" : t1.currency[1] + "", p = void 0 === t1.decimal ? "." : t1.decimal + "", d = void 0 === t1.numerals ? c : function(t1) {
                            return function(e1) {
                                return e1.replace(/[0-9]/g, function(e1) {
                                    return t1[+e1];
                                });
                            };
                        }(f.call(t1.numerals, String)), m = void 0 === t1.percent ? "%" : t1.percent + "", g = void 0 === t1.minus ? "-" : t1.minus + "", v = void 0 === t1.nan ? "NaN" : t1.nan + "";
                        function y(t1) {
                            var e1 = (t1 = a(t1)).fill, r = t1.align, i = t1.sign, c = t1.symbol, f = t1.zero, y = t1.width, x = t1.comma, b = t1.precision, _ = t1.trim, w = t1.type;
                            "n" === w ? (x = !0, w = "g") : l[w] || (void 0 === b && (b = 12), _ = !0, w = "g"), (f || "0" === e1 && "=" === r) && (f = !0, e1 = "0", r = "=");
                            var T = "$" === c ? s : "#" === c && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "", k = "$" === c ? u : /[%p]/.test(w) ? m : "", A = l[w], M = /[defgprs%]/.test(w);
                            function S(t1) {
                                var a, s, l, c = T, u = k;
                                if ("c" === w) u = A(t1) + u, t1 = "";
                                else {
                                    var m = (t1 = +t1) < 0 || 1 / t1 < 0;
                                    if (t1 = isNaN(t1) ? v : A(Math.abs(t1), b), _ && (t1 = function(t1) {
                                        t: for(var e1, r = t1.length, n = 1, i = -1; n < r; ++n)switch(t1[n]){
                                            case ".":
                                                i = e1 = n;
                                                break;
                                            case "0":
                                                0 === i && (i = n), e1 = n;
                                                break;
                                            default:
                                                if (!+t1[n]) break t;
                                                i > 0 && (i = 0);
                                        }
                                        return i > 0 ? t1.slice(0, i) + t1.slice(e1 + 1) : t1;
                                    }(t1)), m && 0 == +t1 && "+" !== i && (m = !1), c = (m ? "(" === i ? i : g : "-" === i || "(" === i ? "" : i) + c, u = ("s" === w ? h[8 + n / 3] : "") + u + (m && "(" === i ? ")" : ""), M) {
                                        for(a = -1, s = t1.length; ++a < s;)if (48 > (l = t1.charCodeAt(a)) || l > 57) {
                                            u = (46 === l ? p + t1.slice(a + 1) : t1.slice(a)) + u, t1 = t1.slice(0, a);
                                            break;
                                        }
                                    }
                                }
                                x && !f && (t1 = o(t1, 1 / 0));
                                var S = c.length + t1.length + u.length, E = S < y ? new Array(y - S + 1).join(e1) : "";
                                switch(x && f && (t1 = o(E + t1, E.length ? y - u.length : 1 / 0), E = ""), r){
                                    case "<":
                                        t1 = c + t1 + u + E;
                                        break;
                                    case "=":
                                        t1 = c + E + t1 + u;
                                        break;
                                    case "^":
                                        t1 = E.slice(0, S = E.length >> 1) + c + t1 + u + E.slice(S);
                                        break;
                                    default:
                                        t1 = E + c + t1 + u;
                                }
                                return d(t1);
                            }
                            return b = void 0 === b ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, b)) : Math.max(0, Math.min(20, b)), S.toString = function() {
                                return t1 + "";
                            }, S;
                        }
                        return {
                            format: y,
                            formatPrefix: function(t1, e1) {
                                var n = y(((t1 = a(t1)).type = "f", t1)), i = 3 * Math.max(-8, Math.min(8, Math.floor(r(e1) / 3))), o = Math.pow(10, -i), s = h[8 + i / 3];
                                return function(t1) {
                                    return n(o * t1) + s;
                                };
                            }
                        };
                    }
                    function d(e1) {
                        return u = p(e1), t1.format = u.format, t1.formatPrefix = u.formatPrefix, u;
                    }
                    d({
                        decimal: ".",
                        thousands: ",",
                        grouping: [
                            3
                        ],
                        currency: [
                            "$",
                            ""
                        ],
                        minus: "-"
                    }), t1.FormatSpecifier = o, t1.formatDefaultLocale = d, t1.formatLocale = p, t1.formatSpecifier = a, t1.precisionFixed = function(t1) {
                        return Math.max(0, -r(Math.abs(t1)));
                    }, t1.precisionPrefix = function(t1, e1) {
                        return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(r(e1) / 3))) - r(Math.abs(t1)));
                    }, t1.precisionRound = function(t1, e1) {
                        return t1 = Math.abs(t1), e1 = Math.abs(e1) - t1, Math.max(0, r(e1) - r(t1)) + 1;
                    }, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {}
        ],
        113: [
            function(t1, e1, r) {
                !function(n, i) {
                    "object" == typeof r && void 0 !== e1 ? i(r, t1("d3-geo"), t1("d3-array")) : i(n.d3 = n.d3 || {}, n.d3, n.d3);
                }(this, function(t1, e1, r) {
                    "use strict";
                    var n = Math.abs, i = Math.atan, a = Math.atan2, o = Math.cos, s = Math.exp, l = Math.floor, c = Math.log, u = Math.max, f = Math.min, h = Math.pow, p = Math.round, d = Math.sign || function(t1) {
                        return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
                    }, m = Math.sin, g = Math.tan, v = 1e-6, y = Math.PI, x = y / 2, b = y / 4, _ = Math.SQRT1_2, w = L(2), T = L(y), k = 2 * y, A = 180 / y, M = y / 180;
                    function S(t1) {
                        return t1 > 1 ? x : t1 < -1 ? -x : Math.asin(t1);
                    }
                    function E(t1) {
                        return t1 > 1 ? 0 : t1 < -1 ? y : Math.acos(t1);
                    }
                    function L(t1) {
                        return t1 > 0 ? Math.sqrt(t1) : 0;
                    }
                    function C(t1) {
                        return (s(t1) - s(-t1)) / 2;
                    }
                    function P(t1) {
                        return (s(t1) + s(-t1)) / 2;
                    }
                    function I(t1) {
                        var e1 = g(t1 / 2), r = 2 * c(o(t1 / 2)) / (e1 * e1);
                        function i(t1, e1) {
                            var n = o(t1), i = o(e1), a = m(e1), s = i * n, l = -((1 - s ? c((1 + s) / 2) / (1 - s) : -0.5) + r / (1 + s));
                            return [
                                l * i * m(t1),
                                l * a
                            ];
                        }
                        return i.invert = function(e1, i) {
                            var s, l = L(e1 * e1 + i * i), u = -t1 / 2, f = 50;
                            if (!l) return [
                                0,
                                0
                            ];
                            do {
                                var h = u / 2, p = o(h), d = m(h), g = d / p, y = -c(n(p));
                                u -= s = (2 / g * y - r * g - l) / (-y / (d * d) + 1 - r / (2 * p * p)) * (p < 0 ? .7 : 1);
                            }while (n(s) > v && --f > 0);
                            var x = m(u);
                            return [
                                a(e1 * x, l * o(u)),
                                S(i * x / l)
                            ];
                        }, i;
                    }
                    function O(t1, e1) {
                        var r = o(e1), n = function(t1) {
                            return t1 ? t1 / Math.sin(t1) : 1;
                        }(E(r * o(t1 /= 2)));
                        return [
                            2 * r * m(t1) * n,
                            m(e1) * n
                        ];
                    }
                    function z(t1) {
                        var e1 = m(t1), r = o(t1), i = t1 >= 0 ? 1 : -1, s = g(i * t1), l = (1 + e1 - r) / 2;
                        function c(t1, n) {
                            var c = o(n), u = o(t1 /= 2);
                            return [
                                (1 + c) * m(t1),
                                (i * n > -a(u, s) - .001 ? 0 : 10 * -i) + l + m(n) * r - (1 + c) * e1 * u
                            ];
                        }
                        return c.invert = function(t1, c) {
                            var u = 0, f = 0, h = 50;
                            do {
                                var p = o(u), d = m(u), g = o(f), y = m(f), x = 1 + g, b = x * d - t1, _ = l + y * r - x * e1 * p - c, w = x * p / 2, T = -d * y, k = e1 * x * d / 2, A = r * g + e1 * p * y, M = T * k - A * w, S = (_ * T - b * A) / M / 2, E = (b * k - _ * w) / M;
                                n(E) > 2 && (E /= 2), u -= S, f -= E;
                            }while ((n(S) > v || n(E) > v) && --h > 0);
                            return i * f > -a(o(u), s) - .001 ? [
                                2 * u,
                                f
                            ] : null;
                        }, c;
                    }
                    function D(t1, e1) {
                        var r = g(e1 / 2), n = L(1 - r * r), i = 1 + n * o(t1 /= 2), a = m(t1) * n / i, s = r / i, l = a * a, c = s * s;
                        return [
                            4 / 3 * a * (3 + l - 3 * c),
                            4 / 3 * s * (3 + 3 * l - c)
                        ];
                    }
                    O.invert = function(t1, e1) {
                        if (!(t1 * t1 + 4 * e1 * e1 > y * y + v)) {
                            var r = t1, i = e1, a = 25;
                            do {
                                var s, l = m(r), c = m(r / 2), u = o(r / 2), f = m(i), h = o(i), p = m(2 * i), d = f * f, g = h * h, x = c * c, b = 1 - g * u * u, _ = b ? E(h * u) * L(s = 1 / b) : s = 0, w = 2 * _ * h * c - t1, T = _ * f - e1, k = s * (g * x + _ * h * u * d), A = s * (.5 * l * p - 2 * _ * f * c), M = .25 * s * (p * c - _ * f * g * l), S = s * (d * u + _ * x * h), C = A * M - S * k;
                                if (!C) break;
                                var P = (T * A - w * S) / C, I = (w * M - T * k) / C;
                                r -= P, i -= I;
                            }while ((n(P) > v || n(I) > v) && --a > 0);
                            return [
                                r,
                                i
                            ];
                        }
                    }, D.invert = function(t1, e1) {
                        if (e1 *= 3 / 8, !(t1 *= 3 / 8) && n(e1) > 1) return null;
                        var r = 1 + t1 * t1 + e1 * e1, i = L((r - L(r * r - 4 * e1 * e1)) / 2), s = S(i) / 3, l = i ? function(t1) {
                            return c(t1 + L(t1 * t1 - 1));
                        }(n(e1 / i)) / 3 : function(t1) {
                            return c(t1 + L(t1 * t1 + 1));
                        }(n(t1)) / 3, u = o(s), f = P(l), h = f * f - u * u;
                        return [
                            2 * d(t1) * a(C(l) * u, .25 - h),
                            2 * d(e1) * a(f * m(s), .25 + h)
                        ];
                    };
                    var R = L(8), F = c(1 + w);
                    function B(t1, e1) {
                        var r = n(e1);
                        return r < b ? [
                            t1,
                            c(g(b + e1 / 2))
                        ] : [
                            t1 * o(r) * (2 * w - 1 / m(r)),
                            d(e1) * (2 * w * (r - b) - c(g(r / 2)))
                        ];
                    }
                    function N(t1) {
                        var r = 2 * y / t1;
                        function s(t1, i) {
                            var s = e1.geoAzimuthalEquidistantRaw(t1, i);
                            if (n(t1) > x) {
                                var l = a(s[1], s[0]), c = L(s[0] * s[0] + s[1] * s[1]), u = r * p((l - x) / r) + x, f = a(m(l -= u), 2 - o(l));
                                l = u + S(y / c * m(f)) - f, s[0] = c * o(l), s[1] = c * m(l);
                            }
                            return s;
                        }
                        return s.invert = function(t1, n) {
                            var s = L(t1 * t1 + n * n);
                            if (s > x) {
                                var l = a(n, t1), c = r * p((l - x) / r) + x, u = l > c ? -1 : 1, f = s * o(c - l), h = 1 / g(u * E((f - y) / L(y * (y - 2 * f) + s * s)));
                                l = c + 2 * i((h + u * L(h * h - 3)) / 3), t1 = s * o(l), n = s * m(l);
                            }
                            return e1.geoAzimuthalEquidistantRaw.invert(t1, n);
                        }, s;
                    }
                    function j(t1, r) {
                        if (arguments.length < 2 && (r = t1), 1 === r) return e1.geoAzimuthalEqualAreaRaw;
                        if (r === 1 / 0) return U;
                        function n(n, i) {
                            var a = e1.geoAzimuthalEqualAreaRaw(n / r, i);
                            return a[0] *= t1, a;
                        }
                        return n.invert = function(n, i) {
                            var a = e1.geoAzimuthalEqualAreaRaw.invert(n / t1, i);
                            return a[0] *= r, a;
                        }, n;
                    }
                    function U(t1, e1) {
                        return [
                            t1 * o(e1) / o(e1 /= 2),
                            2 * m(e1)
                        ];
                    }
                    function V(t1, e1, r) {
                        var i, a, o, s = 100;
                        r = void 0 === r ? 0 : +r, e1 = +e1;
                        do (a = t1(r)) === (o = t1(r + v)) && (o = a + v), r -= i = -1 * v * (a - e1) / (a - o);
                        while (s-- > 0 && n(i) > v);
                        return s < 0 ? NaN : r;
                    }
                    function H(t1, e1, r) {
                        return void 0 === e1 && (e1 = 40), void 0 === r && (r = 1e-12), function(i, a, o, s) {
                            var l, c, u;
                            o = void 0 === o ? 0 : +o, s = void 0 === s ? 0 : +s;
                            for(var f = 0; f < e1; f++){
                                var h = t1(o, s), p = h[0] - i, d = h[1] - a;
                                if (n(p) < r && n(d) < r) break;
                                var m = p * p + d * d;
                                if (m > l) o -= c /= 2, s -= u /= 2;
                                else {
                                    l = m;
                                    var g = (o > 0 ? -1 : 1) * r, v = (s > 0 ? -1 : 1) * r, y = t1(o + g, s), x = t1(o, s + v), b = (y[0] - h[0]) / g, _ = (y[1] - h[1]) / g, w = (x[0] - h[0]) / v, T = (x[1] - h[1]) / v, k = T * b - _ * w, A = (n(k) < .5 ? .5 : 1) / k;
                                    if (o += c = (d * w - p * T) * A, s += u = (p * _ - d * b) * A, n(c) < r && n(u) < r) break;
                                }
                            }
                            return [
                                o,
                                s
                            ];
                        };
                    }
                    function q() {
                        var t1 = j(1.68, 2);
                        function e1(e1, r) {
                            if (e1 + r < -1.4) {
                                var n = (e1 - r + 1.6) * (e1 + r + 1.4) / 8;
                                e1 += n, r -= .8 * n * m(r + y / 2);
                            }
                            var i = t1(e1, r), a = (1 - o(e1 * r)) / 12;
                            return i[1] < 0 && (i[0] *= 1 + a), i[1] > 0 && (i[1] *= 1 + a / 1.5 * i[0] * i[0]), i;
                        }
                        return e1.invert = H(e1), e1;
                    }
                    function G(t1, e1) {
                        var r, i = t1 * m(e1), a = 30;
                        do e1 -= r = (e1 + m(e1) - i) / (1 + o(e1));
                        while (n(r) > v && --a > 0);
                        return e1 / 2;
                    }
                    function Y(t1, e1, r) {
                        function n(n, i) {
                            return [
                                t1 * n * o(i = G(r, i)),
                                e1 * m(i)
                            ];
                        }
                        return n.invert = function(n, i) {
                            return i = S(i / e1), [
                                n / (t1 * o(i)),
                                S((2 * i + m(2 * i)) / r)
                            ];
                        }, n;
                    }
                    B.invert = function(t1, e1) {
                        if ((a = n(e1)) < F) return [
                            t1,
                            2 * i(s(e1)) - x
                        ];
                        var r, a, l = b, u = 25;
                        do {
                            var f = o(l / 2), h = g(l / 2);
                            l -= r = (R * (l - b) - c(h) - a) / (R - f * f / (2 * h));
                        }while (n(r) > 1e-12 && --u > 0);
                        return [
                            t1 / (o(l) * (R - 1 / m(l))),
                            d(e1) * l
                        ];
                    }, U.invert = function(t1, e1) {
                        var r = 2 * S(e1 / 2);
                        return [
                            t1 * o(r / 2) / o(r),
                            r
                        ];
                    };
                    var W = Y(w / x, w, y);
                    var X = 2.00276, Z = 1.11072;
                    function J(t1, e1) {
                        var r = G(y, e1);
                        return [
                            X * t1 / (1 / o(e1) + Z / o(r)),
                            (e1 + w * m(r)) / X
                        ];
                    }
                    function K(t1) {
                        var r = 0, n = e1.geoProjectionMutator(t1), i = n(r);
                        return i.parallel = function(t1) {
                            return arguments.length ? n(r = t1 * M) : r * A;
                        }, i;
                    }
                    function Q(t1, e1) {
                        return [
                            t1 * o(e1),
                            e1
                        ];
                    }
                    function $(t1) {
                        if (!t1) return Q;
                        var e1 = 1 / g(t1);
                        function r(r, n) {
                            var i = e1 + t1 - n, a = i ? r * o(n) / i : i;
                            return [
                                i * m(a),
                                e1 - i * o(a)
                            ];
                        }
                        return r.invert = function(r, n) {
                            var i = L(r * r + (n = e1 - n) * n), s = e1 + t1 - i;
                            return [
                                i / o(s) * a(r, n),
                                s
                            ];
                        }, r;
                    }
                    function tt(t1) {
                        function e1(e1, r) {
                            var n = x - r, i = n ? e1 * t1 * m(n) / n : n;
                            return [
                                n * m(i) / t1,
                                x - n * o(i)
                            ];
                        }
                        return e1.invert = function(e1, r) {
                            var n = e1 * t1, i = x - r, o = L(n * n + i * i), s = a(n, i);
                            return [
                                (o ? o / m(o) : 1) * s / t1,
                                x - o
                            ];
                        }, e1;
                    }
                    J.invert = function(t1, e1) {
                        var r, i, a = X * e1, s = e1 < 0 ? -b : b, l = 25;
                        do i = a - w * m(s), s -= r = (m(2 * s) + 2 * s - y * m(i)) / (2 * o(2 * s) + 2 + y * o(i) * w * o(s));
                        while (n(r) > v && --l > 0);
                        return i = a - w * m(s), [
                            t1 * (1 / o(i) + Z / o(s)) / X,
                            i
                        ];
                    }, Q.invert = function(t1, e1) {
                        return [
                            t1 / o(e1),
                            e1
                        ];
                    };
                    var et = Y(1, 4 / y, y);
                    function rt(t1, e1, r, i, s, l) {
                        var c, u = o(l);
                        if (n(t1) > 1 || n(l) > 1) c = E(r * s + e1 * i * u);
                        else {
                            var f = m(t1 / 2), h = m(l / 2);
                            c = 2 * S(L(f * f + e1 * i * h * h));
                        }
                        return n(c) > v ? [
                            c,
                            a(i * m(l), e1 * s - r * i * u)
                        ] : [
                            0,
                            0
                        ];
                    }
                    function nt(t1, e1, r) {
                        return E((t1 * t1 + e1 * e1 - r * r) / (2 * t1 * e1));
                    }
                    function it(t1) {
                        return t1 - 2 * y * l((t1 + y) / (2 * y));
                    }
                    function at(t1, e1, r) {
                        for(var n, i = [
                            [
                                t1[0],
                                t1[1],
                                m(t1[1]),
                                o(t1[1])
                            ],
                            [
                                e1[0],
                                e1[1],
                                m(e1[1]),
                                o(e1[1])
                            ],
                            [
                                r[0],
                                r[1],
                                m(r[1]),
                                o(r[1])
                            ]
                        ], a = i[2], s = 0; s < 3; ++s, a = n)n = i[s], a.v = rt(n[1] - a[1], a[3], a[2], n[3], n[2], n[0] - a[0]), a.point = [
                            0,
                            0
                        ];
                        var l = nt(i[0].v[0], i[2].v[0], i[1].v[0]), c = nt(i[0].v[0], i[1].v[0], i[2].v[0]), u = y - l;
                        i[2].point[1] = 0, i[0].point[0] = -(i[1].point[0] = i[0].v[0] / 2);
                        var f = [
                            i[2].point[0] = i[0].point[0] + i[2].v[0] * o(l),
                            2 * (i[0].point[1] = i[1].point[1] = i[2].v[0] * m(l))
                        ];
                        return function(t1, e1) {
                            var r, n = m(e1), a = o(e1), s = new Array(3);
                            for(r = 0; r < 3; ++r){
                                var l = i[r];
                                if (s[r] = rt(e1 - l[1], l[3], l[2], a, n, t1 - l[0]), !s[r][0]) return l.point;
                                s[r][1] = it(s[r][1] - l.v[1]);
                            }
                            var h = f.slice();
                            for(r = 0; r < 3; ++r){
                                var p = 2 == r ? 0 : r + 1, d = nt(i[r].v[0], s[r][0], s[p][0]);
                                s[r][1] < 0 && (d = -d), r ? 1 == r ? (d = c - d, h[0] -= s[r][0] * o(d), h[1] -= s[r][0] * m(d)) : (d = u - d, h[0] += s[r][0] * o(d), h[1] += s[r][0] * m(d)) : (h[0] += s[r][0] * o(d), h[1] -= s[r][0] * m(d));
                            }
                            return h[0] /= 3, h[1] /= 3, h;
                        };
                    }
                    function ot(t1) {
                        return t1[0] *= M, t1[1] *= M, t1;
                    }
                    function st(t1, r, n) {
                        var i = e1.geoCentroid({
                            type: "MultiPoint",
                            coordinates: [
                                t1,
                                r,
                                n
                            ]
                        }), a = [
                            -i[0],
                            -i[1]
                        ], o = e1.geoRotation(a), s = at(ot(o(t1)), ot(o(r)), ot(o(n)));
                        s.invert = H(s);
                        var l = e1.geoProjection(s).rotate(a), c = l.center;
                        return delete l.rotate, l.center = function(t1) {
                            return arguments.length ? c(o(t1)) : o.invert(c());
                        }, l.clipAngle(90);
                    }
                    function lt(t1, e1) {
                        var r = L(1 - m(e1));
                        return [
                            2 / T * t1 * r,
                            T * (1 - r)
                        ];
                    }
                    function ct(t1) {
                        var e1 = g(t1);
                        function r(t1, r) {
                            return [
                                t1,
                                (t1 ? t1 / m(t1) : 1) * (m(r) * o(t1) - e1 * o(r))
                            ];
                        }
                        return r.invert = e1 ? function(t1, r) {
                            t1 && (r *= m(t1) / t1);
                            var n = o(t1);
                            return [
                                t1,
                                2 * a(L(n * n + e1 * e1 - r * r) - n, e1 - r)
                            ];
                        } : function(t1, e1) {
                            return [
                                t1,
                                S(t1 ? e1 * g(t1) / t1 : e1)
                            ];
                        }, r;
                    }
                    lt.invert = function(t1, e1) {
                        var r = (r = e1 / T - 1) * r;
                        return [
                            r > 0 ? t1 * L(y / r) / 2 : 0,
                            S(1 - r)
                        ];
                    };
                    var ut = L(3);
                    function ft(t1, e1) {
                        return [
                            ut * t1 * (2 * o(2 * e1 / 3) - 1) / T,
                            ut * T * m(e1 / 3)
                        ];
                    }
                    function ht(t1) {
                        var e1 = o(t1);
                        function r(t1, r) {
                            return [
                                t1 * e1,
                                m(r) / e1
                            ];
                        }
                        return r.invert = function(t1, r) {
                            return [
                                t1 / e1,
                                S(r * e1)
                            ];
                        }, r;
                    }
                    function pt(t1) {
                        var e1 = o(t1);
                        function r(t1, r) {
                            return [
                                t1 * e1,
                                (1 + e1) * g(r / 2)
                            ];
                        }
                        return r.invert = function(t1, r) {
                            return [
                                t1 / e1,
                                2 * i(r / (1 + e1))
                            ];
                        }, r;
                    }
                    function dt(t1, e1) {
                        var r = L(8 / (3 * y));
                        return [
                            r * t1 * (1 - n(e1) / y),
                            r * e1
                        ];
                    }
                    function mt(t1, e1) {
                        var r = L(4 - 3 * m(n(e1)));
                        return [
                            2 / L(6 * y) * t1 * r,
                            d(e1) * L(2 * y / 3) * (2 - r)
                        ];
                    }
                    function gt(t1, e1) {
                        var r = L(y * (4 + y));
                        return [
                            2 / r * t1 * (1 + L(1 - 4 * e1 * e1 / (y * y))),
                            4 / r * e1
                        ];
                    }
                    function vt(t1, e1) {
                        var r = (2 + x) * m(e1);
                        e1 /= 2;
                        for(var i = 0, a = 1 / 0; i < 10 && n(a) > v; i++){
                            var s = o(e1);
                            e1 -= a = (e1 + m(e1) * (s + 2) - r) / (2 * s * (1 + s));
                        }
                        return [
                            2 / L(y * (4 + y)) * t1 * (1 + o(e1)),
                            2 * L(y / (4 + y)) * m(e1)
                        ];
                    }
                    function yt(t1, e1) {
                        return [
                            t1 * (1 + o(e1)) / L(2 + y),
                            2 * e1 / L(2 + y)
                        ];
                    }
                    function xt(t1, e1) {
                        for(var r = (1 + x) * m(e1), i = 0, a = 1 / 0; i < 10 && n(a) > v; i++)e1 -= a = (e1 + m(e1) - r) / (1 + o(e1));
                        return r = L(2 + y), [
                            t1 * (1 + o(e1)) / r,
                            2 * e1 / r
                        ];
                    }
                    ft.invert = function(t1, e1) {
                        var r = 3 * S(e1 / (ut * T));
                        return [
                            T * t1 / (ut * (2 * o(2 * r / 3) - 1)),
                            r
                        ];
                    }, dt.invert = function(t1, e1) {
                        var r = L(8 / (3 * y)), i = e1 / r;
                        return [
                            t1 / (r * (1 - n(i) / y)),
                            i
                        ];
                    }, mt.invert = function(t1, e1) {
                        var r = 2 - n(e1) / L(2 * y / 3);
                        return [
                            t1 * L(6 * y) / (2 * r),
                            d(e1) * S((4 - r * r) / 3)
                        ];
                    }, gt.invert = function(t1, e1) {
                        var r = L(y * (4 + y)) / 2;
                        return [
                            t1 * r / (1 + L(1 - e1 * e1 * (4 + y) / (4 * y))),
                            e1 * r / 2
                        ];
                    }, vt.invert = function(t1, e1) {
                        var r = e1 * L((4 + y) / y) / 2, n = S(r), i = o(n);
                        return [
                            t1 / (2 / L(y * (4 + y)) * (1 + i)),
                            S((n + r * (i + 2)) / (2 + x))
                        ];
                    }, yt.invert = function(t1, e1) {
                        var r = L(2 + y), n = e1 * r / 2;
                        return [
                            r * t1 / (1 + o(n)),
                            n
                        ];
                    }, xt.invert = function(t1, e1) {
                        var r = 1 + x, n = L(r / 2);
                        return [
                            2 * t1 * n / (1 + o(e1 *= n)),
                            S((e1 + m(e1)) / r)
                        ];
                    };
                    var bt = 3 + 2 * w;
                    function _t(t1, e1) {
                        var r = m(t1 /= 2), n = o(t1), a = L(o(e1)), s = o(e1 /= 2), l = m(e1) / (s + w * n * a), u = L(2 / (1 + l * l)), f = L((w * s + (n + r) * a) / (w * s + (n - r) * a));
                        return [
                            bt * (u * (f - 1 / f) - 2 * c(f)),
                            bt * (u * l * (f + 1 / f) - 2 * i(l))
                        ];
                    }
                    _t.invert = function(t1, e1) {
                        if (!(r = D.invert(t1 / 1.2, 1.065 * e1))) return null;
                        var r, a = r[0], s = r[1], l = 20;
                        t1 /= bt, e1 /= bt;
                        do {
                            var h = a / 2, p = s / 2, d = m(h), g = o(h), y = m(p), b = o(p), T = o(s), k = L(T), A = y / (b + w * g * k), M = A * A, S = L(2 / (1 + M)), E = (w * b + (g + d) * k) / (w * b + (g - d) * k), C = L(E), P = C - 1 / C, I = C + 1 / C, O = S * P - 2 * c(C) - t1, z = S * A * I - 2 * i(A) - e1, R = y && _ * k * d * M / y, F = (w * g * b + k) / (2 * (b + w * g * k) * (b + w * g * k) * k), B = -0.5 * A * S * S * S, N = B * R, j = B * F, U = (U = 2 * b + w * k * (g - d)) * U * C, V = (w * g * b * k + T) / U, H = -w * d * y / (k * U), q = P * N - 2 * V / C + S * (V + V / E), G = P * j - 2 * H / C + S * (H + H / E), Y = A * I * N - 2 * R / (1 + M) + S * I * R + S * A * (V - V / E), W = A * I * j - 2 * F / (1 + M) + S * I * F + S * A * (H - H / E), X = G * Y - W * q;
                            if (!X) break;
                            var Z = (z * G - O * W) / X, J = (O * Y - z * q) / X;
                            a -= Z, s = u(-x, f(x, s - J));
                        }while ((n(Z) > v || n(J) > v) && --l > 0);
                        return n(n(s) - x) < v ? [
                            0,
                            s
                        ] : l && [
                            a,
                            s
                        ];
                    };
                    var wt = o(35 * M);
                    function Tt(t1, e1) {
                        var r = g(e1 / 2);
                        return [
                            t1 * wt * L(1 - r * r),
                            (1 + wt) * r
                        ];
                    }
                    function kt(t1, e1) {
                        var r = e1 / 2, n = o(r);
                        return [
                            2 * t1 / T * o(e1) * n * n,
                            T * g(r)
                        ];
                    }
                    function At(t1) {
                        var e1 = 1 - t1, r = i(y, 0)[0] - i(-y, 0)[0], n = L(2 * (i(0, x)[1] - i(0, -x)[1]) / r);
                        function i(r, n) {
                            var i = o(n), a = m(n);
                            return [
                                i / (e1 + t1 * i) * r,
                                e1 * n + t1 * a
                            ];
                        }
                        function a(t1, e1) {
                            var r = i(t1, e1);
                            return [
                                r[0] * n,
                                r[1] / n
                            ];
                        }
                        function s(t1) {
                            return a(0, t1)[1];
                        }
                        return a.invert = function(r, i) {
                            var a = V(s, i);
                            return [
                                r / n * (t1 + e1 / o(a)),
                                a
                            ];
                        }, a;
                    }
                    function Mt(t1) {
                        return [
                            t1[0] / 2,
                            S(g(t1[1] / 2 * M)) * A
                        ];
                    }
                    function St(t1) {
                        return [
                            2 * t1[0],
                            2 * i(m(t1[1] * M)) * A
                        ];
                    }
                    function Et(t1, r) {
                        var i = 2 * y / r, s = t1 * t1;
                        function l(r, l) {
                            var c = e1.geoAzimuthalEquidistantRaw(r, l), u = c[0], f = c[1], h = u * u + f * f;
                            if (h > s) {
                                var d = L(h), g = a(f, u), b = i * p(g / i), _ = g - b, w = t1 * o(_), T = (t1 * m(_) - _ * m(w)) / (x - w), k = Lt(_, T), A = (y - t1) / Ct(k, w, y);
                                u = d;
                                var M, S = 50;
                                do u -= M = (t1 + Ct(k, w, u) * A - d) / (k(u) * A);
                                while (n(M) > v && --S > 0);
                                f = _ * m(u), u < x && (f -= T * (u - x));
                                var E = m(b), C = o(b);
                                c[0] = u * C - f * E, c[1] = u * E + f * C;
                            }
                            return c;
                        }
                        return l.invert = function(r, l) {
                            var c = r * r + l * l;
                            if (c > s) {
                                var u = L(c), f = a(l, r), h = i * p(f / i), d = f - h;
                                r = u * o(d), l = u * m(d);
                                for(var g = r - x, v = m(r), b = l / v, _ = r < x ? 1 / 0 : 0, w = 10;;){
                                    var T = t1 * m(b), k = t1 * o(b), A = m(k), M = x - k, S = (T - b * A) / M, E = Lt(b, S);
                                    if (n(_) < 1e-12 || !--w) break;
                                    b -= _ = (b * v - S * g - l) / (v - 2 * g * (M * (k + b * T * o(k) - A) - T * (T - b * A)) / (M * M));
                                }
                                r = (u = t1 + Ct(E, k, r) * (y - t1) / Ct(E, k, y)) * o(f = h + b), l = u * m(f);
                            }
                            return e1.geoAzimuthalEquidistantRaw.invert(r, l);
                        }, l;
                    }
                    function Lt(t1, e1) {
                        return function(r) {
                            var n = t1 * o(r);
                            return r < x && (n -= e1), L(1 + n * n);
                        };
                    }
                    function Ct(t1, e1, r) {
                        for(var n = (r - e1) / 50, i = t1(e1) + t1(r), a = 1, o = e1; a < 50; ++a)i += 2 * t1(o += n);
                        return .5 * i * n;
                    }
                    function Pt(t1, e1, r, i, a, s, l, c) {
                        function u(n, u) {
                            if (!u) return [
                                t1 * n / y,
                                0
                            ];
                            var f = u * u, h = t1 + f * (e1 + f * (r + f * i)), p = u * (a - 1 + f * (s - c + f * l)), d = (h * h + p * p) / (2 * p), g = n * S(h / d) / y;
                            return [
                                d * m(g),
                                u * (1 + f * c) + d * (1 - o(g))
                            ];
                        }
                        return arguments.length < 8 && (c = 0), u.invert = function(u, f) {
                            var h, p, d = y * u / t1, g = f, x = 50;
                            do {
                                var b = g * g, _ = t1 + b * (e1 + b * (r + b * i)), w = g * (a - 1 + b * (s - c + b * l)), T = _ * _ + w * w, k = 2 * w, A = T / k, M = A * A, E = S(_ / A) / y, C = d * E, P = _ * _, I = (2 * e1 + b * (4 * r + 6 * b * i)) * g, O = a + b * (3 * s + 5 * b * l), z = (2 * (_ * I + w * (O - 1)) * k - T * (2 * (O - 1))) / (k * k), D = o(C), R = m(C), F = A * D, B = A * R, N = d / y * (1 / L(1 - P / M)) * (I * A - _ * z) / M, j = B - u, U = g * (1 + b * c) + A - F - f, V = z * R + F * N, H = F * E, q = 1 + z - (z * D - B * N), G = B * E, Y = V * G - q * H;
                                if (!Y) break;
                                d -= h = (U * V - j * q) / Y, g -= p = (j * G - U * H) / Y;
                            }while ((n(h) > v || n(p) > v) && --x > 0);
                            return [
                                d,
                                g
                            ];
                        }, u;
                    }
                    Tt.invert = function(t1, e1) {
                        var r = e1 / (1 + wt);
                        return [
                            t1 && t1 / (wt * L(1 - r * r)),
                            2 * i(r)
                        ];
                    }, kt.invert = function(t1, e1) {
                        var r = i(e1 / T), n = o(r), a = 2 * r;
                        return [
                            t1 * T / 2 / (o(a) * n * n),
                            a
                        ];
                    };
                    var It = Pt(2.8284, -1.6988, .75432, -0.18071, 1.76003, -0.38914, .042555);
                    var Ot = Pt(2.583819, -0.835827, .170354, -0.038094, 1.543313, -0.411435, .082742);
                    var zt = Pt(5 / 6 * y, -0.62636, -0.0344, 0, 1.3493, -0.05524, 0, .045);
                    function Dt(t1, e1) {
                        var r = t1 * t1, n = e1 * e1;
                        return [
                            t1 * (1 - .162388 * n) * (.87 - 952426e-9 * r * r),
                            e1 * (1 + n / 12)
                        ];
                    }
                    Dt.invert = function(t1, e1) {
                        var r, i = t1, a = e1, o = 50;
                        do {
                            var s = a * a;
                            a -= r = (a * (1 + s / 12) - e1) / (1 + s / 4);
                        }while (n(r) > v && --o > 0);
                        o = 50, t1 /= 1 - .162388 * s;
                        do {
                            var l = (l = i * i) * l;
                            i -= r = (i * (.87 - 952426e-9 * l) - t1) / (.87 - .00476213 * l);
                        }while (n(r) > v && --o > 0);
                        return [
                            i,
                            a
                        ];
                    };
                    var Rt = Pt(2.6516, -0.76534, .19123, -0.047094, 1.36289, -0.13965, .031762);
                    function Ft(t1) {
                        var e1 = t1(x, 0)[0] - t1(-x, 0)[0];
                        function r(r, n) {
                            var i = r > 0 ? -0.5 : .5, a = t1(r + i * y, n);
                            return a[0] -= i * e1, a;
                        }
                        return t1.invert && (r.invert = function(r, n) {
                            var i = r > 0 ? -0.5 : .5, a = t1.invert(r + i * e1, n), o = a[0] - i * y;
                            return o < -y ? o += 2 * y : o > y && (o -= 2 * y), a[0] = o, a;
                        }), r;
                    }
                    function Bt(t1, e1) {
                        var r = d(t1), i = d(e1), s = o(e1), l = o(t1) * s, c = m(t1) * s, u = m(i * e1);
                        t1 = n(a(c, u)), e1 = S(l), n(t1 - x) > v && (t1 %= x);
                        var f = function(t1, e1) {
                            if (e1 === x) return [
                                0,
                                0
                            ];
                            var r, i, a = m(e1), s = a * a, l = s * s, c = 1 + l, u = 1 + 3 * l, f = 1 - l, h = S(1 / L(c)), p = f + s * c * h, d = (1 - a) / p, g = L(d), b = d * c, _ = L(b), w = g * f;
                            if (0 === t1) return [
                                0,
                                -(w + s * _)
                            ];
                            var T, k = o(e1), A = 1 / k, M = 2 * a * k, E = (-p * k - (-3 * s + h * u) * M * (1 - a)) / (p * p), C = -A * M, P = -A * (s * c * E + d * u * M), I = -2 * A * (f * (.5 * E / g) - 2 * s * g * M), O = 4 * t1 / y;
                            if (t1 > .222 * y || e1 < y / 4 && t1 > .175 * y) {
                                if (r = (w + s * L(b * (1 + l) - w * w)) / (1 + l), t1 > y / 4) return [
                                    r,
                                    r
                                ];
                                var z = r, D = .5 * r;
                                r = .5 * (D + z), i = 50;
                                do {
                                    var R = L(b - r * r), F = r * (I + C * R) + P * S(r / _) - O;
                                    if (!F) break;
                                    F < 0 ? D = r : z = r, r = .5 * (D + z);
                                }while (n(z - D) > v && --i > 0);
                            } else {
                                r = v, i = 25;
                                do {
                                    var B = r * r, N = L(b - B), j = I + C * N, U = r * j + P * S(r / _) - O, V = j + (P - C * B) / N;
                                    r -= T = N ? U / V : 0;
                                }while (n(T) > v && --i > 0);
                            }
                            return [
                                r,
                                -w - s * L(b - r * r)
                            ];
                        }(t1 > y / 4 ? x - t1 : t1, e1);
                        return t1 > y / 4 && (u = f[0], f[0] = -f[1], f[1] = -u), f[0] *= r, f[1] *= -i, f;
                    }
                    function Nt(t1, e1) {
                        var r, a, l, c, u, f;
                        if (e1 < v) return [
                            (c = m(t1)) - (r = e1 * (t1 - c * (a = o(t1))) / 4) * a,
                            a + r * c,
                            1 - e1 * c * c / 2,
                            t1 - r
                        ];
                        if (e1 >= 1 - v) return r = (1 - e1) / 4, l = 1 / (a = P(t1)), [
                            (c = ((f = s(2 * (f = t1))) - 1) / (f + 1)) + r * ((u = a * C(t1)) - t1) / (a * a),
                            l - r * c * l * (u - t1),
                            l + r * c * l * (u + t1),
                            2 * i(s(t1)) - x + r * (u - t1) / a
                        ];
                        var h = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ], p = [
                            L(e1),
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ], d = 0;
                        for(a = L(1 - e1), u = 1; n(p[d] / h[d]) > v && d < 8;)r = h[d++], p[d] = (r - a) / 2, h[d] = (r + a) / 2, a = L(r * a), u *= 2;
                        l = u * h[d] * t1;
                        do l = (S(c = p[d] * m(a = l) / h[d]) + l) / 2;
                        while (--d);
                        return [
                            m(l),
                            c = o(l),
                            c / o(l - a),
                            l
                        ];
                    }
                    function jt(t1, e1) {
                        if (!e1) return t1;
                        if (1 === e1) return c(g(t1 / 2 + b));
                        for(var r = 1, a = L(1 - e1), o = L(e1), s = 0; n(o) > v; s++){
                            if (t1 % y) {
                                var l = i(a * g(t1) / r);
                                l < 0 && (l += y), t1 += l + ~~(t1 / y) * y;
                            } else t1 += t1;
                            o = (r + a) / 2, a = L(r * a), o = ((r = o) - a) / 2;
                        }
                        return t1 / (h(2, s) * r);
                    }
                    function Ut(t1, e1) {
                        var r = (w - 1) / (w + 1), l = L(1 - r * r), u = jt(x, l * l), f = c(g(y / 4 + n(e1) / 2)), h = s(-1 * f) / L(r), p = function(t1, e1) {
                            var r = t1 * t1, n = e1 + 1, i = 1 - r - e1 * e1;
                            return [
                                .5 * ((t1 >= 0 ? x : -x) - a(i, 2 * t1)),
                                -0.25 * c(i * i + 4 * r) + .5 * c(n * n + r)
                            ];
                        }(h * o(-1 * t1), h * m(-1 * t1)), v = function(t1, e1, r) {
                            var a = n(t1), o = C(n(e1));
                            if (a) {
                                var s = 1 / m(a), l = 1 / (g(a) * g(a)), c = -(l + r * (o * o * s * s) - 1 + r), u = (-c + L(c * c - 4 * ((r - 1) * l))) / 2;
                                return [
                                    jt(i(1 / L(u)), r) * d(t1),
                                    jt(i(L((u / l - 1) / r)), 1 - r) * d(e1)
                                ];
                            }
                            return [
                                0,
                                jt(i(o), 1 - r) * d(e1)
                            ];
                        }(p[0], p[1], l * l);
                        return [
                            -v[1],
                            (e1 >= 0 ? 1 : -1) * (.5 * u - v[0])
                        ];
                    }
                    function Vt(t1) {
                        var e1 = m(t1), r = o(t1), i = Ht(t1);
                        function s(t1, a) {
                            var s = i(t1, a);
                            t1 = s[0], a = s[1];
                            var l = m(a), c = o(a), u = o(t1), f = E(e1 * l + r * c * u), h = m(f), p = n(h) > v ? f / h : 1;
                            return [
                                p * r * m(t1),
                                (n(t1) > x ? p : -p) * (e1 * c - r * l * u)
                            ];
                        }
                        return i.invert = Ht(-t1), s.invert = function(t1, r) {
                            var n = L(t1 * t1 + r * r), s = -m(n), l = o(n), c = n * l, u = -r * s, f = n * e1, h = L(c * c + u * u - f * f), p = a(c * f + u * h, u * f - c * h), d = (n > x ? -1 : 1) * a(t1 * s, n * o(p) * l + r * m(p) * s);
                            return i.invert(d, p);
                        }, s;
                    }
                    function Ht(t1) {
                        var e1 = m(t1), r = o(t1);
                        return function(t1, n) {
                            var i = o(n), s = o(t1) * i, l = m(t1) * i, c = m(n);
                            return [
                                a(l, s * r - c * e1),
                                S(c * r + s * e1)
                            ];
                        };
                    }
                    Bt.invert = function(t1, e1) {
                        n(t1) > 1 && (t1 = 2 * d(t1) - t1), n(e1) > 1 && (e1 = 2 * d(e1) - e1);
                        var r = d(t1), i = d(e1), s = -r * t1, l = -i * e1, c = l / s < 1, u = function(t1, e1) {
                            var r = 0, i = 1, a = .5, s = 50;
                            for(;;){
                                var l = a * a, c = L(a), u = S(1 / L(1 + l)), f = 1 - l + a * (1 + l) * u, h = (1 - c) / f, p = L(h), d = h * (1 + l), m = p * (1 - l), g = L(d - t1 * t1), v = e1 + m + a * g;
                                if (n(i - r) < 1e-12 || 0 == --s || 0 === v) break;
                                v > 0 ? r = a : i = a, a = .5 * (r + i);
                            }
                            if (!s) return null;
                            var x = S(c), b = o(x), _ = 1 / b, w = 2 * c * b, T = (-f * b - (-3 * a + u * (1 + 3 * l)) * w * (1 - c)) / (f * f);
                            return [
                                y / 4 * (t1 * (-2 * _ * (.5 * T / p * (1 - l) - 2 * a * p * w) + -_ * w * g) + -_ * (a * (1 + l) * T + h * (1 + 3 * l) * w) * S(t1 / L(d))),
                                x
                            ];
                        }(c ? l : s, c ? s : l), f = u[0], h = u[1], p = o(h);
                        return c && (f = -x - f), [
                            r * (a(m(f) * p, -m(h)) + y),
                            i * S(o(f) * p)
                        ];
                    }, Ut.invert = function(t1, e1) {
                        var r, n, o, l, u, f, h = (w - 1) / (w + 1), p = L(1 - h * h), d = jt(x, p * p), m = (n = -t1, o = p * p, (r = .5 * d - e1) ? (l = Nt(r, o), n ? (f = (u = Nt(n, 1 - o))[1] * u[1] + o * l[0] * l[0] * u[0] * u[0], [
                            [
                                l[0] * u[2] / f,
                                l[1] * l[2] * u[0] * u[1] / f
                            ],
                            [
                                l[1] * u[1] / f,
                                -l[0] * l[2] * u[0] * u[2] / f
                            ],
                            [
                                l[2] * u[1] * u[2] / f,
                                -o * l[0] * l[1] * u[0] / f
                            ]
                        ]) : [
                            [
                                l[0],
                                0
                            ],
                            [
                                l[1],
                                0
                            ],
                            [
                                l[2],
                                0
                            ]
                        ]) : [
                            [
                                0,
                                (u = Nt(n, 1 - o))[0] / u[1]
                            ],
                            [
                                1 / u[1],
                                0
                            ],
                            [
                                u[2] / u[1],
                                0
                            ]
                        ]), g = function(t1, e1) {
                            var r = e1[0] * e1[0] + e1[1] * e1[1];
                            return [
                                (t1[0] * e1[0] + t1[1] * e1[1]) / r,
                                (t1[1] * e1[0] - t1[0] * e1[1]) / r
                            ];
                        }(m[0], m[1]);
                        return [
                            a(g[1], g[0]) / -1,
                            2 * i(s(-0.5 * c(h * g[0] * g[0] + h * g[1] * g[1]))) - x
                        ];
                    };
                    var qt = S(1 - 1 / 3) * A, Gt = ht(0);
                    function Yt(t1) {
                        var e1 = qt * M, r = lt(y, e1)[0] - lt(-y, e1)[0], i = Gt(0, e1)[1], a = lt(0, e1)[1], o = T - a, s = k / t1, c = 4 / k, h = i + o * o * 4 / k;
                        function p(p, d) {
                            var m, g = n(d);
                            if (g > e1) {
                                var v = f(t1 - 1, u(0, l((p + y) / s)));
                                (m = lt(p += y * (t1 - 1) / t1 - v * s, g))[0] = m[0] * k / r - k * (t1 - 1) / (2 * t1) + v * k / t1, m[1] = i + 4 * (m[1] - a) * o / k, d < 0 && (m[1] = -m[1]);
                            } else m = Gt(p, d);
                            return m[0] *= c, m[1] /= h, m;
                        }
                        return p.invert = function(e1, p) {
                            e1 /= c;
                            var d = n(p *= h);
                            if (d > i) {
                                var m = f(t1 - 1, u(0, l((e1 + y) / s)));
                                e1 = (e1 + y * (t1 - 1) / t1 - m * s) * r / k;
                                var g = lt.invert(e1, .25 * (d - i) * k / o + a);
                                return g[0] -= y * (t1 - 1) / t1 - m * s, p < 0 && (g[1] = -g[1]), g;
                            }
                            return Gt.invert(e1, p);
                        }, p;
                    }
                    function Wt(t1, e1) {
                        return [
                            t1,
                            1 & e1 ? 90 - v : qt
                        ];
                    }
                    function Xt(t1, e1) {
                        return [
                            t1,
                            1 & e1 ? -90 + v : -qt
                        ];
                    }
                    function Zt(t1) {
                        return [
                            t1[0] * (1 - v),
                            t1[1]
                        ];
                    }
                    function Jt(t1) {
                        var e1, r = 1 + t1, i = S(m(1 / r)), s = 2 * L(y / (e1 = y + 4 * i * r)), l = .5 * s * (r + L(t1 * (2 + t1))), c = t1 * t1, u = r * r;
                        function f(f, h) {
                            var p, d, g = 1 - m(h);
                            if (g && g < 2) {
                                var v, b = x - h, _ = 25;
                                do {
                                    var w = m(b), T = o(b), k = i + a(w, r - T), A = 1 + u - 2 * r * T;
                                    b -= v = (b - c * i - r * w + A * k - .5 * g * e1) / (2 * r * w * k);
                                }while (n(v) > 1e-12 && --_ > 0);
                                p = s * L(A), d = f * k / y;
                            } else p = s * (t1 + g), d = f * i / y;
                            return [
                                p * m(d),
                                l - p * o(d)
                            ];
                        }
                        return f.invert = function(t1, n) {
                            var o = t1 * t1 + (n -= l) * n, f = (1 + u - o / (s * s)) / (2 * r), h = E(f), p = m(h), d = i + a(p, r - f);
                            return [
                                S(t1 / L(o)) * y / d,
                                S(1 - 2 * (h - c * i - r * p + (1 + u - 2 * r * f) * d) / e1)
                            ];
                        }, f;
                    }
                    function Kt(t1, e1) {
                        return e1 > -0.7109889596207567 ? ((t1 = W(t1, e1))[1] += .0528035274542, t1) : Q(t1, e1);
                    }
                    function Qt(t1, e1) {
                        return n(e1) > .7109889596207567 ? ((t1 = W(t1, e1))[1] -= e1 > 0 ? .0528035274542 : -0.0528035274542, t1) : Q(t1, e1);
                    }
                    function $t(t1, e1, r, n) {
                        var i = L(4 * y / (2 * r + (1 + t1 - e1 / 2) * m(2 * r) + (t1 + e1) / 2 * m(4 * r) + e1 / 2 * m(6 * r))), a = L(n * m(r) * L((1 + t1 * o(2 * r) + e1 * o(4 * r)) / (1 + t1 + e1))), s = r * c(1);
                        function l(r) {
                            return L(1 + t1 * o(2 * r) + e1 * o(4 * r));
                        }
                        function c(n) {
                            var i = n * r;
                            return (2 * i + (1 + t1 - e1 / 2) * m(2 * i) + (t1 + e1) / 2 * m(4 * i) + e1 / 2 * m(6 * i)) / r;
                        }
                        function u(t1) {
                            return l(t1) * m(t1);
                        }
                        var f = function(t1, e1) {
                            var n = r * V(c, s * m(e1) / r, e1 / y);
                            isNaN(n) && (n = r * d(e1));
                            var u = i * l(n);
                            return [
                                u * a * t1 / y * o(n),
                                u / a * m(n)
                            ];
                        };
                        return f.invert = function(t1, e1) {
                            var n = V(u, e1 * a / i);
                            return [
                                t1 * y / (o(n) * i * a * l(n)),
                                S(r * c(n / r) / s)
                            ];
                        }, 0 === r && (i = L(n / y), (f = function(t1, e1) {
                            return [
                                t1 * i,
                                m(e1) / i
                            ];
                        }).invert = function(t1, e1) {
                            return [
                                t1 / i,
                                S(e1 * i)
                            ];
                        }), f;
                    }
                    function te(t1, e1, r, n, i) {
                        void 0 === n && (n = 1e-8), void 0 === i && (i = 20);
                        var a = t1(e1), o = t1(.5 * (e1 + r)), s = t1(r);
                        return function t1(e1, r, n, i, a, o, s, l, c, u, f) {
                            if (f.nanEncountered) return NaN;
                            var h, p, d, m, g, v, y, x, b, _;
                            if (p = e1(r + .25 * (h = n - r)), d = e1(n - .25 * h), isNaN(p)) f.nanEncountered = !0;
                            else {
                                if (!isNaN(d)) return _ = ((v = (m = h * (i + 4 * p + a) / 12) + (g = h * (a + 4 * d + o) / 12)) - s) / 15, u > c ? (f.maxDepthCount++, v + _) : Math.abs(_) < l ? v + _ : (x = t1(e1, r, y = r + .5 * h, i, p, a, m, .5 * l, c, u + 1, f), isNaN(x) ? (f.nanEncountered = !0, NaN) : (b = t1(e1, y, n, a, d, o, g, .5 * l, c, u + 1, f), isNaN(b) ? (f.nanEncountered = !0, NaN) : x + b));
                                f.nanEncountered = !0;
                            }
                        }(t1, e1, r, a, o, s, (a + 4 * o + s) * (r - e1) / 6, n, i, 1, {
                            maxDepthCount: 0,
                            nanEncountered: !1
                        });
                    }
                    function ee(t1, e1, r) {
                        function i(r) {
                            return t1 + (1 - t1) * h(1 - h(r, e1), 1 / e1);
                        }
                        function a(t1) {
                            return te(i, 0, t1, 1e-4);
                        }
                        for(var o = 1 / a(1), s = 1e3, l = (1 + 1e-8) * o, c = [], u = 0; u <= s; u++)c.push(a(u / s) * l);
                        function f(t1) {
                            var e1 = 0, r = s, n = 500;
                            do c[n] > t1 ? r = n : e1 = n, n = e1 + r >> 1;
                            while (n > e1);
                            var i = c[n + 1] - c[n];
                            return i && (i = (t1 - c[n + 1]) / i), (n + 1 + i) / s;
                        }
                        var p = 2 * f(1) / y * o / r, g = function(t1, e1) {
                            var r = f(n(m(e1))), a = i(r) * t1;
                            return r /= p, [
                                a,
                                e1 >= 0 ? r : -r
                            ];
                        };
                        return g.invert = function(t1, e1) {
                            var r;
                            return n(e1 *= p) < 1 && (r = d(e1) * S(a(n(e1)) * o)), [
                                t1 / i(n(e1)),
                                r
                            ];
                        }, g;
                    }
                    function re(t1, e1) {
                        return n(t1[0] - e1[0]) < v && n(t1[1] - e1[1]) < v;
                    }
                    function ne(t1, e1) {
                        for(var r, n, i, a = -1, o = t1.length, s = t1[0], l = []; ++a < o;){
                            n = ((r = t1[a])[0] - s[0]) / e1, i = (r[1] - s[1]) / e1;
                            for(var c = 0; c < e1; ++c)l.push([
                                s[0] + c * n,
                                s[1] + c * i
                            ]);
                            s = r;
                        }
                        return l.push(r), l;
                    }
                    function ie(t1) {
                        var e1, n, i, a, o, s, l, c = [], u = t1[0].length;
                        for(l = 0; l < u; ++l)n = (e1 = t1[0][l])[0][0], i = e1[0][1], a = e1[1][1], o = e1[2][0], s = e1[2][1], c.push(ne([
                            [
                                n + v,
                                i + v
                            ],
                            [
                                n + v,
                                a - v
                            ],
                            [
                                o - v,
                                a - v
                            ],
                            [
                                o - v,
                                s + v
                            ]
                        ], 30));
                        for(l = t1[1].length - 1; l >= 0; --l)n = (e1 = t1[1][l])[0][0], i = e1[0][1], a = e1[1][1], o = e1[2][0], s = e1[2][1], c.push(ne([
                            [
                                o - v,
                                s - v
                            ],
                            [
                                o - v,
                                a + v
                            ],
                            [
                                n + v,
                                a + v
                            ],
                            [
                                n + v,
                                i - v
                            ]
                        ], 30));
                        return {
                            type: "Polygon",
                            coordinates: [
                                r.merge(c)
                            ]
                        };
                    }
                    function ae(t1, r, n) {
                        var i, a;
                        function o(e1, n) {
                            for(var i = n < 0 ? -1 : 1, a = r[+(n < 0)], o = 0, s = a.length - 1; o < s && e1 > a[o][2][0]; ++o);
                            var l = t1(e1 - a[o][1][0], n);
                            return l[0] += t1(a[o][1][0], i * n > i * a[o][0][1] ? a[o][0][1] : n)[0], l;
                        }
                        n ? o.invert = n(o) : t1.invert && (o.invert = function(e1, n) {
                            for(var i = a[+(n < 0)], s = r[+(n < 0)], l = 0, c = i.length; l < c; ++l){
                                var u = i[l];
                                if (u[0][0] <= e1 && e1 < u[1][0] && u[0][1] <= n && n < u[1][1]) {
                                    var f = t1.invert(e1 - t1(s[l][1][0], 0)[0], n);
                                    return f[0] += s[l][1][0], re(o(f[0], f[1]), [
                                        e1,
                                        n
                                    ]) ? f : null;
                                }
                            }
                        });
                        var s = e1.geoProjection(o), l = s.stream;
                        return s.stream = function(t1) {
                            var r = s.rotate(), n = l(t1), a = (s.rotate([
                                0,
                                0
                            ]), l(t1));
                            return s.rotate(r), n.sphere = function() {
                                e1.geoStream(i, a);
                            }, n;
                        }, s.lobes = function(e1) {
                            return arguments.length ? (i = ie(e1), r = e1.map(function(t1) {
                                return t1.map(function(t1) {
                                    return [
                                        [
                                            t1[0][0] * M,
                                            t1[0][1] * M
                                        ],
                                        [
                                            t1[1][0] * M,
                                            t1[1][1] * M
                                        ],
                                        [
                                            t1[2][0] * M,
                                            t1[2][1] * M
                                        ]
                                    ];
                                });
                            }), a = r.map(function(e1) {
                                return e1.map(function(e1) {
                                    var r, n = t1(e1[0][0], e1[0][1])[0], i = t1(e1[2][0], e1[2][1])[0], a = t1(e1[1][0], e1[0][1])[1], o = t1(e1[1][0], e1[1][1])[1];
                                    return a > o && (r = a, a = o, o = r), [
                                        [
                                            n,
                                            a
                                        ],
                                        [
                                            i,
                                            o
                                        ]
                                    ];
                                });
                            }), s) : r.map(function(t1) {
                                return t1.map(function(t1) {
                                    return [
                                        [
                                            t1[0][0] * A,
                                            t1[0][1] * A
                                        ],
                                        [
                                            t1[1][0] * A,
                                            t1[1][1] * A
                                        ],
                                        [
                                            t1[2][0] * A,
                                            t1[2][1] * A
                                        ]
                                    ];
                                });
                            });
                        }, null != r && s.lobes(r), s;
                    }
                    Kt.invert = function(t1, e1) {
                        return e1 > -0.7109889596207567 ? W.invert(t1, e1 - .0528035274542) : Q.invert(t1, e1);
                    }, Qt.invert = function(t1, e1) {
                        return n(e1) > .7109889596207567 ? W.invert(t1, e1 + (e1 > 0 ? .0528035274542 : -0.0528035274542)) : Q.invert(t1, e1);
                    };
                    var oe = [
                        [
                            [
                                [
                                    -180,
                                    0
                                ],
                                [
                                    -100,
                                    90
                                ],
                                [
                                    -40,
                                    0
                                ]
                            ],
                            [
                                [
                                    -40,
                                    0
                                ],
                                [
                                    30,
                                    90
                                ],
                                [
                                    180,
                                    0
                                ]
                            ]
                        ],
                        [
                            [
                                [
                                    -180,
                                    0
                                ],
                                [
                                    -160,
                                    -90
                                ],
                                [
                                    -100,
                                    0
                                ]
                            ],
                            [
                                [
                                    -100,
                                    0
                                ],
                                [
                                    -60,
                                    -90
                                ],
                                [
                                    -20,
                                    0
                                ]
                            ],
                            [
                                [
                                    -20,
                                    0
                                ],
                                [
                                    20,
                                    -90
                                ],
                                [
                                    80,
                                    0
                                ]
                            ],
                            [
                                [
                                    80,
                                    0
                                ],
                                [
                                    140,
                                    -90
                                ],
                                [
                                    180,
                                    0
                                ]
                            ]
                        ]
                    ];
                    var se = [
                        [
                            [
                                [
                                    -180,
                                    0
                                ],
                                [
                                    -100,
                                    90
                                ],
                                [
                                    -40,
                                    0
                                ]
                            ],
                            [
                                [
                                    -40,
                                    0
                                ],
                                [
                                    30,
                                    90
                                ],
                                [
                                    180,
                                    0
                                ]
                            ]
                        ],
                        [
                            [
                                [
                                    -180,
                                    0
                                ],
                                [
                                    -160,
                                    -90
                                ],
                                [
                                    -100,
                                    0
                                ]
                            ],
                            [
                                [
                                    -100,
                                    0
                                ],
                                [
                                    -60,
                                    -90
                                ],
                                [
                                    -20,
                                    0
                                ]
                            ],
                            [
                                [
                                    -20,
                                    0
                                ],
                                [
                                    20,
                                    -90
                                ],
                                [
                                    80,
                                    0
                                ]
                            ],
                            [
                                [
                                    80,
                                    0
                                ],
                                [
                                    140,
                                    -90
                                ],
                                [
                                    180,
                                    0
                                ]
                            ]
                        ]
                    ];
                    var le = [
                        [
                            [
                                [
                                    -180,
                                    0
                                ],
                                [
                                    -100,
                                    90
                                ],
                                [
                                    -40,
                                    0
                                ]
                            ],
                            [
                                [
                                    -40,
                                    0
                                ],
                                [
                                    30,
                                    90
                                ],
                                [
                                    180,
                                    0
                                ]
                            ]
                        ],
                        [
                            [
                                [
                                    -180,
                                    0
                                ],
                                [
                                    -160,
                                    -90
                                ],
                                [
                                    -100,
                                    0
                                ]
                            ],
                            [
                                [
                                    -100,
                                    0
                                ],
                                [
                                    -60,
                                    -90
                                ],
                                [
                                    -20,
                                    0
                                ]
                            ],
                            [
                                [
                                    -20,
                                    0
                                ],
                                [
                                    20,
                                    -90
                                ],
                                [
                                    80,
                                    0
                                ]
                            ],
                            [
                                [
                                    80,
                                    0
                                ],
                                [
                                    140,
                                    -90
                                ],
                                [
                                    180,
                                    0
                                ]
                            ]
                        ]
                    ];
                    var ce = [
                        [
                            [
                                [
                                    -180,
                                    0
                                ],
                                [
                                    -90,
                                    90
                                ],
                                [
                                    0,
                                    0
                                ]
                            ],
                            [
                                [
                                    0,
                                    0
                                ],
                                [
                                    90,
                                    90
                                ],
                                [
                                    180,
                                    0
                                ]
                            ]
                        ],
                        [
                            [
                                [
                                    -180,
                                    0
                                ],
                                [
                                    -90,
                                    -90
                                ],
                                [
                                    0,
                                    0
                                ]
                            ],
                            [
                                [
                                    0,
                                    0
                                ],
                                [
                                    90,
                                    -90
                                ],
                                [
                                    180,
                                    0
                                ]
                            ]
                        ]
                    ];
                    var ue = [
                        [
                            [
                                [
                                    -180,
                                    35
                                ],
                                [
                                    -30,
                                    90
                                ],
                                [
                                    0,
                                    35
                                ]
                            ],
                            [
                                [
                                    0,
                                    35
                                ],
                                [
                                    30,
                                    90
                                ],
                                [
                                    180,
                                    35
                                ]
                            ]
                        ],
                        [
                            [
                                [
                                    -180,
                                    -10
                                ],
                                [
                                    -102,
                                    -90
                                ],
                                [
                                    -65,
                                    -10
                                ]
                            ],
                            [
                                [
                                    -65,
                                    -10
                                ],
                                [
                                    5,
                                    -90
                                ],
                                [
                                    77,
                                    -10
                                ]
                            ],
                            [
                                [
                                    77,
                                    -10
                                ],
                                [
                                    103,
                                    -90
                                ],
                                [
                                    180,
                                    -10
                                ]
                            ]
                        ]
                    ];
                    var fe = [
                        [
                            [
                                [
                                    -180,
                                    0
                                ],
                                [
                                    -110,
                                    90
                                ],
                                [
                                    -40,
                                    0
                                ]
                            ],
                            [
                                [
                                    -40,
                                    0
                                ],
                                [
                                    0,
                                    90
                                ],
                                [
                                    40,
                                    0
                                ]
                            ],
                            [
                                [
                                    40,
                                    0
                                ],
                                [
                                    110,
                                    90
                                ],
                                [
                                    180,
                                    0
                                ]
                            ]
                        ],
                        [
                            [
                                [
                                    -180,
                                    0
                                ],
                                [
                                    -110,
                                    -90
                                ],
                                [
                                    -40,
                                    0
                                ]
                            ],
                            [
                                [
                                    -40,
                                    0
                                ],
                                [
                                    0,
                                    -90
                                ],
                                [
                                    40,
                                    0
                                ]
                            ],
                            [
                                [
                                    40,
                                    0
                                ],
                                [
                                    110,
                                    -90
                                ],
                                [
                                    180,
                                    0
                                ]
                            ]
                        ]
                    ];
                    function he(t1, e1) {
                        return [
                            3 / k * t1 * L(y * y / 3 - e1 * e1),
                            e1
                        ];
                    }
                    function pe(t1) {
                        function e1(e1, r) {
                            if (n(n(r) - x) < v) return [
                                0,
                                r < 0 ? -2 : 2
                            ];
                            var i = m(r), a = h((1 + i) / (1 - i), t1 / 2), s = .5 * (a + 1 / a) + o(e1 *= t1);
                            return [
                                2 * m(e1) / s,
                                (a - 1 / a) / s
                            ];
                        }
                        return e1.invert = function(e1, r) {
                            var i = n(r);
                            if (n(i - 2) < v) return e1 ? null : [
                                0,
                                d(r) * x
                            ];
                            if (i > 2) return null;
                            var o = (e1 /= 2) * e1, s = (r /= 2) * r, l = 2 * r / (1 + o + s);
                            return l = h((1 + l) / (1 - l), 1 / t1), [
                                a(2 * e1, 1 - o - s) / t1,
                                S((l - 1) / (l + 1))
                            ];
                        }, e1;
                    }
                    he.invert = function(t1, e1) {
                        return [
                            k / 3 * t1 / L(y * y / 3 - e1 * e1),
                            e1
                        ];
                    };
                    var de = y / w;
                    function me(t1, e1) {
                        return [
                            t1 * (1 + L(o(e1))) / 2,
                            e1 / (o(e1 / 2) * o(t1 / 6))
                        ];
                    }
                    function ge(t1, e1) {
                        var r = t1 * t1, n = e1 * e1;
                        return [
                            t1 * (.975534 + n * (-0.0143059 * r - .119161 + -0.0547009 * n)),
                            e1 * (1.00384 + r * (.0802894 + -0.02855 * n + 199025e-9 * r) + n * (.0998909 + -0.0491032 * n))
                        ];
                    }
                    function ve(t1, e1) {
                        return [
                            m(t1) / o(e1),
                            g(e1) * o(t1)
                        ];
                    }
                    function ye(t1) {
                        var e1 = o(t1), r = g(b + t1 / 2);
                        function i(i, a) {
                            var o = a - t1, s = n(o) < v ? i * e1 : n(s = b + a / 2) < v || n(n(s) - x) < v ? 0 : i * o / c(g(s) / r);
                            return [
                                s,
                                o
                            ];
                        }
                        return i.invert = function(i, a) {
                            var o, s = a + t1;
                            return [
                                n(a) < v ? i / e1 : n(o = b + s / 2) < v || n(n(o) - x) < v ? 0 : i * c(g(o) / r) / a,
                                s
                            ];
                        }, i;
                    }
                    function xe(t1, e1) {
                        return [
                            t1,
                            1.25 * c(g(b + .4 * e1))
                        ];
                    }
                    function be(t1) {
                        var e1 = t1.length - 1;
                        function r(r, n) {
                            for(var i, a = o(n), s = 2 / (1 + a * o(r)), l = s * a * m(r), c = s * m(n), u = e1, f = t1[u], h = f[0], p = f[1]; --u >= 0;)h = (f = t1[u])[0] + l * (i = h) - c * p, p = f[1] + l * p + c * i;
                            return [
                                h = l * (i = h) - c * p,
                                p = l * p + c * i
                            ];
                        }
                        return r.invert = function(r, s) {
                            var l = 20, c = r, u = s;
                            do {
                                for(var f, h = e1, p = t1[h], d = p[0], g = p[1], v = 0, y = 0; --h >= 0;)v = d + c * (f = v) - u * y, y = g + c * y + u * f, d = (p = t1[h])[0] + c * (f = d) - u * g, g = p[1] + c * g + u * f;
                                var x, b, _ = (v = d + c * (f = v) - u * y) * v + (y = g + c * y + u * f) * y;
                                c -= x = ((d = c * (f = d) - u * g - r) * v + (g = c * g + u * f - s) * y) / _, u -= b = (g * v - d * y) / _;
                            }while (n(x) + n(b) > 1e-12 && --l > 0);
                            if (l) {
                                var w = L(c * c + u * u), T = 2 * i(.5 * w), k = m(T);
                                return [
                                    a(c * k, w * o(T)),
                                    w ? S(u * k / w) : 0
                                ];
                            }
                        }, r;
                    }
                    me.invert = function(t1, e1) {
                        var r = n(t1), i = n(e1), a = v, s = x;
                        i < de ? s *= i / de : a += 6 * E(de / i);
                        for(var l = 0; l < 25; l++){
                            var c = m(s), u = L(o(s)), f = m(s / 2), h = o(s / 2), p = m(a / 6), d = o(a / 6), g = .5 * a * (1 + u) - r, y = s / (h * d) - i, b = u ? -0.25 * a * c / u : 0, _ = .5 * (1 + u), w = (1 + .5 * s * f / h) / (h * d), T = s / h * (p / 6) / (d * d), k = b * T - w * _, A = (g * T - y * _) / k, M = (y * b - g * w) / k;
                            if (s -= A, a -= M, n(A) < v && n(M) < v) break;
                        }
                        return [
                            t1 < 0 ? -a : a,
                            e1 < 0 ? -s : s
                        ];
                    }, ge.invert = function(t1, e1) {
                        var r = d(t1) * y, i = e1 / 2, a = 50;
                        do {
                            var o = r * r, s = i * i, l = r * i, c = r * (.975534 + s * (-0.0143059 * o - .119161 + -0.0547009 * s)) - t1, u = i * (1.00384 + o * (.0802894 + -0.02855 * s + 199025e-9 * o) + s * (.0998909 + -0.0491032 * s)) - e1, f = .975534 - s * (.119161 + 3 * o * .0143059 + .0547009 * s), h = -l * (.238322 + .2188036 * s + .0286118 * o), p = l * (.1605788 + 7961e-7 * o + -0.0571 * s), m = 1.00384 + o * (.0802894 + 199025e-9 * o) + s * (3 * (.0998909 - .02855 * o) - .245516 * s), g = h * p - m * f, x = (u * h - c * m) / g, b = (c * p - u * f) / g;
                            r -= x, i -= b;
                        }while ((n(x) > v || n(b) > v) && --a > 0);
                        return a && [
                            r,
                            i
                        ];
                    }, ve.invert = function(t1, e1) {
                        var r = t1 * t1, n = e1 * e1 + 1, i = r + n, a = t1 ? _ * L((i - L(i * i - 4 * r)) / r) : 1 / L(n);
                        return [
                            S(t1 * a),
                            d(e1) * E(a)
                        ];
                    }, xe.invert = function(t1, e1) {
                        return [
                            t1,
                            2.5 * i(s(.8 * e1)) - .625 * y
                        ];
                    };
                    var _e = [
                        [
                            .9972523,
                            0
                        ],
                        [
                            .0052513,
                            -0.0041175
                        ],
                        [
                            .0074606,
                            .0048125
                        ],
                        [
                            -0.0153783,
                            -0.1968253
                        ],
                        [
                            .0636871,
                            -0.1408027
                        ],
                        [
                            .3660976,
                            -0.2937382
                        ]
                    ], we = [
                        [
                            .98879,
                            0
                        ],
                        [
                            0,
                            0
                        ],
                        [
                            -0.050909,
                            0
                        ],
                        [
                            0,
                            0
                        ],
                        [
                            .075528,
                            0
                        ]
                    ], Te = [
                        [
                            .984299,
                            0
                        ],
                        [
                            .0211642,
                            .0037608
                        ],
                        [
                            -0.1036018,
                            -0.0575102
                        ],
                        [
                            -0.0329095,
                            -0.0320119
                        ],
                        [
                            .0499471,
                            .1223335
                        ],
                        [
                            .026046,
                            .0899805
                        ],
                        [
                            7388e-7,
                            -0.1435792
                        ],
                        [
                            .0075848,
                            -0.1334108
                        ],
                        [
                            -0.0216473,
                            .0776645
                        ],
                        [
                            -0.0225161,
                            .0853673
                        ]
                    ], ke = [
                        [
                            .9245,
                            0
                        ],
                        [
                            0,
                            0
                        ],
                        [
                            .01943,
                            0
                        ]
                    ], Ae = [
                        [
                            .721316,
                            0
                        ],
                        [
                            0,
                            0
                        ],
                        [
                            -0.00881625,
                            -0.00617325
                        ]
                    ];
                    function Me(t1, r) {
                        var n = e1.geoProjection(be(t1)).rotate(r).clipAngle(90), i = e1.geoRotation(r), a = n.center;
                        return delete n.rotate, n.center = function(t1) {
                            return arguments.length ? a(i(t1)) : i.invert(a());
                        }, n;
                    }
                    var Se = L(6), Ee = L(7);
                    function Le(t1, e1) {
                        var r = S(7 * m(e1) / (3 * Se));
                        return [
                            Se * t1 * (2 * o(2 * r / 3) - 1) / Ee,
                            9 * m(r / 3) / Ee
                        ];
                    }
                    function Ce(t1, e1) {
                        for(var r, i = (1 + _) * m(e1), a = e1, s = 0; s < 25 && (a -= r = (m(a / 2) + m(a) - i) / (.5 * o(a / 2) + o(a)), !(n(r) < v)); s++);
                        return [
                            t1 * (1 + 2 * o(a) / o(a / 2)) / (3 * w),
                            2 * L(3) * m(a / 2) / L(2 + w)
                        ];
                    }
                    function Pe(t1, e1) {
                        for(var r, i = L(6 / (4 + y)), a = (1 + y / 4) * m(e1), s = e1 / 2, l = 0; l < 25 && (s -= r = (s / 2 + m(s) - a) / (.5 + o(s)), !(n(r) < v)); l++);
                        return [
                            i * (.5 + o(s)) * t1 / 1.5,
                            i * s
                        ];
                    }
                    function Ie(t1, e1) {
                        var r = e1 * e1, n = r * r, i = r * n;
                        return [
                            t1 * (.84719 - .13063 * r + i * i * (.05494 * r - .04515 - .02326 * n + .00331 * i)),
                            e1 * (1.01183 + n * n * (.01926 * r - .02625 - .00396 * n))
                        ];
                    }
                    function Oe(t1, e1) {
                        return [
                            t1 * (1 + o(e1)) / 2,
                            2 * (e1 - g(e1 / 2))
                        ];
                    }
                    Le.invert = function(t1, e1) {
                        var r = 3 * S(e1 * Ee / 9);
                        return [
                            t1 * Ee / (Se * (2 * o(2 * r / 3) - 1)),
                            S(3 * m(r) * Se / 7)
                        ];
                    }, Ce.invert = function(t1, e1) {
                        var r = e1 * L(2 + w) / (2 * L(3)), n = 2 * S(r);
                        return [
                            3 * w * t1 / (1 + 2 * o(n) / o(n / 2)),
                            S((r + m(n)) / (1 + _))
                        ];
                    }, Pe.invert = function(t1, e1) {
                        var r = L(6 / (4 + y)), i = e1 / r;
                        return n(n(i) - x) < v && (i = i < 0 ? -x : x), [
                            1.5 * t1 / (r * (.5 + o(i))),
                            S((i / 2 + m(i)) / (1 + y / 4))
                        ];
                    }, Ie.invert = function(t1, e1) {
                        var r, i, a, o, s = e1, l = 25;
                        do s -= r = (s * (1.01183 + (a = (i = s * s) * i) * a * (.01926 * i - .02625 - .00396 * a)) - e1) / (1.01183 + a * a * (.21186 * i - .23625 + -0.05148 * a));
                        while (n(r) > 1e-12 && --l > 0);
                        return [
                            t1 / (.84719 - .13063 * (i = s * s) + (o = i * (a = i * i)) * o * (.05494 * i - .04515 - .02326 * a + .00331 * o)),
                            s
                        ];
                    }, Oe.invert = function(t1, e1) {
                        for(var r = e1 / 2, i = 0, a = 1 / 0; i < 10 && n(a) > v; ++i){
                            var s = o(e1 / 2);
                            e1 -= a = (e1 - g(e1 / 2) - r) / (1 - .5 / (s * s));
                        }
                        return [
                            2 * t1 / (1 + o(e1)),
                            e1
                        ];
                    };
                    var ze = [
                        [
                            [
                                [
                                    -180,
                                    0
                                ],
                                [
                                    -90,
                                    90
                                ],
                                [
                                    0,
                                    0
                                ]
                            ],
                            [
                                [
                                    0,
                                    0
                                ],
                                [
                                    90,
                                    90
                                ],
                                [
                                    180,
                                    0
                                ]
                            ]
                        ],
                        [
                            [
                                [
                                    -180,
                                    0
                                ],
                                [
                                    -90,
                                    -90
                                ],
                                [
                                    0,
                                    0
                                ]
                            ],
                            [
                                [
                                    0,
                                    0
                                ],
                                [
                                    90,
                                    -90
                                ],
                                [
                                    180,
                                    0
                                ]
                            ]
                        ]
                    ];
                    function De(t1, e1) {
                        var r = m(e1), i = o(e1), a = d(t1);
                        if (0 === t1 || n(e1) === x) return [
                            0,
                            e1
                        ];
                        if (0 === e1) return [
                            t1,
                            0
                        ];
                        if (n(t1) === x) return [
                            t1 * i,
                            x * r
                        ];
                        var s = y / (2 * t1) - 2 * t1 / y, l = 2 * e1 / y, c = (1 - l * l) / (r - l), u = s * s, f = c * c, h = 1 + u / f, p = 1 + f / u, g = (s * r / c - s / 2) / h, v = (f * r / u + c / 2) / p, b = v * v - (f * r * r / u + c * r - 1) / p;
                        return [
                            x * (g + L(g * g + i * i / h) * a),
                            x * (v + L(b < 0 ? 0 : b) * d(-e1 * s) * a)
                        ];
                    }
                    De.invert = function(t1, e1) {
                        var r = (t1 /= x) * t1, n = r + (e1 /= x) * e1, i = y * y;
                        return [
                            t1 ? (n - 1 + L((1 - n) * (1 - n) + 4 * r)) / (2 * t1) * x : 0,
                            V(function(t1) {
                                return n * (y * m(t1) - 2 * t1) * y + 4 * t1 * t1 * (e1 - m(t1)) + 2 * y * t1 - i * e1;
                            }, 0)
                        ];
                    };
                    function Re(t1, e1) {
                        var r = e1 * e1;
                        return [
                            t1,
                            e1 * (1.0148 + r * r * (.23185 + r * (.02406 * r - .14499)))
                        ];
                    }
                    function Fe(t1, e1) {
                        if (n(e1) < v) return [
                            t1,
                            0
                        ];
                        var r = g(e1), i = t1 * m(e1);
                        return [
                            m(i) / r,
                            e1 + (1 - o(i)) / r
                        ];
                    }
                    function Be(t1, e1) {
                        var r = je(t1[1], t1[0]), n = je(e1[1], e1[0]), i = function(t1, e1) {
                            return a(t1[0] * e1[1] - t1[1] * e1[0], t1[0] * e1[0] + t1[1] * e1[1]);
                        }(r, n), s = Ue(r) / Ue(n);
                        return Ne([
                            1,
                            0,
                            t1[0][0],
                            0,
                            1,
                            t1[0][1]
                        ], Ne([
                            s,
                            0,
                            0,
                            0,
                            s,
                            0
                        ], Ne([
                            o(i),
                            m(i),
                            0,
                            -m(i),
                            o(i),
                            0
                        ], [
                            1,
                            0,
                            -e1[0][0],
                            0,
                            1,
                            -e1[0][1]
                        ])));
                    }
                    function Ne(t1, e1) {
                        return [
                            t1[0] * e1[0] + t1[1] * e1[3],
                            t1[0] * e1[1] + t1[1] * e1[4],
                            t1[0] * e1[2] + t1[1] * e1[5] + t1[2],
                            t1[3] * e1[0] + t1[4] * e1[3],
                            t1[3] * e1[1] + t1[4] * e1[4],
                            t1[3] * e1[2] + t1[4] * e1[5] + t1[5]
                        ];
                    }
                    function je(t1, e1) {
                        return [
                            t1[0] - e1[0],
                            t1[1] - e1[1]
                        ];
                    }
                    function Ue(t1) {
                        return L(t1[0] * t1[0] + t1[1] * t1[1]);
                    }
                    function Ve(t1, r, i) {
                        function a(t1, e1) {
                            var n, i = r(t1, e1), a = i.project([
                                t1 * A,
                                e1 * A
                            ]);
                            return (n = i.transform) ? [
                                n[0] * a[0] + n[1] * a[1] + n[2],
                                -(n[3] * a[0] + n[4] * a[1] + n[5])
                            ] : (a[1] = -a[1], a);
                        }
                        !function t1(e1, r) {
                            if (e1.edges = function(t1) {
                                for(var e1 = t1.length, r = [], n = t1[e1 - 1], i = 0; i < e1; ++i)r.push([
                                    n,
                                    n = t1[i]
                                ]);
                                return r;
                            }(e1.face), r.face) {
                                var n = e1.shared = function(t1, e1) {
                                    for(var r, n, i = t1.length, a = null, o = 0; o < i; ++o){
                                        r = t1[o];
                                        for(var s = e1.length; --s >= 0;)if (n = e1[s], r[0] === n[0] && r[1] === n[1]) {
                                            if (a) return [
                                                a,
                                                r
                                            ];
                                            a = r;
                                        }
                                    }
                                }(e1.face, r.face), i = Be(n.map(r.project), n.map(e1.project));
                                e1.transform = r.transform ? Ne(r.transform, i) : i;
                                for(var a = r.edges, o = 0, s = a.length; o < s; ++o)He(n[0], a[o][1]) && He(n[1], a[o][0]) && (a[o] = e1), He(n[0], a[o][0]) && He(n[1], a[o][1]) && (a[o] = e1);
                                for(a = e1.edges, o = 0, s = a.length; o < s; ++o)He(n[0], a[o][0]) && He(n[1], a[o][1]) && (a[o] = r), He(n[0], a[o][1]) && He(n[1], a[o][0]) && (a[o] = r);
                            } else e1.transform = r.transform;
                            e1.children && e1.children.forEach(function(r) {
                                t1(r, e1);
                            });
                            return e1;
                        }(t1, {
                            transform: null
                        }), qe(t1) && (a.invert = function(e1, n) {
                            var i = function t1(e1, n) {
                                var i = e1.project.invert, a = e1.transform, o = n;
                                a && (a = function(t1) {
                                    var e1 = 1 / (t1[0] * t1[4] - t1[1] * t1[3]);
                                    return [
                                        e1 * t1[4],
                                        -e1 * t1[1],
                                        e1 * (t1[1] * t1[5] - t1[2] * t1[4]),
                                        -e1 * t1[3],
                                        e1 * t1[0],
                                        e1 * (t1[2] * t1[3] - t1[0] * t1[5])
                                    ];
                                }(a), o = [
                                    a[0] * o[0] + a[1] * o[1] + a[2],
                                    a[3] * o[0] + a[4] * o[1] + a[5]
                                ]);
                                if (i && e1 === function(t1) {
                                    return r(t1[0] * M, t1[1] * M);
                                }(s = i(o))) return s;
                                for(var s, l = e1.children, c = 0, u = l && l.length; c < u; ++c)if (s = t1(l[c], n)) return s;
                            }(t1, [
                                e1,
                                -n
                            ]);
                            return i && (i[0] *= M, i[1] *= M, i);
                        });
                        var o = e1.geoProjection(a), s = o.stream;
                        return o.stream = function(r) {
                            var i = o.rotate(), a = s(r), l = (o.rotate([
                                0,
                                0
                            ]), s(r));
                            return o.rotate(i), a.sphere = function() {
                                l.polygonStart(), l.lineStart(), function t1(r, i, a) {
                                    var o, s, l = i.edges, c = l.length, u = {
                                        type: "MultiPoint",
                                        coordinates: i.face
                                    }, f = i.face.filter(function(t1) {
                                        return 90 !== n(t1[1]);
                                    }), h = e1.geoBounds({
                                        type: "MultiPoint",
                                        coordinates: f
                                    }), p = !1, d = -1, m = h[1][0] - h[0][0], g = 180 === m || 360 === m ? [
                                        (h[0][0] + h[1][0]) / 2,
                                        (h[0][1] + h[1][1]) / 2
                                    ] : e1.geoCentroid(u);
                                    if (a) for(; ++d < c && l[d] !== a;);
                                    ++d;
                                    for(var y = 0; y < c; ++y)s = l[(y + d) % c], Array.isArray(s) ? (p || (r.point((o = e1.geoInterpolate(s[0], g)(v))[0], o[1]), p = !0), r.point((o = e1.geoInterpolate(s[1], g)(v))[0], o[1])) : (p = !1, s !== a && t1(r, s, i));
                                }(l, t1), l.lineEnd(), l.polygonEnd();
                            }, a;
                        }, o.angle(null == i ? -30 : i * A);
                    }
                    function He(t1, e1) {
                        return t1 && e1 && t1[0] === e1[0] && t1[1] === e1[1];
                    }
                    function qe(t1) {
                        return t1.project.invert || t1.children && t1.children.some(qe);
                    }
                    Re.invert = function(t1, e1) {
                        e1 > 1.790857183 ? e1 = 1.790857183 : e1 < -1.790857183 && (e1 = -1.790857183);
                        var r, i = e1;
                        do {
                            var a = i * i;
                            i -= r = (i * (1.0148 + a * a * (.23185 + a * (.02406 * a - .14499))) - e1) / (1.0148 + a * a * (5 * .23185 + a * (.21654 * a - 1.01493)));
                        }while (n(r) > v);
                        return [
                            t1,
                            i
                        ];
                    }, Fe.invert = function(t1, e1) {
                        if (n(e1) < v) return [
                            t1,
                            0
                        ];
                        var r, i = t1 * t1 + e1 * e1, a = .5 * e1, s = 10;
                        do {
                            var l = g(a), c = 1 / o(a), u = i - 2 * e1 * a + a * a;
                            a -= r = (l * u + 2 * (a - e1)) / (2 + u * c * c + 2 * (a - e1) * l);
                        }while (n(r) > v && --s > 0);
                        return l = g(a), [
                            (n(e1) < n(a + 1 / l) ? S(t1 * l) : d(e1) * d(t1) * (E(n(t1 * l)) + x)) / m(a),
                            a
                        ];
                    };
                    var Ge = [
                        [
                            0,
                            90
                        ],
                        [
                            -90,
                            0
                        ],
                        [
                            0,
                            0
                        ],
                        [
                            90,
                            0
                        ],
                        [
                            180,
                            0
                        ],
                        [
                            0,
                            -90
                        ]
                    ], Ye = [
                        [
                            0,
                            2,
                            1
                        ],
                        [
                            0,
                            3,
                            2
                        ],
                        [
                            5,
                            1,
                            2
                        ],
                        [
                            5,
                            2,
                            3
                        ],
                        [
                            0,
                            1,
                            4
                        ],
                        [
                            0,
                            4,
                            3
                        ],
                        [
                            5,
                            4,
                            1
                        ],
                        [
                            5,
                            3,
                            4
                        ]
                    ].map(function(t1) {
                        return t1.map(function(t1) {
                            return Ge[t1];
                        });
                    });
                    var We = 2 / L(3);
                    function Xe(t1, e1) {
                        var r = lt(t1, e1);
                        return [
                            r[0] * We,
                            r[1]
                        ];
                    }
                    function Ze(t1, e1) {
                        for(var r = 0, n = t1.length, i = 0; r < n; ++r)i += t1[r] * e1[r];
                        return i;
                    }
                    function Je(t1) {
                        return [
                            a(t1[1], t1[0]) * A,
                            S(u(-1, f(1, t1[2]))) * A
                        ];
                    }
                    function Ke(t1) {
                        var e1 = t1[0] * M, r = t1[1] * M, n = o(r);
                        return [
                            n * o(e1),
                            n * m(e1),
                            m(r)
                        ];
                    }
                    function Qe() {}
                    function $e(t1, e1) {
                        return {
                            type: "FeatureCollection",
                            features: t1.features.map(function(t1) {
                                return tr(t1, e1);
                            })
                        };
                    }
                    function tr(t1, e1) {
                        return {
                            type: "Feature",
                            id: t1.id,
                            properties: t1.properties,
                            geometry: er(t1.geometry, e1)
                        };
                    }
                    function er(t1, r) {
                        if (!t1) return null;
                        if ("GeometryCollection" === t1.type) return function(t1, e1) {
                            return {
                                type: "GeometryCollection",
                                geometries: t1.geometries.map(function(t1) {
                                    return er(t1, e1);
                                })
                            };
                        }(t1, r);
                        var n;
                        switch(t1.type){
                            case "Point":
                            case "MultiPoint":
                                n = ir;
                                break;
                            case "LineString":
                            case "MultiLineString":
                                n = ar;
                                break;
                            case "Polygon":
                            case "MultiPolygon":
                            case "Sphere":
                                n = or;
                                break;
                            default:
                                return null;
                        }
                        return e1.geoStream(t1, r(n)), n.result();
                    }
                    Xe.invert = function(t1, e1) {
                        return lt.invert(t1 / We, e1);
                    };
                    var rr = [], nr = [], ir = {
                        point: function(t1, e1) {
                            rr.push([
                                t1,
                                e1
                            ]);
                        },
                        result: function() {
                            var t1 = rr.length ? rr.length < 2 ? {
                                type: "Point",
                                coordinates: rr[0]
                            } : {
                                type: "MultiPoint",
                                coordinates: rr
                            } : null;
                            return rr = [], t1;
                        }
                    }, ar = {
                        lineStart: Qe,
                        point: function(t1, e1) {
                            rr.push([
                                t1,
                                e1
                            ]);
                        },
                        lineEnd: function() {
                            rr.length && (nr.push(rr), rr = []);
                        },
                        result: function() {
                            var t1 = nr.length ? nr.length < 2 ? {
                                type: "LineString",
                                coordinates: nr[0]
                            } : {
                                type: "MultiLineString",
                                coordinates: nr
                            } : null;
                            return nr = [], t1;
                        }
                    }, or = {
                        polygonStart: Qe,
                        lineStart: Qe,
                        point: function(t1, e1) {
                            rr.push([
                                t1,
                                e1
                            ]);
                        },
                        lineEnd: function() {
                            var t1 = rr.length;
                            if (t1) {
                                do rr.push(rr[0].slice());
                                while (++t1 < 4);
                                nr.push(rr), rr = [];
                            }
                        },
                        polygonEnd: Qe,
                        result: function() {
                            if (!nr.length) return null;
                            var t1 = [], e1 = [];
                            return nr.forEach(function(r) {
                                !function(t1) {
                                    if ((e1 = t1.length) < 4) return !1;
                                    for(var e1, r = 0, n = t1[e1 - 1][1] * t1[0][0] - t1[e1 - 1][0] * t1[0][1]; ++r < e1;)n += t1[r - 1][1] * t1[r][0] - t1[r - 1][0] * t1[r][1];
                                    return n <= 0;
                                }(r) ? e1.push(r) : t1.push([
                                    r
                                ]);
                            }), e1.forEach(function(e1) {
                                var r = e1[0];
                                t1.some(function(t1) {
                                    if (function(t1, e1) {
                                        for(var r = e1[0], n = e1[1], i = !1, a = 0, o = t1.length, s = o - 1; a < o; s = a++){
                                            var l = t1[a], c = l[0], u = l[1], f = t1[s], h = f[0], p = f[1];
                                            u > n ^ p > n && r < (h - c) * (n - u) / (p - u) + c && (i = !i);
                                        }
                                        return i;
                                    }(t1[0], r)) return t1.push(e1), !0;
                                }) || t1.push([
                                    e1
                                ]);
                            }), nr = [], t1.length ? t1.length > 1 ? {
                                type: "MultiPolygon",
                                coordinates: t1
                            } : {
                                type: "Polygon",
                                coordinates: t1[0]
                            } : null;
                        }
                    };
                    function sr(t1) {
                        var r = t1(x, 0)[0] - t1(-x, 0)[0];
                        function i(e1, i) {
                            var a = n(e1) < x, o = t1(a ? e1 : e1 > 0 ? e1 - y : e1 + y, i), s = (o[0] - o[1]) * _, l = (o[0] + o[1]) * _;
                            if (a) return [
                                s,
                                l
                            ];
                            var c = r * _, u = s > 0 ^ l > 0 ? -1 : 1;
                            return [
                                u * s - d(l) * c,
                                u * l - d(s) * c
                            ];
                        }
                        return t1.invert && (i.invert = function(e1, i) {
                            var a = (e1 + i) * _, o = (i - e1) * _, s = n(a) < .5 * r && n(o) < .5 * r;
                            if (!s) {
                                var l = r * _, c = a > 0 ^ o > 0 ? -1 : 1, u = -c * e1 + (o > 0 ? 1 : -1) * l, f = -c * i + (a > 0 ? 1 : -1) * l;
                                a = (-u - f) * _, o = (u - f) * _;
                            }
                            var h = t1.invert(a, o);
                            return s || (h[0] += a > 0 ? y : -y), h;
                        }), e1.geoProjection(i).rotate([
                            -90,
                            -90,
                            45
                        ]).clipAngle(179.999);
                    }
                    function lr() {
                        return sr(Ut).scale(111.48);
                    }
                    function cr(t1) {
                        var e1 = m(t1);
                        function r(r, n) {
                            var a = e1 ? g(r * e1 / 2) / e1 : r / 2;
                            if (!n) return [
                                2 * a,
                                -t1
                            ];
                            var s = 2 * i(a * m(n)), l = 1 / g(n);
                            return [
                                m(s) * l,
                                n + (1 - o(s)) * l - t1
                            ];
                        }
                        return r.invert = function(r, a) {
                            if (n(a += t1) < v) return [
                                e1 ? 2 * i(e1 * r / 2) / e1 : r,
                                0
                            ];
                            var s, l = r * r + a * a, c = 0, u = 10;
                            do {
                                var f = g(c), h = 1 / o(c), p = l - 2 * a * c + c * c;
                                c -= s = (f * p + 2 * (c - a)) / (2 + p * h * h + 2 * (c - a) * f);
                            }while (n(s) > v && --u > 0);
                            var d = r * (f = g(c)), x = g(n(a) < n(c + 1 / f) ? .5 * S(d) : .5 * E(d) + y / 4) / m(c);
                            return [
                                e1 ? 2 * i(e1 * x) / e1 : 2 * x,
                                c
                            ];
                        }, r;
                    }
                    var ur = [
                        [
                            .9986,
                            -0.062
                        ],
                        [
                            1,
                            0
                        ],
                        [
                            .9986,
                            .062
                        ],
                        [
                            .9954,
                            .124
                        ],
                        [
                            .99,
                            .186
                        ],
                        [
                            .9822,
                            .248
                        ],
                        [
                            .973,
                            .31
                        ],
                        [
                            .96,
                            .372
                        ],
                        [
                            .9427,
                            .434
                        ],
                        [
                            .9216,
                            .4958
                        ],
                        [
                            .8962,
                            .5571
                        ],
                        [
                            .8679,
                            .6176
                        ],
                        [
                            .835,
                            .6769
                        ],
                        [
                            .7986,
                            .7346
                        ],
                        [
                            .7597,
                            .7903
                        ],
                        [
                            .7186,
                            .8435
                        ],
                        [
                            .6732,
                            .8936
                        ],
                        [
                            .6213,
                            .9394
                        ],
                        [
                            .5722,
                            .9761
                        ],
                        [
                            .5322,
                            1
                        ]
                    ];
                    function fr(t1, e1) {
                        var r, i = f(18, 36 * n(e1) / y), a = l(i), o = i - a, s = (r = ur[a])[0], c = r[1], u = (r = ur[++a])[0], h = r[1], p = (r = ur[f(19, ++a)])[0], d = r[1];
                        return [
                            t1 * (u + o * (p - s) / 2 + o * o * (p - 2 * u + s) / 2),
                            (e1 > 0 ? x : -x) * (h + o * (d - c) / 2 + o * o * (d - 2 * h + c) / 2)
                        ];
                    }
                    function hr(t1, e1) {
                        var r = function(t1) {
                            function e1(e1, r) {
                                var n = o(r), i = (t1 - 1) / (t1 - n * o(e1));
                                return [
                                    i * n * m(e1),
                                    i * m(r)
                                ];
                            }
                            return e1.invert = function(e1, r) {
                                var n = e1 * e1 + r * r, i = L(n), o = (t1 - L(1 - n * (t1 + 1) / (t1 - 1))) / ((t1 - 1) / i + i / (t1 - 1));
                                return [
                                    a(e1 * o, i * L(1 - o * o)),
                                    i ? S(r * o / i) : 0
                                ];
                            }, e1;
                        }(t1);
                        if (!e1) return r;
                        var n = o(e1), i = m(e1);
                        function s(e1, a) {
                            var o = r(e1, a), s = o[1], l = s * i / (t1 - 1) + n;
                            return [
                                o[0] * n / l,
                                s / l
                            ];
                        }
                        return s.invert = function(e1, a) {
                            var o = (t1 - 1) / (t1 - 1 - a * i);
                            return r.invert(o * e1, o * a * n);
                        }, s;
                    }
                    ur.forEach(function(t1) {
                        t1[1] *= 1.0144;
                    }), fr.invert = function(t1, e1) {
                        var r = e1 / x, i = 90 * r, a = f(18, n(i / 5)), o = u(0, l(a));
                        do {
                            var s = ur[o][1], c = ur[o + 1][1], h = ur[f(19, o + 2)][1], p = h - s, d = h - 2 * c + s, m = 2 * (n(r) - c) / p, g = d / p, v = m * (1 - g * m * (1 - 2 * g * m));
                            if (v >= 0 || 1 === o) {
                                i = (e1 >= 0 ? 5 : -5) * (v + a);
                                var y, b = 50;
                                do v = (a = f(18, n(i) / 5)) - (o = l(a)), s = ur[o][1], c = ur[o + 1][1], h = ur[f(19, o + 2)][1], i -= (y = (e1 >= 0 ? x : -x) * (c + v * (h - s) / 2 + v * v * (h - 2 * c + s) / 2) - e1) * A;
                                while (n(y) > 1e-12 && --b > 0);
                                break;
                            }
                        }while (--o >= 0);
                        var _ = ur[o][0], w = ur[o + 1][0], T = ur[f(19, o + 2)][0];
                        return [
                            t1 / (w + v * (T - _) / 2 + v * v * (T - 2 * w + _) / 2),
                            i * M
                        ];
                    };
                    var pr = -179.9999, dr = 179.9999, mr = -89.9999;
                    function gr(t1) {
                        return t1.length > 0;
                    }
                    function vr(t1) {
                        var e1;
                        return -90 === t1 || 90 === t1 ? [
                            0,
                            t1
                        ] : [
                            -180,
                            (e1 = t1, Math.floor(1e4 * e1) / 1e4)
                        ];
                    }
                    function yr(t1) {
                        var e1 = t1[0], r = t1[1], n = !1;
                        return e1 <= pr ? (e1 = -180, n = !0) : e1 >= dr && (e1 = 180, n = !0), r <= mr ? (r = -90, n = !0) : r >= 89.9999 && (r = 90, n = !0), n ? [
                            e1,
                            r
                        ] : t1;
                    }
                    function xr(t1) {
                        return t1.map(yr);
                    }
                    function br(t1, e1, r) {
                        for(var n = 0, i = t1.length; n < i; ++n){
                            var a = t1[n].slice();
                            r.push({
                                index: -1,
                                polygon: e1,
                                ring: a
                            });
                            for(var o = 0, s = a.length; o < s; ++o){
                                var l = a[o], c = l[0], u = l[1];
                                if (c <= pr || c >= dr || u <= mr || u >= 89.9999) {
                                    a[o] = yr(l);
                                    for(var f = o + 1; f < s; ++f){
                                        var h = a[f], p = h[0], d = h[1];
                                        if (p > pr && p < dr && d > mr && d < 89.9999) break;
                                    }
                                    if (f === o + 1) continue;
                                    if (o) {
                                        var m = {
                                            index: -1,
                                            polygon: e1,
                                            ring: a.slice(0, o + 1)
                                        };
                                        m.ring[m.ring.length - 1] = vr(u), r[r.length - 1] = m;
                                    } else r.pop();
                                    if (f >= s) break;
                                    r.push({
                                        index: -1,
                                        polygon: e1,
                                        ring: a = a.slice(f - 1)
                                    }), a[0] = vr(a[0][1]), o = -1, s = a.length;
                                }
                            }
                        }
                    }
                    function _r(t1) {
                        var e1, r, n, i, a, o, s = t1.length, l = {}, c = {};
                        for(e1 = 0; e1 < s; ++e1)n = (r = t1[e1]).ring[0], a = r.ring[r.ring.length - 1], n[0] !== a[0] || n[1] !== a[1] ? (r.index = e1, l[n] = c[a] = r) : (r.polygon.push(r.ring), t1[e1] = null);
                        for(e1 = 0; e1 < s; ++e1)if (r = t1[e1]) {
                            if (n = r.ring[0], a = r.ring[r.ring.length - 1], i = c[n], o = l[a], delete l[n], delete c[a], n[0] === a[0] && n[1] === a[1]) {
                                r.polygon.push(r.ring);
                                continue;
                            }
                            i ? (delete c[n], delete l[i.ring[0]], i.ring.pop(), t1[i.index] = null, r = {
                                index: -1,
                                polygon: i.polygon,
                                ring: i.ring.concat(r.ring)
                            }, i === o ? r.polygon.push(r.ring) : (r.index = s++, t1.push(l[r.ring[0]] = c[r.ring[r.ring.length - 1]] = r))) : o ? (delete l[a], delete c[o.ring[o.ring.length - 1]], r.ring.pop(), r = {
                                index: s++,
                                polygon: o.polygon,
                                ring: r.ring.concat(o.ring)
                            }, t1[o.index] = null, t1.push(l[r.ring[0]] = c[r.ring[r.ring.length - 1]] = r)) : (r.ring.push(r.ring[0]), r.polygon.push(r.ring));
                        }
                    }
                    function wr(t1) {
                        var e1 = {
                            type: "Feature",
                            geometry: Tr(t1.geometry)
                        };
                        return null != t1.id && (e1.id = t1.id), null != t1.bbox && (e1.bbox = t1.bbox), null != t1.properties && (e1.properties = t1.properties), e1;
                    }
                    function Tr(t1) {
                        if (null == t1) return t1;
                        var e1, r, n, i;
                        switch(t1.type){
                            case "GeometryCollection":
                                e1 = {
                                    type: "GeometryCollection",
                                    geometries: t1.geometries.map(Tr)
                                };
                                break;
                            case "Point":
                                e1 = {
                                    type: "Point",
                                    coordinates: yr(t1.coordinates)
                                };
                                break;
                            case "MultiPoint":
                            case "LineString":
                                e1 = {
                                    type: t1.type,
                                    coordinates: xr(t1.coordinates)
                                };
                                break;
                            case "MultiLineString":
                                e1 = {
                                    type: "MultiLineString",
                                    coordinates: t1.coordinates.map(xr)
                                };
                                break;
                            case "Polygon":
                                var a = [];
                                br(t1.coordinates, a, r = []), _r(r), e1 = {
                                    type: "Polygon",
                                    coordinates: a
                                };
                                break;
                            case "MultiPolygon":
                                r = [], n = -1, i = t1.coordinates.length;
                                for(var o = new Array(i); ++n < i;)br(t1.coordinates[n], o[n] = [], r);
                                _r(r), e1 = {
                                    type: "MultiPolygon",
                                    coordinates: o.filter(gr)
                                };
                                break;
                            default:
                                return t1;
                        }
                        return null != t1.bbox && (e1.bbox = t1.bbox), e1;
                    }
                    function kr(t1, e1) {
                        var r = g(e1 / 2), n = m(b * r);
                        return [
                            t1 * (.74482 - .34588 * n * n),
                            1.70711 * r
                        ];
                    }
                    function Ar(t1, r, n) {
                        var i = e1.geoInterpolate(r, n), a = i(.5), o = e1.geoRotation([
                            -a[0],
                            -a[1]
                        ])(r), s = i.distance / 2, l = -S(m(o[1] * M) / m(s)), c = [
                            -a[0],
                            -a[1],
                            -(o[0] > 0 ? y - l : l) * A
                        ], u = e1.geoProjection(t1(s)).rotate(c), f = e1.geoRotation(c), h = u.center;
                        return delete u.rotate, u.center = function(t1) {
                            return arguments.length ? h(f(t1)) : f.invert(h());
                        }, u.clipAngle(90);
                    }
                    function Mr(t1) {
                        var r = o(t1);
                        function n(t1, n) {
                            var i = e1.geoGnomonicRaw(t1, n);
                            return i[0] *= r, i;
                        }
                        return n.invert = function(t1, n) {
                            return e1.geoGnomonicRaw.invert(t1 / r, n);
                        }, n;
                    }
                    function Sr(t1, e1) {
                        return Ar(Mr, t1, e1);
                    }
                    function Er(t1) {
                        if (!(t1 *= 2)) return e1.geoAzimuthalEquidistantRaw;
                        var r = -t1 / 2, n = -r, i = t1 * t1, s = g(n), l = .5 / m(n);
                        function c(e1, a) {
                            var s = E(o(a) * o(e1 - r)), l = E(o(a) * o(e1 - n));
                            return [
                                ((s *= s) - (l *= l)) / (2 * t1),
                                (a < 0 ? -1 : 1) * L(4 * i * l - (i - s + l) * (i - s + l)) / (2 * t1)
                            ];
                        }
                        return c.invert = function(t1, e1) {
                            var i, c, u = e1 * e1, f = o(L(u + (i = t1 + r) * i)), h = o(L(u + (i = t1 + n) * i));
                            return [
                                a(c = f - h, i = (f + h) * s),
                                (e1 < 0 ? -1 : 1) * E(L(i * i + c * c) * l)
                            ];
                        }, c;
                    }
                    function Lr(t1, e1) {
                        return Ar(Er, t1, e1);
                    }
                    function Cr(t1, e1) {
                        if (n(e1) < v) return [
                            t1,
                            0
                        ];
                        var r = n(e1 / x), i = S(r);
                        if (n(t1) < v || n(n(e1) - x) < v) return [
                            0,
                            d(e1) * y * g(i / 2)
                        ];
                        var a = o(i), s = n(y / t1 - t1 / y) / 2, l = s * s, c = a / (r + a - 1), u = c * (2 / r - 1), f = u * u, h = f + l, p = c - f, m = l + c;
                        return [
                            d(t1) * y * (s * p + L(l * p * p - h * (c * c - f))) / h,
                            d(e1) * y * (u * m - s * L((l + 1) * h - m * m)) / h
                        ];
                    }
                    function Pr(t1, e1) {
                        if (n(e1) < v) return [
                            t1,
                            0
                        ];
                        var r = n(e1 / x), i = S(r);
                        if (n(t1) < v || n(n(e1) - x) < v) return [
                            0,
                            d(e1) * y * g(i / 2)
                        ];
                        var a = o(i), s = n(y / t1 - t1 / y) / 2, l = s * s, c = a * (L(1 + l) - s * a) / (1 + l * r * r);
                        return [
                            d(t1) * y * c,
                            d(e1) * y * L(1 - c * (2 * s + c))
                        ];
                    }
                    function Ir(t1, e1) {
                        if (n(e1) < v) return [
                            t1,
                            0
                        ];
                        var r = e1 / x, i = S(r);
                        if (n(t1) < v || n(n(e1) - x) < v) return [
                            0,
                            y * g(i / 2)
                        ];
                        var a = (y / t1 - t1 / y) / 2, s = r / (1 + o(i));
                        return [
                            y * (d(t1) * L(a * a + 1 - s * s) - a),
                            y * s
                        ];
                    }
                    function Or(t1, e1) {
                        if (!e1) return [
                            t1,
                            0
                        ];
                        var r = n(e1);
                        if (!t1 || r === x) return [
                            0,
                            e1
                        ];
                        var i = r / x, a = i * i, o = (8 * i - a * (a + 2) - 5) / (2 * a * (i - 1)), s = o * o, l = i * o, c = a + s + 2 * l, u = i + 3 * o, f = t1 / x, h = f + 1 / f, p = d(n(t1) - x) * L(h * h - 4), m = p * p, g = (p * (c + s - 1) + 2 * L(c * (a + s * m - 1) + (1 - a) * (a * (u * u + 4 * s) + 12 * l * s + 4 * s * s))) / (4 * c + m);
                        return [
                            d(t1) * x * g,
                            d(e1) * x * L(1 + p * n(g) - g * g)
                        ];
                    }
                    function zr(t1, e1, r, n) {
                        var i = y / 3;
                        t1 = u(t1, v), e1 = u(e1, v), t1 = f(t1, x), e1 = f(e1, y - v), r = u(r, 0), r = f(r, 100 - v);
                        var s = (n = u(n, v)) / 100, l = E((r / 100 + 1) * o(i)) / i, c = m(t1) / m(l * x), h = e1 / y, p = L(s * m(t1 / 2) / m(e1 / 2));
                        return function(t1, e1, r, n, i) {
                            function s(a, s) {
                                var l = r * m(n * s), c = L(1 - l * l), u = L(2 / (1 + c * o(a *= i)));
                                return [
                                    t1 * c * u * m(a),
                                    e1 * l * u
                                ];
                            }
                            return s.invert = function(o, s) {
                                var l = o / t1, c = s / e1, u = L(l * l + c * c), f = 2 * S(u / 2);
                                return [
                                    a(o * g(f), t1 * u) / i,
                                    u && S(s * m(f) / (e1 * r * u)) / n
                                ];
                            }, s;
                        }(p / L(h * c * l), 1 / (p * L(h * c * l)), c, l, h);
                    }
                    function Dr() {
                        var t1 = 65 * M, r = 60 * M, n = 20, i = 200, a = e1.geoProjectionMutator(zr), o = a(t1, r, n, i);
                        return o.poleline = function(e1) {
                            return arguments.length ? a(t1 = +e1 * M, r, n, i) : t1 * A;
                        }, o.parallels = function(e1) {
                            return arguments.length ? a(t1, r = +e1 * M, n, i) : r * A;
                        }, o.inflation = function(e1) {
                            return arguments.length ? a(t1, r, n = +e1, i) : n;
                        }, o.ratio = function(e1) {
                            return arguments.length ? a(t1, r, n, i = +e1) : i;
                        }, o.scale(163.775);
                    }
                    kr.invert = function(t1, e1) {
                        var r = e1 / 1.70711, n = m(b * r);
                        return [
                            t1 / (.74482 - .34588 * n * n),
                            2 * i(r)
                        ];
                    }, Cr.invert = function(t1, e1) {
                        if (n(e1) < v) return [
                            t1,
                            0
                        ];
                        if (n(t1) < v) return [
                            0,
                            x * m(2 * i(e1 / y))
                        ];
                        var r = (t1 /= y) * t1, a = (e1 /= y) * e1, s = r + a, l = s * s, c = -n(e1) * (1 + s), u = c - 2 * a + r, f = -2 * c + 1 + 2 * a + l, h = a / f + (2 * u * u * u / (f * f * f) - 9 * c * u / (f * f)) / 27, p = (c - u * u / (3 * f)) / f, g = 2 * L(-p / 3), b = E(3 * h / (p * g)) / 3;
                        return [
                            y * (s - 1 + L(1 + 2 * (r - a) + l)) / (2 * t1),
                            d(e1) * y * (-g * o(b + y / 3) - u / (3 * f))
                        ];
                    }, Pr.invert = function(t1, e1) {
                        if (!t1) return [
                            0,
                            x * m(2 * i(e1 / y))
                        ];
                        var r = n(t1 / y), o = (1 - r * r - (e1 /= y) * e1) / (2 * r), s = L(o * o + 1);
                        return [
                            d(t1) * y * (s - o),
                            d(e1) * x * m(2 * a(L((1 - 2 * o * r) * (o + s) - r), L(s + o + r)))
                        ];
                    }, Ir.invert = function(t1, e1) {
                        if (!e1) return [
                            t1,
                            0
                        ];
                        var r = e1 / y, n = (y * y * (1 - r * r) - t1 * t1) / (2 * y * t1);
                        return [
                            t1 ? y * (d(t1) * L(n * n + 1) - n) : 0,
                            x * m(2 * i(r))
                        ];
                    }, Or.invert = function(t1, e1) {
                        var r;
                        if (!t1 || !e1) return [
                            t1,
                            e1
                        ];
                        e1 /= y;
                        var i = d(t1) * t1 / x, a = (i * i - 1 + 4 * e1 * e1) / n(i), o = a * a, s = 2 * e1, l = 50;
                        do {
                            var c = s * s, u = (8 * s - c * (c + 2) - 5) / (2 * c * (s - 1)), f = (3 * s - c * s - 10) / (2 * c * s), h = u * u, p = s * u, m = s + u, g = m * m, b = s + 3 * u, _ = -2 * m * (4 * p * h + (1 - 4 * c + 3 * c * c) * (1 + f) + h * (14 * c - 6 - o + (8 * c - 8 - 2 * o) * f) + p * (12 * c - 8 + (10 * c - 10 - o) * f)), w = L(g * (c + h * o - 1) + (1 - c) * (c * (b * b + 4 * h) + h * (12 * p + 4 * h)));
                            s -= r = (a * (g + h - 1) + 2 * w - i * (4 * g + o)) / (a * (2 * u * f + 2 * m * (1 + f)) + _ / w - 8 * m * (a * (-1 + h + g) + 2 * w) * (1 + f) / (o + 4 * g));
                        }while (r > v && --l > 0);
                        return [
                            d(t1) * (L(a * a + 4) + a) * y / 4,
                            x * s
                        ];
                    };
                    var Rr = 4 * y + 3 * L(3), Fr = 2 * L(2 * y * L(3) / Rr), Br = Y(Fr * L(3) / y, Fr, Rr / 6);
                    function Nr(t1, e1) {
                        return [
                            t1 * L(1 - 3 * e1 * e1 / (y * y)),
                            e1
                        ];
                    }
                    function jr(t1, e1) {
                        var r = o(e1), n = o(t1) * r, i = 1 - n, s = o(t1 = a(m(t1) * r, -m(e1))), l = m(t1);
                        return [
                            l * (r = L(1 - n * n)) - s * i,
                            -s * r - l * i
                        ];
                    }
                    function Ur(t1, e1) {
                        var r = O(t1, e1);
                        return [
                            (r[0] + t1 / x) / 2,
                            (r[1] + e1) / 2
                        ];
                    }
                    Nr.invert = function(t1, e1) {
                        return [
                            t1 / L(1 - 3 * e1 * e1 / (y * y)),
                            e1
                        ];
                    }, jr.invert = function(t1, e1) {
                        var r = (t1 * t1 + e1 * e1) / -2, n = L(-r * (2 + r)), i = e1 * r + t1 * n, o = t1 * r - e1 * n, s = L(o * o + i * i);
                        return [
                            a(n * i, s * (1 + r)),
                            s ? -S(n * o / s) : 0
                        ];
                    }, Ur.invert = function(t1, e1) {
                        var r = t1, i = e1, a = 25;
                        do {
                            var s, l = o(i), c = m(i), u = m(2 * i), f = c * c, h = l * l, p = m(r), d = o(r / 2), g = m(r / 2), y = g * g, b = 1 - h * d * d, _ = b ? E(l * d) * L(s = 1 / b) : s = 0, w = .5 * (2 * _ * l * g + r / x) - t1, T = .5 * (_ * c + i) - e1, k = .5 * s * (h * y + _ * l * d * f) + .5 / x, A = s * (p * u / 4 - _ * c * g), M = .125 * s * (u * g - _ * c * h * p), S = .5 * s * (f * d + _ * y * l) + .5, C = A * M - S * k, P = (T * A - w * S) / C, I = (w * M - T * k) / C;
                            r -= P, i -= I;
                        }while ((n(P) > v || n(I) > v) && --a > 0);
                        return [
                            r,
                            i
                        ];
                    }, t1.geoNaturalEarth = e1.geoNaturalEarth1, t1.geoNaturalEarthRaw = e1.geoNaturalEarth1Raw, t1.geoAiry = function() {
                        var t1 = x, r = e1.geoProjectionMutator(I), n = r(t1);
                        return n.radius = function(e1) {
                            return arguments.length ? r(t1 = e1 * M) : t1 * A;
                        }, n.scale(179.976).clipAngle(147);
                    }, t1.geoAiryRaw = I, t1.geoAitoff = function() {
                        return e1.geoProjection(O).scale(152.63);
                    }, t1.geoAitoffRaw = O, t1.geoArmadillo = function() {
                        var t1 = 20 * M, r = t1 >= 0 ? 1 : -1, n = g(r * t1), i = e1.geoProjectionMutator(z), s = i(t1), l = s.stream;
                        return s.parallel = function(e1) {
                            return arguments.length ? (n = g((r = (t1 = e1 * M) >= 0 ? 1 : -1) * t1), i(t1)) : t1 * A;
                        }, s.stream = function(e1) {
                            var i = s.rotate(), c = l(e1), u = (s.rotate([
                                0,
                                0
                            ]), l(e1)), f = s.precision();
                            return s.rotate(i), c.sphere = function() {
                                u.polygonStart(), u.lineStart();
                                for(var e1 = -180 * r; r * e1 < 180; e1 += 90 * r)u.point(e1, 90 * r);
                                if (t1) for(; r * (e1 -= 3 * r * f) >= -180;)u.point(e1, r * -a(o(e1 * M / 2), n) * A);
                                u.lineEnd(), u.polygonEnd();
                            }, c;
                        }, s.scale(218.695).center([
                            0,
                            28.0974
                        ]);
                    }, t1.geoArmadilloRaw = z, t1.geoAugust = function() {
                        return e1.geoProjection(D).scale(66.1603);
                    }, t1.geoAugustRaw = D, t1.geoBaker = function() {
                        return e1.geoProjection(B).scale(112.314);
                    }, t1.geoBakerRaw = B, t1.geoBerghaus = function() {
                        var t1 = 5, r = e1.geoProjectionMutator(N), n = r(t1), i = n.stream, s = -o(.01 * M), l = m(.01 * M);
                        return n.lobes = function(e1) {
                            return arguments.length ? r(t1 = +e1) : t1;
                        }, n.stream = function(e1) {
                            var r = n.rotate(), c = i(e1), u = (n.rotate([
                                0,
                                0
                            ]), i(e1));
                            return n.rotate(r), c.sphere = function() {
                                u.polygonStart(), u.lineStart();
                                for(var e1 = 0, r = 360 / t1, n = 2 * y / t1, i = 90 - 180 / t1, c = x; e1 < t1; ++e1, i -= r, c -= n)u.point(a(l * o(c), s) * A, S(l * m(c)) * A), i < -90 ? (u.point(-90, -180 - i - .01), u.point(-90, -180 - i + .01)) : (u.point(90, i + .01), u.point(90, i - .01));
                                u.lineEnd(), u.polygonEnd();
                            }, c;
                        }, n.scale(87.8076).center([
                            0,
                            17.1875
                        ]).clipAngle(179.999);
                    }, t1.geoBerghausRaw = N, t1.geoBertin1953 = function() {
                        return e1.geoProjection(q()).rotate([
                            -16.5,
                            -42
                        ]).scale(176.57).center([
                            7.93,
                            .09
                        ]);
                    }, t1.geoBertin1953Raw = q, t1.geoBoggs = function() {
                        return e1.geoProjection(J).scale(160.857);
                    }, t1.geoBoggsRaw = J, t1.geoBonne = function() {
                        return K($).scale(123.082).center([
                            0,
                            26.1441
                        ]).parallel(45);
                    }, t1.geoBonneRaw = $, t1.geoBottomley = function() {
                        var t1 = .5, r = e1.geoProjectionMutator(tt), n = r(t1);
                        return n.fraction = function(e1) {
                            return arguments.length ? r(t1 = +e1) : t1;
                        }, n.scale(158.837);
                    }, t1.geoBottomleyRaw = tt, t1.geoBromley = function() {
                        return e1.geoProjection(et).scale(152.63);
                    }, t1.geoBromleyRaw = et, t1.geoChamberlin = st, t1.geoChamberlinRaw = at, t1.geoChamberlinAfrica = function() {
                        return st([
                            0,
                            22
                        ], [
                            45,
                            22
                        ], [
                            22.5,
                            -22
                        ]).scale(380).center([
                            22.5,
                            2
                        ]);
                    }, t1.geoCollignon = function() {
                        return e1.geoProjection(lt).scale(95.6464).center([
                            0,
                            30
                        ]);
                    }, t1.geoCollignonRaw = lt, t1.geoCraig = function() {
                        return K(ct).scale(249.828).clipAngle(90);
                    }, t1.geoCraigRaw = ct, t1.geoCraster = function() {
                        return e1.geoProjection(ft).scale(156.19);
                    }, t1.geoCrasterRaw = ft, t1.geoCylindricalEqualArea = function() {
                        return K(ht).parallel(38.58).scale(195.044);
                    }, t1.geoCylindricalEqualAreaRaw = ht, t1.geoCylindricalStereographic = function() {
                        return K(pt).scale(124.75);
                    }, t1.geoCylindricalStereographicRaw = pt, t1.geoEckert1 = function() {
                        return e1.geoProjection(dt).scale(165.664);
                    }, t1.geoEckert1Raw = dt, t1.geoEckert2 = function() {
                        return e1.geoProjection(mt).scale(165.664);
                    }, t1.geoEckert2Raw = mt, t1.geoEckert3 = function() {
                        return e1.geoProjection(gt).scale(180.739);
                    }, t1.geoEckert3Raw = gt, t1.geoEckert4 = function() {
                        return e1.geoProjection(vt).scale(180.739);
                    }, t1.geoEckert4Raw = vt, t1.geoEckert5 = function() {
                        return e1.geoProjection(yt).scale(173.044);
                    }, t1.geoEckert5Raw = yt, t1.geoEckert6 = function() {
                        return e1.geoProjection(xt).scale(173.044);
                    }, t1.geoEckert6Raw = xt, t1.geoEisenlohr = function() {
                        return e1.geoProjection(_t).scale(62.5271);
                    }, t1.geoEisenlohrRaw = _t, t1.geoFahey = function() {
                        return e1.geoProjection(Tt).scale(137.152);
                    }, t1.geoFaheyRaw = Tt, t1.geoFoucaut = function() {
                        return e1.geoProjection(kt).scale(135.264);
                    }, t1.geoFoucautRaw = kt, t1.geoFoucautSinusoidal = function() {
                        var t1 = .5, r = e1.geoProjectionMutator(At), n = r(t1);
                        return n.alpha = function(e1) {
                            return arguments.length ? r(t1 = +e1) : t1;
                        }, n.scale(168.725);
                    }, t1.geoFoucautSinusoidalRaw = At, t1.geoGilbert = function(t1) {
                        null == t1 && (t1 = e1.geoOrthographic);
                        var r = t1(), n = e1.geoEquirectangular().scale(A).precision(0).clipAngle(null).translate([
                            0,
                            0
                        ]);
                        function i(t1) {
                            return r(Mt(t1));
                        }
                        function a(t1) {
                            i[t1] = function() {
                                return arguments.length ? (r[t1].apply(r, arguments), i) : r[t1]();
                            };
                        }
                        return r.invert && (i.invert = function(t1) {
                            return St(r.invert(t1));
                        }), i.stream = function(t1) {
                            var e1 = r.stream(t1), i = n.stream({
                                point: function(t1, r) {
                                    e1.point(t1 / 2, S(g(-r / 2 * M)) * A);
                                },
                                lineStart: function() {
                                    e1.lineStart();
                                },
                                lineEnd: function() {
                                    e1.lineEnd();
                                },
                                polygonStart: function() {
                                    e1.polygonStart();
                                },
                                polygonEnd: function() {
                                    e1.polygonEnd();
                                }
                            });
                            return i.sphere = e1.sphere, i;
                        }, i.rotate = function(t1) {
                            return arguments.length ? (n.rotate(t1), i) : n.rotate();
                        }, i.center = function(t1) {
                            return arguments.length ? (r.center(Mt(t1)), i) : St(r.center());
                        }, a("angle"), a("clipAngle"), a("clipExtent"), a("fitExtent"), a("fitHeight"), a("fitSize"), a("fitWidth"), a("scale"), a("translate"), a("precision"), i.scale(249.5);
                    }, t1.geoGingery = function() {
                        var t1 = 6, r = 30 * M, n = o(r), i = m(r), s = e1.geoProjectionMutator(Et), l = s(r, t1), c = l.stream, u = -o(.01 * M), f = m(.01 * M);
                        return l.radius = function(e1) {
                            return arguments.length ? (n = o(r = e1 * M), i = m(r), s(r, t1)) : r * A;
                        }, l.lobes = function(e1) {
                            return arguments.length ? s(r, t1 = +e1) : t1;
                        }, l.stream = function(e1) {
                            var r = l.rotate(), s = c(e1), h = (l.rotate([
                                0,
                                0
                            ]), c(e1));
                            return l.rotate(r), s.sphere = function() {
                                h.polygonStart(), h.lineStart();
                                for(var e1 = 0, r = 2 * y / t1, s = 0; e1 < t1; ++e1, s -= r)h.point(a(f * o(s), u) * A, S(f * m(s)) * A), h.point(a(i * o(s - r / 2), n) * A, S(i * m(s - r / 2)) * A);
                                h.lineEnd(), h.polygonEnd();
                            }, s;
                        }, l.rotate([
                            90,
                            -40
                        ]).scale(91.7095).clipAngle(179.999);
                    }, t1.geoGingeryRaw = Et, t1.geoGinzburg4 = function() {
                        return e1.geoProjection(It).scale(149.995);
                    }, t1.geoGinzburg4Raw = It, t1.geoGinzburg5 = function() {
                        return e1.geoProjection(Ot).scale(153.93);
                    }, t1.geoGinzburg5Raw = Ot, t1.geoGinzburg6 = function() {
                        return e1.geoProjection(zt).scale(130.945);
                    }, t1.geoGinzburg6Raw = zt, t1.geoGinzburg8 = function() {
                        return e1.geoProjection(Dt).scale(131.747);
                    }, t1.geoGinzburg8Raw = Dt, t1.geoGinzburg9 = function() {
                        return e1.geoProjection(Rt).scale(131.087);
                    }, t1.geoGinzburg9Raw = Rt, t1.geoGringorten = function() {
                        return e1.geoProjection(Ft(Bt)).scale(239.75);
                    }, t1.geoGringortenRaw = Bt, t1.geoGuyou = function() {
                        return e1.geoProjection(Ft(Ut)).scale(151.496);
                    }, t1.geoGuyouRaw = Ut, t1.geoHammer = function() {
                        var t1 = 2, r = e1.geoProjectionMutator(j), n = r(t1);
                        return n.coefficient = function(e1) {
                            return arguments.length ? r(t1 = +e1) : t1;
                        }, n.scale(169.529);
                    }, t1.geoHammerRaw = j, t1.geoHammerRetroazimuthal = function() {
                        var t1 = 0, r = e1.geoProjectionMutator(Vt), n = r(t1), i = n.rotate, a = n.stream, o = e1.geoCircle();
                        return n.parallel = function(e1) {
                            if (!arguments.length) return t1 * A;
                            var i = n.rotate();
                            return r(t1 = e1 * M).rotate(i);
                        }, n.rotate = function(e1) {
                            return arguments.length ? (i.call(n, [
                                e1[0],
                                e1[1] - t1 * A
                            ]), o.center([
                                -e1[0],
                                -e1[1]
                            ]), n) : ((e1 = i.call(n))[1] += t1 * A, e1);
                        }, n.stream = function(t1) {
                            return (t1 = a(t1)).sphere = function() {
                                t1.polygonStart();
                                var e1, r = o.radius(89.99)().coordinates[0], n = r.length - 1, i = -1;
                                for(t1.lineStart(); ++i < n;)t1.point((e1 = r[i])[0], e1[1]);
                                for(t1.lineEnd(), n = (r = o.radius(90.01)().coordinates[0]).length - 1, t1.lineStart(); --i >= 0;)t1.point((e1 = r[i])[0], e1[1]);
                                t1.lineEnd(), t1.polygonEnd();
                            }, t1;
                        }, n.scale(79.4187).parallel(45).clipAngle(179.999);
                    }, t1.geoHammerRetroazimuthalRaw = Vt, t1.geoHealpix = function() {
                        var t1 = 4, n = e1.geoProjectionMutator(Yt), i = n(t1), a = i.stream;
                        return i.lobes = function(e1) {
                            return arguments.length ? n(t1 = +e1) : t1;
                        }, i.stream = function(n) {
                            var o = i.rotate(), s = a(n), l = (i.rotate([
                                0,
                                0
                            ]), a(n));
                            return i.rotate(o), s.sphere = function() {
                                var n, i;
                                e1.geoStream((n = 180 / t1, i = [].concat(r.range(-180, 180 + n / 2, n).map(Wt), r.range(180, -180 - n / 2, -n).map(Xt)), {
                                    type: "Polygon",
                                    coordinates: [
                                        180 === n ? i.map(Zt) : i
                                    ]
                                }), l);
                            }, s;
                        }, i.scale(239.75);
                    }, t1.geoHealpixRaw = Yt, t1.geoHill = function() {
                        var t1 = 1, r = e1.geoProjectionMutator(Jt), n = r(t1);
                        return n.ratio = function(e1) {
                            return arguments.length ? r(t1 = +e1) : t1;
                        }, n.scale(167.774).center([
                            0,
                            18.67
                        ]);
                    }, t1.geoHillRaw = Jt, t1.geoHomolosine = function() {
                        return e1.geoProjection(Qt).scale(152.63);
                    }, t1.geoHomolosineRaw = Qt, t1.geoHufnagel = function() {
                        var t1 = 1, r = 0, n = 45 * M, i = 2, a = e1.geoProjectionMutator($t), o = a(t1, r, n, i);
                        return o.a = function(e1) {
                            return arguments.length ? a(t1 = +e1, r, n, i) : t1;
                        }, o.b = function(e1) {
                            return arguments.length ? a(t1, r = +e1, n, i) : r;
                        }, o.psiMax = function(e1) {
                            return arguments.length ? a(t1, r, n = +e1 * M, i) : n * A;
                        }, o.ratio = function(e1) {
                            return arguments.length ? a(t1, r, n, i = +e1) : i;
                        }, o.scale(180.739);
                    }, t1.geoHufnagelRaw = $t, t1.geoHyperelliptical = function() {
                        var t1 = 0, r = 2.5, n = 1.183136, i = e1.geoProjectionMutator(ee), a = i(t1, r, n);
                        return a.alpha = function(e1) {
                            return arguments.length ? i(t1 = +e1, r, n) : t1;
                        }, a.k = function(e1) {
                            return arguments.length ? i(t1, r = +e1, n) : r;
                        }, a.gamma = function(e1) {
                            return arguments.length ? i(t1, r, n = +e1) : n;
                        }, a.scale(152.63);
                    }, t1.geoHyperellipticalRaw = ee, t1.geoInterrupt = ae, t1.geoInterruptedBoggs = function() {
                        return ae(J, oe).scale(160.857);
                    }, t1.geoInterruptedHomolosine = function() {
                        return ae(Qt, se).scale(152.63);
                    }, t1.geoInterruptedMollweide = function() {
                        return ae(W, le).scale(169.529);
                    }, t1.geoInterruptedMollweideHemispheres = function() {
                        return ae(W, ce).scale(169.529).rotate([
                            20,
                            0
                        ]);
                    }, t1.geoInterruptedSinuMollweide = function() {
                        return ae(Kt, ue, H).rotate([
                            -20,
                            -55
                        ]).scale(164.263).center([
                            0,
                            -5.4036
                        ]);
                    }, t1.geoInterruptedSinusoidal = function() {
                        return ae(Q, fe).scale(152.63).rotate([
                            -20,
                            0
                        ]);
                    }, t1.geoKavrayskiy7 = function() {
                        return e1.geoProjection(he).scale(158.837);
                    }, t1.geoKavrayskiy7Raw = he, t1.geoLagrange = function() {
                        var t1 = .5, r = e1.geoProjectionMutator(pe), n = r(t1);
                        return n.spacing = function(e1) {
                            return arguments.length ? r(t1 = +e1) : t1;
                        }, n.scale(124.75);
                    }, t1.geoLagrangeRaw = pe, t1.geoLarrivee = function() {
                        return e1.geoProjection(me).scale(97.2672);
                    }, t1.geoLarriveeRaw = me, t1.geoLaskowski = function() {
                        return e1.geoProjection(ge).scale(139.98);
                    }, t1.geoLaskowskiRaw = ge, t1.geoLittrow = function() {
                        return e1.geoProjection(ve).scale(144.049).clipAngle(89.999);
                    }, t1.geoLittrowRaw = ve, t1.geoLoximuthal = function() {
                        return K(ye).parallel(40).scale(158.837);
                    }, t1.geoLoximuthalRaw = ye, t1.geoMiller = function() {
                        return e1.geoProjection(xe).scale(108.318);
                    }, t1.geoMillerRaw = xe, t1.geoModifiedStereographic = Me, t1.geoModifiedStereographicRaw = be, t1.geoModifiedStereographicAlaska = function() {
                        return Me(_e, [
                            152,
                            -64
                        ]).scale(1400).center([
                            -160.908,
                            62.4864
                        ]).clipAngle(30).angle(7.8);
                    }, t1.geoModifiedStereographicGs48 = function() {
                        return Me(we, [
                            95,
                            -38
                        ]).scale(1e3).clipAngle(55).center([
                            -96.5563,
                            38.8675
                        ]);
                    }, t1.geoModifiedStereographicGs50 = function() {
                        return Me(Te, [
                            120,
                            -45
                        ]).scale(359.513).clipAngle(55).center([
                            -117.474,
                            53.0628
                        ]);
                    }, t1.geoModifiedStereographicMiller = function() {
                        return Me(ke, [
                            -20,
                            -18
                        ]).scale(209.091).center([
                            20,
                            16.7214
                        ]).clipAngle(82);
                    }, t1.geoModifiedStereographicLee = function() {
                        return Me(Ae, [
                            165,
                            10
                        ]).scale(250).clipAngle(130).center([
                            -165,
                            -10
                        ]);
                    }, t1.geoMollweide = function() {
                        return e1.geoProjection(W).scale(169.529);
                    }, t1.geoMollweideRaw = W, t1.geoMtFlatPolarParabolic = function() {
                        return e1.geoProjection(Le).scale(164.859);
                    }, t1.geoMtFlatPolarParabolicRaw = Le, t1.geoMtFlatPolarQuartic = function() {
                        return e1.geoProjection(Ce).scale(188.209);
                    }, t1.geoMtFlatPolarQuarticRaw = Ce, t1.geoMtFlatPolarSinusoidal = function() {
                        return e1.geoProjection(Pe).scale(166.518);
                    }, t1.geoMtFlatPolarSinusoidalRaw = Pe, t1.geoNaturalEarth2 = function() {
                        return e1.geoProjection(Ie).scale(175.295);
                    }, t1.geoNaturalEarth2Raw = Ie, t1.geoNellHammer = function() {
                        return e1.geoProjection(Oe).scale(152.63);
                    }, t1.geoNellHammerRaw = Oe, t1.geoInterruptedQuarticAuthalic = function() {
                        return ae(j(1 / 0), ze).rotate([
                            20,
                            0
                        ]).scale(152.63);
                    }, t1.geoNicolosi = function() {
                        return e1.geoProjection(De).scale(127.267);
                    }, t1.geoNicolosiRaw = De, t1.geoPatterson = function() {
                        return e1.geoProjection(Re).scale(139.319);
                    }, t1.geoPattersonRaw = Re, t1.geoPolyconic = function() {
                        return e1.geoProjection(Fe).scale(103.74);
                    }, t1.geoPolyconicRaw = Fe, t1.geoPolyhedral = Ve, t1.geoPolyhedralButterfly = function(t1) {
                        t1 = t1 || function(t1) {
                            var r = e1.geoCentroid({
                                type: "MultiPoint",
                                coordinates: t1
                            });
                            return e1.geoGnomonic().scale(1).translate([
                                0,
                                0
                            ]).rotate([
                                -r[0],
                                -r[1]
                            ]);
                        };
                        var r = Ye.map(function(e1) {
                            return {
                                face: e1,
                                project: t1(e1)
                            };
                        });
                        return [
                            -1,
                            0,
                            0,
                            1,
                            0,
                            1,
                            4,
                            5
                        ].forEach(function(t1, e1) {
                            var n = r[t1];
                            n && (n.children || (n.children = [])).push(r[e1]);
                        }), Ve(r[0], function(t1, e1) {
                            return r[t1 < -y / 2 ? e1 < 0 ? 6 : 4 : t1 < 0 ? e1 < 0 ? 2 : 0 : t1 < y / 2 ? e1 < 0 ? 3 : 1 : e1 < 0 ? 7 : 5];
                        }).angle(-30).scale(101.858).center([
                            0,
                            45
                        ]);
                    }, t1.geoPolyhedralCollignon = function(t1) {
                        t1 = t1 || function(t1) {
                            var r = e1.geoCentroid({
                                type: "MultiPoint",
                                coordinates: t1
                            });
                            return e1.geoProjection(Xe).translate([
                                0,
                                0
                            ]).scale(1).rotate(r[1] > 0 ? [
                                -r[0],
                                0
                            ] : [
                                180 - r[0],
                                180
                            ]);
                        };
                        var r = Ye.map(function(e1) {
                            return {
                                face: e1,
                                project: t1(e1)
                            };
                        });
                        return [
                            -1,
                            0,
                            0,
                            1,
                            0,
                            1,
                            4,
                            5
                        ].forEach(function(t1, e1) {
                            var n = r[t1];
                            n && (n.children || (n.children = [])).push(r[e1]);
                        }), Ve(r[0], function(t1, e1) {
                            return r[t1 < -y / 2 ? e1 < 0 ? 6 : 4 : t1 < 0 ? e1 < 0 ? 2 : 0 : t1 < y / 2 ? e1 < 0 ? 3 : 1 : e1 < 0 ? 7 : 5];
                        }).angle(-30).scale(121.906).center([
                            0,
                            48.5904
                        ]);
                    }, t1.geoPolyhedralWaterman = function(t1) {
                        t1 = t1 || function(t1) {
                            var r = 6 === t1.length ? e1.geoCentroid({
                                type: "MultiPoint",
                                coordinates: t1
                            }) : t1[0];
                            return e1.geoGnomonic().scale(1).translate([
                                0,
                                0
                            ]).rotate([
                                -r[0],
                                -r[1]
                            ]);
                        };
                        var r = Ye.map(function(t1) {
                            for(var e1, r = t1.map(Ke), n = r.length, i = r[n - 1], a = [], o = 0; o < n; ++o)e1 = r[o], a.push(Je([
                                .9486832980505138 * i[0] + .31622776601683794 * e1[0],
                                .9486832980505138 * i[1] + .31622776601683794 * e1[1],
                                .9486832980505138 * i[2] + .31622776601683794 * e1[2]
                            ]), Je([
                                .9486832980505138 * e1[0] + .31622776601683794 * i[0],
                                .9486832980505138 * e1[1] + .31622776601683794 * i[1],
                                .9486832980505138 * e1[2] + .31622776601683794 * i[2]
                            ])), i = e1;
                            return a;
                        }), n = [], i = [
                            -1,
                            0,
                            0,
                            1,
                            0,
                            1,
                            4,
                            5
                        ];
                        r.forEach(function(t1, e1) {
                            for(var a, o, s = Ye[e1], l = s.length, c = n[e1] = [], u = 0; u < l; ++u)r.push([
                                s[u],
                                t1[(2 * u + 2) % (2 * l)],
                                t1[(2 * u + 1) % (2 * l)]
                            ]), i.push(e1), c.push((a = Ke(t1[(2 * u + 2) % (2 * l)]), o = Ke(t1[(2 * u + 1) % (2 * l)]), [
                                a[1] * o[2] - a[2] * o[1],
                                a[2] * o[0] - a[0] * o[2],
                                a[0] * o[1] - a[1] * o[0]
                            ]));
                        });
                        var a = r.map(function(e1) {
                            return {
                                project: t1(e1),
                                face: e1
                            };
                        });
                        return i.forEach(function(t1, e1) {
                            var r = a[t1];
                            r && (r.children || (r.children = [])).push(a[e1]);
                        }), Ve(a[0], function(t1, e1) {
                            var r = o(e1), i = [
                                r * o(t1),
                                r * m(t1),
                                m(e1)
                            ], s = t1 < -y / 2 ? e1 < 0 ? 6 : 4 : t1 < 0 ? e1 < 0 ? 2 : 0 : t1 < y / 2 ? e1 < 0 ? 3 : 1 : e1 < 0 ? 7 : 5, l = n[s];
                            return a[Ze(l[0], i) < 0 ? 8 + 3 * s : Ze(l[1], i) < 0 ? 8 + 3 * s + 1 : Ze(l[2], i) < 0 ? 8 + 3 * s + 2 : s];
                        }).angle(-30).scale(110.625).center([
                            0,
                            45
                        ]);
                    }, t1.geoProject = function(t1, e1) {
                        var r, n = e1.stream;
                        if (!n) throw new Error("invalid projection");
                        switch(t1 && t1.type){
                            case "Feature":
                                r = tr;
                                break;
                            case "FeatureCollection":
                                r = $e;
                                break;
                            default:
                                r = er;
                        }
                        return r(t1, n);
                    }, t1.geoGringortenQuincuncial = function() {
                        return sr(Bt).scale(176.423);
                    }, t1.geoPeirceQuincuncial = lr, t1.geoPierceQuincuncial = lr, t1.geoQuantize = function(t1, e1) {
                        if (!(0 <= (e1 = +e1) && e1 <= 20)) throw new Error("invalid digits");
                        function r(t1) {
                            var r = t1.length, n = 2, i = new Array(r);
                            for(i[0] = +t1[0].toFixed(e1), i[1] = +t1[1].toFixed(e1); n < r;)i[n] = t1[n], ++n;
                            return i;
                        }
                        function n(t1) {
                            return t1.map(r);
                        }
                        function i(t1) {
                            for(var e1 = r(t1[0]), n = [
                                e1
                            ], i = 1; i < t1.length; i++){
                                var a = r(t1[i]);
                                (a.length > 2 || a[0] != e1[0] || a[1] != e1[1]) && (n.push(a), e1 = a);
                            }
                            return 1 === n.length && t1.length > 1 && n.push(r(t1[t1.length - 1])), n;
                        }
                        function a(t1) {
                            return t1.map(i);
                        }
                        function o(t1) {
                            if (null == t1) return t1;
                            var e1;
                            switch(t1.type){
                                case "GeometryCollection":
                                    e1 = {
                                        type: "GeometryCollection",
                                        geometries: t1.geometries.map(o)
                                    };
                                    break;
                                case "Point":
                                    e1 = {
                                        type: "Point",
                                        coordinates: r(t1.coordinates)
                                    };
                                    break;
                                case "MultiPoint":
                                    e1 = {
                                        type: t1.type,
                                        coordinates: n(t1.coordinates)
                                    };
                                    break;
                                case "LineString":
                                    e1 = {
                                        type: t1.type,
                                        coordinates: i(t1.coordinates)
                                    };
                                    break;
                                case "MultiLineString":
                                case "Polygon":
                                    e1 = {
                                        type: t1.type,
                                        coordinates: a(t1.coordinates)
                                    };
                                    break;
                                case "MultiPolygon":
                                    e1 = {
                                        type: "MultiPolygon",
                                        coordinates: t1.coordinates.map(a)
                                    };
                                    break;
                                default:
                                    return t1;
                            }
                            return null != t1.bbox && (e1.bbox = t1.bbox), e1;
                        }
                        function s(t1) {
                            var e1 = {
                                type: "Feature",
                                properties: t1.properties,
                                geometry: o(t1.geometry)
                            };
                            return null != t1.id && (e1.id = t1.id), null != t1.bbox && (e1.bbox = t1.bbox), e1;
                        }
                        if (null != t1) switch(t1.type){
                            case "Feature":
                                return s(t1);
                            case "FeatureCollection":
                                var l = {
                                    type: "FeatureCollection",
                                    features: t1.features.map(s)
                                };
                                return null != t1.bbox && (l.bbox = t1.bbox), l;
                            default:
                                return o(t1);
                        }
                        return t1;
                    }, t1.geoQuincuncial = sr, t1.geoRectangularPolyconic = function() {
                        return K(cr).scale(131.215);
                    }, t1.geoRectangularPolyconicRaw = cr, t1.geoRobinson = function() {
                        return e1.geoProjection(fr).scale(152.63);
                    }, t1.geoRobinsonRaw = fr, t1.geoSatellite = function() {
                        var t1 = 2, r = 0, n = e1.geoProjectionMutator(hr), i = n(t1, r);
                        return i.distance = function(e1) {
                            return arguments.length ? n(t1 = +e1, r) : t1;
                        }, i.tilt = function(e1) {
                            return arguments.length ? n(t1, r = e1 * M) : r * A;
                        }, i.scale(432.147).clipAngle(E(1 / t1) * A - 1e-6);
                    }, t1.geoSatelliteRaw = hr, t1.geoSinuMollweide = function() {
                        return e1.geoProjection(Kt).rotate([
                            -20,
                            -55
                        ]).scale(164.263).center([
                            0,
                            -5.4036
                        ]);
                    }, t1.geoSinuMollweideRaw = Kt, t1.geoSinusoidal = function() {
                        return e1.geoProjection(Q).scale(152.63);
                    }, t1.geoSinusoidalRaw = Q, t1.geoStitch = function(t1) {
                        if (null == t1) return t1;
                        switch(t1.type){
                            case "Feature":
                                return wr(t1);
                            case "FeatureCollection":
                                var e1 = {
                                    type: "FeatureCollection",
                                    features: t1.features.map(wr)
                                };
                                return null != t1.bbox && (e1.bbox = t1.bbox), e1;
                            default:
                                return Tr(t1);
                        }
                    }, t1.geoTimes = function() {
                        return e1.geoProjection(kr).scale(146.153);
                    }, t1.geoTimesRaw = kr, t1.geoTwoPointAzimuthal = Sr, t1.geoTwoPointAzimuthalRaw = Mr, t1.geoTwoPointAzimuthalUsa = function() {
                        return Sr([
                            -158,
                            21.5
                        ], [
                            -77,
                            39
                        ]).clipAngle(60).scale(400);
                    }, t1.geoTwoPointEquidistant = Lr, t1.geoTwoPointEquidistantRaw = Er, t1.geoTwoPointEquidistantUsa = function() {
                        return Lr([
                            -158,
                            21.5
                        ], [
                            -77,
                            39
                        ]).clipAngle(130).scale(122.571);
                    }, t1.geoVanDerGrinten = function() {
                        return e1.geoProjection(Cr).scale(79.4183);
                    }, t1.geoVanDerGrintenRaw = Cr, t1.geoVanDerGrinten2 = function() {
                        return e1.geoProjection(Pr).scale(79.4183);
                    }, t1.geoVanDerGrinten2Raw = Pr, t1.geoVanDerGrinten3 = function() {
                        return e1.geoProjection(Ir).scale(79.4183);
                    }, t1.geoVanDerGrinten3Raw = Ir, t1.geoVanDerGrinten4 = function() {
                        return e1.geoProjection(Or).scale(127.16);
                    }, t1.geoVanDerGrinten4Raw = Or, t1.geoWagner = Dr, t1.geoWagner7 = function() {
                        return Dr().poleline(65).parallels(60).inflation(0).ratio(200).scale(172.633);
                    }, t1.geoWagnerRaw = zr, t1.geoWagner4 = function() {
                        return e1.geoProjection(Br).scale(176.84);
                    }, t1.geoWagner4Raw = Br, t1.geoWagner6 = function() {
                        return e1.geoProjection(Nr).scale(152.63);
                    }, t1.geoWagner6Raw = Nr, t1.geoWiechel = function() {
                        return e1.geoProjection(jr).rotate([
                            0,
                            -90,
                            45
                        ]).scale(124.75).clipAngle(179.999);
                    }, t1.geoWiechelRaw = jr, t1.geoWinkel3 = function() {
                        return e1.geoProjection(Ur).scale(158.837);
                    }, t1.geoWinkel3Raw = Ur, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {
                "d3-array": 107,
                "d3-geo": 114
            }
        ],
        114: [
            function(t1, e1, r) {
                !function(n, i) {
                    "object" == typeof r && void 0 !== e1 ? i(r, t1("d3-array")) : i((n = n || self).d3 = n.d3 || {}, n.d3);
                }(this, function(t1, e1) {
                    "use strict";
                    function r() {
                        return new n;
                    }
                    function n() {
                        this.reset();
                    }
                    n.prototype = {
                        constructor: n,
                        reset: function() {
                            this.s = this.t = 0;
                        },
                        add: function(t1) {
                            a(i, t1, this.t), a(this, i.s, this.s), this.s ? this.t += i.t : this.s = i.t;
                        },
                        valueOf: function() {
                            return this.s;
                        }
                    };
                    var i = new n;
                    function a(t1, e1, r) {
                        var n = t1.s = e1 + r, i = n - e1, a = n - i;
                        t1.t = e1 - a + (r - i);
                    }
                    var o = 1e-6, s = Math.PI, l = s / 2, c = s / 4, u = 2 * s, f = 180 / s, h = s / 180, p = Math.abs, d = Math.atan, m = Math.atan2, g = Math.cos, v = Math.ceil, y = Math.exp, x = Math.log, b = Math.pow, _ = Math.sin, w = Math.sign || function(t1) {
                        return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
                    }, T = Math.sqrt, k = Math.tan;
                    function A(t1) {
                        return t1 > 1 ? 0 : t1 < -1 ? s : Math.acos(t1);
                    }
                    function M(t1) {
                        return t1 > 1 ? l : t1 < -1 ? -l : Math.asin(t1);
                    }
                    function S(t1) {
                        return (t1 = _(t1 / 2)) * t1;
                    }
                    function E() {}
                    function L(t1, e1) {
                        t1 && P.hasOwnProperty(t1.type) && P[t1.type](t1, e1);
                    }
                    var C = {
                        Feature: function(t1, e1) {
                            L(t1.geometry, e1);
                        },
                        FeatureCollection: function(t1, e1) {
                            for(var r = t1.features, n = -1, i = r.length; ++n < i;)L(r[n].geometry, e1);
                        }
                    }, P = {
                        Sphere: function(t1, e1) {
                            e1.sphere();
                        },
                        Point: function(t1, e1) {
                            t1 = t1.coordinates, e1.point(t1[0], t1[1], t1[2]);
                        },
                        MultiPoint: function(t1, e1) {
                            for(var r = t1.coordinates, n = -1, i = r.length; ++n < i;)t1 = r[n], e1.point(t1[0], t1[1], t1[2]);
                        },
                        LineString: function(t1, e1) {
                            I(t1.coordinates, e1, 0);
                        },
                        MultiLineString: function(t1, e1) {
                            for(var r = t1.coordinates, n = -1, i = r.length; ++n < i;)I(r[n], e1, 0);
                        },
                        Polygon: function(t1, e1) {
                            O(t1.coordinates, e1);
                        },
                        MultiPolygon: function(t1, e1) {
                            for(var r = t1.coordinates, n = -1, i = r.length; ++n < i;)O(r[n], e1);
                        },
                        GeometryCollection: function(t1, e1) {
                            for(var r = t1.geometries, n = -1, i = r.length; ++n < i;)L(r[n], e1);
                        }
                    };
                    function I(t1, e1, r) {
                        var n, i = -1, a = t1.length - r;
                        for(e1.lineStart(); ++i < a;)n = t1[i], e1.point(n[0], n[1], n[2]);
                        e1.lineEnd();
                    }
                    function O(t1, e1) {
                        var r = -1, n = t1.length;
                        for(e1.polygonStart(); ++r < n;)I(t1[r], e1, 1);
                        e1.polygonEnd();
                    }
                    function z(t1, e1) {
                        t1 && C.hasOwnProperty(t1.type) ? C[t1.type](t1, e1) : L(t1, e1);
                    }
                    var D, R, F, B, N, j = r(), U = r(), V = {
                        point: E,
                        lineStart: E,
                        lineEnd: E,
                        polygonStart: function() {
                            j.reset(), V.lineStart = H, V.lineEnd = q;
                        },
                        polygonEnd: function() {
                            var t1 = +j;
                            U.add(t1 < 0 ? u + t1 : t1), this.lineStart = this.lineEnd = this.point = E;
                        },
                        sphere: function() {
                            U.add(u);
                        }
                    };
                    function H() {
                        V.point = G;
                    }
                    function q() {
                        Y(D, R);
                    }
                    function G(t1, e1) {
                        V.point = Y, D = t1, R = e1, F = t1 *= h, B = g(e1 = (e1 *= h) / 2 + c), N = _(e1);
                    }
                    function Y(t1, e1) {
                        var r = (t1 *= h) - F, n = r >= 0 ? 1 : -1, i = n * r, a = g(e1 = (e1 *= h) / 2 + c), o = _(e1), s = N * o, l = B * a + s * g(i), u = s * n * _(i);
                        j.add(m(u, l)), F = t1, B = a, N = o;
                    }
                    function W(t1) {
                        return [
                            m(t1[1], t1[0]),
                            M(t1[2])
                        ];
                    }
                    function X(t1) {
                        var e1 = t1[0], r = t1[1], n = g(r);
                        return [
                            n * g(e1),
                            n * _(e1),
                            _(r)
                        ];
                    }
                    function Z(t1, e1) {
                        return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2];
                    }
                    function J(t1, e1) {
                        return [
                            t1[1] * e1[2] - t1[2] * e1[1],
                            t1[2] * e1[0] - t1[0] * e1[2],
                            t1[0] * e1[1] - t1[1] * e1[0]
                        ];
                    }
                    function K(t1, e1) {
                        t1[0] += e1[0], t1[1] += e1[1], t1[2] += e1[2];
                    }
                    function Q(t1, e1) {
                        return [
                            t1[0] * e1,
                            t1[1] * e1,
                            t1[2] * e1
                        ];
                    }
                    function $(t1) {
                        var e1 = T(t1[0] * t1[0] + t1[1] * t1[1] + t1[2] * t1[2]);
                        t1[0] /= e1, t1[1] /= e1, t1[2] /= e1;
                    }
                    var tt, et, rt, nt, it, at, ot, st, lt, ct, ut, ft, ht, pt, dt, mt, gt, vt, yt, xt, bt, _t, wt, Tt, kt, At, Mt = r(), St = {
                        point: Et,
                        lineStart: Ct,
                        lineEnd: Pt,
                        polygonStart: function() {
                            St.point = It, St.lineStart = Ot, St.lineEnd = zt, Mt.reset(), V.polygonStart();
                        },
                        polygonEnd: function() {
                            V.polygonEnd(), St.point = Et, St.lineStart = Ct, St.lineEnd = Pt, j < 0 ? (tt = -(rt = 180), et = -(nt = 90)) : Mt > o ? nt = 90 : Mt < -o && (et = -90), ct[0] = tt, ct[1] = rt;
                        },
                        sphere: function() {
                            tt = -(rt = 180), et = -(nt = 90);
                        }
                    };
                    function Et(t1, e1) {
                        lt.push(ct = [
                            tt = t1,
                            rt = t1
                        ]), e1 < et && (et = e1), e1 > nt && (nt = e1);
                    }
                    function Lt(t1, e1) {
                        var r = X([
                            t1 * h,
                            e1 * h
                        ]);
                        if (st) {
                            var n = J(st, r), i = J([
                                n[1],
                                -n[0],
                                0
                            ], n);
                            $(i), i = W(i);
                            var a, o = t1 - it, s = o > 0 ? 1 : -1, l = i[0] * f * s, c = p(o) > 180;
                            c ^ (s * it < l && l < s * t1) ? (a = i[1] * f) > nt && (nt = a) : c ^ (s * it < (l = (l + 360) % 360 - 180) && l < s * t1) ? (a = -i[1] * f) < et && (et = a) : (e1 < et && (et = e1), e1 > nt && (nt = e1)), c ? t1 < it ? Dt(tt, t1) > Dt(tt, rt) && (rt = t1) : Dt(t1, rt) > Dt(tt, rt) && (tt = t1) : rt >= tt ? (t1 < tt && (tt = t1), t1 > rt && (rt = t1)) : t1 > it ? Dt(tt, t1) > Dt(tt, rt) && (rt = t1) : Dt(t1, rt) > Dt(tt, rt) && (tt = t1);
                        } else lt.push(ct = [
                            tt = t1,
                            rt = t1
                        ]);
                        e1 < et && (et = e1), e1 > nt && (nt = e1), st = r, it = t1;
                    }
                    function Ct() {
                        St.point = Lt;
                    }
                    function Pt() {
                        ct[0] = tt, ct[1] = rt, St.point = Et, st = null;
                    }
                    function It(t1, e1) {
                        if (st) {
                            var r = t1 - it;
                            Mt.add(p(r) > 180 ? r + (r > 0 ? 360 : -360) : r);
                        } else at = t1, ot = e1;
                        V.point(t1, e1), Lt(t1, e1);
                    }
                    function Ot() {
                        V.lineStart();
                    }
                    function zt() {
                        It(at, ot), V.lineEnd(), p(Mt) > o && (tt = -(rt = 180)), ct[0] = tt, ct[1] = rt, st = null;
                    }
                    function Dt(t1, e1) {
                        return (e1 -= t1) < 0 ? e1 + 360 : e1;
                    }
                    function Rt(t1, e1) {
                        return t1[0] - e1[0];
                    }
                    function Ft(t1, e1) {
                        return t1[0] <= t1[1] ? t1[0] <= e1 && e1 <= t1[1] : e1 < t1[0] || t1[1] < e1;
                    }
                    var Bt = {
                        sphere: E,
                        point: Nt,
                        lineStart: Ut,
                        lineEnd: qt,
                        polygonStart: function() {
                            Bt.lineStart = Gt, Bt.lineEnd = Yt;
                        },
                        polygonEnd: function() {
                            Bt.lineStart = Ut, Bt.lineEnd = qt;
                        }
                    };
                    function Nt(t1, e1) {
                        t1 *= h;
                        var r = g(e1 *= h);
                        jt(r * g(t1), r * _(t1), _(e1));
                    }
                    function jt(t1, e1, r) {
                        ++ut, ht += (t1 - ht) / ut, pt += (e1 - pt) / ut, dt += (r - dt) / ut;
                    }
                    function Ut() {
                        Bt.point = Vt;
                    }
                    function Vt(t1, e1) {
                        t1 *= h;
                        var r = g(e1 *= h);
                        Tt = r * g(t1), kt = r * _(t1), At = _(e1), Bt.point = Ht, jt(Tt, kt, At);
                    }
                    function Ht(t1, e1) {
                        t1 *= h;
                        var r = g(e1 *= h), n = r * g(t1), i = r * _(t1), a = _(e1), o = m(T((o = kt * a - At * i) * o + (o = At * n - Tt * a) * o + (o = Tt * i - kt * n) * o), Tt * n + kt * i + At * a);
                        ft += o, mt += o * (Tt + (Tt = n)), gt += o * (kt + (kt = i)), vt += o * (At + (At = a)), jt(Tt, kt, At);
                    }
                    function qt() {
                        Bt.point = Nt;
                    }
                    function Gt() {
                        Bt.point = Wt;
                    }
                    function Yt() {
                        Xt(_t, wt), Bt.point = Nt;
                    }
                    function Wt(t1, e1) {
                        _t = t1, wt = e1, t1 *= h, e1 *= h, Bt.point = Xt;
                        var r = g(e1);
                        Tt = r * g(t1), kt = r * _(t1), At = _(e1), jt(Tt, kt, At);
                    }
                    function Xt(t1, e1) {
                        t1 *= h;
                        var r = g(e1 *= h), n = r * g(t1), i = r * _(t1), a = _(e1), o = kt * a - At * i, s = At * n - Tt * a, l = Tt * i - kt * n, c = T(o * o + s * s + l * l), u = M(c), f = c && -u / c;
                        yt += f * o, xt += f * s, bt += f * l, ft += u, mt += u * (Tt + (Tt = n)), gt += u * (kt + (kt = i)), vt += u * (At + (At = a)), jt(Tt, kt, At);
                    }
                    function Zt(t1) {
                        return function() {
                            return t1;
                        };
                    }
                    function Jt(t1, e1) {
                        function r(r, n) {
                            return r = t1(r, n), e1(r[0], r[1]);
                        }
                        return t1.invert && e1.invert && (r.invert = function(r, n) {
                            return (r = e1.invert(r, n)) && t1.invert(r[0], r[1]);
                        }), r;
                    }
                    function Kt(t1, e1) {
                        return [
                            p(t1) > s ? t1 + Math.round(-t1 / u) * u : t1,
                            e1
                        ];
                    }
                    function Qt(t1, e1, r) {
                        return (t1 %= u) ? e1 || r ? Jt(te(t1), ee(e1, r)) : te(t1) : e1 || r ? ee(e1, r) : Kt;
                    }
                    function $t(t1) {
                        return function(e1, r) {
                            return [
                                (e1 += t1) > s ? e1 - u : e1 < -s ? e1 + u : e1,
                                r
                            ];
                        };
                    }
                    function te(t1) {
                        var e1 = $t(t1);
                        return e1.invert = $t(-t1), e1;
                    }
                    function ee(t1, e1) {
                        var r = g(t1), n = _(t1), i = g(e1), a = _(e1);
                        function o(t1, e1) {
                            var o = g(e1), s = g(t1) * o, l = _(t1) * o, c = _(e1), u = c * r + s * n;
                            return [
                                m(l * i - u * a, s * r - c * n),
                                M(u * i + l * a)
                            ];
                        }
                        return o.invert = function(t1, e1) {
                            var o = g(e1), s = g(t1) * o, l = _(t1) * o, c = _(e1), u = c * i - l * a;
                            return [
                                m(l * i + c * a, s * r + u * n),
                                M(u * r - s * n)
                            ];
                        }, o;
                    }
                    function re(t1) {
                        function e1(e1) {
                            return (e1 = t1(e1[0] * h, e1[1] * h))[0] *= f, e1[1] *= f, e1;
                        }
                        return t1 = Qt(t1[0] * h, t1[1] * h, t1.length > 2 ? t1[2] * h : 0), e1.invert = function(e1) {
                            return (e1 = t1.invert(e1[0] * h, e1[1] * h))[0] *= f, e1[1] *= f, e1;
                        }, e1;
                    }
                    function ne(t1, e1, r, n, i, a) {
                        if (r) {
                            var o = g(e1), s = _(e1), l = n * r;
                            null == i ? (i = e1 + n * u, a = e1 - l / 2) : (i = ie(o, i), a = ie(o, a), (n > 0 ? i < a : i > a) && (i += n * u));
                            for(var c, f = i; n > 0 ? f > a : f < a; f -= l)c = W([
                                o,
                                -s * g(f),
                                -s * _(f)
                            ]), t1.point(c[0], c[1]);
                        }
                    }
                    function ie(t1, e1) {
                        (e1 = X(e1))[0] -= t1, $(e1);
                        var r = A(-e1[1]);
                        return ((-e1[2] < 0 ? -r : r) + u - o) % u;
                    }
                    function ae() {
                        var t1, e1 = [];
                        return {
                            point: function(e1, r, n) {
                                t1.push([
                                    e1,
                                    r,
                                    n
                                ]);
                            },
                            lineStart: function() {
                                e1.push(t1 = []);
                            },
                            lineEnd: E,
                            rejoin: function() {
                                e1.length > 1 && e1.push(e1.pop().concat(e1.shift()));
                            },
                            result: function() {
                                var r = e1;
                                return e1 = [], t1 = null, r;
                            }
                        };
                    }
                    function oe(t1, e1) {
                        return p(t1[0] - e1[0]) < o && p(t1[1] - e1[1]) < o;
                    }
                    function se(t1, e1, r, n) {
                        this.x = t1, this.z = e1, this.o = r, this.e = n, this.v = !1, this.n = this.p = null;
                    }
                    function le(t1, e1, r, n, i) {
                        var a, s, l = [], c = [];
                        if (t1.forEach(function(t1) {
                            if (!((e1 = t1.length - 1) <= 0)) {
                                var e1, r, n = t1[0], s = t1[e1];
                                if (oe(n, s)) {
                                    if (!n[2] && !s[2]) {
                                        for(i.lineStart(), a = 0; a < e1; ++a)i.point((n = t1[a])[0], n[1]);
                                        return void i.lineEnd();
                                    }
                                    s[0] += 2 * o;
                                }
                                l.push(r = new se(n, t1, null, !0)), c.push(r.o = new se(n, null, r, !1)), l.push(r = new se(s, t1, null, !1)), c.push(r.o = new se(s, null, r, !0));
                            }
                        }), l.length) {
                            for(c.sort(e1), ce(l), ce(c), a = 0, s = c.length; a < s; ++a)c[a].e = r = !r;
                            for(var u, f, h = l[0];;){
                                for(var p = h, d = !0; p.v;)if ((p = p.n) === h) return;
                                u = p.z, i.lineStart();
                                do {
                                    if (p.v = p.o.v = !0, p.e) {
                                        if (d) for(a = 0, s = u.length; a < s; ++a)i.point((f = u[a])[0], f[1]);
                                        else n(p.x, p.n.x, 1, i);
                                        p = p.n;
                                    } else {
                                        if (d) for(u = p.p.z, a = u.length - 1; a >= 0; --a)i.point((f = u[a])[0], f[1]);
                                        else n(p.x, p.p.x, -1, i);
                                        p = p.p;
                                    }
                                    u = (p = p.o).z, d = !d;
                                }while (!p.v);
                                i.lineEnd();
                            }
                        }
                    }
                    function ce(t1) {
                        if (e1 = t1.length) {
                            for(var e1, r, n = 0, i = t1[0]; ++n < e1;)i.n = r = t1[n], r.p = i, i = r;
                            i.n = r = t1[0], r.p = i;
                        }
                    }
                    Kt.invert = Kt;
                    var ue = r();
                    function fe(t1) {
                        return p(t1[0]) <= s ? t1[0] : w(t1[0]) * ((p(t1[0]) + s) % u - s);
                    }
                    function he(t1, e1) {
                        var r = fe(e1), n = e1[1], i = _(n), a = [
                            _(r),
                            -g(r),
                            0
                        ], f = 0, h = 0;
                        ue.reset(), 1 === i ? n = l + o : -1 === i && (n = -l - o);
                        for(var p = 0, d = t1.length; p < d; ++p)if (y = (v = t1[p]).length) for(var v, y, x = v[y - 1], b = fe(x), w = x[1] / 2 + c, T = _(w), k = g(w), A = 0; A < y; ++A, b = E, T = C, k = P, x = S){
                            var S = v[A], E = fe(S), L = S[1] / 2 + c, C = _(L), P = g(L), I = E - b, O = I >= 0 ? 1 : -1, z = O * I, D = z > s, R = T * C;
                            if (ue.add(m(R * O * _(z), k * P + R * g(z))), f += D ? I + O * u : I, D ^ b >= r ^ E >= r) {
                                var F = J(X(x), X(S));
                                $(F);
                                var B = J(a, F);
                                $(B);
                                var N = (D ^ I >= 0 ? -1 : 1) * M(B[2]);
                                (n > N || n === N && (F[0] || F[1])) && (h += D ^ I >= 0 ? 1 : -1);
                            }
                        }
                        return (f < -o || f < o && ue < -o) ^ 1 & h;
                    }
                    function pe(t1, r, n, i) {
                        return function(a) {
                            var o, s, l, c = r(a), u = ae(), f = r(u), h = !1, p = {
                                point: d,
                                lineStart: g,
                                lineEnd: v,
                                polygonStart: function() {
                                    p.point = y, p.lineStart = x, p.lineEnd = b, s = [], o = [];
                                },
                                polygonEnd: function() {
                                    p.point = d, p.lineStart = g, p.lineEnd = v, s = e1.merge(s);
                                    var t1 = he(o, i);
                                    s.length ? (h || (a.polygonStart(), h = !0), le(s, me, t1, n, a)) : t1 && (h || (a.polygonStart(), h = !0), a.lineStart(), n(null, null, 1, a), a.lineEnd()), h && (a.polygonEnd(), h = !1), s = o = null;
                                },
                                sphere: function() {
                                    a.polygonStart(), a.lineStart(), n(null, null, 1, a), a.lineEnd(), a.polygonEnd();
                                }
                            };
                            function d(e1, r) {
                                t1(e1, r) && a.point(e1, r);
                            }
                            function m(t1, e1) {
                                c.point(t1, e1);
                            }
                            function g() {
                                p.point = m, c.lineStart();
                            }
                            function v() {
                                p.point = d, c.lineEnd();
                            }
                            function y(t1, e1) {
                                l.push([
                                    t1,
                                    e1
                                ]), f.point(t1, e1);
                            }
                            function x() {
                                f.lineStart(), l = [];
                            }
                            function b() {
                                y(l[0][0], l[0][1]), f.lineEnd();
                                var t1, e1, r, n, i = f.clean(), c = u.result(), p = c.length;
                                if (l.pop(), o.push(l), l = null, p) {
                                    if (1 & i) {
                                        if ((e1 = (r = c[0]).length - 1) > 0) {
                                            for(h || (a.polygonStart(), h = !0), a.lineStart(), t1 = 0; t1 < e1; ++t1)a.point((n = r[t1])[0], n[1]);
                                            a.lineEnd();
                                        }
                                    } else p > 1 && 2 & i && c.push(c.pop().concat(c.shift())), s.push(c.filter(de));
                                }
                            }
                            return p;
                        };
                    }
                    function de(t1) {
                        return t1.length > 1;
                    }
                    function me(t1, e1) {
                        return ((t1 = t1.x)[0] < 0 ? t1[1] - l - o : l - t1[1]) - ((e1 = e1.x)[0] < 0 ? e1[1] - l - o : l - e1[1]);
                    }
                    var ge = pe(function() {
                        return !0;
                    }, function(t1) {
                        var e1, r = NaN, n = NaN, i = NaN;
                        return {
                            lineStart: function() {
                                t1.lineStart(), e1 = 1;
                            },
                            point: function(a, c) {
                                var u = a > 0 ? s : -s, f = p(a - r);
                                p(f - s) < o ? (t1.point(r, n = (n + c) / 2 > 0 ? l : -l), t1.point(i, n), t1.lineEnd(), t1.lineStart(), t1.point(u, n), t1.point(a, n), e1 = 0) : i !== u && f >= s && (p(r - i) < o && (r -= i * o), p(a - u) < o && (a -= u * o), n = function(t1, e1, r, n) {
                                    var i, a, s = _(t1 - r);
                                    return p(s) > o ? d((_(e1) * (a = g(n)) * _(r) - _(n) * (i = g(e1)) * _(t1)) / (i * a * s)) : (e1 + n) / 2;
                                }(r, n, a, c), t1.point(i, n), t1.lineEnd(), t1.lineStart(), t1.point(u, n), e1 = 0), t1.point(r = a, n = c), i = u;
                            },
                            lineEnd: function() {
                                t1.lineEnd(), r = n = NaN;
                            },
                            clean: function() {
                                return 2 - e1;
                            }
                        };
                    }, function(t1, e1, r, n) {
                        var i;
                        if (null == t1) i = r * l, n.point(-s, i), n.point(0, i), n.point(s, i), n.point(s, 0), n.point(s, -i), n.point(0, -i), n.point(-s, -i), n.point(-s, 0), n.point(-s, i);
                        else if (p(t1[0] - e1[0]) > o) {
                            var a = t1[0] < e1[0] ? s : -s;
                            i = r * a / 2, n.point(-a, i), n.point(0, i), n.point(a, i);
                        } else n.point(e1[0], e1[1]);
                    }, [
                        -s,
                        -l
                    ]);
                    function ve(t1) {
                        var e1 = g(t1), r = 6 * h, n = e1 > 0, i = p(e1) > o;
                        function a(t1, r) {
                            return g(t1) * g(r) > e1;
                        }
                        function l(t1, r, n) {
                            var i = [
                                1,
                                0,
                                0
                            ], a = J(X(t1), X(r)), l = Z(a, a), c = a[0], u = l - c * c;
                            if (!u) return !n && t1;
                            var f = e1 * l / u, h = -e1 * c / u, d = J(i, a), m = Q(i, f);
                            K(m, Q(a, h));
                            var g = d, v = Z(m, g), y = Z(g, g), x = v * v - y * (Z(m, m) - 1);
                            if (!(x < 0)) {
                                var b = T(x), _ = Q(g, (-v - b) / y);
                                if (K(_, m), _ = W(_), !n) return _;
                                var w, k = t1[0], A = r[0], M = t1[1], S = r[1];
                                A < k && (w = k, k = A, A = w);
                                var E = A - k, L = p(E - s) < o;
                                if (!L && S < M && (w = M, M = S, S = w), L || E < o ? L ? M + S > 0 ^ _[1] < (p(_[0] - k) < o ? M : S) : M <= _[1] && _[1] <= S : E > s ^ (k <= _[0] && _[0] <= A)) {
                                    var C = Q(g, (-v + b) / y);
                                    return K(C, m), [
                                        _,
                                        W(C)
                                    ];
                                }
                            }
                        }
                        function c(e1, r) {
                            var i = n ? t1 : s - t1, a = 0;
                            return e1 < -i ? a |= 1 : e1 > i && (a |= 2), r < -i ? a |= 4 : r > i && (a |= 8), a;
                        }
                        return pe(a, function(t1) {
                            var e1, r, o, u, f;
                            return {
                                lineStart: function() {
                                    u = o = !1, f = 1;
                                },
                                point: function(h, p) {
                                    var d, m = [
                                        h,
                                        p
                                    ], g = a(h, p), v = n ? g ? 0 : c(h, p) : g ? c(h + (h < 0 ? s : -s), p) : 0;
                                    if (!e1 && (u = o = g) && t1.lineStart(), g !== o && (!(d = l(e1, m)) || oe(e1, d) || oe(m, d)) && (m[2] = 1), g !== o) f = 0, g ? (t1.lineStart(), d = l(m, e1), t1.point(d[0], d[1])) : (d = l(e1, m), t1.point(d[0], d[1], 2), t1.lineEnd()), e1 = d;
                                    else if (i && e1 && n ^ g) {
                                        var y;
                                        v & r || !(y = l(m, e1, !0)) || (f = 0, n ? (t1.lineStart(), t1.point(y[0][0], y[0][1]), t1.point(y[1][0], y[1][1]), t1.lineEnd()) : (t1.point(y[1][0], y[1][1]), t1.lineEnd(), t1.lineStart(), t1.point(y[0][0], y[0][1], 3)));
                                    }
                                    !g || e1 && oe(e1, m) || t1.point(m[0], m[1]), e1 = m, o = g, r = v;
                                },
                                lineEnd: function() {
                                    o && t1.lineEnd(), e1 = null;
                                },
                                clean: function() {
                                    return f | (u && o) << 1;
                                }
                            };
                        }, function(e1, n, i, a) {
                            ne(a, t1, r, i, e1, n);
                        }, n ? [
                            0,
                            -t1
                        ] : [
                            -s,
                            t1 - s
                        ]);
                    }
                    function ye(t1, r, n, i) {
                        function a(e1, a) {
                            return t1 <= e1 && e1 <= n && r <= a && a <= i;
                        }
                        function s(e1, a, o, s) {
                            var c = 0, f = 0;
                            if (null == e1 || (c = l(e1, o)) !== (f = l(a, o)) || u(e1, a) < 0 ^ o > 0) do s.point(0 === c || 3 === c ? t1 : n, c > 1 ? i : r);
                            while ((c = (c + o + 4) % 4) !== f);
                            else s.point(a[0], a[1]);
                        }
                        function l(e1, i) {
                            return p(e1[0] - t1) < o ? i > 0 ? 0 : 3 : p(e1[0] - n) < o ? i > 0 ? 2 : 1 : p(e1[1] - r) < o ? i > 0 ? 1 : 0 : i > 0 ? 3 : 2;
                        }
                        function c(t1, e1) {
                            return u(t1.x, e1.x);
                        }
                        function u(t1, e1) {
                            var r = l(t1, 1), n = l(e1, 1);
                            return r !== n ? r - n : 0 === r ? e1[1] - t1[1] : 1 === r ? t1[0] - e1[0] : 2 === r ? t1[1] - e1[1] : e1[0] - t1[0];
                        }
                        return function(o) {
                            var l, u, f, h, p, d, m, g, v, y, x, b = o, _ = ae(), w = {
                                point: T,
                                lineStart: function() {
                                    w.point = k, u && u.push(f = []);
                                    y = !0, v = !1, m = g = NaN;
                                },
                                lineEnd: function() {
                                    l && (k(h, p), d && v && _.rejoin(), l.push(_.result()));
                                    w.point = T, v && b.lineEnd();
                                },
                                polygonStart: function() {
                                    b = _, l = [], u = [], x = !0;
                                },
                                polygonEnd: function() {
                                    var r = function() {
                                        for(var e1 = 0, r = 0, n = u.length; r < n; ++r)for(var a, o, s = u[r], l = 1, c = s.length, f = s[0], h = f[0], p = f[1]; l < c; ++l)a = h, o = p, f = s[l], h = f[0], p = f[1], o <= i ? p > i && (h - a) * (i - o) > (p - o) * (t1 - a) && ++e1 : p <= i && (h - a) * (i - o) < (p - o) * (t1 - a) && --e1;
                                        return e1;
                                    }(), n = x && r, a = (l = e1.merge(l)).length;
                                    (n || a) && (o.polygonStart(), n && (o.lineStart(), s(null, null, 1, o), o.lineEnd()), a && le(l, c, r, s, o), o.polygonEnd());
                                    b = o, l = u = f = null;
                                }
                            };
                            function T(t1, e1) {
                                a(t1, e1) && b.point(t1, e1);
                            }
                            function k(e1, o) {
                                var s = a(e1, o);
                                if (u && f.push([
                                    e1,
                                    o
                                ]), y) h = e1, p = o, d = s, y = !1, s && (b.lineStart(), b.point(e1, o));
                                else if (s && v) b.point(e1, o);
                                else {
                                    var l = [
                                        m = Math.max(-1000000000, Math.min(1e9, m)),
                                        g = Math.max(-1000000000, Math.min(1e9, g))
                                    ], c = [
                                        e1 = Math.max(-1000000000, Math.min(1e9, e1)),
                                        o = Math.max(-1000000000, Math.min(1e9, o))
                                    ];
                                    !function(t1, e1, r, n, i, a) {
                                        var o, s = t1[0], l = t1[1], c = 0, u = 1, f = e1[0] - s, h = e1[1] - l;
                                        if (o = r - s, f || !(o > 0)) {
                                            if (o /= f, f < 0) {
                                                if (o < c) return;
                                                o < u && (u = o);
                                            } else if (f > 0) {
                                                if (o > u) return;
                                                o > c && (c = o);
                                            }
                                            if (o = i - s, f || !(o < 0)) {
                                                if (o /= f, f < 0) {
                                                    if (o > u) return;
                                                    o > c && (c = o);
                                                } else if (f > 0) {
                                                    if (o < c) return;
                                                    o < u && (u = o);
                                                }
                                                if (o = n - l, h || !(o > 0)) {
                                                    if (o /= h, h < 0) {
                                                        if (o < c) return;
                                                        o < u && (u = o);
                                                    } else if (h > 0) {
                                                        if (o > u) return;
                                                        o > c && (c = o);
                                                    }
                                                    if (o = a - l, h || !(o < 0)) {
                                                        if (o /= h, h < 0) {
                                                            if (o > u) return;
                                                            o > c && (c = o);
                                                        } else if (h > 0) {
                                                            if (o < c) return;
                                                            o < u && (u = o);
                                                        }
                                                        return c > 0 && (t1[0] = s + c * f, t1[1] = l + c * h), u < 1 && (e1[0] = s + u * f, e1[1] = l + u * h), !0;
                                                    }
                                                }
                                            }
                                        }
                                    }(l, c, t1, r, n, i) ? s && (b.lineStart(), b.point(e1, o), x = !1) : (v || (b.lineStart(), b.point(l[0], l[1])), b.point(c[0], c[1]), s || b.lineEnd(), x = !1);
                                }
                                m = e1, g = o, v = s;
                            }
                            return w;
                        };
                    }
                    var xe, be, _e, we = r(), Te = {
                        sphere: E,
                        point: E,
                        lineStart: function() {
                            Te.point = Ae, Te.lineEnd = ke;
                        },
                        lineEnd: E,
                        polygonStart: E,
                        polygonEnd: E
                    };
                    function ke() {
                        Te.point = Te.lineEnd = E;
                    }
                    function Ae(t1, e1) {
                        xe = t1 *= h, be = _(e1 *= h), _e = g(e1), Te.point = Me;
                    }
                    function Me(t1, e1) {
                        t1 *= h;
                        var r = _(e1 *= h), n = g(e1), i = p(t1 - xe), a = g(i), o = n * _(i), s = _e * r - be * n * a, l = be * r + _e * n * a;
                        we.add(m(T(o * o + s * s), l)), xe = t1, be = r, _e = n;
                    }
                    function Se(t1) {
                        return we.reset(), z(t1, Te), +we;
                    }
                    var Ee = [
                        null,
                        null
                    ], Le = {
                        type: "LineString",
                        coordinates: Ee
                    };
                    function Ce(t1, e1) {
                        return Ee[0] = t1, Ee[1] = e1, Se(Le);
                    }
                    var Pe = {
                        Feature: function(t1, e1) {
                            return Oe(t1.geometry, e1);
                        },
                        FeatureCollection: function(t1, e1) {
                            for(var r = t1.features, n = -1, i = r.length; ++n < i;)if (Oe(r[n].geometry, e1)) return !0;
                            return !1;
                        }
                    }, Ie = {
                        Sphere: function() {
                            return !0;
                        },
                        Point: function(t1, e1) {
                            return ze(t1.coordinates, e1);
                        },
                        MultiPoint: function(t1, e1) {
                            for(var r = t1.coordinates, n = -1, i = r.length; ++n < i;)if (ze(r[n], e1)) return !0;
                            return !1;
                        },
                        LineString: function(t1, e1) {
                            return De(t1.coordinates, e1);
                        },
                        MultiLineString: function(t1, e1) {
                            for(var r = t1.coordinates, n = -1, i = r.length; ++n < i;)if (De(r[n], e1)) return !0;
                            return !1;
                        },
                        Polygon: function(t1, e1) {
                            return Re(t1.coordinates, e1);
                        },
                        MultiPolygon: function(t1, e1) {
                            for(var r = t1.coordinates, n = -1, i = r.length; ++n < i;)if (Re(r[n], e1)) return !0;
                            return !1;
                        },
                        GeometryCollection: function(t1, e1) {
                            for(var r = t1.geometries, n = -1, i = r.length; ++n < i;)if (Oe(r[n], e1)) return !0;
                            return !1;
                        }
                    };
                    function Oe(t1, e1) {
                        return !(!t1 || !Ie.hasOwnProperty(t1.type)) && Ie[t1.type](t1, e1);
                    }
                    function ze(t1, e1) {
                        return 0 === Ce(t1, e1);
                    }
                    function De(t1, e1) {
                        for(var r, n, i, a = 0, o = t1.length; a < o; a++){
                            if (0 === (n = Ce(t1[a], e1))) return !0;
                            if (a > 0 && (i = Ce(t1[a], t1[a - 1])) > 0 && r <= i && n <= i && (r + n - i) * (1 - Math.pow((r - n) / i, 2)) < 1e-12 * i) return !0;
                            r = n;
                        }
                        return !1;
                    }
                    function Re(t1, e1) {
                        return !!he(t1.map(Fe), Be(e1));
                    }
                    function Fe(t1) {
                        return (t1 = t1.map(Be)).pop(), t1;
                    }
                    function Be(t1) {
                        return [
                            t1[0] * h,
                            t1[1] * h
                        ];
                    }
                    function Ne(t1, r, n) {
                        var i = e1.range(t1, r - o, n).concat(r);
                        return function(t1) {
                            return i.map(function(e1) {
                                return [
                                    t1,
                                    e1
                                ];
                            });
                        };
                    }
                    function je(t1, r, n) {
                        var i = e1.range(t1, r - o, n).concat(r);
                        return function(t1) {
                            return i.map(function(e1) {
                                return [
                                    e1,
                                    t1
                                ];
                            });
                        };
                    }
                    function Ue() {
                        var t1, r, n, i, a, s, l, c, u, f, h, d, m = 10, g = m, y = 90, x = 360, b = 2.5;
                        function _() {
                            return {
                                type: "MultiLineString",
                                coordinates: w()
                            };
                        }
                        function w() {
                            return e1.range(v(i / y) * y, n, y).map(h).concat(e1.range(v(c / x) * x, l, x).map(d)).concat(e1.range(v(r / m) * m, t1, m).filter(function(t1) {
                                return p(t1 % y) > o;
                            }).map(u)).concat(e1.range(v(s / g) * g, a, g).filter(function(t1) {
                                return p(t1 % x) > o;
                            }).map(f));
                        }
                        return _.lines = function() {
                            return w().map(function(t1) {
                                return {
                                    type: "LineString",
                                    coordinates: t1
                                };
                            });
                        }, _.outline = function() {
                            return {
                                type: "Polygon",
                                coordinates: [
                                    h(i).concat(d(l).slice(1), h(n).reverse().slice(1), d(c).reverse().slice(1))
                                ]
                            };
                        }, _.extent = function(t1) {
                            return arguments.length ? _.extentMajor(t1).extentMinor(t1) : _.extentMinor();
                        }, _.extentMajor = function(t1) {
                            return arguments.length ? (i = +t1[0][0], n = +t1[1][0], c = +t1[0][1], l = +t1[1][1], i > n && (t1 = i, i = n, n = t1), c > l && (t1 = c, c = l, l = t1), _.precision(b)) : [
                                [
                                    i,
                                    c
                                ],
                                [
                                    n,
                                    l
                                ]
                            ];
                        }, _.extentMinor = function(e1) {
                            return arguments.length ? (r = +e1[0][0], t1 = +e1[1][0], s = +e1[0][1], a = +e1[1][1], r > t1 && (e1 = r, r = t1, t1 = e1), s > a && (e1 = s, s = a, a = e1), _.precision(b)) : [
                                [
                                    r,
                                    s
                                ],
                                [
                                    t1,
                                    a
                                ]
                            ];
                        }, _.step = function(t1) {
                            return arguments.length ? _.stepMajor(t1).stepMinor(t1) : _.stepMinor();
                        }, _.stepMajor = function(t1) {
                            return arguments.length ? (y = +t1[0], x = +t1[1], _) : [
                                y,
                                x
                            ];
                        }, _.stepMinor = function(t1) {
                            return arguments.length ? (m = +t1[0], g = +t1[1], _) : [
                                m,
                                g
                            ];
                        }, _.precision = function(e1) {
                            return arguments.length ? (b = +e1, u = Ne(s, a, 90), f = je(r, t1, b), h = Ne(c, l, 90), d = je(i, n, b), _) : b;
                        }, _.extentMajor([
                            [
                                -180,
                                -90 + o
                            ],
                            [
                                180,
                                90 - o
                            ]
                        ]).extentMinor([
                            [
                                -180,
                                -80 - o
                            ],
                            [
                                180,
                                80 + o
                            ]
                        ]);
                    }
                    function Ve(t1) {
                        return t1;
                    }
                    var He, qe, Ge, Ye, We = r(), Xe = r(), Ze = {
                        point: E,
                        lineStart: E,
                        lineEnd: E,
                        polygonStart: function() {
                            Ze.lineStart = Je, Ze.lineEnd = $e;
                        },
                        polygonEnd: function() {
                            Ze.lineStart = Ze.lineEnd = Ze.point = E, We.add(p(Xe)), Xe.reset();
                        },
                        result: function() {
                            var t1 = We / 2;
                            return We.reset(), t1;
                        }
                    };
                    function Je() {
                        Ze.point = Ke;
                    }
                    function Ke(t1, e1) {
                        Ze.point = Qe, He = Ge = t1, qe = Ye = e1;
                    }
                    function Qe(t1, e1) {
                        Xe.add(Ye * t1 - Ge * e1), Ge = t1, Ye = e1;
                    }
                    function $e() {
                        Qe(He, qe);
                    }
                    var tr = 1 / 0, er = tr, rr = -tr, nr = rr, ir = {
                        point: function(t1, e1) {
                            t1 < tr && (tr = t1);
                            t1 > rr && (rr = t1);
                            e1 < er && (er = e1);
                            e1 > nr && (nr = e1);
                        },
                        lineStart: E,
                        lineEnd: E,
                        polygonStart: E,
                        polygonEnd: E,
                        result: function() {
                            var t1 = [
                                [
                                    tr,
                                    er
                                ],
                                [
                                    rr,
                                    nr
                                ]
                            ];
                            return rr = nr = -(er = tr = 1 / 0), t1;
                        }
                    };
                    var ar, or, sr, lr, cr = 0, ur = 0, fr = 0, hr = 0, pr = 0, dr = 0, mr = 0, gr = 0, vr = 0, yr = {
                        point: xr,
                        lineStart: br,
                        lineEnd: Tr,
                        polygonStart: function() {
                            yr.lineStart = kr, yr.lineEnd = Ar;
                        },
                        polygonEnd: function() {
                            yr.point = xr, yr.lineStart = br, yr.lineEnd = Tr;
                        },
                        result: function() {
                            var t1 = vr ? [
                                mr / vr,
                                gr / vr
                            ] : dr ? [
                                hr / dr,
                                pr / dr
                            ] : fr ? [
                                cr / fr,
                                ur / fr
                            ] : [
                                NaN,
                                NaN
                            ];
                            return cr = ur = fr = hr = pr = dr = mr = gr = vr = 0, t1;
                        }
                    };
                    function xr(t1, e1) {
                        cr += t1, ur += e1, ++fr;
                    }
                    function br() {
                        yr.point = _r;
                    }
                    function _r(t1, e1) {
                        yr.point = wr, xr(sr = t1, lr = e1);
                    }
                    function wr(t1, e1) {
                        var r = t1 - sr, n = e1 - lr, i = T(r * r + n * n);
                        hr += i * (sr + t1) / 2, pr += i * (lr + e1) / 2, dr += i, xr(sr = t1, lr = e1);
                    }
                    function Tr() {
                        yr.point = xr;
                    }
                    function kr() {
                        yr.point = Mr;
                    }
                    function Ar() {
                        Sr(ar, or);
                    }
                    function Mr(t1, e1) {
                        yr.point = Sr, xr(ar = sr = t1, or = lr = e1);
                    }
                    function Sr(t1, e1) {
                        var r = t1 - sr, n = e1 - lr, i = T(r * r + n * n);
                        hr += i * (sr + t1) / 2, pr += i * (lr + e1) / 2, dr += i, mr += (i = lr * t1 - sr * e1) * (sr + t1), gr += i * (lr + e1), vr += 3 * i, xr(sr = t1, lr = e1);
                    }
                    function Er(t1) {
                        this._context = t1;
                    }
                    Er.prototype = {
                        _radius: 4.5,
                        pointRadius: function(t1) {
                            return this._radius = t1, this;
                        },
                        polygonStart: function() {
                            this._line = 0;
                        },
                        polygonEnd: function() {
                            this._line = NaN;
                        },
                        lineStart: function() {
                            this._point = 0;
                        },
                        lineEnd: function() {
                            0 === this._line && this._context.closePath(), this._point = NaN;
                        },
                        point: function(t1, e1) {
                            switch(this._point){
                                case 0:
                                    this._context.moveTo(t1, e1), this._point = 1;
                                    break;
                                case 1:
                                    this._context.lineTo(t1, e1);
                                    break;
                                default:
                                    this._context.moveTo(t1 + this._radius, e1), this._context.arc(t1, e1, this._radius, 0, u);
                            }
                        },
                        result: E
                    };
                    var Lr, Cr, Pr, Ir, Or, zr = r(), Dr = {
                        point: E,
                        lineStart: function() {
                            Dr.point = Rr;
                        },
                        lineEnd: function() {
                            Lr && Fr(Cr, Pr), Dr.point = E;
                        },
                        polygonStart: function() {
                            Lr = !0;
                        },
                        polygonEnd: function() {
                            Lr = null;
                        },
                        result: function() {
                            var t1 = +zr;
                            return zr.reset(), t1;
                        }
                    };
                    function Rr(t1, e1) {
                        Dr.point = Fr, Cr = Ir = t1, Pr = Or = e1;
                    }
                    function Fr(t1, e1) {
                        Ir -= t1, Or -= e1, zr.add(T(Ir * Ir + Or * Or)), Ir = t1, Or = e1;
                    }
                    function Br() {
                        this._string = [];
                    }
                    function Nr(t1) {
                        return "m0," + t1 + "a" + t1 + "," + t1 + " 0 1,1 0," + -2 * t1 + "a" + t1 + "," + t1 + " 0 1,1 0," + 2 * t1 + "z";
                    }
                    function jr(t1) {
                        return function(e1) {
                            var r = new Ur;
                            for(var n in t1)r[n] = t1[n];
                            return r.stream = e1, r;
                        };
                    }
                    function Ur() {}
                    function Vr(t1, e1, r) {
                        var n = t1.clipExtent && t1.clipExtent();
                        return t1.scale(150).translate([
                            0,
                            0
                        ]), null != n && t1.clipExtent(null), z(r, t1.stream(ir)), e1(ir.result()), null != n && t1.clipExtent(n), t1;
                    }
                    function Hr(t1, e1, r) {
                        return Vr(t1, function(r) {
                            var n = e1[1][0] - e1[0][0], i = e1[1][1] - e1[0][1], a = Math.min(n / (r[1][0] - r[0][0]), i / (r[1][1] - r[0][1])), o = +e1[0][0] + (n - a * (r[1][0] + r[0][0])) / 2, s = +e1[0][1] + (i - a * (r[1][1] + r[0][1])) / 2;
                            t1.scale(150 * a).translate([
                                o,
                                s
                            ]);
                        }, r);
                    }
                    function qr(t1, e1, r) {
                        return Hr(t1, [
                            [
                                0,
                                0
                            ],
                            e1
                        ], r);
                    }
                    function Gr(t1, e1, r) {
                        return Vr(t1, function(r) {
                            var n = +e1, i = n / (r[1][0] - r[0][0]), a = (n - i * (r[1][0] + r[0][0])) / 2, o = -i * r[0][1];
                            t1.scale(150 * i).translate([
                                a,
                                o
                            ]);
                        }, r);
                    }
                    function Yr(t1, e1, r) {
                        return Vr(t1, function(r) {
                            var n = +e1, i = n / (r[1][1] - r[0][1]), a = -i * r[0][0], o = (n - i * (r[1][1] + r[0][1])) / 2;
                            t1.scale(150 * i).translate([
                                a,
                                o
                            ]);
                        }, r);
                    }
                    Br.prototype = {
                        _radius: 4.5,
                        _circle: Nr(4.5),
                        pointRadius: function(t1) {
                            return (t1 = +t1) !== this._radius && (this._radius = t1, this._circle = null), this;
                        },
                        polygonStart: function() {
                            this._line = 0;
                        },
                        polygonEnd: function() {
                            this._line = NaN;
                        },
                        lineStart: function() {
                            this._point = 0;
                        },
                        lineEnd: function() {
                            0 === this._line && this._string.push("Z"), this._point = NaN;
                        },
                        point: function(t1, e1) {
                            switch(this._point){
                                case 0:
                                    this._string.push("M", t1, ",", e1), this._point = 1;
                                    break;
                                case 1:
                                    this._string.push("L", t1, ",", e1);
                                    break;
                                default:
                                    null == this._circle && (this._circle = Nr(this._radius)), this._string.push("M", t1, ",", e1, this._circle);
                            }
                        },
                        result: function() {
                            if (this._string.length) {
                                var t1 = this._string.join("");
                                return this._string = [], t1;
                            }
                            return null;
                        }
                    }, Ur.prototype = {
                        constructor: Ur,
                        point: function(t1, e1) {
                            this.stream.point(t1, e1);
                        },
                        sphere: function() {
                            this.stream.sphere();
                        },
                        lineStart: function() {
                            this.stream.lineStart();
                        },
                        lineEnd: function() {
                            this.stream.lineEnd();
                        },
                        polygonStart: function() {
                            this.stream.polygonStart();
                        },
                        polygonEnd: function() {
                            this.stream.polygonEnd();
                        }
                    };
                    var Wr = g(30 * h);
                    function Xr(t1, e1) {
                        return +e1 ? function(t1, e1) {
                            function r(n, i, a, s, l, c, u, f, h, d, g, v, y, x) {
                                var b = u - n, _ = f - i, w = b * b + _ * _;
                                if (w > 4 * e1 && y--) {
                                    var k = s + d, A = l + g, S = c + v, E = T(k * k + A * A + S * S), L = M(S /= E), C = p(p(S) - 1) < o || p(a - h) < o ? (a + h) / 2 : m(A, k), P = t1(C, L), I = P[0], O = P[1], z = I - n, D = O - i, R = _ * z - b * D;
                                    (R * R / w > e1 || p((b * z + _ * D) / w - .5) > .3 || s * d + l * g + c * v < Wr) && (r(n, i, a, s, l, c, I, O, C, k /= E, A /= E, S, y, x), x.point(I, O), r(I, O, C, k, A, S, u, f, h, d, g, v, y, x));
                                }
                            }
                            return function(e1) {
                                var n, i, a, o, s, l, c, u, f, h, p, d, m = {
                                    point: g,
                                    lineStart: v,
                                    lineEnd: x,
                                    polygonStart: function() {
                                        e1.polygonStart(), m.lineStart = b;
                                    },
                                    polygonEnd: function() {
                                        e1.polygonEnd(), m.lineStart = v;
                                    }
                                };
                                function g(r, n) {
                                    r = t1(r, n), e1.point(r[0], r[1]);
                                }
                                function v() {
                                    u = NaN, m.point = y, e1.lineStart();
                                }
                                function y(n, i) {
                                    var a = X([
                                        n,
                                        i
                                    ]), o = t1(n, i);
                                    r(u, f, c, h, p, d, u = o[0], f = o[1], c = n, h = a[0], p = a[1], d = a[2], 16, e1), e1.point(u, f);
                                }
                                function x() {
                                    m.point = g, e1.lineEnd();
                                }
                                function b() {
                                    v(), m.point = _, m.lineEnd = w;
                                }
                                function _(t1, e1) {
                                    y(n = t1, e1), i = u, a = f, o = h, s = p, l = d, m.point = y;
                                }
                                function w() {
                                    r(u, f, c, h, p, d, i, a, n, o, s, l, 16, e1), m.lineEnd = x, x();
                                }
                                return m;
                            };
                        }(t1, e1) : function(t1) {
                            return jr({
                                point: function(e1, r) {
                                    e1 = t1(e1, r), this.stream.point(e1[0], e1[1]);
                                }
                            });
                        }(t1);
                    }
                    var Zr = jr({
                        point: function(t1, e1) {
                            this.stream.point(t1 * h, e1 * h);
                        }
                    });
                    function Jr(t1, e1, r, n, i) {
                        function a(a, o) {
                            return [
                                e1 + t1 * (a *= n),
                                r - t1 * (o *= i)
                            ];
                        }
                        return a.invert = function(a, o) {
                            return [
                                (a - e1) / t1 * n,
                                (r - o) / t1 * i
                            ];
                        }, a;
                    }
                    function Kr(t1, e1, r, n, i, a) {
                        var o = g(a), s = _(a), l = o * t1, c = s * t1, u = o / t1, f = s / t1, h = (s * r - o * e1) / t1, p = (s * e1 + o * r) / t1;
                        function d(t1, a) {
                            return [
                                l * (t1 *= n) - c * (a *= i) + e1,
                                r - c * t1 - l * a
                            ];
                        }
                        return d.invert = function(t1, e1) {
                            return [
                                n * (u * t1 - f * e1 + h),
                                i * (p - f * t1 - u * e1)
                            ];
                        }, d;
                    }
                    function Qr(t1) {
                        return $r(function() {
                            return t1;
                        })();
                    }
                    function $r(t1) {
                        var e1, r, n, i, a, o, s, l, c, u, p = 150, d = 480, m = 250, g = 0, v = 0, y = 0, x = 0, b = 0, _ = 0, w = 1, k = 1, A = null, M = ge, S = null, E = Ve, L = .5;
                        function C(t1) {
                            return l(t1[0] * h, t1[1] * h);
                        }
                        function P(t1) {
                            return (t1 = l.invert(t1[0], t1[1])) && [
                                t1[0] * f,
                                t1[1] * f
                            ];
                        }
                        function I() {
                            var t1 = Kr(p, 0, 0, w, k, _).apply(null, e1(g, v)), n = (_ ? Kr : Jr)(p, d - t1[0], m - t1[1], w, k, _);
                            return r = Qt(y, x, b), s = Jt(e1, n), l = Jt(r, s), o = Xr(s, L), O();
                        }
                        function O() {
                            return c = u = null, C;
                        }
                        return C.stream = function(t1) {
                            return c && u === t1 ? c : c = Zr((function(t1) {
                                return jr({
                                    point: function(e1, r) {
                                        var n = t1(e1, r);
                                        return this.stream.point(n[0], n[1]);
                                    }
                                });
                            })(r)(M(o(E(u = t1)))));
                        }, C.preclip = function(t1) {
                            return arguments.length ? (M = t1, A = void 0, O()) : M;
                        }, C.postclip = function(t1) {
                            return arguments.length ? (E = t1, S = n = i = a = null, O()) : E;
                        }, C.clipAngle = function(t1) {
                            return arguments.length ? (M = +t1 ? ve(A = t1 * h) : (A = null, ge), O()) : A * f;
                        }, C.clipExtent = function(t1) {
                            return arguments.length ? (E = null == t1 ? (S = n = i = a = null, Ve) : ye(S = +t1[0][0], n = +t1[0][1], i = +t1[1][0], a = +t1[1][1]), O()) : null == S ? null : [
                                [
                                    S,
                                    n
                                ],
                                [
                                    i,
                                    a
                                ]
                            ];
                        }, C.scale = function(t1) {
                            return arguments.length ? (p = +t1, I()) : p;
                        }, C.translate = function(t1) {
                            return arguments.length ? (d = +t1[0], m = +t1[1], I()) : [
                                d,
                                m
                            ];
                        }, C.center = function(t1) {
                            return arguments.length ? (g = t1[0] % 360 * h, v = t1[1] % 360 * h, I()) : [
                                g * f,
                                v * f
                            ];
                        }, C.rotate = function(t1) {
                            return arguments.length ? (y = t1[0] % 360 * h, x = t1[1] % 360 * h, b = t1.length > 2 ? t1[2] % 360 * h : 0, I()) : [
                                y * f,
                                x * f,
                                b * f
                            ];
                        }, C.angle = function(t1) {
                            return arguments.length ? (_ = t1 % 360 * h, I()) : _ * f;
                        }, C.reflectX = function(t1) {
                            return arguments.length ? (w = t1 ? -1 : 1, I()) : w < 0;
                        }, C.reflectY = function(t1) {
                            return arguments.length ? (k = t1 ? -1 : 1, I()) : k < 0;
                        }, C.precision = function(t1) {
                            return arguments.length ? (o = Xr(s, L = t1 * t1), O()) : T(L);
                        }, C.fitExtent = function(t1, e1) {
                            return Hr(C, t1, e1);
                        }, C.fitSize = function(t1, e1) {
                            return qr(C, t1, e1);
                        }, C.fitWidth = function(t1, e1) {
                            return Gr(C, t1, e1);
                        }, C.fitHeight = function(t1, e1) {
                            return Yr(C, t1, e1);
                        }, function() {
                            return e1 = t1.apply(this, arguments), C.invert = e1.invert && P, I();
                        };
                    }
                    function tn(t1) {
                        var e1 = 0, r = s / 3, n = $r(t1), i = n(e1, r);
                        return i.parallels = function(t1) {
                            return arguments.length ? n(e1 = t1[0] * h, r = t1[1] * h) : [
                                e1 * f,
                                r * f
                            ];
                        }, i;
                    }
                    function en(t1, e1) {
                        var r = _(t1), n = (r + _(e1)) / 2;
                        if (p(n) < o) return function(t1) {
                            var e1 = g(t1);
                            function r(t1, r) {
                                return [
                                    t1 * e1,
                                    _(r) / e1
                                ];
                            }
                            return r.invert = function(t1, r) {
                                return [
                                    t1 / e1,
                                    M(r * e1)
                                ];
                            }, r;
                        }(t1);
                        var i = 1 + r * (2 * n - r), a = T(i) / n;
                        function l(t1, e1) {
                            var r = T(i - 2 * n * _(e1)) / n;
                            return [
                                r * _(t1 *= n),
                                a - r * g(t1)
                            ];
                        }
                        return l.invert = function(t1, e1) {
                            var r = a - e1, o = m(t1, p(r)) * w(r);
                            return r * n < 0 && (o -= s * w(t1) * w(r)), [
                                o / n,
                                M((i - (t1 * t1 + r * r) * n * n) / (2 * n))
                            ];
                        }, l;
                    }
                    function rn() {
                        return tn(en).scale(155.424).center([
                            0,
                            33.6442
                        ]);
                    }
                    function nn() {
                        return rn().parallels([
                            29.5,
                            45.5
                        ]).scale(1070).translate([
                            480,
                            250
                        ]).rotate([
                            96,
                            0
                        ]).center([
                            -0.6,
                            38.7
                        ]);
                    }
                    function an(t1) {
                        return function(e1, r) {
                            var n = g(e1), i = g(r), a = t1(n * i);
                            return [
                                a * i * _(e1),
                                a * _(r)
                            ];
                        };
                    }
                    function on(t1) {
                        return function(e1, r) {
                            var n = T(e1 * e1 + r * r), i = t1(n), a = _(i), o = g(i);
                            return [
                                m(e1 * a, n * o),
                                M(n && r * a / n)
                            ];
                        };
                    }
                    var sn = an(function(t1) {
                        return T(2 / (1 + t1));
                    });
                    sn.invert = on(function(t1) {
                        return 2 * M(t1 / 2);
                    });
                    var ln = an(function(t1) {
                        return (t1 = A(t1)) && t1 / _(t1);
                    });
                    function cn(t1, e1) {
                        return [
                            t1,
                            x(k((l + e1) / 2))
                        ];
                    }
                    function un(t1) {
                        var e1, r, n, i = Qr(t1), a = i.center, o = i.scale, l = i.translate, c = i.clipExtent, u = null;
                        function f() {
                            var a = s * o(), l = i(re(i.rotate()).invert([
                                0,
                                0
                            ]));
                            return c(null == u ? [
                                [
                                    l[0] - a,
                                    l[1] - a
                                ],
                                [
                                    l[0] + a,
                                    l[1] + a
                                ]
                            ] : t1 === cn ? [
                                [
                                    Math.max(l[0] - a, u),
                                    e1
                                ],
                                [
                                    Math.min(l[0] + a, r),
                                    n
                                ]
                            ] : [
                                [
                                    u,
                                    Math.max(l[1] - a, e1)
                                ],
                                [
                                    r,
                                    Math.min(l[1] + a, n)
                                ]
                            ]);
                        }
                        return i.scale = function(t1) {
                            return arguments.length ? (o(t1), f()) : o();
                        }, i.translate = function(t1) {
                            return arguments.length ? (l(t1), f()) : l();
                        }, i.center = function(t1) {
                            return arguments.length ? (a(t1), f()) : a();
                        }, i.clipExtent = function(t1) {
                            return arguments.length ? (null == t1 ? u = e1 = r = n = null : (u = +t1[0][0], e1 = +t1[0][1], r = +t1[1][0], n = +t1[1][1]), f()) : null == u ? null : [
                                [
                                    u,
                                    e1
                                ],
                                [
                                    r,
                                    n
                                ]
                            ];
                        }, f();
                    }
                    function fn(t1) {
                        return k((l + t1) / 2);
                    }
                    function hn(t1, e1) {
                        var r = g(t1), n = t1 === e1 ? _(t1) : x(r / g(e1)) / x(fn(e1) / fn(t1)), i = r * b(fn(t1), n) / n;
                        if (!n) return cn;
                        function a(t1, e1) {
                            i > 0 ? e1 < -l + o && (e1 = -l + o) : e1 > l - o && (e1 = l - o);
                            var r = i / b(fn(e1), n);
                            return [
                                r * _(n * t1),
                                i - r * g(n * t1)
                            ];
                        }
                        return a.invert = function(t1, e1) {
                            var r = i - e1, a = w(n) * T(t1 * t1 + r * r), o = m(t1, p(r)) * w(r);
                            return r * n < 0 && (o -= s * w(t1) * w(r)), [
                                o / n,
                                2 * d(b(i / a, 1 / n)) - l
                            ];
                        }, a;
                    }
                    function pn(t1, e1) {
                        return [
                            t1,
                            e1
                        ];
                    }
                    function dn(t1, e1) {
                        var r = g(t1), n = t1 === e1 ? _(t1) : (r - g(e1)) / (e1 - t1), i = r / n + t1;
                        if (p(n) < o) return pn;
                        function a(t1, e1) {
                            var r = i - e1, a = n * t1;
                            return [
                                r * _(a),
                                i - r * g(a)
                            ];
                        }
                        return a.invert = function(t1, e1) {
                            var r = i - e1, a = m(t1, p(r)) * w(r);
                            return r * n < 0 && (a -= s * w(t1) * w(r)), [
                                a / n,
                                i - w(n) * T(t1 * t1 + r * r)
                            ];
                        }, a;
                    }
                    ln.invert = on(function(t1) {
                        return t1;
                    }), cn.invert = function(t1, e1) {
                        return [
                            t1,
                            2 * d(y(e1)) - l
                        ];
                    }, pn.invert = pn;
                    var mn = 1.340264, gn = -0.081106, vn = 893e-6, yn = .003796, xn = T(3) / 2;
                    function bn(t1, e1) {
                        var r = M(xn * _(e1)), n = r * r, i = n * n * n;
                        return [
                            t1 * g(r) / (xn * (mn + 3 * gn * n + i * (7 * vn + 9 * yn * n))),
                            r * (mn + gn * n + i * (vn + yn * n))
                        ];
                    }
                    function _n(t1, e1) {
                        var r = g(e1), n = g(t1) * r;
                        return [
                            r * _(t1) / n,
                            _(e1) / n
                        ];
                    }
                    function wn(t1, e1) {
                        var r = e1 * e1, n = r * r;
                        return [
                            t1 * (.8707 - .131979 * r + n * (n * (.003971 * r - .001529 * n) - .013791)),
                            e1 * (1.007226 + r * (.015085 + n * (.028874 * r - .044475 - .005916 * n)))
                        ];
                    }
                    function Tn(t1, e1) {
                        return [
                            g(e1) * _(t1),
                            _(e1)
                        ];
                    }
                    function kn(t1, e1) {
                        var r = g(e1), n = 1 + g(t1) * r;
                        return [
                            r * _(t1) / n,
                            _(e1) / n
                        ];
                    }
                    function An(t1, e1) {
                        return [
                            x(k((l + e1) / 2)),
                            -t1
                        ];
                    }
                    bn.invert = function(t1, e1) {
                        for(var r, n = e1, i = n * n, a = i * i * i, o = 0; o < 12 && (a = (i = (n -= r = (n * (mn + gn * i + a * (vn + yn * i)) - e1) / (mn + 3 * gn * i + a * (7 * vn + 9 * yn * i))) * n) * i * i, !(p(r) < 1e-12)); ++o);
                        return [
                            xn * t1 * (mn + 3 * gn * i + a * (7 * vn + 9 * yn * i)) / g(n),
                            M(_(n) / xn)
                        ];
                    }, _n.invert = on(d), wn.invert = function(t1, e1) {
                        var r, n = e1, i = 25;
                        do {
                            var a = n * n, s = a * a;
                            n -= r = (n * (1.007226 + a * (.015085 + s * (.028874 * a - .044475 - .005916 * s))) - e1) / (1.007226 + a * (.045255 + s * (.259866 * a - .311325 - .005916 * 11 * s)));
                        }while (p(r) > o && --i > 0);
                        return [
                            t1 / (.8707 + (a = n * n) * (a * (a * a * a * (.003971 - .001529 * a) - .013791) - .131979)),
                            n
                        ];
                    }, Tn.invert = on(M), kn.invert = on(function(t1) {
                        return 2 * d(t1);
                    }), An.invert = function(t1, e1) {
                        return [
                            -e1,
                            2 * d(y(t1)) - l
                        ];
                    }, t1.geoAlbers = nn, t1.geoAlbersUsa = function() {
                        var t1, e1, r, n, i, a, s = nn(), l = rn().rotate([
                            154,
                            0
                        ]).center([
                            -2,
                            58.5
                        ]).parallels([
                            55,
                            65
                        ]), c = rn().rotate([
                            157,
                            0
                        ]).center([
                            -3,
                            19.9
                        ]).parallels([
                            8,
                            18
                        ]), u = {
                            point: function(t1, e1) {
                                a = [
                                    t1,
                                    e1
                                ];
                            }
                        };
                        function f(t1) {
                            var e1 = t1[0], o = t1[1];
                            return a = null, r.point(e1, o), a || (n.point(e1, o), a) || (i.point(e1, o), a);
                        }
                        function h() {
                            return t1 = e1 = null, f;
                        }
                        return f.invert = function(t1) {
                            var e1 = s.scale(), r = s.translate(), n = (t1[0] - r[0]) / e1, i = (t1[1] - r[1]) / e1;
                            return (i >= .12 && i < .234 && n >= -0.425 && n < -0.214 ? l : i >= .166 && i < .234 && n >= -0.214 && n < -0.115 ? c : s).invert(t1);
                        }, f.stream = function(r) {
                            var n, i;
                            return t1 && e1 === r ? t1 : (n = [
                                s.stream(e1 = r),
                                l.stream(r),
                                c.stream(r)
                            ], i = n.length, t1 = {
                                point: function(t1, e1) {
                                    for(var r = -1; ++r < i;)n[r].point(t1, e1);
                                },
                                sphere: function() {
                                    for(var t1 = -1; ++t1 < i;)n[t1].sphere();
                                },
                                lineStart: function() {
                                    for(var t1 = -1; ++t1 < i;)n[t1].lineStart();
                                },
                                lineEnd: function() {
                                    for(var t1 = -1; ++t1 < i;)n[t1].lineEnd();
                                },
                                polygonStart: function() {
                                    for(var t1 = -1; ++t1 < i;)n[t1].polygonStart();
                                },
                                polygonEnd: function() {
                                    for(var t1 = -1; ++t1 < i;)n[t1].polygonEnd();
                                }
                            });
                        }, f.precision = function(t1) {
                            return arguments.length ? (s.precision(t1), l.precision(t1), c.precision(t1), h()) : s.precision();
                        }, f.scale = function(t1) {
                            return arguments.length ? (s.scale(t1), l.scale(.35 * t1), c.scale(t1), f.translate(s.translate())) : s.scale();
                        }, f.translate = function(t1) {
                            if (!arguments.length) return s.translate();
                            var e1 = s.scale(), a = +t1[0], f = +t1[1];
                            return r = s.translate(t1).clipExtent([
                                [
                                    a - .455 * e1,
                                    f - .238 * e1
                                ],
                                [
                                    a + .455 * e1,
                                    f + .238 * e1
                                ]
                            ]).stream(u), n = l.translate([
                                a - .307 * e1,
                                f + .201 * e1
                            ]).clipExtent([
                                [
                                    a - .425 * e1 + o,
                                    f + .12 * e1 + o
                                ],
                                [
                                    a - .214 * e1 - o,
                                    f + .234 * e1 - o
                                ]
                            ]).stream(u), i = c.translate([
                                a - .205 * e1,
                                f + .212 * e1
                            ]).clipExtent([
                                [
                                    a - .214 * e1 + o,
                                    f + .166 * e1 + o
                                ],
                                [
                                    a - .115 * e1 - o,
                                    f + .234 * e1 - o
                                ]
                            ]).stream(u), h();
                        }, f.fitExtent = function(t1, e1) {
                            return Hr(f, t1, e1);
                        }, f.fitSize = function(t1, e1) {
                            return qr(f, t1, e1);
                        }, f.fitWidth = function(t1, e1) {
                            return Gr(f, t1, e1);
                        }, f.fitHeight = function(t1, e1) {
                            return Yr(f, t1, e1);
                        }, f.scale(1070);
                    }, t1.geoArea = function(t1) {
                        return U.reset(), z(t1, V), 2 * U;
                    }, t1.geoAzimuthalEqualArea = function() {
                        return Qr(sn).scale(124.75).clipAngle(179.999);
                    }, t1.geoAzimuthalEqualAreaRaw = sn, t1.geoAzimuthalEquidistant = function() {
                        return Qr(ln).scale(79.4188).clipAngle(179.999);
                    }, t1.geoAzimuthalEquidistantRaw = ln, t1.geoBounds = function(t1) {
                        var e1, r, n, i, a, o, s;
                        if (nt = rt = -(tt = et = 1 / 0), lt = [], z(t1, St), r = lt.length) {
                            for(lt.sort(Rt), e1 = 1, a = [
                                n = lt[0]
                            ]; e1 < r; ++e1)Ft(n, (i = lt[e1])[0]) || Ft(n, i[1]) ? (Dt(n[0], i[1]) > Dt(n[0], n[1]) && (n[1] = i[1]), Dt(i[0], n[1]) > Dt(n[0], n[1]) && (n[0] = i[0])) : a.push(n = i);
                            for(o = -1 / 0, e1 = 0, n = a[r = a.length - 1]; e1 <= r; n = i, ++e1)i = a[e1], (s = Dt(n[1], i[0])) > o && (o = s, tt = i[0], rt = n[1]);
                        }
                        return lt = ct = null, tt === 1 / 0 || et === 1 / 0 ? [
                            [
                                NaN,
                                NaN
                            ],
                            [
                                NaN,
                                NaN
                            ]
                        ] : [
                            [
                                tt,
                                et
                            ],
                            [
                                rt,
                                nt
                            ]
                        ];
                    }, t1.geoCentroid = function(t1) {
                        ut = ft = ht = pt = dt = mt = gt = vt = yt = xt = bt = 0, z(t1, Bt);
                        var e1 = yt, r = xt, n = bt, i = e1 * e1 + r * r + n * n;
                        return i < 1e-12 && (e1 = mt, r = gt, n = vt, ft < o && (e1 = ht, r = pt, n = dt), (i = e1 * e1 + r * r + n * n) < 1e-12) ? [
                            NaN,
                            NaN
                        ] : [
                            m(r, e1) * f,
                            M(n / T(i)) * f
                        ];
                    }, t1.geoCircle = function() {
                        var t1, e1, r = Zt([
                            0,
                            0
                        ]), n = Zt(90), i = Zt(6), a = {
                            point: function(r, n) {
                                t1.push(r = e1(r, n)), r[0] *= f, r[1] *= f;
                            }
                        };
                        function o() {
                            var o = r.apply(this, arguments), s = n.apply(this, arguments) * h, l = i.apply(this, arguments) * h;
                            return t1 = [], e1 = Qt(-o[0] * h, -o[1] * h, 0).invert, ne(a, s, l, 1), o = {
                                type: "Polygon",
                                coordinates: [
                                    t1
                                ]
                            }, t1 = e1 = null, o;
                        }
                        return o.center = function(t1) {
                            return arguments.length ? (r = "function" == typeof t1 ? t1 : Zt([
                                +t1[0],
                                +t1[1]
                            ]), o) : r;
                        }, o.radius = function(t1) {
                            return arguments.length ? (n = "function" == typeof t1 ? t1 : Zt(+t1), o) : n;
                        }, o.precision = function(t1) {
                            return arguments.length ? (i = "function" == typeof t1 ? t1 : Zt(+t1), o) : i;
                        }, o;
                    }, t1.geoClipAntimeridian = ge, t1.geoClipCircle = ve, t1.geoClipExtent = function() {
                        var t1, e1, r, n = 0, i = 0, a = 960, o = 500;
                        return r = {
                            stream: function(r) {
                                return t1 && e1 === r ? t1 : t1 = ye(n, i, a, o)(e1 = r);
                            },
                            extent: function(s) {
                                return arguments.length ? (n = +s[0][0], i = +s[0][1], a = +s[1][0], o = +s[1][1], t1 = e1 = null, r) : [
                                    [
                                        n,
                                        i
                                    ],
                                    [
                                        a,
                                        o
                                    ]
                                ];
                            }
                        };
                    }, t1.geoClipRectangle = ye, t1.geoConicConformal = function() {
                        return tn(hn).scale(109.5).parallels([
                            30,
                            30
                        ]);
                    }, t1.geoConicConformalRaw = hn, t1.geoConicEqualArea = rn, t1.geoConicEqualAreaRaw = en, t1.geoConicEquidistant = function() {
                        return tn(dn).scale(131.154).center([
                            0,
                            13.9389
                        ]);
                    }, t1.geoConicEquidistantRaw = dn, t1.geoContains = function(t1, e1) {
                        return (t1 && Pe.hasOwnProperty(t1.type) ? Pe[t1.type] : Oe)(t1, e1);
                    }, t1.geoDistance = Ce, t1.geoEqualEarth = function() {
                        return Qr(bn).scale(177.158);
                    }, t1.geoEqualEarthRaw = bn, t1.geoEquirectangular = function() {
                        return Qr(pn).scale(152.63);
                    }, t1.geoEquirectangularRaw = pn, t1.geoGnomonic = function() {
                        return Qr(_n).scale(144.049).clipAngle(60);
                    }, t1.geoGnomonicRaw = _n, t1.geoGraticule = Ue, t1.geoGraticule10 = function() {
                        return Ue()();
                    }, t1.geoIdentity = function() {
                        var t1, e1, r, n, i, a, o, s = 1, l = 0, c = 0, u = 1, p = 1, d = 0, m = null, v = 1, y = 1, x = jr({
                            point: function(t1, e1) {
                                var r = T([
                                    t1,
                                    e1
                                ]);
                                this.stream.point(r[0], r[1]);
                            }
                        }), b = Ve;
                        function w() {
                            return v = s * u, y = s * p, a = o = null, T;
                        }
                        function T(r) {
                            var n = r[0] * v, i = r[1] * y;
                            if (d) {
                                var a = i * t1 - n * e1;
                                n = n * t1 + i * e1, i = a;
                            }
                            return [
                                n + l,
                                i + c
                            ];
                        }
                        return T.invert = function(r) {
                            var n = r[0] - l, i = r[1] - c;
                            if (d) {
                                var a = i * t1 + n * e1;
                                n = n * t1 - i * e1, i = a;
                            }
                            return [
                                n / v,
                                i / y
                            ];
                        }, T.stream = function(t1) {
                            return a && o === t1 ? a : a = x(b(o = t1));
                        }, T.postclip = function(t1) {
                            return arguments.length ? (b = t1, m = r = n = i = null, w()) : b;
                        }, T.clipExtent = function(t1) {
                            return arguments.length ? (b = null == t1 ? (m = r = n = i = null, Ve) : ye(m = +t1[0][0], r = +t1[0][1], n = +t1[1][0], i = +t1[1][1]), w()) : null == m ? null : [
                                [
                                    m,
                                    r
                                ],
                                [
                                    n,
                                    i
                                ]
                            ];
                        }, T.scale = function(t1) {
                            return arguments.length ? (s = +t1, w()) : s;
                        }, T.translate = function(t1) {
                            return arguments.length ? (l = +t1[0], c = +t1[1], w()) : [
                                l,
                                c
                            ];
                        }, T.angle = function(r) {
                            return arguments.length ? (e1 = _(d = r % 360 * h), t1 = g(d), w()) : d * f;
                        }, T.reflectX = function(t1) {
                            return arguments.length ? (u = t1 ? -1 : 1, w()) : u < 0;
                        }, T.reflectY = function(t1) {
                            return arguments.length ? (p = t1 ? -1 : 1, w()) : p < 0;
                        }, T.fitExtent = function(t1, e1) {
                            return Hr(T, t1, e1);
                        }, T.fitSize = function(t1, e1) {
                            return qr(T, t1, e1);
                        }, T.fitWidth = function(t1, e1) {
                            return Gr(T, t1, e1);
                        }, T.fitHeight = function(t1, e1) {
                            return Yr(T, t1, e1);
                        }, T;
                    }, t1.geoInterpolate = function(t1, e1) {
                        var r = t1[0] * h, n = t1[1] * h, i = e1[0] * h, a = e1[1] * h, o = g(n), s = _(n), l = g(a), c = _(a), u = o * g(r), p = o * _(r), d = l * g(i), v = l * _(i), y = 2 * M(T(S(a - n) + o * l * S(i - r))), x = _(y), b = y ? function(t1) {
                            var e1 = _(t1 *= y) / x, r = _(y - t1) / x, n = r * u + e1 * d, i = r * p + e1 * v, a = r * s + e1 * c;
                            return [
                                m(i, n) * f,
                                m(a, T(n * n + i * i)) * f
                            ];
                        } : function() {
                            return [
                                r * f,
                                n * f
                            ];
                        };
                        return b.distance = y, b;
                    }, t1.geoLength = Se, t1.geoMercator = function() {
                        return un(cn).scale(961 / u);
                    }, t1.geoMercatorRaw = cn, t1.geoNaturalEarth1 = function() {
                        return Qr(wn).scale(175.295);
                    }, t1.geoNaturalEarth1Raw = wn, t1.geoOrthographic = function() {
                        return Qr(Tn).scale(249.5).clipAngle(90 + o);
                    }, t1.geoOrthographicRaw = Tn, t1.geoPath = function(t1, e1) {
                        var r, n, i = 4.5;
                        function a(t1) {
                            return t1 && ("function" == typeof i && n.pointRadius(+i.apply(this, arguments)), z(t1, r(n))), n.result();
                        }
                        return a.area = function(t1) {
                            return z(t1, r(Ze)), Ze.result();
                        }, a.measure = function(t1) {
                            return z(t1, r(Dr)), Dr.result();
                        }, a.bounds = function(t1) {
                            return z(t1, r(ir)), ir.result();
                        }, a.centroid = function(t1) {
                            return z(t1, r(yr)), yr.result();
                        }, a.projection = function(e1) {
                            return arguments.length ? (r = null == e1 ? (t1 = null, Ve) : (t1 = e1).stream, a) : t1;
                        }, a.context = function(t1) {
                            return arguments.length ? (n = null == t1 ? (e1 = null, new Br) : new Er(e1 = t1), "function" != typeof i && n.pointRadius(i), a) : e1;
                        }, a.pointRadius = function(t1) {
                            return arguments.length ? (i = "function" == typeof t1 ? t1 : (n.pointRadius(+t1), +t1), a) : i;
                        }, a.projection(t1).context(e1);
                    }, t1.geoProjection = Qr, t1.geoProjectionMutator = $r, t1.geoRotation = re, t1.geoStereographic = function() {
                        return Qr(kn).scale(250).clipAngle(142);
                    }, t1.geoStereographicRaw = kn, t1.geoStream = z, t1.geoTransform = function(t1) {
                        return {
                            stream: jr(t1)
                        };
                    }, t1.geoTransverseMercator = function() {
                        var t1 = un(An), e1 = t1.center, r = t1.rotate;
                        return t1.center = function(t1) {
                            return arguments.length ? e1([
                                -t1[1],
                                t1[0]
                            ]) : [
                                (t1 = e1())[1],
                                -t1[0]
                            ];
                        }, t1.rotate = function(t1) {
                            return arguments.length ? r([
                                t1[0],
                                t1[1],
                                t1.length > 2 ? t1[2] + 90 : 90
                            ]) : [
                                (t1 = r())[0],
                                t1[1],
                                t1[2] - 90
                            ];
                        }, r([
                            0,
                            0,
                            90
                        ]).scale(159.155);
                    }, t1.geoTransverseMercatorRaw = An, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {
                "d3-array": 107
            }
        ],
        115: [
            function(t1, e1, r) {
                !function(t1, n) {
                    "object" == typeof r && void 0 !== e1 ? n(r) : n((t1 = t1 || self).d3 = t1.d3 || {});
                }(this, function(t1) {
                    "use strict";
                    function e1(t1, e1) {
                        return t1.parent === e1.parent ? 1 : 2;
                    }
                    function r(t1, e1) {
                        return t1 + e1.x;
                    }
                    function n(t1, e1) {
                        return Math.max(t1, e1.y);
                    }
                    function i(t1) {
                        var e1 = 0, r = t1.children, n = r && r.length;
                        if (n) for(; --n >= 0;)e1 += r[n].value;
                        else e1 = 1;
                        t1.value = e1;
                    }
                    function a(t1, e1) {
                        var r, n, i, a, s, u = new c(t1), f = +t1.value && (u.value = t1.value), h = [
                            u
                        ];
                        for(null == e1 && (e1 = o); r = h.pop();)if (f && (r.value = +r.data.value), (i = e1(r.data)) && (s = i.length)) for(r.children = new Array(s), a = s - 1; a >= 0; --a)h.push(n = r.children[a] = new c(i[a])), n.parent = r, n.depth = r.depth + 1;
                        return u.eachBefore(l);
                    }
                    function o(t1) {
                        return t1.children;
                    }
                    function s(t1) {
                        t1.data = t1.data.data;
                    }
                    function l(t1) {
                        var e1 = 0;
                        do t1.height = e1;
                        while ((t1 = t1.parent) && t1.height < ++e1);
                    }
                    function c(t1) {
                        this.data = t1, this.depth = this.height = 0, this.parent = null;
                    }
                    c.prototype = a.prototype = {
                        constructor: c,
                        count: function() {
                            return this.eachAfter(i);
                        },
                        each: function(t1) {
                            var e1, r, n, i, a = this, o = [
                                a
                            ];
                            do {
                                for(e1 = o.reverse(), o = []; a = e1.pop();)if (t1(a), r = a.children) for(n = 0, i = r.length; n < i; ++n)o.push(r[n]);
                            }while (o.length);
                            return this;
                        },
                        eachAfter: function(t1) {
                            for(var e1, r, n, i = this, a = [
                                i
                            ], o = []; i = a.pop();)if (o.push(i), e1 = i.children) for(r = 0, n = e1.length; r < n; ++r)a.push(e1[r]);
                            for(; i = o.pop();)t1(i);
                            return this;
                        },
                        eachBefore: function(t1) {
                            for(var e1, r, n = this, i = [
                                n
                            ]; n = i.pop();)if (t1(n), e1 = n.children) for(r = e1.length - 1; r >= 0; --r)i.push(e1[r]);
                            return this;
                        },
                        sum: function(t1) {
                            return this.eachAfter(function(e1) {
                                for(var r = +t1(e1.data) || 0, n = e1.children, i = n && n.length; --i >= 0;)r += n[i].value;
                                e1.value = r;
                            });
                        },
                        sort: function(t1) {
                            return this.eachBefore(function(e1) {
                                e1.children && e1.children.sort(t1);
                            });
                        },
                        path: function(t1) {
                            for(var e1 = this, r = function(t1, e1) {
                                if (t1 === e1) return t1;
                                var r = t1.ancestors(), n = e1.ancestors(), i = null;
                                t1 = r.pop(), e1 = n.pop();
                                for(; t1 === e1;)i = t1, t1 = r.pop(), e1 = n.pop();
                                return i;
                            }(e1, t1), n = [
                                e1
                            ]; e1 !== r;)e1 = e1.parent, n.push(e1);
                            for(var i = n.length; t1 !== r;)n.splice(i, 0, t1), t1 = t1.parent;
                            return n;
                        },
                        ancestors: function() {
                            for(var t1 = this, e1 = [
                                t1
                            ]; t1 = t1.parent;)e1.push(t1);
                            return e1;
                        },
                        descendants: function() {
                            var t1 = [];
                            return this.each(function(e1) {
                                t1.push(e1);
                            }), t1;
                        },
                        leaves: function() {
                            var t1 = [];
                            return this.eachBefore(function(e1) {
                                e1.children || t1.push(e1);
                            }), t1;
                        },
                        links: function() {
                            var t1 = this, e1 = [];
                            return t1.each(function(r) {
                                r !== t1 && e1.push({
                                    source: r.parent,
                                    target: r
                                });
                            }), e1;
                        },
                        copy: function() {
                            return a(this).eachBefore(s);
                        }
                    };
                    var u = Array.prototype.slice;
                    function f(t1) {
                        for(var e1, r, n = 0, i = (t1 = function(t1) {
                            for(var e1, r, n = t1.length; n;)r = Math.random() * n-- | 0, e1 = t1[n], t1[n] = t1[r], t1[r] = e1;
                            return t1;
                        }(u.call(t1))).length, a = []; n < i;)e1 = t1[n], r && d(r, e1) ? ++n : (r = g(a = h(a, e1)), n = 0);
                        return r;
                    }
                    function h(t1, e1) {
                        var r, n;
                        if (m(e1, t1)) return [
                            e1
                        ];
                        for(r = 0; r < t1.length; ++r)if (p(e1, t1[r]) && m(v(t1[r], e1), t1)) return [
                            t1[r],
                            e1
                        ];
                        for(r = 0; r < t1.length - 1; ++r)for(n = r + 1; n < t1.length; ++n)if (p(v(t1[r], t1[n]), e1) && p(v(t1[r], e1), t1[n]) && p(v(t1[n], e1), t1[r]) && m(y(t1[r], t1[n], e1), t1)) return [
                            t1[r],
                            t1[n],
                            e1
                        ];
                        throw new Error;
                    }
                    function p(t1, e1) {
                        var r = t1.r - e1.r, n = e1.x - t1.x, i = e1.y - t1.y;
                        return r < 0 || r * r < n * n + i * i;
                    }
                    function d(t1, e1) {
                        var r = t1.r - e1.r + 1e-6, n = e1.x - t1.x, i = e1.y - t1.y;
                        return r > 0 && r * r > n * n + i * i;
                    }
                    function m(t1, e1) {
                        for(var r = 0; r < e1.length; ++r)if (!d(t1, e1[r])) return !1;
                        return !0;
                    }
                    function g(t1) {
                        switch(t1.length){
                            case 1:
                                return {
                                    x: (e1 = t1[0]).x,
                                    y: e1.y,
                                    r: e1.r
                                };
                            case 2:
                                return v(t1[0], t1[1]);
                            case 3:
                                return y(t1[0], t1[1], t1[2]);
                        }
                        var e1;
                    }
                    function v(t1, e1) {
                        var r = t1.x, n = t1.y, i = t1.r, a = e1.x, o = e1.y, s = e1.r, l = a - r, c = o - n, u = s - i, f = Math.sqrt(l * l + c * c);
                        return {
                            x: (r + a + l / f * u) / 2,
                            y: (n + o + c / f * u) / 2,
                            r: (f + i + s) / 2
                        };
                    }
                    function y(t1, e1, r) {
                        var n = t1.x, i = t1.y, a = t1.r, o = e1.x, s = e1.y, l = e1.r, c = r.x, u = r.y, f = r.r, h = n - o, p = n - c, d = i - s, m = i - u, g = l - a, v = f - a, y = n * n + i * i - a * a, x = y - o * o - s * s + l * l, b = y - c * c - u * u + f * f, _ = p * d - h * m, w = (d * b - m * x) / (2 * _) - n, T = (m * g - d * v) / _, k = (p * x - h * b) / (2 * _) - i, A = (h * v - p * g) / _, M = T * T + A * A - 1, S = 2 * (a + w * T + k * A), E = w * w + k * k - a * a, L = -(M ? (S + Math.sqrt(S * S - 4 * M * E)) / (2 * M) : E / S);
                        return {
                            x: n + w + T * L,
                            y: i + k + A * L,
                            r: L
                        };
                    }
                    function x(t1, e1, r) {
                        var n, i, a, o, s = t1.x - e1.x, l = t1.y - e1.y, c = s * s + l * l;
                        c ? (i = e1.r + r.r, i *= i, o = t1.r + r.r, i > (o *= o) ? (n = (c + o - i) / (2 * c), a = Math.sqrt(Math.max(0, o / c - n * n)), r.x = t1.x - n * s - a * l, r.y = t1.y - n * l + a * s) : (n = (c + i - o) / (2 * c), a = Math.sqrt(Math.max(0, i / c - n * n)), r.x = e1.x + n * s - a * l, r.y = e1.y + n * l + a * s)) : (r.x = e1.x + r.r, r.y = e1.y);
                    }
                    function b(t1, e1) {
                        var r = t1.r + e1.r - 1e-6, n = e1.x - t1.x, i = e1.y - t1.y;
                        return r > 0 && r * r > n * n + i * i;
                    }
                    function _(t1) {
                        var e1 = t1._, r = t1.next._, n = e1.r + r.r, i = (e1.x * r.r + r.x * e1.r) / n, a = (e1.y * r.r + r.y * e1.r) / n;
                        return i * i + a * a;
                    }
                    function w(t1) {
                        this._ = t1, this.next = null, this.previous = null;
                    }
                    function T(t1) {
                        if (!(i = t1.length)) return 0;
                        var e1, r, n, i, a, o, s, l, c, u, h;
                        if ((e1 = t1[0]).x = 0, e1.y = 0, !(i > 1)) return e1.r;
                        if (r = t1[1], e1.x = -r.r, r.x = e1.r, r.y = 0, !(i > 2)) return e1.r + r.r;
                        x(r, e1, n = t1[2]), e1 = new w(e1), r = new w(r), n = new w(n), e1.next = n.previous = r, r.next = e1.previous = n, n.next = r.previous = e1;
                        t: for(s = 3; s < i; ++s){
                            x(e1._, r._, n = t1[s]), n = new w(n), l = r.next, c = e1.previous, u = r._.r, h = e1._.r;
                            do if (u <= h) {
                                if (b(l._, n._)) {
                                    r = l, e1.next = r, r.previous = e1, --s;
                                    continue t;
                                }
                                u += l._.r, l = l.next;
                            } else {
                                if (b(c._, n._)) {
                                    (e1 = c).next = r, r.previous = e1, --s;
                                    continue t;
                                }
                                h += c._.r, c = c.previous;
                            }
                            while (l !== c.next);
                            for(n.previous = e1, n.next = r, e1.next = r.previous = r = n, a = _(e1); (n = n.next) !== r;)(o = _(n)) < a && (e1 = n, a = o);
                            r = e1.next;
                        }
                        for(e1 = [
                            r._
                        ], n = r; (n = n.next) !== r;)e1.push(n._);
                        for(n = f(e1), s = 0; s < i; ++s)(e1 = t1[s]).x -= n.x, e1.y -= n.y;
                        return n.r;
                    }
                    function k(t1) {
                        return null == t1 ? null : A(t1);
                    }
                    function A(t1) {
                        if ("function" != typeof t1) throw new Error;
                        return t1;
                    }
                    function M() {
                        return 0;
                    }
                    function S(t1) {
                        return function() {
                            return t1;
                        };
                    }
                    function E(t1) {
                        return Math.sqrt(t1.value);
                    }
                    function L(t1) {
                        return function(e1) {
                            e1.children || (e1.r = Math.max(0, +t1(e1) || 0));
                        };
                    }
                    function C(t1, e1) {
                        return function(r) {
                            if (n = r.children) {
                                var n, i, a, o = n.length, s = t1(r) * e1 || 0;
                                if (s) for(i = 0; i < o; ++i)n[i].r += s;
                                if (a = T(n), s) for(i = 0; i < o; ++i)n[i].r -= s;
                                r.r = a + s;
                            }
                        };
                    }
                    function P(t1) {
                        return function(e1) {
                            var r = e1.parent;
                            e1.r *= t1, r && (e1.x = r.x + t1 * e1.x, e1.y = r.y + t1 * e1.y);
                        };
                    }
                    function I(t1) {
                        t1.x0 = Math.round(t1.x0), t1.y0 = Math.round(t1.y0), t1.x1 = Math.round(t1.x1), t1.y1 = Math.round(t1.y1);
                    }
                    function O(t1, e1, r, n, i) {
                        for(var a, o = t1.children, s = -1, l = o.length, c = t1.value && (n - e1) / t1.value; ++s < l;)(a = o[s]).y0 = r, a.y1 = i, a.x0 = e1, a.x1 = e1 += a.value * c;
                    }
                    var z = {
                        depth: -1
                    }, D = {};
                    function R(t1) {
                        return t1.id;
                    }
                    function F(t1) {
                        return t1.parentId;
                    }
                    function B(t1, e1) {
                        return t1.parent === e1.parent ? 1 : 2;
                    }
                    function N(t1) {
                        var e1 = t1.children;
                        return e1 ? e1[0] : t1.t;
                    }
                    function j(t1) {
                        var e1 = t1.children;
                        return e1 ? e1[e1.length - 1] : t1.t;
                    }
                    function U(t1, e1, r) {
                        var n = r / (e1.i - t1.i);
                        e1.c -= n, e1.s += r, t1.c += n, e1.z += r, e1.m += r;
                    }
                    function V(t1, e1, r) {
                        return t1.a.parent === e1.parent ? t1.a : r;
                    }
                    function H(t1, e1) {
                        this._ = t1, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = e1;
                    }
                    function q(t1, e1, r, n, i) {
                        for(var a, o = t1.children, s = -1, l = o.length, c = t1.value && (i - r) / t1.value; ++s < l;)(a = o[s]).x0 = e1, a.x1 = n, a.y0 = r, a.y1 = r += a.value * c;
                    }
                    H.prototype = Object.create(c.prototype);
                    var G = (1 + Math.sqrt(5)) / 2;
                    function Y(t1, e1, r, n, i, a) {
                        for(var o, s, l, c, u, f, h, p, d, m, g, v = [], y = e1.children, x = 0, b = 0, _ = y.length, w = e1.value; x < _;){
                            l = i - r, c = a - n;
                            do u = y[b++].value;
                            while (!u && b < _);
                            for(f = h = u, g = u * u * (m = Math.max(c / l, l / c) / (w * t1)), d = Math.max(h / g, g / f); b < _; ++b){
                                if (u += s = y[b].value, s < f && (f = s), s > h && (h = s), g = u * u * m, (p = Math.max(h / g, g / f)) > d) {
                                    u -= s;
                                    break;
                                }
                                d = p;
                            }
                            v.push(o = {
                                value: u,
                                dice: l < c,
                                children: y.slice(x, b)
                            }), o.dice ? O(o, r, n, i, w ? n += c * u / w : a) : q(o, r, n, w ? r += l * u / w : i, a), w -= u, x = b;
                        }
                        return v;
                    }
                    var W = function t1(e1) {
                        function r(t1, r, n, i, a) {
                            Y(e1, t1, r, n, i, a);
                        }
                        return r.ratio = function(e1) {
                            return t1((e1 = +e1) > 1 ? e1 : 1);
                        }, r;
                    }(G);
                    var X = function t1(e1) {
                        function r(t1, r, n, i, a) {
                            if ((o = t1._squarify) && o.ratio === e1) for(var o, s, l, c, u, f = -1, h = o.length, p = t1.value; ++f < h;){
                                for(l = (s = o[f]).children, c = s.value = 0, u = l.length; c < u; ++c)s.value += l[c].value;
                                s.dice ? O(s, r, n, i, n += (a - n) * s.value / p) : q(s, r, n, r += (i - r) * s.value / p, a), p -= s.value;
                            }
                            else t1._squarify = o = Y(e1, t1, r, n, i, a), o.ratio = e1;
                        }
                        return r.ratio = function(e1) {
                            return t1((e1 = +e1) > 1 ? e1 : 1);
                        }, r;
                    }(G);
                    t1.cluster = function() {
                        var t1 = e1, i = 1, a = 1, o = !1;
                        function s(e1) {
                            var s, l = 0;
                            e1.eachAfter(function(e1) {
                                var i = e1.children;
                                i ? (e1.x = function(t1) {
                                    return t1.reduce(r, 0) / t1.length;
                                }(i), e1.y = function(t1) {
                                    return 1 + t1.reduce(n, 0);
                                }(i)) : (e1.x = s ? l += t1(e1, s) : 0, e1.y = 0, s = e1);
                            });
                            var c = function(t1) {
                                for(var e1; e1 = t1.children;)t1 = e1[0];
                                return t1;
                            }(e1), u = function(t1) {
                                for(var e1; e1 = t1.children;)t1 = e1[e1.length - 1];
                                return t1;
                            }(e1), f = c.x - t1(c, u) / 2, h = u.x + t1(u, c) / 2;
                            return e1.eachAfter(o ? function(t1) {
                                t1.x = (t1.x - e1.x) * i, t1.y = (e1.y - t1.y) * a;
                            } : function(t1) {
                                t1.x = (t1.x - f) / (h - f) * i, t1.y = (1 - (e1.y ? t1.y / e1.y : 1)) * a;
                            });
                        }
                        return s.separation = function(e1) {
                            return arguments.length ? (t1 = e1, s) : t1;
                        }, s.size = function(t1) {
                            return arguments.length ? (o = !1, i = +t1[0], a = +t1[1], s) : o ? null : [
                                i,
                                a
                            ];
                        }, s.nodeSize = function(t1) {
                            return arguments.length ? (o = !0, i = +t1[0], a = +t1[1], s) : o ? [
                                i,
                                a
                            ] : null;
                        }, s;
                    }, t1.hierarchy = a, t1.pack = function() {
                        var t1 = null, e1 = 1, r = 1, n = M;
                        function i(i) {
                            return i.x = e1 / 2, i.y = r / 2, t1 ? i.eachBefore(L(t1)).eachAfter(C(n, .5)).eachBefore(P(1)) : i.eachBefore(L(E)).eachAfter(C(M, 1)).eachAfter(C(n, i.r / Math.min(e1, r))).eachBefore(P(Math.min(e1, r) / (2 * i.r))), i;
                        }
                        return i.radius = function(e1) {
                            return arguments.length ? (t1 = k(e1), i) : t1;
                        }, i.size = function(t1) {
                            return arguments.length ? (e1 = +t1[0], r = +t1[1], i) : [
                                e1,
                                r
                            ];
                        }, i.padding = function(t1) {
                            return arguments.length ? (n = "function" == typeof t1 ? t1 : S(+t1), i) : n;
                        }, i;
                    }, t1.packEnclose = f, t1.packSiblings = function(t1) {
                        return T(t1), t1;
                    }, t1.partition = function() {
                        var t1 = 1, e1 = 1, r = 0, n = !1;
                        function i(i) {
                            var a = i.height + 1;
                            return i.x0 = i.y0 = r, i.x1 = t1, i.y1 = e1 / a, i.eachBefore(function(t1, e1) {
                                return function(n) {
                                    n.children && O(n, n.x0, t1 * (n.depth + 1) / e1, n.x1, t1 * (n.depth + 2) / e1);
                                    var i = n.x0, a = n.y0, o = n.x1 - r, s = n.y1 - r;
                                    o < i && (i = o = (i + o) / 2), s < a && (a = s = (a + s) / 2), n.x0 = i, n.y0 = a, n.x1 = o, n.y1 = s;
                                };
                            }(e1, a)), n && i.eachBefore(I), i;
                        }
                        return i.round = function(t1) {
                            return arguments.length ? (n = !!t1, i) : n;
                        }, i.size = function(r) {
                            return arguments.length ? (t1 = +r[0], e1 = +r[1], i) : [
                                t1,
                                e1
                            ];
                        }, i.padding = function(t1) {
                            return arguments.length ? (r = +t1, i) : r;
                        }, i;
                    }, t1.stratify = function() {
                        var t1 = R, e1 = F;
                        function r(r) {
                            var n, i, a, o, s, u, f, h = r.length, p = new Array(h), d = {};
                            for(i = 0; i < h; ++i)n = r[i], s = p[i] = new c(n), null != (u = t1(n, i, r)) && (u += "") && (d[f = "$" + (s.id = u)] = f in d ? D : s);
                            for(i = 0; i < h; ++i)if (s = p[i], null != (u = e1(r[i], i, r)) && (u += "")) {
                                if (!(o = d["$" + u])) throw new Error("missing: " + u);
                                if (o === D) throw new Error("ambiguous: " + u);
                                o.children ? o.children.push(s) : o.children = [
                                    s
                                ], s.parent = o;
                            } else {
                                if (a) throw new Error("multiple roots");
                                a = s;
                            }
                            if (!a) throw new Error("no root");
                            if (a.parent = z, a.eachBefore(function(t1) {
                                t1.depth = t1.parent.depth + 1, --h;
                            }).eachBefore(l), a.parent = null, h > 0) throw new Error("cycle");
                            return a;
                        }
                        return r.id = function(e1) {
                            return arguments.length ? (t1 = A(e1), r) : t1;
                        }, r.parentId = function(t1) {
                            return arguments.length ? (e1 = A(t1), r) : e1;
                        }, r;
                    }, t1.tree = function() {
                        var t1 = B, e1 = 1, r = 1, n = null;
                        function i(i) {
                            var l = function(t1) {
                                for(var e1, r, n, i, a, o = new H(t1, 0), s = [
                                    o
                                ]; e1 = s.pop();)if (n = e1._.children) for(e1.children = new Array(a = n.length), i = a - 1; i >= 0; --i)s.push(r = e1.children[i] = new H(n[i], i)), r.parent = e1;
                                return (o.parent = new H(null, 0)).children = [
                                    o
                                ], o;
                            }(i);
                            if (l.eachAfter(a), l.parent.m = -l.z, l.eachBefore(o), n) i.eachBefore(s);
                            else {
                                var c = i, u = i, f = i;
                                i.eachBefore(function(t1) {
                                    t1.x < c.x && (c = t1), t1.x > u.x && (u = t1), t1.depth > f.depth && (f = t1);
                                });
                                var h = c === u ? 1 : t1(c, u) / 2, p = h - c.x, d = e1 / (u.x + h + p), m = r / (f.depth || 1);
                                i.eachBefore(function(t1) {
                                    t1.x = (t1.x + p) * d, t1.y = t1.depth * m;
                                });
                            }
                            return i;
                        }
                        function a(e1) {
                            var r = e1.children, n = e1.parent.children, i = e1.i ? n[e1.i - 1] : null;
                            if (r) {
                                !function(t1) {
                                    for(var e1, r = 0, n = 0, i = t1.children, a = i.length; --a >= 0;)(e1 = i[a]).z += r, e1.m += r, r += e1.s + (n += e1.c);
                                }(e1);
                                var a = (r[0].z + r[r.length - 1].z) / 2;
                                i ? (e1.z = i.z + t1(e1._, i._), e1.m = e1.z - a) : e1.z = a;
                            } else i && (e1.z = i.z + t1(e1._, i._));
                            e1.parent.A = function(e1, r, n) {
                                if (r) {
                                    for(var i, a = e1, o = e1, s = r, l = a.parent.children[0], c = a.m, u = o.m, f = s.m, h = l.m; s = j(s), a = N(a), s && a;)l = N(l), (o = j(o)).a = e1, (i = s.z + f - a.z - c + t1(s._, a._)) > 0 && (U(V(s, e1, n), e1, i), c += i, u += i), f += s.m, c += a.m, h += l.m, u += o.m;
                                    s && !j(o) && (o.t = s, o.m += f - u), a && !N(l) && (l.t = a, l.m += c - h, n = e1);
                                }
                                return n;
                            }(e1, i, e1.parent.A || n[0]);
                        }
                        function o(t1) {
                            t1._.x = t1.z + t1.parent.m, t1.m += t1.parent.m;
                        }
                        function s(t1) {
                            t1.x *= e1, t1.y = t1.depth * r;
                        }
                        return i.separation = function(e1) {
                            return arguments.length ? (t1 = e1, i) : t1;
                        }, i.size = function(t1) {
                            return arguments.length ? (n = !1, e1 = +t1[0], r = +t1[1], i) : n ? null : [
                                e1,
                                r
                            ];
                        }, i.nodeSize = function(t1) {
                            return arguments.length ? (n = !0, e1 = +t1[0], r = +t1[1], i) : n ? [
                                e1,
                                r
                            ] : null;
                        }, i;
                    }, t1.treemap = function() {
                        var t1 = W, e1 = !1, r = 1, n = 1, i = [
                            0
                        ], a = M, o = M, s = M, l = M, c = M;
                        function u(t1) {
                            return t1.x0 = t1.y0 = 0, t1.x1 = r, t1.y1 = n, t1.eachBefore(f), i = [
                                0
                            ], e1 && t1.eachBefore(I), t1;
                        }
                        function f(e1) {
                            var r = i[e1.depth], n = e1.x0 + r, u = e1.y0 + r, f = e1.x1 - r, h = e1.y1 - r;
                            f < n && (n = f = (n + f) / 2), h < u && (u = h = (u + h) / 2), e1.x0 = n, e1.y0 = u, e1.x1 = f, e1.y1 = h, e1.children && (r = i[e1.depth + 1] = a(e1) / 2, n += c(e1) - r, u += o(e1) - r, (f -= s(e1) - r) < n && (n = f = (n + f) / 2), (h -= l(e1) - r) < u && (u = h = (u + h) / 2), t1(e1, n, u, f, h));
                        }
                        return u.round = function(t1) {
                            return arguments.length ? (e1 = !!t1, u) : e1;
                        }, u.size = function(t1) {
                            return arguments.length ? (r = +t1[0], n = +t1[1], u) : [
                                r,
                                n
                            ];
                        }, u.tile = function(e1) {
                            return arguments.length ? (t1 = A(e1), u) : t1;
                        }, u.padding = function(t1) {
                            return arguments.length ? u.paddingInner(t1).paddingOuter(t1) : u.paddingInner();
                        }, u.paddingInner = function(t1) {
                            return arguments.length ? (a = "function" == typeof t1 ? t1 : S(+t1), u) : a;
                        }, u.paddingOuter = function(t1) {
                            return arguments.length ? u.paddingTop(t1).paddingRight(t1).paddingBottom(t1).paddingLeft(t1) : u.paddingTop();
                        }, u.paddingTop = function(t1) {
                            return arguments.length ? (o = "function" == typeof t1 ? t1 : S(+t1), u) : o;
                        }, u.paddingRight = function(t1) {
                            return arguments.length ? (s = "function" == typeof t1 ? t1 : S(+t1), u) : s;
                        }, u.paddingBottom = function(t1) {
                            return arguments.length ? (l = "function" == typeof t1 ? t1 : S(+t1), u) : l;
                        }, u.paddingLeft = function(t1) {
                            return arguments.length ? (c = "function" == typeof t1 ? t1 : S(+t1), u) : c;
                        }, u;
                    }, t1.treemapBinary = function(t1, e1, r, n, i) {
                        var a, o, s = t1.children, l = s.length, c = new Array(l + 1);
                        for(c[0] = o = a = 0; a < l; ++a)c[a + 1] = o += s[a].value;
                        !function t1(e1, r, n, i, a, o, l) {
                            if (e1 >= r - 1) {
                                var u = s[e1];
                                return u.x0 = i, u.y0 = a, u.x1 = o, void (u.y1 = l);
                            }
                            var f = c[e1], h = n / 2 + f, p = e1 + 1, d = r - 1;
                            for(; p < d;){
                                var m = p + d >>> 1;
                                c[m] < h ? p = m + 1 : d = m;
                            }
                            h - c[p - 1] < c[p] - h && e1 + 1 < p && --p;
                            var g = c[p] - f, v = n - g;
                            if (o - i > l - a) {
                                var y = (i * v + o * g) / n;
                                t1(e1, p, g, i, a, y, l), t1(p, r, v, y, a, o, l);
                            } else {
                                var x = (a * v + l * g) / n;
                                t1(e1, p, g, i, a, o, x), t1(p, r, v, i, x, o, l);
                            }
                        }(0, l, t1.value, e1, r, n, i);
                    }, t1.treemapDice = O, t1.treemapResquarify = X, t1.treemapSlice = q, t1.treemapSliceDice = function(t1, e1, r, n, i) {
                        (1 & t1.depth ? q : O)(t1, e1, r, n, i);
                    }, t1.treemapSquarify = W, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {}
        ],
        116: [
            function(t1, e1, r) {
                !function(n, i) {
                    "object" == typeof r && void 0 !== e1 ? i(r, t1("d3-color")) : i((n = n || self).d3 = n.d3 || {}, n.d3);
                }(this, function(t1, e1) {
                    "use strict";
                    function r(t1, e1, r, n, i) {
                        var a = t1 * t1, o = a * t1;
                        return ((1 - 3 * t1 + 3 * a - o) * e1 + (4 - 6 * a + 3 * o) * r + (1 + 3 * t1 + 3 * a - 3 * o) * n + o * i) / 6;
                    }
                    function n(t1) {
                        var e1 = t1.length - 1;
                        return function(n) {
                            var i = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e1 - 1) : Math.floor(n * e1), a = t1[i], o = t1[i + 1], s = i > 0 ? t1[i - 1] : 2 * a - o, l = i < e1 - 1 ? t1[i + 2] : 2 * o - a;
                            return r((n - i / e1) * e1, s, a, o, l);
                        };
                    }
                    function i(t1) {
                        var e1 = t1.length;
                        return function(n) {
                            var i = Math.floor(((n %= 1) < 0 ? ++n : n) * e1), a = t1[(i + e1 - 1) % e1], o = t1[i % e1], s = t1[(i + 1) % e1], l = t1[(i + 2) % e1];
                            return r((n - i / e1) * e1, a, o, s, l);
                        };
                    }
                    function a(t1) {
                        return function() {
                            return t1;
                        };
                    }
                    function o(t1, e1) {
                        return function(r) {
                            return t1 + r * e1;
                        };
                    }
                    function s(t1, e1) {
                        var r = e1 - t1;
                        return r ? o(t1, r > 180 || r < -180 ? r - 360 * Math.round(r / 360) : r) : a(isNaN(t1) ? e1 : t1);
                    }
                    function l(t1) {
                        return 1 == (t1 = +t1) ? c : function(e1, r) {
                            return r - e1 ? function(t1, e1, r) {
                                return t1 = Math.pow(t1, r), e1 = Math.pow(e1, r) - t1, r = 1 / r, function(n) {
                                    return Math.pow(t1 + n * e1, r);
                                };
                            }(e1, r, t1) : a(isNaN(e1) ? r : e1);
                        };
                    }
                    function c(t1, e1) {
                        var r = e1 - t1;
                        return r ? o(t1, r) : a(isNaN(t1) ? e1 : t1);
                    }
                    var u = function t1(r) {
                        var n = l(r);
                        function i(t1, r) {
                            var i = n((t1 = e1.rgb(t1)).r, (r = e1.rgb(r)).r), a = n(t1.g, r.g), o = n(t1.b, r.b), s = c(t1.opacity, r.opacity);
                            return function(e1) {
                                return t1.r = i(e1), t1.g = a(e1), t1.b = o(e1), t1.opacity = s(e1), t1 + "";
                            };
                        }
                        return i.gamma = t1, i;
                    }(1);
                    function f(t1) {
                        return function(r) {
                            var n, i, a = r.length, o = new Array(a), s = new Array(a), l = new Array(a);
                            for(n = 0; n < a; ++n)i = e1.rgb(r[n]), o[n] = i.r || 0, s[n] = i.g || 0, l[n] = i.b || 0;
                            return o = t1(o), s = t1(s), l = t1(l), i.opacity = 1, function(t1) {
                                return i.r = o(t1), i.g = s(t1), i.b = l(t1), i + "";
                            };
                        };
                    }
                    var h = f(n), p = f(i);
                    function d(t1, e1) {
                        e1 || (e1 = []);
                        var r, n = t1 ? Math.min(e1.length, t1.length) : 0, i = e1.slice();
                        return function(a) {
                            for(r = 0; r < n; ++r)i[r] = t1[r] * (1 - a) + e1[r] * a;
                            return i;
                        };
                    }
                    function m(t1) {
                        return ArrayBuffer.isView(t1) && !(t1 instanceof DataView);
                    }
                    function g(t1, e1) {
                        var r, n = e1 ? e1.length : 0, i = t1 ? Math.min(n, t1.length) : 0, a = new Array(i), o = new Array(n);
                        for(r = 0; r < i; ++r)a[r] = T(t1[r], e1[r]);
                        for(; r < n; ++r)o[r] = e1[r];
                        return function(t1) {
                            for(r = 0; r < i; ++r)o[r] = a[r](t1);
                            return o;
                        };
                    }
                    function v(t1, e1) {
                        var r = new Date;
                        return t1 = +t1, e1 = +e1, function(n) {
                            return r.setTime(t1 * (1 - n) + e1 * n), r;
                        };
                    }
                    function y(t1, e1) {
                        return t1 = +t1, e1 = +e1, function(r) {
                            return t1 * (1 - r) + e1 * r;
                        };
                    }
                    function x(t1, e1) {
                        var r, n = {}, i = {};
                        for(r in null !== t1 && "object" == typeof t1 || (t1 = {}), null !== e1 && "object" == typeof e1 || (e1 = {}), e1)r in t1 ? n[r] = T(t1[r], e1[r]) : i[r] = e1[r];
                        return function(t1) {
                            for(r in n)i[r] = n[r](t1);
                            return i;
                        };
                    }
                    var b = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, _ = new RegExp(b.source, "g");
                    function w(t1, e1) {
                        var r, n, i, a = b.lastIndex = _.lastIndex = 0, o = -1, s = [], l = [];
                        for(t1 += "", e1 += ""; (r = b.exec(t1)) && (n = _.exec(e1));)(i = n.index) > a && (i = e1.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (r = r[0]) === (n = n[0]) ? s[o] ? s[o] += n : s[++o] = n : (s[++o] = null, l.push({
                            i: o,
                            x: y(r, n)
                        })), a = _.lastIndex;
                        return a < e1.length && (i = e1.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? l[0] ? function(t1) {
                            return function(e1) {
                                return t1(e1) + "";
                            };
                        }(l[0].x) : function(t1) {
                            return function() {
                                return t1;
                            };
                        }(e1) : (e1 = l.length, function(t1) {
                            for(var r, n = 0; n < e1; ++n)s[(r = l[n]).i] = r.x(t1);
                            return s.join("");
                        });
                    }
                    function T(t1, r) {
                        var n, i = typeof r;
                        return null == r || "boolean" === i ? a(r) : ("number" === i ? y : "string" === i ? (n = e1.color(r)) ? (r = n, u) : w : r instanceof e1.color ? u : r instanceof Date ? v : m(r) ? d : Array.isArray(r) ? g : "function" != typeof r.valueOf && "function" != typeof r.toString || isNaN(r) ? x : y)(t1, r);
                    }
                    var k, A, M, S, E = 180 / Math.PI, L = {
                        translateX: 0,
                        translateY: 0,
                        rotate: 0,
                        skewX: 0,
                        scaleX: 1,
                        scaleY: 1
                    };
                    function C(t1, e1, r, n, i, a) {
                        var o, s, l;
                        return (o = Math.sqrt(t1 * t1 + e1 * e1)) && (t1 /= o, e1 /= o), (l = t1 * r + e1 * n) && (r -= t1 * l, n -= e1 * l), (s = Math.sqrt(r * r + n * n)) && (r /= s, n /= s, l /= s), t1 * n < e1 * r && (t1 = -t1, e1 = -e1, l = -l, o = -o), {
                            translateX: i,
                            translateY: a,
                            rotate: Math.atan2(e1, t1) * E,
                            skewX: Math.atan(l) * E,
                            scaleX: o,
                            scaleY: s
                        };
                    }
                    function P(t1, e1, r, n) {
                        function i(t1) {
                            return t1.length ? t1.pop() + " " : "";
                        }
                        return function(a, o) {
                            var s = [], l = [];
                            return a = t1(a), o = t1(o), function(t1, n, i, a, o, s) {
                                if (t1 !== i || n !== a) {
                                    var l = o.push("translate(", null, e1, null, r);
                                    s.push({
                                        i: l - 4,
                                        x: y(t1, i)
                                    }, {
                                        i: l - 2,
                                        x: y(n, a)
                                    });
                                } else (i || a) && o.push("translate(" + i + e1 + a + r);
                            }(a.translateX, a.translateY, o.translateX, o.translateY, s, l), function(t1, e1, r, a) {
                                t1 !== e1 ? (t1 - e1 > 180 ? e1 += 360 : e1 - t1 > 180 && (t1 += 360), a.push({
                                    i: r.push(i(r) + "rotate(", null, n) - 2,
                                    x: y(t1, e1)
                                })) : e1 && r.push(i(r) + "rotate(" + e1 + n);
                            }(a.rotate, o.rotate, s, l), function(t1, e1, r, a) {
                                t1 !== e1 ? a.push({
                                    i: r.push(i(r) + "skewX(", null, n) - 2,
                                    x: y(t1, e1)
                                }) : e1 && r.push(i(r) + "skewX(" + e1 + n);
                            }(a.skewX, o.skewX, s, l), function(t1, e1, r, n, a, o) {
                                if (t1 !== r || e1 !== n) {
                                    var s = a.push(i(a) + "scale(", null, ",", null, ")");
                                    o.push({
                                        i: s - 4,
                                        x: y(t1, r)
                                    }, {
                                        i: s - 2,
                                        x: y(e1, n)
                                    });
                                } else 1 === r && 1 === n || a.push(i(a) + "scale(" + r + "," + n + ")");
                            }(a.scaleX, a.scaleY, o.scaleX, o.scaleY, s, l), a = o = null, function(t1) {
                                for(var e1, r = -1, n = l.length; ++r < n;)s[(e1 = l[r]).i] = e1.x(t1);
                                return s.join("");
                            };
                        };
                    }
                    var I = P(function(t1) {
                        return "none" === t1 ? L : (k || (k = document.createElement("DIV"), A = document.documentElement, M = document.defaultView), k.style.transform = t1, t1 = M.getComputedStyle(A.appendChild(k), null).getPropertyValue("transform"), A.removeChild(k), C(+(t1 = t1.slice(7, -1).split(","))[0], +t1[1], +t1[2], +t1[3], +t1[4], +t1[5]));
                    }, "px, ", "px)", "deg)"), O = P(function(t1) {
                        return null == t1 ? L : (S || (S = document.createElementNS("http://www.w3.org/2000/svg", "g")), S.setAttribute("transform", t1), (t1 = S.transform.baseVal.consolidate()) ? C((t1 = t1.matrix).a, t1.b, t1.c, t1.d, t1.e, t1.f) : L);
                    }, ", ", ")", ")"), z = Math.SQRT2;
                    function D(t1) {
                        return ((t1 = Math.exp(t1)) + 1 / t1) / 2;
                    }
                    function R(t1) {
                        return function(r, n) {
                            var i = t1((r = e1.hsl(r)).h, (n = e1.hsl(n)).h), a = c(r.s, n.s), o = c(r.l, n.l), s = c(r.opacity, n.opacity);
                            return function(t1) {
                                return r.h = i(t1), r.s = a(t1), r.l = o(t1), r.opacity = s(t1), r + "";
                            };
                        };
                    }
                    var F = R(s), B = R(c);
                    function N(t1) {
                        return function(r, n) {
                            var i = t1((r = e1.hcl(r)).h, (n = e1.hcl(n)).h), a = c(r.c, n.c), o = c(r.l, n.l), s = c(r.opacity, n.opacity);
                            return function(t1) {
                                return r.h = i(t1), r.c = a(t1), r.l = o(t1), r.opacity = s(t1), r + "";
                            };
                        };
                    }
                    var j = N(s), U = N(c);
                    function V(t1) {
                        return function r(n) {
                            function i(r, i) {
                                var a = t1((r = e1.cubehelix(r)).h, (i = e1.cubehelix(i)).h), o = c(r.s, i.s), s = c(r.l, i.l), l = c(r.opacity, i.opacity);
                                return function(t1) {
                                    return r.h = a(t1), r.s = o(t1), r.l = s(Math.pow(t1, n)), r.opacity = l(t1), r + "";
                                };
                            }
                            return n = +n, i.gamma = r, i;
                        }(1);
                    }
                    var H = V(s), q = V(c);
                    t1.interpolate = T, t1.interpolateArray = function(t1, e1) {
                        return (m(e1) ? d : g)(t1, e1);
                    }, t1.interpolateBasis = n, t1.interpolateBasisClosed = i, t1.interpolateCubehelix = H, t1.interpolateCubehelixLong = q, t1.interpolateDate = v, t1.interpolateDiscrete = function(t1) {
                        var e1 = t1.length;
                        return function(r) {
                            return t1[Math.max(0, Math.min(e1 - 1, Math.floor(r * e1)))];
                        };
                    }, t1.interpolateHcl = j, t1.interpolateHclLong = U, t1.interpolateHsl = F, t1.interpolateHslLong = B, t1.interpolateHue = function(t1, e1) {
                        var r = s(+t1, +e1);
                        return function(t1) {
                            var e1 = r(t1);
                            return e1 - 360 * Math.floor(e1 / 360);
                        };
                    }, t1.interpolateLab = function(t1, r) {
                        var n = c((t1 = e1.lab(t1)).l, (r = e1.lab(r)).l), i = c(t1.a, r.a), a = c(t1.b, r.b), o = c(t1.opacity, r.opacity);
                        return function(e1) {
                            return t1.l = n(e1), t1.a = i(e1), t1.b = a(e1), t1.opacity = o(e1), t1 + "";
                        };
                    }, t1.interpolateNumber = y, t1.interpolateNumberArray = d, t1.interpolateObject = x, t1.interpolateRgb = u, t1.interpolateRgbBasis = h, t1.interpolateRgbBasisClosed = p, t1.interpolateRound = function(t1, e1) {
                        return t1 = +t1, e1 = +e1, function(r) {
                            return Math.round(t1 * (1 - r) + e1 * r);
                        };
                    }, t1.interpolateString = w, t1.interpolateTransformCss = I, t1.interpolateTransformSvg = O, t1.interpolateZoom = function(t1, e1) {
                        var r, n, i = t1[0], a = t1[1], o = t1[2], s = e1[0], l = e1[1], c = e1[2], u = s - i, f = l - a, h = u * u + f * f;
                        if (h < 1e-12) n = Math.log(c / o) / z, r = function(t1) {
                            return [
                                i + t1 * u,
                                a + t1 * f,
                                o * Math.exp(z * t1 * n)
                            ];
                        };
                        else {
                            var p = Math.sqrt(h), d = (c * c - o * o + 4 * h) / (2 * o * 2 * p), m = (c * c - o * o - 4 * h) / (2 * c * 2 * p), g = Math.log(Math.sqrt(d * d + 1) - d), v = Math.log(Math.sqrt(m * m + 1) - m);
                            n = (v - g) / z, r = function(t1) {
                                var e1, r = t1 * n, s = D(g), l = o / (2 * p) * (s * (e1 = z * r + g, ((e1 = Math.exp(2 * e1)) - 1) / (e1 + 1)) - function(t1) {
                                    return ((t1 = Math.exp(t1)) - 1 / t1) / 2;
                                }(g));
                                return [
                                    i + l * u,
                                    a + l * f,
                                    o * s / D(z * r + g)
                                ];
                            };
                        }
                        return r.duration = 1e3 * n, r;
                    }, t1.piecewise = function(t1, e1) {
                        for(var r = 0, n = e1.length - 1, i = e1[0], a = new Array(n < 0 ? 0 : n); r < n;)a[r] = t1(i, i = e1[++r]);
                        return function(t1) {
                            var e1 = Math.max(0, Math.min(n - 1, Math.floor(t1 *= n)));
                            return a[e1](t1 - e1);
                        };
                    }, t1.quantize = function(t1, e1) {
                        for(var r = new Array(e1), n = 0; n < e1; ++n)r[n] = t1(n / (e1 - 1));
                        return r;
                    }, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {
                "d3-color": 109
            }
        ],
        117: [
            function(t1, e1, r) {
                !function(t1, n) {
                    "object" == typeof r && void 0 !== e1 ? n(r) : n((t1 = t1 || self).d3 = t1.d3 || {});
                }(this, function(t1) {
                    "use strict";
                    var e1 = Math.PI, r = 2 * e1, n = r - 1e-6;
                    function i() {
                        this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
                    }
                    function a() {
                        return new i;
                    }
                    i.prototype = a.prototype = {
                        constructor: i,
                        moveTo: function(t1, e1) {
                            this._ += "M" + (this._x0 = this._x1 = +t1) + "," + (this._y0 = this._y1 = +e1);
                        },
                        closePath: function() {
                            null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
                        },
                        lineTo: function(t1, e1) {
                            this._ += "L" + (this._x1 = +t1) + "," + (this._y1 = +e1);
                        },
                        quadraticCurveTo: function(t1, e1, r, n) {
                            this._ += "Q" + +t1 + "," + +e1 + "," + (this._x1 = +r) + "," + (this._y1 = +n);
                        },
                        bezierCurveTo: function(t1, e1, r, n, i, a) {
                            this._ += "C" + +t1 + "," + +e1 + "," + +r + "," + +n + "," + (this._x1 = +i) + "," + (this._y1 = +a);
                        },
                        arcTo: function(t1, r, n, i, a) {
                            t1 = +t1, r = +r, n = +n, i = +i, a = +a;
                            var o = this._x1, s = this._y1, l = n - t1, c = i - r, u = o - t1, f = s - r, h = u * u + f * f;
                            if (a < 0) throw new Error("negative radius: " + a);
                            if (null === this._x1) this._ += "M" + (this._x1 = t1) + "," + (this._y1 = r);
                            else if (h > 1e-6) {
                                if (Math.abs(f * l - c * u) > 1e-6 && a) {
                                    var p = n - o, d = i - s, m = l * l + c * c, g = p * p + d * d, v = Math.sqrt(m), y = Math.sqrt(h), x = a * Math.tan((e1 - Math.acos((m + h - g) / (2 * v * y))) / 2), b = x / y, _ = x / v;
                                    Math.abs(b - 1) > 1e-6 && (this._ += "L" + (t1 + b * u) + "," + (r + b * f)), this._ += "A" + a + "," + a + ",0,0," + +(f * p > u * d) + "," + (this._x1 = t1 + _ * l) + "," + (this._y1 = r + _ * c);
                                } else this._ += "L" + (this._x1 = t1) + "," + (this._y1 = r);
                            } else ;
                        },
                        arc: function(t1, i, a, o, s, l) {
                            t1 = +t1, i = +i, l = !!l;
                            var c = (a = +a) * Math.cos(o), u = a * Math.sin(o), f = t1 + c, h = i + u, p = 1 ^ l, d = l ? o - s : s - o;
                            if (a < 0) throw new Error("negative radius: " + a);
                            null === this._x1 ? this._ += "M" + f + "," + h : (Math.abs(this._x1 - f) > 1e-6 || Math.abs(this._y1 - h) > 1e-6) && (this._ += "L" + f + "," + h), a && (d < 0 && (d = d % r + r), d > n ? this._ += "A" + a + "," + a + ",0,1," + p + "," + (t1 - c) + "," + (i - u) + "A" + a + "," + a + ",0,1," + p + "," + (this._x1 = f) + "," + (this._y1 = h) : d > 1e-6 && (this._ += "A" + a + "," + a + ",0," + +(d >= e1) + "," + p + "," + (this._x1 = t1 + a * Math.cos(s)) + "," + (this._y1 = i + a * Math.sin(s))));
                        },
                        rect: function(t1, e1, r, n) {
                            this._ += "M" + (this._x0 = this._x1 = +t1) + "," + (this._y0 = this._y1 = +e1) + "h" + +r + "v" + +n + "h" + -r + "Z";
                        },
                        toString: function() {
                            return this._;
                        }
                    }, t1.path = a, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {}
        ],
        118: [
            function(t1, e1, r) {
                !function(t1, n) {
                    "object" == typeof r && void 0 !== e1 ? n(r) : n((t1 = t1 || self).d3 = t1.d3 || {});
                }(this, function(t1) {
                    "use strict";
                    function e1(t1, e1, r, n) {
                        if (isNaN(e1) || isNaN(r)) return t1;
                        var i, a, o, s, l, c, u, f, h, p = t1._root, d = {
                            data: n
                        }, m = t1._x0, g = t1._y0, v = t1._x1, y = t1._y1;
                        if (!p) return t1._root = d, t1;
                        for(; p.length;)if ((c = e1 >= (a = (m + v) / 2)) ? m = a : v = a, (u = r >= (o = (g + y) / 2)) ? g = o : y = o, i = p, !(p = p[f = u << 1 | c])) return i[f] = d, t1;
                        if (s = +t1._x.call(null, p.data), l = +t1._y.call(null, p.data), e1 === s && r === l) return d.next = p, i ? i[f] = d : t1._root = d, t1;
                        do i = i ? i[f] = new Array(4) : t1._root = new Array(4), (c = e1 >= (a = (m + v) / 2)) ? m = a : v = a, (u = r >= (o = (g + y) / 2)) ? g = o : y = o;
                        while ((f = u << 1 | c) == (h = (l >= o) << 1 | s >= a));
                        return i[h] = p, i[f] = d, t1;
                    }
                    function r(t1, e1, r, n, i) {
                        this.node = t1, this.x0 = e1, this.y0 = r, this.x1 = n, this.y1 = i;
                    }
                    function n(t1) {
                        return t1[0];
                    }
                    function i(t1) {
                        return t1[1];
                    }
                    function a(t1, e1, r) {
                        var a = new o(null == e1 ? n : e1, null == r ? i : r, NaN, NaN, NaN, NaN);
                        return null == t1 ? a : a.addAll(t1);
                    }
                    function o(t1, e1, r, n, i, a) {
                        this._x = t1, this._y = e1, this._x0 = r, this._y0 = n, this._x1 = i, this._y1 = a, this._root = void 0;
                    }
                    function s(t1) {
                        for(var e1 = {
                            data: t1.data
                        }, r = e1; t1 = t1.next;)r = r.next = {
                            data: t1.data
                        };
                        return e1;
                    }
                    var l = a.prototype = o.prototype;
                    l.copy = function() {
                        var t1, e1, r = new o(this._x, this._y, this._x0, this._y0, this._x1, this._y1), n = this._root;
                        if (!n) return r;
                        if (!n.length) return r._root = s(n), r;
                        for(t1 = [
                            {
                                source: n,
                                target: r._root = new Array(4)
                            }
                        ]; n = t1.pop();)for(var i = 0; i < 4; ++i)(e1 = n.source[i]) && (e1.length ? t1.push({
                            source: e1,
                            target: n.target[i] = new Array(4)
                        }) : n.target[i] = s(e1));
                        return r;
                    }, l.add = function(t1) {
                        var r = +this._x.call(null, t1), n = +this._y.call(null, t1);
                        return e1(this.cover(r, n), r, n, t1);
                    }, l.addAll = function(t1) {
                        var r, n, i, a, o = t1.length, s = new Array(o), l = new Array(o), c = 1 / 0, u = 1 / 0, f = -1 / 0, h = -1 / 0;
                        for(n = 0; n < o; ++n)isNaN(i = +this._x.call(null, r = t1[n])) || isNaN(a = +this._y.call(null, r)) || (s[n] = i, l[n] = a, i < c && (c = i), i > f && (f = i), a < u && (u = a), a > h && (h = a));
                        if (c > f || u > h) return this;
                        for(this.cover(c, u).cover(f, h), n = 0; n < o; ++n)e1(this, s[n], l[n], t1[n]);
                        return this;
                    }, l.cover = function(t1, e1) {
                        if (isNaN(t1 = +t1) || isNaN(e1 = +e1)) return this;
                        var r = this._x0, n = this._y0, i = this._x1, a = this._y1;
                        if (isNaN(r)) i = (r = Math.floor(t1)) + 1, a = (n = Math.floor(e1)) + 1;
                        else {
                            for(var o, s, l = i - r, c = this._root; r > t1 || t1 >= i || n > e1 || e1 >= a;)switch(s = (e1 < n) << 1 | t1 < r, (o = new Array(4))[s] = c, c = o, l *= 2, s){
                                case 0:
                                    i = r + l, a = n + l;
                                    break;
                                case 1:
                                    r = i - l, a = n + l;
                                    break;
                                case 2:
                                    i = r + l, n = a - l;
                                    break;
                                case 3:
                                    r = i - l, n = a - l;
                            }
                            this._root && this._root.length && (this._root = c);
                        }
                        return this._x0 = r, this._y0 = n, this._x1 = i, this._y1 = a, this;
                    }, l.data = function() {
                        var t1 = [];
                        return this.visit(function(e1) {
                            if (!e1.length) do t1.push(e1.data);
                            while (e1 = e1.next);
                        }), t1;
                    }, l.extent = function(t1) {
                        return arguments.length ? this.cover(+t1[0][0], +t1[0][1]).cover(+t1[1][0], +t1[1][1]) : isNaN(this._x0) ? void 0 : [
                            [
                                this._x0,
                                this._y0
                            ],
                            [
                                this._x1,
                                this._y1
                            ]
                        ];
                    }, l.find = function(t1, e1, n) {
                        var i, a, o, s, l, c, u, f = this._x0, h = this._y0, p = this._x1, d = this._y1, m = [], g = this._root;
                        for(g && m.push(new r(g, f, h, p, d)), null == n ? n = 1 / 0 : (f = t1 - n, h = e1 - n, p = t1 + n, d = e1 + n, n *= n); c = m.pop();)if (!(!(g = c.node) || (a = c.x0) > p || (o = c.y0) > d || (s = c.x1) < f || (l = c.y1) < h)) {
                            if (g.length) {
                                var v = (a + s) / 2, y = (o + l) / 2;
                                m.push(new r(g[3], v, y, s, l), new r(g[2], a, y, v, l), new r(g[1], v, o, s, y), new r(g[0], a, o, v, y)), (u = (e1 >= y) << 1 | t1 >= v) && (c = m[m.length - 1], m[m.length - 1] = m[m.length - 1 - u], m[m.length - 1 - u] = c);
                            } else {
                                var x = t1 - +this._x.call(null, g.data), b = e1 - +this._y.call(null, g.data), _ = x * x + b * b;
                                if (_ < n) {
                                    var w = Math.sqrt(n = _);
                                    f = t1 - w, h = e1 - w, p = t1 + w, d = e1 + w, i = g.data;
                                }
                            }
                        }
                        return i;
                    }, l.remove = function(t1) {
                        if (isNaN(a = +this._x.call(null, t1)) || isNaN(o = +this._y.call(null, t1))) return this;
                        var e1, r, n, i, a, o, s, l, c, u, f, h, p = this._root, d = this._x0, m = this._y0, g = this._x1, v = this._y1;
                        if (!p) return this;
                        if (p.length) for(;;){
                            if ((c = a >= (s = (d + g) / 2)) ? d = s : g = s, (u = o >= (l = (m + v) / 2)) ? m = l : v = l, e1 = p, !(p = p[f = u << 1 | c])) return this;
                            if (!p.length) break;
                            (e1[f + 1 & 3] || e1[f + 2 & 3] || e1[f + 3 & 3]) && (r = e1, h = f);
                        }
                        for(; p.data !== t1;)if (n = p, !(p = p.next)) return this;
                        return (i = p.next) && delete p.next, n ? (i ? n.next = i : delete n.next, this) : e1 ? (i ? e1[f] = i : delete e1[f], (p = e1[0] || e1[1] || e1[2] || e1[3]) && p === (e1[3] || e1[2] || e1[1] || e1[0]) && !p.length && (r ? r[h] = p : this._root = p), this) : (this._root = i, this);
                    }, l.removeAll = function(t1) {
                        for(var e1 = 0, r = t1.length; e1 < r; ++e1)this.remove(t1[e1]);
                        return this;
                    }, l.root = function() {
                        return this._root;
                    }, l.size = function() {
                        var t1 = 0;
                        return this.visit(function(e1) {
                            if (!e1.length) do ++t1;
                            while (e1 = e1.next);
                        }), t1;
                    }, l.visit = function(t1) {
                        var e1, n, i, a, o, s, l = [], c = this._root;
                        for(c && l.push(new r(c, this._x0, this._y0, this._x1, this._y1)); e1 = l.pop();)if (!t1(c = e1.node, i = e1.x0, a = e1.y0, o = e1.x1, s = e1.y1) && c.length) {
                            var u = (i + o) / 2, f = (a + s) / 2;
                            (n = c[3]) && l.push(new r(n, u, f, o, s)), (n = c[2]) && l.push(new r(n, i, f, u, s)), (n = c[1]) && l.push(new r(n, u, a, o, f)), (n = c[0]) && l.push(new r(n, i, a, u, f));
                        }
                        return this;
                    }, l.visitAfter = function(t1) {
                        var e1, n = [], i = [];
                        for(this._root && n.push(new r(this._root, this._x0, this._y0, this._x1, this._y1)); e1 = n.pop();){
                            var a = e1.node;
                            if (a.length) {
                                var o, s = e1.x0, l = e1.y0, c = e1.x1, u = e1.y1, f = (s + c) / 2, h = (l + u) / 2;
                                (o = a[0]) && n.push(new r(o, s, l, f, h)), (o = a[1]) && n.push(new r(o, f, l, c, h)), (o = a[2]) && n.push(new r(o, s, h, f, u)), (o = a[3]) && n.push(new r(o, f, h, c, u));
                            }
                            i.push(e1);
                        }
                        for(; e1 = i.pop();)t1(e1.node, e1.x0, e1.y0, e1.x1, e1.y1);
                        return this;
                    }, l.x = function(t1) {
                        return arguments.length ? (this._x = t1, this) : this._x;
                    }, l.y = function(t1) {
                        return arguments.length ? (this._y = t1, this) : this._y;
                    }, t1.quadtree = a, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {}
        ],
        119: [
            function(t1, e1, r) {
                !function(n, i) {
                    "object" == typeof r && void 0 !== e1 ? i(r, t1("d3-path")) : i((n = n || self).d3 = n.d3 || {}, n.d3);
                }(this, function(t1, e1) {
                    "use strict";
                    function r(t1) {
                        return function() {
                            return t1;
                        };
                    }
                    var n = Math.abs, i = Math.atan2, a = Math.cos, o = Math.max, s = Math.min, l = Math.sin, c = Math.sqrt, u = Math.PI, f = u / 2, h = 2 * u;
                    function p(t1) {
                        return t1 > 1 ? 0 : t1 < -1 ? u : Math.acos(t1);
                    }
                    function d(t1) {
                        return t1 >= 1 ? f : t1 <= -1 ? -f : Math.asin(t1);
                    }
                    function m(t1) {
                        return t1.innerRadius;
                    }
                    function g(t1) {
                        return t1.outerRadius;
                    }
                    function v(t1) {
                        return t1.startAngle;
                    }
                    function y(t1) {
                        return t1.endAngle;
                    }
                    function x(t1) {
                        return t1 && t1.padAngle;
                    }
                    function b(t1, e1, r, n, i, a, o, s) {
                        var l = r - t1, c = n - e1, u = o - i, f = s - a, h = f * l - u * c;
                        if (!(h * h < 1e-12)) return [
                            t1 + (h = (u * (e1 - a) - f * (t1 - i)) / h) * l,
                            e1 + h * c
                        ];
                    }
                    function _(t1, e1, r, n, i, a, s) {
                        var l = t1 - r, u = e1 - n, f = (s ? a : -a) / c(l * l + u * u), h = f * u, p = -f * l, d = t1 + h, m = e1 + p, g = r + h, v = n + p, y = (d + g) / 2, x = (m + v) / 2, b = g - d, _ = v - m, w = b * b + _ * _, T = i - a, k = d * v - g * m, A = (_ < 0 ? -1 : 1) * c(o(0, T * T * w - k * k)), M = (k * _ - b * A) / w, S = (-k * b - _ * A) / w, E = (k * _ + b * A) / w, L = (-k * b + _ * A) / w, C = M - y, P = S - x, I = E - y, O = L - x;
                        return C * C + P * P > I * I + O * O && (M = E, S = L), {
                            cx: M,
                            cy: S,
                            x01: -h,
                            y01: -p,
                            x11: M * (i / T - 1),
                            y11: S * (i / T - 1)
                        };
                    }
                    function w(t1) {
                        this._context = t1;
                    }
                    function T(t1) {
                        return new w(t1);
                    }
                    function k(t1) {
                        return t1[0];
                    }
                    function A(t1) {
                        return t1[1];
                    }
                    function M() {
                        var t1 = k, n = A, i = r(!0), a = null, o = T, s = null;
                        function l(r) {
                            var l, c, u, f = r.length, h = !1;
                            for(null == a && (s = o(u = e1.path())), l = 0; l <= f; ++l)!(l < f && i(c = r[l], l, r)) === h && ((h = !h) ? s.lineStart() : s.lineEnd()), h && s.point(+t1(c, l, r), +n(c, l, r));
                            if (u) return s = null, u + "" || null;
                        }
                        return l.x = function(e1) {
                            return arguments.length ? (t1 = "function" == typeof e1 ? e1 : r(+e1), l) : t1;
                        }, l.y = function(t1) {
                            return arguments.length ? (n = "function" == typeof t1 ? t1 : r(+t1), l) : n;
                        }, l.defined = function(t1) {
                            return arguments.length ? (i = "function" == typeof t1 ? t1 : r(!!t1), l) : i;
                        }, l.curve = function(t1) {
                            return arguments.length ? (o = t1, null != a && (s = o(a)), l) : o;
                        }, l.context = function(t1) {
                            return arguments.length ? (null == t1 ? a = s = null : s = o(a = t1), l) : a;
                        }, l;
                    }
                    function S() {
                        var t1 = k, n = null, i = r(0), a = A, o = r(!0), s = null, l = T, c = null;
                        function u(r) {
                            var u, f, h, p, d, m = r.length, g = !1, v = new Array(m), y = new Array(m);
                            for(null == s && (c = l(d = e1.path())), u = 0; u <= m; ++u){
                                if (!(u < m && o(p = r[u], u, r)) === g) {
                                    if (g = !g) f = u, c.areaStart(), c.lineStart();
                                    else {
                                        for(c.lineEnd(), c.lineStart(), h = u - 1; h >= f; --h)c.point(v[h], y[h]);
                                        c.lineEnd(), c.areaEnd();
                                    }
                                }
                                g && (v[u] = +t1(p, u, r), y[u] = +i(p, u, r), c.point(n ? +n(p, u, r) : v[u], a ? +a(p, u, r) : y[u]));
                            }
                            if (d) return c = null, d + "" || null;
                        }
                        function f() {
                            return M().defined(o).curve(l).context(s);
                        }
                        return u.x = function(e1) {
                            return arguments.length ? (t1 = "function" == typeof e1 ? e1 : r(+e1), n = null, u) : t1;
                        }, u.x0 = function(e1) {
                            return arguments.length ? (t1 = "function" == typeof e1 ? e1 : r(+e1), u) : t1;
                        }, u.x1 = function(t1) {
                            return arguments.length ? (n = null == t1 ? null : "function" == typeof t1 ? t1 : r(+t1), u) : n;
                        }, u.y = function(t1) {
                            return arguments.length ? (i = "function" == typeof t1 ? t1 : r(+t1), a = null, u) : i;
                        }, u.y0 = function(t1) {
                            return arguments.length ? (i = "function" == typeof t1 ? t1 : r(+t1), u) : i;
                        }, u.y1 = function(t1) {
                            return arguments.length ? (a = null == t1 ? null : "function" == typeof t1 ? t1 : r(+t1), u) : a;
                        }, u.lineX0 = u.lineY0 = function() {
                            return f().x(t1).y(i);
                        }, u.lineY1 = function() {
                            return f().x(t1).y(a);
                        }, u.lineX1 = function() {
                            return f().x(n).y(i);
                        }, u.defined = function(t1) {
                            return arguments.length ? (o = "function" == typeof t1 ? t1 : r(!!t1), u) : o;
                        }, u.curve = function(t1) {
                            return arguments.length ? (l = t1, null != s && (c = l(s)), u) : l;
                        }, u.context = function(t1) {
                            return arguments.length ? (null == t1 ? s = c = null : c = l(s = t1), u) : s;
                        }, u;
                    }
                    function E(t1, e1) {
                        return e1 < t1 ? -1 : e1 > t1 ? 1 : e1 >= t1 ? 0 : NaN;
                    }
                    function L(t1) {
                        return t1;
                    }
                    w.prototype = {
                        areaStart: function() {
                            this._line = 0;
                        },
                        areaEnd: function() {
                            this._line = NaN;
                        },
                        lineStart: function() {
                            this._point = 0;
                        },
                        lineEnd: function() {
                            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
                        },
                        point: function(t1, e1) {
                            switch(t1 = +t1, e1 = +e1, this._point){
                                case 0:
                                    this._point = 1, this._line ? this._context.lineTo(t1, e1) : this._context.moveTo(t1, e1);
                                    break;
                                case 1:
                                    this._point = 2;
                                default:
                                    this._context.lineTo(t1, e1);
                            }
                        }
                    };
                    var C = I(T);
                    function P(t1) {
                        this._curve = t1;
                    }
                    function I(t1) {
                        function e1(e1) {
                            return new P(t1(e1));
                        }
                        return e1._curve = t1, e1;
                    }
                    function O(t1) {
                        var e1 = t1.curve;
                        return t1.angle = t1.x, delete t1.x, t1.radius = t1.y, delete t1.y, t1.curve = function(t1) {
                            return arguments.length ? e1(I(t1)) : e1()._curve;
                        }, t1;
                    }
                    function z() {
                        return O(M().curve(C));
                    }
                    function D() {
                        var t1 = S().curve(C), e1 = t1.curve, r = t1.lineX0, n = t1.lineX1, i = t1.lineY0, a = t1.lineY1;
                        return t1.angle = t1.x, delete t1.x, t1.startAngle = t1.x0, delete t1.x0, t1.endAngle = t1.x1, delete t1.x1, t1.radius = t1.y, delete t1.y, t1.innerRadius = t1.y0, delete t1.y0, t1.outerRadius = t1.y1, delete t1.y1, t1.lineStartAngle = function() {
                            return O(r());
                        }, delete t1.lineX0, t1.lineEndAngle = function() {
                            return O(n());
                        }, delete t1.lineX1, t1.lineInnerRadius = function() {
                            return O(i());
                        }, delete t1.lineY0, t1.lineOuterRadius = function() {
                            return O(a());
                        }, delete t1.lineY1, t1.curve = function(t1) {
                            return arguments.length ? e1(I(t1)) : e1()._curve;
                        }, t1;
                    }
                    function R(t1, e1) {
                        return [
                            (e1 = +e1) * Math.cos(t1 -= Math.PI / 2),
                            e1 * Math.sin(t1)
                        ];
                    }
                    P.prototype = {
                        areaStart: function() {
                            this._curve.areaStart();
                        },
                        areaEnd: function() {
                            this._curve.areaEnd();
                        },
                        lineStart: function() {
                            this._curve.lineStart();
                        },
                        lineEnd: function() {
                            this._curve.lineEnd();
                        },
                        point: function(t1, e1) {
                            this._curve.point(e1 * Math.sin(t1), e1 * -Math.cos(t1));
                        }
                    };
                    var F = Array.prototype.slice;
                    function B(t1) {
                        return t1.source;
                    }
                    function N(t1) {
                        return t1.target;
                    }
                    function j(t1) {
                        var n = B, i = N, a = k, o = A, s = null;
                        function l() {
                            var r, l = F.call(arguments), c = n.apply(this, l), u = i.apply(this, l);
                            if (s || (s = r = e1.path()), t1(s, +a.apply(this, (l[0] = c, l)), +o.apply(this, l), +a.apply(this, (l[0] = u, l)), +o.apply(this, l)), r) return s = null, r + "" || null;
                        }
                        return l.source = function(t1) {
                            return arguments.length ? (n = t1, l) : n;
                        }, l.target = function(t1) {
                            return arguments.length ? (i = t1, l) : i;
                        }, l.x = function(t1) {
                            return arguments.length ? (a = "function" == typeof t1 ? t1 : r(+t1), l) : a;
                        }, l.y = function(t1) {
                            return arguments.length ? (o = "function" == typeof t1 ? t1 : r(+t1), l) : o;
                        }, l.context = function(t1) {
                            return arguments.length ? (s = null == t1 ? null : t1, l) : s;
                        }, l;
                    }
                    function U(t1, e1, r, n, i) {
                        t1.moveTo(e1, r), t1.bezierCurveTo(e1 = (e1 + n) / 2, r, e1, i, n, i);
                    }
                    function V(t1, e1, r, n, i) {
                        t1.moveTo(e1, r), t1.bezierCurveTo(e1, r = (r + i) / 2, n, r, n, i);
                    }
                    function H(t1, e1, r, n, i) {
                        var a = R(e1, r), o = R(e1, r = (r + i) / 2), s = R(n, r), l = R(n, i);
                        t1.moveTo(a[0], a[1]), t1.bezierCurveTo(o[0], o[1], s[0], s[1], l[0], l[1]);
                    }
                    var q = {
                        draw: function(t1, e1) {
                            var r = Math.sqrt(e1 / u);
                            t1.moveTo(r, 0), t1.arc(0, 0, r, 0, h);
                        }
                    }, G = {
                        draw: function(t1, e1) {
                            var r = Math.sqrt(e1 / 5) / 2;
                            t1.moveTo(-3 * r, -r), t1.lineTo(-r, -r), t1.lineTo(-r, -3 * r), t1.lineTo(r, -3 * r), t1.lineTo(r, -r), t1.lineTo(3 * r, -r), t1.lineTo(3 * r, r), t1.lineTo(r, r), t1.lineTo(r, 3 * r), t1.lineTo(-r, 3 * r), t1.lineTo(-r, r), t1.lineTo(-3 * r, r), t1.closePath();
                        }
                    }, Y = Math.sqrt(1 / 3), W = 2 * Y, X = {
                        draw: function(t1, e1) {
                            var r = Math.sqrt(e1 / W), n = r * Y;
                            t1.moveTo(0, -r), t1.lineTo(n, 0), t1.lineTo(0, r), t1.lineTo(-n, 0), t1.closePath();
                        }
                    }, Z = Math.sin(u / 10) / Math.sin(7 * u / 10), J = Math.sin(h / 10) * Z, K = -Math.cos(h / 10) * Z, Q = {
                        draw: function(t1, e1) {
                            var r = Math.sqrt(.8908130915292852 * e1), n = J * r, i = K * r;
                            t1.moveTo(0, -r), t1.lineTo(n, i);
                            for(var a = 1; a < 5; ++a){
                                var o = h * a / 5, s = Math.cos(o), l = Math.sin(o);
                                t1.lineTo(l * r, -s * r), t1.lineTo(s * n - l * i, l * n + s * i);
                            }
                            t1.closePath();
                        }
                    }, $ = {
                        draw: function(t1, e1) {
                            var r = Math.sqrt(e1), n = -r / 2;
                            t1.rect(n, n, r, r);
                        }
                    }, tt = Math.sqrt(3), et = {
                        draw: function(t1, e1) {
                            var r = -Math.sqrt(e1 / (3 * tt));
                            t1.moveTo(0, 2 * r), t1.lineTo(-tt * r, -r), t1.lineTo(tt * r, -r), t1.closePath();
                        }
                    }, rt = -0.5, nt = Math.sqrt(3) / 2, it = 1 / Math.sqrt(12), at = 3 * (it / 2 + 1), ot = {
                        draw: function(t1, e1) {
                            var r = Math.sqrt(e1 / at), n = r / 2, i = r * it, a = n, o = r * it + r, s = -a, l = o;
                            t1.moveTo(n, i), t1.lineTo(a, o), t1.lineTo(s, l), t1.lineTo(rt * n - nt * i, nt * n + rt * i), t1.lineTo(rt * a - nt * o, nt * a + rt * o), t1.lineTo(rt * s - nt * l, nt * s + rt * l), t1.lineTo(rt * n + nt * i, rt * i - nt * n), t1.lineTo(rt * a + nt * o, rt * o - nt * a), t1.lineTo(rt * s + nt * l, rt * l - nt * s), t1.closePath();
                        }
                    }, st = [
                        q,
                        G,
                        X,
                        $,
                        Q,
                        et,
                        ot
                    ];
                    function lt() {}
                    function ct(t1, e1, r) {
                        t1._context.bezierCurveTo((2 * t1._x0 + t1._x1) / 3, (2 * t1._y0 + t1._y1) / 3, (t1._x0 + 2 * t1._x1) / 3, (t1._y0 + 2 * t1._y1) / 3, (t1._x0 + 4 * t1._x1 + e1) / 6, (t1._y0 + 4 * t1._y1 + r) / 6);
                    }
                    function ut(t1) {
                        this._context = t1;
                    }
                    function ft(t1) {
                        this._context = t1;
                    }
                    function ht(t1) {
                        this._context = t1;
                    }
                    function pt(t1, e1) {
                        this._basis = new ut(t1), this._beta = e1;
                    }
                    ut.prototype = {
                        areaStart: function() {
                            this._line = 0;
                        },
                        areaEnd: function() {
                            this._line = NaN;
                        },
                        lineStart: function() {
                            this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
                        },
                        lineEnd: function() {
                            switch(this._point){
                                case 3:
                                    ct(this, this._x1, this._y1);
                                case 2:
                                    this._context.lineTo(this._x1, this._y1);
                            }
                            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
                        },
                        point: function(t1, e1) {
                            switch(t1 = +t1, e1 = +e1, this._point){
                                case 0:
                                    this._point = 1, this._line ? this._context.lineTo(t1, e1) : this._context.moveTo(t1, e1);
                                    break;
                                case 1:
                                    this._point = 2;
                                    break;
                                case 2:
                                    this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
                                default:
                                    ct(this, t1, e1);
                            }
                            this._x0 = this._x1, this._x1 = t1, this._y0 = this._y1, this._y1 = e1;
                        }
                    }, ft.prototype = {
                        areaStart: lt,
                        areaEnd: lt,
                        lineStart: function() {
                            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
                        },
                        lineEnd: function() {
                            switch(this._point){
                                case 1:
                                    this._context.moveTo(this._x2, this._y2), this._context.closePath();
                                    break;
                                case 2:
                                    this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
                                    break;
                                case 3:
                                    this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
                            }
                        },
                        point: function(t1, e1) {
                            switch(t1 = +t1, e1 = +e1, this._point){
                                case 0:
                                    this._point = 1, this._x2 = t1, this._y2 = e1;
                                    break;
                                case 1:
                                    this._point = 2, this._x3 = t1, this._y3 = e1;
                                    break;
                                case 2:
                                    this._point = 3, this._x4 = t1, this._y4 = e1, this._context.moveTo((this._x0 + 4 * this._x1 + t1) / 6, (this._y0 + 4 * this._y1 + e1) / 6);
                                    break;
                                default:
                                    ct(this, t1, e1);
                            }
                            this._x0 = this._x1, this._x1 = t1, this._y0 = this._y1, this._y1 = e1;
                        }
                    }, ht.prototype = {
                        areaStart: function() {
                            this._line = 0;
                        },
                        areaEnd: function() {
                            this._line = NaN;
                        },
                        lineStart: function() {
                            this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
                        },
                        lineEnd: function() {
                            (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
                        },
                        point: function(t1, e1) {
                            switch(t1 = +t1, e1 = +e1, this._point){
                                case 0:
                                    this._point = 1;
                                    break;
                                case 1:
                                    this._point = 2;
                                    break;
                                case 2:
                                    this._point = 3;
                                    var r = (this._x0 + 4 * this._x1 + t1) / 6, n = (this._y0 + 4 * this._y1 + e1) / 6;
                                    this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
                                    break;
                                case 3:
                                    this._point = 4;
                                default:
                                    ct(this, t1, e1);
                            }
                            this._x0 = this._x1, this._x1 = t1, this._y0 = this._y1, this._y1 = e1;
                        }
                    }, pt.prototype = {
                        lineStart: function() {
                            this._x = [], this._y = [], this._basis.lineStart();
                        },
                        lineEnd: function() {
                            var t1 = this._x, e1 = this._y, r = t1.length - 1;
                            if (r > 0) for(var n, i = t1[0], a = e1[0], o = t1[r] - i, s = e1[r] - a, l = -1; ++l <= r;)n = l / r, this._basis.point(this._beta * t1[l] + (1 - this._beta) * (i + n * o), this._beta * e1[l] + (1 - this._beta) * (a + n * s));
                            this._x = this._y = null, this._basis.lineEnd();
                        },
                        point: function(t1, e1) {
                            this._x.push(+t1), this._y.push(+e1);
                        }
                    };
                    var dt = function t1(e1) {
                        function r(t1) {
                            return 1 === e1 ? new ut(t1) : new pt(t1, e1);
                        }
                        return r.beta = function(e1) {
                            return t1(+e1);
                        }, r;
                    }(.85);
                    function mt(t1, e1, r) {
                        t1._context.bezierCurveTo(t1._x1 + t1._k * (t1._x2 - t1._x0), t1._y1 + t1._k * (t1._y2 - t1._y0), t1._x2 + t1._k * (t1._x1 - e1), t1._y2 + t1._k * (t1._y1 - r), t1._x2, t1._y2);
                    }
                    function gt(t1, e1) {
                        this._context = t1, this._k = (1 - e1) / 6;
                    }
                    gt.prototype = {
                        areaStart: function() {
                            this._line = 0;
                        },
                        areaEnd: function() {
                            this._line = NaN;
                        },
                        lineStart: function() {
                            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
                        },
                        lineEnd: function() {
                            switch(this._point){
                                case 2:
                                    this._context.lineTo(this._x2, this._y2);
                                    break;
                                case 3:
                                    mt(this, this._x1, this._y1);
                            }
                            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
                        },
                        point: function(t1, e1) {
                            switch(t1 = +t1, e1 = +e1, this._point){
                                case 0:
                                    this._point = 1, this._line ? this._context.lineTo(t1, e1) : this._context.moveTo(t1, e1);
                                    break;
                                case 1:
                                    this._point = 2, this._x1 = t1, this._y1 = e1;
                                    break;
                                case 2:
                                    this._point = 3;
                                default:
                                    mt(this, t1, e1);
                            }
                            this._x0 = this._x1, this._x1 = this._x2, this._x2 = t1, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e1;
                        }
                    };
                    var vt = function t1(e1) {
                        function r(t1) {
                            return new gt(t1, e1);
                        }
                        return r.tension = function(e1) {
                            return t1(+e1);
                        }, r;
                    }(0);
                    function yt(t1, e1) {
                        this._context = t1, this._k = (1 - e1) / 6;
                    }
                    yt.prototype = {
                        areaStart: lt,
                        areaEnd: lt,
                        lineStart: function() {
                            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
                        },
                        lineEnd: function() {
                            switch(this._point){
                                case 1:
                                    this._context.moveTo(this._x3, this._y3), this._context.closePath();
                                    break;
                                case 2:
                                    this._context.lineTo(this._x3, this._y3), this._context.closePath();
                                    break;
                                case 3:
                                    this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
                            }
                        },
                        point: function(t1, e1) {
                            switch(t1 = +t1, e1 = +e1, this._point){
                                case 0:
                                    this._point = 1, this._x3 = t1, this._y3 = e1;
                                    break;
                                case 1:
                                    this._point = 2, this._context.moveTo(this._x4 = t1, this._y4 = e1);
                                    break;
                                case 2:
                                    this._point = 3, this._x5 = t1, this._y5 = e1;
                                    break;
                                default:
                                    mt(this, t1, e1);
                            }
                            this._x0 = this._x1, this._x1 = this._x2, this._x2 = t1, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e1;
                        }
                    };
                    var xt = function t1(e1) {
                        function r(t1) {
                            return new yt(t1, e1);
                        }
                        return r.tension = function(e1) {
                            return t1(+e1);
                        }, r;
                    }(0);
                    function bt(t1, e1) {
                        this._context = t1, this._k = (1 - e1) / 6;
                    }
                    bt.prototype = {
                        areaStart: function() {
                            this._line = 0;
                        },
                        areaEnd: function() {
                            this._line = NaN;
                        },
                        lineStart: function() {
                            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
                        },
                        lineEnd: function() {
                            (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
                        },
                        point: function(t1, e1) {
                            switch(t1 = +t1, e1 = +e1, this._point){
                                case 0:
                                    this._point = 1;
                                    break;
                                case 1:
                                    this._point = 2;
                                    break;
                                case 2:
                                    this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                                    break;
                                case 3:
                                    this._point = 4;
                                default:
                                    mt(this, t1, e1);
                            }
                            this._x0 = this._x1, this._x1 = this._x2, this._x2 = t1, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e1;
                        }
                    };
                    var _t = function t1(e1) {
                        function r(t1) {
                            return new bt(t1, e1);
                        }
                        return r.tension = function(e1) {
                            return t1(+e1);
                        }, r;
                    }(0);
                    function wt(t1, e1, r) {
                        var n = t1._x1, i = t1._y1, a = t1._x2, o = t1._y2;
                        if (t1._l01_a > 1e-12) {
                            var s = 2 * t1._l01_2a + 3 * t1._l01_a * t1._l12_a + t1._l12_2a, l = 3 * t1._l01_a * (t1._l01_a + t1._l12_a);
                            n = (n * s - t1._x0 * t1._l12_2a + t1._x2 * t1._l01_2a) / l, i = (i * s - t1._y0 * t1._l12_2a + t1._y2 * t1._l01_2a) / l;
                        }
                        if (t1._l23_a > 1e-12) {
                            var c = 2 * t1._l23_2a + 3 * t1._l23_a * t1._l12_a + t1._l12_2a, u = 3 * t1._l23_a * (t1._l23_a + t1._l12_a);
                            a = (a * c + t1._x1 * t1._l23_2a - e1 * t1._l12_2a) / u, o = (o * c + t1._y1 * t1._l23_2a - r * t1._l12_2a) / u;
                        }
                        t1._context.bezierCurveTo(n, i, a, o, t1._x2, t1._y2);
                    }
                    function Tt(t1, e1) {
                        this._context = t1, this._alpha = e1;
                    }
                    Tt.prototype = {
                        areaStart: function() {
                            this._line = 0;
                        },
                        areaEnd: function() {
                            this._line = NaN;
                        },
                        lineStart: function() {
                            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
                        },
                        lineEnd: function() {
                            switch(this._point){
                                case 2:
                                    this._context.lineTo(this._x2, this._y2);
                                    break;
                                case 3:
                                    this.point(this._x2, this._y2);
                            }
                            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
                        },
                        point: function(t1, e1) {
                            if (t1 = +t1, e1 = +e1, this._point) {
                                var r = this._x2 - t1, n = this._y2 - e1;
                                this._l23_a = Math.sqrt(this._l23_2a = Math.pow(r * r + n * n, this._alpha));
                            }
                            switch(this._point){
                                case 0:
                                    this._point = 1, this._line ? this._context.lineTo(t1, e1) : this._context.moveTo(t1, e1);
                                    break;
                                case 1:
                                    this._point = 2;
                                    break;
                                case 2:
                                    this._point = 3;
                                default:
                                    wt(this, t1, e1);
                            }
                            this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t1, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e1;
                        }
                    };
                    var kt = function t1(e1) {
                        function r(t1) {
                            return e1 ? new Tt(t1, e1) : new gt(t1, 0);
                        }
                        return r.alpha = function(e1) {
                            return t1(+e1);
                        }, r;
                    }(.5);
                    function At(t1, e1) {
                        this._context = t1, this._alpha = e1;
                    }
                    At.prototype = {
                        areaStart: lt,
                        areaEnd: lt,
                        lineStart: function() {
                            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
                        },
                        lineEnd: function() {
                            switch(this._point){
                                case 1:
                                    this._context.moveTo(this._x3, this._y3), this._context.closePath();
                                    break;
                                case 2:
                                    this._context.lineTo(this._x3, this._y3), this._context.closePath();
                                    break;
                                case 3:
                                    this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
                            }
                        },
                        point: function(t1, e1) {
                            if (t1 = +t1, e1 = +e1, this._point) {
                                var r = this._x2 - t1, n = this._y2 - e1;
                                this._l23_a = Math.sqrt(this._l23_2a = Math.pow(r * r + n * n, this._alpha));
                            }
                            switch(this._point){
                                case 0:
                                    this._point = 1, this._x3 = t1, this._y3 = e1;
                                    break;
                                case 1:
                                    this._point = 2, this._context.moveTo(this._x4 = t1, this._y4 = e1);
                                    break;
                                case 2:
                                    this._point = 3, this._x5 = t1, this._y5 = e1;
                                    break;
                                default:
                                    wt(this, t1, e1);
                            }
                            this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t1, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e1;
                        }
                    };
                    var Mt = function t1(e1) {
                        function r(t1) {
                            return e1 ? new At(t1, e1) : new yt(t1, 0);
                        }
                        return r.alpha = function(e1) {
                            return t1(+e1);
                        }, r;
                    }(.5);
                    function St(t1, e1) {
                        this._context = t1, this._alpha = e1;
                    }
                    St.prototype = {
                        areaStart: function() {
                            this._line = 0;
                        },
                        areaEnd: function() {
                            this._line = NaN;
                        },
                        lineStart: function() {
                            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
                        },
                        lineEnd: function() {
                            (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
                        },
                        point: function(t1, e1) {
                            if (t1 = +t1, e1 = +e1, this._point) {
                                var r = this._x2 - t1, n = this._y2 - e1;
                                this._l23_a = Math.sqrt(this._l23_2a = Math.pow(r * r + n * n, this._alpha));
                            }
                            switch(this._point){
                                case 0:
                                    this._point = 1;
                                    break;
                                case 1:
                                    this._point = 2;
                                    break;
                                case 2:
                                    this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                                    break;
                                case 3:
                                    this._point = 4;
                                default:
                                    wt(this, t1, e1);
                            }
                            this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t1, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e1;
                        }
                    };
                    var Et = function t1(e1) {
                        function r(t1) {
                            return e1 ? new St(t1, e1) : new bt(t1, 0);
                        }
                        return r.alpha = function(e1) {
                            return t1(+e1);
                        }, r;
                    }(.5);
                    function Lt(t1) {
                        this._context = t1;
                    }
                    function Ct(t1) {
                        return t1 < 0 ? -1 : 1;
                    }
                    function Pt(t1, e1, r) {
                        var n = t1._x1 - t1._x0, i = e1 - t1._x1, a = (t1._y1 - t1._y0) / (n || i < 0 && -0), o = (r - t1._y1) / (i || n < 0 && -0), s = (a * i + o * n) / (n + i);
                        return (Ct(a) + Ct(o)) * Math.min(Math.abs(a), Math.abs(o), .5 * Math.abs(s)) || 0;
                    }
                    function It(t1, e1) {
                        var r = t1._x1 - t1._x0;
                        return r ? (3 * (t1._y1 - t1._y0) / r - e1) / 2 : e1;
                    }
                    function Ot(t1, e1, r) {
                        var n = t1._x0, i = t1._y0, a = t1._x1, o = t1._y1, s = (a - n) / 3;
                        t1._context.bezierCurveTo(n + s, i + s * e1, a - s, o - s * r, a, o);
                    }
                    function zt(t1) {
                        this._context = t1;
                    }
                    function Dt(t1) {
                        this._context = new Rt(t1);
                    }
                    function Rt(t1) {
                        this._context = t1;
                    }
                    function Ft(t1) {
                        this._context = t1;
                    }
                    function Bt(t1) {
                        var e1, r, n = t1.length - 1, i = new Array(n), a = new Array(n), o = new Array(n);
                        for(i[0] = 0, a[0] = 2, o[0] = t1[0] + 2 * t1[1], e1 = 1; e1 < n - 1; ++e1)i[e1] = 1, a[e1] = 4, o[e1] = 4 * t1[e1] + 2 * t1[e1 + 1];
                        for(i[n - 1] = 2, a[n - 1] = 7, o[n - 1] = 8 * t1[n - 1] + t1[n], e1 = 1; e1 < n; ++e1)r = i[e1] / a[e1 - 1], a[e1] -= r, o[e1] -= r * o[e1 - 1];
                        for(i[n - 1] = o[n - 1] / a[n - 1], e1 = n - 2; e1 >= 0; --e1)i[e1] = (o[e1] - i[e1 + 1]) / a[e1];
                        for(a[n - 1] = (t1[n] + i[n - 1]) / 2, e1 = 0; e1 < n - 1; ++e1)a[e1] = 2 * t1[e1 + 1] - i[e1 + 1];
                        return [
                            i,
                            a
                        ];
                    }
                    function Nt(t1, e1) {
                        this._context = t1, this._t = e1;
                    }
                    function jt(t1, e1) {
                        if ((i = t1.length) > 1) for(var r, n, i, a = 1, o = t1[e1[0]], s = o.length; a < i; ++a)for(n = o, o = t1[e1[a]], r = 0; r < s; ++r)o[r][1] += o[r][0] = isNaN(n[r][1]) ? n[r][0] : n[r][1];
                    }
                    function Ut(t1) {
                        for(var e1 = t1.length, r = new Array(e1); --e1 >= 0;)r[e1] = e1;
                        return r;
                    }
                    function Vt(t1, e1) {
                        return t1[e1];
                    }
                    function Ht(t1) {
                        var e1 = t1.map(qt);
                        return Ut(t1).sort(function(t1, r) {
                            return e1[t1] - e1[r];
                        });
                    }
                    function qt(t1) {
                        for(var e1, r = -1, n = 0, i = t1.length, a = -1 / 0; ++r < i;)(e1 = +t1[r][1]) > a && (a = e1, n = r);
                        return n;
                    }
                    function Gt(t1) {
                        var e1 = t1.map(Yt);
                        return Ut(t1).sort(function(t1, r) {
                            return e1[t1] - e1[r];
                        });
                    }
                    function Yt(t1) {
                        for(var e1, r = 0, n = -1, i = t1.length; ++n < i;)(e1 = +t1[n][1]) && (r += e1);
                        return r;
                    }
                    Lt.prototype = {
                        areaStart: lt,
                        areaEnd: lt,
                        lineStart: function() {
                            this._point = 0;
                        },
                        lineEnd: function() {
                            this._point && this._context.closePath();
                        },
                        point: function(t1, e1) {
                            t1 = +t1, e1 = +e1, this._point ? this._context.lineTo(t1, e1) : (this._point = 1, this._context.moveTo(t1, e1));
                        }
                    }, zt.prototype = {
                        areaStart: function() {
                            this._line = 0;
                        },
                        areaEnd: function() {
                            this._line = NaN;
                        },
                        lineStart: function() {
                            this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
                        },
                        lineEnd: function() {
                            switch(this._point){
                                case 2:
                                    this._context.lineTo(this._x1, this._y1);
                                    break;
                                case 3:
                                    Ot(this, this._t0, It(this, this._t0));
                            }
                            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
                        },
                        point: function(t1, e1) {
                            var r = NaN;
                            if (e1 = +e1, (t1 = +t1) !== this._x1 || e1 !== this._y1) {
                                switch(this._point){
                                    case 0:
                                        this._point = 1, this._line ? this._context.lineTo(t1, e1) : this._context.moveTo(t1, e1);
                                        break;
                                    case 1:
                                        this._point = 2;
                                        break;
                                    case 2:
                                        this._point = 3, Ot(this, It(this, r = Pt(this, t1, e1)), r);
                                        break;
                                    default:
                                        Ot(this, this._t0, r = Pt(this, t1, e1));
                                }
                                this._x0 = this._x1, this._x1 = t1, this._y0 = this._y1, this._y1 = e1, this._t0 = r;
                            }
                        }
                    }, (Dt.prototype = Object.create(zt.prototype)).point = function(t1, e1) {
                        zt.prototype.point.call(this, e1, t1);
                    }, Rt.prototype = {
                        moveTo: function(t1, e1) {
                            this._context.moveTo(e1, t1);
                        },
                        closePath: function() {
                            this._context.closePath();
                        },
                        lineTo: function(t1, e1) {
                            this._context.lineTo(e1, t1);
                        },
                        bezierCurveTo: function(t1, e1, r, n, i, a) {
                            this._context.bezierCurveTo(e1, t1, n, r, a, i);
                        }
                    }, Ft.prototype = {
                        areaStart: function() {
                            this._line = 0;
                        },
                        areaEnd: function() {
                            this._line = NaN;
                        },
                        lineStart: function() {
                            this._x = [], this._y = [];
                        },
                        lineEnd: function() {
                            var t1 = this._x, e1 = this._y, r = t1.length;
                            if (r) {
                                if (this._line ? this._context.lineTo(t1[0], e1[0]) : this._context.moveTo(t1[0], e1[0]), 2 === r) this._context.lineTo(t1[1], e1[1]);
                                else for(var n = Bt(t1), i = Bt(e1), a = 0, o = 1; o < r; ++a, ++o)this._context.bezierCurveTo(n[0][a], i[0][a], n[1][a], i[1][a], t1[o], e1[o]);
                            }
                            (this._line || 0 !== this._line && 1 === r) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
                        },
                        point: function(t1, e1) {
                            this._x.push(+t1), this._y.push(+e1);
                        }
                    }, Nt.prototype = {
                        areaStart: function() {
                            this._line = 0;
                        },
                        areaEnd: function() {
                            this._line = NaN;
                        },
                        lineStart: function() {
                            this._x = this._y = NaN, this._point = 0;
                        },
                        lineEnd: function() {
                            0 < this._t && this._t < 1 && 2 === this._point && this._context.lineTo(this._x, this._y), (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
                        },
                        point: function(t1, e1) {
                            switch(t1 = +t1, e1 = +e1, this._point){
                                case 0:
                                    this._point = 1, this._line ? this._context.lineTo(t1, e1) : this._context.moveTo(t1, e1);
                                    break;
                                case 1:
                                    this._point = 2;
                                default:
                                    if (this._t <= 0) this._context.lineTo(this._x, e1), this._context.lineTo(t1, e1);
                                    else {
                                        var r = this._x * (1 - this._t) + t1 * this._t;
                                        this._context.lineTo(r, this._y), this._context.lineTo(r, e1);
                                    }
                            }
                            this._x = t1, this._y = e1;
                        }
                    }, t1.arc = function() {
                        var t1 = m, o = g, w = r(0), T = null, k = v, A = y, M = x, S = null;
                        function E() {
                            var r, m, g = +t1.apply(this, arguments), v = +o.apply(this, arguments), y = k.apply(this, arguments) - f, x = A.apply(this, arguments) - f, E = n(x - y), L = x > y;
                            if (S || (S = r = e1.path()), v < g && (m = v, v = g, g = m), v > 1e-12) {
                                if (E > h - 1e-12) S.moveTo(v * a(y), v * l(y)), S.arc(0, 0, v, y, x, !L), g > 1e-12 && (S.moveTo(g * a(x), g * l(x)), S.arc(0, 0, g, x, y, L));
                                else {
                                    var C, P, I = y, O = x, z = y, D = x, R = E, F = E, B = M.apply(this, arguments) / 2, N = B > 1e-12 && (T ? +T.apply(this, arguments) : c(g * g + v * v)), j = s(n(v - g) / 2, +w.apply(this, arguments)), U = j, V = j;
                                    if (N > 1e-12) {
                                        var H = d(N / g * l(B)), q = d(N / v * l(B));
                                        (R -= 2 * H) > 1e-12 ? (z += H *= L ? 1 : -1, D -= H) : (R = 0, z = D = (y + x) / 2), (F -= 2 * q) > 1e-12 ? (I += q *= L ? 1 : -1, O -= q) : (F = 0, I = O = (y + x) / 2);
                                    }
                                    var G = v * a(I), Y = v * l(I), W = g * a(D), X = g * l(D);
                                    if (j > 1e-12) {
                                        var Z, J = v * a(O), K = v * l(O), Q = g * a(z), $ = g * l(z);
                                        if (E < u && (Z = b(G, Y, Q, $, J, K, W, X))) {
                                            var tt = G - Z[0], et = Y - Z[1], rt = J - Z[0], nt = K - Z[1], it = 1 / l(p((tt * rt + et * nt) / (c(tt * tt + et * et) * c(rt * rt + nt * nt))) / 2), at = c(Z[0] * Z[0] + Z[1] * Z[1]);
                                            U = s(j, (g - at) / (it - 1)), V = s(j, (v - at) / (it + 1));
                                        }
                                    }
                                    F > 1e-12 ? V > 1e-12 ? (C = _(Q, $, G, Y, v, V, L), P = _(J, K, W, X, v, V, L), S.moveTo(C.cx + C.x01, C.cy + C.y01), V < j ? S.arc(C.cx, C.cy, V, i(C.y01, C.x01), i(P.y01, P.x01), !L) : (S.arc(C.cx, C.cy, V, i(C.y01, C.x01), i(C.y11, C.x11), !L), S.arc(0, 0, v, i(C.cy + C.y11, C.cx + C.x11), i(P.cy + P.y11, P.cx + P.x11), !L), S.arc(P.cx, P.cy, V, i(P.y11, P.x11), i(P.y01, P.x01), !L))) : (S.moveTo(G, Y), S.arc(0, 0, v, I, O, !L)) : S.moveTo(G, Y), g > 1e-12 && R > 1e-12 ? U > 1e-12 ? (C = _(W, X, J, K, g, -U, L), P = _(G, Y, Q, $, g, -U, L), S.lineTo(C.cx + C.x01, C.cy + C.y01), U < j ? S.arc(C.cx, C.cy, U, i(C.y01, C.x01), i(P.y01, P.x01), !L) : (S.arc(C.cx, C.cy, U, i(C.y01, C.x01), i(C.y11, C.x11), !L), S.arc(0, 0, g, i(C.cy + C.y11, C.cx + C.x11), i(P.cy + P.y11, P.cx + P.x11), L), S.arc(P.cx, P.cy, U, i(P.y11, P.x11), i(P.y01, P.x01), !L))) : S.arc(0, 0, g, D, z, L) : S.lineTo(W, X);
                                }
                            } else S.moveTo(0, 0);
                            if (S.closePath(), r) return S = null, r + "" || null;
                        }
                        return E.centroid = function() {
                            var e1 = (+t1.apply(this, arguments) + +o.apply(this, arguments)) / 2, r = (+k.apply(this, arguments) + +A.apply(this, arguments)) / 2 - u / 2;
                            return [
                                a(r) * e1,
                                l(r) * e1
                            ];
                        }, E.innerRadius = function(e1) {
                            return arguments.length ? (t1 = "function" == typeof e1 ? e1 : r(+e1), E) : t1;
                        }, E.outerRadius = function(t1) {
                            return arguments.length ? (o = "function" == typeof t1 ? t1 : r(+t1), E) : o;
                        }, E.cornerRadius = function(t1) {
                            return arguments.length ? (w = "function" == typeof t1 ? t1 : r(+t1), E) : w;
                        }, E.padRadius = function(t1) {
                            return arguments.length ? (T = null == t1 ? null : "function" == typeof t1 ? t1 : r(+t1), E) : T;
                        }, E.startAngle = function(t1) {
                            return arguments.length ? (k = "function" == typeof t1 ? t1 : r(+t1), E) : k;
                        }, E.endAngle = function(t1) {
                            return arguments.length ? (A = "function" == typeof t1 ? t1 : r(+t1), E) : A;
                        }, E.padAngle = function(t1) {
                            return arguments.length ? (M = "function" == typeof t1 ? t1 : r(+t1), E) : M;
                        }, E.context = function(t1) {
                            return arguments.length ? (S = null == t1 ? null : t1, E) : S;
                        }, E;
                    }, t1.area = S, t1.areaRadial = D, t1.curveBasis = function(t1) {
                        return new ut(t1);
                    }, t1.curveBasisClosed = function(t1) {
                        return new ft(t1);
                    }, t1.curveBasisOpen = function(t1) {
                        return new ht(t1);
                    }, t1.curveBundle = dt, t1.curveCardinal = vt, t1.curveCardinalClosed = xt, t1.curveCardinalOpen = _t, t1.curveCatmullRom = kt, t1.curveCatmullRomClosed = Mt, t1.curveCatmullRomOpen = Et, t1.curveLinear = T, t1.curveLinearClosed = function(t1) {
                        return new Lt(t1);
                    }, t1.curveMonotoneX = function(t1) {
                        return new zt(t1);
                    }, t1.curveMonotoneY = function(t1) {
                        return new Dt(t1);
                    }, t1.curveNatural = function(t1) {
                        return new Ft(t1);
                    }, t1.curveStep = function(t1) {
                        return new Nt(t1, .5);
                    }, t1.curveStepAfter = function(t1) {
                        return new Nt(t1, 1);
                    }, t1.curveStepBefore = function(t1) {
                        return new Nt(t1, 0);
                    }, t1.line = M, t1.lineRadial = z, t1.linkHorizontal = function() {
                        return j(U);
                    }, t1.linkRadial = function() {
                        var t1 = j(H);
                        return t1.angle = t1.x, delete t1.x, t1.radius = t1.y, delete t1.y, t1;
                    }, t1.linkVertical = function() {
                        return j(V);
                    }, t1.pie = function() {
                        var t1 = L, e1 = E, n = null, i = r(0), a = r(h), o = r(0);
                        function s(r) {
                            var s, l, c, u, f, p = r.length, d = 0, m = new Array(p), g = new Array(p), v = +i.apply(this, arguments), y = Math.min(h, Math.max(-h, a.apply(this, arguments) - v)), x = Math.min(Math.abs(y) / p, o.apply(this, arguments)), b = x * (y < 0 ? -1 : 1);
                            for(s = 0; s < p; ++s)(f = g[m[s] = s] = +t1(r[s], s, r)) > 0 && (d += f);
                            for(null != e1 ? m.sort(function(t1, r) {
                                return e1(g[t1], g[r]);
                            }) : null != n && m.sort(function(t1, e1) {
                                return n(r[t1], r[e1]);
                            }), s = 0, c = d ? (y - p * b) / d : 0; s < p; ++s, v = u)l = m[s], u = v + ((f = g[l]) > 0 ? f * c : 0) + b, g[l] = {
                                data: r[l],
                                index: s,
                                value: f,
                                startAngle: v,
                                endAngle: u,
                                padAngle: x
                            };
                            return g;
                        }
                        return s.value = function(e1) {
                            return arguments.length ? (t1 = "function" == typeof e1 ? e1 : r(+e1), s) : t1;
                        }, s.sortValues = function(t1) {
                            return arguments.length ? (e1 = t1, n = null, s) : e1;
                        }, s.sort = function(t1) {
                            return arguments.length ? (n = t1, e1 = null, s) : n;
                        }, s.startAngle = function(t1) {
                            return arguments.length ? (i = "function" == typeof t1 ? t1 : r(+t1), s) : i;
                        }, s.endAngle = function(t1) {
                            return arguments.length ? (a = "function" == typeof t1 ? t1 : r(+t1), s) : a;
                        }, s.padAngle = function(t1) {
                            return arguments.length ? (o = "function" == typeof t1 ? t1 : r(+t1), s) : o;
                        }, s;
                    }, t1.pointRadial = R, t1.radialArea = D, t1.radialLine = z, t1.stack = function() {
                        var t1 = r([]), e1 = Ut, n = jt, i = Vt;
                        function a(r) {
                            var a, o, s = t1.apply(this, arguments), l = r.length, c = s.length, u = new Array(c);
                            for(a = 0; a < c; ++a){
                                for(var f, h = s[a], p = u[a] = new Array(l), d = 0; d < l; ++d)p[d] = f = [
                                    0,
                                    +i(r[d], h, d, r)
                                ], f.data = r[d];
                                p.key = h;
                            }
                            for(a = 0, o = e1(u); a < c; ++a)u[o[a]].index = a;
                            return n(u, o), u;
                        }
                        return a.keys = function(e1) {
                            return arguments.length ? (t1 = "function" == typeof e1 ? e1 : r(F.call(e1)), a) : t1;
                        }, a.value = function(t1) {
                            return arguments.length ? (i = "function" == typeof t1 ? t1 : r(+t1), a) : i;
                        }, a.order = function(t1) {
                            return arguments.length ? (e1 = null == t1 ? Ut : "function" == typeof t1 ? t1 : r(F.call(t1)), a) : e1;
                        }, a.offset = function(t1) {
                            return arguments.length ? (n = null == t1 ? jt : t1, a) : n;
                        }, a;
                    }, t1.stackOffsetDiverging = function(t1, e1) {
                        if ((s = t1.length) > 0) for(var r, n, i, a, o, s, l = 0, c = t1[e1[0]].length; l < c; ++l)for(a = o = 0, r = 0; r < s; ++r)(i = (n = t1[e1[r]][l])[1] - n[0]) > 0 ? (n[0] = a, n[1] = a += i) : i < 0 ? (n[1] = o, n[0] = o += i) : (n[0] = 0, n[1] = i);
                    }, t1.stackOffsetExpand = function(t1, e1) {
                        if ((n = t1.length) > 0) {
                            for(var r, n, i, a = 0, o = t1[0].length; a < o; ++a){
                                for(i = r = 0; r < n; ++r)i += t1[r][a][1] || 0;
                                if (i) for(r = 0; r < n; ++r)t1[r][a][1] /= i;
                            }
                            jt(t1, e1);
                        }
                    }, t1.stackOffsetNone = jt, t1.stackOffsetSilhouette = function(t1, e1) {
                        if ((r = t1.length) > 0) {
                            for(var r, n = 0, i = t1[e1[0]], a = i.length; n < a; ++n){
                                for(var o = 0, s = 0; o < r; ++o)s += t1[o][n][1] || 0;
                                i[n][1] += i[n][0] = -s / 2;
                            }
                            jt(t1, e1);
                        }
                    }, t1.stackOffsetWiggle = function(t1, e1) {
                        if ((i = t1.length) > 0 && (n = (r = t1[e1[0]]).length) > 0) {
                            for(var r, n, i, a = 0, o = 1; o < n; ++o){
                                for(var s = 0, l = 0, c = 0; s < i; ++s){
                                    for(var u = t1[e1[s]], f = u[o][1] || 0, h = (f - (u[o - 1][1] || 0)) / 2, p = 0; p < s; ++p){
                                        var d = t1[e1[p]];
                                        h += (d[o][1] || 0) - (d[o - 1][1] || 0);
                                    }
                                    l += f, c += h * f;
                                }
                                r[o - 1][1] += r[o - 1][0] = a, l && (a -= c / l);
                            }
                            r[o - 1][1] += r[o - 1][0] = a, jt(t1, e1);
                        }
                    }, t1.stackOrderAppearance = Ht, t1.stackOrderAscending = Gt, t1.stackOrderDescending = function(t1) {
                        return Gt(t1).reverse();
                    }, t1.stackOrderInsideOut = function(t1) {
                        var e1, r, n = t1.length, i = t1.map(Yt), a = Ht(t1), o = 0, s = 0, l = [], c = [];
                        for(e1 = 0; e1 < n; ++e1)r = a[e1], o < s ? (o += i[r], l.push(r)) : (s += i[r], c.push(r));
                        return c.reverse().concat(l);
                    }, t1.stackOrderNone = Ut, t1.stackOrderReverse = function(t1) {
                        return Ut(t1).reverse();
                    }, t1.symbol = function() {
                        var t1 = r(q), n = r(64), i = null;
                        function a() {
                            var r;
                            if (i || (i = r = e1.path()), t1.apply(this, arguments).draw(i, +n.apply(this, arguments)), r) return i = null, r + "" || null;
                        }
                        return a.type = function(e1) {
                            return arguments.length ? (t1 = "function" == typeof e1 ? e1 : r(e1), a) : t1;
                        }, a.size = function(t1) {
                            return arguments.length ? (n = "function" == typeof t1 ? t1 : r(+t1), a) : n;
                        }, a.context = function(t1) {
                            return arguments.length ? (i = null == t1 ? null : t1, a) : i;
                        }, a;
                    }, t1.symbolCircle = q, t1.symbolCross = G, t1.symbolDiamond = X, t1.symbolSquare = $, t1.symbolStar = Q, t1.symbolTriangle = et, t1.symbolWye = ot, t1.symbols = st, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {
                "d3-path": 117
            }
        ],
        120: [
            function(t1, e1, r) {
                !function(n, i) {
                    "object" == typeof r && void 0 !== e1 ? i(r, t1("d3-time")) : i((n = n || self).d3 = n.d3 || {}, n.d3);
                }(this, function(t1, e1) {
                    "use strict";
                    function r(t1) {
                        if (0 <= t1.y && t1.y < 100) {
                            var e1 = new Date(-1, t1.m, t1.d, t1.H, t1.M, t1.S, t1.L);
                            return e1.setFullYear(t1.y), e1;
                        }
                        return new Date(t1.y, t1.m, t1.d, t1.H, t1.M, t1.S, t1.L);
                    }
                    function n(t1) {
                        if (0 <= t1.y && t1.y < 100) {
                            var e1 = new Date(Date.UTC(-1, t1.m, t1.d, t1.H, t1.M, t1.S, t1.L));
                            return e1.setUTCFullYear(t1.y), e1;
                        }
                        return new Date(Date.UTC(t1.y, t1.m, t1.d, t1.H, t1.M, t1.S, t1.L));
                    }
                    function i(t1, e1, r) {
                        return {
                            y: t1,
                            m: e1,
                            d: r,
                            H: 0,
                            M: 0,
                            S: 0,
                            L: 0
                        };
                    }
                    function a(t1) {
                        var a = t1.dateTime, o = t1.date, l = t1.time, c = t1.periods, u = t1.days, f = t1.shortDays, h = t1.months, yt = t1.shortMonths, xt = p(c), bt = d(c), _t = p(u), wt = d(u), Tt = p(f), kt = d(f), At = p(h), Mt = d(h), St = p(yt), Et = d(yt), Lt = {
                            a: function(t1) {
                                return f[t1.getDay()];
                            },
                            A: function(t1) {
                                return u[t1.getDay()];
                            },
                            b: function(t1) {
                                return yt[t1.getMonth()];
                            },
                            B: function(t1) {
                                return h[t1.getMonth()];
                            },
                            c: null,
                            d: D,
                            e: D,
                            f: j,
                            H: R,
                            I: F,
                            j: B,
                            L: N,
                            m: U,
                            M: V,
                            p: function(t1) {
                                return c[+(t1.getHours() >= 12)];
                            },
                            q: function(t1) {
                                return 1 + ~~(t1.getMonth() / 3);
                            },
                            Q: gt,
                            s: vt,
                            S: H,
                            u: q,
                            U: G,
                            V: Y,
                            w: W,
                            W: X,
                            x: null,
                            X: null,
                            y: Z,
                            Y: J,
                            Z: K,
                            "%": mt
                        }, Ct = {
                            a: function(t1) {
                                return f[t1.getUTCDay()];
                            },
                            A: function(t1) {
                                return u[t1.getUTCDay()];
                            },
                            b: function(t1) {
                                return yt[t1.getUTCMonth()];
                            },
                            B: function(t1) {
                                return h[t1.getUTCMonth()];
                            },
                            c: null,
                            d: Q,
                            e: Q,
                            f: nt,
                            H: $,
                            I: tt,
                            j: et,
                            L: rt,
                            m: it,
                            M: at,
                            p: function(t1) {
                                return c[+(t1.getUTCHours() >= 12)];
                            },
                            q: function(t1) {
                                return 1 + ~~(t1.getUTCMonth() / 3);
                            },
                            Q: gt,
                            s: vt,
                            S: ot,
                            u: st,
                            U: lt,
                            V: ct,
                            w: ut,
                            W: ft,
                            x: null,
                            X: null,
                            y: ht,
                            Y: pt,
                            Z: dt,
                            "%": mt
                        }, Pt = {
                            a: function(t1, e1, r) {
                                var n = Tt.exec(e1.slice(r));
                                return n ? (t1.w = kt[n[0].toLowerCase()], r + n[0].length) : -1;
                            },
                            A: function(t1, e1, r) {
                                var n = _t.exec(e1.slice(r));
                                return n ? (t1.w = wt[n[0].toLowerCase()], r + n[0].length) : -1;
                            },
                            b: function(t1, e1, r) {
                                var n = St.exec(e1.slice(r));
                                return n ? (t1.m = Et[n[0].toLowerCase()], r + n[0].length) : -1;
                            },
                            B: function(t1, e1, r) {
                                var n = At.exec(e1.slice(r));
                                return n ? (t1.m = Mt[n[0].toLowerCase()], r + n[0].length) : -1;
                            },
                            c: function(t1, e1, r) {
                                return zt(t1, a, e1, r);
                            },
                            d: A,
                            e: A,
                            f: P,
                            H: S,
                            I: S,
                            j: M,
                            L: C,
                            m: k,
                            M: E,
                            p: function(t1, e1, r) {
                                var n = xt.exec(e1.slice(r));
                                return n ? (t1.p = bt[n[0].toLowerCase()], r + n[0].length) : -1;
                            },
                            q: T,
                            Q: O,
                            s: z,
                            S: L,
                            u: g,
                            U: v,
                            V: y,
                            w: m,
                            W: x,
                            x: function(t1, e1, r) {
                                return zt(t1, o, e1, r);
                            },
                            X: function(t1, e1, r) {
                                return zt(t1, l, e1, r);
                            },
                            y: _,
                            Y: b,
                            Z: w,
                            "%": I
                        };
                        function It(t1, e1) {
                            return function(r) {
                                var n, i, a, o = [], l = -1, c = 0, u = t1.length;
                                for(r instanceof Date || (r = new Date(+r)); ++l < u;)37 === t1.charCodeAt(l) && (o.push(t1.slice(c, l)), null != (i = s[n = t1.charAt(++l)]) ? n = t1.charAt(++l) : i = "e" === n ? " " : "0", (a = e1[n]) && (n = a(r, i)), o.push(n), c = l + 1);
                                return o.push(t1.slice(c, l)), o.join("");
                            };
                        }
                        function Ot(t1, a) {
                            return function(o) {
                                var s, l, c = i(1900, void 0, 1);
                                if (zt(c, t1, o += "", 0) != o.length) return null;
                                if ("Q" in c) return new Date(c.Q);
                                if ("s" in c) return new Date(1e3 * c.s + ("L" in c ? c.L : 0));
                                if (a && !("Z" in c) && (c.Z = 0), "p" in c && (c.H = c.H % 12 + 12 * c.p), void 0 === c.m && (c.m = "q" in c ? c.q : 0), "V" in c) {
                                    if (c.V < 1 || c.V > 53) return null;
                                    "w" in c || (c.w = 1), "Z" in c ? (l = (s = n(i(c.y, 0, 1))).getUTCDay(), s = l > 4 || 0 === l ? e1.utcMonday.ceil(s) : e1.utcMonday(s), s = e1.utcDay.offset(s, 7 * (c.V - 1)), c.y = s.getUTCFullYear(), c.m = s.getUTCMonth(), c.d = s.getUTCDate() + (c.w + 6) % 7) : (l = (s = r(i(c.y, 0, 1))).getDay(), s = l > 4 || 0 === l ? e1.timeMonday.ceil(s) : e1.timeMonday(s), s = e1.timeDay.offset(s, 7 * (c.V - 1)), c.y = s.getFullYear(), c.m = s.getMonth(), c.d = s.getDate() + (c.w + 6) % 7);
                                } else ("W" in c || "U" in c) && ("w" in c || (c.w = "u" in c ? c.u % 7 : "W" in c ? 1 : 0), l = "Z" in c ? n(i(c.y, 0, 1)).getUTCDay() : r(i(c.y, 0, 1)).getDay(), c.m = 0, c.d = "W" in c ? (c.w + 6) % 7 + 7 * c.W - (l + 5) % 7 : c.w + 7 * c.U - (l + 6) % 7);
                                return "Z" in c ? (c.H += c.Z / 100 | 0, c.M += c.Z % 100, n(c)) : r(c);
                            };
                        }
                        function zt(t1, e1, r, n) {
                            for(var i, a, o = 0, l = e1.length, c = r.length; o < l;){
                                if (n >= c) return -1;
                                if (37 === (i = e1.charCodeAt(o++))) {
                                    if (i = e1.charAt(o++), !(a = Pt[i in s ? e1.charAt(o++) : i]) || (n = a(t1, r, n)) < 0) return -1;
                                } else if (i != r.charCodeAt(n++)) return -1;
                            }
                            return n;
                        }
                        return Lt.x = It(o, Lt), Lt.X = It(l, Lt), Lt.c = It(a, Lt), Ct.x = It(o, Ct), Ct.X = It(l, Ct), Ct.c = It(a, Ct), {
                            format: function(t1) {
                                var e1 = It(t1 += "", Lt);
                                return e1.toString = function() {
                                    return t1;
                                }, e1;
                            },
                            parse: function(t1) {
                                var e1 = Ot(t1 += "", !1);
                                return e1.toString = function() {
                                    return t1;
                                }, e1;
                            },
                            utcFormat: function(t1) {
                                var e1 = It(t1 += "", Ct);
                                return e1.toString = function() {
                                    return t1;
                                }, e1;
                            },
                            utcParse: function(t1) {
                                var e1 = Ot(t1 += "", !0);
                                return e1.toString = function() {
                                    return t1;
                                }, e1;
                            }
                        };
                    }
                    var o, s = {
                        "-": "",
                        _: " ",
                        0: "0"
                    }, l = /^\s*\d+/, c = /^%/, u = /[\\^$*+?|[\]().{}]/g;
                    function f(t1, e1, r) {
                        var n = t1 < 0 ? "-" : "", i = (n ? -t1 : t1) + "", a = i.length;
                        return n + (a < r ? new Array(r - a + 1).join(e1) + i : i);
                    }
                    function h(t1) {
                        return t1.replace(u, "\\$&");
                    }
                    function p(t1) {
                        return new RegExp("^(?:" + t1.map(h).join("|") + ")", "i");
                    }
                    function d(t1) {
                        for(var e1 = {}, r = -1, n = t1.length; ++r < n;)e1[t1[r].toLowerCase()] = r;
                        return e1;
                    }
                    function m(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 1));
                        return n ? (t1.w = +n[0], r + n[0].length) : -1;
                    }
                    function g(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 1));
                        return n ? (t1.u = +n[0], r + n[0].length) : -1;
                    }
                    function v(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 2));
                        return n ? (t1.U = +n[0], r + n[0].length) : -1;
                    }
                    function y(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 2));
                        return n ? (t1.V = +n[0], r + n[0].length) : -1;
                    }
                    function x(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 2));
                        return n ? (t1.W = +n[0], r + n[0].length) : -1;
                    }
                    function b(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 4));
                        return n ? (t1.y = +n[0], r + n[0].length) : -1;
                    }
                    function _(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 2));
                        return n ? (t1.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
                    }
                    function w(t1, e1, r) {
                        var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e1.slice(r, r + 6));
                        return n ? (t1.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
                    }
                    function T(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 1));
                        return n ? (t1.q = 3 * n[0] - 3, r + n[0].length) : -1;
                    }
                    function k(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 2));
                        return n ? (t1.m = n[0] - 1, r + n[0].length) : -1;
                    }
                    function A(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 2));
                        return n ? (t1.d = +n[0], r + n[0].length) : -1;
                    }
                    function M(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 3));
                        return n ? (t1.m = 0, t1.d = +n[0], r + n[0].length) : -1;
                    }
                    function S(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 2));
                        return n ? (t1.H = +n[0], r + n[0].length) : -1;
                    }
                    function E(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 2));
                        return n ? (t1.M = +n[0], r + n[0].length) : -1;
                    }
                    function L(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 2));
                        return n ? (t1.S = +n[0], r + n[0].length) : -1;
                    }
                    function C(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 3));
                        return n ? (t1.L = +n[0], r + n[0].length) : -1;
                    }
                    function P(t1, e1, r) {
                        var n = l.exec(e1.slice(r, r + 6));
                        return n ? (t1.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
                    }
                    function I(t1, e1, r) {
                        var n = c.exec(e1.slice(r, r + 1));
                        return n ? r + n[0].length : -1;
                    }
                    function O(t1, e1, r) {
                        var n = l.exec(e1.slice(r));
                        return n ? (t1.Q = +n[0], r + n[0].length) : -1;
                    }
                    function z(t1, e1, r) {
                        var n = l.exec(e1.slice(r));
                        return n ? (t1.s = +n[0], r + n[0].length) : -1;
                    }
                    function D(t1, e1) {
                        return f(t1.getDate(), e1, 2);
                    }
                    function R(t1, e1) {
                        return f(t1.getHours(), e1, 2);
                    }
                    function F(t1, e1) {
                        return f(t1.getHours() % 12 || 12, e1, 2);
                    }
                    function B(t1, r) {
                        return f(1 + e1.timeDay.count(e1.timeYear(t1), t1), r, 3);
                    }
                    function N(t1, e1) {
                        return f(t1.getMilliseconds(), e1, 3);
                    }
                    function j(t1, e1) {
                        return N(t1, e1) + "000";
                    }
                    function U(t1, e1) {
                        return f(t1.getMonth() + 1, e1, 2);
                    }
                    function V(t1, e1) {
                        return f(t1.getMinutes(), e1, 2);
                    }
                    function H(t1, e1) {
                        return f(t1.getSeconds(), e1, 2);
                    }
                    function q(t1) {
                        var e1 = t1.getDay();
                        return 0 === e1 ? 7 : e1;
                    }
                    function G(t1, r) {
                        return f(e1.timeSunday.count(e1.timeYear(t1) - 1, t1), r, 2);
                    }
                    function Y(t1, r) {
                        var n = t1.getDay();
                        return t1 = n >= 4 || 0 === n ? e1.timeThursday(t1) : e1.timeThursday.ceil(t1), f(e1.timeThursday.count(e1.timeYear(t1), t1) + (4 === e1.timeYear(t1).getDay()), r, 2);
                    }
                    function W(t1) {
                        return t1.getDay();
                    }
                    function X(t1, r) {
                        return f(e1.timeMonday.count(e1.timeYear(t1) - 1, t1), r, 2);
                    }
                    function Z(t1, e1) {
                        return f(t1.getFullYear() % 100, e1, 2);
                    }
                    function J(t1, e1) {
                        return f(t1.getFullYear() % 1e4, e1, 4);
                    }
                    function K(t1) {
                        var e1 = t1.getTimezoneOffset();
                        return (e1 > 0 ? "-" : (e1 *= -1, "+")) + f(e1 / 60 | 0, "0", 2) + f(e1 % 60, "0", 2);
                    }
                    function Q(t1, e1) {
                        return f(t1.getUTCDate(), e1, 2);
                    }
                    function $(t1, e1) {
                        return f(t1.getUTCHours(), e1, 2);
                    }
                    function tt(t1, e1) {
                        return f(t1.getUTCHours() % 12 || 12, e1, 2);
                    }
                    function et(t1, r) {
                        return f(1 + e1.utcDay.count(e1.utcYear(t1), t1), r, 3);
                    }
                    function rt(t1, e1) {
                        return f(t1.getUTCMilliseconds(), e1, 3);
                    }
                    function nt(t1, e1) {
                        return rt(t1, e1) + "000";
                    }
                    function it(t1, e1) {
                        return f(t1.getUTCMonth() + 1, e1, 2);
                    }
                    function at(t1, e1) {
                        return f(t1.getUTCMinutes(), e1, 2);
                    }
                    function ot(t1, e1) {
                        return f(t1.getUTCSeconds(), e1, 2);
                    }
                    function st(t1) {
                        var e1 = t1.getUTCDay();
                        return 0 === e1 ? 7 : e1;
                    }
                    function lt(t1, r) {
                        return f(e1.utcSunday.count(e1.utcYear(t1) - 1, t1), r, 2);
                    }
                    function ct(t1, r) {
                        var n = t1.getUTCDay();
                        return t1 = n >= 4 || 0 === n ? e1.utcThursday(t1) : e1.utcThursday.ceil(t1), f(e1.utcThursday.count(e1.utcYear(t1), t1) + (4 === e1.utcYear(t1).getUTCDay()), r, 2);
                    }
                    function ut(t1) {
                        return t1.getUTCDay();
                    }
                    function ft(t1, r) {
                        return f(e1.utcMonday.count(e1.utcYear(t1) - 1, t1), r, 2);
                    }
                    function ht(t1, e1) {
                        return f(t1.getUTCFullYear() % 100, e1, 2);
                    }
                    function pt(t1, e1) {
                        return f(t1.getUTCFullYear() % 1e4, e1, 4);
                    }
                    function dt() {
                        return "+0000";
                    }
                    function mt() {
                        return "%";
                    }
                    function gt(t1) {
                        return +t1;
                    }
                    function vt(t1) {
                        return Math.floor(+t1 / 1e3);
                    }
                    function yt(e1) {
                        return o = a(e1), t1.timeFormat = o.format, t1.timeParse = o.parse, t1.utcFormat = o.utcFormat, t1.utcParse = o.utcParse, o;
                    }
                    yt({
                        dateTime: "%x, %X",
                        date: "%-m/%-d/%Y",
                        time: "%-I:%M:%S %p",
                        periods: [
                            "AM",
                            "PM"
                        ],
                        days: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ],
                        shortDays: [
                            "Sun",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat"
                        ],
                        months: [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ],
                        shortMonths: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ]
                    });
                    var xt = Date.prototype.toISOString ? function(t1) {
                        return t1.toISOString();
                    } : t1.utcFormat("%Y-%m-%dT%H:%M:%S.%LZ");
                    var bt = +new Date("2000-01-01T00:00:00.000Z") ? function(t1) {
                        var e1 = new Date(t1);
                        return isNaN(e1) ? null : e1;
                    } : t1.utcParse("%Y-%m-%dT%H:%M:%S.%LZ");
                    t1.isoFormat = xt, t1.isoParse = bt, t1.timeFormatDefaultLocale = yt, t1.timeFormatLocale = a, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {
                "d3-time": 121
            }
        ],
        121: [
            function(t1, e1, r) {
                !function(t1, n) {
                    "object" == typeof r && void 0 !== e1 ? n(r) : n((t1 = t1 || self).d3 = t1.d3 || {});
                }(this, function(t1) {
                    "use strict";
                    var e1 = new Date, r = new Date;
                    function n(t1, i, a, o) {
                        function s(e1) {
                            return t1(e1 = 0 === arguments.length ? new Date : new Date(+e1)), e1;
                        }
                        return s.floor = function(e1) {
                            return t1(e1 = new Date(+e1)), e1;
                        }, s.ceil = function(e1) {
                            return t1(e1 = new Date(e1 - 1)), i(e1, 1), t1(e1), e1;
                        }, s.round = function(t1) {
                            var e1 = s(t1), r = s.ceil(t1);
                            return t1 - e1 < r - t1 ? e1 : r;
                        }, s.offset = function(t1, e1) {
                            return i(t1 = new Date(+t1), null == e1 ? 1 : Math.floor(e1)), t1;
                        }, s.range = function(e1, r, n) {
                            var a, o = [];
                            if (e1 = s.ceil(e1), n = null == n ? 1 : Math.floor(n), !(e1 < r && n > 0)) return o;
                            do o.push(a = new Date(+e1)), i(e1, n), t1(e1);
                            while (a < e1 && e1 < r);
                            return o;
                        }, s.filter = function(e1) {
                            return n(function(r) {
                                if (r >= r) for(; t1(r), !e1(r);)r.setTime(r - 1);
                            }, function(t1, r) {
                                if (t1 >= t1) {
                                    if (r < 0) for(; ++r <= 0;)for(; i(t1, -1), !e1(t1););
                                    else for(; --r >= 0;)for(; i(t1, 1), !e1(t1););
                                }
                            });
                        }, a && (s.count = function(n, i) {
                            return e1.setTime(+n), r.setTime(+i), t1(e1), t1(r), Math.floor(a(e1, r));
                        }, s.every = function(t1) {
                            return t1 = Math.floor(t1), isFinite(t1) && t1 > 0 ? t1 > 1 ? s.filter(o ? function(e1) {
                                return o(e1) % t1 == 0;
                            } : function(e1) {
                                return s.count(0, e1) % t1 == 0;
                            }) : s : null;
                        }), s;
                    }
                    var i = n(function() {}, function(t1, e1) {
                        t1.setTime(+t1 + e1);
                    }, function(t1, e1) {
                        return e1 - t1;
                    });
                    i.every = function(t1) {
                        return t1 = Math.floor(t1), isFinite(t1) && t1 > 0 ? t1 > 1 ? n(function(e1) {
                            e1.setTime(Math.floor(e1 / t1) * t1);
                        }, function(e1, r) {
                            e1.setTime(+e1 + r * t1);
                        }, function(e1, r) {
                            return (r - e1) / t1;
                        }) : i : null;
                    };
                    var a = i.range, o = n(function(t1) {
                        t1.setTime(t1 - t1.getMilliseconds());
                    }, function(t1, e1) {
                        t1.setTime(+t1 + 1e3 * e1);
                    }, function(t1, e1) {
                        return (e1 - t1) / 1e3;
                    }, function(t1) {
                        return t1.getUTCSeconds();
                    }), s = o.range, l = n(function(t1) {
                        t1.setTime(t1 - t1.getMilliseconds() - 1e3 * t1.getSeconds());
                    }, function(t1, e1) {
                        t1.setTime(+t1 + 6e4 * e1);
                    }, function(t1, e1) {
                        return (e1 - t1) / 6e4;
                    }, function(t1) {
                        return t1.getMinutes();
                    }), c = l.range, u = n(function(t1) {
                        t1.setTime(t1 - t1.getMilliseconds() - 1e3 * t1.getSeconds() - 6e4 * t1.getMinutes());
                    }, function(t1, e1) {
                        t1.setTime(+t1 + 36e5 * e1);
                    }, function(t1, e1) {
                        return (e1 - t1) / 36e5;
                    }, function(t1) {
                        return t1.getHours();
                    }), f = u.range, h = n(function(t1) {
                        t1.setHours(0, 0, 0, 0);
                    }, function(t1, e1) {
                        t1.setDate(t1.getDate() + e1);
                    }, function(t1, e1) {
                        return (e1 - t1 - 6e4 * (e1.getTimezoneOffset() - t1.getTimezoneOffset())) / 864e5;
                    }, function(t1) {
                        return t1.getDate() - 1;
                    }), p = h.range;
                    function d(t1) {
                        return n(function(e1) {
                            e1.setDate(e1.getDate() - (e1.getDay() + 7 - t1) % 7), e1.setHours(0, 0, 0, 0);
                        }, function(t1, e1) {
                            t1.setDate(t1.getDate() + 7 * e1);
                        }, function(t1, e1) {
                            return (e1 - t1 - 6e4 * (e1.getTimezoneOffset() - t1.getTimezoneOffset())) / 6048e5;
                        });
                    }
                    var m = d(0), g = d(1), v = d(2), y = d(3), x = d(4), b = d(5), _ = d(6), w = m.range, T = g.range, k = v.range, A = y.range, M = x.range, S = b.range, E = _.range, L = n(function(t1) {
                        t1.setDate(1), t1.setHours(0, 0, 0, 0);
                    }, function(t1, e1) {
                        t1.setMonth(t1.getMonth() + e1);
                    }, function(t1, e1) {
                        return e1.getMonth() - t1.getMonth() + 12 * (e1.getFullYear() - t1.getFullYear());
                    }, function(t1) {
                        return t1.getMonth();
                    }), C = L.range, P = n(function(t1) {
                        t1.setMonth(0, 1), t1.setHours(0, 0, 0, 0);
                    }, function(t1, e1) {
                        t1.setFullYear(t1.getFullYear() + e1);
                    }, function(t1, e1) {
                        return e1.getFullYear() - t1.getFullYear();
                    }, function(t1) {
                        return t1.getFullYear();
                    });
                    P.every = function(t1) {
                        return isFinite(t1 = Math.floor(t1)) && t1 > 0 ? n(function(e1) {
                            e1.setFullYear(Math.floor(e1.getFullYear() / t1) * t1), e1.setMonth(0, 1), e1.setHours(0, 0, 0, 0);
                        }, function(e1, r) {
                            e1.setFullYear(e1.getFullYear() + r * t1);
                        }) : null;
                    };
                    var I = P.range, O = n(function(t1) {
                        t1.setUTCSeconds(0, 0);
                    }, function(t1, e1) {
                        t1.setTime(+t1 + 6e4 * e1);
                    }, function(t1, e1) {
                        return (e1 - t1) / 6e4;
                    }, function(t1) {
                        return t1.getUTCMinutes();
                    }), z = O.range, D = n(function(t1) {
                        t1.setUTCMinutes(0, 0, 0);
                    }, function(t1, e1) {
                        t1.setTime(+t1 + 36e5 * e1);
                    }, function(t1, e1) {
                        return (e1 - t1) / 36e5;
                    }, function(t1) {
                        return t1.getUTCHours();
                    }), R = D.range, F = n(function(t1) {
                        t1.setUTCHours(0, 0, 0, 0);
                    }, function(t1, e1) {
                        t1.setUTCDate(t1.getUTCDate() + e1);
                    }, function(t1, e1) {
                        return (e1 - t1) / 864e5;
                    }, function(t1) {
                        return t1.getUTCDate() - 1;
                    }), B = F.range;
                    function N(t1) {
                        return n(function(e1) {
                            e1.setUTCDate(e1.getUTCDate() - (e1.getUTCDay() + 7 - t1) % 7), e1.setUTCHours(0, 0, 0, 0);
                        }, function(t1, e1) {
                            t1.setUTCDate(t1.getUTCDate() + 7 * e1);
                        }, function(t1, e1) {
                            return (e1 - t1) / 6048e5;
                        });
                    }
                    var j = N(0), U = N(1), V = N(2), H = N(3), q = N(4), G = N(5), Y = N(6), W = j.range, X = U.range, Z = V.range, J = H.range, K = q.range, Q = G.range, $ = Y.range, tt = n(function(t1) {
                        t1.setUTCDate(1), t1.setUTCHours(0, 0, 0, 0);
                    }, function(t1, e1) {
                        t1.setUTCMonth(t1.getUTCMonth() + e1);
                    }, function(t1, e1) {
                        return e1.getUTCMonth() - t1.getUTCMonth() + 12 * (e1.getUTCFullYear() - t1.getUTCFullYear());
                    }, function(t1) {
                        return t1.getUTCMonth();
                    }), et = tt.range, rt = n(function(t1) {
                        t1.setUTCMonth(0, 1), t1.setUTCHours(0, 0, 0, 0);
                    }, function(t1, e1) {
                        t1.setUTCFullYear(t1.getUTCFullYear() + e1);
                    }, function(t1, e1) {
                        return e1.getUTCFullYear() - t1.getUTCFullYear();
                    }, function(t1) {
                        return t1.getUTCFullYear();
                    });
                    rt.every = function(t1) {
                        return isFinite(t1 = Math.floor(t1)) && t1 > 0 ? n(function(e1) {
                            e1.setUTCFullYear(Math.floor(e1.getUTCFullYear() / t1) * t1), e1.setUTCMonth(0, 1), e1.setUTCHours(0, 0, 0, 0);
                        }, function(e1, r) {
                            e1.setUTCFullYear(e1.getUTCFullYear() + r * t1);
                        }) : null;
                    };
                    var nt = rt.range;
                    t1.timeDay = h, t1.timeDays = p, t1.timeFriday = b, t1.timeFridays = S, t1.timeHour = u, t1.timeHours = f, t1.timeInterval = n, t1.timeMillisecond = i, t1.timeMilliseconds = a, t1.timeMinute = l, t1.timeMinutes = c, t1.timeMonday = g, t1.timeMondays = T, t1.timeMonth = L, t1.timeMonths = C, t1.timeSaturday = _, t1.timeSaturdays = E, t1.timeSecond = o, t1.timeSeconds = s, t1.timeSunday = m, t1.timeSundays = w, t1.timeThursday = x, t1.timeThursdays = M, t1.timeTuesday = v, t1.timeTuesdays = k, t1.timeWednesday = y, t1.timeWednesdays = A, t1.timeWeek = m, t1.timeWeeks = w, t1.timeYear = P, t1.timeYears = I, t1.utcDay = F, t1.utcDays = B, t1.utcFriday = G, t1.utcFridays = Q, t1.utcHour = D, t1.utcHours = R, t1.utcMillisecond = i, t1.utcMilliseconds = a, t1.utcMinute = O, t1.utcMinutes = z, t1.utcMonday = U, t1.utcMondays = X, t1.utcMonth = tt, t1.utcMonths = et, t1.utcSaturday = Y, t1.utcSaturdays = $, t1.utcSecond = o, t1.utcSeconds = s, t1.utcSunday = j, t1.utcSundays = W, t1.utcThursday = q, t1.utcThursdays = K, t1.utcTuesday = V, t1.utcTuesdays = Z, t1.utcWednesday = H, t1.utcWednesdays = J, t1.utcWeek = j, t1.utcWeeks = W, t1.utcYear = rt, t1.utcYears = nt, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {}
        ],
        122: [
            function(t1, e1, r) {
                arguments[4][121][0].apply(r, arguments);
            },
            {
                dup: 121
            }
        ],
        123: [
            function(t1, e1, r) {
                !function(t1, n) {
                    "object" == typeof r && void 0 !== e1 ? n(r) : n((t1 = t1 || self).d3 = t1.d3 || {});
                }(this, function(t1) {
                    "use strict";
                    var e1, r, n = 0, i = 0, a = 0, o = 0, s = 0, l = 0, c = "object" == typeof performance && performance.now ? performance : Date, u = "object" == typeof window && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t1) {
                        setTimeout(t1, 17);
                    };
                    function f() {
                        return s || (u(h), s = c.now() + l);
                    }
                    function h() {
                        s = 0;
                    }
                    function p() {
                        this._call = this._time = this._next = null;
                    }
                    function d(t1, e1, r) {
                        var n = new p;
                        return n.restart(t1, e1, r), n;
                    }
                    function m() {
                        f(), ++n;
                        for(var t1, r = e1; r;)(t1 = s - r._time) >= 0 && r._call.call(null, t1), r = r._next;
                        --n;
                    }
                    function g() {
                        s = (o = c.now()) + l, n = i = 0;
                        try {
                            m();
                        } finally{
                            n = 0, function() {
                                var t1, n, i = e1, a = 1 / 0;
                                for(; i;)i._call ? (a > i._time && (a = i._time), t1 = i, i = i._next) : (n = i._next, i._next = null, i = t1 ? t1._next = n : e1 = n);
                                r = t1, y(a);
                            }(), s = 0;
                        }
                    }
                    function v() {
                        var t1 = c.now(), e1 = t1 - o;
                        e1 > 1e3 && (l -= e1, o = t1);
                    }
                    function y(t1) {
                        n || (i && (i = clearTimeout(i)), t1 - s > 24 ? (t1 < 1 / 0 && (i = setTimeout(g, t1 - c.now() - l)), a && (a = clearInterval(a))) : (a || (o = c.now(), a = setInterval(v, 1e3)), n = 1, u(g)));
                    }
                    p.prototype = d.prototype = {
                        constructor: p,
                        restart: function(t1, n, i) {
                            if ("function" != typeof t1) throw new TypeError("callback is not a function");
                            i = (null == i ? f() : +i) + (null == n ? 0 : +n), this._next || r === this || (r ? r._next = this : e1 = this, r = this), this._call = t1, this._time = i, y();
                        },
                        stop: function() {
                            this._call && (this._call = null, this._time = 1 / 0, y());
                        }
                    }, t1.interval = function(t1, e1, r) {
                        var n = new p, i = e1;
                        return null == e1 ? (n.restart(t1, e1, r), n) : (e1 = +e1, r = null == r ? f() : +r, n.restart(function a(o) {
                            o += i, n.restart(a, i += e1, r), t1(o);
                        }, e1, r), n);
                    }, t1.now = f, t1.timeout = function(t1, e1, r) {
                        var n = new p;
                        return e1 = null == e1 ? 0 : +e1, n.restart(function(r) {
                            n.stop(), t1(r + e1);
                        }, e1, r), n;
                    }, t1.timer = d, t1.timerFlush = m, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {}
        ],
        124: [
            function(t1, e1, r) {
                e1.exports = function() {
                    for(var t1 = 0; t1 < arguments.length; t1++)if (void 0 !== arguments[t1]) return arguments[t1];
                };
            },
            {}
        ],
        125: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = a;
                var n = (a.canvas = document.createElement("canvas")).getContext("2d"), i = o([
                    32,
                    126
                ]);
                function a(t1, e1) {
                    Array.isArray(t1) && (t1 = t1.join(", "));
                    var r, a = {}, s = 16, l = .05;
                    e1 && (2 === e1.length && "number" == typeof e1[0] ? r = o(e1) : Array.isArray(e1) ? r = e1 : (e1.o ? r = o(e1.o) : e1.pairs && (r = e1.pairs), e1.fontSize && (s = e1.fontSize), null != e1.threshold && (l = e1.threshold))), r || (r = i), n.font = s + "px " + t1;
                    for(var c = 0; c < r.length; c++){
                        var u = r[c], f = n.measureText(u[0]).width + n.measureText(u[1]).width, h = n.measureText(u).width;
                        if (Math.abs(f - h) > s * l) {
                            var p = (h - f) / s;
                            a[u] = 1e3 * p;
                        }
                    }
                    return a;
                }
                function o(t1) {
                    for(var e1 = [], r = t1[0]; r <= t1[1]; r++)for(var n = String.fromCharCode(r), i = t1[0]; i < t1[1]; i++){
                        var a = n + String.fromCharCode(i);
                        e1.push(a);
                    }
                    return e1;
                }
                a.createPairs = o, a.ascii = i;
            },
            {}
        ],
        126: [
            function(t1, e1, r) {
                var n = t1("abs-svg-path"), i = t1("normalize-svg-path"), a = {
                    M: "moveTo",
                    C: "bezierCurveTo"
                };
                e1.exports = function(t1, e1) {
                    t1.beginPath(), i(n(e1)).forEach(function(e1) {
                        var r = e1[0], n = e1.slice(1);
                        t1[a[r]].apply(t1, n);
                    }), t1.closePath();
                };
            },
            {
                "abs-svg-path": 70,
                "normalize-svg-path": 246
            }
        ],
        127: [
            function(t1, e1, r) {
                e1.exports = function(t1) {
                    switch(t1){
                        case "int8":
                            return Int8Array;
                        case "int16":
                            return Int16Array;
                        case "int32":
                            return Int32Array;
                        case "uint8":
                            return Uint8Array;
                        case "uint16":
                            return Uint16Array;
                        case "uint32":
                            return Uint32Array;
                        case "float32":
                            return Float32Array;
                        case "float64":
                            return Float64Array;
                        case "array":
                            return Array;
                        case "uint8_clamped":
                            return Uint8ClampedArray;
                    }
                };
            },
            {}
        ],
        128: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    switch(void 0 === e1 && (e1 = 0), typeof t1){
                        case "number":
                            if (t1 > 0) return function(t1, e1) {
                                var r, n;
                                for(r = new Array(t1), n = 0; n < t1; ++n)r[n] = e1;
                                return r;
                            }(0 | t1, e1);
                            break;
                        case "object":
                            if ("number" == typeof t1.length) return function t1(e1, r, n) {
                                var i = 0 | e1[n];
                                if (i <= 0) return [];
                                var a, o = new Array(i);
                                if (n === e1.length - 1) for(a = 0; a < i; ++a)o[a] = r;
                                else for(a = 0; a < i; ++a)o[a] = t1(e1, r, n + 1);
                                return o;
                            }(t1, e1, 0);
                    }
                    return [];
                };
            },
            {}
        ],
        129: [
            function(t1, e1, r) {
                "use strict";
                function n(t1, e1, r) {
                    r = r || 2;
                    var n, s, l, c, u, p, d, g = e1 && e1.length, v = g ? e1[0] * r : t1.length, y = i(t1, 0, v, r, !0), x = [];
                    if (!y || y.next === y.prev) return x;
                    if (g && (y = function(t1, e1, r, n) {
                        var o, s, l, c, u, p = [];
                        for(o = 0, s = e1.length; o < s; o++)l = e1[o] * n, c = o < s - 1 ? e1[o + 1] * n : t1.length, (u = i(t1, l, c, n, !1)) === u.next && (u.steiner = !0), p.push(m(u));
                        for(p.sort(f), o = 0; o < p.length; o++)h(p[o], r), r = a(r, r.next);
                        return r;
                    }(t1, e1, y, r)), t1.length > 80 * r) {
                        n = l = t1[0], s = c = t1[1];
                        for(var b = r; b < v; b += r)(u = t1[b]) < n && (n = u), (p = t1[b + 1]) < s && (s = p), u > l && (l = u), p > c && (c = p);
                        d = 0 !== (d = Math.max(l - n, c - s)) ? 1 / d : 0;
                    }
                    return o(y, x, r, n, s, d), x;
                }
                function i(t1, e1, r, n, i) {
                    var a, o;
                    if (i === E(t1, e1, r, n) > 0) for(a = e1; a < r; a += n)o = A(a, t1[a], t1[a + 1], o);
                    else for(a = r - n; a >= e1; a -= n)o = A(a, t1[a], t1[a + 1], o);
                    return o && x(o, o.next) && (M(o), o = o.next), o;
                }
                function a(t1, e1) {
                    if (!t1) return t1;
                    e1 || (e1 = t1);
                    var r, n = t1;
                    do if (r = !1, n.steiner || !x(n, n.next) && 0 !== y(n.prev, n, n.next)) n = n.next;
                    else {
                        if (M(n), (n = e1 = n.prev) === n.next) break;
                        r = !0;
                    }
                    while (r || n !== e1);
                    return e1;
                }
                function o(t1, e1, r, n, i, f, h) {
                    if (t1) {
                        !h && f && function(t1, e1, r, n) {
                            var i = t1;
                            do null === i.z && (i.z = d(i.x, i.y, e1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                            while (i !== t1);
                            i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                                var e1, r, n, i, a, o, s, l, c = 1;
                                do {
                                    for(r = t1, t1 = null, a = null, o = 0; r;){
                                        for(o++, n = r, s = 0, e1 = 0; e1 < c && (s++, n = n.nextZ); e1++);
                                        for(l = c; s > 0 || l > 0 && n;)0 !== s && (0 === l || !n || r.z <= n.z) ? (i = r, r = r.nextZ, s--) : (i = n, n = n.nextZ, l--), a ? a.nextZ = i : t1 = i, i.prevZ = a, a = i;
                                        r = n;
                                    }
                                    a.nextZ = null, c *= 2;
                                }while (o > 1);
                            }(i);
                        }(t1, n, i, f);
                        for(var p, m, g = t1; t1.prev !== t1.next;)if (p = t1.prev, m = t1.next, f ? l(t1, n, i, f) : s(t1)) e1.push(p.i / r), e1.push(t1.i / r), e1.push(m.i / r), M(t1), t1 = m.next, g = m.next;
                        else if ((t1 = m) === g) {
                            h ? 1 === h ? o(t1 = c(a(t1), e1, r), e1, r, n, i, f, 2) : 2 === h && u(t1, e1, r, n, i, f) : o(a(t1), e1, r, n, i, f, 1);
                            break;
                        }
                    }
                }
                function s(t1) {
                    var e1 = t1.prev, r = t1, n = t1.next;
                    if (y(e1, r, n) >= 0) return !1;
                    for(var i = t1.next.next; i !== t1.prev;){
                        if (g(e1.x, e1.y, r.x, r.y, n.x, n.y, i.x, i.y) && y(i.prev, i, i.next) >= 0) return !1;
                        i = i.next;
                    }
                    return !0;
                }
                function l(t1, e1, r, n) {
                    var i = t1.prev, a = t1, o = t1.next;
                    if (y(i, a, o) >= 0) return !1;
                    for(var s = i.x < a.x ? i.x < o.x ? i.x : o.x : a.x < o.x ? a.x : o.x, l = i.y < a.y ? i.y < o.y ? i.y : o.y : a.y < o.y ? a.y : o.y, c = i.x > a.x ? i.x > o.x ? i.x : o.x : a.x > o.x ? a.x : o.x, u = i.y > a.y ? i.y > o.y ? i.y : o.y : a.y > o.y ? a.y : o.y, f = d(s, l, e1, r, n), h = d(c, u, e1, r, n), p = t1.prevZ, m = t1.nextZ; p && p.z >= f && m && m.z <= h;){
                        if (p !== t1.prev && p !== t1.next && g(i.x, i.y, a.x, a.y, o.x, o.y, p.x, p.y) && y(p.prev, p, p.next) >= 0) return !1;
                        if (p = p.prevZ, m !== t1.prev && m !== t1.next && g(i.x, i.y, a.x, a.y, o.x, o.y, m.x, m.y) && y(m.prev, m, m.next) >= 0) return !1;
                        m = m.nextZ;
                    }
                    for(; p && p.z >= f;){
                        if (p !== t1.prev && p !== t1.next && g(i.x, i.y, a.x, a.y, o.x, o.y, p.x, p.y) && y(p.prev, p, p.next) >= 0) return !1;
                        p = p.prevZ;
                    }
                    for(; m && m.z <= h;){
                        if (m !== t1.prev && m !== t1.next && g(i.x, i.y, a.x, a.y, o.x, o.y, m.x, m.y) && y(m.prev, m, m.next) >= 0) return !1;
                        m = m.nextZ;
                    }
                    return !0;
                }
                function c(t1, e1, r) {
                    var n = t1;
                    do {
                        var i = n.prev, o = n.next.next;
                        !x(i, o) && b(i, n, n.next, o) && T(i, o) && T(o, i) && (e1.push(i.i / r), e1.push(n.i / r), e1.push(o.i / r), M(n), M(n.next), n = t1 = o), n = n.next;
                    }while (n !== t1);
                    return a(n);
                }
                function u(t1, e1, r, n, i, s) {
                    var l = t1;
                    do {
                        for(var c = l.next.next; c !== l.prev;){
                            if (l.i !== c.i && v(l, c)) {
                                var u = k(l, c);
                                return l = a(l, l.next), u = a(u, u.next), o(l, e1, r, n, i, s), void o(u, e1, r, n, i, s);
                            }
                            c = c.next;
                        }
                        l = l.next;
                    }while (l !== t1);
                }
                function f(t1, e1) {
                    return t1.x - e1.x;
                }
                function h(t1, e1) {
                    if (e1 = function(t1, e1) {
                        var r, n = e1, i = t1.x, a = t1.y, o = -1 / 0;
                        do {
                            if (a <= n.y && a >= n.next.y && n.next.y !== n.y) {
                                var s = n.x + (a - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                                if (s <= i && s > o) {
                                    if (o = s, s === i) {
                                        if (a === n.y) return n;
                                        if (a === n.next.y) return n.next;
                                    }
                                    r = n.x < n.next.x ? n : n.next;
                                }
                            }
                            n = n.next;
                        }while (n !== e1);
                        if (!r) return null;
                        if (i === o) return r;
                        var l, c = r, u = r.x, f = r.y, h = 1 / 0;
                        n = r;
                        do i >= n.x && n.x >= u && i !== n.x && g(a < f ? i : o, a, u, f, a < f ? o : i, a, n.x, n.y) && (l = Math.abs(a - n.y) / (i - n.x), T(n, t1) && (l < h || l === h && (n.x > r.x || n.x === r.x && p(r, n))) && (r = n, h = l)), n = n.next;
                        while (n !== c);
                        return r;
                    }(t1, e1)) {
                        var r = k(e1, t1);
                        a(e1, e1.next), a(r, r.next);
                    }
                }
                function p(t1, e1) {
                    return y(t1.prev, t1, e1.prev) < 0 && y(e1.next, t1, t1.next) < 0;
                }
                function d(t1, e1, r, n, i) {
                    return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = 32767 * (t1 - r) * i) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = 32767 * (e1 - n) * i) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
                }
                function m(t1) {
                    var e1 = t1, r = t1;
                    do (e1.x < r.x || e1.x === r.x && e1.y < r.y) && (r = e1), e1 = e1.next;
                    while (e1 !== t1);
                    return r;
                }
                function g(t1, e1, r, n, i, a, o, s) {
                    return (i - o) * (e1 - s) - (t1 - o) * (a - s) >= 0 && (t1 - o) * (n - s) - (r - o) * (e1 - s) >= 0 && (r - o) * (a - s) - (i - o) * (n - s) >= 0;
                }
                function v(t1, e1) {
                    return t1.next.i !== e1.i && t1.prev.i !== e1.i && !function(t1, e1) {
                        var r = t1;
                        do {
                            if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e1.i && r.next.i !== e1.i && b(r, r.next, t1, e1)) return !0;
                            r = r.next;
                        }while (r !== t1);
                        return !1;
                    }(t1, e1) && (T(t1, e1) && T(e1, t1) && function(t1, e1) {
                        var r = t1, n = !1, i = (t1.x + e1.x) / 2, a = (t1.y + e1.y) / 2;
                        do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                        while (r !== t1);
                        return n;
                    }(t1, e1) && (y(t1.prev, t1, e1.prev) || y(t1, e1.prev, e1)) || x(t1, e1) && y(t1.prev, t1, t1.next) > 0 && y(e1.prev, e1, e1.next) > 0);
                }
                function y(t1, e1, r) {
                    return (e1.y - t1.y) * (r.x - e1.x) - (e1.x - t1.x) * (r.y - e1.y);
                }
                function x(t1, e1) {
                    return t1.x === e1.x && t1.y === e1.y;
                }
                function b(t1, e1, r, n) {
                    var i = w(y(t1, e1, r)), a = w(y(t1, e1, n)), o = w(y(r, n, t1)), s = w(y(r, n, e1));
                    return i !== a && o !== s || !(0 !== i || !_(t1, r, e1)) || !(0 !== a || !_(t1, n, e1)) || !(0 !== o || !_(r, t1, n)) || !(0 !== s || !_(r, e1, n));
                }
                function _(t1, e1, r) {
                    return e1.x <= Math.max(t1.x, r.x) && e1.x >= Math.min(t1.x, r.x) && e1.y <= Math.max(t1.y, r.y) && e1.y >= Math.min(t1.y, r.y);
                }
                function w(t1) {
                    return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
                }
                function T(t1, e1) {
                    return y(t1.prev, t1, t1.next) < 0 ? y(t1, e1, t1.next) >= 0 && y(t1, t1.prev, e1) >= 0 : y(t1, e1, t1.prev) < 0 || y(t1, t1.next, e1) < 0;
                }
                function k(t1, e1) {
                    var r = new S(t1.i, t1.x, t1.y), n = new S(e1.i, e1.x, e1.y), i = t1.next, a = e1.prev;
                    return t1.next = e1, e1.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
                }
                function A(t1, e1, r, n) {
                    var i = new S(t1, e1, r);
                    return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
                }
                function M(t1) {
                    t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
                }
                function S(t1, e1, r) {
                    this.i = t1, this.x = e1, this.y = r, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
                }
                function E(t1, e1, r, n) {
                    for(var i = 0, a = e1, o = r - n; a < r; a += n)i += (t1[o] - t1[a]) * (t1[a + 1] + t1[o + 1]), o = a;
                    return i;
                }
                e1.exports = n, e1.exports.default = n, n.deviation = function(t1, e1, r, n) {
                    var i = e1 && e1.length, a = i ? e1[0] * r : t1.length, o = Math.abs(E(t1, 0, a, r));
                    if (i) for(var s = 0, l = e1.length; s < l; s++){
                        var c = e1[s] * r, u = s < l - 1 ? e1[s + 1] * r : t1.length;
                        o -= Math.abs(E(t1, c, u, r));
                    }
                    var f = 0;
                    for(s = 0; s < n.length; s += 3){
                        var h = n[s] * r, p = n[s + 1] * r, d = n[s + 2] * r;
                        f += Math.abs((t1[h] - t1[d]) * (t1[p + 1] - t1[h + 1]) - (t1[h] - t1[p]) * (t1[d + 1] - t1[h + 1]));
                    }
                    return 0 === o && 0 === f ? 0 : Math.abs((f - o) / o);
                }, n.flatten = function(t1) {
                    for(var e1 = t1[0][0].length, r = {
                        vertices: [],
                        holes: [],
                        dimensions: e1
                    }, n = 0, i = 0; i < t1.length; i++){
                        for(var a = 0; a < t1[i].length; a++)for(var o = 0; o < e1; o++)r.vertices.push(t1[i][a][o]);
                        i > 0 && (n += t1[i - 1].length, r.holes.push(n));
                    }
                    return r;
                };
            },
            {}
        ],
        130: [
            function(t1, e1, r) {
                var n = t1("strongly-connected-components");
                e1.exports = function(t1, e1) {
                    var r, i = [], a = [], o = [], s = {}, l = [];
                    function c(t1) {
                        var e1, n, i = !1;
                        for(a.push(t1), o[t1] = !0, e1 = 0; e1 < l[t1].length; e1++)(n = l[t1][e1]) === r ? (u(r, a), i = !0) : o[n] || (i = c(n));
                        if (i) !function t1(e1) {
                            o[e1] = !1, s.hasOwnProperty(e1) && Object.keys(s[e1]).forEach(function(r) {
                                delete s[e1][r], o[r] && t1(r);
                            });
                        }(t1);
                        else for(e1 = 0; e1 < l[t1].length; e1++){
                            n = l[t1][e1];
                            var f = s[n];
                            f || (f = {}, s[n] = f), f[n] = !0;
                        }
                        return a.pop(), i;
                    }
                    function u(t1, r) {
                        var n = [].concat(r).concat(t1);
                        e1 ? e1(c) : i.push(n);
                    }
                    function f(e1) {
                        !function(e1) {
                            for(var r = 0; r < t1.length; r++)r < e1 && (t1[r] = []), t1[r] = t1[r].filter(function(t1) {
                                return t1 >= e1;
                            });
                        }(e1);
                        for(var r, i = n(t1).components.filter(function(t1) {
                            return t1.length > 1;
                        }), a = 1 / 0, o = 0; o < i.length; o++)for(var s = 0; s < i[o].length; s++)i[o][s] < a && (a = i[o][s], r = o);
                        var l = i[r];
                        return !!l && {
                            leastVertex: a,
                            adjList: t1.map(function(t1, e1) {
                                return -1 === l.indexOf(e1) ? [] : t1.filter(function(t1) {
                                    return -1 !== l.indexOf(t1);
                                });
                            })
                        };
                    }
                    r = 0;
                    for(var h = t1.length; r < h;){
                        var p = f(r);
                        if (r = p.leastVertex, l = p.adjList) {
                            for(var d = 0; d < l.length; d++)for(var m = 0; m < l[d].length; m++){
                                var g = l[d][m];
                                o[+g] = !1, s[g] = {};
                            }
                            c(r), r += 1;
                        } else r = h;
                    }
                    return e1 ? void 0 : i;
                };
            },
            {
                "strongly-connected-components": 306
            }
        ],
        131: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../object/valid-value");
                e1.exports = function() {
                    return n(this).length = 0, this;
                };
            },
            {
                "../../object/valid-value": 162
            }
        ],
        132: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("./is-implemented")() ? Array.from : t1("./shim");
            },
            {
                "./is-implemented": 133,
                "./shim": 134
            }
        ],
        133: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function() {
                    var t1, e1, r = Array.from;
                    return "function" == typeof r && (e1 = r(t1 = [
                        "raz",
                        "dwa"
                    ]), Boolean(e1 && e1 !== t1 && "dwa" === e1[1]));
                };
            },
            {}
        ],
        134: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("es6-symbol").iterator, i = t1("../../function/is-arguments"), a = t1("../../function/is-function"), o = t1("../../number/to-pos-integer"), s = t1("../../object/valid-callable"), l = t1("../../object/valid-value"), c = t1("../../object/is-value"), u = t1("../../string/is-string"), f = Array.isArray, h = Function.prototype.call, p = {
                    configurable: !0,
                    enumerable: !0,
                    writable: !0,
                    value: null
                }, d = Object.defineProperty;
                e1.exports = function(t1) {
                    var e1, r, m, g, v, y, x, b, _, w, T = arguments[1], k = arguments[2];
                    if (t1 = Object(l(t1)), c(T) && s(T), this && this !== Array && a(this)) e1 = this;
                    else {
                        if (!T) {
                            if (i(t1)) return 1 !== (v = t1.length) ? Array.apply(null, t1) : ((g = new Array(1))[0] = t1[0], g);
                            if (f(t1)) {
                                for(g = new Array(v = t1.length), r = 0; r < v; ++r)g[r] = t1[r];
                                return g;
                            }
                        }
                        g = [];
                    }
                    if (!f(t1)) {
                        if (void 0 !== (_ = t1[n])) {
                            for(x = s(_).call(t1), e1 && (g = new e1), b = x.next(), r = 0; !b.done;)w = T ? h.call(T, k, b.value, r) : b.value, e1 ? (p.value = w, d(g, r, p)) : g[r] = w, b = x.next(), ++r;
                            v = r;
                        } else if (u(t1)) {
                            for(v = t1.length, e1 && (g = new e1), r = 0, m = 0; r < v; ++r)w = t1[r], r + 1 < v && (y = w.charCodeAt(0)) >= 55296 && y <= 56319 && (w += t1[++r]), w = T ? h.call(T, k, w, m) : w, e1 ? (p.value = w, d(g, m, p)) : g[m] = w, ++m;
                            v = m;
                        }
                    }
                    if (void 0 === v) for(v = o(t1.length), e1 && (g = new e1(v)), r = 0; r < v; ++r)w = T ? h.call(T, k, t1[r], r) : t1[r], e1 ? (p.value = w, d(g, r, p)) : g[r] = w;
                    return e1 && (p.value = null, g.length = v), g;
                };
            },
            {
                "../../function/is-arguments": 135,
                "../../function/is-function": 136,
                "../../number/to-pos-integer": 142,
                "../../object/is-value": 151,
                "../../object/valid-callable": 160,
                "../../object/valid-value": 162,
                "../../string/is-string": 166,
                "es6-symbol": 175
            }
        ],
        135: [
            function(t1, e1, r) {
                "use strict";
                var n = Object.prototype.toString, i = n.call(function() {
                    return arguments;
                }());
                e1.exports = function(t1) {
                    return n.call(t1) === i;
                };
            },
            {}
        ],
        136: [
            function(t1, e1, r) {
                "use strict";
                var n = Object.prototype.toString, i = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);
                e1.exports = function(t1) {
                    return "function" == typeof t1 && i(n.call(t1));
                };
            },
            {}
        ],
        137: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function() {};
            },
            {}
        ],
        138: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("./is-implemented")() ? Math.sign : t1("./shim");
            },
            {
                "./is-implemented": 139,
                "./shim": 140
            }
        ],
        139: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function() {
                    var t1 = Math.sign;
                    return "function" == typeof t1 && 1 === t1(10) && -1 === t1(-20);
                };
            },
            {}
        ],
        140: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    return t1 = Number(t1), isNaN(t1) || 0 === t1 ? t1 : t1 > 0 ? 1 : -1;
                };
            },
            {}
        ],
        141: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../math/sign"), i = Math.abs, a = Math.floor;
                e1.exports = function(t1) {
                    return isNaN(t1) ? 0 : 0 !== (t1 = Number(t1)) && isFinite(t1) ? n(t1) * a(i(t1)) : t1;
                };
            },
            {
                "../math/sign": 138
            }
        ],
        142: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./to-integer"), i = Math.max;
                e1.exports = function(t1) {
                    return i(0, n(t1));
                };
            },
            {
                "./to-integer": 141
            }
        ],
        143: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./valid-callable"), i = t1("./valid-value"), a = Function.prototype.bind, o = Function.prototype.call, s = Object.keys, l = Object.prototype.propertyIsEnumerable;
                e1.exports = function(t1, e1) {
                    return function(r, c) {
                        var u, f = arguments[2], h = arguments[3];
                        return r = Object(i(r)), n(c), u = s(r), h && u.sort("function" == typeof h ? a.call(h, r) : void 0), "function" != typeof t1 && (t1 = u[t1]), o.call(t1, u, function(t1, n) {
                            return l.call(r, t1) ? o.call(c, f, r[t1], t1, r, n) : e1;
                        });
                    };
                };
            },
            {
                "./valid-callable": 160,
                "./valid-value": 162
            }
        ],
        144: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("./is-implemented")() ? Object.assign : t1("./shim");
            },
            {
                "./is-implemented": 145,
                "./shim": 146
            }
        ],
        145: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function() {
                    var t1, e1 = Object.assign;
                    return "function" == typeof e1 && (e1(t1 = {
                        foo: "raz"
                    }, {
                        bar: "dwa"
                    }, {
                        trzy: "trzy"
                    }), t1.foo + t1.bar + t1.trzy === "razdwatrzy");
                };
            },
            {}
        ],
        146: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../keys"), i = t1("../valid-value"), a = Math.max;
                e1.exports = function(t1, e1) {
                    var r, o, s, l = a(arguments.length, 2);
                    for(t1 = Object(i(t1)), s = function(n) {
                        try {
                            t1[n] = e1[n];
                        } catch (t1) {
                            r || (r = t1);
                        }
                    }, o = 1; o < l; ++o)n(e1 = arguments[o]).forEach(s);
                    if (void 0 !== r) throw r;
                    return t1;
                };
            },
            {
                "../keys": 152,
                "../valid-value": 162
            }
        ],
        147: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../array/from"), i = t1("./assign"), a = t1("./valid-value");
                e1.exports = function(t1) {
                    var e1 = Object(a(t1)), r = arguments[1], o = Object(arguments[2]);
                    if (e1 !== t1 && !r) return e1;
                    var s = {};
                    return r ? n(r, function(e1) {
                        (o.ensure || e1 in t1) && (s[e1] = t1[e1]);
                    }) : i(s, t1), s;
                };
            },
            {
                "../array/from": 132,
                "./assign": 144,
                "./valid-value": 162
            }
        ],
        148: [
            function(t1, e1, r) {
                "use strict";
                var n, i, a, o, s = Object.create;
                t1("./set-prototype-of/is-implemented")() || (n = t1("./set-prototype-of/shim")), e1.exports = n ? 1 !== n.level ? s : (i = {}, a = {}, o = {
                    configurable: !1,
                    enumerable: !1,
                    writable: !0,
                    value: void 0
                }, Object.getOwnPropertyNames(Object.prototype).forEach(function(t1) {
                    a[t1] = "__proto__" !== t1 ? o : {
                        configurable: !0,
                        enumerable: !1,
                        writable: !0,
                        value: void 0
                    };
                }), Object.defineProperties(i, a), Object.defineProperty(n, "nullPolyfill", {
                    configurable: !1,
                    enumerable: !1,
                    writable: !1,
                    value: i
                }), function(t1, e1) {
                    return s(null === t1 ? i : t1, e1);
                }) : s;
            },
            {
                "./set-prototype-of/is-implemented": 158,
                "./set-prototype-of/shim": 159
            }
        ],
        149: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("./_iterate")("forEach");
            },
            {
                "./_iterate": 143
            }
        ],
        150: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./is-value"), i = {
                    function: !0,
                    object: !0
                };
                e1.exports = function(t1) {
                    return n(t1) && i[typeof t1] || !1;
                };
            },
            {
                "./is-value": 151
            }
        ],
        151: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../function/noop")();
                e1.exports = function(t1) {
                    return t1 !== n && null !== t1;
                };
            },
            {
                "../function/noop": 137
            }
        ],
        152: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("./is-implemented")() ? Object.keys : t1("./shim");
            },
            {
                "./is-implemented": 153,
                "./shim": 154
            }
        ],
        153: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function() {
                    try {
                        return Object.keys("primitive"), !0;
                    } catch (t1) {
                        return !1;
                    }
                };
            },
            {}
        ],
        154: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../is-value"), i = Object.keys;
                e1.exports = function(t1) {
                    return i(n(t1) ? Object(t1) : t1);
                };
            },
            {
                "../is-value": 151
            }
        ],
        155: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./valid-callable"), i = t1("./for-each"), a = Function.prototype.call;
                e1.exports = function(t1, e1) {
                    var r = {}, o = arguments[2];
                    return n(e1), i(t1, function(t1, n, i, s) {
                        r[n] = a.call(e1, o, t1, n, i, s);
                    }), r;
                };
            },
            {
                "./for-each": 149,
                "./valid-callable": 160
            }
        ],
        156: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./is-value"), i = Array.prototype.forEach, a = Object.create, o = function(t1, e1) {
                    var r;
                    for(r in t1)e1[r] = t1[r];
                };
                e1.exports = function(t1) {
                    var e1 = a(null);
                    return i.call(arguments, function(t1) {
                        n(t1) && o(Object(t1), e1);
                    }), e1;
                };
            },
            {
                "./is-value": 151
            }
        ],
        157: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("./is-implemented")() ? Object.setPrototypeOf : t1("./shim");
            },
            {
                "./is-implemented": 158,
                "./shim": 159
            }
        ],
        158: [
            function(t1, e1, r) {
                "use strict";
                var n = Object.create, i = Object.getPrototypeOf, a = {};
                e1.exports = function() {
                    var t1 = Object.setPrototypeOf, e1 = arguments[0] || n;
                    return "function" == typeof t1 && i(t1(e1(null), a)) === a;
                };
            },
            {}
        ],
        159: [
            function(t1, e1, r) {
                "use strict";
                var n, i = t1("../is-object"), a = t1("../valid-value"), o = Object.prototype.isPrototypeOf, s = Object.defineProperty, l = {
                    configurable: !0,
                    enumerable: !1,
                    writable: !0,
                    value: void 0
                };
                n = function(t1, e1) {
                    if (a(t1), null === e1 || i(e1)) return t1;
                    throw new TypeError("Prototype must be null or an object");
                }, e1.exports = function(t1) {
                    var e1, r;
                    return t1 ? (2 === t1.level ? t1.set ? (r = t1.set, e1 = function(t1, e1) {
                        return r.call(n(t1, e1), e1), t1;
                    }) : e1 = function(t1, e1) {
                        return n(t1, e1).__proto__ = e1, t1;
                    } : e1 = function t1(e1, r) {
                        var i;
                        return n(e1, r), (i = o.call(t1.nullPolyfill, e1)) && delete t1.nullPolyfill.__proto__, null === r && (r = t1.nullPolyfill), e1.__proto__ = r, i && s(t1.nullPolyfill, "__proto__", l), e1;
                    }, Object.defineProperty(e1, "level", {
                        configurable: !1,
                        enumerable: !1,
                        writable: !1,
                        value: t1.level
                    })) : null;
                }(function() {
                    var t1, e1 = Object.create(null), r = {}, n = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");
                    if (n) {
                        try {
                            (t1 = n.set).call(e1, r);
                        } catch (t1) {}
                        if (Object.getPrototypeOf(e1) === r) return {
                            set: t1,
                            level: 2
                        };
                    }
                    return e1.__proto__ = r, Object.getPrototypeOf(e1) === r ? {
                        level: 2
                    } : ((e1 = {}).__proto__ = r, Object.getPrototypeOf(e1) === r && {
                        level: 1
                    });
                }()), t1("../create");
            },
            {
                "../create": 148,
                "../is-object": 150,
                "../valid-value": 162
            }
        ],
        160: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    if ("function" != typeof t1) throw new TypeError(t1 + " is not a function");
                    return t1;
                };
            },
            {}
        ],
        161: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./is-object");
                e1.exports = function(t1) {
                    if (!n(t1)) throw new TypeError(t1 + " is not an Object");
                    return t1;
                };
            },
            {
                "./is-object": 150
            }
        ],
        162: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./is-value");
                e1.exports = function(t1) {
                    if (!n(t1)) throw new TypeError("Cannot use null or undefined");
                    return t1;
                };
            },
            {
                "./is-value": 151
            }
        ],
        163: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("./is-implemented")() ? String.prototype.contains : t1("./shim");
            },
            {
                "./is-implemented": 164,
                "./shim": 165
            }
        ],
        164: [
            function(t1, e1, r) {
                "use strict";
                var n = "razdwatrzy";
                e1.exports = function() {
                    return "function" == typeof n.contains && !0 === n.contains("dwa") && !1 === n.contains("foo");
                };
            },
            {}
        ],
        165: [
            function(t1, e1, r) {
                "use strict";
                var n = String.prototype.indexOf;
                e1.exports = function(t1) {
                    return n.call(this, t1, arguments[1]) > -1;
                };
            },
            {}
        ],
        166: [
            function(t1, e1, r) {
                "use strict";
                var n = Object.prototype.toString, i = n.call("");
                e1.exports = function(t1) {
                    return "string" == typeof t1 || t1 && "object" == typeof t1 && (t1 instanceof String || n.call(t1) === i) || !1;
                };
            },
            {}
        ],
        167: [
            function(t1, e1, r) {
                "use strict";
                var n = Object.create(null), i = Math.random;
                e1.exports = function() {
                    var t1;
                    do t1 = i().toString(36).slice(2);
                    while (n[t1]);
                    return t1;
                };
            },
            {}
        ],
        168: [
            function(t1, e1, r) {
                "use strict";
                var n, i = t1("es5-ext/object/set-prototype-of"), a = t1("es5-ext/string/#/contains"), o = t1("d"), s = t1("es6-symbol"), l = t1("./"), c = Object.defineProperty;
                n = e1.exports = function(t1, e1) {
                    if (!(this instanceof n)) throw new TypeError("Constructor requires 'new'");
                    l.call(this, t1), e1 = e1 ? a.call(e1, "key+value") ? "key+value" : a.call(e1, "key") ? "key" : "value" : "value", c(this, "__kind__", o("", e1));
                }, i && i(n, l), delete n.prototype.constructor, n.prototype = Object.create(l.prototype, {
                    _resolve: o(function(t1) {
                        return "value" === this.__kind__ ? this.__list__[t1] : "key+value" === this.__kind__ ? [
                            t1,
                            this.__list__[t1]
                        ] : t1;
                    })
                }), c(n.prototype, s.toStringTag, o("c", "Array Iterator"));
            },
            {
                "./": 171,
                d: 106,
                "es5-ext/object/set-prototype-of": 157,
                "es5-ext/string/#/contains": 163,
                "es6-symbol": 175
            }
        ],
        169: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("es5-ext/function/is-arguments"), i = t1("es5-ext/object/valid-callable"), a = t1("es5-ext/string/is-string"), o = t1("./get"), s = Array.isArray, l = Function.prototype.call, c = Array.prototype.some;
                e1.exports = function(t1, e1) {
                    var r, u, f, h, p, d, m, g, v = arguments[2];
                    if (s(t1) || n(t1) ? r = "array" : a(t1) ? r = "string" : t1 = o(t1), i(e1), f = function() {
                        h = !0;
                    }, "array" !== r) {
                        if ("string" !== r) for(u = t1.next(); !u.done;){
                            if (l.call(e1, v, u.value, f), h) return;
                            u = t1.next();
                        }
                        else for(d = t1.length, p = 0; p < d && (m = t1[p], p + 1 < d && (g = m.charCodeAt(0)) >= 55296 && g <= 56319 && (m += t1[++p]), l.call(e1, v, m, f), !h); ++p);
                    } else c.call(t1, function(t1) {
                        return l.call(e1, v, t1, f), h;
                    });
                };
            },
            {
                "./get": 170,
                "es5-ext/function/is-arguments": 135,
                "es5-ext/object/valid-callable": 160,
                "es5-ext/string/is-string": 166
            }
        ],
        170: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("es5-ext/function/is-arguments"), i = t1("es5-ext/string/is-string"), a = t1("./array"), o = t1("./string"), s = t1("./valid-iterable"), l = t1("es6-symbol").iterator;
                e1.exports = function(t1) {
                    return "function" == typeof s(t1)[l] ? t1[l]() : n(t1) ? new a(t1) : i(t1) ? new o(t1) : new a(t1);
                };
            },
            {
                "./array": 168,
                "./string": 173,
                "./valid-iterable": 174,
                "es5-ext/function/is-arguments": 135,
                "es5-ext/string/is-string": 166,
                "es6-symbol": 175
            }
        ],
        171: [
            function(t1, e1, r) {
                "use strict";
                var n, i = t1("es5-ext/array/#/clear"), a = t1("es5-ext/object/assign"), o = t1("es5-ext/object/valid-callable"), s = t1("es5-ext/object/valid-value"), l = t1("d"), c = t1("d/auto-bind"), u = t1("es6-symbol"), f = Object.defineProperty, h = Object.defineProperties;
                e1.exports = n = function(t1, e1) {
                    if (!(this instanceof n)) throw new TypeError("Constructor requires 'new'");
                    h(this, {
                        __list__: l("w", s(t1)),
                        __context__: l("w", e1),
                        __nextIndex__: l("w", 0)
                    }), e1 && (o(e1.on), e1.on("_add", this._onAdd), e1.on("_delete", this._onDelete), e1.on("_clear", this._onClear));
                }, delete n.prototype.constructor, h(n.prototype, a({
                    _next: l(function() {
                        var t1;
                        if (this.__list__) return this.__redo__ && void 0 !== (t1 = this.__redo__.shift()) ? t1 : this.__nextIndex__ < this.__list__.length ? this.__nextIndex__++ : void this._unBind();
                    }),
                    next: l(function() {
                        return this._createResult(this._next());
                    }),
                    _createResult: l(function(t1) {
                        return void 0 === t1 ? {
                            done: !0,
                            value: void 0
                        } : {
                            done: !1,
                            value: this._resolve(t1)
                        };
                    }),
                    _resolve: l(function(t1) {
                        return this.__list__[t1];
                    }),
                    _unBind: l(function() {
                        this.__list__ = null, delete this.__redo__, this.__context__ && (this.__context__.off("_add", this._onAdd), this.__context__.off("_delete", this._onDelete), this.__context__.off("_clear", this._onClear), this.__context__ = null);
                    }),
                    toString: l(function() {
                        return "[object " + (this[u.toStringTag] || "Object") + "]";
                    })
                }, c({
                    _onAdd: l(function(t1) {
                        t1 >= this.__nextIndex__ || (++this.__nextIndex__, this.__redo__ ? (this.__redo__.forEach(function(e1, r) {
                            e1 >= t1 && (this.__redo__[r] = ++e1);
                        }, this), this.__redo__.push(t1)) : f(this, "__redo__", l("c", [
                            t1
                        ])));
                    }),
                    _onDelete: l(function(t1) {
                        var e1;
                        t1 >= this.__nextIndex__ || (--this.__nextIndex__, this.__redo__ && (-1 !== (e1 = this.__redo__.indexOf(t1)) && this.__redo__.splice(e1, 1), this.__redo__.forEach(function(e1, r) {
                            e1 > t1 && (this.__redo__[r] = --e1);
                        }, this)));
                    }),
                    _onClear: l(function() {
                        this.__redo__ && i.call(this.__redo__), this.__nextIndex__ = 0;
                    })
                }))), f(n.prototype, u.iterator, l(function() {
                    return this;
                }));
            },
            {
                d: 106,
                "d/auto-bind": 105,
                "es5-ext/array/#/clear": 131,
                "es5-ext/object/assign": 144,
                "es5-ext/object/valid-callable": 160,
                "es5-ext/object/valid-value": 162,
                "es6-symbol": 175
            }
        ],
        172: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("es5-ext/function/is-arguments"), i = t1("es5-ext/object/is-value"), a = t1("es5-ext/string/is-string"), o = t1("es6-symbol").iterator, s = Array.isArray;
                e1.exports = function(t1) {
                    return !!i(t1) && (!!s(t1) || !!a(t1) || !!n(t1) || "function" == typeof t1[o]);
                };
            },
            {
                "es5-ext/function/is-arguments": 135,
                "es5-ext/object/is-value": 151,
                "es5-ext/string/is-string": 166,
                "es6-symbol": 175
            }
        ],
        173: [
            function(t1, e1, r) {
                "use strict";
                var n, i = t1("es5-ext/object/set-prototype-of"), a = t1("d"), o = t1("es6-symbol"), s = t1("./"), l = Object.defineProperty;
                n = e1.exports = function(t1) {
                    if (!(this instanceof n)) throw new TypeError("Constructor requires 'new'");
                    t1 = String(t1), s.call(this, t1), l(this, "__length__", a("", t1.length));
                }, i && i(n, s), delete n.prototype.constructor, n.prototype = Object.create(s.prototype, {
                    _next: a(function() {
                        if (this.__list__) return this.__nextIndex__ < this.__length__ ? this.__nextIndex__++ : void this._unBind();
                    }),
                    _resolve: a(function(t1) {
                        var e1, r = this.__list__[t1];
                        return this.__nextIndex__ === this.__length__ ? r : (e1 = r.charCodeAt(0)) >= 55296 && e1 <= 56319 ? r + this.__list__[this.__nextIndex__++] : r;
                    })
                }), l(n.prototype, o.toStringTag, a("c", "String Iterator"));
            },
            {
                "./": 171,
                d: 106,
                "es5-ext/object/set-prototype-of": 157,
                "es6-symbol": 175
            }
        ],
        174: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./is-iterable");
                e1.exports = function(t1) {
                    if (!n(t1)) throw new TypeError(t1 + " is not iterable");
                    return t1;
                };
            },
            {
                "./is-iterable": 172
            }
        ],
        175: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("./is-implemented")() ? t1("ext/global-this").Symbol : t1("./polyfill");
            },
            {
                "./is-implemented": 176,
                "./polyfill": 181,
                "ext/global-this": 188
            }
        ],
        176: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("ext/global-this"), i = {
                    object: !0,
                    symbol: !0
                };
                e1.exports = function() {
                    var t1, e1 = n.Symbol;
                    if ("function" != typeof e1) return !1;
                    t1 = e1("test symbol");
                    try {
                        String(t1);
                    } catch (t1) {
                        return !1;
                    }
                    return !!i[typeof e1.iterator] && !!i[typeof e1.toPrimitive] && !!i[typeof e1.toStringTag];
                };
            },
            {
                "ext/global-this": 188
            }
        ],
        177: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    return !!t1 && ("symbol" == typeof t1 || !!t1.constructor && "Symbol" === t1.constructor.name && "Symbol" === t1[t1.constructor.toStringTag]);
                };
            },
            {}
        ],
        178: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("d"), i = Object.create, a = Object.defineProperty, o = Object.prototype, s = i(null);
                e1.exports = function(t1) {
                    for(var e1, r, i = 0; s[t1 + (i || "")];)++i;
                    return s[t1 += i || ""] = !0, a(o, e1 = "@@" + t1, n.gs(null, function(t1) {
                        r || (r = !0, a(this, e1, n(t1)), r = !1);
                    })), e1;
                };
            },
            {
                d: 106
            }
        ],
        179: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("d"), i = t1("ext/global-this").Symbol;
                e1.exports = function(t1) {
                    return Object.defineProperties(t1, {
                        hasInstance: n("", i && i.hasInstance || t1("hasInstance")),
                        isConcatSpreadable: n("", i && i.isConcatSpreadable || t1("isConcatSpreadable")),
                        iterator: n("", i && i.iterator || t1("iterator")),
                        match: n("", i && i.match || t1("match")),
                        replace: n("", i && i.replace || t1("replace")),
                        search: n("", i && i.search || t1("search")),
                        species: n("", i && i.species || t1("species")),
                        split: n("", i && i.split || t1("split")),
                        toPrimitive: n("", i && i.toPrimitive || t1("toPrimitive")),
                        toStringTag: n("", i && i.toStringTag || t1("toStringTag")),
                        unscopables: n("", i && i.unscopables || t1("unscopables"))
                    });
                };
            },
            {
                d: 106,
                "ext/global-this": 188
            }
        ],
        180: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("d"), i = t1("../../../validate-symbol"), a = Object.create(null);
                e1.exports = function(t1) {
                    return Object.defineProperties(t1, {
                        for: n(function(e1) {
                            return a[e1] ? a[e1] : a[e1] = t1(String(e1));
                        }),
                        keyFor: n(function(t1) {
                            var e1;
                            for(e1 in i(t1), a)if (a[e1] === t1) return e1;
                        })
                    });
                };
            },
            {
                "../../../validate-symbol": 182,
                d: 106
            }
        ],
        181: [
            function(t1, e1, r) {
                "use strict";
                var n, i, a, o = t1("d"), s = t1("./validate-symbol"), l = t1("ext/global-this").Symbol, c = t1("./lib/private/generate-name"), u = t1("./lib/private/setup/standard-symbols"), f = t1("./lib/private/setup/symbol-registry"), h = Object.create, p = Object.defineProperties, d = Object.defineProperty;
                if ("function" == typeof l) try {
                    String(l()), a = !0;
                } catch (t1) {}
                else l = null;
                i = function(t1) {
                    if (this instanceof i) throw new TypeError("Symbol is not a constructor");
                    return n(t1);
                }, e1.exports = n = function t1(e1) {
                    var r;
                    if (this instanceof t1) throw new TypeError("Symbol is not a constructor");
                    return a ? l(e1) : (r = h(i.prototype), e1 = void 0 === e1 ? "" : String(e1), p(r, {
                        __description__: o("", e1),
                        __name__: o("", c(e1))
                    }));
                }, u(n), f(n), p(i.prototype, {
                    constructor: o(n),
                    toString: o("", function() {
                        return this.__name__;
                    })
                }), p(n.prototype, {
                    toString: o(function() {
                        return "Symbol (" + s(this).__description__ + ")";
                    }),
                    valueOf: o(function() {
                        return s(this);
                    })
                }), d(n.prototype, n.toPrimitive, o("", function() {
                    var t1 = s(this);
                    return "symbol" == typeof t1 ? t1 : t1.toString();
                })), d(n.prototype, n.toStringTag, o("c", "Symbol")), d(i.prototype, n.toStringTag, o("c", n.prototype[n.toStringTag])), d(i.prototype, n.toPrimitive, o("c", n.prototype[n.toPrimitive]));
            },
            {
                "./lib/private/generate-name": 178,
                "./lib/private/setup/standard-symbols": 179,
                "./lib/private/setup/symbol-registry": 180,
                "./validate-symbol": 182,
                d: 106,
                "ext/global-this": 188
            }
        ],
        182: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./is-symbol");
                e1.exports = function(t1) {
                    if (!n(t1)) throw new TypeError(t1 + " is not a symbol");
                    return t1;
                };
            },
            {
                "./is-symbol": 177
            }
        ],
        183: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("./is-implemented")() ? WeakMap : t1("./polyfill");
            },
            {
                "./is-implemented": 184,
                "./polyfill": 186
            }
        ],
        184: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function() {
                    var t1, e1;
                    if ("function" != typeof WeakMap) return !1;
                    try {
                        t1 = new WeakMap([
                            [
                                e1 = {},
                                "one"
                            ],
                            [
                                {},
                                "two"
                            ],
                            [
                                {},
                                "three"
                            ]
                        ]);
                    } catch (t1) {
                        return !1;
                    }
                    return "[object WeakMap]" === String(t1) && "function" == typeof t1.set && t1.set({}, 1) === t1 && "function" == typeof t1.delete && "function" == typeof t1.has && "one" === t1.get(e1);
                };
            },
            {}
        ],
        185: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = "function" == typeof WeakMap && "[object WeakMap]" === Object.prototype.toString.call(new WeakMap);
            },
            {}
        ],
        186: [
            function(t1, e1, r) {
                "use strict";
                var n, i = t1("es5-ext/object/is-value"), a = t1("es5-ext/object/set-prototype-of"), o = t1("es5-ext/object/valid-object"), s = t1("es5-ext/object/valid-value"), l = t1("es5-ext/string/random-uniq"), c = t1("d"), u = t1("es6-iterator/get"), f = t1("es6-iterator/for-of"), h = t1("es6-symbol").toStringTag, p = t1("./is-native-implemented"), d = Array.isArray, m = Object.defineProperty, g = Object.prototype.hasOwnProperty, v = Object.getPrototypeOf;
                e1.exports = n = function() {
                    var t1, e1 = arguments[0];
                    if (!(this instanceof n)) throw new TypeError("Constructor requires 'new'");
                    return t1 = p && a && WeakMap !== n ? a(new WeakMap, v(this)) : this, i(e1) && (d(e1) || (e1 = u(e1))), m(t1, "__weakMapData__", c("c", "$weakMap$" + l())), e1 ? (f(e1, function(e1) {
                        s(e1), t1.set(e1[0], e1[1]);
                    }), t1) : t1;
                }, p && (a && a(n, WeakMap), n.prototype = Object.create(WeakMap.prototype, {
                    constructor: c(n)
                })), Object.defineProperties(n.prototype, {
                    delete: c(function(t1) {
                        return !!g.call(o(t1), this.__weakMapData__) && (delete t1[this.__weakMapData__], !0);
                    }),
                    get: c(function(t1) {
                        if (g.call(o(t1), this.__weakMapData__)) return t1[this.__weakMapData__];
                    }),
                    has: c(function(t1) {
                        return g.call(o(t1), this.__weakMapData__);
                    }),
                    set: c(function(t1, e1) {
                        return m(o(t1), this.__weakMapData__, c("c", e1)), this;
                    }),
                    toString: c(function() {
                        return "[object WeakMap]";
                    })
                }), m(n.prototype, h, c("c", "WeakMap"));
            },
            {
                "./is-native-implemented": 185,
                d: 106,
                "es5-ext/object/is-value": 151,
                "es5-ext/object/set-prototype-of": 157,
                "es5-ext/object/valid-object": 161,
                "es5-ext/object/valid-value": 162,
                "es5-ext/string/random-uniq": 167,
                "es6-iterator/for-of": 169,
                "es6-iterator/get": 170,
                "es6-symbol": 175
            }
        ],
        187: [
            function(t1, e1, r) {
                var n = function() {
                    if ("object" == typeof self && self) return self;
                    if ("object" == typeof window && window) return window;
                    throw new Error("Unable to resolve global `this`");
                };
                e1.exports = function() {
                    if (this) return this;
                    try {
                        Object.defineProperty(Object.prototype, "__global__", {
                            get: function() {
                                return this;
                            },
                            configurable: !0
                        });
                    } catch (t1) {
                        return n();
                    }
                    try {
                        return __global__ || n();
                    } finally{
                        delete Object.prototype.__global__;
                    }
                }();
            },
            {}
        ],
        188: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("./is-implemented")() ? globalThis : t1("./implementation");
            },
            {
                "./implementation": 187,
                "./is-implemented": 189
            }
        ],
        189: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function() {
                    return "object" == typeof globalThis && !!globalThis && globalThis.Array === Array;
                };
            },
            {}
        ],
        190: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("is-string-blank");
                e1.exports = function(t1) {
                    var e1 = typeof t1;
                    if ("string" === e1) {
                        var r = t1;
                        if (0 === (t1 = +t1) && n(r)) return !1;
                    } else if ("number" !== e1) return !1;
                    return t1 - t1 < 1;
                };
            },
            {
                "is-string-blank": 237
            }
        ],
        191: [
            function(t1, e1, r) {
                var n = t1("dtype");
                e1.exports = function(t1, e1, r) {
                    if (!t1) throw new TypeError("must specify data as first parameter");
                    if (r = 0 | +(r || 0), Array.isArray(t1) && t1[0] && "number" == typeof t1[0][0]) {
                        var i, a, o, s, l = t1[0].length, c = t1.length * l;
                        e1 && "string" != typeof e1 || (e1 = new (n(e1 || "float32"))(c + r));
                        var u = e1.length - r;
                        if (c !== u) throw new Error("source length " + c + " (" + l + "x" + t1.length + ") does not match destination length " + u);
                        for(i = 0, o = r; i < t1.length; i++)for(a = 0; a < l; a++)e1[o++] = null === t1[i][a] ? NaN : t1[i][a];
                    } else if (e1 && "string" != typeof e1) e1.set(t1, r);
                    else {
                        var f = n(e1 || "float32");
                        if (Array.isArray(t1) || "array" === e1) for(e1 = new f(t1.length + r), i = 0, o = r, s = e1.length; o < s; o++, i++)e1[o] = null === t1[i] ? NaN : t1[i];
                        else 0 === r ? e1 = new f(t1) : (e1 = new f(t1.length + r)).set(t1, r);
                    }
                    return e1;
                };
            },
            {
                dtype: 127
            }
        ],
        192: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("css-font/stringify"), i = [
                    32,
                    126
                ];
                e1.exports = function(t1) {
                    var e1 = (t1 = t1 || {}).shape ? t1.shape : t1.canvas ? [
                        t1.canvas.width,
                        t1.canvas.height
                    ] : [
                        512,
                        512
                    ], r = t1.canvas || document.createElement("canvas"), a = t1.font, o = "number" == typeof t1.step ? [
                        t1.step,
                        t1.step
                    ] : t1.step || [
                        32,
                        32
                    ], s = t1.chars || i;
                    a && "string" != typeof a && (a = n(a));
                    if (Array.isArray(s)) {
                        if (2 === s.length && "number" == typeof s[0] && "number" == typeof s[1]) {
                            for(var l = [], c = s[0], u = 0; c <= s[1]; c++)l[u++] = String.fromCharCode(c);
                            s = l;
                        }
                    } else s = String(s).split("");
                    e1 = e1.slice(), r.width = e1[0], r.height = e1[1];
                    var f = r.getContext("2d");
                    f.fillStyle = "#000", f.fillRect(0, 0, r.width, r.height), f.font = a, f.textAlign = "center", f.textBaseline = "middle", f.fillStyle = "#fff";
                    var h = o[0] / 2, p = o[1] / 2;
                    for(c = 0; c < s.length; c++)f.fillText(s[c], h, p), (h += o[0]) > e1[0] - o[0] / 2 && (h = o[0] / 2, p += o[1]);
                    return r;
                };
            },
            {
                "css-font/stringify": 102
            }
        ],
        193: [
            function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    e1 || (e1 = {}), ("string" == typeof t1 || Array.isArray(t1)) && (e1.family = t1);
                    var r = Array.isArray(e1.family) ? e1.family.join(", ") : e1.family;
                    if (!r) throw Error("`family` must be defined");
                    var s = e1.size || e1.fontSize || e1.em || 48, l = e1.weight || e1.fontWeight || "", c = (t1 = [
                        e1.style || e1.fontStyle || "",
                        l,
                        s
                    ].join(" ") + "px " + r, e1.origin || "top");
                    if (n.cache[r] && s <= n.cache[r].em) return i(n.cache[r], c);
                    var u = e1.canvas || n.canvas, f = u.getContext("2d"), h = {
                        upper: void 0 !== e1.upper ? e1.upper : "H",
                        lower: void 0 !== e1.lower ? e1.lower : "x",
                        descent: void 0 !== e1.descent ? e1.descent : "p",
                        ascent: void 0 !== e1.ascent ? e1.ascent : "h",
                        tittle: void 0 !== e1.tittle ? e1.tittle : "i",
                        overshoot: void 0 !== e1.overshoot ? e1.overshoot : "O"
                    }, p = Math.ceil(1.5 * s);
                    u.height = p, u.width = .5 * p, f.font = t1;
                    var d = {
                        top: 0
                    };
                    f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillStyle = "black", f.fillText("H", 0, 0);
                    var m = a(f.getImageData(0, 0, p, p));
                    f.clearRect(0, 0, p, p), f.textBaseline = "bottom", f.fillText("H", 0, p);
                    var g = a(f.getImageData(0, 0, p, p));
                    d.lineHeight = d.bottom = p - g + m, f.clearRect(0, 0, p, p), f.textBaseline = "alphabetic", f.fillText("H", 0, p);
                    var v = p - a(f.getImageData(0, 0, p, p)) - 1 + m;
                    d.baseline = d.alphabetic = v, f.clearRect(0, 0, p, p), f.textBaseline = "middle", f.fillText("H", 0, .5 * p);
                    var y = a(f.getImageData(0, 0, p, p));
                    d.median = d.middle = p - y - 1 + m - .5 * p, f.clearRect(0, 0, p, p), f.textBaseline = "hanging", f.fillText("H", 0, .5 * p);
                    var x = a(f.getImageData(0, 0, p, p));
                    d.hanging = p - x - 1 + m - .5 * p, f.clearRect(0, 0, p, p), f.textBaseline = "ideographic", f.fillText("H", 0, p);
                    var b = a(f.getImageData(0, 0, p, p));
                    if (d.ideographic = p - b - 1 + m, h.upper && (f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillText(h.upper, 0, 0), d.upper = a(f.getImageData(0, 0, p, p)), d.capHeight = d.baseline - d.upper), h.lower && (f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillText(h.lower, 0, 0), d.lower = a(f.getImageData(0, 0, p, p)), d.xHeight = d.baseline - d.lower), h.tittle && (f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillText(h.tittle, 0, 0), d.tittle = a(f.getImageData(0, 0, p, p))), h.ascent && (f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillText(h.ascent, 0, 0), d.ascent = a(f.getImageData(0, 0, p, p))), h.descent && (f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillText(h.descent, 0, 0), d.descent = o(f.getImageData(0, 0, p, p))), h.overshoot) {
                        f.clearRect(0, 0, p, p), f.textBaseline = "top", f.fillText(h.overshoot, 0, 0);
                        var _ = o(f.getImageData(0, 0, p, p));
                        d.overshoot = _ - v;
                    }
                    for(var w in d)d[w] /= s;
                    return d.em = s, n.cache[r] = d, i(d, c);
                }
                function i(t1, e1) {
                    var r = {};
                    for(var n in "string" == typeof e1 && (e1 = t1[e1]), t1)"em" !== n && (r[n] = t1[n] - e1);
                    return r;
                }
                function a(t1) {
                    for(var e1 = t1.height, r = t1.data, n = 3; n < r.length; n += 4)if (0 !== r[n]) return Math.floor(.25 * (n - 3) / e1);
                }
                function o(t1) {
                    for(var e1 = t1.height, r = t1.data, n = r.length - 1; n > 0; n -= 4)if (0 !== r[n]) return Math.floor(.25 * (n - 3) / e1);
                }
                e1.exports = n, n.canvas = document.createElement("canvas"), n.cache = {};
            },
            {}
        ],
        194: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    if ("string" != typeof t1) throw new TypeError("must specify type string");
                    if (e1 = e1 || {}, "undefined" == typeof document && !e1.canvas) return null;
                    var r = e1.canvas || document.createElement("canvas");
                    "number" == typeof e1.width && (r.width = e1.width);
                    "number" == typeof e1.height && (r.height = e1.height);
                    var n, i = e1;
                    try {
                        var a = [
                            t1
                        ];
                        0 === t1.indexOf("webgl") && a.push("experimental-" + t1);
                        for(var o = 0; o < a.length; o++)if (n = r.getContext(a[o], i)) return n;
                    } catch (t1) {
                        n = null;
                    }
                    return n || null;
                };
            },
            {}
        ],
        195: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = e1[4], s = e1[5], l = e1[6], c = e1[7], u = e1[8], f = e1[9], h = e1[10], p = e1[11], d = e1[12], m = e1[13], g = e1[14], v = e1[15];
                    return t1[0] = s * (h * v - p * g) - f * (l * v - c * g) + m * (l * p - c * h), t1[1] = -(n * (h * v - p * g) - f * (i * v - a * g) + m * (i * p - a * h)), t1[2] = n * (l * v - c * g) - s * (i * v - a * g) + m * (i * c - a * l), t1[3] = -(n * (l * p - c * h) - s * (i * p - a * h) + f * (i * c - a * l)), t1[4] = -(o * (h * v - p * g) - u * (l * v - c * g) + d * (l * p - c * h)), t1[5] = r * (h * v - p * g) - u * (i * v - a * g) + d * (i * p - a * h), t1[6] = -(r * (l * v - c * g) - o * (i * v - a * g) + d * (i * c - a * l)), t1[7] = r * (l * p - c * h) - o * (i * p - a * h) + u * (i * c - a * l), t1[8] = o * (f * v - p * m) - u * (s * v - c * m) + d * (s * p - c * f), t1[9] = -(r * (f * v - p * m) - u * (n * v - a * m) + d * (n * p - a * f)), t1[10] = r * (s * v - c * m) - o * (n * v - a * m) + d * (n * c - a * s), t1[11] = -(r * (s * p - c * f) - o * (n * p - a * f) + u * (n * c - a * s)), t1[12] = -(o * (f * g - h * m) - u * (s * g - l * m) + d * (s * h - l * f)), t1[13] = r * (f * g - h * m) - u * (n * g - i * m) + d * (n * h - i * f), t1[14] = -(r * (s * g - l * m) - o * (n * g - i * m) + d * (n * l - i * s)), t1[15] = r * (s * h - l * f) - o * (n * h - i * f) + u * (n * l - i * s), t1;
                };
            },
            {}
        ],
        196: [
            function(t1, e1, r) {
                e1.exports = function(t1) {
                    var e1 = new Float32Array(16);
                    return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
                };
            },
            {}
        ],
        197: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
                };
            },
            {}
        ],
        198: [
            function(t1, e1, r) {
                e1.exports = function() {
                    var t1 = new Float32Array(16);
                    return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            {}
        ],
        199: [
            function(t1, e1, r) {
                e1.exports = function(t1) {
                    var e1 = t1[0], r = t1[1], n = t1[2], i = t1[3], a = t1[4], o = t1[5], s = t1[6], l = t1[7], c = t1[8], u = t1[9], f = t1[10], h = t1[11], p = t1[12], d = t1[13], m = t1[14], g = t1[15];
                    return (e1 * o - r * a) * (f * g - h * m) - (e1 * s - n * a) * (u * g - h * d) + (e1 * l - i * a) * (u * m - f * d) + (r * s - n * o) * (c * g - h * p) - (r * l - i * o) * (c * m - f * p) + (n * l - i * s) * (c * d - u * p);
                };
            },
            {}
        ],
        200: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = r + r, s = n + n, l = i + i, c = r * o, u = n * o, f = n * s, h = i * o, p = i * s, d = i * l, m = a * o, g = a * s, v = a * l;
                    return t1[0] = 1 - f - d, t1[1] = u + v, t1[2] = h - g, t1[3] = 0, t1[4] = u - v, t1[5] = 1 - c - d, t1[6] = p + m, t1[7] = 0, t1[8] = h + g, t1[9] = p - m, t1[10] = 1 - c - f, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            {}
        ],
        201: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r) {
                    var n, i, a, o = r[0], s = r[1], l = r[2], c = Math.sqrt(o * o + s * s + l * l);
                    if (Math.abs(c) < 1e-6) return null;
                    return o *= c = 1 / c, s *= c, l *= c, n = Math.sin(e1), i = Math.cos(e1), a = 1 - i, t1[0] = o * o * a + i, t1[1] = s * o * a + l * n, t1[2] = l * o * a - s * n, t1[3] = 0, t1[4] = o * s * a - l * n, t1[5] = s * s * a + i, t1[6] = l * s * a + o * n, t1[7] = 0, t1[8] = o * l * a + s * n, t1[9] = s * l * a - o * n, t1[10] = l * l * a + i, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            {}
        ],
        202: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r) {
                    var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = n + n, l = i + i, c = a + a, u = n * s, f = n * l, h = n * c, p = i * l, d = i * c, m = a * c, g = o * s, v = o * l, y = o * c;
                    return t1[0] = 1 - (p + m), t1[1] = f + y, t1[2] = h - v, t1[3] = 0, t1[4] = f - y, t1[5] = 1 - (u + m), t1[6] = d + g, t1[7] = 0, t1[8] = h + v, t1[9] = d - g, t1[10] = 1 - (u + p), t1[11] = 0, t1[12] = r[0], t1[13] = r[1], t1[14] = r[2], t1[15] = 1, t1;
                };
            },
            {}
        ],
        203: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    return t1[0] = e1[0], t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = e1[1], t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = e1[2], t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            {}
        ],
        204: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = e1[0], t1[13] = e1[1], t1[14] = e1[2], t1[15] = 1, t1;
                };
            },
            {}
        ],
        205: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    var r = Math.sin(e1), n = Math.cos(e1);
                    return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = n, t1[6] = r, t1[7] = 0, t1[8] = 0, t1[9] = -r, t1[10] = n, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            {}
        ],
        206: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    var r = Math.sin(e1), n = Math.cos(e1);
                    return t1[0] = n, t1[1] = 0, t1[2] = -r, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = r, t1[9] = 0, t1[10] = n, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            {}
        ],
        207: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    var r = Math.sin(e1), n = Math.cos(e1);
                    return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = 0, t1[4] = -r, t1[5] = n, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            {}
        ],
        208: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r, n, i, a, o) {
                    var s = 1 / (r - e1), l = 1 / (i - n), c = 1 / (a - o);
                    return t1[0] = 2 * a * s, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 2 * a * l, t1[6] = 0, t1[7] = 0, t1[8] = (r + e1) * s, t1[9] = (i + n) * l, t1[10] = (o + a) * c, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[14] = o * a * 2 * c, t1[15] = 0, t1;
                };
            },
            {}
        ],
        209: [
            function(t1, e1, r) {
                e1.exports = function(t1) {
                    return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                };
            },
            {}
        ],
        210: [
            function(t1, e1, r) {
                e1.exports = {
                    create: t1("./create"),
                    clone: t1("./clone"),
                    copy: t1("./copy"),
                    identity: t1("./identity"),
                    transpose: t1("./transpose"),
                    invert: t1("./invert"),
                    adjoint: t1("./adjoint"),
                    determinant: t1("./determinant"),
                    multiply: t1("./multiply"),
                    translate: t1("./translate"),
                    scale: t1("./scale"),
                    rotate: t1("./rotate"),
                    rotateX: t1("./rotateX"),
                    rotateY: t1("./rotateY"),
                    rotateZ: t1("./rotateZ"),
                    fromRotation: t1("./fromRotation"),
                    fromRotationTranslation: t1("./fromRotationTranslation"),
                    fromScaling: t1("./fromScaling"),
                    fromTranslation: t1("./fromTranslation"),
                    fromXRotation: t1("./fromXRotation"),
                    fromYRotation: t1("./fromYRotation"),
                    fromZRotation: t1("./fromZRotation"),
                    fromQuat: t1("./fromQuat"),
                    frustum: t1("./frustum"),
                    perspective: t1("./perspective"),
                    perspectiveFromFieldOfView: t1("./perspectiveFromFieldOfView"),
                    ortho: t1("./ortho"),
                    lookAt: t1("./lookAt"),
                    str: t1("./str")
                };
            },
            {
                "./adjoint": 195,
                "./clone": 196,
                "./copy": 197,
                "./create": 198,
                "./determinant": 199,
                "./fromQuat": 200,
                "./fromRotation": 201,
                "./fromRotationTranslation": 202,
                "./fromScaling": 203,
                "./fromTranslation": 204,
                "./fromXRotation": 205,
                "./fromYRotation": 206,
                "./fromZRotation": 207,
                "./frustum": 208,
                "./identity": 209,
                "./invert": 211,
                "./lookAt": 212,
                "./multiply": 213,
                "./ortho": 214,
                "./perspective": 215,
                "./perspectiveFromFieldOfView": 216,
                "./rotate": 217,
                "./rotateX": 218,
                "./rotateY": 219,
                "./rotateZ": 220,
                "./scale": 221,
                "./str": 222,
                "./translate": 223,
                "./transpose": 224
            }
        ],
        211: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = e1[4], s = e1[5], l = e1[6], c = e1[7], u = e1[8], f = e1[9], h = e1[10], p = e1[11], d = e1[12], m = e1[13], g = e1[14], v = e1[15], y = r * s - n * o, x = r * l - i * o, b = r * c - a * o, _ = n * l - i * s, w = n * c - a * s, T = i * c - a * l, k = u * m - f * d, A = u * g - h * d, M = u * v - p * d, S = f * g - h * m, E = f * v - p * m, L = h * v - p * g, C = y * L - x * E + b * S + _ * M - w * A + T * k;
                    if (!C) return null;
                    return C = 1 / C, t1[0] = (s * L - l * E + c * S) * C, t1[1] = (i * E - n * L - a * S) * C, t1[2] = (m * T - g * w + v * _) * C, t1[3] = (h * w - f * T - p * _) * C, t1[4] = (l * M - o * L - c * A) * C, t1[5] = (r * L - i * M + a * A) * C, t1[6] = (g * b - d * T - v * x) * C, t1[7] = (u * T - h * b + p * x) * C, t1[8] = (o * E - s * M + c * k) * C, t1[9] = (n * M - r * E - a * k) * C, t1[10] = (d * w - m * b + v * y) * C, t1[11] = (f * b - u * w - p * y) * C, t1[12] = (s * A - o * S - l * k) * C, t1[13] = (r * S - n * A + i * k) * C, t1[14] = (m * x - d * _ - g * y) * C, t1[15] = (u * _ - f * x + h * y) * C, t1;
                };
            },
            {}
        ],
        212: [
            function(t1, e1, r) {
                var n = t1("./identity");
                e1.exports = function(t1, e1, r, i) {
                    var a, o, s, l, c, u, f, h, p, d, m = e1[0], g = e1[1], v = e1[2], y = i[0], x = i[1], b = i[2], _ = r[0], w = r[1], T = r[2];
                    if (Math.abs(m - _) < 1e-6 && Math.abs(g - w) < 1e-6 && Math.abs(v - T) < 1e-6) return n(t1);
                    f = m - _, h = g - w, p = v - T, d = 1 / Math.sqrt(f * f + h * h + p * p), a = x * (p *= d) - b * (h *= d), o = b * (f *= d) - y * p, s = y * h - x * f, (d = Math.sqrt(a * a + o * o + s * s)) ? (a *= d = 1 / d, o *= d, s *= d) : (a = 0, o = 0, s = 0);
                    l = h * s - p * o, c = p * a - f * s, u = f * o - h * a, (d = Math.sqrt(l * l + c * c + u * u)) ? (l *= d = 1 / d, c *= d, u *= d) : (l = 0, c = 0, u = 0);
                    return t1[0] = a, t1[1] = l, t1[2] = f, t1[3] = 0, t1[4] = o, t1[5] = c, t1[6] = h, t1[7] = 0, t1[8] = s, t1[9] = u, t1[10] = p, t1[11] = 0, t1[12] = -(a * m + o * g + s * v), t1[13] = -(l * m + c * g + u * v), t1[14] = -(f * m + h * g + p * v), t1[15] = 1, t1;
                };
            },
            {
                "./identity": 209
            }
        ],
        213: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r) {
                    var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], f = e1[8], h = e1[9], p = e1[10], d = e1[11], m = e1[12], g = e1[13], v = e1[14], y = e1[15], x = r[0], b = r[1], _ = r[2], w = r[3];
                    return t1[0] = x * n + b * s + _ * f + w * m, t1[1] = x * i + b * l + _ * h + w * g, t1[2] = x * a + b * c + _ * p + w * v, t1[3] = x * o + b * u + _ * d + w * y, x = r[4], b = r[5], _ = r[6], w = r[7], t1[4] = x * n + b * s + _ * f + w * m, t1[5] = x * i + b * l + _ * h + w * g, t1[6] = x * a + b * c + _ * p + w * v, t1[7] = x * o + b * u + _ * d + w * y, x = r[8], b = r[9], _ = r[10], w = r[11], t1[8] = x * n + b * s + _ * f + w * m, t1[9] = x * i + b * l + _ * h + w * g, t1[10] = x * a + b * c + _ * p + w * v, t1[11] = x * o + b * u + _ * d + w * y, x = r[12], b = r[13], _ = r[14], w = r[15], t1[12] = x * n + b * s + _ * f + w * m, t1[13] = x * i + b * l + _ * h + w * g, t1[14] = x * a + b * c + _ * p + w * v, t1[15] = x * o + b * u + _ * d + w * y, t1;
                };
            },
            {}
        ],
        214: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r, n, i, a, o) {
                    var s = 1 / (e1 - r), l = 1 / (n - i), c = 1 / (a - o);
                    return t1[0] = -2 * s, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * c, t1[11] = 0, t1[12] = (e1 + r) * s, t1[13] = (i + n) * l, t1[14] = (o + a) * c, t1[15] = 1, t1;
                };
            },
            {}
        ],
        215: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r, n, i) {
                    var a = 1 / Math.tan(e1 / 2), o = 1 / (n - i);
                    return t1[0] = a / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = a, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = (i + n) * o, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[14] = 2 * i * n * o, t1[15] = 0, t1;
                };
            },
            {}
        ],
        216: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r, n) {
                    var i = Math.tan(e1.upDegrees * Math.PI / 180), a = Math.tan(e1.downDegrees * Math.PI / 180), o = Math.tan(e1.leftDegrees * Math.PI / 180), s = Math.tan(e1.rightDegrees * Math.PI / 180), l = 2 / (o + s), c = 2 / (i + a);
                    return t1[0] = l, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = c, t1[6] = 0, t1[7] = 0, t1[8] = -(o - s) * l * .5, t1[9] = (i - a) * c * .5, t1[10] = n / (r - n), t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[14] = n * r / (r - n), t1[15] = 0, t1;
                };
            },
            {}
        ],
        217: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r, n) {
                    var i, a, o, s, l, c, u, f, h, p, d, m, g, v, y, x, b, _, w, T, k, A, M, S, E = n[0], L = n[1], C = n[2], P = Math.sqrt(E * E + L * L + C * C);
                    if (Math.abs(P) < 1e-6) return null;
                    E *= P = 1 / P, L *= P, C *= P, i = Math.sin(r), a = Math.cos(r), o = 1 - a, s = e1[0], l = e1[1], c = e1[2], u = e1[3], f = e1[4], h = e1[5], p = e1[6], d = e1[7], m = e1[8], g = e1[9], v = e1[10], y = e1[11], x = E * E * o + a, b = L * E * o + C * i, _ = C * E * o - L * i, w = E * L * o - C * i, T = L * L * o + a, k = C * L * o + E * i, A = E * C * o + L * i, M = L * C * o - E * i, S = C * C * o + a, t1[0] = s * x + f * b + m * _, t1[1] = l * x + h * b + g * _, t1[2] = c * x + p * b + v * _, t1[3] = u * x + d * b + y * _, t1[4] = s * w + f * T + m * k, t1[5] = l * w + h * T + g * k, t1[6] = c * w + p * T + v * k, t1[7] = u * w + d * T + y * k, t1[8] = s * A + f * M + m * S, t1[9] = l * A + h * M + g * S, t1[10] = c * A + p * M + v * S, t1[11] = u * A + d * M + y * S, e1 !== t1 && (t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]);
                    return t1;
                };
            },
            {}
        ],
        218: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r) {
                    var n = Math.sin(r), i = Math.cos(r), a = e1[4], o = e1[5], s = e1[6], l = e1[7], c = e1[8], u = e1[9], f = e1[10], h = e1[11];
                    e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]);
                    return t1[4] = a * i + c * n, t1[5] = o * i + u * n, t1[6] = s * i + f * n, t1[7] = l * i + h * n, t1[8] = c * i - a * n, t1[9] = u * i - o * n, t1[10] = f * i - s * n, t1[11] = h * i - l * n, t1;
                };
            },
            {}
        ],
        219: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r) {
                    var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], l = e1[3], c = e1[8], u = e1[9], f = e1[10], h = e1[11];
                    e1 !== t1 && (t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]);
                    return t1[0] = a * i - c * n, t1[1] = o * i - u * n, t1[2] = s * i - f * n, t1[3] = l * i - h * n, t1[8] = a * n + c * i, t1[9] = o * n + u * i, t1[10] = s * n + f * i, t1[11] = l * n + h * i, t1;
                };
            },
            {}
        ],
        220: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r) {
                    var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], l = e1[3], c = e1[4], u = e1[5], f = e1[6], h = e1[7];
                    e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]);
                    return t1[0] = a * i + c * n, t1[1] = o * i + u * n, t1[2] = s * i + f * n, t1[3] = l * i + h * n, t1[4] = c * i - a * n, t1[5] = u * i - o * n, t1[6] = f * i - s * n, t1[7] = h * i - l * n, t1;
                };
            },
            {}
        ],
        221: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r) {
                    var n = r[0], i = r[1], a = r[2];
                    return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * a, t1[9] = e1[9] * a, t1[10] = e1[10] * a, t1[11] = e1[11] * a, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
                };
            },
            {}
        ],
        222: [
            function(t1, e1, r) {
                e1.exports = function(t1) {
                    return "mat4(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ", " + t1[4] + ", " + t1[5] + ", " + t1[6] + ", " + t1[7] + ", " + t1[8] + ", " + t1[9] + ", " + t1[10] + ", " + t1[11] + ", " + t1[12] + ", " + t1[13] + ", " + t1[14] + ", " + t1[15] + ")";
                };
            },
            {}
        ],
        223: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r) {
                    var n, i, a, o, s, l, c, u, f, h, p, d, m = r[0], g = r[1], v = r[2];
                    e1 === t1 ? (t1[12] = e1[0] * m + e1[4] * g + e1[8] * v + e1[12], t1[13] = e1[1] * m + e1[5] * g + e1[9] * v + e1[13], t1[14] = e1[2] * m + e1[6] * g + e1[10] * v + e1[14], t1[15] = e1[3] * m + e1[7] * g + e1[11] * v + e1[15]) : (n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], f = e1[8], h = e1[9], p = e1[10], d = e1[11], t1[0] = n, t1[1] = i, t1[2] = a, t1[3] = o, t1[4] = s, t1[5] = l, t1[6] = c, t1[7] = u, t1[8] = f, t1[9] = h, t1[10] = p, t1[11] = d, t1[12] = n * m + s * g + f * v + e1[12], t1[13] = i * m + l * g + h * v + e1[13], t1[14] = a * m + c * g + p * v + e1[14], t1[15] = o * m + u * g + d * v + e1[15]);
                    return t1;
                };
            },
            {}
        ],
        224: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    if (t1 === e1) {
                        var r = e1[1], n = e1[2], i = e1[3], a = e1[6], o = e1[7], s = e1[11];
                        t1[1] = e1[4], t1[2] = e1[8], t1[3] = e1[12], t1[4] = r, t1[6] = e1[9], t1[7] = e1[13], t1[8] = n, t1[9] = a, t1[11] = e1[14], t1[12] = i, t1[13] = o, t1[14] = s;
                    } else t1[0] = e1[0], t1[1] = e1[4], t1[2] = e1[8], t1[3] = e1[12], t1[4] = e1[1], t1[5] = e1[5], t1[6] = e1[9], t1[7] = e1[13], t1[8] = e1[2], t1[9] = e1[6], t1[10] = e1[10], t1[11] = e1[14], t1[12] = e1[3], t1[13] = e1[7], t1[14] = e1[11], t1[15] = e1[15];
                    return t1;
                };
            },
            {}
        ],
        225: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("css-font"), i = t1("pick-by-alias"), a = t1("regl"), o = t1("gl-util/context"), s = t1("es6-weak-map"), l = t1("color-normalize"), c = t1("font-atlas"), u = t1("typedarray-pool"), f = t1("parse-rect"), h = t1("is-plain-obj"), p = t1("parse-unit"), d = t1("to-px"), m = t1("detect-kerning"), g = t1("object-assign"), v = t1("font-measure"), y = t1("flatten-vertex-data"), x = t1("bit-twiddle").nextPow2, b = new s, _ = !1;
                if (document.body) {
                    var w = document.body.appendChild(document.createElement("div"));
                    w.style.font = "italic small-caps bold condensed 16px/2 cursive", getComputedStyle(w).fontStretch && (_ = !0), document.body.removeChild(w);
                }
                var T = function(t1) {
                    !function(t1) {
                        return "function" == typeof t1 && t1._gl && t1.prop && t1.texture && t1.buffer;
                    }(t1) ? this.gl = o(t1) : (t1 = {
                        regl: t1
                    }, this.gl = t1.regl._gl), this.shader = b.get(this.gl), this.shader ? this.regl = this.shader.regl : this.regl = t1.regl || a({
                        gl: this.gl
                    }), this.charBuffer = this.regl.buffer({
                        type: "uint8",
                        usage: "stream"
                    }), this.sizeBuffer = this.regl.buffer({
                        type: "float",
                        usage: "stream"
                    }), this.shader || (this.shader = this.createShader(), b.set(this.gl, this.shader)), this.batch = [], this.fontSize = [], this.font = [], this.fontAtlas = [], this.draw = this.shader.draw.bind(this), this.render = function() {
                        this.regl._refresh(), this.draw(this.batch);
                    }, this.canvas = this.gl.canvas, this.update(h(t1) ? t1 : {});
                };
                T.prototype.createShader = function() {
                    var t1 = this.regl, e1 = t1({
                        blend: {
                            enable: !0,
                            color: [
                                0,
                                0,
                                0,
                                1
                            ],
                            func: {
                                srcRGB: "src alpha",
                                dstRGB: "one minus src alpha",
                                srcAlpha: "one minus dst alpha",
                                dstAlpha: "one"
                            }
                        },
                        stencil: {
                            enable: !1
                        },
                        depth: {
                            enable: !1
                        },
                        count: t1.prop("count"),
                        offset: t1.prop("offset"),
                        attributes: {
                            charOffset: {
                                offset: 4,
                                stride: 8,
                                buffer: t1.this("sizeBuffer")
                            },
                            width: {
                                offset: 0,
                                stride: 8,
                                buffer: t1.this("sizeBuffer")
                            },
                            char: t1.this("charBuffer"),
                            position: t1.this("position")
                        },
                        uniforms: {
                            atlasSize: function(t1, e1) {
                                return [
                                    e1.atlas.width,
                                    e1.atlas.height
                                ];
                            },
                            atlasDim: function(t1, e1) {
                                return [
                                    e1.atlas.cols,
                                    e1.atlas.rows
                                ];
                            },
                            atlas: function(t1, e1) {
                                return e1.atlas.texture;
                            },
                            charStep: function(t1, e1) {
                                return e1.atlas.step;
                            },
                            em: function(t1, e1) {
                                return e1.atlas.em;
                            },
                            color: t1.prop("color"),
                            opacity: t1.prop("opacity"),
                            viewport: t1.this("viewportArray"),
                            scale: t1.this("scale"),
                            align: t1.prop("align"),
                            baseline: t1.prop("baseline"),
                            translate: t1.this("translate"),
                            positionOffset: t1.prop("positionOffset")
                        },
                        primitive: "points",
                        viewport: t1.this("viewport"),
                        vert: "\n\t\t\tprecision highp float;\n\t\t\tattribute float width, charOffset, char;\n\t\t\tattribute vec2 position;\n\t\t\tuniform float fontSize, charStep, em, align, baseline;\n\t\t\tuniform vec4 viewport;\n\t\t\tuniform vec4 color;\n\t\t\tuniform vec2 atlasSize, atlasDim, scale, translate, positionOffset;\n\t\t\tvarying vec2 charCoord, charId;\n\t\t\tvarying float charWidth;\n\t\t\tvarying vec4 fontColor;\n\t\t\tvoid main () {\n\t\t\t\tvec2 offset = floor(em * (vec2(align + charOffset, baseline)\n\t\t\t\t\t+ vec2(positionOffset.x, -positionOffset.y)))\n\t\t\t\t\t/ (viewport.zw * scale.xy);\n\n\t\t\t\tvec2 position = (position + translate) * scale;\n\t\t\t\tposition += offset * scale;\n\n\t\t\t\tcharCoord = position * viewport.zw + viewport.xy;\n\n\t\t\t\tgl_Position = vec4(position * 2. - 1., 0, 1);\n\n\t\t\t\tgl_PointSize = charStep;\n\n\t\t\t\tcharId.x = mod(char, atlasDim.x);\n\t\t\t\tcharId.y = floor(char / atlasDim.x);\n\n\t\t\t\tcharWidth = width * em;\n\n\t\t\t\tfontColor = color / 255.;\n\t\t\t}",
                        frag: "\n\t\t\tprecision highp float;\n\t\t\tuniform float fontSize, charStep, opacity;\n\t\t\tuniform vec2 atlasSize;\n\t\t\tuniform vec4 viewport;\n\t\t\tuniform sampler2D atlas;\n\t\t\tvarying vec4 fontColor;\n\t\t\tvarying vec2 charCoord, charId;\n\t\t\tvarying float charWidth;\n\n\t\t\tfloat lightness(vec4 color) {\n\t\t\t\treturn color.r * 0.299 + color.g * 0.587 + color.b * 0.114;\n\t\t\t}\n\n\t\t\tvoid main () {\n\t\t\t\tvec2 uv = gl_FragCoord.xy - charCoord + charStep * .5;\n\t\t\t\tfloat halfCharStep = floor(charStep * .5 + .5);\n\n\t\t\t\t// invert y and shift by 1px (FF expecially needs that)\n\t\t\t\tuv.y = charStep - uv.y;\n\n\t\t\t\t// ignore points outside of character bounding box\n\t\t\t\tfloat halfCharWidth = ceil(charWidth * .5);\n\t\t\t\tif (floor(uv.x) > halfCharStep + halfCharWidth ||\n\t\t\t\t\tfloor(uv.x) < halfCharStep - halfCharWidth) return;\n\n\t\t\t\tuv += charId * charStep;\n\t\t\t\tuv = uv / atlasSize;\n\n\t\t\t\tvec4 color = fontColor;\n\t\t\t\tvec4 mask = texture2D(atlas, uv);\n\n\t\t\t\tfloat maskY = lightness(mask);\n\t\t\t\t// float colorY = lightness(color);\n\t\t\t\tcolor.a *= maskY;\n\t\t\t\tcolor.a *= opacity;\n\n\t\t\t\t// color.a += .1;\n\n\t\t\t\t// antialiasing, see yiq color space y-channel formula\n\t\t\t\t// color.rgb += (1. - color.rgb) * (1. - mask.rgb);\n\n\t\t\t\tgl_FragColor = color;\n\t\t\t}"
                    });
                    return {
                        regl: t1,
                        draw: e1,
                        atlas: {}
                    };
                }, T.prototype.update = function(t1) {
                    var e1 = this;
                    if ("string" == typeof t1) t1 = {
                        text: t1
                    };
                    else if (!t1) return;
                    null != (t1 = i(t1, {
                        position: "position positions coord coords coordinates",
                        font: "font fontFace fontface typeface cssFont css-font family fontFamily",
                        fontSize: "fontSize fontsize size font-size",
                        text: "text texts chars characters value values symbols",
                        align: "align alignment textAlign textbaseline",
                        baseline: "baseline textBaseline textbaseline",
                        direction: "dir direction textDirection",
                        color: "color colour fill fill-color fillColor textColor textcolor",
                        kerning: "kerning kern",
                        range: "range dataBox",
                        viewport: "vp viewport viewBox viewbox viewPort",
                        opacity: "opacity alpha transparency visible visibility opaque",
                        offset: "offset positionOffset padding shift indent indentation"
                    }, !0)).opacity && (Array.isArray(t1.opacity) ? this.opacity = t1.opacity.map(function(t1) {
                        return parseFloat(t1);
                    }) : this.opacity = parseFloat(t1.opacity)), null != t1.viewport && (this.viewport = f(t1.viewport), this.viewportArray = [
                        this.viewport.x,
                        this.viewport.y,
                        this.viewport.width,
                        this.viewport.height
                    ]), null == this.viewport && (this.viewport = {
                        x: 0,
                        y: 0,
                        width: this.gl.drawingBufferWidth,
                        height: this.gl.drawingBufferHeight
                    }, this.viewportArray = [
                        this.viewport.x,
                        this.viewport.y,
                        this.viewport.width,
                        this.viewport.height
                    ]), null != t1.kerning && (this.kerning = t1.kerning), null != t1.offset && ("number" == typeof t1.offset && (t1.offset = [
                        t1.offset,
                        0
                    ]), this.positionOffset = y(t1.offset)), t1.direction && (this.direction = t1.direction), t1.range && (this.range = t1.range, this.scale = [
                        1 / (t1.range[2] - t1.range[0]),
                        1 / (t1.range[3] - t1.range[1])
                    ], this.translate = [
                        -t1.range[0],
                        -t1.range[1]
                    ]), t1.scale && (this.scale = t1.scale), t1.translate && (this.translate = t1.translate), this.scale || (this.scale = [
                        1 / this.viewport.width,
                        1 / this.viewport.height
                    ]), this.translate || (this.translate = [
                        0,
                        0
                    ]), this.font.length || t1.font || (t1.font = T.baseFontSize + "px sans-serif");
                    var r, a = !1, o = !1;
                    if (t1.font && (Array.isArray(t1.font) ? t1.font : [
                        t1.font
                    ]).forEach(function(t1, r) {
                        if ("string" == typeof t1) try {
                            t1 = n.parse(t1);
                        } catch (e1) {
                            t1 = n.parse(T.baseFontSize + "px " + t1);
                        }
                        else t1 = n.parse(n.stringify(t1));
                        var i = n.stringify({
                            size: T.baseFontSize,
                            family: t1.family,
                            stretch: _ ? t1.stretch : void 0,
                            variant: t1.variant,
                            weight: t1.weight,
                            style: t1.style
                        }), s = p(t1.size), l = Math.round(s[0] * d(s[1]));
                        if (l !== e1.fontSize[r] && (o = !0, e1.fontSize[r] = l), !(e1.font[r] && i == e1.font[r].baseString || (a = !0, e1.font[r] = T.fonts[i], e1.font[r]))) {
                            var c = t1.family.join(", "), u = [
                                t1.style
                            ];
                            t1.style != t1.variant && u.push(t1.variant), t1.variant != t1.weight && u.push(t1.weight), _ && t1.weight != t1.stretch && u.push(t1.stretch), e1.font[r] = {
                                baseString: i,
                                family: c,
                                weight: t1.weight,
                                stretch: t1.stretch,
                                style: t1.style,
                                variant: t1.variant,
                                width: {},
                                kerning: {},
                                metrics: v(c, {
                                    origin: "top",
                                    fontSize: T.baseFontSize,
                                    fontStyle: u.join(" ")
                                })
                            }, T.fonts[i] = e1.font[r];
                        }
                    }), (a || o) && this.font.forEach(function(r, i) {
                        var a = n.stringify({
                            size: e1.fontSize[i],
                            family: r.family,
                            stretch: _ ? r.stretch : void 0,
                            variant: r.variant,
                            weight: r.weight,
                            style: r.style
                        });
                        if (e1.fontAtlas[i] = e1.shader.atlas[a], !e1.fontAtlas[i]) {
                            var o = r.metrics;
                            e1.shader.atlas[a] = e1.fontAtlas[i] = {
                                fontString: a,
                                step: 2 * Math.ceil(e1.fontSize[i] * o.bottom * .5),
                                em: e1.fontSize[i],
                                cols: 0,
                                rows: 0,
                                height: 0,
                                width: 0,
                                chars: [],
                                ids: {},
                                texture: e1.regl.texture()
                            };
                        }
                        null == t1.text && (t1.text = e1.text);
                    }), "string" == typeof t1.text && t1.position && t1.position.length > 2) {
                        for(var s = Array(.5 * t1.position.length), h = 0; h < s.length; h++)s[h] = t1.text;
                        t1.text = s;
                    }
                    if (null != t1.text || a) {
                        if (this.textOffsets = [
                            0
                        ], Array.isArray(t1.text)) {
                            this.count = t1.text[0].length, this.counts = [
                                this.count
                            ];
                            for(var b = 1; b < t1.text.length; b++)this.textOffsets[b] = this.textOffsets[b - 1] + t1.text[b - 1].length, this.count += t1.text[b].length, this.counts.push(t1.text[b].length);
                            this.text = t1.text.join("");
                        } else this.text = t1.text, this.count = this.text.length, this.counts = [
                            this.count
                        ];
                        r = [], this.font.forEach(function(t1, n) {
                            T.atlasContext.font = t1.baseString;
                            for(var i = e1.fontAtlas[n], a = 0; a < e1.text.length; a++){
                                var o = e1.text.charAt(a);
                                if (null == i.ids[o] && (i.ids[o] = i.chars.length, i.chars.push(o), r.push(o)), null == t1.width[o] && (t1.width[o] = T.atlasContext.measureText(o).width / T.baseFontSize, e1.kerning)) {
                                    var s = [];
                                    for(var l in t1.width)s.push(l + o, o + l);
                                    g(t1.kerning, m(t1.family, {
                                        pairs: s
                                    }));
                                }
                            }
                        });
                    }
                    if (t1.position) {
                        if (t1.position.length > 2) {
                            for(var w = !t1.position[0].length, k = u.mallocFloat(2 * this.count), A = 0, M = 0; A < this.counts.length; A++){
                                var S = this.counts[A];
                                if (w) for(var E = 0; E < S; E++)k[M++] = t1.position[2 * A], k[M++] = t1.position[2 * A + 1];
                                else for(var L = 0; L < S; L++)k[M++] = t1.position[A][0], k[M++] = t1.position[A][1];
                            }
                            this.position.call ? this.position({
                                type: "float",
                                data: k
                            }) : this.position = this.regl.buffer({
                                type: "float",
                                data: k
                            }), u.freeFloat(k);
                        } else this.position.destroy && this.position.destroy(), this.position = {
                            constant: t1.position
                        };
                    }
                    if (t1.text || a) {
                        var C = u.mallocUint8(this.count), P = u.mallocFloat(2 * this.count);
                        this.textWidth = [];
                        for(var I = 0, O = 0; I < this.counts.length; I++){
                            for(var z = this.counts[I], D = this.font[I] || this.font[0], R = this.fontAtlas[I] || this.fontAtlas[0], F = 0; F < z; F++){
                                var B = this.text.charAt(O), N = this.text.charAt(O - 1);
                                if (C[O] = R.ids[B], P[2 * O] = D.width[B], F) {
                                    var j = P[2 * O - 2], U = P[2 * O], V = P[2 * O - 1] + .5 * j + .5 * U;
                                    if (this.kerning) {
                                        var H = D.kerning[N + B];
                                        H && (V += .001 * H);
                                    }
                                    P[2 * O + 1] = V;
                                } else P[2 * O + 1] = .5 * P[2 * O];
                                O++;
                            }
                            this.textWidth.push(P.length ? .5 * P[2 * O - 2] + P[2 * O - 1] : 0);
                        }
                        t1.align || (t1.align = this.align), this.charBuffer({
                            data: C,
                            type: "uint8",
                            usage: "stream"
                        }), this.sizeBuffer({
                            data: P,
                            type: "float",
                            usage: "stream"
                        }), u.freeUint8(C), u.freeFloat(P), r.length && this.font.forEach(function(t1, r) {
                            var n = e1.fontAtlas[r], i = n.step, a = Math.floor(T.maxAtlasSize / i), o = Math.min(a, n.chars.length), s = Math.ceil(n.chars.length / o), l = x(o * i), u = x(s * i);
                            n.width = l, n.height = u, n.rows = s, n.cols = o, n.em && n.texture({
                                data: c({
                                    canvas: T.atlasCanvas,
                                    font: n.fontString,
                                    chars: n.chars,
                                    shape: [
                                        l,
                                        u
                                    ],
                                    step: [
                                        i,
                                        i
                                    ]
                                })
                            });
                        });
                    }
                    if (t1.align && (this.align = t1.align, this.alignOffset = this.textWidth.map(function(t1, r) {
                        var n = Array.isArray(e1.align) ? e1.align.length > 1 ? e1.align[r] : e1.align[0] : e1.align;
                        if ("number" == typeof n) return n;
                        switch(n){
                            case "right":
                            case "end":
                                return -t1;
                            case "center":
                            case "centre":
                            case "middle":
                                return .5 * -t1;
                        }
                        return 0;
                    })), null == this.baseline && null == t1.baseline && (t1.baseline = 0), null != t1.baseline && (this.baseline = t1.baseline, Array.isArray(this.baseline) || (this.baseline = [
                        this.baseline
                    ]), this.baselineOffset = this.baseline.map(function(t1, r) {
                        var n = (e1.font[r] || e1.font[0]).metrics, i = 0;
                        return i += .5 * n.bottom, i += "number" == typeof t1 ? t1 - n.baseline : -n[t1], i *= -1;
                    })), null != t1.color) {
                        if (t1.color || (t1.color = "transparent"), "string" != typeof t1.color && isNaN(t1.color)) {
                            var q;
                            if ("number" == typeof t1.color[0] && t1.color.length > this.counts.length) {
                                var G = t1.color.length;
                                q = u.mallocUint8(G);
                                for(var Y = (t1.color.subarray || t1.color.slice).bind(t1.color), W = 0; W < G; W += 4)q.set(l(Y(W, W + 4), "uint8"), W);
                            } else {
                                var X = t1.color.length;
                                q = u.mallocUint8(4 * X);
                                for(var Z = 0; Z < X; Z++)q.set(l(t1.color[Z] || 0, "uint8"), 4 * Z);
                            }
                            this.color = q;
                        } else this.color = l(t1.color, "uint8");
                    }
                    if (t1.position || t1.text || t1.color || t1.baseline || t1.align || t1.font || t1.offset || t1.opacity) {
                        if (this.color.length > 4 || this.baselineOffset.length > 1 || this.align && this.align.length > 1 || this.fontAtlas.length > 1 || this.positionOffset.length > 2) {
                            var J = Math.max(.5 * this.position.length || 0, .25 * this.color.length || 0, this.baselineOffset.length || 0, this.alignOffset.length || 0, this.font.length || 0, this.opacity.length || 0, .5 * this.positionOffset.length || 0);
                            this.batch = Array(J);
                            for(var K = 0; K < this.batch.length; K++)this.batch[K] = {
                                count: this.counts.length > 1 ? this.counts[K] : this.counts[0],
                                offset: this.textOffsets.length > 1 ? this.textOffsets[K] : this.textOffsets[0],
                                color: this.color ? this.color.length <= 4 ? this.color : this.color.subarray(4 * K, 4 * K + 4) : [
                                    0,
                                    0,
                                    0,
                                    255
                                ],
                                opacity: Array.isArray(this.opacity) ? this.opacity[K] : this.opacity,
                                baseline: null != this.baselineOffset[K] ? this.baselineOffset[K] : this.baselineOffset[0],
                                align: this.align ? null != this.alignOffset[K] ? this.alignOffset[K] : this.alignOffset[0] : 0,
                                atlas: this.fontAtlas[K] || this.fontAtlas[0],
                                positionOffset: this.positionOffset.length > 2 ? this.positionOffset.subarray(2 * K, 2 * K + 2) : this.positionOffset
                            };
                        } else this.count ? this.batch = [
                            {
                                count: this.count,
                                offset: 0,
                                color: this.color || [
                                    0,
                                    0,
                                    0,
                                    255
                                ],
                                opacity: Array.isArray(this.opacity) ? this.opacity[0] : this.opacity,
                                baseline: this.baselineOffset[0],
                                align: this.alignOffset ? this.alignOffset[0] : 0,
                                atlas: this.fontAtlas[0],
                                positionOffset: this.positionOffset
                            }
                        ] : this.batch = [];
                    }
                }, T.prototype.destroy = function() {}, T.prototype.kerning = !0, T.prototype.position = {
                    constant: new Float32Array(2)
                }, T.prototype.translate = null, T.prototype.scale = null, T.prototype.font = null, T.prototype.text = "", T.prototype.positionOffset = [
                    0,
                    0
                ], T.prototype.opacity = 1, T.prototype.color = new Uint8Array([
                    0,
                    0,
                    0,
                    255
                ]), T.prototype.alignOffset = [
                    0,
                    0
                ], T.maxAtlasSize = 1024, T.atlasCanvas = document.createElement("canvas"), T.atlasContext = T.atlasCanvas.getContext("2d", {
                    alpha: !1
                }), T.baseFontSize = 64, T.fonts = {}, e1.exports = T;
            },
            {
                "bit-twiddle": 81,
                "color-normalize": 89,
                "css-font": 99,
                "detect-kerning": 125,
                "es6-weak-map": 183,
                "flatten-vertex-data": 191,
                "font-atlas": 192,
                "font-measure": 193,
                "gl-util/context": 226,
                "is-plain-obj": 236,
                "object-assign": 247,
                "parse-rect": 249,
                "parse-unit": 251,
                "pick-by-alias": 253,
                regl: 283,
                "to-px": 314,
                "typedarray-pool": 327
            }
        ],
        226: [
            function(t1, e1, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = t1("pick-by-alias");
                        function i(t1) {
                            if (t1.container) {
                                if (t1.container == document.body) document.body.style.width || (t1.canvas.width = t1.width || t1.pixelRatio * r.innerWidth), document.body.style.height || (t1.canvas.height = t1.height || t1.pixelRatio * r.innerHeight);
                                else {
                                    var e1 = t1.container.getBoundingClientRect();
                                    t1.canvas.width = t1.width || e1.right - e1.left, t1.canvas.height = t1.height || e1.bottom - e1.top;
                                }
                            }
                        }
                        function a(t1) {
                            return "function" == typeof t1.getContext && "width" in t1 && "height" in t1;
                        }
                        function o() {
                            var t1 = document.createElement("canvas");
                            return t1.style.position = "absolute", t1.style.top = 0, t1.style.left = 0, t1;
                        }
                        e1.exports = function(t1) {
                            var e1;
                            if (t1 ? "string" == typeof t1 && (t1 = {
                                container: t1
                            }) : t1 = {}, a(t1) ? t1 = {
                                container: t1
                            } : t1 = "string" == typeof (e1 = t1).nodeName && "function" == typeof e1.appendChild && "function" == typeof e1.getBoundingClientRect ? {
                                container: t1
                            } : function(t1) {
                                return "function" == typeof t1.drawArrays || "function" == typeof t1.drawElements;
                            }(t1) ? {
                                gl: t1
                            } : n(t1, {
                                container: "container target element el canvas holder parent parentNode wrapper use ref root node",
                                gl: "gl context webgl glContext",
                                attrs: "attributes attrs contextAttributes",
                                pixelRatio: "pixelRatio pxRatio px ratio pxratio pixelratio",
                                width: "w width",
                                height: "h height"
                            }, !0), t1.pixelRatio || (t1.pixelRatio = r.pixelRatio || 1), t1.gl) return t1.gl;
                            if (t1.canvas && (t1.container = t1.canvas.parentNode), t1.container) {
                                if ("string" == typeof t1.container) {
                                    var s = document.querySelector(t1.container);
                                    if (!s) throw Error("Element " + t1.container + " is not found");
                                    t1.container = s;
                                }
                                a(t1.container) ? (t1.canvas = t1.container, t1.container = t1.canvas.parentNode) : t1.canvas || (t1.canvas = o(), t1.container.appendChild(t1.canvas), i(t1));
                            } else if (!t1.canvas) {
                                if ("undefined" == typeof document) throw Error("Not DOM environment. Use headless-gl.");
                                t1.container = document.body || document.documentElement, t1.canvas = o(), t1.container.appendChild(t1.canvas), i(t1);
                            }
                            return t1.gl || [
                                "webgl",
                                "experimental-webgl",
                                "webgl-experimental"
                            ].some(function(e1) {
                                try {
                                    t1.gl = t1.canvas.getContext(e1, t1.attrs);
                                } catch (t1) {}
                                return t1.gl;
                            }), t1.gl;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "pick-by-alias": 253
            }
        ],
        227: [
            function(t1, e1, r) {
                e1.exports = function(t1) {
                    "string" == typeof t1 && (t1 = [
                        t1
                    ]);
                    for(var e1 = [].slice.call(arguments, 1), r = [], n = 0; n < t1.length - 1; n++)r.push(t1[n], e1[n] || "");
                    return r.push(t1[n]), r.join("");
                };
            },
            {}
        ],
        228: [
            function(t1, e1, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i = t1("is-browser");
                        n = "function" == typeof r.matchMedia ? !r.matchMedia("(hover: none)").matches : i, e1.exports = n;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "is-browser": 232
            }
        ],
        229: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("is-browser");
                e1.exports = n && function() {
                    var t1 = !1;
                    try {
                        var e1 = Object.defineProperty({}, "passive", {
                            get: function() {
                                t1 = !0;
                            }
                        });
                        window.addEventListener("test", null, e1), window.removeEventListener("test", null, e1);
                    } catch (e1) {
                        t1 = !1;
                    }
                    return t1;
                }();
            },
            {
                "is-browser": 232
            }
        ],
        230: [
            function(t1, e1, r) {
                r.read = function(t1, e1, r, n, i) {
                    var a, o, s = 8 * i - n - 1, l = (1 << s) - 1, c = l >> 1, u = -7, f = r ? i - 1 : 0, h = r ? -1 : 1, p = t1[e1 + f];
                    for(f += h, a = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; a = 256 * a + t1[e1 + f], f += h, u -= 8);
                    for(o = a & (1 << -u) - 1, a >>= -u, u += n; u > 0; o = 256 * o + t1[e1 + f], f += h, u -= 8);
                    if (0 === a) a = 1 - c;
                    else {
                        if (a === l) return o ? NaN : 1 / 0 * (p ? -1 : 1);
                        o += Math.pow(2, n), a -= c;
                    }
                    return (p ? -1 : 1) * o * Math.pow(2, a - n);
                }, r.write = function(t1, e1, r, n, i, a) {
                    var o, s, l, c = 8 * a - i - 1, u = (1 << c) - 1, f = u >> 1, h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = n ? 0 : a - 1, d = n ? 1 : -1, m = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
                    for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (s = isNaN(e1) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e1) / Math.LN2), e1 * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (e1 += o + f >= 1 ? h / l : h * Math.pow(2, 1 - f)) * l >= 2 && (o++, l /= 2), o + f >= u ? (s = 0, o = u) : o + f >= 1 ? (s = (e1 * l - 1) * Math.pow(2, i), o += f) : (s = e1 * Math.pow(2, f - 1) * Math.pow(2, i), o = 0)); i >= 8; t1[r + p] = 255 & s, p += d, s /= 256, i -= 8);
                    for(o = o << i | s, c += i; c > 0; t1[r + p] = 255 & o, p += d, o /= 256, c -= 8);
                    t1[r + p - d] |= 128 * m;
                };
            },
            {}
        ],
        231: [
            function(t1, e1, r) {
                "function" == typeof Object.create ? e1.exports = function(t1, e1) {
                    e1 && (t1.super_ = e1, t1.prototype = Object.create(e1.prototype, {
                        constructor: {
                            value: t1,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : e1.exports = function(t1, e1) {
                    if (e1) {
                        t1.super_ = e1;
                        var r = function() {};
                        r.prototype = e1.prototype, t1.prototype = new r, t1.prototype.constructor = t1;
                    }
                };
            },
            {}
        ],
        232: [
            function(t1, e1, r) {
                e1.exports = !0;
            },
            {}
        ],
        233: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = "undefined" != typeof navigator && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion));
            },
            {}
        ],
        234: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = a, e1.exports.isMobile = a, e1.exports.default = a;
                var n = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i, i = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;
                function a(t1) {
                    t1 || (t1 = {});
                    var e1 = t1.ua;
                    if (e1 || "undefined" == typeof navigator || (e1 = navigator.userAgent), e1 && e1.headers && "string" == typeof e1.headers["user-agent"] && (e1 = e1.headers["user-agent"]), "string" != typeof e1) return !1;
                    var r = t1.tablet ? i.test(e1) : n.test(e1);
                    return !r && t1.tablet && t1.featureDetect && navigator && navigator.maxTouchPoints > 1 && -1 !== e1.indexOf("Macintosh") && -1 !== e1.indexOf("Safari") && (r = !0), r;
                }
            },
            {}
        ],
        235: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    var e1 = typeof t1;
                    return null !== t1 && ("object" === e1 || "function" === e1);
                };
            },
            {}
        ],
        236: [
            function(t1, e1, r) {
                "use strict";
                var n = Object.prototype.toString;
                e1.exports = function(t1) {
                    var e1;
                    return "[object Object]" === n.call(t1) && (null === (e1 = Object.getPrototypeOf(t1)) || e1 === Object.getPrototypeOf({}));
                };
            },
            {}
        ],
        237: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    for(var e1, r = t1.length, n = 0; n < r; n++)if (((e1 = t1.charCodeAt(n)) < 9 || e1 > 13) && 32 !== e1 && 133 !== e1 && 160 !== e1 && 5760 !== e1 && 6158 !== e1 && (e1 < 8192 || e1 > 8205) && 8232 !== e1 && 8233 !== e1 && 8239 !== e1 && 8287 !== e1 && 8288 !== e1 && 12288 !== e1 && 65279 !== e1) return !1;
                    return !0;
                };
            },
            {}
        ],
        238: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    return "string" == typeof t1 && (t1 = t1.trim(), !!(/^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(t1) && /[\dz]$/i.test(t1) && t1.length > 4));
                };
            },
            {}
        ],
        239: [
            function(t1, e1, r) {
                !function(t1, n) {
                    "object" == typeof r && void 0 !== e1 ? e1.exports = n() : (t1 = t1 || self).mapboxgl = n();
                }(this, function() {
                    "use strict";
                    var t1, e1, r;
                    function n(n, i) {
                        if (t1) {
                            if (e1) {
                                var a = "var sharedChunk = {}; (" + t1 + ")(sharedChunk); (" + e1 + ")(sharedChunk);", o = {};
                                t1(o), (r = i(o)).workerUrl = window.URL.createObjectURL(new Blob([
                                    a
                                ], {
                                    type: "text/javascript"
                                }));
                            } else e1 = i;
                        } else t1 = i;
                    }
                    return n(0, function(t1) {
                        function e1(t1, e1) {
                            return t1(e1 = {
                                exports: {}
                            }, e1.exports), e1.exports;
                        }
                        var r = n;
                        function n(t1, e1, r, n) {
                            this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (n - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = n, this.p2x = r, this.p2y = n;
                        }
                        n.prototype.sampleCurveX = function(t1) {
                            return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
                        }, n.prototype.sampleCurveY = function(t1) {
                            return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
                        }, n.prototype.sampleCurveDerivativeX = function(t1) {
                            return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
                        }, n.prototype.solveCurveX = function(t1, e1) {
                            var r, n, i, a, o;
                            for(void 0 === e1 && (e1 = 1e-6), i = t1, o = 0; o < 8; o++){
                                if (a = this.sampleCurveX(i) - t1, Math.abs(a) < e1) return i;
                                var s = this.sampleCurveDerivativeX(i);
                                if (Math.abs(s) < 1e-6) break;
                                i -= a / s;
                            }
                            if ((i = t1) < (r = 0)) return r;
                            if (i > (n = 1)) return n;
                            for(; r < n;){
                                if (a = this.sampleCurveX(i), Math.abs(a - t1) < e1) return i;
                                t1 > a ? r = i : n = i, i = .5 * (n - r) + r;
                            }
                            return i;
                        }, n.prototype.solve = function(t1, e1) {
                            return this.sampleCurveY(this.solveCurveX(t1, e1));
                        };
                        var i = a;
                        function a(t1, e1) {
                            this.x = t1, this.y = e1;
                        }
                        function o(t1, e1, n, i) {
                            var a = new r(t1, e1, n, i);
                            return function(t1) {
                                return a.solve(t1);
                            };
                        }
                        a.prototype = {
                            clone: function() {
                                return new a(this.x, this.y);
                            },
                            add: function(t1) {
                                return this.clone()._add(t1);
                            },
                            sub: function(t1) {
                                return this.clone()._sub(t1);
                            },
                            multByPoint: function(t1) {
                                return this.clone()._multByPoint(t1);
                            },
                            divByPoint: function(t1) {
                                return this.clone()._divByPoint(t1);
                            },
                            mult: function(t1) {
                                return this.clone()._mult(t1);
                            },
                            div: function(t1) {
                                return this.clone()._div(t1);
                            },
                            rotate: function(t1) {
                                return this.clone()._rotate(t1);
                            },
                            rotateAround: function(t1, e1) {
                                return this.clone()._rotateAround(t1, e1);
                            },
                            matMult: function(t1) {
                                return this.clone()._matMult(t1);
                            },
                            unit: function() {
                                return this.clone()._unit();
                            },
                            perp: function() {
                                return this.clone()._perp();
                            },
                            round: function() {
                                return this.clone()._round();
                            },
                            mag: function() {
                                return Math.sqrt(this.x * this.x + this.y * this.y);
                            },
                            equals: function(t1) {
                                return this.x === t1.x && this.y === t1.y;
                            },
                            dist: function(t1) {
                                return Math.sqrt(this.distSqr(t1));
                            },
                            distSqr: function(t1) {
                                var e1 = t1.x - this.x, r = t1.y - this.y;
                                return e1 * e1 + r * r;
                            },
                            angle: function() {
                                return Math.atan2(this.y, this.x);
                            },
                            angleTo: function(t1) {
                                return Math.atan2(this.y - t1.y, this.x - t1.x);
                            },
                            angleWith: function(t1) {
                                return this.angleWithSep(t1.x, t1.y);
                            },
                            angleWithSep: function(t1, e1) {
                                return Math.atan2(this.x * e1 - this.y * t1, this.x * t1 + this.y * e1);
                            },
                            _matMult: function(t1) {
                                var e1 = t1[0] * this.x + t1[1] * this.y, r = t1[2] * this.x + t1[3] * this.y;
                                return this.x = e1, this.y = r, this;
                            },
                            _add: function(t1) {
                                return this.x += t1.x, this.y += t1.y, this;
                            },
                            _sub: function(t1) {
                                return this.x -= t1.x, this.y -= t1.y, this;
                            },
                            _mult: function(t1) {
                                return this.x *= t1, this.y *= t1, this;
                            },
                            _div: function(t1) {
                                return this.x /= t1, this.y /= t1, this;
                            },
                            _multByPoint: function(t1) {
                                return this.x *= t1.x, this.y *= t1.y, this;
                            },
                            _divByPoint: function(t1) {
                                return this.x /= t1.x, this.y /= t1.y, this;
                            },
                            _unit: function() {
                                return this._div(this.mag()), this;
                            },
                            _perp: function() {
                                var t1 = this.y;
                                return this.y = this.x, this.x = -t1, this;
                            },
                            _rotate: function(t1) {
                                var e1 = Math.cos(t1), r = Math.sin(t1), n = e1 * this.x - r * this.y, i = r * this.x + e1 * this.y;
                                return this.x = n, this.y = i, this;
                            },
                            _rotateAround: function(t1, e1) {
                                var r = Math.cos(t1), n = Math.sin(t1), i = e1.x + r * (this.x - e1.x) - n * (this.y - e1.y), a = e1.y + n * (this.x - e1.x) + r * (this.y - e1.y);
                                return this.x = i, this.y = a, this;
                            },
                            _round: function() {
                                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                            }
                        }, a.convert = function(t1) {
                            return t1 instanceof a ? t1 : Array.isArray(t1) ? new a(t1[0], t1[1]) : t1;
                        };
                        var s = o(.25, .1, .25, 1);
                        function l(t1, e1, r) {
                            return Math.min(r, Math.max(e1, t1));
                        }
                        function c(t1, e1, r) {
                            var n = r - e1, i = ((t1 - e1) % n + n) % n + e1;
                            return i === e1 ? r : i;
                        }
                        function u(t1) {
                            for(var e1 = [], r = arguments.length - 1; r-- > 0;)e1[r] = arguments[r + 1];
                            for(var n = 0, i = e1; n < i.length; n += 1){
                                var a = i[n];
                                for(var o in a)t1[o] = a[o];
                            }
                            return t1;
                        }
                        var f = 1;
                        function h() {
                            return f++;
                        }
                        function p() {
                            return function t1(e1) {
                                return e1 ? (e1 ^ 16 * Math.random() >> e1 / 4).toString(16) : ([
                                    1e7
                                ] + -[
                                    1e3
                                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, t1);
                            }();
                        }
                        function d(t1) {
                            return !!t1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t1);
                        }
                        function m(t1, e1) {
                            t1.forEach(function(t1) {
                                e1[t1] && (e1[t1] = e1[t1].bind(e1));
                            });
                        }
                        function g(t1, e1) {
                            return -1 !== t1.indexOf(e1, t1.length - e1.length);
                        }
                        function v(t1, e1, r) {
                            var n = {};
                            for(var i in t1)n[i] = e1.call(r || this, t1[i], i, t1);
                            return n;
                        }
                        function y(t1, e1, r) {
                            var n = {};
                            for(var i in t1)e1.call(r || this, t1[i], i, t1) && (n[i] = t1[i]);
                            return n;
                        }
                        function x(t1) {
                            return Array.isArray(t1) ? t1.map(x) : "object" == typeof t1 && t1 ? v(t1, x) : t1;
                        }
                        var b = {};
                        function _(t1) {
                            b[t1] || ("undefined" != typeof console && console.warn(t1), b[t1] = !0);
                        }
                        function w(t1, e1, r) {
                            return (r.y - t1.y) * (e1.x - t1.x) > (e1.y - t1.y) * (r.x - t1.x);
                        }
                        function T(t1) {
                            for(var e1 = 0, r = 0, n = t1.length, i = n - 1, a = void 0, o = void 0; r < n; i = r++)a = t1[r], e1 += ((o = t1[i]).x - a.x) * (a.y + o.y);
                            return e1;
                        }
                        function k() {
                            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
                        }
                        function A(t1) {
                            var e1 = {};
                            if (t1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, function(t1, r, n, i) {
                                var a = n || i;
                                return e1[r] = !a || a.toLowerCase(), "";
                            }), e1["max-age"]) {
                                var r = parseInt(e1["max-age"], 10);
                                isNaN(r) ? delete e1["max-age"] : e1["max-age"] = r;
                            }
                            return e1;
                        }
                        var M = null;
                        function S(t1) {
                            if (null == M) {
                                var e1 = t1.navigator ? t1.navigator.userAgent : null;
                                M = !!t1.safari || !(!e1 || !(/\b(iPad|iPhone|iPod)\b/.test(e1) || e1.match("Safari") && !e1.match("Chrome")));
                            }
                            return M;
                        }
                        function E(t1) {
                            try {
                                var e1 = self[t1];
                                return e1.setItem("_mapbox_test_", 1), e1.removeItem("_mapbox_test_"), !0;
                            } catch (t1) {
                                return !1;
                            }
                        }
                        var L, C, P, I, O = self.performance && self.performance.now ? self.performance.now.bind(self.performance) : Date.now.bind(Date), z = self.requestAnimationFrame || self.mozRequestAnimationFrame || self.webkitRequestAnimationFrame || self.msRequestAnimationFrame, D = self.cancelAnimationFrame || self.mozCancelAnimationFrame || self.webkitCancelAnimationFrame || self.msCancelAnimationFrame, R = {
                            now: O,
                            frame: function(t1) {
                                var e1 = z(t1);
                                return {
                                    cancel: function() {
                                        return D(e1);
                                    }
                                };
                            },
                            getImageData: function(t1, e1) {
                                void 0 === e1 && (e1 = 0);
                                var r = self.document.createElement("canvas"), n = r.getContext("2d");
                                if (!n) throw new Error("failed to create canvas 2d context");
                                return r.width = t1.width, r.height = t1.height, n.drawImage(t1, 0, 0, t1.width, t1.height), n.getImageData(-e1, -e1, t1.width + 2 * e1, t1.height + 2 * e1);
                            },
                            resolveURL: function(t1) {
                                return L || (L = self.document.createElement("a")), L.href = t1, L.href;
                            },
                            hardwareConcurrency: self.navigator.hardwareConcurrency || 4,
                            get devicePixelRatio () {
                                return self.devicePixelRatio;
                            },
                            get prefersReducedMotion () {
                                return !!self.matchMedia && (null == C && (C = self.matchMedia("(prefers-reduced-motion: reduce)")), C.matches);
                            }
                        }, F = {
                            API_URL: "https://api.mapbox.com",
                            get EVENTS_URL () {
                                return this.API_URL ? 0 === this.API_URL.indexOf("https://api.mapbox.cn") ? "https://events.mapbox.cn/events/v2" : 0 === this.API_URL.indexOf("https://api.mapbox.com") ? "https://events.mapbox.com/events/v2" : null : null;
                            },
                            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
                            REQUIRE_ACCESS_TOKEN: !0,
                            ACCESS_TOKEN: null,
                            MAX_PARALLEL_IMAGE_REQUESTS: 16
                        }, B = {
                            supported: !1,
                            testSupport: function(t1) {
                                if (N || !I) return;
                                j ? U(t1) : P = t1;
                            }
                        }, N = !1, j = !1;
                        function U(t1) {
                            var e1 = t1.createTexture();
                            t1.bindTexture(t1.TEXTURE_2D, e1);
                            try {
                                if (t1.texImage2D(t1.TEXTURE_2D, 0, t1.RGBA, t1.RGBA, t1.UNSIGNED_BYTE, I), t1.isContextLost()) return;
                                B.supported = !0;
                            } catch (t1) {}
                            t1.deleteTexture(e1), N = !0;
                        }
                        self.document && ((I = self.document.createElement("img")).onload = function() {
                            P && U(P), P = null, j = !0;
                        }, I.onerror = function() {
                            N = !0, P = null;
                        }, I.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
                        var V = "01";
                        var H = function(t1, e1) {
                            this._transformRequestFn = t1, this._customAccessToken = e1, this._createSkuToken();
                        };
                        function q(t1) {
                            return 0 === t1.indexOf("mapbox:");
                        }
                        H.prototype._createSkuToken = function() {
                            var t1 = function() {
                                for(var t1 = "", e1 = 0; e1 < 10; e1++)t1 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                                return {
                                    token: [
                                        "1",
                                        V,
                                        t1
                                    ].join(""),
                                    tokenExpiresAt: Date.now() + 432e5
                                };
                            }();
                            this._skuToken = t1.token, this._skuTokenExpiresAt = t1.tokenExpiresAt;
                        }, H.prototype._isSkuTokenExpired = function() {
                            return Date.now() > this._skuTokenExpiresAt;
                        }, H.prototype.transformRequest = function(t1, e1) {
                            return this._transformRequestFn && this._transformRequestFn(t1, e1) || {
                                url: t1
                            };
                        }, H.prototype.normalizeStyleURL = function(t1, e1) {
                            if (!q(t1)) return t1;
                            var r = X(t1);
                            return r.path = "/styles/v1" + r.path, this._makeAPIURL(r, this._customAccessToken || e1);
                        }, H.prototype.normalizeGlyphsURL = function(t1, e1) {
                            if (!q(t1)) return t1;
                            var r = X(t1);
                            return r.path = "/fonts/v1" + r.path, this._makeAPIURL(r, this._customAccessToken || e1);
                        }, H.prototype.normalizeSourceURL = function(t1, e1) {
                            if (!q(t1)) return t1;
                            var r = X(t1);
                            return r.path = "/v4/" + r.authority + ".json", r.params.push("secure"), this._makeAPIURL(r, this._customAccessToken || e1);
                        }, H.prototype.normalizeSpriteURL = function(t1, e1, r, n) {
                            var i = X(t1);
                            return q(t1) ? (i.path = "/styles/v1" + i.path + "/sprite" + e1 + r, this._makeAPIURL(i, this._customAccessToken || n)) : (i.path += "" + e1 + r, Z(i));
                        }, H.prototype.normalizeTileURL = function(t1, e1) {
                            if (this._isSkuTokenExpired() && this._createSkuToken(), t1 && !q(t1)) return t1;
                            var r = X(t1), n = R.devicePixelRatio >= 2 || 512 === e1 ? "@2x" : "", i = B.supported ? ".webp" : "$1";
                            r.path = r.path.replace(/(\.(png|jpg)\d*)(?=$)/, "" + n + i), r.path = r.path.replace(/^.+\/v4\//, "/"), r.path = "/v4" + r.path;
                            var a = this._customAccessToken || function(t1) {
                                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                                    var n = r[e1].match(/^access_token=(.*)$/);
                                    if (n) return n[1];
                                }
                                return null;
                            }(r.params) || F.ACCESS_TOKEN;
                            return F.REQUIRE_ACCESS_TOKEN && a && this._skuToken && r.params.push("sku=" + this._skuToken), this._makeAPIURL(r, a);
                        }, H.prototype.canonicalizeTileURL = function(t1, e1) {
                            var r = X(t1);
                            if (!r.path.match(/(^\/v4\/)/) || !r.path.match(/\.[\w]+$/)) return t1;
                            var n = "mapbox://tiles/";
                            n += r.path.replace("/v4/", "");
                            var i = r.params;
                            return e1 && (i = i.filter(function(t1) {
                                return !t1.match(/^access_token=/);
                            })), i.length && (n += "?" + i.join("&")), n;
                        }, H.prototype.canonicalizeTileset = function(t1, e1) {
                            for(var r = !!e1 && q(e1), n = [], i = 0, a = t1.tiles || []; i < a.length; i += 1){
                                var o = a[i];
                                Y(o) ? n.push(this.canonicalizeTileURL(o, r)) : n.push(o);
                            }
                            return n;
                        }, H.prototype._makeAPIURL = function(t1, e1) {
                            var r = "See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes", n = X(F.API_URL);
                            if (t1.protocol = n.protocol, t1.authority = n.authority, "/" !== n.path && (t1.path = "" + n.path + t1.path), !F.REQUIRE_ACCESS_TOKEN) return Z(t1);
                            if (!(e1 = e1 || F.ACCESS_TOKEN)) throw new Error("An API access token is required to use Mapbox GL. " + r);
                            if ("s" === e1[0]) throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). " + r);
                            return t1.params = t1.params.filter(function(t1) {
                                return -1 === t1.indexOf("access_token");
                            }), t1.params.push("access_token=" + e1), Z(t1);
                        };
                        var G = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
                        function Y(t1) {
                            return G.test(t1);
                        }
                        var W = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
                        function X(t1) {
                            var e1 = t1.match(W);
                            if (!e1) throw new Error("Unable to parse URL object");
                            return {
                                protocol: e1[1],
                                authority: e1[2],
                                path: e1[3] || "/",
                                params: e1[4] ? e1[4].split("&") : []
                            };
                        }
                        function Z(t1) {
                            var e1 = t1.params.length ? "?" + t1.params.join("&") : "";
                            return t1.protocol + "://" + t1.authority + t1.path + e1;
                        }
                        function J(t1) {
                            if (!t1) return null;
                            var e1, r = t1.split(".");
                            if (!r || 3 !== r.length) return null;
                            try {
                                return JSON.parse((e1 = r[1], decodeURIComponent(self.atob(e1).split("").map(function(t1) {
                                    return "%" + ("00" + t1.charCodeAt(0).toString(16)).slice(-2);
                                }).join(""))));
                            } catch (t1) {
                                return null;
                            }
                        }
                        var K = function(t1) {
                            this.type = t1, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
                        };
                        K.prototype.getStorageKey = function(t1) {
                            var e1, r = J(F.ACCESS_TOKEN), n = "";
                            return r && r.u ? (e1 = r.u, n = self.btoa(encodeURIComponent(e1).replace(/%([0-9A-F]{2})/g, function(t1, e1) {
                                return String.fromCharCode(Number("0x" + e1));
                            }))) : n = F.ACCESS_TOKEN || "", t1 ? "mapbox.eventData." + t1 + ":" + n : "mapbox.eventData:" + n;
                        }, K.prototype.fetchEventData = function() {
                            var t1 = E("localStorage"), e1 = this.getStorageKey(), r = this.getStorageKey("uuid");
                            if (t1) try {
                                var n = self.localStorage.getItem(e1);
                                n && (this.eventData = JSON.parse(n));
                                var i = self.localStorage.getItem(r);
                                i && (this.anonId = i);
                            } catch (t1) {
                                _("Unable to read from LocalStorage");
                            }
                        }, K.prototype.saveEventData = function() {
                            var t1 = E("localStorage"), e1 = this.getStorageKey(), r = this.getStorageKey("uuid");
                            if (t1) try {
                                self.localStorage.setItem(r, this.anonId), Object.keys(this.eventData).length >= 1 && self.localStorage.setItem(e1, JSON.stringify(this.eventData));
                            } catch (t1) {
                                _("Unable to write to LocalStorage");
                            }
                        }, K.prototype.processRequests = function(t1) {}, K.prototype.postEvent = function(t1, e1, r, n) {
                            var i = this;
                            if (F.EVENTS_URL) {
                                var a = X(F.EVENTS_URL);
                                a.params.push("access_token=" + (n || F.ACCESS_TOKEN || ""));
                                var o = {
                                    event: this.type,
                                    created: new Date(t1).toISOString(),
                                    sdkIdentifier: "mapbox-gl-js",
                                    sdkVersion: "1.10.1",
                                    skuId: V,
                                    userId: this.anonId
                                }, s = e1 ? u(o, e1) : o, l = {
                                    url: Z(a),
                                    headers: {
                                        "Content-Type": "text/plain"
                                    },
                                    body: JSON.stringify([
                                        s
                                    ])
                                };
                                this.pendingRequest = bt(l, function(t1) {
                                    i.pendingRequest = null, r(t1), i.saveEventData(), i.processRequests(n);
                                });
                            }
                        }, K.prototype.queueRequest = function(t1, e1) {
                            this.queue.push(t1), this.processRequests(e1);
                        };
                        var Q, $, tt = function(t1) {
                            function e1() {
                                t1.call(this, "map.load"), this.success = {}, this.skuToken = "";
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.postMapLoadEvent = function(t1, e1, r, n) {
                                this.skuToken = r, (F.EVENTS_URL && n || F.ACCESS_TOKEN && Array.isArray(t1) && t1.some(function(t1) {
                                    return q(t1) || Y(t1);
                                })) && this.queueRequest({
                                    id: e1,
                                    timestamp: Date.now()
                                }, n);
                            }, e1.prototype.processRequests = function(t1) {
                                var e1 = this;
                                if (!this.pendingRequest && 0 !== this.queue.length) {
                                    var r = this.queue.shift(), n = r.id, i = r.timestamp;
                                    n && this.success[n] || (this.anonId || this.fetchEventData(), d(this.anonId) || (this.anonId = p()), this.postEvent(i, {
                                        skuToken: this.skuToken
                                    }, function(t1) {
                                        t1 || n && (e1.success[n] = !0);
                                    }, t1));
                                }
                            }, e1;
                        }(K), et = new (function(t1) {
                            function e1(e1) {
                                t1.call(this, "appUserTurnstile"), this._customAccessToken = e1;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.postTurnstileEvent = function(t1, e1) {
                                F.EVENTS_URL && F.ACCESS_TOKEN && Array.isArray(t1) && t1.some(function(t1) {
                                    return q(t1) || Y(t1);
                                }) && this.queueRequest(Date.now(), e1);
                            }, e1.prototype.processRequests = function(t1) {
                                var e1 = this;
                                if (!this.pendingRequest && 0 !== this.queue.length) {
                                    this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                                    var r = J(F.ACCESS_TOKEN), n = r ? r.u : F.ACCESS_TOKEN, i = n !== this.eventData.tokenU;
                                    d(this.anonId) || (this.anonId = p(), i = !0);
                                    var a = this.queue.shift();
                                    if (this.eventData.lastSuccess) {
                                        var o = new Date(this.eventData.lastSuccess), s = new Date(a), l = (a - this.eventData.lastSuccess) / 864e5;
                                        i = i || l >= 1 || l < -1 || o.getDate() !== s.getDate();
                                    } else i = !0;
                                    if (!i) return this.processRequests();
                                    this.postEvent(a, {
                                        "enabled.telemetry": !1
                                    }, function(t1) {
                                        t1 || (e1.eventData.lastSuccess = a, e1.eventData.tokenU = n);
                                    }, t1);
                                }
                            }, e1;
                        }(K)), rt = et.postTurnstileEvent.bind(et), nt = new tt, it = nt.postMapLoadEvent.bind(nt), at = 500, ot = 50;
                        function st() {
                            self.caches && !Q && (Q = self.caches.open("mapbox-tiles"));
                        }
                        function lt(t1, e1, r) {
                            if (st(), Q) {
                                var n = {
                                    status: e1.status,
                                    statusText: e1.statusText,
                                    headers: new self.Headers
                                };
                                e1.headers.forEach(function(t1, e1) {
                                    return n.headers.set(e1, t1);
                                });
                                var i = A(e1.headers.get("Cache-Control") || "");
                                if (!i["no-store"]) i["max-age"] && n.headers.set("Expires", new Date(r + 1e3 * i["max-age"]).toUTCString()), new Date(n.headers.get("Expires")).getTime() - r < 42e4 || function(t1, e1) {
                                    if (void 0 === $) try {
                                        new Response(new ReadableStream), $ = !0;
                                    } catch (t1) {
                                        $ = !1;
                                    }
                                    $ ? e1(t1.body) : t1.blob().then(e1);
                                }(e1, function(e1) {
                                    var r = new self.Response(e1, n);
                                    st(), Q && Q.then(function(e1) {
                                        return e1.put(ct(t1.url), r);
                                    }).catch(function(t1) {
                                        return _(t1.message);
                                    });
                                });
                            }
                        }
                        function ct(t1) {
                            var e1 = t1.indexOf("?");
                            return e1 < 0 ? t1 : t1.slice(0, e1);
                        }
                        function ut(t1, e1) {
                            if (st(), !Q) return e1(null);
                            var r = ct(t1.url);
                            Q.then(function(t1) {
                                t1.match(r).then(function(n) {
                                    var i = function(t1) {
                                        if (!t1) return !1;
                                        var e1 = new Date(t1.headers.get("Expires") || 0), r = A(t1.headers.get("Cache-Control") || "");
                                        return e1 > Date.now() && !r["no-cache"];
                                    }(n);
                                    t1.delete(r), i && t1.put(r, n.clone()), e1(null, n, i);
                                }).catch(e1);
                            }).catch(e1);
                        }
                        var ft, ht = 1 / 0;
                        function pt() {
                            return null == ft && (ft = self.OffscreenCanvas && new self.OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap), ft;
                        }
                        var dt = {
                            Unknown: "Unknown",
                            Style: "Style",
                            Source: "Source",
                            Tile: "Tile",
                            Glyphs: "Glyphs",
                            SpriteImage: "SpriteImage",
                            SpriteJSON: "SpriteJSON",
                            Image: "Image"
                        };
                        "function" == typeof Object.freeze && Object.freeze(dt);
                        var mt = function(t1) {
                            function e1(e1, r, n) {
                                401 === r && Y(n) && (e1 += ": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"), t1.call(this, e1), this.status = r, this.url = n, this.name = this.constructor.name, this.message = e1;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.toString = function() {
                                return this.name + ": " + this.message + " (" + this.status + "): " + this.url;
                            }, e1;
                        }(Error), gt = k() ? function() {
                            return self.worker && self.worker.referrer;
                        } : function() {
                            return ("blob:" === self.location.protocol ? self.parent : self).location.href;
                        };
                        function vt(t1, e1) {
                            var r, n = new self.AbortController, i = new self.Request(t1.url, {
                                method: t1.method || "GET",
                                body: t1.body,
                                credentials: t1.credentials,
                                headers: t1.headers,
                                referrer: gt(),
                                signal: n.signal
                            }), a = !1, o = !1, s = (r = i.url).indexOf("sku=") > 0 && Y(r);
                            "json" === t1.type && i.headers.set("Accept", "application/json");
                            var l = function(r, n, a) {
                                if (!o) {
                                    if (r && "SecurityError" !== r.message && _(r), n && a) return c(n);
                                    var l = Date.now();
                                    self.fetch(i).then(function(r) {
                                        if (r.ok) {
                                            var n = s ? r.clone() : null;
                                            return c(r, n, l);
                                        }
                                        return e1(new mt(r.statusText, r.status, t1.url));
                                    }).catch(function(t1) {
                                        20 !== t1.code && e1(new Error(t1.message));
                                    });
                                }
                            }, c = function(r, n, s) {
                                ("arrayBuffer" === t1.type ? r.arrayBuffer() : "json" === t1.type ? r.json() : r.text()).then(function(t1) {
                                    o || (n && s && lt(i, n, s), a = !0, e1(null, t1, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                                }).catch(function(t1) {
                                    o || e1(new Error(t1.message));
                                });
                            };
                            return s ? ut(i, l) : l(null, null), {
                                cancel: function() {
                                    o = !0, a || n.abort();
                                }
                            };
                        }
                        var yt = function(t1, e1) {
                            if (r = t1.url, !(/^file:/.test(r) || /^file:/.test(gt()) && !/^\w+:/.test(r))) {
                                if (self.fetch && self.Request && self.AbortController && self.Request.prototype.hasOwnProperty("signal")) return vt(t1, e1);
                                if (k() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t1, e1, void 0, !0);
                            }
                            var r;
                            return function(t1, e1) {
                                var r = new self.XMLHttpRequest;
                                for(var n in r.open(t1.method || "GET", t1.url, !0), "arrayBuffer" === t1.type && (r.responseType = "arraybuffer"), t1.headers)r.setRequestHeader(n, t1.headers[n]);
                                return "json" === t1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t1.credentials, r.onerror = function() {
                                    e1(new Error(r.statusText));
                                }, r.onload = function() {
                                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                                        var n = r.response;
                                        if ("json" === t1.type) try {
                                            n = JSON.parse(r.response);
                                        } catch (t1) {
                                            return e1(t1);
                                        }
                                        e1(null, n, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                                    } else e1(new mt(r.statusText, r.status, t1.url));
                                }, r.send(t1.body), {
                                    cancel: function() {
                                        return r.abort();
                                    }
                                };
                            }(t1, e1);
                        }, xt = function(t1, e1) {
                            return yt(u(t1, {
                                type: "arrayBuffer"
                            }), e1);
                        }, bt = function(t1, e1) {
                            return yt(u(t1, {
                                method: "POST"
                            }), e1);
                        };
                        var _t, wt;
                        _t = [], wt = 0;
                        var Tt = function(t1, e1) {
                            if (B.supported && (t1.headers || (t1.headers = {}), t1.headers.accept = "image/webp,*/*"), wt >= F.MAX_PARALLEL_IMAGE_REQUESTS) {
                                var r = {
                                    requestParameters: t1,
                                    callback: e1,
                                    cancelled: !1,
                                    cancel: function() {
                                        this.cancelled = !0;
                                    }
                                };
                                return _t.push(r), r;
                            }
                            wt++;
                            var n = !1, i = function() {
                                if (!n) for(n = !0, wt--; _t.length && wt < F.MAX_PARALLEL_IMAGE_REQUESTS;){
                                    var t1 = _t.shift(), e1 = t1.requestParameters, r = t1.callback;
                                    t1.cancelled || (t1.cancel = Tt(e1, r).cancel);
                                }
                            }, a = xt(t1, function(t1, r, n, a) {
                                i(), t1 ? e1(t1) : r && (pt() ? function(t1, e1) {
                                    var r = new self.Blob([
                                        new Uint8Array(t1)
                                    ], {
                                        type: "image/png"
                                    });
                                    self.createImageBitmap(r).then(function(t1) {
                                        e1(null, t1);
                                    }).catch(function(t1) {
                                        e1(new Error("Could not load image because of " + t1.message + ". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                                    });
                                }(r, e1) : function(t1, e1, r, n) {
                                    var i = new self.Image, a = self.URL;
                                    i.onload = function() {
                                        e1(null, i), a.revokeObjectURL(i.src);
                                    }, i.onerror = function() {
                                        return e1(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                                    };
                                    var o = new self.Blob([
                                        new Uint8Array(t1)
                                    ], {
                                        type: "image/png"
                                    });
                                    i.cacheControl = r, i.expires = n, i.src = t1.byteLength ? a.createObjectURL(o) : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
                                }(r, e1, n, a));
                            });
                            return {
                                cancel: function() {
                                    a.cancel(), i();
                                }
                            };
                        };
                        function kt(t1, e1, r) {
                            r[t1] && -1 !== r[t1].indexOf(e1) || (r[t1] = r[t1] || [], r[t1].push(e1));
                        }
                        function At(t1, e1, r) {
                            if (r && r[t1]) {
                                var n = r[t1].indexOf(e1);
                                -1 !== n && r[t1].splice(n, 1);
                            }
                        }
                        var Mt = function(t1, e1) {
                            void 0 === e1 && (e1 = {}), u(this, e1), this.type = t1;
                        }, St = function(t1) {
                            function e1(e1, r) {
                                void 0 === r && (r = {}), t1.call(this, "error", u({
                                    error: e1
                                }, r));
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1;
                        }(Mt), Et = function() {};
                        Et.prototype.on = function(t1, e1) {
                            return this._listeners = this._listeners || {}, kt(t1, e1, this._listeners), this;
                        }, Et.prototype.off = function(t1, e1) {
                            return At(t1, e1, this._listeners), At(t1, e1, this._oneTimeListeners), this;
                        }, Et.prototype.once = function(t1, e1) {
                            return this._oneTimeListeners = this._oneTimeListeners || {}, kt(t1, e1, this._oneTimeListeners), this;
                        }, Et.prototype.fire = function(t1, e1) {
                            "string" == typeof t1 && (t1 = new Mt(t1, e1 || {}));
                            var r = t1.type;
                            if (this.listens(r)) {
                                t1.target = this;
                                for(var n = 0, i = this._listeners && this._listeners[r] ? this._listeners[r].slice() : []; n < i.length; n += 1)i[n].call(this, t1);
                                for(var a = 0, o = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : []; a < o.length; a += 1){
                                    var s = o[a];
                                    At(r, s, this._oneTimeListeners), s.call(this, t1);
                                }
                                var l = this._eventedParent;
                                l && (u(t1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), l.fire(t1));
                            } else t1 instanceof St && console.error(t1.error);
                            return this;
                        }, Et.prototype.listens = function(t1) {
                            return this._listeners && this._listeners[t1] && this._listeners[t1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t1] && this._oneTimeListeners[t1].length > 0 || this._eventedParent && this._eventedParent.listens(t1);
                        }, Et.prototype.setEventedParent = function(t1, e1) {
                            return this._eventedParent = t1, this._eventedParentData = e1, this;
                        };
                        var Lt = {
                            $version: 8,
                            $root: {
                                version: {
                                    required: !0,
                                    type: "enum",
                                    values: [
                                        8
                                    ]
                                },
                                name: {
                                    type: "string"
                                },
                                metadata: {
                                    type: "*"
                                },
                                center: {
                                    type: "array",
                                    value: "number"
                                },
                                zoom: {
                                    type: "number"
                                },
                                bearing: {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees"
                                },
                                pitch: {
                                    type: "number",
                                    default: 0,
                                    units: "degrees"
                                },
                                light: {
                                    type: "light"
                                },
                                sources: {
                                    required: !0,
                                    type: "sources"
                                },
                                sprite: {
                                    type: "string"
                                },
                                glyphs: {
                                    type: "string"
                                },
                                transition: {
                                    type: "transition"
                                },
                                layers: {
                                    required: !0,
                                    type: "array",
                                    value: "layer"
                                }
                            },
                            sources: {
                                "*": {
                                    type: "source"
                                }
                            },
                            source: [
                                "source_vector",
                                "source_raster",
                                "source_raster_dem",
                                "source_geojson",
                                "source_video",
                                "source_image"
                            ],
                            source_vector: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        vector: {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                scheme: {
                                    type: "enum",
                                    values: {
                                        xyz: {},
                                        tms: {}
                                    },
                                    default: "xyz"
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                attribution: {
                                    type: "string"
                                },
                                promoteId: {
                                    type: "promoteId"
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_raster: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        raster: {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                tileSize: {
                                    type: "number",
                                    default: 512,
                                    units: "pixels"
                                },
                                scheme: {
                                    type: "enum",
                                    values: {
                                        xyz: {},
                                        tms: {}
                                    },
                                    default: "xyz"
                                },
                                attribution: {
                                    type: "string"
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_raster_dem: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        "raster-dem": {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                tileSize: {
                                    type: "number",
                                    default: 512,
                                    units: "pixels"
                                },
                                attribution: {
                                    type: "string"
                                },
                                encoding: {
                                    type: "enum",
                                    values: {
                                        terrarium: {},
                                        mapbox: {}
                                    },
                                    default: "mapbox"
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_geojson: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        geojson: {}
                                    }
                                },
                                data: {
                                    type: "*"
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 18
                                },
                                attribution: {
                                    type: "string"
                                },
                                buffer: {
                                    type: "number",
                                    default: 128,
                                    maximum: 512,
                                    minimum: 0
                                },
                                tolerance: {
                                    type: "number",
                                    default: .375
                                },
                                cluster: {
                                    type: "boolean",
                                    default: !1
                                },
                                clusterRadius: {
                                    type: "number",
                                    default: 50,
                                    minimum: 0
                                },
                                clusterMaxZoom: {
                                    type: "number"
                                },
                                clusterProperties: {
                                    type: "*"
                                },
                                lineMetrics: {
                                    type: "boolean",
                                    default: !1
                                },
                                generateId: {
                                    type: "boolean",
                                    default: !1
                                },
                                promoteId: {
                                    type: "promoteId"
                                }
                            },
                            source_video: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        video: {}
                                    }
                                },
                                urls: {
                                    required: !0,
                                    type: "array",
                                    value: "string"
                                },
                                coordinates: {
                                    required: !0,
                                    type: "array",
                                    length: 4,
                                    value: {
                                        type: "array",
                                        length: 2,
                                        value: "number"
                                    }
                                }
                            },
                            source_image: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        image: {}
                                    }
                                },
                                url: {
                                    required: !0,
                                    type: "string"
                                },
                                coordinates: {
                                    required: !0,
                                    type: "array",
                                    length: 4,
                                    value: {
                                        type: "array",
                                        length: 2,
                                        value: "number"
                                    }
                                }
                            },
                            layer: {
                                id: {
                                    type: "string",
                                    required: !0
                                },
                                type: {
                                    type: "enum",
                                    values: {
                                        fill: {},
                                        line: {},
                                        symbol: {},
                                        circle: {},
                                        heatmap: {},
                                        "fill-extrusion": {},
                                        raster: {},
                                        hillshade: {},
                                        background: {}
                                    },
                                    required: !0
                                },
                                metadata: {
                                    type: "*"
                                },
                                source: {
                                    type: "string"
                                },
                                "source-layer": {
                                    type: "string"
                                },
                                minzoom: {
                                    type: "number",
                                    minimum: 0,
                                    maximum: 24
                                },
                                maxzoom: {
                                    type: "number",
                                    minimum: 0,
                                    maximum: 24
                                },
                                filter: {
                                    type: "filter"
                                },
                                layout: {
                                    type: "layout"
                                },
                                paint: {
                                    type: "paint"
                                }
                            },
                            layout: [
                                "layout_fill",
                                "layout_line",
                                "layout_circle",
                                "layout_heatmap",
                                "layout_fill-extrusion",
                                "layout_symbol",
                                "layout_raster",
                                "layout_hillshade",
                                "layout_background"
                            ],
                            layout_background: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_fill: {
                                "fill-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_circle: {
                                "circle-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_heatmap: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            "layout_fill-extrusion": {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_line: {
                                "line-cap": {
                                    type: "enum",
                                    values: {
                                        butt: {},
                                        round: {},
                                        square: {}
                                    },
                                    default: "butt",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-join": {
                                    type: "enum",
                                    values: {
                                        bevel: {},
                                        round: {},
                                        miter: {}
                                    },
                                    default: "miter",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-miter-limit": {
                                    type: "number",
                                    default: 2,
                                    requires: [
                                        {
                                            "line-join": "miter"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-round-limit": {
                                    type: "number",
                                    default: 1.05,
                                    requires: [
                                        {
                                            "line-join": "round"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_symbol: {
                                "symbol-placement": {
                                    type: "enum",
                                    values: {
                                        point: {},
                                        line: {},
                                        "line-center": {}
                                    },
                                    default: "point",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-spacing": {
                                    type: "number",
                                    default: 250,
                                    minimum: 1,
                                    units: "pixels",
                                    requires: [
                                        {
                                            "symbol-placement": "line"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-avoid-edges": {
                                    type: "boolean",
                                    default: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "symbol-z-order": {
                                    type: "enum",
                                    values: {
                                        auto: {},
                                        "viewport-y": {},
                                        source: {}
                                    },
                                    default: "auto",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-allow-overlap": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-ignore-placement": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-optional": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-rotation-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-size": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    units: "factor of the original icon size",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-text-fit": {
                                    type: "enum",
                                    values: {
                                        none: {},
                                        width: {},
                                        height: {},
                                        both: {}
                                    },
                                    default: "none",
                                    requires: [
                                        "icon-image",
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-text-fit-padding": {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    units: "pixels",
                                    requires: [
                                        "icon-image",
                                        "text-field",
                                        {
                                            "icon-text-fit": [
                                                "both",
                                                "width",
                                                "height"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-image": {
                                    type: "resolvedImage",
                                    tokens: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-padding": {
                                    type: "number",
                                    default: 2,
                                    minimum: 0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-keep-upright": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        {
                                            "icon-rotation-alignment": "map"
                                        },
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-offset": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-anchor": {
                                    type: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    default: "center",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-rotation-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-field": {
                                    type: "formatted",
                                    default: "",
                                    tokens: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-font": {
                                    type: "array",
                                    value: "string",
                                    default: [
                                        "Open Sans Regular",
                                        "Arial Unicode MS Regular"
                                    ],
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-size": {
                                    type: "number",
                                    default: 16,
                                    minimum: 0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-max-width": {
                                    type: "number",
                                    default: 10,
                                    minimum: 0,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-line-height": {
                                    type: "number",
                                    default: 1.2,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-letter-spacing": {
                                    type: "number",
                                    default: 0,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-justify": {
                                    type: "enum",
                                    values: {
                                        auto: {},
                                        left: {},
                                        center: {},
                                        right: {}
                                    },
                                    default: "center",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-radial-offset": {
                                    type: "number",
                                    units: "ems",
                                    default: 0,
                                    requires: [
                                        "text-field"
                                    ],
                                    "property-type": "data-driven",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    }
                                },
                                "text-variable-anchor": {
                                    type: "array",
                                    value: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-anchor": {
                                    type: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    default: "center",
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-variable-anchor"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-max-angle": {
                                    type: "number",
                                    default: 45,
                                    units: "degrees",
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-writing-mode": {
                                    type: "array",
                                    value: "enum",
                                    values: {
                                        horizontal: {},
                                        vertical: {}
                                    },
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-padding": {
                                    type: "number",
                                    default: 2,
                                    minimum: 0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-keep-upright": {
                                    type: "boolean",
                                    default: !0,
                                    requires: [
                                        "text-field",
                                        {
                                            "text-rotation-alignment": "map"
                                        },
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-transform": {
                                    type: "enum",
                                    values: {
                                        none: {},
                                        uppercase: {},
                                        lowercase: {}
                                    },
                                    default: "none",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-offset": {
                                    type: "array",
                                    value: "number",
                                    units: "ems",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-radial-offset"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-allow-overlap": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-ignore-placement": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-optional": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field",
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_raster: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            layout_hillshade: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    "property-type": "constant"
                                }
                            },
                            filter: {
                                type: "array",
                                value: "*"
                            },
                            filter_operator: {
                                type: "enum",
                                values: {
                                    "==": {},
                                    "!=": {},
                                    ">": {},
                                    ">=": {},
                                    "<": {},
                                    "<=": {},
                                    in: {},
                                    "!in": {},
                                    all: {},
                                    any: {},
                                    none: {},
                                    has: {},
                                    "!has": {},
                                    within: {}
                                }
                            },
                            geometry_type: {
                                type: "enum",
                                values: {
                                    Point: {},
                                    LineString: {},
                                    Polygon: {}
                                }
                            },
                            function: {
                                expression: {
                                    type: "expression"
                                },
                                stops: {
                                    type: "array",
                                    value: "function_stop"
                                },
                                base: {
                                    type: "number",
                                    default: 1,
                                    minimum: 0
                                },
                                property: {
                                    type: "string",
                                    default: "$zoom"
                                },
                                type: {
                                    type: "enum",
                                    values: {
                                        identity: {},
                                        exponential: {},
                                        interval: {},
                                        categorical: {}
                                    },
                                    default: "exponential"
                                },
                                colorSpace: {
                                    type: "enum",
                                    values: {
                                        rgb: {},
                                        lab: {},
                                        hcl: {}
                                    },
                                    default: "rgb"
                                },
                                default: {
                                    type: "*",
                                    required: !1
                                }
                            },
                            function_stop: {
                                type: "array",
                                minimum: 0,
                                maximum: 24,
                                value: [
                                    "number",
                                    "color"
                                ],
                                length: 2
                            },
                            expression: {
                                type: "array",
                                value: "*",
                                minimum: 1
                            },
                            expression_name: {
                                type: "enum",
                                values: {
                                    let: {
                                        group: "Variable binding"
                                    },
                                    var: {
                                        group: "Variable binding"
                                    },
                                    literal: {
                                        group: "Types"
                                    },
                                    array: {
                                        group: "Types"
                                    },
                                    at: {
                                        group: "Lookup"
                                    },
                                    in: {
                                        group: "Lookup"
                                    },
                                    "index-of": {
                                        group: "Lookup"
                                    },
                                    slice: {
                                        group: "Lookup"
                                    },
                                    case: {
                                        group: "Decision"
                                    },
                                    match: {
                                        group: "Decision"
                                    },
                                    coalesce: {
                                        group: "Decision"
                                    },
                                    step: {
                                        group: "Ramps, scales, curves"
                                    },
                                    interpolate: {
                                        group: "Ramps, scales, curves"
                                    },
                                    "interpolate-hcl": {
                                        group: "Ramps, scales, curves"
                                    },
                                    "interpolate-lab": {
                                        group: "Ramps, scales, curves"
                                    },
                                    ln2: {
                                        group: "Math"
                                    },
                                    pi: {
                                        group: "Math"
                                    },
                                    e: {
                                        group: "Math"
                                    },
                                    typeof: {
                                        group: "Types"
                                    },
                                    string: {
                                        group: "Types"
                                    },
                                    number: {
                                        group: "Types"
                                    },
                                    boolean: {
                                        group: "Types"
                                    },
                                    object: {
                                        group: "Types"
                                    },
                                    collator: {
                                        group: "Types"
                                    },
                                    format: {
                                        group: "Types"
                                    },
                                    image: {
                                        group: "Types"
                                    },
                                    "number-format": {
                                        group: "Types"
                                    },
                                    "to-string": {
                                        group: "Types"
                                    },
                                    "to-number": {
                                        group: "Types"
                                    },
                                    "to-boolean": {
                                        group: "Types"
                                    },
                                    "to-rgba": {
                                        group: "Color"
                                    },
                                    "to-color": {
                                        group: "Types"
                                    },
                                    rgb: {
                                        group: "Color"
                                    },
                                    rgba: {
                                        group: "Color"
                                    },
                                    get: {
                                        group: "Lookup"
                                    },
                                    has: {
                                        group: "Lookup"
                                    },
                                    length: {
                                        group: "Lookup"
                                    },
                                    properties: {
                                        group: "Feature data"
                                    },
                                    "feature-state": {
                                        group: "Feature data"
                                    },
                                    "geometry-type": {
                                        group: "Feature data"
                                    },
                                    id: {
                                        group: "Feature data"
                                    },
                                    zoom: {
                                        group: "Zoom"
                                    },
                                    "heatmap-density": {
                                        group: "Heatmap"
                                    },
                                    "line-progress": {
                                        group: "Feature data"
                                    },
                                    accumulated: {
                                        group: "Feature data"
                                    },
                                    "+": {
                                        group: "Math"
                                    },
                                    "*": {
                                        group: "Math"
                                    },
                                    "-": {
                                        group: "Math"
                                    },
                                    "/": {
                                        group: "Math"
                                    },
                                    "%": {
                                        group: "Math"
                                    },
                                    "^": {
                                        group: "Math"
                                    },
                                    sqrt: {
                                        group: "Math"
                                    },
                                    log10: {
                                        group: "Math"
                                    },
                                    ln: {
                                        group: "Math"
                                    },
                                    log2: {
                                        group: "Math"
                                    },
                                    sin: {
                                        group: "Math"
                                    },
                                    cos: {
                                        group: "Math"
                                    },
                                    tan: {
                                        group: "Math"
                                    },
                                    asin: {
                                        group: "Math"
                                    },
                                    acos: {
                                        group: "Math"
                                    },
                                    atan: {
                                        group: "Math"
                                    },
                                    min: {
                                        group: "Math"
                                    },
                                    max: {
                                        group: "Math"
                                    },
                                    round: {
                                        group: "Math"
                                    },
                                    abs: {
                                        group: "Math"
                                    },
                                    ceil: {
                                        group: "Math"
                                    },
                                    floor: {
                                        group: "Math"
                                    },
                                    distance: {
                                        group: "Math"
                                    },
                                    "==": {
                                        group: "Decision"
                                    },
                                    "!=": {
                                        group: "Decision"
                                    },
                                    ">": {
                                        group: "Decision"
                                    },
                                    "<": {
                                        group: "Decision"
                                    },
                                    ">=": {
                                        group: "Decision"
                                    },
                                    "<=": {
                                        group: "Decision"
                                    },
                                    all: {
                                        group: "Decision"
                                    },
                                    any: {
                                        group: "Decision"
                                    },
                                    "!": {
                                        group: "Decision"
                                    },
                                    within: {
                                        group: "Decision"
                                    },
                                    "is-supported-script": {
                                        group: "String"
                                    },
                                    upcase: {
                                        group: "String"
                                    },
                                    downcase: {
                                        group: "String"
                                    },
                                    concat: {
                                        group: "String"
                                    },
                                    "resolved-locale": {
                                        group: "String"
                                    }
                                }
                            },
                            light: {
                                anchor: {
                                    type: "enum",
                                    default: "viewport",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    "property-type": "data-constant",
                                    transition: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    }
                                },
                                position: {
                                    type: "array",
                                    default: [
                                        1.15,
                                        210,
                                        30
                                    ],
                                    length: 3,
                                    value: "number",
                                    "property-type": "data-constant",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    }
                                },
                                color: {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#ffffff",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                intensity: {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                }
                            },
                            paint: [
                                "paint_fill",
                                "paint_line",
                                "paint_circle",
                                "paint_heatmap",
                                "paint_fill-extrusion",
                                "paint_symbol",
                                "paint_raster",
                                "paint_hillshade",
                                "paint_background"
                            ],
                            paint_fill: {
                                "fill-antialias": {
                                    type: "boolean",
                                    default: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-outline-color": {
                                    type: "color",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-pattern"
                                        },
                                        {
                                            "fill-antialias": !0
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "fill-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                }
                            },
                            "paint_fill-extrusion": {
                                "fill-extrusion-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-extrusion-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "fill-extrusion-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                },
                                "fill-extrusion-height": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "meters",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-base": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "meters",
                                    transition: !0,
                                    requires: [
                                        "fill-extrusion-height"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-vertical-gradient": {
                                    type: "boolean",
                                    default: !0,
                                    transition: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_line: {
                                "line-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "line-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "line-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-width": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-gap-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-offset": {
                                    type: "number",
                                    default: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-dasharray": {
                                    type: "array",
                                    value: "number",
                                    minimum: 0,
                                    transition: !0,
                                    units: "line widths",
                                    requires: [
                                        {
                                            "!": "line-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "cross-faded"
                                },
                                "line-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                },
                                "line-gradient": {
                                    type: "color",
                                    transition: !1,
                                    requires: [
                                        {
                                            "!": "line-dasharray"
                                        },
                                        {
                                            "!": "line-pattern"
                                        },
                                        {
                                            source: "geojson",
                                            has: {
                                                lineMetrics: !0
                                            }
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "line-progress"
                                        ]
                                    },
                                    "property-type": "color-ramp"
                                }
                            },
                            paint_circle: {
                                "circle-radius": {
                                    type: "number",
                                    default: 5,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-blur": {
                                    type: "number",
                                    default: 0,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "circle-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-pitch-scale": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "viewport",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-stroke-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-stroke-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-stroke-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                }
                            },
                            paint_heatmap: {
                                "heatmap-radius": {
                                    type: "number",
                                    default: 30,
                                    minimum: 1,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "heatmap-weight": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "heatmap-intensity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "heatmap-color": {
                                    type: "color",
                                    default: [
                                        "interpolate",
                                        [
                                            "linear"
                                        ],
                                        [
                                            "heatmap-density"
                                        ],
                                        0,
                                        "rgba(0, 0, 255, 0)",
                                        .1,
                                        "royalblue",
                                        .3,
                                        "cyan",
                                        .5,
                                        "lime",
                                        .7,
                                        "yellow",
                                        1,
                                        "red"
                                    ],
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "heatmap-density"
                                        ]
                                    },
                                    "property-type": "color-ramp"
                                },
                                "heatmap-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_symbol: {
                                "icon-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-color": {
                                    type: "color",
                                    default: "rgba(0, 0, 0, 0)",
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "icon-image",
                                        "icon-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    overridable: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-color": {
                                    type: "color",
                                    default: "rgba(0, 0, 0, 0)",
                                    transition: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "text-field",
                                        "text-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_raster: {
                                "raster-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-hue-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    transition: !0,
                                    units: "degrees",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-brightness-min": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-brightness-max": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-saturation": {
                                    type: "number",
                                    default: 0,
                                    minimum: -1,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-contrast": {
                                    type: "number",
                                    default: 0,
                                    minimum: -1,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-resampling": {
                                    type: "enum",
                                    values: {
                                        linear: {},
                                        nearest: {}
                                    },
                                    default: "linear",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-fade-duration": {
                                    type: "number",
                                    default: 300,
                                    minimum: 0,
                                    transition: !1,
                                    units: "milliseconds",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_hillshade: {
                                "hillshade-illumination-direction": {
                                    type: "number",
                                    default: 335,
                                    minimum: 0,
                                    maximum: 359,
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-illumination-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "viewport",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-exaggeration": {
                                    type: "number",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-shadow-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-highlight-color": {
                                    type: "color",
                                    default: "#FFFFFF",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-accent-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_background: {
                                "background-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "background-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "background-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "cross-faded"
                                },
                                "background-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            transition: {
                                duration: {
                                    type: "number",
                                    default: 300,
                                    minimum: 0,
                                    units: "milliseconds"
                                },
                                delay: {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "milliseconds"
                                }
                            },
                            "property-type": {
                                "data-driven": {
                                    type: "property-type"
                                },
                                "cross-faded": {
                                    type: "property-type"
                                },
                                "cross-faded-data-driven": {
                                    type: "property-type"
                                },
                                "color-ramp": {
                                    type: "property-type"
                                },
                                "data-constant": {
                                    type: "property-type"
                                },
                                constant: {
                                    type: "property-type"
                                }
                            },
                            promoteId: {
                                "*": {
                                    type: "string"
                                }
                            }
                        }, Ct = function(t1, e1, r, n) {
                            this.message = (t1 ? t1 + ": " : "") + r, n && (this.identifier = n), null != e1 && e1.__line__ && (this.line = e1.__line__);
                        };
                        function Pt(t1) {
                            var e1 = t1.key, r = t1.value;
                            return r ? [
                                new Ct(e1, r, "constants have been deprecated as of v8")
                            ] : [];
                        }
                        function It(t1) {
                            for(var e1 = [], r = arguments.length - 1; r-- > 0;)e1[r] = arguments[r + 1];
                            for(var n = 0, i = e1; n < i.length; n += 1){
                                var a = i[n];
                                for(var o in a)t1[o] = a[o];
                            }
                            return t1;
                        }
                        function Ot(t1) {
                            return t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean ? t1.valueOf() : t1;
                        }
                        function zt(t1) {
                            if (Array.isArray(t1)) return t1.map(zt);
                            if (t1 instanceof Object && !(t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean)) {
                                var e1 = {};
                                for(var r in t1)e1[r] = zt(t1[r]);
                                return e1;
                            }
                            return Ot(t1);
                        }
                        var Dt = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, r), this.message = r, this.key = e1;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1;
                        }(Error), Rt = function(t1, e1) {
                            void 0 === e1 && (e1 = []), this.parent = t1, this.bindings = {};
                            for(var r = 0, n = e1; r < n.length; r += 1){
                                var i = n[r], a = i[0], o = i[1];
                                this.bindings[a] = o;
                            }
                        };
                        Rt.prototype.concat = function(t1) {
                            return new Rt(this, t1);
                        }, Rt.prototype.get = function(t1) {
                            if (this.bindings[t1]) return this.bindings[t1];
                            if (this.parent) return this.parent.get(t1);
                            throw new Error(t1 + " not found in scope.");
                        }, Rt.prototype.has = function(t1) {
                            return !!this.bindings[t1] || !!this.parent && this.parent.has(t1);
                        };
                        var Ft = {
                            kind: "null"
                        }, Bt = {
                            kind: "number"
                        }, Nt = {
                            kind: "string"
                        }, jt = {
                            kind: "boolean"
                        }, Ut = {
                            kind: "color"
                        }, Vt = {
                            kind: "object"
                        }, Ht = {
                            kind: "value"
                        }, qt = {
                            kind: "collator"
                        }, Gt = {
                            kind: "formatted"
                        }, Yt = {
                            kind: "resolvedImage"
                        };
                        function Wt(t1, e1) {
                            return {
                                kind: "array",
                                itemType: t1,
                                N: e1
                            };
                        }
                        function Xt(t1) {
                            if ("array" === t1.kind) {
                                var e1 = Xt(t1.itemType);
                                return "number" == typeof t1.N ? "array<" + e1 + ", " + t1.N + ">" : "value" === t1.itemType.kind ? "array" : "array<" + e1 + ">";
                            }
                            return t1.kind;
                        }
                        var Zt = [
                            Ft,
                            Bt,
                            Nt,
                            jt,
                            Ut,
                            Gt,
                            Vt,
                            Wt(Ht),
                            Yt
                        ];
                        function Jt(t1, e1) {
                            if ("error" === e1.kind) return null;
                            if ("array" === t1.kind) {
                                if ("array" === e1.kind && (0 === e1.N && "value" === e1.itemType.kind || !Jt(t1.itemType, e1.itemType)) && ("number" != typeof t1.N || t1.N === e1.N)) return null;
                            } else {
                                if (t1.kind === e1.kind) return null;
                                if ("value" === t1.kind) for(var r = 0, n = Zt; r < n.length; r += 1){
                                    if (!Jt(n[r], e1)) return null;
                                }
                            }
                            return "Expected " + Xt(t1) + " but found " + Xt(e1) + " instead.";
                        }
                        function Kt(t1, e1) {
                            return e1.some(function(e1) {
                                return e1.kind === t1.kind;
                            });
                        }
                        function Qt(t1, e1) {
                            return e1.some(function(e1) {
                                return "null" === e1 ? null === t1 : "array" === e1 ? Array.isArray(t1) : "object" === e1 ? t1 && !Array.isArray(t1) && "object" == typeof t1 : e1 === typeof t1;
                            });
                        }
                        var $t = e1(function(t1, e1) {
                            var r = {
                                transparent: [
                                    0,
                                    0,
                                    0,
                                    0
                                ],
                                aliceblue: [
                                    240,
                                    248,
                                    255,
                                    1
                                ],
                                antiquewhite: [
                                    250,
                                    235,
                                    215,
                                    1
                                ],
                                aqua: [
                                    0,
                                    255,
                                    255,
                                    1
                                ],
                                aquamarine: [
                                    127,
                                    255,
                                    212,
                                    1
                                ],
                                azure: [
                                    240,
                                    255,
                                    255,
                                    1
                                ],
                                beige: [
                                    245,
                                    245,
                                    220,
                                    1
                                ],
                                bisque: [
                                    255,
                                    228,
                                    196,
                                    1
                                ],
                                black: [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                blanchedalmond: [
                                    255,
                                    235,
                                    205,
                                    1
                                ],
                                blue: [
                                    0,
                                    0,
                                    255,
                                    1
                                ],
                                blueviolet: [
                                    138,
                                    43,
                                    226,
                                    1
                                ],
                                brown: [
                                    165,
                                    42,
                                    42,
                                    1
                                ],
                                burlywood: [
                                    222,
                                    184,
                                    135,
                                    1
                                ],
                                cadetblue: [
                                    95,
                                    158,
                                    160,
                                    1
                                ],
                                chartreuse: [
                                    127,
                                    255,
                                    0,
                                    1
                                ],
                                chocolate: [
                                    210,
                                    105,
                                    30,
                                    1
                                ],
                                coral: [
                                    255,
                                    127,
                                    80,
                                    1
                                ],
                                cornflowerblue: [
                                    100,
                                    149,
                                    237,
                                    1
                                ],
                                cornsilk: [
                                    255,
                                    248,
                                    220,
                                    1
                                ],
                                crimson: [
                                    220,
                                    20,
                                    60,
                                    1
                                ],
                                cyan: [
                                    0,
                                    255,
                                    255,
                                    1
                                ],
                                darkblue: [
                                    0,
                                    0,
                                    139,
                                    1
                                ],
                                darkcyan: [
                                    0,
                                    139,
                                    139,
                                    1
                                ],
                                darkgoldenrod: [
                                    184,
                                    134,
                                    11,
                                    1
                                ],
                                darkgray: [
                                    169,
                                    169,
                                    169,
                                    1
                                ],
                                darkgreen: [
                                    0,
                                    100,
                                    0,
                                    1
                                ],
                                darkgrey: [
                                    169,
                                    169,
                                    169,
                                    1
                                ],
                                darkkhaki: [
                                    189,
                                    183,
                                    107,
                                    1
                                ],
                                darkmagenta: [
                                    139,
                                    0,
                                    139,
                                    1
                                ],
                                darkolivegreen: [
                                    85,
                                    107,
                                    47,
                                    1
                                ],
                                darkorange: [
                                    255,
                                    140,
                                    0,
                                    1
                                ],
                                darkorchid: [
                                    153,
                                    50,
                                    204,
                                    1
                                ],
                                darkred: [
                                    139,
                                    0,
                                    0,
                                    1
                                ],
                                darksalmon: [
                                    233,
                                    150,
                                    122,
                                    1
                                ],
                                darkseagreen: [
                                    143,
                                    188,
                                    143,
                                    1
                                ],
                                darkslateblue: [
                                    72,
                                    61,
                                    139,
                                    1
                                ],
                                darkslategray: [
                                    47,
                                    79,
                                    79,
                                    1
                                ],
                                darkslategrey: [
                                    47,
                                    79,
                                    79,
                                    1
                                ],
                                darkturquoise: [
                                    0,
                                    206,
                                    209,
                                    1
                                ],
                                darkviolet: [
                                    148,
                                    0,
                                    211,
                                    1
                                ],
                                deeppink: [
                                    255,
                                    20,
                                    147,
                                    1
                                ],
                                deepskyblue: [
                                    0,
                                    191,
                                    255,
                                    1
                                ],
                                dimgray: [
                                    105,
                                    105,
                                    105,
                                    1
                                ],
                                dimgrey: [
                                    105,
                                    105,
                                    105,
                                    1
                                ],
                                dodgerblue: [
                                    30,
                                    144,
                                    255,
                                    1
                                ],
                                firebrick: [
                                    178,
                                    34,
                                    34,
                                    1
                                ],
                                floralwhite: [
                                    255,
                                    250,
                                    240,
                                    1
                                ],
                                forestgreen: [
                                    34,
                                    139,
                                    34,
                                    1
                                ],
                                fuchsia: [
                                    255,
                                    0,
                                    255,
                                    1
                                ],
                                gainsboro: [
                                    220,
                                    220,
                                    220,
                                    1
                                ],
                                ghostwhite: [
                                    248,
                                    248,
                                    255,
                                    1
                                ],
                                gold: [
                                    255,
                                    215,
                                    0,
                                    1
                                ],
                                goldenrod: [
                                    218,
                                    165,
                                    32,
                                    1
                                ],
                                gray: [
                                    128,
                                    128,
                                    128,
                                    1
                                ],
                                green: [
                                    0,
                                    128,
                                    0,
                                    1
                                ],
                                greenyellow: [
                                    173,
                                    255,
                                    47,
                                    1
                                ],
                                grey: [
                                    128,
                                    128,
                                    128,
                                    1
                                ],
                                honeydew: [
                                    240,
                                    255,
                                    240,
                                    1
                                ],
                                hotpink: [
                                    255,
                                    105,
                                    180,
                                    1
                                ],
                                indianred: [
                                    205,
                                    92,
                                    92,
                                    1
                                ],
                                indigo: [
                                    75,
                                    0,
                                    130,
                                    1
                                ],
                                ivory: [
                                    255,
                                    255,
                                    240,
                                    1
                                ],
                                khaki: [
                                    240,
                                    230,
                                    140,
                                    1
                                ],
                                lavender: [
                                    230,
                                    230,
                                    250,
                                    1
                                ],
                                lavenderblush: [
                                    255,
                                    240,
                                    245,
                                    1
                                ],
                                lawngreen: [
                                    124,
                                    252,
                                    0,
                                    1
                                ],
                                lemonchiffon: [
                                    255,
                                    250,
                                    205,
                                    1
                                ],
                                lightblue: [
                                    173,
                                    216,
                                    230,
                                    1
                                ],
                                lightcoral: [
                                    240,
                                    128,
                                    128,
                                    1
                                ],
                                lightcyan: [
                                    224,
                                    255,
                                    255,
                                    1
                                ],
                                lightgoldenrodyellow: [
                                    250,
                                    250,
                                    210,
                                    1
                                ],
                                lightgray: [
                                    211,
                                    211,
                                    211,
                                    1
                                ],
                                lightgreen: [
                                    144,
                                    238,
                                    144,
                                    1
                                ],
                                lightgrey: [
                                    211,
                                    211,
                                    211,
                                    1
                                ],
                                lightpink: [
                                    255,
                                    182,
                                    193,
                                    1
                                ],
                                lightsalmon: [
                                    255,
                                    160,
                                    122,
                                    1
                                ],
                                lightseagreen: [
                                    32,
                                    178,
                                    170,
                                    1
                                ],
                                lightskyblue: [
                                    135,
                                    206,
                                    250,
                                    1
                                ],
                                lightslategray: [
                                    119,
                                    136,
                                    153,
                                    1
                                ],
                                lightslategrey: [
                                    119,
                                    136,
                                    153,
                                    1
                                ],
                                lightsteelblue: [
                                    176,
                                    196,
                                    222,
                                    1
                                ],
                                lightyellow: [
                                    255,
                                    255,
                                    224,
                                    1
                                ],
                                lime: [
                                    0,
                                    255,
                                    0,
                                    1
                                ],
                                limegreen: [
                                    50,
                                    205,
                                    50,
                                    1
                                ],
                                linen: [
                                    250,
                                    240,
                                    230,
                                    1
                                ],
                                magenta: [
                                    255,
                                    0,
                                    255,
                                    1
                                ],
                                maroon: [
                                    128,
                                    0,
                                    0,
                                    1
                                ],
                                mediumaquamarine: [
                                    102,
                                    205,
                                    170,
                                    1
                                ],
                                mediumblue: [
                                    0,
                                    0,
                                    205,
                                    1
                                ],
                                mediumorchid: [
                                    186,
                                    85,
                                    211,
                                    1
                                ],
                                mediumpurple: [
                                    147,
                                    112,
                                    219,
                                    1
                                ],
                                mediumseagreen: [
                                    60,
                                    179,
                                    113,
                                    1
                                ],
                                mediumslateblue: [
                                    123,
                                    104,
                                    238,
                                    1
                                ],
                                mediumspringgreen: [
                                    0,
                                    250,
                                    154,
                                    1
                                ],
                                mediumturquoise: [
                                    72,
                                    209,
                                    204,
                                    1
                                ],
                                mediumvioletred: [
                                    199,
                                    21,
                                    133,
                                    1
                                ],
                                midnightblue: [
                                    25,
                                    25,
                                    112,
                                    1
                                ],
                                mintcream: [
                                    245,
                                    255,
                                    250,
                                    1
                                ],
                                mistyrose: [
                                    255,
                                    228,
                                    225,
                                    1
                                ],
                                moccasin: [
                                    255,
                                    228,
                                    181,
                                    1
                                ],
                                navajowhite: [
                                    255,
                                    222,
                                    173,
                                    1
                                ],
                                navy: [
                                    0,
                                    0,
                                    128,
                                    1
                                ],
                                oldlace: [
                                    253,
                                    245,
                                    230,
                                    1
                                ],
                                olive: [
                                    128,
                                    128,
                                    0,
                                    1
                                ],
                                olivedrab: [
                                    107,
                                    142,
                                    35,
                                    1
                                ],
                                orange: [
                                    255,
                                    165,
                                    0,
                                    1
                                ],
                                orangered: [
                                    255,
                                    69,
                                    0,
                                    1
                                ],
                                orchid: [
                                    218,
                                    112,
                                    214,
                                    1
                                ],
                                palegoldenrod: [
                                    238,
                                    232,
                                    170,
                                    1
                                ],
                                palegreen: [
                                    152,
                                    251,
                                    152,
                                    1
                                ],
                                paleturquoise: [
                                    175,
                                    238,
                                    238,
                                    1
                                ],
                                palevioletred: [
                                    219,
                                    112,
                                    147,
                                    1
                                ],
                                papayawhip: [
                                    255,
                                    239,
                                    213,
                                    1
                                ],
                                peachpuff: [
                                    255,
                                    218,
                                    185,
                                    1
                                ],
                                peru: [
                                    205,
                                    133,
                                    63,
                                    1
                                ],
                                pink: [
                                    255,
                                    192,
                                    203,
                                    1
                                ],
                                plum: [
                                    221,
                                    160,
                                    221,
                                    1
                                ],
                                powderblue: [
                                    176,
                                    224,
                                    230,
                                    1
                                ],
                                purple: [
                                    128,
                                    0,
                                    128,
                                    1
                                ],
                                rebeccapurple: [
                                    102,
                                    51,
                                    153,
                                    1
                                ],
                                red: [
                                    255,
                                    0,
                                    0,
                                    1
                                ],
                                rosybrown: [
                                    188,
                                    143,
                                    143,
                                    1
                                ],
                                royalblue: [
                                    65,
                                    105,
                                    225,
                                    1
                                ],
                                saddlebrown: [
                                    139,
                                    69,
                                    19,
                                    1
                                ],
                                salmon: [
                                    250,
                                    128,
                                    114,
                                    1
                                ],
                                sandybrown: [
                                    244,
                                    164,
                                    96,
                                    1
                                ],
                                seagreen: [
                                    46,
                                    139,
                                    87,
                                    1
                                ],
                                seashell: [
                                    255,
                                    245,
                                    238,
                                    1
                                ],
                                sienna: [
                                    160,
                                    82,
                                    45,
                                    1
                                ],
                                silver: [
                                    192,
                                    192,
                                    192,
                                    1
                                ],
                                skyblue: [
                                    135,
                                    206,
                                    235,
                                    1
                                ],
                                slateblue: [
                                    106,
                                    90,
                                    205,
                                    1
                                ],
                                slategray: [
                                    112,
                                    128,
                                    144,
                                    1
                                ],
                                slategrey: [
                                    112,
                                    128,
                                    144,
                                    1
                                ],
                                snow: [
                                    255,
                                    250,
                                    250,
                                    1
                                ],
                                springgreen: [
                                    0,
                                    255,
                                    127,
                                    1
                                ],
                                steelblue: [
                                    70,
                                    130,
                                    180,
                                    1
                                ],
                                tan: [
                                    210,
                                    180,
                                    140,
                                    1
                                ],
                                teal: [
                                    0,
                                    128,
                                    128,
                                    1
                                ],
                                thistle: [
                                    216,
                                    191,
                                    216,
                                    1
                                ],
                                tomato: [
                                    255,
                                    99,
                                    71,
                                    1
                                ],
                                turquoise: [
                                    64,
                                    224,
                                    208,
                                    1
                                ],
                                violet: [
                                    238,
                                    130,
                                    238,
                                    1
                                ],
                                wheat: [
                                    245,
                                    222,
                                    179,
                                    1
                                ],
                                white: [
                                    255,
                                    255,
                                    255,
                                    1
                                ],
                                whitesmoke: [
                                    245,
                                    245,
                                    245,
                                    1
                                ],
                                yellow: [
                                    255,
                                    255,
                                    0,
                                    1
                                ],
                                yellowgreen: [
                                    154,
                                    205,
                                    50,
                                    1
                                ]
                            };
                            function n(t1) {
                                return (t1 = Math.round(t1)) < 0 ? 0 : t1 > 255 ? 255 : t1;
                            }
                            function i(t1) {
                                return t1 < 0 ? 0 : t1 > 1 ? 1 : t1;
                            }
                            function a(t1) {
                                return "%" === t1[t1.length - 1] ? n(parseFloat(t1) / 100 * 255) : n(parseInt(t1));
                            }
                            function o(t1) {
                                return "%" === t1[t1.length - 1] ? i(parseFloat(t1) / 100) : i(parseFloat(t1));
                            }
                            function s(t1, e1, r) {
                                return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? t1 + (e1 - t1) * r * 6 : 2 * r < 1 ? e1 : 3 * r < 2 ? t1 + (e1 - t1) * (2 / 3 - r) * 6 : t1;
                            }
                            try {
                                e1.parseCSSColor = function(t1) {
                                    var e1, i = t1.replace(/ /g, "").toLowerCase();
                                    if (i in r) return r[i].slice();
                                    if ("#" === i[0]) return 4 === i.length ? (e1 = parseInt(i.substr(1), 16)) >= 0 && e1 <= 4095 ? [
                                        (3840 & e1) >> 4 | (3840 & e1) >> 8,
                                        240 & e1 | (240 & e1) >> 4,
                                        15 & e1 | (15 & e1) << 4,
                                        1
                                    ] : null : 7 === i.length && (e1 = parseInt(i.substr(1), 16)) >= 0 && e1 <= 16777215 ? [
                                        (16711680 & e1) >> 16,
                                        (65280 & e1) >> 8,
                                        255 & e1,
                                        1
                                    ] : null;
                                    var l = i.indexOf("("), c = i.indexOf(")");
                                    if (-1 !== l && c + 1 === i.length) {
                                        var u = i.substr(0, l), f = i.substr(l + 1, c - (l + 1)).split(","), h = 1;
                                        switch(u){
                                            case "rgba":
                                                if (4 !== f.length) return null;
                                                h = o(f.pop());
                                            case "rgb":
                                                return 3 !== f.length ? null : [
                                                    a(f[0]),
                                                    a(f[1]),
                                                    a(f[2]),
                                                    h
                                                ];
                                            case "hsla":
                                                if (4 !== f.length) return null;
                                                h = o(f.pop());
                                            case "hsl":
                                                if (3 !== f.length) return null;
                                                var p = (parseFloat(f[0]) % 360 + 360) % 360 / 360, d = o(f[1]), m = o(f[2]), g = m <= .5 ? m * (d + 1) : m + d - m * d, v = 2 * m - g;
                                                return [
                                                    n(255 * s(v, g, p + 1 / 3)),
                                                    n(255 * s(v, g, p)),
                                                    n(255 * s(v, g, p - 1 / 3)),
                                                    h
                                                ];
                                            default:
                                                return null;
                                        }
                                    }
                                    return null;
                                };
                            } catch (t1) {}
                        }).parseCSSColor, te = function(t1, e1, r, n) {
                            void 0 === n && (n = 1), this.r = t1, this.g = e1, this.b = r, this.a = n;
                        };
                        te.parse = function(t1) {
                            if (t1) {
                                if (t1 instanceof te) return t1;
                                if ("string" == typeof t1) {
                                    var e1 = $t(t1);
                                    if (e1) return new te(e1[0] / 255 * e1[3], e1[1] / 255 * e1[3], e1[2] / 255 * e1[3], e1[3]);
                                }
                            }
                        }, te.prototype.toString = function() {
                            var t1 = this.toArray(), e1 = t1[0], r = t1[1], n = t1[2], i = t1[3];
                            return "rgba(" + Math.round(e1) + "," + Math.round(r) + "," + Math.round(n) + "," + i + ")";
                        }, te.prototype.toArray = function() {
                            var t1 = this.r, e1 = this.g, r = this.b, n = this.a;
                            return 0 === n ? [
                                0,
                                0,
                                0,
                                0
                            ] : [
                                255 * t1 / n,
                                255 * e1 / n,
                                255 * r / n,
                                n
                            ];
                        }, te.black = new te(0, 0, 0, 1), te.white = new te(1, 1, 1, 1), te.transparent = new te(0, 0, 0, 0), te.red = new te(1, 0, 0, 1);
                        var ee = function(t1, e1, r) {
                            this.sensitivity = t1 ? e1 ? "variant" : "case" : e1 ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                                sensitivity: this.sensitivity,
                                usage: "search"
                            });
                        };
                        ee.prototype.compare = function(t1, e1) {
                            return this.collator.compare(t1, e1);
                        }, ee.prototype.resolvedLocale = function() {
                            return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
                        };
                        var re = function(t1, e1, r, n, i) {
                            this.text = t1, this.image = e1, this.scale = r, this.fontStack = n, this.textColor = i;
                        }, ne = function(t1) {
                            this.sections = t1;
                        };
                        ne.fromString = function(t1) {
                            return new ne([
                                new re(t1, null, null, null, null)
                            ]);
                        }, ne.prototype.isEmpty = function() {
                            return 0 === this.sections.length || !this.sections.some(function(t1) {
                                return 0 !== t1.text.length || t1.image && 0 !== t1.image.name.length;
                            });
                        }, ne.factory = function(t1) {
                            return t1 instanceof ne ? t1 : ne.fromString(t1);
                        }, ne.prototype.toString = function() {
                            return 0 === this.sections.length ? "" : this.sections.map(function(t1) {
                                return t1.text;
                            }).join("");
                        }, ne.prototype.serialize = function() {
                            for(var t1 = [
                                "format"
                            ], e1 = 0, r = this.sections; e1 < r.length; e1 += 1){
                                var n = r[e1];
                                if (n.image) t1.push([
                                    "image",
                                    n.image.name
                                ]);
                                else {
                                    t1.push(n.text);
                                    var i = {};
                                    n.fontStack && (i["text-font"] = [
                                        "literal",
                                        n.fontStack.split(",")
                                    ]), n.scale && (i["font-scale"] = n.scale), n.textColor && (i["text-color"] = [
                                        "rgba"
                                    ].concat(n.textColor.toArray())), t1.push(i);
                                }
                            }
                            return t1;
                        };
                        var ie = function(t1) {
                            this.name = t1.name, this.available = t1.available;
                        };
                        function ae(t1, e1, r, n) {
                            return "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : "Invalid rgba value [" + [
                                t1,
                                e1,
                                r,
                                n
                            ].join(", ") + "]: 'a' must be between 0 and 1." : "Invalid rgba value [" + ("number" == typeof n ? [
                                t1,
                                e1,
                                r,
                                n
                            ] : [
                                t1,
                                e1,
                                r
                            ]).join(", ") + "]: 'r', 'g', and 'b' must be between 0 and 255.";
                        }
                        function oe(t1) {
                            if (null === t1) return !0;
                            if ("string" == typeof t1) return !0;
                            if ("boolean" == typeof t1) return !0;
                            if ("number" == typeof t1) return !0;
                            if (t1 instanceof te) return !0;
                            if (t1 instanceof ee) return !0;
                            if (t1 instanceof ne) return !0;
                            if (t1 instanceof ie) return !0;
                            if (Array.isArray(t1)) {
                                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                                    if (!oe(r[e1])) return !1;
                                }
                                return !0;
                            }
                            if ("object" == typeof t1) {
                                for(var n in t1)if (!oe(t1[n])) return !1;
                                return !0;
                            }
                            return !1;
                        }
                        function se(t1) {
                            if (null === t1) return Ft;
                            if ("string" == typeof t1) return Nt;
                            if ("boolean" == typeof t1) return jt;
                            if ("number" == typeof t1) return Bt;
                            if (t1 instanceof te) return Ut;
                            if (t1 instanceof ee) return qt;
                            if (t1 instanceof ne) return Gt;
                            if (t1 instanceof ie) return Yt;
                            if (Array.isArray(t1)) {
                                for(var e1, r = t1.length, n = 0, i = t1; n < i.length; n += 1){
                                    var a = se(i[n]);
                                    if (e1) {
                                        if (e1 === a) continue;
                                        e1 = Ht;
                                        break;
                                    }
                                    e1 = a;
                                }
                                return Wt(e1 || Ht, r);
                            }
                            return Vt;
                        }
                        function le(t1) {
                            var e1 = typeof t1;
                            return null === t1 ? "" : "string" === e1 || "number" === e1 || "boolean" === e1 ? String(t1) : t1 instanceof te || t1 instanceof ne || t1 instanceof ie ? t1.toString() : JSON.stringify(t1);
                        }
                        ie.prototype.toString = function() {
                            return this.name;
                        }, ie.fromString = function(t1) {
                            return t1 ? new ie({
                                name: t1,
                                available: !1
                            }) : null;
                        }, ie.prototype.serialize = function() {
                            return [
                                "image",
                                this.name
                            ];
                        };
                        var ce = function(t1, e1) {
                            this.type = t1, this.value = e1;
                        };
                        ce.parse = function(t1, e1) {
                            if (2 !== t1.length) return e1.error("'literal' expression requires exactly one argument, but found " + (t1.length - 1) + " instead.");
                            if (!oe(t1[1])) return e1.error("invalid value");
                            var r = t1[1], n = se(r), i = e1.expectedType;
                            return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new ce(n, r);
                        }, ce.prototype.evaluate = function() {
                            return this.value;
                        }, ce.prototype.eachChild = function() {}, ce.prototype.outputDefined = function() {
                            return !0;
                        }, ce.prototype.serialize = function() {
                            return "array" === this.type.kind || "object" === this.type.kind ? [
                                "literal",
                                this.value
                            ] : this.value instanceof te ? [
                                "rgba"
                            ].concat(this.value.toArray()) : this.value instanceof ne ? this.value.serialize() : this.value;
                        };
                        var ue = function(t1) {
                            this.name = "ExpressionEvaluationError", this.message = t1;
                        };
                        ue.prototype.toJSON = function() {
                            return this.message;
                        };
                        var fe = {
                            string: Nt,
                            number: Bt,
                            boolean: jt,
                            object: Vt
                        }, he = function(t1, e1) {
                            this.type = t1, this.args = e1;
                        };
                        he.parse = function(t1, e1) {
                            if (t1.length < 2) return e1.error("Expected at least one argument.");
                            var r, n = 1, i = t1[0];
                            if ("array" === i) {
                                var a, o;
                                if (t1.length > 2) {
                                    var s = t1[1];
                                    if ("string" != typeof s || !(s in fe) || "object" === s) return e1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                                    a = fe[s], n++;
                                } else a = Ht;
                                if (t1.length > 3) {
                                    if (null !== t1[2] && ("number" != typeof t1[2] || t1[2] < 0 || t1[2] !== Math.floor(t1[2]))) return e1.error('The length argument to "array" must be a positive integer literal', 2);
                                    o = t1[2], n++;
                                }
                                r = Wt(a, o);
                            } else r = fe[i];
                            for(var l = []; n < t1.length; n++){
                                var c = e1.parse(t1[n], n, Ht);
                                if (!c) return null;
                                l.push(c);
                            }
                            return new he(r, l);
                        }, he.prototype.evaluate = function(t1) {
                            for(var e1 = 0; e1 < this.args.length; e1++){
                                var r = this.args[e1].evaluate(t1);
                                if (!Jt(this.type, se(r))) return r;
                                if (e1 === this.args.length - 1) throw new ue("Expected value to be of type " + Xt(this.type) + ", but found " + Xt(se(r)) + " instead.");
                            }
                            return null;
                        }, he.prototype.eachChild = function(t1) {
                            this.args.forEach(t1);
                        }, he.prototype.outputDefined = function() {
                            return this.args.every(function(t1) {
                                return t1.outputDefined();
                            });
                        }, he.prototype.serialize = function() {
                            var t1 = this.type, e1 = [
                                t1.kind
                            ];
                            if ("array" === t1.kind) {
                                var r = t1.itemType;
                                if ("string" === r.kind || "number" === r.kind || "boolean" === r.kind) {
                                    e1.push(r.kind);
                                    var n = t1.N;
                                    ("number" == typeof n || this.args.length > 1) && e1.push(n);
                                }
                            }
                            return e1.concat(this.args.map(function(t1) {
                                return t1.serialize();
                            }));
                        };
                        var pe = function(t1) {
                            this.type = Gt, this.sections = t1;
                        };
                        pe.parse = function(t1, e1) {
                            if (t1.length < 2) return e1.error("Expected at least one argument.");
                            var r = t1[1];
                            if (!Array.isArray(r) && "object" == typeof r) return e1.error("First argument must be an image or text section.");
                            for(var n = [], i = !1, a = 1; a <= t1.length - 1; ++a){
                                var o = t1[a];
                                if (i && "object" == typeof o && !Array.isArray(o)) {
                                    i = !1;
                                    var s = null;
                                    if (o["font-scale"] && !(s = e1.parse(o["font-scale"], 1, Bt))) return null;
                                    var l = null;
                                    if (o["text-font"] && !(l = e1.parse(o["text-font"], 1, Wt(Nt)))) return null;
                                    var c = null;
                                    if (o["text-color"] && !(c = e1.parse(o["text-color"], 1, Ut))) return null;
                                    var u = n[n.length - 1];
                                    u.scale = s, u.font = l, u.textColor = c;
                                } else {
                                    var f = e1.parse(t1[a], 1, Ht);
                                    if (!f) return null;
                                    var h = f.type.kind;
                                    if ("string" !== h && "value" !== h && "null" !== h && "resolvedImage" !== h) return e1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                                    i = !0, n.push({
                                        content: f,
                                        scale: null,
                                        font: null,
                                        textColor: null
                                    });
                                }
                            }
                            return new pe(n);
                        }, pe.prototype.evaluate = function(t1) {
                            return new ne(this.sections.map(function(e1) {
                                var r = e1.content.evaluate(t1);
                                return se(r) === Yt ? new re("", r, null, null, null) : new re(le(r), null, e1.scale ? e1.scale.evaluate(t1) : null, e1.font ? e1.font.evaluate(t1).join(",") : null, e1.textColor ? e1.textColor.evaluate(t1) : null);
                            }));
                        }, pe.prototype.eachChild = function(t1) {
                            for(var e1 = 0, r = this.sections; e1 < r.length; e1 += 1){
                                var n = r[e1];
                                t1(n.content), n.scale && t1(n.scale), n.font && t1(n.font), n.textColor && t1(n.textColor);
                            }
                        }, pe.prototype.outputDefined = function() {
                            return !1;
                        }, pe.prototype.serialize = function() {
                            for(var t1 = [
                                "format"
                            ], e1 = 0, r = this.sections; e1 < r.length; e1 += 1){
                                var n = r[e1];
                                t1.push(n.content.serialize());
                                var i = {};
                                n.scale && (i["font-scale"] = n.scale.serialize()), n.font && (i["text-font"] = n.font.serialize()), n.textColor && (i["text-color"] = n.textColor.serialize()), t1.push(i);
                            }
                            return t1;
                        };
                        var de = function(t1) {
                            this.type = Yt, this.input = t1;
                        };
                        de.parse = function(t1, e1) {
                            if (2 !== t1.length) return e1.error("Expected two arguments.");
                            var r = e1.parse(t1[1], 1, Nt);
                            return r ? new de(r) : e1.error("No image name provided.");
                        }, de.prototype.evaluate = function(t1) {
                            var e1 = this.input.evaluate(t1), r = ie.fromString(e1);
                            return r && t1.availableImages && (r.available = t1.availableImages.indexOf(e1) > -1), r;
                        }, de.prototype.eachChild = function(t1) {
                            t1(this.input);
                        }, de.prototype.outputDefined = function() {
                            return !1;
                        }, de.prototype.serialize = function() {
                            return [
                                "image",
                                this.input.serialize()
                            ];
                        };
                        var me = {
                            "to-boolean": jt,
                            "to-color": Ut,
                            "to-number": Bt,
                            "to-string": Nt
                        }, ge = function(t1, e1) {
                            this.type = t1, this.args = e1;
                        };
                        ge.parse = function(t1, e1) {
                            if (t1.length < 2) return e1.error("Expected at least one argument.");
                            var r = t1[0];
                            if (("to-boolean" === r || "to-string" === r) && 2 !== t1.length) return e1.error("Expected one argument.");
                            for(var n = me[r], i = [], a = 1; a < t1.length; a++){
                                var o = e1.parse(t1[a], a, Ht);
                                if (!o) return null;
                                i.push(o);
                            }
                            return new ge(n, i);
                        }, ge.prototype.evaluate = function(t1) {
                            if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t1));
                            if ("color" === this.type.kind) {
                                for(var e1, r, n = 0, i = this.args; n < i.length; n += 1){
                                    if (r = null, (e1 = i[n].evaluate(t1)) instanceof te) return e1;
                                    if ("string" == typeof e1) {
                                        var a = t1.parseColor(e1);
                                        if (a) return a;
                                    } else if (Array.isArray(e1) && !(r = e1.length < 3 || e1.length > 4 ? "Invalid rbga value " + JSON.stringify(e1) + ": expected an array containing either three or four numeric values." : ae(e1[0], e1[1], e1[2], e1[3]))) return new te(e1[0] / 255, e1[1] / 255, e1[2] / 255, e1[3]);
                                }
                                throw new ue(r || "Could not parse color from value '" + ("string" == typeof e1 ? e1 : String(JSON.stringify(e1))) + "'");
                            }
                            if ("number" === this.type.kind) {
                                for(var o = null, s = 0, l = this.args; s < l.length; s += 1){
                                    if (null === (o = l[s].evaluate(t1))) return 0;
                                    var c = Number(o);
                                    if (!isNaN(c)) return c;
                                }
                                throw new ue("Could not convert " + JSON.stringify(o) + " to number.");
                            }
                            return "formatted" === this.type.kind ? ne.fromString(le(this.args[0].evaluate(t1))) : "resolvedImage" === this.type.kind ? ie.fromString(le(this.args[0].evaluate(t1))) : le(this.args[0].evaluate(t1));
                        }, ge.prototype.eachChild = function(t1) {
                            this.args.forEach(t1);
                        }, ge.prototype.outputDefined = function() {
                            return this.args.every(function(t1) {
                                return t1.outputDefined();
                            });
                        }, ge.prototype.serialize = function() {
                            if ("formatted" === this.type.kind) return new pe([
                                {
                                    content: this.args[0],
                                    scale: null,
                                    font: null,
                                    textColor: null
                                }
                            ]).serialize();
                            if ("resolvedImage" === this.type.kind) return new de(this.args[0]).serialize();
                            var t1 = [
                                "to-" + this.type.kind
                            ];
                            return this.eachChild(function(e1) {
                                t1.push(e1.serialize());
                            }), t1;
                        };
                        var ve = [
                            "Unknown",
                            "Point",
                            "LineString",
                            "Polygon"
                        ], ye = function() {
                            this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
                        };
                        ye.prototype.id = function() {
                            return this.feature && "id" in this.feature ? this.feature.id : null;
                        }, ye.prototype.geometryType = function() {
                            return this.feature ? "number" == typeof this.feature.type ? ve[this.feature.type] : this.feature.type : null;
                        }, ye.prototype.geometry = function() {
                            return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
                        }, ye.prototype.canonicalID = function() {
                            return this.canonical;
                        }, ye.prototype.properties = function() {
                            return this.feature && this.feature.properties || {};
                        }, ye.prototype.parseColor = function(t1) {
                            var e1 = this._parseColorCache[t1];
                            return e1 || (e1 = this._parseColorCache[t1] = te.parse(t1)), e1;
                        };
                        var xe = function(t1, e1, r, n) {
                            this.name = t1, this.type = e1, this._evaluate = r, this.args = n;
                        };
                        xe.prototype.evaluate = function(t1) {
                            return this._evaluate(t1, this.args);
                        }, xe.prototype.eachChild = function(t1) {
                            this.args.forEach(t1);
                        }, xe.prototype.outputDefined = function() {
                            return !1;
                        }, xe.prototype.serialize = function() {
                            return [
                                this.name
                            ].concat(this.args.map(function(t1) {
                                return t1.serialize();
                            }));
                        }, xe.parse = function(t1, e1) {
                            var r, n = t1[0], i = xe.definitions[n];
                            if (!i) return e1.error('Unknown expression "' + n + '". If you wanted a literal array, use ["literal", [...]].', 0);
                            for(var a = Array.isArray(i) ? i[0] : i.type, o = Array.isArray(i) ? [
                                [
                                    i[1],
                                    i[2]
                                ]
                            ] : i.overloads, s = o.filter(function(e1) {
                                var r = e1[0];
                                return !Array.isArray(r) || r.length === t1.length - 1;
                            }), l = null, c = 0, u = s; c < u.length; c += 1){
                                var f = u[c], h = f[0], p = f[1];
                                l = new Ue(e1.registry, e1.path, null, e1.scope);
                                for(var d = [], m = !1, g = 1; g < t1.length; g++){
                                    var v = t1[g], y = Array.isArray(h) ? h[g - 1] : h.type, x = l.parse(v, 1 + d.length, y);
                                    if (!x) {
                                        m = !0;
                                        break;
                                    }
                                    d.push(x);
                                }
                                if (!m) {
                                    if (Array.isArray(h) && h.length !== d.length) l.error("Expected " + h.length + " arguments, but found " + d.length + " instead.");
                                    else {
                                        for(var b = 0; b < d.length; b++){
                                            var _ = Array.isArray(h) ? h[b] : h.type, w = d[b];
                                            l.concat(b + 1).checkSubtype(_, w.type);
                                        }
                                        if (0 === l.errors.length) return new xe(n, a, p, d);
                                    }
                                }
                            }
                            if (1 === s.length) (r = e1.errors).push.apply(r, l.errors);
                            else {
                                for(var T = (s.length ? s : o).map(function(t1) {
                                    var e1, r = t1[0];
                                    return e1 = r, Array.isArray(e1) ? "(" + e1.map(Xt).join(", ") + ")" : "(" + Xt(e1.type) + "...)";
                                }).join(" | "), k = [], A = 1; A < t1.length; A++){
                                    var M = e1.parse(t1[A], 1 + k.length);
                                    if (!M) return null;
                                    k.push(Xt(M.type));
                                }
                                e1.error("Expected arguments of type " + T + ", but found (" + k.join(", ") + ") instead.");
                            }
                            return null;
                        }, xe.register = function(t1, e1) {
                            for(var r in xe.definitions = e1, e1)t1[r] = xe;
                        };
                        var be = function(t1, e1, r) {
                            this.type = qt, this.locale = r, this.caseSensitive = t1, this.diacriticSensitive = e1;
                        };
                        be.parse = function(t1, e1) {
                            if (2 !== t1.length) return e1.error("Expected one argument.");
                            var r = t1[1];
                            if ("object" != typeof r || Array.isArray(r)) return e1.error("Collator options argument must be an object.");
                            var n = e1.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, jt);
                            if (!n) return null;
                            var i = e1.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, jt);
                            if (!i) return null;
                            var a = null;
                            return r.locale && !(a = e1.parse(r.locale, 1, Nt)) ? null : new be(n, i, a);
                        }, be.prototype.evaluate = function(t1) {
                            return new ee(this.caseSensitive.evaluate(t1), this.diacriticSensitive.evaluate(t1), this.locale ? this.locale.evaluate(t1) : null);
                        }, be.prototype.eachChild = function(t1) {
                            t1(this.caseSensitive), t1(this.diacriticSensitive), this.locale && t1(this.locale);
                        }, be.prototype.outputDefined = function() {
                            return !1;
                        }, be.prototype.serialize = function() {
                            var t1 = {};
                            return t1["case-sensitive"] = this.caseSensitive.serialize(), t1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t1.locale = this.locale.serialize()), [
                                "collator",
                                t1
                            ];
                        };
                        function _e(t1, e1) {
                            t1[0] = Math.min(t1[0], e1[0]), t1[1] = Math.min(t1[1], e1[1]), t1[2] = Math.max(t1[2], e1[0]), t1[3] = Math.max(t1[3], e1[1]);
                        }
                        function we(t1, e1) {
                            return !(t1[0] <= e1[0]) && !(t1[2] >= e1[2]) && !(t1[1] <= e1[1]) && !(t1[3] >= e1[3]);
                        }
                        function Te(t1, e1) {
                            var r, n = (180 + t1[0]) / 360, i = (r = t1[1], (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + r * Math.PI / 360))) / 360), a = Math.pow(2, e1.z);
                            return [
                                Math.round(n * a * 8192),
                                Math.round(i * a * 8192)
                            ];
                        }
                        function ke(t1, e1, r) {
                            return e1[1] > t1[1] != r[1] > t1[1] && t1[0] < (r[0] - e1[0]) * (t1[1] - e1[1]) / (r[1] - e1[1]) + e1[0];
                        }
                        function Ae(t1, e1) {
                            for(var r, n, i, a, o, s, l, c = !1, u = 0, f = e1.length; u < f; u++)for(var h = e1[u], p = 0, d = h.length; p < d - 1; p++){
                                if (r = t1, n = h[p], i = h[p + 1], a = void 0, o = void 0, s = void 0, l = void 0, a = r[0] - n[0], o = r[1] - n[1], s = r[0] - i[0], l = r[1] - i[1], a * l - s * o == 0 && a * s <= 0 && o * l <= 0) return !1;
                                ke(t1, h[p], h[p + 1]) && (c = !c);
                            }
                            return c;
                        }
                        function Me(t1, e1) {
                            for(var r = 0; r < e1.length; r++)if (Ae(t1, e1[r])) return !0;
                            return !1;
                        }
                        function Se(t1, e1, r, n) {
                            var i = t1[0] - r[0], a = t1[1] - r[1], o = e1[0] - r[0], s = e1[1] - r[1], l = n[0] - r[0], c = n[1] - r[1], u = i * c - l * a, f = o * c - l * s;
                            return u > 0 && f < 0 || u < 0 && f > 0;
                        }
                        function Ee(t1, e1, r) {
                            for(var n = 0, i = r; n < i.length; n += 1)for(var a = i[n], o = 0; o < a.length - 1; ++o)if (s = t1, l = e1, c = a[o], u = a[o + 1], f = void 0, h = void 0, p = void 0, d = void 0, p = [
                                l[0] - s[0],
                                l[1] - s[1]
                            ], d = [
                                u[0] - c[0],
                                u[1] - c[1]
                            ], 0 != (f = d)[0] * (h = p)[1] - f[1] * h[0] && Se(s, l, c, u) && Se(c, u, s, l)) return !0;
                            var s, l, c, u, f, h, p, d;
                            return !1;
                        }
                        function Le(t1, e1) {
                            for(var r = 0; r < t1.length; ++r)if (!Ae(t1[r], e1)) return !1;
                            for(var n = 0; n < t1.length - 1; ++n)if (Ee(t1[n], t1[n + 1], e1)) return !1;
                            return !0;
                        }
                        function Ce(t1, e1) {
                            for(var r = 0; r < e1.length; r++)if (Le(t1, e1[r])) return !0;
                            return !1;
                        }
                        function Pe(t1, e1, r) {
                            for(var n = [], i = 0; i < t1.length; i++){
                                for(var a = [], o = 0; o < t1[i].length; o++){
                                    var s = Te(t1[i][o], r);
                                    _e(e1, s), a.push(s);
                                }
                                n.push(a);
                            }
                            return n;
                        }
                        function Ie(t1, e1, r) {
                            for(var n = [], i = 0; i < t1.length; i++){
                                var a = Pe(t1[i], e1, r);
                                n.push(a);
                            }
                            return n;
                        }
                        function Oe(t1, e1, r, n) {
                            if (t1[0] < r[0] || t1[0] > r[2]) {
                                var i = .5 * n, a = t1[0] - r[0] > i ? -n : r[0] - t1[0] > i ? n : 0;
                                0 === a && (a = t1[0] - r[2] > i ? -n : r[2] - t1[0] > i ? n : 0), t1[0] += a;
                            }
                            _e(e1, t1);
                        }
                        function ze(t1, e1, r, n) {
                            for(var i = 8192 * Math.pow(2, n.z), a = [
                                8192 * n.x,
                                8192 * n.y
                            ], o = [], s = 0, l = t1; s < l.length; s += 1)for(var c = 0, u = l[s]; c < u.length; c += 1){
                                var f = u[c], h = [
                                    f.x + a[0],
                                    f.y + a[1]
                                ];
                                Oe(h, e1, r, i), o.push(h);
                            }
                            return o;
                        }
                        function De(t1, e1, r, n) {
                            for(var i, a = 8192 * Math.pow(2, n.z), o = [
                                8192 * n.x,
                                8192 * n.y
                            ], s = [], l = 0, c = t1; l < c.length; l += 1){
                                for(var u = [], f = 0, h = c[l]; f < h.length; f += 1){
                                    var p = h[f], d = [
                                        p.x + o[0],
                                        p.y + o[1]
                                    ];
                                    _e(e1, d), u.push(d);
                                }
                                s.push(u);
                            }
                            if (e1[2] - e1[0] <= a / 2) {
                                (i = e1)[0] = i[1] = 1 / 0, i[2] = i[3] = -1 / 0;
                                for(var m = 0, g = s; m < g.length; m += 1)for(var v = 0, y = g[m]; v < y.length; v += 1)Oe(y[v], e1, r, a);
                            }
                            return s;
                        }
                        var Re = function(t1, e1) {
                            this.type = jt, this.geojson = t1, this.geometries = e1;
                        };
                        function Fe(t1) {
                            if (t1 instanceof xe) {
                                if ("get" === t1.name && 1 === t1.args.length) return !1;
                                if ("feature-state" === t1.name) return !1;
                                if ("has" === t1.name && 1 === t1.args.length) return !1;
                                if ("properties" === t1.name || "geometry-type" === t1.name || "id" === t1.name) return !1;
                                if (/^filter-/.test(t1.name)) return !1;
                            }
                            if (t1 instanceof Re) return !1;
                            var e1 = !0;
                            return t1.eachChild(function(t1) {
                                e1 && !Fe(t1) && (e1 = !1);
                            }), e1;
                        }
                        function Be(t1) {
                            if (t1 instanceof xe && "feature-state" === t1.name) return !1;
                            var e1 = !0;
                            return t1.eachChild(function(t1) {
                                e1 && !Be(t1) && (e1 = !1);
                            }), e1;
                        }
                        function Ne(t1, e1) {
                            if (t1 instanceof xe && e1.indexOf(t1.name) >= 0) return !1;
                            var r = !0;
                            return t1.eachChild(function(t1) {
                                r && !Ne(t1, e1) && (r = !1);
                            }), r;
                        }
                        Re.parse = function(t1, e1) {
                            if (2 !== t1.length) return e1.error("'within' expression requires exactly one argument, but found " + (t1.length - 1) + " instead.");
                            if (oe(t1[1])) {
                                var r = t1[1];
                                if ("FeatureCollection" === r.type) for(var n = 0; n < r.features.length; ++n){
                                    var i = r.features[n].geometry.type;
                                    if ("Polygon" === i || "MultiPolygon" === i) return new Re(r, r.features[n].geometry);
                                }
                                else if ("Feature" === r.type) {
                                    var a = r.geometry.type;
                                    if ("Polygon" === a || "MultiPolygon" === a) return new Re(r, r.geometry);
                                } else if ("Polygon" === r.type || "MultiPolygon" === r.type) return new Re(r, r);
                            }
                            return e1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
                        }, Re.prototype.evaluate = function(t1) {
                            if (null != t1.geometry() && null != t1.canonicalID()) {
                                if ("Point" === t1.geometryType()) return function(t1, e1) {
                                    var r = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], n = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], i = t1.canonicalID();
                                    if ("Polygon" === e1.type) {
                                        var a = Pe(e1.coordinates, n, i), o = ze(t1.geometry(), r, n, i);
                                        if (!we(r, n)) return !1;
                                        for(var s = 0, l = o; s < l.length; s += 1){
                                            if (!Ae(l[s], a)) return !1;
                                        }
                                    }
                                    if ("MultiPolygon" === e1.type) {
                                        var c = Ie(e1.coordinates, n, i), u = ze(t1.geometry(), r, n, i);
                                        if (!we(r, n)) return !1;
                                        for(var f = 0, h = u; f < h.length; f += 1){
                                            if (!Me(h[f], c)) return !1;
                                        }
                                    }
                                    return !0;
                                }(t1, this.geometries);
                                if ("LineString" === t1.geometryType()) return function(t1, e1) {
                                    var r = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], n = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], i = t1.canonicalID();
                                    if ("Polygon" === e1.type) {
                                        var a = Pe(e1.coordinates, n, i), o = De(t1.geometry(), r, n, i);
                                        if (!we(r, n)) return !1;
                                        for(var s = 0, l = o; s < l.length; s += 1){
                                            if (!Le(l[s], a)) return !1;
                                        }
                                    }
                                    if ("MultiPolygon" === e1.type) {
                                        var c = Ie(e1.coordinates, n, i), u = De(t1.geometry(), r, n, i);
                                        if (!we(r, n)) return !1;
                                        for(var f = 0, h = u; f < h.length; f += 1){
                                            if (!Ce(h[f], c)) return !1;
                                        }
                                    }
                                    return !0;
                                }(t1, this.geometries);
                            }
                            return !1;
                        }, Re.prototype.eachChild = function() {}, Re.prototype.outputDefined = function() {
                            return !0;
                        }, Re.prototype.serialize = function() {
                            return [
                                "within",
                                this.geojson
                            ];
                        };
                        var je = function(t1, e1) {
                            this.type = e1.type, this.name = t1, this.boundExpression = e1;
                        };
                        je.parse = function(t1, e1) {
                            if (2 !== t1.length || "string" != typeof t1[1]) return e1.error("'var' expression requires exactly one string literal argument.");
                            var r = t1[1];
                            return e1.scope.has(r) ? new je(r, e1.scope.get(r)) : e1.error('Unknown variable "' + r + '". Make sure "' + r + '" has been bound in an enclosing "let" expression before using it.', 1);
                        }, je.prototype.evaluate = function(t1) {
                            return this.boundExpression.evaluate(t1);
                        }, je.prototype.eachChild = function() {}, je.prototype.outputDefined = function() {
                            return !1;
                        }, je.prototype.serialize = function() {
                            return [
                                "var",
                                this.name
                            ];
                        };
                        var Ue = function(t1, e1, r, n, i) {
                            void 0 === e1 && (e1 = []), void 0 === n && (n = new Rt), void 0 === i && (i = []), this.registry = t1, this.path = e1, this.key = e1.map(function(t1) {
                                return "[" + t1 + "]";
                            }).join(""), this.scope = n, this.errors = i, this.expectedType = r;
                        };
                        function Ve(t1, e1) {
                            for(var r, n, i = t1.length - 1, a = 0, o = i, s = 0; a <= o;)if (r = t1[s = Math.floor((a + o) / 2)], n = t1[s + 1], r <= e1) {
                                if (s === i || e1 < n) return s;
                                a = s + 1;
                            } else {
                                if (!(r > e1)) throw new ue("Input is not a number.");
                                o = s - 1;
                            }
                            return 0;
                        }
                        Ue.prototype.parse = function(t1, e1, r, n, i) {
                            return void 0 === i && (i = {}), e1 ? this.concat(e1, r, n)._parse(t1, i) : this._parse(t1, i);
                        }, Ue.prototype._parse = function(t1, e1) {
                            function r(t1, e1, r) {
                                return "assert" === r ? new he(e1, [
                                    t1
                                ]) : "coerce" === r ? new ge(e1, [
                                    t1
                                ]) : t1;
                            }
                            if (null !== t1 && "string" != typeof t1 && "boolean" != typeof t1 && "number" != typeof t1 || (t1 = [
                                "literal",
                                t1
                            ]), Array.isArray(t1)) {
                                if (0 === t1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                                var n = t1[0];
                                if ("string" != typeof n) return this.error("Expression name must be a string, but found " + typeof n + ' instead. If you wanted a literal array, use ["literal", [...]].', 0), null;
                                var i = this.registry[n];
                                if (i) {
                                    var a = i.parse(t1, this);
                                    if (!a) return null;
                                    if (this.expectedType) {
                                        var o = this.expectedType, s = a.type;
                                        if ("string" !== o.kind && "number" !== o.kind && "boolean" !== o.kind && "object" !== o.kind && "array" !== o.kind || "value" !== s.kind) {
                                            if ("color" !== o.kind && "formatted" !== o.kind && "resolvedImage" !== o.kind || "value" !== s.kind && "string" !== s.kind) {
                                                if (this.checkSubtype(o, s)) return null;
                                            } else a = r(a, o, e1.typeAnnotation || "coerce");
                                        } else a = r(a, o, e1.typeAnnotation || "assert");
                                    }
                                    if (!(a instanceof ce) && "resolvedImage" !== a.type.kind && function t1(e1) {
                                        if (e1 instanceof je) return t1(e1.boundExpression);
                                        if (e1 instanceof xe && "error" === e1.name) return !1;
                                        if (e1 instanceof be) return !1;
                                        if (e1 instanceof Re) return !1;
                                        var r = e1 instanceof ge || e1 instanceof he, n = !0;
                                        if (e1.eachChild(function(e1) {
                                            n = r ? n && t1(e1) : n && e1 instanceof ce;
                                        }), !n) return !1;
                                        return Fe(e1) && Ne(e1, [
                                            "zoom",
                                            "heatmap-density",
                                            "line-progress",
                                            "accumulated",
                                            "is-supported-script"
                                        ]);
                                    }(a)) {
                                        var l = new ye;
                                        try {
                                            a = new ce(a.type, a.evaluate(l));
                                        } catch (t1) {
                                            return this.error(t1.message), null;
                                        }
                                    }
                                    return a;
                                }
                                return this.error('Unknown expression "' + n + '". If you wanted a literal array, use ["literal", [...]].', 0);
                            }
                            return void 0 === t1 ? this.error("'undefined' value invalid. Use null instead.") : "object" == typeof t1 ? this.error('Bare objects invalid. Use ["literal", {...}] instead.') : this.error("Expected an array, but found " + typeof t1 + " instead.");
                        }, Ue.prototype.concat = function(t1, e1, r) {
                            var n = "number" == typeof t1 ? this.path.concat(t1) : this.path, i = r ? this.scope.concat(r) : this.scope;
                            return new Ue(this.registry, n, e1 || null, i, this.errors);
                        }, Ue.prototype.error = function(t1) {
                            for(var e1 = [], r = arguments.length - 1; r-- > 0;)e1[r] = arguments[r + 1];
                            var n = "" + this.key + e1.map(function(t1) {
                                return "[" + t1 + "]";
                            }).join("");
                            this.errors.push(new Dt(n, t1));
                        }, Ue.prototype.checkSubtype = function(t1, e1) {
                            var r = Jt(t1, e1);
                            return r && this.error(r), r;
                        };
                        var He = function(t1, e1, r) {
                            this.type = t1, this.input = e1, this.labels = [], this.outputs = [];
                            for(var n = 0, i = r; n < i.length; n += 1){
                                var a = i[n], o = a[0], s = a[1];
                                this.labels.push(o), this.outputs.push(s);
                            }
                        };
                        function qe(t1, e1, r) {
                            return t1 * (1 - r) + e1 * r;
                        }
                        He.parse = function(t1, e1) {
                            if (t1.length - 1 < 4) return e1.error("Expected at least 4 arguments, but found only " + (t1.length - 1) + ".");
                            if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                            var r = e1.parse(t1[1], 1, Bt);
                            if (!r) return null;
                            var n = [], i = null;
                            e1.expectedType && "value" !== e1.expectedType.kind && (i = e1.expectedType);
                            for(var a = 1; a < t1.length; a += 2){
                                var o = 1 === a ? -1 / 0 : t1[a], s = t1[a + 1], l = a, c = a + 1;
                                if ("number" != typeof o) return e1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', l);
                                if (n.length && n[n.length - 1][0] >= o) return e1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', l);
                                var u = e1.parse(s, c, i);
                                if (!u) return null;
                                i = i || u.type, n.push([
                                    o,
                                    u
                                ]);
                            }
                            return new He(i, r, n);
                        }, He.prototype.evaluate = function(t1) {
                            var e1 = this.labels, r = this.outputs;
                            if (1 === e1.length) return r[0].evaluate(t1);
                            var n = this.input.evaluate(t1);
                            if (n <= e1[0]) return r[0].evaluate(t1);
                            var i = e1.length;
                            return n >= e1[i - 1] ? r[i - 1].evaluate(t1) : r[Ve(e1, n)].evaluate(t1);
                        }, He.prototype.eachChild = function(t1) {
                            t1(this.input);
                            for(var e1 = 0, r = this.outputs; e1 < r.length; e1 += 1)t1(r[e1]);
                        }, He.prototype.outputDefined = function() {
                            return this.outputs.every(function(t1) {
                                return t1.outputDefined();
                            });
                        }, He.prototype.serialize = function() {
                            for(var t1 = [
                                "step",
                                this.input.serialize()
                            ], e1 = 0; e1 < this.labels.length; e1++)e1 > 0 && t1.push(this.labels[e1]), t1.push(this.outputs[e1].serialize());
                            return t1;
                        };
                        var Ge = Object.freeze({
                            __proto__: null,
                            number: qe,
                            color: function(t1, e1, r) {
                                return new te(qe(t1.r, e1.r, r), qe(t1.g, e1.g, r), qe(t1.b, e1.b, r), qe(t1.a, e1.a, r));
                            },
                            array: function(t1, e1, r) {
                                return t1.map(function(t1, n) {
                                    return qe(t1, e1[n], r);
                                });
                            }
                        }), Ye = 6 / 29, We = 3 * Ye * Ye, Xe = Math.PI / 180, Ze = 180 / Math.PI;
                        function Je(t1) {
                            return t1 > .008856451679035631 ? Math.pow(t1, 1 / 3) : t1 / We + 4 / 29;
                        }
                        function Ke(t1) {
                            return t1 > Ye ? t1 * t1 * t1 : We * (t1 - 4 / 29);
                        }
                        function Qe(t1) {
                            return 255 * (t1 <= .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055);
                        }
                        function $e(t1) {
                            return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
                        }
                        function tr(t1) {
                            var e1 = $e(t1.r), r = $e(t1.g), n = $e(t1.b), i = Je((.4124564 * e1 + .3575761 * r + .1804375 * n) / .95047), a = Je((.2126729 * e1 + .7151522 * r + .072175 * n) / 1);
                            return {
                                l: 116 * a - 16,
                                a: 500 * (i - a),
                                b: 200 * (a - Je((.0193339 * e1 + .119192 * r + .9503041 * n) / 1.08883)),
                                alpha: t1.a
                            };
                        }
                        function er(t1) {
                            var e1 = (t1.l + 16) / 116, r = isNaN(t1.a) ? e1 : e1 + t1.a / 500, n = isNaN(t1.b) ? e1 : e1 - t1.b / 200;
                            return e1 = 1 * Ke(e1), r = .95047 * Ke(r), n = 1.08883 * Ke(n), new te(Qe(3.2404542 * r - 1.5371385 * e1 - .4985314 * n), Qe(-0.969266 * r + 1.8760108 * e1 + .041556 * n), Qe(.0556434 * r - .2040259 * e1 + 1.0572252 * n), t1.alpha);
                        }
                        function rr(t1, e1, r) {
                            var n = e1 - t1;
                            return t1 + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
                        }
                        var nr = {
                            forward: tr,
                            reverse: er,
                            interpolate: function(t1, e1, r) {
                                return {
                                    l: qe(t1.l, e1.l, r),
                                    a: qe(t1.a, e1.a, r),
                                    b: qe(t1.b, e1.b, r),
                                    alpha: qe(t1.alpha, e1.alpha, r)
                                };
                            }
                        }, ir = {
                            forward: function(t1) {
                                var e1 = tr(t1), r = e1.l, n = e1.a, i = e1.b, a = Math.atan2(i, n) * Ze;
                                return {
                                    h: a < 0 ? a + 360 : a,
                                    c: Math.sqrt(n * n + i * i),
                                    l: r,
                                    alpha: t1.a
                                };
                            },
                            reverse: function(t1) {
                                var e1 = t1.h * Xe, r = t1.c;
                                return er({
                                    l: t1.l,
                                    a: Math.cos(e1) * r,
                                    b: Math.sin(e1) * r,
                                    alpha: t1.alpha
                                });
                            },
                            interpolate: function(t1, e1, r) {
                                return {
                                    h: rr(t1.h, e1.h, r),
                                    c: qe(t1.c, e1.c, r),
                                    l: qe(t1.l, e1.l, r),
                                    alpha: qe(t1.alpha, e1.alpha, r)
                                };
                            }
                        }, ar = Object.freeze({
                            __proto__: null,
                            lab: nr,
                            hcl: ir
                        }), or = function(t1, e1, r, n, i) {
                            this.type = t1, this.operator = e1, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                            for(var a = 0, o = i; a < o.length; a += 1){
                                var s = o[a], l = s[0], c = s[1];
                                this.labels.push(l), this.outputs.push(c);
                            }
                        };
                        function sr(t1, e1, r, n) {
                            var i = n - r, a = t1 - r;
                            return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
                        }
                        or.interpolationFactor = function(t1, e1, n, i) {
                            var a = 0;
                            if ("exponential" === t1.name) a = sr(e1, t1.base, n, i);
                            else if ("linear" === t1.name) a = sr(e1, 1, n, i);
                            else if ("cubic-bezier" === t1.name) {
                                var o = t1.controlPoints;
                                a = new r(o[0], o[1], o[2], o[3]).solve(sr(e1, 1, n, i));
                            }
                            return a;
                        }, or.parse = function(t1, e1) {
                            var r = t1[0], n = t1[1], i = t1[2], a = t1.slice(3);
                            if (!Array.isArray(n) || 0 === n.length) return e1.error("Expected an interpolation type expression.", 1);
                            if ("linear" === n[0]) n = {
                                name: "linear"
                            };
                            else if ("exponential" === n[0]) {
                                var o = n[1];
                                if ("number" != typeof o) return e1.error("Exponential interpolation requires a numeric base.", 1, 1);
                                n = {
                                    name: "exponential",
                                    base: o
                                };
                            } else {
                                if ("cubic-bezier" !== n[0]) return e1.error("Unknown interpolation type " + String(n[0]), 1, 0);
                                var s = n.slice(1);
                                if (4 !== s.length || s.some(function(t1) {
                                    return "number" != typeof t1 || t1 < 0 || t1 > 1;
                                })) return e1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                                n = {
                                    name: "cubic-bezier",
                                    controlPoints: s
                                };
                            }
                            if (t1.length - 1 < 4) return e1.error("Expected at least 4 arguments, but found only " + (t1.length - 1) + ".");
                            if ((t1.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                            if (!(i = e1.parse(i, 2, Bt))) return null;
                            var l = [], c = null;
                            "interpolate-hcl" === r || "interpolate-lab" === r ? c = Ut : e1.expectedType && "value" !== e1.expectedType.kind && (c = e1.expectedType);
                            for(var u = 0; u < a.length; u += 2){
                                var f = a[u], h = a[u + 1], p = u + 3, d = u + 4;
                                if ("number" != typeof f) return e1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', p);
                                if (l.length && l[l.length - 1][0] >= f) return e1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', p);
                                var m = e1.parse(h, d, c);
                                if (!m) return null;
                                c = c || m.type, l.push([
                                    f,
                                    m
                                ]);
                            }
                            return "number" === c.kind || "color" === c.kind || "array" === c.kind && "number" === c.itemType.kind && "number" == typeof c.N ? new or(c, r, n, i, l) : e1.error("Type " + Xt(c) + " is not interpolatable.");
                        }, or.prototype.evaluate = function(t1) {
                            var e1 = this.labels, r = this.outputs;
                            if (1 === e1.length) return r[0].evaluate(t1);
                            var n = this.input.evaluate(t1);
                            if (n <= e1[0]) return r[0].evaluate(t1);
                            var i = e1.length;
                            if (n >= e1[i - 1]) return r[i - 1].evaluate(t1);
                            var a = Ve(e1, n), o = e1[a], s = e1[a + 1], l = or.interpolationFactor(this.interpolation, n, o, s), c = r[a].evaluate(t1), u = r[a + 1].evaluate(t1);
                            return "interpolate" === this.operator ? Ge[this.type.kind.toLowerCase()](c, u, l) : "interpolate-hcl" === this.operator ? ir.reverse(ir.interpolate(ir.forward(c), ir.forward(u), l)) : nr.reverse(nr.interpolate(nr.forward(c), nr.forward(u), l));
                        }, or.prototype.eachChild = function(t1) {
                            t1(this.input);
                            for(var e1 = 0, r = this.outputs; e1 < r.length; e1 += 1)t1(r[e1]);
                        }, or.prototype.outputDefined = function() {
                            return this.outputs.every(function(t1) {
                                return t1.outputDefined();
                            });
                        }, or.prototype.serialize = function() {
                            var t1;
                            t1 = "linear" === this.interpolation.name ? [
                                "linear"
                            ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                                "linear"
                            ] : [
                                "exponential",
                                this.interpolation.base
                            ] : [
                                "cubic-bezier"
                            ].concat(this.interpolation.controlPoints);
                            for(var e1 = [
                                this.operator,
                                t1,
                                this.input.serialize()
                            ], r = 0; r < this.labels.length; r++)e1.push(this.labels[r], this.outputs[r].serialize());
                            return e1;
                        };
                        var lr = function(t1, e1) {
                            this.type = t1, this.args = e1;
                        };
                        lr.parse = function(t1, e1) {
                            if (t1.length < 2) return e1.error("Expectected at least one argument.");
                            var r = null, n = e1.expectedType;
                            n && "value" !== n.kind && (r = n);
                            for(var i = [], a = 0, o = t1.slice(1); a < o.length; a += 1){
                                var s = o[a], l = e1.parse(s, 1 + i.length, r, void 0, {
                                    typeAnnotation: "omit"
                                });
                                if (!l) return null;
                                r = r || l.type, i.push(l);
                            }
                            var c = n && i.some(function(t1) {
                                return Jt(n, t1.type);
                            });
                            return new lr(c ? Ht : r, i);
                        }, lr.prototype.evaluate = function(t1) {
                            for(var e1, r = null, n = 0, i = 0, a = this.args; i < a.length; i += 1){
                                if (n++, (r = a[i].evaluate(t1)) && r instanceof ie && !r.available && (e1 || (e1 = r.name), r = null, n === this.args.length && (r = e1)), null !== r) break;
                            }
                            return r;
                        }, lr.prototype.eachChild = function(t1) {
                            this.args.forEach(t1);
                        }, lr.prototype.outputDefined = function() {
                            return this.args.every(function(t1) {
                                return t1.outputDefined();
                            });
                        }, lr.prototype.serialize = function() {
                            var t1 = [
                                "coalesce"
                            ];
                            return this.eachChild(function(e1) {
                                t1.push(e1.serialize());
                            }), t1;
                        };
                        var cr = function(t1, e1) {
                            this.type = e1.type, this.bindings = [].concat(t1), this.result = e1;
                        };
                        cr.prototype.evaluate = function(t1) {
                            return this.result.evaluate(t1);
                        }, cr.prototype.eachChild = function(t1) {
                            for(var e1 = 0, r = this.bindings; e1 < r.length; e1 += 1)t1(r[e1][1]);
                            t1(this.result);
                        }, cr.parse = function(t1, e1) {
                            if (t1.length < 4) return e1.error("Expected at least 3 arguments, but found " + (t1.length - 1) + " instead.");
                            for(var r = [], n = 1; n < t1.length - 1; n += 2){
                                var i = t1[n];
                                if ("string" != typeof i) return e1.error("Expected string, but found " + typeof i + " instead.", n);
                                if (/[^a-zA-Z0-9_]/.test(i)) return e1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                                var a = e1.parse(t1[n + 1], n + 1);
                                if (!a) return null;
                                r.push([
                                    i,
                                    a
                                ]);
                            }
                            var o = e1.parse(t1[t1.length - 1], t1.length - 1, e1.expectedType, r);
                            return o ? new cr(r, o) : null;
                        }, cr.prototype.outputDefined = function() {
                            return this.result.outputDefined();
                        }, cr.prototype.serialize = function() {
                            for(var t1 = [
                                "let"
                            ], e1 = 0, r = this.bindings; e1 < r.length; e1 += 1){
                                var n = r[e1], i = n[0], a = n[1];
                                t1.push(i, a.serialize());
                            }
                            return t1.push(this.result.serialize()), t1;
                        };
                        var ur = function(t1, e1, r) {
                            this.type = t1, this.index = e1, this.input = r;
                        };
                        ur.parse = function(t1, e1) {
                            if (3 !== t1.length) return e1.error("Expected 2 arguments, but found " + (t1.length - 1) + " instead.");
                            var r = e1.parse(t1[1], 1, Bt), n = e1.parse(t1[2], 2, Wt(e1.expectedType || Ht));
                            if (!r || !n) return null;
                            var i = n.type;
                            return new ur(i.itemType, r, n);
                        }, ur.prototype.evaluate = function(t1) {
                            var e1 = this.index.evaluate(t1), r = this.input.evaluate(t1);
                            if (e1 < 0) throw new ue("Array index out of bounds: " + e1 + " < 0.");
                            if (e1 >= r.length) throw new ue("Array index out of bounds: " + e1 + " > " + (r.length - 1) + ".");
                            if (e1 !== Math.floor(e1)) throw new ue("Array index must be an integer, but found " + e1 + " instead.");
                            return r[e1];
                        }, ur.prototype.eachChild = function(t1) {
                            t1(this.index), t1(this.input);
                        }, ur.prototype.outputDefined = function() {
                            return !1;
                        }, ur.prototype.serialize = function() {
                            return [
                                "at",
                                this.index.serialize(),
                                this.input.serialize()
                            ];
                        };
                        var fr = function(t1, e1) {
                            this.type = jt, this.needle = t1, this.haystack = e1;
                        };
                        fr.parse = function(t1, e1) {
                            if (3 !== t1.length) return e1.error("Expected 2 arguments, but found " + (t1.length - 1) + " instead.");
                            var r = e1.parse(t1[1], 1, Ht), n = e1.parse(t1[2], 2, Ht);
                            return r && n ? Kt(r.type, [
                                jt,
                                Nt,
                                Bt,
                                Ft,
                                Ht
                            ]) ? new fr(r, n) : e1.error("Expected first argument to be of type boolean, string, number or null, but found " + Xt(r.type) + " instead") : null;
                        }, fr.prototype.evaluate = function(t1) {
                            var e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                            if (!r) return !1;
                            if (!Qt(e1, [
                                "boolean",
                                "string",
                                "number",
                                "null"
                            ])) throw new ue("Expected first argument to be of type boolean, string, number or null, but found " + Xt(se(e1)) + " instead.");
                            if (!Qt(r, [
                                "string",
                                "array"
                            ])) throw new ue("Expected second argument to be of type array or string, but found " + Xt(se(r)) + " instead.");
                            return r.indexOf(e1) >= 0;
                        }, fr.prototype.eachChild = function(t1) {
                            t1(this.needle), t1(this.haystack);
                        }, fr.prototype.outputDefined = function() {
                            return !0;
                        }, fr.prototype.serialize = function() {
                            return [
                                "in",
                                this.needle.serialize(),
                                this.haystack.serialize()
                            ];
                        };
                        var hr = function(t1, e1, r) {
                            this.type = Bt, this.needle = t1, this.haystack = e1, this.fromIndex = r;
                        };
                        hr.parse = function(t1, e1) {
                            if (t1.length <= 2 || t1.length >= 5) return e1.error("Expected 3 or 4 arguments, but found " + (t1.length - 1) + " instead.");
                            var r = e1.parse(t1[1], 1, Ht), n = e1.parse(t1[2], 2, Ht);
                            if (!r || !n) return null;
                            if (!Kt(r.type, [
                                jt,
                                Nt,
                                Bt,
                                Ft,
                                Ht
                            ])) return e1.error("Expected first argument to be of type boolean, string, number or null, but found " + Xt(r.type) + " instead");
                            if (4 === t1.length) {
                                var i = e1.parse(t1[3], 3, Bt);
                                return i ? new hr(r, n, i) : null;
                            }
                            return new hr(r, n);
                        }, hr.prototype.evaluate = function(t1) {
                            var e1 = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                            if (!Qt(e1, [
                                "boolean",
                                "string",
                                "number",
                                "null"
                            ])) throw new ue("Expected first argument to be of type boolean, string, number or null, but found " + Xt(se(e1)) + " instead.");
                            if (!Qt(r, [
                                "string",
                                "array"
                            ])) throw new ue("Expected second argument to be of type array or string, but found " + Xt(se(r)) + " instead.");
                            if (this.fromIndex) {
                                var n = this.fromIndex.evaluate(t1);
                                return r.indexOf(e1, n);
                            }
                            return r.indexOf(e1);
                        }, hr.prototype.eachChild = function(t1) {
                            t1(this.needle), t1(this.haystack), this.fromIndex && t1(this.fromIndex);
                        }, hr.prototype.outputDefined = function() {
                            return !1;
                        }, hr.prototype.serialize = function() {
                            if (null != this.fromIndex && void 0 !== this.fromIndex) {
                                var t1 = this.fromIndex.serialize();
                                return [
                                    "index-of",
                                    this.needle.serialize(),
                                    this.haystack.serialize(),
                                    t1
                                ];
                            }
                            return [
                                "index-of",
                                this.needle.serialize(),
                                this.haystack.serialize()
                            ];
                        };
                        var pr = function(t1, e1, r, n, i, a) {
                            this.inputType = t1, this.type = e1, this.input = r, this.cases = n, this.outputs = i, this.otherwise = a;
                        };
                        pr.parse = function(t1, e1) {
                            if (t1.length < 5) return e1.error("Expected at least 4 arguments, but found only " + (t1.length - 1) + ".");
                            if (t1.length % 2 != 1) return e1.error("Expected an even number of arguments.");
                            var r, n;
                            e1.expectedType && "value" !== e1.expectedType.kind && (n = e1.expectedType);
                            for(var i = {}, a = [], o = 2; o < t1.length - 1; o += 2){
                                var s = t1[o], l = t1[o + 1];
                                Array.isArray(s) || (s = [
                                    s
                                ]);
                                var c = e1.concat(o);
                                if (0 === s.length) return c.error("Expected at least one branch label.");
                                for(var u = 0, f = s; u < f.length; u += 1){
                                    var h = f[u];
                                    if ("number" != typeof h && "string" != typeof h) return c.error("Branch labels must be numbers or strings.");
                                    if ("number" == typeof h && Math.abs(h) > Number.MAX_SAFE_INTEGER) return c.error("Branch labels must be integers no larger than " + Number.MAX_SAFE_INTEGER + ".");
                                    if ("number" == typeof h && Math.floor(h) !== h) return c.error("Numeric branch labels must be integer values.");
                                    if (r) {
                                        if (c.checkSubtype(r, se(h))) return null;
                                    } else r = se(h);
                                    if (void 0 !== i[String(h)]) return c.error("Branch labels must be unique.");
                                    i[String(h)] = a.length;
                                }
                                var p = e1.parse(l, o, n);
                                if (!p) return null;
                                n = n || p.type, a.push(p);
                            }
                            var d = e1.parse(t1[1], 1, Ht);
                            if (!d) return null;
                            var m = e1.parse(t1[t1.length - 1], t1.length - 1, n);
                            return m ? "value" !== d.type.kind && e1.concat(1).checkSubtype(r, d.type) ? null : new pr(r, n, d, i, a, m) : null;
                        }, pr.prototype.evaluate = function(t1) {
                            var e1 = this.input.evaluate(t1);
                            return (se(e1) === this.inputType && this.outputs[this.cases[e1]] || this.otherwise).evaluate(t1);
                        }, pr.prototype.eachChild = function(t1) {
                            t1(this.input), this.outputs.forEach(t1), t1(this.otherwise);
                        }, pr.prototype.outputDefined = function() {
                            return this.outputs.every(function(t1) {
                                return t1.outputDefined();
                            }) && this.otherwise.outputDefined();
                        }, pr.prototype.serialize = function() {
                            for(var t1 = this, e1 = [
                                "match",
                                this.input.serialize()
                            ], r = [], n = {}, i = 0, a = Object.keys(this.cases).sort(); i < a.length; i += 1){
                                var o = a[i];
                                void 0 === (f = n[this.cases[o]]) ? (n[this.cases[o]] = r.length, r.push([
                                    this.cases[o],
                                    [
                                        o
                                    ]
                                ])) : r[f][1].push(o);
                            }
                            for(var s = function(e1) {
                                return "number" === t1.inputType.kind ? Number(e1) : e1;
                            }, l = 0, c = r; l < c.length; l += 1){
                                var u = c[l], f = u[0], h = u[1];
                                1 === h.length ? e1.push(s(h[0])) : e1.push(h.map(s)), e1.push(this.outputs[outputIndex$1].serialize());
                            }
                            return e1.push(this.otherwise.serialize()), e1;
                        };
                        var dr = function(t1, e1, r) {
                            this.type = t1, this.branches = e1, this.otherwise = r;
                        };
                        dr.parse = function(t1, e1) {
                            if (t1.length < 4) return e1.error("Expected at least 3 arguments, but found only " + (t1.length - 1) + ".");
                            if (t1.length % 2 != 0) return e1.error("Expected an odd number of arguments.");
                            var r;
                            e1.expectedType && "value" !== e1.expectedType.kind && (r = e1.expectedType);
                            for(var n = [], i = 1; i < t1.length - 1; i += 2){
                                var a = e1.parse(t1[i], i, jt);
                                if (!a) return null;
                                var o = e1.parse(t1[i + 1], i + 1, r);
                                if (!o) return null;
                                n.push([
                                    a,
                                    o
                                ]), r = r || o.type;
                            }
                            var s = e1.parse(t1[t1.length - 1], t1.length - 1, r);
                            return s ? new dr(r, n, s) : null;
                        }, dr.prototype.evaluate = function(t1) {
                            for(var e1 = 0, r = this.branches; e1 < r.length; e1 += 1){
                                var n = r[e1], i = n[0], a = n[1];
                                if (i.evaluate(t1)) return a.evaluate(t1);
                            }
                            return this.otherwise.evaluate(t1);
                        }, dr.prototype.eachChild = function(t1) {
                            for(var e1 = 0, r = this.branches; e1 < r.length; e1 += 1){
                                var n = r[e1], i = n[0], a = n[1];
                                t1(i), t1(a);
                            }
                            t1(this.otherwise);
                        }, dr.prototype.outputDefined = function() {
                            return this.branches.every(function(t1) {
                                t1[0];
                                return t1[1].outputDefined();
                            }) && this.otherwise.outputDefined();
                        }, dr.prototype.serialize = function() {
                            var t1 = [
                                "case"
                            ];
                            return this.eachChild(function(e1) {
                                t1.push(e1.serialize());
                            }), t1;
                        };
                        var mr = function(t1, e1, r, n) {
                            this.type = t1, this.input = e1, this.beginIndex = r, this.endIndex = n;
                        };
                        function gr(t1, e1) {
                            return "==" === t1 || "!=" === t1 ? "boolean" === e1.kind || "string" === e1.kind || "number" === e1.kind || "null" === e1.kind || "value" === e1.kind : "string" === e1.kind || "number" === e1.kind || "value" === e1.kind;
                        }
                        function vr(t1, e1, r, n) {
                            return 0 === n.compare(e1, r);
                        }
                        function yr(t1, e1, r) {
                            var n = "==" !== t1 && "!=" !== t1;
                            return function() {
                                function i(t1, e1, r) {
                                    this.type = jt, this.lhs = t1, this.rhs = e1, this.collator = r, this.hasUntypedArgument = "value" === t1.type.kind || "value" === e1.type.kind;
                                }
                                return i.parse = function(t1, e1) {
                                    if (3 !== t1.length && 4 !== t1.length) return e1.error("Expected two or three arguments.");
                                    var r = t1[0], a = e1.parse(t1[1], 1, Ht);
                                    if (!a) return null;
                                    if (!gr(r, a.type)) return e1.concat(1).error('"' + r + "\" comparisons are not supported for type '" + Xt(a.type) + "'.");
                                    var o = e1.parse(t1[2], 2, Ht);
                                    if (!o) return null;
                                    if (!gr(r, o.type)) return e1.concat(2).error('"' + r + "\" comparisons are not supported for type '" + Xt(o.type) + "'.");
                                    if (a.type.kind !== o.type.kind && "value" !== a.type.kind && "value" !== o.type.kind) return e1.error("Cannot compare types '" + Xt(a.type) + "' and '" + Xt(o.type) + "'.");
                                    n && ("value" === a.type.kind && "value" !== o.type.kind ? a = new he(o.type, [
                                        a
                                    ]) : "value" !== a.type.kind && "value" === o.type.kind && (o = new he(a.type, [
                                        o
                                    ])));
                                    var s = null;
                                    if (4 === t1.length) {
                                        if ("string" !== a.type.kind && "string" !== o.type.kind && "value" !== a.type.kind && "value" !== o.type.kind) return e1.error("Cannot use collator to compare non-string types.");
                                        if (!(s = e1.parse(t1[3], 3, qt))) return null;
                                    }
                                    return new i(a, o, s);
                                }, i.prototype.evaluate = function(i) {
                                    var a = this.lhs.evaluate(i), o = this.rhs.evaluate(i);
                                    if (n && this.hasUntypedArgument) {
                                        var s = se(a), l = se(o);
                                        if (s.kind !== l.kind || "string" !== s.kind && "number" !== s.kind) throw new ue('Expected arguments for "' + t1 + '" to be (string, string) or (number, number), but found (' + s.kind + ", " + l.kind + ") instead.");
                                    }
                                    if (this.collator && !n && this.hasUntypedArgument) {
                                        var c = se(a), u = se(o);
                                        if ("string" !== c.kind || "string" !== u.kind) return e1(i, a, o);
                                    }
                                    return this.collator ? r(i, a, o, this.collator.evaluate(i)) : e1(i, a, o);
                                }, i.prototype.eachChild = function(t1) {
                                    t1(this.lhs), t1(this.rhs), this.collator && t1(this.collator);
                                }, i.prototype.outputDefined = function() {
                                    return !0;
                                }, i.prototype.serialize = function() {
                                    var e1 = [
                                        t1
                                    ];
                                    return this.eachChild(function(t1) {
                                        e1.push(t1.serialize());
                                    }), e1;
                                }, i;
                            }();
                        }
                        mr.parse = function(t1, e1) {
                            if (t1.length <= 2 || t1.length >= 5) return e1.error("Expected 3 or 4 arguments, but found " + (t1.length - 1) + " instead.");
                            var r = e1.parse(t1[1], 1, Ht), n = e1.parse(t1[2], 2, Bt);
                            if (!r || !n) return null;
                            if (!Kt(r.type, [
                                Wt(Ht),
                                Nt,
                                Ht
                            ])) return e1.error("Expected first argument to be of type array or string, but found " + Xt(r.type) + " instead");
                            if (4 === t1.length) {
                                var i = e1.parse(t1[3], 3, Bt);
                                return i ? new mr(r.type, r, n, i) : null;
                            }
                            return new mr(r.type, r, n);
                        }, mr.prototype.evaluate = function(t1) {
                            var e1 = this.input.evaluate(t1), r = this.beginIndex.evaluate(t1);
                            if (!Qt(e1, [
                                "string",
                                "array"
                            ])) throw new ue("Expected first argument to be of type array or string, but found " + Xt(se(e1)) + " instead.");
                            if (this.endIndex) {
                                var n = this.endIndex.evaluate(t1);
                                return e1.slice(r, n);
                            }
                            return e1.slice(r);
                        }, mr.prototype.eachChild = function(t1) {
                            t1(this.input), t1(this.beginIndex), this.endIndex && t1(this.endIndex);
                        }, mr.prototype.outputDefined = function() {
                            return !1;
                        }, mr.prototype.serialize = function() {
                            if (null != this.endIndex && void 0 !== this.endIndex) {
                                var t1 = this.endIndex.serialize();
                                return [
                                    "slice",
                                    this.input.serialize(),
                                    this.beginIndex.serialize(),
                                    t1
                                ];
                            }
                            return [
                                "slice",
                                this.input.serialize(),
                                this.beginIndex.serialize()
                            ];
                        };
                        var xr = yr("==", function(t1, e1, r) {
                            return e1 === r;
                        }, vr), br = yr("!=", function(t1, e1, r) {
                            return e1 !== r;
                        }, function(t1, e1, r, n) {
                            return !vr(0, e1, r, n);
                        }), _r = yr("<", function(t1, e1, r) {
                            return e1 < r;
                        }, function(t1, e1, r, n) {
                            return n.compare(e1, r) < 0;
                        }), wr = yr(">", function(t1, e1, r) {
                            return e1 > r;
                        }, function(t1, e1, r, n) {
                            return n.compare(e1, r) > 0;
                        }), Tr = yr("<=", function(t1, e1, r) {
                            return e1 <= r;
                        }, function(t1, e1, r, n) {
                            return n.compare(e1, r) <= 0;
                        }), kr = yr(">=", function(t1, e1, r) {
                            return e1 >= r;
                        }, function(t1, e1, r, n) {
                            return n.compare(e1, r) >= 0;
                        }), Ar = function(t1, e1, r, n, i) {
                            this.type = Nt, this.number = t1, this.locale = e1, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
                        };
                        Ar.parse = function(t1, e1) {
                            if (3 !== t1.length) return e1.error("Expected two arguments.");
                            var r = e1.parse(t1[1], 1, Bt);
                            if (!r) return null;
                            var n = t1[2];
                            if ("object" != typeof n || Array.isArray(n)) return e1.error("NumberFormat options argument must be an object.");
                            var i = null;
                            if (n.locale && !(i = e1.parse(n.locale, 1, Nt))) return null;
                            var a = null;
                            if (n.currency && !(a = e1.parse(n.currency, 1, Nt))) return null;
                            var o = null;
                            if (n["min-fraction-digits"] && !(o = e1.parse(n["min-fraction-digits"], 1, Bt))) return null;
                            var s = null;
                            return n["max-fraction-digits"] && !(s = e1.parse(n["max-fraction-digits"], 1, Bt)) ? null : new Ar(r, i, a, o, s);
                        }, Ar.prototype.evaluate = function(t1) {
                            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t1) : [], {
                                style: this.currency ? "currency" : "decimal",
                                currency: this.currency ? this.currency.evaluate(t1) : void 0,
                                minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t1) : void 0,
                                maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t1) : void 0
                            }).format(this.number.evaluate(t1));
                        }, Ar.prototype.eachChild = function(t1) {
                            t1(this.number), this.locale && t1(this.locale), this.currency && t1(this.currency), this.minFractionDigits && t1(this.minFractionDigits), this.maxFractionDigits && t1(this.maxFractionDigits);
                        }, Ar.prototype.outputDefined = function() {
                            return !1;
                        }, Ar.prototype.serialize = function() {
                            var t1 = {};
                            return this.locale && (t1.locale = this.locale.serialize()), this.currency && (t1.currency = this.currency.serialize()), this.minFractionDigits && (t1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                                "number-format",
                                this.number.serialize(),
                                t1
                            ];
                        };
                        var Mr = function(t1) {
                            this.type = Bt, this.input = t1;
                        };
                        Mr.parse = function(t1, e1) {
                            if (2 !== t1.length) return e1.error("Expected 1 argument, but found " + (t1.length - 1) + " instead.");
                            var r = e1.parse(t1[1], 1);
                            return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e1.error("Expected argument of type string or array, but found " + Xt(r.type) + " instead.") : new Mr(r) : null;
                        }, Mr.prototype.evaluate = function(t1) {
                            var e1 = this.input.evaluate(t1);
                            if ("string" == typeof e1) return e1.length;
                            if (Array.isArray(e1)) return e1.length;
                            throw new ue("Expected value to be of type string or array, but found " + Xt(se(e1)) + " instead.");
                        }, Mr.prototype.eachChild = function(t1) {
                            t1(this.input);
                        }, Mr.prototype.outputDefined = function() {
                            return !1;
                        }, Mr.prototype.serialize = function() {
                            var t1 = [
                                "length"
                            ];
                            return this.eachChild(function(e1) {
                                t1.push(e1.serialize());
                            }), t1;
                        };
                        var Sr = {
                            "==": xr,
                            "!=": br,
                            ">": wr,
                            "<": _r,
                            ">=": kr,
                            "<=": Tr,
                            array: he,
                            at: ur,
                            boolean: he,
                            case: dr,
                            coalesce: lr,
                            collator: be,
                            format: pe,
                            image: de,
                            in: fr,
                            "index-of": hr,
                            interpolate: or,
                            "interpolate-hcl": or,
                            "interpolate-lab": or,
                            length: Mr,
                            let: cr,
                            literal: ce,
                            match: pr,
                            number: he,
                            "number-format": Ar,
                            object: he,
                            slice: mr,
                            step: He,
                            string: he,
                            "to-boolean": ge,
                            "to-color": ge,
                            "to-number": ge,
                            "to-string": ge,
                            var: je,
                            within: Re
                        };
                        function Er(t1, e1) {
                            var r = e1[0], n = e1[1], i = e1[2], a = e1[3];
                            r = r.evaluate(t1), n = n.evaluate(t1), i = i.evaluate(t1);
                            var o = a ? a.evaluate(t1) : 1, s = ae(r, n, i, o);
                            if (s) throw new ue(s);
                            return new te(r / 255 * o, n / 255 * o, i / 255 * o, o);
                        }
                        function Lr(t1, e1) {
                            return t1 in e1;
                        }
                        function Cr(t1, e1) {
                            var r = e1[t1];
                            return void 0 === r ? null : r;
                        }
                        function Pr(t1) {
                            return {
                                type: t1
                            };
                        }
                        function Ir(t1) {
                            return {
                                result: "success",
                                value: t1
                            };
                        }
                        function Or(t1) {
                            return {
                                result: "error",
                                value: t1
                            };
                        }
                        function zr(t1) {
                            return "data-driven" === t1["property-type"] || "cross-faded-data-driven" === t1["property-type"];
                        }
                        function Dr(t1) {
                            return !!t1.expression && t1.expression.parameters.indexOf("zoom") > -1;
                        }
                        function Rr(t1) {
                            return !!t1.expression && t1.expression.interpolated;
                        }
                        function Fr(t1) {
                            return t1 instanceof Number ? "number" : t1 instanceof String ? "string" : t1 instanceof Boolean ? "boolean" : Array.isArray(t1) ? "array" : null === t1 ? "null" : typeof t1;
                        }
                        function Br(t1) {
                            return "object" == typeof t1 && null !== t1 && !Array.isArray(t1);
                        }
                        function Nr(t1) {
                            return t1;
                        }
                        function jr(t1, e1, r) {
                            return void 0 !== t1 ? t1 : void 0 !== e1 ? e1 : void 0 !== r ? r : void 0;
                        }
                        function Ur(t1, e1, r, n, i) {
                            return jr(typeof r === i ? n[r] : void 0, t1.default, e1.default);
                        }
                        function Vr(t1, e1, r) {
                            if ("number" !== Fr(r)) return jr(t1.default, e1.default);
                            var n = t1.stops.length;
                            if (1 === n) return t1.stops[0][1];
                            if (r <= t1.stops[0][0]) return t1.stops[0][1];
                            if (r >= t1.stops[n - 1][0]) return t1.stops[n - 1][1];
                            var i = Ve(t1.stops.map(function(t1) {
                                return t1[0];
                            }), r);
                            return t1.stops[i][1];
                        }
                        function Hr(t1, e1, r) {
                            var n = void 0 !== t1.base ? t1.base : 1;
                            if ("number" !== Fr(r)) return jr(t1.default, e1.default);
                            var i = t1.stops.length;
                            if (1 === i) return t1.stops[0][1];
                            if (r <= t1.stops[0][0]) return t1.stops[0][1];
                            if (r >= t1.stops[i - 1][0]) return t1.stops[i - 1][1];
                            var a = Ve(t1.stops.map(function(t1) {
                                return t1[0];
                            }), r), o = function(t1, e1, r, n) {
                                var i = n - r, a = t1 - r;
                                return 0 === i ? 0 : 1 === e1 ? a / i : (Math.pow(e1, a) - 1) / (Math.pow(e1, i) - 1);
                            }(r, n, t1.stops[a][0], t1.stops[a + 1][0]), s = t1.stops[a][1], l = t1.stops[a + 1][1], c = Ge[e1.type] || Nr;
                            if (t1.colorSpace && "rgb" !== t1.colorSpace) {
                                var u = ar[t1.colorSpace];
                                c = function(t1, e1) {
                                    return u.reverse(u.interpolate(u.forward(t1), u.forward(e1), o));
                                };
                            }
                            return "function" == typeof s.evaluate ? {
                                evaluate: function() {
                                    for(var t1 = [], e1 = arguments.length; e1--;)t1[e1] = arguments[e1];
                                    var r = s.evaluate.apply(void 0, t1), n = l.evaluate.apply(void 0, t1);
                                    if (void 0 !== r && void 0 !== n) return c(r, n, o);
                                }
                            } : c(s, l, o);
                        }
                        function qr(t1, e1, r) {
                            return "color" === e1.type ? r = te.parse(r) : "formatted" === e1.type ? r = ne.fromString(r.toString()) : "resolvedImage" === e1.type ? r = ie.fromString(r.toString()) : Fr(r) === e1.type || "enum" === e1.type && e1.values[r] || (r = void 0), jr(r, t1.default, e1.default);
                        }
                        xe.register(Sr, {
                            error: [
                                {
                                    kind: "error"
                                },
                                [
                                    Nt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    throw new ue(r.evaluate(t1));
                                }
                            ],
                            typeof: [
                                Nt,
                                [
                                    Ht
                                ],
                                function(t1, e1) {
                                    return Xt(se(e1[0].evaluate(t1)));
                                }
                            ],
                            "to-rgba": [
                                Wt(Bt, 4),
                                [
                                    Ut
                                ],
                                function(t1, e1) {
                                    return e1[0].evaluate(t1).toArray();
                                }
                            ],
                            rgb: [
                                Ut,
                                [
                                    Bt,
                                    Bt,
                                    Bt
                                ],
                                Er
                            ],
                            rgba: [
                                Ut,
                                [
                                    Bt,
                                    Bt,
                                    Bt,
                                    Bt
                                ],
                                Er
                            ],
                            has: {
                                type: jt,
                                overloads: [
                                    [
                                        [
                                            Nt
                                        ],
                                        function(t1, e1) {
                                            return Lr(e1[0].evaluate(t1), t1.properties());
                                        }
                                    ],
                                    [
                                        [
                                            Nt,
                                            Vt
                                        ],
                                        function(t1, e1) {
                                            var r = e1[0], n = e1[1];
                                            return Lr(r.evaluate(t1), n.evaluate(t1));
                                        }
                                    ]
                                ]
                            },
                            get: {
                                type: Ht,
                                overloads: [
                                    [
                                        [
                                            Nt
                                        ],
                                        function(t1, e1) {
                                            return Cr(e1[0].evaluate(t1), t1.properties());
                                        }
                                    ],
                                    [
                                        [
                                            Nt,
                                            Vt
                                        ],
                                        function(t1, e1) {
                                            var r = e1[0], n = e1[1];
                                            return Cr(r.evaluate(t1), n.evaluate(t1));
                                        }
                                    ]
                                ]
                            },
                            "feature-state": [
                                Ht,
                                [
                                    Nt
                                ],
                                function(t1, e1) {
                                    return Cr(e1[0].evaluate(t1), t1.featureState || {});
                                }
                            ],
                            properties: [
                                Vt,
                                [],
                                function(t1) {
                                    return t1.properties();
                                }
                            ],
                            "geometry-type": [
                                Nt,
                                [],
                                function(t1) {
                                    return t1.geometryType();
                                }
                            ],
                            id: [
                                Ht,
                                [],
                                function(t1) {
                                    return t1.id();
                                }
                            ],
                            zoom: [
                                Bt,
                                [],
                                function(t1) {
                                    return t1.globals.zoom;
                                }
                            ],
                            "heatmap-density": [
                                Bt,
                                [],
                                function(t1) {
                                    return t1.globals.heatmapDensity || 0;
                                }
                            ],
                            "line-progress": [
                                Bt,
                                [],
                                function(t1) {
                                    return t1.globals.lineProgress || 0;
                                }
                            ],
                            accumulated: [
                                Ht,
                                [],
                                function(t1) {
                                    return void 0 === t1.globals.accumulated ? null : t1.globals.accumulated;
                                }
                            ],
                            "+": [
                                Bt,
                                Pr(Bt),
                                function(t1, e1) {
                                    for(var r = 0, n = 0, i = e1; n < i.length; n += 1)r += i[n].evaluate(t1);
                                    return r;
                                }
                            ],
                            "*": [
                                Bt,
                                Pr(Bt),
                                function(t1, e1) {
                                    for(var r = 1, n = 0, i = e1; n < i.length; n += 1)r *= i[n].evaluate(t1);
                                    return r;
                                }
                            ],
                            "-": {
                                type: Bt,
                                overloads: [
                                    [
                                        [
                                            Bt,
                                            Bt
                                        ],
                                        function(t1, e1) {
                                            var r = e1[0], n = e1[1];
                                            return r.evaluate(t1) - n.evaluate(t1);
                                        }
                                    ],
                                    [
                                        [
                                            Bt
                                        ],
                                        function(t1, e1) {
                                            return -e1[0].evaluate(t1);
                                        }
                                    ]
                                ]
                            },
                            "/": [
                                Bt,
                                [
                                    Bt,
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1];
                                    return r.evaluate(t1) / n.evaluate(t1);
                                }
                            ],
                            "%": [
                                Bt,
                                [
                                    Bt,
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1];
                                    return r.evaluate(t1) % n.evaluate(t1);
                                }
                            ],
                            ln2: [
                                Bt,
                                [],
                                function() {
                                    return Math.LN2;
                                }
                            ],
                            pi: [
                                Bt,
                                [],
                                function() {
                                    return Math.PI;
                                }
                            ],
                            e: [
                                Bt,
                                [],
                                function() {
                                    return Math.E;
                                }
                            ],
                            "^": [
                                Bt,
                                [
                                    Bt,
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1];
                                    return Math.pow(r.evaluate(t1), n.evaluate(t1));
                                }
                            ],
                            sqrt: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.sqrt(r.evaluate(t1));
                                }
                            ],
                            log10: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.log(r.evaluate(t1)) / Math.LN10;
                                }
                            ],
                            ln: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.log(r.evaluate(t1));
                                }
                            ],
                            log2: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.log(r.evaluate(t1)) / Math.LN2;
                                }
                            ],
                            sin: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.sin(r.evaluate(t1));
                                }
                            ],
                            cos: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.cos(r.evaluate(t1));
                                }
                            ],
                            tan: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.tan(r.evaluate(t1));
                                }
                            ],
                            asin: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.asin(r.evaluate(t1));
                                }
                            ],
                            acos: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.acos(r.evaluate(t1));
                                }
                            ],
                            atan: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.atan(r.evaluate(t1));
                                }
                            ],
                            min: [
                                Bt,
                                Pr(Bt),
                                function(t1, e1) {
                                    return Math.min.apply(Math, e1.map(function(e1) {
                                        return e1.evaluate(t1);
                                    }));
                                }
                            ],
                            max: [
                                Bt,
                                Pr(Bt),
                                function(t1, e1) {
                                    return Math.max.apply(Math, e1.map(function(e1) {
                                        return e1.evaluate(t1);
                                    }));
                                }
                            ],
                            abs: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.abs(r.evaluate(t1));
                                }
                            ],
                            round: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0].evaluate(t1);
                                    return r < 0 ? -Math.round(-r) : Math.round(r);
                                }
                            ],
                            floor: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.floor(r.evaluate(t1));
                                }
                            ],
                            ceil: [
                                Bt,
                                [
                                    Bt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return Math.ceil(r.evaluate(t1));
                                }
                            ],
                            "filter-==": [
                                jt,
                                [
                                    Nt,
                                    Ht
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1];
                                    return t1.properties()[r.value] === n.value;
                                }
                            ],
                            "filter-id-==": [
                                jt,
                                [
                                    Ht
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return t1.id() === r.value;
                                }
                            ],
                            "filter-type-==": [
                                jt,
                                [
                                    Nt
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return t1.geometryType() === r.value;
                                }
                            ],
                            "filter-<": [
                                jt,
                                [
                                    Nt,
                                    Ht
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                                    return typeof i == typeof a && i < a;
                                }
                            ],
                            "filter-id-<": [
                                jt,
                                [
                                    Ht
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = t1.id(), i = r.value;
                                    return typeof n == typeof i && n < i;
                                }
                            ],
                            "filter->": [
                                jt,
                                [
                                    Nt,
                                    Ht
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                                    return typeof i == typeof a && i > a;
                                }
                            ],
                            "filter-id->": [
                                jt,
                                [
                                    Ht
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = t1.id(), i = r.value;
                                    return typeof n == typeof i && n > i;
                                }
                            ],
                            "filter-<=": [
                                jt,
                                [
                                    Nt,
                                    Ht
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                                    return typeof i == typeof a && i <= a;
                                }
                            ],
                            "filter-id-<=": [
                                jt,
                                [
                                    Ht
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = t1.id(), i = r.value;
                                    return typeof n == typeof i && n <= i;
                                }
                            ],
                            "filter->=": [
                                jt,
                                [
                                    Nt,
                                    Ht
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1], i = t1.properties()[r.value], a = n.value;
                                    return typeof i == typeof a && i >= a;
                                }
                            ],
                            "filter-id->=": [
                                jt,
                                [
                                    Ht
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = t1.id(), i = r.value;
                                    return typeof n == typeof i && n >= i;
                                }
                            ],
                            "filter-has": [
                                jt,
                                [
                                    Ht
                                ],
                                function(t1, e1) {
                                    return e1[0].value in t1.properties();
                                }
                            ],
                            "filter-has-id": [
                                jt,
                                [],
                                function(t1) {
                                    return null !== t1.id() && void 0 !== t1.id();
                                }
                            ],
                            "filter-type-in": [
                                jt,
                                [
                                    Wt(Nt)
                                ],
                                function(t1, e1) {
                                    return e1[0].value.indexOf(t1.geometryType()) >= 0;
                                }
                            ],
                            "filter-id-in": [
                                jt,
                                [
                                    Wt(Ht)
                                ],
                                function(t1, e1) {
                                    return e1[0].value.indexOf(t1.id()) >= 0;
                                }
                            ],
                            "filter-in-small": [
                                jt,
                                [
                                    Nt,
                                    Wt(Ht)
                                ],
                                function(t1, e1) {
                                    var r = e1[0];
                                    return e1[1].value.indexOf(t1.properties()[r.value]) >= 0;
                                }
                            ],
                            "filter-in-large": [
                                jt,
                                [
                                    Nt,
                                    Wt(Ht)
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = e1[1];
                                    return function(t1, e1, r, n) {
                                        for(; r <= n;){
                                            var i = r + n >> 1;
                                            if (e1[i] === t1) return !0;
                                            e1[i] > t1 ? n = i - 1 : r = i + 1;
                                        }
                                        return !1;
                                    }(t1.properties()[r.value], n.value, 0, n.value.length - 1);
                                }
                            ],
                            all: {
                                type: jt,
                                overloads: [
                                    [
                                        [
                                            jt,
                                            jt
                                        ],
                                        function(t1, e1) {
                                            var r = e1[0], n = e1[1];
                                            return r.evaluate(t1) && n.evaluate(t1);
                                        }
                                    ],
                                    [
                                        Pr(jt),
                                        function(t1, e1) {
                                            for(var r = 0, n = e1; r < n.length; r += 1){
                                                if (!n[r].evaluate(t1)) return !1;
                                            }
                                            return !0;
                                        }
                                    ]
                                ]
                            },
                            any: {
                                type: jt,
                                overloads: [
                                    [
                                        [
                                            jt,
                                            jt
                                        ],
                                        function(t1, e1) {
                                            var r = e1[0], n = e1[1];
                                            return r.evaluate(t1) || n.evaluate(t1);
                                        }
                                    ],
                                    [
                                        Pr(jt),
                                        function(t1, e1) {
                                            for(var r = 0, n = e1; r < n.length; r += 1){
                                                if (n[r].evaluate(t1)) return !0;
                                            }
                                            return !1;
                                        }
                                    ]
                                ]
                            },
                            "!": [
                                jt,
                                [
                                    jt
                                ],
                                function(t1, e1) {
                                    return !e1[0].evaluate(t1);
                                }
                            ],
                            "is-supported-script": [
                                jt,
                                [
                                    Nt
                                ],
                                function(t1, e1) {
                                    var r = e1[0], n = t1.globals && t1.globals.isSupportedScript;
                                    return !n || n(r.evaluate(t1));
                                }
                            ],
                            upcase: [
                                Nt,
                                [
                                    Nt
                                ],
                                function(t1, e1) {
                                    return e1[0].evaluate(t1).toUpperCase();
                                }
                            ],
                            downcase: [
                                Nt,
                                [
                                    Nt
                                ],
                                function(t1, e1) {
                                    return e1[0].evaluate(t1).toLowerCase();
                                }
                            ],
                            concat: [
                                Nt,
                                Pr(Ht),
                                function(t1, e1) {
                                    return e1.map(function(e1) {
                                        return le(e1.evaluate(t1));
                                    }).join("");
                                }
                            ],
                            "resolved-locale": [
                                Nt,
                                [
                                    qt
                                ],
                                function(t1, e1) {
                                    return e1[0].evaluate(t1).resolvedLocale();
                                }
                            ]
                        });
                        var Gr = function(t1, e1) {
                            this.expression = t1, this._warningHistory = {}, this._evaluator = new ye, this._defaultValue = e1 ? function(t1) {
                                return "color" === t1.type && Br(t1.default) ? new te(0, 0, 0, 0) : "color" === t1.type ? te.parse(t1.default) || null : void 0 === t1.default ? null : t1.default;
                            }(e1) : null, this._enumValues = e1 && "enum" === e1.type ? e1.values : null;
                        };
                        function Yr(t1) {
                            return Array.isArray(t1) && t1.length > 0 && "string" == typeof t1[0] && t1[0] in Sr;
                        }
                        function Wr(t1, e1) {
                            var r = new Ue(Sr, [], e1 ? function(t1) {
                                var e1 = {
                                    color: Ut,
                                    string: Nt,
                                    number: Bt,
                                    enum: Nt,
                                    boolean: jt,
                                    formatted: Gt,
                                    resolvedImage: Yt
                                };
                                if ("array" === t1.type) return Wt(e1[t1.value] || Ht, t1.length);
                                return e1[t1.type];
                            }(e1) : void 0), n = r.parse(t1, void 0, void 0, void 0, e1 && "string" === e1.type ? {
                                typeAnnotation: "coerce"
                            } : void 0);
                            return n ? Ir(new Gr(n, e1)) : Or(r.errors);
                        }
                        Gr.prototype.evaluateWithoutErrorHandling = function(t1, e1, r, n, i, a) {
                            return this._evaluator.globals = t1, this._evaluator.feature = e1, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a, this.expression.evaluate(this._evaluator);
                        }, Gr.prototype.evaluate = function(t1, e1, r, n, i, a) {
                            this._evaluator.globals = t1, this._evaluator.feature = e1 || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a || null;
                            try {
                                var o = this.expression.evaluate(this._evaluator);
                                if (null == o || "number" == typeof o && o != o) return this._defaultValue;
                                if (this._enumValues && !(o in this._enumValues)) throw new ue("Expected value to be one of " + Object.keys(this._enumValues).map(function(t1) {
                                    return JSON.stringify(t1);
                                }).join(", ") + ", but found " + JSON.stringify(o) + " instead.");
                                return o;
                            } catch (t1) {
                                return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(t1.message)), this._defaultValue;
                            }
                        };
                        var Xr = function(t1, e1) {
                            this.kind = t1, this._styleExpression = e1, this.isStateDependent = "constant" !== t1 && !Be(e1.expression);
                        };
                        Xr.prototype.evaluateWithoutErrorHandling = function(t1, e1, r, n, i, a) {
                            return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
                        }, Xr.prototype.evaluate = function(t1, e1, r, n, i, a) {
                            return this._styleExpression.evaluate(t1, e1, r, n, i, a);
                        };
                        var Zr = function(t1, e1, r, n) {
                            this.kind = t1, this.zoomStops = r, this._styleExpression = e1, this.isStateDependent = "camera" !== t1 && !Be(e1.expression), this.interpolationType = n;
                        };
                        function Jr(t1, e1) {
                            if ("error" === (t1 = Wr(t1, e1)).result) return t1;
                            var r = t1.value.expression, n = Fe(r);
                            if (!n && !zr(e1)) return Or([
                                new Dt("", "data expressions not supported")
                            ]);
                            var i = Ne(r, [
                                "zoom"
                            ]);
                            if (!i && !Dr(e1)) return Or([
                                new Dt("", "zoom expressions not supported")
                            ]);
                            var a = function t1(e1) {
                                var r = null;
                                if (e1 instanceof cr) r = t1(e1.result);
                                else if (e1 instanceof lr) for(var n = 0, i = e1.args; n < i.length; n += 1){
                                    var a = i[n];
                                    if (r = t1(a)) break;
                                }
                                else (e1 instanceof He || e1 instanceof or) && e1.input instanceof xe && "zoom" === e1.input.name && (r = e1);
                                if (r instanceof Dt) return r;
                                return e1.eachChild(function(e1) {
                                    var n = t1(e1);
                                    n instanceof Dt ? r = n : !r && n ? r = new Dt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : r && n && r !== n && (r = new Dt("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
                                }), r;
                            }(r);
                            if (!a && !i) return Or([
                                new Dt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
                            ]);
                            if (a instanceof Dt) return Or([
                                a
                            ]);
                            if (a instanceof or && !Rr(e1)) return Or([
                                new Dt("", '"interpolate" expressions cannot be used with this property')
                            ]);
                            if (!a) return Ir(new Xr(n ? "constant" : "source", t1.value));
                            var o = a instanceof or ? a.interpolation : void 0;
                            return Ir(new Zr(n ? "camera" : "composite", t1.value, a.labels, o));
                        }
                        Zr.prototype.evaluateWithoutErrorHandling = function(t1, e1, r, n, i, a) {
                            return this._styleExpression.evaluateWithoutErrorHandling(t1, e1, r, n, i, a);
                        }, Zr.prototype.evaluate = function(t1, e1, r, n, i, a) {
                            return this._styleExpression.evaluate(t1, e1, r, n, i, a);
                        }, Zr.prototype.interpolationFactor = function(t1, e1, r) {
                            return this.interpolationType ? or.interpolationFactor(this.interpolationType, t1, e1, r) : 0;
                        };
                        var Kr = function(t1, e1) {
                            this._parameters = t1, this._specification = e1, It(this, function t1(e1, r) {
                                var n, i, a, o = "color" === r.type, s = e1.stops && "object" == typeof e1.stops[0][0], l = s || void 0 !== e1.property, c = s || !l, u = e1.type || (Rr(r) ? "exponential" : "interval");
                                if (o && ((e1 = It({}, e1)).stops && (e1.stops = e1.stops.map(function(t1) {
                                    return [
                                        t1[0],
                                        te.parse(t1[1])
                                    ];
                                })), e1.default ? e1.default = te.parse(e1.default) : e1.default = te.parse(r.default)), e1.colorSpace && "rgb" !== e1.colorSpace && !ar[e1.colorSpace]) throw new Error("Unknown color space: " + e1.colorSpace);
                                if ("exponential" === u) n = Hr;
                                else if ("interval" === u) n = Vr;
                                else if ("categorical" === u) {
                                    n = Ur, i = Object.create(null);
                                    for(var f = 0, h = e1.stops; f < h.length; f += 1){
                                        var p = h[f];
                                        i[p[0]] = p[1];
                                    }
                                    a = typeof e1.stops[0][0];
                                } else {
                                    if ("identity" !== u) throw new Error('Unknown function type "' + u + '"');
                                    n = qr;
                                }
                                if (s) {
                                    for(var d = {}, m = [], g = 0; g < e1.stops.length; g++){
                                        var v = e1.stops[g], y = v[0].zoom;
                                        void 0 === d[y] && (d[y] = {
                                            zoom: y,
                                            type: e1.type,
                                            property: e1.property,
                                            default: e1.default,
                                            stops: []
                                        }, m.push(y)), d[y].stops.push([
                                            v[0].value,
                                            v[1]
                                        ]);
                                    }
                                    for(var x = [], b = 0, _ = m; b < _.length; b += 1){
                                        var w = _[b];
                                        x.push([
                                            d[w].zoom,
                                            t1(d[w], r)
                                        ]);
                                    }
                                    var T = {
                                        name: "linear"
                                    };
                                    return {
                                        kind: "composite",
                                        interpolationType: T,
                                        interpolationFactor: or.interpolationFactor.bind(void 0, T),
                                        zoomStops: x.map(function(t1) {
                                            return t1[0];
                                        }),
                                        evaluate: function(t1, n) {
                                            var i = t1.zoom;
                                            return Hr({
                                                stops: x,
                                                base: e1.base
                                            }, r, i).evaluate(i, n);
                                        }
                                    };
                                }
                                if (c) {
                                    var k = "exponential" === u ? {
                                        name: "exponential",
                                        base: void 0 !== e1.base ? e1.base : 1
                                    } : null;
                                    return {
                                        kind: "camera",
                                        interpolationType: k,
                                        interpolationFactor: or.interpolationFactor.bind(void 0, k),
                                        zoomStops: e1.stops.map(function(t1) {
                                            return t1[0];
                                        }),
                                        evaluate: function(t1) {
                                            var o = t1.zoom;
                                            return n(e1, r, o, i, a);
                                        }
                                    };
                                }
                                return {
                                    kind: "source",
                                    evaluate: function(t1, o) {
                                        var s = o && o.properties ? o.properties[e1.property] : void 0;
                                        return void 0 === s ? jr(e1.default, r.default) : n(e1, r, s, i, a);
                                    }
                                };
                            }(this._parameters, this._specification));
                        };
                        function Qr(t1) {
                            var e1 = t1.key, r = t1.value, n = t1.valueSpec || {}, i = t1.objectElementValidators || {}, a = t1.style, o = t1.styleSpec, s = [], l = Fr(r);
                            if ("object" !== l) return [
                                new Ct(e1, r, "object expected, " + l + " found")
                            ];
                            for(var c in r){
                                var u = c.split(".")[0], f = n[u] || n["*"], h = void 0;
                                if (i[u]) h = i[u];
                                else if (n[u]) h = kn;
                                else if (i["*"]) h = i["*"];
                                else {
                                    if (!n["*"]) {
                                        s.push(new Ct(e1, r[c], 'unknown property "' + c + '"'));
                                        continue;
                                    }
                                    h = kn;
                                }
                                s = s.concat(h({
                                    key: (e1 ? e1 + "." : e1) + c,
                                    value: r[c],
                                    valueSpec: f,
                                    style: a,
                                    styleSpec: o,
                                    object: r,
                                    objectKey: c
                                }, r));
                            }
                            for(var p in n)i[p] || n[p].required && void 0 === n[p].default && void 0 === r[p] && s.push(new Ct(e1, r, 'missing required property "' + p + '"'));
                            return s;
                        }
                        function $r(t1) {
                            var e1 = t1.value, r = t1.valueSpec, n = t1.style, i = t1.styleSpec, a = t1.key, o = t1.arrayElementValidator || kn;
                            if ("array" !== Fr(e1)) return [
                                new Ct(a, e1, "array expected, " + Fr(e1) + " found")
                            ];
                            if (r.length && e1.length !== r.length) return [
                                new Ct(a, e1, "array length " + r.length + " expected, length " + e1.length + " found")
                            ];
                            if (r["min-length"] && e1.length < r["min-length"]) return [
                                new Ct(a, e1, "array length at least " + r["min-length"] + " expected, length " + e1.length + " found")
                            ];
                            var s = {
                                type: r.value,
                                values: r.values
                            };
                            i.$version < 7 && (s.function = r.function), "object" === Fr(r.value) && (s = r.value);
                            for(var l = [], c = 0; c < e1.length; c++)l = l.concat(o({
                                array: e1,
                                arrayIndex: c,
                                value: e1[c],
                                valueSpec: s,
                                style: n,
                                styleSpec: i,
                                key: a + "[" + c + "]"
                            }));
                            return l;
                        }
                        function tn(t1) {
                            var e1 = t1.key, r = t1.value, n = t1.valueSpec, i = Fr(r);
                            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [
                                new Ct(e1, r, "number expected, " + i + " found")
                            ] : "minimum" in n && r < n.minimum ? [
                                new Ct(e1, r, r + " is less than the minimum value " + n.minimum)
                            ] : "maximum" in n && r > n.maximum ? [
                                new Ct(e1, r, r + " is greater than the maximum value " + n.maximum)
                            ] : [];
                        }
                        function en(t1) {
                            var e1, r, n, i = t1.valueSpec, a = Ot(t1.value.type), o = {}, s = "categorical" !== a && void 0 === t1.value.property, l = !s, c = "array" === Fr(t1.value.stops) && "array" === Fr(t1.value.stops[0]) && "object" === Fr(t1.value.stops[0][0]), u = Qr({
                                key: t1.key,
                                value: t1.value,
                                valueSpec: t1.styleSpec.function,
                                style: t1.style,
                                styleSpec: t1.styleSpec,
                                objectElementValidators: {
                                    stops: function(t1) {
                                        if ("identity" === a) return [
                                            new Ct(t1.key, t1.value, 'identity function may not have a "stops" property')
                                        ];
                                        var e1 = [], r = t1.value;
                                        e1 = e1.concat($r({
                                            key: t1.key,
                                            value: r,
                                            valueSpec: t1.valueSpec,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec,
                                            arrayElementValidator: f
                                        })), "array" === Fr(r) && 0 === r.length && e1.push(new Ct(t1.key, r, "array must have at least one stop"));
                                        return e1;
                                    },
                                    default: function(t1) {
                                        return kn({
                                            key: t1.key,
                                            value: t1.value,
                                            valueSpec: i,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec
                                        });
                                    }
                                }
                            });
                            return "identity" === a && s && u.push(new Ct(t1.key, t1.value, 'missing required property "property"')), "identity" === a || t1.value.stops || u.push(new Ct(t1.key, t1.value, 'missing required property "stops"')), "exponential" === a && t1.valueSpec.expression && !Rr(t1.valueSpec) && u.push(new Ct(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (l && !zr(t1.valueSpec) ? u.push(new Ct(t1.key, t1.value, "property functions not supported")) : s && !Dr(t1.valueSpec) && u.push(new Ct(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== a && !c || void 0 !== t1.value.property || u.push(new Ct(t1.key, t1.value, '"property" property is required')), u;
                            function f(t1) {
                                var e1 = [], a = t1.value, s = t1.key;
                                if ("array" !== Fr(a)) return [
                                    new Ct(s, a, "array expected, " + Fr(a) + " found")
                                ];
                                if (2 !== a.length) return [
                                    new Ct(s, a, "array length 2 expected, length " + a.length + " found")
                                ];
                                if (c) {
                                    if ("object" !== Fr(a[0])) return [
                                        new Ct(s, a, "object expected, " + Fr(a[0]) + " found")
                                    ];
                                    if (void 0 === a[0].zoom) return [
                                        new Ct(s, a, "object stop key must have zoom")
                                    ];
                                    if (void 0 === a[0].value) return [
                                        new Ct(s, a, "object stop key must have value")
                                    ];
                                    if (n && n > Ot(a[0].zoom)) return [
                                        new Ct(s, a[0].zoom, "stop zoom values must appear in ascending order")
                                    ];
                                    Ot(a[0].zoom) !== n && (n = Ot(a[0].zoom), r = void 0, o = {}), e1 = e1.concat(Qr({
                                        key: s + "[0]",
                                        value: a[0],
                                        valueSpec: {
                                            zoom: {}
                                        },
                                        style: t1.style,
                                        styleSpec: t1.styleSpec,
                                        objectElementValidators: {
                                            zoom: tn,
                                            value: h
                                        }
                                    }));
                                } else e1 = e1.concat(h({
                                    key: s + "[0]",
                                    value: a[0],
                                    valueSpec: {},
                                    style: t1.style,
                                    styleSpec: t1.styleSpec
                                }, a));
                                return Yr(zt(a[1])) ? e1.concat([
                                    new Ct(s + "[1]", a[1], "expressions are not allowed in function stops.")
                                ]) : e1.concat(kn({
                                    key: s + "[1]",
                                    value: a[1],
                                    valueSpec: i,
                                    style: t1.style,
                                    styleSpec: t1.styleSpec
                                }));
                            }
                            function h(t1, n) {
                                var s = Fr(t1.value), l = Ot(t1.value), c = null !== t1.value ? t1.value : n;
                                if (e1) {
                                    if (s !== e1) return [
                                        new Ct(t1.key, c, s + " stop domain type must match previous stop domain type " + e1)
                                    ];
                                } else e1 = s;
                                if ("number" !== s && "string" !== s && "boolean" !== s) return [
                                    new Ct(t1.key, c, "stop domain value must be a number, string, or boolean")
                                ];
                                if ("number" !== s && "categorical" !== a) {
                                    var u = "number expected, " + s + " found";
                                    return zr(i) && void 0 === a && (u += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                                        new Ct(t1.key, c, u)
                                    ];
                                }
                                return "categorical" !== a || "number" !== s || isFinite(l) && Math.floor(l) === l ? "categorical" !== a && "number" === s && void 0 !== r && l < r ? [
                                    new Ct(t1.key, c, "stop domain values must appear in ascending order")
                                ] : (r = l, "categorical" === a && l in o ? [
                                    new Ct(t1.key, c, "stop domain values must be unique")
                                ] : (o[l] = !0, [])) : [
                                    new Ct(t1.key, c, "integer expected, found " + l)
                                ];
                            }
                        }
                        function rn(t1) {
                            var e1 = ("property" === t1.expressionContext ? Jr : Wr)(zt(t1.value), t1.valueSpec);
                            if ("error" === e1.result) return e1.value.map(function(e1) {
                                return new Ct("" + t1.key + e1.key, t1.value, e1.message);
                            });
                            var r = e1.value.expression || e1.value._styleExpression.expression;
                            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !r.outputDefined()) return [
                                new Ct(t1.key, t1.value, 'Invalid data expression for "' + t1.propertyKey + '". Output values must be contained as literals within the expression.')
                            ];
                            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !Be(r)) return [
                                new Ct(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
                            ];
                            if ("filter" === t1.expressionContext && !Be(r)) return [
                                new Ct(t1.key, t1.value, '"feature-state" data expressions are not supported with filters.')
                            ];
                            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                                if (!Ne(r, [
                                    "zoom",
                                    "feature-state"
                                ])) return [
                                    new Ct(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                                ];
                                if ("cluster-initial" === t1.expressionContext && !Fe(r)) return [
                                    new Ct(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                                ];
                            }
                            return [];
                        }
                        function nn(t1) {
                            var e1 = t1.key, r = t1.value, n = t1.valueSpec, i = [];
                            return Array.isArray(n.values) ? -1 === n.values.indexOf(Ot(r)) && i.push(new Ct(e1, r, "expected one of [" + n.values.join(", ") + "], " + JSON.stringify(r) + " found")) : -1 === Object.keys(n.values).indexOf(Ot(r)) && i.push(new Ct(e1, r, "expected one of [" + Object.keys(n.values).join(", ") + "], " + JSON.stringify(r) + " found")), i;
                        }
                        function an(t1) {
                            if (!0 === t1 || !1 === t1) return !0;
                            if (!Array.isArray(t1) || 0 === t1.length) return !1;
                            switch(t1[0]){
                                case "has":
                                    return t1.length >= 2 && "$id" !== t1[1] && "$type" !== t1[1];
                                case "in":
                                    return t1.length >= 3 && ("string" != typeof t1[1] || Array.isArray(t1[2]));
                                case "!in":
                                case "!has":
                                case "none":
                                    return !1;
                                case "==":
                                case "!=":
                                case ">":
                                case ">=":
                                case "<":
                                case "<=":
                                    return 3 !== t1.length || Array.isArray(t1[1]) || Array.isArray(t1[2]);
                                case "any":
                                case "all":
                                    for(var e1 = 0, r = t1.slice(1); e1 < r.length; e1 += 1){
                                        var n = r[e1];
                                        if (!an(n) && "boolean" != typeof n) return !1;
                                    }
                                    return !0;
                                default:
                                    return !0;
                            }
                        }
                        Kr.deserialize = function(t1) {
                            return new Kr(t1._parameters, t1._specification);
                        }, Kr.serialize = function(t1) {
                            return {
                                _parameters: t1._parameters,
                                _specification: t1._specification
                            };
                        };
                        var on = {
                            type: "boolean",
                            default: !1,
                            transition: !1,
                            "property-type": "data-driven",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            }
                        };
                        function sn(t1) {
                            if (null == t1) return {
                                filter: function() {
                                    return !0;
                                },
                                needGeometry: !1
                            };
                            an(t1) || (t1 = cn(t1));
                            var e1 = Wr(t1, on);
                            if ("error" === e1.result) throw new Error(e1.value.map(function(t1) {
                                return t1.key + ": " + t1.message;
                            }).join(", "));
                            return {
                                filter: function(t1, r, n) {
                                    return e1.value.evaluate(t1, r, {}, n);
                                },
                                needGeometry: function t1(e1) {
                                    if (!Array.isArray(e1)) return !1;
                                    if ("within" === e1[0]) return !0;
                                    for(var r = 1; r < e1.length; r++)if (t1(e1[r])) return !0;
                                    return !1;
                                }(t1)
                            };
                        }
                        function ln(t1, e1) {
                            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
                        }
                        function cn(t1) {
                            if (!t1) return !0;
                            var e1, r = t1[0];
                            return t1.length <= 1 ? "any" !== r : "==" === r ? un(t1[1], t1[2], "==") : "!=" === r ? pn(un(t1[1], t1[2], "==")) : "<" === r || ">" === r || "<=" === r || ">=" === r ? un(t1[1], t1[2], r) : "any" === r ? (e1 = t1.slice(1), [
                                "any"
                            ].concat(e1.map(cn))) : "all" === r ? [
                                "all"
                            ].concat(t1.slice(1).map(cn)) : "none" === r ? [
                                "all"
                            ].concat(t1.slice(1).map(cn).map(pn)) : "in" === r ? fn(t1[1], t1.slice(2)) : "!in" === r ? pn(fn(t1[1], t1.slice(2))) : "has" === r ? hn(t1[1]) : "!has" === r ? pn(hn(t1[1])) : "within" !== r || t1;
                        }
                        function un(t1, e1, r) {
                            switch(t1){
                                case "$type":
                                    return [
                                        "filter-type-" + r,
                                        e1
                                    ];
                                case "$id":
                                    return [
                                        "filter-id-" + r,
                                        e1
                                    ];
                                default:
                                    return [
                                        "filter-" + r,
                                        t1,
                                        e1
                                    ];
                            }
                        }
                        function fn(t1, e1) {
                            if (0 === e1.length) return !1;
                            switch(t1){
                                case "$type":
                                    return [
                                        "filter-type-in",
                                        [
                                            "literal",
                                            e1
                                        ]
                                    ];
                                case "$id":
                                    return [
                                        "filter-id-in",
                                        [
                                            "literal",
                                            e1
                                        ]
                                    ];
                                default:
                                    return e1.length > 200 && !e1.some(function(t1) {
                                        return typeof t1 != typeof e1[0];
                                    }) ? [
                                        "filter-in-large",
                                        t1,
                                        [
                                            "literal",
                                            e1.sort(ln)
                                        ]
                                    ] : [
                                        "filter-in-small",
                                        t1,
                                        [
                                            "literal",
                                            e1
                                        ]
                                    ];
                            }
                        }
                        function hn(t1) {
                            switch(t1){
                                case "$type":
                                    return !0;
                                case "$id":
                                    return [
                                        "filter-has-id"
                                    ];
                                default:
                                    return [
                                        "filter-has",
                                        t1
                                    ];
                            }
                        }
                        function pn(t1) {
                            return [
                                "!",
                                t1
                            ];
                        }
                        function dn(t1) {
                            return an(zt(t1.value)) ? rn(It({}, t1, {
                                expressionContext: "filter",
                                valueSpec: {
                                    value: "boolean"
                                }
                            })) : function t1(e1) {
                                var r = e1.value, n = e1.key;
                                if ("array" !== Fr(r)) return [
                                    new Ct(n, r, "array expected, " + Fr(r) + " found")
                                ];
                                var i, a = e1.styleSpec, o = [];
                                if (r.length < 1) return [
                                    new Ct(n, r, "filter array must have at least 1 element")
                                ];
                                switch(o = o.concat(nn({
                                    key: n + "[0]",
                                    value: r[0],
                                    valueSpec: a.filter_operator,
                                    style: e1.style,
                                    styleSpec: e1.styleSpec
                                })), Ot(r[0])){
                                    case "<":
                                    case "<=":
                                    case ">":
                                    case ">=":
                                        r.length >= 2 && "$type" === Ot(r[1]) && o.push(new Ct(n, r, '"$type" cannot be use with operator "' + r[0] + '"'));
                                    case "==":
                                    case "!=":
                                        3 !== r.length && o.push(new Ct(n, r, 'filter array for operator "' + r[0] + '" must have 3 elements'));
                                    case "in":
                                    case "!in":
                                        r.length >= 2 && "string" !== (i = Fr(r[1])) && o.push(new Ct(n + "[1]", r[1], "string expected, " + i + " found"));
                                        for(var s = 2; s < r.length; s++)i = Fr(r[s]), "$type" === Ot(r[1]) ? o = o.concat(nn({
                                            key: n + "[" + s + "]",
                                            value: r[s],
                                            valueSpec: a.geometry_type,
                                            style: e1.style,
                                            styleSpec: e1.styleSpec
                                        })) : "string" !== i && "number" !== i && "boolean" !== i && o.push(new Ct(n + "[" + s + "]", r[s], "string, number, or boolean expected, " + i + " found"));
                                        break;
                                    case "any":
                                    case "all":
                                    case "none":
                                        for(var l = 1; l < r.length; l++)o = o.concat(t1({
                                            key: n + "[" + l + "]",
                                            value: r[l],
                                            style: e1.style,
                                            styleSpec: e1.styleSpec
                                        }));
                                        break;
                                    case "has":
                                    case "!has":
                                        i = Fr(r[1]), 2 !== r.length ? o.push(new Ct(n, r, 'filter array for "' + r[0] + '" operator must have 2 elements')) : "string" !== i && o.push(new Ct(n + "[1]", r[1], "string expected, " + i + " found"));
                                        break;
                                    case "within":
                                        i = Fr(r[1]), 2 !== r.length ? o.push(new Ct(n, r, 'filter array for "' + r[0] + '" operator must have 2 elements')) : "object" !== i && o.push(new Ct(n + "[1]", r[1], "object expected, " + i + " found"));
                                }
                                return o;
                            }(t1);
                        }
                        function mn(t1, e1) {
                            var r = t1.key, n = t1.style, i = t1.styleSpec, a = t1.value, o = t1.objectKey, s = i[e1 + "_" + t1.layerType];
                            if (!s) return [];
                            var l = o.match(/^(.*)-transition$/);
                            if ("paint" === e1 && l && s[l[1]] && s[l[1]].transition) return kn({
                                key: r,
                                value: a,
                                valueSpec: i.transition,
                                style: n,
                                styleSpec: i
                            });
                            var c, u = t1.valueSpec || s[o];
                            if (!u) return [
                                new Ct(r, a, 'unknown property "' + o + '"')
                            ];
                            if ("string" === Fr(a) && zr(u) && !u.tokens && (c = /^{([^}]+)}$/.exec(a))) return [
                                new Ct(r, a, '"' + o + '" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": ' + JSON.stringify(c[1]) + " }`.")
                            ];
                            var f = [];
                            return "symbol" === t1.layerType && ("text-field" === o && n && !n.glyphs && f.push(new Ct(r, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === o && Br(zt(a)) && "identity" === Ot(a.type) && f.push(new Ct(r, a, '"text-font" does not support identity functions'))), f.concat(kn({
                                key: t1.key,
                                value: a,
                                valueSpec: u,
                                style: n,
                                styleSpec: i,
                                expressionContext: "property",
                                propertyType: e1,
                                propertyKey: o
                            }));
                        }
                        function gn(t1) {
                            return mn(t1, "paint");
                        }
                        function vn(t1) {
                            return mn(t1, "layout");
                        }
                        function yn(t1) {
                            var e1 = [], r = t1.value, n = t1.key, i = t1.style, a = t1.styleSpec;
                            r.type || r.ref || e1.push(new Ct(n, r, 'either "type" or "ref" is required'));
                            var o, s = Ot(r.type), l = Ot(r.ref);
                            if (r.id) for(var c = Ot(r.id), u = 0; u < t1.arrayIndex; u++){
                                var f = i.layers[u];
                                Ot(f.id) === c && e1.push(new Ct(n, r.id, 'duplicate layer id "' + r.id + '", previously used at line ' + f.id.__line__));
                            }
                            if ("ref" in r) [
                                "type",
                                "source",
                                "source-layer",
                                "filter",
                                "layout"
                            ].forEach(function(t1) {
                                t1 in r && e1.push(new Ct(n, r[t1], '"' + t1 + '" is prohibited for ref layers'));
                            }), i.layers.forEach(function(t1) {
                                Ot(t1.id) === l && (o = t1);
                            }), o ? o.ref ? e1.push(new Ct(n, r.ref, "ref cannot reference another ref layer")) : s = Ot(o.type) : e1.push(new Ct(n, r.ref, 'ref layer "' + l + '" not found'));
                            else if ("background" !== s) {
                                if (r.source) {
                                    var h = i.sources && i.sources[r.source], p = h && Ot(h.type);
                                    h ? "vector" === p && "raster" === s ? e1.push(new Ct(n, r.source, 'layer "' + r.id + '" requires a raster source')) : "raster" === p && "raster" !== s ? e1.push(new Ct(n, r.source, 'layer "' + r.id + '" requires a vector source')) : "vector" !== p || r["source-layer"] ? "raster-dem" === p && "hillshade" !== s ? e1.push(new Ct(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== s || !r.paint || !r.paint["line-gradient"] || "geojson" === p && h.lineMetrics || e1.push(new Ct(n, r, 'layer "' + r.id + '" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')) : e1.push(new Ct(n, r, 'layer "' + r.id + '" must specify a "source-layer"')) : e1.push(new Ct(n, r.source, 'source "' + r.source + '" not found'));
                                } else e1.push(new Ct(n, r, 'missing required property "source"'));
                            }
                            return e1 = e1.concat(Qr({
                                key: n,
                                value: r,
                                valueSpec: a.layer,
                                style: t1.style,
                                styleSpec: t1.styleSpec,
                                objectElementValidators: {
                                    "*": function() {
                                        return [];
                                    },
                                    type: function() {
                                        return kn({
                                            key: n + ".type",
                                            value: r.type,
                                            valueSpec: a.layer.type,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec,
                                            object: r,
                                            objectKey: "type"
                                        });
                                    },
                                    filter: dn,
                                    layout: function(t1) {
                                        return Qr({
                                            layer: r,
                                            key: t1.key,
                                            value: t1.value,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec,
                                            objectElementValidators: {
                                                "*": function(t1) {
                                                    return vn(It({
                                                        layerType: s
                                                    }, t1));
                                                }
                                            }
                                        });
                                    },
                                    paint: function(t1) {
                                        return Qr({
                                            layer: r,
                                            key: t1.key,
                                            value: t1.value,
                                            style: t1.style,
                                            styleSpec: t1.styleSpec,
                                            objectElementValidators: {
                                                "*": function(t1) {
                                                    return gn(It({
                                                        layerType: s
                                                    }, t1));
                                                }
                                            }
                                        });
                                    }
                                }
                            }));
                        }
                        function xn(t1) {
                            var e1 = t1.value, r = t1.key, n = Fr(e1);
                            return "string" !== n ? [
                                new Ct(r, e1, "string expected, " + n + " found")
                            ] : [];
                        }
                        var bn = {
                            promoteId: function(t1) {
                                var e1 = t1.key, r = t1.value;
                                if ("string" === Fr(r)) return xn({
                                    key: e1,
                                    value: r
                                });
                                var n = [];
                                for(var i in r)n.push.apply(n, xn({
                                    key: e1 + "." + i,
                                    value: r[i]
                                }));
                                return n;
                            }
                        };
                        function _n(t1) {
                            var e1 = t1.value, r = t1.key, n = t1.styleSpec, i = t1.style;
                            if (!e1.type) return [
                                new Ct(r, e1, '"type" is required')
                            ];
                            var a, o = Ot(e1.type);
                            switch(o){
                                case "vector":
                                case "raster":
                                case "raster-dem":
                                    return a = Qr({
                                        key: r,
                                        value: e1,
                                        valueSpec: n["source_" + o.replace("-", "_")],
                                        style: t1.style,
                                        styleSpec: n,
                                        objectElementValidators: bn
                                    });
                                case "geojson":
                                    if (a = Qr({
                                        key: r,
                                        value: e1,
                                        valueSpec: n.source_geojson,
                                        style: i,
                                        styleSpec: n,
                                        objectElementValidators: bn
                                    }), e1.cluster) for(var s in e1.clusterProperties){
                                        var l = e1.clusterProperties[s], c = l[0], u = l[1], f = "string" == typeof c ? [
                                            c,
                                            [
                                                "accumulated"
                                            ],
                                            [
                                                "get",
                                                s
                                            ]
                                        ] : c;
                                        a.push.apply(a, rn({
                                            key: r + "." + s + ".map",
                                            value: u,
                                            expressionContext: "cluster-map"
                                        })), a.push.apply(a, rn({
                                            key: r + "." + s + ".reduce",
                                            value: f,
                                            expressionContext: "cluster-reduce"
                                        }));
                                    }
                                    return a;
                                case "video":
                                    return Qr({
                                        key: r,
                                        value: e1,
                                        valueSpec: n.source_video,
                                        style: i,
                                        styleSpec: n
                                    });
                                case "image":
                                    return Qr({
                                        key: r,
                                        value: e1,
                                        valueSpec: n.source_image,
                                        style: i,
                                        styleSpec: n
                                    });
                                case "canvas":
                                    return [
                                        new Ct(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                                    ];
                                default:
                                    return nn({
                                        key: r + ".type",
                                        value: e1.type,
                                        valueSpec: {
                                            values: [
                                                "vector",
                                                "raster",
                                                "raster-dem",
                                                "geojson",
                                                "video",
                                                "image"
                                            ]
                                        },
                                        style: i,
                                        styleSpec: n
                                    });
                            }
                        }
                        function wn(t1) {
                            var e1 = t1.value, r = t1.styleSpec, n = r.light, i = t1.style, a = [], o = Fr(e1);
                            if (void 0 === e1) return a;
                            if ("object" !== o) return a = a.concat([
                                new Ct("light", e1, "object expected, " + o + " found")
                            ]);
                            for(var s in e1){
                                var l = s.match(/^(.*)-transition$/);
                                a = l && n[l[1]] && n[l[1]].transition ? a.concat(kn({
                                    key: s,
                                    value: e1[s],
                                    valueSpec: r.transition,
                                    style: i,
                                    styleSpec: r
                                })) : n[s] ? a.concat(kn({
                                    key: s,
                                    value: e1[s],
                                    valueSpec: n[s],
                                    style: i,
                                    styleSpec: r
                                })) : a.concat([
                                    new Ct(s, e1[s], 'unknown property "' + s + '"')
                                ]);
                            }
                            return a;
                        }
                        var Tn = {
                            "*": function() {
                                return [];
                            },
                            array: $r,
                            boolean: function(t1) {
                                var e1 = t1.value, r = t1.key, n = Fr(e1);
                                return "boolean" !== n ? [
                                    new Ct(r, e1, "boolean expected, " + n + " found")
                                ] : [];
                            },
                            number: tn,
                            color: function(t1) {
                                var e1 = t1.key, r = t1.value, n = Fr(r);
                                return "string" !== n ? [
                                    new Ct(e1, r, "color expected, " + n + " found")
                                ] : null === $t(r) ? [
                                    new Ct(e1, r, 'color expected, "' + r + '" found')
                                ] : [];
                            },
                            constants: Pt,
                            enum: nn,
                            filter: dn,
                            function: en,
                            layer: yn,
                            object: Qr,
                            source: _n,
                            light: wn,
                            string: xn,
                            formatted: function(t1) {
                                return 0 === xn(t1).length ? [] : rn(t1);
                            },
                            resolvedImage: function(t1) {
                                return 0 === xn(t1).length ? [] : rn(t1);
                            }
                        };
                        function kn(t1) {
                            var e1 = t1.value, r = t1.valueSpec, n = t1.styleSpec;
                            return r.expression && Br(Ot(e1)) ? en(t1) : r.expression && Yr(zt(e1)) ? rn(t1) : r.type && Tn[r.type] ? Tn[r.type](t1) : Qr(It({}, t1, {
                                valueSpec: r.type ? n[r.type] : r
                            }));
                        }
                        function An(t1) {
                            var e1 = t1.value, r = t1.key, n = xn(t1);
                            return n.length || (-1 === e1.indexOf("{fontstack}") && n.push(new Ct(r, e1, '"glyphs" url must include a "{fontstack}" token')), -1 === e1.indexOf("{range}") && n.push(new Ct(r, e1, '"glyphs" url must include a "{range}" token'))), n;
                        }
                        function Mn(t1, e1) {
                            void 0 === e1 && (e1 = Lt);
                            var r = [];
                            return r = r.concat(kn({
                                key: "",
                                value: t1,
                                valueSpec: e1.$root,
                                styleSpec: e1,
                                style: t1,
                                objectElementValidators: {
                                    glyphs: An,
                                    "*": function() {
                                        return [];
                                    }
                                }
                            })), t1.constants && (r = r.concat(Pt({
                                key: "constants",
                                value: t1.constants,
                                style: t1,
                                styleSpec: e1
                            }))), Sn(r);
                        }
                        function Sn(t1) {
                            return [].concat(t1).sort(function(t1, e1) {
                                return t1.line - e1.line;
                            });
                        }
                        function En(t1) {
                            return function() {
                                for(var e1 = [], r = arguments.length; r--;)e1[r] = arguments[r];
                                return Sn(t1.apply(this, e1));
                            };
                        }
                        Mn.source = En(_n), Mn.light = En(wn), Mn.layer = En(yn), Mn.filter = En(dn), Mn.paintProperty = En(gn), Mn.layoutProperty = En(vn);
                        var Ln = Mn, Cn = Ln.light, Pn = Ln.paintProperty, In = Ln.layoutProperty;
                        function On(t1, e1) {
                            var r = !1;
                            if (e1 && e1.length) for(var n = 0, i = e1; n < i.length; n += 1){
                                var a = i[n];
                                t1.fire(new St(new Error(a.message))), r = !0;
                            }
                            return r;
                        }
                        var zn = Dn;
                        function Dn(t1, e1, r) {
                            var n = this.cells = [];
                            if (t1 instanceof ArrayBuffer) {
                                this.arrayBuffer = t1;
                                var i = new Int32Array(this.arrayBuffer);
                                t1 = i[0], e1 = i[1], r = i[2], this.d = e1 + 2 * r;
                                for(var a = 0; a < this.d * this.d; a++){
                                    var o = i[3 + a], s = i[3 + a + 1];
                                    n.push(o === s ? null : i.subarray(o, s));
                                }
                                var l = i[3 + n.length], c = i[3 + n.length + 1];
                                this.keys = i.subarray(l, c), this.bboxes = i.subarray(c), this.insert = this._insertReadonly;
                            } else {
                                this.d = e1 + 2 * r;
                                for(var u = 0; u < this.d * this.d; u++)n.push([]);
                                this.keys = [], this.bboxes = [];
                            }
                            this.n = e1, this.extent = t1, this.padding = r, this.scale = e1 / t1, this.uid = 0;
                            var f = r / e1 * t1;
                            this.min = -f, this.max = t1 + f;
                        }
                        Dn.prototype.insert = function(t1, e1, r, n, i) {
                            this._forEachCell(e1, r, n, i, this._insertCell, this.uid++), this.keys.push(t1), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
                        }, Dn.prototype._insertReadonly = function() {
                            throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
                        }, Dn.prototype._insertCell = function(t1, e1, r, n, i, a) {
                            this.cells[i].push(a);
                        }, Dn.prototype.query = function(t1, e1, r, n, i) {
                            var a = this.min, o = this.max;
                            if (t1 <= a && e1 <= a && o <= r && o <= n && !i) return Array.prototype.slice.call(this.keys);
                            var s = [];
                            return this._forEachCell(t1, e1, r, n, this._queryCell, s, {}, i), s;
                        }, Dn.prototype._queryCell = function(t1, e1, r, n, i, a, o, s) {
                            var l = this.cells[i];
                            if (null !== l) for(var c = this.keys, u = this.bboxes, f = 0; f < l.length; f++){
                                var h = l[f];
                                if (void 0 === o[h]) {
                                    var p = 4 * h;
                                    (s ? s(u[p + 0], u[p + 1], u[p + 2], u[p + 3]) : t1 <= u[p + 2] && e1 <= u[p + 3] && r >= u[p + 0] && n >= u[p + 1]) ? (o[h] = !0, a.push(c[h])) : o[h] = !1;
                                }
                            }
                        }, Dn.prototype._forEachCell = function(t1, e1, r, n, i, a, o, s) {
                            for(var l = this._convertToCellCoord(t1), c = this._convertToCellCoord(e1), u = this._convertToCellCoord(r), f = this._convertToCellCoord(n), h = l; h <= u; h++)for(var p = c; p <= f; p++){
                                var d = this.d * p + h;
                                if ((!s || s(this._convertFromCellCoord(h), this._convertFromCellCoord(p), this._convertFromCellCoord(h + 1), this._convertFromCellCoord(p + 1))) && i.call(this, t1, e1, r, n, d, a, o, s)) return;
                            }
                        }, Dn.prototype._convertFromCellCoord = function(t1) {
                            return (t1 - this.padding) / this.scale;
                        }, Dn.prototype._convertToCellCoord = function(t1) {
                            return Math.max(0, Math.min(this.d - 1, Math.floor(t1 * this.scale) + this.padding));
                        }, Dn.prototype.toArrayBuffer = function() {
                            if (this.arrayBuffer) return this.arrayBuffer;
                            for(var t1 = this.cells, e1 = 3 + this.cells.length + 1 + 1, r = 0, n = 0; n < this.cells.length; n++)r += this.cells[n].length;
                            var i = new Int32Array(e1 + r + this.keys.length + this.bboxes.length);
                            i[0] = this.extent, i[1] = this.n, i[2] = this.padding;
                            for(var a = e1, o = 0; o < t1.length; o++){
                                var s = t1[o];
                                i[3 + o] = a, i.set(s, a), a += s.length;
                            }
                            return i[3 + t1.length] = a, i.set(this.keys, a), a += this.keys.length, i[3 + t1.length + 1] = a, i.set(this.bboxes, a), a += this.bboxes.length, i.buffer;
                        };
                        var Rn = self.ImageData, Fn = self.ImageBitmap, Bn = {};
                        function Nn(t1, e1, r) {
                            void 0 === r && (r = {}), Object.defineProperty(e1, "_classRegistryKey", {
                                value: t1,
                                writeable: !1
                            }), Bn[t1] = {
                                klass: e1,
                                omit: r.omit || [],
                                shallow: r.shallow || []
                            };
                        }
                        for(var jn in Nn("Object", Object), zn.serialize = function(t1, e1) {
                            var r = t1.toArrayBuffer();
                            return e1 && e1.push(r), {
                                buffer: r
                            };
                        }, zn.deserialize = function(t1) {
                            return new zn(t1.buffer);
                        }, Nn("Grid", zn), Nn("Color", te), Nn("Error", Error), Nn("ResolvedImage", ie), Nn("StylePropertyFunction", Kr), Nn("StyleExpression", Gr, {
                            omit: [
                                "_evaluator"
                            ]
                        }), Nn("ZoomDependentExpression", Zr), Nn("ZoomConstantExpression", Xr), Nn("CompoundExpression", xe, {
                            omit: [
                                "_evaluate"
                            ]
                        }), Sr)Sr[jn]._classRegistryKey || Nn("Expression_" + jn, Sr[jn]);
                        function Un(t1) {
                            return t1 && "undefined" != typeof ArrayBuffer && (t1 instanceof ArrayBuffer || t1.constructor && "ArrayBuffer" === t1.constructor.name);
                        }
                        function Vn(t1) {
                            return Fn && t1 instanceof Fn;
                        }
                        function Hn(t1, e1) {
                            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp) return t1;
                            if (Un(t1) || Vn(t1)) return e1 && e1.push(t1), t1;
                            if (ArrayBuffer.isView(t1)) {
                                var r = t1;
                                return e1 && e1.push(r.buffer), r;
                            }
                            if (t1 instanceof Rn) return e1 && e1.push(t1.data.buffer), t1;
                            if (Array.isArray(t1)) {
                                for(var n = [], i = 0, a = t1; i < a.length; i += 1){
                                    var o = a[i];
                                    n.push(Hn(o, e1));
                                }
                                return n;
                            }
                            if ("object" == typeof t1) {
                                var s = t1.constructor, l = s._classRegistryKey;
                                if (!l) throw new Error("can't serialize object of unregistered class");
                                var c = s.serialize ? s.serialize(t1, e1) : {};
                                if (!s.serialize) {
                                    for(var u in t1)if (t1.hasOwnProperty(u) && !(Bn[l].omit.indexOf(u) >= 0)) {
                                        var f = t1[u];
                                        c[u] = Bn[l].shallow.indexOf(u) >= 0 ? f : Hn(f, e1);
                                    }
                                    t1 instanceof Error && (c.message = t1.message);
                                }
                                if (c.$name) throw new Error("$name property is reserved for worker serialization logic.");
                                return "Object" !== l && (c.$name = l), c;
                            }
                            throw new Error("can't serialize object of type " + typeof t1);
                        }
                        function qn(t1) {
                            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || Un(t1) || Vn(t1) || ArrayBuffer.isView(t1) || t1 instanceof Rn) return t1;
                            if (Array.isArray(t1)) return t1.map(qn);
                            if ("object" == typeof t1) {
                                var e1 = t1.$name || "Object", r = Bn[e1].klass;
                                if (!r) throw new Error("can't deserialize unregistered class " + e1);
                                if (r.deserialize) return r.deserialize(t1);
                                for(var n = Object.create(r.prototype), i = 0, a = Object.keys(t1); i < a.length; i += 1){
                                    var o = a[i];
                                    if ("$name" !== o) {
                                        var s = t1[o];
                                        n[o] = Bn[e1].shallow.indexOf(o) >= 0 ? s : qn(s);
                                    }
                                }
                                return n;
                            }
                            throw new Error("can't deserialize object of type " + typeof t1);
                        }
                        var Gn = function() {
                            this.first = !0;
                        };
                        Gn.prototype.update = function(t1, e1) {
                            var r = Math.floor(t1);
                            return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t1, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e1) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e1), t1 !== this.lastZoom && (this.lastZoom = t1, this.lastFloorZoom = r, !0));
                        };
                        var Yn = {
                            "Latin-1 Supplement": function(t1) {
                                return t1 >= 128 && t1 <= 255;
                            },
                            Arabic: function(t1) {
                                return t1 >= 1536 && t1 <= 1791;
                            },
                            "Arabic Supplement": function(t1) {
                                return t1 >= 1872 && t1 <= 1919;
                            },
                            "Arabic Extended-A": function(t1) {
                                return t1 >= 2208 && t1 <= 2303;
                            },
                            "Hangul Jamo": function(t1) {
                                return t1 >= 4352 && t1 <= 4607;
                            },
                            "Unified Canadian Aboriginal Syllabics": function(t1) {
                                return t1 >= 5120 && t1 <= 5759;
                            },
                            Khmer: function(t1) {
                                return t1 >= 6016 && t1 <= 6143;
                            },
                            "Unified Canadian Aboriginal Syllabics Extended": function(t1) {
                                return t1 >= 6320 && t1 <= 6399;
                            },
                            "General Punctuation": function(t1) {
                                return t1 >= 8192 && t1 <= 8303;
                            },
                            "Letterlike Symbols": function(t1) {
                                return t1 >= 8448 && t1 <= 8527;
                            },
                            "Number Forms": function(t1) {
                                return t1 >= 8528 && t1 <= 8591;
                            },
                            "Miscellaneous Technical": function(t1) {
                                return t1 >= 8960 && t1 <= 9215;
                            },
                            "Control Pictures": function(t1) {
                                return t1 >= 9216 && t1 <= 9279;
                            },
                            "Optical Character Recognition": function(t1) {
                                return t1 >= 9280 && t1 <= 9311;
                            },
                            "Enclosed Alphanumerics": function(t1) {
                                return t1 >= 9312 && t1 <= 9471;
                            },
                            "Geometric Shapes": function(t1) {
                                return t1 >= 9632 && t1 <= 9727;
                            },
                            "Miscellaneous Symbols": function(t1) {
                                return t1 >= 9728 && t1 <= 9983;
                            },
                            "Miscellaneous Symbols and Arrows": function(t1) {
                                return t1 >= 11008 && t1 <= 11263;
                            },
                            "CJK Radicals Supplement": function(t1) {
                                return t1 >= 11904 && t1 <= 12031;
                            },
                            "Kangxi Radicals": function(t1) {
                                return t1 >= 12032 && t1 <= 12255;
                            },
                            "Ideographic Description Characters": function(t1) {
                                return t1 >= 12272 && t1 <= 12287;
                            },
                            "CJK Symbols and Punctuation": function(t1) {
                                return t1 >= 12288 && t1 <= 12351;
                            },
                            Hiragana: function(t1) {
                                return t1 >= 12352 && t1 <= 12447;
                            },
                            Katakana: function(t1) {
                                return t1 >= 12448 && t1 <= 12543;
                            },
                            Bopomofo: function(t1) {
                                return t1 >= 12544 && t1 <= 12591;
                            },
                            "Hangul Compatibility Jamo": function(t1) {
                                return t1 >= 12592 && t1 <= 12687;
                            },
                            Kanbun: function(t1) {
                                return t1 >= 12688 && t1 <= 12703;
                            },
                            "Bopomofo Extended": function(t1) {
                                return t1 >= 12704 && t1 <= 12735;
                            },
                            "CJK Strokes": function(t1) {
                                return t1 >= 12736 && t1 <= 12783;
                            },
                            "Katakana Phonetic Extensions": function(t1) {
                                return t1 >= 12784 && t1 <= 12799;
                            },
                            "Enclosed CJK Letters and Months": function(t1) {
                                return t1 >= 12800 && t1 <= 13055;
                            },
                            "CJK Compatibility": function(t1) {
                                return t1 >= 13056 && t1 <= 13311;
                            },
                            "CJK Unified Ideographs Extension A": function(t1) {
                                return t1 >= 13312 && t1 <= 19903;
                            },
                            "Yijing Hexagram Symbols": function(t1) {
                                return t1 >= 19904 && t1 <= 19967;
                            },
                            "CJK Unified Ideographs": function(t1) {
                                return t1 >= 19968 && t1 <= 40959;
                            },
                            "Yi Syllables": function(t1) {
                                return t1 >= 40960 && t1 <= 42127;
                            },
                            "Yi Radicals": function(t1) {
                                return t1 >= 42128 && t1 <= 42191;
                            },
                            "Hangul Jamo Extended-A": function(t1) {
                                return t1 >= 43360 && t1 <= 43391;
                            },
                            "Hangul Syllables": function(t1) {
                                return t1 >= 44032 && t1 <= 55215;
                            },
                            "Hangul Jamo Extended-B": function(t1) {
                                return t1 >= 55216 && t1 <= 55295;
                            },
                            "Private Use Area": function(t1) {
                                return t1 >= 57344 && t1 <= 63743;
                            },
                            "CJK Compatibility Ideographs": function(t1) {
                                return t1 >= 63744 && t1 <= 64255;
                            },
                            "Arabic Presentation Forms-A": function(t1) {
                                return t1 >= 64336 && t1 <= 65023;
                            },
                            "Vertical Forms": function(t1) {
                                return t1 >= 65040 && t1 <= 65055;
                            },
                            "CJK Compatibility Forms": function(t1) {
                                return t1 >= 65072 && t1 <= 65103;
                            },
                            "Small Form Variants": function(t1) {
                                return t1 >= 65104 && t1 <= 65135;
                            },
                            "Arabic Presentation Forms-B": function(t1) {
                                return t1 >= 65136 && t1 <= 65279;
                            },
                            "Halfwidth and Fullwidth Forms": function(t1) {
                                return t1 >= 65280 && t1 <= 65519;
                            }
                        };
                        function Wn(t1) {
                            for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                                if (Zn(r[e1].charCodeAt(0))) return !0;
                            }
                            return !1;
                        }
                        function Xn(t1) {
                            return !Yn.Arabic(t1) && !Yn["Arabic Supplement"](t1) && !Yn["Arabic Extended-A"](t1) && !Yn["Arabic Presentation Forms-A"](t1) && !Yn["Arabic Presentation Forms-B"](t1);
                        }
                        function Zn(t1) {
                            return 746 === t1 || 747 === t1 || !(t1 < 4352) && (!!Yn["Bopomofo Extended"](t1) || !!Yn.Bopomofo(t1) || !(!Yn["CJK Compatibility Forms"](t1) || t1 >= 65097 && t1 <= 65103) || !!Yn["CJK Compatibility Ideographs"](t1) || !!Yn["CJK Compatibility"](t1) || !!Yn["CJK Radicals Supplement"](t1) || !!Yn["CJK Strokes"](t1) || !(!Yn["CJK Symbols and Punctuation"](t1) || t1 >= 12296 && t1 <= 12305 || t1 >= 12308 && t1 <= 12319 || 12336 === t1) || !!Yn["CJK Unified Ideographs Extension A"](t1) || !!Yn["CJK Unified Ideographs"](t1) || !!Yn["Enclosed CJK Letters and Months"](t1) || !!Yn["Hangul Compatibility Jamo"](t1) || !!Yn["Hangul Jamo Extended-A"](t1) || !!Yn["Hangul Jamo Extended-B"](t1) || !!Yn["Hangul Jamo"](t1) || !!Yn["Hangul Syllables"](t1) || !!Yn.Hiragana(t1) || !!Yn["Ideographic Description Characters"](t1) || !!Yn.Kanbun(t1) || !!Yn["Kangxi Radicals"](t1) || !!Yn["Katakana Phonetic Extensions"](t1) || !(!Yn.Katakana(t1) || 12540 === t1) || !(!Yn["Halfwidth and Fullwidth Forms"](t1) || 65288 === t1 || 65289 === t1 || 65293 === t1 || t1 >= 65306 && t1 <= 65310 || 65339 === t1 || 65341 === t1 || 65343 === t1 || t1 >= 65371 && t1 <= 65503 || 65507 === t1 || t1 >= 65512 && t1 <= 65519) || !(!Yn["Small Form Variants"](t1) || t1 >= 65112 && t1 <= 65118 || t1 >= 65123 && t1 <= 65126) || !!Yn["Unified Canadian Aboriginal Syllabics"](t1) || !!Yn["Unified Canadian Aboriginal Syllabics Extended"](t1) || !!Yn["Vertical Forms"](t1) || !!Yn["Yijing Hexagram Symbols"](t1) || !!Yn["Yi Syllables"](t1) || !!Yn["Yi Radicals"](t1));
                        }
                        function Jn(t1) {
                            return !(Zn(t1) || function(t1) {
                                return !(!Yn["Latin-1 Supplement"](t1) || 167 !== t1 && 169 !== t1 && 174 !== t1 && 177 !== t1 && 188 !== t1 && 189 !== t1 && 190 !== t1 && 215 !== t1 && 247 !== t1) || !(!Yn["General Punctuation"](t1) || 8214 !== t1 && 8224 !== t1 && 8225 !== t1 && 8240 !== t1 && 8241 !== t1 && 8251 !== t1 && 8252 !== t1 && 8258 !== t1 && 8263 !== t1 && 8264 !== t1 && 8265 !== t1 && 8273 !== t1) || !!Yn["Letterlike Symbols"](t1) || !!Yn["Number Forms"](t1) || !(!Yn["Miscellaneous Technical"](t1) || !(t1 >= 8960 && t1 <= 8967 || t1 >= 8972 && t1 <= 8991 || t1 >= 8996 && t1 <= 9e3 || 9003 === t1 || t1 >= 9085 && t1 <= 9114 || t1 >= 9150 && t1 <= 9165 || 9167 === t1 || t1 >= 9169 && t1 <= 9179 || t1 >= 9186 && t1 <= 9215)) || !(!Yn["Control Pictures"](t1) || 9251 === t1) || !!Yn["Optical Character Recognition"](t1) || !!Yn["Enclosed Alphanumerics"](t1) || !!Yn["Geometric Shapes"](t1) || !(!Yn["Miscellaneous Symbols"](t1) || t1 >= 9754 && t1 <= 9759) || !(!Yn["Miscellaneous Symbols and Arrows"](t1) || !(t1 >= 11026 && t1 <= 11055 || t1 >= 11088 && t1 <= 11097 || t1 >= 11192 && t1 <= 11243)) || !!Yn["CJK Symbols and Punctuation"](t1) || !!Yn.Katakana(t1) || !!Yn["Private Use Area"](t1) || !!Yn["CJK Compatibility Forms"](t1) || !!Yn["Small Form Variants"](t1) || !!Yn["Halfwidth and Fullwidth Forms"](t1) || 8734 === t1 || 8756 === t1 || 8757 === t1 || t1 >= 9984 && t1 <= 10087 || t1 >= 10102 && t1 <= 10131 || 65532 === t1 || 65533 === t1;
                            }(t1));
                        }
                        function Kn(t1) {
                            return t1 >= 1424 && t1 <= 2303 || Yn["Arabic Presentation Forms-A"](t1) || Yn["Arabic Presentation Forms-B"](t1);
                        }
                        function Qn(t1, e1) {
                            return !(!e1 && Kn(t1)) && !(t1 >= 2304 && t1 <= 3583 || t1 >= 3840 && t1 <= 4255 || Yn.Khmer(t1));
                        }
                        function $n(t1) {
                            for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                                if (Kn(r[e1].charCodeAt(0))) return !0;
                            }
                            return !1;
                        }
                        var ti = "deferred", ei = "loading", ri = "loaded", ni = "error", ii = null, ai = "unavailable", oi = null, si = function(t1) {
                            t1 && "string" == typeof t1 && t1.indexOf("NetworkError") > -1 && (ai = ni), ii && ii(t1);
                        };
                        function li() {
                            ci.fire(new Mt("pluginStateChange", {
                                pluginStatus: ai,
                                pluginURL: oi
                            }));
                        }
                        var ci = new Et, ui = function() {
                            return ai;
                        }, fi = function() {
                            if (ai !== ti || !oi) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
                            ai = ei, li(), oi && xt({
                                url: oi
                            }, function(t1) {
                                t1 ? si(t1) : (ai = ri, li());
                            });
                        }, hi = {
                            applyArabicShaping: null,
                            processBidirectionalText: null,
                            processStyledBidirectionalText: null,
                            isLoaded: function() {
                                return ai === ri || null != hi.applyArabicShaping;
                            },
                            isLoading: function() {
                                return ai === ei;
                            },
                            setState: function(t1) {
                                ai = t1.pluginStatus, oi = t1.pluginURL;
                            },
                            isParsed: function() {
                                return null != hi.applyArabicShaping && null != hi.processBidirectionalText && null != hi.processStyledBidirectionalText;
                            },
                            getPluginURL: function() {
                                return oi;
                            }
                        }, pi = function(t1, e1) {
                            this.zoom = t1, e1 ? (this.now = e1.now, this.fadeDuration = e1.fadeDuration, this.zoomHistory = e1.zoomHistory, this.transition = e1.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Gn, this.transition = {});
                        };
                        pi.prototype.isSupportedScript = function(t1) {
                            return function(t1, e1) {
                                for(var r = 0, n = t1; r < n.length; r += 1){
                                    if (!Qn(n[r].charCodeAt(0), e1)) return !1;
                                }
                                return !0;
                            }(t1, hi.isLoaded());
                        }, pi.prototype.crossFadingFactor = function() {
                            return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
                        }, pi.prototype.getCrossfadeParameters = function() {
                            var t1 = this.zoom, e1 = t1 - Math.floor(t1), r = this.crossFadingFactor();
                            return t1 > this.zoomHistory.lastIntegerZoom ? {
                                fromScale: 2,
                                toScale: 1,
                                t: e1 + (1 - e1) * r
                            } : {
                                fromScale: .5,
                                toScale: 1,
                                t: 1 - (1 - r) * e1
                            };
                        };
                        var di = function(t1, e1) {
                            this.property = t1, this.value = e1, this.expression = function(t1, e1) {
                                if (Br(t1)) return new Kr(t1, e1);
                                if (Yr(t1)) {
                                    var r = Jr(t1, e1);
                                    if ("error" === r.result) throw new Error(r.value.map(function(t1) {
                                        return t1.key + ": " + t1.message;
                                    }).join(", "));
                                    return r.value;
                                }
                                var n = t1;
                                return "string" == typeof t1 && "color" === e1.type && (n = te.parse(t1)), {
                                    kind: "constant",
                                    evaluate: function() {
                                        return n;
                                    }
                                };
                            }(void 0 === e1 ? t1.specification.default : e1, t1.specification);
                        };
                        di.prototype.isDataDriven = function() {
                            return "source" === this.expression.kind || "composite" === this.expression.kind;
                        }, di.prototype.possiblyEvaluate = function(t1, e1, r) {
                            return this.property.possiblyEvaluate(this, t1, e1, r);
                        };
                        var mi = function(t1) {
                            this.property = t1, this.value = new di(t1, void 0);
                        };
                        mi.prototype.transitioned = function(t1, e1) {
                            return new vi(this.property, this.value, e1, u({}, t1.transition, this.transition), t1.now);
                        }, mi.prototype.untransitioned = function() {
                            return new vi(this.property, this.value, null, {}, 0);
                        };
                        var gi = function(t1) {
                            this._properties = t1, this._values = Object.create(t1.defaultTransitionablePropertyValues);
                        };
                        gi.prototype.getValue = function(t1) {
                            return x(this._values[t1].value.value);
                        }, gi.prototype.setValue = function(t1, e1) {
                            this._values.hasOwnProperty(t1) || (this._values[t1] = new mi(this._values[t1].property)), this._values[t1].value = new di(this._values[t1].property, null === e1 ? void 0 : x(e1));
                        }, gi.prototype.getTransition = function(t1) {
                            return x(this._values[t1].transition);
                        }, gi.prototype.setTransition = function(t1, e1) {
                            this._values.hasOwnProperty(t1) || (this._values[t1] = new mi(this._values[t1].property)), this._values[t1].transition = x(e1) || void 0;
                        }, gi.prototype.serialize = function() {
                            for(var t1 = {}, e1 = 0, r = Object.keys(this._values); e1 < r.length; e1 += 1){
                                var n = r[e1], i = this.getValue(n);
                                void 0 !== i && (t1[n] = i);
                                var a = this.getTransition(n);
                                void 0 !== a && (t1[n + "-transition"] = a);
                            }
                            return t1;
                        }, gi.prototype.transitioned = function(t1, e1) {
                            for(var r = new yi(this._properties), n = 0, i = Object.keys(this._values); n < i.length; n += 1){
                                var a = i[n];
                                r._values[a] = this._values[a].transitioned(t1, e1._values[a]);
                            }
                            return r;
                        }, gi.prototype.untransitioned = function() {
                            for(var t1 = new yi(this._properties), e1 = 0, r = Object.keys(this._values); e1 < r.length; e1 += 1){
                                var n = r[e1];
                                t1._values[n] = this._values[n].untransitioned();
                            }
                            return t1;
                        };
                        var vi = function(t1, e1, r, n, i) {
                            this.property = t1, this.value = e1, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t1.specification.transition && (n.delay || n.duration) && (this.prior = r);
                        };
                        vi.prototype.possiblyEvaluate = function(t1, e1, r) {
                            var n = t1.now || 0, i = this.value.possiblyEvaluate(t1, e1, r), a = this.prior;
                            if (a) {
                                if (n > this.end) return this.prior = null, i;
                                if (this.value.isDataDriven()) return this.prior = null, i;
                                if (n < this.begin) return a.possiblyEvaluate(t1, e1, r);
                                var o = (n - this.begin) / (this.end - this.begin);
                                return this.property.interpolate(a.possiblyEvaluate(t1, e1, r), i, function(t1) {
                                    if (t1 <= 0) return 0;
                                    if (t1 >= 1) return 1;
                                    var e1 = t1 * t1, r = e1 * t1;
                                    return 4 * (t1 < .5 ? r : 3 * (t1 - e1) + r - .75);
                                }(o));
                            }
                            return i;
                        };
                        var yi = function(t1) {
                            this._properties = t1, this._values = Object.create(t1.defaultTransitioningPropertyValues);
                        };
                        yi.prototype.possiblyEvaluate = function(t1, e1, r) {
                            for(var n = new _i(this._properties), i = 0, a = Object.keys(this._values); i < a.length; i += 1){
                                var o = a[i];
                                n._values[o] = this._values[o].possiblyEvaluate(t1, e1, r);
                            }
                            return n;
                        }, yi.prototype.hasTransition = function() {
                            for(var t1 = 0, e1 = Object.keys(this._values); t1 < e1.length; t1 += 1){
                                var r = e1[t1];
                                if (this._values[r].prior) return !0;
                            }
                            return !1;
                        };
                        var xi = function(t1) {
                            this._properties = t1, this._values = Object.create(t1.defaultPropertyValues);
                        };
                        xi.prototype.getValue = function(t1) {
                            return x(this._values[t1].value);
                        }, xi.prototype.setValue = function(t1, e1) {
                            this._values[t1] = new di(this._values[t1].property, null === e1 ? void 0 : x(e1));
                        }, xi.prototype.serialize = function() {
                            for(var t1 = {}, e1 = 0, r = Object.keys(this._values); e1 < r.length; e1 += 1){
                                var n = r[e1], i = this.getValue(n);
                                void 0 !== i && (t1[n] = i);
                            }
                            return t1;
                        }, xi.prototype.possiblyEvaluate = function(t1, e1, r) {
                            for(var n = new _i(this._properties), i = 0, a = Object.keys(this._values); i < a.length; i += 1){
                                var o = a[i];
                                n._values[o] = this._values[o].possiblyEvaluate(t1, e1, r);
                            }
                            return n;
                        };
                        var bi = function(t1, e1, r) {
                            this.property = t1, this.value = e1, this.parameters = r;
                        };
                        bi.prototype.isConstant = function() {
                            return "constant" === this.value.kind;
                        }, bi.prototype.constantOr = function(t1) {
                            return "constant" === this.value.kind ? this.value.value : t1;
                        }, bi.prototype.evaluate = function(t1, e1, r, n) {
                            return this.property.evaluate(this.value, this.parameters, t1, e1, r, n);
                        };
                        var _i = function(t1) {
                            this._properties = t1, this._values = Object.create(t1.defaultPossiblyEvaluatedValues);
                        };
                        _i.prototype.get = function(t1) {
                            return this._values[t1];
                        };
                        var wi = function(t1) {
                            this.specification = t1;
                        };
                        wi.prototype.possiblyEvaluate = function(t1, e1) {
                            return t1.expression.evaluate(e1);
                        }, wi.prototype.interpolate = function(t1, e1, r) {
                            var n = Ge[this.specification.type];
                            return n ? n(t1, e1, r) : t1;
                        };
                        var Ti = function(t1, e1) {
                            this.specification = t1, this.overrides = e1;
                        };
                        Ti.prototype.possiblyEvaluate = function(t1, e1, r, n) {
                            return "constant" === t1.expression.kind || "camera" === t1.expression.kind ? new bi(this, {
                                kind: "constant",
                                value: t1.expression.evaluate(e1, null, {}, r, n)
                            }, e1) : new bi(this, t1.expression, e1);
                        }, Ti.prototype.interpolate = function(t1, e1, r) {
                            if ("constant" !== t1.value.kind || "constant" !== e1.value.kind) return t1;
                            if (void 0 === t1.value.value || void 0 === e1.value.value) return new bi(this, {
                                kind: "constant",
                                value: void 0
                            }, t1.parameters);
                            var n = Ge[this.specification.type];
                            return n ? new bi(this, {
                                kind: "constant",
                                value: n(t1.value.value, e1.value.value, r)
                            }, t1.parameters) : t1;
                        }, Ti.prototype.evaluate = function(t1, e1, r, n, i, a) {
                            return "constant" === t1.kind ? t1.value : t1.evaluate(e1, r, n, i, a);
                        };
                        var ki = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.possiblyEvaluate = function(t1, e1, r, n) {
                                if (void 0 === t1.value) return new bi(this, {
                                    kind: "constant",
                                    value: void 0
                                }, e1);
                                if ("constant" === t1.expression.kind) {
                                    var i = t1.expression.evaluate(e1, null, {}, r, n), a = "resolvedImage" === t1.property.specification.type && "string" != typeof i ? i.name : i, o = this._calculate(a, a, a, e1);
                                    return new bi(this, {
                                        kind: "constant",
                                        value: o
                                    }, e1);
                                }
                                if ("camera" === t1.expression.kind) {
                                    var s = this._calculate(t1.expression.evaluate({
                                        zoom: e1.zoom - 1
                                    }), t1.expression.evaluate({
                                        zoom: e1.zoom
                                    }), t1.expression.evaluate({
                                        zoom: e1.zoom + 1
                                    }), e1);
                                    return new bi(this, {
                                        kind: "constant",
                                        value: s
                                    }, e1);
                                }
                                return new bi(this, t1.expression, e1);
                            }, e1.prototype.evaluate = function(t1, e1, r, n, i, a) {
                                if ("source" === t1.kind) {
                                    var o = t1.evaluate(e1, r, n, i, a);
                                    return this._calculate(o, o, o, e1);
                                }
                                return "composite" === t1.kind ? this._calculate(t1.evaluate({
                                    zoom: Math.floor(e1.zoom) - 1
                                }, r, n), t1.evaluate({
                                    zoom: Math.floor(e1.zoom)
                                }, r, n), t1.evaluate({
                                    zoom: Math.floor(e1.zoom) + 1
                                }, r, n), e1) : t1.value;
                            }, e1.prototype._calculate = function(t1, e1, r, n) {
                                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                                    from: t1,
                                    to: e1
                                } : {
                                    from: r,
                                    to: e1
                                };
                            }, e1.prototype.interpolate = function(t1) {
                                return t1;
                            }, e1;
                        }(Ti), Ai = function(t1) {
                            this.specification = t1;
                        };
                        Ai.prototype.possiblyEvaluate = function(t1, e1, r, n) {
                            if (void 0 !== t1.value) {
                                if ("constant" === t1.expression.kind) {
                                    var i = t1.expression.evaluate(e1, null, {}, r, n);
                                    return this._calculate(i, i, i, e1);
                                }
                                return this._calculate(t1.expression.evaluate(new pi(Math.floor(e1.zoom - 1), e1)), t1.expression.evaluate(new pi(Math.floor(e1.zoom), e1)), t1.expression.evaluate(new pi(Math.floor(e1.zoom + 1), e1)), e1);
                            }
                        }, Ai.prototype._calculate = function(t1, e1, r, n) {
                            return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                                from: t1,
                                to: e1
                            } : {
                                from: r,
                                to: e1
                            };
                        }, Ai.prototype.interpolate = function(t1) {
                            return t1;
                        };
                        var Mi = function(t1) {
                            this.specification = t1;
                        };
                        Mi.prototype.possiblyEvaluate = function(t1, e1, r, n) {
                            return !!t1.expression.evaluate(e1, null, {}, r, n);
                        }, Mi.prototype.interpolate = function() {
                            return !1;
                        };
                        var Si = function(t1) {
                            for(var e1 in this.properties = t1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [], t1){
                                var r = t1[e1];
                                r.specification.overridable && this.overridableProperties.push(e1);
                                var n = this.defaultPropertyValues[e1] = new di(r, void 0), i = this.defaultTransitionablePropertyValues[e1] = new mi(r);
                                this.defaultTransitioningPropertyValues[e1] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e1] = n.possiblyEvaluate({});
                            }
                        };
                        Nn("DataDrivenProperty", Ti), Nn("DataConstantProperty", wi), Nn("CrossFadedDataDrivenProperty", ki), Nn("CrossFadedProperty", Ai), Nn("ColorRampProperty", Mi);
                        var Ei = function(t1) {
                            function e1(e1, r) {
                                if (t1.call(this), this.id = e1.id, this.type = e1.type, this._featureFilter = {
                                    filter: function() {
                                        return !0;
                                    },
                                    needGeometry: !1
                                }, "custom" !== e1.type && (e1, this.metadata = e1.metadata, this.minzoom = e1.minzoom, this.maxzoom = e1.maxzoom, "background" !== e1.type && (this.source = e1.source, this.sourceLayer = e1["source-layer"], this.filter = e1.filter), r.layout && (this._unevaluatedLayout = new xi(r.layout)), r.paint)) {
                                    for(var n in this._transitionablePaint = new gi(r.paint), e1.paint)this.setPaintProperty(n, e1.paint[n], {
                                        validate: !1
                                    });
                                    for(var i in e1.layout)this.setLayoutProperty(i, e1.layout[i], {
                                        validate: !1
                                    });
                                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new _i(r.paint);
                                }
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getCrossfadeParameters = function() {
                                return this._crossfadeParameters;
                            }, e1.prototype.getLayoutProperty = function(t1) {
                                return "visibility" === t1 ? this.visibility : this._unevaluatedLayout.getValue(t1);
                            }, e1.prototype.setLayoutProperty = function(t1, e1, r) {
                                if (void 0 === r && (r = {}), null != e1) {
                                    var n = "layers." + this.id + ".layout." + t1;
                                    if (this._validate(In, n, t1, e1, r)) return;
                                }
                                "visibility" !== t1 ? this._unevaluatedLayout.setValue(t1, e1) : this.visibility = e1;
                            }, e1.prototype.getPaintProperty = function(t1) {
                                return g(t1, "-transition") ? this._transitionablePaint.getTransition(t1.slice(0, -11)) : this._transitionablePaint.getValue(t1);
                            }, e1.prototype.setPaintProperty = function(t1, e1, r) {
                                if (void 0 === r && (r = {}), null != e1) {
                                    var n = "layers." + this.id + ".paint." + t1;
                                    if (this._validate(Pn, n, t1, e1, r)) return !1;
                                }
                                if (g(t1, "-transition")) return this._transitionablePaint.setTransition(t1.slice(0, -11), e1 || void 0), !1;
                                var i = this._transitionablePaint._values[t1], a = "cross-faded-data-driven" === i.property.specification["property-type"], o = i.value.isDataDriven(), s = i.value;
                                this._transitionablePaint.setValue(t1, e1), this._handleSpecialPaintPropertyUpdate(t1);
                                var l = this._transitionablePaint._values[t1].value;
                                return l.isDataDriven() || o || a || this._handleOverridablePaintPropertyUpdate(t1, s, l);
                            }, e1.prototype._handleSpecialPaintPropertyUpdate = function(t1) {}, e1.prototype._handleOverridablePaintPropertyUpdate = function(t1, e1, r) {
                                return !1;
                            }, e1.prototype.isHidden = function(t1) {
                                return !!(this.minzoom && t1 < this.minzoom) || !!(this.maxzoom && t1 >= this.maxzoom) || "none" === this.visibility;
                            }, e1.prototype.updateTransitions = function(t1) {
                                this._transitioningPaint = this._transitionablePaint.transitioned(t1, this._transitioningPaint);
                            }, e1.prototype.hasTransition = function() {
                                return this._transitioningPaint.hasTransition();
                            }, e1.prototype.recalculate = function(t1, e1) {
                                t1.getCrossfadeParameters && (this._crossfadeParameters = t1.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t1, void 0, e1)), this.paint = this._transitioningPaint.possiblyEvaluate(t1, void 0, e1);
                            }, e1.prototype.serialize = function() {
                                var t1 = {
                                    id: this.id,
                                    type: this.type,
                                    source: this.source,
                                    "source-layer": this.sourceLayer,
                                    metadata: this.metadata,
                                    minzoom: this.minzoom,
                                    maxzoom: this.maxzoom,
                                    filter: this.filter,
                                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                                };
                                return this.visibility && (t1.layout = t1.layout || {}, t1.layout.visibility = this.visibility), y(t1, function(t1, e1) {
                                    return !(void 0 === t1 || "layout" === e1 && !Object.keys(t1).length || "paint" === e1 && !Object.keys(t1).length);
                                });
                            }, e1.prototype._validate = function(t1, e1, r, n, i) {
                                return void 0 === i && (i = {}), (!i || !1 !== i.validate) && On(this, t1.call(Ln, {
                                    key: e1,
                                    layerType: this.type,
                                    objectKey: r,
                                    value: n,
                                    styleSpec: Lt,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    }
                                }));
                            }, e1.prototype.is3D = function() {
                                return !1;
                            }, e1.prototype.isTileClipped = function() {
                                return !1;
                            }, e1.prototype.hasOffscreenPass = function() {
                                return !1;
                            }, e1.prototype.resize = function() {}, e1.prototype.isStateDependent = function() {
                                for(var t1 in this.paint._values){
                                    var e1 = this.paint.get(t1);
                                    if (e1 instanceof bi && zr(e1.property.specification) && ("source" === e1.value.kind || "composite" === e1.value.kind) && e1.value.isStateDependent) return !0;
                                }
                                return !1;
                            }, e1;
                        }(Et), Li = {
                            Int8: Int8Array,
                            Uint8: Uint8Array,
                            Int16: Int16Array,
                            Uint16: Uint16Array,
                            Int32: Int32Array,
                            Uint32: Uint32Array,
                            Float32: Float32Array
                        }, Ci = function(t1, e1) {
                            this._structArray = t1, this._pos1 = e1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
                        }, Pi = function() {
                            this.isTransferred = !1, this.capacity = -1, this.resize(0);
                        };
                        function Ii(t1, e1) {
                            void 0 === e1 && (e1 = 1);
                            var r = 0, n = 0;
                            return {
                                members: t1.map(function(t1) {
                                    var i, a = (i = t1.type, Li[i].BYTES_PER_ELEMENT), o = r = Oi(r, Math.max(e1, a)), s = t1.components || 1;
                                    return n = Math.max(n, a), r += a * s, {
                                        name: t1.name,
                                        type: t1.type,
                                        components: s,
                                        offset: o
                                    };
                                }),
                                size: Oi(r, Math.max(n, e1)),
                                alignment: e1
                            };
                        }
                        function Oi(t1, e1) {
                            return Math.ceil(t1 / e1) * e1;
                        }
                        Pi.serialize = function(t1, e1) {
                            return t1._trim(), e1 && (t1.isTransferred = !0, e1.push(t1.arrayBuffer)), {
                                length: t1.length,
                                arrayBuffer: t1.arrayBuffer
                            };
                        }, Pi.deserialize = function(t1) {
                            var e1 = Object.create(this.prototype);
                            return e1.arrayBuffer = t1.arrayBuffer, e1.length = t1.length, e1.capacity = t1.arrayBuffer.byteLength / e1.bytesPerElement, e1._refreshViews(), e1;
                        }, Pi.prototype._trim = function() {
                            this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
                        }, Pi.prototype.clear = function() {
                            this.length = 0;
                        }, Pi.prototype.resize = function(t1) {
                            this.reserve(t1), this.length = t1;
                        }, Pi.prototype.reserve = function(t1) {
                            if (t1 > this.capacity) {
                                this.capacity = Math.max(t1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                                var e1 = this.uint8;
                                this._refreshViews(), e1 && this.uint8.set(e1);
                            }
                        }, Pi.prototype._refreshViews = function() {
                            throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
                        };
                        var zi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1) {
                                var r = this.length;
                                return this.resize(r + 1), this.emplace(r, t1, e1);
                            }, e1.prototype.emplace = function(t1, e1, r) {
                                var n = 2 * t1;
                                return this.int16[n + 0] = e1, this.int16[n + 1] = r, t1;
                            }, e1;
                        }(Pi);
                        zi.prototype.bytesPerElement = 4, Nn("StructArrayLayout2i4", zi);
                        var Di = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n) {
                                var i = this.length;
                                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i) {
                                var a = 4 * t1;
                                return this.int16[a + 0] = e1, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, t1;
                            }, e1;
                        }(Pi);
                        Di.prototype.bytesPerElement = 8, Nn("StructArrayLayout4i8", Di);
                        var Ri = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a) {
                                var o = this.length;
                                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o) {
                                var s = 6 * t1;
                                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, t1;
                            }, e1;
                        }(Pi);
                        Ri.prototype.bytesPerElement = 12, Nn("StructArrayLayout2i4i12", Ri);
                        var Fi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a) {
                                var o = this.length;
                                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o) {
                                var s = 4 * t1, l = 8 * t1;
                                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.uint8[l + 4] = n, this.uint8[l + 5] = i, this.uint8[l + 6] = a, this.uint8[l + 7] = o, t1;
                            }, e1;
                        }(Pi);
                        Fi.prototype.bytesPerElement = 8, Nn("StructArrayLayout2i4ub8", Fi);
                        var Bi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, l, c) {
                                var u = this.length;
                                return this.resize(u + 1), this.emplace(u, t1, e1, r, n, i, a, o, s, l, c);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                var f = 9 * t1, h = 18 * t1;
                                return this.uint16[f + 0] = e1, this.uint16[f + 1] = r, this.uint16[f + 2] = n, this.uint16[f + 3] = i, this.uint16[f + 4] = a, this.uint16[f + 5] = o, this.uint16[f + 6] = s, this.uint16[f + 7] = l, this.uint8[h + 16] = c, this.uint8[h + 17] = u, t1;
                            }, e1;
                        }(Pi);
                        Bi.prototype.bytesPerElement = 18, Nn("StructArrayLayout8ui2ub18", Bi);
                        var Ni = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, l, c, u, f) {
                                var h = this.length;
                                return this.resize(h + 1), this.emplace(h, t1, e1, r, n, i, a, o, s, l, c, u, f);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, l, c, u, f, h) {
                                var p = 12 * t1;
                                return this.int16[p + 0] = e1, this.int16[p + 1] = r, this.int16[p + 2] = n, this.int16[p + 3] = i, this.uint16[p + 4] = a, this.uint16[p + 5] = o, this.uint16[p + 6] = s, this.uint16[p + 7] = l, this.int16[p + 8] = c, this.int16[p + 9] = u, this.int16[p + 10] = f, this.int16[p + 11] = h, t1;
                            }, e1;
                        }(Pi);
                        Ni.prototype.bytesPerElement = 24, Nn("StructArrayLayout4i4ui4i24", Ni);
                        var ji = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                                var n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }, e1.prototype.emplace = function(t1, e1, r, n) {
                                var i = 3 * t1;
                                return this.float32[i + 0] = e1, this.float32[i + 1] = r, this.float32[i + 2] = n, t1;
                            }, e1;
                        }(Pi);
                        ji.prototype.bytesPerElement = 12, Nn("StructArrayLayout3f12", ji);
                        var Ui = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1) {
                                var e1 = this.length;
                                return this.resize(e1 + 1), this.emplace(e1, t1);
                            }, e1.prototype.emplace = function(t1, e1) {
                                var r = 1 * t1;
                                return this.uint32[r + 0] = e1, t1;
                            }, e1;
                        }(Pi);
                        Ui.prototype.bytesPerElement = 4, Nn("StructArrayLayout1ul4", Ui);
                        var Vi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, l) {
                                var c = this.length;
                                return this.resize(c + 1), this.emplace(c, t1, e1, r, n, i, a, o, s, l);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, l, c) {
                                var u = 10 * t1, f = 5 * t1;
                                return this.int16[u + 0] = e1, this.int16[u + 1] = r, this.int16[u + 2] = n, this.int16[u + 3] = i, this.int16[u + 4] = a, this.int16[u + 5] = o, this.uint32[f + 3] = s, this.uint16[u + 8] = l, this.uint16[u + 9] = c, t1;
                            }, e1;
                        }(Pi);
                        Vi.prototype.bytesPerElement = 20, Nn("StructArrayLayout6i1ul2ui20", Vi);
                        var Hi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a) {
                                var o = this.length;
                                return this.resize(o + 1), this.emplace(o, t1, e1, r, n, i, a);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o) {
                                var s = 6 * t1;
                                return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, this.int16[s + 5] = o, t1;
                            }, e1;
                        }(Pi);
                        Hi.prototype.bytesPerElement = 12, Nn("StructArrayLayout2i2i2i12", Hi);
                        var qi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i) {
                                var a = this.length;
                                return this.resize(a + 1), this.emplace(a, t1, e1, r, n, i);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a) {
                                var o = 4 * t1, s = 8 * t1;
                                return this.float32[o + 0] = e1, this.float32[o + 1] = r, this.float32[o + 2] = n, this.int16[s + 6] = i, this.int16[s + 7] = a, t1;
                            }, e1;
                        }(Pi);
                        qi.prototype.bytesPerElement = 16, Nn("StructArrayLayout2f1f2i16", qi);
                        var Gi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n) {
                                var i = this.length;
                                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i) {
                                var a = 12 * t1, o = 3 * t1;
                                return this.uint8[a + 0] = e1, this.uint8[a + 1] = r, this.float32[o + 1] = n, this.float32[o + 2] = i, t1;
                            }, e1;
                        }(Pi);
                        Gi.prototype.bytesPerElement = 12, Nn("StructArrayLayout2ub2f12", Gi);
                        var Yi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                                var n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }, e1.prototype.emplace = function(t1, e1, r, n) {
                                var i = 3 * t1;
                                return this.uint16[i + 0] = e1, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t1;
                            }, e1;
                        }(Pi);
                        Yi.prototype.bytesPerElement = 6, Nn("StructArrayLayout3ui6", Yi);
                        var Wi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g) {
                                var v = this.length;
                                return this.resize(v + 1), this.emplace(v, t1, e1, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g, v) {
                                var y = 24 * t1, x = 12 * t1, b = 48 * t1;
                                return this.int16[y + 0] = e1, this.int16[y + 1] = r, this.uint16[y + 2] = n, this.uint16[y + 3] = i, this.uint32[x + 2] = a, this.uint32[x + 3] = o, this.uint32[x + 4] = s, this.uint16[y + 10] = l, this.uint16[y + 11] = c, this.uint16[y + 12] = u, this.float32[x + 7] = f, this.float32[x + 8] = h, this.uint8[b + 36] = p, this.uint8[b + 37] = d, this.uint8[b + 38] = m, this.uint32[x + 10] = g, this.int16[y + 22] = v, t1;
                            }, e1;
                        }(Pi);
                        Wi.prototype.bytesPerElement = 48, Nn("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", Wi);
                        var Xi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g, v, y, x, b, _, w, T, k, A, M, S) {
                                var E = this.length;
                                return this.resize(E + 1), this.emplace(E, t1, e1, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g, v, y, x, b, _, w, T, k, A, M, S);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g, v, y, x, b, _, w, T, k, A, M, S, E) {
                                var L = 34 * t1, C = 17 * t1;
                                return this.int16[L + 0] = e1, this.int16[L + 1] = r, this.int16[L + 2] = n, this.int16[L + 3] = i, this.int16[L + 4] = a, this.int16[L + 5] = o, this.int16[L + 6] = s, this.int16[L + 7] = l, this.uint16[L + 8] = c, this.uint16[L + 9] = u, this.uint16[L + 10] = f, this.uint16[L + 11] = h, this.uint16[L + 12] = p, this.uint16[L + 13] = d, this.uint16[L + 14] = m, this.uint16[L + 15] = g, this.uint16[L + 16] = v, this.uint16[L + 17] = y, this.uint16[L + 18] = x, this.uint16[L + 19] = b, this.uint16[L + 20] = _, this.uint16[L + 21] = w, this.uint16[L + 22] = T, this.uint32[C + 12] = k, this.float32[C + 13] = A, this.float32[C + 14] = M, this.float32[C + 15] = S, this.float32[C + 16] = E, t1;
                            }, e1;
                        }(Pi);
                        Xi.prototype.bytesPerElement = 68, Nn("StructArrayLayout8i15ui1ul4f68", Xi);
                        var Zi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1) {
                                var e1 = this.length;
                                return this.resize(e1 + 1), this.emplace(e1, t1);
                            }, e1.prototype.emplace = function(t1, e1) {
                                var r = 1 * t1;
                                return this.float32[r + 0] = e1, t1;
                            }, e1;
                        }(Pi);
                        Zi.prototype.bytesPerElement = 4, Nn("StructArrayLayout1f4", Zi);
                        var Ji = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                                var n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }, e1.prototype.emplace = function(t1, e1, r, n) {
                                var i = 3 * t1;
                                return this.int16[i + 0] = e1, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
                            }, e1;
                        }(Pi);
                        Ji.prototype.bytesPerElement = 6, Nn("StructArrayLayout3i6", Ji);
                        var Ki = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r) {
                                var n = this.length;
                                return this.resize(n + 1), this.emplace(n, t1, e1, r);
                            }, e1.prototype.emplace = function(t1, e1, r, n) {
                                var i = 2 * t1, a = 4 * t1;
                                return this.uint32[i + 0] = e1, this.uint16[a + 2] = r, this.uint16[a + 3] = n, t1;
                            }, e1;
                        }(Pi);
                        Ki.prototype.bytesPerElement = 8, Nn("StructArrayLayout1ul2ui8", Ki);
                        var Qi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1) {
                                var r = this.length;
                                return this.resize(r + 1), this.emplace(r, t1, e1);
                            }, e1.prototype.emplace = function(t1, e1, r) {
                                var n = 2 * t1;
                                return this.uint16[n + 0] = e1, this.uint16[n + 1] = r, t1;
                            }, e1;
                        }(Pi);
                        Qi.prototype.bytesPerElement = 4, Nn("StructArrayLayout2ui4", Qi);
                        var $i = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1) {
                                var e1 = this.length;
                                return this.resize(e1 + 1), this.emplace(e1, t1);
                            }, e1.prototype.emplace = function(t1, e1) {
                                var r = 1 * t1;
                                return this.uint16[r + 0] = e1, t1;
                            }, e1;
                        }(Pi);
                        $i.prototype.bytesPerElement = 2, Nn("StructArrayLayout1ui2", $i);
                        var ta = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1) {
                                var r = this.length;
                                return this.resize(r + 1), this.emplace(r, t1, e1);
                            }, e1.prototype.emplace = function(t1, e1, r) {
                                var n = 2 * t1;
                                return this.float32[n + 0] = e1, this.float32[n + 1] = r, t1;
                            }, e1;
                        }(Pi);
                        ta.prototype.bytesPerElement = 8, Nn("StructArrayLayout2f8", ta);
                        var ea = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._refreshViews = function() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }, e1.prototype.emplaceBack = function(t1, e1, r, n) {
                                var i = this.length;
                                return this.resize(i + 1), this.emplace(i, t1, e1, r, n);
                            }, e1.prototype.emplace = function(t1, e1, r, n, i) {
                                var a = 4 * t1;
                                return this.float32[a + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, t1;
                            }, e1;
                        }(Pi);
                        ea.prototype.bytesPerElement = 16, Nn("StructArrayLayout4f16", ea);
                        var ra = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1;
                            var r = {
                                anchorPointX: {
                                    configurable: !0
                                },
                                anchorPointY: {
                                    configurable: !0
                                },
                                x1: {
                                    configurable: !0
                                },
                                y1: {
                                    configurable: !0
                                },
                                x2: {
                                    configurable: !0
                                },
                                y2: {
                                    configurable: !0
                                },
                                featureIndex: {
                                    configurable: !0
                                },
                                sourceLayerIndex: {
                                    configurable: !0
                                },
                                bucketIndex: {
                                    configurable: !0
                                },
                                anchorPoint: {
                                    configurable: !0
                                }
                            };
                            return r.anchorPointX.get = function() {
                                return this._structArray.int16[this._pos2 + 0];
                            }, r.anchorPointY.get = function() {
                                return this._structArray.int16[this._pos2 + 1];
                            }, r.x1.get = function() {
                                return this._structArray.int16[this._pos2 + 2];
                            }, r.y1.get = function() {
                                return this._structArray.int16[this._pos2 + 3];
                            }, r.x2.get = function() {
                                return this._structArray.int16[this._pos2 + 4];
                            }, r.y2.get = function() {
                                return this._structArray.int16[this._pos2 + 5];
                            }, r.featureIndex.get = function() {
                                return this._structArray.uint32[this._pos4 + 3];
                            }, r.sourceLayerIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 8];
                            }, r.bucketIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 9];
                            }, r.anchorPoint.get = function() {
                                return new i(this.anchorPointX, this.anchorPointY);
                            }, Object.defineProperties(e1.prototype, r), e1;
                        }(Ci);
                        ra.prototype.size = 20;
                        var na = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.get = function(t1) {
                                return new ra(this, t1);
                            }, e1;
                        }(Vi);
                        Nn("CollisionBoxArray", na);
                        var ia = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1;
                            var r = {
                                anchorX: {
                                    configurable: !0
                                },
                                anchorY: {
                                    configurable: !0
                                },
                                glyphStartIndex: {
                                    configurable: !0
                                },
                                numGlyphs: {
                                    configurable: !0
                                },
                                vertexStartIndex: {
                                    configurable: !0
                                },
                                lineStartIndex: {
                                    configurable: !0
                                },
                                lineLength: {
                                    configurable: !0
                                },
                                segment: {
                                    configurable: !0
                                },
                                lowerSize: {
                                    configurable: !0
                                },
                                upperSize: {
                                    configurable: !0
                                },
                                lineOffsetX: {
                                    configurable: !0
                                },
                                lineOffsetY: {
                                    configurable: !0
                                },
                                writingMode: {
                                    configurable: !0
                                },
                                placedOrientation: {
                                    configurable: !0
                                },
                                hidden: {
                                    configurable: !0
                                },
                                crossTileID: {
                                    configurable: !0
                                },
                                associatedIconIndex: {
                                    configurable: !0
                                }
                            };
                            return r.anchorX.get = function() {
                                return this._structArray.int16[this._pos2 + 0];
                            }, r.anchorY.get = function() {
                                return this._structArray.int16[this._pos2 + 1];
                            }, r.glyphStartIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 2];
                            }, r.numGlyphs.get = function() {
                                return this._structArray.uint16[this._pos2 + 3];
                            }, r.vertexStartIndex.get = function() {
                                return this._structArray.uint32[this._pos4 + 2];
                            }, r.lineStartIndex.get = function() {
                                return this._structArray.uint32[this._pos4 + 3];
                            }, r.lineLength.get = function() {
                                return this._structArray.uint32[this._pos4 + 4];
                            }, r.segment.get = function() {
                                return this._structArray.uint16[this._pos2 + 10];
                            }, r.lowerSize.get = function() {
                                return this._structArray.uint16[this._pos2 + 11];
                            }, r.upperSize.get = function() {
                                return this._structArray.uint16[this._pos2 + 12];
                            }, r.lineOffsetX.get = function() {
                                return this._structArray.float32[this._pos4 + 7];
                            }, r.lineOffsetY.get = function() {
                                return this._structArray.float32[this._pos4 + 8];
                            }, r.writingMode.get = function() {
                                return this._structArray.uint8[this._pos1 + 36];
                            }, r.placedOrientation.get = function() {
                                return this._structArray.uint8[this._pos1 + 37];
                            }, r.placedOrientation.set = function(t1) {
                                this._structArray.uint8[this._pos1 + 37] = t1;
                            }, r.hidden.get = function() {
                                return this._structArray.uint8[this._pos1 + 38];
                            }, r.hidden.set = function(t1) {
                                this._structArray.uint8[this._pos1 + 38] = t1;
                            }, r.crossTileID.get = function() {
                                return this._structArray.uint32[this._pos4 + 10];
                            }, r.crossTileID.set = function(t1) {
                                this._structArray.uint32[this._pos4 + 10] = t1;
                            }, r.associatedIconIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 22];
                            }, Object.defineProperties(e1.prototype, r), e1;
                        }(Ci);
                        ia.prototype.size = 48;
                        var aa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.get = function(t1) {
                                return new ia(this, t1);
                            }, e1;
                        }(Wi);
                        Nn("PlacedSymbolArray", aa);
                        var oa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1;
                            var r = {
                                anchorX: {
                                    configurable: !0
                                },
                                anchorY: {
                                    configurable: !0
                                },
                                rightJustifiedTextSymbolIndex: {
                                    configurable: !0
                                },
                                centerJustifiedTextSymbolIndex: {
                                    configurable: !0
                                },
                                leftJustifiedTextSymbolIndex: {
                                    configurable: !0
                                },
                                verticalPlacedTextSymbolIndex: {
                                    configurable: !0
                                },
                                placedIconSymbolIndex: {
                                    configurable: !0
                                },
                                verticalPlacedIconSymbolIndex: {
                                    configurable: !0
                                },
                                key: {
                                    configurable: !0
                                },
                                textBoxStartIndex: {
                                    configurable: !0
                                },
                                textBoxEndIndex: {
                                    configurable: !0
                                },
                                verticalTextBoxStartIndex: {
                                    configurable: !0
                                },
                                verticalTextBoxEndIndex: {
                                    configurable: !0
                                },
                                iconBoxStartIndex: {
                                    configurable: !0
                                },
                                iconBoxEndIndex: {
                                    configurable: !0
                                },
                                verticalIconBoxStartIndex: {
                                    configurable: !0
                                },
                                verticalIconBoxEndIndex: {
                                    configurable: !0
                                },
                                featureIndex: {
                                    configurable: !0
                                },
                                numHorizontalGlyphVertices: {
                                    configurable: !0
                                },
                                numVerticalGlyphVertices: {
                                    configurable: !0
                                },
                                numIconVertices: {
                                    configurable: !0
                                },
                                numVerticalIconVertices: {
                                    configurable: !0
                                },
                                useRuntimeCollisionCircles: {
                                    configurable: !0
                                },
                                crossTileID: {
                                    configurable: !0
                                },
                                textBoxScale: {
                                    configurable: !0
                                },
                                textOffset0: {
                                    configurable: !0
                                },
                                textOffset1: {
                                    configurable: !0
                                },
                                collisionCircleDiameter: {
                                    configurable: !0
                                }
                            };
                            return r.anchorX.get = function() {
                                return this._structArray.int16[this._pos2 + 0];
                            }, r.anchorY.get = function() {
                                return this._structArray.int16[this._pos2 + 1];
                            }, r.rightJustifiedTextSymbolIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 2];
                            }, r.centerJustifiedTextSymbolIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 3];
                            }, r.leftJustifiedTextSymbolIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 4];
                            }, r.verticalPlacedTextSymbolIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 5];
                            }, r.placedIconSymbolIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 6];
                            }, r.verticalPlacedIconSymbolIndex.get = function() {
                                return this._structArray.int16[this._pos2 + 7];
                            }, r.key.get = function() {
                                return this._structArray.uint16[this._pos2 + 8];
                            }, r.textBoxStartIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 9];
                            }, r.textBoxEndIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 10];
                            }, r.verticalTextBoxStartIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 11];
                            }, r.verticalTextBoxEndIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 12];
                            }, r.iconBoxStartIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 13];
                            }, r.iconBoxEndIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 14];
                            }, r.verticalIconBoxStartIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 15];
                            }, r.verticalIconBoxEndIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 16];
                            }, r.featureIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 17];
                            }, r.numHorizontalGlyphVertices.get = function() {
                                return this._structArray.uint16[this._pos2 + 18];
                            }, r.numVerticalGlyphVertices.get = function() {
                                return this._structArray.uint16[this._pos2 + 19];
                            }, r.numIconVertices.get = function() {
                                return this._structArray.uint16[this._pos2 + 20];
                            }, r.numVerticalIconVertices.get = function() {
                                return this._structArray.uint16[this._pos2 + 21];
                            }, r.useRuntimeCollisionCircles.get = function() {
                                return this._structArray.uint16[this._pos2 + 22];
                            }, r.crossTileID.get = function() {
                                return this._structArray.uint32[this._pos4 + 12];
                            }, r.crossTileID.set = function(t1) {
                                this._structArray.uint32[this._pos4 + 12] = t1;
                            }, r.textBoxScale.get = function() {
                                return this._structArray.float32[this._pos4 + 13];
                            }, r.textOffset0.get = function() {
                                return this._structArray.float32[this._pos4 + 14];
                            }, r.textOffset1.get = function() {
                                return this._structArray.float32[this._pos4 + 15];
                            }, r.collisionCircleDiameter.get = function() {
                                return this._structArray.float32[this._pos4 + 16];
                            }, Object.defineProperties(e1.prototype, r), e1;
                        }(Ci);
                        oa.prototype.size = 68;
                        var sa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.get = function(t1) {
                                return new oa(this, t1);
                            }, e1;
                        }(Xi);
                        Nn("SymbolInstanceArray", sa);
                        var la = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getoffsetX = function(t1) {
                                return this.float32[1 * t1 + 0];
                            }, e1;
                        }(Zi);
                        Nn("GlyphOffsetArray", la);
                        var ca = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getx = function(t1) {
                                return this.int16[3 * t1 + 0];
                            }, e1.prototype.gety = function(t1) {
                                return this.int16[3 * t1 + 1];
                            }, e1.prototype.gettileUnitDistanceFromAnchor = function(t1) {
                                return this.int16[3 * t1 + 2];
                            }, e1;
                        }(Ji);
                        Nn("SymbolLineVertexArray", ca);
                        var ua = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1;
                            var r = {
                                featureIndex: {
                                    configurable: !0
                                },
                                sourceLayerIndex: {
                                    configurable: !0
                                },
                                bucketIndex: {
                                    configurable: !0
                                }
                            };
                            return r.featureIndex.get = function() {
                                return this._structArray.uint32[this._pos4 + 0];
                            }, r.sourceLayerIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 2];
                            }, r.bucketIndex.get = function() {
                                return this._structArray.uint16[this._pos2 + 3];
                            }, Object.defineProperties(e1.prototype, r), e1;
                        }(Ci);
                        ua.prototype.size = 8;
                        var fa = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.get = function(t1) {
                                return new ua(this, t1);
                            }, e1;
                        }(Ki);
                        Nn("FeatureIndexArray", fa);
                        var ha = Ii([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4).members, pa = function(t1) {
                            void 0 === t1 && (t1 = []), this.segments = t1;
                        };
                        function da(t1, e1) {
                            return 256 * (t1 = l(Math.floor(t1), 0, 255)) + (e1 = l(Math.floor(e1), 0, 255));
                        }
                        pa.prototype.prepareSegment = function(t1, e1, r, n) {
                            var i = this.segments[this.segments.length - 1];
                            return t1 > pa.MAX_VERTEX_ARRAY_LENGTH && _("Max vertices per segment is " + pa.MAX_VERTEX_ARRAY_LENGTH + ": bucket requested " + t1), (!i || i.vertexLength + t1 > pa.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                                vertexOffset: e1.length,
                                primitiveOffset: r.length,
                                vertexLength: 0,
                                primitiveLength: 0
                            }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
                        }, pa.prototype.get = function() {
                            return this.segments;
                        }, pa.prototype.destroy = function() {
                            for(var t1 = 0, e1 = this.segments; t1 < e1.length; t1 += 1){
                                var r = e1[t1];
                                for(var n in r.vaos)r.vaos[n].destroy();
                            }
                        }, pa.simpleSegment = function(t1, e1, r, n) {
                            return new pa([
                                {
                                    vertexOffset: t1,
                                    primitiveOffset: e1,
                                    vertexLength: r,
                                    primitiveLength: n,
                                    vaos: {},
                                    sortKey: 0
                                }
                            ]);
                        }, pa.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Nn("SegmentVector", pa);
                        var ma = Ii([
                            {
                                name: "a_pattern_from",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pattern_to",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixel_ratio_from",
                                components: 1,
                                type: "Uint8"
                            },
                            {
                                name: "a_pixel_ratio_to",
                                components: 1,
                                type: "Uint8"
                            }
                        ]), ga = e1(function(t1) {
                            t1.exports = function(t1, e1) {
                                var r, n, i, a, o, s, l, c;
                                for(r = 3 & t1.length, n = t1.length - r, i = e1, o = 3432918353, s = 461845907, c = 0; c < n;)l = 255 & t1.charCodeAt(c) | (255 & t1.charCodeAt(++c)) << 8 | (255 & t1.charCodeAt(++c)) << 16 | (255 & t1.charCodeAt(++c)) << 24, ++c, i = 27492 + (65535 & (a = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (a >>> 16) & 65535) << 16);
                                switch(l = 0, r){
                                    case 3:
                                        l ^= (255 & t1.charCodeAt(c + 2)) << 16;
                                    case 2:
                                        l ^= (255 & t1.charCodeAt(c + 1)) << 8;
                                    case 1:
                                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t1.charCodeAt(c))) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295;
                                }
                                return i ^= t1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
                            };
                        }), va = e1(function(t1) {
                            t1.exports = function(t1, e1) {
                                for(var r, n = t1.length, i = e1 ^ n, a = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t1.charCodeAt(a) | (255 & t1.charCodeAt(++a)) << 8 | (255 & t1.charCodeAt(++a)) << 16 | (255 & t1.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++a;
                                switch(n){
                                    case 3:
                                        i ^= (255 & t1.charCodeAt(a + 2)) << 16;
                                    case 2:
                                        i ^= (255 & t1.charCodeAt(a + 1)) << 8;
                                    case 1:
                                        i = 1540483477 * (65535 & (i ^= 255 & t1.charCodeAt(a))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                                }
                                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
                            };
                        }), ya = ga, xa = ga, ba = va;
                        ya.murmur3 = xa, ya.murmur2 = ba;
                        var _a = function() {
                            this.ids = [], this.positions = [], this.indexed = !1;
                        };
                        _a.prototype.add = function(t1, e1, r, n) {
                            this.ids.push(Ta(t1)), this.positions.push(e1, r, n);
                        }, _a.prototype.getPositions = function(t1) {
                            for(var e1 = Ta(t1), r = 0, n = this.ids.length - 1; r < n;){
                                var i = r + n >> 1;
                                this.ids[i] >= e1 ? n = i : r = i + 1;
                            }
                            for(var a = []; this.ids[r] === e1;){
                                var o = this.positions[3 * r], s = this.positions[3 * r + 1], l = this.positions[3 * r + 2];
                                a.push({
                                    index: o,
                                    start: s,
                                    end: l
                                }), r++;
                            }
                            return a;
                        }, _a.serialize = function(t1, e1) {
                            var r = new Float64Array(t1.ids), n = new Uint32Array(t1.positions);
                            return function t1(e1, r, n, i) {
                                for(; n < i;){
                                    for(var a = e1[n + i >> 1], o = n - 1, s = i + 1;;){
                                        do o++;
                                        while (e1[o] < a);
                                        do s--;
                                        while (e1[s] > a);
                                        if (o >= s) break;
                                        ka(e1, o, s), ka(r, 3 * o, 3 * s), ka(r, 3 * o + 1, 3 * s + 1), ka(r, 3 * o + 2, 3 * s + 2);
                                    }
                                    s - n < i - s ? (t1(e1, r, n, s), n = s + 1) : (t1(e1, r, s + 1, i), i = s);
                                }
                            }(r, n, 0, r.length - 1), e1 && e1.push(r.buffer, n.buffer), {
                                ids: r,
                                positions: n
                            };
                        }, _a.deserialize = function(t1) {
                            var e1 = new _a;
                            return e1.ids = t1.ids, e1.positions = t1.positions, e1.indexed = !0, e1;
                        };
                        var wa = Math.pow(2, 53) - 1;
                        function Ta(t1) {
                            var e1 = +t1;
                            return !isNaN(e1) && e1 <= wa ? e1 : ya(String(t1));
                        }
                        function ka(t1, e1, r) {
                            var n = t1[e1];
                            t1[e1] = t1[r], t1[r] = n;
                        }
                        Nn("FeaturePositionMap", _a);
                        var Aa = function(t1, e1) {
                            this.gl = t1.gl, this.location = e1;
                        }, Ma = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = 0;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                this.current !== t1 && (this.current = t1, this.gl.uniform1i(this.location, t1));
                            }, e1;
                        }(Aa), Sa = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = 0;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                this.current !== t1 && (this.current = t1, this.gl.uniform1f(this.location, t1));
                            }, e1;
                        }(Aa), Ea = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = [
                                    0,
                                    0
                                ];
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                t1[0] === this.current[0] && t1[1] === this.current[1] || (this.current = t1, this.gl.uniform2f(this.location, t1[0], t1[1]));
                            }, e1;
                        }(Aa), La = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = [
                                    0,
                                    0,
                                    0
                                ];
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] || (this.current = t1, this.gl.uniform3f(this.location, t1[0], t1[1], t1[2]));
                            }, e1;
                        }(Aa), Ca = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                t1[0] === this.current[0] && t1[1] === this.current[1] && t1[2] === this.current[2] && t1[3] === this.current[3] || (this.current = t1, this.gl.uniform4f(this.location, t1[0], t1[1], t1[2], t1[3]));
                            }, e1;
                        }(Aa), Pa = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = te.transparent;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                t1.r === this.current.r && t1.g === this.current.g && t1.b === this.current.b && t1.a === this.current.a || (this.current = t1, this.gl.uniform4f(this.location, t1.r, t1.g, t1.b, t1.a));
                            }, e1;
                        }(Aa), Ia = new Float32Array(16), Oa = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1, r), this.current = Ia;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                if (t1[12] !== this.current[12] || t1[0] !== this.current[0]) return this.current = t1, void this.gl.uniformMatrix4fv(this.location, !1, t1);
                                for(var e1 = 1; e1 < 16; e1++)if (t1[e1] !== this.current[e1]) {
                                    this.current = t1, this.gl.uniformMatrix4fv(this.location, !1, t1);
                                    break;
                                }
                            }, e1;
                        }(Aa);
                        function za(t1) {
                            return [
                                da(255 * t1.r, 255 * t1.g),
                                da(255 * t1.b, 255 * t1.a)
                            ];
                        }
                        var Da = function(t1, e1, r) {
                            this.value = t1, this.uniformNames = e1.map(function(t1) {
                                return "u_" + t1;
                            }), this.type = r;
                        };
                        Da.prototype.setUniform = function(t1, e1, r) {
                            t1.set(r.constantOr(this.value));
                        }, Da.prototype.getBinding = function(t1, e1, r) {
                            return "color" === this.type ? new Pa(t1, e1) : new Sa(t1, e1);
                        };
                        var Ra = function(t1, e1) {
                            this.uniformNames = e1.map(function(t1) {
                                return "u_" + t1;
                            }), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
                        };
                        Ra.prototype.setConstantPatternPositions = function(t1, e1) {
                            this.pixelRatioFrom = e1.pixelRatio, this.pixelRatioTo = t1.pixelRatio, this.patternFrom = e1.tlbr, this.patternTo = t1.tlbr;
                        }, Ra.prototype.setUniform = function(t1, e1, r, n) {
                            var i = "u_pattern_to" === n ? this.patternTo : "u_pattern_from" === n ? this.patternFrom : "u_pixel_ratio_to" === n ? this.pixelRatioTo : "u_pixel_ratio_from" === n ? this.pixelRatioFrom : null;
                            i && t1.set(i);
                        }, Ra.prototype.getBinding = function(t1, e1, r) {
                            return "u_pattern" === r.substr(0, 9) ? new Ca(t1, e1) : new Sa(t1, e1);
                        };
                        var Fa = function(t1, e1, r, n) {
                            this.expression = t1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e1.map(function(t1) {
                                return {
                                    name: "a_" + t1,
                                    type: "Float32",
                                    components: "color" === r ? 2 : 1,
                                    offset: 0
                                };
                            }), this.paintVertexArray = new n;
                        };
                        Fa.prototype.populatePaintArray = function(t1, e1, r, n, i) {
                            var a = this.paintVertexArray.length, o = this.expression.evaluate(new pi(0), e1, {}, n, [], i);
                            this.paintVertexArray.resize(t1), this._setPaintValue(a, t1, o);
                        }, Fa.prototype.updatePaintArray = function(t1, e1, r, n) {
                            var i = this.expression.evaluate({
                                zoom: 0
                            }, r, n);
                            this._setPaintValue(t1, e1, i);
                        }, Fa.prototype._setPaintValue = function(t1, e1, r) {
                            if ("color" === this.type) for(var n = za(r), i = t1; i < e1; i++)this.paintVertexArray.emplace(i, n[0], n[1]);
                            else {
                                for(var a = t1; a < e1; a++)this.paintVertexArray.emplace(a, r);
                                this.maxValue = Math.max(this.maxValue, Math.abs(r));
                            }
                        }, Fa.prototype.upload = function(t1) {
                            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                        }, Fa.prototype.destroy = function() {
                            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                        };
                        var Ba = function(t1, e1, r, n, i, a) {
                            this.expression = t1, this.uniformNames = e1.map(function(t1) {
                                return "u_" + t1 + "_t";
                            }), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e1.map(function(t1) {
                                return {
                                    name: "a_" + t1,
                                    type: "Float32",
                                    components: "color" === r ? 4 : 2,
                                    offset: 0
                                };
                            }), this.paintVertexArray = new a;
                        };
                        Ba.prototype.populatePaintArray = function(t1, e1, r, n, i) {
                            var a = this.expression.evaluate(new pi(this.zoom), e1, {}, n, [], i), o = this.expression.evaluate(new pi(this.zoom + 1), e1, {}, n, [], i), s = this.paintVertexArray.length;
                            this.paintVertexArray.resize(t1), this._setPaintValue(s, t1, a, o);
                        }, Ba.prototype.updatePaintArray = function(t1, e1, r, n) {
                            var i = this.expression.evaluate({
                                zoom: this.zoom
                            }, r, n), a = this.expression.evaluate({
                                zoom: this.zoom + 1
                            }, r, n);
                            this._setPaintValue(t1, e1, i, a);
                        }, Ba.prototype._setPaintValue = function(t1, e1, r, n) {
                            if ("color" === this.type) for(var i = za(r), a = za(n), o = t1; o < e1; o++)this.paintVertexArray.emplace(o, i[0], i[1], a[0], a[1]);
                            else {
                                for(var s = t1; s < e1; s++)this.paintVertexArray.emplace(s, r, n);
                                this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                            }
                        }, Ba.prototype.upload = function(t1) {
                            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                        }, Ba.prototype.destroy = function() {
                            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                        }, Ba.prototype.setUniform = function(t1, e1) {
                            var r = this.useIntegerZoom ? Math.floor(e1.zoom) : e1.zoom, n = l(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
                            t1.set(n);
                        }, Ba.prototype.getBinding = function(t1, e1, r) {
                            return new Sa(t1, e1);
                        };
                        var Na = function(t1, e1, r, n, i, a) {
                            this.expression = t1, this.type = e1, this.useIntegerZoom = r, this.zoom = n, this.layerId = a, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
                        };
                        Na.prototype.populatePaintArray = function(t1, e1, r) {
                            var n = this.zoomInPaintVertexArray.length;
                            this.zoomInPaintVertexArray.resize(t1), this.zoomOutPaintVertexArray.resize(t1), this._setPaintValues(n, t1, e1.patterns && e1.patterns[this.layerId], r);
                        }, Na.prototype.updatePaintArray = function(t1, e1, r, n, i) {
                            this._setPaintValues(t1, e1, r.patterns && r.patterns[this.layerId], i);
                        }, Na.prototype._setPaintValues = function(t1, e1, r, n) {
                            if (n && r) {
                                var i = r.min, a = r.mid, o = r.max, s = n[i], l = n[a], c = n[o];
                                if (s && l && c) for(var u = t1; u < e1; u++)this.zoomInPaintVertexArray.emplace(u, l.tl[0], l.tl[1], l.br[0], l.br[1], s.tl[0], s.tl[1], s.br[0], s.br[1], l.pixelRatio, s.pixelRatio), this.zoomOutPaintVertexArray.emplace(u, l.tl[0], l.tl[1], l.br[0], l.br[1], c.tl[0], c.tl[1], c.br[0], c.br[1], l.pixelRatio, c.pixelRatio);
                            }
                        }, Na.prototype.upload = function(t1) {
                            this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t1.createVertexBuffer(this.zoomInPaintVertexArray, ma.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t1.createVertexBuffer(this.zoomOutPaintVertexArray, ma.members, this.expression.isStateDependent));
                        }, Na.prototype.destroy = function() {
                            this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
                        };
                        var ja = function(t1, e1, r, n) {
                            this.binders = {}, this.layoutAttributes = n, this._buffers = [];
                            var i = [];
                            for(var a in t1.paint._values)if (r(a)) {
                                var o = t1.paint.get(a);
                                if (o instanceof bi && zr(o.property.specification)) {
                                    var s = Va(a, t1.type), l = o.value, c = o.property.specification.type, u = o.property.useIntegerZoom, f = o.property.specification["property-type"], h = "cross-faded" === f || "cross-faded-data-driven" === f;
                                    if ("constant" === l.kind) this.binders[a] = h ? new Ra(l.value, s) : new Da(l.value, s, c), i.push("/u_" + a);
                                    else if ("source" === l.kind || h) {
                                        var p = Ha(a, c, "source");
                                        this.binders[a] = h ? new Na(l, c, u, e1, p, t1.id) : new Fa(l, s, c, p), i.push("/a_" + a);
                                    } else {
                                        var d = Ha(a, c, "composite");
                                        this.binders[a] = new Ba(l, s, c, u, e1, d), i.push("/z_" + a);
                                    }
                                }
                            }
                            this.cacheKey = i.sort().join("");
                        };
                        ja.prototype.getMaxValue = function(t1) {
                            var e1 = this.binders[t1];
                            return e1 instanceof Fa || e1 instanceof Ba ? e1.maxValue : 0;
                        }, ja.prototype.populatePaintArrays = function(t1, e1, r, n, i) {
                            for(var a in this.binders){
                                var o = this.binders[a];
                                (o instanceof Fa || o instanceof Ba || o instanceof Na) && o.populatePaintArray(t1, e1, r, n, i);
                            }
                        }, ja.prototype.setConstantPatternPositions = function(t1, e1) {
                            for(var r in this.binders){
                                var n = this.binders[r];
                                n instanceof Ra && n.setConstantPatternPositions(t1, e1);
                            }
                        }, ja.prototype.updatePaintArrays = function(t1, e1, r, n, i) {
                            var a = !1;
                            for(var o in t1)for(var s = 0, l = e1.getPositions(o); s < l.length; s += 1){
                                var c = l[s], u = r.feature(c.index);
                                for(var f in this.binders){
                                    var h = this.binders[f];
                                    if ((h instanceof Fa || h instanceof Ba || h instanceof Na) && !0 === h.expression.isStateDependent) {
                                        var p = n.paint.get(f);
                                        h.expression = p.value, h.updatePaintArray(c.start, c.end, u, t1[o], i), a = !0;
                                    }
                                }
                            }
                            return a;
                        }, ja.prototype.defines = function() {
                            var t1 = [];
                            for(var e1 in this.binders){
                                var r = this.binders[e1];
                                (r instanceof Da || r instanceof Ra) && t1.push.apply(t1, r.uniformNames.map(function(t1) {
                                    return "#define HAS_UNIFORM_" + t1;
                                }));
                            }
                            return t1;
                        }, ja.prototype.getPaintVertexBuffers = function() {
                            return this._buffers;
                        }, ja.prototype.getUniforms = function(t1, e1) {
                            var r = [];
                            for(var n in this.binders){
                                var i = this.binders[n];
                                if (i instanceof Da || i instanceof Ra || i instanceof Ba) for(var a = 0, o = i.uniformNames; a < o.length; a += 1){
                                    var s = o[a];
                                    if (e1[s]) {
                                        var l = i.getBinding(t1, e1[s], s);
                                        r.push({
                                            name: s,
                                            property: n,
                                            binding: l
                                        });
                                    }
                                }
                            }
                            return r;
                        }, ja.prototype.setUniforms = function(t1, e1, r, n) {
                            for(var i = 0, a = e1; i < a.length; i += 1){
                                var o = a[i], s = o.name, l = o.property, c = o.binding;
                                this.binders[l].setUniform(c, n, r.get(l), s);
                            }
                        }, ja.prototype.updatePaintBuffers = function(t1) {
                            for(var e1 in this._buffers = [], this.binders){
                                var r = this.binders[e1];
                                if (t1 && r instanceof Na) {
                                    var n = 2 === t1.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                                    n && this._buffers.push(n);
                                } else (r instanceof Fa || r instanceof Ba) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
                            }
                        }, ja.prototype.upload = function(t1) {
                            for(var e1 in this.binders){
                                var r = this.binders[e1];
                                (r instanceof Fa || r instanceof Ba || r instanceof Na) && r.upload(t1);
                            }
                            this.updatePaintBuffers();
                        }, ja.prototype.destroy = function() {
                            for(var t1 in this.binders){
                                var e1 = this.binders[t1];
                                (e1 instanceof Fa || e1 instanceof Ba || e1 instanceof Na) && e1.destroy();
                            }
                        };
                        var Ua = function(t1, e1, r, n) {
                            void 0 === n && (n = function() {
                                return !0;
                            }), this.programConfigurations = {};
                            for(var i = 0, a = e1; i < a.length; i += 1){
                                var o = a[i];
                                this.programConfigurations[o.id] = new ja(o, r, n, t1);
                            }
                            this.needsUpload = !1, this._featureMap = new _a, this._bufferOffset = 0;
                        };
                        function Va(t1, e1) {
                            return ({
                                "text-opacity": [
                                    "opacity"
                                ],
                                "icon-opacity": [
                                    "opacity"
                                ],
                                "text-color": [
                                    "fill_color"
                                ],
                                "icon-color": [
                                    "fill_color"
                                ],
                                "text-halo-color": [
                                    "halo_color"
                                ],
                                "icon-halo-color": [
                                    "halo_color"
                                ],
                                "text-halo-blur": [
                                    "halo_blur"
                                ],
                                "icon-halo-blur": [
                                    "halo_blur"
                                ],
                                "text-halo-width": [
                                    "halo_width"
                                ],
                                "icon-halo-width": [
                                    "halo_width"
                                ],
                                "line-gap-width": [
                                    "gapwidth"
                                ],
                                "line-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ],
                                "fill-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ],
                                "fill-extrusion-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ]
                            })[t1] || [
                                t1.replace(e1 + "-", "").replace(/-/g, "_")
                            ];
                        }
                        function Ha(t1, e1, r) {
                            var n = {
                                color: {
                                    source: ta,
                                    composite: ea
                                },
                                number: {
                                    source: Zi,
                                    composite: ta
                                }
                            }, i = function(t1) {
                                return ({
                                    "line-pattern": {
                                        source: Bi,
                                        composite: Bi
                                    },
                                    "fill-pattern": {
                                        source: Bi,
                                        composite: Bi
                                    },
                                    "fill-extrusion-pattern": {
                                        source: Bi,
                                        composite: Bi
                                    }
                                })[t1];
                            }(t1);
                            return i && i[r] || n[e1][r];
                        }
                        Ua.prototype.populatePaintArrays = function(t1, e1, r, n, i, a) {
                            for(var o in this.programConfigurations)this.programConfigurations[o].populatePaintArrays(t1, e1, n, i, a);
                            void 0 !== e1.id && this._featureMap.add(e1.id, r, this._bufferOffset, t1), this._bufferOffset = t1, this.needsUpload = !0;
                        }, Ua.prototype.updatePaintArrays = function(t1, e1, r, n) {
                            for(var i = 0, a = r; i < a.length; i += 1){
                                var o = a[i];
                                this.needsUpload = this.programConfigurations[o.id].updatePaintArrays(t1, this._featureMap, e1, o, n) || this.needsUpload;
                            }
                        }, Ua.prototype.get = function(t1) {
                            return this.programConfigurations[t1];
                        }, Ua.prototype.upload = function(t1) {
                            if (this.needsUpload) {
                                for(var e1 in this.programConfigurations)this.programConfigurations[e1].upload(t1);
                                this.needsUpload = !1;
                            }
                        }, Ua.prototype.destroy = function() {
                            for(var t1 in this.programConfigurations)this.programConfigurations[t1].destroy();
                        }, Nn("ConstantBinder", Da), Nn("CrossFadedConstantBinder", Ra), Nn("SourceExpressionBinder", Fa), Nn("CrossFadedCompositeBinder", Na), Nn("CompositeExpressionBinder", Ba), Nn("ProgramConfiguration", ja, {
                            omit: [
                                "_buffers"
                            ]
                        }), Nn("ProgramConfigurationSet", Ua);
                        var qa, Ga = (qa = 15, {
                            min: -1 * Math.pow(2, qa - 1),
                            max: Math.pow(2, qa - 1) - 1
                        });
                        function Ya(t1) {
                            for(var e1 = 8192 / t1.extent, r = t1.loadGeometry(), n = 0; n < r.length; n++)for(var i = r[n], a = 0; a < i.length; a++){
                                var o = i[a];
                                o.x = Math.round(o.x * e1), o.y = Math.round(o.y * e1), (o.x < Ga.min || o.x > Ga.max || o.y < Ga.min || o.y > Ga.max) && (_("Geometry exceeds allowed extent, reduce your vector tile buffer size"), o.x = l(o.x, Ga.min, Ga.max), o.y = l(o.y, Ga.min, Ga.max));
                            }
                            return r;
                        }
                        function Wa(t1, e1, r, n, i) {
                            t1.emplaceBack(2 * e1 + (n + 1) / 2, 2 * r + (i + 1) / 2);
                        }
                        var Xa = function(t1) {
                            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                                return t1.id;
                            }), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new zi, this.indexArray = new Yi, this.segments = new pa, this.programConfigurations = new Ua(ha, t1.layers, t1.zoom), this.stateDependentLayerIds = this.layers.filter(function(t1) {
                                return t1.isStateDependent();
                            }).map(function(t1) {
                                return t1.id;
                            });
                        };
                        function Za(t1, e1) {
                            for(var r = 0; r < t1.length; r++)if (io(e1, t1[r])) return !0;
                            for(var n = 0; n < e1.length; n++)if (io(t1, e1[n])) return !0;
                            return !!$a(t1, e1);
                        }
                        function Ja(t1, e1, r) {
                            return !!io(t1, e1) || !!eo(e1, t1, r);
                        }
                        function Ka(t1, e1) {
                            if (1 === t1.length) return no(e1, t1[0]);
                            for(var r = 0; r < e1.length; r++)for(var n = e1[r], i = 0; i < n.length; i++)if (io(t1, n[i])) return !0;
                            for(var a = 0; a < t1.length; a++)if (no(e1, t1[a])) return !0;
                            for(var o = 0; o < e1.length; o++)if ($a(t1, e1[o])) return !0;
                            return !1;
                        }
                        function Qa(t1, e1, r) {
                            if (t1.length > 1) {
                                if ($a(t1, e1)) return !0;
                                for(var n = 0; n < e1.length; n++)if (eo(e1[n], t1, r)) return !0;
                            }
                            for(var i = 0; i < t1.length; i++)if (eo(t1[i], e1, r)) return !0;
                            return !1;
                        }
                        function $a(t1, e1) {
                            if (0 === t1.length || 0 === e1.length) return !1;
                            for(var r = 0; r < t1.length - 1; r++)for(var n = t1[r], i = t1[r + 1], a = 0; a < e1.length - 1; a++){
                                if (to(n, i, e1[a], e1[a + 1])) return !0;
                            }
                            return !1;
                        }
                        function to(t1, e1, r, n) {
                            return w(t1, r, n) !== w(e1, r, n) && w(t1, e1, r) !== w(t1, e1, n);
                        }
                        function eo(t1, e1, r) {
                            var n = r * r;
                            if (1 === e1.length) return t1.distSqr(e1[0]) < n;
                            for(var i = 1; i < e1.length; i++){
                                if (ro(t1, e1[i - 1], e1[i]) < n) return !0;
                            }
                            return !1;
                        }
                        function ro(t1, e1, r) {
                            var n = e1.distSqr(r);
                            if (0 === n) return t1.distSqr(e1);
                            var i = ((t1.x - e1.x) * (r.x - e1.x) + (t1.y - e1.y) * (r.y - e1.y)) / n;
                            return i < 0 ? t1.distSqr(e1) : i > 1 ? t1.distSqr(r) : t1.distSqr(r.sub(e1)._mult(i)._add(e1));
                        }
                        function no(t1, e1) {
                            for(var r, n, i, a = !1, o = 0; o < t1.length; o++)for(var s = 0, l = (r = t1[o]).length - 1; s < r.length; l = s++)n = r[s], i = r[l], n.y > e1.y != i.y > e1.y && e1.x < (i.x - n.x) * (e1.y - n.y) / (i.y - n.y) + n.x && (a = !a);
                            return a;
                        }
                        function io(t1, e1) {
                            for(var r = !1, n = 0, i = t1.length - 1; n < t1.length; i = n++){
                                var a = t1[n], o = t1[i];
                                a.y > e1.y != o.y > e1.y && e1.x < (o.x - a.x) * (e1.y - a.y) / (o.y - a.y) + a.x && (r = !r);
                            }
                            return r;
                        }
                        function ao(t1, e1, r) {
                            var n = r[0], i = r[2];
                            if (t1.x < n.x && e1.x < n.x || t1.x > i.x && e1.x > i.x || t1.y < n.y && e1.y < n.y || t1.y > i.y && e1.y > i.y) return !1;
                            var a = w(t1, e1, r[0]);
                            return a !== w(t1, e1, r[1]) || a !== w(t1, e1, r[2]) || a !== w(t1, e1, r[3]);
                        }
                        function oo(t1, e1, r) {
                            var n = e1.paint.get(t1).value;
                            return "constant" === n.kind ? n.value : r.programConfigurations.get(e1.id).getMaxValue(t1);
                        }
                        function so(t1) {
                            return Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
                        }
                        function lo(t1, e1, r, n, a) {
                            if (!e1[0] && !e1[1]) return t1;
                            var o = i.convert(e1)._mult(a);
                            "viewport" === r && o._rotate(-n);
                            for(var s = [], l = 0; l < t1.length; l++){
                                var c = t1[l];
                                s.push(c.sub(o));
                            }
                            return s;
                        }
                        Xa.prototype.populate = function(t1, e1, r) {
                            var n = this.layers[0], i = [], a = null;
                            "circle" === n.type && (a = n.layout.get("circle-sort-key"));
                            for(var o = 0, s = t1; o < s.length; o += 1){
                                var l = s[o], c = l.feature, u = l.id, f = l.index, h = l.sourceLayerIndex, p = this.layers[0]._featureFilter.needGeometry, d = {
                                    type: c.type,
                                    id: u,
                                    properties: c.properties,
                                    geometry: p ? Ya(c) : []
                                };
                                if (this.layers[0]._featureFilter.filter(new pi(this.zoom), d, r)) {
                                    p || (d.geometry = Ya(c));
                                    var m = a ? a.evaluate(d, {}, r) : void 0, g = {
                                        id: u,
                                        properties: c.properties,
                                        type: c.type,
                                        sourceLayerIndex: h,
                                        index: f,
                                        geometry: d.geometry,
                                        patterns: {},
                                        sortKey: m
                                    };
                                    i.push(g);
                                }
                            }
                            a && i.sort(function(t1, e1) {
                                return t1.sortKey - e1.sortKey;
                            });
                            for(var v = 0, y = i; v < y.length; v += 1){
                                var x = y[v], b = x, _ = b.geometry, w = b.index, T = b.sourceLayerIndex, k = t1[w].feature;
                                this.addFeature(x, _, w, r), e1.featureIndex.insert(k, _, w, T, this.index);
                            }
                        }, Xa.prototype.update = function(t1, e1, r) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
                        }, Xa.prototype.isEmpty = function() {
                            return 0 === this.layoutVertexArray.length;
                        }, Xa.prototype.uploadPending = function() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }, Xa.prototype.upload = function(t1) {
                            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, ha), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
                        }, Xa.prototype.destroy = function() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                        }, Xa.prototype.addFeature = function(t1, e1, r, n) {
                            for(var i = 0, a = e1; i < a.length; i += 1)for(var o = 0, s = a[i]; o < s.length; o += 1){
                                var l = s[o], c = l.x, u = l.y;
                                if (!(c < 0 || c >= 8192 || u < 0 || u >= 8192)) {
                                    var f = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t1.sortKey), h = f.vertexLength;
                                    Wa(this.layoutVertexArray, c, u, -1, -1), Wa(this.layoutVertexArray, c, u, 1, -1), Wa(this.layoutVertexArray, c, u, 1, 1), Wa(this.layoutVertexArray, c, u, -1, 1), this.indexArray.emplaceBack(h, h + 1, h + 2), this.indexArray.emplaceBack(h, h + 3, h + 2), f.vertexLength += 4, f.primitiveLength += 2;
                                }
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, {}, n);
                        }, Nn("CircleBucket", Xa, {
                            omit: [
                                "layers"
                            ]
                        });
                        var co = new Si({
                            "circle-sort-key": new Ti(Lt.layout_circle["circle-sort-key"])
                        }), uo = {
                            paint: new Si({
                                "circle-radius": new Ti(Lt.paint_circle["circle-radius"]),
                                "circle-color": new Ti(Lt.paint_circle["circle-color"]),
                                "circle-blur": new Ti(Lt.paint_circle["circle-blur"]),
                                "circle-opacity": new Ti(Lt.paint_circle["circle-opacity"]),
                                "circle-translate": new wi(Lt.paint_circle["circle-translate"]),
                                "circle-translate-anchor": new wi(Lt.paint_circle["circle-translate-anchor"]),
                                "circle-pitch-scale": new wi(Lt.paint_circle["circle-pitch-scale"]),
                                "circle-pitch-alignment": new wi(Lt.paint_circle["circle-pitch-alignment"]),
                                "circle-stroke-width": new Ti(Lt.paint_circle["circle-stroke-width"]),
                                "circle-stroke-color": new Ti(Lt.paint_circle["circle-stroke-color"]),
                                "circle-stroke-opacity": new Ti(Lt.paint_circle["circle-stroke-opacity"])
                            }),
                            layout: co
                        }, fo = "undefined" != typeof Float32Array ? Float32Array : Array;
                        function ho(t1) {
                            return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                        }
                        function po(t1, e1, r) {
                            var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], f = e1[8], h = e1[9], p = e1[10], d = e1[11], m = e1[12], g = e1[13], v = e1[14], y = e1[15], x = r[0], b = r[1], _ = r[2], w = r[3];
                            return t1[0] = x * n + b * s + _ * f + w * m, t1[1] = x * i + b * l + _ * h + w * g, t1[2] = x * a + b * c + _ * p + w * v, t1[3] = x * o + b * u + _ * d + w * y, x = r[4], b = r[5], _ = r[6], w = r[7], t1[4] = x * n + b * s + _ * f + w * m, t1[5] = x * i + b * l + _ * h + w * g, t1[6] = x * a + b * c + _ * p + w * v, t1[7] = x * o + b * u + _ * d + w * y, x = r[8], b = r[9], _ = r[10], w = r[11], t1[8] = x * n + b * s + _ * f + w * m, t1[9] = x * i + b * l + _ * h + w * g, t1[10] = x * a + b * c + _ * p + w * v, t1[11] = x * o + b * u + _ * d + w * y, x = r[12], b = r[13], _ = r[14], w = r[15], t1[12] = x * n + b * s + _ * f + w * m, t1[13] = x * i + b * l + _ * h + w * g, t1[14] = x * a + b * c + _ * p + w * v, t1[15] = x * o + b * u + _ * d + w * y, t1;
                        }
                        Math.hypot || (Math.hypot = function() {
                            for(var t1 = arguments, e1 = 0, r = arguments.length; r--;)e1 += t1[r] * t1[r];
                            return Math.sqrt(e1);
                        });
                        var mo = po;
                        var go, vo, yo = function(t1, e1, r) {
                            return t1[0] = e1[0] - r[0], t1[1] = e1[1] - r[1], t1[2] = e1[2] - r[2], t1;
                        };
                        go = new fo(3), fo != Float32Array && (go[0] = 0, go[1] = 0, go[2] = 0), vo = go;
                        function xo(t1, e1, r) {
                            var n = e1[0], i = e1[1], a = e1[2], o = e1[3];
                            return t1[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * o, t1[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * o, t1[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * o, t1[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * o, t1;
                        }
                        !function() {
                            var t1 = function() {
                                var t1 = new fo(4);
                                return fo != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 0), t1;
                            }();
                        }();
                        var bo = function(t1) {
                            var e1 = t1[0], r = t1[1];
                            return e1 * e1 + r * r;
                        }, _o = (function() {
                            var t1 = function() {
                                var t1 = new fo(2);
                                return fo != Float32Array && (t1[0] = 0, t1[1] = 0), t1;
                            }();
                        }(), function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, uo);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.createBucket = function(t1) {
                                return new Xa(t1);
                            }, e1.prototype.queryRadius = function(t1) {
                                var e1 = t1;
                                return oo("circle-radius", this, e1) + oo("circle-stroke-width", this, e1) + so(this.paint.get("circle-translate"));
                            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, i, a, o, s) {
                                for(var l = lo(t1, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), a.angle, o), c = this.paint.get("circle-radius").evaluate(e1, r) + this.paint.get("circle-stroke-width").evaluate(e1, r), u = "map" === this.paint.get("circle-pitch-alignment"), f = u ? l : function(t1, e1) {
                                    return t1.map(function(t1) {
                                        return wo(t1, e1);
                                    });
                                }(l, s), h = u ? c * o : c, p = 0, d = n; p < d.length; p += 1)for(var m = 0, g = d[p]; m < g.length; m += 1){
                                    var v = g[m], y = u ? v : wo(v, s), x = h, b = xo([], [
                                        v.x,
                                        v.y,
                                        0,
                                        1
                                    ], s);
                                    if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? x *= b[3] / a.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (x *= a.cameraToCenterDistance / b[3]), Ja(f, y, x)) return !0;
                                }
                                return !1;
                            }, e1;
                        }(Ei));
                        function wo(t1, e1) {
                            var r = xo([], [
                                t1.x,
                                t1.y,
                                0,
                                1
                            ], e1);
                            return new i(r[0] / r[3], r[1] / r[3]);
                        }
                        var To = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1;
                        }(Xa);
                        function ko(t1, e1, r, n) {
                            var i = e1.width, a = e1.height;
                            if (n) {
                                if (n instanceof Uint8ClampedArray) n = new Uint8Array(n.buffer);
                                else if (n.length !== i * a * r) throw new RangeError("mismatched image size");
                            } else n = new Uint8Array(i * a * r);
                            return t1.width = i, t1.height = a, t1.data = n, t1;
                        }
                        function Ao(t1, e1, r) {
                            var n = e1.width, i = e1.height;
                            if (n !== t1.width || i !== t1.height) {
                                var a = ko({}, {
                                    width: n,
                                    height: i
                                }, r);
                                Mo(t1, a, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: Math.min(t1.width, n),
                                    height: Math.min(t1.height, i)
                                }, r), t1.width = n, t1.height = i, t1.data = a.data;
                            }
                        }
                        function Mo(t1, e1, r, n, i, a) {
                            if (0 === i.width || 0 === i.height) return e1;
                            if (i.width > t1.width || i.height > t1.height || r.x > t1.width - i.width || r.y > t1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
                            if (i.width > e1.width || i.height > e1.height || n.x > e1.width - i.width || n.y > e1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
                            for(var o = t1.data, s = e1.data, l = 0; l < i.height; l++)for(var c = ((r.y + l) * t1.width + r.x) * a, u = ((n.y + l) * e1.width + n.x) * a, f = 0; f < i.width * a; f++)s[u + f] = o[c + f];
                            return e1;
                        }
                        Nn("HeatmapBucket", To, {
                            omit: [
                                "layers"
                            ]
                        });
                        var So = function(t1, e1) {
                            ko(this, t1, 1, e1);
                        };
                        So.prototype.resize = function(t1) {
                            Ao(this, t1, 1);
                        }, So.prototype.clone = function() {
                            return new So({
                                width: this.width,
                                height: this.height
                            }, new Uint8Array(this.data));
                        }, So.copy = function(t1, e1, r, n, i) {
                            Mo(t1, e1, r, n, i, 1);
                        };
                        var Eo = function(t1, e1) {
                            ko(this, t1, 4, e1);
                        };
                        Eo.prototype.resize = function(t1) {
                            Ao(this, t1, 4);
                        }, Eo.prototype.replace = function(t1, e1) {
                            e1 ? this.data.set(t1) : t1 instanceof Uint8ClampedArray ? this.data = new Uint8Array(t1.buffer) : this.data = t1;
                        }, Eo.prototype.clone = function() {
                            return new Eo({
                                width: this.width,
                                height: this.height
                            }, new Uint8Array(this.data));
                        }, Eo.copy = function(t1, e1, r, n, i) {
                            Mo(t1, e1, r, n, i, 4);
                        }, Nn("AlphaImage", So), Nn("RGBAImage", Eo);
                        var Lo = {
                            paint: new Si({
                                "heatmap-radius": new Ti(Lt.paint_heatmap["heatmap-radius"]),
                                "heatmap-weight": new Ti(Lt.paint_heatmap["heatmap-weight"]),
                                "heatmap-intensity": new wi(Lt.paint_heatmap["heatmap-intensity"]),
                                "heatmap-color": new Mi(Lt.paint_heatmap["heatmap-color"]),
                                "heatmap-opacity": new wi(Lt.paint_heatmap["heatmap-opacity"])
                            })
                        };
                        function Co(t1, e1) {
                            for(var r = new Uint8Array(1024), n = {}, i = 0, a = 0; i < 256; i++, a += 4){
                                n[e1] = i / 255;
                                var o = t1.evaluate(n);
                                r[a + 0] = Math.floor(255 * o.r / o.a), r[a + 1] = Math.floor(255 * o.g / o.a), r[a + 2] = Math.floor(255 * o.b / o.a), r[a + 3] = Math.floor(255 * o.a);
                            }
                            return new Eo({
                                width: 256,
                                height: 1
                            }, r);
                        }
                        var Po = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, Lo), this._updateColorRamp();
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.createBucket = function(t1) {
                                return new To(t1);
                            }, e1.prototype._handleSpecialPaintPropertyUpdate = function(t1) {
                                "heatmap-color" === t1 && this._updateColorRamp();
                            }, e1.prototype._updateColorRamp = function() {
                                var t1 = this._transitionablePaint._values["heatmap-color"].value.expression;
                                this.colorRamp = Co(t1, "heatmapDensity"), this.colorRampTexture = null;
                            }, e1.prototype.resize = function() {
                                this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                            }, e1.prototype.queryRadius = function() {
                                return 0;
                            }, e1.prototype.queryIntersectsFeature = function() {
                                return !1;
                            }, e1.prototype.hasOffscreenPass = function() {
                                return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                            }, e1;
                        }(Ei), Io = {
                            paint: new Si({
                                "hillshade-illumination-direction": new wi(Lt.paint_hillshade["hillshade-illumination-direction"]),
                                "hillshade-illumination-anchor": new wi(Lt.paint_hillshade["hillshade-illumination-anchor"]),
                                "hillshade-exaggeration": new wi(Lt.paint_hillshade["hillshade-exaggeration"]),
                                "hillshade-shadow-color": new wi(Lt.paint_hillshade["hillshade-shadow-color"]),
                                "hillshade-highlight-color": new wi(Lt.paint_hillshade["hillshade-highlight-color"]),
                                "hillshade-accent-color": new wi(Lt.paint_hillshade["hillshade-accent-color"])
                            })
                        }, Oo = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, Io);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.hasOffscreenPass = function() {
                                return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                            }, e1;
                        }(Ei), zo = Ii([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4).members, Do = Fo, Ro = Fo;
                        function Fo(t1, e1, r) {
                            r = r || 2;
                            var n, i, a, o, s, l, c, u = e1 && e1.length, f = u ? e1[0] * r : t1.length, h = Bo(t1, 0, f, r, !0), p = [];
                            if (!h || h.next === h.prev) return p;
                            if (u && (h = function(t1, e1, r, n) {
                                var i, a, o, s, l, c = [];
                                for(i = 0, a = e1.length; i < a; i++)o = e1[i] * n, s = i < a - 1 ? e1[i + 1] * n : t1.length, (l = Bo(t1, o, s, n, !1)) === l.next && (l.steiner = !0), c.push(Zo(l));
                                for(c.sort(Go), i = 0; i < c.length; i++)Yo(c[i], r), r = No(r, r.next);
                                return r;
                            }(t1, e1, h, r)), t1.length > 80 * r) {
                                n = a = t1[0], i = o = t1[1];
                                for(var d = r; d < f; d += r)(s = t1[d]) < n && (n = s), (l = t1[d + 1]) < i && (i = l), s > a && (a = s), l > o && (o = l);
                                c = 0 !== (c = Math.max(a - n, o - i)) ? 1 / c : 0;
                            }
                            return jo(h, p, r, n, i, c), p;
                        }
                        function Bo(t1, e1, r, n, i) {
                            var a, o;
                            if (i === ls(t1, e1, r, n) > 0) for(a = e1; a < r; a += n)o = as(a, t1[a], t1[a + 1], o);
                            else for(a = r - n; a >= e1; a -= n)o = as(a, t1[a], t1[a + 1], o);
                            return o && $o(o, o.next) && (os(o), o = o.next), o;
                        }
                        function No(t1, e1) {
                            if (!t1) return t1;
                            e1 || (e1 = t1);
                            var r, n = t1;
                            do if (r = !1, n.steiner || !$o(n, n.next) && 0 !== Qo(n.prev, n, n.next)) n = n.next;
                            else {
                                if (os(n), (n = e1 = n.prev) === n.next) break;
                                r = !0;
                            }
                            while (r || n !== e1);
                            return e1;
                        }
                        function jo(t1, e1, r, n, i, a, o) {
                            if (t1) {
                                !o && a && function(t1, e1, r, n) {
                                    var i = t1;
                                    do null === i.z && (i.z = Xo(i.x, i.y, e1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                                    while (i !== t1);
                                    i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                                        var e1, r, n, i, a, o, s, l, c = 1;
                                        do {
                                            for(r = t1, t1 = null, a = null, o = 0; r;){
                                                for(o++, n = r, s = 0, e1 = 0; e1 < c && (s++, n = n.nextZ); e1++);
                                                for(l = c; s > 0 || l > 0 && n;)0 !== s && (0 === l || !n || r.z <= n.z) ? (i = r, r = r.nextZ, s--) : (i = n, n = n.nextZ, l--), a ? a.nextZ = i : t1 = i, i.prevZ = a, a = i;
                                                r = n;
                                            }
                                            a.nextZ = null, c *= 2;
                                        }while (o > 1);
                                    }(i);
                                }(t1, n, i, a);
                                for(var s, l, c = t1; t1.prev !== t1.next;)if (s = t1.prev, l = t1.next, a ? Vo(t1, n, i, a) : Uo(t1)) e1.push(s.i / r), e1.push(t1.i / r), e1.push(l.i / r), os(t1), t1 = l.next, c = l.next;
                                else if ((t1 = l) === c) {
                                    o ? 1 === o ? jo(t1 = Ho(No(t1), e1, r), e1, r, n, i, a, 2) : 2 === o && qo(t1, e1, r, n, i, a) : jo(No(t1), e1, r, n, i, a, 1);
                                    break;
                                }
                            }
                        }
                        function Uo(t1) {
                            var e1 = t1.prev, r = t1, n = t1.next;
                            if (Qo(e1, r, n) >= 0) return !1;
                            for(var i = t1.next.next; i !== t1.prev;){
                                if (Jo(e1.x, e1.y, r.x, r.y, n.x, n.y, i.x, i.y) && Qo(i.prev, i, i.next) >= 0) return !1;
                                i = i.next;
                            }
                            return !0;
                        }
                        function Vo(t1, e1, r, n) {
                            var i = t1.prev, a = t1, o = t1.next;
                            if (Qo(i, a, o) >= 0) return !1;
                            for(var s = i.x < a.x ? i.x < o.x ? i.x : o.x : a.x < o.x ? a.x : o.x, l = i.y < a.y ? i.y < o.y ? i.y : o.y : a.y < o.y ? a.y : o.y, c = i.x > a.x ? i.x > o.x ? i.x : o.x : a.x > o.x ? a.x : o.x, u = i.y > a.y ? i.y > o.y ? i.y : o.y : a.y > o.y ? a.y : o.y, f = Xo(s, l, e1, r, n), h = Xo(c, u, e1, r, n), p = t1.prevZ, d = t1.nextZ; p && p.z >= f && d && d.z <= h;){
                                if (p !== t1.prev && p !== t1.next && Jo(i.x, i.y, a.x, a.y, o.x, o.y, p.x, p.y) && Qo(p.prev, p, p.next) >= 0) return !1;
                                if (p = p.prevZ, d !== t1.prev && d !== t1.next && Jo(i.x, i.y, a.x, a.y, o.x, o.y, d.x, d.y) && Qo(d.prev, d, d.next) >= 0) return !1;
                                d = d.nextZ;
                            }
                            for(; p && p.z >= f;){
                                if (p !== t1.prev && p !== t1.next && Jo(i.x, i.y, a.x, a.y, o.x, o.y, p.x, p.y) && Qo(p.prev, p, p.next) >= 0) return !1;
                                p = p.prevZ;
                            }
                            for(; d && d.z <= h;){
                                if (d !== t1.prev && d !== t1.next && Jo(i.x, i.y, a.x, a.y, o.x, o.y, d.x, d.y) && Qo(d.prev, d, d.next) >= 0) return !1;
                                d = d.nextZ;
                            }
                            return !0;
                        }
                        function Ho(t1, e1, r) {
                            var n = t1;
                            do {
                                var i = n.prev, a = n.next.next;
                                !$o(i, a) && ts(i, n, n.next, a) && ns(i, a) && ns(a, i) && (e1.push(i.i / r), e1.push(n.i / r), e1.push(a.i / r), os(n), os(n.next), n = t1 = a), n = n.next;
                            }while (n !== t1);
                            return No(n);
                        }
                        function qo(t1, e1, r, n, i, a) {
                            var o = t1;
                            do {
                                for(var s = o.next.next; s !== o.prev;){
                                    if (o.i !== s.i && Ko(o, s)) {
                                        var l = is(o, s);
                                        return o = No(o, o.next), l = No(l, l.next), jo(o, e1, r, n, i, a), void jo(l, e1, r, n, i, a);
                                    }
                                    s = s.next;
                                }
                                o = o.next;
                            }while (o !== t1);
                        }
                        function Go(t1, e1) {
                            return t1.x - e1.x;
                        }
                        function Yo(t1, e1) {
                            if (e1 = function(t1, e1) {
                                var r, n = e1, i = t1.x, a = t1.y, o = -1 / 0;
                                do {
                                    if (a <= n.y && a >= n.next.y && n.next.y !== n.y) {
                                        var s = n.x + (a - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                                        if (s <= i && s > o) {
                                            if (o = s, s === i) {
                                                if (a === n.y) return n;
                                                if (a === n.next.y) return n.next;
                                            }
                                            r = n.x < n.next.x ? n : n.next;
                                        }
                                    }
                                    n = n.next;
                                }while (n !== e1);
                                if (!r) return null;
                                if (i === o) return r;
                                var l, c = r, u = r.x, f = r.y, h = 1 / 0;
                                n = r;
                                do i >= n.x && n.x >= u && i !== n.x && Jo(a < f ? i : o, a, u, f, a < f ? o : i, a, n.x, n.y) && (l = Math.abs(a - n.y) / (i - n.x), ns(n, t1) && (l < h || l === h && (n.x > r.x || n.x === r.x && Wo(r, n))) && (r = n, h = l)), n = n.next;
                                while (n !== c);
                                return r;
                            }(t1, e1)) {
                                var r = is(e1, t1);
                                No(e1, e1.next), No(r, r.next);
                            }
                        }
                        function Wo(t1, e1) {
                            return Qo(t1.prev, t1, e1.prev) < 0 && Qo(e1.next, t1, t1.next) < 0;
                        }
                        function Xo(t1, e1, r, n, i) {
                            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = 32767 * (t1 - r) * i) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = 32767 * (e1 - n) * i) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
                        }
                        function Zo(t1) {
                            var e1 = t1, r = t1;
                            do (e1.x < r.x || e1.x === r.x && e1.y < r.y) && (r = e1), e1 = e1.next;
                            while (e1 !== t1);
                            return r;
                        }
                        function Jo(t1, e1, r, n, i, a, o, s) {
                            return (i - o) * (e1 - s) - (t1 - o) * (a - s) >= 0 && (t1 - o) * (n - s) - (r - o) * (e1 - s) >= 0 && (r - o) * (a - s) - (i - o) * (n - s) >= 0;
                        }
                        function Ko(t1, e1) {
                            return t1.next.i !== e1.i && t1.prev.i !== e1.i && !function(t1, e1) {
                                var r = t1;
                                do {
                                    if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e1.i && r.next.i !== e1.i && ts(r, r.next, t1, e1)) return !0;
                                    r = r.next;
                                }while (r !== t1);
                                return !1;
                            }(t1, e1) && (ns(t1, e1) && ns(e1, t1) && function(t1, e1) {
                                var r = t1, n = !1, i = (t1.x + e1.x) / 2, a = (t1.y + e1.y) / 2;
                                do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                                while (r !== t1);
                                return n;
                            }(t1, e1) && (Qo(t1.prev, t1, e1.prev) || Qo(t1, e1.prev, e1)) || $o(t1, e1) && Qo(t1.prev, t1, t1.next) > 0 && Qo(e1.prev, e1, e1.next) > 0);
                        }
                        function Qo(t1, e1, r) {
                            return (e1.y - t1.y) * (r.x - e1.x) - (e1.x - t1.x) * (r.y - e1.y);
                        }
                        function $o(t1, e1) {
                            return t1.x === e1.x && t1.y === e1.y;
                        }
                        function ts(t1, e1, r, n) {
                            var i = rs(Qo(t1, e1, r)), a = rs(Qo(t1, e1, n)), o = rs(Qo(r, n, t1)), s = rs(Qo(r, n, e1));
                            return i !== a && o !== s || !(0 !== i || !es(t1, r, e1)) || !(0 !== a || !es(t1, n, e1)) || !(0 !== o || !es(r, t1, n)) || !(0 !== s || !es(r, e1, n));
                        }
                        function es(t1, e1, r) {
                            return e1.x <= Math.max(t1.x, r.x) && e1.x >= Math.min(t1.x, r.x) && e1.y <= Math.max(t1.y, r.y) && e1.y >= Math.min(t1.y, r.y);
                        }
                        function rs(t1) {
                            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
                        }
                        function ns(t1, e1) {
                            return Qo(t1.prev, t1, t1.next) < 0 ? Qo(t1, e1, t1.next) >= 0 && Qo(t1, t1.prev, e1) >= 0 : Qo(t1, e1, t1.prev) < 0 || Qo(t1, t1.next, e1) < 0;
                        }
                        function is(t1, e1) {
                            var r = new ss(t1.i, t1.x, t1.y), n = new ss(e1.i, e1.x, e1.y), i = t1.next, a = e1.prev;
                            return t1.next = e1, e1.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
                        }
                        function as(t1, e1, r, n) {
                            var i = new ss(t1, e1, r);
                            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
                        }
                        function os(t1) {
                            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
                        }
                        function ss(t1, e1, r) {
                            this.i = t1, this.x = e1, this.y = r, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
                        }
                        function ls(t1, e1, r, n) {
                            for(var i = 0, a = e1, o = r - n; a < r; a += n)i += (t1[o] - t1[a]) * (t1[a + 1] + t1[o + 1]), o = a;
                            return i;
                        }
                        function cs(t1, e1, r, n, i) {
                            !function t1(e1, r, n, i, a) {
                                for(; i > n;){
                                    if (i - n > 600) {
                                        var o = i - n + 1, s = r - n + 1, l = Math.log(o), c = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * c * (o - c) / o) * (s - o / 2 < 0 ? -1 : 1), f = Math.max(n, Math.floor(r - s * c / o + u)), h = Math.min(i, Math.floor(r + (o - s) * c / o + u));
                                        t1(e1, r, f, h, a);
                                    }
                                    var p = e1[r], d = n, m = i;
                                    for(us(e1, n, r), a(e1[i], p) > 0 && us(e1, n, i); d < m;){
                                        for(us(e1, d, m), d++, m--; a(e1[d], p) < 0;)d++;
                                        for(; a(e1[m], p) > 0;)m--;
                                    }
                                    0 === a(e1[n], p) ? us(e1, n, m) : (m++, us(e1, m, i)), m <= r && (n = m + 1), r <= m && (i = m - 1);
                                }
                            }(t1, e1, r || 0, n || t1.length - 1, i || fs);
                        }
                        function us(t1, e1, r) {
                            var n = t1[e1];
                            t1[e1] = t1[r], t1[r] = n;
                        }
                        function fs(t1, e1) {
                            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
                        }
                        function hs(t1, e1) {
                            var r = t1.length;
                            if (r <= 1) return [
                                t1
                            ];
                            for(var n, i, a = [], o = 0; o < r; o++){
                                var s = T(t1[o]);
                                0 !== s && (t1[o].area = Math.abs(s), void 0 === i && (i = s < 0), i === s < 0 ? (n && a.push(n), n = [
                                    t1[o]
                                ]) : n.push(t1[o]));
                            }
                            if (n && a.push(n), e1 > 1) for(var l = 0; l < a.length; l++)a[l].length <= e1 || (cs(a[l], e1, 1, a[l].length - 1, ps), a[l] = a[l].slice(0, e1));
                            return a;
                        }
                        function ps(t1, e1) {
                            return e1.area - t1.area;
                        }
                        function ds(t1, e1, r) {
                            for(var n = r.patternDependencies, i = !1, a = 0, o = e1; a < o.length; a += 1){
                                var s = o[a].paint.get(t1 + "-pattern");
                                s.isConstant() || (i = !0);
                                var l = s.constantOr(null);
                                l && (i = !0, n[l.to] = !0, n[l.from] = !0);
                            }
                            return i;
                        }
                        function ms(t1, e1, r, n, i) {
                            for(var a = i.patternDependencies, o = 0, s = e1; o < s.length; o += 1){
                                var l = s[o], c = l.paint.get(t1 + "-pattern").value;
                                if ("constant" !== c.kind) {
                                    var u = c.evaluate({
                                        zoom: n - 1
                                    }, r, {}, i.availableImages), f = c.evaluate({
                                        zoom: n
                                    }, r, {}, i.availableImages), h = c.evaluate({
                                        zoom: n + 1
                                    }, r, {}, i.availableImages);
                                    u = u && u.name ? u.name : u, f = f && f.name ? f.name : f, h = h && h.name ? h.name : h, a[u] = !0, a[f] = !0, a[h] = !0, r.patterns[l.id] = {
                                        min: u,
                                        mid: f,
                                        max: h
                                    };
                                }
                            }
                            return r;
                        }
                        Fo.deviation = function(t1, e1, r, n) {
                            var i = e1 && e1.length, a = i ? e1[0] * r : t1.length, o = Math.abs(ls(t1, 0, a, r));
                            if (i) for(var s = 0, l = e1.length; s < l; s++){
                                var c = e1[s] * r, u = s < l - 1 ? e1[s + 1] * r : t1.length;
                                o -= Math.abs(ls(t1, c, u, r));
                            }
                            var f = 0;
                            for(s = 0; s < n.length; s += 3){
                                var h = n[s] * r, p = n[s + 1] * r, d = n[s + 2] * r;
                                f += Math.abs((t1[h] - t1[d]) * (t1[p + 1] - t1[h + 1]) - (t1[h] - t1[p]) * (t1[d + 1] - t1[h + 1]));
                            }
                            return 0 === o && 0 === f ? 0 : Math.abs((f - o) / o);
                        }, Fo.flatten = function(t1) {
                            for(var e1 = t1[0][0].length, r = {
                                vertices: [],
                                holes: [],
                                dimensions: e1
                            }, n = 0, i = 0; i < t1.length; i++){
                                for(var a = 0; a < t1[i].length; a++)for(var o = 0; o < e1; o++)r.vertices.push(t1[i][a][o]);
                                i > 0 && (n += t1[i - 1].length, r.holes.push(n));
                            }
                            return r;
                        }, Do.default = Ro;
                        var gs = function(t1) {
                            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                                return t1.id;
                            }), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new zi, this.indexArray = new Yi, this.indexArray2 = new Qi, this.programConfigurations = new Ua(zo, t1.layers, t1.zoom), this.segments = new pa, this.segments2 = new pa, this.stateDependentLayerIds = this.layers.filter(function(t1) {
                                return t1.isStateDependent();
                            }).map(function(t1) {
                                return t1.id;
                            });
                        };
                        gs.prototype.populate = function(t1, e1, r) {
                            this.hasPattern = ds("fill", this.layers, e1);
                            for(var n = this.layers[0].layout.get("fill-sort-key"), i = [], a = 0, o = t1; a < o.length; a += 1){
                                var s = o[a], l = s.feature, c = s.id, u = s.index, f = s.sourceLayerIndex, h = this.layers[0]._featureFilter.needGeometry, p = {
                                    type: l.type,
                                    id: c,
                                    properties: l.properties,
                                    geometry: h ? Ya(l) : []
                                };
                                if (this.layers[0]._featureFilter.filter(new pi(this.zoom), p, r)) {
                                    h || (p.geometry = Ya(l));
                                    var d = n ? n.evaluate(p, {}, r, e1.availableImages) : void 0, m = {
                                        id: c,
                                        properties: l.properties,
                                        type: l.type,
                                        sourceLayerIndex: f,
                                        index: u,
                                        geometry: p.geometry,
                                        patterns: {},
                                        sortKey: d
                                    };
                                    i.push(m);
                                }
                            }
                            n && i.sort(function(t1, e1) {
                                return t1.sortKey - e1.sortKey;
                            });
                            for(var g = 0, v = i; g < v.length; g += 1){
                                var y = v[g], x = y, b = x.geometry, _ = x.index, w = x.sourceLayerIndex;
                                if (this.hasPattern) {
                                    var T = ms("fill", this.layers, y, this.zoom, e1);
                                    this.patternFeatures.push(T);
                                } else this.addFeature(y, b, _, r, {});
                                var k = t1[_].feature;
                                e1.featureIndex.insert(k, b, _, w, this.index);
                            }
                        }, gs.prototype.update = function(t1, e1, r) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
                        }, gs.prototype.addFeatures = function(t1, e1, r) {
                            for(var n = 0, i = this.patternFeatures; n < i.length; n += 1){
                                var a = i[n];
                                this.addFeature(a, a.geometry, a.index, e1, r);
                            }
                        }, gs.prototype.isEmpty = function() {
                            return 0 === this.layoutVertexArray.length;
                        }, gs.prototype.uploadPending = function() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }, gs.prototype.upload = function(t1) {
                            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, zo), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.indexBuffer2 = t1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t1), this.uploaded = !0;
                        }, gs.prototype.destroy = function() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
                        }, gs.prototype.addFeature = function(t1, e1, r, n, i) {
                            for(var a = 0, o = hs(e1, 500); a < o.length; a += 1){
                                for(var s = o[a], l = 0, c = 0, u = s; c < u.length; c += 1)l += u[c].length;
                                for(var f = this.segments.prepareSegment(l, this.layoutVertexArray, this.indexArray), h = f.vertexLength, p = [], d = [], m = 0, g = s; m < g.length; m += 1){
                                    var v = g[m];
                                    if (0 !== v.length) {
                                        v !== s[0] && d.push(p.length / 2);
                                        var y = this.segments2.prepareSegment(v.length, this.layoutVertexArray, this.indexArray2), x = y.vertexLength;
                                        this.layoutVertexArray.emplaceBack(v[0].x, v[0].y), this.indexArray2.emplaceBack(x + v.length - 1, x), p.push(v[0].x), p.push(v[0].y);
                                        for(var b = 1; b < v.length; b++)this.layoutVertexArray.emplaceBack(v[b].x, v[b].y), this.indexArray2.emplaceBack(x + b - 1, x + b), p.push(v[b].x), p.push(v[b].y);
                                        y.vertexLength += v.length, y.primitiveLength += v.length;
                                    }
                                }
                                for(var _ = Do(p, d), w = 0; w < _.length; w += 3)this.indexArray.emplaceBack(h + _[w], h + _[w + 1], h + _[w + 2]);
                                f.vertexLength += l, f.primitiveLength += _.length / 3;
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
                        }, Nn("FillBucket", gs, {
                            omit: [
                                "layers",
                                "patternFeatures"
                            ]
                        });
                        var vs = new Si({
                            "fill-sort-key": new Ti(Lt.layout_fill["fill-sort-key"])
                        }), ys = {
                            paint: new Si({
                                "fill-antialias": new wi(Lt.paint_fill["fill-antialias"]),
                                "fill-opacity": new Ti(Lt.paint_fill["fill-opacity"]),
                                "fill-color": new Ti(Lt.paint_fill["fill-color"]),
                                "fill-outline-color": new Ti(Lt.paint_fill["fill-outline-color"]),
                                "fill-translate": new wi(Lt.paint_fill["fill-translate"]),
                                "fill-translate-anchor": new wi(Lt.paint_fill["fill-translate-anchor"]),
                                "fill-pattern": new ki(Lt.paint_fill["fill-pattern"])
                            }),
                            layout: vs
                        }, xs = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, ys);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.recalculate = function(e1, r) {
                                t1.prototype.recalculate.call(this, e1, r);
                                var n = this.paint._values["fill-outline-color"];
                                "constant" === n.value.kind && void 0 === n.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                            }, e1.prototype.createBucket = function(t1) {
                                return new gs(t1);
                            }, e1.prototype.queryRadius = function() {
                                return so(this.paint.get("fill-translate"));
                            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, i, a, o) {
                                return Ka(lo(t1, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), a.angle, o), n);
                            }, e1.prototype.isTileClipped = function() {
                                return !0;
                            }, e1;
                        }(Ei), bs = Ii([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_normal_ed",
                                components: 4,
                                type: "Int16"
                            }
                        ], 4).members, _s = ws;
                        function ws(t1, e1, r, n, i) {
                            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t1, this._geometry = -1, this._keys = n, this._values = i, t1.readFields(Ts, this, e1);
                        }
                        function Ts(t1, e1, r) {
                            1 == t1 ? e1.id = r.readVarint() : 2 == t1 ? function(t1, e1) {
                                var r = t1.readVarint() + t1.pos;
                                for(; t1.pos < r;){
                                    var n = e1._keys[t1.readVarint()], i = e1._values[t1.readVarint()];
                                    e1.properties[n] = i;
                                }
                            }(r, e1) : 3 == t1 ? e1.type = r.readVarint() : 4 == t1 && (e1._geometry = r.pos);
                        }
                        function ks(t1) {
                            for(var e1, r, n = 0, i = 0, a = t1.length, o = a - 1; i < a; o = i++)e1 = t1[i], n += ((r = t1[o]).x - e1.x) * (e1.y + r.y);
                            return n;
                        }
                        ws.types = [
                            "Unknown",
                            "Point",
                            "LineString",
                            "Polygon"
                        ], ws.prototype.loadGeometry = function() {
                            var t1 = this._pbf;
                            t1.pos = this._geometry;
                            for(var e1, r = t1.readVarint() + t1.pos, n = 1, a = 0, o = 0, s = 0, l = []; t1.pos < r;){
                                if (a <= 0) {
                                    var c = t1.readVarint();
                                    n = 7 & c, a = c >> 3;
                                }
                                if (a--, 1 === n || 2 === n) o += t1.readSVarint(), s += t1.readSVarint(), 1 === n && (e1 && l.push(e1), e1 = []), e1.push(new i(o, s));
                                else {
                                    if (7 !== n) throw new Error("unknown command " + n);
                                    e1 && e1.push(e1[0].clone());
                                }
                            }
                            return e1 && l.push(e1), l;
                        }, ws.prototype.bbox = function() {
                            var t1 = this._pbf;
                            t1.pos = this._geometry;
                            for(var e1 = t1.readVarint() + t1.pos, r = 1, n = 0, i = 0, a = 0, o = 1 / 0, s = -1 / 0, l = 1 / 0, c = -1 / 0; t1.pos < e1;){
                                if (n <= 0) {
                                    var u = t1.readVarint();
                                    r = 7 & u, n = u >> 3;
                                }
                                if (n--, 1 === r || 2 === r) (i += t1.readSVarint()) < o && (o = i), i > s && (s = i), (a += t1.readSVarint()) < l && (l = a), a > c && (c = a);
                                else if (7 !== r) throw new Error("unknown command " + r);
                            }
                            return [
                                o,
                                l,
                                s,
                                c
                            ];
                        }, ws.prototype.toGeoJSON = function(t1, e1, r) {
                            var n, i, a = this.extent * Math.pow(2, r), o = this.extent * t1, s = this.extent * e1, l = this.loadGeometry(), c = ws.types[this.type];
                            function u(t1) {
                                for(var e1 = 0; e1 < t1.length; e1++){
                                    var r = t1[e1], n = 180 - 360 * (r.y + s) / a;
                                    t1[e1] = [
                                        360 * (r.x + o) / a - 180,
                                        360 / Math.PI * Math.atan(Math.exp(n * Math.PI / 180)) - 90
                                    ];
                                }
                            }
                            switch(this.type){
                                case 1:
                                    var f = [];
                                    for(n = 0; n < l.length; n++)f[n] = l[n][0];
                                    u(l = f);
                                    break;
                                case 2:
                                    for(n = 0; n < l.length; n++)u(l[n]);
                                    break;
                                case 3:
                                    for(l = function(t1) {
                                        var e1 = t1.length;
                                        if (e1 <= 1) return [
                                            t1
                                        ];
                                        for(var r, n, i = [], a = 0; a < e1; a++){
                                            var o = ks(t1[a]);
                                            0 !== o && (void 0 === n && (n = o < 0), n === o < 0 ? (r && i.push(r), r = [
                                                t1[a]
                                            ]) : r.push(t1[a]));
                                        }
                                        r && i.push(r);
                                        return i;
                                    }(l), n = 0; n < l.length; n++)for(i = 0; i < l[n].length; i++)u(l[n][i]);
                            }
                            1 === l.length ? l = l[0] : c = "Multi" + c;
                            var h = {
                                type: "Feature",
                                geometry: {
                                    type: c,
                                    coordinates: l
                                },
                                properties: this.properties
                            };
                            return "id" in this && (h.id = this.id), h;
                        };
                        var As = Ms;
                        function Ms(t1, e1) {
                            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t1, this._keys = [], this._values = [], this._features = [], t1.readFields(Ss, this, e1), this.length = this._features.length;
                        }
                        function Ss(t1, e1, r) {
                            15 === t1 ? e1.version = r.readVarint() : 1 === t1 ? e1.name = r.readString() : 5 === t1 ? e1.extent = r.readVarint() : 2 === t1 ? e1._features.push(r.pos) : 3 === t1 ? e1._keys.push(r.readString()) : 4 === t1 && e1._values.push(function(t1) {
                                var e1 = null, r = t1.readVarint() + t1.pos;
                                for(; t1.pos < r;){
                                    var n = t1.readVarint() >> 3;
                                    e1 = 1 === n ? t1.readString() : 2 === n ? t1.readFloat() : 3 === n ? t1.readDouble() : 4 === n ? t1.readVarint64() : 5 === n ? t1.readVarint() : 6 === n ? t1.readSVarint() : 7 === n ? t1.readBoolean() : null;
                                }
                                return e1;
                            }(r));
                        }
                        function Es(t1, e1, r) {
                            if (3 === t1) {
                                var n = new As(r, r.readVarint() + r.pos);
                                n.length && (e1[n.name] = n);
                            }
                        }
                        Ms.prototype.feature = function(t1) {
                            if (t1 < 0 || t1 >= this._features.length) throw new Error("feature index out of bounds");
                            this._pbf.pos = this._features[t1];
                            var e1 = this._pbf.readVarint() + this._pbf.pos;
                            return new _s(this._pbf, e1, this.extent, this._keys, this._values);
                        };
                        var Ls = {
                            VectorTile: function(t1, e1) {
                                this.layers = t1.readFields(Es, {}, e1);
                            },
                            VectorTileFeature: _s,
                            VectorTileLayer: As
                        }, Cs = Ls.VectorTileFeature.types, Ps = Math.pow(2, 13);
                        function Is(t1, e1, r, n, i, a, o, s) {
                            t1.emplaceBack(e1, r, 2 * Math.floor(n * Ps) + o, i * Ps * 2, a * Ps * 2, Math.round(s));
                        }
                        var Os = function(t1) {
                            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                                return t1.id;
                            }), this.index = t1.index, this.hasPattern = !1, this.layoutVertexArray = new Ri, this.indexArray = new Yi, this.programConfigurations = new Ua(bs, t1.layers, t1.zoom), this.segments = new pa, this.stateDependentLayerIds = this.layers.filter(function(t1) {
                                return t1.isStateDependent();
                            }).map(function(t1) {
                                return t1.id;
                            });
                        };
                        function zs(t1, e1) {
                            return t1.x === e1.x && (t1.x < 0 || t1.x > 8192) || t1.y === e1.y && (t1.y < 0 || t1.y > 8192);
                        }
                        function Ds(t1) {
                            return t1.every(function(t1) {
                                return t1.x < 0;
                            }) || t1.every(function(t1) {
                                return t1.x > 8192;
                            }) || t1.every(function(t1) {
                                return t1.y < 0;
                            }) || t1.every(function(t1) {
                                return t1.y > 8192;
                            });
                        }
                        Os.prototype.populate = function(t1, e1, r) {
                            this.features = [], this.hasPattern = ds("fill-extrusion", this.layers, e1);
                            for(var n = 0, i = t1; n < i.length; n += 1){
                                var a = i[n], o = a.feature, s = a.id, l = a.index, c = a.sourceLayerIndex, u = this.layers[0]._featureFilter.needGeometry, f = {
                                    type: o.type,
                                    id: s,
                                    properties: o.properties,
                                    geometry: u ? Ya(o) : []
                                };
                                if (this.layers[0]._featureFilter.filter(new pi(this.zoom), f, r)) {
                                    var h = {
                                        id: s,
                                        sourceLayerIndex: c,
                                        index: l,
                                        geometry: u ? f.geometry : Ya(o),
                                        properties: o.properties,
                                        type: o.type,
                                        patterns: {}
                                    };
                                    void 0 !== o.id && (h.id = o.id), this.hasPattern ? this.features.push(ms("fill-extrusion", this.layers, h, this.zoom, e1)) : this.addFeature(h, h.geometry, l, r, {}), e1.featureIndex.insert(o, h.geometry, l, c, this.index, !0);
                                }
                            }
                        }, Os.prototype.addFeatures = function(t1, e1, r) {
                            for(var n = 0, i = this.features; n < i.length; n += 1){
                                var a = i[n], o = a.geometry;
                                this.addFeature(a, o, a.index, e1, r);
                            }
                        }, Os.prototype.update = function(t1, e1, r) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
                        }, Os.prototype.isEmpty = function() {
                            return 0 === this.layoutVertexArray.length;
                        }, Os.prototype.uploadPending = function() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }, Os.prototype.upload = function(t1) {
                            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, bs), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
                        }, Os.prototype.destroy = function() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                        }, Os.prototype.addFeature = function(t1, e1, r, n, i) {
                            for(var a = 0, o = hs(e1, 500); a < o.length; a += 1){
                                for(var s = o[a], l = 0, c = 0, u = s; c < u.length; c += 1)l += u[c].length;
                                for(var f = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray), h = 0, p = s; h < p.length; h += 1){
                                    var d = p[h];
                                    if (0 !== d.length && !Ds(d)) for(var m = 0, g = 0; g < d.length; g++){
                                        var v = d[g];
                                        if (g >= 1) {
                                            var y = d[g - 1];
                                            if (!zs(v, y)) {
                                                f.vertexLength + 4 > pa.MAX_VERTEX_ARRAY_LENGTH && (f = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                                var x = v.sub(y)._perp()._unit(), b = y.dist(v);
                                                m + b > 32768 && (m = 0), Is(this.layoutVertexArray, v.x, v.y, x.x, x.y, 0, 0, m), Is(this.layoutVertexArray, v.x, v.y, x.x, x.y, 0, 1, m), m += b, Is(this.layoutVertexArray, y.x, y.y, x.x, x.y, 0, 0, m), Is(this.layoutVertexArray, y.x, y.y, x.x, x.y, 0, 1, m);
                                                var _ = f.vertexLength;
                                                this.indexArray.emplaceBack(_, _ + 2, _ + 1), this.indexArray.emplaceBack(_ + 1, _ + 2, _ + 3), f.vertexLength += 4, f.primitiveLength += 2;
                                            }
                                        }
                                    }
                                }
                                if (f.vertexLength + l > pa.MAX_VERTEX_ARRAY_LENGTH && (f = this.segments.prepareSegment(l, this.layoutVertexArray, this.indexArray)), "Polygon" === Cs[t1.type]) {
                                    for(var w = [], T = [], k = f.vertexLength, A = 0, M = s; A < M.length; A += 1){
                                        var S = M[A];
                                        if (0 !== S.length) {
                                            S !== s[0] && T.push(w.length / 2);
                                            for(var E = 0; E < S.length; E++){
                                                var L = S[E];
                                                Is(this.layoutVertexArray, L.x, L.y, 0, 0, 1, 1, 0), w.push(L.x), w.push(L.y);
                                            }
                                        }
                                    }
                                    for(var C = Do(w, T), P = 0; P < C.length; P += 3)this.indexArray.emplaceBack(k + C[P], k + C[P + 2], k + C[P + 1]);
                                    f.primitiveLength += C.length / 3, f.vertexLength += l;
                                }
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
                        }, Nn("FillExtrusionBucket", Os, {
                            omit: [
                                "layers",
                                "features"
                            ]
                        });
                        var Rs = {
                            paint: new Si({
                                "fill-extrusion-opacity": new wi(Lt["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                                "fill-extrusion-color": new Ti(Lt["paint_fill-extrusion"]["fill-extrusion-color"]),
                                "fill-extrusion-translate": new wi(Lt["paint_fill-extrusion"]["fill-extrusion-translate"]),
                                "fill-extrusion-translate-anchor": new wi(Lt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                                "fill-extrusion-pattern": new ki(Lt["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                                "fill-extrusion-height": new Ti(Lt["paint_fill-extrusion"]["fill-extrusion-height"]),
                                "fill-extrusion-base": new Ti(Lt["paint_fill-extrusion"]["fill-extrusion-base"]),
                                "fill-extrusion-vertical-gradient": new wi(Lt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                            })
                        }, Fs = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, Rs);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.createBucket = function(t1) {
                                return new Os(t1);
                            }, e1.prototype.queryRadius = function() {
                                return so(this.paint.get("fill-extrusion-translate"));
                            }, e1.prototype.is3D = function() {
                                return !0;
                            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, a, o, s, l) {
                                var c = lo(t1, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), o.angle, s), u = this.paint.get("fill-extrusion-height").evaluate(e1, r), f = this.paint.get("fill-extrusion-base").evaluate(e1, r), h = function(t1, e1, r, n) {
                                    for(var a = [], o = 0, s = t1; o < s.length; o += 1){
                                        var l = s[o], c = [
                                            l.x,
                                            l.y,
                                            n,
                                            1
                                        ];
                                        xo(c, c, e1), a.push(new i(c[0] / c[3], c[1] / c[3]));
                                    }
                                    return a;
                                }(c, l, 0, 0), p = function(t1, e1, r, n) {
                                    for(var a = [], o = [], s = n[8] * e1, l = n[9] * e1, c = n[10] * e1, u = n[11] * e1, f = n[8] * r, h = n[9] * r, p = n[10] * r, d = n[11] * r, m = 0, g = t1; m < g.length; m += 1){
                                        for(var v = g[m], y = [], x = [], b = 0, _ = v; b < _.length; b += 1){
                                            var w = _[b], T = w.x, k = w.y, A = n[0] * T + n[4] * k + n[12], M = n[1] * T + n[5] * k + n[13], S = n[2] * T + n[6] * k + n[14], E = n[3] * T + n[7] * k + n[15], L = S + c, C = E + u, P = A + f, I = M + h, O = S + p, z = E + d, D = new i((A + s) / C, (M + l) / C);
                                            D.z = L / C, y.push(D);
                                            var R = new i(P / z, I / z);
                                            R.z = O / z, x.push(R);
                                        }
                                        a.push(y), o.push(x);
                                    }
                                    return [
                                        a,
                                        o
                                    ];
                                }(n, f, u, l);
                                return function(t1, e1, r) {
                                    var n = 1 / 0;
                                    Ka(r, e1) && (n = Ns(r, e1[0]));
                                    for(var i = 0; i < e1.length; i++)for(var a = e1[i], o = t1[i], s = 0; s < a.length - 1; s++){
                                        var l = a[s], c = a[s + 1], u = o[s], f = o[s + 1], h = [
                                            l,
                                            c,
                                            f,
                                            u,
                                            l
                                        ];
                                        Za(r, h) && (n = Math.min(n, Ns(r, h)));
                                    }
                                    return n !== 1 / 0 && n;
                                }(p[0], p[1], h);
                            }, e1;
                        }(Ei);
                        function Bs(t1, e1) {
                            return t1.x * e1.x + t1.y * e1.y;
                        }
                        function Ns(t1, e1) {
                            if (1 === t1.length) {
                                for(var r, n = 0, i = e1[n++]; !r || i.equals(r);)if (!(r = e1[n++])) return 1 / 0;
                                for(; n < e1.length; n++){
                                    var a = e1[n], o = t1[0], s = r.sub(i), l = a.sub(i), c = o.sub(i), u = Bs(s, s), f = Bs(s, l), h = Bs(l, l), p = Bs(c, s), d = Bs(c, l), m = u * h - f * f, g = (h * p - f * d) / m, v = (u * d - f * p) / m, y = 1 - g - v, x = i.z * y + r.z * g + a.z * v;
                                    if (isFinite(x)) return x;
                                }
                                return 1 / 0;
                            }
                            for(var b = 1 / 0, _ = 0, w = e1; _ < w.length; _ += 1){
                                var T = w[_];
                                b = Math.min(b, T.z);
                            }
                            return b;
                        }
                        var js = Ii([
                            {
                                name: "a_pos_normal",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_data",
                                components: 4,
                                type: "Uint8"
                            }
                        ], 4).members, Us = Ls.VectorTileFeature.types, Vs = Math.cos(Math.PI / 180 * 37.5), Hs = Math.pow(2, 14) / .5, qs = function(t1) {
                            this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                                return t1.id;
                            }), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new Fi, this.indexArray = new Yi, this.programConfigurations = new Ua(js, t1.layers, t1.zoom), this.segments = new pa, this.stateDependentLayerIds = this.layers.filter(function(t1) {
                                return t1.isStateDependent();
                            }).map(function(t1) {
                                return t1.id;
                            });
                        };
                        qs.prototype.populate = function(t1, e1, r) {
                            this.hasPattern = ds("line", this.layers, e1);
                            for(var n = this.layers[0].layout.get("line-sort-key"), i = [], a = 0, o = t1; a < o.length; a += 1){
                                var s = o[a], l = s.feature, c = s.id, u = s.index, f = s.sourceLayerIndex, h = this.layers[0]._featureFilter.needGeometry, p = {
                                    type: l.type,
                                    id: c,
                                    properties: l.properties,
                                    geometry: h ? Ya(l) : []
                                };
                                if (this.layers[0]._featureFilter.filter(new pi(this.zoom), p, r)) {
                                    h || (p.geometry = Ya(l));
                                    var d = n ? n.evaluate(p, {}, r) : void 0, m = {
                                        id: c,
                                        properties: l.properties,
                                        type: l.type,
                                        sourceLayerIndex: f,
                                        index: u,
                                        geometry: p.geometry,
                                        patterns: {},
                                        sortKey: d
                                    };
                                    i.push(m);
                                }
                            }
                            n && i.sort(function(t1, e1) {
                                return t1.sortKey - e1.sortKey;
                            });
                            for(var g = 0, v = i; g < v.length; g += 1){
                                var y = v[g], x = y, b = x.geometry, _ = x.index, w = x.sourceLayerIndex;
                                if (this.hasPattern) {
                                    var T = ms("line", this.layers, y, this.zoom, e1);
                                    this.patternFeatures.push(T);
                                } else this.addFeature(y, b, _, r, {});
                                var k = t1[_].feature;
                                e1.featureIndex.insert(k, b, _, w, this.index);
                            }
                        }, qs.prototype.update = function(t1, e1, r) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t1, e1, this.stateDependentLayers, r);
                        }, qs.prototype.addFeatures = function(t1, e1, r) {
                            for(var n = 0, i = this.patternFeatures; n < i.length; n += 1){
                                var a = i[n];
                                this.addFeature(a, a.geometry, a.index, e1, r);
                            }
                        }, qs.prototype.isEmpty = function() {
                            return 0 === this.layoutVertexArray.length;
                        }, qs.prototype.uploadPending = function() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }, qs.prototype.upload = function(t1) {
                            this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, js), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
                        }, qs.prototype.destroy = function() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                        }, qs.prototype.addFeature = function(t1, e1, r, n, i) {
                            for(var a = this.layers[0].layout, o = a.get("line-join").evaluate(t1, {}), s = a.get("line-cap"), l = a.get("line-miter-limit"), c = a.get("line-round-limit"), u = 0, f = e1; u < f.length; u += 1){
                                var h = f[u];
                                this.addLine(h, t1, o, s, l, c);
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, n);
                        }, qs.prototype.addLine = function(t1, e1, r, n, i, a) {
                            if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, e1.properties && e1.properties.hasOwnProperty("mapbox_clip_start") && e1.properties.hasOwnProperty("mapbox_clip_end")) {
                                this.clipStart = +e1.properties.mapbox_clip_start, this.clipEnd = +e1.properties.mapbox_clip_end;
                                for(var o = 0; o < t1.length - 1; o++)this.totalDistance += t1[o].dist(t1[o + 1]);
                                this.updateScaledDistance();
                            }
                            for(var s = "Polygon" === Us[e1.type], l = t1.length; l >= 2 && t1[l - 1].equals(t1[l - 2]);)l--;
                            for(var c = 0; c < l - 1 && t1[c].equals(t1[c + 1]);)c++;
                            if (!(l < (s ? 3 : 2))) {
                                "bevel" === r && (i = 1.05);
                                var u, f = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, h = this.segments.prepareSegment(10 * l, this.layoutVertexArray, this.indexArray), p = void 0, d = void 0, m = void 0, g = void 0;
                                this.e1 = this.e2 = -1, s && (u = t1[l - 2], g = t1[c].sub(u)._unit()._perp());
                                for(var v = c; v < l; v++)if (!(d = v === l - 1 ? s ? t1[c + 1] : void 0 : t1[v + 1]) || !t1[v].equals(d)) {
                                    g && (m = g), u && (p = u), u = t1[v], g = d ? d.sub(u)._unit()._perp() : m;
                                    var y = (m = m || g).add(g);
                                    0 === y.x && 0 === y.y || y._unit();
                                    var x = m.x * g.x + m.y * g.y, b = y.x * g.x + y.y * g.y, _ = 0 !== b ? 1 / b : 1 / 0, w = 2 * Math.sqrt(2 - 2 * b), T = b < Vs && p && d, k = m.x * g.y - m.y * g.x > 0;
                                    if (T && v > c) {
                                        var A = u.dist(p);
                                        if (A > 2 * f) {
                                            var M = u.sub(u.sub(p)._mult(f / A)._round());
                                            this.updateDistance(p, M), this.addCurrentVertex(M, m, 0, 0, h), p = M;
                                        }
                                    }
                                    var S = p && d, E = S ? r : s ? "butt" : n;
                                    if (S && "round" === E && (_ < a ? E = "miter" : _ <= 2 && (E = "fakeround")), "miter" === E && _ > i && (E = "bevel"), "bevel" === E && (_ > 2 && (E = "flipbevel"), _ < i && (E = "miter")), p && this.updateDistance(p, u), "miter" === E) y._mult(_), this.addCurrentVertex(u, y, 0, 0, h);
                                    else if ("flipbevel" === E) {
                                        if (_ > 100) y = g.mult(-1);
                                        else {
                                            var L = _ * m.add(g).mag() / m.sub(g).mag();
                                            y._perp()._mult(L * (k ? -1 : 1));
                                        }
                                        this.addCurrentVertex(u, y, 0, 0, h), this.addCurrentVertex(u, y.mult(-1), 0, 0, h);
                                    } else if ("bevel" === E || "fakeround" === E) {
                                        var C = -Math.sqrt(_ * _ - 1), P = k ? C : 0, I = k ? 0 : C;
                                        if (p && this.addCurrentVertex(u, m, P, I, h), "fakeround" === E) for(var O = Math.round(180 * w / Math.PI / 20), z = 1; z < O; z++){
                                            var D = z / O;
                                            if (.5 !== D) {
                                                var R = D - .5;
                                                D += D * R * (D - 1) * ((1.0904 + x * (x * (3.55645 - 1.43519 * x) - 3.2452)) * R * R + (.848013 + x * (.215638 * x - 1.06021)));
                                            }
                                            var F = g.sub(m)._mult(D)._add(m)._unit()._mult(k ? -1 : 1);
                                            this.addHalfVertex(u, F.x, F.y, !1, k, 0, h);
                                        }
                                        d && this.addCurrentVertex(u, g, -P, -I, h);
                                    } else if ("butt" === E) this.addCurrentVertex(u, y, 0, 0, h);
                                    else if ("square" === E) {
                                        var B = p ? 1 : -1;
                                        this.addCurrentVertex(u, y, B, B, h);
                                    } else "round" === E && (p && (this.addCurrentVertex(u, m, 0, 0, h), this.addCurrentVertex(u, m, 1, 1, h, !0)), d && (this.addCurrentVertex(u, g, -1, -1, h, !0), this.addCurrentVertex(u, g, 0, 0, h)));
                                    if (T && v < l - 1) {
                                        var N = u.dist(d);
                                        if (N > 2 * f) {
                                            var j = u.add(d.sub(u)._mult(f / N)._round());
                                            this.updateDistance(u, j), this.addCurrentVertex(j, g, 0, 0, h), u = j;
                                        }
                                    }
                                }
                            }
                        }, qs.prototype.addCurrentVertex = function(t1, e1, r, n, i, a) {
                            void 0 === a && (a = !1);
                            var o = e1.x + e1.y * r, s = e1.y - e1.x * r, l = -e1.x + e1.y * n, c = -e1.y - e1.x * n;
                            this.addHalfVertex(t1, o, s, a, !1, r, i), this.addHalfVertex(t1, l, c, a, !0, -n, i), this.distance > Hs / 2 && 0 === this.totalDistance && (this.distance = 0, this.addCurrentVertex(t1, e1, r, n, i, a));
                        }, qs.prototype.addHalfVertex = function(t1, e1, r, n, i, a, o) {
                            var s = t1.x, l = t1.y, c = .5 * this.scaledDistance;
                            this.layoutVertexArray.emplaceBack((s << 1) + (n ? 1 : 0), (l << 1) + (i ? 1 : 0), Math.round(63 * e1) + 128, Math.round(63 * r) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1) | (63 & c) << 2, c >> 6);
                            var u = o.vertexLength++;
                            this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), i ? this.e2 = u : this.e1 = u;
                        }, qs.prototype.updateScaledDistance = function() {
                            this.scaledDistance = this.totalDistance > 0 ? (this.clipStart + (this.clipEnd - this.clipStart) * this.distance / this.totalDistance) * (Hs - 1) : this.distance;
                        }, qs.prototype.updateDistance = function(t1, e1) {
                            this.distance += t1.dist(e1), this.updateScaledDistance();
                        }, Nn("LineBucket", qs, {
                            omit: [
                                "layers",
                                "patternFeatures"
                            ]
                        });
                        var Gs = new Si({
                            "line-cap": new wi(Lt.layout_line["line-cap"]),
                            "line-join": new Ti(Lt.layout_line["line-join"]),
                            "line-miter-limit": new wi(Lt.layout_line["line-miter-limit"]),
                            "line-round-limit": new wi(Lt.layout_line["line-round-limit"]),
                            "line-sort-key": new Ti(Lt.layout_line["line-sort-key"])
                        }), Ys = {
                            paint: new Si({
                                "line-opacity": new Ti(Lt.paint_line["line-opacity"]),
                                "line-color": new Ti(Lt.paint_line["line-color"]),
                                "line-translate": new wi(Lt.paint_line["line-translate"]),
                                "line-translate-anchor": new wi(Lt.paint_line["line-translate-anchor"]),
                                "line-width": new Ti(Lt.paint_line["line-width"]),
                                "line-gap-width": new Ti(Lt.paint_line["line-gap-width"]),
                                "line-offset": new Ti(Lt.paint_line["line-offset"]),
                                "line-blur": new Ti(Lt.paint_line["line-blur"]),
                                "line-dasharray": new Ai(Lt.paint_line["line-dasharray"]),
                                "line-pattern": new ki(Lt.paint_line["line-pattern"]),
                                "line-gradient": new Mi(Lt.paint_line["line-gradient"])
                            }),
                            layout: Gs
                        }, Ws = new (function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.possiblyEvaluate = function(e1, r) {
                                return r = new pi(Math.floor(r.zoom), {
                                    now: r.now,
                                    fadeDuration: r.fadeDuration,
                                    zoomHistory: r.zoomHistory,
                                    transition: r.transition
                                }), t1.prototype.possiblyEvaluate.call(this, e1, r);
                            }, e1.prototype.evaluate = function(e1, r, n, i) {
                                return r = u({}, r, {
                                    zoom: Math.floor(r.zoom)
                                }), t1.prototype.evaluate.call(this, e1, r, n, i);
                            }, e1;
                        }(Ti))(Ys.paint.properties["line-width"].specification);
                        Ws.useIntegerZoom = !0;
                        var Xs = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, Ys);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._handleSpecialPaintPropertyUpdate = function(t1) {
                                "line-gradient" === t1 && this._updateGradient();
                            }, e1.prototype._updateGradient = function() {
                                var t1 = this._transitionablePaint._values["line-gradient"].value.expression;
                                this.gradient = Co(t1, "lineProgress"), this.gradientTexture = null;
                            }, e1.prototype.recalculate = function(e1, r) {
                                t1.prototype.recalculate.call(this, e1, r), this.paint._values["line-floorwidth"] = Ws.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, e1);
                            }, e1.prototype.createBucket = function(t1) {
                                return new qs(t1);
                            }, e1.prototype.queryRadius = function(t1) {
                                var e1 = t1, r = Zs(oo("line-width", this, e1), oo("line-gap-width", this, e1)), n = oo("line-offset", this, e1);
                                return r / 2 + Math.abs(n) + so(this.paint.get("line-translate"));
                            }, e1.prototype.queryIntersectsFeature = function(t1, e1, r, n, a, o, s) {
                                var l = lo(t1, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), o.angle, s), c = s / 2 * Zs(this.paint.get("line-width").evaluate(e1, r), this.paint.get("line-gap-width").evaluate(e1, r)), u = this.paint.get("line-offset").evaluate(e1, r);
                                return u && (n = function(t1, e1) {
                                    for(var r = [], n = new i(0, 0), a = 0; a < t1.length; a++){
                                        for(var o = t1[a], s = [], l = 0; l < o.length; l++){
                                            var c = o[l - 1], u = o[l], f = o[l + 1], h = 0 === l ? n : u.sub(c)._unit()._perp(), p = l === o.length - 1 ? n : f.sub(u)._unit()._perp(), d = h._add(p)._unit(), m = d.x * p.x + d.y * p.y;
                                            d._mult(1 / m), s.push(d._mult(e1)._add(u));
                                        }
                                        r.push(s);
                                    }
                                    return r;
                                }(n, u * s)), function(t1, e1, r) {
                                    for(var n = 0; n < e1.length; n++){
                                        var i = e1[n];
                                        if (t1.length >= 3) {
                                            for(var a = 0; a < i.length; a++)if (io(t1, i[a])) return !0;
                                        }
                                        if (Qa(t1, i, r)) return !0;
                                    }
                                    return !1;
                                }(l, n, c);
                            }, e1.prototype.isTileClipped = function() {
                                return !0;
                            }, e1;
                        }(Ei);
                        function Zs(t1, e1) {
                            return e1 > 0 ? e1 + 2 * t1 : t1;
                        }
                        var Js = Ii([
                            {
                                name: "a_pos_offset",
                                components: 4,
                                type: "Int16"
                            },
                            {
                                name: "a_data",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixeloffset",
                                components: 4,
                                type: "Int16"
                            }
                        ], 4), Ks = Ii([
                            {
                                name: "a_projected_pos",
                                components: 3,
                                type: "Float32"
                            }
                        ], 4), Qs = (Ii([
                            {
                                name: "a_fade_opacity",
                                components: 1,
                                type: "Uint32"
                            }
                        ], 4), Ii([
                            {
                                name: "a_placed",
                                components: 2,
                                type: "Uint8"
                            },
                            {
                                name: "a_shift",
                                components: 2,
                                type: "Float32"
                            }
                        ])), $s = (Ii([
                            {
                                type: "Int16",
                                name: "anchorPointX"
                            },
                            {
                                type: "Int16",
                                name: "anchorPointY"
                            },
                            {
                                type: "Int16",
                                name: "x1"
                            },
                            {
                                type: "Int16",
                                name: "y1"
                            },
                            {
                                type: "Int16",
                                name: "x2"
                            },
                            {
                                type: "Int16",
                                name: "y2"
                            },
                            {
                                type: "Uint32",
                                name: "featureIndex"
                            },
                            {
                                type: "Uint16",
                                name: "sourceLayerIndex"
                            },
                            {
                                type: "Uint16",
                                name: "bucketIndex"
                            }
                        ]), Ii([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_anchor_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_extrude",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4)), tl = Ii([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Float32"
                            },
                            {
                                name: "a_radius",
                                components: 1,
                                type: "Float32"
                            },
                            {
                                name: "a_flags",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4);
                        Ii([
                            {
                                name: "triangle",
                                components: 3,
                                type: "Uint16"
                            }
                        ]), Ii([
                            {
                                type: "Int16",
                                name: "anchorX"
                            },
                            {
                                type: "Int16",
                                name: "anchorY"
                            },
                            {
                                type: "Uint16",
                                name: "glyphStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "numGlyphs"
                            },
                            {
                                type: "Uint32",
                                name: "vertexStartIndex"
                            },
                            {
                                type: "Uint32",
                                name: "lineStartIndex"
                            },
                            {
                                type: "Uint32",
                                name: "lineLength"
                            },
                            {
                                type: "Uint16",
                                name: "segment"
                            },
                            {
                                type: "Uint16",
                                name: "lowerSize"
                            },
                            {
                                type: "Uint16",
                                name: "upperSize"
                            },
                            {
                                type: "Float32",
                                name: "lineOffsetX"
                            },
                            {
                                type: "Float32",
                                name: "lineOffsetY"
                            },
                            {
                                type: "Uint8",
                                name: "writingMode"
                            },
                            {
                                type: "Uint8",
                                name: "placedOrientation"
                            },
                            {
                                type: "Uint8",
                                name: "hidden"
                            },
                            {
                                type: "Uint32",
                                name: "crossTileID"
                            },
                            {
                                type: "Int16",
                                name: "associatedIconIndex"
                            }
                        ]), Ii([
                            {
                                type: "Int16",
                                name: "anchorX"
                            },
                            {
                                type: "Int16",
                                name: "anchorY"
                            },
                            {
                                type: "Int16",
                                name: "rightJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "centerJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "leftJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "verticalPlacedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "placedIconSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "verticalPlacedIconSymbolIndex"
                            },
                            {
                                type: "Uint16",
                                name: "key"
                            },
                            {
                                type: "Uint16",
                                name: "textBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "textBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalTextBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalTextBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "iconBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "iconBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalIconBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalIconBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "featureIndex"
                            },
                            {
                                type: "Uint16",
                                name: "numHorizontalGlyphVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numVerticalGlyphVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numIconVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numVerticalIconVertices"
                            },
                            {
                                type: "Uint16",
                                name: "useRuntimeCollisionCircles"
                            },
                            {
                                type: "Uint32",
                                name: "crossTileID"
                            },
                            {
                                type: "Float32",
                                name: "textBoxScale"
                            },
                            {
                                type: "Float32",
                                components: 2,
                                name: "textOffset"
                            },
                            {
                                type: "Float32",
                                name: "collisionCircleDiameter"
                            }
                        ]), Ii([
                            {
                                type: "Float32",
                                name: "offsetX"
                            }
                        ]), Ii([
                            {
                                type: "Int16",
                                name: "x"
                            },
                            {
                                type: "Int16",
                                name: "y"
                            },
                            {
                                type: "Int16",
                                name: "tileUnitDistanceFromAnchor"
                            }
                        ]);
                        function el(t1, e1, r) {
                            return t1.sections.forEach(function(t1) {
                                t1.text = function(t1, e1, r) {
                                    var n = e1.layout.get("text-transform").evaluate(r, {});
                                    return "uppercase" === n ? t1 = t1.toLocaleUpperCase() : "lowercase" === n && (t1 = t1.toLocaleLowerCase()), hi.applyArabicShaping && (t1 = hi.applyArabicShaping(t1)), t1;
                                }(t1.text, e1, r);
                            }), t1;
                        }
                        var rl = {
                            "!": "\ufe15",
                            "#": "\uff03",
                            $: "\uff04",
                            "%": "\uff05",
                            "&": "\uff06",
                            "(": "\ufe35",
                            ")": "\ufe36",
                            "*": "\uff0a",
                            "+": "\uff0b",
                            ",": "\ufe10",
                            "-": "\ufe32",
                            ".": "\u30fb",
                            "/": "\uff0f",
                            ":": "\ufe13",
                            ";": "\ufe14",
                            "<": "\ufe3f",
                            "=": "\uff1d",
                            ">": "\ufe40",
                            "?": "\ufe16",
                            "@": "\uff20",
                            "[": "\ufe47",
                            "\\": "\uff3c",
                            "]": "\ufe48",
                            "^": "\uff3e",
                            _: "\ufe33",
                            "`": "\uff40",
                            "{": "\ufe37",
                            "|": "\u2015",
                            "}": "\ufe38",
                            "~": "\uff5e",
                            "\xa2": "\uffe0",
                            "\xa3": "\uffe1",
                            "\xa5": "\uffe5",
                            "\xa6": "\uffe4",
                            "\xac": "\uffe2",
                            "\xaf": "\uffe3",
                            "\u2013": "\ufe32",
                            "\u2014": "\ufe31",
                            "\u2018": "\ufe43",
                            "\u2019": "\ufe44",
                            "\u201c": "\ufe41",
                            "\u201d": "\ufe42",
                            "\u2026": "\ufe19",
                            "\u2027": "\u30fb",
                            "\u20a9": "\uffe6",
                            "\u3001": "\ufe11",
                            "\u3002": "\ufe12",
                            "\u3008": "\ufe3f",
                            "\u3009": "\ufe40",
                            "\u300a": "\ufe3d",
                            "\u300b": "\ufe3e",
                            "\u300c": "\ufe41",
                            "\u300d": "\ufe42",
                            "\u300e": "\ufe43",
                            "\u300f": "\ufe44",
                            "\u3010": "\ufe3b",
                            "\u3011": "\ufe3c",
                            "\u3014": "\ufe39",
                            "\u3015": "\ufe3a",
                            "\u3016": "\ufe17",
                            "\u3017": "\ufe18",
                            "\uff01": "\ufe15",
                            "\uff08": "\ufe35",
                            "\uff09": "\ufe36",
                            "\uff0c": "\ufe10",
                            "\uff0d": "\ufe32",
                            "\uff0e": "\u30fb",
                            "\uff1a": "\ufe13",
                            "\uff1b": "\ufe14",
                            "\uff1c": "\ufe3f",
                            "\uff1e": "\ufe40",
                            "\uff1f": "\ufe16",
                            "\uff3b": "\ufe47",
                            "\uff3d": "\ufe48",
                            "\uff3f": "\ufe33",
                            "\uff5b": "\ufe37",
                            "\uff5c": "\u2015",
                            "\uff5d": "\ufe38",
                            "\uff5f": "\ufe35",
                            "\uff60": "\ufe36",
                            "\uff61": "\ufe12",
                            "\uff62": "\ufe41",
                            "\uff63": "\ufe42"
                        };
                        var nl = function(t1, e1, r, n, i) {
                            var a, o, s = 8 * i - n - 1, l = (1 << s) - 1, c = l >> 1, u = -7, f = r ? i - 1 : 0, h = r ? -1 : 1, p = t1[e1 + f];
                            for(f += h, a = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; a = 256 * a + t1[e1 + f], f += h, u -= 8);
                            for(o = a & (1 << -u) - 1, a >>= -u, u += n; u > 0; o = 256 * o + t1[e1 + f], f += h, u -= 8);
                            if (0 === a) a = 1 - c;
                            else {
                                if (a === l) return o ? NaN : 1 / 0 * (p ? -1 : 1);
                                o += Math.pow(2, n), a -= c;
                            }
                            return (p ? -1 : 1) * o * Math.pow(2, a - n);
                        }, il = function(t1, e1, r, n, i, a) {
                            var o, s, l, c = 8 * a - i - 1, u = (1 << c) - 1, f = u >> 1, h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = n ? 0 : a - 1, d = n ? 1 : -1, m = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
                            for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (s = isNaN(e1) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e1) / Math.LN2), e1 * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (e1 += o + f >= 1 ? h / l : h * Math.pow(2, 1 - f)) * l >= 2 && (o++, l /= 2), o + f >= u ? (s = 0, o = u) : o + f >= 1 ? (s = (e1 * l - 1) * Math.pow(2, i), o += f) : (s = e1 * Math.pow(2, f - 1) * Math.pow(2, i), o = 0)); i >= 8; t1[r + p] = 255 & s, p += d, s /= 256, i -= 8);
                            for(o = o << i | s, c += i; c > 0; t1[r + p] = 255 & o, p += d, o /= 256, c -= 8);
                            t1[r + p - d] |= 128 * m;
                        }, al = ol;
                        function ol(t1) {
                            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t1) ? t1 : new Uint8Array(t1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
                        }
                        ol.Varint = 0, ol.Fixed64 = 1, ol.Bytes = 2, ol.Fixed32 = 5;
                        var sl = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
                        function ll(t1) {
                            return t1.type === ol.Bytes ? t1.readVarint() + t1.pos : t1.pos + 1;
                        }
                        function cl(t1, e1, r) {
                            return r ? 4294967296 * e1 + (t1 >>> 0) : 4294967296 * (e1 >>> 0) + (t1 >>> 0);
                        }
                        function ul(t1, e1, r) {
                            var n = e1 <= 16383 ? 1 : e1 <= 2097151 ? 2 : e1 <= 268435455 ? 3 : Math.floor(Math.log(e1) / (7 * Math.LN2));
                            r.realloc(n);
                            for(var i = r.pos - 1; i >= t1; i--)r.buf[i + n] = r.buf[i];
                        }
                        function fl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeVarint(t1[r]);
                        }
                        function hl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeSVarint(t1[r]);
                        }
                        function pl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeFloat(t1[r]);
                        }
                        function dl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeDouble(t1[r]);
                        }
                        function ml(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeBoolean(t1[r]);
                        }
                        function gl1(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeFixed32(t1[r]);
                        }
                        function vl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeSFixed32(t1[r]);
                        }
                        function yl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeFixed64(t1[r]);
                        }
                        function xl(t1, e1) {
                            for(var r = 0; r < t1.length; r++)e1.writeSFixed64(t1[r]);
                        }
                        function bl(t1, e1) {
                            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + 16777216 * t1[e1 + 3];
                        }
                        function _l(t1, e1, r) {
                            t1[r] = e1, t1[r + 1] = e1 >>> 8, t1[r + 2] = e1 >>> 16, t1[r + 3] = e1 >>> 24;
                        }
                        function wl(t1, e1) {
                            return (t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16) + (t1[e1 + 3] << 24);
                        }
                        ol.prototype = {
                            destroy: function() {
                                this.buf = null;
                            },
                            readFields: function(t1, e1, r) {
                                for(r = r || this.length; this.pos < r;){
                                    var n = this.readVarint(), i = n >> 3, a = this.pos;
                                    this.type = 7 & n, t1(i, e1, this), this.pos === a && this.skip(n);
                                }
                                return e1;
                            },
                            readMessage: function(t1, e1) {
                                return this.readFields(t1, e1, this.readVarint() + this.pos);
                            },
                            readFixed32: function() {
                                var t1 = bl(this.buf, this.pos);
                                return this.pos += 4, t1;
                            },
                            readSFixed32: function() {
                                var t1 = wl(this.buf, this.pos);
                                return this.pos += 4, t1;
                            },
                            readFixed64: function() {
                                var t1 = bl(this.buf, this.pos) + 4294967296 * bl(this.buf, this.pos + 4);
                                return this.pos += 8, t1;
                            },
                            readSFixed64: function() {
                                var t1 = bl(this.buf, this.pos) + 4294967296 * wl(this.buf, this.pos + 4);
                                return this.pos += 8, t1;
                            },
                            readFloat: function() {
                                var t1 = nl(this.buf, this.pos, !0, 23, 4);
                                return this.pos += 4, t1;
                            },
                            readDouble: function() {
                                var t1 = nl(this.buf, this.pos, !0, 52, 8);
                                return this.pos += 8, t1;
                            },
                            readVarint: function(t1) {
                                var e1, r, n = this.buf;
                                return e1 = 127 & (r = n[this.pos++]), r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e1 : (e1 |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e1 : function(t1, e1, r) {
                                    var n, i, a = r.buf;
                                    if (i = a[r.pos++], n = (112 & i) >> 4, i < 128) return cl(t1, n, e1);
                                    if (i = a[r.pos++], n |= (127 & i) << 3, i < 128) return cl(t1, n, e1);
                                    if (i = a[r.pos++], n |= (127 & i) << 10, i < 128) return cl(t1, n, e1);
                                    if (i = a[r.pos++], n |= (127 & i) << 17, i < 128) return cl(t1, n, e1);
                                    if (i = a[r.pos++], n |= (127 & i) << 24, i < 128) return cl(t1, n, e1);
                                    if (i = a[r.pos++], n |= (1 & i) << 31, i < 128) return cl(t1, n, e1);
                                    throw new Error("Expected varint not more than 10 bytes");
                                }(e1 |= (15 & (r = n[this.pos])) << 28, t1, this))));
                            },
                            readVarint64: function() {
                                return this.readVarint(!0);
                            },
                            readSVarint: function() {
                                var t1 = this.readVarint();
                                return t1 % 2 == 1 ? (t1 + 1) / -2 : t1 / 2;
                            },
                            readBoolean: function() {
                                return Boolean(this.readVarint());
                            },
                            readString: function() {
                                var t1 = this.readVarint() + this.pos, e1 = this.pos;
                                return this.pos = t1, t1 - e1 >= 12 && sl ? function(t1, e1, r) {
                                    return sl.decode(t1.subarray(e1, r));
                                }(this.buf, e1, t1) : function(t1, e1, r) {
                                    var n = "", i = e1;
                                    for(; i < r;){
                                        var a, o, s, l = t1[i], c = null, u = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                                        if (i + u > r) break;
                                        1 === u ? l < 128 && (c = l) : 2 === u ? 128 == (192 & (a = t1[i + 1])) && (c = (31 & l) << 6 | 63 & a) <= 127 && (c = null) : 3 === u ? (a = t1[i + 1], o = t1[i + 2], 128 == (192 & a) && 128 == (192 & o) && ((c = (15 & l) << 12 | (63 & a) << 6 | 63 & o) <= 2047 || c >= 55296 && c <= 57343) && (c = null)) : 4 === u && (a = t1[i + 1], o = t1[i + 2], s = t1[i + 3], 128 == (192 & a) && 128 == (192 & o) && 128 == (192 & s) && ((c = (15 & l) << 18 | (63 & a) << 12 | (63 & o) << 6 | 63 & s) <= 65535 || c >= 1114112) && (c = null)), null === c ? (c = 65533, u = 1) : c > 65535 && (c -= 65536, n += String.fromCharCode(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n += String.fromCharCode(c), i += u;
                                    }
                                    return n;
                                }(this.buf, e1, t1);
                            },
                            readBytes: function() {
                                var t1 = this.readVarint() + this.pos, e1 = this.buf.subarray(this.pos, t1);
                                return this.pos = t1, e1;
                            },
                            readPackedVarint: function(t1, e1) {
                                if (this.type !== ol.Bytes) return t1.push(this.readVarint(e1));
                                var r = ll(this);
                                for(t1 = t1 || []; this.pos < r;)t1.push(this.readVarint(e1));
                                return t1;
                            },
                            readPackedSVarint: function(t1) {
                                if (this.type !== ol.Bytes) return t1.push(this.readSVarint());
                                var e1 = ll(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSVarint());
                                return t1;
                            },
                            readPackedBoolean: function(t1) {
                                if (this.type !== ol.Bytes) return t1.push(this.readBoolean());
                                var e1 = ll(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readBoolean());
                                return t1;
                            },
                            readPackedFloat: function(t1) {
                                if (this.type !== ol.Bytes) return t1.push(this.readFloat());
                                var e1 = ll(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFloat());
                                return t1;
                            },
                            readPackedDouble: function(t1) {
                                if (this.type !== ol.Bytes) return t1.push(this.readDouble());
                                var e1 = ll(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readDouble());
                                return t1;
                            },
                            readPackedFixed32: function(t1) {
                                if (this.type !== ol.Bytes) return t1.push(this.readFixed32());
                                var e1 = ll(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed32());
                                return t1;
                            },
                            readPackedSFixed32: function(t1) {
                                if (this.type !== ol.Bytes) return t1.push(this.readSFixed32());
                                var e1 = ll(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed32());
                                return t1;
                            },
                            readPackedFixed64: function(t1) {
                                if (this.type !== ol.Bytes) return t1.push(this.readFixed64());
                                var e1 = ll(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readFixed64());
                                return t1;
                            },
                            readPackedSFixed64: function(t1) {
                                if (this.type !== ol.Bytes) return t1.push(this.readSFixed64());
                                var e1 = ll(this);
                                for(t1 = t1 || []; this.pos < e1;)t1.push(this.readSFixed64());
                                return t1;
                            },
                            skip: function(t1) {
                                var e1 = 7 & t1;
                                if (e1 === ol.Varint) for(; this.buf[this.pos++] > 127;);
                                else if (e1 === ol.Bytes) this.pos = this.readVarint() + this.pos;
                                else if (e1 === ol.Fixed32) this.pos += 4;
                                else {
                                    if (e1 !== ol.Fixed64) throw new Error("Unimplemented type: " + e1);
                                    this.pos += 8;
                                }
                            },
                            writeTag: function(t1, e1) {
                                this.writeVarint(t1 << 3 | e1);
                            },
                            realloc: function(t1) {
                                for(var e1 = this.length || 16; e1 < this.pos + t1;)e1 *= 2;
                                if (e1 !== this.length) {
                                    var r = new Uint8Array(e1);
                                    r.set(this.buf), this.buf = r, this.length = e1;
                                }
                            },
                            finish: function() {
                                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                            },
                            writeFixed32: function(t1) {
                                this.realloc(4), _l(this.buf, t1, this.pos), this.pos += 4;
                            },
                            writeSFixed32: function(t1) {
                                this.realloc(4), _l(this.buf, t1, this.pos), this.pos += 4;
                            },
                            writeFixed64: function(t1) {
                                this.realloc(8), _l(this.buf, -1 & t1, this.pos), _l(this.buf, Math.floor(t1 * (1 / 4294967296)), this.pos + 4), this.pos += 8;
                            },
                            writeSFixed64: function(t1) {
                                this.realloc(8), _l(this.buf, -1 & t1, this.pos), _l(this.buf, Math.floor(t1 * (1 / 4294967296)), this.pos + 4), this.pos += 8;
                            },
                            writeVarint: function(t1) {
                                (t1 = +t1 || 0) > 268435455 || t1 < 0 ? function(t1, e1) {
                                    var r, n;
                                    t1 >= 0 ? (r = t1 % 4294967296 | 0, n = t1 / 4294967296 | 0) : (n = ~(-t1 / 4294967296), 4294967295 ^ (r = ~(-t1 % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0));
                                    if (t1 >= 0x10000000000000000 || t1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                                    e1.realloc(10), function(t1, e1, r) {
                                        r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos] = 127 & t1;
                                    }(r, 0, e1), function(t1, e1) {
                                        var r = (7 & t1) << 4;
                                        if (e1.buf[e1.pos++] |= r | ((t1 >>>= 3) ? 128 : 0), !t1) return;
                                        if (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), !t1) return;
                                        if (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), !t1) return;
                                        if (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), !t1) return;
                                        if (e1.buf[e1.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), !t1) return;
                                        e1.buf[e1.pos++] = 127 & t1;
                                    }(n, e1);
                                }(t1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t1 | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = t1 >>> 7 & 127))));
                            },
                            writeSVarint: function(t1) {
                                this.writeVarint(t1 < 0 ? 2 * -t1 - 1 : 2 * t1);
                            },
                            writeBoolean: function(t1) {
                                this.writeVarint(Boolean(t1));
                            },
                            writeString: function(t1) {
                                t1 = String(t1), this.realloc(4 * t1.length), this.pos++;
                                var e1 = this.pos;
                                this.pos = function(t1, e1, r) {
                                    for(var n, i, a = 0; a < e1.length; a++){
                                        if ((n = e1.charCodeAt(a)) > 55295 && n < 57344) {
                                            if (!i) {
                                                n > 56319 || a + 1 === e1.length ? (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189) : i = n;
                                                continue;
                                            }
                                            if (n < 56320) {
                                                t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = n;
                                                continue;
                                            }
                                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                                        } else i && (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = null);
                                        n < 128 ? t1[r++] = n : (n < 2048 ? t1[r++] = n >> 6 | 192 : (n < 65536 ? t1[r++] = n >> 12 | 224 : (t1[r++] = n >> 18 | 240, t1[r++] = n >> 12 & 63 | 128), t1[r++] = n >> 6 & 63 | 128), t1[r++] = 63 & n | 128);
                                    }
                                    return r;
                                }(this.buf, t1, this.pos);
                                var r = this.pos - e1;
                                r >= 128 && ul(e1, r, this), this.pos = e1 - 1, this.writeVarint(r), this.pos += r;
                            },
                            writeFloat: function(t1) {
                                this.realloc(4), il(this.buf, t1, this.pos, !0, 23, 4), this.pos += 4;
                            },
                            writeDouble: function(t1) {
                                this.realloc(8), il(this.buf, t1, this.pos, !0, 52, 8), this.pos += 8;
                            },
                            writeBytes: function(t1) {
                                var e1 = t1.length;
                                this.writeVarint(e1), this.realloc(e1);
                                for(var r = 0; r < e1; r++)this.buf[this.pos++] = t1[r];
                            },
                            writeRawMessage: function(t1, e1) {
                                this.pos++;
                                var r = this.pos;
                                t1(e1, this);
                                var n = this.pos - r;
                                n >= 128 && ul(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
                            },
                            writeMessage: function(t1, e1, r) {
                                this.writeTag(t1, ol.Bytes), this.writeRawMessage(e1, r);
                            },
                            writePackedVarint: function(t1, e1) {
                                e1.length && this.writeMessage(t1, fl, e1);
                            },
                            writePackedSVarint: function(t1, e1) {
                                e1.length && this.writeMessage(t1, hl, e1);
                            },
                            writePackedBoolean: function(t1, e1) {
                                e1.length && this.writeMessage(t1, ml, e1);
                            },
                            writePackedFloat: function(t1, e1) {
                                e1.length && this.writeMessage(t1, pl, e1);
                            },
                            writePackedDouble: function(t1, e1) {
                                e1.length && this.writeMessage(t1, dl, e1);
                            },
                            writePackedFixed32: function(t1, e1) {
                                e1.length && this.writeMessage(t1, gl1, e1);
                            },
                            writePackedSFixed32: function(t1, e1) {
                                e1.length && this.writeMessage(t1, vl, e1);
                            },
                            writePackedFixed64: function(t1, e1) {
                                e1.length && this.writeMessage(t1, yl, e1);
                            },
                            writePackedSFixed64: function(t1, e1) {
                                e1.length && this.writeMessage(t1, xl, e1);
                            },
                            writeBytesField: function(t1, e1) {
                                this.writeTag(t1, ol.Bytes), this.writeBytes(e1);
                            },
                            writeFixed32Field: function(t1, e1) {
                                this.writeTag(t1, ol.Fixed32), this.writeFixed32(e1);
                            },
                            writeSFixed32Field: function(t1, e1) {
                                this.writeTag(t1, ol.Fixed32), this.writeSFixed32(e1);
                            },
                            writeFixed64Field: function(t1, e1) {
                                this.writeTag(t1, ol.Fixed64), this.writeFixed64(e1);
                            },
                            writeSFixed64Field: function(t1, e1) {
                                this.writeTag(t1, ol.Fixed64), this.writeSFixed64(e1);
                            },
                            writeVarintField: function(t1, e1) {
                                this.writeTag(t1, ol.Varint), this.writeVarint(e1);
                            },
                            writeSVarintField: function(t1, e1) {
                                this.writeTag(t1, ol.Varint), this.writeSVarint(e1);
                            },
                            writeStringField: function(t1, e1) {
                                this.writeTag(t1, ol.Bytes), this.writeString(e1);
                            },
                            writeFloatField: function(t1, e1) {
                                this.writeTag(t1, ol.Fixed32), this.writeFloat(e1);
                            },
                            writeDoubleField: function(t1, e1) {
                                this.writeTag(t1, ol.Fixed64), this.writeDouble(e1);
                            },
                            writeBooleanField: function(t1, e1) {
                                this.writeVarintField(t1, Boolean(e1));
                            }
                        };
                        function Tl(t1, e1, r) {
                            1 === t1 && r.readMessage(kl, e1);
                        }
                        function kl(t1, e1, r) {
                            if (3 === t1) {
                                var n = r.readMessage(Al, {}), i = n.id, a = n.bitmap, o = n.width, s = n.height, l = n.left, c = n.top, u = n.advance;
                                e1.push({
                                    id: i,
                                    bitmap: new So({
                                        width: o + 6,
                                        height: s + 6
                                    }, a),
                                    metrics: {
                                        width: o,
                                        height: s,
                                        left: l,
                                        top: c,
                                        advance: u
                                    }
                                });
                            }
                        }
                        function Al(t1, e1, r) {
                            1 === t1 ? e1.id = r.readVarint() : 2 === t1 ? e1.bitmap = r.readBytes() : 3 === t1 ? e1.width = r.readVarint() : 4 === t1 ? e1.height = r.readVarint() : 5 === t1 ? e1.left = r.readSVarint() : 6 === t1 ? e1.top = r.readSVarint() : 7 === t1 && (e1.advance = r.readVarint());
                        }
                        function Ml(t1) {
                            for(var e1 = 0, r = 0, n = 0, i = t1; n < i.length; n += 1){
                                var a = i[n];
                                e1 += a.w * a.h, r = Math.max(r, a.w);
                            }
                            t1.sort(function(t1, e1) {
                                return e1.h - t1.h;
                            });
                            for(var o = [
                                {
                                    x: 0,
                                    y: 0,
                                    w: Math.max(Math.ceil(Math.sqrt(e1 / .95)), r),
                                    h: 1 / 0
                                }
                            ], s = 0, l = 0, c = 0, u = t1; c < u.length; c += 1)for(var f = u[c], h = o.length - 1; h >= 0; h--){
                                var p = o[h];
                                if (!(f.w > p.w || f.h > p.h)) {
                                    if (f.x = p.x, f.y = p.y, l = Math.max(l, f.y + f.h), s = Math.max(s, f.x + f.w), f.w === p.w && f.h === p.h) {
                                        var d = o.pop();
                                        h < o.length && (o[h] = d);
                                    } else f.h === p.h ? (p.x += f.w, p.w -= f.w) : f.w === p.w ? (p.y += f.h, p.h -= f.h) : (o.push({
                                        x: p.x + f.w,
                                        y: p.y,
                                        w: p.w - f.w,
                                        h: f.h
                                    }), p.y += f.h, p.h -= f.h);
                                    break;
                                }
                            }
                            return {
                                w: s,
                                h: l,
                                fill: e1 / (s * l) || 0
                            };
                        }
                        var Sl = function(t1, e1) {
                            var r = e1.pixelRatio, n = e1.version, i = e1.stretchX, a = e1.stretchY, o = e1.content;
                            this.paddedRect = t1, this.pixelRatio = r, this.stretchX = i, this.stretchY = a, this.content = o, this.version = n;
                        }, El = {
                            tl: {
                                configurable: !0
                            },
                            br: {
                                configurable: !0
                            },
                            tlbr: {
                                configurable: !0
                            },
                            displaySize: {
                                configurable: !0
                            }
                        };
                        El.tl.get = function() {
                            return [
                                this.paddedRect.x + 1,
                                this.paddedRect.y + 1
                            ];
                        }, El.br.get = function() {
                            return [
                                this.paddedRect.x + this.paddedRect.w - 1,
                                this.paddedRect.y + this.paddedRect.h - 1
                            ];
                        }, El.tlbr.get = function() {
                            return this.tl.concat(this.br);
                        }, El.displaySize.get = function() {
                            return [
                                (this.paddedRect.w - 2) / this.pixelRatio,
                                (this.paddedRect.h - 2) / this.pixelRatio
                            ];
                        }, Object.defineProperties(Sl.prototype, El);
                        var Ll = function(t1, e1) {
                            var r = {}, n = {};
                            this.haveRenderCallbacks = [];
                            var i = [];
                            this.addImages(t1, r, i), this.addImages(e1, n, i);
                            var a = Ml(i), o = a.w, s = a.h, l = new Eo({
                                width: o || 1,
                                height: s || 1
                            });
                            for(var c in t1){
                                var u = t1[c], f = r[c].paddedRect;
                                Eo.copy(u.data, l, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: f.x + 1,
                                    y: f.y + 1
                                }, u.data);
                            }
                            for(var h in e1){
                                var p = e1[h], d = n[h].paddedRect, m = d.x + 1, g = d.y + 1, v = p.data.width, y = p.data.height;
                                Eo.copy(p.data, l, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: m,
                                    y: g
                                }, p.data), Eo.copy(p.data, l, {
                                    x: 0,
                                    y: y - 1
                                }, {
                                    x: m,
                                    y: g - 1
                                }, {
                                    width: v,
                                    height: 1
                                }), Eo.copy(p.data, l, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: m,
                                    y: g + y
                                }, {
                                    width: v,
                                    height: 1
                                }), Eo.copy(p.data, l, {
                                    x: v - 1,
                                    y: 0
                                }, {
                                    x: m - 1,
                                    y: g
                                }, {
                                    width: 1,
                                    height: y
                                }), Eo.copy(p.data, l, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: m + v,
                                    y: g
                                }, {
                                    width: 1,
                                    height: y
                                });
                            }
                            this.image = l, this.iconPositions = r, this.patternPositions = n;
                        };
                        Ll.prototype.addImages = function(t1, e1, r) {
                            for(var n in t1){
                                var i = t1[n], a = {
                                    x: 0,
                                    y: 0,
                                    w: i.data.width + 2,
                                    h: i.data.height + 2
                                };
                                r.push(a), e1[n] = new Sl(a, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
                            }
                        }, Ll.prototype.patchUpdatedImages = function(t1, e1) {
                            for(var r in t1.dispatchRenderCallbacks(this.haveRenderCallbacks), t1.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t1.getImage(r), e1), this.patchUpdatedImage(this.patternPositions[r], t1.getImage(r), e1);
                        }, Ll.prototype.patchUpdatedImage = function(t1, e1, r) {
                            if (t1 && e1 && t1.version !== e1.version) {
                                t1.version = e1.version;
                                var n = t1.tl, i = n[0], a = n[1];
                                r.update(e1.data, void 0, {
                                    x: i,
                                    y: a
                                });
                            }
                        }, Nn("ImagePosition", Sl), Nn("ImageAtlas", Ll);
                        var Cl = {
                            horizontal: 1,
                            vertical: 2,
                            horizontalOnly: 3
                        };
                        var Pl = function() {
                            this.scale = 1, this.fontStack = "", this.imageName = null;
                        };
                        Pl.forText = function(t1, e1) {
                            var r = new Pl;
                            return r.scale = t1 || 1, r.fontStack = e1, r;
                        }, Pl.forImage = function(t1) {
                            var e1 = new Pl;
                            return e1.imageName = t1, e1;
                        };
                        var Il = function() {
                            this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
                        };
                        function Ol(t1, e1, r, n, i, a, o, s, l, c, u, f, h, p, d, m) {
                            var g, v = Il.fromFeature(t1, i);
                            f === Cl.vertical && v.verticalizePunctuation();
                            var y = hi.processBidirectionalText, x = hi.processStyledBidirectionalText;
                            if (y && 1 === v.sections.length) {
                                g = [];
                                for(var b = 0, _ = y(v.toString(), jl(v, c, a, e1, n, p, d)); b < _.length; b += 1){
                                    var w = _[b], T = new Il;
                                    T.text = w, T.sections = v.sections;
                                    for(var k = 0; k < w.length; k++)T.sectionIndex.push(0);
                                    g.push(T);
                                }
                            } else if (x) {
                                g = [];
                                for(var A = 0, M = x(v.text, v.sectionIndex, jl(v, c, a, e1, n, p, d)); A < M.length; A += 1){
                                    var S = M[A], E = new Il;
                                    E.text = S[0], E.sectionIndex = S[1], E.sections = v.sections, g.push(E);
                                }
                            } else g = function(t1, e1) {
                                for(var r = [], n = t1.text, i = 0, a = 0, o = e1; a < o.length; a += 1){
                                    var s = o[a];
                                    r.push(t1.substring(i, s)), i = s;
                                }
                                return i < n.length && r.push(t1.substring(i, n.length)), r;
                            }(v, jl(v, c, a, e1, n, p, d));
                            var L = [], C = {
                                positionedLines: L,
                                text: v.toString(),
                                top: u[1],
                                bottom: u[1],
                                left: u[0],
                                right: u[0],
                                writingMode: f,
                                iconsInText: !1,
                                verticalizable: !1
                            };
                            return function(t1, e1, r, n, i, a, o, s, l, c, u, f) {
                                for(var h = 0, p = -17, d = 0, m = 0, g = "right" === s ? 1 : "left" === s ? 0 : .5, v = 0, y = 0, x = i; y < x.length; y += 1){
                                    var b = x[y];
                                    b.trim();
                                    var _ = b.getMaxScale(), w = 24 * (_ - 1), T = {
                                        positionedGlyphs: [],
                                        lineOffset: 0
                                    };
                                    t1.positionedLines[v] = T;
                                    var k = T.positionedGlyphs, A = 0;
                                    if (b.length()) {
                                        for(var M = 0; M < b.length(); M++){
                                            var S = b.getSection(M), E = b.getSectionIndex(M), L = b.getCharCode(M), C = 0, P = null, I = null, O = null, z = 24, D = !(l === Cl.horizontal || !u && !Zn(L) || u && (zl[L] || (Y = L, Yn.Arabic(Y) || Yn["Arabic Supplement"](Y) || Yn["Arabic Extended-A"](Y) || Yn["Arabic Presentation Forms-A"](Y) || Yn["Arabic Presentation Forms-B"](Y))));
                                            if (S.imageName) {
                                                var R = n[S.imageName];
                                                if (!R) continue;
                                                O = S.imageName, t1.iconsInText = t1.iconsInText || !0, I = R.paddedRect;
                                                var F = R.displaySize;
                                                S.scale = 24 * S.scale / f, P = {
                                                    width: F[0],
                                                    height: F[1],
                                                    left: 1,
                                                    top: -3,
                                                    advance: D ? F[1] : F[0]
                                                };
                                                var B = 24 - F[1] * S.scale;
                                                C = w + B, z = P.advance;
                                                var N = D ? F[0] * S.scale - 24 * _ : F[1] * S.scale - 24 * _;
                                                N > 0 && N > A && (A = N);
                                            } else {
                                                var j = r[S.fontStack], U = j && j[L];
                                                if (U && U.rect) I = U.rect, P = U.metrics;
                                                else {
                                                    var V = e1[S.fontStack], H = V && V[L];
                                                    if (!H) continue;
                                                    P = H.metrics;
                                                }
                                                C = 24 * (_ - S.scale);
                                            }
                                            D ? (t1.verticalizable = !0, k.push({
                                                glyph: L,
                                                imageName: O,
                                                x: h,
                                                y: p + C,
                                                vertical: D,
                                                scale: S.scale,
                                                fontStack: S.fontStack,
                                                sectionIndex: E,
                                                metrics: P,
                                                rect: I
                                            }), h += z * S.scale + c) : (k.push({
                                                glyph: L,
                                                imageName: O,
                                                x: h,
                                                y: p + C,
                                                vertical: D,
                                                scale: S.scale,
                                                fontStack: S.fontStack,
                                                sectionIndex: E,
                                                metrics: P,
                                                rect: I
                                            }), h += P.advance * S.scale + c);
                                        }
                                        if (0 !== k.length) {
                                            var q = h - c;
                                            d = Math.max(q, d), Vl(k, 0, k.length - 1, g, A);
                                        }
                                        h = 0;
                                        var G = a * _ + A;
                                        T.lineOffset = Math.max(A, w), p += G, m = Math.max(G, m), ++v;
                                    } else p += a, ++v;
                                }
                                var Y;
                                var W = p - -17, X = Ul(o), Z = X.horizontalAlign, J = X.verticalAlign;
                                (function(t1, e1, r, n, i, a, o, s, l) {
                                    var c = (e1 - r) * i, u = 0;
                                    u = a !== o ? -s * n - -17 : (-n * l + .5) * o;
                                    for(var f = 0, h = t1; f < h.length; f += 1)for(var p = h[f], d = 0, m = p.positionedGlyphs; d < m.length; d += 1){
                                        var g = m[d];
                                        g.x += c, g.y += u;
                                    }
                                })(t1.positionedLines, g, Z, J, d, m, a, W, i.length), t1.top += -J * W, t1.bottom = t1.top + W, t1.left += -Z * d, t1.right = t1.left + d;
                            }(C, e1, r, n, g, o, s, l, f, c, h, m), !function(t1) {
                                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                                    if (0 !== r[e1].positionedGlyphs.length) return !1;
                                }
                                return !0;
                            }(L) && C;
                        }
                        Il.fromFeature = function(t1, e1) {
                            for(var r = new Il, n = 0; n < t1.sections.length; n++){
                                var i = t1.sections[n];
                                i.image ? r.addImageSection(i) : r.addTextSection(i, e1);
                            }
                            return r;
                        }, Il.prototype.length = function() {
                            return this.text.length;
                        }, Il.prototype.getSection = function(t1) {
                            return this.sections[this.sectionIndex[t1]];
                        }, Il.prototype.getSectionIndex = function(t1) {
                            return this.sectionIndex[t1];
                        }, Il.prototype.getCharCode = function(t1) {
                            return this.text.charCodeAt(t1);
                        }, Il.prototype.verticalizePunctuation = function() {
                            this.text = function(t1) {
                                for(var e1 = "", r = 0; r < t1.length; r++){
                                    var n = t1.charCodeAt(r + 1) || null, i = t1.charCodeAt(r - 1) || null;
                                    (!n || !Jn(n) || rl[t1[r + 1]]) && (!i || !Jn(i) || rl[t1[r - 1]]) && rl[t1[r]] ? e1 += rl[t1[r]] : e1 += t1[r];
                                }
                                return e1;
                            }(this.text);
                        }, Il.prototype.trim = function() {
                            for(var t1 = 0, e1 = 0; e1 < this.text.length && zl[this.text.charCodeAt(e1)]; e1++)t1++;
                            for(var r = this.text.length, n = this.text.length - 1; n >= 0 && n >= t1 && zl[this.text.charCodeAt(n)]; n--)r--;
                            this.text = this.text.substring(t1, r), this.sectionIndex = this.sectionIndex.slice(t1, r);
                        }, Il.prototype.substring = function(t1, e1) {
                            var r = new Il;
                            return r.text = this.text.substring(t1, e1), r.sectionIndex = this.sectionIndex.slice(t1, e1), r.sections = this.sections, r;
                        }, Il.prototype.toString = function() {
                            return this.text;
                        }, Il.prototype.getMaxScale = function() {
                            var t1 = this;
                            return this.sectionIndex.reduce(function(e1, r) {
                                return Math.max(e1, t1.sections[r].scale);
                            }, 0);
                        }, Il.prototype.addTextSection = function(t1, e1) {
                            this.text += t1.text, this.sections.push(Pl.forText(t1.scale, t1.fontStack || e1));
                            for(var r = this.sections.length - 1, n = 0; n < t1.text.length; ++n)this.sectionIndex.push(r);
                        }, Il.prototype.addImageSection = function(t1) {
                            var e1 = t1.image ? t1.image.name : "";
                            if (0 !== e1.length) {
                                var r = this.getNextImageSectionCharCode();
                                r ? (this.text += String.fromCharCode(r), this.sections.push(Pl.forImage(e1)), this.sectionIndex.push(this.sections.length - 1)) : _("Reached maximum number of images 6401");
                            } else _("Can't add FormattedSection with an empty image.");
                        }, Il.prototype.getNextImageSectionCharCode = function() {
                            return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
                        };
                        var zl = {
                            9: !0,
                            10: !0,
                            11: !0,
                            12: !0,
                            13: !0,
                            32: !0
                        }, Dl = {};
                        function Rl(t1, e1, r, n, i, a) {
                            if (e1.imageName) {
                                var o = n[e1.imageName];
                                return o ? o.displaySize[0] * e1.scale * 24 / a + i : 0;
                            }
                            var s = r[e1.fontStack], l = s && s[t1];
                            return l ? l.metrics.advance * e1.scale + i : 0;
                        }
                        function Fl(t1, e1, r, n) {
                            var i = Math.pow(t1 - e1, 2);
                            return n ? t1 < e1 ? i / 2 : 2 * i : i + Math.abs(r) * r;
                        }
                        function Bl(t1, e1, r) {
                            var n = 0;
                            return 10 === t1 && (n -= 1e4), r && (n += 150), 40 !== t1 && 65288 !== t1 || (n += 50), 41 !== e1 && 65289 !== e1 || (n += 50), n;
                        }
                        function Nl(t1, e1, r, n, i, a) {
                            for(var o = null, s = Fl(e1, r, i, a), l = 0, c = n; l < c.length; l += 1){
                                var u = c[l], f = Fl(e1 - u.x, r, i, a) + u.badness;
                                f <= s && (o = u, s = f);
                            }
                            return {
                                index: t1,
                                x: e1,
                                priorBreak: o,
                                badness: s
                            };
                        }
                        function jl(t1, e1, r, n, i, a, o) {
                            if ("point" !== a) return [];
                            if (!t1) return [];
                            for(var s, l = [], c = function(t1, e1, r, n, i, a) {
                                for(var o = 0, s = 0; s < t1.length(); s++){
                                    var l = t1.getSection(s);
                                    o += Rl(t1.getCharCode(s), l, n, i, e1, a);
                                }
                                return o / Math.max(1, Math.ceil(o / r));
                            }(t1, e1, r, n, i, o), u = t1.text.indexOf("\u200b") >= 0, f = 0, h = 0; h < t1.length(); h++){
                                var p = t1.getSection(h), d = t1.getCharCode(h);
                                if (zl[d] || (f += Rl(d, p, n, i, e1, o)), h < t1.length() - 1) {
                                    var m = !!(!((s = d) < 11904) && (Yn["Bopomofo Extended"](s) || Yn.Bopomofo(s) || Yn["CJK Compatibility Forms"](s) || Yn["CJK Compatibility Ideographs"](s) || Yn["CJK Compatibility"](s) || Yn["CJK Radicals Supplement"](s) || Yn["CJK Strokes"](s) || Yn["CJK Symbols and Punctuation"](s) || Yn["CJK Unified Ideographs Extension A"](s) || Yn["CJK Unified Ideographs"](s) || Yn["Enclosed CJK Letters and Months"](s) || Yn["Halfwidth and Fullwidth Forms"](s) || Yn.Hiragana(s) || Yn["Ideographic Description Characters"](s) || Yn["Kangxi Radicals"](s) || Yn["Katakana Phonetic Extensions"](s) || Yn.Katakana(s) || Yn["Vertical Forms"](s) || Yn["Yi Radicals"](s) || Yn["Yi Syllables"](s)));
                                    (Dl[d] || m || p.imageName) && l.push(Nl(h + 1, f, c, l, Bl(d, t1.getCharCode(h + 1), m && u), !1));
                                }
                            }
                            return function t1(e1) {
                                return e1 ? t1(e1.priorBreak).concat(e1.index) : [];
                            }(Nl(t1.length(), f, c, l, 0, !0));
                        }
                        function Ul(t1) {
                            var e1 = .5, r = .5;
                            switch(t1){
                                case "right":
                                case "top-right":
                                case "bottom-right":
                                    e1 = 1;
                                    break;
                                case "left":
                                case "top-left":
                                case "bottom-left":
                                    e1 = 0;
                            }
                            switch(t1){
                                case "bottom":
                                case "bottom-right":
                                case "bottom-left":
                                    r = 1;
                                    break;
                                case "top":
                                case "top-right":
                                case "top-left":
                                    r = 0;
                            }
                            return {
                                horizontalAlign: e1,
                                verticalAlign: r
                            };
                        }
                        function Vl(t1, e1, r, n, i) {
                            if (n || i) for(var a = t1[r], o = a.metrics.advance * a.scale, s = (t1[r].x + o) * n, l = e1; l <= r; l++)t1[l].x -= s, t1[l].y += i;
                        }
                        function Hl(t1, e1, r, n, i, a) {
                            var o, s = t1.image;
                            if (s.content) {
                                var l = s.content, c = s.pixelRatio || 1;
                                o = [
                                    l[0] / c,
                                    l[1] / c,
                                    s.displaySize[0] - l[2] / c,
                                    s.displaySize[1] - l[3] / c
                                ];
                            }
                            var u, f, h, p, d = e1.left * a, m = e1.right * a;
                            "width" === r || "both" === r ? (p = i[0] + d - n[3], f = i[0] + m + n[1]) : f = (p = i[0] + (d + m - s.displaySize[0]) / 2) + s.displaySize[0];
                            var g = e1.top * a, v = e1.bottom * a;
                            return "height" === r || "both" === r ? (u = i[1] + g - n[0], h = i[1] + v + n[2]) : h = (u = i[1] + (g + v - s.displaySize[1]) / 2) + s.displaySize[1], {
                                image: s,
                                top: u,
                                right: f,
                                bottom: h,
                                left: p,
                                collisionPadding: o
                            };
                        }
                        Dl[10] = !0, Dl[32] = !0, Dl[38] = !0, Dl[40] = !0, Dl[41] = !0, Dl[43] = !0, Dl[45] = !0, Dl[47] = !0, Dl[173] = !0, Dl[183] = !0, Dl[8203] = !0, Dl[8208] = !0, Dl[8211] = !0, Dl[8231] = !0;
                        var ql = function(t1) {
                            function e1(e1, r, n, i) {
                                t1.call(this, e1, r), this.angle = n, void 0 !== i && (this.segment = i);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.clone = function() {
                                return new e1(this.x, this.y, this.angle, this.segment);
                            }, e1;
                        }(i);
                        Nn("Anchor", ql);
                        function Gl(t1, e1) {
                            var r = e1.expression;
                            if ("constant" === r.kind) return {
                                kind: "constant",
                                layoutSize: r.evaluate(new pi(t1 + 1))
                            };
                            if ("source" === r.kind) return {
                                kind: "source"
                            };
                            for(var n = r.zoomStops, i = r.interpolationType, a = 0; a < n.length && n[a] <= t1;)a++;
                            for(var o = a = Math.max(0, a - 1); o < n.length && n[o] < t1 + 1;)o++;
                            o = Math.min(n.length - 1, o);
                            var s = n[a], l = n[o];
                            return "composite" === r.kind ? {
                                kind: "composite",
                                minZoom: s,
                                maxZoom: l,
                                interpolationType: i
                            } : {
                                kind: "camera",
                                minZoom: s,
                                maxZoom: l,
                                minSize: r.evaluate(new pi(s)),
                                maxSize: r.evaluate(new pi(l)),
                                interpolationType: i
                            };
                        }
                        function Yl(t1, e1, r) {
                            var n = e1.uSize, i = e1.uSizeT, a = r.lowerSize, o = r.upperSize;
                            return "source" === t1.kind ? a / 128 : "composite" === t1.kind ? qe(a / 128, o / 128, i) : n;
                        }
                        function Wl(t1, e1) {
                            var r = 0, n = 0;
                            if ("constant" === t1.kind) n = t1.layoutSize;
                            else if ("source" !== t1.kind) {
                                var i = t1.interpolationType, a = t1.minZoom, o = t1.maxZoom, s = i ? l(or.interpolationFactor(i, e1, a, o), 0, 1) : 0;
                                "camera" === t1.kind ? n = qe(t1.minSize, t1.maxSize, s) : r = s;
                            }
                            return {
                                uSizeT: r,
                                uSize: n
                            };
                        }
                        var Xl = Object.freeze({
                            __proto__: null,
                            getSizeData: Gl,
                            evaluateSizeForFeature: Yl,
                            evaluateSizeForZoom: Wl,
                            SIZE_PACK_FACTOR: 128
                        });
                        function Zl(t1, e1, r, n, i) {
                            if (void 0 === e1.segment) return !0;
                            for(var a = e1, o = e1.segment + 1, s = 0; s > -r / 2;){
                                if (--o < 0) return !1;
                                s -= t1[o].dist(a), a = t1[o];
                            }
                            s += t1[o].dist(t1[o + 1]), o++;
                            for(var l = [], c = 0; s < r / 2;){
                                var u = t1[o - 1], f = t1[o], h = t1[o + 1];
                                if (!h) return !1;
                                var p = u.angleTo(f) - f.angleTo(h);
                                for(p = Math.abs((p + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                                    distance: s,
                                    angleDelta: p
                                }), c += p; s - l[0].distance > n;)c -= l.shift().angleDelta;
                                if (c > i) return !1;
                                o++, s += f.dist(h);
                            }
                            return !0;
                        }
                        function Jl(t1) {
                            for(var e1 = 0, r = 0; r < t1.length - 1; r++)e1 += t1[r].dist(t1[r + 1]);
                            return e1;
                        }
                        function Kl(t1, e1, r) {
                            return t1 ? .6 * e1 * r : 0;
                        }
                        function Ql(t1, e1) {
                            return Math.max(t1 ? t1.right - t1.left : 0, e1 ? e1.right - e1.left : 0);
                        }
                        function $l(t1, e1, r, n, i, a) {
                            for(var o = Kl(r, i, a), s = Ql(r, n) * a, l = 0, c = Jl(t1) / 2, u = 0; u < t1.length - 1; u++){
                                var f = t1[u], h = t1[u + 1], p = f.dist(h);
                                if (l + p > c) {
                                    var d = (c - l) / p, m = qe(f.x, h.x, d), g = qe(f.y, h.y, d), v = new ql(m, g, h.angleTo(f), u);
                                    return v._round(), !o || Zl(t1, v, s, o, e1) ? v : void 0;
                                }
                                l += p;
                            }
                        }
                        function tc(t1, e1, r, n, i, a, o, s, l) {
                            var c = Kl(n, a, o), u = Ql(n, i), f = u * o, h = 0 === t1[0].x || t1[0].x === l || 0 === t1[0].y || t1[0].y === l;
                            return e1 - f < e1 / 4 && (e1 = f + e1 / 4), function t1(e1, r, n, i, a, o, s, l, c) {
                                for(var u = o / 2, f = Jl(e1), h = 0, p = r - n, d = [], m = 0; m < e1.length - 1; m++){
                                    for(var g = e1[m], v = e1[m + 1], y = g.dist(v), x = v.angleTo(g); p + n < h + y;){
                                        var b = ((p += n) - h) / y, _ = qe(g.x, v.x, b), w = qe(g.y, v.y, b);
                                        if (_ >= 0 && _ < c && w >= 0 && w < c && p - u >= 0 && p + u <= f) {
                                            var T = new ql(_, w, x, m);
                                            T._round(), i && !Zl(e1, T, o, i, a) || d.push(T);
                                        }
                                    }
                                    h += y;
                                }
                                l || d.length || s || (d = t1(e1, h / 2, n, i, a, o, s, !0, c));
                                return d;
                            }(t1, h ? e1 / 2 * s % e1 : (u / 2 + 2 * a) * o * s % e1, e1, c, r, f, h, !1, l);
                        }
                        function ec(t1, e1, r, n, a) {
                            for(var o = [], s = 0; s < t1.length; s++)for(var l = t1[s], c = void 0, u = 0; u < l.length - 1; u++){
                                var f = l[u], h = l[u + 1];
                                f.x < e1 && h.x < e1 || (f.x < e1 ? f = new i(e1, f.y + (h.y - f.y) * ((e1 - f.x) / (h.x - f.x)))._round() : h.x < e1 && (h = new i(e1, f.y + (h.y - f.y) * ((e1 - f.x) / (h.x - f.x)))._round()), f.y < r && h.y < r || (f.y < r ? f = new i(f.x + (h.x - f.x) * ((r - f.y) / (h.y - f.y)), r)._round() : h.y < r && (h = new i(f.x + (h.x - f.x) * ((r - f.y) / (h.y - f.y)), r)._round()), f.x >= n && h.x >= n || (f.x >= n ? f = new i(n, f.y + (h.y - f.y) * ((n - f.x) / (h.x - f.x)))._round() : h.x >= n && (h = new i(n, f.y + (h.y - f.y) * ((n - f.x) / (h.x - f.x)))._round()), f.y >= a && h.y >= a || (f.y >= a ? f = new i(f.x + (h.x - f.x) * ((a - f.y) / (h.y - f.y)), a)._round() : h.y >= a && (h = new i(f.x + (h.x - f.x) * ((a - f.y) / (h.y - f.y)), a)._round()), c && f.equals(c[c.length - 1]) || (c = [
                                    f
                                ], o.push(c)), c.push(h)))));
                            }
                            return o;
                        }
                        function rc(t1, e1, r, n) {
                            var a = [], o = t1.image, s = o.pixelRatio, l = o.paddedRect.w - 2, c = o.paddedRect.h - 2, u = t1.right - t1.left, f = t1.bottom - t1.top, h = o.stretchX || [
                                [
                                    0,
                                    l
                                ]
                            ], p = o.stretchY || [
                                [
                                    0,
                                    c
                                ]
                            ], d = function(t1, e1) {
                                return t1 + e1[1] - e1[0];
                            }, m = h.reduce(d, 0), g = p.reduce(d, 0), v = l - m, y = c - g, x = 0, b = m, _ = 0, w = g, T = 0, k = v, A = 0, M = y;
                            if (o.content && n) {
                                var S = o.content;
                                x = nc(h, 0, S[0]), _ = nc(p, 0, S[1]), b = nc(h, S[0], S[2]), w = nc(p, S[1], S[3]), T = S[0] - x, A = S[1] - _, k = S[2] - S[0] - b, M = S[3] - S[1] - w;
                            }
                            var E = function(n, a, l, c) {
                                var h = ac(n.stretch - x, b, u, t1.left), p = oc(n.fixed - T, k, n.stretch, m), d = ac(a.stretch - _, w, f, t1.top), v = oc(a.fixed - A, M, a.stretch, g), y = ac(l.stretch - x, b, u, t1.left), S = oc(l.fixed - T, k, l.stretch, m), E = ac(c.stretch - _, w, f, t1.top), L = oc(c.fixed - A, M, c.stretch, g), C = new i(h, d), P = new i(y, d), I = new i(y, E), O = new i(h, E), z = new i(p / s, v / s), D = new i(S / s, L / s), R = e1 * Math.PI / 180;
                                if (R) {
                                    var F = Math.sin(R), B = Math.cos(R), N = [
                                        B,
                                        -F,
                                        F,
                                        B
                                    ];
                                    C._matMult(N), P._matMult(N), O._matMult(N), I._matMult(N);
                                }
                                var j = n.stretch + n.fixed, U = l.stretch + l.fixed, V = a.stretch + a.fixed, H = c.stretch + c.fixed;
                                return {
                                    tl: C,
                                    tr: P,
                                    bl: O,
                                    br: I,
                                    tex: {
                                        x: o.paddedRect.x + 1 + j,
                                        y: o.paddedRect.y + 1 + V,
                                        w: U - j,
                                        h: H - V
                                    },
                                    writingMode: void 0,
                                    glyphOffset: [
                                        0,
                                        0
                                    ],
                                    sectionIndex: 0,
                                    pixelOffsetTL: z,
                                    pixelOffsetBR: D,
                                    minFontScaleX: k / s / u,
                                    minFontScaleY: M / s / f,
                                    isSDF: r
                                };
                            };
                            if (n && (o.stretchX || o.stretchY)) for(var L = ic(h, v, m), C = ic(p, y, g), P = 0; P < L.length - 1; P++)for(var I = L[P], O = L[P + 1], z = 0; z < C.length - 1; z++){
                                var D = C[z], R = C[z + 1];
                                a.push(E(I, D, O, R));
                            }
                            else a.push(E({
                                fixed: 0,
                                stretch: -1
                            }, {
                                fixed: 0,
                                stretch: -1
                            }, {
                                fixed: 0,
                                stretch: l + 1
                            }, {
                                fixed: 0,
                                stretch: c + 1
                            }));
                            return a;
                        }
                        function nc(t1, e1, r) {
                            for(var n = 0, i = 0, a = t1; i < a.length; i += 1){
                                var o = a[i];
                                n += Math.max(e1, Math.min(r, o[1])) - Math.max(e1, Math.min(r, o[0]));
                            }
                            return n;
                        }
                        function ic(t1, e1, r) {
                            for(var n = [
                                {
                                    fixed: -1,
                                    stretch: 0
                                }
                            ], i = 0, a = t1; i < a.length; i += 1){
                                var o = a[i], s = o[0], l = o[1], c = n[n.length - 1];
                                n.push({
                                    fixed: s - c.stretch,
                                    stretch: c.stretch
                                }), n.push({
                                    fixed: s - c.stretch,
                                    stretch: c.stretch + (l - s)
                                });
                            }
                            return n.push({
                                fixed: e1 + 1,
                                stretch: r
                            }), n;
                        }
                        function ac(t1, e1, r, n) {
                            return t1 / e1 * r + n;
                        }
                        function oc(t1, e1, r, n) {
                            return t1 - e1 * r / n;
                        }
                        var sc = function(t1, e1, r, n, a, o, s, l, c, u) {
                            if (this.boxStartIndex = t1.length, c) {
                                var f = o.top, h = o.bottom, p = o.collisionPadding;
                                p && (f -= p[1], h += p[3]);
                                var d = h - f;
                                d > 0 && (d = Math.max(10, d), this.circleDiameter = d);
                            } else {
                                var m = o.top * s - l, g = o.bottom * s + l, v = o.left * s - l, y = o.right * s + l, x = o.collisionPadding;
                                if (x && (v -= x[0] * s, m -= x[1] * s, y += x[2] * s, g += x[3] * s), u) {
                                    var b = new i(v, m), _ = new i(y, m), w = new i(v, g), T = new i(y, g), k = u * Math.PI / 180;
                                    b._rotate(k), _._rotate(k), w._rotate(k), T._rotate(k), v = Math.min(b.x, _.x, w.x, T.x), y = Math.max(b.x, _.x, w.x, T.x), m = Math.min(b.y, _.y, w.y, T.y), g = Math.max(b.y, _.y, w.y, T.y);
                                }
                                t1.emplaceBack(e1.x, e1.y, v, m, y, g, r, n, a);
                            }
                            this.boxEndIndex = t1.length;
                        }, lc = function(t1, e1) {
                            if (void 0 === t1 && (t1 = []), void 0 === e1 && (e1 = cc), this.data = t1, this.length = this.data.length, this.compare = e1, this.length > 0) for(var r = (this.length >> 1) - 1; r >= 0; r--)this._down(r);
                        };
                        function cc(t1, e1) {
                            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
                        }
                        function uc(t1, e1, r) {
                            void 0 === e1 && (e1 = 1), void 0 === r && (r = !1);
                            for(var n = 1 / 0, a = 1 / 0, o = -1 / 0, s = -1 / 0, l = t1[0], c = 0; c < l.length; c++){
                                var u = l[c];
                                (!c || u.x < n) && (n = u.x), (!c || u.y < a) && (a = u.y), (!c || u.x > o) && (o = u.x), (!c || u.y > s) && (s = u.y);
                            }
                            var f = o - n, h = s - a, p = Math.min(f, h), d = p / 2, m = new lc([], fc);
                            if (0 === p) return new i(n, a);
                            for(var g = n; g < o; g += p)for(var v = a; v < s; v += p)m.push(new hc(g + d, v + d, d, t1));
                            for(var y = function(t1) {
                                for(var e1 = 0, r = 0, n = 0, i = t1[0], a = 0, o = i.length, s = o - 1; a < o; s = a++){
                                    var l = i[a], c = i[s], u = l.x * c.y - c.x * l.y;
                                    r += (l.x + c.x) * u, n += (l.y + c.y) * u, e1 += 3 * u;
                                }
                                return new hc(r / e1, n / e1, 0, t1);
                            }(t1), x = m.length; m.length;){
                                var b = m.pop();
                                (b.d > y.d || !y.d) && (y = b, r && console.log("found best %d after %d probes", Math.round(1e4 * b.d) / 1e4, x)), b.max - y.d <= e1 || (d = b.h / 2, m.push(new hc(b.p.x - d, b.p.y - d, d, t1)), m.push(new hc(b.p.x + d, b.p.y - d, d, t1)), m.push(new hc(b.p.x - d, b.p.y + d, d, t1)), m.push(new hc(b.p.x + d, b.p.y + d, d, t1)), x += 4);
                            }
                            return r && (console.log("num probes: " + x), console.log("best distance: " + y.d)), y.p;
                        }
                        function fc(t1, e1) {
                            return e1.max - t1.max;
                        }
                        function hc(t1, e1, r, n) {
                            this.p = new i(t1, e1), this.h = r, this.d = function(t1, e1) {
                                for(var r = !1, n = 1 / 0, i = 0; i < e1.length; i++)for(var a = e1[i], o = 0, s = a.length, l = s - 1; o < s; l = o++){
                                    var c = a[o], u = a[l];
                                    c.y > t1.y != u.y > t1.y && t1.x < (u.x - c.x) * (t1.y - c.y) / (u.y - c.y) + c.x && (r = !r), n = Math.min(n, ro(t1, c, u));
                                }
                                return (r ? 1 : -1) * Math.sqrt(n);
                            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
                        }
                        lc.prototype.push = function(t1) {
                            this.data.push(t1), this.length++, this._up(this.length - 1);
                        }, lc.prototype.pop = function() {
                            if (0 !== this.length) {
                                var t1 = this.data[0], e1 = this.data.pop();
                                return this.length--, this.length > 0 && (this.data[0] = e1, this._down(0)), t1;
                            }
                        }, lc.prototype.peek = function() {
                            return this.data[0];
                        }, lc.prototype._up = function(t1) {
                            for(var e1 = this.data, r = this.compare, n = e1[t1]; t1 > 0;){
                                var i = t1 - 1 >> 1, a = e1[i];
                                if (r(n, a) >= 0) break;
                                e1[t1] = a, t1 = i;
                            }
                            e1[t1] = n;
                        }, lc.prototype._down = function(t1) {
                            for(var e1 = this.data, r = this.compare, n = this.length >> 1, i = e1[t1]; t1 < n;){
                                var a = 1 + (t1 << 1), o = e1[a], s = a + 1;
                                if (s < this.length && r(e1[s], o) < 0 && (a = s, o = e1[s]), r(o, i) >= 0) break;
                                e1[t1] = o, t1 = a;
                            }
                            e1[t1] = i;
                        };
                        var pc = Number.POSITIVE_INFINITY;
                        function dc(t1, e1) {
                            return e1[1] !== pc ? function(t1, e1, r) {
                                var n = 0, i = 0;
                                switch(e1 = Math.abs(e1), r = Math.abs(r), t1){
                                    case "top-right":
                                    case "top-left":
                                    case "top":
                                        i = r - 7;
                                        break;
                                    case "bottom-right":
                                    case "bottom-left":
                                    case "bottom":
                                        i = 7 - r;
                                }
                                switch(t1){
                                    case "top-right":
                                    case "bottom-right":
                                    case "right":
                                        n = -e1;
                                        break;
                                    case "top-left":
                                    case "bottom-left":
                                    case "left":
                                        n = e1;
                                }
                                return [
                                    n,
                                    i
                                ];
                            }(t1, e1[0], e1[1]) : function(t1, e1) {
                                var r = 0, n = 0;
                                e1 < 0 && (e1 = 0);
                                var i = e1 / Math.sqrt(2);
                                switch(t1){
                                    case "top-right":
                                    case "top-left":
                                        n = i - 7;
                                        break;
                                    case "bottom-right":
                                    case "bottom-left":
                                        n = 7 - i;
                                        break;
                                    case "bottom":
                                        n = 7 - e1;
                                        break;
                                    case "top":
                                        n = e1 - 7;
                                }
                                switch(t1){
                                    case "top-right":
                                    case "bottom-right":
                                        r = -i;
                                        break;
                                    case "top-left":
                                    case "bottom-left":
                                        r = i;
                                        break;
                                    case "left":
                                        r = e1;
                                        break;
                                    case "right":
                                        r = -e1;
                                }
                                return [
                                    r,
                                    n
                                ];
                            }(t1, e1[0]);
                        }
                        function mc(t1) {
                            switch(t1){
                                case "right":
                                case "top-right":
                                case "bottom-right":
                                    return "right";
                                case "left":
                                case "top-left":
                                case "bottom-left":
                                    return "left";
                            }
                            return "center";
                        }
                        function gc(t1, e1, r, n, a, o, s, l, c, u, f, h, p, d, m) {
                            var g = function(t1, e1, r, n, a, o, s, l) {
                                for(var c = n.layout.get("text-rotate").evaluate(o, {}) * Math.PI / 180, u = [], f = 0, h = e1.positionedLines; f < h.length; f += 1)for(var p = h[f], d = 0, m = p.positionedGlyphs; d < m.length; d += 1){
                                    var g = m[d];
                                    if (g.rect) {
                                        var v = g.rect || {}, y = 4, x = !0, b = 1, _ = 0, w = (a || l) && g.vertical, T = g.metrics.advance * g.scale / 2;
                                        if (l && e1.verticalizable) {
                                            var k = 24 * (g.scale - 1), A = (24 - g.metrics.width * g.scale) / 2;
                                            _ = p.lineOffset / 2 - (g.imageName ? -A : k);
                                        }
                                        if (g.imageName) {
                                            var M = s[g.imageName];
                                            x = M.sdf, y = 1 / (b = M.pixelRatio);
                                        }
                                        var S = a ? [
                                            g.x + T,
                                            g.y
                                        ] : [
                                            0,
                                            0
                                        ], E = a ? [
                                            0,
                                            0
                                        ] : [
                                            g.x + T + r[0],
                                            g.y + r[1] - _
                                        ], L = [
                                            0,
                                            0
                                        ];
                                        w && (L = E, E = [
                                            0,
                                            0
                                        ]);
                                        var C = (g.metrics.left - y) * g.scale - T + E[0], P = (-g.metrics.top - y) * g.scale + E[1], I = C + v.w * g.scale / b, O = P + v.h * g.scale / b, z = new i(C, P), D = new i(I, P), R = new i(C, O), F = new i(I, O);
                                        if (w) {
                                            var B = new i(-T, T - -17), N = -Math.PI / 2, j = 12 - T, U = g.imageName ? j : 0, V = new i(22 - j, -U), H = new (Function.prototype.bind.apply(i, [
                                                null
                                            ].concat(L)));
                                            z._rotateAround(N, B)._add(V)._add(H), D._rotateAround(N, B)._add(V)._add(H), R._rotateAround(N, B)._add(V)._add(H), F._rotateAround(N, B)._add(V)._add(H);
                                        }
                                        if (c) {
                                            var q = Math.sin(c), G = Math.cos(c), Y = [
                                                G,
                                                -q,
                                                q,
                                                G
                                            ];
                                            z._matMult(Y), D._matMult(Y), R._matMult(Y), F._matMult(Y);
                                        }
                                        var W = new i(0, 0), X = new i(0, 0);
                                        u.push({
                                            tl: z,
                                            tr: D,
                                            bl: R,
                                            br: F,
                                            tex: v,
                                            writingMode: e1.writingMode,
                                            glyphOffset: S,
                                            sectionIndex: g.sectionIndex,
                                            isSDF: x,
                                            pixelOffsetTL: W,
                                            pixelOffsetBR: X,
                                            minFontScaleX: 0,
                                            minFontScaleY: 0
                                        });
                                    }
                                }
                                return u;
                            }(0, r, l, a, o, s, n, t1.allowVerticalPlacement), v = t1.textSizeData, y = null;
                            "source" === v.kind ? (y = [
                                128 * a.layout.get("text-size").evaluate(s, {})
                            ])[0] > 32640 && _(t1.layerIds[0] + ': Value for "text-size" is >= 255. Reduce your "text-size".') : "composite" === v.kind && ((y = [
                                128 * d.compositeTextSizes[0].evaluate(s, {}, m),
                                128 * d.compositeTextSizes[1].evaluate(s, {}, m)
                            ])[0] > 32640 || y[1] > 32640) && _(t1.layerIds[0] + ': Value for "text-size" is >= 255. Reduce your "text-size".'), t1.addSymbols(t1.text, g, y, l, o, s, u, e1, c.lineStartIndex, c.lineLength, p, m);
                            for(var x = 0, b = f; x < b.length; x += 1)h[b[x]] = t1.text.placedSymbolArray.length - 1;
                            return 4 * g.length;
                        }
                        function vc(t1) {
                            for(var e1 in t1)return t1[e1];
                            return null;
                        }
                        function yc(t1, e1, r, n) {
                            var i = t1.compareText;
                            if (e1 in i) {
                                for(var a = i[e1], o = a.length - 1; o >= 0; o--)if (n.dist(a[o]) < r) return !0;
                            } else i[e1] = [];
                            return i[e1].push(n), !1;
                        }
                        var xc = Ls.VectorTileFeature.types, bc = [
                            {
                                name: "a_fade_opacity",
                                components: 1,
                                type: "Uint8",
                                offset: 0
                            }
                        ];
                        function _c(t1, e1, r, n, i, a, o, s, l, c, u, f, h) {
                            var p = s ? Math.min(32640, Math.round(s[0])) : 0, d = s ? Math.min(32640, Math.round(s[1])) : 0;
                            t1.emplaceBack(e1, r, Math.round(32 * n), Math.round(32 * i), a, o, (p << 1) + (l ? 1 : 0), d, 16 * c, 16 * u, 256 * f, 256 * h);
                        }
                        function wc(t1, e1, r) {
                            t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r), t1.emplaceBack(e1.x, e1.y, r);
                        }
                        function Tc(t1) {
                            for(var e1 = 0, r = t1.sections; e1 < r.length; e1 += 1){
                                if ($n(r[e1].text)) return !0;
                            }
                            return !1;
                        }
                        var kc = function(t1) {
                            this.layoutVertexArray = new Ni, this.indexArray = new Yi, this.programConfigurations = t1, this.segments = new pa, this.dynamicLayoutVertexArray = new ji, this.opacityVertexArray = new Ui, this.placedSymbolArray = new aa;
                        };
                        kc.prototype.isEmpty = function() {
                            return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
                        }, kc.prototype.upload = function(t1, e1, r, n) {
                            this.isEmpty() || (r && (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Js.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray, e1), this.dynamicLayoutVertexBuffer = t1.createVertexBuffer(this.dynamicLayoutVertexArray, Ks.members, !0), this.opacityVertexBuffer = t1.createVertexBuffer(this.opacityVertexArray, bc, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t1));
                        }, kc.prototype.destroy = function() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
                        }, Nn("SymbolBuffers", kc);
                        var Ac = function(t1, e1, r) {
                            this.layoutVertexArray = new t1, this.layoutAttributes = e1, this.indexArray = new r, this.segments = new pa, this.collisionVertexArray = new Gi;
                        };
                        Ac.prototype.upload = function(t1) {
                            this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t1.createVertexBuffer(this.collisionVertexArray, Qs.members, !0);
                        }, Ac.prototype.destroy = function() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
                        }, Nn("CollisionBuffers", Ac);
                        var Mc = function(t1) {
                            this.collisionBoxArray = t1.collisionBoxArray, this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map(function(t1) {
                                return t1.id;
                            }), this.index = t1.index, this.pixelRatio = t1.pixelRatio, this.sourceLayerIndex = t1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = ho([]), this.placementViewportMatrix = ho([]);
                            var e1 = this.layers[0]._unevaluatedLayout._values;
                            this.textSizeData = Gl(this.zoom, e1["text-size"]), this.iconSizeData = Gl(this.zoom, e1["icon-size"]);
                            var r = this.layers[0].layout, n = r.get("symbol-sort-key"), i = r.get("symbol-z-order");
                            this.sortFeaturesByKey = "viewport-y" !== i && void 0 !== n.constantOr(1);
                            var a = "viewport-y" === i || "auto" === i && !this.sortFeaturesByKey;
                            this.sortFeaturesByY = a && (r.get("text-allow-overlap") || r.get("icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement")), "point" === r.get("symbol-placement") && (this.writingModes = r.get("text-writing-mode").map(function(t1) {
                                return Cl[t1];
                            })), this.stateDependentLayerIds = this.layers.filter(function(t1) {
                                return t1.isStateDependent();
                            }).map(function(t1) {
                                return t1.id;
                            }), this.sourceID = t1.sourceID;
                        };
                        Mc.prototype.createArrays = function() {
                            this.text = new kc(new Ua(Js.members, this.layers, this.zoom, function(t1) {
                                return /^text/.test(t1);
                            })), this.icon = new kc(new Ua(Js.members, this.layers, this.zoom, function(t1) {
                                return /^icon/.test(t1);
                            })), this.glyphOffsetArray = new la, this.lineVertexArray = new ca, this.symbolInstances = new sa;
                        }, Mc.prototype.calculateGlyphDependencies = function(t1, e1, r, n, i) {
                            for(var a = 0; a < t1.length; a++)if (e1[t1.charCodeAt(a)] = !0, (r || n) && i) {
                                var o = rl[t1.charAt(a)];
                                o && (e1[o.charCodeAt(0)] = !0);
                            }
                        }, Mc.prototype.populate = function(t1, e1, r) {
                            var n = this.layers[0], i = n.layout, a = i.get("text-font"), o = i.get("text-field"), s = i.get("icon-image"), l = ("constant" !== o.value.kind || o.value.value instanceof ne && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0), c = "constant" !== s.value.kind || !!s.value.value || Object.keys(s.parameters).length > 0, u = i.get("symbol-sort-key");
                            if (this.features = [], l || c) {
                                for(var f = e1.iconDependencies, h = e1.glyphDependencies, p = e1.availableImages, d = new pi(this.zoom), m = 0, g = t1; m < g.length; m += 1){
                                    var v = g[m], y = v.feature, x = v.id, b = v.index, _ = v.sourceLayerIndex, w = n._featureFilter.needGeometry, T = {
                                        type: y.type,
                                        id: x,
                                        properties: y.properties,
                                        geometry: w ? Ya(y) : []
                                    };
                                    if (n._featureFilter.filter(d, T, r)) {
                                        w || (T.geometry = Ya(y));
                                        var k = void 0;
                                        if (l) {
                                            var A = n.getValueAndResolveTokens("text-field", T, r, p), M = ne.factory(A);
                                            Tc(M) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === ui() || this.hasRTLText && hi.isParsed()) && (k = el(M, n, T));
                                        }
                                        var S = void 0;
                                        if (c) {
                                            var E = n.getValueAndResolveTokens("icon-image", T, r, p);
                                            S = E instanceof ie ? E : ie.fromString(E);
                                        }
                                        if (k || S) {
                                            var L = this.sortFeaturesByKey ? u.evaluate(T, {}, r) : void 0, C = {
                                                id: x,
                                                text: k,
                                                icon: S,
                                                index: b,
                                                sourceLayerIndex: _,
                                                geometry: Ya(y),
                                                properties: y.properties,
                                                type: xc[y.type],
                                                sortKey: L
                                            };
                                            if (this.features.push(C), S && (f[S.name] = !0), k) {
                                                var P = a.evaluate(T, {}, r).join(","), I = "map" === i.get("text-rotation-alignment") && "point" !== i.get("symbol-placement");
                                                this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(Cl.vertical) >= 0;
                                                for(var O = 0, z = k.sections; O < z.length; O += 1){
                                                    var D = z[O];
                                                    if (D.image) f[D.image.name] = !0;
                                                    else {
                                                        var R = Wn(k.toString()), F = D.fontStack || P, B = h[F] = h[F] || {};
                                                        this.calculateGlyphDependencies(D.text, B, I, this.allowVerticalPlacement, R);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                "line" === i.get("symbol-placement") && (this.features = function(t1) {
                                    var e1 = {}, r = {}, n = [], i = 0;
                                    function a(e1) {
                                        n.push(t1[e1]), i++;
                                    }
                                    function o(t1, e1, i) {
                                        var a = r[t1];
                                        return delete r[t1], r[e1] = a, n[a].geometry[0].pop(), n[a].geometry[0] = n[a].geometry[0].concat(i[0]), a;
                                    }
                                    function s(t1, r, i) {
                                        var a = e1[r];
                                        return delete e1[r], e1[t1] = a, n[a].geometry[0].shift(), n[a].geometry[0] = i[0].concat(n[a].geometry[0]), a;
                                    }
                                    function l(t1, e1, r) {
                                        var n = r ? e1[0][e1[0].length - 1] : e1[0][0];
                                        return t1 + ":" + n.x + ":" + n.y;
                                    }
                                    for(var c = 0; c < t1.length; c++){
                                        var u = t1[c], f = u.geometry, h = u.text ? u.text.toString() : null;
                                        if (h) {
                                            var p = l(h, f), d = l(h, f, !0);
                                            if (p in r && d in e1 && r[p] !== e1[d]) {
                                                var m = s(p, d, f), g = o(p, d, n[m].geometry);
                                                delete e1[p], delete r[d], r[l(h, n[g].geometry, !0)] = g, n[m].geometry = null;
                                            } else p in r ? o(p, d, f) : d in e1 ? s(p, d, f) : (a(c), e1[p] = i - 1, r[d] = i - 1);
                                        } else a(c);
                                    }
                                    return n.filter(function(t1) {
                                        return t1.geometry;
                                    });
                                }(this.features)), this.sortFeaturesByKey && this.features.sort(function(t1, e1) {
                                    return t1.sortKey - e1.sortKey;
                                });
                            }
                        }, Mc.prototype.update = function(t1, e1, r) {
                            this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t1, e1, this.layers, r), this.icon.programConfigurations.updatePaintArrays(t1, e1, this.layers, r));
                        }, Mc.prototype.isEmpty = function() {
                            return 0 === this.symbolInstances.length && !this.hasRTLText;
                        }, Mc.prototype.uploadPending = function() {
                            return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
                        }, Mc.prototype.upload = function(t1) {
                            !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t1), this.iconCollisionBox.upload(t1)), this.text.upload(t1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
                        }, Mc.prototype.destroyDebugData = function() {
                            this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
                        }, Mc.prototype.destroy = function() {
                            this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
                        }, Mc.prototype.addToLineVertexArray = function(t1, e1) {
                            var r = this.lineVertexArray.length;
                            if (void 0 !== t1.segment) {
                                for(var n = t1.dist(e1[t1.segment + 1]), i = t1.dist(e1[t1.segment]), a = {}, o = t1.segment + 1; o < e1.length; o++)a[o] = {
                                    x: e1[o].x,
                                    y: e1[o].y,
                                    tileUnitDistanceFromAnchor: n
                                }, o < e1.length - 1 && (n += e1[o + 1].dist(e1[o]));
                                for(var s = t1.segment || 0; s >= 0; s--)a[s] = {
                                    x: e1[s].x,
                                    y: e1[s].y,
                                    tileUnitDistanceFromAnchor: i
                                }, s > 0 && (i += e1[s - 1].dist(e1[s]));
                                for(var l = 0; l < e1.length; l++){
                                    var c = a[l];
                                    this.lineVertexArray.emplaceBack(c.x, c.y, c.tileUnitDistanceFromAnchor);
                                }
                            }
                            return {
                                lineStartIndex: r,
                                lineLength: this.lineVertexArray.length - r
                            };
                        }, Mc.prototype.addSymbols = function(t1, e1, r, n, i, a, o, s, l, c, u, f) {
                            for(var h = t1.indexArray, p = t1.layoutVertexArray, d = t1.segments.prepareSegment(4 * e1.length, p, h, a.sortKey), m = this.glyphOffsetArray.length, g = d.vertexLength, v = this.allowVerticalPlacement && o === Cl.vertical ? Math.PI / 2 : 0, y = a.text && a.text.sections, x = 0; x < e1.length; x++){
                                var b = e1[x], _ = b.tl, w = b.tr, T = b.bl, k = b.br, A = b.tex, M = b.pixelOffsetTL, S = b.pixelOffsetBR, E = b.minFontScaleX, L = b.minFontScaleY, C = b.glyphOffset, P = b.isSDF, I = b.sectionIndex, O = d.vertexLength, z = C[1];
                                _c(p, s.x, s.y, _.x, z + _.y, A.x, A.y, r, P, M.x, M.y, E, L), _c(p, s.x, s.y, w.x, z + w.y, A.x + A.w, A.y, r, P, S.x, M.y, E, L), _c(p, s.x, s.y, T.x, z + T.y, A.x, A.y + A.h, r, P, M.x, S.y, E, L), _c(p, s.x, s.y, k.x, z + k.y, A.x + A.w, A.y + A.h, r, P, S.x, S.y, E, L), wc(t1.dynamicLayoutVertexArray, s, v), h.emplaceBack(O, O + 1, O + 2), h.emplaceBack(O + 1, O + 2, O + 3), d.vertexLength += 4, d.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(C[0]), x !== e1.length - 1 && I === e1[x + 1].sectionIndex || t1.programConfigurations.populatePaintArrays(p.length, a, a.index, {}, f, y && y[I]);
                            }
                            t1.placedSymbolArray.emplaceBack(s.x, s.y, m, this.glyphOffsetArray.length - m, g, l, c, s.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], o, 0, !1, 0, u);
                        }, Mc.prototype._addCollisionDebugVertex = function(t1, e1, r, n, i, a) {
                            return e1.emplaceBack(0, 0), t1.emplaceBack(r.x, r.y, n, i, Math.round(a.x), Math.round(a.y));
                        }, Mc.prototype.addCollisionDebugVertices = function(t1, e1, r, n, a, o, s) {
                            var l = a.segments.prepareSegment(4, a.layoutVertexArray, a.indexArray), c = l.vertexLength, u = a.layoutVertexArray, f = a.collisionVertexArray, h = s.anchorX, p = s.anchorY;
                            this._addCollisionDebugVertex(u, f, o, h, p, new i(t1, e1)), this._addCollisionDebugVertex(u, f, o, h, p, new i(r, e1)), this._addCollisionDebugVertex(u, f, o, h, p, new i(r, n)), this._addCollisionDebugVertex(u, f, o, h, p, new i(t1, n)), l.vertexLength += 4;
                            var d = a.indexArray;
                            d.emplaceBack(c, c + 1), d.emplaceBack(c + 1, c + 2), d.emplaceBack(c + 2, c + 3), d.emplaceBack(c + 3, c), l.primitiveLength += 4;
                        }, Mc.prototype.addDebugCollisionBoxes = function(t1, e1, r, n) {
                            for(var i = t1; i < e1; i++){
                                var a = this.collisionBoxArray.get(i), o = a.x1, s = a.y1, l = a.x2, c = a.y2;
                                this.addCollisionDebugVertices(o, s, l, c, n ? this.textCollisionBox : this.iconCollisionBox, a.anchorPoint, r);
                            }
                        }, Mc.prototype.generateCollisionDebugBuffers = function() {
                            this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Ac(Hi, $s.members, Qi), this.iconCollisionBox = new Ac(Hi, $s.members, Qi);
                            for(var t1 = 0; t1 < this.symbolInstances.length; t1++){
                                var e1 = this.symbolInstances.get(t1);
                                this.addDebugCollisionBoxes(e1.textBoxStartIndex, e1.textBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.verticalTextBoxStartIndex, e1.verticalTextBoxEndIndex, e1, !0), this.addDebugCollisionBoxes(e1.iconBoxStartIndex, e1.iconBoxEndIndex, e1, !1), this.addDebugCollisionBoxes(e1.verticalIconBoxStartIndex, e1.verticalIconBoxEndIndex, e1, !1);
                            }
                        }, Mc.prototype._deserializeCollisionBoxesForSymbol = function(t1, e1, r, n, i, a, o, s, l) {
                            for(var c = {}, u = e1; u < r; u++){
                                var f = t1.get(u);
                                c.textBox = {
                                    x1: f.x1,
                                    y1: f.y1,
                                    x2: f.x2,
                                    y2: f.y2,
                                    anchorPointX: f.anchorPointX,
                                    anchorPointY: f.anchorPointY
                                }, c.textFeatureIndex = f.featureIndex;
                                break;
                            }
                            for(var h = n; h < i; h++){
                                var p = t1.get(h);
                                c.verticalTextBox = {
                                    x1: p.x1,
                                    y1: p.y1,
                                    x2: p.x2,
                                    y2: p.y2,
                                    anchorPointX: p.anchorPointX,
                                    anchorPointY: p.anchorPointY
                                }, c.verticalTextFeatureIndex = p.featureIndex;
                                break;
                            }
                            for(var d = a; d < o; d++){
                                var m = t1.get(d);
                                c.iconBox = {
                                    x1: m.x1,
                                    y1: m.y1,
                                    x2: m.x2,
                                    y2: m.y2,
                                    anchorPointX: m.anchorPointX,
                                    anchorPointY: m.anchorPointY
                                }, c.iconFeatureIndex = m.featureIndex;
                                break;
                            }
                            for(var g = s; g < l; g++){
                                var v = t1.get(g);
                                c.verticalIconBox = {
                                    x1: v.x1,
                                    y1: v.y1,
                                    x2: v.x2,
                                    y2: v.y2,
                                    anchorPointX: v.anchorPointX,
                                    anchorPointY: v.anchorPointY
                                }, c.verticalIconFeatureIndex = v.featureIndex;
                                break;
                            }
                            return c;
                        }, Mc.prototype.deserializeCollisionBoxes = function(t1) {
                            this.collisionArrays = [];
                            for(var e1 = 0; e1 < this.symbolInstances.length; e1++){
                                var r = this.symbolInstances.get(e1);
                                this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                            }
                        }, Mc.prototype.hasTextData = function() {
                            return this.text.segments.get().length > 0;
                        }, Mc.prototype.hasIconData = function() {
                            return this.icon.segments.get().length > 0;
                        }, Mc.prototype.hasDebugData = function() {
                            return this.textCollisionBox && this.iconCollisionBox;
                        }, Mc.prototype.hasTextCollisionBoxData = function() {
                            return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
                        }, Mc.prototype.hasIconCollisionBoxData = function() {
                            return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
                        }, Mc.prototype.addIndicesForPlacedSymbol = function(t1, e1) {
                            for(var r = t1.placedSymbolArray.get(e1), n = r.vertexStartIndex + 4 * r.numGlyphs, i = r.vertexStartIndex; i < n; i += 4)t1.indexArray.emplaceBack(i, i + 1, i + 2), t1.indexArray.emplaceBack(i + 1, i + 2, i + 3);
                        }, Mc.prototype.getSortedSymbolIndexes = function(t1) {
                            if (this.sortedAngle === t1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                            for(var e1 = Math.sin(t1), r = Math.cos(t1), n = [], i = [], a = [], o = 0; o < this.symbolInstances.length; ++o){
                                a.push(o);
                                var s = this.symbolInstances.get(o);
                                n.push(0 | Math.round(e1 * s.anchorX + r * s.anchorY)), i.push(s.featureIndex);
                            }
                            return a.sort(function(t1, e1) {
                                return n[t1] - n[e1] || i[e1] - i[t1];
                            }), a;
                        }, Mc.prototype.addToSortKeyRanges = function(t1, e1) {
                            var r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                            r && r.sortKey === e1 ? r.symbolInstanceEnd = t1 + 1 : this.sortKeyRanges.push({
                                sortKey: e1,
                                symbolInstanceStart: t1,
                                symbolInstanceEnd: t1 + 1
                            });
                        }, Mc.prototype.sortFeatures = function(t1) {
                            var e1 = this;
                            if (this.sortFeaturesByY && this.sortedAngle !== t1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                                this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t1), this.sortedAngle = t1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                                for(var r = 0, n = this.symbolInstanceIndexes; r < n.length; r += 1){
                                    var i = n[r], a = this.symbolInstances.get(i);
                                    this.featureSortOrder.push(a.featureIndex), [
                                        a.rightJustifiedTextSymbolIndex,
                                        a.centerJustifiedTextSymbolIndex,
                                        a.leftJustifiedTextSymbolIndex
                                    ].forEach(function(t1, r, n) {
                                        t1 >= 0 && n.indexOf(t1) === r && e1.addIndicesForPlacedSymbol(e1.text, t1);
                                    }), a.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, a.verticalPlacedTextSymbolIndex), a.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, a.placedIconSymbolIndex), a.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, a.verticalPlacedIconSymbolIndex);
                                }
                                this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                            }
                        }, Nn("SymbolBucket", Mc, {
                            omit: [
                                "layers",
                                "collisionBoxArray",
                                "features",
                                "compareText"
                            ]
                        }), Mc.MAX_GLYPHS = 65535, Mc.addDynamicAttributes = wc;
                        var Sc = new Si({
                            "symbol-placement": new wi(Lt.layout_symbol["symbol-placement"]),
                            "symbol-spacing": new wi(Lt.layout_symbol["symbol-spacing"]),
                            "symbol-avoid-edges": new wi(Lt.layout_symbol["symbol-avoid-edges"]),
                            "symbol-sort-key": new Ti(Lt.layout_symbol["symbol-sort-key"]),
                            "symbol-z-order": new wi(Lt.layout_symbol["symbol-z-order"]),
                            "icon-allow-overlap": new wi(Lt.layout_symbol["icon-allow-overlap"]),
                            "icon-ignore-placement": new wi(Lt.layout_symbol["icon-ignore-placement"]),
                            "icon-optional": new wi(Lt.layout_symbol["icon-optional"]),
                            "icon-rotation-alignment": new wi(Lt.layout_symbol["icon-rotation-alignment"]),
                            "icon-size": new Ti(Lt.layout_symbol["icon-size"]),
                            "icon-text-fit": new wi(Lt.layout_symbol["icon-text-fit"]),
                            "icon-text-fit-padding": new wi(Lt.layout_symbol["icon-text-fit-padding"]),
                            "icon-image": new Ti(Lt.layout_symbol["icon-image"]),
                            "icon-rotate": new Ti(Lt.layout_symbol["icon-rotate"]),
                            "icon-padding": new wi(Lt.layout_symbol["icon-padding"]),
                            "icon-keep-upright": new wi(Lt.layout_symbol["icon-keep-upright"]),
                            "icon-offset": new Ti(Lt.layout_symbol["icon-offset"]),
                            "icon-anchor": new Ti(Lt.layout_symbol["icon-anchor"]),
                            "icon-pitch-alignment": new wi(Lt.layout_symbol["icon-pitch-alignment"]),
                            "text-pitch-alignment": new wi(Lt.layout_symbol["text-pitch-alignment"]),
                            "text-rotation-alignment": new wi(Lt.layout_symbol["text-rotation-alignment"]),
                            "text-field": new Ti(Lt.layout_symbol["text-field"]),
                            "text-font": new Ti(Lt.layout_symbol["text-font"]),
                            "text-size": new Ti(Lt.layout_symbol["text-size"]),
                            "text-max-width": new Ti(Lt.layout_symbol["text-max-width"]),
                            "text-line-height": new wi(Lt.layout_symbol["text-line-height"]),
                            "text-letter-spacing": new Ti(Lt.layout_symbol["text-letter-spacing"]),
                            "text-justify": new Ti(Lt.layout_symbol["text-justify"]),
                            "text-radial-offset": new Ti(Lt.layout_symbol["text-radial-offset"]),
                            "text-variable-anchor": new wi(Lt.layout_symbol["text-variable-anchor"]),
                            "text-anchor": new Ti(Lt.layout_symbol["text-anchor"]),
                            "text-max-angle": new wi(Lt.layout_symbol["text-max-angle"]),
                            "text-writing-mode": new wi(Lt.layout_symbol["text-writing-mode"]),
                            "text-rotate": new Ti(Lt.layout_symbol["text-rotate"]),
                            "text-padding": new wi(Lt.layout_symbol["text-padding"]),
                            "text-keep-upright": new wi(Lt.layout_symbol["text-keep-upright"]),
                            "text-transform": new Ti(Lt.layout_symbol["text-transform"]),
                            "text-offset": new Ti(Lt.layout_symbol["text-offset"]),
                            "text-allow-overlap": new wi(Lt.layout_symbol["text-allow-overlap"]),
                            "text-ignore-placement": new wi(Lt.layout_symbol["text-ignore-placement"]),
                            "text-optional": new wi(Lt.layout_symbol["text-optional"])
                        }), Ec = {
                            paint: new Si({
                                "icon-opacity": new Ti(Lt.paint_symbol["icon-opacity"]),
                                "icon-color": new Ti(Lt.paint_symbol["icon-color"]),
                                "icon-halo-color": new Ti(Lt.paint_symbol["icon-halo-color"]),
                                "icon-halo-width": new Ti(Lt.paint_symbol["icon-halo-width"]),
                                "icon-halo-blur": new Ti(Lt.paint_symbol["icon-halo-blur"]),
                                "icon-translate": new wi(Lt.paint_symbol["icon-translate"]),
                                "icon-translate-anchor": new wi(Lt.paint_symbol["icon-translate-anchor"]),
                                "text-opacity": new Ti(Lt.paint_symbol["text-opacity"]),
                                "text-color": new Ti(Lt.paint_symbol["text-color"], {
                                    runtimeType: Ut,
                                    getOverride: function(t1) {
                                        return t1.textColor;
                                    },
                                    hasOverride: function(t1) {
                                        return !!t1.textColor;
                                    }
                                }),
                                "text-halo-color": new Ti(Lt.paint_symbol["text-halo-color"]),
                                "text-halo-width": new Ti(Lt.paint_symbol["text-halo-width"]),
                                "text-halo-blur": new Ti(Lt.paint_symbol["text-halo-blur"]),
                                "text-translate": new wi(Lt.paint_symbol["text-translate"]),
                                "text-translate-anchor": new wi(Lt.paint_symbol["text-translate-anchor"])
                            }),
                            layout: Sc
                        }, Lc = function(t1) {
                            this.type = t1.property.overrides ? t1.property.overrides.runtimeType : Ft, this.defaultValue = t1;
                        };
                        Lc.prototype.evaluate = function(t1) {
                            if (t1.formattedSection) {
                                var e1 = this.defaultValue.property.overrides;
                                if (e1 && e1.hasOverride(t1.formattedSection)) return e1.getOverride(t1.formattedSection);
                            }
                            return t1.feature && t1.featureState ? this.defaultValue.evaluate(t1.feature, t1.featureState) : this.defaultValue.property.specification.default;
                        }, Lc.prototype.eachChild = function(t1) {
                            this.defaultValue.isConstant() || t1(this.defaultValue.value._styleExpression.expression);
                        }, Lc.prototype.outputDefined = function() {
                            return !1;
                        }, Lc.prototype.serialize = function() {
                            return null;
                        }, Nn("FormatSectionOverride", Lc, {
                            omit: [
                                "defaultValue"
                            ]
                        });
                        var Cc = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, Ec);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.recalculate = function(e1, r) {
                                if (t1.prototype.recalculate.call(this, e1, r), "auto" === this.layout.get("icon-rotation-alignment") && ("point" !== this.layout.get("symbol-placement") ? this.layout._values["icon-rotation-alignment"] = "map" : this.layout._values["icon-rotation-alignment"] = "viewport"), "auto" === this.layout.get("text-rotation-alignment") && ("point" !== this.layout.get("symbol-placement") ? this.layout._values["text-rotation-alignment"] = "map" : this.layout._values["text-rotation-alignment"] = "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                                    var n = this.layout.get("text-writing-mode");
                                    if (n) {
                                        for(var i = [], a = 0, o = n; a < o.length; a += 1){
                                            var s = o[a];
                                            i.indexOf(s) < 0 && i.push(s);
                                        }
                                        this.layout._values["text-writing-mode"] = i;
                                    } else this.layout._values["text-writing-mode"] = [
                                        "horizontal"
                                    ];
                                }
                                this._setPaintOverrides();
                            }, e1.prototype.getValueAndResolveTokens = function(t1, e1, r, n) {
                                var i = this.layout.get(t1).evaluate(e1, {}, r, n), a = this._unevaluatedLayout._values[t1];
                                return a.isDataDriven() || Yr(a.value) || !i ? i : function(t1, e1) {
                                    return e1.replace(/{([^{}]+)}/g, function(e1, r) {
                                        return r in t1 ? String(t1[r]) : "";
                                    });
                                }(e1.properties, i);
                            }, e1.prototype.createBucket = function(t1) {
                                return new Mc(t1);
                            }, e1.prototype.queryRadius = function() {
                                return 0;
                            }, e1.prototype.queryIntersectsFeature = function() {
                                return !1;
                            }, e1.prototype._setPaintOverrides = function() {
                                for(var t1 = 0, r = Ec.paint.overridableProperties; t1 < r.length; t1 += 1){
                                    var n = r[t1];
                                    if (e1.hasPaintOverride(this.layout, n)) {
                                        var i = this.paint.get(n), a = new Lc(i), o = new Gr(a, i.property.specification), s = null;
                                        s = "constant" === i.value.kind || "source" === i.value.kind ? new Xr("source", o) : new Zr("composite", o, i.value.zoomStops, i.value._interpolationType), this.paint._values[n] = new bi(i.property, s, i.parameters);
                                    }
                                }
                            }, e1.prototype._handleOverridablePaintPropertyUpdate = function(t1, r, n) {
                                return !(!this.layout || r.isDataDriven() || n.isDataDriven()) && e1.hasPaintOverride(this.layout, t1);
                            }, e1.hasPaintOverride = function(t1, e1) {
                                var r = t1.get("text-field"), n = Ec.paint.properties[e1], i = !1, a = function(t1) {
                                    for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                                        var a = r[e1];
                                        if (n.overrides && n.overrides.hasOverride(a)) return void (i = !0);
                                    }
                                };
                                if ("constant" === r.value.kind && r.value.value instanceof ne) a(r.value.value.sections);
                                else if ("source" === r.value.kind) {
                                    var o = function(t1) {
                                        if (!i) {
                                            if (t1 instanceof ce && se(t1.value) === Gt) {
                                                var e1 = t1.value;
                                                a(e1.sections);
                                            } else t1 instanceof pe ? a(t1.sections) : t1.eachChild(o);
                                        }
                                    }, s = r.value;
                                    s._styleExpression && o(s._styleExpression.expression);
                                }
                                return i;
                            }, e1;
                        }(Ei), Pc = {
                            paint: new Si({
                                "background-color": new wi(Lt.paint_background["background-color"]),
                                "background-pattern": new Ai(Lt.paint_background["background-pattern"]),
                                "background-opacity": new wi(Lt.paint_background["background-opacity"])
                            })
                        }, Ic = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, Pc);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1;
                        }(Ei), Oc = {
                            paint: new Si({
                                "raster-opacity": new wi(Lt.paint_raster["raster-opacity"]),
                                "raster-hue-rotate": new wi(Lt.paint_raster["raster-hue-rotate"]),
                                "raster-brightness-min": new wi(Lt.paint_raster["raster-brightness-min"]),
                                "raster-brightness-max": new wi(Lt.paint_raster["raster-brightness-max"]),
                                "raster-saturation": new wi(Lt.paint_raster["raster-saturation"]),
                                "raster-contrast": new wi(Lt.paint_raster["raster-contrast"]),
                                "raster-resampling": new wi(Lt.paint_raster["raster-resampling"]),
                                "raster-fade-duration": new wi(Lt.paint_raster["raster-fade-duration"])
                            })
                        }, zc = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, Oc);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1;
                        }(Ei);
                        var Dc = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1, {}), this.implementation = e1;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.is3D = function() {
                                return "3d" === this.implementation.renderingMode;
                            }, e1.prototype.hasOffscreenPass = function() {
                                return void 0 !== this.implementation.prerender;
                            }, e1.prototype.recalculate = function() {}, e1.prototype.updateTransitions = function() {}, e1.prototype.hasTransition = function() {}, e1.prototype.serialize = function() {}, e1.prototype.onAdd = function(t1) {
                                this.implementation.onAdd && this.implementation.onAdd(t1, t1.painter.context.gl);
                            }, e1.prototype.onRemove = function(t1) {
                                this.implementation.onRemove && this.implementation.onRemove(t1, t1.painter.context.gl);
                            }, e1;
                        }(Ei), Rc = {
                            circle: _o,
                            heatmap: Po,
                            hillshade: Oo,
                            fill: xs,
                            "fill-extrusion": Fs,
                            line: Xs,
                            symbol: Cc,
                            background: Ic,
                            raster: zc
                        };
                        var Fc = self.HTMLImageElement, Bc = self.HTMLCanvasElement, Nc = self.HTMLVideoElement, jc = self.ImageData, Uc = self.ImageBitmap, Vc = function(t1, e1, r, n) {
                            this.context = t1, this.format = r, this.texture = t1.gl.createTexture(), this.update(e1, n);
                        };
                        Vc.prototype.update = function(t1, e1, r) {
                            var n = t1.width, i = t1.height, a = !(this.size && this.size[0] === n && this.size[1] === i || r), o = this.context, s = o.gl;
                            if (this.useMipmap = Boolean(e1 && e1.useMipmap), s.bindTexture(s.TEXTURE_2D, this.texture), o.pixelStoreUnpackFlipY.set(!1), o.pixelStoreUnpack.set(1), o.pixelStoreUnpackPremultiplyAlpha.set(this.format === s.RGBA && (!e1 || !1 !== e1.premultiply)), a) this.size = [
                                n,
                                i
                            ], t1 instanceof Fc || t1 instanceof Bc || t1 instanceof Nc || t1 instanceof jc || Uc && t1 instanceof Uc ? s.texImage2D(s.TEXTURE_2D, 0, this.format, this.format, s.UNSIGNED_BYTE, t1) : s.texImage2D(s.TEXTURE_2D, 0, this.format, n, i, 0, this.format, s.UNSIGNED_BYTE, t1.data);
                            else {
                                var l = r || {
                                    x: 0,
                                    y: 0
                                }, c = l.x, u = l.y;
                                t1 instanceof Fc || t1 instanceof Bc || t1 instanceof Nc || t1 instanceof jc || Uc && t1 instanceof Uc ? s.texSubImage2D(s.TEXTURE_2D, 0, c, u, s.RGBA, s.UNSIGNED_BYTE, t1) : s.texSubImage2D(s.TEXTURE_2D, 0, c, u, n, i, s.RGBA, s.UNSIGNED_BYTE, t1.data);
                            }
                            this.useMipmap && this.isSizePowerOfTwo() && s.generateMipmap(s.TEXTURE_2D);
                        }, Vc.prototype.bind = function(t1, e1, r) {
                            var n = this.context.gl;
                            n.bindTexture(n.TEXTURE_2D, this.texture), r !== n.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (r = n.LINEAR), t1 !== this.filter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, r || t1), this.filter = t1), e1 !== this.wrap && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, e1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, e1), this.wrap = e1);
                        }, Vc.prototype.isSizePowerOfTwo = function() {
                            return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
                        }, Vc.prototype.destroy = function() {
                            this.context.gl.deleteTexture(this.texture), this.texture = null;
                        };
                        var Hc = function(t1) {
                            var e1 = this;
                            this._callback = t1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = function() {
                                e1._triggered = !1, e1._callback();
                            });
                        };
                        Hc.prototype.trigger = function() {
                            var t1 = this;
                            this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(function() {
                                t1._triggered = !1, t1._callback();
                            }, 0));
                        }, Hc.prototype.remove = function() {
                            delete this._channel, this._callback = function() {};
                        };
                        var qc = function(t1, e1, r) {
                            this.target = t1, this.parent = e1, this.mapId = r, this.callbacks = {}, this.tasks = {}, this.taskQueue = [], this.cancelCallbacks = {}, m([
                                "receive",
                                "process"
                            ], this), this.invoker = new Hc(this.process), this.target.addEventListener("message", this.receive, !1), this.globalScope = k() ? t1 : self;
                        };
                        function Gc(t1, e1, r) {
                            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
                            return [
                                t1 * n - 2 * Math.PI * 6378137 / 2,
                                e1 * n - 2 * Math.PI * 6378137 / 2
                            ];
                        }
                        qc.prototype.send = function(t1, e1, r, n, i) {
                            var a = this;
                            void 0 === i && (i = !1);
                            var o = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                            r && (this.callbacks[o] = r);
                            var s = S(this.globalScope) ? void 0 : [];
                            return this.target.postMessage({
                                id: o,
                                type: t1,
                                hasCallback: !!r,
                                targetMapId: n,
                                mustQueue: i,
                                sourceMapId: this.mapId,
                                data: Hn(e1, s)
                            }, s), {
                                cancel: function() {
                                    r && delete a.callbacks[o], a.target.postMessage({
                                        id: o,
                                        type: "<cancel>",
                                        targetMapId: n,
                                        sourceMapId: a.mapId
                                    });
                                }
                            };
                        }, qc.prototype.receive = function(t1) {
                            var e1 = t1.data, r = e1.id;
                            if (r && (!e1.targetMapId || this.mapId === e1.targetMapId)) {
                                if ("<cancel>" === e1.type) {
                                    delete this.tasks[r];
                                    var n = this.cancelCallbacks[r];
                                    delete this.cancelCallbacks[r], n && n();
                                } else k() || e1.mustQueue ? (this.tasks[r] = e1, this.taskQueue.push(r), this.invoker.trigger()) : this.processTask(r, e1);
                            }
                        }, qc.prototype.process = function() {
                            if (this.taskQueue.length) {
                                var t1 = this.taskQueue.shift(), e1 = this.tasks[t1];
                                delete this.tasks[t1], this.taskQueue.length && this.invoker.trigger(), e1 && this.processTask(t1, e1);
                            }
                        }, qc.prototype.processTask = function(t1, e1) {
                            var r = this;
                            if ("<response>" === e1.type) {
                                var n = this.callbacks[t1];
                                delete this.callbacks[t1], n && (e1.error ? n(qn(e1.error)) : n(null, qn(e1.data)));
                            } else {
                                var i = !1, a = S(this.globalScope) ? void 0 : [], o = e1.hasCallback ? function(e1, n) {
                                    i = !0, delete r.cancelCallbacks[t1], r.target.postMessage({
                                        id: t1,
                                        type: "<response>",
                                        sourceMapId: r.mapId,
                                        error: e1 ? Hn(e1) : null,
                                        data: Hn(n, a)
                                    }, a);
                                } : function(t1) {
                                    i = !0;
                                }, s = null, l = qn(e1.data);
                                if (this.parent[e1.type]) s = this.parent[e1.type](e1.sourceMapId, l, o);
                                else if (this.parent.getWorkerSource) {
                                    var c = e1.type.split(".");
                                    s = this.parent.getWorkerSource(e1.sourceMapId, c[0], l.source)[c[1]](l, o);
                                } else o(new Error("Could not find function " + e1.type));
                                !i && s && s.cancel && (this.cancelCallbacks[t1] = s.cancel);
                            }
                        }, qc.prototype.remove = function() {
                            this.invoker.remove(), this.target.removeEventListener("message", this.receive, !1);
                        };
                        var Yc = function(t1, e1) {
                            t1 && (e1 ? this.setSouthWest(t1).setNorthEast(e1) : 4 === t1.length ? this.setSouthWest([
                                t1[0],
                                t1[1]
                            ]).setNorthEast([
                                t1[2],
                                t1[3]
                            ]) : this.setSouthWest(t1[0]).setNorthEast(t1[1]));
                        };
                        Yc.prototype.setNorthEast = function(t1) {
                            return this._ne = t1 instanceof Wc ? new Wc(t1.lng, t1.lat) : Wc.convert(t1), this;
                        }, Yc.prototype.setSouthWest = function(t1) {
                            return this._sw = t1 instanceof Wc ? new Wc(t1.lng, t1.lat) : Wc.convert(t1), this;
                        }, Yc.prototype.extend = function(t1) {
                            var e1, r, n = this._sw, i = this._ne;
                            if (t1 instanceof Wc) e1 = t1, r = t1;
                            else {
                                if (!(t1 instanceof Yc)) {
                                    if (Array.isArray(t1)) {
                                        if (4 === t1.length || t1.every(Array.isArray)) {
                                            var a = t1;
                                            return this.extend(Yc.convert(a));
                                        }
                                        var o = t1;
                                        return this.extend(Wc.convert(o));
                                    }
                                    return this;
                                }
                                if (e1 = t1._sw, r = t1._ne, !e1 || !r) return this;
                            }
                            return n || i ? (n.lng = Math.min(e1.lng, n.lng), n.lat = Math.min(e1.lat, n.lat), i.lng = Math.max(r.lng, i.lng), i.lat = Math.max(r.lat, i.lat)) : (this._sw = new Wc(e1.lng, e1.lat), this._ne = new Wc(r.lng, r.lat)), this;
                        }, Yc.prototype.getCenter = function() {
                            return new Wc((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
                        }, Yc.prototype.getSouthWest = function() {
                            return this._sw;
                        }, Yc.prototype.getNorthEast = function() {
                            return this._ne;
                        }, Yc.prototype.getNorthWest = function() {
                            return new Wc(this.getWest(), this.getNorth());
                        }, Yc.prototype.getSouthEast = function() {
                            return new Wc(this.getEast(), this.getSouth());
                        }, Yc.prototype.getWest = function() {
                            return this._sw.lng;
                        }, Yc.prototype.getSouth = function() {
                            return this._sw.lat;
                        }, Yc.prototype.getEast = function() {
                            return this._ne.lng;
                        }, Yc.prototype.getNorth = function() {
                            return this._ne.lat;
                        }, Yc.prototype.toArray = function() {
                            return [
                                this._sw.toArray(),
                                this._ne.toArray()
                            ];
                        }, Yc.prototype.toString = function() {
                            return "LngLatBounds(" + this._sw.toString() + ", " + this._ne.toString() + ")";
                        }, Yc.prototype.isEmpty = function() {
                            return !(this._sw && this._ne);
                        }, Yc.prototype.contains = function(t1) {
                            var e1 = Wc.convert(t1), r = e1.lng, n = e1.lat, i = this._sw.lat <= n && n <= this._ne.lat, a = this._sw.lng <= r && r <= this._ne.lng;
                            return this._sw.lng > this._ne.lng && (a = this._sw.lng >= r && r >= this._ne.lng), i && a;
                        }, Yc.convert = function(t1) {
                            return !t1 || t1 instanceof Yc ? t1 : new Yc(t1);
                        };
                        var Wc = function(t1, e1) {
                            if (isNaN(t1) || isNaN(e1)) throw new Error("Invalid LngLat object: (" + t1 + ", " + e1 + ")");
                            if (this.lng = +t1, this.lat = +e1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
                        };
                        Wc.prototype.wrap = function() {
                            return new Wc(c(this.lng, -180, 180), this.lat);
                        }, Wc.prototype.toArray = function() {
                            return [
                                this.lng,
                                this.lat
                            ];
                        }, Wc.prototype.toString = function() {
                            return "LngLat(" + this.lng + ", " + this.lat + ")";
                        }, Wc.prototype.distanceTo = function(t1) {
                            var e1 = Math.PI / 180, r = this.lat * e1, n = t1.lat * e1, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t1.lng - this.lng) * e1);
                            return 6371008.8 * Math.acos(Math.min(i, 1));
                        }, Wc.prototype.toBounds = function(t1) {
                            void 0 === t1 && (t1 = 0);
                            var e1 = 360 * t1 / 40075017, r = e1 / Math.cos(Math.PI / 180 * this.lat);
                            return new Yc(new Wc(this.lng - r, this.lat - e1), new Wc(this.lng + r, this.lat + e1));
                        }, Wc.convert = function(t1) {
                            if (t1 instanceof Wc) return t1;
                            if (Array.isArray(t1) && (2 === t1.length || 3 === t1.length)) return new Wc(Number(t1[0]), Number(t1[1]));
                            if (!Array.isArray(t1) && "object" == typeof t1 && null !== t1) return new Wc(Number("lng" in t1 ? t1.lng : t1.lon), Number(t1.lat));
                            throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
                        };
                        var Xc = 2 * Math.PI * 6371008.8;
                        function Zc(t1) {
                            return Xc * Math.cos(t1 * Math.PI / 180);
                        }
                        function Jc(t1) {
                            return (180 + t1) / 360;
                        }
                        function Kc(t1) {
                            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1 * Math.PI / 360))) / 360;
                        }
                        function Qc(t1, e1) {
                            return t1 / Zc(e1);
                        }
                        function $c(t1) {
                            var e1 = 180 - 360 * t1;
                            return 360 / Math.PI * Math.atan(Math.exp(e1 * Math.PI / 180)) - 90;
                        }
                        var tu = function(t1, e1, r) {
                            void 0 === r && (r = 0), this.x = +t1, this.y = +e1, this.z = +r;
                        };
                        tu.fromLngLat = function(t1, e1) {
                            void 0 === e1 && (e1 = 0);
                            var r = Wc.convert(t1);
                            return new tu(Jc(r.lng), Kc(r.lat), Qc(e1, r.lat));
                        }, tu.prototype.toLngLat = function() {
                            return new Wc(360 * this.x - 180, $c(this.y));
                        }, tu.prototype.toAltitude = function() {
                            var t1, e1;
                            return t1 = this.z, e1 = this.y, t1 * Zc($c(e1));
                        }, tu.prototype.meterInMercatorCoordinateUnits = function() {
                            var t1;
                            return 1 / Xc * (t1 = $c(this.y), 1 / Math.cos(t1 * Math.PI / 180));
                        };
                        var eu = function(t1, e1, r) {
                            this.z = t1, this.x = e1, this.y = r, this.key = iu(0, t1, t1, e1, r);
                        };
                        eu.prototype.equals = function(t1) {
                            return this.z === t1.z && this.x === t1.x && this.y === t1.y;
                        }, eu.prototype.url = function(t1, e1) {
                            var r, n, i, a, o, s = (r = this.x, n = this.y, i = this.z, a = Gc(256 * r, 256 * (n = Math.pow(2, i) - n - 1), i), o = Gc(256 * (r + 1), 256 * (n + 1), i), a[0] + "," + a[1] + "," + o[0] + "," + o[1]), l = function(t1, e1, r) {
                                for(var n, i = "", a = t1; a > 0; a--)i += (e1 & (n = 1 << a - 1) ? 1 : 0) + (r & n ? 2 : 0);
                                return i;
                            }(this.z, this.x, this.y);
                            return t1[(this.x + this.y) % t1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace("{z}", String(this.z)).replace("{x}", String(this.x)).replace("{y}", String("tms" === e1 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", l).replace("{bbox-epsg-3857}", s);
                        }, eu.prototype.getTilePoint = function(t1) {
                            var e1 = Math.pow(2, this.z);
                            return new i(8192 * (t1.x * e1 - this.x), 8192 * (t1.y * e1 - this.y));
                        }, eu.prototype.toString = function() {
                            return this.z + "/" + this.x + "/" + this.y;
                        };
                        var ru = function(t1, e1) {
                            this.wrap = t1, this.canonical = e1, this.key = iu(t1, e1.z, e1.z, e1.x, e1.y);
                        }, nu = function(t1, e1, r, n, i) {
                            this.overscaledZ = t1, this.wrap = e1, this.canonical = new eu(r, +n, +i), this.key = iu(e1, t1, r, n, i);
                        };
                        function iu(t1, e1, r, n, i) {
                            (t1 *= 2) < 0 && (t1 = -1 * t1 - 1);
                            var a = 1 << r;
                            return (a * a * t1 + a * i + n).toString(36) + r.toString(36) + e1.toString(36);
                        }
                        nu.prototype.equals = function(t1) {
                            return this.overscaledZ === t1.overscaledZ && this.wrap === t1.wrap && this.canonical.equals(t1.canonical);
                        }, nu.prototype.scaledTo = function(t1) {
                            var e1 = this.canonical.z - t1;
                            return t1 > this.canonical.z ? new nu(t1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new nu(t1, this.wrap, t1, this.canonical.x >> e1, this.canonical.y >> e1);
                        }, nu.prototype.calculateScaledKey = function(t1, e1) {
                            var r = this.canonical.z - t1;
                            return t1 > this.canonical.z ? iu(this.wrap * +e1, t1, this.canonical.z, this.canonical.x, this.canonical.y) : iu(this.wrap * +e1, t1, t1, this.canonical.x >> r, this.canonical.y >> r);
                        }, nu.prototype.isChildOf = function(t1) {
                            if (t1.wrap !== this.wrap) return !1;
                            var e1 = this.canonical.z - t1.canonical.z;
                            return 0 === t1.overscaledZ || t1.overscaledZ < this.overscaledZ && t1.canonical.x === this.canonical.x >> e1 && t1.canonical.y === this.canonical.y >> e1;
                        }, nu.prototype.children = function(t1) {
                            if (this.overscaledZ >= t1) return [
                                new nu(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                            ];
                            var e1 = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                            return [
                                new nu(e1, this.wrap, e1, r, n),
                                new nu(e1, this.wrap, e1, r + 1, n),
                                new nu(e1, this.wrap, e1, r, n + 1),
                                new nu(e1, this.wrap, e1, r + 1, n + 1)
                            ];
                        }, nu.prototype.isLessThan = function(t1) {
                            return this.wrap < t1.wrap || !(this.wrap > t1.wrap) && (this.overscaledZ < t1.overscaledZ || !(this.overscaledZ > t1.overscaledZ) && (this.canonical.x < t1.canonical.x || !(this.canonical.x > t1.canonical.x) && this.canonical.y < t1.canonical.y));
                        }, nu.prototype.wrapped = function() {
                            return new nu(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
                        }, nu.prototype.unwrapTo = function(t1) {
                            return new nu(this.overscaledZ, t1, this.canonical.z, this.canonical.x, this.canonical.y);
                        }, nu.prototype.overscaleFactor = function() {
                            return Math.pow(2, this.overscaledZ - this.canonical.z);
                        }, nu.prototype.toUnwrapped = function() {
                            return new ru(this.wrap, this.canonical);
                        }, nu.prototype.toString = function() {
                            return this.overscaledZ + "/" + this.canonical.x + "/" + this.canonical.y;
                        }, nu.prototype.getTilePoint = function(t1) {
                            return this.canonical.getTilePoint(new tu(t1.x - this.wrap, t1.y));
                        }, Nn("CanonicalTileID", eu), Nn("OverscaledTileID", nu, {
                            omit: [
                                "posMatrix"
                            ]
                        });
                        var au = function(t1, e1, r) {
                            if (this.uid = t1, e1.height !== e1.width) throw new RangeError("DEM tiles must be square");
                            if (r && "mapbox" !== r && "terrarium" !== r) return _('"' + r + '" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');
                            this.stride = e1.height;
                            var n = this.dim = e1.height - 2;
                            this.data = new Uint32Array(e1.data.buffer), this.encoding = r || "mapbox";
                            for(var i = 0; i < n; i++)this.data[this._idx(-1, i)] = this.data[this._idx(0, i)], this.data[this._idx(n, i)] = this.data[this._idx(n - 1, i)], this.data[this._idx(i, -1)] = this.data[this._idx(i, 0)], this.data[this._idx(i, n)] = this.data[this._idx(i, n - 1)];
                            this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(n, -1)] = this.data[this._idx(n - 1, 0)], this.data[this._idx(-1, n)] = this.data[this._idx(0, n - 1)], this.data[this._idx(n, n)] = this.data[this._idx(n - 1, n - 1)];
                        };
                        au.prototype.get = function(t1, e1) {
                            var r = new Uint8Array(this.data.buffer), n = 4 * this._idx(t1, e1);
                            return ("terrarium" === this.encoding ? this._unpackTerrarium : this._unpackMapbox)(r[n], r[n + 1], r[n + 2]);
                        }, au.prototype.getUnpackVector = function() {
                            return "terrarium" === this.encoding ? [
                                256,
                                1,
                                1 / 256,
                                32768
                            ] : [
                                6553.6,
                                25.6,
                                .1,
                                1e4
                            ];
                        }, au.prototype._idx = function(t1, e1) {
                            if (t1 < -1 || t1 >= this.dim + 1 || e1 < -1 || e1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                            return (e1 + 1) * this.stride + (t1 + 1);
                        }, au.prototype._unpackMapbox = function(t1, e1, r) {
                            return (256 * t1 * 256 + 256 * e1 + r) / 10 - 1e4;
                        }, au.prototype._unpackTerrarium = function(t1, e1, r) {
                            return 256 * t1 + e1 + r / 256 - 32768;
                        }, au.prototype.getPixels = function() {
                            return new Eo({
                                width: this.stride,
                                height: this.stride
                            }, new Uint8Array(this.data.buffer));
                        }, au.prototype.backfillBorder = function(t1, e1, r) {
                            if (this.dim !== t1.dim) throw new Error("dem dimension mismatch");
                            var n = e1 * this.dim, i = e1 * this.dim + this.dim, a = r * this.dim, o = r * this.dim + this.dim;
                            switch(e1){
                                case -1:
                                    n = i - 1;
                                    break;
                                case 1:
                                    i = n + 1;
                            }
                            switch(r){
                                case -1:
                                    a = o - 1;
                                    break;
                                case 1:
                                    o = a + 1;
                            }
                            for(var s = -e1 * this.dim, l = -r * this.dim, c = a; c < o; c++)for(var u = n; u < i; u++)this.data[this._idx(u, c)] = t1.data[this._idx(u + s, c + l)];
                        }, Nn("DEMData", au);
                        var ou = function(t1) {
                            this._stringToNumber = {}, this._numberToString = [];
                            for(var e1 = 0; e1 < t1.length; e1++){
                                var r = t1[e1];
                                this._stringToNumber[r] = e1, this._numberToString[e1] = r;
                            }
                        };
                        ou.prototype.encode = function(t1) {
                            return this._stringToNumber[t1];
                        }, ou.prototype.decode = function(t1) {
                            return this._numberToString[t1];
                        };
                        var su = function(t1, e1, r, n, i) {
                            this.type = "Feature", this._vectorTileFeature = t1, t1._z = e1, t1._x = r, t1._y = n, this.properties = t1.properties, this.id = i;
                        }, lu = {
                            geometry: {
                                configurable: !0
                            }
                        };
                        lu.geometry.get = function() {
                            return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
                        }, lu.geometry.set = function(t1) {
                            this._geometry = t1;
                        }, su.prototype.toJSON = function() {
                            var t1 = {
                                geometry: this.geometry
                            };
                            for(var e1 in this)"_geometry" !== e1 && "_vectorTileFeature" !== e1 && (t1[e1] = this[e1]);
                            return t1;
                        }, Object.defineProperties(su.prototype, lu);
                        var cu = function() {
                            this.state = {}, this.stateChanges = {}, this.deletedStates = {};
                        };
                        cu.prototype.updateState = function(t1, e1, r) {
                            var n = String(e1);
                            if (this.stateChanges[t1] = this.stateChanges[t1] || {}, this.stateChanges[t1][n] = this.stateChanges[t1][n] || {}, u(this.stateChanges[t1][n], r), null === this.deletedStates[t1]) for(var i in this.deletedStates[t1] = {}, this.state[t1])i !== n && (this.deletedStates[t1][i] = null);
                            else if (this.deletedStates[t1] && null === this.deletedStates[t1][n]) for(var a in this.deletedStates[t1][n] = {}, this.state[t1][n])r[a] || (this.deletedStates[t1][n][a] = null);
                            else for(var o in r)this.deletedStates[t1] && this.deletedStates[t1][n] && null === this.deletedStates[t1][n][o] && delete this.deletedStates[t1][n][o];
                        }, cu.prototype.removeFeatureState = function(t1, e1, r) {
                            if (!(null === this.deletedStates[t1])) {
                                var n = String(e1);
                                if (this.deletedStates[t1] = this.deletedStates[t1] || {}, r && void 0 !== e1) null !== this.deletedStates[t1][n] && (this.deletedStates[t1][n] = this.deletedStates[t1][n] || {}, this.deletedStates[t1][n][r] = null);
                                else if (void 0 !== e1) {
                                    if (this.stateChanges[t1] && this.stateChanges[t1][n]) for(r in this.deletedStates[t1][n] = {}, this.stateChanges[t1][n])this.deletedStates[t1][n][r] = null;
                                    else this.deletedStates[t1][n] = null;
                                } else this.deletedStates[t1] = null;
                            }
                        }, cu.prototype.getState = function(t1, e1) {
                            var r = String(e1), n = this.state[t1] || {}, i = this.stateChanges[t1] || {}, a = u({}, n[r], i[r]);
                            if (null === this.deletedStates[t1]) return {};
                            if (this.deletedStates[t1]) {
                                var o = this.deletedStates[t1][e1];
                                if (null === o) return {};
                                for(var s in o)delete a[s];
                            }
                            return a;
                        }, cu.prototype.initializeTileState = function(t1, e1) {
                            t1.setFeatureState(this.state, e1);
                        }, cu.prototype.coalesceChanges = function(t1, e1) {
                            var r = {};
                            for(var n in this.stateChanges){
                                this.state[n] = this.state[n] || {};
                                var i = {};
                                for(var a in this.stateChanges[n])this.state[n][a] || (this.state[n][a] = {}), u(this.state[n][a], this.stateChanges[n][a]), i[a] = this.state[n][a];
                                r[n] = i;
                            }
                            for(var o in this.deletedStates){
                                this.state[o] = this.state[o] || {};
                                var s = {};
                                if (null === this.deletedStates[o]) for(var l in this.state[o])s[l] = {}, this.state[o][l] = {};
                                else for(var c in this.deletedStates[o]){
                                    if (null === this.deletedStates[o][c]) this.state[o][c] = {};
                                    else for(var f = 0, h = Object.keys(this.deletedStates[o][c]); f < h.length; f += 1){
                                        var p = h[f];
                                        delete this.state[o][c][p];
                                    }
                                    s[c] = this.state[o][c];
                                }
                                r[o] = r[o] || {}, u(r[o], s);
                            }
                            if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(r).length) for(var d in t1)t1[d].setFeatureState(r, e1);
                        };
                        var uu = function(t1, e1) {
                            this.tileID = t1, this.x = t1.canonical.x, this.y = t1.canonical.y, this.z = t1.canonical.z, this.grid = new zn(8192, 16, 0), this.grid3D = new zn(8192, 16, 0), this.featureIndexArray = new fa, this.promoteId = e1;
                        };
                        function fu(t1, e1, r, n, i) {
                            return v(t1, function(t1, a) {
                                var o = e1 instanceof _i ? e1.get(a) : null;
                                return o && o.evaluate ? o.evaluate(r, n, i) : o;
                            });
                        }
                        function hu(t1) {
                            for(var e1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0, a = 0, o = t1; a < o.length; a += 1){
                                var s = o[a];
                                e1 = Math.min(e1, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
                            }
                            return {
                                minX: e1,
                                minY: r,
                                maxX: n,
                                maxY: i
                            };
                        }
                        function pu(t1, e1) {
                            return e1 - t1;
                        }
                        uu.prototype.insert = function(t1, e1, r, n, i, a) {
                            var o = this.featureIndexArray.length;
                            this.featureIndexArray.emplaceBack(r, n, i);
                            for(var s = a ? this.grid3D : this.grid, l = 0; l < e1.length; l++){
                                for(var c = e1[l], u = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ], f = 0; f < c.length; f++){
                                    var h = c[f];
                                    u[0] = Math.min(u[0], h.x), u[1] = Math.min(u[1], h.y), u[2] = Math.max(u[2], h.x), u[3] = Math.max(u[3], h.y);
                                }
                                u[0] < 8192 && u[1] < 8192 && u[2] >= 0 && u[3] >= 0 && s.insert(o, u[0], u[1], u[2], u[3]);
                            }
                        }, uu.prototype.loadVTLayers = function() {
                            return this.vtLayers || (this.vtLayers = new Ls.VectorTile(new al(this.rawTileData)).layers, this.sourceLayerCoder = new ou(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                                "_geojsonTileLayer"
                            ])), this.vtLayers;
                        }, uu.prototype.query = function(t1, e1, r, n) {
                            var a = this;
                            this.loadVTLayers();
                            for(var o = t1.params || {}, s = 8192 / t1.tileSize / t1.scale, l = sn(o.filter), c = t1.queryGeometry, u = t1.queryPadding * s, f = hu(c), h = this.grid.query(f.minX - u, f.minY - u, f.maxX + u, f.maxY + u), p = hu(t1.cameraQueryGeometry), d = this.grid3D.query(p.minX - u, p.minY - u, p.maxX + u, p.maxY + u, function(e1, r, n, a) {
                                return function(t1, e1, r, n, a) {
                                    for(var o = 0, s = t1; o < s.length; o += 1){
                                        var l = s[o];
                                        if (e1 <= l.x && r <= l.y && n >= l.x && a >= l.y) return !0;
                                    }
                                    var c = [
                                        new i(e1, r),
                                        new i(e1, a),
                                        new i(n, a),
                                        new i(n, r)
                                    ];
                                    if (t1.length > 2) for(var u = 0, f = c; u < f.length; u += 1){
                                        if (io(t1, f[u])) return !0;
                                    }
                                    for(var h = 0; h < t1.length - 1; h++){
                                        if (ao(t1[h], t1[h + 1], c)) return !0;
                                    }
                                    return !1;
                                }(t1.cameraQueryGeometry, e1 - u, r - u, n + u, a + u);
                            }), m = 0, g = d; m < g.length; m += 1){
                                var v = g[m];
                                h.push(v);
                            }
                            h.sort(pu);
                            for(var y, x = {}, b = function(i) {
                                var u = h[i];
                                if (u !== y) {
                                    y = u;
                                    var f = a.featureIndexArray.get(u), p = null;
                                    a.loadMatchingFeature(x, f.bucketIndex, f.sourceLayerIndex, f.featureIndex, l, o.layers, o.availableImages, e1, r, n, function(e1, r, n) {
                                        return p || (p = Ya(e1)), r.queryIntersectsFeature(c, e1, n, p, a.z, t1.transform, s, t1.pixelPosMatrix);
                                    });
                                }
                            }, _ = 0; _ < h.length; _++)b(_);
                            return x;
                        }, uu.prototype.loadMatchingFeature = function(t1, e1, r, n, i, a, o, s, l, c, u) {
                            var f = this.bucketLayerIDs[e1];
                            if (!a || function(t1, e1) {
                                for(var r = 0; r < t1.length; r++)if (e1.indexOf(t1[r]) >= 0) return !0;
                                return !1;
                            }(a, f)) {
                                var h = this.sourceLayerCoder.decode(r), p = this.vtLayers[h].feature(n);
                                if (i.filter(new pi(this.tileID.overscaledZ), p)) for(var d = this.getId(p, h), m = 0; m < f.length; m++){
                                    var g = f[m];
                                    if (!(a && a.indexOf(g) < 0)) {
                                        var v = s[g];
                                        if (v) {
                                            var y = {};
                                            void 0 !== d && c && (y = c.getState(v.sourceLayer || "_geojsonTileLayer", d));
                                            var x = l[g];
                                            x.paint = fu(x.paint, v.paint, p, y, o), x.layout = fu(x.layout, v.layout, p, y, o);
                                            var b = !u || u(p, v, y);
                                            if (b) {
                                                var _ = new su(p, this.z, this.x, this.y, d);
                                                _.layer = x;
                                                var w = t1[g];
                                                void 0 === w && (w = t1[g] = []), w.push({
                                                    featureIndex: n,
                                                    feature: _,
                                                    intersectionZ: b
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }, uu.prototype.lookupSymbolFeatures = function(t1, e1, r, n, i, a, o, s) {
                            var l = {};
                            this.loadVTLayers();
                            for(var c = sn(i), u = 0, f = t1; u < f.length; u += 1){
                                var h = f[u];
                                this.loadMatchingFeature(l, r, n, h, c, a, o, s, e1);
                            }
                            return l;
                        }, uu.prototype.hasLayer = function(t1) {
                            for(var e1 = 0, r = this.bucketLayerIDs; e1 < r.length; e1 += 1)for(var n = 0, i = r[e1]; n < i.length; n += 1){
                                if (t1 === i[n]) return !0;
                            }
                            return !1;
                        }, uu.prototype.getId = function(t1, e1) {
                            var r = t1.id;
                            if (this.promoteId) {
                                var n = "string" == typeof this.promoteId ? this.promoteId : this.promoteId[e1];
                                "boolean" == typeof (r = t1.properties[n]) && (r = Number(r));
                            }
                            return r;
                        }, Nn("FeatureIndex", uu, {
                            omit: [
                                "rawTileData",
                                "sourceLayerCoder"
                            ]
                        });
                        var du = function(t1, e1) {
                            this.tileID = t1, this.uid = h(), this.uses = 0, this.tileSize = e1, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.expiredRequestCount = 0, this.state = "loading";
                        };
                        du.prototype.registerFadeDuration = function(t1) {
                            var e1 = t1 + this.timeAdded;
                            e1 < R.now() || this.fadeEndTime && e1 < this.fadeEndTime || (this.fadeEndTime = e1);
                        }, du.prototype.wasRequested = function() {
                            return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
                        }, du.prototype.loadVectorData = function(t1, e1, r) {
                            if (this.hasData() && this.unloadVectorData(), this.state = "loaded", t1) {
                                for(var n in t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = function(t1, e1) {
                                    var r = {};
                                    if (!e1) return r;
                                    for(var n = function() {
                                        var t1 = a[i], n = t1.layerIds.map(function(t1) {
                                            return e1.getLayer(t1);
                                        }).filter(Boolean);
                                        if (0 !== n.length) {
                                            t1.layers = n, t1.stateDependentLayerIds && (t1.stateDependentLayers = t1.stateDependentLayerIds.map(function(t1) {
                                                return n.filter(function(e1) {
                                                    return e1.id === t1;
                                                })[0];
                                            }));
                                            for(var o = 0, s = n; o < s.length; o += 1){
                                                var l = s[o];
                                                r[l.id] = t1;
                                            }
                                        }
                                    }, i = 0, a = t1; i < a.length; i += 1)n();
                                    return r;
                                }(t1.buckets, e1.style), this.hasSymbolBuckets = !1, this.buckets){
                                    var i = this.buckets[n];
                                    if (i instanceof Mc) {
                                        if (this.hasSymbolBuckets = !0, !r) break;
                                        i.justReloaded = !0;
                                    }
                                }
                                if (this.hasRTLText = !1, this.hasSymbolBuckets) for(var a in this.buckets){
                                    var o = this.buckets[a];
                                    if (o instanceof Mc && o.hasRTLText) {
                                        this.hasRTLText = !0, hi.isLoading() || hi.isLoaded() || "deferred" !== ui() || fi();
                                        break;
                                    }
                                }
                                for(var s in this.queryPadding = 0, this.buckets){
                                    var l = this.buckets[s];
                                    this.queryPadding = Math.max(this.queryPadding, e1.style.getLayer(s).queryRadius(l));
                                }
                                t1.imageAtlas && (this.imageAtlas = t1.imageAtlas), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage);
                            } else this.collisionBoxArray = new na;
                        }, du.prototype.unloadVectorData = function() {
                            for(var t1 in this.buckets)this.buckets[t1].destroy();
                            this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
                        }, du.prototype.getBucket = function(t1) {
                            return this.buckets[t1.id];
                        }, du.prototype.upload = function(t1) {
                            for(var e1 in this.buckets){
                                var r = this.buckets[e1];
                                r.uploadPending() && r.upload(t1);
                            }
                            var n = t1.gl;
                            this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new Vc(t1, this.imageAtlas.image, n.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new Vc(t1, this.glyphAtlasImage, n.ALPHA), this.glyphAtlasImage = null);
                        }, du.prototype.prepare = function(t1) {
                            this.imageAtlas && this.imageAtlas.patchUpdatedImages(t1, this.imageAtlasTexture);
                        }, du.prototype.queryRenderedFeatures = function(t1, e1, r, n, i, a, o, s, l, c) {
                            return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                                queryGeometry: n,
                                cameraQueryGeometry: i,
                                scale: a,
                                tileSize: this.tileSize,
                                pixelPosMatrix: c,
                                transform: s,
                                params: o,
                                queryPadding: this.queryPadding * l
                            }, t1, e1, r) : {};
                        }, du.prototype.querySourceFeatures = function(t1, e1) {
                            var r = this.latestFeatureIndex;
                            if (r && r.rawTileData) {
                                var n = r.loadVTLayers(), i = e1 ? e1.sourceLayer : "", a = n._geojsonTileLayer || n[i];
                                if (a) for(var o = sn(e1 && e1.filter), s = this.tileID.canonical, l = s.z, c = s.x, u = s.y, f = {
                                    z: l,
                                    x: c,
                                    y: u
                                }, h = 0; h < a.length; h++){
                                    var p = a.feature(h);
                                    if (o.filter(new pi(this.tileID.overscaledZ), p)) {
                                        var d = r.getId(p, i), m = new su(p, l, c, u, d);
                                        m.tile = f, t1.push(m);
                                    }
                                }
                            }
                        }, du.prototype.hasData = function() {
                            return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
                        }, du.prototype.patternsLoaded = function() {
                            return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
                        }, du.prototype.setExpiryData = function(t1) {
                            var e1 = this.expirationTime;
                            if (t1.cacheControl) {
                                var r = A(t1.cacheControl);
                                r["max-age"] && (this.expirationTime = Date.now() + 1e3 * r["max-age"]);
                            } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
                            if (this.expirationTime) {
                                var n = Date.now(), i = !1;
                                if (this.expirationTime > n) i = !1;
                                else if (e1) {
                                    if (this.expirationTime < e1) i = !0;
                                    else {
                                        var a = this.expirationTime - e1;
                                        a ? this.expirationTime = n + Math.max(a, 3e4) : i = !0;
                                    }
                                } else i = !0;
                                i ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                            }
                        }, du.prototype.getExpiryTimeout = function() {
                            if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
                        }, du.prototype.setFeatureState = function(t1, e1) {
                            if (this.latestFeatureIndex && this.latestFeatureIndex.rawTileData && 0 !== Object.keys(t1).length) {
                                var r = this.latestFeatureIndex.loadVTLayers();
                                for(var n in this.buckets)if (e1.style.hasLayer(n)) {
                                    var i = this.buckets[n], a = i.layers[0].sourceLayer || "_geojsonTileLayer", o = r[a], s = t1[a];
                                    if (o && s && 0 !== Object.keys(s).length) {
                                        i.update(s, o, this.imageAtlas && this.imageAtlas.patternPositions || {});
                                        var l = e1 && e1.style && e1.style.getLayer(n);
                                        l && (this.queryPadding = Math.max(this.queryPadding, l.queryRadius(i)));
                                    }
                                }
                            }
                        }, du.prototype.holdingForFade = function() {
                            return void 0 !== this.symbolFadeHoldUntil;
                        }, du.prototype.symbolFadeFinished = function() {
                            return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < R.now();
                        }, du.prototype.clearFadeHold = function() {
                            this.symbolFadeHoldUntil = void 0;
                        }, du.prototype.setHoldDuration = function(t1) {
                            this.symbolFadeHoldUntil = R.now() + t1;
                        }, du.prototype.setDependencies = function(t1, e1) {
                            for(var r = {}, n = 0, i = e1; n < i.length; n += 1)r[i[n]] = !0;
                            this.dependencies[t1] = r;
                        }, du.prototype.hasDependency = function(t1, e1) {
                            for(var r = 0, n = t1; r < n.length; r += 1){
                                var i = n[r], a = this.dependencies[i];
                                if (a) for(var o = 0, s = e1; o < s.length; o += 1){
                                    if (a[s[o]]) return !0;
                                }
                            }
                            return !1;
                        };
                        var mu = self.performance, gu = function(t1) {
                            this._marks = {
                                start: [
                                    t1.url,
                                    "start"
                                ].join("#"),
                                end: [
                                    t1.url,
                                    "end"
                                ].join("#"),
                                measure: t1.url.toString()
                            }, mu.mark(this._marks.start);
                        };
                        gu.prototype.finish = function() {
                            mu.mark(this._marks.end);
                            var t1 = mu.getEntriesByName(this._marks.measure);
                            return 0 === t1.length && (mu.measure(this._marks.measure, this._marks.start, this._marks.end), t1 = mu.getEntriesByName(this._marks.measure), mu.clearMarks(this._marks.start), mu.clearMarks(this._marks.end), mu.clearMeasures(this._marks.measure)), t1;
                        }, t1.Actor = qc, t1.AlphaImage = So, t1.CanonicalTileID = eu, t1.CollisionBoxArray = na, t1.Color = te, t1.DEMData = au, t1.DataConstantProperty = wi, t1.DictionaryCoder = ou, t1.EXTENT = 8192, t1.ErrorEvent = St, t1.EvaluationParameters = pi, t1.Event = Mt, t1.Evented = Et, t1.FeatureIndex = uu, t1.FillBucket = gs, t1.FillExtrusionBucket = Os, t1.ImageAtlas = Ll, t1.ImagePosition = Sl, t1.LineBucket = qs, t1.LngLat = Wc, t1.LngLatBounds = Yc, t1.MercatorCoordinate = tu, t1.ONE_EM = 24, t1.OverscaledTileID = nu, t1.Point = i, t1.Point$1 = i, t1.Properties = Si, t1.Protobuf = al, t1.RGBAImage = Eo, t1.RequestManager = H, t1.RequestPerformance = gu, t1.ResourceType = dt, t1.SegmentVector = pa, t1.SourceFeatureState = cu, t1.StructArrayLayout1ui2 = $i, t1.StructArrayLayout2f1f2i16 = qi, t1.StructArrayLayout2i4 = zi, t1.StructArrayLayout3ui6 = Yi, t1.StructArrayLayout4i8 = Di, t1.SymbolBucket = Mc, t1.Texture = Vc, t1.Tile = du, t1.Transitionable = gi, t1.Uniform1f = Sa, t1.Uniform1i = Ma, t1.Uniform2f = Ea, t1.Uniform3f = La, t1.Uniform4f = Ca, t1.UniformColor = Pa, t1.UniformMatrix4f = Oa, t1.UnwrappedTileID = ru, t1.ValidationError = Ct, t1.WritingMode = Cl, t1.ZoomHistory = Gn, t1.add = function(t1, e1, r) {
                            return t1[0] = e1[0] + r[0], t1[1] = e1[1] + r[1], t1[2] = e1[2] + r[2], t1;
                        }, t1.addDynamicAttributes = wc, t1.asyncAll = function(t1, e1, r) {
                            if (!t1.length) return r(null, []);
                            var n = t1.length, i = new Array(t1.length), a = null;
                            t1.forEach(function(t1, o) {
                                e1(t1, function(t1, e1) {
                                    t1 && (a = t1), i[o] = e1, 0 == --n && r(a, i);
                                });
                            });
                        }, t1.bezier = o, t1.bindAll = m, t1.browser = R, t1.cacheEntryPossiblyAdded = function(t1) {
                            ++ht > ot && (t1.getActor().send("enforceCacheSizeLimit", at), ht = 0);
                        }, t1.clamp = l, t1.clearTileCache = function(t1) {
                            var e1 = self.caches.delete("mapbox-tiles");
                            t1 && e1.catch(t1).then(function() {
                                return t1();
                            });
                        }, t1.clipLine = ec, t1.clone = function(t1) {
                            var e1 = new fo(16);
                            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
                        }, t1.clone$1 = x, t1.clone$2 = function(t1) {
                            var e1 = new fo(3);
                            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1;
                        }, t1.collisionCircleLayout = tl, t1.config = F, t1.create = function() {
                            var t1 = new fo(16);
                            return fo != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0), t1[0] = 1, t1[5] = 1, t1[10] = 1, t1[15] = 1, t1;
                        }, t1.create$1 = function() {
                            var t1 = new fo(9);
                            return fo != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[0] = 1, t1[4] = 1, t1[8] = 1, t1;
                        }, t1.create$2 = function() {
                            var t1 = new fo(4);
                            return fo != Float32Array && (t1[1] = 0, t1[2] = 0), t1[0] = 1, t1[3] = 1, t1;
                        }, t1.createCommonjsModule = e1, t1.createExpression = Wr, t1.createLayout = Ii, t1.createStyleLayer = function(t1) {
                            return "custom" === t1.type ? new Dc(t1) : new Rc[t1.type](t1);
                        }, t1.cross = function(t1, e1, r) {
                            var n = e1[0], i = e1[1], a = e1[2], o = r[0], s = r[1], l = r[2];
                            return t1[0] = i * l - a * s, t1[1] = a * o - n * l, t1[2] = n * s - i * o, t1;
                        }, t1.deepEqual = function t1(e1, r) {
                            if (Array.isArray(e1)) {
                                if (!Array.isArray(r) || e1.length !== r.length) return !1;
                                for(var n = 0; n < e1.length; n++)if (!t1(e1[n], r[n])) return !1;
                                return !0;
                            }
                            if ("object" == typeof e1 && null !== e1 && null !== r) {
                                if ("object" != typeof r) return !1;
                                if (Object.keys(e1).length !== Object.keys(r).length) return !1;
                                for(var i in e1)if (!t1(e1[i], r[i])) return !1;
                                return !0;
                            }
                            return e1 === r;
                        }, t1.dot = function(t1, e1) {
                            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2];
                        }, t1.dot$1 = function(t1, e1) {
                            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2] + t1[3] * e1[3];
                        }, t1.ease = s, t1.emitValidationErrors = On, t1.endsWith = g, t1.enforceCacheSizeLimit = function(t1) {
                            st(), Q && Q.then(function(e1) {
                                e1.keys().then(function(r) {
                                    for(var n = 0; n < r.length - t1; n++)e1.delete(r[n]);
                                });
                            });
                        }, t1.evaluateSizeForFeature = Yl, t1.evaluateSizeForZoom = Wl, t1.evaluateVariableOffset = dc, t1.evented = ci, t1.extend = u, t1.featureFilter = sn, t1.filterObject = y, t1.fromRotation = function(t1, e1) {
                            var r = Math.sin(e1), n = Math.cos(e1);
                            return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = -r, t1[4] = n, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
                        }, t1.getAnchorAlignment = Ul, t1.getAnchorJustification = mc, t1.getArrayBuffer = xt, t1.getImage = Tt, t1.getJSON = function(t1, e1) {
                            return yt(u(t1, {
                                type: "json"
                            }), e1);
                        }, t1.getRTLTextPluginStatus = ui, t1.getReferrer = gt, t1.getVideo = function(t1, e1) {
                            var r, n, i = self.document.createElement("video");
                            i.muted = !0, i.onloadstart = function() {
                                e1(null, i);
                            };
                            for(var a = 0; a < t1.length; a++){
                                var o = self.document.createElement("source");
                                r = t1[a], n = void 0, (n = self.document.createElement("a")).href = r, (n.protocol !== self.document.location.protocol || n.host !== self.document.location.host) && (i.crossOrigin = "Anonymous"), o.src = t1[a], i.appendChild(o);
                            }
                            return {
                                cancel: function() {}
                            };
                        }, t1.identity = ho, t1.invert = function(t1, e1) {
                            var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = e1[4], s = e1[5], l = e1[6], c = e1[7], u = e1[8], f = e1[9], h = e1[10], p = e1[11], d = e1[12], m = e1[13], g = e1[14], v = e1[15], y = r * s - n * o, x = r * l - i * o, b = r * c - a * o, _ = n * l - i * s, w = n * c - a * s, T = i * c - a * l, k = u * m - f * d, A = u * g - h * d, M = u * v - p * d, S = f * g - h * m, E = f * v - p * m, L = h * v - p * g, C = y * L - x * E + b * S + _ * M - w * A + T * k;
                            return C ? (C = 1 / C, t1[0] = (s * L - l * E + c * S) * C, t1[1] = (i * E - n * L - a * S) * C, t1[2] = (m * T - g * w + v * _) * C, t1[3] = (h * w - f * T - p * _) * C, t1[4] = (l * M - o * L - c * A) * C, t1[5] = (r * L - i * M + a * A) * C, t1[6] = (g * b - d * T - v * x) * C, t1[7] = (u * T - h * b + p * x) * C, t1[8] = (o * E - s * M + c * k) * C, t1[9] = (n * M - r * E - a * k) * C, t1[10] = (d * w - m * b + v * y) * C, t1[11] = (f * b - u * w - p * y) * C, t1[12] = (s * A - o * S - l * k) * C, t1[13] = (r * S - n * A + i * k) * C, t1[14] = (m * x - d * _ - g * y) * C, t1[15] = (u * _ - f * x + h * y) * C, t1) : null;
                        }, t1.isChar = Yn, t1.isMapboxURL = q, t1.keysDifference = function(t1, e1) {
                            var r = [];
                            for(var n in t1)n in e1 || r.push(n);
                            return r;
                        }, t1.makeRequest = yt, t1.mapObject = v, t1.mercatorXfromLng = Jc, t1.mercatorYfromLat = Kc, t1.mercatorZfromAltitude = Qc, t1.mul = mo, t1.multiply = po, t1.mvt = Ls, t1.normalize = function(t1, e1) {
                            var r = e1[0], n = e1[1], i = e1[2], a = r * r + n * n + i * i;
                            return a > 0 && (a = 1 / Math.sqrt(a)), t1[0] = e1[0] * a, t1[1] = e1[1] * a, t1[2] = e1[2] * a, t1;
                        }, t1.number = qe, t1.offscreenCanvasSupported = pt, t1.ortho = function(t1, e1, r, n, i, a, o) {
                            var s = 1 / (e1 - r), l = 1 / (n - i), c = 1 / (a - o);
                            return t1[0] = -2 * s, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * c, t1[11] = 0, t1[12] = (e1 + r) * s, t1[13] = (i + n) * l, t1[14] = (o + a) * c, t1[15] = 1, t1;
                        }, t1.parseGlyphPBF = function(t1) {
                            return new al(t1).readFields(Tl, []);
                        }, t1.pbf = al, t1.performSymbolLayout = function(t1, e1, r, n, i, a, o) {
                            t1.createArrays();
                            var s = 512 * t1.overscaling;
                            t1.tilePixelRatio = 8192 / s, t1.compareText = {}, t1.iconsNeedLinear = !1;
                            var l = t1.layers[0].layout, c = t1.layers[0]._unevaluatedLayout._values, u = {};
                            if ("composite" === t1.textSizeData.kind) {
                                var f = t1.textSizeData, h = f.minZoom, p = f.maxZoom;
                                u.compositeTextSizes = [
                                    c["text-size"].possiblyEvaluate(new pi(h), o),
                                    c["text-size"].possiblyEvaluate(new pi(p), o)
                                ];
                            }
                            if ("composite" === t1.iconSizeData.kind) {
                                var d = t1.iconSizeData, m = d.minZoom, g = d.maxZoom;
                                u.compositeIconSizes = [
                                    c["icon-size"].possiblyEvaluate(new pi(m), o),
                                    c["icon-size"].possiblyEvaluate(new pi(g), o)
                                ];
                            }
                            u.layoutTextSize = c["text-size"].possiblyEvaluate(new pi(t1.zoom + 1), o), u.layoutIconSize = c["icon-size"].possiblyEvaluate(new pi(t1.zoom + 1), o), u.textMaxSize = c["text-size"].possiblyEvaluate(new pi(18));
                            for(var v = 24 * l.get("text-line-height"), y = "map" === l.get("text-rotation-alignment") && "point" !== l.get("symbol-placement"), x = l.get("text-keep-upright"), b = l.get("text-size"), w = function() {
                                var a = k[T], s = l.get("text-font").evaluate(a, {}, o).join(","), c = b.evaluate(a, {}, o), f = u.layoutTextSize.evaluate(a, {}, o), h = u.layoutIconSize.evaluate(a, {}, o), p = {
                                    horizontal: {},
                                    vertical: void 0
                                }, d = a.text, m = [
                                    0,
                                    0
                                ];
                                if (d) {
                                    var g = d.toString(), w = 24 * l.get("text-letter-spacing").evaluate(a, {}, o), A = function(t1) {
                                        for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                                            if (!Xn(r[e1].charCodeAt(0))) return !1;
                                        }
                                        return !0;
                                    }(g) ? w : 0, M = l.get("text-anchor").evaluate(a, {}, o), S = l.get("text-variable-anchor");
                                    if (!S) {
                                        var E = l.get("text-radial-offset").evaluate(a, {}, o);
                                        m = E ? dc(M, [
                                            24 * E,
                                            pc
                                        ]) : l.get("text-offset").evaluate(a, {}, o).map(function(t1) {
                                            return 24 * t1;
                                        });
                                    }
                                    var L = y ? "center" : l.get("text-justify").evaluate(a, {}, o), C = l.get("symbol-placement"), P = "point" === C ? 24 * l.get("text-max-width").evaluate(a, {}, o) : 0, I = function() {
                                        t1.allowVerticalPlacement && Wn(g) && (p.vertical = Ol(d, e1, r, i, s, P, v, M, "left", A, m, Cl.vertical, !0, C, f, c));
                                    };
                                    if (!y && S) {
                                        for(var O = "auto" === L ? S.map(function(t1) {
                                            return mc(t1);
                                        }) : [
                                            L
                                        ], z = !1, D = 0; D < O.length; D++){
                                            var R = O[D];
                                            if (!p.horizontal[R]) {
                                                if (z) p.horizontal[R] = p.horizontal[0];
                                                else {
                                                    var F = Ol(d, e1, r, i, s, P, v, "center", R, A, m, Cl.horizontal, !1, C, f, c);
                                                    F && (p.horizontal[R] = F, z = 1 === F.positionedLines.length);
                                                }
                                            }
                                        }
                                        I();
                                    } else {
                                        "auto" === L && (L = mc(M));
                                        var B = Ol(d, e1, r, i, s, P, v, M, L, A, m, Cl.horizontal, !1, C, f, c);
                                        B && (p.horizontal[L] = B), I(), Wn(g) && y && x && (p.vertical = Ol(d, e1, r, i, s, P, v, M, L, A, m, Cl.vertical, !1, C, f, c));
                                    }
                                }
                                var N = void 0, j = !1;
                                if (a.icon && a.icon.name) {
                                    var U = n[a.icon.name];
                                    U && (N = function(t1, e1, r) {
                                        var n = Ul(r), i = n.horizontalAlign, a = n.verticalAlign, o = e1[0], s = e1[1], l = o - t1.displaySize[0] * i, c = l + t1.displaySize[0], u = s - t1.displaySize[1] * a;
                                        return {
                                            image: t1,
                                            top: u,
                                            bottom: u + t1.displaySize[1],
                                            left: l,
                                            right: c
                                        };
                                    }(i[a.icon.name], l.get("icon-offset").evaluate(a, {}, o), l.get("icon-anchor").evaluate(a, {}, o)), j = U.sdf, void 0 === t1.sdfIcons ? t1.sdfIcons = U.sdf : t1.sdfIcons !== U.sdf && _("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (U.pixelRatio !== t1.pixelRatio || 0 !== l.get("icon-rotate").constantOr(1)) && (t1.iconsNeedLinear = !0));
                                }
                                var V = vc(p.horizontal) || p.vertical;
                                t1.iconsInText = !!V && V.iconsInText, (V || N) && function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                    var f = a.textMaxSize.evaluate(e1, {});
                                    void 0 === f && (f = o);
                                    var h, p = t1.layers[0].layout, d = p.get("icon-offset").evaluate(e1, {}, u), m = vc(r.horizontal), g = o / 24, v = t1.tilePixelRatio * g, y = t1.tilePixelRatio * f / 24, x = t1.tilePixelRatio * s, b = t1.tilePixelRatio * p.get("symbol-spacing"), w = p.get("text-padding") * t1.tilePixelRatio, T = p.get("icon-padding") * t1.tilePixelRatio, k = p.get("text-max-angle") / 180 * Math.PI, A = "map" === p.get("text-rotation-alignment") && "point" !== p.get("symbol-placement"), M = "map" === p.get("icon-rotation-alignment") && "point" !== p.get("symbol-placement"), S = p.get("symbol-placement"), E = b / 2, L = p.get("icon-text-fit");
                                    n && "none" !== L && (t1.allowVerticalPlacement && r.vertical && (h = Hl(n, r.vertical, L, p.get("icon-text-fit-padding"), d, g)), m && (n = Hl(n, m, L, p.get("icon-text-fit-padding"), d, g)));
                                    var C = function(s, f) {
                                        f.x < 0 || f.x >= 8192 || f.y < 0 || f.y >= 8192 || function(t1, e1, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g, v, y, x, b, w, T, k, A) {
                                            var M, S, E, L, C, P = t1.addToLineVertexArray(e1, r), I = 0, O = 0, z = 0, D = 0, R = -1, F = -1, B = {}, N = ya(""), j = 0, U = 0;
                                            void 0 === s._unevaluatedLayout.getValue("text-radial-offset") ? (M = s.layout.get("text-offset").evaluate(b, {}, k).map(function(t1) {
                                                return 24 * t1;
                                            }), j = M[0], U = M[1]) : (j = 24 * s.layout.get("text-radial-offset").evaluate(b, {}, k), U = pc);
                                            if (t1.allowVerticalPlacement && n.vertical) {
                                                var V = s.layout.get("text-rotate").evaluate(b, {}, k) + 90, H = n.vertical;
                                                L = new sc(l, e1, c, u, f, H, h, p, d, V), o && (C = new sc(l, e1, c, u, f, o, g, v, d, V));
                                            }
                                            if (i) {
                                                var q = s.layout.get("icon-rotate").evaluate(b, {}), G = "none" !== s.layout.get("icon-text-fit"), Y = rc(i, q, T, G), W = o ? rc(o, q, T, G) : void 0;
                                                E = new sc(l, e1, c, u, f, i, g, v, !1, q), I = 4 * Y.length;
                                                var X = t1.iconSizeData, Z = null;
                                                "source" === X.kind ? (Z = [
                                                    128 * s.layout.get("icon-size").evaluate(b, {})
                                                ])[0] > 32640 && _(t1.layerIds[0] + ': Value for "icon-size" is >= 255. Reduce your "icon-size".') : "composite" === X.kind && ((Z = [
                                                    128 * w.compositeIconSizes[0].evaluate(b, {}, k),
                                                    128 * w.compositeIconSizes[1].evaluate(b, {}, k)
                                                ])[0] > 32640 || Z[1] > 32640) && _(t1.layerIds[0] + ': Value for "icon-size" is >= 255. Reduce your "icon-size".'), t1.addSymbols(t1.icon, Y, Z, x, y, b, !1, e1, P.lineStartIndex, P.lineLength, -1, k), R = t1.icon.placedSymbolArray.length - 1, W && (O = 4 * W.length, t1.addSymbols(t1.icon, W, Z, x, y, b, Cl.vertical, e1, P.lineStartIndex, P.lineLength, -1, k), F = t1.icon.placedSymbolArray.length - 1);
                                            }
                                            for(var J in n.horizontal){
                                                var K = n.horizontal[J];
                                                if (!S) {
                                                    N = ya(K.text);
                                                    var Q = s.layout.get("text-rotate").evaluate(b, {}, k);
                                                    S = new sc(l, e1, c, u, f, K, h, p, d, Q);
                                                }
                                                var $ = 1 === K.positionedLines.length;
                                                if (z += gc(t1, e1, K, a, s, d, b, m, P, n.vertical ? Cl.horizontal : Cl.horizontalOnly, $ ? Object.keys(n.horizontal) : [
                                                    J
                                                ], B, R, w, k), $) break;
                                            }
                                            n.vertical && (D += gc(t1, e1, n.vertical, a, s, d, b, m, P, Cl.vertical, [
                                                "vertical"
                                            ], B, F, w, k));
                                            var tt = S ? S.boxStartIndex : t1.collisionBoxArray.length, et = S ? S.boxEndIndex : t1.collisionBoxArray.length, rt = L ? L.boxStartIndex : t1.collisionBoxArray.length, nt = L ? L.boxEndIndex : t1.collisionBoxArray.length, it = E ? E.boxStartIndex : t1.collisionBoxArray.length, at = E ? E.boxEndIndex : t1.collisionBoxArray.length, ot = C ? C.boxStartIndex : t1.collisionBoxArray.length, st = C ? C.boxEndIndex : t1.collisionBoxArray.length, lt = -1, ct = function(t1, e1) {
                                                return t1 && t1.circleDiameter ? Math.max(t1.circleDiameter, e1) : e1;
                                            };
                                            lt = ct(S, lt), lt = ct(L, lt), lt = ct(E, lt);
                                            var ut = (lt = ct(C, lt)) > -1 ? 1 : 0;
                                            ut && (lt *= A / 24);
                                            t1.glyphOffsetArray.length >= Mc.MAX_GLYPHS && _("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907");
                                            void 0 !== b.sortKey && t1.addToSortKeyRanges(t1.symbolInstances.length, b.sortKey);
                                            t1.symbolInstances.emplaceBack(e1.x, e1.y, B.right >= 0 ? B.right : -1, B.center >= 0 ? B.center : -1, B.left >= 0 ? B.left : -1, B.vertical || -1, R, F, N, tt, et, rt, nt, it, at, ot, st, c, z, D, I, O, ut, 0, h, j, U, lt);
                                        }(t1, f, s, r, n, i, h, t1.layers[0], t1.collisionBoxArray, e1.index, e1.sourceLayerIndex, t1.index, v, w, A, l, x, T, M, d, e1, a, c, u, o);
                                    };
                                    if ("line" === S) for(var P = 0, I = ec(e1.geometry, 0, 0, 8192, 8192); P < I.length; P += 1)for(var O = I[P], z = tc(O, b, k, r.vertical || m, n, 24, y, t1.overscaling, 8192), D = 0, R = z; D < R.length; D += 1){
                                        var F = R[D], B = m;
                                        B && yc(t1, B.text, E, F) || C(O, F);
                                    }
                                    else if ("line-center" === S) for(var N = 0, j = e1.geometry; N < j.length; N += 1){
                                        var U = j[N];
                                        if (U.length > 1) {
                                            var V = $l(U, k, r.vertical || m, n, 24, y);
                                            V && C(U, V);
                                        }
                                    }
                                    else if ("Polygon" === e1.type) for(var H = 0, q = hs(e1.geometry, 0); H < q.length; H += 1){
                                        var G = q[H], Y = uc(G, 16);
                                        C(G[0], new ql(Y.x, Y.y, 0));
                                    }
                                    else if ("LineString" === e1.type) for(var W = 0, X = e1.geometry; W < X.length; W += 1){
                                        var Z = X[W];
                                        C(Z, new ql(Z[0].x, Z[0].y, 0));
                                    }
                                    else if ("Point" === e1.type) for(var J = 0, K = e1.geometry; J < K.length; J += 1)for(var Q = K[J], $ = 0, tt = Q; $ < tt.length; $ += 1){
                                        var et = tt[$];
                                        C([
                                            et
                                        ], new ql(et.x, et.y, 0));
                                    }
                                }(t1, a, p, N, n, u, f, h, m, j, o);
                            }, T = 0, k = t1.features; T < k.length; T += 1)w();
                            a && t1.generateCollisionDebugBuffers();
                        }, t1.perspective = function(t1, e1, r, n, i) {
                            var a, o = 1 / Math.tan(e1 / 2);
                            return t1[0] = o / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = o, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (a = 1 / (n - i), t1[10] = (i + n) * a, t1[14] = 2 * i * n * a) : (t1[10] = -1, t1[14] = -2 * n), t1;
                        }, t1.pick = function(t1, e1) {
                            for(var r = {}, n = 0; n < e1.length; n++){
                                var i = e1[n];
                                i in t1 && (r[i] = t1[i]);
                            }
                            return r;
                        }, t1.plugin = hi, t1.polygonIntersectsPolygon = Za, t1.postMapLoadEvent = it, t1.postTurnstileEvent = rt, t1.potpack = Ml, t1.refProperties = [
                            "type",
                            "source",
                            "source-layer",
                            "minzoom",
                            "maxzoom",
                            "filter",
                            "layout"
                        ], t1.register = Nn, t1.registerForPluginStateChange = function(t1) {
                            return t1({
                                pluginStatus: ai,
                                pluginURL: oi
                            }), ci.on("pluginStateChange", t1), t1;
                        }, t1.rotate = function(t1, e1, r) {
                            var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = Math.sin(r), l = Math.cos(r);
                            return t1[0] = n * l + a * s, t1[1] = i * l + o * s, t1[2] = n * -s + a * l, t1[3] = i * -s + o * l, t1;
                        }, t1.rotateX = function(t1, e1, r) {
                            var n = Math.sin(r), i = Math.cos(r), a = e1[4], o = e1[5], s = e1[6], l = e1[7], c = e1[8], u = e1[9], f = e1[10], h = e1[11];
                            return e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[4] = a * i + c * n, t1[5] = o * i + u * n, t1[6] = s * i + f * n, t1[7] = l * i + h * n, t1[8] = c * i - a * n, t1[9] = u * i - o * n, t1[10] = f * i - s * n, t1[11] = h * i - l * n, t1;
                        }, t1.rotateZ = function(t1, e1, r) {
                            var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], l = e1[3], c = e1[4], u = e1[5], f = e1[6], h = e1[7];
                            return e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]), t1[0] = a * i + c * n, t1[1] = o * i + u * n, t1[2] = s * i + f * n, t1[3] = l * i + h * n, t1[4] = c * i - a * n, t1[5] = u * i - o * n, t1[6] = f * i - s * n, t1[7] = h * i - l * n, t1;
                        }, t1.scale = function(t1, e1, r) {
                            var n = r[0], i = r[1], a = r[2];
                            return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * a, t1[9] = e1[9] * a, t1[10] = e1[10] * a, t1[11] = e1[11] * a, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
                        }, t1.scale$1 = function(t1, e1, r) {
                            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1[3] = e1[3] * r, t1;
                        }, t1.scale$2 = function(t1, e1, r) {
                            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1;
                        }, t1.setCacheLimits = function(t1, e1) {
                            at = t1, ot = e1;
                        }, t1.setRTLTextPlugin = function(t1, e1, r) {
                            if (void 0 === r && (r = !1), ai === ti || ai === ei || ai === ri) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                            oi = R.resolveURL(t1), ai = ti, ii = e1, li(), r || fi();
                        }, t1.sphericalToCartesian = function(t1) {
                            var e1 = t1[0], r = t1[1], n = t1[2];
                            return r += 90, r *= Math.PI / 180, n *= Math.PI / 180, {
                                x: e1 * Math.cos(r) * Math.sin(n),
                                y: e1 * Math.sin(r) * Math.sin(n),
                                z: e1 * Math.cos(n)
                            };
                        }, t1.sqrLen = bo, t1.styleSpec = Lt, t1.sub = yo, t1.symbolSize = Xl, t1.transformMat3 = function(t1, e1, r) {
                            var n = e1[0], i = e1[1], a = e1[2];
                            return t1[0] = n * r[0] + i * r[3] + a * r[6], t1[1] = n * r[1] + i * r[4] + a * r[7], t1[2] = n * r[2] + i * r[5] + a * r[8], t1;
                        }, t1.transformMat4 = xo, t1.translate = function(t1, e1, r) {
                            var n, i, a, o, s, l, c, u, f, h, p, d, m = r[0], g = r[1], v = r[2];
                            return e1 === t1 ? (t1[12] = e1[0] * m + e1[4] * g + e1[8] * v + e1[12], t1[13] = e1[1] * m + e1[5] * g + e1[9] * v + e1[13], t1[14] = e1[2] * m + e1[6] * g + e1[10] * v + e1[14], t1[15] = e1[3] * m + e1[7] * g + e1[11] * v + e1[15]) : (n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], f = e1[8], h = e1[9], p = e1[10], d = e1[11], t1[0] = n, t1[1] = i, t1[2] = a, t1[3] = o, t1[4] = s, t1[5] = l, t1[6] = c, t1[7] = u, t1[8] = f, t1[9] = h, t1[10] = p, t1[11] = d, t1[12] = n * m + s * g + f * v + e1[12], t1[13] = i * m + l * g + h * v + e1[13], t1[14] = a * m + c * g + p * v + e1[14], t1[15] = o * m + u * g + d * v + e1[15]), t1;
                        }, t1.triggerPluginCompletionEvent = si, t1.uniqueId = h, t1.validateCustomStyleLayer = function(t1) {
                            var e1 = [], r = t1.id;
                            return void 0 === r && e1.push({
                                message: "layers." + r + ': missing required property "id"'
                            }), void 0 === t1.render && e1.push({
                                message: "layers." + r + ': missing required method "render"'
                            }), t1.renderingMode && "2d" !== t1.renderingMode && "3d" !== t1.renderingMode && e1.push({
                                message: "layers." + r + ': property "renderingMode" must be either "2d" or "3d"'
                            }), e1;
                        }, t1.validateLight = Cn, t1.validateStyle = Ln, t1.values = function(t1) {
                            var e1 = [];
                            for(var r in t1)e1.push(t1[r]);
                            return e1;
                        }, t1.vectorTile = Ls, t1.version = "1.10.1", t1.warnOnce = _, t1.webpSupported = B, t1.window = self, t1.wrap = c;
                    }), n(0, function(t1) {
                        function e1(t1) {
                            var r = typeof t1;
                            if ("number" === r || "boolean" === r || "string" === r || null == t1) return JSON.stringify(t1);
                            if (Array.isArray(t1)) {
                                for(var n = "[", i = 0, a = t1; i < a.length; i += 1)n += e1(a[i]) + ",";
                                return n + "]";
                            }
                            for(var o = Object.keys(t1).sort(), s = "{", l = 0; l < o.length; l++)s += JSON.stringify(o[l]) + ":" + e1(t1[o[l]]) + ",";
                            return s + "}";
                        }
                        function r(r) {
                            for(var n = "", i = 0, a = t1.refProperties; i < a.length; i += 1)n += "/" + e1(r[a[i]]);
                            return n;
                        }
                        var n = function(t1) {
                            this.keyCache = {}, t1 && this.replace(t1);
                        };
                        n.prototype.replace = function(t1) {
                            this._layerConfigs = {}, this._layers = {}, this.update(t1, []);
                        }, n.prototype.update = function(e1, n) {
                            for(var i = this, a = 0, o = e1; a < o.length; a += 1){
                                var s = o[a];
                                this._layerConfigs[s.id] = s;
                                var l = this._layers[s.id] = t1.createStyleLayer(s);
                                l._featureFilter = t1.featureFilter(l.filter), this.keyCache[s.id] && delete this.keyCache[s.id];
                            }
                            for(var c = 0, u = n; c < u.length; c += 1){
                                var f = u[c];
                                delete this.keyCache[f], delete this._layerConfigs[f], delete this._layers[f];
                            }
                            this.familiesBySource = {};
                            for(var h = 0, p = function(t1, e1) {
                                for(var n = {}, i = 0; i < t1.length; i++){
                                    var a = e1 && e1[t1[i].id] || r(t1[i]);
                                    e1 && (e1[t1[i].id] = a);
                                    var o = n[a];
                                    o || (o = n[a] = []), o.push(t1[i]);
                                }
                                var s = [];
                                for(var l in n)s.push(n[l]);
                                return s;
                            }(t1.values(this._layerConfigs), this.keyCache); h < p.length; h += 1){
                                var d = p[h].map(function(t1) {
                                    return i._layers[t1.id];
                                }), m = d[0];
                                if ("none" !== m.visibility) {
                                    var g = m.source || "", v = this.familiesBySource[g];
                                    v || (v = this.familiesBySource[g] = {});
                                    var y = m.sourceLayer || "_geojsonTileLayer", x = v[y];
                                    x || (x = v[y] = []), x.push(d);
                                }
                            }
                        };
                        var i = function(e1) {
                            var r = {}, n = [];
                            for(var i in e1){
                                var a = e1[i], o = r[i] = {};
                                for(var s in a){
                                    var l = a[+s];
                                    if (l && 0 !== l.bitmap.width && 0 !== l.bitmap.height) {
                                        var c = {
                                            x: 0,
                                            y: 0,
                                            w: l.bitmap.width + 2,
                                            h: l.bitmap.height + 2
                                        };
                                        n.push(c), o[s] = {
                                            rect: c,
                                            metrics: l.metrics
                                        };
                                    }
                                }
                            }
                            var u = t1.potpack(n), f = u.w, h = u.h, p = new t1.AlphaImage({
                                width: f || 1,
                                height: h || 1
                            });
                            for(var d in e1){
                                var m = e1[d];
                                for(var g in m){
                                    var v = m[+g];
                                    if (v && 0 !== v.bitmap.width && 0 !== v.bitmap.height) {
                                        var y = r[d][g].rect;
                                        t1.AlphaImage.copy(v.bitmap, p, {
                                            x: 0,
                                            y: 0
                                        }, {
                                            x: y.x + 1,
                                            y: y.y + 1
                                        }, v.bitmap);
                                    }
                                }
                            }
                            this.image = p, this.positions = r;
                        };
                        t1.register("GlyphAtlas", i);
                        var a = function(e1) {
                            this.tileID = new t1.OverscaledTileID(e1.tileID.overscaledZ, e1.tileID.wrap, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y), this.uid = e1.uid, this.zoom = e1.zoom, this.pixelRatio = e1.pixelRatio, this.tileSize = e1.tileSize, this.source = e1.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = e1.showCollisionBoxes, this.collectResourceTiming = !!e1.collectResourceTiming, this.returnDependencies = !!e1.returnDependencies, this.promoteId = e1.promoteId;
                        };
                        function o(e1, r, n) {
                            for(var i = new t1.EvaluationParameters(r), a = 0, o = e1; a < o.length; a += 1)o[a].recalculate(i, n);
                        }
                        function s(e1, r) {
                            var n = t1.getArrayBuffer(e1.request, function(e1, n, i, a) {
                                e1 ? r(e1) : n && r(null, {
                                    vectorTile: new t1.vectorTile.VectorTile(new t1.pbf(n)),
                                    rawData: n,
                                    cacheControl: i,
                                    expires: a
                                });
                            });
                            return function() {
                                n.cancel(), r();
                            };
                        }
                        a.prototype.parse = function(e1, r, n, a, s) {
                            var l = this;
                            this.status = "parsing", this.data = e1, this.collisionBoxArray = new t1.CollisionBoxArray;
                            var c = new t1.DictionaryCoder(Object.keys(e1.layers).sort()), u = new t1.FeatureIndex(this.tileID, this.promoteId);
                            u.bucketLayerIDs = [];
                            var f, h, p, d, m = {}, g = {
                                featureIndex: u,
                                iconDependencies: {},
                                patternDependencies: {},
                                glyphDependencies: {},
                                availableImages: n
                            }, v = r.familiesBySource[this.source];
                            for(var y in v){
                                var x = e1.layers[y];
                                if (x) {
                                    1 === x.version && t1.warnOnce('Vector tile source "' + this.source + '" layer "' + y + '" does not use vector tile spec v2 and therefore may have some rendering errors.');
                                    for(var b = c.encode(y), _ = [], w = 0; w < x.length; w++){
                                        var T = x.feature(w), k = u.getId(T, y);
                                        _.push({
                                            feature: T,
                                            id: k,
                                            index: w,
                                            sourceLayerIndex: b
                                        });
                                    }
                                    for(var A = 0, M = v[y]; A < M.length; A += 1){
                                        var S = M[A], E = S[0];
                                        if (!(E.minzoom && this.zoom < Math.floor(E.minzoom))) {
                                            if (!(E.maxzoom && this.zoom >= E.maxzoom)) {
                                                if ("none" !== E.visibility) o(S, this.zoom, n), (m[E.id] = E.createBucket({
                                                    index: u.bucketLayerIDs.length,
                                                    layers: S,
                                                    zoom: this.zoom,
                                                    pixelRatio: this.pixelRatio,
                                                    overscaling: this.overscaling,
                                                    collisionBoxArray: this.collisionBoxArray,
                                                    sourceLayerIndex: b,
                                                    sourceID: this.source
                                                })).populate(_, g, this.tileID.canonical), u.bucketLayerIDs.push(S.map(function(t1) {
                                                    return t1.id;
                                                }));
                                            }
                                        }
                                    }
                                }
                            }
                            var L = t1.mapObject(g.glyphDependencies, function(t1) {
                                return Object.keys(t1).map(Number);
                            });
                            Object.keys(L).length ? a.send("getGlyphs", {
                                uid: this.uid,
                                stacks: L
                            }, function(t1, e1) {
                                f || (f = t1, h = e1, I.call(l));
                            }) : h = {};
                            var C = Object.keys(g.iconDependencies);
                            C.length ? a.send("getImages", {
                                icons: C,
                                source: this.source,
                                tileID: this.tileID,
                                type: "icons"
                            }, function(t1, e1) {
                                f || (f = t1, p = e1, I.call(l));
                            }) : p = {};
                            var P = Object.keys(g.patternDependencies);
                            function I() {
                                if (f) return s(f);
                                if (h && p && d) {
                                    var e1 = new i(h), r = new t1.ImageAtlas(p, d);
                                    for(var a in m){
                                        var l = m[a];
                                        l instanceof t1.SymbolBucket ? (o(l.layers, this.zoom, n), t1.performSymbolLayout(l, h, e1.positions, p, r.iconPositions, this.showCollisionBoxes, this.tileID.canonical)) : l.hasPattern && (l instanceof t1.LineBucket || l instanceof t1.FillBucket || l instanceof t1.FillExtrusionBucket) && (o(l.layers, this.zoom, n), l.addFeatures(g, this.tileID.canonical, r.patternPositions));
                                    }
                                    this.status = "done", s(null, {
                                        buckets: t1.values(m).filter(function(t1) {
                                            return !t1.isEmpty();
                                        }),
                                        featureIndex: u,
                                        collisionBoxArray: this.collisionBoxArray,
                                        glyphAtlasImage: e1.image,
                                        imageAtlas: r,
                                        glyphMap: this.returnDependencies ? h : null,
                                        iconMap: this.returnDependencies ? p : null,
                                        glyphPositions: this.returnDependencies ? e1.positions : null
                                    });
                                }
                            }
                            P.length ? a.send("getImages", {
                                icons: P,
                                source: this.source,
                                tileID: this.tileID,
                                type: "patterns"
                            }, function(t1, e1) {
                                f || (f = t1, d = e1, I.call(l));
                            }) : d = {}, I.call(this);
                        };
                        var l = function(t1, e1, r, n) {
                            this.actor = t1, this.layerIndex = e1, this.availableImages = r, this.loadVectorData = n || s, this.loading = {}, this.loaded = {};
                        };
                        l.prototype.loadTile = function(e1, r) {
                            var n = this, i = e1.uid;
                            this.loading || (this.loading = {});
                            var o = !!(e1 && e1.request && e1.request.collectResourceTiming) && new t1.RequestPerformance(e1.request), s = this.loading[i] = new a(e1);
                            s.abort = this.loadVectorData(e1, function(e1, a) {
                                if (delete n.loading[i], e1 || !a) return s.status = "done", n.loaded[i] = s, r(e1);
                                var l = a.rawData, c = {};
                                a.expires && (c.expires = a.expires), a.cacheControl && (c.cacheControl = a.cacheControl);
                                var u = {};
                                if (o) {
                                    var f = o.finish();
                                    f && (u.resourceTiming = JSON.parse(JSON.stringify(f)));
                                }
                                s.vectorTile = a.vectorTile, s.parse(a.vectorTile, n.layerIndex, n.availableImages, n.actor, function(e1, n) {
                                    if (e1 || !n) return r(e1);
                                    r(null, t1.extend({
                                        rawTileData: l.slice(0)
                                    }, n, c, u));
                                }), n.loaded = n.loaded || {}, n.loaded[i] = s;
                            });
                        }, l.prototype.reloadTile = function(t1, e1) {
                            var r = this, n = this.loaded, i = t1.uid, a = this;
                            if (n && n[i]) {
                                var o = n[i];
                                o.showCollisionBoxes = t1.showCollisionBoxes;
                                var s = function(t1, n) {
                                    var i = o.reloadCallback;
                                    i && (delete o.reloadCallback, o.parse(o.vectorTile, a.layerIndex, r.availableImages, a.actor, i)), e1(t1, n);
                                };
                                "parsing" === o.status ? o.reloadCallback = s : "done" === o.status && (o.vectorTile ? o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.actor, s) : s());
                            }
                        }, l.prototype.abortTile = function(t1, e1) {
                            var r = this.loading, n = t1.uid;
                            r && r[n] && r[n].abort && (r[n].abort(), delete r[n]), e1();
                        }, l.prototype.removeTile = function(t1, e1) {
                            var r = this.loaded, n = t1.uid;
                            r && r[n] && delete r[n], e1();
                        };
                        var c = t1.window.ImageBitmap, u = function() {
                            this.loaded = {};
                        };
                        u.prototype.loadTile = function(e1, r) {
                            var n = e1.uid, i = e1.encoding, a = e1.rawImageData, o = c && a instanceof c ? this.getImageData(a) : a, s = new t1.DEMData(n, o, i);
                            this.loaded = this.loaded || {}, this.loaded[n] = s, r(null, s);
                        }, u.prototype.getImageData = function(e1) {
                            this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e1.width, e1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d")), this.offscreenCanvas.width = e1.width, this.offscreenCanvas.height = e1.height, this.offscreenCanvasContext.drawImage(e1, 0, 0, e1.width, e1.height);
                            var r = this.offscreenCanvasContext.getImageData(-1, -1, e1.width + 2, e1.height + 2);
                            return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), new t1.RGBAImage({
                                width: r.width,
                                height: r.height
                            }, r.data);
                        }, u.prototype.removeTile = function(t1) {
                            var e1 = this.loaded, r = t1.uid;
                            e1 && e1[r] && delete e1[r];
                        };
                        var f = function t1(e1, r) {
                            var n, i = e1 && e1.type;
                            if ("FeatureCollection" === i) for(n = 0; n < e1.features.length; n++)t1(e1.features[n], r);
                            else if ("GeometryCollection" === i) for(n = 0; n < e1.geometries.length; n++)t1(e1.geometries[n], r);
                            else if ("Feature" === i) t1(e1.geometry, r);
                            else if ("Polygon" === i) h(e1.coordinates, r);
                            else if ("MultiPolygon" === i) for(n = 0; n < e1.coordinates.length; n++)h(e1.coordinates[n], r);
                            return e1;
                        };
                        function h(t1, e1) {
                            if (0 !== t1.length) {
                                p(t1[0], e1);
                                for(var r = 1; r < t1.length; r++)p(t1[r], !e1);
                            }
                        }
                        function p(t1, e1) {
                            for(var r = 0, n = 0, i = t1.length, a = i - 1; n < i; a = n++)r += (t1[n][0] - t1[a][0]) * (t1[a][1] + t1[n][1]);
                            r >= 0 != !!e1 && t1.reverse();
                        }
                        var d = t1.vectorTile.VectorTileFeature.prototype.toGeoJSON, m = function(e1) {
                            this._feature = e1, this.extent = t1.EXTENT, this.type = e1.type, this.properties = e1.tags, "id" in e1 && !isNaN(e1.id) && (this.id = parseInt(e1.id, 10));
                        };
                        m.prototype.loadGeometry = function() {
                            if (1 === this._feature.type) {
                                for(var e1 = [], r = 0, n = this._feature.geometry; r < n.length; r += 1){
                                    var i = n[r];
                                    e1.push([
                                        new t1.Point$1(i[0], i[1])
                                    ]);
                                }
                                return e1;
                            }
                            for(var a = [], o = 0, s = this._feature.geometry; o < s.length; o += 1){
                                for(var l = [], c = 0, u = s[o]; c < u.length; c += 1){
                                    var f = u[c];
                                    l.push(new t1.Point$1(f[0], f[1]));
                                }
                                a.push(l);
                            }
                            return a;
                        }, m.prototype.toGeoJSON = function(t1, e1, r) {
                            return d.call(this, t1, e1, r);
                        };
                        var g = function(e1) {
                            this.layers = {
                                _geojsonTileLayer: this
                            }, this.name = "_geojsonTileLayer", this.extent = t1.EXTENT, this.length = e1.length, this._features = e1;
                        };
                        g.prototype.feature = function(t1) {
                            return new m(this._features[t1]);
                        };
                        var v = t1.vectorTile.VectorTileFeature, y = x;
                        function x(t1, e1) {
                            this.options = e1 || {}, this.features = t1, this.length = t1.length;
                        }
                        function b(t1, e1) {
                            this.id = "number" == typeof t1.id ? t1.id : void 0, this.type = t1.type, this.rawGeometry = 1 === t1.type ? [
                                t1.geometry
                            ] : t1.geometry, this.properties = t1.tags, this.extent = e1 || 4096;
                        }
                        x.prototype.feature = function(t1) {
                            return new b(this.features[t1], this.options.extent);
                        }, b.prototype.loadGeometry = function() {
                            var e1 = this.rawGeometry;
                            this.geometry = [];
                            for(var r = 0; r < e1.length; r++){
                                for(var n = e1[r], i = [], a = 0; a < n.length; a++)i.push(new t1.Point$1(n[a][0], n[a][1]));
                                this.geometry.push(i);
                            }
                            return this.geometry;
                        }, b.prototype.bbox = function() {
                            this.geometry || this.loadGeometry();
                            for(var t1 = this.geometry, e1 = 1 / 0, r = -1 / 0, n = 1 / 0, i = -1 / 0, a = 0; a < t1.length; a++)for(var o = t1[a], s = 0; s < o.length; s++){
                                var l = o[s];
                                e1 = Math.min(e1, l.x), r = Math.max(r, l.x), n = Math.min(n, l.y), i = Math.max(i, l.y);
                            }
                            return [
                                e1,
                                n,
                                r,
                                i
                            ];
                        }, b.prototype.toGeoJSON = v.prototype.toGeoJSON;
                        var _ = A, w = A, T = function(t1, e1) {
                            e1 = e1 || {};
                            var r = {};
                            for(var n in t1)r[n] = new y(t1[n].features, e1), r[n].name = n, r[n].version = e1.version, r[n].extent = e1.extent;
                            return A({
                                layers: r
                            });
                        }, k = y;
                        function A(e1) {
                            var r = new t1.pbf;
                            return function(t1, e1) {
                                for(var r in t1.layers)e1.writeMessage(3, M, t1.layers[r]);
                            }(e1, r), r.finish();
                        }
                        function M(t1, e1) {
                            var r;
                            e1.writeVarintField(15, t1.version || 1), e1.writeStringField(1, t1.name || ""), e1.writeVarintField(5, t1.extent || 4096);
                            var n = {
                                keys: [],
                                values: [],
                                keycache: {},
                                valuecache: {}
                            };
                            for(r = 0; r < t1.length; r++)n.feature = t1.feature(r), e1.writeMessage(2, S, n);
                            var i = n.keys;
                            for(r = 0; r < i.length; r++)e1.writeStringField(3, i[r]);
                            var a = n.values;
                            for(r = 0; r < a.length; r++)e1.writeMessage(4, I, a[r]);
                        }
                        function S(t1, e1) {
                            var r = t1.feature;
                            void 0 !== r.id && e1.writeVarintField(1, r.id), e1.writeMessage(2, E, t1), e1.writeVarintField(3, r.type), e1.writeMessage(4, P, r);
                        }
                        function E(t1, e1) {
                            var r = t1.feature, n = t1.keys, i = t1.values, a = t1.keycache, o = t1.valuecache;
                            for(var s in r.properties){
                                var l = a[s];
                                void 0 === l && (n.push(s), l = n.length - 1, a[s] = l), e1.writeVarint(l);
                                var c = r.properties[s], u = typeof c;
                                "string" !== u && "boolean" !== u && "number" !== u && (c = JSON.stringify(c));
                                var f = u + ":" + c, h = o[f];
                                void 0 === h && (i.push(c), h = i.length - 1, o[f] = h), e1.writeVarint(h);
                            }
                        }
                        function L(t1, e1) {
                            return (e1 << 3) + (7 & t1);
                        }
                        function C(t1) {
                            return t1 << 1 ^ t1 >> 31;
                        }
                        function P(t1, e1) {
                            for(var r = t1.loadGeometry(), n = t1.type, i = 0, a = 0, o = r.length, s = 0; s < o; s++){
                                var l = r[s], c = 1;
                                1 === n && (c = l.length), e1.writeVarint(L(1, c));
                                for(var u = 3 === n ? l.length - 1 : l.length, f = 0; f < u; f++){
                                    1 === f && 1 !== n && e1.writeVarint(L(2, u - 1));
                                    var h = l[f].x - i, p = l[f].y - a;
                                    e1.writeVarint(C(h)), e1.writeVarint(C(p)), i += h, a += p;
                                }
                                3 === n && e1.writeVarint(L(7, 1));
                            }
                        }
                        function I(t1, e1) {
                            var r = typeof t1;
                            "string" === r ? e1.writeStringField(1, t1) : "boolean" === r ? e1.writeBooleanField(7, t1) : "number" === r && (t1 % 1 != 0 ? e1.writeDoubleField(3, t1) : t1 < 0 ? e1.writeSVarintField(6, t1) : e1.writeVarintField(5, t1));
                        }
                        function O(t1, e1, r, n, i, a) {
                            if (!(i - n <= r)) {
                                var o = n + i >> 1;
                                !function t1(e1, r, n, i, a, o) {
                                    for(; a > i;){
                                        if (a - i > 600) {
                                            var s = a - i + 1, l = n - i + 1, c = Math.log(s), u = .5 * Math.exp(2 * c / 3), f = .5 * Math.sqrt(c * u * (s - u) / s) * (l - s / 2 < 0 ? -1 : 1), h = Math.max(i, Math.floor(n - l * u / s + f)), p = Math.min(a, Math.floor(n + (s - l) * u / s + f));
                                            t1(e1, r, n, h, p, o);
                                        }
                                        var d = r[2 * n + o], m = i, g = a;
                                        for(z(e1, r, i, n), r[2 * a + o] > d && z(e1, r, i, a); m < g;){
                                            for(z(e1, r, m, g), m++, g--; r[2 * m + o] < d;)m++;
                                            for(; r[2 * g + o] > d;)g--;
                                        }
                                        r[2 * i + o] === d ? z(e1, r, i, g) : (g++, z(e1, r, g, a)), g <= n && (i = g + 1), n <= g && (a = g - 1);
                                    }
                                }(t1, e1, o, n, i, a % 2), O(t1, e1, r, n, o - 1, a + 1), O(t1, e1, r, o + 1, i, a + 1);
                            }
                        }
                        function z(t1, e1, r, n) {
                            D(t1, r, n), D(e1, 2 * r, 2 * n), D(e1, 2 * r + 1, 2 * n + 1);
                        }
                        function D(t1, e1, r) {
                            var n = t1[e1];
                            t1[e1] = t1[r], t1[r] = n;
                        }
                        function R(t1, e1, r, n) {
                            var i = t1 - r, a = e1 - n;
                            return i * i + a * a;
                        }
                        _.fromVectorTileJs = w, _.fromGeojsonVt = T, _.GeoJSONWrapper = k;
                        var F = function(t1) {
                            return t1[0];
                        }, B = function(t1) {
                            return t1[1];
                        }, N = function(t1, e1, r, n, i) {
                            void 0 === e1 && (e1 = F), void 0 === r && (r = B), void 0 === n && (n = 64), void 0 === i && (i = Float64Array), this.nodeSize = n, this.points = t1;
                            for(var a = t1.length < 65536 ? Uint16Array : Uint32Array, o = this.ids = new a(t1.length), s = this.coords = new i(2 * t1.length), l = 0; l < t1.length; l++)o[l] = l, s[2 * l] = e1(t1[l]), s[2 * l + 1] = r(t1[l]);
                            O(o, s, n, 0, o.length - 1, 0);
                        };
                        N.prototype.range = function(t1, e1, r, n) {
                            return function(t1, e1, r, n, i, a, o) {
                                for(var s, l, c = [
                                    0,
                                    t1.length - 1,
                                    0
                                ], u = []; c.length;){
                                    var f = c.pop(), h = c.pop(), p = c.pop();
                                    if (h - p <= o) for(var d = p; d <= h; d++)s = e1[2 * d], l = e1[2 * d + 1], s >= r && s <= i && l >= n && l <= a && u.push(t1[d]);
                                    else {
                                        var m = Math.floor((p + h) / 2);
                                        s = e1[2 * m], l = e1[2 * m + 1], s >= r && s <= i && l >= n && l <= a && u.push(t1[m]);
                                        var g = (f + 1) % 2;
                                        (0 === f ? r <= s : n <= l) && (c.push(p), c.push(m - 1), c.push(g)), (0 === f ? i >= s : a >= l) && (c.push(m + 1), c.push(h), c.push(g));
                                    }
                                }
                                return u;
                            }(this.ids, this.coords, t1, e1, r, n, this.nodeSize);
                        }, N.prototype.within = function(t1, e1, r) {
                            return function(t1, e1, r, n, i, a) {
                                for(var o = [
                                    0,
                                    t1.length - 1,
                                    0
                                ], s = [], l = i * i; o.length;){
                                    var c = o.pop(), u = o.pop(), f = o.pop();
                                    if (u - f <= a) for(var h = f; h <= u; h++)R(e1[2 * h], e1[2 * h + 1], r, n) <= l && s.push(t1[h]);
                                    else {
                                        var p = Math.floor((f + u) / 2), d = e1[2 * p], m = e1[2 * p + 1];
                                        R(d, m, r, n) <= l && s.push(t1[p]);
                                        var g = (c + 1) % 2;
                                        (0 === c ? r - i <= d : n - i <= m) && (o.push(f), o.push(p - 1), o.push(g)), (0 === c ? r + i >= d : n + i >= m) && (o.push(p + 1), o.push(u), o.push(g));
                                    }
                                }
                                return s;
                            }(this.ids, this.coords, t1, e1, r, this.nodeSize);
                        };
                        var j = {
                            minZoom: 0,
                            maxZoom: 16,
                            radius: 40,
                            extent: 512,
                            nodeSize: 64,
                            log: !1,
                            generateId: !1,
                            reduce: null,
                            map: function(t1) {
                                return t1;
                            }
                        }, U = function(t1) {
                            this.options = X(Object.create(j), t1), this.trees = new Array(this.options.maxZoom + 1);
                        };
                        function V(t1, e1, r, n, i) {
                            return {
                                x: t1,
                                y: e1,
                                zoom: 1 / 0,
                                id: r,
                                parentId: -1,
                                numPoints: n,
                                properties: i
                            };
                        }
                        function H(t1, e1) {
                            var r = t1.geometry.coordinates, n = r[0], i = r[1];
                            return {
                                x: Y(n),
                                y: W(i),
                                zoom: 1 / 0,
                                index: e1,
                                parentId: -1
                            };
                        }
                        function q(t1) {
                            var e1, r, n;
                            return {
                                type: "Feature",
                                id: t1.id,
                                properties: G(t1),
                                geometry: {
                                    type: "Point",
                                    coordinates: [
                                        (n = t1.x, 360 * (n - .5)),
                                        (e1 = t1.y, r = (180 - 360 * e1) * Math.PI / 180, 360 * Math.atan(Math.exp(r)) / Math.PI - 90)
                                    ]
                                }
                            };
                        }
                        function G(t1) {
                            var e1 = t1.numPoints, r = e1 >= 1e4 ? Math.round(e1 / 1e3) + "k" : e1 >= 1e3 ? Math.round(e1 / 100) / 10 + "k" : e1;
                            return X(X({}, t1.properties), {
                                cluster: !0,
                                cluster_id: t1.id,
                                point_count: e1,
                                point_count_abbreviated: r
                            });
                        }
                        function Y(t1) {
                            return t1 / 360 + .5;
                        }
                        function W(t1) {
                            var e1 = Math.sin(t1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + e1) / (1 - e1)) / Math.PI;
                            return r < 0 ? 0 : r > 1 ? 1 : r;
                        }
                        function X(t1, e1) {
                            for(var r in e1)t1[r] = e1[r];
                            return t1;
                        }
                        function Z(t1) {
                            return t1.x;
                        }
                        function J(t1) {
                            return t1.y;
                        }
                        function K(t1, e1, r, n, i, a) {
                            var o = i - r, s = a - n;
                            if (0 !== o || 0 !== s) {
                                var l = ((t1 - r) * o + (e1 - n) * s) / (o * o + s * s);
                                l > 1 ? (r = i, n = a) : l > 0 && (r += o * l, n += s * l);
                            }
                            return (o = t1 - r) * o + (s = e1 - n) * s;
                        }
                        function Q(t1, e1, r, n) {
                            var i = {
                                id: void 0 === t1 ? null : t1,
                                type: e1,
                                geometry: r,
                                tags: n,
                                minX: 1 / 0,
                                minY: 1 / 0,
                                maxX: -1 / 0,
                                maxY: -1 / 0
                            };
                            return function(t1) {
                                var e1 = t1.geometry, r = t1.type;
                                if ("Point" === r || "MultiPoint" === r || "LineString" === r) $(t1, e1);
                                else if ("Polygon" === r || "MultiLineString" === r) for(var n = 0; n < e1.length; n++)$(t1, e1[n]);
                                else if ("MultiPolygon" === r) for(n = 0; n < e1.length; n++)for(var i = 0; i < e1[n].length; i++)$(t1, e1[n][i]);
                            }(i), i;
                        }
                        function $(t1, e1) {
                            for(var r = 0; r < e1.length; r += 3)t1.minX = Math.min(t1.minX, e1[r]), t1.minY = Math.min(t1.minY, e1[r + 1]), t1.maxX = Math.max(t1.maxX, e1[r]), t1.maxY = Math.max(t1.maxY, e1[r + 1]);
                        }
                        function tt(t1, e1, r, n) {
                            if (e1.geometry) {
                                var i = e1.geometry.coordinates, a = e1.geometry.type, o = Math.pow(r.tolerance / ((1 << r.maxZoom) * r.extent), 2), s = [], l = e1.id;
                                if (r.promoteId ? l = e1.properties[r.promoteId] : r.generateId && (l = n || 0), "Point" === a) et(i, s);
                                else if ("MultiPoint" === a) for(var c = 0; c < i.length; c++)et(i[c], s);
                                else if ("LineString" === a) rt(i, s, o, !1);
                                else if ("MultiLineString" === a) {
                                    if (r.lineMetrics) {
                                        for(c = 0; c < i.length; c++)s = [], rt(i[c], s, o, !1), t1.push(Q(l, "LineString", s, e1.properties));
                                        return;
                                    }
                                    nt(i, s, o, !1);
                                } else if ("Polygon" === a) nt(i, s, o, !0);
                                else {
                                    if ("MultiPolygon" !== a) {
                                        if ("GeometryCollection" === a) {
                                            for(c = 0; c < e1.geometry.geometries.length; c++)tt(t1, {
                                                id: l,
                                                geometry: e1.geometry.geometries[c],
                                                properties: e1.properties
                                            }, r, n);
                                            return;
                                        }
                                        throw new Error("Input data is not a valid GeoJSON object.");
                                    }
                                    for(c = 0; c < i.length; c++){
                                        var u = [];
                                        nt(i[c], u, o, !0), s.push(u);
                                    }
                                }
                                t1.push(Q(l, a, s, e1.properties));
                            }
                        }
                        function et(t1, e1) {
                            e1.push(it(t1[0])), e1.push(at(t1[1])), e1.push(0);
                        }
                        function rt(t1, e1, r, n) {
                            for(var i, a, o = 0, s = 0; s < t1.length; s++){
                                var l = it(t1[s][0]), c = at(t1[s][1]);
                                e1.push(l), e1.push(c), e1.push(0), s > 0 && (o += n ? (i * c - l * a) / 2 : Math.sqrt(Math.pow(l - i, 2) + Math.pow(c - a, 2))), i = l, a = c;
                            }
                            var u = e1.length - 3;
                            e1[2] = 1, function t1(e1, r, n, i) {
                                for(var a, o = i, s = n - r >> 1, l = n - r, c = e1[r], u = e1[r + 1], f = e1[n], h = e1[n + 1], p = r + 3; p < n; p += 3){
                                    var d = K(e1[p], e1[p + 1], c, u, f, h);
                                    if (d > o) a = p, o = d;
                                    else if (d === o) {
                                        var m = Math.abs(p - s);
                                        m < l && (a = p, l = m);
                                    }
                                }
                                o > i && (a - r > 3 && t1(e1, r, a, i), e1[a + 2] = o, n - a > 3 && t1(e1, a, n, i));
                            }(e1, 0, u, r), e1[u + 2] = 1, e1.size = Math.abs(o), e1.start = 0, e1.end = e1.size;
                        }
                        function nt(t1, e1, r, n) {
                            for(var i = 0; i < t1.length; i++){
                                var a = [];
                                rt(t1[i], a, r, n), e1.push(a);
                            }
                        }
                        function it(t1) {
                            return t1 / 360 + .5;
                        }
                        function at(t1) {
                            var e1 = Math.sin(t1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + e1) / (1 - e1)) / Math.PI;
                            return r < 0 ? 0 : r > 1 ? 1 : r;
                        }
                        function ot(t1, e1, r, n, i, a, o, s) {
                            if (n /= e1, a >= (r /= e1) && o < n) return t1;
                            if (o < r || a >= n) return null;
                            for(var l = [], c = 0; c < t1.length; c++){
                                var u = t1[c], f = u.geometry, h = u.type, p = 0 === i ? u.minX : u.minY, d = 0 === i ? u.maxX : u.maxY;
                                if (p >= r && d < n) l.push(u);
                                else if (!(d < r || p >= n)) {
                                    var m = [];
                                    if ("Point" === h || "MultiPoint" === h) st(f, m, r, n, i);
                                    else if ("LineString" === h) lt(f, m, r, n, i, !1, s.lineMetrics);
                                    else if ("MultiLineString" === h) ut(f, m, r, n, i, !1);
                                    else if ("Polygon" === h) ut(f, m, r, n, i, !0);
                                    else if ("MultiPolygon" === h) for(var g = 0; g < f.length; g++){
                                        var v = [];
                                        ut(f[g], v, r, n, i, !0), v.length && m.push(v);
                                    }
                                    if (m.length) {
                                        if (s.lineMetrics && "LineString" === h) {
                                            for(g = 0; g < m.length; g++)l.push(Q(u.id, h, m[g], u.tags));
                                            continue;
                                        }
                                        "LineString" !== h && "MultiLineString" !== h || (1 === m.length ? (h = "LineString", m = m[0]) : h = "MultiLineString"), "Point" !== h && "MultiPoint" !== h || (h = 3 === m.length ? "Point" : "MultiPoint"), l.push(Q(u.id, h, m, u.tags));
                                    }
                                }
                            }
                            return l.length ? l : null;
                        }
                        function st(t1, e1, r, n, i) {
                            for(var a = 0; a < t1.length; a += 3){
                                var o = t1[a + i];
                                o >= r && o <= n && (e1.push(t1[a]), e1.push(t1[a + 1]), e1.push(t1[a + 2]));
                            }
                        }
                        function lt(t1, e1, r, n, i, a, o) {
                            for(var s, l, c = ct(t1), u = 0 === i ? ht : pt, f = t1.start, h = 0; h < t1.length - 3; h += 3){
                                var p = t1[h], d = t1[h + 1], m = t1[h + 2], g = t1[h + 3], v = t1[h + 4], y = 0 === i ? p : d, x = 0 === i ? g : v, b = !1;
                                o && (s = Math.sqrt(Math.pow(p - g, 2) + Math.pow(d - v, 2))), y < r ? x > r && (l = u(c, p, d, g, v, r), o && (c.start = f + s * l)) : y > n ? x < n && (l = u(c, p, d, g, v, n), o && (c.start = f + s * l)) : ft(c, p, d, m), x < r && y >= r && (l = u(c, p, d, g, v, r), b = !0), x > n && y <= n && (l = u(c, p, d, g, v, n), b = !0), !a && b && (o && (c.end = f + s * l), e1.push(c), c = ct(t1)), o && (f += s);
                            }
                            var _ = t1.length - 3;
                            p = t1[_], d = t1[_ + 1], m = t1[_ + 2], (y = 0 === i ? p : d) >= r && y <= n && ft(c, p, d, m), _ = c.length - 3, a && _ >= 3 && (c[_] !== c[0] || c[_ + 1] !== c[1]) && ft(c, c[0], c[1], c[2]), c.length && e1.push(c);
                        }
                        function ct(t1) {
                            var e1 = [];
                            return e1.size = t1.size, e1.start = t1.start, e1.end = t1.end, e1;
                        }
                        function ut(t1, e1, r, n, i, a) {
                            for(var o = 0; o < t1.length; o++)lt(t1[o], e1, r, n, i, a, !1);
                        }
                        function ft(t1, e1, r, n) {
                            t1.push(e1), t1.push(r), t1.push(n);
                        }
                        function ht(t1, e1, r, n, i, a) {
                            var o = (a - e1) / (n - e1);
                            return t1.push(a), t1.push(r + (i - r) * o), t1.push(1), o;
                        }
                        function pt(t1, e1, r, n, i, a) {
                            var o = (a - r) / (i - r);
                            return t1.push(e1 + (n - e1) * o), t1.push(a), t1.push(1), o;
                        }
                        function dt(t1, e1) {
                            for(var r = [], n = 0; n < t1.length; n++){
                                var i, a = t1[n], o = a.type;
                                if ("Point" === o || "MultiPoint" === o || "LineString" === o) i = mt(a.geometry, e1);
                                else if ("MultiLineString" === o || "Polygon" === o) {
                                    i = [];
                                    for(var s = 0; s < a.geometry.length; s++)i.push(mt(a.geometry[s], e1));
                                } else if ("MultiPolygon" === o) for(i = [], s = 0; s < a.geometry.length; s++){
                                    for(var l = [], c = 0; c < a.geometry[s].length; c++)l.push(mt(a.geometry[s][c], e1));
                                    i.push(l);
                                }
                                r.push(Q(a.id, o, i, a.tags));
                            }
                            return r;
                        }
                        function mt(t1, e1) {
                            var r = [];
                            r.size = t1.size, void 0 !== t1.start && (r.start = t1.start, r.end = t1.end);
                            for(var n = 0; n < t1.length; n += 3)r.push(t1[n] + e1, t1[n + 1], t1[n + 2]);
                            return r;
                        }
                        function gt(t1, e1) {
                            if (t1.transformed) return t1;
                            var r, n, i, a = 1 << t1.z, o = t1.x, s = t1.y;
                            for(r = 0; r < t1.features.length; r++){
                                var l = t1.features[r], c = l.geometry, u = l.type;
                                if (l.geometry = [], 1 === u) for(n = 0; n < c.length; n += 2)l.geometry.push(vt(c[n], c[n + 1], e1, a, o, s));
                                else for(n = 0; n < c.length; n++){
                                    var f = [];
                                    for(i = 0; i < c[n].length; i += 2)f.push(vt(c[n][i], c[n][i + 1], e1, a, o, s));
                                    l.geometry.push(f);
                                }
                            }
                            return t1.transformed = !0, t1;
                        }
                        function vt(t1, e1, r, n, i, a) {
                            return [
                                Math.round(r * (t1 * n - i)),
                                Math.round(r * (e1 * n - a))
                            ];
                        }
                        function yt(t1, e1, r, n, i) {
                            for(var a = e1 === i.maxZoom ? 0 : i.tolerance / ((1 << e1) * i.extent), o = {
                                features: [],
                                numPoints: 0,
                                numSimplified: 0,
                                numFeatures: 0,
                                source: null,
                                x: r,
                                y: n,
                                z: e1,
                                transformed: !1,
                                minX: 2,
                                minY: 1,
                                maxX: -1,
                                maxY: 0
                            }, s = 0; s < t1.length; s++){
                                o.numFeatures++, xt(o, t1[s], a, i);
                                var l = t1[s].minX, c = t1[s].minY, u = t1[s].maxX, f = t1[s].maxY;
                                l < o.minX && (o.minX = l), c < o.minY && (o.minY = c), u > o.maxX && (o.maxX = u), f > o.maxY && (o.maxY = f);
                            }
                            return o;
                        }
                        function xt(t1, e1, r, n) {
                            var i = e1.geometry, a = e1.type, o = [];
                            if ("Point" === a || "MultiPoint" === a) for(var s = 0; s < i.length; s += 3)o.push(i[s]), o.push(i[s + 1]), t1.numPoints++, t1.numSimplified++;
                            else if ("LineString" === a) bt(o, i, t1, r, !1, !1);
                            else if ("MultiLineString" === a || "Polygon" === a) for(s = 0; s < i.length; s++)bt(o, i[s], t1, r, "Polygon" === a, 0 === s);
                            else if ("MultiPolygon" === a) for(var l = 0; l < i.length; l++){
                                var c = i[l];
                                for(s = 0; s < c.length; s++)bt(o, c[s], t1, r, !0, 0 === s);
                            }
                            if (o.length) {
                                var u = e1.tags || null;
                                if ("LineString" === a && n.lineMetrics) {
                                    for(var f in u = {}, e1.tags)u[f] = e1.tags[f];
                                    u.mapbox_clip_start = i.start / i.size, u.mapbox_clip_end = i.end / i.size;
                                }
                                var h = {
                                    geometry: o,
                                    type: "Polygon" === a || "MultiPolygon" === a ? 3 : "LineString" === a || "MultiLineString" === a ? 2 : 1,
                                    tags: u
                                };
                                null !== e1.id && (h.id = e1.id), t1.features.push(h);
                            }
                        }
                        function bt(t1, e1, r, n, i, a) {
                            var o = n * n;
                            if (n > 0 && e1.size < (i ? o : n)) r.numPoints += e1.length / 3;
                            else {
                                for(var s = [], l = 0; l < e1.length; l += 3)(0 === n || e1[l + 2] > o) && (r.numSimplified++, s.push(e1[l]), s.push(e1[l + 1])), r.numPoints++;
                                i && function(t1, e1) {
                                    for(var r = 0, n = 0, i = t1.length, a = i - 2; n < i; a = n, n += 2)r += (t1[n] - t1[a]) * (t1[n + 1] + t1[a + 1]);
                                    if (r > 0 === e1) for(n = 0, i = t1.length; n < i / 2; n += 2){
                                        var o = t1[n], s = t1[n + 1];
                                        t1[n] = t1[i - 2 - n], t1[n + 1] = t1[i - 1 - n], t1[i - 2 - n] = o, t1[i - 1 - n] = s;
                                    }
                                }(s, a), t1.push(s);
                            }
                        }
                        function _t(t1, e1) {
                            var r = (e1 = this.options = function(t1, e1) {
                                for(var r in e1)t1[r] = e1[r];
                                return t1;
                            }(Object.create(this.options), e1)).debug;
                            if (r && console.time("preprocess data"), e1.maxZoom < 0 || e1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                            if (e1.promoteId && e1.generateId) throw new Error("promoteId and generateId cannot be used together.");
                            var n = function(t1, e1) {
                                var r = [];
                                if ("FeatureCollection" === t1.type) for(var n = 0; n < t1.features.length; n++)tt(r, t1.features[n], e1, n);
                                else "Feature" === t1.type ? tt(r, t1, e1) : tt(r, {
                                    geometry: t1
                                }, e1);
                                return r;
                            }(t1, e1);
                            this.tiles = {}, this.tileCoords = [], r && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", e1.indexMaxZoom, e1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), (n = function(t1, e1) {
                                var r = e1.buffer / e1.extent, n = t1, i = ot(t1, 1, -1 - r, r, 0, -1, 2, e1), a = ot(t1, 1, 1 - r, 2 + r, 0, -1, 2, e1);
                                return (i || a) && (n = ot(t1, 1, -r, 1 + r, 0, -1, 2, e1) || [], i && (n = dt(i, 1).concat(n)), a && (n = n.concat(dt(a, -1)))), n;
                            }(n, e1)).length && this.splitTile(n, 0, 0, 0), r && (n.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
                        }
                        function wt(t1, e1, r) {
                            return 32 * ((1 << t1) * r + e1) + t1;
                        }
                        function Tt(t1, e1) {
                            var r = t1.tileID.canonical;
                            if (!this._geoJSONIndex) return e1(null, null);
                            var n = this._geoJSONIndex.getTile(r.z, r.x, r.y);
                            if (!n) return e1(null, null);
                            var i = new g(n.features), a = _(i);
                            0 === a.byteOffset && a.byteLength === a.buffer.byteLength || (a = new Uint8Array(a)), e1(null, {
                                vectorTile: i,
                                rawData: a.buffer
                            });
                        }
                        U.prototype.load = function(t1) {
                            var e1 = this.options, r = e1.log, n = e1.minZoom, i = e1.maxZoom, a = e1.nodeSize;
                            r && console.time("total time");
                            var o = "prepare " + t1.length + " points";
                            r && console.time(o), this.points = t1;
                            for(var s = [], l = 0; l < t1.length; l++)t1[l].geometry && s.push(H(t1[l], l));
                            this.trees[i + 1] = new N(s, Z, J, a, Float32Array), r && console.timeEnd(o);
                            for(var c = i; c >= n; c--){
                                var u = +Date.now();
                                s = this._cluster(s, c), this.trees[c] = new N(s, Z, J, a, Float32Array), r && console.log("z%d: %d clusters in %dms", c, s.length, +Date.now() - u);
                            }
                            return r && console.timeEnd("total time"), this;
                        }, U.prototype.getClusters = function(t1, e1) {
                            var r = ((t1[0] + 180) % 360 + 360) % 360 - 180, n = Math.max(-90, Math.min(90, t1[1])), i = 180 === t1[2] ? 180 : ((t1[2] + 180) % 360 + 360) % 360 - 180, a = Math.max(-90, Math.min(90, t1[3]));
                            if (t1[2] - t1[0] >= 360) r = -180, i = 180;
                            else if (r > i) {
                                var o = this.getClusters([
                                    r,
                                    n,
                                    180,
                                    a
                                ], e1), s = this.getClusters([
                                    -180,
                                    n,
                                    i,
                                    a
                                ], e1);
                                return o.concat(s);
                            }
                            for(var l = this.trees[this._limitZoom(e1)], c = [], u = 0, f = l.range(Y(r), W(a), Y(i), W(n)); u < f.length; u += 1){
                                var h = f[u], p = l.points[h];
                                c.push(p.numPoints ? q(p) : this.points[p.index]);
                            }
                            return c;
                        }, U.prototype.getChildren = function(t1) {
                            var e1 = this._getOriginId(t1), r = this._getOriginZoom(t1), n = "No cluster with the specified id.", i = this.trees[r];
                            if (!i) throw new Error(n);
                            var a = i.points[e1];
                            if (!a) throw new Error(n);
                            for(var o = this.options.radius / (this.options.extent * Math.pow(2, r - 1)), s = [], l = 0, c = i.within(a.x, a.y, o); l < c.length; l += 1){
                                var u = c[l], f = i.points[u];
                                f.parentId === t1 && s.push(f.numPoints ? q(f) : this.points[f.index]);
                            }
                            if (0 === s.length) throw new Error(n);
                            return s;
                        }, U.prototype.getLeaves = function(t1, e1, r) {
                            e1 = e1 || 10, r = r || 0;
                            var n = [];
                            return this._appendLeaves(n, t1, e1, r, 0), n;
                        }, U.prototype.getTile = function(t1, e1, r) {
                            var n = this.trees[this._limitZoom(t1)], i = Math.pow(2, t1), a = this.options, o = a.extent, s = a.radius / o, l = (r - s) / i, c = (r + 1 + s) / i, u = {
                                features: []
                            };
                            return this._addTileFeatures(n.range((e1 - s) / i, l, (e1 + 1 + s) / i, c), n.points, e1, r, i, u), 0 === e1 && this._addTileFeatures(n.range(1 - s / i, l, 1, c), n.points, i, r, i, u), e1 === i - 1 && this._addTileFeatures(n.range(0, l, s / i, c), n.points, -1, r, i, u), u.features.length ? u : null;
                        }, U.prototype.getClusterExpansionZoom = function(t1) {
                            for(var e1 = this._getOriginZoom(t1) - 1; e1 <= this.options.maxZoom;){
                                var r = this.getChildren(t1);
                                if (e1++, 1 !== r.length) break;
                                t1 = r[0].properties.cluster_id;
                            }
                            return e1;
                        }, U.prototype._appendLeaves = function(t1, e1, r, n, i) {
                            for(var a = 0, o = this.getChildren(e1); a < o.length; a += 1){
                                var s = o[a], l = s.properties;
                                if (l && l.cluster ? i + l.point_count <= n ? i += l.point_count : i = this._appendLeaves(t1, l.cluster_id, r, n, i) : i < n ? i++ : t1.push(s), t1.length === r) break;
                            }
                            return i;
                        }, U.prototype._addTileFeatures = function(t1, e1, r, n, i, a) {
                            for(var o = 0, s = t1; o < s.length; o += 1){
                                var l = e1[s[o]], c = l.numPoints, u = {
                                    type: 1,
                                    geometry: [
                                        [
                                            Math.round(this.options.extent * (l.x * i - r)),
                                            Math.round(this.options.extent * (l.y * i - n))
                                        ]
                                    ],
                                    tags: c ? G(l) : this.points[l.index].properties
                                }, f = void 0;
                                c ? f = l.id : this.options.generateId ? f = l.index : this.points[l.index].id && (f = this.points[l.index].id), void 0 !== f && (u.id = f), a.features.push(u);
                            }
                        }, U.prototype._limitZoom = function(t1) {
                            return Math.max(this.options.minZoom, Math.min(t1, this.options.maxZoom + 1));
                        }, U.prototype._cluster = function(t1, e1) {
                            for(var r = [], n = this.options, i = n.radius, a = n.extent, o = n.reduce, s = i / (a * Math.pow(2, e1)), l = 0; l < t1.length; l++){
                                var c = t1[l];
                                if (!(c.zoom <= e1)) {
                                    c.zoom = e1;
                                    for(var u = this.trees[e1 + 1], f = u.within(c.x, c.y, s), h = c.numPoints || 1, p = c.x * h, d = c.y * h, m = o && h > 1 ? this._map(c, !0) : null, g = (l << 5) + (e1 + 1) + this.points.length, v = 0, y = f; v < y.length; v += 1){
                                        var x = y[v], b = u.points[x];
                                        if (!(b.zoom <= e1)) {
                                            b.zoom = e1;
                                            var _ = b.numPoints || 1;
                                            p += b.x * _, d += b.y * _, h += _, b.parentId = g, o && (m || (m = this._map(c, !0)), o(m, this._map(b)));
                                        }
                                    }
                                    1 === h ? r.push(c) : (c.parentId = g, r.push(V(p / h, d / h, g, h, m)));
                                }
                            }
                            return r;
                        }, U.prototype._getOriginId = function(t1) {
                            return t1 - this.points.length >> 5;
                        }, U.prototype._getOriginZoom = function(t1) {
                            return (t1 - this.points.length) % 32;
                        }, U.prototype._map = function(t1, e1) {
                            if (t1.numPoints) return e1 ? X({}, t1.properties) : t1.properties;
                            var r = this.points[t1.index].properties, n = this.options.map(r);
                            return e1 && n === r ? X({}, n) : n;
                        }, _t.prototype.options = {
                            maxZoom: 14,
                            indexMaxZoom: 5,
                            indexMaxPoints: 1e5,
                            tolerance: 3,
                            extent: 4096,
                            buffer: 64,
                            lineMetrics: !1,
                            promoteId: null,
                            generateId: !1,
                            debug: 0
                        }, _t.prototype.splitTile = function(t1, e1, r, n, i, a, o) {
                            for(var s = [
                                t1,
                                e1,
                                r,
                                n
                            ], l = this.options, c = l.debug; s.length;){
                                n = s.pop(), r = s.pop(), e1 = s.pop(), t1 = s.pop();
                                var u = 1 << e1, f = wt(e1, r, n), h = this.tiles[f];
                                if (!h && (c > 1 && console.time("creation"), h = this.tiles[f] = yt(t1, e1, r, n, l), this.tileCoords.push({
                                    z: e1,
                                    x: r,
                                    y: n
                                }), c)) {
                                    c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", e1, r, n, h.numFeatures, h.numPoints, h.numSimplified), console.timeEnd("creation"));
                                    var p = "z" + e1;
                                    this.stats[p] = (this.stats[p] || 0) + 1, this.total++;
                                }
                                if (h.source = t1, i) {
                                    if (e1 === l.maxZoom || e1 === i) continue;
                                    var d = 1 << i - e1;
                                    if (r !== Math.floor(a / d) || n !== Math.floor(o / d)) continue;
                                } else if (e1 === l.indexMaxZoom || h.numPoints <= l.indexMaxPoints) continue;
                                if (h.source = null, 0 !== t1.length) {
                                    c > 1 && console.time("clipping");
                                    var m, g, v, y, x, b, _ = .5 * l.buffer / l.extent, w = .5 - _, T = .5 + _, k = 1 + _;
                                    m = g = v = y = null, x = ot(t1, u, r - _, r + T, 0, h.minX, h.maxX, l), b = ot(t1, u, r + w, r + k, 0, h.minX, h.maxX, l), t1 = null, x && (m = ot(x, u, n - _, n + T, 1, h.minY, h.maxY, l), g = ot(x, u, n + w, n + k, 1, h.minY, h.maxY, l), x = null), b && (v = ot(b, u, n - _, n + T, 1, h.minY, h.maxY, l), y = ot(b, u, n + w, n + k, 1, h.minY, h.maxY, l), b = null), c > 1 && console.timeEnd("clipping"), s.push(m || [], e1 + 1, 2 * r, 2 * n), s.push(g || [], e1 + 1, 2 * r, 2 * n + 1), s.push(v || [], e1 + 1, 2 * r + 1, 2 * n), s.push(y || [], e1 + 1, 2 * r + 1, 2 * n + 1);
                                }
                            }
                        }, _t.prototype.getTile = function(t1, e1, r) {
                            var n = this.options, i = n.extent, a = n.debug;
                            if (t1 < 0 || t1 > 24) return null;
                            var o = 1 << t1, s = wt(t1, e1 = (e1 % o + o) % o, r);
                            if (this.tiles[s]) return gt(this.tiles[s], i);
                            a > 1 && console.log("drilling down to z%d-%d-%d", t1, e1, r);
                            for(var l, c = t1, u = e1, f = r; !l && c > 0;)c--, u = Math.floor(u / 2), f = Math.floor(f / 2), l = this.tiles[wt(c, u, f)];
                            return l && l.source ? (a > 1 && console.log("found parent tile z%d-%d-%d", c, u, f), a > 1 && console.time("drilling down"), this.splitTile(l.source, c, u, f, t1, e1, r), a > 1 && console.timeEnd("drilling down"), this.tiles[s] ? gt(this.tiles[s], i) : null) : null;
                        };
                        var kt = function(e1) {
                            function r(t1, r, n, i) {
                                e1.call(this, t1, r, n, Tt), i && (this.loadGeoJSON = i);
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.loadData = function(t1, e1) {
                                this._pendingCallback && this._pendingCallback(null, {
                                    abandoned: !0
                                }), this._pendingCallback = e1, this._pendingLoadDataParams = t1, this._state && "Idle" !== this._state ? this._state = "NeedsLoadData" : (this._state = "Coalescing", this._loadData());
                            }, r.prototype._loadData = function() {
                                var e1 = this;
                                if (this._pendingCallback && this._pendingLoadDataParams) {
                                    var r = this._pendingCallback, n = this._pendingLoadDataParams;
                                    delete this._pendingCallback, delete this._pendingLoadDataParams;
                                    var i = !!(n && n.request && n.request.collectResourceTiming) && new t1.RequestPerformance(n.request);
                                    this.loadGeoJSON(n, function(a, o) {
                                        if (a || !o) return r(a);
                                        if ("object" != typeof o) return r(new Error("Input data given to '" + n.source + "' is not a valid GeoJSON object."));
                                        f(o, !0);
                                        try {
                                            e1._geoJSONIndex = n.cluster ? new U(function(e1) {
                                                var r = e1.superclusterOptions, n = e1.clusterProperties;
                                                if (!n || !r) return r;
                                                for(var i = {}, a = {}, o = {
                                                    accumulated: null,
                                                    zoom: 0
                                                }, s = {
                                                    properties: null
                                                }, l = Object.keys(n), c = 0, u = l; c < u.length; c += 1){
                                                    var f = u[c], h = n[f], p = h[0], d = h[1], m = t1.createExpression(d), g = t1.createExpression("string" == typeof p ? [
                                                        p,
                                                        [
                                                            "accumulated"
                                                        ],
                                                        [
                                                            "get",
                                                            f
                                                        ]
                                                    ] : p);
                                                    i[f] = m.value, a[f] = g.value;
                                                }
                                                return r.map = function(t1) {
                                                    s.properties = t1;
                                                    for(var e1 = {}, r = 0, n = l; r < n.length; r += 1){
                                                        var a = n[r];
                                                        e1[a] = i[a].evaluate(o, s);
                                                    }
                                                    return e1;
                                                }, r.reduce = function(t1, e1) {
                                                    s.properties = e1;
                                                    for(var r = 0, n = l; r < n.length; r += 1){
                                                        var i = n[r];
                                                        o.accumulated = t1[i], t1[i] = a[i].evaluate(o, s);
                                                    }
                                                }, r;
                                            }(n)).load(o.features) : function(t1, e1) {
                                                return new _t(t1, e1);
                                            }(o, n.geojsonVtOptions);
                                        } catch (a) {
                                            return r(a);
                                        }
                                        e1.loaded = {};
                                        var s = {};
                                        if (i) {
                                            var l = i.finish();
                                            l && (s.resourceTiming = {}, s.resourceTiming[n.source] = JSON.parse(JSON.stringify(l)));
                                        }
                                        r(null, s);
                                    });
                                }
                            }, r.prototype.coalesce = function() {
                                "Coalescing" === this._state ? this._state = "Idle" : "NeedsLoadData" === this._state && (this._state = "Coalescing", this._loadData());
                            }, r.prototype.reloadTile = function(t1, r) {
                                var n = this.loaded, i = t1.uid;
                                return n && n[i] ? e1.prototype.reloadTile.call(this, t1, r) : this.loadTile(t1, r);
                            }, r.prototype.loadGeoJSON = function(e1, r) {
                                if (e1.request) t1.getJSON(e1.request, r);
                                else {
                                    if ("string" != typeof e1.data) return r(new Error("Input data given to '" + e1.source + "' is not a valid GeoJSON object."));
                                    try {
                                        return r(null, JSON.parse(e1.data));
                                    } catch (t1) {
                                        return r(new Error("Input data given to '" + e1.source + "' is not a valid GeoJSON object."));
                                    }
                                }
                            }, r.prototype.removeSource = function(t1, e1) {
                                this._pendingCallback && this._pendingCallback(null, {
                                    abandoned: !0
                                }), e1();
                            }, r.prototype.getClusterExpansionZoom = function(t1, e1) {
                                try {
                                    e1(null, this._geoJSONIndex.getClusterExpansionZoom(t1.clusterId));
                                } catch (t1) {
                                    e1(t1);
                                }
                            }, r.prototype.getClusterChildren = function(t1, e1) {
                                try {
                                    e1(null, this._geoJSONIndex.getChildren(t1.clusterId));
                                } catch (t1) {
                                    e1(t1);
                                }
                            }, r.prototype.getClusterLeaves = function(t1, e1) {
                                try {
                                    e1(null, this._geoJSONIndex.getLeaves(t1.clusterId, t1.limit, t1.offset));
                                } catch (t1) {
                                    e1(t1);
                                }
                            }, r;
                        }(l);
                        var At = function(e1) {
                            var r = this;
                            this.self = e1, this.actor = new t1.Actor(e1, this), this.layerIndexes = {}, this.availableImages = {}, this.workerSourceTypes = {
                                vector: l,
                                geojson: kt
                            }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = function(t1, e1) {
                                if (r.workerSourceTypes[t1]) throw new Error('Worker source with name "' + t1 + '" already registered.');
                                r.workerSourceTypes[t1] = e1;
                            }, this.self.registerRTLTextPlugin = function(e1) {
                                if (t1.plugin.isParsed()) throw new Error("RTL text plugin already registered.");
                                t1.plugin.applyArabicShaping = e1.applyArabicShaping, t1.plugin.processBidirectionalText = e1.processBidirectionalText, t1.plugin.processStyledBidirectionalText = e1.processStyledBidirectionalText;
                            };
                        };
                        return At.prototype.setReferrer = function(t1, e1) {
                            this.referrer = e1;
                        }, At.prototype.setImages = function(t1, e1, r) {
                            for(var n in this.availableImages[t1] = e1, this.workerSources[t1]){
                                var i = this.workerSources[t1][n];
                                for(var a in i)i[a].availableImages = e1;
                            }
                            r();
                        }, At.prototype.setLayers = function(t1, e1, r) {
                            this.getLayerIndex(t1).replace(e1), r();
                        }, At.prototype.updateLayers = function(t1, e1, r) {
                            this.getLayerIndex(t1).update(e1.layers, e1.removedIds), r();
                        }, At.prototype.loadTile = function(t1, e1, r) {
                            this.getWorkerSource(t1, e1.type, e1.source).loadTile(e1, r);
                        }, At.prototype.loadDEMTile = function(t1, e1, r) {
                            this.getDEMWorkerSource(t1, e1.source).loadTile(e1, r);
                        }, At.prototype.reloadTile = function(t1, e1, r) {
                            this.getWorkerSource(t1, e1.type, e1.source).reloadTile(e1, r);
                        }, At.prototype.abortTile = function(t1, e1, r) {
                            this.getWorkerSource(t1, e1.type, e1.source).abortTile(e1, r);
                        }, At.prototype.removeTile = function(t1, e1, r) {
                            this.getWorkerSource(t1, e1.type, e1.source).removeTile(e1, r);
                        }, At.prototype.removeDEMTile = function(t1, e1) {
                            this.getDEMWorkerSource(t1, e1.source).removeTile(e1);
                        }, At.prototype.removeSource = function(t1, e1, r) {
                            if (this.workerSources[t1] && this.workerSources[t1][e1.type] && this.workerSources[t1][e1.type][e1.source]) {
                                var n = this.workerSources[t1][e1.type][e1.source];
                                delete this.workerSources[t1][e1.type][e1.source], void 0 !== n.removeSource ? n.removeSource(e1, r) : r();
                            }
                        }, At.prototype.loadWorkerSource = function(t1, e1, r) {
                            try {
                                this.self.importScripts(e1.url), r();
                            } catch (t1) {
                                r(t1.toString());
                            }
                        }, At.prototype.syncRTLPluginState = function(e1, r, n) {
                            try {
                                t1.plugin.setState(r);
                                var i = t1.plugin.getPluginURL();
                                if (t1.plugin.isLoaded() && !t1.plugin.isParsed() && null != i) {
                                    this.self.importScripts(i);
                                    var a = t1.plugin.isParsed();
                                    n(a ? void 0 : new Error("RTL Text Plugin failed to import scripts from " + i), a);
                                }
                            } catch (t1) {
                                n(t1.toString());
                            }
                        }, At.prototype.getAvailableImages = function(t1) {
                            var e1 = this.availableImages[t1];
                            return e1 || (e1 = []), e1;
                        }, At.prototype.getLayerIndex = function(t1) {
                            var e1 = this.layerIndexes[t1];
                            return e1 || (e1 = this.layerIndexes[t1] = new n), e1;
                        }, At.prototype.getWorkerSource = function(t1, e1, r) {
                            var n = this;
                            if (this.workerSources[t1] || (this.workerSources[t1] = {}), this.workerSources[t1][e1] || (this.workerSources[t1][e1] = {}), !this.workerSources[t1][e1][r]) {
                                var i = {
                                    send: function(e1, r, i) {
                                        n.actor.send(e1, r, i, t1);
                                    }
                                };
                                this.workerSources[t1][e1][r] = new this.workerSourceTypes[e1](i, this.getLayerIndex(t1), this.getAvailableImages(t1));
                            }
                            return this.workerSources[t1][e1][r];
                        }, At.prototype.getDEMWorkerSource = function(t1, e1) {
                            return this.demWorkerSources[t1] || (this.demWorkerSources[t1] = {}), this.demWorkerSources[t1][e1] || (this.demWorkerSources[t1][e1] = new u), this.demWorkerSources[t1][e1];
                        }, At.prototype.enforceCacheSizeLimit = function(e1, r) {
                            t1.enforceCacheSizeLimit(r);
                        }, "undefined" != typeof WorkerGlobalScope && void 0 !== t1.window && t1.window instanceof WorkerGlobalScope && (t1.window.worker = new At(t1.window)), At;
                    }), n(0, function(t1) {
                        var e1 = t1.createCommonjsModule(function(t1) {
                            function e1(t1) {
                                return !r(t1);
                            }
                            function r(t1) {
                                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray ? Function.prototype && Function.prototype.bind ? Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions ? "JSON" in window && "parse" in JSON && "stringify" in JSON ? function() {
                                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                                    var t1, e1, r = new Blob([
                                        ""
                                    ], {
                                        type: "text/javascript"
                                    }), n = URL.createObjectURL(r);
                                    try {
                                        e1 = new Worker(n), t1 = !0;
                                    } catch (e1) {
                                        t1 = !1;
                                    }
                                    e1 && e1.terminate();
                                    return URL.revokeObjectURL(n), t1;
                                }() ? "Uint8ClampedArray" in window ? ArrayBuffer.isView ? function() {
                                    var t1 = document.createElement("canvas");
                                    t1.width = t1.height = 1;
                                    var e1 = t1.getContext("2d");
                                    if (!e1) return !1;
                                    var r = e1.getImageData(0, 0, 1, 1);
                                    return r && r.width === t1.width;
                                }() ? function(t1) {
                                    void 0 === n[t1] && (n[t1] = function(t1) {
                                        var r = function(t1) {
                                            var r = document.createElement("canvas"), n = Object.create(e1.webGLContextAttributes);
                                            return n.failIfMajorPerformanceCaveat = t1, r.probablySupportsContext ? r.probablySupportsContext("webgl", n) || r.probablySupportsContext("experimental-webgl", n) : r.supportsContext ? r.supportsContext("webgl", n) || r.supportsContext("experimental-webgl", n) : r.getContext("webgl", n) || r.getContext("experimental-webgl", n);
                                        }(t1);
                                        if (!r) return !1;
                                        var n = r.createShader(r.VERTEX_SHADER);
                                        if (!n || r.isContextLost()) return !1;
                                        return r.shaderSource(n, "void main() {}"), r.compileShader(n), !0 === r.getShaderParameter(n, r.COMPILE_STATUS);
                                    }(t1));
                                    return n[t1];
                                }(t1 && t1.failIfMajorPerformanceCaveat) ? void 0 : "insufficient WebGL support" : "insufficient Canvas/getImageData support" : "insufficient ArrayBuffer support" : "insufficient Uint8ClampedArray support" : "insufficient worker support" : "insufficient JSON support" : "insufficient Object support" : "insufficient Function support" : "insufficent Array support";
                            }
                            t1.exports ? t1.exports = e1 : window && (window.mapboxgl = window.mapboxgl || {}, window.mapboxgl.supported = e1, window.mapboxgl.notSupportedReason = r);
                            var n = {};
                            e1.webGLContextAttributes = {
                                antialias: !1,
                                alpha: !0,
                                stencil: !0,
                                depth: !0
                            };
                        }), r = {
                            create: function(e1, r, n) {
                                var i = t1.window.document.createElement(e1);
                                return void 0 !== r && (i.className = r), n && n.appendChild(i), i;
                            },
                            createNS: function(e1, r) {
                                return t1.window.document.createElementNS(e1, r);
                            }
                        }, n = t1.window.document.documentElement.style;
                        function i(t1) {
                            if (!n) return t1[0];
                            for(var e1 = 0; e1 < t1.length; e1++)if (t1[e1] in n) return t1[e1];
                            return t1[0];
                        }
                        var a, o = i([
                            "userSelect",
                            "MozUserSelect",
                            "WebkitUserSelect",
                            "msUserSelect"
                        ]);
                        r.disableDrag = function() {
                            n && o && (a = n[o], n[o] = "none");
                        }, r.enableDrag = function() {
                            n && o && (n[o] = a);
                        };
                        var s = i([
                            "transform",
                            "WebkitTransform"
                        ]);
                        r.setTransform = function(t1, e1) {
                            t1.style[s] = e1;
                        };
                        var l = !1;
                        try {
                            var c = Object.defineProperty({}, "passive", {
                                get: function() {
                                    l = !0;
                                }
                            });
                            t1.window.addEventListener("test", c, c), t1.window.removeEventListener("test", c, c);
                        } catch (t1) {
                            l = !1;
                        }
                        r.addEventListener = function(t1, e1, r, n) {
                            void 0 === n && (n = {}), "passive" in n && l ? t1.addEventListener(e1, r, n) : t1.addEventListener(e1, r, n.capture);
                        }, r.removeEventListener = function(t1, e1, r, n) {
                            void 0 === n && (n = {}), "passive" in n && l ? t1.removeEventListener(e1, r, n) : t1.removeEventListener(e1, r, n.capture);
                        };
                        var u = function(e1) {
                            e1.preventDefault(), e1.stopPropagation(), t1.window.removeEventListener("click", u, !0);
                        };
                        function f(t1) {
                            var e1 = t1.userImage;
                            if (e1 && e1.render && e1.render()) return t1.data.replace(new Uint8Array(e1.data.buffer)), !0;
                            return !1;
                        }
                        r.suppressClick = function() {
                            t1.window.addEventListener("click", u, !0), t1.window.setTimeout(function() {
                                t1.window.removeEventListener("click", u, !0);
                            }, 0);
                        }, r.mousePos = function(e1, r) {
                            var n = e1.getBoundingClientRect();
                            return new t1.Point(r.clientX - n.left - e1.clientLeft, r.clientY - n.top - e1.clientTop);
                        }, r.touchPos = function(e1, r) {
                            for(var n = e1.getBoundingClientRect(), i = [], a = 0; a < r.length; a++)i.push(new t1.Point(r[a].clientX - n.left - e1.clientLeft, r[a].clientY - n.top - e1.clientTop));
                            return i;
                        }, r.mouseButton = function(e1) {
                            return void 0 !== t1.window.InstallTrigger && 2 === e1.button && e1.ctrlKey && t1.window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : e1.button;
                        }, r.remove = function(t1) {
                            t1.parentNode && t1.parentNode.removeChild(t1);
                        };
                        var h = function(e1) {
                            function r() {
                                e1.call(this), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new t1.RGBAImage({
                                    width: 1,
                                    height: 1
                                }), this.dirty = !0;
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.isLoaded = function() {
                                return this.loaded;
                            }, r.prototype.setLoaded = function(t1) {
                                if (this.loaded !== t1 && (this.loaded = t1, t1)) {
                                    for(var e1 = 0, r = this.requestors; e1 < r.length; e1 += 1){
                                        var n = r[e1], i = n.ids, a = n.callback;
                                        this._notify(i, a);
                                    }
                                    this.requestors = [];
                                }
                            }, r.prototype.getImage = function(t1) {
                                return this.images[t1];
                            }, r.prototype.addImage = function(t1, e1) {
                                this._validate(t1, e1) && (this.images[t1] = e1);
                            }, r.prototype._validate = function(e1, r) {
                                var n = !0;
                                return this._validateStretch(r.stretchX, r.data && r.data.width) || (this.fire(new t1.ErrorEvent(new Error('Image "' + e1 + '" has invalid "stretchX" value'))), n = !1), this._validateStretch(r.stretchY, r.data && r.data.height) || (this.fire(new t1.ErrorEvent(new Error('Image "' + e1 + '" has invalid "stretchY" value'))), n = !1), this._validateContent(r.content, r) || (this.fire(new t1.ErrorEvent(new Error('Image "' + e1 + '" has invalid "content" value'))), n = !1), n;
                            }, r.prototype._validateStretch = function(t1, e1) {
                                if (!t1) return !0;
                                for(var r = 0, n = 0, i = t1; n < i.length; n += 1){
                                    var a = i[n];
                                    if (a[0] < r || a[1] < a[0] || e1 < a[1]) return !1;
                                    r = a[1];
                                }
                                return !0;
                            }, r.prototype._validateContent = function(t1, e1) {
                                return !t1 || 4 === t1.length && !(t1[0] < 0 || e1.data.width < t1[0]) && !(t1[1] < 0 || e1.data.height < t1[1]) && !(t1[2] < 0 || e1.data.width < t1[2]) && !(t1[3] < 0 || e1.data.height < t1[3]) && !(t1[2] < t1[0]) && !(t1[3] < t1[1]);
                            }, r.prototype.updateImage = function(t1, e1) {
                                var r = this.images[t1];
                                e1.version = r.version + 1, this.images[t1] = e1, this.updatedImages[t1] = !0;
                            }, r.prototype.removeImage = function(t1) {
                                var e1 = this.images[t1];
                                delete this.images[t1], delete this.patterns[t1], e1.userImage && e1.userImage.onRemove && e1.userImage.onRemove();
                            }, r.prototype.listImages = function() {
                                return Object.keys(this.images);
                            }, r.prototype.getImages = function(t1, e1) {
                                var r = !0;
                                if (!this.isLoaded()) for(var n = 0, i = t1; n < i.length; n += 1){
                                    var a = i[n];
                                    this.images[a] || (r = !1);
                                }
                                this.isLoaded() || r ? this._notify(t1, e1) : this.requestors.push({
                                    ids: t1,
                                    callback: e1
                                });
                            }, r.prototype._notify = function(e1, r) {
                                for(var n = {}, i = 0, a = e1; i < a.length; i += 1){
                                    var o = a[i];
                                    this.images[o] || this.fire(new t1.Event("styleimagemissing", {
                                        id: o
                                    }));
                                    var s = this.images[o];
                                    s ? n[o] = {
                                        data: s.data.clone(),
                                        pixelRatio: s.pixelRatio,
                                        sdf: s.sdf,
                                        version: s.version,
                                        stretchX: s.stretchX,
                                        stretchY: s.stretchY,
                                        content: s.content,
                                        hasRenderCallback: Boolean(s.userImage && s.userImage.render)
                                    } : t1.warnOnce('Image "' + o + '" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.');
                                }
                                r(null, n);
                            }, r.prototype.getPixelSize = function() {
                                var t1 = this.atlasImage;
                                return {
                                    width: t1.width,
                                    height: t1.height
                                };
                            }, r.prototype.getPattern = function(e1) {
                                var r = this.patterns[e1], n = this.getImage(e1);
                                if (!n) return null;
                                if (r && r.position.version === n.version) return r.position;
                                if (r) r.position.version = n.version;
                                else {
                                    var i = {
                                        w: n.data.width + 2,
                                        h: n.data.height + 2,
                                        x: 0,
                                        y: 0
                                    }, a = new t1.ImagePosition(i, n);
                                    this.patterns[e1] = {
                                        bin: i,
                                        position: a
                                    };
                                }
                                return this._updatePatternAtlas(), this.patterns[e1].position;
                            }, r.prototype.bind = function(e1) {
                                var r = e1.gl;
                                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new t1.Texture(e1, this.atlasImage, r.RGBA), this.atlasTexture.bind(r.LINEAR, r.CLAMP_TO_EDGE);
                            }, r.prototype._updatePatternAtlas = function() {
                                var e1 = [];
                                for(var r in this.patterns)e1.push(this.patterns[r].bin);
                                var n = t1.potpack(e1), i = n.w, a = n.h, o = this.atlasImage;
                                for(var s in o.resize({
                                    width: i || 1,
                                    height: a || 1
                                }), this.patterns){
                                    var l = this.patterns[s].bin, c = l.x + 1, u = l.y + 1, f = this.images[s].data, h = f.width, p = f.height;
                                    t1.RGBAImage.copy(f, o, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: c,
                                        y: u
                                    }, {
                                        width: h,
                                        height: p
                                    }), t1.RGBAImage.copy(f, o, {
                                        x: 0,
                                        y: p - 1
                                    }, {
                                        x: c,
                                        y: u - 1
                                    }, {
                                        width: h,
                                        height: 1
                                    }), t1.RGBAImage.copy(f, o, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: c,
                                        y: u + p
                                    }, {
                                        width: h,
                                        height: 1
                                    }), t1.RGBAImage.copy(f, o, {
                                        x: h - 1,
                                        y: 0
                                    }, {
                                        x: c - 1,
                                        y: u
                                    }, {
                                        width: 1,
                                        height: p
                                    }), t1.RGBAImage.copy(f, o, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: c + h,
                                        y: u
                                    }, {
                                        width: 1,
                                        height: p
                                    });
                                }
                                this.dirty = !0;
                            }, r.prototype.beginFrame = function() {
                                this.callbackDispatchedThisFrame = {};
                            }, r.prototype.dispatchRenderCallbacks = function(t1) {
                                for(var e1 = 0, r = t1; e1 < r.length; e1 += 1){
                                    var n = r[e1];
                                    if (!this.callbackDispatchedThisFrame[n]) {
                                        this.callbackDispatchedThisFrame[n] = !0;
                                        var i = this.images[n];
                                        f(i) && this.updateImage(n, i);
                                    }
                                }
                            }, r;
                        }(t1.Evented);
                        var p = g, d = g, m = 1e20;
                        function g(t1, e1, r, n, i, a) {
                            this.fontSize = t1 || 24, this.buffer = void 0 === e1 ? 3 : e1, this.cutoff = n || .25, this.fontFamily = i || "sans-serif", this.fontWeight = a || "normal", this.radius = r || 8;
                            var o = this.size = this.fontSize + 2 * this.buffer;
                            this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = o, this.ctx = this.canvas.getContext("2d"), this.ctx.font = this.fontWeight + " " + this.fontSize + "px " + this.fontFamily, this.ctx.textBaseline = "middle", this.ctx.fillStyle = "black", this.gridOuter = new Float64Array(o * o), this.gridInner = new Float64Array(o * o), this.f = new Float64Array(o), this.d = new Float64Array(o), this.z = new Float64Array(o + 1), this.v = new Int16Array(o), this.middle = Math.round(o / 2 * (navigator.userAgent.indexOf("Gecko/") >= 0 ? 1.2 : 1));
                        }
                        function v(t1, e1, r, n, i, a, o) {
                            for(var s = 0; s < e1; s++){
                                for(var l = 0; l < r; l++)n[l] = t1[l * e1 + s];
                                for(y(n, i, a, o, r), l = 0; l < r; l++)t1[l * e1 + s] = i[l];
                            }
                            for(l = 0; l < r; l++){
                                for(s = 0; s < e1; s++)n[s] = t1[l * e1 + s];
                                for(y(n, i, a, o, e1), s = 0; s < e1; s++)t1[l * e1 + s] = Math.sqrt(i[s]);
                            }
                        }
                        function y(t1, e1, r, n, i) {
                            r[0] = 0, n[0] = -m, n[1] = +m;
                            for(var a = 1, o = 0; a < i; a++){
                                for(var s = (t1[a] + a * a - (t1[r[o]] + r[o] * r[o])) / (2 * a - 2 * r[o]); s <= n[o];)o--, s = (t1[a] + a * a - (t1[r[o]] + r[o] * r[o])) / (2 * a - 2 * r[o]);
                                r[++o] = a, n[o] = s, n[o + 1] = +m;
                            }
                            for(a = 0, o = 0; a < i; a++){
                                for(; n[o + 1] < a;)o++;
                                e1[a] = (a - r[o]) * (a - r[o]) + t1[r[o]];
                            }
                        }
                        g.prototype.draw = function(t1) {
                            this.ctx.clearRect(0, 0, this.size, this.size), this.ctx.fillText(t1, this.buffer, this.middle);
                            for(var e1 = this.ctx.getImageData(0, 0, this.size, this.size), r = new Uint8ClampedArray(this.size * this.size), n = 0; n < this.size * this.size; n++){
                                var i = e1.data[4 * n + 3] / 255;
                                this.gridOuter[n] = 1 === i ? 0 : 0 === i ? m : Math.pow(Math.max(0, .5 - i), 2), this.gridInner[n] = 1 === i ? m : 0 === i ? 0 : Math.pow(Math.max(0, i - .5), 2);
                            }
                            for(v(this.gridOuter, this.size, this.size, this.f, this.d, this.v, this.z), v(this.gridInner, this.size, this.size, this.f, this.d, this.v, this.z), n = 0; n < this.size * this.size; n++){
                                var a = this.gridOuter[n] - this.gridInner[n];
                                r[n] = Math.max(0, Math.min(255, Math.round(255 - 255 * (a / this.radius + this.cutoff))));
                            }
                            return r;
                        }, p.default = d;
                        var x = function(t1, e1) {
                            this.requestManager = t1, this.localIdeographFontFamily = e1, this.entries = {};
                        };
                        x.prototype.setURL = function(t1) {
                            this.url = t1;
                        }, x.prototype.getGlyphs = function(e1, r) {
                            var n = this, i = [];
                            for(var a in e1)for(var o = 0, s = e1[a]; o < s.length; o += 1){
                                var l = s[o];
                                i.push({
                                    stack: a,
                                    id: l
                                });
                            }
                            t1.asyncAll(i, function(t1, e1) {
                                var r = t1.stack, i = t1.id, a = n.entries[r];
                                a || (a = n.entries[r] = {
                                    glyphs: {},
                                    requests: {},
                                    ranges: {}
                                });
                                var o = a.glyphs[i];
                                if (void 0 === o) {
                                    if (o = n._tinySDF(a, r, i)) return a.glyphs[i] = o, void e1(null, {
                                        stack: r,
                                        id: i,
                                        glyph: o
                                    });
                                    var s = Math.floor(i / 256);
                                    if (256 * s > 65535) e1(new Error("glyphs > 65535 not supported"));
                                    else if (a.ranges[s]) e1(null, {
                                        stack: r,
                                        id: i,
                                        glyph: o
                                    });
                                    else {
                                        var l = a.requests[s];
                                        l || (l = a.requests[s] = [], x.loadGlyphRange(r, s, n.url, n.requestManager, function(t1, e1) {
                                            if (e1) {
                                                for(var r in e1)n._doesCharSupportLocalGlyph(+r) || (a.glyphs[+r] = e1[+r]);
                                                a.ranges[s] = !0;
                                            }
                                            for(var i = 0, o = l; i < o.length; i += 1)(0, o[i])(t1, e1);
                                            delete a.requests[s];
                                        })), l.push(function(t1, n) {
                                            t1 ? e1(t1) : n && e1(null, {
                                                stack: r,
                                                id: i,
                                                glyph: n[i] || null
                                            });
                                        });
                                    }
                                } else e1(null, {
                                    stack: r,
                                    id: i,
                                    glyph: o
                                });
                            }, function(t1, e1) {
                                if (t1) r(t1);
                                else if (e1) {
                                    for(var n = {}, i = 0, a = e1; i < a.length; i += 1){
                                        var o = a[i], s = o.stack, l = o.id, c = o.glyph;
                                        (n[s] || (n[s] = {}))[l] = c && {
                                            id: c.id,
                                            bitmap: c.bitmap.clone(),
                                            metrics: c.metrics
                                        };
                                    }
                                    r(null, n);
                                }
                            });
                        }, x.prototype._doesCharSupportLocalGlyph = function(e1) {
                            return !!this.localIdeographFontFamily && (t1.isChar["CJK Unified Ideographs"](e1) || t1.isChar["Hangul Syllables"](e1) || t1.isChar.Hiragana(e1) || t1.isChar.Katakana(e1));
                        }, x.prototype._tinySDF = function(e1, r, n) {
                            var i = this.localIdeographFontFamily;
                            if (i && this._doesCharSupportLocalGlyph(n)) {
                                var a = e1.tinySDF;
                                if (!a) {
                                    var o = "400";
                                    /bold/i.test(r) ? o = "900" : /medium/i.test(r) ? o = "500" : /light/i.test(r) && (o = "200"), a = e1.tinySDF = new x.TinySDF(24, 3, 8, .25, i, o);
                                }
                                return {
                                    id: n,
                                    bitmap: new t1.AlphaImage({
                                        width: 30,
                                        height: 30
                                    }, a.draw(String.fromCharCode(n))),
                                    metrics: {
                                        width: 24,
                                        height: 24,
                                        left: 0,
                                        top: -8,
                                        advance: 24
                                    }
                                };
                            }
                        }, x.loadGlyphRange = function(e1, r, n, i, a) {
                            var o = 256 * r, s = o + 255, l = i.transformRequest(i.normalizeGlyphsURL(n).replace("{fontstack}", e1).replace("{range}", o + "-" + s), t1.ResourceType.Glyphs);
                            t1.getArrayBuffer(l, function(e1, r) {
                                if (e1) a(e1);
                                else if (r) {
                                    for(var n = {}, i = 0, o = t1.parseGlyphPBF(r); i < o.length; i += 1){
                                        var s = o[i];
                                        n[s.id] = s;
                                    }
                                    a(null, n);
                                }
                            });
                        }, x.TinySDF = p;
                        var b = function() {
                            this.specification = t1.styleSpec.light.position;
                        };
                        b.prototype.possiblyEvaluate = function(e1, r) {
                            return t1.sphericalToCartesian(e1.expression.evaluate(r));
                        }, b.prototype.interpolate = function(e1, r, n) {
                            return {
                                x: t1.number(e1.x, r.x, n),
                                y: t1.number(e1.y, r.y, n),
                                z: t1.number(e1.z, r.z, n)
                            };
                        };
                        var _ = new t1.Properties({
                            anchor: new t1.DataConstantProperty(t1.styleSpec.light.anchor),
                            position: new b,
                            color: new t1.DataConstantProperty(t1.styleSpec.light.color),
                            intensity: new t1.DataConstantProperty(t1.styleSpec.light.intensity)
                        }), w = function(e1) {
                            function r(r) {
                                e1.call(this), this._transitionable = new t1.Transitionable(_), this.setLight(r), this._transitioning = this._transitionable.untransitioned();
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.getLight = function() {
                                return this._transitionable.serialize();
                            }, r.prototype.setLight = function(e1, r) {
                                if (void 0 === r && (r = {}), !this._validate(t1.validateLight, e1, r)) for(var n in e1){
                                    var i = e1[n];
                                    t1.endsWith(n, "-transition") ? this._transitionable.setTransition(n.slice(0, -11), i) : this._transitionable.setValue(n, i);
                                }
                            }, r.prototype.updateTransitions = function(t1) {
                                this._transitioning = this._transitionable.transitioned(t1, this._transitioning);
                            }, r.prototype.hasTransition = function() {
                                return this._transitioning.hasTransition();
                            }, r.prototype.recalculate = function(t1) {
                                this.properties = this._transitioning.possiblyEvaluate(t1);
                            }, r.prototype._validate = function(e1, r, n) {
                                return (!n || !1 !== n.validate) && t1.emitValidationErrors(this, e1.call(t1.validateStyle, t1.extend({
                                    value: r,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    },
                                    styleSpec: t1.styleSpec
                                })));
                            }, r;
                        }(t1.Evented), T = function(t1, e1) {
                            this.width = t1, this.height = e1, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
                        };
                        T.prototype.getDash = function(t1, e1) {
                            var r = t1.join(",") + String(e1);
                            return this.dashEntry[r] || (this.dashEntry[r] = this.addDash(t1, e1)), this.dashEntry[r];
                        }, T.prototype.getDashRanges = function(t1, e1, r) {
                            var n = [], i = t1.length % 2 == 1 ? -t1[t1.length - 1] * r : 0, a = t1[0] * r, o = !0;
                            n.push({
                                left: i,
                                right: a,
                                isDash: o,
                                zeroLength: 0 === t1[0]
                            });
                            for(var s = t1[0], l = 1; l < t1.length; l++){
                                o = !o;
                                var c = t1[l];
                                i = s * r, a = (s += c) * r, n.push({
                                    left: i,
                                    right: a,
                                    isDash: o,
                                    zeroLength: 0 === c
                                });
                            }
                            return n;
                        }, T.prototype.addRoundDash = function(t1, e1, r) {
                            for(var n = e1 / 2, i = -r; i <= r; i++)for(var a = this.nextRow + r + i, o = this.width * a, s = 0, l = t1[s], c = 0; c < this.width; c++){
                                c / l.right > 1 && (l = t1[++s]);
                                var u = Math.abs(c - l.left), f = Math.abs(c - l.right), h = Math.min(u, f), p = void 0, d = i / r * (n + 1);
                                if (l.isDash) {
                                    var m = n - Math.abs(d);
                                    p = Math.sqrt(h * h + m * m);
                                } else p = n - Math.sqrt(h * h + d * d);
                                this.data[o + c] = Math.max(0, Math.min(255, p + 128));
                            }
                        }, T.prototype.addRegularDash = function(t1) {
                            for(var e1 = t1.length - 1; e1 >= 0; --e1){
                                var r = t1[e1], n = t1[e1 + 1];
                                r.zeroLength ? t1.splice(e1, 1) : n && n.isDash === r.isDash && (n.left = r.left, t1.splice(e1, 1));
                            }
                            var i = t1[0], a = t1[t1.length - 1];
                            i.isDash === a.isDash && (i.left = a.left - this.width, a.right = i.right + this.width);
                            for(var o = this.width * this.nextRow, s = 0, l = t1[s], c = 0; c < this.width; c++){
                                c / l.right > 1 && (l = t1[++s]);
                                var u = Math.abs(c - l.left), f = Math.abs(c - l.right), h = Math.min(u, f), p = l.isDash ? h : -h;
                                this.data[o + c] = Math.max(0, Math.min(255, p + 128));
                            }
                        }, T.prototype.addDash = function(e1, r) {
                            var n = r ? 7 : 0, i = 2 * n + 1;
                            if (this.nextRow + i > this.height) return t1.warnOnce("LineAtlas out of space"), null;
                            for(var a = 0, o = 0; o < e1.length; o++)a += e1[o];
                            if (0 !== a) {
                                var s = this.width / a, l = this.getDashRanges(e1, this.width, s);
                                r ? this.addRoundDash(l, s, n) : this.addRegularDash(l);
                            }
                            var c = {
                                y: (this.nextRow + n + .5) / this.height,
                                height: 2 * n / this.height,
                                width: a
                            };
                            return this.nextRow += i, this.dirty = !0, c;
                        }, T.prototype.bind = function(t1) {
                            var e1 = t1.gl;
                            this.texture ? (e1.bindTexture(e1.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, e1.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, this.width, this.height, e1.ALPHA, e1.UNSIGNED_BYTE, this.data))) : (this.texture = e1.createTexture(), e1.bindTexture(e1.TEXTURE_2D, this.texture), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_S, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_T, e1.REPEAT), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MIN_FILTER, e1.LINEAR), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MAG_FILTER, e1.LINEAR), e1.texImage2D(e1.TEXTURE_2D, 0, e1.ALPHA, this.width, this.height, 0, e1.ALPHA, e1.UNSIGNED_BYTE, this.data));
                        };
                        var k = function e1(r, n) {
                            this.workerPool = r, this.actors = [], this.currentActor = 0, this.id = t1.uniqueId();
                            for(var i = this.workerPool.acquire(this.id), a = 0; a < i.length; a++){
                                var o = i[a], s = new e1.Actor(o, n, this.id);
                                s.name = "Worker " + a, this.actors.push(s);
                            }
                        };
                        function A(e1, r, n) {
                            var i = function(i, a) {
                                if (i) return n(i);
                                if (a) {
                                    var o = t1.pick(t1.extend(a, e1), [
                                        "tiles",
                                        "minzoom",
                                        "maxzoom",
                                        "attribution",
                                        "mapbox_logo",
                                        "bounds",
                                        "scheme",
                                        "tileSize",
                                        "encoding"
                                    ]);
                                    a.vector_layers && (o.vectorLayers = a.vector_layers, o.vectorLayerIds = o.vectorLayers.map(function(t1) {
                                        return t1.id;
                                    })), o.tiles = r.canonicalizeTileset(o, e1.url), n(null, o);
                                }
                            };
                            return e1.url ? t1.getJSON(r.transformRequest(r.normalizeSourceURL(e1.url), t1.ResourceType.Source), i) : t1.browser.frame(function() {
                                return i(null, e1);
                            });
                        }
                        k.prototype.broadcast = function(e1, r, n) {
                            n = n || function() {}, t1.asyncAll(this.actors, function(t1, n) {
                                t1.send(e1, r, n);
                            }, n);
                        }, k.prototype.getActor = function() {
                            return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
                        }, k.prototype.remove = function() {
                            this.actors.forEach(function(t1) {
                                t1.remove();
                            }), this.actors = [], this.workerPool.release(this.id);
                        }, k.Actor = t1.Actor;
                        var M = function(e1, r, n) {
                            this.bounds = t1.LngLatBounds.convert(this.validateBounds(e1)), this.minzoom = r || 0, this.maxzoom = n || 24;
                        };
                        M.prototype.validateBounds = function(t1) {
                            return Array.isArray(t1) && 4 === t1.length ? [
                                Math.max(-180, t1[0]),
                                Math.max(-90, t1[1]),
                                Math.min(180, t1[2]),
                                Math.min(90, t1[3])
                            ] : [
                                -180,
                                -90,
                                180,
                                90
                            ];
                        }, M.prototype.contains = function(e1) {
                            var r = Math.pow(2, e1.z), n = Math.floor(t1.mercatorXfromLng(this.bounds.getWest()) * r), i = Math.floor(t1.mercatorYfromLat(this.bounds.getNorth()) * r), a = Math.ceil(t1.mercatorXfromLng(this.bounds.getEast()) * r), o = Math.ceil(t1.mercatorYfromLat(this.bounds.getSouth()) * r);
                            return e1.x >= n && e1.x < a && e1.y >= i && e1.y < o;
                        };
                        var S = function(e1) {
                            function r(r, n, i, a) {
                                if (e1.call(this), this.id = r, this.dispatcher = i, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, t1.extend(this, t1.pick(n, [
                                    "url",
                                    "scheme",
                                    "tileSize",
                                    "promoteId"
                                ])), this._options = t1.extend({
                                    type: "vector"
                                }, n), this._collectResourceTiming = n.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                                this.setEventedParent(a);
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.load = function() {
                                var e1 = this;
                                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                                    dataType: "source"
                                })), this._tileJSONRequest = A(this._options, this.map._requestManager, function(r, n) {
                                    e1._tileJSONRequest = null, e1._loaded = !0, r ? e1.fire(new t1.ErrorEvent(r)) : n && (t1.extend(e1, n), n.bounds && (e1.tileBounds = new M(n.bounds, e1.minzoom, e1.maxzoom)), t1.postTurnstileEvent(n.tiles, e1.map._requestManager._customAccessToken), t1.postMapLoadEvent(n.tiles, e1.map._getMapId(), e1.map._requestManager._skuToken, e1.map._requestManager._customAccessToken), e1.fire(new t1.Event("data", {
                                        dataType: "source",
                                        sourceDataType: "metadata"
                                    })), e1.fire(new t1.Event("data", {
                                        dataType: "source",
                                        sourceDataType: "content"
                                    })));
                                });
                            }, r.prototype.loaded = function() {
                                return this._loaded;
                            }, r.prototype.hasTile = function(t1) {
                                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
                            }, r.prototype.onAdd = function(t1) {
                                this.map = t1, this.load();
                            }, r.prototype.onRemove = function() {
                                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                            }, r.prototype.serialize = function() {
                                return t1.extend({}, this._options);
                            }, r.prototype.loadTile = function(e1, r) {
                                var n = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme)), i = {
                                    request: this.map._requestManager.transformRequest(n, t1.ResourceType.Tile),
                                    uid: e1.uid,
                                    tileID: e1.tileID,
                                    zoom: e1.tileID.overscaledZ,
                                    tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                                    type: this.type,
                                    source: this.id,
                                    pixelRatio: t1.browser.devicePixelRatio,
                                    showCollisionBoxes: this.map.showCollisionBoxes,
                                    promoteId: this.promoteId
                                };
                                function a(n, i) {
                                    return delete e1.request, e1.aborted ? r(null) : n && 404 !== n.status ? r(n) : (i && i.resourceTiming && (e1.resourceTiming = i.resourceTiming), this.map._refreshExpiredTiles && i && e1.setExpiryData(i), e1.loadVectorData(i, this.map.painter), t1.cacheEntryPossiblyAdded(this.dispatcher), r(null), void (e1.reloadCallback && (this.loadTile(e1, e1.reloadCallback), e1.reloadCallback = null)));
                                }
                                i.request.collectResourceTiming = this._collectResourceTiming, e1.actor && "expired" !== e1.state ? "loading" === e1.state ? e1.reloadCallback = r : e1.request = e1.actor.send("reloadTile", i, a.bind(this)) : (e1.actor = this.dispatcher.getActor(), e1.request = e1.actor.send("loadTile", i, a.bind(this)));
                            }, r.prototype.abortTile = function(t1) {
                                t1.request && (t1.request.cancel(), delete t1.request), t1.actor && t1.actor.send("abortTile", {
                                    uid: t1.uid,
                                    type: this.type,
                                    source: this.id
                                }, void 0);
                            }, r.prototype.unloadTile = function(t1) {
                                t1.unloadVectorData(), t1.actor && t1.actor.send("removeTile", {
                                    uid: t1.uid,
                                    type: this.type,
                                    source: this.id
                                }, void 0);
                            }, r.prototype.hasTransition = function() {
                                return !1;
                            }, r;
                        }(t1.Evented), E = function(e1) {
                            function r(r, n, i, a) {
                                e1.call(this), this.id = r, this.dispatcher = i, this.setEventedParent(a), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = t1.extend({
                                    type: "raster"
                                }, n), t1.extend(this, t1.pick(n, [
                                    "url",
                                    "scheme",
                                    "tileSize"
                                ]));
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.load = function() {
                                var e1 = this;
                                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                                    dataType: "source"
                                })), this._tileJSONRequest = A(this._options, this.map._requestManager, function(r, n) {
                                    e1._tileJSONRequest = null, e1._loaded = !0, r ? e1.fire(new t1.ErrorEvent(r)) : n && (t1.extend(e1, n), n.bounds && (e1.tileBounds = new M(n.bounds, e1.minzoom, e1.maxzoom)), t1.postTurnstileEvent(n.tiles), t1.postMapLoadEvent(n.tiles, e1.map._getMapId(), e1.map._requestManager._skuToken), e1.fire(new t1.Event("data", {
                                        dataType: "source",
                                        sourceDataType: "metadata"
                                    })), e1.fire(new t1.Event("data", {
                                        dataType: "source",
                                        sourceDataType: "content"
                                    })));
                                });
                            }, r.prototype.loaded = function() {
                                return this._loaded;
                            }, r.prototype.onAdd = function(t1) {
                                this.map = t1, this.load();
                            }, r.prototype.onRemove = function() {
                                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                            }, r.prototype.serialize = function() {
                                return t1.extend({}, this._options);
                            }, r.prototype.hasTile = function(t1) {
                                return !this.tileBounds || this.tileBounds.contains(t1.canonical);
                            }, r.prototype.loadTile = function(e1, r) {
                                var n = this, i = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
                                e1.request = t1.getImage(this.map._requestManager.transformRequest(i, t1.ResourceType.Tile), function(i, a) {
                                    if (delete e1.request, e1.aborted) e1.state = "unloaded", r(null);
                                    else if (i) e1.state = "errored", r(i);
                                    else if (a) {
                                        n.map._refreshExpiredTiles && e1.setExpiryData(a), delete a.cacheControl, delete a.expires;
                                        var o = n.map.painter.context, s = o.gl;
                                        e1.texture = n.map.painter.getTileTexture(a.width), e1.texture ? e1.texture.update(a, {
                                            useMipmap: !0
                                        }) : (e1.texture = new t1.Texture(o, a, s.RGBA, {
                                            useMipmap: !0
                                        }), e1.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE, s.LINEAR_MIPMAP_NEAREST), o.extTextureFilterAnisotropic && s.texParameterf(s.TEXTURE_2D, o.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, o.extTextureFilterAnisotropicMax)), e1.state = "loaded", t1.cacheEntryPossiblyAdded(n.dispatcher), r(null);
                                    }
                                });
                            }, r.prototype.abortTile = function(t1, e1) {
                                t1.request && (t1.request.cancel(), delete t1.request), e1();
                            }, r.prototype.unloadTile = function(t1, e1) {
                                t1.texture && this.map.painter.saveTileTexture(t1.texture), e1();
                            }, r.prototype.hasTransition = function() {
                                return !1;
                            }, r;
                        }(t1.Evented), L = function(e1) {
                            function r(r, n, i, a) {
                                e1.call(this, r, n, i, a), this.type = "raster-dem", this.maxzoom = 22, this._options = t1.extend({
                                    type: "raster-dem"
                                }, n), this.encoding = n.encoding || "mapbox";
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.serialize = function() {
                                return {
                                    type: "raster-dem",
                                    url: this.url,
                                    tileSize: this.tileSize,
                                    tiles: this.tiles,
                                    bounds: this.bounds,
                                    encoding: this.encoding
                                };
                            }, r.prototype.loadTile = function(e1, r) {
                                var n = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
                                function i(t1, n) {
                                    t1 && (e1.state = "errored", r(t1)), n && (e1.dem = n, e1.needsHillshadePrepare = !0, e1.state = "loaded", r(null));
                                }
                                e1.request = t1.getImage(this.map._requestManager.transformRequest(n, t1.ResourceType.Tile), (function(n, a) {
                                    if (delete e1.request, e1.aborted) e1.state = "unloaded", r(null);
                                    else if (n) e1.state = "errored", r(n);
                                    else if (a) {
                                        this.map._refreshExpiredTiles && e1.setExpiryData(a), delete a.cacheControl, delete a.expires;
                                        var o = t1.window.ImageBitmap && a instanceof t1.window.ImageBitmap && t1.offscreenCanvasSupported() ? a : t1.browser.getImageData(a, 1), s = {
                                            uid: e1.uid,
                                            coord: e1.tileID,
                                            source: this.id,
                                            rawImageData: o,
                                            encoding: this.encoding
                                        };
                                        e1.actor && "expired" !== e1.state || (e1.actor = this.dispatcher.getActor(), e1.actor.send("loadDEMTile", s, i.bind(this)));
                                    }
                                }).bind(this)), e1.neighboringTiles = this._getNeighboringTiles(e1.tileID);
                            }, r.prototype._getNeighboringTiles = function(e1) {
                                var r = e1.canonical, n = Math.pow(2, r.z), i = (r.x - 1 + n) % n, a = 0 === r.x ? e1.wrap - 1 : e1.wrap, o = (r.x + 1 + n) % n, s = r.x + 1 === n ? e1.wrap + 1 : e1.wrap, l = {};
                                return l[new t1.OverscaledTileID(e1.overscaledZ, a, r.z, i, r.y).key] = {
                                    backfilled: !1
                                }, l[new t1.OverscaledTileID(e1.overscaledZ, s, r.z, o, r.y).key] = {
                                    backfilled: !1
                                }, r.y > 0 && (l[new t1.OverscaledTileID(e1.overscaledZ, a, r.z, i, r.y - 1).key] = {
                                    backfilled: !1
                                }, l[new t1.OverscaledTileID(e1.overscaledZ, e1.wrap, r.z, r.x, r.y - 1).key] = {
                                    backfilled: !1
                                }, l[new t1.OverscaledTileID(e1.overscaledZ, s, r.z, o, r.y - 1).key] = {
                                    backfilled: !1
                                }), r.y + 1 < n && (l[new t1.OverscaledTileID(e1.overscaledZ, a, r.z, i, r.y + 1).key] = {
                                    backfilled: !1
                                }, l[new t1.OverscaledTileID(e1.overscaledZ, e1.wrap, r.z, r.x, r.y + 1).key] = {
                                    backfilled: !1
                                }, l[new t1.OverscaledTileID(e1.overscaledZ, s, r.z, o, r.y + 1).key] = {
                                    backfilled: !1
                                }), l;
                            }, r.prototype.unloadTile = function(t1) {
                                t1.demTexture && this.map.painter.saveTileTexture(t1.demTexture), t1.fbo && (t1.fbo.destroy(), delete t1.fbo), t1.dem && delete t1.dem, delete t1.neighboringTiles, t1.state = "unloaded", t1.actor && t1.actor.send("removeDEMTile", {
                                    uid: t1.uid,
                                    source: this.id
                                });
                            }, r;
                        }(E), C = function(e1) {
                            function r(r, n, i, a) {
                                e1.call(this), this.id = r, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._loaded = !1, this.actor = i.getActor(), this.setEventedParent(a), this._data = n.data, this._options = t1.extend({}, n), this._collectResourceTiming = n.collectResourceTiming, this._resourceTiming = [], void 0 !== n.maxzoom && (this.maxzoom = n.maxzoom), n.type && (this.type = n.type), n.attribution && (this.attribution = n.attribution), this.promoteId = n.promoteId;
                                var o = t1.EXTENT / this.tileSize;
                                this.workerOptions = t1.extend({
                                    source: this.id,
                                    cluster: n.cluster || !1,
                                    geojsonVtOptions: {
                                        buffer: (void 0 !== n.buffer ? n.buffer : 128) * o,
                                        tolerance: (void 0 !== n.tolerance ? n.tolerance : .375) * o,
                                        extent: t1.EXTENT,
                                        maxZoom: this.maxzoom,
                                        lineMetrics: n.lineMetrics || !1,
                                        generateId: n.generateId || !1
                                    },
                                    superclusterOptions: {
                                        maxZoom: void 0 !== n.clusterMaxZoom ? Math.min(n.clusterMaxZoom, this.maxzoom - 1) : this.maxzoom - 1,
                                        extent: t1.EXTENT,
                                        radius: (n.clusterRadius || 50) * o,
                                        log: !1,
                                        generateId: n.generateId || !1
                                    },
                                    clusterProperties: n.clusterProperties
                                }, n.workerOptions);
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.load = function() {
                                var e1 = this;
                                this.fire(new t1.Event("dataloading", {
                                    dataType: "source"
                                })), this._updateWorkerData(function(r) {
                                    if (r) e1.fire(new t1.ErrorEvent(r));
                                    else {
                                        var n = {
                                            dataType: "source",
                                            sourceDataType: "metadata"
                                        };
                                        e1._collectResourceTiming && e1._resourceTiming && e1._resourceTiming.length > 0 && (n.resourceTiming = e1._resourceTiming, e1._resourceTiming = []), e1.fire(new t1.Event("data", n));
                                    }
                                });
                            }, r.prototype.onAdd = function(t1) {
                                this.map = t1, this.load();
                            }, r.prototype.setData = function(e1) {
                                var r = this;
                                return this._data = e1, this.fire(new t1.Event("dataloading", {
                                    dataType: "source"
                                })), this._updateWorkerData(function(e1) {
                                    if (e1) r.fire(new t1.ErrorEvent(e1));
                                    else {
                                        var n = {
                                            dataType: "source",
                                            sourceDataType: "content"
                                        };
                                        r._collectResourceTiming && r._resourceTiming && r._resourceTiming.length > 0 && (n.resourceTiming = r._resourceTiming, r._resourceTiming = []), r.fire(new t1.Event("data", n));
                                    }
                                }), this;
                            }, r.prototype.getClusterExpansionZoom = function(t1, e1) {
                                return this.actor.send("geojson.getClusterExpansionZoom", {
                                    clusterId: t1,
                                    source: this.id
                                }, e1), this;
                            }, r.prototype.getClusterChildren = function(t1, e1) {
                                return this.actor.send("geojson.getClusterChildren", {
                                    clusterId: t1,
                                    source: this.id
                                }, e1), this;
                            }, r.prototype.getClusterLeaves = function(t1, e1, r, n) {
                                return this.actor.send("geojson.getClusterLeaves", {
                                    source: this.id,
                                    clusterId: t1,
                                    limit: e1,
                                    offset: r
                                }, n), this;
                            }, r.prototype._updateWorkerData = function(e1) {
                                var r = this;
                                this._loaded = !1;
                                var n = t1.extend({}, this.workerOptions), i = this._data;
                                "string" == typeof i ? (n.request = this.map._requestManager.transformRequest(t1.browser.resolveURL(i), t1.ResourceType.Source), n.request.collectResourceTiming = this._collectResourceTiming) : n.data = JSON.stringify(i), this.actor.send(this.type + ".loadData", n, function(t1, i) {
                                    r._removed || i && i.abandoned || (r._loaded = !0, i && i.resourceTiming && i.resourceTiming[r.id] && (r._resourceTiming = i.resourceTiming[r.id].slice(0)), r.actor.send(r.type + ".coalesce", {
                                        source: n.source
                                    }, null), e1(t1));
                                });
                            }, r.prototype.loaded = function() {
                                return this._loaded;
                            }, r.prototype.loadTile = function(e1, r) {
                                var n = this, i = e1.actor ? "reloadTile" : "loadTile";
                                e1.actor = this.actor;
                                var a = {
                                    type: this.type,
                                    uid: e1.uid,
                                    tileID: e1.tileID,
                                    zoom: e1.tileID.overscaledZ,
                                    maxZoom: this.maxzoom,
                                    tileSize: this.tileSize,
                                    source: this.id,
                                    pixelRatio: t1.browser.devicePixelRatio,
                                    showCollisionBoxes: this.map.showCollisionBoxes,
                                    promoteId: this.promoteId
                                };
                                e1.request = this.actor.send(i, a, function(t1, a) {
                                    return delete e1.request, e1.unloadVectorData(), e1.aborted ? r(null) : t1 ? r(t1) : (e1.loadVectorData(a, n.map.painter, "reloadTile" === i), r(null));
                                });
                            }, r.prototype.abortTile = function(t1) {
                                t1.request && (t1.request.cancel(), delete t1.request), t1.aborted = !0;
                            }, r.prototype.unloadTile = function(t1) {
                                t1.unloadVectorData(), this.actor.send("removeTile", {
                                    uid: t1.uid,
                                    type: this.type,
                                    source: this.id
                                });
                            }, r.prototype.onRemove = function() {
                                this._removed = !0, this.actor.send("removeSource", {
                                    type: this.type,
                                    source: this.id
                                });
                            }, r.prototype.serialize = function() {
                                return t1.extend({}, this._options, {
                                    type: this.type,
                                    data: this._data
                                });
                            }, r.prototype.hasTransition = function() {
                                return !1;
                            }, r;
                        }(t1.Evented), P = t1.createLayout([
                            {
                                name: "a_pos",
                                type: "Int16",
                                components: 2
                            },
                            {
                                name: "a_texture_pos",
                                type: "Int16",
                                components: 2
                            }
                        ]), I = function(e1) {
                            function r(t1, r, n, i) {
                                e1.call(this), this.id = t1, this.dispatcher = n, this.coordinates = r.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(i), this.options = r;
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.load = function(e1, r) {
                                var n = this;
                                this._loaded = !1, this.fire(new t1.Event("dataloading", {
                                    dataType: "source"
                                })), this.url = this.options.url, t1.getImage(this.map._requestManager.transformRequest(this.url, t1.ResourceType.Image), function(i, a) {
                                    n._loaded = !0, i ? n.fire(new t1.ErrorEvent(i)) : a && (n.image = a, e1 && (n.coordinates = e1), r && r(), n._finishLoading());
                                });
                            }, r.prototype.loaded = function() {
                                return this._loaded;
                            }, r.prototype.updateImage = function(t1) {
                                var e1 = this;
                                return this.image && t1.url ? (this.options.url = t1.url, this.load(t1.coordinates, function() {
                                    e1.texture = null;
                                }), this) : this;
                            }, r.prototype._finishLoading = function() {
                                this.map && (this.setCoordinates(this.coordinates), this.fire(new t1.Event("data", {
                                    dataType: "source",
                                    sourceDataType: "metadata"
                                })));
                            }, r.prototype.onAdd = function(t1) {
                                this.map = t1, this.load();
                            }, r.prototype.setCoordinates = function(e1) {
                                var r = this;
                                this.coordinates = e1;
                                var n = e1.map(t1.MercatorCoordinate.fromLngLat);
                                this.tileID = function(e1) {
                                    for(var r = 1 / 0, n = 1 / 0, i = -1 / 0, a = -1 / 0, o = 0, s = e1; o < s.length; o += 1){
                                        var l = s[o];
                                        r = Math.min(r, l.x), n = Math.min(n, l.y), i = Math.max(i, l.x), a = Math.max(a, l.y);
                                    }
                                    var c = i - r, u = a - n, f = Math.max(c, u), h = Math.max(0, Math.floor(-Math.log(f) / Math.LN2)), p = Math.pow(2, h);
                                    return new t1.CanonicalTileID(h, Math.floor((r + i) / 2 * p), Math.floor((n + a) / 2 * p));
                                }(n), this.minzoom = this.maxzoom = this.tileID.z;
                                var i = n.map(function(t1) {
                                    return r.tileID.getTilePoint(t1)._round();
                                });
                                return this._boundsArray = new t1.StructArrayLayout4i8, this._boundsArray.emplaceBack(i[0].x, i[0].y, 0, 0), this._boundsArray.emplaceBack(i[1].x, i[1].y, t1.EXTENT, 0), this._boundsArray.emplaceBack(i[3].x, i[3].y, 0, t1.EXTENT), this._boundsArray.emplaceBack(i[2].x, i[2].y, t1.EXTENT, t1.EXTENT), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new t1.Event("data", {
                                    dataType: "source",
                                    sourceDataType: "content"
                                })), this;
                            }, r.prototype.prepare = function() {
                                if (0 !== Object.keys(this.tiles).length && this.image) {
                                    var e1 = this.map.painter.context, r = e1.gl;
                                    for(var n in this.boundsBuffer || (this.boundsBuffer = e1.createVertexBuffer(this._boundsArray, P.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new t1.Texture(e1, this.image, r.RGBA), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE)), this.tiles){
                                        var i = this.tiles[n];
                                        "loaded" !== i.state && (i.state = "loaded", i.texture = this.texture);
                                    }
                                }
                            }, r.prototype.loadTile = function(t1, e1) {
                                this.tileID && this.tileID.equals(t1.tileID.canonical) ? (this.tiles[String(t1.tileID.wrap)] = t1, t1.buckets = {}, e1(null)) : (t1.state = "errored", e1(null));
                            }, r.prototype.serialize = function() {
                                return {
                                    type: "image",
                                    url: this.options.url,
                                    coordinates: this.coordinates
                                };
                            }, r.prototype.hasTransition = function() {
                                return !1;
                            }, r;
                        }(t1.Evented);
                        var O = function(e1) {
                            function r(t1, r, n, i) {
                                e1.call(this, t1, r, n, i), this.roundZoom = !0, this.type = "video", this.options = r;
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.load = function() {
                                var e1 = this;
                                this._loaded = !1;
                                var r = this.options;
                                this.urls = [];
                                for(var n = 0, i = r.urls; n < i.length; n += 1){
                                    var a = i[n];
                                    this.urls.push(this.map._requestManager.transformRequest(a, t1.ResourceType.Source).url);
                                }
                                t1.getVideo(this.urls, function(r, n) {
                                    e1._loaded = !0, r ? e1.fire(new t1.ErrorEvent(r)) : n && (e1.video = n, e1.video.loop = !0, e1.video.addEventListener("playing", function() {
                                        e1.map.triggerRepaint();
                                    }), e1.map && e1.video.play(), e1._finishLoading());
                                });
                            }, r.prototype.pause = function() {
                                this.video && this.video.pause();
                            }, r.prototype.play = function() {
                                this.video && this.video.play();
                            }, r.prototype.seek = function(e1) {
                                if (this.video) {
                                    var r = this.video.seekable;
                                    e1 < r.start(0) || e1 > r.end(0) ? this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + this.id, null, "Playback for this video can be set only between the " + r.start(0) + " and " + r.end(0) + "-second mark."))) : this.video.currentTime = e1;
                                }
                            }, r.prototype.getVideo = function() {
                                return this.video;
                            }, r.prototype.onAdd = function(t1) {
                                this.map || (this.map = t1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                            }, r.prototype.prepare = function() {
                                if (!(0 === Object.keys(this.tiles).length || this.video.readyState < 2)) {
                                    var e1 = this.map.painter.context, r = e1.gl;
                                    for(var n in this.boundsBuffer || (this.boundsBuffer = e1.createVertexBuffer(this._boundsArray, P.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE), r.texSubImage2D(r.TEXTURE_2D, 0, 0, 0, r.RGBA, r.UNSIGNED_BYTE, this.video)) : (this.texture = new t1.Texture(e1, this.video, r.RGBA), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE)), this.tiles){
                                        var i = this.tiles[n];
                                        "loaded" !== i.state && (i.state = "loaded", i.texture = this.texture);
                                    }
                                }
                            }, r.prototype.serialize = function() {
                                return {
                                    type: "video",
                                    urls: this.urls,
                                    coordinates: this.coordinates
                                };
                            }, r.prototype.hasTransition = function() {
                                return this.video && !this.video.paused;
                            }, r;
                        }(I), z = function(e1) {
                            function r(r, n, i, a) {
                                e1.call(this, r, n, i, a), n.coordinates ? Array.isArray(n.coordinates) && 4 === n.coordinates.length && !n.coordinates.some(function(t1) {
                                    return !Array.isArray(t1) || 2 !== t1.length || t1.some(function(t1) {
                                        return "number" != typeof t1;
                                    });
                                }) || this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + r, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + r, null, 'missing required property "coordinates"'))), n.animate && "boolean" != typeof n.animate && this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + r, null, 'optional "animate" property must be a boolean value'))), n.canvas ? "string" == typeof n.canvas || n.canvas instanceof t1.window.HTMLCanvasElement || this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + r, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t1.ErrorEvent(new t1.ValidationError("sources." + r, null, 'missing required property "canvas"'))), this.options = n, this.animate = void 0 === n.animate || n.animate;
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.load = function() {
                                this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof t1.window.HTMLCanvasElement ? this.options.canvas : t1.window.document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t1.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                                    this._playing = !0, this.map.triggerRepaint();
                                }, this.pause = function() {
                                    this._playing && (this.prepare(), this._playing = !1);
                                }, this._finishLoading());
                            }, r.prototype.getCanvas = function() {
                                return this.canvas;
                            }, r.prototype.onAdd = function(t1) {
                                this.map = t1, this.load(), this.canvas && this.animate && this.play();
                            }, r.prototype.onRemove = function() {
                                this.pause();
                            }, r.prototype.prepare = function() {
                                var e1 = !1;
                                if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), !this._hasInvalidDimensions() && 0 !== Object.keys(this.tiles).length) {
                                    var r = this.map.painter.context, n = r.gl;
                                    for(var i in this.boundsBuffer || (this.boundsBuffer = r.createVertexBuffer(this._boundsArray, P.members)), this.boundsSegments || (this.boundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? (e1 || this._playing) && this.texture.update(this.canvas, {
                                        premultiply: !0
                                    }) : this.texture = new t1.Texture(r, this.canvas, n.RGBA, {
                                        premultiply: !0
                                    }), this.tiles){
                                        var a = this.tiles[i];
                                        "loaded" !== a.state && (a.state = "loaded", a.texture = this.texture);
                                    }
                                }
                            }, r.prototype.serialize = function() {
                                return {
                                    type: "canvas",
                                    coordinates: this.coordinates
                                };
                            }, r.prototype.hasTransition = function() {
                                return this._playing;
                            }, r.prototype._hasInvalidDimensions = function() {
                                for(var t1 = 0, e1 = [
                                    this.canvas.width,
                                    this.canvas.height
                                ]; t1 < e1.length; t1 += 1){
                                    var r = e1[t1];
                                    if (isNaN(r) || r <= 0) return !0;
                                }
                                return !1;
                            }, r;
                        }(I), D = {
                            vector: S,
                            raster: E,
                            "raster-dem": L,
                            geojson: C,
                            video: O,
                            image: I,
                            canvas: z
                        };
                        function R(e1, r) {
                            var n = t1.identity([]);
                            return t1.translate(n, n, [
                                1,
                                1,
                                0
                            ]), t1.scale(n, n, [
                                .5 * e1.width,
                                .5 * e1.height,
                                1
                            ]), t1.multiply(n, n, e1.calculatePosMatrix(r.toUnwrapped()));
                        }
                        function F(t1, e1, r, n, i, a) {
                            var o = function(t1, e1, r) {
                                if (t1) for(var n = 0, i = t1; n < i.length; n += 1){
                                    var a = e1[i[n]];
                                    if (a && a.source === r && "fill-extrusion" === a.type) return !0;
                                }
                                else for(var o in e1){
                                    var s = e1[o];
                                    if (s.source === r && "fill-extrusion" === s.type) return !0;
                                }
                                return !1;
                            }(i && i.layers, e1, t1.id), s = a.maxPitchScaleFactor(), l = t1.tilesIn(n, s, o);
                            l.sort(B);
                            for(var c = [], u = 0, f = l; u < f.length; u += 1){
                                var h = f[u];
                                c.push({
                                    wrappedTileID: h.tileID.wrapped().key,
                                    queryResults: h.tile.queryRenderedFeatures(e1, r, t1._state, h.queryGeometry, h.cameraQueryGeometry, h.scale, i, a, s, R(t1.transform, h.tileID))
                                });
                            }
                            var p = function(t1) {
                                for(var e1 = {}, r = {}, n = 0, i = t1; n < i.length; n += 1){
                                    var a = i[n], o = a.queryResults, s = a.wrappedTileID, l = r[s] = r[s] || {};
                                    for(var c in o)for(var u = o[c], f = l[c] = l[c] || {}, h = e1[c] = e1[c] || [], p = 0, d = u; p < d.length; p += 1){
                                        var m = d[p];
                                        f[m.featureIndex] || (f[m.featureIndex] = !0, h.push(m));
                                    }
                                }
                                return e1;
                            }(c);
                            for(var d in p)p[d].forEach(function(e1) {
                                var r = e1.feature, n = t1.getFeatureState(r.layer["source-layer"], r.id);
                                r.source = r.layer.source, r.layer["source-layer"] && (r.sourceLayer = r.layer["source-layer"]), r.state = n;
                            });
                            return p;
                        }
                        function B(t1, e1) {
                            var r = t1.tileID, n = e1.tileID;
                            return r.overscaledZ - n.overscaledZ || r.canonical.y - n.canonical.y || r.wrap - n.wrap || r.canonical.x - n.canonical.x;
                        }
                        var N = function(t1, e1) {
                            this.max = t1, this.onRemove = e1, this.reset();
                        };
                        N.prototype.reset = function() {
                            for(var t1 in this.data)for(var e1 = 0, r = this.data[t1]; e1 < r.length; e1 += 1){
                                var n = r[e1];
                                n.timeout && clearTimeout(n.timeout), this.onRemove(n.value);
                            }
                            return this.data = {}, this.order = [], this;
                        }, N.prototype.add = function(t1, e1, r) {
                            var n = this, i = t1.wrapped().key;
                            void 0 === this.data[i] && (this.data[i] = []);
                            var a = {
                                value: e1,
                                timeout: void 0
                            };
                            if (void 0 !== r && (a.timeout = setTimeout(function() {
                                n.remove(t1, a);
                            }, r)), this.data[i].push(a), this.order.push(i), this.order.length > this.max) {
                                var o = this._getAndRemoveByKey(this.order[0]);
                                o && this.onRemove(o);
                            }
                            return this;
                        }, N.prototype.has = function(t1) {
                            return t1.wrapped().key in this.data;
                        }, N.prototype.getAndRemove = function(t1) {
                            return this.has(t1) ? this._getAndRemoveByKey(t1.wrapped().key) : null;
                        }, N.prototype._getAndRemoveByKey = function(t1) {
                            var e1 = this.data[t1].shift();
                            return e1.timeout && clearTimeout(e1.timeout), 0 === this.data[t1].length && delete this.data[t1], this.order.splice(this.order.indexOf(t1), 1), e1.value;
                        }, N.prototype.getByKey = function(t1) {
                            var e1 = this.data[t1];
                            return e1 ? e1[0].value : null;
                        }, N.prototype.get = function(t1) {
                            return this.has(t1) ? this.data[t1.wrapped().key][0].value : null;
                        }, N.prototype.remove = function(t1, e1) {
                            if (!this.has(t1)) return this;
                            var r = t1.wrapped().key, n = void 0 === e1 ? 0 : this.data[r].indexOf(e1), i = this.data[r][n];
                            return this.data[r].splice(n, 1), i.timeout && clearTimeout(i.timeout), 0 === this.data[r].length && delete this.data[r], this.onRemove(i.value), this.order.splice(this.order.indexOf(r), 1), this;
                        }, N.prototype.setMaxSize = function(t1) {
                            for(this.max = t1; this.order.length > this.max;){
                                var e1 = this._getAndRemoveByKey(this.order[0]);
                                e1 && this.onRemove(e1);
                            }
                            return this;
                        }, N.prototype.filter = function(t1) {
                            var e1 = [];
                            for(var r in this.data)for(var n = 0, i = this.data[r]; n < i.length; n += 1){
                                var a = i[n];
                                t1(a.value) || e1.push(a);
                            }
                            for(var o = 0, s = e1; o < s.length; o += 1){
                                var l = s[o];
                                this.remove(l.value.tileID, l);
                            }
                        };
                        var j = function(t1, e1, r) {
                            this.context = t1;
                            var n = t1.gl;
                            this.buffer = n.createBuffer(), this.dynamicDraw = Boolean(r), this.context.unbindVAO(), t1.bindElementBuffer.set(this.buffer), n.bufferData(n.ELEMENT_ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
                        };
                        j.prototype.bind = function() {
                            this.context.bindElementBuffer.set(this.buffer);
                        }, j.prototype.updateData = function(t1) {
                            var e1 = this.context.gl;
                            this.context.unbindVAO(), this.bind(), e1.bufferSubData(e1.ELEMENT_ARRAY_BUFFER, 0, t1.arrayBuffer);
                        }, j.prototype.destroy = function() {
                            var t1 = this.context.gl;
                            this.buffer && (t1.deleteBuffer(this.buffer), delete this.buffer);
                        };
                        var U = {
                            Int8: "BYTE",
                            Uint8: "UNSIGNED_BYTE",
                            Int16: "SHORT",
                            Uint16: "UNSIGNED_SHORT",
                            Int32: "INT",
                            Uint32: "UNSIGNED_INT",
                            Float32: "FLOAT"
                        }, V = function(t1, e1, r, n) {
                            this.length = e1.length, this.attributes = r, this.itemSize = e1.bytesPerElement, this.dynamicDraw = n, this.context = t1;
                            var i = t1.gl;
                            this.buffer = i.createBuffer(), t1.bindVertexBuffer.set(this.buffer), i.bufferData(i.ARRAY_BUFFER, e1.arrayBuffer, this.dynamicDraw ? i.DYNAMIC_DRAW : i.STATIC_DRAW), this.dynamicDraw || delete e1.arrayBuffer;
                        };
                        V.prototype.bind = function() {
                            this.context.bindVertexBuffer.set(this.buffer);
                        }, V.prototype.updateData = function(t1) {
                            var e1 = this.context.gl;
                            this.bind(), e1.bufferSubData(e1.ARRAY_BUFFER, 0, t1.arrayBuffer);
                        }, V.prototype.enableAttributes = function(t1, e1) {
                            for(var r = 0; r < this.attributes.length; r++){
                                var n = this.attributes[r], i = e1.attributes[n.name];
                                void 0 !== i && t1.enableVertexAttribArray(i);
                            }
                        }, V.prototype.setVertexAttribPointers = function(t1, e1, r) {
                            for(var n = 0; n < this.attributes.length; n++){
                                var i = this.attributes[n], a = e1.attributes[i.name];
                                void 0 !== a && t1.vertexAttribPointer(a, i.components, t1[U[i.type]], !1, this.itemSize, i.offset + this.itemSize * (r || 0));
                            }
                        }, V.prototype.destroy = function() {
                            var t1 = this.context.gl;
                            this.buffer && (t1.deleteBuffer(this.buffer), delete this.buffer);
                        };
                        var H = function(t1) {
                            this.gl = t1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
                        };
                        H.prototype.get = function() {
                            return this.current;
                        }, H.prototype.set = function(t1) {}, H.prototype.getDefault = function() {
                            return this.default;
                        }, H.prototype.setDefault = function() {
                            this.set(this.default);
                        };
                        var q = function(e1) {
                            function r() {
                                e1.apply(this, arguments);
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.getDefault = function() {
                                return t1.Color.transparent;
                            }, r.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.clearColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
                            }, r;
                        }(H), G = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return 1;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.clearDepth(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), Y = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return 0;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.clearStencil(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), W = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ];
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.colorMask(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), X = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !0;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.depthMask(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), Z = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return 255;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.stencilMask(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), J = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return {
                                    func: this.gl.ALWAYS,
                                    ref: 0,
                                    mask: 255
                                };
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1.func !== e1.func || t1.ref !== e1.ref || t1.mask !== e1.mask || this.dirty) && (this.gl.stencilFunc(t1.func, t1.ref, t1.mask), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), K = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                var t1 = this.gl;
                                return [
                                    t1.KEEP,
                                    t1.KEEP,
                                    t1.KEEP
                                ];
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || this.dirty) && (this.gl.stencilOp(t1[0], t1[1], t1[2]), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), Q = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !1;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    t1 ? e1.enable(e1.STENCIL_TEST) : e1.disable(e1.STENCIL_TEST), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), $ = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return [
                                    0,
                                    1
                                ];
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.depthRange(t1[0], t1[1]), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), tt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !1;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    t1 ? e1.enable(e1.DEPTH_TEST) : e1.disable(e1.DEPTH_TEST), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), et = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return this.gl.LESS;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.depthFunc(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), rt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !1;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    t1 ? e1.enable(e1.BLEND) : e1.disable(e1.BLEND), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), nt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                var t1 = this.gl;
                                return [
                                    t1.ONE,
                                    t1.ZERO
                                ];
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || this.dirty) && (this.gl.blendFunc(t1[0], t1[1]), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), it = function(e1) {
                            function r() {
                                e1.apply(this, arguments);
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.getDefault = function() {
                                return t1.Color.transparent;
                            }, r.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1.r !== e1.r || t1.g !== e1.g || t1.b !== e1.b || t1.a !== e1.a || this.dirty) && (this.gl.blendColor(t1.r, t1.g, t1.b, t1.a), this.current = t1, this.dirty = !1);
                            }, r;
                        }(H), at = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return this.gl.FUNC_ADD;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.blendEquation(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), ot = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !1;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    t1 ? e1.enable(e1.CULL_FACE) : e1.disable(e1.CULL_FACE), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), st = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return this.gl.BACK;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.cullFace(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), lt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return this.gl.CCW;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.frontFace(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), ct = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.useProgram(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), ut = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return this.gl.TEXTURE0;
                            }, e1.prototype.set = function(t1) {
                                (t1 !== this.current || this.dirty) && (this.gl.activeTexture(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), ft = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                var t1 = this.gl;
                                return [
                                    0,
                                    0,
                                    t1.drawingBufferWidth,
                                    t1.drawingBufferHeight
                                ];
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.current;
                                (t1[0] !== e1[0] || t1[1] !== e1[1] || t1[2] !== e1[2] || t1[3] !== e1[3] || this.dirty) && (this.gl.viewport(t1[0], t1[1], t1[2], t1[3]), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), ht = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.bindFramebuffer(e1.FRAMEBUFFER, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), pt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.bindRenderbuffer(e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), dt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.bindTexture(e1.TEXTURE_2D, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), mt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.bindBuffer(e1.ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), gt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                var e1 = this.gl;
                                e1.bindBuffer(e1.ELEMENT_ARRAY_BUFFER, t1), this.current = t1, this.dirty = !1;
                            }, e1;
                        }(H), vt = function(t1) {
                            function e1(e1) {
                                t1.call(this, e1), this.vao = e1.extVertexArrayObject;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1.prototype.set = function(t1) {
                                this.vao && (t1 !== this.current || this.dirty) && (this.vao.bindVertexArrayOES(t1), this.current = t1, this.dirty = !1);
                            }, e1;
                        }(H), yt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return 4;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.pixelStorei(e1.UNPACK_ALIGNMENT, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), xt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !1;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), bt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return !1;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    var e1 = this.gl;
                                    e1.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(H), _t = function(t1) {
                            function e1(e1, r) {
                                t1.call(this, e1), this.context = e1, this.parent = r;
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.getDefault = function() {
                                return null;
                            }, e1;
                        }(H), wt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.setDirty = function() {
                                this.dirty = !0;
                            }, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    this.context.bindFramebuffer.set(this.parent);
                                    var e1 = this.gl;
                                    e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, t1, 0), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(_t), Tt = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.set = function(t1) {
                                if (t1 !== this.current || this.dirty) {
                                    this.context.bindFramebuffer.set(this.parent);
                                    var e1 = this.gl;
                                    e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.RENDERBUFFER, t1), this.current = t1, this.dirty = !1;
                                }
                            }, e1;
                        }(_t), kt = function(t1, e1, r, n) {
                            this.context = t1, this.width = e1, this.height = r;
                            var i = t1.gl, a = this.framebuffer = i.createFramebuffer();
                            this.colorAttachment = new wt(t1, a), n && (this.depthAttachment = new Tt(t1, a));
                        };
                        kt.prototype.destroy = function() {
                            var t1 = this.context.gl, e1 = this.colorAttachment.get();
                            if (e1 && t1.deleteTexture(e1), this.depthAttachment) {
                                var r = this.depthAttachment.get();
                                r && t1.deleteRenderbuffer(r);
                            }
                            t1.deleteFramebuffer(this.framebuffer);
                        };
                        var At = function(t1, e1, r) {
                            this.func = t1, this.mask = e1, this.range = r;
                        };
                        At.ReadOnly = !1, At.ReadWrite = !0, At.disabled = new At(519, At.ReadOnly, [
                            0,
                            1
                        ]);
                        var Mt = function(t1, e1, r, n, i, a) {
                            this.test = t1, this.ref = e1, this.mask = r, this.fail = n, this.depthFail = i, this.pass = a;
                        };
                        Mt.disabled = new Mt({
                            func: 519,
                            mask: 0
                        }, 0, 0, 7680, 7680, 7680);
                        var St = function(t1, e1, r) {
                            this.blendFunction = t1, this.blendColor = e1, this.mask = r;
                        };
                        St.disabled = new St(St.Replace = [
                            1,
                            0
                        ], t1.Color.transparent, [
                            !1,
                            !1,
                            !1,
                            !1
                        ]), St.unblended = new St(St.Replace, t1.Color.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]), St.alphaBlended = new St([
                            1,
                            771
                        ], t1.Color.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        var Et = function(t1, e1, r) {
                            this.enable = t1, this.mode = e1, this.frontFace = r;
                        };
                        Et.disabled = new Et(!1, 1029, 2305), Et.backCCW = new Et(!0, 1029, 2305);
                        var Lt = function(t1) {
                            this.gl = t1, this.extVertexArrayObject = this.gl.getExtension("OES_vertex_array_object"), this.clearColor = new q(this), this.clearDepth = new G(this), this.clearStencil = new Y(this), this.colorMask = new W(this), this.depthMask = new X(this), this.stencilMask = new Z(this), this.stencilFunc = new J(this), this.stencilOp = new K(this), this.stencilTest = new Q(this), this.depthRange = new $(this), this.depthTest = new tt(this), this.depthFunc = new et(this), this.blend = new rt(this), this.blendFunc = new nt(this), this.blendColor = new it(this), this.blendEquation = new at(this), this.cullFace = new ot(this), this.cullFaceSide = new st(this), this.frontFace = new lt(this), this.program = new ct(this), this.activeTexture = new ut(this), this.viewport = new ft(this), this.bindFramebuffer = new ht(this), this.bindRenderbuffer = new pt(this), this.bindTexture = new dt(this), this.bindVertexBuffer = new mt(this), this.bindElementBuffer = new gt(this), this.bindVertexArrayOES = this.extVertexArrayObject && new vt(this), this.pixelStoreUnpack = new yt(this), this.pixelStoreUnpackPremultiplyAlpha = new xt(this), this.pixelStoreUnpackFlipY = new bt(this), this.extTextureFilterAnisotropic = t1.getExtension("EXT_texture_filter_anisotropic") || t1.getExtension("MOZ_EXT_texture_filter_anisotropic") || t1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = t1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.extTextureHalfFloat = t1.getExtension("OES_texture_half_float"), this.extTextureHalfFloat && (t1.getExtension("OES_texture_half_float_linear"), this.extRenderToTextureHalfFloat = t1.getExtension("EXT_color_buffer_half_float")), this.extTimerQuery = t1.getExtension("EXT_disjoint_timer_query");
                        };
                        Lt.prototype.setDefault = function() {
                            this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
                        }, Lt.prototype.setDirty = function() {
                            this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.extVertexArrayObject && (this.bindVertexArrayOES.dirty = !0), this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
                        }, Lt.prototype.createIndexBuffer = function(t1, e1) {
                            return new j(this, t1, e1);
                        }, Lt.prototype.createVertexBuffer = function(t1, e1, r) {
                            return new V(this, t1, e1, r);
                        }, Lt.prototype.createRenderbuffer = function(t1, e1, r) {
                            var n = this.gl, i = n.createRenderbuffer();
                            return this.bindRenderbuffer.set(i), n.renderbufferStorage(n.RENDERBUFFER, t1, e1, r), this.bindRenderbuffer.set(null), i;
                        }, Lt.prototype.createFramebuffer = function(t1, e1, r) {
                            return new kt(this, t1, e1, r);
                        }, Lt.prototype.clear = function(t1) {
                            var e1 = t1.color, r = t1.depth, n = this.gl, i = 0;
                            e1 && (i |= n.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set([
                                !0,
                                !0,
                                !0,
                                !0
                            ])), void 0 !== r && (i |= n.DEPTH_BUFFER_BIT, this.depthRange.set([
                                0,
                                1
                            ]), this.clearDepth.set(r), this.depthMask.set(!0)), n.clear(i);
                        }, Lt.prototype.setCullFace = function(t1) {
                            !1 === t1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(t1.mode), this.frontFace.set(t1.frontFace));
                        }, Lt.prototype.setDepthMode = function(t1) {
                            t1.func !== this.gl.ALWAYS || t1.mask ? (this.depthTest.set(!0), this.depthFunc.set(t1.func), this.depthMask.set(t1.mask), this.depthRange.set(t1.range)) : this.depthTest.set(!1);
                        }, Lt.prototype.setStencilMode = function(t1) {
                            t1.test.func !== this.gl.ALWAYS || t1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(t1.mask), this.stencilOp.set([
                                t1.fail,
                                t1.depthFail,
                                t1.pass
                            ]), this.stencilFunc.set({
                                func: t1.test.func,
                                ref: t1.ref,
                                mask: t1.test.mask
                            })) : this.stencilTest.set(!1);
                        }, Lt.prototype.setColorMode = function(e1) {
                            t1.deepEqual(e1.blendFunction, St.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor)), this.colorMask.set(e1.mask);
                        }, Lt.prototype.unbindVAO = function() {
                            this.extVertexArrayObject && this.bindVertexArrayOES.set(null);
                        };
                        var Ct = function(e1) {
                            function r(r, n, i) {
                                var a = this;
                                e1.call(this), this.id = r, this.dispatcher = i, this.on("data", function(t1) {
                                    "source" === t1.dataType && "metadata" === t1.sourceDataType && (a._sourceLoaded = !0), a._sourceLoaded && !a._paused && "source" === t1.dataType && "content" === t1.sourceDataType && (a.reload(), a.transform && a.update(a.transform));
                                }), this.on("error", function() {
                                    a._sourceErrored = !0;
                                }), this._source = function(e1, r, n, i) {
                                    var a = new D[r.type](e1, r, n, i);
                                    if (a.id !== e1) throw new Error("Expected Source id to be " + e1 + " instead of " + a.id);
                                    return t1.bindAll([
                                        "load",
                                        "abort",
                                        "unload",
                                        "serialize",
                                        "prepare"
                                    ], a), a;
                                }(r, n, i, this), this._tiles = {}, this._cache = new N(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new t1.SourceFeatureState;
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.onAdd = function(t1) {
                                this.map = t1, this._maxTileCacheSize = t1 ? t1._maxTileCacheSize : null, this._source && this._source.onAdd && this._source.onAdd(t1);
                            }, r.prototype.onRemove = function(t1) {
                                this._source && this._source.onRemove && this._source.onRemove(t1);
                            }, r.prototype.loaded = function() {
                                if (this._sourceErrored) return !0;
                                if (!this._sourceLoaded) return !1;
                                if (!this._source.loaded()) return !1;
                                for(var t1 in this._tiles){
                                    var e1 = this._tiles[t1];
                                    if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
                                }
                                return !0;
                            }, r.prototype.getSource = function() {
                                return this._source;
                            }, r.prototype.pause = function() {
                                this._paused = !0;
                            }, r.prototype.resume = function() {
                                if (this._paused) {
                                    var t1 = this._shouldReloadOnResume;
                                    this._paused = !1, this._shouldReloadOnResume = !1, t1 && this.reload(), this.transform && this.update(this.transform);
                                }
                            }, r.prototype._loadTile = function(t1, e1) {
                                return this._source.loadTile(t1, e1);
                            }, r.prototype._unloadTile = function(t1) {
                                if (this._source.unloadTile) return this._source.unloadTile(t1, function() {});
                            }, r.prototype._abortTile = function(t1) {
                                if (this._source.abortTile) return this._source.abortTile(t1, function() {});
                            }, r.prototype.serialize = function() {
                                return this._source.serialize();
                            }, r.prototype.prepare = function(t1) {
                                for(var e1 in this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null), this._tiles){
                                    var r = this._tiles[e1];
                                    r.upload(t1), r.prepare(this.map.style.imageManager);
                                }
                            }, r.prototype.getIds = function() {
                                return t1.values(this._tiles).map(function(t1) {
                                    return t1.tileID;
                                }).sort(Pt).map(function(t1) {
                                    return t1.key;
                                });
                            }, r.prototype.getRenderableIds = function(e1) {
                                var r = this, n = [];
                                for(var i in this._tiles)this._isIdRenderable(i, e1) && n.push(this._tiles[i]);
                                return e1 ? n.sort(function(e1, n) {
                                    var i = e1.tileID, a = n.tileID, o = new t1.Point(i.canonical.x, i.canonical.y)._rotate(r.transform.angle), s = new t1.Point(a.canonical.x, a.canonical.y)._rotate(r.transform.angle);
                                    return i.overscaledZ - a.overscaledZ || s.y - o.y || s.x - o.x;
                                }).map(function(t1) {
                                    return t1.tileID.key;
                                }) : n.map(function(t1) {
                                    return t1.tileID;
                                }).sort(Pt).map(function(t1) {
                                    return t1.key;
                                });
                            }, r.prototype.hasRenderableParent = function(t1) {
                                var e1 = this.findLoadedParent(t1, 0);
                                return !!e1 && this._isIdRenderable(e1.tileID.key);
                            }, r.prototype._isIdRenderable = function(t1, e1) {
                                return this._tiles[t1] && this._tiles[t1].hasData() && !this._coveredTiles[t1] && (e1 || !this._tiles[t1].holdingForFade());
                            }, r.prototype.reload = function() {
                                if (this._paused) this._shouldReloadOnResume = !0;
                                else for(var t1 in this._cache.reset(), this._tiles)"errored" !== this._tiles[t1].state && this._reloadTile(t1, "reloading");
                            }, r.prototype._reloadTile = function(t1, e1) {
                                var r = this._tiles[t1];
                                r && ("loading" !== r.state && (r.state = e1), this._loadTile(r, this._tileLoaded.bind(this, r, t1, e1)));
                            }, r.prototype._tileLoaded = function(e1, r, n, i) {
                                if (i) return e1.state = "errored", void (404 !== i.status ? this._source.fire(new t1.ErrorEvent(i, {
                                    tile: e1
                                })) : this.update(this.transform));
                                e1.timeAdded = t1.browser.now(), "expired" === n && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(r, e1), "raster-dem" === this.getSource().type && e1.dem && this._backfillDEM(e1), this._state.initializeTileState(e1, this.map ? this.map.painter : null), this._source.fire(new t1.Event("data", {
                                    dataType: "source",
                                    tile: e1,
                                    coord: e1.tileID
                                }));
                            }, r.prototype._backfillDEM = function(t1) {
                                for(var e1 = this.getRenderableIds(), r = 0; r < e1.length; r++){
                                    var n = e1[r];
                                    if (t1.neighboringTiles && t1.neighboringTiles[n]) {
                                        var i = this.getTileByID(n);
                                        a(t1, i), a(i, t1);
                                    }
                                }
                                function a(t1, e1) {
                                    t1.needsHillshadePrepare = !0;
                                    var r = e1.tileID.canonical.x - t1.tileID.canonical.x, n = e1.tileID.canonical.y - t1.tileID.canonical.y, i = Math.pow(2, t1.tileID.canonical.z), a = e1.tileID.key;
                                    0 === r && 0 === n || Math.abs(n) > 1 || (Math.abs(r) > 1 && (1 === Math.abs(r + i) ? r += i : 1 === Math.abs(r - i) && (r -= i)), e1.dem && t1.dem && (t1.dem.backfillBorder(e1.dem, r, n), t1.neighboringTiles && t1.neighboringTiles[a] && (t1.neighboringTiles[a].backfilled = !0)));
                                }
                            }, r.prototype.getTile = function(t1) {
                                return this.getTileByID(t1.key);
                            }, r.prototype.getTileByID = function(t1) {
                                return this._tiles[t1];
                            }, r.prototype._retainLoadedChildren = function(t1, e1, r, n) {
                                for(var i in this._tiles){
                                    var a = this._tiles[i];
                                    if (!(n[i] || !a.hasData() || a.tileID.overscaledZ <= e1 || a.tileID.overscaledZ > r)) {
                                        for(var o = a.tileID; a && a.tileID.overscaledZ > e1 + 1;){
                                            var s = a.tileID.scaledTo(a.tileID.overscaledZ - 1);
                                            (a = this._tiles[s.key]) && a.hasData() && (o = s);
                                        }
                                        for(var l = o; l.overscaledZ > e1;)if (t1[(l = l.scaledTo(l.overscaledZ - 1)).key]) {
                                            n[o.key] = o;
                                            break;
                                        }
                                    }
                                }
                            }, r.prototype.findLoadedParent = function(t1, e1) {
                                if (t1.key in this._loadedParentTiles) {
                                    var r = this._loadedParentTiles[t1.key];
                                    return r && r.tileID.overscaledZ >= e1 ? r : null;
                                }
                                for(var n = t1.overscaledZ - 1; n >= e1; n--){
                                    var i = t1.scaledTo(n), a = this._getLoadedTile(i);
                                    if (a) return a;
                                }
                            }, r.prototype._getLoadedTile = function(t1) {
                                var e1 = this._tiles[t1.key];
                                return e1 && e1.hasData() ? e1 : this._cache.getByKey(t1.wrapped().key);
                            }, r.prototype.updateCacheSize = function(t1) {
                                var e1 = (Math.ceil(t1.width / this._source.tileSize) + 1) * (Math.ceil(t1.height / this._source.tileSize) + 1), r = Math.floor(5 * e1), n = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, r) : r;
                                this._cache.setMaxSize(n);
                            }, r.prototype.handleWrapJump = function(t1) {
                                var e1 = (t1 - (void 0 === this._prevLng ? t1 : this._prevLng)) / 360, r = Math.round(e1);
                                if (this._prevLng = t1, r) {
                                    var n = {};
                                    for(var i in this._tiles){
                                        var a = this._tiles[i];
                                        a.tileID = a.tileID.unwrapTo(a.tileID.wrap + r), n[a.tileID.key] = a;
                                    }
                                    for(var o in this._tiles = n, this._timers)clearTimeout(this._timers[o]), delete this._timers[o];
                                    for(var s in this._tiles){
                                        var l = this._tiles[s];
                                        this._setTileReloadTimer(s, l);
                                    }
                                }
                            }, r.prototype.update = function(e1) {
                                var n = this;
                                if (this.transform = e1, this._sourceLoaded && !this._paused) {
                                    var i;
                                    this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used ? this._source.tileID ? i = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map(function(e1) {
                                        return new t1.OverscaledTileID(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y);
                                    }) : (i = e1.coveringTiles({
                                        tileSize: this._source.tileSize,
                                        minzoom: this._source.minzoom,
                                        maxzoom: this._source.maxzoom,
                                        roundZoom: this._source.roundZoom,
                                        reparseOverscaled: this._source.reparseOverscaled
                                    }), this._source.hasTile && (i = i.filter(function(t1) {
                                        return n._source.hasTile(t1);
                                    }))) : i = [];
                                    var a = e1.coveringZoomLevel(this._source), o = Math.max(a - r.maxOverzooming, this._source.minzoom), s = Math.max(a + r.maxUnderzooming, this._source.minzoom), l = this._updateRetainedTiles(i, a);
                                    if (It(this._source.type)) {
                                        for(var c = {}, u = {}, f = 0, h = Object.keys(l); f < h.length; f += 1){
                                            var p = h[f], d = l[p], m = this._tiles[p];
                                            if (m && !(m.fadeEndTime && m.fadeEndTime <= t1.browser.now())) {
                                                var g = this.findLoadedParent(d, o);
                                                g && (this._addTile(g.tileID), c[g.tileID.key] = g.tileID), u[p] = d;
                                            }
                                        }
                                        for(var v in this._retainLoadedChildren(u, a, s, l), c)l[v] || (this._coveredTiles[v] = !0, l[v] = c[v]);
                                    }
                                    for(var y in l)this._tiles[y].clearFadeHold();
                                    for(var x = 0, b = t1.keysDifference(this._tiles, l); x < b.length; x += 1){
                                        var _ = b[x], w = this._tiles[_];
                                        w.hasSymbolBuckets && !w.holdingForFade() ? w.setHoldDuration(this.map._fadeDuration) : w.hasSymbolBuckets && !w.symbolFadeFinished() || this._removeTile(_);
                                    }
                                    this._updateLoadedParentTileCache();
                                }
                            }, r.prototype.releaseSymbolFadeTiles = function() {
                                for(var t1 in this._tiles)this._tiles[t1].holdingForFade() && this._removeTile(t1);
                            }, r.prototype._updateRetainedTiles = function(t1, e1) {
                                for(var n = {}, i = {}, a = Math.max(e1 - r.maxOverzooming, this._source.minzoom), o = Math.max(e1 + r.maxUnderzooming, this._source.minzoom), s = {}, l = 0, c = t1; l < c.length; l += 1){
                                    var u = c[l], f = this._addTile(u);
                                    n[u.key] = u, f.hasData() || e1 < this._source.maxzoom && (s[u.key] = u);
                                }
                                this._retainLoadedChildren(s, e1, o, n);
                                for(var h = 0, p = t1; h < p.length; h += 1){
                                    var d = p[h], m = this._tiles[d.key];
                                    if (!m.hasData()) {
                                        if (e1 + 1 > this._source.maxzoom) {
                                            var g = d.children(this._source.maxzoom)[0], v = this.getTile(g);
                                            if (v && v.hasData()) {
                                                n[g.key] = g;
                                                continue;
                                            }
                                        } else {
                                            var y = d.children(this._source.maxzoom);
                                            if (n[y[0].key] && n[y[1].key] && n[y[2].key] && n[y[3].key]) continue;
                                        }
                                        for(var x = m.wasRequested(), b = d.overscaledZ - 1; b >= a; --b){
                                            var _ = d.scaledTo(b);
                                            if (i[_.key]) break;
                                            if (i[_.key] = !0, !(m = this.getTile(_)) && x && (m = this._addTile(_)), m && (n[_.key] = _, x = m.wasRequested(), m.hasData())) break;
                                        }
                                    }
                                }
                                return n;
                            }, r.prototype._updateLoadedParentTileCache = function() {
                                for(var t1 in this._loadedParentTiles = {}, this._tiles){
                                    for(var e1 = [], r = void 0, n = this._tiles[t1].tileID; n.overscaledZ > 0;){
                                        if (n.key in this._loadedParentTiles) {
                                            r = this._loadedParentTiles[n.key];
                                            break;
                                        }
                                        e1.push(n.key);
                                        var i = n.scaledTo(n.overscaledZ - 1);
                                        if (r = this._getLoadedTile(i)) break;
                                        n = i;
                                    }
                                    for(var a = 0, o = e1; a < o.length; a += 1){
                                        var s = o[a];
                                        this._loadedParentTiles[s] = r;
                                    }
                                }
                            }, r.prototype._addTile = function(e1) {
                                var r = this._tiles[e1.key];
                                if (r) return r;
                                (r = this._cache.getAndRemove(e1)) && (this._setTileReloadTimer(e1.key, r), r.tileID = e1, this._state.initializeTileState(r, this.map ? this.map.painter : null), this._cacheTimers[e1.key] && (clearTimeout(this._cacheTimers[e1.key]), delete this._cacheTimers[e1.key], this._setTileReloadTimer(e1.key, r)));
                                var n = Boolean(r);
                                return n || (r = new t1.Tile(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(r, this._tileLoaded.bind(this, r, e1.key, r.state))), r ? (r.uses++, this._tiles[e1.key] = r, n || this._source.fire(new t1.Event("dataloading", {
                                    tile: r,
                                    coord: r.tileID,
                                    dataType: "source"
                                })), r) : null;
                            }, r.prototype._setTileReloadTimer = function(t1, e1) {
                                var r = this;
                                t1 in this._timers && (clearTimeout(this._timers[t1]), delete this._timers[t1]);
                                var n = e1.getExpiryTimeout();
                                n && (this._timers[t1] = setTimeout(function() {
                                    r._reloadTile(t1, "expired"), delete r._timers[t1];
                                }, n));
                            }, r.prototype._removeTile = function(t1) {
                                var e1 = this._tiles[t1];
                                e1 && (e1.uses--, delete this._tiles[t1], this._timers[t1] && (clearTimeout(this._timers[t1]), delete this._timers[t1]), e1.uses > 0 || (e1.hasData() && "reloading" !== e1.state ? this._cache.add(e1.tileID, e1, e1.getExpiryTimeout()) : (e1.aborted = !0, this._abortTile(e1), this._unloadTile(e1))));
                            }, r.prototype.clearTiles = function() {
                                for(var t1 in this._shouldReloadOnResume = !1, this._paused = !1, this._tiles)this._removeTile(t1);
                                this._cache.reset();
                            }, r.prototype.tilesIn = function(e1, r, n) {
                                var i = this, a = [], o = this.transform;
                                if (!o) return a;
                                for(var s = n ? o.getCameraQueryGeometry(e1) : e1, l = e1.map(function(t1) {
                                    return o.pointCoordinate(t1);
                                }), c = s.map(function(t1) {
                                    return o.pointCoordinate(t1);
                                }), u = this.getIds(), f = 1 / 0, h = 1 / 0, p = -1 / 0, d = -1 / 0, m = 0, g = c; m < g.length; m += 1){
                                    var v = g[m];
                                    f = Math.min(f, v.x), h = Math.min(h, v.y), p = Math.max(p, v.x), d = Math.max(d, v.y);
                                }
                                for(var y = function(e1) {
                                    var n = i._tiles[u[e1]];
                                    if (!n.holdingForFade()) {
                                        var s = n.tileID, m = Math.pow(2, o.zoom - n.tileID.overscaledZ), g = r * n.queryPadding * t1.EXTENT / n.tileSize / m, v = [
                                            s.getTilePoint(new t1.MercatorCoordinate(f, h)),
                                            s.getTilePoint(new t1.MercatorCoordinate(p, d))
                                        ];
                                        if (v[0].x - g < t1.EXTENT && v[0].y - g < t1.EXTENT && v[1].x + g >= 0 && v[1].y + g >= 0) {
                                            var y = l.map(function(t1) {
                                                return s.getTilePoint(t1);
                                            }), x = c.map(function(t1) {
                                                return s.getTilePoint(t1);
                                            });
                                            a.push({
                                                tile: n,
                                                tileID: s,
                                                queryGeometry: y,
                                                cameraQueryGeometry: x,
                                                scale: m
                                            });
                                        }
                                    }
                                }, x = 0; x < u.length; x++)y(x);
                                return a;
                            }, r.prototype.getVisibleCoordinates = function(t1) {
                                for(var e1 = this, r = this.getRenderableIds(t1).map(function(t1) {
                                    return e1._tiles[t1].tileID;
                                }), n = 0, i = r; n < i.length; n += 1){
                                    var a = i[n];
                                    a.posMatrix = this.transform.calculatePosMatrix(a.toUnwrapped());
                                }
                                return r;
                            }, r.prototype.hasTransition = function() {
                                if (this._source.hasTransition()) return !0;
                                if (It(this._source.type)) for(var e1 in this._tiles){
                                    var r = this._tiles[e1];
                                    if (void 0 !== r.fadeEndTime && r.fadeEndTime >= t1.browser.now()) return !0;
                                }
                                return !1;
                            }, r.prototype.setFeatureState = function(t1, e1, r) {
                                t1 = t1 || "_geojsonTileLayer", this._state.updateState(t1, e1, r);
                            }, r.prototype.removeFeatureState = function(t1, e1, r) {
                                t1 = t1 || "_geojsonTileLayer", this._state.removeFeatureState(t1, e1, r);
                            }, r.prototype.getFeatureState = function(t1, e1) {
                                return t1 = t1 || "_geojsonTileLayer", this._state.getState(t1, e1);
                            }, r.prototype.setDependencies = function(t1, e1, r) {
                                var n = this._tiles[t1];
                                n && n.setDependencies(e1, r);
                            }, r.prototype.reloadTilesForDependencies = function(t1, e1) {
                                for(var r in this._tiles)this._tiles[r].hasDependency(t1, e1) && this._reloadTile(r, "reloading");
                                this._cache.filter(function(r) {
                                    return !r.hasDependency(t1, e1);
                                });
                            }, r;
                        }(t1.Evented);
                        function Pt(t1, e1) {
                            var r = Math.abs(2 * t1.wrap) - +(t1.wrap < 0), n = Math.abs(2 * e1.wrap) - +(e1.wrap < 0);
                            return t1.overscaledZ - e1.overscaledZ || n - r || e1.canonical.y - t1.canonical.y || e1.canonical.x - t1.canonical.x;
                        }
                        function It(t1) {
                            return "raster" === t1 || "image" === t1 || "video" === t1;
                        }
                        function Ot() {
                            return new t1.window.Worker(Zi.workerUrl);
                        }
                        Ct.maxOverzooming = 10, Ct.maxUnderzooming = 3;
                        var zt = "mapboxgl_preloaded_worker_pool", Dt = function() {
                            this.active = {};
                        };
                        Dt.prototype.acquire = function(t1) {
                            if (!this.workers) for(this.workers = []; this.workers.length < Dt.workerCount;)this.workers.push(new Ot);
                            return this.active[t1] = !0, this.workers.slice();
                        }, Dt.prototype.release = function(t1) {
                            delete this.active[t1], 0 === this.numActive() && (this.workers.forEach(function(t1) {
                                t1.terminate();
                            }), this.workers = null);
                        }, Dt.prototype.isPreloaded = function() {
                            return !!this.active[zt];
                        }, Dt.prototype.numActive = function() {
                            return Object.keys(this.active).length;
                        };
                        var Rt, Ft = Math.floor(t1.browser.hardwareConcurrency / 2);
                        function Bt() {
                            return Rt || (Rt = new Dt), Rt;
                        }
                        function Nt(e1, r) {
                            var n = {};
                            for(var i in e1)"ref" !== i && (n[i] = e1[i]);
                            return t1.refProperties.forEach(function(t1) {
                                t1 in r && (n[t1] = r[t1]);
                            }), n;
                        }
                        function jt(t1) {
                            t1 = t1.slice();
                            for(var e1 = Object.create(null), r = 0; r < t1.length; r++)e1[t1[r].id] = t1[r];
                            for(var n = 0; n < t1.length; n++)"ref" in t1[n] && (t1[n] = Nt(t1[n], e1[t1[n].ref]));
                            return t1;
                        }
                        Dt.workerCount = Math.max(Math.min(Ft, 6), 1);
                        var Ut = {
                            setStyle: "setStyle",
                            addLayer: "addLayer",
                            removeLayer: "removeLayer",
                            setPaintProperty: "setPaintProperty",
                            setLayoutProperty: "setLayoutProperty",
                            setFilter: "setFilter",
                            addSource: "addSource",
                            removeSource: "removeSource",
                            setGeoJSONSourceData: "setGeoJSONSourceData",
                            setLayerZoomRange: "setLayerZoomRange",
                            setLayerProperty: "setLayerProperty",
                            setCenter: "setCenter",
                            setZoom: "setZoom",
                            setBearing: "setBearing",
                            setPitch: "setPitch",
                            setSprite: "setSprite",
                            setGlyphs: "setGlyphs",
                            setTransition: "setTransition",
                            setLight: "setLight"
                        };
                        function Vt(t1, e1, r) {
                            r.push({
                                command: Ut.addSource,
                                args: [
                                    t1,
                                    e1[t1]
                                ]
                            });
                        }
                        function Ht(t1, e1, r) {
                            e1.push({
                                command: Ut.removeSource,
                                args: [
                                    t1
                                ]
                            }), r[t1] = !0;
                        }
                        function qt(t1, e1, r, n) {
                            Ht(t1, r, n), Vt(t1, e1, r);
                        }
                        function Gt(e1, r, n) {
                            var i;
                            for(i in e1[n])if (e1[n].hasOwnProperty(i) && "data" !== i && !t1.deepEqual(e1[n][i], r[n][i])) return !1;
                            for(i in r[n])if (r[n].hasOwnProperty(i) && "data" !== i && !t1.deepEqual(e1[n][i], r[n][i])) return !1;
                            return !0;
                        }
                        function Yt(e1, r, n, i, a, o) {
                            var s;
                            for(s in r = r || {}, e1 = e1 || {})e1.hasOwnProperty(s) && (t1.deepEqual(e1[s], r[s]) || n.push({
                                command: o,
                                args: [
                                    i,
                                    s,
                                    r[s],
                                    a
                                ]
                            }));
                            for(s in r)r.hasOwnProperty(s) && !e1.hasOwnProperty(s) && (t1.deepEqual(e1[s], r[s]) || n.push({
                                command: o,
                                args: [
                                    i,
                                    s,
                                    r[s],
                                    a
                                ]
                            }));
                        }
                        function Wt(t1) {
                            return t1.id;
                        }
                        function Xt(t1, e1) {
                            return t1[e1.id] = e1, t1;
                        }
                        function Zt(e1, r) {
                            if (!e1) return [
                                {
                                    command: Ut.setStyle,
                                    args: [
                                        r
                                    ]
                                }
                            ];
                            var n = [];
                            try {
                                if (!t1.deepEqual(e1.version, r.version)) return [
                                    {
                                        command: Ut.setStyle,
                                        args: [
                                            r
                                        ]
                                    }
                                ];
                                t1.deepEqual(e1.center, r.center) || n.push({
                                    command: Ut.setCenter,
                                    args: [
                                        r.center
                                    ]
                                }), t1.deepEqual(e1.zoom, r.zoom) || n.push({
                                    command: Ut.setZoom,
                                    args: [
                                        r.zoom
                                    ]
                                }), t1.deepEqual(e1.bearing, r.bearing) || n.push({
                                    command: Ut.setBearing,
                                    args: [
                                        r.bearing
                                    ]
                                }), t1.deepEqual(e1.pitch, r.pitch) || n.push({
                                    command: Ut.setPitch,
                                    args: [
                                        r.pitch
                                    ]
                                }), t1.deepEqual(e1.sprite, r.sprite) || n.push({
                                    command: Ut.setSprite,
                                    args: [
                                        r.sprite
                                    ]
                                }), t1.deepEqual(e1.glyphs, r.glyphs) || n.push({
                                    command: Ut.setGlyphs,
                                    args: [
                                        r.glyphs
                                    ]
                                }), t1.deepEqual(e1.transition, r.transition) || n.push({
                                    command: Ut.setTransition,
                                    args: [
                                        r.transition
                                    ]
                                }), t1.deepEqual(e1.light, r.light) || n.push({
                                    command: Ut.setLight,
                                    args: [
                                        r.light
                                    ]
                                });
                                var i = {}, a = [];
                                !function(e1, r, n, i) {
                                    var a;
                                    for(a in r = r || {}, e1 = e1 || {})e1.hasOwnProperty(a) && (r.hasOwnProperty(a) || Ht(a, n, i));
                                    for(a in r)r.hasOwnProperty(a) && (e1.hasOwnProperty(a) ? t1.deepEqual(e1[a], r[a]) || ("geojson" === e1[a].type && "geojson" === r[a].type && Gt(e1, r, a) ? n.push({
                                        command: Ut.setGeoJSONSourceData,
                                        args: [
                                            a,
                                            r[a].data
                                        ]
                                    }) : qt(a, r, n, i)) : Vt(a, r, n));
                                }(e1.sources, r.sources, a, i);
                                var o = [];
                                e1.layers && e1.layers.forEach(function(t1) {
                                    i[t1.source] ? n.push({
                                        command: Ut.removeLayer,
                                        args: [
                                            t1.id
                                        ]
                                    }) : o.push(t1);
                                }), n = n.concat(a), function(e1, r, n) {
                                    r = r || [];
                                    var i, a, o, s, l, c, u, f = (e1 = e1 || []).map(Wt), h = r.map(Wt), p = e1.reduce(Xt, {}), d = r.reduce(Xt, {}), m = f.slice(), g = Object.create(null);
                                    for(i = 0, a = 0; i < f.length; i++)o = f[i], d.hasOwnProperty(o) ? a++ : (n.push({
                                        command: Ut.removeLayer,
                                        args: [
                                            o
                                        ]
                                    }), m.splice(m.indexOf(o, a), 1));
                                    for(i = 0, a = 0; i < h.length; i++)o = h[h.length - 1 - i], m[m.length - 1 - i] !== o && (p.hasOwnProperty(o) ? (n.push({
                                        command: Ut.removeLayer,
                                        args: [
                                            o
                                        ]
                                    }), m.splice(m.lastIndexOf(o, m.length - a), 1)) : a++, c = m[m.length - i], n.push({
                                        command: Ut.addLayer,
                                        args: [
                                            d[o],
                                            c
                                        ]
                                    }), m.splice(m.length - i, 0, o), g[o] = !0);
                                    for(i = 0; i < h.length; i++)if (s = p[o = h[i]], l = d[o], !g[o] && !t1.deepEqual(s, l)) {
                                        if (t1.deepEqual(s.source, l.source) && t1.deepEqual(s["source-layer"], l["source-layer"]) && t1.deepEqual(s.type, l.type)) {
                                            for(u in Yt(s.layout, l.layout, n, o, null, Ut.setLayoutProperty), Yt(s.paint, l.paint, n, o, null, Ut.setPaintProperty), t1.deepEqual(s.filter, l.filter) || n.push({
                                                command: Ut.setFilter,
                                                args: [
                                                    o,
                                                    l.filter
                                                ]
                                            }), t1.deepEqual(s.minzoom, l.minzoom) && t1.deepEqual(s.maxzoom, l.maxzoom) || n.push({
                                                command: Ut.setLayerZoomRange,
                                                args: [
                                                    o,
                                                    l.minzoom,
                                                    l.maxzoom
                                                ]
                                            }), s)s.hasOwnProperty(u) && "layout" !== u && "paint" !== u && "filter" !== u && "metadata" !== u && "minzoom" !== u && "maxzoom" !== u && (0 === u.indexOf("paint.") ? Yt(s[u], l[u], n, o, u.slice(6), Ut.setPaintProperty) : t1.deepEqual(s[u], l[u]) || n.push({
                                                command: Ut.setLayerProperty,
                                                args: [
                                                    o,
                                                    u,
                                                    l[u]
                                                ]
                                            }));
                                            for(u in l)l.hasOwnProperty(u) && !s.hasOwnProperty(u) && "layout" !== u && "paint" !== u && "filter" !== u && "metadata" !== u && "minzoom" !== u && "maxzoom" !== u && (0 === u.indexOf("paint.") ? Yt(s[u], l[u], n, o, u.slice(6), Ut.setPaintProperty) : t1.deepEqual(s[u], l[u]) || n.push({
                                                command: Ut.setLayerProperty,
                                                args: [
                                                    o,
                                                    u,
                                                    l[u]
                                                ]
                                            }));
                                        } else n.push({
                                            command: Ut.removeLayer,
                                            args: [
                                                o
                                            ]
                                        }), c = m[m.lastIndexOf(o) + 1], n.push({
                                            command: Ut.addLayer,
                                            args: [
                                                l,
                                                c
                                            ]
                                        });
                                    }
                                }(o, r.layers, n);
                            } catch (t1) {
                                console.warn("Unable to compute style diff:", t1), n = [
                                    {
                                        command: Ut.setStyle,
                                        args: [
                                            r
                                        ]
                                    }
                                ];
                            }
                            return n;
                        }
                        var Jt = function(t1, e1) {
                            this.reset(t1, e1);
                        };
                        Jt.prototype.reset = function(t1, e1) {
                            this.points = t1 || [], this._distances = [
                                0
                            ];
                            for(var r = 1; r < this.points.length; r++)this._distances[r] = this._distances[r - 1] + this.points[r].dist(this.points[r - 1]);
                            this.length = this._distances[this._distances.length - 1], this.padding = Math.min(e1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
                        }, Jt.prototype.lerp = function(e1) {
                            if (1 === this.points.length) return this.points[0];
                            e1 = t1.clamp(e1, 0, 1);
                            for(var r = 1, n = this._distances[r], i = e1 * this.paddedLength + this.padding; n < i && r < this._distances.length;)n = this._distances[++r];
                            var a = r - 1, o = this._distances[a], s = n - o, l = s > 0 ? (i - o) / s : 0;
                            return this.points[a].mult(1 - l).add(this.points[r].mult(l));
                        };
                        var Kt = function(t1, e1, r) {
                            var n = this.boxCells = [], i = this.circleCells = [];
                            this.xCellCount = Math.ceil(t1 / r), this.yCellCount = Math.ceil(e1 / r);
                            for(var a = 0; a < this.xCellCount * this.yCellCount; a++)n.push([]), i.push([]);
                            this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = t1, this.height = e1, this.xScale = this.xCellCount / t1, this.yScale = this.yCellCount / e1, this.boxUid = 0, this.circleUid = 0;
                        };
                        function Qt(e1, r, n, i, a) {
                            var o = t1.create();
                            return r ? (t1.scale(o, o, [
                                1 / a,
                                1 / a,
                                1
                            ]), n || t1.rotateZ(o, o, i.angle)) : t1.multiply(o, i.labelPlaneMatrix, e1), o;
                        }
                        function $t(e1, r, n, i, a) {
                            if (r) {
                                var o = t1.clone(e1);
                                return t1.scale(o, o, [
                                    a,
                                    a,
                                    1
                                ]), n || t1.rotateZ(o, o, -i.angle), o;
                            }
                            return i.glCoordMatrix;
                        }
                        function te(e1, r) {
                            var n = [
                                e1.x,
                                e1.y,
                                0,
                                1
                            ];
                            fe(n, n, r);
                            var i = n[3];
                            return {
                                point: new t1.Point(n[0] / i, n[1] / i),
                                signedDistanceFromCamera: i
                            };
                        }
                        function ee(t1, e1) {
                            return .5 + t1 / e1 * .5;
                        }
                        function re(t1, e1) {
                            var r = t1[0] / t1[3], n = t1[1] / t1[3];
                            return r >= -e1[0] && r <= e1[0] && n >= -e1[1] && n <= e1[1];
                        }
                        function ne(e1, r, n, i, a, o, s, l) {
                            var c = i ? e1.textSizeData : e1.iconSizeData, u = t1.evaluateSizeForZoom(c, n.transform.zoom), f = [
                                256 / n.width * 2 + 1,
                                256 / n.height * 2 + 1
                            ], h = i ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
                            h.clear();
                            for(var p = e1.lineVertexArray, d = i ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, m = n.transform.width / n.transform.height, g = !1, v = 0; v < d.length; v++){
                                var y = d.get(v);
                                if (y.hidden || y.writingMode === t1.WritingMode.vertical && !g) ue(y.numGlyphs, h);
                                else {
                                    g = !1;
                                    var x = [
                                        y.anchorX,
                                        y.anchorY,
                                        0,
                                        1
                                    ];
                                    if (t1.transformMat4(x, x, r), re(x, f)) {
                                        var b = x[3], _ = ee(n.transform.cameraToCenterDistance, b), w = t1.evaluateSizeForFeature(c, u, y), T = s ? w / _ : w * _, k = new t1.Point(y.anchorX, y.anchorY), A = te(k, a).point, M = {}, S = oe(y, T, !1, l, r, a, o, e1.glyphOffsetArray, p, h, A, k, M, m);
                                        g = S.useVertical, (S.notEnoughRoom || g || S.needsFlipping && oe(y, T, !0, l, r, a, o, e1.glyphOffsetArray, p, h, A, k, M, m).notEnoughRoom) && ue(y.numGlyphs, h);
                                    } else ue(y.numGlyphs, h);
                                }
                            }
                            i ? e1.text.dynamicLayoutVertexBuffer.updateData(h) : e1.icon.dynamicLayoutVertexBuffer.updateData(h);
                        }
                        function ie(t1, e1, r, n, i, a, o, s, l, c, u) {
                            var f = s.glyphStartIndex + s.numGlyphs, h = s.lineStartIndex, p = s.lineStartIndex + s.lineLength, d = e1.getoffsetX(s.glyphStartIndex), m = e1.getoffsetX(f - 1), g = le(t1 * d, r, n, i, a, o, s.segment, h, p, l, c, u);
                            if (!g) return null;
                            var v = le(t1 * m, r, n, i, a, o, s.segment, h, p, l, c, u);
                            return v ? {
                                first: g,
                                last: v
                            } : null;
                        }
                        function ae(e1, r, n, i) {
                            if (e1 === t1.WritingMode.horizontal && Math.abs(n.y - r.y) > Math.abs(n.x - r.x) * i) return {
                                useVertical: !0
                            };
                            return (e1 === t1.WritingMode.vertical ? r.y < n.y : r.x > n.x) ? {
                                needsFlipping: !0
                            } : null;
                        }
                        function oe(e1, r, n, i, a, o, s, l, c, u, f, h, p, d) {
                            var m, g = r / 24, v = e1.lineOffsetX * g, y = e1.lineOffsetY * g;
                            if (e1.numGlyphs > 1) {
                                var x = e1.glyphStartIndex + e1.numGlyphs, b = e1.lineStartIndex, _ = e1.lineStartIndex + e1.lineLength, w = ie(g, l, v, y, n, f, h, e1, c, o, p);
                                if (!w) return {
                                    notEnoughRoom: !0
                                };
                                var T = te(w.first.point, s).point, k = te(w.last.point, s).point;
                                if (i && !n) {
                                    var A = ae(e1.writingMode, T, k, d);
                                    if (A) return A;
                                }
                                m = [
                                    w.first
                                ];
                                for(var M = e1.glyphStartIndex + 1; M < x - 1; M++)m.push(le(g * l.getoffsetX(M), v, y, n, f, h, e1.segment, b, _, c, o, p));
                                m.push(w.last);
                            } else {
                                if (i && !n) {
                                    var S = te(h, a).point, E = e1.lineStartIndex + e1.segment + 1, L = new t1.Point(c.getx(E), c.gety(E)), C = te(L, a), P = C.signedDistanceFromCamera > 0 ? C.point : se(h, L, S, 1, a), I = ae(e1.writingMode, S, P, d);
                                    if (I) return I;
                                }
                                var O = le(g * l.getoffsetX(e1.glyphStartIndex), v, y, n, f, h, e1.segment, e1.lineStartIndex, e1.lineStartIndex + e1.lineLength, c, o, p);
                                if (!O) return {
                                    notEnoughRoom: !0
                                };
                                m = [
                                    O
                                ];
                            }
                            for(var z = 0, D = m; z < D.length; z += 1){
                                var R = D[z];
                                t1.addDynamicAttributes(u, R.point, R.angle);
                            }
                            return {};
                        }
                        function se(t1, e1, r, n, i) {
                            var a = te(t1.add(t1.sub(e1)._unit()), i).point, o = r.sub(a);
                            return r.add(o._mult(n / o.mag()));
                        }
                        function le(e1, r, n, i, a, o, s, l, c, u, f, h) {
                            var p = i ? e1 - r : e1 + r, d = p > 0 ? 1 : -1, m = 0;
                            i && (d *= -1, m = Math.PI), d < 0 && (m += Math.PI);
                            for(var g = d > 0 ? l + s : l + s + 1, v = a, y = a, x = 0, b = 0, _ = Math.abs(p), w = []; x + b <= _;){
                                if ((g += d) < l || g >= c) return null;
                                if (y = v, w.push(v), void 0 === (v = h[g])) {
                                    var T = new t1.Point(u.getx(g), u.gety(g)), k = te(T, f);
                                    if (k.signedDistanceFromCamera > 0) v = h[g] = k.point;
                                    else {
                                        var A = g - d;
                                        v = se(0 === x ? o : new t1.Point(u.getx(A), u.gety(A)), T, y, _ - x + 1, f);
                                    }
                                }
                                x += b, b = y.dist(v);
                            }
                            var M = (_ - x) / b, S = v.sub(y), E = S.mult(M)._add(y);
                            E._add(S._unit()._perp()._mult(n * d));
                            var L = m + Math.atan2(v.y - y.y, v.x - y.x);
                            return w.push(E), {
                                point: E,
                                angle: L,
                                path: w
                            };
                        }
                        Kt.prototype.keysLength = function() {
                            return this.boxKeys.length + this.circleKeys.length;
                        }, Kt.prototype.insert = function(t1, e1, r, n, i) {
                            this._forEachCell(e1, r, n, i, this._insertBoxCell, this.boxUid++), this.boxKeys.push(t1), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
                        }, Kt.prototype.insertCircle = function(t1, e1, r, n) {
                            this._forEachCell(e1 - n, r - n, e1 + n, r + n, this._insertCircleCell, this.circleUid++), this.circleKeys.push(t1), this.circles.push(e1), this.circles.push(r), this.circles.push(n);
                        }, Kt.prototype._insertBoxCell = function(t1, e1, r, n, i, a) {
                            this.boxCells[i].push(a);
                        }, Kt.prototype._insertCircleCell = function(t1, e1, r, n, i, a) {
                            this.circleCells[i].push(a);
                        }, Kt.prototype._query = function(t1, e1, r, n, i, a) {
                            if (r < 0 || t1 > this.width || n < 0 || e1 > this.height) return !i && [];
                            var o = [];
                            if (t1 <= 0 && e1 <= 0 && this.width <= r && this.height <= n) {
                                if (i) return !0;
                                for(var s = 0; s < this.boxKeys.length; s++)o.push({
                                    key: this.boxKeys[s],
                                    x1: this.bboxes[4 * s],
                                    y1: this.bboxes[4 * s + 1],
                                    x2: this.bboxes[4 * s + 2],
                                    y2: this.bboxes[4 * s + 3]
                                });
                                for(var l = 0; l < this.circleKeys.length; l++){
                                    var c = this.circles[3 * l], u = this.circles[3 * l + 1], f = this.circles[3 * l + 2];
                                    o.push({
                                        key: this.circleKeys[l],
                                        x1: c - f,
                                        y1: u - f,
                                        x2: c + f,
                                        y2: u + f
                                    });
                                }
                                return a ? o.filter(a) : o;
                            }
                            var h = {
                                hitTest: i,
                                seenUids: {
                                    box: {},
                                    circle: {}
                                }
                            };
                            return this._forEachCell(t1, e1, r, n, this._queryCell, o, h, a), i ? o.length > 0 : o;
                        }, Kt.prototype._queryCircle = function(t1, e1, r, n, i) {
                            var a = t1 - r, o = t1 + r, s = e1 - r, l = e1 + r;
                            if (o < 0 || a > this.width || l < 0 || s > this.height) return !n && [];
                            var c = [], u = {
                                hitTest: n,
                                circle: {
                                    x: t1,
                                    y: e1,
                                    radius: r
                                },
                                seenUids: {
                                    box: {},
                                    circle: {}
                                }
                            };
                            return this._forEachCell(a, s, o, l, this._queryCellCircle, c, u, i), n ? c.length > 0 : c;
                        }, Kt.prototype.query = function(t1, e1, r, n, i) {
                            return this._query(t1, e1, r, n, !1, i);
                        }, Kt.prototype.hitTest = function(t1, e1, r, n, i) {
                            return this._query(t1, e1, r, n, !0, i);
                        }, Kt.prototype.hitTestCircle = function(t1, e1, r, n) {
                            return this._queryCircle(t1, e1, r, !0, n);
                        }, Kt.prototype._queryCell = function(t1, e1, r, n, i, a, o, s) {
                            var l = o.seenUids, c = this.boxCells[i];
                            if (null !== c) for(var u = this.bboxes, f = 0, h = c; f < h.length; f += 1){
                                var p = h[f];
                                if (!l.box[p]) {
                                    l.box[p] = !0;
                                    var d = 4 * p;
                                    if (t1 <= u[d + 2] && e1 <= u[d + 3] && r >= u[d + 0] && n >= u[d + 1] && (!s || s(this.boxKeys[p]))) {
                                        if (o.hitTest) return a.push(!0), !0;
                                        a.push({
                                            key: this.boxKeys[p],
                                            x1: u[d],
                                            y1: u[d + 1],
                                            x2: u[d + 2],
                                            y2: u[d + 3]
                                        });
                                    }
                                }
                            }
                            var m = this.circleCells[i];
                            if (null !== m) for(var g = this.circles, v = 0, y = m; v < y.length; v += 1){
                                var x = y[v];
                                if (!l.circle[x]) {
                                    l.circle[x] = !0;
                                    var b = 3 * x;
                                    if (this._circleAndRectCollide(g[b], g[b + 1], g[b + 2], t1, e1, r, n) && (!s || s(this.circleKeys[x]))) {
                                        if (o.hitTest) return a.push(!0), !0;
                                        var _ = g[b], w = g[b + 1], T = g[b + 2];
                                        a.push({
                                            key: this.circleKeys[x],
                                            x1: _ - T,
                                            y1: w - T,
                                            x2: _ + T,
                                            y2: w + T
                                        });
                                    }
                                }
                            }
                        }, Kt.prototype._queryCellCircle = function(t1, e1, r, n, i, a, o, s) {
                            var l = o.circle, c = o.seenUids, u = this.boxCells[i];
                            if (null !== u) for(var f = this.bboxes, h = 0, p = u; h < p.length; h += 1){
                                var d = p[h];
                                if (!c.box[d]) {
                                    c.box[d] = !0;
                                    var m = 4 * d;
                                    if (this._circleAndRectCollide(l.x, l.y, l.radius, f[m + 0], f[m + 1], f[m + 2], f[m + 3]) && (!s || s(this.boxKeys[d]))) return a.push(!0), !0;
                                }
                            }
                            var g = this.circleCells[i];
                            if (null !== g) for(var v = this.circles, y = 0, x = g; y < x.length; y += 1){
                                var b = x[y];
                                if (!c.circle[b]) {
                                    c.circle[b] = !0;
                                    var _ = 3 * b;
                                    if (this._circlesCollide(v[_], v[_ + 1], v[_ + 2], l.x, l.y, l.radius) && (!s || s(this.circleKeys[b]))) return a.push(!0), !0;
                                }
                            }
                        }, Kt.prototype._forEachCell = function(t1, e1, r, n, i, a, o, s) {
                            for(var l = this._convertToXCellCoord(t1), c = this._convertToYCellCoord(e1), u = this._convertToXCellCoord(r), f = this._convertToYCellCoord(n), h = l; h <= u; h++)for(var p = c; p <= f; p++){
                                var d = this.xCellCount * p + h;
                                if (i.call(this, t1, e1, r, n, d, a, o, s)) return;
                            }
                        }, Kt.prototype._convertToXCellCoord = function(t1) {
                            return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(t1 * this.xScale)));
                        }, Kt.prototype._convertToYCellCoord = function(t1) {
                            return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(t1 * this.yScale)));
                        }, Kt.prototype._circlesCollide = function(t1, e1, r, n, i, a) {
                            var o = n - t1, s = i - e1, l = r + a;
                            return l * l > o * o + s * s;
                        }, Kt.prototype._circleAndRectCollide = function(t1, e1, r, n, i, a, o) {
                            var s = (a - n) / 2, l = Math.abs(t1 - (n + s));
                            if (l > s + r) return !1;
                            var c = (o - i) / 2, u = Math.abs(e1 - (i + c));
                            if (u > c + r) return !1;
                            if (l <= s || u <= c) return !0;
                            var f = l - s, h = u - c;
                            return f * f + h * h <= r * r;
                        };
                        var ce = new Float32Array([
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0
                        ]);
                        function ue(t1, e1) {
                            for(var r = 0; r < t1; r++){
                                var n = e1.length;
                                e1.resize(n + 4), e1.float32.set(ce, 3 * n);
                            }
                        }
                        function fe(t1, e1, r) {
                            var n = e1[0], i = e1[1];
                            return t1[0] = r[0] * n + r[4] * i + r[12], t1[1] = r[1] * n + r[5] * i + r[13], t1[3] = r[3] * n + r[7] * i + r[15], t1;
                        }
                        var he = function(t1, e1, r) {
                            void 0 === e1 && (e1 = new Kt(t1.width + 200, t1.height + 200, 25)), void 0 === r && (r = new Kt(t1.width + 200, t1.height + 200, 25)), this.transform = t1, this.grid = e1, this.ignoredGrid = r, this.pitchfactor = Math.cos(t1._pitch) * t1.cameraToCenterDistance, this.screenRightBoundary = t1.width + 100, this.screenBottomBoundary = t1.height + 100, this.gridRightBoundary = t1.width + 200, this.gridBottomBoundary = t1.height + 200;
                        };
                        function pe(e1, r, n) {
                            return r * (t1.EXTENT / (e1.tileSize * Math.pow(2, n - e1.tileID.overscaledZ)));
                        }
                        he.prototype.placeCollisionBox = function(t1, e1, r, n, i) {
                            var a = this.projectAndGetPerspectiveRatio(n, t1.anchorPointX, t1.anchorPointY), o = r * a.perspectiveRatio, s = t1.x1 * o + a.point.x, l = t1.y1 * o + a.point.y, c = t1.x2 * o + a.point.x, u = t1.y2 * o + a.point.y;
                            return !this.isInsideGrid(s, l, c, u) || !e1 && this.grid.hitTest(s, l, c, u, i) ? {
                                box: [],
                                offscreen: !1
                            } : {
                                box: [
                                    s,
                                    l,
                                    c,
                                    u
                                ],
                                offscreen: this.isOffscreen(s, l, c, u)
                            };
                        }, he.prototype.placeCollisionCircles = function(e1, r, n, i, a, o, s, l, c, u, f, h, p) {
                            var d = [], m = new t1.Point(r.anchorX, r.anchorY), g = te(m, o), v = ee(this.transform.cameraToCenterDistance, g.signedDistanceFromCamera), y = (u ? a / v : a * v) / t1.ONE_EM, x = te(m, s).point, b = ie(y, i, r.lineOffsetX * y, r.lineOffsetY * y, !1, x, m, r, n, s, {}), _ = !1, w = !1, T = !0;
                            if (b) {
                                for(var k = .5 * h * v + p, A = new t1.Point(-100, -100), M = new t1.Point(this.screenRightBoundary, this.screenBottomBoundary), S = new Jt, E = b.first, L = b.last, C = [], P = E.path.length - 1; P >= 1; P--)C.push(E.path[P]);
                                for(var I = 1; I < L.path.length; I++)C.push(L.path[I]);
                                var O = 2.5 * k;
                                if (l) {
                                    var z = C.map(function(t1) {
                                        return te(t1, l);
                                    });
                                    C = z.some(function(t1) {
                                        return t1.signedDistanceFromCamera <= 0;
                                    }) ? [] : z.map(function(t1) {
                                        return t1.point;
                                    });
                                }
                                var D = [];
                                if (C.length > 0) {
                                    for(var R = C[0].clone(), F = C[0].clone(), B = 1; B < C.length; B++)R.x = Math.min(R.x, C[B].x), R.y = Math.min(R.y, C[B].y), F.x = Math.max(F.x, C[B].x), F.y = Math.max(F.y, C[B].y);
                                    D = R.x >= A.x && F.x <= M.x && R.y >= A.y && F.y <= M.y ? [
                                        C
                                    ] : F.x < A.x || R.x > M.x || F.y < A.y || R.y > M.y ? [] : t1.clipLine([
                                        C
                                    ], A.x, A.y, M.x, M.y);
                                }
                                for(var N = 0, j = D; N < j.length; N += 1){
                                    var U = j[N];
                                    S.reset(U, .25 * k);
                                    var V = 0;
                                    V = S.length <= .5 * k ? 1 : Math.ceil(S.paddedLength / O) + 1;
                                    for(var H = 0; H < V; H++){
                                        var q = H / Math.max(V - 1, 1), G = S.lerp(q), Y = G.x + 100, W = G.y + 100;
                                        d.push(Y, W, k, 0);
                                        var X = Y - k, Z = W - k, J = Y + k, K = W + k;
                                        if (T = T && this.isOffscreen(X, Z, J, K), w = w || this.isInsideGrid(X, Z, J, K), !e1 && this.grid.hitTestCircle(Y, W, k, f) && (_ = !0, !c)) return {
                                            circles: [],
                                            offscreen: !1,
                                            collisionDetected: _
                                        };
                                    }
                                }
                            }
                            return {
                                circles: !c && _ || !w ? [] : d,
                                offscreen: T,
                                collisionDetected: _
                            };
                        }, he.prototype.queryRenderedSymbols = function(e1) {
                            if (0 === e1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                            for(var r = [], n = 1 / 0, i = 1 / 0, a = -1 / 0, o = -1 / 0, s = 0, l = e1; s < l.length; s += 1){
                                var c = l[s], u = new t1.Point(c.x + 100, c.y + 100);
                                n = Math.min(n, u.x), i = Math.min(i, u.y), a = Math.max(a, u.x), o = Math.max(o, u.y), r.push(u);
                            }
                            for(var f = {}, h = {}, p = 0, d = this.grid.query(n, i, a, o).concat(this.ignoredGrid.query(n, i, a, o)); p < d.length; p += 1){
                                var m = d[p], g = m.key;
                                if (void 0 === f[g.bucketInstanceId] && (f[g.bucketInstanceId] = {}), !f[g.bucketInstanceId][g.featureIndex]) {
                                    var v = [
                                        new t1.Point(m.x1, m.y1),
                                        new t1.Point(m.x2, m.y1),
                                        new t1.Point(m.x2, m.y2),
                                        new t1.Point(m.x1, m.y2)
                                    ];
                                    t1.polygonIntersectsPolygon(r, v) && (f[g.bucketInstanceId][g.featureIndex] = !0, void 0 === h[g.bucketInstanceId] && (h[g.bucketInstanceId] = []), h[g.bucketInstanceId].push(g.featureIndex));
                                }
                            }
                            return h;
                        }, he.prototype.insertCollisionBox = function(t1, e1, r, n, i) {
                            var a = {
                                bucketInstanceId: r,
                                featureIndex: n,
                                collisionGroupID: i
                            };
                            (e1 ? this.ignoredGrid : this.grid).insert(a, t1[0], t1[1], t1[2], t1[3]);
                        }, he.prototype.insertCollisionCircles = function(t1, e1, r, n, i) {
                            for(var a = e1 ? this.ignoredGrid : this.grid, o = {
                                bucketInstanceId: r,
                                featureIndex: n,
                                collisionGroupID: i
                            }, s = 0; s < t1.length; s += 4)a.insertCircle(o, t1[s], t1[s + 1], t1[s + 2]);
                        }, he.prototype.projectAndGetPerspectiveRatio = function(e1, r, n) {
                            var i = [
                                r,
                                n,
                                0,
                                1
                            ];
                            return fe(i, i, e1), {
                                point: new t1.Point((i[0] / i[3] + 1) / 2 * this.transform.width + 100, (-i[1] / i[3] + 1) / 2 * this.transform.height + 100),
                                perspectiveRatio: .5 + this.transform.cameraToCenterDistance / i[3] * .5
                            };
                        }, he.prototype.isOffscreen = function(t1, e1, r, n) {
                            return r < 100 || t1 >= this.screenRightBoundary || n < 100 || e1 > this.screenBottomBoundary;
                        }, he.prototype.isInsideGrid = function(t1, e1, r, n) {
                            return r >= 0 && t1 < this.gridRightBoundary && n >= 0 && e1 < this.gridBottomBoundary;
                        }, he.prototype.getViewportMatrix = function() {
                            var e1 = t1.identity([]);
                            return t1.translate(e1, e1, [
                                -100,
                                -100,
                                0
                            ]), e1;
                        };
                        var de = function(t1, e1, r, n) {
                            this.opacity = t1 ? Math.max(0, Math.min(1, t1.opacity + (t1.placed ? e1 : -e1))) : n && r ? 1 : 0, this.placed = r;
                        };
                        de.prototype.isHidden = function() {
                            return 0 === this.opacity && !this.placed;
                        };
                        var me = function(t1, e1, r, n, i) {
                            this.text = new de(t1 ? t1.text : null, e1, r, i), this.icon = new de(t1 ? t1.icon : null, e1, n, i);
                        };
                        me.prototype.isHidden = function() {
                            return this.text.isHidden() && this.icon.isHidden();
                        };
                        var ge = function(t1, e1, r) {
                            this.text = t1, this.icon = e1, this.skipFade = r;
                        }, ve = function() {
                            this.invProjMatrix = t1.create(), this.viewportMatrix = t1.create(), this.circles = [];
                        }, ye = function(t1, e1, r, n, i) {
                            this.bucketInstanceId = t1, this.featureIndex = e1, this.sourceLayerIndex = r, this.bucketIndex = n, this.tileID = i;
                        }, xe = function(t1) {
                            this.crossSourceCollisions = t1, this.maxGroupID = 0, this.collisionGroups = {};
                        };
                        function be(e1, r, n, i, a) {
                            var o = t1.getAnchorAlignment(e1), s = -(o.horizontalAlign - .5) * r, l = -(o.verticalAlign - .5) * n, c = t1.evaluateVariableOffset(e1, i);
                            return new t1.Point(s + c[0] * a, l + c[1] * a);
                        }
                        function _e(e1, r, n, i, a, o) {
                            var s = e1.x1, l = e1.x2, c = e1.y1, u = e1.y2, f = e1.anchorPointX, h = e1.anchorPointY, p = new t1.Point(r, n);
                            return i && p._rotate(a ? o : -o), {
                                x1: s + p.x,
                                y1: c + p.y,
                                x2: l + p.x,
                                y2: u + p.y,
                                anchorPointX: f,
                                anchorPointY: h
                            };
                        }
                        xe.prototype.get = function(t1) {
                            if (this.crossSourceCollisions) return {
                                ID: 0,
                                predicate: null
                            };
                            if (!this.collisionGroups[t1]) {
                                var e1 = ++this.maxGroupID;
                                this.collisionGroups[t1] = {
                                    ID: e1,
                                    predicate: function(t1) {
                                        return t1.collisionGroupID === e1;
                                    }
                                };
                            }
                            return this.collisionGroups[t1];
                        };
                        var we = function(t1, e1, r, n) {
                            this.transform = t1.clone(), this.collisionIndex = new he(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = e1, this.retainedQueryData = {}, this.collisionGroups = new xe(r), this.collisionCircleArrays = {}, this.prevPlacement = n, n && (n.prevPlacement = void 0), this.placedOrientations = {};
                        };
                        function Te(t1, e1, r, n, i) {
                            t1.emplaceBack(e1 ? 1 : 0, r ? 1 : 0, n || 0, i || 0), t1.emplaceBack(e1 ? 1 : 0, r ? 1 : 0, n || 0, i || 0), t1.emplaceBack(e1 ? 1 : 0, r ? 1 : 0, n || 0, i || 0), t1.emplaceBack(e1 ? 1 : 0, r ? 1 : 0, n || 0, i || 0);
                        }
                        we.prototype.getBucketParts = function(e1, r, n, i) {
                            var a = n.getBucket(r), o = n.latestFeatureIndex;
                            if (a && o && r.id === a.layerIds[0]) {
                                var s = n.collisionBoxArray, l = a.layers[0].layout, c = Math.pow(2, this.transform.zoom - n.tileID.overscaledZ), u = n.tileSize / t1.EXTENT, f = this.transform.calculatePosMatrix(n.tileID.toUnwrapped()), h = "map" === l.get("text-pitch-alignment"), p = "map" === l.get("text-rotation-alignment"), d = pe(n, 1, this.transform.zoom), m = Qt(f, h, p, this.transform, d), g = null;
                                if (h) {
                                    var v = $t(f, h, p, this.transform, d);
                                    g = t1.multiply([], this.transform.labelPlaneMatrix, v);
                                }
                                this.retainedQueryData[a.bucketInstanceId] = new ye(a.bucketInstanceId, o, a.sourceLayerIndex, a.index, n.tileID);
                                var y = {
                                    bucket: a,
                                    layout: l,
                                    posMatrix: f,
                                    textLabelPlaneMatrix: m,
                                    labelToScreenMatrix: g,
                                    scale: c,
                                    textPixelRatio: u,
                                    holdingForFade: n.holdingForFade(),
                                    collisionBoxArray: s,
                                    partiallyEvaluatedTextSize: t1.evaluateSizeForZoom(a.textSizeData, this.transform.zoom),
                                    collisionGroup: this.collisionGroups.get(a.sourceID)
                                };
                                if (i) for(var x = 0, b = a.sortKeyRanges; x < b.length; x += 1){
                                    var _ = b[x], w = _.sortKey, T = _.symbolInstanceStart, k = _.symbolInstanceEnd;
                                    e1.push({
                                        sortKey: w,
                                        symbolInstanceStart: T,
                                        symbolInstanceEnd: k,
                                        parameters: y
                                    });
                                }
                                else e1.push({
                                    symbolInstanceStart: 0,
                                    symbolInstanceEnd: a.symbolInstances.length,
                                    parameters: y
                                });
                            }
                        }, we.prototype.attemptAnchorPlacement = function(t1, e1, r, n, i, a, o, s, l, c, u, f, h, p, d) {
                            var m, g = [
                                f.textOffset0,
                                f.textOffset1
                            ], v = be(t1, r, n, g, i), y = this.collisionIndex.placeCollisionBox(_e(e1, v.x, v.y, a, o, this.transform.angle), u, s, l, c.predicate);
                            if (d && 0 === this.collisionIndex.placeCollisionBox(_e(d, v.x, v.y, a, o, this.transform.angle), u, s, l, c.predicate).box.length) return;
                            if (y.box.length > 0) return this.prevPlacement && this.prevPlacement.variableOffsets[f.crossTileID] && this.prevPlacement.placements[f.crossTileID] && this.prevPlacement.placements[f.crossTileID].text && (m = this.prevPlacement.variableOffsets[f.crossTileID].anchor), this.variableOffsets[f.crossTileID] = {
                                textOffset: g,
                                width: r,
                                height: n,
                                anchor: t1,
                                textBoxScale: i,
                                prevAnchor: m
                            }, this.markUsedJustification(h, t1, f, p), h.allowVerticalPlacement && (this.markUsedOrientation(h, p, f), this.placedOrientations[f.crossTileID] = p), {
                                shift: v,
                                placedGlyphBoxes: y
                            };
                        }, we.prototype.placeLayerBucketPart = function(e1, r, n) {
                            var i = this, a = e1.parameters, o = a.bucket, s = a.layout, l = a.posMatrix, c = a.textLabelPlaneMatrix, u = a.labelToScreenMatrix, f = a.textPixelRatio, h = a.holdingForFade, p = a.collisionBoxArray, d = a.partiallyEvaluatedTextSize, m = a.collisionGroup, g = s.get("text-optional"), v = s.get("icon-optional"), y = s.get("text-allow-overlap"), x = s.get("icon-allow-overlap"), b = "map" === s.get("text-rotation-alignment"), _ = "map" === s.get("text-pitch-alignment"), w = "none" !== s.get("icon-text-fit"), T = "viewport-y" === s.get("symbol-z-order"), k = y && (x || !o.hasIconData() || v), A = x && (y || !o.hasTextData() || g);
                            !o.collisionArrays && p && o.deserializeCollisionBoxes(p);
                            var M = function(e1, a) {
                                if (!r[e1.crossTileID]) {
                                    if (h) i.placements[e1.crossTileID] = new ge(!1, !1, !1);
                                    else {
                                        var p, T = !1, M = !1, S = !0, E = null, L = {
                                            box: null,
                                            offscreen: null
                                        }, C = {
                                            box: null,
                                            offscreen: null
                                        }, P = null, I = null, O = 0, z = 0, D = 0;
                                        a.textFeatureIndex ? O = a.textFeatureIndex : e1.useRuntimeCollisionCircles && (O = e1.featureIndex), a.verticalTextFeatureIndex && (z = a.verticalTextFeatureIndex);
                                        var R = a.textBox;
                                        if (R) {
                                            var F = function(r) {
                                                var n = t1.WritingMode.horizontal;
                                                if (o.allowVerticalPlacement && !r && i.prevPlacement) {
                                                    var a = i.prevPlacement.placedOrientations[e1.crossTileID];
                                                    a && (i.placedOrientations[e1.crossTileID] = a, n = a, i.markUsedOrientation(o, n, e1));
                                                }
                                                return n;
                                            }, B = function(r, n) {
                                                if (o.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && a.verticalTextBox) for(var i = 0, s = o.writingModes; i < s.length; i += 1){
                                                    if (s[i] === t1.WritingMode.vertical ? (L = n(), C = L) : L = r(), L && L.box && L.box.length) break;
                                                }
                                                else L = r();
                                            };
                                            if (s.get("text-variable-anchor")) {
                                                var N = s.get("text-variable-anchor");
                                                if (i.prevPlacement && i.prevPlacement.variableOffsets[e1.crossTileID]) {
                                                    var j = i.prevPlacement.variableOffsets[e1.crossTileID];
                                                    N.indexOf(j.anchor) > 0 && (N = N.filter(function(t1) {
                                                        return t1 !== j.anchor;
                                                    })).unshift(j.anchor);
                                                }
                                                var U = function(t1, r, n) {
                                                    for(var a = t1.x2 - t1.x1, s = t1.y2 - t1.y1, c = e1.textBoxScale, u = w && !x ? r : null, h = {
                                                        box: [],
                                                        offscreen: !1
                                                    }, p = y ? 2 * N.length : N.length, d = 0; d < p; ++d){
                                                        var g = N[d % N.length], v = d >= N.length, k = i.attemptAnchorPlacement(g, t1, a, s, c, b, _, f, l, m, v, e1, o, n, u);
                                                        if (k && (h = k.placedGlyphBoxes) && h.box && h.box.length) {
                                                            T = !0, E = k.shift;
                                                            break;
                                                        }
                                                    }
                                                    return h;
                                                };
                                                B(function() {
                                                    return U(R, a.iconBox, t1.WritingMode.horizontal);
                                                }, function() {
                                                    var r = a.verticalTextBox, n = L && L.box && L.box.length;
                                                    return o.allowVerticalPlacement && !n && e1.numVerticalGlyphVertices > 0 && r ? U(r, a.verticalIconBox, t1.WritingMode.vertical) : {
                                                        box: null,
                                                        offscreen: null
                                                    };
                                                }), L && (T = L.box, S = L.offscreen);
                                                var V = F(L && L.box);
                                                if (!T && i.prevPlacement) {
                                                    var H = i.prevPlacement.variableOffsets[e1.crossTileID];
                                                    H && (i.variableOffsets[e1.crossTileID] = H, i.markUsedJustification(o, H.anchor, e1, V));
                                                }
                                            } else {
                                                var q = function(t1, r) {
                                                    var n = i.collisionIndex.placeCollisionBox(t1, y, f, l, m.predicate);
                                                    return n && n.box && n.box.length && (i.markUsedOrientation(o, r, e1), i.placedOrientations[e1.crossTileID] = r), n;
                                                };
                                                B(function() {
                                                    return q(R, t1.WritingMode.horizontal);
                                                }, function() {
                                                    var r = a.verticalTextBox;
                                                    return o.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && r ? q(r, t1.WritingMode.vertical) : {
                                                        box: null,
                                                        offscreen: null
                                                    };
                                                }), F(L && L.box && L.box.length);
                                            }
                                        }
                                        if (T = (p = L) && p.box && p.box.length > 0, S = p && p.offscreen, e1.useRuntimeCollisionCircles) {
                                            var G = o.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), Y = t1.evaluateSizeForFeature(o.textSizeData, d, G), W = s.get("text-padding"), X = e1.collisionCircleDiameter;
                                            P = i.collisionIndex.placeCollisionCircles(y, G, o.lineVertexArray, o.glyphOffsetArray, Y, l, c, u, n, _, m.predicate, X, W), T = y || P.circles.length > 0 && !P.collisionDetected, S = S && P.offscreen;
                                        }
                                        if (a.iconFeatureIndex && (D = a.iconFeatureIndex), a.iconBox) {
                                            var Z = function(t1) {
                                                var e1 = w && E ? _e(t1, E.x, E.y, b, _, i.transform.angle) : t1;
                                                return i.collisionIndex.placeCollisionBox(e1, x, f, l, m.predicate);
                                            };
                                            M = C && C.box && C.box.length && a.verticalIconBox ? (I = Z(a.verticalIconBox)).box.length > 0 : (I = Z(a.iconBox)).box.length > 0, S = S && I.offscreen;
                                        }
                                        var J = g || 0 === e1.numHorizontalGlyphVertices && 0 === e1.numVerticalGlyphVertices, K = v || 0 === e1.numIconVertices;
                                        if (J || K ? K ? J || (M = M && T) : T = M && T : M = T = M && T, T && p && p.box && (C && C.box && z ? i.collisionIndex.insertCollisionBox(p.box, s.get("text-ignore-placement"), o.bucketInstanceId, z, m.ID) : i.collisionIndex.insertCollisionBox(p.box, s.get("text-ignore-placement"), o.bucketInstanceId, O, m.ID)), M && I && i.collisionIndex.insertCollisionBox(I.box, s.get("icon-ignore-placement"), o.bucketInstanceId, D, m.ID), P && (T && i.collisionIndex.insertCollisionCircles(P.circles, s.get("text-ignore-placement"), o.bucketInstanceId, O, m.ID), n)) {
                                            var Q = o.bucketInstanceId, $ = i.collisionCircleArrays[Q];
                                            void 0 === $ && ($ = i.collisionCircleArrays[Q] = new ve);
                                            for(var tt = 0; tt < P.circles.length; tt += 4)$.circles.push(P.circles[tt + 0]), $.circles.push(P.circles[tt + 1]), $.circles.push(P.circles[tt + 2]), $.circles.push(P.collisionDetected ? 1 : 0);
                                        }
                                        i.placements[e1.crossTileID] = new ge(T || k, M || A, S || o.justReloaded), r[e1.crossTileID] = !0;
                                    }
                                }
                            };
                            if (T) for(var S = o.getSortedSymbolIndexes(this.transform.angle), E = S.length - 1; E >= 0; --E){
                                var L = S[E];
                                M(o.symbolInstances.get(L), o.collisionArrays[L]);
                            }
                            else for(var C = e1.symbolInstanceStart; C < e1.symbolInstanceEnd; C++)M(o.symbolInstances.get(C), o.collisionArrays[C]);
                            if (n && o.bucketInstanceId in this.collisionCircleArrays) {
                                var P = this.collisionCircleArrays[o.bucketInstanceId];
                                t1.invert(P.invProjMatrix, l), P.viewportMatrix = this.collisionIndex.getViewportMatrix();
                            }
                            o.justReloaded = !1;
                        }, we.prototype.markUsedJustification = function(e1, r, n, i) {
                            var a, o = {
                                left: n.leftJustifiedTextSymbolIndex,
                                center: n.centerJustifiedTextSymbolIndex,
                                right: n.rightJustifiedTextSymbolIndex
                            };
                            a = i === t1.WritingMode.vertical ? n.verticalPlacedTextSymbolIndex : o[t1.getAnchorJustification(r)];
                            for(var s = 0, l = [
                                n.leftJustifiedTextSymbolIndex,
                                n.centerJustifiedTextSymbolIndex,
                                n.rightJustifiedTextSymbolIndex,
                                n.verticalPlacedTextSymbolIndex
                            ]; s < l.length; s += 1){
                                var c = l[s];
                                c >= 0 && (e1.text.placedSymbolArray.get(c).crossTileID = a >= 0 && c !== a ? 0 : n.crossTileID);
                            }
                        }, we.prototype.markUsedOrientation = function(e1, r, n) {
                            for(var i = r === t1.WritingMode.horizontal || r === t1.WritingMode.horizontalOnly ? r : 0, a = r === t1.WritingMode.vertical ? r : 0, o = 0, s = [
                                n.leftJustifiedTextSymbolIndex,
                                n.centerJustifiedTextSymbolIndex,
                                n.rightJustifiedTextSymbolIndex
                            ]; o < s.length; o += 1){
                                var l = s[o];
                                e1.text.placedSymbolArray.get(l).placedOrientation = i;
                            }
                            n.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(n.verticalPlacedTextSymbolIndex).placedOrientation = a);
                        }, we.prototype.commit = function(t1) {
                            this.commitTime = t1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                            var e1 = this.prevPlacement, r = !1;
                            this.prevZoomAdjustment = e1 ? e1.zoomAdjustment(this.transform.zoom) : 0;
                            var n = e1 ? e1.symbolFadeChange(t1) : 1, i = e1 ? e1.opacities : {}, a = e1 ? e1.variableOffsets : {}, o = e1 ? e1.placedOrientations : {};
                            for(var s in this.placements){
                                var l = this.placements[s], c = i[s];
                                c ? (this.opacities[s] = new me(c, n, l.text, l.icon), r = r || l.text !== c.text.placed || l.icon !== c.icon.placed) : (this.opacities[s] = new me(null, n, l.text, l.icon, l.skipFade), r = r || l.text || l.icon);
                            }
                            for(var u in i){
                                var f = i[u];
                                if (!this.opacities[u]) {
                                    var h = new me(f, n, !1, !1);
                                    h.isHidden() || (this.opacities[u] = h, r = r || f.text.placed || f.icon.placed);
                                }
                            }
                            for(var p in a)this.variableOffsets[p] || !this.opacities[p] || this.opacities[p].isHidden() || (this.variableOffsets[p] = a[p]);
                            for(var d in o)this.placedOrientations[d] || !this.opacities[d] || this.opacities[d].isHidden() || (this.placedOrientations[d] = o[d]);
                            r ? this.lastPlacementChangeTime = t1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = e1 ? e1.lastPlacementChangeTime : t1);
                        }, we.prototype.updateLayerOpacities = function(t1, e1) {
                            for(var r = {}, n = 0, i = e1; n < i.length; n += 1){
                                var a = i[n], o = a.getBucket(t1);
                                o && a.latestFeatureIndex && t1.id === o.layerIds[0] && this.updateBucketOpacities(o, r, a.collisionBoxArray);
                            }
                        }, we.prototype.updateBucketOpacities = function(e1, r, n) {
                            var i = this;
                            e1.hasTextData() && e1.text.opacityVertexArray.clear(), e1.hasIconData() && e1.icon.opacityVertexArray.clear(), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
                            var a = e1.layers[0].layout, o = new me(null, 0, !1, !1, !0), s = a.get("text-allow-overlap"), l = a.get("icon-allow-overlap"), c = a.get("text-variable-anchor"), u = "map" === a.get("text-rotation-alignment"), f = "map" === a.get("text-pitch-alignment"), h = "none" !== a.get("icon-text-fit"), p = new me(null, 0, s && (l || !e1.hasIconData() || a.get("icon-optional")), l && (s || !e1.hasTextData() || a.get("text-optional")), !0);
                            !e1.collisionArrays && n && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(n);
                            for(var d = function(t1, e1, r) {
                                for(var n = 0; n < e1 / 4; n++)t1.opacityVertexArray.emplaceBack(r);
                            }, m = function(n) {
                                var a = e1.symbolInstances.get(n), s = a.numHorizontalGlyphVertices, l = a.numVerticalGlyphVertices, m = a.crossTileID, g = r[m], v = i.opacities[m];
                                g ? v = o : v || (v = p, i.opacities[m] = v), r[m] = !0;
                                var y = s > 0 || l > 0, x = a.numIconVertices > 0, b = i.placedOrientations[a.crossTileID], _ = b === t1.WritingMode.vertical, w = b === t1.WritingMode.horizontal || b === t1.WritingMode.horizontalOnly;
                                if (y) {
                                    var T = Pe(v.text), k = _ ? Ie : T;
                                    d(e1.text, s, k);
                                    var A = w ? Ie : T;
                                    d(e1.text, l, A);
                                    var M = v.text.isHidden();
                                    [
                                        a.rightJustifiedTextSymbolIndex,
                                        a.centerJustifiedTextSymbolIndex,
                                        a.leftJustifiedTextSymbolIndex
                                    ].forEach(function(t1) {
                                        t1 >= 0 && (e1.text.placedSymbolArray.get(t1).hidden = M || _ ? 1 : 0);
                                    }), a.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).hidden = M || w ? 1 : 0);
                                    var S = i.variableOffsets[a.crossTileID];
                                    S && i.markUsedJustification(e1, S.anchor, a, b);
                                    var E = i.placedOrientations[a.crossTileID];
                                    E && (i.markUsedJustification(e1, "left", a, E), i.markUsedOrientation(e1, E, a));
                                }
                                if (x) {
                                    var L = Pe(v.icon), C = !(h && a.verticalPlacedIconSymbolIndex && _);
                                    if (a.placedIconSymbolIndex >= 0) {
                                        var P = C ? L : Ie;
                                        d(e1.icon, a.numIconVertices, P), e1.icon.placedSymbolArray.get(a.placedIconSymbolIndex).hidden = v.icon.isHidden();
                                    }
                                    if (a.verticalPlacedIconSymbolIndex >= 0) {
                                        var I = C ? Ie : L;
                                        d(e1.icon, a.numVerticalIconVertices, I), e1.icon.placedSymbolArray.get(a.verticalPlacedIconSymbolIndex).hidden = v.icon.isHidden();
                                    }
                                }
                                if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                                    var O = e1.collisionArrays[n];
                                    if (O) {
                                        var z = new t1.Point(0, 0);
                                        if (O.textBox || O.verticalTextBox) {
                                            var D = !0;
                                            if (c) {
                                                var R = i.variableOffsets[m];
                                                R ? (z = be(R.anchor, R.width, R.height, R.textOffset, R.textBoxScale), u && z._rotate(f ? i.transform.angle : -i.transform.angle)) : D = !1;
                                            }
                                            O.textBox && Te(e1.textCollisionBox.collisionVertexArray, v.text.placed, !D || _, z.x, z.y), O.verticalTextBox && Te(e1.textCollisionBox.collisionVertexArray, v.text.placed, !D || w, z.x, z.y);
                                        }
                                        var F = Boolean(!w && O.verticalIconBox);
                                        O.iconBox && Te(e1.iconCollisionBox.collisionVertexArray, v.icon.placed, F, h ? z.x : 0, h ? z.y : 0), O.verticalIconBox && Te(e1.iconCollisionBox.collisionVertexArray, v.icon.placed, !F, h ? z.x : 0, h ? z.y : 0);
                                    }
                                }
                            }, g = 0; g < e1.symbolInstances.length; g++)m(g);
                            if (e1.sortFeatures(this.transform.angle), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.bucketInstanceId in this.collisionCircleArrays) {
                                var v = this.collisionCircleArrays[e1.bucketInstanceId];
                                e1.placementInvProjMatrix = v.invProjMatrix, e1.placementViewportMatrix = v.viewportMatrix, e1.collisionCircleArray = v.circles, delete this.collisionCircleArrays[e1.bucketInstanceId];
                            }
                        }, we.prototype.symbolFadeChange = function(t1) {
                            return 0 === this.fadeDuration ? 1 : (t1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
                        }, we.prototype.zoomAdjustment = function(t1) {
                            return Math.max(0, (this.transform.zoom - t1) / 1.5);
                        }, we.prototype.hasTransitions = function(t1) {
                            return this.stale || t1 - this.lastPlacementChangeTime < this.fadeDuration;
                        }, we.prototype.stillRecent = function(t1, e1) {
                            var r = this.zoomAtLastRecencyCheck === e1 ? 1 - this.zoomAdjustment(e1) : 1;
                            return this.zoomAtLastRecencyCheck = e1, this.commitTime + this.fadeDuration * r > t1;
                        }, we.prototype.setStale = function() {
                            this.stale = !0;
                        };
                        var ke = Math.pow(2, 25), Ae = Math.pow(2, 24), Me = Math.pow(2, 17), Se = Math.pow(2, 16), Ee = Math.pow(2, 9), Le = Math.pow(2, 8), Ce = Math.pow(2, 1);
                        function Pe(t1) {
                            if (0 === t1.opacity && !t1.placed) return 0;
                            if (1 === t1.opacity && t1.placed) return 4294967295;
                            var e1 = t1.placed ? 1 : 0, r = Math.floor(127 * t1.opacity);
                            return r * ke + e1 * Ae + r * Me + e1 * Se + r * Ee + e1 * Le + r * Ce + e1;
                        }
                        var Ie = 0, Oe = function(t1) {
                            this._sortAcrossTiles = "viewport-y" !== t1.layout.get("symbol-z-order") && void 0 !== t1.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
                        };
                        Oe.prototype.continuePlacement = function(t1, e1, r, n, i) {
                            for(var a = this._bucketParts; this._currentTileIndex < t1.length;){
                                var o = t1[this._currentTileIndex];
                                if (e1.getBucketParts(a, n, o, this._sortAcrossTiles), this._currentTileIndex++, i()) return !0;
                            }
                            for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, a.sort(function(t1, e1) {
                                return t1.sortKey - e1.sortKey;
                            })); this._currentPartIndex < a.length;){
                                var s = a[this._currentPartIndex];
                                if (e1.placeLayerBucketPart(s, this._seenCrossTileIDs, r), this._currentPartIndex++, i()) return !0;
                            }
                            return !1;
                        };
                        var ze = function(t1, e1, r, n, i, a, o) {
                            this.placement = new we(t1, i, a, o), this._currentPlacementIndex = e1.length - 1, this._forceFullPlacement = r, this._showCollisionBoxes = n, this._done = !1;
                        };
                        ze.prototype.isDone = function() {
                            return this._done;
                        }, ze.prototype.continuePlacement = function(e1, r, n) {
                            for(var i = this, a = t1.browser.now(), o = function() {
                                var e1 = t1.browser.now() - a;
                                return !i._forceFullPlacement && e1 > 2;
                            }; this._currentPlacementIndex >= 0;){
                                var s = r[e1[this._currentPlacementIndex]], l = this.placement.collisionIndex.transform.zoom;
                                if ("symbol" === s.type && (!s.minzoom || s.minzoom <= l) && (!s.maxzoom || s.maxzoom > l)) {
                                    if (this._inProgressLayer || (this._inProgressLayer = new Oe(s)), this._inProgressLayer.continuePlacement(n[s.source], this.placement, this._showCollisionBoxes, s, o)) return;
                                    delete this._inProgressLayer;
                                }
                                this._currentPlacementIndex--;
                            }
                            this._done = !0;
                        }, ze.prototype.commit = function(t1) {
                            return this.placement.commit(t1), this.placement;
                        };
                        var De = 512 / t1.EXTENT / 2, Re = function(t1, e1, r) {
                            this.tileID = t1, this.indexedSymbolInstances = {}, this.bucketInstanceId = r;
                            for(var n = 0; n < e1.length; n++){
                                var i = e1.get(n), a = i.key;
                                this.indexedSymbolInstances[a] || (this.indexedSymbolInstances[a] = []), this.indexedSymbolInstances[a].push({
                                    crossTileID: i.crossTileID,
                                    coord: this.getScaledCoordinates(i, t1)
                                });
                            }
                        };
                        Re.prototype.getScaledCoordinates = function(e1, r) {
                            var n = r.canonical.z - this.tileID.canonical.z, i = De / Math.pow(2, n);
                            return {
                                x: Math.floor((r.canonical.x * t1.EXTENT + e1.anchorX) * i),
                                y: Math.floor((r.canonical.y * t1.EXTENT + e1.anchorY) * i)
                            };
                        }, Re.prototype.findMatches = function(t1, e1, r) {
                            for(var n = this.tileID.canonical.z < e1.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - e1.canonical.z), i = 0; i < t1.length; i++){
                                var a = t1.get(i);
                                if (!a.crossTileID) {
                                    var o = this.indexedSymbolInstances[a.key];
                                    if (o) for(var s = this.getScaledCoordinates(a, e1), l = 0, c = o; l < c.length; l += 1){
                                        var u = c[l];
                                        if (Math.abs(u.coord.x - s.x) <= n && Math.abs(u.coord.y - s.y) <= n && !r[u.crossTileID]) {
                                            r[u.crossTileID] = !0, a.crossTileID = u.crossTileID;
                                            break;
                                        }
                                    }
                                }
                            }
                        };
                        var Fe = function() {
                            this.maxCrossTileID = 0;
                        };
                        Fe.prototype.generate = function() {
                            return ++this.maxCrossTileID;
                        };
                        var Be = function() {
                            this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
                        };
                        Be.prototype.handleWrapJump = function(t1) {
                            var e1 = Math.round((t1 - this.lng) / 360);
                            if (0 !== e1) for(var r in this.indexes){
                                var n = this.indexes[r], i = {};
                                for(var a in n){
                                    var o = n[a];
                                    o.tileID = o.tileID.unwrapTo(o.tileID.wrap + e1), i[o.tileID.key] = o;
                                }
                                this.indexes[r] = i;
                            }
                            this.lng = t1;
                        }, Be.prototype.addBucket = function(t1, e1, r) {
                            if (this.indexes[t1.overscaledZ] && this.indexes[t1.overscaledZ][t1.key]) {
                                if (this.indexes[t1.overscaledZ][t1.key].bucketInstanceId === e1.bucketInstanceId) return !1;
                                this.removeBucketCrossTileIDs(t1.overscaledZ, this.indexes[t1.overscaledZ][t1.key]);
                            }
                            for(var n = 0; n < e1.symbolInstances.length; n++)e1.symbolInstances.get(n).crossTileID = 0;
                            this.usedCrossTileIDs[t1.overscaledZ] || (this.usedCrossTileIDs[t1.overscaledZ] = {});
                            var i = this.usedCrossTileIDs[t1.overscaledZ];
                            for(var a in this.indexes){
                                var o = this.indexes[a];
                                if (Number(a) > t1.overscaledZ) for(var s in o){
                                    var l = o[s];
                                    l.tileID.isChildOf(t1) && l.findMatches(e1.symbolInstances, t1, i);
                                }
                                else {
                                    var c = o[t1.scaledTo(Number(a)).key];
                                    c && c.findMatches(e1.symbolInstances, t1, i);
                                }
                            }
                            for(var u = 0; u < e1.symbolInstances.length; u++){
                                var f = e1.symbolInstances.get(u);
                                f.crossTileID || (f.crossTileID = r.generate(), i[f.crossTileID] = !0);
                            }
                            return void 0 === this.indexes[t1.overscaledZ] && (this.indexes[t1.overscaledZ] = {}), this.indexes[t1.overscaledZ][t1.key] = new Re(t1, e1.symbolInstances, e1.bucketInstanceId), !0;
                        }, Be.prototype.removeBucketCrossTileIDs = function(t1, e1) {
                            for(var r in e1.indexedSymbolInstances)for(var n = 0, i = e1.indexedSymbolInstances[r]; n < i.length; n += 1){
                                var a = i[n];
                                delete this.usedCrossTileIDs[t1][a.crossTileID];
                            }
                        }, Be.prototype.removeStaleBuckets = function(t1) {
                            var e1 = !1;
                            for(var r in this.indexes){
                                var n = this.indexes[r];
                                for(var i in n)t1[n[i].bucketInstanceId] || (this.removeBucketCrossTileIDs(r, n[i]), delete n[i], e1 = !0);
                            }
                            return e1;
                        };
                        var Ne = function() {
                            this.layerIndexes = {}, this.crossTileIDs = new Fe, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
                        };
                        Ne.prototype.addLayer = function(t1, e1, r) {
                            var n = this.layerIndexes[t1.id];
                            void 0 === n && (n = this.layerIndexes[t1.id] = new Be);
                            var i = !1, a = {};
                            n.handleWrapJump(r);
                            for(var o = 0, s = e1; o < s.length; o += 1){
                                var l = s[o], c = l.getBucket(t1);
                                c && t1.id === c.layerIds[0] && (c.bucketInstanceId || (c.bucketInstanceId = ++this.maxBucketInstanceId), n.addBucket(l.tileID, c, this.crossTileIDs) && (i = !0), a[c.bucketInstanceId] = !0);
                            }
                            return n.removeStaleBuckets(a) && (i = !0), i;
                        }, Ne.prototype.pruneUnusedLayers = function(t1) {
                            var e1 = {};
                            for(var r in t1.forEach(function(t1) {
                                e1[t1] = !0;
                            }), this.layerIndexes)e1[r] || delete this.layerIndexes[r];
                        };
                        var je = function(e1, r) {
                            return t1.emitValidationErrors(e1, r && r.filter(function(t1) {
                                return "source.canvas" !== t1.identifier;
                            }));
                        }, Ue = t1.pick(Ut, [
                            "addLayer",
                            "removeLayer",
                            "setPaintProperty",
                            "setLayoutProperty",
                            "setFilter",
                            "addSource",
                            "removeSource",
                            "setLayerZoomRange",
                            "setLight",
                            "setTransition",
                            "setGeoJSONSourceData"
                        ]), Ve = t1.pick(Ut, [
                            "setCenter",
                            "setZoom",
                            "setBearing",
                            "setPitch"
                        ]), He = function() {
                            var e1 = {}, r = t1.styleSpec.$version;
                            for(var n in t1.styleSpec.$root){
                                var i = t1.styleSpec.$root[n];
                                if (i.required) {
                                    var a = null;
                                    null != (a = "version" === n ? r : "array" === i.type ? [] : {}) && (e1[n] = a);
                                }
                            }
                            return e1;
                        }(), qe = function(e1) {
                            function r(n, i) {
                                var a = this;
                                void 0 === i && (i = {}), e1.call(this), this.map = n, this.dispatcher = new k(Bt(), this), this.imageManager = new h, this.imageManager.setEventedParent(this), this.glyphManager = new x(n._requestManager, i.localIdeographFontFamily), this.lineAtlas = new T(256, 512), this.crossTileSymbolIndex = new Ne, this._layers = {}, this._serializedLayers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new t1.ZoomHistory, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("setReferrer", t1.getReferrer());
                                var o = this;
                                this._rtlTextPluginCallback = r.registerForPluginStateChange(function(e1) {
                                    var r = {
                                        pluginStatus: e1.pluginStatus,
                                        pluginURL: e1.pluginURL
                                    };
                                    o.dispatcher.broadcast("syncRTLPluginState", r, function(e1, r) {
                                        if ((t1.triggerPluginCompletionEvent(e1), r) && r.every(function(t1) {
                                            return t1;
                                        })) for(var n in o.sourceCaches)o.sourceCaches[n].reload();
                                    });
                                }), this.on("data", function(t1) {
                                    if ("source" === t1.dataType && "metadata" === t1.sourceDataType) {
                                        var e1 = a.sourceCaches[t1.sourceId];
                                        if (e1) {
                                            var r = e1.getSource();
                                            if (r && r.vectorLayerIds) for(var n in a._layers){
                                                var i = a._layers[n];
                                                i.source === r.id && a._validateLayer(i);
                                            }
                                        }
                                    }
                                });
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.loadURL = function(e1, r) {
                                var n = this;
                                void 0 === r && (r = {}), this.fire(new t1.Event("dataloading", {
                                    dataType: "style"
                                }));
                                var i = "boolean" == typeof r.validate ? r.validate : !t1.isMapboxURL(e1);
                                e1 = this.map._requestManager.normalizeStyleURL(e1, r.accessToken);
                                var a = this.map._requestManager.transformRequest(e1, t1.ResourceType.Style);
                                this._request = t1.getJSON(a, function(e1, r) {
                                    n._request = null, e1 ? n.fire(new t1.ErrorEvent(e1)) : r && n._load(r, i);
                                });
                            }, r.prototype.loadJSON = function(e1, r) {
                                var n = this;
                                void 0 === r && (r = {}), this.fire(new t1.Event("dataloading", {
                                    dataType: "style"
                                })), this._request = t1.browser.frame(function() {
                                    n._request = null, n._load(e1, !1 !== r.validate);
                                });
                            }, r.prototype.loadEmpty = function() {
                                this.fire(new t1.Event("dataloading", {
                                    dataType: "style"
                                })), this._load(He, !1);
                            }, r.prototype._load = function(e1, r) {
                                if (!r || !je(this, t1.validateStyle(e1))) {
                                    for(var n in this._loaded = !0, this.stylesheet = e1, e1.sources)this.addSource(n, e1.sources[n], {
                                        validate: !1
                                    });
                                    e1.sprite ? this._loadSprite(e1.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(e1.glyphs);
                                    var i = jt(this.stylesheet.layers);
                                    this._order = i.map(function(t1) {
                                        return t1.id;
                                    }), this._layers = {}, this._serializedLayers = {};
                                    for(var a = 0, o = i; a < o.length; a += 1){
                                        var s = o[a];
                                        (s = t1.createStyleLayer(s)).setEventedParent(this, {
                                            layer: {
                                                id: s.id
                                            }
                                        }), this._layers[s.id] = s, this._serializedLayers[s.id] = s.serialize();
                                    }
                                    this.dispatcher.broadcast("setLayers", this._serializeLayers(this._order)), this.light = new w(this.stylesheet.light), this.fire(new t1.Event("data", {
                                        dataType: "style"
                                    })), this.fire(new t1.Event("style.load"));
                                }
                            }, r.prototype._loadSprite = function(e1) {
                                var r = this;
                                this._spriteRequest = function(e1, r, n) {
                                    var i, a, o, s = t1.browser.devicePixelRatio > 1 ? "@2x" : "", l = t1.getJSON(r.transformRequest(r.normalizeSpriteURL(e1, s, ".json"), t1.ResourceType.SpriteJSON), function(t1, e1) {
                                        l = null, o || (o = t1, i = e1, u());
                                    }), c = t1.getImage(r.transformRequest(r.normalizeSpriteURL(e1, s, ".png"), t1.ResourceType.SpriteImage), function(t1, e1) {
                                        c = null, o || (o = t1, a = e1, u());
                                    });
                                    function u() {
                                        if (o) n(o);
                                        else if (i && a) {
                                            var e1 = t1.browser.getImageData(a), r = {};
                                            for(var s in i){
                                                var l = i[s], c = l.width, u = l.height, f = l.x, h = l.y, p = l.sdf, d = l.pixelRatio, m = l.stretchX, g = l.stretchY, v = l.content, y = new t1.RGBAImage({
                                                    width: c,
                                                    height: u
                                                });
                                                t1.RGBAImage.copy(e1, y, {
                                                    x: f,
                                                    y: h
                                                }, {
                                                    x: 0,
                                                    y: 0
                                                }, {
                                                    width: c,
                                                    height: u
                                                }), r[s] = {
                                                    data: y,
                                                    pixelRatio: d,
                                                    sdf: p,
                                                    stretchX: m,
                                                    stretchY: g,
                                                    content: v
                                                };
                                            }
                                            n(null, r);
                                        }
                                    }
                                    return {
                                        cancel: function() {
                                            l && (l.cancel(), l = null), c && (c.cancel(), c = null);
                                        }
                                    };
                                }(e1, this.map._requestManager, function(e1, n) {
                                    if (r._spriteRequest = null, e1) r.fire(new t1.ErrorEvent(e1));
                                    else if (n) for(var i in n)r.imageManager.addImage(i, n[i]);
                                    r.imageManager.setLoaded(!0), r._availableImages = r.imageManager.listImages(), r.dispatcher.broadcast("setImages", r._availableImages), r.fire(new t1.Event("data", {
                                        dataType: "style"
                                    }));
                                });
                            }, r.prototype._validateLayer = function(e1) {
                                var r = this.sourceCaches[e1.source];
                                if (r) {
                                    var n = e1.sourceLayer;
                                    if (n) {
                                        var i = r.getSource();
                                        ("geojson" === i.type || i.vectorLayerIds && -1 === i.vectorLayerIds.indexOf(n)) && this.fire(new t1.ErrorEvent(new Error('Source layer "' + n + '" does not exist on source "' + i.id + '" as specified by style layer "' + e1.id + '"')));
                                    }
                                }
                            }, r.prototype.loaded = function() {
                                if (!this._loaded) return !1;
                                if (Object.keys(this._updatedSources).length) return !1;
                                for(var t1 in this.sourceCaches)if (!this.sourceCaches[t1].loaded()) return !1;
                                return !!this.imageManager.isLoaded();
                            }, r.prototype._serializeLayers = function(t1) {
                                for(var e1 = [], r = 0, n = t1; r < n.length; r += 1){
                                    var i = n[r], a = this._layers[i];
                                    "custom" !== a.type && e1.push(a.serialize());
                                }
                                return e1;
                            }, r.prototype.hasTransitions = function() {
                                if (this.light && this.light.hasTransition()) return !0;
                                for(var t1 in this.sourceCaches)if (this.sourceCaches[t1].hasTransition()) return !0;
                                for(var e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
                                return !1;
                            }, r.prototype._checkLoaded = function() {
                                if (!this._loaded) throw new Error("Style is not done loading");
                            }, r.prototype.update = function(e1) {
                                if (this._loaded) {
                                    var r = this._changed;
                                    if (this._changed) {
                                        var n = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
                                        for(var a in (n.length || i.length) && this._updateWorkerLayers(n, i), this._updatedSources){
                                            var o = this._updatedSources[a];
                                            "reload" === o ? this._reloadSource(a) : "clear" === o && this._clearSource(a);
                                        }
                                        for(var s in this._updateTilesForChangedImages(), this._updatedPaintProps)this._layers[s].updateTransitions(e1);
                                        this.light.updateTransitions(e1), this._resetUpdates();
                                    }
                                    for(var l in this.sourceCaches)this.sourceCaches[l].used = !1;
                                    for(var c = 0, u = this._order; c < u.length; c += 1){
                                        var f = u[c], h = this._layers[f];
                                        h.recalculate(e1, this._availableImages), !h.isHidden(e1.zoom) && h.source && (this.sourceCaches[h.source].used = !0);
                                    }
                                    this.light.recalculate(e1), this.z = e1.zoom, r && this.fire(new t1.Event("data", {
                                        dataType: "style"
                                    }));
                                }
                            }, r.prototype._updateTilesForChangedImages = function() {
                                var t1 = Object.keys(this._changedImages);
                                if (t1.length) {
                                    for(var e1 in this.sourceCaches)this.sourceCaches[e1].reloadTilesForDependencies([
                                        "icons",
                                        "patterns"
                                    ], t1);
                                    this._changedImages = {};
                                }
                            }, r.prototype._updateWorkerLayers = function(t1, e1) {
                                this.dispatcher.broadcast("updateLayers", {
                                    layers: this._serializeLayers(t1),
                                    removedIds: e1
                                });
                            }, r.prototype._resetUpdates = function() {
                                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {};
                            }, r.prototype.setState = function(e1) {
                                var r = this;
                                if (this._checkLoaded(), je(this, t1.validateStyle(e1))) return !1;
                                (e1 = t1.clone$1(e1)).layers = jt(e1.layers);
                                var n = Zt(this.serialize(), e1).filter(function(t1) {
                                    return !(t1.command in Ve);
                                });
                                if (0 === n.length) return !1;
                                var i = n.filter(function(t1) {
                                    return !(t1.command in Ue);
                                });
                                if (i.length > 0) throw new Error("Unimplemented: " + i.map(function(t1) {
                                    return t1.command;
                                }).join(", ") + ".");
                                return n.forEach(function(t1) {
                                    "setTransition" !== t1.command && r[t1.command].apply(r, t1.args);
                                }), this.stylesheet = e1, !0;
                            }, r.prototype.addImage = function(e1, r) {
                                if (this.getImage(e1)) return this.fire(new t1.ErrorEvent(new Error("An image with this name already exists.")));
                                this.imageManager.addImage(e1, r), this._availableImages = this.imageManager.listImages(), this._changedImages[e1] = !0, this._changed = !0, this.fire(new t1.Event("data", {
                                    dataType: "style"
                                }));
                            }, r.prototype.updateImage = function(t1, e1) {
                                this.imageManager.updateImage(t1, e1);
                            }, r.prototype.getImage = function(t1) {
                                return this.imageManager.getImage(t1);
                            }, r.prototype.removeImage = function(e1) {
                                if (!this.getImage(e1)) return this.fire(new t1.ErrorEvent(new Error("No image with this name exists.")));
                                this.imageManager.removeImage(e1), this._availableImages = this.imageManager.listImages(), this._changedImages[e1] = !0, this._changed = !0, this.fire(new t1.Event("data", {
                                    dataType: "style"
                                }));
                            }, r.prototype.listImages = function() {
                                return this._checkLoaded(), this.imageManager.listImages();
                            }, r.prototype.addSource = function(e1, r, n) {
                                var i = this;
                                if (void 0 === n && (n = {}), this._checkLoaded(), void 0 !== this.sourceCaches[e1]) throw new Error("There is already a source with this ID");
                                if (!r.type) throw new Error("The type property must be defined, but the only the following properties were given: " + Object.keys(r).join(", ") + ".");
                                if (!([
                                    "vector",
                                    "raster",
                                    "geojson",
                                    "video",
                                    "image"
                                ].indexOf(r.type) >= 0) || !this._validate(t1.validateStyle.source, "sources." + e1, r, null, n)) {
                                    this.map && this.map._collectResourceTiming && (r.collectResourceTiming = !0);
                                    var a = this.sourceCaches[e1] = new Ct(e1, r, this.dispatcher);
                                    a.style = this, a.setEventedParent(this, function() {
                                        return {
                                            isSourceLoaded: i.loaded(),
                                            source: a.serialize(),
                                            sourceId: e1
                                        };
                                    }), a.onAdd(this.map), this._changed = !0;
                                }
                            }, r.prototype.removeSource = function(e1) {
                                if (this._checkLoaded(), void 0 === this.sourceCaches[e1]) throw new Error("There is no source with this ID");
                                for(var r in this._layers)if (this._layers[r].source === e1) return this.fire(new t1.ErrorEvent(new Error('Source "' + e1 + '" cannot be removed while layer "' + r + '" is using it.')));
                                var n = this.sourceCaches[e1];
                                delete this.sourceCaches[e1], delete this._updatedSources[e1], n.fire(new t1.Event("data", {
                                    sourceDataType: "metadata",
                                    dataType: "source",
                                    sourceId: e1
                                })), n.setEventedParent(null), n.clearTiles(), n.onRemove && n.onRemove(this.map), this._changed = !0;
                            }, r.prototype.setGeoJSONSourceData = function(t1, e1) {
                                this._checkLoaded(), this.sourceCaches[t1].getSource().setData(e1), this._changed = !0;
                            }, r.prototype.getSource = function(t1) {
                                return this.sourceCaches[t1] && this.sourceCaches[t1].getSource();
                            }, r.prototype.addLayer = function(e1, r, n) {
                                void 0 === n && (n = {}), this._checkLoaded();
                                var i = e1.id;
                                if (this.getLayer(i)) this.fire(new t1.ErrorEvent(new Error('Layer with id "' + i + '" already exists on this map')));
                                else {
                                    var a;
                                    if ("custom" === e1.type) {
                                        if (je(this, t1.validateCustomStyleLayer(e1))) return;
                                        a = t1.createStyleLayer(e1);
                                    } else {
                                        if ("object" == typeof e1.source && (this.addSource(i, e1.source), e1 = t1.clone$1(e1), e1 = t1.extend(e1, {
                                            source: i
                                        })), this._validate(t1.validateStyle.layer, "layers." + i, e1, {
                                            arrayIndex: -1
                                        }, n)) return;
                                        a = t1.createStyleLayer(e1), this._validateLayer(a), a.setEventedParent(this, {
                                            layer: {
                                                id: i
                                            }
                                        }), this._serializedLayers[a.id] = a.serialize();
                                    }
                                    var o = r ? this._order.indexOf(r) : this._order.length;
                                    if (r && -1 === o) this.fire(new t1.ErrorEvent(new Error('Layer with id "' + r + '" does not exist on this map.')));
                                    else {
                                        if (this._order.splice(o, 0, i), this._layerOrderChanged = !0, this._layers[i] = a, this._removedLayers[i] && a.source && "custom" !== a.type) {
                                            var s = this._removedLayers[i];
                                            delete this._removedLayers[i], s.type !== a.type ? this._updatedSources[a.source] = "clear" : (this._updatedSources[a.source] = "reload", this.sourceCaches[a.source].pause());
                                        }
                                        this._updateLayer(a), a.onAdd && a.onAdd(this.map);
                                    }
                                }
                            }, r.prototype.moveLayer = function(e1, r) {
                                if (this._checkLoaded(), this._changed = !0, this._layers[e1]) {
                                    if (e1 !== r) {
                                        var n = this._order.indexOf(e1);
                                        this._order.splice(n, 1);
                                        var i = r ? this._order.indexOf(r) : this._order.length;
                                        r && -1 === i ? this.fire(new t1.ErrorEvent(new Error('Layer with id "' + r + '" does not exist on this map.'))) : (this._order.splice(i, 0, e1), this._layerOrderChanged = !0);
                                    }
                                } else this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be moved.")));
                            }, r.prototype.removeLayer = function(e1) {
                                this._checkLoaded();
                                var r = this._layers[e1];
                                if (r) {
                                    r.setEventedParent(null);
                                    var n = this._order.indexOf(e1);
                                    this._order.splice(n, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = r, delete this._layers[e1], delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], r.onRemove && r.onRemove(this.map);
                                } else this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be removed.")));
                            }, r.prototype.getLayer = function(t1) {
                                return this._layers[t1];
                            }, r.prototype.hasLayer = function(t1) {
                                return t1 in this._layers;
                            }, r.prototype.setLayerZoomRange = function(e1, r, n) {
                                this._checkLoaded();
                                var i = this.getLayer(e1);
                                i ? i.minzoom === r && i.maxzoom === n || (null != r && (i.minzoom = r), null != n && (i.maxzoom = n), this._updateLayer(i)) : this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot have zoom extent.")));
                            }, r.prototype.setFilter = function(e1, r, n) {
                                void 0 === n && (n = {}), this._checkLoaded();
                                var i = this.getLayer(e1);
                                if (i) {
                                    if (!t1.deepEqual(i.filter, r)) return null == r ? (i.filter = void 0, void this._updateLayer(i)) : void (this._validate(t1.validateStyle.filter, "layers." + i.id + ".filter", r, null, n) || (i.filter = t1.clone$1(r), this._updateLayer(i)));
                                } else this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be filtered.")));
                            }, r.prototype.getFilter = function(e1) {
                                return t1.clone$1(this.getLayer(e1).filter);
                            }, r.prototype.setLayoutProperty = function(e1, r, n, i) {
                                void 0 === i && (i = {}), this._checkLoaded();
                                var a = this.getLayer(e1);
                                a ? t1.deepEqual(a.getLayoutProperty(r), n) || (a.setLayoutProperty(r, n, i), this._updateLayer(a)) : this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be styled.")));
                            }, r.prototype.getLayoutProperty = function(e1, r) {
                                var n = this.getLayer(e1);
                                if (n) return n.getLayoutProperty(r);
                                this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style.")));
                            }, r.prototype.setPaintProperty = function(e1, r, n, i) {
                                void 0 === i && (i = {}), this._checkLoaded();
                                var a = this.getLayer(e1);
                                a ? t1.deepEqual(a.getPaintProperty(r), n) || (a.setPaintProperty(r, n, i) && this._updateLayer(a), this._changed = !0, this._updatedPaintProps[e1] = !0) : this.fire(new t1.ErrorEvent(new Error("The layer '" + e1 + "' does not exist in the map's style and cannot be styled.")));
                            }, r.prototype.getPaintProperty = function(t1, e1) {
                                return this.getLayer(t1).getPaintProperty(e1);
                            }, r.prototype.setFeatureState = function(e1, r) {
                                this._checkLoaded();
                                var n = e1.source, i = e1.sourceLayer, a = this.sourceCaches[n];
                                if (void 0 !== a) {
                                    var o = a.getSource().type;
                                    "geojson" === o && i ? this.fire(new t1.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== o || i ? (void 0 === e1.id && this.fire(new t1.ErrorEvent(new Error("The feature id parameter must be provided."))), a.setFeatureState(i, e1.id, r)) : this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                                } else this.fire(new t1.ErrorEvent(new Error("The source '" + n + "' does not exist in the map's style.")));
                            }, r.prototype.removeFeatureState = function(e1, r) {
                                this._checkLoaded();
                                var n = e1.source, i = this.sourceCaches[n];
                                if (void 0 !== i) {
                                    var a = i.getSource().type, o = "vector" === a ? e1.sourceLayer : void 0;
                                    "vector" !== a || o ? r && "string" != typeof e1.id && "number" != typeof e1.id ? this.fire(new t1.ErrorEvent(new Error("A feature id is requred to remove its specific state property."))) : i.removeFeatureState(o, e1.id, r) : this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                                } else this.fire(new t1.ErrorEvent(new Error("The source '" + n + "' does not exist in the map's style.")));
                            }, r.prototype.getFeatureState = function(e1) {
                                this._checkLoaded();
                                var r = e1.source, n = e1.sourceLayer, i = this.sourceCaches[r];
                                if (void 0 !== i) {
                                    if ("vector" !== i.getSource().type || n) return void 0 === e1.id && this.fire(new t1.ErrorEvent(new Error("The feature id parameter must be provided."))), i.getFeatureState(n, e1.id);
                                    this.fire(new t1.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                                } else this.fire(new t1.ErrorEvent(new Error("The source '" + r + "' does not exist in the map's style.")));
                            }, r.prototype.getTransition = function() {
                                return t1.extend({
                                    duration: 300,
                                    delay: 0
                                }, this.stylesheet && this.stylesheet.transition);
                            }, r.prototype.serialize = function() {
                                return t1.filterObject({
                                    version: this.stylesheet.version,
                                    name: this.stylesheet.name,
                                    metadata: this.stylesheet.metadata,
                                    light: this.stylesheet.light,
                                    center: this.stylesheet.center,
                                    zoom: this.stylesheet.zoom,
                                    bearing: this.stylesheet.bearing,
                                    pitch: this.stylesheet.pitch,
                                    sprite: this.stylesheet.sprite,
                                    glyphs: this.stylesheet.glyphs,
                                    transition: this.stylesheet.transition,
                                    sources: t1.mapObject(this.sourceCaches, function(t1) {
                                        return t1.serialize();
                                    }),
                                    layers: this._serializeLayers(this._order)
                                }, function(t1) {
                                    return void 0 !== t1;
                                });
                            }, r.prototype._updateLayer = function(t1) {
                                this._updatedLayers[t1.id] = !0, t1.source && !this._updatedSources[t1.source] && "raster" !== this.sourceCaches[t1.source].getSource().type && (this._updatedSources[t1.source] = "reload", this.sourceCaches[t1.source].pause()), this._changed = !0;
                            }, r.prototype._flattenAndSortRenderedFeatures = function(t1) {
                                for(var e1 = this, r = function(t1) {
                                    return "fill-extrusion" === e1._layers[t1].type;
                                }, n = {}, i = [], a = this._order.length - 1; a >= 0; a--){
                                    var o = this._order[a];
                                    if (r(o)) {
                                        n[o] = a;
                                        for(var s = 0, l = t1; s < l.length; s += 1){
                                            var c = l[s][o];
                                            if (c) for(var u = 0, f = c; u < f.length; u += 1){
                                                var h = f[u];
                                                i.push(h);
                                            }
                                        }
                                    }
                                }
                                i.sort(function(t1, e1) {
                                    return e1.intersectionZ - t1.intersectionZ;
                                });
                                for(var p = [], d = this._order.length - 1; d >= 0; d--){
                                    var m = this._order[d];
                                    if (r(m)) for(var g = i.length - 1; g >= 0; g--){
                                        var v = i[g].feature;
                                        if (n[v.layer.id] < d) break;
                                        p.push(v), i.pop();
                                    }
                                    else for(var y = 0, x = t1; y < x.length; y += 1){
                                        var b = x[y][m];
                                        if (b) for(var _ = 0, w = b; _ < w.length; _ += 1){
                                            var T = w[_];
                                            p.push(T.feature);
                                        }
                                    }
                                }
                                return p;
                            }, r.prototype.queryRenderedFeatures = function(e1, r, n) {
                                r && r.filter && this._validate(t1.validateStyle.filter, "queryRenderedFeatures.filter", r.filter, null, r);
                                var i = {};
                                if (r && r.layers) {
                                    if (!Array.isArray(r.layers)) return this.fire(new t1.ErrorEvent(new Error("parameters.layers must be an Array."))), [];
                                    for(var a = 0, o = r.layers; a < o.length; a += 1){
                                        var s = o[a], l = this._layers[s];
                                        if (!l) return this.fire(new t1.ErrorEvent(new Error("The layer '" + s + "' does not exist in the map's style and cannot be queried for features."))), [];
                                        i[l.source] = !0;
                                    }
                                }
                                var c = [];
                                for(var u in r.availableImages = this._availableImages, this.sourceCaches)r.layers && !i[u] || c.push(F(this.sourceCaches[u], this._layers, this._serializedLayers, e1, r, n));
                                return this.placement && c.push(function(t1, e1, r, n, i, a, o) {
                                    for(var s = {}, l = a.queryRenderedSymbols(n), c = [], u = 0, f = Object.keys(l).map(Number); u < f.length; u += 1){
                                        var h = f[u];
                                        c.push(o[h]);
                                    }
                                    c.sort(B);
                                    for(var p = function() {
                                        var r = m[d], n = r.featureIndex.lookupSymbolFeatures(l[r.bucketInstanceId], e1, r.bucketIndex, r.sourceLayerIndex, i.filter, i.layers, i.availableImages, t1);
                                        for(var a in n){
                                            var o = s[a] = s[a] || [], c = n[a];
                                            c.sort(function(t1, e1) {
                                                var n = r.featureSortOrder;
                                                if (n) {
                                                    var i = n.indexOf(t1.featureIndex);
                                                    return n.indexOf(e1.featureIndex) - i;
                                                }
                                                return e1.featureIndex - t1.featureIndex;
                                            });
                                            for(var u = 0, f = c; u < f.length; u += 1){
                                                var h = f[u];
                                                o.push(h);
                                            }
                                        }
                                    }, d = 0, m = c; d < m.length; d += 1)p();
                                    var g = function(e1) {
                                        s[e1].forEach(function(n) {
                                            var i = n.feature, a = t1[e1], o = r[a.source].getFeatureState(i.layer["source-layer"], i.id);
                                            i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = o;
                                        });
                                    };
                                    for(var v in s)g(v);
                                    return s;
                                }(this._layers, this._serializedLayers, this.sourceCaches, e1, r, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(c);
                            }, r.prototype.querySourceFeatures = function(e1, r) {
                                r && r.filter && this._validate(t1.validateStyle.filter, "querySourceFeatures.filter", r.filter, null, r);
                                var n = this.sourceCaches[e1];
                                return n ? function(t1, e1) {
                                    for(var r = t1.getRenderableIds().map(function(e1) {
                                        return t1.getTileByID(e1);
                                    }), n = [], i = {}, a = 0; a < r.length; a++){
                                        var o = r[a], s = o.tileID.canonical.key;
                                        i[s] || (i[s] = !0, o.querySourceFeatures(n, e1));
                                    }
                                    return n;
                                }(n, r) : [];
                            }, r.prototype.addSourceType = function(t1, e1, n) {
                                return r.getSourceType(t1) ? n(new Error('A source type called "' + t1 + '" already exists.')) : (r.setSourceType(t1, e1), e1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                                    name: t1,
                                    url: e1.workerSourceURL
                                }, n) : n(null, null));
                            }, r.prototype.getLight = function() {
                                return this.light.getLight();
                            }, r.prototype.setLight = function(e1, r) {
                                void 0 === r && (r = {}), this._checkLoaded();
                                var n = this.light.getLight(), i = !1;
                                for(var a in e1)if (!t1.deepEqual(e1[a], n[a])) {
                                    i = !0;
                                    break;
                                }
                                if (i) {
                                    var o = {
                                        now: t1.browser.now(),
                                        transition: t1.extend({
                                            duration: 300,
                                            delay: 0
                                        }, this.stylesheet.transition)
                                    };
                                    this.light.setLight(e1, r), this.light.updateTransitions(o);
                                }
                            }, r.prototype._validate = function(e1, r, n, i, a) {
                                return void 0 === a && (a = {}), (!a || !1 !== a.validate) && je(this, e1.call(t1.validateStyle, t1.extend({
                                    key: r,
                                    style: this.serialize(),
                                    value: n,
                                    styleSpec: t1.styleSpec
                                }, i)));
                            }, r.prototype._remove = function() {
                                for(var e1 in this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), t1.evented.off("pluginStateChange", this._rtlTextPluginCallback), this._layers)this._layers[e1].setEventedParent(null);
                                for(var r in this.sourceCaches)this.sourceCaches[r].clearTiles(), this.sourceCaches[r].setEventedParent(null);
                                this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove();
                            }, r.prototype._clearSource = function(t1) {
                                this.sourceCaches[t1].clearTiles();
                            }, r.prototype._reloadSource = function(t1) {
                                this.sourceCaches[t1].resume(), this.sourceCaches[t1].reload();
                            }, r.prototype._updateSources = function(t1) {
                                for(var e1 in this.sourceCaches)this.sourceCaches[e1].update(t1);
                            }, r.prototype._generateCollisionBoxes = function() {
                                for(var t1 in this.sourceCaches)this._reloadSource(t1);
                            }, r.prototype._updatePlacement = function(e1, r, n, i, a) {
                                void 0 === a && (a = !1);
                                for(var o = !1, s = !1, l = {}, c = 0, u = this._order; c < u.length; c += 1){
                                    var f = u[c], h = this._layers[f];
                                    if ("symbol" === h.type) {
                                        if (!l[h.source]) {
                                            var p = this.sourceCaches[h.source];
                                            l[h.source] = p.getRenderableIds(!0).map(function(t1) {
                                                return p.getTileByID(t1);
                                            }).sort(function(t1, e1) {
                                                return e1.tileID.overscaledZ - t1.tileID.overscaledZ || (t1.tileID.isLessThan(e1.tileID) ? -1 : 1);
                                            });
                                        }
                                        var d = this.crossTileSymbolIndex.addLayer(h, l[h.source], e1.center.lng);
                                        o = o || d;
                                    }
                                }
                                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((a = a || this._layerOrderChanged || 0 === n) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(t1.browser.now(), e1.zoom)) && (this.pauseablePlacement = new ze(e1, this._order, a, r, n, i, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(t1.browser.now()), s = !0), o && this.pauseablePlacement.placement.setStale()), s || o) for(var m = 0, g = this._order; m < g.length; m += 1){
                                    var v = g[m], y = this._layers[v];
                                    "symbol" === y.type && this.placement.updateLayerOpacities(y, l[y.source]);
                                }
                                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(t1.browser.now());
                            }, r.prototype._releaseSymbolFadeTiles = function() {
                                for(var t1 in this.sourceCaches)this.sourceCaches[t1].releaseSymbolFadeTiles();
                            }, r.prototype.getImages = function(t1, e1, r) {
                                this.imageManager.getImages(e1.icons, r), this._updateTilesForChangedImages();
                                var n = this.sourceCaches[e1.source];
                                n && n.setDependencies(e1.tileID.key, e1.type, e1.icons);
                            }, r.prototype.getGlyphs = function(t1, e1, r) {
                                this.glyphManager.getGlyphs(e1.stacks, r);
                            }, r.prototype.getResource = function(e1, r, n) {
                                return t1.makeRequest(r, n);
                            }, r;
                        }(t1.Evented);
                        qe.getSourceType = function(t1) {
                            return D[t1];
                        }, qe.setSourceType = function(t1, e1) {
                            D[t1] = e1;
                        }, qe.registerForPluginStateChange = t1.registerForPluginStateChange;
                        var Ge = t1.createLayout([
                            {
                                name: "a_pos",
                                type: "Int16",
                                components: 2
                            }
                        ]), Ye = yr("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}"), We = yr("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), Xe = yr("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"), Ze = yr("varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"), Je = yr("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), Ke = yr("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"), Qe = yr("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"), $e = yr("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"), tr = yr("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"), er = yr("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,0,1);}"), rr = yr("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"), nr = yr("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"), ir = yr("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"), ar = yr("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"), or = yr("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"), sr = yr("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"), lr = yr("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform float u_maxzoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggeration=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/ pow(2.0,(u_zoom-u_maxzoom)*exaggeration+19.2562-u_zoom);gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"), cr = yr("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"), ur = yr("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"), fr = yr("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,vec2(v_lineprogress,0.5));gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define MAX_LINE_DISTANCE 32767.0\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_lineprogress=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0/MAX_LINE_DISTANCE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"), hr = yr("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"), pr = yr("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"), dr = yr("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"), mr = yr("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}"), gr = yr("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"), vr = yr("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}");
                        function yr(t1, e1) {
                            var r = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, n = {};
                            return {
                                fragmentSource: t1 = t1.replace(r, function(t1, e1, r, i, a) {
                                    return n[a] = !0, "define" === e1 ? "\n#ifndef HAS_UNIFORM_u_" + a + "\nvarying " + r + " " + i + " " + a + ";\n#else\nuniform " + r + " " + i + " u_" + a + ";\n#endif\n" : "\n#ifdef HAS_UNIFORM_u_" + a + "\n    " + r + " " + i + " " + a + " = u_" + a + ";\n#endif\n";
                                }),
                                vertexSource: e1 = e1.replace(r, function(t1, e1, r, i, a) {
                                    var o = "float" === i ? "vec2" : "vec4", s = a.match(/color/) ? "color" : o;
                                    return n[a] ? "define" === e1 ? "\n#ifndef HAS_UNIFORM_u_" + a + "\nuniform lowp float u_" + a + "_t;\nattribute " + r + " " + o + " a_" + a + ";\nvarying " + r + " " + i + " " + a + ";\n#else\nuniform " + r + " " + i + " u_" + a + ";\n#endif\n" : "vec4" === s ? "\n#ifndef HAS_UNIFORM_u_" + a + "\n    " + a + " = a_" + a + ";\n#else\n    " + r + " " + i + " " + a + " = u_" + a + ";\n#endif\n" : "\n#ifndef HAS_UNIFORM_u_" + a + "\n    " + a + " = unpack_mix_" + s + "(a_" + a + ", u_" + a + "_t);\n#else\n    " + r + " " + i + " " + a + " = u_" + a + ";\n#endif\n" : "define" === e1 ? "\n#ifndef HAS_UNIFORM_u_" + a + "\nuniform lowp float u_" + a + "_t;\nattribute " + r + " " + o + " a_" + a + ";\n#else\nuniform " + r + " " + i + " u_" + a + ";\n#endif\n" : "vec4" === s ? "\n#ifndef HAS_UNIFORM_u_" + a + "\n    " + r + " " + i + " " + a + " = a_" + a + ";\n#else\n    " + r + " " + i + " " + a + " = u_" + a + ";\n#endif\n" : "\n#ifndef HAS_UNIFORM_u_" + a + "\n    " + r + " " + i + " " + a + " = unpack_mix_" + s + "(a_" + a + ", u_" + a + "_t);\n#else\n    " + r + " " + i + " " + a + " = u_" + a + ";\n#endif\n";
                                })
                            };
                        }
                        var xr = Object.freeze({
                            __proto__: null,
                            prelude: Ye,
                            background: We,
                            backgroundPattern: Xe,
                            circle: Ze,
                            clippingMask: Je,
                            heatmap: Ke,
                            heatmapTexture: Qe,
                            collisionBox: $e,
                            collisionCircle: tr,
                            debug: er,
                            fill: rr,
                            fillOutline: nr,
                            fillOutlinePattern: ir,
                            fillPattern: ar,
                            fillExtrusion: or,
                            fillExtrusionPattern: sr,
                            hillshadePrepare: lr,
                            hillshade: cr,
                            line: ur,
                            lineGradient: fr,
                            linePattern: hr,
                            lineSDF: pr,
                            raster: dr,
                            symbolIcon: mr,
                            symbolSDF: gr,
                            symbolTextAndIcon: vr
                        }), br = function() {
                            this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
                        };
                        br.prototype.bind = function(t1, e1, r, n, i, a, o, s) {
                            this.context = t1;
                            for(var l = this.boundPaintVertexBuffers.length !== n.length, c = 0; !l && c < n.length; c++)this.boundPaintVertexBuffers[c] !== n[c] && (l = !0);
                            var u = !this.vao || this.boundProgram !== e1 || this.boundLayoutVertexBuffer !== r || l || this.boundIndexBuffer !== i || this.boundVertexOffset !== a || this.boundDynamicVertexBuffer !== o || this.boundDynamicVertexBuffer2 !== s;
                            !t1.extVertexArrayObject || u ? this.freshBind(e1, r, n, i, a, o, s) : (t1.bindVertexArrayOES.set(this.vao), o && o.bind(), i && i.dynamicDraw && i.bind(), s && s.bind());
                        }, br.prototype.freshBind = function(t1, e1, r, n, i, a, o) {
                            var s, l = t1.numAttributes, c = this.context, u = c.gl;
                            if (c.extVertexArrayObject) this.vao && this.destroy(), this.vao = c.extVertexArrayObject.createVertexArrayOES(), c.bindVertexArrayOES.set(this.vao), s = 0, this.boundProgram = t1, this.boundLayoutVertexBuffer = e1, this.boundPaintVertexBuffers = r, this.boundIndexBuffer = n, this.boundVertexOffset = i, this.boundDynamicVertexBuffer = a, this.boundDynamicVertexBuffer2 = o;
                            else {
                                s = c.currentNumAttributes || 0;
                                for(var f = l; f < s; f++)u.disableVertexAttribArray(f);
                            }
                            e1.enableAttributes(u, t1);
                            for(var h = 0, p = r; h < p.length; h += 1)p[h].enableAttributes(u, t1);
                            a && a.enableAttributes(u, t1), o && o.enableAttributes(u, t1), e1.bind(), e1.setVertexAttribPointers(u, t1, i);
                            for(var d = 0, m = r; d < m.length; d += 1){
                                var g = m[d];
                                g.bind(), g.setVertexAttribPointers(u, t1, i);
                            }
                            a && (a.bind(), a.setVertexAttribPointers(u, t1, i)), n && n.bind(), o && (o.bind(), o.setVertexAttribPointers(u, t1, i)), c.currentNumAttributes = l;
                        }, br.prototype.destroy = function() {
                            this.vao && (this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao), this.vao = null);
                        };
                        var _r = function(t1, e1, r, n, i) {
                            var a = t1.gl;
                            this.program = a.createProgram();
                            var o = r ? r.defines() : [];
                            i && o.push("#define OVERDRAW_INSPECTOR;");
                            var s = o.concat(Ye.fragmentSource, e1.fragmentSource).join("\n"), l = o.concat(Ye.vertexSource, e1.vertexSource).join("\n"), c = a.createShader(a.FRAGMENT_SHADER);
                            if (a.isContextLost()) this.failedToCreate = !0;
                            else {
                                a.shaderSource(c, s), a.compileShader(c), a.attachShader(this.program, c);
                                var u = a.createShader(a.VERTEX_SHADER);
                                if (a.isContextLost()) this.failedToCreate = !0;
                                else {
                                    a.shaderSource(u, l), a.compileShader(u), a.attachShader(this.program, u);
                                    for(var f = r ? r.layoutAttributes : [], h = 0; h < f.length; h++)a.bindAttribLocation(this.program, h, f[h].name);
                                    a.linkProgram(this.program), a.deleteShader(u), a.deleteShader(c), this.numAttributes = a.getProgramParameter(this.program, a.ACTIVE_ATTRIBUTES), this.attributes = {};
                                    for(var p = {}, d = 0; d < this.numAttributes; d++){
                                        var m = a.getActiveAttrib(this.program, d);
                                        m && (this.attributes[m.name] = a.getAttribLocation(this.program, m.name));
                                    }
                                    for(var g = a.getProgramParameter(this.program, a.ACTIVE_UNIFORMS), v = 0; v < g; v++){
                                        var y = a.getActiveUniform(this.program, v);
                                        y && (p[y.name] = a.getUniformLocation(this.program, y.name));
                                    }
                                    this.fixedUniforms = n(t1, p), this.binderUniforms = r ? r.getUniforms(t1, p) : [];
                                }
                            }
                        };
                        function wr(t1, e1, r) {
                            var n = 1 / pe(r, 1, e1.transform.tileZoom), i = Math.pow(2, r.tileID.overscaledZ), a = r.tileSize * Math.pow(2, e1.transform.tileZoom) / i, o = a * (r.tileID.canonical.x + r.tileID.wrap * i), s = a * r.tileID.canonical.y;
                            return {
                                u_image: 0,
                                u_texsize: r.imageAtlasTexture.size,
                                u_scale: [
                                    n,
                                    t1.fromScale,
                                    t1.toScale
                                ],
                                u_fade: t1.t,
                                u_pixel_coord_upper: [
                                    o >> 16,
                                    s >> 16
                                ],
                                u_pixel_coord_lower: [
                                    65535 & o,
                                    65535 & s
                                ]
                            };
                        }
                        _r.prototype.draw = function(t1, e1, r, n, i, a, o, s, l, c, u, f, h, p, d, m) {
                            var g, v = t1.gl;
                            if (!this.failedToCreate) {
                                for(var y in t1.program.set(this.program), t1.setDepthMode(r), t1.setStencilMode(n), t1.setColorMode(i), t1.setCullFace(a), this.fixedUniforms)this.fixedUniforms[y].set(o[y]);
                                p && p.setUniforms(t1, this.binderUniforms, f, {
                                    zoom: h
                                });
                                for(var x = (g = {}, g[v.LINES] = 2, g[v.TRIANGLES] = 3, g[v.LINE_STRIP] = 1, g)[e1], b = 0, _ = u.get(); b < _.length; b += 1){
                                    var w = _[b], T = w.vaos || (w.vaos = {});
                                    (T[s] || (T[s] = new br)).bind(t1, this, l, p ? p.getPaintVertexBuffers() : [], c, w.vertexOffset, d, m), v.drawElements(e1, w.primitiveLength * x, v.UNSIGNED_SHORT, w.primitiveOffset * x * 2);
                                }
                            }
                        };
                        var Tr = function(e1, r, n, i) {
                            var a = r.style.light, o = a.properties.get("position"), s = [
                                o.x,
                                o.y,
                                o.z
                            ], l = t1.create$1();
                            "viewport" === a.properties.get("anchor") && t1.fromRotation(l, -r.transform.angle), t1.transformMat3(s, s, l);
                            var c = a.properties.get("color");
                            return {
                                u_matrix: e1,
                                u_lightpos: s,
                                u_lightintensity: a.properties.get("intensity"),
                                u_lightcolor: [
                                    c.r,
                                    c.g,
                                    c.b
                                ],
                                u_vertical_gradient: +n,
                                u_opacity: i
                            };
                        }, kr = function(e1, r, n, i, a, o, s) {
                            return t1.extend(Tr(e1, r, n, i), wr(o, r, s), {
                                u_height_factor: -Math.pow(2, a.overscaledZ) / s.tileSize / 8
                            });
                        }, Ar = function(t1) {
                            return {
                                u_matrix: t1
                            };
                        }, Mr = function(e1, r, n, i) {
                            return t1.extend(Ar(e1), wr(n, r, i));
                        }, Sr = function(t1, e1) {
                            return {
                                u_matrix: t1,
                                u_world: e1
                            };
                        }, Er = function(e1, r, n, i, a) {
                            return t1.extend(Mr(e1, r, n, i), {
                                u_world: a
                            });
                        }, Lr = function(e1, r, n, i) {
                            var a, o, s = e1.transform;
                            if ("map" === i.paint.get("circle-pitch-alignment")) {
                                var l = pe(n, 1, s.zoom);
                                a = !0, o = [
                                    l,
                                    l
                                ];
                            } else a = !1, o = s.pixelsToGLUnits;
                            return {
                                u_camera_to_center_distance: s.cameraToCenterDistance,
                                u_scale_with_map: +("map" === i.paint.get("circle-pitch-scale")),
                                u_matrix: e1.translatePosMatrix(r.posMatrix, n, i.paint.get("circle-translate"), i.paint.get("circle-translate-anchor")),
                                u_pitch_with_map: +a,
                                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                                u_extrude_scale: o
                            };
                        }, Cr = function(t1, e1, r) {
                            var n = pe(r, 1, e1.zoom), i = Math.pow(2, e1.zoom - r.tileID.overscaledZ), a = r.tileID.overscaleFactor();
                            return {
                                u_matrix: t1,
                                u_camera_to_center_distance: e1.cameraToCenterDistance,
                                u_pixels_to_tile_units: n,
                                u_extrude_scale: [
                                    e1.pixelsToGLUnits[0] / (n * i),
                                    e1.pixelsToGLUnits[1] / (n * i)
                                ],
                                u_overscale_factor: a
                            };
                        }, Pr = function(t1, e1, r) {
                            return {
                                u_matrix: t1,
                                u_inv_matrix: e1,
                                u_camera_to_center_distance: r.cameraToCenterDistance,
                                u_viewport_size: [
                                    r.width,
                                    r.height
                                ]
                            };
                        }, Ir = function(t1, e1, r) {
                            return void 0 === r && (r = 1), {
                                u_matrix: t1,
                                u_color: e1,
                                u_overlay: 0,
                                u_overlay_scale: r
                            };
                        }, Or = function(t1) {
                            return {
                                u_matrix: t1
                            };
                        }, zr = function(t1, e1, r, n) {
                            return {
                                u_matrix: t1,
                                u_extrude_scale: pe(e1, 1, r),
                                u_intensity: n
                            };
                        };
                        function Dr(e1, r) {
                            var n = Math.pow(2, r.canonical.z), i = r.canonical.y;
                            return [
                                new t1.MercatorCoordinate(0, i / n).toLngLat().lat,
                                new t1.MercatorCoordinate(0, (i + 1) / n).toLngLat().lat
                            ];
                        }
                        var Rr = function(e1, r, n) {
                            var i = e1.transform;
                            return {
                                u_matrix: Ur(e1, r, n),
                                u_ratio: 1 / pe(r, 1, i.zoom),
                                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                                u_units_to_pixels: [
                                    1 / i.pixelsToGLUnits[0],
                                    1 / i.pixelsToGLUnits[1]
                                ]
                            };
                        }, Fr = function(e1, r, n) {
                            return t1.extend(Rr(e1, r, n), {
                                u_image: 0
                            });
                        }, Br = function(e1, r, n, i) {
                            var a = e1.transform, o = jr(r, a);
                            return {
                                u_matrix: Ur(e1, r, n),
                                u_texsize: r.imageAtlasTexture.size,
                                u_ratio: 1 / pe(r, 1, a.zoom),
                                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                                u_image: 0,
                                u_scale: [
                                    o,
                                    i.fromScale,
                                    i.toScale
                                ],
                                u_fade: i.t,
                                u_units_to_pixels: [
                                    1 / a.pixelsToGLUnits[0],
                                    1 / a.pixelsToGLUnits[1]
                                ]
                            };
                        }, Nr = function(e1, r, n, i, a) {
                            var o = e1.transform, s = e1.lineAtlas, l = jr(r, o), c = "round" === n.layout.get("line-cap"), u = s.getDash(i.from, c), f = s.getDash(i.to, c), h = u.width * a.fromScale, p = f.width * a.toScale;
                            return t1.extend(Rr(e1, r, n), {
                                u_patternscale_a: [
                                    l / h,
                                    -u.height / 2
                                ],
                                u_patternscale_b: [
                                    l / p,
                                    -f.height / 2
                                ],
                                u_sdfgamma: s.width / (256 * Math.min(h, p) * t1.browser.devicePixelRatio) / 2,
                                u_image: 0,
                                u_tex_y_a: u.y,
                                u_tex_y_b: f.y,
                                u_mix: a.t
                            });
                        };
                        function jr(t1, e1) {
                            return 1 / pe(t1, 1, e1.tileZoom);
                        }
                        function Ur(t1, e1, r) {
                            return t1.translatePosMatrix(e1.tileID.posMatrix, e1, r.paint.get("line-translate"), r.paint.get("line-translate-anchor"));
                        }
                        var Vr = function(t1, e1, r, n, i) {
                            var a, o;
                            return {
                                u_matrix: t1,
                                u_tl_parent: e1,
                                u_scale_parent: r,
                                u_buffer_scale: 1,
                                u_fade_t: n.mix,
                                u_opacity: n.opacity * i.paint.get("raster-opacity"),
                                u_image0: 0,
                                u_image1: 1,
                                u_brightness_low: i.paint.get("raster-brightness-min"),
                                u_brightness_high: i.paint.get("raster-brightness-max"),
                                u_saturation_factor: (o = i.paint.get("raster-saturation"), o > 0 ? 1 - 1 / (1.001 - o) : -o),
                                u_contrast_factor: (a = i.paint.get("raster-contrast"), a > 0 ? 1 / (1 - a) : 1 + a),
                                u_spin_weights: Hr(i.paint.get("raster-hue-rotate"))
                            };
                        };
                        function Hr(t1) {
                            t1 *= Math.PI / 180;
                            var e1 = Math.sin(t1), r = Math.cos(t1);
                            return [
                                (2 * r + 1) / 3,
                                (-Math.sqrt(3) * e1 - r + 1) / 3,
                                (Math.sqrt(3) * e1 - r + 1) / 3
                            ];
                        }
                        var qr, Gr = function(t1, e1, r, n, i, a, o, s, l, c) {
                            var u = i.transform;
                            return {
                                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                                u_size_t: e1 ? e1.uSizeT : 0,
                                u_size: e1 ? e1.uSize : 0,
                                u_camera_to_center_distance: u.cameraToCenterDistance,
                                u_pitch: u.pitch / 360 * 2 * Math.PI,
                                u_rotate_symbol: +r,
                                u_aspect_ratio: u.width / u.height,
                                u_fade_change: i.options.fadeDuration ? i.symbolFadeChange : 1,
                                u_matrix: a,
                                u_label_plane_matrix: o,
                                u_coord_matrix: s,
                                u_is_text: +l,
                                u_pitch_with_map: +n,
                                u_texsize: c,
                                u_texture: 0
                            };
                        }, Yr = function(e1, r, n, i, a, o, s, l, c, u, f) {
                            var h = a.transform;
                            return t1.extend(Gr(e1, r, n, i, a, o, s, l, c, u), {
                                u_gamma_scale: i ? Math.cos(h._pitch) * h.cameraToCenterDistance : 1,
                                u_device_pixel_ratio: t1.browser.devicePixelRatio,
                                u_is_halo: +f
                            });
                        }, Wr = function(e1, r, n, i, a, o, s, l, c, u) {
                            return t1.extend(Yr(e1, r, n, i, a, o, s, l, !0, c, !0), {
                                u_texsize_icon: u,
                                u_texture_icon: 1
                            });
                        }, Xr = function(t1, e1, r) {
                            return {
                                u_matrix: t1,
                                u_opacity: e1,
                                u_color: r
                            };
                        }, Zr = function(e1, r, n, i, a, o) {
                            return t1.extend(function(t1, e1, r, n) {
                                var i = r.imageManager.getPattern(t1.from.toString()), a = r.imageManager.getPattern(t1.to.toString()), o = r.imageManager.getPixelSize(), s = o.width, l = o.height, c = Math.pow(2, n.tileID.overscaledZ), u = n.tileSize * Math.pow(2, r.transform.tileZoom) / c, f = u * (n.tileID.canonical.x + n.tileID.wrap * c), h = u * n.tileID.canonical.y;
                                return {
                                    u_image: 0,
                                    u_pattern_tl_a: i.tl,
                                    u_pattern_br_a: i.br,
                                    u_pattern_tl_b: a.tl,
                                    u_pattern_br_b: a.br,
                                    u_texsize: [
                                        s,
                                        l
                                    ],
                                    u_mix: e1.t,
                                    u_pattern_size_a: i.displaySize,
                                    u_pattern_size_b: a.displaySize,
                                    u_scale_a: e1.fromScale,
                                    u_scale_b: e1.toScale,
                                    u_tile_units_to_pixels: 1 / pe(n, 1, r.transform.tileZoom),
                                    u_pixel_coord_upper: [
                                        f >> 16,
                                        h >> 16
                                    ],
                                    u_pixel_coord_lower: [
                                        65535 & f,
                                        65535 & h
                                    ]
                                };
                            }(i, o, n, a), {
                                u_matrix: e1,
                                u_opacity: r
                            });
                        }, Jr = {
                            fillExtrusion: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_lightpos: new t1.Uniform3f(e1, r.u_lightpos),
                                    u_lightintensity: new t1.Uniform1f(e1, r.u_lightintensity),
                                    u_lightcolor: new t1.Uniform3f(e1, r.u_lightcolor),
                                    u_vertical_gradient: new t1.Uniform1f(e1, r.u_vertical_gradient),
                                    u_opacity: new t1.Uniform1f(e1, r.u_opacity)
                                };
                            },
                            fillExtrusionPattern: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_lightpos: new t1.Uniform3f(e1, r.u_lightpos),
                                    u_lightintensity: new t1.Uniform1f(e1, r.u_lightintensity),
                                    u_lightcolor: new t1.Uniform3f(e1, r.u_lightcolor),
                                    u_vertical_gradient: new t1.Uniform1f(e1, r.u_vertical_gradient),
                                    u_height_factor: new t1.Uniform1f(e1, r.u_height_factor),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_pixel_coord_upper: new t1.Uniform2f(e1, r.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new t1.Uniform2f(e1, r.u_pixel_coord_lower),
                                    u_scale: new t1.Uniform3f(e1, r.u_scale),
                                    u_fade: new t1.Uniform1f(e1, r.u_fade),
                                    u_opacity: new t1.Uniform1f(e1, r.u_opacity)
                                };
                            },
                            fill: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix)
                                };
                            },
                            fillPattern: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_pixel_coord_upper: new t1.Uniform2f(e1, r.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new t1.Uniform2f(e1, r.u_pixel_coord_lower),
                                    u_scale: new t1.Uniform3f(e1, r.u_scale),
                                    u_fade: new t1.Uniform1f(e1, r.u_fade)
                                };
                            },
                            fillOutline: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_world: new t1.Uniform2f(e1, r.u_world)
                                };
                            },
                            fillOutlinePattern: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_world: new t1.Uniform2f(e1, r.u_world),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_pixel_coord_upper: new t1.Uniform2f(e1, r.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new t1.Uniform2f(e1, r.u_pixel_coord_lower),
                                    u_scale: new t1.Uniform3f(e1, r.u_scale),
                                    u_fade: new t1.Uniform1f(e1, r.u_fade)
                                };
                            },
                            circle: function(e1, r) {
                                return {
                                    u_camera_to_center_distance: new t1.Uniform1f(e1, r.u_camera_to_center_distance),
                                    u_scale_with_map: new t1.Uniform1i(e1, r.u_scale_with_map),
                                    u_pitch_with_map: new t1.Uniform1i(e1, r.u_pitch_with_map),
                                    u_extrude_scale: new t1.Uniform2f(e1, r.u_extrude_scale),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix)
                                };
                            },
                            collisionBox: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_camera_to_center_distance: new t1.Uniform1f(e1, r.u_camera_to_center_distance),
                                    u_pixels_to_tile_units: new t1.Uniform1f(e1, r.u_pixels_to_tile_units),
                                    u_extrude_scale: new t1.Uniform2f(e1, r.u_extrude_scale),
                                    u_overscale_factor: new t1.Uniform1f(e1, r.u_overscale_factor)
                                };
                            },
                            collisionCircle: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_inv_matrix: new t1.UniformMatrix4f(e1, r.u_inv_matrix),
                                    u_camera_to_center_distance: new t1.Uniform1f(e1, r.u_camera_to_center_distance),
                                    u_viewport_size: new t1.Uniform2f(e1, r.u_viewport_size)
                                };
                            },
                            debug: function(e1, r) {
                                return {
                                    u_color: new t1.UniformColor(e1, r.u_color),
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_overlay: new t1.Uniform1i(e1, r.u_overlay),
                                    u_overlay_scale: new t1.Uniform1f(e1, r.u_overlay_scale)
                                };
                            },
                            clippingMask: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix)
                                };
                            },
                            heatmap: function(e1, r) {
                                return {
                                    u_extrude_scale: new t1.Uniform1f(e1, r.u_extrude_scale),
                                    u_intensity: new t1.Uniform1f(e1, r.u_intensity),
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix)
                                };
                            },
                            heatmapTexture: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_world: new t1.Uniform2f(e1, r.u_world),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_color_ramp: new t1.Uniform1i(e1, r.u_color_ramp),
                                    u_opacity: new t1.Uniform1f(e1, r.u_opacity)
                                };
                            },
                            hillshade: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_latrange: new t1.Uniform2f(e1, r.u_latrange),
                                    u_light: new t1.Uniform2f(e1, r.u_light),
                                    u_shadow: new t1.UniformColor(e1, r.u_shadow),
                                    u_highlight: new t1.UniformColor(e1, r.u_highlight),
                                    u_accent: new t1.UniformColor(e1, r.u_accent)
                                };
                            },
                            hillshadePrepare: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_dimension: new t1.Uniform2f(e1, r.u_dimension),
                                    u_zoom: new t1.Uniform1f(e1, r.u_zoom),
                                    u_maxzoom: new t1.Uniform1f(e1, r.u_maxzoom),
                                    u_unpack: new t1.Uniform4f(e1, r.u_unpack)
                                };
                            },
                            line: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_ratio: new t1.Uniform1f(e1, r.u_ratio),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_units_to_pixels: new t1.Uniform2f(e1, r.u_units_to_pixels)
                                };
                            },
                            lineGradient: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_ratio: new t1.Uniform1f(e1, r.u_ratio),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_units_to_pixels: new t1.Uniform2f(e1, r.u_units_to_pixels),
                                    u_image: new t1.Uniform1i(e1, r.u_image)
                                };
                            },
                            linePattern: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_ratio: new t1.Uniform1f(e1, r.u_ratio),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_units_to_pixels: new t1.Uniform2f(e1, r.u_units_to_pixels),
                                    u_scale: new t1.Uniform3f(e1, r.u_scale),
                                    u_fade: new t1.Uniform1f(e1, r.u_fade)
                                };
                            },
                            lineSDF: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_ratio: new t1.Uniform1f(e1, r.u_ratio),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_units_to_pixels: new t1.Uniform2f(e1, r.u_units_to_pixels),
                                    u_patternscale_a: new t1.Uniform2f(e1, r.u_patternscale_a),
                                    u_patternscale_b: new t1.Uniform2f(e1, r.u_patternscale_b),
                                    u_sdfgamma: new t1.Uniform1f(e1, r.u_sdfgamma),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_tex_y_a: new t1.Uniform1f(e1, r.u_tex_y_a),
                                    u_tex_y_b: new t1.Uniform1f(e1, r.u_tex_y_b),
                                    u_mix: new t1.Uniform1f(e1, r.u_mix)
                                };
                            },
                            raster: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_tl_parent: new t1.Uniform2f(e1, r.u_tl_parent),
                                    u_scale_parent: new t1.Uniform1f(e1, r.u_scale_parent),
                                    u_buffer_scale: new t1.Uniform1f(e1, r.u_buffer_scale),
                                    u_fade_t: new t1.Uniform1f(e1, r.u_fade_t),
                                    u_opacity: new t1.Uniform1f(e1, r.u_opacity),
                                    u_image0: new t1.Uniform1i(e1, r.u_image0),
                                    u_image1: new t1.Uniform1i(e1, r.u_image1),
                                    u_brightness_low: new t1.Uniform1f(e1, r.u_brightness_low),
                                    u_brightness_high: new t1.Uniform1f(e1, r.u_brightness_high),
                                    u_saturation_factor: new t1.Uniform1f(e1, r.u_saturation_factor),
                                    u_contrast_factor: new t1.Uniform1f(e1, r.u_contrast_factor),
                                    u_spin_weights: new t1.Uniform3f(e1, r.u_spin_weights)
                                };
                            },
                            symbolIcon: function(e1, r) {
                                return {
                                    u_is_size_zoom_constant: new t1.Uniform1i(e1, r.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new t1.Uniform1i(e1, r.u_is_size_feature_constant),
                                    u_size_t: new t1.Uniform1f(e1, r.u_size_t),
                                    u_size: new t1.Uniform1f(e1, r.u_size),
                                    u_camera_to_center_distance: new t1.Uniform1f(e1, r.u_camera_to_center_distance),
                                    u_pitch: new t1.Uniform1f(e1, r.u_pitch),
                                    u_rotate_symbol: new t1.Uniform1i(e1, r.u_rotate_symbol),
                                    u_aspect_ratio: new t1.Uniform1f(e1, r.u_aspect_ratio),
                                    u_fade_change: new t1.Uniform1f(e1, r.u_fade_change),
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, r.u_label_plane_matrix),
                                    u_coord_matrix: new t1.UniformMatrix4f(e1, r.u_coord_matrix),
                                    u_is_text: new t1.Uniform1i(e1, r.u_is_text),
                                    u_pitch_with_map: new t1.Uniform1i(e1, r.u_pitch_with_map),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_texture: new t1.Uniform1i(e1, r.u_texture)
                                };
                            },
                            symbolSDF: function(e1, r) {
                                return {
                                    u_is_size_zoom_constant: new t1.Uniform1i(e1, r.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new t1.Uniform1i(e1, r.u_is_size_feature_constant),
                                    u_size_t: new t1.Uniform1f(e1, r.u_size_t),
                                    u_size: new t1.Uniform1f(e1, r.u_size),
                                    u_camera_to_center_distance: new t1.Uniform1f(e1, r.u_camera_to_center_distance),
                                    u_pitch: new t1.Uniform1f(e1, r.u_pitch),
                                    u_rotate_symbol: new t1.Uniform1i(e1, r.u_rotate_symbol),
                                    u_aspect_ratio: new t1.Uniform1f(e1, r.u_aspect_ratio),
                                    u_fade_change: new t1.Uniform1f(e1, r.u_fade_change),
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, r.u_label_plane_matrix),
                                    u_coord_matrix: new t1.UniformMatrix4f(e1, r.u_coord_matrix),
                                    u_is_text: new t1.Uniform1i(e1, r.u_is_text),
                                    u_pitch_with_map: new t1.Uniform1i(e1, r.u_pitch_with_map),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_texture: new t1.Uniform1i(e1, r.u_texture),
                                    u_gamma_scale: new t1.Uniform1f(e1, r.u_gamma_scale),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_is_halo: new t1.Uniform1i(e1, r.u_is_halo)
                                };
                            },
                            symbolTextAndIcon: function(e1, r) {
                                return {
                                    u_is_size_zoom_constant: new t1.Uniform1i(e1, r.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new t1.Uniform1i(e1, r.u_is_size_feature_constant),
                                    u_size_t: new t1.Uniform1f(e1, r.u_size_t),
                                    u_size: new t1.Uniform1f(e1, r.u_size),
                                    u_camera_to_center_distance: new t1.Uniform1f(e1, r.u_camera_to_center_distance),
                                    u_pitch: new t1.Uniform1f(e1, r.u_pitch),
                                    u_rotate_symbol: new t1.Uniform1i(e1, r.u_rotate_symbol),
                                    u_aspect_ratio: new t1.Uniform1f(e1, r.u_aspect_ratio),
                                    u_fade_change: new t1.Uniform1f(e1, r.u_fade_change),
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_label_plane_matrix: new t1.UniformMatrix4f(e1, r.u_label_plane_matrix),
                                    u_coord_matrix: new t1.UniformMatrix4f(e1, r.u_coord_matrix),
                                    u_is_text: new t1.Uniform1i(e1, r.u_is_text),
                                    u_pitch_with_map: new t1.Uniform1i(e1, r.u_pitch_with_map),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_texsize_icon: new t1.Uniform2f(e1, r.u_texsize_icon),
                                    u_texture: new t1.Uniform1i(e1, r.u_texture),
                                    u_texture_icon: new t1.Uniform1i(e1, r.u_texture_icon),
                                    u_gamma_scale: new t1.Uniform1f(e1, r.u_gamma_scale),
                                    u_device_pixel_ratio: new t1.Uniform1f(e1, r.u_device_pixel_ratio),
                                    u_is_halo: new t1.Uniform1i(e1, r.u_is_halo)
                                };
                            },
                            background: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_opacity: new t1.Uniform1f(e1, r.u_opacity),
                                    u_color: new t1.UniformColor(e1, r.u_color)
                                };
                            },
                            backgroundPattern: function(e1, r) {
                                return {
                                    u_matrix: new t1.UniformMatrix4f(e1, r.u_matrix),
                                    u_opacity: new t1.Uniform1f(e1, r.u_opacity),
                                    u_image: new t1.Uniform1i(e1, r.u_image),
                                    u_pattern_tl_a: new t1.Uniform2f(e1, r.u_pattern_tl_a),
                                    u_pattern_br_a: new t1.Uniform2f(e1, r.u_pattern_br_a),
                                    u_pattern_tl_b: new t1.Uniform2f(e1, r.u_pattern_tl_b),
                                    u_pattern_br_b: new t1.Uniform2f(e1, r.u_pattern_br_b),
                                    u_texsize: new t1.Uniform2f(e1, r.u_texsize),
                                    u_mix: new t1.Uniform1f(e1, r.u_mix),
                                    u_pattern_size_a: new t1.Uniform2f(e1, r.u_pattern_size_a),
                                    u_pattern_size_b: new t1.Uniform2f(e1, r.u_pattern_size_b),
                                    u_scale_a: new t1.Uniform1f(e1, r.u_scale_a),
                                    u_scale_b: new t1.Uniform1f(e1, r.u_scale_b),
                                    u_pixel_coord_upper: new t1.Uniform2f(e1, r.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new t1.Uniform2f(e1, r.u_pixel_coord_lower),
                                    u_tile_units_to_pixels: new t1.Uniform1f(e1, r.u_tile_units_to_pixels)
                                };
                            }
                        };
                        function Kr(e1, r, n, i, a, o, s) {
                            for(var l = e1.context, c = l.gl, u = e1.useProgram("collisionBox"), f = [], h = 0, p = 0, d = 0; d < i.length; d++){
                                var m = i[d], g = r.getTile(m), v = g.getBucket(n);
                                if (v) {
                                    var y = m.posMatrix;
                                    0 === a[0] && 0 === a[1] || (y = e1.translatePosMatrix(m.posMatrix, g, a, o));
                                    var x = s ? v.textCollisionBox : v.iconCollisionBox, b = v.collisionCircleArray;
                                    if (b.length > 0) {
                                        var _ = t1.create(), w = y;
                                        t1.mul(_, v.placementInvProjMatrix, e1.transform.glCoordMatrix), t1.mul(_, _, v.placementViewportMatrix), f.push({
                                            circleArray: b,
                                            circleOffset: p,
                                            transform: w,
                                            invTransform: _
                                        }), p = h += b.length / 4;
                                    }
                                    x && u.draw(l, c.LINES, At.disabled, Mt.disabled, e1.colorModeForRenderPass(), Et.disabled, Cr(y, e1.transform, g), n.id, x.layoutVertexBuffer, x.indexBuffer, x.segments, null, e1.transform.zoom, null, null, x.collisionVertexBuffer);
                                }
                            }
                            if (s && f.length) {
                                var T = e1.useProgram("collisionCircle"), k = new t1.StructArrayLayout2f1f2i16;
                                k.resize(4 * h), k._trim();
                                for(var A = 0, M = 0, S = f; M < S.length; M += 1)for(var E = S[M], L = 0; L < E.circleArray.length / 4; L++){
                                    var C = 4 * L, P = E.circleArray[C + 0], I = E.circleArray[C + 1], O = E.circleArray[C + 2], z = E.circleArray[C + 3];
                                    k.emplace(A++, P, I, O, z, 0), k.emplace(A++, P, I, O, z, 1), k.emplace(A++, P, I, O, z, 2), k.emplace(A++, P, I, O, z, 3);
                                }
                                (!qr || qr.length < 2 * h) && (qr = function(e1) {
                                    var r = 2 * e1, n = new t1.StructArrayLayout3ui6;
                                    n.resize(r), n._trim();
                                    for(var i = 0; i < r; i++){
                                        var a = 6 * i;
                                        n.uint16[a + 0] = 4 * i + 0, n.uint16[a + 1] = 4 * i + 1, n.uint16[a + 2] = 4 * i + 2, n.uint16[a + 3] = 4 * i + 2, n.uint16[a + 4] = 4 * i + 3, n.uint16[a + 5] = 4 * i + 0;
                                    }
                                    return n;
                                }(h));
                                for(var D = l.createIndexBuffer(qr, !0), R = l.createVertexBuffer(k, t1.collisionCircleLayout.members, !0), F = 0, B = f; F < B.length; F += 1){
                                    var N = B[F], j = Pr(N.transform, N.invTransform, e1.transform);
                                    T.draw(l, c.TRIANGLES, At.disabled, Mt.disabled, e1.colorModeForRenderPass(), Et.disabled, j, n.id, R, D, t1.SegmentVector.simpleSegment(0, 2 * N.circleOffset, N.circleArray.length, N.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
                                }
                                R.destroy(), D.destroy();
                            }
                        }
                        var Qr = t1.identity(new Float32Array(16));
                        function $r(e1, r, n, i, a, o) {
                            var s = t1.getAnchorAlignment(e1), l = -(s.horizontalAlign - .5) * r, c = -(s.verticalAlign - .5) * n, u = t1.evaluateVariableOffset(e1, i);
                            return new t1.Point((l / a + u[0]) * o, (c / a + u[1]) * o);
                        }
                        function tn(e1, r, n, i, a, o, s, l, c, u, f) {
                            var h = e1.text.placedSymbolArray, p = e1.text.dynamicLayoutVertexArray, d = e1.icon.dynamicLayoutVertexArray, m = {};
                            p.clear();
                            for(var g = 0; g < h.length; g++){
                                var v = h.get(g), y = e1.allowVerticalPlacement && !v.placedOrientation, x = v.hidden || !v.crossTileID || y ? null : i[v.crossTileID];
                                if (x) {
                                    var b = new t1.Point(v.anchorX, v.anchorY), _ = te(b, n ? l : s), w = ee(o.cameraToCenterDistance, _.signedDistanceFromCamera), T = a.evaluateSizeForFeature(e1.textSizeData, u, v) * w / t1.ONE_EM;
                                    n && (T *= e1.tilePixelRatio / c);
                                    for(var k = x.width, A = x.height, M = $r(x.anchor, k, A, x.textOffset, x.textBoxScale, T), S = n ? te(b.add(M), s).point : _.point.add(r ? M.rotate(-o.angle) : M), E = e1.allowVerticalPlacement && v.placedOrientation === t1.WritingMode.vertical ? Math.PI / 2 : 0, L = 0; L < v.numGlyphs; L++)t1.addDynamicAttributes(p, S, E);
                                    f && v.associatedIconIndex >= 0 && (m[v.associatedIconIndex] = {
                                        shiftedAnchor: S,
                                        angle: E
                                    });
                                } else ue(v.numGlyphs, p);
                            }
                            if (f) {
                                d.clear();
                                for(var C = e1.icon.placedSymbolArray, P = 0; P < C.length; P++){
                                    var I = C.get(P);
                                    if (I.hidden) ue(I.numGlyphs, d);
                                    else {
                                        var O = m[P];
                                        if (O) for(var z = 0; z < I.numGlyphs; z++)t1.addDynamicAttributes(d, O.shiftedAnchor, O.angle);
                                        else ue(I.numGlyphs, d);
                                    }
                                }
                                e1.icon.dynamicLayoutVertexBuffer.updateData(d);
                            }
                            e1.text.dynamicLayoutVertexBuffer.updateData(p);
                        }
                        function en(t1, e1, r) {
                            return r.iconsInText && e1 ? "symbolTextAndIcon" : t1 ? "symbolSDF" : "symbolIcon";
                        }
                        function rn(e1, r, n, i, a, o, s, l, c, u, f, h) {
                            for(var p = e1.context, d = p.gl, m = e1.transform, g = "map" === l, v = "map" === c, y = g && "point" !== n.layout.get("symbol-placement"), x = g && !v && !y, b = void 0 !== n.layout.get("symbol-sort-key").constantOr(1), _ = e1.depthModeForSublayer(0, At.ReadOnly), w = n.layout.get("text-variable-anchor"), T = [], k = 0, A = i; k < A.length; k += 1){
                                var M = A[k], S = r.getTile(M), E = S.getBucket(n);
                                if (E) {
                                    var L = a ? E.text : E.icon;
                                    if (L && L.segments.get().length) {
                                        var C = L.programConfigurations.get(n.id), P = a || E.sdfIcons, I = a ? E.textSizeData : E.iconSizeData, O = v || 0 !== m.pitch, z = e1.useProgram(en(P, a, E), C), D = t1.evaluateSizeForZoom(I, m.zoom), R = void 0, F = [
                                            0,
                                            0
                                        ], B = void 0, N = void 0, j = null, U = void 0;
                                        if (a) {
                                            if (B = S.glyphAtlasTexture, N = d.LINEAR, R = S.glyphAtlasTexture.size, E.iconsInText) {
                                                F = S.imageAtlasTexture.size, j = S.imageAtlasTexture;
                                                var V = "composite" === I.kind || "camera" === I.kind;
                                                U = O || e1.options.rotating || e1.options.zooming || V ? d.LINEAR : d.NEAREST;
                                            }
                                        } else {
                                            var H = 1 !== n.layout.get("icon-size").constantOr(0) || E.iconsNeedLinear;
                                            B = S.imageAtlasTexture, N = P || e1.options.rotating || e1.options.zooming || H || O ? d.LINEAR : d.NEAREST, R = S.imageAtlasTexture.size;
                                        }
                                        var q = pe(S, 1, e1.transform.zoom), G = Qt(M.posMatrix, v, g, e1.transform, q), Y = $t(M.posMatrix, v, g, e1.transform, q), W = w && E.hasTextData(), X = "none" !== n.layout.get("icon-text-fit") && W && E.hasIconData();
                                        y && ne(E, M.posMatrix, e1, a, G, Y, v, u);
                                        var Z = e1.translatePosMatrix(M.posMatrix, S, o, s), J = y || a && w || X ? Qr : G, K = e1.translatePosMatrix(Y, S, o, s, !0), Q = P && 0 !== n.paint.get(a ? "text-halo-width" : "icon-halo-width").constantOr(1), $ = {
                                            program: z,
                                            buffers: L,
                                            uniformValues: P ? E.iconsInText ? Wr(I.kind, D, x, v, e1, Z, J, K, R, F) : Yr(I.kind, D, x, v, e1, Z, J, K, a, R, !0) : Gr(I.kind, D, x, v, e1, Z, J, K, a, R),
                                            atlasTexture: B,
                                            atlasTextureIcon: j,
                                            atlasInterpolation: N,
                                            atlasInterpolationIcon: U,
                                            isSDF: P,
                                            hasHalo: Q
                                        };
                                        if (b) for(var tt = 0, et = L.segments.get(); tt < et.length; tt += 1){
                                            var rt = et[tt];
                                            T.push({
                                                segments: new t1.SegmentVector([
                                                    rt
                                                ]),
                                                sortKey: rt.sortKey,
                                                state: $
                                            });
                                        }
                                        else T.push({
                                            segments: L.segments,
                                            sortKey: 0,
                                            state: $
                                        });
                                    }
                                }
                            }
                            b && T.sort(function(t1, e1) {
                                return t1.sortKey - e1.sortKey;
                            });
                            for(var nt = 0, it = T; nt < it.length; nt += 1){
                                var at = it[nt], ot = at.state;
                                if (p.activeTexture.set(d.TEXTURE0), ot.atlasTexture.bind(ot.atlasInterpolation, d.CLAMP_TO_EDGE), ot.atlasTextureIcon && (p.activeTexture.set(d.TEXTURE1), ot.atlasTextureIcon && ot.atlasTextureIcon.bind(ot.atlasInterpolationIcon, d.CLAMP_TO_EDGE)), ot.isSDF) {
                                    var st = ot.uniformValues;
                                    ot.hasHalo && (st.u_is_halo = 1, nn(ot.buffers, at.segments, n, e1, ot.program, _, f, h, st)), st.u_is_halo = 0;
                                }
                                nn(ot.buffers, at.segments, n, e1, ot.program, _, f, h, ot.uniformValues);
                            }
                        }
                        function nn(t1, e1, r, n, i, a, o, s, l) {
                            var c = n.context, u = c.gl;
                            i.draw(c, u.TRIANGLES, a, o, s, Et.disabled, l, r.id, t1.layoutVertexBuffer, t1.indexBuffer, e1, r.paint, n.transform.zoom, t1.programConfigurations.get(r.id), t1.dynamicLayoutVertexBuffer, t1.opacityVertexBuffer);
                        }
                        function an(t1, e1, r, n, i, a, o) {
                            var s, l, c, u, f, h = t1.context.gl, p = r.paint.get("fill-pattern"), d = p && p.constantOr(1), m = r.getCrossfadeParameters();
                            o ? (l = d && !r.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", s = h.LINES) : (l = d ? "fillPattern" : "fill", s = h.TRIANGLES);
                            for(var g = 0, v = n; g < v.length; g += 1){
                                var y = v[g], x = e1.getTile(y);
                                if (!d || x.patternsLoaded()) {
                                    var b = x.getBucket(r);
                                    if (b) {
                                        var _ = b.programConfigurations.get(r.id), w = t1.useProgram(l, _);
                                        d && (t1.context.activeTexture.set(h.TEXTURE0), x.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), _.updatePaintBuffers(m));
                                        var T = p.constantOr(null);
                                        if (T && x.imageAtlas) {
                                            var k = x.imageAtlas, A = k.patternPositions[T.to.toString()], M = k.patternPositions[T.from.toString()];
                                            A && M && _.setConstantPatternPositions(A, M);
                                        }
                                        var S = t1.translatePosMatrix(y.posMatrix, x, r.paint.get("fill-translate"), r.paint.get("fill-translate-anchor"));
                                        if (o) {
                                            u = b.indexBuffer2, f = b.segments2;
                                            var E = [
                                                h.drawingBufferWidth,
                                                h.drawingBufferHeight
                                            ];
                                            c = "fillOutlinePattern" === l && d ? Er(S, t1, m, x, E) : Sr(S, E);
                                        } else u = b.indexBuffer, f = b.segments, c = d ? Mr(S, t1, m, x) : Ar(S);
                                        w.draw(t1.context, s, i, t1.stencilModeForClipping(y), a, Et.disabled, c, r.id, b.layoutVertexBuffer, u, f, r.paint, t1.transform.zoom, _);
                                    }
                                }
                            }
                        }
                        function on(t1, e1, r, n, i, a, o) {
                            for(var s = t1.context, l = s.gl, c = r.paint.get("fill-extrusion-pattern"), u = c.constantOr(1), f = r.getCrossfadeParameters(), h = r.paint.get("fill-extrusion-opacity"), p = 0, d = n; p < d.length; p += 1){
                                var m = d[p], g = e1.getTile(m), v = g.getBucket(r);
                                if (v) {
                                    var y = v.programConfigurations.get(r.id), x = t1.useProgram(u ? "fillExtrusionPattern" : "fillExtrusion", y);
                                    u && (t1.context.activeTexture.set(l.TEXTURE0), g.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), y.updatePaintBuffers(f));
                                    var b = c.constantOr(null);
                                    if (b && g.imageAtlas) {
                                        var _ = g.imageAtlas, w = _.patternPositions[b.to.toString()], T = _.patternPositions[b.from.toString()];
                                        w && T && y.setConstantPatternPositions(w, T);
                                    }
                                    var k = t1.translatePosMatrix(m.posMatrix, g, r.paint.get("fill-extrusion-translate"), r.paint.get("fill-extrusion-translate-anchor")), A = r.paint.get("fill-extrusion-vertical-gradient"), M = u ? kr(k, t1, A, h, m, f, g) : Tr(k, t1, A, h);
                                    x.draw(s, s.gl.TRIANGLES, i, a, o, Et.backCCW, M, r.id, v.layoutVertexBuffer, v.indexBuffer, v.segments, r.paint, t1.transform.zoom, y);
                                }
                            }
                        }
                        function sn(t1, e1, r, n, i, a) {
                            var o = t1.context, s = o.gl, l = e1.fbo;
                            if (l) {
                                var c = t1.useProgram("hillshade");
                                o.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, l.colorAttachment.get());
                                var u = function(t1, e1, r) {
                                    var n = r.paint.get("hillshade-shadow-color"), i = r.paint.get("hillshade-highlight-color"), a = r.paint.get("hillshade-accent-color"), o = r.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                                    "viewport" === r.paint.get("hillshade-illumination-anchor") && (o -= t1.transform.angle);
                                    var s = !t1.options.moving;
                                    return {
                                        u_matrix: t1.transform.calculatePosMatrix(e1.tileID.toUnwrapped(), s),
                                        u_image: 0,
                                        u_latrange: Dr(t1, e1.tileID),
                                        u_light: [
                                            r.paint.get("hillshade-exaggeration"),
                                            o
                                        ],
                                        u_shadow: n,
                                        u_highlight: i,
                                        u_accent: a
                                    };
                                }(t1, e1, r);
                                c.draw(o, s.TRIANGLES, n, i, a, Et.disabled, u, r.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments);
                            }
                        }
                        function ln(e1, r, n, i, a, o, s) {
                            var l = e1.context, c = l.gl, u = r.dem;
                            if (u && u.data) {
                                var f = u.dim, h = u.stride, p = u.getPixels();
                                if (l.activeTexture.set(c.TEXTURE1), l.pixelStoreUnpackPremultiplyAlpha.set(!1), r.demTexture = r.demTexture || e1.getTileTexture(h), r.demTexture) {
                                    var d = r.demTexture;
                                    d.update(p, {
                                        premultiply: !1
                                    }), d.bind(c.NEAREST, c.CLAMP_TO_EDGE);
                                } else r.demTexture = new t1.Texture(l, p, c.RGBA, {
                                    premultiply: !1
                                }), r.demTexture.bind(c.NEAREST, c.CLAMP_TO_EDGE);
                                l.activeTexture.set(c.TEXTURE0);
                                var m = r.fbo;
                                if (!m) {
                                    var g = new t1.Texture(l, {
                                        width: f,
                                        height: f,
                                        data: null
                                    }, c.RGBA);
                                    g.bind(c.LINEAR, c.CLAMP_TO_EDGE), (m = r.fbo = l.createFramebuffer(f, f, !0)).colorAttachment.set(g.texture);
                                }
                                l.bindFramebuffer.set(m.framebuffer), l.viewport.set([
                                    0,
                                    0,
                                    f,
                                    f
                                ]), e1.useProgram("hillshadePrepare").draw(l, c.TRIANGLES, a, o, s, Et.disabled, function(e1, r, n) {
                                    var i = r.stride, a = t1.create();
                                    return t1.ortho(a, 0, t1.EXTENT, -t1.EXTENT, 0, 0, 1), t1.translate(a, a, [
                                        0,
                                        -t1.EXTENT,
                                        0
                                    ]), {
                                        u_matrix: a,
                                        u_image: 1,
                                        u_dimension: [
                                            i,
                                            i
                                        ],
                                        u_zoom: e1.overscaledZ,
                                        u_maxzoom: n,
                                        u_unpack: r.getUnpackVector()
                                    };
                                }(r.tileID, u, i), n.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), r.needsHillshadePrepare = !1;
                            }
                        }
                        function cn(e1, r, n, i, a) {
                            var o = i.paint.get("raster-fade-duration");
                            if (o > 0) {
                                var s = t1.browser.now(), l = (s - e1.timeAdded) / o, c = r ? (s - r.timeAdded) / o : -1, u = n.getSource(), f = a.coveringZoomLevel({
                                    tileSize: u.tileSize,
                                    roundZoom: u.roundZoom
                                }), h = !r || Math.abs(r.tileID.overscaledZ - f) > Math.abs(e1.tileID.overscaledZ - f), p = h && e1.refreshedUponExpiration ? 1 : t1.clamp(h ? l : 1 - c, 0, 1);
                                return e1.refreshedUponExpiration && l >= 1 && (e1.refreshedUponExpiration = !1), r ? {
                                    opacity: 1,
                                    mix: 1 - p
                                } : {
                                    opacity: p,
                                    mix: 0
                                };
                            }
                            return {
                                opacity: 1,
                                mix: 0
                            };
                        }
                        var un = new t1.Color(1, 0, 0, 1), fn = new t1.Color(0, 1, 0, 1), hn = new t1.Color(0, 0, 1, 1), pn = new t1.Color(1, 0, 1, 1), dn = new t1.Color(0, 1, 1, 1);
                        function mn(t1) {
                            var e1 = t1.transform.padding;
                            gn(t1, t1.transform.height - (e1.top || 0), 3, un), gn(t1, e1.bottom || 0, 3, fn), vn(t1, e1.left || 0, 3, hn), vn(t1, t1.transform.width - (e1.right || 0), 3, pn);
                            var r = t1.transform.centerPoint;
                            !function(t1, e1, r, n) {
                                yn(t1, e1 - 1, r - 10, 2, 20, n), yn(t1, e1 - 10, r - 1, 20, 2, n);
                            }(t1, r.x, t1.transform.height - r.y, dn);
                        }
                        function gn(t1, e1, r, n) {
                            yn(t1, 0, e1 + r / 2, t1.transform.width, r, n);
                        }
                        function vn(t1, e1, r, n) {
                            yn(t1, e1 - r / 2, 0, r, t1.transform.height, n);
                        }
                        function yn(e1, r, n, i, a, o) {
                            var s = e1.context, l = s.gl;
                            l.enable(l.SCISSOR_TEST), l.scissor(r * t1.browser.devicePixelRatio, n * t1.browser.devicePixelRatio, i * t1.browser.devicePixelRatio, a * t1.browser.devicePixelRatio), s.clear({
                                color: o
                            }), l.disable(l.SCISSOR_TEST);
                        }
                        function xn(e1, r, n) {
                            var i = e1.context, a = i.gl, o = n.posMatrix, s = e1.useProgram("debug"), l = At.disabled, c = Mt.disabled, u = e1.colorModeForRenderPass();
                            i.activeTexture.set(a.TEXTURE0), e1.emptyTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), s.draw(i, a.LINE_STRIP, l, c, u, Et.disabled, Ir(o, t1.Color.red), "$debug", e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
                            var f = r.getTileByID(n.key).latestRawTileData, h = f && f.byteLength || 0, p = Math.floor(h / 1024), d = r.getTile(n).tileSize, m = 512 / Math.min(d, 512) * (n.overscaledZ / e1.transform.zoom) * .5, g = n.canonical.toString();
                            n.overscaledZ !== n.canonical.z && (g += " => " + n.overscaledZ), function(t1, e1) {
                                t1.initDebugOverlayCanvas();
                                var r = t1.debugOverlayCanvas, n = t1.context.gl, i = t1.debugOverlayCanvas.getContext("2d");
                                i.clearRect(0, 0, r.width, r.height), i.shadowColor = "white", i.shadowBlur = 2, i.lineWidth = 1.5, i.strokeStyle = "white", i.textBaseline = "top", i.font = "bold 36px Open Sans, sans-serif", i.fillText(e1, 5, 5), i.strokeText(e1, 5, 5), t1.debugOverlayTexture.update(r), t1.debugOverlayTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                            }(e1, g + " " + p + "kb"), s.draw(i, a.TRIANGLES, l, c, St.alphaBlended, Et.disabled, Ir(o, t1.Color.transparent, m), "$debug", e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments);
                        }
                        var bn = {
                            symbol: function(e1, r, n, i, a) {
                                if ("translucent" === e1.renderPass) {
                                    var o = Mt.disabled, s = e1.colorModeForRenderPass();
                                    n.layout.get("text-variable-anchor") && function(e1, r, n, i, a, o, s) {
                                        for(var l = r.transform, c = "map" === a, u = "map" === o, f = 0, h = e1; f < h.length; f += 1){
                                            var p = h[f], d = i.getTile(p), m = d.getBucket(n);
                                            if (m && m.text && m.text.segments.get().length) {
                                                var g = m.textSizeData, v = t1.evaluateSizeForZoom(g, l.zoom), y = pe(d, 1, r.transform.zoom), x = Qt(p.posMatrix, u, c, r.transform, y), b = "none" !== n.layout.get("icon-text-fit") && m.hasIconData();
                                                if (v) {
                                                    var _ = Math.pow(2, l.zoom - d.tileID.overscaledZ);
                                                    tn(m, c, u, s, t1.symbolSize, l, x, p.posMatrix, _, v, b);
                                                }
                                            }
                                        }
                                    }(i, e1, n, r, n.layout.get("text-rotation-alignment"), n.layout.get("text-pitch-alignment"), a), 0 !== n.paint.get("icon-opacity").constantOr(1) && rn(e1, r, n, i, !1, n.paint.get("icon-translate"), n.paint.get("icon-translate-anchor"), n.layout.get("icon-rotation-alignment"), n.layout.get("icon-pitch-alignment"), n.layout.get("icon-keep-upright"), o, s), 0 !== n.paint.get("text-opacity").constantOr(1) && rn(e1, r, n, i, !0, n.paint.get("text-translate"), n.paint.get("text-translate-anchor"), n.layout.get("text-rotation-alignment"), n.layout.get("text-pitch-alignment"), n.layout.get("text-keep-upright"), o, s), r.map.showCollisionBoxes && (Kr(e1, r, n, i, n.paint.get("text-translate"), n.paint.get("text-translate-anchor"), !0), Kr(e1, r, n, i, n.paint.get("icon-translate"), n.paint.get("icon-translate-anchor"), !1));
                                }
                            },
                            circle: function(e1, r, n, i) {
                                if ("translucent" === e1.renderPass) {
                                    var a = n.paint.get("circle-opacity"), o = n.paint.get("circle-stroke-width"), s = n.paint.get("circle-stroke-opacity"), l = void 0 !== n.layout.get("circle-sort-key").constantOr(1);
                                    if (0 !== a.constantOr(1) || 0 !== o.constantOr(1) && 0 !== s.constantOr(1)) {
                                        for(var c = e1.context, u = c.gl, f = e1.depthModeForSublayer(0, At.ReadOnly), h = Mt.disabled, p = e1.colorModeForRenderPass(), d = [], m = 0; m < i.length; m++){
                                            var g = i[m], v = r.getTile(g), y = v.getBucket(n);
                                            if (y) {
                                                var x = y.programConfigurations.get(n.id), b = {
                                                    programConfiguration: x,
                                                    program: e1.useProgram("circle", x),
                                                    layoutVertexBuffer: y.layoutVertexBuffer,
                                                    indexBuffer: y.indexBuffer,
                                                    uniformValues: Lr(e1, g, v, n)
                                                };
                                                if (l) for(var _ = 0, w = y.segments.get(); _ < w.length; _ += 1){
                                                    var T = w[_];
                                                    d.push({
                                                        segments: new t1.SegmentVector([
                                                            T
                                                        ]),
                                                        sortKey: T.sortKey,
                                                        state: b
                                                    });
                                                }
                                                else d.push({
                                                    segments: y.segments,
                                                    sortKey: 0,
                                                    state: b
                                                });
                                            }
                                        }
                                        l && d.sort(function(t1, e1) {
                                            return t1.sortKey - e1.sortKey;
                                        });
                                        for(var k = 0, A = d; k < A.length; k += 1){
                                            var M = A[k], S = M.state, E = S.programConfiguration, L = S.program, C = S.layoutVertexBuffer, P = S.indexBuffer, I = S.uniformValues, O = M.segments;
                                            L.draw(c, u.TRIANGLES, f, h, p, Et.disabled, I, n.id, C, P, O, n.paint, e1.transform.zoom, E);
                                        }
                                    }
                                }
                            },
                            heatmap: function(e1, r, n, i) {
                                if (0 !== n.paint.get("heatmap-opacity")) {
                                    if ("offscreen" === e1.renderPass) {
                                        var a = e1.context, o = a.gl, s = Mt.disabled, l = new St([
                                            o.ONE,
                                            o.ONE
                                        ], t1.Color.transparent, [
                                            !0,
                                            !0,
                                            !0,
                                            !0
                                        ]);
                                        !function(t1, e1, r) {
                                            var n = t1.gl;
                                            t1.activeTexture.set(n.TEXTURE1), t1.viewport.set([
                                                0,
                                                0,
                                                e1.width / 4,
                                                e1.height / 4
                                            ]);
                                            var i = r.heatmapFbo;
                                            if (i) n.bindTexture(n.TEXTURE_2D, i.colorAttachment.get()), t1.bindFramebuffer.set(i.framebuffer);
                                            else {
                                                var a = n.createTexture();
                                                n.bindTexture(n.TEXTURE_2D, a), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.LINEAR), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.LINEAR), i = r.heatmapFbo = t1.createFramebuffer(e1.width / 4, e1.height / 4, !1), function(t1, e1, r, n) {
                                                    var i = t1.gl, a = t1.extRenderToTextureHalfFloat ? t1.extTextureHalfFloat.HALF_FLOAT_OES : i.UNSIGNED_BYTE;
                                                    i.texImage2D(i.TEXTURE_2D, 0, i.RGBA, e1.width / 4, e1.height / 4, 0, i.RGBA, a, null), n.colorAttachment.set(r);
                                                }(t1, e1, a, i);
                                            }
                                        }(a, e1, n), a.clear({
                                            color: t1.Color.transparent
                                        });
                                        for(var c = 0; c < i.length; c++){
                                            var u = i[c];
                                            if (!r.hasRenderableParent(u)) {
                                                var f = r.getTile(u), h = f.getBucket(n);
                                                if (h) {
                                                    var p = h.programConfigurations.get(n.id), d = e1.useProgram("heatmap", p), m = e1.transform.zoom;
                                                    d.draw(a, o.TRIANGLES, At.disabled, s, l, Et.disabled, zr(u.posMatrix, f, m, n.paint.get("heatmap-intensity")), n.id, h.layoutVertexBuffer, h.indexBuffer, h.segments, n.paint, e1.transform.zoom, p);
                                                }
                                            }
                                        }
                                        a.viewport.set([
                                            0,
                                            0,
                                            e1.width,
                                            e1.height
                                        ]);
                                    } else "translucent" === e1.renderPass && (e1.context.setColorMode(e1.colorModeForRenderPass()), function(e1, r) {
                                        var n = e1.context, i = n.gl, a = r.heatmapFbo;
                                        if (!a) return;
                                        n.activeTexture.set(i.TEXTURE0), i.bindTexture(i.TEXTURE_2D, a.colorAttachment.get()), n.activeTexture.set(i.TEXTURE1);
                                        var o = r.colorRampTexture;
                                        o || (o = r.colorRampTexture = new t1.Texture(n, r.colorRamp, i.RGBA));
                                        o.bind(i.LINEAR, i.CLAMP_TO_EDGE), e1.useProgram("heatmapTexture").draw(n, i.TRIANGLES, At.disabled, Mt.disabled, e1.colorModeForRenderPass(), Et.disabled, function(e1, r, n, i) {
                                            var a = t1.create();
                                            t1.ortho(a, 0, e1.width, e1.height, 0, 0, 1);
                                            var o = e1.context.gl;
                                            return {
                                                u_matrix: a,
                                                u_world: [
                                                    o.drawingBufferWidth,
                                                    o.drawingBufferHeight
                                                ],
                                                u_image: n,
                                                u_color_ramp: i,
                                                u_opacity: r.paint.get("heatmap-opacity")
                                            };
                                        }(e1, r, 0, 1), r.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, r.paint, e1.transform.zoom);
                                    }(e1, n));
                                }
                            },
                            line: function(e1, r, n, i) {
                                if ("translucent" === e1.renderPass) {
                                    var a = n.paint.get("line-opacity"), o = n.paint.get("line-width");
                                    if (0 !== a.constantOr(1) && 0 !== o.constantOr(1)) {
                                        var s = e1.depthModeForSublayer(0, At.ReadOnly), l = e1.colorModeForRenderPass(), c = n.paint.get("line-dasharray"), u = n.paint.get("line-pattern"), f = u.constantOr(1), h = n.paint.get("line-gradient"), p = n.getCrossfadeParameters(), d = f ? "linePattern" : c ? "lineSDF" : h ? "lineGradient" : "line", m = e1.context, g = m.gl, v = !0;
                                        if (h) {
                                            m.activeTexture.set(g.TEXTURE0);
                                            var y = n.gradientTexture;
                                            if (!n.gradient) return;
                                            y || (y = n.gradientTexture = new t1.Texture(m, n.gradient, g.RGBA)), y.bind(g.LINEAR, g.CLAMP_TO_EDGE);
                                        }
                                        for(var x = 0, b = i; x < b.length; x += 1){
                                            var _ = b[x], w = r.getTile(_);
                                            if (!f || w.patternsLoaded()) {
                                                var T = w.getBucket(n);
                                                if (T) {
                                                    var k = T.programConfigurations.get(n.id), A = e1.context.program.get(), M = e1.useProgram(d, k), S = v || M.program !== A, E = u.constantOr(null);
                                                    if (E && w.imageAtlas) {
                                                        var L = w.imageAtlas, C = L.patternPositions[E.to.toString()], P = L.patternPositions[E.from.toString()];
                                                        C && P && k.setConstantPatternPositions(C, P);
                                                    }
                                                    var I = f ? Br(e1, w, n, p) : c ? Nr(e1, w, n, c, p) : h ? Fr(e1, w, n) : Rr(e1, w, n);
                                                    f ? (m.activeTexture.set(g.TEXTURE0), w.imageAtlasTexture.bind(g.LINEAR, g.CLAMP_TO_EDGE), k.updatePaintBuffers(p)) : c && (S || e1.lineAtlas.dirty) && (m.activeTexture.set(g.TEXTURE0), e1.lineAtlas.bind(m)), M.draw(m, g.TRIANGLES, s, e1.stencilModeForClipping(_), l, Et.disabled, I, n.id, T.layoutVertexBuffer, T.indexBuffer, T.segments, n.paint, e1.transform.zoom, k), v = !1;
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            fill: function(e1, r, n, i) {
                                var a = n.paint.get("fill-color"), o = n.paint.get("fill-opacity");
                                if (0 !== o.constantOr(1)) {
                                    var s = e1.colorModeForRenderPass(), l = n.paint.get("fill-pattern"), c = e1.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === a.constantOr(t1.Color.transparent).a && 1 === o.constantOr(0) ? "opaque" : "translucent";
                                    if (e1.renderPass === c) {
                                        var u = e1.depthModeForSublayer(1, "opaque" === e1.renderPass ? At.ReadWrite : At.ReadOnly);
                                        an(e1, r, n, i, u, s, !1);
                                    }
                                    if ("translucent" === e1.renderPass && n.paint.get("fill-antialias")) {
                                        var f = e1.depthModeForSublayer(n.getPaintProperty("fill-outline-color") ? 2 : 0, At.ReadOnly);
                                        an(e1, r, n, i, f, s, !0);
                                    }
                                }
                            },
                            "fill-extrusion": function(t1, e1, r, n) {
                                var i = r.paint.get("fill-extrusion-opacity");
                                if (0 !== i && "translucent" === t1.renderPass) {
                                    var a = new At(t1.context.gl.LEQUAL, At.ReadWrite, t1.depthRangeFor3D);
                                    if (1 !== i || r.paint.get("fill-extrusion-pattern").constantOr(1)) on(t1, e1, r, n, a, Mt.disabled, St.disabled), on(t1, e1, r, n, a, t1.stencilModeFor3D(), t1.colorModeForRenderPass());
                                    else {
                                        var o = t1.colorModeForRenderPass();
                                        on(t1, e1, r, n, a, Mt.disabled, o);
                                    }
                                }
                            },
                            hillshade: function(t1, e1, r, n) {
                                if ("offscreen" === t1.renderPass || "translucent" === t1.renderPass) {
                                    for(var i = t1.context, a = e1.getSource().maxzoom, o = t1.depthModeForSublayer(0, At.ReadOnly), s = t1.colorModeForRenderPass(), l = "translucent" === t1.renderPass ? t1.stencilConfigForOverlap(n) : [
                                        {},
                                        n
                                    ], c = l[0], u = 0, f = l[1]; u < f.length; u += 1){
                                        var h = f[u], p = e1.getTile(h);
                                        p.needsHillshadePrepare && "offscreen" === t1.renderPass ? ln(t1, p, r, a, o, Mt.disabled, s) : "translucent" === t1.renderPass && sn(t1, p, r, o, c[h.overscaledZ], s);
                                    }
                                    i.viewport.set([
                                        0,
                                        0,
                                        t1.width,
                                        t1.height
                                    ]);
                                }
                            },
                            raster: function(t1, e1, r, n) {
                                if ("translucent" === t1.renderPass && 0 !== r.paint.get("raster-opacity") && n.length) for(var i = t1.context, a = i.gl, o = e1.getSource(), s = t1.useProgram("raster"), l = t1.colorModeForRenderPass(), c = o instanceof I ? [
                                    {},
                                    n
                                ] : t1.stencilConfigForOverlap(n), u = c[0], f = c[1], h = f[f.length - 1].overscaledZ, p = !t1.options.moving, d = 0, m = f; d < m.length; d += 1){
                                    var g = m[d], v = t1.depthModeForSublayer(g.overscaledZ - h, 1 === r.paint.get("raster-opacity") ? At.ReadWrite : At.ReadOnly, a.LESS), y = e1.getTile(g), x = t1.transform.calculatePosMatrix(g.toUnwrapped(), p);
                                    y.registerFadeDuration(r.paint.get("raster-fade-duration"));
                                    var b = e1.findLoadedParent(g, 0), _ = cn(y, b, e1, r, t1.transform), w = void 0, T = void 0, k = "nearest" === r.paint.get("raster-resampling") ? a.NEAREST : a.LINEAR;
                                    i.activeTexture.set(a.TEXTURE0), y.texture.bind(k, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), i.activeTexture.set(a.TEXTURE1), b ? (b.texture.bind(k, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST), w = Math.pow(2, b.tileID.overscaledZ - y.tileID.overscaledZ), T = [
                                        y.tileID.canonical.x * w % 1,
                                        y.tileID.canonical.y * w % 1
                                    ]) : y.texture.bind(k, a.CLAMP_TO_EDGE, a.LINEAR_MIPMAP_NEAREST);
                                    var A = Vr(x, T || [
                                        0,
                                        0
                                    ], w || 1, _, r);
                                    o instanceof I ? s.draw(i, a.TRIANGLES, v, Mt.disabled, l, Et.disabled, A, r.id, o.boundsBuffer, t1.quadTriangleIndexBuffer, o.boundsSegments) : s.draw(i, a.TRIANGLES, v, u[g.overscaledZ], l, Et.disabled, A, r.id, t1.rasterBoundsBuffer, t1.quadTriangleIndexBuffer, t1.rasterBoundsSegments);
                                }
                            },
                            background: function(t1, e1, r) {
                                var n = r.paint.get("background-color"), i = r.paint.get("background-opacity");
                                if (0 !== i) {
                                    var a = t1.context, o = a.gl, s = t1.transform, l = s.tileSize, c = r.paint.get("background-pattern");
                                    if (!t1.isPatternMissing(c)) {
                                        var u = !c && 1 === n.a && 1 === i && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                                        if (t1.renderPass === u) {
                                            var f = Mt.disabled, h = t1.depthModeForSublayer(0, "opaque" === u ? At.ReadWrite : At.ReadOnly), p = t1.colorModeForRenderPass(), d = t1.useProgram(c ? "backgroundPattern" : "background"), m = s.coveringTiles({
                                                tileSize: l
                                            });
                                            c && (a.activeTexture.set(o.TEXTURE0), t1.imageManager.bind(t1.context));
                                            for(var g = r.getCrossfadeParameters(), v = 0, y = m; v < y.length; v += 1){
                                                var x = y[v], b = t1.transform.calculatePosMatrix(x.toUnwrapped()), _ = c ? Zr(b, i, t1, c, {
                                                    tileID: x,
                                                    tileSize: l
                                                }, g) : Xr(b, i, n);
                                                d.draw(a, o.TRIANGLES, h, f, p, Et.disabled, _, r.id, t1.tileExtentBuffer, t1.quadTriangleIndexBuffer, t1.tileExtentSegments);
                                            }
                                        }
                                    }
                                }
                            },
                            debug: function(t1, e1, r) {
                                for(var n = 0; n < r.length; n++)xn(t1, e1, r[n]);
                            },
                            custom: function(t1, e1, r) {
                                var n = t1.context, i = r.implementation;
                                if ("offscreen" === t1.renderPass) {
                                    var a = i.prerender;
                                    a && (t1.setCustomLayerDefaults(), n.setColorMode(t1.colorModeForRenderPass()), a.call(i, n.gl, t1.transform.customLayerMatrix()), n.setDirty(), t1.setBaseState());
                                } else if ("translucent" === t1.renderPass) {
                                    t1.setCustomLayerDefaults(), n.setColorMode(t1.colorModeForRenderPass()), n.setStencilMode(Mt.disabled);
                                    var o = "3d" === i.renderingMode ? new At(t1.context.gl.LEQUAL, At.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, At.ReadOnly);
                                    n.setDepthMode(o), i.render(n.gl, t1.transform.customLayerMatrix()), n.setDirty(), t1.setBaseState(), n.bindFramebuffer.set(null);
                                }
                            }
                        }, _n = function(t1, e1) {
                            this.context = new Lt(t1), this.transform = e1, this._tileTextures = {}, this.setup(), this.numSublayers = Ct.maxUnderzooming + Ct.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Ne, this.gpuTimers = {};
                        };
                        _n.prototype.resize = function(e1, r) {
                            if (this.width = e1 * t1.browser.devicePixelRatio, this.height = r * t1.browser.devicePixelRatio, this.context.viewport.set([
                                0,
                                0,
                                this.width,
                                this.height
                            ]), this.style) for(var n = 0, i = this.style._order; n < i.length; n += 1){
                                var a = i[n];
                                this.style._layers[a].resize();
                            }
                        }, _n.prototype.setup = function() {
                            var e1 = this.context, r = new t1.StructArrayLayout2i4;
                            r.emplaceBack(0, 0), r.emplaceBack(t1.EXTENT, 0), r.emplaceBack(0, t1.EXTENT), r.emplaceBack(t1.EXTENT, t1.EXTENT), this.tileExtentBuffer = e1.createVertexBuffer(r, Ge.members), this.tileExtentSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
                            var n = new t1.StructArrayLayout2i4;
                            n.emplaceBack(0, 0), n.emplaceBack(t1.EXTENT, 0), n.emplaceBack(0, t1.EXTENT), n.emplaceBack(t1.EXTENT, t1.EXTENT), this.debugBuffer = e1.createVertexBuffer(n, Ge.members), this.debugSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 5);
                            var i = new t1.StructArrayLayout4i8;
                            i.emplaceBack(0, 0, 0, 0), i.emplaceBack(t1.EXTENT, 0, t1.EXTENT, 0), i.emplaceBack(0, t1.EXTENT, 0, t1.EXTENT), i.emplaceBack(t1.EXTENT, t1.EXTENT, t1.EXTENT, t1.EXTENT), this.rasterBoundsBuffer = e1.createVertexBuffer(i, P.members), this.rasterBoundsSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
                            var a = new t1.StructArrayLayout2i4;
                            a.emplaceBack(0, 0), a.emplaceBack(1, 0), a.emplaceBack(0, 1), a.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(a, Ge.members), this.viewportSegments = t1.SegmentVector.simpleSegment(0, 0, 4, 2);
                            var o = new t1.StructArrayLayout1ui2;
                            o.emplaceBack(0), o.emplaceBack(1), o.emplaceBack(3), o.emplaceBack(2), o.emplaceBack(0), this.tileBorderIndexBuffer = e1.createIndexBuffer(o);
                            var s = new t1.StructArrayLayout3ui6;
                            s.emplaceBack(0, 1, 2), s.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(s), this.emptyTexture = new t1.Texture(e1, {
                                width: 1,
                                height: 1,
                                data: new Uint8Array([
                                    0,
                                    0,
                                    0,
                                    0
                                ])
                            }, e1.gl.RGBA);
                            var l = this.context.gl;
                            this.stencilClearMode = new Mt({
                                func: l.ALWAYS,
                                mask: 0
                            }, 0, 255, l.ZERO, l.ZERO, l.ZERO);
                        }, _n.prototype.clearStencil = function() {
                            var e1 = this.context, r = e1.gl;
                            this.nextStencilID = 1, this.currentStencilSource = void 0;
                            var n = t1.create();
                            t1.ortho(n, 0, this.width, this.height, 0, 0, 1), t1.scale(n, n, [
                                r.drawingBufferWidth,
                                r.drawingBufferHeight,
                                0
                            ]), this.useProgram("clippingMask").draw(e1, r.TRIANGLES, At.disabled, this.stencilClearMode, St.disabled, Et.disabled, Or(n), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
                        }, _n.prototype._renderTileClippingMasks = function(t1, e1) {
                            if (this.currentStencilSource !== t1.source && t1.isTileClipped() && e1 && e1.length) {
                                this.currentStencilSource = t1.source;
                                var r = this.context, n = r.gl;
                                this.nextStencilID + e1.length > 256 && this.clearStencil(), r.setColorMode(St.disabled), r.setDepthMode(At.disabled);
                                var i = this.useProgram("clippingMask");
                                this._tileClippingMaskIDs = {};
                                for(var a = 0, o = e1; a < o.length; a += 1){
                                    var s = o[a], l = this._tileClippingMaskIDs[s.key] = this.nextStencilID++;
                                    i.draw(r, n.TRIANGLES, At.disabled, new Mt({
                                        func: n.ALWAYS,
                                        mask: 0
                                    }, l, 255, n.KEEP, n.KEEP, n.REPLACE), St.disabled, Et.disabled, Or(s.posMatrix), "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                                }
                            }
                        }, _n.prototype.stencilModeFor3D = function() {
                            this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                            var t1 = this.nextStencilID++, e1 = this.context.gl;
                            return new Mt({
                                func: e1.NOTEQUAL,
                                mask: 255
                            }, t1, 255, e1.KEEP, e1.KEEP, e1.REPLACE);
                        }, _n.prototype.stencilModeForClipping = function(t1) {
                            var e1 = this.context.gl;
                            return new Mt({
                                func: e1.EQUAL,
                                mask: 255
                            }, this._tileClippingMaskIDs[t1.key], 0, e1.KEEP, e1.KEEP, e1.REPLACE);
                        }, _n.prototype.stencilConfigForOverlap = function(t1) {
                            var e1, r = this.context.gl, n = t1.sort(function(t1, e1) {
                                return e1.overscaledZ - t1.overscaledZ;
                            }), i = n[n.length - 1].overscaledZ, a = n[0].overscaledZ - i + 1;
                            if (a > 1) {
                                this.currentStencilSource = void 0, this.nextStencilID + a > 256 && this.clearStencil();
                                for(var o = {}, s = 0; s < a; s++)o[s + i] = new Mt({
                                    func: r.GEQUAL,
                                    mask: 255
                                }, s + this.nextStencilID, 255, r.KEEP, r.KEEP, r.REPLACE);
                                return this.nextStencilID += a, [
                                    o,
                                    n
                                ];
                            }
                            return [
                                (e1 = {}, e1[i] = Mt.disabled, e1),
                                n
                            ];
                        }, _n.prototype.colorModeForRenderPass = function() {
                            var e1 = this.context.gl;
                            if (this._showOverdrawInspector) return new St([
                                e1.CONSTANT_COLOR,
                                e1.ONE
                            ], new t1.Color(1 / 8, 1 / 8, 1 / 8, 0), [
                                !0,
                                !0,
                                !0,
                                !0
                            ]);
                            return "opaque" === this.renderPass ? St.unblended : St.alphaBlended;
                        }, _n.prototype.depthModeForSublayer = function(t1, e1, r) {
                            if (!this.opaquePassEnabledForLayer()) return At.disabled;
                            var n = 1 - ((1 + this.currentLayer) * this.numSublayers + t1) * this.depthEpsilon;
                            return new At(r || this.context.gl.LEQUAL, e1, [
                                n,
                                n
                            ]);
                        }, _n.prototype.opaquePassEnabledForLayer = function() {
                            return this.currentLayer < this.opaquePassCutoff;
                        }, _n.prototype.render = function(e1, r) {
                            var n = this;
                            this.style = e1, this.options = r, this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange(t1.browser.now()), this.imageManager.beginFrame();
                            var i = this.style._order, a = this.style.sourceCaches;
                            for(var o in a){
                                var s = a[o];
                                s.used && s.prepare(this.context);
                            }
                            var l, c, u = {}, f = {}, h = {};
                            for(var p in a){
                                var d = a[p];
                                u[p] = d.getVisibleCoordinates(), f[p] = u[p].slice().reverse(), h[p] = d.getVisibleCoordinates(!0).reverse();
                            }
                            this.opaquePassCutoff = 1 / 0;
                            for(var m = 0; m < i.length; m++){
                                var g = i[m];
                                if (this.style._layers[g].is3D()) {
                                    this.opaquePassCutoff = m;
                                    break;
                                }
                            }
                            this.renderPass = "offscreen";
                            for(var v = 0, y = i; v < y.length; v += 1){
                                var x = y[v], b = this.style._layers[x];
                                if (b.hasOffscreenPass() && !b.isHidden(this.transform.zoom)) {
                                    var _ = f[b.source];
                                    ("custom" === b.type || _.length) && this.renderLayer(this, a[b.source], b, _);
                                }
                            }
                            for(this.context.bindFramebuffer.set(null), this.context.clear({
                                color: r.showOverdrawInspector ? t1.Color.black : t1.Color.transparent,
                                depth: 1
                            }), this.clearStencil(), this._showOverdrawInspector = r.showOverdrawInspector, this.depthRangeFor3D = [
                                0,
                                1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
                            ], this.renderPass = "opaque", this.currentLayer = i.length - 1; this.currentLayer >= 0; this.currentLayer--){
                                var w = this.style._layers[i[this.currentLayer]], T = a[w.source], k = u[w.source];
                                this._renderTileClippingMasks(w, k), this.renderLayer(this, T, w, k);
                            }
                            for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < i.length; this.currentLayer++){
                                var A = this.style._layers[i[this.currentLayer]], M = a[A.source], S = ("symbol" === A.type ? h : f)[A.source];
                                this._renderTileClippingMasks(A, u[A.source]), this.renderLayer(this, M, A, S);
                            }
                            this.options.showTileBoundaries && (t1.values(this.style._layers).forEach(function(t1) {
                                t1.source && !t1.isHidden(n.transform.zoom) && (t1.source !== (c && c.id) && (c = n.style.sourceCaches[t1.source]), (!l || l.getSource().maxzoom < c.getSource().maxzoom) && (l = c));
                            }), l && bn.debug(this, l, l.getVisibleCoordinates()));
                            this.options.showPadding && mn(this), this.context.setDefault();
                        }, _n.prototype.renderLayer = function(t1, e1, r, n) {
                            r.isHidden(this.transform.zoom) || ("background" === r.type || "custom" === r.type || n.length) && (this.id = r.id, this.gpuTimingStart(r), bn[r.type](t1, e1, r, n, this.style.placement.variableOffsets), this.gpuTimingEnd());
                        }, _n.prototype.gpuTimingStart = function(t1) {
                            if (this.options.gpuTiming) {
                                var e1 = this.context.extTimerQuery, r = this.gpuTimers[t1.id];
                                r || (r = this.gpuTimers[t1.id] = {
                                    calls: 0,
                                    cpuTime: 0,
                                    query: e1.createQueryEXT()
                                }), r.calls++, e1.beginQueryEXT(e1.TIME_ELAPSED_EXT, r.query);
                            }
                        }, _n.prototype.gpuTimingEnd = function() {
                            if (this.options.gpuTiming) {
                                var t1 = this.context.extTimerQuery;
                                t1.endQueryEXT(t1.TIME_ELAPSED_EXT);
                            }
                        }, _n.prototype.collectGpuTimers = function() {
                            var t1 = this.gpuTimers;
                            return this.gpuTimers = {}, t1;
                        }, _n.prototype.queryGpuTimers = function(t1) {
                            var e1 = {};
                            for(var r in t1){
                                var n = t1[r], i = this.context.extTimerQuery, a = i.getQueryObjectEXT(n.query, i.QUERY_RESULT_EXT) / 1e6;
                                i.deleteQueryEXT(n.query), e1[r] = a;
                            }
                            return e1;
                        }, _n.prototype.translatePosMatrix = function(e1, r, n, i, a) {
                            if (!n[0] && !n[1]) return e1;
                            var o = a ? "map" === i ? this.transform.angle : 0 : "viewport" === i ? -this.transform.angle : 0;
                            if (o) {
                                var s = Math.sin(o), l = Math.cos(o);
                                n = [
                                    n[0] * l - n[1] * s,
                                    n[0] * s + n[1] * l
                                ];
                            }
                            var c = [
                                a ? n[0] : pe(r, n[0], this.transform.zoom),
                                a ? n[1] : pe(r, n[1], this.transform.zoom),
                                0
                            ], u = new Float32Array(16);
                            return t1.translate(u, e1, c), u;
                        }, _n.prototype.saveTileTexture = function(t1) {
                            var e1 = this._tileTextures[t1.size[0]];
                            e1 ? e1.push(t1) : this._tileTextures[t1.size[0]] = [
                                t1
                            ];
                        }, _n.prototype.getTileTexture = function(t1) {
                            var e1 = this._tileTextures[t1];
                            return e1 && e1.length > 0 ? e1.pop() : null;
                        }, _n.prototype.isPatternMissing = function(t1) {
                            if (!t1) return !1;
                            if (!t1.from || !t1.to) return !0;
                            var e1 = this.imageManager.getPattern(t1.from.toString()), r = this.imageManager.getPattern(t1.to.toString());
                            return !e1 || !r;
                        }, _n.prototype.useProgram = function(t1, e1) {
                            this.cache = this.cache || {};
                            var r = "" + t1 + (e1 ? e1.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "");
                            return this.cache[r] || (this.cache[r] = new _r(this.context, xr[t1], e1, Jr[t1], this._showOverdrawInspector)), this.cache[r];
                        }, _n.prototype.setCustomLayerDefaults = function() {
                            this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
                        }, _n.prototype.setBaseState = function() {
                            var t1 = this.context.gl;
                            this.context.cullFace.set(!1), this.context.viewport.set([
                                0,
                                0,
                                this.width,
                                this.height
                            ]), this.context.blendEquation.set(t1.FUNC_ADD);
                        }, _n.prototype.initDebugOverlayCanvas = function() {
                            if (null == this.debugOverlayCanvas) {
                                this.debugOverlayCanvas = t1.window.document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512;
                                var e1 = this.context.gl;
                                this.debugOverlayTexture = new t1.Texture(this.context, this.debugOverlayCanvas, e1.RGBA);
                            }
                        }, _n.prototype.destroy = function() {
                            this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy();
                        };
                        var wn = function(t1, e1) {
                            this.points = t1, this.planes = e1;
                        };
                        wn.fromInvProjectionMatrix = function(e1, r, n) {
                            var i = Math.pow(2, n), a = [
                                [
                                    -1,
                                    1,
                                    -1,
                                    1
                                ],
                                [
                                    1,
                                    1,
                                    -1,
                                    1
                                ],
                                [
                                    1,
                                    -1,
                                    -1,
                                    1
                                ],
                                [
                                    -1,
                                    -1,
                                    -1,
                                    1
                                ],
                                [
                                    -1,
                                    1,
                                    1,
                                    1
                                ],
                                [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                [
                                    1,
                                    -1,
                                    1,
                                    1
                                ],
                                [
                                    -1,
                                    -1,
                                    1,
                                    1
                                ]
                            ].map(function(r) {
                                return t1.transformMat4([], r, e1);
                            }).map(function(e1) {
                                return t1.scale$1([], e1, 1 / e1[3] / r * i);
                            }), o = [
                                [
                                    0,
                                    1,
                                    2
                                ],
                                [
                                    6,
                                    5,
                                    4
                                ],
                                [
                                    0,
                                    3,
                                    7
                                ],
                                [
                                    2,
                                    1,
                                    5
                                ],
                                [
                                    3,
                                    2,
                                    6
                                ],
                                [
                                    0,
                                    4,
                                    5
                                ]
                            ].map(function(e1) {
                                var r = t1.sub([], a[e1[0]], a[e1[1]]), n = t1.sub([], a[e1[2]], a[e1[1]]), i = t1.normalize([], t1.cross([], r, n)), o = -t1.dot(i, a[e1[1]]);
                                return i.concat(o);
                            });
                            return new wn(a, o);
                        };
                        var Tn = function(e1, r) {
                            this.min = e1, this.max = r, this.center = t1.scale$2([], t1.add([], this.min, this.max), .5);
                        };
                        Tn.prototype.quadrant = function(e1) {
                            for(var r = [
                                e1 % 2 == 0,
                                e1 < 2
                            ], n = t1.clone$2(this.min), i = t1.clone$2(this.max), a = 0; a < r.length; a++)n[a] = r[a] ? this.min[a] : this.center[a], i[a] = r[a] ? this.center[a] : this.max[a];
                            return i[2] = this.max[2], new Tn(n, i);
                        }, Tn.prototype.distanceX = function(t1) {
                            return Math.max(Math.min(this.max[0], t1[0]), this.min[0]) - t1[0];
                        }, Tn.prototype.distanceY = function(t1) {
                            return Math.max(Math.min(this.max[1], t1[1]), this.min[1]) - t1[1];
                        }, Tn.prototype.intersects = function(e1) {
                            for(var r = [
                                [
                                    this.min[0],
                                    this.min[1],
                                    0,
                                    1
                                ],
                                [
                                    this.max[0],
                                    this.min[1],
                                    0,
                                    1
                                ],
                                [
                                    this.max[0],
                                    this.max[1],
                                    0,
                                    1
                                ],
                                [
                                    this.min[0],
                                    this.max[1],
                                    0,
                                    1
                                ]
                            ], n = !0, i = 0; i < e1.planes.length; i++){
                                for(var a = e1.planes[i], o = 0, s = 0; s < r.length; s++)o += t1.dot$1(a, r[s]) >= 0;
                                if (0 === o) return 0;
                                o !== r.length && (n = !1);
                            }
                            if (n) return 2;
                            for(var l = 0; l < 3; l++){
                                for(var c = Number.MAX_VALUE, u = -Number.MAX_VALUE, f = 0; f < e1.points.length; f++){
                                    var h = e1.points[f][l] - this.min[l];
                                    c = Math.min(c, h), u = Math.max(u, h);
                                }
                                if (u < 0 || c > this.max[l] - this.min[l]) return 0;
                            }
                            return 1;
                        };
                        var kn = function(t1, e1, r, n) {
                            if (void 0 === t1 && (t1 = 0), void 0 === e1 && (e1 = 0), void 0 === r && (r = 0), void 0 === n && (n = 0), isNaN(t1) || t1 < 0 || isNaN(e1) || e1 < 0 || isNaN(r) || r < 0 || isNaN(n) || n < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                            this.top = t1, this.bottom = e1, this.left = r, this.right = n;
                        };
                        kn.prototype.interpolate = function(e1, r, n) {
                            return null != r.top && null != e1.top && (this.top = t1.number(e1.top, r.top, n)), null != r.bottom && null != e1.bottom && (this.bottom = t1.number(e1.bottom, r.bottom, n)), null != r.left && null != e1.left && (this.left = t1.number(e1.left, r.left, n)), null != r.right && null != e1.right && (this.right = t1.number(e1.right, r.right, n)), this;
                        }, kn.prototype.getCenter = function(e1, r) {
                            var n = t1.clamp((this.left + e1 - this.right) / 2, 0, e1), i = t1.clamp((this.top + r - this.bottom) / 2, 0, r);
                            return new t1.Point(n, i);
                        }, kn.prototype.equals = function(t1) {
                            return this.top === t1.top && this.bottom === t1.bottom && this.left === t1.left && this.right === t1.right;
                        }, kn.prototype.clone = function() {
                            return new kn(this.top, this.bottom, this.left, this.right);
                        }, kn.prototype.toJSON = function() {
                            return {
                                top: this.top,
                                bottom: this.bottom,
                                left: this.left,
                                right: this.right
                            };
                        };
                        var An = function(e1, r, n, i, a) {
                            this.tileSize = 512, this.maxValidLatitude = 85.051129, this._renderWorldCopies = void 0 === a || a, this._minZoom = e1 || 0, this._maxZoom = r || 22, this._minPitch = null == n ? 0 : n, this._maxPitch = null == i ? 60 : i, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new t1.LngLat(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new kn, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
                        }, Mn = {
                            minZoom: {
                                configurable: !0
                            },
                            maxZoom: {
                                configurable: !0
                            },
                            minPitch: {
                                configurable: !0
                            },
                            maxPitch: {
                                configurable: !0
                            },
                            renderWorldCopies: {
                                configurable: !0
                            },
                            worldSize: {
                                configurable: !0
                            },
                            centerOffset: {
                                configurable: !0
                            },
                            size: {
                                configurable: !0
                            },
                            bearing: {
                                configurable: !0
                            },
                            pitch: {
                                configurable: !0
                            },
                            fov: {
                                configurable: !0
                            },
                            zoom: {
                                configurable: !0
                            },
                            center: {
                                configurable: !0
                            },
                            padding: {
                                configurable: !0
                            },
                            centerPoint: {
                                configurable: !0
                            },
                            unmodified: {
                                configurable: !0
                            },
                            point: {
                                configurable: !0
                            }
                        };
                        An.prototype.clone = function() {
                            var t1 = new An(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
                            return t1.tileSize = this.tileSize, t1.latRange = this.latRange, t1.width = this.width, t1.height = this.height, t1._center = this._center, t1.zoom = this.zoom, t1.angle = this.angle, t1._fov = this._fov, t1._pitch = this._pitch, t1._unmodified = this._unmodified, t1._edgeInsets = this._edgeInsets.clone(), t1._calcMatrices(), t1;
                        }, Mn.minZoom.get = function() {
                            return this._minZoom;
                        }, Mn.minZoom.set = function(t1) {
                            this._minZoom !== t1 && (this._minZoom = t1, this.zoom = Math.max(this.zoom, t1));
                        }, Mn.maxZoom.get = function() {
                            return this._maxZoom;
                        }, Mn.maxZoom.set = function(t1) {
                            this._maxZoom !== t1 && (this._maxZoom = t1, this.zoom = Math.min(this.zoom, t1));
                        }, Mn.minPitch.get = function() {
                            return this._minPitch;
                        }, Mn.minPitch.set = function(t1) {
                            this._minPitch !== t1 && (this._minPitch = t1, this.pitch = Math.max(this.pitch, t1));
                        }, Mn.maxPitch.get = function() {
                            return this._maxPitch;
                        }, Mn.maxPitch.set = function(t1) {
                            this._maxPitch !== t1 && (this._maxPitch = t1, this.pitch = Math.min(this.pitch, t1));
                        }, Mn.renderWorldCopies.get = function() {
                            return this._renderWorldCopies;
                        }, Mn.renderWorldCopies.set = function(t1) {
                            void 0 === t1 ? t1 = !0 : null === t1 && (t1 = !1), this._renderWorldCopies = t1;
                        }, Mn.worldSize.get = function() {
                            return this.tileSize * this.scale;
                        }, Mn.centerOffset.get = function() {
                            return this.centerPoint._sub(this.size._div(2));
                        }, Mn.size.get = function() {
                            return new t1.Point(this.width, this.height);
                        }, Mn.bearing.get = function() {
                            return -this.angle / Math.PI * 180;
                        }, Mn.bearing.set = function(e1) {
                            var r = -t1.wrap(e1, -180, 180) * Math.PI / 180;
                            this.angle !== r && (this._unmodified = !1, this.angle = r, this._calcMatrices(), this.rotationMatrix = t1.create$2(), t1.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
                        }, Mn.pitch.get = function() {
                            return this._pitch / Math.PI * 180;
                        }, Mn.pitch.set = function(e1) {
                            var r = t1.clamp(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                            this._pitch !== r && (this._unmodified = !1, this._pitch = r, this._calcMatrices());
                        }, Mn.fov.get = function() {
                            return this._fov / Math.PI * 180;
                        }, Mn.fov.set = function(t1) {
                            t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = t1 / 180 * Math.PI, this._calcMatrices());
                        }, Mn.zoom.get = function() {
                            return this._zoom;
                        }, Mn.zoom.set = function(t1) {
                            var e1 = Math.min(Math.max(t1, this.minZoom), this.maxZoom);
                            this._zoom !== e1 && (this._unmodified = !1, this._zoom = e1, this.scale = this.zoomScale(e1), this.tileZoom = Math.floor(e1), this.zoomFraction = e1 - this.tileZoom, this._constrain(), this._calcMatrices());
                        }, Mn.center.get = function() {
                            return this._center;
                        }, Mn.center.set = function(t1) {
                            t1.lat === this._center.lat && t1.lng === this._center.lng || (this._unmodified = !1, this._center = t1, this._constrain(), this._calcMatrices());
                        }, Mn.padding.get = function() {
                            return this._edgeInsets.toJSON();
                        }, Mn.padding.set = function(t1) {
                            this._edgeInsets.equals(t1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, t1, 1), this._calcMatrices());
                        }, Mn.centerPoint.get = function() {
                            return this._edgeInsets.getCenter(this.width, this.height);
                        }, An.prototype.isPaddingEqual = function(t1) {
                            return this._edgeInsets.equals(t1);
                        }, An.prototype.interpolatePadding = function(t1, e1, r) {
                            this._unmodified = !1, this._edgeInsets.interpolate(t1, e1, r), this._constrain(), this._calcMatrices();
                        }, An.prototype.coveringZoomLevel = function(t1) {
                            var e1 = (t1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / t1.tileSize));
                            return Math.max(0, e1);
                        }, An.prototype.getVisibleUnwrappedCoordinates = function(e1) {
                            var r = [
                                new t1.UnwrappedTileID(0, e1)
                            ];
                            if (this._renderWorldCopies) for(var n = this.pointCoordinate(new t1.Point(0, 0)), i = this.pointCoordinate(new t1.Point(this.width, 0)), a = this.pointCoordinate(new t1.Point(this.width, this.height)), o = this.pointCoordinate(new t1.Point(0, this.height)), s = Math.floor(Math.min(n.x, i.x, a.x, o.x)), l = Math.floor(Math.max(n.x, i.x, a.x, o.x)), c = s - 1; c <= l + 1; c++)0 !== c && r.push(new t1.UnwrappedTileID(c, e1));
                            return r;
                        }, An.prototype.coveringTiles = function(e1) {
                            var r = this.coveringZoomLevel(e1), n = r;
                            if (void 0 !== e1.minzoom && r < e1.minzoom) return [];
                            void 0 !== e1.maxzoom && r > e1.maxzoom && (r = e1.maxzoom);
                            var i = t1.MercatorCoordinate.fromLngLat(this.center), a = Math.pow(2, r), o = [
                                a * i.x,
                                a * i.y,
                                0
                            ], s = wn.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, r), l = e1.minzoom || 0;
                            this.pitch <= 60 && this._edgeInsets.top < .1 && (l = r);
                            var c = function(t1) {
                                return {
                                    aabb: new Tn([
                                        t1 * a,
                                        0,
                                        0
                                    ], [
                                        (t1 + 1) * a,
                                        a,
                                        0
                                    ]),
                                    zoom: 0,
                                    x: 0,
                                    y: 0,
                                    wrap: t1,
                                    fullyVisible: !1
                                };
                            }, u = [], f = [], h = r, p = e1.reparseOverscaled ? n : r;
                            if (this._renderWorldCopies) for(var d = 1; d <= 3; d++)u.push(c(-d)), u.push(c(d));
                            for(u.push(c(0)); u.length > 0;){
                                var m = u.pop(), g = m.x, v = m.y, y = m.fullyVisible;
                                if (!y) {
                                    var x = m.aabb.intersects(s);
                                    if (0 === x) continue;
                                    y = 2 === x;
                                }
                                var b = m.aabb.distanceX(o), _ = m.aabb.distanceY(o), w = Math.max(Math.abs(b), Math.abs(_)), T = 3 + (1 << h - m.zoom) - 2;
                                if (m.zoom === h || w > T && m.zoom >= l) f.push({
                                    tileID: new t1.OverscaledTileID(m.zoom === h ? p : m.zoom, m.wrap, m.zoom, g, v),
                                    distanceSq: t1.sqrLen([
                                        o[0] - .5 - g,
                                        o[1] - .5 - v
                                    ])
                                });
                                else for(var k = 0; k < 4; k++){
                                    var A = (g << 1) + k % 2, M = (v << 1) + (k >> 1);
                                    u.push({
                                        aabb: m.aabb.quadrant(k),
                                        zoom: m.zoom + 1,
                                        x: A,
                                        y: M,
                                        wrap: m.wrap,
                                        fullyVisible: y
                                    });
                                }
                            }
                            return f.sort(function(t1, e1) {
                                return t1.distanceSq - e1.distanceSq;
                            }).map(function(t1) {
                                return t1.tileID;
                            });
                        }, An.prototype.resize = function(t1, e1) {
                            this.width = t1, this.height = e1, this.pixelsToGLUnits = [
                                2 / t1,
                                -2 / e1
                            ], this._constrain(), this._calcMatrices();
                        }, Mn.unmodified.get = function() {
                            return this._unmodified;
                        }, An.prototype.zoomScale = function(t1) {
                            return Math.pow(2, t1);
                        }, An.prototype.scaleZoom = function(t1) {
                            return Math.log(t1) / Math.LN2;
                        }, An.prototype.project = function(e1) {
                            var r = t1.clamp(e1.lat, -this.maxValidLatitude, this.maxValidLatitude);
                            return new t1.Point(t1.mercatorXfromLng(e1.lng) * this.worldSize, t1.mercatorYfromLat(r) * this.worldSize);
                        }, An.prototype.unproject = function(e1) {
                            return new t1.MercatorCoordinate(e1.x / this.worldSize, e1.y / this.worldSize).toLngLat();
                        }, Mn.point.get = function() {
                            return this.project(this.center);
                        }, An.prototype.setLocationAtPoint = function(e1, r) {
                            var n = this.pointCoordinate(r), i = this.pointCoordinate(this.centerPoint), a = this.locationCoordinate(e1), o = new t1.MercatorCoordinate(a.x - (n.x - i.x), a.y - (n.y - i.y));
                            this.center = this.coordinateLocation(o), this._renderWorldCopies && (this.center = this.center.wrap());
                        }, An.prototype.locationPoint = function(t1) {
                            return this.coordinatePoint(this.locationCoordinate(t1));
                        }, An.prototype.pointLocation = function(t1) {
                            return this.coordinateLocation(this.pointCoordinate(t1));
                        }, An.prototype.locationCoordinate = function(e1) {
                            return t1.MercatorCoordinate.fromLngLat(e1);
                        }, An.prototype.coordinateLocation = function(t1) {
                            return t1.toLngLat();
                        }, An.prototype.pointCoordinate = function(e1) {
                            var r = [
                                e1.x,
                                e1.y,
                                0,
                                1
                            ], n = [
                                e1.x,
                                e1.y,
                                1,
                                1
                            ];
                            t1.transformMat4(r, r, this.pixelMatrixInverse), t1.transformMat4(n, n, this.pixelMatrixInverse);
                            var i = r[3], a = n[3], o = r[0] / i, s = n[0] / a, l = r[1] / i, c = n[1] / a, u = r[2] / i, f = n[2] / a, h = u === f ? 0 : (0 - u) / (f - u);
                            return new t1.MercatorCoordinate(t1.number(o, s, h) / this.worldSize, t1.number(l, c, h) / this.worldSize);
                        }, An.prototype.coordinatePoint = function(e1) {
                            var r = [
                                e1.x * this.worldSize,
                                e1.y * this.worldSize,
                                0,
                                1
                            ];
                            return t1.transformMat4(r, r, this.pixelMatrix), new t1.Point(r[0] / r[3], r[1] / r[3]);
                        }, An.prototype.getBounds = function() {
                            return (new t1.LngLatBounds).extend(this.pointLocation(new t1.Point(0, 0))).extend(this.pointLocation(new t1.Point(this.width, 0))).extend(this.pointLocation(new t1.Point(this.width, this.height))).extend(this.pointLocation(new t1.Point(0, this.height)));
                        }, An.prototype.getMaxBounds = function() {
                            return this.latRange && 2 === this.latRange.length && this.lngRange && 2 === this.lngRange.length ? new t1.LngLatBounds([
                                this.lngRange[0],
                                this.latRange[0]
                            ], [
                                this.lngRange[1],
                                this.latRange[1]
                            ]) : null;
                        }, An.prototype.setMaxBounds = function(t1) {
                            t1 ? (this.lngRange = [
                                t1.getWest(),
                                t1.getEast()
                            ], this.latRange = [
                                t1.getSouth(),
                                t1.getNorth()
                            ], this._constrain()) : (this.lngRange = null, this.latRange = [
                                -this.maxValidLatitude,
                                this.maxValidLatitude
                            ]);
                        }, An.prototype.calculatePosMatrix = function(e1, r) {
                            void 0 === r && (r = !1);
                            var n = e1.key, i = r ? this._alignedPosMatrixCache : this._posMatrixCache;
                            if (i[n]) return i[n];
                            var a = e1.canonical, o = this.worldSize / this.zoomScale(a.z), s = a.x + Math.pow(2, a.z) * e1.wrap, l = t1.identity(new Float64Array(16));
                            return t1.translate(l, l, [
                                s * o,
                                a.y * o,
                                0
                            ]), t1.scale(l, l, [
                                o / t1.EXTENT,
                                o / t1.EXTENT,
                                1
                            ]), t1.multiply(l, r ? this.alignedProjMatrix : this.projMatrix, l), i[n] = new Float32Array(l), i[n];
                        }, An.prototype.customLayerMatrix = function() {
                            return this.mercatorMatrix.slice();
                        }, An.prototype._constrain = function() {
                            if (this.center && this.width && this.height && !this._constraining) {
                                this._constraining = !0;
                                var e1, r, n, i, a = -90, o = 90, s = -180, l = 180, c = this.size, u = this._unmodified;
                                if (this.latRange) {
                                    var f = this.latRange;
                                    a = t1.mercatorYfromLat(f[1]) * this.worldSize, e1 = (o = t1.mercatorYfromLat(f[0]) * this.worldSize) - a < c.y ? c.y / (o - a) : 0;
                                }
                                if (this.lngRange) {
                                    var h = this.lngRange;
                                    s = t1.mercatorXfromLng(h[0]) * this.worldSize, r = (l = t1.mercatorXfromLng(h[1]) * this.worldSize) - s < c.x ? c.x / (l - s) : 0;
                                }
                                var p = this.point, d = Math.max(r || 0, e1 || 0);
                                if (d) return this.center = this.unproject(new t1.Point(r ? (l + s) / 2 : p.x, e1 ? (o + a) / 2 : p.y)), this.zoom += this.scaleZoom(d), this._unmodified = u, void (this._constraining = !1);
                                if (this.latRange) {
                                    var m = p.y, g = c.y / 2;
                                    m - g < a && (i = a + g), m + g > o && (i = o - g);
                                }
                                if (this.lngRange) {
                                    var v = p.x, y = c.x / 2;
                                    v - y < s && (n = s + y), v + y > l && (n = l - y);
                                }
                                void 0 === n && void 0 === i || (this.center = this.unproject(new t1.Point(void 0 !== n ? n : p.x, void 0 !== i ? i : p.y))), this._unmodified = u, this._constraining = !1;
                            }
                        }, An.prototype._calcMatrices = function() {
                            if (this.height) {
                                var e1 = this._fov / 2, r = this.centerOffset;
                                this.cameraToCenterDistance = .5 / Math.tan(e1) * this.height;
                                var n = Math.PI / 2 + this._pitch, i = this._fov * (.5 + r.y / this.height), a = Math.sin(i) * this.cameraToCenterDistance / Math.sin(t1.clamp(Math.PI - n - i, .01, Math.PI - .01)), o = this.point, s = o.x, l = o.y, c = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * a + this.cameraToCenterDistance), u = this.height / 50, f = new Float64Array(16);
                                t1.perspective(f, this._fov, this.width / this.height, u, c), f[8] = 2 * -r.x / this.width, f[9] = 2 * r.y / this.height, t1.scale(f, f, [
                                    1,
                                    -1,
                                    1
                                ]), t1.translate(f, f, [
                                    0,
                                    0,
                                    -this.cameraToCenterDistance
                                ]), t1.rotateX(f, f, this._pitch), t1.rotateZ(f, f, this.angle), t1.translate(f, f, [
                                    -s,
                                    -l,
                                    0
                                ]), this.mercatorMatrix = t1.scale([], f, [
                                    this.worldSize,
                                    this.worldSize,
                                    this.worldSize
                                ]), t1.scale(f, f, [
                                    1,
                                    1,
                                    t1.mercatorZfromAltitude(1, this.center.lat) * this.worldSize,
                                    1
                                ]), this.projMatrix = f, this.invProjMatrix = t1.invert([], this.projMatrix);
                                var h = this.width % 2 / 2, p = this.height % 2 / 2, d = Math.cos(this.angle), m = Math.sin(this.angle), g = s - Math.round(s) + d * h + m * p, v = l - Math.round(l) + d * p + m * h, y = new Float64Array(f);
                                if (t1.translate(y, y, [
                                    g > .5 ? g - 1 : g,
                                    v > .5 ? v - 1 : v,
                                    0
                                ]), this.alignedProjMatrix = y, f = t1.create(), t1.scale(f, f, [
                                    this.width / 2,
                                    -this.height / 2,
                                    1
                                ]), t1.translate(f, f, [
                                    1,
                                    -1,
                                    0
                                ]), this.labelPlaneMatrix = f, f = t1.create(), t1.scale(f, f, [
                                    1,
                                    -1,
                                    1
                                ]), t1.translate(f, f, [
                                    -1,
                                    -1,
                                    0
                                ]), t1.scale(f, f, [
                                    2 / this.width,
                                    2 / this.height,
                                    1
                                ]), this.glCoordMatrix = f, this.pixelMatrix = t1.multiply(new Float64Array(16), this.labelPlaneMatrix, this.projMatrix), !(f = t1.invert(new Float64Array(16), this.pixelMatrix))) throw new Error("failed to invert matrix");
                                this.pixelMatrixInverse = f, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
                            }
                        }, An.prototype.maxPitchScaleFactor = function() {
                            if (!this.pixelMatrixInverse) return 1;
                            var e1 = this.pointCoordinate(new t1.Point(0, 0)), r = [
                                e1.x * this.worldSize,
                                e1.y * this.worldSize,
                                0,
                                1
                            ];
                            return t1.transformMat4(r, r, this.pixelMatrix)[3] / this.cameraToCenterDistance;
                        }, An.prototype.getCameraPoint = function() {
                            var e1 = this._pitch, r = Math.tan(e1) * (this.cameraToCenterDistance || 1);
                            return this.centerPoint.add(new t1.Point(0, r));
                        }, An.prototype.getCameraQueryGeometry = function(e1) {
                            var r = this.getCameraPoint();
                            if (1 === e1.length) return [
                                e1[0],
                                r
                            ];
                            for(var n = r.x, i = r.y, a = r.x, o = r.y, s = 0, l = e1; s < l.length; s += 1){
                                var c = l[s];
                                n = Math.min(n, c.x), i = Math.min(i, c.y), a = Math.max(a, c.x), o = Math.max(o, c.y);
                            }
                            return [
                                new t1.Point(n, i),
                                new t1.Point(a, i),
                                new t1.Point(a, o),
                                new t1.Point(n, o),
                                new t1.Point(n, i)
                            ];
                        }, Object.defineProperties(An.prototype, Mn);
                        var Sn = function(e1) {
                            var r, n, i, a, o;
                            this._hashName = e1 && encodeURIComponent(e1), t1.bindAll([
                                "_getCurrentHash",
                                "_onHashChange",
                                "_updateHash"
                            ], this), this._updateHash = (r = this._updateHashUnthrottled.bind(this), n = 300, i = !1, a = null, o = function() {
                                a = null, i && (r(), a = setTimeout(o, n), i = !1);
                            }, function() {
                                return i = !0, a || o(), a;
                            });
                        };
                        Sn.prototype.addTo = function(e1) {
                            return this._map = e1, t1.window.addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
                        }, Sn.prototype.remove = function() {
                            return t1.window.removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), delete this._map, this;
                        }, Sn.prototype.getHashString = function(e1) {
                            var r = this._map.getCenter(), n = Math.round(100 * this._map.getZoom()) / 100, i = Math.ceil((n * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), a = Math.pow(10, i), o = Math.round(r.lng * a) / a, s = Math.round(r.lat * a) / a, l = this._map.getBearing(), c = this._map.getPitch(), u = "";
                            if (u += e1 ? "/" + o + "/" + s + "/" + n : n + "/" + s + "/" + o, (l || c) && (u += "/" + Math.round(10 * l) / 10), c && (u += "/" + Math.round(c)), this._hashName) {
                                var f = this._hashName, h = !1, p = t1.window.location.hash.slice(1).split("&").map(function(t1) {
                                    var e1 = t1.split("=")[0];
                                    return e1 === f ? (h = !0, e1 + "=" + u) : t1;
                                }).filter(function(t1) {
                                    return t1;
                                });
                                return h || p.push(f + "=" + u), "#" + p.join("&");
                            }
                            return "#" + u;
                        }, Sn.prototype._getCurrentHash = function() {
                            var e1, r = this, n = t1.window.location.hash.replace("#", "");
                            return this._hashName ? (n.split("&").map(function(t1) {
                                return t1.split("=");
                            }).forEach(function(t1) {
                                t1[0] === r._hashName && (e1 = t1);
                            }), (e1 && e1[1] || "").split("/")) : n.split("/");
                        }, Sn.prototype._onHashChange = function() {
                            var t1 = this._getCurrentHash();
                            if (t1.length >= 3 && !t1.some(function(t1) {
                                return isNaN(t1);
                            })) {
                                var e1 = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : this._map.getBearing();
                                return this._map.jumpTo({
                                    center: [
                                        +t1[2],
                                        +t1[1]
                                    ],
                                    zoom: +t1[0],
                                    bearing: e1,
                                    pitch: +(t1[4] || 0)
                                }), !0;
                            }
                            return !1;
                        }, Sn.prototype._updateHashUnthrottled = function() {
                            var e1 = this.getHashString();
                            try {
                                t1.window.history.replaceState(t1.window.history.state, "", e1);
                            } catch (t1) {}
                        };
                        var En = {
                            linearity: .3,
                            easing: t1.bezier(0, 0, .3, 1)
                        }, Ln = t1.extend({
                            deceleration: 2500,
                            maxSpeed: 1400
                        }, En), Cn = t1.extend({
                            deceleration: 20,
                            maxSpeed: 1400
                        }, En), Pn = t1.extend({
                            deceleration: 1e3,
                            maxSpeed: 360
                        }, En), In = t1.extend({
                            deceleration: 1e3,
                            maxSpeed: 90
                        }, En), On = function(t1) {
                            this._map = t1, this.clear();
                        };
                        function zn(t1, e1) {
                            (!t1.duration || t1.duration < e1.duration) && (t1.duration = e1.duration, t1.easing = e1.easing);
                        }
                        function Dn(e1, r, n) {
                            var i = n.maxSpeed, a = n.linearity, o = n.deceleration, s = t1.clamp(e1 * a / (r / 1e3), -i, i), l = Math.abs(s) / (o * a);
                            return {
                                easing: n.easing,
                                duration: 1e3 * l,
                                amount: s * (l / 2)
                            };
                        }
                        On.prototype.clear = function() {
                            this._inertiaBuffer = [];
                        }, On.prototype.record = function(e1) {
                            this._drainInertiaBuffer(), this._inertiaBuffer.push({
                                time: t1.browser.now(),
                                settings: e1
                            });
                        }, On.prototype._drainInertiaBuffer = function() {
                            for(var e1 = this._inertiaBuffer, r = t1.browser.now(); e1.length > 0 && r - e1[0].time > 160;)e1.shift();
                        }, On.prototype._onMoveEnd = function(e1) {
                            if (this._drainInertiaBuffer(), !(this._inertiaBuffer.length < 2)) {
                                for(var r = {
                                    zoom: 0,
                                    bearing: 0,
                                    pitch: 0,
                                    pan: new t1.Point(0, 0),
                                    pinchAround: void 0,
                                    around: void 0
                                }, n = 0, i = this._inertiaBuffer; n < i.length; n += 1){
                                    var a = i[n].settings;
                                    r.zoom += a.zoomDelta || 0, r.bearing += a.bearingDelta || 0, r.pitch += a.pitchDelta || 0, a.panDelta && r.pan._add(a.panDelta), a.around && (r.around = a.around), a.pinchAround && (r.pinchAround = a.pinchAround);
                                }
                                var o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, s = {};
                                if (r.pan.mag()) {
                                    var l = Dn(r.pan.mag(), o, t1.extend({}, Ln, e1 || {}));
                                    s.offset = r.pan.mult(l.amount / r.pan.mag()), s.center = this._map.transform.center, zn(s, l);
                                }
                                if (r.zoom) {
                                    var c = Dn(r.zoom, o, Cn);
                                    s.zoom = this._map.transform.zoom + c.amount, zn(s, c);
                                }
                                if (r.bearing) {
                                    var u = Dn(r.bearing, o, Pn);
                                    s.bearing = this._map.transform.bearing + t1.clamp(u.amount, -179, 179), zn(s, u);
                                }
                                if (r.pitch) {
                                    var f = Dn(r.pitch, o, In);
                                    s.pitch = this._map.transform.pitch + f.amount, zn(s, f);
                                }
                                if (s.zoom || s.bearing) {
                                    var h = void 0 === r.pinchAround ? r.around : r.pinchAround;
                                    s.around = h ? this._map.unproject(h) : this._map.getCenter();
                                }
                                return this.clear(), t1.extend(s, {
                                    noMoveStart: !0
                                });
                            }
                        };
                        var Rn = function(e1) {
                            function n(n, i, a, o) {
                                void 0 === o && (o = {});
                                var s = r.mousePos(i.getCanvasContainer(), a), l = i.unproject(s);
                                e1.call(this, n, t1.extend({
                                    point: s,
                                    lngLat: l,
                                    originalEvent: a
                                }, o)), this._defaultPrevented = !1, this.target = i;
                            }
                            e1 && (n.__proto__ = e1), n.prototype = Object.create(e1 && e1.prototype), n.prototype.constructor = n;
                            var i = {
                                defaultPrevented: {
                                    configurable: !0
                                }
                            };
                            return n.prototype.preventDefault = function() {
                                this._defaultPrevented = !0;
                            }, i.defaultPrevented.get = function() {
                                return this._defaultPrevented;
                            }, Object.defineProperties(n.prototype, i), n;
                        }(t1.Event), Fn = function(e1) {
                            function n(n, i, a) {
                                var o = "touchend" === n ? a.changedTouches : a.touches, s = r.touchPos(i.getCanvasContainer(), o), l = s.map(function(t1) {
                                    return i.unproject(t1);
                                }), c = s.reduce(function(t1, e1, r, n) {
                                    return t1.add(e1.div(n.length));
                                }, new t1.Point(0, 0)), u = i.unproject(c);
                                e1.call(this, n, {
                                    points: s,
                                    point: c,
                                    lngLats: l,
                                    lngLat: u,
                                    originalEvent: a
                                }), this._defaultPrevented = !1;
                            }
                            e1 && (n.__proto__ = e1), n.prototype = Object.create(e1 && e1.prototype), n.prototype.constructor = n;
                            var i = {
                                defaultPrevented: {
                                    configurable: !0
                                }
                            };
                            return n.prototype.preventDefault = function() {
                                this._defaultPrevented = !0;
                            }, i.defaultPrevented.get = function() {
                                return this._defaultPrevented;
                            }, Object.defineProperties(n.prototype, i), n;
                        }(t1.Event), Bn = function(t1) {
                            function e1(e1, r, n) {
                                t1.call(this, e1, {
                                    originalEvent: n
                                }), this._defaultPrevented = !1;
                            }
                            t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1;
                            var r = {
                                defaultPrevented: {
                                    configurable: !0
                                }
                            };
                            return e1.prototype.preventDefault = function() {
                                this._defaultPrevented = !0;
                            }, r.defaultPrevented.get = function() {
                                return this._defaultPrevented;
                            }, Object.defineProperties(e1.prototype, r), e1;
                        }(t1.Event), Nn = function(t1, e1) {
                            this._map = t1, this._clickTolerance = e1.clickTolerance;
                        };
                        Nn.prototype.reset = function() {
                            delete this._mousedownPos;
                        }, Nn.prototype.wheel = function(t1) {
                            return this._firePreventable(new Bn(t1.type, this._map, t1));
                        }, Nn.prototype.mousedown = function(t1, e1) {
                            return this._mousedownPos = e1, this._firePreventable(new Rn(t1.type, this._map, t1));
                        }, Nn.prototype.mouseup = function(t1) {
                            this._map.fire(new Rn(t1.type, this._map, t1));
                        }, Nn.prototype.click = function(t1, e1) {
                            this._mousedownPos && this._mousedownPos.dist(e1) >= this._clickTolerance || this._map.fire(new Rn(t1.type, this._map, t1));
                        }, Nn.prototype.dblclick = function(t1) {
                            return this._firePreventable(new Rn(t1.type, this._map, t1));
                        }, Nn.prototype.mouseover = function(t1) {
                            this._map.fire(new Rn(t1.type, this._map, t1));
                        }, Nn.prototype.mouseout = function(t1) {
                            this._map.fire(new Rn(t1.type, this._map, t1));
                        }, Nn.prototype.touchstart = function(t1) {
                            return this._firePreventable(new Fn(t1.type, this._map, t1));
                        }, Nn.prototype.touchmove = function(t1) {
                            this._map.fire(new Fn(t1.type, this._map, t1));
                        }, Nn.prototype.touchend = function(t1) {
                            this._map.fire(new Fn(t1.type, this._map, t1));
                        }, Nn.prototype.touchcancel = function(t1) {
                            this._map.fire(new Fn(t1.type, this._map, t1));
                        }, Nn.prototype._firePreventable = function(t1) {
                            if (this._map.fire(t1), t1.defaultPrevented) return {};
                        }, Nn.prototype.isEnabled = function() {
                            return !0;
                        }, Nn.prototype.isActive = function() {
                            return !1;
                        }, Nn.prototype.enable = function() {}, Nn.prototype.disable = function() {};
                        var jn = function(t1) {
                            this._map = t1;
                        };
                        jn.prototype.reset = function() {
                            this._delayContextMenu = !1, delete this._contextMenuEvent;
                        }, jn.prototype.mousemove = function(t1) {
                            this._map.fire(new Rn(t1.type, this._map, t1));
                        }, jn.prototype.mousedown = function() {
                            this._delayContextMenu = !0;
                        }, jn.prototype.mouseup = function() {
                            this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new Rn("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
                        }, jn.prototype.contextmenu = function(t1) {
                            this._delayContextMenu ? this._contextMenuEvent = t1 : this._map.fire(new Rn(t1.type, this._map, t1)), this._map.listens("contextmenu") && t1.preventDefault();
                        }, jn.prototype.isEnabled = function() {
                            return !0;
                        }, jn.prototype.isActive = function() {
                            return !1;
                        }, jn.prototype.enable = function() {}, jn.prototype.disable = function() {};
                        var Un = function(t1, e1) {
                            this._map = t1, this._el = t1.getCanvasContainer(), this._container = t1.getContainer(), this._clickTolerance = e1.clickTolerance || 1;
                        };
                        function Vn(t1, e1) {
                            for(var r = {}, n = 0; n < t1.length; n++)r[t1[n].identifier] = e1[n];
                            return r;
                        }
                        Un.prototype.isEnabled = function() {
                            return !!this._enabled;
                        }, Un.prototype.isActive = function() {
                            return !!this._active;
                        }, Un.prototype.enable = function() {
                            this.isEnabled() || (this._enabled = !0);
                        }, Un.prototype.disable = function() {
                            this.isEnabled() && (this._enabled = !1);
                        }, Un.prototype.mousedown = function(t1, e1) {
                            this.isEnabled() && t1.shiftKey && 0 === t1.button && (r.disableDrag(), this._startPos = this._lastPos = e1, this._active = !0);
                        }, Un.prototype.mousemoveWindow = function(t1, e1) {
                            if (this._active) {
                                var n = e1;
                                if (!(this._lastPos.equals(n) || !this._box && n.dist(this._startPos) < this._clickTolerance)) {
                                    var i = this._startPos;
                                    this._lastPos = n, this._box || (this._box = r.create("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", t1));
                                    var a = Math.min(i.x, n.x), o = Math.max(i.x, n.x), s = Math.min(i.y, n.y), l = Math.max(i.y, n.y);
                                    r.setTransform(this._box, "translate(" + a + "px," + s + "px)"), this._box.style.width = o - a + "px", this._box.style.height = l - s + "px";
                                }
                            }
                        }, Un.prototype.mouseupWindow = function(e1, n) {
                            var i = this;
                            if (this._active && 0 === e1.button) {
                                var a = this._startPos, o = n;
                                if (this.reset(), r.suppressClick(), a.x !== o.x || a.y !== o.y) return this._map.fire(new t1.Event("boxzoomend", {
                                    originalEvent: e1
                                })), {
                                    cameraAnimation: function(t1) {
                                        return t1.fitScreenCoordinates(a, o, i._map.getBearing(), {
                                            linear: !0
                                        });
                                    }
                                };
                                this._fireEvent("boxzoomcancel", e1);
                            }
                        }, Un.prototype.keydown = function(t1) {
                            this._active && 27 === t1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", t1));
                        }, Un.prototype.reset = function() {
                            this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (r.remove(this._box), this._box = null), r.enableDrag(), delete this._startPos, delete this._lastPos;
                        }, Un.prototype._fireEvent = function(e1, r) {
                            return this._map.fire(new t1.Event(e1, {
                                originalEvent: r
                            }));
                        };
                        var Hn = function(t1) {
                            this.reset(), this.numTouches = t1.numTouches;
                        };
                        Hn.prototype.reset = function() {
                            delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
                        }, Hn.prototype.touchstart = function(e1, r, n) {
                            (this.centroid || n.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e1.timeStamp), n.length === this.numTouches && (this.centroid = function(e1) {
                                for(var r = new t1.Point(0, 0), n = 0, i = e1; n < i.length; n += 1){
                                    var a = i[n];
                                    r._add(a);
                                }
                                return r.div(e1.length);
                            }(r), this.touches = Vn(n, r)));
                        }, Hn.prototype.touchmove = function(t1, e1, r) {
                            if (!this.aborted && this.centroid) {
                                var n = Vn(r, e1);
                                for(var i in this.touches){
                                    var a = this.touches[i], o = n[i];
                                    (!o || o.dist(a) > 30) && (this.aborted = !0);
                                }
                            }
                        }, Hn.prototype.touchend = function(t1, e1, r) {
                            if ((!this.centroid || t1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === r.length) {
                                var n = !this.aborted && this.centroid;
                                if (this.reset(), n) return n;
                            }
                        };
                        var qn = function(t1) {
                            this.singleTap = new Hn(t1), this.numTaps = t1.numTaps, this.reset();
                        };
                        qn.prototype.reset = function() {
                            this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
                        }, qn.prototype.touchstart = function(t1, e1, r) {
                            this.singleTap.touchstart(t1, e1, r);
                        }, qn.prototype.touchmove = function(t1, e1, r) {
                            this.singleTap.touchmove(t1, e1, r);
                        }, qn.prototype.touchend = function(t1, e1, r) {
                            var n = this.singleTap.touchend(t1, e1, r);
                            if (n) {
                                var i = t1.timeStamp - this.lastTime < 500, a = !this.lastTap || this.lastTap.dist(n) < 30;
                                if (i && a || this.reset(), this.count++, this.lastTime = t1.timeStamp, this.lastTap = n, this.count === this.numTaps) return this.reset(), n;
                            }
                        };
                        var Gn = function() {
                            this._zoomIn = new qn({
                                numTouches: 1,
                                numTaps: 2
                            }), this._zoomOut = new qn({
                                numTouches: 2,
                                numTaps: 1
                            }), this.reset();
                        };
                        Gn.prototype.reset = function() {
                            this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
                        }, Gn.prototype.touchstart = function(t1, e1, r) {
                            this._zoomIn.touchstart(t1, e1, r), this._zoomOut.touchstart(t1, e1, r);
                        }, Gn.prototype.touchmove = function(t1, e1, r) {
                            this._zoomIn.touchmove(t1, e1, r), this._zoomOut.touchmove(t1, e1, r);
                        }, Gn.prototype.touchend = function(t1, e1, r) {
                            var n = this, i = this._zoomIn.touchend(t1, e1, r), a = this._zoomOut.touchend(t1, e1, r);
                            return i ? (this._active = !0, t1.preventDefault(), setTimeout(function() {
                                return n.reset();
                            }, 0), {
                                cameraAnimation: function(e1) {
                                    return e1.easeTo({
                                        duration: 300,
                                        zoom: e1.getZoom() + 1,
                                        around: e1.unproject(i)
                                    }, {
                                        originalEvent: t1
                                    });
                                }
                            }) : a ? (this._active = !0, t1.preventDefault(), setTimeout(function() {
                                return n.reset();
                            }, 0), {
                                cameraAnimation: function(e1) {
                                    return e1.easeTo({
                                        duration: 300,
                                        zoom: e1.getZoom() - 1,
                                        around: e1.unproject(a)
                                    }, {
                                        originalEvent: t1
                                    });
                                }
                            }) : void 0;
                        }, Gn.prototype.touchcancel = function() {
                            this.reset();
                        }, Gn.prototype.enable = function() {
                            this._enabled = !0;
                        }, Gn.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, Gn.prototype.isEnabled = function() {
                            return this._enabled;
                        }, Gn.prototype.isActive = function() {
                            return this._active;
                        };
                        var Yn = function(t1) {
                            this.reset(), this._clickTolerance = t1.clickTolerance || 1;
                        };
                        Yn.prototype.reset = function() {
                            this._active = !1, this._moved = !1, delete this._lastPoint, delete this._eventButton;
                        }, Yn.prototype._correctButton = function(t1, e1) {
                            return !1;
                        }, Yn.prototype._move = function(t1, e1) {
                            return {};
                        }, Yn.prototype.mousedown = function(t1, e1) {
                            if (!this._lastPoint) {
                                var n = r.mouseButton(t1);
                                this._correctButton(t1, n) && (this._lastPoint = e1, this._eventButton = n);
                            }
                        }, Yn.prototype.mousemoveWindow = function(t1, e1) {
                            var r = this._lastPoint;
                            if (r && (t1.preventDefault(), this._moved || !(e1.dist(r) < this._clickTolerance))) return this._moved = !0, this._lastPoint = e1, this._move(r, e1);
                        }, Yn.prototype.mouseupWindow = function(t1) {
                            r.mouseButton(t1) === this._eventButton && (this._moved && r.suppressClick(), this.reset());
                        }, Yn.prototype.enable = function() {
                            this._enabled = !0;
                        }, Yn.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, Yn.prototype.isEnabled = function() {
                            return this._enabled;
                        }, Yn.prototype.isActive = function() {
                            return this._active;
                        };
                        var Wn = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.mousedown = function(e1, r) {
                                t1.prototype.mousedown.call(this, e1, r), this._lastPoint && (this._active = !0);
                            }, e1.prototype._correctButton = function(t1, e1) {
                                return 0 === e1 && !t1.ctrlKey;
                            }, e1.prototype._move = function(t1, e1) {
                                return {
                                    around: e1,
                                    panDelta: e1.sub(t1)
                                };
                            }, e1;
                        }(Yn), Xn = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._correctButton = function(t1, e1) {
                                return 0 === e1 && t1.ctrlKey || 2 === e1;
                            }, e1.prototype._move = function(t1, e1) {
                                var r = .8 * (e1.x - t1.x);
                                if (r) return this._active = !0, {
                                    bearingDelta: r
                                };
                            }, e1.prototype.contextmenu = function(t1) {
                                t1.preventDefault();
                            }, e1;
                        }(Yn), Zn = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype._correctButton = function(t1, e1) {
                                return 0 === e1 && t1.ctrlKey || 2 === e1;
                            }, e1.prototype._move = function(t1, e1) {
                                var r = -0.5 * (e1.y - t1.y);
                                if (r) return this._active = !0, {
                                    pitchDelta: r
                                };
                            }, e1.prototype.contextmenu = function(t1) {
                                t1.preventDefault();
                            }, e1;
                        }(Yn), Jn = function(t1) {
                            this._minTouches = 1, this._clickTolerance = t1.clickTolerance || 1, this.reset();
                        };
                        Jn.prototype.reset = function() {
                            this._active = !1, this._touches = {}, this._sum = new t1.Point(0, 0);
                        }, Jn.prototype.touchstart = function(t1, e1, r) {
                            return this._calculateTransform(t1, e1, r);
                        }, Jn.prototype.touchmove = function(t1, e1, r) {
                            if (this._active) return t1.preventDefault(), this._calculateTransform(t1, e1, r);
                        }, Jn.prototype.touchend = function(t1, e1, r) {
                            this._calculateTransform(t1, e1, r), this._active && r.length < this._minTouches && this.reset();
                        }, Jn.prototype.touchcancel = function() {
                            this.reset();
                        }, Jn.prototype._calculateTransform = function(e1, r, n) {
                            n.length > 0 && (this._active = !0);
                            var i = Vn(n, r), a = new t1.Point(0, 0), o = new t1.Point(0, 0), s = 0;
                            for(var l in i){
                                var c = i[l], u = this._touches[l];
                                u && (a._add(c), o._add(c.sub(u)), s++, i[l] = c);
                            }
                            if (this._touches = i, !(s < this._minTouches) && o.mag()) {
                                var f = o.div(s);
                                if (this._sum._add(f), !(this._sum.mag() < this._clickTolerance)) return {
                                    around: a.div(s),
                                    panDelta: f
                                };
                            }
                        }, Jn.prototype.enable = function() {
                            this._enabled = !0;
                        }, Jn.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, Jn.prototype.isEnabled = function() {
                            return this._enabled;
                        }, Jn.prototype.isActive = function() {
                            return this._active;
                        };
                        var Kn = function() {
                            this.reset();
                        };
                        function Qn(t1, e1, r) {
                            for(var n = 0; n < t1.length; n++)if (t1[n].identifier === r) return e1[n];
                        }
                        Kn.prototype.reset = function() {
                            this._active = !1, delete this._firstTwoTouches;
                        }, Kn.prototype._start = function(t1) {}, Kn.prototype._move = function(t1, e1, r) {
                            return {};
                        }, Kn.prototype.touchstart = function(t1, e1, r) {
                            this._firstTwoTouches || r.length < 2 || (this._firstTwoTouches = [
                                r[0].identifier,
                                r[1].identifier
                            ], this._start([
                                e1[0],
                                e1[1]
                            ]));
                        }, Kn.prototype.touchmove = function(t1, e1, r) {
                            if (this._firstTwoTouches) {
                                t1.preventDefault();
                                var n = this._firstTwoTouches, i = n[0], a = n[1], o = Qn(r, e1, i), s = Qn(r, e1, a);
                                if (o && s) {
                                    var l = this._aroundCenter ? null : o.add(s).div(2);
                                    return this._move([
                                        o,
                                        s
                                    ], l, t1);
                                }
                            }
                        }, Kn.prototype.touchend = function(t1, e1, n) {
                            if (this._firstTwoTouches) {
                                var i = this._firstTwoTouches, a = i[0], o = i[1], s = Qn(n, e1, a), l = Qn(n, e1, o);
                                s && l || (this._active && r.suppressClick(), this.reset());
                            }
                        }, Kn.prototype.touchcancel = function() {
                            this.reset();
                        }, Kn.prototype.enable = function(t1) {
                            this._enabled = !0, this._aroundCenter = !!t1 && "center" === t1.around;
                        }, Kn.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, Kn.prototype.isEnabled = function() {
                            return this._enabled;
                        }, Kn.prototype.isActive = function() {
                            return this._active;
                        };
                        function $n(t1, e1) {
                            return Math.log(t1 / e1) / Math.LN2;
                        }
                        var ti = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.reset = function() {
                                t1.prototype.reset.call(this), delete this._distance, delete this._startDistance;
                            }, e1.prototype._start = function(t1) {
                                this._startDistance = this._distance = t1[0].dist(t1[1]);
                            }, e1.prototype._move = function(t1, e1) {
                                var r = this._distance;
                                if (this._distance = t1[0].dist(t1[1]), this._active || !(Math.abs($n(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                                    zoomDelta: $n(this._distance, r),
                                    pinchAround: e1
                                };
                            }, e1;
                        }(Kn);
                        function ei(t1, e1) {
                            return 180 * t1.angleWith(e1) / Math.PI;
                        }
                        var ri = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.reset = function() {
                                t1.prototype.reset.call(this), delete this._minDiameter, delete this._startVector, delete this._vector;
                            }, e1.prototype._start = function(t1) {
                                this._startVector = this._vector = t1[0].sub(t1[1]), this._minDiameter = t1[0].dist(t1[1]);
                            }, e1.prototype._move = function(t1, e1) {
                                var r = this._vector;
                                if (this._vector = t1[0].sub(t1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                                    bearingDelta: ei(this._vector, r),
                                    pinchAround: e1
                                };
                            }, e1.prototype._isBelowThreshold = function(t1) {
                                this._minDiameter = Math.min(this._minDiameter, t1.mag());
                                var e1 = 25 / (Math.PI * this._minDiameter) * 360, r = ei(t1, this._startVector);
                                return Math.abs(r) < e1;
                            }, e1;
                        }(Kn);
                        function ni(t1) {
                            return Math.abs(t1.y) > Math.abs(t1.x);
                        }
                        var ii = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1.prototype.reset = function() {
                                t1.prototype.reset.call(this), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
                            }, e1.prototype._start = function(t1) {
                                this._lastPoints = t1, ni(t1[0].sub(t1[1])) && (this._valid = !1);
                            }, e1.prototype._move = function(t1, e1, r) {
                                var n = t1[0].sub(this._lastPoints[0]), i = t1[1].sub(this._lastPoints[1]);
                                if (this._valid = this.gestureBeginsVertically(n, i, r.timeStamp), this._valid) {
                                    this._lastPoints = t1, this._active = !0;
                                    return {
                                        pitchDelta: -0.5 * ((n.y + i.y) / 2)
                                    };
                                }
                            }, e1.prototype.gestureBeginsVertically = function(t1, e1, r) {
                                if (void 0 !== this._valid) return this._valid;
                                var n = t1.mag() >= 2, i = e1.mag() >= 2;
                                if (n || i) {
                                    if (!n || !i) return void 0 === this._firstMove && (this._firstMove = r), r - this._firstMove < 100 && void 0;
                                    var a = t1.y > 0 == e1.y > 0;
                                    return ni(t1) && ni(e1) && a;
                                }
                            }, e1;
                        }(Kn), ai = {
                            panStep: 100,
                            bearingStep: 15,
                            pitchStep: 10
                        }, oi = function() {
                            var t1 = ai;
                            this._panStep = t1.panStep, this._bearingStep = t1.bearingStep, this._pitchStep = t1.pitchStep;
                        };
                        function si(t1) {
                            return t1 * (2 - t1);
                        }
                        oi.prototype.reset = function() {
                            this._active = !1;
                        }, oi.prototype.keydown = function(t1) {
                            var e1 = this;
                            if (!(t1.altKey || t1.ctrlKey || t1.metaKey)) {
                                var r = 0, n = 0, i = 0, a = 0, o = 0;
                                switch(t1.keyCode){
                                    case 61:
                                    case 107:
                                    case 171:
                                    case 187:
                                        r = 1;
                                        break;
                                    case 189:
                                    case 109:
                                    case 173:
                                        r = -1;
                                        break;
                                    case 37:
                                        t1.shiftKey ? n = -1 : (t1.preventDefault(), a = -1);
                                        break;
                                    case 39:
                                        t1.shiftKey ? n = 1 : (t1.preventDefault(), a = 1);
                                        break;
                                    case 38:
                                        t1.shiftKey ? i = 1 : (t1.preventDefault(), o = -1);
                                        break;
                                    case 40:
                                        t1.shiftKey ? i = -1 : (t1.preventDefault(), o = 1);
                                        break;
                                    default:
                                        return;
                                }
                                return {
                                    cameraAnimation: function(s) {
                                        var l = s.getZoom();
                                        s.easeTo({
                                            duration: 300,
                                            easeId: "keyboardHandler",
                                            easing: si,
                                            zoom: r ? Math.round(l) + r * (t1.shiftKey ? 2 : 1) : l,
                                            bearing: s.getBearing() + n * e1._bearingStep,
                                            pitch: s.getPitch() + i * e1._pitchStep,
                                            offset: [
                                                -a * e1._panStep,
                                                -o * e1._panStep
                                            ],
                                            center: s.getCenter()
                                        }, {
                                            originalEvent: t1
                                        });
                                    }
                                };
                            }
                        }, oi.prototype.enable = function() {
                            this._enabled = !0;
                        }, oi.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, oi.prototype.isEnabled = function() {
                            return this._enabled;
                        }, oi.prototype.isActive = function() {
                            return this._active;
                        };
                        var li = function(e1, r) {
                            this._map = e1, this._el = e1.getCanvasContainer(), this._handler = r, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = 1 / 450, t1.bindAll([
                                "_onWheel",
                                "_onTimeout",
                                "_onScrollFrame",
                                "_onScrollFinished"
                            ], this);
                        };
                        li.prototype.setZoomRate = function(t1) {
                            this._defaultZoomRate = t1;
                        }, li.prototype.setWheelZoomRate = function(t1) {
                            this._wheelZoomRate = t1;
                        }, li.prototype.isEnabled = function() {
                            return !!this._enabled;
                        }, li.prototype.isActive = function() {
                            return !!this._active || void 0 !== this._finishTimeout;
                        }, li.prototype.isZooming = function() {
                            return !!this._zooming;
                        }, li.prototype.enable = function(t1) {
                            this.isEnabled() || (this._enabled = !0, this._aroundCenter = t1 && "center" === t1.around);
                        }, li.prototype.disable = function() {
                            this.isEnabled() && (this._enabled = !1);
                        }, li.prototype.wheel = function(e1) {
                            if (this.isEnabled()) {
                                var r = e1.deltaMode === t1.window.WheelEvent.DOM_DELTA_LINE ? 40 * e1.deltaY : e1.deltaY, n = t1.browser.now(), i = n - (this._lastWheelEventTime || 0);
                                this._lastWheelEventTime = n, 0 !== r && r % 4.000244140625 == 0 ? this._type = "wheel" : 0 !== r && Math.abs(r) < 4 ? this._type = "trackpad" : i > 400 ? (this._type = null, this._lastValue = r, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(i * r) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, r += this._lastValue)), e1.shiftKey && r && (r /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= r, this._active || this._start(e1)), e1.preventDefault();
                            }
                        }, li.prototype._onTimeout = function(t1) {
                            this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(t1);
                        }, li.prototype._start = function(e1) {
                            if (this._delta) {
                                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                                var n = r.mousePos(this._el, e1);
                                this._around = t1.LngLat.convert(this._aroundCenter ? this._map.getCenter() : this._map.unproject(n)), this._aroundPoint = this._map.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
                            }
                        }, li.prototype.renderFrame = function() {
                            return this._onScrollFrame();
                        }, li.prototype._onScrollFrame = function() {
                            var e1 = this;
                            if (this._frameId && (this._frameId = null, this.isActive())) {
                                var r = this._map.transform;
                                if (0 !== this._delta) {
                                    var n = "wheel" === this._type && Math.abs(this._delta) > 4.000244140625 ? this._wheelZoomRate : this._defaultZoomRate, i = 2 / (1 + Math.exp(-Math.abs(this._delta * n)));
                                    this._delta < 0 && 0 !== i && (i = 1 / i);
                                    var a = "number" == typeof this._targetZoom ? r.zoomScale(this._targetZoom) : r.scale;
                                    this._targetZoom = Math.min(r.maxZoom, Math.max(r.minZoom, r.scaleZoom(a * i))), "wheel" === this._type && (this._startZoom = r.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                                }
                                var o, s = "number" == typeof this._targetZoom ? this._targetZoom : r.zoom, l = this._startZoom, c = this._easing, u = !1;
                                if ("wheel" === this._type && l && c) {
                                    var f = Math.min((t1.browser.now() - this._lastWheelEventTime) / 200, 1), h = c(f);
                                    o = t1.number(l, s, h), f < 1 ? this._frameId || (this._frameId = !0) : u = !0;
                                } else o = s, u = !0;
                                return this._active = !0, u && (this._active = !1, this._finishTimeout = setTimeout(function() {
                                    e1._zooming = !1, e1._handler._triggerRenderFrame(), delete e1._targetZoom, delete e1._finishTimeout;
                                }, 200)), {
                                    noInertia: !0,
                                    needsRenderFrame: !u,
                                    zoomDelta: o - r.zoom,
                                    around: this._aroundPoint,
                                    originalEvent: this._lastWheelEvent
                                };
                            }
                        }, li.prototype._smoothOutEasing = function(e1) {
                            var r = t1.ease;
                            if (this._prevEase) {
                                var n = this._prevEase, i = (t1.browser.now() - n.start) / n.duration, a = n.easing(i + .01) - n.easing(i), o = .27 / Math.sqrt(a * a + 1e-4) * .01, s = Math.sqrt(.0729 - o * o);
                                r = t1.bezier(o, s, .25, 1);
                            }
                            return this._prevEase = {
                                start: t1.browser.now(),
                                duration: e1,
                                easing: r
                            }, r;
                        }, li.prototype.reset = function() {
                            this._active = !1;
                        };
                        var ci = function(t1, e1) {
                            this._clickZoom = t1, this._tapZoom = e1;
                        };
                        ci.prototype.enable = function() {
                            this._clickZoom.enable(), this._tapZoom.enable();
                        }, ci.prototype.disable = function() {
                            this._clickZoom.disable(), this._tapZoom.disable();
                        }, ci.prototype.isEnabled = function() {
                            return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
                        }, ci.prototype.isActive = function() {
                            return this._clickZoom.isActive() || this._tapZoom.isActive();
                        };
                        var ui = function() {
                            this.reset();
                        };
                        ui.prototype.reset = function() {
                            this._active = !1;
                        }, ui.prototype.dblclick = function(t1, e1) {
                            return t1.preventDefault(), {
                                cameraAnimation: function(r) {
                                    r.easeTo({
                                        duration: 300,
                                        zoom: r.getZoom() + (t1.shiftKey ? -1 : 1),
                                        around: r.unproject(e1)
                                    }, {
                                        originalEvent: t1
                                    });
                                }
                            };
                        }, ui.prototype.enable = function() {
                            this._enabled = !0;
                        }, ui.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, ui.prototype.isEnabled = function() {
                            return this._enabled;
                        }, ui.prototype.isActive = function() {
                            return this._active;
                        };
                        var fi = function() {
                            this._tap = new qn({
                                numTouches: 1,
                                numTaps: 1
                            }), this.reset();
                        };
                        fi.prototype.reset = function() {
                            this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, this._tap.reset();
                        }, fi.prototype.touchstart = function(t1, e1, r) {
                            this._swipePoint || (this._tapTime && t1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? r.length > 0 && (this._swipePoint = e1[0], this._swipeTouch = r[0].identifier) : this._tap.touchstart(t1, e1, r));
                        }, fi.prototype.touchmove = function(t1, e1, r) {
                            if (this._tapTime) {
                                if (this._swipePoint) {
                                    if (r[0].identifier !== this._swipeTouch) return;
                                    var n = e1[0], i = n.y - this._swipePoint.y;
                                    return this._swipePoint = n, t1.preventDefault(), this._active = !0, {
                                        zoomDelta: i / 128
                                    };
                                }
                            } else this._tap.touchmove(t1, e1, r);
                        }, fi.prototype.touchend = function(t1, e1, r) {
                            this._tapTime ? this._swipePoint && 0 === r.length && this.reset() : this._tap.touchend(t1, e1, r) && (this._tapTime = t1.timeStamp);
                        }, fi.prototype.touchcancel = function() {
                            this.reset();
                        }, fi.prototype.enable = function() {
                            this._enabled = !0;
                        }, fi.prototype.disable = function() {
                            this._enabled = !1, this.reset();
                        }, fi.prototype.isEnabled = function() {
                            return this._enabled;
                        }, fi.prototype.isActive = function() {
                            return this._active;
                        };
                        var hi = function(t1, e1, r) {
                            this._el = t1, this._mousePan = e1, this._touchPan = r;
                        };
                        hi.prototype.enable = function(t1) {
                            this._inertiaOptions = t1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
                        }, hi.prototype.disable = function() {
                            this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
                        }, hi.prototype.isEnabled = function() {
                            return this._mousePan.isEnabled() && this._touchPan.isEnabled();
                        }, hi.prototype.isActive = function() {
                            return this._mousePan.isActive() || this._touchPan.isActive();
                        };
                        var pi = function(t1, e1, r) {
                            this._pitchWithRotate = t1.pitchWithRotate, this._mouseRotate = e1, this._mousePitch = r;
                        };
                        pi.prototype.enable = function() {
                            this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
                        }, pi.prototype.disable = function() {
                            this._mouseRotate.disable(), this._mousePitch.disable();
                        }, pi.prototype.isEnabled = function() {
                            return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
                        }, pi.prototype.isActive = function() {
                            return this._mouseRotate.isActive() || this._mousePitch.isActive();
                        };
                        var di = function(t1, e1, r, n) {
                            this._el = t1, this._touchZoom = e1, this._touchRotate = r, this._tapDragZoom = n, this._rotationDisabled = !1, this._enabled = !0;
                        };
                        di.prototype.enable = function(t1) {
                            this._touchZoom.enable(t1), this._rotationDisabled || this._touchRotate.enable(t1), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
                        }, di.prototype.disable = function() {
                            this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
                        }, di.prototype.isEnabled = function() {
                            return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
                        }, di.prototype.isActive = function() {
                            return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
                        }, di.prototype.disableRotation = function() {
                            this._rotationDisabled = !0, this._touchRotate.disable();
                        }, di.prototype.enableRotation = function() {
                            this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
                        };
                        var mi = function(t1) {
                            return t1.zoom || t1.drag || t1.pitch || t1.rotate;
                        }, gi = function(t1) {
                            function e1() {
                                t1.apply(this, arguments);
                            }
                            return t1 && (e1.__proto__ = t1), e1.prototype = Object.create(t1 && t1.prototype), e1.prototype.constructor = e1, e1;
                        }(t1.Event);
                        function vi(t1) {
                            return t1.panDelta && t1.panDelta.mag() || t1.zoomDelta || t1.bearingDelta || t1.pitchDelta;
                        }
                        var yi = function(e1, n) {
                            this._map = e1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new On(e1), this._bearingSnap = n.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(n), t1.bindAll([
                                "handleEvent",
                                "handleWindowEvent"
                            ], this);
                            var i = this._el;
                            this._listeners = [
                                [
                                    i,
                                    "touchstart",
                                    {
                                        passive: !1
                                    }
                                ],
                                [
                                    i,
                                    "touchmove",
                                    {
                                        passive: !1
                                    }
                                ],
                                [
                                    i,
                                    "touchend",
                                    void 0
                                ],
                                [
                                    i,
                                    "touchcancel",
                                    void 0
                                ],
                                [
                                    i,
                                    "mousedown",
                                    void 0
                                ],
                                [
                                    i,
                                    "mousemove",
                                    void 0
                                ],
                                [
                                    i,
                                    "mouseup",
                                    void 0
                                ],
                                [
                                    t1.window.document,
                                    "mousemove",
                                    {
                                        capture: !0
                                    }
                                ],
                                [
                                    t1.window.document,
                                    "mouseup",
                                    void 0
                                ],
                                [
                                    i,
                                    "mouseover",
                                    void 0
                                ],
                                [
                                    i,
                                    "mouseout",
                                    void 0
                                ],
                                [
                                    i,
                                    "dblclick",
                                    void 0
                                ],
                                [
                                    i,
                                    "click",
                                    void 0
                                ],
                                [
                                    i,
                                    "keydown",
                                    {
                                        capture: !1
                                    }
                                ],
                                [
                                    i,
                                    "keyup",
                                    void 0
                                ],
                                [
                                    i,
                                    "wheel",
                                    {
                                        passive: !1
                                    }
                                ],
                                [
                                    i,
                                    "contextmenu",
                                    void 0
                                ],
                                [
                                    t1.window,
                                    "blur",
                                    void 0
                                ]
                            ];
                            for(var a = 0, o = this._listeners; a < o.length; a += 1){
                                var s = o[a], l = s[0], c = s[1], u = s[2];
                                r.addEventListener(l, c, l === t1.window.document ? this.handleWindowEvent : this.handleEvent, u);
                            }
                        };
                        yi.prototype.destroy = function() {
                            for(var e1 = 0, n = this._listeners; e1 < n.length; e1 += 1){
                                var i = n[e1], a = i[0], o = i[1], s = i[2];
                                r.removeEventListener(a, o, a === t1.window.document ? this.handleWindowEvent : this.handleEvent, s);
                            }
                        }, yi.prototype._addDefaultHandlers = function(t1) {
                            var e1 = this._map, r = e1.getCanvasContainer();
                            this._add("mapEvent", new Nn(e1, t1));
                            var n = e1.boxZoom = new Un(e1, t1);
                            this._add("boxZoom", n);
                            var i = new Gn, a = new ui;
                            e1.doubleClickZoom = new ci(a, i), this._add("tapZoom", i), this._add("clickZoom", a);
                            var o = new fi;
                            this._add("tapDragZoom", o);
                            var s = e1.touchPitch = new ii;
                            this._add("touchPitch", s);
                            var l = new Xn(t1), c = new Zn(t1);
                            e1.dragRotate = new pi(t1, l, c), this._add("mouseRotate", l, [
                                "mousePitch"
                            ]), this._add("mousePitch", c, [
                                "mouseRotate"
                            ]);
                            var u = new Wn(t1), f = new Jn(t1);
                            e1.dragPan = new hi(r, u, f), this._add("mousePan", u), this._add("touchPan", f, [
                                "touchZoom",
                                "touchRotate"
                            ]);
                            var h = new ri, p = new ti;
                            e1.touchZoomRotate = new di(r, p, h, o), this._add("touchRotate", h, [
                                "touchPan",
                                "touchZoom"
                            ]), this._add("touchZoom", p, [
                                "touchPan",
                                "touchRotate"
                            ]);
                            var d = e1.scrollZoom = new li(e1, this);
                            this._add("scrollZoom", d, [
                                "mousePan"
                            ]);
                            var m = e1.keyboard = new oi;
                            this._add("keyboard", m), this._add("blockableMapEvent", new jn(e1));
                            for(var g = 0, v = [
                                "boxZoom",
                                "doubleClickZoom",
                                "tapDragZoom",
                                "touchPitch",
                                "dragRotate",
                                "dragPan",
                                "touchZoomRotate",
                                "scrollZoom",
                                "keyboard"
                            ]; g < v.length; g += 1){
                                var y = v[g];
                                t1.interactive && t1[y] && e1[y].enable(t1[y]);
                            }
                        }, yi.prototype._add = function(t1, e1, r) {
                            this._handlers.push({
                                handlerName: t1,
                                handler: e1,
                                allowed: r
                            }), this._handlersById[t1] = e1;
                        }, yi.prototype.stop = function() {
                            if (!this._updatingCamera) {
                                for(var t1 = 0, e1 = this._handlers; t1 < e1.length; t1 += 1)e1[t1].handler.reset();
                                this._inertia.clear(), this._fireEvents({}, {}), this._changes = [];
                            }
                        }, yi.prototype.isActive = function() {
                            for(var t1 = 0, e1 = this._handlers; t1 < e1.length; t1 += 1){
                                if (e1[t1].handler.isActive()) return !0;
                            }
                            return !1;
                        }, yi.prototype.isZooming = function() {
                            return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
                        }, yi.prototype.isRotating = function() {
                            return !!this._eventsInProgress.rotate;
                        }, yi.prototype.isMoving = function() {
                            return Boolean(mi(this._eventsInProgress)) || this.isZooming();
                        }, yi.prototype._blockedByActive = function(t1, e1, r) {
                            for(var n in t1)if (n !== r && (!e1 || e1.indexOf(n) < 0)) return !0;
                            return !1;
                        }, yi.prototype.handleWindowEvent = function(t1) {
                            this.handleEvent(t1, t1.type + "Window");
                        }, yi.prototype._getMapTouches = function(t1) {
                            for(var e1 = [], r = 0, n = t1; r < n.length; r += 1){
                                var i = n[r], a = i.target;
                                this._el.contains(a) && e1.push(i);
                            }
                            return e1;
                        }, yi.prototype.handleEvent = function(t1, e1) {
                            if ("blur" !== t1.type) {
                                this._updatingCamera = !0;
                                for(var n = "renderFrame" === t1.type ? void 0 : t1, i = {
                                    needsRenderFrame: !1
                                }, a = {}, o = {}, s = t1.touches ? this._getMapTouches(t1.touches) : void 0, l = s ? r.touchPos(this._el, s) : r.mousePos(this._el, t1), c = 0, u = this._handlers; c < u.length; c += 1){
                                    var f = u[c], h = f.handlerName, p = f.handler, d = f.allowed;
                                    if (p.isEnabled()) {
                                        var m = void 0;
                                        this._blockedByActive(o, d, h) ? p.reset() : p[e1 || t1.type] && (m = p[e1 || t1.type](t1, l, s), this.mergeHandlerResult(i, a, m, h, n), m && m.needsRenderFrame && this._triggerRenderFrame()), (m || p.isActive()) && (o[h] = p);
                                    }
                                }
                                var g = {};
                                for(var v in this._previousActiveHandlers)o[v] || (g[v] = n);
                                this._previousActiveHandlers = o, (Object.keys(g).length || vi(i)) && (this._changes.push([
                                    i,
                                    a,
                                    g
                                ]), this._triggerRenderFrame()), (Object.keys(o).length || vi(i)) && this._map._stop(!0), this._updatingCamera = !1;
                                var y = i.cameraAnimation;
                                y && (this._inertia.clear(), this._fireEvents({}, {}), this._changes = [], y(this._map));
                            } else this.stop();
                        }, yi.prototype.mergeHandlerResult = function(e1, r, n, i, a) {
                            if (n) {
                                t1.extend(e1, n);
                                var o = {
                                    handlerName: i,
                                    originalEvent: n.originalEvent || a
                                };
                                void 0 !== n.zoomDelta && (r.zoom = o), void 0 !== n.panDelta && (r.drag = o), void 0 !== n.pitchDelta && (r.pitch = o), void 0 !== n.bearingDelta && (r.rotate = o);
                            }
                        }, yi.prototype._applyChanges = function() {
                            for(var e1 = {}, r = {}, n = {}, i = 0, a = this._changes; i < a.length; i += 1){
                                var o = a[i], s = o[0], l = o[1], c = o[2];
                                s.panDelta && (e1.panDelta = (e1.panDelta || new t1.Point(0, 0))._add(s.panDelta)), s.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + s.zoomDelta), s.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + s.bearingDelta), s.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + s.pitchDelta), void 0 !== s.around && (e1.around = s.around), void 0 !== s.pinchAround && (e1.pinchAround = s.pinchAround), s.noInertia && (e1.noInertia = s.noInertia), t1.extend(r, l), t1.extend(n, c);
                            }
                            this._updateMapTransform(e1, r, n), this._changes = [];
                        }, yi.prototype._updateMapTransform = function(t1, e1, r) {
                            var n = this._map, i = n.transform;
                            if (!vi(t1)) return this._fireEvents(e1, r);
                            var a = t1.panDelta, o = t1.zoomDelta, s = t1.bearingDelta, l = t1.pitchDelta, c = t1.around, u = t1.pinchAround;
                            void 0 !== u && (c = u), n._stop(!0), c = c || n.transform.centerPoint;
                            var f = i.pointLocation(a ? c.sub(a) : c);
                            s && (i.bearing += s), l && (i.pitch += l), o && (i.zoom += o), i.setLocationAtPoint(f, c), this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(e1, r);
                        }, yi.prototype._fireEvents = function(e1, r) {
                            var n = this, i = mi(this._eventsInProgress), a = mi(e1), o = {};
                            for(var s in e1){
                                var l = e1[s].originalEvent;
                                this._eventsInProgress[s] || (o[s + "start"] = l), this._eventsInProgress[s] = e1[s];
                            }
                            for(var c in !i && a && this._fireEvent("movestart", a.originalEvent), o)this._fireEvent(c, o[c]);
                            for(var u in e1.rotate && (this._bearingChanged = !0), a && this._fireEvent("move", a.originalEvent), e1){
                                var f = e1[u].originalEvent;
                                this._fireEvent(u, f);
                            }
                            var h, p = {};
                            for(var d in this._eventsInProgress){
                                var m = this._eventsInProgress[d], g = m.handlerName, v = m.originalEvent;
                                this._handlersById[g].isActive() || (delete this._eventsInProgress[d], h = r[g] || v, p[d + "end"] = h);
                            }
                            for(var y in p)this._fireEvent(y, p[y]);
                            var x = mi(this._eventsInProgress);
                            if ((i || a) && !x) {
                                this._updatingCamera = !0;
                                var b = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), _ = function(t1) {
                                    return 0 !== t1 && -n._bearingSnap < t1 && t1 < n._bearingSnap;
                                };
                                b ? (_(b.bearing || this._map.getBearing()) && (b.bearing = 0), this._map.easeTo(b, {
                                    originalEvent: h
                                })) : (this._map.fire(new t1.Event("moveend", {
                                    originalEvent: h
                                })), _(this._map.getBearing()) && this._map.resetNorth()), this._bearingChanged = !1, this._updatingCamera = !1;
                            }
                        }, yi.prototype._fireEvent = function(e1, r) {
                            this._map.fire(new t1.Event(e1, r ? {
                                originalEvent: r
                            } : {}));
                        }, yi.prototype._triggerRenderFrame = function() {
                            var t1 = this;
                            void 0 === this._frameId && (this._frameId = this._map._requestRenderFrame(function(e1) {
                                delete t1._frameId, t1.handleEvent(new gi("renderFrame", {
                                    timeStamp: e1
                                })), t1._applyChanges();
                            }));
                        };
                        var xi = function(e1) {
                            function r(r, n) {
                                e1.call(this), this._moving = !1, this._zooming = !1, this.transform = r, this._bearingSnap = n.bearingSnap, t1.bindAll([
                                    "_renderFrameCallback"
                                ], this);
                            }
                            return e1 && (r.__proto__ = e1), r.prototype = Object.create(e1 && e1.prototype), r.prototype.constructor = r, r.prototype.getCenter = function() {
                                return new t1.LngLat(this.transform.center.lng, this.transform.center.lat);
                            }, r.prototype.setCenter = function(t1, e1) {
                                return this.jumpTo({
                                    center: t1
                                }, e1);
                            }, r.prototype.panBy = function(e1, r, n) {
                                return e1 = t1.Point.convert(e1).mult(-1), this.panTo(this.transform.center, t1.extend({
                                    offset: e1
                                }, r), n);
                            }, r.prototype.panTo = function(e1, r, n) {
                                return this.easeTo(t1.extend({
                                    center: e1
                                }, r), n);
                            }, r.prototype.getZoom = function() {
                                return this.transform.zoom;
                            }, r.prototype.setZoom = function(t1, e1) {
                                return this.jumpTo({
                                    zoom: t1
                                }, e1), this;
                            }, r.prototype.zoomTo = function(e1, r, n) {
                                return this.easeTo(t1.extend({
                                    zoom: e1
                                }, r), n);
                            }, r.prototype.zoomIn = function(t1, e1) {
                                return this.zoomTo(this.getZoom() + 1, t1, e1), this;
                            }, r.prototype.zoomOut = function(t1, e1) {
                                return this.zoomTo(this.getZoom() - 1, t1, e1), this;
                            }, r.prototype.getBearing = function() {
                                return this.transform.bearing;
                            }, r.prototype.setBearing = function(t1, e1) {
                                return this.jumpTo({
                                    bearing: t1
                                }, e1), this;
                            }, r.prototype.getPadding = function() {
                                return this.transform.padding;
                            }, r.prototype.setPadding = function(t1, e1) {
                                return this.jumpTo({
                                    padding: t1
                                }, e1), this;
                            }, r.prototype.rotateTo = function(e1, r, n) {
                                return this.easeTo(t1.extend({
                                    bearing: e1
                                }, r), n);
                            }, r.prototype.resetNorth = function(e1, r) {
                                return this.rotateTo(0, t1.extend({
                                    duration: 1e3
                                }, e1), r), this;
                            }, r.prototype.resetNorthPitch = function(e1, r) {
                                return this.easeTo(t1.extend({
                                    bearing: 0,
                                    pitch: 0,
                                    duration: 1e3
                                }, e1), r), this;
                            }, r.prototype.snapToNorth = function(t1, e1) {
                                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(t1, e1) : this;
                            }, r.prototype.getPitch = function() {
                                return this.transform.pitch;
                            }, r.prototype.setPitch = function(t1, e1) {
                                return this.jumpTo({
                                    pitch: t1
                                }, e1), this;
                            }, r.prototype.cameraForBounds = function(e1, r) {
                                return e1 = t1.LngLatBounds.convert(e1), this._cameraForBoxAndBearing(e1.getNorthWest(), e1.getSouthEast(), 0, r);
                            }, r.prototype._cameraForBoxAndBearing = function(e1, r, n, i) {
                                var a = {
                                    top: 0,
                                    bottom: 0,
                                    right: 0,
                                    left: 0
                                };
                                if ("number" == typeof (i = t1.extend({
                                    padding: a,
                                    offset: [
                                        0,
                                        0
                                    ],
                                    maxZoom: this.transform.maxZoom
                                }, i)).padding) {
                                    var o = i.padding;
                                    i.padding = {
                                        top: o,
                                        bottom: o,
                                        right: o,
                                        left: o
                                    };
                                }
                                i.padding = t1.extend(a, i.padding);
                                var s = this.transform, l = s.padding, c = s.project(t1.LngLat.convert(e1)), u = s.project(t1.LngLat.convert(r)), f = c.rotate(-n * Math.PI / 180), h = u.rotate(-n * Math.PI / 180), p = new t1.Point(Math.max(f.x, h.x), Math.max(f.y, h.y)), d = new t1.Point(Math.min(f.x, h.x), Math.min(f.y, h.y)), m = p.sub(d), g = (s.width - (l.left + l.right + i.padding.left + i.padding.right)) / m.x, v = (s.height - (l.top + l.bottom + i.padding.top + i.padding.bottom)) / m.y;
                                if (!(v < 0 || g < 0)) {
                                    var y = Math.min(s.scaleZoom(s.scale * Math.min(g, v)), i.maxZoom), x = t1.Point.convert(i.offset), b = (i.padding.left - i.padding.right) / 2, _ = (i.padding.top - i.padding.bottom) / 2, w = new t1.Point(x.x + b, x.y + _).mult(s.scale / s.zoomScale(y));
                                    return {
                                        center: s.unproject(c.add(u).div(2).sub(w)),
                                        zoom: y,
                                        bearing: n
                                    };
                                }
                                t1.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                            }, r.prototype.fitBounds = function(t1, e1, r) {
                                return this._fitInternal(this.cameraForBounds(t1, e1), e1, r);
                            }, r.prototype.fitScreenCoordinates = function(e1, r, n, i, a) {
                                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t1.Point.convert(e1)), this.transform.pointLocation(t1.Point.convert(r)), n, i), i, a);
                            }, r.prototype._fitInternal = function(e1, r, n) {
                                return e1 ? (delete (r = t1.extend(e1, r)).padding, r.linear ? this.easeTo(r, n) : this.flyTo(r, n)) : this;
                            }, r.prototype.jumpTo = function(e1, r) {
                                this.stop();
                                var n = this.transform, i = !1, a = !1, o = !1;
                                return "zoom" in e1 && n.zoom !== +e1.zoom && (i = !0, n.zoom = +e1.zoom), void 0 !== e1.center && (n.center = t1.LngLat.convert(e1.center)), "bearing" in e1 && n.bearing !== +e1.bearing && (a = !0, n.bearing = +e1.bearing), "pitch" in e1 && n.pitch !== +e1.pitch && (o = !0, n.pitch = +e1.pitch), null == e1.padding || n.isPaddingEqual(e1.padding) || (n.padding = e1.padding), this.fire(new t1.Event("movestart", r)).fire(new t1.Event("move", r)), i && this.fire(new t1.Event("zoomstart", r)).fire(new t1.Event("zoom", r)).fire(new t1.Event("zoomend", r)), a && this.fire(new t1.Event("rotatestart", r)).fire(new t1.Event("rotate", r)).fire(new t1.Event("rotateend", r)), o && this.fire(new t1.Event("pitchstart", r)).fire(new t1.Event("pitch", r)).fire(new t1.Event("pitchend", r)), this.fire(new t1.Event("moveend", r));
                            }, r.prototype.easeTo = function(e1, r) {
                                var n = this;
                                this._stop(!1, e1.easeId), (!1 === (e1 = t1.extend({
                                    offset: [
                                        0,
                                        0
                                    ],
                                    duration: 500,
                                    easing: t1.ease
                                }, e1)).animate || !e1.essential && t1.browser.prefersReducedMotion) && (e1.duration = 0);
                                var i = this.transform, a = this.getZoom(), o = this.getBearing(), s = this.getPitch(), l = this.getPadding(), c = "zoom" in e1 ? +e1.zoom : a, u = "bearing" in e1 ? this._normalizeBearing(e1.bearing, o) : o, f = "pitch" in e1 ? +e1.pitch : s, h = "padding" in e1 ? e1.padding : i.padding, p = t1.Point.convert(e1.offset), d = i.centerPoint.add(p), m = i.pointLocation(d), g = t1.LngLat.convert(e1.center || m);
                                this._normalizeCenter(g);
                                var v, y, x = i.project(m), b = i.project(g).sub(x), _ = i.zoomScale(c - a);
                                e1.around && (v = t1.LngLat.convert(e1.around), y = i.locationPoint(v));
                                var w = {
                                    moving: this._moving,
                                    zooming: this._zooming,
                                    rotating: this._rotating,
                                    pitching: this._pitching
                                };
                                return this._zooming = this._zooming || c !== a, this._rotating = this._rotating || o !== u, this._pitching = this._pitching || f !== s, this._padding = !i.isPaddingEqual(h), this._easeId = e1.easeId, this._prepareEase(r, e1.noMoveStart, w), clearTimeout(this._easeEndTimeoutID), this._ease(function(e1) {
                                    if (n._zooming && (i.zoom = t1.number(a, c, e1)), n._rotating && (i.bearing = t1.number(o, u, e1)), n._pitching && (i.pitch = t1.number(s, f, e1)), n._padding && (i.interpolatePadding(l, h, e1), d = i.centerPoint.add(p)), v) i.setLocationAtPoint(v, y);
                                    else {
                                        var m = i.zoomScale(i.zoom - a), g = c > a ? Math.min(2, _) : Math.max(.5, _), w = Math.pow(g, 1 - e1), T = i.unproject(x.add(b.mult(e1 * w)).mult(m));
                                        i.setLocationAtPoint(i.renderWorldCopies ? T.wrap() : T, d);
                                    }
                                    n._fireMoveEvents(r);
                                }, function(t1) {
                                    n._afterEase(r, t1);
                                }, e1), this;
                            }, r.prototype._prepareEase = function(e1, r, n) {
                                void 0 === n && (n = {}), this._moving = !0, r || n.moving || this.fire(new t1.Event("movestart", e1)), this._zooming && !n.zooming && this.fire(new t1.Event("zoomstart", e1)), this._rotating && !n.rotating && this.fire(new t1.Event("rotatestart", e1)), this._pitching && !n.pitching && this.fire(new t1.Event("pitchstart", e1));
                            }, r.prototype._fireMoveEvents = function(e1) {
                                this.fire(new t1.Event("move", e1)), this._zooming && this.fire(new t1.Event("zoom", e1)), this._rotating && this.fire(new t1.Event("rotate", e1)), this._pitching && this.fire(new t1.Event("pitch", e1));
                            }, r.prototype._afterEase = function(e1, r) {
                                if (!this._easeId || !r || this._easeId !== r) {
                                    delete this._easeId;
                                    var n = this._zooming, i = this._rotating, a = this._pitching;
                                    this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, n && this.fire(new t1.Event("zoomend", e1)), i && this.fire(new t1.Event("rotateend", e1)), a && this.fire(new t1.Event("pitchend", e1)), this.fire(new t1.Event("moveend", e1));
                                }
                            }, r.prototype.flyTo = function(e1, r) {
                                var n = this;
                                if (!e1.essential && t1.browser.prefersReducedMotion) {
                                    var i = t1.pick(e1, [
                                        "center",
                                        "zoom",
                                        "bearing",
                                        "pitch",
                                        "around"
                                    ]);
                                    return this.jumpTo(i, r);
                                }
                                this.stop(), e1 = t1.extend({
                                    offset: [
                                        0,
                                        0
                                    ],
                                    speed: 1.2,
                                    curve: 1.42,
                                    easing: t1.ease
                                }, e1);
                                var a = this.transform, o = this.getZoom(), s = this.getBearing(), l = this.getPitch(), c = this.getPadding(), u = "zoom" in e1 ? t1.clamp(+e1.zoom, a.minZoom, a.maxZoom) : o, f = "bearing" in e1 ? this._normalizeBearing(e1.bearing, s) : s, h = "pitch" in e1 ? +e1.pitch : l, p = "padding" in e1 ? e1.padding : a.padding, d = a.zoomScale(u - o), m = t1.Point.convert(e1.offset), g = a.centerPoint.add(m), v = a.pointLocation(g), y = t1.LngLat.convert(e1.center || v);
                                this._normalizeCenter(y);
                                var x = a.project(v), b = a.project(y).sub(x), _ = e1.curve, w = Math.max(a.width, a.height), T = w / d, k = b.mag();
                                if ("minZoom" in e1) {
                                    var A = t1.clamp(Math.min(e1.minZoom, o, u), a.minZoom, a.maxZoom), M = w / a.zoomScale(A - o);
                                    _ = Math.sqrt(M / k * 2);
                                }
                                var S = _ * _;
                                function E(t1) {
                                    var e1 = (T * T - w * w + (t1 ? -1 : 1) * S * S * k * k) / (2 * (t1 ? T : w) * S * k);
                                    return Math.log(Math.sqrt(e1 * e1 + 1) - e1);
                                }
                                function L(t1) {
                                    return (Math.exp(t1) - Math.exp(-t1)) / 2;
                                }
                                function C(t1) {
                                    return (Math.exp(t1) + Math.exp(-t1)) / 2;
                                }
                                var P = E(0), I = function(t1) {
                                    return C(P) / C(P + _ * t1);
                                }, O = function(t1) {
                                    var e1;
                                    return w * ((C(P) * (L(e1 = P + _ * t1) / C(e1)) - L(P)) / S) / k;
                                }, z = (E(1) - P) / _;
                                if (Math.abs(k) < 1e-6 || !isFinite(z)) {
                                    if (Math.abs(w - T) < 1e-6) return this.easeTo(e1, r);
                                    var D = T < w ? -1 : 1;
                                    z = Math.abs(Math.log(T / w)) / _, O = function() {
                                        return 0;
                                    }, I = function(t1) {
                                        return Math.exp(D * _ * t1);
                                    };
                                }
                                if ("duration" in e1) e1.duration = +e1.duration;
                                else {
                                    var R = "screenSpeed" in e1 ? +e1.screenSpeed / _ : +e1.speed;
                                    e1.duration = 1e3 * z / R;
                                }
                                return e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = s !== f, this._pitching = h !== l, this._padding = !a.isPaddingEqual(p), this._prepareEase(r, !1), this._ease(function(e1) {
                                    var i = e1 * z, d = 1 / I(i);
                                    a.zoom = 1 === e1 ? u : o + a.scaleZoom(d), n._rotating && (a.bearing = t1.number(s, f, e1)), n._pitching && (a.pitch = t1.number(l, h, e1)), n._padding && (a.interpolatePadding(c, p, e1), g = a.centerPoint.add(m));
                                    var v = 1 === e1 ? y : a.unproject(x.add(b.mult(O(i))).mult(d));
                                    a.setLocationAtPoint(a.renderWorldCopies ? v.wrap() : v, g), n._fireMoveEvents(r);
                                }, function() {
                                    return n._afterEase(r);
                                }, e1), this;
                            }, r.prototype.isEasing = function() {
                                return !!this._easeFrameId;
                            }, r.prototype.stop = function() {
                                return this._stop();
                            }, r.prototype._stop = function(t1, e1) {
                                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                                    var r = this._onEaseEnd;
                                    delete this._onEaseEnd, r.call(this, e1);
                                }
                                if (!t1) {
                                    var n = this.handlers;
                                    n && n.stop();
                                }
                                return this;
                            }, r.prototype._ease = function(e1, r, n) {
                                !1 === n.animate || 0 === n.duration ? (e1(1), r()) : (this._easeStart = t1.browser.now(), this._easeOptions = n, this._onEaseFrame = e1, this._onEaseEnd = r, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
                            }, r.prototype._renderFrameCallback = function() {
                                var e1 = Math.min((t1.browser.now() - this._easeStart) / this._easeOptions.duration, 1);
                                this._onEaseFrame(this._easeOptions.easing(e1)), e1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                            }, r.prototype._normalizeBearing = function(e1, r) {
                                e1 = t1.wrap(e1, -180, 180);
                                var n = Math.abs(e1 - r);
                                return Math.abs(e1 - 360 - r) < n && (e1 -= 360), Math.abs(e1 + 360 - r) < n && (e1 += 360), e1;
                            }, r.prototype._normalizeCenter = function(t1) {
                                var e1 = this.transform;
                                if (e1.renderWorldCopies && !e1.lngRange) {
                                    var r = t1.lng - e1.center.lng;
                                    t1.lng += r > 180 ? -360 : r < -180 ? 360 : 0;
                                }
                            }, r;
                        }(t1.Evented), bi = function(e1) {
                            void 0 === e1 && (e1 = {}), this.options = e1, t1.bindAll([
                                "_updateEditLink",
                                "_updateData",
                                "_updateCompact"
                            ], this);
                        };
                        bi.prototype.getDefaultPosition = function() {
                            return "bottom-right";
                        }, bi.prototype.onAdd = function(t1) {
                            var e1 = this.options && this.options.compact;
                            return this._map = t1, this._container = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._innerContainer = r.create("div", "mapboxgl-ctrl-attrib-inner", this._container), e1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === e1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
                        }, bi.prototype.onRemove = function() {
                            r.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
                        }, bi.prototype._updateEditLink = function() {
                            var e1 = this._editLink;
                            e1 || (e1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                            var r = [
                                {
                                    key: "owner",
                                    value: this.styleOwner
                                },
                                {
                                    key: "id",
                                    value: this.styleId
                                },
                                {
                                    key: "access_token",
                                    value: this._map._requestManager._customAccessToken || t1.config.ACCESS_TOKEN
                                }
                            ];
                            if (e1) {
                                var n = r.reduce(function(t1, e1, n) {
                                    return e1.value && (t1 += e1.key + "=" + e1.value + (n < r.length - 1 ? "&" : "")), t1;
                                }, "?");
                                e1.href = t1.config.FEEDBACK_URL + "/" + n + (this._map._hash ? this._map._hash.getHashString(!0) : ""), e1.rel = "noopener nofollow";
                            }
                        }, bi.prototype._updateData = function(t1) {
                            !t1 || "metadata" !== t1.sourceDataType && "style" !== t1.dataType || (this._updateAttributions(), this._updateEditLink());
                        }, bi.prototype._updateAttributions = function() {
                            if (this._map.style) {
                                var t1 = [];
                                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? t1 = t1.concat(this.options.customAttribution.map(function(t1) {
                                    return "string" != typeof t1 ? "" : t1;
                                })) : "string" == typeof this.options.customAttribution && t1.push(this.options.customAttribution)), this._map.style.stylesheet) {
                                    var e1 = this._map.style.stylesheet;
                                    this.styleOwner = e1.owner, this.styleId = e1.id;
                                }
                                var r = this._map.style.sourceCaches;
                                for(var n in r){
                                    var i = r[n];
                                    if (i.used) {
                                        var a = i.getSource();
                                        a.attribution && t1.indexOf(a.attribution) < 0 && t1.push(a.attribution);
                                    }
                                }
                                t1.sort(function(t1, e1) {
                                    return t1.length - e1.length;
                                });
                                var o = (t1 = t1.filter(function(e1, r) {
                                    for(var n = r + 1; n < t1.length; n++)if (t1[n].indexOf(e1) >= 0) return !1;
                                    return !0;
                                })).join(" | ");
                                o !== this._attribHTML && (this._attribHTML = o, t1.length ? (this._innerContainer.innerHTML = o, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
                            }
                        }, bi.prototype._updateCompact = function() {
                            this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact");
                        };
                        var _i = function() {
                            t1.bindAll([
                                "_updateLogo"
                            ], this), t1.bindAll([
                                "_updateCompact"
                            ], this);
                        };
                        _i.prototype.onAdd = function(t1) {
                            this._map = t1, this._container = r.create("div", "mapboxgl-ctrl");
                            var e1 = r.create("a", "mapboxgl-ctrl-logo");
                            return e1.target = "_blank", e1.rel = "noopener nofollow", e1.href = "https://www.mapbox.com/", e1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), e1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(e1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
                        }, _i.prototype.onRemove = function() {
                            r.remove(this._container), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
                        }, _i.prototype.getDefaultPosition = function() {
                            return "bottom-left";
                        }, _i.prototype._updateLogo = function(t1) {
                            t1 && "metadata" !== t1.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
                        }, _i.prototype._logoRequired = function() {
                            if (this._map.style) {
                                var t1 = this._map.style.sourceCaches;
                                for(var e1 in t1){
                                    if (t1[e1].getSource().mapbox_logo) return !0;
                                }
                                return !1;
                            }
                        }, _i.prototype._updateCompact = function() {
                            var t1 = this._container.children;
                            if (t1.length) {
                                var e1 = t1[0];
                                this._map.getCanvasContainer().offsetWidth < 250 ? e1.classList.add("mapboxgl-compact") : e1.classList.remove("mapboxgl-compact");
                            }
                        };
                        var wi = function() {
                            this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
                        };
                        wi.prototype.add = function(t1) {
                            var e1 = ++this._id;
                            return this._queue.push({
                                callback: t1,
                                id: e1,
                                cancelled: !1
                            }), e1;
                        }, wi.prototype.remove = function(t1) {
                            for(var e1 = this._currentlyRunning, r = 0, n = e1 ? this._queue.concat(e1) : this._queue; r < n.length; r += 1){
                                var i = n[r];
                                if (i.id === t1) return void (i.cancelled = !0);
                            }
                        }, wi.prototype.run = function(t1) {
                            void 0 === t1 && (t1 = 0);
                            var e1 = this._currentlyRunning = this._queue;
                            this._queue = [];
                            for(var r = 0, n = e1; r < n.length; r += 1){
                                var i = n[r];
                                if (!i.cancelled && (i.callback(t1), this._cleared)) break;
                            }
                            this._cleared = !1, this._currentlyRunning = !1;
                        }, wi.prototype.clear = function() {
                            this._currentlyRunning && (this._cleared = !0), this._queue = [];
                        };
                        var Ti = {
                            "FullscreenControl.Enter": "Enter fullscreen",
                            "FullscreenControl.Exit": "Exit fullscreen",
                            "GeolocateControl.FindMyLocation": "Find my location",
                            "GeolocateControl.LocationNotAvailable": "Location not available",
                            "LogoControl.Title": "Mapbox logo",
                            "NavigationControl.ResetBearing": "Reset bearing to north",
                            "NavigationControl.ZoomIn": "Zoom in",
                            "NavigationControl.ZoomOut": "Zoom out",
                            "ScaleControl.Feet": "ft",
                            "ScaleControl.Meters": "m",
                            "ScaleControl.Kilometers": "km",
                            "ScaleControl.Miles": "mi",
                            "ScaleControl.NauticalMiles": "nm"
                        }, ki = t1.window.HTMLImageElement, Ai = t1.window.HTMLElement, Mi = t1.window.ImageBitmap, Si = {
                            center: [
                                0,
                                0
                            ],
                            zoom: 0,
                            bearing: 0,
                            pitch: 0,
                            minZoom: -2,
                            maxZoom: 22,
                            minPitch: 0,
                            maxPitch: 60,
                            interactive: !0,
                            scrollZoom: !0,
                            boxZoom: !0,
                            dragRotate: !0,
                            dragPan: !0,
                            keyboard: !0,
                            doubleClickZoom: !0,
                            touchZoomRotate: !0,
                            touchPitch: !0,
                            bearingSnap: 7,
                            clickTolerance: 3,
                            pitchWithRotate: !0,
                            hash: !1,
                            attributionControl: !0,
                            failIfMajorPerformanceCaveat: !1,
                            preserveDrawingBuffer: !1,
                            trackResize: !0,
                            renderWorldCopies: !0,
                            refreshExpiredTiles: !0,
                            maxTileCacheSize: null,
                            localIdeographFontFamily: "sans-serif",
                            transformRequest: null,
                            accessToken: null,
                            fadeDuration: 300,
                            crossSourceCollisions: !0
                        }, Ei = function(n) {
                            function i(e1) {
                                var r = this;
                                if (null != (e1 = t1.extend({}, Si, e1)).minZoom && null != e1.maxZoom && e1.minZoom > e1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                                if (null != e1.minPitch && null != e1.maxPitch && e1.minPitch > e1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                                if (null != e1.minPitch && e1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                                if (null != e1.maxPitch && e1.maxPitch > 60) throw new Error("maxPitch must be less than or equal to 60");
                                var i = new An(e1.minZoom, e1.maxZoom, e1.minPitch, e1.maxPitch, e1.renderWorldCopies);
                                if (n.call(this, i, e1), this._interactive = e1.interactive, this._maxTileCacheSize = e1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = e1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = e1.preserveDrawingBuffer, this._antialias = e1.antialias, this._trackResize = e1.trackResize, this._bearingSnap = e1.bearingSnap, this._refreshExpiredTiles = e1.refreshExpiredTiles, this._fadeDuration = e1.fadeDuration, this._crossSourceCollisions = e1.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = e1.collectResourceTiming, this._renderTaskQueue = new wi, this._controls = [], this._mapId = t1.uniqueId(), this._locale = t1.extend({}, Ti, e1.locale), this._requestManager = new t1.RequestManager(e1.transformRequest, e1.accessToken), "string" == typeof e1.container) {
                                    if (this._container = t1.window.document.getElementById(e1.container), !this._container) throw new Error("Container '" + e1.container + "' not found.");
                                } else {
                                    if (!(e1.container instanceof Ai)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                                    this._container = e1.container;
                                }
                                if (e1.maxBounds && this.setMaxBounds(e1.maxBounds), t1.bindAll([
                                    "_onWindowOnline",
                                    "_onWindowResize",
                                    "_contextLost",
                                    "_contextRestored"
                                ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                                this.on("move", function() {
                                    return r._update(!1);
                                }), this.on("moveend", function() {
                                    return r._update(!1);
                                }), this.on("zoom", function() {
                                    return r._update(!0);
                                }), void 0 !== t1.window && (t1.window.addEventListener("online", this._onWindowOnline, !1), t1.window.addEventListener("resize", this._onWindowResize, !1)), this.handlers = new yi(this, e1);
                                var a = "string" == typeof e1.hash && e1.hash || void 0;
                                this._hash = e1.hash && new Sn(a).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                                    center: e1.center,
                                    zoom: e1.zoom,
                                    bearing: e1.bearing,
                                    pitch: e1.pitch
                                }), e1.bounds && (this.resize(), this.fitBounds(e1.bounds, t1.extend({}, e1.fitBoundsOptions, {
                                    duration: 0
                                })))), this.resize(), this._localIdeographFontFamily = e1.localIdeographFontFamily, e1.style && this.setStyle(e1.style, {
                                    localIdeographFontFamily: e1.localIdeographFontFamily
                                }), e1.attributionControl && this.addControl(new bi({
                                    customAttribution: e1.customAttribution
                                })), this.addControl(new _i, e1.logoPosition), this.on("style.load", function() {
                                    r.transform.unmodified && r.jumpTo(r.style.stylesheet);
                                }), this.on("data", function(e1) {
                                    r._update("style" === e1.dataType), r.fire(new t1.Event(e1.dataType + "data", e1));
                                }), this.on("dataloading", function(e1) {
                                    r.fire(new t1.Event(e1.dataType + "dataloading", e1));
                                });
                            }
                            n && (i.__proto__ = n), i.prototype = Object.create(n && n.prototype), i.prototype.constructor = i;
                            var a = {
                                showTileBoundaries: {
                                    configurable: !0
                                },
                                showPadding: {
                                    configurable: !0
                                },
                                showCollisionBoxes: {
                                    configurable: !0
                                },
                                showOverdrawInspector: {
                                    configurable: !0
                                },
                                repaint: {
                                    configurable: !0
                                },
                                vertices: {
                                    configurable: !0
                                },
                                version: {
                                    configurable: !0
                                }
                            };
                            return i.prototype._getMapId = function() {
                                return this._mapId;
                            }, i.prototype.addControl = function(e1, r) {
                                if (void 0 === r && e1.getDefaultPosition && (r = e1.getDefaultPosition()), void 0 === r && (r = "top-right"), !e1 || !e1.onAdd) return this.fire(new t1.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                                var n = e1.onAdd(this);
                                this._controls.push(e1);
                                var i = this._controlPositions[r];
                                return -1 !== r.indexOf("bottom") ? i.insertBefore(n, i.firstChild) : i.appendChild(n), this;
                            }, i.prototype.removeControl = function(e1) {
                                if (!e1 || !e1.onRemove) return this.fire(new t1.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                                var r = this._controls.indexOf(e1);
                                return r > -1 && this._controls.splice(r, 1), e1.onRemove(this), this;
                            }, i.prototype.resize = function(e1) {
                                var r = this._containerDimensions(), n = r[0], i = r[1];
                                this._resizeCanvas(n, i), this.transform.resize(n, i), this.painter.resize(n, i);
                                var a = !this._moving;
                                return a && (this.stop(), this.fire(new t1.Event("movestart", e1)).fire(new t1.Event("move", e1))), this.fire(new t1.Event("resize", e1)), a && this.fire(new t1.Event("moveend", e1)), this;
                            }, i.prototype.getBounds = function() {
                                return this.transform.getBounds();
                            }, i.prototype.getMaxBounds = function() {
                                return this.transform.getMaxBounds();
                            }, i.prototype.setMaxBounds = function(e1) {
                                return this.transform.setMaxBounds(t1.LngLatBounds.convert(e1)), this._update();
                            }, i.prototype.setMinZoom = function(t1) {
                                if ((t1 = null == t1 ? -2 : t1) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 && this.setZoom(t1), this;
                                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                            }, i.prototype.getMinZoom = function() {
                                return this.transform.minZoom;
                            }, i.prototype.setMaxZoom = function(t1) {
                                if ((t1 = null == t1 ? 22 : t1) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 && this.setZoom(t1), this;
                                throw new Error("maxZoom must be greater than the current minZoom");
                            }, i.prototype.getMaxZoom = function() {
                                return this.transform.maxZoom;
                            }, i.prototype.setMinPitch = function(t1) {
                                if ((t1 = null == t1 ? 0 : t1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                                if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 && this.setPitch(t1), this;
                                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                            }, i.prototype.getMinPitch = function() {
                                return this.transform.minPitch;
                            }, i.prototype.setMaxPitch = function(t1) {
                                if ((t1 = null == t1 ? 60 : t1) > 60) throw new Error("maxPitch must be less than or equal to 60");
                                if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 && this.setPitch(t1), this;
                                throw new Error("maxPitch must be greater than the current minPitch");
                            }, i.prototype.getMaxPitch = function() {
                                return this.transform.maxPitch;
                            }, i.prototype.getRenderWorldCopies = function() {
                                return this.transform.renderWorldCopies;
                            }, i.prototype.setRenderWorldCopies = function(t1) {
                                return this.transform.renderWorldCopies = t1, this._update();
                            }, i.prototype.project = function(e1) {
                                return this.transform.locationPoint(t1.LngLat.convert(e1));
                            }, i.prototype.unproject = function(e1) {
                                return this.transform.pointLocation(t1.Point.convert(e1));
                            }, i.prototype.isMoving = function() {
                                return this._moving || this.handlers.isMoving();
                            }, i.prototype.isZooming = function() {
                                return this._zooming || this.handlers.isZooming();
                            }, i.prototype.isRotating = function() {
                                return this._rotating || this.handlers.isRotating();
                            }, i.prototype._createDelegatedListener = function(t1, e1, r) {
                                var n, i = this;
                                if ("mouseenter" === t1 || "mouseover" === t1) {
                                    var a = !1;
                                    return {
                                        layer: e1,
                                        listener: r,
                                        delegates: {
                                            mousemove: function(n) {
                                                var o = i.getLayer(e1) ? i.queryRenderedFeatures(n.point, {
                                                    layers: [
                                                        e1
                                                    ]
                                                }) : [];
                                                o.length ? a || (a = !0, r.call(i, new Rn(t1, i, n.originalEvent, {
                                                    features: o
                                                }))) : a = !1;
                                            },
                                            mouseout: function() {
                                                a = !1;
                                            }
                                        }
                                    };
                                }
                                if ("mouseleave" === t1 || "mouseout" === t1) {
                                    var o = !1;
                                    return {
                                        layer: e1,
                                        listener: r,
                                        delegates: {
                                            mousemove: function(n) {
                                                (i.getLayer(e1) ? i.queryRenderedFeatures(n.point, {
                                                    layers: [
                                                        e1
                                                    ]
                                                }) : []).length ? o = !0 : o && (o = !1, r.call(i, new Rn(t1, i, n.originalEvent)));
                                            },
                                            mouseout: function(e1) {
                                                o && (o = !1, r.call(i, new Rn(t1, i, e1.originalEvent)));
                                            }
                                        }
                                    };
                                }
                                return {
                                    layer: e1,
                                    listener: r,
                                    delegates: (n = {}, n[t1] = function(t1) {
                                        var n = i.getLayer(e1) ? i.queryRenderedFeatures(t1.point, {
                                            layers: [
                                                e1
                                            ]
                                        }) : [];
                                        n.length && (t1.features = n, r.call(i, t1), delete t1.features);
                                    }, n)
                                };
                            }, i.prototype.on = function(t1, e1, r) {
                                if (void 0 === r) return n.prototype.on.call(this, t1, e1);
                                var i = this._createDelegatedListener(t1, e1, r);
                                for(var a in this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[t1] = this._delegatedListeners[t1] || [], this._delegatedListeners[t1].push(i), i.delegates)this.on(a, i.delegates[a]);
                                return this;
                            }, i.prototype.once = function(t1, e1, r) {
                                if (void 0 === r) return n.prototype.once.call(this, t1, e1);
                                var i = this._createDelegatedListener(t1, e1, r);
                                for(var a in i.delegates)this.once(a, i.delegates[a]);
                                return this;
                            }, i.prototype.off = function(t1, e1, r) {
                                var i = this;
                                if (void 0 === r) return n.prototype.off.call(this, t1, e1);
                                return this._delegatedListeners && this._delegatedListeners[t1] && function(n) {
                                    for(var a = n[t1], o = 0; o < a.length; o++){
                                        var s = a[o];
                                        if (s.layer === e1 && s.listener === r) {
                                            for(var l in s.delegates)i.off(l, s.delegates[l]);
                                            return a.splice(o, 1), i;
                                        }
                                    }
                                }(this._delegatedListeners), this;
                            }, i.prototype.queryRenderedFeatures = function(e1, r) {
                                if (!this.style) return [];
                                var n;
                                if (void 0 !== r || void 0 === e1 || e1 instanceof t1.Point || Array.isArray(e1) || (r = e1, e1 = void 0), r = r || {}, (e1 = e1 || [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        this.transform.width,
                                        this.transform.height
                                    ]
                                ]) instanceof t1.Point || "number" == typeof e1[0]) n = [
                                    t1.Point.convert(e1)
                                ];
                                else {
                                    var i = t1.Point.convert(e1[0]), a = t1.Point.convert(e1[1]);
                                    n = [
                                        i,
                                        new t1.Point(a.x, i.y),
                                        a,
                                        new t1.Point(i.x, a.y),
                                        i
                                    ];
                                }
                                return this.style.queryRenderedFeatures(n, r, this.transform);
                            }, i.prototype.querySourceFeatures = function(t1, e1) {
                                return this.style.querySourceFeatures(t1, e1);
                            }, i.prototype.setStyle = function(e1, r) {
                                return !1 !== (r = t1.extend({}, {
                                    localIdeographFontFamily: this._localIdeographFontFamily
                                }, r)).diff && r.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, r), this) : (this._localIdeographFontFamily = r.localIdeographFontFamily, this._updateStyle(e1, r));
                            }, i.prototype._getUIString = function(t1) {
                                var e1 = this._locale[t1];
                                if (null == e1) throw new Error("Missing UI string '" + t1 + "'");
                                return e1;
                            }, i.prototype._updateStyle = function(t1, e1) {
                                return this.style && (this.style.setEventedParent(null), this.style._remove()), t1 ? (this.style = new qe(this, e1 || {}), this.style.setEventedParent(this, {
                                    style: this.style
                                }), "string" == typeof t1 ? this.style.loadURL(t1) : this.style.loadJSON(t1), this) : (delete this.style, this);
                            }, i.prototype._lazyInitEmptyStyle = function() {
                                this.style || (this.style = new qe(this, {}), this.style.setEventedParent(this, {
                                    style: this.style
                                }), this.style.loadEmpty());
                            }, i.prototype._diffStyle = function(e1, r) {
                                var n = this;
                                if ("string" == typeof e1) {
                                    var i = this._requestManager.normalizeStyleURL(e1), a = this._requestManager.transformRequest(i, t1.ResourceType.Style);
                                    t1.getJSON(a, function(e1, i) {
                                        e1 ? n.fire(new t1.ErrorEvent(e1)) : i && n._updateDiff(i, r);
                                    });
                                } else "object" == typeof e1 && this._updateDiff(e1, r);
                            }, i.prototype._updateDiff = function(e1, r) {
                                try {
                                    this.style.setState(e1) && this._update(!0);
                                } catch (n) {
                                    t1.warnOnce("Unable to perform style diff: " + (n.message || n.error || n) + ".  Rebuilding the style from scratch."), this._updateStyle(e1, r);
                                }
                            }, i.prototype.getStyle = function() {
                                if (this.style) return this.style.serialize();
                            }, i.prototype.isStyleLoaded = function() {
                                return this.style ? this.style.loaded() : t1.warnOnce("There is no style added to the map.");
                            }, i.prototype.addSource = function(t1, e1) {
                                return this._lazyInitEmptyStyle(), this.style.addSource(t1, e1), this._update(!0);
                            }, i.prototype.isSourceLoaded = function(e1) {
                                var r = this.style && this.style.sourceCaches[e1];
                                if (void 0 !== r) return r.loaded();
                                this.fire(new t1.ErrorEvent(new Error("There is no source with ID '" + e1 + "'")));
                            }, i.prototype.areTilesLoaded = function() {
                                var t1 = this.style && this.style.sourceCaches;
                                for(var e1 in t1){
                                    var r = t1[e1]._tiles;
                                    for(var n in r){
                                        var i = r[n];
                                        if ("loaded" !== i.state && "errored" !== i.state) return !1;
                                    }
                                }
                                return !0;
                            }, i.prototype.addSourceType = function(t1, e1, r) {
                                return this._lazyInitEmptyStyle(), this.style.addSourceType(t1, e1, r);
                            }, i.prototype.removeSource = function(t1) {
                                return this.style.removeSource(t1), this._update(!0);
                            }, i.prototype.getSource = function(t1) {
                                return this.style.getSource(t1);
                            }, i.prototype.addImage = function(e1, r, n) {
                                void 0 === n && (n = {});
                                var i = n.pixelRatio;
                                void 0 === i && (i = 1);
                                var a = n.sdf;
                                void 0 === a && (a = !1);
                                var o = n.stretchX, s = n.stretchY, l = n.content;
                                this._lazyInitEmptyStyle();
                                if (r instanceof ki || Mi && r instanceof Mi) {
                                    var c = t1.browser.getImageData(r), u = c.width, f = c.height, h = c.data;
                                    this.style.addImage(e1, {
                                        data: new t1.RGBAImage({
                                            width: u,
                                            height: f
                                        }, h),
                                        pixelRatio: i,
                                        stretchX: o,
                                        stretchY: s,
                                        content: l,
                                        sdf: a,
                                        version: 0
                                    });
                                } else {
                                    if (void 0 === r.width || void 0 === r.height) return this.fire(new t1.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                                    var p = r.width, d = r.height, m = r.data, g = r;
                                    this.style.addImage(e1, {
                                        data: new t1.RGBAImage({
                                            width: p,
                                            height: d
                                        }, new Uint8Array(m)),
                                        pixelRatio: i,
                                        stretchX: o,
                                        stretchY: s,
                                        content: l,
                                        sdf: a,
                                        version: 0,
                                        userImage: g
                                    }), g.onAdd && g.onAdd(this, e1);
                                }
                            }, i.prototype.updateImage = function(e1, r) {
                                var n = this.style.getImage(e1);
                                if (!n) return this.fire(new t1.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                                var i = r instanceof ki || Mi && r instanceof Mi ? t1.browser.getImageData(r) : r, a = i.width, o = i.height, s = i.data;
                                if (void 0 === a || void 0 === o) return this.fire(new t1.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                                if (a !== n.data.width || o !== n.data.height) return this.fire(new t1.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                                var l = !(r instanceof ki || Mi && r instanceof Mi);
                                n.data.replace(s, l), this.style.updateImage(e1, n);
                            }, i.prototype.hasImage = function(e1) {
                                return e1 ? !!this.style.getImage(e1) : (this.fire(new t1.ErrorEvent(new Error("Missing required image id"))), !1);
                            }, i.prototype.removeImage = function(t1) {
                                this.style.removeImage(t1);
                            }, i.prototype.loadImage = function(e1, r) {
                                t1.getImage(this._requestManager.transformRequest(e1, t1.ResourceType.Image), r);
                            }, i.prototype.listImages = function() {
                                return this.style.listImages();
                            }, i.prototype.addLayer = function(t1, e1) {
                                return this._lazyInitEmptyStyle(), this.style.addLayer(t1, e1), this._update(!0);
                            }, i.prototype.moveLayer = function(t1, e1) {
                                return this.style.moveLayer(t1, e1), this._update(!0);
                            }, i.prototype.removeLayer = function(t1) {
                                return this.style.removeLayer(t1), this._update(!0);
                            }, i.prototype.getLayer = function(t1) {
                                return this.style.getLayer(t1);
                            }, i.prototype.setLayerZoomRange = function(t1, e1, r) {
                                return this.style.setLayerZoomRange(t1, e1, r), this._update(!0);
                            }, i.prototype.setFilter = function(t1, e1, r) {
                                return void 0 === r && (r = {}), this.style.setFilter(t1, e1, r), this._update(!0);
                            }, i.prototype.getFilter = function(t1) {
                                return this.style.getFilter(t1);
                            }, i.prototype.setPaintProperty = function(t1, e1, r, n) {
                                return void 0 === n && (n = {}), this.style.setPaintProperty(t1, e1, r, n), this._update(!0);
                            }, i.prototype.getPaintProperty = function(t1, e1) {
                                return this.style.getPaintProperty(t1, e1);
                            }, i.prototype.setLayoutProperty = function(t1, e1, r, n) {
                                return void 0 === n && (n = {}), this.style.setLayoutProperty(t1, e1, r, n), this._update(!0);
                            }, i.prototype.getLayoutProperty = function(t1, e1) {
                                return this.style.getLayoutProperty(t1, e1);
                            }, i.prototype.setLight = function(t1, e1) {
                                return void 0 === e1 && (e1 = {}), this._lazyInitEmptyStyle(), this.style.setLight(t1, e1), this._update(!0);
                            }, i.prototype.getLight = function() {
                                return this.style.getLight();
                            }, i.prototype.setFeatureState = function(t1, e1) {
                                return this.style.setFeatureState(t1, e1), this._update();
                            }, i.prototype.removeFeatureState = function(t1, e1) {
                                return this.style.removeFeatureState(t1, e1), this._update();
                            }, i.prototype.getFeatureState = function(t1) {
                                return this.style.getFeatureState(t1);
                            }, i.prototype.getContainer = function() {
                                return this._container;
                            }, i.prototype.getCanvasContainer = function() {
                                return this._canvasContainer;
                            }, i.prototype.getCanvas = function() {
                                return this._canvas;
                            }, i.prototype._containerDimensions = function() {
                                var t1 = 0, e1 = 0;
                                return this._container && (t1 = this._container.clientWidth || 400, e1 = this._container.clientHeight || 300), [
                                    t1,
                                    e1
                                ];
                            }, i.prototype._detectMissingCSS = function() {
                                "rgb(250, 128, 114)" !== t1.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && t1.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                            }, i.prototype._setupContainer = function() {
                                var t1 = this._container;
                                t1.classList.add("mapboxgl-map"), (this._missingCSSCanary = r.create("div", "mapboxgl-canary", t1)).style.visibility = "hidden", this._detectMissingCSS();
                                var e1 = this._canvasContainer = r.create("div", "mapboxgl-canvas-container", t1);
                                this._interactive && e1.classList.add("mapboxgl-interactive"), this._canvas = r.create("canvas", "mapboxgl-canvas", e1), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", "Map");
                                var n = this._containerDimensions();
                                this._resizeCanvas(n[0], n[1]);
                                var i = this._controlContainer = r.create("div", "mapboxgl-control-container", t1), a = this._controlPositions = {};
                                [
                                    "top-left",
                                    "top-right",
                                    "bottom-left",
                                    "bottom-right"
                                ].forEach(function(t1) {
                                    a[t1] = r.create("div", "mapboxgl-ctrl-" + t1, i);
                                });
                            }, i.prototype._resizeCanvas = function(e1, r) {
                                var n = t1.browser.devicePixelRatio || 1;
                                this._canvas.width = n * e1, this._canvas.height = n * r, this._canvas.style.width = e1 + "px", this._canvas.style.height = r + "px";
                            }, i.prototype._setupPainter = function() {
                                var r = t1.extend({}, e1.webGLContextAttributes, {
                                    failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                                    preserveDrawingBuffer: this._preserveDrawingBuffer,
                                    antialias: this._antialias || !1
                                }), n = this._canvas.getContext("webgl", r) || this._canvas.getContext("experimental-webgl", r);
                                n ? (this.painter = new _n(n, this.transform), t1.webpSupported.testSupport(n)) : this.fire(new t1.ErrorEvent(new Error("Failed to initialize WebGL")));
                            }, i.prototype._contextLost = function(e1) {
                                e1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new t1.Event("webglcontextlost", {
                                    originalEvent: e1
                                }));
                            }, i.prototype._contextRestored = function(e1) {
                                this._setupPainter(), this.resize(), this._update(), this.fire(new t1.Event("webglcontextrestored", {
                                    originalEvent: e1
                                }));
                            }, i.prototype.loaded = function() {
                                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                            }, i.prototype._update = function(t1) {
                                return this.style ? (this._styleDirty = this._styleDirty || t1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                            }, i.prototype._requestRenderFrame = function(t1) {
                                return this._update(), this._renderTaskQueue.add(t1);
                            }, i.prototype._cancelRenderFrame = function(t1) {
                                this._renderTaskQueue.remove(t1);
                            }, i.prototype._render = function(e1) {
                                var r, n = this, i = 0, a = this.painter.context.extTimerQuery;
                                if (this.listens("gpu-timing-frame") && (r = a.createQueryEXT(), a.beginQueryEXT(a.TIME_ELAPSED_EXT, r), i = t1.browser.now()), this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), !this._removed) {
                                    var o = !1;
                                    if (this.style && this._styleDirty) {
                                        this._styleDirty = !1;
                                        var s = this.transform.zoom, l = t1.browser.now();
                                        this.style.zoomHistory.update(s, l);
                                        var c = new t1.EvaluationParameters(s, {
                                            now: l,
                                            fadeDuration: this._fadeDuration,
                                            zoomHistory: this.style.zoomHistory,
                                            transition: this.style.getTransition()
                                        }), u = c.crossFadingFactor();
                                        1 === u && u === this._crossFadingFactor || (o = !0, this._crossFadingFactor = u), this.style.update(c);
                                    }
                                    if (this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, this._fadeDuration, this._crossSourceCollisions), this.painter.render(this.style, {
                                        showTileBoundaries: this.showTileBoundaries,
                                        showOverdrawInspector: this._showOverdrawInspector,
                                        rotating: this.isRotating(),
                                        zooming: this.isZooming(),
                                        moving: this.isMoving(),
                                        fadeDuration: this._fadeDuration,
                                        showPadding: this.showPadding,
                                        gpuTiming: !!this.listens("gpu-timing-layer")
                                    }), this.fire(new t1.Event("render")), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new t1.Event("load"))), this.style && (this.style.hasTransitions() || o) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), this.listens("gpu-timing-frame")) {
                                        var f = t1.browser.now() - i;
                                        a.endQueryEXT(a.TIME_ELAPSED_EXT, r), setTimeout(function() {
                                            var e1 = a.getQueryObjectEXT(r, a.QUERY_RESULT_EXT) / 1e6;
                                            a.deleteQueryEXT(r), n.fire(new t1.Event("gpu-timing-frame", {
                                                cpuTime: f,
                                                gpuTime: e1
                                            }));
                                        }, 50);
                                    }
                                    if (this.listens("gpu-timing-layer")) {
                                        var h = this.painter.collectGpuTimers();
                                        setTimeout(function() {
                                            var e1 = n.painter.queryGpuTimers(h);
                                            n.fire(new t1.Event("gpu-timing-layer", {
                                                layerTimes: e1
                                            }));
                                        }, 50);
                                    }
                                    return this._sourcesDirty || this._styleDirty || this._placementDirty || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && (this._fullyLoaded || (this._fullyLoaded = !0), this.fire(new t1.Event("idle"))), this;
                                }
                            }, i.prototype.remove = function() {
                                this._hash && this._hash.remove();
                                for(var e1 = 0, r = this._controls; e1 < r.length; e1 += 1)r[e1].onRemove(this);
                                this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), void 0 !== t1.window && (t1.window.removeEventListener("resize", this._onWindowResize, !1), t1.window.removeEventListener("online", this._onWindowOnline, !1));
                                var n = this.painter.context.gl.getExtension("WEBGL_lose_context");
                                n && n.loseContext(), Li(this._canvasContainer), Li(this._controlContainer), Li(this._missingCSSCanary), this._container.classList.remove("mapboxgl-map"), this._removed = !0, this.fire(new t1.Event("remove"));
                            }, i.prototype.triggerRepaint = function() {
                                var e1 = this;
                                this.style && !this._frame && (this._frame = t1.browser.frame(function(t1) {
                                    e1._frame = null, e1._render(t1);
                                }));
                            }, i.prototype._onWindowOnline = function() {
                                this._update();
                            }, i.prototype._onWindowResize = function(t1) {
                                this._trackResize && this.resize({
                                    originalEvent: t1
                                })._update();
                            }, a.showTileBoundaries.get = function() {
                                return !!this._showTileBoundaries;
                            }, a.showTileBoundaries.set = function(t1) {
                                this._showTileBoundaries !== t1 && (this._showTileBoundaries = t1, this._update());
                            }, a.showPadding.get = function() {
                                return !!this._showPadding;
                            }, a.showPadding.set = function(t1) {
                                this._showPadding !== t1 && (this._showPadding = t1, this._update());
                            }, a.showCollisionBoxes.get = function() {
                                return !!this._showCollisionBoxes;
                            }, a.showCollisionBoxes.set = function(t1) {
                                this._showCollisionBoxes !== t1 && (this._showCollisionBoxes = t1, t1 ? this.style._generateCollisionBoxes() : this._update());
                            }, a.showOverdrawInspector.get = function() {
                                return !!this._showOverdrawInspector;
                            }, a.showOverdrawInspector.set = function(t1) {
                                this._showOverdrawInspector !== t1 && (this._showOverdrawInspector = t1, this._update());
                            }, a.repaint.get = function() {
                                return !!this._repaint;
                            }, a.repaint.set = function(t1) {
                                this._repaint !== t1 && (this._repaint = t1, this.triggerRepaint());
                            }, a.vertices.get = function() {
                                return !!this._vertices;
                            }, a.vertices.set = function(t1) {
                                this._vertices = t1, this._update();
                            }, i.prototype._setCacheLimits = function(e1, r) {
                                t1.setCacheLimits(e1, r);
                            }, a.version.get = function() {
                                return t1.version;
                            }, Object.defineProperties(i.prototype, a), i;
                        }(xi);
                        function Li(t1) {
                            t1.parentNode && t1.parentNode.removeChild(t1);
                        }
                        var Ci = {
                            showCompass: !0,
                            showZoom: !0,
                            visualizePitch: !1
                        }, Pi = function(e1) {
                            var n = this;
                            this.options = t1.extend({}, Ci, e1), this._container = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", function(t1) {
                                return t1.preventDefault();
                            }), this.options.showZoom && (t1.bindAll([
                                "_setButtonTitle",
                                "_updateZoomButtons"
                            ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", function(t1) {
                                return n._map.zoomIn({}, {
                                    originalEvent: t1
                                });
                            }), r.create("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", !0), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", function(t1) {
                                return n._map.zoomOut({}, {
                                    originalEvent: t1
                                });
                            }), r.create("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", !0)), this.options.showCompass && (t1.bindAll([
                                "_rotateCompassArrow"
                            ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", function(t1) {
                                n.options.visualizePitch ? n._map.resetNorthPitch({}, {
                                    originalEvent: t1
                                }) : n._map.resetNorth({}, {
                                    originalEvent: t1
                                });
                            }), this._compassIcon = r.create("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", !0));
                        };
                        Pi.prototype._updateZoomButtons = function() {
                            var t1 = this._map.getZoom();
                            this._zoomInButton.disabled = t1 === this._map.getMaxZoom(), this._zoomOutButton.disabled = t1 === this._map.getMinZoom();
                        }, Pi.prototype._rotateCompassArrow = function() {
                            var t1 = this.options.visualizePitch ? "scale(" + 1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5) + ") rotateX(" + this._map.transform.pitch + "deg) rotateZ(" + this._map.transform.angle * (180 / Math.PI) + "deg)" : "rotate(" + this._map.transform.angle * (180 / Math.PI) + "deg)";
                            this._compassIcon.style.transform = t1;
                        }, Pi.prototype.onAdd = function(t1) {
                            return this._map = t1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Ii(this._map, this._compass, this.options.visualizePitch)), this._container;
                        }, Pi.prototype.onRemove = function() {
                            r.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
                        }, Pi.prototype._createButton = function(t1, e1) {
                            var n = r.create("button", t1, this._container);
                            return n.type = "button", n.addEventListener("click", e1), n;
                        }, Pi.prototype._setButtonTitle = function(t1, e1) {
                            var r = this._map._getUIString("NavigationControl." + e1);
                            t1.title = r, t1.setAttribute("aria-label", r);
                        };
                        var Ii = function(e1, n, i) {
                            void 0 === i && (i = !1), this._clickTolerance = 10, this.element = n, this.mouseRotate = new Xn({
                                clickTolerance: e1.dragRotate._mouseRotate._clickTolerance
                            }), this.map = e1, i && (this.mousePitch = new Zn({
                                clickTolerance: e1.dragRotate._mousePitch._clickTolerance
                            })), t1.bindAll([
                                "mousedown",
                                "mousemove",
                                "mouseup",
                                "touchstart",
                                "touchmove",
                                "touchend",
                                "reset"
                            ], this), r.addEventListener(n, "mousedown", this.mousedown), r.addEventListener(n, "touchstart", this.touchstart, {
                                passive: !1
                            }), r.addEventListener(n, "touchmove", this.touchmove), r.addEventListener(n, "touchend", this.touchend), r.addEventListener(n, "touchcancel", this.reset);
                        };
                        function Oi(e1, r, n) {
                            if (e1 = new t1.LngLat(e1.lng, e1.lat), r) {
                                var i = new t1.LngLat(e1.lng - 360, e1.lat), a = new t1.LngLat(e1.lng + 360, e1.lat), o = n.locationPoint(e1).distSqr(r);
                                n.locationPoint(i).distSqr(r) < o ? e1 = i : n.locationPoint(a).distSqr(r) < o && (e1 = a);
                            }
                            for(; Math.abs(e1.lng - n.center.lng) > 180;){
                                var s = n.locationPoint(e1);
                                if (s.x >= 0 && s.y >= 0 && s.x <= n.width && s.y <= n.height) break;
                                e1.lng > n.center.lng ? e1.lng -= 360 : e1.lng += 360;
                            }
                            return e1;
                        }
                        Ii.prototype.down = function(t1, e1) {
                            this.mouseRotate.mousedown(t1, e1), this.mousePitch && this.mousePitch.mousedown(t1, e1), r.disableDrag();
                        }, Ii.prototype.move = function(t1, e1) {
                            var r = this.map, n = this.mouseRotate.mousemoveWindow(t1, e1);
                            if (n && n.bearingDelta && r.setBearing(r.getBearing() + n.bearingDelta), this.mousePitch) {
                                var i = this.mousePitch.mousemoveWindow(t1, e1);
                                i && i.pitchDelta && r.setPitch(r.getPitch() + i.pitchDelta);
                            }
                        }, Ii.prototype.off = function() {
                            var t1 = this.element;
                            r.removeEventListener(t1, "mousedown", this.mousedown), r.removeEventListener(t1, "touchstart", this.touchstart, {
                                passive: !1
                            }), r.removeEventListener(t1, "touchmove", this.touchmove), r.removeEventListener(t1, "touchend", this.touchend), r.removeEventListener(t1, "touchcancel", this.reset), this.offTemp();
                        }, Ii.prototype.offTemp = function() {
                            r.enableDrag(), r.removeEventListener(t1.window, "mousemove", this.mousemove), r.removeEventListener(t1.window, "mouseup", this.mouseup);
                        }, Ii.prototype.mousedown = function(e1) {
                            this.down(t1.extend({}, e1, {
                                ctrlKey: !0,
                                preventDefault: function() {
                                    return e1.preventDefault();
                                }
                            }), r.mousePos(this.element, e1)), r.addEventListener(t1.window, "mousemove", this.mousemove), r.addEventListener(t1.window, "mouseup", this.mouseup);
                        }, Ii.prototype.mousemove = function(t1) {
                            this.move(t1, r.mousePos(this.element, t1));
                        }, Ii.prototype.mouseup = function(t1) {
                            this.mouseRotate.mouseupWindow(t1), this.mousePitch && this.mousePitch.mouseupWindow(t1), this.offTemp();
                        }, Ii.prototype.touchstart = function(t1) {
                            1 !== t1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = r.touchPos(this.element, t1.targetTouches)[0], this.down({
                                type: "mousedown",
                                button: 0,
                                ctrlKey: !0,
                                preventDefault: function() {
                                    return t1.preventDefault();
                                }
                            }, this._startPos));
                        }, Ii.prototype.touchmove = function(t1) {
                            1 !== t1.targetTouches.length ? this.reset() : (this._lastPos = r.touchPos(this.element, t1.targetTouches)[0], this.move({
                                preventDefault: function() {
                                    return t1.preventDefault();
                                }
                            }, this._lastPos));
                        }, Ii.prototype.touchend = function(t1) {
                            0 === t1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
                        }, Ii.prototype.reset = function() {
                            this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                        };
                        var zi = {
                            center: "translate(-50%,-50%)",
                            top: "translate(-50%,0)",
                            "top-left": "translate(0,0)",
                            "top-right": "translate(-100%,0)",
                            bottom: "translate(-50%,-100%)",
                            "bottom-left": "translate(0,-100%)",
                            "bottom-right": "translate(-100%,-100%)",
                            left: "translate(0,-50%)",
                            right: "translate(-100%,-50%)"
                        };
                        function Di(t1, e1, r) {
                            var n = t1.classList;
                            for(var i in zi)n.remove("mapboxgl-" + r + "-anchor-" + i);
                            n.add("mapboxgl-" + r + "-anchor-" + e1);
                        }
                        var Ri, Fi = function(e1) {
                            function n(n, i) {
                                var a = this;
                                if (e1.call(this), (n instanceof t1.window.HTMLElement || i) && (n = t1.extend({
                                    element: n
                                }, i)), t1.bindAll([
                                    "_update",
                                    "_onMove",
                                    "_onUp",
                                    "_addDragHandler",
                                    "_onMapClick",
                                    "_onKeyPress"
                                ], this), this._anchor = n && n.anchor || "center", this._color = n && n.color || "#3FB1CE", this._draggable = n && n.draggable || !1, this._state = "inactive", this._rotation = n && n.rotation || 0, this._rotationAlignment = n && n.rotationAlignment || "auto", this._pitchAlignment = n && n.pitchAlignment && "auto" !== n.pitchAlignment ? n.pitchAlignment : this._rotationAlignment, n && n.element) this._element = n.element, this._offset = t1.Point.convert(n && n.offset || [
                                    0,
                                    0
                                ]);
                                else {
                                    this._defaultMarker = !0, this._element = r.create("div"), this._element.setAttribute("aria-label", "Map marker");
                                    var o = r.createNS("http://www.w3.org/2000/svg", "svg");
                                    o.setAttributeNS(null, "display", "block"), o.setAttributeNS(null, "height", "41px"), o.setAttributeNS(null, "width", "27px"), o.setAttributeNS(null, "viewBox", "0 0 27 41");
                                    var s = r.createNS("http://www.w3.org/2000/svg", "g");
                                    s.setAttributeNS(null, "stroke", "none"), s.setAttributeNS(null, "stroke-width", "1"), s.setAttributeNS(null, "fill", "none"), s.setAttributeNS(null, "fill-rule", "evenodd");
                                    var l = r.createNS("http://www.w3.org/2000/svg", "g");
                                    l.setAttributeNS(null, "fill-rule", "nonzero");
                                    var c = r.createNS("http://www.w3.org/2000/svg", "g");
                                    c.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), c.setAttributeNS(null, "fill", "#000000");
                                    for(var u = 0, f = [
                                        {
                                            rx: "10.5",
                                            ry: "5.25002273"
                                        },
                                        {
                                            rx: "10.5",
                                            ry: "5.25002273"
                                        },
                                        {
                                            rx: "9.5",
                                            ry: "4.77275007"
                                        },
                                        {
                                            rx: "8.5",
                                            ry: "4.29549936"
                                        },
                                        {
                                            rx: "7.5",
                                            ry: "3.81822308"
                                        },
                                        {
                                            rx: "6.5",
                                            ry: "3.34094679"
                                        },
                                        {
                                            rx: "5.5",
                                            ry: "2.86367051"
                                        },
                                        {
                                            rx: "4.5",
                                            ry: "2.38636864"
                                        }
                                    ]; u < f.length; u += 1){
                                        var h = f[u], p = r.createNS("http://www.w3.org/2000/svg", "ellipse");
                                        p.setAttributeNS(null, "opacity", "0.04"), p.setAttributeNS(null, "cx", "10.5"), p.setAttributeNS(null, "cy", "5.80029008"), p.setAttributeNS(null, "rx", h.rx), p.setAttributeNS(null, "ry", h.ry), c.appendChild(p);
                                    }
                                    var d = r.createNS("http://www.w3.org/2000/svg", "g");
                                    d.setAttributeNS(null, "fill", this._color);
                                    var m = r.createNS("http://www.w3.org/2000/svg", "path");
                                    m.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), d.appendChild(m);
                                    var g = r.createNS("http://www.w3.org/2000/svg", "g");
                                    g.setAttributeNS(null, "opacity", "0.25"), g.setAttributeNS(null, "fill", "#000000");
                                    var v = r.createNS("http://www.w3.org/2000/svg", "path");
                                    v.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), g.appendChild(v);
                                    var y = r.createNS("http://www.w3.org/2000/svg", "g");
                                    y.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), y.setAttributeNS(null, "fill", "#FFFFFF");
                                    var x = r.createNS("http://www.w3.org/2000/svg", "g");
                                    x.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                                    var b = r.createNS("http://www.w3.org/2000/svg", "circle");
                                    b.setAttributeNS(null, "fill", "#000000"), b.setAttributeNS(null, "opacity", "0.25"), b.setAttributeNS(null, "cx", "5.5"), b.setAttributeNS(null, "cy", "5.5"), b.setAttributeNS(null, "r", "5.4999962");
                                    var _ = r.createNS("http://www.w3.org/2000/svg", "circle");
                                    _.setAttributeNS(null, "fill", "#FFFFFF"), _.setAttributeNS(null, "cx", "5.5"), _.setAttributeNS(null, "cy", "5.5"), _.setAttributeNS(null, "r", "5.4999962"), x.appendChild(b), x.appendChild(_), l.appendChild(c), l.appendChild(d), l.appendChild(g), l.appendChild(y), l.appendChild(x), o.appendChild(l), this._element.appendChild(o), this._offset = t1.Point.convert(n && n.offset || [
                                        0,
                                        -14
                                    ]);
                                }
                                this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", function(t1) {
                                    t1.preventDefault();
                                }), this._element.addEventListener("mousedown", function(t1) {
                                    t1.preventDefault();
                                }), this._element.addEventListener("focus", function() {
                                    var t1 = a._map.getContainer();
                                    t1.scrollTop = 0, t1.scrollLeft = 0;
                                }), Di(this._element, this._anchor, "marker"), this._popup = null;
                            }
                            return e1 && (n.__proto__ = e1), n.prototype = Object.create(e1 && e1.prototype), n.prototype.constructor = n, n.prototype.addTo = function(t1) {
                                return this.remove(), this._map = t1, t1.getCanvasContainer().appendChild(this._element), t1.on("move", this._update), t1.on("moveend", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
                            }, n.prototype.remove = function() {
                                return this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), r.remove(this._element), this._popup && this._popup.remove(), this;
                            }, n.prototype.getLngLat = function() {
                                return this._lngLat;
                            }, n.prototype.setLngLat = function(e1) {
                                return this._lngLat = t1.LngLat.convert(e1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
                            }, n.prototype.getElement = function() {
                                return this._element;
                            }, n.prototype.setPopup = function(t1) {
                                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), t1) {
                                    if (!("offset" in t1.options)) {
                                        var e1 = Math.sqrt(Math.pow(13.5, 2) / 2);
                                        t1.options.offset = this._defaultMarker ? {
                                            top: [
                                                0,
                                                0
                                            ],
                                            "top-left": [
                                                0,
                                                0
                                            ],
                                            "top-right": [
                                                0,
                                                0
                                            ],
                                            bottom: [
                                                0,
                                                -38.1
                                            ],
                                            "bottom-left": [
                                                e1,
                                                -1 * (24.6 + e1)
                                            ],
                                            "bottom-right": [
                                                -e1,
                                                -1 * (24.6 + e1)
                                            ],
                                            left: [
                                                13.5,
                                                -24.6
                                            ],
                                            right: [
                                                -13.5,
                                                -24.6
                                            ]
                                        } : this._offset;
                                    }
                                    this._popup = t1, this._lngLat && this._popup.setLngLat(this._lngLat), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                                }
                                return this;
                            }, n.prototype._onKeyPress = function(t1) {
                                var e1 = t1.code, r = t1.charCode || t1.keyCode;
                                "Space" !== e1 && "Enter" !== e1 && 32 !== r && 13 !== r || this.togglePopup();
                            }, n.prototype._onMapClick = function(t1) {
                                var e1 = t1.originalEvent.target, r = this._element;
                                this._popup && (e1 === r || r.contains(e1)) && this.togglePopup();
                            }, n.prototype.getPopup = function() {
                                return this._popup;
                            }, n.prototype.togglePopup = function() {
                                var t1 = this._popup;
                                return t1 ? (t1.isOpen() ? t1.remove() : t1.addTo(this._map), this) : this;
                            }, n.prototype._update = function(t1) {
                                if (this._map) {
                                    this._map.transform.renderWorldCopies && (this._lngLat = Oi(this._lngLat, this._pos, this._map.transform)), this._pos = this._map.project(this._lngLat)._add(this._offset);
                                    var e1 = "";
                                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? e1 = "rotateZ(" + this._rotation + "deg)" : "map" === this._rotationAlignment && (e1 = "rotateZ(" + (this._rotation - this._map.getBearing()) + "deg)");
                                    var n = "";
                                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? n = "rotateX(0deg)" : "map" === this._pitchAlignment && (n = "rotateX(" + this._map.getPitch() + "deg)"), t1 && "moveend" !== t1.type || (this._pos = this._pos.round()), r.setTransform(this._element, zi[this._anchor] + " translate(" + this._pos.x + "px, " + this._pos.y + "px) " + n + " " + e1);
                                }
                            }, n.prototype.getOffset = function() {
                                return this._offset;
                            }, n.prototype.setOffset = function(e1) {
                                return this._offset = t1.Point.convert(e1), this._update(), this;
                            }, n.prototype._onMove = function(e1) {
                                this._pos = e1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t1.Event("dragstart"))), this.fire(new t1.Event("drag"));
                            }, n.prototype._onUp = function() {
                                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t1.Event("dragend")), this._state = "inactive";
                            }, n.prototype._addDragHandler = function(t1) {
                                this._element.contains(t1.originalEvent.target) && (t1.preventDefault(), this._positionDelta = t1.point.sub(this._pos).add(this._offset), this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                            }, n.prototype.setDraggable = function(t1) {
                                return this._draggable = !!t1, this._map && (t1 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
                            }, n.prototype.isDraggable = function() {
                                return this._draggable;
                            }, n.prototype.setRotation = function(t1) {
                                return this._rotation = t1 || 0, this._update(), this;
                            }, n.prototype.getRotation = function() {
                                return this._rotation;
                            }, n.prototype.setRotationAlignment = function(t1) {
                                return this._rotationAlignment = t1 || "auto", this._update(), this;
                            }, n.prototype.getRotationAlignment = function() {
                                return this._rotationAlignment;
                            }, n.prototype.setPitchAlignment = function(t1) {
                                return this._pitchAlignment = t1 && "auto" !== t1 ? t1 : this._rotationAlignment, this._update(), this;
                            }, n.prototype.getPitchAlignment = function() {
                                return this._pitchAlignment;
                            }, n;
                        }(t1.Evented), Bi = {
                            positionOptions: {
                                enableHighAccuracy: !1,
                                maximumAge: 0,
                                timeout: 6e3
                            },
                            fitBoundsOptions: {
                                maxZoom: 15
                            },
                            trackUserLocation: !1,
                            showAccuracyCircle: !0,
                            showUserLocation: !0
                        };
                        var Ni = 0, ji = !1, Ui = function(e1) {
                            function n(r) {
                                e1.call(this), this.options = t1.extend({}, Bi, r), t1.bindAll([
                                    "_onSuccess",
                                    "_onError",
                                    "_onZoom",
                                    "_finish",
                                    "_setupUI",
                                    "_updateCamera",
                                    "_updateMarker"
                                ], this);
                            }
                            return e1 && (n.__proto__ = e1), n.prototype = Object.create(e1 && e1.prototype), n.prototype.constructor = n, n.prototype.onAdd = function(e1) {
                                var n;
                                return this._map = e1, this._container = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), n = this._setupUI, void 0 !== Ri ? n(Ri) : void 0 !== t1.window.navigator.permissions ? t1.window.navigator.permissions.query({
                                    name: "geolocation"
                                }).then(function(t1) {
                                    Ri = "denied" !== t1.state, n(Ri);
                                }) : (Ri = !!t1.window.navigator.geolocation, n(Ri)), this._container;
                            }, n.prototype.onRemove = function() {
                                void 0 !== this._geolocationWatchID && (t1.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), r.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, Ni = 0, ji = !1;
                            }, n.prototype._isOutOfMapMaxBounds = function(t1) {
                                var e1 = this._map.getMaxBounds(), r = t1.coords;
                                return e1 && (r.longitude < e1.getWest() || r.longitude > e1.getEast() || r.latitude < e1.getSouth() || r.latitude > e1.getNorth());
                            }, n.prototype._setErrorState = function() {
                                switch(this._watchState){
                                    case "WAITING_ACTIVE":
                                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                        break;
                                    case "ACTIVE_LOCK":
                                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                                        break;
                                    case "BACKGROUND":
                                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                                }
                            }, n.prototype._onSuccess = function(e1) {
                                if (this._map) {
                                    if (this._isOutOfMapMaxBounds(e1)) return this._setErrorState(), this.fire(new t1.Event("outofmaxbounds", e1)), this._updateMarker(), void this._finish();
                                    if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                                        case "WAITING_ACTIVE":
                                        case "ACTIVE_LOCK":
                                        case "ACTIVE_ERROR":
                                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                            break;
                                        case "BACKGROUND":
                                        case "BACKGROUND_ERROR":
                                            this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                    }
                                    this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e1), this.options.showUserLocation && this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"), this.fire(new t1.Event("geolocate", e1)), this._finish();
                                }
                            }, n.prototype._updateCamera = function(e1) {
                                var r = new t1.LngLat(e1.coords.longitude, e1.coords.latitude), n = e1.coords.accuracy, i = this._map.getBearing(), a = t1.extend({
                                    bearing: i
                                }, this.options.fitBoundsOptions);
                                this._map.fitBounds(r.toBounds(n), a, {
                                    geolocateSource: !0
                                });
                            }, n.prototype._updateMarker = function(e1) {
                                if (e1) {
                                    var r = new t1.LngLat(e1.coords.longitude, e1.coords.latitude);
                                    this._accuracyCircleMarker.setLngLat(r).addTo(this._map), this._userLocationDotMarker.setLngLat(r).addTo(this._map), this._accuracy = e1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                                } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                            }, n.prototype._updateCircleRadius = function() {
                                var t1 = this._map._container.clientHeight / 2, e1 = this._map.unproject([
                                    0,
                                    t1
                                ]), r = this._map.unproject([
                                    1,
                                    t1
                                ]), n = e1.distanceTo(r), i = Math.ceil(2 * this._accuracy / n);
                                this._circleElement.style.width = i + "px", this._circleElement.style.height = i + "px";
                            }, n.prototype._onZoom = function() {
                                this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                            }, n.prototype._onError = function(e1) {
                                if (this._map) {
                                    if (this.options.trackUserLocation) {
                                        if (1 === e1.code) {
                                            this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                            var r = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                            this._geolocateButton.title = r, this._geolocateButton.setAttribute("aria-label", r), void 0 !== this._geolocationWatchID && this._clearWatch();
                                        } else {
                                            if (3 === e1.code && ji) return;
                                            this._setErrorState();
                                        }
                                    }
                                    "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("mapboxgl-user-location-dot-stale"), this.fire(new t1.Event("error", e1)), this._finish();
                                }
                            }, n.prototype._finish = function() {
                                this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                            }, n.prototype._setupUI = function(e1) {
                                var n = this;
                                if (this._container.addEventListener("contextmenu", function(t1) {
                                    return t1.preventDefault();
                                }), this._geolocateButton = r.create("button", "mapboxgl-ctrl-geolocate", this._container), r.create("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", !0), this._geolocateButton.type = "button", !1 === e1) {
                                    t1.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");
                                    var i = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                    this._geolocateButton.disabled = !0, this._geolocateButton.title = i, this._geolocateButton.setAttribute("aria-label", i);
                                } else {
                                    var a = this._map._getUIString("GeolocateControl.FindMyLocation");
                                    this._geolocateButton.title = a, this._geolocateButton.setAttribute("aria-label", a);
                                }
                                this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = r.create("div", "mapboxgl-user-location-dot"), this._userLocationDotMarker = new Fi(this._dotElement), this._circleElement = r.create("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Fi({
                                    element: this._circleElement,
                                    pitchAlignment: "map"
                                }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", function(e1) {
                                    var r = e1.originalEvent && "resize" === e1.originalEvent.type;
                                    e1.geolocateSource || "ACTIVE_LOCK" !== n._watchState || r || (n._watchState = "BACKGROUND", n._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), n._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), n.fire(new t1.Event("trackuserlocationend")));
                                });
                            }, n.prototype.trigger = function() {
                                if (!this._setup) return t1.warnOnce("Geolocate control triggered before added to a map"), !1;
                                if (this.options.trackUserLocation) {
                                    switch(this._watchState){
                                        case "OFF":
                                            this._watchState = "WAITING_ACTIVE", this.fire(new t1.Event("trackuserlocationstart"));
                                            break;
                                        case "WAITING_ACTIVE":
                                        case "ACTIVE_LOCK":
                                        case "ACTIVE_ERROR":
                                        case "BACKGROUND_ERROR":
                                            Ni--, ji = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new t1.Event("trackuserlocationend"));
                                            break;
                                        case "BACKGROUND":
                                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t1.Event("trackuserlocationstart"));
                                    }
                                    switch(this._watchState){
                                        case "WAITING_ACTIVE":
                                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                            break;
                                        case "ACTIVE_LOCK":
                                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                            break;
                                        case "ACTIVE_ERROR":
                                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                            break;
                                        case "BACKGROUND":
                                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                            break;
                                        case "BACKGROUND_ERROR":
                                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                                    }
                                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                                    else if (void 0 === this._geolocationWatchID) {
                                        var e1;
                                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), ++Ni > 1 ? (e1 = {
                                            maximumAge: 6e5,
                                            timeout: 0
                                        }, ji = !0) : (e1 = this.options.positionOptions, ji = !1), this._geolocationWatchID = t1.window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e1);
                                    }
                                } else t1.window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                                return !0;
                            }, n.prototype._clearWatch = function() {
                                t1.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                            }, n;
                        }(t1.Evented), Vi = {
                            maxWidth: 100,
                            unit: "metric"
                        }, Hi = function(e1) {
                            this.options = t1.extend({}, Vi, e1), t1.bindAll([
                                "_onMove",
                                "setUnit"
                            ], this);
                        };
                        function qi(t1, e1, r) {
                            var n = r && r.maxWidth || 100, i = t1._container.clientHeight / 2, a = t1.unproject([
                                0,
                                i
                            ]), o = t1.unproject([
                                n,
                                i
                            ]), s = a.distanceTo(o);
                            if (r && "imperial" === r.unit) {
                                var l = 3.2808 * s;
                                if (l > 5280) Gi(e1, n, l / 5280, t1._getUIString("ScaleControl.Miles"));
                                else Gi(e1, n, l, t1._getUIString("ScaleControl.Feet"));
                            } else if (r && "nautical" === r.unit) Gi(e1, n, s / 1852, t1._getUIString("ScaleControl.NauticalMiles"));
                            else s >= 1e3 ? Gi(e1, n, s / 1e3, t1._getUIString("ScaleControl.Kilometers")) : Gi(e1, n, s, t1._getUIString("ScaleControl.Meters"));
                        }
                        function Gi(t1, e1, r, n) {
                            var i, a, o, s = (i = r, a = Math.pow(10, ("" + Math.floor(i)).length - 1), o = (o = i / a) >= 10 ? 10 : o >= 5 ? 5 : o >= 3 ? 3 : o >= 2 ? 2 : o >= 1 ? 1 : function(t1) {
                                var e1 = Math.pow(10, Math.ceil(-Math.log(t1) / Math.LN10));
                                return Math.round(t1 * e1) / e1;
                            }(o), a * o), l = s / r;
                            t1.style.width = e1 * l + "px", t1.innerHTML = s + "&nbsp;" + n;
                        }
                        Hi.prototype.getDefaultPosition = function() {
                            return "bottom-left";
                        }, Hi.prototype._onMove = function() {
                            qi(this._map, this._container, this.options);
                        }, Hi.prototype.onAdd = function(t1) {
                            return this._map = t1, this._container = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", t1.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
                        }, Hi.prototype.onRemove = function() {
                            r.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
                        }, Hi.prototype.setUnit = function(t1) {
                            this.options.unit = t1, qi(this._map, this._container, this.options);
                        };
                        var Yi = function(e1) {
                            this._fullscreen = !1, e1 && e1.container && (e1.container instanceof t1.window.HTMLElement ? this._container = e1.container : t1.warnOnce("Full screen control 'container' must be a DOM element.")), t1.bindAll([
                                "_onClickFullscreen",
                                "_changeIcon"
                            ], this), "onfullscreenchange" in t1.window.document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in t1.window.document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in t1.window.document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in t1.window.document && (this._fullscreenchange = "MSFullscreenChange");
                        };
                        Yi.prototype.onAdd = function(e1) {
                            return this._map = e1, this._container || (this._container = this._map.getContainer()), this._controlContainer = r.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", t1.warnOnce("This device does not support fullscreen mode.")), this._controlContainer;
                        }, Yi.prototype.onRemove = function() {
                            r.remove(this._controlContainer), this._map = null, t1.window.document.removeEventListener(this._fullscreenchange, this._changeIcon);
                        }, Yi.prototype._checkFullscreenSupport = function() {
                            return !!(t1.window.document.fullscreenEnabled || t1.window.document.mozFullScreenEnabled || t1.window.document.msFullscreenEnabled || t1.window.document.webkitFullscreenEnabled);
                        }, Yi.prototype._setupUI = function() {
                            var e1 = this._fullscreenButton = r.create("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                            r.create("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", !0), e1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), t1.window.document.addEventListener(this._fullscreenchange, this._changeIcon);
                        }, Yi.prototype._updateTitle = function() {
                            var t1 = this._getTitle();
                            this._fullscreenButton.setAttribute("aria-label", t1), this._fullscreenButton.title = t1;
                        }, Yi.prototype._getTitle = function() {
                            return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                        }, Yi.prototype._isFullscreen = function() {
                            return this._fullscreen;
                        }, Yi.prototype._changeIcon = function() {
                            (t1.window.document.fullscreenElement || t1.window.document.mozFullScreenElement || t1.window.document.webkitFullscreenElement || t1.window.document.msFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                        }, Yi.prototype._onClickFullscreen = function() {
                            this._isFullscreen() ? t1.window.document.exitFullscreen ? t1.window.document.exitFullscreen() : t1.window.document.mozCancelFullScreen ? t1.window.document.mozCancelFullScreen() : t1.window.document.msExitFullscreen ? t1.window.document.msExitFullscreen() : t1.window.document.webkitCancelFullScreen && t1.window.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                        };
                        var Wi = {
                            closeButton: !0,
                            closeOnClick: !0,
                            className: "",
                            maxWidth: "240px"
                        }, Xi = function(e1) {
                            function n(r) {
                                e1.call(this), this.options = t1.extend(Object.create(Wi), r), t1.bindAll([
                                    "_update",
                                    "_onClose",
                                    "remove",
                                    "_onMouseMove",
                                    "_onMouseUp",
                                    "_onDrag"
                                ], this);
                            }
                            return e1 && (n.__proto__ = e1), n.prototype = Object.create(e1 && e1.prototype), n.prototype.constructor = n, n.prototype.addTo = function(e1) {
                                return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")) : this._map.on("move", this._update), this.fire(new t1.Event("open")), this;
                            }, n.prototype.isOpen = function() {
                                return !!this._map;
                            }, n.prototype.remove = function() {
                                return this._content && r.remove(this._content), this._container && (r.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), delete this._map), this.fire(new t1.Event("close")), this;
                            }, n.prototype.getLngLat = function() {
                                return this._lngLat;
                            }, n.prototype.setLngLat = function(e1) {
                                return this._lngLat = t1.LngLat.convert(e1), this._pos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                            }, n.prototype.trackPointer = function() {
                                return this._trackPointer = !0, this._pos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                            }, n.prototype.getElement = function() {
                                return this._container;
                            }, n.prototype.setText = function(e1) {
                                return this.setDOMContent(t1.window.document.createTextNode(e1));
                            }, n.prototype.setHTML = function(e1) {
                                var r, n = t1.window.document.createDocumentFragment(), i = t1.window.document.createElement("body");
                                for(i.innerHTML = e1; r = i.firstChild;)n.appendChild(r);
                                return this.setDOMContent(n);
                            }, n.prototype.getMaxWidth = function() {
                                return this._container && this._container.style.maxWidth;
                            }, n.prototype.setMaxWidth = function(t1) {
                                return this.options.maxWidth = t1, this._update(), this;
                            }, n.prototype.setDOMContent = function(t1) {
                                return this._createContent(), this._content.appendChild(t1), this._update(), this;
                            }, n.prototype.addClassName = function(t1) {
                                this._container && this._container.classList.add(t1);
                            }, n.prototype.removeClassName = function(t1) {
                                this._container && this._container.classList.remove(t1);
                            }, n.prototype.toggleClassName = function(t1) {
                                if (this._container) return this._container.classList.toggle(t1);
                            }, n.prototype._createContent = function() {
                                this._content && r.remove(this._content), this._content = r.create("div", "mapboxgl-popup-content", this._container), this.options.closeButton && (this._closeButton = r.create("button", "mapboxgl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.setAttribute("aria-label", "Close popup"), this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
                            }, n.prototype._onMouseUp = function(t1) {
                                this._update(t1.point);
                            }, n.prototype._onMouseMove = function(t1) {
                                this._update(t1.point);
                            }, n.prototype._onDrag = function(t1) {
                                this._update(t1.point);
                            }, n.prototype._update = function(e1) {
                                var n = this, i = this._lngLat || this._trackPointer;
                                if (this._map && i && this._content && (this._container || (this._container = r.create("div", "mapboxgl-popup", this._map.getContainer()), this._tip = r.create("div", "mapboxgl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className && this.options.className.split(" ").forEach(function(t1) {
                                    return n._container.classList.add(t1);
                                }), this._trackPointer && this._container.classList.add("mapboxgl-popup-track-pointer")), this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = Oi(this._lngLat, this._pos, this._map.transform)), !this._trackPointer || e1)) {
                                    var a = this._pos = this._trackPointer && e1 ? e1 : this._map.project(this._lngLat), o = this.options.anchor, s = function e1(r) {
                                        if (r) {
                                            if ("number" == typeof r) {
                                                var n = Math.round(Math.sqrt(.5 * Math.pow(r, 2)));
                                                return {
                                                    center: new t1.Point(0, 0),
                                                    top: new t1.Point(0, r),
                                                    "top-left": new t1.Point(n, n),
                                                    "top-right": new t1.Point(-n, n),
                                                    bottom: new t1.Point(0, -r),
                                                    "bottom-left": new t1.Point(n, -n),
                                                    "bottom-right": new t1.Point(-n, -n),
                                                    left: new t1.Point(r, 0),
                                                    right: new t1.Point(-r, 0)
                                                };
                                            }
                                            if (r instanceof t1.Point || Array.isArray(r)) {
                                                var i = t1.Point.convert(r);
                                                return {
                                                    center: i,
                                                    top: i,
                                                    "top-left": i,
                                                    "top-right": i,
                                                    bottom: i,
                                                    "bottom-left": i,
                                                    "bottom-right": i,
                                                    left: i,
                                                    right: i
                                                };
                                            }
                                            return {
                                                center: t1.Point.convert(r.center || [
                                                    0,
                                                    0
                                                ]),
                                                top: t1.Point.convert(r.top || [
                                                    0,
                                                    0
                                                ]),
                                                "top-left": t1.Point.convert(r["top-left"] || [
                                                    0,
                                                    0
                                                ]),
                                                "top-right": t1.Point.convert(r["top-right"] || [
                                                    0,
                                                    0
                                                ]),
                                                bottom: t1.Point.convert(r.bottom || [
                                                    0,
                                                    0
                                                ]),
                                                "bottom-left": t1.Point.convert(r["bottom-left"] || [
                                                    0,
                                                    0
                                                ]),
                                                "bottom-right": t1.Point.convert(r["bottom-right"] || [
                                                    0,
                                                    0
                                                ]),
                                                left: t1.Point.convert(r.left || [
                                                    0,
                                                    0
                                                ]),
                                                right: t1.Point.convert(r.right || [
                                                    0,
                                                    0
                                                ])
                                            };
                                        }
                                        return e1(new t1.Point(0, 0));
                                    }(this.options.offset);
                                    if (!o) {
                                        var l, c = this._container.offsetWidth, u = this._container.offsetHeight;
                                        l = a.y + s.bottom.y < u ? [
                                            "top"
                                        ] : a.y > this._map.transform.height - u ? [
                                            "bottom"
                                        ] : [], a.x < c / 2 ? l.push("left") : a.x > this._map.transform.width - c / 2 && l.push("right"), o = 0 === l.length ? "bottom" : l.join("-");
                                    }
                                    var f = a.add(s[o]).round();
                                    r.setTransform(this._container, zi[o] + " translate(" + f.x + "px," + f.y + "px)"), Di(this._container, o, "popup");
                                }
                            }, n.prototype._onClose = function() {
                                this.remove();
                            }, n;
                        }(t1.Evented);
                        var Zi = {
                            version: t1.version,
                            supported: e1,
                            setRTLTextPlugin: t1.setRTLTextPlugin,
                            getRTLTextPluginStatus: t1.getRTLTextPluginStatus,
                            Map: Ei,
                            NavigationControl: Pi,
                            GeolocateControl: Ui,
                            AttributionControl: bi,
                            ScaleControl: Hi,
                            FullscreenControl: Yi,
                            Popup: Xi,
                            Marker: Fi,
                            Style: qe,
                            LngLat: t1.LngLat,
                            LngLatBounds: t1.LngLatBounds,
                            Point: t1.Point,
                            MercatorCoordinate: t1.MercatorCoordinate,
                            Evented: t1.Evented,
                            config: t1.config,
                            prewarm: function() {
                                Bt().acquire(zt);
                            },
                            clearPrewarmedResources: function() {
                                var t1 = Rt;
                                t1 && (t1.isPreloaded() && 1 === t1.numActive() ? (t1.release(zt), Rt = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
                            },
                            get accessToken () {
                                return t1.config.ACCESS_TOKEN;
                            },
                            set accessToken (e){
                                t1.config.ACCESS_TOKEN = e;
                            },
                            get baseApiUrl () {
                                return t1.config.API_URL;
                            },
                            set baseApiUrl (e){
                                t1.config.API_URL = e;
                            },
                            get workerCount () {
                                return Dt.workerCount;
                            },
                            set workerCount (t){
                                Dt.workerCount = t;
                            },
                            get maxParallelImageRequests () {
                                return t1.config.MAX_PARALLEL_IMAGE_REQUESTS;
                            },
                            set maxParallelImageRequests (e){
                                t1.config.MAX_PARALLEL_IMAGE_REQUESTS = e;
                            },
                            clearStorage: function(e1) {
                                t1.clearTileCache(e1);
                            },
                            workerUrl: ""
                        };
                        return Zi;
                    }), r;
                });
            },
            {}
        ],
        240: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = Math.log2 || function(t1) {
                    return Math.log(t1) * Math.LOG2E;
                };
            },
            {}
        ],
        241: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    e1 || (e1 = t1, t1 = window);
                    var r = 0, i = 0, a = 0, o = {
                        shift: !1,
                        alt: !1,
                        control: !1,
                        meta: !1
                    }, s = !1;
                    function l(t1) {
                        var e1 = !1;
                        return "altKey" in t1 && (e1 = e1 || t1.altKey !== o.alt, o.alt = !!t1.altKey), "shiftKey" in t1 && (e1 = e1 || t1.shiftKey !== o.shift, o.shift = !!t1.shiftKey), "ctrlKey" in t1 && (e1 = e1 || t1.ctrlKey !== o.control, o.control = !!t1.ctrlKey), "metaKey" in t1 && (e1 = e1 || t1.metaKey !== o.meta, o.meta = !!t1.metaKey), e1;
                    }
                    function c(t1, s) {
                        var c = n.x(s), u = n.y(s);
                        "buttons" in s && (t1 = 0 | s.buttons), (t1 !== r || c !== i || u !== a || l(s)) && (r = 0 | t1, i = c || 0, a = u || 0, e1 && e1(r, i, a, o));
                    }
                    function u(t1) {
                        c(0, t1);
                    }
                    function f() {
                        (r || i || a || o.shift || o.alt || o.meta || o.control) && (i = a = 0, r = 0, o.shift = o.alt = o.control = o.meta = !1, e1 && e1(0, 0, 0, o));
                    }
                    function h(t1) {
                        l(t1) && e1 && e1(r, i, a, o);
                    }
                    function p(t1) {
                        0 === n.buttons(t1) ? c(0, t1) : c(r, t1);
                    }
                    function d(t1) {
                        c(r | n.buttons(t1), t1);
                    }
                    function m(t1) {
                        c(r & ~n.buttons(t1), t1);
                    }
                    function g() {
                        s || (s = !0, t1.addEventListener("mousemove", p), t1.addEventListener("mousedown", d), t1.addEventListener("mouseup", m), t1.addEventListener("mouseleave", u), t1.addEventListener("mouseenter", u), t1.addEventListener("mouseout", u), t1.addEventListener("mouseover", u), t1.addEventListener("blur", f), t1.addEventListener("keyup", h), t1.addEventListener("keydown", h), t1.addEventListener("keypress", h), t1 !== window && (window.addEventListener("blur", f), window.addEventListener("keyup", h), window.addEventListener("keydown", h), window.addEventListener("keypress", h)));
                    }
                    g();
                    var v = {
                        element: t1
                    };
                    return Object.defineProperties(v, {
                        enabled: {
                            get: function() {
                                return s;
                            },
                            set: function(e1) {
                                e1 ? g() : function() {
                                    if (!s) return;
                                    s = !1, t1.removeEventListener("mousemove", p), t1.removeEventListener("mousedown", d), t1.removeEventListener("mouseup", m), t1.removeEventListener("mouseleave", u), t1.removeEventListener("mouseenter", u), t1.removeEventListener("mouseout", u), t1.removeEventListener("mouseover", u), t1.removeEventListener("blur", f), t1.removeEventListener("keyup", h), t1.removeEventListener("keydown", h), t1.removeEventListener("keypress", h), t1 !== window && (window.removeEventListener("blur", f), window.removeEventListener("keyup", h), window.removeEventListener("keydown", h), window.removeEventListener("keypress", h));
                                }();
                            },
                            enumerable: !0
                        },
                        buttons: {
                            get: function() {
                                return r;
                            },
                            enumerable: !0
                        },
                        x: {
                            get: function() {
                                return i;
                            },
                            enumerable: !0
                        },
                        y: {
                            get: function() {
                                return a;
                            },
                            enumerable: !0
                        },
                        mods: {
                            get: function() {
                                return o;
                            },
                            enumerable: !0
                        }
                    }), v;
                };
                var n = t1("mouse-event");
            },
            {
                "mouse-event": 243
            }
        ],
        242: [
            function(t1, e1, r) {
                var n = {
                    left: 0,
                    top: 0
                };
                e1.exports = function(t1, e1, r) {
                    e1 = e1 || t1.currentTarget || t1.srcElement, Array.isArray(r) || (r = [
                        0,
                        0
                    ]);
                    var i = t1.clientX || 0, a = t1.clientY || 0, o = (s = e1, s === window || s === document || s === document.body ? n : s.getBoundingClientRect());
                    var s;
                    return r[0] = i - o.left, r[1] = a - o.top, r;
                };
            },
            {}
        ],
        243: [
            function(t1, e1, r) {
                "use strict";
                function n(t1) {
                    return t1.target || t1.srcElement || window;
                }
                r.buttons = function(t1) {
                    if ("object" == typeof t1) {
                        if ("buttons" in t1) return t1.buttons;
                        if ("which" in t1) {
                            if (2 === (e1 = t1.which)) return 4;
                            if (3 === e1) return 2;
                            if (e1 > 0) return 1 << e1 - 1;
                        } else if ("button" in t1) {
                            var e1;
                            if (1 === (e1 = t1.button)) return 4;
                            if (2 === e1) return 2;
                            if (e1 >= 0) return 1 << e1;
                        }
                    }
                    return 0;
                }, r.element = n, r.x = function(t1) {
                    if ("object" == typeof t1) {
                        if ("offsetX" in t1) return t1.offsetX;
                        var e1 = n(t1).getBoundingClientRect();
                        return t1.clientX - e1.left;
                    }
                    return 0;
                }, r.y = function(t1) {
                    if ("object" == typeof t1) {
                        if ("offsetY" in t1) return t1.offsetY;
                        var e1 = n(t1).getBoundingClientRect();
                        return t1.clientY - e1.top;
                    }
                    return 0;
                };
            },
            {}
        ],
        244: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("to-px");
                e1.exports = function(t1, e1, r) {
                    "function" == typeof t1 && (r = !!e1, e1 = t1, t1 = window);
                    var i = n("ex", t1), a = function(t1) {
                        r && t1.preventDefault();
                        var n = t1.deltaX || 0, a = t1.deltaY || 0, o = t1.deltaZ || 0, s = 1;
                        switch(t1.deltaMode){
                            case 1:
                                s = i;
                                break;
                            case 2:
                                s = window.innerHeight;
                        }
                        if (a *= s, o *= s, (n *= s) || a || o) return e1(n, a, o, t1);
                    };
                    return t1.addEventListener("wheel", a), a;
                };
            },
            {
                "to-px": 314
            }
        ],
        245: [
            function(t1, e1, r) {
                (function(t1, r) {
                    (function() {
                        /*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/ !function(t1, r, n) {
                            r[t1] = r[t1] || n(), void 0 !== e1 && e1.exports && (e1.exports = r[t1]);
                        }("Promise", void 0 !== t1 ? t1 : this, function() {
                            "use strict";
                            var t1, e1, n, i = Object.prototype.toString, a = void 0 !== r ? function(t1) {
                                return r(t1);
                            } : setTimeout;
                            try {
                                Object.defineProperty({}, "x", {}), t1 = function(t1, e1, r, n) {
                                    return Object.defineProperty(t1, e1, {
                                        value: r,
                                        writable: !0,
                                        configurable: !1 !== n
                                    });
                                };
                            } catch (e1) {
                                t1 = function(t1, e1, r) {
                                    return t1[e1] = r, t1;
                                };
                            }
                            function o(t1, r) {
                                n.add(t1, r), e1 || (e1 = a(n.drain));
                            }
                            function s(t1) {
                                var e1, r = typeof t1;
                                return null == t1 || "object" != r && "function" != r || (e1 = t1.then), "function" == typeof e1 && e1;
                            }
                            function l() {
                                for(var t1 = 0; t1 < this.chain.length; t1++)c(this, 1 === this.state ? this.chain[t1].success : this.chain[t1].failure, this.chain[t1]);
                                this.chain.length = 0;
                            }
                            function c(t1, e1, r) {
                                var n, i;
                                try {
                                    !1 === e1 ? r.reject(t1.msg) : (n = !0 === e1 ? t1.msg : e1.call(void 0, t1.msg)) === r.promise ? r.reject(TypeError("Promise-chain cycle")) : (i = s(n)) ? i.call(n, r.resolve, r.reject) : r.resolve(n);
                                } catch (t1) {
                                    r.reject(t1);
                                }
                            }
                            function u(t1) {
                                var e1, r = this;
                                if (!r.triggered) {
                                    r.triggered = !0, r.def && (r = r.def);
                                    try {
                                        (e1 = s(t1)) ? o(function() {
                                            var n = new p(r);
                                            try {
                                                e1.call(t1, function() {
                                                    u.apply(n, arguments);
                                                }, function() {
                                                    f.apply(n, arguments);
                                                });
                                            } catch (t1) {
                                                f.call(n, t1);
                                            }
                                        }) : (r.msg = t1, r.state = 1, r.chain.length > 0 && o(l, r));
                                    } catch (t1) {
                                        f.call(new p(r), t1);
                                    }
                                }
                            }
                            function f(t1) {
                                var e1 = this;
                                e1.triggered || (e1.triggered = !0, e1.def && (e1 = e1.def), e1.msg = t1, e1.state = 2, e1.chain.length > 0 && o(l, e1));
                            }
                            function h(t1, e1, r, n) {
                                for(var i = 0; i < e1.length; i++)!function(i) {
                                    t1.resolve(e1[i]).then(function(t1) {
                                        r(i, t1);
                                    }, n);
                                }(i);
                            }
                            function p(t1) {
                                this.def = t1, this.triggered = !1;
                            }
                            function d(t1) {
                                this.promise = t1, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
                            }
                            function m(t1) {
                                if ("function" != typeof t1) throw TypeError("Not a function");
                                if (0 !== this.__NPO__) throw TypeError("Not a promise");
                                this.__NPO__ = 1;
                                var e1 = new d(this);
                                this.then = function(t1, r) {
                                    var n = {
                                        success: "function" != typeof t1 || t1,
                                        failure: "function" == typeof r && r
                                    };
                                    return n.promise = new this.constructor(function(t1, e1) {
                                        if ("function" != typeof t1 || "function" != typeof e1) throw TypeError("Not a function");
                                        n.resolve = t1, n.reject = e1;
                                    }), e1.chain.push(n), 0 !== e1.state && o(l, e1), n.promise;
                                }, this.catch = function(t1) {
                                    return this.then(void 0, t1);
                                };
                                try {
                                    t1.call(void 0, function(t1) {
                                        u.call(e1, t1);
                                    }, function(t1) {
                                        f.call(e1, t1);
                                    });
                                } catch (t1) {
                                    f.call(e1, t1);
                                }
                            }
                            n = function() {
                                var t1, r, n;
                                function i(t1, e1) {
                                    this.fn = t1, this.self = e1, this.next = void 0;
                                }
                                return {
                                    add: function(e1, a) {
                                        n = new i(e1, a), r ? r.next = n : t1 = n, r = n, n = void 0;
                                    },
                                    drain: function() {
                                        var n = t1;
                                        for(t1 = r = e1 = void 0; n;)n.fn.call(n.self), n = n.next;
                                    }
                                };
                            }();
                            var g = t1({}, "constructor", m, !1);
                            return m.prototype = g, t1(g, "__NPO__", 0, !1), t1(m, "resolve", function(t1) {
                                return t1 && "object" == typeof t1 && 1 === t1.__NPO__ ? t1 : new this(function(e1, r) {
                                    if ("function" != typeof e1 || "function" != typeof r) throw TypeError("Not a function");
                                    e1(t1);
                                });
                            }), t1(m, "reject", function(t1) {
                                return new this(function(e1, r) {
                                    if ("function" != typeof e1 || "function" != typeof r) throw TypeError("Not a function");
                                    r(t1);
                                });
                            }), t1(m, "all", function(t1) {
                                var e1 = this;
                                return "[object Array]" != i.call(t1) ? e1.reject(TypeError("Not an array")) : 0 === t1.length ? e1.resolve([]) : new e1(function(r, n) {
                                    if ("function" != typeof r || "function" != typeof n) throw TypeError("Not a function");
                                    var i = t1.length, a = Array(i), o = 0;
                                    h(e1, t1, function(t1, e1) {
                                        a[t1] = e1, ++o === i && r(a);
                                    }, n);
                                });
                            }), t1(m, "race", function(t1) {
                                var e1 = this;
                                return "[object Array]" != i.call(t1) ? e1.reject(TypeError("Not an array")) : new e1(function(r, n) {
                                    if ("function" != typeof r || "function" != typeof n) throw TypeError("Not a function");
                                    h(e1, t1, function(t1, e1) {
                                        r(e1);
                                    }, n);
                                });
                            }), m;
                        });
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, t1("timers").setImmediate);
            },
            {
                timers: 311
            }
        ],
        246: [
            function(t1, e1, r) {
                var n = Math.PI, i = c(120);
                function a(t1, e1, r, n) {
                    return [
                        "C",
                        t1,
                        e1,
                        r,
                        n,
                        r,
                        n
                    ];
                }
                function o(t1, e1, r, n, i, a) {
                    return [
                        "C",
                        t1 / 3 + 2 / 3 * r,
                        e1 / 3 + 2 / 3 * n,
                        i / 3 + 2 / 3 * r,
                        a / 3 + 2 / 3 * n,
                        i,
                        a
                    ];
                }
                function s(t1, e1, r, a, o, c, u, f, h, p) {
                    if (p) T = p[0], k = p[1], _ = p[2], w = p[3];
                    else {
                        var d = l(t1, e1, -o);
                        t1 = d.x, e1 = d.y;
                        var m = (t1 - (f = (d = l(f, h, -o)).x)) / 2, g = (e1 - (h = d.y)) / 2, v = m * m / (r * r) + g * g / (a * a);
                        v > 1 && (r *= v = Math.sqrt(v), a *= v);
                        var y = r * r, x = a * a, b = (c == u ? -1 : 1) * Math.sqrt(Math.abs((y * x - y * g * g - x * m * m) / (y * g * g + x * m * m)));
                        b == 1 / 0 && (b = 1);
                        var _ = b * r * g / a + (t1 + f) / 2, w = b * -a * m / r + (e1 + h) / 2, T = Math.asin(((e1 - w) / a).toFixed(9)), k = Math.asin(((h - w) / a).toFixed(9));
                        (T = t1 < _ ? n - T : T) < 0 && (T = 2 * n + T), (k = f < _ ? n - k : k) < 0 && (k = 2 * n + k), u && T > k && (T -= 2 * n), !u && k > T && (k -= 2 * n);
                    }
                    if (Math.abs(k - T) > i) {
                        var A = k, M = f, S = h;
                        k = T + i * (u && k > T ? 1 : -1);
                        var E = s(f = _ + r * Math.cos(k), h = w + a * Math.sin(k), r, a, o, 0, u, M, S, [
                            k,
                            A,
                            _,
                            w
                        ]);
                    }
                    var L = Math.tan((k - T) / 4), C = 4 / 3 * r * L, P = 4 / 3 * a * L, I = [
                        2 * t1 - (t1 + C * Math.sin(T)),
                        2 * e1 - (e1 - P * Math.cos(T)),
                        f + C * Math.sin(k),
                        h - P * Math.cos(k),
                        f,
                        h
                    ];
                    if (p) return I;
                    E && (I = I.concat(E));
                    for(var O = 0; O < I.length;){
                        var z = l(I[O], I[O + 1], o);
                        I[O++] = z.x, I[O++] = z.y;
                    }
                    return I;
                }
                function l(t1, e1, r) {
                    return {
                        x: t1 * Math.cos(r) - e1 * Math.sin(r),
                        y: t1 * Math.sin(r) + e1 * Math.cos(r)
                    };
                }
                function c(t1) {
                    return t1 * (n / 180);
                }
                e1.exports = function(t1) {
                    for(var e1, r = [], n = 0, i = 0, l = 0, u = 0, f = null, h = null, p = 0, d = 0, m = 0, g = t1.length; m < g; m++){
                        var v = t1[m], y = v[0];
                        switch(y){
                            case "M":
                                l = v[1], u = v[2];
                                break;
                            case "A":
                                (v = s(p, d, v[1], v[2], c(v[3]), v[4], v[5], v[6], v[7])).unshift("C"), v.length > 7 && (r.push(v.splice(0, 7)), v.unshift("C"));
                                break;
                            case "S":
                                var x = p, b = d;
                                "C" != e1 && "S" != e1 || (x += x - n, b += b - i), v = [
                                    "C",
                                    x,
                                    b,
                                    v[1],
                                    v[2],
                                    v[3],
                                    v[4]
                                ];
                                break;
                            case "T":
                                "Q" == e1 || "T" == e1 ? (f = 2 * p - f, h = 2 * d - h) : (f = p, h = d), v = o(p, d, f, h, v[1], v[2]);
                                break;
                            case "Q":
                                f = v[1], h = v[2], v = o(p, d, v[1], v[2], v[3], v[4]);
                                break;
                            case "L":
                                v = a(p, d, v[1], v[2]);
                                break;
                            case "H":
                                v = a(p, d, v[1], d);
                                break;
                            case "V":
                                v = a(p, d, p, v[1]);
                                break;
                            case "Z":
                                v = a(p, d, l, u);
                        }
                        e1 = y, p = v[v.length - 2], d = v[v.length - 1], v.length > 4 ? (n = v[v.length - 4], i = v[v.length - 3]) : (n = p, i = d), r.push(v);
                    }
                    return r;
                };
            },
            {}
        ],
        247: [
            function(t1, e1, r) {
                /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
                var n = Object.getOwnPropertySymbols, i = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
                function o(t1) {
                    if (null == t1) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(t1);
                }
                e1.exports = function() {
                    try {
                        if (!Object.assign) return !1;
                        var t1 = new String("abc");
                        if (t1[5] = "de", "5" === Object.getOwnPropertyNames(t1)[0]) return !1;
                        for(var e1 = {}, r = 0; r < 10; r++)e1["_" + String.fromCharCode(r)] = r;
                        if ("0123456789" !== Object.getOwnPropertyNames(e1).map(function(t1) {
                            return e1[t1];
                        }).join("")) return !1;
                        var n = {};
                        return "abcdefghijklmnopqrst".split("").forEach(function(t1) {
                            n[t1] = t1;
                        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
                    } catch (t1) {
                        return !1;
                    }
                }() ? Object.assign : function(t1, e1) {
                    for(var r, s, l = o(t1), c = 1; c < arguments.length; c++){
                        for(var u in r = Object(arguments[c]))i.call(r, u) && (l[u] = r[u]);
                        if (n) {
                            s = n(r);
                            for(var f = 0; f < s.length; f++)a.call(r, s[f]) && (l[s[f]] = r[s[f]]);
                        }
                    }
                    return l;
                };
            },
            {}
        ],
        248: [
            function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    if ("string" != typeof t1) return [
                        t1
                    ];
                    var r = [
                        t1
                    ];
                    "string" == typeof e1 || Array.isArray(e1) ? e1 = {
                        brackets: e1
                    } : e1 || (e1 = {});
                    var n = e1.brackets ? Array.isArray(e1.brackets) ? e1.brackets : [
                        e1.brackets
                    ] : [
                        "{}",
                        "[]",
                        "()"
                    ], i = e1.escape || "___", a = !!e1.flat;
                    n.forEach(function(t1) {
                        var e1 = new RegExp([
                            "\\",
                            t1[0],
                            "[^\\",
                            t1[0],
                            "\\",
                            t1[1],
                            "]*\\",
                            t1[1]
                        ].join("")), n = [];
                        function a(e1, a, o) {
                            var s = r.push(e1.slice(t1[0].length, -t1[1].length)) - 1;
                            return n.push(s), i + s + i;
                        }
                        r.forEach(function(t1, n) {
                            for(var i, o = 0; t1 != i;)if (i = t1, t1 = t1.replace(e1, a), o++ > 1e4) throw Error("References have circular dependency. Please, check them.");
                            r[n] = t1;
                        }), n = n.reverse(), r = r.map(function(e1) {
                            return n.forEach(function(r) {
                                e1 = e1.replace(new RegExp("(\\" + i + r + "\\" + i + ")", "g"), t1[0] + "$1" + t1[1]);
                            }), e1;
                        });
                    });
                    var o = new RegExp("\\" + i + "([0-9]+)\\" + i);
                    return a ? r : function t1(e1, r, n) {
                        for(var i, a = [], s = 0; i = o.exec(e1);){
                            if (s++ > 1e4) throw Error("Circular references in parenthesis");
                            a.push(e1.slice(0, i.index)), a.push(t1(r[i[1]], r)), e1 = e1.slice(i.index + i[0].length);
                        }
                        return a.push(e1), a;
                    }(r[0], r);
                }
                function i(t1, e1) {
                    if (e1 && e1.flat) {
                        var r, n = e1 && e1.escape || "___", i = t1[0];
                        if (!i) return "";
                        for(var a = new RegExp("\\" + n + "([0-9]+)\\" + n), o = 0; i != r;){
                            if (o++ > 1e4) throw Error("Circular references in " + t1);
                            r = i, i = i.replace(a, s);
                        }
                        return i;
                    }
                    return t1.reduce(function t1(e1, r) {
                        return Array.isArray(r) && (r = r.reduce(t1, "")), e1 + r;
                    }, "");
                    function s(e1, r) {
                        if (null == t1[r]) throw Error("Reference " + r + "is undefined");
                        return t1[r];
                    }
                }
                function a(t1, e1) {
                    return Array.isArray(t1) ? i(t1, e1) : n(t1, e1);
                }
                a.parse = n, a.stringify = i, e1.exports = a;
            },
            {}
        ],
        249: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("pick-by-alias");
                e1.exports = function(t1) {
                    var e1;
                    arguments.length > 1 && (t1 = arguments);
                    "string" == typeof t1 ? t1 = t1.split(/\s/).map(parseFloat) : "number" == typeof t1 && (t1 = [
                        t1
                    ]);
                    t1.length && "number" == typeof t1[0] ? e1 = 1 === t1.length ? {
                        width: t1[0],
                        height: t1[0],
                        x: 0,
                        y: 0
                    } : 2 === t1.length ? {
                        width: t1[0],
                        height: t1[1],
                        x: 0,
                        y: 0
                    } : {
                        x: t1[0],
                        y: t1[1],
                        width: t1[2] - t1[0] || 0,
                        height: t1[3] - t1[1] || 0
                    } : t1 && (t1 = n(t1, {
                        left: "x l left Left",
                        top: "y t top Top",
                        width: "w width W Width",
                        height: "h height W Width",
                        bottom: "b bottom Bottom",
                        right: "r right Right"
                    }), e1 = {
                        x: t1.left || 0,
                        y: t1.top || 0
                    }, null == t1.width ? t1.right ? e1.width = t1.right - e1.x : e1.width = 0 : e1.width = t1.width, null == t1.height ? t1.bottom ? e1.height = t1.bottom - e1.y : e1.height = 0 : e1.height = t1.height);
                    return e1;
                };
            },
            {
                "pick-by-alias": 253
            }
        ],
        250: [
            function(t1, e1, r) {
                e1.exports = function(t1) {
                    var e1 = [];
                    return t1.replace(i, function(t1, r, i) {
                        var o = r.toLowerCase();
                        for(i = function(t1) {
                            var e1 = t1.match(a);
                            return e1 ? e1.map(Number) : [];
                        }(i), "m" == o && i.length > 2 && (e1.push([
                            r
                        ].concat(i.splice(0, 2))), o = "l", r = "m" == r ? "l" : "L");;){
                            if (i.length == n[o]) return i.unshift(r), e1.push(i);
                            if (i.length < n[o]) throw new Error("malformed path data");
                            e1.push([
                                r
                            ].concat(i.splice(0, n[o])));
                        }
                    }), e1;
                };
                var n = {
                    a: 7,
                    c: 6,
                    h: 1,
                    l: 2,
                    m: 2,
                    q: 4,
                    s: 4,
                    t: 2,
                    v: 1,
                    z: 0
                }, i = /([astvzqmhlc])([^astvzqmhlc]*)/gi;
                var a = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
            },
            {}
        ],
        251: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1) {
                    e1 || (e1 = [
                        0,
                        ""
                    ]), t1 = String(t1);
                    var r = parseFloat(t1, 10);
                    return e1[0] = r, e1[1] = t1.match(/[\d.\-\+]*\s*(.*)/)[1] || "", e1;
                };
            },
            {}
        ],
        252: [
            function(t1, e1, r) {
                (function(t1) {
                    (function() {
                        (function() {
                            var r, n, i, a, o, s;
                            "undefined" != typeof performance && null !== performance && performance.now ? e1.exports = function() {
                                return performance.now();
                            } : null != t1 && t1.hrtime ? (e1.exports = function() {
                                return (r() - o) / 1e6;
                            }, n = t1.hrtime, a = (r = function() {
                                var t1;
                                return 1e9 * (t1 = n())[0] + t1[1];
                            })(), s = 1e9 * t1.uptime(), o = a - s) : Date.now ? (e1.exports = function() {
                                return Date.now() - i;
                            }, i = Date.now()) : (e1.exports = function() {
                                return (new Date).getTime() - i;
                            }, i = (new Date).getTime());
                        }).call(this);
                    }).call(this);
                }).call(this, t1("_process"));
            },
            {
                _process: 277
            }
        ],
        253: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r) {
                    var n, a, o = {};
                    if ("string" == typeof e1 && (e1 = i(e1)), Array.isArray(e1)) {
                        var s = {};
                        for(a = 0; a < e1.length; a++)s[e1[a]] = !0;
                        e1 = s;
                    }
                    for(n in e1)e1[n] = i(e1[n]);
                    var l = {};
                    for(n in e1){
                        var c = e1[n];
                        if (Array.isArray(c)) for(a = 0; a < c.length; a++){
                            var u = c[a];
                            if (r && (l[u] = !0), u in t1) {
                                if (o[n] = t1[u], r) for(var f = a; f < c.length; f++)l[c[f]] = !0;
                                break;
                            }
                        }
                        else n in t1 && (e1[n] && (o[n] = t1[n]), r && (l[n] = !0));
                    }
                    if (r) for(n in t1)l[n] || (o[n] = t1[n]);
                    return o;
                };
                var n = {};
                function i(t1) {
                    return n[t1] ? n[t1] : ("string" == typeof t1 && (t1 = n[t1] = t1.split(/\s*,\s*|\s+/)), t1);
                }
            },
            {}
        ],
        254: [
            function(t1, e1, r) {
                /*
 * @copyright 2016 Sean Connelly (@voidqk), http://syntheti.cc
 * @license MIT
 * @preserve Project Home: https://github.com/voidqk/polybooljs
 */ var n, i = t1("./lib/build-log"), a = t1("./lib/epsilon"), o = t1("./lib/intersecter"), s = t1("./lib/segment-chainer"), l = t1("./lib/segment-selector"), c = t1("./lib/geojson"), u = !1, f = a();
                function h(t1, e1, r) {
                    var i = n.segments(t1), a = n.segments(e1), o = r(n.combine(i, a));
                    return n.polygon(o);
                }
                n = {
                    buildLog: function(t1) {
                        return !0 === t1 ? u = i() : !1 === t1 && (u = !1), !1 !== u && u.list;
                    },
                    epsilon: function(t1) {
                        return f.epsilon(t1);
                    },
                    segments: function(t1) {
                        var e1 = o(!0, f, u);
                        return t1.regions.forEach(e1.addRegion), {
                            segments: e1.calculate(t1.inverted),
                            inverted: t1.inverted
                        };
                    },
                    combine: function(t1, e1) {
                        return {
                            combined: o(!1, f, u).calculate(t1.segments, t1.inverted, e1.segments, e1.inverted),
                            inverted1: t1.inverted,
                            inverted2: e1.inverted
                        };
                    },
                    selectUnion: function(t1) {
                        return {
                            segments: l.union(t1.combined, u),
                            inverted: t1.inverted1 || t1.inverted2
                        };
                    },
                    selectIntersect: function(t1) {
                        return {
                            segments: l.intersect(t1.combined, u),
                            inverted: t1.inverted1 && t1.inverted2
                        };
                    },
                    selectDifference: function(t1) {
                        return {
                            segments: l.difference(t1.combined, u),
                            inverted: t1.inverted1 && !t1.inverted2
                        };
                    },
                    selectDifferenceRev: function(t1) {
                        return {
                            segments: l.differenceRev(t1.combined, u),
                            inverted: !t1.inverted1 && t1.inverted2
                        };
                    },
                    selectXor: function(t1) {
                        return {
                            segments: l.xor(t1.combined, u),
                            inverted: t1.inverted1 !== t1.inverted2
                        };
                    },
                    polygon: function(t1) {
                        return {
                            regions: s(t1.segments, f, u),
                            inverted: t1.inverted
                        };
                    },
                    polygonFromGeoJSON: function(t1) {
                        return c.toPolygon(n, t1);
                    },
                    polygonToGeoJSON: function(t1) {
                        return c.fromPolygon(n, f, t1);
                    },
                    union: function(t1, e1) {
                        return h(t1, e1, n.selectUnion);
                    },
                    intersect: function(t1, e1) {
                        return h(t1, e1, n.selectIntersect);
                    },
                    difference: function(t1, e1) {
                        return h(t1, e1, n.selectDifference);
                    },
                    differenceRev: function(t1, e1) {
                        return h(t1, e1, n.selectDifferenceRev);
                    },
                    xor: function(t1, e1) {
                        return h(t1, e1, n.selectXor);
                    }
                }, "object" == typeof window && (window.PolyBool = n), e1.exports = n;
            },
            {
                "./lib/build-log": 255,
                "./lib/epsilon": 256,
                "./lib/geojson": 257,
                "./lib/intersecter": 258,
                "./lib/segment-chainer": 260,
                "./lib/segment-selector": 261
            }
        ],
        255: [
            function(t1, e1, r) {
                e1.exports = function() {
                    var t1, e1 = 0, r = !1;
                    function n(e1, r) {
                        return t1.list.push({
                            type: e1,
                            data: r ? JSON.parse(JSON.stringify(r)) : void 0
                        }), t1;
                    }
                    return t1 = {
                        list: [],
                        segmentId: function() {
                            return e1++;
                        },
                        checkIntersection: function(t1, e1) {
                            return n("check", {
                                seg1: t1,
                                seg2: e1
                            });
                        },
                        segmentChop: function(t1, e1) {
                            return n("div_seg", {
                                seg: t1,
                                pt: e1
                            }), n("chop", {
                                seg: t1,
                                pt: e1
                            });
                        },
                        statusRemove: function(t1) {
                            return n("pop_seg", {
                                seg: t1
                            });
                        },
                        segmentUpdate: function(t1) {
                            return n("seg_update", {
                                seg: t1
                            });
                        },
                        segmentNew: function(t1, e1) {
                            return n("new_seg", {
                                seg: t1,
                                primary: e1
                            });
                        },
                        segmentRemove: function(t1) {
                            return n("rem_seg", {
                                seg: t1
                            });
                        },
                        tempStatus: function(t1, e1, r) {
                            return n("temp_status", {
                                seg: t1,
                                above: e1,
                                below: r
                            });
                        },
                        rewind: function(t1) {
                            return n("rewind", {
                                seg: t1
                            });
                        },
                        status: function(t1, e1, r) {
                            return n("status", {
                                seg: t1,
                                above: e1,
                                below: r
                            });
                        },
                        vert: function(e1) {
                            return e1 === r ? t1 : (r = e1, n("vert", {
                                x: e1
                            }));
                        },
                        log: function(t1) {
                            return "string" != typeof t1 && (t1 = JSON.stringify(t1, !1, "  ")), n("log", {
                                txt: t1
                            });
                        },
                        reset: function() {
                            return n("reset");
                        },
                        selected: function(t1) {
                            return n("selected", {
                                segs: t1
                            });
                        },
                        chainStart: function(t1) {
                            return n("chain_start", {
                                seg: t1
                            });
                        },
                        chainRemoveHead: function(t1, e1) {
                            return n("chain_rem_head", {
                                index: t1,
                                pt: e1
                            });
                        },
                        chainRemoveTail: function(t1, e1) {
                            return n("chain_rem_tail", {
                                index: t1,
                                pt: e1
                            });
                        },
                        chainNew: function(t1, e1) {
                            return n("chain_new", {
                                pt1: t1,
                                pt2: e1
                            });
                        },
                        chainMatch: function(t1) {
                            return n("chain_match", {
                                index: t1
                            });
                        },
                        chainClose: function(t1) {
                            return n("chain_close", {
                                index: t1
                            });
                        },
                        chainAddHead: function(t1, e1) {
                            return n("chain_add_head", {
                                index: t1,
                                pt: e1
                            });
                        },
                        chainAddTail: function(t1, e1) {
                            return n("chain_add_tail", {
                                index: t1,
                                pt: e1
                            });
                        },
                        chainConnect: function(t1, e1) {
                            return n("chain_con", {
                                index1: t1,
                                index2: e1
                            });
                        },
                        chainReverse: function(t1) {
                            return n("chain_rev", {
                                index: t1
                            });
                        },
                        chainJoin: function(t1, e1) {
                            return n("chain_join", {
                                index1: t1,
                                index2: e1
                            });
                        },
                        done: function() {
                            return n("done");
                        }
                    };
                };
            },
            {}
        ],
        256: [
            function(t1, e1, r) {
                e1.exports = function(t1) {
                    "number" != typeof t1 && (t1 = 1e-10);
                    var e1 = {
                        epsilon: function(e1) {
                            return "number" == typeof e1 && (t1 = e1), t1;
                        },
                        pointAboveOrOnLine: function(e1, r, n) {
                            var i = r[0], a = r[1], o = n[0], s = n[1], l = e1[0];
                            return (o - i) * (e1[1] - a) - (s - a) * (l - i) >= -t1;
                        },
                        pointBetween: function(e1, r, n) {
                            var i = e1[1] - r[1], a = n[0] - r[0], o = e1[0] - r[0], s = n[1] - r[1], l = o * a + i * s;
                            return !(l < t1) && !(l - (a * a + s * s) > -t1);
                        },
                        pointsSameX: function(e1, r) {
                            return Math.abs(e1[0] - r[0]) < t1;
                        },
                        pointsSameY: function(e1, r) {
                            return Math.abs(e1[1] - r[1]) < t1;
                        },
                        pointsSame: function(t1, r) {
                            return e1.pointsSameX(t1, r) && e1.pointsSameY(t1, r);
                        },
                        pointsCompare: function(t1, r) {
                            return e1.pointsSameX(t1, r) ? e1.pointsSameY(t1, r) ? 0 : t1[1] < r[1] ? -1 : 1 : t1[0] < r[0] ? -1 : 1;
                        },
                        pointsCollinear: function(e1, r, n) {
                            var i = e1[0] - r[0], a = e1[1] - r[1], o = r[0] - n[0], s = r[1] - n[1];
                            return Math.abs(i * s - o * a) < t1;
                        },
                        linesIntersect: function(e1, r, n, i) {
                            var a = r[0] - e1[0], o = r[1] - e1[1], s = i[0] - n[0], l = i[1] - n[1], c = a * l - o * s;
                            if (Math.abs(c) < t1) return !1;
                            var u = e1[0] - n[0], f = e1[1] - n[1], h = (s * f - l * u) / c, p = (a * f - o * u) / c, d = {
                                alongA: 0,
                                alongB: 0,
                                pt: [
                                    e1[0] + h * a,
                                    e1[1] + h * o
                                ]
                            };
                            return d.alongA = h <= -t1 ? -2 : h < t1 ? -1 : h - 1 <= -t1 ? 0 : h - 1 < t1 ? 1 : 2, d.alongB = p <= -t1 ? -2 : p < t1 ? -1 : p - 1 <= -t1 ? 0 : p - 1 < t1 ? 1 : 2, d;
                        },
                        pointInsideRegion: function(e1, r) {
                            for(var n = e1[0], i = e1[1], a = r[r.length - 1][0], o = r[r.length - 1][1], s = !1, l = 0; l < r.length; l++){
                                var c = r[l][0], u = r[l][1];
                                u - i > t1 != o - i > t1 && (a - c) * (i - u) / (o - u) + c - n > t1 && (s = !s), a = c, o = u;
                            }
                            return s;
                        }
                    };
                    return e1;
                };
            },
            {}
        ],
        257: [
            function(t1, e1, r) {
                var n = {
                    toPolygon: function(t1, e1) {
                        function r(e1) {
                            if (e1.length <= 0) return t1.segments({
                                inverted: !1,
                                regions: []
                            });
                            function r(e1) {
                                var r = e1.slice(0, e1.length - 1);
                                return t1.segments({
                                    inverted: !1,
                                    regions: [
                                        r
                                    ]
                                });
                            }
                            for(var n = r(e1[0]), i = 1; i < e1.length; i++)n = t1.selectDifference(t1.combine(n, r(e1[i])));
                            return n;
                        }
                        if ("Polygon" === e1.type) return t1.polygon(r(e1.coordinates));
                        if ("MultiPolygon" === e1.type) {
                            for(var n = t1.segments({
                                inverted: !1,
                                regions: []
                            }), i = 0; i < e1.coordinates.length; i++)n = t1.selectUnion(t1.combine(n, r(e1.coordinates[i])));
                            return t1.polygon(n);
                        }
                        throw new Error("PolyBool: Cannot convert GeoJSON object to PolyBool polygon");
                    },
                    fromPolygon: function(t1, e1, r) {
                        function n(t1, r) {
                            return e1.pointInsideRegion([
                                .5 * (t1[0][0] + t1[1][0]),
                                .5 * (t1[0][1] + t1[1][1])
                            ], r);
                        }
                        function i(t1) {
                            return {
                                region: t1,
                                children: []
                            };
                        }
                        r = t1.polygon(t1.segments(r));
                        var a = i(null);
                        function o(t1, e1) {
                            for(var r = 0; r < t1.children.length; r++){
                                if (n(e1, (s = t1.children[r]).region)) return void o(s, e1);
                            }
                            var a = i(e1);
                            for(r = 0; r < t1.children.length; r++){
                                var s;
                                n((s = t1.children[r]).region, e1) && (a.children.push(s), t1.children.splice(r, 1), r--);
                            }
                            t1.children.push(a);
                        }
                        for(var s = 0; s < r.regions.length; s++){
                            var l = r.regions[s];
                            l.length < 3 || o(a, l);
                        }
                        function c(t1, e1) {
                            for(var r = 0, n = t1[t1.length - 1][0], i = t1[t1.length - 1][1], a = [], o = 0; o < t1.length; o++){
                                var s = t1[o][0], l = t1[o][1];
                                a.push([
                                    s,
                                    l
                                ]), r += l * n - s * i, n = s, i = l;
                            }
                            return r < 0 !== e1 && a.reverse(), a.push([
                                a[0][0],
                                a[0][1]
                            ]), a;
                        }
                        var u = [];
                        function f(t1) {
                            var e1 = [
                                c(t1.region, !1)
                            ];
                            u.push(e1);
                            for(var r = 0; r < t1.children.length; r++)e1.push(h(t1.children[r]));
                        }
                        function h(t1) {
                            for(var e1 = 0; e1 < t1.children.length; e1++)f(t1.children[e1]);
                            return c(t1.region, !0);
                        }
                        for(s = 0; s < a.children.length; s++)f(a.children[s]);
                        return u.length <= 0 ? {
                            type: "Polygon",
                            coordinates: []
                        } : 1 == u.length ? {
                            type: "Polygon",
                            coordinates: u[0]
                        } : {
                            type: "MultiPolygon",
                            coordinates: u
                        };
                    }
                };
                e1.exports = n;
            },
            {}
        ],
        258: [
            function(t1, e1, r) {
                var n = t1("./linked-list");
                e1.exports = function(t1, e1, r) {
                    function i(t1, e1, n) {
                        return {
                            id: r ? r.segmentId() : -1,
                            start: t1,
                            end: e1,
                            myFill: {
                                above: n.myFill.above,
                                below: n.myFill.below
                            },
                            otherFill: null
                        };
                    }
                    var a = n.create();
                    function o(t1, r) {
                        a.insertBefore(t1, function(n) {
                            return function(t1, r, n, i, a, o) {
                                var s = e1.pointsCompare(r, a);
                                return 0 !== s ? s : e1.pointsSame(n, o) ? 0 : t1 !== i ? t1 ? 1 : -1 : e1.pointAboveOrOnLine(n, i ? a : o, i ? o : a) ? 1 : -1;
                            }(t1.isStart, t1.pt, r, n.isStart, n.pt, n.other.pt) < 0;
                        });
                    }
                    function s(t1, e1) {
                        var r = function(t1, e1) {
                            var r = n.node({
                                isStart: !0,
                                pt: t1.start,
                                seg: t1,
                                primary: e1,
                                other: null,
                                status: null
                            });
                            return o(r, t1.end), r;
                        }(t1, e1);
                        return function(t1, e1, r) {
                            var i = n.node({
                                isStart: !1,
                                pt: e1.end,
                                seg: e1,
                                primary: r,
                                other: t1,
                                status: null
                            });
                            t1.other = i, o(i, t1.pt);
                        }(r, t1, e1), r;
                    }
                    function l(t1, e1) {
                        var n = i(e1, t1.seg.end, t1.seg);
                        return function(t1, e1) {
                            r && r.segmentChop(t1.seg, e1), t1.other.remove(), t1.seg.end = e1, t1.other.pt = e1, o(t1.other, t1.pt);
                        }(t1, e1), s(n, t1.primary);
                    }
                    function c(i, o) {
                        var s = n.create();
                        function c(t1) {
                            return s.findTransition(function(r) {
                                var n, i, a, o, s, l;
                                return (n = t1, i = r.ev, a = n.seg.start, o = n.seg.end, s = i.seg.start, l = i.seg.end, e1.pointsCollinear(a, s, l) ? e1.pointsCollinear(o, s, l) || e1.pointAboveOrOnLine(o, s, l) ? 1 : -1 : e1.pointAboveOrOnLine(a, s, l) ? 1 : -1) > 0;
                            });
                        }
                        function u(t1, n) {
                            var i = t1.seg, a = n.seg, o = i.start, s = i.end, c = a.start, u = a.end;
                            r && r.checkIntersection(i, a);
                            var f = e1.linesIntersect(o, s, c, u);
                            if (!1 === f) {
                                if (!e1.pointsCollinear(o, s, c)) return !1;
                                if (e1.pointsSame(o, u) || e1.pointsSame(s, c)) return !1;
                                var h = e1.pointsSame(o, c), p = e1.pointsSame(s, u);
                                if (h && p) return n;
                                var d = !h && e1.pointBetween(o, c, u), m = !p && e1.pointBetween(s, c, u);
                                if (h) return m ? l(n, s) : l(t1, u), n;
                                d && (p || (m ? l(n, s) : l(t1, u)), l(n, o));
                            } else 0 === f.alongA && (-1 === f.alongB ? l(t1, c) : 0 === f.alongB ? l(t1, f.pt) : 1 === f.alongB && l(t1, u)), 0 === f.alongB && (-1 === f.alongA ? l(n, o) : 0 === f.alongA ? l(n, f.pt) : 1 === f.alongA && l(n, s));
                            return !1;
                        }
                        for(var f = []; !a.isEmpty();){
                            var h = a.getHead();
                            if (r && r.vert(h.pt[0]), h.isStart) {
                                r && r.segmentNew(h.seg, h.primary);
                                var p = c(h), d = p.before ? p.before.ev : null, m = p.after ? p.after.ev : null;
                                function g() {
                                    if (d) {
                                        var t1 = u(h, d);
                                        if (t1) return t1;
                                    }
                                    return !!m && u(h, m);
                                }
                                r && r.tempStatus(h.seg, !!d && d.seg, !!m && m.seg);
                                var v, y = g();
                                if (y) {
                                    var x;
                                    if (t1) (x = null === h.seg.myFill.below || h.seg.myFill.above !== h.seg.myFill.below) && (y.seg.myFill.above = !y.seg.myFill.above);
                                    else y.seg.otherFill = h.seg.myFill;
                                    r && r.segmentUpdate(y.seg), h.other.remove(), h.remove();
                                }
                                if (a.getHead() !== h) {
                                    r && r.rewind(h.seg);
                                    continue;
                                }
                                if (t1) x = null === h.seg.myFill.below || h.seg.myFill.above !== h.seg.myFill.below, h.seg.myFill.below = m ? m.seg.myFill.above : i, h.seg.myFill.above = x ? !h.seg.myFill.below : h.seg.myFill.below;
                                else if (null === h.seg.otherFill) v = m ? h.primary === m.primary ? m.seg.otherFill.above : m.seg.myFill.above : h.primary ? o : i, h.seg.otherFill = {
                                    above: v,
                                    below: v
                                };
                                r && r.status(h.seg, !!d && d.seg, !!m && m.seg), h.other.status = p.insert(n.node({
                                    ev: h
                                }));
                            } else {
                                var b = h.status;
                                if (null === b) throw new Error("PolyBool: Zero-length segment detected; your epsilon is probably too small or too large");
                                if (s.exists(b.prev) && s.exists(b.next) && u(b.prev.ev, b.next.ev), r && r.statusRemove(b.ev.seg), b.remove(), !h.primary) {
                                    var _ = h.seg.myFill;
                                    h.seg.myFill = h.seg.otherFill, h.seg.otherFill = _;
                                }
                                f.push(h.seg);
                            }
                            a.getHead().remove();
                        }
                        return r && r.done(), f;
                    }
                    return t1 ? {
                        addRegion: function(t1) {
                            for(var n, i, a, o = t1[t1.length - 1], l = 0; l < t1.length; l++){
                                n = o, o = t1[l];
                                var c = e1.pointsCompare(n, o);
                                0 !== c && s((i = c < 0 ? n : o, a = c < 0 ? o : n, {
                                    id: r ? r.segmentId() : -1,
                                    start: i,
                                    end: a,
                                    myFill: {
                                        above: null,
                                        below: null
                                    },
                                    otherFill: null
                                }), !0);
                            }
                        },
                        calculate: function(t1) {
                            return c(t1, !1);
                        }
                    } : {
                        calculate: function(t1, e1, r, n) {
                            return t1.forEach(function(t1) {
                                s(i(t1.start, t1.end, t1), !0);
                            }), r.forEach(function(t1) {
                                s(i(t1.start, t1.end, t1), !1);
                            }), c(e1, n);
                        }
                    };
                };
            },
            {
                "./linked-list": 259
            }
        ],
        259: [
            function(t1, e1, r) {
                e1.exports = {
                    create: function() {
                        var t1 = {
                            root: {
                                root: !0,
                                next: null
                            },
                            exists: function(e1) {
                                return null !== e1 && e1 !== t1.root;
                            },
                            isEmpty: function() {
                                return null === t1.root.next;
                            },
                            getHead: function() {
                                return t1.root.next;
                            },
                            insertBefore: function(e1, r) {
                                for(var n = t1.root, i = t1.root.next; null !== i;){
                                    if (r(i)) return e1.prev = i.prev, e1.next = i, i.prev.next = e1, void (i.prev = e1);
                                    n = i, i = i.next;
                                }
                                n.next = e1, e1.prev = n, e1.next = null;
                            },
                            findTransition: function(e1) {
                                for(var r = t1.root, n = t1.root.next; null !== n && !e1(n);)r = n, n = n.next;
                                return {
                                    before: r === t1.root ? null : r,
                                    after: n,
                                    insert: function(t1) {
                                        return t1.prev = r, t1.next = n, r.next = t1, null !== n && (n.prev = t1), t1;
                                    }
                                };
                            }
                        };
                        return t1;
                    },
                    node: function(t1) {
                        return t1.prev = null, t1.next = null, t1.remove = function() {
                            t1.prev.next = t1.next, t1.next && (t1.next.prev = t1.prev), t1.prev = null, t1.next = null;
                        }, t1;
                    }
                };
            },
            {}
        ],
        260: [
            function(t1, e1, r) {
                e1.exports = function(t1, e1, r) {
                    var n = [], i = [];
                    return t1.forEach(function(t1) {
                        var a = t1.start, o = t1.end;
                        if (e1.pointsSame(a, o)) console.warn("PolyBool: Warning: Zero-length segment detected; your epsilon is probably too small or too large");
                        else {
                            r && r.chainStart(t1);
                            for(var s = {
                                index: 0,
                                matches_head: !1,
                                matches_pt1: !1
                            }, l = {
                                index: 0,
                                matches_head: !1,
                                matches_pt1: !1
                            }, c = s, u = 0; u < n.length; u++){
                                var f = (g = n[u])[0], h = (g[1], g[g.length - 1]);
                                g[g.length - 2];
                                if (e1.pointsSame(f, a)) {
                                    if (k(u, !0, !0)) break;
                                } else if (e1.pointsSame(f, o)) {
                                    if (k(u, !0, !1)) break;
                                } else if (e1.pointsSame(h, a)) {
                                    if (k(u, !1, !0)) break;
                                } else if (e1.pointsSame(h, o) && k(u, !1, !1)) break;
                            }
                            if (c === s) return n.push([
                                a,
                                o
                            ]), void (r && r.chainNew(a, o));
                            if (c === l) {
                                r && r.chainMatch(s.index);
                                var p = s.index, d = s.matches_pt1 ? o : a, m = s.matches_head, g = n[p], v = m ? g[0] : g[g.length - 1], y = m ? g[1] : g[g.length - 2], x = m ? g[g.length - 1] : g[0], b = m ? g[g.length - 2] : g[1];
                                return e1.pointsCollinear(y, v, d) && (m ? (r && r.chainRemoveHead(s.index, d), g.shift()) : (r && r.chainRemoveTail(s.index, d), g.pop()), v = y), e1.pointsSame(x, d) ? (n.splice(p, 1), e1.pointsCollinear(b, x, v) && (m ? (r && r.chainRemoveTail(s.index, v), g.pop()) : (r && r.chainRemoveHead(s.index, v), g.shift())), r && r.chainClose(s.index), void i.push(g)) : void (m ? (r && r.chainAddHead(s.index, d), g.unshift(d)) : (r && r.chainAddTail(s.index, d), g.push(d)));
                            }
                            var _ = s.index, w = l.index;
                            r && r.chainConnect(_, w);
                            var T = n[_].length < n[w].length;
                            s.matches_head ? l.matches_head ? T ? (A(_), M(_, w)) : (A(w), M(w, _)) : M(w, _) : l.matches_head ? M(_, w) : T ? (A(_), M(w, _)) : (A(w), M(_, w));
                        }
                        function k(t1, e1, r) {
                            return c.index = t1, c.matches_head = e1, c.matches_pt1 = r, c === s ? (c = l, !1) : (c = null, !0);
                        }
                        function A(t1) {
                            r && r.chainReverse(t1), n[t1].reverse();
                        }
                        function M(t1, i) {
                            var a = n[t1], o = n[i], s = a[a.length - 1], l = a[a.length - 2], c = o[0], u = o[1];
                            e1.pointsCollinear(l, s, c) && (r && r.chainRemoveTail(t1, s), a.pop(), s = l), e1.pointsCollinear(s, c, u) && (r && r.chainRemoveHead(i, c), o.shift()), r && r.chainJoin(t1, i), n[t1] = a.concat(o), n.splice(i, 1);
                        }
                    }), i;
                };
            },
            {}
        ],
        261: [
            function(t1, e1, r) {
                function n(t1, e1, r) {
                    var n = [];
                    return t1.forEach(function(t1) {
                        var i = (t1.myFill.above ? 8 : 0) + (t1.myFill.below ? 4 : 0) + (t1.otherFill && t1.otherFill.above ? 2 : 0) + (t1.otherFill && t1.otherFill.below ? 1 : 0);
                        0 !== e1[i] && n.push({
                            id: r ? r.segmentId() : -1,
                            start: t1.start,
                            end: t1.end,
                            myFill: {
                                above: 1 === e1[i],
                                below: 2 === e1[i]
                            },
                            otherFill: null
                        });
                    }), r && r.selected(n), n;
                }
                var i = {
                    union: function(t1, e1) {
                        return n(t1, [
                            0,
                            2,
                            1,
                            0,
                            2,
                            2,
                            0,
                            0,
                            1,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0
                        ], e1);
                    },
                    intersect: function(t1, e1) {
                        return n(t1, [
                            0,
                            0,
                            0,
                            0,
                            0,
                            2,
                            0,
                            2,
                            0,
                            0,
                            1,
                            1,
                            0,
                            2,
                            1,
                            0
                        ], e1);
                    },
                    difference: function(t1, e1) {
                        return n(t1, [
                            0,
                            0,
                            0,
                            0,
                            2,
                            0,
                            2,
                            0,
                            1,
                            1,
                            0,
                            0,
                            0,
                            1,
                            2,
                            0
                        ], e1);
                    },
                    differenceRev: function(t1, e1) {
                        return n(t1, [
                            0,
                            2,
                            1,
                            0,
                            0,
                            0,
                            1,
                            1,
                            0,
                            2,
                            0,
                            2,
                            0,
                            0,
                            0,
                            0
                        ], e1);
                    },
                    xor: function(t1, e1) {
                        return n(t1, [
                            0,
                            2,
                            1,
                            0,
                            2,
                            0,
                            0,
                            1,
                            1,
                            0,
                            0,
                            2,
                            0,
                            1,
                            2,
                            0
                        ], e1);
                    }
                };
                e1.exports = i;
            },
            {}
        ],
        262: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("stream").Transform, i = t1("stream-parser");
                function a() {
                    n.call(this, {
                        readableObjectMode: !0
                    });
                }
                function o(t1, e1, r) {
                    Error.call(this), Error.captureStackTrace(this, this.constructor), this.name = this.constructor.name, this.message = t1, e1 && (this.code = e1), r && (this.statusCode = r);
                }
                a.prototype = Object.create(n.prototype), a.prototype.constructor = a, i(a.prototype), r.ParserStream = a, r.sliceEq = function(t1, e1, r) {
                    for(var n = e1, i = 0; i < r.length;)if (t1[n++] !== r[i++]) return !1;
                    return !0;
                }, r.str2arr = function(t1, e1) {
                    var r = [], n = 0;
                    if (e1 && "hex" === e1) for(; n < t1.length;)r.push(parseInt(t1.slice(n, n + 2), 16)), n += 2;
                    else for(; n < t1.length; n++)r.push(255 & t1.charCodeAt(n));
                    return r;
                }, r.readUInt16LE = function(t1, e1) {
                    return t1[e1] | t1[e1 + 1] << 8;
                }, r.readUInt16BE = function(t1, e1) {
                    return t1[e1 + 1] | t1[e1] << 8;
                }, r.readUInt32LE = function(t1, e1) {
                    return t1[e1] | t1[e1 + 1] << 8 | t1[e1 + 2] << 16 | 16777216 * t1[e1 + 3];
                }, r.readUInt32BE = function(t1, e1) {
                    return t1[e1 + 3] | t1[e1 + 2] << 8 | t1[e1 + 1] << 16 | 16777216 * t1[e1];
                }, o.prototype = Object.create(Error.prototype), o.prototype.constructor = o, r.ProbeError = o;
            },
            {
                stream: 285,
                "stream-parser": 301
            }
        ],
        263: [
            function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    var r = new Error(t1);
                    return r.code = e1, r;
                }
                function i(t1) {
                    try {
                        return decodeURIComponent(escape(t1));
                    } catch (e1) {
                        return t1;
                    }
                }
                function a(t1, e1, r) {
                    this.input = t1.subarray(e1, r), this.start = e1;
                    var i = String.fromCharCode.apply(null, this.input.subarray(0, 4));
                    if ("II*\0" !== i && "MM\0*" !== i) throw n("invalid TIFF signature", "EBADDATA");
                    this.big_endian = "M" === i[0];
                }
                a.prototype.each = function(t1) {
                    this.aborted = !1;
                    var e1 = this.read_uint32(4);
                    for(this.ifds_to_read = [
                        {
                            id: 0,
                            offset: e1
                        }
                    ]; this.ifds_to_read.length > 0 && !this.aborted;){
                        var r = this.ifds_to_read.shift();
                        r.offset && this.scan_ifd(r.id, r.offset, t1);
                    }
                }, a.prototype.read_uint16 = function(t1) {
                    var e1 = this.input;
                    if (t1 + 2 > e1.length) throw n("unexpected EOF", "EBADDATA");
                    return this.big_endian ? 256 * e1[t1] + e1[t1 + 1] : e1[t1] + 256 * e1[t1 + 1];
                }, a.prototype.read_uint32 = function(t1) {
                    var e1 = this.input;
                    if (t1 + 4 > e1.length) throw n("unexpected EOF", "EBADDATA");
                    return this.big_endian ? 16777216 * e1[t1] + 65536 * e1[t1 + 1] + 256 * e1[t1 + 2] + e1[t1 + 3] : e1[t1] + 256 * e1[t1 + 1] + 65536 * e1[t1 + 2] + 16777216 * e1[t1 + 3];
                }, a.prototype.is_subifd_link = function(t1, e1) {
                    return 0 === t1 && 34665 === e1 || 0 === t1 && 34853 === e1 || 34665 === t1 && 40965 === e1;
                }, a.prototype.exif_format_length = function(t1) {
                    switch(t1){
                        case 1:
                        case 2:
                        case 6:
                        case 7:
                            return 1;
                        case 3:
                        case 8:
                            return 2;
                        case 4:
                        case 9:
                        case 11:
                            return 4;
                        case 5:
                        case 10:
                        case 12:
                            return 8;
                        default:
                            return 0;
                    }
                }, a.prototype.exif_format_read = function(t1, e1) {
                    var r;
                    switch(t1){
                        case 1:
                        case 2:
                            return r = this.input[e1];
                        case 6:
                            return (r = this.input[e1]) | 33554430 * (128 & r);
                        case 3:
                            return r = this.read_uint16(e1);
                        case 8:
                            return (r = this.read_uint16(e1)) | 131070 * (32768 & r);
                        case 4:
                            return r = this.read_uint32(e1);
                        case 9:
                            return 0 | (r = this.read_uint32(e1));
                        case 5:
                        case 10:
                        case 11:
                        case 12:
                        case 7:
                        default:
                            return null;
                    }
                }, a.prototype.scan_ifd = function(t1, e1, r) {
                    var a = this.read_uint16(e1);
                    e1 += 2;
                    for(var o = 0; o < a; o++){
                        var s = this.read_uint16(e1), l = this.read_uint16(e1 + 2), c = this.read_uint32(e1 + 4), u = this.exif_format_length(l), f = c * u, h = f <= 4 ? e1 + 8 : this.read_uint32(e1 + 8), p = !1;
                        if (h + f > this.input.length) throw n("unexpected EOF", "EBADDATA");
                        for(var d = [], m = h, g = 0; g < c; g++, m += u){
                            var v = this.exif_format_read(l, m);
                            if (null === v) {
                                d = null;
                                break;
                            }
                            d.push(v);
                        }
                        if (Array.isArray(d) && 2 === l && (d = i(String.fromCharCode.apply(null, d))) && "\0" === d[d.length - 1] && (d = d.slice(0, -1)), this.is_subifd_link(t1, s) && Array.isArray(d) && Number.isInteger(d[0]) && d[0] > 0 && (this.ifds_to_read.push({
                            id: s,
                            offset: d[0]
                        }), p = !0), !1 === r({
                            is_big_endian: this.big_endian,
                            ifd: t1,
                            tag: s,
                            format: l,
                            count: c,
                            entry_offset: e1 + this.start,
                            data_length: f,
                            data_offset: h + this.start,
                            value: d,
                            is_subifd_link: p
                        })) return void (this.aborted = !0);
                        e1 += 12;
                    }
                    0 === t1 && this.ifds_to_read.push({
                        id: 1,
                        offset: this.read_uint32(e1)
                    });
                }, e1.exports.ExifParser = a, e1.exports.get_orientation = function(t1) {
                    var e1 = 0;
                    try {
                        return new a(t1, 0, t1.length).each(function(t1) {
                            if (0 === t1.ifd && 274 === t1.tag && Array.isArray(t1.value)) return e1 = t1.value[0], !1;
                        }), e1;
                    } catch (t1) {
                        return -1;
                    }
                };
            },
            {}
        ],
        264: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./common").readUInt16BE, i = t1("./common").readUInt32BE;
                function a(t1, e1) {
                    if (t1.length < 4 + e1) return null;
                    var r = i(t1, e1);
                    return t1.length < r + e1 || r < 8 ? null : {
                        boxtype: String.fromCharCode.apply(null, t1.slice(e1 + 4, e1 + 8)),
                        data: t1.slice(e1 + 8, e1 + r),
                        end: e1 + r
                    };
                }
                function o(t1, e1) {
                    for(var r = 0;;){
                        var n = a(t1, r);
                        if (!n) break;
                        switch(n.boxtype){
                            case "ispe":
                                e1.sizes.push({
                                    width: i(n.data, 4),
                                    height: i(n.data, 8)
                                });
                                break;
                            case "irot":
                                e1.transforms.push({
                                    type: "irot",
                                    value: 3 & n.data[0]
                                });
                                break;
                            case "imir":
                                e1.transforms.push({
                                    type: "imir",
                                    value: 1 & n.data[0]
                                });
                        }
                        r = n.end;
                    }
                }
                function s(t1, e1, r) {
                    for(var n = 0, i = 0; i < r; i++)n = 256 * n + (t1[e1 + i] || 0);
                    return n;
                }
                function l(t1, e1) {
                    for(var r = t1[4] >> 4 & 15, i = 15 & t1[4], a = t1[5] >> 4 & 15, o = n(t1, 6), l = 8, c = 0; c < o; c++){
                        var u = n(t1, l), f = n(t1, l += 2), h = s(t1, l += 2, a), p = n(t1, l += a);
                        if (l += 2, 0 === f && 1 === p) {
                            var d = s(t1, l, r), m = s(t1, l + r, i);
                            e1.item_loc[u] = {
                                length: m,
                                offset: d + h
                            };
                        }
                        l += p * (r + i);
                    }
                }
                function c(t1, e1) {
                    for(var r = n(t1, 4), i = 6, o = 0; o < r; o++){
                        var s = a(t1, i);
                        if (!s) break;
                        if ("infe" === s.boxtype) {
                            for(var l = n(s.data, 4), c = "", u = 8; u < s.data.length && s.data[u]; u++)c += String.fromCharCode(s.data[u]);
                            e1.item_inf[c] = l;
                        }
                        i = s.end;
                    }
                }
                function u(t1, e1) {
                    for(var r = 0;;){
                        var n = a(t1, r);
                        if (!n) break;
                        "ipco" === n.boxtype && o(n.data, e1), r = n.end;
                    }
                }
                e1.exports.unbox = a, e1.exports.readSizeFromMeta = function(t1) {
                    var e1 = {
                        sizes: [],
                        transforms: [],
                        item_inf: {},
                        item_loc: {}
                    };
                    if (function(t1, e1) {
                        for(var r = 4;;){
                            var n = a(t1, r);
                            if (!n) break;
                            "iprp" === n.boxtype && u(n.data, e1), "iloc" === n.boxtype && l(n.data, e1), "iinf" === n.boxtype && c(n.data, e1), r = n.end;
                        }
                    }(t1, e1), e1.sizes.length) {
                        var r, n, i, o = (r = e1.sizes, n = r.reduce(function(t1, e1) {
                            return t1.width > e1.width || t1.width === e1.width && t1.height > e1.height ? t1 : e1;
                        }), i = r.reduce(function(t1, e1) {
                            return t1.height > e1.height || t1.height === e1.height && t1.width > e1.width ? t1 : e1;
                        }), n.width > i.height || n.width === i.height && n.height > i.width ? n : i), s = 1;
                        e1.transforms.forEach(function(t1) {
                            var e1 = {
                                1: 6,
                                2: 5,
                                3: 8,
                                4: 7,
                                5: 4,
                                6: 3,
                                7: 2,
                                8: 1
                            }, r = {
                                1: 4,
                                2: 3,
                                3: 2,
                                4: 1,
                                5: 6,
                                6: 5,
                                7: 8,
                                8: 7
                            };
                            if ("imir" === t1.type && (s = 0 === t1.value ? r[s] : e1[s = e1[s = r[s]]]), "irot" === t1.type) for(var n = 0; n < t1.value; n++)s = e1[s];
                        });
                        var f = null;
                        return e1.item_inf.Exif && (f = e1.item_loc[e1.item_inf.Exif]), {
                            width: o.width,
                            height: o.height,
                            orientation: e1.transforms.length ? s : null,
                            variants: e1.sizes,
                            exif_location: f
                        };
                    }
                }, e1.exports.getMimeType = function(t1) {
                    var e1 = String.fromCharCode.apply(null, t1.slice(0, 4)), r = {};
                    r[e1] = !0;
                    for(var n = 8; n < t1.length; n += 4)r[String.fromCharCode.apply(null, t1.slice(n, n + 4))] = !0;
                    if (r.mif1 || r.msf1 || r.miaf) return "avif" === e1 || "avis" === e1 || "avio" === e1 ? {
                        type: "avif",
                        mime: "image/avif"
                    } : "heic" === e1 || "heix" === e1 ? {
                        type: "heic",
                        mime: "image/heic"
                    } : "hevc" === e1 || "hevx" === e1 ? {
                        type: "heic",
                        mime: "image/heic-sequence"
                    } : r.avif || r.avis ? {
                        type: "avif",
                        mime: "image/avif"
                    } : r.heic || r.heix || r.hevc || r.hevx || r.heis ? r.msf1 ? {
                        type: "heif",
                        mime: "image/heif-sequence"
                    } : {
                        type: "heif",
                        mime: "image/heif"
                    } : {
                        type: "avif",
                        mime: "image/avif"
                    };
                };
            },
            {
                "./common": 262
            }
        ],
        265: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../common").str2arr, i = t1("../common").sliceEq, a = t1("../common").readUInt32BE, o = t1("../miaf_utils"), s = t1("../exif_utils"), l = n("ftyp");
                e1.exports = function(t1) {
                    if (i(t1, 4, l)) {
                        var e1 = o.unbox(t1, 0);
                        if (e1) {
                            var r = o.getMimeType(e1.data);
                            if (r) {
                                for(var n, c = e1.end;;){
                                    var u = o.unbox(t1, c);
                                    if (!u) break;
                                    if (c = u.end, "mdat" === u.boxtype) return;
                                    if ("meta" === u.boxtype) {
                                        n = u.data;
                                        break;
                                    }
                                }
                                if (n) {
                                    var f = o.readSizeFromMeta(n);
                                    if (f) {
                                        var h = {
                                            width: f.width,
                                            height: f.height,
                                            type: r.type,
                                            mime: r.mime,
                                            wUnits: "px",
                                            hUnits: "px"
                                        };
                                        if (f.variants.length > 1 && (h.variants = f.variants), f.orientation && (h.orientation = f.orientation), f.exif_location && f.exif_location.offset + f.exif_location.length <= t1.length) {
                                            var p = a(t1, f.exif_location.offset), d = t1.slice(f.exif_location.offset + p + 4, f.exif_location.offset + f.exif_location.length), m = s.get_orientation(d);
                                            m > 0 && (h.orientation = m);
                                        }
                                        return h;
                                    }
                                }
                            }
                        }
                    }
                };
            },
            {
                "../common": 262,
                "../exif_utils": 263,
                "../miaf_utils": 264
            }
        ],
        266: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../common").str2arr, i = t1("../common").sliceEq, a = t1("../common").readUInt16LE, o = n("BM");
                e1.exports = function(t1) {
                    if (!(t1.length < 26) && i(t1, 0, o)) return {
                        width: a(t1, 18),
                        height: a(t1, 22),
                        type: "bmp",
                        mime: "image/bmp",
                        wUnits: "px",
                        hUnits: "px"
                    };
                };
            },
            {
                "../common": 262
            }
        ],
        267: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../common").str2arr, i = t1("../common").sliceEq, a = t1("../common").readUInt16LE, o = n("GIF87a"), s = n("GIF89a");
                e1.exports = function(t1) {
                    if (!(t1.length < 10) && (i(t1, 0, o) || i(t1, 0, s))) return {
                        width: a(t1, 6),
                        height: a(t1, 8),
                        type: "gif",
                        mime: "image/gif",
                        wUnits: "px",
                        hUnits: "px"
                    };
                };
            },
            {
                "../common": 262
            }
        ],
        268: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../common").readUInt16LE;
                e1.exports = function(t1) {
                    var e1 = n(t1, 0), r = n(t1, 2), i = n(t1, 4);
                    if (0 === e1 && 1 === r && i) {
                        for(var a = [], o = {
                            width: 0,
                            height: 0
                        }, s = 0; s < i; s++){
                            var l = t1[6 + 16 * s] || 256, c = t1[6 + 16 * s + 1] || 256, u = {
                                width: l,
                                height: c
                            };
                            a.push(u), (l > o.width || c > o.height) && (o = u);
                        }
                        return {
                            width: o.width,
                            height: o.height,
                            variants: a,
                            type: "ico",
                            mime: "image/x-icon",
                            wUnits: "px",
                            hUnits: "px"
                        };
                    }
                };
            },
            {
                "../common": 262
            }
        ],
        269: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../common").readUInt16BE, i = t1("../common").str2arr, a = t1("../common").sliceEq, o = t1("../exif_utils"), s = i("Exif\0\0");
                e1.exports = function(t1) {
                    if (!(t1.length < 2) && 255 === t1[0] && 216 === t1[1] && 255 === t1[2]) for(var e1 = 2;;){
                        for(;;){
                            if (t1.length - e1 < 2) return;
                            if (255 === t1[e1++]) break;
                        }
                        for(var r, i, l = t1[e1++]; 255 === l;)l = t1[e1++];
                        if (208 <= l && l <= 217 || 1 === l) r = 0;
                        else {
                            if (!(192 <= l && l <= 254)) return;
                            if (t1.length - e1 < 2) return;
                            r = n(t1, e1) - 2, e1 += 2;
                        }
                        if (217 === l || 218 === l) return;
                        if (225 === l && r >= 10 && a(t1, e1, s) && (i = o.get_orientation(t1.slice(e1 + 6, e1 + r))), r >= 5 && 192 <= l && l <= 207 && 196 !== l && 200 !== l && 204 !== l) {
                            if (t1.length - e1 < r) return;
                            var c = {
                                width: n(t1, e1 + 3),
                                height: n(t1, e1 + 1),
                                type: "jpg",
                                mime: "image/jpeg",
                                wUnits: "px",
                                hUnits: "px"
                            };
                            return i > 0 && (c.orientation = i), c;
                        }
                        e1 += r;
                    }
                };
            },
            {
                "../common": 262,
                "../exif_utils": 263
            }
        ],
        270: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../common").str2arr, i = t1("../common").sliceEq, a = t1("../common").readUInt32BE, o = n("\x89PNG\r\n\x1a\n"), s = n("IHDR");
                e1.exports = function(t1) {
                    if (!(t1.length < 24) && i(t1, 0, o) && i(t1, 12, s)) return {
                        width: a(t1, 16),
                        height: a(t1, 20),
                        type: "png",
                        mime: "image/png",
                        wUnits: "px",
                        hUnits: "px"
                    };
                };
            },
            {
                "../common": 262
            }
        ],
        271: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../common").str2arr, i = t1("../common").sliceEq, a = t1("../common").readUInt32BE, o = n("8BPS\0\x01");
                e1.exports = function(t1) {
                    if (!(t1.length < 22) && i(t1, 0, o)) return {
                        width: a(t1, 18),
                        height: a(t1, 14),
                        type: "psd",
                        mime: "image/vnd.adobe.photoshop",
                        wUnits: "px",
                        hUnits: "px"
                    };
                };
            },
            {
                "../common": 262
            }
        ],
        272: [
            function(t1, e1, r) {
                "use strict";
                function n(t1) {
                    return "number" == typeof t1 && isFinite(t1) && t1 > 0;
                }
                var i = /<[-_.:a-zA-Z0-9][^>]*>/, a = /^<([-_.:a-zA-Z0-9]+:)?svg\s/, o = /[^-]\bwidth="([^%]+?)"|[^-]\bwidth='([^%]+?)'/, s = /\bheight="([^%]+?)"|\bheight='([^%]+?)'/, l = /\bview[bB]ox="(.+?)"|\bview[bB]ox='(.+?)'/, c = /in$|mm$|cm$|pt$|pc$|px$|em$|ex$/;
                function u(t1) {
                    return c.test(t1) ? t1.match(c)[0] : "px";
                }
                e1.exports = function(t1) {
                    if (function(t1) {
                        var e1, r = 0, n = t1.length;
                        for(239 === t1[0] && 187 === t1[1] && 191 === t1[2] && (r = 3); r < n && (32 === (e1 = t1[r]) || 9 === e1 || 13 === e1 || 10 === e1);)r++;
                        return r !== n && 60 === t1[r];
                    }(t1)) {
                        for(var e1 = "", r = 0; r < t1.length; r++)e1 += String.fromCharCode(t1[r]);
                        var c = (e1.match(i) || [
                            ""
                        ])[0];
                        if (a.test(c)) {
                            var f = function(t1) {
                                var e1 = t1.match(o), r = t1.match(s), n = t1.match(l);
                                return {
                                    width: e1 && (e1[1] || e1[2]),
                                    height: r && (r[1] || r[2]),
                                    viewbox: n && (n[1] || n[2])
                                };
                            }(c), h = parseFloat(f.width), p = parseFloat(f.height);
                            if (f.width && f.height) {
                                if (!n(h) || !n(p)) return;
                                return {
                                    width: h,
                                    height: p,
                                    type: "svg",
                                    mime: "image/svg+xml",
                                    wUnits: u(f.width),
                                    hUnits: u(f.height)
                                };
                            }
                            var d = (f.viewbox || "").split(" "), m = {
                                width: d[2],
                                height: d[3]
                            }, g = parseFloat(m.width), v = parseFloat(m.height);
                            if (n(g) && n(v) && u(m.width) === u(m.height)) {
                                var y = g / v;
                                if (f.width) {
                                    if (!n(h)) return;
                                    return {
                                        width: h,
                                        height: h / y,
                                        type: "svg",
                                        mime: "image/svg+xml",
                                        wUnits: u(f.width),
                                        hUnits: u(f.width)
                                    };
                                }
                                if (f.height) {
                                    if (!n(p)) return;
                                    return {
                                        width: p * y,
                                        height: p,
                                        type: "svg",
                                        mime: "image/svg+xml",
                                        wUnits: u(f.height),
                                        hUnits: u(f.height)
                                    };
                                }
                                return {
                                    width: g,
                                    height: v,
                                    type: "svg",
                                    mime: "image/svg+xml",
                                    wUnits: u(m.width),
                                    hUnits: u(m.height)
                                };
                            }
                        }
                    }
                };
            },
            {}
        ],
        273: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../common").str2arr, i = t1("../common").sliceEq, a = t1("../common").readUInt16LE, o = t1("../common").readUInt16BE, s = t1("../common").readUInt32LE, l = t1("../common").readUInt32BE, c = n("II*\0"), u = n("MM\0*");
                function f(t1, e1, r) {
                    return r ? o(t1, e1) : a(t1, e1);
                }
                function h(t1, e1, r) {
                    return r ? l(t1, e1) : s(t1, e1);
                }
                function p(t1, e1, r) {
                    var n = f(t1, e1 + 2, r);
                    return 1 !== h(t1, e1 + 4, r) || 3 !== n && 4 !== n ? null : 3 === n ? f(t1, e1 + 8, r) : h(t1, e1 + 8, r);
                }
                e1.exports = function(t1) {
                    if (!(t1.length < 8) && (i(t1, 0, c) || i(t1, 0, u))) {
                        var e1 = 77 === t1[0], r = h(t1, 4, e1) - 8;
                        if (!(r < 0)) {
                            var n = r + 8;
                            if (!(t1.length - n < 2)) {
                                var a = 12 * f(t1, n + 0, e1);
                                if (!(a <= 0 || (n += 2, t1.length - n < a))) {
                                    var o, s, l, d;
                                    for(o = 0; o < a; o += 12)256 === (d = f(t1, n + o, e1)) ? s = p(t1, n + o, e1) : 257 === d && (l = p(t1, n + o, e1));
                                    return s && l ? {
                                        width: s,
                                        height: l,
                                        type: "tiff",
                                        mime: "image/tiff",
                                        wUnits: "px",
                                        hUnits: "px"
                                    } : void 0;
                                }
                            }
                        }
                    }
                };
            },
            {
                "../common": 262
            }
        ],
        274: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../common").str2arr, i = t1("../common").sliceEq, a = t1("../common").readUInt16LE, o = t1("../common").readUInt32LE, s = t1("../exif_utils"), l = n("RIFF"), c = n("WEBP");
                function u(t1, e1) {
                    if (157 === t1[e1 + 3] && 1 === t1[e1 + 4] && 42 === t1[e1 + 5]) return {
                        width: 16383 & a(t1, e1 + 6),
                        height: 16383 & a(t1, e1 + 8),
                        type: "webp",
                        mime: "image/webp",
                        wUnits: "px",
                        hUnits: "px"
                    };
                }
                function f(t1, e1) {
                    if (47 === t1[e1]) {
                        var r = o(t1, e1 + 1);
                        return {
                            width: 1 + (16383 & r),
                            height: 1 + (r >> 14 & 16383),
                            type: "webp",
                            mime: "image/webp",
                            wUnits: "px",
                            hUnits: "px"
                        };
                    }
                }
                function h(t1, e1) {
                    return {
                        width: 1 + (t1[e1 + 6] << 16 | t1[e1 + 5] << 8 | t1[e1 + 4]),
                        height: 1 + (t1[e1 + 9] << e1 | t1[e1 + 8] << 8 | t1[e1 + 7]),
                        type: "webp",
                        mime: "image/webp",
                        wUnits: "px",
                        hUnits: "px"
                    };
                }
                e1.exports = function(t1) {
                    if (!(t1.length < 16) && (i(t1, 0, l) || i(t1, 8, c))) {
                        var e1 = 12, r = null, n = 0, a = o(t1, 4) + 8;
                        if (!(a > t1.length)) {
                            for(; e1 + 8 < a;)if (0 !== t1[e1]) {
                                var p = String.fromCharCode.apply(null, t1.slice(e1, e1 + 4)), d = o(t1, e1 + 4);
                                "VP8 " === p && d >= 10 ? r = r || u(t1, e1 + 8) : "VP8L" === p && d >= 9 ? r = r || f(t1, e1 + 8) : "VP8X" === p && d >= 10 ? r = r || h(t1, e1 + 8) : "EXIF" === p && (n = s.get_orientation(t1.slice(e1 + 8, e1 + 8 + d)), e1 = 1 / 0), e1 += 8 + d;
                            } else e1++;
                            if (r) return n > 0 && (r.orientation = n), r;
                        }
                    }
                };
            },
            {
                "../common": 262,
                "../exif_utils": 263
            }
        ],
        275: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    avif: t1("./parse_sync/avif"),
                    bmp: t1("./parse_sync/bmp"),
                    gif: t1("./parse_sync/gif"),
                    ico: t1("./parse_sync/ico"),
                    jpeg: t1("./parse_sync/jpeg"),
                    png: t1("./parse_sync/png"),
                    psd: t1("./parse_sync/psd"),
                    svg: t1("./parse_sync/svg"),
                    tiff: t1("./parse_sync/tiff"),
                    webp: t1("./parse_sync/webp")
                };
            },
            {
                "./parse_sync/avif": 265,
                "./parse_sync/bmp": 266,
                "./parse_sync/gif": 267,
                "./parse_sync/ico": 268,
                "./parse_sync/jpeg": 269,
                "./parse_sync/png": 270,
                "./parse_sync/psd": 271,
                "./parse_sync/svg": 272,
                "./parse_sync/tiff": 273,
                "./parse_sync/webp": 274
            }
        ],
        276: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./lib/parsers_sync");
                e1.exports = function(t1) {
                    return function(t1) {
                        for(var e1 = Object.keys(n), r = 0; r < e1.length; r++){
                            var i = n[e1[r]](t1);
                            if (i) return i;
                        }
                        return null;
                    }(t1);
                }, e1.exports.parsers = n;
            },
            {
                "./lib/parsers_sync": 275
            }
        ],
        277: [
            function(t1, e1, r) {
                var n, i, a = e1.exports = {};
                function o() {
                    throw new Error("setTimeout has not been defined");
                }
                function s() {
                    throw new Error("clearTimeout has not been defined");
                }
                function l(t1) {
                    if (n === setTimeout) return setTimeout(t1, 0);
                    if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(t1, 0);
                    try {
                        return n(t1, 0);
                    } catch (e1) {
                        try {
                            return n.call(null, t1, 0);
                        } catch (e1) {
                            return n.call(this, t1, 0);
                        }
                    }
                }
                !function() {
                    try {
                        n = "function" == typeof setTimeout ? setTimeout : o;
                    } catch (t1) {
                        n = o;
                    }
                    try {
                        i = "function" == typeof clearTimeout ? clearTimeout : s;
                    } catch (t1) {
                        i = s;
                    }
                }();
                var c, u = [], f = !1, h = -1;
                function p() {
                    f && c && (f = !1, c.length ? u = c.concat(u) : h = -1, u.length && d());
                }
                function d() {
                    if (!f) {
                        var t1 = l(p);
                        f = !0;
                        for(var e1 = u.length; e1;){
                            for(c = u, u = []; ++h < e1;)c && c[h].run();
                            h = -1, e1 = u.length;
                        }
                        c = null, f = !1, function(t1) {
                            if (i === clearTimeout) return clearTimeout(t1);
                            if ((i === s || !i) && clearTimeout) return i = clearTimeout, clearTimeout(t1);
                            try {
                                i(t1);
                            } catch (e1) {
                                try {
                                    return i.call(null, t1);
                                } catch (e1) {
                                    return i.call(this, t1);
                                }
                            }
                        }(t1);
                    }
                }
                function m(t1, e1) {
                    this.fun = t1, this.array = e1;
                }
                function g() {}
                a.nextTick = function(t1) {
                    var e1 = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)e1[r - 1] = arguments[r];
                    u.push(new m(t1, e1)), 1 !== u.length || f || l(d);
                }, m.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, a.title = "browser", a.browser = !0, a.env = {}, a.argv = [], a.version = "", a.versions = {}, a.on = g, a.addListener = g, a.once = g, a.off = g, a.removeListener = g, a.removeAllListeners = g, a.emit = g, a.prependListener = g, a.prependOnceListener = g, a.listeners = function(t1) {
                    return [];
                }, a.binding = function(t1) {
                    throw new Error("process.binding is not supported");
                }, a.cwd = function() {
                    return "/";
                }, a.chdir = function(t1) {
                    throw new Error("process.chdir is not supported");
                }, a.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        278: [
            function(t1, e1, r) {
                (function(r) {
                    (function() {
                        for(var n = t1("performance-now"), i = "undefined" == typeof window ? r : window, a = [
                            "moz",
                            "webkit"
                        ], o = "AnimationFrame", s = i["request" + o], l = i["cancel" + o] || i["cancelRequest" + o], c = 0; !s && c < a.length; c++)s = i[a[c] + "Request" + o], l = i[a[c] + "Cancel" + o] || i[a[c] + "CancelRequest" + o];
                        if (!s || !l) {
                            var u = 0, f = 0, h = [];
                            s = function(t1) {
                                if (0 === h.length) {
                                    var e1 = n(), r = Math.max(0, 1e3 / 60 - (e1 - u));
                                    u = r + e1, setTimeout(function() {
                                        var t1 = h.slice(0);
                                        h.length = 0;
                                        for(var e1 = 0; e1 < t1.length; e1++)if (!t1[e1].cancelled) try {
                                            t1[e1].callback(u);
                                        } catch (t1) {
                                            setTimeout(function() {
                                                throw t1;
                                            }, 0);
                                        }
                                    }, Math.round(r));
                                }
                                return h.push({
                                    handle: ++f,
                                    callback: t1,
                                    cancelled: !1
                                }), f;
                            }, l = function(t1) {
                                for(var e1 = 0; e1 < h.length; e1++)h[e1].handle === t1 && (h[e1].cancelled = !0);
                            };
                        }
                        e1.exports = function(t1) {
                            return s.call(i, t1);
                        }, e1.exports.cancel = function() {
                            l.apply(i, arguments);
                        }, e1.exports.polyfill = function(t1) {
                            t1 || (t1 = i), t1.requestAnimationFrame = s, t1.cancelAnimationFrame = l;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "performance-now": 252
            }
        ],
        279: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("array-bounds"), i = t1("color-normalize"), a = t1("update-diff"), o = t1("pick-by-alias"), s = t1("object-assign"), l = t1("flatten-vertex-data"), c = t1("to-float32"), u = c.float32, f = c.fract32;
                e1.exports = function(t1, e1) {
                    "function" == typeof t1 ? (e1 || (e1 = {}), e1.regl = t1) : e1 = t1;
                    e1.length && (e1.positions = e1);
                    if (!(t1 = e1.regl).hasExtension("ANGLE_instanced_arrays")) throw Error("regl-error2d: `ANGLE_instanced_arrays` extension should be enabled");
                    var r, c, p, d, m, g, v = t1._gl, y = {
                        color: "black",
                        capSize: 5,
                        lineWidth: 1,
                        opacity: 1,
                        viewport: null,
                        range: null,
                        offset: 0,
                        count: 0,
                        bounds: null,
                        positions: [],
                        errors: []
                    }, x = [];
                    return d = t1.buffer({
                        usage: "dynamic",
                        type: "uint8",
                        data: new Uint8Array(0)
                    }), c = t1.buffer({
                        usage: "dynamic",
                        type: "float",
                        data: new Uint8Array(0)
                    }), p = t1.buffer({
                        usage: "dynamic",
                        type: "float",
                        data: new Uint8Array(0)
                    }), m = t1.buffer({
                        usage: "dynamic",
                        type: "float",
                        data: new Uint8Array(0)
                    }), g = t1.buffer({
                        usage: "static",
                        type: "float",
                        data: h
                    }), T(e1), r = t1({
                        vert: "\n\t\tprecision highp float;\n\n\t\tattribute vec2 position, positionFract;\n\t\tattribute vec4 error;\n\t\tattribute vec4 color;\n\n\t\tattribute vec2 direction, lineOffset, capOffset;\n\n\t\tuniform vec4 viewport;\n\t\tuniform float lineWidth, capSize;\n\t\tuniform vec2 scale, scaleFract, translate, translateFract;\n\n\t\tvarying vec4 fragColor;\n\n\t\tvoid main() {\n\t\t\tfragColor = color / 255.;\n\n\t\t\tvec2 pixelOffset = lineWidth * lineOffset + (capSize + lineWidth) * capOffset;\n\n\t\t\tvec2 dxy = -step(.5, direction.xy) * error.xz + step(direction.xy, vec2(-.5)) * error.yw;\n\n\t\t\tvec2 position = position + dxy;\n\n\t\t\tvec2 pos = (position + translate) * scale\n\t\t\t\t+ (positionFract + translateFract) * scale\n\t\t\t\t+ (position + translate) * scaleFract\n\t\t\t\t+ (positionFract + translateFract) * scaleFract;\n\n\t\t\tpos += pixelOffset / viewport.zw;\n\n\t\t\tgl_Position = vec4(pos * 2. - 1., 0, 1);\n\t\t}\n\t\t",
                        frag: "\n\t\tprecision highp float;\n\n\t\tvarying vec4 fragColor;\n\n\t\tuniform float opacity;\n\n\t\tvoid main() {\n\t\t\tgl_FragColor = fragColor;\n\t\t\tgl_FragColor.a *= opacity;\n\t\t}\n\t\t",
                        uniforms: {
                            range: t1.prop("range"),
                            lineWidth: t1.prop("lineWidth"),
                            capSize: t1.prop("capSize"),
                            opacity: t1.prop("opacity"),
                            scale: t1.prop("scale"),
                            translate: t1.prop("translate"),
                            scaleFract: t1.prop("scaleFract"),
                            translateFract: t1.prop("translateFract"),
                            viewport: function(t1, e1) {
                                return [
                                    e1.viewport.x,
                                    e1.viewport.y,
                                    t1.viewportWidth,
                                    t1.viewportHeight
                                ];
                            }
                        },
                        attributes: {
                            color: {
                                buffer: d,
                                offset: function(t1, e1) {
                                    return 4 * e1.offset;
                                },
                                divisor: 1
                            },
                            position: {
                                buffer: c,
                                offset: function(t1, e1) {
                                    return 8 * e1.offset;
                                },
                                divisor: 1
                            },
                            positionFract: {
                                buffer: p,
                                offset: function(t1, e1) {
                                    return 8 * e1.offset;
                                },
                                divisor: 1
                            },
                            error: {
                                buffer: m,
                                offset: function(t1, e1) {
                                    return 16 * e1.offset;
                                },
                                divisor: 1
                            },
                            direction: {
                                buffer: g,
                                stride: 24,
                                offset: 0
                            },
                            lineOffset: {
                                buffer: g,
                                stride: 24,
                                offset: 8
                            },
                            capOffset: {
                                buffer: g,
                                stride: 24,
                                offset: 16
                            }
                        },
                        primitive: "triangles",
                        blend: {
                            enable: !0,
                            color: [
                                0,
                                0,
                                0,
                                0
                            ],
                            equation: {
                                rgb: "add",
                                alpha: "add"
                            },
                            func: {
                                srcRGB: "src alpha",
                                dstRGB: "one minus src alpha",
                                srcAlpha: "one minus dst alpha",
                                dstAlpha: "one"
                            }
                        },
                        depth: {
                            enable: !1
                        },
                        scissor: {
                            enable: !0,
                            box: t1.prop("viewport")
                        },
                        viewport: t1.prop("viewport"),
                        stencil: !1,
                        instances: t1.prop("count"),
                        count: h.length
                    }), s(b, {
                        update: T,
                        draw: _,
                        destroy: k,
                        regl: t1,
                        gl: v,
                        canvas: v.canvas,
                        groups: x
                    }), b;
                    function b(t1) {
                        t1 ? T(t1) : null === t1 && k(), _();
                    }
                    function _(e1) {
                        if ("number" == typeof e1) return w(e1);
                        e1 && !Array.isArray(e1) && (e1 = [
                            e1
                        ]), t1._refresh(), x.forEach(function(t1, r) {
                            t1 && (e1 && (e1[r] ? t1.draw = !0 : t1.draw = !1), t1.draw ? w(r) : t1.draw = !0);
                        });
                    }
                    function w(t1) {
                        "number" == typeof t1 && (t1 = x[t1]), null != t1 && t1 && t1.count && t1.color && t1.opacity && t1.positions && t1.positions.length > 1 && (t1.scaleRatio = [
                            t1.scale[0] * t1.viewport.width,
                            t1.scale[1] * t1.viewport.height
                        ], r(t1), t1.after && t1.after(t1));
                    }
                    function T(t1) {
                        if (t1) {
                            null != t1.length ? "number" == typeof t1[0] && (t1 = [
                                {
                                    positions: t1
                                }
                            ]) : Array.isArray(t1) || (t1 = [
                                t1
                            ]);
                            var e1 = 0, r = 0;
                            if (b.groups = x = t1.map(function(t1, c) {
                                var u = x[c];
                                return t1 ? ("function" == typeof t1 ? t1 = {
                                    after: t1
                                } : "number" == typeof t1[0] && (t1 = {
                                    positions: t1
                                }), t1 = o(t1, {
                                    color: "color colors fill",
                                    capSize: "capSize cap capsize cap-size",
                                    lineWidth: "lineWidth line-width width line thickness",
                                    opacity: "opacity alpha",
                                    range: "range dataBox",
                                    viewport: "viewport viewBox",
                                    errors: "errors error",
                                    positions: "positions position data points"
                                }), u || (x[c] = u = {
                                    id: c,
                                    scale: null,
                                    translate: null,
                                    scaleFract: null,
                                    translateFract: null,
                                    draw: !0
                                }, t1 = s({}, y, t1)), a(u, t1, [
                                    {
                                        lineWidth: function(t1) {
                                            return .5 * +t1;
                                        },
                                        capSize: function(t1) {
                                            return .5 * +t1;
                                        },
                                        opacity: parseFloat,
                                        errors: function(t1) {
                                            return t1 = l(t1), r += t1.length, t1;
                                        },
                                        positions: function(t1, r) {
                                            return t1 = l(t1, "float64"), r.count = Math.floor(t1.length / 2), r.bounds = n(t1, 2), r.offset = e1, e1 += r.count, t1;
                                        }
                                    },
                                    {
                                        color: function(t1, e1) {
                                            var r = e1.count;
                                            if (t1 || (t1 = "transparent"), !Array.isArray(t1) || "number" == typeof t1[0]) {
                                                var n = t1;
                                                t1 = Array(r);
                                                for(var a = 0; a < r; a++)t1[a] = n;
                                            }
                                            if (t1.length < r) throw Error("Not enough colors");
                                            for(var o = new Uint8Array(4 * r), s = 0; s < r; s++){
                                                var l = i(t1[s], "uint8");
                                                o.set(l, 4 * s);
                                            }
                                            return o;
                                        },
                                        range: function(t1, e1, r) {
                                            var n = e1.bounds;
                                            return t1 || (t1 = n), e1.scale = [
                                                1 / (t1[2] - t1[0]),
                                                1 / (t1[3] - t1[1])
                                            ], e1.translate = [
                                                -t1[0],
                                                -t1[1]
                                            ], e1.scaleFract = f(e1.scale), e1.translateFract = f(e1.translate), t1;
                                        },
                                        viewport: function(t1) {
                                            var e1;
                                            return Array.isArray(t1) ? e1 = {
                                                x: t1[0],
                                                y: t1[1],
                                                width: t1[2] - t1[0],
                                                height: t1[3] - t1[1]
                                            } : t1 ? (e1 = {
                                                x: t1.x || t1.left || 0,
                                                y: t1.y || t1.top || 0
                                            }, t1.right ? e1.width = t1.right - e1.x : e1.width = t1.w || t1.width || 0, t1.bottom ? e1.height = t1.bottom - e1.y : e1.height = t1.h || t1.height || 0) : e1 = {
                                                x: 0,
                                                y: 0,
                                                width: v.drawingBufferWidth,
                                                height: v.drawingBufferHeight
                                            }, e1;
                                        }
                                    }
                                ]), u) : u;
                            }), e1 || r) {
                                var h = x.reduce(function(t1, e1, r) {
                                    return t1 + (e1 ? e1.count : 0);
                                }, 0), g = new Float64Array(2 * h), _ = new Uint8Array(4 * h), w = new Float32Array(4 * h);
                                x.forEach(function(t1, e1) {
                                    if (t1) {
                                        var r = t1.positions, n = t1.count, i = t1.offset, a = t1.color, o = t1.errors;
                                        n && (_.set(a, 4 * i), w.set(o, 4 * i), g.set(r, 2 * i));
                                    }
                                });
                                var T = u(g);
                                c(T);
                                var k = f(g, T);
                                p(k), d(_), m(w);
                            }
                        }
                    }
                    function k() {
                        c.destroy(), p.destroy(), d.destroy(), m.destroy(), g.destroy();
                    }
                };
                var h = [
                    [
                        1,
                        0,
                        0,
                        1,
                        0,
                        0
                    ],
                    [
                        1,
                        0,
                        0,
                        -1,
                        0,
                        0
                    ],
                    [
                        -1,
                        0,
                        0,
                        -1,
                        0,
                        0
                    ],
                    [
                        -1,
                        0,
                        0,
                        -1,
                        0,
                        0
                    ],
                    [
                        -1,
                        0,
                        0,
                        1,
                        0,
                        0
                    ],
                    [
                        1,
                        0,
                        0,
                        1,
                        0,
                        0
                    ],
                    [
                        1,
                        0,
                        -1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        -1,
                        0,
                        0,
                        -1
                    ],
                    [
                        1,
                        0,
                        1,
                        0,
                        0,
                        -1
                    ],
                    [
                        1,
                        0,
                        1,
                        0,
                        0,
                        -1
                    ],
                    [
                        1,
                        0,
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        -1,
                        0,
                        0,
                        1
                    ],
                    [
                        -1,
                        0,
                        -1,
                        0,
                        0,
                        1
                    ],
                    [
                        -1,
                        0,
                        -1,
                        0,
                        0,
                        -1
                    ],
                    [
                        -1,
                        0,
                        1,
                        0,
                        0,
                        -1
                    ],
                    [
                        -1,
                        0,
                        1,
                        0,
                        0,
                        -1
                    ],
                    [
                        -1,
                        0,
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        -1,
                        0,
                        -1,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        1,
                        1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        1,
                        -1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        -1,
                        -1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        -1,
                        -1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        1,
                        1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        -1,
                        1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        -1,
                        1,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        -1,
                        -1,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        1,
                        -1,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        1,
                        1,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        -1,
                        1,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        1,
                        -1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0,
                        -1,
                        1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0,
                        -1,
                        -1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0,
                        1,
                        -1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0,
                        1,
                        1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0,
                        -1,
                        1,
                        0
                    ],
                    [
                        0,
                        -1,
                        0,
                        1,
                        -1,
                        0
                    ]
                ];
            },
            {
                "array-bounds": 71,
                "color-normalize": 89,
                "flatten-vertex-data": 191,
                "object-assign": 247,
                "pick-by-alias": 253,
                "to-float32": 313,
                "update-diff": 329
            }
        ],
        280: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("color-normalize"), i = t1("array-bounds"), a = t1("object-assign"), o = t1("glslify"), s = t1("pick-by-alias"), l = t1("flatten-vertex-data"), c = t1("earcut"), u = t1("array-normalize"), f = t1("to-float32"), h = f.float32, p = f.fract32, d = t1("es6-weak-map"), m = t1("parse-rect"), g = t1("array-find-index");
                function v(t1, e1) {
                    if (!(this instanceof v)) return new v(t1, e1);
                    if ("function" == typeof t1 ? (e1 || (e1 = {}), e1.regl = t1) : e1 = t1, e1.length && (e1.positions = e1), !(t1 = e1.regl).hasExtension("ANGLE_instanced_arrays")) throw Error("regl-error2d: `ANGLE_instanced_arrays` extension should be enabled");
                    this.gl = t1._gl, this.regl = t1, this.passes = [], this.shaders = v.shaders.has(t1) ? v.shaders.get(t1) : v.shaders.set(t1, v.createShaders(t1)).get(t1), this.update(e1);
                }
                e1.exports = v, v.dashMult = 2, v.maxPatternLength = 256, v.precisionThreshold = 3e6, v.maxPoints = 1e4, v.maxLines = 2048, v.shaders = new d, v.createShaders = function(t1) {
                    var e1, r = t1.buffer({
                        usage: "static",
                        type: "float",
                        data: [
                            0,
                            1,
                            0,
                            0,
                            1,
                            1,
                            1,
                            0
                        ]
                    }), n = {
                        primitive: "triangle strip",
                        instances: t1.prop("count"),
                        count: 4,
                        offset: 0,
                        uniforms: {
                            miterMode: function(t1, e1) {
                                return "round" === e1.join ? 2 : 1;
                            },
                            miterLimit: t1.prop("miterLimit"),
                            scale: t1.prop("scale"),
                            scaleFract: t1.prop("scaleFract"),
                            translateFract: t1.prop("translateFract"),
                            translate: t1.prop("translate"),
                            thickness: t1.prop("thickness"),
                            dashTexture: t1.prop("dashTexture"),
                            opacity: t1.prop("opacity"),
                            pixelRatio: t1.context("pixelRatio"),
                            id: t1.prop("id"),
                            dashLength: t1.prop("dashLength"),
                            viewport: function(t1, e1) {
                                return [
                                    e1.viewport.x,
                                    e1.viewport.y,
                                    t1.viewportWidth,
                                    t1.viewportHeight
                                ];
                            },
                            depth: t1.prop("depth")
                        },
                        blend: {
                            enable: !0,
                            color: [
                                0,
                                0,
                                0,
                                0
                            ],
                            equation: {
                                rgb: "add",
                                alpha: "add"
                            },
                            func: {
                                srcRGB: "src alpha",
                                dstRGB: "one minus src alpha",
                                srcAlpha: "one minus dst alpha",
                                dstAlpha: "one"
                            }
                        },
                        depth: {
                            enable: function(t1, e1) {
                                return !e1.overlay;
                            }
                        },
                        stencil: {
                            enable: !1
                        },
                        scissor: {
                            enable: !0,
                            box: t1.prop("viewport")
                        },
                        viewport: t1.prop("viewport")
                    }, i = t1(a({
                        vert: o([
                            "precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aCoord, bCoord, aCoordFract, bCoordFract;\nattribute vec4 color;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvec2 project(vec2 position, vec2 positionFract, vec2 scale, vec2 scaleFract, vec2 translate, vec2 translateFract) {\n\t// the order is important\n\treturn position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n}\n\nvoid main() {\n\tfloat lineStart = 1. - lineEnd;\n\tfloat lineOffset = lineTop * 2. - 1.;\n\n\tvec2 diff = (bCoord + bCoordFract - aCoord - aCoordFract);\n\ttangent = normalize(diff * scale * viewport.zw);\n\tvec2 normal = vec2(-tangent.y, tangent.x);\n\n\tvec2 position = project(aCoord, aCoordFract, scale, scaleFract, translate, translateFract) * lineStart\n\t\t+ project(bCoord, bCoordFract, scale, scaleFract, translate, translateFract) * lineEnd\n\n\t\t+ thickness * normal * .5 * lineOffset / viewport.zw;\n\n\tgl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n\tfragColor = color / 255.;\n}\n"
                        ]),
                        frag: o([
                            "precision highp float;\n#define GLSLIFY 1\n\nuniform float dashLength, pixelRatio, thickness, opacity, id;\nuniform sampler2D dashTexture;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvoid main() {\n\tfloat alpha = 1.;\n\n\tfloat t = fract(dot(tangent, gl_FragCoord.xy) / dashLength) * .5 + .25;\n\tfloat dash = texture2D(dashTexture, vec2(t, .5)).r;\n\n\tgl_FragColor = fragColor;\n\tgl_FragColor.a *= alpha * opacity * dash;\n}\n"
                        ]),
                        attributes: {
                            lineEnd: {
                                buffer: r,
                                divisor: 0,
                                stride: 8,
                                offset: 0
                            },
                            lineTop: {
                                buffer: r,
                                divisor: 0,
                                stride: 8,
                                offset: 4
                            },
                            aCoord: {
                                buffer: t1.prop("positionBuffer"),
                                stride: 8,
                                offset: 8,
                                divisor: 1
                            },
                            bCoord: {
                                buffer: t1.prop("positionBuffer"),
                                stride: 8,
                                offset: 16,
                                divisor: 1
                            },
                            aCoordFract: {
                                buffer: t1.prop("positionFractBuffer"),
                                stride: 8,
                                offset: 8,
                                divisor: 1
                            },
                            bCoordFract: {
                                buffer: t1.prop("positionFractBuffer"),
                                stride: 8,
                                offset: 16,
                                divisor: 1
                            },
                            color: {
                                buffer: t1.prop("colorBuffer"),
                                stride: 4,
                                offset: 0,
                                divisor: 1
                            }
                        }
                    }, n));
                    try {
                        e1 = t1(a({
                            cull: {
                                enable: !0,
                                face: "back"
                            },
                            vert: o([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aCoord, bCoord, nextCoord, prevCoord;\nattribute vec4 aColor, bColor;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, translate;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\nuniform float miterLimit, miterMode;\n\nvarying vec4 fragColor;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 tangent;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nconst float REVERSE_THRESHOLD = -.875;\nconst float MIN_DIFF = 1e-6;\n\n// TODO: possible optimizations: avoid overcalculating all for vertices and calc just one instead\n// TODO: precalculate dot products, normalize things beforehead etc.\n// TODO: refactor to rectangular algorithm\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n\tvec2 diff = b - a;\n\tvec2 perp = normalize(vec2(-diff.y, diff.x));\n\treturn dot(p - a, perp);\n}\n\nbool isNaN( float val ){\n  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true;\n}\n\nvoid main() {\n\tvec2 aCoord = aCoord, bCoord = bCoord, prevCoord = prevCoord, nextCoord = nextCoord;\n\n  vec2 adjustedScale;\n  adjustedScale.x = (abs(scale.x) < MIN_DIFF) ? MIN_DIFF : scale.x;\n  adjustedScale.y = (abs(scale.y) < MIN_DIFF) ? MIN_DIFF : scale.y;\n\n  vec2 scaleRatio = adjustedScale * viewport.zw;\n\tvec2 normalWidth = thickness / scaleRatio;\n\n\tfloat lineStart = 1. - lineEnd;\n\tfloat lineBot = 1. - lineTop;\n\n\tfragColor = (lineStart * aColor + lineEnd * bColor) / 255.;\n\n\tif (isNaN(aCoord.x) || isNaN(aCoord.y) || isNaN(bCoord.x) || isNaN(bCoord.y)) return;\n\n\tif (aCoord == prevCoord) prevCoord = aCoord + normalize(bCoord - aCoord);\n\tif (bCoord == nextCoord) nextCoord = bCoord - normalize(bCoord - aCoord);\n\n\tvec2 prevDiff = aCoord - prevCoord;\n\tvec2 currDiff = bCoord - aCoord;\n\tvec2 nextDiff = nextCoord - bCoord;\n\n\tvec2 prevTangent = normalize(prevDiff * scaleRatio);\n\tvec2 currTangent = normalize(currDiff * scaleRatio);\n\tvec2 nextTangent = normalize(nextDiff * scaleRatio);\n\n\tvec2 prevNormal = vec2(-prevTangent.y, prevTangent.x);\n\tvec2 currNormal = vec2(-currTangent.y, currTangent.x);\n\tvec2 nextNormal = vec2(-nextTangent.y, nextTangent.x);\n\n\tvec2 startJoinDirection = normalize(prevTangent - currTangent);\n\tvec2 endJoinDirection = normalize(currTangent - nextTangent);\n\n\t// collapsed/unidirectional segment cases\n\t// FIXME: there should be more elegant solution\n\tvec2 prevTanDiff = abs(prevTangent - currTangent);\n\tvec2 nextTanDiff = abs(nextTangent - currTangent);\n\tif (max(prevTanDiff.x, prevTanDiff.y) < MIN_DIFF) {\n\t\tstartJoinDirection = currNormal;\n\t}\n\tif (max(nextTanDiff.x, nextTanDiff.y) < MIN_DIFF) {\n\t\tendJoinDirection = currNormal;\n\t}\n\tif (aCoord == bCoord) {\n\t\tendJoinDirection = startJoinDirection;\n\t\tcurrNormal = prevNormal;\n\t\tcurrTangent = prevTangent;\n\t}\n\n\ttangent = currTangent;\n\n\t//calculate join shifts relative to normals\n\tfloat startJoinShift = dot(currNormal, startJoinDirection);\n\tfloat endJoinShift = dot(currNormal, endJoinDirection);\n\n\tfloat startMiterRatio = abs(1. / startJoinShift);\n\tfloat endMiterRatio = abs(1. / endJoinShift);\n\n\tvec2 startJoin = startJoinDirection * startMiterRatio;\n\tvec2 endJoin = endJoinDirection * endMiterRatio;\n\n\tvec2 startTopJoin, startBotJoin, endTopJoin, endBotJoin;\n\tstartTopJoin = sign(startJoinShift) * startJoin * .5;\n\tstartBotJoin = -startTopJoin;\n\n\tendTopJoin = sign(endJoinShift) * endJoin * .5;\n\tendBotJoin = -endTopJoin;\n\n\tvec2 aTopCoord = aCoord + normalWidth * startTopJoin;\n\tvec2 bTopCoord = bCoord + normalWidth * endTopJoin;\n\tvec2 aBotCoord = aCoord + normalWidth * startBotJoin;\n\tvec2 bBotCoord = bCoord + normalWidth * endBotJoin;\n\n\t//miter anti-clipping\n\tfloat baClipping = distToLine(bCoord, aCoord, aBotCoord) / dot(normalize(normalWidth * endBotJoin), normalize(normalWidth.yx * vec2(-startBotJoin.y, startBotJoin.x)));\n\tfloat abClipping = distToLine(aCoord, bCoord, bTopCoord) / dot(normalize(normalWidth * startBotJoin), normalize(normalWidth.yx * vec2(-endBotJoin.y, endBotJoin.x)));\n\n\t//prevent close to reverse direction switch\n\tbool prevReverse = dot(currTangent, prevTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, prevNormal)) * min(length(prevDiff), length(currDiff)) <  length(normalWidth * currNormal);\n\tbool nextReverse = dot(currTangent, nextTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, nextNormal)) * min(length(nextDiff), length(currDiff)) <  length(normalWidth * currNormal);\n\n\tif (prevReverse) {\n\t\t//make join rectangular\n\t\tvec2 miterShift = normalWidth * startJoinDirection * miterLimit * .5;\n\t\tfloat normalAdjust = 1. - min(miterLimit / startMiterRatio, 1.);\n\t\taBotCoord = aCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n\t\taTopCoord = aCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n\t}\n\telse if (!nextReverse && baClipping > 0. && baClipping < length(normalWidth * endBotJoin)) {\n\t\t//handle miter clipping\n\t\tbTopCoord -= normalWidth * endTopJoin;\n\t\tbTopCoord += normalize(endTopJoin * normalWidth) * baClipping;\n\t}\n\n\tif (nextReverse) {\n\t\t//make join rectangular\n\t\tvec2 miterShift = normalWidth * endJoinDirection * miterLimit * .5;\n\t\tfloat normalAdjust = 1. - min(miterLimit / endMiterRatio, 1.);\n\t\tbBotCoord = bCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n\t\tbTopCoord = bCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n\t}\n\telse if (!prevReverse && abClipping > 0. && abClipping < length(normalWidth * startBotJoin)) {\n\t\t//handle miter clipping\n\t\taBotCoord -= normalWidth * startBotJoin;\n\t\taBotCoord += normalize(startBotJoin * normalWidth) * abClipping;\n\t}\n\n\tvec2 aTopPosition = (aTopCoord) * adjustedScale + translate;\n\tvec2 aBotPosition = (aBotCoord) * adjustedScale + translate;\n\n\tvec2 bTopPosition = (bTopCoord) * adjustedScale + translate;\n\tvec2 bBotPosition = (bBotCoord) * adjustedScale + translate;\n\n\t//position is normalized 0..1 coord on the screen\n\tvec2 position = (aTopPosition * lineTop + aBotPosition * lineBot) * lineStart + (bTopPosition * lineTop + bBotPosition * lineBot) * lineEnd;\n\n\tstartCoord = aCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n\tendCoord = bCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n\n\tgl_Position = vec4(position  * 2.0 - 1.0, depth, 1);\n\n\tenableStartMiter = step(dot(currTangent, prevTangent), .5);\n\tenableEndMiter = step(dot(currTangent, nextTangent), .5);\n\n\t//bevel miter cutoffs\n\tif (miterMode == 1.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tvec2 startMiterWidth = vec2(startJoinDirection) * thickness * miterLimit * .5;\n\t\t\tstartCutoff = vec4(aCoord, aCoord);\n\t\t\tstartCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n\t\t\tstartCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tstartCutoff += viewport.xyxy;\n\t\t\tstartCutoff += startMiterWidth.xyxy;\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tvec2 endMiterWidth = vec2(endJoinDirection) * thickness * miterLimit * .5;\n\t\t\tendCutoff = vec4(bCoord, bCoord);\n\t\t\tendCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n\t\t\tendCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tendCutoff += viewport.xyxy;\n\t\t\tendCutoff += endMiterWidth.xyxy;\n\t\t}\n\t}\n\n\t//round miter cutoffs\n\telse if (miterMode == 2.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tvec2 startMiterWidth = vec2(startJoinDirection) * thickness * abs(dot(startJoinDirection, currNormal)) * .5;\n\t\t\tstartCutoff = vec4(aCoord, aCoord);\n\t\t\tstartCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n\t\t\tstartCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tstartCutoff += viewport.xyxy;\n\t\t\tstartCutoff += startMiterWidth.xyxy;\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tvec2 endMiterWidth = vec2(endJoinDirection) * thickness * abs(dot(endJoinDirection, currNormal)) * .5;\n\t\t\tendCutoff = vec4(bCoord, bCoord);\n\t\t\tendCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n\t\t\tendCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tendCutoff += viewport.xyxy;\n\t\t\tendCutoff += endMiterWidth.xyxy;\n\t\t}\n\t}\n}\n"
                            ]),
                            frag: o([
                                "precision highp float;\n#define GLSLIFY 1\n\nuniform float dashLength, pixelRatio, thickness, opacity, id, miterMode;\nuniform sampler2D dashTexture;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n\tvec2 diff = b - a;\n\tvec2 perp = normalize(vec2(-diff.y, diff.x));\n\treturn dot(p - a, perp);\n}\n\nvoid main() {\n\tfloat alpha = 1., distToStart, distToEnd;\n\tfloat cutoff = thickness * .5;\n\n\t//bevel miter\n\tif (miterMode == 1.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tdistToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n\t\t\tif (distToStart < -1.) {\n\t\t\t\tdiscard;\n\t\t\t\treturn;\n\t\t\t}\n\t\t\talpha *= min(max(distToStart + 1., 0.), 1.);\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tdistToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n\t\t\tif (distToEnd < -1.) {\n\t\t\t\tdiscard;\n\t\t\t\treturn;\n\t\t\t}\n\t\t\talpha *= min(max(distToEnd + 1., 0.), 1.);\n\t\t}\n\t}\n\n\t// round miter\n\telse if (miterMode == 2.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tdistToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n\t\t\tif (distToStart < 0.) {\n\t\t\t\tfloat radius = length(gl_FragCoord.xy - startCoord);\n\n\t\t\t\tif(radius > cutoff + .5) {\n\t\t\t\t\tdiscard;\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\talpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n\t\t\t}\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tdistToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n\t\t\tif (distToEnd < 0.) {\n\t\t\t\tfloat radius = length(gl_FragCoord.xy - endCoord);\n\n\t\t\t\tif(radius > cutoff + .5) {\n\t\t\t\t\tdiscard;\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\talpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n\t\t\t}\n\t\t}\n\t}\n\n\tfloat t = fract(dot(tangent, gl_FragCoord.xy) / dashLength) * .5 + .25;\n\tfloat dash = texture2D(dashTexture, vec2(t, .5)).r;\n\n\tgl_FragColor = fragColor;\n\tgl_FragColor.a *= alpha * opacity * dash;\n}\n"
                            ]),
                            attributes: {
                                lineEnd: {
                                    buffer: r,
                                    divisor: 0,
                                    stride: 8,
                                    offset: 0
                                },
                                lineTop: {
                                    buffer: r,
                                    divisor: 0,
                                    stride: 8,
                                    offset: 4
                                },
                                aColor: {
                                    buffer: t1.prop("colorBuffer"),
                                    stride: 4,
                                    offset: 0,
                                    divisor: 1
                                },
                                bColor: {
                                    buffer: t1.prop("colorBuffer"),
                                    stride: 4,
                                    offset: 4,
                                    divisor: 1
                                },
                                prevCoord: {
                                    buffer: t1.prop("positionBuffer"),
                                    stride: 8,
                                    offset: 0,
                                    divisor: 1
                                },
                                aCoord: {
                                    buffer: t1.prop("positionBuffer"),
                                    stride: 8,
                                    offset: 8,
                                    divisor: 1
                                },
                                bCoord: {
                                    buffer: t1.prop("positionBuffer"),
                                    stride: 8,
                                    offset: 16,
                                    divisor: 1
                                },
                                nextCoord: {
                                    buffer: t1.prop("positionBuffer"),
                                    stride: 8,
                                    offset: 24,
                                    divisor: 1
                                }
                            }
                        }, n));
                    } catch (t1) {
                        e1 = i;
                    }
                    return {
                        fill: t1({
                            primitive: "triangle",
                            elements: function(t1, e1) {
                                return e1.triangles;
                            },
                            offset: 0,
                            vert: o([
                                "precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 position, positionFract;\n\nuniform vec4 color;\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float pixelRatio, id;\nuniform vec4 viewport;\nuniform float opacity;\n\nvarying vec4 fragColor;\n\nconst float MAX_LINES = 256.;\n\nvoid main() {\n\tfloat depth = (MAX_LINES - 4. - id) / (MAX_LINES);\n\n\tvec2 position = position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n\n\tgl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n\tfragColor = color / 255.;\n\tfragColor.a *= opacity;\n}\n"
                            ]),
                            frag: o([
                                "precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n\tgl_FragColor = fragColor;\n}\n"
                            ]),
                            uniforms: {
                                scale: t1.prop("scale"),
                                color: t1.prop("fill"),
                                scaleFract: t1.prop("scaleFract"),
                                translateFract: t1.prop("translateFract"),
                                translate: t1.prop("translate"),
                                opacity: t1.prop("opacity"),
                                pixelRatio: t1.context("pixelRatio"),
                                id: t1.prop("id"),
                                viewport: function(t1, e1) {
                                    return [
                                        e1.viewport.x,
                                        e1.viewport.y,
                                        t1.viewportWidth,
                                        t1.viewportHeight
                                    ];
                                }
                            },
                            attributes: {
                                position: {
                                    buffer: t1.prop("positionBuffer"),
                                    stride: 8,
                                    offset: 8
                                },
                                positionFract: {
                                    buffer: t1.prop("positionFractBuffer"),
                                    stride: 8,
                                    offset: 8
                                }
                            },
                            blend: n.blend,
                            depth: {
                                enable: !1
                            },
                            scissor: n.scissor,
                            stencil: n.stencil,
                            viewport: n.viewport
                        }),
                        rect: i,
                        miter: e1
                    };
                }, v.defaults = {
                    dashes: null,
                    join: "miter",
                    miterLimit: 1,
                    thickness: 10,
                    cap: "square",
                    color: "black",
                    opacity: 1,
                    overlay: !1,
                    viewport: null,
                    range: null,
                    close: !1,
                    fill: null
                }, v.prototype.render = function() {
                    for(var t1, e1 = [], r = arguments.length; r--;)e1[r] = arguments[r];
                    e1.length && (t1 = this).update.apply(t1, e1), this.draw();
                }, v.prototype.draw = function() {
                    for(var t1 = this, e1 = [], r = arguments.length; r--;)e1[r] = arguments[r];
                    return (e1.length ? e1 : this.passes).forEach(function(e1, r) {
                        var n;
                        if (e1 && Array.isArray(e1)) return (n = t1).draw.apply(n, e1);
                        "number" == typeof e1 && (e1 = t1.passes[e1]), e1 && e1.count > 1 && e1.opacity && (t1.regl._refresh(), e1.fill && e1.triangles && e1.triangles.length > 2 && t1.shaders.fill(e1), e1.thickness && (e1.scale[0] * e1.viewport.width > v.precisionThreshold || e1.scale[1] * e1.viewport.height > v.precisionThreshold || "rect" === e1.join || !e1.join && (e1.thickness <= 2 || e1.count >= v.maxPoints) ? t1.shaders.rect(e1) : t1.shaders.miter(e1)));
                    }), this;
                }, v.prototype.update = function(t1) {
                    var e1 = this;
                    if (t1) {
                        null != t1.length ? "number" == typeof t1[0] && (t1 = [
                            {
                                positions: t1
                            }
                        ]) : Array.isArray(t1) || (t1 = [
                            t1
                        ]);
                        var r = this.regl, o = this.gl;
                        if (t1.forEach(function(t1, f) {
                            var d = e1.passes[f];
                            if (void 0 !== t1) {
                                if (null !== t1) {
                                    if ("number" == typeof t1[0] && (t1 = {
                                        positions: t1
                                    }), t1 = s(t1, {
                                        positions: "positions points data coords",
                                        thickness: "thickness lineWidth lineWidths line-width linewidth width stroke-width strokewidth strokeWidth",
                                        join: "lineJoin linejoin join type mode",
                                        miterLimit: "miterlimit miterLimit",
                                        dashes: "dash dashes dasharray dash-array dashArray",
                                        color: "color colour stroke colors colours stroke-color strokeColor",
                                        fill: "fill fill-color fillColor",
                                        opacity: "alpha opacity",
                                        overlay: "overlay crease overlap intersect",
                                        close: "closed close closed-path closePath",
                                        range: "range dataBox",
                                        viewport: "viewport viewBox",
                                        hole: "holes hole hollow",
                                        splitNull: "splitNull"
                                    }), d || (e1.passes[f] = d = {
                                        id: f,
                                        scale: null,
                                        scaleFract: null,
                                        translate: null,
                                        translateFract: null,
                                        count: 0,
                                        hole: [],
                                        depth: 0,
                                        dashLength: 1,
                                        dashTexture: r.texture({
                                            channels: 1,
                                            data: new Uint8Array([
                                                255
                                            ]),
                                            width: 1,
                                            height: 1,
                                            mag: "linear",
                                            min: "linear"
                                        }),
                                        colorBuffer: r.buffer({
                                            usage: "dynamic",
                                            type: "uint8",
                                            data: new Uint8Array
                                        }),
                                        positionBuffer: r.buffer({
                                            usage: "dynamic",
                                            type: "float",
                                            data: new Uint8Array
                                        }),
                                        positionFractBuffer: r.buffer({
                                            usage: "dynamic",
                                            type: "float",
                                            data: new Uint8Array
                                        })
                                    }, t1 = a({}, v.defaults, t1)), null != t1.thickness && (d.thickness = parseFloat(t1.thickness)), null != t1.opacity && (d.opacity = parseFloat(t1.opacity)), null != t1.miterLimit && (d.miterLimit = parseFloat(t1.miterLimit)), null != t1.overlay && (d.overlay = !!t1.overlay, f < v.maxLines && (d.depth = 2 * (v.maxLines - 1 - f % v.maxLines) / v.maxLines - 1)), null != t1.join && (d.join = t1.join), null != t1.hole && (d.hole = t1.hole), null != t1.fill && (d.fill = t1.fill ? n(t1.fill, "uint8") : null), null != t1.viewport && (d.viewport = m(t1.viewport)), d.viewport || (d.viewport = m([
                                        o.drawingBufferWidth,
                                        o.drawingBufferHeight
                                    ])), null != t1.close && (d.close = t1.close), null === t1.positions && (t1.positions = []), t1.positions) {
                                        var y, x;
                                        if (t1.positions.x && t1.positions.y) {
                                            var b = t1.positions.x, _ = t1.positions.y;
                                            x = d.count = Math.max(b.length, _.length), y = new Float64Array(2 * x);
                                            for(var w = 0; w < x; w++)y[2 * w] = b[w], y[2 * w + 1] = _[w];
                                        } else y = l(t1.positions, "float64"), x = d.count = Math.floor(y.length / 2);
                                        var T = d.bounds = i(y, 2);
                                        if (d.fill) {
                                            for(var k = [], A = {}, M = 0, S = 0, E = 0, L = d.count; S < L; S++){
                                                var C = y[2 * S], P = y[2 * S + 1];
                                                isNaN(C) || isNaN(P) || null == C || null == P ? (C = y[2 * M], P = y[2 * M + 1], A[S] = M) : M = S, k[E++] = C, k[E++] = P;
                                            }
                                            if (t1.splitNull) {
                                                d.count - 1 in A || (A[d.count] = d.count - 1);
                                                var I = Object.keys(A).map(Number).sort(function(t1, e1) {
                                                    return t1 - e1;
                                                }), O = [], z = 0, D = null != d.hole ? d.hole[0] : null;
                                                if (null != D) {
                                                    var R = g(I, function(t1) {
                                                        return t1 >= D;
                                                    });
                                                    (I = I.slice(0, R)).push(D);
                                                }
                                                for(var F = function(t1) {
                                                    var e1 = k.slice(2 * z, 2 * I[t1]).concat(D ? k.slice(2 * D) : []), r = (d.hole || []).map(function(e1) {
                                                        return e1 - D + (I[t1] - z);
                                                    }), n = c(e1, r);
                                                    n = n.map(function(e1) {
                                                        return e1 + z + (e1 + z < I[t1] ? 0 : D - I[t1]);
                                                    }), O.push.apply(O, n), z = I[t1] + 1;
                                                }, B = 0; B < I.length; B++)F(B);
                                                for(var N = 0, j = O.length; N < j; N++)null != A[O[N]] && (O[N] = A[O[N]]);
                                                d.triangles = O;
                                            } else {
                                                for(var U = c(k, d.hole || []), V = 0, H = U.length; V < H; V++)null != A[U[V]] && (U[V] = A[U[V]]);
                                                d.triangles = U;
                                            }
                                        }
                                        var q = new Float64Array(y);
                                        u(q, 2, T);
                                        var G = new Float64Array(2 * x + 6);
                                        d.close ? y[0] === y[2 * x - 2] && y[1] === y[2 * x - 1] ? (G[0] = q[2 * x - 4], G[1] = q[2 * x - 3]) : (G[0] = q[2 * x - 2], G[1] = q[2 * x - 1]) : (G[0] = q[0], G[1] = q[1]), G.set(q, 2), d.close ? y[0] === y[2 * x - 2] && y[1] === y[2 * x - 1] ? (G[2 * x + 2] = q[2], G[2 * x + 3] = q[3], d.count -= 1) : (G[2 * x + 2] = q[0], G[2 * x + 3] = q[1], G[2 * x + 4] = q[2], G[2 * x + 5] = q[3]) : (G[2 * x + 2] = q[2 * x - 2], G[2 * x + 3] = q[2 * x - 1], G[2 * x + 4] = q[2 * x - 2], G[2 * x + 5] = q[2 * x - 1]);
                                        var Y = h(G);
                                        d.positionBuffer(Y);
                                        var W = p(G, Y);
                                        d.positionFractBuffer(W);
                                    }
                                    if (t1.range ? d.range = t1.range : d.range || (d.range = d.bounds), (t1.range || t1.positions) && d.count) {
                                        var X = d.bounds, Z = X[2] - X[0], J = X[3] - X[1], K = d.range[2] - d.range[0], Q = d.range[3] - d.range[1];
                                        d.scale = [
                                            Z / K,
                                            J / Q
                                        ], d.translate = [
                                            -d.range[0] / K + X[0] / K || 0,
                                            -d.range[1] / Q + X[1] / Q || 0
                                        ], d.scaleFract = p(d.scale), d.translateFract = p(d.translate);
                                    }
                                    if (t1.dashes) {
                                        var $, tt = 0;
                                        if (!t1.dashes || t1.dashes.length < 2) tt = 1, $ = new Uint8Array([
                                            255,
                                            255,
                                            255,
                                            255,
                                            255,
                                            255,
                                            255,
                                            255
                                        ]);
                                        else {
                                            tt = 0;
                                            for(var et = 0; et < t1.dashes.length; ++et)tt += t1.dashes[et];
                                            $ = new Uint8Array(tt * v.dashMult);
                                            for(var rt = 0, nt = 255, it = 0; it < 2; it++)for(var at = 0; at < t1.dashes.length; ++at){
                                                for(var ot = 0, st = t1.dashes[at] * v.dashMult * .5; ot < st; ++ot)$[rt++] = nt;
                                                nt ^= 255;
                                            }
                                        }
                                        d.dashLength = tt, d.dashTexture({
                                            channels: 1,
                                            data: $,
                                            width: $.length,
                                            height: 1,
                                            mag: "linear",
                                            min: "linear"
                                        }, 0, 0);
                                    }
                                    if (t1.color) {
                                        var lt = d.count, ct = t1.color;
                                        ct || (ct = "transparent");
                                        var ut = new Uint8Array(4 * lt + 4);
                                        if (Array.isArray(ct) && "number" != typeof ct[0]) {
                                            for(var ft = 0; ft < lt; ft++){
                                                var ht = n(ct[ft], "uint8");
                                                ut.set(ht, 4 * ft);
                                            }
                                            ut.set(n(ct[0], "uint8"), 4 * lt);
                                        } else for(var pt = n(ct, "uint8"), dt = 0; dt < lt + 1; dt++)ut.set(pt, 4 * dt);
                                        d.colorBuffer({
                                            usage: "dynamic",
                                            type: "uint8",
                                            data: ut
                                        });
                                    }
                                } else e1.passes[f] = null;
                            }
                        }), t1.length < this.passes.length) {
                            for(var f = t1.length; f < this.passes.length; f++){
                                var d = this.passes[f];
                                d && (d.colorBuffer.destroy(), d.positionBuffer.destroy(), d.dashTexture.destroy());
                            }
                            this.passes.length = t1.length;
                        }
                        for(var y = [], x = 0; x < this.passes.length; x++)null !== this.passes[x] && y.push(this.passes[x]);
                        return this.passes = y, this;
                    }
                }, v.prototype.destroy = function() {
                    return this.passes.forEach(function(t1) {
                        t1.colorBuffer.destroy(), t1.positionBuffer.destroy(), t1.dashTexture.destroy();
                    }), this.passes.length = 0, this;
                };
            },
            {
                "array-bounds": 71,
                "array-find-index": 72,
                "array-normalize": 73,
                "color-normalize": 89,
                earcut: 129,
                "es6-weak-map": 183,
                "flatten-vertex-data": 191,
                glslify: 227,
                "object-assign": 247,
                "parse-rect": 249,
                "pick-by-alias": 253,
                "to-float32": 313
            }
        ],
        281: [
            function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    return function(t1) {
                        if (Array.isArray(t1)) return t1;
                    }(t1) || function(t1, e1) {
                        var r = null == t1 ? null : "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
                        if (null == r) return;
                        var n, i, a = [], o = !0, s = !1;
                        try {
                            for(r = r.call(t1); !(o = (n = r.next()).done) && (a.push(n.value), !e1 || a.length !== e1); o = !0);
                        } catch (t1) {
                            s = !0, i = t1;
                        } finally{
                            try {
                                o || null == r.return || r.return();
                            } finally{
                                if (s) throw i;
                            }
                        }
                        return a;
                    }(t1, e1) || a(t1, e1) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function i(t1) {
                    return function(t1) {
                        if (Array.isArray(t1)) return o(t1);
                    }(t1) || function(t1) {
                        if ("undefined" != typeof Symbol && null != t1[Symbol.iterator] || null != t1["@@iterator"]) return Array.from(t1);
                    }(t1) || a(t1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function a(t1, e1) {
                    if (t1) {
                        if ("string" == typeof t1) return o(t1, e1);
                        var r = Object.prototype.toString.call(t1).slice(8, -1);
                        return "Object" === r && t1.constructor && (r = t1.constructor.name), "Map" === r || "Set" === r ? Array.from(t1) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? o(t1, e1) : void 0;
                    }
                }
                function o(t1, e1) {
                    (null == e1 || e1 > t1.length) && (e1 = t1.length);
                    for(var r = 0, n = new Array(e1); r < e1; r++)n[r] = t1[r];
                    return n;
                }
                var s = t1("color-normalize"), l = t1("array-bounds"), c = t1("color-id"), u = t1("@plotly/point-cluster"), f = t1("object-assign"), h = t1("glslify"), p = t1("pick-by-alias"), d = t1("update-diff"), m = t1("flatten-vertex-data"), g = t1("is-iexplorer"), v = t1("to-float32"), y = t1("parse-rect"), x = b;
                function b(t1, e1) {
                    var r = this;
                    if (!(this instanceof b)) return new b(t1, e1);
                    "function" == typeof t1 ? (e1 || (e1 = {}), e1.regl = t1) : (e1 = t1, t1 = null), e1 && e1.length && (e1.positions = e1);
                    var n, i = (t1 = e1.regl)._gl, a = [];
                    this.tooManyColors = g, n = t1.texture({
                        data: new Uint8Array(1020),
                        width: 255,
                        height: 1,
                        type: "uint8",
                        format: "rgba",
                        wrapS: "clamp",
                        wrapT: "clamp",
                        mag: "nearest",
                        min: "nearest"
                    }), f(this, {
                        regl: t1,
                        gl: i,
                        groups: [],
                        markerCache: [
                            null
                        ],
                        markerTextures: [
                            null
                        ],
                        palette: a,
                        paletteIds: {},
                        paletteTexture: n,
                        maxColors: 255,
                        maxSize: 100,
                        canvas: i.canvas
                    }), this.update(e1);
                    var o = {
                        uniforms: {
                            constPointSize: !!e1.constPointSize,
                            opacity: t1.prop("opacity"),
                            paletteSize: function(t1, e1) {
                                return [
                                    r.tooManyColors ? 0 : 255,
                                    n.height
                                ];
                            },
                            pixelRatio: t1.context("pixelRatio"),
                            scale: t1.prop("scale"),
                            scaleFract: t1.prop("scaleFract"),
                            translate: t1.prop("translate"),
                            translateFract: t1.prop("translateFract"),
                            markerTexture: t1.prop("markerTexture"),
                            paletteTexture: n
                        },
                        attributes: {
                            x: function(t1, e1) {
                                return e1.xAttr || {
                                    buffer: e1.positionBuffer,
                                    stride: 8,
                                    offset: 0
                                };
                            },
                            y: function(t1, e1) {
                                return e1.yAttr || {
                                    buffer: e1.positionBuffer,
                                    stride: 8,
                                    offset: 4
                                };
                            },
                            xFract: function(t1, e1) {
                                return e1.xAttr ? {
                                    constant: [
                                        0,
                                        0
                                    ]
                                } : {
                                    buffer: e1.positionFractBuffer,
                                    stride: 8,
                                    offset: 0
                                };
                            },
                            yFract: function(t1, e1) {
                                return e1.yAttr ? {
                                    constant: [
                                        0,
                                        0
                                    ]
                                } : {
                                    buffer: e1.positionFractBuffer,
                                    stride: 8,
                                    offset: 4
                                };
                            },
                            size: function(t1, e1) {
                                return e1.size.length ? {
                                    buffer: e1.sizeBuffer,
                                    stride: 2,
                                    offset: 0
                                } : {
                                    constant: [
                                        Math.round(255 * e1.size / r.maxSize)
                                    ]
                                };
                            },
                            borderSize: function(t1, e1) {
                                return e1.borderSize.length ? {
                                    buffer: e1.sizeBuffer,
                                    stride: 2,
                                    offset: 1
                                } : {
                                    constant: [
                                        Math.round(255 * e1.borderSize / r.maxSize)
                                    ]
                                };
                            },
                            colorId: function(t1, e1) {
                                return e1.color.length ? {
                                    buffer: e1.colorBuffer,
                                    stride: r.tooManyColors ? 8 : 4,
                                    offset: 0
                                } : {
                                    constant: r.tooManyColors ? a.slice(4 * e1.color, 4 * e1.color + 4) : [
                                        e1.color
                                    ]
                                };
                            },
                            borderColorId: function(t1, e1) {
                                return e1.borderColor.length ? {
                                    buffer: e1.colorBuffer,
                                    stride: r.tooManyColors ? 8 : 4,
                                    offset: r.tooManyColors ? 4 : 2
                                } : {
                                    constant: r.tooManyColors ? a.slice(4 * e1.borderColor, 4 * e1.borderColor + 4) : [
                                        e1.borderColor
                                    ]
                                };
                            },
                            isActive: function(t1, e1) {
                                return !0 === e1.activation ? {
                                    constant: [
                                        1
                                    ]
                                } : e1.activation ? e1.activation : {
                                    constant: [
                                        0
                                    ]
                                };
                            }
                        },
                        blend: {
                            enable: !0,
                            color: [
                                0,
                                0,
                                0,
                                1
                            ],
                            func: {
                                srcRGB: "src alpha",
                                dstRGB: "one minus src alpha",
                                srcAlpha: "one minus dst alpha",
                                dstAlpha: "one"
                            }
                        },
                        scissor: {
                            enable: !0,
                            box: t1.prop("viewport")
                        },
                        viewport: t1.prop("viewport"),
                        stencil: {
                            enable: !1
                        },
                        depth: {
                            enable: !1
                        },
                        elements: t1.prop("elements"),
                        count: t1.prop("count"),
                        offset: t1.prop("offset"),
                        primitive: "points"
                    }, s = f({}, o);
                    s.frag = h([
                        "precision highp float;\n#define GLSLIFY 1\n\nuniform float opacity;\nuniform sampler2D markerTexture;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragWidth, fragBorderColorLevel, fragColorLevel;\n\nfloat smoothStep(float x, float y) {\n  return 1.0 / (1.0 + exp(50.0*(x - y)));\n}\n\nvoid main() {\n  float dist = texture2D(markerTexture, gl_PointCoord).r, delta = fragWidth;\n\n  // max-distance alpha\n  if (dist < 0.003) discard;\n\n  // null-border case\n  if (fragBorderColorLevel == fragColorLevel || fragBorderColor.a == 0.) {\n    float colorAmt = smoothstep(.5 - delta, .5 + delta, dist);\n    gl_FragColor = vec4(fragColor.rgb, colorAmt * fragColor.a * opacity);\n  }\n  else {\n    float borderColorAmt = smoothstep(fragBorderColorLevel - delta, fragBorderColorLevel + delta, dist);\n    float colorAmt = smoothstep(fragColorLevel - delta, fragColorLevel + delta, dist);\n\n    vec4 color = fragBorderColor;\n    color.a *= borderColorAmt;\n    color = mix(color, fragColor, colorAmt);\n    color.a *= opacity;\n\n    gl_FragColor = color;\n  }\n\n}\n"
                    ]), s.vert = h([
                        "precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\nuniform bool constPointSize;\nuniform float pixelRatio;\nuniform vec2 scale, scaleFract, translate, translateFract, paletteSize;\nuniform sampler2D paletteTexture;\n\nconst float maxSize = 100.;\nconst float borderLevel = .5;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragPointSize, fragBorderRadius, fragWidth, fragBorderColorLevel, fragColorLevel;\n\nfloat pointSizeScale = (constPointSize) ? 2. : pixelRatio;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(paletteTexture,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = 2. * size * pointSizeScale;\n  fragPointSize = size * pixelRatio;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0., 1.);\n\n  fragColor = color;\n  fragBorderColor = borderColor;\n  fragWidth = 1. / gl_PointSize;\n\n  fragBorderColorLevel = clamp(borderLevel - borderLevel * borderSize / size, 0., 1.);\n  fragColorLevel = clamp(borderLevel + (1. - borderLevel) * borderSize / size, 0., 1.);\n}"
                    ]), this.drawMarker = t1(s);
                    var l = f({}, o);
                    l.frag = h([
                        "precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragBorderRadius, fragWidth;\n\nuniform float opacity;\n\nfloat smoothStep(float edge0, float edge1, float x) {\n\tfloat t;\n\tt = clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);\n\treturn t * t * (3.0 - 2.0 * t);\n}\n\nvoid main() {\n\tfloat radius, alpha = 1.0, delta = fragWidth;\n\n\tradius = length(2.0 * gl_PointCoord.xy - 1.0);\n\n\tif (radius > 1.0 + delta) {\n\t\tdiscard;\n\t}\n\n\talpha -= smoothstep(1.0 - delta, 1.0 + delta, radius);\n\n\tfloat borderRadius = fragBorderRadius;\n\tfloat ratio = smoothstep(borderRadius - delta, borderRadius + delta, radius);\n\tvec4 color = mix(fragColor, fragBorderColor, ratio);\n\tcolor.a *= alpha * opacity;\n\tgl_FragColor = color;\n}\n"
                    ]), l.vert = h([
                        "precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\nuniform bool constPointSize;\nuniform float pixelRatio;\nuniform vec2 paletteSize, scale, scaleFract, translate, translateFract;\nuniform sampler2D paletteTexture;\n\nconst float maxSize = 100.;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragBorderRadius, fragWidth;\n\nfloat pointSizeScale = (constPointSize) ? 2. : pixelRatio;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(paletteTexture,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = (size + borderSize) * pointSizeScale;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0., 1.);\n\n  fragBorderRadius = 1. - 2. * borderSize / (size + borderSize);\n  fragColor = color;\n  fragBorderColor = borderColor.a == 0. || borderSize == 0. ? vec4(color.rgb, 0.) : borderColor;\n  fragWidth = 1. / gl_PointSize;\n}\n"
                    ]), g && (l.frag = l.frag.replace("smoothstep", "smoothStep"), s.frag = s.frag.replace("smoothstep", "smoothStep")), this.drawCircle = t1(l);
                }
                b.defaults = {
                    color: "black",
                    borderColor: "transparent",
                    borderSize: 0,
                    size: 12,
                    opacity: 1,
                    marker: void 0,
                    viewport: null,
                    range: null,
                    pixelSize: null,
                    count: 0,
                    offset: 0,
                    bounds: null,
                    positions: [],
                    snap: 1e4
                }, b.prototype.render = function() {
                    return arguments.length && this.update.apply(this, arguments), this.draw(), this;
                }, b.prototype.draw = function() {
                    for(var t1 = this, e1 = arguments.length, r = new Array(e1), n = 0; n < e1; n++)r[n] = arguments[n];
                    var i = this.groups;
                    if (1 === r.length && Array.isArray(r[0]) && (null === r[0][0] || Array.isArray(r[0][0])) && (r = r[0]), this.regl._refresh(), r.length) for(var a = 0; a < r.length; a++)this.drawItem(a, r[a]);
                    else i.forEach(function(e1, r) {
                        t1.drawItem(r);
                    });
                    return this;
                }, b.prototype.drawItem = function(t1, e1) {
                    var r = this.groups, n = r[t1];
                    if ("number" == typeof e1 && (t1 = e1, n = r[e1], e1 = null), n && n.count && n.opacity) {
                        n.activation[0] && this.drawCircle(this.getMarkerDrawOptions(0, n, e1));
                        for(var a = [], o = 1; o < n.activation.length; o++)n.activation[o] && (!0 === n.activation[o] || n.activation[o].data.length) && a.push.apply(a, i(this.getMarkerDrawOptions(o, n, e1)));
                        a.length && this.drawMarker(a);
                    }
                }, b.prototype.getMarkerDrawOptions = function(t1, e1, r) {
                    var i = e1.range, a = e1.tree, o = e1.viewport, s = e1.activation, l = e1.selectionBuffer, c = e1.count;
                    this.regl;
                    if (!a) return r ? [
                        f({}, e1, {
                            markerTexture: this.markerTextures[t1],
                            activation: s[t1],
                            count: r.length,
                            elements: r,
                            offset: 0
                        })
                    ] : [
                        f({}, e1, {
                            markerTexture: this.markerTextures[t1],
                            activation: s[t1],
                            offset: 0
                        })
                    ];
                    var u = [], h = a.range(i, {
                        lod: !0,
                        px: [
                            (i[2] - i[0]) / o.width,
                            (i[3] - i[1]) / o.height
                        ]
                    });
                    if (r) {
                        for(var p = s[t1].data, d = new Uint8Array(c), m = 0; m < r.length; m++){
                            var g = r[m];
                            d[g] = p ? p[g] : 1;
                        }
                        l.subdata(d);
                    }
                    for(var v = h.length; v--;){
                        var y = n(h[v], 2), x = y[0], b = y[1];
                        u.push(f({}, e1, {
                            markerTexture: this.markerTextures[t1],
                            activation: r ? l : s[t1],
                            offset: x,
                            count: b - x
                        }));
                    }
                    return u;
                }, b.prototype.update = function() {
                    for(var t1 = this, e1 = arguments.length, r = new Array(e1), n = 0; n < e1; n++)r[n] = arguments[n];
                    if (r.length) {
                        1 === r.length && Array.isArray(r[0]) && (r = r[0]);
                        var i = this.groups, a = this.gl, o = this.regl, s = this.maxSize, c = this.maxColors, h = this.palette;
                        this.groups = i = r.map(function(e1, r) {
                            var n = i[r];
                            if (void 0 === e1) return n;
                            null === e1 ? e1 = {
                                positions: null
                            } : "function" == typeof e1 ? e1 = {
                                ondraw: e1
                            } : "number" == typeof e1[0] && (e1 = {
                                positions: e1
                            }), null === (e1 = p(e1, {
                                positions: "positions data points",
                                snap: "snap cluster lod tree",
                                size: "sizes size radius",
                                borderSize: "borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline",
                                color: "colors color fill fill-color fillColor",
                                borderColor: "borderColors borderColor stroke stroke-color strokeColor",
                                marker: "markers marker shape",
                                range: "range dataBox databox",
                                viewport: "viewport viewPort viewBox viewbox",
                                opacity: "opacity alpha transparency",
                                bounds: "bound bounds boundaries limits",
                                tooManyColors: "tooManyColors palette paletteMode optimizePalette enablePalette"
                            })).positions && (e1.positions = []), null != e1.tooManyColors && (t1.tooManyColors = e1.tooManyColors), n || (i[r] = n = {
                                id: r,
                                scale: null,
                                translate: null,
                                scaleFract: null,
                                translateFract: null,
                                activation: [],
                                selectionBuffer: o.buffer({
                                    data: new Uint8Array(0),
                                    usage: "stream",
                                    type: "uint8"
                                }),
                                sizeBuffer: o.buffer({
                                    data: new Uint8Array(0),
                                    usage: "dynamic",
                                    type: "uint8"
                                }),
                                colorBuffer: o.buffer({
                                    data: new Uint8Array(0),
                                    usage: "dynamic",
                                    type: "uint8"
                                }),
                                positionBuffer: o.buffer({
                                    data: new Uint8Array(0),
                                    usage: "dynamic",
                                    type: "float"
                                }),
                                positionFractBuffer: o.buffer({
                                    data: new Uint8Array(0),
                                    usage: "dynamic",
                                    type: "float"
                                })
                            }, e1 = f({}, b.defaults, e1)), e1.positions && !("marker" in e1) && (e1.marker = n.marker, delete n.marker), e1.marker && !("positions" in e1) && (e1.positions = n.positions, delete n.positions);
                            var g = 0, x = 0;
                            if (d(n, e1, [
                                {
                                    snap: !0,
                                    size: function(t1, e1) {
                                        return null == t1 && (t1 = b.defaults.size), g += t1 && t1.length ? 1 : 0, t1;
                                    },
                                    borderSize: function(t1, e1) {
                                        return null == t1 && (t1 = b.defaults.borderSize), g += t1 && t1.length ? 1 : 0, t1;
                                    },
                                    opacity: parseFloat,
                                    color: function(e1, r) {
                                        return null == e1 && (e1 = b.defaults.color), e1 = t1.updateColor(e1), x++, e1;
                                    },
                                    borderColor: function(e1, r) {
                                        return null == e1 && (e1 = b.defaults.borderColor), e1 = t1.updateColor(e1), x++, e1;
                                    },
                                    bounds: function(t1, e1, r) {
                                        return "range" in r || (r.range = null), t1;
                                    },
                                    positions: function(t1, e1, r) {
                                        var n = e1.snap, i = e1.positionBuffer, a = e1.positionFractBuffer, s = e1.selectionBuffer;
                                        if (t1.x || t1.y) return t1.x.length ? e1.xAttr = {
                                            buffer: o.buffer(t1.x),
                                            offset: 0,
                                            stride: 4,
                                            count: t1.x.length
                                        } : e1.xAttr = {
                                            buffer: t1.x.buffer,
                                            offset: 4 * t1.x.offset || 0,
                                            stride: 4 * (t1.x.stride || 1),
                                            count: t1.x.count
                                        }, t1.y.length ? e1.yAttr = {
                                            buffer: o.buffer(t1.y),
                                            offset: 0,
                                            stride: 4,
                                            count: t1.y.length
                                        } : e1.yAttr = {
                                            buffer: t1.y.buffer,
                                            offset: 4 * t1.y.offset || 0,
                                            stride: 4 * (t1.y.stride || 1),
                                            count: t1.y.count
                                        }, e1.count = Math.max(e1.xAttr.count, e1.yAttr.count), t1;
                                        t1 = m(t1, "float64");
                                        var c = e1.count = Math.floor(t1.length / 2), f = e1.bounds = c ? l(t1, 2) : null;
                                        if (r.range || e1.range || (delete e1.range, r.range = f), r.marker || e1.marker || (delete e1.marker, r.marker = null), n && (!0 === n || c > n) ? e1.tree = u(t1, {
                                            bounds: f
                                        }) : n && n.length && (e1.tree = n), e1.tree) {
                                            var h = {
                                                primitive: "points",
                                                usage: "static",
                                                data: e1.tree,
                                                type: "uint32"
                                            };
                                            e1.elements ? e1.elements(h) : e1.elements = o.elements(h);
                                        }
                                        var p = v.float32(t1);
                                        return i({
                                            data: p,
                                            usage: "dynamic"
                                        }), a({
                                            data: v.fract32(t1, p),
                                            usage: "dynamic"
                                        }), s({
                                            data: new Uint8Array(c),
                                            type: "uint8",
                                            usage: "stream"
                                        }), t1;
                                    }
                                },
                                {
                                    marker: function(e1, r, n) {
                                        var i = r.activation;
                                        if (i.forEach(function(t1) {
                                            return t1 && t1.destroy && t1.destroy();
                                        }), i.length = 0, e1 && "number" != typeof e1[0]) {
                                            for(var a = [], s = 0, l = Math.min(e1.length, r.count); s < l; s++){
                                                var c = t1.addMarker(e1[s]);
                                                a[c] || (a[c] = new Uint8Array(r.count)), a[c][s] = 1;
                                            }
                                            for(var u = 0; u < a.length; u++)if (a[u]) {
                                                var f = {
                                                    data: a[u],
                                                    type: "uint8",
                                                    usage: "static"
                                                };
                                                i[u] ? i[u](f) : i[u] = o.buffer(f), i[u].data = a[u];
                                            }
                                        } else i[t1.addMarker(e1)] = !0;
                                        return e1;
                                    },
                                    range: function(t1, e1, r) {
                                        var n = e1.bounds;
                                        if (n) return t1 || (t1 = n), e1.scale = [
                                            1 / (t1[2] - t1[0]),
                                            1 / (t1[3] - t1[1])
                                        ], e1.translate = [
                                            -t1[0],
                                            -t1[1]
                                        ], e1.scaleFract = v.fract(e1.scale), e1.translateFract = v.fract(e1.translate), t1;
                                    },
                                    viewport: function(t1) {
                                        return y(t1 || [
                                            a.drawingBufferWidth,
                                            a.drawingBufferHeight
                                        ]);
                                    }
                                }
                            ]), g) {
                                var _ = n, w = _.count, T = _.size, k = _.borderSize, A = _.sizeBuffer, M = new Uint8Array(2 * w);
                                if (T.length || k.length) for(var S = 0; S < w; S++)M[2 * S] = Math.round(255 * (null == T[S] ? T : T[S]) / s), M[2 * S + 1] = Math.round(255 * (null == k[S] ? k : k[S]) / s);
                                A({
                                    data: M,
                                    usage: "dynamic"
                                });
                            }
                            if (x) {
                                var E, L = n, C = L.count, P = L.color, I = L.borderColor, O = L.colorBuffer;
                                if (t1.tooManyColors) {
                                    if (P.length || I.length) {
                                        E = new Uint8Array(8 * C);
                                        for(var z = 0; z < C; z++){
                                            var D = P[z];
                                            E[8 * z] = h[4 * D], E[8 * z + 1] = h[4 * D + 1], E[8 * z + 2] = h[4 * D + 2], E[8 * z + 3] = h[4 * D + 3];
                                            var R = I[z];
                                            E[8 * z + 4] = h[4 * R], E[8 * z + 5] = h[4 * R + 1], E[8 * z + 6] = h[4 * R + 2], E[8 * z + 7] = h[4 * R + 3];
                                        }
                                    }
                                } else if (P.length || I.length) {
                                    E = new Uint8Array(4 * C + 2);
                                    for(var F = 0; F < C; F++)null != P[F] && (E[4 * F] = P[F] % c, E[4 * F + 1] = Math.floor(P[F] / c)), null != I[F] && (E[4 * F + 2] = I[F] % c, E[4 * F + 3] = Math.floor(I[F] / c));
                                }
                                O({
                                    data: E || new Uint8Array(0),
                                    type: "uint8",
                                    usage: "dynamic"
                                });
                            }
                            return n;
                        });
                    }
                }, b.prototype.addMarker = function(t1) {
                    var e1, r = this.markerTextures, n = this.regl, i = this.markerCache, a = null == t1 ? 0 : i.indexOf(t1);
                    if (a >= 0) return a;
                    if (t1 instanceof Uint8Array || t1 instanceof Uint8ClampedArray) e1 = t1;
                    else {
                        e1 = new Uint8Array(t1.length);
                        for(var o = 0, s = t1.length; o < s; o++)e1[o] = 255 * t1[o];
                    }
                    var l = Math.floor(Math.sqrt(e1.length));
                    return a = r.length, i.push(t1), r.push(n.texture({
                        channels: 1,
                        data: e1,
                        radius: l,
                        mag: "linear",
                        min: "linear"
                    })), a;
                }, b.prototype.updateColor = function(t1) {
                    var e1 = this.paletteIds, r = this.palette, n = this.maxColors;
                    Array.isArray(t1) || (t1 = [
                        t1
                    ]);
                    var i = [];
                    if ("number" == typeof t1[0]) {
                        var a = [];
                        if (Array.isArray(t1)) for(var o = 0; o < t1.length; o += 4)a.push(t1.slice(o, o + 4));
                        else for(var l = 0; l < t1.length; l += 4)a.push(t1.subarray(l, l + 4));
                        t1 = a;
                    }
                    for(var u = 0; u < t1.length; u++){
                        var f = t1[u];
                        f = s(f, "uint8");
                        var h = c(f, !1);
                        if (null == e1[h]) {
                            var p = r.length;
                            e1[h] = Math.floor(p / 4), r[p] = f[0], r[p + 1] = f[1], r[p + 2] = f[2], r[p + 3] = f[3];
                        }
                        i[u] = e1[h];
                    }
                    return !this.tooManyColors && r.length > 4 * n && (this.tooManyColors = !0), this.updatePalette(r), 1 === i.length ? i[0] : i;
                }, b.prototype.updatePalette = function(t1) {
                    if (!this.tooManyColors) {
                        var e1 = this.maxColors, r = this.paletteTexture, n = Math.ceil(.25 * t1.length / e1);
                        if (n > 1) for(var i = .25 * (t1 = t1.slice()).length % e1; i < n * e1; i++)t1.push(0, 0, 0, 0);
                        r.height < n && r.resize(e1, n), r.subimage({
                            width: Math.min(.25 * t1.length, e1),
                            height: n,
                            data: t1
                        }, 0, 0);
                    }
                }, b.prototype.destroy = function() {
                    return this.groups.forEach(function(t1) {
                        t1.sizeBuffer.destroy(), t1.positionBuffer.destroy(), t1.positionFractBuffer.destroy(), t1.colorBuffer.destroy(), t1.activation.forEach(function(t1) {
                            return t1 && t1.destroy && t1.destroy();
                        }), t1.selectionBuffer.destroy(), t1.elements && t1.elements.destroy();
                    }), this.groups.length = 0, this.paletteTexture.destroy(), this.markerTextures.forEach(function(t1) {
                        return t1 && t1.destroy && t1.destroy();
                    }), this;
                };
                var _ = t1("object-assign");
                e1.exports = function(t1, e1) {
                    var r = new x(t1, e1), n = r.render.bind(r);
                    return _(n, {
                        render: n,
                        update: r.update.bind(r),
                        draw: r.draw.bind(r),
                        destroy: r.destroy.bind(r),
                        regl: r.regl,
                        gl: r.gl,
                        canvas: r.gl.canvas,
                        groups: r.groups,
                        markers: r.markerCache,
                        palette: r.palette
                    }), n;
                };
            },
            {
                "@plotly/point-cluster": 59,
                "array-bounds": 71,
                "color-id": 87,
                "color-normalize": 89,
                "flatten-vertex-data": 191,
                glslify: 227,
                "is-iexplorer": 233,
                "object-assign": 247,
                "parse-rect": 249,
                "pick-by-alias": 253,
                "to-float32": 313,
                "update-diff": 329
            }
        ],
        282: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("regl-scatter2d"), i = t1("pick-by-alias"), a = t1("array-bounds"), o = t1("raf"), s = t1("array-range"), l = t1("parse-rect"), c = t1("flatten-vertex-data");
                function u(t1, e1) {
                    if (!(this instanceof u)) return new u(t1, e1);
                    this.traces = [], this.passes = {}, this.regl = t1, this.scatter = n(t1), this.canvas = this.scatter.canvas;
                }
                function f(t1, e1, r) {
                    return (null != t1.id ? t1.id : t1) << 16 | (255 & e1) << 8 | 255 & r;
                }
                function h(t1, e1, r) {
                    var n, i, a, o, s = t1[e1], l = t1[r];
                    return s.length > 2 ? (s[0], s[2], n = s[1], i = s[3]) : s.length ? (n = s[0], i = s[1]) : (s.x, n = s.y, s.x, s.width, i = s.y + s.height), l.length > 2 ? (a = l[0], o = l[2], l[1], l[3]) : l.length ? (a = l[0], o = l[1]) : (a = l.x, l.y, o = l.x + l.width, l.y, l.height), [
                        a,
                        n,
                        o,
                        i
                    ];
                }
                function p(t1) {
                    if ("number" == typeof t1) return [
                        t1,
                        t1,
                        t1,
                        t1
                    ];
                    if (2 === t1.length) return [
                        t1[0],
                        t1[1],
                        t1[0],
                        t1[1]
                    ];
                    var e1 = l(t1);
                    return [
                        e1.x,
                        e1.y,
                        e1.x + e1.width,
                        e1.y + e1.height
                    ];
                }
                e1.exports = u, u.prototype.render = function() {
                    for(var t1, e1 = this, r = [], n = arguments.length; n--;)r[n] = arguments[n];
                    return r.length && (t1 = this).update.apply(t1, r), this.regl.attributes.preserveDrawingBuffer ? this.draw() : (this.dirty ? null == this.planned && (this.planned = o(function() {
                        e1.draw(), e1.dirty = !0, e1.planned = null;
                    })) : (this.draw(), this.dirty = !0, o(function() {
                        e1.dirty = !1;
                    })), this);
                }, u.prototype.update = function() {
                    for(var t1, e1 = [], r = arguments.length; r--;)e1[r] = arguments[r];
                    if (e1.length) {
                        for(var n = 0; n < e1.length; n++)this.updateItem(n, e1[n]);
                        this.traces = this.traces.filter(Boolean);
                        for(var i = [], a = 0, o = 0; o < this.traces.length; o++){
                            for(var s = this.traces[o], l = this.traces[o].passes, c = 0; c < l.length; c++)i.push(this.passes[l[c]]);
                            s.passOffset = a, a += s.passes.length;
                        }
                        return (t1 = this.scatter).update.apply(t1, i), this;
                    }
                }, u.prototype.updateItem = function(t1, e1) {
                    var r = this.regl;
                    if (null === e1) return this.traces[t1] = null, this;
                    if (!e1) return this;
                    var n, o = i(e1, {
                        data: "data items columns rows values dimensions samples x",
                        snap: "snap cluster",
                        size: "sizes size radius",
                        color: "colors color fill fill-color fillColor",
                        opacity: "opacity alpha transparency opaque",
                        borderSize: "borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline",
                        borderColor: "borderColors borderColor bordercolor stroke stroke-color strokeColor",
                        marker: "markers marker shape",
                        range: "range ranges databox dataBox",
                        viewport: "viewport viewBox viewbox",
                        domain: "domain domains area areas",
                        padding: "pad padding paddings pads margin margins",
                        transpose: "transpose transposed",
                        diagonal: "diagonal diag showDiagonal",
                        upper: "upper up top upperhalf upperHalf showupperhalf showUpper showUpperHalf",
                        lower: "lower low bottom lowerhalf lowerHalf showlowerhalf showLowerHalf showLower"
                    }), s = this.traces[t1] || (this.traces[t1] = {
                        id: t1,
                        buffer: r.buffer({
                            usage: "dynamic",
                            type: "float",
                            data: new Uint8Array
                        }),
                        color: "black",
                        marker: null,
                        size: 12,
                        borderColor: "transparent",
                        borderSize: 1,
                        viewport: l([
                            r._gl.drawingBufferWidth,
                            r._gl.drawingBufferHeight
                        ]),
                        padding: [
                            0,
                            0,
                            0,
                            0
                        ],
                        opacity: 1,
                        diagonal: !0,
                        upper: !0,
                        lower: !0
                    });
                    if (null != o.color && (s.color = o.color), null != o.size && (s.size = o.size), null != o.marker && (s.marker = o.marker), null != o.borderColor && (s.borderColor = o.borderColor), null != o.borderSize && (s.borderSize = o.borderSize), null != o.opacity && (s.opacity = o.opacity), o.viewport && (s.viewport = l(o.viewport)), null != o.diagonal && (s.diagonal = o.diagonal), null != o.upper && (s.upper = o.upper), null != o.lower && (s.lower = o.lower), o.data) {
                        s.buffer(c(o.data)), s.columns = o.data.length, s.count = o.data[0].length, s.bounds = [];
                        for(var u = 0; u < s.columns; u++)s.bounds[u] = a(o.data[u], 1);
                    }
                    o.range && (s.range = o.range, n = s.range && "number" != typeof s.range[0]), o.domain && (s.domain = o.domain);
                    var d = !1;
                    null != o.padding && (Array.isArray(o.padding) && o.padding.length === s.columns && "number" == typeof o.padding[o.padding.length - 1] ? (s.padding = o.padding.map(p), d = !0) : s.padding = p(o.padding));
                    var m = s.columns, g = s.count, v = s.viewport.width, y = s.viewport.height, x = s.viewport.x, b = s.viewport.y, _ = v / m, w = y / m;
                    s.passes = [];
                    for(var T = 0; T < m; T++)for(var k = 0; k < m; k++)if ((s.diagonal || k !== T) && (s.upper || !(T > k)) && (s.lower || !(T < k))) {
                        var A = f(s.id, T, k), M = this.passes[A] || (this.passes[A] = {});
                        if (o.data && (o.transpose ? M.positions = {
                            x: {
                                buffer: s.buffer,
                                offset: k,
                                count: g,
                                stride: m
                            },
                            y: {
                                buffer: s.buffer,
                                offset: T,
                                count: g,
                                stride: m
                            }
                        } : M.positions = {
                            x: {
                                buffer: s.buffer,
                                offset: k * g,
                                count: g
                            },
                            y: {
                                buffer: s.buffer,
                                offset: T * g,
                                count: g
                            }
                        }, M.bounds = h(s.bounds, T, k)), o.domain || o.viewport || o.data) {
                            var S = d ? h(s.padding, T, k) : s.padding;
                            if (s.domain) {
                                var E = h(s.domain, T, k), L = E[0], C = E[1], P = E[2], I = E[3];
                                M.viewport = [
                                    x + L * v + S[0],
                                    b + C * y + S[1],
                                    x + P * v - S[2],
                                    b + I * y - S[3]
                                ];
                            } else M.viewport = [
                                x + k * _ + _ * S[0],
                                b + T * w + w * S[1],
                                x + (k + 1) * _ - _ * S[2],
                                b + (T + 1) * w - w * S[3]
                            ];
                        }
                        o.color && (M.color = s.color), o.size && (M.size = s.size), o.marker && (M.marker = s.marker), o.borderSize && (M.borderSize = s.borderSize), o.borderColor && (M.borderColor = s.borderColor), o.opacity && (M.opacity = s.opacity), o.range && (M.range = n ? h(s.range, T, k) : s.range || M.bounds), s.passes.push(A);
                    }
                    return this;
                }, u.prototype.draw = function() {
                    for(var t1, e1 = [], r = arguments.length; r--;)e1[r] = arguments[r];
                    if (e1.length) {
                        for(var n = [], i = 0; i < e1.length; i++)if ("number" == typeof e1[i]) {
                            var a = this.traces[e1[i]], o = a.passes, l = a.passOffset;
                            n.push.apply(n, s(l, l + o.length));
                        } else if (e1[i].length) {
                            var c = e1[i], u = this.traces[i], f = u.passes, h = u.passOffset;
                            f = f.map(function(t1, e1) {
                                n[h + e1] = c;
                            });
                        }
                        (t1 = this.scatter).draw.apply(t1, n);
                    } else this.scatter.draw();
                    return this;
                }, u.prototype.destroy = function() {
                    return this.traces.forEach(function(t1) {
                        t1.buffer && t1.buffer.destroy && t1.buffer.destroy();
                    }), this.traces = null, this.passes = null, this.scatter.destroy(), this;
                };
            },
            {
                "array-bounds": 71,
                "array-range": 74,
                "flatten-vertex-data": 191,
                "parse-rect": 249,
                "pick-by-alias": 253,
                raf: 278,
                "regl-scatter2d": 281
            }
        ],
        283: [
            function(t1, e1, r) {
                !function(t1, n) {
                    "object" == typeof r && void 0 !== e1 ? e1.exports = n() : t1.createREGL = n();
                }(this, function() {
                    function t1(t1, e1) {
                        this.id = U++, this.type = t1, this.data = e1;
                    }
                    function e1(t1) {
                        return "[" + (function t1(e1) {
                            if (0 === e1.length) return [];
                            var r = e1.charAt(0), n = e1.charAt(e1.length - 1);
                            if (1 < e1.length && r === n && ('"' === r || "'" === r)) return [
                                '"' + e1.substr(1, e1.length - 2).replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"'
                            ];
                            if (r = /\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(e1)) return t1(e1.substr(0, r.index)).concat(t1(r[1])).concat(t1(e1.substr(r.index + r[0].length)));
                            if (1 === (r = e1.split(".")).length) return [
                                '"' + e1.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"'
                            ];
                            for(e1 = [], n = 0; n < r.length; ++n)e1 = e1.concat(t1(r[n]));
                            return e1;
                        })(t1).join("][") + "]";
                    }
                    function r(t1) {
                        return "string" == typeof t1 ? t1.split() : t1;
                    }
                    function n(t1) {
                        return "string" == typeof t1 ? document.querySelector(t1) : t1;
                    }
                    function i(t1) {
                        var e1, i, a, o, s = t1 || {};
                        t1 = {};
                        var l = [], c = [], u = "undefined" == typeof window ? 1 : window.devicePixelRatio, f = !1, h = function(t1) {}, p = function() {};
                        if ("string" == typeof s ? e1 = document.querySelector(s) : "object" == typeof s && ("string" == typeof s.nodeName && "function" == typeof s.appendChild && "function" == typeof s.getBoundingClientRect ? e1 = s : "function" == typeof s.drawArrays || "function" == typeof s.drawElements ? a = (o = s).canvas : ("gl" in s ? o = s.gl : "canvas" in s ? a = n(s.canvas) : "container" in s && (i = n(s.container)), "attributes" in s && (t1 = s.attributes), "extensions" in s && (l = r(s.extensions)), "optionalExtensions" in s && (c = r(s.optionalExtensions)), "onDone" in s && (h = s.onDone), "profile" in s && (f = !!s.profile), "pixelRatio" in s && (u = +s.pixelRatio))), e1 && ("canvas" === e1.nodeName.toLowerCase() ? a = e1 : i = e1), !o) {
                            if (!a) {
                                if (!(e1 = function(t1, e1, r) {
                                    function n() {
                                        var e1 = window.innerWidth, n = window.innerHeight;
                                        t1 !== document.body && (e1 = (n = a.getBoundingClientRect()).right - n.left, n = n.bottom - n.top), a.width = r * e1, a.height = r * n;
                                    }
                                    var i, a = document.createElement("canvas");
                                    return j(a.style, {
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%"
                                    }), t1.appendChild(a), t1 === document.body && (a.style.position = "absolute", j(t1.style, {
                                        margin: 0,
                                        padding: 0
                                    })), t1 !== document.body && "function" == typeof ResizeObserver ? (i = new ResizeObserver(function() {
                                        setTimeout(n);
                                    })).observe(t1) : window.addEventListener("resize", n, !1), n(), {
                                        canvas: a,
                                        onDestroy: function() {
                                            i ? i.disconnect() : window.removeEventListener("resize", n), t1.removeChild(a);
                                        }
                                    };
                                }(i || document.body, 0, u))) return null;
                                a = e1.canvas, p = e1.onDestroy;
                            }
                            void 0 === t1.premultipliedAlpha && (t1.premultipliedAlpha = !0), o = function(t1, e1) {
                                function r(r) {
                                    try {
                                        return t1.getContext(r, e1);
                                    } catch (t1) {
                                        return null;
                                    }
                                }
                                return r("webgl") || r("experimental-webgl") || r("webgl-experimental");
                            }(a, t1);
                        }
                        return o ? {
                            gl: o,
                            canvas: a,
                            container: i,
                            extensions: l,
                            optionalExtensions: c,
                            pixelRatio: u,
                            profile: f,
                            onDone: h,
                            onDestroy: p
                        } : (p(), h("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org"), null);
                    }
                    function a(t1, e1) {
                        for(var r = Array(t1), n = 0; n < t1; ++n)r[n] = e1(n);
                        return r;
                    }
                    function o(t1) {
                        var e1, r;
                        return e1 = (65535 < t1) << 4, e1 |= r = (255 < (t1 >>>= e1)) << 3, (e1 |= r = (15 < (t1 >>>= r)) << 2) | (r = (3 < (t1 >>>= r)) << 1) | t1 >>> r >> 1;
                    }
                    function s() {
                        function t1(t1) {
                            t: {
                                for(var e1 = 16; 268435456 >= e1; e1 *= 16)if (t1 <= e1) {
                                    t1 = e1;
                                    break t;
                                }
                                t1 = 0;
                            }
                            return 0 < (e1 = r[o(t1) >> 2]).length ? e1.pop() : new ArrayBuffer(t1);
                        }
                        function e1(t1) {
                            r[o(t1.byteLength) >> 2].push(t1);
                        }
                        var r = a(8, function() {
                            return [];
                        });
                        return {
                            alloc: t1,
                            free: e1,
                            allocType: function(e1, r) {
                                var n = null;
                                switch(e1){
                                    case 5120:
                                        n = new Int8Array(t1(r), 0, r);
                                        break;
                                    case 5121:
                                        n = new Uint8Array(t1(r), 0, r);
                                        break;
                                    case 5122:
                                        n = new Int16Array(t1(2 * r), 0, r);
                                        break;
                                    case 5123:
                                        n = new Uint16Array(t1(2 * r), 0, r);
                                        break;
                                    case 5124:
                                        n = new Int32Array(t1(4 * r), 0, r);
                                        break;
                                    case 5125:
                                        n = new Uint32Array(t1(4 * r), 0, r);
                                        break;
                                    case 5126:
                                        n = new Float32Array(t1(4 * r), 0, r);
                                        break;
                                    default:
                                        return null;
                                }
                                return n.length !== r ? n.subarray(0, r) : n;
                            },
                            freeType: function(t1) {
                                e1(t1.buffer);
                            }
                        };
                    }
                    function l(t1) {
                        return !!t1 && "object" == typeof t1 && Array.isArray(t1.shape) && Array.isArray(t1.stride) && "number" == typeof t1.offset && t1.shape.length === t1.stride.length && (Array.isArray(t1.data) || W(t1.data));
                    }
                    function c(t1, e1, r, n, i, a) {
                        for(var o = 0; o < e1; ++o)for(var s = t1[o], l = 0; l < r; ++l)for(var c = s[l], u = 0; u < n; ++u)i[a++] = c[u];
                    }
                    function u(t1) {
                        return 0 | J[Object.prototype.toString.call(t1)];
                    }
                    function f(t1, e1) {
                        for(var r = 0; r < e1.length; ++r)t1[r] = e1[r];
                    }
                    function h(t1, e1, r, n, i, a, o) {
                        for(var s = 0, l = 0; l < r; ++l)for(var c = 0; c < n; ++c)t1[s++] = e1[i * l + a * c + o];
                    }
                    function p(t1, e1, r, n) {
                        function i(e1) {
                            this.id = c++, this.buffer = t1.createBuffer(), this.type = e1, this.usage = 35044, this.byteLength = 0, this.dimension = 1, this.dtype = 5121, this.persistentData = null, r.profile && (this.stats = {
                                size: 0
                            });
                        }
                        function a(e1, r, n) {
                            e1.byteLength = r.byteLength, t1.bufferData(e1.type, r, n);
                        }
                        function o(t1, e1, r, n, i, o) {
                            if (t1.usage = r, Array.isArray(e1)) {
                                if (t1.dtype = n || 5126, 0 < e1.length) {
                                    if (Array.isArray(e1[0])) {
                                        i = tt(e1);
                                        for(var s = n = 1; s < i.length; ++s)n *= i[s];
                                        t1.dimension = n, a(t1, e1 = $(e1, i, t1.dtype), r), o ? t1.persistentData = e1 : G.freeType(e1);
                                    } else "number" == typeof e1[0] ? (t1.dimension = i, f(i = G.allocType(t1.dtype, e1.length), e1), a(t1, i, r), o ? t1.persistentData = i : G.freeType(i)) : W(e1[0]) && (t1.dimension = e1[0].length, t1.dtype = n || u(e1[0]) || 5126, a(t1, e1 = $(e1, [
                                        e1.length,
                                        e1[0].length
                                    ], t1.dtype), r), o ? t1.persistentData = e1 : G.freeType(e1));
                                }
                            } else if (W(e1)) t1.dtype = n || u(e1), t1.dimension = i, a(t1, e1, r), o && (t1.persistentData = new Uint8Array(new Uint8Array(e1.buffer)));
                            else if (l(e1)) {
                                i = e1.shape;
                                var c = e1.stride, p = (s = e1.offset, 0), d = 0, m = 0, g = 0;
                                1 === i.length ? (p = i[0], d = 1, m = c[0], g = 0) : 2 === i.length && (p = i[0], d = i[1], m = c[0], g = c[1]), t1.dtype = n || u(e1.data) || 5126, t1.dimension = d, h(i = G.allocType(t1.dtype, p * d), e1.data, p, d, m, g, s), a(t1, i, r), o ? t1.persistentData = i : G.freeType(i);
                            } else e1 instanceof ArrayBuffer && (t1.dtype = 5121, t1.dimension = i, a(t1, e1, r), o && (t1.persistentData = new Uint8Array(new Uint8Array(e1))));
                        }
                        function s(r) {
                            e1.bufferCount--, n(r), t1.deleteBuffer(r.buffer), r.buffer = null, delete p[r.id];
                        }
                        var c = 0, p = {};
                        i.prototype.bind = function() {
                            t1.bindBuffer(this.type, this.buffer);
                        }, i.prototype.destroy = function() {
                            s(this);
                        };
                        var d = [];
                        return r.profile && (e1.getTotalBufferSize = function() {
                            var t1 = 0;
                            return Object.keys(p).forEach(function(e1) {
                                t1 += p[e1].stats.size;
                            }), t1;
                        }), {
                            create: function(n, a, c, d) {
                                function m(e1) {
                                    var n = 35044, i = null, a = 0, s = 0, c = 1;
                                    return Array.isArray(e1) || W(e1) || l(e1) || e1 instanceof ArrayBuffer ? i = e1 : "number" == typeof e1 ? a = 0 | e1 : e1 && ("data" in e1 && (i = e1.data), "usage" in e1 && (n = Q[e1.usage]), "type" in e1 && (s = K[e1.type]), "dimension" in e1 && (c = 0 | e1.dimension), "length" in e1 && (a = 0 | e1.length)), g.bind(), i ? o(g, i, n, s, c, d) : (a && t1.bufferData(g.type, a, n), g.dtype = s || 5121, g.usage = n, g.dimension = c, g.byteLength = a), r.profile && (g.stats.size = g.byteLength * et[g.dtype]), m;
                                }
                                e1.bufferCount++;
                                var g = new i(a);
                                return p[g.id] = g, c || m(n), m._reglType = "buffer", m._buffer = g, m.subdata = function(e1, r) {
                                    var n, i = 0 | (r || 0);
                                    if (g.bind(), W(e1) || e1 instanceof ArrayBuffer) t1.bufferSubData(g.type, i, e1);
                                    else if (Array.isArray(e1)) {
                                        if (0 < e1.length) {
                                            if ("number" == typeof e1[0]) {
                                                var a = G.allocType(g.dtype, e1.length);
                                                f(a, e1), t1.bufferSubData(g.type, i, a), G.freeType(a);
                                            } else (Array.isArray(e1[0]) || W(e1[0])) && (n = tt(e1), a = $(e1, n, g.dtype), t1.bufferSubData(g.type, i, a), G.freeType(a));
                                        }
                                    } else if (l(e1)) {
                                        n = e1.shape;
                                        var o = e1.stride, s = a = 0, c = 0, p = 0;
                                        1 === n.length ? (a = n[0], s = 1, c = o[0], p = 0) : 2 === n.length && (a = n[0], s = n[1], c = o[0], p = o[1]), n = Array.isArray(e1.data) ? g.dtype : u(e1.data), h(n = G.allocType(n, a * s), e1.data, a, s, c, p, e1.offset), t1.bufferSubData(g.type, i, n), G.freeType(n);
                                    }
                                    return m;
                                }, r.profile && (m.stats = g.stats), m.destroy = function() {
                                    s(g);
                                }, m;
                            },
                            createStream: function(t1, e1) {
                                var r = d.pop();
                                return r || (r = new i(t1)), r.bind(), o(r, e1, 35040, 0, 1, !1), r;
                            },
                            destroyStream: function(t1) {
                                d.push(t1);
                            },
                            clear: function() {
                                X(p).forEach(s), d.forEach(s);
                            },
                            getBuffer: function(t1) {
                                return t1 && t1._buffer instanceof i ? t1._buffer : null;
                            },
                            restore: function() {
                                X(p).forEach(function(e1) {
                                    e1.buffer = t1.createBuffer(), t1.bindBuffer(e1.type, e1.buffer), t1.bufferData(e1.type, e1.persistentData || e1.byteLength, e1.usage);
                                });
                            },
                            _initBuffer: o
                        };
                    }
                    function d(t1, e1, r, n) {
                        function i(t1) {
                            this.id = c++, s[this.id] = this, this.buffer = t1, this.primType = 4, this.type = this.vertCount = 0;
                        }
                        function a(n, i, a, o, s, c, u) {
                            var f;
                            if (n.buffer.bind(), i ? ((f = u) || W(i) && (!l(i) || W(i.data)) || (f = e1.oes_element_index_uint ? 5125 : 5123), r._initBuffer(n.buffer, i, a, f, 3)) : (t1.bufferData(34963, c, a), n.buffer.dtype = f || 5121, n.buffer.usage = a, n.buffer.dimension = 3, n.buffer.byteLength = c), f = u, !u) {
                                switch(n.buffer.dtype){
                                    case 5121:
                                    case 5120:
                                        f = 5121;
                                        break;
                                    case 5123:
                                    case 5122:
                                        f = 5123;
                                        break;
                                    case 5125:
                                    case 5124:
                                        f = 5125;
                                }
                                n.buffer.dtype = f;
                            }
                            n.type = f, 0 > (i = s) && (i = n.buffer.byteLength, 5123 === f ? i >>= 1 : 5125 === f && (i >>= 2)), n.vertCount = i, i = o, 0 > o && (i = 4, 1 === (o = n.buffer.dimension) && (i = 0), 2 === o && (i = 1), 3 === o && (i = 4)), n.primType = i;
                        }
                        function o(t1) {
                            n.elementsCount--, delete s[t1.id], t1.buffer.destroy(), t1.buffer = null;
                        }
                        var s = {}, c = 0, u = {
                            uint8: 5121,
                            uint16: 5123
                        };
                        e1.oes_element_index_uint && (u.uint32 = 5125), i.prototype.bind = function() {
                            this.buffer.bind();
                        };
                        var f = [];
                        return {
                            create: function(t1, e1) {
                                function s(t1) {
                                    if (t1) {
                                        if ("number" == typeof t1) c(t1), f.primType = 4, f.vertCount = 0 | t1, f.type = 5121;
                                        else {
                                            var e1 = null, r = 35044, n = -1, i = -1, o = 0, h = 0;
                                            Array.isArray(t1) || W(t1) || l(t1) ? e1 = t1 : ("data" in t1 && (e1 = t1.data), "usage" in t1 && (r = Q[t1.usage]), "primitive" in t1 && (n = rt[t1.primitive]), "count" in t1 && (i = 0 | t1.count), "type" in t1 && (h = u[t1.type]), "length" in t1 ? o = 0 | t1.length : (o = i, 5123 === h || 5122 === h ? o *= 2 : 5125 !== h && 5124 !== h || (o *= 4))), a(f, e1, r, n, i, o, h);
                                        }
                                    } else c(), f.primType = 4, f.vertCount = 0, f.type = 5121;
                                    return s;
                                }
                                var c = r.create(null, 34963, !0), f = new i(c._buffer);
                                return n.elementsCount++, s(t1), s._reglType = "elements", s._elements = f, s.subdata = function(t1, e1) {
                                    return c.subdata(t1, e1), s;
                                }, s.destroy = function() {
                                    o(f);
                                }, s;
                            },
                            createStream: function(t1) {
                                var e1 = f.pop();
                                return e1 || (e1 = new i(r.create(null, 34963, !0, !1)._buffer)), a(e1, t1, 35040, -1, -1, 0, 0), e1;
                            },
                            destroyStream: function(t1) {
                                f.push(t1);
                            },
                            getElements: function(t1) {
                                return "function" == typeof t1 && t1._elements instanceof i ? t1._elements : null;
                            },
                            clear: function() {
                                X(s).forEach(o);
                            }
                        };
                    }
                    function m(t1) {
                        for(var e1 = G.allocType(5123, t1.length), r = 0; r < t1.length; ++r)if (isNaN(t1[r])) e1[r] = 65535;
                        else if (1 / 0 === t1[r]) e1[r] = 31744;
                        else if (-1 / 0 === t1[r]) e1[r] = 64512;
                        else {
                            nt[0] = t1[r];
                            var n = (a = it[0]) >>> 31 << 15, i = (a << 1 >>> 24) - 127, a = a >> 13 & 1023;
                            e1[r] = -24 > i ? n : -14 > i ? n + (a + 1024 >> -14 - i) : 15 < i ? n + 31744 : n + (i + 15 << 10) + a;
                        }
                        return e1;
                    }
                    function g(t1) {
                        return Array.isArray(t1) || W(t1);
                    }
                    function v(t1) {
                        return "[object " + t1 + "]";
                    }
                    function y(t1) {
                        return Array.isArray(t1) && (0 === t1.length || "number" == typeof t1[0]);
                    }
                    function x(t1) {
                        return !(!Array.isArray(t1) || 0 === t1.length || !g(t1[0]));
                    }
                    function b(t1) {
                        return Object.prototype.toString.call(t1);
                    }
                    function _(t1) {
                        if (!t1) return !1;
                        var e1 = b(t1);
                        return 0 <= dt.indexOf(e1) || y(t1) || x(t1) || l(t1);
                    }
                    function w(t1, e1) {
                        36193 === t1.type ? (t1.data = m(e1), G.freeType(e1)) : t1.data = e1;
                    }
                    function T(t1, e1, r, n, i, a) {
                        if (t1 = void 0 !== gt[t1] ? gt[t1] : st[t1] * mt[e1], a && (t1 *= 6), i) {
                            for(n = 0; 1 <= r;)n += t1 * r * r, r /= 2;
                            return n;
                        }
                        return t1 * r * n;
                    }
                    function k(t1, e1, r, n, i, a, o) {
                        function s() {
                            this.format = this.internalformat = 6408, this.type = 5121, this.flipY = this.premultiplyAlpha = this.compressed = !1, this.unpackAlignment = 1, this.colorSpace = 37444, this.channels = this.height = this.width = 0;
                        }
                        function c(t1, e1) {
                            t1.internalformat = e1.internalformat, t1.format = e1.format, t1.type = e1.type, t1.compressed = e1.compressed, t1.premultiplyAlpha = e1.premultiplyAlpha, t1.flipY = e1.flipY, t1.unpackAlignment = e1.unpackAlignment, t1.colorSpace = e1.colorSpace, t1.width = e1.width, t1.height = e1.height, t1.channels = e1.channels;
                        }
                        function u(t1, e1) {
                            if ("object" == typeof e1 && e1) {
                                "premultiplyAlpha" in e1 && (t1.premultiplyAlpha = e1.premultiplyAlpha), "flipY" in e1 && (t1.flipY = e1.flipY), "alignment" in e1 && (t1.unpackAlignment = e1.alignment), "colorSpace" in e1 && (t1.colorSpace = H[e1.colorSpace]), "type" in e1 && (t1.type = q[e1.type]);
                                var r = t1.width, n = t1.height, i = t1.channels, a = !1;
                                "shape" in e1 ? (r = e1.shape[0], n = e1.shape[1], 3 === e1.shape.length && (i = e1.shape[2], a = !0)) : ("radius" in e1 && (r = n = e1.radius), "width" in e1 && (r = e1.width), "height" in e1 && (n = e1.height), "channels" in e1 && (i = e1.channels, a = !0)), t1.width = 0 | r, t1.height = 0 | n, t1.channels = 0 | i, r = !1, "format" in e1 && (r = e1.format, n = t1.internalformat = Y[r], t1.format = dt[n], r in q && !("type" in e1) && (t1.type = q[r]), r in K && (t1.compressed = !0), r = !0), !a && r ? t1.channels = st[t1.format] : a && !r && t1.channels !== ot[t1.format] && (t1.format = t1.internalformat = ot[t1.channels]);
                            }
                        }
                        function f(e1) {
                            t1.pixelStorei(37440, e1.flipY), t1.pixelStorei(37441, e1.premultiplyAlpha), t1.pixelStorei(37443, e1.colorSpace), t1.pixelStorei(3317, e1.unpackAlignment);
                        }
                        function h() {
                            s.call(this), this.yOffset = this.xOffset = 0, this.data = null, this.needsFree = !1, this.element = null, this.needsCopy = !1;
                        }
                        function p(t1, e1) {
                            var r = null;
                            if (_(e1) ? r = e1 : e1 && (u(t1, e1), "x" in e1 && (t1.xOffset = 0 | e1.x), "y" in e1 && (t1.yOffset = 0 | e1.y), _(e1.data) && (r = e1.data)), e1.copy) {
                                var n = i.viewportWidth, a = i.viewportHeight;
                                t1.width = t1.width || n - t1.xOffset, t1.height = t1.height || a - t1.yOffset, t1.needsCopy = !0;
                            } else if (r) {
                                if (W(r)) t1.channels = t1.channels || 4, t1.data = r, "type" in e1 || 5121 !== t1.type || (t1.type = 0 | J[Object.prototype.toString.call(r)]);
                                else if (y(r)) {
                                    switch(t1.channels = t1.channels || 4, a = (n = r).length, t1.type){
                                        case 5121:
                                        case 5123:
                                        case 5125:
                                        case 5126:
                                            (a = G.allocType(t1.type, a)).set(n), t1.data = a;
                                            break;
                                        case 36193:
                                            t1.data = m(n);
                                    }
                                    t1.alignment = 1, t1.needsFree = !0;
                                } else if (l(r)) {
                                    n = r.data, Array.isArray(n) || 5121 !== t1.type || (t1.type = 0 | J[Object.prototype.toString.call(n)]);
                                    a = r.shape;
                                    var o, s, c, f, h = r.stride;
                                    3 === a.length ? (c = a[2], f = h[2]) : f = c = 1, o = a[0], s = a[1], a = h[0], h = h[1], t1.alignment = 1, t1.width = o, t1.height = s, t1.channels = c, t1.format = t1.internalformat = ot[c], t1.needsFree = !0, o = f, r = r.offset, c = t1.width, f = t1.height, s = t1.channels;
                                    for(var p = G.allocType(36193 === t1.type ? 5126 : t1.type, c * f * s), d = 0, v = 0; v < f; ++v)for(var T = 0; T < c; ++T)for(var k = 0; k < s; ++k)p[d++] = n[a * T + h * v + o * k + r];
                                    w(t1, p);
                                } else if (b(r) === lt || b(r) === ct || b(r) === ut) b(r) === lt || b(r) === ct ? t1.element = r : t1.element = r.canvas, t1.width = t1.element.width, t1.height = t1.element.height, t1.channels = 4;
                                else if (b(r) === ft) t1.element = r, t1.width = r.width, t1.height = r.height, t1.channels = 4;
                                else if (b(r) === ht) t1.element = r, t1.width = r.naturalWidth, t1.height = r.naturalHeight, t1.channels = 4;
                                else if (b(r) === pt) t1.element = r, t1.width = r.videoWidth, t1.height = r.videoHeight, t1.channels = 4;
                                else if (x(r)) {
                                    for(n = t1.width || r[0].length, a = t1.height || r.length, h = t1.channels, h = g(r[0][0]) ? h || r[0][0].length : h || 1, o = Z.shape(r), c = 1, f = 0; f < o.length; ++f)c *= o[f];
                                    c = G.allocType(36193 === t1.type ? 5126 : t1.type, c), Z.flatten(r, o, "", c), w(t1, c), t1.alignment = 1, t1.width = n, t1.height = a, t1.channels = h, t1.format = t1.internalformat = ot[h], t1.needsFree = !0;
                                }
                            } else t1.width = t1.width || 1, t1.height = t1.height || 1, t1.channels = t1.channels || 4;
                        }
                        function d(e1, r, i, a, o) {
                            var s = e1.element, l = e1.data, c = e1.internalformat, u = e1.format, h = e1.type, p = e1.width, d = e1.height;
                            f(e1), s ? t1.texSubImage2D(r, o, i, a, u, h, s) : e1.compressed ? t1.compressedTexSubImage2D(r, o, i, a, c, p, d, l) : e1.needsCopy ? (n(), t1.copyTexSubImage2D(r, o, i, a, e1.xOffset, e1.yOffset, p, d)) : t1.texSubImage2D(r, o, i, a, p, d, u, h, l);
                        }
                        function v() {
                            return mt.pop() || new h;
                        }
                        function k(t1) {
                            t1.needsFree && G.freeType(t1.data), h.call(t1), mt.push(t1);
                        }
                        function A() {
                            s.call(this), this.genMipmaps = !1, this.mipmapHint = 4352, this.mipmask = 0, this.images = Array(16);
                        }
                        function M(t1, e1, r) {
                            var n = t1.images[0] = v();
                            t1.mipmask = 1, n.width = t1.width = e1, n.height = t1.height = r, n.channels = t1.channels = 4;
                        }
                        function S(t1, e1) {
                            var r = null;
                            if (_(e1)) c(r = t1.images[0] = v(), t1), p(r, e1), t1.mipmask = 1;
                            else if (u(t1, e1), Array.isArray(e1.mipmap)) for(var n = e1.mipmap, i = 0; i < n.length; ++i)c(r = t1.images[i] = v(), t1), r.width >>= i, r.height >>= i, p(r, n[i]), t1.mipmask |= 1 << i;
                            else c(r = t1.images[0] = v(), t1), p(r, e1), t1.mipmask = 1;
                            c(t1, t1.images[0]);
                        }
                        function E(e1, r) {
                            for(var i = e1.images, a = 0; a < i.length && i[a]; ++a){
                                var o = i[a], s = r, l = a, c = o.element, u = o.data, h = o.internalformat, p = o.format, d = o.type, m = o.width, g = o.height;
                                f(o), c ? t1.texImage2D(s, l, p, p, d, c) : o.compressed ? t1.compressedTexImage2D(s, l, h, m, g, 0, u) : o.needsCopy ? (n(), t1.copyTexImage2D(s, l, p, o.xOffset, o.yOffset, m, g, 0)) : t1.texImage2D(s, l, p, m, g, 0, p, d, u || null);
                            }
                        }
                        function L() {
                            var t1 = gt.pop() || new A;
                            s.call(t1);
                            for(var e1 = t1.mipmask = 0; 16 > e1; ++e1)t1.images[e1] = null;
                            return t1;
                        }
                        function C(t1) {
                            for(var e1 = t1.images, r = 0; r < e1.length; ++r)e1[r] && k(e1[r]), e1[r] = null;
                            gt.push(t1);
                        }
                        function P() {
                            this.magFilter = this.minFilter = 9728, this.wrapT = this.wrapS = 33071, this.anisotropic = 1, this.genMipmaps = !1, this.mipmapHint = 4352;
                        }
                        function I(t1, e1) {
                            "min" in e1 && (t1.minFilter = V[e1.min], 0 <= at.indexOf(t1.minFilter) && !("faces" in e1) && (t1.genMipmaps = !0)), "mag" in e1 && (t1.magFilter = U[e1.mag]);
                            var r = t1.wrapS, n = t1.wrapT;
                            if ("wrap" in e1) {
                                var i = e1.wrap;
                                "string" == typeof i ? r = n = N[i] : Array.isArray(i) && (r = N[i[0]], n = N[i[1]]);
                            } else "wrapS" in e1 && (r = N[e1.wrapS]), "wrapT" in e1 && (n = N[e1.wrapT]);
                            if (t1.wrapS = r, t1.wrapT = n, "anisotropic" in e1 && (t1.anisotropic = e1.anisotropic), "mipmap" in e1) {
                                switch(r = !1, typeof e1.mipmap){
                                    case "string":
                                        t1.mipmapHint = B[e1.mipmap], r = t1.genMipmaps = !0;
                                        break;
                                    case "boolean":
                                        r = t1.genMipmaps = e1.mipmap;
                                        break;
                                    case "object":
                                        t1.genMipmaps = !1, r = !0;
                                }
                                !r || "min" in e1 || (t1.minFilter = 9984);
                            }
                        }
                        function O(r, n) {
                            t1.texParameteri(n, 10241, r.minFilter), t1.texParameteri(n, 10240, r.magFilter), t1.texParameteri(n, 10242, r.wrapS), t1.texParameteri(n, 10243, r.wrapT), e1.ext_texture_filter_anisotropic && t1.texParameteri(n, 34046, r.anisotropic), r.genMipmaps && (t1.hint(33170, r.mipmapHint), t1.generateMipmap(n));
                        }
                        function z(e1) {
                            s.call(this), this.mipmask = 0, this.internalformat = 6408, this.id = vt++, this.refCount = 1, this.target = e1, this.texture = t1.createTexture(), this.unit = -1, this.bindCount = 0, this.texInfo = new P, o.profile && (this.stats = {
                                size: 0
                            });
                        }
                        function D(e1) {
                            t1.activeTexture(33984), t1.bindTexture(e1.target, e1.texture);
                        }
                        function R() {
                            var e1 = bt[0];
                            e1 ? t1.bindTexture(e1.target, e1.texture) : t1.bindTexture(3553, null);
                        }
                        function F(e1) {
                            var r = e1.texture, n = e1.unit, i = e1.target;
                            0 <= n && (t1.activeTexture(33984 + n), t1.bindTexture(i, null), bt[n] = null), t1.deleteTexture(r), e1.texture = null, e1.params = null, e1.pixels = null, e1.refCount = 0, delete yt[e1.id], a.textureCount--;
                        }
                        var B = {
                            "don't care": 4352,
                            "dont care": 4352,
                            nice: 4354,
                            fast: 4353
                        }, N = {
                            repeat: 10497,
                            clamp: 33071,
                            mirror: 33648
                        }, U = {
                            nearest: 9728,
                            linear: 9729
                        }, V = j({
                            mipmap: 9987,
                            "nearest mipmap nearest": 9984,
                            "linear mipmap nearest": 9985,
                            "nearest mipmap linear": 9986,
                            "linear mipmap linear": 9987
                        }, U), H = {
                            none: 0,
                            browser: 37444
                        }, q = {
                            uint8: 5121,
                            rgba4: 32819,
                            rgb565: 33635,
                            "rgb5 a1": 32820
                        }, Y = {
                            alpha: 6406,
                            luminance: 6409,
                            "luminance alpha": 6410,
                            rgb: 6407,
                            rgba: 6408,
                            rgba4: 32854,
                            "rgb5 a1": 32855,
                            rgb565: 36194
                        }, K = {};
                        e1.ext_srgb && (Y.srgb = 35904, Y.srgba = 35906), e1.oes_texture_float && (q.float32 = q.float = 5126), e1.oes_texture_half_float && (q.float16 = q["half float"] = 36193), e1.webgl_depth_texture && (j(Y, {
                            depth: 6402,
                            "depth stencil": 34041
                        }), j(q, {
                            uint16: 5123,
                            uint32: 5125,
                            "depth stencil": 34042
                        })), e1.webgl_compressed_texture_s3tc && j(K, {
                            "rgb s3tc dxt1": 33776,
                            "rgba s3tc dxt1": 33777,
                            "rgba s3tc dxt3": 33778,
                            "rgba s3tc dxt5": 33779
                        }), e1.webgl_compressed_texture_atc && j(K, {
                            "rgb atc": 35986,
                            "rgba atc explicit alpha": 35987,
                            "rgba atc interpolated alpha": 34798
                        }), e1.webgl_compressed_texture_pvrtc && j(K, {
                            "rgb pvrtc 4bppv1": 35840,
                            "rgb pvrtc 2bppv1": 35841,
                            "rgba pvrtc 4bppv1": 35842,
                            "rgba pvrtc 2bppv1": 35843
                        }), e1.webgl_compressed_texture_etc1 && (K["rgb etc1"] = 36196);
                        var Q = Array.prototype.slice.call(t1.getParameter(34467));
                        Object.keys(K).forEach(function(t1) {
                            var e1 = K[t1];
                            0 <= Q.indexOf(e1) && (Y[t1] = e1);
                        });
                        var $ = Object.keys(Y);
                        r.textureFormats = $;
                        var tt = [];
                        Object.keys(Y).forEach(function(t1) {
                            tt[Y[t1]] = t1;
                        });
                        var et = [];
                        Object.keys(q).forEach(function(t1) {
                            et[q[t1]] = t1;
                        });
                        var rt = [];
                        Object.keys(U).forEach(function(t1) {
                            rt[U[t1]] = t1;
                        });
                        var nt = [];
                        Object.keys(V).forEach(function(t1) {
                            nt[V[t1]] = t1;
                        });
                        var it = [];
                        Object.keys(N).forEach(function(t1) {
                            it[N[t1]] = t1;
                        });
                        var dt = $.reduce(function(t1, r) {
                            var n = Y[r];
                            return 6409 === n || 6406 === n || 6409 === n || 6410 === n || 6402 === n || 34041 === n || e1.ext_srgb && (35904 === n || 35906 === n) ? t1[n] = n : 32855 === n || 0 <= r.indexOf("rgba") ? t1[n] = 6408 : t1[n] = 6407, t1;
                        }, {}), mt = [], gt = [], vt = 0, yt = {}, xt = r.maxTextureUnits, bt = Array(xt).map(function() {
                            return null;
                        });
                        return j(z.prototype, {
                            bind: function() {
                                this.bindCount += 1;
                                var e1 = this.unit;
                                if (0 > e1) {
                                    for(var r = 0; r < xt; ++r){
                                        var n = bt[r];
                                        if (n) {
                                            if (0 < n.bindCount) continue;
                                            n.unit = -1;
                                        }
                                        bt[r] = this, e1 = r;
                                        break;
                                    }
                                    o.profile && a.maxTextureUnits < e1 + 1 && (a.maxTextureUnits = e1 + 1), this.unit = e1, t1.activeTexture(33984 + e1), t1.bindTexture(this.target, this.texture);
                                }
                                return e1;
                            },
                            unbind: function() {
                                --this.bindCount;
                            },
                            decRef: function() {
                                0 >= --this.refCount && F(this);
                            }
                        }), o.profile && (a.getTotalTextureSize = function() {
                            var t1 = 0;
                            return Object.keys(yt).forEach(function(e1) {
                                t1 += yt[e1].stats.size;
                            }), t1;
                        }), {
                            create2D: function(e1, r) {
                                function n(t1, e1) {
                                    var r = i.texInfo;
                                    P.call(r);
                                    var a = L();
                                    return "number" == typeof t1 ? M(a, 0 | t1, "number" == typeof e1 ? 0 | e1 : 0 | t1) : t1 ? (I(r, t1), S(a, t1)) : M(a, 1, 1), r.genMipmaps && (a.mipmask = (a.width << 1) - 1), i.mipmask = a.mipmask, c(i, a), i.internalformat = a.internalformat, n.width = a.width, n.height = a.height, D(i), E(a, 3553), O(r, 3553), R(), C(a), o.profile && (i.stats.size = T(i.internalformat, i.type, a.width, a.height, r.genMipmaps, !1)), n.format = tt[i.internalformat], n.type = et[i.type], n.mag = rt[r.magFilter], n.min = nt[r.minFilter], n.wrapS = it[r.wrapS], n.wrapT = it[r.wrapT], n;
                                }
                                var i = new z(3553);
                                return yt[i.id] = i, a.textureCount++, n(e1, r), n.subimage = function(t1, e1, r, a) {
                                    e1 |= 0, r |= 0, a |= 0;
                                    var o = v();
                                    return c(o, i), o.width = 0, o.height = 0, p(o, t1), o.width = o.width || (i.width >> a) - e1, o.height = o.height || (i.height >> a) - r, D(i), d(o, 3553, e1, r, a), R(), k(o), n;
                                }, n.resize = function(e1, r) {
                                    var a = 0 | e1, s = 0 | r || a;
                                    if (a === i.width && s === i.height) return n;
                                    n.width = i.width = a, n.height = i.height = s, D(i);
                                    for(var l = 0; i.mipmask >> l; ++l){
                                        var c = a >> l, u = s >> l;
                                        if (!c || !u) break;
                                        t1.texImage2D(3553, l, i.format, c, u, 0, i.format, i.type, null);
                                    }
                                    return R(), o.profile && (i.stats.size = T(i.internalformat, i.type, a, s, !1, !1)), n;
                                }, n._reglType = "texture2d", n._texture = i, o.profile && (n.stats = i.stats), n.destroy = function() {
                                    i.decRef();
                                }, n;
                            },
                            createCube: function(e1, r, n, i, s, l) {
                                function f(t1, e1, r, n, i, a) {
                                    var s, l = h.texInfo;
                                    for(P.call(l), s = 0; 6 > s; ++s)m[s] = L();
                                    if ("number" != typeof t1 && t1) {
                                        if ("object" == typeof t1) {
                                            if (e1) S(m[0], t1), S(m[1], e1), S(m[2], r), S(m[3], n), S(m[4], i), S(m[5], a);
                                            else if (I(l, t1), u(h, t1), "faces" in t1) for(t1 = t1.faces, s = 0; 6 > s; ++s)c(m[s], h), S(m[s], t1[s]);
                                            else for(s = 0; 6 > s; ++s)S(m[s], t1);
                                        }
                                    } else for(t1 = 0 | t1 || 1, s = 0; 6 > s; ++s)M(m[s], t1, t1);
                                    for(c(h, m[0]), h.mipmask = l.genMipmaps ? (m[0].width << 1) - 1 : m[0].mipmask, h.internalformat = m[0].internalformat, f.width = m[0].width, f.height = m[0].height, D(h), s = 0; 6 > s; ++s)E(m[s], 34069 + s);
                                    for(O(l, 34067), R(), o.profile && (h.stats.size = T(h.internalformat, h.type, f.width, f.height, l.genMipmaps, !0)), f.format = tt[h.internalformat], f.type = et[h.type], f.mag = rt[l.magFilter], f.min = nt[l.minFilter], f.wrapS = it[l.wrapS], f.wrapT = it[l.wrapT], s = 0; 6 > s; ++s)C(m[s]);
                                    return f;
                                }
                                var h = new z(34067);
                                yt[h.id] = h, a.cubeCount++;
                                var m = Array(6);
                                return f(e1, r, n, i, s, l), f.subimage = function(t1, e1, r, n, i) {
                                    r |= 0, n |= 0, i |= 0;
                                    var a = v();
                                    return c(a, h), a.width = 0, a.height = 0, p(a, e1), a.width = a.width || (h.width >> i) - r, a.height = a.height || (h.height >> i) - n, D(h), d(a, 34069 + t1, r, n, i), R(), k(a), f;
                                }, f.resize = function(e1) {
                                    if ((e1 |= 0) !== h.width) {
                                        f.width = h.width = e1, f.height = h.height = e1, D(h);
                                        for(var r = 0; 6 > r; ++r)for(var n = 0; h.mipmask >> n; ++n)t1.texImage2D(34069 + r, n, h.format, e1 >> n, e1 >> n, 0, h.format, h.type, null);
                                        return R(), o.profile && (h.stats.size = T(h.internalformat, h.type, f.width, f.height, !1, !0)), f;
                                    }
                                }, f._reglType = "textureCube", f._texture = h, o.profile && (f.stats = h.stats), f.destroy = function() {
                                    h.decRef();
                                }, f;
                            },
                            clear: function() {
                                for(var e1 = 0; e1 < xt; ++e1)t1.activeTexture(33984 + e1), t1.bindTexture(3553, null), bt[e1] = null;
                                X(yt).forEach(F), a.cubeCount = 0, a.textureCount = 0;
                            },
                            getTexture: function(t1) {
                                return null;
                            },
                            restore: function() {
                                for(var e1 = 0; e1 < xt; ++e1){
                                    var r = bt[e1];
                                    r && (r.bindCount = 0, r.unit = -1, bt[e1] = null);
                                }
                                X(yt).forEach(function(e1) {
                                    e1.texture = t1.createTexture(), t1.bindTexture(e1.target, e1.texture);
                                    for(var r = 0; 32 > r; ++r)if (0 != (e1.mipmask & 1 << r)) {
                                        if (3553 === e1.target) t1.texImage2D(3553, r, e1.internalformat, e1.width >> r, e1.height >> r, 0, e1.internalformat, e1.type, null);
                                        else for(var n = 0; 6 > n; ++n)t1.texImage2D(34069 + n, r, e1.internalformat, e1.width >> r, e1.height >> r, 0, e1.internalformat, e1.type, null);
                                    }
                                    O(e1.texInfo, e1.target);
                                });
                            },
                            refresh: function() {
                                for(var e1 = 0; e1 < xt; ++e1){
                                    var r = bt[e1];
                                    r && (r.bindCount = 0, r.unit = -1, bt[e1] = null), t1.activeTexture(33984 + e1), t1.bindTexture(3553, null), t1.bindTexture(34067, null);
                                }
                            }
                        };
                    }
                    function A(t1, e1, r, n, i, a) {
                        function o(t1, e1, r) {
                            this.target = t1, this.texture = e1, this.renderbuffer = r;
                            var n = t1 = 0;
                            e1 ? (t1 = e1.width, n = e1.height) : r && (t1 = r.width, n = r.height), this.width = t1, this.height = n;
                        }
                        function s(t1) {
                            t1 && (t1.texture && t1.texture._texture.decRef(), t1.renderbuffer && t1.renderbuffer._renderbuffer.decRef());
                        }
                        function l(t1, e1, r) {
                            t1 && (t1.texture ? t1.texture._texture.refCount += 1 : t1.renderbuffer._renderbuffer.refCount += 1);
                        }
                        function c(e1, r) {
                            r && (r.texture ? t1.framebufferTexture2D(36160, e1, r.target, r.texture._texture.texture, 0) : t1.framebufferRenderbuffer(36160, e1, 36161, r.renderbuffer._renderbuffer.renderbuffer));
                        }
                        function u(t1) {
                            var e1 = 3553, r = null, n = null, i = t1;
                            return "object" == typeof t1 && (i = t1.data, "target" in t1 && (e1 = 0 | t1.target)), "texture2d" === (t1 = i._reglType) || "textureCube" === t1 ? r = i : "renderbuffer" === t1 && (n = i, e1 = 36161), new o(e1, r, n);
                        }
                        function f(t1, e1, r, a, s) {
                            return r ? ((t1 = n.create2D({
                                width: t1,
                                height: e1,
                                format: a,
                                type: s
                            }))._texture.refCount = 0, new o(3553, t1, null)) : ((t1 = i.create({
                                width: t1,
                                height: e1,
                                format: a
                            }))._renderbuffer.refCount = 0, new o(36161, null, t1));
                        }
                        function h(t1) {
                            return t1 && (t1.texture || t1.renderbuffer);
                        }
                        function p(t1, e1, r) {
                            t1 && (t1.texture ? t1.texture.resize(e1, r) : t1.renderbuffer && t1.renderbuffer.resize(e1, r), t1.width = e1, t1.height = r);
                        }
                        function d() {
                            this.id = T++, k[this.id] = this, this.framebuffer = t1.createFramebuffer(), this.height = this.width = 0, this.colorAttachments = [], this.depthStencilAttachment = this.stencilAttachment = this.depthAttachment = null;
                        }
                        function m(t1) {
                            t1.colorAttachments.forEach(s), s(t1.depthAttachment), s(t1.stencilAttachment), s(t1.depthStencilAttachment);
                        }
                        function g(e1) {
                            t1.deleteFramebuffer(e1.framebuffer), e1.framebuffer = null, a.framebufferCount--, delete k[e1.id];
                        }
                        function v(e1) {
                            var n;
                            t1.bindFramebuffer(36160, e1.framebuffer);
                            var i = e1.colorAttachments;
                            for(n = 0; n < i.length; ++n)c(36064 + n, i[n]);
                            for(n = i.length; n < r.maxColorAttachments; ++n)t1.framebufferTexture2D(36160, 36064 + n, 3553, null, 0);
                            t1.framebufferTexture2D(36160, 33306, 3553, null, 0), t1.framebufferTexture2D(36160, 36096, 3553, null, 0), t1.framebufferTexture2D(36160, 36128, 3553, null, 0), c(36096, e1.depthAttachment), c(36128, e1.stencilAttachment), c(33306, e1.depthStencilAttachment), t1.checkFramebufferStatus(36160), t1.isContextLost(), t1.bindFramebuffer(36160, x.next ? x.next.framebuffer : null), x.cur = x.next, t1.getError();
                        }
                        function y(t1, e1) {
                            function r(t1, e1) {
                                var i, a = 0, o = 0, s = !0, c = !0;
                                i = null;
                                var p = !0, d = "rgba", g = "uint8", y = 1, x = null, w = null, T = null, k = !1;
                                "number" == typeof t1 ? (a = 0 | t1, o = 0 | e1 || a) : t1 ? ("shape" in t1 ? (a = (o = t1.shape)[0], o = o[1]) : ("radius" in t1 && (a = o = t1.radius), "width" in t1 && (a = t1.width), "height" in t1 && (o = t1.height)), ("color" in t1 || "colors" in t1) && (i = t1.color || t1.colors, Array.isArray(i)), i || ("colorCount" in t1 && (y = 0 | t1.colorCount), "colorTexture" in t1 && (p = !!t1.colorTexture, d = "rgba4"), "colorType" in t1 && (g = t1.colorType, !p) && ("half float" === g || "float16" === g ? d = "rgba16f" : "float" !== g && "float32" !== g || (d = "rgba32f")), "colorFormat" in t1 && (d = t1.colorFormat, 0 <= b.indexOf(d) ? p = !0 : 0 <= _.indexOf(d) && (p = !1))), ("depthTexture" in t1 || "depthStencilTexture" in t1) && (k = !(!t1.depthTexture && !t1.depthStencilTexture)), "depth" in t1 && ("boolean" == typeof t1.depth ? s = t1.depth : (x = t1.depth, c = !1)), "stencil" in t1 && ("boolean" == typeof t1.stencil ? c = t1.stencil : (w = t1.stencil, s = !1)), "depthStencil" in t1 && ("boolean" == typeof t1.depthStencil ? s = c = t1.depthStencil : (T = t1.depthStencil, c = s = !1))) : a = o = 1;
                                var A = null, M = null, S = null, E = null;
                                if (Array.isArray(i)) A = i.map(u);
                                else if (i) A = [
                                    u(i)
                                ];
                                else for(A = Array(y), i = 0; i < y; ++i)A[i] = f(a, o, p, d, g);
                                for(a = a || A[0].width, o = o || A[0].height, x ? M = u(x) : s && !c && (M = f(a, o, k, "depth", "uint32")), w ? S = u(w) : c && !s && (S = f(a, o, !1, "stencil", "uint8")), T ? E = u(T) : !x && !w && c && s && (E = f(a, o, k, "depth stencil", "depth stencil")), s = null, i = 0; i < A.length; ++i)l(A[i]), A[i] && A[i].texture && (c = xt[A[i].texture._texture.format] * bt[A[i].texture._texture.type], null === s && (s = c));
                                return l(M), l(S), l(E), m(n), n.width = a, n.height = o, n.colorAttachments = A, n.depthAttachment = M, n.stencilAttachment = S, n.depthStencilAttachment = E, r.color = A.map(h), r.depth = h(M), r.stencil = h(S), r.depthStencil = h(E), r.width = n.width, r.height = n.height, v(n), r;
                            }
                            var n = new d;
                            return a.framebufferCount++, r(t1, e1), j(r, {
                                resize: function(t1, e1) {
                                    var i = Math.max(0 | t1, 1), a = Math.max(0 | e1 || i, 1);
                                    if (i === n.width && a === n.height) return r;
                                    for(var o = n.colorAttachments, s = 0; s < o.length; ++s)p(o[s], i, a);
                                    return p(n.depthAttachment, i, a), p(n.stencilAttachment, i, a), p(n.depthStencilAttachment, i, a), n.width = r.width = i, n.height = r.height = a, v(n), r;
                                },
                                _reglType: "framebuffer",
                                _framebuffer: n,
                                destroy: function() {
                                    g(n), m(n);
                                },
                                use: function(t1) {
                                    x.setFBO({
                                        framebuffer: r
                                    }, t1);
                                }
                            });
                        }
                        var x = {
                            cur: null,
                            next: null,
                            dirty: !1,
                            setFBO: null
                        }, b = [
                            "rgba"
                        ], _ = [
                            "rgba4",
                            "rgb565",
                            "rgb5 a1"
                        ];
                        e1.ext_srgb && _.push("srgba"), e1.ext_color_buffer_half_float && _.push("rgba16f", "rgb16f"), e1.webgl_color_buffer_float && _.push("rgba32f");
                        var w = [
                            "uint8"
                        ];
                        e1.oes_texture_half_float && w.push("half float", "float16"), e1.oes_texture_float && w.push("float", "float32");
                        var T = 0, k = {};
                        return j(x, {
                            getFramebuffer: function(t1) {
                                return "function" == typeof t1 && "framebuffer" === t1._reglType && (t1 = t1._framebuffer) instanceof d ? t1 : null;
                            },
                            create: y,
                            createCube: function(t1) {
                                function e1(t1) {
                                    var i, a = {
                                        color: null
                                    }, o = 0, s = null;
                                    i = "rgba";
                                    var l = "uint8", c = 1;
                                    if ("number" == typeof t1 ? o = 0 | t1 : t1 ? ("shape" in t1 ? o = t1.shape[0] : ("radius" in t1 && (o = 0 | t1.radius), "width" in t1 ? o = 0 | t1.width : "height" in t1 && (o = 0 | t1.height)), ("color" in t1 || "colors" in t1) && (s = t1.color || t1.colors, Array.isArray(s)), s || ("colorCount" in t1 && (c = 0 | t1.colorCount), "colorType" in t1 && (l = t1.colorType), "colorFormat" in t1 && (i = t1.colorFormat)), "depth" in t1 && (a.depth = t1.depth), "stencil" in t1 && (a.stencil = t1.stencil), "depthStencil" in t1 && (a.depthStencil = t1.depthStencil)) : o = 1, s) {
                                        if (Array.isArray(s)) for(t1 = [], i = 0; i < s.length; ++i)t1[i] = s[i];
                                        else t1 = [
                                            s
                                        ];
                                    } else for(t1 = Array(c), s = {
                                        radius: o,
                                        format: i,
                                        type: l
                                    }, i = 0; i < c; ++i)t1[i] = n.createCube(s);
                                    for(a.color = Array(t1.length), i = 0; i < t1.length; ++i)c = t1[i], o = o || c.width, a.color[i] = {
                                        target: 34069,
                                        data: t1[i]
                                    };
                                    for(i = 0; 6 > i; ++i){
                                        for(c = 0; c < t1.length; ++c)a.color[c].target = 34069 + i;
                                        0 < i && (a.depth = r[0].depth, a.stencil = r[0].stencil, a.depthStencil = r[0].depthStencil), r[i] ? r[i](a) : r[i] = y(a);
                                    }
                                    return j(e1, {
                                        width: o,
                                        height: o,
                                        color: t1
                                    });
                                }
                                var r = Array(6);
                                return e1(t1), j(e1, {
                                    faces: r,
                                    resize: function(t1) {
                                        var n = 0 | t1;
                                        if (n === e1.width) return e1;
                                        var i = e1.color;
                                        for(t1 = 0; t1 < i.length; ++t1)i[t1].resize(n);
                                        for(t1 = 0; 6 > t1; ++t1)r[t1].resize(n);
                                        return e1.width = e1.height = n, e1;
                                    },
                                    _reglType: "framebufferCube",
                                    destroy: function() {
                                        r.forEach(function(t1) {
                                            t1.destroy();
                                        });
                                    }
                                });
                            },
                            clear: function() {
                                X(k).forEach(g);
                            },
                            restore: function() {
                                x.cur = null, x.next = null, x.dirty = !0, X(k).forEach(function(e1) {
                                    e1.framebuffer = t1.createFramebuffer(), v(e1);
                                });
                            }
                        });
                    }
                    function M() {
                        this.w = this.z = this.y = this.x = this.state = 0, this.buffer = null, this.size = 0, this.normalized = !1, this.type = 5126, this.divisor = this.stride = this.offset = 0;
                    }
                    function S(t1, e1, r, n, i, a, o) {
                        function s() {
                            this.id = ++f, this.attributes = [], this.elements = null, this.ownsElements = !1, this.offset = this.count = 0, this.instances = -1, this.primitive = 4;
                            var t1 = e1.oes_vertex_array_object;
                            this.vao = t1 ? t1.createVertexArrayOES() : null, h[this.id] = this, this.buffers = [];
                        }
                        var c = r.maxAttributes, u = Array(c);
                        for(r = 0; r < c; ++r)u[r] = new M;
                        var f = 0, h = {}, p = {
                            Record: M,
                            scope: {},
                            state: u,
                            currentVAO: null,
                            targetVAO: null,
                            restore: e1.oes_vertex_array_object ? function() {
                                e1.oes_vertex_array_object && X(h).forEach(function(t1) {
                                    t1.refresh();
                                });
                            } : function() {},
                            createVAO: function(t1) {
                                function e1(t1) {
                                    var n;
                                    Array.isArray(t1) ? (n = t1, r.elements && r.ownsElements && r.elements.destroy(), r.elements = null, r.ownsElements = !1, r.offset = 0, r.count = 0, r.instances = -1, r.primitive = 4) : (t1.elements ? (n = t1.elements, r.ownsElements ? ("function" == typeof n && "elements" === n._reglType ? r.elements.destroy() : r.elements(n), r.ownsElements = !1) : a.getElements(t1.elements) ? (r.elements = t1.elements, r.ownsElements = !1) : (r.elements = a.create(t1.elements), r.ownsElements = !0)) : (r.elements = null, r.ownsElements = !1), n = t1.attributes, r.offset = 0, r.count = -1, r.instances = -1, r.primitive = 4, r.elements && (r.count = r.elements._elements.vertCount, r.primitive = r.elements._elements.primType), "offset" in t1 && (r.offset = 0 | t1.offset), "count" in t1 && (r.count = 0 | t1.count), "instances" in t1 && (r.instances = 0 | t1.instances), "primitive" in t1 && (r.primitive = rt[t1.primitive])), t1 = {};
                                    var o = r.attributes;
                                    o.length = n.length;
                                    for(var s = 0; s < n.length; ++s){
                                        var c, u = n[s], f = o[s] = new M, h = u.data || u;
                                        if (Array.isArray(h) || W(h) || l(h)) r.buffers[s] && (c = r.buffers[s], W(h) && c._buffer.byteLength >= h.byteLength ? c.subdata(h) : (c.destroy(), r.buffers[s] = null)), r.buffers[s] || (c = r.buffers[s] = i.create(u, 34962, !1, !0)), f.buffer = i.getBuffer(c), f.size = 0 | f.buffer.dimension, f.normalized = !1, f.type = f.buffer.dtype, f.offset = 0, f.stride = 0, f.divisor = 0, f.state = 1, t1[s] = 1;
                                        else i.getBuffer(u) ? (f.buffer = i.getBuffer(u), f.size = 0 | f.buffer.dimension, f.normalized = !1, f.type = f.buffer.dtype, f.offset = 0, f.stride = 0, f.divisor = 0, f.state = 1) : i.getBuffer(u.buffer) ? (f.buffer = i.getBuffer(u.buffer), f.size = 0 | (+u.size || f.buffer.dimension), f.normalized = !!u.normalized || !1, f.type = "type" in u ? K[u.type] : f.buffer.dtype, f.offset = 0 | (u.offset || 0), f.stride = 0 | (u.stride || 0), f.divisor = 0 | (u.divisor || 0), f.state = 1) : "x" in u && (f.x = +u.x || 0, f.y = +u.y || 0, f.z = +u.z || 0, f.w = +u.w || 0, f.state = 2);
                                    }
                                    for(c = 0; c < r.buffers.length; ++c)!t1[c] && r.buffers[c] && (r.buffers[c].destroy(), r.buffers[c] = null);
                                    return r.refresh(), e1;
                                }
                                var r = new s;
                                return n.vaoCount += 1, e1.destroy = function() {
                                    for(var t1 = 0; t1 < r.buffers.length; ++t1)r.buffers[t1] && r.buffers[t1].destroy();
                                    r.buffers.length = 0, r.ownsElements && (r.elements.destroy(), r.elements = null, r.ownsElements = !1), r.destroy();
                                }, e1._vao = r, e1._reglType = "vao", e1(t1);
                            },
                            getVAO: function(t1) {
                                return "function" == typeof t1 && t1._vao ? t1._vao : null;
                            },
                            destroyBuffer: function(e1) {
                                for(var r = 0; r < u.length; ++r){
                                    var n = u[r];
                                    n.buffer === e1 && (t1.disableVertexAttribArray(r), n.buffer = null);
                                }
                            },
                            setVAO: e1.oes_vertex_array_object ? function(t1) {
                                if (t1 !== p.currentVAO) {
                                    var r = e1.oes_vertex_array_object;
                                    t1 ? r.bindVertexArrayOES(t1.vao) : r.bindVertexArrayOES(null), p.currentVAO = t1;
                                }
                            } : function(r) {
                                if (r !== p.currentVAO) {
                                    if (r) r.bindAttrs();
                                    else {
                                        for(var n = e1.angle_instanced_arrays, i = 0; i < u.length; ++i){
                                            var a = u[i];
                                            a.buffer ? (t1.enableVertexAttribArray(i), a.buffer.bind(), t1.vertexAttribPointer(i, a.size, a.type, a.normalized, a.stride, a.offfset), n && a.divisor && n.vertexAttribDivisorANGLE(i, a.divisor)) : (t1.disableVertexAttribArray(i), t1.vertexAttrib4f(i, a.x, a.y, a.z, a.w));
                                        }
                                        o.elements ? t1.bindBuffer(34963, o.elements.buffer.buffer) : t1.bindBuffer(34963, null);
                                    }
                                    p.currentVAO = r;
                                }
                            },
                            clear: e1.oes_vertex_array_object ? function() {
                                X(h).forEach(function(t1) {
                                    t1.destroy();
                                });
                            } : function() {}
                        };
                        return s.prototype.bindAttrs = function() {
                            for(var r = e1.angle_instanced_arrays, n = this.attributes, i = 0; i < n.length; ++i){
                                var o = n[i];
                                o.buffer ? (t1.enableVertexAttribArray(i), t1.bindBuffer(34962, o.buffer.buffer), t1.vertexAttribPointer(i, o.size, o.type, o.normalized, o.stride, o.offset), r && o.divisor && r.vertexAttribDivisorANGLE(i, o.divisor)) : (t1.disableVertexAttribArray(i), t1.vertexAttrib4f(i, o.x, o.y, o.z, o.w));
                            }
                            for(r = n.length; r < c; ++r)t1.disableVertexAttribArray(r);
                            (r = a.getElements(this.elements)) ? t1.bindBuffer(34963, r.buffer.buffer) : t1.bindBuffer(34963, null);
                        }, s.prototype.refresh = function() {
                            var t1 = e1.oes_vertex_array_object;
                            t1 && (t1.bindVertexArrayOES(this.vao), this.bindAttrs(), p.currentVAO = null, t1.bindVertexArrayOES(null));
                        }, s.prototype.destroy = function() {
                            if (this.vao) {
                                var t1 = e1.oes_vertex_array_object;
                                this === p.currentVAO && (p.currentVAO = null, t1.bindVertexArrayOES(null)), t1.deleteVertexArrayOES(this.vao), this.vao = null;
                            }
                            this.ownsElements && (this.elements.destroy(), this.elements = null, this.ownsElements = !1), h[this.id] && (delete h[this.id], --n.vaoCount);
                        }, p;
                    }
                    function E(t1, e1, r, n) {
                        function i(t1, e1, r, n) {
                            this.name = t1, this.id = e1, this.location = r, this.info = n;
                        }
                        function a(t1, e1) {
                            for(var r = 0; r < t1.length; ++r)if (t1[r].id === e1.id) return void (t1[r].location = e1.location);
                            t1.push(e1);
                        }
                        function o(r, n, i) {
                            if (!(o = (i = 35632 === r ? c : u)[n])) {
                                var a = e1.str(n), o = t1.createShader(r);
                                t1.shaderSource(o, a), t1.compileShader(o), i[n] = o;
                            }
                            return o;
                        }
                        function s(t1, e1) {
                            this.id = p++, this.fragId = t1, this.vertId = e1, this.program = null, this.uniforms = [], this.attributes = [], this.refCount = 1, n.profile && (this.stats = {
                                uniformsCount: 0,
                                attributesCount: 0
                            });
                        }
                        function l(r, s, l) {
                            var c;
                            c = o(35632, r.fragId);
                            var u = o(35633, r.vertId);
                            if (s = r.program = t1.createProgram(), t1.attachShader(s, c), t1.attachShader(s, u), l) for(c = 0; c < l.length; ++c)u = l[c], t1.bindAttribLocation(s, u[0], u[1]);
                            t1.linkProgram(s), u = t1.getProgramParameter(s, 35718), n.profile && (r.stats.uniformsCount = u);
                            var f = r.uniforms;
                            for(c = 0; c < u; ++c)if (l = t1.getActiveUniform(s, c)) {
                                if (1 < l.size) for(var h = 0; h < l.size; ++h){
                                    var p = l.name.replace("[0]", "[" + h + "]");
                                    a(f, new i(p, e1.id(p), t1.getUniformLocation(s, p), l));
                                }
                                h = l.name, 1 < l.size && (h = h.replace("[0]", "")), a(f, new i(h, e1.id(h), t1.getUniformLocation(s, h), l));
                            }
                            for(u = t1.getProgramParameter(s, 35721), n.profile && (r.stats.attributesCount = u), r = r.attributes, c = 0; c < u; ++c)(l = t1.getActiveAttrib(s, c)) && a(r, new i(l.name, e1.id(l.name), t1.getAttribLocation(s, l.name), l));
                        }
                        var c = {}, u = {}, f = {}, h = [], p = 0;
                        return n.profile && (r.getMaxUniformsCount = function() {
                            var t1 = 0;
                            return h.forEach(function(e1) {
                                e1.stats.uniformsCount > t1 && (t1 = e1.stats.uniformsCount);
                            }), t1;
                        }, r.getMaxAttributesCount = function() {
                            var t1 = 0;
                            return h.forEach(function(e1) {
                                e1.stats.attributesCount > t1 && (t1 = e1.stats.attributesCount);
                            }), t1;
                        }), {
                            clear: function() {
                                var e1 = t1.deleteShader.bind(t1);
                                X(c).forEach(e1), c = {}, X(u).forEach(e1), u = {}, h.forEach(function(e1) {
                                    t1.deleteProgram(e1.program);
                                }), h.length = 0, f = {}, r.shaderCount = 0;
                            },
                            program: function(e1, n, i, a) {
                                var o = f[n];
                                o || (o = f[n] = {});
                                var p = o[e1];
                                if (p && (p.refCount++, !a)) return p;
                                var d = new s(n, e1);
                                return r.shaderCount++, l(d, i, a), p || (o[e1] = d), h.push(d), j(d, {
                                    destroy: function() {
                                        if (d.refCount--, 0 >= d.refCount) {
                                            t1.deleteProgram(d.program);
                                            var e1 = h.indexOf(d);
                                            h.splice(e1, 1), r.shaderCount--;
                                        }
                                        0 >= o[d.vertId].refCount && (t1.deleteShader(u[d.vertId]), delete u[d.vertId], delete f[d.fragId][d.vertId]), Object.keys(f[d.fragId]).length || (t1.deleteShader(c[d.fragId]), delete c[d.fragId], delete f[d.fragId]);
                                    }
                                });
                            },
                            restore: function() {
                                c = {}, u = {};
                                for(var t1 = 0; t1 < h.length; ++t1)l(h[t1], null, h[t1].attributes.map(function(t1) {
                                    return [
                                        t1.location,
                                        t1.name
                                    ];
                                }));
                            },
                            shader: o,
                            frag: -1,
                            vert: -1
                        };
                    }
                    function L(t1, e1, r, n, i, a, o) {
                        function s(i) {
                            var a;
                            a = null === e1.next ? 5121 : e1.next.colorAttachments[0].texture._texture.type;
                            var o = 0, s = 0, l = n.framebufferWidth, c = n.framebufferHeight, u = null;
                            return W(i) ? u = i : i && (o = 0 | i.x, s = 0 | i.y, l = 0 | (i.width || n.framebufferWidth - o), c = 0 | (i.height || n.framebufferHeight - s), u = i.data || null), r(), i = l * c * 4, u || (5121 === a ? u = new Uint8Array(i) : 5126 === a && (u = u || new Float32Array(i))), t1.pixelStorei(3333, 4), t1.readPixels(o, s, l, c, 6408, a, u), u;
                        }
                        return function(t1) {
                            return t1 && "framebuffer" in t1 ? function(t1) {
                                var r;
                                return e1.setFBO({
                                    framebuffer: t1.framebuffer
                                }, function() {
                                    r = s(t1);
                                }), r;
                            }(t1) : s(t1);
                        };
                    }
                    function C(t1) {
                        return Array.prototype.slice.call(t1);
                    }
                    function P(t1) {
                        return C(t1).join("");
                    }
                    function I(t1) {
                        return Array.isArray(t1) || W(t1) || l(t1);
                    }
                    function O(t1) {
                        return t1.sort(function(t1, e1) {
                            return "viewport" === t1 ? -1 : "viewport" === e1 ? 1 : t1 < e1 ? -1 : 1;
                        });
                    }
                    function z(t1, e1, r, n) {
                        this.thisDep = t1, this.contextDep = e1, this.propDep = r, this.append = n;
                    }
                    function D(t1) {
                        return t1 && !(t1.thisDep || t1.contextDep || t1.propDep);
                    }
                    function R(t1) {
                        return new z(!1, !1, !1, t1);
                    }
                    function F(t1, e1) {
                        var r = t1.type;
                        if (0 === r) return new z(!0, 1 <= (r = t1.data.length), 2 <= r, e1);
                        if (4 === r) return new z((r = t1.data).thisDep, r.contextDep, r.propDep, e1);
                        if (5 === r) return new z(!1, !1, !1, e1);
                        if (6 === r) {
                            for(var n = r = !1, i = !1, a = 0; a < t1.data.length; ++a){
                                var o = t1.data[a];
                                1 === o.type ? i = !0 : 2 === o.type ? n = !0 : 3 === o.type ? r = !0 : 0 === o.type ? (r = !0, 1 <= (o = o.data) && (n = !0), 2 <= o && (i = !0)) : 4 === o.type && (r = r || o.data.thisDep, n = n || o.data.contextDep, i = i || o.data.propDep);
                            }
                            return new z(r, n, i, e1);
                        }
                        return new z(3 === r, 2 === r, 1 === r, e1);
                    }
                    function B(t1, e1, r, n, i, o, s, l, c, u, f, h, p, d, m) {
                        function v(t1) {
                            return t1.replace(".", "_");
                        }
                        function y(t1, e1, r) {
                            var n = v(t1);
                            ot.push(t1), at[n] = it[n] = !!r, st[n] = e1;
                        }
                        function x(t1, e1, r) {
                            var n = v(t1);
                            ot.push(t1), Array.isArray(r) ? (it[n] = r.slice(), at[n] = r.slice()) : it[n] = at[n] = r, lt[n] = e1;
                        }
                        function b() {
                            var t1 = function() {
                                function t1() {
                                    var t1 = [], e1 = [];
                                    return j(function() {
                                        t1.push.apply(t1, C(arguments));
                                    }, {
                                        def: function() {
                                            var n = "v" + r++;
                                            return e1.push(n), 0 < arguments.length && (t1.push(n, "="), t1.push.apply(t1, C(arguments)), t1.push(";")), n;
                                        },
                                        toString: function() {
                                            return P([
                                                0 < e1.length ? "var " + e1.join(",") + ";" : "",
                                                P(t1)
                                            ]);
                                        }
                                    });
                                }
                                function e1() {
                                    function e1(t1, e1) {
                                        n(t1, e1, "=", r.def(t1, e1), ";");
                                    }
                                    var r = t1(), n = t1(), i = r.toString, a = n.toString;
                                    return j(function() {
                                        r.apply(r, C(arguments));
                                    }, {
                                        def: r.def,
                                        entry: r,
                                        exit: n,
                                        save: e1,
                                        set: function(t1, n, i) {
                                            e1(t1, n), r(t1, n, "=", i, ";");
                                        },
                                        toString: function() {
                                            return i() + a();
                                        }
                                    });
                                }
                                var r = 0, n = [], i = [], a = t1(), o = {};
                                return {
                                    global: a,
                                    link: function(t1) {
                                        for(var e1 = 0; e1 < i.length; ++e1)if (i[e1] === t1) return n[e1];
                                        return e1 = "g" + r++, n.push(e1), i.push(t1), e1;
                                    },
                                    block: t1,
                                    proc: function(t1, r) {
                                        function n() {
                                            var t1 = "a" + i.length;
                                            return i.push(t1), t1;
                                        }
                                        var i = [];
                                        r = r || 0;
                                        for(var a = 0; a < r; ++a)n();
                                        var s = (a = e1()).toString;
                                        return o[t1] = j(a, {
                                            arg: n,
                                            toString: function() {
                                                return P([
                                                    "function(",
                                                    i.join(),
                                                    "){",
                                                    s(),
                                                    "}"
                                                ]);
                                            }
                                        });
                                    },
                                    scope: e1,
                                    cond: function() {
                                        var t1 = P(arguments), r = e1(), n = e1(), i = r.toString, a = n.toString;
                                        return j(r, {
                                            then: function() {
                                                return r.apply(r, C(arguments)), this;
                                            },
                                            else: function() {
                                                return n.apply(n, C(arguments)), this;
                                            },
                                            toString: function() {
                                                var e1 = a();
                                                return e1 && (e1 = "else{" + e1 + "}"), P([
                                                    "if(",
                                                    t1,
                                                    "){",
                                                    i(),
                                                    "}",
                                                    e1
                                                ]);
                                            }
                                        });
                                    },
                                    compile: function() {
                                        var t1 = [
                                            '"use strict";',
                                            a,
                                            "return {"
                                        ];
                                        Object.keys(o).forEach(function(e1) {
                                            t1.push('"', e1, '":', o[e1].toString(), ",");
                                        }), t1.push("}");
                                        var e1 = P(t1).replace(/;/g, ";\n").replace(/}/g, "}\n").replace(/{/g, "{\n");
                                        return Function.apply(null, n.concat(e1)).apply(null, i);
                                    }
                                };
                            }(), r = t1.link, n = t1.global;
                            t1.id = ft++, t1.batchId = "0";
                            var i = r(ct), a = t1.shared = {
                                props: "a0"
                            };
                            Object.keys(ct).forEach(function(t1) {
                                a[t1] = n.def(i, ".", t1);
                            });
                            var o = t1.next = {}, s = t1.current = {};
                            Object.keys(lt).forEach(function(t1) {
                                Array.isArray(it[t1]) && (o[t1] = n.def(a.next, ".", t1), s[t1] = n.def(a.current, ".", t1));
                            });
                            var l = t1.constants = {};
                            Object.keys(ut).forEach(function(t1) {
                                l[t1] = n.def(JSON.stringify(ut[t1]));
                            }), t1.invoke = function(e1, n) {
                                switch(n.type){
                                    case 0:
                                        var i = [
                                            "this",
                                            a.context,
                                            a.props,
                                            t1.batchId
                                        ];
                                        return e1.def(r(n.data), ".call(", i.slice(0, Math.max(n.data.length + 1, 4)), ")");
                                    case 1:
                                        return e1.def(a.props, n.data);
                                    case 2:
                                        return e1.def(a.context, n.data);
                                    case 3:
                                        return e1.def("this", n.data);
                                    case 4:
                                        return n.data.append(t1, e1), n.data.ref;
                                    case 5:
                                        return n.data.toString();
                                    case 6:
                                        return n.data.map(function(r) {
                                            return t1.invoke(e1, r);
                                        });
                                }
                            }, t1.attribCache = {};
                            var c = {};
                            return t1.scopeAttrib = function(t1) {
                                if ((t1 = e1.id(t1)) in c) return c[t1];
                                var n = u.scope[t1];
                                return n || (n = u.scope[t1] = new Q), c[t1] = r(n);
                            }, t1;
                        }
                        function _(t1, e1) {
                            var r = t1.static, n = t1.dynamic;
                            if ("framebuffer" in r) {
                                var i = r.framebuffer;
                                return i ? (i = l.getFramebuffer(i), R(function(t1, e1) {
                                    var r = t1.link(i), n = t1.shared;
                                    return e1.set(n.framebuffer, ".next", r), n = n.context, e1.set(n, ".framebufferWidth", r + ".width"), e1.set(n, ".framebufferHeight", r + ".height"), r;
                                })) : R(function(t1, e1) {
                                    var r = t1.shared;
                                    return e1.set(r.framebuffer, ".next", "null"), r = r.context, e1.set(r, ".framebufferWidth", r + ".drawingBufferWidth"), e1.set(r, ".framebufferHeight", r + ".drawingBufferHeight"), "null";
                                });
                            }
                            if ("framebuffer" in n) {
                                var a = n.framebuffer;
                                return F(a, function(t1, e1) {
                                    var r = t1.invoke(e1, a), n = t1.shared, i = n.framebuffer;
                                    r = e1.def(i, ".getFramebuffer(", r, ")");
                                    return e1.set(i, ".next", r), n = n.context, e1.set(n, ".framebufferWidth", r + "?" + r + ".width:" + n + ".drawingBufferWidth"), e1.set(n, ".framebufferHeight", r + "?" + r + ".height:" + n + ".drawingBufferHeight"), r;
                                });
                            }
                            return null;
                        }
                        function w(t1, r, n) {
                            function i(t1) {
                                if (t1 in a) {
                                    var r = e1.id(a[t1]);
                                    return (t1 = R(function() {
                                        return r;
                                    })).id = r, t1;
                                }
                                if (t1 in o) {
                                    var n = o[t1];
                                    return F(n, function(t1, e1) {
                                        var r = t1.invoke(e1, n);
                                        return e1.def(t1.shared.strings, ".id(", r, ")");
                                    });
                                }
                                return null;
                            }
                            var a = t1.static, o = t1.dynamic, s = i("frag"), l = i("vert"), c = null;
                            return D(s) && D(l) ? (c = f.program(l.id, s.id, null, n), t1 = R(function(t1, e1) {
                                return t1.link(c);
                            })) : t1 = new z(s && s.thisDep || l && l.thisDep, s && s.contextDep || l && l.contextDep, s && s.propDep || l && l.propDep, function(t1, e1) {
                                var r, n, i = t1.shared.shader;
                                return r = s ? s.append(t1, e1) : e1.def(i, ".", "frag"), n = l ? l.append(t1, e1) : e1.def(i, ".", "vert"), e1.def(i + ".program(" + n + "," + r + ")");
                            }), {
                                frag: s,
                                vert: l,
                                progVar: t1,
                                program: c
                            };
                        }
                        function T(t1, e1) {
                            function r(t1, e1) {
                                if (t1 in n) {
                                    var r = 0 | n[t1];
                                    return e1 ? a.offset = r : a.instances = r, R(function(t1, n) {
                                        return e1 && (t1.OFFSET = r), r;
                                    });
                                }
                                if (t1 in i) {
                                    var o = i[t1];
                                    return F(o, function(t1, r) {
                                        var n = t1.invoke(r, o);
                                        return e1 && (t1.OFFSET = n), n;
                                    });
                                }
                                if (e1) {
                                    if (c) return R(function(t1, e1) {
                                        return t1.OFFSET = 0;
                                    });
                                    if (s) return new z(l.thisDep, l.contextDep, l.propDep, function(t1, e1) {
                                        return e1.def(t1.shared.vao + ".currentVAO?" + t1.shared.vao + ".currentVAO.offset:0");
                                    });
                                } else if (s) return new z(l.thisDep, l.contextDep, l.propDep, function(t1, e1) {
                                    return e1.def(t1.shared.vao + ".currentVAO?" + t1.shared.vao + ".currentVAO.instances:-1");
                                });
                                return null;
                            }
                            var n = t1.static, i = t1.dynamic, a = {}, s = !1, l = function() {
                                if ("vao" in n) {
                                    var t1 = n.vao;
                                    return null !== t1 && null === u.getVAO(t1) && (t1 = u.createVAO(t1)), s = !0, a.vao = t1, R(function(e1) {
                                        var r = u.getVAO(t1);
                                        return r ? e1.link(r) : "null";
                                    });
                                }
                                if ("vao" in i) {
                                    s = !0;
                                    var e1 = i.vao;
                                    return F(e1, function(t1, r) {
                                        var n = t1.invoke(r, e1);
                                        return r.def(t1.shared.vao + ".getVAO(" + n + ")");
                                    });
                                }
                                return null;
                            }(), c = !1, f = function() {
                                if ("elements" in n) {
                                    var t1 = n.elements;
                                    if (a.elements = t1, I(t1)) {
                                        var e1 = a.elements = o.create(t1, !0);
                                        t1 = o.getElements(e1);
                                        c = !0;
                                    } else t1 && (t1 = o.getElements(t1), c = !0);
                                    return (e1 = R(function(e1, r) {
                                        if (t1) {
                                            var n = e1.link(t1);
                                            return e1.ELEMENTS = n;
                                        }
                                        return e1.ELEMENTS = null;
                                    })).value = t1, e1;
                                }
                                if ("elements" in i) {
                                    c = !0;
                                    var r = i.elements;
                                    return F(r, function(t1, e1) {
                                        var n = (i = t1.shared).isBufferArgs, i = i.elements, a = t1.invoke(e1, r), o = e1.def("null");
                                        n = e1.def(n, "(", a, ")"), a = t1.cond(n).then(o, "=", i, ".createStream(", a, ");").else(o, "=", i, ".getElements(", a, ");");
                                        return e1.entry(a), e1.exit(t1.cond(n).then(i, ".destroyStream(", o, ");")), t1.ELEMENTS = o;
                                    });
                                }
                                return s ? new z(l.thisDep, l.contextDep, l.propDep, function(t1, e1) {
                                    return e1.def(t1.shared.vao + ".currentVAO?" + t1.shared.elements + ".getElements(" + t1.shared.vao + ".currentVAO.elements):null");
                                }) : null;
                            }(), h = r("offset", !0), p = function() {
                                if ("primitive" in n) {
                                    var t1 = n.primitive;
                                    return a.primitive = t1, R(function(e1, r) {
                                        return rt[t1];
                                    });
                                }
                                if ("primitive" in i) {
                                    var e1 = i.primitive;
                                    return F(e1, function(t1, r) {
                                        var n = t1.constants.primTypes, i = t1.invoke(r, e1);
                                        return r.def(n, "[", i, "]");
                                    });
                                }
                                return c ? D(f) ? f.value ? R(function(t1, e1) {
                                    return e1.def(t1.ELEMENTS, ".primType");
                                }) : R(function() {
                                    return 4;
                                }) : new z(f.thisDep, f.contextDep, f.propDep, function(t1, e1) {
                                    var r = t1.ELEMENTS;
                                    return e1.def(r, "?", r, ".primType:", 4);
                                }) : s ? new z(l.thisDep, l.contextDep, l.propDep, function(t1, e1) {
                                    return e1.def(t1.shared.vao + ".currentVAO?" + t1.shared.vao + ".currentVAO.primitive:4");
                                }) : null;
                            }(), d = function() {
                                if ("count" in n) {
                                    var t1 = 0 | n.count;
                                    return a.count = t1, R(function() {
                                        return t1;
                                    });
                                }
                                if ("count" in i) {
                                    var e1 = i.count;
                                    return F(e1, function(t1, r) {
                                        return t1.invoke(r, e1);
                                    });
                                }
                                return c ? D(f) ? f ? h ? new z(h.thisDep, h.contextDep, h.propDep, function(t1, e1) {
                                    return e1.def(t1.ELEMENTS, ".vertCount-", t1.OFFSET);
                                }) : R(function(t1, e1) {
                                    return e1.def(t1.ELEMENTS, ".vertCount");
                                }) : R(function() {
                                    return -1;
                                }) : new z(f.thisDep || h.thisDep, f.contextDep || h.contextDep, f.propDep || h.propDep, function(t1, e1) {
                                    var r = t1.ELEMENTS;
                                    return t1.OFFSET ? e1.def(r, "?", r, ".vertCount-", t1.OFFSET, ":-1") : e1.def(r, "?", r, ".vertCount:-1");
                                }) : s ? new z(l.thisDep, l.contextDep, l.propDep, function(t1, e1) {
                                    return e1.def(t1.shared.vao, ".currentVAO?", t1.shared.vao, ".currentVAO.count:-1");
                                }) : null;
                            }(), m = r("instances", !1);
                            return {
                                elements: f,
                                primitive: p,
                                count: d,
                                instances: m,
                                offset: h,
                                vao: l,
                                vaoActive: s,
                                elementsActive: c,
                                static: a
                            };
                        }
                        function k(t1, r) {
                            var n = t1.static, a = t1.dynamic, o = {};
                            return Object.keys(n).forEach(function(t1) {
                                var r = n[t1], a = e1.id(t1), s = new Q;
                                if (I(r)) s.state = 1, s.buffer = i.getBuffer(i.create(r, 34962, !1, !0)), s.type = 0;
                                else if (c = i.getBuffer(r)) s.state = 1, s.buffer = c, s.type = 0;
                                else if ("constant" in r) {
                                    var l = r.constant;
                                    s.buffer = "null", s.state = 2, "number" == typeof l ? s.x = l : _t.forEach(function(t1, e1) {
                                        e1 < l.length && (s[t1] = l[e1]);
                                    });
                                } else {
                                    var c = I(r.buffer) ? i.getBuffer(i.create(r.buffer, 34962, !1, !0)) : i.getBuffer(r.buffer), u = 0 | r.offset, f = 0 | r.stride, h = 0 | r.size, p = !!r.normalized, d = 0;
                                    "type" in r && (d = K[r.type]), r = 0 | r.divisor, s.buffer = c, s.state = 1, s.size = h, s.normalized = p, s.type = d || c.dtype, s.offset = u, s.stride = f, s.divisor = r;
                                }
                                o[t1] = R(function(t1, e1) {
                                    var r = t1.attribCache;
                                    if (a in r) return r[a];
                                    var n = {
                                        isStream: !1
                                    };
                                    return Object.keys(s).forEach(function(t1) {
                                        n[t1] = s[t1];
                                    }), s.buffer && (n.buffer = t1.link(s.buffer), n.type = n.type || n.buffer + ".dtype"), r[a] = n;
                                });
                            }), Object.keys(a).forEach(function(t1) {
                                var e1 = a[t1];
                                o[t1] = F(e1, function(t1, r) {
                                    function n(t1) {
                                        r(l[t1], "=", i, ".", t1, "|0;");
                                    }
                                    var i = t1.invoke(r, e1), a = t1.shared, o = t1.constants, s = a.isBufferArgs, l = (a = a.buffer, {
                                        isStream: r.def(!1)
                                    }), c = new Q;
                                    c.state = 1, Object.keys(c).forEach(function(t1) {
                                        l[t1] = r.def("" + c[t1]);
                                    });
                                    var u = l.buffer, f = l.type;
                                    return r("if(", s, "(", i, ")){", l.isStream, "=true;", u, "=", a, ".createStream(", 34962, ",", i, ");", f, "=", u, ".dtype;", "}else{", u, "=", a, ".getBuffer(", i, ");", "if(", u, "){", f, "=", u, ".dtype;", '}else if("constant" in ', i, "){", l.state, "=", 2, ";", "if(typeof " + i + '.constant === "number"){', l[_t[0]], "=", i, ".constant;", _t.slice(1).map(function(t1) {
                                        return l[t1];
                                    }).join("="), "=0;", "}else{", _t.map(function(t1, e1) {
                                        return l[t1] + "=" + i + ".constant.length>" + e1 + "?" + i + ".constant[" + e1 + "]:0;";
                                    }).join(""), "}}else{", "if(", s, "(", i, ".buffer)){", u, "=", a, ".createStream(", 34962, ",", i, ".buffer);", "}else{", u, "=", a, ".getBuffer(", i, ".buffer);", "}", f, '="type" in ', i, "?", o.glTypes, "[", i, ".type]:", u, ".dtype;", l.normalized, "=!!", i, ".normalized;"), n("size"), n("offset"), n("stride"), n("divisor"), r("}}"), r.exit("if(", l.isStream, "){", a, ".destroyStream(", u, ");", "}"), l;
                                });
                            }), o;
                        }
                        function A(t1, e1, n, i, o) {
                            function s(t1) {
                                var e1 = c[t1];
                                e1 && (h[t1] = e1);
                            }
                            var l = function(t1, e1) {
                                if ("string" == typeof (r = t1.static).frag && "string" == typeof r.vert) {
                                    if (0 < Object.keys(e1.dynamic).length) return null;
                                    var r = e1.static, n = Object.keys(r);
                                    if (0 < n.length && "number" == typeof r[n[0]]) {
                                        for(var i = [], a = 0; a < n.length; ++a)i.push([
                                            0 | r[n[a]],
                                            n[a]
                                        ]);
                                        return i;
                                    }
                                }
                                return null;
                            }(t1, e1), c = function(t1, e1, r) {
                                function n(t1) {
                                    if (t1 in i) {
                                        var r = i[t1];
                                        t1 = !0;
                                        var n, o, s = 0 | r.x, l = 0 | r.y;
                                        return "width" in r ? n = 0 | r.width : t1 = !1, "height" in r ? o = 0 | r.height : t1 = !1, new z(!t1 && e1 && e1.thisDep, !t1 && e1 && e1.contextDep, !t1 && e1 && e1.propDep, function(t1, e1) {
                                            var i = t1.shared.context, a = n;
                                            "width" in r || (a = e1.def(i, ".", "framebufferWidth", "-", s));
                                            var c = o;
                                            return "height" in r || (c = e1.def(i, ".", "framebufferHeight", "-", l)), [
                                                s,
                                                l,
                                                a,
                                                c
                                            ];
                                        });
                                    }
                                    if (t1 in a) {
                                        var c = a[t1];
                                        return t1 = F(c, function(t1, e1) {
                                            var r = t1.invoke(e1, c), n = t1.shared.context, i = e1.def(r, ".x|0"), a = e1.def(r, ".y|0");
                                            return [
                                                i,
                                                a,
                                                e1.def('"width" in ', r, "?", r, ".width|0:", "(", n, ".", "framebufferWidth", "-", i, ")"),
                                                r = e1.def('"height" in ', r, "?", r, ".height|0:", "(", n, ".", "framebufferHeight", "-", a, ")")
                                            ];
                                        }), e1 && (t1.thisDep = t1.thisDep || e1.thisDep, t1.contextDep = t1.contextDep || e1.contextDep, t1.propDep = t1.propDep || e1.propDep), t1;
                                    }
                                    return e1 ? new z(e1.thisDep, e1.contextDep, e1.propDep, function(t1, e1) {
                                        var r = t1.shared.context;
                                        return [
                                            0,
                                            0,
                                            e1.def(r, ".", "framebufferWidth"),
                                            e1.def(r, ".", "framebufferHeight")
                                        ];
                                    }) : null;
                                }
                                var i = t1.static, a = t1.dynamic;
                                if (t1 = n("viewport")) {
                                    var o = t1;
                                    t1 = new z(t1.thisDep, t1.contextDep, t1.propDep, function(t1, e1) {
                                        var r = o.append(t1, e1), n = t1.shared.context;
                                        return e1.set(n, ".viewportWidth", r[2]), e1.set(n, ".viewportHeight", r[3]), r;
                                    });
                                }
                                return {
                                    viewport: t1,
                                    scissor_box: n("scissor.box")
                                };
                            }(t1, d = _(t1)), f = T(t1), h = function(t1, e1) {
                                var r = t1.static, n = t1.dynamic, i = {};
                                return ot.forEach(function(t1) {
                                    function e1(e1, a) {
                                        if (t1 in r) {
                                            var s = e1(r[t1]);
                                            i[o] = R(function() {
                                                return s;
                                            });
                                        } else if (t1 in n) {
                                            var l = n[t1];
                                            i[o] = F(l, function(t1, e1) {
                                                return a(t1, e1, t1.invoke(e1, l));
                                            });
                                        }
                                    }
                                    var o = v(t1);
                                    switch(t1){
                                        case "cull.enable":
                                        case "blend.enable":
                                        case "dither":
                                        case "stencil.enable":
                                        case "depth.enable":
                                        case "scissor.enable":
                                        case "polygonOffset.enable":
                                        case "sample.alpha":
                                        case "sample.enable":
                                        case "depth.mask":
                                            return e1(function(t1) {
                                                return t1;
                                            }, function(t1, e1, r) {
                                                return r;
                                            });
                                        case "depth.func":
                                            return e1(function(t1) {
                                                return kt[t1];
                                            }, function(t1, e1, r) {
                                                return e1.def(t1.constants.compareFuncs, "[", r, "]");
                                            });
                                        case "depth.range":
                                            return e1(function(t1) {
                                                return t1;
                                            }, function(t1, e1, r) {
                                                return [
                                                    e1.def("+", r, "[0]"),
                                                    e1 = e1.def("+", r, "[1]")
                                                ];
                                            });
                                        case "blend.func":
                                            return e1(function(t1) {
                                                return [
                                                    Tt["srcRGB" in t1 ? t1.srcRGB : t1.src],
                                                    Tt["dstRGB" in t1 ? t1.dstRGB : t1.dst],
                                                    Tt["srcAlpha" in t1 ? t1.srcAlpha : t1.src],
                                                    Tt["dstAlpha" in t1 ? t1.dstAlpha : t1.dst]
                                                ];
                                            }, function(t1, e1, r) {
                                                function n(t1, n) {
                                                    return e1.def('"', t1, n, '" in ', r, "?", r, ".", t1, n, ":", r, ".", t1);
                                                }
                                                t1 = t1.constants.blendFuncs;
                                                var i = n("src", "RGB"), a = n("dst", "RGB"), o = (i = e1.def(t1, "[", i, "]"), e1.def(t1, "[", n("src", "Alpha"), "]"));
                                                return [
                                                    i,
                                                    a = e1.def(t1, "[", a, "]"),
                                                    o,
                                                    t1 = e1.def(t1, "[", n("dst", "Alpha"), "]")
                                                ];
                                            });
                                        case "blend.equation":
                                            return e1(function(t1) {
                                                return "string" == typeof t1 ? [
                                                    $[t1],
                                                    $[t1]
                                                ] : "object" == typeof t1 ? [
                                                    $[t1.rgb],
                                                    $[t1.alpha]
                                                ] : void 0;
                                            }, function(t1, e1, r) {
                                                var n = t1.constants.blendEquations, i = e1.def(), a = e1.def();
                                                return (t1 = t1.cond("typeof ", r, '==="string"')).then(i, "=", a, "=", n, "[", r, "];"), t1.else(i, "=", n, "[", r, ".rgb];", a, "=", n, "[", r, ".alpha];"), e1(t1), [
                                                    i,
                                                    a
                                                ];
                                            });
                                        case "blend.color":
                                            return e1(function(t1) {
                                                return a(4, function(e1) {
                                                    return +t1[e1];
                                                });
                                            }, function(t1, e1, r) {
                                                return a(4, function(t1) {
                                                    return e1.def("+", r, "[", t1, "]");
                                                });
                                            });
                                        case "stencil.mask":
                                            return e1(function(t1) {
                                                return 0 | t1;
                                            }, function(t1, e1, r) {
                                                return e1.def(r, "|0");
                                            });
                                        case "stencil.func":
                                            return e1(function(t1) {
                                                return [
                                                    kt[t1.cmp || "keep"],
                                                    t1.ref || 0,
                                                    "mask" in t1 ? t1.mask : -1
                                                ];
                                            }, function(t1, e1, r) {
                                                return [
                                                    t1 = e1.def('"cmp" in ', r, "?", t1.constants.compareFuncs, "[", r, ".cmp]", ":", 7680),
                                                    e1.def(r, ".ref|0"),
                                                    e1 = e1.def('"mask" in ', r, "?", r, ".mask|0:-1")
                                                ];
                                            });
                                        case "stencil.opFront":
                                        case "stencil.opBack":
                                            return e1(function(e1) {
                                                return [
                                                    "stencil.opBack" === t1 ? 1029 : 1028,
                                                    At[e1.fail || "keep"],
                                                    At[e1.zfail || "keep"],
                                                    At[e1.zpass || "keep"]
                                                ];
                                            }, function(e1, r, n) {
                                                function i(t1) {
                                                    return r.def('"', t1, '" in ', n, "?", a, "[", n, ".", t1, "]:", 7680);
                                                }
                                                var a = e1.constants.stencilOps;
                                                return [
                                                    "stencil.opBack" === t1 ? 1029 : 1028,
                                                    i("fail"),
                                                    i("zfail"),
                                                    i("zpass")
                                                ];
                                            });
                                        case "polygonOffset.offset":
                                            return e1(function(t1) {
                                                return [
                                                    0 | t1.factor,
                                                    0 | t1.units
                                                ];
                                            }, function(t1, e1, r) {
                                                return [
                                                    e1.def(r, ".factor|0"),
                                                    e1 = e1.def(r, ".units|0")
                                                ];
                                            });
                                        case "cull.face":
                                            return e1(function(t1) {
                                                var e1 = 0;
                                                return "front" === t1 ? e1 = 1028 : "back" === t1 && (e1 = 1029), e1;
                                            }, function(t1, e1, r) {
                                                return e1.def(r, '==="front"?', 1028, ":", 1029);
                                            });
                                        case "lineWidth":
                                            return e1(function(t1) {
                                                return t1;
                                            }, function(t1, e1, r) {
                                                return r;
                                            });
                                        case "frontFace":
                                            return e1(function(t1) {
                                                return Mt[t1];
                                            }, function(t1, e1, r) {
                                                return e1.def(r + '==="cw"?2304:2305');
                                            });
                                        case "colorMask":
                                            return e1(function(t1) {
                                                return t1.map(function(t1) {
                                                    return !!t1;
                                                });
                                            }, function(t1, e1, r) {
                                                return a(4, function(t1) {
                                                    return "!!" + r + "[" + t1 + "]";
                                                });
                                            });
                                        case "sample.coverage":
                                            return e1(function(t1) {
                                                return [
                                                    "value" in t1 ? t1.value : 1,
                                                    !!t1.invert
                                                ];
                                            }, function(t1, e1, r) {
                                                return [
                                                    e1.def('"value" in ', r, "?+", r, ".value:1"),
                                                    e1 = e1.def("!!", r, ".invert")
                                                ];
                                            });
                                    }
                                }), i;
                            }(t1), p = w(t1, 0, l);
                            s("viewport"), s(v("scissor.box"));
                            var d, m = 0 < Object.keys(h).length;
                            if ((d = {
                                framebuffer: d,
                                draw: f,
                                shader: p,
                                state: h,
                                dirty: m,
                                scopeVAO: null,
                                drawVAO: null,
                                useVAO: !1,
                                attributes: {}
                            }).profile = function(t1) {
                                var e1, r = t1.static;
                                if (t1 = t1.dynamic, "profile" in r) {
                                    var n = !!r.profile;
                                    (e1 = R(function(t1, e1) {
                                        return n;
                                    })).enable = n;
                                } else if ("profile" in t1) {
                                    var i = t1.profile;
                                    e1 = F(i, function(t1, e1) {
                                        return t1.invoke(e1, i);
                                    });
                                }
                                return e1;
                            }(t1), d.uniforms = function(t1, e1) {
                                var r = t1.static, n = t1.dynamic, i = {};
                                return Object.keys(r).forEach(function(t1) {
                                    var e1, n = r[t1];
                                    if ("number" == typeof n || "boolean" == typeof n) e1 = R(function() {
                                        return n;
                                    });
                                    else if ("function" == typeof n) {
                                        var o = n._reglType;
                                        "texture2d" === o || "textureCube" === o ? e1 = R(function(t1) {
                                            return t1.link(n);
                                        }) : "framebuffer" !== o && "framebufferCube" !== o || (e1 = R(function(t1) {
                                            return t1.link(n.color[0]);
                                        }));
                                    } else g(n) && (e1 = R(function(t1) {
                                        return t1.global.def("[", a(n.length, function(t1) {
                                            return n[t1];
                                        }), "]");
                                    }));
                                    e1.value = n, i[t1] = e1;
                                }), Object.keys(n).forEach(function(t1) {
                                    var e1 = n[t1];
                                    i[t1] = F(e1, function(t1, r) {
                                        return t1.invoke(r, e1);
                                    });
                                }), i;
                            }(n), d.drawVAO = d.scopeVAO = f.vao, !d.drawVAO && p.program && !l && r.angle_instanced_arrays && f.static.elements) {
                                var y = !0;
                                if (t1 = p.program.attributes.map(function(t1) {
                                    return t1 = e1.static[t1], y = y && !!t1, t1;
                                }), y && 0 < t1.length) {
                                    var x = u.getVAO(u.createVAO({
                                        attributes: t1,
                                        elements: f.static.elements
                                    }));
                                    d.drawVAO = new z(null, null, null, function(t1, e1) {
                                        return t1.link(x);
                                    }), d.useVAO = !0;
                                }
                            }
                            return l ? d.useVAO = !0 : d.attributes = k(e1), d.context = function(t1) {
                                var e1 = t1.static, r = t1.dynamic, n = {};
                                return Object.keys(e1).forEach(function(t1) {
                                    var r = e1[t1];
                                    n[t1] = R(function(t1, e1) {
                                        return "number" == typeof r || "boolean" == typeof r ? "" + r : t1.link(r);
                                    });
                                }), Object.keys(r).forEach(function(t1) {
                                    var e1 = r[t1];
                                    n[t1] = F(e1, function(t1, r) {
                                        return t1.invoke(r, e1);
                                    });
                                }), n;
                            }(i), d;
                        }
                        function M(t1, e1, r) {
                            var n = t1.shared.context, i = t1.scope();
                            Object.keys(r).forEach(function(a) {
                                e1.save(n, "." + a);
                                var o = r[a].append(t1, e1);
                                Array.isArray(o) ? i(n, ".", a, "=[", o.join(), "];") : i(n, ".", a, "=", o, ";");
                            }), e1(i);
                        }
                        function S(t1, e1, r, n) {
                            var i, a = (s = t1.shared).gl, o = s.framebuffer;
                            et && (i = e1.def(s.extensions, ".webgl_draw_buffers"));
                            var s = (l = t1.constants).drawBuffer, l = l.backBuffer;
                            t1 = r ? r.append(t1, e1) : e1.def(o, ".next"), n || e1("if(", t1, "!==", o, ".cur){"), e1("if(", t1, "){", a, ".bindFramebuffer(", 36160, ",", t1, ".framebuffer);"), et && e1(i, ".drawBuffersWEBGL(", s, "[", t1, ".colorAttachments.length]);"), e1("}else{", a, ".bindFramebuffer(", 36160, ",null);"), et && e1(i, ".drawBuffersWEBGL(", l, ");"), e1("}", o, ".cur=", t1, ";"), n || e1("}");
                        }
                        function E(t1, e1, r) {
                            var n = t1.shared, i = n.gl, o = t1.current, s = t1.next, l = n.current, c = n.next, u = t1.cond(l, ".dirty");
                            ot.forEach(function(e1) {
                                var n, f;
                                if (!((e1 = v(e1)) in r.state)) {
                                    if (e1 in s) {
                                        n = s[e1], f = o[e1];
                                        var h = a(it[e1].length, function(t1) {
                                            return u.def(n, "[", t1, "]");
                                        });
                                        u(t1.cond(h.map(function(t1, e1) {
                                            return t1 + "!==" + f + "[" + e1 + "]";
                                        }).join("||")).then(i, ".", lt[e1], "(", h, ");", h.map(function(t1, e1) {
                                            return f + "[" + e1 + "]=" + t1;
                                        }).join(";"), ";"));
                                    } else n = u.def(c, ".", e1), h = t1.cond(n, "!==", l, ".", e1), u(h), e1 in st ? h(t1.cond(n).then(i, ".enable(", st[e1], ");").else(i, ".disable(", st[e1], ");"), l, ".", e1, "=", n, ";") : h(i, ".", lt[e1], "(", n, ");", l, ".", e1, "=", n, ";");
                                }
                            }), 0 === Object.keys(r.state).length && u(l, ".dirty=false;"), e1(u);
                        }
                        function L(t1, e1, r, n) {
                            var i = t1.shared, a = t1.current, o = i.current, s = i.gl;
                            O(Object.keys(r)).forEach(function(i) {
                                var l = r[i];
                                if (!n || n(l)) {
                                    var c = l.append(t1, e1);
                                    if (st[i]) {
                                        var u = st[i];
                                        D(l) ? e1(s, c ? ".enable(" : ".disable(", u, ");") : e1(t1.cond(c).then(s, ".enable(", u, ");").else(s, ".disable(", u, ");")), e1(o, ".", i, "=", c, ";");
                                    } else if (g(c)) {
                                        var f = a[i];
                                        e1(s, ".", lt[i], "(", c, ");", c.map(function(t1, e1) {
                                            return f + "[" + e1 + "]=" + t1;
                                        }).join(";"), ";");
                                    } else e1(s, ".", lt[i], "(", c, ");", o, ".", i, "=", c, ";");
                                }
                            });
                        }
                        function B(t1, e1) {
                            tt && (t1.instancing = e1.def(t1.shared.extensions, ".angle_instanced_arrays"));
                        }
                        function N(t1, e1, r, n, i) {
                            function a() {
                                return "undefined" == typeof performance ? "Date.now()" : "performance.now()";
                            }
                            function o(t1) {
                                t1(c = e1.def(), "=", a(), ";"), "string" == typeof i ? t1(h, ".count+=", i, ";") : t1(h, ".count++;"), d && (n ? t1(u = e1.def(), "=", m, ".getNumPendingQueries();") : t1(m, ".beginQuery(", h, ");"));
                            }
                            function s(t1) {
                                t1(h, ".cpuTime+=", a(), "-", c, ";"), d && (n ? t1(m, ".pushScopeStats(", u, ",", m, ".getNumPendingQueries(),", h, ");") : t1(m, ".endQuery();"));
                            }
                            function l(t1) {
                                var r = e1.def(p, ".profile");
                                e1(p, ".profile=", t1, ";"), e1.exit(p, ".profile=", r, ";");
                            }
                            var c, u, f = t1.shared, h = t1.stats, p = f.current, m = f.timer;
                            if (r = r.profile) {
                                if (D(r)) return void (r.enable ? (o(e1), s(e1.exit), l("true")) : l("false"));
                                l(r = r.append(t1, e1));
                            } else r = e1.def(p, ".profile");
                            o(f = t1.block()), e1("if(", r, "){", f, "}"), s(t1 = t1.block()), e1.exit("if(", r, "){", t1, "}");
                        }
                        function U(t1, e1, r, n, i) {
                            function a(r, n, i) {
                                function a() {
                                    e1("if(!", u, ".buffer){", l, ".enableVertexAttribArray(", c, ");}");
                                    var r, a = i.type;
                                    r = i.size ? e1.def(i.size, "||", n) : n, e1("if(", u, ".type!==", a, "||", u, ".size!==", r, "||", p.map(function(t1) {
                                        return u + "." + t1 + "!==" + i[t1];
                                    }).join("||"), "){", l, ".bindBuffer(", 34962, ",", f, ".buffer);", l, ".vertexAttribPointer(", [
                                        c,
                                        r,
                                        a,
                                        i.normalized,
                                        i.stride,
                                        i.offset
                                    ], ");", u, ".type=", a, ";", u, ".size=", r, ";", p.map(function(t1) {
                                        return u + "." + t1 + "=" + i[t1] + ";";
                                    }).join(""), "}"), tt && (a = i.divisor, e1("if(", u, ".divisor!==", a, "){", t1.instancing, ".vertexAttribDivisorANGLE(", [
                                        c,
                                        a
                                    ], ");", u, ".divisor=", a, ";}"));
                                }
                                function s() {
                                    e1("if(", u, ".buffer){", l, ".disableVertexAttribArray(", c, ");", u, ".buffer=null;", "}if(", _t.map(function(t1, e1) {
                                        return u + "." + t1 + "!==" + h[e1];
                                    }).join("||"), "){", l, ".vertexAttrib4f(", c, ",", h, ");", _t.map(function(t1, e1) {
                                        return u + "." + t1 + "=" + h[e1] + ";";
                                    }).join(""), "}");
                                }
                                var l = o.gl, c = e1.def(r, ".location"), u = e1.def(o.attributes, "[", c, "]");
                                r = i.state;
                                var f = i.buffer, h = [
                                    i.x,
                                    i.y,
                                    i.z,
                                    i.w
                                ], p = [
                                    "buffer",
                                    "normalized",
                                    "offset",
                                    "stride"
                                ];
                                1 === r ? a() : 2 === r ? s() : (e1("if(", r, "===", 1, "){"), a(), e1("}else{"), s(), e1("}"));
                            }
                            var o = t1.shared;
                            n.forEach(function(n) {
                                var o, s = n.name, l = r.attributes[s];
                                if (l) {
                                    if (!i(l)) return;
                                    o = l.append(t1, e1);
                                } else {
                                    if (!i(St)) return;
                                    var c = t1.scopeAttrib(s);
                                    o = {}, Object.keys(new Q).forEach(function(t1) {
                                        o[t1] = e1.def(c, ".", t1);
                                    });
                                }
                                a(t1.link(n), function(t1) {
                                    switch(t1){
                                        case 35664:
                                        case 35667:
                                        case 35671:
                                            return 2;
                                        case 35665:
                                        case 35668:
                                        case 35672:
                                            return 3;
                                        case 35666:
                                        case 35669:
                                        case 35673:
                                            return 4;
                                        default:
                                            return 1;
                                    }
                                }(n.info.type), o);
                            });
                        }
                        function H(t1, r, n, i, o, s) {
                            for(var l, c = t1.shared, u = c.gl, f = {}, h = 0; h < i.length; ++h){
                                var p = (b = i[h]).name, d = b.info.type, m = b.info.size, v = n.uniforms[p];
                                if (1 < m) {
                                    if (!v) continue;
                                    var y = p.replace("[0]", "");
                                    if (f[y]) continue;
                                    f[y] = 1;
                                }
                                var x, b = t1.link(b) + ".location";
                                if (v) {
                                    if (!o(v)) continue;
                                    if (D(v)) {
                                        if (p = v.value, 35678 === d || 35680 === d) r(u, ".uniform1i(", b, ",", (d = t1.link(p._texture || p.color[0]._texture)) + ".bind());"), r.exit(d, ".unbind();");
                                        else if (35674 === d || 35675 === d || 35676 === d) m = t1.global.def("new Float32Array([" + Array.prototype.slice.call(p) + "])"), p = 2, 35675 === d ? p = 3 : 35676 === d && (p = 4), r(u, ".uniformMatrix", p, "fv(", b, ",false,", m, ");");
                                        else {
                                            switch(d){
                                                case 5126:
                                                    l = "1f";
                                                    break;
                                                case 35664:
                                                    l = "2f";
                                                    break;
                                                case 35665:
                                                    l = "3f";
                                                    break;
                                                case 35666:
                                                    l = "4f";
                                                    break;
                                                case 35670:
                                                case 5124:
                                                    l = "1i";
                                                    break;
                                                case 35671:
                                                case 35667:
                                                    l = "2i";
                                                    break;
                                                case 35672:
                                                case 35668:
                                                    l = "3i";
                                                    break;
                                                case 35673:
                                                    l = "4i";
                                                    break;
                                                case 35669:
                                                    l = "4i";
                                            }
                                            1 < m ? (l += "v", p = t1.global.def("[" + Array.prototype.slice.call(p) + "]")) : p = g(p) ? Array.prototype.slice.call(p) : p, r(u, ".uniform", l, "(", b, ",", p, ");");
                                        }
                                        continue;
                                    }
                                    x = v.append(t1, r);
                                } else {
                                    if (!o(St)) continue;
                                    x = r.def(c.uniforms, "[", e1.id(p), "]");
                                }
                                switch(35678 === d ? r("if(", x, "&&", x, '._reglType==="framebuffer"){', x, "=", x, ".color[0];", "}") : 35680 === d && r("if(", x, "&&", x, '._reglType==="framebufferCube"){', x, "=", x, ".color[0];", "}"), p = 1, d){
                                    case 35678:
                                    case 35680:
                                        d = r.def(x, "._texture"), r(u, ".uniform1i(", b, ",", d, ".bind());"), r.exit(d, ".unbind();");
                                        continue;
                                    case 5124:
                                    case 35670:
                                        l = "1i";
                                        break;
                                    case 35667:
                                    case 35671:
                                        l = "2i", p = 2;
                                        break;
                                    case 35668:
                                    case 35672:
                                        l = "3i", p = 3;
                                        break;
                                    case 35669:
                                    case 35673:
                                        l = "4i", p = 4;
                                        break;
                                    case 5126:
                                        l = "1f";
                                        break;
                                    case 35664:
                                        l = "2f", p = 2;
                                        break;
                                    case 35665:
                                        l = "3f", p = 3;
                                        break;
                                    case 35666:
                                        l = "4f", p = 4;
                                        break;
                                    case 35674:
                                        l = "Matrix2fv";
                                        break;
                                    case 35675:
                                        l = "Matrix3fv";
                                        break;
                                    case 35676:
                                        l = "Matrix4fv";
                                }
                                if (-1 === l.indexOf("Matrix") && 1 < m && (l += "v", p = 1), "M" === l.charAt(0)) {
                                    r(u, ".uniform", l, "(", b, ",");
                                    b = Math.pow(d - 35674 + 2, 2);
                                    var _ = t1.global.def("new Float32Array(", b, ")");
                                    Array.isArray(x) ? r("false,(", a(b, function(t1) {
                                        return _ + "[" + t1 + "]=" + x[t1];
                                    }), ",", _, ")") : r("false,(Array.isArray(", x, ")||", x, " instanceof Float32Array)?", x, ":(", a(b, function(t1) {
                                        return _ + "[" + t1 + "]=" + x + "[" + t1 + "]";
                                    }), ",", _, ")"), r(");");
                                } else {
                                    if (1 < p) {
                                        d = [];
                                        var w = [];
                                        for(m = 0; m < p; ++m)Array.isArray(x) ? w.push(x[m]) : w.push(r.def(x + "[" + m + "]")), s && d.push(r.def());
                                        s && r("if(!", t1.batchId, "||", d.map(function(t1, e1) {
                                            return t1 + "!==" + w[e1];
                                        }).join("||"), "){", d.map(function(t1, e1) {
                                            return t1 + "=" + w[e1] + ";";
                                        }).join("")), r(u, ".uniform", l, "(", b, ",", w.join(","), ");");
                                    } else s && (d = r.def(), r("if(!", t1.batchId, "||", d, "!==", x, "){", d, "=", x, ";")), r(u, ".uniform", l, "(", b, ",", x, ");");
                                    s && r("}");
                                }
                            }
                        }
                        function q(t1, e1, r, n) {
                            function i(i) {
                                var a = h[i];
                                return a ? a.contextDep && n.contextDynamic || a.propDep ? a.append(t1, r) : a.append(t1, e1) : e1.def(f, ".", i);
                            }
                            function a() {
                                function t1() {
                                    r(l, ".drawElementsInstancedANGLE(", [
                                        d,
                                        g,
                                        v,
                                        m + "<<((" + v + "-5121)>>1)",
                                        s
                                    ], ");");
                                }
                                function e1() {
                                    r(l, ".drawArraysInstancedANGLE(", [
                                        d,
                                        m,
                                        g,
                                        s
                                    ], ");");
                                }
                                p && "null" !== p ? y ? t1() : (r("if(", p, "){"), t1(), r("}else{"), e1(), r("}")) : e1();
                            }
                            function o() {
                                function t1() {
                                    r(u + ".drawElements(" + [
                                        d,
                                        g,
                                        v,
                                        m + "<<((" + v + "-5121)>>1)"
                                    ] + ");");
                                }
                                function e1() {
                                    r(u + ".drawArrays(" + [
                                        d,
                                        m,
                                        g
                                    ] + ");");
                                }
                                p && "null" !== p ? y ? t1() : (r("if(", p, "){"), t1(), r("}else{"), e1(), r("}")) : e1();
                            }
                            var s, l, c = t1.shared, u = c.gl, f = c.draw, h = n.draw, p = function() {
                                var i = h.elements, a = e1;
                                return i ? ((i.contextDep && n.contextDynamic || i.propDep) && (a = r), i = i.append(t1, a), h.elementsActive && a("if(" + i + ")" + u + ".bindBuffer(34963," + i + ".buffer.buffer);")) : (i = a.def(), a(i, "=", f, ".", "elements", ";", "if(", i, "){", u, ".bindBuffer(", 34963, ",", i, ".buffer.buffer);}", "else if(", c.vao, ".currentVAO){", i, "=", t1.shared.elements + ".getElements(" + c.vao, ".currentVAO.elements);", nt ? "" : "if(" + i + ")" + u + ".bindBuffer(34963," + i + ".buffer.buffer);", "}")), i;
                            }(), d = i("primitive"), m = i("offset"), g = function() {
                                var i = h.count, a = e1;
                                return i ? ((i.contextDep && n.contextDynamic || i.propDep) && (a = r), i = i.append(t1, a)) : i = a.def(f, ".", "count"), i;
                            }();
                            if ("number" == typeof g) {
                                if (0 === g) return;
                            } else r("if(", g, "){"), r.exit("}");
                            tt && (s = i("instances"), l = t1.instancing);
                            var v = p + ".type", y = h.elements && D(h.elements) && !h.vaoActive;
                            tt && ("number" != typeof s || 0 <= s) ? "string" == typeof s ? (r("if(", s, ">0){"), a(), r("}else if(", s, "<0){"), o(), r("}")) : a() : o();
                        }
                        function G(t1, e1, r, n, i) {
                            return i = (e1 = b()).proc("body", i), tt && (e1.instancing = i.def(e1.shared.extensions, ".angle_instanced_arrays")), t1(e1, i, r, n), e1.compile().body;
                        }
                        function Y(t1, e1, r, n) {
                            B(t1, e1), r.useVAO ? r.drawVAO ? e1(t1.shared.vao, ".setVAO(", r.drawVAO.append(t1, e1), ");") : e1(t1.shared.vao, ".setVAO(", t1.shared.vao, ".targetVAO);") : (e1(t1.shared.vao, ".setVAO(null);"), U(t1, e1, r, n.attributes, function() {
                                return !0;
                            })), H(t1, e1, r, n.uniforms, function() {
                                return !0;
                            }, !1), q(t1, e1, e1, r);
                        }
                        function W(t1, e1, r, n) {
                            function i() {
                                return !0;
                            }
                            t1.batchId = "a1", B(t1, e1), U(t1, e1, r, n.attributes, i), H(t1, e1, r, n.uniforms, i, !1), q(t1, e1, e1, r);
                        }
                        function X(t1, e1, r, n) {
                            function i(t1) {
                                return t1.contextDep && o || t1.propDep;
                            }
                            function a(t1) {
                                return !i(t1);
                            }
                            B(t1, e1);
                            var o = r.contextDep, s = e1.def(), l = e1.def();
                            t1.shared.props = l, t1.batchId = s;
                            var c = t1.scope(), u = t1.scope();
                            e1(c.entry, "for(", s, "=0;", s, "<", "a1", ";++", s, "){", l, "=", "a0", "[", s, "];", u, "}", c.exit), r.needsContext && M(t1, u, r.context), r.needsFramebuffer && S(t1, u, r.framebuffer), L(t1, u, r.state, i), r.profile && i(r.profile) && N(t1, u, r, !1, !0), n ? (r.useVAO ? r.drawVAO ? i(r.drawVAO) ? u(t1.shared.vao, ".setVAO(", r.drawVAO.append(t1, u), ");") : c(t1.shared.vao, ".setVAO(", r.drawVAO.append(t1, c), ");") : c(t1.shared.vao, ".setVAO(", t1.shared.vao, ".targetVAO);") : (c(t1.shared.vao, ".setVAO(null);"), U(t1, c, r, n.attributes, a), U(t1, u, r, n.attributes, i)), H(t1, c, r, n.uniforms, a, !1), H(t1, u, r, n.uniforms, i, !0), q(t1, c, u, r)) : (e1 = t1.global.def("{}"), n = r.shader.progVar.append(t1, u), l = u.def(n, ".id"), c = u.def(e1, "[", l, "]"), u(t1.shared.gl, ".useProgram(", n, ".program);", "if(!", c, "){", c, "=", e1, "[", l, "]=", t1.link(function(e1) {
                                return G(W, t1, r, e1, 2);
                            }), "(", n, ");}", c, ".call(this,a0[", s, "],", s, ");"));
                        }
                        function Z(t1, r) {
                            function n(e1) {
                                var n = r.shader[e1];
                                n && i.set(a.shader, "." + e1, n.append(t1, i));
                            }
                            var i = t1.proc("scope", 3);
                            t1.batchId = "a2";
                            var a = t1.shared, o = a.current;
                            M(t1, i, r.context), r.framebuffer && r.framebuffer.append(t1, i), O(Object.keys(r.state)).forEach(function(e1) {
                                var n = r.state[e1].append(t1, i);
                                g(n) ? n.forEach(function(r, n) {
                                    i.set(t1.next[e1], "[" + n + "]", r);
                                }) : i.set(a.next, "." + e1, n);
                            }), N(t1, i, r, !0, !0), [
                                "elements",
                                "offset",
                                "count",
                                "instances",
                                "primitive"
                            ].forEach(function(e1) {
                                var n = r.draw[e1];
                                n && i.set(a.draw, "." + e1, "" + n.append(t1, i));
                            }), Object.keys(r.uniforms).forEach(function(n) {
                                var o = r.uniforms[n].append(t1, i);
                                Array.isArray(o) && (o = "[" + o.join() + "]"), i.set(a.uniforms, "[" + e1.id(n) + "]", o);
                            }), Object.keys(r.attributes).forEach(function(e1) {
                                var n = r.attributes[e1].append(t1, i), a = t1.scopeAttrib(e1);
                                Object.keys(new Q).forEach(function(t1) {
                                    i.set(a, "." + t1, n[t1]);
                                });
                            }), r.scopeVAO && i.set(a.vao, ".targetVAO", r.scopeVAO.append(t1, i)), n("vert"), n("frag"), 0 < Object.keys(r.state).length && (i(o, ".dirty=true;"), i.exit(o, ".dirty=true;")), i("a1(", t1.shared.context, ",a0,", t1.batchId, ");");
                        }
                        function J(t1, e1, r) {
                            var n = e1.static[r];
                            if (n && function(t1) {
                                if ("object" == typeof t1 && !g(t1)) {
                                    for(var e1 = Object.keys(t1), r = 0; r < e1.length; ++r)if (V.isDynamic(t1[e1[r]])) return !0;
                                    return !1;
                                }
                            }(n)) {
                                var i = t1.global, a = Object.keys(n), o = !1, s = !1, l = !1, c = t1.global.def("{}");
                                a.forEach(function(e1) {
                                    var r = n[e1];
                                    if (V.isDynamic(r)) "function" == typeof r && (r = n[e1] = V.unbox(r)), e1 = F(r, null), o = o || e1.thisDep, l = l || e1.propDep, s = s || e1.contextDep;
                                    else {
                                        switch(i(c, ".", e1, "="), typeof r){
                                            case "number":
                                                i(r);
                                                break;
                                            case "string":
                                                i('"', r, '"');
                                                break;
                                            case "object":
                                                Array.isArray(r) && i("[", r.join(), "]");
                                                break;
                                            default:
                                                i(t1.link(r));
                                        }
                                        i(";");
                                    }
                                }), e1.dynamic[r] = new V.DynamicVariable(4, {
                                    thisDep: o,
                                    contextDep: s,
                                    propDep: l,
                                    ref: c,
                                    append: function(t1, e1) {
                                        a.forEach(function(r) {
                                            var i = n[r];
                                            V.isDynamic(i) && (i = t1.invoke(e1, i), e1(c, ".", r, "=", i, ";"));
                                        });
                                    }
                                }), delete e1.static[r];
                            }
                        }
                        var Q = u.Record, $ = {
                            add: 32774,
                            subtract: 32778,
                            "reverse subtract": 32779
                        };
                        r.ext_blend_minmax && ($.min = 32775, $.max = 32776);
                        var tt = r.angle_instanced_arrays, et = r.webgl_draw_buffers, nt = r.oes_vertex_array_object, it = {
                            dirty: !0,
                            profile: m.profile
                        }, at = {}, ot = [], st = {}, lt = {};
                        y("dither", 3024), y("blend.enable", 3042), x("blend.color", "blendColor", [
                            0,
                            0,
                            0,
                            0
                        ]), x("blend.equation", "blendEquationSeparate", [
                            32774,
                            32774
                        ]), x("blend.func", "blendFuncSeparate", [
                            1,
                            0,
                            1,
                            0
                        ]), y("depth.enable", 2929, !0), x("depth.func", "depthFunc", 513), x("depth.range", "depthRange", [
                            0,
                            1
                        ]), x("depth.mask", "depthMask", !0), x("colorMask", "colorMask", [
                            !0,
                            !0,
                            !0,
                            !0
                        ]), y("cull.enable", 2884), x("cull.face", "cullFace", 1029), x("frontFace", "frontFace", 2305), x("lineWidth", "lineWidth", 1), y("polygonOffset.enable", 32823), x("polygonOffset.offset", "polygonOffset", [
                            0,
                            0
                        ]), y("sample.alpha", 32926), y("sample.enable", 32928), x("sample.coverage", "sampleCoverage", [
                            1,
                            !1
                        ]), y("stencil.enable", 2960), x("stencil.mask", "stencilMask", -1), x("stencil.func", "stencilFunc", [
                            519,
                            0,
                            -1
                        ]), x("stencil.opFront", "stencilOpSeparate", [
                            1028,
                            7680,
                            7680,
                            7680
                        ]), x("stencil.opBack", "stencilOpSeparate", [
                            1029,
                            7680,
                            7680,
                            7680
                        ]), y("scissor.enable", 3089), x("scissor.box", "scissor", [
                            0,
                            0,
                            t1.drawingBufferWidth,
                            t1.drawingBufferHeight
                        ]), x("viewport", "viewport", [
                            0,
                            0,
                            t1.drawingBufferWidth,
                            t1.drawingBufferHeight
                        ]);
                        var ct = {
                            gl: t1,
                            context: p,
                            strings: e1,
                            next: at,
                            current: it,
                            draw: h,
                            elements: o,
                            buffer: i,
                            shader: f,
                            attributes: u.state,
                            vao: u,
                            uniforms: c,
                            framebuffer: l,
                            extensions: r,
                            timer: d,
                            isBufferArgs: I
                        }, ut = {
                            primTypes: rt,
                            compareFuncs: kt,
                            blendFuncs: Tt,
                            blendEquations: $,
                            stencilOps: At,
                            glTypes: K,
                            orientationType: Mt
                        };
                        et && (ut.backBuffer = [
                            1029
                        ], ut.drawBuffer = a(n.maxDrawbuffers, function(t1) {
                            return 0 === t1 ? [
                                0
                            ] : a(t1, function(t1) {
                                return 36064 + t1;
                            });
                        }));
                        var ft = 0;
                        return {
                            next: at,
                            current: it,
                            procs: function() {
                                var t1 = b(), e1 = t1.proc("poll"), i = t1.proc("refresh"), o = t1.block();
                                e1(o), i(o);
                                var s, l = t1.shared, c = l.gl, u = l.next, f = l.current;
                                o(f, ".dirty=false;"), S(t1, e1), S(t1, i, null, !0), tt && (s = t1.link(tt)), r.oes_vertex_array_object && i(t1.link(r.oes_vertex_array_object), ".bindVertexArrayOES(null);");
                                for(var h = 0; h < n.maxAttributes; ++h){
                                    var p = i.def(l.attributes, "[", h, "]"), d = t1.cond(p, ".buffer");
                                    d.then(c, ".enableVertexAttribArray(", h, ");", c, ".bindBuffer(", 34962, ",", p, ".buffer.buffer);", c, ".vertexAttribPointer(", h, ",", p, ".size,", p, ".type,", p, ".normalized,", p, ".stride,", p, ".offset);").else(c, ".disableVertexAttribArray(", h, ");", c, ".vertexAttrib4f(", h, ",", p, ".x,", p, ".y,", p, ".z,", p, ".w);", p, ".buffer=null;"), i(d), tt && i(s, ".vertexAttribDivisorANGLE(", h, ",", p, ".divisor);");
                                }
                                return i(t1.shared.vao, ".currentVAO=null;", t1.shared.vao, ".setVAO(", t1.shared.vao, ".targetVAO);"), Object.keys(st).forEach(function(r) {
                                    var n = st[r], a = o.def(u, ".", r), s = t1.block();
                                    s("if(", a, "){", c, ".enable(", n, ")}else{", c, ".disable(", n, ")}", f, ".", r, "=", a, ";"), i(s), e1("if(", a, "!==", f, ".", r, "){", s, "}");
                                }), Object.keys(lt).forEach(function(r) {
                                    var n, s, l = lt[r], h = it[r], p = t1.block();
                                    p(c, ".", l, "("), g(h) ? (l = h.length, n = t1.global.def(u, ".", r), s = t1.global.def(f, ".", r), p(a(l, function(t1) {
                                        return n + "[" + t1 + "]";
                                    }), ");", a(l, function(t1) {
                                        return s + "[" + t1 + "]=" + n + "[" + t1 + "];";
                                    }).join("")), e1("if(", a(l, function(t1) {
                                        return n + "[" + t1 + "]!==" + s + "[" + t1 + "]";
                                    }).join("||"), "){", p, "}")) : (n = o.def(u, ".", r), s = o.def(f, ".", r), p(n, ");", f, ".", r, "=", n, ";"), e1("if(", n, "!==", s, "){", p, "}")), i(p);
                                }), t1.compile();
                            }(),
                            compile: function(t1, e1, r, n, i) {
                                var a = b();
                                a.stats = a.link(i), Object.keys(e1.static).forEach(function(t1) {
                                    J(a, e1, t1);
                                }), wt.forEach(function(e1) {
                                    J(a, t1, e1);
                                });
                                var o = A(t1, e1, r, n);
                                return function(t1, e1) {
                                    var r = t1.proc("draw", 1);
                                    B(t1, r), M(t1, r, e1.context), S(t1, r, e1.framebuffer), E(t1, r, e1), L(t1, r, e1.state), N(t1, r, e1, !1, !0);
                                    var n = e1.shader.progVar.append(t1, r);
                                    if (r(t1.shared.gl, ".useProgram(", n, ".program);"), e1.shader.program) Y(t1, r, e1, e1.shader.program);
                                    else {
                                        r(t1.shared.vao, ".setVAO(null);");
                                        var i = t1.global.def("{}"), a = r.def(n, ".id"), o = r.def(i, "[", a, "]");
                                        r(t1.cond(o).then(o, ".call(this,a0);").else(o, "=", i, "[", a, "]=", t1.link(function(r) {
                                            return G(Y, t1, e1, r, 1);
                                        }), "(", n, ");", o, ".call(this,a0);"));
                                    }
                                    0 < Object.keys(e1.state).length && r(t1.shared.current, ".dirty=true;"), t1.shared.vao && r(t1.shared.vao, ".setVAO(null);");
                                }(a, o), Z(a, o), function(t1, e1) {
                                    function r(t1) {
                                        return t1.contextDep && i || t1.propDep;
                                    }
                                    var n = t1.proc("batch", 2);
                                    t1.batchId = "0", B(t1, n);
                                    var i = !1, a = !0;
                                    Object.keys(e1.context).forEach(function(t1) {
                                        i = i || e1.context[t1].propDep;
                                    }), i || (M(t1, n, e1.context), a = !1);
                                    var o = !1;
                                    if ((s = e1.framebuffer) ? (s.propDep ? i = o = !0 : s.contextDep && i && (o = !0), o || S(t1, n, s)) : S(t1, n, null), e1.state.viewport && e1.state.viewport.propDep && (i = !0), E(t1, n, e1), L(t1, n, e1.state, function(t1) {
                                        return !r(t1);
                                    }), e1.profile && r(e1.profile) || N(t1, n, e1, !1, "a1"), e1.contextDep = i, e1.needsContext = a, e1.needsFramebuffer = o, (a = e1.shader.progVar).contextDep && i || a.propDep) X(t1, n, e1, null);
                                    else if (a = a.append(t1, n), n(t1.shared.gl, ".useProgram(", a, ".program);"), e1.shader.program) X(t1, n, e1, e1.shader.program);
                                    else {
                                        n(t1.shared.vao, ".setVAO(null);");
                                        var s = t1.global.def("{}"), l = (o = n.def(a, ".id"), n.def(s, "[", o, "]"));
                                        n(t1.cond(l).then(l, ".call(this,a0,a1);").else(l, "=", s, "[", o, "]=", t1.link(function(r) {
                                            return G(X, t1, e1, r, 2);
                                        }), "(", a, ");", l, ".call(this,a0,a1);"));
                                    }
                                    0 < Object.keys(e1.state).length && n(t1.shared.current, ".dirty=true;"), t1.shared.vao && n(t1.shared.vao, ".setVAO(null);");
                                }(a, o), j(a.compile(), {
                                    destroy: function() {
                                        o.shader.program.destroy();
                                    }
                                });
                            }
                        };
                    }
                    function N(t1, e1) {
                        for(var r = 0; r < t1.length; ++r)if (t1[r] === e1) return r;
                        return -1;
                    }
                    var j = function(t1, e1) {
                        for(var r = Object.keys(e1), n = 0; n < r.length; ++n)t1[r[n]] = e1[r[n]];
                        return t1;
                    }, U = 0, V = {
                        DynamicVariable: t1,
                        define: function(r, n) {
                            return new t1(r, e1(n + ""));
                        },
                        isDynamic: function(e1) {
                            return "function" == typeof e1 && !e1._reglType || e1 instanceof t1;
                        },
                        unbox: function e1(r, n) {
                            return "function" == typeof r ? new t1(0, r) : "number" == typeof r || "boolean" == typeof r ? new t1(5, r) : Array.isArray(r) ? new t1(6, r.map(function(t1, r) {
                                return e1(t1, n + "[" + r + "]");
                            })) : r instanceof t1 ? r : void 0;
                        },
                        accessor: e1
                    }, H = {
                        next: "function" == typeof requestAnimationFrame ? function(t1) {
                            return requestAnimationFrame(t1);
                        } : function(t1) {
                            return setTimeout(t1, 16);
                        },
                        cancel: "function" == typeof cancelAnimationFrame ? function(t1) {
                            return cancelAnimationFrame(t1);
                        } : clearTimeout
                    }, q = "undefined" != typeof performance && performance.now ? function() {
                        return performance.now();
                    } : function() {
                        return +new Date;
                    }, G = s();
                    G.zero = s();
                    var Y = function(t1, e1) {
                        var r = 1;
                        e1.ext_texture_filter_anisotropic && (r = t1.getParameter(34047));
                        var n = 1, i = 1;
                        e1.webgl_draw_buffers && (n = t1.getParameter(34852), i = t1.getParameter(36063));
                        var a = !!e1.oes_texture_float;
                        if (a) {
                            a = t1.createTexture(), t1.bindTexture(3553, a), t1.texImage2D(3553, 0, 6408, 1, 1, 0, 6408, 5126, null);
                            var o = t1.createFramebuffer();
                            if (t1.bindFramebuffer(36160, o), t1.framebufferTexture2D(36160, 36064, 3553, a, 0), t1.bindTexture(3553, null), 36053 !== t1.checkFramebufferStatus(36160)) a = !1;
                            else {
                                t1.viewport(0, 0, 1, 1), t1.clearColor(1, 0, 0, 1), t1.clear(16384);
                                var s = G.allocType(5126, 4);
                                t1.readPixels(0, 0, 1, 1, 6408, 5126, s), t1.getError() ? a = !1 : (t1.deleteFramebuffer(o), t1.deleteTexture(a), a = 1 === s[0]), G.freeType(s);
                            }
                        }
                        return s = !0, "undefined" != typeof navigator && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion) || /Edge/.test(navigator.userAgent)) || (s = t1.createTexture(), o = G.allocType(5121, 36), t1.activeTexture(33984), t1.bindTexture(34067, s), t1.texImage2D(34069, 0, 6408, 3, 3, 0, 6408, 5121, o), G.freeType(o), t1.bindTexture(34067, null), t1.deleteTexture(s), s = !t1.getError()), {
                            colorBits: [
                                t1.getParameter(3410),
                                t1.getParameter(3411),
                                t1.getParameter(3412),
                                t1.getParameter(3413)
                            ],
                            depthBits: t1.getParameter(3414),
                            stencilBits: t1.getParameter(3415),
                            subpixelBits: t1.getParameter(3408),
                            extensions: Object.keys(e1).filter(function(t1) {
                                return !!e1[t1];
                            }),
                            maxAnisotropic: r,
                            maxDrawbuffers: n,
                            maxColorAttachments: i,
                            pointSizeDims: t1.getParameter(33901),
                            lineWidthDims: t1.getParameter(33902),
                            maxViewportDims: t1.getParameter(3386),
                            maxCombinedTextureUnits: t1.getParameter(35661),
                            maxCubeMapSize: t1.getParameter(34076),
                            maxRenderbufferSize: t1.getParameter(34024),
                            maxTextureUnits: t1.getParameter(34930),
                            maxTextureSize: t1.getParameter(3379),
                            maxAttributes: t1.getParameter(34921),
                            maxVertexUniforms: t1.getParameter(36347),
                            maxVertexTextureUnits: t1.getParameter(35660),
                            maxVaryingVectors: t1.getParameter(36348),
                            maxFragmentUniforms: t1.getParameter(36349),
                            glsl: t1.getParameter(35724),
                            renderer: t1.getParameter(7937),
                            vendor: t1.getParameter(7936),
                            version: t1.getParameter(7938),
                            readFloat: a,
                            npotTextureCube: s
                        };
                    }, W = function(t1) {
                        return t1 instanceof Uint8Array || t1 instanceof Uint16Array || t1 instanceof Uint32Array || t1 instanceof Int8Array || t1 instanceof Int16Array || t1 instanceof Int32Array || t1 instanceof Float32Array || t1 instanceof Float64Array || t1 instanceof Uint8ClampedArray;
                    }, X = function(t1) {
                        return Object.keys(t1).map(function(e1) {
                            return t1[e1];
                        });
                    }, Z = {
                        shape: function(t1) {
                            for(var e1 = []; t1.length; t1 = t1[0])e1.push(t1.length);
                            return e1;
                        },
                        flatten: function(t1, e1, r, n) {
                            var i = 1;
                            if (e1.length) for(var a = 0; a < e1.length; ++a)i *= e1[a];
                            else i = 0;
                            switch(r = n || G.allocType(r, i), e1.length){
                                case 0:
                                    break;
                                case 1:
                                    for(n = e1[0], e1 = 0; e1 < n; ++e1)r[e1] = t1[e1];
                                    break;
                                case 2:
                                    for(n = e1[0], e1 = e1[1], a = i = 0; a < n; ++a)for(var o = t1[a], s = 0; s < e1; ++s)r[i++] = o[s];
                                    break;
                                case 3:
                                    c(t1, e1[0], e1[1], e1[2], r, 0);
                                    break;
                                default:
                                    !function t1(e1, r, n, i, a) {
                                        for(var o = 1, s = n + 1; s < r.length; ++s)o *= r[s];
                                        var l = r[n];
                                        if (4 == r.length - n) {
                                            var u = r[n + 1], f = r[n + 2];
                                            for(r = r[n + 3], s = 0; s < l; ++s)c(e1[s], u, f, r, i, a), a += o;
                                        } else for(s = 0; s < l; ++s)t1(e1[s], r, n + 1, i, a), a += o;
                                    }(t1, e1, 0, r, 0);
                            }
                            return r;
                        }
                    }, J = {
                        "[object Int8Array]": 5120,
                        "[object Int16Array]": 5122,
                        "[object Int32Array]": 5124,
                        "[object Uint8Array]": 5121,
                        "[object Uint8ClampedArray]": 5121,
                        "[object Uint16Array]": 5123,
                        "[object Uint32Array]": 5125,
                        "[object Float32Array]": 5126,
                        "[object Float64Array]": 5121,
                        "[object ArrayBuffer]": 5121
                    }, K = {
                        int8: 5120,
                        int16: 5122,
                        int32: 5124,
                        uint8: 5121,
                        uint16: 5123,
                        uint32: 5125,
                        float: 5126,
                        float32: 5126
                    }, Q = {
                        dynamic: 35048,
                        stream: 35040,
                        static: 35044
                    }, $ = Z.flatten, tt = Z.shape, et = [];
                    et[5120] = 1, et[5122] = 2, et[5124] = 4, et[5121] = 1, et[5123] = 2, et[5125] = 4, et[5126] = 4;
                    var rt = {
                        points: 0,
                        point: 0,
                        lines: 1,
                        line: 1,
                        triangles: 4,
                        triangle: 4,
                        "line loop": 2,
                        "line strip": 3,
                        "triangle strip": 5,
                        "triangle fan": 6
                    }, nt = new Float32Array(1), it = new Uint32Array(nt.buffer), at = [
                        9984,
                        9986,
                        9985,
                        9987
                    ], ot = [
                        0,
                        6409,
                        6410,
                        6407,
                        6408
                    ], st = {};
                    st[6409] = st[6406] = st[6402] = 1, st[34041] = st[6410] = 2, st[6407] = st[35904] = 3, st[6408] = st[35906] = 4;
                    var lt = v("HTMLCanvasElement"), ct = v("OffscreenCanvas"), ut = v("CanvasRenderingContext2D"), ft = v("ImageBitmap"), ht = v("HTMLImageElement"), pt = v("HTMLVideoElement"), dt = Object.keys(J).concat([
                        lt,
                        ct,
                        ut,
                        ft,
                        ht,
                        pt
                    ]), mt = [];
                    mt[5121] = 1, mt[5126] = 4, mt[36193] = 2, mt[5123] = 2, mt[5125] = 4;
                    var gt = [];
                    gt[32854] = 2, gt[32855] = 2, gt[36194] = 2, gt[34041] = 4, gt[33776] = .5, gt[33777] = .5, gt[33778] = 1, gt[33779] = 1, gt[35986] = .5, gt[35987] = 1, gt[34798] = 1, gt[35840] = .5, gt[35841] = .25, gt[35842] = .5, gt[35843] = .25, gt[36196] = .5;
                    var vt = [];
                    vt[32854] = 2, vt[32855] = 2, vt[36194] = 2, vt[33189] = 2, vt[36168] = 1, vt[34041] = 4, vt[35907] = 4, vt[34836] = 16, vt[34842] = 8, vt[34843] = 6;
                    var yt = function(t1, e1, r, n, i) {
                        function a(t1) {
                            this.id = c++, this.refCount = 1, this.renderbuffer = t1, this.format = 32854, this.height = this.width = 0, i.profile && (this.stats = {
                                size: 0
                            });
                        }
                        function o(e1) {
                            var r = e1.renderbuffer;
                            t1.bindRenderbuffer(36161, null), t1.deleteRenderbuffer(r), e1.renderbuffer = null, e1.refCount = 0, delete u[e1.id], n.renderbufferCount--;
                        }
                        var s = {
                            rgba4: 32854,
                            rgb565: 36194,
                            "rgb5 a1": 32855,
                            depth: 33189,
                            stencil: 36168,
                            "depth stencil": 34041
                        };
                        e1.ext_srgb && (s.srgba = 35907), e1.ext_color_buffer_half_float && (s.rgba16f = 34842, s.rgb16f = 34843), e1.webgl_color_buffer_float && (s.rgba32f = 34836);
                        var l = [];
                        Object.keys(s).forEach(function(t1) {
                            l[s[t1]] = t1;
                        });
                        var c = 0, u = {};
                        return a.prototype.decRef = function() {
                            0 >= --this.refCount && o(this);
                        }, i.profile && (n.getTotalRenderbufferSize = function() {
                            var t1 = 0;
                            return Object.keys(u).forEach(function(e1) {
                                t1 += u[e1].stats.size;
                            }), t1;
                        }), {
                            create: function(e1, r) {
                                function o(e1, r) {
                                    var n = 0, a = 0, u = 32854;
                                    if ("object" == typeof e1 && e1 ? ("shape" in e1 ? (n = 0 | (a = e1.shape)[0], a = 0 | a[1]) : ("radius" in e1 && (n = a = 0 | e1.radius), "width" in e1 && (n = 0 | e1.width), "height" in e1 && (a = 0 | e1.height)), "format" in e1 && (u = s[e1.format])) : "number" == typeof e1 ? (n = 0 | e1, a = "number" == typeof r ? 0 | r : n) : e1 || (n = a = 1), n !== c.width || a !== c.height || u !== c.format) return o.width = c.width = n, o.height = c.height = a, c.format = u, t1.bindRenderbuffer(36161, c.renderbuffer), t1.renderbufferStorage(36161, u, n, a), i.profile && (c.stats.size = vt[c.format] * c.width * c.height), o.format = l[c.format], o;
                                }
                                var c = new a(t1.createRenderbuffer());
                                return u[c.id] = c, n.renderbufferCount++, o(e1, r), o.resize = function(e1, r) {
                                    var n = 0 | e1, a = 0 | r || n;
                                    return n === c.width && a === c.height || (o.width = c.width = n, o.height = c.height = a, t1.bindRenderbuffer(36161, c.renderbuffer), t1.renderbufferStorage(36161, c.format, n, a), i.profile && (c.stats.size = vt[c.format] * c.width * c.height)), o;
                                }, o._reglType = "renderbuffer", o._renderbuffer = c, i.profile && (o.stats = c.stats), o.destroy = function() {
                                    c.decRef();
                                }, o;
                            },
                            clear: function() {
                                X(u).forEach(o);
                            },
                            restore: function() {
                                X(u).forEach(function(e1) {
                                    e1.renderbuffer = t1.createRenderbuffer(), t1.bindRenderbuffer(36161, e1.renderbuffer), t1.renderbufferStorage(36161, e1.format, e1.width, e1.height);
                                }), t1.bindRenderbuffer(36161, null);
                            }
                        };
                    }, xt = [];
                    xt[6408] = 4, xt[6407] = 3;
                    var bt = [];
                    bt[5121] = 1, bt[5126] = 4, bt[36193] = 2;
                    var _t = [
                        "x",
                        "y",
                        "z",
                        "w"
                    ], wt = "blend.func blend.equation stencil.func stencil.opFront stencil.opBack sample.coverage viewport scissor.box polygonOffset.offset".split(" "), Tt = {
                        0: 0,
                        1: 1,
                        zero: 0,
                        one: 1,
                        "src color": 768,
                        "one minus src color": 769,
                        "src alpha": 770,
                        "one minus src alpha": 771,
                        "dst color": 774,
                        "one minus dst color": 775,
                        "dst alpha": 772,
                        "one minus dst alpha": 773,
                        "constant color": 32769,
                        "one minus constant color": 32770,
                        "constant alpha": 32771,
                        "one minus constant alpha": 32772,
                        "src alpha saturate": 776
                    }, kt = {
                        never: 512,
                        less: 513,
                        "<": 513,
                        equal: 514,
                        "=": 514,
                        "==": 514,
                        "===": 514,
                        lequal: 515,
                        "<=": 515,
                        greater: 516,
                        ">": 516,
                        notequal: 517,
                        "!=": 517,
                        "!==": 517,
                        gequal: 518,
                        ">=": 518,
                        always: 519
                    }, At = {
                        0: 0,
                        zero: 0,
                        keep: 7680,
                        replace: 7681,
                        increment: 7682,
                        decrement: 7683,
                        "increment wrap": 34055,
                        "decrement wrap": 34056,
                        invert: 5386
                    }, Mt = {
                        cw: 2304,
                        ccw: 2305
                    }, St = new z(!1, !1, !1, function() {});
                    return function(t1) {
                        function e1() {
                            if (0 === J.length) w && w.update(), tt = null;
                            else {
                                tt = H.next(e1), f();
                                for(var t1 = J.length - 1; 0 <= t1; --t1){
                                    var r = J[t1];
                                    r && r(P, null, 0);
                                }
                                g.flush(), w && w.update();
                            }
                        }
                        function r() {
                            !tt && 0 < J.length && (tt = H.next(e1));
                        }
                        function n() {
                            tt && (H.cancel(e1), tt = null);
                        }
                        function a(t1) {
                            t1.preventDefault(), n(), K.forEach(function(t1) {
                                t1();
                            });
                        }
                        function o(t1) {
                            g.getError(), y.restore(), R.restore(), O.restore(), F.restore(), U.restore(), G.restore(), D.restore(), w && w.restore(), W.procs.refresh(), r(), Q.forEach(function(t1) {
                                t1();
                            });
                        }
                        function s(t1) {
                            function e1(t1, e1) {
                                var r = {}, n = {};
                                return Object.keys(t1).forEach(function(i) {
                                    var a = t1[i];
                                    if (V.isDynamic(a)) n[i] = V.unbox(a, i);
                                    else {
                                        if (e1 && Array.isArray(a)) {
                                            for(var o = 0; o < a.length; ++o)if (V.isDynamic(a[o])) return void (n[i] = V.unbox(a, i));
                                        }
                                        r[i] = a;
                                    }
                                }), {
                                    dynamic: n,
                                    static: r
                                };
                            }
                            var r = e1(t1.context || {}, !0), n = e1(t1.uniforms || {}, !0), i = e1(t1.attributes || {}, !1);
                            t1 = e1(function(t1) {
                                function e1(t1) {
                                    if (t1 in r) {
                                        var e1 = r[t1];
                                        delete r[t1], Object.keys(e1).forEach(function(n) {
                                            r[t1 + "." + n] = e1[n];
                                        });
                                    }
                                }
                                var r = j({}, t1);
                                return delete r.uniforms, delete r.attributes, delete r.context, delete r.vao, "stencil" in r && r.stencil.op && (r.stencil.opBack = r.stencil.opFront = r.stencil.op, delete r.stencil.op), e1("blend"), e1("depth"), e1("cull"), e1("stencil"), e1("polygonOffset"), e1("scissor"), e1("sample"), "vao" in t1 && (r.vao = t1.vao), r;
                            }(t1), !1);
                            var a = {
                                gpuTime: 0,
                                cpuTime: 0,
                                count: 0
                            }, o = W.compile(t1, i, n, r, a), s = o.draw, l = o.batch, c = o.scope, u = [];
                            return j(function(t1, e1) {
                                var r;
                                if ("function" == typeof t1) return c.call(this, null, t1, 0);
                                if ("function" == typeof e1) {
                                    if ("number" == typeof t1) for(r = 0; r < t1; ++r)c.call(this, null, e1, r);
                                    else {
                                        if (!Array.isArray(t1)) return c.call(this, t1, e1, 0);
                                        for(r = 0; r < t1.length; ++r)c.call(this, t1[r], e1, r);
                                    }
                                } else if ("number" == typeof t1) {
                                    if (0 < t1) return l.call(this, function(t1) {
                                        for(; u.length < t1;)u.push(null);
                                        return u;
                                    }(0 | t1), 0 | t1);
                                } else {
                                    if (!Array.isArray(t1)) return s.call(this, t1);
                                    if (t1.length) return l.call(this, t1, t1.length);
                                }
                            }, {
                                stats: a,
                                destroy: function() {
                                    o.destroy();
                                }
                            });
                        }
                        function l(t1, e1) {
                            var r = 0;
                            W.procs.poll();
                            var n = e1.color;
                            n && (g.clearColor(+n[0] || 0, +n[1] || 0, +n[2] || 0, +n[3] || 0), r |= 16384), "depth" in e1 && (g.clearDepth(+e1.depth), r |= 256), "stencil" in e1 && (g.clearStencil(0 | e1.stencil), r |= 1024), g.clear(r);
                        }
                        function c(t1) {
                            return J.push(t1), r(), {
                                cancel: function() {
                                    var e1 = N(J, t1);
                                    J[e1] = function t1() {
                                        var e1 = N(J, t1);
                                        J[e1] = J[J.length - 1], --J.length, 0 >= J.length && n();
                                    };
                                }
                            };
                        }
                        function u() {
                            var t1 = X.viewport, e1 = X.scissor_box;
                            t1[0] = t1[1] = e1[0] = e1[1] = 0, P.viewportWidth = P.framebufferWidth = P.drawingBufferWidth = t1[2] = e1[2] = g.drawingBufferWidth, P.viewportHeight = P.framebufferHeight = P.drawingBufferHeight = t1[3] = e1[3] = g.drawingBufferHeight;
                        }
                        function f() {
                            P.tick += 1, P.time = m(), u(), W.procs.poll();
                        }
                        function h() {
                            F.refresh(), u(), W.procs.refresh(), w && w.update();
                        }
                        function m() {
                            return (q() - T) / 1e3;
                        }
                        if (!(t1 = i(t1))) return null;
                        var g = t1.gl, v = g.getContextAttributes();
                        g.isContextLost();
                        var y = function(t1, e1) {
                            function r(e1) {
                                var r;
                                e1 = e1.toLowerCase();
                                try {
                                    r = n[e1] = t1.getExtension(e1);
                                } catch (t1) {}
                                return !!r;
                            }
                            for(var n = {}, i = 0; i < e1.extensions.length; ++i){
                                var a = e1.extensions[i];
                                if (!r(a)) return e1.onDestroy(), e1.onDone('"' + a + '" extension is not supported by the current WebGL context, try upgrading your system or a different browser'), null;
                            }
                            return e1.optionalExtensions.forEach(r), {
                                extensions: n,
                                restore: function() {
                                    Object.keys(n).forEach(function(t1) {
                                        if (n[t1] && !r(t1)) throw Error("(regl): error restoring extension " + t1);
                                    });
                                }
                            };
                        }(g, t1);
                        if (!y) return null;
                        var x = function() {
                            var t1 = {
                                "": 0
                            }, e1 = [
                                ""
                            ];
                            return {
                                id: function(r) {
                                    var n = t1[r];
                                    return n || (n = t1[r] = e1.length, e1.push(r), n);
                                },
                                str: function(t1) {
                                    return e1[t1];
                                }
                            };
                        }(), b = {
                            vaoCount: 0,
                            bufferCount: 0,
                            elementsCount: 0,
                            framebufferCount: 0,
                            shaderCount: 0,
                            textureCount: 0,
                            cubeCount: 0,
                            renderbufferCount: 0,
                            maxTextureUnits: 0
                        }, _ = y.extensions, w = function(t1, e1) {
                            function r() {
                                this.endQueryIndex = this.startQueryIndex = -1, this.sum = 0, this.stats = null;
                            }
                            function n(t1, e1, n) {
                                var i = o.pop() || new r;
                                i.startQueryIndex = t1, i.endQueryIndex = e1, i.sum = 0, i.stats = n, s.push(i);
                            }
                            if (!e1.ext_disjoint_timer_query) return null;
                            var i = [], a = [], o = [], s = [], l = [], c = [];
                            return {
                                beginQuery: function(t1) {
                                    var r = i.pop() || e1.ext_disjoint_timer_query.createQueryEXT();
                                    e1.ext_disjoint_timer_query.beginQueryEXT(35007, r), a.push(r), n(a.length - 1, a.length, t1);
                                },
                                endQuery: function() {
                                    e1.ext_disjoint_timer_query.endQueryEXT(35007);
                                },
                                pushScopeStats: n,
                                update: function() {
                                    var t1, r;
                                    if (0 !== (t1 = a.length)) {
                                        c.length = Math.max(c.length, t1 + 1), l.length = Math.max(l.length, t1 + 1), l[0] = 0;
                                        var n = c[0] = 0;
                                        for(r = t1 = 0; r < a.length; ++r){
                                            var u = a[r];
                                            e1.ext_disjoint_timer_query.getQueryObjectEXT(u, 34919) ? (n += e1.ext_disjoint_timer_query.getQueryObjectEXT(u, 34918), i.push(u)) : a[t1++] = u, l[r + 1] = n, c[r + 1] = t1;
                                        }
                                        for(a.length = t1, r = t1 = 0; r < s.length; ++r){
                                            var f = (n = s[r]).startQueryIndex;
                                            u = n.endQueryIndex;
                                            n.sum += l[u] - l[f], f = c[f], (u = c[u]) === f ? (n.stats.gpuTime += n.sum / 1e6, o.push(n)) : (n.startQueryIndex = f, n.endQueryIndex = u, s[t1++] = n);
                                        }
                                        s.length = t1;
                                    }
                                },
                                getNumPendingQueries: function() {
                                    return a.length;
                                },
                                clear: function() {
                                    i.push.apply(i, a);
                                    for(var t1 = 0; t1 < i.length; t1++)e1.ext_disjoint_timer_query.deleteQueryEXT(i[t1]);
                                    a.length = 0, i.length = 0;
                                },
                                restore: function() {
                                    a.length = 0, i.length = 0;
                                }
                            };
                        }(0, _), T = q(), M = g.drawingBufferWidth, C = g.drawingBufferHeight, P = {
                            tick: 0,
                            time: 0,
                            viewportWidth: M,
                            viewportHeight: C,
                            framebufferWidth: M,
                            framebufferHeight: C,
                            drawingBufferWidth: M,
                            drawingBufferHeight: C,
                            pixelRatio: t1.pixelRatio
                        }, I = (M = {
                            elements: null,
                            primitive: 4,
                            count: -1,
                            offset: 0,
                            instances: -1
                        }, Y(g, _)), O = p(g, b, t1, function(t1) {
                            return D.destroyBuffer(t1);
                        }), z = d(g, _, O, b), D = S(g, _, I, b, O, z, M), R = E(g, x, b, t1), F = k(g, _, I, function() {
                            W.procs.poll();
                        }, P, b, t1), U = yt(g, _, 0, b, t1), G = A(g, _, I, F, U, b), W = B(g, x, _, I, O, z, 0, G, {}, D, R, M, P, w, t1), X = (x = L(g, G, W.procs.poll, P), W.next), Z = g.canvas, J = [], K = [], Q = [], $ = [
                            t1.onDestroy
                        ], tt = null;
                        Z && (Z.addEventListener("webglcontextlost", a, !1), Z.addEventListener("webglcontextrestored", o, !1));
                        var et = G.setFBO = s({
                            framebuffer: V.define.call(null, 1, "framebuffer")
                        });
                        return h(), v = j(s, {
                            clear: function(t1) {
                                if ("framebuffer" in t1) {
                                    if (t1.framebuffer && "framebufferCube" === t1.framebuffer_reglType) for(var e1 = 0; 6 > e1; ++e1)et(j({
                                        framebuffer: t1.framebuffer.faces[e1]
                                    }, t1), l);
                                    else et(t1, l);
                                } else l(0, t1);
                            },
                            prop: V.define.bind(null, 1),
                            context: V.define.bind(null, 2),
                            this: V.define.bind(null, 3),
                            draw: s({}),
                            buffer: function(t1) {
                                return O.create(t1, 34962, !1, !1);
                            },
                            elements: function(t1) {
                                return z.create(t1, !1);
                            },
                            texture: F.create2D,
                            cube: F.createCube,
                            renderbuffer: U.create,
                            framebuffer: G.create,
                            framebufferCube: G.createCube,
                            vao: D.createVAO,
                            attributes: v,
                            frame: c,
                            on: function(t1, e1) {
                                var r;
                                switch(t1){
                                    case "frame":
                                        return c(e1);
                                    case "lost":
                                        r = K;
                                        break;
                                    case "restore":
                                        r = Q;
                                        break;
                                    case "destroy":
                                        r = $;
                                }
                                return r.push(e1), {
                                    cancel: function() {
                                        for(var t1 = 0; t1 < r.length; ++t1)if (r[t1] === e1) {
                                            r[t1] = r[r.length - 1], r.pop();
                                            break;
                                        }
                                    }
                                };
                            },
                            limits: I,
                            hasExtension: function(t1) {
                                return 0 <= I.extensions.indexOf(t1.toLowerCase());
                            },
                            read: x,
                            destroy: function() {
                                J.length = 0, n(), Z && (Z.removeEventListener("webglcontextlost", a), Z.removeEventListener("webglcontextrestored", o)), R.clear(), G.clear(), U.clear(), D.clear(), F.clear(), z.clear(), O.clear(), w && w.clear(), $.forEach(function(t1) {
                                    t1();
                                });
                            },
                            _gl: g,
                            _refresh: h,
                            poll: function() {
                                f(), w && w.update();
                            },
                            now: m,
                            stats: b
                        }), t1.onDone(null, v), v;
                    };
                });
            },
            {}
        ],
        284: [
            function(t1, e1, r) {
                var n = t1("buffer"), i = n.Buffer;
                function a(t1, e1) {
                    for(var r in t1)e1[r] = t1[r];
                }
                function o(t1, e1, r) {
                    return i(t1, e1, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? e1.exports = n : (a(n, r), r.Buffer = o), o.prototype = Object.create(i.prototype), a(i, o), o.from = function(t1, e1, r) {
                    if ("number" == typeof t1) throw new TypeError("Argument must not be a number");
                    return i(t1, e1, r);
                }, o.alloc = function(t1, e1, r) {
                    if ("number" != typeof t1) throw new TypeError("Argument must be a number");
                    var n = i(t1);
                    return void 0 !== e1 ? "string" == typeof r ? n.fill(e1, r) : n.fill(e1) : n.fill(0), n;
                }, o.allocUnsafe = function(t1) {
                    if ("number" != typeof t1) throw new TypeError("Argument must be a number");
                    return i(t1);
                }, o.allocUnsafeSlow = function(t1) {
                    if ("number" != typeof t1) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(t1);
                };
            },
            {
                buffer: 85
            }
        ],
        285: [
            function(t1, e1, r) {
                e1.exports = i;
                var n = t1("events").EventEmitter;
                function i() {
                    n.call(this);
                }
                t1("inherits")(i, n), i.Readable = t1("readable-stream/lib/_stream_readable.js"), i.Writable = t1("readable-stream/lib/_stream_writable.js"), i.Duplex = t1("readable-stream/lib/_stream_duplex.js"), i.Transform = t1("readable-stream/lib/_stream_transform.js"), i.PassThrough = t1("readable-stream/lib/_stream_passthrough.js"), i.finished = t1("readable-stream/lib/internal/streams/end-of-stream.js"), i.pipeline = t1("readable-stream/lib/internal/streams/pipeline.js"), i.Stream = i, i.prototype.pipe = function(t1, e1) {
                    var r = this;
                    function i(e1) {
                        t1.writable && !1 === t1.write(e1) && r.pause && r.pause();
                    }
                    function a() {
                        r.readable && r.resume && r.resume();
                    }
                    r.on("data", i), t1.on("drain", a), t1._isStdio || e1 && !1 === e1.end || (r.on("end", s), r.on("close", l));
                    var o = !1;
                    function s() {
                        o || (o = !0, t1.end());
                    }
                    function l() {
                        o || (o = !0, "function" == typeof t1.destroy && t1.destroy());
                    }
                    function c(t1) {
                        if (u(), 0 === n.listenerCount(this, "error")) throw t1;
                    }
                    function u() {
                        r.removeListener("data", i), t1.removeListener("drain", a), r.removeListener("end", s), r.removeListener("close", l), r.removeListener("error", c), t1.removeListener("error", c), r.removeListener("end", u), r.removeListener("close", u), t1.removeListener("close", u);
                    }
                    return r.on("error", c), t1.on("error", c), r.on("end", u), r.on("close", u), t1.on("close", u), t1.emit("pipe", r), t1;
                };
            },
            {
                events: 84,
                inherits: 231,
                "readable-stream/lib/_stream_duplex.js": 287,
                "readable-stream/lib/_stream_passthrough.js": 288,
                "readable-stream/lib/_stream_readable.js": 289,
                "readable-stream/lib/_stream_transform.js": 290,
                "readable-stream/lib/_stream_writable.js": 291,
                "readable-stream/lib/internal/streams/end-of-stream.js": 295,
                "readable-stream/lib/internal/streams/pipeline.js": 297
            }
        ],
        286: [
            function(t1, e1, r) {
                "use strict";
                var n = {};
                function i(t1, e1, r) {
                    r || (r = Error);
                    var i = function(t1) {
                        var r, n;
                        function i(r, n, i) {
                            return t1.call(this, function(t1, r, n) {
                                return "string" == typeof e1 ? e1 : e1(t1, r, n);
                            }(r, n, i)) || this;
                        }
                        return n = t1, (r = i).prototype = Object.create(n.prototype), r.prototype.constructor = r, r.__proto__ = n, i;
                    }(r);
                    i.prototype.name = r.name, i.prototype.code = t1, n[t1] = i;
                }
                function a(t1, e1) {
                    if (Array.isArray(t1)) {
                        var r = t1.length;
                        return t1 = t1.map(function(t1) {
                            return String(t1);
                        }), r > 2 ? "one of ".concat(e1, " ").concat(t1.slice(0, r - 1).join(", "), ", or ") + t1[r - 1] : 2 === r ? "one of ".concat(e1, " ").concat(t1[0], " or ").concat(t1[1]) : "of ".concat(e1, " ").concat(t1[0]);
                    }
                    return "of ".concat(e1, " ").concat(String(t1));
                }
                i("ERR_INVALID_OPT_VALUE", function(t1, e1) {
                    return 'The value "' + e1 + '" is invalid for option "' + t1 + '"';
                }, TypeError), i("ERR_INVALID_ARG_TYPE", function(t1, e1, r) {
                    var n, i, o, s;
                    if ("string" == typeof e1 && (i = "not ", e1.substr(!o || o < 0 ? 0 : +o, i.length) === i) ? (n = "must not be", e1 = e1.replace(/^not /, "")) : n = "must be", function(t1, e1, r) {
                        return (void 0 === r || r > t1.length) && (r = t1.length), t1.substring(r - e1.length, r) === e1;
                    }(t1, " argument")) s = "The ".concat(t1, " ").concat(n, " ").concat(a(e1, "type"));
                    else {
                        var l = function(t1, e1, r) {
                            return "number" != typeof r && (r = 0), !(r + e1.length > t1.length) && -1 !== t1.indexOf(e1, r);
                        }(t1, ".") ? "property" : "argument";
                        s = 'The "'.concat(t1, '" ').concat(l, " ").concat(n, " ").concat(a(e1, "type"));
                    }
                    return s += ". Received type ".concat(typeof r);
                }, TypeError), i("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), i("ERR_METHOD_NOT_IMPLEMENTED", function(t1) {
                    return "The " + t1 + " method is not implemented";
                }), i("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), i("ERR_STREAM_DESTROYED", function(t1) {
                    return "Cannot call " + t1 + " after a stream was destroyed";
                }), i("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), i("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), i("ERR_STREAM_WRITE_AFTER_END", "write after end"), i("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), i("ERR_UNKNOWN_ENCODING", function(t1) {
                    return "Unknown encoding: " + t1;
                }, TypeError), i("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), e1.exports.codes = n;
            },
            {}
        ],
        287: [
            function(t1, e1, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = Object.keys || function(t1) {
                            var e1 = [];
                            for(var r in t1)e1.push(r);
                            return e1;
                        };
                        e1.exports = c;
                        var i = t1("./_stream_readable"), a = t1("./_stream_writable");
                        t1("inherits")(c, i);
                        for(var o = n(a.prototype), s = 0; s < o.length; s++){
                            var l = o[s];
                            c.prototype[l] || (c.prototype[l] = a.prototype[l]);
                        }
                        function c(t1) {
                            if (!(this instanceof c)) return new c(t1);
                            i.call(this, t1), a.call(this, t1), this.allowHalfOpen = !0, t1 && (!1 === t1.readable && (this.readable = !1), !1 === t1.writable && (this.writable = !1), !1 === t1.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", u)));
                        }
                        function u() {
                            this._writableState.ended || r.nextTick(f, this);
                        }
                        function f(t1) {
                            t1.end();
                        }
                        Object.defineProperty(c.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), Object.defineProperty(c.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(c.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(c.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                            },
                            set: function(t1) {
                                void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t1, this._writableState.destroyed = t1);
                            }
                        });
                    }).call(this);
                }).call(this, t1("_process"));
            },
            {
                "./_stream_readable": 289,
                "./_stream_writable": 291,
                _process: 277,
                inherits: 231
            }
        ],
        288: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = i;
                var n = t1("./_stream_transform");
                function i(t1) {
                    if (!(this instanceof i)) return new i(t1);
                    n.call(this, t1);
                }
                t1("inherits")(i, n), i.prototype._transform = function(t1, e1, r) {
                    r(null, t1);
                };
            },
            {
                "./_stream_transform": 290,
                inherits: 231
            }
        ],
        289: [
            function(t1, e1, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i;
                        e1.exports = A, A.ReadableState = k;
                        t1("events").EventEmitter;
                        var a = function(t1, e1) {
                            return t1.listeners(e1).length;
                        }, o = t1("./internal/streams/stream"), s = t1("buffer").Buffer, l = n.Uint8Array || function() {};
                        var c, u = t1("util");
                        c = u && u.debuglog ? u.debuglog("stream") : function() {};
                        var f, h, p, d = t1("./internal/streams/buffer_list"), m = t1("./internal/streams/destroy"), g = t1("./internal/streams/state").getHighWaterMark, v = t1("../errors").codes, y = v.ERR_INVALID_ARG_TYPE, x = v.ERR_STREAM_PUSH_AFTER_EOF, b = v.ERR_METHOD_NOT_IMPLEMENTED, _ = v.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                        t1("inherits")(A, o);
                        var w = m.errorOrDestroy, T = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function k(e1, r, n) {
                            i = i || t1("./_stream_duplex"), e1 = e1 || {}, "boolean" != typeof n && (n = r instanceof i), this.objectMode = !!e1.objectMode, n && (this.objectMode = this.objectMode || !!e1.readableObjectMode), this.highWaterMark = g(this, e1, "readableHighWaterMark", n), this.buffer = new d, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== e1.emitClose, this.autoDestroy = !!e1.autoDestroy, this.destroyed = !1, this.defaultEncoding = e1.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e1.encoding && (f || (f = t1("string_decoder/").StringDecoder), this.decoder = new f(e1.encoding), this.encoding = e1.encoding);
                        }
                        function A(e1) {
                            if (i = i || t1("./_stream_duplex"), !(this instanceof A)) return new A(e1);
                            var r = this instanceof i;
                            this._readableState = new k(e1, this, r), this.readable = !0, e1 && ("function" == typeof e1.read && (this._read = e1.read), "function" == typeof e1.destroy && (this._destroy = e1.destroy)), o.call(this);
                        }
                        function M(t1, e1, r, n, i) {
                            c("readableAddChunk", e1);
                            var a, o = t1._readableState;
                            if (null === e1) o.reading = !1, function(t1, e1) {
                                if (c("onEofChunk"), e1.ended) return;
                                if (e1.decoder) {
                                    var r = e1.decoder.end();
                                    r && r.length && (e1.buffer.push(r), e1.length += e1.objectMode ? 1 : r.length);
                                }
                                e1.ended = !0, e1.sync ? L(t1) : (e1.needReadable = !1, e1.emittedReadable || (e1.emittedReadable = !0, C(t1)));
                            }(t1, o);
                            else if (i || (a = function(t1, e1) {
                                var r;
                                n = e1, s.isBuffer(n) || n instanceof l || "string" == typeof e1 || void 0 === e1 || t1.objectMode || (r = new y("chunk", [
                                    "string",
                                    "Buffer",
                                    "Uint8Array"
                                ], e1));
                                var n;
                                return r;
                            }(o, e1)), a) w(t1, a);
                            else if (o.objectMode || e1 && e1.length > 0) {
                                if ("string" == typeof e1 || o.objectMode || Object.getPrototypeOf(e1) === s.prototype || (e1 = function(t1) {
                                    return s.from(t1);
                                }(e1)), n) o.endEmitted ? w(t1, new _) : S(t1, o, e1, !0);
                                else if (o.ended) w(t1, new x);
                                else {
                                    if (o.destroyed) return !1;
                                    o.reading = !1, o.decoder && !r ? (e1 = o.decoder.write(e1), o.objectMode || 0 !== e1.length ? S(t1, o, e1, !1) : P(t1, o)) : S(t1, o, e1, !1);
                                }
                            } else n || (o.reading = !1, P(t1, o));
                            return !o.ended && (o.length < o.highWaterMark || 0 === o.length);
                        }
                        function S(t1, e1, r, n) {
                            e1.flowing && 0 === e1.length && !e1.sync ? (e1.awaitDrain = 0, t1.emit("data", r)) : (e1.length += e1.objectMode ? 1 : r.length, n ? e1.buffer.unshift(r) : e1.buffer.push(r), e1.needReadable && L(t1)), P(t1, e1);
                        }
                        Object.defineProperty(A.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(t1) {
                                this._readableState && (this._readableState.destroyed = t1);
                            }
                        }), A.prototype.destroy = m.destroy, A.prototype._undestroy = m.undestroy, A.prototype._destroy = function(t1, e1) {
                            e1(t1);
                        }, A.prototype.push = function(t1, e1) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof t1 && ((e1 = e1 || n.defaultEncoding) !== n.encoding && (t1 = s.from(t1, e1), e1 = ""), r = !0), M(this, t1, e1, !1, r);
                        }, A.prototype.unshift = function(t1) {
                            return M(this, t1, null, !0, !1);
                        }, A.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, A.prototype.setEncoding = function(e1) {
                            f || (f = t1("string_decoder/").StringDecoder);
                            var r = new f(e1);
                            this._readableState.decoder = r, this._readableState.encoding = this._readableState.decoder.encoding;
                            for(var n = this._readableState.buffer.head, i = ""; null !== n;)i += r.write(n.data), n = n.next;
                            return this._readableState.buffer.clear(), "" !== i && this._readableState.buffer.push(i), this._readableState.length = i.length, this;
                        };
                        function E(t1, e1) {
                            return t1 <= 0 || 0 === e1.length && e1.ended ? 0 : e1.objectMode ? 1 : t1 != t1 ? e1.flowing && e1.length ? e1.buffer.head.data.length : e1.length : (t1 > e1.highWaterMark && (e1.highWaterMark = function(t1) {
                                return t1 >= 1073741824 ? t1 = 1073741824 : (t1--, t1 |= t1 >>> 1, t1 |= t1 >>> 2, t1 |= t1 >>> 4, t1 |= t1 >>> 8, t1 |= t1 >>> 16, t1++), t1;
                            }(t1)), t1 <= e1.length ? t1 : e1.ended ? e1.length : (e1.needReadable = !0, 0));
                        }
                        function L(t1) {
                            var e1 = t1._readableState;
                            c("emitReadable", e1.needReadable, e1.emittedReadable), e1.needReadable = !1, e1.emittedReadable || (c("emitReadable", e1.flowing), e1.emittedReadable = !0, r.nextTick(C, t1));
                        }
                        function C(t1) {
                            var e1 = t1._readableState;
                            c("emitReadable_", e1.destroyed, e1.length, e1.ended), e1.destroyed || !e1.length && !e1.ended || (t1.emit("readable"), e1.emittedReadable = !1), e1.needReadable = !e1.flowing && !e1.ended && e1.length <= e1.highWaterMark, R(t1);
                        }
                        function P(t1, e1) {
                            e1.readingMore || (e1.readingMore = !0, r.nextTick(I, t1, e1));
                        }
                        function I(t1, e1) {
                            for(; !e1.reading && !e1.ended && (e1.length < e1.highWaterMark || e1.flowing && 0 === e1.length);){
                                var r = e1.length;
                                if (c("maybeReadMore read 0"), t1.read(0), r === e1.length) break;
                            }
                            e1.readingMore = !1;
                        }
                        function O(t1) {
                            var e1 = t1._readableState;
                            e1.readableListening = t1.listenerCount("readable") > 0, e1.resumeScheduled && !e1.paused ? e1.flowing = !0 : t1.listenerCount("data") > 0 && t1.resume();
                        }
                        function z(t1) {
                            c("readable nexttick read 0"), t1.read(0);
                        }
                        function D(t1, e1) {
                            c("resume", e1.reading), e1.reading || t1.read(0), e1.resumeScheduled = !1, t1.emit("resume"), R(t1), e1.flowing && !e1.reading && t1.read(0);
                        }
                        function R(t1) {
                            var e1 = t1._readableState;
                            for(c("flow", e1.flowing); e1.flowing && null !== t1.read(););
                        }
                        function F(t1, e1) {
                            var r;
                            return 0 === e1.length ? null : (e1.objectMode ? r = e1.buffer.shift() : !t1 || t1 >= e1.length ? (r = e1.decoder ? e1.buffer.join("") : 1 === e1.buffer.length ? e1.buffer.first() : e1.buffer.concat(e1.length), e1.buffer.clear()) : r = e1.buffer.consume(t1, e1.decoder), r);
                        }
                        function B(t1) {
                            var e1 = t1._readableState;
                            c("endReadable", e1.endEmitted), e1.endEmitted || (e1.ended = !0, r.nextTick(N, e1, t1));
                        }
                        function N(t1, e1) {
                            if (c("endReadableNT", t1.endEmitted, t1.length), !t1.endEmitted && 0 === t1.length && (t1.endEmitted = !0, e1.readable = !1, e1.emit("end"), t1.autoDestroy)) {
                                var r = e1._writableState;
                                (!r || r.autoDestroy && r.finished) && e1.destroy();
                            }
                        }
                        function j(t1, e1) {
                            for(var r = 0, n = t1.length; r < n; r++)if (t1[r] === e1) return r;
                            return -1;
                        }
                        A.prototype.read = function(t1) {
                            c("read", t1), t1 = parseInt(t1, 10);
                            var e1 = this._readableState, r = t1;
                            if (0 !== t1 && (e1.emittedReadable = !1), 0 === t1 && e1.needReadable && ((0 !== e1.highWaterMark ? e1.length >= e1.highWaterMark : e1.length > 0) || e1.ended)) return c("read: emitReadable", e1.length, e1.ended), 0 === e1.length && e1.ended ? B(this) : L(this), null;
                            if (0 === (t1 = E(t1, e1)) && e1.ended) return 0 === e1.length && B(this), null;
                            var n, i = e1.needReadable;
                            return c("need readable", i), (0 === e1.length || e1.length - t1 < e1.highWaterMark) && c("length less than watermark", i = !0), e1.ended || e1.reading ? c("reading or ended", i = !1) : i && (c("do read"), e1.reading = !0, e1.sync = !0, 0 === e1.length && (e1.needReadable = !0), this._read(e1.highWaterMark), e1.sync = !1, e1.reading || (t1 = E(r, e1))), null === (n = t1 > 0 ? F(t1, e1) : null) ? (e1.needReadable = e1.length <= e1.highWaterMark, t1 = 0) : (e1.length -= t1, e1.awaitDrain = 0), 0 === e1.length && (e1.ended || (e1.needReadable = !0), r !== t1 && e1.ended && B(this)), null !== n && this.emit("data", n), n;
                        }, A.prototype._read = function(t1) {
                            w(this, new b("_read()"));
                        }, A.prototype.pipe = function(t1, e1) {
                            var n = this, i = this._readableState;
                            switch(i.pipesCount){
                                case 0:
                                    i.pipes = t1;
                                    break;
                                case 1:
                                    i.pipes = [
                                        i.pipes,
                                        t1
                                    ];
                                    break;
                                default:
                                    i.pipes.push(t1);
                            }
                            i.pipesCount += 1, c("pipe count=%d opts=%j", i.pipesCount, e1);
                            var o = (!e1 || !1 !== e1.end) && t1 !== r.stdout && t1 !== r.stderr ? l : g;
                            function s(e1, r) {
                                c("onunpipe"), e1 === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, c("cleanup"), t1.removeListener("close", d), t1.removeListener("finish", m), t1.removeListener("drain", u), t1.removeListener("error", p), t1.removeListener("unpipe", s), n.removeListener("end", l), n.removeListener("end", g), n.removeListener("data", h), f = !0, !i.awaitDrain || t1._writableState && !t1._writableState.needDrain || u());
                            }
                            function l() {
                                c("onend"), t1.end();
                            }
                            i.endEmitted ? r.nextTick(o) : n.once("end", o), t1.on("unpipe", s);
                            var u = function(t1) {
                                return function() {
                                    var e1 = t1._readableState;
                                    c("pipeOnDrain", e1.awaitDrain), e1.awaitDrain && e1.awaitDrain--, 0 === e1.awaitDrain && a(t1, "data") && (e1.flowing = !0, R(t1));
                                };
                            }(n);
                            t1.on("drain", u);
                            var f = !1;
                            function h(e1) {
                                c("ondata");
                                var r = t1.write(e1);
                                c("dest.write", r), !1 === r && ((1 === i.pipesCount && i.pipes === t1 || i.pipesCount > 1 && -1 !== j(i.pipes, t1)) && !f && (c("false write response, pause", i.awaitDrain), i.awaitDrain++), n.pause());
                            }
                            function p(e1) {
                                c("onerror", e1), g(), t1.removeListener("error", p), 0 === a(t1, "error") && w(t1, e1);
                            }
                            function d() {
                                t1.removeListener("finish", m), g();
                            }
                            function m() {
                                c("onfinish"), t1.removeListener("close", d), g();
                            }
                            function g() {
                                c("unpipe"), n.unpipe(t1);
                            }
                            return n.on("data", h), function(t1, e1, r) {
                                if ("function" == typeof t1.prependListener) return t1.prependListener(e1, r);
                                t1._events && t1._events[e1] ? Array.isArray(t1._events[e1]) ? t1._events[e1].unshift(r) : t1._events[e1] = [
                                    r,
                                    t1._events[e1]
                                ] : t1.on(e1, r);
                            }(t1, "error", p), t1.once("close", d), t1.once("finish", m), t1.emit("pipe", n), i.flowing || (c("pipe resume"), n.resume()), t1;
                        }, A.prototype.unpipe = function(t1) {
                            var e1 = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === e1.pipesCount) return this;
                            if (1 === e1.pipesCount) return t1 && t1 !== e1.pipes || (t1 || (t1 = e1.pipes), e1.pipes = null, e1.pipesCount = 0, e1.flowing = !1, t1 && t1.emit("unpipe", this, r)), this;
                            if (!t1) {
                                var n = e1.pipes, i = e1.pipesCount;
                                e1.pipes = null, e1.pipesCount = 0, e1.flowing = !1;
                                for(var a = 0; a < i; a++)n[a].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = j(e1.pipes, t1);
                            return -1 === o || (e1.pipes.splice(o, 1), e1.pipesCount -= 1, 1 === e1.pipesCount && (e1.pipes = e1.pipes[0]), t1.emit("unpipe", this, r)), this;
                        }, A.prototype.on = function(t1, e1) {
                            var n = o.prototype.on.call(this, t1, e1), i = this._readableState;
                            return "data" === t1 ? (i.readableListening = this.listenerCount("readable") > 0, !1 !== i.flowing && this.resume()) : "readable" === t1 && (i.endEmitted || i.readableListening || (i.readableListening = i.needReadable = !0, i.flowing = !1, i.emittedReadable = !1, c("on readable", i.length, i.reading), i.length ? L(this) : i.reading || r.nextTick(z, this))), n;
                        }, A.prototype.addListener = A.prototype.on, A.prototype.removeListener = function(t1, e1) {
                            var n = o.prototype.removeListener.call(this, t1, e1);
                            return "readable" === t1 && r.nextTick(O, this), n;
                        }, A.prototype.removeAllListeners = function(t1) {
                            var e1 = o.prototype.removeAllListeners.apply(this, arguments);
                            return "readable" !== t1 && void 0 !== t1 || r.nextTick(O, this), e1;
                        }, A.prototype.resume = function() {
                            var t1 = this._readableState;
                            return t1.flowing || (c("resume"), t1.flowing = !t1.readableListening, function(t1, e1) {
                                e1.resumeScheduled || (e1.resumeScheduled = !0, r.nextTick(D, t1, e1));
                            }(this, t1)), t1.paused = !1, this;
                        }, A.prototype.pause = function() {
                            return c("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (c("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
                        }, A.prototype.wrap = function(t1) {
                            var e1 = this, r = this._readableState, n = !1;
                            for(var i in t1.on("end", function() {
                                if (c("wrapped end"), r.decoder && !r.ended) {
                                    var t1 = r.decoder.end();
                                    t1 && t1.length && e1.push(t1);
                                }
                                e1.push(null);
                            }), t1.on("data", function(i) {
                                (c("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (e1.push(i) || (n = !0, t1.pause()));
                            }), t1)void 0 === this[i] && "function" == typeof t1[i] && (this[i] = function(e1) {
                                return function() {
                                    return t1[e1].apply(t1, arguments);
                                };
                            }(i));
                            for(var a = 0; a < T.length; a++)t1.on(T[a], this.emit.bind(this, T[a]));
                            return this._read = function(e1) {
                                c("wrapped _read", e1), n && (n = !1, t1.resume());
                            }, this;
                        }, "function" == typeof Symbol && (A.prototype[Symbol.asyncIterator] = function() {
                            return void 0 === h && (h = t1("./internal/streams/async_iterator")), h(this);
                        }), Object.defineProperty(A.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), Object.defineProperty(A.prototype, "readableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState && this._readableState.buffer;
                            }
                        }), Object.defineProperty(A.prototype, "readableFlowing", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.flowing;
                            },
                            set: function(t1) {
                                this._readableState && (this._readableState.flowing = t1);
                            }
                        }), A._fromList = F, Object.defineProperty(A.prototype, "readableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.length;
                            }
                        }), "function" == typeof Symbol && (A.from = function(e1, r) {
                            return void 0 === p && (p = t1("./internal/streams/from")), p(A, e1, r);
                        });
                    }).call(this);
                }).call(this, t1("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 286,
                "./_stream_duplex": 287,
                "./internal/streams/async_iterator": 292,
                "./internal/streams/buffer_list": 293,
                "./internal/streams/destroy": 294,
                "./internal/streams/from": 296,
                "./internal/streams/state": 298,
                "./internal/streams/stream": 299,
                _process: 277,
                buffer: 85,
                events: 84,
                inherits: 231,
                "string_decoder/": 300,
                util: 83
            }
        ],
        290: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = u;
                var n = t1("../errors").codes, i = n.ERR_METHOD_NOT_IMPLEMENTED, a = n.ERR_MULTIPLE_CALLBACK, o = n.ERR_TRANSFORM_ALREADY_TRANSFORMING, s = n.ERR_TRANSFORM_WITH_LENGTH_0, l = t1("./_stream_duplex");
                function c(t1, e1) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (null === n) return this.emit("error", new a);
                    r.writechunk = null, r.writecb = null, null != e1 && this.push(e1), n(t1);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function u(t1) {
                    if (!(this instanceof u)) return new u(t1);
                    l.call(this, t1), this._transformState = {
                        afterTransform: c.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, t1 && ("function" == typeof t1.transform && (this._transform = t1.transform), "function" == typeof t1.flush && (this._flush = t1.flush)), this.on("prefinish", f);
                }
                function f() {
                    var t1 = this;
                    "function" != typeof this._flush || this._readableState.destroyed ? h(this, null, null) : this._flush(function(e1, r) {
                        h(t1, e1, r);
                    });
                }
                function h(t1, e1, r) {
                    if (e1) return t1.emit("error", e1);
                    if (null != r && t1.push(r), t1._writableState.length) throw new s;
                    if (t1._transformState.transforming) throw new o;
                    return t1.push(null);
                }
                t1("inherits")(u, l), u.prototype.push = function(t1, e1) {
                    return this._transformState.needTransform = !1, l.prototype.push.call(this, t1, e1);
                }, u.prototype._transform = function(t1, e1, r) {
                    r(new i("_transform()"));
                }, u.prototype._write = function(t1, e1, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = t1, n.writeencoding = e1, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, u.prototype._read = function(t1) {
                    var e1 = this._transformState;
                    null === e1.writechunk || e1.transforming ? e1.needTransform = !0 : (e1.transforming = !0, this._transform(e1.writechunk, e1.writeencoding, e1.afterTransform));
                }, u.prototype._destroy = function(t1, e1) {
                    l.prototype._destroy.call(this, t1, function(t1) {
                        e1(t1);
                    });
                };
            },
            {
                "../errors": 286,
                "./_stream_duplex": 287,
                inherits: 231
            }
        ],
        291: [
            function(t1, e1, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        function i(t1) {
                            var e1 = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(t1, e1, r) {
                                    var n = t1.entry;
                                    t1.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        e1.pendingcb--, i(r), n = n.next;
                                    }
                                    e1.corkedRequestsFree.next = t1;
                                }(e1, t1);
                            };
                        }
                        var a;
                        e1.exports = A, A.WritableState = k;
                        var o = {
                            deprecate: t1("util-deprecate")
                        }, s = t1("./internal/streams/stream"), l = t1("buffer").Buffer, c = n.Uint8Array || function() {};
                        var u, f = t1("./internal/streams/destroy"), h = t1("./internal/streams/state").getHighWaterMark, p = t1("../errors").codes, d = p.ERR_INVALID_ARG_TYPE, m = p.ERR_METHOD_NOT_IMPLEMENTED, g = p.ERR_MULTIPLE_CALLBACK, v = p.ERR_STREAM_CANNOT_PIPE, y = p.ERR_STREAM_DESTROYED, x = p.ERR_STREAM_NULL_VALUES, b = p.ERR_STREAM_WRITE_AFTER_END, _ = p.ERR_UNKNOWN_ENCODING, w = f.errorOrDestroy;
                        function T() {}
                        function k(e1, n, o) {
                            a = a || t1("./_stream_duplex"), e1 = e1 || {}, "boolean" != typeof o && (o = n instanceof a), this.objectMode = !!e1.objectMode, o && (this.objectMode = this.objectMode || !!e1.writableObjectMode), this.highWaterMark = h(this, e1, "writableHighWaterMark", o), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var s = !1 === e1.decodeStrings;
                            this.decodeStrings = !s, this.defaultEncoding = e1.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(t1) {
                                !function(t1, e1) {
                                    var n = t1._writableState, i = n.sync, a = n.writecb;
                                    if ("function" != typeof a) throw new g;
                                    if (function(t1) {
                                        t1.writing = !1, t1.writecb = null, t1.length -= t1.writelen, t1.writelen = 0;
                                    }(n), e1) !function(t1, e1, n, i, a) {
                                        --e1.pendingcb, n ? (r.nextTick(a, i), r.nextTick(P, t1, e1), t1._writableState.errorEmitted = !0, w(t1, i)) : (a(i), t1._writableState.errorEmitted = !0, w(t1, i), P(t1, e1));
                                    }(t1, n, i, e1, a);
                                    else {
                                        var o = L(n) || t1.destroyed;
                                        o || n.corked || n.bufferProcessing || !n.bufferedRequest || E(t1, n), i ? r.nextTick(S, t1, n, o, a) : S(t1, n, o, a);
                                    }
                                }(n, t1);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== e1.emitClose, this.autoDestroy = !!e1.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new i(this);
                        }
                        function A(e1) {
                            var r = this instanceof (a = a || t1("./_stream_duplex"));
                            if (!r && !u.call(A, this)) return new A(e1);
                            this._writableState = new k(e1, this, r), this.writable = !0, e1 && ("function" == typeof e1.write && (this._write = e1.write), "function" == typeof e1.writev && (this._writev = e1.writev), "function" == typeof e1.destroy && (this._destroy = e1.destroy), "function" == typeof e1.final && (this._final = e1.final)), s.call(this);
                        }
                        function M(t1, e1, r, n, i, a, o) {
                            e1.writelen = n, e1.writecb = o, e1.writing = !0, e1.sync = !0, e1.destroyed ? e1.onwrite(new y("write")) : r ? t1._writev(i, e1.onwrite) : t1._write(i, a, e1.onwrite), e1.sync = !1;
                        }
                        function S(t1, e1, r, n) {
                            r || function(t1, e1) {
                                0 === e1.length && e1.needDrain && (e1.needDrain = !1, t1.emit("drain"));
                            }(t1, e1), e1.pendingcb--, n(), P(t1, e1);
                        }
                        function E(t1, e1) {
                            e1.bufferProcessing = !0;
                            var r = e1.bufferedRequest;
                            if (t1._writev && r && r.next) {
                                var n = e1.bufferedRequestCount, a = new Array(n), o = e1.corkedRequestsFree;
                                o.entry = r;
                                for(var s = 0, l = !0; r;)a[s] = r, r.isBuf || (l = !1), r = r.next, s += 1;
                                a.allBuffers = l, M(t1, e1, !0, e1.length, a, "", o.finish), e1.pendingcb++, e1.lastBufferedRequest = null, o.next ? (e1.corkedRequestsFree = o.next, o.next = null) : e1.corkedRequestsFree = new i(e1), e1.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, f = r.callback;
                                    if (M(t1, e1, !1, e1.objectMode ? 1 : c.length, c, u, f), r = r.next, e1.bufferedRequestCount--, e1.writing) break;
                                }
                                null === r && (e1.lastBufferedRequest = null);
                            }
                            e1.bufferedRequest = r, e1.bufferProcessing = !1;
                        }
                        function L(t1) {
                            return t1.ending && 0 === t1.length && null === t1.bufferedRequest && !t1.finished && !t1.writing;
                        }
                        function C(t1, e1) {
                            t1._final(function(r) {
                                e1.pendingcb--, r && w(t1, r), e1.prefinished = !0, t1.emit("prefinish"), P(t1, e1);
                            });
                        }
                        function P(t1, e1) {
                            var n = L(e1);
                            if (n && (function(t1, e1) {
                                e1.prefinished || e1.finalCalled || ("function" != typeof t1._final || e1.destroyed ? (e1.prefinished = !0, t1.emit("prefinish")) : (e1.pendingcb++, e1.finalCalled = !0, r.nextTick(C, t1, e1)));
                            }(t1, e1), 0 === e1.pendingcb && (e1.finished = !0, t1.emit("finish"), e1.autoDestroy))) {
                                var i = t1._readableState;
                                (!i || i.autoDestroy && i.endEmitted) && t1.destroy();
                            }
                            return n;
                        }
                        t1("inherits")(A, s), k.prototype.getBuffer = function() {
                            for(var t1 = this.bufferedRequest, e1 = []; t1;)e1.push(t1), t1 = t1.next;
                            return e1;
                        }, function() {
                            try {
                                Object.defineProperty(k.prototype, "buffer", {
                                    get: o.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (t1) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (u = Function.prototype[Symbol.hasInstance], Object.defineProperty(A, Symbol.hasInstance, {
                            value: function(t1) {
                                return !!u.call(this, t1) || this === A && t1 && t1._writableState instanceof k;
                            }
                        })) : u = function(t1) {
                            return t1 instanceof this;
                        }, A.prototype.pipe = function() {
                            w(this, new v);
                        }, A.prototype.write = function(t1, e1, n) {
                            var i, a = this._writableState, o = !1, s = !a.objectMode && (i = t1, l.isBuffer(i) || i instanceof c);
                            return s && !l.isBuffer(t1) && (t1 = function(t1) {
                                return l.from(t1);
                            }(t1)), "function" == typeof e1 && (n = e1, e1 = null), s ? e1 = "buffer" : e1 || (e1 = a.defaultEncoding), "function" != typeof n && (n = T), a.ending ? function(t1, e1) {
                                var n = new b;
                                w(t1, n), r.nextTick(e1, n);
                            }(this, n) : (s || function(t1, e1, n, i) {
                                var a;
                                return null === n ? a = new x : "string" == typeof n || e1.objectMode || (a = new d("chunk", [
                                    "string",
                                    "Buffer"
                                ], n)), !a || (w(t1, a), r.nextTick(i, a), !1);
                            }(this, a, t1, n)) && (a.pendingcb++, o = function(t1, e1, r, n, i, a) {
                                if (!r) {
                                    var o = function(t1, e1, r) {
                                        t1.objectMode || !1 === t1.decodeStrings || "string" != typeof e1 || (e1 = l.from(e1, r));
                                        return e1;
                                    }(e1, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var s = e1.objectMode ? 1 : n.length;
                                e1.length += s;
                                var c = e1.length < e1.highWaterMark;
                                c || (e1.needDrain = !0);
                                if (e1.writing || e1.corked) {
                                    var u = e1.lastBufferedRequest;
                                    e1.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: a,
                                        next: null
                                    }, u ? u.next = e1.lastBufferedRequest : e1.bufferedRequest = e1.lastBufferedRequest, e1.bufferedRequestCount += 1;
                                } else M(t1, e1, !1, s, n, i, a);
                                return c;
                            }(this, a, s, t1, e1, n)), o;
                        }, A.prototype.cork = function() {
                            this._writableState.corked++;
                        }, A.prototype.uncork = function() {
                            var t1 = this._writableState;
                            t1.corked && (t1.corked--, t1.writing || t1.corked || t1.bufferProcessing || !t1.bufferedRequest || E(this, t1));
                        }, A.prototype.setDefaultEncoding = function(t1) {
                            if ("string" == typeof t1 && (t1 = t1.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((t1 + "").toLowerCase()) > -1)) throw new _(t1);
                            return this._writableState.defaultEncoding = t1, this;
                        }, Object.defineProperty(A.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(A.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), A.prototype._write = function(t1, e1, r) {
                            r(new m("_write()"));
                        }, A.prototype._writev = null, A.prototype.end = function(t1, e1, n) {
                            var i = this._writableState;
                            return "function" == typeof t1 ? (n = t1, t1 = null, e1 = null) : "function" == typeof e1 && (n = e1, e1 = null), null != t1 && this.write(t1, e1), i.corked && (i.corked = 1, this.uncork()), i.ending || function(t1, e1, n) {
                                e1.ending = !0, P(t1, e1), n && (e1.finished ? r.nextTick(n) : t1.once("finish", n));
                                e1.ended = !0, t1.writable = !1;
                            }(this, i, n), this;
                        }, Object.defineProperty(A.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(A.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(t1) {
                                this._writableState && (this._writableState.destroyed = t1);
                            }
                        }), A.prototype.destroy = f.destroy, A.prototype._undestroy = f.undestroy, A.prototype._destroy = function(t1, e1) {
                            e1(t1);
                        };
                    }).call(this);
                }).call(this, t1("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 286,
                "./_stream_duplex": 287,
                "./internal/streams/destroy": 294,
                "./internal/streams/state": 298,
                "./internal/streams/stream": 299,
                _process: 277,
                buffer: 85,
                inherits: 231,
                "util-deprecate": 330
            }
        ],
        292: [
            function(t1, e1, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n;
                        function i(t1, e1, r) {
                            return e1 in t1 ? Object.defineProperty(t1, e1, {
                                value: r,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : t1[e1] = r, t1;
                        }
                        var a = t1("./end-of-stream"), o = Symbol("lastResolve"), s = Symbol("lastReject"), l = Symbol("error"), c = Symbol("ended"), u = Symbol("lastPromise"), f = Symbol("handlePromise"), h = Symbol("stream");
                        function p(t1, e1) {
                            return {
                                value: t1,
                                done: e1
                            };
                        }
                        function d(t1) {
                            var e1 = t1[o];
                            if (null !== e1) {
                                var r = t1[h].read();
                                null !== r && (t1[u] = null, t1[o] = null, t1[s] = null, e1(p(r, !1)));
                            }
                        }
                        function m(t1) {
                            r.nextTick(d, t1);
                        }
                        var g = Object.getPrototypeOf(function() {}), v = Object.setPrototypeOf((i(n = {
                            get stream () {
                                return this[h];
                            },
                            next: function() {
                                var t1 = this, e1 = this[l];
                                if (null !== e1) return Promise.reject(e1);
                                if (this[c]) return Promise.resolve(p(void 0, !0));
                                if (this[h].destroyed) return new Promise(function(e1, n) {
                                    r.nextTick(function() {
                                        t1[l] ? n(t1[l]) : e1(p(void 0, !0));
                                    });
                                });
                                var n, i = this[u];
                                if (i) n = new Promise(function(t1, e1) {
                                    return function(r, n) {
                                        t1.then(function() {
                                            e1[c] ? r(p(void 0, !0)) : e1[f](r, n);
                                        }, n);
                                    };
                                }(i, this));
                                else {
                                    var a = this[h].read();
                                    if (null !== a) return Promise.resolve(p(a, !1));
                                    n = new Promise(this[f]);
                                }
                                return this[u] = n, n;
                            }
                        }, Symbol.asyncIterator, function() {
                            return this;
                        }), i(n, "return", function() {
                            var t1 = this;
                            return new Promise(function(e1, r) {
                                t1[h].destroy(null, function(t1) {
                                    t1 ? r(t1) : e1(p(void 0, !0));
                                });
                            });
                        }), n), g);
                        e1.exports = function(t1) {
                            var e1, r = Object.create(v, (i(e1 = {}, h, {
                                value: t1,
                                writable: !0
                            }), i(e1, o, {
                                value: null,
                                writable: !0
                            }), i(e1, s, {
                                value: null,
                                writable: !0
                            }), i(e1, l, {
                                value: null,
                                writable: !0
                            }), i(e1, c, {
                                value: t1._readableState.endEmitted,
                                writable: !0
                            }), i(e1, f, {
                                value: function(t1, e1) {
                                    var n = r[h].read();
                                    n ? (r[u] = null, r[o] = null, r[s] = null, t1(p(n, !1))) : (r[o] = t1, r[s] = e1);
                                },
                                writable: !0
                            }), e1));
                            return r[u] = null, a(t1, function(t1) {
                                if (t1 && "ERR_STREAM_PREMATURE_CLOSE" !== t1.code) {
                                    var e1 = r[s];
                                    return null !== e1 && (r[u] = null, r[o] = null, r[s] = null, e1(t1)), void (r[l] = t1);
                                }
                                var n = r[o];
                                null !== n && (r[u] = null, r[o] = null, r[s] = null, n(p(void 0, !0))), r[c] = !0;
                            }), t1.on("readable", m.bind(null, r)), r;
                        };
                    }).call(this);
                }).call(this, t1("_process"));
            },
            {
                "./end-of-stream": 295,
                _process: 277
            }
        ],
        293: [
            function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    var r = Object.keys(t1);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(t1);
                        e1 && (n = n.filter(function(e1) {
                            return Object.getOwnPropertyDescriptor(t1, e1).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function i(t1, e1, r) {
                    return e1 in t1 ? Object.defineProperty(t1, e1, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t1[e1] = r, t1;
                }
                function a(t1, e1) {
                    for(var r = 0; r < e1.length; r++){
                        var n = e1[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t1, n.key, n);
                    }
                }
                var o = t1("buffer").Buffer, s = t1("util").inspect, l = s && s.custom || "inspect";
                e1.exports = function() {
                    function t1() {
                        !function(t1, e1) {
                            if (!(t1 instanceof e1)) throw new TypeError("Cannot call a class as a function");
                        }(this, t1), this.head = null, this.tail = null, this.length = 0;
                    }
                    var e1, r, c;
                    return e1 = t1, r = [
                        {
                            key: "push",
                            value: function(t1) {
                                var e1 = {
                                    data: t1,
                                    next: null
                                };
                                this.length > 0 ? this.tail.next = e1 : this.head = e1, this.tail = e1, ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function(t1) {
                                var e1 = {
                                    data: t1,
                                    next: this.head
                                };
                                0 === this.length && (this.tail = e1), this.head = e1, ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function() {
                                if (0 !== this.length) {
                                    var t1 = this.head.data;
                                    return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t1;
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.head = this.tail = null, this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function(t1) {
                                if (0 === this.length) return "";
                                for(var e1 = this.head, r = "" + e1.data; e1 = e1.next;)r += t1 + e1.data;
                                return r;
                            }
                        },
                        {
                            key: "concat",
                            value: function(t1) {
                                if (0 === this.length) return o.alloc(0);
                                for(var e1, r, n, i = o.allocUnsafe(t1 >>> 0), a = this.head, s = 0; a;)e1 = a.data, r = i, n = s, o.prototype.copy.call(e1, r, n), s += a.data.length, a = a.next;
                                return i;
                            }
                        },
                        {
                            key: "consume",
                            value: function(t1, e1) {
                                var r;
                                return t1 < this.head.data.length ? (r = this.head.data.slice(0, t1), this.head.data = this.head.data.slice(t1)) : r = t1 === this.head.data.length ? this.shift() : e1 ? this._getString(t1) : this._getBuffer(t1), r;
                            }
                        },
                        {
                            key: "first",
                            value: function() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function(t1) {
                                var e1 = this.head, r = 1, n = e1.data;
                                for(t1 -= n.length; e1 = e1.next;){
                                    var i = e1.data, a = t1 > i.length ? i.length : t1;
                                    if (a === i.length ? n += i : n += i.slice(0, t1), 0 == (t1 -= a)) {
                                        a === i.length ? (++r, e1.next ? this.head = e1.next : this.head = this.tail = null) : (this.head = e1, e1.data = i.slice(a));
                                        break;
                                    }
                                    ++r;
                                }
                                return this.length -= r, n;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function(t1) {
                                var e1 = o.allocUnsafe(t1), r = this.head, n = 1;
                                for(r.data.copy(e1), t1 -= r.data.length; r = r.next;){
                                    var i = r.data, a = t1 > i.length ? i.length : t1;
                                    if (i.copy(e1, e1.length - t1, 0, a), 0 == (t1 -= a)) {
                                        a === i.length ? (++n, r.next ? this.head = r.next : this.head = this.tail = null) : (this.head = r, r.data = i.slice(a));
                                        break;
                                    }
                                    ++n;
                                }
                                return this.length -= n, e1;
                            }
                        },
                        {
                            key: l,
                            value: function(t1, e1) {
                                return s(this, function(t1) {
                                    for(var e1 = 1; e1 < arguments.length; e1++){
                                        var r = null != arguments[e1] ? arguments[e1] : {};
                                        e1 % 2 ? n(Object(r), !0).forEach(function(e1) {
                                            i(t1, e1, r[e1]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t1, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(e1) {
                                            Object.defineProperty(t1, e1, Object.getOwnPropertyDescriptor(r, e1));
                                        });
                                    }
                                    return t1;
                                }({}, e1, {
                                    depth: 0,
                                    customInspect: !1
                                }));
                            }
                        }
                    ], a(e1.prototype, r), c && a(e1, c), t1;
                }();
            },
            {
                buffer: 85,
                util: 83
            }
        ],
        294: [
            function(t1, e1, r) {
                (function(t1) {
                    (function() {
                        "use strict";
                        function r(t1, e1) {
                            i(t1, e1), n(t1);
                        }
                        function n(t1) {
                            t1._writableState && !t1._writableState.emitClose || t1._readableState && !t1._readableState.emitClose || t1.emit("close");
                        }
                        function i(t1, e1) {
                            t1.emit("error", e1);
                        }
                        e1.exports = {
                            destroy: function(e1, a) {
                                var o = this, s = this._readableState && this._readableState.destroyed, l = this._writableState && this._writableState.destroyed;
                                return s || l ? (a ? a(e1) : e1 && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, t1.nextTick(i, this, e1)) : t1.nextTick(i, this, e1)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e1 || null, function(e1) {
                                    !a && e1 ? o._writableState ? o._writableState.errorEmitted ? t1.nextTick(n, o) : (o._writableState.errorEmitted = !0, t1.nextTick(r, o, e1)) : t1.nextTick(r, o, e1) : a ? (t1.nextTick(n, o), a(e1)) : t1.nextTick(n, o);
                                }), this);
                            },
                            undestroy: function() {
                                this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                            },
                            errorOrDestroy: function(t1, e1) {
                                var r = t1._readableState, n = t1._writableState;
                                r && r.autoDestroy || n && n.autoDestroy ? t1.destroy(e1) : t1.emit("error", e1);
                            }
                        };
                    }).call(this);
                }).call(this, t1("_process"));
            },
            {
                _process: 277
            }
        ],
        295: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
                function i() {}
                e1.exports = function t1(e1, r, a) {
                    if ("function" == typeof r) return t1(e1, null, r);
                    r || (r = {}), a = function(t1) {
                        var e1 = !1;
                        return function() {
                            if (!e1) {
                                e1 = !0;
                                for(var r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
                                t1.apply(this, n);
                            }
                        };
                    }(a || i);
                    var o = r.readable || !1 !== r.readable && e1.readable, s = r.writable || !1 !== r.writable && e1.writable, l = function() {
                        e1.writable || u();
                    }, c = e1._writableState && e1._writableState.finished, u = function() {
                        s = !1, c = !0, o || a.call(e1);
                    }, f = e1._readableState && e1._readableState.endEmitted, h = function() {
                        o = !1, f = !0, s || a.call(e1);
                    }, p = function(t1) {
                        a.call(e1, t1);
                    }, d = function() {
                        var t1;
                        return o && !f ? (e1._readableState && e1._readableState.ended || (t1 = new n), a.call(e1, t1)) : s && !c ? (e1._writableState && e1._writableState.ended || (t1 = new n), a.call(e1, t1)) : void 0;
                    }, m = function() {
                        e1.req.on("finish", u);
                    };
                    return !function(t1) {
                        return t1.setHeader && "function" == typeof t1.abort;
                    }(e1) ? s && !e1._writableState && (e1.on("end", l), e1.on("close", l)) : (e1.on("complete", u), e1.on("abort", d), e1.req ? m() : e1.on("request", m)), e1.on("end", h), e1.on("finish", u), !1 !== r.error && e1.on("error", p), e1.on("close", d), function() {
                        e1.removeListener("complete", u), e1.removeListener("abort", d), e1.removeListener("request", m), e1.req && e1.req.removeListener("finish", u), e1.removeListener("end", l), e1.removeListener("close", l), e1.removeListener("finish", u), e1.removeListener("end", h), e1.removeListener("error", p), e1.removeListener("close", d);
                    };
                };
            },
            {
                "../../../errors": 286
            }
        ],
        296: [
            function(t1, e1, r) {
                e1.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            {}
        ],
        297: [
            function(t1, e1, r) {
                "use strict";
                var n;
                var i = t1("../../../errors").codes, a = i.ERR_MISSING_ARGS, o = i.ERR_STREAM_DESTROYED;
                function s(t1) {
                    if (t1) throw t1;
                }
                function l(e1, r, i, a) {
                    a = function(t1) {
                        var e1 = !1;
                        return function() {
                            e1 || (e1 = !0, t1.apply(void 0, arguments));
                        };
                    }(a);
                    var s = !1;
                    e1.on("close", function() {
                        s = !0;
                    }), void 0 === n && (n = t1("./end-of-stream")), n(e1, {
                        readable: r,
                        writable: i
                    }, function(t1) {
                        if (t1) return a(t1);
                        s = !0, a();
                    });
                    var l = !1;
                    return function(t1) {
                        if (!s && !l) return l = !0, function(t1) {
                            return t1.setHeader && "function" == typeof t1.abort;
                        }(e1) ? e1.abort() : "function" == typeof e1.destroy ? e1.destroy() : void a(t1 || new o("pipe"));
                    };
                }
                function c(t1) {
                    t1();
                }
                function u(t1, e1) {
                    return t1.pipe(e1);
                }
                function f(t1) {
                    return t1.length ? "function" != typeof t1[t1.length - 1] ? s : t1.pop() : s;
                }
                e1.exports = function() {
                    for(var t1 = arguments.length, e1 = new Array(t1), r = 0; r < t1; r++)e1[r] = arguments[r];
                    var n, i = f(e1);
                    if (Array.isArray(e1[0]) && (e1 = e1[0]), e1.length < 2) throw new a("streams");
                    var o = e1.map(function(t1, r) {
                        var a = r < e1.length - 1;
                        return l(t1, a, r > 0, function(t1) {
                            n || (n = t1), t1 && o.forEach(c), a || (o.forEach(c), i(n));
                        });
                    });
                    return e1.reduce(u);
                };
            },
            {
                "../../../errors": 286,
                "./end-of-stream": 295
            }
        ],
        298: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../errors").codes.ERR_INVALID_OPT_VALUE;
                e1.exports = {
                    getHighWaterMark: function(t1, e1, r, i) {
                        var a = function(t1, e1, r) {
                            return null != t1.highWaterMark ? t1.highWaterMark : e1 ? t1[r] : null;
                        }(e1, i, r);
                        if (null != a) {
                            if (!isFinite(a) || Math.floor(a) !== a || a < 0) throw new n(i ? r : "highWaterMark", a);
                            return Math.floor(a);
                        }
                        return t1.objectMode ? 16 : 16384;
                    }
                };
            },
            {
                "../../../errors": 286
            }
        ],
        299: [
            function(t1, e1, r) {
                e1.exports = t1("events").EventEmitter;
            },
            {
                events: 84
            }
        ],
        300: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("safe-buffer").Buffer, i = n.isEncoding || function(t1) {
                    switch((t1 = "" + t1) && t1.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return !0;
                        default:
                            return !1;
                    }
                };
                function a(t1) {
                    var e1;
                    switch(this.encoding = function(t1) {
                        var e1 = function(t1) {
                            if (!t1) return "utf8";
                            for(var e1;;)switch(t1){
                                case "utf8":
                                case "utf-8":
                                    return "utf8";
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return "utf16le";
                                case "latin1":
                                case "binary":
                                    return "latin1";
                                case "base64":
                                case "ascii":
                                case "hex":
                                    return t1;
                                default:
                                    if (e1) return;
                                    t1 = ("" + t1).toLowerCase(), e1 = !0;
                            }
                        }(t1);
                        if ("string" != typeof e1 && (n.isEncoding === i || !i(t1))) throw new Error("Unknown encoding: " + t1);
                        return e1 || t1;
                    }(t1), this.encoding){
                        case "utf16le":
                            this.text = l, this.end = c, e1 = 4;
                            break;
                        case "utf8":
                            this.fillLast = s, e1 = 4;
                            break;
                        case "base64":
                            this.text = u, this.end = f, e1 = 3;
                            break;
                        default:
                            return this.write = h, void (this.end = p);
                    }
                    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(e1);
                }
                function o(t1) {
                    return t1 <= 127 ? 0 : t1 >> 5 == 6 ? 2 : t1 >> 4 == 14 ? 3 : t1 >> 3 == 30 ? 4 : t1 >> 6 == 2 ? -1 : -2;
                }
                function s(t1) {
                    var e1 = this.lastTotal - this.lastNeed, r = function(t1, e1, r) {
                        if (128 != (192 & e1[0])) return t1.lastNeed = 0, "\ufffd";
                        if (t1.lastNeed > 1 && e1.length > 1) {
                            if (128 != (192 & e1[1])) return t1.lastNeed = 1, "\ufffd";
                            if (t1.lastNeed > 2 && e1.length > 2 && 128 != (192 & e1[2])) return t1.lastNeed = 2, "\ufffd";
                        }
                    }(this, t1);
                    return void 0 !== r ? r : this.lastNeed <= t1.length ? (t1.copy(this.lastChar, e1, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t1.copy(this.lastChar, e1, 0, t1.length), void (this.lastNeed -= t1.length));
                }
                function l(t1, e1) {
                    if ((t1.length - e1) % 2 == 0) {
                        var r = t1.toString("utf16le", e1);
                        if (r) {
                            var n = r.charCodeAt(r.length - 1);
                            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t1[t1.length - 2], this.lastChar[1] = t1[t1.length - 1], r.slice(0, -1);
                        }
                        return r;
                    }
                    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t1[t1.length - 1], t1.toString("utf16le", e1, t1.length - 1);
                }
                function c(t1) {
                    var e1 = t1 && t1.length ? this.write(t1) : "";
                    if (this.lastNeed) {
                        var r = this.lastTotal - this.lastNeed;
                        return e1 + this.lastChar.toString("utf16le", 0, r);
                    }
                    return e1;
                }
                function u(t1, e1) {
                    var r = (t1.length - e1) % 3;
                    return 0 === r ? t1.toString("base64", e1) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = t1[t1.length - 1] : (this.lastChar[0] = t1[t1.length - 2], this.lastChar[1] = t1[t1.length - 1]), t1.toString("base64", e1, t1.length - r));
                }
                function f(t1) {
                    var e1 = t1 && t1.length ? this.write(t1) : "";
                    return this.lastNeed ? e1 + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e1;
                }
                function h(t1) {
                    return t1.toString(this.encoding);
                }
                function p(t1) {
                    return t1 && t1.length ? this.write(t1) : "";
                }
                r.StringDecoder = a, a.prototype.write = function(t1) {
                    if (0 === t1.length) return "";
                    var e1, r;
                    if (this.lastNeed) {
                        if (void 0 === (e1 = this.fillLast(t1))) return "";
                        r = this.lastNeed, this.lastNeed = 0;
                    } else r = 0;
                    return r < t1.length ? e1 ? e1 + this.text(t1, r) : this.text(t1, r) : e1 || "";
                }, a.prototype.end = function(t1) {
                    var e1 = t1 && t1.length ? this.write(t1) : "";
                    return this.lastNeed ? e1 + "\ufffd" : e1;
                }, a.prototype.text = function(t1, e1) {
                    var r = function(t1, e1, r) {
                        var n = e1.length - 1;
                        if (n < r) return 0;
                        var i = o(e1[n]);
                        if (i >= 0) return i > 0 && (t1.lastNeed = i - 1), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(e1[n])) >= 0) return i > 0 && (t1.lastNeed = i - 2), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(e1[n])) >= 0) return i > 0 && (2 === i ? i = 0 : t1.lastNeed = i - 3), i;
                        return 0;
                    }(this, t1, e1);
                    if (!this.lastNeed) return t1.toString("utf8", e1);
                    this.lastTotal = r;
                    var n = t1.length - (r - this.lastNeed);
                    return t1.copy(this.lastChar, 0, n), t1.toString("utf8", e1, n);
                }, a.prototype.fillLast = function(t1) {
                    if (this.lastNeed <= t1.length) return t1.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    t1.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t1.length), this.lastNeed -= t1.length;
                };
            },
            {
                "safe-buffer": 284
            }
        ],
        301: [
            function(t1, e1, r) {
                (function(r, n) {
                    (function() {
                        var r = t1("assert"), i = t1("debug")("stream-parser");
                        e1.exports = function(t1) {
                            var e1 = t1 && "function" == typeof t1._transform, r = t1 && "function" == typeof t1._write;
                            if (!e1 && !r) throw new Error("must pass a Writable or Transform stream in");
                            i("extending Parser into stream"), t1._bytes = o, t1._skipBytes = s, e1 && (t1._passthrough = l);
                            e1 ? t1._transform = u : t1._write = c;
                        };
                        function a(t1) {
                            i("initializing parser stream"), t1._parserBytesLeft = 0, t1._parserBuffers = [], t1._parserBuffered = 0, t1._parserState = -1, t1._parserCallback = null, "function" == typeof t1.push && (t1._parserOutput = t1.push.bind(t1)), t1._parserInit = !0;
                        }
                        function o(t1, e1) {
                            r(!this._parserCallback, 'there is already a "callback" set!'), r(isFinite(t1) && t1 > 0, 'can only buffer a finite number of bytes > 0, got "' + t1 + '"'), this._parserInit || a(this), i("buffering %o bytes", t1), this._parserBytesLeft = t1, this._parserCallback = e1, this._parserState = 0;
                        }
                        function s(t1, e1) {
                            r(!this._parserCallback, 'there is already a "callback" set!'), r(t1 > 0, 'can only skip > 0 bytes, got "' + t1 + '"'), this._parserInit || a(this), i("skipping %o bytes", t1), this._parserBytesLeft = t1, this._parserCallback = e1, this._parserState = 1;
                        }
                        function l(t1, e1) {
                            r(!this._parserCallback, 'There is already a "callback" set!'), r(t1 > 0, 'can only pass through > 0 bytes, got "' + t1 + '"'), this._parserInit || a(this), i("passing through %o bytes", t1), this._parserBytesLeft = t1, this._parserCallback = e1, this._parserState = 2;
                        }
                        function c(t1, e1, r) {
                            this._parserInit || a(this), i("write(%o bytes)", t1.length), "function" == typeof e1 && (r = e1), h(this, t1, null, r);
                        }
                        function u(t1, e1, r) {
                            this._parserInit || a(this), i("transform(%o bytes)", t1.length), "function" != typeof e1 && (e1 = this._parserOutput), h(this, t1, e1, r);
                        }
                        function f(t1, e1, r, a) {
                            if (t1._parserBytesLeft -= e1.length, i("%o bytes left for stream piece", t1._parserBytesLeft), 0 === t1._parserState ? (t1._parserBuffers.push(e1), t1._parserBuffered += e1.length) : 2 === t1._parserState && r(e1), 0 !== t1._parserBytesLeft) return a;
                            var o = t1._parserCallback;
                            if (o && 0 === t1._parserState && t1._parserBuffers.length > 1 && (e1 = n.concat(t1._parserBuffers, t1._parserBuffered)), 0 !== t1._parserState && (e1 = null), t1._parserCallback = null, t1._parserBuffered = 0, t1._parserState = -1, t1._parserBuffers.splice(0), o) {
                                var s = [];
                                e1 && s.push(e1), r && s.push(r);
                                var l = o.length > s.length;
                                l && s.push(p(a));
                                var c = o.apply(t1, s);
                                if (!l || a === c) return a;
                            }
                        }
                        var h = p(function t1(e1, r, n, i) {
                            return e1._parserBytesLeft <= 0 ? i(new Error("got data but not currently parsing anything")) : r.length <= e1._parserBytesLeft ? function() {
                                return f(e1, r, n, i);
                            } : function() {
                                var a = r.slice(0, e1._parserBytesLeft);
                                return f(e1, a, n, function(o) {
                                    return o ? i(o) : r.length > a.length ? function() {
                                        return t1(e1, r.slice(a.length), n, i);
                                    } : void 0;
                                });
                            };
                        });
                        function p(t1) {
                            return function() {
                                for(var e1 = t1.apply(this, arguments); "function" == typeof e1;)e1 = e1();
                                return e1;
                            };
                        }
                    }).call(this);
                }).call(this, t1("_process"), t1("buffer").Buffer);
            },
            {
                _process: 277,
                assert: 75,
                buffer: 85,
                debug: 302
            }
        ],
        302: [
            function(t1, e1, r) {
                (function(n) {
                    (function() {
                        function i() {
                            var t1;
                            try {
                                t1 = r.storage.debug;
                            } catch (t1) {}
                            return !t1 && void 0 !== n && "env" in n && (t1 = n.env.DEBUG), t1;
                        }
                        (r = e1.exports = t1("./debug")).log = function() {
                            return "object" == typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
                        }, r.formatArgs = function(t1) {
                            var e1 = this.useColors;
                            if (t1[0] = (e1 ? "%c" : "") + this.namespace + (e1 ? " %c" : " ") + t1[0] + (e1 ? "%c " : " ") + "+" + r.humanize(this.diff), !e1) return;
                            var n = "color: " + this.color;
                            t1.splice(1, 0, n, "color: inherit");
                            var i = 0, a = 0;
                            t1[0].replace(/%[a-zA-Z%]/g, function(t1) {
                                "%%" !== t1 && (i++, "%c" === t1 && (a = i));
                            }), t1.splice(a, 0, n);
                        }, r.save = function(t1) {
                            try {
                                null == t1 ? r.storage.removeItem("debug") : r.storage.debug = t1;
                            } catch (t1) {}
                        }, r.load = i, r.useColors = function() {
                            if ("undefined" != typeof window && window.process && "renderer" === window.process.type) return !0;
                            return "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
                        }, r.storage = "undefined" != typeof chrome && void 0 !== chrome.storage ? chrome.storage.local : function() {
                            try {
                                return window.localStorage;
                            } catch (t1) {}
                        }(), r.colors = [
                            "lightseagreen",
                            "forestgreen",
                            "goldenrod",
                            "dodgerblue",
                            "darkorchid",
                            "crimson"
                        ], r.formatters.j = function(t1) {
                            try {
                                return JSON.stringify(t1);
                            } catch (t1) {
                                return "[UnexpectedJSONParseError]: " + t1.message;
                            }
                        }, r.enable(i());
                    }).call(this);
                }).call(this, t1("_process"));
            },
            {
                "./debug": 303,
                _process: 277
            }
        ],
        303: [
            function(t1, e1, r) {
                var n;
                function i(t1) {
                    function e1() {
                        if (e1.enabled) {
                            var t1 = e1, i = +new Date, a = i - (n || i);
                            t1.diff = a, t1.prev = n, t1.curr = i, n = i;
                            for(var o = new Array(arguments.length), s = 0; s < o.length; s++)o[s] = arguments[s];
                            o[0] = r.coerce(o[0]), "string" != typeof o[0] && o.unshift("%O");
                            var l = 0;
                            o[0] = o[0].replace(/%([a-zA-Z%])/g, function(e1, n) {
                                if ("%%" === e1) return e1;
                                l++;
                                var i = r.formatters[n];
                                if ("function" == typeof i) {
                                    var a = o[l];
                                    e1 = i.call(t1, a), o.splice(l, 1), l--;
                                }
                                return e1;
                            }), r.formatArgs.call(t1, o);
                            var c = e1.log || r.log || console.log.bind(console);
                            c.apply(t1, o);
                        }
                    }
                    return e1.namespace = t1, e1.enabled = r.enabled(t1), e1.useColors = r.useColors(), e1.color = function(t1) {
                        var e1, n = 0;
                        for(e1 in t1)n = (n << 5) - n + t1.charCodeAt(e1), n |= 0;
                        return r.colors[Math.abs(n) % r.colors.length];
                    }(t1), "function" == typeof r.init && r.init(e1), e1;
                }
                (r = e1.exports = i.debug = i.default = i).coerce = function(t1) {
                    return t1 instanceof Error ? t1.stack || t1.message : t1;
                }, r.disable = function() {
                    r.enable("");
                }, r.enable = function(t1) {
                    r.save(t1), r.names = [], r.skips = [];
                    for(var e1 = ("string" == typeof t1 ? t1 : "").split(/[\s,]+/), n = e1.length, i = 0; i < n; i++)e1[i] && ("-" === (t1 = e1[i].replace(/\*/g, ".*?"))[0] ? r.skips.push(new RegExp("^" + t1.substr(1) + "$")) : r.names.push(new RegExp("^" + t1 + "$")));
                }, r.enabled = function(t1) {
                    var e1, n;
                    for(e1 = 0, n = r.skips.length; e1 < n; e1++)if (r.skips[e1].test(t1)) return !1;
                    for(e1 = 0, n = r.names.length; e1 < n; e1++)if (r.names[e1].test(t1)) return !0;
                    return !1;
                }, r.humanize = t1("ms"), r.names = [], r.skips = [], r.formatters = {};
            },
            {
                ms: 304
            }
        ],
        304: [
            function(t1, e1, r) {
                var n = 1e3, i = 6e4, a = 60 * i, o = 24 * a;
                function s(t1, e1, r) {
                    if (!(t1 < e1)) return t1 < 1.5 * e1 ? Math.floor(t1 / e1) + " " + r : Math.ceil(t1 / e1) + " " + r + "s";
                }
                e1.exports = function(t1, e1) {
                    e1 = e1 || {};
                    var r, l = typeof t1;
                    if ("string" === l && t1.length > 0) return function(t1) {
                        if ((t1 = String(t1)).length > 100) return;
                        var e1 = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t1);
                        if (!e1) return;
                        var r = parseFloat(e1[1]);
                        switch((e1[2] || "ms").toLowerCase()){
                            case "years":
                            case "year":
                            case "yrs":
                            case "yr":
                            case "y":
                                return 315576e5 * r;
                            case "days":
                            case "day":
                            case "d":
                                return r * o;
                            case "hours":
                            case "hour":
                            case "hrs":
                            case "hr":
                            case "h":
                                return r * a;
                            case "minutes":
                            case "minute":
                            case "mins":
                            case "min":
                            case "m":
                                return r * i;
                            case "seconds":
                            case "second":
                            case "secs":
                            case "sec":
                            case "s":
                                return r * n;
                            case "milliseconds":
                            case "millisecond":
                            case "msecs":
                            case "msec":
                            case "ms":
                                return r;
                            default:
                                return;
                        }
                    }(t1);
                    if ("number" === l && !1 === isNaN(t1)) return e1.long ? s(r = t1, o, "day") || s(r, a, "hour") || s(r, i, "minute") || s(r, n, "second") || r + " ms" : function(t1) {
                        if (t1 >= o) return Math.round(t1 / o) + "d";
                        if (t1 >= a) return Math.round(t1 / a) + "h";
                        if (t1 >= i) return Math.round(t1 / i) + "m";
                        if (t1 >= n) return Math.round(t1 / n) + "s";
                        return t1 + "ms";
                    }(t1);
                    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t1));
                };
            },
            {}
        ],
        305: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("parenthesis");
                e1.exports = function(t1, e1, r) {
                    if (null == t1) throw Error("First argument should be a string");
                    if (null == e1) throw Error("Separator should be a string or a RegExp");
                    r ? ("string" == typeof r || Array.isArray(r)) && (r = {
                        ignore: r
                    }) : r = {}, null == r.escape && (r.escape = !0), null == r.ignore ? r.ignore = [
                        "[]",
                        "()",
                        "{}",
                        "<>",
                        '""',
                        "''",
                        "``",
                        "\u201c\u201d",
                        "\xab\xbb"
                    ] : ("string" == typeof r.ignore && (r.ignore = [
                        r.ignore
                    ]), r.ignore = r.ignore.map(function(t1) {
                        return 1 === t1.length && (t1 += t1), t1;
                    }));
                    var i = n.parse(t1, {
                        flat: !0,
                        brackets: r.ignore
                    }), a = i[0].split(e1);
                    if (r.escape) {
                        for(var o = [], s = 0; s < a.length; s++){
                            var l = a[s], c = a[s + 1];
                            "\\" === l[l.length - 1] && "\\" !== l[l.length - 2] ? (o.push(l + e1 + c), s++) : o.push(l);
                        }
                        a = o;
                    }
                    for(s = 0; s < a.length; s++)i[0] = a[s], a[s] = n.stringify(i, {
                        flat: !0
                    });
                    return a;
                };
            },
            {
                parenthesis: 248
            }
        ],
        306: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    for(var e1 = t1.length, r = new Array(e1), n = new Array(e1), i = new Array(e1), a = new Array(e1), o = new Array(e1), s = new Array(e1), l = 0; l < e1; ++l)r[l] = -1, n[l] = 0, i[l] = !1, a[l] = 0, o[l] = -1, s[l] = [];
                    var c, u = 0, f = [], h = [];
                    function p(e1) {
                        var l = [
                            e1
                        ], c = [
                            e1
                        ];
                        for(r[e1] = n[e1] = u, i[e1] = !0, u += 1; c.length > 0;){
                            e1 = c[c.length - 1];
                            var p = t1[e1];
                            if (a[e1] < p.length) {
                                for(var d = a[e1]; d < p.length; ++d){
                                    var m = p[d];
                                    if (r[m] < 0) {
                                        r[m] = n[m] = u, i[m] = !0, u += 1, l.push(m), c.push(m);
                                        break;
                                    }
                                    i[m] && (n[e1] = 0 | Math.min(n[e1], n[m])), o[m] >= 0 && s[e1].push(o[m]);
                                }
                                a[e1] = d;
                            } else {
                                if (n[e1] === r[e1]) {
                                    var g = [], v = [], y = 0;
                                    for(d = l.length - 1; d >= 0; --d){
                                        var x = l[d];
                                        if (i[x] = !1, g.push(x), v.push(s[x]), y += s[x].length, o[x] = f.length, x === e1) {
                                            l.length = d;
                                            break;
                                        }
                                    }
                                    f.push(g);
                                    var b = new Array(y);
                                    for(d = 0; d < v.length; d++)for(var _ = 0; _ < v[d].length; _++)b[--y] = v[d][_];
                                    h.push(b);
                                }
                                c.pop();
                            }
                        }
                    }
                    for(l = 0; l < e1; ++l)r[l] < 0 && p(l);
                    for(l = 0; l < h.length; l++){
                        var d = h[l];
                        if (0 !== d.length) {
                            d.sort(function(t1, e1) {
                                return t1 - e1;
                            }), c = [
                                d[0]
                            ];
                            for(var m = 1; m < d.length; m++)d[m] !== d[m - 1] && c.push(d[m]);
                            h[l] = c;
                        }
                    }
                    return {
                        components: f,
                        adjacencyList: h
                    };
                };
            },
            {}
        ],
        307: [
            function(t1, e1, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
                var n = function(t1, e1) {
                    if (Array.isArray(t1)) return t1;
                    if (Symbol.iterator in Object(t1)) return function(t1, e1) {
                        var r = [], n = !0, i = !1, a = void 0;
                        try {
                            for(var o, s = t1[Symbol.iterator](); !(n = (o = s.next()).done) && (r.push(o.value), !e1 || r.length !== e1); n = !0);
                        } catch (t1) {
                            i = !0, a = t1;
                        } finally{
                            try {
                                !n && s.return && s.return();
                            } finally{
                                if (i) throw a;
                            }
                        }
                        return r;
                    }(t1, e1);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                }, i = 2 * Math.PI, a = function(t1, e1, r, n, i, a, o) {
                    var s = t1.x, l = t1.y;
                    return {
                        x: n * (s *= e1) - i * (l *= r) + a,
                        y: i * s + n * l + o
                    };
                }, o = function(t1, e1) {
                    var r = 1.5707963267948966 === e1 ? .551915024494 : -1.5707963267948966 === e1 ? -0.551915024494 : 4 / 3 * Math.tan(e1 / 4), n = Math.cos(t1), i = Math.sin(t1), a = Math.cos(t1 + e1), o = Math.sin(t1 + e1);
                    return [
                        {
                            x: n - i * r,
                            y: i + n * r
                        },
                        {
                            x: a + o * r,
                            y: o - a * r
                        },
                        {
                            x: a,
                            y: o
                        }
                    ];
                }, s = function(t1, e1, r, n) {
                    var i = t1 * r + e1 * n;
                    return i > 1 && (i = 1), i < -1 && (i = -1), (t1 * n - e1 * r < 0 ? -1 : 1) * Math.acos(i);
                };
                r.default = function(t1) {
                    var e1 = t1.px, r = t1.py, l = t1.cx, c = t1.cy, u = t1.rx, f = t1.ry, h = t1.xAxisRotation, p = void 0 === h ? 0 : h, d = t1.largeArcFlag, m = void 0 === d ? 0 : d, g = t1.sweepFlag, v = void 0 === g ? 0 : g, y = [];
                    if (0 === u || 0 === f) return [];
                    var x = Math.sin(p * i / 360), b = Math.cos(p * i / 360), _ = b * (e1 - l) / 2 + x * (r - c) / 2, w = -x * (e1 - l) / 2 + b * (r - c) / 2;
                    if (0 === _ && 0 === w) return [];
                    u = Math.abs(u), f = Math.abs(f);
                    var T = Math.pow(_, 2) / Math.pow(u, 2) + Math.pow(w, 2) / Math.pow(f, 2);
                    T > 1 && (u *= Math.sqrt(T), f *= Math.sqrt(T));
                    var k = function(t1, e1, r, n, a, o, l, c, u, f, h, p) {
                        var d = Math.pow(a, 2), m = Math.pow(o, 2), g = Math.pow(h, 2), v = Math.pow(p, 2), y = d * m - d * v - m * g;
                        y < 0 && (y = 0), y /= d * v + m * g;
                        var x = (y = Math.sqrt(y) * (l === c ? -1 : 1)) * a / o * p, b = y * -o / a * h, _ = f * x - u * b + (t1 + r) / 2, w = u * x + f * b + (e1 + n) / 2, T = (h - x) / a, k = (p - b) / o, A = (-h - x) / a, M = (-p - b) / o, S = s(1, 0, T, k), E = s(T, k, A, M);
                        return 0 === c && E > 0 && (E -= i), 1 === c && E < 0 && (E += i), [
                            _,
                            w,
                            S,
                            E
                        ];
                    }(e1, r, l, c, u, f, m, v, x, b, _, w), A = n(k, 4), M = A[0], S = A[1], E = A[2], L = A[3], C = Math.abs(L) / (i / 4);
                    Math.abs(1 - C) < 1e-7 && (C = 1);
                    var P = Math.max(Math.ceil(C), 1);
                    L /= P;
                    for(var I = 0; I < P; I++)y.push(o(E, L)), E += L;
                    return y.map(function(t1) {
                        var e1 = a(t1[0], u, f, b, x, M, S), r = e1.x, n = e1.y, i = a(t1[1], u, f, b, x, M, S), o = i.x, s = i.y, l = a(t1[2], u, f, b, x, M, S);
                        return {
                            x1: r,
                            y1: n,
                            x2: o,
                            y2: s,
                            x: l.x,
                            y: l.y
                        };
                    });
                }, e1.exports = r.default;
            },
            {}
        ],
        308: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("parse-svg-path"), i = t1("abs-svg-path"), a = t1("normalize-svg-path"), o = t1("is-svg-path"), s = t1("assert");
                e1.exports = function(t1) {
                    Array.isArray(t1) && 1 === t1.length && "string" == typeof t1[0] && (t1 = t1[0]);
                    "string" == typeof t1 && (s(o(t1), "String is not an SVG path."), t1 = n(t1));
                    if (s(Array.isArray(t1), "Argument should be a string or an array of path segments."), t1 = i(t1), !(t1 = a(t1)).length) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    for(var e1 = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], r = 0, l = t1.length; r < l; r++)for(var c = t1[r].slice(1), u = 0; u < c.length; u += 2)c[u + 0] < e1[0] && (e1[0] = c[u + 0]), c[u + 1] < e1[1] && (e1[1] = c[u + 1]), c[u + 0] > e1[2] && (e1[2] = c[u + 0]), c[u + 1] > e1[3] && (e1[3] = c[u + 1]);
                    return e1;
                };
            },
            {
                "abs-svg-path": 70,
                assert: 75,
                "is-svg-path": 238,
                "normalize-svg-path": 309,
                "parse-svg-path": 250
            }
        ],
        309: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    for(var e1, r = [], o = 0, s = 0, l = 0, c = 0, u = null, f = null, h = 0, p = 0, d = 0, m = t1.length; d < m; d++){
                        var g = t1[d], v = g[0];
                        switch(v){
                            case "M":
                                l = g[1], c = g[2];
                                break;
                            case "A":
                                var y = n({
                                    px: h,
                                    py: p,
                                    cx: g[6],
                                    cy: g[7],
                                    rx: g[1],
                                    ry: g[2],
                                    xAxisRotation: g[3],
                                    largeArcFlag: g[4],
                                    sweepFlag: g[5]
                                });
                                if (!y.length) continue;
                                for(var x, b = 0; b < y.length; b++)x = y[b], g = [
                                    "C",
                                    x.x1,
                                    x.y1,
                                    x.x2,
                                    x.y2,
                                    x.x,
                                    x.y
                                ], b < y.length - 1 && r.push(g);
                                break;
                            case "S":
                                var _ = h, w = p;
                                "C" != e1 && "S" != e1 || (_ += _ - o, w += w - s), g = [
                                    "C",
                                    _,
                                    w,
                                    g[1],
                                    g[2],
                                    g[3],
                                    g[4]
                                ];
                                break;
                            case "T":
                                "Q" == e1 || "T" == e1 ? (u = 2 * h - u, f = 2 * p - f) : (u = h, f = p), g = a(h, p, u, f, g[1], g[2]);
                                break;
                            case "Q":
                                u = g[1], f = g[2], g = a(h, p, g[1], g[2], g[3], g[4]);
                                break;
                            case "L":
                                g = i(h, p, g[1], g[2]);
                                break;
                            case "H":
                                g = i(h, p, g[1], p);
                                break;
                            case "V":
                                g = i(h, p, h, g[1]);
                                break;
                            case "Z":
                                g = i(h, p, l, c);
                        }
                        e1 = v, h = g[g.length - 2], p = g[g.length - 1], g.length > 4 ? (o = g[g.length - 4], s = g[g.length - 3]) : (o = h, s = p), r.push(g);
                    }
                    return r;
                };
                var n = t1("svg-arc-to-cubic-bezier");
                function i(t1, e1, r, n) {
                    return [
                        "C",
                        t1,
                        e1,
                        r,
                        n,
                        r,
                        n
                    ];
                }
                function a(t1, e1, r, n, i, a) {
                    return [
                        "C",
                        t1 / 3 + 2 / 3 * r,
                        e1 / 3 + 2 / 3 * n,
                        i / 3 + 2 / 3 * r,
                        a / 3 + 2 / 3 * n,
                        i,
                        a
                    ];
                }
            },
            {
                "svg-arc-to-cubic-bezier": 307
            }
        ],
        310: [
            function(t1, e1, r) {
                "use strict";
                var n, i = t1("svg-path-bounds"), a = t1("parse-svg-path"), o = t1("draw-svg-path"), s = t1("is-svg-path"), l = t1("bitmap-sdf"), c = document.createElement("canvas"), u = c.getContext("2d");
                e1.exports = function(t1, e1) {
                    if (!s(t1)) throw Error("Argument should be valid svg path string");
                    e1 || (e1 = {});
                    var r, f;
                    e1.shape ? (r = e1.shape[0], f = e1.shape[1]) : (r = c.width = e1.w || e1.width || 200, f = c.height = e1.h || e1.height || 200);
                    var h = Math.min(r, f), p = e1.stroke || 0, d = e1.viewbox || e1.viewBox || i(t1), m = [
                        r / (d[2] - d[0]),
                        f / (d[3] - d[1])
                    ], g = Math.min(m[0] || 0, m[1] || 0) / 2;
                    u.fillStyle = "black", u.fillRect(0, 0, r, f), u.fillStyle = "white", p && ("number" != typeof p && (p = 1), u.strokeStyle = p > 0 ? "white" : "black", u.lineWidth = Math.abs(p));
                    if (u.translate(.5 * r, .5 * f), u.scale(g, g), function() {
                        if (null != n) return n;
                        var t1 = document.createElement("canvas").getContext("2d");
                        if (t1.canvas.width = t1.canvas.height = 1, !window.Path2D) return n = !1;
                        var e1 = new Path2D("M0,0h1v1h-1v-1Z");
                        t1.fillStyle = "black", t1.fill(e1);
                        var r = t1.getImageData(0, 0, 1, 1);
                        return n = r && r.data && 255 === r.data[3];
                    }()) {
                        var v = new Path2D(t1);
                        u.fill(v), p && u.stroke(v);
                    } else {
                        var y = a(t1);
                        o(u, y), u.fill(), p && u.stroke();
                    }
                    return u.setTransform(1, 0, 0, 1, 0, 0), l(u, {
                        cutoff: null != e1.cutoff ? e1.cutoff : .5,
                        radius: null != e1.radius ? e1.radius : .5 * h
                    });
                };
            },
            {
                "bitmap-sdf": 82,
                "draw-svg-path": 126,
                "is-svg-path": 238,
                "parse-svg-path": 250,
                "svg-path-bounds": 308
            }
        ],
        311: [
            function(t1, e1, r) {
                (function(e1, n) {
                    (function() {
                        var i = t1("process/browser.js").nextTick, a = Function.prototype.apply, o = Array.prototype.slice, s = {}, l = 0;
                        function c(t1, e1) {
                            this._id = t1, this._clearFn = e1;
                        }
                        r.setTimeout = function() {
                            return new c(a.call(setTimeout, window, arguments), clearTimeout);
                        }, r.setInterval = function() {
                            return new c(a.call(setInterval, window, arguments), clearInterval);
                        }, r.clearTimeout = r.clearInterval = function(t1) {
                            t1.close();
                        }, c.prototype.unref = c.prototype.ref = function() {}, c.prototype.close = function() {
                            this._clearFn.call(window, this._id);
                        }, r.enroll = function(t1, e1) {
                            clearTimeout(t1._idleTimeoutId), t1._idleTimeout = e1;
                        }, r.unenroll = function(t1) {
                            clearTimeout(t1._idleTimeoutId), t1._idleTimeout = -1;
                        }, r._unrefActive = r.active = function(t1) {
                            clearTimeout(t1._idleTimeoutId);
                            var e1 = t1._idleTimeout;
                            e1 >= 0 && (t1._idleTimeoutId = setTimeout(function() {
                                t1._onTimeout && t1._onTimeout();
                            }, e1));
                        }, r.setImmediate = "function" == typeof e1 ? e1 : function(t1) {
                            var e1 = l++, n = !(arguments.length < 2) && o.call(arguments, 1);
                            return s[e1] = !0, i(function() {
                                s[e1] && (n ? t1.apply(null, n) : t1.call(null), r.clearImmediate(e1));
                            }), e1;
                        }, r.clearImmediate = "function" == typeof n ? n : function(t1) {
                            delete s[t1];
                        };
                    }).call(this);
                }).call(this, t1("timers").setImmediate, t1("timers").clearImmediate);
            },
            {
                "process/browser.js": 277,
                timers: 311
            }
        ],
        312: [
            function(t1, e1, r) {
                !function(t1) {
                    var r = /^\s+/, n = /\s+$/, i = 0, a = t1.round, o = t1.min, s = t1.max, l = t1.random;
                    function c(e1, l) {
                        if (l = l || {}, (e1 = e1 || "") instanceof c) return e1;
                        if (!(this instanceof c)) return new c(e1, l);
                        var u = function(e1) {
                            var i = {
                                r: 0,
                                g: 0,
                                b: 0
                            }, a = 1, l = null, c = null, u = null, f = !1, h = !1;
                            "string" == typeof e1 && (e1 = function(t1) {
                                t1 = t1.replace(r, "").replace(n, "").toLowerCase();
                                var e1, i = !1;
                                if (S[t1]) t1 = S[t1], i = !0;
                                else if ("transparent" == t1) return {
                                    r: 0,
                                    g: 0,
                                    b: 0,
                                    a: 0,
                                    format: "name"
                                };
                                if (e1 = j.rgb.exec(t1)) return {
                                    r: e1[1],
                                    g: e1[2],
                                    b: e1[3]
                                };
                                if (e1 = j.rgba.exec(t1)) return {
                                    r: e1[1],
                                    g: e1[2],
                                    b: e1[3],
                                    a: e1[4]
                                };
                                if (e1 = j.hsl.exec(t1)) return {
                                    h: e1[1],
                                    s: e1[2],
                                    l: e1[3]
                                };
                                if (e1 = j.hsla.exec(t1)) return {
                                    h: e1[1],
                                    s: e1[2],
                                    l: e1[3],
                                    a: e1[4]
                                };
                                if (e1 = j.hsv.exec(t1)) return {
                                    h: e1[1],
                                    s: e1[2],
                                    v: e1[3]
                                };
                                if (e1 = j.hsva.exec(t1)) return {
                                    h: e1[1],
                                    s: e1[2],
                                    v: e1[3],
                                    a: e1[4]
                                };
                                if (e1 = j.hex8.exec(t1)) return {
                                    r: I(e1[1]),
                                    g: I(e1[2]),
                                    b: I(e1[3]),
                                    a: R(e1[4]),
                                    format: i ? "name" : "hex8"
                                };
                                if (e1 = j.hex6.exec(t1)) return {
                                    r: I(e1[1]),
                                    g: I(e1[2]),
                                    b: I(e1[3]),
                                    format: i ? "name" : "hex"
                                };
                                if (e1 = j.hex4.exec(t1)) return {
                                    r: I(e1[1] + "" + e1[1]),
                                    g: I(e1[2] + "" + e1[2]),
                                    b: I(e1[3] + "" + e1[3]),
                                    a: R(e1[4] + "" + e1[4]),
                                    format: i ? "name" : "hex8"
                                };
                                if (e1 = j.hex3.exec(t1)) return {
                                    r: I(e1[1] + "" + e1[1]),
                                    g: I(e1[2] + "" + e1[2]),
                                    b: I(e1[3] + "" + e1[3]),
                                    format: i ? "name" : "hex"
                                };
                                return !1;
                            }(e1));
                            "object" == typeof e1 && (U(e1.r) && U(e1.g) && U(e1.b) ? (p = e1.r, d = e1.g, m = e1.b, i = {
                                r: 255 * C(p, 255),
                                g: 255 * C(d, 255),
                                b: 255 * C(m, 255)
                            }, f = !0, h = "%" === String(e1.r).substr(-1) ? "prgb" : "rgb") : U(e1.h) && U(e1.s) && U(e1.v) ? (l = z(e1.s), c = z(e1.v), i = function(e1, r, n) {
                                e1 = 6 * C(e1, 360), r = C(r, 100), n = C(n, 100);
                                var i = t1.floor(e1), a = e1 - i, o = n * (1 - r), s = n * (1 - a * r), l = n * (1 - (1 - a) * r), c = i % 6;
                                return {
                                    r: 255 * [
                                        n,
                                        s,
                                        o,
                                        o,
                                        l,
                                        n
                                    ][c],
                                    g: 255 * [
                                        l,
                                        n,
                                        n,
                                        s,
                                        o,
                                        o
                                    ][c],
                                    b: 255 * [
                                        o,
                                        o,
                                        l,
                                        n,
                                        n,
                                        s
                                    ][c]
                                };
                            }(e1.h, l, c), f = !0, h = "hsv") : U(e1.h) && U(e1.s) && U(e1.l) && (l = z(e1.s), u = z(e1.l), i = function(t1, e1, r) {
                                var n, i, a;
                                function o(t1, e1, r) {
                                    return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t1 + 6 * (e1 - t1) * r : r < .5 ? e1 : r < 2 / 3 ? t1 + (e1 - t1) * (2 / 3 - r) * 6 : t1;
                                }
                                if (t1 = C(t1, 360), e1 = C(e1, 100), r = C(r, 100), 0 === e1) n = i = a = r;
                                else {
                                    var s = r < .5 ? r * (1 + e1) : r + e1 - r * e1, l = 2 * r - s;
                                    n = o(l, s, t1 + 1 / 3), i = o(l, s, t1), a = o(l, s, t1 - 1 / 3);
                                }
                                return {
                                    r: 255 * n,
                                    g: 255 * i,
                                    b: 255 * a
                                };
                            }(e1.h, l, u), f = !0, h = "hsl"), e1.hasOwnProperty("a") && (a = e1.a));
                            var p, d, m;
                            return a = L(a), {
                                ok: f,
                                format: e1.format || h,
                                r: o(255, s(i.r, 0)),
                                g: o(255, s(i.g, 0)),
                                b: o(255, s(i.b, 0)),
                                a: a
                            };
                        }(e1);
                        this._originalInput = e1, this._r = u.r, this._g = u.g, this._b = u.b, this._a = u.a, this._roundA = a(100 * this._a) / 100, this._format = l.format || u.format, this._gradientType = l.gradientType, this._r < 1 && (this._r = a(this._r)), this._g < 1 && (this._g = a(this._g)), this._b < 1 && (this._b = a(this._b)), this._ok = u.ok, this._tc_id = i++;
                    }
                    function u(t1, e1, r) {
                        t1 = C(t1, 255), e1 = C(e1, 255), r = C(r, 255);
                        var n, i, a = s(t1, e1, r), l = o(t1, e1, r), c = (a + l) / 2;
                        if (a == l) n = i = 0;
                        else {
                            var u = a - l;
                            switch(i = c > .5 ? u / (2 - a - l) : u / (a + l), a){
                                case t1:
                                    n = (e1 - r) / u + (e1 < r ? 6 : 0);
                                    break;
                                case e1:
                                    n = (r - t1) / u + 2;
                                    break;
                                case r:
                                    n = (t1 - e1) / u + 4;
                            }
                            n /= 6;
                        }
                        return {
                            h: n,
                            s: i,
                            l: c
                        };
                    }
                    function f(t1, e1, r) {
                        t1 = C(t1, 255), e1 = C(e1, 255), r = C(r, 255);
                        var n, i, a = s(t1, e1, r), l = o(t1, e1, r), c = a, u = a - l;
                        if (i = 0 === a ? 0 : u / a, a == l) n = 0;
                        else {
                            switch(a){
                                case t1:
                                    n = (e1 - r) / u + (e1 < r ? 6 : 0);
                                    break;
                                case e1:
                                    n = (r - t1) / u + 2;
                                    break;
                                case r:
                                    n = (t1 - e1) / u + 4;
                            }
                            n /= 6;
                        }
                        return {
                            h: n,
                            s: i,
                            v: c
                        };
                    }
                    function h(t1, e1, r, n) {
                        var i = [
                            O(a(t1).toString(16)),
                            O(a(e1).toString(16)),
                            O(a(r).toString(16))
                        ];
                        return n && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
                    }
                    function p(t1, e1, r, n) {
                        return [
                            O(D(n)),
                            O(a(t1).toString(16)),
                            O(a(e1).toString(16)),
                            O(a(r).toString(16))
                        ].join("");
                    }
                    function d(t1, e1) {
                        e1 = 0 === e1 ? 0 : e1 || 10;
                        var r = c(t1).toHsl();
                        return r.s -= e1 / 100, r.s = P(r.s), c(r);
                    }
                    function m(t1, e1) {
                        e1 = 0 === e1 ? 0 : e1 || 10;
                        var r = c(t1).toHsl();
                        return r.s += e1 / 100, r.s = P(r.s), c(r);
                    }
                    function g(t1) {
                        return c(t1).desaturate(100);
                    }
                    function v(t1, e1) {
                        e1 = 0 === e1 ? 0 : e1 || 10;
                        var r = c(t1).toHsl();
                        return r.l += e1 / 100, r.l = P(r.l), c(r);
                    }
                    function y(t1, e1) {
                        e1 = 0 === e1 ? 0 : e1 || 10;
                        var r = c(t1).toRgb();
                        return r.r = s(0, o(255, r.r - a(-e1 / 100 * 255))), r.g = s(0, o(255, r.g - a(-e1 / 100 * 255))), r.b = s(0, o(255, r.b - a(-e1 / 100 * 255))), c(r);
                    }
                    function x(t1, e1) {
                        e1 = 0 === e1 ? 0 : e1 || 10;
                        var r = c(t1).toHsl();
                        return r.l -= e1 / 100, r.l = P(r.l), c(r);
                    }
                    function b(t1, e1) {
                        var r = c(t1).toHsl(), n = (r.h + e1) % 360;
                        return r.h = n < 0 ? 360 + n : n, c(r);
                    }
                    function _(t1) {
                        var e1 = c(t1).toHsl();
                        return e1.h = (e1.h + 180) % 360, c(e1);
                    }
                    function w(t1) {
                        var e1 = c(t1).toHsl(), r = e1.h;
                        return [
                            c(t1),
                            c({
                                h: (r + 120) % 360,
                                s: e1.s,
                                l: e1.l
                            }),
                            c({
                                h: (r + 240) % 360,
                                s: e1.s,
                                l: e1.l
                            })
                        ];
                    }
                    function T(t1) {
                        var e1 = c(t1).toHsl(), r = e1.h;
                        return [
                            c(t1),
                            c({
                                h: (r + 90) % 360,
                                s: e1.s,
                                l: e1.l
                            }),
                            c({
                                h: (r + 180) % 360,
                                s: e1.s,
                                l: e1.l
                            }),
                            c({
                                h: (r + 270) % 360,
                                s: e1.s,
                                l: e1.l
                            })
                        ];
                    }
                    function k(t1) {
                        var e1 = c(t1).toHsl(), r = e1.h;
                        return [
                            c(t1),
                            c({
                                h: (r + 72) % 360,
                                s: e1.s,
                                l: e1.l
                            }),
                            c({
                                h: (r + 216) % 360,
                                s: e1.s,
                                l: e1.l
                            })
                        ];
                    }
                    function A(t1, e1, r) {
                        e1 = e1 || 6, r = r || 30;
                        var n = c(t1).toHsl(), i = 360 / r, a = [
                            c(t1)
                        ];
                        for(n.h = (n.h - (i * e1 >> 1) + 720) % 360; --e1;)n.h = (n.h + i) % 360, a.push(c(n));
                        return a;
                    }
                    function M(t1, e1) {
                        e1 = e1 || 6;
                        for(var r = c(t1).toHsv(), n = r.h, i = r.s, a = r.v, o = [], s = 1 / e1; e1--;)o.push(c({
                            h: n,
                            s: i,
                            v: a
                        })), a = (a + s) % 1;
                        return o;
                    }
                    c.prototype = {
                        isDark: function() {
                            return this.getBrightness() < 128;
                        },
                        isLight: function() {
                            return !this.isDark();
                        },
                        isValid: function() {
                            return this._ok;
                        },
                        getOriginalInput: function() {
                            return this._originalInput;
                        },
                        getFormat: function() {
                            return this._format;
                        },
                        getAlpha: function() {
                            return this._a;
                        },
                        getBrightness: function() {
                            var t1 = this.toRgb();
                            return (299 * t1.r + 587 * t1.g + 114 * t1.b) / 1e3;
                        },
                        getLuminance: function() {
                            var e1, r, n, i = this.toRgb();
                            return e1 = i.r / 255, r = i.g / 255, n = i.b / 255, .2126 * (e1 <= .03928 ? e1 / 12.92 : t1.pow((e1 + .055) / 1.055, 2.4)) + .7152 * (r <= .03928 ? r / 12.92 : t1.pow((r + .055) / 1.055, 2.4)) + .0722 * (n <= .03928 ? n / 12.92 : t1.pow((n + .055) / 1.055, 2.4));
                        },
                        setAlpha: function(t1) {
                            return this._a = L(t1), this._roundA = a(100 * this._a) / 100, this;
                        },
                        toHsv: function() {
                            var t1 = f(this._r, this._g, this._b);
                            return {
                                h: 360 * t1.h,
                                s: t1.s,
                                v: t1.v,
                                a: this._a
                            };
                        },
                        toHsvString: function() {
                            var t1 = f(this._r, this._g, this._b), e1 = a(360 * t1.h), r = a(100 * t1.s), n = a(100 * t1.v);
                            return 1 == this._a ? "hsv(" + e1 + ", " + r + "%, " + n + "%)" : "hsva(" + e1 + ", " + r + "%, " + n + "%, " + this._roundA + ")";
                        },
                        toHsl: function() {
                            var t1 = u(this._r, this._g, this._b);
                            return {
                                h: 360 * t1.h,
                                s: t1.s,
                                l: t1.l,
                                a: this._a
                            };
                        },
                        toHslString: function() {
                            var t1 = u(this._r, this._g, this._b), e1 = a(360 * t1.h), r = a(100 * t1.s), n = a(100 * t1.l);
                            return 1 == this._a ? "hsl(" + e1 + ", " + r + "%, " + n + "%)" : "hsla(" + e1 + ", " + r + "%, " + n + "%, " + this._roundA + ")";
                        },
                        toHex: function(t1) {
                            return h(this._r, this._g, this._b, t1);
                        },
                        toHexString: function(t1) {
                            return "#" + this.toHex(t1);
                        },
                        toHex8: function(t1) {
                            return function(t1, e1, r, n, i) {
                                var o = [
                                    O(a(t1).toString(16)),
                                    O(a(e1).toString(16)),
                                    O(a(r).toString(16)),
                                    O(D(n))
                                ];
                                if (i && o[0].charAt(0) == o[0].charAt(1) && o[1].charAt(0) == o[1].charAt(1) && o[2].charAt(0) == o[2].charAt(1) && o[3].charAt(0) == o[3].charAt(1)) return o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0);
                                return o.join("");
                            }(this._r, this._g, this._b, this._a, t1);
                        },
                        toHex8String: function(t1) {
                            return "#" + this.toHex8(t1);
                        },
                        toRgb: function() {
                            return {
                                r: a(this._r),
                                g: a(this._g),
                                b: a(this._b),
                                a: this._a
                            };
                        },
                        toRgbString: function() {
                            return 1 == this._a ? "rgb(" + a(this._r) + ", " + a(this._g) + ", " + a(this._b) + ")" : "rgba(" + a(this._r) + ", " + a(this._g) + ", " + a(this._b) + ", " + this._roundA + ")";
                        },
                        toPercentageRgb: function() {
                            return {
                                r: a(100 * C(this._r, 255)) + "%",
                                g: a(100 * C(this._g, 255)) + "%",
                                b: a(100 * C(this._b, 255)) + "%",
                                a: this._a
                            };
                        },
                        toPercentageRgbString: function() {
                            return 1 == this._a ? "rgb(" + a(100 * C(this._r, 255)) + "%, " + a(100 * C(this._g, 255)) + "%, " + a(100 * C(this._b, 255)) + "%)" : "rgba(" + a(100 * C(this._r, 255)) + "%, " + a(100 * C(this._g, 255)) + "%, " + a(100 * C(this._b, 255)) + "%, " + this._roundA + ")";
                        },
                        toName: function() {
                            return 0 === this._a ? "transparent" : !(this._a < 1) && (E[h(this._r, this._g, this._b, !0)] || !1);
                        },
                        toFilter: function(t1) {
                            var e1 = "#" + p(this._r, this._g, this._b, this._a), r = e1, n = this._gradientType ? "GradientType = 1, " : "";
                            if (t1) {
                                var i = c(t1);
                                r = "#" + p(i._r, i._g, i._b, i._a);
                            }
                            return "progid:DXImageTransform.Microsoft.gradient(" + n + "startColorstr=" + e1 + ",endColorstr=" + r + ")";
                        },
                        toString: function(t1) {
                            var e1 = !!t1;
                            t1 = t1 || this._format;
                            var r = !1, n = this._a < 1 && this._a >= 0;
                            return e1 || !n || "hex" !== t1 && "hex6" !== t1 && "hex3" !== t1 && "hex4" !== t1 && "hex8" !== t1 && "name" !== t1 ? ("rgb" === t1 && (r = this.toRgbString()), "prgb" === t1 && (r = this.toPercentageRgbString()), "hex" !== t1 && "hex6" !== t1 || (r = this.toHexString()), "hex3" === t1 && (r = this.toHexString(!0)), "hex4" === t1 && (r = this.toHex8String(!0)), "hex8" === t1 && (r = this.toHex8String()), "name" === t1 && (r = this.toName()), "hsl" === t1 && (r = this.toHslString()), "hsv" === t1 && (r = this.toHsvString()), r || this.toHexString()) : "name" === t1 && 0 === this._a ? this.toName() : this.toRgbString();
                        },
                        clone: function() {
                            return c(this.toString());
                        },
                        _applyModification: function(t1, e1) {
                            var r = t1.apply(null, [
                                this
                            ].concat([].slice.call(e1)));
                            return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
                        },
                        lighten: function() {
                            return this._applyModification(v, arguments);
                        },
                        brighten: function() {
                            return this._applyModification(y, arguments);
                        },
                        darken: function() {
                            return this._applyModification(x, arguments);
                        },
                        desaturate: function() {
                            return this._applyModification(d, arguments);
                        },
                        saturate: function() {
                            return this._applyModification(m, arguments);
                        },
                        greyscale: function() {
                            return this._applyModification(g, arguments);
                        },
                        spin: function() {
                            return this._applyModification(b, arguments);
                        },
                        _applyCombination: function(t1, e1) {
                            return t1.apply(null, [
                                this
                            ].concat([].slice.call(e1)));
                        },
                        analogous: function() {
                            return this._applyCombination(A, arguments);
                        },
                        complement: function() {
                            return this._applyCombination(_, arguments);
                        },
                        monochromatic: function() {
                            return this._applyCombination(M, arguments);
                        },
                        splitcomplement: function() {
                            return this._applyCombination(k, arguments);
                        },
                        triad: function() {
                            return this._applyCombination(w, arguments);
                        },
                        tetrad: function() {
                            return this._applyCombination(T, arguments);
                        }
                    }, c.fromRatio = function(t1, e1) {
                        if ("object" == typeof t1) {
                            var r = {};
                            for(var n in t1)t1.hasOwnProperty(n) && (r[n] = "a" === n ? t1[n] : z(t1[n]));
                            t1 = r;
                        }
                        return c(t1, e1);
                    }, c.equals = function(t1, e1) {
                        return !(!t1 || !e1) && c(t1).toRgbString() == c(e1).toRgbString();
                    }, c.random = function() {
                        return c.fromRatio({
                            r: l(),
                            g: l(),
                            b: l()
                        });
                    }, c.mix = function(t1, e1, r) {
                        r = 0 === r ? 0 : r || 50;
                        var n = c(t1).toRgb(), i = c(e1).toRgb(), a = r / 100;
                        return c({
                            r: (i.r - n.r) * a + n.r,
                            g: (i.g - n.g) * a + n.g,
                            b: (i.b - n.b) * a + n.b,
                            a: (i.a - n.a) * a + n.a
                        });
                    }, c.readability = function(e1, r) {
                        var n = c(e1), i = c(r);
                        return (t1.max(n.getLuminance(), i.getLuminance()) + .05) / (t1.min(n.getLuminance(), i.getLuminance()) + .05);
                    }, c.isReadable = function(t1, e1, r) {
                        var n, i, a = c.readability(t1, e1);
                        switch(i = !1, (n = function(t1) {
                            var e1, r;
                            e1 = ((t1 = t1 || {
                                level: "AA",
                                size: "small"
                            }).level || "AA").toUpperCase(), r = (t1.size || "small").toLowerCase(), "AA" !== e1 && "AAA" !== e1 && (e1 = "AA");
                            "small" !== r && "large" !== r && (r = "small");
                            return {
                                level: e1,
                                size: r
                            };
                        }(r)).level + n.size){
                            case "AAsmall":
                            case "AAAlarge":
                                i = a >= 4.5;
                                break;
                            case "AAlarge":
                                i = a >= 3;
                                break;
                            case "AAAsmall":
                                i = a >= 7;
                        }
                        return i;
                    }, c.mostReadable = function(t1, e1, r) {
                        var n, i, a, o, s = null, l = 0;
                        i = (r = r || {}).includeFallbackColors, a = r.level, o = r.size;
                        for(var u = 0; u < e1.length; u++)(n = c.readability(t1, e1[u])) > l && (l = n, s = c(e1[u]));
                        return c.isReadable(t1, s, {
                            level: a,
                            size: o
                        }) || !i ? s : (r.includeFallbackColors = !1, c.mostReadable(t1, [
                            "#fff",
                            "#000"
                        ], r));
                    };
                    var S = c.names = {
                        aliceblue: "f0f8ff",
                        antiquewhite: "faebd7",
                        aqua: "0ff",
                        aquamarine: "7fffd4",
                        azure: "f0ffff",
                        beige: "f5f5dc",
                        bisque: "ffe4c4",
                        black: "000",
                        blanchedalmond: "ffebcd",
                        blue: "00f",
                        blueviolet: "8a2be2",
                        brown: "a52a2a",
                        burlywood: "deb887",
                        burntsienna: "ea7e5d",
                        cadetblue: "5f9ea0",
                        chartreuse: "7fff00",
                        chocolate: "d2691e",
                        coral: "ff7f50",
                        cornflowerblue: "6495ed",
                        cornsilk: "fff8dc",
                        crimson: "dc143c",
                        cyan: "0ff",
                        darkblue: "00008b",
                        darkcyan: "008b8b",
                        darkgoldenrod: "b8860b",
                        darkgray: "a9a9a9",
                        darkgreen: "006400",
                        darkgrey: "a9a9a9",
                        darkkhaki: "bdb76b",
                        darkmagenta: "8b008b",
                        darkolivegreen: "556b2f",
                        darkorange: "ff8c00",
                        darkorchid: "9932cc",
                        darkred: "8b0000",
                        darksalmon: "e9967a",
                        darkseagreen: "8fbc8f",
                        darkslateblue: "483d8b",
                        darkslategray: "2f4f4f",
                        darkslategrey: "2f4f4f",
                        darkturquoise: "00ced1",
                        darkviolet: "9400d3",
                        deeppink: "ff1493",
                        deepskyblue: "00bfff",
                        dimgray: "696969",
                        dimgrey: "696969",
                        dodgerblue: "1e90ff",
                        firebrick: "b22222",
                        floralwhite: "fffaf0",
                        forestgreen: "228b22",
                        fuchsia: "f0f",
                        gainsboro: "dcdcdc",
                        ghostwhite: "f8f8ff",
                        gold: "ffd700",
                        goldenrod: "daa520",
                        gray: "808080",
                        green: "008000",
                        greenyellow: "adff2f",
                        grey: "808080",
                        honeydew: "f0fff0",
                        hotpink: "ff69b4",
                        indianred: "cd5c5c",
                        indigo: "4b0082",
                        ivory: "fffff0",
                        khaki: "f0e68c",
                        lavender: "e6e6fa",
                        lavenderblush: "fff0f5",
                        lawngreen: "7cfc00",
                        lemonchiffon: "fffacd",
                        lightblue: "add8e6",
                        lightcoral: "f08080",
                        lightcyan: "e0ffff",
                        lightgoldenrodyellow: "fafad2",
                        lightgray: "d3d3d3",
                        lightgreen: "90ee90",
                        lightgrey: "d3d3d3",
                        lightpink: "ffb6c1",
                        lightsalmon: "ffa07a",
                        lightseagreen: "20b2aa",
                        lightskyblue: "87cefa",
                        lightslategray: "789",
                        lightslategrey: "789",
                        lightsteelblue: "b0c4de",
                        lightyellow: "ffffe0",
                        lime: "0f0",
                        limegreen: "32cd32",
                        linen: "faf0e6",
                        magenta: "f0f",
                        maroon: "800000",
                        mediumaquamarine: "66cdaa",
                        mediumblue: "0000cd",
                        mediumorchid: "ba55d3",
                        mediumpurple: "9370db",
                        mediumseagreen: "3cb371",
                        mediumslateblue: "7b68ee",
                        mediumspringgreen: "00fa9a",
                        mediumturquoise: "48d1cc",
                        mediumvioletred: "c71585",
                        midnightblue: "191970",
                        mintcream: "f5fffa",
                        mistyrose: "ffe4e1",
                        moccasin: "ffe4b5",
                        navajowhite: "ffdead",
                        navy: "000080",
                        oldlace: "fdf5e6",
                        olive: "808000",
                        olivedrab: "6b8e23",
                        orange: "ffa500",
                        orangered: "ff4500",
                        orchid: "da70d6",
                        palegoldenrod: "eee8aa",
                        palegreen: "98fb98",
                        paleturquoise: "afeeee",
                        palevioletred: "db7093",
                        papayawhip: "ffefd5",
                        peachpuff: "ffdab9",
                        peru: "cd853f",
                        pink: "ffc0cb",
                        plum: "dda0dd",
                        powderblue: "b0e0e6",
                        purple: "800080",
                        rebeccapurple: "663399",
                        red: "f00",
                        rosybrown: "bc8f8f",
                        royalblue: "4169e1",
                        saddlebrown: "8b4513",
                        salmon: "fa8072",
                        sandybrown: "f4a460",
                        seagreen: "2e8b57",
                        seashell: "fff5ee",
                        sienna: "a0522d",
                        silver: "c0c0c0",
                        skyblue: "87ceeb",
                        slateblue: "6a5acd",
                        slategray: "708090",
                        slategrey: "708090",
                        snow: "fffafa",
                        springgreen: "00ff7f",
                        steelblue: "4682b4",
                        tan: "d2b48c",
                        teal: "008080",
                        thistle: "d8bfd8",
                        tomato: "ff6347",
                        turquoise: "40e0d0",
                        violet: "ee82ee",
                        wheat: "f5deb3",
                        white: "fff",
                        whitesmoke: "f5f5f5",
                        yellow: "ff0",
                        yellowgreen: "9acd32"
                    }, E = c.hexNames = function(t1) {
                        var e1 = {};
                        for(var r in t1)t1.hasOwnProperty(r) && (e1[t1[r]] = r);
                        return e1;
                    }(S);
                    function L(t1) {
                        return t1 = parseFloat(t1), (isNaN(t1) || t1 < 0 || t1 > 1) && (t1 = 1), t1;
                    }
                    function C(e1, r) {
                        (function(t1) {
                            return "string" == typeof t1 && -1 != t1.indexOf(".") && 1 === parseFloat(t1);
                        })(e1) && (e1 = "100%");
                        var n = function(t1) {
                            return "string" == typeof t1 && -1 != t1.indexOf("%");
                        }(e1);
                        return e1 = o(r, s(0, parseFloat(e1))), n && (e1 = parseInt(e1 * r, 10) / 100), t1.abs(e1 - r) < 1e-6 ? 1 : e1 % r / parseFloat(r);
                    }
                    function P(t1) {
                        return o(1, s(0, t1));
                    }
                    function I(t1) {
                        return parseInt(t1, 16);
                    }
                    function O(t1) {
                        return 1 == t1.length ? "0" + t1 : "" + t1;
                    }
                    function z(t1) {
                        return t1 <= 1 && (t1 = 100 * t1 + "%"), t1;
                    }
                    function D(e1) {
                        return t1.round(255 * parseFloat(e1)).toString(16);
                    }
                    function R(t1) {
                        return I(t1) / 255;
                    }
                    var F, B, N, j = (B = "[\\s|\\(]+(" + (F = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + F + ")[,|\\s]+(" + F + ")\\s*\\)?", N = "[\\s|\\(]+(" + F + ")[,|\\s]+(" + F + ")[,|\\s]+(" + F + ")[,|\\s]+(" + F + ")\\s*\\)?", {
                        CSS_UNIT: new RegExp(F),
                        rgb: new RegExp("rgb" + B),
                        rgba: new RegExp("rgba" + N),
                        hsl: new RegExp("hsl" + B),
                        hsla: new RegExp("hsla" + N),
                        hsv: new RegExp("hsv" + B),
                        hsva: new RegExp("hsva" + N),
                        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
                        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
                    });
                    function U(t1) {
                        return !!j.CSS_UNIT.exec(t1);
                    }
                    void 0 !== e1 && e1.exports ? e1.exports = c : window.tinycolor = c;
                }(Math);
            },
            {}
        ],
        313: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = i, e1.exports.float32 = e1.exports.float = i, e1.exports.fract32 = e1.exports.fract = function(t1, e1) {
                    if (t1.length) {
                        if (t1 instanceof Float32Array) return new Float32Array(t1.length);
                        e1 instanceof Float32Array || (e1 = i(t1));
                        for(var r = 0, n = e1.length; r < n; r++)e1[r] = t1[r] - e1[r];
                        return e1;
                    }
                    return i(t1 - i(t1));
                };
                var n = new Float32Array(1);
                function i(t1) {
                    return t1.length ? t1 instanceof Float32Array ? t1 : new Float32Array(t1) : (n[0] = t1, n[0]);
                }
            },
            {}
        ],
        314: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("parse-unit");
                e1.exports = a;
                function i(t1, e1) {
                    var r = n(getComputedStyle(t1).getPropertyValue(e1));
                    return r[0] * a(r[1], t1);
                }
                function a(t1, e1) {
                    switch(e1 = e1 || document.body, t1 = (t1 || "px").trim().toLowerCase(), e1 !== window && e1 !== document || (e1 = document.body), t1){
                        case "%":
                            return e1.clientHeight / 100;
                        case "ch":
                        case "ex":
                            return function(t1, e1) {
                                var r = document.createElement("div");
                                r.style["font-size"] = "128" + t1, e1.appendChild(r);
                                var n = i(r, "font-size") / 128;
                                return e1.removeChild(r), n;
                            }(t1, e1);
                        case "em":
                            return i(e1, "font-size");
                        case "rem":
                            return i(document.body, "font-size");
                        case "vw":
                            return window.innerWidth / 100;
                        case "vh":
                            return window.innerHeight / 100;
                        case "vmin":
                            return Math.min(window.innerWidth, window.innerHeight) / 100;
                        case "vmax":
                            return Math.max(window.innerWidth, window.innerHeight) / 100;
                        case "in":
                            return 96;
                        case "cm":
                            return 96 / 2.54;
                        case "mm":
                            return 96 / 25.4;
                        case "pt":
                            return 96 / 72;
                        case "pc":
                            return 16;
                    }
                    return 1;
                }
            },
            {
                "parse-unit": 251
            }
        ],
        315: [
            function(t1, e1, r) {
                !function(t1, n) {
                    "object" == typeof r && void 0 !== e1 ? n(r) : n((t1 = t1 || self).topojson = t1.topojson || {});
                }(this, function(t1) {
                    "use strict";
                    function e1(t1) {
                        return t1;
                    }
                    function r(t1) {
                        if (null == t1) return e1;
                        var r, n, i = t1.scale[0], a = t1.scale[1], o = t1.translate[0], s = t1.translate[1];
                        return function(t1, e1) {
                            e1 || (r = n = 0);
                            var l = 2, c = t1.length, u = new Array(c);
                            for(u[0] = (r += t1[0]) * i + o, u[1] = (n += t1[1]) * a + s; l < c;)u[l] = t1[l], ++l;
                            return u;
                        };
                    }
                    function n(t1) {
                        var e1, n = r(t1.transform), i = 1 / 0, a = i, o = -i, s = -i;
                        function l(t1) {
                            (t1 = n(t1))[0] < i && (i = t1[0]), t1[0] > o && (o = t1[0]), t1[1] < a && (a = t1[1]), t1[1] > s && (s = t1[1]);
                        }
                        function c(t1) {
                            switch(t1.type){
                                case "GeometryCollection":
                                    t1.geometries.forEach(c);
                                    break;
                                case "Point":
                                    l(t1.coordinates);
                                    break;
                                case "MultiPoint":
                                    t1.coordinates.forEach(l);
                            }
                        }
                        for(e1 in t1.arcs.forEach(function(t1) {
                            for(var e1, r = -1, l = t1.length; ++r < l;)(e1 = n(t1[r], r))[0] < i && (i = e1[0]), e1[0] > o && (o = e1[0]), e1[1] < a && (a = e1[1]), e1[1] > s && (s = e1[1]);
                        }), t1.objects)c(t1.objects[e1]);
                        return [
                            i,
                            a,
                            o,
                            s
                        ];
                    }
                    function i(t1, e1) {
                        var r = e1.id, n = e1.bbox, i = null == e1.properties ? {} : e1.properties, o = a(t1, e1);
                        return null == r && null == n ? {
                            type: "Feature",
                            properties: i,
                            geometry: o
                        } : null == n ? {
                            type: "Feature",
                            id: r,
                            properties: i,
                            geometry: o
                        } : {
                            type: "Feature",
                            id: r,
                            bbox: n,
                            properties: i,
                            geometry: o
                        };
                    }
                    function a(t1, e1) {
                        var n = r(t1.transform), i = t1.arcs;
                        function a(t1, e1) {
                            e1.length && e1.pop();
                            for(var r = i[t1 < 0 ? ~t1 : t1], a = 0, o = r.length; a < o; ++a)e1.push(n(r[a], a));
                            t1 < 0 && function(t1, e1) {
                                for(var r, n = t1.length, i = n - e1; i < --n;)r = t1[i], t1[i++] = t1[n], t1[n] = r;
                            }(e1, o);
                        }
                        function o(t1) {
                            return n(t1);
                        }
                        function s(t1) {
                            for(var e1 = [], r = 0, n = t1.length; r < n; ++r)a(t1[r], e1);
                            return e1.length < 2 && e1.push(e1[0]), e1;
                        }
                        function l(t1) {
                            for(var e1 = s(t1); e1.length < 4;)e1.push(e1[0]);
                            return e1;
                        }
                        function c(t1) {
                            return t1.map(l);
                        }
                        return function t1(e1) {
                            var r, n = e1.type;
                            switch(n){
                                case "GeometryCollection":
                                    return {
                                        type: n,
                                        geometries: e1.geometries.map(t1)
                                    };
                                case "Point":
                                    r = o(e1.coordinates);
                                    break;
                                case "MultiPoint":
                                    r = e1.coordinates.map(o);
                                    break;
                                case "LineString":
                                    r = s(e1.arcs);
                                    break;
                                case "MultiLineString":
                                    r = e1.arcs.map(s);
                                    break;
                                case "Polygon":
                                    r = c(e1.arcs);
                                    break;
                                case "MultiPolygon":
                                    r = e1.arcs.map(c);
                                    break;
                                default:
                                    return null;
                            }
                            return {
                                type: n,
                                coordinates: r
                            };
                        }(e1);
                    }
                    function o(t1, e1) {
                        var r = {}, n = {}, i = {}, a = [], o = -1;
                        function s(t1, e1) {
                            for(var n in t1){
                                var i = t1[n];
                                delete e1[i.start], delete i.start, delete i.end, i.forEach(function(t1) {
                                    r[t1 < 0 ? ~t1 : t1] = 1;
                                }), a.push(i);
                            }
                        }
                        return e1.forEach(function(r, n) {
                            var i, a = t1.arcs[r < 0 ? ~r : r];
                            a.length < 3 && !a[1][0] && !a[1][1] && (i = e1[++o], e1[o] = r, e1[n] = i);
                        }), e1.forEach(function(e1) {
                            var r, a, o = function(e1) {
                                var r, n = t1.arcs[e1 < 0 ? ~e1 : e1], i = n[0];
                                t1.transform ? (r = [
                                    0,
                                    0
                                ], n.forEach(function(t1) {
                                    r[0] += t1[0], r[1] += t1[1];
                                })) : r = n[n.length - 1];
                                return e1 < 0 ? [
                                    r,
                                    i
                                ] : [
                                    i,
                                    r
                                ];
                            }(e1), s = o[0], l = o[1];
                            if (r = i[s]) {
                                if (delete i[r.end], r.push(e1), r.end = l, a = n[l]) {
                                    delete n[a.start];
                                    var c = a === r ? r : r.concat(a);
                                    n[c.start = r.start] = i[c.end = a.end] = c;
                                } else n[r.start] = i[r.end] = r;
                            } else if (r = n[l]) {
                                if (delete n[r.start], r.unshift(e1), r.start = s, a = i[s]) {
                                    delete i[a.end];
                                    var u = a === r ? r : a.concat(r);
                                    n[u.start = a.start] = i[u.end = r.end] = u;
                                } else n[r.start] = i[r.end] = r;
                            } else n[(r = [
                                e1
                            ]).start = s] = i[r.end = l] = r;
                        }), s(i, n), s(n, i), e1.forEach(function(t1) {
                            r[t1 < 0 ? ~t1 : t1] || a.push([
                                t1
                            ]);
                        }), a;
                    }
                    function s(t1, e1, r) {
                        var n, i, a;
                        if (arguments.length > 1) n = l(t1, e1, r);
                        else for(i = 0, n = new Array(a = t1.arcs.length); i < a; ++i)n[i] = i;
                        return {
                            type: "MultiLineString",
                            arcs: o(t1, n)
                        };
                    }
                    function l(t1, e1, r) {
                        var n, i = [], a = [];
                        function o(t1) {
                            var e1 = t1 < 0 ? ~t1 : t1;
                            (a[e1] || (a[e1] = [])).push({
                                i: t1,
                                g: n
                            });
                        }
                        function s(t1) {
                            t1.forEach(o);
                        }
                        function l(t1) {
                            t1.forEach(s);
                        }
                        return function t1(e1) {
                            switch(n = e1, e1.type){
                                case "GeometryCollection":
                                    e1.geometries.forEach(t1);
                                    break;
                                case "LineString":
                                    s(e1.arcs);
                                    break;
                                case "MultiLineString":
                                case "Polygon":
                                    l(e1.arcs);
                                    break;
                                case "MultiPolygon":
                                    !function(t1) {
                                        t1.forEach(l);
                                    }(e1.arcs);
                            }
                        }(e1), a.forEach(null == r ? function(t1) {
                            i.push(t1[0].i);
                        } : function(t1) {
                            r(t1[0].g, t1[t1.length - 1].g) && i.push(t1[0].i);
                        }), i;
                    }
                    function c(t1, e1) {
                        var r = {}, n = [], i = [];
                        function s(t1) {
                            t1.forEach(function(e1) {
                                e1.forEach(function(e1) {
                                    (r[e1 = e1 < 0 ? ~e1 : e1] || (r[e1] = [])).push(t1);
                                });
                            }), n.push(t1);
                        }
                        function l(e1) {
                            return function(t1) {
                                for(var e1, r = -1, n = t1.length, i = t1[n - 1], a = 0; ++r < n;)e1 = i, i = t1[r], a += e1[0] * i[1] - e1[1] * i[0];
                                return Math.abs(a);
                            }(a(t1, {
                                type: "Polygon",
                                arcs: [
                                    e1
                                ]
                            }).coordinates[0]);
                        }
                        return e1.forEach(function t1(e1) {
                            switch(e1.type){
                                case "GeometryCollection":
                                    e1.geometries.forEach(t1);
                                    break;
                                case "Polygon":
                                    s(e1.arcs);
                                    break;
                                case "MultiPolygon":
                                    e1.arcs.forEach(s);
                            }
                        }), n.forEach(function(t1) {
                            if (!t1._) {
                                var e1 = [], n = [
                                    t1
                                ];
                                for(t1._ = 1, i.push(e1); t1 = n.pop();)e1.push(t1), t1.forEach(function(t1) {
                                    t1.forEach(function(t1) {
                                        r[t1 < 0 ? ~t1 : t1].forEach(function(t1) {
                                            t1._ || (t1._ = 1, n.push(t1));
                                        });
                                    });
                                });
                            }
                        }), n.forEach(function(t1) {
                            delete t1._;
                        }), {
                            type: "MultiPolygon",
                            arcs: i.map(function(e1) {
                                var n, i = [];
                                if (e1.forEach(function(t1) {
                                    t1.forEach(function(t1) {
                                        t1.forEach(function(t1) {
                                            r[t1 < 0 ? ~t1 : t1].length < 2 && i.push(t1);
                                        });
                                    });
                                }), (n = (i = o(t1, i)).length) > 1) for(var a, s, c = 1, u = l(i[0]); c < n; ++c)(a = l(i[c])) > u && (s = i[0], i[0] = i[c], i[c] = s, u = a);
                                return i;
                            }).filter(function(t1) {
                                return t1.length > 0;
                            })
                        };
                    }
                    function u(t1, e1) {
                        for(var r = 0, n = t1.length; r < n;){
                            var i = r + n >>> 1;
                            t1[i] < e1 ? r = i + 1 : n = i;
                        }
                        return r;
                    }
                    function f(t1) {
                        if (null == t1) return e1;
                        var r, n, i = t1.scale[0], a = t1.scale[1], o = t1.translate[0], s = t1.translate[1];
                        return function(t1, e1) {
                            e1 || (r = n = 0);
                            var l = 2, c = t1.length, u = new Array(c), f = Math.round((t1[0] - o) / i), h = Math.round((t1[1] - s) / a);
                            for(u[0] = f - r, r = f, u[1] = h - n, n = h; l < c;)u[l] = t1[l], ++l;
                            return u;
                        };
                    }
                    t1.bbox = n, t1.feature = function(t1, e1) {
                        return "string" == typeof e1 && (e1 = t1.objects[e1]), "GeometryCollection" === e1.type ? {
                            type: "FeatureCollection",
                            features: e1.geometries.map(function(e1) {
                                return i(t1, e1);
                            })
                        } : i(t1, e1);
                    }, t1.merge = function(t1) {
                        return a(t1, c.apply(this, arguments));
                    }, t1.mergeArcs = c, t1.mesh = function(t1) {
                        return a(t1, s.apply(this, arguments));
                    }, t1.meshArcs = s, t1.neighbors = function(t1) {
                        var e1 = {}, r = t1.map(function() {
                            return [];
                        });
                        function n(t1, r) {
                            t1.forEach(function(t1) {
                                t1 < 0 && (t1 = ~t1);
                                var n = e1[t1];
                                n ? n.push(r) : e1[t1] = [
                                    r
                                ];
                            });
                        }
                        function i(t1, e1) {
                            t1.forEach(function(t1) {
                                n(t1, e1);
                            });
                        }
                        var a = {
                            LineString: n,
                            MultiLineString: i,
                            Polygon: i,
                            MultiPolygon: function(t1, e1) {
                                t1.forEach(function(t1) {
                                    i(t1, e1);
                                });
                            }
                        };
                        for(var o in t1.forEach(function t1(e1, r) {
                            "GeometryCollection" === e1.type ? e1.geometries.forEach(function(e1) {
                                t1(e1, r);
                            }) : e1.type in a && a[e1.type](e1.arcs, r);
                        }), e1)for(var s = e1[o], l = s.length, c = 0; c < l; ++c)for(var f = c + 1; f < l; ++f){
                            var h, p = s[c], d = s[f];
                            (h = r[p])[o = u(h, d)] !== d && h.splice(o, 0, d), (h = r[d])[o = u(h, p)] !== p && h.splice(o, 0, p);
                        }
                        return r;
                    }, t1.quantize = function(t1, e1) {
                        if (t1.transform) throw new Error("already quantized");
                        if (e1 && e1.scale) l = t1.bbox;
                        else {
                            if (!((r = Math.floor(e1)) >= 2)) throw new Error("n must be \u22652");
                            var r, i = (l = t1.bbox || n(t1))[0], a = l[1], o = l[2], s = l[3];
                            e1 = {
                                scale: [
                                    o - i ? (o - i) / (r - 1) : 1,
                                    s - a ? (s - a) / (r - 1) : 1
                                ],
                                translate: [
                                    i,
                                    a
                                ]
                            };
                        }
                        var l, c, u = f(e1), h = t1.objects, p = {};
                        function d(t1) {
                            return u(t1);
                        }
                        function m(t1) {
                            var e1;
                            switch(t1.type){
                                case "GeometryCollection":
                                    e1 = {
                                        type: "GeometryCollection",
                                        geometries: t1.geometries.map(m)
                                    };
                                    break;
                                case "Point":
                                    e1 = {
                                        type: "Point",
                                        coordinates: d(t1.coordinates)
                                    };
                                    break;
                                case "MultiPoint":
                                    e1 = {
                                        type: "MultiPoint",
                                        coordinates: t1.coordinates.map(d)
                                    };
                                    break;
                                default:
                                    return t1;
                            }
                            return null != t1.id && (e1.id = t1.id), null != t1.bbox && (e1.bbox = t1.bbox), null != t1.properties && (e1.properties = t1.properties), e1;
                        }
                        for(c in h)p[c] = m(h[c]);
                        return {
                            type: "Topology",
                            bbox: l,
                            transform: e1,
                            objects: p,
                            arcs: t1.arcs.map(function(t1) {
                                var e1, r = 0, n = 1, i = t1.length, a = new Array(i);
                                for(a[0] = u(t1[0], 0); ++r < i;)((e1 = u(t1[r], r))[0] || e1[1]) && (a[n++] = e1);
                                return 1 === n && (a[n++] = [
                                    0,
                                    0
                                ]), a.length = n, a;
                            })
                        };
                    }, t1.transform = r, t1.untransform = f, Object.defineProperty(t1, "__esModule", {
                        value: !0
                    });
                });
            },
            {}
        ],
        316: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../prototype/is");
                e1.exports = function(t1) {
                    if ("function" != typeof t1) return !1;
                    if (!hasOwnProperty.call(t1, "length")) return !1;
                    try {
                        if ("number" != typeof t1.length) return !1;
                        if ("function" != typeof t1.call) return !1;
                        if ("function" != typeof t1.apply) return !1;
                    } catch (t1) {
                        return !1;
                    }
                    return !n(t1);
                };
            },
            {
                "../prototype/is": 323
            }
        ],
        317: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../value/is"), i = t1("../object/is"), a = t1("../string/coerce"), o = t1("./to-short-string"), s = function(t1, e1) {
                    return t1.replace("%v", o(e1));
                };
                e1.exports = function(t1, e1, r) {
                    if (!i(r)) throw new TypeError(s(e1, t1));
                    if (!n(t1)) {
                        if ("default" in r) return r.default;
                        if (r.isOptional) return null;
                    }
                    var o = a(r.errorMessage);
                    throw n(o) || (o = e1), new TypeError(s(o, t1));
                };
            },
            {
                "../object/is": 320,
                "../string/coerce": 324,
                "../value/is": 326,
                "./to-short-string": 319
            }
        ],
        318: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    try {
                        return t1.toString();
                    } catch (e1) {
                        try {
                            return String(t1);
                        } catch (t1) {
                            return null;
                        }
                    }
                };
            },
            {}
        ],
        319: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./safe-to-string"), i = /[\n\r\u2028\u2029]/g;
                e1.exports = function(t1) {
                    var e1 = n(t1);
                    return null === e1 ? "<Non-coercible to string value>" : (e1.length > 100 && (e1 = e1.slice(0, 99) + "\u2026"), e1 = e1.replace(i, function(t1) {
                        switch(t1){
                            case "\n":
                                return "\\n";
                            case "\r":
                                return "\\r";
                            case "\u2028":
                                return "\\u2028";
                            case "\u2029":
                                return "\\u2029";
                            default:
                                throw new Error("Unexpected character");
                        }
                    }));
                };
            },
            {
                "./safe-to-string": 318
            }
        ],
        320: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../value/is"), i = {
                    object: !0,
                    function: !0,
                    undefined: !0
                };
                e1.exports = function(t1) {
                    return !!n(t1) && hasOwnProperty.call(i, typeof t1);
                };
            },
            {
                "../value/is": 326
            }
        ],
        321: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib/resolve-exception"), i = t1("./is");
                e1.exports = function(t1) {
                    return i(t1) ? t1 : n(t1, "%v is not a plain function", arguments[1]);
                };
            },
            {
                "../lib/resolve-exception": 317,
                "./is": 322
            }
        ],
        322: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../function/is"), i = /^\s*class[\s{/}]/, a = Function.prototype.toString;
                e1.exports = function(t1) {
                    return !!n(t1) && !i.test(a.call(t1));
                };
            },
            {
                "../function/is": 316
            }
        ],
        323: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../object/is");
                e1.exports = function(t1) {
                    if (!n(t1)) return !1;
                    try {
                        return !!t1.constructor && t1.constructor.prototype === t1;
                    } catch (t1) {
                        return !1;
                    }
                };
            },
            {
                "../object/is": 320
            }
        ],
        324: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../value/is"), i = t1("../object/is"), a = Object.prototype.toString;
                e1.exports = function(t1) {
                    if (!n(t1)) return null;
                    if (i(t1)) {
                        var e1 = t1.toString;
                        if ("function" != typeof e1) return null;
                        if (e1 === a) return null;
                    }
                    try {
                        return "" + t1;
                    } catch (t1) {
                        return null;
                    }
                };
            },
            {
                "../object/is": 320,
                "../value/is": 326
            }
        ],
        325: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib/resolve-exception"), i = t1("./is");
                e1.exports = function(t1) {
                    return i(t1) ? t1 : n(t1, "Cannot use %v", arguments[1]);
                };
            },
            {
                "../lib/resolve-exception": 317,
                "./is": 326
            }
        ],
        326: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    return null != t1;
                };
            },
            {}
        ],
        327: [
            function(t1, e1, r) {
                (function(e1) {
                    (function() {
                        "use strict";
                        var n = t1("bit-twiddle"), i = t1("dup"), a = t1("buffer").Buffer;
                        e1.__TYPEDARRAY_POOL || (e1.__TYPEDARRAY_POOL = {
                            UINT8: i([
                                32,
                                0
                            ]),
                            UINT16: i([
                                32,
                                0
                            ]),
                            UINT32: i([
                                32,
                                0
                            ]),
                            BIGUINT64: i([
                                32,
                                0
                            ]),
                            INT8: i([
                                32,
                                0
                            ]),
                            INT16: i([
                                32,
                                0
                            ]),
                            INT32: i([
                                32,
                                0
                            ]),
                            BIGINT64: i([
                                32,
                                0
                            ]),
                            FLOAT: i([
                                32,
                                0
                            ]),
                            DOUBLE: i([
                                32,
                                0
                            ]),
                            DATA: i([
                                32,
                                0
                            ]),
                            UINT8C: i([
                                32,
                                0
                            ]),
                            BUFFER: i([
                                32,
                                0
                            ])
                        });
                        var o = "undefined" != typeof Uint8ClampedArray, s = "undefined" != typeof BigUint64Array, l = "undefined" != typeof BigInt64Array, c = e1.__TYPEDARRAY_POOL;
                        c.UINT8C || (c.UINT8C = i([
                            32,
                            0
                        ])), c.BIGUINT64 || (c.BIGUINT64 = i([
                            32,
                            0
                        ])), c.BIGINT64 || (c.BIGINT64 = i([
                            32,
                            0
                        ])), c.BUFFER || (c.BUFFER = i([
                            32,
                            0
                        ]));
                        var u = c.DATA, f = c.BUFFER;
                        function h(t1) {
                            if (t1) {
                                var e1 = t1.length || t1.byteLength, r = n.log2(e1);
                                u[r].push(t1);
                            }
                        }
                        function p(t1) {
                            t1 = n.nextPow2(t1);
                            var e1 = n.log2(t1), r = u[e1];
                            return r.length > 0 ? r.pop() : new ArrayBuffer(t1);
                        }
                        function d(t1) {
                            return new Uint8Array(p(t1), 0, t1);
                        }
                        function m(t1) {
                            return new Uint16Array(p(2 * t1), 0, t1);
                        }
                        function g(t1) {
                            return new Uint32Array(p(4 * t1), 0, t1);
                        }
                        function v(t1) {
                            return new Int8Array(p(t1), 0, t1);
                        }
                        function y(t1) {
                            return new Int16Array(p(2 * t1), 0, t1);
                        }
                        function x(t1) {
                            return new Int32Array(p(4 * t1), 0, t1);
                        }
                        function b(t1) {
                            return new Float32Array(p(4 * t1), 0, t1);
                        }
                        function _(t1) {
                            return new Float64Array(p(8 * t1), 0, t1);
                        }
                        function w(t1) {
                            return o ? new Uint8ClampedArray(p(t1), 0, t1) : d(t1);
                        }
                        function T(t1) {
                            return s ? new BigUint64Array(p(8 * t1), 0, t1) : null;
                        }
                        function k(t1) {
                            return l ? new BigInt64Array(p(8 * t1), 0, t1) : null;
                        }
                        function A(t1) {
                            return new DataView(p(t1), 0, t1);
                        }
                        function M(t1) {
                            t1 = n.nextPow2(t1);
                            var e1 = n.log2(t1), r = f[e1];
                            return r.length > 0 ? r.pop() : new a(t1);
                        }
                        r.free = function(t1) {
                            if (a.isBuffer(t1)) f[n.log2(t1.length)].push(t1);
                            else {
                                if ("[object ArrayBuffer]" !== Object.prototype.toString.call(t1) && (t1 = t1.buffer), !t1) return;
                                var e1 = t1.length || t1.byteLength, r = 0 | n.log2(e1);
                                u[r].push(t1);
                            }
                        }, r.freeUint8 = r.freeUint16 = r.freeUint32 = r.freeBigUint64 = r.freeInt8 = r.freeInt16 = r.freeInt32 = r.freeBigInt64 = r.freeFloat32 = r.freeFloat = r.freeFloat64 = r.freeDouble = r.freeUint8Clamped = r.freeDataView = function(t1) {
                            h(t1.buffer);
                        }, r.freeArrayBuffer = h, r.freeBuffer = function(t1) {
                            f[n.log2(t1.length)].push(t1);
                        }, r.malloc = function(t1, e1) {
                            if (void 0 === e1 || "arraybuffer" === e1) return p(t1);
                            switch(e1){
                                case "uint8":
                                    return d(t1);
                                case "uint16":
                                    return m(t1);
                                case "uint32":
                                    return g(t1);
                                case "int8":
                                    return v(t1);
                                case "int16":
                                    return y(t1);
                                case "int32":
                                    return x(t1);
                                case "float":
                                case "float32":
                                    return b(t1);
                                case "double":
                                case "float64":
                                    return _(t1);
                                case "uint8_clamped":
                                    return w(t1);
                                case "bigint64":
                                    return k(t1);
                                case "biguint64":
                                    return T(t1);
                                case "buffer":
                                    return M(t1);
                                case "data":
                                case "dataview":
                                    return A(t1);
                                default:
                                    return null;
                            }
                            return null;
                        }, r.mallocArrayBuffer = p, r.mallocUint8 = d, r.mallocUint16 = m, r.mallocUint32 = g, r.mallocInt8 = v, r.mallocInt16 = y, r.mallocInt32 = x, r.mallocFloat32 = r.mallocFloat = b, r.mallocFloat64 = r.mallocDouble = _, r.mallocUint8Clamped = w, r.mallocBigUint64 = T, r.mallocBigInt64 = k, r.mallocDataView = A, r.mallocBuffer = M, r.clearCache = function() {
                            for(var t1 = 0; t1 < 32; ++t1)c.UINT8[t1].length = 0, c.UINT16[t1].length = 0, c.UINT32[t1].length = 0, c.INT8[t1].length = 0, c.INT16[t1].length = 0, c.INT32[t1].length = 0, c.FLOAT[t1].length = 0, c.DOUBLE[t1].length = 0, c.BIGUINT64[t1].length = 0, c.BIGINT64[t1].length = 0, c.UINT8C[t1].length = 0, u[t1].length = 0, f[t1].length = 0;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "bit-twiddle": 81,
                buffer: 85,
                dup: 128
            }
        ],
        328: [
            function(t1, e1, r) {
                var n = /[\'\"]/;
                e1.exports = function(t1) {
                    return t1 ? (n.test(t1.charAt(0)) && (t1 = t1.substr(1)), n.test(t1.charAt(t1.length - 1)) && (t1 = t1.substr(0, t1.length - 1)), t1) : "";
                };
            },
            {}
        ],
        329: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r) {
                    Array.isArray(r) || (r = [].slice.call(arguments, 2));
                    for(var n = 0, i = r.length; n < i; n++){
                        var a = r[n];
                        for(var o in a)if ((void 0 === e1[o] || Array.isArray(e1[o]) || t1[o] !== e1[o]) && o in e1) {
                            var s;
                            if (!0 === a[o]) s = e1[o];
                            else {
                                if (!1 === a[o]) continue;
                                if ("function" == typeof a[o] && void 0 === (s = a[o](e1[o], t1, e1))) continue;
                            }
                            t1[o] = s;
                        }
                    }
                    return t1;
                };
            },
            {}
        ],
        330: [
            function(t1, e1, r) {
                (function(t1) {
                    (function() {
                        function r(e1) {
                            try {
                                if (!t1.localStorage) return !1;
                            } catch (t1) {
                                return !1;
                            }
                            var r = t1.localStorage[e1];
                            return null != r && "true" === String(r).toLowerCase();
                        }
                        e1.exports = function(t1, e1) {
                            if (r("noDeprecation")) return t1;
                            var n = !1;
                            return function() {
                                if (!n) {
                                    if (r("throwDeprecation")) throw new Error(e1);
                                    r("traceDeprecation") ? console.trace(e1) : console.warn(e1), n = !0;
                                }
                                return t1.apply(this, arguments);
                            };
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        331: [
            function(t1, e1, r) {
                var n = t1("get-canvas-context");
                e1.exports = function(t1) {
                    return n("webgl", t1);
                };
            },
            {
                "get-canvas-context": 194
            }
        ],
        332: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign"), a = n.instance();
                function o(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                o.prototype = new n.baseCalendar, i(o.prototype, {
                    name: "Chinese",
                    jdEpoch: 1721425.5,
                    hasYearZero: !1,
                    minMonth: 0,
                    firstMonth: 0,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Chinese",
                            epochs: [
                                "BEC",
                                "EC"
                            ],
                            monthNumbers: function(t1, e1) {
                                if ("string" == typeof t1) {
                                    var r = t1.match(l);
                                    return r ? r[0] : "";
                                }
                                var n = this._validateYear(t1), i = t1.month(), a = "" + this.toChineseMonth(n, i);
                                return e1 && a.length < 2 && (a = "0" + a), this.isIntercalaryMonth(n, i) && (a += "i"), a;
                            },
                            monthNames: function(t1) {
                                if ("string" == typeof t1) {
                                    var e1 = t1.match(c);
                                    return e1 ? e1[0] : "";
                                }
                                var r = this._validateYear(t1), n = t1.month(), i = [
                                    "\u4e00\u6708",
                                    "\u4e8c\u6708",
                                    "\u4e09\u6708",
                                    "\u56db\u6708",
                                    "\u4e94\u6708",
                                    "\u516d\u6708",
                                    "\u4e03\u6708",
                                    "\u516b\u6708",
                                    "\u4e5d\u6708",
                                    "\u5341\u6708",
                                    "\u5341\u4e00\u6708",
                                    "\u5341\u4e8c\u6708"
                                ][this.toChineseMonth(r, n) - 1];
                                return this.isIntercalaryMonth(r, n) && (i = "\u95f0" + i), i;
                            },
                            monthNamesShort: function(t1) {
                                if ("string" == typeof t1) {
                                    var e1 = t1.match(u);
                                    return e1 ? e1[0] : "";
                                }
                                var r = this._validateYear(t1), n = t1.month(), i = [
                                    "\u4e00",
                                    "\u4e8c",
                                    "\u4e09",
                                    "\u56db",
                                    "\u4e94",
                                    "\u516d",
                                    "\u4e03",
                                    "\u516b",
                                    "\u4e5d",
                                    "\u5341",
                                    "\u5341\u4e00",
                                    "\u5341\u4e8c"
                                ][this.toChineseMonth(r, n) - 1];
                                return this.isIntercalaryMonth(r, n) && (i = "\u95f0" + i), i;
                            },
                            parseMonth: function(t1, e1) {
                                t1 = this._validateYear(t1);
                                var r, n = parseInt(e1);
                                if (isNaN(n)) "\u95f0" === e1[0] && (r = !0, e1 = e1.substring(1)), "\u6708" === e1[e1.length - 1] && (e1 = e1.substring(0, e1.length - 1)), n = 1 + [
                                    "\u4e00",
                                    "\u4e8c",
                                    "\u4e09",
                                    "\u56db",
                                    "\u4e94",
                                    "\u516d",
                                    "\u4e03",
                                    "\u516b",
                                    "\u4e5d",
                                    "\u5341",
                                    "\u5341\u4e00",
                                    "\u5341\u4e8c"
                                ].indexOf(e1);
                                else {
                                    var i = e1[e1.length - 1];
                                    r = "i" === i || "I" === i;
                                }
                                return this.toMonthIndex(t1, n, r);
                            },
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 1,
                            isRTL: !1
                        }
                    },
                    _validateYear: function(t1, e1) {
                        if (t1.year && (t1 = t1.year()), "number" != typeof t1 || t1 < 1888 || t1 > 2111) throw e1.replace(/\{0\}/, this.local.name);
                        return t1;
                    },
                    toMonthIndex: function(t1, e1, r) {
                        var i = this.intercalaryMonth(t1);
                        if (r && e1 !== i || e1 < 1 || e1 > 12) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
                        return i ? !r && e1 <= i ? e1 - 1 : e1 : e1 - 1;
                    },
                    toChineseMonth: function(t1, e1) {
                        t1.year && (e1 = (t1 = t1.year()).month());
                        var r = this.intercalaryMonth(t1);
                        if (e1 < 0 || e1 > (r ? 12 : 11)) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
                        return r ? e1 < r ? e1 + 1 : e1 : e1 + 1;
                    },
                    intercalaryMonth: function(t1) {
                        return t1 = this._validateYear(t1), f[t1 - f[0]] >> 13;
                    },
                    isIntercalaryMonth: function(t1, e1) {
                        t1.year && (e1 = (t1 = t1.year()).month());
                        var r = this.intercalaryMonth(t1);
                        return !!r && r === e1;
                    },
                    leapYear: function(t1) {
                        return 0 !== this.intercalaryMonth(t1);
                    },
                    weekOfYear: function(t1, e1, r) {
                        var i, o = this._validateYear(t1, n.local.invalidyear), s = h[o - h[0]], l = s >> 9 & 4095, c = s >> 5 & 15, u = 31 & s;
                        (i = a.newDate(l, c, u)).add(4 - (i.dayOfWeek() || 7), "d");
                        var f = this.toJD(t1, e1, r) - i.toJD();
                        return 1 + Math.floor(f / 7);
                    },
                    monthsInYear: function(t1) {
                        return this.leapYear(t1) ? 13 : 12;
                    },
                    daysInMonth: function(t1, e1) {
                        t1.year && (e1 = t1.month(), t1 = t1.year()), t1 = this._validateYear(t1);
                        var r = f[t1 - f[0]];
                        if (e1 > (r >> 13 ? 12 : 11)) throw n.local.invalidMonth.replace(/\{0\}/, this.local.name);
                        return r & 1 << 12 - e1 ? 30 : 29;
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, s, r, n.local.invalidDate);
                        t1 = this._validateYear(i.year()), e1 = i.month(), r = i.day();
                        var o = this.isIntercalaryMonth(t1, e1), s = this.toChineseMonth(t1, e1), l = function(t1, e1, r, n, i) {
                            var a, o, s;
                            if ("object" == typeof t1) o = t1, a = e1 || {};
                            else {
                                var l;
                                if (!("number" == typeof t1 && t1 >= 1888 && t1 <= 2111)) throw new Error("Lunar year outside range 1888-2111");
                                if (!("number" == typeof e1 && e1 >= 1 && e1 <= 12)) throw new Error("Lunar month outside range 1 - 12");
                                if (!("number" == typeof r && r >= 1 && r <= 30)) throw new Error("Lunar day outside range 1 - 30");
                                "object" == typeof n ? (l = !1, a = n) : (l = !!n, a = i || {}), o = {
                                    year: t1,
                                    month: e1,
                                    day: r,
                                    isIntercalary: l
                                };
                            }
                            s = o.day - 1;
                            var c, u = f[o.year - f[0]], p = u >> 13;
                            c = p && (o.month > p || o.isIntercalary) ? o.month : o.month - 1;
                            for(var d = 0; d < c; d++)s += u & 1 << 12 - d ? 30 : 29;
                            var m = h[o.year - h[0]], g = new Date(m >> 9 & 4095, (m >> 5 & 15) - 1, (31 & m) + s);
                            return a.year = g.getFullYear(), a.month = 1 + g.getMonth(), a.day = g.getDate(), a;
                        }(t1, s, r, o);
                        return a.toJD(l.year, l.month, l.day);
                    },
                    fromJD: function(t1) {
                        var e1 = a.fromJD(t1), r = function(t1, e1, r, n) {
                            var i, a;
                            if ("object" == typeof t1) i = t1, a = e1 || {};
                            else {
                                if (!("number" == typeof t1 && t1 >= 1888 && t1 <= 2111)) throw new Error("Solar year outside range 1888-2111");
                                if (!("number" == typeof e1 && e1 >= 1 && e1 <= 12)) throw new Error("Solar month outside range 1 - 12");
                                if (!("number" == typeof r && r >= 1 && r <= 31)) throw new Error("Solar day outside range 1 - 31");
                                i = {
                                    year: t1,
                                    month: e1,
                                    day: r
                                }, a = n || {};
                            }
                            var o = h[i.year - h[0]], s = i.year << 9 | i.month << 5 | i.day;
                            a.year = s >= o ? i.year : i.year - 1, o = h[a.year - h[0]];
                            var l, c = new Date(o >> 9 & 4095, (o >> 5 & 15) - 1, 31 & o), u = new Date(i.year, i.month - 1, i.day);
                            l = Math.round((u - c) / 864e5);
                            var p, d = f[a.year - f[0]];
                            for(p = 0; p < 13; p++){
                                var m = d & 1 << 12 - p ? 30 : 29;
                                if (l < m) break;
                                l -= m;
                            }
                            var g = d >> 13;
                            !g || p < g ? (a.isIntercalary = !1, a.month = 1 + p) : p === g ? (a.isIntercalary = !0, a.month = p) : (a.isIntercalary = !1, a.month = p);
                            return a.day = 1 + l, a;
                        }(e1.year(), e1.month(), e1.day()), n = this.toMonthIndex(r.year, r.month, r.isIntercalary);
                        return this.newDate(r.year, n, r.day);
                    },
                    fromString: function(t1) {
                        var e1 = t1.match(s), r = this._validateYear(+e1[1]), n = +e1[2], i = !!e1[3], a = this.toMonthIndex(r, n, i), o = +e1[4];
                        return this.newDate(r, a, o);
                    },
                    add: function(t1, e1, r) {
                        var n = t1.year(), i = t1.month(), a = this.isIntercalaryMonth(n, i), s = this.toChineseMonth(n, i), l = Object.getPrototypeOf(o.prototype).add.call(this, t1, e1, r);
                        if ("y" === r) {
                            var c = l.year(), u = l.month(), f = this.isIntercalaryMonth(c, s), h = a && f ? this.toMonthIndex(c, s, !0) : this.toMonthIndex(c, s, !1);
                            h !== u && l.month(h);
                        }
                        return l;
                    }
                });
                var s = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m, l = /^\d?\d[iI]?/m, c = /^\u95f0?\u5341?[\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]?\u6708/m, u = /^\u95f0?\u5341?[\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]?/m;
                n.calendars.chinese = o;
                var f = [
                    1887,
                    5780,
                    5802,
                    19157,
                    2742,
                    50359,
                    1198,
                    2646,
                    46378,
                    7466,
                    3412,
                    30122,
                    5482,
                    67949,
                    2396,
                    5294,
                    43597,
                    6732,
                    6954,
                    36181,
                    2772,
                    4954,
                    18781,
                    2396,
                    54427,
                    5274,
                    6730,
                    47781,
                    5800,
                    6868,
                    21210,
                    4790,
                    59703,
                    2350,
                    5270,
                    46667,
                    3402,
                    3496,
                    38325,
                    1388,
                    4782,
                    18735,
                    2350,
                    52374,
                    6804,
                    7498,
                    44457,
                    2906,
                    1388,
                    29294,
                    4700,
                    63789,
                    6442,
                    6804,
                    56138,
                    5802,
                    2772,
                    38235,
                    1210,
                    4698,
                    22827,
                    5418,
                    63125,
                    3476,
                    5802,
                    43701,
                    2484,
                    5302,
                    27223,
                    2646,
                    70954,
                    7466,
                    3412,
                    54698,
                    5482,
                    2412,
                    38062,
                    5294,
                    2636,
                    32038,
                    6954,
                    60245,
                    2772,
                    4826,
                    43357,
                    2394,
                    5274,
                    39501,
                    6730,
                    72357,
                    5800,
                    5844,
                    53978,
                    4790,
                    2358,
                    38039,
                    5270,
                    87627,
                    3402,
                    3496,
                    54708,
                    5484,
                    4782,
                    43311,
                    2350,
                    3222,
                    27978,
                    7498,
                    68965,
                    2904,
                    5484,
                    45677,
                    4700,
                    6444,
                    39573,
                    6804,
                    6986,
                    19285,
                    2772,
                    62811,
                    1210,
                    4698,
                    47403,
                    5418,
                    5780,
                    38570,
                    5546,
                    76469,
                    2420,
                    5302,
                    51799,
                    2646,
                    5414,
                    36501,
                    3412,
                    5546,
                    18869,
                    2412,
                    54446,
                    5276,
                    6732,
                    48422,
                    6822,
                    2900,
                    28010,
                    4826,
                    92509,
                    2394,
                    5274,
                    55883,
                    6730,
                    6820,
                    47956,
                    5812,
                    2778,
                    18779,
                    2358,
                    62615,
                    5270,
                    5450,
                    46757,
                    3492,
                    5556,
                    27318,
                    4718,
                    67887,
                    2350,
                    3222,
                    52554,
                    7498,
                    3428,
                    38252,
                    5468,
                    4700,
                    31022,
                    6444,
                    64149,
                    6804,
                    6986,
                    43861,
                    2772,
                    5338,
                    35421,
                    2650,
                    70955,
                    5418,
                    5780,
                    54954,
                    5546,
                    2740,
                    38074,
                    5302,
                    2646,
                    29991,
                    3366,
                    61011,
                    3412,
                    5546,
                    43445,
                    2412,
                    5294,
                    35406,
                    6732,
                    72998,
                    6820,
                    6996,
                    52586,
                    2778,
                    2396,
                    38045,
                    5274,
                    6698,
                    23333,
                    6820,
                    64338,
                    5812,
                    2746,
                    43355,
                    2358,
                    5270,
                    39499,
                    5450,
                    79525,
                    3492,
                    5548
                ], h = [
                    1887,
                    966732,
                    967231,
                    967733,
                    968265,
                    968766,
                    969297,
                    969798,
                    970298,
                    970829,
                    971330,
                    971830,
                    972362,
                    972863,
                    973395,
                    973896,
                    974397,
                    974928,
                    975428,
                    975929,
                    976461,
                    976962,
                    977462,
                    977994,
                    978494,
                    979026,
                    979526,
                    980026,
                    980558,
                    981059,
                    981559,
                    982091,
                    982593,
                    983124,
                    983624,
                    984124,
                    984656,
                    985157,
                    985656,
                    986189,
                    986690,
                    987191,
                    987722,
                    988222,
                    988753,
                    989254,
                    989754,
                    990286,
                    990788,
                    991288,
                    991819,
                    992319,
                    992851,
                    993352,
                    993851,
                    994383,
                    994885,
                    995385,
                    995917,
                    996418,
                    996918,
                    997450,
                    997949,
                    998481,
                    998982,
                    999483,
                    1000014,
                    1000515,
                    1001016,
                    1001548,
                    1002047,
                    1002578,
                    1003080,
                    1003580,
                    1004111,
                    1004613,
                    1005113,
                    1005645,
                    1006146,
                    1006645,
                    1007177,
                    1007678,
                    1008209,
                    1008710,
                    1009211,
                    1009743,
                    1010243,
                    1010743,
                    1011275,
                    1011775,
                    1012306,
                    1012807,
                    1013308,
                    1013840,
                    1014341,
                    1014841,
                    1015373,
                    1015874,
                    1016404,
                    1016905,
                    1017405,
                    1017937,
                    1018438,
                    1018939,
                    1019471,
                    1019972,
                    1020471,
                    1021002,
                    1021503,
                    1022035,
                    1022535,
                    1023036,
                    1023568,
                    1024069,
                    1024568,
                    1025100,
                    1025601,
                    1026102,
                    1026633,
                    1027133,
                    1027666,
                    1028167,
                    1028666,
                    1029198,
                    1029699,
                    1030199,
                    1030730,
                    1031231,
                    1031763,
                    1032264,
                    1032764,
                    1033296,
                    1033797,
                    1034297,
                    1034828,
                    1035329,
                    1035830,
                    1036362,
                    1036861,
                    1037393,
                    1037894,
                    1038394,
                    1038925,
                    1039427,
                    1039927,
                    1040459,
                    1040959,
                    1041491,
                    1041992,
                    1042492,
                    1043023,
                    1043524,
                    1044024,
                    1044556,
                    1045057,
                    1045558,
                    1046090,
                    1046590,
                    1047121,
                    1047622,
                    1048122,
                    1048654,
                    1049154,
                    1049655,
                    1050187,
                    1050689,
                    1051219,
                    1051720,
                    1052220,
                    1052751,
                    1053252,
                    1053752,
                    1054284,
                    1054786,
                    1055285,
                    1055817,
                    1056317,
                    1056849,
                    1057349,
                    1057850,
                    1058382,
                    1058883,
                    1059383,
                    1059915,
                    1060415,
                    1060947,
                    1061447,
                    1061947,
                    1062479,
                    1062981,
                    1063480,
                    1064012,
                    1064514,
                    1065014,
                    1065545,
                    1066045,
                    1066577,
                    1067078,
                    1067578,
                    1068110,
                    1068611,
                    1069112,
                    1069642,
                    1070142,
                    1070674,
                    1071175,
                    1071675,
                    1072207,
                    1072709,
                    1073209,
                    1073740,
                    1074241,
                    1074741,
                    1075273,
                    1075773,
                    1076305,
                    1076807,
                    1077308,
                    1077839,
                    1078340,
                    1078840,
                    1079372,
                    1079871,
                    1080403,
                    1080904
                ];
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        333: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign");
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Coptic",
                    jdEpoch: 1825029.5,
                    daysPerMonth: [
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        5
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Coptic",
                            epochs: [
                                "BAM",
                                "AM"
                            ],
                            monthNames: [
                                "Thout",
                                "Paopi",
                                "Hathor",
                                "Koiak",
                                "Tobi",
                                "Meshir",
                                "Paremhat",
                                "Paremoude",
                                "Pashons",
                                "Paoni",
                                "Epip",
                                "Mesori",
                                "Pi Kogi Enavot"
                            ],
                            monthNamesShort: [
                                "Tho",
                                "Pao",
                                "Hath",
                                "Koi",
                                "Tob",
                                "Mesh",
                                "Pat",
                                "Pad",
                                "Pash",
                                "Pao",
                                "Epi",
                                "Meso",
                                "PiK"
                            ],
                            dayNames: [
                                "Tkyriaka",
                                "Pesnau",
                                "Pshoment",
                                "Peftoou",
                                "Ptiou",
                                "Psoou",
                                "Psabbaton"
                            ],
                            dayNamesShort: [
                                "Tky",
                                "Pes",
                                "Psh",
                                "Pef",
                                "Pti",
                                "Pso",
                                "Psa"
                            ],
                            dayNamesMin: [
                                "Tk",
                                "Pes",
                                "Psh",
                                "Pef",
                                "Pt",
                                "Pso",
                                "Psa"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return (t1 = e1.year() + (e1.year() < 0 ? 1 : 0)) % 4 == 3 || t1 % 4 == -1;
                    },
                    monthsInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear), 13;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (13 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return (t1 = i.year()) < 0 && t1++, i.day() + 30 * (i.month() - 1) + 365 * (t1 - 1) + Math.floor(t1 / 4) + this.jdEpoch - 1;
                    },
                    fromJD: function(t1) {
                        var e1 = Math.floor(t1) + .5 - this.jdEpoch, r = Math.floor((e1 - Math.floor((e1 + 366) / 1461)) / 365) + 1;
                        r <= 0 && r--, e1 = Math.floor(t1) + .5 - this.newDate(r, 1, 1).toJD();
                        var n = Math.floor(e1 / 30) + 1, i = e1 - 30 * (n - 1) + 1;
                        return this.newDate(r, n, i);
                    }
                }), n.calendars.coptic = a;
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        334: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign");
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Discworld",
                    jdEpoch: 1721425.5,
                    daysPerMonth: [
                        16,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Discworld",
                            epochs: [
                                "BUC",
                                "UC"
                            ],
                            monthNames: [
                                "Ick",
                                "Offle",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "Grune",
                                "August",
                                "Spune",
                                "Sektober",
                                "Ember",
                                "December"
                            ],
                            monthNamesShort: [
                                "Ick",
                                "Off",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Gru",
                                "Aug",
                                "Spu",
                                "Sek",
                                "Emb",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Octeday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Oct",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Oc",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 2,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), !1;
                    },
                    monthsInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), 13;
                    },
                    daysInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), 400;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 8) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1];
                    },
                    daysInWeek: function() {
                        return 8;
                    },
                    dayOfWeek: function(t1, e1, r) {
                        return (this._validate(t1, e1, r, n.local.invalidDate).day() + 1) % 8;
                    },
                    weekDay: function(t1, e1, r) {
                        var n = this.dayOfWeek(t1, e1, r);
                        return n >= 2 && n <= 6;
                    },
                    extraInfo: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return {
                            century: o[Math.floor((i.year() - 1) / 100) + 1] || ""
                        };
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return t1 = i.year() + (i.year() < 0 ? 1 : 0), e1 = i.month(), (r = i.day()) + (e1 > 1 ? 16 : 0) + (e1 > 2 ? 32 * (e1 - 2) : 0) + 400 * (t1 - 1) + this.jdEpoch - 1;
                    },
                    fromJD: function(t1) {
                        t1 = Math.floor(t1 + .5) - Math.floor(this.jdEpoch) - 1;
                        var e1 = Math.floor(t1 / 400) + 1;
                        t1 -= 400 * (e1 - 1), t1 += t1 > 15 ? 16 : 0;
                        var r = Math.floor(t1 / 32) + 1, n = t1 - 32 * (r - 1) + 1;
                        return this.newDate(e1 <= 0 ? e1 - 1 : e1, r, n);
                    }
                });
                var o = {
                    20: "Fruitbat",
                    21: "Anchovy"
                };
                n.calendars.discworld = a;
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        335: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign");
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Ethiopian",
                    jdEpoch: 1724220.5,
                    daysPerMonth: [
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        5
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Ethiopian",
                            epochs: [
                                "BEE",
                                "EE"
                            ],
                            monthNames: [
                                "Meskerem",
                                "Tikemet",
                                "Hidar",
                                "Tahesas",
                                "Tir",
                                "Yekatit",
                                "Megabit",
                                "Miazia",
                                "Genbot",
                                "Sene",
                                "Hamle",
                                "Nehase",
                                "Pagume"
                            ],
                            monthNamesShort: [
                                "Mes",
                                "Tik",
                                "Hid",
                                "Tah",
                                "Tir",
                                "Yek",
                                "Meg",
                                "Mia",
                                "Gen",
                                "Sen",
                                "Ham",
                                "Neh",
                                "Pag"
                            ],
                            dayNames: [
                                "Ehud",
                                "Segno",
                                "Maksegno",
                                "Irob",
                                "Hamus",
                                "Arb",
                                "Kidame"
                            ],
                            dayNamesShort: [
                                "Ehu",
                                "Seg",
                                "Mak",
                                "Iro",
                                "Ham",
                                "Arb",
                                "Kid"
                            ],
                            dayNamesMin: [
                                "Eh",
                                "Se",
                                "Ma",
                                "Ir",
                                "Ha",
                                "Ar",
                                "Ki"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return (t1 = e1.year() + (e1.year() < 0 ? 1 : 0)) % 4 == 3 || t1 % 4 == -1;
                    },
                    monthsInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear), 13;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (13 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return (t1 = i.year()) < 0 && t1++, i.day() + 30 * (i.month() - 1) + 365 * (t1 - 1) + Math.floor(t1 / 4) + this.jdEpoch - 1;
                    },
                    fromJD: function(t1) {
                        var e1 = Math.floor(t1) + .5 - this.jdEpoch, r = Math.floor((e1 - Math.floor((e1 + 366) / 1461)) / 365) + 1;
                        r <= 0 && r--, e1 = Math.floor(t1) + .5 - this.newDate(r, 1, 1).toJD();
                        var n = Math.floor(e1 / 30) + 1, i = e1 - 30 * (n - 1) + 1;
                        return this.newDate(r, n, i);
                    }
                }), n.calendars.ethiopian = a;
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        336: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign");
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                function o(t1, e1) {
                    return t1 - e1 * Math.floor(t1 / e1);
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Hebrew",
                    jdEpoch: 347995.5,
                    daysPerMonth: [
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        29
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 7,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Hebrew",
                            epochs: [
                                "BAM",
                                "AM"
                            ],
                            monthNames: [
                                "Nisan",
                                "Iyar",
                                "Sivan",
                                "Tammuz",
                                "Av",
                                "Elul",
                                "Tishrei",
                                "Cheshvan",
                                "Kislev",
                                "Tevet",
                                "Shevat",
                                "Adar",
                                "Adar II"
                            ],
                            monthNamesShort: [
                                "Nis",
                                "Iya",
                                "Siv",
                                "Tam",
                                "Av",
                                "Elu",
                                "Tis",
                                "Che",
                                "Kis",
                                "Tev",
                                "She",
                                "Ada",
                                "Ad2"
                            ],
                            dayNames: [
                                "Yom Rishon",
                                "Yom Sheni",
                                "Yom Shlishi",
                                "Yom Revi'i",
                                "Yom Chamishi",
                                "Yom Shishi",
                                "Yom Shabbat"
                            ],
                            dayNamesShort: [
                                "Ris",
                                "She",
                                "Shl",
                                "Rev",
                                "Cha",
                                "Shi",
                                "Sha"
                            ],
                            dayNamesMin: [
                                "Ri",
                                "She",
                                "Shl",
                                "Re",
                                "Ch",
                                "Shi",
                                "Sha"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return this._leapYear(e1.year());
                    },
                    _leapYear: function(t1) {
                        return o(7 * (t1 = t1 < 0 ? t1 + 1 : t1) + 1, 19) < 7;
                    },
                    monthsInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), this._leapYear(t1.year ? t1.year() : t1) ? 13 : 12;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInYear: function(t1) {
                        return t1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear).year(), this.toJD(-1 === t1 ? 1 : t1 + 1, 7, 1) - this.toJD(t1, 7, 1);
                    },
                    daysInMonth: function(t1, e1) {
                        return t1.year && (e1 = t1.month(), t1 = t1.year()), this._validate(t1, e1, this.minDay, n.local.invalidMonth), 12 === e1 && this.leapYear(t1) || 8 === e1 && 5 === o(this.daysInYear(t1), 10) ? 30 : 9 === e1 && 3 === o(this.daysInYear(t1), 10) ? 29 : this.daysPerMonth[e1 - 1];
                    },
                    weekDay: function(t1, e1, r) {
                        return 6 !== this.dayOfWeek(t1, e1, r);
                    },
                    extraInfo: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return {
                            yearType: (this.leapYear(i) ? "embolismic" : "common") + " " + [
                                "deficient",
                                "regular",
                                "complete"
                            ][this.daysInYear(i) % 10 - 3]
                        };
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        t1 = i.year(), e1 = i.month(), r = i.day();
                        var a = t1 <= 0 ? t1 + 1 : t1, o = this.jdEpoch + this._delay1(a) + this._delay2(a) + r + 1;
                        if (e1 < 7) {
                            for(var s = 7; s <= this.monthsInYear(t1); s++)o += this.daysInMonth(t1, s);
                            for(s = 1; s < e1; s++)o += this.daysInMonth(t1, s);
                        } else for(s = 7; s < e1; s++)o += this.daysInMonth(t1, s);
                        return o;
                    },
                    _delay1: function(t1) {
                        var e1 = Math.floor((235 * t1 - 234) / 19), r = 12084 + 13753 * e1, n = 29 * e1 + Math.floor(r / 25920);
                        return o(3 * (n + 1), 7) < 3 && n++, n;
                    },
                    _delay2: function(t1) {
                        var e1 = this._delay1(t1 - 1), r = this._delay1(t1);
                        return this._delay1(t1 + 1) - r == 356 ? 2 : r - e1 == 382 ? 1 : 0;
                    },
                    fromJD: function(t1) {
                        t1 = Math.floor(t1) + .5;
                        for(var e1 = Math.floor(98496 * (t1 - this.jdEpoch) / 35975351) - 1; t1 >= this.toJD(-1 === e1 ? 1 : e1 + 1, 7, 1);)e1++;
                        for(var r = t1 < this.toJD(e1, 1, 1) ? 7 : 1; t1 > this.toJD(e1, r, this.daysInMonth(e1, r));)r++;
                        var n = t1 - this.toJD(e1, r, 1) + 1;
                        return this.newDate(e1, r, n);
                    }
                }), n.calendars.hebrew = a;
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        337: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign");
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Islamic",
                    jdEpoch: 1948439.5,
                    daysPerMonth: [
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29,
                        30,
                        29
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Islamic",
                            epochs: [
                                "BH",
                                "AH"
                            ],
                            monthNames: [
                                "Muharram",
                                "Safar",
                                "Rabi' al-awwal",
                                "Rabi' al-thani",
                                "Jumada al-awwal",
                                "Jumada al-thani",
                                "Rajab",
                                "Sha'aban",
                                "Ramadan",
                                "Shawwal",
                                "Dhu al-Qi'dah",
                                "Dhu al-Hijjah"
                            ],
                            monthNamesShort: [
                                "Muh",
                                "Saf",
                                "Rab1",
                                "Rab2",
                                "Jum1",
                                "Jum2",
                                "Raj",
                                "Sha'",
                                "Ram",
                                "Shaw",
                                "DhuQ",
                                "DhuH"
                            ],
                            dayNames: [
                                "Yawm al-ahad",
                                "Yawm al-ithnayn",
                                "Yawm ath-thulaathaa'",
                                "Yawm al-arbi'aa'",
                                "Yawm al-kham\u012bs",
                                "Yawm al-jum'a",
                                "Yawm as-sabt"
                            ],
                            dayNamesShort: [
                                "Aha",
                                "Ith",
                                "Thu",
                                "Arb",
                                "Kha",
                                "Jum",
                                "Sab"
                            ],
                            dayNamesMin: [
                                "Ah",
                                "It",
                                "Th",
                                "Ar",
                                "Kh",
                                "Ju",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 6,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        return (11 * this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear).year() + 14) % 30 < 11;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInYear: function(t1) {
                        return this.leapYear(t1) ? 355 : 354;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return 5 !== this.dayOfWeek(t1, e1, r);
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return t1 = i.year(), e1 = i.month(), t1 = t1 <= 0 ? t1 + 1 : t1, (r = i.day()) + Math.ceil(29.5 * (e1 - 1)) + 354 * (t1 - 1) + Math.floor((3 + 11 * t1) / 30) + this.jdEpoch - 1;
                    },
                    fromJD: function(t1) {
                        t1 = Math.floor(t1) + .5;
                        var e1 = Math.floor((30 * (t1 - this.jdEpoch) + 10646) / 10631);
                        e1 = e1 <= 0 ? e1 - 1 : e1;
                        var r = Math.min(12, Math.ceil((t1 - 29 - this.toJD(e1, 1, 1)) / 29.5) + 1), n = t1 - this.toJD(e1, r, 1) + 1;
                        return this.newDate(e1, r, n);
                    }
                }), n.calendars.islamic = a;
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        338: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign");
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Julian",
                    jdEpoch: 1721423.5,
                    daysPerMonth: [
                        31,
                        28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Julian",
                            epochs: [
                                "BC",
                                "AD"
                            ],
                            monthNames: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            monthNamesShort: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "mm/dd/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return (t1 = e1.year() < 0 ? e1.year() + 1 : e1.year()) % 4 == 0;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return t1 = i.year(), e1 = i.month(), r = i.day(), t1 < 0 && t1++, e1 <= 2 && (t1--, e1 += 12), Math.floor(365.25 * (t1 + 4716)) + Math.floor(30.6001 * (e1 + 1)) + r - 1524.5;
                    },
                    fromJD: function(t1) {
                        var e1 = Math.floor(t1 + .5) + 1524, r = Math.floor((e1 - 122.1) / 365.25), n = Math.floor(365.25 * r), i = Math.floor((e1 - n) / 30.6001), a = i - Math.floor(i < 14 ? 1 : 13), o = r - Math.floor(a > 2 ? 4716 : 4715), s = e1 - n - Math.floor(30.6001 * i);
                        return o <= 0 && o--, this.newDate(o, a, s);
                    }
                }), n.calendars.julian = a;
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        339: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign");
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                function o(t1, e1) {
                    return t1 - e1 * Math.floor(t1 / e1);
                }
                function s(t1, e1) {
                    return o(t1 - 1, e1) + 1;
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Mayan",
                    jdEpoch: 584282.5,
                    hasYearZero: !0,
                    minMonth: 0,
                    firstMonth: 0,
                    minDay: 0,
                    regionalOptions: {
                        "": {
                            name: "Mayan",
                            epochs: [
                                "",
                                ""
                            ],
                            monthNames: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17"
                            ],
                            monthNamesShort: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17"
                            ],
                            dayNames: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17",
                                "18",
                                "19"
                            ],
                            dayNamesShort: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17",
                                "18",
                                "19"
                            ],
                            dayNamesMin: [
                                "0",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                                "13",
                                "14",
                                "15",
                                "16",
                                "17",
                                "18",
                                "19"
                            ],
                            digits: null,
                            dateFormat: "YYYY.m.d",
                            firstDay: 0,
                            isRTL: !1,
                            haabMonths: [
                                "Pop",
                                "Uo",
                                "Zip",
                                "Zotz",
                                "Tzec",
                                "Xul",
                                "Yaxkin",
                                "Mol",
                                "Chen",
                                "Yax",
                                "Zac",
                                "Ceh",
                                "Mac",
                                "Kankin",
                                "Muan",
                                "Pax",
                                "Kayab",
                                "Cumku",
                                "Uayeb"
                            ],
                            tzolkinMonths: [
                                "Imix",
                                "Ik",
                                "Akbal",
                                "Kan",
                                "Chicchan",
                                "Cimi",
                                "Manik",
                                "Lamat",
                                "Muluc",
                                "Oc",
                                "Chuen",
                                "Eb",
                                "Ben",
                                "Ix",
                                "Men",
                                "Cib",
                                "Caban",
                                "Etznab",
                                "Cauac",
                                "Ahau"
                            ]
                        }
                    },
                    leapYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), !1;
                    },
                    formatYear: function(t1) {
                        t1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear).year();
                        var e1 = Math.floor(t1 / 400);
                        return t1 %= 400, t1 += t1 < 0 ? 400 : 0, e1 + "." + Math.floor(t1 / 20) + "." + t1 % 20;
                    },
                    forYear: function(t1) {
                        if ((t1 = t1.split(".")).length < 3) throw "Invalid Mayan year";
                        for(var e1 = 0, r = 0; r < t1.length; r++){
                            var n = parseInt(t1[r], 10);
                            if (Math.abs(n) > 19 || r > 0 && n < 0) throw "Invalid Mayan year";
                            e1 = 20 * e1 + n;
                        }
                        return e1;
                    },
                    monthsInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), 18;
                    },
                    weekOfYear: function(t1, e1, r) {
                        return this._validate(t1, e1, r, n.local.invalidDate), 0;
                    },
                    daysInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear), 360;
                    },
                    daysInMonth: function(t1, e1) {
                        return this._validate(t1, e1, this.minDay, n.local.invalidMonth), 20;
                    },
                    daysInWeek: function() {
                        return 5;
                    },
                    dayOfWeek: function(t1, e1, r) {
                        return this._validate(t1, e1, r, n.local.invalidDate).day();
                    },
                    weekDay: function(t1, e1, r) {
                        return this._validate(t1, e1, r, n.local.invalidDate), !0;
                    },
                    extraInfo: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate).toJD(), a = this._toHaab(i), o = this._toTzolkin(i);
                        return {
                            haabMonthName: this.local.haabMonths[a[0] - 1],
                            haabMonth: a[0],
                            haabDay: a[1],
                            tzolkinDayName: this.local.tzolkinMonths[o[0] - 1],
                            tzolkinDay: o[0],
                            tzolkinTrecena: o[1]
                        };
                    },
                    _toHaab: function(t1) {
                        var e1 = o((t1 -= this.jdEpoch) + 8 + 340, 365);
                        return [
                            Math.floor(e1 / 20) + 1,
                            o(e1, 20)
                        ];
                    },
                    _toTzolkin: function(t1) {
                        return [
                            s((t1 -= this.jdEpoch) + 20, 20),
                            s(t1 + 4, 13)
                        ];
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        return i.day() + 20 * i.month() + 360 * i.year() + this.jdEpoch;
                    },
                    fromJD: function(t1) {
                        t1 = Math.floor(t1) + .5 - this.jdEpoch;
                        var e1 = Math.floor(t1 / 360);
                        t1 %= 360, t1 += t1 < 0 ? 360 : 0;
                        var r = Math.floor(t1 / 20), n = t1 % 20;
                        return this.newDate(e1, r, n);
                    }
                }), n.calendars.mayan = a;
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        340: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign");
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar;
                var o = n.instance("gregorian");
                i(a.prototype, {
                    name: "Nanakshahi",
                    jdEpoch: 2257673.5,
                    daysPerMonth: [
                        31,
                        31,
                        31,
                        31,
                        31,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Nanakshahi",
                            epochs: [
                                "BN",
                                "AN"
                            ],
                            monthNames: [
                                "Chet",
                                "Vaisakh",
                                "Jeth",
                                "Harh",
                                "Sawan",
                                "Bhadon",
                                "Assu",
                                "Katak",
                                "Maghar",
                                "Poh",
                                "Magh",
                                "Phagun"
                            ],
                            monthNamesShort: [
                                "Che",
                                "Vai",
                                "Jet",
                                "Har",
                                "Saw",
                                "Bha",
                                "Ass",
                                "Kat",
                                "Mgr",
                                "Poh",
                                "Mgh",
                                "Pha"
                            ],
                            dayNames: [
                                "Somvaar",
                                "Mangalvar",
                                "Budhvaar",
                                "Veervaar",
                                "Shukarvaar",
                                "Sanicharvaar",
                                "Etvaar"
                            ],
                            dayNamesShort: [
                                "Som",
                                "Mangal",
                                "Budh",
                                "Veer",
                                "Shukar",
                                "Sanichar",
                                "Et"
                            ],
                            dayNamesMin: [
                                "So",
                                "Ma",
                                "Bu",
                                "Ve",
                                "Sh",
                                "Sa",
                                "Et"
                            ],
                            digits: null,
                            dateFormat: "dd-mm-yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear || n.regionalOptions[""].invalidYear);
                        return o.leapYear(e1.year() + (e1.year() < 1 ? 1 : 0) + 1469);
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(1 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidMonth);
                        (t1 = i.year()) < 0 && t1++;
                        for(var a = i.day(), s = 1; s < i.month(); s++)a += this.daysPerMonth[s - 1];
                        return a + o.toJD(t1 + 1468, 3, 13);
                    },
                    fromJD: function(t1) {
                        t1 = Math.floor(t1 + .5);
                        for(var e1 = Math.floor((t1 - (this.jdEpoch - 1)) / 366); t1 >= this.toJD(e1 + 1, 1, 1);)e1++;
                        for(var r = t1 - Math.floor(this.toJD(e1, 1, 1) + .5) + 1, n = 1; r > this.daysInMonth(e1, n);)r -= this.daysInMonth(e1, n), n++;
                        return this.newDate(e1, n, r);
                    }
                }), n.calendars.nanakshahi = a;
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        341: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign");
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Nepali",
                    jdEpoch: 1700709.5,
                    daysPerMonth: [
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    daysPerYear: 365,
                    regionalOptions: {
                        "": {
                            name: "Nepali",
                            epochs: [
                                "BBS",
                                "ABS"
                            ],
                            monthNames: [
                                "Baisakh",
                                "Jestha",
                                "Ashadh",
                                "Shrawan",
                                "Bhadra",
                                "Ashwin",
                                "Kartik",
                                "Mangsir",
                                "Paush",
                                "Mangh",
                                "Falgun",
                                "Chaitra"
                            ],
                            monthNamesShort: [
                                "Bai",
                                "Je",
                                "As",
                                "Shra",
                                "Bha",
                                "Ash",
                                "Kar",
                                "Mang",
                                "Pau",
                                "Ma",
                                "Fal",
                                "Chai"
                            ],
                            dayNames: [
                                "Aaitabaar",
                                "Sombaar",
                                "Manglbaar",
                                "Budhabaar",
                                "Bihibaar",
                                "Shukrabaar",
                                "Shanibaar"
                            ],
                            dayNamesShort: [
                                "Aaita",
                                "Som",
                                "Mangl",
                                "Budha",
                                "Bihi",
                                "Shukra",
                                "Shani"
                            ],
                            dayNamesMin: [
                                "Aai",
                                "So",
                                "Man",
                                "Bu",
                                "Bi",
                                "Shu",
                                "Sha"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 1,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        return this.daysInYear(t1) !== this.daysPerYear;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInYear: function(t1) {
                        if (t1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear).year(), void 0 === this.NEPALI_CALENDAR_DATA[t1]) return this.daysPerYear;
                        for(var e1 = 0, r = this.minMonth; r <= 12; r++)e1 += this.NEPALI_CALENDAR_DATA[t1][r];
                        return e1;
                    },
                    daysInMonth: function(t1, e1) {
                        return t1.year && (e1 = t1.month(), t1 = t1.year()), this._validate(t1, e1, this.minDay, n.local.invalidMonth), void 0 === this.NEPALI_CALENDAR_DATA[t1] ? this.daysPerMonth[e1 - 1] : this.NEPALI_CALENDAR_DATA[t1][e1];
                    },
                    weekDay: function(t1, e1, r) {
                        return 6 !== this.dayOfWeek(t1, e1, r);
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        t1 = i.year(), e1 = i.month(), r = i.day();
                        var a = n.instance(), o = 0, s = e1, l = t1;
                        this._createMissingCalendarData(t1);
                        var c = t1 - (s > 9 || 9 === s && r >= this.NEPALI_CALENDAR_DATA[l][0] ? 56 : 57);
                        for(9 !== e1 && (o = r, s--); 9 !== s;)s <= 0 && (s = 12, l--), o += this.NEPALI_CALENDAR_DATA[l][s], s--;
                        return 9 === e1 ? (o += r - this.NEPALI_CALENDAR_DATA[l][0]) < 0 && (o += a.daysInYear(c)) : o += this.NEPALI_CALENDAR_DATA[l][9] - this.NEPALI_CALENDAR_DATA[l][0], a.newDate(c, 1, 1).add(o, "d").toJD();
                    },
                    fromJD: function(t1) {
                        var e1 = n.instance().fromJD(t1), r = e1.year(), i = e1.dayOfYear(), a = r + 56;
                        this._createMissingCalendarData(a);
                        for(var o = 9, s = this.NEPALI_CALENDAR_DATA[a][0], l = this.NEPALI_CALENDAR_DATA[a][o] - s + 1; i > l;)++o > 12 && (o = 1, a++), l += this.NEPALI_CALENDAR_DATA[a][o];
                        var c = this.NEPALI_CALENDAR_DATA[a][o] - (l - i);
                        return this.newDate(a, o, c);
                    },
                    _createMissingCalendarData: function(t1) {
                        var e1 = this.daysPerMonth.slice(0);
                        e1.unshift(17);
                        for(var r = t1 - 1; r < t1 + 2; r++)void 0 === this.NEPALI_CALENDAR_DATA[r] && (this.NEPALI_CALENDAR_DATA[r] = e1);
                    },
                    NEPALI_CALENDAR_DATA: {
                        1970: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1971: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            32,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1972: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        1973: [
                            19,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        1974: [
                            19,
                            31,
                            31,
                            32,
                            30,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1975: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            30,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1976: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        1977: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        1978: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1979: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1980: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        1981: [
                            18,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        1982: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1983: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1984: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        1985: [
                            18,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        1986: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1987: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1988: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        1989: [
                            18,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1990: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1991: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1992: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        1993: [
                            18,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1994: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1995: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        1996: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        1997: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1998: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        1999: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2e3: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2001: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2002: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2003: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2004: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2005: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2006: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2007: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2008: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            29,
                            31
                        ],
                        2009: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2010: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2011: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2012: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2013: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2014: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2015: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2016: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2017: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2018: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2019: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2020: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2021: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2022: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2023: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2024: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2025: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2026: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2027: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2028: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2029: [
                            18,
                            31,
                            31,
                            32,
                            31,
                            32,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2030: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            30,
                            30,
                            30,
                            31
                        ],
                        2031: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            31,
                            31,
                            31,
                            31,
                            31,
                            31,
                            31
                        ],
                        2032: [
                            17,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32,
                            32
                        ],
                        2033: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2034: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2035: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            29,
                            31
                        ],
                        2036: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2037: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2038: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2039: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2040: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2041: [
                            18,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2042: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2043: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2044: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2045: [
                            18,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2046: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2047: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2048: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2049: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2050: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2051: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2052: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2053: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2054: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2055: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            30,
                            29,
                            30
                        ],
                        2056: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            32,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2057: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2058: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2059: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2060: [
                            17,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2061: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2062: [
                            17,
                            30,
                            32,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2063: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2064: [
                            17,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2065: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2066: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            29,
                            31
                        ],
                        2067: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2068: [
                            17,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2069: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2070: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            29,
                            30,
                            30,
                            29,
                            30,
                            30
                        ],
                        2071: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2072: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2073: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            31
                        ],
                        2074: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2075: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2076: [
                            16,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2077: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            29,
                            31
                        ],
                        2078: [
                            17,
                            31,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2079: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2080: [
                            16,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            29,
                            30,
                            30
                        ],
                        2081: [
                            17,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2082: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2083: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2084: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2085: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            31,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2086: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2087: [
                            16,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2088: [
                            16,
                            30,
                            31,
                            32,
                            32,
                            30,
                            31,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2089: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2090: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2091: [
                            16,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2092: [
                            16,
                            31,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2093: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2094: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2095: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            30,
                            30,
                            30,
                            30
                        ],
                        2096: [
                            17,
                            30,
                            31,
                            32,
                            32,
                            31,
                            30,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ],
                        2097: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            31,
                            30,
                            30,
                            30,
                            29,
                            30,
                            30,
                            30
                        ],
                        2098: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            29,
                            30,
                            29,
                            30,
                            30,
                            31
                        ],
                        2099: [
                            17,
                            31,
                            31,
                            32,
                            31,
                            31,
                            31,
                            30,
                            29,
                            29,
                            30,
                            30,
                            30
                        ],
                        2100: [
                            17,
                            31,
                            32,
                            31,
                            32,
                            30,
                            31,
                            30,
                            29,
                            30,
                            29,
                            30,
                            30
                        ]
                    }
                }), n.calendars.nepali = a;
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        342: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign");
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                function o(t1, e1) {
                    return t1 - e1 * Math.floor(t1 / e1);
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "Persian",
                    jdEpoch: 1948320.5,
                    daysPerMonth: [
                        31,
                        31,
                        31,
                        31,
                        31,
                        31,
                        30,
                        30,
                        30,
                        30,
                        30,
                        29
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Persian",
                            epochs: [
                                "BP",
                                "AP"
                            ],
                            monthNames: [
                                "Farvardin",
                                "Ordibehesht",
                                "Khordad",
                                "Tir",
                                "Mordad",
                                "Shahrivar",
                                "Mehr",
                                "Aban",
                                "Azar",
                                "Day",
                                "Bahman",
                                "Esfand"
                            ],
                            monthNamesShort: [
                                "Far",
                                "Ord",
                                "Kho",
                                "Tir",
                                "Mor",
                                "Sha",
                                "Meh",
                                "Aba",
                                "Aza",
                                "Day",
                                "Bah",
                                "Esf"
                            ],
                            dayNames: [
                                "Yekshambe",
                                "Doshambe",
                                "Seshambe",
                                "Ch\xe6harshambe",
                                "Panjshambe",
                                "Jom'e",
                                "Shambe"
                            ],
                            dayNamesShort: [
                                "Yek",
                                "Do",
                                "Se",
                                "Ch\xe6",
                                "Panj",
                                "Jom",
                                "Sha"
                            ],
                            dayNamesMin: [
                                "Ye",
                                "Do",
                                "Se",
                                "Ch",
                                "Pa",
                                "Jo",
                                "Sh"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 6,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return 682 * ((e1.year() - (e1.year() > 0 ? 474 : 473)) % 2820 + 474 + 38) % 2816 < 682;
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-(n.dayOfWeek() + 1) % 7, "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (12 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return 5 !== this.dayOfWeek(t1, e1, r);
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        t1 = i.year(), e1 = i.month(), r = i.day();
                        var a = t1 - (t1 >= 0 ? 474 : 473), s = 474 + o(a, 2820);
                        return r + (e1 <= 7 ? 31 * (e1 - 1) : 30 * (e1 - 1) + 6) + Math.floor((682 * s - 110) / 2816) + 365 * (s - 1) + 1029983 * Math.floor(a / 2820) + this.jdEpoch - 1;
                    },
                    fromJD: function(t1) {
                        var e1 = (t1 = Math.floor(t1) + .5) - this.toJD(475, 1, 1), r = Math.floor(e1 / 1029983), n = o(e1, 1029983), i = 2820;
                        if (1029982 !== n) {
                            var a = Math.floor(n / 366), s = o(n, 366);
                            i = Math.floor((2134 * a + 2816 * s + 2815) / 1028522) + a + 1;
                        }
                        var l = i + 2820 * r + 474;
                        l = l <= 0 ? l - 1 : l;
                        var c = t1 - this.toJD(l, 1, 1) + 1, u = c <= 186 ? Math.ceil(c / 31) : Math.ceil((c - 6) / 30), f = t1 - this.toJD(l, u, 1) + 1;
                        return this.newDate(l, u, f);
                    }
                }), n.calendars.persian = a, n.calendars.jalali = a;
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        343: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign"), a = n.instance();
                function o(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                o.prototype = new n.baseCalendar, i(o.prototype, {
                    name: "Taiwan",
                    jdEpoch: 2419402.5,
                    yearsOffset: 1911,
                    daysPerMonth: [
                        31,
                        28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Taiwan",
                            epochs: [
                                "BROC",
                                "ROC"
                            ],
                            monthNames: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            monthNamesShort: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 1,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        t1 = this._t2gYear(e1.year());
                        return a.leapYear(t1);
                    },
                    weekOfYear: function(t1, e1, r) {
                        var i = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        t1 = this._t2gYear(i.year());
                        return a.weekOfYear(t1, i.month(), i.day());
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        t1 = this._t2gYear(i.year());
                        return a.toJD(t1, i.month(), i.day());
                    },
                    fromJD: function(t1) {
                        var e1 = a.fromJD(t1), r = this._g2tYear(e1.year());
                        return this.newDate(r, e1.month(), e1.day());
                    },
                    _t2gYear: function(t1) {
                        return t1 + this.yearsOffset + (t1 >= -this.yearsOffset && t1 <= -1 ? 1 : 0);
                    },
                    _g2tYear: function(t1) {
                        return t1 - this.yearsOffset - (t1 >= 1 && t1 <= this.yearsOffset ? 1 : 0);
                    }
                }), n.calendars.taiwan = o;
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        344: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign"), a = n.instance();
                function o(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                o.prototype = new n.baseCalendar, i(o.prototype, {
                    name: "Thai",
                    jdEpoch: 1523098.5,
                    yearsOffset: 543,
                    daysPerMonth: [
                        31,
                        28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Thai",
                            epochs: [
                                "BBE",
                                "BE"
                            ],
                            monthNames: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            monthNamesShort: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "dd/mm/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        t1 = this._t2gYear(e1.year());
                        return a.leapYear(t1);
                    },
                    weekOfYear: function(t1, e1, r) {
                        var i = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        t1 = this._t2gYear(i.year());
                        return a.weekOfYear(t1, i.month(), i.day());
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate);
                        t1 = this._t2gYear(i.year());
                        return a.toJD(t1, i.month(), i.day());
                    },
                    fromJD: function(t1) {
                        var e1 = a.fromJD(t1), r = this._g2tYear(e1.year());
                        return this.newDate(r, e1.month(), e1.day());
                    },
                    _t2gYear: function(t1) {
                        return t1 - this.yearsOffset - (t1 >= 1 && t1 <= this.yearsOffset ? 1 : 0);
                    },
                    _g2tYear: function(t1) {
                        return t1 + this.yearsOffset + (t1 >= -this.yearsOffset && t1 <= -1 ? 1 : 0);
                    }
                }), n.calendars.thai = o;
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        345: [
            function(t1, e1, r) {
                var n = t1("../main"), i = t1("object-assign");
                function a(t1) {
                    this.local = this.regionalOptions[t1 || ""] || this.regionalOptions[""];
                }
                a.prototype = new n.baseCalendar, i(a.prototype, {
                    name: "UmmAlQura",
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Umm al-Qura",
                            epochs: [
                                "BH",
                                "AH"
                            ],
                            monthNames: [
                                "Al-Muharram",
                                "Safar",
                                "Rabi' al-awwal",
                                "Rabi' Al-Thani",
                                "Jumada Al-Awwal",
                                "Jumada Al-Thani",
                                "Rajab",
                                "Sha'aban",
                                "Ramadan",
                                "Shawwal",
                                "Dhu al-Qi'dah",
                                "Dhu al-Hijjah"
                            ],
                            monthNamesShort: [
                                "Muh",
                                "Saf",
                                "Rab1",
                                "Rab2",
                                "Jum1",
                                "Jum2",
                                "Raj",
                                "Sha'",
                                "Ram",
                                "Shaw",
                                "DhuQ",
                                "DhuH"
                            ],
                            dayNames: [
                                "Yawm al-Ahad",
                                "Yawm al-Ithnain",
                                "Yawm al-Thal\u0101th\u0101\u2019",
                                "Yawm al-Arba\u2018\u0101\u2019",
                                "Yawm al-Kham\u012bs",
                                "Yawm al-Jum\u2018a",
                                "Yawm al-Sabt"
                            ],
                            dayNamesMin: [
                                "Ah",
                                "Ith",
                                "Th",
                                "Ar",
                                "Kh",
                                "Ju",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "yyyy/mm/dd",
                            firstDay: 6,
                            isRTL: !0
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, n.local.invalidYear);
                        return 355 === this.daysInYear(e1.year());
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInYear: function(t1) {
                        for(var e1 = 0, r = 1; r <= 12; r++)e1 += this.daysInMonth(t1, r);
                        return e1;
                    },
                    daysInMonth: function(t1, e1) {
                        for(var r = this._validate(t1, e1, this.minDay, n.local.invalidMonth).toJD() - 24e5 + .5, i = 0, a = 0; a < o.length; a++){
                            if (o[a] > r) return o[i] - o[i - 1];
                            i++;
                        }
                        return 30;
                    },
                    weekDay: function(t1, e1, r) {
                        return 5 !== this.dayOfWeek(t1, e1, r);
                    },
                    toJD: function(t1, e1, r) {
                        var i = this._validate(t1, e1, r, n.local.invalidDate), a = 12 * (i.year() - 1) + i.month() - 15292;
                        return i.day() + o[a - 1] - 1 + 24e5 - .5;
                    },
                    fromJD: function(t1) {
                        for(var e1 = t1 - 24e5 + .5, r = 0, n = 0; n < o.length && !(o[n] > e1); n++)r++;
                        var i = r + 15292, a = Math.floor((i - 1) / 12), s = a + 1, l = i - 12 * a, c = e1 - o[r - 1] + 1;
                        return this.newDate(s, l, c);
                    },
                    isValid: function(t1, e1, r) {
                        var i = n.baseCalendar.prototype.isValid.apply(this, arguments);
                        return i && (i = (t1 = null != t1.year ? t1.year : t1) >= 1276 && t1 <= 1500), i;
                    },
                    _validate: function(t1, e1, r, i) {
                        var a = n.baseCalendar.prototype._validate.apply(this, arguments);
                        if (a.year < 1276 || a.year > 1500) throw i.replace(/\{0\}/, this.local.name);
                        return a;
                    }
                }), n.calendars.ummalqura = a;
                var o = [
                    20,
                    50,
                    79,
                    109,
                    138,
                    168,
                    197,
                    227,
                    256,
                    286,
                    315,
                    345,
                    374,
                    404,
                    433,
                    463,
                    492,
                    522,
                    551,
                    581,
                    611,
                    641,
                    670,
                    700,
                    729,
                    759,
                    788,
                    818,
                    847,
                    877,
                    906,
                    936,
                    965,
                    995,
                    1024,
                    1054,
                    1083,
                    1113,
                    1142,
                    1172,
                    1201,
                    1231,
                    1260,
                    1290,
                    1320,
                    1350,
                    1379,
                    1409,
                    1438,
                    1468,
                    1497,
                    1527,
                    1556,
                    1586,
                    1615,
                    1645,
                    1674,
                    1704,
                    1733,
                    1763,
                    1792,
                    1822,
                    1851,
                    1881,
                    1910,
                    1940,
                    1969,
                    1999,
                    2028,
                    2058,
                    2087,
                    2117,
                    2146,
                    2176,
                    2205,
                    2235,
                    2264,
                    2294,
                    2323,
                    2353,
                    2383,
                    2413,
                    2442,
                    2472,
                    2501,
                    2531,
                    2560,
                    2590,
                    2619,
                    2649,
                    2678,
                    2708,
                    2737,
                    2767,
                    2796,
                    2826,
                    2855,
                    2885,
                    2914,
                    2944,
                    2973,
                    3003,
                    3032,
                    3062,
                    3091,
                    3121,
                    3150,
                    3180,
                    3209,
                    3239,
                    3268,
                    3298,
                    3327,
                    3357,
                    3386,
                    3416,
                    3446,
                    3476,
                    3505,
                    3535,
                    3564,
                    3594,
                    3623,
                    3653,
                    3682,
                    3712,
                    3741,
                    3771,
                    3800,
                    3830,
                    3859,
                    3889,
                    3918,
                    3948,
                    3977,
                    4007,
                    4036,
                    4066,
                    4095,
                    4125,
                    4155,
                    4185,
                    4214,
                    4244,
                    4273,
                    4303,
                    4332,
                    4362,
                    4391,
                    4421,
                    4450,
                    4480,
                    4509,
                    4539,
                    4568,
                    4598,
                    4627,
                    4657,
                    4686,
                    4716,
                    4745,
                    4775,
                    4804,
                    4834,
                    4863,
                    4893,
                    4922,
                    4952,
                    4981,
                    5011,
                    5040,
                    5070,
                    5099,
                    5129,
                    5158,
                    5188,
                    5218,
                    5248,
                    5277,
                    5307,
                    5336,
                    5366,
                    5395,
                    5425,
                    5454,
                    5484,
                    5513,
                    5543,
                    5572,
                    5602,
                    5631,
                    5661,
                    5690,
                    5720,
                    5749,
                    5779,
                    5808,
                    5838,
                    5867,
                    5897,
                    5926,
                    5956,
                    5985,
                    6015,
                    6044,
                    6074,
                    6103,
                    6133,
                    6162,
                    6192,
                    6221,
                    6251,
                    6281,
                    6311,
                    6340,
                    6370,
                    6399,
                    6429,
                    6458,
                    6488,
                    6517,
                    6547,
                    6576,
                    6606,
                    6635,
                    6665,
                    6694,
                    6724,
                    6753,
                    6783,
                    6812,
                    6842,
                    6871,
                    6901,
                    6930,
                    6960,
                    6989,
                    7019,
                    7048,
                    7078,
                    7107,
                    7137,
                    7166,
                    7196,
                    7225,
                    7255,
                    7284,
                    7314,
                    7344,
                    7374,
                    7403,
                    7433,
                    7462,
                    7492,
                    7521,
                    7551,
                    7580,
                    7610,
                    7639,
                    7669,
                    7698,
                    7728,
                    7757,
                    7787,
                    7816,
                    7846,
                    7875,
                    7905,
                    7934,
                    7964,
                    7993,
                    8023,
                    8053,
                    8083,
                    8112,
                    8142,
                    8171,
                    8201,
                    8230,
                    8260,
                    8289,
                    8319,
                    8348,
                    8378,
                    8407,
                    8437,
                    8466,
                    8496,
                    8525,
                    8555,
                    8584,
                    8614,
                    8643,
                    8673,
                    8702,
                    8732,
                    8761,
                    8791,
                    8821,
                    8850,
                    8880,
                    8909,
                    8938,
                    8968,
                    8997,
                    9027,
                    9056,
                    9086,
                    9115,
                    9145,
                    9175,
                    9205,
                    9234,
                    9264,
                    9293,
                    9322,
                    9352,
                    9381,
                    9410,
                    9440,
                    9470,
                    9499,
                    9529,
                    9559,
                    9589,
                    9618,
                    9648,
                    9677,
                    9706,
                    9736,
                    9765,
                    9794,
                    9824,
                    9853,
                    9883,
                    9913,
                    9943,
                    9972,
                    10002,
                    10032,
                    10061,
                    10090,
                    10120,
                    10149,
                    10178,
                    10208,
                    10237,
                    10267,
                    10297,
                    10326,
                    10356,
                    10386,
                    10415,
                    10445,
                    10474,
                    10504,
                    10533,
                    10562,
                    10592,
                    10621,
                    10651,
                    10680,
                    10710,
                    10740,
                    10770,
                    10799,
                    10829,
                    10858,
                    10888,
                    10917,
                    10947,
                    10976,
                    11005,
                    11035,
                    11064,
                    11094,
                    11124,
                    11153,
                    11183,
                    11213,
                    11242,
                    11272,
                    11301,
                    11331,
                    11360,
                    11389,
                    11419,
                    11448,
                    11478,
                    11507,
                    11537,
                    11567,
                    11596,
                    11626,
                    11655,
                    11685,
                    11715,
                    11744,
                    11774,
                    11803,
                    11832,
                    11862,
                    11891,
                    11921,
                    11950,
                    11980,
                    12010,
                    12039,
                    12069,
                    12099,
                    12128,
                    12158,
                    12187,
                    12216,
                    12246,
                    12275,
                    12304,
                    12334,
                    12364,
                    12393,
                    12423,
                    12453,
                    12483,
                    12512,
                    12542,
                    12571,
                    12600,
                    12630,
                    12659,
                    12688,
                    12718,
                    12747,
                    12777,
                    12807,
                    12837,
                    12866,
                    12896,
                    12926,
                    12955,
                    12984,
                    13014,
                    13043,
                    13072,
                    13102,
                    13131,
                    13161,
                    13191,
                    13220,
                    13250,
                    13280,
                    13310,
                    13339,
                    13368,
                    13398,
                    13427,
                    13456,
                    13486,
                    13515,
                    13545,
                    13574,
                    13604,
                    13634,
                    13664,
                    13693,
                    13723,
                    13752,
                    13782,
                    13811,
                    13840,
                    13870,
                    13899,
                    13929,
                    13958,
                    13988,
                    14018,
                    14047,
                    14077,
                    14107,
                    14136,
                    14166,
                    14195,
                    14224,
                    14254,
                    14283,
                    14313,
                    14342,
                    14372,
                    14401,
                    14431,
                    14461,
                    14490,
                    14520,
                    14550,
                    14579,
                    14609,
                    14638,
                    14667,
                    14697,
                    14726,
                    14756,
                    14785,
                    14815,
                    14844,
                    14874,
                    14904,
                    14933,
                    14963,
                    14993,
                    15021,
                    15051,
                    15081,
                    15110,
                    15140,
                    15169,
                    15199,
                    15228,
                    15258,
                    15287,
                    15317,
                    15347,
                    15377,
                    15406,
                    15436,
                    15465,
                    15494,
                    15524,
                    15553,
                    15582,
                    15612,
                    15641,
                    15671,
                    15701,
                    15731,
                    15760,
                    15790,
                    15820,
                    15849,
                    15878,
                    15908,
                    15937,
                    15966,
                    15996,
                    16025,
                    16055,
                    16085,
                    16114,
                    16144,
                    16174,
                    16204,
                    16233,
                    16262,
                    16292,
                    16321,
                    16350,
                    16380,
                    16409,
                    16439,
                    16468,
                    16498,
                    16528,
                    16558,
                    16587,
                    16617,
                    16646,
                    16676,
                    16705,
                    16734,
                    16764,
                    16793,
                    16823,
                    16852,
                    16882,
                    16912,
                    16941,
                    16971,
                    17001,
                    17030,
                    17060,
                    17089,
                    17118,
                    17148,
                    17177,
                    17207,
                    17236,
                    17266,
                    17295,
                    17325,
                    17355,
                    17384,
                    17414,
                    17444,
                    17473,
                    17502,
                    17532,
                    17561,
                    17591,
                    17620,
                    17650,
                    17679,
                    17709,
                    17738,
                    17768,
                    17798,
                    17827,
                    17857,
                    17886,
                    17916,
                    17945,
                    17975,
                    18004,
                    18034,
                    18063,
                    18093,
                    18122,
                    18152,
                    18181,
                    18211,
                    18241,
                    18270,
                    18300,
                    18330,
                    18359,
                    18388,
                    18418,
                    18447,
                    18476,
                    18506,
                    18535,
                    18565,
                    18595,
                    18625,
                    18654,
                    18684,
                    18714,
                    18743,
                    18772,
                    18802,
                    18831,
                    18860,
                    18890,
                    18919,
                    18949,
                    18979,
                    19008,
                    19038,
                    19068,
                    19098,
                    19127,
                    19156,
                    19186,
                    19215,
                    19244,
                    19274,
                    19303,
                    19333,
                    19362,
                    19392,
                    19422,
                    19452,
                    19481,
                    19511,
                    19540,
                    19570,
                    19599,
                    19628,
                    19658,
                    19687,
                    19717,
                    19746,
                    19776,
                    19806,
                    19836,
                    19865,
                    19895,
                    19924,
                    19954,
                    19983,
                    20012,
                    20042,
                    20071,
                    20101,
                    20130,
                    20160,
                    20190,
                    20219,
                    20249,
                    20279,
                    20308,
                    20338,
                    20367,
                    20396,
                    20426,
                    20455,
                    20485,
                    20514,
                    20544,
                    20573,
                    20603,
                    20633,
                    20662,
                    20692,
                    20721,
                    20751,
                    20780,
                    20810,
                    20839,
                    20869,
                    20898,
                    20928,
                    20957,
                    20987,
                    21016,
                    21046,
                    21076,
                    21105,
                    21135,
                    21164,
                    21194,
                    21223,
                    21253,
                    21282,
                    21312,
                    21341,
                    21371,
                    21400,
                    21430,
                    21459,
                    21489,
                    21519,
                    21548,
                    21578,
                    21607,
                    21637,
                    21666,
                    21696,
                    21725,
                    21754,
                    21784,
                    21813,
                    21843,
                    21873,
                    21902,
                    21932,
                    21962,
                    21991,
                    22021,
                    22050,
                    22080,
                    22109,
                    22138,
                    22168,
                    22197,
                    22227,
                    22256,
                    22286,
                    22316,
                    22346,
                    22375,
                    22405,
                    22434,
                    22464,
                    22493,
                    22522,
                    22552,
                    22581,
                    22611,
                    22640,
                    22670,
                    22700,
                    22730,
                    22759,
                    22789,
                    22818,
                    22848,
                    22877,
                    22906,
                    22936,
                    22965,
                    22994,
                    23024,
                    23054,
                    23083,
                    23113,
                    23143,
                    23173,
                    23202,
                    23232,
                    23261,
                    23290,
                    23320,
                    23349,
                    23379,
                    23408,
                    23438,
                    23467,
                    23497,
                    23527,
                    23556,
                    23586,
                    23616,
                    23645,
                    23674,
                    23704,
                    23733,
                    23763,
                    23792,
                    23822,
                    23851,
                    23881,
                    23910,
                    23940,
                    23970,
                    23999,
                    24029,
                    24058,
                    24088,
                    24117,
                    24147,
                    24176,
                    24206,
                    24235,
                    24265,
                    24294,
                    24324,
                    24353,
                    24383,
                    24413,
                    24442,
                    24472,
                    24501,
                    24531,
                    24560,
                    24590,
                    24619,
                    24648,
                    24678,
                    24707,
                    24737,
                    24767,
                    24796,
                    24826,
                    24856,
                    24885,
                    24915,
                    24944,
                    24974,
                    25003,
                    25032,
                    25062,
                    25091,
                    25121,
                    25150,
                    25180,
                    25210,
                    25240,
                    25269,
                    25299,
                    25328,
                    25358,
                    25387,
                    25416,
                    25446,
                    25475,
                    25505,
                    25534,
                    25564,
                    25594,
                    25624,
                    25653,
                    25683,
                    25712,
                    25742,
                    25771,
                    25800,
                    25830,
                    25859,
                    25888,
                    25918,
                    25948,
                    25977,
                    26007,
                    26037,
                    26067,
                    26096,
                    26126,
                    26155,
                    26184,
                    26214,
                    26243,
                    26272,
                    26302,
                    26332,
                    26361,
                    26391,
                    26421,
                    26451,
                    26480,
                    26510,
                    26539,
                    26568,
                    26598,
                    26627,
                    26656,
                    26686,
                    26715,
                    26745,
                    26775,
                    26805,
                    26834,
                    26864,
                    26893,
                    26923,
                    26952,
                    26982,
                    27011,
                    27041,
                    27070,
                    27099,
                    27129,
                    27159,
                    27188,
                    27218,
                    27248,
                    27277,
                    27307,
                    27336,
                    27366,
                    27395,
                    27425,
                    27454,
                    27484,
                    27513,
                    27542,
                    27572,
                    27602,
                    27631,
                    27661,
                    27691,
                    27720,
                    27750,
                    27779,
                    27809,
                    27838,
                    27868,
                    27897,
                    27926,
                    27956,
                    27985,
                    28015,
                    28045,
                    28074,
                    28104,
                    28134,
                    28163,
                    28193,
                    28222,
                    28252,
                    28281,
                    28310,
                    28340,
                    28369,
                    28399,
                    28428,
                    28458,
                    28488,
                    28517,
                    28547,
                    28577,
                    28607,
                    28636,
                    28665,
                    28695,
                    28724,
                    28754,
                    28783,
                    28813,
                    28843,
                    28872,
                    28901,
                    28931,
                    28960,
                    28990,
                    29019,
                    29049,
                    29078,
                    29108,
                    29137,
                    29167,
                    29196,
                    29226,
                    29255,
                    29285,
                    29315,
                    29345,
                    29375,
                    29404,
                    29434,
                    29463,
                    29492,
                    29522,
                    29551,
                    29580,
                    29610,
                    29640,
                    29669,
                    29699,
                    29729,
                    29759,
                    29788,
                    29818,
                    29847,
                    29876,
                    29906,
                    29935,
                    29964,
                    29994,
                    30023,
                    30053,
                    30082,
                    30112,
                    30141,
                    30171,
                    30200,
                    30230,
                    30259,
                    30289,
                    30318,
                    30348,
                    30378,
                    30408,
                    30437,
                    30467,
                    30496,
                    30526,
                    30555,
                    30585,
                    30614,
                    30644,
                    30673,
                    30703,
                    30732,
                    30762,
                    30791,
                    30821,
                    30850,
                    30880,
                    30909,
                    30939,
                    30968,
                    30998,
                    31027,
                    31057,
                    31086,
                    31116,
                    31145,
                    31175,
                    31204,
                    31234,
                    31263,
                    31293,
                    31322,
                    31352,
                    31381,
                    31411,
                    31441,
                    31471,
                    31500,
                    31530,
                    31559,
                    31589,
                    31618,
                    31648,
                    31676,
                    31706,
                    31736,
                    31766,
                    31795,
                    31825,
                    31854,
                    31884,
                    31913,
                    31943,
                    31972,
                    32002,
                    32031,
                    32061,
                    32090,
                    32120,
                    32150,
                    32180,
                    32209,
                    32239,
                    32268,
                    32298,
                    32327,
                    32357,
                    32386,
                    32416,
                    32445,
                    32475,
                    32504,
                    32534,
                    32563,
                    32593,
                    32622,
                    32652,
                    32681,
                    32711,
                    32740,
                    32770,
                    32799,
                    32829,
                    32858,
                    32888,
                    32917,
                    32947,
                    32976,
                    33006,
                    33035,
                    33065,
                    33094,
                    33124,
                    33153,
                    33183,
                    33213,
                    33243,
                    33272,
                    33302,
                    33331,
                    33361,
                    33390,
                    33420,
                    33450,
                    33479,
                    33509,
                    33539,
                    33568,
                    33598,
                    33627,
                    33657,
                    33686,
                    33716,
                    33745,
                    33775,
                    33804,
                    33834,
                    33863,
                    33893,
                    33922,
                    33952,
                    33981,
                    34011,
                    34040,
                    34069,
                    34099,
                    34128,
                    34158,
                    34187,
                    34217,
                    34247,
                    34277,
                    34306,
                    34336,
                    34365,
                    34395,
                    34424,
                    34454,
                    34483,
                    34512,
                    34542,
                    34571,
                    34601,
                    34631,
                    34660,
                    34690,
                    34719,
                    34749,
                    34778,
                    34808,
                    34837,
                    34867,
                    34896,
                    34926,
                    34955,
                    34985,
                    35015,
                    35044,
                    35074,
                    35103,
                    35133,
                    35162,
                    35192,
                    35222,
                    35251,
                    35280,
                    35310,
                    35340,
                    35370,
                    35399,
                    35429,
                    35458,
                    35488,
                    35517,
                    35547,
                    35576,
                    35605,
                    35635,
                    35665,
                    35694,
                    35723,
                    35753,
                    35782,
                    35811,
                    35841,
                    35871,
                    35901,
                    35930,
                    35960,
                    35989,
                    36019,
                    36048,
                    36078,
                    36107,
                    36136,
                    36166,
                    36195,
                    36225,
                    36254,
                    36284,
                    36314,
                    36343,
                    36373,
                    36403,
                    36433,
                    36462,
                    36492,
                    36521,
                    36551,
                    36580,
                    36610,
                    36639,
                    36669,
                    36698,
                    36728,
                    36757,
                    36786,
                    36816,
                    36845,
                    36875,
                    36904,
                    36934,
                    36963,
                    36993,
                    37022,
                    37052,
                    37081,
                    37111,
                    37141,
                    37170,
                    37200,
                    37229,
                    37259,
                    37288,
                    37318,
                    37347,
                    37377,
                    37406,
                    37436,
                    37465,
                    37495,
                    37524,
                    37554,
                    37584,
                    37613,
                    37643,
                    37672,
                    37701,
                    37731,
                    37760,
                    37790,
                    37819,
                    37849,
                    37878,
                    37908,
                    37938,
                    37967,
                    37997,
                    38027,
                    38056,
                    38085,
                    38115,
                    38144,
                    38174,
                    38203,
                    38233,
                    38262,
                    38292,
                    38322,
                    38351,
                    38381,
                    38410,
                    38440,
                    38469,
                    38499,
                    38528,
                    38558,
                    38587,
                    38617,
                    38646,
                    38676,
                    38705,
                    38735,
                    38764,
                    38794,
                    38823,
                    38853,
                    38882,
                    38912,
                    38941,
                    38971,
                    39001,
                    39030,
                    39059,
                    39089,
                    39118,
                    39148,
                    39178,
                    39208,
                    39237,
                    39267,
                    39297,
                    39326,
                    39355,
                    39385,
                    39414,
                    39444,
                    39473,
                    39503,
                    39532,
                    39562,
                    39592,
                    39621,
                    39650,
                    39680,
                    39709,
                    39739,
                    39768,
                    39798,
                    39827,
                    39857,
                    39886,
                    39916,
                    39946,
                    39975,
                    40005,
                    40035,
                    40064,
                    40094,
                    40123,
                    40153,
                    40182,
                    40212,
                    40241,
                    40271,
                    40300,
                    40330,
                    40359,
                    40389,
                    40418,
                    40448,
                    40477,
                    40507,
                    40536,
                    40566,
                    40595,
                    40625,
                    40655,
                    40685,
                    40714,
                    40744,
                    40773,
                    40803,
                    40832,
                    40862,
                    40892,
                    40921,
                    40951,
                    40980,
                    41009,
                    41039,
                    41068,
                    41098,
                    41127,
                    41157,
                    41186,
                    41216,
                    41245,
                    41275,
                    41304,
                    41334,
                    41364,
                    41393,
                    41422,
                    41452,
                    41481,
                    41511,
                    41540,
                    41570,
                    41599,
                    41629,
                    41658,
                    41688,
                    41718,
                    41748,
                    41777,
                    41807,
                    41836,
                    41865,
                    41894,
                    41924,
                    41953,
                    41983,
                    42012,
                    42042,
                    42072,
                    42102,
                    42131,
                    42161,
                    42190,
                    42220,
                    42249,
                    42279,
                    42308,
                    42337,
                    42367,
                    42397,
                    42426,
                    42456,
                    42485,
                    42515,
                    42545,
                    42574,
                    42604,
                    42633,
                    42662,
                    42692,
                    42721,
                    42751,
                    42780,
                    42810,
                    42839,
                    42869,
                    42899,
                    42929,
                    42958,
                    42988,
                    43017,
                    43046,
                    43076,
                    43105,
                    43135,
                    43164,
                    43194,
                    43223,
                    43253,
                    43283,
                    43312,
                    43342,
                    43371,
                    43401,
                    43430,
                    43460,
                    43489,
                    43519,
                    43548,
                    43578,
                    43607,
                    43637,
                    43666,
                    43696,
                    43726,
                    43755,
                    43785,
                    43814,
                    43844,
                    43873,
                    43903,
                    43932,
                    43962,
                    43991,
                    44021,
                    44050,
                    44080,
                    44109,
                    44139,
                    44169,
                    44198,
                    44228,
                    44258,
                    44287,
                    44317,
                    44346,
                    44375,
                    44405,
                    44434,
                    44464,
                    44493,
                    44523,
                    44553,
                    44582,
                    44612,
                    44641,
                    44671,
                    44700,
                    44730,
                    44759,
                    44788,
                    44818,
                    44847,
                    44877,
                    44906,
                    44936,
                    44966,
                    44996,
                    45025,
                    45055,
                    45084,
                    45114,
                    45143,
                    45172,
                    45202,
                    45231,
                    45261,
                    45290,
                    45320,
                    45350,
                    45380,
                    45409,
                    45439,
                    45468,
                    45498,
                    45527,
                    45556,
                    45586,
                    45615,
                    45644,
                    45674,
                    45704,
                    45733,
                    45763,
                    45793,
                    45823,
                    45852,
                    45882,
                    45911,
                    45940,
                    45970,
                    45999,
                    46028,
                    46058,
                    46088,
                    46117,
                    46147,
                    46177,
                    46206,
                    46236,
                    46265,
                    46295,
                    46324,
                    46354,
                    46383,
                    46413,
                    46442,
                    46472,
                    46501,
                    46531,
                    46560,
                    46590,
                    46620,
                    46649,
                    46679,
                    46708,
                    46738,
                    46767,
                    46797,
                    46826,
                    46856,
                    46885,
                    46915,
                    46944,
                    46974,
                    47003,
                    47033,
                    47063,
                    47092,
                    47122,
                    47151,
                    47181,
                    47210,
                    47240,
                    47269,
                    47298,
                    47328,
                    47357,
                    47387,
                    47417,
                    47446,
                    47476,
                    47506,
                    47535,
                    47565,
                    47594,
                    47624,
                    47653,
                    47682,
                    47712,
                    47741,
                    47771,
                    47800,
                    47830,
                    47860,
                    47890,
                    47919,
                    47949,
                    47978,
                    48008,
                    48037,
                    48066,
                    48096,
                    48125,
                    48155,
                    48184,
                    48214,
                    48244,
                    48273,
                    48303,
                    48333,
                    48362,
                    48392,
                    48421,
                    48450,
                    48480,
                    48509,
                    48538,
                    48568,
                    48598,
                    48627,
                    48657,
                    48687,
                    48717,
                    48746,
                    48776,
                    48805,
                    48834,
                    48864,
                    48893,
                    48922,
                    48952,
                    48982,
                    49011,
                    49041,
                    49071,
                    49100,
                    49130,
                    49160,
                    49189,
                    49218,
                    49248,
                    49277,
                    49306,
                    49336,
                    49365,
                    49395,
                    49425,
                    49455,
                    49484,
                    49514,
                    49543,
                    49573,
                    49602,
                    49632,
                    49661,
                    49690,
                    49720,
                    49749,
                    49779,
                    49809,
                    49838,
                    49868,
                    49898,
                    49927,
                    49957,
                    49986,
                    50016,
                    50045,
                    50075,
                    50104,
                    50133,
                    50163,
                    50192,
                    50222,
                    50252,
                    50281,
                    50311,
                    50340,
                    50370,
                    50400,
                    50429,
                    50459,
                    50488,
                    50518,
                    50547,
                    50576,
                    50606,
                    50635,
                    50665,
                    50694,
                    50724,
                    50754,
                    50784,
                    50813,
                    50843,
                    50872,
                    50902,
                    50931,
                    50960,
                    50990,
                    51019,
                    51049,
                    51078,
                    51108,
                    51138,
                    51167,
                    51197,
                    51227,
                    51256,
                    51286,
                    51315,
                    51345,
                    51374,
                    51403,
                    51433,
                    51462,
                    51492,
                    51522,
                    51552,
                    51582,
                    51611,
                    51641,
                    51670,
                    51699,
                    51729,
                    51758,
                    51787,
                    51816,
                    51846,
                    51876,
                    51906,
                    51936,
                    51965,
                    51995,
                    52025,
                    52054,
                    52083,
                    52113,
                    52142,
                    52171,
                    52200,
                    52230,
                    52260,
                    52290,
                    52319,
                    52349,
                    52379,
                    52408,
                    52438,
                    52467,
                    52497,
                    52526,
                    52555,
                    52585,
                    52614,
                    52644,
                    52673,
                    52703,
                    52733,
                    52762,
                    52792,
                    52822,
                    52851,
                    52881,
                    52910,
                    52939,
                    52969,
                    52998,
                    53028,
                    53057,
                    53087,
                    53116,
                    53146,
                    53176,
                    53205,
                    53235,
                    53264,
                    53294,
                    53324,
                    53353,
                    53383,
                    53412,
                    53441,
                    53471,
                    53500,
                    53530,
                    53559,
                    53589,
                    53619,
                    53648,
                    53678,
                    53708,
                    53737,
                    53767,
                    53796,
                    53825,
                    53855,
                    53884,
                    53913,
                    53943,
                    53973,
                    54003,
                    54032,
                    54062,
                    54092,
                    54121,
                    54151,
                    54180,
                    54209,
                    54239,
                    54268,
                    54297,
                    54327,
                    54357,
                    54387,
                    54416,
                    54446,
                    54476,
                    54505,
                    54535,
                    54564,
                    54593,
                    54623,
                    54652,
                    54681,
                    54711,
                    54741,
                    54770,
                    54800,
                    54830,
                    54859,
                    54889,
                    54919,
                    54948,
                    54977,
                    55007,
                    55036,
                    55066,
                    55095,
                    55125,
                    55154,
                    55184,
                    55213,
                    55243,
                    55273,
                    55302,
                    55332,
                    55361,
                    55391,
                    55420,
                    55450,
                    55479,
                    55508,
                    55538,
                    55567,
                    55597,
                    55627,
                    55657,
                    55686,
                    55716,
                    55745,
                    55775,
                    55804,
                    55834,
                    55863,
                    55892,
                    55922,
                    55951,
                    55981,
                    56011,
                    56040,
                    56070,
                    56100,
                    56129,
                    56159,
                    56188,
                    56218,
                    56247,
                    56276,
                    56306,
                    56335,
                    56365,
                    56394,
                    56424,
                    56454,
                    56483,
                    56513,
                    56543,
                    56572,
                    56601,
                    56631,
                    56660,
                    56690,
                    56719,
                    56749,
                    56778,
                    56808,
                    56837,
                    56867,
                    56897,
                    56926,
                    56956,
                    56985,
                    57015,
                    57044,
                    57074,
                    57103,
                    57133,
                    57162,
                    57192,
                    57221,
                    57251,
                    57280,
                    57310,
                    57340,
                    57369,
                    57399,
                    57429,
                    57458,
                    57487,
                    57517,
                    57546,
                    57576,
                    57605,
                    57634,
                    57664,
                    57694,
                    57723,
                    57753,
                    57783,
                    57813,
                    57842,
                    57871,
                    57901,
                    57930,
                    57959,
                    57989,
                    58018,
                    58048,
                    58077,
                    58107,
                    58137,
                    58167,
                    58196,
                    58226,
                    58255,
                    58285,
                    58314,
                    58343,
                    58373,
                    58402,
                    58432,
                    58461,
                    58491,
                    58521,
                    58551,
                    58580,
                    58610,
                    58639,
                    58669,
                    58698,
                    58727,
                    58757,
                    58786,
                    58816,
                    58845,
                    58875,
                    58905,
                    58934,
                    58964,
                    58994,
                    59023,
                    59053,
                    59082,
                    59111,
                    59141,
                    59170,
                    59200,
                    59229,
                    59259,
                    59288,
                    59318,
                    59348,
                    59377,
                    59407,
                    59436,
                    59466,
                    59495,
                    59525,
                    59554,
                    59584,
                    59613,
                    59643,
                    59672,
                    59702,
                    59731,
                    59761,
                    59791,
                    59820,
                    59850,
                    59879,
                    59909,
                    59939,
                    59968,
                    59997,
                    60027,
                    60056,
                    60086,
                    60115,
                    60145,
                    60174,
                    60204,
                    60234,
                    60264,
                    60293,
                    60323,
                    60352,
                    60381,
                    60411,
                    60440,
                    60469,
                    60499,
                    60528,
                    60558,
                    60588,
                    60618,
                    60648,
                    60677,
                    60707,
                    60736,
                    60765,
                    60795,
                    60824,
                    60853,
                    60883,
                    60912,
                    60942,
                    60972,
                    61002,
                    61031,
                    61061,
                    61090,
                    61120,
                    61149,
                    61179,
                    61208,
                    61237,
                    61267,
                    61296,
                    61326,
                    61356,
                    61385,
                    61415,
                    61445,
                    61474,
                    61504,
                    61533,
                    61563,
                    61592,
                    61621,
                    61651,
                    61680,
                    61710,
                    61739,
                    61769,
                    61799,
                    61828,
                    61858,
                    61888,
                    61917,
                    61947,
                    61976,
                    62006,
                    62035,
                    62064,
                    62094,
                    62123,
                    62153,
                    62182,
                    62212,
                    62242,
                    62271,
                    62301,
                    62331,
                    62360,
                    62390,
                    62419,
                    62448,
                    62478,
                    62507,
                    62537,
                    62566,
                    62596,
                    62625,
                    62655,
                    62685,
                    62715,
                    62744,
                    62774,
                    62803,
                    62832,
                    62862,
                    62891,
                    62921,
                    62950,
                    62980,
                    63009,
                    63039,
                    63069,
                    63099,
                    63128,
                    63157,
                    63187,
                    63216,
                    63246,
                    63275,
                    63305,
                    63334,
                    63363,
                    63393,
                    63423,
                    63453,
                    63482,
                    63512,
                    63541,
                    63571,
                    63600,
                    63630,
                    63659,
                    63689,
                    63718,
                    63747,
                    63777,
                    63807,
                    63836,
                    63866,
                    63895,
                    63925,
                    63955,
                    63984,
                    64014,
                    64043,
                    64073,
                    64102,
                    64131,
                    64161,
                    64190,
                    64220,
                    64249,
                    64279,
                    64309,
                    64339,
                    64368,
                    64398,
                    64427,
                    64457,
                    64486,
                    64515,
                    64545,
                    64574,
                    64603,
                    64633,
                    64663,
                    64692,
                    64722,
                    64752,
                    64782,
                    64811,
                    64841,
                    64870,
                    64899,
                    64929,
                    64958,
                    64987,
                    65017,
                    65047,
                    65076,
                    65106,
                    65136,
                    65166,
                    65195,
                    65225,
                    65254,
                    65283,
                    65313,
                    65342,
                    65371,
                    65401,
                    65431,
                    65460,
                    65490,
                    65520,
                    65549,
                    65579,
                    65608,
                    65638,
                    65667,
                    65697,
                    65726,
                    65755,
                    65785,
                    65815,
                    65844,
                    65874,
                    65903,
                    65933,
                    65963,
                    65992,
                    66022,
                    66051,
                    66081,
                    66110,
                    66140,
                    66169,
                    66199,
                    66228,
                    66258,
                    66287,
                    66317,
                    66346,
                    66376,
                    66405,
                    66435,
                    66465,
                    66494,
                    66524,
                    66553,
                    66583,
                    66612,
                    66641,
                    66671,
                    66700,
                    66730,
                    66760,
                    66789,
                    66819,
                    66849,
                    66878,
                    66908,
                    66937,
                    66967,
                    66996,
                    67025,
                    67055,
                    67084,
                    67114,
                    67143,
                    67173,
                    67203,
                    67233,
                    67262,
                    67292,
                    67321,
                    67351,
                    67380,
                    67409,
                    67439,
                    67468,
                    67497,
                    67527,
                    67557,
                    67587,
                    67617,
                    67646,
                    67676,
                    67705,
                    67735,
                    67764,
                    67793,
                    67823,
                    67852,
                    67882,
                    67911,
                    67941,
                    67971,
                    68e3,
                    68030,
                    68060,
                    68089,
                    68119,
                    68148,
                    68177,
                    68207,
                    68236,
                    68266,
                    68295,
                    68325,
                    68354,
                    68384,
                    68414,
                    68443,
                    68473,
                    68502,
                    68532,
                    68561,
                    68591,
                    68620,
                    68650,
                    68679,
                    68708,
                    68738,
                    68768,
                    68797,
                    68827,
                    68857,
                    68886,
                    68916,
                    68946,
                    68975,
                    69004,
                    69034,
                    69063,
                    69092,
                    69122,
                    69152,
                    69181,
                    69211,
                    69240,
                    69270,
                    69300,
                    69330,
                    69359,
                    69388,
                    69418,
                    69447,
                    69476,
                    69506,
                    69535,
                    69565,
                    69595,
                    69624,
                    69654,
                    69684,
                    69713,
                    69743,
                    69772,
                    69802,
                    69831,
                    69861,
                    69890,
                    69919,
                    69949,
                    69978,
                    70008,
                    70038,
                    70067,
                    70097,
                    70126,
                    70156,
                    70186,
                    70215,
                    70245,
                    70274,
                    70303,
                    70333,
                    70362,
                    70392,
                    70421,
                    70451,
                    70481,
                    70510,
                    70540,
                    70570,
                    70599,
                    70629,
                    70658,
                    70687,
                    70717,
                    70746,
                    70776,
                    70805,
                    70835,
                    70864,
                    70894,
                    70924,
                    70954,
                    70983,
                    71013,
                    71042,
                    71071,
                    71101,
                    71130,
                    71159,
                    71189,
                    71218,
                    71248,
                    71278,
                    71308,
                    71337,
                    71367,
                    71397,
                    71426,
                    71455,
                    71485,
                    71514,
                    71543,
                    71573,
                    71602,
                    71632,
                    71662,
                    71691,
                    71721,
                    71751,
                    71781,
                    71810,
                    71839,
                    71869,
                    71898,
                    71927,
                    71957,
                    71986,
                    72016,
                    72046,
                    72075,
                    72105,
                    72135,
                    72164,
                    72194,
                    72223,
                    72253,
                    72282,
                    72311,
                    72341,
                    72370,
                    72400,
                    72429,
                    72459,
                    72489,
                    72518,
                    72548,
                    72577,
                    72607,
                    72637,
                    72666,
                    72695,
                    72725,
                    72754,
                    72784,
                    72813,
                    72843,
                    72872,
                    72902,
                    72931,
                    72961,
                    72991,
                    73020,
                    73050,
                    73080,
                    73109,
                    73139,
                    73168,
                    73197,
                    73227,
                    73256,
                    73286,
                    73315,
                    73345,
                    73375,
                    73404,
                    73434,
                    73464,
                    73493,
                    73523,
                    73552,
                    73581,
                    73611,
                    73640,
                    73669,
                    73699,
                    73729,
                    73758,
                    73788,
                    73818,
                    73848,
                    73877,
                    73907,
                    73936,
                    73965,
                    73995,
                    74024,
                    74053,
                    74083,
                    74113,
                    74142,
                    74172,
                    74202,
                    74231,
                    74261,
                    74291,
                    74320,
                    74349,
                    74379,
                    74408,
                    74437,
                    74467,
                    74497,
                    74526,
                    74556,
                    74586,
                    74615,
                    74645,
                    74675,
                    74704,
                    74733,
                    74763,
                    74792,
                    74822,
                    74851,
                    74881,
                    74910,
                    74940,
                    74969,
                    74999,
                    75029,
                    75058,
                    75088,
                    75117,
                    75147,
                    75176,
                    75206,
                    75235,
                    75264,
                    75294,
                    75323,
                    75353,
                    75383,
                    75412,
                    75442,
                    75472,
                    75501,
                    75531,
                    75560,
                    75590,
                    75619,
                    75648,
                    75678,
                    75707,
                    75737,
                    75766,
                    75796,
                    75826,
                    75856,
                    75885,
                    75915,
                    75944,
                    75974,
                    76003,
                    76032,
                    76062,
                    76091,
                    76121,
                    76150,
                    76180,
                    76210,
                    76239,
                    76269,
                    76299,
                    76328,
                    76358,
                    76387,
                    76416,
                    76446,
                    76475,
                    76505,
                    76534,
                    76564,
                    76593,
                    76623,
                    76653,
                    76682,
                    76712,
                    76741,
                    76771,
                    76801,
                    76830,
                    76859,
                    76889,
                    76918,
                    76948,
                    76977,
                    77007,
                    77036,
                    77066,
                    77096,
                    77125,
                    77155,
                    77185,
                    77214,
                    77243,
                    77273,
                    77302,
                    77332,
                    77361,
                    77390,
                    77420,
                    77450,
                    77479,
                    77509,
                    77539,
                    77569,
                    77598,
                    77627,
                    77657,
                    77686,
                    77715,
                    77745,
                    77774,
                    77804,
                    77833,
                    77863,
                    77893,
                    77923,
                    77952,
                    77982,
                    78011,
                    78041,
                    78070,
                    78099,
                    78129,
                    78158,
                    78188,
                    78217,
                    78247,
                    78277,
                    78307,
                    78336,
                    78366,
                    78395,
                    78425,
                    78454,
                    78483,
                    78513,
                    78542,
                    78572,
                    78601,
                    78631,
                    78661,
                    78690,
                    78720,
                    78750,
                    78779,
                    78808,
                    78838,
                    78867,
                    78897,
                    78926,
                    78956,
                    78985,
                    79015,
                    79044,
                    79074,
                    79104,
                    79133,
                    79163,
                    79192,
                    79222,
                    79251,
                    79281,
                    79310,
                    79340,
                    79369,
                    79399,
                    79428,
                    79458,
                    79487,
                    79517,
                    79546,
                    79576,
                    79606,
                    79635,
                    79665,
                    79695,
                    79724,
                    79753,
                    79783,
                    79812,
                    79841,
                    79871,
                    79900,
                    79930,
                    79960,
                    79990
                ];
            },
            {
                "../main": 346,
                "object-assign": 247
            }
        ],
        346: [
            function(t1, e1, r) {
                var n = t1("object-assign");
                function i() {
                    this.regionalOptions = [], this.regionalOptions[""] = {
                        invalidCalendar: "Calendar {0} not found",
                        invalidDate: "Invalid {0} date",
                        invalidMonth: "Invalid {0} month",
                        invalidYear: "Invalid {0} year",
                        differentCalendars: "Cannot mix {0} and {1} dates"
                    }, this.local = this.regionalOptions[""], this.calendars = {}, this._localCals = {};
                }
                function a(t1, e1, r, n) {
                    if (this._calendar = t1, this._year = e1, this._month = r, this._day = n, 0 === this._calendar._validateLevel && !this._calendar.isValid(this._year, this._month, this._day)) throw (c.local.invalidDate || c.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
                }
                function o(t1, e1) {
                    return "000000".substring(0, e1 - (t1 = "" + t1).length) + t1;
                }
                function s() {
                    this.shortYearCutoff = "+10";
                }
                function l(t1) {
                    this.local = this.regionalOptions[t1] || this.regionalOptions[""];
                }
                n(i.prototype, {
                    instance: function(t1, e1) {
                        t1 = (t1 || "gregorian").toLowerCase(), e1 = e1 || "";
                        var r = this._localCals[t1 + "-" + e1];
                        if (!r && this.calendars[t1] && (r = new this.calendars[t1](e1), this._localCals[t1 + "-" + e1] = r), !r) throw (this.local.invalidCalendar || this.regionalOptions[""].invalidCalendar).replace(/\{0\}/, t1);
                        return r;
                    },
                    newDate: function(t1, e1, r, n, i) {
                        return (n = (null != t1 && t1.year ? t1.calendar() : "string" == typeof n ? this.instance(n, i) : n) || this.instance()).newDate(t1, e1, r);
                    },
                    substituteDigits: function(t1) {
                        return function(e1) {
                            return (e1 + "").replace(/[0-9]/g, function(e1) {
                                return t1[e1];
                            });
                        };
                    },
                    substituteChineseDigits: function(t1, e1) {
                        return function(r) {
                            for(var n = "", i = 0; r > 0;){
                                var a = r % 10;
                                n = (0 === a ? "" : t1[a] + e1[i]) + n, i++, r = Math.floor(r / 10);
                            }
                            return 0 === n.indexOf(t1[1] + e1[1]) && (n = n.substr(1)), n || t1[0];
                        };
                    }
                }), n(a.prototype, {
                    newDate: function(t1, e1, r) {
                        return this._calendar.newDate(null == t1 ? this : t1, e1, r);
                    },
                    year: function(t1) {
                        return 0 === arguments.length ? this._year : this.set(t1, "y");
                    },
                    month: function(t1) {
                        return 0 === arguments.length ? this._month : this.set(t1, "m");
                    },
                    day: function(t1) {
                        return 0 === arguments.length ? this._day : this.set(t1, "d");
                    },
                    date: function(t1, e1, r) {
                        if (!this._calendar.isValid(t1, e1, r)) throw (c.local.invalidDate || c.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
                        return this._year = t1, this._month = e1, this._day = r, this;
                    },
                    leapYear: function() {
                        return this._calendar.leapYear(this);
                    },
                    epoch: function() {
                        return this._calendar.epoch(this);
                    },
                    formatYear: function() {
                        return this._calendar.formatYear(this);
                    },
                    monthOfYear: function() {
                        return this._calendar.monthOfYear(this);
                    },
                    weekOfYear: function() {
                        return this._calendar.weekOfYear(this);
                    },
                    daysInYear: function() {
                        return this._calendar.daysInYear(this);
                    },
                    dayOfYear: function() {
                        return this._calendar.dayOfYear(this);
                    },
                    daysInMonth: function() {
                        return this._calendar.daysInMonth(this);
                    },
                    dayOfWeek: function() {
                        return this._calendar.dayOfWeek(this);
                    },
                    weekDay: function() {
                        return this._calendar.weekDay(this);
                    },
                    extraInfo: function() {
                        return this._calendar.extraInfo(this);
                    },
                    add: function(t1, e1) {
                        return this._calendar.add(this, t1, e1);
                    },
                    set: function(t1, e1) {
                        return this._calendar.set(this, t1, e1);
                    },
                    compareTo: function(t1) {
                        if (this._calendar.name !== t1._calendar.name) throw (c.local.differentCalendars || c.regionalOptions[""].differentCalendars).replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, t1._calendar.local.name);
                        var e1 = this._year !== t1._year ? this._year - t1._year : this._month !== t1._month ? this.monthOfYear() - t1.monthOfYear() : this._day - t1._day;
                        return 0 === e1 ? 0 : e1 < 0 ? -1 : 1;
                    },
                    calendar: function() {
                        return this._calendar;
                    },
                    toJD: function() {
                        return this._calendar.toJD(this);
                    },
                    fromJD: function(t1) {
                        return this._calendar.fromJD(t1);
                    },
                    toJSDate: function() {
                        return this._calendar.toJSDate(this);
                    },
                    fromJSDate: function(t1) {
                        return this._calendar.fromJSDate(t1);
                    },
                    toString: function() {
                        return (this.year() < 0 ? "-" : "") + o(Math.abs(this.year()), 4) + "-" + o(this.month(), 2) + "-" + o(this.day(), 2);
                    }
                }), n(s.prototype, {
                    _validateLevel: 0,
                    newDate: function(t1, e1, r) {
                        return null == t1 ? this.today() : (t1.year && (this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), r = t1.day(), e1 = t1.month(), t1 = t1.year()), new a(this, t1, e1, r));
                    },
                    today: function() {
                        return this.fromJSDate(new Date);
                    },
                    epoch: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear).year() < 0 ? this.local.epochs[0] : this.local.epochs[1];
                    },
                    formatYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
                        return (e1.year() < 0 ? "-" : "") + o(Math.abs(e1.year()), 4);
                    },
                    monthsInYear: function(t1) {
                        return this._validate(t1, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear), 12;
                    },
                    monthOfYear: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth);
                        return (r.month() + this.monthsInYear(r) - this.firstMonth) % this.monthsInYear(r) + this.minMonth;
                    },
                    fromMonthOfYear: function(t1, e1) {
                        var r = (e1 + this.firstMonth - 2 * this.minMonth) % this.monthsInYear(t1) + this.minMonth;
                        return this._validate(t1, r, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth), r;
                    },
                    daysInYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
                        return this.leapYear(e1) ? 366 : 365;
                    },
                    dayOfYear: function(t1, e1, r) {
                        var n = this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        return n.toJD() - this.newDate(n.year(), this.fromMonthOfYear(n.year(), this.minMonth), this.minDay).toJD() + 1;
                    },
                    daysInWeek: function() {
                        return 7;
                    },
                    dayOfWeek: function(t1, e1, r) {
                        var n = this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        return (Math.floor(this.toJD(n)) + 2) % this.daysInWeek();
                    },
                    extraInfo: function(t1, e1, r) {
                        return this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), {};
                    },
                    add: function(t1, e1, r) {
                        return this._validate(t1, this.minMonth, this.minDay, c.local.invalidDate || c.regionalOptions[""].invalidDate), this._correctAdd(t1, this._add(t1, e1, r), e1, r);
                    },
                    _add: function(t1, e1, r) {
                        if (this._validateLevel++, "d" === r || "w" === r) {
                            var n = t1.toJD() + e1 * ("w" === r ? this.daysInWeek() : 1), i = t1.calendar().fromJD(n);
                            return this._validateLevel--, [
                                i.year(),
                                i.month(),
                                i.day()
                            ];
                        }
                        try {
                            var a = t1.year() + ("y" === r ? e1 : 0), o = t1.monthOfYear() + ("m" === r ? e1 : 0);
                            i = t1.day();
                            "y" === r ? (t1.month() !== this.fromMonthOfYear(a, o) && (o = this.newDate(a, t1.month(), this.minDay).monthOfYear()), o = Math.min(o, this.monthsInYear(a)), i = Math.min(i, this.daysInMonth(a, this.fromMonthOfYear(a, o)))) : "m" === r && (!function(t1) {
                                for(; o < t1.minMonth;)a--, o += t1.monthsInYear(a);
                                for(var e1 = t1.monthsInYear(a); o > e1 - 1 + t1.minMonth;)a++, o -= e1, e1 = t1.monthsInYear(a);
                            }(this), i = Math.min(i, this.daysInMonth(a, this.fromMonthOfYear(a, o))));
                            var s = [
                                a,
                                this.fromMonthOfYear(a, o),
                                i
                            ];
                            return this._validateLevel--, s;
                        } catch (t1) {
                            throw this._validateLevel--, t1;
                        }
                    },
                    _correctAdd: function(t1, e1, r, n) {
                        if (!(this.hasYearZero || "y" !== n && "m" !== n || 0 !== e1[0] && t1.year() > 0 == e1[0] > 0)) {
                            var i = {
                                y: [
                                    1,
                                    1,
                                    "y"
                                ],
                                m: [
                                    1,
                                    this.monthsInYear(-1),
                                    "m"
                                ],
                                w: [
                                    this.daysInWeek(),
                                    this.daysInYear(-1),
                                    "d"
                                ],
                                d: [
                                    1,
                                    this.daysInYear(-1),
                                    "d"
                                ]
                            }[n], a = r < 0 ? -1 : 1;
                            e1 = this._add(t1, r * i[0] + a * i[1], i[2]);
                        }
                        return t1.date(e1[0], e1[1], e1[2]);
                    },
                    set: function(t1, e1, r) {
                        this._validate(t1, this.minMonth, this.minDay, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        var n = "y" === r ? e1 : t1.year(), i = "m" === r ? e1 : t1.month(), a = "d" === r ? e1 : t1.day();
                        return "y" !== r && "m" !== r || (a = Math.min(a, this.daysInMonth(n, i))), t1.date(n, i, a);
                    },
                    isValid: function(t1, e1, r) {
                        this._validateLevel++;
                        var n = this.hasYearZero || 0 !== t1;
                        if (n) {
                            var i = this.newDate(t1, e1, this.minDay);
                            n = e1 >= this.minMonth && e1 - this.minMonth < this.monthsInYear(i) && r >= this.minDay && r - this.minDay < this.daysInMonth(i);
                        }
                        return this._validateLevel--, n;
                    },
                    toJSDate: function(t1, e1, r) {
                        var n = this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        return c.instance().fromJD(this.toJD(n)).toJSDate();
                    },
                    fromJSDate: function(t1) {
                        return this.fromJD(c.instance().fromJSDate(t1).toJD());
                    },
                    _validate: function(t1, e1, r, n) {
                        if (t1.year) {
                            if (0 === this._validateLevel && this.name !== t1.calendar().name) throw (c.local.differentCalendars || c.regionalOptions[""].differentCalendars).replace(/\{0\}/, this.local.name).replace(/\{1\}/, t1.calendar().local.name);
                            return t1;
                        }
                        try {
                            if (this._validateLevel++, 1 === this._validateLevel && !this.isValid(t1, e1, r)) throw n.replace(/\{0\}/, this.local.name);
                            var i = this.newDate(t1, e1, r);
                            return this._validateLevel--, i;
                        } catch (t1) {
                            throw this._validateLevel--, t1;
                        }
                    }
                }), l.prototype = new s, n(l.prototype, {
                    name: "Gregorian",
                    jdEpoch: 1721425.5,
                    daysPerMonth: [
                        31,
                        28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ],
                    hasYearZero: !1,
                    minMonth: 1,
                    firstMonth: 1,
                    minDay: 1,
                    regionalOptions: {
                        "": {
                            name: "Gregorian",
                            epochs: [
                                "BCE",
                                "CE"
                            ],
                            monthNames: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            monthNamesShort: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            dayNames: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ],
                            dayNamesShort: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            dayNamesMin: [
                                "Su",
                                "Mo",
                                "Tu",
                                "We",
                                "Th",
                                "Fr",
                                "Sa"
                            ],
                            digits: null,
                            dateFormat: "mm/dd/yyyy",
                            firstDay: 0,
                            isRTL: !1
                        }
                    },
                    leapYear: function(t1) {
                        var e1 = this._validate(t1, this.minMonth, this.minDay, c.local.invalidYear || c.regionalOptions[""].invalidYear);
                        return (t1 = e1.year() + (e1.year() < 0 ? 1 : 0)) % 4 == 0 && (t1 % 100 != 0 || t1 % 400 == 0);
                    },
                    weekOfYear: function(t1, e1, r) {
                        var n = this.newDate(t1, e1, r);
                        return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                    },
                    daysInMonth: function(t1, e1) {
                        var r = this._validate(t1, e1, this.minDay, c.local.invalidMonth || c.regionalOptions[""].invalidMonth);
                        return this.daysPerMonth[r.month() - 1] + (2 === r.month() && this.leapYear(r.year()) ? 1 : 0);
                    },
                    weekDay: function(t1, e1, r) {
                        return (this.dayOfWeek(t1, e1, r) || 7) < 6;
                    },
                    toJD: function(t1, e1, r) {
                        var n = this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate);
                        t1 = n.year(), e1 = n.month(), r = n.day(), t1 < 0 && t1++, e1 < 3 && (e1 += 12, t1--);
                        var i = Math.floor(t1 / 100), a = 2 - i + Math.floor(i / 4);
                        return Math.floor(365.25 * (t1 + 4716)) + Math.floor(30.6001 * (e1 + 1)) + r + a - 1524.5;
                    },
                    fromJD: function(t1) {
                        var e1 = Math.floor(t1 + .5), r = Math.floor((e1 - 1867216.25) / 36524.25), n = (r = e1 + 1 + r - Math.floor(r / 4)) + 1524, i = Math.floor((n - 122.1) / 365.25), a = Math.floor(365.25 * i), o = Math.floor((n - a) / 30.6001), s = n - a - Math.floor(30.6001 * o), l = o - (o > 13.5 ? 13 : 1), c = i - (l > 2.5 ? 4716 : 4715);
                        return c <= 0 && c--, this.newDate(c, l, s);
                    },
                    toJSDate: function(t1, e1, r) {
                        var n = this._validate(t1, e1, r, c.local.invalidDate || c.regionalOptions[""].invalidDate), i = new Date(n.year(), n.month() - 1, n.day());
                        return i.setHours(0), i.setMinutes(0), i.setSeconds(0), i.setMilliseconds(0), i.setHours(i.getHours() > 12 ? i.getHours() + 2 : 0), i;
                    },
                    fromJSDate: function(t1) {
                        return this.newDate(t1.getFullYear(), t1.getMonth() + 1, t1.getDate());
                    }
                });
                var c = e1.exports = new i;
                c.cdate = a, c.baseCalendar = s, c.calendars.gregorian = l;
            },
            {
                "object-assign": 247
            }
        ],
        347: [
            function(t1, e1, r) {
                var n = t1("object-assign"), i = t1("./main");
                n(i.regionalOptions[""], {
                    invalidArguments: "Invalid arguments",
                    invalidFormat: "Cannot format a date from another calendar",
                    missingNumberAt: "Missing number at position {0}",
                    unknownNameAt: "Unknown name at position {0}",
                    unexpectedLiteralAt: "Unexpected literal at position {0}",
                    unexpectedText: "Additional text found at end"
                }), i.local = i.regionalOptions[""], n(i.cdate.prototype, {
                    formatDate: function(t1, e1) {
                        return "string" != typeof t1 && (e1 = t1, t1 = ""), this._calendar.formatDate(t1 || "", this, e1);
                    }
                }), n(i.baseCalendar.prototype, {
                    UNIX_EPOCH: i.instance().newDate(1970, 1, 1).toJD(),
                    SECS_PER_DAY: 86400,
                    TICKS_EPOCH: i.instance().jdEpoch,
                    TICKS_PER_DAY: 864e9,
                    ATOM: "yyyy-mm-dd",
                    COOKIE: "D, dd M yyyy",
                    FULL: "DD, MM d, yyyy",
                    ISO_8601: "yyyy-mm-dd",
                    JULIAN: "J",
                    RFC_822: "D, d M yy",
                    RFC_850: "DD, dd-M-yy",
                    RFC_1036: "D, d M yy",
                    RFC_1123: "D, d M yyyy",
                    RFC_2822: "D, d M yyyy",
                    RSS: "D, d M yy",
                    TICKS: "!",
                    TIMESTAMP: "@",
                    W3C: "yyyy-mm-dd",
                    formatDate: function(t1, e1, r) {
                        if ("string" != typeof t1 && (r = e1, e1 = t1, t1 = ""), !e1) return "";
                        if (e1.calendar() !== this) throw i.local.invalidFormat || i.regionalOptions[""].invalidFormat;
                        t1 = t1 || this.local.dateFormat;
                        for(var n, a, o, s, l = (r = r || {}).dayNamesShort || this.local.dayNamesShort, c = r.dayNames || this.local.dayNames, u = r.monthNumbers || this.local.monthNumbers, f = r.monthNamesShort || this.local.monthNamesShort, h = r.monthNames || this.local.monthNames, p = (r.calculateWeek || this.local.calculateWeek, function(e1, r) {
                            for(var n = 1; w + n < t1.length && t1.charAt(w + n) === e1;)n++;
                            return w += n - 1, Math.floor(n / (r || 1)) > 1;
                        }), d = function(t1, e1, r, n) {
                            var i = "" + e1;
                            if (p(t1, n)) for(; i.length < r;)i = "0" + i;
                            return i;
                        }, m = this, g = function(t1) {
                            return "function" == typeof u ? u.call(m, t1, p("m")) : x(d("m", t1.month(), 2));
                        }, v = function(t1, e1) {
                            return e1 ? "function" == typeof h ? h.call(m, t1) : h[t1.month() - m.minMonth] : "function" == typeof f ? f.call(m, t1) : f[t1.month() - m.minMonth];
                        }, y = this.local.digits, x = function(t1) {
                            return r.localNumbers && y ? y(t1) : t1;
                        }, b = "", _ = !1, w = 0; w < t1.length; w++)if (_) "'" !== t1.charAt(w) || p("'") ? b += t1.charAt(w) : _ = !1;
                        else switch(t1.charAt(w)){
                            case "d":
                                b += x(d("d", e1.day(), 2));
                                break;
                            case "D":
                                b += (n = "D", a = e1.dayOfWeek(), o = l, s = c, p(n) ? s[a] : o[a]);
                                break;
                            case "o":
                                b += d("o", e1.dayOfYear(), 3);
                                break;
                            case "w":
                                b += d("w", e1.weekOfYear(), 2);
                                break;
                            case "m":
                                b += g(e1);
                                break;
                            case "M":
                                b += v(e1, p("M"));
                                break;
                            case "y":
                                b += p("y", 2) ? e1.year() : (e1.year() % 100 < 10 ? "0" : "") + e1.year() % 100;
                                break;
                            case "Y":
                                p("Y", 2), b += e1.formatYear();
                                break;
                            case "J":
                                b += e1.toJD();
                                break;
                            case "@":
                                b += (e1.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY;
                                break;
                            case "!":
                                b += (e1.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY;
                                break;
                            case "'":
                                p("'") ? b += "'" : _ = !0;
                                break;
                            default:
                                b += t1.charAt(w);
                        }
                        return b;
                    },
                    parseDate: function(t1, e1, r) {
                        if (null == e1) throw i.local.invalidArguments || i.regionalOptions[""].invalidArguments;
                        if ("" === (e1 = "object" == typeof e1 ? e1.toString() : e1 + "")) return null;
                        t1 = t1 || this.local.dateFormat;
                        var n = (r = r || {}).shortYearCutoff || this.shortYearCutoff;
                        n = "string" != typeof n ? n : this.today().year() % 100 + parseInt(n, 10);
                        for(var a = r.dayNamesShort || this.local.dayNamesShort, o = r.dayNames || this.local.dayNames, s = r.parseMonth || this.local.parseMonth, l = r.monthNumbers || this.local.monthNumbers, c = r.monthNamesShort || this.local.monthNamesShort, u = r.monthNames || this.local.monthNames, f = -1, h = -1, p = -1, d = -1, m = -1, g = !1, v = !1, y = function(e1, r) {
                            for(var n = 1; M + n < t1.length && t1.charAt(M + n) === e1;)n++;
                            return M += n - 1, Math.floor(n / (r || 1)) > 1;
                        }, x = function(t1, r) {
                            var n = y(t1, r), a = [
                                2,
                                3,
                                n ? 4 : 2,
                                n ? 4 : 2,
                                10,
                                11,
                                20
                            ]["oyYJ@!".indexOf(t1) + 1], o = new RegExp("^-?\\d{1," + a + "}"), s = e1.substring(A).match(o);
                            if (!s) throw (i.local.missingNumberAt || i.regionalOptions[""].missingNumberAt).replace(/\{0\}/, A);
                            return A += s[0].length, parseInt(s[0], 10);
                        }, b = this, _ = function() {
                            if ("function" == typeof l) {
                                y("m");
                                var t1 = l.call(b, e1.substring(A));
                                return A += t1.length, t1;
                            }
                            return x("m");
                        }, w = function(t1, r, n, a) {
                            for(var o = y(t1, a) ? n : r, s = 0; s < o.length; s++)if (e1.substr(A, o[s].length).toLowerCase() === o[s].toLowerCase()) return A += o[s].length, s + b.minMonth;
                            throw (i.local.unknownNameAt || i.regionalOptions[""].unknownNameAt).replace(/\{0\}/, A);
                        }, T = function() {
                            if ("function" == typeof u) {
                                var t1 = y("M") ? u.call(b, e1.substring(A)) : c.call(b, e1.substring(A));
                                return A += t1.length, t1;
                            }
                            return w("M", c, u);
                        }, k = function() {
                            if (e1.charAt(A) !== t1.charAt(M)) throw (i.local.unexpectedLiteralAt || i.regionalOptions[""].unexpectedLiteralAt).replace(/\{0\}/, A);
                            A++;
                        }, A = 0, M = 0; M < t1.length; M++)if (v) "'" !== t1.charAt(M) || y("'") ? k() : v = !1;
                        else switch(t1.charAt(M)){
                            case "d":
                                d = x("d");
                                break;
                            case "D":
                                w("D", a, o);
                                break;
                            case "o":
                                m = x("o");
                                break;
                            case "w":
                                x("w");
                                break;
                            case "m":
                                p = _();
                                break;
                            case "M":
                                p = T();
                                break;
                            case "y":
                                var S = M;
                                g = !y("y", 2), M = S, h = x("y", 2);
                                break;
                            case "Y":
                                h = x("Y", 2);
                                break;
                            case "J":
                                f = x("J") + .5, "." === e1.charAt(A) && (A++, x("J"));
                                break;
                            case "@":
                                f = x("@") / this.SECS_PER_DAY + this.UNIX_EPOCH;
                                break;
                            case "!":
                                f = x("!") / this.TICKS_PER_DAY + this.TICKS_EPOCH;
                                break;
                            case "*":
                                A = e1.length;
                                break;
                            case "'":
                                y("'") ? k() : v = !0;
                                break;
                            default:
                                k();
                        }
                        if (A < e1.length) throw i.local.unexpectedText || i.regionalOptions[""].unexpectedText;
                        if (-1 === h ? h = this.today().year() : h < 100 && g && (h += -1 === n ? 1900 : this.today().year() - this.today().year() % 100 - (h <= n ? 0 : 100)), "string" == typeof p && (p = s.call(this, h, p)), m > -1) {
                            p = 1, d = m;
                            for(var E = this.daysInMonth(h, p); d > E; E = this.daysInMonth(h, p))p++, d -= E;
                        }
                        return f > -1 ? this.fromJD(f) : this.newDate(h, p, d);
                    },
                    determineDate: function(t1, e1, r, n, i) {
                        r && "object" != typeof r && (i = n, n = r, r = null), "string" != typeof n && (i = n, n = "");
                        var a = this;
                        return e1 = e1 ? e1.newDate() : null, t1 = null == t1 ? e1 : "string" == typeof t1 ? function(t1) {
                            try {
                                return a.parseDate(n, t1, i);
                            } catch (t1) {}
                            for(var e1 = ((t1 = t1.toLowerCase()).match(/^c/) && r ? r.newDate() : null) || a.today(), o = /([+-]?[0-9]+)\s*(d|w|m|y)?/g, s = o.exec(t1); s;)e1.add(parseInt(s[1], 10), s[2] || "d"), s = o.exec(t1);
                            return e1;
                        }(t1) : "number" == typeof t1 ? isNaN(t1) || t1 === 1 / 0 || t1 === -1 / 0 ? e1 : a.today().add(t1, "d") : a.newDate(t1);
                    }
                });
            },
            {
                "./main": 346,
                "object-assign": 247
            }
        ],
        348: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = [
                    {
                        path: "",
                        backoff: 0
                    },
                    {
                        path: "M-2.4,-3V3L0.6,0Z",
                        backoff: .6
                    },
                    {
                        path: "M-3.7,-2.5V2.5L1.3,0Z",
                        backoff: 1.3
                    },
                    {
                        path: "M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z",
                        backoff: 1.55
                    },
                    {
                        path: "M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z",
                        backoff: 1.6
                    },
                    {
                        path: "M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z",
                        backoff: 2
                    },
                    {
                        path: "M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z",
                        backoff: 0,
                        noRotate: !0
                    },
                    {
                        path: "M2,2V-2H-2V2Z",
                        backoff: 0,
                        noRotate: !0
                    }
                ];
            },
            {}
        ],
        349: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./arrow_paths"), i = t1("../../plots/font_attributes"), a = t1("../../plots/cartesian/constants"), o = t1("../../plot_api/plot_template").templatedArray;
                t1("../../constants/axis_placeable_objects");
                e1.exports = o("annotation", {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc+arraydraw"
                    },
                    text: {
                        valType: "string",
                        editType: "calc+arraydraw"
                    },
                    textangle: {
                        valType: "angle",
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    font: i({
                        editType: "calc+arraydraw",
                        colorEditType: "arraydraw"
                    }),
                    width: {
                        valType: "number",
                        min: 1,
                        dflt: null,
                        editType: "calc+arraydraw"
                    },
                    height: {
                        valType: "number",
                        min: 1,
                        dflt: null,
                        editType: "calc+arraydraw"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    align: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "center",
                        editType: "arraydraw"
                    },
                    valign: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "middle",
                        editType: "arraydraw"
                    },
                    bgcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)",
                        editType: "arraydraw"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)",
                        editType: "arraydraw"
                    },
                    borderpad: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc+arraydraw"
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc+arraydraw"
                    },
                    showarrow: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc+arraydraw"
                    },
                    arrowcolor: {
                        valType: "color",
                        editType: "arraydraw"
                    },
                    arrowhead: {
                        valType: "integer",
                        min: 0,
                        max: n.length,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    startarrowhead: {
                        valType: "integer",
                        min: 0,
                        max: n.length,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    arrowside: {
                        valType: "flaglist",
                        flags: [
                            "end",
                            "start"
                        ],
                        extras: [
                            "none"
                        ],
                        dflt: "end",
                        editType: "arraydraw"
                    },
                    arrowsize: {
                        valType: "number",
                        min: .3,
                        dflt: 1,
                        editType: "calc+arraydraw"
                    },
                    startarrowsize: {
                        valType: "number",
                        min: .3,
                        dflt: 1,
                        editType: "calc+arraydraw"
                    },
                    arrowwidth: {
                        valType: "number",
                        min: .1,
                        editType: "calc+arraydraw"
                    },
                    standoff: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    startstandoff: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    ax: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    ay: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    axref: {
                        valType: "enumerated",
                        dflt: "pixel",
                        values: [
                            "pixel",
                            a.idRegex.x.toString()
                        ],
                        editType: "calc"
                    },
                    ayref: {
                        valType: "enumerated",
                        dflt: "pixel",
                        values: [
                            "pixel",
                            a.idRegex.y.toString()
                        ],
                        editType: "calc"
                    },
                    xref: {
                        valType: "enumerated",
                        values: [
                            "paper",
                            a.idRegex.x.toString()
                        ],
                        editType: "calc"
                    },
                    x: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "auto",
                        editType: "calc+arraydraw"
                    },
                    xshift: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    yref: {
                        valType: "enumerated",
                        values: [
                            "paper",
                            a.idRegex.y.toString()
                        ],
                        editType: "calc"
                    },
                    y: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "auto",
                        editType: "calc+arraydraw"
                    },
                    yshift: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc+arraydraw"
                    },
                    clicktoshow: {
                        valType: "enumerated",
                        values: [
                            !1,
                            "onoff",
                            "onout"
                        ],
                        dflt: !1,
                        editType: "arraydraw"
                    },
                    xclick: {
                        valType: "any",
                        editType: "arraydraw"
                    },
                    yclick: {
                        valType: "any",
                        editType: "arraydraw"
                    },
                    hovertext: {
                        valType: "string",
                        editType: "arraydraw"
                    },
                    hoverlabel: {
                        bgcolor: {
                            valType: "color",
                            editType: "arraydraw"
                        },
                        bordercolor: {
                            valType: "color",
                            editType: "arraydraw"
                        },
                        font: i({
                            editType: "arraydraw"
                        }),
                        editType: "arraydraw"
                    },
                    captureevents: {
                        valType: "boolean",
                        editType: "arraydraw"
                    },
                    editType: "calc",
                    _deprecated: {
                        ref: {
                            valType: "string",
                            editType: "calc"
                        }
                    }
                });
            },
            {
                "../../constants/axis_placeable_objects": 472,
                "../../plot_api/plot_template": 543,
                "../../plots/cartesian/constants": 561,
                "../../plots/font_attributes": 585,
                "./arrow_paths": 348
            }
        ],
        350: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axes"), a = t1("./draw").draw;
                function o(t1) {
                    var e1 = t1._fullLayout;
                    n.filterVisible(e1.annotations).forEach(function(e1) {
                        var r = i.getFromId(t1, e1.xref), n = i.getFromId(t1, e1.yref), a = i.getRefType(e1.xref), o = i.getRefType(e1.yref);
                        e1._extremes = {}, "range" === a && s(e1, r), "range" === o && s(e1, n);
                    });
                }
                function s(t1, e1) {
                    var r, n = e1._id, a = n.charAt(0), o = t1[a], s = t1["a" + a], l = t1[a + "ref"], c = t1["a" + a + "ref"], u = t1["_" + a + "padplus"], f = t1["_" + a + "padminus"], h = {
                        x: 1,
                        y: -1
                    }[a] * t1[a + "shift"], p = 3 * t1.arrowsize * t1.arrowwidth || 0, d = p + h, m = p - h, g = 3 * t1.startarrowsize * t1.arrowwidth || 0, v = g + h, y = g - h;
                    if (c === l) {
                        var x = i.findExtremes(e1, [
                            e1.r2c(o)
                        ], {
                            ppadplus: d,
                            ppadminus: m
                        }), b = i.findExtremes(e1, [
                            e1.r2c(s)
                        ], {
                            ppadplus: Math.max(u, v),
                            ppadminus: Math.max(f, y)
                        });
                        r = {
                            min: [
                                x.min[0],
                                b.min[0]
                            ],
                            max: [
                                x.max[0],
                                b.max[0]
                            ]
                        };
                    } else v = s ? v + s : v, y = s ? y - s : y, r = i.findExtremes(e1, [
                        e1.r2c(o)
                    ], {
                        ppadplus: Math.max(u, d, v),
                        ppadminus: Math.max(f, m, y)
                    });
                    t1._extremes[n] = r;
                }
                e1.exports = function(t1) {
                    var e1 = t1._fullLayout;
                    if (n.filterVisible(e1.annotations).length && t1._fullData.length) return n.syncOrAsync([
                        a,
                        o
                    ], t1);
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "./draw": 355
            }
        ],
        351: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../registry"), a = t1("../../plot_api/plot_template").arrayEditor;
                function o(t1, e1) {
                    var r, n, i, a, o, l, c, u = t1._fullLayout.annotations, f = [], h = [], p = [], d = (e1 || []).length;
                    for(r = 0; r < u.length; r++)if (a = (i = u[r]).clicktoshow) {
                        for(n = 0; n < d; n++)if (l = (o = e1[n]).xaxis, c = o.yaxis, l._id === i.xref && c._id === i.yref && l.d2r(o.x) === s(i._xclick, l) && c.d2r(o.y) === s(i._yclick, c)) {
                            (i.visible ? "onout" === a ? h : p : f).push(r);
                            break;
                        }
                        n === d && i.visible && "onout" === a && h.push(r);
                    }
                    return {
                        on: f,
                        off: h,
                        explicitOff: p
                    };
                }
                function s(t1, e1) {
                    return "log" === e1.type ? e1.l2r(t1) : e1.d2r(t1);
                }
                e1.exports = {
                    hasClickToShow: function(t1, e1) {
                        var r = o(t1, e1);
                        return r.on.length > 0 || r.explicitOff.length > 0;
                    },
                    onClick: function(t1, e1) {
                        var r, s, l = o(t1, e1), c = l.on, u = l.off.concat(l.explicitOff), f = {}, h = t1._fullLayout.annotations;
                        if (!c.length && !u.length) return;
                        for(r = 0; r < c.length; r++)(s = a(t1.layout, "annotations", h[c[r]])).modifyItem("visible", !0), n.extendFlat(f, s.getUpdateObj());
                        for(r = 0; r < u.length; r++)(s = a(t1.layout, "annotations", h[u[r]])).modifyItem("visible", !1), n.extendFlat(f, s.getUpdateObj());
                        return i.call("update", t1, {}, f);
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../../registry": 638
            }
        ],
        352: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../color");
                e1.exports = function(t1, e1, r, a) {
                    a("opacity");
                    var o = a("bgcolor"), s = a("bordercolor"), l = i.opacity(s);
                    a("borderpad");
                    var c = a("borderwidth"), u = a("showarrow");
                    if (a("text", u ? " " : r._dfltTitle.annotation), a("textangle"), n.coerceFont(a, "font", r.font), a("width"), a("align"), a("height") && a("valign"), u) {
                        var f, h, p = a("arrowside");
                        -1 !== p.indexOf("end") && (f = a("arrowhead"), h = a("arrowsize")), -1 !== p.indexOf("start") && (a("startarrowhead", f), a("startarrowsize", h)), a("arrowcolor", l ? e1.bordercolor : i.defaultLine), a("arrowwidth", 2 * (l && c || 1)), a("standoff"), a("startstandoff");
                    }
                    var d = a("hovertext"), m = r.hoverlabel || {};
                    if (d) {
                        var g = a("hoverlabel.bgcolor", m.bgcolor || (i.opacity(o) ? i.rgb(o) : i.defaultLine)), v = a("hoverlabel.bordercolor", m.bordercolor || i.contrast(g));
                        n.coerceFont(a, "hoverlabel.font", {
                            family: m.font.family,
                            size: m.font.size,
                            color: m.font.color || v
                        });
                    }
                    a("captureevents", !!d);
                };
            },
            {
                "../../lib": 503,
                "../color": 366
            }
        ],
        353: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib/to_log_range");
                e1.exports = function(t1, e1, r, a) {
                    e1 = e1 || {};
                    var o = "log" === r && "linear" === e1.type, s = "linear" === r && "log" === e1.type;
                    if (o || s) for(var l, c, u = t1._fullLayout.annotations, f = e1._id.charAt(0), h = 0; h < u.length; h++)l = u[h], c = "annotations[" + h + "].", l[f + "ref"] === e1._id && p(f), l["a" + f + "ref"] === e1._id && p("a" + f);
                    function p(t1) {
                        var r = l[t1], s = null;
                        s = o ? i(r, e1.range) : Math.pow(10, r), n(s) || (s = null), a(c + t1, s);
                    }
                };
            },
            {
                "../../lib/to_log_range": 531,
                "fast-isnumeric": 190
            }
        ],
        354: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axes"), a = t1("../../plots/array_container_defaults"), o = t1("./common_defaults"), s = t1("./attributes");
                function l(t1, e1, r) {
                    function a(r, i) {
                        return n.coerce(t1, e1, s, r, i);
                    }
                    var l = a("visible"), c = a("clicktoshow");
                    if (l || c) {
                        o(t1, e1, r, a);
                        for(var u = e1.showarrow, f = [
                            "x",
                            "y"
                        ], h = [
                            -10,
                            -30
                        ], p = {
                            _fullLayout: r
                        }, d = 0; d < 2; d++){
                            var m = f[d], g = i.coerceRef(t1, e1, p, m, "", "paper");
                            if ("paper" !== g) i.getFromId(p, g)._annIndices.push(e1._index);
                            if (i.coercePosition(e1, p, a, g, m, .5), u) {
                                var v = "a" + m, y = i.coerceRef(t1, e1, p, v, "pixel", [
                                    "pixel",
                                    "paper"
                                ]);
                                "pixel" !== y && y !== g && (y = e1[v] = "pixel");
                                var x = "pixel" === y ? h[d] : .4;
                                i.coercePosition(e1, p, a, y, v, x);
                            }
                            a(m + "anchor"), a(m + "shift");
                        }
                        if (n.noneOrAll(t1, e1, [
                            "x",
                            "y"
                        ]), u && n.noneOrAll(t1, e1, [
                            "ax",
                            "ay"
                        ]), c) {
                            var b = a("xclick"), _ = a("yclick");
                            e1._xclick = void 0 === b ? e1.x : i.cleanPosition(b, p, e1.xref), e1._yclick = void 0 === _ ? e1.y : i.cleanPosition(_, p, e1.yref);
                        }
                    }
                }
                e1.exports = function(t1, e1) {
                    a(t1, e1, {
                        name: "annotations",
                        handleItemDefaults: l
                    });
                };
            },
            {
                "../../lib": 503,
                "../../plots/array_container_defaults": 549,
                "../../plots/cartesian/axes": 554,
                "./attributes": 349,
                "./common_defaults": 352
            }
        ],
        355: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../registry"), a = t1("../../plots/plots"), o = t1("../../lib"), s = o.strTranslate, l = t1("../../plots/cartesian/axes"), c = t1("../color"), u = t1("../drawing"), f = t1("../fx"), h = t1("../../lib/svg_text_utils"), p = t1("../../lib/setcursor"), d = t1("../dragelement"), m = t1("../../plot_api/plot_template").arrayEditor, g = t1("./draw_arrow_head");
                function v(t1, e1) {
                    var r = t1._fullLayout.annotations[e1] || {}, n = l.getFromId(t1, r.xref), i = l.getFromId(t1, r.yref);
                    n && n.setScale(), i && i.setScale(), x(t1, r, e1, !1, n, i);
                }
                function y(t1, e1, r, n, i) {
                    var a = i[r], o = i[r + "ref"], s = -1 !== r.indexOf("y"), c = "domain" === l.getRefType(o), u = s ? n.h : n.w;
                    return t1 ? c ? a + (s ? -e1 : e1) / t1._length : t1.p2r(t1.r2p(a) + e1) : a + (s ? -e1 : e1) / u;
                }
                function x(t1, e1, r, a, v, x) {
                    var b, _, w = t1._fullLayout, T = t1._fullLayout._size, k = t1._context.edits;
                    a ? (b = "annotation-" + a, _ = a + ".annotations") : (b = "annotation", _ = "annotations");
                    var A = m(t1.layout, _, e1), M = A.modifyBase, S = A.modifyItem, E = A.getUpdateObj;
                    w._infolayer.selectAll("." + b + '[data-index="' + r + '"]').remove();
                    var L = "clip" + w._uid + "_ann" + r;
                    if (e1._input && !1 !== e1.visible) {
                        var C = {
                            x: {},
                            y: {}
                        }, P = +e1.textangle || 0, I = w._infolayer.append("g").classed(b, !0).attr("data-index", String(r)).style("opacity", e1.opacity), O = I.append("g").classed("annotation-text-g", !0), z = k[e1.showarrow ? "annotationTail" : "annotationPosition"], D = e1.captureevents || k.annotationText || z, R = O.append("g").style("pointer-events", D ? "all" : null).call(p, "pointer").on("click", function() {
                            t1._dragging = !1, t1.emit("plotly_clickannotation", Y(n.event));
                        });
                        e1.hovertext && R.on("mouseover", function() {
                            var r = e1.hoverlabel, n = r.font, i = this.getBoundingClientRect(), a = t1.getBoundingClientRect();
                            f.loneHover({
                                x0: i.left - a.left,
                                x1: i.right - a.left,
                                y: (i.top + i.bottom) / 2 - a.top,
                                text: e1.hovertext,
                                color: r.bgcolor,
                                borderColor: r.bordercolor,
                                fontFamily: n.family,
                                fontSize: n.size,
                                fontColor: n.color
                            }, {
                                container: w._hoverlayer.node(),
                                outerContainer: w._paper.node(),
                                gd: t1
                            });
                        }).on("mouseout", function() {
                            f.loneUnhover(w._hoverlayer.node());
                        });
                        var F = e1.borderwidth, B = e1.borderpad, N = F + B, j = R.append("rect").attr("class", "bg").style("stroke-width", F + "px").call(c.stroke, e1.bordercolor).call(c.fill, e1.bgcolor), U = e1.width || e1.height, V = w._topclips.selectAll("#" + L).data(U ? [
                            0
                        ] : []);
                        V.enter().append("clipPath").classed("annclip", !0).attr("id", L).append("rect"), V.exit().remove();
                        var H = e1.font, q = w._meta ? o.templateString(e1.text, w._meta) : e1.text, G = R.append("text").classed("annotation-text", !0).text(q);
                        k.annotationText ? G.call(h.makeEditable, {
                            delegate: R,
                            gd: t1
                        }).call(W).on("edit", function(r) {
                            e1.text = r, this.call(W), S("text", r), v && v.autorange && M(v._name + ".autorange", !0), x && x.autorange && M(x._name + ".autorange", !0), i.call("_guiRelayout", t1, E());
                        }) : G.call(W);
                    } else n.selectAll("#" + L).remove();
                    function Y(t1) {
                        var n = {
                            index: r,
                            annotation: e1._input,
                            fullAnnotation: e1,
                            event: t1
                        };
                        return a && (n.subplotId = a), n;
                    }
                    function W(r) {
                        return r.call(u.font, H).attr({
                            "text-anchor": {
                                left: "start",
                                right: "end"
                            }[e1.align] || "middle"
                        }), h.convertToTspans(r, t1, X), r;
                    }
                    function X() {
                        var r = G.selectAll("a");
                        1 === r.size() && r.text() === G.text() && R.insert("a", ":first-child").attr({
                            "xlink:xlink:href": r.attr("xlink:href"),
                            "xlink:xlink:show": r.attr("xlink:show")
                        }).style({
                            cursor: "pointer"
                        }).node().appendChild(j.node());
                        var n = R.select(".annotation-text-math-group"), f = !n.empty(), m = u.bBox((f ? n : G).node()), b = m.width, _ = m.height, A = e1.width || b, D = e1.height || _, B = Math.round(A + 2 * N), H = Math.round(D + 2 * N);
                        function q(t1, e1) {
                            return "auto" === e1 && (e1 = t1 < 1 / 3 ? "left" : t1 > 2 / 3 ? "right" : "center"), ({
                                center: 0,
                                middle: 0,
                                left: .5,
                                bottom: -0.5,
                                right: -0.5,
                                top: .5
                            })[e1];
                        }
                        for(var W = !1, X = [
                            "x",
                            "y"
                        ], Z = 0; Z < X.length; Z++){
                            var J, K, Q, $, tt, et = X[Z], rt = e1[et + "ref"] || et, nt = e1["a" + et + "ref"], it = {
                                x: v,
                                y: x
                            }[et], at = (P + ("x" === et ? 0 : -90)) * Math.PI / 180, ot = B * Math.cos(at), st = H * Math.sin(at), lt = Math.abs(ot) + Math.abs(st), ct = e1[et + "anchor"], ut = e1[et + "shift"] * ("x" === et ? 1 : -1), ft = C[et], ht = l.getRefType(rt);
                            if (it && "domain" !== ht) {
                                var pt = it.r2fraction(e1[et]);
                                (pt < 0 || pt > 1) && (nt === rt ? ((pt = it.r2fraction(e1["a" + et])) < 0 || pt > 1) && (W = !0) : W = !0), J = it._offset + it.r2p(e1[et]), $ = .5;
                            } else {
                                var dt = "domain" === ht;
                                "x" === et ? (Q = e1[et], J = dt ? it._offset + it._length * Q : J = T.l + T.w * Q) : (Q = 1 - e1[et], J = dt ? it._offset + it._length * Q : J = T.t + T.h * Q), $ = e1.showarrow ? .5 : Q;
                            }
                            if (e1.showarrow) {
                                ft.head = J;
                                var mt = e1["a" + et];
                                if (tt = ot * q(.5, e1.xanchor) - st * q(.5, e1.yanchor), nt === rt) {
                                    var gt = l.getRefType(nt);
                                    "domain" === gt ? ("y" === et && (mt = 1 - mt), ft.tail = it._offset + it._length * mt) : "paper" === gt ? "y" === et ? (mt = 1 - mt, ft.tail = T.t + T.h * mt) : ft.tail = T.l + T.w * mt : ft.tail = it._offset + it.r2p(mt), K = tt;
                                } else ft.tail = J + mt, K = tt + mt;
                                ft.text = ft.tail + tt;
                                var vt = w["x" === et ? "width" : "height"];
                                if ("paper" === rt && (ft.head = o.constrain(ft.head, 1, vt - 1)), "pixel" === nt) {
                                    var yt = -Math.max(ft.tail - 3, ft.text), xt = Math.min(ft.tail + 3, ft.text) - vt;
                                    yt > 0 ? (ft.tail += yt, ft.text += yt) : xt > 0 && (ft.tail -= xt, ft.text -= xt);
                                }
                                ft.tail += ut, ft.head += ut;
                            } else K = tt = lt * q($, ct), ft.text = J + tt;
                            ft.text += ut, tt += ut, K += ut, e1["_" + et + "padplus"] = lt / 2 + K, e1["_" + et + "padminus"] = lt / 2 - K, e1["_" + et + "size"] = lt, e1["_" + et + "shift"] = tt;
                        }
                        if (W) R.remove();
                        else {
                            var bt = 0, _t = 0;
                            if ("left" !== e1.align && (bt = (A - b) * ("center" === e1.align ? .5 : 1)), "top" !== e1.valign && (_t = (D - _) * ("middle" === e1.valign ? .5 : 1)), f) n.select("svg").attr({
                                x: N + bt - 1,
                                y: N + _t
                            }).call(u.setClipUrl, U ? L : null, t1);
                            else {
                                var wt = N + _t - m.top, Tt = N + bt - m.left;
                                G.call(h.positionText, Tt, wt).call(u.setClipUrl, U ? L : null, t1);
                            }
                            V.select("rect").call(u.setRect, N, N, A, D), j.call(u.setRect, F / 2, F / 2, B - F, H - F), R.call(u.setTranslate, Math.round(C.x.text - B / 2), Math.round(C.y.text - H / 2)), O.attr({
                                transform: "rotate(" + P + "," + C.x.text + "," + C.y.text + ")"
                            });
                            var kt, At = function(r, n) {
                                I.selectAll(".annotation-arrow-g").remove();
                                var l = C.x.head, f = C.y.head, h = C.x.tail + r, p = C.y.tail + n, m = C.x.text + r, b = C.y.text + n, _ = o.rotationXYMatrix(P, m, b), w = o.apply2DTransform(_), A = o.apply2DTransform2(_), L = +j.attr("width"), z = +j.attr("height"), D = m - .5 * L, F = D + L, B = b - .5 * z, N = B + z, U = [
                                    [
                                        D,
                                        B,
                                        D,
                                        N
                                    ],
                                    [
                                        D,
                                        N,
                                        F,
                                        N
                                    ],
                                    [
                                        F,
                                        N,
                                        F,
                                        B
                                    ],
                                    [
                                        F,
                                        B,
                                        D,
                                        B
                                    ]
                                ].map(A);
                                if (!U.reduce(function(t1, e1) {
                                    return t1 ^ !!o.segmentsIntersect(l, f, l + 1e6, f + 1e6, e1[0], e1[1], e1[2], e1[3]);
                                }, !1)) {
                                    U.forEach(function(t1) {
                                        var e1 = o.segmentsIntersect(h, p, l, f, t1[0], t1[1], t1[2], t1[3]);
                                        e1 && (h = e1.x, p = e1.y);
                                    });
                                    var V = e1.arrowwidth, H = e1.arrowcolor, q = e1.arrowside, G = I.append("g").style({
                                        opacity: c.opacity(H)
                                    }).classed("annotation-arrow-g", !0), Y = G.append("path").attr("d", "M" + h + "," + p + "L" + l + "," + f).style("stroke-width", V + "px").call(c.stroke, c.rgb(H));
                                    if (g(Y, q, e1), k.annotationPosition && Y.node().parentNode && !a) {
                                        var W = l, X = f;
                                        if (e1.standoff) {
                                            var Z = Math.sqrt(Math.pow(l - h, 2) + Math.pow(f - p, 2));
                                            W += e1.standoff * (h - l) / Z, X += e1.standoff * (p - f) / Z;
                                        }
                                        var J, K, Q = G.append("path").classed("annotation-arrow", !0).classed("anndrag", !0).classed("cursor-move", !0).attr({
                                            d: "M3,3H-3V-3H3ZM0,0L" + (h - W) + "," + (p - X),
                                            transform: s(W, X)
                                        }).style("stroke-width", V + 6 + "px").call(c.stroke, "rgba(0,0,0,0)").call(c.fill, "rgba(0,0,0,0)");
                                        d.init({
                                            element: Q.node(),
                                            gd: t1,
                                            prepFn: function() {
                                                var t1 = u.getTranslate(R);
                                                J = t1.x, K = t1.y, v && v.autorange && M(v._name + ".autorange", !0), x && x.autorange && M(x._name + ".autorange", !0);
                                            },
                                            moveFn: function(t1, r) {
                                                var n = w(J, K), i = n[0] + t1, a = n[1] + r;
                                                R.call(u.setTranslate, i, a), S("x", y(v, t1, "x", T, e1)), S("y", y(x, r, "y", T, e1)), e1.axref === e1.xref && S("ax", y(v, t1, "ax", T, e1)), e1.ayref === e1.yref && S("ay", y(x, r, "ay", T, e1)), G.attr("transform", s(t1, r)), O.attr({
                                                    transform: "rotate(" + P + "," + i + "," + a + ")"
                                                });
                                            },
                                            doneFn: function() {
                                                i.call("_guiRelayout", t1, E());
                                                var e1 = document.querySelector(".js-notes-box-panel");
                                                e1 && e1.redraw(e1.selectedObj);
                                            }
                                        });
                                    }
                                }
                            };
                            if (e1.showarrow && At(0, 0), z) d.init({
                                element: R.node(),
                                gd: t1,
                                prepFn: function() {
                                    kt = O.attr("transform");
                                },
                                moveFn: function(t1, r) {
                                    var n = "pointer";
                                    if (e1.showarrow) e1.axref === e1.xref ? S("ax", y(v, t1, "ax", T, e1)) : S("ax", e1.ax + t1), e1.ayref === e1.yref ? S("ay", y(x, r, "ay", T.w, e1)) : S("ay", e1.ay + r), At(t1, r);
                                    else {
                                        if (a) return;
                                        var i, o;
                                        if (v) i = y(v, t1, "x", T, e1);
                                        else {
                                            var l = e1._xsize / T.w, c = e1.x + (e1._xshift - e1.xshift) / T.w - l / 2;
                                            i = d.align(c + t1 / T.w, l, 0, 1, e1.xanchor);
                                        }
                                        if (x) o = y(x, r, "y", T, e1);
                                        else {
                                            var u = e1._ysize / T.h, f = e1.y - (e1._yshift + e1.yshift) / T.h - u / 2;
                                            o = d.align(f - r / T.h, u, 0, 1, e1.yanchor);
                                        }
                                        S("x", i), S("y", o), v && x || (n = d.getCursor(v ? .5 : i, x ? .5 : o, e1.xanchor, e1.yanchor));
                                    }
                                    O.attr({
                                        transform: s(t1, r) + kt
                                    }), p(R, n);
                                },
                                clickFn: function(r, n) {
                                    e1.captureevents && t1.emit("plotly_clickannotation", Y(n));
                                },
                                doneFn: function() {
                                    p(R), i.call("_guiRelayout", t1, E());
                                    var e1 = document.querySelector(".js-notes-box-panel");
                                    e1 && e1.redraw(e1.selectedObj);
                                }
                            });
                        }
                    }
                }
                e1.exports = {
                    draw: function(t1) {
                        var e1 = t1._fullLayout;
                        e1._infolayer.selectAll(".annotation").remove();
                        for(var r = 0; r < e1.annotations.length; r++)e1.annotations[r].visible && v(t1, r);
                        return a.previousPromises(t1);
                    },
                    drawOne: v,
                    drawRaw: x
                };
            },
            {
                "../../lib": 503,
                "../../lib/setcursor": 524,
                "../../lib/svg_text_utils": 529,
                "../../plot_api/plot_template": 543,
                "../../plots/cartesian/axes": 554,
                "../../plots/plots": 619,
                "../../registry": 638,
                "../color": 366,
                "../dragelement": 385,
                "../drawing": 388,
                "../fx": 406,
                "./draw_arrow_head": 356,
                "@plotly/d3": 58
            }
        ],
        356: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../color"), a = t1("./arrow_paths"), o = t1("../../lib"), s = o.strScale, l = o.strRotate, c = o.strTranslate;
                e1.exports = function(t1, e1, r) {
                    var o, u, f, h, p = t1.node(), d = a[r.arrowhead || 0], m = a[r.startarrowhead || 0], g = (r.arrowwidth || 1) * (r.arrowsize || 1), v = (r.arrowwidth || 1) * (r.startarrowsize || 1), y = e1.indexOf("start") >= 0, x = e1.indexOf("end") >= 0, b = d.backoff * g + r.standoff, _ = m.backoff * v + r.startstandoff;
                    if ("line" === p.nodeName) {
                        o = {
                            x: +t1.attr("x1"),
                            y: +t1.attr("y1")
                        }, u = {
                            x: +t1.attr("x2"),
                            y: +t1.attr("y2")
                        };
                        var w = o.x - u.x, T = o.y - u.y;
                        if (h = (f = Math.atan2(T, w)) + Math.PI, b && _ && b + _ > Math.sqrt(w * w + T * T)) return void z();
                        if (b) {
                            if (b * b > w * w + T * T) return void z();
                            var k = b * Math.cos(f), A = b * Math.sin(f);
                            u.x += k, u.y += A, t1.attr({
                                x2: u.x,
                                y2: u.y
                            });
                        }
                        if (_) {
                            if (_ * _ > w * w + T * T) return void z();
                            var M = _ * Math.cos(f), S = _ * Math.sin(f);
                            o.x -= M, o.y -= S, t1.attr({
                                x1: o.x,
                                y1: o.y
                            });
                        }
                    } else if ("path" === p.nodeName) {
                        var E = p.getTotalLength(), L = "";
                        if (E < b + _) return void z();
                        var C = p.getPointAtLength(0), P = p.getPointAtLength(.1);
                        f = Math.atan2(C.y - P.y, C.x - P.x), o = p.getPointAtLength(Math.min(_, E)), L = "0px," + _ + "px,";
                        var I = p.getPointAtLength(E), O = p.getPointAtLength(E - .1);
                        h = Math.atan2(I.y - O.y, I.x - O.x), u = p.getPointAtLength(Math.max(0, E - b)), L += E - (L ? _ + b : b) + "px," + E + "px", t1.style("stroke-dasharray", L);
                    }
                    function z() {
                        t1.style("stroke-dasharray", "0px,100px");
                    }
                    function D(e1, a, o, u) {
                        e1.path && (e1.noRotate && (o = 0), n.select(p.parentNode).append("path").attr({
                            class: t1.attr("class"),
                            d: e1.path,
                            transform: c(a.x, a.y) + l(180 * o / Math.PI) + s(u)
                        }).style({
                            fill: i.rgb(r.arrowcolor),
                            "stroke-width": 0
                        }));
                    }
                    y && D(m, o, f, v), x && D(d, u, h, g);
                };
            },
            {
                "../../lib": 503,
                "../color": 366,
                "./arrow_paths": 348,
                "@plotly/d3": 58
            }
        ],
        357: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./draw"), i = t1("./click");
                e1.exports = {
                    moduleType: "component",
                    name: "annotations",
                    layoutAttributes: t1("./attributes"),
                    supplyLayoutDefaults: t1("./defaults"),
                    includeBasePlot: t1("../../plots/cartesian/include_components")("annotations"),
                    calcAutorange: t1("./calc_autorange"),
                    draw: n.draw,
                    drawOne: n.drawOne,
                    drawRaw: n.drawRaw,
                    hasClickToShow: i.hasClickToShow,
                    onClick: i.onClick,
                    convertCoords: t1("./convert_coords")
                };
            },
            {
                "../../plots/cartesian/include_components": 567,
                "./attributes": 349,
                "./calc_autorange": 350,
                "./click": 351,
                "./convert_coords": 353,
                "./defaults": 354,
                "./draw": 355
            }
        ],
        358: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../annotations/attributes"), i = t1("../../plot_api/edit_types").overrideAll, a = t1("../../plot_api/plot_template").templatedArray;
                e1.exports = i(a("annotation", {
                    visible: n.visible,
                    x: {
                        valType: "any"
                    },
                    y: {
                        valType: "any"
                    },
                    z: {
                        valType: "any"
                    },
                    ax: {
                        valType: "number"
                    },
                    ay: {
                        valType: "number"
                    },
                    xanchor: n.xanchor,
                    xshift: n.xshift,
                    yanchor: n.yanchor,
                    yshift: n.yshift,
                    text: n.text,
                    textangle: n.textangle,
                    font: n.font,
                    width: n.width,
                    height: n.height,
                    opacity: n.opacity,
                    align: n.align,
                    valign: n.valign,
                    bgcolor: n.bgcolor,
                    bordercolor: n.bordercolor,
                    borderpad: n.borderpad,
                    borderwidth: n.borderwidth,
                    showarrow: n.showarrow,
                    arrowcolor: n.arrowcolor,
                    arrowhead: n.arrowhead,
                    startarrowhead: n.startarrowhead,
                    arrowside: n.arrowside,
                    arrowsize: n.arrowsize,
                    startarrowsize: n.startarrowsize,
                    arrowwidth: n.arrowwidth,
                    standoff: n.standoff,
                    startstandoff: n.startstandoff,
                    hovertext: n.hovertext,
                    hoverlabel: n.hoverlabel,
                    captureevents: n.captureevents
                }), "calc", "from-root");
            },
            {
                "../../plot_api/edit_types": 536,
                "../../plot_api/plot_template": 543,
                "../annotations/attributes": 349
            }
        ],
        359: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axes");
                function a(t1, e1) {
                    var r = e1.fullSceneLayout.domain, a = e1.fullLayout._size, o = {
                        pdata: null,
                        type: "linear",
                        autorange: !1,
                        range: [
                            -1 / 0,
                            1 / 0
                        ]
                    };
                    t1._xa = {}, n.extendFlat(t1._xa, o), i.setConvert(t1._xa), t1._xa._offset = a.l + r.x[0] * a.w, t1._xa.l2p = function() {
                        return .5 * (1 + t1._pdata[0] / t1._pdata[3]) * a.w * (r.x[1] - r.x[0]);
                    }, t1._ya = {}, n.extendFlat(t1._ya, o), i.setConvert(t1._ya), t1._ya._offset = a.t + (1 - r.y[1]) * a.h, t1._ya.l2p = function() {
                        return .5 * (1 - t1._pdata[1] / t1._pdata[3]) * a.h * (r.y[1] - r.y[0]);
                    };
                }
                e1.exports = function(t1) {
                    for(var e1 = t1.fullSceneLayout.annotations, r = 0; r < e1.length; r++)a(e1[r], t1);
                    t1.fullLayout._infolayer.selectAll(".annotation-" + t1.id).remove();
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554
            }
        ],
        360: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axes"), a = t1("../../plots/array_container_defaults"), o = t1("../annotations/common_defaults"), s = t1("./attributes");
                function l(t1, e1, r, a) {
                    function l(r, i) {
                        return n.coerce(t1, e1, s, r, i);
                    }
                    function c(t1) {
                        var n = t1 + "axis", a = {
                            _fullLayout: {}
                        };
                        return a._fullLayout[n] = r[n], i.coercePosition(e1, a, l, t1, t1, .5);
                    }
                    l("visible") && (o(t1, e1, a.fullLayout, l), c("x"), c("y"), c("z"), n.noneOrAll(t1, e1, [
                        "x",
                        "y",
                        "z"
                    ]), e1.xref = "x", e1.yref = "y", e1.zref = "z", l("xanchor"), l("yanchor"), l("xshift"), l("yshift"), e1.showarrow && (e1.axref = "pixel", e1.ayref = "pixel", l("ax", -10), l("ay", -30), n.noneOrAll(t1, e1, [
                        "ax",
                        "ay"
                    ])));
                }
                e1.exports = function(t1, e1, r) {
                    a(t1, e1, {
                        name: "annotations",
                        handleItemDefaults: l,
                        fullLayout: r.fullLayout
                    });
                };
            },
            {
                "../../lib": 503,
                "../../plots/array_container_defaults": 549,
                "../../plots/cartesian/axes": 554,
                "../annotations/common_defaults": 352,
                "./attributes": 358
            }
        ],
        361: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../annotations/draw").drawRaw, i = t1("../../plots/gl3d/project"), a = [
                    "x",
                    "y",
                    "z"
                ];
                e1.exports = function(t1) {
                    for(var e1 = t1.fullSceneLayout, r = t1.dataScale, o = e1.annotations, s = 0; s < o.length; s++){
                        for(var l = o[s], c = !1, u = 0; u < 3; u++){
                            var f = a[u], h = l[f], p = e1[f + "axis"].r2fraction(h);
                            if (p < 0 || p > 1) {
                                c = !0;
                                break;
                            }
                        }
                        c ? t1.fullLayout._infolayer.select(".annotation-" + t1.id + '[data-index="' + s + '"]').remove() : (l._pdata = i(t1.glplot.cameraParams, [
                            e1.xaxis.r2l(l.x) * r[0],
                            e1.yaxis.r2l(l.y) * r[1],
                            e1.zaxis.r2l(l.z) * r[2]
                        ]), n(t1.graphDiv, l, s, t1.id, l._xa, l._ya));
                    }
                };
            },
            {
                "../../plots/gl3d/project": 607,
                "../annotations/draw": 355
            }
        ],
        362: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib");
                e1.exports = {
                    moduleType: "component",
                    name: "annotations3d",
                    schema: {
                        subplots: {
                            scene: {
                                annotations: t1("./attributes")
                            }
                        }
                    },
                    layoutAttributes: t1("./attributes"),
                    handleDefaults: t1("./defaults"),
                    includeBasePlot: function(t1, e1) {
                        var r = n.subplotsRegistry.gl3d;
                        if (!r) return;
                        for(var a = r.attrRegex, o = Object.keys(t1), s = 0; s < o.length; s++){
                            var l = o[s];
                            a.test(l) && (t1[l].annotations || []).length && (i.pushUnique(e1._basePlotModules, r), i.pushUnique(e1._subplots.gl3d, l));
                        }
                    },
                    convert: t1("./convert"),
                    draw: t1("./draw")
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638,
                "./attributes": 358,
                "./convert": 359,
                "./defaults": 360,
                "./draw": 361
            }
        ],
        363: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = t1("world-calendars/dist/main"), t1("world-calendars/dist/plus"), t1("world-calendars/dist/calendars/chinese"), t1("world-calendars/dist/calendars/coptic"), t1("world-calendars/dist/calendars/discworld"), t1("world-calendars/dist/calendars/ethiopian"), t1("world-calendars/dist/calendars/hebrew"), t1("world-calendars/dist/calendars/islamic"), t1("world-calendars/dist/calendars/julian"), t1("world-calendars/dist/calendars/mayan"), t1("world-calendars/dist/calendars/nanakshahi"), t1("world-calendars/dist/calendars/nepali"), t1("world-calendars/dist/calendars/persian"), t1("world-calendars/dist/calendars/taiwan"), t1("world-calendars/dist/calendars/thai"), t1("world-calendars/dist/calendars/ummalqura");
            },
            {
                "world-calendars/dist/calendars/chinese": 332,
                "world-calendars/dist/calendars/coptic": 333,
                "world-calendars/dist/calendars/discworld": 334,
                "world-calendars/dist/calendars/ethiopian": 335,
                "world-calendars/dist/calendars/hebrew": 336,
                "world-calendars/dist/calendars/islamic": 337,
                "world-calendars/dist/calendars/julian": 338,
                "world-calendars/dist/calendars/mayan": 339,
                "world-calendars/dist/calendars/nanakshahi": 340,
                "world-calendars/dist/calendars/nepali": 341,
                "world-calendars/dist/calendars/persian": 342,
                "world-calendars/dist/calendars/taiwan": 343,
                "world-calendars/dist/calendars/thai": 344,
                "world-calendars/dist/calendars/ummalqura": 345,
                "world-calendars/dist/main": 346,
                "world-calendars/dist/plus": 347
            }
        ],
        364: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./calendars"), i = t1("../../lib"), a = t1("../../constants/numerical"), o = a.EPOCHJD, s = a.ONEDAY, l = {
                    valType: "enumerated",
                    values: i.sortObjectKeys(n.calendars),
                    editType: "calc",
                    dflt: "gregorian"
                }, c = function(t1, e1, r, n) {
                    var a = {};
                    return a[r] = l, i.coerce(t1, e1, a, r, n);
                }, u = {
                    d: {
                        0: "dd",
                        "-": "d"
                    },
                    e: {
                        0: "d",
                        "-": "d"
                    },
                    a: {
                        0: "D",
                        "-": "D"
                    },
                    A: {
                        0: "DD",
                        "-": "DD"
                    },
                    j: {
                        0: "oo",
                        "-": "o"
                    },
                    W: {
                        0: "ww",
                        "-": "w"
                    },
                    m: {
                        0: "mm",
                        "-": "m"
                    },
                    b: {
                        0: "M",
                        "-": "M"
                    },
                    B: {
                        0: "MM",
                        "-": "MM"
                    },
                    y: {
                        0: "yy",
                        "-": "yy"
                    },
                    Y: {
                        0: "yyyy",
                        "-": "yyyy"
                    },
                    U: "##",
                    w: "##",
                    c: {
                        0: "D M d %X yyyy",
                        "-": "D M d %X yyyy"
                    },
                    x: {
                        0: "mm/dd/yyyy",
                        "-": "mm/dd/yyyy"
                    }
                };
                var f = {};
                function h(t1) {
                    var e1 = f[t1];
                    return e1 || (e1 = f[t1] = n.instance(t1));
                }
                function p(t1) {
                    return i.extendFlat({}, l, {
                        description: t1
                    });
                }
                function d(t1) {
                    return "Sets the calendar system to use with `" + t1 + "` date data.";
                }
                var m = {
                    xcalendar: p(d("x"))
                }, g = i.extendFlat({}, m, {
                    ycalendar: p(d("y"))
                }), v = i.extendFlat({}, g, {
                    zcalendar: p(d("z"))
                }), y = p([
                    "Sets the calendar system to use for `range` and `tick0`",
                    "if this is a date axis. This does not set the calendar for",
                    "interpreting data on this axis, that's specified in the trace",
                    "or via the global `layout.calendar`"
                ].join(" "));
                e1.exports = {
                    moduleType: "component",
                    name: "calendars",
                    schema: {
                        traces: {
                            scatter: g,
                            bar: g,
                            box: g,
                            heatmap: g,
                            contour: g,
                            histogram: g,
                            histogram2d: g,
                            histogram2dcontour: g,
                            scatter3d: v,
                            surface: v,
                            mesh3d: v,
                            scattergl: g,
                            ohlc: m,
                            candlestick: m
                        },
                        layout: {
                            calendar: p([
                                "Sets the default calendar system to use for interpreting and",
                                "displaying dates throughout the plot."
                            ].join(" "))
                        },
                        subplots: {
                            xaxis: {
                                calendar: y
                            },
                            yaxis: {
                                calendar: y
                            },
                            scene: {
                                xaxis: {
                                    calendar: y
                                },
                                yaxis: {
                                    calendar: y
                                },
                                zaxis: {
                                    calendar: y
                                }
                            },
                            polar: {
                                radialaxis: {
                                    calendar: y
                                }
                            }
                        },
                        transforms: {
                            filter: {
                                valuecalendar: p([
                                    "WARNING: All transforms are deprecated and may be removed from the API in next major version.",
                                    "Sets the calendar system to use for `value`, if it is a date."
                                ].join(" ")),
                                targetcalendar: p([
                                    "WARNING: All transforms are deprecated and may be removed from the API in next major version.",
                                    "Sets the calendar system to use for `target`, if it is an",
                                    "array of dates. If `target` is a string (eg *x*) we use the",
                                    "corresponding trace attribute (eg `xcalendar`) if it exists,",
                                    "even if `targetcalendar` is provided."
                                ].join(" "))
                            }
                        }
                    },
                    layoutAttributes: l,
                    handleDefaults: c,
                    handleTraceDefaults: function(t1, e1, r, n) {
                        for(var i = 0; i < r.length; i++)c(t1, e1, r[i] + "calendar", n.calendar);
                    },
                    CANONICAL_SUNDAY: {
                        chinese: "2000-01-02",
                        coptic: "2000-01-03",
                        discworld: "2000-01-03",
                        ethiopian: "2000-01-05",
                        hebrew: "5000-01-01",
                        islamic: "1000-01-02",
                        julian: "2000-01-03",
                        mayan: "5000-01-01",
                        nanakshahi: "1000-01-05",
                        nepali: "2000-01-05",
                        persian: "1000-01-01",
                        jalali: "1000-01-01",
                        taiwan: "1000-01-04",
                        thai: "2000-01-04",
                        ummalqura: "1400-01-06"
                    },
                    CANONICAL_TICK: {
                        chinese: "2000-01-01",
                        coptic: "2000-01-01",
                        discworld: "2000-01-01",
                        ethiopian: "2000-01-01",
                        hebrew: "5000-01-01",
                        islamic: "1000-01-01",
                        julian: "2000-01-01",
                        mayan: "5000-01-01",
                        nanakshahi: "1000-01-01",
                        nepali: "2000-01-01",
                        persian: "1000-01-01",
                        jalali: "1000-01-01",
                        taiwan: "1000-01-01",
                        thai: "2000-01-01",
                        ummalqura: "1400-01-01"
                    },
                    DFLTRANGE: {
                        chinese: [
                            "2000-01-01",
                            "2001-01-01"
                        ],
                        coptic: [
                            "1700-01-01",
                            "1701-01-01"
                        ],
                        discworld: [
                            "1800-01-01",
                            "1801-01-01"
                        ],
                        ethiopian: [
                            "2000-01-01",
                            "2001-01-01"
                        ],
                        hebrew: [
                            "5700-01-01",
                            "5701-01-01"
                        ],
                        islamic: [
                            "1400-01-01",
                            "1401-01-01"
                        ],
                        julian: [
                            "2000-01-01",
                            "2001-01-01"
                        ],
                        mayan: [
                            "5200-01-01",
                            "5201-01-01"
                        ],
                        nanakshahi: [
                            "0500-01-01",
                            "0501-01-01"
                        ],
                        nepali: [
                            "2000-01-01",
                            "2001-01-01"
                        ],
                        persian: [
                            "1400-01-01",
                            "1401-01-01"
                        ],
                        jalali: [
                            "1400-01-01",
                            "1401-01-01"
                        ],
                        taiwan: [
                            "0100-01-01",
                            "0101-01-01"
                        ],
                        thai: [
                            "2500-01-01",
                            "2501-01-01"
                        ],
                        ummalqura: [
                            "1400-01-01",
                            "1401-01-01"
                        ]
                    },
                    getCal: h,
                    worldCalFmt: function(t1, e1, r) {
                        for(var n, i, a, l, c, f = Math.floor((e1 + .05) / s) + o, p = h(r).fromJD(f), d = 0; -1 !== (d = t1.indexOf("%", d));)"0" === (n = t1.charAt(d + 1)) || "-" === n || "_" === n ? (a = 3, i = t1.charAt(d + 2), "_" === n && (n = "-")) : (i = n, n = "0", a = 2), (l = u[i]) ? (c = "##" === l ? "##" : p.formatDate(l[n]), t1 = t1.substr(0, d) + c + t1.substr(d + a), d += c.length) : d += a;
                        return t1;
                    }
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "./calendars": 363
            }
        ],
        365: [
            function(t1, e1, r) {
                "use strict";
                r.defaults = [
                    "#1f77b4",
                    "#ff7f0e",
                    "#2ca02c",
                    "#d62728",
                    "#9467bd",
                    "#8c564b",
                    "#e377c2",
                    "#7f7f7f",
                    "#bcbd22",
                    "#17becf"
                ], r.defaultLine = "#444", r.lightLine = "#eee", r.background = "#fff", r.borderLine = "#BEC8D9", r.lightFraction = 1e3 / 11;
            },
            {}
        ],
        366: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("tinycolor2"), i = t1("fast-isnumeric"), a = t1("../../lib/array").isTypedArray, o = e1.exports = {}, s = t1("./attributes");
                o.defaults = s.defaults;
                var l = o.defaultLine = s.defaultLine;
                o.lightLine = s.lightLine;
                var c = o.background = s.background;
                function u(t1) {
                    if (i(t1) || "string" != typeof t1) return t1;
                    var e1 = t1.trim();
                    if ("rgb" !== e1.substr(0, 3)) return t1;
                    var r = e1.match(/^rgba?\s*\(([^()]*)\)$/);
                    if (!r) return t1;
                    var n = r[1].trim().split(/\s*[\s,]\s*/), a = "a" === e1.charAt(3) && 4 === n.length;
                    if (!a && 3 !== n.length) return t1;
                    for(var o = 0; o < n.length; o++){
                        if (!n[o].length) return t1;
                        if (n[o] = Number(n[o]), !(n[o] >= 0)) return t1;
                        if (3 === o) n[o] > 1 && (n[o] = 1);
                        else if (n[o] >= 1) return t1;
                    }
                    var s = Math.round(255 * n[0]) + ", " + Math.round(255 * n[1]) + ", " + Math.round(255 * n[2]);
                    return a ? "rgba(" + s + ", " + n[3] + ")" : "rgb(" + s + ")";
                }
                o.tinyRGB = function(t1) {
                    var e1 = t1.toRgb();
                    return "rgb(" + Math.round(e1.r) + ", " + Math.round(e1.g) + ", " + Math.round(e1.b) + ")";
                }, o.rgb = function(t1) {
                    return o.tinyRGB(n(t1));
                }, o.opacity = function(t1) {
                    return t1 ? n(t1).getAlpha() : 0;
                }, o.addOpacity = function(t1, e1) {
                    var r = n(t1).toRgb();
                    return "rgba(" + Math.round(r.r) + ", " + Math.round(r.g) + ", " + Math.round(r.b) + ", " + e1 + ")";
                }, o.combine = function(t1, e1) {
                    var r = n(t1).toRgb();
                    if (1 === r.a) return n(t1).toRgbString();
                    var i = n(e1 || c).toRgb(), a = 1 === i.a ? i : {
                        r: 255 * (1 - i.a) + i.r * i.a,
                        g: 255 * (1 - i.a) + i.g * i.a,
                        b: 255 * (1 - i.a) + i.b * i.a
                    }, o = {
                        r: a.r * (1 - r.a) + r.r * r.a,
                        g: a.g * (1 - r.a) + r.g * r.a,
                        b: a.b * (1 - r.a) + r.b * r.a
                    };
                    return n(o).toRgbString();
                }, o.contrast = function(t1, e1, r) {
                    var i = n(t1);
                    return 1 !== i.getAlpha() && (i = n(o.combine(t1, c))), (i.isDark() ? e1 ? i.lighten(e1) : c : r ? i.darken(r) : l).toString();
                }, o.stroke = function(t1, e1) {
                    var r = n(e1);
                    t1.style({
                        stroke: o.tinyRGB(r),
                        "stroke-opacity": r.getAlpha()
                    });
                }, o.fill = function(t1, e1) {
                    var r = n(e1);
                    t1.style({
                        fill: o.tinyRGB(r),
                        "fill-opacity": r.getAlpha()
                    });
                }, o.clean = function(t1) {
                    if (t1 && "object" == typeof t1) {
                        var e1, r, n, i, s = Object.keys(t1);
                        for(e1 = 0; e1 < s.length; e1++)if (i = t1[n = s[e1]], "color" === n.substr(n.length - 5)) {
                            if (Array.isArray(i)) for(r = 0; r < i.length; r++)i[r] = u(i[r]);
                            else t1[n] = u(i);
                        } else if ("colorscale" === n.substr(n.length - 10) && Array.isArray(i)) for(r = 0; r < i.length; r++)Array.isArray(i[r]) && (i[r][1] = u(i[r][1]));
                        else if (Array.isArray(i)) {
                            var l = i[0];
                            if (!Array.isArray(l) && l && "object" == typeof l) for(r = 0; r < i.length; r++)o.clean(i[r]);
                        } else i && "object" == typeof i && !a(i) && o.clean(i);
                    }
                };
            },
            {
                "../../lib/array": 485,
                "./attributes": 365,
                "fast-isnumeric": 190,
                tinycolor2: 312
            }
        ],
        367: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/layout_attributes"), i = t1("../../plots/font_attributes"), a = t1("../../lib/extend").extendFlat, o = t1("../../plot_api/edit_types").overrideAll;
                e1.exports = o({
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "h",
                            "v"
                        ],
                        dflt: "v"
                    },
                    thicknessmode: {
                        valType: "enumerated",
                        values: [
                            "fraction",
                            "pixels"
                        ],
                        dflt: "pixels"
                    },
                    thickness: {
                        valType: "number",
                        min: 0,
                        dflt: 30
                    },
                    lenmode: {
                        valType: "enumerated",
                        values: [
                            "fraction",
                            "pixels"
                        ],
                        dflt: "fraction"
                    },
                    len: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    x: {
                        valType: "number",
                        min: -2,
                        max: 3
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ]
                    },
                    xpad: {
                        valType: "number",
                        min: 0,
                        dflt: 10
                    },
                    y: {
                        valType: "number",
                        min: -2,
                        max: 3
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ]
                    },
                    ypad: {
                        valType: "number",
                        min: 0,
                        dflt: 10
                    },
                    outlinecolor: n.linecolor,
                    outlinewidth: n.linewidth,
                    bordercolor: n.linecolor,
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 0
                    },
                    bgcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)"
                    },
                    tickmode: n.tickmode,
                    nticks: n.nticks,
                    tick0: n.tick0,
                    dtick: n.dtick,
                    tickvals: n.tickvals,
                    ticktext: n.ticktext,
                    ticks: a({}, n.ticks, {
                        dflt: ""
                    }),
                    ticklabeloverflow: a({}, n.ticklabeloverflow, {}),
                    ticklabelposition: {
                        valType: "enumerated",
                        values: [
                            "outside",
                            "inside",
                            "outside top",
                            "inside top",
                            "outside left",
                            "inside left",
                            "outside right",
                            "inside right",
                            "outside bottom",
                            "inside bottom"
                        ],
                        dflt: "outside"
                    },
                    ticklen: n.ticklen,
                    tickwidth: n.tickwidth,
                    tickcolor: n.tickcolor,
                    showticklabels: n.showticklabels,
                    tickfont: i({}),
                    tickangle: n.tickangle,
                    tickformat: n.tickformat,
                    tickformatstops: n.tickformatstops,
                    tickprefix: n.tickprefix,
                    showtickprefix: n.showtickprefix,
                    ticksuffix: n.ticksuffix,
                    showticksuffix: n.showticksuffix,
                    separatethousands: n.separatethousands,
                    exponentformat: n.exponentformat,
                    minexponent: n.minexponent,
                    showexponent: n.showexponent,
                    title: {
                        text: {
                            valType: "string"
                        },
                        font: i({}),
                        side: {
                            valType: "enumerated",
                            values: [
                                "right",
                                "top",
                                "bottom"
                            ]
                        }
                    },
                    _deprecated: {
                        title: {
                            valType: "string"
                        },
                        titlefont: i({}),
                        titleside: {
                            valType: "enumerated",
                            values: [
                                "right",
                                "top",
                                "bottom"
                            ],
                            dflt: "top"
                        }
                    }
                }, "colorbars", "from-root");
            },
            {
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../../plots/cartesian/layout_attributes": 569,
                "../../plots/font_attributes": 585
            }
        ],
        368: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    cn: {
                        colorbar: "colorbar",
                        cbbg: "cbbg",
                        cbfill: "cbfill",
                        cbfills: "cbfills",
                        cbline: "cbline",
                        cblines: "cblines",
                        cbaxis: "cbaxis",
                        cbtitleunshift: "cbtitleunshift",
                        cbtitle: "cbtitle",
                        cboutline: "cboutline",
                        crisp: "crisp",
                        jsPlaceholder: "js-placeholder"
                    }
                };
            },
            {}
        ],
        369: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plot_api/plot_template"), a = t1("../../plots/cartesian/tick_value_defaults"), o = t1("../../plots/cartesian/tick_mark_defaults"), s = t1("../../plots/cartesian/tick_label_defaults"), l = t1("../../plots/cartesian/prefix_suffix_defaults"), c = t1("./attributes");
                e1.exports = function(t1, e1, r) {
                    var u = i.newContainer(e1, "colorbar"), f = t1.colorbar || {};
                    function h(t1, e1) {
                        return n.coerce(f, u, c, t1, e1);
                    }
                    var p = r.margin || {
                        t: 0,
                        b: 0,
                        l: 0,
                        r: 0
                    }, d = r.width - p.l - p.r, m = r.height - p.t - p.b, g = "v" === h("orientation"), v = h("thicknessmode");
                    h("thickness", "fraction" === v ? 30 / (g ? d : m) : 30);
                    var y = h("lenmode");
                    h("len", "fraction" === y ? 1 : g ? m : d), h("x", g ? 1.02 : .5), h("xanchor", g ? "left" : "center"), h("xpad"), h("y", g ? .5 : 1.02), h("yanchor", g ? "middle" : "bottom"), h("ypad"), n.noneOrAll(f, u, [
                        "x",
                        "y"
                    ]), h("outlinecolor"), h("outlinewidth"), h("bordercolor"), h("borderwidth"), h("bgcolor");
                    var x = n.coerce(f, u, {
                        ticklabelposition: {
                            valType: "enumerated",
                            dflt: "outside",
                            values: g ? [
                                "outside",
                                "inside",
                                "outside top",
                                "inside top",
                                "outside bottom",
                                "inside bottom"
                            ] : [
                                "outside",
                                "inside",
                                "outside left",
                                "inside left",
                                "outside right",
                                "inside right"
                            ]
                        }
                    }, "ticklabelposition");
                    h("ticklabeloverflow", -1 !== x.indexOf("inside") ? "hide past domain" : "hide past div"), a(f, u, h, "linear");
                    var b = r.font, _ = {
                        outerTicks: !1,
                        font: b
                    };
                    -1 !== x.indexOf("inside") && (_.bgColor = "black"), l(f, u, h, "linear", _), s(f, u, h, "linear", _), o(f, u, h, "linear", _), h("title.text", r._dfltTitle.colorbar);
                    var w = u.tickfont, T = n.extendFlat({}, w, {
                        color: b.color,
                        size: n.bigFont(w.size)
                    });
                    n.coerceFont(h, "title.font", T), h("title.side", g ? "top" : "right");
                };
            },
            {
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../../plots/cartesian/prefix_suffix_defaults": 573,
                "../../plots/cartesian/tick_label_defaults": 578,
                "../../plots/cartesian/tick_mark_defaults": 579,
                "../../plots/cartesian/tick_value_defaults": 580,
                "./attributes": 367
            }
        ],
        370: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("tinycolor2"), a = t1("../../plots/plots"), o = t1("../../registry"), s = t1("../../plots/cartesian/axes"), l = t1("../dragelement"), c = t1("../../lib"), u = c.strTranslate, f = t1("../../lib/extend").extendFlat, h = t1("../../lib/setcursor"), p = t1("../drawing"), d = t1("../color"), m = t1("../titles"), g = t1("../../lib/svg_text_utils"), v = t1("../colorscale/helpers").flipScale, y = t1("../../plots/cartesian/axis_defaults"), x = t1("../../plots/cartesian/position_defaults"), b = t1("../../plots/cartesian/layout_attributes"), _ = t1("../../constants/alignment"), w = _.LINE_SPACING, T = _.FROM_TL, k = _.FROM_BR, A = t1("./constants").cn;
                e1.exports = {
                    draw: function(t1) {
                        var e1 = t1._fullLayout._infolayer.selectAll("g." + A.colorbar).data(function(t1) {
                            var e1, r, n, i, a = t1._fullLayout, o = t1.calcdata, s = [];
                            function l(t1) {
                                return f(t1, {
                                    _fillcolor: null,
                                    _line: {
                                        color: null,
                                        width: null,
                                        dash: null
                                    },
                                    _levels: {
                                        start: null,
                                        end: null,
                                        size: null
                                    },
                                    _filllevels: null,
                                    _fillgradient: null,
                                    _zrange: null
                                });
                            }
                            function c() {
                                "function" == typeof i.calc ? i.calc(t1, n, e1) : (e1._fillgradient = r.reversescale ? v(r.colorscale) : r.colorscale, e1._zrange = [
                                    r[i.min],
                                    r[i.max]
                                ]);
                            }
                            for(var u = 0; u < o.length; u++){
                                var h = o[u], p = (n = h[0].trace)._module.colorbar;
                                if (!0 === n.visible && p) for(var d = Array.isArray(p), m = d ? p : [
                                    p
                                ], g = 0; g < m.length; g++){
                                    var y = (i = m[g]).container;
                                    (r = y ? n[y] : n) && r.showscale && ((e1 = l(r.colorbar))._id = "cb" + n.uid + (d && y ? "-" + y : ""), e1._traceIndex = n.index, e1._propPrefix = (y ? y + "." : "") + "colorbar.", e1._meta = n._meta, c(), s.push(e1));
                                }
                            }
                            for(var x in a._colorAxes)if ((r = a[x]).showscale) {
                                var b = a._colorAxes[x];
                                (e1 = l(r.colorbar))._id = "cb" + x, e1._propPrefix = x + ".colorbar.", e1._meta = a._meta, i = {
                                    min: "cmin",
                                    max: "cmax"
                                }, "heatmap" !== b[0] && (n = b[1], i.calc = n._module.colorbar.calc), c(), s.push(e1);
                            }
                            return s;
                        }(t1), function(t1) {
                            return t1._id;
                        });
                        e1.enter().append("g").attr("class", function(t1) {
                            return t1._id;
                        }).classed(A.colorbar, !0), e1.each(function(e1) {
                            var r = n.select(this);
                            c.ensureSingle(r, "rect", A.cbbg), c.ensureSingle(r, "g", A.cbfills), c.ensureSingle(r, "g", A.cblines), c.ensureSingle(r, "g", A.cbaxis, function(t1) {
                                t1.classed(A.crisp, !0);
                            }), c.ensureSingle(r, "g", A.cbtitleunshift, function(t1) {
                                t1.append("g").classed(A.cbtitle, !0);
                            }), c.ensureSingle(r, "rect", A.cboutline);
                            var v = function(t1, e1, r) {
                                var o = "v" === e1.orientation, l = e1.len, h = e1.lenmode, v = e1.thickness, _ = e1.thicknessmode, M = e1.outlinewidth, S = e1.borderwidth, E = e1.bgcolor, L = e1.xanchor, C = e1.yanchor, P = e1.xpad, I = e1.ypad, O = e1.x, z = o ? e1.y : 1 - e1.y, D = r._fullLayout, R = D._size, F = e1._fillcolor, B = e1._line, N = e1.title, j = N.side, U = e1._zrange || n.extent(("function" == typeof F ? F : B.color).domain()), V = "function" == typeof B.color ? B.color : function() {
                                    return B.color;
                                }, H = "function" == typeof F ? F : function() {
                                    return F;
                                }, q = e1._levels, G = function(t1, e1, r) {
                                    var n, i, a = e1._levels, o = [], s = [], l = a.end + a.size / 100, c = a.size, u = 1.001 * r[0] - .001 * r[1], f = 1.001 * r[1] - .001 * r[0];
                                    for(i = 0; i < 1e5 && (n = a.start + i * c, !(c > 0 ? n >= l : n <= l)); i++)n > u && n < f && o.push(n);
                                    if (e1._fillgradient) s = [
                                        0
                                    ];
                                    else if ("function" == typeof e1._fillcolor) {
                                        var h = e1._filllevels;
                                        if (h) for(l = h.end + h.size / 100, c = h.size, i = 0; i < 1e5 && (n = h.start + i * c, !(c > 0 ? n >= l : n <= l)); i++)n > r[0] && n < r[1] && s.push(n);
                                        else (s = o.map(function(t1) {
                                            return t1 - a.size / 2;
                                        })).push(s[s.length - 1] + a.size);
                                    } else e1._fillcolor && "string" == typeof e1._fillcolor && (s = [
                                        0
                                    ]);
                                    a.size < 0 && (o.reverse(), s.reverse());
                                    return {
                                        line: o,
                                        fill: s
                                    };
                                }(0, e1, U), Y = G.fill, W = G.line, X = Math.round(v * ("fraction" === _ ? o ? R.w : R.h : 1)), Z = X / (o ? R.w : R.h), J = Math.round(l * ("fraction" === h ? o ? R.h : R.w : 1)), K = J / (o ? R.h : R.w), Q = Math.round(o ? O * R.w + P : z * R.h + I), $ = {
                                    center: .5,
                                    right: 1
                                }[L] || 0, tt = {
                                    top: 1,
                                    middle: .5
                                }[C] || 0, et = o ? O - $ * Z : z - tt * Z, rt = o ? z - tt * K : O - $ * K, nt = Math.round(o ? R.h * (1 - rt) : R.w * rt);
                                e1._lenFrac = K, e1._thickFrac = Z, e1._uFrac = et, e1._vFrac = rt;
                                var it = e1._axis = function(t1, e1, r) {
                                    var n = t1._fullLayout, i = "v" === e1.orientation, a = {
                                        type: "linear",
                                        range: r,
                                        tickmode: e1.tickmode,
                                        nticks: e1.nticks,
                                        tick0: e1.tick0,
                                        dtick: e1.dtick,
                                        tickvals: e1.tickvals,
                                        ticktext: e1.ticktext,
                                        ticks: e1.ticks,
                                        ticklen: e1.ticklen,
                                        tickwidth: e1.tickwidth,
                                        tickcolor: e1.tickcolor,
                                        showticklabels: e1.showticklabels,
                                        ticklabelposition: e1.ticklabelposition,
                                        ticklabeloverflow: e1.ticklabeloverflow,
                                        tickfont: e1.tickfont,
                                        tickangle: e1.tickangle,
                                        tickformat: e1.tickformat,
                                        exponentformat: e1.exponentformat,
                                        minexponent: e1.minexponent,
                                        separatethousands: e1.separatethousands,
                                        showexponent: e1.showexponent,
                                        showtickprefix: e1.showtickprefix,
                                        tickprefix: e1.tickprefix,
                                        showticksuffix: e1.showticksuffix,
                                        ticksuffix: e1.ticksuffix,
                                        title: e1.title,
                                        showline: !0,
                                        anchor: "free",
                                        side: i ? "right" : "bottom",
                                        position: 1
                                    }, o = i ? "y" : "x", s = {
                                        type: "linear",
                                        _id: o + e1._id
                                    }, l = {
                                        letter: o,
                                        font: n.font,
                                        noHover: !0,
                                        noTickson: !0,
                                        noTicklabelmode: !0,
                                        calendar: n.calendar
                                    };
                                    function u(t1, e1) {
                                        return c.coerce(a, s, b, t1, e1);
                                    }
                                    return y(a, s, u, l, n), x(a, s, u, l), s;
                                }(r, e1, U);
                                it.position = Z + (o ? O + P / R.w : z + I / R.h);
                                var at = -1 !== [
                                    "top",
                                    "bottom"
                                ].indexOf(j);
                                o && at && (it.title.side = j, it.titlex = O + P / R.w, it.titley = rt + ("top" === N.side ? K - I / R.h : I / R.h));
                                o || at || (it.title.side = j, it.titley = z + I / R.h, it.titlex = rt + P / R.w);
                                if (B.color && "auto" === e1.tickmode) {
                                    it.tickmode = "linear", it.tick0 = q.start;
                                    var ot = q.size, st = c.constrain(J / 50, 4, 15) + 1, lt = (U[1] - U[0]) / ((e1.nticks || st) * ot);
                                    if (lt > 1) {
                                        var ct = Math.pow(10, Math.floor(Math.log(lt) / Math.LN10));
                                        ot *= ct * c.roundUp(lt / ct, [
                                            2,
                                            5,
                                            10
                                        ]), (Math.abs(q.start) / q.size + 1e-6) % 1 < 2e-6 && (it.tick0 = 0);
                                    }
                                    it.dtick = ot;
                                }
                                it.domain = o ? [
                                    rt + I / R.h,
                                    rt + K - I / R.h
                                ] : [
                                    rt + P / R.w,
                                    rt + K - P / R.w
                                ], it.setScale(), t1.attr("transform", u(Math.round(R.l), Math.round(R.t)));
                                var ut, ft = t1.select("." + A.cbtitleunshift).attr("transform", u(-Math.round(R.l), -Math.round(R.t))), ht = it.ticklabelposition, pt = it.title.font.size, dt = t1.select("." + A.cbaxis), mt = 0, gt = 0;
                                function vt(n, i) {
                                    var a = {
                                        propContainer: it,
                                        propName: e1._propPrefix + "title",
                                        traceIndex: e1._traceIndex,
                                        _meta: e1._meta,
                                        placeholder: D._dfltTitle.colorbar,
                                        containerGroup: t1.select("." + A.cbtitle)
                                    }, o = "h" === n.charAt(0) ? n.substr(1) : "h" + n;
                                    t1.selectAll("." + o + ",." + o + "-math-group").remove(), m.draw(r, n, f(a, i || {}));
                                }
                                return c.syncOrAsync([
                                    a.previousPromises,
                                    function() {
                                        var t1, e1;
                                        (o && at || !o && !at) && ("top" === j && (t1 = P + R.l + R.w * O, e1 = I + R.t + R.h * (1 - rt - K) + 3 + .75 * pt), "bottom" === j && (t1 = P + R.l + R.w * O, e1 = I + R.t + R.h * (1 - rt) - 3 - .25 * pt), "right" === j && (e1 = I + R.t + R.h * z + 3 + .75 * pt, t1 = P + R.l + R.w * rt), vt(it._id + "title", {
                                            attributes: {
                                                x: t1,
                                                y: e1,
                                                "text-anchor": o ? "start" : "middle"
                                            }
                                        }));
                                    },
                                    function() {
                                        if (!o && !at || o && at) {
                                            var a, l = t1.select("." + A.cbtitle), f = l.select("text"), h = [
                                                -M / 2,
                                                M / 2
                                            ], d = l.select(".h" + it._id + "title-math-group").node(), m = 15.6;
                                            if (f.node() && (m = parseInt(f.node().style.fontSize, 10) * w), d ? (a = p.bBox(d), gt = a.width, (mt = a.height) > m && (h[1] -= (mt - m) / 2)) : f.node() && !f.classed(A.jsPlaceholder) && (a = p.bBox(f.node()), gt = a.width, mt = a.height), o) {
                                                if (mt) {
                                                    if (mt += 5, "top" === j) it.domain[1] -= mt / R.h, h[1] *= -1;
                                                    else {
                                                        it.domain[0] += mt / R.h;
                                                        var v = g.lineCount(f);
                                                        h[1] += (1 - v) * m;
                                                    }
                                                    l.attr("transform", u(h[0], h[1])), it.setScale();
                                                }
                                            } else gt && ("right" === j && (it.domain[0] += (gt + pt / 2) / R.w), l.attr("transform", u(h[0], h[1])), it.setScale());
                                        }
                                        t1.selectAll("." + A.cbfills + ",." + A.cblines).attr("transform", o ? u(0, Math.round(R.h * (1 - it.domain[1]))) : u(Math.round(R.w * it.domain[0]), 0)), dt.attr("transform", o ? u(0, Math.round(-R.t)) : u(Math.round(-R.l), 0));
                                        var y = t1.select("." + A.cbfills).selectAll("rect." + A.cbfill).attr("style", "").data(Y);
                                        y.enter().append("rect").classed(A.cbfill, !0).style("stroke", "none"), y.exit().remove();
                                        var x = U.map(it.c2p).map(Math.round).sort(function(t1, e1) {
                                            return t1 - e1;
                                        });
                                        y.each(function(t1, a) {
                                            var s = [
                                                0 === a ? U[0] : (Y[a] + Y[a - 1]) / 2,
                                                a === Y.length - 1 ? U[1] : (Y[a] + Y[a + 1]) / 2
                                            ].map(it.c2p).map(Math.round);
                                            o && (s[1] = c.constrain(s[1] + (s[1] > s[0]) ? 1 : -1, x[0], x[1]));
                                            var l = n.select(this).attr(o ? "x" : "y", Q).attr(o ? "y" : "x", n.min(s)).attr(o ? "width" : "height", Math.max(X, 2)).attr(o ? "height" : "width", Math.max(n.max(s) - n.min(s), 2));
                                            if (e1._fillgradient) p.gradient(l, r, e1._id, o ? "vertical" : "horizontalreversed", e1._fillgradient, "fill");
                                            else {
                                                var u = H(t1).replace("e-", "");
                                                l.attr("fill", i(u).toHexString());
                                            }
                                        });
                                        var b = t1.select("." + A.cblines).selectAll("path." + A.cbline).data(B.color && B.width ? W : []);
                                        b.enter().append("path").classed(A.cbline, !0), b.exit().remove(), b.each(function(t1) {
                                            var e1 = Q, r = Math.round(it.c2p(t1)) + B.width / 2 % 1;
                                            n.select(this).attr("d", "M" + (o ? e1 + "," + r : r + "," + e1) + (o ? "h" : "v") + X).call(p.lineGroupStyle, B.width, V(t1), B.dash);
                                        }), dt.selectAll("g." + it._id + "tick,path").remove();
                                        var _ = Q + X + (M || 0) / 2 - ("outside" === e1.ticks ? 1 : 0), T = s.calcTicks(it), k = s.getTickSigns(it)[2];
                                        return s.drawTicks(r, it, {
                                            vals: "inside" === it.ticks ? s.clipEnds(it, T) : T,
                                            layer: dt,
                                            path: s.makeTickPath(it, _, k),
                                            transFn: s.makeTransTickFn(it)
                                        }), s.drawLabels(r, it, {
                                            vals: T,
                                            layer: dt,
                                            transFn: s.makeTransTickLabelFn(it),
                                            labelFns: s.makeLabelFns(it, _)
                                        });
                                    },
                                    function() {
                                        if (o && !at || !o && at) {
                                            var t1, i, a = it.position || 0, s = it._offset + it._length / 2;
                                            if ("right" === j) i = s, t1 = R.l + R.w * a + 10 + pt * (it.showticklabels ? 1 : .5);
                                            else if (t1 = s, "bottom" === j && (i = R.t + R.h * a + 10 + (-1 === ht.indexOf("inside") ? it.tickfont.size : 0) + ("intside" !== it.ticks && e1.ticklen || 0)), "top" === j) {
                                                var l = N.text.split("<br>").length;
                                                i = R.t + R.h * a + 10 - X - w * pt * l;
                                            }
                                            vt((o ? "h" : "v") + it._id + "title", {
                                                avoid: {
                                                    selection: n.select(r).selectAll("g." + it._id + "tick"),
                                                    side: j,
                                                    offsetTop: o ? 0 : R.t,
                                                    offsetLeft: o ? R.l : 0,
                                                    maxShift: o ? D.width : D.height
                                                },
                                                attributes: {
                                                    x: t1,
                                                    y: i,
                                                    "text-anchor": "middle"
                                                },
                                                transform: {
                                                    rotate: o ? -90 : 0,
                                                    offset: 0
                                                }
                                            });
                                        }
                                    },
                                    a.previousPromises,
                                    function() {
                                        var n, s = X + M / 2;
                                        -1 === ht.indexOf("inside") && (n = p.bBox(dt.node()), s += o ? n.width : n.height), ut = ft.select("text");
                                        var c = 0, f = o && "top" === j, m = !o && "right" === j, g = 0;
                                        if (ut.node() && !ut.classed(A.jsPlaceholder)) {
                                            var y, x = ft.select(".h" + it._id + "title-math-group").node();
                                            x && (o && at || !o && !at) ? (c = (n = p.bBox(x)).width, y = n.height) : (c = (n = p.bBox(ft.node())).right - R.l - (o ? Q : nt), y = n.bottom - R.t - (o ? nt : Q), o || "top" !== j || (s += n.height, g = n.height)), m && (ut.attr("transform", u(c / 2 + pt / 2, 0)), c *= 2), s = Math.max(s, o ? c : y);
                                        }
                                        var b = 2 * (o ? P : I) + s + S + M / 2, w = 0;
                                        !o && N.text && "bottom" === C && z <= 0 && (b += w = b / 2, g += w), D._hColorbarMoveTitle = w, D._hColorbarMoveCBTitle = g;
                                        var F = S + M;
                                        t1.select("." + A.cbbg).attr("x", (o ? Q : nt) - F / 2 - (o ? P : 0)).attr("y", (o ? nt : Q) - (o ? J : I + g - w)).attr(o ? "width" : "height", Math.max(b - w, 2)).attr(o ? "height" : "width", Math.max(J + F, 2)).call(d.fill, E).call(d.stroke, e1.bordercolor).style("stroke-width", S);
                                        var B = m ? Math.max(c - 10, 0) : 0;
                                        if (t1.selectAll("." + A.cboutline).attr("x", (o ? Q : nt + P) + B).attr("y", (o ? nt + I - J : Q) + (f ? mt : 0)).attr(o ? "width" : "height", Math.max(X, 2)).attr(o ? "height" : "width", Math.max(J - (o ? 2 * I + mt : 2 * P + B), 2)).call(d.stroke, e1.outlinecolor).style({
                                            fill: "none",
                                            "stroke-width": M
                                        }), t1.attr("transform", u(R.l - (o ? $ * b : 0), R.t - (o ? 0 : (1 - tt) * b - g))), !o && (S || i(E).getAlpha() && !i.equals(D.paper_bgcolor, E))) {
                                            var U = dt.selectAll("text"), V = U[0].length, H = t1.select("." + A.cbbg).node(), q = p.bBox(H), G = p.getTranslate(t1);
                                            U.each(function(t1, e1) {
                                                var r = V - 1;
                                                if (0 === e1 || e1 === r) {
                                                    var n, i = p.bBox(this), a = p.getTranslate(this);
                                                    if (e1 === r) {
                                                        var o = i.right + a.x;
                                                        (n = q.right + G.x + nt - S - 2 + O - o) > 0 && (n = 0);
                                                    } else if (0 === e1) {
                                                        var s = i.left + a.x;
                                                        (n = q.left + G.x + nt + S + 2 - s) < 0 && (n = 0);
                                                    }
                                                    n && (V < 3 ? this.setAttribute("transform", "translate(" + n + ",0) " + this.getAttribute("transform")) : this.setAttribute("visibility", "hidden"));
                                                }
                                            });
                                        }
                                        var Y = {}, W = T[L], Z = k[L], K = T[C], et = k[C], rt = b - X;
                                        o ? ("pixels" === h ? (Y.y = z, Y.t = J * K, Y.b = J * et) : (Y.t = Y.b = 0, Y.yt = z + l * K, Y.yb = z - l * et), "pixels" === _ ? (Y.x = O, Y.l = b * W, Y.r = b * Z) : (Y.l = rt * W, Y.r = rt * Z, Y.xl = O - v * W, Y.xr = O + v * Z)) : ("pixels" === h ? (Y.x = O, Y.l = J * W, Y.r = J * Z) : (Y.l = Y.r = 0, Y.xl = O + l * W, Y.xr = O - l * Z), "pixels" === _ ? (Y.y = 1 - z, Y.t = b * K, Y.b = b * et) : (Y.t = rt * K, Y.b = rt * et, Y.yt = z - v * K, Y.yb = z + v * et)), a.autoMargin(r, e1._id, Y);
                                    }
                                ], r);
                            }(r, e1, t1);
                            v && v.then && (t1._promises || []).push(v), t1._context.edits.colorbarPosition && function(t1, e1, r) {
                                var n, i, a, s = "v" === e1.orientation, c = r._fullLayout._size;
                                l.init({
                                    element: t1.node(),
                                    gd: r,
                                    prepFn: function() {
                                        n = t1.attr("transform"), h(t1);
                                    },
                                    moveFn: function(r, o) {
                                        t1.attr("transform", n + u(r, o)), i = l.align((s ? e1._uFrac : e1._vFrac) + r / c.w, s ? e1._thickFrac : e1._lenFrac, 0, 1, e1.xanchor), a = l.align((s ? e1._vFrac : 1 - e1._uFrac) - o / c.h, s ? e1._lenFrac : e1._thickFrac, 0, 1, e1.yanchor);
                                        var f = l.getCursor(i, a, e1.xanchor, e1.yanchor);
                                        h(t1, f);
                                    },
                                    doneFn: function() {
                                        if (h(t1), void 0 !== i && void 0 !== a) {
                                            var n = {};
                                            n[e1._propPrefix + "x"] = i, n[e1._propPrefix + "y"] = a, void 0 !== e1._traceIndex ? o.call("_guiRestyle", r, n, e1._traceIndex) : o.call("_guiRelayout", r, n);
                                        }
                                    }
                                });
                            }(r, e1, t1);
                        }), e1.exit().each(function(e1) {
                            a.autoMargin(t1, e1._id);
                        }).remove(), e1.order();
                    }
                };
            },
            {
                "../../constants/alignment": 471,
                "../../lib": 503,
                "../../lib/extend": 493,
                "../../lib/setcursor": 524,
                "../../lib/svg_text_utils": 529,
                "../../plots/cartesian/axes": 554,
                "../../plots/cartesian/axis_defaults": 556,
                "../../plots/cartesian/layout_attributes": 569,
                "../../plots/cartesian/position_defaults": 572,
                "../../plots/plots": 619,
                "../../registry": 638,
                "../color": 366,
                "../colorscale/helpers": 377,
                "../dragelement": 385,
                "../drawing": 388,
                "../titles": 464,
                "./constants": 368,
                "@plotly/d3": 58,
                tinycolor2: 312
            }
        ],
        371: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = function(t1) {
                    return n.isPlainObject(t1.colorbar);
                };
            },
            {
                "../../lib": 503
            }
        ],
        372: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "component",
                    name: "colorbar",
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    draw: t1("./draw").draw,
                    hasColorbar: t1("./has_colorbar")
                };
            },
            {
                "./attributes": 367,
                "./defaults": 369,
                "./draw": 370,
                "./has_colorbar": 371
            }
        ],
        373: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../colorbar/attributes"), i = t1("../../lib/regex").counter, a = t1("../../lib/sort_object_keys"), o = t1("./scales.js").scales;
                a(o);
                function s(t1) {
                    return "`" + t1 + "`";
                }
                e1.exports = function(t1, e1) {
                    t1 = t1 || "";
                    var r, a = (e1 = e1 || {}).cLetter || "c", l = ("onlyIfNumerical" in e1 ? e1.onlyIfNumerical : Boolean(t1), "noScale" in e1 ? e1.noScale : "marker.line" === t1), c = "showScaleDflt" in e1 ? e1.showScaleDflt : "z" === a, u = "string" == typeof e1.colorscaleDflt ? o[e1.colorscaleDflt] : null, f = e1.editTypeOverride || "", h = t1 ? t1 + "." : "";
                    "colorAttr" in e1 ? (r = e1.colorAttr, e1.colorAttr) : s(h + (r = ({
                        z: "z",
                        c: "color"
                    })[a]));
                    var p = a + "auto", d = a + "min", m = a + "max", g = a + "mid", v = (s(h + p), s(h + d), s(h + m), {});
                    v[d] = v[m] = void 0;
                    var y = {};
                    y[p] = !1;
                    var x = {};
                    return "color" === r && (x.color = {
                        valType: "color",
                        arrayOk: !0,
                        editType: f || "style"
                    }, e1.anim && (x.color.anim = !0)), x[p] = {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc",
                        impliedEdits: v
                    }, x[d] = {
                        valType: "number",
                        dflt: null,
                        editType: f || "plot",
                        impliedEdits: y
                    }, x[m] = {
                        valType: "number",
                        dflt: null,
                        editType: f || "plot",
                        impliedEdits: y
                    }, x[g] = {
                        valType: "number",
                        dflt: null,
                        editType: "calc",
                        impliedEdits: v
                    }, x.colorscale = {
                        valType: "colorscale",
                        editType: "calc",
                        dflt: u,
                        impliedEdits: {
                            autocolorscale: !1
                        }
                    }, x.autocolorscale = {
                        valType: "boolean",
                        dflt: !1 !== e1.autoColorDflt,
                        editType: "calc",
                        impliedEdits: {
                            colorscale: void 0
                        }
                    }, x.reversescale = {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    }, l || (x.showscale = {
                        valType: "boolean",
                        dflt: c,
                        editType: "calc"
                    }, x.colorbar = n), e1.noColorAxis || (x.coloraxis = {
                        valType: "subplotid",
                        regex: i("coloraxis"),
                        dflt: null,
                        editType: "calc"
                    }), x;
                };
            },
            {
                "../../lib/regex": 520,
                "../../lib/sort_object_keys": 526,
                "../colorbar/attributes": 367,
                "./scales.js": 381
            }
        ],
        374: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = t1("./helpers").extractOpts;
                e1.exports = function(t1, e1, r) {
                    var o, s = t1._fullLayout, l = r.vals, c = r.containerStr, u = c ? i.nestedProperty(e1, c).get() : e1, f = a(u), h = !1 !== f.auto, p = f.min, d = f.max, m = f.mid, g = function() {
                        return i.aggNums(Math.min, null, l);
                    }, v = function() {
                        return i.aggNums(Math.max, null, l);
                    };
                    (void 0 === p ? p = g() : h && (p = u._colorAx && n(p) ? Math.min(p, g()) : g()), void 0 === d ? d = v() : h && (d = u._colorAx && n(d) ? Math.max(d, v()) : v()), h && void 0 !== m && (d - m > m - p ? p = m - (d - m) : d - m < m - p && (d = m + (m - p))), p === d && (p -= .5, d += .5), f._sync("min", p), f._sync("max", d), f.autocolorscale) && (o = p * d < 0 ? s.colorscale.diverging : p >= 0 ? s.colorscale.sequential : s.colorscale.sequentialminus, f._sync("colorscale", o));
                };
            },
            {
                "../../lib": 503,
                "./helpers": 377,
                "fast-isnumeric": 190
            }
        ],
        375: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./helpers").hasColorscale, a = t1("./helpers").extractOpts;
                e1.exports = function(t1, e1) {
                    function r(t1, e1) {
                        var r = t1["_" + e1];
                        void 0 !== r && (t1[e1] = r);
                    }
                    function o(t1, i) {
                        var o = i.container ? n.nestedProperty(t1, i.container).get() : t1;
                        if (o) {
                            if (o.coloraxis) o._colorAx = e1[o.coloraxis];
                            else {
                                var s = a(o), l = s.auto;
                                (l || void 0 === s.min) && r(o, i.min), (l || void 0 === s.max) && r(o, i.max), s.autocolorscale && r(o, "colorscale");
                            }
                        }
                    }
                    for(var s = 0; s < t1.length; s++){
                        var l = t1[s], c = l._module.colorbar;
                        if (c) {
                            if (Array.isArray(c)) for(var u = 0; u < c.length; u++)o(l, c[u]);
                            else o(l, c);
                        }
                        i(l, "marker.line") && o(l, {
                            container: "marker.line",
                            min: "cmin",
                            max: "cmax"
                        });
                    }
                    for(var f in e1._colorAxes)o(e1[f], {
                        min: "cmin",
                        max: "cmax"
                    });
                };
            },
            {
                "../../lib": 503,
                "./helpers": 377
            }
        ],
        376: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = t1("../colorbar/has_colorbar"), o = t1("../colorbar/defaults"), s = t1("./scales").isValid, l = t1("../../registry").traceIs;
                function c(t1, e1) {
                    var r = e1.slice(0, e1.length - 1);
                    return e1 ? i.nestedProperty(t1, r).get() || {} : t1;
                }
                e1.exports = function t1(e1, r, u, f, h) {
                    var p = h.prefix, d = h.cLetter, m = "_module" in r, g = c(e1, p), v = c(r, p), y = c(r._template || {}, p) || {}, x = function() {
                        return delete e1.coloraxis, delete r.coloraxis, t1(e1, r, u, f, h);
                    };
                    if (m) {
                        var b = u._colorAxes || {}, _ = f(p + "coloraxis");
                        if (_) {
                            var w = l(r, "contour") && i.nestedProperty(r, "contours.coloring").get() || "heatmap", T = b[_];
                            return void (T ? (T[2].push(x), T[0] !== w && (T[0] = !1, i.warn([
                                "Ignoring coloraxis:",
                                _,
                                "setting",
                                "as it is linked to incompatible colorscales."
                            ].join(" ")))) : b[_] = [
                                w,
                                r,
                                [
                                    x
                                ]
                            ]);
                        }
                    }
                    var k = g[d + "min"], A = g[d + "max"], M = n(k) && n(A) && k < A;
                    f(p + d + "auto", !M) ? f(p + d + "mid") : (f(p + d + "min"), f(p + d + "max"));
                    var S, E, L = g.colorscale, C = y.colorscale;
                    (void 0 !== L && (S = !s(L)), void 0 !== C && (S = !s(C)), f(p + "autocolorscale", S), f(p + "colorscale"), f(p + "reversescale"), "marker.line." !== p) && (p && m && (E = a(g)), f(p + "showscale", E) && (p && y && (v._template = y), o(g, v, u)));
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638,
                "../colorbar/defaults": 369,
                "../colorbar/has_colorbar": 371,
                "./scales": 381,
                "fast-isnumeric": 190
            }
        ],
        377: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("tinycolor2"), a = t1("fast-isnumeric"), o = t1("../../lib"), s = t1("../color"), l = t1("./scales").isValid;
                var c = [
                    "showscale",
                    "autocolorscale",
                    "colorscale",
                    "reversescale",
                    "colorbar"
                ], u = [
                    "min",
                    "max",
                    "mid",
                    "auto"
                ];
                function f(t1) {
                    var e1, r, n, i = t1._colorAx, a = i || t1, o = {};
                    for(r = 0; r < c.length; r++)o[n = c[r]] = a[n];
                    if (i) for(e1 = "c", r = 0; r < u.length; r++)o[n = u[r]] = a["c" + n];
                    else {
                        var s;
                        for(r = 0; r < u.length; r++)((s = "c" + (n = u[r])) in a || (s = "z" + n) in a) && (o[n] = a[s]);
                        e1 = s.charAt(0);
                    }
                    return o._sync = function(t1, r) {
                        var n = -1 !== u.indexOf(t1) ? e1 + t1 : t1;
                        a[n] = a["_" + n] = r;
                    }, o;
                }
                function h(t1) {
                    for(var e1 = f(t1), r = e1.min, n = e1.max, i = e1.reversescale ? p(e1.colorscale) : e1.colorscale, a = i.length, o = new Array(a), s = new Array(a), l = 0; l < a; l++){
                        var c = i[l];
                        o[l] = r + c[0] * (n - r), s[l] = c[1];
                    }
                    return {
                        domain: o,
                        range: s
                    };
                }
                function p(t1) {
                    for(var e1 = t1.length, r = new Array(e1), n = e1 - 1, i = 0; n >= 0; n--, i++){
                        var a = t1[n];
                        r[i] = [
                            1 - a[0],
                            a[1]
                        ];
                    }
                    return r;
                }
                function d(t1, e1) {
                    e1 = e1 || {};
                    for(var r = t1.domain, o = t1.range, l = o.length, c = new Array(l), u = 0; u < l; u++){
                        var f = i(o[u]).toRgb();
                        c[u] = [
                            f.r,
                            f.g,
                            f.b,
                            f.a
                        ];
                    }
                    var h, p = n.scale.linear().domain(r).range(c).clamp(!0), d = e1.noNumericCheck, g = e1.returnArray;
                    return (h = d && g ? p : d ? function(t1) {
                        return m(p(t1));
                    } : g ? function(t1) {
                        return a(t1) ? p(t1) : i(t1).isValid() ? t1 : s.defaultLine;
                    } : function(t1) {
                        return a(t1) ? m(p(t1)) : i(t1).isValid() ? t1 : s.defaultLine;
                    }).domain = p.domain, h.range = function() {
                        return o;
                    }, h;
                }
                function m(t1) {
                    var e1 = {
                        r: t1[0],
                        g: t1[1],
                        b: t1[2],
                        a: t1[3]
                    };
                    return i(e1).toRgbString();
                }
                e1.exports = {
                    hasColorscale: function(t1, e1, r) {
                        var n = e1 ? o.nestedProperty(t1, e1).get() || {} : t1, i = n[r || "color"], s = !1;
                        if (o.isArrayOrTypedArray(i)) {
                            for(var c = 0; c < i.length; c++)if (a(i[c])) {
                                s = !0;
                                break;
                            }
                        }
                        return o.isPlainObject(n) && (s || !0 === n.showscale || a(n.cmin) && a(n.cmax) || l(n.colorscale) || o.isPlainObject(n.colorbar));
                    },
                    extractOpts: f,
                    extractScale: h,
                    flipScale: p,
                    makeColorScaleFunc: d,
                    makeColorScaleFuncFromTrace: function(t1, e1) {
                        return d(h(t1), e1);
                    }
                };
            },
            {
                "../../lib": 503,
                "../color": 366,
                "./scales": 381,
                "@plotly/d3": 58,
                "fast-isnumeric": 190,
                tinycolor2: 312
            }
        ],
        378: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./scales"), i = t1("./helpers");
                e1.exports = {
                    moduleType: "component",
                    name: "colorscale",
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("./layout_attributes"),
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    handleDefaults: t1("./defaults"),
                    crossTraceDefaults: t1("./cross_trace_defaults"),
                    calc: t1("./calc"),
                    scales: n.scales,
                    defaultScale: n.defaultScale,
                    getScale: n.get,
                    isValidScale: n.isValid,
                    hasColorscale: i.hasColorscale,
                    extractOpts: i.extractOpts,
                    extractScale: i.extractScale,
                    flipScale: i.flipScale,
                    makeColorScaleFunc: i.makeColorScaleFunc,
                    makeColorScaleFuncFromTrace: i.makeColorScaleFuncFromTrace
                };
            },
            {
                "./attributes": 373,
                "./calc": 374,
                "./cross_trace_defaults": 375,
                "./defaults": 376,
                "./helpers": 377,
                "./layout_attributes": 379,
                "./layout_defaults": 380,
                "./scales": 381
            }
        ],
        379: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib/extend").extendFlat, i = t1("./attributes"), a = t1("./scales").scales;
                e1.exports = {
                    editType: "calc",
                    colorscale: {
                        editType: "calc",
                        sequential: {
                            valType: "colorscale",
                            dflt: a.Reds,
                            editType: "calc"
                        },
                        sequentialminus: {
                            valType: "colorscale",
                            dflt: a.Blues,
                            editType: "calc"
                        },
                        diverging: {
                            valType: "colorscale",
                            dflt: a.RdBu,
                            editType: "calc"
                        }
                    },
                    coloraxis: n({
                        _isSubplotObj: !0,
                        editType: "calc"
                    }, i("", {
                        colorAttr: "corresponding trace color array(s)",
                        noColorAxis: !0,
                        showScaleDflt: !0
                    }))
                };
            },
            {
                "../../lib/extend": 493,
                "./attributes": 373,
                "./scales": 381
            }
        ],
        380: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plot_api/plot_template"), a = t1("./layout_attributes"), o = t1("./defaults");
                e1.exports = function(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    r("colorscale.sequential"), r("colorscale.sequentialminus"), r("colorscale.diverging");
                    var s, l, c = e1._colorAxes;
                    function u(t1, e1) {
                        return n.coerce(s, l, a.coloraxis, t1, e1);
                    }
                    for(var f in c){
                        var h = c[f];
                        if (h[0]) s = t1[f] || {}, (l = i.newContainer(e1, f, "coloraxis"))._name = f, o(s, l, e1, u, {
                            prefix: "",
                            cLetter: "c"
                        });
                        else {
                            for(var p = 0; p < h[2].length; p++)h[2][p]();
                            delete e1._colorAxes[f];
                        }
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "./defaults": 376,
                "./layout_attributes": 379
            }
        ],
        381: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("tinycolor2"), i = {
                    Greys: [
                        [
                            0,
                            "rgb(0,0,0)"
                        ],
                        [
                            1,
                            "rgb(255,255,255)"
                        ]
                    ],
                    YlGnBu: [
                        [
                            0,
                            "rgb(8,29,88)"
                        ],
                        [
                            .125,
                            "rgb(37,52,148)"
                        ],
                        [
                            .25,
                            "rgb(34,94,168)"
                        ],
                        [
                            .375,
                            "rgb(29,145,192)"
                        ],
                        [
                            .5,
                            "rgb(65,182,196)"
                        ],
                        [
                            .625,
                            "rgb(127,205,187)"
                        ],
                        [
                            .75,
                            "rgb(199,233,180)"
                        ],
                        [
                            .875,
                            "rgb(237,248,217)"
                        ],
                        [
                            1,
                            "rgb(255,255,217)"
                        ]
                    ],
                    Greens: [
                        [
                            0,
                            "rgb(0,68,27)"
                        ],
                        [
                            .125,
                            "rgb(0,109,44)"
                        ],
                        [
                            .25,
                            "rgb(35,139,69)"
                        ],
                        [
                            .375,
                            "rgb(65,171,93)"
                        ],
                        [
                            .5,
                            "rgb(116,196,118)"
                        ],
                        [
                            .625,
                            "rgb(161,217,155)"
                        ],
                        [
                            .75,
                            "rgb(199,233,192)"
                        ],
                        [
                            .875,
                            "rgb(229,245,224)"
                        ],
                        [
                            1,
                            "rgb(247,252,245)"
                        ]
                    ],
                    YlOrRd: [
                        [
                            0,
                            "rgb(128,0,38)"
                        ],
                        [
                            .125,
                            "rgb(189,0,38)"
                        ],
                        [
                            .25,
                            "rgb(227,26,28)"
                        ],
                        [
                            .375,
                            "rgb(252,78,42)"
                        ],
                        [
                            .5,
                            "rgb(253,141,60)"
                        ],
                        [
                            .625,
                            "rgb(254,178,76)"
                        ],
                        [
                            .75,
                            "rgb(254,217,118)"
                        ],
                        [
                            .875,
                            "rgb(255,237,160)"
                        ],
                        [
                            1,
                            "rgb(255,255,204)"
                        ]
                    ],
                    Bluered: [
                        [
                            0,
                            "rgb(0,0,255)"
                        ],
                        [
                            1,
                            "rgb(255,0,0)"
                        ]
                    ],
                    RdBu: [
                        [
                            0,
                            "rgb(5,10,172)"
                        ],
                        [
                            .35,
                            "rgb(106,137,247)"
                        ],
                        [
                            .5,
                            "rgb(190,190,190)"
                        ],
                        [
                            .6,
                            "rgb(220,170,132)"
                        ],
                        [
                            .7,
                            "rgb(230,145,90)"
                        ],
                        [
                            1,
                            "rgb(178,10,28)"
                        ]
                    ],
                    Reds: [
                        [
                            0,
                            "rgb(220,220,220)"
                        ],
                        [
                            .2,
                            "rgb(245,195,157)"
                        ],
                        [
                            .4,
                            "rgb(245,160,105)"
                        ],
                        [
                            1,
                            "rgb(178,10,28)"
                        ]
                    ],
                    Blues: [
                        [
                            0,
                            "rgb(5,10,172)"
                        ],
                        [
                            .35,
                            "rgb(40,60,190)"
                        ],
                        [
                            .5,
                            "rgb(70,100,245)"
                        ],
                        [
                            .6,
                            "rgb(90,120,245)"
                        ],
                        [
                            .7,
                            "rgb(106,137,247)"
                        ],
                        [
                            1,
                            "rgb(220,220,220)"
                        ]
                    ],
                    Picnic: [
                        [
                            0,
                            "rgb(0,0,255)"
                        ],
                        [
                            .1,
                            "rgb(51,153,255)"
                        ],
                        [
                            .2,
                            "rgb(102,204,255)"
                        ],
                        [
                            .3,
                            "rgb(153,204,255)"
                        ],
                        [
                            .4,
                            "rgb(204,204,255)"
                        ],
                        [
                            .5,
                            "rgb(255,255,255)"
                        ],
                        [
                            .6,
                            "rgb(255,204,255)"
                        ],
                        [
                            .7,
                            "rgb(255,153,255)"
                        ],
                        [
                            .8,
                            "rgb(255,102,204)"
                        ],
                        [
                            .9,
                            "rgb(255,102,102)"
                        ],
                        [
                            1,
                            "rgb(255,0,0)"
                        ]
                    ],
                    Rainbow: [
                        [
                            0,
                            "rgb(150,0,90)"
                        ],
                        [
                            .125,
                            "rgb(0,0,200)"
                        ],
                        [
                            .25,
                            "rgb(0,25,255)"
                        ],
                        [
                            .375,
                            "rgb(0,152,255)"
                        ],
                        [
                            .5,
                            "rgb(44,255,150)"
                        ],
                        [
                            .625,
                            "rgb(151,255,0)"
                        ],
                        [
                            .75,
                            "rgb(255,234,0)"
                        ],
                        [
                            .875,
                            "rgb(255,111,0)"
                        ],
                        [
                            1,
                            "rgb(255,0,0)"
                        ]
                    ],
                    Portland: [
                        [
                            0,
                            "rgb(12,51,131)"
                        ],
                        [
                            .25,
                            "rgb(10,136,186)"
                        ],
                        [
                            .5,
                            "rgb(242,211,56)"
                        ],
                        [
                            .75,
                            "rgb(242,143,56)"
                        ],
                        [
                            1,
                            "rgb(217,30,30)"
                        ]
                    ],
                    Jet: [
                        [
                            0,
                            "rgb(0,0,131)"
                        ],
                        [
                            .125,
                            "rgb(0,60,170)"
                        ],
                        [
                            .375,
                            "rgb(5,255,255)"
                        ],
                        [
                            .625,
                            "rgb(255,255,0)"
                        ],
                        [
                            .875,
                            "rgb(250,0,0)"
                        ],
                        [
                            1,
                            "rgb(128,0,0)"
                        ]
                    ],
                    Hot: [
                        [
                            0,
                            "rgb(0,0,0)"
                        ],
                        [
                            .3,
                            "rgb(230,0,0)"
                        ],
                        [
                            .6,
                            "rgb(255,210,0)"
                        ],
                        [
                            1,
                            "rgb(255,255,255)"
                        ]
                    ],
                    Blackbody: [
                        [
                            0,
                            "rgb(0,0,0)"
                        ],
                        [
                            .2,
                            "rgb(230,0,0)"
                        ],
                        [
                            .4,
                            "rgb(230,210,0)"
                        ],
                        [
                            .7,
                            "rgb(255,255,255)"
                        ],
                        [
                            1,
                            "rgb(160,200,255)"
                        ]
                    ],
                    Earth: [
                        [
                            0,
                            "rgb(0,0,130)"
                        ],
                        [
                            .1,
                            "rgb(0,180,180)"
                        ],
                        [
                            .2,
                            "rgb(40,210,40)"
                        ],
                        [
                            .4,
                            "rgb(230,230,50)"
                        ],
                        [
                            .6,
                            "rgb(120,70,20)"
                        ],
                        [
                            1,
                            "rgb(255,255,255)"
                        ]
                    ],
                    Electric: [
                        [
                            0,
                            "rgb(0,0,0)"
                        ],
                        [
                            .15,
                            "rgb(30,0,100)"
                        ],
                        [
                            .4,
                            "rgb(120,0,100)"
                        ],
                        [
                            .6,
                            "rgb(160,90,0)"
                        ],
                        [
                            .8,
                            "rgb(230,200,0)"
                        ],
                        [
                            1,
                            "rgb(255,250,220)"
                        ]
                    ],
                    Viridis: [
                        [
                            0,
                            "#440154"
                        ],
                        [
                            .06274509803921569,
                            "#48186a"
                        ],
                        [
                            .12549019607843137,
                            "#472d7b"
                        ],
                        [
                            .18823529411764706,
                            "#424086"
                        ],
                        [
                            .25098039215686274,
                            "#3b528b"
                        ],
                        [
                            .3137254901960784,
                            "#33638d"
                        ],
                        [
                            .3764705882352941,
                            "#2c728e"
                        ],
                        [
                            .4392156862745098,
                            "#26828e"
                        ],
                        [
                            .5019607843137255,
                            "#21918c"
                        ],
                        [
                            .5647058823529412,
                            "#1fa088"
                        ],
                        [
                            .6274509803921569,
                            "#28ae80"
                        ],
                        [
                            .6901960784313725,
                            "#3fbc73"
                        ],
                        [
                            .7529411764705882,
                            "#5ec962"
                        ],
                        [
                            .8156862745098039,
                            "#84d44b"
                        ],
                        [
                            .8784313725490196,
                            "#addc30"
                        ],
                        [
                            .9411764705882353,
                            "#d8e219"
                        ],
                        [
                            1,
                            "#fde725"
                        ]
                    ],
                    Cividis: [
                        [
                            0,
                            "rgb(0,32,76)"
                        ],
                        [
                            .058824,
                            "rgb(0,42,102)"
                        ],
                        [
                            .117647,
                            "rgb(0,52,110)"
                        ],
                        [
                            .176471,
                            "rgb(39,63,108)"
                        ],
                        [
                            .235294,
                            "rgb(60,74,107)"
                        ],
                        [
                            .294118,
                            "rgb(76,85,107)"
                        ],
                        [
                            .352941,
                            "rgb(91,95,109)"
                        ],
                        [
                            .411765,
                            "rgb(104,106,112)"
                        ],
                        [
                            .470588,
                            "rgb(117,117,117)"
                        ],
                        [
                            .529412,
                            "rgb(131,129,120)"
                        ],
                        [
                            .588235,
                            "rgb(146,140,120)"
                        ],
                        [
                            .647059,
                            "rgb(161,152,118)"
                        ],
                        [
                            .705882,
                            "rgb(176,165,114)"
                        ],
                        [
                            .764706,
                            "rgb(192,177,109)"
                        ],
                        [
                            .823529,
                            "rgb(209,191,102)"
                        ],
                        [
                            .882353,
                            "rgb(225,204,92)"
                        ],
                        [
                            .941176,
                            "rgb(243,219,79)"
                        ],
                        [
                            1,
                            "rgb(255,233,69)"
                        ]
                    ]
                }, a = i.RdBu;
                function o(t1) {
                    var e1 = 0;
                    if (!Array.isArray(t1) || t1.length < 2) return !1;
                    if (!t1[0] || !t1[t1.length - 1]) return !1;
                    if (0 != +t1[0][0] || 1 != +t1[t1.length - 1][0]) return !1;
                    for(var r = 0; r < t1.length; r++){
                        var i = t1[r];
                        if (2 !== i.length || +i[0] < e1 || !n(i[1]).isValid()) return !1;
                        e1 = +i[0];
                    }
                    return !0;
                }
                e1.exports = {
                    scales: i,
                    defaultScale: a,
                    get: function(t1, e1) {
                        if (e1 || (e1 = a), !t1) return e1;
                        function r() {
                            try {
                                t1 = i[t1] || JSON.parse(t1);
                            } catch (r) {
                                t1 = e1;
                            }
                        }
                        return "string" == typeof t1 && (r(), "string" == typeof t1 && r()), o(t1) ? t1 : e1;
                    },
                    isValid: function(t1) {
                        return void 0 !== i[t1] || o(t1);
                    }
                };
            },
            {
                tinycolor2: 312
            }
        ],
        382: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n, i) {
                    var a = (t1 - r) / (n - r), o = a + e1 / (n - r), s = (a + o) / 2;
                    return "left" === i || "bottom" === i ? a : "center" === i || "middle" === i ? s : "right" === i || "top" === i ? o : a < 2 / 3 - s ? a : o > 4 / 3 - s ? o : s;
                };
            },
            {}
        ],
        383: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = [
                    [
                        "sw-resize",
                        "s-resize",
                        "se-resize"
                    ],
                    [
                        "w-resize",
                        "move",
                        "e-resize"
                    ],
                    [
                        "nw-resize",
                        "n-resize",
                        "ne-resize"
                    ]
                ];
                e1.exports = function(t1, e1, r, a) {
                    return t1 = "left" === r ? 0 : "center" === r ? 1 : "right" === r ? 2 : n.constrain(Math.floor(3 * t1), 0, 2), e1 = "bottom" === a ? 0 : "middle" === a ? 1 : "top" === a ? 2 : n.constrain(Math.floor(3 * e1), 0, 2), i[e1][t1];
                };
            },
            {
                "../../lib": 503
            }
        ],
        384: [
            function(t1, e1, r) {
                "use strict";
                r.selectMode = function(t1) {
                    return "lasso" === t1 || "select" === t1;
                }, r.drawMode = function(t1) {
                    return "drawclosedpath" === t1 || "drawopenpath" === t1 || "drawline" === t1 || "drawrect" === t1 || "drawcircle" === t1;
                }, r.openMode = function(t1) {
                    return "drawline" === t1 || "drawopenpath" === t1;
                }, r.rectMode = function(t1) {
                    return "select" === t1 || "drawline" === t1 || "drawrect" === t1 || "drawcircle" === t1;
                }, r.freeMode = function(t1) {
                    return "lasso" === t1 || "drawclosedpath" === t1 || "drawopenpath" === t1;
                }, r.selectingOrDrawing = function(t1) {
                    return r.freeMode(t1) || r.rectMode(t1);
                };
            },
            {}
        ],
        385: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("mouse-event-offset"), i = t1("has-hover"), a = t1("has-passive-events"), o = t1("../../lib").removeElement, s = t1("../../plots/cartesian/constants"), l = e1.exports = {};
                l.align = t1("./align"), l.getCursor = t1("./cursor");
                var c = t1("./unhover");
                function u() {
                    var t1 = document.createElement("div");
                    t1.className = "dragcover";
                    var e1 = t1.style;
                    return e1.position = "fixed", e1.left = 0, e1.right = 0, e1.top = 0, e1.bottom = 0, e1.zIndex = 999999999, e1.background = "none", document.body.appendChild(t1), t1;
                }
                function f(t1) {
                    return n(t1.changedTouches ? t1.changedTouches[0] : t1, document.body);
                }
                l.unhover = c.wrapped, l.unhoverRaw = c.raw, l.init = function(t1) {
                    var e1, r, n, c, h, p, d, m, g = t1.gd, v = 1, y = g._context.doubleClickDelay, x = t1.element;
                    g._mouseDownTime || (g._mouseDownTime = 0), x.style.pointerEvents = "all", x.onmousedown = _, a ? (x._ontouchstart && x.removeEventListener("touchstart", x._ontouchstart), x._ontouchstart = _, x.addEventListener("touchstart", _, {
                        passive: !1
                    })) : x.ontouchstart = _;
                    var b = t1.clampFn || function(t1, e1, r) {
                        return Math.abs(t1) < r && (t1 = 0), Math.abs(e1) < r && (e1 = 0), [
                            t1,
                            e1
                        ];
                    };
                    function _(a) {
                        g._dragged = !1, g._dragging = !0;
                        var o = f(a);
                        e1 = o[0], r = o[1], d = a.target, p = a, m = 2 === a.buttons || a.ctrlKey, void 0 === a.clientX && void 0 === a.clientY && (a.clientX = e1, a.clientY = r), (n = (new Date).getTime()) - g._mouseDownTime < y ? v += 1 : (v = 1, g._mouseDownTime = n), t1.prepFn && t1.prepFn(a, e1, r), i && !m ? (h = u()).style.cursor = window.getComputedStyle(x).cursor : i || (h = document, c = window.getComputedStyle(document.documentElement).cursor, document.documentElement.style.cursor = window.getComputedStyle(x).cursor), document.addEventListener("mouseup", T), document.addEventListener("touchend", T), !1 !== t1.dragmode && (a.preventDefault(), document.addEventListener("mousemove", w), document.addEventListener("touchmove", w, {
                            passive: !1
                        }));
                    }
                    function w(n) {
                        n.preventDefault();
                        var i = f(n), a = t1.minDrag || s.MINDRAG, o = b(i[0] - e1, i[1] - r, a), c = o[0], u = o[1];
                        (c || u) && (g._dragged = !0, l.unhover(g, n)), g._dragged && t1.moveFn && !m && (g._dragdata = {
                            element: x,
                            dx: c,
                            dy: u
                        }, t1.moveFn(c, u));
                    }
                    function T(e1) {
                        if (delete g._dragdata, !1 !== t1.dragmode && (e1.preventDefault(), document.removeEventListener("mousemove", w), document.removeEventListener("touchmove", w)), document.removeEventListener("mouseup", T), document.removeEventListener("touchend", T), i ? o(h) : c && (h.documentElement.style.cursor = c, c = null), g._dragging) {
                            if (g._dragging = !1, (new Date).getTime() - g._mouseDownTime > y && (v = Math.max(v - 1, 1)), g._dragged) t1.doneFn && t1.doneFn();
                            else if (t1.clickFn && t1.clickFn(v, p), !m) {
                                var r;
                                try {
                                    r = new MouseEvent("click", e1);
                                } catch (t1) {
                                    var n = f(e1);
                                    (r = document.createEvent("MouseEvents")).initMouseEvent("click", e1.bubbles, e1.cancelable, e1.view, e1.detail, e1.screenX, e1.screenY, n[0], n[1], e1.ctrlKey, e1.altKey, e1.shiftKey, e1.metaKey, e1.button, e1.relatedTarget);
                                }
                                d.dispatchEvent(r);
                            }
                            g._dragging = !1, g._dragged = !1;
                        } else g._dragged = !1;
                    }
                }, l.coverSlip = u;
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/constants": 561,
                "./align": 382,
                "./cursor": 383,
                "./unhover": 386,
                "has-hover": 228,
                "has-passive-events": 229,
                "mouse-event-offset": 242
            }
        ],
        386: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib/events"), i = t1("../../lib/throttle"), a = t1("../../lib/dom").getGraphDiv, o = t1("../fx/constants"), s = e1.exports = {};
                s.wrapped = function(t1, e1, r) {
                    (t1 = a(t1))._fullLayout && i.clear(t1._fullLayout._uid + o.HOVERID), s.raw(t1, e1, r);
                }, s.raw = function(t1, e1) {
                    var r = t1._fullLayout, i = t1._hoverdata;
                    e1 || (e1 = {}), e1.target && !t1._dragged && !1 === n.triggerHandler(t1, "plotly_beforehover", e1) || (r._hoverlayer.selectAll("g").remove(), r._hoverlayer.selectAll("line").remove(), r._hoverlayer.selectAll("circle").remove(), t1._hoverdata = void 0, e1.target && i && t1.emit("plotly_unhover", {
                        event: e1,
                        points: i
                    }));
                };
            },
            {
                "../../lib/dom": 491,
                "../../lib/events": 492,
                "../../lib/throttle": 530,
                "../fx/constants": 400
            }
        ],
        387: [
            function(t1, e1, r) {
                "use strict";
                r.dash = {
                    valType: "string",
                    values: [
                        "solid",
                        "dot",
                        "dash",
                        "longdash",
                        "dashdot",
                        "longdashdot"
                    ],
                    dflt: "solid",
                    editType: "style"
                }, r.pattern = {
                    shape: {
                        valType: "enumerated",
                        values: [
                            "",
                            "/",
                            "\\",
                            "x",
                            "-",
                            "|",
                            "+",
                            "."
                        ],
                        dflt: "",
                        arrayOk: !0,
                        editType: "style"
                    },
                    fillmode: {
                        valType: "enumerated",
                        values: [
                            "replace",
                            "overlay"
                        ],
                        dflt: "replace",
                        editType: "style"
                    },
                    bgcolor: {
                        valType: "color",
                        arrayOk: !0,
                        editType: "style"
                    },
                    fgcolor: {
                        valType: "color",
                        arrayOk: !0,
                        editType: "style"
                    },
                    fgopacity: {
                        valType: "number",
                        editType: "style",
                        min: 0,
                        max: 1
                    },
                    size: {
                        valType: "number",
                        min: 0,
                        dflt: 8,
                        arrayOk: !0,
                        editType: "style"
                    },
                    solidity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .3,
                        arrayOk: !0,
                        editType: "style"
                    },
                    editType: "style"
                };
            },
            {}
        ],
        388: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = i.numberFormat, o = t1("fast-isnumeric"), s = t1("tinycolor2"), l = t1("../../registry"), c = t1("../color"), u = t1("../colorscale"), f = i.strTranslate, h = t1("../../lib/svg_text_utils"), p = t1("../../constants/xmlns_namespaces"), d = t1("../../constants/alignment").LINE_SPACING, m = t1("../../constants/interactions").DESELECTDIM, g = t1("../../traces/scatter/subtypes"), v = t1("../../traces/scatter/make_bubble_size_func"), y = t1("../../components/fx/helpers").appendArrayPointValue, x = e1.exports = {};
                x.font = function(t1, e1, r, n) {
                    i.isPlainObject(e1) && (n = e1.color, r = e1.size, e1 = e1.family), e1 && t1.style("font-family", e1), r + 1 && t1.style("font-size", r + "px"), n && t1.call(c.fill, n);
                }, x.setPosition = function(t1, e1, r) {
                    t1.attr("x", e1).attr("y", r);
                }, x.setSize = function(t1, e1, r) {
                    t1.attr("width", e1).attr("height", r);
                }, x.setRect = function(t1, e1, r, n, i) {
                    t1.call(x.setPosition, e1, r).call(x.setSize, n, i);
                }, x.translatePoint = function(t1, e1, r, n) {
                    var i = r.c2p(t1.x), a = n.c2p(t1.y);
                    return !!(o(i) && o(a) && e1.node()) && ("text" === e1.node().nodeName ? e1.attr("x", i).attr("y", a) : e1.attr("transform", f(i, a)), !0);
                }, x.translatePoints = function(t1, e1, r) {
                    t1.each(function(t1) {
                        var i = n.select(this);
                        x.translatePoint(t1, i, e1, r);
                    });
                }, x.hideOutsideRangePoint = function(t1, e1, r, n, i, a) {
                    e1.attr("display", r.isPtWithinRange(t1, i) && n.isPtWithinRange(t1, a) ? null : "none");
                }, x.hideOutsideRangePoints = function(t1, e1) {
                    if (e1._hasClipOnAxisFalse) {
                        var r = e1.xaxis, i = e1.yaxis;
                        t1.each(function(e1) {
                            var a = e1[0].trace, o = a.xcalendar, s = a.ycalendar, c = l.traceIs(a, "bar-like") ? ".bartext" : ".point,.textpoint";
                            t1.selectAll(c).each(function(t1) {
                                x.hideOutsideRangePoint(t1, n.select(this), r, i, o, s);
                            });
                        });
                    }
                }, x.crispRound = function(t1, e1, r) {
                    return e1 && o(e1) ? t1._context.staticPlot ? e1 : e1 < 1 ? 1 : Math.round(e1) : r || 0;
                }, x.singleLineStyle = function(t1, e1, r, n, i) {
                    e1.style("fill", "none");
                    var a = (((t1 || [])[0] || {}).trace || {}).line || {}, o = r || a.width || 0, s = i || a.dash || "";
                    c.stroke(e1, n || a.color), x.dashLine(e1, s, o);
                }, x.lineGroupStyle = function(t1, e1, r, i) {
                    t1.style("fill", "none").each(function(t1) {
                        var a = (((t1 || [])[0] || {}).trace || {}).line || {}, o = e1 || a.width || 0, s = i || a.dash || "";
                        n.select(this).call(c.stroke, r || a.color).call(x.dashLine, s, o);
                    });
                }, x.dashLine = function(t1, e1, r) {
                    r = +r || 0, e1 = x.dashStyle(e1, r), t1.style({
                        "stroke-dasharray": e1,
                        "stroke-width": r + "px"
                    });
                }, x.dashStyle = function(t1, e1) {
                    e1 = +e1 || 1;
                    var r = Math.max(e1, 3);
                    return "solid" === t1 ? t1 = "" : "dot" === t1 ? t1 = r + "px," + r + "px" : "dash" === t1 ? t1 = 3 * r + "px," + 3 * r + "px" : "longdash" === t1 ? t1 = 5 * r + "px," + 5 * r + "px" : "dashdot" === t1 ? t1 = 3 * r + "px," + r + "px," + r + "px," + r + "px" : "longdashdot" === t1 && (t1 = 5 * r + "px," + 2 * r + "px," + r + "px," + 2 * r + "px"), t1;
                }, x.singleFillStyle = function(t1) {
                    var e1 = (((n.select(t1.node()).data()[0] || [])[0] || {}).trace || {}).fillcolor;
                    e1 && t1.call(c.fill, e1);
                }, x.fillGroupStyle = function(t1) {
                    t1.style("stroke-width", 0).each(function(t1) {
                        var e1 = n.select(this);
                        t1[0].trace && e1.call(c.fill, t1[0].trace.fillcolor);
                    });
                };
                var b = t1("./symbol_defs");
                x.symbolNames = [], x.symbolFuncs = [], x.symbolNeedLines = {}, x.symbolNoDot = {}, x.symbolNoFill = {}, x.symbolList = [], Object.keys(b).forEach(function(t1) {
                    var e1 = b[t1], r = e1.n;
                    x.symbolList.push(r, String(r), t1, r + 100, String(r + 100), t1 + "-open"), x.symbolNames[r] = t1, x.symbolFuncs[r] = e1.f, e1.needLine && (x.symbolNeedLines[r] = !0), e1.noDot ? x.symbolNoDot[r] = !0 : x.symbolList.push(r + 200, String(r + 200), t1 + "-dot", r + 300, String(r + 300), t1 + "-open-dot"), e1.noFill && (x.symbolNoFill[r] = !0);
                });
                var _ = x.symbolNames.length;
                function w(t1, e1) {
                    var r = t1 % 100;
                    return x.symbolFuncs[r](e1) + (t1 >= 200 ? "M0,0.5L0.5,0L0,-0.5L-0.5,0Z" : "");
                }
                x.symbolNumber = function(t1) {
                    if (o(t1)) t1 = +t1;
                    else if ("string" == typeof t1) {
                        var e1 = 0;
                        t1.indexOf("-open") > 0 && (e1 = 100, t1 = t1.replace("-open", "")), t1.indexOf("-dot") > 0 && (e1 += 200, t1 = t1.replace("-dot", "")), (t1 = x.symbolNames.indexOf(t1)) >= 0 && (t1 += e1);
                    }
                    return t1 % 100 >= _ || t1 >= 400 ? 0 : Math.floor(Math.max(t1, 0));
                };
                var T = {
                    x1: 1,
                    x2: 0,
                    y1: 0,
                    y2: 0
                }, k = {
                    x1: 0,
                    x2: 0,
                    y1: 1,
                    y2: 0
                }, A = a("~f"), M = {
                    radial: {
                        node: "radialGradient"
                    },
                    radialreversed: {
                        node: "radialGradient",
                        reversed: !0
                    },
                    horizontal: {
                        node: "linearGradient",
                        attrs: T
                    },
                    horizontalreversed: {
                        node: "linearGradient",
                        attrs: T,
                        reversed: !0
                    },
                    vertical: {
                        node: "linearGradient",
                        attrs: k
                    },
                    verticalreversed: {
                        node: "linearGradient",
                        attrs: k,
                        reversed: !0
                    }
                };
                x.gradient = function(t1, e1, r, a, o, l) {
                    for(var u = o.length, f = M[a], h = new Array(u), p = 0; p < u; p++)f.reversed ? h[u - 1 - p] = [
                        A(100 * (1 - o[p][0])),
                        o[p][1]
                    ] : h[p] = [
                        A(100 * o[p][0]),
                        o[p][1]
                    ];
                    var d = e1._fullLayout, m = "g" + d._uid + "-" + r, g = d._defs.select(".gradients").selectAll("#" + m).data([
                        a + h.join(";")
                    ], i.identity);
                    g.exit().remove(), g.enter().append(f.node).each(function() {
                        var t1 = n.select(this);
                        f.attrs && t1.attr(f.attrs), t1.attr("id", m);
                        var e1 = t1.selectAll("stop").data(h);
                        e1.exit().remove(), e1.enter().append("stop"), e1.each(function(t1) {
                            var e1 = s(t1[1]);
                            n.select(this).attr({
                                offset: t1[0] + "%",
                                "stop-color": c.tinyRGB(e1),
                                "stop-opacity": e1.getAlpha()
                            });
                        });
                    }), t1.style(l, D(m, e1)).style(l + "-opacity", null);
                    var v = function(t1) {
                        return "." + t1.attr("class").replace(/\s/g, ".");
                    }, y = v(n.select(t1.node().parentNode)) + ">" + v(t1);
                    d._gradientUrlQueryParts[y] = 1;
                }, x.pattern = function(t1, e1, r, a, o, s, l, u, f, h, p, d) {
                    var m = "legend" === e1;
                    u && ("overlay" === f ? (h = u, p = c.contrast(h)) : (h = void 0, p = u));
                    var g, v, y, x, b, _, w, T, k, A, M, S = r._fullLayout, E = "p" + S._uid + "-" + a, L = {};
                    switch(o){
                        case "/":
                            g = s * Math.sqrt(2), v = s * Math.sqrt(2), _ = "path", L = {
                                d: y = "M-" + g / 4 + "," + v / 4 + "l" + g / 2 + ",-" + v / 2 + "M0," + v + "L" + g + ",0M" + g / 4 * 3 + "," + v / 4 * 5 + "l" + g / 2 + ",-" + v / 2,
                                opacity: d,
                                stroke: p,
                                "stroke-width": (x = l * s) + "px"
                            };
                            break;
                        case "\\":
                            g = s * Math.sqrt(2), v = s * Math.sqrt(2), _ = "path", L = {
                                d: y = "M" + g / 4 * 3 + ",-" + v / 4 + "l" + g / 2 + "," + v / 2 + "M0,0L" + g + "," + v + "M-" + g / 4 + "," + v / 4 * 3 + "l" + g / 2 + "," + v / 2,
                                opacity: d,
                                stroke: p,
                                "stroke-width": (x = l * s) + "px"
                            };
                            break;
                        case "x":
                            g = s * Math.sqrt(2), v = s * Math.sqrt(2), y = "M-" + g / 4 + "," + v / 4 + "l" + g / 2 + ",-" + v / 2 + "M0," + v + "L" + g + ",0M" + g / 4 * 3 + "," + v / 4 * 5 + "l" + g / 2 + ",-" + v / 2 + "M" + g / 4 * 3 + ",-" + v / 4 + "l" + g / 2 + "," + v / 2 + "M0,0L" + g + "," + v + "M-" + g / 4 + "," + v / 4 * 3 + "l" + g / 2 + "," + v / 2, x = s - s * Math.sqrt(1 - l), _ = "path", L = {
                                d: y,
                                opacity: d,
                                stroke: p,
                                "stroke-width": x + "px"
                            };
                            break;
                        case "|":
                            _ = "path", _ = "path", L = {
                                d: y = "M" + (g = s) / 2 + ",0L" + g / 2 + "," + (v = s),
                                opacity: d,
                                stroke: p,
                                "stroke-width": (x = l * s) + "px"
                            };
                            break;
                        case "-":
                            _ = "path", _ = "path", L = {
                                d: y = "M0," + (v = s) / 2 + "L" + (g = s) + "," + v / 2,
                                opacity: d,
                                stroke: p,
                                "stroke-width": (x = l * s) + "px"
                            };
                            break;
                        case "+":
                            _ = "path", y = "M" + (g = s) / 2 + ",0L" + g / 2 + "," + (v = s) + "M0," + v / 2 + "L" + g + "," + v / 2, x = s - s * Math.sqrt(1 - l), _ = "path", L = {
                                d: y,
                                opacity: d,
                                stroke: p,
                                "stroke-width": x + "px"
                            };
                            break;
                        case ".":
                            g = s, v = s, l < Math.PI / 4 ? b = Math.sqrt(l * s * s / Math.PI) : (w = l, T = Math.PI / 4, k = 1, A = s / 2, M = s / Math.sqrt(2), b = A + (M - A) * (w - T) / (k - T)), _ = "circle", L = {
                                cx: g / 2,
                                cy: v / 2,
                                r: b,
                                opacity: d,
                                fill: p
                            };
                    }
                    var C = [
                        o || "noSh",
                        h || "noBg",
                        p || "noFg",
                        s,
                        l
                    ].join(";"), P = S._defs.select(".patterns").selectAll("#" + E).data([
                        C
                    ], i.identity);
                    P.exit().remove(), P.enter().append("pattern").each(function() {
                        var t1 = n.select(this);
                        if (t1.attr({
                            id: E,
                            width: g + "px",
                            height: v + "px",
                            patternUnits: "userSpaceOnUse",
                            patternTransform: m ? "scale(0.8)" : ""
                        }), h) {
                            var e1 = t1.selectAll("rect").data([
                                0
                            ]);
                            e1.exit().remove(), e1.enter().append("rect").attr({
                                width: g + "px",
                                height: v + "px",
                                fill: h
                            });
                        }
                        var r = t1.selectAll(_).data([
                            0
                        ]);
                        r.exit().remove(), r.enter().append(_).attr(L);
                    }), t1.style("fill", D(E, r)).style("fill-opacity", null), t1.classed("pattern_filled", !0);
                    var I = "." + n.select(t1.node().parentNode).attr("class").replace(/\s/g, ".") + ">.pattern_filled";
                    S._patternUrlQueryParts[I] = 1;
                }, x.initGradients = function(t1) {
                    var e1 = t1._fullLayout;
                    i.ensureSingle(e1._defs, "g", "gradients").selectAll("linearGradient,radialGradient").remove(), e1._gradientUrlQueryParts = {};
                }, x.initPatterns = function(t1) {
                    var e1 = t1._fullLayout;
                    i.ensureSingle(e1._defs, "g", "patterns").selectAll("pattern").remove(), e1._patternUrlQueryParts = {};
                }, x.getPatternAttr = function(t1, e1, r) {
                    return t1 && i.isArrayOrTypedArray(t1) ? e1 < t1.length ? t1[e1] : r : t1;
                }, x.pointStyle = function(t1, e1, r) {
                    if (t1.size()) {
                        var i = x.makePointStyleFns(e1);
                        t1.each(function(t1) {
                            x.singlePointStyle(t1, n.select(this), e1, i, r);
                        });
                    }
                }, x.singlePointStyle = function(t1, e1, r, n, a) {
                    var o = r.marker, s = o.line;
                    if (e1.style("opacity", n.selectedOpacityFn ? n.selectedOpacityFn(t1) : void 0 === t1.mo ? o.opacity : t1.mo), n.ms2mrc) {
                        var l;
                        l = "various" === t1.ms || "various" === o.size ? 3 : n.ms2mrc(t1.ms), t1.mrc = l, n.selectedSizeFn && (l = t1.mrc = n.selectedSizeFn(t1));
                        var u = x.symbolNumber(t1.mx || o.symbol) || 0;
                        t1.om = u % 200 >= 100, e1.attr("d", w(u, l));
                    }
                    var f, h, p, d = !1;
                    if (t1.so) p = s.outlierwidth, h = s.outliercolor, f = o.outliercolor;
                    else {
                        var m = (s || {}).width;
                        p = (t1.mlw + 1 || m + 1 || (t1.trace ? (t1.trace.marker.line || {}).width : 0) + 1) - 1 || 0, h = "mlc" in t1 ? t1.mlcc = n.lineScale(t1.mlc) : i.isArrayOrTypedArray(s.color) ? c.defaultLine : s.color, i.isArrayOrTypedArray(o.color) && (f = c.defaultLine, d = !0), f = "mc" in t1 ? t1.mcc = n.markerScale(t1.mc) : o.color || "rgba(0,0,0,0)", n.selectedColorFn && (f = n.selectedColorFn(t1));
                    }
                    if (t1.om) e1.call(c.stroke, f).style({
                        "stroke-width": (p || 1) + "px",
                        fill: "none"
                    });
                    else {
                        e1.style("stroke-width", (t1.isBlank ? 0 : p) + "px");
                        var g = o.gradient, v = t1.mgt;
                        v ? d = !0 : v = g && g.type, i.isArrayOrTypedArray(v) && (v = v[0], M[v] || (v = 0));
                        var y = o.pattern, b = y && x.getPatternAttr(y.shape, t1.i, "");
                        if (v && "none" !== v) {
                            var _ = t1.mgc;
                            _ ? d = !0 : _ = g.color;
                            var T = r.uid;
                            d && (T += "-" + t1.i), x.gradient(e1, a, T, v, [
                                [
                                    0,
                                    _
                                ],
                                [
                                    1,
                                    f
                                ]
                            ], "fill");
                        } else if (b) {
                            var k = x.getPatternAttr(y.bgcolor, t1.i, null), A = x.getPatternAttr(y.fgcolor, t1.i, null), S = y.fgopacity, E = x.getPatternAttr(y.size, t1.i, 8), L = x.getPatternAttr(y.solidity, t1.i, .3), C = t1.mcc || i.isArrayOrTypedArray(y.shape) || i.isArrayOrTypedArray(y.bgcolor) || i.isArrayOrTypedArray(y.size) || i.isArrayOrTypedArray(y.solidity), P = r.uid;
                            C && (P += "-" + t1.i), x.pattern(e1, "point", a, P, b, E, L, t1.mcc, y.fillmode, k, A, S);
                        } else c.fill(e1, f);
                        p && c.stroke(e1, h);
                    }
                }, x.makePointStyleFns = function(t1) {
                    var e1 = {}, r = t1.marker;
                    return e1.markerScale = x.tryColorscale(r, ""), e1.lineScale = x.tryColorscale(r, "line"), l.traceIs(t1, "symbols") && (e1.ms2mrc = g.isBubble(t1) ? v(t1) : function() {
                        return (r.size || 6) / 2;
                    }), t1.selectedpoints && i.extendFlat(e1, x.makeSelectedPointStyleFns(t1)), e1;
                }, x.makeSelectedPointStyleFns = function(t1) {
                    var e1 = {}, r = t1.selected || {}, n = t1.unselected || {}, a = t1.marker || {}, o = r.marker || {}, s = n.marker || {}, c = a.opacity, u = o.opacity, f = s.opacity, h = void 0 !== u, p = void 0 !== f;
                    (i.isArrayOrTypedArray(c) || h || p) && (e1.selectedOpacityFn = function(t1) {
                        var e1 = void 0 === t1.mo ? a.opacity : t1.mo;
                        return t1.selected ? h ? u : e1 : p ? f : m * e1;
                    });
                    var d = a.color, g = o.color, v = s.color;
                    (g || v) && (e1.selectedColorFn = function(t1) {
                        var e1 = t1.mcc || d;
                        return t1.selected ? g || e1 : v || e1;
                    });
                    var y = a.size, x = o.size, b = s.size, _ = void 0 !== x, w = void 0 !== b;
                    return l.traceIs(t1, "symbols") && (_ || w) && (e1.selectedSizeFn = function(t1) {
                        var e1 = t1.mrc || y / 2;
                        return t1.selected ? _ ? x / 2 : e1 : w ? b / 2 : e1;
                    }), e1;
                }, x.makeSelectedTextStyleFns = function(t1) {
                    var e1 = {}, r = t1.selected || {}, n = t1.unselected || {}, i = t1.textfont || {}, a = r.textfont || {}, o = n.textfont || {}, s = i.color, l = a.color, u = o.color;
                    return e1.selectedTextColorFn = function(t1) {
                        var e1 = t1.tc || s;
                        return t1.selected ? l || e1 : u || (l ? e1 : c.addOpacity(e1, m));
                    }, e1;
                }, x.selectedPointStyle = function(t1, e1) {
                    if (t1.size() && e1.selectedpoints) {
                        var r = x.makeSelectedPointStyleFns(e1), i = e1.marker || {}, a = [];
                        r.selectedOpacityFn && a.push(function(t1, e1) {
                            t1.style("opacity", r.selectedOpacityFn(e1));
                        }), r.selectedColorFn && a.push(function(t1, e1) {
                            c.fill(t1, r.selectedColorFn(e1));
                        }), r.selectedSizeFn && a.push(function(t1, e1) {
                            var n = e1.mx || i.symbol || 0, a = r.selectedSizeFn(e1);
                            t1.attr("d", w(x.symbolNumber(n), a)), e1.mrc2 = a;
                        }), a.length && t1.each(function(t1) {
                            for(var e1 = n.select(this), r = 0; r < a.length; r++)a[r](e1, t1);
                        });
                    }
                }, x.tryColorscale = function(t1, e1) {
                    var r = e1 ? i.nestedProperty(t1, e1).get() : t1;
                    if (r) {
                        var n = r.color;
                        if ((r.colorscale || r._colorAx) && i.isArrayOrTypedArray(n)) return u.makeColorScaleFuncFromTrace(r);
                    }
                    return i.identity;
                };
                var S = {
                    start: 1,
                    end: -1,
                    middle: 0,
                    bottom: 1,
                    top: -1
                };
                function E(t1, e1, r, i, a) {
                    var o = n.select(t1.node().parentNode), s = -1 !== e1.indexOf("top") ? "top" : -1 !== e1.indexOf("bottom") ? "bottom" : "middle", l = -1 !== e1.indexOf("left") ? "end" : -1 !== e1.indexOf("right") ? "start" : "middle", c = i ? i / .8 + 1 : 0, u = (h.lineCount(t1) - 1) * d + 1, p = S[l] * c, m = .75 * r + S[s] * c + (S[s] - 1) * u * r / 2;
                    t1.attr("text-anchor", l), a || o.attr("transform", f(p, m));
                }
                function L(t1, e1) {
                    var r = t1.ts || e1.textfont.size;
                    return o(r) && r > 0 ? r : 0;
                }
                x.textPointStyle = function(t1, e1, r) {
                    if (t1.size()) {
                        var a;
                        if (e1.selectedpoints) {
                            var o = x.makeSelectedTextStyleFns(e1);
                            a = o.selectedTextColorFn;
                        }
                        var s = e1.texttemplate, l = r._fullLayout;
                        t1.each(function(t1) {
                            var o = n.select(this), c = s ? i.extractOption(t1, e1, "txt", "texttemplate") : i.extractOption(t1, e1, "tx", "text");
                            if (c || 0 === c) {
                                if (s) {
                                    var u = e1._module.formatLabels, f = u ? u(t1, e1, l) : {}, p = {};
                                    y(p, e1, t1.i);
                                    var d = e1._meta || {};
                                    c = i.texttemplateString(c, f, l._d3locale, p, t1, d);
                                }
                                var m = t1.tp || e1.textposition, g = L(t1, e1), v = a ? a(t1) : t1.tc || e1.textfont.color;
                                o.call(x.font, t1.tf || e1.textfont.family, g, v).text(c).call(h.convertToTspans, r).call(E, m, g, t1.mrc);
                            } else o.remove();
                        });
                    }
                }, x.selectedTextStyle = function(t1, e1) {
                    if (t1.size() && e1.selectedpoints) {
                        var r = x.makeSelectedTextStyleFns(e1);
                        t1.each(function(t1) {
                            var i = n.select(this), a = r.selectedTextColorFn(t1), o = t1.tp || e1.textposition, s = L(t1, e1);
                            c.fill(i, a);
                            var u = l.traceIs(e1, "bar-like");
                            E(i, o, s, t1.mrc2 || t1.mrc, u);
                        });
                    }
                };
                function C(t1, e1, r, i) {
                    var a = t1[0] - e1[0], o = t1[1] - e1[1], s = r[0] - e1[0], l = r[1] - e1[1], c = Math.pow(a * a + o * o, .25), u = Math.pow(s * s + l * l, .25), f = (u * u * a - c * c * s) * i, h = (u * u * o - c * c * l) * i, p = 3 * u * (c + u), d = 3 * c * (c + u);
                    return [
                        [
                            n.round(e1[0] + (p && f / p), 2),
                            n.round(e1[1] + (p && h / p), 2)
                        ],
                        [
                            n.round(e1[0] - (d && f / d), 2),
                            n.round(e1[1] - (d && h / d), 2)
                        ]
                    ];
                }
                x.smoothopen = function(t1, e1) {
                    if (t1.length < 3) return "M" + t1.join("L");
                    var r, n = "M" + t1[0], i = [];
                    for(r = 1; r < t1.length - 1; r++)i.push(C(t1[r - 1], t1[r], t1[r + 1], e1));
                    for(n += "Q" + i[0][0] + " " + t1[1], r = 2; r < t1.length - 1; r++)n += "C" + i[r - 2][1] + " " + i[r - 1][0] + " " + t1[r];
                    return n += "Q" + i[t1.length - 3][1] + " " + t1[t1.length - 1];
                }, x.smoothclosed = function(t1, e1) {
                    if (t1.length < 3) return "M" + t1.join("L") + "Z";
                    var r, n = "M" + t1[0], i = t1.length - 1, a = [
                        C(t1[i], t1[0], t1[1], e1)
                    ];
                    for(r = 1; r < i; r++)a.push(C(t1[r - 1], t1[r], t1[r + 1], e1));
                    for(a.push(C(t1[i - 1], t1[i], t1[0], e1)), r = 1; r <= i; r++)n += "C" + a[r - 1][1] + " " + a[r][0] + " " + t1[r];
                    return n += "C" + a[i][1] + " " + a[0][0] + " " + t1[0] + "Z";
                };
                var P = {
                    hv: function(t1, e1) {
                        return "H" + n.round(e1[0], 2) + "V" + n.round(e1[1], 2);
                    },
                    vh: function(t1, e1) {
                        return "V" + n.round(e1[1], 2) + "H" + n.round(e1[0], 2);
                    },
                    hvh: function(t1, e1) {
                        return "H" + n.round((t1[0] + e1[0]) / 2, 2) + "V" + n.round(e1[1], 2) + "H" + n.round(e1[0], 2);
                    },
                    vhv: function(t1, e1) {
                        return "V" + n.round((t1[1] + e1[1]) / 2, 2) + "H" + n.round(e1[0], 2) + "V" + n.round(e1[1], 2);
                    }
                }, I = function(t1, e1) {
                    return "L" + n.round(e1[0], 2) + "," + n.round(e1[1], 2);
                };
                x.steps = function(t1) {
                    var e1 = P[t1] || I;
                    return function(t1) {
                        for(var r = "M" + n.round(t1[0][0], 2) + "," + n.round(t1[0][1], 2), i = 1; i < t1.length; i++)r += e1(t1[i - 1], t1[i]);
                        return r;
                    };
                }, x.makeTester = function() {
                    var t1 = i.ensureSingleById(n.select("body"), "svg", "js-plotly-tester", function(t1) {
                        t1.attr(p.svgAttrs).style({
                            position: "absolute",
                            left: "-10000px",
                            top: "-10000px",
                            width: "9000px",
                            height: "9000px",
                            "z-index": "1"
                        });
                    }), e1 = i.ensureSingle(t1, "path", "js-reference-point", function(t1) {
                        t1.attr("d", "M0,0H1V1H0Z").style({
                            "stroke-width": 0,
                            fill: "black"
                        });
                    });
                    x.tester = t1, x.testref = e1;
                }, x.savedBBoxes = {};
                var O = 0;
                function z(t1) {
                    var e1 = t1.getAttribute("data-unformatted");
                    if (null !== e1) return e1 + t1.getAttribute("data-math") + t1.getAttribute("text-anchor") + t1.getAttribute("style");
                }
                function D(t1, e1) {
                    if (!t1) return null;
                    var r = e1._context, n = r._exportedPlot ? "" : r._baseUrl || "";
                    return n ? "url('" + n + "#" + t1 + "')" : "url(#" + t1 + ")";
                }
                x.bBox = function(t1, e1, r) {
                    var a, o, s;
                    if (r || (r = z(t1)), r) {
                        if (a = x.savedBBoxes[r]) return i.extendFlat({}, a);
                    } else if (1 === t1.childNodes.length) {
                        var l = t1.childNodes[0];
                        if (r = z(l)) {
                            var c = +l.getAttribute("x") || 0, u = +l.getAttribute("y") || 0, f = l.getAttribute("transform");
                            if (!f) {
                                var p = x.bBox(l, !1, r);
                                return c && (p.left += c, p.right += c), u && (p.top += u, p.bottom += u), p;
                            }
                            if (r += "~" + c + "~" + u + "~" + f, a = x.savedBBoxes[r]) return i.extendFlat({}, a);
                        }
                    }
                    e1 ? o = t1 : (s = x.tester.node(), o = t1.cloneNode(!0), s.appendChild(o)), n.select(o).attr("transform", null).call(h.positionText, 0, 0);
                    var d = o.getBoundingClientRect(), m = x.testref.node().getBoundingClientRect();
                    e1 || s.removeChild(o);
                    var g = {
                        height: d.height,
                        width: d.width,
                        left: d.left - m.left,
                        top: d.top - m.top,
                        right: d.right - m.left,
                        bottom: d.bottom - m.top
                    };
                    return O >= 1e4 && (x.savedBBoxes = {}, O = 0), r && (x.savedBBoxes[r] = g), O++, i.extendFlat({}, g);
                }, x.setClipUrl = function(t1, e1, r) {
                    t1.attr("clip-path", D(e1, r));
                }, x.getTranslate = function(t1) {
                    var e1 = (t1[t1.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/, function(t1, e1, r) {
                        return [
                            e1,
                            r
                        ].join(" ");
                    }).split(" ");
                    return {
                        x: +e1[0] || 0,
                        y: +e1[1] || 0
                    };
                }, x.setTranslate = function(t1, e1, r) {
                    var n = t1.attr ? "attr" : "getAttribute", i = t1.attr ? "attr" : "setAttribute", a = t1[n]("transform") || "";
                    return e1 = e1 || 0, r = r || 0, a = a.replace(/(\btranslate\(.*?\);?)/, "").trim(), a = (a += f(e1, r)).trim(), t1[i]("transform", a), a;
                }, x.getScale = function(t1) {
                    var e1 = (t1[t1.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/, function(t1, e1, r) {
                        return [
                            e1,
                            r
                        ].join(" ");
                    }).split(" ");
                    return {
                        x: +e1[0] || 1,
                        y: +e1[1] || 1
                    };
                }, x.setScale = function(t1, e1, r) {
                    var n = t1.attr ? "attr" : "getAttribute", i = t1.attr ? "attr" : "setAttribute", a = t1[n]("transform") || "";
                    return e1 = e1 || 1, r = r || 1, a = a.replace(/(\bscale\(.*?\);?)/, "").trim(), a = (a += "scale(" + e1 + "," + r + ")").trim(), t1[i]("transform", a), a;
                };
                var R = /\s*sc.*/;
                x.setPointGroupScale = function(t1, e1, r) {
                    if (e1 = e1 || 1, r = r || 1, t1) {
                        var n = 1 === e1 && 1 === r ? "" : "scale(" + e1 + "," + r + ")";
                        t1.each(function() {
                            var t1 = (this.getAttribute("transform") || "").replace(R, "");
                            t1 = (t1 += n).trim(), this.setAttribute("transform", t1);
                        });
                    }
                };
                var F = /translate\([^)]*\)\s*$/;
                x.setTextPointsScale = function(t1, e1, r) {
                    t1 && t1.each(function() {
                        var t1, i = n.select(this), a = i.select("text");
                        if (a.node()) {
                            var o = parseFloat(a.attr("x") || 0), s = parseFloat(a.attr("y") || 0), l = (i.attr("transform") || "").match(F);
                            t1 = 1 === e1 && 1 === r ? [] : [
                                f(o, s),
                                "scale(" + e1 + "," + r + ")",
                                f(-o, -s)
                            ], l && t1.push(l), i.attr("transform", t1.join(""));
                        }
                    });
                };
            },
            {
                "../../components/fx/helpers": 402,
                "../../constants/alignment": 471,
                "../../constants/interactions": 478,
                "../../constants/xmlns_namespaces": 480,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../registry": 638,
                "../../traces/scatter/make_bubble_size_func": 943,
                "../../traces/scatter/subtypes": 951,
                "../color": 366,
                "../colorscale": 378,
                "./symbol_defs": 389,
                "@plotly/d3": 58,
                "fast-isnumeric": 190,
                tinycolor2: 312
            }
        ],
        389: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3");
                e1.exports = {
                    circle: {
                        n: 0,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M" + e1 + ",0A" + e1 + "," + e1 + " 0 1,1 0,-" + e1 + "A" + e1 + "," + e1 + " 0 0,1 " + e1 + ",0Z";
                        }
                    },
                    square: {
                        n: 1,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M" + e1 + "," + e1 + "H-" + e1 + "V-" + e1 + "H" + e1 + "Z";
                        }
                    },
                    diamond: {
                        n: 2,
                        f: function(t1) {
                            var e1 = n.round(1.3 * t1, 2);
                            return "M" + e1 + ",0L0," + e1 + "L-" + e1 + ",0L0,-" + e1 + "Z";
                        }
                    },
                    cross: {
                        n: 3,
                        f: function(t1) {
                            var e1 = n.round(.4 * t1, 2), r = n.round(1.2 * t1, 2);
                            return "M" + r + "," + e1 + "H" + e1 + "V" + r + "H-" + e1 + "V" + e1 + "H-" + r + "V-" + e1 + "H-" + e1 + "V-" + r + "H" + e1 + "V-" + e1 + "H" + r + "Z";
                        }
                    },
                    x: {
                        n: 4,
                        f: function(t1) {
                            var e1 = n.round(.8 * t1 / Math.sqrt(2), 2), r = "l" + e1 + "," + e1, i = "l" + e1 + ",-" + e1, a = "l-" + e1 + ",-" + e1, o = "l-" + e1 + "," + e1;
                            return "M0," + e1 + r + i + a + i + a + o + a + o + r + o + r + "Z";
                        }
                    },
                    "triangle-up": {
                        n: 5,
                        f: function(t1) {
                            var e1 = n.round(2 * t1 / Math.sqrt(3), 2);
                            return "M-" + e1 + "," + n.round(t1 / 2, 2) + "H" + e1 + "L0,-" + n.round(t1, 2) + "Z";
                        }
                    },
                    "triangle-down": {
                        n: 6,
                        f: function(t1) {
                            var e1 = n.round(2 * t1 / Math.sqrt(3), 2);
                            return "M-" + e1 + ",-" + n.round(t1 / 2, 2) + "H" + e1 + "L0," + n.round(t1, 2) + "Z";
                        }
                    },
                    "triangle-left": {
                        n: 7,
                        f: function(t1) {
                            var e1 = n.round(2 * t1 / Math.sqrt(3), 2);
                            return "M" + n.round(t1 / 2, 2) + ",-" + e1 + "V" + e1 + "L-" + n.round(t1, 2) + ",0Z";
                        }
                    },
                    "triangle-right": {
                        n: 8,
                        f: function(t1) {
                            var e1 = n.round(2 * t1 / Math.sqrt(3), 2);
                            return "M-" + n.round(t1 / 2, 2) + ",-" + e1 + "V" + e1 + "L" + n.round(t1, 2) + ",0Z";
                        }
                    },
                    "triangle-ne": {
                        n: 9,
                        f: function(t1) {
                            var e1 = n.round(.6 * t1, 2), r = n.round(1.2 * t1, 2);
                            return "M-" + r + ",-" + e1 + "H" + e1 + "V" + r + "Z";
                        }
                    },
                    "triangle-se": {
                        n: 10,
                        f: function(t1) {
                            var e1 = n.round(.6 * t1, 2), r = n.round(1.2 * t1, 2);
                            return "M" + e1 + ",-" + r + "V" + e1 + "H-" + r + "Z";
                        }
                    },
                    "triangle-sw": {
                        n: 11,
                        f: function(t1) {
                            var e1 = n.round(.6 * t1, 2), r = n.round(1.2 * t1, 2);
                            return "M" + r + "," + e1 + "H-" + e1 + "V-" + r + "Z";
                        }
                    },
                    "triangle-nw": {
                        n: 12,
                        f: function(t1) {
                            var e1 = n.round(.6 * t1, 2), r = n.round(1.2 * t1, 2);
                            return "M-" + e1 + "," + r + "V-" + e1 + "H" + r + "Z";
                        }
                    },
                    pentagon: {
                        n: 13,
                        f: function(t1) {
                            var e1 = n.round(.951 * t1, 2), r = n.round(.588 * t1, 2), i = n.round(-t1, 2), a = n.round(-0.309 * t1, 2);
                            return "M" + e1 + "," + a + "L" + r + "," + n.round(.809 * t1, 2) + "H-" + r + "L-" + e1 + "," + a + "L0," + i + "Z";
                        }
                    },
                    hexagon: {
                        n: 14,
                        f: function(t1) {
                            var e1 = n.round(t1, 2), r = n.round(t1 / 2, 2), i = n.round(t1 * Math.sqrt(3) / 2, 2);
                            return "M" + i + ",-" + r + "V" + r + "L0," + e1 + "L-" + i + "," + r + "V-" + r + "L0,-" + e1 + "Z";
                        }
                    },
                    hexagon2: {
                        n: 15,
                        f: function(t1) {
                            var e1 = n.round(t1, 2), r = n.round(t1 / 2, 2), i = n.round(t1 * Math.sqrt(3) / 2, 2);
                            return "M-" + r + "," + i + "H" + r + "L" + e1 + ",0L" + r + ",-" + i + "H-" + r + "L-" + e1 + ",0Z";
                        }
                    },
                    octagon: {
                        n: 16,
                        f: function(t1) {
                            var e1 = n.round(.924 * t1, 2), r = n.round(.383 * t1, 2);
                            return "M-" + r + ",-" + e1 + "H" + r + "L" + e1 + ",-" + r + "V" + r + "L" + r + "," + e1 + "H-" + r + "L-" + e1 + "," + r + "V-" + r + "Z";
                        }
                    },
                    star: {
                        n: 17,
                        f: function(t1) {
                            var e1 = 1.4 * t1, r = n.round(.225 * e1, 2), i = n.round(.951 * e1, 2), a = n.round(.363 * e1, 2), o = n.round(.588 * e1, 2), s = n.round(-e1, 2), l = n.round(-0.309 * e1, 2), c = n.round(.118 * e1, 2), u = n.round(.809 * e1, 2);
                            return "M" + r + "," + l + "H" + i + "L" + a + "," + c + "L" + o + "," + u + "L0," + n.round(.382 * e1, 2) + "L-" + o + "," + u + "L-" + a + "," + c + "L-" + i + "," + l + "H-" + r + "L0," + s + "Z";
                        }
                    },
                    hexagram: {
                        n: 18,
                        f: function(t1) {
                            var e1 = n.round(.66 * t1, 2), r = n.round(.38 * t1, 2), i = n.round(.76 * t1, 2);
                            return "M-" + i + ",0l-" + r + ",-" + e1 + "h" + i + "l" + r + ",-" + e1 + "l" + r + "," + e1 + "h" + i + "l-" + r + "," + e1 + "l" + r + "," + e1 + "h-" + i + "l-" + r + "," + e1 + "l-" + r + ",-" + e1 + "h-" + i + "Z";
                        }
                    },
                    "star-triangle-up": {
                        n: 19,
                        f: function(t1) {
                            var e1 = n.round(t1 * Math.sqrt(3) * .8, 2), r = n.round(.8 * t1, 2), i = n.round(1.6 * t1, 2), a = n.round(4 * t1, 2), o = "A " + a + "," + a + " 0 0 1 ";
                            return "M-" + e1 + "," + r + o + e1 + "," + r + o + "0,-" + i + o + "-" + e1 + "," + r + "Z";
                        }
                    },
                    "star-triangle-down": {
                        n: 20,
                        f: function(t1) {
                            var e1 = n.round(t1 * Math.sqrt(3) * .8, 2), r = n.round(.8 * t1, 2), i = n.round(1.6 * t1, 2), a = n.round(4 * t1, 2), o = "A " + a + "," + a + " 0 0 1 ";
                            return "M" + e1 + ",-" + r + o + "-" + e1 + ",-" + r + o + "0," + i + o + e1 + ",-" + r + "Z";
                        }
                    },
                    "star-square": {
                        n: 21,
                        f: function(t1) {
                            var e1 = n.round(1.1 * t1, 2), r = n.round(2 * t1, 2), i = "A " + r + "," + r + " 0 0 1 ";
                            return "M-" + e1 + ",-" + e1 + i + "-" + e1 + "," + e1 + i + e1 + "," + e1 + i + e1 + ",-" + e1 + i + "-" + e1 + ",-" + e1 + "Z";
                        }
                    },
                    "star-diamond": {
                        n: 22,
                        f: function(t1) {
                            var e1 = n.round(1.4 * t1, 2), r = n.round(1.9 * t1, 2), i = "A " + r + "," + r + " 0 0 1 ";
                            return "M-" + e1 + ",0" + i + "0," + e1 + i + e1 + ",0" + i + "0,-" + e1 + i + "-" + e1 + ",0Z";
                        }
                    },
                    "diamond-tall": {
                        n: 23,
                        f: function(t1) {
                            var e1 = n.round(.7 * t1, 2), r = n.round(1.4 * t1, 2);
                            return "M0," + r + "L" + e1 + ",0L0,-" + r + "L-" + e1 + ",0Z";
                        }
                    },
                    "diamond-wide": {
                        n: 24,
                        f: function(t1) {
                            var e1 = n.round(1.4 * t1, 2), r = n.round(.7 * t1, 2);
                            return "M0," + r + "L" + e1 + ",0L0,-" + r + "L-" + e1 + ",0Z";
                        }
                    },
                    hourglass: {
                        n: 25,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M" + e1 + "," + e1 + "H-" + e1 + "L" + e1 + ",-" + e1 + "H-" + e1 + "Z";
                        },
                        noDot: !0
                    },
                    bowtie: {
                        n: 26,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M" + e1 + "," + e1 + "V-" + e1 + "L-" + e1 + "," + e1 + "V-" + e1 + "Z";
                        },
                        noDot: !0
                    },
                    "circle-cross": {
                        n: 27,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M0," + e1 + "V-" + e1 + "M" + e1 + ",0H-" + e1 + "M" + e1 + ",0A" + e1 + "," + e1 + " 0 1,1 0,-" + e1 + "A" + e1 + "," + e1 + " 0 0,1 " + e1 + ",0Z";
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "circle-x": {
                        n: 28,
                        f: function(t1) {
                            var e1 = n.round(t1, 2), r = n.round(t1 / Math.sqrt(2), 2);
                            return "M" + r + "," + r + "L-" + r + ",-" + r + "M" + r + ",-" + r + "L-" + r + "," + r + "M" + e1 + ",0A" + e1 + "," + e1 + " 0 1,1 0,-" + e1 + "A" + e1 + "," + e1 + " 0 0,1 " + e1 + ",0Z";
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "square-cross": {
                        n: 29,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M0," + e1 + "V-" + e1 + "M" + e1 + ",0H-" + e1 + "M" + e1 + "," + e1 + "H-" + e1 + "V-" + e1 + "H" + e1 + "Z";
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "square-x": {
                        n: 30,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M" + e1 + "," + e1 + "L-" + e1 + ",-" + e1 + "M" + e1 + ",-" + e1 + "L-" + e1 + "," + e1 + "M" + e1 + "," + e1 + "H-" + e1 + "V-" + e1 + "H" + e1 + "Z";
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "diamond-cross": {
                        n: 31,
                        f: function(t1) {
                            var e1 = n.round(1.3 * t1, 2);
                            return "M" + e1 + ",0L0," + e1 + "L-" + e1 + ",0L0,-" + e1 + "ZM0,-" + e1 + "V" + e1 + "M-" + e1 + ",0H" + e1;
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "diamond-x": {
                        n: 32,
                        f: function(t1) {
                            var e1 = n.round(1.3 * t1, 2), r = n.round(.65 * t1, 2);
                            return "M" + e1 + ",0L0," + e1 + "L-" + e1 + ",0L0,-" + e1 + "ZM-" + r + ",-" + r + "L" + r + "," + r + "M-" + r + "," + r + "L" + r + ",-" + r;
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "cross-thin": {
                        n: 33,
                        f: function(t1) {
                            var e1 = n.round(1.4 * t1, 2);
                            return "M0," + e1 + "V-" + e1 + "M" + e1 + ",0H-" + e1;
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "x-thin": {
                        n: 34,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M" + e1 + "," + e1 + "L-" + e1 + ",-" + e1 + "M" + e1 + ",-" + e1 + "L-" + e1 + "," + e1;
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    asterisk: {
                        n: 35,
                        f: function(t1) {
                            var e1 = n.round(1.2 * t1, 2), r = n.round(.85 * t1, 2);
                            return "M0," + e1 + "V-" + e1 + "M" + e1 + ",0H-" + e1 + "M" + r + "," + r + "L-" + r + ",-" + r + "M" + r + ",-" + r + "L-" + r + "," + r;
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    hash: {
                        n: 36,
                        f: function(t1) {
                            var e1 = n.round(t1 / 2, 2), r = n.round(t1, 2);
                            return "M" + e1 + "," + r + "V-" + r + "m-" + r + ",0V" + r + "M" + r + "," + e1 + "H-" + r + "m0,-" + r + "H" + r;
                        },
                        needLine: !0,
                        noFill: !0
                    },
                    "y-up": {
                        n: 37,
                        f: function(t1) {
                            var e1 = n.round(1.2 * t1, 2), r = n.round(1.6 * t1, 2), i = n.round(.8 * t1, 2);
                            return "M-" + e1 + "," + i + "L0,0M" + e1 + "," + i + "L0,0M0,-" + r + "L0,0";
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "y-down": {
                        n: 38,
                        f: function(t1) {
                            var e1 = n.round(1.2 * t1, 2), r = n.round(1.6 * t1, 2), i = n.round(.8 * t1, 2);
                            return "M-" + e1 + ",-" + i + "L0,0M" + e1 + ",-" + i + "L0,0M0," + r + "L0,0";
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "y-left": {
                        n: 39,
                        f: function(t1) {
                            var e1 = n.round(1.2 * t1, 2), r = n.round(1.6 * t1, 2), i = n.round(.8 * t1, 2);
                            return "M" + i + "," + e1 + "L0,0M" + i + ",-" + e1 + "L0,0M-" + r + ",0L0,0";
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "y-right": {
                        n: 40,
                        f: function(t1) {
                            var e1 = n.round(1.2 * t1, 2), r = n.round(1.6 * t1, 2), i = n.round(.8 * t1, 2);
                            return "M-" + i + "," + e1 + "L0,0M-" + i + ",-" + e1 + "L0,0M" + r + ",0L0,0";
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "line-ew": {
                        n: 41,
                        f: function(t1) {
                            var e1 = n.round(1.4 * t1, 2);
                            return "M" + e1 + ",0H-" + e1;
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "line-ns": {
                        n: 42,
                        f: function(t1) {
                            var e1 = n.round(1.4 * t1, 2);
                            return "M0," + e1 + "V-" + e1;
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "line-ne": {
                        n: 43,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M" + e1 + ",-" + e1 + "L-" + e1 + "," + e1;
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "line-nw": {
                        n: 44,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M" + e1 + "," + e1 + "L-" + e1 + ",-" + e1;
                        },
                        needLine: !0,
                        noDot: !0,
                        noFill: !0
                    },
                    "arrow-up": {
                        n: 45,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M0,0L-" + e1 + "," + n.round(2 * t1, 2) + "H" + e1 + "Z";
                        },
                        noDot: !0
                    },
                    "arrow-down": {
                        n: 46,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M0,0L-" + e1 + ",-" + n.round(2 * t1, 2) + "H" + e1 + "Z";
                        },
                        noDot: !0
                    },
                    "arrow-left": {
                        n: 47,
                        f: function(t1) {
                            var e1 = n.round(2 * t1, 2), r = n.round(t1, 2);
                            return "M0,0L" + e1 + ",-" + r + "V" + r + "Z";
                        },
                        noDot: !0
                    },
                    "arrow-right": {
                        n: 48,
                        f: function(t1) {
                            var e1 = n.round(2 * t1, 2), r = n.round(t1, 2);
                            return "M0,0L-" + e1 + ",-" + r + "V" + r + "Z";
                        },
                        noDot: !0
                    },
                    "arrow-bar-up": {
                        n: 49,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M-" + e1 + ",0H" + e1 + "M0,0L-" + e1 + "," + n.round(2 * t1, 2) + "H" + e1 + "Z";
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "arrow-bar-down": {
                        n: 50,
                        f: function(t1) {
                            var e1 = n.round(t1, 2);
                            return "M-" + e1 + ",0H" + e1 + "M0,0L-" + e1 + ",-" + n.round(2 * t1, 2) + "H" + e1 + "Z";
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "arrow-bar-left": {
                        n: 51,
                        f: function(t1) {
                            var e1 = n.round(2 * t1, 2), r = n.round(t1, 2);
                            return "M0,-" + r + "V" + r + "M0,0L" + e1 + ",-" + r + "V" + r + "Z";
                        },
                        needLine: !0,
                        noDot: !0
                    },
                    "arrow-bar-right": {
                        n: 52,
                        f: function(t1) {
                            var e1 = n.round(2 * t1, 2), r = n.round(t1, 2);
                            return "M0,-" + r + "V" + r + "M0,0L-" + e1 + ",-" + r + "V" + r + "Z";
                        },
                        needLine: !0,
                        noDot: !0
                    }
                };
            },
            {
                "@plotly/d3": 58
            }
        ],
        390: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    visible: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "percent",
                            "constant",
                            "sqrt",
                            "data"
                        ],
                        editType: "calc"
                    },
                    symmetric: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    array: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    arrayminus: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    value: {
                        valType: "number",
                        min: 0,
                        dflt: 10,
                        editType: "calc"
                    },
                    valueminus: {
                        valType: "number",
                        min: 0,
                        dflt: 10,
                        editType: "calc"
                    },
                    traceref: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "style"
                    },
                    tracerefminus: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "style"
                    },
                    copy_ystyle: {
                        valType: "boolean",
                        editType: "plot"
                    },
                    copy_zstyle: {
                        valType: "boolean",
                        editType: "style"
                    },
                    color: {
                        valType: "color",
                        editType: "style"
                    },
                    thickness: {
                        valType: "number",
                        min: 0,
                        dflt: 2,
                        editType: "style"
                    },
                    width: {
                        valType: "number",
                        min: 0,
                        editType: "plot"
                    },
                    editType: "calc",
                    _deprecated: {
                        opacity: {
                            valType: "number",
                            editType: "style"
                        }
                    }
                };
            },
            {}
        ],
        391: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../registry"), a = t1("../../plots/cartesian/axes"), o = t1("../../lib"), s = t1("./compute_error");
                function l(t1, e1, r, i) {
                    var l = e1["error_" + i] || {}, c = [];
                    if (l.visible && -1 !== [
                        "linear",
                        "log"
                    ].indexOf(r.type)) {
                        for(var u = s(l), f = 0; f < t1.length; f++){
                            var h = t1[f], p = h.i;
                            if (void 0 === p) p = f;
                            else if (null === p) continue;
                            var d = h[i];
                            if (n(r.c2l(d))) {
                                var m = u(d, p);
                                if (n(m[0]) && n(m[1])) {
                                    var g = h[i + "s"] = d - m[0], v = h[i + "h"] = d + m[1];
                                    c.push(g, v);
                                }
                            }
                        }
                        var y = r._id, x = e1._extremes[y], b = a.findExtremes(r, c, o.extendFlat({
                            tozero: x.opts.tozero
                        }, {
                            padded: !0
                        }));
                        x.min = x.min.concat(b.min), x.max = x.max.concat(b.max);
                    }
                }
                e1.exports = function(t1) {
                    for(var e1 = t1.calcdata, r = 0; r < e1.length; r++){
                        var n = e1[r], o = n[0].trace;
                        if (!0 === o.visible && i.traceIs(o, "errorBarsOK")) {
                            var s = a.getFromId(t1, o.xaxis), c = a.getFromId(t1, o.yaxis);
                            l(n, o, s, "x"), l(n, o, c, "y");
                        }
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "../../registry": 638,
                "./compute_error": 392,
                "fast-isnumeric": 190
            }
        ],
        392: [
            function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    return "percent" === t1 ? function(t1) {
                        return Math.abs(t1 * e1 / 100);
                    } : "constant" === t1 ? function() {
                        return Math.abs(e1);
                    } : "sqrt" === t1 ? function(t1) {
                        return Math.sqrt(Math.abs(t1));
                    } : void 0;
                }
                e1.exports = function(t1) {
                    var e1 = t1.type, r = t1.symmetric;
                    if ("data" === e1) {
                        var i = t1.array || [];
                        if (r) return function(t1, e1) {
                            var r = +i[e1];
                            return [
                                r,
                                r
                            ];
                        };
                        var a = t1.arrayminus || [];
                        return function(t1, e1) {
                            var r = +i[e1], n = +a[e1];
                            return isNaN(r) && isNaN(n) ? [
                                NaN,
                                NaN
                            ] : [
                                n || 0,
                                r || 0
                            ];
                        };
                    }
                    var o = n(e1, t1.value), s = n(e1, t1.valueminus);
                    return r || void 0 === t1.valueminus ? function(t1) {
                        var e1 = o(t1);
                        return [
                            e1,
                            e1
                        ];
                    } : function(t1) {
                        return [
                            s(t1),
                            o(t1)
                        ];
                    };
                };
            },
            {}
        ],
        393: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../registry"), a = t1("../../lib"), o = t1("../../plot_api/plot_template"), s = t1("./attributes");
                e1.exports = function(t1, e1, r, l) {
                    var c = "error_" + l.axis, u = o.newContainer(e1, c), f = t1[c] || {};
                    function h(t1, e1) {
                        return a.coerce(f, u, s, t1, e1);
                    }
                    if (!1 !== h("visible", void 0 !== f.array || void 0 !== f.value || "sqrt" === f.type)) {
                        var p = h("type", "array" in f ? "data" : "percent"), d = !0;
                        "sqrt" !== p && (d = h("symmetric", !(("data" === p ? "arrayminus" : "valueminus") in f))), "data" === p ? (h("array"), h("traceref"), d || (h("arrayminus"), h("tracerefminus"))) : "percent" !== p && "constant" !== p || (h("value"), d || h("valueminus"));
                        var m = "copy_" + l.inherit + "style";
                        if (l.inherit) (e1["error_" + l.inherit] || {}).visible && h(m, !(f.color || n(f.thickness) || n(f.width)));
                        l.inherit && u[m] || (h("color", r), h("thickness"), h("width", i.traceIs(e1, "gl3d") ? 0 : 4));
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../../registry": 638,
                "./attributes": 390,
                "fast-isnumeric": 190
            }
        ],
        394: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plot_api/edit_types").overrideAll, a = t1("./attributes"), o = {
                    error_x: n.extendFlat({}, a),
                    error_y: n.extendFlat({}, a)
                };
                delete o.error_x.copy_zstyle, delete o.error_y.copy_zstyle, delete o.error_y.copy_ystyle;
                var s = {
                    error_x: n.extendFlat({}, a),
                    error_y: n.extendFlat({}, a),
                    error_z: n.extendFlat({}, a)
                };
                delete s.error_x.copy_ystyle, delete s.error_y.copy_ystyle, delete s.error_z.copy_ystyle, delete s.error_z.copy_zstyle, e1.exports = {
                    moduleType: "component",
                    name: "errorbars",
                    schema: {
                        traces: {
                            scatter: o,
                            bar: o,
                            histogram: o,
                            scatter3d: i(s, "calc", "nested"),
                            scattergl: i(o, "calc", "nested")
                        }
                    },
                    supplyDefaults: t1("./defaults"),
                    calc: t1("./calc"),
                    makeComputeError: t1("./compute_error"),
                    plot: t1("./plot"),
                    style: t1("./style"),
                    hoverInfo: function(t1, e1, r) {
                        (e1.error_y || {}).visible && (r.yerr = t1.yh - t1.y, e1.error_y.symmetric || (r.yerrneg = t1.y - t1.ys));
                        (e1.error_x || {}).visible && (r.xerr = t1.xh - t1.x, e1.error_x.symmetric || (r.xerrneg = t1.x - t1.xs));
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plot_api/edit_types": 536,
                "./attributes": 390,
                "./calc": 391,
                "./compute_error": 392,
                "./defaults": 393,
                "./plot": 395,
                "./style": 396
            }
        ],
        395: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("fast-isnumeric"), a = t1("../drawing"), o = t1("../../traces/scatter/subtypes");
                e1.exports = function(t1, e1, r, s) {
                    var l = r.xaxis, c = r.yaxis, u = s && s.duration > 0;
                    e1.each(function(e1) {
                        var f, h = e1[0].trace, p = h.error_x || {}, d = h.error_y || {};
                        h.ids && (f = function(t1) {
                            return t1.id;
                        });
                        var m = o.hasMarkers(h) && h.marker.maxdisplayed > 0;
                        d.visible || p.visible || (e1 = []);
                        var g = n.select(this).selectAll("g.errorbar").data(e1, f);
                        if (g.exit().remove(), e1.length) {
                            p.visible || g.selectAll("path.xerror").remove(), d.visible || g.selectAll("path.yerror").remove(), g.style("opacity", 1);
                            var v = g.enter().append("g").classed("errorbar", !0);
                            u && v.style("opacity", 0).transition().duration(s.duration).style("opacity", 1), a.setClipUrl(g, r.layerClipId, t1), g.each(function(t1) {
                                var e1 = n.select(this), r = function(t1, e1, r) {
                                    var n = {
                                        x: e1.c2p(t1.x),
                                        y: r.c2p(t1.y)
                                    };
                                    void 0 !== t1.yh && (n.yh = r.c2p(t1.yh), n.ys = r.c2p(t1.ys), i(n.ys) || (n.noYS = !0, n.ys = r.c2p(t1.ys, !0)));
                                    void 0 !== t1.xh && (n.xh = e1.c2p(t1.xh), n.xs = e1.c2p(t1.xs), i(n.xs) || (n.noXS = !0, n.xs = e1.c2p(t1.xs, !0)));
                                    return n;
                                }(t1, l, c);
                                if (!m || t1.vis) {
                                    var a, o = e1.select("path.yerror");
                                    if (d.visible && i(r.x) && i(r.yh) && i(r.ys)) {
                                        var f = d.width;
                                        a = "M" + (r.x - f) + "," + r.yh + "h" + 2 * f + "m-" + f + ",0V" + r.ys, r.noYS || (a += "m-" + f + ",0h" + 2 * f), !o.size() ? o = e1.append("path").style("vector-effect", "non-scaling-stroke").classed("yerror", !0) : u && (o = o.transition().duration(s.duration).ease(s.easing)), o.attr("d", a);
                                    } else o.remove();
                                    var h = e1.select("path.xerror");
                                    if (p.visible && i(r.y) && i(r.xh) && i(r.xs)) {
                                        var g = (p.copy_ystyle ? d : p).width;
                                        a = "M" + r.xh + "," + (r.y - g) + "v" + 2 * g + "m0,-" + g + "H" + r.xs, r.noXS || (a += "m0,-" + g + "v" + 2 * g), !h.size() ? h = e1.append("path").style("vector-effect", "non-scaling-stroke").classed("xerror", !0) : u && (h = h.transition().duration(s.duration).ease(s.easing)), h.attr("d", a);
                                    } else h.remove();
                                }
                            });
                        }
                    });
                };
            },
            {
                "../../traces/scatter/subtypes": 951,
                "../drawing": 388,
                "@plotly/d3": 58,
                "fast-isnumeric": 190
            }
        ],
        396: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../color");
                e1.exports = function(t1) {
                    t1.each(function(t1) {
                        var e1 = t1[0].trace, r = e1.error_y || {}, a = e1.error_x || {}, o = n.select(this);
                        o.selectAll("path.yerror").style("stroke-width", r.thickness + "px").call(i.stroke, r.color), a.copy_ystyle && (a = r), o.selectAll("path.xerror").style("stroke-width", a.thickness + "px").call(i.stroke, a.color);
                    });
                };
            },
            {
                "../color": 366,
                "@plotly/d3": 58
            }
        ],
        397: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/font_attributes"), i = t1("./layout_attributes").hoverlabel, a = t1("../../lib/extend").extendFlat;
                e1.exports = {
                    hoverlabel: {
                        bgcolor: a({}, i.bgcolor, {
                            arrayOk: !0
                        }),
                        bordercolor: a({}, i.bordercolor, {
                            arrayOk: !0
                        }),
                        font: n({
                            arrayOk: !0,
                            editType: "none"
                        }),
                        align: a({}, i.align, {
                            arrayOk: !0
                        }),
                        namelength: a({}, i.namelength, {
                            arrayOk: !0
                        }),
                        editType: "none"
                    }
                };
            },
            {
                "../../lib/extend": 493,
                "../../plots/font_attributes": 585,
                "./layout_attributes": 407
            }
        ],
        398: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../registry");
                function a(t1, e1, r, i) {
                    i = i || n.identity, Array.isArray(t1) && (e1[0][r] = i(t1));
                }
                e1.exports = function(t1) {
                    var e1 = t1.calcdata, r = t1._fullLayout;
                    function o(t1) {
                        return function(e1) {
                            return n.coerceHoverinfo({
                                hoverinfo: e1
                            }, {
                                _module: t1._module
                            }, r);
                        };
                    }
                    for(var s = 0; s < e1.length; s++){
                        var l = e1[s], c = l[0].trace;
                        if (!i.traceIs(c, "pie-like")) {
                            var u = i.traceIs(c, "2dMap") ? a : n.fillArray;
                            u(c.hoverinfo, l, "hi", o(c)), c.hovertemplate && u(c.hovertemplate, l, "ht"), c.hoverlabel && (u(c.hoverlabel.bgcolor, l, "hbg"), u(c.hoverlabel.bordercolor, l, "hbc"), u(c.hoverlabel.font.size, l, "hts"), u(c.hoverlabel.font.color, l, "htc"), u(c.hoverlabel.font.family, l, "htf"), u(c.hoverlabel.namelength, l, "hnl"), u(c.hoverlabel.align, l, "hta"));
                        }
                    }
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638
            }
        ],
        399: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("./hover").hover;
                e1.exports = function(t1, e1, r) {
                    var a = n.getComponentMethod("annotations", "onClick")(t1, t1._hoverdata);
                    function o() {
                        t1.emit("plotly_click", {
                            points: t1._hoverdata,
                            event: e1
                        });
                    }
                    void 0 !== r && i(t1, e1, r, !0), t1._hoverdata && e1 && e1.target && (a && a.then ? a.then(o) : o(), e1.stopImmediatePropagation && e1.stopImmediatePropagation());
                };
            },
            {
                "../../registry": 638,
                "./hover": 403
            }
        ],
        400: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    YANGLE: 60,
                    HOVERARROWSIZE: 6,
                    HOVERTEXTPAD: 3,
                    HOVERFONTSIZE: 13,
                    HOVERFONT: "Arial, sans-serif",
                    HOVERMINTIME: 50,
                    HOVERID: "-hover"
                };
            },
            {}
        ],
        401: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./attributes"), a = t1("./hoverlabel_defaults");
                e1.exports = function(t1, e1, r, o) {
                    var s = n.extendFlat({}, o.hoverlabel);
                    e1.hovertemplate && (s.namelength = -1), a(t1, e1, function(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }, s);
                };
            },
            {
                "../../lib": 503,
                "./attributes": 397,
                "./hoverlabel_defaults": 404
            }
        ],
        402: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                r.getSubplot = function(t1) {
                    return t1.subplot || t1.xaxis + t1.yaxis || t1.geo;
                }, r.isTraceInSubplots = function(t1, e1) {
                    if ("splom" === t1.type) {
                        for(var n = t1.xaxes || [], i = t1.yaxes || [], a = 0; a < n.length; a++)for(var o = 0; o < i.length; o++)if (-1 !== e1.indexOf(n[a] + i[o])) return !0;
                        return !1;
                    }
                    return -1 !== e1.indexOf(r.getSubplot(t1));
                }, r.flat = function(t1, e1) {
                    for(var r = new Array(t1.length), n = 0; n < t1.length; n++)r[n] = e1;
                    return r;
                }, r.p2c = function(t1, e1) {
                    for(var r = new Array(t1.length), n = 0; n < t1.length; n++)r[n] = t1[n].p2c(e1);
                    return r;
                }, r.getDistanceFunction = function(t1, e1, n, i) {
                    return "closest" === t1 ? i || r.quadrature(e1, n) : "x" === t1.charAt(0) ? e1 : n;
                }, r.getClosest = function(t1, e1, r) {
                    if (!1 !== r.index) r.index >= 0 && r.index < t1.length ? r.distance = 0 : r.index = !1;
                    else for(var n = 0; n < t1.length; n++){
                        var i = e1(t1[n]);
                        i <= r.distance && (r.index = n, r.distance = i);
                    }
                    return r;
                }, r.inbox = function(t1, e1, r) {
                    return t1 * e1 < 0 || 0 === t1 ? r : 1 / 0;
                }, r.quadrature = function(t1, e1) {
                    return function(r) {
                        var n = t1(r), i = e1(r);
                        return Math.sqrt(n * n + i * i);
                    };
                }, r.makeEventData = function(t1, e1, n) {
                    var i = "index" in t1 ? t1.index : t1.pointNumber, a = {
                        data: e1._input,
                        fullData: e1,
                        curveNumber: e1.index,
                        pointNumber: i
                    };
                    if (e1._indexToPoints) {
                        var o = e1._indexToPoints[i];
                        1 === o.length ? a.pointIndex = o[0] : a.pointIndices = o;
                    } else a.pointIndex = i;
                    return e1._module.eventData ? a = e1._module.eventData(a, t1, e1, n, i) : ("xVal" in t1 ? a.x = t1.xVal : "x" in t1 && (a.x = t1.x), "yVal" in t1 ? a.y = t1.yVal : "y" in t1 && (a.y = t1.y), t1.xa && (a.xaxis = t1.xa), t1.ya && (a.yaxis = t1.ya), void 0 !== t1.zLabelVal && (a.z = t1.zLabelVal)), r.appendArrayPointValue(a, e1, i), a;
                }, r.appendArrayPointValue = function(t1, e1, r) {
                    var i = e1._arrayAttrs;
                    if (i) for(var s = 0; s < i.length; s++){
                        var l = i[s], c = a(l);
                        if (void 0 === t1[c]) {
                            var u = o(n.nestedProperty(e1, l).get(), r);
                            void 0 !== u && (t1[c] = u);
                        }
                    }
                }, r.appendArrayMultiPointValues = function(t1, e1, r) {
                    var i = e1._arrayAttrs;
                    if (i) for(var s = 0; s < i.length; s++){
                        var l = i[s], c = a(l);
                        if (void 0 === t1[c]) {
                            for(var u = n.nestedProperty(e1, l).get(), f = new Array(r.length), h = 0; h < r.length; h++)f[h] = o(u, r[h]);
                            t1[c] = f;
                        }
                    }
                };
                var i = {
                    ids: "id",
                    locations: "location",
                    labels: "label",
                    values: "value",
                    "marker.colors": "color",
                    parents: "parent"
                };
                function a(t1) {
                    return i[t1] || t1;
                }
                function o(t1, e1) {
                    return Array.isArray(e1) ? Array.isArray(t1) && Array.isArray(t1[e1[0]]) ? t1[e1[0]][e1[1]] : void 0 : t1[e1];
                }
                var s = {
                    x: !0,
                    y: !0
                }, l = {
                    "x unified": !0,
                    "y unified": !0
                };
                r.isUnifiedHover = function(t1) {
                    return "string" == typeof t1 && !!l[t1];
                }, r.isXYhover = function(t1) {
                    return "string" == typeof t1 && !!s[t1];
                };
            },
            {
                "../../lib": 503
            }
        ],
        403: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("fast-isnumeric"), a = t1("tinycolor2"), o = t1("../../lib"), s = o.strTranslate, l = o.strRotate, c = t1("../../lib/events"), u = t1("../../lib/svg_text_utils"), f = t1("../../lib/override_cursor"), h = t1("../drawing"), p = t1("../color"), d = t1("../dragelement"), m = t1("../../plots/cartesian/axes"), g = t1("../../registry"), v = t1("./helpers"), y = t1("./constants"), x = t1("../legend/defaults"), b = t1("../legend/draw"), _ = y.YANGLE, w = Math.PI * _ / 180, T = 1 / Math.sin(w), k = Math.cos(w), A = Math.sin(w), M = y.HOVERARROWSIZE, S = y.HOVERTEXTPAD, E = {
                    box: !0,
                    ohlc: !0,
                    violin: !0,
                    candlestick: !0
                }, L = {
                    scatter: !0,
                    scattergl: !0,
                    splom: !0
                };
                function C(t1) {
                    return [
                        t1.trace.index,
                        t1.index,
                        t1.x0,
                        t1.y0,
                        t1.name,
                        t1.attr,
                        t1.xa ? t1.xa._id : "",
                        t1.ya ? t1.ya._id : ""
                    ].join(",");
                }
                r.hover = function(t1, e1, r, a) {
                    t1 = o.getGraphDiv(t1);
                    var s = e1.target;
                    o.throttle(t1._fullLayout._uid + y.HOVERID, y.HOVERMINTIME, function() {
                        !function(t1, e1, r, a, s) {
                            r || (r = "xy");
                            var l = Array.isArray(r) ? r : [
                                r
                            ], u = t1._fullLayout, h = u._plots || [], m = h[r], y = u._has("cartesian");
                            if (m) {
                                var x = m.overlays.map(function(t1) {
                                    return t1.id;
                                });
                                l = l.concat(x);
                            }
                            for(var b = l.length, _ = new Array(b), w = new Array(b), k = !1, A = 0; A < b; A++){
                                var M = l[A];
                                if (h[M]) k = !0, _[A] = h[M].xaxis, w[A] = h[M].yaxis;
                                else {
                                    if (!u[M] || !u[M]._subplot) return void o.warn("Unrecognized subplot: " + M);
                                    var S = u[M]._subplot;
                                    _[A] = S.xaxis, w[A] = S.yaxis;
                                }
                            }
                            var P = e1.hovermode || u.hovermode;
                            P && !k && (P = "closest");
                            if (-1 === [
                                "x",
                                "y",
                                "closest",
                                "x unified",
                                "y unified"
                            ].indexOf(P) || !t1.calcdata || t1.querySelector(".zoombox") || t1._dragging) return d.unhoverRaw(t1, e1);
                            var O = u.hoverdistance;
                            -1 === O && (O = 1 / 0);
                            var B = u.spikedistance;
                            -1 === B && (B = 1 / 0);
                            var V, H, q, G, Y, W, X, Z, J, K, Q, $, tt, et = [], rt = [], nt = {
                                hLinePoint: null,
                                vLinePoint: null
                            }, it = !1;
                            if (Array.isArray(e1)) for(P = "array", q = 0; q < e1.length; q++)(Y = t1.calcdata[e1[q].curveNumber || 0]) && (W = Y[0].trace, "skip" !== Y[0].trace.hoverinfo && (rt.push(Y), "h" === W.orientation && (it = !0)));
                            else {
                                for(G = 0; G < t1.calcdata.length; G++)Y = t1.calcdata[G], "skip" !== (W = Y[0].trace).hoverinfo && v.isTraceInSubplots(W, l) && (rt.push(Y), "h" === W.orientation && (it = !0));
                                var at, ot;
                                if (!s) at = "xpx" in e1 ? e1.xpx : _[0]._length / 2, ot = "ypx" in e1 ? e1.ypx : w[0]._length / 2;
                                else {
                                    if (!1 === c.triggerHandler(t1, "plotly_beforehover", e1)) return;
                                    var st = s.getBoundingClientRect();
                                    at = e1.clientX - st.left, ot = e1.clientY - st.top, u._calcInverseTransform(t1);
                                    var lt = o.apply3DTransform(u._invTransform)(at, ot);
                                    if (at = lt[0], ot = lt[1], at < 0 || at > _[0]._length || ot < 0 || ot > w[0]._length) return d.unhoverRaw(t1, e1);
                                }
                                if (e1.pointerX = at + _[0]._offset, e1.pointerY = ot + w[0]._offset, V = "xval" in e1 ? v.flat(l, e1.xval) : v.p2c(_, at), H = "yval" in e1 ? v.flat(l, e1.yval) : v.p2c(w, ot), !i(V[0]) || !i(H[0])) return o.warn("Fx.hover failed", e1, t1), d.unhoverRaw(t1, e1);
                            }
                            var ct = 1 / 0;
                            function ut(t1, r) {
                                for(G = 0; G < rt.length; G++)if ((Y = rt[G]) && Y[0] && Y[0].trace && !0 === (W = Y[0].trace).visible && 0 !== W._length && -1 === [
                                    "carpet",
                                    "contourcarpet"
                                ].indexOf(W._module.name)) {
                                    if ("splom" === W.type ? X = l[Z = 0] : (X = v.getSubplot(W), Z = l.indexOf(X)), J = P, v.isUnifiedHover(J) && (J = J.charAt(0)), $ = {
                                        cd: Y,
                                        trace: W,
                                        xa: _[Z],
                                        ya: w[Z],
                                        maxHoverDistance: O,
                                        maxSpikeDistance: B,
                                        index: !1,
                                        distance: Math.min(ct, O),
                                        spikeDistance: 1 / 0,
                                        xSpike: void 0,
                                        ySpike: void 0,
                                        color: p.defaultLine,
                                        name: W.name,
                                        x0: void 0,
                                        x1: void 0,
                                        y0: void 0,
                                        y1: void 0,
                                        xLabelVal: void 0,
                                        yLabelVal: void 0,
                                        zLabelVal: void 0,
                                        text: void 0
                                    }, u[X] && ($.subplot = u[X]._subplot), u._splomScenes && u._splomScenes[W.uid] && ($.scene = u._splomScenes[W.uid]), tt = et.length, "array" === J) {
                                        var n = e1[G];
                                        "pointNumber" in n ? ($.index = n.pointNumber, J = "closest") : (J = "", "xval" in n && (K = n.xval, J = "x"), "yval" in n && (Q = n.yval, J = J ? "closest" : "y"));
                                    } else void 0 !== t1 && void 0 !== r ? (K = t1, Q = r) : (K = V[Z], Q = H[Z]);
                                    if (0 !== O) {
                                        if (W._module && W._module.hoverPoints) {
                                            var a = W._module.hoverPoints($, K, Q, J, {
                                                finiteRange: !0,
                                                hoverLayer: u._hoverlayer
                                            });
                                            if (a) for(var s, c = 0; c < a.length; c++)s = a[c], i(s.x0) && i(s.y0) && et.push(D(s, P));
                                        } else o.log("Unrecognized trace type in hover:", W);
                                    }
                                    if ("closest" === P && et.length > tt && (et.splice(0, tt), ct = et[0].distance), y && 0 !== B && 0 === et.length) {
                                        $.distance = B, $.index = !1;
                                        var f = W._module.hoverPoints($, K, Q, "closest", {
                                            hoverLayer: u._hoverlayer
                                        });
                                        if (f && (f = f.filter(function(t1) {
                                            return t1.spikeDistance <= B;
                                        })), f && f.length) {
                                            var h, d = f.filter(function(t1) {
                                                return t1.xa.showspikes && "hovered data" !== t1.xa.spikesnap;
                                            });
                                            if (d.length) {
                                                var m = d[0];
                                                i(m.x0) && i(m.y0) && (h = ht(m), (!nt.vLinePoint || nt.vLinePoint.spikeDistance > h.spikeDistance) && (nt.vLinePoint = h));
                                            }
                                            var g = f.filter(function(t1) {
                                                return t1.ya.showspikes && "hovered data" !== t1.ya.spikesnap;
                                            });
                                            if (g.length) {
                                                var x = g[0];
                                                i(x.x0) && i(x.y0) && (h = ht(x), (!nt.hLinePoint || nt.hLinePoint.spikeDistance > h.spikeDistance) && (nt.hLinePoint = h));
                                            }
                                        }
                                    }
                                }
                            }
                            function ft(t1, e1, r) {
                                for(var n, i = null, a = 1 / 0, o = 0; o < t1.length; o++)n = t1[o].spikeDistance, r && 0 === o && (n = -1 / 0), n <= a && n <= e1 && (i = t1[o], a = n);
                                return i;
                            }
                            function ht(t1) {
                                return t1 ? {
                                    xa: t1.xa,
                                    ya: t1.ya,
                                    x: void 0 !== t1.xSpike ? t1.xSpike : (t1.x0 + t1.x1) / 2,
                                    y: void 0 !== t1.ySpike ? t1.ySpike : (t1.y0 + t1.y1) / 2,
                                    distance: t1.distance,
                                    spikeDistance: t1.spikeDistance,
                                    curveNumber: t1.trace.index,
                                    color: t1.color,
                                    pointNumber: t1.index
                                } : null;
                            }
                            ut();
                            var pt = {
                                fullLayout: u,
                                container: u._hoverlayer,
                                event: e1
                            }, dt = t1._spikepoints, mt = {
                                vLinePoint: nt.vLinePoint,
                                hLinePoint: nt.hLinePoint
                            };
                            t1._spikepoints = mt;
                            var gt = function() {
                                et.sort(function(t1, e1) {
                                    return t1.distance - e1.distance;
                                }), et = function(t1, e1) {
                                    for(var r = e1.charAt(0), n = [], i = [], a = [], o = 0; o < t1.length; o++){
                                        var s = t1[o];
                                        g.traceIs(s.trace, "bar-like") || g.traceIs(s.trace, "box-violin") ? a.push(s) : s.trace[r + "period"] ? i.push(s) : n.push(s);
                                    }
                                    return n.concat(i).concat(a);
                                }(et, P);
                            };
                            gt();
                            var vt = P.charAt(0), yt = ("x" === vt || "y" === vt) && et[0] && L[et[0].trace.type];
                            if (y && 0 !== B && 0 !== et.length) {
                                var xt = ft(et.filter(function(t1) {
                                    return t1.ya.showspikes;
                                }), B, yt);
                                nt.hLinePoint = ht(xt);
                                var bt = ft(et.filter(function(t1) {
                                    return t1.xa.showspikes;
                                }), B, yt);
                                nt.vLinePoint = ht(bt);
                            }
                            if (0 === et.length) {
                                var _t = d.unhoverRaw(t1, e1);
                                return !y || null === nt.hLinePoint && null === nt.vLinePoint || F(dt) && R(t1, nt, pt), _t;
                            }
                            y && F(dt) && R(t1, nt, pt);
                            if (v.isXYhover(J) && 0 !== et[0].length && "splom" !== et[0].trace.type) {
                                var wt = et[0], Tt = (et = E[wt.trace.type] ? et.filter(function(t1) {
                                    return t1.trace.index === wt.trace.index;
                                }) : [
                                    wt
                                ]).length, kt = N("x", wt, u), At = N("y", wt, u);
                                ut(kt, At);
                                var Mt, St = [], Et = {}, Lt = 0, Ct = function(t1) {
                                    var e1 = E[t1.trace.type] ? C(t1) : t1.trace.index;
                                    if (Et[e1]) {
                                        var r = Et[e1] - 1, n = St[r];
                                        r > 0 && Math.abs(t1.distance) < Math.abs(n.distance) && (St[r] = t1);
                                    } else Lt++, Et[e1] = Lt, St.push(t1);
                                };
                                for(Mt = 0; Mt < Tt; Mt++)Ct(et[Mt]);
                                for(Mt = et.length - 1; Mt > Tt - 1; Mt--)Ct(et[Mt]);
                                et = St, gt();
                            }
                            var Pt = t1._hoverdata, It = [], Ot = j(t1), zt = U(t1);
                            for(q = 0; q < et.length; q++){
                                var Dt = et[q], Rt = v.makeEventData(Dt, Dt.trace, Dt.cd);
                                if (!1 !== Dt.hovertemplate) {
                                    var Ft = !1;
                                    Dt.cd[Dt.index] && Dt.cd[Dt.index].ht && (Ft = Dt.cd[Dt.index].ht), Dt.hovertemplate = Ft || Dt.trace.hovertemplate || !1;
                                }
                                if (Dt.xa && Dt.ya) {
                                    var Bt = Dt.x0 + Dt.xa._offset, Nt = Dt.x1 + Dt.xa._offset, jt = Dt.y0 + Dt.ya._offset, Ut = Dt.y1 + Dt.ya._offset, Vt = Math.min(Bt, Nt), Ht = Math.max(Bt, Nt), qt = Math.min(jt, Ut), Gt = Math.max(jt, Ut);
                                    Rt.bbox = {
                                        x0: Vt + zt,
                                        x1: Ht + zt,
                                        y0: qt + Ot,
                                        y1: Gt + Ot
                                    };
                                }
                                Dt.eventData = [
                                    Rt
                                ], It.push(Rt);
                            }
                            t1._hoverdata = It;
                            var Yt = "y" === P && (rt.length > 1 || et.length > 1) || "closest" === P && it && et.length > 1, Wt = p.combine(u.plot_bgcolor || p.background, u.paper_bgcolor), Xt = I(et, {
                                gd: t1,
                                hovermode: P,
                                rotateLabels: Yt,
                                bgColor: Wt,
                                container: u._hoverlayer,
                                outerContainer: u._paper.node(),
                                commonLabelOpts: u.hoverlabel,
                                hoverdistance: u.hoverdistance
                            });
                            v.isUnifiedHover(P) || (!function(t1, e1, r) {
                                var n, i, a, o, s, l, c, u = 0, f = 1, h = t1.size(), p = new Array(h), d = 0;
                                function m(t1) {
                                    var e1 = t1[0], r = t1[t1.length - 1];
                                    if (i = e1.pmin - e1.pos - e1.dp + e1.size, a = r.pos + r.dp + r.size - e1.pmax, i > .01) {
                                        for(s = t1.length - 1; s >= 0; s--)t1[s].dp += i;
                                        n = !1;
                                    }
                                    if (!(a < .01)) {
                                        if (i < -0.01) {
                                            for(s = t1.length - 1; s >= 0; s--)t1[s].dp -= a;
                                            n = !1;
                                        }
                                        if (n) {
                                            var c = 0;
                                            for(o = 0; o < t1.length; o++)(l = t1[o]).pos + l.dp + l.size > e1.pmax && c++;
                                            for(o = t1.length - 1; o >= 0 && !(c <= 0); o--)(l = t1[o]).pos > e1.pmax - 1 && (l.del = !0, c--);
                                            for(o = 0; o < t1.length && !(c <= 0); o++)if ((l = t1[o]).pos < e1.pmin + 1) for(l.del = !0, c--, a = 2 * l.size, s = t1.length - 1; s >= 0; s--)t1[s].dp -= a;
                                            for(o = t1.length - 1; o >= 0 && !(c <= 0); o--)(l = t1[o]).pos + l.dp + l.size > e1.pmax && (l.del = !0, c--);
                                        }
                                    }
                                }
                                t1.each(function(t1) {
                                    var n = t1[e1], i = "x" === n._id.charAt(0), a = n.range;
                                    0 === d && a && a[0] > a[1] !== i && (f = -1), p[d++] = [
                                        {
                                            datum: t1,
                                            traceIndex: t1.trace.index,
                                            dp: 0,
                                            pos: t1.pos,
                                            posref: t1.posref,
                                            size: t1.by * (i ? T : 1) / 2,
                                            pmin: 0,
                                            pmax: i ? r.width : r.height
                                        }
                                    ];
                                }), p.sort(function(t1, e1) {
                                    return t1[0].posref - e1[0].posref || f * (e1[0].traceIndex - t1[0].traceIndex);
                                });
                                for(; !n && u <= h;){
                                    for(u++, n = !0, o = 0; o < p.length - 1;){
                                        var g = p[o], v = p[o + 1], y = g[g.length - 1], x = v[0];
                                        if ((i = y.pos + y.dp + y.size - x.pos - x.dp + x.size) > .01 && y.pmin === x.pmin && y.pmax === x.pmax) {
                                            for(s = v.length - 1; s >= 0; s--)v[s].dp += i;
                                            for(g.push.apply(g, v), p.splice(o + 1, 1), c = 0, s = g.length - 1; s >= 0; s--)c += g[s].dp;
                                            for(a = c / g.length, s = g.length - 1; s >= 0; s--)g[s].dp -= a;
                                            n = !1;
                                        } else o++;
                                    }
                                    p.forEach(m);
                                }
                                for(o = p.length - 1; o >= 0; o--){
                                    var b = p[o];
                                    for(s = b.length - 1; s >= 0; s--){
                                        var _ = b[s], w = _.datum;
                                        w.offset = _.dp, w.del = _.del;
                                    }
                                }
                            }(Xt, Yt ? "xa" : "ya", u), z(Xt, Yt, u._invScaleX, u._invScaleY));
                            if (s && s.tagName) {
                                var Zt = g.getComponentMethod("annotations", "hasClickToShow")(t1, It);
                                f(n.select(s), Zt ? "pointer" : "");
                            }
                            if (!s || a || !function(t1, e1, r) {
                                if (!r || r.length !== t1._hoverdata.length) return !0;
                                for(var n = r.length - 1; n >= 0; n--){
                                    var i = r[n], a = t1._hoverdata[n];
                                    if (i.curveNumber !== a.curveNumber || String(i.pointNumber) !== String(a.pointNumber) || String(i.pointNumbers) !== String(a.pointNumbers)) return !0;
                                }
                                return !1;
                            }(t1, 0, Pt)) return;
                            Pt && t1.emit("plotly_unhover", {
                                event: e1,
                                points: Pt
                            });
                            t1.emit("plotly_hover", {
                                event: e1,
                                points: t1._hoverdata,
                                xaxes: _,
                                yaxes: w,
                                xvals: V,
                                yvals: H
                            });
                        }(t1, e1, r, a, s);
                    });
                }, r.loneHover = function(t1, e1) {
                    var r = !0;
                    Array.isArray(t1) || (r = !1, t1 = [
                        t1
                    ]);
                    var i = e1.gd, a = j(i), o = U(i), s = I(t1.map(function(t1) {
                        var r = t1._x0 || t1.x0 || t1.x || 0, n = t1._x1 || t1.x1 || t1.x || 0, s = t1._y0 || t1.y0 || t1.y || 0, l = t1._y1 || t1.y1 || t1.y || 0, c = t1.eventData;
                        if (c) {
                            var u = Math.min(r, n), f = Math.max(r, n), h = Math.min(s, l), d = Math.max(s, l), m = t1.trace;
                            if (g.traceIs(m, "gl3d")) {
                                var v = i._fullLayout[m.scene]._scene.container, y = v.offsetLeft, x = v.offsetTop;
                                u += y, f += y, h += x, d += x;
                            }
                            c.bbox = {
                                x0: u + o,
                                x1: f + o,
                                y0: h + a,
                                y1: d + a
                            }, e1.inOut_bbox && e1.inOut_bbox.push(c.bbox);
                        } else c = !1;
                        return {
                            color: t1.color || p.defaultLine,
                            x0: t1.x0 || t1.x || 0,
                            x1: t1.x1 || t1.x || 0,
                            y0: t1.y0 || t1.y || 0,
                            y1: t1.y1 || t1.y || 0,
                            xLabel: t1.xLabel,
                            yLabel: t1.yLabel,
                            zLabel: t1.zLabel,
                            text: t1.text,
                            name: t1.name,
                            idealAlign: t1.idealAlign,
                            borderColor: t1.borderColor,
                            fontFamily: t1.fontFamily,
                            fontSize: t1.fontSize,
                            fontColor: t1.fontColor,
                            nameLength: t1.nameLength,
                            textAlign: t1.textAlign,
                            trace: t1.trace || {
                                index: 0,
                                hoverinfo: ""
                            },
                            xa: {
                                _offset: 0
                            },
                            ya: {
                                _offset: 0
                            },
                            index: 0,
                            hovertemplate: t1.hovertemplate || !1,
                            hovertemplateLabels: t1.hovertemplateLabels || !1,
                            eventData: c
                        };
                    }), {
                        gd: i,
                        hovermode: "closest",
                        rotateLabels: !1,
                        bgColor: e1.bgColor || p.background,
                        container: n.select(e1.container),
                        outerContainer: e1.outerContainer || e1.container
                    }), l = 0, c = 0;
                    return s.sort(function(t1, e1) {
                        return t1.y0 - e1.y0;
                    }).each(function(t1, r) {
                        var n = t1.y0 - t1.by / 2;
                        t1.offset = n - 5 < l ? l - n + 5 : 0, l = n + t1.by + t1.offset, r === e1.anchorIndex && (c = t1.offset);
                    }).each(function(t1) {
                        t1.offset -= c;
                    }), z(s, !1, i._fullLayout._invScaleX, i._fullLayout._invScaleY), r ? s : s.node();
                };
                var P = /<extra>([\s\S]*)<\/extra>/;
                function I(t1, e1) {
                    var r = e1.gd, i = r._fullLayout, a = e1.hovermode, c = e1.rotateLabels, f = e1.bgColor, d = e1.container, m = e1.outerContainer, w = e1.commonLabelOpts || {};
                    if (0 === t1.length) return [
                        []
                    ];
                    var T = e1.fontFamily || y.HOVERFONT, k = e1.fontSize || y.HOVERFONTSIZE, A = t1[0], E = A.xa, L = A.ya, P = a.charAt(0), I = A[P + "Label"], z = V(r, m), D = z.top, R = z.width, F = z.height, B = void 0 !== I && A.distance <= e1.hoverdistance && ("x" === a || "y" === a);
                    if (B) {
                        var N, j, U = !0;
                        for(N = 0; N < t1.length; N++)if (U && void 0 === t1[N].zLabel && (U = !1), j = t1[N].hoverinfo || t1[N].trace.hoverinfo) {
                            var H = Array.isArray(j) ? j : j.split("+");
                            if (-1 === H.indexOf("all") && -1 === H.indexOf(a)) {
                                B = !1;
                                break;
                            }
                        }
                        U && (B = !1);
                    }
                    var q = d.selectAll("g.axistext").data(B ? [
                        0
                    ] : []);
                    if (q.enter().append("g").classed("axistext", !0), q.exit().remove(), q.each(function() {
                        var t1 = n.select(this), e1 = o.ensureSingle(t1, "path", "", function(t1) {
                            t1.style({
                                "stroke-width": "1px"
                            });
                        }), l = o.ensureSingle(t1, "text", "", function(t1) {
                            t1.attr("data-notex", 1);
                        }), c = w.bgcolor || p.defaultLine, f = w.bordercolor || p.contrast(c), d = p.contrast(c), m = {
                            family: w.font.family || T,
                            size: w.font.size || k,
                            color: w.font.color || d
                        };
                        e1.style({
                            fill: c,
                            stroke: f
                        }), l.text(I).call(h.font, m).call(u.positionText, 0, 0).call(u.convertToTspans, r), t1.attr("transform", "");
                        var g, v, y = V(r, l.node());
                        if ("x" === a) {
                            var x = "top" === E.side ? "-" : "";
                            l.attr("text-anchor", "middle").call(u.positionText, 0, "top" === E.side ? D - y.bottom - M - S : D - y.top + M + S), g = E._offset + (A.x0 + A.x1) / 2, v = L._offset + ("top" === E.side ? 0 : L._length);
                            var b = y.width / 2 + S;
                            g < b ? (g = b, e1.attr("d", "M-" + (b - M) + ",0L-" + (b - 2 * M) + "," + x + M + "H" + (S + y.width / 2) + "v" + x + (2 * S + y.height) + "H-" + b + "V" + x + M + "Z")) : g > i.width - b ? (g = i.width - b, e1.attr("d", "M" + (b - M) + ",0L" + b + "," + x + M + "v" + x + (2 * S + y.height) + "H-" + b + "V" + x + M + "H" + (b - 2 * M) + "Z")) : e1.attr("d", "M0,0L" + M + "," + x + M + "H" + (S + y.width / 2) + "v" + x + (2 * S + y.height) + "H-" + (S + y.width / 2) + "V" + x + M + "H-" + M + "Z");
                        } else {
                            var _, C, P;
                            "right" === L.side ? (_ = "start", C = 1, P = "", g = E._offset + E._length) : (_ = "end", C = -1, P = "-", g = E._offset), v = L._offset + (A.y0 + A.y1) / 2, l.attr("text-anchor", _), e1.attr("d", "M0,0L" + P + M + "," + M + "V" + (S + y.height / 2) + "h" + P + (2 * S + y.width) + "V-" + (S + y.height / 2) + "H" + P + M + "V-" + M + "Z");
                            var O, z = y.height / 2, R = D - y.top - z, F = "clip" + i._uid + "commonlabel" + L._id;
                            if (g < y.width + 2 * S + M) {
                                O = "M-" + (M + S) + "-" + z + "h-" + (y.width - S) + "V" + z + "h" + (y.width - S) + "Z";
                                var B = y.width - g + S;
                                u.positionText(l, B, R), "end" === _ && l.selectAll("tspan").each(function() {
                                    var t1 = n.select(this), e1 = h.tester.append("text").text(t1.text()).call(h.font, m), i = V(r, e1.node());
                                    Math.round(i.width) < Math.round(y.width) && t1.attr("x", B - i.width), e1.remove();
                                });
                            } else u.positionText(l, C * (S + M), R), O = null;
                            var N = i._topclips.selectAll("#" + F).data(O ? [
                                0
                            ] : []);
                            N.enter().append("clipPath").attr("id", F).append("path"), N.exit().remove(), N.select("path").attr("d", O), h.setClipUrl(l, O ? F : null, r);
                        }
                        t1.attr("transform", s(g, v));
                    }), v.isUnifiedHover(a)) {
                        d.selectAll("g.hovertext").remove();
                        var G = t1.filter(function(t1) {
                            return "none" !== t1.hoverinfo;
                        });
                        if (0 === G.length) return;
                        var Y = i.hoverlabel, W = Y.font, X = {
                            showlegend: !0,
                            legend: {
                                title: {
                                    text: I,
                                    font: W
                                },
                                font: W,
                                bgcolor: Y.bgcolor,
                                bordercolor: Y.bordercolor,
                                borderwidth: 1,
                                tracegroupgap: 7,
                                traceorder: i.legend ? i.legend.traceorder : void 0,
                                orientation: "v"
                            }
                        }, Z = {
                            font: W
                        };
                        x(X, Z, r._fullData);
                        var J = Z.legend;
                        J.entries = [];
                        for(var K = 0; K < G.length; K++){
                            var Q = G[K];
                            if ("none" !== Q.hoverinfo) {
                                var $ = O(Q, !0, a, i, I), tt = $[0], et = $[1];
                                Q.name = et, Q.text = "" !== et ? et + " : " + tt : tt;
                                var rt = Q.cd[Q.index];
                                rt && (rt.mc && (Q.mc = rt.mc), rt.mcc && (Q.mc = rt.mcc), rt.mlc && (Q.mlc = rt.mlc), rt.mlcc && (Q.mlc = rt.mlcc), rt.mlw && (Q.mlw = rt.mlw), rt.mrc && (Q.mrc = rt.mrc), rt.dir && (Q.dir = rt.dir)), Q._distinct = !0, J.entries.push([
                                    Q
                                ]);
                            }
                        }
                        J.entries.sort(function(t1, e1) {
                            return t1[0].trace.index - e1[0].trace.index;
                        }), J.layer = d, J._inHover = !0, J._groupTitleFont = Y.grouptitlefont, b(r, J);
                        var nt, it, at, ot, st = d.select("g.legend"), lt = V(r, st.node()), ct = lt.width + 2 * S, ut = lt.height + 2 * S, ft = G[0], ht = (ft.x0 + ft.x1) / 2, pt = (ft.y0 + ft.y1) / 2, dt = !(g.traceIs(ft.trace, "bar-like") || g.traceIs(ft.trace, "box-violin"));
                        "y" === P ? dt ? (it = pt - S, nt = pt + S) : (it = Math.min.apply(null, G.map(function(t1) {
                            return Math.min(t1.y0, t1.y1);
                        })), nt = Math.max.apply(null, G.map(function(t1) {
                            return Math.max(t1.y0, t1.y1);
                        }))) : it = nt = o.mean(G.map(function(t1) {
                            return (t1.y0 + t1.y1) / 2;
                        })) - ut / 2, "x" === P ? dt ? (at = ht + S, ot = ht - S) : (at = Math.max.apply(null, G.map(function(t1) {
                            return Math.max(t1.x0, t1.x1);
                        })), ot = Math.min.apply(null, G.map(function(t1) {
                            return Math.min(t1.x0, t1.x1);
                        }))) : at = ot = o.mean(G.map(function(t1) {
                            return (t1.x0 + t1.x1) / 2;
                        })) - ct / 2;
                        var mt, gt, vt = E._offset, yt = L._offset;
                        return ot += vt - ct, it += yt - ut, mt = (at += vt) + ct < R && at >= 0 ? at : ot + ct < R && ot >= 0 ? ot : vt + ct < R ? vt : at - ht < ht - ot + ct ? R - ct : 0, mt += S, gt = (nt += yt) + ut < F && nt >= 0 ? nt : it + ut < F && it >= 0 ? it : yt + ut < F ? yt : nt - pt < pt - it + ut ? F - ut : 0, gt += S, st.attr("transform", s(mt - 1, gt - 1)), st;
                    }
                    var xt = d.selectAll("g.hovertext").data(t1, function(t1) {
                        return C(t1);
                    });
                    return xt.enter().append("g").classed("hovertext", !0).each(function() {
                        var t1 = n.select(this);
                        t1.append("rect").call(p.fill, p.addOpacity(f, .8)), t1.append("text").classed("name", !0), t1.append("path").style("stroke-width", "1px"), t1.append("text").classed("nums", !0).call(h.font, T, k);
                    }), xt.exit().remove(), xt.each(function(t1) {
                        var e1 = n.select(this).attr("transform", ""), o = t1.color;
                        Array.isArray(o) && (o = o[t1.eventData[0].pointNumber]);
                        var d = t1.bgcolor || o, m = p.combine(p.opacity(d) ? d : p.defaultLine, f), g = p.combine(p.opacity(o) ? o : p.defaultLine, f), v = t1.borderColor || p.contrast(m), y = O(t1, B, a, i, I, e1), x = y[0], b = y[1], w = e1.select("text.nums").call(h.font, t1.fontFamily || T, t1.fontSize || k, t1.fontColor || v).text(x).attr("data-notex", 1).call(u.positionText, 0, 0).call(u.convertToTspans, r), A = e1.select("text.name"), E = 0, L = 0;
                        if (b && b !== x) {
                            A.call(h.font, t1.fontFamily || T, t1.fontSize || k, g).text(b).attr("data-notex", 1).call(u.positionText, 0, 0).call(u.convertToTspans, r);
                            var C = V(r, A.node());
                            E = C.width + 2 * S, L = C.height + 2 * S;
                        } else A.remove(), e1.select("rect").remove();
                        e1.select("path").style({
                            fill: m,
                            stroke: v
                        });
                        var P = t1.xa._offset + (t1.x0 + t1.x1) / 2, z = t1.ya._offset + (t1.y0 + t1.y1) / 2, N = Math.abs(t1.x1 - t1.x0), j = Math.abs(t1.y1 - t1.y0), U = V(r, w.node()), H = U.width / i._invScaleX, q = U.height / i._invScaleY;
                        t1.ty0 = (D - U.top) / i._invScaleY, t1.bx = H + 2 * S, t1.by = Math.max(q + 2 * S, L), t1.anchor = "start", t1.txwidth = H, t1.tx2width = E, t1.offset = 0;
                        var G, Y, W = (H + M + S + E) * i._invScaleX;
                        if (c) t1.pos = P, G = z + j / 2 + W <= F, Y = z - j / 2 - W >= 0, "top" !== t1.idealAlign && G || !Y ? G ? (z += j / 2, t1.anchor = "start") : t1.anchor = "middle" : (z -= j / 2, t1.anchor = "end");
                        else if (t1.pos = z, G = P + N / 2 + W <= R, Y = P - N / 2 - W >= 0, "left" !== t1.idealAlign && G || !Y) {
                            if (G) P += N / 2, t1.anchor = "start";
                            else {
                                t1.anchor = "middle";
                                var X = W / 2, Z = P + X - R, J = P - X;
                                Z > 0 && (P -= Z), J < 0 && (P += -J);
                            }
                        } else P -= N / 2, t1.anchor = "end";
                        w.attr("text-anchor", t1.anchor), E && A.attr("text-anchor", t1.anchor), e1.attr("transform", s(P, z) + (c ? l(_) : ""));
                    }), xt;
                }
                function O(t1, e1, r, n, i, a) {
                    var s = "", l = "";
                    void 0 !== t1.nameOverride && (t1.name = t1.nameOverride), t1.name && (t1.trace._meta && (t1.name = o.templateString(t1.name, t1.trace._meta)), s = B(t1.name, t1.nameLength));
                    var c = r.charAt(0), u = "x" === c ? "y" : "x";
                    void 0 !== t1.zLabel ? (void 0 !== t1.xLabel && (l += "x: " + t1.xLabel + "<br>"), void 0 !== t1.yLabel && (l += "y: " + t1.yLabel + "<br>"), "choropleth" !== t1.trace.type && "choroplethmapbox" !== t1.trace.type && (l += (l ? "z: " : "") + t1.zLabel)) : e1 && t1[c + "Label"] === i ? l = t1[u + "Label"] || "" : void 0 === t1.xLabel ? void 0 !== t1.yLabel && "scattercarpet" !== t1.trace.type && (l = t1.yLabel) : l = void 0 === t1.yLabel ? t1.xLabel : "(" + t1.xLabel + ", " + t1.yLabel + ")", !t1.text && 0 !== t1.text || Array.isArray(t1.text) || (l += (l ? "<br>" : "") + t1.text), void 0 !== t1.extraText && (l += (l ? "<br>" : "") + t1.extraText), a && "" === l && !t1.hovertemplate && ("" === s && a.remove(), l = s);
                    var f = t1.hovertemplate || !1;
                    if (f) {
                        var h = t1.hovertemplateLabels || t1;
                        t1[c + "Label"] !== i && (h[c + "other"] = h[c + "Val"], h[c + "otherLabel"] = h[c + "Label"]), l = (l = o.hovertemplateString(f, h, n._d3locale, t1.eventData[0] || {}, t1.trace._meta)).replace(P, function(e1, r) {
                            return s = B(r, t1.nameLength), "";
                        });
                    }
                    return [
                        l,
                        s
                    ];
                }
                function z(t1, e1, r, i) {
                    var a = function(t1) {
                        return t1 * r;
                    }, o = function(t1) {
                        return t1 * i;
                    };
                    t1.each(function(t1) {
                        var r = n.select(this);
                        if (t1.del) return r.remove();
                        var i = r.select("text.nums"), s = t1.anchor, l = "end" === s ? -1 : 1, c = {
                            start: 1,
                            end: -1,
                            middle: 0
                        }[s], f = c * (M + S), p = f + c * (t1.txwidth + S), d = 0, m = t1.offset, g = "middle" === s;
                        g && (f -= t1.tx2width / 2, p += t1.txwidth / 2 + S), e1 && (m *= -A, d = t1.offset * k), r.select("path").attr("d", g ? "M-" + a(t1.bx / 2 + t1.tx2width / 2) + "," + o(m - t1.by / 2) + "h" + a(t1.bx) + "v" + o(t1.by) + "h-" + a(t1.bx) + "Z" : "M0,0L" + a(l * M + d) + "," + o(M + m) + "v" + o(t1.by / 2 - M) + "h" + a(l * t1.bx) + "v-" + o(t1.by) + "H" + a(l * M + d) + "V" + o(m - M) + "Z");
                        var v = d + f, y = m + t1.ty0 - t1.by / 2 + S, x = t1.textAlign || "auto";
                        "auto" !== x && ("left" === x && "start" !== s ? (i.attr("text-anchor", "start"), v = g ? -t1.bx / 2 - t1.tx2width / 2 + S : -t1.bx - S) : "right" === x && "end" !== s && (i.attr("text-anchor", "end"), v = g ? t1.bx / 2 - t1.tx2width / 2 - S : t1.bx + S)), i.call(u.positionText, a(v), o(y)), t1.tx2width && (r.select("text.name").call(u.positionText, a(p + c * S + d), o(m + t1.ty0 - t1.by / 2 + S)), r.select("rect").call(h.setRect, a(p + (c - 1) * t1.tx2width / 2 + d), o(m - t1.by / 2 - 1), a(t1.tx2width), o(t1.by + 2)));
                    });
                }
                function D(t1, e1) {
                    var r = t1.index, n = t1.trace || {}, a = t1.cd[0], s = t1.cd[r] || {};
                    function l(t1) {
                        return t1 || i(t1) && 0 === t1;
                    }
                    var c = Array.isArray(r) ? function(t1, e1) {
                        var i = o.castOption(a, r, t1);
                        return l(i) ? i : o.extractOption({}, n, "", e1);
                    } : function(t1, e1) {
                        return o.extractOption(s, n, t1, e1);
                    };
                    function u(e1, r, n) {
                        var i = c(r, n);
                        l(i) && (t1[e1] = i);
                    }
                    if (u("hoverinfo", "hi", "hoverinfo"), u("bgcolor", "hbg", "hoverlabel.bgcolor"), u("borderColor", "hbc", "hoverlabel.bordercolor"), u("fontFamily", "htf", "hoverlabel.font.family"), u("fontSize", "hts", "hoverlabel.font.size"), u("fontColor", "htc", "hoverlabel.font.color"), u("nameLength", "hnl", "hoverlabel.namelength"), u("textAlign", "hta", "hoverlabel.align"), t1.posref = "y" === e1 || "closest" === e1 && "h" === n.orientation ? t1.xa._offset + (t1.x0 + t1.x1) / 2 : t1.ya._offset + (t1.y0 + t1.y1) / 2, t1.x0 = o.constrain(t1.x0, 0, t1.xa._length), t1.x1 = o.constrain(t1.x1, 0, t1.xa._length), t1.y0 = o.constrain(t1.y0, 0, t1.ya._length), t1.y1 = o.constrain(t1.y1, 0, t1.ya._length), void 0 !== t1.xLabelVal && (t1.xLabel = "xLabel" in t1 ? t1.xLabel : m.hoverLabelText(t1.xa, t1.xLabelVal, n.xhoverformat), t1.xVal = t1.xa.c2d(t1.xLabelVal)), void 0 !== t1.yLabelVal && (t1.yLabel = "yLabel" in t1 ? t1.yLabel : m.hoverLabelText(t1.ya, t1.yLabelVal, n.yhoverformat), t1.yVal = t1.ya.c2d(t1.yLabelVal)), void 0 !== t1.zLabelVal && void 0 === t1.zLabel && (t1.zLabel = String(t1.zLabelVal)), !(isNaN(t1.xerr) || "log" === t1.xa.type && t1.xerr <= 0)) {
                        var f = m.tickText(t1.xa, t1.xa.c2l(t1.xerr), "hover").text;
                        void 0 !== t1.xerrneg ? t1.xLabel += " +" + f + " / -" + m.tickText(t1.xa, t1.xa.c2l(t1.xerrneg), "hover").text : t1.xLabel += " \xb1 " + f, "x" === e1 && (t1.distance += 1);
                    }
                    if (!(isNaN(t1.yerr) || "log" === t1.ya.type && t1.yerr <= 0)) {
                        var h = m.tickText(t1.ya, t1.ya.c2l(t1.yerr), "hover").text;
                        void 0 !== t1.yerrneg ? t1.yLabel += " +" + h + " / -" + m.tickText(t1.ya, t1.ya.c2l(t1.yerrneg), "hover").text : t1.yLabel += " \xb1 " + h, "y" === e1 && (t1.distance += 1);
                    }
                    var p = t1.hoverinfo || t1.trace.hoverinfo;
                    return p && "all" !== p && (-1 === (p = Array.isArray(p) ? p : p.split("+")).indexOf("x") && (t1.xLabel = void 0), -1 === p.indexOf("y") && (t1.yLabel = void 0), -1 === p.indexOf("z") && (t1.zLabel = void 0), -1 === p.indexOf("text") && (t1.text = void 0), -1 === p.indexOf("name") && (t1.name = void 0)), t1;
                }
                function R(t1, e1, r) {
                    var n, i, o = r.container, s = r.fullLayout, l = s._size, c = r.event, u = !!e1.hLinePoint, f = !!e1.vLinePoint;
                    if (o.selectAll(".spikeline").remove(), f || u) {
                        var d = p.combine(s.plot_bgcolor, s.paper_bgcolor);
                        if (u) {
                            var g, v, y = e1.hLinePoint;
                            n = y && y.xa, "cursor" === (i = y && y.ya).spikesnap ? (g = c.pointerX, v = c.pointerY) : (g = n._offset + y.x, v = i._offset + y.y);
                            var x, b, _ = a.readability(y.color, d) < 1.5 ? p.contrast(d) : y.color, w = i.spikemode, T = i.spikethickness, k = i.spikecolor || _, A = m.getPxPosition(t1, i);
                            if (-1 !== w.indexOf("toaxis") || -1 !== w.indexOf("across")) {
                                if (-1 !== w.indexOf("toaxis") && (x = A, b = g), -1 !== w.indexOf("across")) {
                                    var M = i._counterDomainMin, S = i._counterDomainMax;
                                    "free" === i.anchor && (M = Math.min(M, i.position), S = Math.max(S, i.position)), x = l.l + M * l.w, b = l.l + S * l.w;
                                }
                                o.insert("line", ":first-child").attr({
                                    x1: x,
                                    x2: b,
                                    y1: v,
                                    y2: v,
                                    "stroke-width": T,
                                    stroke: k,
                                    "stroke-dasharray": h.dashStyle(i.spikedash, T)
                                }).classed("spikeline", !0).classed("crisp", !0), o.insert("line", ":first-child").attr({
                                    x1: x,
                                    x2: b,
                                    y1: v,
                                    y2: v,
                                    "stroke-width": T + 2,
                                    stroke: d
                                }).classed("spikeline", !0).classed("crisp", !0);
                            }
                            -1 !== w.indexOf("marker") && o.insert("circle", ":first-child").attr({
                                cx: A + ("right" !== i.side ? T : -T),
                                cy: v,
                                r: T,
                                fill: k
                            }).classed("spikeline", !0);
                        }
                        if (f) {
                            var E, L, C = e1.vLinePoint;
                            n = C && C.xa, i = C && C.ya, "cursor" === n.spikesnap ? (E = c.pointerX, L = c.pointerY) : (E = n._offset + C.x, L = i._offset + C.y);
                            var P, I, O = a.readability(C.color, d) < 1.5 ? p.contrast(d) : C.color, z = n.spikemode, D = n.spikethickness, R = n.spikecolor || O, F = m.getPxPosition(t1, n);
                            if (-1 !== z.indexOf("toaxis") || -1 !== z.indexOf("across")) {
                                if (-1 !== z.indexOf("toaxis") && (P = F, I = L), -1 !== z.indexOf("across")) {
                                    var B = n._counterDomainMin, N = n._counterDomainMax;
                                    "free" === n.anchor && (B = Math.min(B, n.position), N = Math.max(N, n.position)), P = l.t + (1 - N) * l.h, I = l.t + (1 - B) * l.h;
                                }
                                o.insert("line", ":first-child").attr({
                                    x1: E,
                                    x2: E,
                                    y1: P,
                                    y2: I,
                                    "stroke-width": D,
                                    stroke: R,
                                    "stroke-dasharray": h.dashStyle(n.spikedash, D)
                                }).classed("spikeline", !0).classed("crisp", !0), o.insert("line", ":first-child").attr({
                                    x1: E,
                                    x2: E,
                                    y1: P,
                                    y2: I,
                                    "stroke-width": D + 2,
                                    stroke: d
                                }).classed("spikeline", !0).classed("crisp", !0);
                            }
                            -1 !== z.indexOf("marker") && o.insert("circle", ":first-child").attr({
                                cx: E,
                                cy: F - ("top" !== n.side ? D : -D),
                                r: D,
                                fill: R
                            }).classed("spikeline", !0);
                        }
                    }
                }
                function F(t1, e1) {
                    return !e1 || e1.vLinePoint !== t1._spikepoints.vLinePoint || e1.hLinePoint !== t1._spikepoints.hLinePoint;
                }
                function B(t1, e1) {
                    return u.plainText(t1 || "", {
                        len: e1,
                        allowedTags: [
                            "br",
                            "sub",
                            "sup",
                            "b",
                            "i",
                            "em"
                        ]
                    });
                }
                function N(t1, e1, r) {
                    var n = e1[t1 + "a"], i = e1[t1 + "Val"], a = e1.cd[0];
                    if ("category" === n.type) i = n._categoriesMap[i];
                    else if ("date" === n.type) {
                        var o = e1.trace[t1 + "periodalignment"];
                        if (o) {
                            var s = e1.cd[e1.index], l = s[t1 + "Start"];
                            void 0 === l && (l = s[t1]);
                            var c = s[t1 + "End"];
                            void 0 === c && (c = s[t1]);
                            var u = c - l;
                            "end" === o ? i += u : "middle" === o && (i += u / 2);
                        }
                        i = n.d2c(i);
                    }
                    return a && a.t && a.t.posLetter === n._id && ("group" !== r.boxmode && "group" !== r.violinmode || (i += a.t.dPos)), i;
                }
                function j(t1) {
                    return t1.offsetTop + t1.clientTop;
                }
                function U(t1) {
                    return t1.offsetLeft + t1.clientLeft;
                }
                function V(t1, e1) {
                    var r = t1._fullLayout, n = e1.getBoundingClientRect(), i = n.x, a = n.y, s = i + n.width, l = a + n.height, c = o.apply3DTransform(r._invTransform)(i, a), u = o.apply3DTransform(r._invTransform)(s, l), f = c[0], h = c[1], p = u[0], d = u[1];
                    return {
                        x: f,
                        y: h,
                        width: p - f,
                        height: d - h,
                        top: Math.min(h, d),
                        left: Math.min(f, p),
                        right: Math.max(f, p),
                        bottom: Math.max(h, d)
                    };
                }
            },
            {
                "../../lib": 503,
                "../../lib/events": 492,
                "../../lib/override_cursor": 514,
                "../../lib/svg_text_utils": 529,
                "../../plots/cartesian/axes": 554,
                "../../registry": 638,
                "../color": 366,
                "../dragelement": 385,
                "../drawing": 388,
                "../legend/defaults": 418,
                "../legend/draw": 419,
                "./constants": 400,
                "./helpers": 402,
                "@plotly/d3": 58,
                "fast-isnumeric": 190,
                tinycolor2: 312
            }
        ],
        404: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../color"), a = t1("./helpers").isUnifiedHover;
                e1.exports = function(t1, e1, r, o) {
                    o = o || {};
                    var s = e1.legend;
                    function l(t1) {
                        o.font[t1] || (o.font[t1] = s ? e1.legend.font[t1] : e1.font[t1]);
                    }
                    e1 && a(e1.hovermode) && (o.font || (o.font = {}), l("size"), l("family"), l("color"), s ? (o.bgcolor || (o.bgcolor = i.combine(e1.legend.bgcolor, e1.paper_bgcolor)), o.bordercolor || (o.bordercolor = e1.legend.bordercolor)) : o.bgcolor || (o.bgcolor = e1.paper_bgcolor)), r("hoverlabel.bgcolor", o.bgcolor), r("hoverlabel.bordercolor", o.bordercolor), r("hoverlabel.namelength", o.namelength), n.coerceFont(r, "hoverlabel.font", o.font), r("hoverlabel.align", o.align);
                };
            },
            {
                "../../lib": 503,
                "../color": 366,
                "./helpers": 402
            }
        ],
        405: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./layout_attributes");
                e1.exports = function(t1, e1) {
                    function r(r, a) {
                        return void 0 !== e1[r] ? e1[r] : n.coerce(t1, e1, i, r, a);
                    }
                    return r("clickmode"), r("hovermode");
                };
            },
            {
                "../../lib": 503,
                "./layout_attributes": 407
            }
        ],
        406: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../dragelement"), o = t1("./helpers"), s = t1("./layout_attributes"), l = t1("./hover");
                e1.exports = {
                    moduleType: "component",
                    name: "fx",
                    constants: t1("./constants"),
                    schema: {
                        layout: s
                    },
                    attributes: t1("./attributes"),
                    layoutAttributes: s,
                    supplyLayoutGlobalDefaults: t1("./layout_global_defaults"),
                    supplyDefaults: t1("./defaults"),
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    calc: t1("./calc"),
                    getDistanceFunction: o.getDistanceFunction,
                    getClosest: o.getClosest,
                    inbox: o.inbox,
                    quadrature: o.quadrature,
                    appendArrayPointValue: o.appendArrayPointValue,
                    castHoverOption: function(t1, e1, r) {
                        return i.castOption(t1, e1, "hoverlabel." + r);
                    },
                    castHoverinfo: function(t1, e1, r) {
                        return i.castOption(t1, r, "hoverinfo", function(r) {
                            return i.coerceHoverinfo({
                                hoverinfo: r
                            }, {
                                _module: t1._module
                            }, e1);
                        });
                    },
                    hover: l.hover,
                    unhover: a.unhover,
                    loneHover: l.loneHover,
                    loneUnhover: function(t1) {
                        var e1 = i.isD3Selection(t1) ? t1 : n.select(t1);
                        e1.selectAll("g.hovertext").remove(), e1.selectAll(".spikeline").remove();
                    },
                    click: t1("./click")
                };
            },
            {
                "../../lib": 503,
                "../dragelement": 385,
                "./attributes": 397,
                "./calc": 398,
                "./click": 399,
                "./constants": 400,
                "./defaults": 401,
                "./helpers": 402,
                "./hover": 403,
                "./layout_attributes": 407,
                "./layout_defaults": 408,
                "./layout_global_defaults": 409,
                "@plotly/d3": 58
            }
        ],
        407: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./constants"), i = t1("../../plots/font_attributes"), a = i({
                    editType: "none"
                });
                a.family.dflt = n.HOVERFONT, a.size.dflt = n.HOVERFONTSIZE, e1.exports = {
                    clickmode: {
                        valType: "flaglist",
                        flags: [
                            "event",
                            "select"
                        ],
                        dflt: "event",
                        editType: "plot",
                        extras: [
                            "none"
                        ]
                    },
                    dragmode: {
                        valType: "enumerated",
                        values: [
                            "zoom",
                            "pan",
                            "select",
                            "lasso",
                            "drawclosedpath",
                            "drawopenpath",
                            "drawline",
                            "drawrect",
                            "drawcircle",
                            "orbit",
                            "turntable",
                            !1
                        ],
                        dflt: "zoom",
                        editType: "modebar"
                    },
                    hovermode: {
                        valType: "enumerated",
                        values: [
                            "x",
                            "y",
                            "closest",
                            !1,
                            "x unified",
                            "y unified"
                        ],
                        dflt: "closest",
                        editType: "modebar"
                    },
                    hoverdistance: {
                        valType: "integer",
                        min: -1,
                        dflt: 20,
                        editType: "none"
                    },
                    spikedistance: {
                        valType: "integer",
                        min: -1,
                        dflt: -1,
                        editType: "none"
                    },
                    hoverlabel: {
                        bgcolor: {
                            valType: "color",
                            editType: "none"
                        },
                        bordercolor: {
                            valType: "color",
                            editType: "none"
                        },
                        font: a,
                        grouptitlefont: i({
                            editType: "none"
                        }),
                        align: {
                            valType: "enumerated",
                            values: [
                                "left",
                                "right",
                                "auto"
                            ],
                            dflt: "auto",
                            editType: "none"
                        },
                        namelength: {
                            valType: "integer",
                            min: -1,
                            dflt: 15,
                            editType: "none"
                        },
                        editType: "none"
                    },
                    selectdirection: {
                        valType: "enumerated",
                        values: [
                            "h",
                            "v",
                            "d",
                            "any"
                        ],
                        dflt: "any",
                        editType: "none"
                    }
                };
            },
            {
                "../../plots/font_attributes": 585,
                "./constants": 400
            }
        ],
        408: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./layout_attributes"), a = t1("./hovermode_defaults"), o = t1("./hoverlabel_defaults");
                e1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    a(t1, e1) && (r("hoverdistance"), r("spikedistance")), "select" === r("dragmode") && r("selectdirection");
                    var s = e1._has("mapbox"), l = e1._has("geo"), c = e1._basePlotModules.length;
                    "zoom" === e1.dragmode && ((s || l) && 1 === c || s && l && 2 === c) && (e1.dragmode = "pan"), o(t1, e1, r), n.coerceFont(r, "hoverlabel.grouptitlefont", e1.hoverlabel.font);
                };
            },
            {
                "../../lib": 503,
                "./hoverlabel_defaults": 404,
                "./hovermode_defaults": 405,
                "./layout_attributes": 407
            }
        ],
        409: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./hoverlabel_defaults"), a = t1("./layout_attributes");
                e1.exports = function(t1, e1) {
                    i(t1, e1, function(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    });
                };
            },
            {
                "../../lib": 503,
                "./hoverlabel_defaults": 404,
                "./layout_attributes": 407
            }
        ],
        410: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../lib/regex").counter, a = t1("../../plots/domain").attributes, o = t1("../../plots/cartesian/constants").idRegex, s = t1("../../plot_api/plot_template"), l = {
                    rows: {
                        valType: "integer",
                        min: 1,
                        editType: "plot"
                    },
                    roworder: {
                        valType: "enumerated",
                        values: [
                            "top to bottom",
                            "bottom to top"
                        ],
                        dflt: "top to bottom",
                        editType: "plot"
                    },
                    columns: {
                        valType: "integer",
                        min: 1,
                        editType: "plot"
                    },
                    subplots: {
                        valType: "info_array",
                        freeLength: !0,
                        dimensions: 2,
                        items: {
                            valType: "enumerated",
                            values: [
                                i("xy").toString(),
                                ""
                            ],
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    xaxes: {
                        valType: "info_array",
                        freeLength: !0,
                        items: {
                            valType: "enumerated",
                            values: [
                                o.x.toString(),
                                ""
                            ],
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    yaxes: {
                        valType: "info_array",
                        freeLength: !0,
                        items: {
                            valType: "enumerated",
                            values: [
                                o.y.toString(),
                                ""
                            ],
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    pattern: {
                        valType: "enumerated",
                        values: [
                            "independent",
                            "coupled"
                        ],
                        dflt: "coupled",
                        editType: "plot"
                    },
                    xgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "plot"
                    },
                    ygap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "plot"
                    },
                    domain: a({
                        name: "grid",
                        editType: "plot",
                        noGridCell: !0
                    }, {}),
                    xside: {
                        valType: "enumerated",
                        values: [
                            "bottom",
                            "bottom plot",
                            "top plot",
                            "top"
                        ],
                        dflt: "bottom plot",
                        editType: "plot"
                    },
                    yside: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "left plot",
                            "right plot",
                            "right"
                        ],
                        dflt: "left plot",
                        editType: "plot"
                    },
                    editType: "plot"
                };
                function c(t1, e1, r) {
                    var n = e1[r + "axes"], i = Object.keys((t1._splomAxes || {})[r] || {});
                    return Array.isArray(n) ? n : i.length ? i : void 0;
                }
                function u(t1, e1, r, n, i, a) {
                    var o = e1(t1 + "gap", r), s = e1("domain." + t1);
                    e1(t1 + "side", n);
                    for(var l = new Array(i), c = s[0], u = (s[1] - c) / (i - o), f = u * (1 - o), h = 0; h < i; h++){
                        var p = c + u * h;
                        l[a ? i - 1 - h : h] = [
                            p,
                            p + f
                        ];
                    }
                    return l;
                }
                function f(t1, e1, r, n, i) {
                    var a, o = new Array(r);
                    function s(t1, r) {
                        -1 !== e1.indexOf(r) && void 0 === n[r] ? (o[t1] = r, n[r] = t1) : o[t1] = "";
                    }
                    if (Array.isArray(t1)) for(a = 0; a < r; a++)s(a, t1[a]);
                    else for(s(0, i), a = 1; a < r; a++)s(a, i + (a + 1));
                    return o;
                }
                e1.exports = {
                    moduleType: "component",
                    name: "grid",
                    schema: {
                        layout: {
                            grid: l
                        }
                    },
                    layoutAttributes: l,
                    sizeDefaults: function(t1, e1) {
                        var r = t1.grid || {}, i = c(e1, r, "x"), a = c(e1, r, "y");
                        if (t1.grid || i || a) {
                            var o, f, h = Array.isArray(r.subplots) && Array.isArray(r.subplots[0]), p = Array.isArray(i), d = Array.isArray(a), m = p && i !== r.xaxes && d && a !== r.yaxes;
                            h ? (o = r.subplots.length, f = r.subplots[0].length) : (d && (o = a.length), p && (f = i.length));
                            var g = s.newContainer(e1, "grid"), v = k("rows", o), y = k("columns", f);
                            if (v * y > 1) {
                                if (!h && !p && !d) "independent" === k("pattern") && (h = !0);
                                g._hasSubplotGrid = h;
                                var x, b, _ = "top to bottom" === k("roworder"), w = h ? .2 : .1, T = h ? .3 : .1;
                                m && e1._splomGridDflt && (x = e1._splomGridDflt.xside, b = e1._splomGridDflt.yside), g._domains = {
                                    x: u("x", k, w, x, y),
                                    y: u("y", k, T, b, v, _)
                                };
                            } else delete e1.grid;
                        }
                        function k(t1, e1) {
                            return n.coerce(r, g, l, t1, e1);
                        }
                    },
                    contentDefaults: function(t1, e1) {
                        var r = e1.grid;
                        if (r && r._domains) {
                            var n, i, a, o, s, l, u, h = t1.grid || {}, p = e1._subplots, d = r._hasSubplotGrid, m = r.rows, g = r.columns, v = "independent" === r.pattern, y = r._axisMap = {};
                            if (d) {
                                var x = h.subplots || [];
                                l = r.subplots = new Array(m);
                                var b = 1;
                                for(n = 0; n < m; n++){
                                    var _ = l[n] = new Array(g), w = x[n] || [];
                                    for(i = 0; i < g; i++)if (v ? (s = 1 === b ? "xy" : "x" + b + "y" + b, b++) : s = w[i], _[i] = "", -1 !== p.cartesian.indexOf(s)) {
                                        if (u = s.indexOf("y"), a = s.slice(0, u), o = s.slice(u), void 0 !== y[a] && y[a] !== i || void 0 !== y[o] && y[o] !== n) continue;
                                        _[i] = s, y[a] = i, y[o] = n;
                                    }
                                }
                            } else {
                                var T = c(e1, h, "x"), k = c(e1, h, "y");
                                r.xaxes = f(T, p.xaxis, g, y, "x"), r.yaxes = f(k, p.yaxis, m, y, "y");
                            }
                            var A = r._anchors = {}, M = "top to bottom" === r.roworder;
                            for(var S in y){
                                var E, L, C, P = S.charAt(0), I = r[P + "side"];
                                if (I.length < 8) A[S] = "free";
                                else if ("x" === P) {
                                    if ("t" === I.charAt(0) === M ? (E = 0, L = 1, C = m) : (E = m - 1, L = -1, C = -1), d) {
                                        var O = y[S];
                                        for(n = E; n !== C; n += L)if ((s = l[n][O]) && (u = s.indexOf("y"), s.slice(0, u) === S)) {
                                            A[S] = s.slice(u);
                                            break;
                                        }
                                    } else for(n = E; n !== C; n += L)if (o = r.yaxes[n], -1 !== p.cartesian.indexOf(S + o)) {
                                        A[S] = o;
                                        break;
                                    }
                                } else if ("l" === I.charAt(0) ? (E = 0, L = 1, C = g) : (E = g - 1, L = -1, C = -1), d) {
                                    var z = y[S];
                                    for(n = E; n !== C; n += L)if ((s = l[z][n]) && (u = s.indexOf("y"), s.slice(u) === S)) {
                                        A[S] = s.slice(0, u);
                                        break;
                                    }
                                } else for(n = E; n !== C; n += L)if (a = r.xaxes[n], -1 !== p.cartesian.indexOf(a + S)) {
                                    A[S] = a;
                                    break;
                                }
                            }
                        }
                    }
                };
            },
            {
                "../../lib": 503,
                "../../lib/regex": 520,
                "../../plot_api/plot_template": 543,
                "../../plots/cartesian/constants": 561,
                "../../plots/domain": 584
            }
        ],
        411: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/constants"), i = t1("../../plot_api/plot_template").templatedArray;
                t1("../../constants/axis_placeable_objects");
                e1.exports = i("image", {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "arraydraw"
                    },
                    source: {
                        valType: "string",
                        editType: "arraydraw"
                    },
                    layer: {
                        valType: "enumerated",
                        values: [
                            "below",
                            "above"
                        ],
                        dflt: "above",
                        editType: "arraydraw"
                    },
                    sizex: {
                        valType: "number",
                        dflt: 0,
                        editType: "arraydraw"
                    },
                    sizey: {
                        valType: "number",
                        dflt: 0,
                        editType: "arraydraw"
                    },
                    sizing: {
                        valType: "enumerated",
                        values: [
                            "fill",
                            "contain",
                            "stretch"
                        ],
                        dflt: "contain",
                        editType: "arraydraw"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    x: {
                        valType: "any",
                        dflt: 0,
                        editType: "arraydraw"
                    },
                    y: {
                        valType: "any",
                        dflt: 0,
                        editType: "arraydraw"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left",
                        editType: "arraydraw"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "top",
                        editType: "arraydraw"
                    },
                    xref: {
                        valType: "enumerated",
                        values: [
                            "paper",
                            n.idRegex.x.toString()
                        ],
                        dflt: "paper",
                        editType: "arraydraw"
                    },
                    yref: {
                        valType: "enumerated",
                        values: [
                            "paper",
                            n.idRegex.y.toString()
                        ],
                        dflt: "paper",
                        editType: "arraydraw"
                    },
                    editType: "arraydraw"
                });
            },
            {
                "../../constants/axis_placeable_objects": 472,
                "../../plot_api/plot_template": 543,
                "../../plots/cartesian/constants": 561
            }
        ],
        412: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib/to_log_range");
                e1.exports = function(t1, e1, r, a) {
                    e1 = e1 || {};
                    var o = "log" === r && "linear" === e1.type, s = "linear" === r && "log" === e1.type;
                    if (o || s) {
                        for(var l, c, u = t1._fullLayout.images, f = e1._id.charAt(0), h = 0; h < u.length; h++)if (c = "images[" + h + "].", (l = u[h])[f + "ref"] === e1._id) {
                            var p = l[f], d = l["size" + f], m = null, g = null;
                            if (o) {
                                m = i(p, e1.range);
                                var v = d / Math.pow(10, m) / 2;
                                g = 2 * Math.log(v + Math.sqrt(1 + v * v)) / Math.LN10;
                            } else g = (m = Math.pow(10, p)) * (Math.pow(10, d / 2) - Math.pow(10, -d / 2));
                            n(m) ? n(g) || (g = null) : (m = null, g = null), a(c + f, m), a(c + "size" + f, g);
                        }
                    }
                };
            },
            {
                "../../lib/to_log_range": 531,
                "fast-isnumeric": 190
            }
        ],
        413: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axes"), a = t1("../../plots/array_container_defaults"), o = t1("./attributes");
                function s(t1, e1, r) {
                    function a(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    var s = a("source");
                    if (!a("visible", !!s)) return e1;
                    a("layer"), a("xanchor"), a("yanchor"), a("sizex"), a("sizey"), a("sizing"), a("opacity");
                    for(var l = {
                        _fullLayout: r
                    }, c = [
                        "x",
                        "y"
                    ], u = 0; u < 2; u++){
                        var f = c[u], h = i.coerceRef(t1, e1, l, f, "paper", void 0);
                        if ("paper" !== h) i.getFromId(l, h)._imgIndices.push(e1._index);
                        i.coercePosition(e1, l, a, h, f, 0);
                    }
                    return e1;
                }
                e1.exports = function(t1, e1) {
                    a(t1, e1, {
                        name: "images",
                        handleItemDefaults: s
                    });
                };
            },
            {
                "../../lib": 503,
                "../../plots/array_container_defaults": 549,
                "../../plots/cartesian/axes": 554,
                "./attributes": 411
            }
        ],
        414: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../drawing"), a = t1("../../plots/cartesian/axes"), o = t1("../../plots/cartesian/axis_ids"), s = t1("../../constants/xmlns_namespaces");
                e1.exports = function(t1) {
                    var e1, r, l = t1._fullLayout, c = [], u = {}, f = [];
                    for(r = 0; r < l.images.length; r++){
                        var h = l.images[r];
                        if (h.visible) {
                            if ("below" === h.layer && "paper" !== h.xref && "paper" !== h.yref) {
                                e1 = o.ref2id(h.xref) + o.ref2id(h.yref);
                                var p = l._plots[e1];
                                if (!p) {
                                    f.push(h);
                                    continue;
                                }
                                p.mainplot && (e1 = p.mainplot.id), u[e1] || (u[e1] = []), u[e1].push(h);
                            } else "above" === h.layer ? c.push(h) : f.push(h);
                        }
                    }
                    var d = {
                        left: {
                            sizing: "xMin",
                            offset: 0
                        },
                        center: {
                            sizing: "xMid",
                            offset: -0.5
                        },
                        right: {
                            sizing: "xMax",
                            offset: -1
                        }
                    }, m = {
                        top: {
                            sizing: "YMin",
                            offset: 0
                        },
                        middle: {
                            sizing: "YMid",
                            offset: -0.5
                        },
                        bottom: {
                            sizing: "YMax",
                            offset: -1
                        }
                    };
                    function g(e1) {
                        var r = n.select(this);
                        if (this._imgSrc !== e1.source) {
                            if (r.attr("xmlns", s.svg), e1.source && "data:" === e1.source.slice(0, 5)) r.attr("xlink:href", e1.source), this._imgSrc = e1.source;
                            else {
                                var i = new Promise((function(t1) {
                                    var n = new Image;
                                    function i() {
                                        r.remove(), t1();
                                    }
                                    this.img = n, n.setAttribute("crossOrigin", "anonymous"), n.onerror = i, n.onload = function() {
                                        var e1 = document.createElement("canvas");
                                        e1.width = this.width, e1.height = this.height, e1.getContext("2d").drawImage(this, 0, 0);
                                        var n = e1.toDataURL("image/png");
                                        r.attr("xlink:href", n), t1();
                                    }, r.on("error", i), n.src = e1.source, this._imgSrc = e1.source;
                                }).bind(this));
                                t1._promises.push(i);
                            }
                        }
                    }
                    function v(e1) {
                        var r, o, s = n.select(this), c = a.getFromId(t1, e1.xref), u = a.getFromId(t1, e1.yref), f = "domain" === a.getRefType(e1.xref), h = "domain" === a.getRefType(e1.yref), p = l._size;
                        r = void 0 !== c ? "string" == typeof e1.xref && f ? c._length * e1.sizex : Math.abs(c.l2p(e1.sizex) - c.l2p(0)) : e1.sizex * p.w, o = void 0 !== u ? "string" == typeof e1.yref && h ? u._length * e1.sizey : Math.abs(u.l2p(e1.sizey) - u.l2p(0)) : e1.sizey * p.h;
                        var g, v, y = r * d[e1.xanchor].offset, x = o * m[e1.yanchor].offset, b = d[e1.xanchor].sizing + m[e1.yanchor].sizing;
                        switch(g = void 0 !== c ? "string" == typeof e1.xref && f ? c._length * e1.x + c._offset : c.r2p(e1.x) + c._offset : e1.x * p.w + p.l, g += y, v = void 0 !== u ? "string" == typeof e1.yref && h ? u._length * (1 - e1.y) + u._offset : u.r2p(e1.y) + u._offset : p.h - e1.y * p.h + p.t, v += x, e1.sizing){
                            case "fill":
                                b += " slice";
                                break;
                            case "stretch":
                                b = "none";
                        }
                        s.attr({
                            x: g,
                            y: v,
                            width: r,
                            height: o,
                            preserveAspectRatio: b,
                            opacity: e1.opacity
                        });
                        var _ = (c && "domain" !== a.getRefType(e1.xref) ? c._id : "") + (u && "domain" !== a.getRefType(e1.yref) ? u._id : "");
                        i.setClipUrl(s, _ ? "clip" + l._uid + _ : null, t1);
                    }
                    var y = l._imageLowerLayer.selectAll("image").data(f), x = l._imageUpperLayer.selectAll("image").data(c);
                    y.enter().append("image"), x.enter().append("image"), y.exit().remove(), x.exit().remove(), y.each(function(t1) {
                        g.bind(this)(t1), v.bind(this)(t1);
                    }), x.each(function(t1) {
                        g.bind(this)(t1), v.bind(this)(t1);
                    });
                    var b = Object.keys(l._plots);
                    for(r = 0; r < b.length; r++){
                        e1 = b[r];
                        var _ = l._plots[e1];
                        if (_.imagelayer) {
                            var w = _.imagelayer.selectAll("image").data(u[e1] || []);
                            w.enter().append("image"), w.exit().remove(), w.each(function(t1) {
                                g.bind(this)(t1), v.bind(this)(t1);
                            });
                        }
                    }
                };
            },
            {
                "../../constants/xmlns_namespaces": 480,
                "../../plots/cartesian/axes": 554,
                "../../plots/cartesian/axis_ids": 558,
                "../drawing": 388,
                "@plotly/d3": 58
            }
        ],
        415: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "component",
                    name: "images",
                    layoutAttributes: t1("./attributes"),
                    supplyLayoutDefaults: t1("./defaults"),
                    includeBasePlot: t1("../../plots/cartesian/include_components")("images"),
                    draw: t1("./draw"),
                    convertCoords: t1("./convert_coords")
                };
            },
            {
                "../../plots/cartesian/include_components": 567,
                "./attributes": 411,
                "./convert_coords": 412,
                "./defaults": 413,
                "./draw": 414
            }
        ],
        416: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/font_attributes"), i = t1("../color/attributes");
                e1.exports = {
                    bgcolor: {
                        valType: "color",
                        editType: "legend"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "legend"
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "legend"
                    },
                    font: n({
                        editType: "legend"
                    }),
                    grouptitlefont: n({
                        editType: "legend"
                    }),
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        dflt: "v",
                        editType: "legend"
                    },
                    traceorder: {
                        valType: "flaglist",
                        flags: [
                            "reversed",
                            "grouped"
                        ],
                        extras: [
                            "normal"
                        ],
                        editType: "legend"
                    },
                    tracegroupgap: {
                        valType: "number",
                        min: 0,
                        dflt: 10,
                        editType: "legend"
                    },
                    itemsizing: {
                        valType: "enumerated",
                        values: [
                            "trace",
                            "constant"
                        ],
                        dflt: "trace",
                        editType: "legend"
                    },
                    itemwidth: {
                        valType: "number",
                        min: 30,
                        dflt: 30,
                        editType: "legend"
                    },
                    itemclick: {
                        valType: "enumerated",
                        values: [
                            "toggle",
                            "toggleothers",
                            !1
                        ],
                        dflt: "toggle",
                        editType: "legend"
                    },
                    itemdoubleclick: {
                        valType: "enumerated",
                        values: [
                            "toggle",
                            "toggleothers",
                            !1
                        ],
                        dflt: "toggleothers",
                        editType: "legend"
                    },
                    groupclick: {
                        valType: "enumerated",
                        values: [
                            "toggleitem",
                            "togglegroup"
                        ],
                        dflt: "togglegroup",
                        editType: "legend"
                    },
                    x: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        editType: "legend"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left",
                        editType: "legend"
                    },
                    y: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        editType: "legend"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        editType: "legend"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    valign: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "middle",
                        editType: "legend"
                    },
                    title: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "legend"
                        },
                        font: n({
                            editType: "legend"
                        }),
                        side: {
                            valType: "enumerated",
                            values: [
                                "top",
                                "left",
                                "top left"
                            ],
                            editType: "legend"
                        },
                        editType: "legend"
                    },
                    editType: "legend"
                };
            },
            {
                "../../plots/font_attributes": 585,
                "../color/attributes": 365
            }
        ],
        417: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    scrollBarWidth: 6,
                    scrollBarMinHeight: 20,
                    scrollBarColor: "#808BA4",
                    scrollBarMargin: 4,
                    scrollBarEnterAttrs: {
                        rx: 20,
                        ry: 3,
                        width: 0,
                        height: 0
                    },
                    titlePad: 2,
                    itemGap: 5
                };
            },
            {}
        ],
        418: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib"), a = t1("../../plot_api/plot_template"), o = t1("../../plots/attributes"), s = t1("./attributes"), l = t1("../../plots/layout_attributes"), c = t1("./helpers");
                e1.exports = function(t1, e1, r) {
                    var u, f = t1.legend || {}, h = a.newContainer(e1, "legend");
                    function p(t1, e1) {
                        return i.coerce(f, h, s, t1, e1);
                    }
                    for(var d = function(t1, e1) {
                        var r = u._input, n = u;
                        return i.coerce(r, n, o, t1, e1);
                    }, m = e1.font || {}, g = i.coerceFont(p, "grouptitlefont", i.extendFlat({}, m, {
                        size: Math.round(1.1 * m.size)
                    })), v = 0, y = !1, x = "normal", b = 0; b < r.length; b++)(u = r[b]).visible && ((u.showlegend || u._dfltShowLegend && !(u._module && u._module.attributes && u._module.attributes.showlegend && !1 === u._module.attributes.showlegend.dflt)) && (v++, u.showlegend && (y = !0, (n.traceIs(u, "pie-like") || !0 === u._input.showlegend) && v++), i.coerceFont(d, "legendgrouptitle.font", g)), (n.traceIs(u, "bar") && "stack" === e1.barmode || -1 !== [
                        "tonextx",
                        "tonexty"
                    ].indexOf(u.fill)) && (x = c.isGrouped({
                        traceorder: x
                    }) ? "grouped+reversed" : "reversed"), void 0 !== u.legendgroup && "" !== u.legendgroup && (x = c.isReversed({
                        traceorder: x
                    }) ? "reversed+grouped" : "grouped"));
                    var _ = i.coerce(t1, e1, l, "showlegend", y && v > 1);
                    if (!1 === _ && (e1.legend = void 0), (!1 !== _ || f.uirevision) && (p("uirevision", e1.uirevision), !1 !== _)) {
                        p("bgcolor", e1.paper_bgcolor), p("bordercolor"), p("borderwidth");
                        var w, T, k, A = i.coerceFont(p, "font", e1.font), M = "h" === p("orientation");
                        if (M ? (w = 0, n.getComponentMethod("rangeslider", "isVisible")(t1.xaxis) ? (T = 1.1, k = "bottom") : (T = -0.1, k = "top")) : (w = 1.02, T = 1, k = "auto"), p("traceorder", x), c.isGrouped(e1.legend) && p("tracegroupgap"), p("itemsizing"), p("itemwidth"), p("itemclick"), p("itemdoubleclick"), p("groupclick"), p("x", w), p("xanchor"), p("y", T), p("yanchor", k), p("valign"), i.noneOrAll(f, h, [
                            "x",
                            "y"
                        ]), p("title.text")) {
                            p("title.side", M ? "left" : "top");
                            var S = i.extendFlat({}, A, {
                                size: i.bigFont(A.size)
                            });
                            i.coerceFont(p, "title.font", S);
                        }
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../../plots/attributes": 550,
                "../../plots/layout_attributes": 610,
                "../../registry": 638,
                "./attributes": 416,
                "./helpers": 422
            }
        ],
        419: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../../plots/plots"), o = t1("../../registry"), s = t1("../../lib/events"), l = t1("../dragelement"), c = t1("../drawing"), u = t1("../color"), f = t1("../../lib/svg_text_utils"), h = t1("./handle_click"), p = t1("./constants"), d = t1("../../constants/alignment"), m = d.LINE_SPACING, g = d.FROM_TL, v = d.FROM_BR, y = t1("./get_legend_data"), x = t1("./style"), b = t1("./helpers");
                function _(t1, e1, r, n, i) {
                    var a = r.data()[0][0].trace, l = {
                        event: i,
                        node: r.node(),
                        curveNumber: a.index,
                        expandedIndex: a._expandedIndex,
                        data: t1.data,
                        layout: t1.layout,
                        frames: t1._transitionData._frames,
                        config: t1._context,
                        fullData: t1._fullData,
                        fullLayout: t1._fullLayout
                    };
                    if (a._group && (l.group = a._group), o.traceIs(a, "pie-like") && (l.label = r.datum()[0].label), !1 !== s.triggerHandler(t1, "plotly_legendclick", l)) {
                        if (1 === n) e1._clickTimeout = setTimeout(function() {
                            t1._fullLayout && h(r, t1, n);
                        }, t1._context.doubleClickDelay);
                        else if (2 === n) e1._clickTimeout && clearTimeout(e1._clickTimeout), t1._legendMouseDownTime = 0, !1 !== s.triggerHandler(t1, "plotly_legenddoubleclick", l) && h(r, t1, n);
                    }
                }
                function w(t1, e1, r) {
                    var n, a, s = t1.data()[0][0], l = s.trace, u = o.traceIs(l, "pie-like"), h = !r._inHover && e1._context.edits.legendText && !u, d = r._maxNameLength;
                    s.groupTitle ? (n = s.groupTitle.text, a = s.groupTitle.font) : (a = r.font, r.entries ? n = s.text : (n = u ? s.label : l.name, l._meta && (n = i.templateString(n, l._meta))));
                    var m = i.ensureSingle(t1, "text", "legendtext");
                    m.attr("text-anchor", "start").call(c.font, a).text(h ? T(n, d) : n);
                    var g = r.itemwidth + 2 * p.itemGap;
                    f.positionText(m, g, 0), h ? m.call(f.makeEditable, {
                        gd: e1,
                        text: n
                    }).call(A, t1, e1, r).on("edit", function(n) {
                        this.text(T(n, d)).call(A, t1, e1, r);
                        var a = s.trace._fullInput || {}, c = {};
                        if (o.hasTransform(a, "groupby")) {
                            var u = o.getTransformIndices(a, "groupby"), f = u[u.length - 1], h = i.keyedContainer(a, "transforms[" + f + "].styles", "target", "value.name");
                            h.set(s.trace._group, n), c = h.constructUpdate();
                        } else c.name = n;
                        return o.call("_guiRestyle", e1, c, l.index);
                    }) : A(m, t1, e1, r);
                }
                function T(t1, e1) {
                    var r = Math.max(4, e1);
                    if (t1 && t1.trim().length >= r / 2) return t1;
                    for(var n = r - (t1 = t1 || "").length; n > 0; n--)t1 += " ";
                    return t1;
                }
                function k(t1, e1) {
                    var r, a = e1._context.doubleClickDelay, o = 1, s = i.ensureSingle(t1, "rect", "legendtoggle", function(t1) {
                        e1._context.staticPlot || t1.style("cursor", "pointer").attr("pointer-events", "all"), t1.call(u.fill, "rgba(0,0,0,0)");
                    });
                    e1._context.staticPlot || (s.on("mousedown", function() {
                        (r = (new Date).getTime()) - e1._legendMouseDownTime < a ? o += 1 : (o = 1, e1._legendMouseDownTime = r);
                    }), s.on("mouseup", function() {
                        if (!e1._dragged && !e1._editing) {
                            var r = e1._fullLayout.legend;
                            (new Date).getTime() - e1._legendMouseDownTime > a && (o = Math.max(o - 1, 1)), _(e1, r, t1, o, n.event);
                        }
                    }));
                }
                function A(t1, e1, r, n, i) {
                    n._inHover && t1.attr("data-notex", !0), f.convertToTspans(t1, r, function() {
                        !function(t1, e1, r, n) {
                            var i = t1.data()[0][0];
                            if (!r._inHover && i && !i.trace.showlegend) return void t1.remove();
                            var a = t1.select("g[class*=math-group]"), o = a.node();
                            r || (r = e1._fullLayout.legend);
                            var s, l = r.borderwidth;
                            s = 1 === n ? r.title.font : i.groupTitle ? i.groupTitle.font : r.font;
                            var u, h, d = s.size * m;
                            if (o) {
                                var g = c.bBox(o);
                                u = g.height, h = g.width, 1 === n ? c.setTranslate(a, l, l + .75 * u) : c.setTranslate(a, 0, .25 * u);
                            } else {
                                var v = t1.select(1 === n ? ".legendtitletext" : ".legendtext"), y = f.lineCount(v), x = v.node();
                                if (u = d * y, h = x ? c.bBox(x).width : 0, 1 === n) "left" === r.title.side && (h += 2 * p.itemGap), f.positionText(v, l + p.titlePad, l + d);
                                else {
                                    var b = 2 * p.itemGap + r.itemwidth;
                                    i.groupTitle && (b = p.itemGap, h -= r.itemwidth), f.positionText(v, b, -d * ((y - 1) / 2 - .3));
                                }
                            }
                            1 === n ? (r._titleWidth = h, r._titleHeight = u) : (i.lineHeight = d, i.height = Math.max(u, 16) + 3, i.width = h);
                        }(e1, r, n, i);
                    });
                }
                function M(t1) {
                    return i.isRightAnchor(t1) ? "right" : i.isCenterAnchor(t1) ? "center" : "left";
                }
                function S(t1) {
                    return i.isBottomAnchor(t1) ? "bottom" : i.isMiddleAnchor(t1) ? "middle" : "top";
                }
                e1.exports = function(t1, e1) {
                    return e1 || (e1 = t1._fullLayout.legend || {}), function(t1, e1) {
                        var r, s, f = t1._fullLayout, h = "legend" + f._uid, d = e1._inHover;
                        d ? (r = e1.layer, h += "-hover") : r = f._infolayer;
                        if (!r) return;
                        t1._legendMouseDownTime || (t1._legendMouseDownTime = 0);
                        if (d) {
                            if (!e1.entries) return;
                            s = y(e1.entries, e1);
                        } else {
                            if (!t1.calcdata) return;
                            s = f.showlegend && y(t1.calcdata, e1);
                        }
                        var m = f.hiddenlabels || [];
                        if (!(d || f.showlegend && s.length)) return r.selectAll(".legend").remove(), f._topdefs.select("#" + h).remove(), a.autoMargin(t1, "legend");
                        var T = i.ensureSingle(r, "g", "legend", function(t1) {
                            d || t1.attr("pointer-events", "all");
                        }), E = i.ensureSingleById(f._topdefs, "clipPath", h, function(t1) {
                            t1.append("rect");
                        }), L = i.ensureSingle(T, "rect", "bg", function(t1) {
                            t1.attr("shape-rendering", "crispEdges");
                        });
                        L.call(u.stroke, e1.bordercolor).call(u.fill, e1.bgcolor).style("stroke-width", e1.borderwidth + "px");
                        var C = i.ensureSingle(T, "g", "scrollbox"), P = e1.title;
                        if (e1._titleWidth = 0, e1._titleHeight = 0, P.text) {
                            var I = i.ensureSingle(C, "text", "legendtitletext");
                            I.attr("text-anchor", "start").call(c.font, P.font).text(P.text), A(I, C, t1, e1, 1);
                        } else C.selectAll(".legendtitletext").remove();
                        var O = i.ensureSingle(T, "rect", "scrollbar", function(t1) {
                            t1.attr(p.scrollBarEnterAttrs).call(u.fill, p.scrollBarColor);
                        }), z = C.selectAll("g.groups").data(s);
                        z.enter().append("g").attr("class", "groups"), z.exit().remove();
                        var D = z.selectAll("g.traces").data(i.identity);
                        D.enter().append("g").attr("class", "traces"), D.exit().remove(), D.style("opacity", function(t1) {
                            var e1 = t1[0].trace;
                            return o.traceIs(e1, "pie-like") ? -1 !== m.indexOf(t1[0].label) ? .5 : 1 : "legendonly" === e1.visible ? .5 : 1;
                        }).each(function() {
                            n.select(this).call(w, t1, e1);
                        }).call(x, t1, e1).each(function() {
                            d || n.select(this).call(k, t1);
                        }), i.syncOrAsync([
                            a.previousPromises,
                            function() {
                                return function(t1, e1, r, i) {
                                    var a = t1._fullLayout;
                                    i || (i = a.legend);
                                    var o = a._size, s = b.isVertical(i), l = b.isGrouped(i), u = i.borderwidth, f = 2 * u, h = p.itemGap, d = i.itemwidth + 2 * h, m = 2 * (u + h), g = S(i), v = i.y < 0 || 0 === i.y && "top" === g, y = i.y > 1 || 1 === i.y && "bottom" === g, x = i.tracegroupgap;
                                    i._maxHeight = Math.max(v || y ? a.height / 2 : o.h, 30);
                                    var _ = 0;
                                    i._width = 0, i._height = 0;
                                    var w = function(t1) {
                                        var e1 = 0, r = 0, n = t1.title.side;
                                        n && (-1 !== n.indexOf("left") && (e1 = t1._titleWidth), -1 !== n.indexOf("top") && (r = t1._titleHeight));
                                        return [
                                            e1,
                                            r
                                        ];
                                    }(i);
                                    if (s) r.each(function(t1) {
                                        var e1 = t1[0].height;
                                        c.setTranslate(this, u + w[0], u + w[1] + i._height + e1 / 2 + h), i._height += e1, i._width = Math.max(i._width, t1[0].width);
                                    }), _ = d + i._width, i._width += h + d + f, i._height += m, l && (e1.each(function(t1, e1) {
                                        c.setTranslate(this, 0, e1 * i.tracegroupgap);
                                    }), i._height += (i._lgroupsLength - 1) * i.tracegroupgap);
                                    else {
                                        var T = M(i), k = i.x < 0 || 0 === i.x && "right" === T, A = i.x > 1 || 1 === i.x && "left" === T, E = y || v, L = a.width / 2;
                                        i._maxWidth = Math.max(k ? E && "left" === T ? o.l + o.w : L : A ? E && "right" === T ? o.r + o.w : L : o.w, 2 * d);
                                        var C = 0, P = 0;
                                        r.each(function(t1) {
                                            var e1 = t1[0].width + d;
                                            C = Math.max(C, e1), P += e1;
                                        }), _ = null;
                                        var I = 0;
                                        if (l) {
                                            var O = 0, z = 0, D = 0;
                                            e1.each(function() {
                                                var t1 = 0, e1 = 0;
                                                n.select(this).selectAll("g.traces").each(function(r) {
                                                    var n = r[0].width, i = r[0].height;
                                                    c.setTranslate(this, w[0], w[1] + u + h + i / 2 + e1), e1 += i, t1 = Math.max(t1, d + n);
                                                }), O = Math.max(O, e1);
                                                var r = t1 + h;
                                                z > 0 && r + u + z > i._maxWidth && (I = Math.max(I, z), z = 0, D += O + x, O = e1), c.setTranslate(this, z, D), z += r;
                                            }), i._width = Math.max(I, z) + u, i._height = D + O + m;
                                        } else {
                                            var R = r.size(), F = P + f + (R - 1) * h < i._maxWidth, B = 0, N = 0, j = 0, U = 0;
                                            r.each(function(t1) {
                                                var e1 = t1[0].height, r = d + t1[0].width, n = (F ? r : C) + h;
                                                n + u + N - h >= i._maxWidth && (I = Math.max(I, U), N = 0, j += B, i._height += B, B = 0), c.setTranslate(this, w[0] + u + N, w[1] + u + j + e1 / 2 + h), U = N + r + h, N += n, B = Math.max(B, e1);
                                            }), F ? (i._width = N + f, i._height = B + m) : (i._width = Math.max(I, U) + f, i._height += B + m);
                                        }
                                    }
                                    i._width = Math.ceil(Math.max(i._width + w[0], i._titleWidth + 2 * (u + p.titlePad))), i._height = Math.ceil(Math.max(i._height + w[1], i._titleHeight + 2 * (u + p.itemGap))), i._effHeight = Math.min(i._height, i._maxHeight);
                                    var V = t1._context.edits, H = V.legendText || V.legendPosition;
                                    r.each(function(t1) {
                                        var e1 = n.select(this).select(".legendtoggle"), r = t1[0].height, i = H ? d : _ || d + t1[0].width;
                                        s || (i += h / 2), c.setRect(e1, 0, -r / 2, i, r);
                                    });
                                }(t1, z, D, e1);
                            },
                            function() {
                                var s, u, m, y, x = f._size, b = e1.borderwidth;
                                if (!d) {
                                    if (function(t1) {
                                        var e1 = t1._fullLayout.legend, r = M(e1), n = S(e1);
                                        return a.autoMargin(t1, "legend", {
                                            x: e1.x,
                                            y: e1.y,
                                            l: e1._width * g[r],
                                            r: e1._width * v[r],
                                            b: e1._effHeight * v[n],
                                            t: e1._effHeight * g[n]
                                        });
                                    }(t1)) return;
                                    var w = x.l + x.w * e1.x - g[M(e1)] * e1._width, k = x.t + x.h * (1 - e1.y) - g[S(e1)] * e1._effHeight;
                                    if (f.margin.autoexpand) {
                                        var A = w, P = k;
                                        w = i.constrain(w, 0, f.width - e1._width), k = i.constrain(k, 0, f.height - e1._effHeight), w !== A && i.log("Constrain legend.x to make legend fit inside graph"), k !== P && i.log("Constrain legend.y to make legend fit inside graph");
                                    }
                                    c.setTranslate(T, w, k);
                                }
                                if (O.on(".drag", null), T.on("wheel", null), d || e1._height <= e1._maxHeight || t1._context.staticPlot) {
                                    var I = e1._effHeight;
                                    d && (I = e1._height), L.attr({
                                        width: e1._width - b,
                                        height: I - b,
                                        x: b / 2,
                                        y: b / 2
                                    }), c.setTranslate(C, 0, 0), E.select("rect").attr({
                                        width: e1._width - 2 * b,
                                        height: I - 2 * b,
                                        x: b,
                                        y: b
                                    }), c.setClipUrl(C, h, t1), c.setRect(O, 0, 0, 0, 0), delete e1._scrollY;
                                } else {
                                    var z, D, R, F = Math.max(p.scrollBarMinHeight, e1._effHeight * e1._effHeight / e1._height), B = e1._effHeight - F - 2 * p.scrollBarMargin, N = e1._height - e1._effHeight, j = B / N, U = Math.min(e1._scrollY || 0, N);
                                    L.attr({
                                        width: e1._width - 2 * b + p.scrollBarWidth + p.scrollBarMargin,
                                        height: e1._effHeight - b,
                                        x: b / 2,
                                        y: b / 2
                                    }), E.select("rect").attr({
                                        width: e1._width - 2 * b + p.scrollBarWidth + p.scrollBarMargin,
                                        height: e1._effHeight - 2 * b,
                                        x: b,
                                        y: b + U
                                    }), c.setClipUrl(C, h, t1), q(U, F, j), T.on("wheel", function() {
                                        q(U = i.constrain(e1._scrollY + n.event.deltaY / B * N, 0, N), F, j), 0 !== U && U !== N && n.event.preventDefault();
                                    });
                                    var V = n.behavior.drag().on("dragstart", function() {
                                        var t1 = n.event.sourceEvent;
                                        z = "touchstart" === t1.type ? t1.changedTouches[0].clientY : t1.clientY, R = U;
                                    }).on("drag", function() {
                                        var t1 = n.event.sourceEvent;
                                        2 === t1.buttons || t1.ctrlKey || (D = "touchmove" === t1.type ? t1.changedTouches[0].clientY : t1.clientY, q(U = function(t1, e1, r) {
                                            var n = (r - e1) / j + t1;
                                            return i.constrain(n, 0, N);
                                        }(R, z, D), F, j));
                                    });
                                    O.call(V);
                                    var H = n.behavior.drag().on("dragstart", function() {
                                        var t1 = n.event.sourceEvent;
                                        "touchstart" === t1.type && (z = t1.changedTouches[0].clientY, R = U);
                                    }).on("drag", function() {
                                        var t1 = n.event.sourceEvent;
                                        "touchmove" === t1.type && (D = t1.changedTouches[0].clientY, q(U = function(t1, e1, r) {
                                            var n = (e1 - r) / j + t1;
                                            return i.constrain(n, 0, N);
                                        }(R, z, D), F, j));
                                    });
                                    C.call(H);
                                }
                                function q(r, n, i) {
                                    e1._scrollY = t1._fullLayout.legend._scrollY = r, c.setTranslate(C, 0, -r), c.setRect(O, e1._width, p.scrollBarMargin + r * i, p.scrollBarWidth, n), E.select("rect").attr("y", b + r);
                                }
                                t1._context.edits.legendPosition && (T.classed("cursor-move", !0), l.init({
                                    element: T.node(),
                                    gd: t1,
                                    prepFn: function() {
                                        var t1 = c.getTranslate(T);
                                        m = t1.x, y = t1.y;
                                    },
                                    moveFn: function(t1, r) {
                                        var n = m + t1, i = y + r;
                                        c.setTranslate(T, n, i), s = l.align(n, 0, x.l, x.l + x.w, e1.xanchor), u = l.align(i, 0, x.t + x.h, x.t, e1.yanchor);
                                    },
                                    doneFn: function() {
                                        void 0 !== s && void 0 !== u && o.call("_guiRelayout", t1, {
                                            "legend.x": s,
                                            "legend.y": u
                                        });
                                    },
                                    clickFn: function(e1, n) {
                                        var i = r.selectAll("g.traces").filter(function() {
                                            var t1 = this.getBoundingClientRect();
                                            return n.clientX >= t1.left && n.clientX <= t1.right && n.clientY >= t1.top && n.clientY <= t1.bottom;
                                        });
                                        i.size() > 0 && _(t1, T, i, e1, n);
                                    }
                                }));
                            }
                        ], t1);
                    }(t1, e1);
                };
            },
            {
                "../../constants/alignment": 471,
                "../../lib": 503,
                "../../lib/events": 492,
                "../../lib/svg_text_utils": 529,
                "../../plots/plots": 619,
                "../../registry": 638,
                "../color": 366,
                "../dragelement": 385,
                "../drawing": 388,
                "./constants": 417,
                "./get_legend_data": 420,
                "./handle_click": 421,
                "./helpers": 422,
                "./style": 424,
                "@plotly/d3": 58
            }
        ],
        420: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("./helpers");
                e1.exports = function(t1, e1) {
                    var r, a, o = e1._inHover, s = i.isGrouped(e1), l = i.isReversed(e1), c = {}, u = [], f = !1, h = {}, p = 0, d = 0;
                    function m(t1, r) {
                        if ("" !== t1 && i.isGrouped(e1)) -1 === u.indexOf(t1) ? (u.push(t1), f = !0, c[t1] = [
                            r
                        ]) : c[t1].push(r);
                        else {
                            var n = "~~i" + p;
                            u.push(n), c[n] = [
                                r
                            ], p++;
                        }
                    }
                    for(r = 0; r < t1.length; r++){
                        var g = t1[r], v = g[0], y = v.trace, x = y.legendgroup;
                        if (o || y.visible && y.showlegend) {
                            if (n.traceIs(y, "pie-like")) for(h[x] || (h[x] = {}), a = 0; a < g.length; a++){
                                var b = g[a].label;
                                h[x][b] || (m(x, {
                                    label: b,
                                    color: g[a].color,
                                    i: g[a].i,
                                    trace: y,
                                    pts: g[a].pts
                                }), h[x][b] = !0, d = Math.max(d, (b || "").length));
                            }
                            else m(x, v), d = Math.max(d, (y.name || "").length);
                        }
                    }
                    if (!u.length) return [];
                    var _ = !f || !s, w = [];
                    for(r = 0; r < u.length; r++){
                        var T = c[u[r]];
                        _ ? w.push(T[0]) : w.push(T);
                    }
                    for(_ && (w = [
                        w
                    ]), r = 0; r < w.length; r++){
                        var k = 1 / 0;
                        for(a = 0; a < w[r].length; a++){
                            var A = w[r][a].trace.legendrank;
                            k > A && (k = A);
                        }
                        w[r][0]._groupMinRank = k, w[r][0]._preGroupSort = r;
                    }
                    var M = function(t1, e1) {
                        return t1.trace.legendrank - e1.trace.legendrank || t1._preSort - e1._preSort;
                    };
                    for(w.forEach(function(t1, e1) {
                        t1[0]._preGroupSort = e1;
                    }), w.sort(function(t1, e1) {
                        return t1[0]._groupMinRank - e1[0]._groupMinRank || t1[0]._preGroupSort - e1[0]._preGroupSort;
                    }), r = 0; r < w.length; r++){
                        w[r].forEach(function(t1, e1) {
                            t1._preSort = e1;
                        }), w[r].sort(M);
                        var S = w[r][0].trace, E = null;
                        for(a = 0; a < w[r].length; a++){
                            var L = w[r][a].trace.legendgrouptitle;
                            if (L && L.text) {
                                E = L, o && (L.font = e1._groupTitleFont);
                                break;
                            }
                        }
                        if (l && w[r].reverse(), E) {
                            var C = !1;
                            for(a = 0; a < w[r].length; a++)if (n.traceIs(w[r][a].trace, "pie-like")) {
                                C = !0;
                                break;
                            }
                            w[r].unshift({
                                i: -1,
                                groupTitle: E,
                                noClick: C,
                                trace: {
                                    showlegend: S.showlegend,
                                    legendgroup: S.legendgroup,
                                    visible: "toggleitem" === e1.groupclick || S.visible
                                }
                            });
                        }
                        for(a = 0; a < w[r].length; a++)w[r][a] = [
                            w[r][a]
                        ];
                    }
                    return e1._lgroupsLength = w.length, e1._maxNameLength = d, w;
                };
            },
            {
                "../../registry": 638,
                "./helpers": 422
            }
        ],
        421: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../registry"), a = !0;
                e1.exports = function(t1, e1, r) {
                    var o = e1._fullLayout;
                    if (!e1._dragged && !e1._editing) {
                        var s, l = o.legend.itemclick, c = o.legend.itemdoubleclick, u = o.legend.groupclick;
                        if (1 === r && "toggle" === l && "toggleothers" === c && a && e1.data && e1._context.showTips ? (n.notifier(n._(e1, "Double-click on legend to isolate one trace"), "long"), a = !1) : a = !1, 1 === r ? s = l : 2 === r && (s = c), s) {
                            var f = "togglegroup" === u, h = o.hiddenlabels ? o.hiddenlabels.slice() : [], p = t1.data()[0][0];
                            if (!p.groupTitle || !p.noClick) {
                                var d, m, g, v, y, x = e1._fullData, b = p.trace, _ = b.legendgroup, w = {}, T = [], k = [], A = [];
                                if (i.traceIs(b, "pie-like")) {
                                    var M = p.label, S = h.indexOf(M);
                                    "toggle" === s ? -1 === S ? h.push(M) : h.splice(S, 1) : "toggleothers" === s && (h = [], e1.calcdata[0].forEach(function(t1) {
                                        M !== t1.label && h.push(t1.label);
                                    }), e1._fullLayout.hiddenlabels && e1._fullLayout.hiddenlabels.length === h.length && -1 === S && (h = [])), i.call("_guiRelayout", e1, "hiddenlabels", h);
                                } else {
                                    var E, L = _ && _.length, C = [];
                                    if (L) for(d = 0; d < x.length; d++)(E = x[d]).visible && E.legendgroup === _ && C.push(d);
                                    if ("toggle" === s) {
                                        var P;
                                        switch(b.visible){
                                            case !0:
                                                P = "legendonly";
                                                break;
                                            case !1:
                                                P = !1;
                                                break;
                                            case "legendonly":
                                                P = !0;
                                        }
                                        if (L) {
                                            if (f) for(d = 0; d < x.length; d++)!1 !== x[d].visible && x[d].legendgroup === _ && j(x[d], P);
                                            else j(b, P);
                                        } else j(b, P);
                                    } else if ("toggleothers" === s) {
                                        var I, O, z, D, R = !0;
                                        for(d = 0; d < x.length; d++)if (I = x[d] === b, z = !0 !== x[d].showlegend, !(I || z || (O = L && x[d].legendgroup === _) || !0 !== x[d].visible || i.traceIs(x[d], "notLegendIsolatable"))) {
                                            R = !1;
                                            break;
                                        }
                                        for(d = 0; d < x.length; d++)if (!1 !== x[d].visible && !i.traceIs(x[d], "notLegendIsolatable")) switch(b.visible){
                                            case "legendonly":
                                                j(x[d], !0);
                                                break;
                                            case !0:
                                                D = !!R || "legendonly", I = x[d] === b, z = !0 !== x[d].showlegend && !x[d].legendgroup, O = I || L && x[d].legendgroup === _, j(x[d], !(!O && !z) || D);
                                        }
                                    }
                                    for(d = 0; d < k.length; d++)if (g = k[d]) {
                                        var F = g.constructUpdate(), B = Object.keys(F);
                                        for(m = 0; m < B.length; m++)v = B[m], (w[v] = w[v] || [])[A[d]] = F[v];
                                    }
                                    for(y = Object.keys(w), d = 0; d < y.length; d++)for(v = y[d], m = 0; m < T.length; m++)w[v].hasOwnProperty(m) || (w[v][m] = void 0);
                                    i.call("_guiRestyle", e1, w, T);
                                }
                            }
                        }
                    }
                    function N(t1, e1, r) {
                        var n = T.indexOf(t1), i = w[e1];
                        return i || (i = w[e1] = []), -1 === T.indexOf(t1) && (T.push(t1), n = T.length - 1), i[n] = r, n;
                    }
                    function j(t1, e1) {
                        if (!p.groupTitle || f) {
                            var r = t1._fullInput;
                            if (i.hasTransform(r, "groupby")) {
                                var a = k[r.index];
                                if (!a) {
                                    var o = i.getTransformIndices(r, "groupby"), s = o[o.length - 1];
                                    a = n.keyedContainer(r, "transforms[" + s + "].styles", "target", "value.visible"), k[r.index] = a;
                                }
                                var l = a.get(t1._group);
                                void 0 === l && (l = !0), !1 !== l && a.set(t1._group, e1), A[r.index] = N(r.index, "visible", !1 !== r.visible);
                            } else {
                                var c = !1 !== r.visible && e1;
                                N(r.index, "visible", c);
                            }
                        }
                    }
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638
            }
        ],
        422: [
            function(t1, e1, r) {
                "use strict";
                r.isGrouped = function(t1) {
                    return -1 !== (t1.traceorder || "").indexOf("grouped");
                }, r.isVertical = function(t1) {
                    return "h" !== t1.orientation;
                }, r.isReversed = function(t1) {
                    return -1 !== (t1.traceorder || "").indexOf("reversed");
                };
            },
            {}
        ],
        423: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "component",
                    name: "legend",
                    layoutAttributes: t1("./attributes"),
                    supplyLayoutDefaults: t1("./defaults"),
                    draw: t1("./draw"),
                    style: t1("./style")
                };
            },
            {
                "./attributes": 416,
                "./defaults": 418,
                "./draw": 419,
                "./style": 424
            }
        ],
        424: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../registry"), a = t1("../../lib"), o = a.strTranslate, s = t1("../drawing"), l = t1("../color"), c = t1("../colorscale/helpers").extractOpts, u = t1("../../traces/scatter/subtypes"), f = t1("../../traces/pie/style_one"), h = t1("../../traces/pie/helpers").castOption, p = t1("./constants");
                function d(t1, e1) {
                    return (e1 ? "radial" : "horizontal") + (t1 ? "" : "reversed");
                }
                function m(t1) {
                    var e1 = t1[0].trace, r = e1.contours, n = u.hasLines(e1), i = u.hasMarkers(e1), a = e1.visible && e1.fill && "none" !== e1.fill, o = !1, s = !1;
                    if (r) {
                        var l = r.coloring;
                        "lines" === l ? o = !0 : n = "none" === l || "heatmap" === l || r.showlines, "constraint" === r.type ? a = "=" !== r._operation : "fill" !== l && "heatmap" !== l || (s = !0);
                    }
                    return {
                        showMarker: i,
                        showLine: n,
                        showFill: a,
                        showGradientLine: o,
                        showGradientFill: s,
                        anyLine: n || o,
                        anyFill: a || s
                    };
                }
                function g(t1, e1, r) {
                    return t1 && a.isArrayOrTypedArray(t1) ? e1 : t1 > r ? r : t1;
                }
                e1.exports = function(t1, e1, r) {
                    var v = e1._fullLayout;
                    r || (r = v.legend);
                    var y = "constant" === r.itemsizing, x = r.itemwidth, b = (x + 2 * p.itemGap) / 2, _ = o(b, 0), w = function(t1, e1, r, n) {
                        var i;
                        if (t1 + 1) i = t1;
                        else {
                            if (!(e1 && e1.width > 0)) return 0;
                            i = e1.width;
                        }
                        return y ? n : Math.min(i, r);
                    };
                    function T(t1, a, o) {
                        var u = t1[0].trace, f = u.marker || {}, h = f.line || {}, p = o ? u.visible && u.type === o : i.traceIs(u, "bar"), d = n.select(a).select("g.legendpoints").selectAll("path.legend" + o).data(p ? [
                            t1
                        ] : []);
                        d.enter().append("path").classed("legend" + o, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", _), d.exit().remove(), d.each(function(t1) {
                            var i = n.select(this), a = t1[0], o = w(a.mlw, f.line, 5, 2);
                            i.style("stroke-width", o + "px");
                            var p = a.mcc;
                            if (!r._inHover && "mc" in a) {
                                var d = c(f), m = d.mid;
                                void 0 === m && (m = (d.max + d.min) / 2), p = s.tryColorscale(f, "")(m);
                            }
                            var v = p || a.mc || f.color, y = f.pattern, x = y && s.getPatternAttr(y.shape, 0, "");
                            if (x) {
                                var b = s.getPatternAttr(y.bgcolor, 0, null), _ = s.getPatternAttr(y.fgcolor, 0, null), T = y.fgopacity, k = g(y.size, 8, 10), A = g(y.solidity, .5, 1), M = "legend-" + u.uid;
                                i.call(s.pattern, "legend", e1, M, x, k, A, p, y.fillmode, b, _, T);
                            } else i.call(l.fill, v);
                            o && l.stroke(i, a.mlc || h.color);
                        });
                    }
                    function k(t1, e1, r) {
                        var o = t1[0], s = o.trace, l = r ? s.visible && s.type === r : i.traceIs(s, r), c = n.select(e1).select("g.legendpoints").selectAll("path.legend" + r).data(l ? [
                            t1
                        ] : []);
                        if (c.enter().append("path").classed("legend" + r, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", _), c.exit().remove(), c.size()) {
                            var u = (s.marker || {}).line, p = w(h(u.width, o.pts), u, 5, 2), d = a.minExtend(s, {
                                marker: {
                                    line: {
                                        width: p
                                    }
                                }
                            });
                            d.marker.line.color = u.color;
                            var m = a.minExtend(o, {
                                trace: d
                            });
                            f(c, m, d);
                        }
                    }
                    t1.each(function(t1) {
                        var e1 = n.select(this), i = a.ensureSingle(e1, "g", "layers");
                        i.style("opacity", t1[0].trace.opacity);
                        var s = r.valign, l = t1[0].lineHeight, c = t1[0].height;
                        if ("middle" !== s && l && c) {
                            var u = {
                                top: 1,
                                bottom: -1
                            }[s] * (.5 * (l - c + 3));
                            i.attr("transform", o(0, u));
                        } else i.attr("transform", null);
                        i.selectAll("g.legendfill").data([
                            t1
                        ]).enter().append("g").classed("legendfill", !0), i.selectAll("g.legendlines").data([
                            t1
                        ]).enter().append("g").classed("legendlines", !0);
                        var f = i.selectAll("g.legendsymbols").data([
                            t1
                        ]);
                        f.enter().append("g").classed("legendsymbols", !0), f.selectAll("g.legendpoints").data([
                            t1
                        ]).enter().append("g").classed("legendpoints", !0);
                    }).each(function(t1) {
                        var r, i = t1[0].trace, o = [];
                        if (i.visible) switch(i.type){
                            case "histogram2d":
                            case "heatmap":
                                o = [
                                    [
                                        "M-15,-2V4H15V-2Z"
                                    ]
                                ], r = !0;
                                break;
                            case "choropleth":
                            case "choroplethmapbox":
                                o = [
                                    [
                                        "M-6,-6V6H6V-6Z"
                                    ]
                                ], r = !0;
                                break;
                            case "densitymapbox":
                                o = [
                                    [
                                        "M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"
                                    ]
                                ], r = "radial";
                                break;
                            case "cone":
                                o = [
                                    [
                                        "M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z"
                                    ],
                                    [
                                        "M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z"
                                    ],
                                    [
                                        "M-6,-2 A2,2 0 0,0 -6,2 L6,0Z"
                                    ]
                                ], r = !1;
                                break;
                            case "streamtube":
                                o = [
                                    [
                                        "M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z"
                                    ],
                                    [
                                        "M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z"
                                    ],
                                    [
                                        "M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z"
                                    ]
                                ], r = !1;
                                break;
                            case "surface":
                                o = [
                                    [
                                        "M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z"
                                    ],
                                    [
                                        "M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z"
                                    ]
                                ], r = !0;
                                break;
                            case "mesh3d":
                                o = [
                                    [
                                        "M-6,6H0L-6,-6Z"
                                    ],
                                    [
                                        "M6,6H0L6,-6Z"
                                    ],
                                    [
                                        "M-6,-6H6L0,6Z"
                                    ]
                                ], r = !1;
                                break;
                            case "volume":
                                o = [
                                    [
                                        "M-6,6H0L-6,-6Z"
                                    ],
                                    [
                                        "M6,6H0L6,-6Z"
                                    ],
                                    [
                                        "M-6,-6H6L0,6Z"
                                    ]
                                ], r = !0;
                                break;
                            case "isosurface":
                                o = [
                                    [
                                        "M-6,6H0L-6,-6Z"
                                    ],
                                    [
                                        "M6,6H0L6,-6Z"
                                    ],
                                    [
                                        "M-6,-6 A12,24 0 0,0 6,-6 L0,6Z"
                                    ]
                                ], r = !1;
                        }
                        var u = n.select(this).select("g.legendpoints").selectAll("path.legend3dandfriends").data(o);
                        u.enter().append("path").classed("legend3dandfriends", !0).attr("transform", _).style("stroke-miterlimit", 1), u.exit().remove(), u.each(function(t1, o) {
                            var u, f = n.select(this), h = c(i), p = h.colorscale, m = h.reversescale;
                            if (p) {
                                if (!r) {
                                    var g = p.length;
                                    u = 0 === o ? p[m ? g - 1 : 0][1] : 1 === o ? p[m ? 0 : g - 1][1] : p[Math.floor((g - 1) / 2)][1];
                                }
                            } else {
                                var v = i.vertexcolor || i.facecolor || i.color;
                                u = a.isArrayOrTypedArray(v) ? v[o] || v[0] : v;
                            }
                            f.attr("d", t1[0]), u ? f.call(l.fill, u) : f.call(function(t1) {
                                if (t1.size()) {
                                    var n = "legendfill-" + i.uid;
                                    s.gradient(t1, e1, n, d(m, "radial" === r), p, "fill");
                                }
                            });
                        });
                    }).each(function(t1) {
                        var e1 = t1[0].trace, r = "waterfall" === e1.type;
                        if (t1[0]._distinct && r) {
                            var i = t1[0].trace[t1[0].dir].marker;
                            return t1[0].mc = i.color, t1[0].mlw = i.line.width, t1[0].mlc = i.line.color, T(t1, this, "waterfall");
                        }
                        var a = [];
                        e1.visible && r && (a = t1[0].hasTotals ? [
                            [
                                "increasing",
                                "M-6,-6V6H0Z"
                            ],
                            [
                                "totals",
                                "M6,6H0L-6,-6H-0Z"
                            ],
                            [
                                "decreasing",
                                "M6,6V-6H0Z"
                            ]
                        ] : [
                            [
                                "increasing",
                                "M-6,-6V6H6Z"
                            ],
                            [
                                "decreasing",
                                "M6,6V-6H-6Z"
                            ]
                        ]);
                        var o = n.select(this).select("g.legendpoints").selectAll("path.legendwaterfall").data(a);
                        o.enter().append("path").classed("legendwaterfall", !0).attr("transform", _).style("stroke-miterlimit", 1), o.exit().remove(), o.each(function(t1) {
                            var r = n.select(this), i = e1[t1[0]].marker, a = w(void 0, i.line, 5, 2);
                            r.attr("d", t1[1]).style("stroke-width", a + "px").call(l.fill, i.color), a && r.call(l.stroke, i.line.color);
                        });
                    }).each(function(t1) {
                        T(t1, this, "funnel");
                    }).each(function(t1) {
                        T(t1, this);
                    }).each(function(t1) {
                        var r = t1[0].trace, o = n.select(this).select("g.legendpoints").selectAll("path.legendbox").data(r.visible && i.traceIs(r, "box-violin") ? [
                            t1
                        ] : []);
                        o.enter().append("path").classed("legendbox", !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", _), o.exit().remove(), o.each(function() {
                            var t1 = n.select(this);
                            if ("all" !== r.boxpoints && "all" !== r.points || 0 !== l.opacity(r.fillcolor) || 0 !== l.opacity((r.line || {}).color)) {
                                var i = w(void 0, r.line, 5, 2);
                                t1.style("stroke-width", i + "px").call(l.fill, r.fillcolor), i && l.stroke(t1, r.line.color);
                            } else {
                                var c = a.minExtend(r, {
                                    marker: {
                                        size: y ? 12 : a.constrain(r.marker.size, 2, 16),
                                        sizeref: 1,
                                        sizemin: 1,
                                        sizemode: "diameter"
                                    }
                                });
                                o.call(s.pointStyle, c, e1);
                            }
                        });
                    }).each(function(t1) {
                        k(t1, this, "funnelarea");
                    }).each(function(t1) {
                        k(t1, this, "pie");
                    }).each(function(t1) {
                        var r, i, o = m(t1), l = o.showFill, f = o.showLine, h = o.showGradientLine, p = o.showGradientFill, g = o.anyFill, v = o.anyLine, y = t1[0], b = y.trace, _ = c(b), T = _.colorscale, k = _.reversescale, A = u.hasMarkers(b) || !g ? "M5,0" : v ? "M5,-2" : "M5,-3", M = n.select(this), S = M.select(".legendfill").selectAll("path").data(l || p ? [
                            t1
                        ] : []);
                        if (S.enter().append("path").classed("js-fill", !0), S.exit().remove(), S.attr("d", A + "h" + x + "v6h-" + x + "z").call(l ? s.fillGroupStyle : function(t1) {
                            if (t1.size()) {
                                var r = "legendfill-" + b.uid;
                                s.gradient(t1, e1, r, d(k), T, "fill");
                            }
                        }), f || h) {
                            var E = w(void 0, b.line, 10, 5);
                            i = a.minExtend(b, {
                                line: {
                                    width: E
                                }
                            }), r = [
                                a.minExtend(y, {
                                    trace: i
                                })
                            ];
                        }
                        var L = M.select(".legendlines").selectAll("path").data(f || h ? [
                            r
                        ] : []);
                        L.enter().append("path").classed("js-line", !0), L.exit().remove(), L.attr("d", A + (h ? "l" + x + ",0.0001" : "h" + x)).call(f ? s.lineGroupStyle : function(t1) {
                            if (t1.size()) {
                                var r = "legendline-" + b.uid;
                                s.lineGroupStyle(t1), s.gradient(t1, e1, r, d(k), T, "stroke");
                            }
                        });
                    }).each(function(t1) {
                        var r, i, o = m(t1), l = o.anyFill, c = o.anyLine, f = o.showLine, h = o.showMarker, p = t1[0], d = p.trace, g = !h && !c && !l && u.hasText(d);
                        function v(t1, e1, r, n) {
                            var i = a.nestedProperty(d, t1).get(), o = a.isArrayOrTypedArray(i) && e1 ? e1(i) : i;
                            if (y && o && void 0 !== n && (o = n), r) {
                                if (o < r[0]) return r[0];
                                if (o > r[1]) return r[1];
                            }
                            return o;
                        }
                        function x(t1) {
                            return p._distinct && p.index && t1[p.index] ? t1[p.index] : t1[0];
                        }
                        if (h || g || f) {
                            var b = {}, w = {};
                            if (h) {
                                b.mc = v("marker.color", x), b.mx = v("marker.symbol", x), b.mo = v("marker.opacity", a.mean, [
                                    .2,
                                    1
                                ]), b.mlc = v("marker.line.color", x), b.mlw = v("marker.line.width", a.mean, [
                                    0,
                                    5
                                ], 2), w.marker = {
                                    sizeref: 1,
                                    sizemin: 1,
                                    sizemode: "diameter"
                                };
                                var T = v("marker.size", a.mean, [
                                    2,
                                    16
                                ], 12);
                                b.ms = T, w.marker.size = T;
                            }
                            f && (w.line = {
                                width: v("line.width", x, [
                                    0,
                                    10
                                ], 5)
                            }), g && (b.tx = "Aa", b.tp = v("textposition", x), b.ts = 10, b.tc = v("textfont.color", x), b.tf = v("textfont.family", x)), r = [
                                a.minExtend(p, b)
                            ], (i = a.minExtend(d, w)).selectedpoints = null, i.texttemplate = null;
                        }
                        var k = n.select(this).select("g.legendpoints"), A = k.selectAll("path.scatterpts").data(h ? r : []);
                        A.enter().insert("path", ":first-child").classed("scatterpts", !0).attr("transform", _), A.exit().remove(), A.call(s.pointStyle, i, e1), h && (r[0].mrc = 3);
                        var M = k.selectAll("g.pointtext").data(g ? r : []);
                        M.enter().append("g").classed("pointtext", !0).append("text").attr("transform", _), M.exit().remove(), M.selectAll("text").call(s.textPointStyle, i, e1);
                    }).each(function(t1) {
                        var e1 = t1[0].trace, r = n.select(this).select("g.legendpoints").selectAll("path.legendcandle").data(e1.visible && "candlestick" === e1.type ? [
                            t1,
                            t1
                        ] : []);
                        r.enter().append("path").classed("legendcandle", !0).attr("d", function(t1, e1) {
                            return e1 ? "M-15,0H-8M-8,6V-6H8Z" : "M15,0H8M8,-6V6H-8Z";
                        }).attr("transform", _).style("stroke-miterlimit", 1), r.exit().remove(), r.each(function(t1, r) {
                            var i = n.select(this), a = e1[r ? "increasing" : "decreasing"], o = w(void 0, a.line, 5, 2);
                            i.style("stroke-width", o + "px").call(l.fill, a.fillcolor), o && l.stroke(i, a.line.color);
                        });
                    }).each(function(t1) {
                        var e1 = t1[0].trace, r = n.select(this).select("g.legendpoints").selectAll("path.legendohlc").data(e1.visible && "ohlc" === e1.type ? [
                            t1,
                            t1
                        ] : []);
                        r.enter().append("path").classed("legendohlc", !0).attr("d", function(t1, e1) {
                            return e1 ? "M-15,0H0M-8,-6V0" : "M15,0H0M8,6V0";
                        }).attr("transform", _).style("stroke-miterlimit", 1), r.exit().remove(), r.each(function(t1, r) {
                            var i = n.select(this), a = e1[r ? "increasing" : "decreasing"], o = w(void 0, a.line, 5, 2);
                            i.style("fill", "none").call(s.dashLine, a.line.dash, o), o && l.stroke(i, a.line.color);
                        });
                    });
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638,
                "../../traces/pie/helpers": 905,
                "../../traces/pie/style_one": 911,
                "../../traces/scatter/subtypes": 951,
                "../color": 366,
                "../colorscale/helpers": 377,
                "../drawing": 388,
                "./constants": 417,
                "@plotly/d3": 58
            }
        ],
        425: [
            function(t1, e1, r) {
                "use strict";
                t1("./constants");
                e1.exports = {
                    editType: "modebar",
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        dflt: "h",
                        editType: "modebar"
                    },
                    bgcolor: {
                        valType: "color",
                        editType: "modebar"
                    },
                    color: {
                        valType: "color",
                        editType: "modebar"
                    },
                    activecolor: {
                        valType: "color",
                        editType: "modebar"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    add: {
                        valType: "string",
                        arrayOk: !0,
                        dflt: "",
                        editType: "modebar"
                    },
                    remove: {
                        valType: "string",
                        arrayOk: !0,
                        dflt: "",
                        editType: "modebar"
                    }
                };
            },
            {
                "./constants": 427
            }
        ],
        426: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../plots/plots"), a = t1("../../plots/cartesian/axis_ids"), o = t1("../../fonts/ploticon"), s = t1("../shapes/draw").eraseActiveShape, l = t1("../../lib"), c = l._, u = e1.exports = {};
                function f(t1, e1) {
                    var r, i, o = e1.currentTarget, s = o.getAttribute("data-attr"), l = o.getAttribute("data-val") || !0, c = t1._fullLayout, u = {}, f = a.list(t1, null, !0), h = c._cartesianSpikesEnabled;
                    if ("zoom" === s) {
                        var p, d = "in" === l ? .5 : 2, m = (1 + d) / 2, g = (1 - d) / 2;
                        for(i = 0; i < f.length; i++)if (!(r = f[i]).fixedrange) {
                            if (p = r._name, "auto" === l) u[p + ".autorange"] = !0;
                            else if ("reset" === l) {
                                if (void 0 === r._rangeInitial) u[p + ".autorange"] = !0;
                                else {
                                    var v = r._rangeInitial.slice();
                                    u[p + ".range[0]"] = v[0], u[p + ".range[1]"] = v[1];
                                }
                                void 0 !== r._showSpikeInitial && (u[p + ".showspikes"] = r._showSpikeInitial, "on" !== h || r._showSpikeInitial || (h = "off"));
                            } else {
                                var y = [
                                    r.r2l(r.range[0]),
                                    r.r2l(r.range[1])
                                ], x = [
                                    m * y[0] + g * y[1],
                                    m * y[1] + g * y[0]
                                ];
                                u[p + ".range[0]"] = r.l2r(x[0]), u[p + ".range[1]"] = r.l2r(x[1]);
                            }
                        }
                    } else "hovermode" !== s || "x" !== l && "y" !== l || (l = c._isHoriz ? "y" : "x", o.setAttribute("data-val", l)), u[s] = l;
                    c._cartesianSpikesEnabled = h, n.call("_guiRelayout", t1, u);
                }
                function h(t1, e1) {
                    for(var r = e1.currentTarget, i = r.getAttribute("data-attr"), a = r.getAttribute("data-val") || !0, o = t1._fullLayout._subplots.gl3d || [], s = {}, l = i.split("."), c = 0; c < o.length; c++)s[o[c] + "." + l[1]] = a;
                    var u = "pan" === a ? a : "zoom";
                    s.dragmode = u, n.call("_guiRelayout", t1, s);
                }
                function p(t1, e1) {
                    for(var r = e1.currentTarget.getAttribute("data-attr"), i = "resetLastSave" === r, a = "resetDefault" === r, o = t1._fullLayout, s = o._subplots.gl3d || [], l = {}, c = 0; c < s.length; c++){
                        var u, f = s[c], h = f + ".camera", p = f + ".aspectratio", d = f + ".aspectmode", m = o[f]._scene;
                        i ? (l[h + ".up"] = m.viewInitial.up, l[h + ".eye"] = m.viewInitial.eye, l[h + ".center"] = m.viewInitial.center, u = !0) : a && (l[h + ".up"] = null, l[h + ".eye"] = null, l[h + ".center"] = null, u = !0), u && (l[p + ".x"] = m.viewInitial.aspectratio.x, l[p + ".y"] = m.viewInitial.aspectratio.y, l[p + ".z"] = m.viewInitial.aspectratio.z, l[d] = m.viewInitial.aspectmode);
                    }
                    n.call("_guiRelayout", t1, l);
                }
                function d(t1, e1) {
                    var r = e1.currentTarget, n = r._previousVal, i = t1._fullLayout, a = i._subplots.gl3d || [], o = [
                        "xaxis",
                        "yaxis",
                        "zaxis"
                    ], s = {}, l = {};
                    if (n) l = n, r._previousVal = null;
                    else {
                        for(var c = 0; c < a.length; c++){
                            var u = a[c], f = i[u], h = u + ".hovermode";
                            s[h] = f.hovermode, l[h] = !1;
                            for(var p = 0; p < 3; p++){
                                var d = o[p], m = u + "." + d + ".showspikes";
                                l[m] = !1, s[m] = f[d].showspikes;
                            }
                        }
                        r._previousVal = s;
                    }
                    return l;
                }
                function m(t1, e1) {
                    for(var r = e1.currentTarget, i = r.getAttribute("data-attr"), a = r.getAttribute("data-val") || !0, o = t1._fullLayout, s = o._subplots.geo || [], l = 0; l < s.length; l++){
                        var c = s[l], u = o[c];
                        if ("zoom" === i) {
                            var f = u.projection.scale, h = "in" === a ? 2 * f : .5 * f;
                            n.call("_guiRelayout", t1, c + ".projection.scale", h);
                        }
                    }
                    "reset" === i && x(t1, "geo");
                }
                function g(t1) {
                    var e1 = t1._fullLayout;
                    return !e1.hovermode && (e1._has("cartesian") ? e1._isHoriz ? "y" : "x" : "closest");
                }
                function v(t1) {
                    var e1 = g(t1);
                    n.call("_guiRelayout", t1, "hovermode", e1);
                }
                function y(t1, e1) {
                    for(var r = e1.currentTarget.getAttribute("data-val"), i = t1._fullLayout, a = i._subplots.mapbox || [], o = {}, s = 0; s < a.length; s++){
                        var l = a[s], c = i[l].zoom, u = "in" === r ? 1.05 * c : c / 1.05;
                        o[l + ".zoom"] = u;
                    }
                    n.call("_guiRelayout", t1, o);
                }
                function x(t1, e1) {
                    for(var r = t1._fullLayout, i = r._subplots[e1] || [], a = {}, o = 0; o < i.length; o++)for(var s = i[o], l = r[s]._subplot.viewInitial, c = Object.keys(l), u = 0; u < c.length; u++){
                        var f = c[u];
                        a[s + "." + f] = l[f];
                    }
                    n.call("_guiRelayout", t1, a);
                }
                u.toImage = {
                    name: "toImage",
                    title: function(t1) {
                        var e1 = (t1._context.toImageButtonOptions || {}).format || "png";
                        return c(t1, "png" === e1 ? "Download plot as a png" : "Download plot");
                    },
                    icon: o.camera,
                    click: function(t1) {
                        var e1 = t1._context.toImageButtonOptions, r = {
                            format: e1.format || "png"
                        };
                        l.notifier(c(t1, "Taking snapshot - this may take a few seconds"), "long"), "svg" !== r.format && l.isIE() && (l.notifier(c(t1, "IE only supports svg.  Changing format to svg."), "long"), r.format = "svg"), [
                            "filename",
                            "width",
                            "height",
                            "scale"
                        ].forEach(function(t1) {
                            t1 in e1 && (r[t1] = e1[t1]);
                        }), n.call("downloadImage", t1, r).then(function(e1) {
                            l.notifier(c(t1, "Snapshot succeeded") + " - " + e1, "long");
                        }).catch(function() {
                            l.notifier(c(t1, "Sorry, there was a problem downloading your snapshot!"), "long");
                        });
                    }
                }, u.sendDataToCloud = {
                    name: "sendDataToCloud",
                    title: function(t1) {
                        return c(t1, "Edit in Chart Studio");
                    },
                    icon: o.disk,
                    click: function(t1) {
                        i.sendDataToCloud(t1);
                    }
                }, u.editInChartStudio = {
                    name: "editInChartStudio",
                    title: function(t1) {
                        return c(t1, "Edit in Chart Studio");
                    },
                    icon: o.pencil,
                    click: function(t1) {
                        i.sendDataToCloud(t1);
                    }
                }, u.zoom2d = {
                    name: "zoom2d",
                    _cat: "zoom",
                    title: function(t1) {
                        return c(t1, "Zoom");
                    },
                    attr: "dragmode",
                    val: "zoom",
                    icon: o.zoombox,
                    click: f
                }, u.pan2d = {
                    name: "pan2d",
                    _cat: "pan",
                    title: function(t1) {
                        return c(t1, "Pan");
                    },
                    attr: "dragmode",
                    val: "pan",
                    icon: o.pan,
                    click: f
                }, u.select2d = {
                    name: "select2d",
                    _cat: "select",
                    title: function(t1) {
                        return c(t1, "Box Select");
                    },
                    attr: "dragmode",
                    val: "select",
                    icon: o.selectbox,
                    click: f
                }, u.lasso2d = {
                    name: "lasso2d",
                    _cat: "lasso",
                    title: function(t1) {
                        return c(t1, "Lasso Select");
                    },
                    attr: "dragmode",
                    val: "lasso",
                    icon: o.lasso,
                    click: f
                }, u.drawclosedpath = {
                    name: "drawclosedpath",
                    title: function(t1) {
                        return c(t1, "Draw closed freeform");
                    },
                    attr: "dragmode",
                    val: "drawclosedpath",
                    icon: o.drawclosedpath,
                    click: f
                }, u.drawopenpath = {
                    name: "drawopenpath",
                    title: function(t1) {
                        return c(t1, "Draw open freeform");
                    },
                    attr: "dragmode",
                    val: "drawopenpath",
                    icon: o.drawopenpath,
                    click: f
                }, u.drawline = {
                    name: "drawline",
                    title: function(t1) {
                        return c(t1, "Draw line");
                    },
                    attr: "dragmode",
                    val: "drawline",
                    icon: o.drawline,
                    click: f
                }, u.drawrect = {
                    name: "drawrect",
                    title: function(t1) {
                        return c(t1, "Draw rectangle");
                    },
                    attr: "dragmode",
                    val: "drawrect",
                    icon: o.drawrect,
                    click: f
                }, u.drawcircle = {
                    name: "drawcircle",
                    title: function(t1) {
                        return c(t1, "Draw circle");
                    },
                    attr: "dragmode",
                    val: "drawcircle",
                    icon: o.drawcircle,
                    click: f
                }, u.eraseshape = {
                    name: "eraseshape",
                    title: function(t1) {
                        return c(t1, "Erase active shape");
                    },
                    icon: o.eraseshape,
                    click: s
                }, u.zoomIn2d = {
                    name: "zoomIn2d",
                    _cat: "zoomin",
                    title: function(t1) {
                        return c(t1, "Zoom in");
                    },
                    attr: "zoom",
                    val: "in",
                    icon: o.zoom_plus,
                    click: f
                }, u.zoomOut2d = {
                    name: "zoomOut2d",
                    _cat: "zoomout",
                    title: function(t1) {
                        return c(t1, "Zoom out");
                    },
                    attr: "zoom",
                    val: "out",
                    icon: o.zoom_minus,
                    click: f
                }, u.autoScale2d = {
                    name: "autoScale2d",
                    _cat: "autoscale",
                    title: function(t1) {
                        return c(t1, "Autoscale");
                    },
                    attr: "zoom",
                    val: "auto",
                    icon: o.autoscale,
                    click: f
                }, u.resetScale2d = {
                    name: "resetScale2d",
                    _cat: "resetscale",
                    title: function(t1) {
                        return c(t1, "Reset axes");
                    },
                    attr: "zoom",
                    val: "reset",
                    icon: o.home,
                    click: f
                }, u.hoverClosestCartesian = {
                    name: "hoverClosestCartesian",
                    _cat: "hoverclosest",
                    title: function(t1) {
                        return c(t1, "Show closest data on hover");
                    },
                    attr: "hovermode",
                    val: "closest",
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: f
                }, u.hoverCompareCartesian = {
                    name: "hoverCompareCartesian",
                    _cat: "hoverCompare",
                    title: function(t1) {
                        return c(t1, "Compare data on hover");
                    },
                    attr: "hovermode",
                    val: function(t1) {
                        return t1._fullLayout._isHoriz ? "y" : "x";
                    },
                    icon: o.tooltip_compare,
                    gravity: "ne",
                    click: f
                }, u.zoom3d = {
                    name: "zoom3d",
                    _cat: "zoom",
                    title: function(t1) {
                        return c(t1, "Zoom");
                    },
                    attr: "scene.dragmode",
                    val: "zoom",
                    icon: o.zoombox,
                    click: h
                }, u.pan3d = {
                    name: "pan3d",
                    _cat: "pan",
                    title: function(t1) {
                        return c(t1, "Pan");
                    },
                    attr: "scene.dragmode",
                    val: "pan",
                    icon: o.pan,
                    click: h
                }, u.orbitRotation = {
                    name: "orbitRotation",
                    title: function(t1) {
                        return c(t1, "Orbital rotation");
                    },
                    attr: "scene.dragmode",
                    val: "orbit",
                    icon: o["3d_rotate"],
                    click: h
                }, u.tableRotation = {
                    name: "tableRotation",
                    title: function(t1) {
                        return c(t1, "Turntable rotation");
                    },
                    attr: "scene.dragmode",
                    val: "turntable",
                    icon: o["z-axis"],
                    click: h
                }, u.resetCameraDefault3d = {
                    name: "resetCameraDefault3d",
                    _cat: "resetCameraDefault",
                    title: function(t1) {
                        return c(t1, "Reset camera to default");
                    },
                    attr: "resetDefault",
                    icon: o.home,
                    click: p
                }, u.resetCameraLastSave3d = {
                    name: "resetCameraLastSave3d",
                    _cat: "resetCameraLastSave",
                    title: function(t1) {
                        return c(t1, "Reset camera to last save");
                    },
                    attr: "resetLastSave",
                    icon: o.movie,
                    click: p
                }, u.hoverClosest3d = {
                    name: "hoverClosest3d",
                    _cat: "hoverclosest",
                    title: function(t1) {
                        return c(t1, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: null,
                    toggle: !0,
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: function(t1, e1) {
                        var r = d(t1, e1);
                        n.call("_guiRelayout", t1, r);
                    }
                }, u.zoomInGeo = {
                    name: "zoomInGeo",
                    _cat: "zoomin",
                    title: function(t1) {
                        return c(t1, "Zoom in");
                    },
                    attr: "zoom",
                    val: "in",
                    icon: o.zoom_plus,
                    click: m
                }, u.zoomOutGeo = {
                    name: "zoomOutGeo",
                    _cat: "zoomout",
                    title: function(t1) {
                        return c(t1, "Zoom out");
                    },
                    attr: "zoom",
                    val: "out",
                    icon: o.zoom_minus,
                    click: m
                }, u.resetGeo = {
                    name: "resetGeo",
                    _cat: "reset",
                    title: function(t1) {
                        return c(t1, "Reset");
                    },
                    attr: "reset",
                    val: null,
                    icon: o.autoscale,
                    click: m
                }, u.hoverClosestGeo = {
                    name: "hoverClosestGeo",
                    _cat: "hoverclosest",
                    title: function(t1) {
                        return c(t1, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: null,
                    toggle: !0,
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: v
                }, u.hoverClosestGl2d = {
                    name: "hoverClosestGl2d",
                    _cat: "hoverclosest",
                    title: function(t1) {
                        return c(t1, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: null,
                    toggle: !0,
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: v
                }, u.hoverClosestPie = {
                    name: "hoverClosestPie",
                    _cat: "hoverclosest",
                    title: function(t1) {
                        return c(t1, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: "closest",
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: v
                }, u.resetViewSankey = {
                    name: "resetSankeyGroup",
                    title: function(t1) {
                        return c(t1, "Reset view");
                    },
                    icon: o.home,
                    click: function(t1) {
                        for(var e1 = {
                            "node.groups": [],
                            "node.x": [],
                            "node.y": []
                        }, r = 0; r < t1._fullData.length; r++){
                            var i = t1._fullData[r]._viewInitial;
                            e1["node.groups"].push(i.node.groups.slice()), e1["node.x"].push(i.node.x.slice()), e1["node.y"].push(i.node.y.slice());
                        }
                        n.call("restyle", t1, e1);
                    }
                }, u.toggleHover = {
                    name: "toggleHover",
                    title: function(t1) {
                        return c(t1, "Toggle show closest data on hover");
                    },
                    attr: "hovermode",
                    val: null,
                    toggle: !0,
                    icon: o.tooltip_basic,
                    gravity: "ne",
                    click: function(t1, e1) {
                        var r = d(t1, e1);
                        r.hovermode = g(t1), n.call("_guiRelayout", t1, r);
                    }
                }, u.resetViews = {
                    name: "resetViews",
                    title: function(t1) {
                        return c(t1, "Reset views");
                    },
                    icon: o.home,
                    click: function(t1, e1) {
                        var r = e1.currentTarget;
                        r.setAttribute("data-attr", "zoom"), r.setAttribute("data-val", "reset"), f(t1, e1), r.setAttribute("data-attr", "resetLastSave"), p(t1, e1), x(t1, "geo"), x(t1, "mapbox");
                    }
                }, u.toggleSpikelines = {
                    name: "toggleSpikelines",
                    title: function(t1) {
                        return c(t1, "Toggle Spike Lines");
                    },
                    icon: o.spikeline,
                    attr: "_cartesianSpikesEnabled",
                    val: "on",
                    click: function(t1) {
                        var e1 = t1._fullLayout, r = e1._cartesianSpikesEnabled;
                        e1._cartesianSpikesEnabled = "on" === r ? "off" : "on", n.call("_guiRelayout", t1, function(t1) {
                            for(var e1 = "on" === t1._fullLayout._cartesianSpikesEnabled, r = a.list(t1, null, !0), n = {}, i = 0; i < r.length; i++){
                                var o = r[i];
                                n[o._name + ".showspikes"] = !!e1 || o._showSpikeInitial;
                            }
                            return n;
                        }(t1));
                    }
                }, u.resetViewMapbox = {
                    name: "resetViewMapbox",
                    _cat: "resetView",
                    title: function(t1) {
                        return c(t1, "Reset view");
                    },
                    attr: "reset",
                    icon: o.home,
                    click: function(t1) {
                        x(t1, "mapbox");
                    }
                }, u.zoomInMapbox = {
                    name: "zoomInMapbox",
                    _cat: "zoomin",
                    title: function(t1) {
                        return c(t1, "Zoom in");
                    },
                    attr: "zoom",
                    val: "in",
                    icon: o.zoom_plus,
                    click: y
                }, u.zoomOutMapbox = {
                    name: "zoomOutMapbox",
                    _cat: "zoomout",
                    title: function(t1) {
                        return c(t1, "Zoom out");
                    },
                    attr: "zoom",
                    val: "out",
                    icon: o.zoom_minus,
                    click: y
                };
            },
            {
                "../../fonts/ploticon": 482,
                "../../lib": 503,
                "../../plots/cartesian/axis_ids": 558,
                "../../plots/plots": 619,
                "../../registry": 638,
                "../shapes/draw": 450
            }
        ],
        427: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./buttons"), i = Object.keys(n), a = [
                    "drawline",
                    "drawopenpath",
                    "drawclosedpath",
                    "drawcircle",
                    "drawrect",
                    "eraseshape"
                ], o = [
                    "v1hovermode",
                    "hoverclosest",
                    "hovercompare",
                    "togglehover",
                    "togglespikelines"
                ].concat(a), s = [];
                i.forEach(function(t1) {
                    !function(t1) {
                        if (-1 === o.indexOf(t1._cat || t1.name)) {
                            var e1 = t1.name, r = (t1._cat || t1.name).toLowerCase();
                            -1 === s.indexOf(e1) && s.push(e1), -1 === s.indexOf(r) && s.push(r);
                        }
                    }(n[t1]);
                }), s.sort(), e1.exports = {
                    DRAW_MODES: a,
                    backButtons: o,
                    foreButtons: s
                };
            },
            {
                "./buttons": 426
            }
        ],
        428: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../color"), a = t1("../../plot_api/plot_template"), o = t1("./attributes");
                e1.exports = function(t1, e1) {
                    var r = t1.modebar || {}, s = a.newContainer(e1, "modebar");
                    function l(t1, e1) {
                        return n.coerce(r, s, o, t1, e1);
                    }
                    l("orientation"), l("bgcolor", i.addOpacity(e1.paper_bgcolor, .5));
                    var c = i.contrast(i.rgb(e1.modebar.bgcolor));
                    l("color", i.addOpacity(c, .3)), l("activecolor", i.addOpacity(c, .7)), l("uirevision", e1.uirevision), l("add"), l("remove");
                };
            },
            {
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../color": 366,
                "./attributes": 425
            }
        ],
        429: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "component",
                    name: "modebar",
                    layoutAttributes: t1("./attributes"),
                    supplyLayoutDefaults: t1("./defaults"),
                    manage: t1("./manage")
                };
            },
            {
                "./attributes": 425,
                "./defaults": 428,
                "./manage": 430
            }
        ],
        430: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axis_ids"), i = t1("../../traces/scatter/subtypes"), a = t1("../../registry"), o = t1("../fx/helpers").isUnifiedHover, s = t1("./modebar"), l = t1("./buttons"), c = t1("./constants").DRAW_MODES;
                e1.exports = function(t1) {
                    var e1 = t1._fullLayout, r = t1._context, u = e1._modeBar;
                    if (r.displayModeBar || r.watermark) {
                        if (!Array.isArray(r.modeBarButtonsToRemove)) throw new Error([
                            "*modeBarButtonsToRemove* configuration options",
                            "must be an array."
                        ].join(" "));
                        if (!Array.isArray(r.modeBarButtonsToAdd)) throw new Error([
                            "*modeBarButtonsToAdd* configuration options",
                            "must be an array."
                        ].join(" "));
                        var f, h = r.modeBarButtons;
                        f = Array.isArray(h) && h.length ? function(t1) {
                            for(var e1 = 0; e1 < t1.length; e1++)for(var r = t1[e1], n = 0; n < r.length; n++){
                                var i = r[n];
                                if ("string" == typeof i) {
                                    if (void 0 === l[i]) throw new Error([
                                        "*modeBarButtons* configuration options",
                                        "invalid button name"
                                    ].join(" "));
                                    t1[e1][n] = l[i];
                                }
                            }
                            return t1;
                        }(h) : !r.displayModeBar && r.watermark ? [] : function(t1) {
                            var e1 = t1._fullLayout, r = t1._fullData, s = t1._context;
                            function u(t1, e1) {
                                if ("string" == typeof e1) {
                                    if (e1.toLowerCase() === t1.toLowerCase()) return !0;
                                } else {
                                    var r = e1.name, n = e1._cat || e1.name;
                                    if (r === t1 || n === t1.toLowerCase()) return !0;
                                }
                                return !1;
                            }
                            var f = e1.modebar.add;
                            "string" == typeof f && (f = [
                                f
                            ]);
                            var h = e1.modebar.remove;
                            "string" == typeof h && (h = [
                                h
                            ]);
                            var p = s.modeBarButtonsToAdd.concat(f.filter(function(t1) {
                                for(var e1 = 0; e1 < s.modeBarButtonsToRemove.length; e1++)if (u(t1, s.modeBarButtonsToRemove[e1])) return !1;
                                return !0;
                            })), d = s.modeBarButtonsToRemove.concat(h.filter(function(t1) {
                                for(var e1 = 0; e1 < s.modeBarButtonsToAdd.length; e1++)if (u(t1, s.modeBarButtonsToAdd[e1])) return !1;
                                return !0;
                            })), m = e1._has("cartesian"), g = e1._has("gl3d"), v = e1._has("geo"), y = e1._has("pie"), x = e1._has("funnelarea"), b = e1._has("gl2d"), _ = e1._has("ternary"), w = e1._has("mapbox"), T = e1._has("polar"), k = e1._has("smith"), A = e1._has("sankey"), M = function(t1) {
                                for(var e1 = n.list({
                                    _fullLayout: t1
                                }, null, !0), r = 0; r < e1.length; r++)if (!e1[r].fixedrange) return !1;
                                return !0;
                            }(e1), S = o(e1.hovermode), E = [];
                            function L(t1) {
                                if (t1.length) {
                                    for(var e1 = [], r = 0; r < t1.length; r++){
                                        for(var n = t1[r], i = l[n], a = i.name.toLowerCase(), o = (i._cat || i.name).toLowerCase(), s = !1, c = 0; c < d.length; c++){
                                            var u = d[c].toLowerCase();
                                            if (u === a || u === o) {
                                                s = !0;
                                                break;
                                            }
                                        }
                                        s || e1.push(l[n]);
                                    }
                                    E.push(e1);
                                }
                            }
                            var C = [
                                "toImage"
                            ];
                            s.showEditInChartStudio ? C.push("editInChartStudio") : s.showSendToCloud && C.push("sendDataToCloud");
                            L(C);
                            var P = [], I = [], O = [], z = [];
                            (m || b || y || x || _) + v + g + w + T + k > 1 ? (I = [
                                "toggleHover"
                            ], O = [
                                "resetViews"
                            ]) : v ? (P = [
                                "zoomInGeo",
                                "zoomOutGeo"
                            ], I = [
                                "hoverClosestGeo"
                            ], O = [
                                "resetGeo"
                            ]) : g ? (I = [
                                "hoverClosest3d"
                            ], O = [
                                "resetCameraDefault3d",
                                "resetCameraLastSave3d"
                            ]) : w ? (P = [
                                "zoomInMapbox",
                                "zoomOutMapbox"
                            ], I = [
                                "toggleHover"
                            ], O = [
                                "resetViewMapbox"
                            ]) : b ? I = [
                                "hoverClosestGl2d"
                            ] : y ? I = [
                                "hoverClosestPie"
                            ] : A ? (I = [
                                "hoverClosestCartesian",
                                "hoverCompareCartesian"
                            ], O = [
                                "resetViewSankey"
                            ]) : I = [
                                "toggleHover"
                            ];
                            m && (I = [
                                "toggleSpikelines",
                                "hoverClosestCartesian",
                                "hoverCompareCartesian"
                            ]);
                            ((function(t1) {
                                for(var e1 = 0; e1 < t1.length; e1++)if (!a.traceIs(t1[e1], "noHover")) return !1;
                                return !0;
                            })(r) || S) && (I = []);
                            !m && !b || M || (P = [
                                "zoomIn2d",
                                "zoomOut2d",
                                "autoScale2d"
                            ], "resetViews" !== O[0] && (O = [
                                "resetScale2d"
                            ]));
                            g ? z = [
                                "zoom3d",
                                "pan3d",
                                "orbitRotation",
                                "tableRotation"
                            ] : (m || b) && !M || _ ? z = [
                                "zoom2d",
                                "pan2d"
                            ] : w || v ? z = [
                                "pan2d"
                            ] : T && (z = [
                                "zoom2d"
                            ]);
                            (function(t1) {
                                for(var e1 = !1, r = 0; r < t1.length && !e1; r++){
                                    var n = t1[r];
                                    n._module && n._module.selectPoints && (a.traceIs(n, "scatter-like") ? (i.hasMarkers(n) || i.hasText(n)) && (e1 = !0) : a.traceIs(n, "box-violin") && "all" !== n.boxpoints && "all" !== n.points || (e1 = !0));
                                }
                                return e1;
                            })(r) && z.push("select2d", "lasso2d");
                            var D = [], R = function(t1) {
                                -1 === D.indexOf(t1) && -1 !== I.indexOf(t1) && D.push(t1);
                            };
                            if (Array.isArray(p)) {
                                for(var F = [], B = 0; B < p.length; B++){
                                    var N = p[B];
                                    "string" == typeof N ? (N = N.toLowerCase(), -1 !== c.indexOf(N) ? (e1._has("mapbox") || e1._has("cartesian")) && z.push(N) : "togglespikelines" === N ? R("toggleSpikelines") : "togglehover" === N ? R("toggleHover") : "hovercompare" === N ? R("hoverCompareCartesian") : "hoverclosest" === N ? (R("hoverClosestCartesian"), R("hoverClosestGeo"), R("hoverClosest3d"), R("hoverClosestGl2d"), R("hoverClosestPie")) : "v1hovermode" === N && (R("toggleHover"), R("hoverClosestCartesian"), R("hoverCompareCartesian"), R("hoverClosestGeo"), R("hoverClosest3d"), R("hoverClosestGl2d"), R("hoverClosestPie"))) : F.push(N);
                                }
                                p = F;
                            }
                            return L(z), L(P.concat(O)), L(D), function(t1, e1) {
                                if (e1.length) {
                                    if (Array.isArray(e1[0])) for(var r = 0; r < e1.length; r++)t1.push(e1[r]);
                                    else t1.push(e1);
                                }
                                return t1;
                            }(E, p);
                        }(t1), u ? u.update(t1, f) : e1._modeBar = s(t1, f);
                    } else u && (u.destroy(), delete e1._modeBar);
                };
            },
            {
                "../../plots/cartesian/axis_ids": 558,
                "../../registry": 638,
                "../../traces/scatter/subtypes": 951,
                "../fx/helpers": 402,
                "./buttons": 426,
                "./constants": 427,
                "./modebar": 431
            }
        ],
        431: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("fast-isnumeric"), a = t1("../../lib"), o = t1("../../fonts/ploticon"), s = new DOMParser;
                function l(t1) {
                    this.container = t1.container, this.element = document.createElement("div"), this.update(t1.graphInfo, t1.buttons), this.container.appendChild(this.element);
                }
                var c = l.prototype;
                c.update = function(t1, e1) {
                    this.graphInfo = t1;
                    var r = this.graphInfo._context, n = this.graphInfo._fullLayout, i = "modebar-" + n._uid;
                    this.element.setAttribute("id", i), this._uid = i, this.element.className = "modebar", "hover" === r.displayModeBar && (this.element.className += " modebar--hover ease-bg"), "v" === n.modebar.orientation && (this.element.className += " vertical", e1 = e1.reverse());
                    var o = n.modebar, s = "hover" === r.displayModeBar ? ".js-plotly-plot .plotly:hover " : "";
                    a.deleteRelatedStyleRule(i), a.addRelatedStyleRule(i, s + "#" + i + " .modebar-group", "background-color: " + o.bgcolor), a.addRelatedStyleRule(i, "#" + i + " .modebar-btn .icon path", "fill: " + o.color), a.addRelatedStyleRule(i, "#" + i + " .modebar-btn:hover .icon path", "fill: " + o.activecolor), a.addRelatedStyleRule(i, "#" + i + " .modebar-btn.active .icon path", "fill: " + o.activecolor);
                    var l = !this.hasButtons(e1), c = this.hasLogo !== r.displaylogo, u = this.locale !== r.locale;
                    if (this.locale = r.locale, (l || c || u) && (this.removeAllButtons(), this.updateButtons(e1), r.watermark || r.displaylogo)) {
                        var f = this.getLogo();
                        r.watermark && (f.className = f.className + " watermark"), "v" === n.modebar.orientation ? this.element.insertBefore(f, this.element.childNodes[0]) : this.element.appendChild(f), this.hasLogo = !0;
                    }
                    this.updateActiveButton();
                }, c.updateButtons = function(t1) {
                    var e1 = this;
                    this.buttons = t1, this.buttonElements = [], this.buttonsNames = [], this.buttons.forEach(function(t1) {
                        var r = e1.createGroup();
                        t1.forEach(function(t1) {
                            var n = t1.name;
                            if (!n) throw new Error("must provide button 'name' in button config");
                            if (-1 !== e1.buttonsNames.indexOf(n)) throw new Error("button name '" + n + "' is taken");
                            e1.buttonsNames.push(n);
                            var i = e1.createButton(t1);
                            e1.buttonElements.push(i), r.appendChild(i);
                        }), e1.element.appendChild(r);
                    });
                }, c.createGroup = function() {
                    var t1 = document.createElement("div");
                    return t1.className = "modebar-group", t1;
                }, c.createButton = function(t1) {
                    var e1 = this, r = document.createElement("a");
                    r.setAttribute("rel", "tooltip"), r.className = "modebar-btn";
                    var i = t1.title;
                    void 0 === i ? i = t1.name : "function" == typeof i && (i = i(this.graphInfo)), (i || 0 === i) && r.setAttribute("data-title", i), void 0 !== t1.attr && r.setAttribute("data-attr", t1.attr);
                    var a = t1.val;
                    if (void 0 !== a && ("function" == typeof a && (a = a(this.graphInfo)), r.setAttribute("data-val", a)), "function" != typeof t1.click) throw new Error("must provide button 'click' function in button config");
                    r.addEventListener("click", function(r) {
                        t1.click(e1.graphInfo, r), e1.updateActiveButton(r.currentTarget);
                    }), r.setAttribute("data-toggle", t1.toggle || !1), t1.toggle && n.select(r).classed("active", !0);
                    var s = t1.icon;
                    return "function" == typeof s ? r.appendChild(s()) : r.appendChild(this.createIcon(s || o.question)), r.setAttribute("data-gravity", t1.gravity || "n"), r;
                }, c.createIcon = function(t1) {
                    var e1, r = i(t1.height) ? Number(t1.height) : t1.ascent - t1.descent, n = "http://www.w3.org/2000/svg";
                    if (t1.path) {
                        (e1 = document.createElementNS(n, "svg")).setAttribute("viewBox", [
                            0,
                            0,
                            t1.width,
                            r
                        ].join(" ")), e1.setAttribute("class", "icon");
                        var a = document.createElementNS(n, "path");
                        a.setAttribute("d", t1.path), t1.transform ? a.setAttribute("transform", t1.transform) : void 0 !== t1.ascent && a.setAttribute("transform", "matrix(1 0 0 -1 0 " + t1.ascent + ")"), e1.appendChild(a);
                    }
                    t1.svg && (e1 = s.parseFromString(t1.svg, "application/xml").childNodes[0]);
                    return e1.setAttribute("height", "1em"), e1.setAttribute("width", "1em"), e1;
                }, c.updateActiveButton = function(t1) {
                    var e1 = this.graphInfo._fullLayout, r = void 0 !== t1 ? t1.getAttribute("data-attr") : null;
                    this.buttonElements.forEach(function(t1) {
                        var i = t1.getAttribute("data-val") || !0, o = t1.getAttribute("data-attr"), s = "true" === t1.getAttribute("data-toggle"), l = n.select(t1);
                        if (s) o === r && l.classed("active", !l.classed("active"));
                        else {
                            var c = null === o ? o : a.nestedProperty(e1, o).get();
                            l.classed("active", c === i);
                        }
                    });
                }, c.hasButtons = function(t1) {
                    var e1 = this.buttons;
                    if (!e1) return !1;
                    if (t1.length !== e1.length) return !1;
                    for(var r = 0; r < t1.length; ++r){
                        if (t1[r].length !== e1[r].length) return !1;
                        for(var n = 0; n < t1[r].length; n++)if (t1[r][n].name !== e1[r][n].name) return !1;
                    }
                    return !0;
                }, c.getLogo = function() {
                    var t1 = this.createGroup(), e1 = document.createElement("a");
                    return e1.href = "https://plotly.com/", e1.target = "_blank", e1.setAttribute("data-title", a._(this.graphInfo, "Produced with Plotly")), e1.className = "modebar-btn plotlyjsicon modebar-btn--logo", e1.appendChild(this.createIcon(o.newplotlylogo)), t1.appendChild(e1), t1;
                }, c.removeAllButtons = function() {
                    for(; this.element.firstChild;)this.element.removeChild(this.element.firstChild);
                    this.hasLogo = !1;
                }, c.destroy = function() {
                    a.removeElement(this.container.querySelector(".modebar")), a.deleteRelatedStyleRule(this._uid);
                }, e1.exports = function(t1, e1) {
                    var r = t1._fullLayout, i = new l({
                        graphInfo: t1,
                        container: r._modebardiv.node(),
                        buttons: e1
                    });
                    return r._privateplot && n.select(i.element).append("span").classed("badge-private float--left", !0).text("PRIVATE"), i;
                };
            },
            {
                "../../fonts/ploticon": 482,
                "../../lib": 503,
                "@plotly/d3": 58,
                "fast-isnumeric": 190
            }
        ],
        432: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/font_attributes"), i = t1("../color/attributes"), a = (0, t1("../../plot_api/plot_template").templatedArray)("button", {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    step: {
                        valType: "enumerated",
                        values: [
                            "month",
                            "year",
                            "day",
                            "hour",
                            "minute",
                            "second",
                            "all"
                        ],
                        dflt: "month",
                        editType: "plot"
                    },
                    stepmode: {
                        valType: "enumerated",
                        values: [
                            "backward",
                            "todate"
                        ],
                        dflt: "backward",
                        editType: "plot"
                    },
                    count: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "plot"
                    },
                    label: {
                        valType: "string",
                        editType: "plot"
                    },
                    editType: "plot"
                });
                e1.exports = {
                    visible: {
                        valType: "boolean",
                        editType: "plot"
                    },
                    buttons: a,
                    x: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        editType: "plot"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left",
                        editType: "plot"
                    },
                    y: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        editType: "plot"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "bottom",
                        editType: "plot"
                    },
                    font: n({
                        editType: "plot"
                    }),
                    bgcolor: {
                        valType: "color",
                        dflt: i.lightLine,
                        editType: "plot"
                    },
                    activecolor: {
                        valType: "color",
                        editType: "plot"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "plot"
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "plot"
                    },
                    editType: "plot"
                };
            },
            {
                "../../plot_api/plot_template": 543,
                "../../plots/font_attributes": 585,
                "../color/attributes": 365
            }
        ],
        433: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    yPad: .02,
                    minButtonWidth: 30,
                    rx: 3,
                    ry: 3,
                    lightAmount: 25,
                    darkAmount: 10
                };
            },
            {}
        ],
        434: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../color"), a = t1("../../plot_api/plot_template"), o = t1("../../plots/array_container_defaults"), s = t1("./attributes"), l = t1("./constants");
                function c(t1, e1, r, i) {
                    var a = i.calendar;
                    function o(r, i) {
                        return n.coerce(t1, e1, s.buttons, r, i);
                    }
                    if (o("visible")) {
                        var l = o("step");
                        "all" !== l && (!a || "gregorian" === a || "month" !== l && "year" !== l ? o("stepmode") : e1.stepmode = "backward", o("count")), o("label");
                    }
                }
                e1.exports = function(t1, e1, r, u, f) {
                    var h = t1.rangeselector || {}, p = a.newContainer(e1, "rangeselector");
                    function d(t1, e1) {
                        return n.coerce(h, p, s, t1, e1);
                    }
                    if (d("visible", o(h, p, {
                        name: "buttons",
                        handleItemDefaults: c,
                        calendar: f
                    }).length > 0)) {
                        var m = function(t1, e1, r) {
                            for(var n = r.filter(function(r) {
                                return e1[r].anchor === t1._id;
                            }), i = 0, a = 0; a < n.length; a++){
                                var o = e1[n[a]].domain;
                                o && (i = Math.max(o[1], i));
                            }
                            return [
                                t1.domain[0],
                                i + l.yPad
                            ];
                        }(e1, r, u);
                        d("x", m[0]), d("y", m[1]), n.noneOrAll(t1, e1, [
                            "x",
                            "y"
                        ]), d("xanchor"), d("yanchor"), n.coerceFont(d, "font", r.font);
                        var g = d("bgcolor");
                        d("activecolor", i.contrast(g, l.lightAmount, l.darkAmount)), d("bordercolor"), d("borderwidth");
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../../plots/array_container_defaults": 549,
                "../color": 366,
                "./attributes": 432,
                "./constants": 433
            }
        ],
        435: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../registry"), a = t1("../../plots/plots"), o = t1("../color"), s = t1("../drawing"), l = t1("../../lib"), c = l.strTranslate, u = t1("../../lib/svg_text_utils"), f = t1("../../plots/cartesian/axis_ids"), h = t1("../../constants/alignment"), p = h.LINE_SPACING, d = h.FROM_TL, m = h.FROM_BR, g = t1("./constants"), v = t1("./get_update_object");
                function y(t1) {
                    return t1._id;
                }
                function x(t1, e1, r) {
                    var n = l.ensureSingle(t1, "rect", "selector-rect", function(t1) {
                        t1.attr("shape-rendering", "crispEdges");
                    });
                    n.attr({
                        rx: g.rx,
                        ry: g.ry
                    }), n.call(o.stroke, e1.bordercolor).call(o.fill, function(t1, e1) {
                        return e1._isActive || e1._isHovered ? t1.activecolor : t1.bgcolor;
                    }(e1, r)).style("stroke-width", e1.borderwidth + "px");
                }
                function b(t1, e1, r, n) {
                    l.ensureSingle(t1, "text", "selector-text", function(t1) {
                        t1.attr("text-anchor", "middle");
                    }).call(s.font, e1.font).text(function(t1, e1) {
                        if (t1.label) return e1 ? l.templateString(t1.label, e1) : t1.label;
                        return "all" === t1.step ? "all" : t1.count + t1.step.charAt(0);
                    }(r, n._fullLayout._meta)).call(function(t1) {
                        u.convertToTspans(t1, n);
                    });
                }
                e1.exports = function(t1) {
                    var e1 = t1._fullLayout._infolayer.selectAll(".rangeselector").data(function(t1) {
                        for(var e1 = f.list(t1, "x", !0), r = [], n = 0; n < e1.length; n++){
                            var i = e1[n];
                            i.rangeselector && i.rangeselector.visible && r.push(i);
                        }
                        return r;
                    }(t1), y);
                    e1.enter().append("g").classed("rangeselector", !0), e1.exit().remove(), e1.style({
                        cursor: "pointer",
                        "pointer-events": "all"
                    }), e1.each(function(e1) {
                        var r = n.select(this), o = e1, f = o.rangeselector, h = r.selectAll("g.button").data(l.filterVisible(f.buttons));
                        h.enter().append("g").classed("button", !0), h.exit().remove(), h.each(function(e1) {
                            var r = n.select(this), a = v(o, e1);
                            e1._isActive = function(t1, e1, r) {
                                if ("all" === e1.step) return !0 === t1.autorange;
                                var n = Object.keys(r);
                                return t1.range[0] === r[n[0]] && t1.range[1] === r[n[1]];
                            }(o, e1, a), r.call(x, f, e1), r.call(b, f, e1, t1), r.on("click", function() {
                                t1._dragged || i.call("_guiRelayout", t1, a);
                            }), r.on("mouseover", function() {
                                e1._isHovered = !0, r.call(x, f, e1);
                            }), r.on("mouseout", function() {
                                e1._isHovered = !1, r.call(x, f, e1);
                            });
                        }), function(t1, e1, r, i, o) {
                            var f = 0, h = 0, v = r.borderwidth;
                            e1.each(function() {
                                var t1 = n.select(this).select(".selector-text"), e1 = r.font.size * p, i = Math.max(e1 * u.lineCount(t1), 16) + 3;
                                h = Math.max(h, i);
                            }), e1.each(function() {
                                var t1 = n.select(this), e1 = t1.select(".selector-rect"), i = t1.select(".selector-text"), a = i.node() && s.bBox(i.node()).width, o = r.font.size * p, l = u.lineCount(i), d = Math.max(a + 10, g.minButtonWidth);
                                t1.attr("transform", c(v + f, v)), e1.attr({
                                    x: 0,
                                    y: 0,
                                    width: d,
                                    height: h
                                }), u.positionText(i, d / 2, h / 2 - (l - 1) * o / 2 + 3), f += d + 5;
                            });
                            var y = t1._fullLayout._size, x = y.l + y.w * r.x, b = y.t + y.h * (1 - r.y), _ = "left";
                            l.isRightAnchor(r) && (x -= f, _ = "right");
                            l.isCenterAnchor(r) && (x -= f / 2, _ = "center");
                            var w = "top";
                            l.isBottomAnchor(r) && (b -= h, w = "bottom");
                            l.isMiddleAnchor(r) && (b -= h / 2, w = "middle");
                            f = Math.ceil(f), h = Math.ceil(h), x = Math.round(x), b = Math.round(b), a.autoMargin(t1, i + "-range-selector", {
                                x: r.x,
                                y: r.y,
                                l: f * d[_],
                                r: f * m[_],
                                b: h * m[w],
                                t: h * d[w]
                            }), o.attr("transform", c(x, b));
                        }(t1, h, f, o._name, r);
                    });
                };
            },
            {
                "../../constants/alignment": 471,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../plots/cartesian/axis_ids": 558,
                "../../plots/plots": 619,
                "../../registry": 638,
                "../color": 366,
                "../drawing": 388,
                "./constants": 433,
                "./get_update_object": 436,
                "@plotly/d3": 58
            }
        ],
        436: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("d3-time"), i = t1("../../lib").titleCase;
                e1.exports = function(t1, e1) {
                    var r = t1._name, a = {};
                    if ("all" === e1.step) a[r + ".autorange"] = !0;
                    else {
                        var o = function(t1, e1) {
                            var r, a = t1.range, o = new Date(t1.r2l(a[1])), s = e1.step, l = n["utc" + i(s)], c = e1.count;
                            switch(e1.stepmode){
                                case "backward":
                                    r = t1.l2r(+l.offset(o, -c));
                                    break;
                                case "todate":
                                    var u = l.offset(o, -c);
                                    r = t1.l2r(+l.ceil(u));
                            }
                            var f = a[1];
                            return [
                                r,
                                f
                            ];
                        }(t1, e1);
                        a[r + ".range[0]"] = o[0], a[r + ".range[1]"] = o[1];
                    }
                    return a;
                };
            },
            {
                "../../lib": 503,
                "d3-time": 122
            }
        ],
        437: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "component",
                    name: "rangeselector",
                    schema: {
                        subplots: {
                            xaxis: {
                                rangeselector: t1("./attributes")
                            }
                        }
                    },
                    layoutAttributes: t1("./attributes"),
                    handleDefaults: t1("./defaults"),
                    draw: t1("./draw")
                };
            },
            {
                "./attributes": 432,
                "./defaults": 434,
                "./draw": 435
            }
        ],
        438: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../color/attributes");
                e1.exports = {
                    bgcolor: {
                        valType: "color",
                        dflt: n.background,
                        editType: "plot"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: n.defaultLine,
                        editType: "plot"
                    },
                    borderwidth: {
                        valType: "integer",
                        dflt: 0,
                        min: 0,
                        editType: "plot"
                    },
                    autorange: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc",
                        impliedEdits: {
                            "range[0]": void 0,
                            "range[1]": void 0
                        }
                    },
                    range: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "calc",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            },
                            {
                                valType: "any",
                                editType: "calc",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            }
                        ],
                        editType: "calc",
                        impliedEdits: {
                            autorange: !1
                        }
                    },
                    thickness: {
                        valType: "number",
                        dflt: .15,
                        min: 0,
                        max: 1,
                        editType: "plot"
                    },
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    editType: "calc"
                };
            },
            {
                "../color/attributes": 365
            }
        ],
        439: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axis_ids").list, i = t1("../../plots/cartesian/autorange").getAutoRange, a = t1("./constants");
                e1.exports = function(t1) {
                    for(var e1 = n(t1, "x", !0), r = 0; r < e1.length; r++){
                        var o = e1[r], s = o[a.name];
                        s && s.visible && s.autorange && (s._input.autorange = !0, s._input.range = s.range = i(t1, o));
                    }
                };
            },
            {
                "../../plots/cartesian/autorange": 553,
                "../../plots/cartesian/axis_ids": 558,
                "./constants": 440
            }
        ],
        440: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    name: "rangeslider",
                    containerClassName: "rangeslider-container",
                    bgClassName: "rangeslider-bg",
                    rangePlotClassName: "rangeslider-rangeplot",
                    maskMinClassName: "rangeslider-mask-min",
                    maskMaxClassName: "rangeslider-mask-max",
                    slideBoxClassName: "rangeslider-slidebox",
                    grabberMinClassName: "rangeslider-grabber-min",
                    grabAreaMinClassName: "rangeslider-grabarea-min",
                    handleMinClassName: "rangeslider-handle-min",
                    grabberMaxClassName: "rangeslider-grabber-max",
                    grabAreaMaxClassName: "rangeslider-grabarea-max",
                    handleMaxClassName: "rangeslider-handle-max",
                    maskMinOppAxisClassName: "rangeslider-mask-min-opp-axis",
                    maskMaxOppAxisClassName: "rangeslider-mask-max-opp-axis",
                    maskColor: "rgba(0,0,0,0.4)",
                    maskOppAxisColor: "rgba(0,0,0,0.2)",
                    slideBoxFill: "transparent",
                    slideBoxCursor: "ew-resize",
                    grabAreaFill: "transparent",
                    grabAreaCursor: "col-resize",
                    grabAreaWidth: 10,
                    handleWidth: 4,
                    handleRadius: 1,
                    handleStrokeWidth: 1,
                    extraPad: 15
                };
            },
            {}
        ],
        441: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plot_api/plot_template"), a = t1("../../plots/cartesian/axis_ids"), o = t1("./attributes"), s = t1("./oppaxis_attributes");
                e1.exports = function(t1, e1, r) {
                    var l = t1[r], c = e1[r];
                    if (l.rangeslider || e1._requestRangeslider[c._id]) {
                        n.isPlainObject(l.rangeslider) || (l.rangeslider = {});
                        var u, f, h = l.rangeslider, p = i.newContainer(c, "rangeslider");
                        if (_("visible")) {
                            _("bgcolor", e1.plot_bgcolor), _("bordercolor"), _("borderwidth"), _("thickness"), _("autorange", !c.isValidRange(h.range)), _("range");
                            var d = e1._subplots;
                            if (d) for(var m = d.cartesian.filter(function(t1) {
                                return t1.substr(0, t1.indexOf("y")) === a.name2id(r);
                            }).map(function(t1) {
                                return t1.substr(t1.indexOf("y"), t1.length);
                            }), g = n.simpleMap(m, a.id2name), v = 0; v < g.length; v++){
                                var y = g[v];
                                u = h[y] || {}, f = i.newContainer(p, y, "yaxis");
                                var x, b = e1[y];
                                u.range && b.isValidRange(u.range) && (x = "fixed"), "match" !== w("rangemode", x) && w("range", b.range.slice());
                            }
                            p._input = h;
                        }
                    }
                    function _(t1, e1) {
                        return n.coerce(h, p, o, t1, e1);
                    }
                    function w(t1, e1) {
                        return n.coerce(u, f, s, t1, e1);
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../../plots/cartesian/axis_ids": 558,
                "./attributes": 438,
                "./oppaxis_attributes": 445
            }
        ],
        442: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../registry"), a = t1("../../plots/plots"), o = t1("../../lib"), s = o.strTranslate, l = t1("../drawing"), c = t1("../color"), u = t1("../titles"), f = t1("../../plots/cartesian"), h = t1("../../plots/cartesian/axis_ids"), p = t1("../dragelement"), d = t1("../../lib/setcursor"), m = t1("./constants");
                function g(t1, e1, r, n) {
                    var i = o.ensureSingle(t1, "rect", m.bgClassName, function(t1) {
                        t1.attr({
                            x: 0,
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }), a = n.borderwidth % 2 == 0 ? n.borderwidth : n.borderwidth - 1, c = -n._offsetShift, u = l.crispRound(e1, n.borderwidth);
                    i.attr({
                        width: n._width + a,
                        height: n._height + a,
                        transform: s(c, c),
                        fill: n.bgcolor,
                        stroke: n.bordercolor,
                        "stroke-width": u
                    });
                }
                function v(t1, e1, r, n) {
                    var i = e1._fullLayout;
                    o.ensureSingleById(i._topdefs, "clipPath", n._clipId, function(t1) {
                        t1.append("rect").attr({
                            x: 0,
                            y: 0
                        });
                    }).select("rect").attr({
                        width: n._width,
                        height: n._height
                    });
                }
                function y(t1, e1, r, i) {
                    var s, c = e1.calcdata, u = t1.selectAll("g." + m.rangePlotClassName).data(r._subplotsWith, o.identity);
                    u.enter().append("g").attr("class", function(t1) {
                        return m.rangePlotClassName + " " + t1;
                    }).call(l.setClipUrl, i._clipId, e1), u.order(), u.exit().remove(), u.each(function(t1, o) {
                        var l = n.select(this), u = 0 === o, p = h.getFromId(e1, t1, "y"), d = p._name, m = i[d], g = {
                            data: [],
                            layout: {
                                xaxis: {
                                    type: r.type,
                                    domain: [
                                        0,
                                        1
                                    ],
                                    range: i.range.slice(),
                                    calendar: r.calendar
                                },
                                width: i._width,
                                height: i._height,
                                margin: {
                                    t: 0,
                                    b: 0,
                                    l: 0,
                                    r: 0
                                }
                            },
                            _context: e1._context
                        };
                        r.rangebreaks && (g.layout.xaxis.rangebreaks = r.rangebreaks), g.layout[d] = {
                            type: p.type,
                            domain: [
                                0,
                                1
                            ],
                            range: "match" !== m.rangemode ? m.range.slice() : p.range.slice(),
                            calendar: p.calendar
                        }, p.rangebreaks && (g.layout[d].rangebreaks = p.rangebreaks), a.supplyDefaults(g);
                        var v = g._fullLayout.xaxis, y = g._fullLayout[d];
                        v.clearCalc(), v.setScale(), y.clearCalc(), y.setScale();
                        var x = {
                            id: t1,
                            plotgroup: l,
                            xaxis: v,
                            yaxis: y,
                            isRangePlot: !0
                        };
                        u ? s = x : (x.mainplot = "xy", x.mainplotinfo = s), f.rangePlot(e1, x, function(t1, e1) {
                            for(var r = [], n = 0; n < t1.length; n++){
                                var i = t1[n], a = i[0].trace;
                                a.xaxis + a.yaxis === e1 && r.push(i);
                            }
                            return r;
                        }(c, t1));
                    });
                }
                function x(t1, e1, r, n, i) {
                    (o.ensureSingle(t1, "rect", m.maskMinClassName, function(t1) {
                        t1.attr({
                            x: 0,
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr("height", n._height).call(c.fill, m.maskColor), o.ensureSingle(t1, "rect", m.maskMaxClassName, function(t1) {
                        t1.attr({
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr("height", n._height).call(c.fill, m.maskColor), "match" !== i.rangemode) && (o.ensureSingle(t1, "rect", m.maskMinOppAxisClassName, function(t1) {
                        t1.attr({
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr("width", n._width).call(c.fill, m.maskOppAxisColor), o.ensureSingle(t1, "rect", m.maskMaxOppAxisClassName, function(t1) {
                        t1.attr({
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr("width", n._width).style("border-top", m.maskOppBorder).call(c.fill, m.maskOppAxisColor));
                }
                function b(t1, e1, r, n) {
                    e1._context.staticPlot || o.ensureSingle(t1, "rect", m.slideBoxClassName, function(t1) {
                        t1.attr({
                            y: 0,
                            cursor: m.slideBoxCursor,
                            "shape-rendering": "crispEdges"
                        });
                    }).attr({
                        height: n._height,
                        fill: m.slideBoxFill
                    });
                }
                function _(t1, e1, r, n) {
                    var i = o.ensureSingle(t1, "g", m.grabberMinClassName), a = o.ensureSingle(t1, "g", m.grabberMaxClassName), s = {
                        x: 0,
                        width: m.handleWidth,
                        rx: m.handleRadius,
                        fill: c.background,
                        stroke: c.defaultLine,
                        "stroke-width": m.handleStrokeWidth,
                        "shape-rendering": "crispEdges"
                    }, l = {
                        y: Math.round(n._height / 4),
                        height: Math.round(n._height / 2)
                    };
                    o.ensureSingle(i, "rect", m.handleMinClassName, function(t1) {
                        t1.attr(s);
                    }).attr(l), o.ensureSingle(a, "rect", m.handleMaxClassName, function(t1) {
                        t1.attr(s);
                    }).attr(l);
                    var u = {
                        width: m.grabAreaWidth,
                        x: 0,
                        y: 0,
                        fill: m.grabAreaFill,
                        cursor: e1._context.staticPlot ? void 0 : m.grabAreaCursor
                    };
                    o.ensureSingle(i, "rect", m.grabAreaMinClassName, function(t1) {
                        t1.attr(u);
                    }).attr("height", n._height), o.ensureSingle(a, "rect", m.grabAreaMaxClassName, function(t1) {
                        t1.attr(u);
                    }).attr("height", n._height);
                }
                e1.exports = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._rangeSliderData, a = 0; a < r.length; a++){
                        var l = r[a][m.name];
                        l._clipId = l._id + "-" + e1._uid;
                    }
                    var c = e1._infolayer.selectAll("g." + m.containerClassName).data(r, function(t1) {
                        return t1._name;
                    });
                    c.exit().each(function(t1) {
                        var r = t1[m.name];
                        e1._topdefs.select("#" + r._clipId).remove();
                    }).remove(), 0 !== r.length && (c.enter().append("g").classed(m.containerClassName, !0).attr("pointer-events", "all"), c.each(function(r) {
                        var a = n.select(this), l = r[m.name], c = e1[h.id2name(r.anchor)], f = l[h.id2name(r.anchor)];
                        if (l.range) {
                            var w, T = o.simpleMap(l.range, r.r2l), k = o.simpleMap(r.range, r.r2l);
                            w = k[0] < k[1] ? [
                                Math.min(T[0], k[0]),
                                Math.max(T[1], k[1])
                            ] : [
                                Math.max(T[0], k[0]),
                                Math.min(T[1], k[1])
                            ], l.range = l._input.range = o.simpleMap(w, r.l2r);
                        }
                        r.cleanRange("rangeslider.range");
                        var A = e1._size, M = r.domain;
                        l._width = A.w * (M[1] - M[0]);
                        var S = Math.round(A.l + A.w * M[0]), E = Math.round(A.t + A.h * (1 - r._counterDomainMin) + ("bottom" === r.side ? r._depth : 0) + l._offsetShift + m.extraPad);
                        a.attr("transform", s(S, E)), l._rl = o.simpleMap(l.range, r.r2l);
                        var L = l._rl[0], C = l._rl[1], P = C - L;
                        if (l.p2d = function(t1) {
                            return t1 / l._width * P + L;
                        }, l.d2p = function(t1) {
                            return (t1 - L) / P * l._width;
                        }, r.rangebreaks) {
                            var I = r.locateBreaks(L, C);
                            if (I.length) {
                                var O, z, D = 0;
                                for(O = 0; O < I.length; O++)D += (z = I[O]).max - z.min;
                                var R = l._width / (C - L - D), F = [
                                    -R * L
                                ];
                                for(O = 0; O < I.length; O++)z = I[O], F.push(F[F.length - 1] - R * (z.max - z.min));
                                for(l.d2p = function(t1) {
                                    for(var e1 = F[0], r = 0; r < I.length; r++){
                                        var n = I[r];
                                        if (t1 >= n.max) e1 = F[r + 1];
                                        else if (t1 < n.min) break;
                                    }
                                    return e1 + R * t1;
                                }, O = 0; O < I.length; O++)(z = I[O]).pmin = l.d2p(z.min), z.pmax = l.d2p(z.max);
                                l.p2d = function(t1) {
                                    for(var e1 = F[0], r = 0; r < I.length; r++){
                                        var n = I[r];
                                        if (t1 >= n.pmax) e1 = F[r + 1];
                                        else if (t1 < n.pmin) break;
                                    }
                                    return (t1 - e1) / R;
                                };
                            }
                        }
                        if ("match" !== f.rangemode) {
                            var B = c.r2l(f.range[0]), N = c.r2l(f.range[1]) - B;
                            l.d2pOppAxis = function(t1) {
                                return (t1 - B) / N * l._height;
                            };
                        }
                        a.call(g, t1, r, l).call(v, t1, r, l).call(y, t1, r, l).call(x, t1, r, l, f).call(b, t1, r, l).call(_, t1, r, l), function(t1, e1, r, a) {
                            if (e1._context.staticPlot) return;
                            var s = t1.select("rect." + m.slideBoxClassName).node(), l = t1.select("rect." + m.grabAreaMinClassName).node(), c = t1.select("rect." + m.grabAreaMaxClassName).node();
                            function u() {
                                var u = n.event, f = u.target, h = u.clientX || u.touches[0].clientX, m = h - t1.node().getBoundingClientRect().left, g = a.d2p(r._rl[0]), v = a.d2p(r._rl[1]), y = p.coverSlip();
                                function x(t1) {
                                    var u, p, x, b = +(t1.clientX || t1.touches[0].clientX) - h;
                                    switch(f){
                                        case s:
                                            x = "ew-resize", u = g + b, p = v + b;
                                            break;
                                        case l:
                                            x = "col-resize", u = g + b, p = v;
                                            break;
                                        case c:
                                            x = "col-resize", u = g, p = v + b;
                                            break;
                                        default:
                                            x = "ew-resize", u = m, p = m + b;
                                    }
                                    if (p < u) {
                                        var _ = p;
                                        p = u, u = _;
                                    }
                                    a._pixelMin = u, a._pixelMax = p, d(n.select(y), x), function(t1, e1, r, n) {
                                        function a(t1) {
                                            return r.l2r(o.constrain(t1, n._rl[0], n._rl[1]));
                                        }
                                        var s = a(n.p2d(n._pixelMin)), l = a(n.p2d(n._pixelMax));
                                        window.requestAnimationFrame(function() {
                                            i.call("_guiRelayout", e1, r._name + ".range", [
                                                s,
                                                l
                                            ]);
                                        });
                                    }(0, e1, r, a);
                                }
                                function b() {
                                    y.removeEventListener("mousemove", x), y.removeEventListener("mouseup", b), this.removeEventListener("touchmove", x), this.removeEventListener("touchend", b), o.removeElement(y);
                                }
                                this.addEventListener("touchmove", x), this.addEventListener("touchend", b), y.addEventListener("mousemove", x), y.addEventListener("mouseup", b);
                            }
                            t1.on("mousedown", u), t1.on("touchstart", u);
                        }(a, t1, r, l), function(t1, e1, r, n, i, a) {
                            var l = m.handleWidth / 2;
                            function c(t1) {
                                return o.constrain(t1, 0, n._width);
                            }
                            function u(t1) {
                                return o.constrain(t1, 0, n._height);
                            }
                            function f(t1) {
                                return o.constrain(t1, -l, n._width + l);
                            }
                            var h = c(n.d2p(r._rl[0])), p = c(n.d2p(r._rl[1]));
                            if (t1.select("rect." + m.slideBoxClassName).attr("x", h).attr("width", p - h), t1.select("rect." + m.maskMinClassName).attr("width", h), t1.select("rect." + m.maskMaxClassName).attr("x", p).attr("width", n._width - p), "match" !== a.rangemode) {
                                var d = n._height - u(n.d2pOppAxis(i._rl[1])), g = n._height - u(n.d2pOppAxis(i._rl[0]));
                                t1.select("rect." + m.maskMinOppAxisClassName).attr("x", h).attr("height", d).attr("width", p - h), t1.select("rect." + m.maskMaxOppAxisClassName).attr("x", h).attr("y", g).attr("height", n._height - g).attr("width", p - h), t1.select("rect." + m.slideBoxClassName).attr("y", d).attr("height", g - d);
                            }
                            var v = Math.round(f(h - l)) - .5, y = Math.round(f(p - l)) + .5;
                            t1.select("g." + m.grabberMinClassName).attr("transform", s(v, .5)), t1.select("g." + m.grabberMaxClassName).attr("transform", s(y, .5));
                        }(a, 0, r, l, c, f), "bottom" === r.side && u.draw(t1, r._id + "title", {
                            propContainer: r,
                            propName: r._name + ".title",
                            placeholder: e1._dfltTitle.x,
                            attributes: {
                                x: r._offset + r._length / 2,
                                y: E + l._height + l._offsetShift + 10 + 1.5 * r.title.font.size,
                                "text-anchor": "middle"
                            }
                        });
                    }));
                };
            },
            {
                "../../lib": 503,
                "../../lib/setcursor": 524,
                "../../plots/cartesian": 568,
                "../../plots/cartesian/axis_ids": 558,
                "../../plots/plots": 619,
                "../../registry": 638,
                "../color": 366,
                "../dragelement": 385,
                "../drawing": 388,
                "../titles": 464,
                "./constants": 440,
                "@plotly/d3": 58
            }
        ],
        443: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axis_ids"), i = t1("../../lib/svg_text_utils"), a = t1("./constants"), o = t1("../../constants/alignment").LINE_SPACING, s = a.name;
                function l(t1) {
                    var e1 = t1 && t1[s];
                    return e1 && e1.visible;
                }
                r.isVisible = l, r.makeData = function(t1) {
                    var e1 = n.list({
                        _fullLayout: t1
                    }, "x", !0), r = t1.margin, i = [];
                    if (!t1._has("gl2d")) for(var a = 0; a < e1.length; a++){
                        var o = e1[a];
                        if (l(o)) {
                            i.push(o);
                            var c = o[s];
                            c._id = s + o._id, c._height = (t1.height - r.b - r.t) * c.thickness, c._offsetShift = Math.floor(c.borderwidth / 2);
                        }
                    }
                    t1._rangeSliderData = i;
                }, r.autoMarginOpts = function(t1, e1) {
                    var r = t1._fullLayout, n = e1[s], l = e1._id.charAt(0), c = 0, u = 0;
                    "bottom" === e1.side && (c = e1._depth, e1.title.text !== r._dfltTitle[l] && (u = 1.5 * e1.title.font.size + 10 + n._offsetShift, u += (e1.title.text.match(i.BR_TAG_ALL) || []).length * e1.title.font.size * o));
                    return {
                        x: 0,
                        y: e1._counterDomainMin,
                        l: 0,
                        r: 0,
                        t: 0,
                        b: n._height + c + Math.max(r.margin.b, u),
                        pad: a.extraPad + 2 * n._offsetShift
                    };
                };
            },
            {
                "../../constants/alignment": 471,
                "../../lib/svg_text_utils": 529,
                "../../plots/cartesian/axis_ids": 558,
                "./constants": 440
            }
        ],
        444: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./attributes"), a = t1("./oppaxis_attributes"), o = t1("./helpers");
                e1.exports = {
                    moduleType: "component",
                    name: "rangeslider",
                    schema: {
                        subplots: {
                            xaxis: {
                                rangeslider: n.extendFlat({}, i, {
                                    yaxis: a
                                })
                            }
                        }
                    },
                    layoutAttributes: t1("./attributes"),
                    handleDefaults: t1("./defaults"),
                    calcAutorange: t1("./calc_autorange"),
                    draw: t1("./draw"),
                    isVisible: o.isVisible,
                    makeData: o.makeData,
                    autoMarginOpts: o.autoMarginOpts
                };
            },
            {
                "../../lib": 503,
                "./attributes": 438,
                "./calc_autorange": 439,
                "./defaults": 441,
                "./draw": 442,
                "./helpers": 443,
                "./oppaxis_attributes": 445
            }
        ],
        445: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    _isSubplotObj: !0,
                    rangemode: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "fixed",
                            "match"
                        ],
                        dflt: "match",
                        editType: "calc"
                    },
                    range: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "plot"
                            },
                            {
                                valType: "any",
                                editType: "plot"
                            }
                        ],
                        editType: "plot"
                    },
                    editType: "calc"
                };
            },
            {}
        ],
        446: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../annotations/attributes"), i = t1("../../traces/scatter/attributes").line, a = t1("../drawing/attributes").dash, o = t1("../../lib/extend").extendFlat, s = t1("../../plot_api/plot_template").templatedArray;
                t1("../../constants/axis_placeable_objects");
                e1.exports = s("shape", {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc+arraydraw"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "circle",
                            "rect",
                            "path",
                            "line"
                        ],
                        editType: "calc+arraydraw"
                    },
                    layer: {
                        valType: "enumerated",
                        values: [
                            "below",
                            "above"
                        ],
                        dflt: "above",
                        editType: "arraydraw"
                    },
                    xref: o({}, n.xref, {}),
                    xsizemode: {
                        valType: "enumerated",
                        values: [
                            "scaled",
                            "pixel"
                        ],
                        dflt: "scaled",
                        editType: "calc+arraydraw"
                    },
                    xanchor: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    x0: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    x1: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    yref: o({}, n.yref, {}),
                    ysizemode: {
                        valType: "enumerated",
                        values: [
                            "scaled",
                            "pixel"
                        ],
                        dflt: "scaled",
                        editType: "calc+arraydraw"
                    },
                    yanchor: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    y0: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    y1: {
                        valType: "any",
                        editType: "calc+arraydraw"
                    },
                    path: {
                        valType: "string",
                        editType: "calc+arraydraw"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "arraydraw"
                    },
                    line: {
                        color: o({}, i.color, {
                            editType: "arraydraw"
                        }),
                        width: o({}, i.width, {
                            editType: "calc+arraydraw"
                        }),
                        dash: o({}, a, {
                            editType: "arraydraw"
                        }),
                        editType: "calc+arraydraw"
                    },
                    fillcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)",
                        editType: "arraydraw"
                    },
                    fillrule: {
                        valType: "enumerated",
                        values: [
                            "evenodd",
                            "nonzero"
                        ],
                        dflt: "evenodd",
                        editType: "arraydraw"
                    },
                    editable: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc+arraydraw"
                    },
                    editType: "arraydraw"
                });
            },
            {
                "../../constants/axis_placeable_objects": 472,
                "../../lib/extend": 493,
                "../../plot_api/plot_template": 543,
                "../../traces/scatter/attributes": 926,
                "../annotations/attributes": 349,
                "../drawing/attributes": 387
            }
        ],
        447: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axes"), a = t1("./constants"), o = t1("./helpers");
                function s(t1) {
                    return c(t1.line.width, t1.xsizemode, t1.x0, t1.x1, t1.path, !1);
                }
                function l(t1) {
                    return c(t1.line.width, t1.ysizemode, t1.y0, t1.y1, t1.path, !0);
                }
                function c(t1, e1, r, i, s, l) {
                    var c = t1 / 2, u = l;
                    if ("pixel" === e1) {
                        var f = s ? o.extractPathCoords(s, l ? a.paramIsY : a.paramIsX) : [
                            r,
                            i
                        ], h = n.aggNums(Math.max, null, f), p = n.aggNums(Math.min, null, f), d = p < 0 ? Math.abs(p) + c : c, m = h > 0 ? h + c : c;
                        return {
                            ppad: c,
                            ppadplus: u ? d : m,
                            ppadminus: u ? m : d
                        };
                    }
                    return {
                        ppad: c
                    };
                }
                function u(t1, e1, r, n, i) {
                    var s = "category" === t1.type || "multicategory" === t1.type ? t1.r2c : t1.d2c;
                    if (void 0 !== e1) return [
                        s(e1),
                        s(r)
                    ];
                    if (n) {
                        var l, c, u, f, h = 1 / 0, p = -1 / 0, d = n.match(a.segmentRE);
                        for("date" === t1.type && (s = o.decodeDate(s)), l = 0; l < d.length; l++)void 0 !== (c = i[d[l].charAt(0)].drawn) && (!(u = d[l].substr(1).match(a.paramRE)) || u.length < c || ((f = s(u[c])) < h && (h = f), f > p && (p = f)));
                        return p >= h ? [
                            h,
                            p
                        ] : void 0;
                    }
                }
                e1.exports = function(t1) {
                    var e1 = t1._fullLayout, r = n.filterVisible(e1.shapes);
                    if (r.length && t1._fullData.length) for(var o = 0; o < r.length; o++){
                        var c, f, h = r[o];
                        h._extremes = {};
                        var p = i.getRefType(h.xref), d = i.getRefType(h.yref);
                        if ("paper" !== h.xref && "domain" !== p) {
                            var m = "pixel" === h.xsizemode ? h.xanchor : h.x0, g = "pixel" === h.xsizemode ? h.xanchor : h.x1;
                            (f = u(c = i.getFromId(t1, h.xref), m, g, h.path, a.paramIsX)) && (h._extremes[c._id] = i.findExtremes(c, f, s(h)));
                        }
                        if ("paper" !== h.yref && "domain" !== d) {
                            var v = "pixel" === h.ysizemode ? h.yanchor : h.y0, y = "pixel" === h.ysizemode ? h.yanchor : h.y1;
                            (f = u(c = i.getFromId(t1, h.yref), v, y, h.path, a.paramIsY)) && (h._extremes[c._id] = i.findExtremes(c, f, l(h)));
                        }
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "./constants": 448,
                "./helpers": 457
            }
        ],
        448: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
                    paramRE: /[^\s,]+/g,
                    paramIsX: {
                        M: {
                            0: !0,
                            drawn: 0
                        },
                        L: {
                            0: !0,
                            drawn: 0
                        },
                        H: {
                            0: !0,
                            drawn: 0
                        },
                        V: {},
                        Q: {
                            0: !0,
                            2: !0,
                            drawn: 2
                        },
                        C: {
                            0: !0,
                            2: !0,
                            4: !0,
                            drawn: 4
                        },
                        T: {
                            0: !0,
                            drawn: 0
                        },
                        S: {
                            0: !0,
                            2: !0,
                            drawn: 2
                        },
                        Z: {}
                    },
                    paramIsY: {
                        M: {
                            1: !0,
                            drawn: 1
                        },
                        L: {
                            1: !0,
                            drawn: 1
                        },
                        H: {},
                        V: {
                            0: !0,
                            drawn: 0
                        },
                        Q: {
                            1: !0,
                            3: !0,
                            drawn: 3
                        },
                        C: {
                            1: !0,
                            3: !0,
                            5: !0,
                            drawn: 5
                        },
                        T: {
                            1: !0,
                            drawn: 1
                        },
                        S: {
                            1: !0,
                            3: !0,
                            drawn: 5
                        },
                        Z: {}
                    },
                    numParams: {
                        M: 2,
                        L: 2,
                        H: 1,
                        V: 1,
                        Q: 4,
                        C: 6,
                        T: 2,
                        S: 4,
                        Z: 0
                    }
                };
            },
            {}
        ],
        449: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axes"), a = t1("../../plots/array_container_defaults"), o = t1("./attributes"), s = t1("./helpers");
                function l(t1, e1, r) {
                    function a(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    if (a("visible")) {
                        var l = a("path"), c = a("type", l ? "path" : "rect");
                        "path" !== e1.type && delete e1.path, a("editable"), a("layer"), a("opacity"), a("fillcolor"), a("fillrule"), a("line.width") && (a("line.color"), a("line.dash"));
                        for(var u = a("xsizemode"), f = a("ysizemode"), h = [
                            "x",
                            "y"
                        ], p = 0; p < 2; p++){
                            var d, m, g, v = h[p], y = v + "anchor", x = "x" === v ? u : f, b = {
                                _fullLayout: r
                            }, _ = i.coerceRef(t1, e1, b, v, void 0, "paper");
                            if ("range" === i.getRefType(_) ? ((d = i.getFromId(b, _))._shapeIndices.push(e1._index), g = s.rangeToShapePosition(d), m = s.shapePositionToRange(d)) : m = g = n.identity, "path" !== c) {
                                var w = v + "0", T = v + "1", k = t1[w], A = t1[T];
                                t1[w] = m(t1[w], !0), t1[T] = m(t1[T], !0), "pixel" === x ? (a(w, 0), a(T, 10)) : (i.coercePosition(e1, b, a, _, w, .25), i.coercePosition(e1, b, a, _, T, .75)), e1[w] = g(e1[w]), e1[T] = g(e1[T]), t1[w] = k, t1[T] = A;
                            }
                            if ("pixel" === x) {
                                var M = t1[y];
                                t1[y] = m(t1[y], !0), i.coercePosition(e1, b, a, _, y, .25), e1[y] = g(e1[y]), t1[y] = M;
                            }
                        }
                        "path" === c ? a("path") : n.noneOrAll(t1, e1, [
                            "x0",
                            "x1",
                            "y0",
                            "y1"
                        ]);
                    }
                }
                e1.exports = function(t1, e1) {
                    a(t1, e1, {
                        name: "shapes",
                        handleItemDefaults: l
                    });
                };
            },
            {
                "../../lib": 503,
                "../../plots/array_container_defaults": 549,
                "../../plots/cartesian/axes": 554,
                "./attributes": 446,
                "./helpers": 457
            }
        ],
        450: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib"), a = t1("../../plots/cartesian/axes"), o = t1("./draw_newshape/helpers").readPaths, s = t1("./draw_newshape/display_outlines"), l = t1("../../plots/cartesian/handle_outline").clearOutlineControllers, c = t1("../color"), u = t1("../drawing"), f = t1("../../plot_api/plot_template").arrayEditor, h = t1("../dragelement"), p = t1("../../lib/setcursor"), d = t1("./constants"), m = t1("./helpers");
                function g(t1) {
                    var e1 = t1._fullLayout;
                    for(var r in e1._shapeUpperLayer.selectAll("path").remove(), e1._shapeLowerLayer.selectAll("path").remove(), e1._plots){
                        var n = e1._plots[r].shapelayer;
                        n && n.selectAll("path").remove();
                    }
                    for(var i = 0; i < e1.shapes.length; i++)e1.shapes[i].visible && x(t1, i);
                }
                function v(t1) {
                    return !!t1._fullLayout._drawing;
                }
                function y(t1) {
                    return !t1._context.edits.shapePosition;
                }
                function x(t1, e1) {
                    t1._fullLayout._paperdiv.selectAll('.shapelayer [data-index="' + e1 + '"]').remove();
                    var r = m.makeOptionsAndPlotinfo(t1, e1), l = r.options, x = r.plotinfo;
                    if (l._input && !1 !== l.visible) {
                        if ("below" !== l.layer) k(t1._fullLayout._shapeUpperLayer);
                        else if ("paper" === l.xref || "paper" === l.yref) k(t1._fullLayout._shapeLowerLayer);
                        else if (x._hadPlotinfo) k((x.mainplotinfo || x).shapelayer);
                        else k(t1._fullLayout._shapeLowerLayer);
                    }
                    function k(r) {
                        var k = _(t1, l), A = {
                            "data-index": e1,
                            "fill-rule": l.fillrule,
                            d: k
                        }, M = l.opacity, S = l.fillcolor, E = l.line.width ? l.line.color : "rgba(0,0,0,0)", L = l.line.width, C = l.line.dash;
                        L || !0 !== l.editable || (L = 5, C = "solid");
                        var P = "Z" !== k[k.length - 1], I = y(t1) && l.editable && t1._fullLayout._activeShapeIndex === e1;
                        I && (S = P ? "rgba(0,0,0,0)" : t1._fullLayout.activeshape.fillcolor, M = t1._fullLayout.activeshape.opacity);
                        var O, z = r.append("path").attr(A).style("opacity", M).call(c.stroke, E).call(c.fill, S).call(u.dashLine, C, L);
                        if (b(z, t1, l), (I || t1._context.edits.shapePosition) && (O = f(t1.layout, "shapes", l)), I) {
                            z.style({
                                cursor: "move"
                            });
                            var D = {
                                element: z.node(),
                                plotinfo: x,
                                gd: t1,
                                editHelpers: O,
                                isActiveShape: !0
                            }, R = o(k, t1);
                            s(R, z, D);
                        } else t1._context.edits.shapePosition ? function(t1, e1, r, o, s, l) {
                            var c, f, g, y, x, T, k, A, M, S, E, L, C, P, I, O, z = "pixel" === r.xsizemode, D = "pixel" === r.ysizemode, R = "line" === r.type, F = "path" === r.type, B = l.modifyItem, N = a.getFromId(t1, r.xref), j = a.getRefType(r.xref), U = a.getFromId(t1, r.yref), V = a.getRefType(r.yref), H = m.getDataToPixel(t1, N, !1, j), q = m.getDataToPixel(t1, U, !0, V), G = m.getPixelToData(t1, N, !1, j), Y = m.getPixelToData(t1, U, !0, V), W = R ? function() {
                                var t1 = Math.max(r.line.width, 10), n = s.append("g").attr("data-index", o);
                                n.append("path").attr("d", e1.attr("d")).style({
                                    cursor: "move",
                                    "stroke-width": t1,
                                    "stroke-opacity": "0"
                                });
                                var i = {
                                    "fill-opacity": "0"
                                }, a = Math.max(t1 / 2, 10);
                                return n.append("circle").attr({
                                    "data-line-point": "start-point",
                                    cx: z ? H(r.xanchor) + r.x0 : H(r.x0),
                                    cy: D ? q(r.yanchor) - r.y0 : q(r.y0),
                                    r: a
                                }).style(i).classed("cursor-grab", !0), n.append("circle").attr({
                                    "data-line-point": "end-point",
                                    cx: z ? H(r.xanchor) + r.x1 : H(r.x1),
                                    cy: D ? q(r.yanchor) - r.y1 : q(r.y1),
                                    r: a
                                }).style(i).classed("cursor-grab", !0), n;
                            }() : e1, X = {
                                element: W.node(),
                                gd: t1,
                                prepFn: function(n) {
                                    if (v(t1)) return;
                                    z && (x = H(r.xanchor));
                                    D && (T = q(r.yanchor));
                                    "path" === r.type ? I = r.path : (c = z ? r.x0 : H(r.x0), f = D ? r.y0 : q(r.y0), g = z ? r.x1 : H(r.x1), y = D ? r.y1 : q(r.y1));
                                    c < g ? (M = c, C = "x0", S = g, P = "x1") : (M = g, C = "x1", S = c, P = "x0");
                                    !D && f < y || D && f > y ? (k = f, E = "y0", A = y, L = "y1") : (k = y, E = "y1", A = f, L = "y0");
                                    Z(n), Q(s, r), function(t1, e1, r) {
                                        var n = e1.xref, i = e1.yref, o = a.getFromId(r, n), s = a.getFromId(r, i), l = "";
                                        "paper" === n || o.autorange || (l += n);
                                        "paper" === i || s.autorange || (l += i);
                                        u.setClipUrl(t1, l ? "clip" + r._fullLayout._uid + l : null, r);
                                    }(e1, r, t1), X.moveFn = "move" === O ? J : K, X.altKey = n.altKey;
                                },
                                doneFn: function() {
                                    if (v(t1)) return;
                                    p(e1), $(s), b(e1, t1, r), n.call("_guiRelayout", t1, l.getUpdateObj());
                                },
                                clickFn: function() {
                                    if (v(t1)) return;
                                    $(s);
                                }
                            };
                            function Z(r) {
                                if (v(t1)) O = null;
                                else if (R) O = "path" === r.target.tagName ? "move" : "start-point" === r.target.attributes["data-line-point"].value ? "resize-over-start-point" : "resize-over-end-point";
                                else {
                                    var n = X.element.getBoundingClientRect(), i = n.right - n.left, a = n.bottom - n.top, o = r.clientX - n.left, s = r.clientY - n.top, l = !F && i > 10 && a > 10 && !r.shiftKey ? h.getCursor(o / i, 1 - s / a) : "move";
                                    p(e1, l), O = l.split("-")[0];
                                }
                            }
                            function J(n, i) {
                                if ("path" === r.type) {
                                    var a = function(t1) {
                                        return t1;
                                    }, o = a, l = a;
                                    z ? B("xanchor", r.xanchor = G(x + n)) : (o = function(t1) {
                                        return G(H(t1) + n);
                                    }, N && "date" === N.type && (o = m.encodeDate(o))), D ? B("yanchor", r.yanchor = Y(T + i)) : (l = function(t1) {
                                        return Y(q(t1) + i);
                                    }, U && "date" === U.type && (l = m.encodeDate(l))), B("path", r.path = w(I, o, l));
                                } else z ? B("xanchor", r.xanchor = G(x + n)) : (B("x0", r.x0 = G(c + n)), B("x1", r.x1 = G(g + n))), D ? B("yanchor", r.yanchor = Y(T + i)) : (B("y0", r.y0 = Y(f + i)), B("y1", r.y1 = Y(y + i)));
                                e1.attr("d", _(t1, r)), Q(s, r);
                            }
                            function K(n, i) {
                                if (F) {
                                    var a = function(t1) {
                                        return t1;
                                    }, o = a, l = a;
                                    z ? B("xanchor", r.xanchor = G(x + n)) : (o = function(t1) {
                                        return G(H(t1) + n);
                                    }, N && "date" === N.type && (o = m.encodeDate(o))), D ? B("yanchor", r.yanchor = Y(T + i)) : (l = function(t1) {
                                        return Y(q(t1) + i);
                                    }, U && "date" === U.type && (l = m.encodeDate(l))), B("path", r.path = w(I, o, l));
                                } else if (R) {
                                    if ("resize-over-start-point" === O) {
                                        var u = c + n, h = D ? f - i : f + i;
                                        B("x0", r.x0 = z ? u : G(u)), B("y0", r.y0 = D ? h : Y(h));
                                    } else if ("resize-over-end-point" === O) {
                                        var p = g + n, d = D ? y - i : y + i;
                                        B("x1", r.x1 = z ? p : G(p)), B("y1", r.y1 = D ? d : Y(d));
                                    }
                                } else {
                                    var v = function(t1) {
                                        return -1 !== O.indexOf(t1);
                                    }, b = v("n"), j = v("s"), V = v("w"), W = v("e"), X = b ? k + i : k, Z = j ? A + i : A, J = V ? M + n : M, K = W ? S + n : S;
                                    D && (b && (X = k - i), j && (Z = A - i)), (!D && Z - X > 10 || D && X - Z > 10) && (B(E, r[E] = D ? X : Y(X)), B(L, r[L] = D ? Z : Y(Z))), K - J > 10 && (B(C, r[C] = z ? J : G(J)), B(P, r[P] = z ? K : G(K)));
                                }
                                e1.attr("d", _(t1, r)), Q(s, r);
                            }
                            function Q(t1, e1) {
                                (z || D) && function() {
                                    var r = "path" !== e1.type, n = t1.selectAll(".visual-cue").data([
                                        0
                                    ]);
                                    n.enter().append("path").attr({
                                        fill: "#fff",
                                        "fill-rule": "evenodd",
                                        stroke: "#000",
                                        "stroke-width": 1
                                    }).classed("visual-cue", !0);
                                    var a = H(z ? e1.xanchor : i.midRange(r ? [
                                        e1.x0,
                                        e1.x1
                                    ] : m.extractPathCoords(e1.path, d.paramIsX))), o = q(D ? e1.yanchor : i.midRange(r ? [
                                        e1.y0,
                                        e1.y1
                                    ] : m.extractPathCoords(e1.path, d.paramIsY)));
                                    if (a = m.roundPositionForSharpStrokeRendering(a, 1), o = m.roundPositionForSharpStrokeRendering(o, 1), z && D) {
                                        var s = "M" + (a - 1 - 1) + "," + (o - 1 - 1) + "h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z";
                                        n.attr("d", s);
                                    } else if (z) {
                                        var l = "M" + (a - 1 - 1) + "," + (o - 9 - 1) + "v18 h2 v-18 Z";
                                        n.attr("d", l);
                                    } else {
                                        var c = "M" + (a - 9 - 1) + "," + (o - 1 - 1) + "h18 v2 h-18 Z";
                                        n.attr("d", c);
                                    }
                                }();
                            }
                            function $(t1) {
                                t1.selectAll(".visual-cue").remove();
                            }
                            h.init(X), W.node().onmousemove = Z;
                        }(t1, z, l, e1, r, O) : !0 === l.editable && z.style("pointer-events", P || c.opacity(S) * M <= .5 ? "stroke" : "all");
                        z.node().addEventListener("click", function() {
                            return function(t1, e1) {
                                if (!y(t1)) return;
                                var r = +e1.node().getAttribute("data-index");
                                if (r >= 0) {
                                    if (r === t1._fullLayout._activeShapeIndex) return void T(t1);
                                    t1._fullLayout._activeShapeIndex = r, t1._fullLayout._deactivateShape = T, g(t1);
                                }
                            }(t1, z);
                        });
                    }
                }
                function b(t1, e1, r) {
                    var n = (r.xref + r.yref).replace(/paper/g, "").replace(/[xyz][1-9]* *domain/g, "");
                    u.setClipUrl(t1, n ? "clip" + e1._fullLayout._uid + n : null, e1);
                }
                function _(t1, e1) {
                    var r, n, o, s, l, c, u, f, h = e1.type, p = a.getRefType(e1.xref), g = a.getRefType(e1.yref), v = a.getFromId(t1, e1.xref), y = a.getFromId(t1, e1.yref), x = t1._fullLayout._size;
                    if (v ? "domain" === p ? n = function(t1) {
                        return v._offset + v._length * t1;
                    } : (r = m.shapePositionToRange(v), n = function(t1) {
                        return v._offset + v.r2p(r(t1, !0));
                    }) : n = function(t1) {
                        return x.l + x.w * t1;
                    }, y ? "domain" === g ? s = function(t1) {
                        return y._offset + y._length * (1 - t1);
                    } : (o = m.shapePositionToRange(y), s = function(t1) {
                        return y._offset + y.r2p(o(t1, !0));
                    }) : s = function(t1) {
                        return x.t + x.h * (1 - t1);
                    }, "path" === h) return v && "date" === v.type && (n = m.decodeDate(n)), y && "date" === y.type && (s = m.decodeDate(s)), function(t1, e1, r) {
                        var n = t1.path, a = t1.xsizemode, o = t1.ysizemode, s = t1.xanchor, l = t1.yanchor;
                        return n.replace(d.segmentRE, function(t1) {
                            var n = 0, c = t1.charAt(0), u = d.paramIsX[c], f = d.paramIsY[c], h = d.numParams[c], p = t1.substr(1).replace(d.paramRE, function(t1) {
                                return u[n] ? t1 = "pixel" === a ? e1(s) + Number(t1) : e1(t1) : f[n] && (t1 = "pixel" === o ? r(l) - Number(t1) : r(t1)), ++n > h && (t1 = "X"), t1;
                            });
                            return n > h && (p = p.replace(/[\s,]*X.*/, ""), i.log("Ignoring extra params in segment " + t1)), c + p;
                        });
                    }(e1, n, s);
                    if ("pixel" === e1.xsizemode) {
                        var b = n(e1.xanchor);
                        l = b + e1.x0, c = b + e1.x1;
                    } else l = n(e1.x0), c = n(e1.x1);
                    if ("pixel" === e1.ysizemode) {
                        var _ = s(e1.yanchor);
                        u = _ - e1.y0, f = _ - e1.y1;
                    } else u = s(e1.y0), f = s(e1.y1);
                    if ("line" === h) return "M" + l + "," + u + "L" + c + "," + f;
                    if ("rect" === h) return "M" + l + "," + u + "H" + c + "V" + f + "H" + l + "Z";
                    var w = (l + c) / 2, T = (u + f) / 2, k = Math.abs(w - l), A = Math.abs(T - u), M = "A" + k + "," + A, S = w + k + "," + T;
                    return "M" + S + M + " 0 1,1 " + (w + "," + (T - A)) + M + " 0 0,1 " + S + "Z";
                }
                function w(t1, e1, r) {
                    return t1.replace(d.segmentRE, function(t1) {
                        var n = 0, i = t1.charAt(0), a = d.paramIsX[i], o = d.paramIsY[i], s = d.numParams[i];
                        return i + t1.substr(1).replace(d.paramRE, function(t1) {
                            return n >= s || (a[n] ? t1 = e1(t1) : o[n] && (t1 = r(t1)), n++), t1;
                        });
                    });
                }
                function T(t1) {
                    y(t1) && t1._fullLayout._activeShapeIndex >= 0 && (l(t1), delete t1._fullLayout._activeShapeIndex, g(t1));
                }
                e1.exports = {
                    draw: g,
                    drawOne: x,
                    eraseActiveShape: function(t1) {
                        if (!y(t1)) return;
                        l(t1);
                        var e1 = t1._fullLayout._activeShapeIndex, r = (t1.layout || {}).shapes || [];
                        if (e1 < r.length) {
                            for(var i = [], a = 0; a < r.length; a++)a !== e1 && i.push(r[a]);
                            delete t1._fullLayout._activeShapeIndex, n.call("_guiRelayout", t1, {
                                shapes: i
                            });
                        }
                    }
                };
            },
            {
                "../../lib": 503,
                "../../lib/setcursor": 524,
                "../../plot_api/plot_template": 543,
                "../../plots/cartesian/axes": 554,
                "../../plots/cartesian/handle_outline": 565,
                "../../registry": 638,
                "../color": 366,
                "../dragelement": 385,
                "../drawing": 388,
                "./constants": 448,
                "./draw_newshape/display_outlines": 454,
                "./draw_newshape/helpers": 455,
                "./helpers": 457
            }
        ],
        451: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../drawing/attributes").dash, i = t1("../../../lib/extend").extendFlat;
                e1.exports = {
                    newshape: {
                        line: {
                            color: {
                                valType: "color",
                                editType: "none"
                            },
                            width: {
                                valType: "number",
                                min: 0,
                                dflt: 4,
                                editType: "none"
                            },
                            dash: i({}, n, {
                                dflt: "solid",
                                editType: "none"
                            }),
                            editType: "none"
                        },
                        fillcolor: {
                            valType: "color",
                            dflt: "rgba(0,0,0,0)",
                            editType: "none"
                        },
                        fillrule: {
                            valType: "enumerated",
                            values: [
                                "evenodd",
                                "nonzero"
                            ],
                            dflt: "evenodd",
                            editType: "none"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1,
                            editType: "none"
                        },
                        layer: {
                            valType: "enumerated",
                            values: [
                                "below",
                                "above"
                            ],
                            dflt: "above",
                            editType: "none"
                        },
                        drawdirection: {
                            valType: "enumerated",
                            values: [
                                "ortho",
                                "horizontal",
                                "vertical",
                                "diagonal"
                            ],
                            dflt: "diagonal",
                            editType: "none"
                        },
                        editType: "none"
                    },
                    activeshape: {
                        fillcolor: {
                            valType: "color",
                            dflt: "rgb(255,0,255)",
                            editType: "none"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .5,
                            editType: "none"
                        },
                        editType: "none"
                    }
                };
            },
            {
                "../../../lib/extend": 493,
                "../../drawing/attributes": 387
            }
        ],
        452: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    CIRCLE_SIDES: 32,
                    i000: 0,
                    i090: 8,
                    i180: 16,
                    i270: 24,
                    cos45: Math.cos(Math.PI / 4),
                    sin45: Math.sin(Math.PI / 4),
                    SQRT2: Math.sqrt(2)
                };
            },
            {}
        ],
        453: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../color");
                e1.exports = function(t1, e1, r) {
                    if (r("newshape.drawdirection"), r("newshape.layer"), r("newshape.fillcolor"), r("newshape.fillrule"), r("newshape.opacity"), r("newshape.line.width")) {
                        var i = (t1 || {}).plot_bgcolor || "#FFF";
                        r("newshape.line.color", n.contrast(i)), r("newshape.line.dash");
                    }
                    r("activeshape.fillcolor"), r("activeshape.opacity");
                };
            },
            {
                "../../color": 366
            }
        ],
        454: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../dragelement"), i = t1("../../dragelement/helpers").drawMode, a = t1("../../../registry"), o = t1("./constants"), s = o.i000, l = o.i090, c = o.i180, u = o.i270, f = t1("../../../plots/cartesian/handle_outline").clearOutlineControllers, h = t1("./helpers"), p = h.pointsShapeRectangle, d = h.pointsShapeEllipse, m = h.writePaths, g = t1("./newshapes");
                e1.exports = function t1(e1, r, o, h) {
                    h || (h = 0);
                    var v = o.gd;
                    function y() {
                        t1(e1, r, o, h++), d(e1[0]) && x({
                            redrawing: !0
                        });
                    }
                    function x(t1) {
                        o.isActiveShape = !1;
                        var e1 = g(r, o);
                        Object.keys(e1).length && a.call((t1 || {}).redrawing ? "relayout" : "_guiRelayout", v, e1);
                    }
                    var b, _, w, T, k, A = o.isActiveShape, M = v._fullLayout._zoomlayer, S = o.dragmode;
                    (i(S) ? v._fullLayout._drawing = !0 : v._fullLayout._activeShapeIndex >= 0 && f(v), r.attr("d", m(e1)), A && !h) && (k = function(t1, e1) {
                        for(var r = 0; r < e1.length; r++){
                            var n = e1[r];
                            t1[r] = [];
                            for(var i = 0; i < n.length; i++){
                                t1[r][i] = [];
                                for(var a = 0; a < n[i].length; a++)t1[r][i][a] = n[i][a];
                            }
                        }
                        return t1;
                    }([], e1), function(t1) {
                        b = [];
                        for(var r = 0; r < e1.length; r++){
                            var i = e1[r], a = !p(i) && d(i);
                            b[r] = [];
                            for(var o = 0; o < i.length; o++)if ("Z" !== i[o][0] && (!a || o === s || o === l || o === c || o === u)) {
                                var f = i[o][1], h = i[o][2], m = t1.append("circle").classed("cursor-grab", !0).attr("data-i", r).attr("data-j", o).attr("cx", f).attr("cy", h).attr("r", 4).style({
                                    "mix-blend-mode": "luminosity",
                                    fill: "black",
                                    stroke: "white",
                                    "stroke-width": 1
                                });
                                b[r][o] = {
                                    element: m.node(),
                                    gd: v,
                                    prepFn: E,
                                    doneFn: C,
                                    clickFn: P
                                }, n.init(b[r][o]);
                            }
                        }
                    }(M.append("g").attr("class", "outline-controllers")), function() {
                        if (_ = [], !e1.length) return;
                        _[0] = {
                            element: r[0][0],
                            gd: v,
                            prepFn: O,
                            doneFn: z
                        }, n.init(_[0]);
                    }());
                    function E(t1) {
                        w = +t1.srcElement.getAttribute("data-i"), T = +t1.srcElement.getAttribute("data-j"), b[w][T].moveFn = L;
                    }
                    function L(t1, r) {
                        if (e1.length) {
                            var n = k[w][T][1], i = k[w][T][2], a = e1[w], o = a.length;
                            if (p(a)) {
                                for(var s = 0; s < o; s++)if (s !== T) {
                                    var l = a[s];
                                    l[1] === a[T][1] && (l[1] = n + t1), l[2] === a[T][2] && (l[2] = i + r);
                                }
                                if (a[T][1] = n + t1, a[T][2] = i + r, !p(a)) for(var c = 0; c < o; c++)for(var u = 0; u < a[c].length; u++)a[c][u] = k[w][c][u];
                            } else a[T][1] = n + t1, a[T][2] = i + r;
                            y();
                        }
                    }
                    function C() {
                        x();
                    }
                    function P(t1, r) {
                        if (2 === t1) {
                            w = +r.srcElement.getAttribute("data-i"), T = +r.srcElement.getAttribute("data-j");
                            var n = e1[w];
                            p(n) || d(n) || function() {
                                if (e1.length && e1[w] && e1[w].length) {
                                    for(var t1 = [], r = 0; r < e1[w].length; r++)r !== T && t1.push(e1[w][r]);
                                    t1.length > 1 && (2 !== t1.length || "Z" !== t1[1][0]) && (0 === T && (t1[0][0] = "M"), e1[w] = t1, y(), x());
                                }
                            }();
                        }
                    }
                    function I(t1, r) {
                        !function(t1, r) {
                            if (e1.length) for(var n = 0; n < e1.length; n++)for(var i = 0; i < e1[n].length; i++)for(var a = 0; a + 2 < e1[n][i].length; a += 2)e1[n][i][a + 1] = k[n][i][a + 1] + t1, e1[n][i][a + 2] = k[n][i][a + 2] + r;
                        }(t1, r), y();
                    }
                    function O(t1) {
                        (w = +t1.srcElement.getAttribute("data-i")) || (w = 0), _[w].moveFn = I;
                    }
                    function z() {
                        x();
                    }
                };
            },
            {
                "../../../plots/cartesian/handle_outline": 565,
                "../../../registry": 638,
                "../../dragelement": 385,
                "../../dragelement/helpers": 384,
                "./constants": 452,
                "./helpers": 455,
                "./newshapes": 456
            }
        ],
        455: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("parse-svg-path"), i = t1("./constants"), a = i.CIRCLE_SIDES, o = i.SQRT2, s = t1("../../../plots/cartesian/helpers"), l = s.p2r, c = s.r2p, u = [
                    0,
                    3,
                    4,
                    5,
                    6,
                    1,
                    2
                ], f = [
                    0,
                    3,
                    4,
                    1,
                    2
                ];
                function h(t1, e1) {
                    return Math.abs(t1 - e1) <= 1e-6;
                }
                function p(t1, e1) {
                    var r = e1[1] - t1[1], n = e1[2] - t1[2];
                    return Math.sqrt(r * r + n * n);
                }
                r.writePaths = function(t1) {
                    var e1 = t1.length;
                    if (!e1) return "M0,0Z";
                    for(var r = "", n = 0; n < e1; n++)for(var i = t1[n].length, a = 0; a < i; a++){
                        var o = t1[n][a][0];
                        if ("Z" === o) r += "Z";
                        else for(var s = t1[n][a].length, l = 0; l < s; l++){
                            var c = l;
                            "Q" === o || "S" === o ? c = f[l] : "C" === o && (c = u[l]), r += t1[n][a][c], l > 0 && l < s - 1 && (r += ",");
                        }
                    }
                    return r;
                }, r.readPaths = function(t1, e1, r, i) {
                    var o, s, u, f = n(t1), h = [], p = -1, d = 0, m = 0, g = function() {
                        s = d, u = m;
                    };
                    g();
                    for(var v = 0; v < f.length; v++){
                        var y, x, b, _, w = [], T = f[v][0], k = T;
                        switch(T){
                            case "M":
                                p++, h[p] = [], d = +f[v][1], m = +f[v][2], w.push([
                                    k,
                                    d,
                                    m
                                ]), g();
                                break;
                            case "Q":
                            case "S":
                                y = +f[v][1], b = +f[v][2], d = +f[v][3], m = +f[v][4], w.push([
                                    k,
                                    d,
                                    m,
                                    y,
                                    b
                                ]);
                                break;
                            case "C":
                                y = +f[v][1], b = +f[v][2], x = +f[v][3], _ = +f[v][4], d = +f[v][5], m = +f[v][6], w.push([
                                    k,
                                    d,
                                    m,
                                    y,
                                    b,
                                    x,
                                    _
                                ]);
                                break;
                            case "T":
                            case "L":
                                d = +f[v][1], m = +f[v][2], w.push([
                                    k,
                                    d,
                                    m
                                ]);
                                break;
                            case "H":
                                k = "L", d = +f[v][1], w.push([
                                    k,
                                    d,
                                    m
                                ]);
                                break;
                            case "V":
                                k = "L", m = +f[v][1], w.push([
                                    k,
                                    d,
                                    m
                                ]);
                                break;
                            case "A":
                                k = "L";
                                var A = +f[v][1], M = +f[v][2];
                                +f[v][4] || (A = -A, M = -M);
                                var S = d - A, E = m;
                                for(o = 1; o <= a / 2; o++){
                                    var L = 2 * Math.PI * o / a;
                                    w.push([
                                        k,
                                        S + A * Math.cos(L),
                                        E + M * Math.sin(L)
                                    ]);
                                }
                                break;
                            case "Z":
                                d === s && m === u || (d = s, m = u, w.push([
                                    k,
                                    d,
                                    m
                                ]));
                        }
                        for(var C = (r || {}).domain, P = e1._fullLayout._size, I = r && "pixel" === r.xsizemode, O = r && "pixel" === r.ysizemode, z = !1 === i, D = 0; D < w.length; D++){
                            for(o = 0; o + 2 < 7; o += 2){
                                var R = w[D][o + 1], F = w[D][o + 2];
                                void 0 !== R && void 0 !== F && (d = R, m = F, r && (r.xaxis && r.xaxis.p2r ? (z && (R -= r.xaxis._offset), R = I ? c(r.xaxis, r.xanchor) + R : l(r.xaxis, R)) : (z && (R -= P.l), C ? R = C.x[0] + R / P.w : R /= P.w), r.yaxis && r.yaxis.p2r ? (z && (F -= r.yaxis._offset), F = O ? c(r.yaxis, r.yanchor) - F : l(r.yaxis, F)) : (z && (F -= P.t), F = C ? C.y[1] - F / P.h : 1 - F / P.h)), w[D][o + 1] = R, w[D][o + 2] = F);
                            }
                            h[p].push(w[D].slice());
                        }
                    }
                    return h;
                }, r.pointsShapeRectangle = function(t1) {
                    if (5 !== t1.length) return !1;
                    for(var e1 = 1; e1 < 3; e1++){
                        if (!h(t1[0][e1] - t1[1][e1], t1[3][e1] - t1[2][e1])) return !1;
                        if (!h(t1[0][e1] - t1[3][e1], t1[1][e1] - t1[2][e1])) return !1;
                    }
                    return !(!h(t1[0][1], t1[1][1]) && !h(t1[0][1], t1[3][1])) && !!(p(t1[0], t1[1]) * p(t1[0], t1[3]));
                }, r.pointsShapeEllipse = function(t1) {
                    var e1 = t1.length;
                    if (e1 !== a + 1) return !1;
                    e1 = a;
                    for(var r = 0; r < e1; r++){
                        var n = (2 * e1 - r) % e1, i = (e1 / 2 + n) % e1, o = (e1 / 2 + r) % e1;
                        if (!h(p(t1[r], t1[o]), p(t1[n], t1[i]))) return !1;
                    }
                    return !0;
                }, r.handleEllipse = function(t1, e1, n) {
                    if (!t1) return [
                        e1,
                        n
                    ];
                    var i = r.ellipseOver({
                        x0: e1[0],
                        y0: e1[1],
                        x1: n[0],
                        y1: n[1]
                    }), s = (i.x1 + i.x0) / 2, l = (i.y1 + i.y0) / 2, c = (i.x1 - i.x0) / 2, u = (i.y1 - i.y0) / 2;
                    c || (c = u /= o), u || (u = c /= o);
                    for(var f = [], h = 0; h < a; h++){
                        var p = 2 * h * Math.PI / a;
                        f.push([
                            s + c * Math.cos(p),
                            l + u * Math.sin(p)
                        ]);
                    }
                    return f;
                }, r.ellipseOver = function(t1) {
                    var e1 = t1.x0, r = t1.y0, n = t1.x1, i = t1.y1, a = n - e1, s = i - r, l = ((e1 -= a) + n) / 2, c = ((r -= s) + i) / 2;
                    return {
                        x0: l - (a *= o),
                        y0: c - (s *= o),
                        x1: l + a,
                        y1: c + s
                    };
                };
            },
            {
                "../../../plots/cartesian/helpers": 566,
                "./constants": 452,
                "parse-svg-path": 250
            }
        ],
        456: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../dragelement/helpers"), i = n.drawMode, a = n.openMode, o = t1("./constants"), s = o.i000, l = o.i090, c = o.i180, u = o.i270, f = o.cos45, h = o.sin45, p = t1("../../../plots/cartesian/helpers"), d = p.p2r, m = p.r2p, g = t1("../../../plots/cartesian/handle_outline").clearSelect, v = t1("./helpers"), y = v.readPaths, x = v.writePaths, b = v.ellipseOver;
                e1.exports = function(t1, e1) {
                    if (t1.length) {
                        var r = t1[0][0];
                        if (r) {
                            var n = r.getAttribute("d"), o = e1.gd, p = o._fullLayout.newshape, v = e1.plotinfo, _ = v.xaxis, w = v.yaxis, T = !!v.domain || !v.xaxis, k = !!v.domain || !v.yaxis, A = e1.isActiveShape, M = e1.dragmode, S = (o.layout || {}).shapes || [];
                            if (!i(M) && void 0 !== A) {
                                var E = o._fullLayout._activeShapeIndex;
                                if (E < S.length) switch(o._fullLayout.shapes[E].type){
                                    case "rect":
                                        M = "drawrect";
                                        break;
                                    case "circle":
                                        M = "drawcircle";
                                        break;
                                    case "line":
                                        M = "drawline";
                                        break;
                                    case "path":
                                        var L = S[E].path || "";
                                        M = "Z" === L[L.length - 1] ? "drawclosedpath" : "drawopenpath";
                                }
                            }
                            var C, P = a(M), I = y(n, o, v, A), O = {
                                editable: !0,
                                xref: T ? "paper" : _._id,
                                yref: k ? "paper" : w._id,
                                layer: p.layer,
                                opacity: p.opacity,
                                line: {
                                    color: p.line.color,
                                    width: p.line.width,
                                    dash: p.line.dash
                                }
                            };
                            if (P || (O.fillcolor = p.fillcolor, O.fillrule = p.fillrule), 1 === I.length && (C = I[0]), C && "drawrect" === M) O.type = "rect", O.x0 = C[0][1], O.y0 = C[0][2], O.x1 = C[2][1], O.y1 = C[2][2];
                            else if (C && "drawline" === M) O.type = "line", O.x0 = C[0][1], O.y0 = C[0][2], O.x1 = C[1][1], O.y1 = C[1][2];
                            else if (C && "drawcircle" === M) {
                                O.type = "circle";
                                var z = C[s][1], D = C[l][1], R = C[c][1], F = C[u][1], B = C[s][2], N = C[l][2], j = C[c][2], U = C[u][2], V = v.xaxis && ("date" === v.xaxis.type || "log" === v.xaxis.type), H = v.yaxis && ("date" === v.yaxis.type || "log" === v.yaxis.type);
                                V && (z = m(v.xaxis, z), D = m(v.xaxis, D), R = m(v.xaxis, R), F = m(v.xaxis, F)), H && (B = m(v.yaxis, B), N = m(v.yaxis, N), j = m(v.yaxis, j), U = m(v.yaxis, U));
                                var q = (D + F) / 2, G = (B + j) / 2, Y = b({
                                    x0: q,
                                    y0: G,
                                    x1: q + (F - D + R - z) / 2 * f,
                                    y1: G + (U - N + j - B) / 2 * h
                                });
                                V && (Y.x0 = d(v.xaxis, Y.x0), Y.x1 = d(v.xaxis, Y.x1)), H && (Y.y0 = d(v.yaxis, Y.y0), Y.y1 = d(v.yaxis, Y.y1)), O.x0 = Y.x0, O.y0 = Y.y0, O.x1 = Y.x1, O.y1 = Y.y1;
                            } else O.type = "path", _ && w && function(t1, e1, r) {
                                var n = "date" === e1.type, i = "date" === r.type;
                                if (!n && !i) return t1;
                                for(var a = 0; a < t1.length; a++)for(var o = 0; o < t1[a].length; o++)for(var s = 0; s + 2 < t1[a][o].length; s += 2)n && (t1[a][o][s + 1] = t1[a][o][s + 1].replace(" ", "_")), i && (t1[a][o][s + 2] = t1[a][o][s + 2].replace(" ", "_"));
                            }(I, _, w), O.path = x(I), C = null;
                            g(o);
                            for(var W = e1.editHelpers, X = (W || {}).modifyItem, Z = [], J = 0; J < S.length; J++){
                                var K = o._fullLayout.shapes[J];
                                if (Z[J] = K._input, void 0 !== A && J === o._fullLayout._activeShapeIndex) {
                                    var Q = O;
                                    switch(K.type){
                                        case "line":
                                        case "rect":
                                        case "circle":
                                            X("x0", Q.x0), X("x1", Q.x1), X("y0", Q.y0), X("y1", Q.y1);
                                            break;
                                        case "path":
                                            X("path", Q.path);
                                    }
                                }
                            }
                            return void 0 === A ? (Z.push(O), Z) : W ? W.getUpdateObj() : {};
                        }
                    }
                };
            },
            {
                "../../../plots/cartesian/handle_outline": 565,
                "../../../plots/cartesian/helpers": 566,
                "../../dragelement/helpers": 384,
                "./constants": 452,
                "./helpers": 455
            }
        ],
        457: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./constants"), i = t1("../../lib");
                r.rangeToShapePosition = function(t1) {
                    return "log" === t1.type ? t1.r2d : function(t1) {
                        return t1;
                    };
                }, r.shapePositionToRange = function(t1) {
                    return "log" === t1.type ? t1.d2r : function(t1) {
                        return t1;
                    };
                }, r.decodeDate = function(t1) {
                    return function(e1) {
                        return e1.replace && (e1 = e1.replace("_", " ")), t1(e1);
                    };
                }, r.encodeDate = function(t1) {
                    return function(e1) {
                        return t1(e1).replace(" ", "_");
                    };
                }, r.extractPathCoords = function(t1, e1) {
                    var r = [];
                    return t1.match(n.segmentRE).forEach(function(t1) {
                        var a = e1[t1.charAt(0)].drawn;
                        if (void 0 !== a) {
                            var o = t1.substr(1).match(n.paramRE);
                            !o || o.length < a || r.push(i.cleanNumber(o[a]));
                        }
                    }), r;
                }, r.getDataToPixel = function(t1, e1, n, i) {
                    var a, o = t1._fullLayout._size;
                    if (e1) {
                        if ("domain" === i) a = function(t1) {
                            return e1._length * (n ? 1 - t1 : t1) + e1._offset;
                        };
                        else {
                            var s = r.shapePositionToRange(e1);
                            a = function(t1) {
                                return e1._offset + e1.r2p(s(t1, !0));
                            }, "date" === e1.type && (a = r.decodeDate(a));
                        }
                    } else a = n ? function(t1) {
                        return o.t + o.h * (1 - t1);
                    } : function(t1) {
                        return o.l + o.w * t1;
                    };
                    return a;
                }, r.getPixelToData = function(t1, e1, n, i) {
                    var a, o = t1._fullLayout._size;
                    if (e1) {
                        if ("domain" === i) a = function(t1) {
                            var r = (t1 - e1._offset) / e1._length;
                            return n ? 1 - r : r;
                        };
                        else {
                            var s = r.rangeToShapePosition(e1);
                            a = function(t1) {
                                return s(e1.p2r(t1 - e1._offset));
                            };
                        }
                    } else a = n ? function(t1) {
                        return 1 - (t1 - o.t) / o.h;
                    } : function(t1) {
                        return (t1 - o.l) / o.w;
                    };
                    return a;
                }, r.roundPositionForSharpStrokeRendering = function(t1, e1) {
                    var r = 1 === Math.round(e1 % 2), n = Math.round(t1);
                    return r ? n + .5 : n;
                }, r.makeOptionsAndPlotinfo = function(t1, e1) {
                    var r = t1._fullLayout.shapes[e1] || {}, n = t1._fullLayout._plots[r.xref + r.yref];
                    return !!n ? n._hadPlotinfo = !0 : (n = {}, r.xref && "paper" !== r.xref && (n.xaxis = t1._fullLayout[r.xref + "axis"]), r.yref && "paper" !== r.yref && (n.yaxis = t1._fullLayout[r.yref + "axis"])), n.xsizemode = r.xsizemode, n.ysizemode = r.ysizemode, n.xanchor = r.xanchor, n.yanchor = r.yanchor, {
                        options: r,
                        plotinfo: n
                    };
                };
            },
            {
                "../../lib": 503,
                "./constants": 448
            }
        ],
        458: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./draw");
                e1.exports = {
                    moduleType: "component",
                    name: "shapes",
                    layoutAttributes: t1("./attributes"),
                    supplyLayoutDefaults: t1("./defaults"),
                    supplyDrawNewShapeDefaults: t1("./draw_newshape/defaults"),
                    includeBasePlot: t1("../../plots/cartesian/include_components")("shapes"),
                    calcAutorange: t1("./calc_autorange"),
                    draw: n.draw,
                    drawOne: n.drawOne
                };
            },
            {
                "../../plots/cartesian/include_components": 567,
                "./attributes": 446,
                "./calc_autorange": 447,
                "./defaults": 449,
                "./draw": 450,
                "./draw_newshape/defaults": 453
            }
        ],
        459: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/font_attributes"), i = t1("../../plots/pad_attributes"), a = t1("../../lib/extend").extendDeepAll, o = t1("../../plot_api/edit_types").overrideAll, s = t1("../../plots/animation_attributes"), l = t1("../../plot_api/plot_template").templatedArray, c = t1("./constants"), u = l("step", {
                    visible: {
                        valType: "boolean",
                        dflt: !0
                    },
                    method: {
                        valType: "enumerated",
                        values: [
                            "restyle",
                            "relayout",
                            "animate",
                            "update",
                            "skip"
                        ],
                        dflt: "restyle"
                    },
                    args: {
                        valType: "info_array",
                        freeLength: !0,
                        items: [
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            }
                        ]
                    },
                    label: {
                        valType: "string"
                    },
                    value: {
                        valType: "string"
                    },
                    execute: {
                        valType: "boolean",
                        dflt: !0
                    }
                });
                e1.exports = o(l("slider", {
                    visible: {
                        valType: "boolean",
                        dflt: !0
                    },
                    active: {
                        valType: "number",
                        min: 0,
                        dflt: 0
                    },
                    steps: u,
                    lenmode: {
                        valType: "enumerated",
                        values: [
                            "fraction",
                            "pixels"
                        ],
                        dflt: "fraction"
                    },
                    len: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    x: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        dflt: 0
                    },
                    pad: a(i({
                        editType: "arraydraw"
                    }), {}, {
                        t: {
                            dflt: 20
                        }
                    }),
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left"
                    },
                    y: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        dflt: 0
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "top"
                    },
                    transition: {
                        duration: {
                            valType: "number",
                            min: 0,
                            dflt: 150
                        },
                        easing: {
                            valType: "enumerated",
                            values: s.transition.easing.values,
                            dflt: "cubic-in-out"
                        }
                    },
                    currentvalue: {
                        visible: {
                            valType: "boolean",
                            dflt: !0
                        },
                        xanchor: {
                            valType: "enumerated",
                            values: [
                                "left",
                                "center",
                                "right"
                            ],
                            dflt: "left"
                        },
                        offset: {
                            valType: "number",
                            dflt: 10
                        },
                        prefix: {
                            valType: "string"
                        },
                        suffix: {
                            valType: "string"
                        },
                        font: n({})
                    },
                    font: n({}),
                    activebgcolor: {
                        valType: "color",
                        dflt: c.gripBgActiveColor
                    },
                    bgcolor: {
                        valType: "color",
                        dflt: c.railBgColor
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: c.railBorderColor
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: c.railBorderWidth
                    },
                    ticklen: {
                        valType: "number",
                        min: 0,
                        dflt: c.tickLength
                    },
                    tickcolor: {
                        valType: "color",
                        dflt: c.tickColor
                    },
                    tickwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    minorticklen: {
                        valType: "number",
                        min: 0,
                        dflt: c.minorTickLength
                    }
                }), "arraydraw", "from-root");
            },
            {
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../../plot_api/plot_template": 543,
                "../../plots/animation_attributes": 548,
                "../../plots/font_attributes": 585,
                "../../plots/pad_attributes": 618,
                "./constants": 460
            }
        ],
        460: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    name: "sliders",
                    containerClassName: "slider-container",
                    groupClassName: "slider-group",
                    inputAreaClass: "slider-input-area",
                    railRectClass: "slider-rail-rect",
                    railTouchRectClass: "slider-rail-touch-rect",
                    gripRectClass: "slider-grip-rect",
                    tickRectClass: "slider-tick-rect",
                    inputProxyClass: "slider-input-proxy",
                    labelsClass: "slider-labels",
                    labelGroupClass: "slider-label-group",
                    labelClass: "slider-label",
                    currentValueClass: "slider-current-value",
                    railHeight: 5,
                    menuIndexAttrName: "slider-active-index",
                    autoMarginIdRoot: "slider-",
                    minWidth: 30,
                    minHeight: 30,
                    textPadX: 40,
                    arrowOffsetX: 4,
                    railRadius: 2,
                    railWidth: 5,
                    railBorder: 4,
                    railBorderWidth: 1,
                    railBorderColor: "#bec8d9",
                    railBgColor: "#f8fafc",
                    railInset: 8,
                    stepInset: 10,
                    gripRadius: 10,
                    gripWidth: 20,
                    gripHeight: 20,
                    gripBorder: 20,
                    gripBorderWidth: 1,
                    gripBorderColor: "#bec8d9",
                    gripBgColor: "#f6f8fa",
                    gripBgActiveColor: "#dbdde0",
                    labelPadding: 8,
                    labelOffset: 0,
                    tickWidth: 1,
                    tickColor: "#333",
                    tickOffset: 25,
                    tickLength: 7,
                    minorTickOffset: 25,
                    minorTickColor: "#333",
                    minorTickLength: 4,
                    currentValuePadding: 8,
                    currentValueInset: 0
                };
            },
            {}
        ],
        461: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/array_container_defaults"), a = t1("./attributes"), o = t1("./constants").name, s = a.steps;
                function l(t1, e1, r) {
                    function o(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    for(var s = i(t1, e1, {
                        name: "steps",
                        handleItemDefaults: c
                    }), l = 0, u = 0; u < s.length; u++)s[u].visible && l++;
                    if (l < 2 ? e1.visible = !1 : o("visible")) {
                        e1._stepCount = l;
                        var f = e1._visibleSteps = n.filterVisible(s);
                        (s[o("active")] || {}).visible || (e1.active = f[0]._index), o("x"), o("y"), n.noneOrAll(t1, e1, [
                            "x",
                            "y"
                        ]), o("xanchor"), o("yanchor"), o("len"), o("lenmode"), o("pad.t"), o("pad.r"), o("pad.b"), o("pad.l"), n.coerceFont(o, "font", r.font), o("currentvalue.visible") && (o("currentvalue.xanchor"), o("currentvalue.prefix"), o("currentvalue.suffix"), o("currentvalue.offset"), n.coerceFont(o, "currentvalue.font", e1.font)), o("transition.duration"), o("transition.easing"), o("bgcolor"), o("activebgcolor"), o("bordercolor"), o("borderwidth"), o("ticklen"), o("tickwidth"), o("tickcolor"), o("minorticklen");
                    }
                }
                function c(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, s, r, i);
                    }
                    if ("skip" === t1.method || Array.isArray(t1.args) ? r("visible") : e1.visible = !1) {
                        r("method"), r("args");
                        var i = r("label", "step-" + e1._index);
                        r("value", i), r("execute");
                    }
                }
                e1.exports = function(t1, e1) {
                    i(t1, e1, {
                        name: o,
                        handleItemDefaults: l
                    });
                };
            },
            {
                "../../lib": 503,
                "../../plots/array_container_defaults": 549,
                "./attributes": 459,
                "./constants": 460
            }
        ],
        462: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../plots/plots"), a = t1("../color"), o = t1("../drawing"), s = t1("../../lib"), l = s.strTranslate, c = t1("../../lib/svg_text_utils"), u = t1("../../plot_api/plot_template").arrayEditor, f = t1("./constants"), h = t1("../../constants/alignment"), p = h.LINE_SPACING, d = h.FROM_TL, m = h.FROM_BR;
                function g(t1) {
                    return f.autoMarginIdRoot + t1._index;
                }
                function v(t1) {
                    return t1._index;
                }
                function y(t1, e1) {
                    var r = o.tester.selectAll("g." + f.labelGroupClass).data(e1._visibleSteps);
                    r.enter().append("g").classed(f.labelGroupClass, !0);
                    var a = 0, l = 0;
                    r.each(function(t1) {
                        var r = _(n.select(this), {
                            step: t1
                        }, e1).node();
                        if (r) {
                            var i = o.bBox(r);
                            l = Math.max(l, i.height), a = Math.max(a, i.width);
                        }
                    }), r.remove();
                    var u = e1._dims = {};
                    u.inputAreaWidth = Math.max(f.railWidth, f.gripHeight);
                    var h = t1._fullLayout._size;
                    u.lx = h.l + h.w * e1.x, u.ly = h.t + h.h * (1 - e1.y), "fraction" === e1.lenmode ? u.outerLength = Math.round(h.w * e1.len) : u.outerLength = e1.len, u.inputAreaStart = 0, u.inputAreaLength = Math.round(u.outerLength - e1.pad.l - e1.pad.r);
                    var p = (u.inputAreaLength - 2 * f.stepInset) / (e1._stepCount - 1), v = a + f.labelPadding;
                    if (u.labelStride = Math.max(1, Math.ceil(v / p)), u.labelHeight = l, u.currentValueMaxWidth = 0, u.currentValueHeight = 0, u.currentValueTotalHeight = 0, u.currentValueMaxLines = 1, e1.currentvalue.visible) {
                        var y = o.tester.append("g");
                        r.each(function(t1) {
                            var r = x(y, e1, t1.label), n = r.node() && o.bBox(r.node()) || {
                                width: 0,
                                height: 0
                            }, i = c.lineCount(r);
                            u.currentValueMaxWidth = Math.max(u.currentValueMaxWidth, Math.ceil(n.width)), u.currentValueHeight = Math.max(u.currentValueHeight, Math.ceil(n.height)), u.currentValueMaxLines = Math.max(u.currentValueMaxLines, i);
                        }), u.currentValueTotalHeight = u.currentValueHeight + e1.currentvalue.offset, y.remove();
                    }
                    u.height = u.currentValueTotalHeight + f.tickOffset + e1.ticklen + f.labelOffset + u.labelHeight + e1.pad.t + e1.pad.b;
                    var b = "left";
                    s.isRightAnchor(e1) && (u.lx -= u.outerLength, b = "right"), s.isCenterAnchor(e1) && (u.lx -= u.outerLength / 2, b = "center");
                    var w = "top";
                    s.isBottomAnchor(e1) && (u.ly -= u.height, w = "bottom"), s.isMiddleAnchor(e1) && (u.ly -= u.height / 2, w = "middle"), u.outerLength = Math.ceil(u.outerLength), u.height = Math.ceil(u.height), u.lx = Math.round(u.lx), u.ly = Math.round(u.ly);
                    var T = {
                        y: e1.y,
                        b: u.height * m[w],
                        t: u.height * d[w]
                    };
                    "fraction" === e1.lenmode ? (T.l = 0, T.xl = e1.x - e1.len * d[b], T.r = 0, T.xr = e1.x + e1.len * m[b]) : (T.x = e1.x, T.l = u.outerLength * d[b], T.r = u.outerLength * m[b]), i.autoMargin(t1, g(e1), T);
                }
                function x(t1, e1, r) {
                    if (e1.currentvalue.visible) {
                        var n, i, a = e1._dims;
                        switch(e1.currentvalue.xanchor){
                            case "right":
                                n = a.inputAreaLength - f.currentValueInset - a.currentValueMaxWidth, i = "left";
                                break;
                            case "center":
                                n = .5 * a.inputAreaLength, i = "middle";
                                break;
                            default:
                                n = f.currentValueInset, i = "left";
                        }
                        var l = s.ensureSingle(t1, "text", f.labelClass, function(t1) {
                            t1.attr({
                                "text-anchor": i,
                                "data-notex": 1
                            });
                        }), u = e1.currentvalue.prefix ? e1.currentvalue.prefix : "";
                        if ("string" == typeof r) u += r;
                        else {
                            var h = e1.steps[e1.active].label, d = e1._gd._fullLayout._meta;
                            d && (h = s.templateString(h, d)), u += h;
                        }
                        e1.currentvalue.suffix && (u += e1.currentvalue.suffix), l.call(o.font, e1.currentvalue.font).text(u).call(c.convertToTspans, e1._gd);
                        var m = c.lineCount(l), g = (a.currentValueMaxLines + 1 - m) * e1.currentvalue.font.size * p;
                        return c.positionText(l, n, g), l;
                    }
                }
                function b(t1, e1, r) {
                    s.ensureSingle(t1, "rect", f.gripRectClass, function(n) {
                        n.call(A, e1, t1, r).style("pointer-events", "all");
                    }).attr({
                        width: f.gripWidth,
                        height: f.gripHeight,
                        rx: f.gripRadius,
                        ry: f.gripRadius
                    }).call(a.stroke, r.bordercolor).call(a.fill, r.bgcolor).style("stroke-width", r.borderwidth + "px");
                }
                function _(t1, e1, r) {
                    var n = s.ensureSingle(t1, "text", f.labelClass, function(t1) {
                        t1.attr({
                            "text-anchor": "middle",
                            "data-notex": 1
                        });
                    }), i = e1.step.label, a = r._gd._fullLayout._meta;
                    return a && (i = s.templateString(i, a)), n.call(o.font, r.font).text(i).call(c.convertToTspans, r._gd), n;
                }
                function w(t1, e1) {
                    var r = s.ensureSingle(t1, "g", f.labelsClass), i = e1._dims, a = r.selectAll("g." + f.labelGroupClass).data(i.labelSteps);
                    a.enter().append("g").classed(f.labelGroupClass, !0), a.exit().remove(), a.each(function(t1) {
                        var r = n.select(this);
                        r.call(_, t1, e1), o.setTranslate(r, E(e1, t1.fraction), f.tickOffset + e1.ticklen + e1.font.size * p + f.labelOffset + i.currentValueTotalHeight);
                    });
                }
                function T(t1, e1, r, n, i) {
                    var a = Math.round(n * (r._stepCount - 1)), o = r._visibleSteps[a]._index;
                    o !== r.active && k(t1, e1, r, o, !0, i);
                }
                function k(t1, e1, r, n, a, o) {
                    var s = r.active;
                    r.active = n, u(t1.layout, f.name, r).applyUpdate("active", n);
                    var l = r.steps[r.active];
                    e1.call(S, r, o), e1.call(x, r), t1.emit("plotly_sliderchange", {
                        slider: r,
                        step: r.steps[r.active],
                        interaction: a,
                        previousActive: s
                    }), l && l.method && a && (e1._nextMethod ? (e1._nextMethod.step = l, e1._nextMethod.doCallback = a, e1._nextMethod.doTransition = o) : (e1._nextMethod = {
                        step: l,
                        doCallback: a,
                        doTransition: o
                    }, e1._nextMethodRaf = window.requestAnimationFrame(function() {
                        var r = e1._nextMethod.step;
                        r.method && (r.execute && i.executeAPICommand(t1, r.method, r.args), e1._nextMethod = null, e1._nextMethodRaf = null);
                    })));
                }
                function A(t1, e1, r) {
                    var i = r.node(), o = n.select(e1);
                    function s() {
                        return r.data()[0];
                    }
                    function l() {
                        var t1 = s();
                        e1.emit("plotly_sliderstart", {
                            slider: t1
                        });
                        var l = r.select("." + f.gripRectClass);
                        n.event.stopPropagation(), n.event.preventDefault(), l.call(a.fill, t1.activebgcolor);
                        var c = L(t1, n.mouse(i)[0]);
                        function u() {
                            var t1 = s(), a = L(t1, n.mouse(i)[0]);
                            T(e1, r, t1, a, !1);
                        }
                        function h() {
                            var t1 = s();
                            t1._dragging = !1, l.call(a.fill, t1.bgcolor), o.on("mouseup", null), o.on("mousemove", null), o.on("touchend", null), o.on("touchmove", null), e1.emit("plotly_sliderend", {
                                slider: t1,
                                step: t1.steps[t1.active]
                            });
                        }
                        T(e1, r, t1, c, !0), t1._dragging = !0, o.on("mousemove", u), o.on("touchmove", u), o.on("mouseup", h), o.on("touchend", h);
                    }
                    t1.on("mousedown", l), t1.on("touchstart", l);
                }
                function M(t1, e1) {
                    var r = t1.selectAll("rect." + f.tickRectClass).data(e1._visibleSteps), i = e1._dims;
                    r.enter().append("rect").classed(f.tickRectClass, !0), r.exit().remove(), r.attr({
                        width: e1.tickwidth + "px",
                        "shape-rendering": "crispEdges"
                    }), r.each(function(t1, r) {
                        var s = r % i.labelStride == 0, l = n.select(this);
                        l.attr({
                            height: s ? e1.ticklen : e1.minorticklen
                        }).call(a.fill, e1.tickcolor), o.setTranslate(l, E(e1, r / (e1._stepCount - 1)) - .5 * e1.tickwidth, (s ? f.tickOffset : f.minorTickOffset) + i.currentValueTotalHeight);
                    });
                }
                function S(t1, e1, r) {
                    for(var n = t1.select("rect." + f.gripRectClass), i = 0, a = 0; a < e1._stepCount; a++)if (e1._visibleSteps[a]._index === e1.active) {
                        i = a;
                        break;
                    }
                    var o = E(e1, i / (e1._stepCount - 1));
                    if (!e1._invokingCommand) {
                        var s = n;
                        r && e1.transition.duration > 0 && (s = s.transition().duration(e1.transition.duration).ease(e1.transition.easing)), s.attr("transform", l(o - .5 * f.gripWidth, e1._dims.currentValueTotalHeight));
                    }
                }
                function E(t1, e1) {
                    var r = t1._dims;
                    return r.inputAreaStart + f.stepInset + (r.inputAreaLength - 2 * f.stepInset) * Math.min(1, Math.max(0, e1));
                }
                function L(t1, e1) {
                    var r = t1._dims;
                    return Math.min(1, Math.max(0, (e1 - f.stepInset - r.inputAreaStart) / (r.inputAreaLength - 2 * f.stepInset - 2 * r.inputAreaStart)));
                }
                function C(t1, e1, r) {
                    var n = r._dims, i = s.ensureSingle(t1, "rect", f.railTouchRectClass, function(n) {
                        n.call(A, e1, t1, r).style("pointer-events", "all");
                    });
                    i.attr({
                        width: n.inputAreaLength,
                        height: Math.max(n.inputAreaWidth, f.tickOffset + r.ticklen + n.labelHeight)
                    }).call(a.fill, r.bgcolor).attr("opacity", 0), o.setTranslate(i, 0, n.currentValueTotalHeight);
                }
                function P(t1, e1) {
                    var r = e1._dims, n = r.inputAreaLength - 2 * f.railInset, i = s.ensureSingle(t1, "rect", f.railRectClass);
                    i.attr({
                        width: n,
                        height: f.railWidth,
                        rx: f.railRadius,
                        ry: f.railRadius,
                        "shape-rendering": "crispEdges"
                    }).call(a.stroke, e1.bordercolor).call(a.fill, e1.bgcolor).style("stroke-width", e1.borderwidth + "px"), o.setTranslate(i, f.railInset, .5 * (r.inputAreaWidth - f.railWidth) + r.currentValueTotalHeight);
                }
                e1.exports = function(t1) {
                    var e1 = t1._fullLayout, r = function(t1, e1) {
                        for(var r = t1[f.name], n = [], i = 0; i < r.length; i++){
                            var a = r[i];
                            a.visible && (a._gd = e1, n.push(a));
                        }
                        return n;
                    }(e1, t1), a = e1._infolayer.selectAll("g." + f.containerClassName).data(r.length > 0 ? [
                        0
                    ] : []);
                    function s(e1) {
                        e1._commandObserver && (e1._commandObserver.remove(), delete e1._commandObserver), i.autoMargin(t1, g(e1));
                    }
                    if (a.enter().append("g").classed(f.containerClassName, !0).style("cursor", "ew-resize"), a.exit().each(function() {
                        n.select(this).selectAll("g." + f.groupClassName).each(s);
                    }).remove(), 0 !== r.length) {
                        var l = a.selectAll("g." + f.groupClassName).data(r, v);
                        l.enter().append("g").classed(f.groupClassName, !0), l.exit().each(s).remove();
                        for(var c = 0; c < r.length; c++){
                            var u = r[c];
                            y(t1, u);
                        }
                        l.each(function(e1) {
                            var r = n.select(this);
                            !function(t1) {
                                var e1 = t1._dims;
                                e1.labelSteps = [];
                                for(var r = t1._stepCount, n = 0; n < r; n += e1.labelStride)e1.labelSteps.push({
                                    fraction: n / (r - 1),
                                    step: t1._visibleSteps[n]
                                });
                            }(e1), i.manageCommandObserver(t1, e1, e1._visibleSteps, function(e1) {
                                var n = r.data()[0];
                                n.active !== e1.index && (n._dragging || k(t1, r, n, e1.index, !1, !0));
                            }), function(t1, e1, r) {
                                (r.steps[r.active] || {}).visible || (r.active = r._visibleSteps[0]._index);
                                e1.call(x, r).call(P, r).call(w, r).call(M, r).call(C, t1, r).call(b, t1, r);
                                var n = r._dims;
                                o.setTranslate(e1, n.lx + r.pad.l, n.ly + r.pad.t), e1.call(S, r, !1), e1.call(x, r);
                            }(t1, n.select(this), e1);
                        });
                    }
                };
            },
            {
                "../../constants/alignment": 471,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../plot_api/plot_template": 543,
                "../../plots/plots": 619,
                "../color": 366,
                "../drawing": 388,
                "./constants": 460,
                "@plotly/d3": 58
            }
        ],
        463: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./constants");
                e1.exports = {
                    moduleType: "component",
                    name: n.name,
                    layoutAttributes: t1("./attributes"),
                    supplyLayoutDefaults: t1("./defaults"),
                    draw: t1("./draw")
                };
            },
            {
                "./attributes": 459,
                "./constants": 460,
                "./defaults": 461,
                "./draw": 462
            }
        ],
        464: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("fast-isnumeric"), a = t1("../../plots/plots"), o = t1("../../registry"), s = t1("../../lib"), l = s.strTranslate, c = t1("../drawing"), u = t1("../color"), f = t1("../../lib/svg_text_utils"), h = t1("../../constants/interactions"), p = t1("../../constants/alignment").OPPOSITE_SIDE, d = / [XY][0-9]* /;
                e1.exports = {
                    draw: function(t1, e1, r) {
                        var m, g = r.propContainer, v = r.propName, y = r.placeholder, x = r.traceIndex, b = r.avoid || {}, _ = r.attributes, w = r.transform, T = r.containerGroup, k = t1._fullLayout, A = 1, M = !1, S = g.title, E = (S && S.text ? S.text : "").trim(), L = S && S.font ? S.font : {}, C = L.family, P = L.size, I = L.color;
                        "title.text" === v ? m = "titleText" : -1 !== v.indexOf("axis") ? m = "axisTitleText" : v.indexOf(!0) && (m = "colorbarTitleText");
                        var O = t1._context.edits[m];
                        "" === E ? A = 0 : E.replace(d, " % ") === y.replace(d, " % ") && (A = .2, M = !0, O || (E = "")), r._meta ? E = s.templateString(E, r._meta) : k._meta && (E = s.templateString(E, k._meta));
                        var z, D = E || O;
                        T || (T = s.ensureSingle(k._infolayer, "g", "g-" + e1), z = k._hColorbarMoveTitle);
                        var R = T.selectAll("text").data(D ? [
                            0
                        ] : []);
                        if (R.enter().append("text"), R.text(E).attr("class", e1), R.exit().remove(), !D) return T;
                        function F(t1) {
                            s.syncOrAsync([
                                B,
                                N
                            ], t1);
                        }
                        function B(e1) {
                            var r;
                            return !w && z && (w = {}), w ? (r = "", w.rotate && (r += "rotate(" + [
                                w.rotate,
                                _.x,
                                _.y
                            ] + ")"), (w.offset || z) && (r += l(0, (w.offset || 0) - (z || 0)))) : r = null, e1.attr("transform", r), e1.style({
                                "font-family": C,
                                "font-size": n.round(P, 2) + "px",
                                fill: u.rgb(I),
                                opacity: A * u.opacity(I),
                                "font-weight": a.fontWeight
                            }).attr(_).call(f.convertToTspans, t1), a.previousPromises(t1);
                        }
                        function N(t1) {
                            var e1 = n.select(t1.node().parentNode);
                            if (b && b.selection && b.side && E) {
                                e1.attr("transform", null);
                                var r = p[b.side], a = "left" === b.side || "top" === b.side ? -1 : 1, o = i(b.pad) ? b.pad : 2, u = c.bBox(e1.node()), f = {
                                    left: 0,
                                    top: 0,
                                    right: k.width,
                                    bottom: k.height
                                }, h = b.maxShift || a * (f[b.side] - u[b.side]), d = 0;
                                if (h < 0) d = h;
                                else {
                                    var m = b.offsetLeft || 0, g = b.offsetTop || 0;
                                    u.left -= m, u.right -= m, u.top -= g, u.bottom -= g, b.selection.each(function() {
                                        var t1 = c.bBox(this);
                                        s.bBoxIntersect(u, t1, o) && (d = Math.max(d, a * (t1[b.side] - u[r]) + o));
                                    }), d = Math.min(h, d);
                                }
                                if (d > 0 || h < 0) {
                                    var v = {
                                        left: [
                                            -d,
                                            0
                                        ],
                                        right: [
                                            d,
                                            0
                                        ],
                                        top: [
                                            0,
                                            -d
                                        ],
                                        bottom: [
                                            0,
                                            d
                                        ]
                                    }[b.side];
                                    e1.attr("transform", l(v[0], v[1]));
                                }
                            }
                        }
                        return R.call(F), O && (E ? R.on(".opacity", null) : (A = 0, M = !0, R.text(y).on("mouseover.opacity", function() {
                            n.select(this).transition().duration(h.SHOW_PLACEHOLDER).style("opacity", 1);
                        }).on("mouseout.opacity", function() {
                            n.select(this).transition().duration(h.HIDE_PLACEHOLDER).style("opacity", 0);
                        })), R.call(f.makeEditable, {
                            gd: t1
                        }).on("edit", function(e1) {
                            void 0 !== x ? o.call("_guiRestyle", t1, v, e1, x) : o.call("_guiRelayout", t1, v, e1);
                        }).on("cancel", function() {
                            this.text(this.attr("data-unformatted")).call(F);
                        }).on("input", function(t1) {
                            this.text(t1 || " ").call(f.positionText, _.x, _.y);
                        })), R.classed("js-placeholder", M), T;
                    }
                };
            },
            {
                "../../constants/alignment": 471,
                "../../constants/interactions": 478,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../plots/plots": 619,
                "../../registry": 638,
                "../color": 366,
                "../drawing": 388,
                "@plotly/d3": 58,
                "fast-isnumeric": 190
            }
        ],
        465: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/font_attributes"), i = t1("../color/attributes"), a = t1("../../lib/extend").extendFlat, o = t1("../../plot_api/edit_types").overrideAll, s = t1("../../plots/pad_attributes"), l = t1("../../plot_api/plot_template").templatedArray, c = l("button", {
                    visible: {
                        valType: "boolean"
                    },
                    method: {
                        valType: "enumerated",
                        values: [
                            "restyle",
                            "relayout",
                            "animate",
                            "update",
                            "skip"
                        ],
                        dflt: "restyle"
                    },
                    args: {
                        valType: "info_array",
                        freeLength: !0,
                        items: [
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            }
                        ]
                    },
                    args2: {
                        valType: "info_array",
                        freeLength: !0,
                        items: [
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            },
                            {
                                valType: "any"
                            }
                        ]
                    },
                    label: {
                        valType: "string",
                        dflt: ""
                    },
                    execute: {
                        valType: "boolean",
                        dflt: !0
                    }
                });
                e1.exports = o(l("updatemenu", {
                    _arrayAttrRegexps: [
                        /^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/
                    ],
                    visible: {
                        valType: "boolean"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "dropdown",
                            "buttons"
                        ],
                        dflt: "dropdown"
                    },
                    direction: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "right",
                            "up",
                            "down"
                        ],
                        dflt: "down"
                    },
                    active: {
                        valType: "integer",
                        min: -1,
                        dflt: 0
                    },
                    showactive: {
                        valType: "boolean",
                        dflt: !0
                    },
                    buttons: c,
                    x: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        dflt: -0.05
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "right"
                    },
                    y: {
                        valType: "number",
                        min: -2,
                        max: 3,
                        dflt: 1
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        dflt: "top"
                    },
                    pad: a(s({
                        editType: "arraydraw"
                    }), {}),
                    font: n({}),
                    bgcolor: {
                        valType: "color"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: i.borderLine
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "arraydraw"
                    }
                }), "arraydraw", "from-root");
            },
            {
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../../plot_api/plot_template": 543,
                "../../plots/font_attributes": 585,
                "../../plots/pad_attributes": 618,
                "../color/attributes": 365
            }
        ],
        466: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    name: "updatemenus",
                    containerClassName: "updatemenu-container",
                    headerGroupClassName: "updatemenu-header-group",
                    headerClassName: "updatemenu-header",
                    headerArrowClassName: "updatemenu-header-arrow",
                    dropdownButtonGroupClassName: "updatemenu-dropdown-button-group",
                    dropdownButtonClassName: "updatemenu-dropdown-button",
                    buttonClassName: "updatemenu-button",
                    itemRectClassName: "updatemenu-item-rect",
                    itemTextClassName: "updatemenu-item-text",
                    menuIndexAttrName: "updatemenu-active-index",
                    autoMarginIdRoot: "updatemenu-",
                    blankHeaderOpts: {
                        label: "  "
                    },
                    minWidth: 30,
                    minHeight: 30,
                    textPadX: 24,
                    arrowPadX: 16,
                    rx: 2,
                    ry: 2,
                    textOffsetX: 12,
                    textOffsetY: 3,
                    arrowOffsetX: 4,
                    gapButtonHeader: 5,
                    gapButton: 2,
                    activeColor: "#F4FAFF",
                    hoverColor: "#F4FAFF",
                    arrowSymbol: {
                        left: "\u25c4",
                        right: "\u25ba",
                        up: "\u25b2",
                        down: "\u25bc"
                    }
                };
            },
            {}
        ],
        467: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/array_container_defaults"), a = t1("./attributes"), o = t1("./constants").name, s = a.buttons;
                function l(t1, e1, r) {
                    function o(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    o("visible", i(t1, e1, {
                        name: "buttons",
                        handleItemDefaults: c
                    }).length > 0) && (o("active"), o("direction"), o("type"), o("showactive"), o("x"), o("y"), n.noneOrAll(t1, e1, [
                        "x",
                        "y"
                    ]), o("xanchor"), o("yanchor"), o("pad.t"), o("pad.r"), o("pad.b"), o("pad.l"), n.coerceFont(o, "font", r.font), o("bgcolor", r.paper_bgcolor), o("bordercolor"), o("borderwidth"));
                }
                function c(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, s, r, i);
                    }
                    r("visible", "skip" === t1.method || Array.isArray(t1.args)) && (r("method"), r("args"), r("args2"), r("label"), r("execute"));
                }
                e1.exports = function(t1, e1) {
                    i(t1, e1, {
                        name: o,
                        handleItemDefaults: l
                    });
                };
            },
            {
                "../../lib": 503,
                "../../plots/array_container_defaults": 549,
                "./attributes": 465,
                "./constants": 466
            }
        ],
        468: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../plots/plots"), a = t1("../color"), o = t1("../drawing"), s = t1("../../lib"), l = t1("../../lib/svg_text_utils"), c = t1("../../plot_api/plot_template").arrayEditor, u = t1("../../constants/alignment").LINE_SPACING, f = t1("./constants"), h = t1("./scrollbox");
                function p(t1) {
                    return t1._index;
                }
                function d(t1, e1) {
                    return +t1.attr(f.menuIndexAttrName) === e1._index;
                }
                function m(t1, e1, r, n, i, a, o, s) {
                    e1.active = o, c(t1.layout, f.name, e1).applyUpdate("active", o), "buttons" === e1.type ? v(t1, n, null, null, e1) : "dropdown" === e1.type && (i.attr(f.menuIndexAttrName, "-1"), g(t1, n, i, a, e1), s || v(t1, n, i, a, e1));
                }
                function g(t1, e1, r, n, i) {
                    var a = s.ensureSingle(e1, "g", f.headerClassName, function(t1) {
                        t1.style("pointer-events", "all");
                    }), l = i._dims, c = i.active, u = i.buttons[c] || f.blankHeaderOpts, h = {
                        y: i.pad.t,
                        yPad: 0,
                        x: i.pad.l,
                        xPad: 0,
                        index: 0
                    }, p = {
                        width: l.headerWidth,
                        height: l.headerHeight
                    };
                    a.call(y, i, u, t1).call(M, i, h, p), s.ensureSingle(e1, "text", f.headerArrowClassName, function(t1) {
                        t1.attr("text-anchor", "end").call(o.font, i.font).text(f.arrowSymbol[i.direction]);
                    }).attr({
                        x: l.headerWidth - f.arrowOffsetX + i.pad.l,
                        y: l.headerHeight / 2 + f.textOffsetY + i.pad.t
                    }), a.on("click", function() {
                        r.call(S, String(d(r, i) ? -1 : i._index)), v(t1, e1, r, n, i);
                    }), a.on("mouseover", function() {
                        a.call(w);
                    }), a.on("mouseout", function() {
                        a.call(T, i);
                    }), o.setTranslate(e1, l.lx, l.ly);
                }
                function v(t1, e1, r, a, o) {
                    r || (r = e1).attr("pointer-events", "all");
                    var l = function(t1) {
                        return -1 == +t1.attr(f.menuIndexAttrName);
                    }(r) && "buttons" !== o.type ? [] : o.buttons, c = "dropdown" === o.type ? f.dropdownButtonClassName : f.buttonClassName, u = r.selectAll("g." + c).data(s.filterVisible(l)), h = u.enter().append("g").classed(c, !0), p = u.exit();
                    "dropdown" === o.type ? (h.attr("opacity", "0").transition().attr("opacity", "1"), p.transition().attr("opacity", "0").remove()) : p.remove();
                    var d = 0, g = 0, v = o._dims, x = -1 !== [
                        "up",
                        "down"
                    ].indexOf(o.direction);
                    "dropdown" === o.type && (x ? g = v.headerHeight + f.gapButtonHeader : d = v.headerWidth + f.gapButtonHeader), "dropdown" === o.type && "up" === o.direction && (g = -f.gapButtonHeader + f.gapButton - v.openHeight), "dropdown" === o.type && "left" === o.direction && (d = -f.gapButtonHeader + f.gapButton - v.openWidth);
                    var b = {
                        x: v.lx + d + o.pad.l,
                        y: v.ly + g + o.pad.t,
                        yPad: f.gapButton,
                        xPad: f.gapButton,
                        index: 0
                    }, k = {
                        l: b.x + o.borderwidth,
                        t: b.y + o.borderwidth
                    };
                    u.each(function(s, l) {
                        var c = n.select(this);
                        c.call(y, o, s, t1).call(M, o, b), c.on("click", function() {
                            n.event.defaultPrevented || (s.execute && (s.args2 && o.active === l ? (m(t1, o, 0, e1, r, a, -1), i.executeAPICommand(t1, s.method, s.args2)) : (m(t1, o, 0, e1, r, a, l), i.executeAPICommand(t1, s.method, s.args))), t1.emit("plotly_buttonclicked", {
                                menu: o,
                                button: s,
                                active: o.active
                            }));
                        }), c.on("mouseover", function() {
                            c.call(w);
                        }), c.on("mouseout", function() {
                            c.call(T, o), u.call(_, o);
                        });
                    }), u.call(_, o), x ? (k.w = Math.max(v.openWidth, v.headerWidth), k.h = b.y - k.t) : (k.w = b.x - k.l, k.h = Math.max(v.openHeight, v.headerHeight)), k.direction = o.direction, a && (u.size() ? function(t1, e1, r, n, i, a) {
                        var o, s, l, c = i.direction, u = "up" === c || "down" === c, h = i._dims, p = i.active;
                        if (u) for(s = 0, l = 0; l < p; l++)s += h.heights[l] + f.gapButton;
                        else for(o = 0, l = 0; l < p; l++)o += h.widths[l] + f.gapButton;
                        n.enable(a, o, s), n.hbar && n.hbar.attr("opacity", "0").transition().attr("opacity", "1");
                        n.vbar && n.vbar.attr("opacity", "0").transition().attr("opacity", "1");
                    }(0, 0, 0, a, o, k) : function(t1) {
                        var e1 = !!t1.hbar, r = !!t1.vbar;
                        e1 && t1.hbar.transition().attr("opacity", "0").each("end", function() {
                            e1 = !1, r || t1.disable();
                        });
                        r && t1.vbar.transition().attr("opacity", "0").each("end", function() {
                            r = !1, e1 || t1.disable();
                        });
                    }(a));
                }
                function y(t1, e1, r, n) {
                    t1.call(x, e1).call(b, e1, r, n);
                }
                function x(t1, e1) {
                    s.ensureSingle(t1, "rect", f.itemRectClassName, function(t1) {
                        t1.attr({
                            rx: f.rx,
                            ry: f.ry,
                            "shape-rendering": "crispEdges"
                        });
                    }).call(a.stroke, e1.bordercolor).call(a.fill, e1.bgcolor).style("stroke-width", e1.borderwidth + "px");
                }
                function b(t1, e1, r, n) {
                    var i = s.ensureSingle(t1, "text", f.itemTextClassName, function(t1) {
                        t1.attr({
                            "text-anchor": "start",
                            "data-notex": 1
                        });
                    }), a = r.label, c = n._fullLayout._meta;
                    c && (a = s.templateString(a, c)), i.call(o.font, e1.font).text(a).call(l.convertToTspans, n);
                }
                function _(t1, e1) {
                    var r = e1.active;
                    t1.each(function(t1, i) {
                        var o = n.select(this);
                        i === r && e1.showactive && o.select("rect." + f.itemRectClassName).call(a.fill, f.activeColor);
                    });
                }
                function w(t1) {
                    t1.select("rect." + f.itemRectClassName).call(a.fill, f.hoverColor);
                }
                function T(t1, e1) {
                    t1.select("rect." + f.itemRectClassName).call(a.fill, e1.bgcolor);
                }
                function k(t1, e1) {
                    var r = e1._dims = {
                        width1: 0,
                        height1: 0,
                        heights: [],
                        widths: [],
                        totalWidth: 0,
                        totalHeight: 0,
                        openWidth: 0,
                        openHeight: 0,
                        lx: 0,
                        ly: 0
                    }, a = o.tester.selectAll("g." + f.dropdownButtonClassName).data(s.filterVisible(e1.buttons));
                    a.enter().append("g").classed(f.dropdownButtonClassName, !0);
                    var c = -1 !== [
                        "up",
                        "down"
                    ].indexOf(e1.direction);
                    a.each(function(i, a) {
                        var s = n.select(this);
                        s.call(y, e1, i, t1);
                        var h = s.select("." + f.itemTextClassName), p = h.node() && o.bBox(h.node()).width, d = Math.max(p + f.textPadX, f.minWidth), m = e1.font.size * u, g = l.lineCount(h), v = Math.max(m * g, f.minHeight) + f.textOffsetY;
                        v = Math.ceil(v), d = Math.ceil(d), r.widths[a] = d, r.heights[a] = v, r.height1 = Math.max(r.height1, v), r.width1 = Math.max(r.width1, d), c ? (r.totalWidth = Math.max(r.totalWidth, d), r.openWidth = r.totalWidth, r.totalHeight += v + f.gapButton, r.openHeight += v + f.gapButton) : (r.totalWidth += d + f.gapButton, r.openWidth += d + f.gapButton, r.totalHeight = Math.max(r.totalHeight, v), r.openHeight = r.totalHeight);
                    }), c ? r.totalHeight -= f.gapButton : r.totalWidth -= f.gapButton, r.headerWidth = r.width1 + f.arrowPadX, r.headerHeight = r.height1, "dropdown" === e1.type && (c ? (r.width1 += f.arrowPadX, r.totalHeight = r.height1) : r.totalWidth = r.width1, r.totalWidth += f.arrowPadX), a.remove();
                    var h = r.totalWidth + e1.pad.l + e1.pad.r, p = r.totalHeight + e1.pad.t + e1.pad.b, d = t1._fullLayout._size;
                    r.lx = d.l + d.w * e1.x, r.ly = d.t + d.h * (1 - e1.y);
                    var m = "left";
                    s.isRightAnchor(e1) && (r.lx -= h, m = "right"), s.isCenterAnchor(e1) && (r.lx -= h / 2, m = "center");
                    var g = "top";
                    s.isBottomAnchor(e1) && (r.ly -= p, g = "bottom"), s.isMiddleAnchor(e1) && (r.ly -= p / 2, g = "middle"), r.totalWidth = Math.ceil(r.totalWidth), r.totalHeight = Math.ceil(r.totalHeight), r.lx = Math.round(r.lx), r.ly = Math.round(r.ly), i.autoMargin(t1, A(e1), {
                        x: e1.x,
                        y: e1.y,
                        l: h * (({
                            right: 1,
                            center: .5
                        })[m] || 0),
                        r: h * (({
                            left: 1,
                            center: .5
                        })[m] || 0),
                        b: p * (({
                            top: 1,
                            middle: .5
                        })[g] || 0),
                        t: p * (({
                            bottom: 1,
                            middle: .5
                        })[g] || 0)
                    });
                }
                function A(t1) {
                    return f.autoMarginIdRoot + t1._index;
                }
                function M(t1, e1, r, n) {
                    n = n || {};
                    var i = t1.select("." + f.itemRectClassName), a = t1.select("." + f.itemTextClassName), s = e1.borderwidth, c = r.index, h = e1._dims;
                    o.setTranslate(t1, s + r.x, s + r.y);
                    var p = -1 !== [
                        "up",
                        "down"
                    ].indexOf(e1.direction), d = n.height || (p ? h.heights[c] : h.height1);
                    i.attr({
                        x: 0,
                        y: 0,
                        width: n.width || (p ? h.width1 : h.widths[c]),
                        height: d
                    });
                    var m = e1.font.size * u, g = (l.lineCount(a) - 1) * m / 2;
                    l.positionText(a, f.textOffsetX, d / 2 - g + f.textOffsetY), p ? r.y += h.heights[c] + r.yPad : r.x += h.widths[c] + r.xPad, r.index++;
                }
                function S(t1, e1) {
                    t1.attr(f.menuIndexAttrName, e1 || "-1").selectAll("g." + f.dropdownButtonClassName).remove();
                }
                e1.exports = function(t1) {
                    var e1 = t1._fullLayout, r = s.filterVisible(e1[f.name]);
                    function a(e1) {
                        i.autoMargin(t1, A(e1));
                    }
                    var o = e1._menulayer.selectAll("g." + f.containerClassName).data(r.length > 0 ? [
                        0
                    ] : []);
                    if (o.enter().append("g").classed(f.containerClassName, !0).style("cursor", "pointer"), o.exit().each(function() {
                        n.select(this).selectAll("g." + f.headerGroupClassName).each(a);
                    }).remove(), 0 !== r.length) {
                        var l = o.selectAll("g." + f.headerGroupClassName).data(r, p);
                        l.enter().append("g").classed(f.headerGroupClassName, !0);
                        for(var c = s.ensureSingle(o, "g", f.dropdownButtonGroupClassName, function(t1) {
                            t1.style("pointer-events", "all");
                        }), u = 0; u < r.length; u++){
                            var y = r[u];
                            k(t1, y);
                        }
                        var x = "updatemenus" + e1._uid, b = new h(t1, c, x);
                        l.enter().size() && (c.node().parentNode.appendChild(c.node()), c.call(S)), l.exit().each(function(t1) {
                            c.call(S), a(t1);
                        }).remove(), l.each(function(e1) {
                            var r = n.select(this), a = "dropdown" === e1.type ? c : null;
                            i.manageCommandObserver(t1, e1, e1.buttons, function(n) {
                                m(t1, e1, e1.buttons[n.index], r, a, b, n.index, !0);
                            }), "dropdown" === e1.type ? (g(t1, r, c, b, e1), d(c, e1) && v(t1, r, c, b, e1)) : v(t1, r, null, null, e1);
                        });
                    }
                };
            },
            {
                "../../constants/alignment": 471,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../plot_api/plot_template": 543,
                "../../plots/plots": 619,
                "../color": 366,
                "../drawing": 388,
                "./constants": 466,
                "./scrollbox": 470,
                "@plotly/d3": 58
            }
        ],
        469: [
            function(t1, e1, r) {
                arguments[4][463][0].apply(r, arguments);
            },
            {
                "./attributes": 465,
                "./constants": 466,
                "./defaults": 467,
                "./draw": 468,
                dup: 463
            }
        ],
        470: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = s;
                var n = t1("@plotly/d3"), i = t1("../color"), a = t1("../drawing"), o = t1("../../lib");
                function s(t1, e1, r) {
                    this.gd = t1, this.container = e1, this.id = r, this.position = null, this.translateX = null, this.translateY = null, this.hbar = null, this.vbar = null, this.bg = this.container.selectAll("rect.scrollbox-bg").data([
                        0
                    ]), this.bg.exit().on(".drag", null).on("wheel", null).remove(), this.bg.enter().append("rect").classed("scrollbox-bg", !0).style("pointer-events", "all").attr({
                        opacity: 0,
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    });
                }
                s.barWidth = 2, s.barLength = 20, s.barRadius = 2, s.barPad = 1, s.barColor = "#808BA4", s.prototype.enable = function(t1, e1, r) {
                    var o = this.gd._fullLayout, l = o.width, c = o.height;
                    this.position = t1;
                    var u, f, h, p, d = this.position.l, m = this.position.w, g = this.position.t, v = this.position.h, y = this.position.direction, x = "down" === y, b = "left" === y, _ = "up" === y, w = m, T = v;
                    x || b || "right" === y || _ || (this.position.direction = "down", x = !0), x || _ ? (f = (u = d) + w, x ? (h = g, T = (p = Math.min(h + T, c)) - h) : T = (p = g + T) - (h = Math.max(p - T, 0))) : (p = (h = g) + T, b ? w = (f = d + w) - (u = Math.max(f - w, 0)) : (u = d, w = (f = Math.min(u + w, l)) - u)), this._box = {
                        l: u,
                        t: h,
                        w: w,
                        h: T
                    };
                    var k = m > w, A = s.barLength + 2 * s.barPad, M = s.barWidth + 2 * s.barPad, S = d, E = g + v;
                    E + M > c && (E = c - M);
                    var L = this.container.selectAll("rect.scrollbar-horizontal").data(k ? [
                        0
                    ] : []);
                    L.exit().on(".drag", null).remove(), L.enter().append("rect").classed("scrollbar-horizontal", !0).call(i.fill, s.barColor), k ? (this.hbar = L.attr({
                        rx: s.barRadius,
                        ry: s.barRadius,
                        x: S,
                        y: E,
                        width: A,
                        height: M
                    }), this._hbarXMin = S + A / 2, this._hbarTranslateMax = w - A) : (delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax);
                    var C = v > T, P = s.barWidth + 2 * s.barPad, I = s.barLength + 2 * s.barPad, O = d + m, z = g;
                    O + P > l && (O = l - P);
                    var D = this.container.selectAll("rect.scrollbar-vertical").data(C ? [
                        0
                    ] : []);
                    D.exit().on(".drag", null).remove(), D.enter().append("rect").classed("scrollbar-vertical", !0).call(i.fill, s.barColor), C ? (this.vbar = D.attr({
                        rx: s.barRadius,
                        ry: s.barRadius,
                        x: O,
                        y: z,
                        width: P,
                        height: I
                    }), this._vbarYMin = z + I / 2, this._vbarTranslateMax = T - I) : (delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
                    var R = this.id, F = u - .5, B = C ? f + P + .5 : f + .5, N = h - .5, j = k ? p + M + .5 : p + .5, U = o._topdefs.selectAll("#" + R).data(k || C ? [
                        0
                    ] : []);
                    if (U.exit().remove(), U.enter().append("clipPath").attr("id", R).append("rect"), k || C ? (this._clipRect = U.select("rect").attr({
                        x: Math.floor(F),
                        y: Math.floor(N),
                        width: Math.ceil(B) - Math.floor(F),
                        height: Math.ceil(j) - Math.floor(N)
                    }), this.container.call(a.setClipUrl, R, this.gd), this.bg.attr({
                        x: d,
                        y: g,
                        width: m,
                        height: v
                    })) : (this.bg.attr({
                        width: 0,
                        height: 0
                    }), this.container.on("wheel", null).on(".drag", null).call(a.setClipUrl, null), delete this._clipRect), k || C) {
                        var V = n.behavior.drag().on("dragstart", function() {
                            n.event.sourceEvent.preventDefault();
                        }).on("drag", this._onBoxDrag.bind(this));
                        this.container.on("wheel", null).on("wheel", this._onBoxWheel.bind(this)).on(".drag", null).call(V);
                        var H = n.behavior.drag().on("dragstart", function() {
                            n.event.sourceEvent.preventDefault(), n.event.sourceEvent.stopPropagation();
                        }).on("drag", this._onBarDrag.bind(this));
                        k && this.hbar.on(".drag", null).call(H), C && this.vbar.on(".drag", null).call(H);
                    }
                    this.setTranslate(e1, r);
                }, s.prototype.disable = function() {
                    (this.hbar || this.vbar) && (this.bg.attr({
                        width: 0,
                        height: 0
                    }), this.container.on("wheel", null).on(".drag", null).call(a.setClipUrl, null), delete this._clipRect), this.hbar && (this.hbar.on(".drag", null), this.hbar.remove(), delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax), this.vbar && (this.vbar.on(".drag", null), this.vbar.remove(), delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
                }, s.prototype._onBoxDrag = function() {
                    var t1 = this.translateX, e1 = this.translateY;
                    this.hbar && (t1 -= n.event.dx), this.vbar && (e1 -= n.event.dy), this.setTranslate(t1, e1);
                }, s.prototype._onBoxWheel = function() {
                    var t1 = this.translateX, e1 = this.translateY;
                    this.hbar && (t1 += n.event.deltaY), this.vbar && (e1 += n.event.deltaY), this.setTranslate(t1, e1);
                }, s.prototype._onBarDrag = function() {
                    var t1 = this.translateX, e1 = this.translateY;
                    if (this.hbar) {
                        var r = t1 + this._hbarXMin, i = r + this._hbarTranslateMax;
                        t1 = (o.constrain(n.event.x, r, i) - r) / (i - r) * (this.position.w - this._box.w);
                    }
                    if (this.vbar) {
                        var a = e1 + this._vbarYMin, s = a + this._vbarTranslateMax;
                        e1 = (o.constrain(n.event.y, a, s) - a) / (s - a) * (this.position.h - this._box.h);
                    }
                    this.setTranslate(t1, e1);
                }, s.prototype.setTranslate = function(t1, e1) {
                    var r = this.position.w - this._box.w, n = this.position.h - this._box.h;
                    if (t1 = o.constrain(t1 || 0, 0, r), e1 = o.constrain(e1 || 0, 0, n), this.translateX = t1, this.translateY = e1, this.container.call(a.setTranslate, this._box.l - this.position.l - t1, this._box.t - this.position.t - e1), this._clipRect && this._clipRect.attr({
                        x: Math.floor(this.position.l + t1 - .5),
                        y: Math.floor(this.position.t + e1 - .5)
                    }), this.hbar) {
                        var i = t1 / r;
                        this.hbar.call(a.setTranslate, t1 + i * this._hbarTranslateMax, e1);
                    }
                    if (this.vbar) {
                        var s = e1 / n;
                        this.vbar.call(a.setTranslate, t1, e1 + s * this._vbarTranslateMax);
                    }
                };
            },
            {
                "../../lib": 503,
                "../color": 366,
                "../drawing": 388,
                "@plotly/d3": 58
            }
        ],
        471: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    FROM_BL: {
                        left: 0,
                        center: .5,
                        right: 1,
                        bottom: 0,
                        middle: .5,
                        top: 1
                    },
                    FROM_TL: {
                        left: 0,
                        center: .5,
                        right: 1,
                        bottom: 1,
                        middle: .5,
                        top: 0
                    },
                    FROM_BR: {
                        left: 1,
                        center: .5,
                        right: 0,
                        bottom: 0,
                        middle: .5,
                        top: 1
                    },
                    LINE_SPACING: 1.3,
                    CAP_SHIFT: .7,
                    MID_SHIFT: .35,
                    OPPOSITE_SIDE: {
                        left: "right",
                        right: "left",
                        top: "bottom",
                        bottom: "top"
                    }
                };
            },
            {}
        ],
        472: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    axisRefDescription: function(t1, e1, r) {
                        return [
                            "If set to a",
                            t1,
                            "axis id (e.g. *" + t1 + "* or",
                            "*" + t1 + "2*), the `" + t1 + "` position refers to a",
                            t1,
                            "coordinate. If set to *paper*, the `" + t1 + "`",
                            "position refers to the distance from the",
                            e1,
                            "of the plotting",
                            "area in normalized coordinates where *0* (*1*) corresponds to the",
                            e1,
                            "(" + r + "). If set to a",
                            t1,
                            "axis ID followed by",
                            "*domain* (separated by a space), the position behaves like for",
                            "*paper*, but refers to the distance in fractions of the domain",
                            "length from the",
                            e1,
                            "of the domain of that axis: e.g.,",
                            "*" + t1 + "2 domain* refers to the domain of the second",
                            t1,
                            " axis and a",
                            t1,
                            "position of 0.5 refers to the",
                            "point between the",
                            e1,
                            "and the",
                            r,
                            "of the domain of the",
                            "second",
                            t1,
                            "axis."
                        ].join(" ");
                    }
                };
            },
            {}
        ],
        473: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    INCREASING: {
                        COLOR: "#3D9970",
                        SYMBOL: "\u25b2"
                    },
                    DECREASING: {
                        COLOR: "#FF4136",
                        SYMBOL: "\u25bc"
                    }
                };
            },
            {}
        ],
        474: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    FORMAT_LINK: "https://github.com/d3/d3-format/tree/v1.4.5#d3-format",
                    DATE_FORMAT_LINK: "https://github.com/d3/d3-time-format/tree/v2.2.3#locale_format"
                };
            },
            {}
        ],
        475: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    COMPARISON_OPS: [
                        "=",
                        "!=",
                        "<",
                        ">=",
                        ">",
                        "<="
                    ],
                    COMPARISON_OPS2: [
                        "=",
                        "<",
                        ">=",
                        ">",
                        "<="
                    ],
                    INTERVAL_OPS: [
                        "[]",
                        "()",
                        "[)",
                        "(]",
                        "][",
                        ")(",
                        "](",
                        ")["
                    ],
                    SET_OPS: [
                        "{}",
                        "}{"
                    ],
                    CONSTRAINT_REDUCTION: {
                        "=": "=",
                        "<": "<",
                        "<=": "<",
                        ">": ">",
                        ">=": ">",
                        "[]": "[]",
                        "()": "[]",
                        "[)": "[]",
                        "(]": "[]",
                        "][": "][",
                        ")(": "][",
                        "](": "][",
                        ")[": "]["
                    }
                };
            },
            {}
        ],
        476: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    solid: [
                        [],
                        0
                    ],
                    dot: [
                        [
                            .5,
                            1
                        ],
                        200
                    ],
                    dash: [
                        [
                            .5,
                            1
                        ],
                        50
                    ],
                    longdash: [
                        [
                            .5,
                            1
                        ],
                        10
                    ],
                    dashdot: [
                        [
                            .5,
                            .625,
                            .875,
                            1
                        ],
                        50
                    ],
                    longdashdot: [
                        [
                            .5,
                            .7,
                            .8,
                            1
                        ],
                        10
                    ]
                };
            },
            {}
        ],
        477: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    circle: "\u25cf",
                    "circle-open": "\u25cb",
                    square: "\u25a0",
                    "square-open": "\u25a1",
                    diamond: "\u25c6",
                    "diamond-open": "\u25c7",
                    cross: "+",
                    x: "\u274c"
                };
            },
            {}
        ],
        478: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    SHOW_PLACEHOLDER: 100,
                    HIDE_PLACEHOLDER: 1e3,
                    DESELECTDIM: .2
                };
            },
            {}
        ],
        479: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    BADNUM: void 0,
                    FP_SAFE: 1e-4 * Number.MAX_VALUE,
                    ONEMAXYEAR: 316224e5,
                    ONEAVGYEAR: 315576e5,
                    ONEMINYEAR: 31536e6,
                    ONEMAXQUARTER: 79488e5,
                    ONEAVGQUARTER: 78894e5,
                    ONEMINQUARTER: 76896e5,
                    ONEMAXMONTH: 26784e5,
                    ONEAVGMONTH: 26298e5,
                    ONEMINMONTH: 24192e5,
                    ONEWEEK: 6048e5,
                    ONEDAY: 864e5,
                    ONEHOUR: 36e5,
                    ONEMIN: 6e4,
                    ONESEC: 1e3,
                    EPOCHJD: 2440587.5,
                    ALMOST_EQUAL: .999999,
                    LOG_CLIP: 10,
                    MINUS_SIGN: "\u2212"
                };
            },
            {}
        ],
        480: [
            function(t1, e1, r) {
                "use strict";
                r.xmlns = "http://www.w3.org/2000/xmlns/", r.svg = "http://www.w3.org/2000/svg", r.xlink = "http://www.w3.org/1999/xlink", r.svgAttrs = {
                    xmlns: r.svg,
                    "xmlns:xlink": r.xlink
                };
            },
            {}
        ],
        481: [
            function(t1, e1, r) {
                "use strict";
                r.version = t1("./version").version, t1("native-promise-only"), t1("../build/plotcss");
                for(var n = t1("./registry"), i = r.register = n.register, a = t1("./plot_api"), o = Object.keys(a), s = 0; s < o.length; s++){
                    var l = o[s];
                    "_" !== l.charAt(0) && (r[l] = a[l]), i({
                        moduleType: "apiMethod",
                        name: l,
                        fn: a[l]
                    });
                }
                i(t1("./traces/scatter")), i([
                    t1("./components/legend"),
                    t1("./components/fx"),
                    t1("./components/annotations"),
                    t1("./components/annotations3d"),
                    t1("./components/shapes"),
                    t1("./components/images"),
                    t1("./components/updatemenus"),
                    t1("./components/sliders"),
                    t1("./components/rangeslider"),
                    t1("./components/rangeselector"),
                    t1("./components/grid"),
                    t1("./components/errorbars"),
                    t1("./components/colorscale"),
                    t1("./components/colorbar"),
                    t1("./components/modebar")
                ]), i([
                    t1("./locale-en"),
                    t1("./locale-en-us")
                ]), window.PlotlyLocales && Array.isArray(window.PlotlyLocales) && (i(window.PlotlyLocales), delete window.PlotlyLocales), r.Icons = t1("./fonts/ploticon");
                var c = t1("./components/fx"), u = t1("./plots/plots");
                r.Plots = {
                    resize: u.resize,
                    graphJson: u.graphJson,
                    sendDataToCloud: u.sendDataToCloud
                }, r.Fx = {
                    hover: c.hover,
                    unhover: c.unhover,
                    loneHover: c.loneHover,
                    loneUnhover: c.loneUnhover
                }, r.Snapshot = t1("./snapshot"), r.PlotSchema = t1("./plot_api/plot_schema");
            },
            {
                "../build/plotcss": 1,
                "./components/annotations": 357,
                "./components/annotations3d": 362,
                "./components/colorbar": 372,
                "./components/colorscale": 378,
                "./components/errorbars": 394,
                "./components/fx": 406,
                "./components/grid": 410,
                "./components/images": 415,
                "./components/legend": 423,
                "./components/modebar": 429,
                "./components/rangeselector": 437,
                "./components/rangeslider": 444,
                "./components/shapes": 458,
                "./components/sliders": 463,
                "./components/updatemenus": 469,
                "./fonts/ploticon": 482,
                "./locale-en": 534,
                "./locale-en-us": 533,
                "./plot_api": 538,
                "./plot_api/plot_schema": 542,
                "./plots/plots": 619,
                "./registry": 638,
                "./snapshot": 643,
                "./traces/scatter": 938,
                "./version": 1119,
                "native-promise-only": 245
            }
        ],
        482: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    undo: {
                        width: 857.1,
                        height: 1e3,
                        path: "m857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    home: {
                        width: 928.6,
                        height: 1e3,
                        path: "m786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    "camera-retro": {
                        width: 1e3,
                        height: 1e3,
                        path: "m518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    zoombox: {
                        width: 1e3,
                        height: 1e3,
                        path: "m1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    pan: {
                        width: 1e3,
                        height: 1e3,
                        path: "m1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    zoom_plus: {
                        width: 875,
                        height: 1e3,
                        path: "m1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    zoom_minus: {
                        width: 875,
                        height: 1e3,
                        path: "m0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    autoscale: {
                        width: 1e3,
                        height: 1e3,
                        path: "m250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    tooltip_basic: {
                        width: 1500,
                        height: 1e3,
                        path: "m375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    tooltip_compare: {
                        width: 1125,
                        height: 1e3,
                        path: "m187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    plotlylogo: {
                        width: 1542,
                        height: 1e3,
                        path: "m0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    "z-axis": {
                        width: 1e3,
                        height: 1e3,
                        path: "m833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    "3d_rotate": {
                        width: 1e3,
                        height: 1e3,
                        path: "m922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    camera: {
                        width: 1e3,
                        height: 1e3,
                        path: "m500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    movie: {
                        width: 1e3,
                        height: 1e3,
                        path: "m938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    question: {
                        width: 857.1,
                        height: 1e3,
                        path: "m500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    disk: {
                        width: 857.1,
                        height: 1e3,
                        path: "m214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    drawopenpath: {
                        width: 70,
                        height: 70,
                        path: "M33.21,85.65a7.31,7.31,0,0,1-2.59-.48c-8.16-3.11-9.27-19.8-9.88-41.3-.1-3.58-.19-6.68-.35-9-.15-2.1-.67-3.48-1.43-3.79-2.13-.88-7.91,2.32-12,5.86L3,32.38c1.87-1.64,11.55-9.66,18.27-6.9,2.13.87,4.75,3.14,5.17,9,.17,2.43.26,5.59.36,9.25a224.17,224.17,0,0,0,1.5,23.4c1.54,10.76,4,12.22,4.48,12.4.84.32,2.79-.46,5.76-3.59L43,80.07C41.53,81.57,37.68,85.64,33.21,85.65ZM74.81,69a11.34,11.34,0,0,0,6.09-6.72L87.26,44.5,74.72,32,56.9,38.35c-2.37.86-5.57,3.42-6.61,6L38.65,72.14l8.42,8.43ZM55,46.27a7.91,7.91,0,0,1,3.64-3.17l14.8-5.3,8,8L76.11,60.6l-.06.19a6.37,6.37,0,0,1-3,3.43L48.25,74.59,44.62,71Zm16.57,7.82A6.9,6.9,0,1,0,64.64,61,6.91,6.91,0,0,0,71.54,54.09Zm-4.05,0a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,67.49,54.09Zm-4.13,5.22L60.5,56.45,44.26,72.7l2.86,2.86ZM97.83,35.67,84.14,22l-8.57,8.57L89.26,44.24Zm-13.69-8,8,8-2.85,2.85-8-8Z",
                        transform: "matrix(1 0 0 1 -15 -15)"
                    },
                    drawclosedpath: {
                        width: 90,
                        height: 90,
                        path: "M88.41,21.12a26.56,26.56,0,0,0-36.18,0l-2.07,2-2.07-2a26.57,26.57,0,0,0-36.18,0,23.74,23.74,0,0,0,0,34.8L48,90.12a3.22,3.22,0,0,0,4.42,0l36-34.21a23.73,23.73,0,0,0,0-34.79ZM84,51.24,50.16,83.35,16.35,51.25a17.28,17.28,0,0,1,0-25.47,20,20,0,0,1,27.3,0l4.29,4.07a3.23,3.23,0,0,0,4.44,0l4.29-4.07a20,20,0,0,1,27.3,0,17.27,17.27,0,0,1,0,25.46ZM66.76,47.68h-33v6.91h33ZM53.35,35H46.44V68h6.91Z",
                        transform: "matrix(1 0 0 1 -5 -5)"
                    },
                    lasso: {
                        width: 1031,
                        height: 1e3,
                        path: "m1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    selectbox: {
                        width: 1e3,
                        height: 1e3,
                        path: "m0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z",
                        transform: "matrix(1 0 0 -1 0 850)"
                    },
                    drawline: {
                        width: 70,
                        height: 70,
                        path: "M60.64,62.3a11.29,11.29,0,0,0,6.09-6.72l6.35-17.72L60.54,25.31l-17.82,6.4c-2.36.86-5.57,3.41-6.6,6L24.48,65.5l8.42,8.42ZM40.79,39.63a7.89,7.89,0,0,1,3.65-3.17l14.79-5.31,8,8L61.94,54l-.06.19a6.44,6.44,0,0,1-3,3.43L34.07,68l-3.62-3.63Zm16.57,7.81a6.9,6.9,0,1,0-6.89,6.9A6.9,6.9,0,0,0,57.36,47.44Zm-4,0a2.86,2.86,0,1,1-2.85-2.85A2.86,2.86,0,0,1,53.32,47.44Zm-4.13,5.22L46.33,49.8,30.08,66.05l2.86,2.86ZM83.65,29,70,15.34,61.4,23.9,75.09,37.59ZM70,21.06l8,8-2.84,2.85-8-8ZM87,80.49H10.67V87H87Z",
                        transform: "matrix(1 0 0 1 -15 -15)"
                    },
                    drawrect: {
                        width: 80,
                        height: 80,
                        path: "M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z",
                        transform: "matrix(1 0 0 1 -10 -10)"
                    },
                    drawcircle: {
                        width: 80,
                        height: 80,
                        path: "M50,84.72C26.84,84.72,8,69.28,8,50.3S26.84,15.87,50,15.87,92,31.31,92,50.3,73.16,84.72,50,84.72Zm0-60.59c-18.6,0-33.74,11.74-33.74,26.17S31.4,76.46,50,76.46,83.74,64.72,83.74,50.3,68.6,24.13,50,24.13Zm17.15,22h-34v7.11h34Zm-13.8-13H46.24v34h7.11Z",
                        transform: "matrix(1 0 0 1 -10 -10)"
                    },
                    eraseshape: {
                        width: 80,
                        height: 80,
                        path: "M82.77,78H31.85L6,49.57,31.85,21.14H82.77a8.72,8.72,0,0,1,8.65,8.77V69.24A8.72,8.72,0,0,1,82.77,78ZM35.46,69.84H82.77a.57.57,0,0,0,.49-.6V29.91a.57.57,0,0,0-.49-.61H35.46L17,49.57Zm32.68-34.7-24,24,5,5,24-24Zm-19,.53-5,5,24,24,5-5Z",
                        transform: "matrix(1 0 0 1 -10 -10)"
                    },
                    spikeline: {
                        width: 1e3,
                        height: 1e3,
                        path: "M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z",
                        transform: "matrix(1.5 0 0 -1.5 0 850)"
                    },
                    pencil: {
                        width: 1792,
                        height: 1792,
                        path: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z",
                        transform: "matrix(1 0 0 1 0 1)"
                    },
                    newplotlylogo: {
                        name: "newplotlylogo",
                        svg: "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 132 132'><defs><style>.cls-1 {fill: #3f4f75;} .cls-2 {fill: #80cfbe;} .cls-3 {fill: #fff;}</style></defs><title>plotly-logomark</title><g id='symbol'><rect class='cls-1' width='132' height='132' rx='6' ry='6'/><circle class='cls-2' cx='78' cy='54' r='6'/><circle class='cls-2' cx='102' cy='30' r='6'/><circle class='cls-2' cx='78' cy='30' r='6'/><circle class='cls-2' cx='54' cy='30' r='6'/><circle class='cls-2' cx='30' cy='30' r='6'/><circle class='cls-2' cx='30' cy='54' r='6'/><path class='cls-3' d='M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z'/><path class='cls-3' d='M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z'/><path class='cls-3' d='M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z'/><path class='cls-3' d='M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z'/></g></svg>"
                    }
                };
            },
            {}
        ],
        483: [
            function(t1, e1, r) {
                "use strict";
                r.isLeftAnchor = function(t1) {
                    return "left" === t1.xanchor || "auto" === t1.xanchor && t1.x <= 1 / 3;
                }, r.isCenterAnchor = function(t1) {
                    return "center" === t1.xanchor || "auto" === t1.xanchor && t1.x > 1 / 3 && t1.x < 2 / 3;
                }, r.isRightAnchor = function(t1) {
                    return "right" === t1.xanchor || "auto" === t1.xanchor && t1.x >= 2 / 3;
                }, r.isTopAnchor = function(t1) {
                    return "top" === t1.yanchor || "auto" === t1.yanchor && t1.y >= 2 / 3;
                }, r.isMiddleAnchor = function(t1) {
                    return "middle" === t1.yanchor || "auto" === t1.yanchor && t1.y > 1 / 3 && t1.y < 2 / 3;
                }, r.isBottomAnchor = function(t1) {
                    return "bottom" === t1.yanchor || "auto" === t1.yanchor && t1.y <= 1 / 3;
                };
            },
            {}
        ],
        484: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./mod"), i = n.mod, a = n.modHalf, o = Math.PI, s = 2 * o;
                function l(t1) {
                    return Math.abs(t1[1] - t1[0]) > s - 1e-14;
                }
                function c(t1, e1) {
                    return a(e1 - t1, s);
                }
                function u(t1, e1) {
                    if (l(e1)) return !0;
                    var r, n;
                    e1[0] < e1[1] ? (r = e1[0], n = e1[1]) : (r = e1[1], n = e1[0]), (r = i(r, s)) > (n = i(n, s)) && (n += s);
                    var a = i(t1, s), o = a + s;
                    return a >= r && a <= n || o >= r && o <= n;
                }
                function f(t1, e1, r, n, i, a, c) {
                    i = i || 0, a = a || 0;
                    var u, f, h, p, d, m = l([
                        r,
                        n
                    ]);
                    function g(t1, e1) {
                        return [
                            t1 * Math.cos(e1) + i,
                            a - t1 * Math.sin(e1)
                        ];
                    }
                    m ? (u = 0, f = o, h = s) : r < n ? (u = r, h = n) : (u = n, h = r), t1 < e1 ? (p = t1, d = e1) : (p = e1, d = t1);
                    var v, y = Math.abs(h - u) <= o ? 0 : 1;
                    function x(t1, e1, r) {
                        return "A" + [
                            t1,
                            t1
                        ] + " " + [
                            0,
                            y,
                            r
                        ] + " " + g(t1, e1);
                    }
                    return m ? v = null === p ? "M" + g(d, u) + x(d, f, 0) + x(d, h, 0) + "Z" : "M" + g(p, u) + x(p, f, 0) + x(p, h, 0) + "ZM" + g(d, u) + x(d, f, 1) + x(d, h, 1) + "Z" : null === p ? (v = "M" + g(d, u) + x(d, h, 0), c && (v += "L0,0Z")) : v = "M" + g(p, u) + "L" + g(d, u) + x(d, h, 0) + "L" + g(p, h) + x(p, u, 1) + "Z", v;
                }
                e1.exports = {
                    deg2rad: function(t1) {
                        return t1 / 180 * o;
                    },
                    rad2deg: function(t1) {
                        return t1 / o * 180;
                    },
                    angleDelta: c,
                    angleDist: function(t1, e1) {
                        return Math.abs(c(t1, e1));
                    },
                    isFullCircle: l,
                    isAngleInsideSector: u,
                    isPtInsideSector: function(t1, e1, r, n) {
                        var i, a;
                        return !!u(e1, n) && (r[0] < r[1] ? (i = r[0], a = r[1]) : (i = r[1], a = r[0]), t1 >= i && t1 <= a);
                    },
                    pathArc: function(t1, e1, r, n, i) {
                        return f(null, t1, e1, r, n, i, 0);
                    },
                    pathSector: function(t1, e1, r, n, i) {
                        return f(null, t1, e1, r, n, i, 1);
                    },
                    pathAnnulus: function(t1, e1, r, n, i, a) {
                        return f(t1, e1, r, n, i, a, 1);
                    }
                };
            },
            {
                "./mod": 510
            }
        ],
        485: [
            function(t1, e1, r) {
                "use strict";
                var n = Array.isArray, i = ArrayBuffer, a = DataView;
                function o(t1) {
                    return i.isView(t1) && !(t1 instanceof a);
                }
                function s(t1) {
                    return n(t1) || o(t1);
                }
                function l(t1, e1, r) {
                    if (s(t1)) {
                        if (s(t1[0])) {
                            for(var n = r, i = 0; i < t1.length; i++)n = e1(n, t1[i].length);
                            return n;
                        }
                        return t1.length;
                    }
                    return 0;
                }
                r.isTypedArray = o, r.isArrayOrTypedArray = s, r.isArray1D = function(t1) {
                    return !s(t1[0]);
                }, r.ensureArray = function(t1, e1) {
                    return n(t1) || (t1 = []), t1.length = e1, t1;
                }, r.concat = function() {
                    var t1, e1, r, i, a, o, s, l, c = [], u = !0, f = 0;
                    for(r = 0; r < arguments.length; r++)(o = (i = arguments[r]).length) && (e1 ? c.push(i) : (e1 = i, a = o), n(i) ? t1 = !1 : (u = !1, f ? t1 !== i.constructor && (t1 = !1) : t1 = i.constructor), f += o);
                    if (!f) return [];
                    if (!c.length) return e1;
                    if (u) return e1.concat.apply(e1, c);
                    if (t1) {
                        for((s = new t1(f)).set(e1), r = 0; r < c.length; r++)i = c[r], s.set(i, a), a += i.length;
                        return s;
                    }
                    for(s = new Array(f), l = 0; l < e1.length; l++)s[l] = e1[l];
                    for(r = 0; r < c.length; r++){
                        for(i = c[r], l = 0; l < i.length; l++)s[a + l] = i[l];
                        a += l;
                    }
                    return s;
                }, r.maxRowLength = function(t1) {
                    return l(t1, Math.max, 0);
                }, r.minRowLength = function(t1) {
                    return l(t1, Math.min, 1 / 0);
                };
            },
            {}
        ],
        486: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../constants/numerical").BADNUM, a = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;
                e1.exports = function(t1) {
                    return "string" == typeof t1 && (t1 = t1.replace(a, "")), n(t1) ? Number(t1) : i;
                };
            },
            {
                "../constants/numerical": 479,
                "fast-isnumeric": 190
            }
        ],
        487: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    var e1 = t1._fullLayout;
                    e1._glcanvas && e1._glcanvas.size() && e1._glcanvas.each(function(t1) {
                        t1.regl && t1.regl.clear({
                            color: !0,
                            depth: !0
                        });
                    });
                };
            },
            {}
        ],
        488: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    t1._responsiveChartHandler && (window.removeEventListener("resize", t1._responsiveChartHandler), delete t1._responsiveChartHandler);
                };
            },
            {}
        ],
        489: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("tinycolor2"), a = t1("../plots/attributes"), o = t1("../components/colorscale/scales"), s = t1("../components/color"), l = t1("../constants/interactions").DESELECTDIM, c = t1("./nested_property"), u = t1("./regex").counter, f = t1("./mod").modHalf, h = t1("./array").isArrayOrTypedArray;
                function p(t1, e1) {
                    var n = r.valObjectMeta[e1.valType];
                    if (e1.arrayOk && h(t1)) return !0;
                    if (n.validateFunction) return n.validateFunction(t1, e1);
                    var i = {}, a = i, o = {
                        set: function(t1) {
                            a = t1;
                        }
                    };
                    return n.coerceFunction(t1, o, i, e1), a !== i;
                }
                r.valObjectMeta = {
                    data_array: {
                        coerceFunction: function(t1, e1, r) {
                            h(t1) ? e1.set(t1) : void 0 !== r && e1.set(r);
                        }
                    },
                    enumerated: {
                        coerceFunction: function(t1, e1, r, n) {
                            n.coerceNumber && (t1 = +t1), -1 === n.values.indexOf(t1) ? e1.set(r) : e1.set(t1);
                        },
                        validateFunction: function(t1, e1) {
                            e1.coerceNumber && (t1 = +t1);
                            for(var r = e1.values, n = 0; n < r.length; n++){
                                var i = String(r[n]);
                                if ("/" === i.charAt(0) && "/" === i.charAt(i.length - 1)) {
                                    if (new RegExp(i.substr(1, i.length - 2)).test(t1)) return !0;
                                } else if (t1 === r[n]) return !0;
                            }
                            return !1;
                        }
                    },
                    boolean: {
                        coerceFunction: function(t1, e1, r) {
                            !0 === t1 || !1 === t1 ? e1.set(t1) : e1.set(r);
                        }
                    },
                    number: {
                        coerceFunction: function(t1, e1, r, i) {
                            !n(t1) || void 0 !== i.min && t1 < i.min || void 0 !== i.max && t1 > i.max ? e1.set(r) : e1.set(+t1);
                        }
                    },
                    integer: {
                        coerceFunction: function(t1, e1, r, i) {
                            t1 % 1 || !n(t1) || void 0 !== i.min && t1 < i.min || void 0 !== i.max && t1 > i.max ? e1.set(r) : e1.set(+t1);
                        }
                    },
                    string: {
                        coerceFunction: function(t1, e1, r, n) {
                            if ("string" != typeof t1) {
                                var i = "number" == typeof t1;
                                !0 !== n.strict && i ? e1.set(String(t1)) : e1.set(r);
                            } else n.noBlank && !t1 ? e1.set(r) : e1.set(t1);
                        }
                    },
                    color: {
                        coerceFunction: function(t1, e1, r) {
                            i(t1).isValid() ? e1.set(t1) : e1.set(r);
                        }
                    },
                    colorlist: {
                        coerceFunction: function(t1, e1, r) {
                            Array.isArray(t1) && t1.length && t1.every(function(t1) {
                                return i(t1).isValid();
                            }) ? e1.set(t1) : e1.set(r);
                        }
                    },
                    colorscale: {
                        coerceFunction: function(t1, e1, r) {
                            e1.set(o.get(t1, r));
                        }
                    },
                    angle: {
                        coerceFunction: function(t1, e1, r) {
                            "auto" === t1 ? e1.set("auto") : n(t1) ? e1.set(f(+t1, 360)) : e1.set(r);
                        }
                    },
                    subplotid: {
                        coerceFunction: function(t1, e1, r, n) {
                            var i = n.regex || u(r);
                            "string" == typeof t1 && i.test(t1) ? e1.set(t1) : e1.set(r);
                        },
                        validateFunction: function(t1, e1) {
                            var r = e1.dflt;
                            return t1 === r || "string" == typeof t1 && !!u(r).test(t1);
                        }
                    },
                    flaglist: {
                        coerceFunction: function(t1, e1, r, n) {
                            if ("string" == typeof t1) {
                                if (-1 === (n.extras || []).indexOf(t1)) {
                                    for(var i = t1.split("+"), a = 0; a < i.length;){
                                        var o = i[a];
                                        -1 === n.flags.indexOf(o) || i.indexOf(o) < a ? i.splice(a, 1) : a++;
                                    }
                                    i.length ? e1.set(i.join("+")) : e1.set(r);
                                } else e1.set(t1);
                            } else e1.set(r);
                        }
                    },
                    any: {
                        coerceFunction: function(t1, e1, r) {
                            void 0 === t1 ? e1.set(r) : e1.set(t1);
                        }
                    },
                    info_array: {
                        coerceFunction: function(t1, e1, n, i) {
                            function a(t1, e1, n) {
                                var i, a = {
                                    set: function(t1) {
                                        i = t1;
                                    }
                                };
                                return void 0 === n && (n = e1.dflt), r.valObjectMeta[e1.valType].coerceFunction(t1, a, n, e1), i;
                            }
                            var o = 2 === i.dimensions || "1-2" === i.dimensions && Array.isArray(t1) && Array.isArray(t1[0]);
                            if (Array.isArray(t1)) {
                                var s, l, c, u, f, h, p = i.items, d = [], m = Array.isArray(p), g = m && o && Array.isArray(p[0]), v = o && m && !g, y = m && !v ? p.length : t1.length;
                                if (n = Array.isArray(n) ? n : [], o) for(s = 0; s < y; s++)for(d[s] = [], c = Array.isArray(t1[s]) ? t1[s] : [], f = v ? p.length : m ? p[s].length : c.length, l = 0; l < f; l++)u = v ? p[l] : m ? p[s][l] : p, void 0 !== (h = a(c[l], u, (n[s] || [])[l])) && (d[s][l] = h);
                                else for(s = 0; s < y; s++)void 0 !== (h = a(t1[s], m ? p[s] : p, n[s])) && (d[s] = h);
                                e1.set(d);
                            } else e1.set(n);
                        },
                        validateFunction: function(t1, e1) {
                            if (!Array.isArray(t1)) return !1;
                            var r = e1.items, n = Array.isArray(r), i = 2 === e1.dimensions;
                            if (!e1.freeLength && t1.length !== r.length) return !1;
                            for(var a = 0; a < t1.length; a++)if (i) {
                                if (!Array.isArray(t1[a]) || !e1.freeLength && t1[a].length !== r[a].length) return !1;
                                for(var o = 0; o < t1[a].length; o++)if (!p(t1[a][o], n ? r[a][o] : r)) return !1;
                            } else if (!p(t1[a], n ? r[a] : r)) return !1;
                            return !0;
                        }
                    }
                }, r.coerce = function(t1, e1, n, i, a) {
                    var o = c(n, i).get(), s = c(t1, i), l = c(e1, i), u = s.get(), f = e1._template;
                    if (void 0 === u && f && (u = c(f, i).get(), f = 0), void 0 === a && (a = o.dflt), o.arrayOk && h(u)) return l.set(u), u;
                    var d = r.valObjectMeta[o.valType].coerceFunction;
                    d(u, l, a, o);
                    var m = l.get();
                    return f && m === a && !p(u, o) && (d(u = c(f, i).get(), l, a, o), m = l.get()), m;
                }, r.coerce2 = function(t1, e1, n, i, a) {
                    var o = c(t1, i), s = r.coerce(t1, e1, n, i, a), l = o.get();
                    return null != l && s;
                }, r.coerceFont = function(t1, e1, r) {
                    var n = {};
                    return r = r || {}, n.family = t1(e1 + ".family", r.family), n.size = t1(e1 + ".size", r.size), n.color = t1(e1 + ".color", r.color), n;
                }, r.coercePattern = function(t1, e1, r, n) {
                    if (t1(e1 + ".shape")) {
                        t1(e1 + ".solidity"), t1(e1 + ".size");
                        var i = "overlay" === t1(e1 + ".fillmode");
                        if (!n) {
                            var a = t1(e1 + ".bgcolor", i ? r : void 0);
                            t1(e1 + ".fgcolor", i ? s.contrast(a) : r);
                        }
                        t1(e1 + ".fgopacity", i ? .5 : 1);
                    }
                }, r.coerceHoverinfo = function(t1, e1, n) {
                    var i, o = e1._module.attributes, s = o.hoverinfo ? o : a, l = s.hoverinfo;
                    if (1 === n._dataLength) {
                        var c = "all" === l.dflt ? l.flags.slice() : l.dflt.split("+");
                        c.splice(c.indexOf("name"), 1), i = c.join("+");
                    }
                    return r.coerce(t1, e1, s, "hoverinfo", i);
                }, r.coerceSelectionMarkerOpacity = function(t1, e1) {
                    if (t1.marker) {
                        var r, n, i = t1.marker.opacity;
                        if (void 0 !== i) h(i) || t1.selected || t1.unselected || (r = i, n = l * i), e1("selected.marker.opacity", r), e1("unselected.marker.opacity", n);
                    }
                }, r.validate = p;
            },
            {
                "../components/color": 366,
                "../components/colorscale/scales": 381,
                "../constants/interactions": 478,
                "../plots/attributes": 550,
                "./array": 485,
                "./mod": 510,
                "./nested_property": 511,
                "./regex": 520,
                "fast-isnumeric": 190,
                tinycolor2: 312
            }
        ],
        490: [
            function(t1, e1, r) {
                "use strict";
                var n, i, a = t1("d3-time-format").timeFormat, o = t1("fast-isnumeric"), s = t1("./loggers"), l = t1("./mod").mod, c = t1("../constants/numerical"), u = c.BADNUM, f = c.ONEDAY, h = c.ONEHOUR, p = c.ONEMIN, d = c.ONESEC, m = c.EPOCHJD, g = t1("../registry"), v = t1("d3-time-format").utcFormat, y = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m, x = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m, b = (new Date).getFullYear() - 70;
                function _(t1) {
                    return t1 && g.componentsRegistry.calendars && "string" == typeof t1 && "gregorian" !== t1;
                }
                function w(t1, e1) {
                    return String(t1 + Math.pow(10, e1)).substr(1);
                }
                r.dateTick0 = function(t1, e1) {
                    var n = function(t1, e1) {
                        return _(t1) ? e1 ? g.getComponentMethod("calendars", "CANONICAL_SUNDAY")[t1] : g.getComponentMethod("calendars", "CANONICAL_TICK")[t1] : e1 ? "2000-01-02" : "2000-01-01";
                    }(t1, !!e1);
                    if (e1 < 2) return n;
                    var i = r.dateTime2ms(n, t1);
                    return i += f * (e1 - 1), r.ms2DateTime(i, 0, t1);
                }, r.dfltRange = function(t1) {
                    return _(t1) ? g.getComponentMethod("calendars", "DFLTRANGE")[t1] : [
                        "2000-01-01",
                        "2001-01-01"
                    ];
                }, r.isJSDate = function(t1) {
                    return "object" == typeof t1 && null !== t1 && "function" == typeof t1.getTime;
                }, r.dateTime2ms = function(t1, e1) {
                    if (r.isJSDate(t1)) {
                        var a = t1.getTimezoneOffset() * p, o = (t1.getUTCMinutes() - t1.getMinutes()) * p + (t1.getUTCSeconds() - t1.getSeconds()) * d + (t1.getUTCMilliseconds() - t1.getMilliseconds());
                        if (o) {
                            var s = 3 * p;
                            a = a - s / 2 + l(o - a + s / 2, s);
                        }
                        return (t1 = Number(t1) - a) >= n && t1 <= i ? t1 : u;
                    }
                    if ("string" != typeof t1 && "number" != typeof t1) return u;
                    t1 = String(t1);
                    var c = _(e1), v = t1.charAt(0);
                    !c || "G" !== v && "g" !== v || (t1 = t1.substr(1), e1 = "");
                    var w = c && "chinese" === e1.substr(0, 7), T = t1.match(w ? x : y);
                    if (!T) return u;
                    var k = T[1], A = T[3] || "1", M = Number(T[5] || 1), S = Number(T[7] || 0), E = Number(T[9] || 0), L = Number(T[11] || 0);
                    if (c) {
                        if (2 === k.length) return u;
                        var C;
                        k = Number(k);
                        try {
                            var P = g.getComponentMethod("calendars", "getCal")(e1);
                            if (w) {
                                var I = "i" === A.charAt(A.length - 1);
                                A = parseInt(A, 10), C = P.newDate(k, P.toMonthIndex(k, A, I), M);
                            } else C = P.newDate(k, Number(A), M);
                        } catch (t1) {
                            return u;
                        }
                        return C ? (C.toJD() - m) * f + S * h + E * p + L * d : u;
                    }
                    k = 2 === k.length ? (Number(k) + 2e3 - b) % 100 + b : Number(k), A -= 1;
                    var O = new Date(Date.UTC(2e3, A, M, S, E));
                    return O.setUTCFullYear(k), O.getUTCMonth() !== A || O.getUTCDate() !== M ? u : O.getTime() + L * d;
                }, n = r.MIN_MS = r.dateTime2ms("-9999"), i = r.MAX_MS = r.dateTime2ms("9999-12-31 23:59:59.9999"), r.isDateTime = function(t1, e1) {
                    return r.dateTime2ms(t1, e1) !== u;
                };
                var T = 90 * f, k = 3 * h, A = 5 * p;
                function M(t1, e1, r, n, i) {
                    if ((e1 || r || n || i) && (t1 += " " + w(e1, 2) + ":" + w(r, 2), (n || i) && (t1 += ":" + w(n, 2), i))) {
                        for(var a = 4; i % 10 == 0;)a -= 1, i /= 10;
                        t1 += "." + w(i, a);
                    }
                    return t1;
                }
                r.ms2DateTime = function(t1, e1, r) {
                    if ("number" != typeof t1 || !(t1 >= n && t1 <= i)) return u;
                    e1 || (e1 = 0);
                    var a, o, s, c, y, x, b = Math.floor(10 * l(t1 + .05, 1)), w = Math.round(t1 - b / 10);
                    if (_(r)) {
                        var S = Math.floor(w / f) + m, E = Math.floor(l(t1, f));
                        try {
                            a = g.getComponentMethod("calendars", "getCal")(r).fromJD(S).formatDate("yyyy-mm-dd");
                        } catch (t1) {
                            a = v("G%Y-%m-%d")(new Date(w));
                        }
                        if ("-" === a.charAt(0)) for(; a.length < 11;)a = "-0" + a.substr(1);
                        else for(; a.length < 10;)a = "0" + a;
                        o = e1 < T ? Math.floor(E / h) : 0, s = e1 < T ? Math.floor(E % h / p) : 0, c = e1 < k ? Math.floor(E % p / d) : 0, y = e1 < A ? E % d * 10 + b : 0;
                    } else x = new Date(w), a = v("%Y-%m-%d")(x), o = e1 < T ? x.getUTCHours() : 0, s = e1 < T ? x.getUTCMinutes() : 0, c = e1 < k ? x.getUTCSeconds() : 0, y = e1 < A ? 10 * x.getUTCMilliseconds() + b : 0;
                    return M(a, o, s, c, y);
                }, r.ms2DateTimeLocal = function(t1) {
                    if (!(t1 >= n + f && t1 <= i - f)) return u;
                    var e1 = Math.floor(10 * l(t1 + .05, 1)), r = new Date(Math.round(t1 - e1 / 10));
                    return M(a("%Y-%m-%d")(r), r.getHours(), r.getMinutes(), r.getSeconds(), 10 * r.getUTCMilliseconds() + e1);
                }, r.cleanDate = function(t1, e1, n) {
                    if (t1 === u) return e1;
                    if (r.isJSDate(t1) || "number" == typeof t1 && isFinite(t1)) {
                        if (_(n)) return s.error("JS Dates and milliseconds are incompatible with world calendars", t1), e1;
                        if (!(t1 = r.ms2DateTimeLocal(+t1)) && void 0 !== e1) return e1;
                    } else if (!r.isDateTime(t1, n)) return s.error("unrecognized date", t1), e1;
                    return t1;
                };
                var S = /%\d?f/g, E = /%h/g, L = {
                    1: "1",
                    2: "1",
                    3: "2",
                    4: "2"
                };
                function C(t1, e1, r, n) {
                    t1 = t1.replace(S, function(t1) {
                        var r = Math.min(+t1.charAt(1) || 6, 6);
                        return (e1 / 1e3 % 1 + 2).toFixed(r).substr(2).replace(/0+$/, "") || "0";
                    });
                    var i = new Date(Math.floor(e1 + .05));
                    if (t1 = t1.replace(E, function() {
                        return L[r("%q")(i)];
                    }), _(n)) try {
                        t1 = g.getComponentMethod("calendars", "worldCalFmt")(t1, e1, n);
                    } catch (t1) {
                        return "Invalid";
                    }
                    return r(t1)(i);
                }
                var P = [
                    59,
                    59.9,
                    59.99,
                    59.999,
                    59.9999
                ];
                r.formatDate = function(t1, e1, r, n, i, a) {
                    if (i = _(i) && i, !e1) {
                        if ("y" === r) e1 = a.year;
                        else if ("m" === r) e1 = a.month;
                        else {
                            if ("d" !== r) return function(t1, e1) {
                                var r = l(t1 + .05, f), n = w(Math.floor(r / h), 2) + ":" + w(l(Math.floor(r / p), 60), 2);
                                if ("M" !== e1) {
                                    o(e1) || (e1 = 0);
                                    var i = (100 + Math.min(l(t1 / d, 60), P[e1])).toFixed(e1).substr(1);
                                    e1 > 0 && (i = i.replace(/0+$/, "").replace(/[\.]$/, "")), n += ":" + i;
                                }
                                return n;
                            }(t1, r) + "\n" + C(a.dayMonthYear, t1, n, i);
                            e1 = a.dayMonth + "\n" + a.year;
                        }
                    }
                    return C(e1, t1, n, i);
                };
                var I = 3 * f;
                r.incrementMonth = function(t1, e1, r) {
                    r = _(r) && r;
                    var n = l(t1, f);
                    if (t1 = Math.round(t1 - n), r) try {
                        var i = Math.round(t1 / f) + m, a = g.getComponentMethod("calendars", "getCal")(r), o = a.fromJD(i);
                        return e1 % 12 ? a.add(o, e1, "m") : a.add(o, e1 / 12, "y"), (o.toJD() - m) * f + n;
                    } catch (e1) {
                        s.error("invalid ms " + t1 + " in calendar " + r);
                    }
                    var c = new Date(t1 + I);
                    return c.setUTCMonth(c.getUTCMonth() + e1) + n - I;
                }, r.findExactDates = function(t1, e1) {
                    for(var r, n, i = 0, a = 0, s = 0, l = 0, c = _(e1) && g.getComponentMethod("calendars", "getCal")(e1), u = 0; u < t1.length; u++)if (n = t1[u], o(n)) {
                        if (!(n % f)) {
                            if (c) try {
                                1 === (r = c.fromJD(n / f + m)).day() ? 1 === r.month() ? i++ : a++ : s++;
                            } catch (t1) {}
                            else 1 === (r = new Date(n)).getUTCDate() ? 0 === r.getUTCMonth() ? i++ : a++ : s++;
                        }
                    } else l++;
                    s += a += i;
                    var h = t1.length - l;
                    return {
                        exactYears: i / h,
                        exactMonths: a / h,
                        exactDays: s / h
                    };
                };
            },
            {
                "../constants/numerical": 479,
                "../registry": 638,
                "./loggers": 507,
                "./mod": 510,
                "d3-time-format": 120,
                "fast-isnumeric": 190
            }
        ],
        491: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("./loggers"), a = t1("./matrix"), o = t1("gl-mat4");
                function s(t1) {
                    var e1 = t1 && t1.parentNode;
                    e1 && e1.removeChild(t1);
                }
                function l(t1, e1, r) {
                    var n = "plotly.js-style-" + t1, a = document.getElementById(n);
                    a || ((a = document.createElement("style")).setAttribute("id", n), a.appendChild(document.createTextNode("")), document.head.appendChild(a));
                    var o = a.sheet;
                    o.insertRule ? o.insertRule(e1 + "{" + r + "}", 0) : o.addRule ? o.addRule(e1, r, 0) : i.warn("addStyleRule failed");
                }
                function c(t1) {
                    var e1 = window.getComputedStyle(t1, null), r = e1.getPropertyValue("-webkit-transform") || e1.getPropertyValue("-moz-transform") || e1.getPropertyValue("-ms-transform") || e1.getPropertyValue("-o-transform") || e1.getPropertyValue("transform");
                    return "none" === r ? null : r.replace("matrix", "").replace("3d", "").slice(1, -1).split(",").map(function(t1) {
                        return +t1;
                    });
                }
                function u(t1) {
                    for(var e1 = []; f(t1);)e1.push(t1), t1 = t1.parentNode;
                    return e1;
                }
                function f(t1) {
                    return t1 && (t1 instanceof Element || t1 instanceof HTMLElement);
                }
                e1.exports = {
                    getGraphDiv: function(t1) {
                        var e1;
                        if ("string" == typeof t1) {
                            if (null === (e1 = document.getElementById(t1))) throw new Error("No DOM element with id '" + t1 + "' exists on the page.");
                            return e1;
                        }
                        if (null == t1) throw new Error("DOM element provided is null or undefined");
                        return t1;
                    },
                    isPlotDiv: function(t1) {
                        var e1 = n.select(t1);
                        return e1.node() instanceof HTMLElement && e1.size() && e1.classed("js-plotly-plot");
                    },
                    removeElement: s,
                    addStyleRule: function(t1, e1) {
                        l("global", t1, e1);
                    },
                    addRelatedStyleRule: l,
                    deleteRelatedStyleRule: function(t1) {
                        var e1 = "plotly.js-style-" + t1, r = document.getElementById(e1);
                        r && s(r);
                    },
                    getFullTransformMatrix: function(t1) {
                        var e1 = u(t1), r = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ];
                        return e1.forEach(function(t1) {
                            var e1 = c(t1);
                            if (e1) {
                                var n = a.convertCssMatrix(e1);
                                r = o.multiply(r, r, n);
                            }
                        }), r;
                    },
                    getElementTransformMatrix: c,
                    getElementAndAncestors: u,
                    equalDomRects: function(t1, e1) {
                        return t1 && e1 && t1.x === e1.x && t1.y === e1.y && t1.top === e1.top && t1.left === e1.left && t1.right === e1.right && t1.bottom === e1.bottom;
                    }
                };
            },
            {
                "./loggers": 507,
                "./matrix": 509,
                "@plotly/d3": 58,
                "gl-mat4": 210
            }
        ],
        492: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("events").EventEmitter, i = {
                    init: function(t1) {
                        if (t1._ev instanceof n) return t1;
                        var e1 = new n, r = new n;
                        return t1._ev = e1, t1._internalEv = r, t1.on = e1.on.bind(e1), t1.once = e1.once.bind(e1), t1.removeListener = e1.removeListener.bind(e1), t1.removeAllListeners = e1.removeAllListeners.bind(e1), t1._internalOn = r.on.bind(r), t1._internalOnce = r.once.bind(r), t1._removeInternalListener = r.removeListener.bind(r), t1._removeAllInternalListeners = r.removeAllListeners.bind(r), t1.emit = function(n, i) {
                            "undefined" != typeof jQuery && jQuery(t1).trigger(n, i), e1.emit(n, i), r.emit(n, i);
                        }, t1;
                    },
                    triggerHandler: function(t1, e1, r) {
                        var n, i;
                        "undefined" != typeof jQuery && (n = jQuery(t1).triggerHandler(e1, r));
                        var a = t1._ev;
                        if (!a) return n;
                        var o, s = a._events[e1];
                        if (!s) return n;
                        function l(t1) {
                            return t1.listener ? (a.removeListener(e1, t1.listener), t1.fired ? void 0 : (t1.fired = !0, t1.listener.apply(a, [
                                r
                            ]))) : t1.apply(a, [
                                r
                            ]);
                        }
                        for(s = Array.isArray(s) ? s : [
                            s
                        ], o = 0; o < s.length - 1; o++)l(s[o]);
                        return i = l(s[o]), void 0 !== n ? n : i;
                    },
                    purge: function(t1) {
                        return delete t1._ev, delete t1.on, delete t1.once, delete t1.removeListener, delete t1.removeAllListeners, delete t1.emit, delete t1._ev, delete t1._internalEv, delete t1._internalOn, delete t1._internalOnce, delete t1._removeInternalListener, delete t1._removeAllInternalListeners, t1;
                    }
                };
                e1.exports = i;
            },
            {
                events: 84
            }
        ],
        493: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./is_plain_object.js"), i = Array.isArray;
                function a(t1, e1, r, o) {
                    var s, l, c, u, f, h, p = t1[0], d = t1.length;
                    if (2 === d && i(p) && i(t1[1]) && 0 === p.length) {
                        if (function(t1, e1) {
                            var r, n;
                            for(r = 0; r < t1.length; r++){
                                if (null !== (n = t1[r]) && "object" == typeof n) return !1;
                                void 0 !== n && (e1[r] = n);
                            }
                            return !0;
                        }(t1[1], p)) return p;
                        p.splice(0, p.length);
                    }
                    for(var m = 1; m < d; m++)for(l in s = t1[m])c = p[l], u = s[l], o && i(u) ? p[l] = u : e1 && u && (n(u) || (f = i(u))) ? (f ? (f = !1, h = c && i(c) ? c : []) : h = c && n(c) ? c : {}, p[l] = a([
                        h,
                        u
                    ], e1, r, o)) : (void 0 !== u || r) && (p[l] = u);
                    return p;
                }
                r.extendFlat = function() {
                    return a(arguments, !1, !1, !1);
                }, r.extendDeep = function() {
                    return a(arguments, !0, !1, !1);
                }, r.extendDeepAll = function() {
                    return a(arguments, !0, !0, !1);
                }, r.extendDeepNoArrays = function() {
                    return a(arguments, !0, !1, !0);
                };
            },
            {
                "./is_plain_object.js": 504
            }
        ],
        494: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    for(var e1 = {}, r = [], n = 0, i = 0; i < t1.length; i++){
                        var a = t1[i];
                        1 !== e1[a] && (e1[a] = 1, r[n++] = a);
                    }
                    return r;
                };
            },
            {}
        ],
        495: [
            function(t1, e1, r) {
                "use strict";
                function n(t1) {
                    return !0 === t1.visible;
                }
                function i(t1) {
                    var e1 = t1[0].trace;
                    return !0 === e1.visible && 0 !== e1._length;
                }
                e1.exports = function(t1) {
                    for(var e1, r = (e1 = t1, Array.isArray(e1) && Array.isArray(e1[0]) && e1[0][0] && e1[0][0].trace ? i : n), a = [], o = 0; o < t1.length; o++){
                        var s = t1[o];
                        r(s) && a.push(s);
                    }
                    return a;
                };
            },
            {}
        ],
        496: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("country-regex"), a = t1("@turf/area"), o = t1("@turf/centroid"), s = t1("@turf/bbox"), l = t1("./identity"), c = t1("./loggers"), u = t1("./is_plain_object"), f = t1("./nested_property"), h = t1("./polygon"), p = Object.keys(i), d = {
                    "ISO-3": l,
                    "USA-states": l,
                    "country names": function(t1) {
                        for(var e1 = 0; e1 < p.length; e1++){
                            var r = p[e1];
                            if (new RegExp(i[r]).test(t1.trim().toLowerCase())) return r;
                        }
                        return c.log("Unrecognized country name: " + t1 + "."), !1;
                    }
                };
                function m(t1) {
                    var e1 = t1.geojson, r = window.PlotlyGeoAssets || {}, n = "string" == typeof e1 ? r[e1] : e1;
                    return u(n) ? n : (c.error("Oops ... something went wrong when fetching " + e1), !1);
                }
                e1.exports = {
                    locationToFeature: function(t1, e1, r) {
                        if (!e1 || "string" != typeof e1) return !1;
                        var n, i, a, o = d[t1](e1);
                        if (o) {
                            if ("USA-states" === t1) for(n = [], a = 0; a < r.length; a++)(i = r[a]).properties && i.properties.gu && "USA" === i.properties.gu && n.push(i);
                            else n = r;
                            for(a = 0; a < n.length; a++)if ((i = n[a]).id === o) return i;
                            c.log([
                                "Location with id",
                                o,
                                "does not have a matching topojson feature at this resolution."
                            ].join(" "));
                        }
                        return !1;
                    },
                    feature2polygons: function(t1) {
                        var e1, r, n, i, a = t1.geometry, o = a.coordinates, s = t1.id, l = [];
                        function c(t1) {
                            for(var e1 = 0; e1 < t1.length - 1; e1++)if (t1[e1][0] > 0 && t1[e1 + 1][0] < 0) return e1;
                            return null;
                        }
                        switch(e1 = "RUS" === s || "FJI" === s ? function(t1) {
                            var e1;
                            if (null === c(t1)) e1 = t1;
                            else for(e1 = new Array(t1.length), i = 0; i < t1.length; i++)e1[i] = [
                                t1[i][0] < 0 ? t1[i][0] + 360 : t1[i][0],
                                t1[i][1]
                            ];
                            l.push(h.tester(e1));
                        } : "ATA" === s ? function(t1) {
                            var e1 = c(t1);
                            if (null === e1) return l.push(h.tester(t1));
                            var r = new Array(t1.length + 1), n = 0;
                            for(i = 0; i < t1.length; i++)i > e1 ? r[n++] = [
                                t1[i][0] + 360,
                                t1[i][1]
                            ] : i === e1 ? (r[n++] = t1[i], r[n++] = [
                                t1[i][0],
                                -90
                            ]) : r[n++] = t1[i];
                            var a = h.tester(r);
                            a.pts.pop(), l.push(a);
                        } : function(t1) {
                            l.push(h.tester(t1));
                        }, a.type){
                            case "MultiPolygon":
                                for(r = 0; r < o.length; r++)for(n = 0; n < o[r].length; n++)e1(o[r][n]);
                                break;
                            case "Polygon":
                                for(r = 0; r < o.length; r++)e1(o[r]);
                        }
                        return l;
                    },
                    getTraceGeojson: m,
                    extractTraceFeature: function(t1) {
                        var e1 = t1[0].trace, r = m(e1);
                        if (!r) return !1;
                        var n, i = {}, s = [];
                        for(n = 0; n < e1._length; n++){
                            var l = t1[n];
                            (l.loc || 0 === l.loc) && (i[l.loc] = l);
                        }
                        function u(t1) {
                            var r = f(t1, e1.featureidkey || "id").get(), n = i[r];
                            if (n) {
                                var l = t1.geometry;
                                if ("Polygon" === l.type || "MultiPolygon" === l.type) {
                                    var u = {
                                        type: "Feature",
                                        id: r,
                                        geometry: l,
                                        properties: {}
                                    };
                                    u.properties.ct = function(t1) {
                                        var e1, r = t1.geometry;
                                        if ("MultiPolygon" === r.type) for(var n = r.coordinates, i = 0, s = 0; s < n.length; s++){
                                            var l = {
                                                type: "Polygon",
                                                coordinates: n[s]
                                            }, c = a.default(l);
                                            c > i && (i = c, e1 = l);
                                        }
                                        else e1 = r;
                                        return o.default(e1).geometry.coordinates;
                                    }(u), n.fIn = t1, n.fOut = u, s.push(u);
                                } else c.log([
                                    "Location",
                                    n.loc,
                                    "does not have a valid GeoJSON geometry.",
                                    "Traces with locationmode *geojson-id* only support",
                                    "*Polygon* and *MultiPolygon* geometries."
                                ].join(" "));
                            }
                            delete i[r];
                        }
                        switch(r.type){
                            case "FeatureCollection":
                                var h = r.features;
                                for(n = 0; n < h.length; n++)u(h[n]);
                                break;
                            case "Feature":
                                u(r);
                                break;
                            default:
                                return c.warn([
                                    "Invalid GeoJSON type",
                                    (r.type || "none") + ".",
                                    "Traces with locationmode *geojson-id* only support",
                                    "*FeatureCollection* and *Feature* types."
                                ].join(" ")), !1;
                        }
                        for(var p in i)c.log([
                            "Location *" + p + "*",
                            "does not have a matching feature with id-key",
                            "*" + e1.featureidkey + "*."
                        ].join(" "));
                        return s;
                    },
                    fetchTraceGeoData: function(t1) {
                        var e1 = window.PlotlyGeoAssets || {}, r = [];
                        function i(t1) {
                            return new Promise(function(r, i) {
                                n.json(t1, function(n, a) {
                                    if (n) {
                                        delete e1[t1];
                                        var o = 404 === n.status ? 'GeoJSON at URL "' + t1 + '" does not exist.' : "Unexpected error while fetching from " + t1;
                                        return i(new Error(o));
                                    }
                                    return e1[t1] = a, r(a);
                                });
                            });
                        }
                        function a(t1) {
                            return new Promise(function(r, n) {
                                var i = 0, a = setInterval(function() {
                                    return e1[t1] && "pending" !== e1[t1] ? (clearInterval(a), r(e1[t1])) : i > 100 ? (clearInterval(a), n("Unexpected error while fetching from " + t1)) : void i++;
                                }, 50);
                            });
                        }
                        for(var o = 0; o < t1.length; o++){
                            var s = t1[o][0].trace.geojson;
                            "string" == typeof s && (e1[s] ? "pending" === e1[s] && r.push(a(s)) : (e1[s] = "pending", r.push(i(s))));
                        }
                        return r;
                    },
                    computeBbox: function(t1) {
                        return s.default(t1);
                    }
                };
            },
            {
                "./identity": 501,
                "./is_plain_object": 504,
                "./loggers": 507,
                "./nested_property": 511,
                "./polygon": 515,
                "@plotly/d3": 58,
                "@turf/area": 61,
                "@turf/bbox": 64,
                "@turf/centroid": 67,
                "country-regex": 94
            }
        ],
        497: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../constants/numerical").BADNUM;
                r.calcTraceToLineCoords = function(t1) {
                    for(var e1 = t1[0].trace.connectgaps, r = [], i = [], a = 0; a < t1.length; a++){
                        var o = t1[a].lonlat;
                        o[0] !== n ? i.push(o) : !e1 && i.length > 0 && (r.push(i), i = []);
                    }
                    return i.length > 0 && r.push(i), r;
                }, r.makeLine = function(t1) {
                    return 1 === t1.length ? {
                        type: "LineString",
                        coordinates: t1[0]
                    } : {
                        type: "MultiLineString",
                        coordinates: t1
                    };
                }, r.makePolygon = function(t1) {
                    if (1 === t1.length) return {
                        type: "Polygon",
                        coordinates: t1
                    };
                    for(var e1 = new Array(t1.length), r = 0; r < t1.length; r++)e1[r] = [
                        t1[r]
                    ];
                    return {
                        type: "MultiPolygon",
                        coordinates: e1
                    };
                }, r.makeBlank = function() {
                    return {
                        type: "Point",
                        coordinates: []
                    };
                };
            },
            {
                "../constants/numerical": 479
            }
        ],
        498: [
            function(t1, e1, r) {
                "use strict";
                var n, i, a, o = t1("./mod").mod;
                function s(t1, e1, r, n, i, a, o, s) {
                    var l = r - t1, c = i - t1, u = o - i, f = n - e1, h = a - e1, p = s - a, d = l * p - u * f;
                    if (0 === d) return null;
                    var m = (c * p - u * h) / d, g = (c * f - l * h) / d;
                    return g < 0 || g > 1 || m < 0 || m > 1 ? null : {
                        x: t1 + l * m,
                        y: e1 + f * m
                    };
                }
                function l(t1, e1, r, n, i) {
                    var a = n * t1 + i * e1;
                    if (a < 0) return n * n + i * i;
                    if (a > r) {
                        var o = n - t1, s = i - e1;
                        return o * o + s * s;
                    }
                    var l = n * e1 - i * t1;
                    return l * l / r;
                }
                r.segmentsIntersect = s, r.segmentDistance = function(t1, e1, r, n, i, a, o, c) {
                    if (s(t1, e1, r, n, i, a, o, c)) return 0;
                    var u = r - t1, f = n - e1, h = o - i, p = c - a, d = u * u + f * f, m = h * h + p * p, g = Math.min(l(u, f, d, i - t1, a - e1), l(u, f, d, o - t1, c - e1), l(h, p, m, t1 - i, e1 - a), l(h, p, m, r - i, n - a));
                    return Math.sqrt(g);
                }, r.getTextLocation = function(t1, e1, r, s) {
                    if (t1 === i && s === a || (n = {}, i = t1, a = s), n[r]) return n[r];
                    var l = t1.getPointAtLength(o(r - s / 2, e1)), c = t1.getPointAtLength(o(r + s / 2, e1)), u = Math.atan((c.y - l.y) / (c.x - l.x)), f = t1.getPointAtLength(o(r, e1)), h = {
                        x: (4 * f.x + l.x + c.x) / 6,
                        y: (4 * f.y + l.y + c.y) / 6,
                        theta: u
                    };
                    return n[r] = h, h;
                }, r.clearLocationCache = function() {
                    i = null;
                }, r.getVisibleSegment = function(t1, e1, r) {
                    var n, i, a = e1.left, o = e1.right, s = e1.top, l = e1.bottom, c = 0, u = t1.getTotalLength(), f = u;
                    function h(e1) {
                        var r = t1.getPointAtLength(e1);
                        0 === e1 ? n = r : e1 === u && (i = r);
                        var c = r.x < a ? a - r.x : r.x > o ? r.x - o : 0, f = r.y < s ? s - r.y : r.y > l ? r.y - l : 0;
                        return Math.sqrt(c * c + f * f);
                    }
                    for(var p = h(c); p;){
                        if ((c += p + r) > f) return;
                        p = h(c);
                    }
                    for(p = h(f); p;){
                        if (c > (f -= p + r)) return;
                        p = h(f);
                    }
                    return {
                        min: c,
                        max: f,
                        len: f - c,
                        total: u,
                        isClosed: 0 === c && f === u && Math.abs(n.x - i.x) < .1 && Math.abs(n.y - i.y) < .1
                    };
                }, r.findPointOnPath = function(t1, e1, r, n) {
                    for(var i, a, o, s = (n = n || {}).pathLength || t1.getTotalLength(), l = n.tolerance || .001, c = n.iterationLimit || 30, u = t1.getPointAtLength(0)[r] > t1.getPointAtLength(s)[r] ? -1 : 1, f = 0, h = 0, p = s; f < c;){
                        if (i = (h + p) / 2, o = (a = t1.getPointAtLength(i))[r] - e1, Math.abs(o) < l) return a;
                        u * o > 0 ? p = i : h = i, f++;
                    }
                    return a;
                };
            },
            {
                "./mod": 510
            }
        ],
        499: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("tinycolor2"), a = t1("color-normalize"), o = t1("../components/colorscale"), s = t1("../components/color/attributes").defaultLine, l = t1("./array").isArrayOrTypedArray, c = a(s);
                function u(t1, e1) {
                    var r = t1;
                    return r[3] *= e1, r;
                }
                function f(t1) {
                    if (n(t1)) return c;
                    var e1 = a(t1);
                    return e1.length ? e1 : c;
                }
                function h(t1) {
                    return n(t1) ? t1 : 1;
                }
                e1.exports = {
                    formatColor: function(t1, e1, r) {
                        var n, i, s, p, d, m = t1.color, g = l(m), v = l(e1), y = o.extractOpts(t1), x = [];
                        if (n = void 0 !== y.colorscale ? o.makeColorScaleFuncFromTrace(t1) : f, i = g ? function(t1, e1) {
                            return void 0 === t1[e1] ? c : a(n(t1[e1]));
                        } : f, s = v ? function(t1, e1) {
                            return void 0 === t1[e1] ? 1 : h(t1[e1]);
                        } : h, g || v) for(var b = 0; b < r; b++)p = i(m, b), d = s(e1, b), x[b] = u(p, d);
                        else x = u(a(m), e1);
                        return x;
                    },
                    parseColorScale: function(t1) {
                        var e1 = o.extractOpts(t1), r = e1.colorscale;
                        return e1.reversescale && (r = o.flipScale(e1.colorscale)), r.map(function(t1) {
                            var e1 = t1[0], r = i(t1[1]).toRgb();
                            return {
                                index: e1,
                                rgb: [
                                    r.r,
                                    r.g,
                                    r.b,
                                    r.a
                                ]
                            };
                        });
                    }
                };
            },
            {
                "../components/color/attributes": 365,
                "../components/colorscale": 378,
                "./array": 485,
                "color-normalize": 89,
                "fast-isnumeric": 190,
                tinycolor2: 312
            }
        ],
        500: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./identity");
                function i(t1) {
                    return [
                        t1
                    ];
                }
                e1.exports = {
                    keyFun: function(t1) {
                        return t1.key;
                    },
                    repeat: i,
                    descend: n,
                    wrap: i,
                    unwrap: function(t1) {
                        return t1[0];
                    }
                };
            },
            {
                "./identity": 501
            }
        ],
        501: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    return t1;
                };
            },
            {}
        ],
        502: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    if (!e1) return t1;
                    var r = 1 / Math.abs(e1), n = r > 1 ? (r * t1 + r * e1) / r : t1 + e1, i = String(n).length;
                    if (i > 16) {
                        var a = String(e1).length;
                        if (i >= String(t1).length + a) {
                            var o = parseFloat(n).toPrecision(12);
                            -1 === o.indexOf("e+") && (n = +o);
                        }
                    }
                    return n;
                };
            },
            {}
        ],
        503: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("d3-time-format").utcFormat, a = t1("d3-format").format, o = t1("fast-isnumeric"), s = t1("../constants/numerical"), l = s.FP_SAFE, c = -l, u = s.BADNUM, f = e1.exports = {};
                f.adjustFormat = function(t1) {
                    return !t1 || /^\d[.]\df/.test(t1) || /[.]\d%/.test(t1) ? t1 : "0.f" === t1 ? "~f" : /^\d%/.test(t1) ? "~%" : /^\ds/.test(t1) ? "~s" : !/^[~,.0$]/.test(t1) && /[&fps]/.test(t1) ? "~" + t1 : t1;
                };
                var h = {};
                f.warnBadFormat = function(t1) {
                    var e1 = String(t1);
                    h[e1] || (h[e1] = 1, f.warn('encountered bad format: "' + e1 + '"'));
                }, f.noFormat = function(t1) {
                    return String(t1);
                }, f.numberFormat = function(t1) {
                    var e1;
                    try {
                        e1 = a(f.adjustFormat(t1));
                    } catch (e1) {
                        return f.warnBadFormat(t1), f.noFormat;
                    }
                    return e1;
                }, f.nestedProperty = t1("./nested_property"), f.keyedContainer = t1("./keyed_container"), f.relativeAttr = t1("./relative_attr"), f.isPlainObject = t1("./is_plain_object"), f.toLogRange = t1("./to_log_range"), f.relinkPrivateKeys = t1("./relink_private");
                var p = t1("./array");
                f.isTypedArray = p.isTypedArray, f.isArrayOrTypedArray = p.isArrayOrTypedArray, f.isArray1D = p.isArray1D, f.ensureArray = p.ensureArray, f.concat = p.concat, f.maxRowLength = p.maxRowLength, f.minRowLength = p.minRowLength;
                var d = t1("./mod");
                f.mod = d.mod, f.modHalf = d.modHalf;
                var m = t1("./coerce");
                f.valObjectMeta = m.valObjectMeta, f.coerce = m.coerce, f.coerce2 = m.coerce2, f.coerceFont = m.coerceFont, f.coercePattern = m.coercePattern, f.coerceHoverinfo = m.coerceHoverinfo, f.coerceSelectionMarkerOpacity = m.coerceSelectionMarkerOpacity, f.validate = m.validate;
                var g = t1("./dates");
                f.dateTime2ms = g.dateTime2ms, f.isDateTime = g.isDateTime, f.ms2DateTime = g.ms2DateTime, f.ms2DateTimeLocal = g.ms2DateTimeLocal, f.cleanDate = g.cleanDate, f.isJSDate = g.isJSDate, f.formatDate = g.formatDate, f.incrementMonth = g.incrementMonth, f.dateTick0 = g.dateTick0, f.dfltRange = g.dfltRange, f.findExactDates = g.findExactDates, f.MIN_MS = g.MIN_MS, f.MAX_MS = g.MAX_MS;
                var v = t1("./search");
                f.findBin = v.findBin, f.sorterAsc = v.sorterAsc, f.sorterDes = v.sorterDes, f.distinctVals = v.distinctVals, f.roundUp = v.roundUp, f.sort = v.sort, f.findIndexOfMin = v.findIndexOfMin, f.sortObjectKeys = t1("./sort_object_keys");
                var y = t1("./stats");
                f.aggNums = y.aggNums, f.len = y.len, f.mean = y.mean, f.median = y.median, f.midRange = y.midRange, f.variance = y.variance, f.stdev = y.stdev, f.interp = y.interp;
                var x = t1("./matrix");
                f.init2dArray = x.init2dArray, f.transposeRagged = x.transposeRagged, f.dot = x.dot, f.translationMatrix = x.translationMatrix, f.rotationMatrix = x.rotationMatrix, f.rotationXYMatrix = x.rotationXYMatrix, f.apply3DTransform = x.apply3DTransform, f.apply2DTransform = x.apply2DTransform, f.apply2DTransform2 = x.apply2DTransform2, f.convertCssMatrix = x.convertCssMatrix, f.inverseTransformMatrix = x.inverseTransformMatrix;
                var b = t1("./angles");
                f.deg2rad = b.deg2rad, f.rad2deg = b.rad2deg, f.angleDelta = b.angleDelta, f.angleDist = b.angleDist, f.isFullCircle = b.isFullCircle, f.isAngleInsideSector = b.isAngleInsideSector, f.isPtInsideSector = b.isPtInsideSector, f.pathArc = b.pathArc, f.pathSector = b.pathSector, f.pathAnnulus = b.pathAnnulus;
                var _ = t1("./anchor_utils");
                f.isLeftAnchor = _.isLeftAnchor, f.isCenterAnchor = _.isCenterAnchor, f.isRightAnchor = _.isRightAnchor, f.isTopAnchor = _.isTopAnchor, f.isMiddleAnchor = _.isMiddleAnchor, f.isBottomAnchor = _.isBottomAnchor;
                var w = t1("./geometry2d");
                f.segmentsIntersect = w.segmentsIntersect, f.segmentDistance = w.segmentDistance, f.getTextLocation = w.getTextLocation, f.clearLocationCache = w.clearLocationCache, f.getVisibleSegment = w.getVisibleSegment, f.findPointOnPath = w.findPointOnPath;
                var T = t1("./extend");
                f.extendFlat = T.extendFlat, f.extendDeep = T.extendDeep, f.extendDeepAll = T.extendDeepAll, f.extendDeepNoArrays = T.extendDeepNoArrays;
                var k = t1("./loggers");
                f.log = k.log, f.warn = k.warn, f.error = k.error;
                var A = t1("./regex");
                f.counterRegex = A.counter;
                var M = t1("./throttle");
                f.throttle = M.throttle, f.throttleDone = M.done, f.clearThrottle = M.clear;
                var S = t1("./dom");
                function E(t1) {
                    var e1 = {};
                    for(var r in t1)for(var n = t1[r], i = 0; i < n.length; i++)e1[n[i]] = +r;
                    return e1;
                }
                f.getGraphDiv = S.getGraphDiv, f.isPlotDiv = S.isPlotDiv, f.removeElement = S.removeElement, f.addStyleRule = S.addStyleRule, f.addRelatedStyleRule = S.addRelatedStyleRule, f.deleteRelatedStyleRule = S.deleteRelatedStyleRule, f.getFullTransformMatrix = S.getFullTransformMatrix, f.getElementTransformMatrix = S.getElementTransformMatrix, f.getElementAndAncestors = S.getElementAndAncestors, f.equalDomRects = S.equalDomRects, f.clearResponsive = t1("./clear_responsive"), f.preserveDrawingBuffer = t1("./preserve_drawing_buffer"), f.makeTraceGroups = t1("./make_trace_groups"), f._ = t1("./localize"), f.notifier = t1("./notifier"), f.filterUnique = t1("./filter_unique"), f.filterVisible = t1("./filter_visible"), f.pushUnique = t1("./push_unique"), f.increment = t1("./increment"), f.cleanNumber = t1("./clean_number"), f.ensureNumber = function(t1) {
                    return o(t1) ? (t1 = Number(t1)) > l || t1 < c ? u : t1 : u;
                }, f.isIndex = function(t1, e1) {
                    return !(void 0 !== e1 && t1 >= e1) && o(t1) && t1 >= 0 && t1 % 1 == 0;
                }, f.noop = t1("./noop"), f.identity = t1("./identity"), f.repeat = function(t1, e1) {
                    for(var r = new Array(e1), n = 0; n < e1; n++)r[n] = t1;
                    return r;
                }, f.swapAttrs = function(t1, e1, r, n) {
                    r || (r = "x"), n || (n = "y");
                    for(var i = 0; i < e1.length; i++){
                        var a = e1[i], o = f.nestedProperty(t1, a.replace("?", r)), s = f.nestedProperty(t1, a.replace("?", n)), l = o.get();
                        o.set(s.get()), s.set(l);
                    }
                }, f.raiseToTop = function(t1) {
                    t1.parentNode.appendChild(t1);
                }, f.cancelTransition = function(t1) {
                    return t1.transition().duration(0);
                }, f.constrain = function(t1, e1, r) {
                    return e1 > r ? Math.max(r, Math.min(e1, t1)) : Math.max(e1, Math.min(r, t1));
                }, f.bBoxIntersect = function(t1, e1, r) {
                    return r = r || 0, t1.left <= e1.right + r && e1.left <= t1.right + r && t1.top <= e1.bottom + r && e1.top <= t1.bottom + r;
                }, f.simpleMap = function(t1, e1, r, n, i) {
                    for(var a = t1.length, o = new Array(a), s = 0; s < a; s++)o[s] = e1(t1[s], r, n, i);
                    return o;
                }, f.randstr = function t1(e1, r, n, i) {
                    if (n || (n = 16), void 0 === r && (r = 24), r <= 0) return "0";
                    var a, o, s = Math.log(Math.pow(2, r)) / Math.log(n), l = "";
                    for(a = 2; s === 1 / 0; a *= 2)s = Math.log(Math.pow(2, r / a)) / Math.log(n) * a;
                    var c = s - Math.floor(s);
                    for(a = 0; a < Math.floor(s); a++)l = Math.floor(Math.random() * n).toString(n) + l;
                    c && (o = Math.pow(n, c), l = Math.floor(Math.random() * o).toString(n) + l);
                    var u = parseInt(l, n);
                    return e1 && e1[l] || u !== 1 / 0 && u >= Math.pow(2, r) ? i > 10 ? (f.warn("randstr failed uniqueness"), l) : t1(e1, r, n, (i || 0) + 1) : l;
                }, f.OptionControl = function(t1, e1) {
                    t1 || (t1 = {}), e1 || (e1 = "opt");
                    var r = {
                        optionList: [],
                        _newoption: function(n) {
                            n[e1] = t1, r[n.name] = n, r.optionList.push(n);
                        }
                    };
                    return r["_" + e1] = t1, r;
                }, f.smooth = function(t1, e1) {
                    if ((e1 = Math.round(e1) || 0) < 2) return t1;
                    var r, n, i, a, o = t1.length, s = 2 * o, l = 2 * e1 - 1, c = new Array(l), u = new Array(o);
                    for(r = 0; r < l; r++)c[r] = (1 - Math.cos(Math.PI * (r + 1) / e1)) / (2 * e1);
                    for(r = 0; r < o; r++){
                        for(a = 0, n = 0; n < l; n++)(i = r + n + 1 - e1) < -o ? i -= s * Math.round(i / s) : i >= s && (i -= s * Math.floor(i / s)), i < 0 ? i = -1 - i : i >= o && (i = s - 1 - i), a += t1[i] * c[n];
                        u[r] = a;
                    }
                    return u;
                }, f.syncOrAsync = function(t1, e1, r) {
                    var n;
                    function i() {
                        return f.syncOrAsync(t1, e1, r);
                    }
                    for(; t1.length;)if ((n = (0, t1.splice(0, 1)[0])(e1)) && n.then) return n.then(i);
                    return r && r(e1);
                }, f.stripTrailingSlash = function(t1) {
                    return "/" === t1.substr(-1) ? t1.substr(0, t1.length - 1) : t1;
                }, f.noneOrAll = function(t1, e1, r) {
                    if (t1) {
                        var n, i = !1, a = !0;
                        for(n = 0; n < r.length; n++)null != t1[r[n]] ? i = !0 : a = !1;
                        if (i && !a) for(n = 0; n < r.length; n++)t1[r[n]] = e1[r[n]];
                    }
                }, f.mergeArray = function(t1, e1, r, n) {
                    var i = "function" == typeof n;
                    if (f.isArrayOrTypedArray(t1)) for(var a = Math.min(t1.length, e1.length), o = 0; o < a; o++){
                        var s = t1[o];
                        e1[o][r] = i ? n(s) : s;
                    }
                }, f.mergeArrayCastPositive = function(t1, e1, r) {
                    return f.mergeArray(t1, e1, r, function(t1) {
                        var e1 = +t1;
                        return isFinite(e1) && e1 > 0 ? e1 : 0;
                    });
                }, f.fillArray = function(t1, e1, r, n) {
                    if (n = n || f.identity, f.isArrayOrTypedArray(t1)) for(var i = 0; i < e1.length; i++)e1[i][r] = n(t1[i]);
                }, f.castOption = function(t1, e1, r, n) {
                    n = n || f.identity;
                    var i = f.nestedProperty(t1, r).get();
                    return f.isArrayOrTypedArray(i) ? Array.isArray(e1) && f.isArrayOrTypedArray(i[e1[0]]) ? n(i[e1[0]][e1[1]]) : n(i[e1]) : i;
                }, f.extractOption = function(t1, e1, r, n) {
                    if (r in t1) return t1[r];
                    var i = f.nestedProperty(e1, n).get();
                    return Array.isArray(i) ? void 0 : i;
                }, f.tagSelected = function(t1, e1, r) {
                    var n, i, a = e1.selectedpoints, o = e1._indexToPoints;
                    o && (n = E(o));
                    for(var s = 0; s < a.length; s++){
                        var l = a[s];
                        if (f.isIndex(l) || f.isArrayOrTypedArray(l) && f.isIndex(l[0]) && f.isIndex(l[1])) {
                            var c = n ? n[l] : l, u = r ? r[c] : c;
                            void 0 !== (i = u) && i < t1.length && (t1[u].selected = 1);
                        }
                    }
                }, f.selIndices2selPoints = function(t1) {
                    var e1 = t1.selectedpoints, r = t1._indexToPoints;
                    if (r) {
                        for(var n = E(r), i = [], a = 0; a < e1.length; a++){
                            var o = e1[a];
                            if (f.isIndex(o)) {
                                var s = n[o];
                                f.isIndex(s) && i.push(s);
                            }
                        }
                        return i;
                    }
                    return e1;
                }, f.getTargetArray = function(t1, e1) {
                    var r = e1.target;
                    if ("string" == typeof r && r) {
                        var n = f.nestedProperty(t1, r).get();
                        return !!Array.isArray(n) && n;
                    }
                    return !!Array.isArray(r) && r;
                }, f.minExtend = function(t1, e1) {
                    var r = {};
                    "object" != typeof e1 && (e1 = {});
                    var n, i, a, o = Object.keys(t1);
                    for(n = 0; n < o.length; n++)a = t1[i = o[n]], "_" !== i.charAt(0) && "function" != typeof a && ("module" === i ? r[i] = a : Array.isArray(a) ? r[i] = "colorscale" === i ? a.slice() : a.slice(0, 3) : f.isTypedArray(a) ? r[i] = a.subarray(0, 3) : r[i] = a && "object" == typeof a ? f.minExtend(t1[i], e1[i]) : a);
                    for(o = Object.keys(e1), n = 0; n < o.length; n++)"object" == typeof (a = e1[i = o[n]]) && i in r && "object" == typeof r[i] || (r[i] = a);
                    return r;
                }, f.titleCase = function(t1) {
                    return t1.charAt(0).toUpperCase() + t1.substr(1);
                }, f.containsAny = function(t1, e1) {
                    for(var r = 0; r < e1.length; r++)if (-1 !== t1.indexOf(e1[r])) return !0;
                    return !1;
                }, f.isIE = function() {
                    return void 0 !== window.navigator.msSaveBlob;
                };
                var L = /Version\/[\d\.]+.*Safari/;
                f.isSafari = function() {
                    return L.test(window.navigator.userAgent);
                };
                var C = /iPad|iPhone|iPod/;
                f.isIOS = function() {
                    return C.test(window.navigator.userAgent);
                };
                var P = /Firefox\/(\d+)\.\d+/;
                f.getFirefoxVersion = function() {
                    var t1 = P.exec(window.navigator.userAgent);
                    if (t1 && 2 === t1.length) {
                        var e1 = parseInt(t1[1]);
                        if (!isNaN(e1)) return e1;
                    }
                    return null;
                }, f.isD3Selection = function(t1) {
                    return t1 instanceof n.selection;
                }, f.ensureSingle = function(t1, e1, r, n) {
                    var i = t1.select(e1 + (r ? "." + r : ""));
                    if (i.size()) return i;
                    var a = t1.append(e1);
                    return r && a.classed(r, !0), n && a.call(n), a;
                }, f.ensureSingleById = function(t1, e1, r, n) {
                    var i = t1.select(e1 + "#" + r);
                    if (i.size()) return i;
                    var a = t1.append(e1).attr("id", r);
                    return n && a.call(n), a;
                }, f.objectFromPath = function(t1, e1) {
                    for(var r, n = t1.split("."), i = r = {}, a = 0; a < n.length; a++){
                        var o = n[a], s = null, l = n[a].match(/(.*)\[([0-9]+)\]/);
                        l ? (o = l[1], s = l[2], r = r[o] = [], a === n.length - 1 ? r[s] = e1 : r[s] = {}, r = r[s]) : (a === n.length - 1 ? r[o] = e1 : r[o] = {}, r = r[o]);
                    }
                    return i;
                };
                var I = /^([^\[\.]+)\.(.+)?/, O = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
                f.expandObjectPaths = function(t1) {
                    var e1, r, n, i, a, o, s;
                    if ("object" == typeof t1 && !Array.isArray(t1)) for(r in t1)t1.hasOwnProperty(r) && ((e1 = r.match(I)) ? (i = t1[r], n = e1[1], delete t1[r], t1[n] = f.extendDeepNoArrays(t1[n] || {}, f.objectFromPath(r, f.expandObjectPaths(i))[n])) : (e1 = r.match(O)) ? (i = t1[r], n = e1[1], a = parseInt(e1[2]), delete t1[r], t1[n] = t1[n] || [], "." === e1[3] ? (s = e1[4], o = t1[n][a] = t1[n][a] || {}, f.extendDeepNoArrays(o, f.objectFromPath(s, f.expandObjectPaths(i)))) : t1[n][a] = f.expandObjectPaths(i)) : t1[r] = f.expandObjectPaths(t1[r]));
                    return t1;
                }, f.numSeparate = function(t1, e1, r) {
                    if (r || (r = !1), "string" != typeof e1 || 0 === e1.length) throw new Error("Separator string required for formatting!");
                    "number" == typeof t1 && (t1 = String(t1));
                    var n = /(\d+)(\d{3})/, i = e1.charAt(0), a = e1.charAt(1), o = t1.split("."), s = o[0], l = o.length > 1 ? i + o[1] : "";
                    if (a && (o.length > 1 || s.length > 4 || r)) for(; n.test(s);)s = s.replace(n, "$1" + a + "$2");
                    return s + l;
                }, f.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
                var z = /^\w*$/;
                f.templateString = function(t1, e1) {
                    var r = {};
                    return t1.replace(f.TEMPLATE_STRING_REGEX, function(t1, n) {
                        var i;
                        return z.test(n) ? i = e1[n] : (r[n] = r[n] || f.nestedProperty(e1, n).get, i = r[n]()), f.isValidTextValue(i) ? i : "";
                    });
                };
                var D = {
                    max: 10,
                    count: 0,
                    name: "hovertemplate"
                };
                f.hovertemplateString = function() {
                    return B.apply(D, arguments);
                };
                var R = {
                    max: 10,
                    count: 0,
                    name: "texttemplate"
                };
                f.texttemplateString = function() {
                    return B.apply(R, arguments);
                };
                var F = /^[:|\|]/;
                function B(t1, e1, r) {
                    var n = this, a = arguments;
                    e1 || (e1 = {});
                    var o = {};
                    return t1.replace(f.TEMPLATE_STRING_REGEX, function(t1, s, l) {
                        var c, u, h, p = "_xother" === s || "_yother" === s, d = "_xother_" === s || "_yother_" === s, m = "xother_" === s || "yother_" === s, g = "xother" === s || "yother" === s || p || m || d, v = s;
                        if ((p || d) && (v = v.substring(1)), (m || d) && (v = v.substring(0, v.length - 1)), g) {
                            if (void 0 === (c = e1[v])) return "";
                        } else for(h = 3; h < a.length; h++)if (u = a[h]) {
                            if (u.hasOwnProperty(v)) {
                                c = u[v];
                                break;
                            }
                            if (z.test(v) || (c = f.nestedProperty(u, v).get(), (c = o[v] || f.nestedProperty(u, v).get()) && (o[v] = c)), void 0 !== c) break;
                        }
                        if (void 0 === c && n) return n.count < n.max && (f.warn("Variable '" + v + "' in " + n.name + " could not be found!"), c = t1), n.count === n.max && f.warn("Too many " + n.name + " warnings - additional warnings will be suppressed"), n.count++, t1;
                        if (l) {
                            var y;
                            if (":" === l[0] && (c = (y = r ? r.numberFormat : f.numberFormat)(l.replace(F, ""))(c)), "|" === l[0]) {
                                y = r ? r.timeFormat : i;
                                var x = f.dateTime2ms(c);
                                c = f.formatDate(x, l.replace(F, ""), !1, y);
                            }
                        } else {
                            var b = v + "Label";
                            e1.hasOwnProperty(b) && (c = e1[b]);
                        }
                        return g && (c = "(" + c + ")", (p || d) && (c = " " + c), (m || d) && (c += " ")), c;
                    });
                }
                f.subplotSort = function(t1, e1) {
                    for(var r = Math.min(t1.length, e1.length) + 1, n = 0, i = 0, a = 0; a < r; a++){
                        var o = t1.charCodeAt(a) || 0, s = e1.charCodeAt(a) || 0, l = o >= 48 && o <= 57, c = s >= 48 && s <= 57;
                        if (l && (n = 10 * n + o - 48), c && (i = 10 * i + s - 48), !l || !c) {
                            if (n !== i) return n - i;
                            if (o !== s) return o - s;
                        }
                    }
                    return i - n;
                };
                var N = 2e9;
                f.seedPseudoRandom = function() {
                    N = 2e9;
                }, f.pseudoRandom = function() {
                    var t1 = N;
                    return N = (69069 * N + 1) % 4294967296, Math.abs(N - t1) < 429496729 ? f.pseudoRandom() : N / 4294967296;
                }, f.fillText = function(t1, e1, r) {
                    var n = Array.isArray(r) ? function(t1) {
                        r.push(t1);
                    } : function(t1) {
                        r.text = t1;
                    }, i = f.extractOption(t1, e1, "htx", "hovertext");
                    if (f.isValidTextValue(i)) return n(i);
                    var a = f.extractOption(t1, e1, "tx", "text");
                    return f.isValidTextValue(a) ? n(a) : void 0;
                }, f.isValidTextValue = function(t1) {
                    return t1 || 0 === t1;
                }, f.formatPercent = function(t1, e1) {
                    e1 = e1 || 0;
                    for(var r = (Math.round(100 * t1 * Math.pow(10, e1)) * Math.pow(.1, e1)).toFixed(e1) + "%", n = 0; n < e1; n++)-1 !== r.indexOf(".") && (r = (r = r.replace("0%", "%")).replace(".%", "%"));
                    return r;
                }, f.isHidden = function(t1) {
                    var e1 = window.getComputedStyle(t1).display;
                    return !e1 || "none" === e1;
                }, f.strTranslate = function(t1, e1) {
                    return t1 || e1 ? "translate(" + t1 + "," + e1 + ")" : "";
                }, f.strRotate = function(t1) {
                    return t1 ? "rotate(" + t1 + ")" : "";
                }, f.strScale = function(t1) {
                    return 1 !== t1 ? "scale(" + t1 + ")" : "";
                }, f.getTextTransform = function(t1) {
                    var e1 = t1.noCenter, r = t1.textX, n = t1.textY, i = t1.targetX, a = t1.targetY, o = t1.anchorX || 0, s = t1.anchorY || 0, l = t1.rotate, c = t1.scale;
                    return c ? c > 1 && (c = 1) : c = 0, f.strTranslate(i - c * (r + o), a - c * (n + s)) + f.strScale(c) + (l ? "rotate(" + l + (e1 ? "" : " " + r + " " + n) + ")" : "");
                }, f.ensureUniformFontSize = function(t1, e1) {
                    var r = f.extendFlat({}, e1);
                    return r.size = Math.max(e1.size, t1._fullLayout.uniformtext.minsize || 0), r;
                }, f.join2 = function(t1, e1, r) {
                    var n = t1.length;
                    return n > 1 ? t1.slice(0, -1).join(e1) + r + t1[n - 1] : t1.join(e1);
                }, f.bigFont = function(t1) {
                    return Math.round(1.2 * t1);
                };
                var j = f.getFirefoxVersion(), U = null !== j && j < 86;
                f.getPositionFromD3Event = function() {
                    return U ? [
                        n.event.layerX,
                        n.event.layerY
                    ] : [
                        n.event.offsetX,
                        n.event.offsetY
                    ];
                };
            },
            {
                "../constants/numerical": 479,
                "./anchor_utils": 483,
                "./angles": 484,
                "./array": 485,
                "./clean_number": 486,
                "./clear_responsive": 488,
                "./coerce": 489,
                "./dates": 490,
                "./dom": 491,
                "./extend": 493,
                "./filter_unique": 494,
                "./filter_visible": 495,
                "./geometry2d": 498,
                "./identity": 501,
                "./increment": 502,
                "./is_plain_object": 504,
                "./keyed_container": 505,
                "./localize": 506,
                "./loggers": 507,
                "./make_trace_groups": 508,
                "./matrix": 509,
                "./mod": 510,
                "./nested_property": 511,
                "./noop": 512,
                "./notifier": 513,
                "./preserve_drawing_buffer": 517,
                "./push_unique": 518,
                "./regex": 520,
                "./relative_attr": 521,
                "./relink_private": 522,
                "./search": 523,
                "./sort_object_keys": 526,
                "./stats": 527,
                "./throttle": 530,
                "./to_log_range": 531,
                "@plotly/d3": 58,
                "d3-format": 112,
                "d3-time-format": 120,
                "fast-isnumeric": 190
            }
        ],
        504: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    return window && window.process && window.process.versions ? "[object Object]" === Object.prototype.toString.call(t1) : "[object Object]" === Object.prototype.toString.call(t1) && Object.getPrototypeOf(t1).hasOwnProperty("hasOwnProperty");
                };
            },
            {}
        ],
        505: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./nested_property"), i = /^\w*$/;
                e1.exports = function(t1, e1, r, a) {
                    var o, s, l;
                    r = r || "name", a = a || "value";
                    var c = {};
                    e1 && e1.length ? (l = n(t1, e1), s = l.get()) : s = t1, e1 = e1 || "";
                    var u = {};
                    if (s) for(o = 0; o < s.length; o++)u[s[o][r]] = o;
                    var f = i.test(a), h = {
                        set: function(t1, e1) {
                            var i = null === e1 ? 4 : 0;
                            if (!s) {
                                if (!l || 4 === i) return;
                                s = [], l.set(s);
                            }
                            var o = u[t1];
                            if (void 0 === o) {
                                if (4 === i) return;
                                i |= 3, o = s.length, u[t1] = o;
                            } else e1 !== (f ? s[o][a] : n(s[o], a).get()) && (i |= 2);
                            var p = s[o] = s[o] || {};
                            return p[r] = t1, f ? p[a] = e1 : n(p, a).set(e1), null !== e1 && (i &= -5), c[o] = c[o] | i, h;
                        },
                        get: function(t1) {
                            if (s) {
                                var e1 = u[t1];
                                return void 0 === e1 ? void 0 : f ? s[e1][a] : n(s[e1], a).get();
                            }
                        },
                        rename: function(t1, e1) {
                            var n = u[t1];
                            return void 0 === n || (c[n] = 1 | c[n], u[e1] = n, delete u[t1], s[n][r] = e1), h;
                        },
                        remove: function(t1) {
                            var e1 = u[t1];
                            if (void 0 === e1) return h;
                            var i = s[e1];
                            if (Object.keys(i).length > 2) return c[e1] = 2 | c[e1], h.set(t1, null);
                            if (f) {
                                for(o = e1; o < s.length; o++)c[o] = 3 | c[o];
                                for(o = e1; o < s.length; o++)u[s[o][r]]--;
                                s.splice(e1, 1), delete u[t1];
                            } else n(i, a).set(null), c[e1] = 6 | c[e1];
                            return h;
                        },
                        constructUpdate: function() {
                            for(var t1, i, o = {}, l = Object.keys(c), u = 0; u < l.length; u++)i = l[u], t1 = e1 + "[" + i + "]", s[i] ? (1 & c[i] && (o[t1 + "." + r] = s[i][r]), 2 & c[i] && (o[t1 + "." + a] = f ? 4 & c[i] ? null : s[i][a] : 4 & c[i] ? null : n(s[i], a).get())) : o[t1] = null;
                            return o;
                        }
                    };
                    return h;
                };
            },
            {
                "./nested_property": 511
            }
        ],
        506: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../registry");
                e1.exports = function(t1, e1) {
                    for(var r = t1._context.locale, i = 0; i < 2; i++){
                        for(var a = t1._context.locales, o = 0; o < 2; o++){
                            var s = (a[r] || {}).dictionary;
                            if (s) {
                                var l = s[e1];
                                if (l) return l;
                            }
                            a = n.localeRegistry;
                        }
                        var c = r.split("-")[0];
                        if (c === r) break;
                        r = c;
                    }
                    return e1;
                };
            },
            {
                "../registry": 638
            }
        ],
        507: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../plot_api/plot_config").dfltConfig, i = t1("./notifier"), a = e1.exports = {};
                a.log = function() {
                    var t1;
                    if (n.logging > 1) {
                        var e1 = [
                            "LOG:"
                        ];
                        for(t1 = 0; t1 < arguments.length; t1++)e1.push(arguments[t1]);
                        console.trace.apply(console, e1);
                    }
                    if (n.notifyOnLogging > 1) {
                        var r = [];
                        for(t1 = 0; t1 < arguments.length; t1++)r.push(arguments[t1]);
                        i(r.join("<br>"), "long");
                    }
                }, a.warn = function() {
                    var t1;
                    if (n.logging > 0) {
                        var e1 = [
                            "WARN:"
                        ];
                        for(t1 = 0; t1 < arguments.length; t1++)e1.push(arguments[t1]);
                        console.trace.apply(console, e1);
                    }
                    if (n.notifyOnLogging > 0) {
                        var r = [];
                        for(t1 = 0; t1 < arguments.length; t1++)r.push(arguments[t1]);
                        i(r.join("<br>"), "stick");
                    }
                }, a.error = function() {
                    var t1;
                    if (n.logging > 0) {
                        var e1 = [
                            "ERROR:"
                        ];
                        for(t1 = 0; t1 < arguments.length; t1++)e1.push(arguments[t1]);
                        console.error.apply(console, e1);
                    }
                    if (n.notifyOnLogging > 0) {
                        var r = [];
                        for(t1 = 0; t1 < arguments.length; t1++)r.push(arguments[t1]);
                        i(r.join("<br>"), "stick");
                    }
                };
            },
            {
                "../plot_api/plot_config": 541,
                "./notifier": 513
            }
        ],
        508: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3");
                e1.exports = function(t1, e1, r) {
                    var i = t1.selectAll("g." + r.replace(/\s/g, ".")).data(e1, function(t1) {
                        return t1[0].trace.uid;
                    });
                    i.exit().remove(), i.enter().append("g").attr("class", r), i.order();
                    var a = t1.classed("rangeplot") ? "nodeRangePlot3" : "node3";
                    return i.each(function(t1) {
                        t1[0][a] = n.select(this);
                    }), i;
                };
            },
            {
                "@plotly/d3": 58
            }
        ],
        509: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("gl-mat4");
                r.init2dArray = function(t1, e1) {
                    for(var r = new Array(t1), n = 0; n < t1; n++)r[n] = new Array(e1);
                    return r;
                }, r.transposeRagged = function(t1) {
                    var e1, r, n = 0, i = t1.length;
                    for(e1 = 0; e1 < i; e1++)n = Math.max(n, t1[e1].length);
                    var a = new Array(n);
                    for(e1 = 0; e1 < n; e1++)for(a[e1] = new Array(i), r = 0; r < i; r++)a[e1][r] = t1[r][e1];
                    return a;
                }, r.dot = function(t1, e1) {
                    if (!t1.length || !e1.length || t1.length !== e1.length) return null;
                    var n, i, a = t1.length;
                    if (t1[0].length) for(n = new Array(a), i = 0; i < a; i++)n[i] = r.dot(t1[i], e1);
                    else if (e1[0].length) {
                        var o = r.transposeRagged(e1);
                        for(n = new Array(o.length), i = 0; i < o.length; i++)n[i] = r.dot(t1, o[i]);
                    } else for(n = 0, i = 0; i < a; i++)n += t1[i] * e1[i];
                    return n;
                }, r.translationMatrix = function(t1, e1) {
                    return [
                        [
                            1,
                            0,
                            t1
                        ],
                        [
                            0,
                            1,
                            e1
                        ],
                        [
                            0,
                            0,
                            1
                        ]
                    ];
                }, r.rotationMatrix = function(t1) {
                    var e1 = t1 * Math.PI / 180;
                    return [
                        [
                            Math.cos(e1),
                            -Math.sin(e1),
                            0
                        ],
                        [
                            Math.sin(e1),
                            Math.cos(e1),
                            0
                        ],
                        [
                            0,
                            0,
                            1
                        ]
                    ];
                }, r.rotationXYMatrix = function(t1, e1, n) {
                    return r.dot(r.dot(r.translationMatrix(e1, n), r.rotationMatrix(t1)), r.translationMatrix(-e1, -n));
                }, r.apply3DTransform = function(t1) {
                    return function() {
                        var e1 = arguments, n = 1 === arguments.length ? e1[0] : [
                            e1[0],
                            e1[1],
                            e1[2] || 0
                        ];
                        return r.dot(t1, [
                            n[0],
                            n[1],
                            n[2],
                            1
                        ]).slice(0, 3);
                    };
                }, r.apply2DTransform = function(t1) {
                    return function() {
                        var e1 = arguments;
                        3 === e1.length && (e1 = e1[0]);
                        var n = 1 === arguments.length ? e1[0] : [
                            e1[0],
                            e1[1]
                        ];
                        return r.dot(t1, [
                            n[0],
                            n[1],
                            1
                        ]).slice(0, 2);
                    };
                }, r.apply2DTransform2 = function(t1) {
                    var e1 = r.apply2DTransform(t1);
                    return function(t1) {
                        return e1(t1.slice(0, 2)).concat(e1(t1.slice(2, 4)));
                    };
                }, r.convertCssMatrix = function(t1) {
                    if (t1) {
                        var e1 = t1.length;
                        if (16 === e1) return t1;
                        if (6 === e1) return [
                            t1[0],
                            t1[1],
                            0,
                            0,
                            t1[2],
                            t1[3],
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            t1[4],
                            t1[5],
                            0,
                            1
                        ];
                    }
                    return [
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ];
                }, r.inverseTransformMatrix = function(t1) {
                    var e1 = [];
                    return n.invert(e1, t1), [
                        [
                            e1[0],
                            e1[1],
                            e1[2],
                            e1[3]
                        ],
                        [
                            e1[4],
                            e1[5],
                            e1[6],
                            e1[7]
                        ],
                        [
                            e1[8],
                            e1[9],
                            e1[10],
                            e1[11]
                        ],
                        [
                            e1[12],
                            e1[13],
                            e1[14],
                            e1[15]
                        ]
                    ];
                };
            },
            {
                "gl-mat4": 210
            }
        ],
        510: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    mod: function(t1, e1) {
                        var r = t1 % e1;
                        return r < 0 ? r + e1 : r;
                    },
                    modHalf: function(t1, e1) {
                        return Math.abs(t1) > e1 / 2 ? t1 - Math.round(t1 / e1) * e1 : t1;
                    }
                };
            },
            {}
        ],
        511: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("./array").isArrayOrTypedArray;
                function a(t1, e1) {
                    return function() {
                        var r, n, o, s, l, c = t1;
                        for(s = 0; s < e1.length - 1; s++){
                            if (-1 === (r = e1[s])) {
                                for(n = !0, o = [], l = 0; l < c.length; l++)o[l] = a(c[l], e1.slice(s + 1))(), o[l] !== o[0] && (n = !1);
                                return n ? o[0] : o;
                            }
                            if ("number" == typeof r && !i(c)) return;
                            if ("object" != typeof (c = c[r]) || null === c) return;
                        }
                        if ("object" == typeof c && null !== c && null !== (o = c[e1[s]])) return o;
                    };
                }
                e1.exports = function(t1, e1) {
                    if (n(e1)) e1 = String(e1);
                    else if ("string" != typeof e1 || "[-1]" === e1.substr(e1.length - 4)) throw "bad property string";
                    for(var r, i, o, s = 0, c = e1.split("."); s < c.length;){
                        if (r = String(c[s]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/)) {
                            if (r[1]) c[s] = r[1];
                            else {
                                if (0 !== s) throw "bad property string";
                                c.splice(0, 1);
                            }
                            for(i = r[2].substr(1, r[2].length - 2).split("]["), o = 0; o < i.length; o++)s++, c.splice(s, 0, Number(i[o]));
                        }
                        s++;
                    }
                    return "object" != typeof t1 ? function(t1, e1, r) {
                        return {
                            set: function() {
                                throw "bad container";
                            },
                            get: function() {},
                            astr: e1,
                            parts: r,
                            obj: t1
                        };
                    }(t1, e1, c) : {
                        set: l(t1, c, e1),
                        get: a(t1, c),
                        astr: e1,
                        parts: c,
                        obj: t1
                    };
                };
                var o = /(^|\.)args\[/;
                function s(t1, e1) {
                    return void 0 === t1 || null === t1 && !e1.match(o);
                }
                function l(t1, e1, r) {
                    return function(n) {
                        var a, o, l = t1, h = "", p = [
                            [
                                t1,
                                h
                            ]
                        ], d = s(n, r);
                        for(o = 0; o < e1.length - 1; o++){
                            if ("number" == typeof (a = e1[o]) && !i(l)) throw "array index but container is not an array";
                            if (-1 === a) {
                                if (d = !u(l, e1.slice(o + 1), n, r)) break;
                                return;
                            }
                            if (!f(l, a, e1[o + 1], d)) break;
                            if ("object" != typeof (l = l[a]) || null === l) throw "container is not an object";
                            h = c(h, a), p.push([
                                l,
                                h
                            ]);
                        }
                        if (d) {
                            if (o === e1.length - 1 && (delete l[e1[o]], Array.isArray(l) && +e1[o] == l.length - 1)) for(; l.length && void 0 === l[l.length - 1];)l.pop();
                        } else l[e1[o]] = n;
                    };
                }
                function c(t1, e1) {
                    var r = e1;
                    return n(e1) ? r = "[" + e1 + "]" : t1 && (r = "." + e1), t1 + r;
                }
                function u(t1, e1, r, n) {
                    var a, o = i(r), c = !0, u = r, h = n.replace("-1", 0), p = !o && s(r, h), d = e1[0];
                    for(a = 0; a < t1.length; a++)h = n.replace("-1", a), o && (p = s(u = r[a % r.length], h)), p && (c = !1), f(t1, a, d, p) && l(t1[a], e1, n.replace("-1", a))(u);
                    return c;
                }
                function f(t1, e1, r, n) {
                    if (void 0 === t1[e1]) {
                        if (n) return !1;
                        t1[e1] = "number" == typeof r ? [] : {};
                    }
                    return !0;
                }
            },
            {
                "./array": 485,
                "fast-isnumeric": 190
            }
        ],
        512: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function() {};
            },
            {}
        ],
        513: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("fast-isnumeric"), a = [];
                e1.exports = function(t1, e1) {
                    if (-1 === a.indexOf(t1)) {
                        a.push(t1);
                        var r = 1e3;
                        i(e1) ? r = e1 : "long" === e1 && (r = 3e3);
                        var o = n.select("body").selectAll(".plotly-notifier").data([
                            0
                        ]);
                        o.enter().append("div").classed("plotly-notifier", !0), o.selectAll(".notifier-note").data(a).enter().append("div").classed("notifier-note", !0).style("opacity", 0).each(function(t1) {
                            var i = n.select(this);
                            i.append("button").classed("notifier-close", !0).html("&times;").on("click", function() {
                                i.transition().call(s);
                            });
                            for(var a = i.append("p"), o = t1.split(/<br\s*\/?>/g), l = 0; l < o.length; l++)l && a.append("br"), a.append("span").text(o[l]);
                            "stick" === e1 ? i.transition().duration(350).style("opacity", 1) : i.transition().duration(700).style("opacity", 1).transition().delay(r).call(s);
                        });
                    }
                    function s(t1) {
                        t1.duration(700).style("opacity", 0).each("end", function(t1) {
                            var e1 = a.indexOf(t1);
                            -1 !== e1 && a.splice(e1, 1), n.select(this).remove();
                        });
                    }
                };
            },
            {
                "@plotly/d3": 58,
                "fast-isnumeric": 190
            }
        ],
        514: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./setcursor"), i = "data-savedcursor";
                e1.exports = function(t1, e1) {
                    var r = t1.attr(i);
                    if (e1) {
                        if (!r) {
                            for(var a = (t1.attr("class") || "").split(" "), o = 0; o < a.length; o++){
                                var s = a[o];
                                0 === s.indexOf("cursor-") && t1.attr(i, s.substr(7)).classed(s, !1);
                            }
                            t1.attr(i) || t1.attr(i, "!!");
                        }
                        n(t1, e1);
                    } else r && (t1.attr(i, null), "!!" === r ? n(t1) : n(t1, r));
                };
            },
            {
                "./setcursor": 524
            }
        ],
        515: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./matrix").dot, i = t1("../constants/numerical").BADNUM, a = e1.exports = {};
                a.tester = function(t1) {
                    var e1, r = t1.slice(), n = r[0][0], a = n, o = r[0][1], s = o;
                    for(r.push(r[0]), e1 = 1; e1 < r.length; e1++)n = Math.min(n, r[e1][0]), a = Math.max(a, r[e1][0]), o = Math.min(o, r[e1][1]), s = Math.max(s, r[e1][1]);
                    var l, c = !1;
                    5 === r.length && (r[0][0] === r[1][0] ? r[2][0] === r[3][0] && r[0][1] === r[3][1] && r[1][1] === r[2][1] && (c = !0, l = function(t1) {
                        return t1[0] === r[0][0];
                    }) : r[0][1] === r[1][1] && r[2][1] === r[3][1] && r[0][0] === r[3][0] && r[1][0] === r[2][0] && (c = !0, l = function(t1) {
                        return t1[1] === r[0][1];
                    }));
                    var u = !0, f = r[0];
                    for(e1 = 1; e1 < r.length; e1++)if (f[0] !== r[e1][0] || f[1] !== r[e1][1]) {
                        u = !1;
                        break;
                    }
                    return {
                        xmin: n,
                        xmax: a,
                        ymin: o,
                        ymax: s,
                        pts: r,
                        contains: c ? function(t1, e1) {
                            var r = t1[0], c = t1[1];
                            return !(r === i || r < n || r > a || c === i || c < o || c > s) && (!e1 || !l(t1));
                        } : function(t1, e1) {
                            var l = t1[0], c = t1[1];
                            if (l === i || l < n || l > a || c === i || c < o || c > s) return !1;
                            var u, f, h, p, d, m = r.length, g = r[0][0], v = r[0][1], y = 0;
                            for(u = 1; u < m; u++)if (f = g, h = v, g = r[u][0], v = r[u][1], !(l < (p = Math.min(f, g)) || l > Math.max(f, g) || c > Math.max(h, v))) {
                                if (c < Math.min(h, v)) l !== p && y++;
                                else {
                                    if (c === (d = g === f ? c : h + (l - f) * (v - h) / (g - f))) return 1 !== u || !e1;
                                    c <= d && l !== p && y++;
                                }
                            }
                            return y % 2 == 1;
                        },
                        isRect: c,
                        degenerate: u
                    };
                }, a.isSegmentBent = function(t1, e1, r, i) {
                    var a, o, s, l = t1[e1], c = [
                        t1[r][0] - l[0],
                        t1[r][1] - l[1]
                    ], u = n(c, c), f = Math.sqrt(u), h = [
                        -c[1] / f,
                        c[0] / f
                    ];
                    for(a = e1 + 1; a < r; a++)if (o = [
                        t1[a][0] - l[0],
                        t1[a][1] - l[1]
                    ], (s = n(o, c)) < 0 || s > u || Math.abs(n(o, h)) > i) return !0;
                    return !1;
                }, a.filter = function(t1, e1) {
                    var r = [
                        t1[0]
                    ], n = 0, i = 0;
                    function o(o) {
                        t1.push(o);
                        var s = r.length, l = n;
                        r.splice(i + 1);
                        for(var c = l + 1; c < t1.length; c++)(c === t1.length - 1 || a.isSegmentBent(t1, l, c + 1, e1)) && (r.push(t1[c]), r.length < s - 2 && (n = c, i = r.length - 1), l = c);
                    }
                    t1.length > 1 && o(t1.pop());
                    return {
                        addPt: o,
                        raw: t1,
                        filtered: r
                    };
                };
            },
            {
                "../constants/numerical": 479,
                "./matrix": 509
            }
        ],
        516: [
            function(t1, e1, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = t1("./show_no_webgl_msg"), i = t1("regl");
                        e1.exports = function(t1, e1) {
                            var a = t1._fullLayout, o = !0;
                            return a._glcanvas.each(function(n) {
                                if (!n.regl && (!n.pick || a._has("parcoords"))) {
                                    try {
                                        n.regl = i({
                                            canvas: this,
                                            attributes: {
                                                antialias: !n.pick,
                                                preserveDrawingBuffer: !0
                                            },
                                            pixelRatio: t1._context.plotGlPixelRatio || r.devicePixelRatio,
                                            extensions: e1 || []
                                        });
                                    } catch (t1) {
                                        o = !1;
                                    }
                                    n.regl || (o = !1), o && this.addEventListener("webglcontextlost", function(e1) {
                                        t1 && t1.emit && t1.emit("plotly_webglcontextlost", {
                                            event: e1,
                                            layer: n.key
                                        });
                                    }, !1);
                                }
                            }), o || n({
                                container: a._glcontainer.node()
                            }), o;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./show_no_webgl_msg": 525,
                regl: 283
            }
        ],
        517: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("is-mobile");
                e1.exports = function(t1) {
                    var e1;
                    if ("string" != typeof (e1 = t1 && t1.hasOwnProperty("userAgent") ? t1.userAgent : function() {
                        var t1;
                        "undefined" != typeof navigator && (t1 = navigator.userAgent);
                        t1 && t1.headers && "string" == typeof t1.headers["user-agent"] && (t1 = t1.headers["user-agent"]);
                        return t1;
                    }())) return !0;
                    var r = i({
                        ua: {
                            headers: {
                                "user-agent": e1
                            }
                        },
                        tablet: !0,
                        featureDetect: !1
                    });
                    if (!r) for(var a = e1.split(" "), o = 1; o < a.length; o++){
                        if (-1 !== a[o].indexOf("Safari")) for(var s = o - 1; s > -1; s--){
                            var l = a[s];
                            if ("Version/" === l.substr(0, 8)) {
                                var c = l.substr(8).split(".")[0];
                                if (n(c) && (c = +c), c >= 13) return !0;
                            }
                        }
                    }
                    return r;
                };
            },
            {
                "fast-isnumeric": 190,
                "is-mobile": 234
            }
        ],
        518: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    if (e1 instanceof RegExp) {
                        for(var r = e1.toString(), n = 0; n < t1.length; n++)if (t1[n] instanceof RegExp && t1[n].toString() === r) return t1;
                        t1.push(e1);
                    } else !e1 && 0 !== e1 || -1 !== t1.indexOf(e1) || t1.push(e1);
                    return t1;
                };
            },
            {}
        ],
        519: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = t1("../plot_api/plot_config").dfltConfig;
                var a = {
                    add: function(t1, e1, r, n, a) {
                        var o, s;
                        t1.undoQueue = t1.undoQueue || {
                            index: 0,
                            queue: [],
                            sequence: !1
                        }, s = t1.undoQueue.index, t1.autoplay ? t1.undoQueue.inSequence || (t1.autoplay = !1) : (!t1.undoQueue.sequence || t1.undoQueue.beginSequence ? (o = {
                            undo: {
                                calls: [],
                                args: []
                            },
                            redo: {
                                calls: [],
                                args: []
                            }
                        }, t1.undoQueue.queue.splice(s, t1.undoQueue.queue.length - s, o), t1.undoQueue.index += 1) : o = t1.undoQueue.queue[s - 1], t1.undoQueue.beginSequence = !1, o && (o.undo.calls.unshift(e1), o.undo.args.unshift(r), o.redo.calls.push(n), o.redo.args.push(a)), t1.undoQueue.queue.length > i.queueLength && (t1.undoQueue.queue.shift(), t1.undoQueue.index--));
                    },
                    startSequence: function(t1) {
                        t1.undoQueue = t1.undoQueue || {
                            index: 0,
                            queue: [],
                            sequence: !1
                        }, t1.undoQueue.sequence = !0, t1.undoQueue.beginSequence = !0;
                    },
                    stopSequence: function(t1) {
                        t1.undoQueue = t1.undoQueue || {
                            index: 0,
                            queue: [],
                            sequence: !1
                        }, t1.undoQueue.sequence = !1, t1.undoQueue.beginSequence = !1;
                    },
                    undo: function(t1) {
                        var e1, r;
                        if (!(void 0 === t1.undoQueue || isNaN(t1.undoQueue.index) || t1.undoQueue.index <= 0)) {
                            for(t1.undoQueue.index--, e1 = t1.undoQueue.queue[t1.undoQueue.index], t1.undoQueue.inSequence = !0, r = 0; r < e1.undo.calls.length; r++)a.plotDo(t1, e1.undo.calls[r], e1.undo.args[r]);
                            t1.undoQueue.inSequence = !1, t1.autoplay = !1;
                        }
                    },
                    redo: function(t1) {
                        var e1, r;
                        if (!(void 0 === t1.undoQueue || isNaN(t1.undoQueue.index) || t1.undoQueue.index >= t1.undoQueue.queue.length)) {
                            for(e1 = t1.undoQueue.queue[t1.undoQueue.index], t1.undoQueue.inSequence = !0, r = 0; r < e1.redo.calls.length; r++)a.plotDo(t1, e1.redo.calls[r], e1.redo.args[r]);
                            t1.undoQueue.inSequence = !1, t1.autoplay = !1, t1.undoQueue.index++;
                        }
                    }
                };
                a.plotDo = function(t1, e1, r) {
                    t1.autoplay = !0, r = function(t1, e1) {
                        for(var r, i = [], a = 0; a < e1.length; a++)r = e1[a], i[a] = r === t1 ? r : "object" == typeof r ? Array.isArray(r) ? n.extendDeep([], r) : n.extendDeepAll({}, r) : r;
                        return i;
                    }(t1, r), e1.apply(null, r);
                }, e1.exports = a;
            },
            {
                "../lib": 503,
                "../plot_api/plot_config": 541
            }
        ],
        520: [
            function(t1, e1, r) {
                "use strict";
                r.counter = function(t1, e1, r, n) {
                    var i = (e1 || "") + (r ? "" : "$"), a = !1 === n ? "" : "^";
                    return "xy" === t1 ? new RegExp(a + "x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?" + i) : new RegExp(a + t1 + "([2-9]|[1-9][0-9]+)?" + i);
                };
            },
            {}
        ],
        521: [
            function(t1, e1, r) {
                "use strict";
                var n = /^(.*)(\.[^\.\[\]]+|\[\d\])$/, i = /^[^\.\[\]]+$/;
                e1.exports = function(t1, e1) {
                    for(; e1;){
                        var r = t1.match(n);
                        if (r) t1 = r[1];
                        else {
                            if (!t1.match(i)) throw new Error("bad relativeAttr call:" + [
                                t1,
                                e1
                            ]);
                            t1 = "";
                        }
                        if ("^" !== e1.charAt(0)) break;
                        e1 = e1.slice(1);
                    }
                    return t1 && "[" !== e1.charAt(0) ? t1 + "." + e1 : t1 + e1;
                };
            },
            {}
        ],
        522: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./array").isArrayOrTypedArray, i = t1("./is_plain_object");
                e1.exports = function t1(e1, r) {
                    for(var a in r){
                        var o = r[a], s = e1[a];
                        if (s !== o) {
                            if ("_" === a.charAt(0) || "function" == typeof o) {
                                if (a in e1) continue;
                                e1[a] = o;
                            } else if (n(o) && n(s) && i(o[0])) {
                                if ("customdata" === a || "ids" === a) continue;
                                for(var l = Math.min(o.length, s.length), c = 0; c < l; c++)s[c] !== o[c] && i(o[c]) && i(s[c]) && t1(s[c], o[c]);
                            } else i(o) && i(s) && (t1(s, o), Object.keys(s).length || delete e1[a]);
                        }
                    }
                };
            },
            {
                "./array": 485,
                "./is_plain_object": 504
            }
        ],
        523: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("./loggers"), a = t1("./identity"), o = t1("../constants/numerical").BADNUM;
                function s(t1, e1) {
                    return t1 < e1;
                }
                function l(t1, e1) {
                    return t1 <= e1;
                }
                function c(t1, e1) {
                    return t1 > e1;
                }
                function u(t1, e1) {
                    return t1 >= e1;
                }
                r.findBin = function(t1, e1, r) {
                    if (n(e1.start)) return r ? Math.ceil((t1 - e1.start) / e1.size - 1e-9) - 1 : Math.floor((t1 - e1.start) / e1.size + 1e-9);
                    var a, o, f = 0, h = e1.length, p = 0, d = h > 1 ? (e1[h - 1] - e1[0]) / (h - 1) : 1;
                    for(o = d >= 0 ? r ? s : l : r ? u : c, t1 += 1e-9 * d * (r ? -1 : 1) * (d >= 0 ? 1 : -1); f < h && p++ < 100;)o(e1[a = Math.floor((f + h) / 2)], t1) ? f = a + 1 : h = a;
                    return p > 90 && i.log("Long binary search..."), f - 1;
                }, r.sorterAsc = function(t1, e1) {
                    return t1 - e1;
                }, r.sorterDes = function(t1, e1) {
                    return e1 - t1;
                }, r.distinctVals = function(t1) {
                    var e1, n = t1.slice();
                    for(n.sort(r.sorterAsc), e1 = n.length - 1; e1 > -1 && n[e1] === o; e1--);
                    for(var i, a = n[e1] - n[0] || 1, s = a / (e1 || 1) / 1e4, l = [], c = 0; c <= e1; c++){
                        var u = n[c], f = u - i;
                        void 0 === i ? (l.push(u), i = u) : f > s && (a = Math.min(a, f), l.push(u), i = u);
                    }
                    return {
                        vals: l,
                        minDiff: a
                    };
                }, r.roundUp = function(t1, e1, r) {
                    for(var n, i = 0, a = e1.length - 1, o = 0, s = r ? 0 : 1, l = r ? 1 : 0, c = r ? Math.ceil : Math.floor; i < a && o++ < 100;)e1[n = c((i + a) / 2)] <= t1 ? i = n + s : a = n - l;
                    return e1[i];
                }, r.sort = function(t1, e1) {
                    for(var r = 0, n = 0, i = 1; i < t1.length; i++){
                        var a = e1(t1[i], t1[i - 1]);
                        if (a < 0 ? r = 1 : a > 0 && (n = 1), r && n) return t1.sort(e1);
                    }
                    return n ? t1 : t1.reverse();
                }, r.findIndexOfMin = function(t1, e1) {
                    e1 = e1 || a;
                    for(var r, n = 1 / 0, i = 0; i < t1.length; i++){
                        var o = e1(t1[i]);
                        o < n && (n = o, r = i);
                    }
                    return r;
                };
            },
            {
                "../constants/numerical": 479,
                "./identity": 501,
                "./loggers": 507,
                "fast-isnumeric": 190
            }
        ],
        524: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    (t1.attr("class") || "").split(" ").forEach(function(e1) {
                        0 === e1.indexOf("cursor-") && t1.classed(e1, !1);
                    }), e1 && t1.classed("cursor-" + e1, !0);
                };
            },
            {}
        ],
        525: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../components/color"), i = function() {};
                e1.exports = function(t1) {
                    for(var e1 in t1)"function" == typeof t1[e1] && (t1[e1] = i);
                    t1.destroy = function() {
                        t1.container.parentNode.removeChild(t1.container);
                    };
                    var r = document.createElement("div");
                    r.className = "no-webgl", r.style.cursor = "pointer", r.style.fontSize = "24px", r.style.color = n.defaults[0], r.style.position = "absolute", r.style.left = r.style.top = "0px", r.style.width = r.style.height = "100%", r.style["background-color"] = n.lightLine, r.style["z-index"] = 30;
                    var a = document.createElement("p");
                    return a.textContent = "WebGL is not supported by your browser - visit https://get.webgl.org for more info", a.style.position = "relative", a.style.top = "50%", a.style.left = "50%", a.style.height = "30%", a.style.width = "50%", a.style.margin = "-15% 0 0 -25%", r.appendChild(a), t1.container.appendChild(r), t1.container.style.background = "#FFFFFF", t1.container.onclick = function() {
                        window.open("https://get.webgl.org");
                    }, !1;
                };
            },
            {
                "../components/color": 366
            }
        ],
        526: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    return Object.keys(t1).sort();
                };
            },
            {}
        ],
        527: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("./array").isArrayOrTypedArray;
                r.aggNums = function(t1, e1, a, o) {
                    var s, l;
                    if ((!o || o > a.length) && (o = a.length), n(e1) || (e1 = !1), i(a[0])) {
                        for(l = new Array(o), s = 0; s < o; s++)l[s] = r.aggNums(t1, e1, a[s]);
                        a = l;
                    }
                    for(s = 0; s < o; s++)n(e1) ? n(a[s]) && (e1 = t1(+e1, +a[s])) : e1 = a[s];
                    return e1;
                }, r.len = function(t1) {
                    return r.aggNums(function(t1) {
                        return t1 + 1;
                    }, 0, t1);
                }, r.mean = function(t1, e1) {
                    return e1 || (e1 = r.len(t1)), r.aggNums(function(t1, e1) {
                        return t1 + e1;
                    }, 0, t1) / e1;
                }, r.midRange = function(t1) {
                    if (void 0 !== t1 && 0 !== t1.length) return (r.aggNums(Math.max, null, t1) + r.aggNums(Math.min, null, t1)) / 2;
                }, r.variance = function(t1, e1, i) {
                    return e1 || (e1 = r.len(t1)), n(i) || (i = r.mean(t1, e1)), r.aggNums(function(t1, e1) {
                        return t1 + Math.pow(e1 - i, 2);
                    }, 0, t1) / e1;
                }, r.stdev = function(t1, e1, n) {
                    return Math.sqrt(r.variance(t1, e1, n));
                }, r.median = function(t1) {
                    var e1 = t1.slice().sort();
                    return r.interp(e1, .5);
                }, r.interp = function(t1, e1) {
                    if (!n(e1)) throw "n should be a finite number";
                    if ((e1 = e1 * t1.length - .5) < 0) return t1[0];
                    if (e1 > t1.length - 1) return t1[t1.length - 1];
                    var r = e1 % 1;
                    return r * t1[Math.ceil(e1)] + (1 - r) * t1[Math.floor(e1)];
                };
            },
            {
                "./array": 485,
                "fast-isnumeric": 190
            }
        ],
        528: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("color-normalize");
                e1.exports = function(t1) {
                    return t1 ? n(t1) : [
                        0,
                        0,
                        0,
                        1
                    ];
                };
            },
            {
                "color-normalize": 89
            }
        ],
        529: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../lib"), a = i.strTranslate, o = t1("../constants/xmlns_namespaces"), s = t1("../constants/alignment").LINE_SPACING, l = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
                r.convertToTspans = function(t1, e1, d) {
                    var A = t1.text(), M = !t1.attr("data-notex") && "undefined" != typeof MathJax && A.match(l), L = n.select(t1.node().parentNode);
                    if (!L.empty()) {
                        var C = t1.attr("class") ? t1.attr("class").split(" ")[0] : "text";
                        return C += "-math", L.selectAll("svg." + C).remove(), L.selectAll("g." + C + "-group").remove(), t1.style("display", null).attr({
                            "data-unformatted": A,
                            "data-math": "N"
                        }), M ? (e1 && e1._promises || []).push(new Promise(function(e1) {
                            t1.style("display", "none");
                            var r = parseInt(t1.node().style.fontSize, 10), o = {
                                fontSize: r
                            };
                            !function(t1, e1, r) {
                                var a, o, s, l;
                                MathJax.Hub.Queue(function() {
                                    return o = i.extendDeepAll({}, MathJax.Hub.config), s = MathJax.Hub.processSectionDelay, void 0 !== MathJax.Hub.processSectionDelay && (MathJax.Hub.processSectionDelay = 0), MathJax.Hub.Config({
                                        messageStyle: "none",
                                        tex2jax: {
                                            inlineMath: [
                                                [
                                                    "$",
                                                    "$"
                                                ],
                                                [
                                                    "\\(",
                                                    "\\)"
                                                ]
                                            ]
                                        },
                                        displayAlign: "left"
                                    });
                                }, function() {
                                    if ("SVG" !== (a = MathJax.Hub.config.menuSettings.renderer)) return MathJax.Hub.setRenderer("SVG");
                                }, function() {
                                    var r = "math-output-" + i.randstr({}, 64);
                                    return l = n.select("body").append("div").attr({
                                        id: r
                                    }).style({
                                        visibility: "hidden",
                                        position: "absolute"
                                    }).style({
                                        "font-size": e1.fontSize + "px"
                                    }).text(t1.replace(c, "\\lt ").replace(u, "\\gt ")), MathJax.Hub.Typeset(l.node());
                                }, function() {
                                    var e1 = n.select("body").select("#MathJax_SVG_glyphs");
                                    if (l.select(".MathJax_SVG").empty() || !l.select("svg").node()) i.log("There was an error in the tex syntax.", t1), r();
                                    else {
                                        var o = l.select("svg").node().getBoundingClientRect();
                                        r(l.select(".MathJax_SVG"), e1, o);
                                    }
                                    if (l.remove(), "SVG" !== a) return MathJax.Hub.setRenderer(a);
                                }, function() {
                                    return void 0 !== s && (MathJax.Hub.processSectionDelay = s), MathJax.Hub.Config(o);
                                });
                            }(M[2], o, function(n, i, o) {
                                L.selectAll("svg." + C).remove(), L.selectAll("g." + C + "-group").remove();
                                var s = n && n.select("svg");
                                if (!s || !s.node()) return P(), void e1();
                                var l = L.append("g").classed(C + "-group", !0).attr({
                                    "pointer-events": "none",
                                    "data-unformatted": A,
                                    "data-math": "Y"
                                });
                                l.node().appendChild(s.node()), i && i.node() && s.node().insertBefore(i.node().cloneNode(!0), s.node().firstChild);
                                var c = o.width, u = o.height;
                                s.attr({
                                    class: C,
                                    height: u,
                                    preserveAspectRatio: "xMinYMin meet"
                                }).style({
                                    overflow: "visible",
                                    "pointer-events": "none"
                                });
                                var f = t1.node().style.fill || "black", h = s.select("g");
                                h.attr({
                                    fill: f,
                                    stroke: f
                                });
                                var p = h.node().getBoundingClientRect(), m = p.width, g = p.height;
                                (m > c || g > u) && (s.style("overflow", "hidden"), m = (p = s.node().getBoundingClientRect()).width, g = p.height);
                                var v = +t1.attr("x"), y = +t1.attr("y"), x = -(r || t1.node().getBoundingClientRect().height) / 4;
                                if ("y" === C[0]) l.attr({
                                    transform: "rotate(" + [
                                        -90,
                                        v,
                                        y
                                    ] + ")" + a(-m / 2, x - g / 2)
                                });
                                else if ("l" === C[0]) y = x - g / 2;
                                else if ("a" === C[0] && 0 !== C.indexOf("atitle")) v = 0, y = x;
                                else {
                                    var b = t1.attr("text-anchor");
                                    v -= m * ("middle" === b ? .5 : "end" === b ? 1 : 0), y = y + x - g / 2;
                                }
                                s.attr({
                                    x: v,
                                    y: y
                                }), d && d.call(t1, l), e1(l);
                            });
                        })) : P(), t1;
                    }
                    function P() {
                        L.empty() || (C = t1.attr("class") + "-math", L.select("svg." + C).remove()), t1.text("").style("white-space", "pre"), function(t1, e1) {
                            e1 = e1.replace(m, " ");
                            var r, a = !1, l = [], c = -1;
                            function u() {
                                c++;
                                var e1 = document.createElementNS(o.svg, "tspan");
                                n.select(e1).attr({
                                    class: "line",
                                    dy: c * s + "em"
                                }), t1.appendChild(e1), r = e1;
                                var i = l;
                                if (l = [
                                    {
                                        node: e1
                                    }
                                ], i.length > 1) for(var a = 1; a < i.length; a++)d(i[a]);
                            }
                            function d(t1) {
                                var e1, i = t1.type, a = {};
                                if ("a" === i) {
                                    e1 = "a";
                                    var s = t1.target, c = t1.href, u = t1.popup;
                                    c && (a = {
                                        "xlink:xlink:show": "_blank" === s || "_" !== s.charAt(0) ? "new" : "replace",
                                        target: s,
                                        "xlink:xlink:href": c
                                    }, u && (a.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' + u + '");return false;'));
                                } else e1 = "tspan";
                                t1.style && (a.style = t1.style);
                                var f = document.createElementNS(o.svg, e1);
                                if ("sup" === i || "sub" === i) {
                                    A(r, "\u200b"), r.appendChild(f);
                                    var d = document.createElementNS(o.svg, "tspan");
                                    A(d, "\u200b"), n.select(d).attr("dy", p[i]), a.dy = h[i], r.appendChild(f), r.appendChild(d);
                                } else r.appendChild(f);
                                n.select(f).attr(a), r = t1.node = f, l.push(t1);
                            }
                            function A(t1, e1) {
                                t1.appendChild(document.createTextNode(e1));
                            }
                            function M(t1) {
                                if (1 !== l.length) {
                                    var n = l.pop();
                                    t1 !== n.type && i.log("Start tag <" + n.type + "> doesnt match end tag <" + t1 + ">. Pretending it did match.", e1), r = l[l.length - 1].node;
                                } else i.log("Ignoring unexpected end tag </" + t1 + ">.", e1);
                            }
                            y.test(e1) ? u() : (r = t1, l = [
                                {
                                    node: t1
                                }
                            ]);
                            for(var L = e1.split(g), C = 0; C < L.length; C++){
                                var P = L[C], I = P.match(v), O = I && I[2].toLowerCase(), z = f[O];
                                if ("br" === O) u();
                                else if (void 0 === z) A(r, S(P));
                                else if (I[1]) M(O);
                                else {
                                    var D = I[4], R = {
                                        type: O
                                    }, F = T(D, x);
                                    if (F ? (F = F.replace(k, "$1 fill:"), z && (F += ";" + z)) : z && (F = z), F && (R.style = F), "a" === O) {
                                        a = !0;
                                        var B = T(D, b);
                                        if (B) {
                                            var N = E(B);
                                            N && (R.href = N, R.target = T(D, _) || "_blank", R.popup = T(D, w));
                                        }
                                    }
                                    d(R);
                                }
                            }
                            return a;
                        }(t1.node(), A) && t1.style("pointer-events", "all"), r.positionText(t1), d && d.call(t1);
                    }
                };
                var c = /(<|&lt;|&#60;)/g, u = /(>|&gt;|&#62;)/g;
                var f = {
                    sup: "font-size:70%",
                    sub: "font-size:70%",
                    b: "font-weight:bold",
                    i: "font-style:italic",
                    a: "cursor:pointer",
                    span: "",
                    em: "font-style:italic;font-weight:bold"
                }, h = {
                    sub: "0.3em",
                    sup: "-0.6em"
                }, p = {
                    sub: "-0.21em",
                    sup: "0.42em"
                }, d = [
                    "http:",
                    "https:",
                    "mailto:",
                    "",
                    void 0,
                    ":"
                ], m = r.NEWLINES = /(\r\n?|\n)/g, g = /(<[^<>]*>)/, v = /<(\/?)([^ >]*)(\s+(.*))?>/i, y = /<br(\s+.*)?>/i;
                r.BR_TAG_ALL = /<br(\s+.*)?>/gi;
                var x = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i, b = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i, _ = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i, w = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;
                function T(t1, e1) {
                    if (!t1) return null;
                    var r = t1.match(e1), n = r && (r[3] || r[4]);
                    return n && S(n);
                }
                var k = /(^|;)\s*color:/;
                r.plainText = function(t1, e1) {
                    for(var r = void 0 !== (e1 = e1 || {}).len && -1 !== e1.len ? e1.len : 1 / 0, n = void 0 !== e1.allowedTags ? e1.allowedTags : [
                        "br"
                    ], i = 3, a = t1.split(g), o = [], s = "", l = 0, c = 0; c < a.length; c++){
                        var u = a[c], f = u.match(v), h = f && f[2].toLowerCase();
                        if (h) -1 !== n.indexOf(h) && (o.push(u), s = h);
                        else {
                            var p = u.length;
                            if (l + p < r) o.push(u), l += p;
                            else if (l < r) {
                                var d = r - l;
                                s && ("br" !== s || d <= i || p <= i) && o.pop(), r > i ? o.push(u.substr(0, d - i) + "...") : o.push(u.substr(0, d));
                                break;
                            }
                            s = "";
                        }
                    }
                    return o.join("");
                };
                var A = {
                    mu: "\u03bc",
                    amp: "&",
                    lt: "<",
                    gt: ">",
                    nbsp: "\xa0",
                    times: "\xd7",
                    plusmn: "\xb1",
                    deg: "\xb0"
                }, M = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
                function S(t1) {
                    return t1.replace(M, function(t1, e1) {
                        return ("#" === e1.charAt(0) ? function(t1) {
                            if (t1 > 1114111) return;
                            var e1 = String.fromCodePoint;
                            if (e1) return e1(t1);
                            var r = String.fromCharCode;
                            return t1 <= 65535 ? r(t1) : r(55232 + (t1 >> 10), t1 % 1024 + 56320);
                        }("x" === e1.charAt(1) ? parseInt(e1.substr(2), 16) : parseInt(e1.substr(1), 10)) : A[e1]) || t1;
                    });
                }
                function E(t1) {
                    var e1 = encodeURI(decodeURI(t1)), r = document.createElement("a"), n = document.createElement("a");
                    r.href = t1, n.href = e1;
                    var i = r.protocol, a = n.protocol;
                    return -1 !== d.indexOf(i) && -1 !== d.indexOf(a) ? e1 : "";
                }
                function L(t1, e1, r) {
                    var n, a, o, s = r.horizontalAlign, l = r.verticalAlign || "top", c = t1.node().getBoundingClientRect(), u = e1.node().getBoundingClientRect();
                    return a = "bottom" === l ? function() {
                        return c.bottom - n.height;
                    } : "middle" === l ? function() {
                        return c.top + (c.height - n.height) / 2;
                    } : function() {
                        return c.top;
                    }, o = "right" === s ? function() {
                        return c.right - n.width;
                    } : "center" === s ? function() {
                        return c.left + (c.width - n.width) / 2;
                    } : function() {
                        return c.left;
                    }, function() {
                        n = this.node().getBoundingClientRect();
                        var t1 = o() - u.left, e1 = a() - u.top, s = r.gd || {};
                        if (r.gd) {
                            s._fullLayout._calcInverseTransform(s);
                            var l = i.apply3DTransform(s._fullLayout._invTransform)(t1, e1);
                            t1 = l[0], e1 = l[1];
                        }
                        return this.style({
                            top: e1 + "px",
                            left: t1 + "px",
                            "z-index": 1e3
                        }), this;
                    };
                }
                r.convertEntities = S, r.sanitizeHTML = function(t1) {
                    t1 = t1.replace(m, " ");
                    for(var e1 = document.createElement("p"), r = e1, i = [], a = t1.split(g), o = 0; o < a.length; o++){
                        var s = a[o], l = s.match(v), c = l && l[2].toLowerCase();
                        if (c in f) {
                            if (l[1]) i.length && (r = i.pop());
                            else {
                                var u = l[4], h = T(u, x), p = h ? {
                                    style: h
                                } : {};
                                if ("a" === c) {
                                    var d = T(u, b);
                                    if (d) {
                                        var y = E(d);
                                        if (y) {
                                            p.href = y;
                                            var w = T(u, _);
                                            w && (p.target = w);
                                        }
                                    }
                                }
                                var k = document.createElement(c);
                                r.appendChild(k), n.select(k).attr(p), r = k, i.push(k);
                            }
                        } else r.appendChild(document.createTextNode(S(s)));
                    }
                    return e1.innerHTML;
                }, r.lineCount = function(t1) {
                    return t1.selectAll("tspan.line").size() || 1;
                }, r.positionText = function(t1, e1, r) {
                    return t1.each(function() {
                        var t1 = n.select(this);
                        function i(e1, r) {
                            return void 0 === r ? null === (r = t1.attr(e1)) && (t1.attr(e1, 0), r = 0) : t1.attr(e1, r), r;
                        }
                        var a = i("x", e1), o = i("y", r);
                        "text" === this.nodeName && t1.selectAll("tspan.line").attr({
                            x: a,
                            y: o
                        });
                    });
                };
                r.makeTextShadow = function(t1) {
                    var e1 = "1px ", r = "1px ", n = "1px ";
                    return e1 + r + n + t1 + ", -" + e1 + "-" + r + n + t1 + ", " + e1 + "-" + r + n + t1 + ", -" + e1 + r + n + t1;
                }, r.makeEditable = function(t1, e1) {
                    var r = e1.gd, i = e1.delegate, a = n.dispatch("edit", "input", "cancel"), o = i || t1;
                    if (t1.style({
                        "pointer-events": i ? "none" : "all"
                    }), 1 !== t1.size()) throw new Error("boo");
                    function s() {
                        !function() {
                            var i = n.select(r).select(".svg-container"), o = i.append("div"), s = t1.node().style, c = parseFloat(s.fontSize || 12), u = e1.text;
                            void 0 === u && (u = t1.attr("data-unformatted"));
                            o.classed("plugin-editable editable", !0).style({
                                position: "absolute",
                                "font-family": s.fontFamily || "Arial",
                                "font-size": c,
                                color: e1.fill || s.fill || "black",
                                opacity: 1,
                                "background-color": e1.background || "transparent",
                                outline: "#ffffff33 1px solid",
                                margin: [
                                    -c / 8 + 1,
                                    0,
                                    0,
                                    -1
                                ].join("px ") + "px",
                                padding: "0",
                                "box-sizing": "border-box"
                            }).attr({
                                contenteditable: !0
                            }).text(u).call(L(t1, i, e1)).on("blur", function() {
                                r._editing = !1, t1.text(this.textContent).style({
                                    opacity: 1
                                });
                                var e1, i = n.select(this).attr("class");
                                (e1 = i ? "." + i.split(" ")[0] + "-math-group" : "[class*=-math-group]") && n.select(t1.node().parentNode).select(e1).style({
                                    opacity: 0
                                });
                                var o = this.textContent;
                                n.select(this).transition().duration(0).remove(), n.select(document).on("mouseup", null), a.edit.call(t1, o);
                            }).on("focus", function() {
                                var t1 = this;
                                r._editing = !0, n.select(document).on("mouseup", function() {
                                    if (n.event.target === t1) return !1;
                                    document.activeElement === o.node() && o.node().blur();
                                });
                            }).on("keyup", function() {
                                27 === n.event.which ? (r._editing = !1, t1.style({
                                    opacity: 1
                                }), n.select(this).style({
                                    opacity: 0
                                }).on("blur", function() {
                                    return !1;
                                }).transition().remove(), a.cancel.call(t1, this.textContent)) : (a.input.call(t1, this.textContent), n.select(this).call(L(t1, i, e1)));
                            }).on("keydown", function() {
                                13 === n.event.which && this.blur();
                            }).call(l);
                        }(), t1.style({
                            opacity: 0
                        });
                        var i, s = o.attr("class");
                        (i = s ? "." + s.split(" ")[0] + "-math-group" : "[class*=-math-group]") && n.select(t1.node().parentNode).select(i).style({
                            opacity: 0
                        });
                    }
                    function l(t1) {
                        var e1 = t1.node(), r = document.createRange();
                        r.selectNodeContents(e1);
                        var n = window.getSelection();
                        n.removeAllRanges(), n.addRange(r), e1.focus();
                    }
                    return e1.immediate ? s() : o.on("click", s), n.rebind(t1, a, "on");
                };
            },
            {
                "../constants/alignment": 471,
                "../constants/xmlns_namespaces": 480,
                "../lib": 503,
                "@plotly/d3": 58
            }
        ],
        530: [
            function(t1, e1, r) {
                "use strict";
                var n = {};
                function i(t1) {
                    t1 && null !== t1.timer && (clearTimeout(t1.timer), t1.timer = null);
                }
                r.throttle = function(t1, e1, r) {
                    var a = n[t1], o = Date.now();
                    if (!a) {
                        for(var s in n)n[s].ts < o - 6e4 && delete n[s];
                        a = n[t1] = {
                            ts: 0,
                            timer: null
                        };
                    }
                    function l() {
                        r(), a.ts = Date.now(), a.onDone && (a.onDone(), a.onDone = null);
                    }
                    i(a), o > a.ts + e1 ? l() : a.timer = setTimeout(function() {
                        l(), a.timer = null;
                    }, e1);
                }, r.done = function(t1) {
                    var e1 = n[t1];
                    return e1 && e1.timer ? new Promise(function(t1) {
                        var r = e1.onDone;
                        e1.onDone = function() {
                            r && r(), t1(), e1.onDone = null;
                        };
                    }) : Promise.resolve();
                }, r.clear = function(t1) {
                    if (t1) i(n[t1]), delete n[t1];
                    else for(var e1 in n)r.clear(e1);
                };
            },
            {}
        ],
        531: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric");
                e1.exports = function(t1, e1) {
                    if (t1 > 0) return Math.log(t1) / Math.LN10;
                    var r = Math.log(Math.min(e1[0], e1[1])) / Math.LN10;
                    return n(r) || (r = Math.log(Math.max(e1[0], e1[1])) / Math.LN10 - 6), r;
                };
            },
            {
                "fast-isnumeric": 190
            }
        ],
        532: [
            function(t1, e1, r) {
                "use strict";
                var n = e1.exports = {}, i = t1("../plots/geo/constants").locationmodeToLayer, a = t1("topojson-client").feature;
                n.getTopojsonName = function(t1) {
                    return [
                        t1.scope.replace(/ /g, "-"),
                        "_",
                        t1.resolution.toString(),
                        "m"
                    ].join("");
                }, n.getTopojsonPath = function(t1, e1) {
                    return t1 + e1 + ".json";
                }, n.getTopojsonFeatures = function(t1, e1) {
                    var r = i[t1.locationmode], n = e1.objects[r];
                    return a(e1, n).features;
                };
            },
            {
                "../plots/geo/constants": 587,
                "topojson-client": 315
            }
        ],
        533: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "locale",
                    name: "en-US",
                    dictionary: {
                        "Click to enter Colorscale title": "Click to enter Colorscale title"
                    },
                    format: {
                        date: "%m/%d/%Y"
                    }
                };
            },
            {}
        ],
        534: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "locale",
                    name: "en",
                    dictionary: {
                        "Click to enter Colorscale title": "Click to enter Colourscale title"
                    },
                    format: {
                        days: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ],
                        shortDays: [
                            "Sun",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat"
                        ],
                        months: [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ],
                        shortMonths: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ],
                        periods: [
                            "AM",
                            "PM"
                        ],
                        dateTime: "%a %b %e %X %Y",
                        date: "%d/%m/%Y",
                        time: "%H:%M:%S",
                        decimal: ".",
                        thousands: ",",
                        grouping: [
                            3
                        ],
                        currency: [
                            "$",
                            ""
                        ],
                        year: "%Y",
                        month: "%b %Y",
                        dayMonth: "%b %-d",
                        dayMonthYear: "%b %-d, %Y"
                    }
                };
            },
            {}
        ],
        535: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../registry");
                e1.exports = function(t1) {
                    for(var e1, r, i = n.layoutArrayContainers, a = n.layoutArrayRegexes, o = t1.split("[")[0], s = 0; s < a.length; s++)if ((r = t1.match(a[s])) && 0 === r.index) {
                        e1 = r[0];
                        break;
                    }
                    if (e1 || (e1 = i[i.indexOf(o)]), !e1) return !1;
                    var l = t1.substr(e1.length);
                    return l ? !!(r = l.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/)) && {
                        array: e1,
                        index: Number(r[1]),
                        property: r[3] || ""
                    } : {
                        array: e1,
                        index: "",
                        property: ""
                    };
                };
            },
            {
                "../registry": 638
            }
        ],
        536: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = n.extendFlat, a = n.isPlainObject, o = {
                    valType: "flaglist",
                    extras: [
                        "none"
                    ],
                    flags: [
                        "calc",
                        "clearAxisTypes",
                        "plot",
                        "style",
                        "markerSize",
                        "colorbars"
                    ]
                }, s = {
                    valType: "flaglist",
                    extras: [
                        "none"
                    ],
                    flags: [
                        "calc",
                        "plot",
                        "legend",
                        "ticks",
                        "axrange",
                        "layoutstyle",
                        "modebar",
                        "camera",
                        "arraydraw",
                        "colorbars"
                    ]
                }, l = o.flags.slice().concat([
                    "fullReplot"
                ]), c = s.flags.slice().concat("layoutReplot");
                function u(t1) {
                    for(var e1 = {}, r = 0; r < t1.length; r++)e1[t1[r]] = !1;
                    return e1;
                }
                function f(t1, e1, r) {
                    var n = i({}, t1);
                    for(var o in n){
                        var s = n[o];
                        a(s) && (n[o] = h(s, e1, r, o));
                    }
                    return "from-root" === r && (n.editType = e1), n;
                }
                function h(t1, e1, r, n) {
                    if (t1.valType) {
                        var a = i({}, t1);
                        if (a.editType = e1, Array.isArray(t1.items)) {
                            a.items = new Array(t1.items.length);
                            for(var o = 0; o < t1.items.length; o++)a.items[o] = h(t1.items[o], e1, "from-root");
                        }
                        return a;
                    }
                    return f(t1, e1, "_" === n.charAt(0) ? "nested" : "from-root");
                }
                e1.exports = {
                    traces: o,
                    layout: s,
                    traceFlags: function() {
                        return u(l);
                    },
                    layoutFlags: function() {
                        return u(c);
                    },
                    update: function(t1, e1) {
                        var r = e1.editType;
                        if (r && "none" !== r) for(var n = r.split("+"), i = 0; i < n.length; i++)t1[n[i]] = !0;
                    },
                    overrideAll: f
                };
            },
            {
                "../lib": 503
            }
        ],
        537: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("gl-mat4/fromQuat"), a = t1("../registry"), o = t1("../lib"), s = t1("../plots/plots"), l = t1("../plots/cartesian/axis_ids"), c = t1("../components/color"), u = l.cleanId, f = l.getFromTrace, h = a.traceIs;
                function p(t1, e1) {
                    var r = t1[e1], n = e1.charAt(0);
                    r && "paper" !== r && (t1[e1] = u(r, n, !0));
                }
                function d(t1) {
                    function e1(e1, r) {
                        var n = t1[e1], i = t1.title && t1.title[r];
                        n && !i && (t1.title || (t1.title = {}), t1.title[r] = t1[e1], delete t1[e1]);
                    }
                    t1 && ("string" != typeof t1.title && "number" != typeof t1.title || (t1.title = {
                        text: t1.title
                    }), e1("titlefont", "font"), e1("titleposition", "position"), e1("titleside", "side"), e1("titleoffset", "offset"));
                }
                function m(t1) {
                    if (!o.isPlainObject(t1)) return !1;
                    var e1 = t1.name;
                    return delete t1.name, delete t1.showlegend, ("string" == typeof e1 || "number" == typeof e1) && String(e1);
                }
                function g(t1, e1, r, n) {
                    if (r && !n) return t1;
                    if (n && !r) return e1;
                    if (!t1.trim()) return e1;
                    if (!e1.trim()) return t1;
                    var i, a = Math.min(t1.length, e1.length);
                    for(i = 0; i < a && t1.charAt(i) === e1.charAt(i); i++);
                    return t1.substr(0, i).trim();
                }
                function v(t1) {
                    var e1 = "middle", r = "center";
                    return "string" == typeof t1 && (-1 !== t1.indexOf("top") ? e1 = "top" : -1 !== t1.indexOf("bottom") && (e1 = "bottom"), -1 !== t1.indexOf("left") ? r = "left" : -1 !== t1.indexOf("right") && (r = "right")), e1 + " " + r;
                }
                function y(t1, e1) {
                    return e1 in t1 && "object" == typeof t1[e1] && 0 === Object.keys(t1[e1]).length;
                }
                r.clearPromiseQueue = function(t1) {
                    Array.isArray(t1._promises) && t1._promises.length > 0 && o.log("Clearing previous rejected promises from queue."), t1._promises = [];
                }, r.cleanLayout = function(t1) {
                    var e1, n;
                    t1 || (t1 = {}), t1.xaxis1 && (t1.xaxis || (t1.xaxis = t1.xaxis1), delete t1.xaxis1), t1.yaxis1 && (t1.yaxis || (t1.yaxis = t1.yaxis1), delete t1.yaxis1), t1.scene1 && (t1.scene || (t1.scene = t1.scene1), delete t1.scene1);
                    var a = (s.subplotsRegistry.cartesian || {}).attrRegex, l = (s.subplotsRegistry.polar || {}).attrRegex, f = (s.subplotsRegistry.ternary || {}).attrRegex, h = (s.subplotsRegistry.gl3d || {}).attrRegex, m = Object.keys(t1);
                    for(e1 = 0; e1 < m.length; e1++){
                        var g = m[e1];
                        if (a && a.test(g)) {
                            var v = t1[g];
                            v.anchor && "free" !== v.anchor && (v.anchor = u(v.anchor)), v.overlaying && (v.overlaying = u(v.overlaying)), v.type || (v.isdate ? v.type = "date" : v.islog ? v.type = "log" : !1 === v.isdate && !1 === v.islog && (v.type = "linear")), "withzero" !== v.autorange && "tozero" !== v.autorange || (v.autorange = !0, v.rangemode = "tozero"), delete v.islog, delete v.isdate, delete v.categories, y(v, "domain") && delete v.domain, void 0 !== v.autotick && (void 0 === v.tickmode && (v.tickmode = v.autotick ? "auto" : "linear"), delete v.autotick), d(v);
                        } else if (l && l.test(g)) d(t1[g].radialaxis);
                        else if (f && f.test(g)) {
                            var x = t1[g];
                            d(x.aaxis), d(x.baxis), d(x.caxis);
                        } else if (h && h.test(g)) {
                            var b = t1[g], _ = b.cameraposition;
                            if (Array.isArray(_) && 4 === _[0].length) {
                                var w = _[0], T = _[1], k = _[2], A = i([], w), M = [];
                                for(n = 0; n < 3; ++n)M[n] = T[n] + k * A[2 + 4 * n];
                                b.camera = {
                                    eye: {
                                        x: M[0],
                                        y: M[1],
                                        z: M[2]
                                    },
                                    center: {
                                        x: T[0],
                                        y: T[1],
                                        z: T[2]
                                    },
                                    up: {
                                        x: 0,
                                        y: 0,
                                        z: 1
                                    }
                                }, delete b.cameraposition;
                            }
                            d(b.xaxis), d(b.yaxis), d(b.zaxis);
                        }
                    }
                    var S = Array.isArray(t1.annotations) ? t1.annotations.length : 0;
                    for(e1 = 0; e1 < S; e1++){
                        var E = t1.annotations[e1];
                        o.isPlainObject(E) && (E.ref && ("paper" === E.ref ? (E.xref = "paper", E.yref = "paper") : "data" === E.ref && (E.xref = "x", E.yref = "y"), delete E.ref), p(E, "xref"), p(E, "yref"));
                    }
                    var L = Array.isArray(t1.shapes) ? t1.shapes.length : 0;
                    for(e1 = 0; e1 < L; e1++){
                        var C = t1.shapes[e1];
                        o.isPlainObject(C) && (p(C, "xref"), p(C, "yref"));
                    }
                    var P = Array.isArray(t1.images) ? t1.images.length : 0;
                    for(e1 = 0; e1 < P; e1++){
                        var I = t1.images[e1];
                        o.isPlainObject(I) && (p(I, "xref"), p(I, "yref"));
                    }
                    var O = t1.legend;
                    return O && (O.x > 3 ? (O.x = 1.02, O.xanchor = "left") : O.x < -2 && (O.x = -0.02, O.xanchor = "right"), O.y > 3 ? (O.y = 1.02, O.yanchor = "bottom") : O.y < -2 && (O.y = -0.02, O.yanchor = "top")), d(t1), "rotate" === t1.dragmode && (t1.dragmode = "orbit"), c.clean(t1), t1.template && t1.template.layout && r.cleanLayout(t1.template.layout), t1;
                }, r.cleanData = function(t1) {
                    for(var e1 = 0; e1 < t1.length; e1++){
                        var n, i = t1[e1];
                        if ("histogramy" === i.type && "xbins" in i && !("ybins" in i) && (i.ybins = i.xbins, delete i.xbins), i.error_y && "opacity" in i.error_y) {
                            var l = c.defaults, f = i.error_y.color || (h(i, "bar") ? c.defaultLine : l[e1 % l.length]);
                            i.error_y.color = c.addOpacity(c.rgb(f), c.opacity(f) * i.error_y.opacity), delete i.error_y.opacity;
                        }
                        if ("bardir" in i && ("h" !== i.bardir || !h(i, "bar") && "histogram" !== i.type.substr(0, 9) || (i.orientation = "h", r.swapXYData(i)), delete i.bardir), "histogramy" === i.type && r.swapXYData(i), "histogramx" !== i.type && "histogramy" !== i.type || (i.type = "histogram"), "scl" in i && !("colorscale" in i) && (i.colorscale = i.scl, delete i.scl), "reversescl" in i && !("reversescale" in i) && (i.reversescale = i.reversescl, delete i.reversescl), i.xaxis && (i.xaxis = u(i.xaxis, "x")), i.yaxis && (i.yaxis = u(i.yaxis, "y")), h(i, "gl3d") && i.scene && (i.scene = s.subplotsRegistry.gl3d.cleanId(i.scene)), !h(i, "pie-like") && !h(i, "bar-like")) {
                            if (Array.isArray(i.textposition)) for(n = 0; n < i.textposition.length; n++)i.textposition[n] = v(i.textposition[n]);
                            else i.textposition && (i.textposition = v(i.textposition));
                        }
                        var p = a.getModule(i);
                        if (p && p.colorbar) {
                            var x = p.colorbar.container, b = x ? i[x] : i;
                            b && b.colorscale && ("YIGnBu" === b.colorscale && (b.colorscale = "YlGnBu"), "YIOrRd" === b.colorscale && (b.colorscale = "YlOrRd"));
                        }
                        if ("surface" === i.type && o.isPlainObject(i.contours)) {
                            var _ = [
                                "x",
                                "y",
                                "z"
                            ];
                            for(n = 0; n < _.length; n++){
                                var w = i.contours[_[n]];
                                o.isPlainObject(w) && (w.highlightColor && (w.highlightcolor = w.highlightColor, delete w.highlightColor), w.highlightWidth && (w.highlightwidth = w.highlightWidth, delete w.highlightWidth));
                            }
                        }
                        if ("candlestick" === i.type || "ohlc" === i.type) {
                            var T = !1 !== (i.increasing || {}).showlegend, k = !1 !== (i.decreasing || {}).showlegend, A = m(i.increasing), M = m(i.decreasing);
                            if (!1 !== A && !1 !== M) {
                                var S = g(A, M, T, k);
                                S && (i.name = S);
                            } else !A && !M || i.name || (i.name = A || M);
                        }
                        if (Array.isArray(i.transforms)) {
                            var E = i.transforms;
                            for(n = 0; n < E.length; n++){
                                var L = E[n];
                                if (o.isPlainObject(L)) switch(L.type){
                                    case "filter":
                                        L.filtersrc && (L.target = L.filtersrc, delete L.filtersrc), L.calendar && (L.valuecalendar || (L.valuecalendar = L.calendar), delete L.calendar);
                                        break;
                                    case "groupby":
                                        if (L.styles = L.styles || L.style, L.styles && !Array.isArray(L.styles)) {
                                            var C = L.styles, P = Object.keys(C);
                                            L.styles = [];
                                            for(var I = 0; I < P.length; I++)L.styles.push({
                                                target: P[I],
                                                value: C[P[I]]
                                            });
                                        }
                                }
                            }
                        }
                        y(i, "line") && delete i.line, "marker" in i && (y(i.marker, "line") && delete i.marker.line, y(i, "marker") && delete i.marker), c.clean(i), i.autobinx && (delete i.autobinx, delete i.xbins), i.autobiny && (delete i.autobiny, delete i.ybins), d(i), i.colorbar && d(i.colorbar), i.marker && i.marker.colorbar && d(i.marker.colorbar), i.line && i.line.colorbar && d(i.line.colorbar), i.aaxis && d(i.aaxis), i.baxis && d(i.baxis);
                    }
                }, r.swapXYData = function(t1) {
                    var e1;
                    if (o.swapAttrs(t1, [
                        "?",
                        "?0",
                        "d?",
                        "?bins",
                        "nbins?",
                        "autobin?",
                        "?src",
                        "error_?"
                    ]), Array.isArray(t1.z) && Array.isArray(t1.z[0]) && (t1.transpose ? delete t1.transpose : t1.transpose = !0), t1.error_x && t1.error_y) {
                        var r = t1.error_y, n = "copy_ystyle" in r ? r.copy_ystyle : !(r.color || r.thickness || r.width);
                        o.swapAttrs(t1, [
                            "error_?.copy_ystyle"
                        ]), n && o.swapAttrs(t1, [
                            "error_?.color",
                            "error_?.thickness",
                            "error_?.width"
                        ]);
                    }
                    if ("string" == typeof t1.hoverinfo) {
                        var i = t1.hoverinfo.split("+");
                        for(e1 = 0; e1 < i.length; e1++)"x" === i[e1] ? i[e1] = "y" : "y" === i[e1] && (i[e1] = "x");
                        t1.hoverinfo = i.join("+");
                    }
                }, r.coerceTraceIndices = function(t1, e1) {
                    if (n(e1)) return [
                        e1
                    ];
                    if (!Array.isArray(e1) || !e1.length) return t1.data.map(function(t1, e1) {
                        return e1;
                    });
                    if (Array.isArray(e1)) {
                        for(var r = [], i = 0; i < e1.length; i++)o.isIndex(e1[i], t1.data.length) ? r.push(e1[i]) : o.warn("trace index (", e1[i], ") is not a number or is out of bounds");
                        return r;
                    }
                    return e1;
                }, r.manageArrayContainers = function(t1, e1, r) {
                    var i = t1.obj, a = t1.parts, s = a.length, l = a[s - 1], c = n(l);
                    if (c && null === e1) {
                        var u = a.slice(0, s - 1).join(".");
                        o.nestedProperty(i, u).get().splice(l, 1);
                    } else c && void 0 === t1.get() ? (void 0 === t1.get() && (r[t1.astr] = null), t1.set(e1)) : t1.set(e1);
                };
                var x = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
                function b(t1) {
                    var e1 = t1.search(x);
                    if (e1 > 0) return t1.substr(0, e1);
                }
                r.hasParent = function(t1, e1) {
                    for(var r = b(e1); r;){
                        if (r in t1) return !0;
                        r = b(r);
                    }
                    return !1;
                };
                var _ = [
                    "x",
                    "y",
                    "z"
                ];
                r.clearAxisTypes = function(t1, e1, r) {
                    for(var n = 0; n < e1.length; n++)for(var i = t1._fullData[n], a = 0; a < 3; a++){
                        var s = f(t1, i, _[a]);
                        if (s && "log" !== s.type) {
                            var l = s._name, c = s._id.substr(1);
                            if ("scene" === c.substr(0, 5)) {
                                if (void 0 !== r[c]) continue;
                                l = c + "." + l;
                            }
                            var u = l + ".type";
                            void 0 === r[l] && void 0 === r[u] && o.nestedProperty(t1.layout, u).set(null);
                        }
                    }
                };
            },
            {
                "../components/color": 366,
                "../lib": 503,
                "../plots/cartesian/axis_ids": 558,
                "../plots/plots": 619,
                "../registry": 638,
                "fast-isnumeric": 190,
                "gl-mat4/fromQuat": 200
            }
        ],
        538: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./plot_api");
                r._doPlot = n._doPlot, r.newPlot = n.newPlot, r.restyle = n.restyle, r.relayout = n.relayout, r.redraw = n.redraw, r.update = n.update, r._guiRestyle = n._guiRestyle, r._guiRelayout = n._guiRelayout, r._guiUpdate = n._guiUpdate, r._storeDirectGUIEdit = n._storeDirectGUIEdit, r.react = n.react, r.extendTraces = n.extendTraces, r.prependTraces = n.prependTraces, r.addTraces = n.addTraces, r.deleteTraces = n.deleteTraces, r.moveTraces = n.moveTraces, r.purge = n.purge, r.addFrames = n.addFrames, r.deleteFrames = n.deleteFrames, r.animate = n.animate, r.setPlotConfig = n.setPlotConfig, r.toImage = t1("./to_image"), r.validate = t1("./validate"), r.downloadImage = t1("../snapshot/download");
                var i = t1("./template_api");
                r.makeTemplate = i.makeTemplate, r.validateTemplate = i.validateTemplate;
            },
            {
                "../snapshot/download": 640,
                "./plot_api": 540,
                "./template_api": 545,
                "./to_image": 546,
                "./validate": 547
            }
        ],
        539: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib/is_plain_object"), i = t1("../lib/noop"), a = t1("../lib/loggers"), o = t1("../lib/search").sorterAsc, s = t1("../registry");
                r.containerArrayMatch = t1("./container_array_match");
                var l = r.isAddVal = function(t1) {
                    return "add" === t1 || n(t1);
                }, c = r.isRemoveVal = function(t1) {
                    return null === t1 || "remove" === t1;
                };
                r.applyContainerArrayChanges = function(t1, e1, r, n, u) {
                    var f = e1.astr, h = s.getComponentMethod(f, "supplyLayoutDefaults"), p = s.getComponentMethod(f, "draw"), d = s.getComponentMethod(f, "drawOne"), m = n.replot || n.recalc || h === i || p === i, g = t1.layout, v = t1._fullLayout;
                    if (r[""]) {
                        Object.keys(r).length > 1 && a.warn("Full array edits are incompatible with other edits", f);
                        var y = r[""][""];
                        if (c(y)) e1.set(null);
                        else {
                            if (!Array.isArray(y)) return a.warn("Unrecognized full array edit value", f, y), !0;
                            e1.set(y);
                        }
                        return !m && (h(g, v), p(t1), !0);
                    }
                    var x, b, _, w, T, k, A, M, S = Object.keys(r).map(Number).sort(o), E = e1.get(), L = E || [], C = u(v, f).get(), P = [], I = -1, O = L.length;
                    for(x = 0; x < S.length; x++)if (w = r[_ = S[x]], T = Object.keys(w), k = w[""], A = l(k), _ < 0 || _ > L.length - (A ? 0 : 1)) a.warn("index out of range", f, _);
                    else if (void 0 !== k) T.length > 1 && a.warn("Insertion & removal are incompatible with edits to the same index.", f, _), c(k) ? P.push(_) : A ? ("add" === k && (k = {}), L.splice(_, 0, k), C && C.splice(_, 0, {})) : a.warn("Unrecognized full object edit value", f, _, k), -1 === I && (I = _);
                    else for(b = 0; b < T.length; b++)M = f + "[" + _ + "].", u(L[_], T[b], M).set(w[T[b]]);
                    for(x = P.length - 1; x >= 0; x--)L.splice(P[x], 1), C && C.splice(P[x], 1);
                    if (L.length ? E || e1.set(L) : e1.set(null), m) return !1;
                    if (h(g, v), d !== i) {
                        var z;
                        if (-1 === I) z = S;
                        else {
                            for(O = Math.max(L.length, O), z = [], x = 0; x < S.length && !((_ = S[x]) >= I); x++)z.push(_);
                            for(x = I; x < O; x++)z.push(x);
                        }
                        for(x = 0; x < z.length; x++)d(t1, z[x]);
                    } else p(t1);
                    return !0;
                };
            },
            {
                "../lib/is_plain_object": 504,
                "../lib/loggers": 507,
                "../lib/noop": 512,
                "../lib/search": 523,
                "../registry": 638,
                "./container_array_match": 535
            }
        ],
        540: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("fast-isnumeric"), a = t1("has-hover"), o = t1("../lib"), s = o.nestedProperty, l = t1("../lib/events"), c = t1("../lib/queue"), u = t1("../registry"), f = t1("./plot_schema"), h = t1("../plots/plots"), p = t1("../plots/cartesian/axes"), d = t1("../components/drawing"), m = t1("../components/color"), g = t1("../plots/cartesian/graph_interact").initInteractions, v = t1("../constants/xmlns_namespaces"), y = t1("../plots/cartesian/select").clearSelect, x = t1("./plot_config").dfltConfig, b = t1("./manage_arrays"), _ = t1("./helpers"), w = t1("./subroutines"), T = t1("./edit_types"), k = t1("../plots/cartesian/constants").AX_NAME_PATTERN, A = 0;
                function M(t1) {
                    var e1 = t1._fullLayout;
                    e1._redrawFromAutoMarginCount ? e1._redrawFromAutoMarginCount-- : t1.emit("plotly_afterplot");
                }
                function S(t1, e1) {
                    try {
                        t1._fullLayout._paper.style("background", e1);
                    } catch (t1) {
                        o.error(t1);
                    }
                }
                function E(t1, e1) {
                    S(t1, m.combine(e1, "white"));
                }
                function L(t1, e1) {
                    if (!t1._context) {
                        t1._context = o.extendDeep({}, x);
                        var r = n.select("base");
                        t1._context._baseUrl = r.size() && r.attr("href") ? window.location.href.split("#")[0] : "";
                    }
                    var i, s, l, c = t1._context;
                    if (e1) {
                        for(s = Object.keys(e1), i = 0; i < s.length; i++)"editable" !== (l = s[i]) && "edits" !== l && l in c && ("setBackground" === l && "opaque" === e1[l] ? c[l] = E : c[l] = e1[l]);
                        e1.plot3dPixelRatio && !c.plotGlPixelRatio && (c.plotGlPixelRatio = c.plot3dPixelRatio);
                        var u = e1.editable;
                        if (void 0 !== u) for(c.editable = u, s = Object.keys(c.edits), i = 0; i < s.length; i++)c.edits[s[i]] = u;
                        if (e1.edits) for(s = Object.keys(e1.edits), i = 0; i < s.length; i++)(l = s[i]) in c.edits && (c.edits[l] = e1.edits[l]);
                        c._exportedPlot = e1._exportedPlot;
                    }
                    c.staticPlot && (c.editable = !1, c.edits = {}, c.autosizable = !1, c.scrollZoom = !1, c.doubleClick = !1, c.showTips = !1, c.showLink = !1, c.displayModeBar = !1), "hover" !== c.displayModeBar || a || (c.displayModeBar = !0), "transparent" !== c.setBackground && "function" == typeof c.setBackground || (c.setBackground = S), c._hasZeroHeight = c._hasZeroHeight || 0 === t1.clientHeight, c._hasZeroWidth = c._hasZeroWidth || 0 === t1.clientWidth;
                    var f = c.scrollZoom, h = c._scrollZoom = {};
                    if (!0 === f) h.cartesian = 1, h.gl3d = 1, h.geo = 1, h.mapbox = 1;
                    else if ("string" == typeof f) {
                        var p = f.split("+");
                        for(i = 0; i < p.length; i++)h[p[i]] = 1;
                    } else !1 !== f && (h.gl3d = 1, h.geo = 1, h.mapbox = 1);
                }
                function C(t1, e1) {
                    var r, n, i = e1 + 1, a = [];
                    for(r = 0; r < t1.length; r++)(n = t1[r]) < 0 ? a.push(i + n) : a.push(n);
                    return a;
                }
                function P(t1, e1, r) {
                    var n, i;
                    for(n = 0; n < e1.length; n++){
                        if ((i = e1[n]) !== parseInt(i, 10)) throw new Error("all values in " + r + " must be integers");
                        if (i >= t1.data.length || i < -t1.data.length) throw new Error(r + " must be valid indices for gd.data.");
                        if (e1.indexOf(i, n + 1) > -1 || i >= 0 && e1.indexOf(-t1.data.length + i) > -1 || i < 0 && e1.indexOf(t1.data.length + i) > -1) throw new Error("each index in " + r + " must be unique.");
                    }
                }
                function I(t1, e1, r) {
                    if (!Array.isArray(t1.data)) throw new Error("gd.data must be an array.");
                    if (void 0 === e1) throw new Error("currentIndices is a required argument.");
                    if (Array.isArray(e1) || (e1 = [
                        e1
                    ]), P(t1, e1, "currentIndices"), void 0 === r || Array.isArray(r) || (r = [
                        r
                    ]), void 0 !== r && P(t1, r, "newIndices"), void 0 !== r && e1.length !== r.length) throw new Error("current and new indices must be of equal length.");
                }
                function O(t1, e1, r, n, a) {
                    !function(t1, e1, r, n) {
                        var i = o.isPlainObject(n);
                        if (!Array.isArray(t1.data)) throw new Error("gd.data must be an array");
                        if (!o.isPlainObject(e1)) throw new Error("update must be a key:value object");
                        if (void 0 === r) throw new Error("indices must be an integer or array of integers");
                        for(var a in P(t1, r, "indices"), e1){
                            if (!Array.isArray(e1[a]) || e1[a].length !== r.length) throw new Error("attribute " + a + " must be an array of length equal to indices array length");
                            if (i && (!(a in n) || !Array.isArray(n[a]) || n[a].length !== e1[a].length)) throw new Error("when maxPoints is set as a key:value object it must contain a 1:1 corrispondence with the keys and number of traces in the update object");
                        }
                    }(t1, e1, r, n);
                    for(var l = function(t1, e1, r, n) {
                        var a, l, c, u, f, h = o.isPlainObject(n), p = [];
                        for(var d in Array.isArray(r) || (r = [
                            r
                        ]), r = C(r, t1.data.length - 1), e1)for(var m = 0; m < r.length; m++){
                            if (a = t1.data[r[m]], l = (c = s(a, d)).get(), u = e1[d][m], !o.isArrayOrTypedArray(u)) throw new Error("attribute: " + d + " index: " + m + " must be an array");
                            if (!o.isArrayOrTypedArray(l)) throw new Error("cannot extend missing or non-array attribute: " + d);
                            if (l.constructor !== u.constructor) throw new Error("cannot extend array with an array of a different type: " + d);
                            f = h ? n[d][m] : n, i(f) || (f = -1), p.push({
                                prop: c,
                                target: l,
                                insert: u,
                                maxp: Math.floor(f)
                            });
                        }
                        return p;
                    }(t1, e1, r, n), c = {}, u = {}, f = 0; f < l.length; f++){
                        var h = l[f].prop, p = l[f].maxp, d = a(l[f].target, l[f].insert, p);
                        h.set(d[0]), Array.isArray(c[h.astr]) || (c[h.astr] = []), c[h.astr].push(d[1]), Array.isArray(u[h.astr]) || (u[h.astr] = []), u[h.astr].push(l[f].target.length);
                    }
                    return {
                        update: c,
                        maxPoints: u
                    };
                }
                function z(t1, e1) {
                    var r = new t1.constructor(t1.length + e1.length);
                    return r.set(t1), r.set(e1, t1.length), r;
                }
                function D(t1, e1, n, i) {
                    t1 = o.getGraphDiv(t1), _.clearPromiseQueue(t1);
                    var a = {};
                    if ("string" == typeof e1) a[e1] = n;
                    else {
                        if (!o.isPlainObject(e1)) return o.warn("Restyle fail.", e1, n, i), Promise.reject();
                        a = o.extendFlat({}, e1), void 0 === i && (i = n);
                    }
                    Object.keys(a).length && (t1.changed = !0);
                    var s = _.coerceTraceIndices(t1, i), l = N(t1, a, s), u = l.flags;
                    u.calc && (t1.calcdata = void 0), u.clearAxisTypes && _.clearAxisTypes(t1, s, {});
                    var f = [];
                    u.fullReplot ? f.push(r._doPlot) : (f.push(h.previousPromises), h.supplyDefaults(t1), u.markerSize && (h.doCalcdata(t1), H(f)), u.style && f.push(w.doTraceStyle), u.colorbars && f.push(w.doColorBars), f.push(M)), f.push(h.rehover, h.redrag), c.add(t1, D, [
                        t1,
                        l.undoit,
                        l.traces
                    ], D, [
                        t1,
                        l.redoit,
                        l.traces
                    ]);
                    var p = o.syncOrAsync(f, t1);
                    return p && p.then || (p = Promise.resolve()), p.then(function() {
                        return t1.emit("plotly_restyle", l.eventData), t1;
                    });
                }
                function R(t1) {
                    return void 0 === t1 ? null : t1;
                }
                function F(t1, e1) {
                    return e1 ? function(e1, r, n) {
                        var i = s(e1, r), a = i.set;
                        return i.set = function(e1) {
                            B((n || "") + r, i.get(), e1, t1), a(e1);
                        }, i;
                    } : s;
                }
                function B(t1, e1, r, n) {
                    if (Array.isArray(e1) || Array.isArray(r)) for(var i = Array.isArray(e1) ? e1 : [], a = Array.isArray(r) ? r : [], s = Math.max(i.length, a.length), l = 0; l < s; l++)B(t1 + "[" + l + "]", i[l], a[l], n);
                    else if (o.isPlainObject(e1) || o.isPlainObject(r)) {
                        var c = o.isPlainObject(e1) ? e1 : {}, u = o.isPlainObject(r) ? r : {}, f = o.extendFlat({}, c, u);
                        for(var h in f)B(t1 + "." + h, c[h], u[h], n);
                    } else void 0 === n[t1] && (n[t1] = R(e1));
                }
                function N(t1, e1, r) {
                    var n, i = t1._fullLayout, a = t1._fullData, l = t1.data, c = i._guiEditing, d = F(i._preGUI, c), m = o.extendDeepAll({}, e1);
                    j(e1);
                    var g, v = T.traceFlags(), y = {}, x = {};
                    function b() {
                        return r.map(function() {});
                    }
                    function w(t1) {
                        var e1 = p.id2name(t1);
                        -1 === g.indexOf(e1) && g.push(e1);
                    }
                    function k(t1) {
                        return "LAYOUT" + t1 + ".autorange";
                    }
                    function A(t1) {
                        return "LAYOUT" + t1 + ".range";
                    }
                    function M(t1) {
                        for(var e1 = t1; e1 < a.length; e1++)if (a[e1]._input === l[t1]) return a[e1];
                    }
                    function S(n, a, o) {
                        if (Array.isArray(n)) n.forEach(function(t1) {
                            S(t1, a, o);
                        });
                        else if (!(n in e1) && !_.hasParent(e1, n)) {
                            var s;
                            if ("LAYOUT" === n.substr(0, 6)) s = d(t1.layout, n.replace("LAYOUT", ""));
                            else {
                                var u = r[o];
                                s = F(i._tracePreGUI[M(u)._fullInput.uid], c)(l[u], n);
                            }
                            n in x || (x[n] = b()), void 0 === x[n][o] && (x[n][o] = R(s.get())), void 0 !== a && s.set(a);
                        }
                    }
                    function E(t1) {
                        return function(e1) {
                            return a[e1][t1];
                        };
                    }
                    function L(t1) {
                        return function(e1, n) {
                            return !1 === e1 ? a[r[n]][t1] : null;
                        };
                    }
                    for(var C in e1){
                        if (_.hasParent(e1, C)) throw new Error("cannot set " + C + " and a parent attribute simultaneously");
                        var P, I, O, z, D, B, N = e1[C];
                        if ("autobinx" !== C && "autobiny" !== C || (C = C.charAt(C.length - 1) + "bins", N = Array.isArray(N) ? N.map(L(C)) : !1 === N ? r.map(E(C)) : null), y[C] = N, "LAYOUT" !== C.substr(0, 6)) {
                            for(x[C] = b(), n = 0; n < r.length; n++)if (P = l[r[n]], I = M(r[n]), z = (O = F(i._tracePreGUI[I._fullInput.uid], c)(P, C)).get(), void 0 !== (D = Array.isArray(N) ? N[n % N.length] : N)) {
                                var U = O.parts[O.parts.length - 1], V = C.substr(0, C.length - U.length - 1), H = V ? V + "." : "", q = V ? s(I, V).get() : I;
                                if ((B = f.getTraceValObject(I, O.parts)) && B.impliedEdits && null !== D) for(var G in B.impliedEdits)S(o.relativeAttr(C, G), B.impliedEdits[G], n);
                                else if ("thicknessmode" !== U && "lenmode" !== U || z === D || "fraction" !== D && "pixels" !== D || !q) {
                                    if ("type" === C && ("pie" === D != ("pie" === z) || "funnelarea" === D != ("funnelarea" === z))) {
                                        var Y = "x", W = "y";
                                        "bar" !== D && "bar" !== z || "h" !== P.orientation || (Y = "y", W = "x"), o.swapAttrs(P, [
                                            "?",
                                            "?src"
                                        ], "labels", Y), o.swapAttrs(P, [
                                            "d?",
                                            "?0"
                                        ], "label", Y), o.swapAttrs(P, [
                                            "?",
                                            "?src"
                                        ], "values", W), "pie" === z || "funnelarea" === z ? (s(P, "marker.color").set(s(P, "marker.colors").get()), i._pielayer.selectAll("g.trace").remove()) : u.traceIs(P, "cartesian") && s(P, "marker.colors").set(s(P, "marker.color").get());
                                    }
                                } else {
                                    var X = i._size, Z = q.orient, J = "top" === Z || "bottom" === Z;
                                    if ("thicknessmode" === U) {
                                        var K = J ? X.h : X.w;
                                        S(H + "thickness", q.thickness * ("fraction" === D ? 1 / K : K), n);
                                    } else {
                                        var Q = J ? X.w : X.h;
                                        S(H + "len", q.len * ("fraction" === D ? 1 / Q : Q), n);
                                    }
                                }
                                x[C][n] = R(z);
                                if (-1 !== [
                                    "swapxy",
                                    "swapxyaxes",
                                    "orientation",
                                    "orientationaxes"
                                ].indexOf(C)) {
                                    if ("orientation" === C) {
                                        O.set(D);
                                        var $ = P.x && !P.y ? "h" : "v";
                                        if ((O.get() || $) === I.orientation) continue;
                                    } else "orientationaxes" === C && (P.orientation = ({
                                        v: "h",
                                        h: "v"
                                    })[I.orientation]);
                                    _.swapXYData(P), v.calc = v.clearAxisTypes = !0;
                                } else -1 !== h.dataArrayContainers.indexOf(O.parts[0]) ? (_.manageArrayContainers(O, D, x), v.calc = !0) : (B ? B.arrayOk && !u.traceIs(I, "regl") && (o.isArrayOrTypedArray(D) || o.isArrayOrTypedArray(z)) ? v.calc = !0 : T.update(v, B) : v.calc = !0, O.set(D));
                            }
                            if (-1 !== [
                                "swapxyaxes",
                                "orientationaxes"
                            ].indexOf(C) && p.swap(t1, r), "orientationaxes" === C) {
                                var tt = s(t1.layout, "hovermode"), et = tt.get();
                                "x" === et ? tt.set("y") : "y" === et ? tt.set("x") : "x unified" === et ? tt.set("y unified") : "y unified" === et && tt.set("x unified");
                            }
                            if (-1 !== [
                                "orientation",
                                "type"
                            ].indexOf(C)) {
                                for(g = [], n = 0; n < r.length; n++){
                                    var rt = l[r[n]];
                                    u.traceIs(rt, "cartesian") && (w(rt.xaxis || "x"), w(rt.yaxis || "y"));
                                }
                                S(g.map(k), !0, 0), S(g.map(A), [
                                    0,
                                    1
                                ], 0);
                            }
                        } else O = d(t1.layout, C.replace("LAYOUT", "")), x[C] = [
                            R(O.get())
                        ], O.set(Array.isArray(N) ? N[0] : N), v.calc = !0;
                    }
                    return (v.calc || v.plot) && (v.fullReplot = !0), {
                        flags: v,
                        undoit: x,
                        redoit: y,
                        traces: r,
                        eventData: o.extendDeepNoArrays([], [
                            m,
                            r
                        ])
                    };
                }
                function j(t1) {
                    var e1, r, n, i = o.counterRegex("axis", ".title", !1, !1), a = /colorbar\.title$/, s = Object.keys(t1);
                    for(e1 = 0; e1 < s.length; e1++)r = s[e1], n = t1[r], "title" !== r && !i.test(r) && !a.test(r) || "string" != typeof n && "number" != typeof n ? r.indexOf("titlefont") > -1 && -1 === r.indexOf("grouptitlefont") ? l(r, r.replace("titlefont", "title.font")) : r.indexOf("titleposition") > -1 ? l(r, r.replace("titleposition", "title.position")) : r.indexOf("titleside") > -1 ? l(r, r.replace("titleside", "title.side")) : r.indexOf("titleoffset") > -1 && l(r, r.replace("titleoffset", "title.offset")) : l(r, r.replace("title", "title.text"));
                    function l(e1, r) {
                        t1[r] = t1[e1], delete t1[e1];
                    }
                }
                function U(t1, e1, r) {
                    t1 = o.getGraphDiv(t1), _.clearPromiseQueue(t1);
                    var n = {};
                    if ("string" == typeof e1) n[e1] = r;
                    else {
                        if (!o.isPlainObject(e1)) return o.warn("Relayout fail.", e1, r), Promise.reject();
                        n = o.extendFlat({}, e1);
                    }
                    Object.keys(n).length && (t1.changed = !0);
                    var i = W(t1, n), a = i.flags;
                    a.calc && (t1.calcdata = void 0);
                    var s = [
                        h.previousPromises
                    ];
                    a.layoutReplot ? s.push(w.layoutReplot) : Object.keys(n).length && (V(t1, a, i) || h.supplyDefaults(t1), a.legend && s.push(w.doLegend), a.layoutstyle && s.push(w.layoutStyles), a.axrange && H(s, i.rangesAltered), a.ticks && s.push(w.doTicksRelayout), a.modebar && s.push(w.doModeBar), a.camera && s.push(w.doCamera), a.colorbars && s.push(w.doColorBars), s.push(M)), s.push(h.rehover, h.redrag), c.add(t1, U, [
                        t1,
                        i.undoit
                    ], U, [
                        t1,
                        i.redoit
                    ]);
                    var l = o.syncOrAsync(s, t1);
                    return l && l.then || (l = Promise.resolve(t1)), l.then(function() {
                        return t1.emit("plotly_relayout", i.eventData), t1;
                    });
                }
                function V(t1, e1, r) {
                    var n = t1._fullLayout;
                    if (!e1.axrange) return !1;
                    for(var i in e1)if ("axrange" !== i && e1[i]) return !1;
                    for(var a in r.rangesAltered){
                        var o = p.id2name(a), s = t1.layout[o], l = n[o];
                        if (l.autorange = s.autorange, s.range && (l.range = s.range.slice()), l.cleanRange(), l._matchGroup) {
                            for(var c in l._matchGroup)if (c !== a) {
                                var u = n[p.id2name(c)];
                                u.autorange = l.autorange, u.range = l.range.slice(), u._input.range = l.range.slice();
                            }
                        }
                    }
                    return !0;
                }
                function H(t1, e1) {
                    var r = e1 ? function(t1) {
                        var r = [], n = !0;
                        for(var i in e1){
                            var a = p.getFromId(t1, i);
                            if (r.push(i), -1 !== (a.ticklabelposition || "").indexOf("inside") && a._anchorAxis && r.push(a._anchorAxis._id), a._matchGroup) for(var o in a._matchGroup)e1[o] || r.push(o);
                            a.automargin && (n = !1);
                        }
                        return p.draw(t1, r, {
                            skipTitle: n
                        });
                    } : function(t1) {
                        return p.draw(t1, "redraw");
                    };
                    t1.push(y, w.doAutoRangeAndConstraints, r, w.drawData, w.finalDraw);
                }
                var q = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/, G = /^[xyz]axis[0-9]*\.autorange$/, Y = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
                function W(t1, e1) {
                    var r, n, i, a = t1.layout, l = t1._fullLayout, c = l._guiEditing, h = F(l._preGUI, c), d = Object.keys(e1), m = p.list(t1), g = o.extendDeepAll({}, e1), v = {};
                    for(j(e1), d = Object.keys(e1), n = 0; n < d.length; n++)if (0 === d[n].indexOf("allaxes")) {
                        for(i = 0; i < m.length; i++){
                            var y = m[i]._id.substr(1), x = -1 !== y.indexOf("scene") ? y + "." : "", w = d[n].replace("allaxes", x + m[i]._name);
                            e1[w] || (e1[w] = e1[d[n]]);
                        }
                        delete e1[d[n]];
                    }
                    var A = T.layoutFlags(), M = {}, S = {};
                    function E(t1, r) {
                        if (Array.isArray(t1)) t1.forEach(function(t1) {
                            E(t1, r);
                        });
                        else if (!(t1 in e1) && !_.hasParent(e1, t1)) {
                            var n = h(a, t1);
                            t1 in S || (S[t1] = R(n.get())), void 0 !== r && n.set(r);
                        }
                    }
                    var L, C = {};
                    function P(t1) {
                        var e1 = p.name2id(t1.split(".")[0]);
                        return C[e1] = 1, e1;
                    }
                    for(var I in e1){
                        if (_.hasParent(e1, I)) throw new Error("cannot set " + I + " and a parent attribute simultaneously");
                        for(var O = h(a, I), z = e1[I], D = O.parts.length - 1; D > 0 && "string" != typeof O.parts[D];)D--;
                        var B = O.parts[D], N = O.parts[D - 1] + "." + B, U = O.parts.slice(0, D).join("."), V = s(t1.layout, U).get(), H = s(l, U).get(), W = O.get();
                        if (void 0 !== z) {
                            M[I] = z, S[I] = "reverse" === B ? z : R(W);
                            var Z = f.getLayoutValObject(l, O.parts);
                            if (Z && Z.impliedEdits && null !== z) for(var J in Z.impliedEdits)E(o.relativeAttr(I, J), Z.impliedEdits[J]);
                            if (-1 !== [
                                "width",
                                "height"
                            ].indexOf(I)) {
                                if (z) {
                                    E("autosize", null);
                                    var K = "height" === I ? "width" : "height";
                                    E(K, l[K]);
                                } else l[I] = t1._initialAutoSize[I];
                            } else if ("autosize" === I) E("width", z ? null : l.width), E("height", z ? null : l.height);
                            else if (N.match(q)) P(N), s(l, U + "._inputRange").set(null);
                            else if (N.match(G)) {
                                P(N), s(l, U + "._inputRange").set(null);
                                var Q = s(l, U).get();
                                Q._inputDomain && (Q._input.domain = Q._inputDomain.slice());
                            } else N.match(Y) && s(l, U + "._inputDomain").set(null);
                            if ("type" === B) {
                                L = V;
                                var $ = "linear" === H.type && "log" === z, tt = "log" === H.type && "linear" === z;
                                if ($ || tt) {
                                    if (L && L.range) {
                                        if (H.autorange) $ && (L.range = L.range[1] > L.range[0] ? [
                                            1,
                                            2
                                        ] : [
                                            2,
                                            1
                                        ]);
                                        else {
                                            var et = L.range[0], rt = L.range[1];
                                            $ ? (et <= 0 && rt <= 0 && E(U + ".autorange", !0), et <= 0 ? et = rt / 1e6 : rt <= 0 && (rt = et / 1e6), E(U + ".range[0]", Math.log(et) / Math.LN10), E(U + ".range[1]", Math.log(rt) / Math.LN10)) : (E(U + ".range[0]", Math.pow(10, et)), E(U + ".range[1]", Math.pow(10, rt)));
                                        }
                                    } else E(U + ".autorange", !0);
                                    Array.isArray(l._subplots.polar) && l._subplots.polar.length && l[O.parts[0]] && "radialaxis" === O.parts[1] && delete l[O.parts[0]]._subplot.viewInitial["radialaxis.range"], u.getComponentMethod("annotations", "convertCoords")(t1, H, z, E), u.getComponentMethod("images", "convertCoords")(t1, H, z, E);
                                } else E(U + ".autorange", !0), E(U + ".range", null);
                                s(l, U + "._inputRange").set(null);
                            } else if (B.match(k)) {
                                var nt = s(l, I).get(), it = (z || {}).type;
                                it && "-" !== it || (it = "linear"), u.getComponentMethod("annotations", "convertCoords")(t1, nt, it, E), u.getComponentMethod("images", "convertCoords")(t1, nt, it, E);
                            }
                            var at = b.containerArrayMatch(I);
                            if (at) {
                                r = at.array, n = at.index;
                                var ot = at.property, st = Z || {
                                    editType: "calc"
                                };
                                "" !== n && "" === ot && (b.isAddVal(z) ? S[I] = null : b.isRemoveVal(z) ? S[I] = (s(a, r).get() || [])[n] : o.warn("unrecognized full object value", e1)), T.update(A, st), v[r] || (v[r] = {});
                                var lt = v[r][n];
                                lt || (lt = v[r][n] = {}), lt[ot] = z, delete e1[I];
                            } else "reverse" === B ? (V.range ? V.range.reverse() : (E(U + ".autorange", !0), V.range = [
                                1,
                                0
                            ]), H.autorange ? A.calc = !0 : A.plot = !0) : (l._has("scatter-like") && l._has("regl") && "dragmode" === I && ("lasso" === z || "select" === z) && "lasso" !== W && "select" !== W || l._has("gl2d") ? A.plot = !0 : Z ? T.update(A, Z) : A.calc = !0, O.set(z));
                        }
                    }
                    for(r in v)b.applyContainerArrayChanges(t1, h(a, r), v[r], A, h) || (A.plot = !0);
                    for(var ct in C){
                        var ut = (L = p.getFromId(t1, ct)) && L._constraintGroup;
                        if (ut) for(var ft in A.calc = !0, ut)C[ft] || (p.getFromId(t1, ft)._constraintShrinkable = !0);
                    }
                    return (X(t1) || e1.height || e1.width) && (A.plot = !0), (A.plot || A.calc) && (A.layoutReplot = !0), {
                        flags: A,
                        rangesAltered: C,
                        undoit: S,
                        redoit: M,
                        eventData: g
                    };
                }
                function X(t1) {
                    var e1 = t1._fullLayout, r = e1.width, n = e1.height;
                    return t1.layout.autosize && h.plotAutoSize(t1, t1.layout, e1), e1.width !== r || e1.height !== n;
                }
                function Z(t1, e1, n, i) {
                    t1 = o.getGraphDiv(t1), _.clearPromiseQueue(t1), o.isPlainObject(e1) || (e1 = {}), o.isPlainObject(n) || (n = {}), Object.keys(e1).length && (t1.changed = !0), Object.keys(n).length && (t1.changed = !0);
                    var a = _.coerceTraceIndices(t1, i), s = N(t1, o.extendFlat({}, e1), a), l = s.flags, u = W(t1, o.extendFlat({}, n)), f = u.flags;
                    (l.calc || f.calc) && (t1.calcdata = void 0), l.clearAxisTypes && _.clearAxisTypes(t1, a, n);
                    var p = [];
                    f.layoutReplot ? p.push(w.layoutReplot) : l.fullReplot ? p.push(r._doPlot) : (p.push(h.previousPromises), V(t1, f, u) || h.supplyDefaults(t1), l.style && p.push(w.doTraceStyle), (l.colorbars || f.colorbars) && p.push(w.doColorBars), f.legend && p.push(w.doLegend), f.layoutstyle && p.push(w.layoutStyles), f.axrange && H(p, u.rangesAltered), f.ticks && p.push(w.doTicksRelayout), f.modebar && p.push(w.doModeBar), f.camera && p.push(w.doCamera), p.push(M)), p.push(h.rehover, h.redrag), c.add(t1, Z, [
                        t1,
                        s.undoit,
                        u.undoit,
                        s.traces
                    ], Z, [
                        t1,
                        s.redoit,
                        u.redoit,
                        s.traces
                    ]);
                    var d = o.syncOrAsync(p, t1);
                    return d && d.then || (d = Promise.resolve(t1)), d.then(function() {
                        return t1.emit("plotly_update", {
                            data: s.eventData,
                            layout: u.eventData
                        }), t1;
                    });
                }
                function J(t1) {
                    return function(e1) {
                        e1._fullLayout._guiEditing = !0;
                        var r = t1.apply(null, arguments);
                        return e1._fullLayout._guiEditing = !1, r;
                    };
                }
                var K = [
                    {
                        pattern: /^hiddenlabels/,
                        attr: "legend.uirevision"
                    },
                    {
                        pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/
                    },
                    {
                        pattern: /axis\d*\.showspikes$/,
                        attr: "modebar.uirevision"
                    },
                    {
                        pattern: /(hover|drag)mode$/,
                        attr: "modebar.uirevision"
                    },
                    {
                        pattern: /^(scene\d*)\.camera/
                    },
                    {
                        pattern: /^(geo\d*)\.(projection|center|fitbounds)/
                    },
                    {
                        pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/
                    },
                    {
                        pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/
                    },
                    {
                        pattern: /^(polar\d*\.angularaxis)\.rotation/
                    },
                    {
                        pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/
                    },
                    {
                        pattern: /^legend\.(x|y)$/,
                        attr: "editrevision"
                    },
                    {
                        pattern: /^(shapes|annotations)/,
                        attr: "editrevision"
                    },
                    {
                        pattern: /^title\.text$/,
                        attr: "editrevision"
                    }
                ], Q = [
                    {
                        pattern: /^selectedpoints$/,
                        attr: "selectionrevision"
                    },
                    {
                        pattern: /(^|value\.)visible$/,
                        attr: "legend.uirevision"
                    },
                    {
                        pattern: /^dimensions\[\d+\]\.constraintrange/
                    },
                    {
                        pattern: /^node\.(x|y|groups)/
                    },
                    {
                        pattern: /^level$/
                    },
                    {
                        pattern: /(^|value\.)name$/
                    },
                    {
                        pattern: /colorbar\.title\.text$/
                    },
                    {
                        pattern: /colorbar\.(x|y)$/,
                        attr: "editrevision"
                    }
                ];
                function $(t1, e1) {
                    for(var r = 0; r < e1.length; r++){
                        var n = e1[r], i = t1.match(n.pattern);
                        if (i) {
                            var a = i[1] || "";
                            return {
                                head: a,
                                tail: t1.substr(a.length + 1),
                                attr: n.attr
                            };
                        }
                    }
                }
                function tt(t1, e1) {
                    var r = s(e1, t1).get();
                    if (void 0 !== r) return r;
                    var n = t1.split(".");
                    for(n.pop(); n.length > 1;)if (n.pop(), void 0 !== (r = s(e1, n.join(".") + ".uirevision").get())) return r;
                    return e1.uirevision;
                }
                function et(t1, e1) {
                    for(var r = 0; r < e1.length; r++)if (e1[r]._fullInput.uid === t1) return r;
                    return -1;
                }
                function rt(t1, e1, r) {
                    for(var n = 0; n < e1.length; n++)if (e1[n].uid === t1) return n;
                    return !e1[r] || e1[r].uid ? -1 : r;
                }
                function nt(t1, e1) {
                    var r = o.isPlainObject(t1), n = Array.isArray(t1);
                    return r || n ? (r && o.isPlainObject(e1) || n && Array.isArray(e1)) && JSON.stringify(t1) === JSON.stringify(e1) : t1 === e1;
                }
                function it(t1, e1, r, n) {
                    var i, a, l, c = n.getValObject, u = n.flags, f = n.immutable, h = n.inArray, p = n.arrayIndex;
                    function d() {
                        var t1 = i.editType;
                        h && -1 !== t1.indexOf("arraydraw") ? o.pushUnique(u.arrays[h], p) : (T.update(u, i), "none" !== t1 && u.nChanges++, n.transition && i.anim && u.nChangesAnim++, (q.test(l) || G.test(l)) && (u.rangesAltered[r[0]] = 1), Y.test(l) && s(e1, "_inputDomain").set(null), "datarevision" === a && (u.newDataRevision = 1));
                    }
                    function m(t1) {
                        return "data_array" === t1.valType || t1.arrayOk;
                    }
                    for(a in t1){
                        if (u.calc && !n.transition) return;
                        var g = t1[a], v = e1[a], y = r.concat(a);
                        if (l = y.join("."), "_" !== a.charAt(0) && "function" != typeof g && g !== v) {
                            if (("tick0" === a || "dtick" === a) && "geo" !== r[0]) {
                                var x = e1.tickmode;
                                if ("auto" === x || "array" === x || !x) continue;
                            }
                            if (("range" !== a || !e1.autorange) && ("zmin" !== a && "zmax" !== a || "contourcarpet" !== e1.type) && (i = c(y)) && (!i._compareAsJSON || JSON.stringify(g) !== JSON.stringify(v))) {
                                var b, _ = i.valType, w = m(i), k = Array.isArray(g), A = Array.isArray(v);
                                if (k && A) {
                                    var M = "_input_" + a, S = t1[M], E = e1[M];
                                    if (Array.isArray(S) && S === E) continue;
                                }
                                if (void 0 === v) w && k ? u.calc = !0 : d();
                                else if (i._isLinkedToArray) {
                                    var L = [], C = !1;
                                    h || (u.arrays[a] = L);
                                    var P = Math.min(g.length, v.length), I = Math.max(g.length, v.length);
                                    if (P !== I) {
                                        if ("arraydraw" !== i.editType) {
                                            d();
                                            continue;
                                        }
                                        C = !0;
                                    }
                                    for(b = 0; b < P; b++)it(g[b], v[b], y.concat(b), o.extendFlat({
                                        inArray: a,
                                        arrayIndex: b
                                    }, n));
                                    if (C) for(b = P; b < I; b++)L.push(b);
                                } else !_ && o.isPlainObject(g) ? it(g, v, y, n) : w ? k && A ? (f && (u.calc = !0), (f || n.newDataRevision) && d()) : k !== A ? u.calc = !0 : d() : k && A && g.length === v.length && String(g) === String(v) || d();
                            }
                        }
                    }
                    for(a in e1)if (!(a in t1) && "_" !== a.charAt(0) && "function" != typeof e1[a]) {
                        if (m(i = c(r.concat(a))) && Array.isArray(e1[a])) return void (u.calc = !0);
                        d();
                    }
                }
                function at(t1) {
                    var e1 = t1._fullLayout, r = t1.getBoundingClientRect();
                    if (!o.equalDomRects(r, e1._lastBBox)) {
                        var n = e1._invTransform = o.inverseTransformMatrix(o.getFullTransformMatrix(t1));
                        e1._invScaleX = Math.sqrt(n[0][0] * n[0][0] + n[0][1] * n[0][1] + n[0][2] * n[0][2]), e1._invScaleY = Math.sqrt(n[1][0] * n[1][0] + n[1][1] * n[1][1] + n[1][2] * n[1][2]), e1._lastBBox = r;
                    }
                }
                r.animate = function(t1, e1, r) {
                    if (t1 = o.getGraphDiv(t1), !o.isPlotDiv(t1)) throw new Error("This element is not a Plotly plot: " + t1 + ". It's likely that you've failed to create a plot before animating it. For more details, see https://plotly.com/javascript/animations/");
                    var n = t1._transitionData;
                    n._frameQueue || (n._frameQueue = []);
                    var i = (r = h.supplyAnimationDefaults(r)).transition, a = r.frame;
                    function s(t1) {
                        return Array.isArray(i) ? t1 >= i.length ? i[0] : i[t1] : i;
                    }
                    function l(t1) {
                        return Array.isArray(a) ? t1 >= a.length ? a[0] : a[t1] : a;
                    }
                    function c(t1, e1) {
                        var r = 0;
                        return function() {
                            if (t1 && ++r === e1) return t1();
                        };
                    }
                    return void 0 === n._frameWaitingCnt && (n._frameWaitingCnt = 0), new Promise(function(a, u) {
                        function f() {
                            n._currentFrame && n._currentFrame.onComplete && n._currentFrame.onComplete();
                            var e1 = n._currentFrame = n._frameQueue.shift();
                            if (e1) {
                                var r = e1.name ? e1.name.toString() : null;
                                t1._fullLayout._currentFrame = r, n._lastFrameAt = Date.now(), n._timeToNext = e1.frameOpts.duration, h.transition(t1, e1.frame.data, e1.frame.layout, _.coerceTraceIndices(t1, e1.frame.traces), e1.frameOpts, e1.transitionOpts).then(function() {
                                    e1.onComplete && e1.onComplete();
                                }), t1.emit("plotly_animatingframe", {
                                    name: r,
                                    frame: e1.frame,
                                    animation: {
                                        frame: e1.frameOpts,
                                        transition: e1.transitionOpts
                                    }
                                });
                            } else t1.emit("plotly_animated"), window.cancelAnimationFrame(n._animationRaf), n._animationRaf = null;
                        }
                        function p() {
                            t1.emit("plotly_animating"), n._lastFrameAt = -1 / 0, n._timeToNext = 0, n._runningTransitions = 0, n._currentFrame = null;
                            var e1 = function() {
                                n._animationRaf = window.requestAnimationFrame(e1), Date.now() - n._lastFrameAt > n._timeToNext && f();
                            };
                            e1();
                        }
                        var d, m, g = 0;
                        function v(t1) {
                            return Array.isArray(i) ? g >= i.length ? t1.transitionOpts = i[g] : t1.transitionOpts = i[0] : t1.transitionOpts = i, g++, t1;
                        }
                        var y = [], x = null == e1, b = Array.isArray(e1);
                        if (!x && !b && o.isPlainObject(e1)) y.push({
                            type: "object",
                            data: v(o.extendFlat({}, e1))
                        });
                        else if (x || -1 !== [
                            "string",
                            "number"
                        ].indexOf(typeof e1)) for(d = 0; d < n._frames.length; d++)(m = n._frames[d]) && (x || String(m.group) === String(e1)) && y.push({
                            type: "byname",
                            name: String(m.name),
                            data: v({
                                name: m.name
                            })
                        });
                        else if (b) for(d = 0; d < e1.length; d++){
                            var w = e1[d];
                            -1 !== [
                                "number",
                                "string"
                            ].indexOf(typeof w) ? (w = String(w), y.push({
                                type: "byname",
                                name: w,
                                data: v({
                                    name: w
                                })
                            })) : o.isPlainObject(w) && y.push({
                                type: "object",
                                data: v(o.extendFlat({}, w))
                            });
                        }
                        for(d = 0; d < y.length; d++)if ("byname" === (m = y[d]).type && !n._frameHash[m.data.name]) return o.warn('animate failure: frame not found: "' + m.data.name + '"'), void u();
                        -1 !== [
                            "next",
                            "immediate"
                        ].indexOf(r.mode) && function() {
                            if (0 !== n._frameQueue.length) {
                                for(; n._frameQueue.length;){
                                    var e1 = n._frameQueue.pop();
                                    e1.onInterrupt && e1.onInterrupt();
                                }
                                t1.emit("plotly_animationinterrupted", []);
                            }
                        }(), "reverse" === r.direction && y.reverse();
                        var T = t1._fullLayout._currentFrame;
                        if (T && r.fromcurrent) {
                            var k = -1;
                            for(d = 0; d < y.length; d++)if ("byname" === (m = y[d]).type && m.name === T) {
                                k = d;
                                break;
                            }
                            if (k > 0 && k < y.length - 1) {
                                var A = [];
                                for(d = 0; d < y.length; d++)m = y[d], ("byname" !== y[d].type || d > k) && A.push(m);
                                y = A;
                            }
                        }
                        y.length > 0 ? function(e1) {
                            if (0 !== e1.length) {
                                for(var i = 0; i < e1.length; i++){
                                    var o;
                                    o = "byname" === e1[i].type ? h.computeFrame(t1, e1[i].name) : e1[i].data;
                                    var f = l(i), d = s(i);
                                    d.duration = Math.min(d.duration, f.duration);
                                    var m = {
                                        frame: o,
                                        name: e1[i].name,
                                        frameOpts: f,
                                        transitionOpts: d
                                    };
                                    i === e1.length - 1 && (m.onComplete = c(a, 2), m.onInterrupt = u), n._frameQueue.push(m);
                                }
                                "immediate" === r.mode && (n._lastFrameAt = -1 / 0), n._animationRaf || p();
                            }
                        }(y) : (t1.emit("plotly_animated"), a());
                    });
                }, r.addFrames = function(t1, e1, r) {
                    if (t1 = o.getGraphDiv(t1), null == e1) return Promise.resolve();
                    if (!o.isPlotDiv(t1)) throw new Error("This element is not a Plotly plot: " + t1 + ". It's likely that you've failed to create a plot before adding frames. For more details, see https://plotly.com/javascript/animations/");
                    var n, i, a, s, l = t1._transitionData._frames, u = t1._transitionData._frameHash;
                    if (!Array.isArray(e1)) throw new Error("addFrames failure: frameList must be an Array of frame definitions" + e1);
                    var f = l.length + 2 * e1.length, p = [], d = {};
                    for(n = e1.length - 1; n >= 0; n--)if (o.isPlainObject(e1[n])) {
                        var m = e1[n].name, g = (u[m] || d[m] || {}).name, v = e1[n].name, y = u[g] || d[g];
                        g && v && "number" == typeof v && y && A < 5 && (A++, o.warn('addFrames: overwriting frame "' + (u[g] || d[g]).name + '" with a frame whose name of type "number" also equates to "' + g + '". This is valid but may potentially lead to unexpected behavior since all plotly.js frame names are stored internally as strings.'), 5 === A && o.warn("addFrames: This API call has yielded too many of these warnings. For the rest of this call, further warnings about numeric frame names will be suppressed.")), d[m] = {
                            name: m
                        }, p.push({
                            frame: h.supplyFrameDefaults(e1[n]),
                            index: r && void 0 !== r[n] && null !== r[n] ? r[n] : f + n
                        });
                    }
                    p.sort(function(t1, e1) {
                        return t1.index > e1.index ? -1 : t1.index < e1.index ? 1 : 0;
                    });
                    var x = [], b = [], _ = l.length;
                    for(n = p.length - 1; n >= 0; n--){
                        if ("number" == typeof (i = p[n].frame).name && o.warn("Warning: addFrames accepts frames with numeric names, but the numbers areimplicitly cast to strings"), !i.name) for(; u[i.name = "frame " + t1._transitionData._counter++];);
                        if (u[i.name]) {
                            for(a = 0; a < l.length && (l[a] || {}).name !== i.name; a++);
                            x.push({
                                type: "replace",
                                index: a,
                                value: i
                            }), b.unshift({
                                type: "replace",
                                index: a,
                                value: l[a]
                            });
                        } else s = Math.max(0, Math.min(p[n].index, _)), x.push({
                            type: "insert",
                            index: s,
                            value: i
                        }), b.unshift({
                            type: "delete",
                            index: s
                        }), _++;
                    }
                    var w = h.modifyFrames, T = h.modifyFrames, k = [
                        t1,
                        b
                    ], M = [
                        t1,
                        x
                    ];
                    return c && c.add(t1, w, k, T, M), h.modifyFrames(t1, x);
                }, r.deleteFrames = function(t1, e1) {
                    if (t1 = o.getGraphDiv(t1), !o.isPlotDiv(t1)) throw new Error("This element is not a Plotly plot: " + t1);
                    var r, n, i = t1._transitionData._frames, a = [], s = [];
                    if (!e1) for(e1 = [], r = 0; r < i.length; r++)e1.push(r);
                    for((e1 = e1.slice()).sort(), r = e1.length - 1; r >= 0; r--)n = e1[r], a.push({
                        type: "delete",
                        index: n
                    }), s.unshift({
                        type: "insert",
                        index: n,
                        value: i[n]
                    });
                    var l = h.modifyFrames, u = h.modifyFrames, f = [
                        t1,
                        s
                    ], p = [
                        t1,
                        a
                    ];
                    return c && c.add(t1, l, f, u, p), h.modifyFrames(t1, a);
                }, r.addTraces = function t1(e1, n, i) {
                    e1 = o.getGraphDiv(e1);
                    var a, s, l = [], u = r.deleteTraces, f = t1, h = [
                        e1,
                        l
                    ], p = [
                        e1,
                        n
                    ];
                    for(function(t1, e1, r) {
                        var n, i;
                        if (!Array.isArray(t1.data)) throw new Error("gd.data must be an array.");
                        if (void 0 === e1) throw new Error("traces must be defined.");
                        for(Array.isArray(e1) || (e1 = [
                            e1
                        ]), n = 0; n < e1.length; n++)if ("object" != typeof (i = e1[n]) || Array.isArray(i) || null === i) throw new Error("all values in traces array must be non-array objects");
                        if (void 0 === r || Array.isArray(r) || (r = [
                            r
                        ]), void 0 !== r && r.length !== e1.length) throw new Error("if indices is specified, traces.length must equal indices.length");
                    }(e1, n, i), Array.isArray(n) || (n = [
                        n
                    ]), n = n.map(function(t1) {
                        return o.extendFlat({}, t1);
                    }), _.cleanData(n), a = 0; a < n.length; a++)e1.data.push(n[a]);
                    for(a = 0; a < n.length; a++)l.push(-n.length + a);
                    if (void 0 === i) return s = r.redraw(e1), c.add(e1, u, h, f, p), s;
                    Array.isArray(i) || (i = [
                        i
                    ]);
                    try {
                        I(e1, l, i);
                    } catch (t1) {
                        throw e1.data.splice(e1.data.length - n.length, n.length), t1;
                    }
                    return c.startSequence(e1), c.add(e1, u, h, f, p), s = r.moveTraces(e1, l, i), c.stopSequence(e1), s;
                }, r.deleteTraces = function t1(e1, n) {
                    e1 = o.getGraphDiv(e1);
                    var i, a, s = [], l = r.addTraces, u = t1, f = [
                        e1,
                        s,
                        n
                    ], h = [
                        e1,
                        n
                    ];
                    if (void 0 === n) throw new Error("indices must be an integer or array of integers.");
                    for(Array.isArray(n) || (n = [
                        n
                    ]), P(e1, n, "indices"), (n = C(n, e1.data.length - 1)).sort(o.sorterDes), i = 0; i < n.length; i += 1)a = e1.data.splice(n[i], 1)[0], s.push(a);
                    var p = r.redraw(e1);
                    return c.add(e1, l, f, u, h), p;
                }, r.extendTraces = function t1(e1, n, i, a) {
                    function s(t1, e1, r) {
                        var n, i;
                        if (o.isTypedArray(t1)) {
                            if (r < 0) {
                                var a = new t1.constructor(0), s = z(t1, e1);
                                r < 0 ? (n = s, i = a) : (n = a, i = s);
                            } else if (n = new t1.constructor(r), i = new t1.constructor(t1.length + e1.length - r), r === e1.length) n.set(e1), i.set(t1);
                            else if (r < e1.length) {
                                var l = e1.length - r;
                                n.set(e1.subarray(l)), i.set(t1), i.set(e1.subarray(0, l), t1.length);
                            } else {
                                var c = r - e1.length, u = t1.length - c;
                                n.set(t1.subarray(u)), n.set(e1, c), i.set(t1.subarray(0, u));
                            }
                        } else n = t1.concat(e1), i = r >= 0 && r < n.length ? n.splice(0, n.length - r) : [];
                        return [
                            n,
                            i
                        ];
                    }
                    var l = O(e1 = o.getGraphDiv(e1), n, i, a, s), u = r.redraw(e1), f = [
                        e1,
                        l.update,
                        i,
                        l.maxPoints
                    ];
                    return c.add(e1, r.prependTraces, f, t1, arguments), u;
                }, r.moveTraces = function t1(e1, n, i) {
                    var a, s = [], l = [], u = t1, f = t1, h = [
                        e1 = o.getGraphDiv(e1),
                        i,
                        n
                    ], p = [
                        e1,
                        n,
                        i
                    ];
                    if (I(e1, n, i), n = Array.isArray(n) ? n : [
                        n
                    ], void 0 === i) for(i = [], a = 0; a < n.length; a++)i.push(-n.length + a);
                    for(i = Array.isArray(i) ? i : [
                        i
                    ], n = C(n, e1.data.length - 1), i = C(i, e1.data.length - 1), a = 0; a < e1.data.length; a++)-1 === n.indexOf(a) && s.push(e1.data[a]);
                    for(a = 0; a < n.length; a++)l.push({
                        newIndex: i[a],
                        trace: e1.data[n[a]]
                    });
                    for(l.sort(function(t1, e1) {
                        return t1.newIndex - e1.newIndex;
                    }), a = 0; a < l.length; a += 1)s.splice(l[a].newIndex, 0, l[a].trace);
                    e1.data = s;
                    var d = r.redraw(e1);
                    return c.add(e1, u, h, f, p), d;
                }, r.prependTraces = function t1(e1, n, i, a) {
                    function s(t1, e1, r) {
                        var n, i;
                        if (o.isTypedArray(t1)) {
                            if (r <= 0) {
                                var a = new t1.constructor(0), s = z(e1, t1);
                                r < 0 ? (n = s, i = a) : (n = a, i = s);
                            } else if (n = new t1.constructor(r), i = new t1.constructor(t1.length + e1.length - r), r === e1.length) n.set(e1), i.set(t1);
                            else if (r < e1.length) {
                                var l = e1.length - r;
                                n.set(e1.subarray(0, l)), i.set(e1.subarray(l)), i.set(t1, l);
                            } else {
                                var c = r - e1.length;
                                n.set(e1), n.set(t1.subarray(0, c), e1.length), i.set(t1.subarray(c));
                            }
                        } else n = e1.concat(t1), i = r >= 0 && r < n.length ? n.splice(r, n.length) : [];
                        return [
                            n,
                            i
                        ];
                    }
                    var l = O(e1 = o.getGraphDiv(e1), n, i, a, s), u = r.redraw(e1), f = [
                        e1,
                        l.update,
                        i,
                        l.maxPoints
                    ];
                    return c.add(e1, r.extendTraces, f, t1, arguments), u;
                }, r.newPlot = function(t1, e1, n, i) {
                    return t1 = o.getGraphDiv(t1), h.cleanPlot([], {}, t1._fullData || [], t1._fullLayout || {}), h.purge(t1), r._doPlot(t1, e1, n, i);
                }, r._doPlot = function(t1, e1, i, a) {
                    var s;
                    if (t1 = o.getGraphDiv(t1), l.init(t1), o.isPlainObject(e1)) {
                        var c = e1;
                        e1 = c.data, i = c.layout, a = c.config, s = c.frames;
                    }
                    if (!1 === l.triggerHandler(t1, "plotly_beforeplot", [
                        e1,
                        i,
                        a
                    ])) return Promise.reject();
                    e1 || i || o.isPlotDiv(t1) || o.warn("Calling _doPlot as if redrawing but this container doesn't yet have a plot.", t1), L(t1, a), i || (i = {}), n.select(t1).classed("js-plotly-plot", !0), d.makeTester(), Array.isArray(t1._promises) || (t1._promises = []);
                    var f = 0 === (t1.data || []).length && Array.isArray(e1);
                    Array.isArray(e1) && (_.cleanData(e1), f ? t1.data = e1 : t1.data.push.apply(t1.data, e1), t1.empty = !1), t1.layout && !f || (t1.layout = _.cleanLayout(i)), h.supplyDefaults(t1);
                    var m = t1._fullLayout, y = m._has("cartesian");
                    m._replotting = !0, (f || m._shouldCreateBgLayer) && (!function(t1) {
                        var e1 = n.select(t1), r = t1._fullLayout;
                        if (r._calcInverseTransform = at, r._calcInverseTransform(t1), r._container = e1.selectAll(".plot-container").data([
                            0
                        ]), r._container.enter().insert("div", ":first-child").classed("plot-container", !0).classed("plotly", !0), r._paperdiv = r._container.selectAll(".svg-container").data([
                            0
                        ]), r._paperdiv.enter().append("div").classed("user-select-none", !0).classed("svg-container", !0).style("position", "relative"), r._glcontainer = r._paperdiv.selectAll(".gl-container").data([
                            {}
                        ]), r._glcontainer.enter().append("div").classed("gl-container", !0), r._paperdiv.selectAll(".main-svg").remove(), r._paperdiv.select(".modebar-container").remove(), r._paper = r._paperdiv.insert("svg", ":first-child").classed("main-svg", !0), r._toppaper = r._paperdiv.append("svg").classed("main-svg", !0), r._modebardiv = r._paperdiv.append("div"), delete r._modeBar, r._hoverpaper = r._paperdiv.append("svg").classed("main-svg", !0), !r._uid) {
                            var i = {};
                            n.selectAll("defs").each(function() {
                                this.id && (i[this.id.split("-")[1]] = 1);
                            }), r._uid = o.randstr(i);
                        }
                        r._paperdiv.selectAll(".main-svg").attr(v.svgAttrs), r._defs = r._paper.append("defs").attr("id", "defs-" + r._uid), r._clips = r._defs.append("g").classed("clips", !0), r._topdefs = r._toppaper.append("defs").attr("id", "topdefs-" + r._uid), r._topclips = r._topdefs.append("g").classed("clips", !0), r._bgLayer = r._paper.append("g").classed("bglayer", !0), r._draggers = r._paper.append("g").classed("draglayer", !0);
                        var a = r._paper.append("g").classed("layer-below", !0);
                        r._imageLowerLayer = a.append("g").classed("imagelayer", !0), r._shapeLowerLayer = a.append("g").classed("shapelayer", !0), r._cartesianlayer = r._paper.append("g").classed("cartesianlayer", !0), r._polarlayer = r._paper.append("g").classed("polarlayer", !0), r._smithlayer = r._paper.append("g").classed("smithlayer", !0), r._ternarylayer = r._paper.append("g").classed("ternarylayer", !0), r._geolayer = r._paper.append("g").classed("geolayer", !0), r._funnelarealayer = r._paper.append("g").classed("funnelarealayer", !0), r._pielayer = r._paper.append("g").classed("pielayer", !0), r._iciclelayer = r._paper.append("g").classed("iciclelayer", !0), r._treemaplayer = r._paper.append("g").classed("treemaplayer", !0), r._sunburstlayer = r._paper.append("g").classed("sunburstlayer", !0), r._indicatorlayer = r._toppaper.append("g").classed("indicatorlayer", !0), r._glimages = r._paper.append("g").classed("glimages", !0);
                        var s = r._toppaper.append("g").classed("layer-above", !0);
                        r._imageUpperLayer = s.append("g").classed("imagelayer", !0), r._shapeUpperLayer = s.append("g").classed("shapelayer", !0), r._infolayer = r._toppaper.append("g").classed("infolayer", !0), r._menulayer = r._toppaper.append("g").classed("menulayer", !0), r._zoomlayer = r._toppaper.append("g").classed("zoomlayer", !0), r._hoverlayer = r._hoverpaper.append("g").classed("hoverlayer", !0), r._modebardiv.classed("modebar-container", !0).style("position", "absolute").style("top", "0px").style("right", "0px"), t1.emit("plotly_framework");
                    }(t1), m._shouldCreateBgLayer && delete m._shouldCreateBgLayer), d.initGradients(t1), d.initPatterns(t1), f && p.saveShowSpikeInitial(t1);
                    var x = !t1.calcdata || t1.calcdata.length !== (t1._fullData || []).length;
                    x && h.doCalcdata(t1);
                    for(var b = 0; b < t1.calcdata.length; b++)t1.calcdata[b][0].trace = t1._fullData[b];
                    t1._context.responsive ? t1._responsiveChartHandler || (t1._responsiveChartHandler = function() {
                        o.isHidden(t1) || h.resize(t1);
                    }, window.addEventListener("resize", t1._responsiveChartHandler)) : o.clearResponsive(t1);
                    var T = o.extendFlat({}, m._size), k = 0;
                    function A() {
                        if (h.clearAutoMarginIds(t1), w.drawMarginPushers(t1), p.allowAutoMargin(t1), m._has("pie")) for(var e1 = t1._fullData, r = 0; r < e1.length; r++){
                            var n = e1[r];
                            "pie" === n.type && n.automargin && h.allowAutoMargin(t1, "pie." + n.uid + ".automargin");
                        }
                        return h.doAutoMargin(t1), h.previousPromises(t1);
                    }
                    function S() {
                        t1._transitioning || (w.doAutoRangeAndConstraints(t1), f && p.saveRangeInitial(t1), u.getComponentMethod("rangeslider", "calcAutorange")(t1));
                    }
                    var E = [
                        h.previousPromises,
                        function() {
                            if (s) return r.addFrames(t1, s);
                        },
                        function e1() {
                            for(var r = m._basePlotModules, n = 0; n < r.length; n++)r[n].drawFramework && r[n].drawFramework(t1);
                            !m._glcanvas && m._has("gl") && (m._glcanvas = m._glcontainer.selectAll(".gl-canvas").data([
                                {
                                    key: "contextLayer",
                                    context: !0,
                                    pick: !1
                                },
                                {
                                    key: "focusLayer",
                                    context: !1,
                                    pick: !1
                                },
                                {
                                    key: "pickLayer",
                                    context: !1,
                                    pick: !0
                                }
                            ], function(t1) {
                                return t1.key;
                            }), m._glcanvas.enter().append("canvas").attr("class", function(t1) {
                                return "gl-canvas gl-canvas-" + t1.key.replace("Layer", "");
                            }).style({
                                position: "absolute",
                                top: 0,
                                left: 0,
                                overflow: "visible",
                                "pointer-events": "none"
                            }));
                            var i = t1._context.plotGlPixelRatio;
                            if (m._glcanvas) {
                                m._glcanvas.attr("width", m.width * i).attr("height", m.height * i).style("width", m.width + "px").style("height", m.height + "px");
                                var a = m._glcanvas.data()[0].regl;
                                if (a && (Math.floor(m.width * i) !== a._gl.drawingBufferWidth || Math.floor(m.height * i) !== a._gl.drawingBufferHeight)) {
                                    var s = "WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.";
                                    if (!k) return o.log(s + " Clearing graph and plotting again."), h.cleanPlot([], {}, t1._fullData, m), h.supplyDefaults(t1), m = t1._fullLayout, h.doCalcdata(t1), k++, e1();
                                    o.error(s);
                                }
                            }
                            return "h" === m.modebar.orientation ? m._modebardiv.style("height", null).style("width", "100%") : m._modebardiv.style("width", null).style("height", m.height + "px"), h.previousPromises(t1);
                        },
                        A,
                        function() {
                            if (h.didMarginChange(T, m._size)) return o.syncOrAsync([
                                A,
                                w.layoutStyles
                            ], t1);
                        }
                    ];
                    y && E.push(function() {
                        if (x) return o.syncOrAsync([
                            u.getComponentMethod("shapes", "calcAutorange"),
                            u.getComponentMethod("annotations", "calcAutorange"),
                            S
                        ], t1);
                        S();
                    }), E.push(w.layoutStyles), y && E.push(function() {
                        return p.draw(t1, f ? "" : "redraw");
                    }, function(t1) {
                        t1._fullLayout._insideTickLabelsAutorange && U(t1, t1._fullLayout._insideTickLabelsAutorange).then(function() {
                            t1._fullLayout._insideTickLabelsAutorange = void 0;
                        });
                    }), E.push(w.drawData, w.finalDraw, g, h.addLinks, h.rehover, h.redrag, h.doAutoMargin, function(t1) {
                        t1._fullLayout._insideTickLabelsAutorange && f && p.saveRangeInitial(t1, !0);
                    }, h.previousPromises);
                    var C = o.syncOrAsync(E, t1);
                    return C && C.then || (C = Promise.resolve()), C.then(function() {
                        return M(t1), t1;
                    });
                }, r.purge = function(t1) {
                    var e1 = (t1 = o.getGraphDiv(t1))._fullLayout || {}, r = t1._fullData || [];
                    return h.cleanPlot([], {}, r, e1), h.purge(t1), l.purge(t1), e1._container && e1._container.remove(), delete t1._context, t1;
                }, r.react = function(t1, e1, n, i) {
                    var a, l;
                    t1 = o.getGraphDiv(t1), _.clearPromiseQueue(t1);
                    var c = t1._fullData, p = t1._fullLayout;
                    if (o.isPlotDiv(t1) && c && p) {
                        if (o.isPlainObject(e1)) {
                            var d = e1;
                            e1 = d.data, n = d.layout, i = d.config, a = d.frames;
                        }
                        var m = !1;
                        if (i) {
                            var g = o.extendDeep({}, t1._context);
                            t1._context = void 0, L(t1, i), m = function t1(e1, r) {
                                var n;
                                for(n in e1)if ("_" !== n.charAt(0)) {
                                    var i = e1[n], a = r[n];
                                    if (i !== a) {
                                        if (o.isPlainObject(i) && o.isPlainObject(a)) {
                                            if (t1(i, a)) return !0;
                                        } else {
                                            if (!Array.isArray(i) || !Array.isArray(a)) return !0;
                                            if (i.length !== a.length) return !0;
                                            for(var s = 0; s < i.length; s++)if (i[s] !== a[s]) {
                                                if (!o.isPlainObject(i[s]) || !o.isPlainObject(a[s])) return !0;
                                                if (t1(i[s], a[s])) return !0;
                                            }
                                        }
                                    }
                                }
                            }(g, t1._context);
                        }
                        t1.data = e1 || [], _.cleanData(t1.data), t1.layout = n || {}, _.cleanLayout(t1.layout), function(t1, e1, r, n) {
                            var i, a, l, c, u, f, h, p, d, m, g = n._preGUI, v = [], y = {}, x = {};
                            for(i in g){
                                if (u = $(i, K)) {
                                    if (d = u.head, m = u.tail, a = u.attr || d + ".uirevision", (c = (l = s(n, a).get()) && tt(a, e1)) && c === l) {
                                        if (null === (f = g[i]) && (f = void 0), nt(p = (h = s(e1, i)).get(), f)) {
                                            void 0 === p && "autorange" === m && v.push(d), h.set(R(s(n, i).get()));
                                            continue;
                                        }
                                        if ("autorange" === m || "range[" === m.substr(0, 6)) {
                                            var b = g[d + ".range[0]"], _ = g[d + ".range[1]"], w = g[d + ".autorange"];
                                            if (w || null === w && null === b && null === _) {
                                                if (!(d in y)) {
                                                    var T = s(e1, d).get();
                                                    y[d] = T && (T.autorange || !1 !== T.autorange && (!T.range || 2 !== T.range.length));
                                                }
                                                if (y[d]) {
                                                    h.set(R(s(n, i).get()));
                                                    continue;
                                                }
                                            }
                                        }
                                    }
                                } else o.warn("unrecognized GUI edit: " + i);
                                delete g[i], u && "range[" === u.tail.substr(0, 6) && (x[u.head] = 1);
                            }
                            for(var k = 0; k < v.length; k++){
                                var A = v[k];
                                if (x[A]) {
                                    var M = s(e1, A).get();
                                    M && delete M.autorange;
                                }
                            }
                            var S = n._tracePreGUI;
                            for(var E in S){
                                var L, C = S[E], P = null;
                                for(i in C){
                                    if (!P) {
                                        var I = et(E, r);
                                        if (I < 0) {
                                            delete S[E];
                                            break;
                                        }
                                        var O = rt(E, t1, (L = r[I]._fullInput).index);
                                        if (O < 0) {
                                            delete S[E];
                                            break;
                                        }
                                        P = t1[O];
                                    }
                                    if (u = $(i, Q)) {
                                        if (u.attr ? c = (l = s(n, u.attr).get()) && tt(u.attr, e1) : (l = L.uirevision, void 0 === (c = P.uirevision) && (c = e1.uirevision)), c && c === l && (null === (f = C[i]) && (f = void 0), nt(p = (h = s(P, i)).get(), f))) {
                                            h.set(R(s(L, i).get()));
                                            continue;
                                        }
                                    } else o.warn("unrecognized GUI edit: " + i + " in trace uid " + E);
                                    delete C[i];
                                }
                            }
                        }(t1.data, t1.layout, c, p), h.supplyDefaults(t1, {
                            skipUpdateCalc: !0
                        });
                        var v = t1._fullData, y = t1._fullLayout, x = void 0 === y.datarevision, b = y.transition, k = function(t1, e1, r, n, i) {
                            var a = T.layoutFlags();
                            function o(t1) {
                                return f.getLayoutValObject(r, t1);
                            }
                            a.arrays = {}, a.rangesAltered = {}, a.nChanges = 0, a.nChangesAnim = 0, it(e1, r, [], {
                                getValObject: o,
                                flags: a,
                                immutable: n,
                                transition: i,
                                gd: t1
                            }), (a.plot || a.calc) && (a.layoutReplot = !0);
                            i && a.nChanges && a.nChangesAnim && (a.anim = a.nChanges === a.nChangesAnim ? "all" : "some");
                            return a;
                        }(t1, p, y, x, b), A = k.newDataRevision, S = function(t1, e1, r, n, i, a) {
                            var o = e1.length === r.length;
                            if (!i && !o) return {
                                fullReplot: !0,
                                calc: !0
                            };
                            var s, l, c = T.traceFlags();
                            c.arrays = {}, c.nChanges = 0, c.nChangesAnim = 0;
                            var u = {
                                getValObject: function(t1) {
                                    var e1 = f.getTraceValObject(l, t1);
                                    return !l._module.animatable && e1.anim && (e1.anim = !1), e1;
                                },
                                flags: c,
                                immutable: n,
                                transition: i,
                                newDataRevision: a,
                                gd: t1
                            }, p = {};
                            for(s = 0; s < e1.length; s++)if (r[s]) {
                                if (l = r[s]._fullInput, h.hasMakesDataTransform(l) && (l = r[s]), p[l.uid]) continue;
                                p[l.uid] = 1, it(e1[s]._fullInput, l, [], u);
                            }
                            (c.calc || c.plot) && (c.fullReplot = !0);
                            i && c.nChanges && c.nChangesAnim && (c.anim = c.nChanges === c.nChangesAnim && o ? "all" : "some");
                            return c;
                        }(t1, c, v, x, b, A);
                        if (X(t1) && (k.layoutReplot = !0), S.calc || k.calc) {
                            t1.calcdata = void 0;
                            for(var E = Object.getOwnPropertyNames(y), C = 0; C < E.length; C++){
                                var P = E[C], I = P.substring(0, 5);
                                if ("xaxis" === I || "yaxis" === I) {
                                    var O = y[P]._emptyCategories;
                                    O && O();
                                }
                            }
                        } else h.supplyDefaultsUpdateCalc(t1.calcdata, v);
                        var z = [];
                        if (a && (t1._transitionData = {}, h.createTransitionData(t1), z.push(function() {
                            return r.addFrames(t1, a);
                        })), y.transition && !m && (S.anim || k.anim)) k.ticks && z.push(w.doTicksRelayout), h.doCalcdata(t1), w.doAutoRangeAndConstraints(t1), z.push(function() {
                            return h.transitionFromReact(t1, S, k, p);
                        });
                        else if (S.fullReplot || k.layoutReplot || m) t1._fullLayout._skipDefaults = !0, z.push(r._doPlot);
                        else {
                            for(var D in k.arrays){
                                var F = k.arrays[D];
                                if (F.length) {
                                    var B = u.getComponentMethod(D, "drawOne");
                                    if (B !== o.noop) for(var N = 0; N < F.length; N++)B(t1, F[N]);
                                    else {
                                        var j = u.getComponentMethod(D, "draw");
                                        if (j === o.noop) throw new Error("cannot draw components: " + D);
                                        j(t1);
                                    }
                                }
                            }
                            z.push(h.previousPromises), S.style && z.push(w.doTraceStyle), (S.colorbars || k.colorbars) && z.push(w.doColorBars), k.legend && z.push(w.doLegend), k.layoutstyle && z.push(w.layoutStyles), k.axrange && H(z), k.ticks && z.push(w.doTicksRelayout), k.modebar && z.push(w.doModeBar), k.camera && z.push(w.doCamera), z.push(M);
                        }
                        z.push(h.rehover, h.redrag), (l = o.syncOrAsync(z, t1)) && l.then || (l = Promise.resolve(t1));
                    } else l = r.newPlot(t1, e1, n, i);
                    return l.then(function() {
                        return t1.emit("plotly_react", {
                            data: e1,
                            layout: n
                        }), t1;
                    });
                }, r.redraw = function(t1) {
                    if (t1 = o.getGraphDiv(t1), !o.isPlotDiv(t1)) throw new Error("This element is not a Plotly plot: " + t1);
                    return _.cleanData(t1.data), _.cleanLayout(t1.layout), t1.calcdata = void 0, r._doPlot(t1).then(function() {
                        return t1.emit("plotly_redraw"), t1;
                    });
                }, r.relayout = U, r.restyle = D, r.setPlotConfig = function(t1) {
                    return o.extendFlat(x, t1);
                }, r.update = Z, r._guiRelayout = J(U), r._guiRestyle = J(D), r._guiUpdate = J(Z), r._storeDirectGUIEdit = function(t1, e1, r) {
                    for(var n in r)B(n, s(t1, n).get(), r[n], e1);
                };
            },
            {
                "../components/color": 366,
                "../components/drawing": 388,
                "../constants/xmlns_namespaces": 480,
                "../lib": 503,
                "../lib/events": 492,
                "../lib/queue": 519,
                "../plots/cartesian/axes": 554,
                "../plots/cartesian/constants": 561,
                "../plots/cartesian/graph_interact": 564,
                "../plots/cartesian/select": 575,
                "../plots/plots": 619,
                "../registry": 638,
                "./edit_types": 536,
                "./helpers": 537,
                "./manage_arrays": 539,
                "./plot_config": 541,
                "./plot_schema": 542,
                "./subroutines": 544,
                "@plotly/d3": 58,
                "fast-isnumeric": 190,
                "has-hover": 228
            }
        ],
        541: [
            function(t1, e1, r) {
                "use strict";
                var n = {
                    staticPlot: {
                        valType: "boolean",
                        dflt: !1
                    },
                    plotlyServerURL: {
                        valType: "string",
                        dflt: ""
                    },
                    editable: {
                        valType: "boolean",
                        dflt: !1
                    },
                    edits: {
                        annotationPosition: {
                            valType: "boolean",
                            dflt: !1
                        },
                        annotationTail: {
                            valType: "boolean",
                            dflt: !1
                        },
                        annotationText: {
                            valType: "boolean",
                            dflt: !1
                        },
                        axisTitleText: {
                            valType: "boolean",
                            dflt: !1
                        },
                        colorbarPosition: {
                            valType: "boolean",
                            dflt: !1
                        },
                        colorbarTitleText: {
                            valType: "boolean",
                            dflt: !1
                        },
                        legendPosition: {
                            valType: "boolean",
                            dflt: !1
                        },
                        legendText: {
                            valType: "boolean",
                            dflt: !1
                        },
                        shapePosition: {
                            valType: "boolean",
                            dflt: !1
                        },
                        titleText: {
                            valType: "boolean",
                            dflt: !1
                        }
                    },
                    autosizable: {
                        valType: "boolean",
                        dflt: !1
                    },
                    responsive: {
                        valType: "boolean",
                        dflt: !1
                    },
                    fillFrame: {
                        valType: "boolean",
                        dflt: !1
                    },
                    frameMargins: {
                        valType: "number",
                        dflt: 0,
                        min: 0,
                        max: .5
                    },
                    scrollZoom: {
                        valType: "flaglist",
                        flags: [
                            "cartesian",
                            "gl3d",
                            "geo",
                            "mapbox"
                        ],
                        extras: [
                            !0,
                            !1
                        ],
                        dflt: "gl3d+geo+mapbox"
                    },
                    doubleClick: {
                        valType: "enumerated",
                        values: [
                            !1,
                            "reset",
                            "autosize",
                            "reset+autosize"
                        ],
                        dflt: "reset+autosize"
                    },
                    doubleClickDelay: {
                        valType: "number",
                        dflt: 300,
                        min: 0
                    },
                    showAxisDragHandles: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showAxisRangeEntryBoxes: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showTips: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showLink: {
                        valType: "boolean",
                        dflt: !1
                    },
                    linkText: {
                        valType: "string",
                        dflt: "Edit chart",
                        noBlank: !0
                    },
                    sendData: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showSources: {
                        valType: "any",
                        dflt: !1
                    },
                    displayModeBar: {
                        valType: "enumerated",
                        values: [
                            "hover",
                            !0,
                            !1
                        ],
                        dflt: "hover"
                    },
                    showSendToCloud: {
                        valType: "boolean",
                        dflt: !1
                    },
                    showEditInChartStudio: {
                        valType: "boolean",
                        dflt: !1
                    },
                    modeBarButtonsToRemove: {
                        valType: "any",
                        dflt: []
                    },
                    modeBarButtonsToAdd: {
                        valType: "any",
                        dflt: []
                    },
                    modeBarButtons: {
                        valType: "any",
                        dflt: !1
                    },
                    toImageButtonOptions: {
                        valType: "any",
                        dflt: {}
                    },
                    displaylogo: {
                        valType: "boolean",
                        dflt: !0
                    },
                    watermark: {
                        valType: "boolean",
                        dflt: !1
                    },
                    plotGlPixelRatio: {
                        valType: "number",
                        dflt: 2,
                        min: 1,
                        max: 4
                    },
                    setBackground: {
                        valType: "any",
                        dflt: "transparent"
                    },
                    topojsonURL: {
                        valType: "string",
                        noBlank: !0,
                        dflt: "https://cdn.plot.ly/"
                    },
                    mapboxAccessToken: {
                        valType: "string",
                        dflt: null
                    },
                    logging: {
                        valType: "integer",
                        min: 0,
                        max: 2,
                        dflt: 1
                    },
                    notifyOnLogging: {
                        valType: "integer",
                        min: 0,
                        max: 2,
                        dflt: 0
                    },
                    queueLength: {
                        valType: "integer",
                        min: 0,
                        dflt: 0
                    },
                    globalTransforms: {
                        valType: "any",
                        dflt: []
                    },
                    locale: {
                        valType: "string",
                        dflt: "en-US"
                    },
                    locales: {
                        valType: "any",
                        dflt: {}
                    }
                }, i = {};
                !function t1(e1, r) {
                    for(var n in e1){
                        var i = e1[n];
                        i.valType ? r[n] = i.dflt : (r[n] || (r[n] = {}), t1(i, r[n]));
                    }
                }(n, i), e1.exports = {
                    configAttributes: n,
                    dfltConfig: i
                };
            },
            {}
        ],
        542: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../registry"), i = t1("../lib"), a = t1("../plots/attributes"), o = t1("../plots/layout_attributes"), s = t1("../plots/frame_attributes"), l = t1("../plots/animation_attributes"), c = t1("./plot_config").configAttributes, u = t1("./edit_types"), f = i.extendDeepAll, h = i.isPlainObject, p = i.isArrayOrTypedArray, d = i.nestedProperty, m = i.valObjectMeta, g = [
                    "_isSubplotObj",
                    "_isLinkedToArray",
                    "_arrayAttrRegexps",
                    "_deprecated"
                ];
                function v(t1, e1, r) {
                    if (!t1) return !1;
                    if (t1._isLinkedToArray) {
                        if (y(e1[r])) r++;
                        else if (r < e1.length) return !1;
                    }
                    for(; r < e1.length; r++){
                        var n = t1[e1[r]];
                        if (!h(n)) break;
                        if (t1 = n, r === e1.length - 1) break;
                        if (t1._isLinkedToArray) {
                            if (!y(e1[++r])) return !1;
                        } else if ("info_array" === t1.valType) {
                            var i = e1[++r];
                            if (!y(i)) return !1;
                            var a = t1.items;
                            if (Array.isArray(a)) {
                                if (i >= a.length) return !1;
                                if (2 === t1.dimensions) {
                                    if (r++, e1.length === r) return t1;
                                    var o = e1[r];
                                    if (!y(o)) return !1;
                                    t1 = a[i][o];
                                } else t1 = a[i];
                            } else t1 = a;
                        }
                    }
                    return t1;
                }
                function y(t1) {
                    return t1 === Math.round(t1) && t1 >= 0;
                }
                function x() {
                    var t1, e1, r = {};
                    for(t1 in f(r, o), n.subplotsRegistry)if ((e1 = n.subplotsRegistry[t1]).layoutAttributes) {
                        if (Array.isArray(e1.attr)) for(var i = 0; i < e1.attr.length; i++)w(r, e1, e1.attr[i]);
                        else w(r, e1, "subplot" === e1.attr ? e1.name : e1.attr);
                    }
                    for(t1 in n.componentsRegistry){
                        var a = (e1 = n.componentsRegistry[t1]).schema;
                        if (a && (a.subplots || a.layout)) {
                            var s = a.subplots;
                            if (s && s.xaxis && !s.yaxis) for(var l in s.xaxis)delete r.yaxis[l];
                        } else "colorscale" === e1.name ? f(r, e1.layoutAttributes) : e1.layoutAttributes && T(r, e1.layoutAttributes, e1.name);
                    }
                    return {
                        layoutAttributes: _(r)
                    };
                }
                function b() {
                    var t1 = {
                        frames: f({}, s)
                    };
                    return _(t1), t1.frames;
                }
                function _(t1) {
                    return function(t1) {
                        r.crawl(t1, function(t1, e1, n) {
                            r.isValObject(t1) ? !0 !== t1.arrayOk && "data_array" !== t1.valType || (n[e1 + "src"] = {
                                valType: "string",
                                editType: "none"
                            }) : h(t1) && (t1.role = "object");
                        });
                    }(t1), function(t1) {
                        r.crawl(t1, function(t1, e1, r) {
                            if (t1) {
                                var n = t1._isLinkedToArray;
                                n && (delete t1._isLinkedToArray, r[e1] = {
                                    items: {}
                                }, r[e1].items[n] = t1, r[e1].role = "object");
                            }
                        });
                    }(t1), function(t1) {
                        !function t1(e1) {
                            for(var r in e1)if (h(e1[r])) t1(e1[r]);
                            else if (Array.isArray(e1[r])) for(var n = 0; n < e1[r].length; n++)t1(e1[r][n]);
                            else e1[r] instanceof RegExp && (e1[r] = e1[r].toString());
                        }(t1);
                    }(t1), t1;
                }
                function w(t1, e1, r) {
                    var n = d(t1, r), i = f({}, e1.layoutAttributes);
                    i._isSubplotObj = !0, n.set(i);
                }
                function T(t1, e1, r) {
                    var n = d(t1, r);
                    n.set(f(n.get() || {}, e1));
                }
                r.IS_SUBPLOT_OBJ = "_isSubplotObj", r.IS_LINKED_TO_ARRAY = "_isLinkedToArray", r.DEPRECATED = "_deprecated", r.UNDERSCORE_ATTRS = g, r.get = function() {
                    var t1 = {};
                    n.allTypes.forEach(function(e1) {
                        t1[e1] = function(t1) {
                            var e1, i;
                            e1 = n.modules[t1]._module, i = e1.basePlotModule;
                            var o = {
                                type: null
                            }, s = f({}, a), l = f({}, e1.attributes);
                            r.crawl(l, function(t1, e1, r, n, i) {
                                d(s, i).set(void 0), void 0 === t1 && d(l, i).set(void 0);
                            }), f(o, s), n.traceIs(t1, "noOpacity") && delete o.opacity;
                            n.traceIs(t1, "showLegend") || (delete o.showlegend, delete o.legendgroup);
                            n.traceIs(t1, "noHover") && (delete o.hoverinfo, delete o.hoverlabel);
                            e1.selectPoints || delete o.selectedpoints;
                            f(o, l), i.attributes && f(o, i.attributes);
                            o.type = t1;
                            var c = {
                                meta: e1.meta || {},
                                categories: e1.categories || {},
                                animatable: Boolean(e1.animatable),
                                type: t1,
                                attributes: _(o)
                            };
                            if (e1.layoutAttributes) {
                                var u = {};
                                f(u, e1.layoutAttributes), c.layoutAttributes = _(u);
                            }
                            e1.animatable || r.crawl(c, function(t1) {
                                r.isValObject(t1) && "anim" in t1 && delete t1.anim;
                            });
                            return c;
                        }(e1);
                    });
                    var e1 = {};
                    return Object.keys(n.transformsRegistry).forEach(function(t1) {
                        e1[t1] = function(t1) {
                            var e1 = n.transformsRegistry[t1], r = f({}, e1.attributes);
                            return Object.keys(n.componentsRegistry).forEach(function(e1) {
                                var i = n.componentsRegistry[e1];
                                i.schema && i.schema.transforms && i.schema.transforms[t1] && Object.keys(i.schema.transforms[t1]).forEach(function(e1) {
                                    T(r, i.schema.transforms[t1][e1], e1);
                                });
                            }), {
                                attributes: _(r)
                            };
                        }(t1);
                    }), {
                        defs: {
                            valObjects: m,
                            metaKeys: g.concat([
                                "description",
                                "role",
                                "editType",
                                "impliedEdits"
                            ]),
                            editType: {
                                traces: u.traces,
                                layout: u.layout
                            },
                            impliedEdits: {}
                        },
                        traces: t1,
                        layout: x(),
                        transforms: e1,
                        frames: b(),
                        animation: _(l),
                        config: _(c)
                    };
                }, r.crawl = function(t1, e1, n, i) {
                    var a = n || 0;
                    i = i || "", Object.keys(t1).forEach(function(n) {
                        var o = t1[n];
                        if (-1 === g.indexOf(n)) {
                            var s = (i ? i + "." : "") + n;
                            e1(o, n, t1, a, s), r.isValObject(o) || h(o) && "impliedEdits" !== n && r.crawl(o, e1, a + 1, s);
                        }
                    });
                }, r.isValObject = function(t1) {
                    return t1 && void 0 !== t1.valType;
                }, r.findArrayAttributes = function(t1) {
                    var e1, n, i = [], o = [], s = [];
                    function l(t1, r, a, l) {
                        o = o.slice(0, l).concat([
                            r
                        ]), s = s.slice(0, l).concat([
                            t1 && t1._isLinkedToArray
                        ]), t1 && ("data_array" === t1.valType || !0 === t1.arrayOk) && !("colorbar" === o[l - 1] && ("ticktext" === r || "tickvals" === r)) && function t1(e1, r, a) {
                            var l = e1[o[r]], c = a + o[r];
                            if (r === o.length - 1) p(l) && i.push(n + c);
                            else if (s[r]) {
                                if (Array.isArray(l)) for(var u = 0; u < l.length; u++)h(l[u]) && t1(l[u], r + 1, c + "[" + u + "].");
                            } else h(l) && t1(l, r + 1, c + ".");
                        }(e1, 0, "");
                    }
                    e1 = t1, n = "", r.crawl(a, l), t1._module && t1._module.attributes && r.crawl(t1._module.attributes, l);
                    var c = t1.transforms;
                    if (c) for(var u = 0; u < c.length; u++){
                        var f = c[u], d = f._module;
                        d && (n = "transforms[" + u + "].", e1 = f, r.crawl(d.attributes, l));
                    }
                    return i;
                }, r.getTraceValObject = function(t1, e1) {
                    var r, i, o = e1[0], s = 1;
                    if ("transforms" === o) {
                        if (1 === e1.length) return a.transforms;
                        var l = t1.transforms;
                        if (!Array.isArray(l) || !l.length) return !1;
                        var c = e1[1];
                        if (!y(c) || c >= l.length) return !1;
                        i = (r = (n.transformsRegistry[l[c].type] || {}).attributes) && r[e1[2]], s = 3;
                    } else {
                        var u = t1._module;
                        if (u || (u = (n.modules[t1.type || a.type.dflt] || {})._module), !u) return !1;
                        if (!(i = (r = u.attributes) && r[o])) {
                            var f = u.basePlotModule;
                            f && f.attributes && (i = f.attributes[o]);
                        }
                        i || (i = a[o]);
                    }
                    return v(i, e1, s);
                }, r.getLayoutValObject = function(t1, e1) {
                    return v(function(t1, e1) {
                        var r, i, a, s, l = t1._basePlotModules;
                        if (l) {
                            var c;
                            for(r = 0; r < l.length; r++){
                                if ((a = l[r]).attrRegex && a.attrRegex.test(e1)) {
                                    if (a.layoutAttrOverrides) return a.layoutAttrOverrides;
                                    !c && a.layoutAttributes && (c = a.layoutAttributes);
                                }
                                var u = a.baseLayoutAttrOverrides;
                                if (u && e1 in u) return u[e1];
                            }
                            if (c) return c;
                        }
                        var f = t1._modules;
                        if (f) {
                            for(r = 0; r < f.length; r++)if ((s = f[r].layoutAttributes) && e1 in s) return s[e1];
                        }
                        for(i in n.componentsRegistry){
                            if ("colorscale" === (a = n.componentsRegistry[i]).name && 0 === e1.indexOf("coloraxis")) return a.layoutAttributes[e1];
                            if (!a.schema && e1 === a.name) return a.layoutAttributes;
                        }
                        return e1 in o && o[e1];
                    }(t1, e1[0]), e1, 1);
                };
            },
            {
                "../lib": 503,
                "../plots/animation_attributes": 548,
                "../plots/attributes": 550,
                "../plots/frame_attributes": 586,
                "../plots/layout_attributes": 610,
                "../registry": 638,
                "./edit_types": 536,
                "./plot_config": 541
            }
        ],
        543: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = t1("../plots/attributes"), a = {
                    name: {
                        valType: "string",
                        editType: "none"
                    }
                };
                function o(t1) {
                    return t1 && "string" == typeof t1;
                }
                function s(t1) {
                    var e1 = t1.length - 1;
                    return "s" !== t1.charAt(e1) && n.warn("bad argument to arrayDefaultKey: " + t1), t1.substr(0, t1.length - 1) + "defaults";
                }
                a.templateitemname = {
                    valType: "string",
                    editType: "calc"
                }, r.templatedArray = function(t1, e1) {
                    return e1._isLinkedToArray = t1, e1.name = a.name, e1.templateitemname = a.templateitemname, e1;
                }, r.traceTemplater = function(t1) {
                    var e1, r, a = {};
                    for(e1 in t1)r = t1[e1], Array.isArray(r) && r.length && (a[e1] = 0);
                    return {
                        newTrace: function(o) {
                            var s = {
                                type: e1 = n.coerce(o, {}, i, "type"),
                                _template: null
                            };
                            if (e1 in a) {
                                r = t1[e1];
                                var l = a[e1] % r.length;
                                a[e1]++, s._template = r[l];
                            }
                            return s;
                        }
                    };
                }, r.newContainer = function(t1, e1, r) {
                    var i = t1._template, a = i && (i[e1] || r && i[r]);
                    return n.isPlainObject(a) || (a = null), t1[e1] = {
                        _template: a
                    };
                }, r.arrayTemplater = function(t1, e1, r) {
                    var n = t1._template, i = n && n[s(e1)], a = n && n[e1];
                    Array.isArray(a) && a.length || (a = []);
                    var l = {};
                    return {
                        newItem: function(t1) {
                            var e1 = {
                                name: t1.name,
                                _input: t1
                            }, n = e1.templateitemname = t1.templateitemname;
                            if (!o(n)) return e1._template = i, e1;
                            for(var s = 0; s < a.length; s++){
                                var c = a[s];
                                if (c.name === n) return l[n] = 1, e1._template = c, e1;
                            }
                            return e1[r] = t1[r] || !1, e1._template = !1, e1;
                        },
                        defaultItems: function() {
                            for(var t1 = [], e1 = 0; e1 < a.length; e1++){
                                var r = a[e1], n = r.name;
                                if (o(n) && !l[n]) {
                                    var i = {
                                        _template: r,
                                        name: n,
                                        _input: {
                                            _templateitemname: n
                                        }
                                    };
                                    i.templateitemname = r.templateitemname, t1.push(i), l[n] = 1;
                                }
                            }
                            return t1;
                        }
                    };
                }, r.arrayDefaultKey = s, r.arrayEditor = function(t1, e1, r) {
                    var i = (n.nestedProperty(t1, e1).get() || []).length, a = r._index, o = a >= i && (r._input || {})._templateitemname;
                    o && (a = i);
                    var s, l = e1 + "[" + a + "]";
                    function c() {
                        s = {}, o && (s[l] = {}, s[l].templateitemname = o);
                    }
                    function u(t1, e1) {
                        o ? n.nestedProperty(s[l], t1).set(e1) : s[l + "." + t1] = e1;
                    }
                    function f() {
                        var t1 = s;
                        return c(), t1;
                    }
                    return c(), {
                        modifyBase: function(t1, e1) {
                            s[t1] = e1;
                        },
                        modifyItem: u,
                        getUpdateObj: f,
                        applyUpdate: function(e1, r) {
                            e1 && u(e1, r);
                            var i = f();
                            for(var a in i)n.nestedProperty(t1, a).set(i[a]);
                        }
                    };
                };
            },
            {
                "../lib": 503,
                "../plots/attributes": 550
            }
        ],
        544: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../registry"), a = t1("../plots/plots"), o = t1("../lib"), s = t1("../lib/clear_gl_canvases"), l = t1("../components/color"), c = t1("../components/drawing"), u = t1("../components/titles"), f = t1("../components/modebar"), h = t1("../plots/cartesian/axes"), p = t1("../constants/alignment"), d = t1("../plots/cartesian/constraints"), m = d.enforce, g = d.clean, v = t1("../plots/cartesian/autorange").doAutoRange;
                function y(t1, e1, r) {
                    for(var n = 0; n < r.length; n++){
                        var i = r[n][0], a = r[n][1];
                        if (!(i[0] >= t1[1] || i[1] <= t1[0]) && a[0] < e1[1] && a[1] > e1[0]) return !0;
                    }
                    return !1;
                }
                function x(t1) {
                    var e1, i, s, u, d, m, g = t1._fullLayout, v = g._size, x = v.p, _ = h.list(t1, "", !0);
                    if (g._paperdiv.style({
                        width: t1._context.responsive && g.autosize && !t1._context._hasZeroWidth && !t1.layout.width ? "100%" : g.width + "px",
                        height: t1._context.responsive && g.autosize && !t1._context._hasZeroHeight && !t1.layout.height ? "100%" : g.height + "px"
                    }).selectAll(".main-svg").call(c.setSize, g.width, g.height), t1._context.setBackground(t1, g.paper_bgcolor), r.drawMainTitle(t1), f.manage(t1), !g._has("cartesian")) return a.previousPromises(t1);
                    function T(t1, e1, r) {
                        var n = t1._lw / 2;
                        return "x" === t1._id.charAt(0) ? e1 ? "top" === r ? e1._offset - x - n : e1._offset + e1._length + x + n : v.t + v.h * (1 - (t1.position || 0)) + n % 1 : e1 ? "right" === r ? e1._offset + e1._length + x + n : e1._offset - x - n : v.l + v.w * (t1.position || 0) + n % 1;
                    }
                    for(e1 = 0; e1 < _.length; e1++){
                        var k = (u = _[e1])._anchorAxis;
                        u._linepositions = {}, u._lw = c.crispRound(t1, u.linewidth, 1), u._mainLinePosition = T(u, k, u.side), u._mainMirrorPosition = u.mirror && k ? T(u, k, p.OPPOSITE_SIDE[u.side]) : null;
                    }
                    var A = [], M = [], S = [], E = 1 === l.opacity(g.paper_bgcolor) && 1 === l.opacity(g.plot_bgcolor) && g.paper_bgcolor === g.plot_bgcolor;
                    for(i in g._plots)if ((s = g._plots[i]).mainplot) s.bg && s.bg.remove(), s.bg = void 0;
                    else {
                        var L = s.xaxis.domain, C = s.yaxis.domain, P = s.plotgroup;
                        if (y(L, C, S)) {
                            var I = P.node(), O = s.bg = o.ensureSingle(P, "rect", "bg");
                            I.insertBefore(O.node(), I.childNodes[0]), M.push(i);
                        } else P.select("rect.bg").remove(), S.push([
                            L,
                            C
                        ]), E || (A.push(i), M.push(i));
                    }
                    var z, D, R, F, B, N, j, U, V, H, q, G, Y, W = g._bgLayer.selectAll(".bg").data(A);
                    for(W.enter().append("rect").classed("bg", !0), W.exit().remove(), W.each(function(t1) {
                        g._plots[t1].bg = n.select(this);
                    }), e1 = 0; e1 < M.length; e1++)s = g._plots[M[e1]], d = s.xaxis, m = s.yaxis, s.bg && void 0 !== d._offset && void 0 !== m._offset && s.bg.call(c.setRect, d._offset - x, m._offset - x, d._length + 2 * x, m._length + 2 * x).call(l.fill, g.plot_bgcolor).style("stroke-width", 0);
                    if (!g._hasOnlyLargeSploms) for(i in g._plots){
                        s = g._plots[i], d = s.xaxis, m = s.yaxis;
                        var X, Z, J = s.clipId = "clip" + g._uid + i + "plot", K = o.ensureSingleById(g._clips, "clipPath", J, function(t1) {
                            t1.classed("plotclip", !0).append("rect");
                        });
                        s.clipRect = K.select("rect").attr({
                            width: d._length,
                            height: m._length
                        }), c.setTranslate(s.plot, d._offset, m._offset), s._hasClipOnAxisFalse ? (X = null, Z = J) : (X = J, Z = null), c.setClipUrl(s.plot, X, t1), s.layerClipId = Z;
                    }
                    function Q(t1) {
                        return "M" + z + "," + t1 + "H" + D;
                    }
                    function $(t1) {
                        return "M" + d._offset + "," + t1 + "h" + d._length;
                    }
                    function tt(t1) {
                        return "M" + t1 + "," + U + "V" + j;
                    }
                    function et(t1) {
                        return "M" + t1 + "," + m._offset + "v" + m._length;
                    }
                    function rt(t1, e1, r) {
                        if (!t1.showline || i !== t1._mainSubplot) return "";
                        if (!t1._anchorAxis) return r(t1._mainLinePosition);
                        var n = e1(t1._mainLinePosition);
                        return t1.mirror && (n += e1(t1._mainMirrorPosition)), n;
                    }
                    for(i in g._plots){
                        s = g._plots[i], d = s.xaxis, m = s.yaxis;
                        var nt = "M0,0";
                        b(d, i) && (B = w(d, "left", m, _), z = d._offset - (B ? x + B : 0), N = w(d, "right", m, _), D = d._offset + d._length + (N ? x + N : 0), R = T(d, m, "bottom"), F = T(d, m, "top"), !(Y = !d._anchorAxis || i !== d._mainSubplot) || "allticks" !== d.mirror && "all" !== d.mirror || (d._linepositions[i] = [
                            R,
                            F
                        ]), nt = rt(d, Q, $), Y && d.showline && ("all" === d.mirror || "allticks" === d.mirror) && (nt += Q(R) + Q(F)), s.xlines.style("stroke-width", d._lw + "px").call(l.stroke, d.showline ? d.linecolor : "rgba(0,0,0,0)")), s.xlines.attr("d", nt);
                        var it = "M0,0";
                        b(m, i) && (q = w(m, "bottom", d, _), j = m._offset + m._length + (q ? x : 0), G = w(m, "top", d, _), U = m._offset - (G ? x : 0), V = T(m, d, "left"), H = T(m, d, "right"), !(Y = !m._anchorAxis || i !== m._mainSubplot) || "allticks" !== m.mirror && "all" !== m.mirror || (m._linepositions[i] = [
                            V,
                            H
                        ]), it = rt(m, tt, et), Y && m.showline && ("all" === m.mirror || "allticks" === m.mirror) && (it += tt(V) + tt(H)), s.ylines.style("stroke-width", m._lw + "px").call(l.stroke, m.showline ? m.linecolor : "rgba(0,0,0,0)")), s.ylines.attr("d", it);
                    }
                    return h.makeClipPaths(t1), a.previousPromises(t1);
                }
                function b(t1, e1) {
                    return (t1.ticks || t1.showline) && (e1 === t1._mainSubplot || "all" === t1.mirror || "allticks" === t1.mirror);
                }
                function _(t1, e1, r) {
                    if (!r.showline || !r._lw) return !1;
                    if ("all" === r.mirror || "allticks" === r.mirror) return !0;
                    var n = r._anchorAxis;
                    if (!n) return !1;
                    var i = p.FROM_BL[e1];
                    return r.side === e1 ? n.domain[i] === t1.domain[i] : r.mirror && n.domain[1 - i] === t1.domain[1 - i];
                }
                function w(t1, e1, r, n) {
                    if (_(t1, e1, r)) return r._lw;
                    for(var i = 0; i < n.length; i++){
                        var a = n[i];
                        if (a._mainAxis === r._mainAxis && _(t1, e1, a)) return a._lw;
                    }
                    return 0;
                }
                function T(t1, e1) {
                    var r = t1.title, n = t1._size, i = 0;
                    switch("start" === e1 ? i = r.pad.l : "end" === e1 && (i = -r.pad.r), r.xref){
                        case "paper":
                            return n.l + n.w * r.x + i;
                        case "container":
                        default:
                            return t1.width * r.x + i;
                    }
                }
                function k(t1, e1) {
                    var r = t1.title, n = t1._size, i = 0;
                    if ("0em" !== e1 && e1 ? e1 === p.CAP_SHIFT + "em" && (i = r.pad.t) : i = -r.pad.b, "auto" === r.y) return n.t / 2;
                    switch(r.yref){
                        case "paper":
                            return n.t + n.h - n.h * r.y + i;
                        case "container":
                        default:
                            return t1.height - t1.height * r.y + i;
                    }
                }
                r.layoutStyles = function(t1) {
                    return o.syncOrAsync([
                        a.doAutoMargin,
                        x
                    ], t1);
                }, r.drawMainTitle = function(t1) {
                    var e1 = t1._fullLayout, r = function(t1) {
                        var e1 = t1.title, r = "middle";
                        o.isRightAnchor(e1) ? r = "end" : o.isLeftAnchor(e1) && (r = "start");
                        return r;
                    }(e1), n = function(t1) {
                        var e1 = t1.title, r = "0em";
                        o.isTopAnchor(e1) ? r = p.CAP_SHIFT + "em" : o.isMiddleAnchor(e1) && (r = p.MID_SHIFT + "em");
                        return r;
                    }(e1);
                    u.draw(t1, "gtitle", {
                        propContainer: e1,
                        propName: "title.text",
                        placeholder: e1._dfltTitle.plot,
                        attributes: {
                            x: T(e1, r),
                            y: k(e1, n),
                            "text-anchor": r,
                            dy: n
                        }
                    });
                }, r.doTraceStyle = function(t1) {
                    var e1, n = t1.calcdata, o = [];
                    for(e1 = 0; e1 < n.length; e1++){
                        var l = n[e1], c = l[0] || {}, u = c.trace || {}, f = u._module || {}, h = f.arraysToCalcdata;
                        h && h(l, u);
                        var p = f.editStyle;
                        p && o.push({
                            fn: p,
                            cd0: c
                        });
                    }
                    if (o.length) {
                        for(e1 = 0; e1 < o.length; e1++){
                            var d = o[e1];
                            d.fn(t1, d.cd0);
                        }
                        s(t1), r.redrawReglTraces(t1);
                    }
                    return a.style(t1), i.getComponentMethod("legend", "draw")(t1), a.previousPromises(t1);
                }, r.doColorBars = function(t1) {
                    return i.getComponentMethod("colorbar", "draw")(t1), a.previousPromises(t1);
                }, r.layoutReplot = function(t1) {
                    var e1 = t1.layout;
                    return t1.layout = void 0, i.call("_doPlot", t1, "", e1);
                }, r.doLegend = function(t1) {
                    return i.getComponentMethod("legend", "draw")(t1), a.previousPromises(t1);
                }, r.doTicksRelayout = function(t1) {
                    return h.draw(t1, "redraw"), t1._fullLayout._hasOnlyLargeSploms && (i.subplotsRegistry.splom.updateGrid(t1), s(t1), r.redrawReglTraces(t1)), r.drawMainTitle(t1), a.previousPromises(t1);
                }, r.doModeBar = function(t1) {
                    var e1 = t1._fullLayout;
                    f.manage(t1);
                    for(var r = 0; r < e1._basePlotModules.length; r++){
                        var n = e1._basePlotModules[r].updateFx;
                        n && n(t1);
                    }
                    return a.previousPromises(t1);
                }, r.doCamera = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots.gl3d, n = 0; n < r.length; n++){
                        var i = e1[r[n]];
                        i._scene.setViewport(i);
                    }
                }, r.drawData = function(t1) {
                    var e1 = t1._fullLayout;
                    s(t1);
                    for(var n = e1._basePlotModules, o = 0; o < n.length; o++)n[o].plot(t1);
                    return r.redrawReglTraces(t1), a.style(t1), i.getComponentMethod("shapes", "draw")(t1), i.getComponentMethod("annotations", "draw")(t1), i.getComponentMethod("images", "draw")(t1), e1._replotting = !1, a.previousPromises(t1);
                }, r.redrawReglTraces = function(t1) {
                    var e1 = t1._fullLayout;
                    if (e1._has("regl")) {
                        var r, n, i = t1._fullData, a = [], s = [];
                        for(e1._hasOnlyLargeSploms && e1._splomGrid.draw(), r = 0; r < i.length; r++){
                            var l = i[r];
                            !0 === l.visible && 0 !== l._length && ("splom" === l.type ? e1._splomScenes[l.uid].draw() : "scattergl" === l.type ? o.pushUnique(a, l.xaxis + l.yaxis) : "scatterpolargl" === l.type && o.pushUnique(s, l.subplot));
                        }
                        for(r = 0; r < a.length; r++)(n = e1._plots[a[r]])._scene && n._scene.draw();
                        for(r = 0; r < s.length; r++)(n = e1[s[r]]._subplot)._scene && n._scene.draw();
                    }
                }, r.doAutoRangeAndConstraints = function(t1) {
                    for(var e1, r = h.list(t1, "", !0), n = {}, i = 0; i < r.length; i++)if (!n[(e1 = r[i])._id]) {
                        n[e1._id] = 1, g(t1, e1), v(t1, e1);
                        var a = e1._matchGroup;
                        if (a) for(var o in a){
                            var s = h.getFromId(t1, o);
                            v(t1, s, e1.range), n[o] = 1;
                        }
                    }
                    m(t1);
                }, r.finalDraw = function(t1) {
                    i.getComponentMethod("rangeslider", "draw")(t1), i.getComponentMethod("rangeselector", "draw")(t1);
                }, r.drawMarginPushers = function(t1) {
                    i.getComponentMethod("legend", "draw")(t1), i.getComponentMethod("rangeselector", "draw")(t1), i.getComponentMethod("sliders", "draw")(t1), i.getComponentMethod("updatemenus", "draw")(t1), i.getComponentMethod("colorbar", "draw")(t1);
                };
            },
            {
                "../components/color": 366,
                "../components/drawing": 388,
                "../components/modebar": 429,
                "../components/titles": 464,
                "../constants/alignment": 471,
                "../lib": 503,
                "../lib/clear_gl_canvases": 487,
                "../plots/cartesian/autorange": 553,
                "../plots/cartesian/axes": 554,
                "../plots/cartesian/constraints": 562,
                "../plots/plots": 619,
                "../registry": 638,
                "@plotly/d3": 58
            }
        ],
        545: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = n.isPlainObject, a = t1("./plot_schema"), o = t1("../plots/plots"), s = t1("../plots/attributes"), l = t1("./plot_template"), c = t1("./plot_config").dfltConfig;
                function u(t1, e1) {
                    t1 = n.extendDeep({}, t1);
                    var r, a, o = Object.keys(t1).sort();
                    function s(e1, r, n) {
                        if (i(r) && i(e1)) u(e1, r);
                        else if (Array.isArray(r) && Array.isArray(e1)) {
                            var o = l.arrayTemplater({
                                _template: t1
                            }, n);
                            for(a = 0; a < r.length; a++){
                                var s = r[a], c = o.newItem(s)._template;
                                c && u(c, s);
                            }
                            var f = o.defaultItems();
                            for(a = 0; a < f.length; a++)r.push(f[a]._template);
                            for(a = 0; a < r.length; a++)delete r[a].templateitemname;
                        }
                    }
                    for(r = 0; r < o.length; r++){
                        var c = o[r], h = t1[c];
                        if (c in e1 ? s(h, e1[c], c) : e1[c] = h, f(c) === c) for(var p in e1){
                            var d = f(p);
                            p === d || d !== c || p in t1 || s(h, e1[p], c);
                        }
                    }
                }
                function f(t1) {
                    return t1.replace(/[0-9]+$/, "");
                }
                function h(t1, e1, r, a, o) {
                    var s = o && r(o);
                    for(var c in t1){
                        var u = t1[c], p = m(t1, c, a), d = m(t1, c, o), g = r(d);
                        if (!g) {
                            var v = f(c);
                            v !== c && (g = r(d = m(t1, v, o)));
                        }
                        if ((!s || s !== g) && !(!g || g._noTemplating || "data_array" === g.valType || g.arrayOk && Array.isArray(u))) {
                            if (!g.valType && i(u)) h(u, e1, r, p, d);
                            else if (g._isLinkedToArray && Array.isArray(u)) for(var y = !1, x = 0, b = {}, _ = 0; _ < u.length; _++){
                                var w = u[_];
                                if (i(w)) {
                                    var T = w.name;
                                    if (T) b[T] || (h(w, e1, r, m(u, x, p), m(u, x, d)), x++, b[T] = 1);
                                    else if (!y) {
                                        var k = m(t1, l.arrayDefaultKey(c), a), A = m(u, x, p);
                                        h(w, e1, r, A, m(u, x, d));
                                        var M = n.nestedProperty(e1, A);
                                        n.nestedProperty(e1, k).set(M.get()), M.set(null), y = !0;
                                    }
                                }
                            }
                            else n.nestedProperty(e1, p).set(u);
                        }
                    }
                }
                function p(t1, e1) {
                    return a.getLayoutValObject(t1, n.nestedProperty({}, e1).parts);
                }
                function d(t1, e1) {
                    return a.getTraceValObject(t1, n.nestedProperty({}, e1).parts);
                }
                function m(t1, e1, r) {
                    return r ? Array.isArray(t1) ? r + "[" + e1 + "]" : r + "." + e1 : e1;
                }
                function g(t1) {
                    for(var e1 = 0; e1 < t1.length; e1++)if (i(t1[e1])) return !0;
                }
                function v(t1) {
                    var e1;
                    switch(t1.code){
                        case "data":
                            e1 = "The template has no key data.";
                            break;
                        case "layout":
                            e1 = "The template has no key layout.";
                            break;
                        case "missing":
                            e1 = t1.path ? "There are no templates for item " + t1.path + " with name " + t1.templateitemname : "There are no templates for trace " + t1.index + ", of type " + t1.traceType + ".";
                            break;
                        case "unused":
                            e1 = t1.path ? "The template item at " + t1.path + " was not used in constructing the plot." : t1.dataCount ? "Some of the templates of type " + t1.traceType + " were not used. The template has " + t1.templateCount + " traces, the data only has " + t1.dataCount + " of this type." : "The template has " + t1.templateCount + " traces of type " + t1.traceType + " but there are none in the data.";
                            break;
                        case "reused":
                            e1 = "Some of the templates of type " + t1.traceType + " were used more than once. The template has " + t1.templateCount + " traces, the data has " + t1.dataCount + " of this type.";
                    }
                    return t1.msg = e1, t1;
                }
                r.makeTemplate = function(t1) {
                    t1 = n.isPlainObject(t1) ? t1 : n.getGraphDiv(t1), t1 = n.extendDeep({
                        _context: c
                    }, {
                        data: t1.data,
                        layout: t1.layout
                    }), o.supplyDefaults(t1);
                    var e1 = t1.data || [], r = t1.layout || {};
                    r._basePlotModules = t1._fullLayout._basePlotModules, r._modules = t1._fullLayout._modules;
                    var a = {
                        data: {},
                        layout: {}
                    };
                    e1.forEach(function(t1) {
                        var e1 = {};
                        h(t1, e1, d.bind(null, t1));
                        var r = n.coerce(t1, {}, s, "type"), i = a.data[r];
                        i || (i = a.data[r] = []), i.push(e1);
                    }), h(r, a.layout, p.bind(null, r)), delete a.layout.template;
                    var l = r.template;
                    if (i(l)) {
                        var f, m, g, v, y, x, b = l.layout;
                        i(b) && u(b, a.layout);
                        var _ = l.data;
                        if (i(_)) {
                            for(m in a.data)if (g = _[m], Array.isArray(g)) {
                                for(x = (y = a.data[m]).length, v = g.length, f = 0; f < x; f++)u(g[f % v], y[f]);
                                for(f = x; f < v; f++)y.push(n.extendDeep({}, g[f]));
                            }
                            for(m in _)m in a.data || (a.data[m] = n.extendDeep([], _[m]));
                        }
                    }
                    return a;
                }, r.validateTemplate = function(t1, e1) {
                    var r = n.extendDeep({}, {
                        _context: c,
                        data: t1.data,
                        layout: t1.layout
                    }), a = r.layout || {};
                    i(e1) || (e1 = a.template || {});
                    var s = e1.layout, l = e1.data, u = [];
                    r.layout = a, r.layout.template = e1, o.supplyDefaults(r);
                    var h = r._fullLayout, p = r._fullData, d = {};
                    if (i(s) ? (!function t1(e1, r) {
                        for(var n in e1)if ("_" !== n.charAt(0) && i(e1[n])) {
                            var a, o = f(n), s = [];
                            for(a = 0; a < r.length; a++)s.push(m(e1, n, r[a])), o !== n && s.push(m(e1, o, r[a]));
                            for(a = 0; a < s.length; a++)d[s[a]] = 1;
                            t1(e1[n], s);
                        }
                    }(h, [
                        "layout"
                    ]), function t1(e1, r) {
                        for(var n in e1)if (-1 === n.indexOf("defaults") && i(e1[n])) {
                            var a = m(e1, n, r);
                            d[a] ? t1(e1[n], a) : u.push({
                                code: "unused",
                                path: a
                            });
                        }
                    }(s, "layout")) : u.push({
                        code: "layout"
                    }), i(l)) {
                        for(var y, x = {}, b = 0; b < p.length; b++){
                            var _ = p[b];
                            x[y = _.type] = (x[y] || 0) + 1, _._fullInput._template || u.push({
                                code: "missing",
                                index: _._fullInput.index,
                                traceType: y
                            });
                        }
                        for(y in l){
                            var w = l[y].length, T = x[y] || 0;
                            w > T ? u.push({
                                code: "unused",
                                traceType: y,
                                templateCount: w,
                                dataCount: T
                            }) : T > w && u.push({
                                code: "reused",
                                traceType: y,
                                templateCount: w,
                                dataCount: T
                            });
                        }
                    } else u.push({
                        code: "data"
                    });
                    if (function t1(e1, r) {
                        for(var n in e1)if ("_" !== n.charAt(0)) {
                            var a = e1[n], o = m(e1, n, r);
                            i(a) ? (Array.isArray(e1) && !1 === a._template && a.templateitemname && u.push({
                                code: "missing",
                                path: o,
                                templateitemname: a.templateitemname
                            }), t1(a, o)) : Array.isArray(a) && g(a) && t1(a, o);
                        }
                    }({
                        data: p,
                        layout: h
                    }, ""), u.length) return u.map(v);
                };
            },
            {
                "../lib": 503,
                "../plots/attributes": 550,
                "../plots/plots": 619,
                "./plot_config": 541,
                "./plot_schema": 542,
                "./plot_template": 543
            }
        ],
        546: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("./plot_api"), a = t1("../plots/plots"), o = t1("../lib"), s = t1("../snapshot/helpers"), l = t1("../snapshot/tosvg"), c = t1("../snapshot/svgtoimg"), u = t1("../version").version, f = {
                    format: {
                        valType: "enumerated",
                        values: [
                            "png",
                            "jpeg",
                            "webp",
                            "svg",
                            "full-json"
                        ],
                        dflt: "png"
                    },
                    width: {
                        valType: "number",
                        min: 1
                    },
                    height: {
                        valType: "number",
                        min: 1
                    },
                    scale: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    setBackground: {
                        valType: "any",
                        dflt: !1
                    },
                    imageDataOnly: {
                        valType: "boolean",
                        dflt: !1
                    }
                };
                e1.exports = function(t1, e1) {
                    var r, h, p, d;
                    function m(t1) {
                        return !(t1 in e1) || o.validate(e1[t1], f[t1]);
                    }
                    if (e1 = e1 || {}, o.isPlainObject(t1) ? (r = t1.data || [], h = t1.layout || {}, p = t1.config || {}, d = {}) : (t1 = o.getGraphDiv(t1), r = o.extendDeep([], t1.data), h = o.extendDeep({}, t1.layout), p = t1._context, d = t1._fullLayout || {}), !m("width") && null !== e1.width || !m("height") && null !== e1.height) throw new Error("Height and width should be pixel values.");
                    if (!m("format")) throw new Error("Export format is not " + o.join2(f.format.values, ", ", " or ") + ".");
                    var g = {};
                    function v(t1, r) {
                        return o.coerce(e1, g, f, t1, r);
                    }
                    var y = v("format"), x = v("width"), b = v("height"), _ = v("scale"), w = v("setBackground"), T = v("imageDataOnly"), k = document.createElement("div");
                    k.style.position = "absolute", k.style.left = "-5000px", document.body.appendChild(k);
                    var A = o.extendFlat({}, h);
                    x ? A.width = x : null === e1.width && n(d.width) && (A.width = d.width), b ? A.height = b : null === e1.height && n(d.height) && (A.height = d.height);
                    var M = o.extendFlat({}, p, {
                        _exportedPlot: !0,
                        staticPlot: !0,
                        setBackground: w
                    }), S = s.getRedrawFunc(k);
                    function E() {
                        return new Promise(function(t1) {
                            setTimeout(t1, s.getDelay(k._fullLayout));
                        });
                    }
                    function L() {
                        return new Promise(function(t1, e1) {
                            var r = l(k, y, _), n = k._fullLayout.width, f = k._fullLayout.height;
                            function h() {
                                i.purge(k), document.body.removeChild(k);
                            }
                            if ("full-json" === y) {
                                var p = a.graphJson(k, !1, "keepdata", "object", !0, !0);
                                return p.version = u, p = JSON.stringify(p), h(), t1(T ? p : s.encodeJSON(p));
                            }
                            if (h(), "svg" === y) return t1(T ? r : s.encodeSVG(r));
                            var d = document.createElement("canvas");
                            d.id = o.randstr(), c({
                                format: y,
                                width: n,
                                height: f,
                                scale: _,
                                canvas: d,
                                svg: r,
                                promise: !0
                            }).then(t1).catch(e1);
                        });
                    }
                    return new Promise(function(t1, e1) {
                        i.newPlot(k, r, A, M).then(S).then(E).then(L).then(function(e1) {
                            t1(function(t1) {
                                return T ? t1.replace(s.IMAGE_URL_PREFIX, "") : t1;
                            }(e1));
                        }).catch(function(t1) {
                            e1(t1);
                        });
                    });
                };
            },
            {
                "../lib": 503,
                "../plots/plots": 619,
                "../snapshot/helpers": 642,
                "../snapshot/svgtoimg": 644,
                "../snapshot/tosvg": 646,
                "../version": 1119,
                "./plot_api": 540,
                "fast-isnumeric": 190
            }
        ],
        547: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = t1("../plots/plots"), a = t1("./plot_schema"), o = t1("./plot_config").dfltConfig, s = n.isPlainObject, l = Array.isArray, c = n.isArrayOrTypedArray;
                function u(t1, e1, r, i, a, o) {
                    o = o || [];
                    for(var f = Object.keys(t1), h = 0; h < f.length; h++){
                        var p = f[h];
                        if ("transforms" !== p) {
                            var v = o.slice();
                            v.push(p);
                            var y = t1[p], x = e1[p], b = g(r, p), _ = (b || {}).valType, w = "info_array" === _, T = "colorscale" === _, k = (b || {}).items;
                            if (m(r, p)) {
                                if (s(y) && s(x) && "any" !== _) u(y, x, b, i, a, v);
                                else if (w && l(y)) {
                                    y.length > x.length && i.push(d("unused", a, v.concat(x.length)));
                                    var A, M, S, E, L, C = x.length, P = Array.isArray(k);
                                    if (P && (C = Math.min(C, k.length)), 2 === b.dimensions) for(M = 0; M < C; M++)if (l(y[M])) {
                                        y[M].length > x[M].length && i.push(d("unused", a, v.concat(M, x[M].length)));
                                        var I = x[M].length;
                                        for(A = 0; A < (P ? Math.min(I, k[M].length) : I); A++)S = P ? k[M][A] : k, E = y[M][A], L = x[M][A], n.validate(E, S) ? L !== E && L !== +E && i.push(d("dynamic", a, v.concat(M, A), E, L)) : i.push(d("value", a, v.concat(M, A), E));
                                    } else i.push(d("array", a, v.concat(M), y[M]));
                                    else for(M = 0; M < C; M++)S = P ? k[M] : k, E = y[M], L = x[M], n.validate(E, S) ? L !== E && L !== +E && i.push(d("dynamic", a, v.concat(M), E, L)) : i.push(d("value", a, v.concat(M), E));
                                } else if (b.items && !w && l(y)) {
                                    var O, z, D = k[Object.keys(k)[0]], R = [];
                                    for(O = 0; O < x.length; O++){
                                        var F = x[O]._index || O;
                                        if ((z = v.slice()).push(F), s(y[F]) && s(x[O])) {
                                            R.push(F);
                                            var B = y[F], N = x[O];
                                            s(B) && !1 !== B.visible && !1 === N.visible ? i.push(d("invisible", a, z)) : u(B, N, D, i, a, z);
                                        }
                                    }
                                    for(O = 0; O < y.length; O++)(z = v.slice()).push(O), s(y[O]) ? -1 === R.indexOf(O) && i.push(d("unused", a, z)) : i.push(d("object", a, z, y[O]));
                                } else !s(y) && s(x) ? i.push(d("object", a, v, y)) : c(y) || !c(x) || w || T ? p in e1 ? n.validate(y, b) ? "enumerated" === b.valType && (b.coerceNumber && y !== +x || y !== x) && i.push(d("dynamic", a, v, y, x)) : i.push(d("value", a, v, y)) : i.push(d("unused", a, v, y)) : i.push(d("array", a, v, y));
                            } else i.push(d("schema", a, v));
                        }
                    }
                    return i;
                }
                function f(t1, e1) {
                    for(var r = t1.layout.layoutAttributes, i = 0; i < e1.length; i++){
                        var a = e1[i], o = t1.traces[a.type], s = o.layoutAttributes;
                        s && (a.subplot ? n.extendFlat(r[o.attributes.subplot.dflt], s) : n.extendFlat(r, s));
                    }
                    return r;
                }
                e1.exports = function(t1, e1) {
                    void 0 === t1 && (t1 = []), void 0 === e1 && (e1 = {});
                    var r, c, h = a.get(), p = [], m = {
                        _context: n.extendFlat({}, o)
                    };
                    l(t1) ? (m.data = n.extendDeep([], t1), r = t1) : (m.data = [], r = [], p.push(d("array", "data"))), s(e1) ? (m.layout = n.extendDeep({}, e1), c = e1) : (m.layout = {}, c = {}, arguments.length > 1 && p.push(d("object", "layout"))), i.supplyDefaults(m);
                    for(var g = m._fullData, v = r.length, y = 0; y < v; y++){
                        var x = r[y], b = [
                            "data",
                            y
                        ];
                        if (s(x)) {
                            var _ = g[y], w = _.type, T = h.traces[w].attributes;
                            T.type = {
                                valType: "enumerated",
                                values: [
                                    w
                                ]
                            }, !1 === _.visible && !1 !== x.visible && p.push(d("invisible", b)), u(x, _, T, p, b);
                            var k = x.transforms, A = _.transforms;
                            if (k) {
                                l(k) || p.push(d("array", b, [
                                    "transforms"
                                ])), b.push("transforms");
                                for(var M = 0; M < k.length; M++){
                                    var S = [
                                        "transforms",
                                        M
                                    ], E = k[M].type;
                                    if (s(k[M])) {
                                        var L = h.transforms[E] ? h.transforms[E].attributes : {};
                                        L.type = {
                                            valType: "enumerated",
                                            values: Object.keys(h.transforms)
                                        }, u(k[M], A[M], L, p, b, S);
                                    } else p.push(d("object", b, S));
                                }
                            }
                        } else p.push(d("object", b));
                    }
                    var C = m._fullLayout, P = f(h, g);
                    return u(c, C, P, p, "layout"), 0 === p.length ? void 0 : p;
                };
                var h = {
                    object: function(t1, e1) {
                        return ("layout" === t1 && "" === e1 ? "The layout argument" : "data" === t1[0] && "" === e1 ? "Trace " + t1[1] + " in the data argument" : p(t1) + "key " + e1) + " must be linked to an object container";
                    },
                    array: function(t1, e1) {
                        return ("data" === t1 ? "The data argument" : p(t1) + "key " + e1) + " must be linked to an array container";
                    },
                    schema: function(t1, e1) {
                        return p(t1) + "key " + e1 + " is not part of the schema";
                    },
                    unused: function(t1, e1, r) {
                        var n = s(r) ? "container" : "key";
                        return p(t1) + n + " " + e1 + " did not get coerced";
                    },
                    dynamic: function(t1, e1, r, n) {
                        return [
                            p(t1) + "key",
                            e1,
                            "(set to '" + r + "')",
                            "got reset to",
                            "'" + n + "'",
                            "during defaults."
                        ].join(" ");
                    },
                    invisible: function(t1, e1) {
                        return (e1 ? p(t1) + "item " + e1 : "Trace " + t1[1]) + " got defaulted to be not visible";
                    },
                    value: function(t1, e1, r) {
                        return [
                            p(t1) + "key " + e1,
                            "is set to an invalid value (" + r + ")"
                        ].join(" ");
                    }
                };
                function p(t1) {
                    return l(t1) ? "In data trace " + t1[1] + ", " : "In " + t1 + ", ";
                }
                function d(t1, e1, r, i, a) {
                    var o, s;
                    r = r || "", l(e1) ? (o = e1[0], s = e1[1]) : (o = e1, s = null);
                    var c = function(t1) {
                        if (!l(t1)) return String(t1);
                        for(var e1 = "", r = 0; r < t1.length; r++){
                            var n = t1[r];
                            "number" == typeof n ? e1 = e1.substr(0, e1.length - 1) + "[" + n + "]" : e1 += n, r < t1.length - 1 && (e1 += ".");
                        }
                        return e1;
                    }(r), u = h[t1](e1, c, i, a);
                    return n.log(u), {
                        code: t1,
                        container: o,
                        trace: s,
                        path: r,
                        astr: c,
                        msg: u
                    };
                }
                function m(t1, e1) {
                    var r = y(e1), n = r.keyMinusId, i = r.id;
                    return !!(n in t1 && t1[n]._isSubplotObj && i) || e1 in t1;
                }
                function g(t1, e1) {
                    return e1 in t1 ? t1[e1] : t1[y(e1).keyMinusId];
                }
                var v = n.counterRegex("([a-z]+)");
                function y(t1) {
                    var e1 = t1.match(v);
                    return {
                        keyMinusId: e1 && e1[1],
                        id: e1 && e1[2]
                    };
                }
            },
            {
                "../lib": 503,
                "../plots/plots": 619,
                "./plot_config": 541,
                "./plot_schema": 542
            }
        ],
        548: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    mode: {
                        valType: "enumerated",
                        dflt: "afterall",
                        values: [
                            "immediate",
                            "next",
                            "afterall"
                        ]
                    },
                    direction: {
                        valType: "enumerated",
                        values: [
                            "forward",
                            "reverse"
                        ],
                        dflt: "forward"
                    },
                    fromcurrent: {
                        valType: "boolean",
                        dflt: !1
                    },
                    frame: {
                        duration: {
                            valType: "number",
                            min: 0,
                            dflt: 500
                        },
                        redraw: {
                            valType: "boolean",
                            dflt: !0
                        }
                    },
                    transition: {
                        duration: {
                            valType: "number",
                            min: 0,
                            dflt: 500,
                            editType: "none"
                        },
                        easing: {
                            valType: "enumerated",
                            dflt: "cubic-in-out",
                            values: [
                                "linear",
                                "quad",
                                "cubic",
                                "sin",
                                "exp",
                                "circle",
                                "elastic",
                                "back",
                                "bounce",
                                "linear-in",
                                "quad-in",
                                "cubic-in",
                                "sin-in",
                                "exp-in",
                                "circle-in",
                                "elastic-in",
                                "back-in",
                                "bounce-in",
                                "linear-out",
                                "quad-out",
                                "cubic-out",
                                "sin-out",
                                "exp-out",
                                "circle-out",
                                "elastic-out",
                                "back-out",
                                "bounce-out",
                                "linear-in-out",
                                "quad-in-out",
                                "cubic-in-out",
                                "sin-in-out",
                                "exp-in-out",
                                "circle-in-out",
                                "elastic-in-out",
                                "back-in-out",
                                "bounce-in-out"
                            ],
                            editType: "none"
                        },
                        ordering: {
                            valType: "enumerated",
                            values: [
                                "layout first",
                                "traces first"
                            ],
                            dflt: "layout first",
                            editType: "none"
                        }
                    }
                };
            },
            {}
        ],
        549: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = t1("../plot_api/plot_template");
                e1.exports = function(t1, e1, r) {
                    var a, o, s = r.name, l = r.inclusionAttr || "visible", c = e1[s], u = n.isArrayOrTypedArray(t1[s]) ? t1[s] : [], f = e1[s] = [], h = i.arrayTemplater(e1, s, l);
                    for(a = 0; a < u.length; a++){
                        var p = u[a];
                        n.isPlainObject(p) ? o = h.newItem(p) : (o = h.newItem({}))[l] = !1, o._index = a, !1 !== o[l] && r.handleItemDefaults(p, o, e1, r), f.push(o);
                    }
                    var d = h.defaultItems();
                    for(a = 0; a < d.length; a++)(o = d[a])._index = f.length, r.handleItemDefaults({}, o, e1, r, {}), f.push(o);
                    if (n.isArrayOrTypedArray(c)) {
                        var m = Math.min(c.length, f.length);
                        for(a = 0; a < m; a++)n.relinkPrivateKeys(f[a], c[a]);
                    }
                    return f;
                };
            },
            {
                "../lib": 503,
                "../plot_api/plot_template": 543
            }
        ],
        550: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./font_attributes"), i = t1("../components/fx/attributes");
                e1.exports = {
                    type: {
                        valType: "enumerated",
                        values: [],
                        dflt: "scatter",
                        editType: "calc+clearAxisTypes",
                        _noTemplating: !0
                    },
                    visible: {
                        valType: "enumerated",
                        values: [
                            !0,
                            !1,
                            "legendonly"
                        ],
                        dflt: !0,
                        editType: "calc"
                    },
                    showlegend: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "style"
                    },
                    legendgroup: {
                        valType: "string",
                        dflt: "",
                        editType: "style"
                    },
                    legendgrouptitle: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "style"
                        },
                        font: n({
                            editType: "style"
                        }),
                        editType: "style"
                    },
                    legendrank: {
                        valType: "number",
                        dflt: 1e3,
                        editType: "style"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "style"
                    },
                    name: {
                        valType: "string",
                        editType: "style"
                    },
                    uid: {
                        valType: "string",
                        editType: "plot",
                        anim: !0
                    },
                    ids: {
                        valType: "data_array",
                        editType: "calc",
                        anim: !0
                    },
                    customdata: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    meta: {
                        valType: "any",
                        arrayOk: !0,
                        editType: "plot"
                    },
                    selectedpoints: {
                        valType: "any",
                        editType: "calc"
                    },
                    hoverinfo: {
                        valType: "flaglist",
                        flags: [
                            "x",
                            "y",
                            "z",
                            "text",
                            "name"
                        ],
                        extras: [
                            "all",
                            "none",
                            "skip"
                        ],
                        arrayOk: !0,
                        dflt: "all",
                        editType: "none"
                    },
                    hoverlabel: i.hoverlabel,
                    stream: {
                        token: {
                            valType: "string",
                            noBlank: !0,
                            strict: !0,
                            editType: "calc"
                        },
                        maxpoints: {
                            valType: "number",
                            min: 0,
                            max: 1e4,
                            dflt: 500,
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    transforms: {
                        _isLinkedToArray: "transform",
                        editType: "calc"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    }
                };
            },
            {
                "../components/fx/attributes": 397,
                "./font_attributes": 585
            }
        ],
        551: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = i.dateTime2ms, o = i.incrementMonth, s = t1("../../constants/numerical").ONEAVGMONTH;
                e1.exports = function(t1, e1, r, i) {
                    if ("date" !== e1.type) return {
                        vals: i
                    };
                    var l = t1[r + "periodalignment"];
                    if (!l) return {
                        vals: i
                    };
                    var c, u = t1[r + "period"];
                    if (n(u)) {
                        if ((u = +u) <= 0) return {
                            vals: i
                        };
                    } else if ("string" == typeof u && "M" === u.charAt(0)) {
                        var f = +u.substring(1);
                        if (!(f > 0 && Math.round(f) === f)) return {
                            vals: i
                        };
                        c = f;
                    }
                    for(var h = e1.calendar, p = "start" === l, d = "end" === l, m = t1[r + "period0"], g = a(m, h) || 0, v = [], y = [], x = [], b = i.length, _ = 0; _ < b; _++){
                        var w, T, k, A = i[_];
                        if (c) {
                            for(w = Math.round((A - g) / (c * s)), k = o(g, c * w, h); k > A;)k = o(k, -c, h);
                            for(; k <= A;)k = o(k, c, h);
                            T = o(k, -c, h);
                        } else {
                            for(k = g + (w = Math.round((A - g) / u)) * u; k > A;)k -= u;
                            for(; k <= A;)k += u;
                            T = k - u;
                        }
                        v[_] = p ? T : d ? k : (T + k) / 2, y[_] = T, x[_] = k;
                    }
                    return {
                        vals: v,
                        starts: y,
                        ends: x
                    };
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "fast-isnumeric": 190
            }
        ],
        552: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    xaxis: {
                        valType: "subplotid",
                        dflt: "x",
                        editType: "calc+clearAxisTypes"
                    },
                    yaxis: {
                        valType: "subplotid",
                        dflt: "y",
                        editType: "calc+clearAxisTypes"
                    }
                };
            },
            {}
        ],
        553: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("fast-isnumeric"), a = t1("../../lib"), o = t1("../../constants/numerical").FP_SAFE, s = t1("../../registry"), l = t1("../../components/drawing"), c = t1("./axis_ids"), u = c.getFromId, f = c.isLinked;
                function h(t1, e1) {
                    var r, n, i = [], o = t1._fullLayout, s = d(o, e1, 0), l = d(o, e1, 1), c = m(t1, e1), u = c.min, f = c.max;
                    if (0 === u.length || 0 === f.length) return a.simpleMap(e1.range, e1.r2l);
                    var h = u[0].val, g = f[0].val;
                    for(r = 1; r < u.length && h === g; r++)h = Math.min(h, u[r].val);
                    for(r = 1; r < f.length && h === g; r++)g = Math.max(g, f[r].val);
                    var v = !1;
                    if (e1.range) {
                        var y = a.simpleMap(e1.range, e1.r2l);
                        v = y[1] < y[0];
                    }
                    "reversed" === e1.autorange && (v = !0, e1.autorange = !0);
                    var x, b, _, w, T, k, A = e1.rangemode, M = "tozero" === A, S = "nonnegative" === A, E = e1._length, L = E / 10, C = 0;
                    for(r = 0; r < u.length; r++)for(x = u[r], n = 0; n < f.length; n++)(k = (b = f[n]).val - x.val - p(e1, x.val, b.val)) > 0 && ((T = E - s(x) - l(b)) > L ? k / T > C && (_ = x, w = b, C = k / T) : k / E > C && (_ = {
                        val: x.val,
                        nopad: 1
                    }, w = {
                        val: b.val,
                        nopad: 1
                    }, C = k / E));
                    if (h === g) {
                        var P = h - 1, I = h + 1;
                        if (M) {
                            if (0 === h) i = [
                                0,
                                1
                            ];
                            else {
                                var O = (h > 0 ? f : u).reduce(function(t1, e1) {
                                    return Math.max(t1, l(e1));
                                }, 0), z = h / (1 - Math.min(.5, O / E));
                                i = h > 0 ? [
                                    0,
                                    z
                                ] : [
                                    z,
                                    0
                                ];
                            }
                        } else i = S ? [
                            Math.max(0, P),
                            Math.max(1, I)
                        ] : [
                            P,
                            I
                        ];
                    } else M ? (_.val >= 0 && (_ = {
                        val: 0,
                        nopad: 1
                    }), w.val <= 0 && (w = {
                        val: 0,
                        nopad: 1
                    })) : S && (_.val - C * s(_) < 0 && (_ = {
                        val: 0,
                        nopad: 1
                    }), w.val <= 0 && (w = {
                        val: 1,
                        nopad: 1
                    })), C = (w.val - _.val - p(e1, x.val, b.val)) / (E - s(_) - l(w)), i = [
                        _.val - C * s(_),
                        w.val + C * l(w)
                    ];
                    return v && i.reverse(), a.simpleMap(i, e1.l2r || Number);
                }
                function p(t1, e1, r) {
                    var n = 0;
                    if (t1.rangebreaks) for(var i = t1.locateBreaks(e1, r), a = 0; a < i.length; a++){
                        var o = i[a];
                        n += o.max - o.min;
                    }
                    return n;
                }
                function d(t1, e1, r) {
                    var i = .05 * e1._length, o = e1._anchorAxis || {};
                    if (-1 !== (e1.ticklabelposition || "").indexOf("inside") || -1 !== (o.ticklabelposition || "").indexOf("inside")) {
                        var s = "reversed" === e1.autorange;
                        if (!s) {
                            var c = a.simpleMap(e1.range, e1.r2l);
                            s = c[1] < c[0];
                        }
                        s && (r = !r);
                    }
                    var u = 0;
                    return f(t1, e1._id) || (u = function(t1, e1, r) {
                        var i = 0, o = "x" === e1._id.charAt(0);
                        for(var s in t1._plots){
                            var c = t1._plots[s];
                            if (e1._id === c.xaxis._id || e1._id === c.yaxis._id) {
                                var u = (o ? c.yaxis : c.xaxis) || {};
                                if (-1 !== (u.ticklabelposition || "").indexOf("inside") && (!r && ("left" === u.side || "bottom" === u.side) || r && ("top" === u.side || "right" === u.side))) {
                                    if (u._vals) {
                                        var f = a.deg2rad(u._tickAngles[u._id + "tick"] || 0), h = Math.abs(Math.cos(f)), p = Math.abs(Math.sin(f));
                                        if (!u._vals[0].bb) {
                                            var d = u._id + "tick";
                                            u._selections[d].each(function(t1) {
                                                var e1 = n.select(this);
                                                e1.select(".text-math-group").empty() && (t1.bb = l.bBox(e1.node()));
                                            });
                                        }
                                        for(var m = 0; m < u._vals.length; m++){
                                            var g = u._vals[m].bb;
                                            if (g) {
                                                var v = 6 + g.width, y = 6 + g.height;
                                                i = Math.max(i, o ? Math.max(v * h, y * p) : Math.max(y * h, v * p));
                                            }
                                        }
                                    }
                                    "inside" === u.ticks && "inside" === u.ticklabelposition && (i += u.ticklen || 0);
                                }
                            }
                        }
                        return i;
                    }(t1, e1, r)), i = Math.max(u, i), "domain" === e1.constrain && e1._inputDomain && (i *= (e1._inputDomain[1] - e1._inputDomain[0]) / (e1.domain[1] - e1.domain[0])), function(t1) {
                        return t1.nopad ? 0 : t1.pad + (t1.extrapad ? i : u);
                    };
                }
                e1.exports = {
                    getAutoRange: h,
                    makePadFn: d,
                    doAutoRange: function(t1, e1, r) {
                        if (e1.setScale(), e1.autorange) {
                            e1.range = r ? r.slice() : h(t1, e1), e1._r = e1.range.slice(), e1._rl = a.simpleMap(e1._r, e1.r2l);
                            var n = e1._input, i = {};
                            i[e1._attr + ".range"] = e1.range, i[e1._attr + ".autorange"] = e1.autorange, s.call("_storeDirectGUIEdit", t1.layout, t1._fullLayout._preGUI, i), n.range = e1.range.slice(), n.autorange = e1.autorange;
                        }
                        var o = e1._anchorAxis;
                        if (o && o.rangeslider) {
                            var l = o.rangeslider[e1._name];
                            l && "auto" === l.rangemode && (l.range = h(t1, e1)), o._input.rangeslider[e1._name] = a.extendFlat({}, l);
                        }
                    },
                    findExtremes: function(t1, e1, r) {
                        r || (r = {});
                        t1._m || t1.setScale();
                        var n, a, s, l, c, u, f, h, p, d = [], m = [], y = e1.length, b = r.padded || !1, _ = r.tozero && ("linear" === t1.type || "-" === t1.type), w = "log" === t1.type, T = !1, k = r.vpadLinearized || !1;
                        function A(t1) {
                            if (Array.isArray(t1)) return T = !0, function(e1) {
                                return Math.max(Number(t1[e1] || 0), 0);
                            };
                            var e1 = Math.max(Number(t1 || 0), 0);
                            return function() {
                                return e1;
                            };
                        }
                        var M = A((t1._m > 0 ? r.ppadplus : r.ppadminus) || r.ppad || 0), S = A((t1._m > 0 ? r.ppadminus : r.ppadplus) || r.ppad || 0), E = A(r.vpadplus || r.vpad), L = A(r.vpadminus || r.vpad);
                        if (!T) {
                            if (h = 1 / 0, p = -1 / 0, w) for(n = 0; n < y; n++)(a = e1[n]) < h && a > 0 && (h = a), a > p && a < o && (p = a);
                            else for(n = 0; n < y; n++)(a = e1[n]) < h && a > -o && (h = a), a > p && a < o && (p = a);
                            e1 = [
                                h,
                                p
                            ], y = 2;
                        }
                        var C = {
                            tozero: _,
                            extrapad: b
                        };
                        function P(r) {
                            s = e1[r], i(s) && (u = M(r), f = S(r), k ? (l = t1.c2l(s) - L(r), c = t1.c2l(s) + E(r)) : (h = s - L(r), p = s + E(r), w && h < p / 10 && (h = p / 10), l = t1.c2l(h), c = t1.c2l(p)), _ && (l = Math.min(0, l), c = Math.max(0, c)), x(l) && g(d, l, f, C), x(c) && v(m, c, u, C));
                        }
                        var I = Math.min(6, y);
                        for(n = 0; n < I; n++)P(n);
                        for(n = y - 1; n >= I; n--)P(n);
                        return {
                            min: d,
                            max: m,
                            opts: r
                        };
                    },
                    concatExtremes: m
                };
                function m(t1, e1, r) {
                    var n, i, a, o = e1._id, s = t1._fullData, l = t1._fullLayout, c = [], f = [];
                    function h(t1, e1) {
                        for(n = 0; n < e1.length; n++){
                            var r = t1[e1[n]], s = (r._extremes || {})[o];
                            if (!0 === r.visible && s) {
                                for(i = 0; i < s.min.length; i++)a = s.min[i], g(c, a.val, a.pad, {
                                    extrapad: a.extrapad
                                });
                                for(i = 0; i < s.max.length; i++)a = s.max[i], v(f, a.val, a.pad, {
                                    extrapad: a.extrapad
                                });
                            }
                        }
                    }
                    if (h(s, e1._traceIndices), h(l.annotations || [], e1._annIndices || []), h(l.shapes || [], e1._shapeIndices || []), e1._matchGroup && !r) {
                        for(var p in e1._matchGroup)if (p !== e1._id) {
                            var d = u(t1, p), y = m(t1, d, !0), x = e1._length / d._length;
                            for(i = 0; i < y.min.length; i++)a = y.min[i], g(c, a.val, a.pad * x, {
                                extrapad: a.extrapad
                            });
                            for(i = 0; i < y.max.length; i++)a = y.max[i], v(f, a.val, a.pad * x, {
                                extrapad: a.extrapad
                            });
                        }
                    }
                    return {
                        min: c,
                        max: f
                    };
                }
                function g(t1, e1, r, n) {
                    y(t1, e1, r, n, b);
                }
                function v(t1, e1, r, n) {
                    y(t1, e1, r, n, _);
                }
                function y(t1, e1, r, n, i) {
                    for(var a = n.tozero, o = n.extrapad, s = !0, l = 0; l < t1.length && s; l++){
                        var c = t1[l];
                        if (i(c.val, e1) && c.pad >= r && (c.extrapad || !o)) {
                            s = !1;
                            break;
                        }
                        i(e1, c.val) && c.pad <= r && (o || !c.extrapad) && (t1.splice(l, 1), l--);
                    }
                    if (s) {
                        var u = a && 0 === e1;
                        t1.push({
                            val: e1,
                            pad: u ? 0 : r,
                            extrapad: !u && o
                        });
                    }
                }
                function x(t1) {
                    return i(t1) && Math.abs(t1) < o;
                }
                function b(t1, e1) {
                    return t1 <= e1;
                }
                function _(t1, e1) {
                    return t1 >= e1;
                }
            },
            {
                "../../components/drawing": 388,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../registry": 638,
                "./axis_ids": 558,
                "@plotly/d3": 58,
                "fast-isnumeric": 190
            }
        ],
        554: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("fast-isnumeric"), a = t1("../../plots/plots"), o = t1("../../registry"), s = t1("../../lib"), l = s.strTranslate, c = t1("../../lib/svg_text_utils"), u = t1("../../components/titles"), f = t1("../../components/color"), h = t1("../../components/drawing"), p = t1("./layout_attributes"), d = t1("./clean_ticks"), m = t1("../../constants/numerical"), g = m.ONEMAXYEAR, v = m.ONEAVGYEAR, y = m.ONEMINYEAR, x = m.ONEMAXQUARTER, b = m.ONEAVGQUARTER, _ = m.ONEMINQUARTER, w = m.ONEMAXMONTH, T = m.ONEAVGMONTH, k = m.ONEMINMONTH, A = m.ONEWEEK, M = m.ONEDAY, S = M / 2, E = m.ONEHOUR, L = m.ONEMIN, C = m.ONESEC, P = m.MINUS_SIGN, I = m.BADNUM, O = {
                    K: "zeroline"
                }, z = {
                    K: "gridline",
                    L: "path"
                }, D = {
                    K: "tick",
                    L: "path"
                }, R = {
                    K: "tick",
                    L: "text"
                }, F = t1("../../constants/alignment"), B = F.MID_SHIFT, N = F.CAP_SHIFT, j = F.LINE_SPACING, U = F.OPPOSITE_SIDE, V = e1.exports = {};
                V.setConvert = t1("./set_convert");
                var H = t1("./axis_autotype"), q = t1("./axis_ids"), G = q.idSort, Y = q.isLinked;
                V.id2name = q.id2name, V.name2id = q.name2id, V.cleanId = q.cleanId, V.list = q.list, V.listIds = q.listIds, V.getFromId = q.getFromId, V.getFromTrace = q.getFromTrace;
                var W = t1("./autorange");
                V.getAutoRange = W.getAutoRange, V.findExtremes = W.findExtremes;
                function X(t1) {
                    var e1 = 1e-4 * (t1[1] - t1[0]);
                    return [
                        t1[0] - e1,
                        t1[1] + e1
                    ];
                }
                V.coerceRef = function(t1, e1, r, n, i, a) {
                    var o = n.charAt(n.length - 1), l = r._fullLayout._subplots[o + "axis"], c = n + "ref", u = {};
                    return i || (i = l[0] || ("string" == typeof a ? a : a[0])), a || (a = i), l = l.concat(l.map(function(t1) {
                        return t1 + " domain";
                    })), u[c] = {
                        valType: "enumerated",
                        values: l.concat(a ? "string" == typeof a ? [
                            a
                        ] : a : []),
                        dflt: i
                    }, s.coerce(t1, e1, u, c);
                }, V.getRefType = function(t1) {
                    return void 0 === t1 ? t1 : "paper" === t1 ? "paper" : "pixel" === t1 ? "pixel" : /( domain)$/.test(t1) ? "domain" : "range";
                }, V.coercePosition = function(t1, e1, r, n, i, a) {
                    var o, l;
                    if ("range" !== V.getRefType(n)) o = s.ensureNumber, l = r(i, a);
                    else {
                        var c = V.getFromId(e1, n);
                        l = r(i, a = c.fraction2r(a)), o = c.cleanPos;
                    }
                    t1[i] = o(l);
                }, V.cleanPosition = function(t1, e1, r) {
                    return ("paper" === r || "pixel" === r ? s.ensureNumber : V.getFromId(e1, r).cleanPos)(t1);
                }, V.redrawComponents = function(t1, e1) {
                    e1 = e1 || V.listIds(t1);
                    var r = t1._fullLayout;
                    function n(n, i, a, s) {
                        for(var l = o.getComponentMethod(n, i), c = {}, u = 0; u < e1.length; u++)for(var f = r[V.id2name(e1[u])][a], h = 0; h < f.length; h++){
                            var p = f[h];
                            if (!c[p] && (l(t1, p), c[p] = 1, s)) return;
                        }
                    }
                    n("annotations", "drawOne", "_annIndices"), n("shapes", "drawOne", "_shapeIndices"), n("images", "draw", "_imgIndices", !0);
                };
                var Z = V.getDataConversions = function(t1, e1, r, n) {
                    var i, a = "x" === r || "y" === r || "z" === r ? r : n;
                    if (Array.isArray(a)) {
                        if (i = {
                            type: H(n, void 0, {
                                autotypenumbers: t1._fullLayout.autotypenumbers
                            }),
                            _categories: []
                        }, V.setConvert(i), "category" === i.type) for(var o = 0; o < n.length; o++)i.d2c(n[o]);
                    } else i = V.getFromTrace(t1, e1, a);
                    return i ? {
                        d2c: i.d2c,
                        c2d: i.c2d
                    } : "ids" === a ? {
                        d2c: K,
                        c2d: K
                    } : {
                        d2c: J,
                        c2d: J
                    };
                };
                function J(t1) {
                    return +t1;
                }
                function K(t1) {
                    return String(t1);
                }
                function Q(t1) {
                    return +t1.substring(1);
                }
                V.getDataToCoordFunc = function(t1, e1, r, n) {
                    return Z(t1, e1, r, n).d2c;
                }, V.counterLetter = function(t1) {
                    var e1 = t1.charAt(0);
                    return "x" === e1 ? "y" : "y" === e1 ? "x" : void 0;
                }, V.minDtick = function(t1, e1, r, n) {
                    -1 === [
                        "log",
                        "category",
                        "multicategory"
                    ].indexOf(t1.type) && n ? void 0 === t1._minDtick ? (t1._minDtick = e1, t1._forceTick0 = r) : t1._minDtick && ((t1._minDtick / e1 + 1e-6) % 1 < 2e-6 && ((r - t1._forceTick0) / e1 % 1 + 1.000001) % 1 < 2e-6 ? (t1._minDtick = e1, t1._forceTick0 = r) : ((e1 / t1._minDtick + 1e-6) % 1 > 2e-6 || ((r - t1._forceTick0) / t1._minDtick % 1 + 1.000001) % 1 > 2e-6) && (t1._minDtick = 0)) : t1._minDtick = 0;
                }, V.saveRangeInitial = function(t1, e1) {
                    for(var r = V.list(t1, "", !0), n = !1, i = 0; i < r.length; i++){
                        var a = r[i], o = void 0 === a._rangeInitial, s = o || !(a.range[0] === a._rangeInitial[0] && a.range[1] === a._rangeInitial[1]);
                        (o && !1 === a.autorange || e1 && s) && (a._rangeInitial = a.range.slice(), n = !0);
                    }
                    return n;
                }, V.saveShowSpikeInitial = function(t1, e1) {
                    for(var r = V.list(t1, "", !0), n = !1, i = "on", a = 0; a < r.length; a++){
                        var o = r[a], s = void 0 === o._showSpikeInitial, l = s || !(o.showspikes === o._showspikes);
                        (s || e1 && l) && (o._showSpikeInitial = o.showspikes, n = !0), "on" !== i || o.showspikes || (i = "off");
                    }
                    return t1._fullLayout._cartesianSpikesEnabled = i, n;
                }, V.autoBin = function(t1, e1, r, n, a, o) {
                    var l, c = s.aggNums(Math.min, null, t1), u = s.aggNums(Math.max, null, t1);
                    if ("category" === e1.type || "multicategory" === e1.type) return {
                        start: c - .5,
                        end: u + .5,
                        size: Math.max(1, Math.round(o) || 1),
                        _dataSpan: u - c
                    };
                    if (a || (a = e1.calendar), l = "log" === e1.type ? {
                        type: "linear",
                        range: [
                            c,
                            u
                        ]
                    } : {
                        type: e1.type,
                        range: s.simpleMap([
                            c,
                            u
                        ], e1.c2r, 0, a),
                        calendar: a
                    }, V.setConvert(l), o = o && d.dtick(o, l.type)) l.dtick = o, l.tick0 = d.tick0(void 0, l.type, a);
                    else {
                        var f;
                        if (r) f = (u - c) / r;
                        else {
                            var h = s.distinctVals(t1), p = Math.pow(10, Math.floor(Math.log(h.minDiff) / Math.LN10)), m = p * s.roundUp(h.minDiff / p, [
                                .9,
                                1.9,
                                4.9,
                                9.9
                            ], !0);
                            f = Math.max(m, 2 * s.stdev(t1) / Math.pow(t1.length, n ? .25 : .4)), i(f) || (f = 1);
                        }
                        V.autoTicks(l, f);
                    }
                    var g, v = l.dtick, y = V.tickIncrement(V.tickFirst(l), v, "reverse", a);
                    if ("number" == typeof v) g = (y = function(t1, e1, r, n, a) {
                        var o = 0, s = 0, l = 0, c = 0;
                        function u(e1) {
                            return (1 + 100 * (e1 - t1) / r.dtick) % 100 < 2;
                        }
                        for(var f = 0; f < e1.length; f++)e1[f] % 1 == 0 ? l++ : i(e1[f]) || c++, u(e1[f]) && o++, u(e1[f] + r.dtick / 2) && s++;
                        var h = e1.length - c;
                        if (l === h && "date" !== r.type) r.dtick < 1 ? t1 = n - .5 * r.dtick : (t1 -= .5) + r.dtick < n && (t1 += r.dtick);
                        else if (s < .1 * h && (o > .3 * h || u(n) || u(a))) {
                            var p = r.dtick / 2;
                            t1 += t1 + p < n ? p : -p;
                        }
                        return t1;
                    }(y, t1, l, c, u)) + (1 + Math.floor((u - y) / v)) * v;
                    else for("M" === l.dtick.charAt(0) && (y = function(t1, e1, r, n, i) {
                        var a = s.findExactDates(e1, i);
                        if (a.exactDays > .8) {
                            var o = Number(r.substr(1));
                            a.exactYears > .8 && o % 12 == 0 ? t1 = V.tickIncrement(t1, "M6", "reverse") + 1.5 * M : a.exactMonths > .8 ? t1 = V.tickIncrement(t1, "M1", "reverse") + 15.5 * M : t1 -= S;
                            var l = V.tickIncrement(t1, r);
                            if (l <= n) return l;
                        }
                        return t1;
                    }(y, t1, v, c, a)), g = y; g <= u;)g = V.tickIncrement(g, v, !1, a);
                    return {
                        start: e1.c2r(y, 0, a),
                        end: e1.c2r(g, 0, a),
                        size: v,
                        _dataSpan: u - c
                    };
                }, V.prepTicks = function(t1, e1) {
                    var r = s.simpleMap(t1.range, t1.r2l, void 0, void 0, e1);
                    if (t1._dtickInit = t1.dtick, t1._tick0Init = t1.tick0, "auto" === t1.tickmode || !t1.dtick) {
                        var n, a = t1.nticks;
                        a || ("category" === t1.type || "multicategory" === t1.type ? (n = t1.tickfont ? s.bigFont(t1.tickfont.size || 12) : 15, a = t1._length / n) : (n = "y" === t1._id.charAt(0) ? 40 : 80, a = s.constrain(t1._length / n, 4, 9) + 1), "radialaxis" === t1._name && (a *= 2)), "array" === t1.tickmode && (a *= 100), t1._roughDTick = Math.abs(r[1] - r[0]) / a, V.autoTicks(t1, t1._roughDTick), t1._minDtick > 0 && t1.dtick < 2 * t1._minDtick && (t1.dtick = t1._minDtick, t1.tick0 = t1.l2r(t1._forceTick0));
                    }
                    "period" === t1.ticklabelmode && function(t1) {
                        var e1;
                        function r() {
                            return !(i(t1.dtick) || "M" !== t1.dtick.charAt(0));
                        }
                        var n = r(), a = V.getTickFormat(t1);
                        if (a) {
                            var o = t1._dtickInit !== t1.dtick;
                            /%[fLQsSMX]/.test(a) || (/%[HI]/.test(a) ? (e1 = E, o && !n && t1.dtick < E && (t1.dtick = E)) : /%p/.test(a) ? (e1 = S, o && !n && t1.dtick < S && (t1.dtick = S)) : /%[Aadejuwx]/.test(a) ? (e1 = M, o && !n && t1.dtick < M && (t1.dtick = M)) : /%[UVW]/.test(a) ? (e1 = A, o && !n && t1.dtick < A && (t1.dtick = A)) : /%[Bbm]/.test(a) ? (e1 = T, o && (n ? Q(t1.dtick) < 1 : t1.dtick < k) && (t1.dtick = "M1")) : /%[q]/.test(a) ? (e1 = b, o && (n ? Q(t1.dtick) < 3 : t1.dtick < _) && (t1.dtick = "M3")) : /%[Yy]/.test(a) && (e1 = v, o && (n ? Q(t1.dtick) < 12 : t1.dtick < y) && (t1.dtick = "M12")));
                        }
                        (n = r()) && t1.tick0 === t1._dowTick0 && (t1.tick0 = t1._rawTick0);
                        t1._definedDelta = e1;
                    }(t1), t1.tick0 || (t1.tick0 = "date" === t1.type ? "2000-01-01" : 0), "date" === t1.type && t1.dtick < .1 && (t1.dtick = .1), st(t1);
                }, V.calcTicks = function(t1, e1) {
                    V.prepTicks(t1, e1);
                    var r = s.simpleMap(t1.range, t1.r2l, void 0, void 0, e1);
                    if ("array" === t1.tickmode) return function(t1) {
                        var e1 = t1.tickvals, r = t1.ticktext, n = new Array(e1.length), i = X(s.simpleMap(t1.range, t1.r2l)), a = Math.min(i[0], i[1]), o = Math.max(i[0], i[1]), l = 0;
                        Array.isArray(r) || (r = []);
                        var c = "category" === t1.type ? t1.d2l_noadd : t1.d2l;
                        "log" === t1.type && "L" !== String(t1.dtick).charAt(0) && (t1.dtick = "L" + Math.pow(10, Math.floor(Math.min(t1.range[0], t1.range[1])) - 1));
                        for(var u = 0; u < e1.length; u++){
                            var f = c(e1[u]);
                            f > a && f < o && (void 0 === r[u] ? n[l] = V.tickText(t1, f) : n[l] = lt(t1, f, String(r[u])), l++);
                        }
                        l < e1.length && n.splice(l, e1.length - l);
                        t1.rangebreaks && (n = n.filter(function(e1) {
                            return t1.maskBreaks(e1.x) !== I;
                        }));
                        return n;
                    }(t1);
                    var n = X(r), a = n[0], o = n[1], l = r[1] < r[0], c = Math.min(r[0], r[1]), u = Math.max(r[0], r[1]), f = "log" === t1.type && !(i(t1.dtick) || "L" === t1.dtick.charAt(0)), h = "period" === t1.ticklabelmode;
                    if (t1._tmin = V.tickFirst(t1, e1), t1._tmin < a !== l) return [];
                    "category" !== t1.type && "multicategory" !== t1.type || (o = l ? Math.max(-0.5, o) : Math.min(t1._categories.length - .5, o));
                    var p = t1._tmin;
                    t1.rangebreaks && t1._tick0Init !== t1.tick0 && (p = Mt(p, t1), l || (p = V.tickIncrement(p, t1.dtick, !l, t1.calendar))), h && (p = V.tickIncrement(p, t1.dtick, !l, t1.calendar));
                    for(var d, m = Math.max(1e3, t1._length || 0), L = [], C = null; l ? p >= o : p <= o; p = V.tickIncrement(p, t1.dtick, l, t1.calendar)){
                        if (t1.rangebreaks && !l) {
                            if (p < a) continue;
                            if (t1.maskBreaks(p) === I && Mt(p, t1) >= u) break;
                        }
                        if (L.length > m || p === C) break;
                        C = p;
                        var P = !1;
                        f && p !== (0 | p) && (P = !0), L.push({
                            minor: P,
                            value: p
                        });
                    }
                    if (h && function(t1, e1, r) {
                        for(var n = 0; n < t1.length; n++){
                            var i = t1[n].value, a = n, o = n + 1;
                            n < t1.length - 1 ? (a = n, o = n + 1) : n > 0 ? (a = n - 1, o = n) : (a = n, o = n);
                            var s, l = t1[a].value, c = t1[o].value, u = Math.abs(c - l), f = r || u, h = 0;
                            f >= y ? h = u >= y && u <= g ? u : v : r === b && f >= _ ? h = u >= _ && u <= x ? u : b : f >= k ? h = u >= k && u <= w ? u : T : r === A && f >= A ? h = A : f >= M ? h = M : r === S && f >= S ? h = S : r === E && f >= E && (h = E), h >= u && (h = u, s = !0);
                            var p = i + h;
                            if (e1.rangebreaks && h > 0) {
                                for(var d = 0, m = 0; m < 84; m++){
                                    var L = (m + .5) / 84;
                                    e1.maskBreaks(i * (1 - L) + L * p) !== I && d++;
                                }
                                (h *= d / 84) || (t1[n].drop = !0), s && u > A && (h = u);
                            }
                            (h > 0 || 0 === n) && (t1[n].periodX = i + h / 2);
                        }
                    }(L, t1, t1._definedDelta), t1.rangebreaks) {
                        var O = "y" === t1._id.charAt(0), z = 1;
                        "auto" === t1.tickmode && (z = t1.tickfont ? t1.tickfont.size : 12);
                        var D = NaN;
                        for(d = L.length - 1; d > -1; d--)if (L[d].drop) L.splice(d, 1);
                        else {
                            L[d].value = Mt(L[d].value, t1);
                            var R = t1.c2p(L[d].value);
                            (O ? D > R - z : D < R + z) ? L.splice(l ? d + 1 : d, 1) : D = R;
                        }
                    }
                    At(t1) && 360 === Math.abs(r[1] - r[0]) && L.pop(), t1._tmax = (L[L.length - 1] || {}).value, t1._prevDateHead = "", t1._inCalcTicks = !0;
                    var F, B, N = [];
                    for(d = 0; d < L.length; d++){
                        var j = L[d].minor, U = L[d].value;
                        F = V.tickText(t1, U, !1, j), void 0 !== (B = L[d].periodX) && (F.periodX = B, (B > u || B < c) && (B > u && (F.periodX = u), B < c && (F.periodX = c), F.text = " ", t1._prevDateHead = "")), N.push(F);
                    }
                    return t1._inCalcTicks = !1, N;
                };
                var $ = [
                    2,
                    5,
                    10
                ], tt = [
                    1,
                    2,
                    3,
                    6,
                    12
                ], et = [
                    1,
                    2,
                    5,
                    10,
                    15,
                    30
                ], rt = [
                    1,
                    2,
                    3,
                    7,
                    14
                ], nt = [
                    -0.046,
                    0,
                    .301,
                    .477,
                    .602,
                    .699,
                    .778,
                    .845,
                    .903,
                    .954,
                    1
                ], it = [
                    -0.301,
                    0,
                    .301,
                    .699,
                    1
                ], at = [
                    15,
                    30,
                    45,
                    90,
                    180
                ];
                function ot(t1, e1, r) {
                    return e1 * s.roundUp(t1 / e1, r);
                }
                function st(t1) {
                    var e1 = t1.dtick;
                    if (t1._tickexponent = 0, i(e1) || "string" == typeof e1 || (e1 = 1), "category" !== t1.type && "multicategory" !== t1.type || (t1._tickround = null), "date" === t1.type) {
                        var r = t1.r2l(t1.tick0), n = t1.l2r(r).replace(/(^-|i)/g, ""), a = n.length;
                        if ("M" === String(e1).charAt(0)) a > 10 || "01-01" !== n.substr(5) ? t1._tickround = "d" : t1._tickround = +e1.substr(1) % 12 == 0 ? "y" : "m";
                        else if (e1 >= M && a <= 10 || e1 >= 15 * M) t1._tickround = "d";
                        else if (e1 >= L && a <= 16 || e1 >= E) t1._tickround = "M";
                        else if (e1 >= C && a <= 19 || e1 >= L) t1._tickround = "S";
                        else {
                            var o = t1.l2r(r + e1).replace(/^-/, "").length;
                            t1._tickround = Math.max(a, o) - 20, t1._tickround < 0 && (t1._tickround = 4);
                        }
                    } else if (i(e1) || "L" === e1.charAt(0)) {
                        var s = t1.range.map(t1.r2d || Number);
                        i(e1) || (e1 = Number(e1.substr(1))), t1._tickround = 2 - Math.floor(Math.log(e1) / Math.LN10 + .01);
                        var l = Math.max(Math.abs(s[0]), Math.abs(s[1])), c = Math.floor(Math.log(l) / Math.LN10 + .01), u = void 0 === t1.minexponent ? 3 : t1.minexponent;
                        Math.abs(c) > u && (ut(t1.exponentformat) && !ft(c) ? t1._tickexponent = 3 * Math.round((c - 1) / 3) : t1._tickexponent = c);
                    } else t1._tickround = null;
                }
                function lt(t1, e1, r) {
                    var n = t1.tickfont || {};
                    return {
                        x: e1,
                        dx: 0,
                        dy: 0,
                        text: r || "",
                        fontSize: n.size,
                        font: n.family,
                        fontColor: n.color
                    };
                }
                V.autoTicks = function(t1, e1) {
                    var r;
                    function n(t1) {
                        return Math.pow(t1, Math.floor(Math.log(e1) / Math.LN10));
                    }
                    if ("date" === t1.type) {
                        t1.tick0 = s.dateTick0(t1.calendar, 0);
                        var a = 2 * e1;
                        if (a > v) e1 /= v, r = n(10), t1.dtick = "M" + 12 * ot(e1, r, $);
                        else if (a > T) e1 /= T, t1.dtick = "M" + ot(e1, 1, tt);
                        else if (a > M) {
                            t1.dtick = ot(e1, M, t1._hasDayOfWeekBreaks ? [
                                1,
                                2,
                                7,
                                14
                            ] : rt);
                            var o = V.getTickFormat(t1), l = "period" === t1.ticklabelmode;
                            l && (t1._rawTick0 = t1.tick0), /%[uVW]/.test(o) ? t1.tick0 = s.dateTick0(t1.calendar, 2) : t1.tick0 = s.dateTick0(t1.calendar, 1), l && (t1._dowTick0 = t1.tick0);
                        } else a > E ? t1.dtick = ot(e1, E, tt) : a > L ? t1.dtick = ot(e1, L, et) : a > C ? t1.dtick = ot(e1, C, et) : (r = n(10), t1.dtick = ot(e1, r, $));
                    } else if ("log" === t1.type) {
                        t1.tick0 = 0;
                        var c = s.simpleMap(t1.range, t1.r2l);
                        if (e1 > .7) t1.dtick = Math.ceil(e1);
                        else if (Math.abs(c[1] - c[0]) < 1) {
                            var u = 1.5 * Math.abs((c[1] - c[0]) / e1);
                            e1 = Math.abs(Math.pow(10, c[1]) - Math.pow(10, c[0])) / u, r = n(10), t1.dtick = "L" + ot(e1, r, $);
                        } else t1.dtick = e1 > .3 ? "D2" : "D1";
                    } else "category" === t1.type || "multicategory" === t1.type ? (t1.tick0 = 0, t1.dtick = Math.ceil(Math.max(e1, 1))) : At(t1) ? (t1.tick0 = 0, r = 1, t1.dtick = ot(e1, r, at)) : (t1.tick0 = 0, r = n(10), t1.dtick = ot(e1, r, $));
                    if (0 === t1.dtick && (t1.dtick = 1), !i(t1.dtick) && "string" != typeof t1.dtick) {
                        var f = t1.dtick;
                        throw t1.dtick = 1, "ax.dtick error: " + String(f);
                    }
                }, V.tickIncrement = function(t1, e1, r, a) {
                    var o = r ? -1 : 1;
                    if (i(e1)) return s.increment(t1, o * e1);
                    var l = e1.charAt(0), c = o * Number(e1.substr(1));
                    if ("M" === l) return s.incrementMonth(t1, c, a);
                    if ("L" === l) return Math.log(Math.pow(10, t1) + c) / Math.LN10;
                    if ("D" === l) {
                        var u = "D2" === e1 ? it : nt, f = t1 + .01 * o, h = s.roundUp(s.mod(f, 1), u, r);
                        return Math.floor(f) + Math.log(n.round(Math.pow(10, h), 1)) / Math.LN10;
                    }
                    throw "unrecognized dtick " + String(e1);
                }, V.tickFirst = function(t1, e1) {
                    var r = t1.r2l || Number, a = s.simpleMap(t1.range, r, void 0, void 0, e1), o = a[1] < a[0], l = o ? Math.floor : Math.ceil, c = X(a)[0], u = t1.dtick, f = r(t1.tick0);
                    if (i(u)) {
                        var h = l((c - f) / u) * u + f;
                        return "category" !== t1.type && "multicategory" !== t1.type || (h = s.constrain(h, 0, t1._categories.length - 1)), h;
                    }
                    var p = u.charAt(0), d = Number(u.substr(1));
                    if ("M" === p) {
                        for(var m, g, v, y = 0, x = f; y < 10;){
                            if (((m = V.tickIncrement(x, u, o, t1.calendar)) - c) * (x - c) <= 0) return o ? Math.min(x, m) : Math.max(x, m);
                            g = (c - (x + m) / 2) / (m - x), v = p + (Math.abs(Math.round(g)) || 1) * d, x = V.tickIncrement(x, v, g < 0 ? !o : o, t1.calendar), y++;
                        }
                        return s.error("tickFirst did not converge", t1), x;
                    }
                    if ("L" === p) return Math.log(l((Math.pow(10, c) - f) / d) * d + f) / Math.LN10;
                    if ("D" === p) {
                        var b = "D2" === u ? it : nt, _ = s.roundUp(s.mod(c, 1), b, o);
                        return Math.floor(c) + Math.log(n.round(Math.pow(10, _), 1)) / Math.LN10;
                    }
                    throw "unrecognized dtick " + String(u);
                }, V.tickText = function(t1, e1, r, n) {
                    var a, o = lt(t1, e1), l = "array" === t1.tickmode, c = r || l, u = t1.type, f = "category" === u ? t1.d2l_noadd : t1.d2l;
                    if (l && Array.isArray(t1.ticktext)) {
                        var h = s.simpleMap(t1.range, t1.r2l), p = (Math.abs(h[1] - h[0]) - (t1._lBreaks || 0)) / 1e4;
                        for(a = 0; a < t1.ticktext.length && !(Math.abs(e1 - f(t1.tickvals[a])) < p); a++);
                        if (a < t1.ticktext.length) return o.text = String(t1.ticktext[a]), o;
                    }
                    function d(n) {
                        if (void 0 === n) return !0;
                        if (r) return "none" === n;
                        var i = {
                            first: t1._tmin,
                            last: t1._tmax
                        }[n];
                        return "all" !== n && e1 !== i;
                    }
                    var m = r ? "never" : "none" !== t1.exponentformat && d(t1.showexponent) ? "hide" : "";
                    if ("date" === u ? function(t1, e1, r, n) {
                        var a = t1._tickround, o = r && t1.hoverformat || V.getTickFormat(t1);
                        n && (a = i(a) ? 4 : ({
                            y: "m",
                            m: "d",
                            d: "M",
                            M: "S",
                            S: 4
                        })[a]);
                        var l, c = s.formatDate(e1.x, o, a, t1._dateFormat, t1.calendar, t1._extraFormat), u = c.indexOf("\n");
                        -1 !== u && (l = c.substr(u + 1), c = c.substr(0, u));
                        n && ("00:00:00" === c || "00:00" === c ? (c = l, l = "") : 8 === c.length && (c = c.replace(/:00$/, "")));
                        if (l) {
                            if (r) "d" === a ? c += ", " + l : c = l + (c ? ", " + c : "");
                            else if (t1._inCalcTicks && t1._prevDateHead === l) {
                                var f = St(t1), h = t1._trueSide || t1.side;
                                (!f && "top" === h || f && "bottom" === h) && (c += "<br> ");
                            } else t1._prevDateHead = l, c += "<br>" + l;
                        }
                        e1.text = c;
                    }(t1, o, r, c) : "log" === u ? function(t1, e1, r, n, a) {
                        var o = t1.dtick, l = e1.x, c = t1.tickformat, u = "string" == typeof o && o.charAt(0);
                        "never" === a && (a = "");
                        n && "L" !== u && (o = "L3", u = "L");
                        if (c || "L" === u) e1.text = ht(Math.pow(10, l), t1, a, n);
                        else if (i(o) || "D" === u && s.mod(l + .01, 1) < .1) {
                            var f = Math.round(l), h = Math.abs(f), p = t1.exponentformat;
                            "power" === p || ut(p) && ft(f) ? (e1.text = 0 === f ? 1 : 1 === f ? "10" : "10<sup>" + (f > 1 ? "" : P) + h + "</sup>", e1.fontSize *= 1.25) : ("e" === p || "E" === p) && h > 2 ? e1.text = "1" + p + (f > 0 ? "+" : P) + h : (e1.text = ht(Math.pow(10, l), t1, "", "fakehover"), "D1" === o && "y" === t1._id.charAt(0) && (e1.dy -= e1.fontSize / 6));
                        } else {
                            if ("D" !== u) throw "unrecognized dtick " + String(o);
                            e1.text = String(Math.round(Math.pow(10, s.mod(l, 1)))), e1.fontSize *= .75;
                        }
                        if ("D1" === t1.dtick) {
                            var d = String(e1.text).charAt(0);
                            "0" !== d && "1" !== d || ("y" === t1._id.charAt(0) ? e1.dx -= e1.fontSize / 4 : (e1.dy += e1.fontSize / 2, e1.dx += (t1.range[1] > t1.range[0] ? 1 : -1) * e1.fontSize * (l < 0 ? .5 : .25)));
                        }
                    }(t1, o, 0, c, m) : "category" === u ? function(t1, e1) {
                        var r = t1._categories[Math.round(e1.x)];
                        void 0 === r && (r = "");
                        e1.text = String(r);
                    }(t1, o) : "multicategory" === u ? function(t1, e1, r) {
                        var n = Math.round(e1.x), i = t1._categories[n] || [], a = void 0 === i[1] ? "" : String(i[1]), o = void 0 === i[0] ? "" : String(i[0]);
                        r ? e1.text = o + " - " + a : (e1.text = a, e1.text2 = o);
                    }(t1, o, r) : At(t1) ? function(t1, e1, r, n, i) {
                        if ("radians" !== t1.thetaunit || r) e1.text = ht(e1.x, t1, i, n);
                        else {
                            var a = e1.x / 180;
                            if (0 === a) e1.text = "0";
                            else {
                                var o = function(t1) {
                                    function e1(t1, e1) {
                                        return Math.abs(t1 - e1) <= 1e-6;
                                    }
                                    var r = function(t1) {
                                        for(var r = 1; !e1(Math.round(t1 * r) / r, t1);)r *= 10;
                                        return r;
                                    }(t1), n = t1 * r, i = Math.abs(function t1(r, n) {
                                        return e1(n, 0) ? r : t1(n, r % n);
                                    }(n, r));
                                    return [
                                        Math.round(n / i),
                                        Math.round(r / i)
                                    ];
                                }(a);
                                if (o[1] >= 100) e1.text = ht(s.deg2rad(e1.x), t1, i, n);
                                else {
                                    var l = e1.x < 0;
                                    1 === o[1] ? 1 === o[0] ? e1.text = "\u03c0" : e1.text = o[0] + "\u03c0" : e1.text = [
                                        "<sup>",
                                        o[0],
                                        "</sup>",
                                        "\u2044",
                                        "<sub>",
                                        o[1],
                                        "</sub>",
                                        "\u03c0"
                                    ].join(""), l && (e1.text = P + e1.text);
                                }
                            }
                        }
                    }(t1, o, r, c, m) : function(t1, e1, r, n, i) {
                        "never" === i ? i = "" : "all" === t1.showexponent && Math.abs(e1.x / t1.dtick) < 1e-6 && (i = "hide");
                        e1.text = ht(e1.x, t1, i, n);
                    }(t1, o, 0, c, m), n || (t1.tickprefix && !d(t1.showtickprefix) && (o.text = t1.tickprefix + o.text), t1.ticksuffix && !d(t1.showticksuffix) && (o.text += t1.ticksuffix)), "boundaries" === t1.tickson || t1.showdividers) {
                        var g = function(e1) {
                            var r = t1.l2p(e1);
                            return r >= 0 && r <= t1._length ? e1 : null;
                        };
                        o.xbnd = [
                            g(o.x - .5),
                            g(o.x + t1.dtick - .5)
                        ];
                    }
                    return o;
                }, V.hoverLabelText = function(t1, e1, r) {
                    r && (t1 = s.extendFlat({}, t1, {
                        hoverformat: r
                    }));
                    var n = Array.isArray(e1) ? e1[0] : e1, i = Array.isArray(e1) ? e1[1] : void 0;
                    if (void 0 !== i && i !== n) return V.hoverLabelText(t1, n, r) + " - " + V.hoverLabelText(t1, i, r);
                    var a = "log" === t1.type && n <= 0, o = V.tickText(t1, t1.c2l(a ? -n : n), "hover").text;
                    return a ? 0 === n ? "0" : P + o : o;
                };
                var ct = [
                    "f",
                    "p",
                    "n",
                    "\u03bc",
                    "m",
                    "",
                    "k",
                    "M",
                    "G",
                    "T"
                ];
                function ut(t1) {
                    return "SI" === t1 || "B" === t1;
                }
                function ft(t1) {
                    return t1 > 14 || t1 < -15;
                }
                function ht(t1, e1, r, n) {
                    var a = t1 < 0, o = e1._tickround, l = r || e1.exponentformat || "B", c = e1._tickexponent, u = V.getTickFormat(e1), f = e1.separatethousands;
                    if (n) {
                        var h = {
                            exponentformat: l,
                            minexponent: e1.minexponent,
                            dtick: "none" === e1.showexponent ? e1.dtick : i(t1) && Math.abs(t1) || 1,
                            range: "none" === e1.showexponent ? e1.range.map(e1.r2d) : [
                                0,
                                t1 || 1
                            ]
                        };
                        st(h), o = (Number(h._tickround) || 0) + 4, c = h._tickexponent, e1.hoverformat && (u = e1.hoverformat);
                    }
                    if (u) return e1._numFormat(u)(t1).replace(/-/g, P);
                    var p, d = Math.pow(10, -o) / 2;
                    if ("none" === l && (c = 0), (t1 = Math.abs(t1)) < d) t1 = "0", a = !1;
                    else {
                        if (t1 += d, c && (t1 *= Math.pow(10, -c), o += c), 0 === o) t1 = String(Math.floor(t1));
                        else if (o < 0) {
                            t1 = (t1 = String(Math.round(t1))).substr(0, t1.length + o);
                            for(var m = o; m < 0; m++)t1 += "0";
                        } else {
                            var g = (t1 = String(t1)).indexOf(".") + 1;
                            g && (t1 = t1.substr(0, g + o).replace(/\.?0+$/, ""));
                        }
                        t1 = s.numSeparate(t1, e1._separators, f);
                    }
                    c && "hide" !== l && (ut(l) && ft(c) && (l = "power"), p = c < 0 ? P + -c : "power" !== l ? "+" + c : String(c), "e" === l || "E" === l ? t1 += l + p : "power" === l ? t1 += "\xd710<sup>" + p + "</sup>" : "B" === l && 9 === c ? t1 += "B" : ut(l) && (t1 += ct[c / 3 + 5]));
                    return a ? P + t1 : t1;
                }
                function pt(t1, e1) {
                    for(var r = [], n = {}, i = 0; i < e1.length; i++){
                        var a = e1[i];
                        n[a.text2] ? n[a.text2].push(a.x) : n[a.text2] = [
                            a.x
                        ];
                    }
                    for(var o in n)r.push(lt(t1, s.interp(n[o], .5), o));
                    return r;
                }
                function dt(t1) {
                    return void 0 !== t1.periodX ? t1.periodX : t1.x;
                }
                function mt(t1) {
                    return [
                        t1.text,
                        t1.x,
                        t1.axInfo,
                        t1.font,
                        t1.fontSize,
                        t1.fontColor
                    ].join("_");
                }
                function gt(t1) {
                    var e1 = t1.title.font.size, r = (t1.title.text.match(c.BR_TAG_ALL) || []).length;
                    return t1.title.hasOwnProperty("standoff") ? r ? e1 * (N + r * j) : e1 * N : r ? e1 * (r + 1) * j : e1;
                }
                function vt(t1, e1) {
                    var r = t1.l2p(e1);
                    return r > 1 && r < t1._length - 1;
                }
                function yt(t1) {
                    var e1 = n.select(t1), r = e1.select(".text-math-group");
                    return r.empty() ? e1.select("text") : r;
                }
                function xt(t1) {
                    return t1._id + ".automargin";
                }
                function bt(t1) {
                    return xt(t1) + ".mirror";
                }
                function _t(t1) {
                    return t1._id + ".rangeslider";
                }
                function wt(t1, e1) {
                    for(var r = 0; r < e1.length; r++)-1 === t1.indexOf(e1[r]) && t1.push(e1[r]);
                }
                function Tt(t1, e1, r) {
                    var n, i, a = [], o = [], l = t1.layout;
                    for(n = 0; n < e1.length; n++)a.push(V.getFromId(t1, e1[n]));
                    for(n = 0; n < r.length; n++)o.push(V.getFromId(t1, r[n]));
                    var c = Object.keys(p), u = [
                        "anchor",
                        "domain",
                        "overlaying",
                        "position",
                        "side",
                        "tickangle",
                        "editType"
                    ], f = [
                        "linear",
                        "log"
                    ];
                    for(n = 0; n < c.length; n++){
                        var h = c[n], d = a[0][h], m = o[0][h], g = !0, v = !1, y = !1;
                        if ("_" !== h.charAt(0) && "function" != typeof d && -1 === u.indexOf(h)) {
                            for(i = 1; i < a.length && g; i++){
                                var x = a[i][h];
                                "type" === h && -1 !== f.indexOf(d) && -1 !== f.indexOf(x) && d !== x ? v = !0 : x !== d && (g = !1);
                            }
                            for(i = 1; i < o.length && g; i++){
                                var b = o[i][h];
                                "type" === h && -1 !== f.indexOf(m) && -1 !== f.indexOf(b) && m !== b ? y = !0 : o[i][h] !== m && (g = !1);
                            }
                            g && (v && (l[a[0]._name].type = "linear"), y && (l[o[0]._name].type = "linear"), kt(l, h, a, o, t1._fullLayout._dfltTitle));
                        }
                    }
                    for(n = 0; n < t1._fullLayout.annotations.length; n++){
                        var _ = t1._fullLayout.annotations[n];
                        -1 !== e1.indexOf(_.xref) && -1 !== r.indexOf(_.yref) && s.swapAttrs(l.annotations[n], [
                            "?"
                        ]);
                    }
                }
                function kt(t1, e1, r, n, i) {
                    var a, o = s.nestedProperty, l = o(t1[r[0]._name], e1).get(), c = o(t1[n[0]._name], e1).get();
                    for("title" === e1 && (l && l.text === i.x && (l.text = i.y), c && c.text === i.y && (c.text = i.x)), a = 0; a < r.length; a++)o(t1, r[a]._name + "." + e1).set(c);
                    for(a = 0; a < n.length; a++)o(t1, n[a]._name + "." + e1).set(l);
                }
                function At(t1) {
                    return "angularaxis" === t1._id;
                }
                function Mt(t1, e1) {
                    for(var r = e1._rangebreaks.length, n = 0; n < r; n++){
                        var i = e1._rangebreaks[n];
                        if (t1 >= i.min && t1 < i.max) return i.max;
                    }
                    return t1;
                }
                function St(t1) {
                    return -1 !== (t1.ticklabelposition || "").indexOf("inside");
                }
                function Et(t1, e1) {
                    St(t1._anchorAxis || {}) && t1._hideCounterAxisInsideTickLabels && t1._hideCounterAxisInsideTickLabels(e1);
                }
                V.getTickFormat = function(t1) {
                    var e1, r, n, i, a, o, s, l;
                    function c(t1) {
                        return "string" != typeof t1 ? t1 : Number(t1.replace("M", "")) * T;
                    }
                    function u(t1, e1) {
                        var r = [
                            "L",
                            "D"
                        ];
                        if (typeof t1 == typeof e1) {
                            if ("number" == typeof t1) return t1 - e1;
                            var n = r.indexOf(t1.charAt(0)), i = r.indexOf(e1.charAt(0));
                            return n === i ? Number(t1.replace(/(L|D)/g, "")) - Number(e1.replace(/(L|D)/g, "")) : n - i;
                        }
                        return "number" == typeof t1 ? 1 : -1;
                    }
                    function f(t1, e1) {
                        var r = null === e1[0], n = null === e1[1], i = u(t1, e1[0]) >= 0, a = u(t1, e1[1]) <= 0;
                        return (r || i) && (n || a);
                    }
                    if (t1.tickformatstops && t1.tickformatstops.length > 0) switch(t1.type){
                        case "date":
                        case "linear":
                            for(e1 = 0; e1 < t1.tickformatstops.length; e1++)if ((n = t1.tickformatstops[e1]).enabled && (i = t1.dtick, a = n.dtickrange, o = void 0, s = void 0, l = void 0, o = c || function(t1) {
                                return t1;
                            }, s = a[0], l = a[1], (!s && "number" != typeof s || o(s) <= o(i)) && (!l && "number" != typeof l || o(l) >= o(i)))) {
                                r = n;
                                break;
                            }
                            break;
                        case "log":
                            for(e1 = 0; e1 < t1.tickformatstops.length; e1++)if ((n = t1.tickformatstops[e1]).enabled && f(t1.dtick, n.dtickrange)) {
                                r = n;
                                break;
                            }
                    }
                    return r ? r.value : t1.tickformat;
                }, V.getSubplots = function(t1, e1) {
                    var r = t1._fullLayout._subplots, n = r.cartesian.concat(r.gl2d || []), i = e1 ? V.findSubplotsWithAxis(n, e1) : n;
                    return i.sort(function(t1, e1) {
                        var r = t1.substr(1).split("y"), n = e1.substr(1).split("y");
                        return r[0] === n[0] ? +r[1] - +n[1] : +r[0] - +n[0];
                    }), i;
                }, V.findSubplotsWithAxis = function(t1, e1) {
                    for(var r = new RegExp("x" === e1._id.charAt(0) ? "^" + e1._id + "y" : e1._id + "$"), n = [], i = 0; i < t1.length; i++){
                        var a = t1[i];
                        r.test(a) && n.push(a);
                    }
                    return n;
                }, V.makeClipPaths = function(t1) {
                    var e1 = t1._fullLayout;
                    if (!e1._hasOnlyLargeSploms) {
                        var r, i, a = {
                            _offset: 0,
                            _length: e1.width,
                            _id: ""
                        }, o = {
                            _offset: 0,
                            _length: e1.height,
                            _id: ""
                        }, s = V.list(t1, "x", !0), l = V.list(t1, "y", !0), c = [];
                        for(r = 0; r < s.length; r++)for(c.push({
                            x: s[r],
                            y: o
                        }), i = 0; i < l.length; i++)0 === r && c.push({
                            x: a,
                            y: l[i]
                        }), c.push({
                            x: s[r],
                            y: l[i]
                        });
                        var u = e1._clips.selectAll(".axesclip").data(c, function(t1) {
                            return t1.x._id + t1.y._id;
                        });
                        u.enter().append("clipPath").classed("axesclip", !0).attr("id", function(t1) {
                            return "clip" + e1._uid + t1.x._id + t1.y._id;
                        }).append("rect"), u.exit().remove(), u.each(function(t1) {
                            n.select(this).select("rect").attr({
                                x: t1.x._offset || 0,
                                y: t1.y._offset || 0,
                                width: t1.x._length || 1,
                                height: t1.y._length || 1
                            });
                        });
                    }
                }, V.draw = function(t1, e1, r) {
                    var n = t1._fullLayout;
                    "redraw" === e1 && n._paper.selectAll("g.subplot").each(function(t1) {
                        var e1 = t1[0], r = n._plots[e1];
                        if (r) {
                            var i = r.xaxis, a = r.yaxis;
                            r.xaxislayer.selectAll("." + i._id + "tick").remove(), r.yaxislayer.selectAll("." + a._id + "tick").remove(), r.xaxislayer.selectAll("." + i._id + "tick2").remove(), r.yaxislayer.selectAll("." + a._id + "tick2").remove(), r.xaxislayer.selectAll("." + i._id + "divider").remove(), r.yaxislayer.selectAll("." + a._id + "divider").remove(), r.gridlayer && r.gridlayer.selectAll("path").remove(), r.zerolinelayer && r.zerolinelayer.selectAll("path").remove(), n._infolayer.select(".g-" + i._id + "title").remove(), n._infolayer.select(".g-" + a._id + "title").remove();
                        }
                    });
                    var i = e1 && "redraw" !== e1 ? e1 : V.listIds(t1);
                    return s.syncOrAsync(i.map(function(e1) {
                        return function() {
                            if (e1) {
                                var n = V.getFromId(t1, e1), i = V.drawOne(t1, n, r);
                                return n._r = n.range.slice(), n._rl = s.simpleMap(n._r, n.r2l), i;
                            }
                        };
                    }));
                }, V.drawOne = function(t1, e1, r) {
                    var n, i, l;
                    r = r || {}, e1.setScale();
                    var c = t1._fullLayout, p = e1._id, d = p.charAt(0), m = V.counterLetter(p), g = c._plots[e1._mainSubplot];
                    if (g) {
                        var v = g[d + "axislayer"], y = e1._mainLinePosition, x = e1._mainMirrorPosition, b = e1._vals = V.calcTicks(e1), _ = [
                            e1.mirror,
                            y,
                            x
                        ].join("_");
                        for(n = 0; n < b.length; n++)b[n].axInfo = _;
                        e1._selections = {}, e1._tickAngles && (e1._prevTickAngles = e1._tickAngles), e1._tickAngles = {}, e1._depth = null;
                        var w = {};
                        if (e1.visible) {
                            var T, k, A = V.makeTransTickFn(e1), M = V.makeTransTickLabelFn(e1), S = "inside" === e1.ticks, E = "outside" === e1.ticks;
                            if ("boundaries" === e1.tickson) {
                                var L = function(t1, e1) {
                                    var r, n = [], i = function(t1, e1) {
                                        var r = t1.xbnd[e1];
                                        null !== r && n.push(s.extendFlat({}, t1, {
                                            x: r
                                        }));
                                    };
                                    if (e1.length) {
                                        for(r = 0; r < e1.length; r++)i(e1[r], 0);
                                        i(e1[r - 1], 1);
                                    }
                                    return n;
                                }(0, b);
                                k = V.clipEnds(e1, L), T = S ? k : L;
                            } else k = V.clipEnds(e1, b), T = S && "period" !== e1.ticklabelmode ? k : b;
                            var C = e1._gridVals = k, P = function(t1, e1) {
                                var r, n, i = [], a = e1.length && e1[e1.length - 1].x < e1[0].x, o = function(t1, e1) {
                                    var r = t1.xbnd[e1];
                                    null !== r && i.push(s.extendFlat({}, t1, {
                                        x: r
                                    }));
                                };
                                if (t1.showdividers && e1.length) {
                                    for(r = 0; r < e1.length; r++){
                                        var l = e1[r];
                                        l.text2 !== n && o(l, a ? 1 : 0), n = l.text2;
                                    }
                                    o(e1[r - 1], a ? 0 : 1);
                                }
                                return i;
                            }(e1, b);
                            if (!c._hasOnlyLargeSploms) {
                                var I = e1._subplotsWith, O = {};
                                for(n = 0; n < I.length; n++){
                                    i = I[n];
                                    var z = (l = c._plots[i])[m + "axis"], D = z._mainAxis._id;
                                    if (!O[D]) {
                                        O[D] = 1;
                                        var R = "x" === d ? "M0," + z._offset + "v" + z._length : "M" + z._offset + ",0h" + z._length;
                                        V.drawGrid(t1, e1, {
                                            vals: C,
                                            counterAxis: z,
                                            layer: l.gridlayer.select("." + p),
                                            path: R,
                                            transFn: A
                                        }), V.drawZeroLine(t1, e1, {
                                            counterAxis: z,
                                            layer: l.zerolinelayer,
                                            path: R,
                                            transFn: A
                                        });
                                    }
                                }
                            }
                            var F = V.getTickSigns(e1), B = [];
                            if (e1.ticks) {
                                var N, H, q, G = V.makeTickPath(e1, y, F[2]);
                                if (e1._anchorAxis && e1.mirror && !0 !== e1.mirror ? (N = V.makeTickPath(e1, x, F[3]), H = G + N) : (N = "", H = G), e1.showdividers && E && "boundaries" === e1.tickson) {
                                    var Y = {};
                                    for(n = 0; n < P.length; n++)Y[P[n].x] = 1;
                                    q = function(t1) {
                                        return Y[t1.x] ? N : H;
                                    };
                                } else q = H;
                                V.drawTicks(t1, e1, {
                                    vals: T,
                                    layer: v,
                                    path: q,
                                    transFn: A
                                }), "allticks" === e1.mirror && (B = Object.keys(e1._linepositions || {}));
                            }
                            for(n = 0; n < B.length; n++){
                                i = B[n], l = c._plots[i];
                                var W = e1._linepositions[i] || [], X = V.makeTickPath(e1, W[0], F[0]) + V.makeTickPath(e1, W[1], F[1]);
                                V.drawTicks(t1, e1, {
                                    vals: T,
                                    layer: l[d + "axislayer"],
                                    path: X,
                                    transFn: A
                                });
                            }
                            var Z = [];
                            if (Z.push(function() {
                                return V.drawLabels(t1, e1, {
                                    vals: b,
                                    layer: v,
                                    plotinfo: l,
                                    transFn: M,
                                    labelFns: V.makeLabelFns(e1, y)
                                });
                            }), "multicategory" === e1.type) {
                                var J = {
                                    x: 2,
                                    y: 10
                                }[d];
                                Z.push(function() {
                                    var r = {
                                        x: "height",
                                        y: "width"
                                    }[d], n = Q()[r] + J + (e1._tickAngles[p + "tick"] ? e1.tickfont.size * j : 0);
                                    return V.drawLabels(t1, e1, {
                                        vals: pt(e1, b),
                                        layer: v,
                                        cls: p + "tick2",
                                        repositionOnUpdate: !0,
                                        secondary: !0,
                                        transFn: A,
                                        labelFns: V.makeLabelFns(e1, y + n * F[4])
                                    });
                                }), Z.push(function() {
                                    return e1._depth = F[4] * (Q("tick2")[e1.side] - y), function(t1, e1, r) {
                                        var n = e1._id + "divider", i = r.vals, a = r.layer.selectAll("path." + n).data(i, mt);
                                        a.exit().remove(), a.enter().insert("path", ":first-child").classed(n, 1).classed("crisp", 1).call(f.stroke, e1.dividercolor).style("stroke-width", h.crispRound(t1, e1.dividerwidth, 1) + "px"), a.attr("transform", r.transFn).attr("d", r.path);
                                    }(t1, e1, {
                                        vals: P,
                                        layer: v,
                                        path: V.makeTickPath(e1, y, F[4], e1._depth),
                                        transFn: A
                                    });
                                });
                            } else e1.title.hasOwnProperty("standoff") && Z.push(function() {
                                e1._depth = F[4] * (Q()[e1.side] - y);
                            });
                            var K = o.getComponentMethod("rangeslider", "isVisible")(e1);
                            return Z.push(function() {
                                var r, n, i, s, l = e1.side.charAt(0), u = U[e1.side].charAt(0), f = V.getPxPosition(t1, e1), h = E ? e1.ticklen : 0;
                                if ((e1.automargin || K) && ("multicategory" === e1.type ? r = Q("tick2") : (r = Q(), "x" === d && "b" === l && (e1._depth = Math.max(r.width > 0 ? r.bottom - f : 0, h)))), e1.automargin) {
                                    n = {
                                        x: 0,
                                        y: 0,
                                        r: 0,
                                        l: 0,
                                        t: 0,
                                        b: 0
                                    };
                                    var p = [
                                        0,
                                        1
                                    ];
                                    if ("x" === d) {
                                        if ("b" === l ? n[l] = e1._depth : (n[l] = e1._depth = Math.max(r.width > 0 ? f - r.top : 0, h), p.reverse()), r.width > 0) {
                                            var g = r.right - (e1._offset + e1._length);
                                            g > 0 && (n.xr = 1, n.r = g);
                                            var v = e1._offset - r.left;
                                            v > 0 && (n.xl = 0, n.l = v);
                                        }
                                    } else if ("l" === l ? n[l] = e1._depth = Math.max(r.height > 0 ? f - r.left : 0, h) : (n[l] = e1._depth = Math.max(r.height > 0 ? r.right - f : 0, h), p.reverse()), r.height > 0) {
                                        var y = r.bottom - (e1._offset + e1._length);
                                        y > 0 && (n.yb = 0, n.b = y);
                                        var x = e1._offset - r.top;
                                        x > 0 && (n.yt = 1, n.t = x);
                                    }
                                    n[m] = "free" === e1.anchor ? e1.position : e1._anchorAxis.domain[p[0]], e1.title.text !== c._dfltTitle[d] && (n[l] += gt(e1) + (e1.title.standoff || 0)), e1.mirror && "free" !== e1.anchor && ((i = {
                                        x: 0,
                                        y: 0,
                                        r: 0,
                                        l: 0,
                                        t: 0,
                                        b: 0
                                    })[u] = e1.linewidth, e1.mirror && !0 !== e1.mirror && (i[u] += h), !0 === e1.mirror || "ticks" === e1.mirror ? i[m] = e1._anchorAxis.domain[p[1]] : "all" !== e1.mirror && "allticks" !== e1.mirror || (i[m] = [
                                        e1._counterDomainMin,
                                        e1._counterDomainMax
                                    ][p[1]]));
                                }
                                K && (s = o.getComponentMethod("rangeslider", "autoMarginOpts")(t1, e1)), a.autoMargin(t1, xt(e1), n), a.autoMargin(t1, bt(e1), i), a.autoMargin(t1, _t(e1), s);
                            }), r.skipTitle || K && "bottom" === e1.side || Z.push(function() {
                                return function(t1, e1) {
                                    var r, n = t1._fullLayout, i = e1._id, a = i.charAt(0), o = e1.title.font.size;
                                    if (e1.title.hasOwnProperty("standoff")) r = e1._depth + e1.title.standoff + gt(e1);
                                    else {
                                        var s = St(e1);
                                        if ("multicategory" === e1.type) r = e1._depth;
                                        else {
                                            var l = 1.5 * o;
                                            s && (l = .5 * o, "outside" === e1.ticks && (l += e1.ticklen)), r = 10 + l + (e1.linewidth ? e1.linewidth - 1 : 0);
                                        }
                                        s || (r += "x" === a ? "top" === e1.side ? o * (e1.showticklabels ? 1 : 0) : o * (e1.showticklabels ? 1.5 : .5) : "right" === e1.side ? o * (e1.showticklabels ? 1 : .5) : o * (e1.showticklabels ? .5 : 0));
                                    }
                                    var c, f, p, d, m = V.getPxPosition(t1, e1);
                                    "x" === a ? (f = e1._offset + e1._length / 2, p = "top" === e1.side ? m - r : m + r) : (p = e1._offset + e1._length / 2, f = "right" === e1.side ? m + r : m - r, c = {
                                        rotate: "-90",
                                        offset: 0
                                    });
                                    if ("multicategory" !== e1.type) {
                                        var g = e1._selections[e1._id + "tick"];
                                        if (d = {
                                            selection: g,
                                            side: e1.side
                                        }, g && g.node() && g.node().parentNode) {
                                            var v = h.getTranslate(g.node().parentNode);
                                            d.offsetLeft = v.x, d.offsetTop = v.y;
                                        }
                                        e1.title.hasOwnProperty("standoff") && (d.pad = 0);
                                    }
                                    return u.draw(t1, i + "title", {
                                        propContainer: e1,
                                        propName: e1._name + ".title.text",
                                        placeholder: n._dfltTitle[a],
                                        avoid: d,
                                        transform: c,
                                        attributes: {
                                            x: f,
                                            y: p,
                                            "text-anchor": "middle"
                                        }
                                    });
                                }(t1, e1);
                            }), s.syncOrAsync(Z);
                        }
                    }
                    function Q(t1) {
                        var r = p + (t1 || "tick");
                        return w[r] || (w[r] = function(t1, e1) {
                            var r, n, i, a;
                            t1._selections[e1].size() ? (r = 1 / 0, n = -1 / 0, i = 1 / 0, a = -1 / 0, t1._selections[e1].each(function() {
                                var t1 = yt(this), e1 = h.bBox(t1.node().parentNode);
                                r = Math.min(r, e1.top), n = Math.max(n, e1.bottom), i = Math.min(i, e1.left), a = Math.max(a, e1.right);
                            })) : (r = 0, n = 0, i = 0, a = 0);
                            return {
                                top: r,
                                bottom: n,
                                left: i,
                                right: a,
                                height: n - r,
                                width: a - i
                            };
                        }(e1, r)), w[r];
                    }
                }, V.getTickSigns = function(t1) {
                    var e1 = t1._id.charAt(0), r = {
                        x: "top",
                        y: "right"
                    }[e1], n = t1.side === r ? 1 : -1, i = [
                        -1,
                        1,
                        n,
                        -n
                    ];
                    return "inside" !== t1.ticks == ("x" === e1) && (i = i.map(function(t1) {
                        return -t1;
                    })), t1.side && i.push({
                        l: -1,
                        t: -1,
                        r: 1,
                        b: 1
                    }[t1.side.charAt(0)]), i;
                }, V.makeTransTickFn = function(t1) {
                    return "x" === t1._id.charAt(0) ? function(e1) {
                        return l(t1._offset + t1.l2p(e1.x), 0);
                    } : function(e1) {
                        return l(0, t1._offset + t1.l2p(e1.x));
                    };
                }, V.makeTransTickLabelFn = function(t1) {
                    var e1 = function(t1) {
                        var e1 = t1.ticklabelposition || "", r = function(t1) {
                            return -1 !== e1.indexOf(t1);
                        }, n = r("top"), i = r("left"), a = r("right"), o = r("bottom"), s = r("inside"), l = o || i || n || a;
                        if (!l && !s) return [
                            0,
                            0
                        ];
                        var c = t1.side, u = l ? (t1.tickwidth || 0) / 2 : 0, f = 3, h = t1.tickfont ? t1.tickfont.size : 12;
                        (o || n) && (u += h * N, f += (t1.linewidth || 0) / 2);
                        (i || a) && (u += (t1.linewidth || 0) / 2, f += 3);
                        s && "top" === c && (f -= h * (1 - N));
                        (i || n) && (u = -u);
                        "bottom" !== c && "right" !== c || (f = -f);
                        return [
                            l ? u : 0,
                            s ? f : 0
                        ];
                    }(t1), r = e1[0], n = e1[1];
                    return "x" === t1._id.charAt(0) ? function(e1) {
                        return l(r + t1._offset + t1.l2p(dt(e1)), n);
                    } : function(e1) {
                        return l(n, r + t1._offset + t1.l2p(dt(e1)));
                    };
                }, V.makeTickPath = function(t1, e1, r, n) {
                    n = void 0 !== n ? n : t1.ticklen;
                    var i = t1._id.charAt(0), a = (t1.linewidth || 1) / 2;
                    return "x" === i ? "M0," + (e1 + a * r) + "v" + n * r : "M" + (e1 + a * r) + ",0h" + n * r;
                }, V.makeLabelFns = function(t1, e1, r) {
                    var n = t1.ticklabelposition || "", a = function(t1) {
                        return -1 !== n.indexOf(t1);
                    }, o = a("top"), l = a("left"), c = a("right"), u = a("bottom") || l || o || c, f = a("inside"), h = "inside" === n && "inside" === t1.ticks || !f && "outside" === t1.ticks && "boundaries" !== t1.tickson, p = 0, d = 0, m = h ? t1.ticklen : 0;
                    if (f ? m *= -1 : u && (m = 0), h && (p += m, r)) {
                        var g = s.deg2rad(r);
                        p = m * Math.cos(g) + 1, d = m * Math.sin(g);
                    }
                    t1.showticklabels && (h || t1.showline) && (p += .2 * t1.tickfont.size);
                    var v, y, x, b, _, w = {
                        labelStandoff: p += (t1.linewidth || 1) / 2 * (f ? -1 : 1),
                        labelShift: d
                    }, T = 0, k = t1.side, A = t1._id.charAt(0), M = t1.tickangle;
                    if ("x" === A) b = (_ = !f && "bottom" === k || f && "top" === k) ? 1 : -1, f && (b *= -1), v = d * b, y = e1 + p * b, x = _ ? 1 : -0.2, 90 === Math.abs(M) && (f ? x += B : x = -90 === M && "bottom" === k ? N : 90 === M && "top" === k ? B : .5, T = B / 2 * (M / 90)), w.xFn = function(t1) {
                        return t1.dx + v + T * t1.fontSize;
                    }, w.yFn = function(t1) {
                        return t1.dy + y + t1.fontSize * x;
                    }, w.anchorFn = function(t1, e1) {
                        if (u) {
                            if (l) return "end";
                            if (c) return "start";
                        }
                        return i(e1) && 0 !== e1 && 180 !== e1 ? e1 * b < 0 !== f ? "end" : "start" : "middle";
                    }, w.heightFn = function(e1, r, n) {
                        return r < -60 || r > 60 ? -0.5 * n : "top" === t1.side !== f ? -n : 0;
                    };
                    else if ("y" === A) {
                        if (b = (_ = !f && "left" === k || f && "right" === k) ? 1 : -1, f && (b *= -1), v = p, y = d * b, x = 0, f || 90 !== Math.abs(M) || (x = -90 === M && "left" === k || 90 === M && "right" === k ? N : .5), f) {
                            var S = i(M) ? +M : 0;
                            if (0 !== S) {
                                var E = s.deg2rad(S);
                                T = Math.abs(Math.sin(E)) * N * b, x = 0;
                            }
                        }
                        w.xFn = function(t1) {
                            return t1.dx + e1 - (v + t1.fontSize * x) * b + T * t1.fontSize;
                        }, w.yFn = function(t1) {
                            return t1.dy + y + t1.fontSize * B;
                        }, w.anchorFn = function(t1, e1) {
                            return i(e1) && 90 === Math.abs(e1) ? "middle" : _ ? "end" : "start";
                        }, w.heightFn = function(e1, r, n) {
                            return "right" === t1.side && (r *= -1), r < -30 ? -n : r < 30 ? -0.5 * n : 0;
                        };
                    }
                    return w;
                }, V.drawTicks = function(t1, e1, r) {
                    r = r || {};
                    var n = e1._id + "tick", i = r.vals;
                    "period" === e1.ticklabelmode && (i = i.slice()).shift();
                    var a = r.layer.selectAll("path." + n).data(e1.ticks ? i : [], mt);
                    a.exit().remove(), a.enter().append("path").classed(n, 1).classed("ticks", 1).classed("crisp", !1 !== r.crisp).call(f.stroke, e1.tickcolor).style("stroke-width", h.crispRound(t1, e1.tickwidth, 1) + "px").attr("d", r.path).style("display", null), Et(e1, [
                        D
                    ]), a.attr("transform", r.transFn);
                }, V.drawGrid = function(t1, e1, r) {
                    r = r || {};
                    var n = e1._id + "grid", i = r.vals, a = r.counterAxis;
                    if (!1 === e1.showgrid) i = [];
                    else if (a && V.shouldShowZeroLine(t1, e1, a)) for(var o = "array" === e1.tickmode, s = 0; s < i.length; s++){
                        var l = i[s].x;
                        if (o ? !l : Math.abs(l) < e1.dtick / 100) {
                            if (i = i.slice(0, s).concat(i.slice(s + 1)), !o) break;
                            s--;
                        }
                    }
                    var c = r.layer.selectAll("path." + n).data(i, mt);
                    c.exit().remove(), c.enter().append("path").classed(n, 1).classed("crisp", !1 !== r.crisp), e1._gw = h.crispRound(t1, e1.gridwidth, 1), c.attr("transform", r.transFn).attr("d", r.path).call(f.stroke, e1.gridcolor || "#ddd").style("stroke-width", e1._gw + "px").style("display", null), Et(e1, [
                        z
                    ]), "function" == typeof r.path && c.attr("d", r.path);
                }, V.drawZeroLine = function(t1, e1, r) {
                    r = r || r;
                    var n = e1._id + "zl", i = V.shouldShowZeroLine(t1, e1, r.counterAxis), a = r.layer.selectAll("path." + n).data(i ? [
                        {
                            x: 0,
                            id: e1._id
                        }
                    ] : []);
                    a.exit().remove(), a.enter().append("path").classed(n, 1).classed("zl", 1).classed("crisp", !1 !== r.crisp).each(function() {
                        r.layer.selectAll("path").sort(function(t1, e1) {
                            return G(t1.id, e1.id);
                        });
                    }), a.attr("transform", r.transFn).attr("d", r.path).call(f.stroke, e1.zerolinecolor || f.defaultLine).style("stroke-width", h.crispRound(t1, e1.zerolinewidth, e1._gw || 1) + "px").style("display", null), Et(e1, [
                        O
                    ]);
                }, V.drawLabels = function(t1, e1, r) {
                    r = r || {};
                    var a = t1._fullLayout, o = e1._id, u = o.charAt(0), f = r.cls || o + "tick", p = r.vals, d = r.labelFns, m = r.secondary ? 0 : e1.tickangle, g = (e1._prevTickAngles || {})[f], v = r.layer.selectAll("g." + f).data(e1.showticklabels ? p : [], mt), y = [];
                    function x(t1, a) {
                        t1.each(function(t1) {
                            var o = n.select(this), s = o.select(".text-math-group"), u = d.anchorFn(t1, a), f = r.transFn.call(o.node(), t1) + (i(a) && 0 != +a ? " rotate(" + a + "," + d.xFn(t1) + "," + (d.yFn(t1) - t1.fontSize / 2) + ")" : ""), p = c.lineCount(o), m = j * t1.fontSize, g = d.heightFn(t1, i(a) ? +a : 0, (p - 1) * m);
                            if (g && (f += l(0, g)), s.empty()) {
                                var v = o.select("text");
                                v.attr({
                                    transform: f,
                                    "text-anchor": u
                                }), v.style("opacity", 1), e1._adjustTickLabelsOverflow && e1._adjustTickLabelsOverflow();
                            } else {
                                var y = h.bBox(s.node()).width * ({
                                    end: -0.5,
                                    start: .5
                                })[u];
                                s.attr("transform", f + l(y, 0));
                            }
                        });
                    }
                    v.enter().append("g").classed(f, 1).append("text").attr("text-anchor", "middle").each(function(e1) {
                        var r = n.select(this), i = t1._promises.length;
                        r.call(c.positionText, d.xFn(e1), d.yFn(e1)).call(h.font, e1.font, e1.fontSize, e1.fontColor).text(e1.text).call(c.convertToTspans, t1), t1._promises[i] ? y.push(t1._promises.pop().then(function() {
                            x(r, m);
                        })) : x(r, m);
                    }), Et(e1, [
                        R
                    ]), v.exit().remove(), r.repositionOnUpdate && v.each(function(t1) {
                        n.select(this).select("text").call(c.positionText, d.xFn(t1), d.yFn(t1));
                    }), e1._adjustTickLabelsOverflow = function() {
                        var r = e1.ticklabeloverflow;
                        if (r && "allow" !== r) {
                            var i = -1 !== r.indexOf("hide"), o = "x" === e1._id.charAt(0), l = 0, c = o ? t1._fullLayout.width : t1._fullLayout.height;
                            if (-1 !== r.indexOf("domain")) {
                                var u = s.simpleMap(e1.range, e1.r2l);
                                l = e1.l2p(u[0]) + e1._offset, c = e1.l2p(u[1]) + e1._offset;
                            }
                            var f = Math.min(l, c), p = Math.max(l, c), d = e1.side, m = 1 / 0, g = -1 / 0;
                            for(var y in v.each(function(t1) {
                                var r = n.select(this);
                                if (r.select(".text-math-group").empty()) {
                                    var a = h.bBox(r.node()), s = 0;
                                    o ? (a.right > p || a.left < f) && (s = 1) : (a.bottom > p || a.top + (e1.tickangle ? 0 : t1.fontSize / 4) < f) && (s = 1);
                                    var l = r.select("text");
                                    s ? i && l.style("opacity", 0) : (l.style("opacity", 1), m = "bottom" === d || "right" === d ? Math.min(m, o ? a.top : a.left) : -1 / 0, g = "top" === d || "left" === d ? Math.max(g, o ? a.bottom : a.right) : 1 / 0);
                                }
                            }), a._plots){
                                var x = a._plots[y];
                                if (e1._id === x.xaxis._id || e1._id === x.yaxis._id) {
                                    var b = o ? x.yaxis : x.xaxis;
                                    b && (b["_visibleLabelMin_" + e1._id] = m, b["_visibleLabelMax_" + e1._id] = g);
                                }
                            }
                        }
                    }, e1._hideCounterAxisInsideTickLabels = function(t1) {
                        var r = "x" === e1._id.charAt(0), i = [];
                        for(var o in a._plots){
                            var s = a._plots[o];
                            e1._id !== s.xaxis._id && e1._id !== s.yaxis._id || i.push(r ? s.yaxis : s.xaxis);
                        }
                        i.forEach(function(r, i) {
                            r && St(r) && (t1 || [
                                O,
                                z,
                                D,
                                R
                            ]).forEach(function(t1) {
                                var o = "tick" === t1.K && "text" === t1.L && "period" === e1.ticklabelmode, s = a._plots[e1._mainSubplot];
                                (t1.K === O.K ? s.zerolinelayer.selectAll("." + e1._id + "zl") : t1.K === z.K ? s.gridlayer.selectAll("." + e1._id) : s[e1._id.charAt(0) + "axislayer"]).each(function() {
                                    var a = n.select(this);
                                    t1.L && (a = a.selectAll(t1.L)), a.each(function(a) {
                                        var s = e1.l2p(o ? dt(a) : a.x) + e1._offset, l = n.select(this);
                                        s < e1["_visibleLabelMax_" + r._id] && s > e1["_visibleLabelMin_" + r._id] ? l.style("display", "none") : "tick" !== t1.K || i || l.style("display", null);
                                    });
                                });
                            });
                        });
                    }, x(v, g + 1 ? g : m);
                    var b = null;
                    e1._selections && (e1._selections[f] = v);
                    var _ = [
                        function() {
                            return y.length && Promise.all(y);
                        }
                    ];
                    e1.automargin && a._redrawFromAutoMarginCount && 90 === g ? (b = 90, _.push(function() {
                        x(v, g);
                    })) : _.push(function() {
                        if (x(v, m), p.length && "x" === u && !i(m) && ("log" !== e1.type || "D" !== String(e1.dtick).charAt(0))) {
                            b = 0;
                            var t1, n = 0, a = [];
                            if (v.each(function(t1) {
                                n = Math.max(n, t1.fontSize);
                                var r = e1.l2p(t1.x), i = yt(this), o = h.bBox(i.node());
                                a.push({
                                    top: 0,
                                    bottom: 10,
                                    height: 10,
                                    left: r - o.width / 2,
                                    right: r + o.width / 2 + 2,
                                    width: o.width + 2
                                });
                            }), "boundaries" !== e1.tickson && !e1.showdividers || r.secondary) {
                                var o = p.length, l = Math.abs((p[o - 1].x - p[0].x) * e1._m) / (o - 1), c = e1.ticklabelposition || "", f = function(t1) {
                                    return -1 !== c.indexOf(t1);
                                }, d = f("top"), g = f("left"), y = f("right"), _ = f("bottom") || g || d || y ? (e1.tickwidth || 0) + 6 : 0, w = l < 2.5 * n || "multicategory" === e1.type || "realaxis" === e1._name;
                                for(t1 = 0; t1 < a.length - 1; t1++)if (s.bBoxIntersect(a[t1], a[t1 + 1], _)) {
                                    b = w ? 90 : 30;
                                    break;
                                }
                            } else {
                                var T = 2;
                                for(e1.ticks && (T += e1.tickwidth / 2), t1 = 0; t1 < a.length; t1++){
                                    var k = p[t1].xbnd, A = a[t1];
                                    if (null !== k[0] && A.left - e1.l2p(k[0]) < T || null !== k[1] && e1.l2p(k[1]) - A.right < T) {
                                        b = 90;
                                        break;
                                    }
                                }
                            }
                            b && x(v, b);
                        }
                    }), e1._tickAngles && _.push(function() {
                        e1._tickAngles[f] = null === b ? i(m) ? m : 0 : b;
                    });
                    var w = e1._anchorAxis;
                    w && w.autorange && St(e1) && !Y(a, e1._id) && (a._insideTickLabelsAutorange || (a._insideTickLabelsAutorange = {}), a._insideTickLabelsAutorange[w._name + ".autorange"] = w.autorange, _.push(function() {
                        v.each(function(t1, r) {
                            var n = yt(this);
                            n.select(".text-math-group").empty() && (e1._vals[r].bb = h.bBox(n.node()));
                        });
                    }));
                    var T = s.syncOrAsync(_);
                    return T && T.then && t1._promises.push(T), T;
                }, V.getPxPosition = function(t1, e1) {
                    var r, n = t1._fullLayout._size, i = e1._id.charAt(0), a = e1.side;
                    return "free" !== e1.anchor ? r = e1._anchorAxis : "x" === i ? r = {
                        _offset: n.t + (1 - (e1.position || 0)) * n.h,
                        _length: 0
                    } : "y" === i && (r = {
                        _offset: n.l + (e1.position || 0) * n.w,
                        _length: 0
                    }), "top" === a || "left" === a ? r._offset : "bottom" === a || "right" === a ? r._offset + r._length : void 0;
                }, V.shouldShowZeroLine = function(t1, e1, r) {
                    var n = s.simpleMap(e1.range, e1.r2l);
                    return n[0] * n[1] <= 0 && e1.zeroline && ("linear" === e1.type || "-" === e1.type) && !(e1.rangebreaks && e1.maskBreaks(0) === I) && (vt(e1, 0) || !function(t1, e1, r, n) {
                        var i = r._mainAxis;
                        if (!i) return;
                        var a = t1._fullLayout, o = e1._id.charAt(0), s = V.counterLetter(e1._id), l = e1._offset + (Math.abs(n[0]) < Math.abs(n[1]) == ("x" === o) ? 0 : e1._length);
                        function c(t1) {
                            if (!t1.showline || !t1.linewidth) return !1;
                            var r = Math.max((t1.linewidth + e1.zerolinewidth) / 2, 1);
                            function n(t1) {
                                return "number" == typeof t1 && Math.abs(t1 - l) < r;
                            }
                            if (n(t1._mainLinePosition) || n(t1._mainMirrorPosition)) return !0;
                            var i = t1._linepositions || {};
                            for(var a in i)if (n(i[a][0]) || n(i[a][1])) return !0;
                        }
                        var u = a._plots[r._mainSubplot];
                        if (!(u.mainplotinfo || u).overlays.length) return c(r);
                        for(var f = V.list(t1, s), h = 0; h < f.length; h++){
                            var p = f[h];
                            if (p._mainAxis === i && c(p)) return !0;
                        }
                    }(t1, e1, r, n) || function(t1, e1) {
                        for(var r = t1._fullData, n = e1._mainSubplot, i = e1._id.charAt(0), a = 0; a < r.length; a++){
                            var s = r[a];
                            if (!0 === s.visible && s.xaxis + s.yaxis === n) {
                                if (o.traceIs(s, "bar-like") && s.orientation === ({
                                    x: "h",
                                    y: "v"
                                })[i]) return !0;
                                if (s.fill && s.fill.charAt(s.fill.length - 1) === i) return !0;
                            }
                        }
                        return !1;
                    }(t1, e1));
                }, V.clipEnds = function(t1, e1) {
                    return e1.filter(function(e1) {
                        return vt(t1, e1.x);
                    });
                }, V.allowAutoMargin = function(t1) {
                    for(var e1 = V.list(t1, "", !0), r = 0; r < e1.length; r++){
                        var n = e1[r];
                        n.automargin && (a.allowAutoMargin(t1, xt(n)), n.mirror && a.allowAutoMargin(t1, bt(n))), o.getComponentMethod("rangeslider", "isVisible")(n) && a.allowAutoMargin(t1, _t(n));
                    }
                }, V.swap = function(t1, e1) {
                    for(var r = function(t1, e1) {
                        var r, n, i = [];
                        for(r = 0; r < e1.length; r++){
                            var a = [], o = t1._fullData[e1[r]].xaxis, s = t1._fullData[e1[r]].yaxis;
                            if (o && s) {
                                for(n = 0; n < i.length; n++)-1 === i[n].x.indexOf(o) && -1 === i[n].y.indexOf(s) || a.push(n);
                                if (a.length) {
                                    var l, c = i[a[0]];
                                    if (a.length > 1) for(n = 1; n < a.length; n++)l = i[a[n]], wt(c.x, l.x), wt(c.y, l.y);
                                    wt(c.x, [
                                        o
                                    ]), wt(c.y, [
                                        s
                                    ]);
                                } else i.push({
                                    x: [
                                        o
                                    ],
                                    y: [
                                        s
                                    ]
                                });
                            }
                        }
                        return i;
                    }(t1, e1), n = 0; n < r.length; n++)Tt(t1, r[n].x, r[n].y);
                };
            },
            {
                "../../components/color": 366,
                "../../components/drawing": 388,
                "../../components/titles": 464,
                "../../constants/alignment": 471,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../plots/plots": 619,
                "../../registry": 638,
                "./autorange": 553,
                "./axis_autotype": 555,
                "./axis_ids": 558,
                "./clean_ticks": 560,
                "./layout_attributes": 569,
                "./set_convert": 576,
                "@plotly/d3": 58,
                "fast-isnumeric": 190
            }
        ],
        555: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = t1("../../constants/numerical").BADNUM, o = i.isArrayOrTypedArray, s = i.isDateTime, l = i.cleanNumber, c = Math.round;
                function u(t1, e1) {
                    return e1 ? n(t1) : "number" == typeof t1;
                }
                function f(t1) {
                    return Math.max(1, (t1 - 1) / 1e3);
                }
                e1.exports = function(t1, e1, r) {
                    var i = t1, h = r.noMultiCategory;
                    if (o(i) && !i.length) return "-";
                    if (!h && function(t1) {
                        return o(t1[0]) && o(t1[1]);
                    }(i)) return "multicategory";
                    if (h && Array.isArray(i[0])) {
                        for(var p = [], d = 0; d < i.length; d++)if (o(i[d])) for(var m = 0; m < i[d].length; m++)p.push(i[d][m]);
                        i = p;
                    }
                    if (function(t1, e1) {
                        for(var r = t1.length, i = f(r), a = 0, o = 0, l = {}, u = 0; u < r; u += i){
                            var h = c(u), p = t1[h], d = String(p);
                            l[d] || (l[d] = 1, s(p, e1) && a++, n(p) && o++);
                        }
                        return a > 2 * o;
                    }(i, e1)) return "date";
                    var g = "strict" !== r.autotypenumbers;
                    return function(t1, e1) {
                        for(var r = t1.length, n = f(r), i = 0, o = 0, s = {}, u = 0; u < r; u += n){
                            var h = c(u), p = t1[h], d = String(p);
                            if (!s[d]) {
                                s[d] = 1;
                                var m = typeof p;
                                "boolean" === m ? o++ : (e1 ? l(p) !== a : "number" === m) ? i++ : "string" === m && o++;
                            }
                        }
                        return o > 2 * i;
                    }(i, g) ? "category" : function(t1, e1) {
                        for(var r = t1.length, n = 0; n < r; n++)if (u(t1[n], e1)) return !0;
                        return !1;
                    }(i, g) ? "linear" : "-";
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "fast-isnumeric": 190
            }
        ],
        556: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../registry"), a = t1("../../lib"), o = t1("../array_container_defaults"), s = t1("./layout_attributes"), l = t1("./tick_value_defaults"), c = t1("./tick_mark_defaults"), u = t1("./tick_label_defaults"), f = t1("./prefix_suffix_defaults"), h = t1("./category_order_defaults"), p = t1("./line_grid_defaults"), d = t1("./set_convert"), m = t1("./constants").WEEKDAY_PATTERN, g = t1("./constants").HOUR_PATTERN;
                function v(t1, e1, r) {
                    function i(r, n) {
                        return a.coerce(t1, e1, s.rangebreaks, r, n);
                    }
                    if (i("enabled")) {
                        var o = i("bounds");
                        if (o && o.length >= 2) {
                            var l, c, u = "";
                            if (2 === o.length) {
                                for(l = 0; l < 2; l++)if (c = x(o[l])) {
                                    u = m;
                                    break;
                                }
                            }
                            var f = i("pattern", u);
                            if (f === m) for(l = 0; l < 2; l++)(c = x(o[l])) && (e1.bounds[l] = o[l] = c - 1);
                            if (f) for(l = 0; l < 2; l++)switch(c = o[l], f){
                                case m:
                                    if (!n(c)) return void (e1.enabled = !1);
                                    if ((c = +c) !== Math.floor(c) || c < 0 || c >= 7) return void (e1.enabled = !1);
                                    e1.bounds[l] = o[l] = c;
                                    break;
                                case g:
                                    if (!n(c)) return void (e1.enabled = !1);
                                    if ((c = +c) < 0 || c > 24) return void (e1.enabled = !1);
                                    e1.bounds[l] = o[l] = c;
                            }
                            if (!1 === r.autorange) {
                                var h = r.range;
                                if (h[0] < h[1]) {
                                    if (o[0] < h[0] && o[1] > h[1]) return void (e1.enabled = !1);
                                } else if (o[0] > h[0] && o[1] < h[1]) return void (e1.enabled = !1);
                            }
                        } else {
                            var p = i("values");
                            if (!p || !p.length) return void (e1.enabled = !1);
                            i("dvalue");
                        }
                    }
                }
                e1.exports = function(t1, e1, r, n, g) {
                    var y, x = n.letter, b = n.font || {}, _ = n.splomStash || {}, w = r("visible", !n.visibleDflt), T = e1._template || {}, k = e1.type || T.type || "-";
                    "date" === k && (i.getComponentMethod("calendars", "handleDefaults")(t1, e1, "calendar", n.calendar), n.noTicklabelmode || (y = r("ticklabelmode")));
                    var A = "";
                    n.noTicklabelposition && "multicategory" !== k || (A = a.coerce(t1, e1, {
                        ticklabelposition: {
                            valType: "enumerated",
                            dflt: "outside",
                            values: "period" === y ? [
                                "outside",
                                "inside"
                            ] : "x" === x ? [
                                "outside",
                                "inside",
                                "outside left",
                                "inside left",
                                "outside right",
                                "inside right"
                            ] : [
                                "outside",
                                "inside",
                                "outside top",
                                "inside top",
                                "outside bottom",
                                "inside bottom"
                            ]
                        }
                    }, "ticklabelposition")), n.noTicklabeloverflow || r("ticklabeloverflow", -1 !== A.indexOf("inside") ? "hide past domain" : "category" === k || "multicategory" === k ? "allow" : "hide past div"), d(e1, g);
                    var M = !e1.isValidRange(t1.range);
                    M && n.reverseDflt && (M = "reversed"), !r("autorange", M) || "linear" !== k && "-" !== k || r("rangemode"), r("range"), e1.cleanRange(), h(t1, e1, r, n), "category" === k || n.noHover || r("hoverformat");
                    var S = r("color"), E = S !== s.color.dflt ? S : b.color, L = _.label || g._dfltTitle[x];
                    if (f(t1, e1, r, k, n), !w) return e1;
                    r("title.text", L), a.coerceFont(r, "title.font", {
                        family: b.family,
                        size: a.bigFont(b.size),
                        color: E
                    }), l(t1, e1, r, k), u(t1, e1, r, k, n), c(t1, e1, r, n), p(t1, e1, r, {
                        dfltColor: S,
                        bgColor: n.bgColor,
                        showGrid: n.showGrid,
                        attributes: s
                    }), (e1.showline || e1.ticks) && r("mirror"), n.automargin && r("automargin");
                    var C, P = "multicategory" === k;
                    n.noTickson || "category" !== k && !P || !e1.ticks && !e1.showgrid || (P && (C = "boundaries"), "boundaries" === r("tickson", C) && delete e1.ticklabelposition);
                    P && r("showdividers") && (r("dividercolor"), r("dividerwidth"));
                    if ("date" === k) {
                        if (o(t1, e1, {
                            name: "rangebreaks",
                            inclusionAttr: "enabled",
                            handleItemDefaults: v
                        }), e1.rangebreaks.length) {
                            for(var I = 0; I < e1.rangebreaks.length; I++)if (e1.rangebreaks[I].pattern === m) {
                                e1._hasDayOfWeekBreaks = !0;
                                break;
                            }
                            if (d(e1, g), g._has("scattergl") || g._has("splom")) for(var O = 0; O < n.data.length; O++){
                                var z = n.data[O];
                                "scattergl" !== z.type && "splom" !== z.type || (z.visible = !1, a.warn(z.type + " traces do not work on axes with rangebreaks. Setting trace " + z.index + " to `visible: false`."));
                            }
                        } else delete e1.rangebreaks;
                    }
                    return e1;
                };
                var y = {
                    sun: 1,
                    mon: 2,
                    tue: 3,
                    wed: 4,
                    thu: 5,
                    fri: 6,
                    sat: 7
                };
                function x(t1) {
                    if ("string" == typeof t1) return y[t1.substr(0, 3).toLowerCase()];
                }
            },
            {
                "../../lib": 503,
                "../../registry": 638,
                "../array_container_defaults": 549,
                "./category_order_defaults": 559,
                "./constants": 561,
                "./layout_attributes": 569,
                "./line_grid_defaults": 571,
                "./prefix_suffix_defaults": 573,
                "./set_convert": 576,
                "./tick_label_defaults": 578,
                "./tick_mark_defaults": 579,
                "./tick_value_defaults": 580,
                "fast-isnumeric": 190
            }
        ],
        557: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../constants/docs"), i = n.FORMAT_LINK, a = n.DATE_FORMAT_LINK;
                function o(t1, e1) {
                    return [
                        "Sets the " + t1 + " formatting rule" + (e1 ? "for `" + e1 + "` " : ""),
                        "using d3 formatting mini-languages",
                        "which are very similar to those in Python. For numbers, see: " + i + "."
                    ].join(" ");
                }
                function s(t1, e1) {
                    return o(t1, e1) + [
                        " And for dates see: " + a + ".",
                        "We add two items to d3's date formatter:",
                        "*%h* for half of the year as a decimal number as well as",
                        "*%{n}f* for fractional seconds",
                        "with n digits. For example, *2016-10-13 09:15:23.456* with tickformat",
                        "*%H~%M~%S.%2f* would display *09~15~23.46*"
                    ].join(" ");
                }
                e1.exports = {
                    axisHoverFormat: function(t1, e1) {
                        return {
                            valType: "string",
                            dflt: "",
                            editType: "none",
                            description: (e1 ? o : s)("hover text", t1) + [
                                "By default the values are formatted using " + (e1 ? "generic number format" : "`" + t1 + "axis.hoverformat`") + "."
                            ].join(" ")
                        };
                    },
                    descriptionOnlyNumbers: o,
                    descriptionWithDates: s
                };
            },
            {
                "../../constants/docs": 474
            }
        ],
        558: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("./constants");
                function a(t1, e1) {
                    if (e1 && e1.length) {
                        for(var r = 0; r < e1.length; r++)if (e1[r][t1]) return !0;
                    }
                    return !1;
                }
                r.id2name = function(t1) {
                    if ("string" == typeof t1 && t1.match(i.AX_ID_PATTERN)) {
                        var e1 = t1.split(" ")[0].substr(1);
                        return "1" === e1 && (e1 = ""), t1.charAt(0) + "axis" + e1;
                    }
                }, r.name2id = function(t1) {
                    if (t1.match(i.AX_NAME_PATTERN)) {
                        var e1 = t1.substr(5);
                        return "1" === e1 && (e1 = ""), t1.charAt(0) + e1;
                    }
                }, r.cleanId = function(t1, e1, r) {
                    var n = /( domain)$/.test(t1);
                    if ("string" == typeof t1 && t1.match(i.AX_ID_PATTERN) && (!e1 || t1.charAt(0) === e1) && (!n || r)) {
                        var a = t1.split(" ")[0].substr(1).replace(/^0+/, "");
                        return "1" === a && (a = ""), t1.charAt(0) + a + (n && r ? " domain" : "");
                    }
                }, r.list = function(t1, e1, n) {
                    var i = t1._fullLayout;
                    if (!i) return [];
                    var a, o = r.listIds(t1, e1), s = new Array(o.length);
                    for(a = 0; a < o.length; a++){
                        var l = o[a];
                        s[a] = i[l.charAt(0) + "axis" + l.substr(1)];
                    }
                    if (!n) {
                        var c = i._subplots.gl3d || [];
                        for(a = 0; a < c.length; a++){
                            var u = i[c[a]];
                            e1 ? s.push(u[e1 + "axis"]) : s.push(u.xaxis, u.yaxis, u.zaxis);
                        }
                    }
                    return s;
                }, r.listIds = function(t1, e1) {
                    var r = t1._fullLayout;
                    if (!r) return [];
                    var n = r._subplots;
                    return e1 ? n[e1 + "axis"] : n.xaxis.concat(n.yaxis);
                }, r.getFromId = function(t1, e1, n) {
                    var i = t1._fullLayout;
                    return e1 = void 0 === e1 || "string" != typeof e1 ? e1 : e1.replace(" domain", ""), "x" === n ? e1 = e1.replace(/y[0-9]*/, "") : "y" === n && (e1 = e1.replace(/x[0-9]*/, "")), i[r.id2name(e1)];
                }, r.getFromTrace = function(t1, e1, i) {
                    var a = t1._fullLayout, o = null;
                    if (n.traceIs(e1, "gl3d")) {
                        var s = e1.scene;
                        "scene" === s.substr(0, 5) && (o = a[s][i + "axis"]);
                    } else o = r.getFromId(t1, e1[i + "axis"] || i);
                    return o;
                }, r.idSort = function(t1, e1) {
                    var r = t1.charAt(0), n = e1.charAt(0);
                    return r !== n ? r > n ? 1 : -1 : +(t1.substr(1) || 1) - +(e1.substr(1) || 1);
                }, r.ref2id = function(t1) {
                    return !!/^[xyz]/.test(t1) && t1.split(" ")[0];
                }, r.isLinked = function(t1, e1) {
                    return a(e1, t1._axisMatchGroups) || a(e1, t1._axisConstraintGroups);
                };
            },
            {
                "../../registry": 638,
                "./constants": 561
            }
        ],
        559: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n) {
                    if ("category" === e1.type) {
                        var i, a = t1.categoryarray, o = Array.isArray(a) && a.length > 0;
                        o && (i = "array");
                        var s, l = r("categoryorder", i);
                        "array" === l && (s = r("categoryarray")), o || "array" !== l || (l = e1.categoryorder = "trace"), "trace" === l ? e1._initialCategories = [] : "array" === l ? e1._initialCategories = s.slice() : (s = (function(t1, e1) {
                            var r, n, i, a = e1.dataAttr || t1._id.charAt(0), o = {};
                            if (e1.axData) r = e1.axData;
                            else for(r = [], n = 0; n < e1.data.length; n++){
                                var s = e1.data[n];
                                s[a + "axis"] === t1._id && r.push(s);
                            }
                            for(n = 0; n < r.length; n++){
                                var l = r[n][a];
                                for(i = 0; i < l.length; i++){
                                    var c = l[i];
                                    null != c && (o[c] = 1);
                                }
                            }
                            return Object.keys(o);
                        })(e1, n).sort(), "category ascending" === l ? e1._initialCategories = s : "category descending" === l && (e1._initialCategories = s.reverse()));
                    }
                };
            },
            {}
        ],
        560: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = t1("../../constants/numerical"), o = a.ONEDAY, s = a.ONEWEEK;
                r.dtick = function(t1, e1) {
                    var r = "log" === e1, i = "date" === e1, a = "category" === e1, s = i ? o : 1;
                    if (!t1) return s;
                    if (n(t1)) return (t1 = Number(t1)) <= 0 ? s : a ? Math.max(1, Math.round(t1)) : i ? Math.max(.1, t1) : t1;
                    if ("string" != typeof t1 || !i && !r) return s;
                    var l = t1.charAt(0), c = t1.substr(1);
                    return (c = n(c) ? Number(c) : 0) <= 0 || !(i && "M" === l && c === Math.round(c) || r && "L" === l || r && "D" === l && (1 === c || 2 === c)) ? s : t1;
                }, r.tick0 = function(t1, e1, r, a) {
                    return "date" === e1 ? i.cleanDate(t1, i.dateTick0(r, a % s == 0 ? 1 : 0)) : "D1" !== a && "D2" !== a ? n(t1) ? Number(t1) : 0 : void 0;
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "fast-isnumeric": 190
            }
        ],
        561: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib/regex").counter;
                e1.exports = {
                    idRegex: {
                        x: n("x", "( domain)?"),
                        y: n("y", "( domain)?")
                    },
                    attrRegex: n("[xy]axis"),
                    xAxisMatch: n("xaxis"),
                    yAxisMatch: n("yaxis"),
                    AX_ID_PATTERN: /^[xyz][0-9]*( domain)?$/,
                    AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
                    SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
                    HOUR_PATTERN: "hour",
                    WEEKDAY_PATTERN: "day of week",
                    MINDRAG: 8,
                    MINSELECT: 12,
                    MINZOOM: 20,
                    DRAGGERSIZE: 20,
                    BENDPX: 1.5,
                    REDRAWDELAY: 50,
                    SELECTDELAY: 100,
                    SELECTID: "-select",
                    DFLTRANGEX: [
                        -1,
                        6
                    ],
                    DFLTRANGEY: [
                        -1,
                        4
                    ],
                    traceLayerClasses: [
                        "imagelayer",
                        "heatmaplayer",
                        "contourcarpetlayer",
                        "contourlayer",
                        "funnellayer",
                        "waterfalllayer",
                        "barlayer",
                        "carpetlayer",
                        "violinlayer",
                        "boxlayer",
                        "ohlclayer",
                        "scattercarpetlayer",
                        "scatterlayer"
                    ],
                    clipOnAxisFalseQuery: [
                        ".scatterlayer",
                        ".barlayer",
                        ".funnellayer",
                        ".waterfalllayer"
                    ],
                    layerValue2layerClass: {
                        "above traces": "above",
                        "below traces": "below"
                    }
                };
            },
            {
                "../../lib/regex": 520
            }
        ],
        562: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./autorange"), a = t1("./axis_ids").id2name, o = t1("./layout_attributes"), s = t1("./scale_zoom"), l = t1("./set_convert"), c = t1("../../constants/numerical").ALMOST_EQUAL, u = t1("../../constants/alignment").FROM_BL;
                function f(t1, e1, r) {
                    var i = r.axIds, s = r.layoutOut, l = r.hasImage, c = s._axisConstraintGroups, u = s._axisMatchGroups, f = e1._id, m = f.charAt(0), g = ((s._splomAxes || {})[m] || {})[f] || {}, v = e1._id, y = "x" === v.charAt(0);
                    function x(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    e1._matchGroup = null, e1._constraintGroup = null, x("constrain", l ? "domain" : "range"), n.coerce(t1, e1, {
                        constraintoward: {
                            valType: "enumerated",
                            values: y ? [
                                "left",
                                "center",
                                "right"
                            ] : [
                                "bottom",
                                "middle",
                                "top"
                            ],
                            dflt: y ? "center" : "middle"
                        }
                    }, "constraintoward");
                    var b, _, w = e1.type, T = [];
                    for(b = 0; b < i.length; b++)if ((_ = i[b]) !== v) s[a(_)].type === w && T.push(_);
                    var k = p(c, v);
                    if (k) {
                        var A = [];
                        for(b = 0; b < T.length; b++)k[_ = T[b]] || A.push(_);
                        T = A;
                    }
                    var M, S, E = T.length;
                    E && (t1.matches || g.matches) && (M = n.coerce(t1, e1, {
                        matches: {
                            valType: "enumerated",
                            values: T,
                            dflt: -1 !== T.indexOf(g.matches) ? g.matches : void 0
                        }
                    }, "matches"));
                    var L = l && !y ? e1.anchor : void 0;
                    if (E && !M && (t1.scaleanchor || L) && (S = n.coerce(t1, e1, {
                        scaleanchor: {
                            valType: "enumerated",
                            values: T
                        }
                    }, "scaleanchor", L)), M) {
                        e1._matchGroup = d(u, v, M, 1);
                        var C = s[a(M)], P = h(s, e1) / h(s, C);
                        y !== ("x" === M.charAt(0)) && (P = (y ? "x" : "y") + P), d(c, v, M, P);
                    } else t1.matches && -1 !== i.indexOf(t1.matches) && n.warn("ignored " + e1._name + '.matches: "' + t1.matches + '" to avoid an infinite loop');
                    if (S) {
                        var I = x("scaleratio");
                        I || (I = e1.scaleratio = 1), d(c, v, S, I);
                    } else t1.scaleanchor && -1 !== i.indexOf(t1.scaleanchor) && n.warn("ignored " + e1._name + '.scaleanchor: "' + t1.scaleanchor + '" to avoid either an infinite loop and possibly inconsistent scaleratios, or because this axis declares a *matches* constraint.');
                }
                function h(t1, e1) {
                    var r = e1.domain;
                    return r || (r = t1[a(e1.overlaying)].domain), r[1] - r[0];
                }
                function p(t1, e1) {
                    for(var r = 0; r < t1.length; r++)if (t1[r][e1]) return t1[r];
                    return null;
                }
                function d(t1, e1, r, n) {
                    var i, a, o, s, l, c = p(t1, e1);
                    null === c ? ((c = {})[e1] = 1, l = t1.length, t1.push(c)) : l = t1.indexOf(c);
                    var u = Object.keys(c);
                    for(i = 0; i < t1.length; i++)if (o = t1[i], i !== l && o[r]) {
                        var f = o[r];
                        for(a = 0; a < u.length; a++)o[s = u[a]] = m(f, m(n, c[s]));
                        return void t1.splice(l, 1);
                    }
                    if (1 !== n) for(a = 0; a < u.length; a++){
                        var h = u[a];
                        c[h] = m(n, c[h]);
                    }
                    c[r] = 1;
                }
                function m(t1, e1) {
                    var r, n, i = "", a = "";
                    "string" == typeof t1 && (r = (i = t1.match(/^[xy]*/)[0]).length, t1 = +t1.substr(r)), "string" == typeof e1 && (n = (a = e1.match(/^[xy]*/)[0]).length, e1 = +e1.substr(n));
                    var o = t1 * e1;
                    return r || n ? r && n && i.charAt(0) !== a.charAt(0) ? r === n ? o : (r > n ? i.substr(n) : a.substr(r)) + o : i + a + t1 * e1 : o;
                }
                function g(t1, e1) {
                    for(var r = e1._size, n = r.h / r.w, i = {}, a = Object.keys(t1), o = 0; o < a.length; o++){
                        var s = a[o], l = t1[s];
                        if ("string" == typeof l) {
                            var c = l.match(/^[xy]*/)[0], u = c.length;
                            l = +l.substr(u);
                            for(var f = "y" === c.charAt(0) ? n : 1 / n, h = 0; h < u; h++)l *= f;
                        }
                        i[s] = l;
                    }
                    return i;
                }
                function v(t1, e1) {
                    var r = t1._inputDomain, n = u[t1.constraintoward], i = r[0] + (r[1] - r[0]) * n;
                    t1.domain = t1._input.domain = [
                        i + (r[0] - i) / e1,
                        i + (r[1] - i) / e1
                    ], t1.setScale();
                }
                r.handleDefaults = function(t1, e1, r) {
                    var i, o, s, c, u, h, p, d, m = r.axIds, g = r.axHasImage, v = e1._axisConstraintGroups = [], y = e1._axisMatchGroups = [];
                    for(i = 0; i < m.length; i++)f(u = t1[c = a(m[i])], h = e1[c], {
                        axIds: m,
                        layoutOut: e1,
                        hasImage: g[c]
                    });
                    function x(t1, r) {
                        for(i = 0; i < t1.length; i++)for(s in o = t1[i])e1[a(s)][r] = o;
                    }
                    for(x(y, "_matchGroup"), i = 0; i < v.length; i++)for(s in o = v[i])if ((h = e1[a(s)]).fixedrange) {
                        for(var b in o){
                            var _ = a(b);
                            !1 === (t1[_] || {}).fixedrange && n.warn("fixedrange was specified as false for axis " + _ + " but was overridden because another axis in its constraint group has fixedrange true"), e1[_].fixedrange = !0;
                        }
                        break;
                    }
                    for(i = 0; i < v.length;){
                        for(s in o = v[i]){
                            (h = e1[a(s)])._matchGroup && Object.keys(h._matchGroup).length === Object.keys(o).length && (v.splice(i, 1), i--);
                            break;
                        }
                        i++;
                    }
                    x(v, "_constraintGroup");
                    var w = [
                        "constrain",
                        "range",
                        "autorange",
                        "rangemode",
                        "rangebreaks",
                        "categoryorder",
                        "categoryarray"
                    ], T = !1, k = !1;
                    function A() {
                        d = h[p], "rangebreaks" === p && (k = h._hasDayOfWeekBreaks);
                    }
                    for(i = 0; i < y.length; i++){
                        o = y[i];
                        for(var M = 0; M < w.length; M++){
                            var S;
                            for(s in p = w[M], d = null, o)if (u = t1[c = a(s)], h = e1[c], p in h) {
                                if (!h.matches && (S = h, p in u)) {
                                    A();
                                    break;
                                }
                                null === d && p in u && A();
                            }
                            if ("range" === p && d && (T = !0), "autorange" === p && null === d && T && (d = !1), null === d && p in S && (d = S[p]), null !== d) for(s in o)(h = e1[a(s)])[p] = "range" === p ? d.slice() : d, "rangebreaks" === p && (h._hasDayOfWeekBreaks = k, l(h, e1));
                        }
                    }
                }, r.enforce = function(t1) {
                    var e1, r, n, o, l, u, f, h, p = t1._fullLayout, d = p._axisConstraintGroups || [];
                    for(e1 = 0; e1 < d.length; e1++){
                        n = g(d[e1], p);
                        var m = Object.keys(n), y = 1 / 0, x = 0, b = 1 / 0, _ = {}, w = {}, T = !1;
                        for(r = 0; r < m.length; r++)w[o = m[r]] = l = p[a(o)], l._inputDomain ? l.domain = l._inputDomain.slice() : l._inputDomain = l.domain.slice(), l._inputRange || (l._inputRange = l.range.slice()), l.setScale(), _[o] = u = Math.abs(l._m) / n[o], y = Math.min(y, u), "domain" !== l.constrain && l._constraintShrinkable || (b = Math.min(b, u)), delete l._constraintShrinkable, x = Math.max(x, u), "domain" === l.constrain && (T = !0);
                        if (!(y > c * x) || T) {
                            for(r = 0; r < m.length; r++)if (u = _[o = m[r]], f = (l = w[o]).constrain, u !== b || "domain" === f) {
                                if (h = u / b, "range" === f) s(l, h);
                                else {
                                    var k = l._inputDomain, A = (l.domain[1] - l.domain[0]) / (k[1] - k[0]), M = (l.r2l(l.range[1]) - l.r2l(l.range[0])) / (l.r2l(l._inputRange[1]) - l.r2l(l._inputRange[0]));
                                    if ((h /= A) * M < 1) {
                                        l.domain = l._input.domain = k.slice(), s(l, h);
                                        continue;
                                    }
                                    if (M < 1 && (l.range = l._input.range = l._inputRange.slice(), h *= M), l.autorange) {
                                        var S = l.r2l(l.range[0]), E = l.r2l(l.range[1]), L = (S + E) / 2, C = L, P = L, I = Math.abs(E - L), O = L - I * h * 1.0001, z = L + I * h * 1.0001, D = i.makePadFn(p, l, 0), R = i.makePadFn(p, l, 1);
                                        v(l, h);
                                        var F, B, N = Math.abs(l._m), j = i.concatExtremes(t1, l), U = j.min, V = j.max;
                                        for(B = 0; B < U.length; B++)(F = U[B].val - D(U[B]) / N) > O && F < C && (C = F);
                                        for(B = 0; B < V.length; B++)(F = V[B].val + R(V[B]) / N) < z && F > P && (P = F);
                                        h /= (P - C) / (2 * I), C = l.l2r(C), P = l.l2r(P), l.range = l._input.range = S < E ? [
                                            C,
                                            P
                                        ] : [
                                            P,
                                            C
                                        ];
                                    }
                                    v(l, h);
                                }
                            }
                        }
                    }
                }, r.getAxisGroup = function(t1, e1) {
                    for(var r = t1._axisMatchGroups, n = 0; n < r.length; n++){
                        if (r[n][e1]) return "g" + n;
                    }
                    return e1;
                }, r.clean = function(t1, e1) {
                    if (e1._inputDomain) {
                        for(var r = !1, n = e1._id, i = t1._fullLayout._axisConstraintGroups, a = 0; a < i.length; a++)if (i[a][n]) {
                            r = !0;
                            break;
                        }
                        r && "domain" === e1.constrain || (e1._input.domain = e1.domain = e1._inputDomain, delete e1._inputDomain);
                    }
                };
            },
            {
                "../../constants/alignment": 471,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "./autorange": 553,
                "./axis_ids": 558,
                "./layout_attributes": 569,
                "./scale_zoom": 574,
                "./set_convert": 576
            }
        ],
        563: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = i.numberFormat, o = t1("tinycolor2"), s = t1("has-passive-events"), l = t1("../../registry"), c = i.strTranslate, u = t1("../../lib/svg_text_utils"), f = t1("../../components/color"), h = t1("../../components/drawing"), p = t1("../../components/fx"), d = t1("./axes"), m = t1("../../lib/setcursor"), g = t1("../../components/dragelement"), v = t1("../../components/dragelement/helpers"), y = v.selectingOrDrawing, x = v.freeMode, b = t1("../../constants/alignment").FROM_TL, _ = t1("../../lib/clear_gl_canvases"), w = t1("../../plot_api/subroutines").redrawReglTraces, T = t1("../plots"), k = t1("./axis_ids").getFromId, A = t1("./select").prepSelect, M = t1("./select").clearSelect, S = t1("./select").selectOnClick, E = t1("./scale_zoom"), L = t1("./constants"), C = L.MINDRAG, P = L.MINZOOM, I = !0;
                function O(t1, e1, r, n) {
                    var a = i.ensureSingle(t1.draglayer, e1, r, function(e1) {
                        e1.classed("drag", !0).style({
                            fill: "transparent",
                            "stroke-width": 0
                        }).attr("data-subplot", t1.id);
                    });
                    return a.call(m, n), a.node();
                }
                function z(t1, e1, r, i, a, o, s) {
                    var l = O(t1, "rect", e1, r);
                    return n.select(l).call(h.setRect, i, a, o, s), l;
                }
                function D(t1, e1) {
                    for(var r = 0; r < t1.length; r++)if (!t1[r].fixedrange) return e1;
                    return "";
                }
                function R(t1, e1, r, n, i) {
                    for(var a = 0; a < t1.length; a++){
                        var o = t1[a];
                        if (!o.fixedrange) {
                            if (o.rangebreaks) {
                                var s = "y" === o._id.charAt(0), l = s ? 1 - e1 : e1, c = s ? 1 - r : r;
                                n[o._name + ".range[0]"] = o.l2r(o.p2l(l * o._length)), n[o._name + ".range[1]"] = o.l2r(o.p2l(c * o._length));
                            } else {
                                var u = o._rl[0], f = o._rl[1] - u;
                                n[o._name + ".range[0]"] = o.l2r(u + f * e1), n[o._name + ".range[1]"] = o.l2r(u + f * r);
                            }
                        }
                    }
                    if (i && i.length) {
                        var h = (e1 + (1 - r)) / 2;
                        R(i, h, 1 - h, n, []);
                    }
                }
                function F(t1, e1) {
                    for(var r = 0; r < t1.length; r++){
                        var n = t1[r];
                        if (!n.fixedrange) {
                            if (n.rangebreaks) {
                                var i = n._length, a = (n.p2l(0 + e1) - n.p2l(0) + (n.p2l(i + e1) - n.p2l(i))) / 2;
                                n.range = [
                                    n.l2r(n._rl[0] - a),
                                    n.l2r(n._rl[1] - a)
                                ];
                            } else n.range = [
                                n.l2r(n._rl[0] - e1 / n._m),
                                n.l2r(n._rl[1] - e1 / n._m)
                            ];
                        }
                    }
                }
                function B(t1) {
                    return 1 - (t1 >= 0 ? Math.min(t1, .9) : 1 / (1 / Math.max(t1, -0.3) + 3.222));
                }
                function N(t1, e1, r, n, i) {
                    return t1.append("path").attr("class", "zoombox").style({
                        fill: e1 > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
                        "stroke-width": 0
                    }).attr("transform", c(r, n)).attr("d", i + "Z");
                }
                function j(t1, e1, r) {
                    return t1.append("path").attr("class", "zoombox-corners").style({
                        fill: f.background,
                        stroke: f.defaultLine,
                        "stroke-width": 1,
                        opacity: 0
                    }).attr("transform", c(e1, r)).attr("d", "M0,0Z");
                }
                function U(t1, e1, r, n, i, a) {
                    t1.attr("d", n + "M" + r.l + "," + r.t + "v" + r.h + "h" + r.w + "v-" + r.h + "h-" + r.w + "Z"), V(t1, e1, i, a);
                }
                function V(t1, e1, r, n) {
                    r || (t1.transition().style("fill", n > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), e1.transition().style("opacity", 1).duration(200));
                }
                function H(t1) {
                    n.select(t1).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
                }
                function q(t1) {
                    I && t1.data && t1._context.showTips && (i.notifier(i._(t1, "Double-click to zoom back out"), "long"), I = !1);
                }
                function G(t1) {
                    var e1 = Math.floor(Math.min(t1.b - t1.t, t1.r - t1.l, P) / 2);
                    return "M" + (t1.l - 3.5) + "," + (t1.t - .5 + e1) + "h3v" + -e1 + "h" + e1 + "v-3h-" + (e1 + 3) + "ZM" + (t1.r + 3.5) + "," + (t1.t - .5 + e1) + "h-3v" + -e1 + "h" + -e1 + "v-3h" + (e1 + 3) + "ZM" + (t1.r + 3.5) + "," + (t1.b + .5 - e1) + "h-3v" + e1 + "h" + -e1 + "v3h" + (e1 + 3) + "ZM" + (t1.l - 3.5) + "," + (t1.b + .5 - e1) + "h3v" + e1 + "h" + e1 + "v3h-" + (e1 + 3) + "Z";
                }
                function Y(t1, e1, r, n, a) {
                    for(var o, s, l, c, u = !1, f = {}, h = {}, p = (a || {}).xaHash, d = (a || {}).yaHash, m = 0; m < e1.length; m++){
                        var g = e1[m];
                        for(o in r)if (g[o]) {
                            for(l in g)a && (p[l] || d[l]) || ("x" === l.charAt(0) ? r : n)[l] || (f[l] = o);
                            for(s in n)a && (p[s] || d[s]) || !g[s] || (u = !0);
                        }
                        for(s in n)if (g[s]) for(c in g)a && (p[c] || d[c]) || ("x" === c.charAt(0) ? r : n)[c] || (h[c] = s);
                    }
                    u && (i.extendFlat(f, h), h = {});
                    var v = {}, y = [];
                    for(l in f){
                        var x = k(t1, l);
                        y.push(x), v[x._id] = x;
                    }
                    var b = {}, _ = [];
                    for(c in h){
                        var w = k(t1, c);
                        _.push(w), b[w._id] = w;
                    }
                    return {
                        xaHash: v,
                        yaHash: b,
                        xaxes: y,
                        yaxes: _,
                        xLinks: f,
                        yLinks: h,
                        isSubplotConstrained: u
                    };
                }
                function W(t1, e1) {
                    if (s) {
                        var r = void 0 !== t1.onwheel ? "wheel" : "mousewheel";
                        t1._onwheel && t1.removeEventListener(r, t1._onwheel), t1._onwheel = e1, t1.addEventListener(r, e1, {
                            passive: !1
                        });
                    } else void 0 !== t1.onwheel ? t1.onwheel = e1 : void 0 !== t1.onmousewheel ? t1.onmousewheel = e1 : t1.isAddedWheelEvent || (t1.isAddedWheelEvent = !0, t1.addEventListener("wheel", e1, {
                        passive: !1
                    }));
                }
                function X(t1) {
                    var e1 = [];
                    for(var r in t1)e1.push(t1[r]);
                    return e1;
                }
                e1.exports = {
                    makeDragBox: function(t1, e1, r, s, c, f, m, v) {
                        var I, O, V, Z, J, K, Q, $, tt, et, rt, nt, it, at, ot, st, lt, ct, ut, ft, ht, pt, dt, mt = t1._fullLayout._zoomlayer, gt = m + v === "nsew", vt = 1 === (m + v).length;
                        function yt() {
                            if (I = e1.xaxis, O = e1.yaxis, tt = I._length, et = O._length, Q = I._offset, $ = O._offset, (V = {})[I._id] = I, (Z = {})[O._id] = O, m && v) for(var r = e1.overlays, n = 0; n < r.length; n++){
                                var i = r[n].xaxis;
                                V[i._id] = i;
                                var a = r[n].yaxis;
                                Z[a._id] = a;
                            }
                            J = X(V), K = X(Z), it = D(J, v), at = D(K, m), ot = !at && !it, nt = Y(t1, t1._fullLayout._axisMatchGroups, V, Z);
                            var o = (rt = Y(t1, t1._fullLayout._axisConstraintGroups, V, Z, nt)).isSubplotConstrained || nt.isSubplotConstrained;
                            st = v || o, lt = m || o;
                            var s = t1._fullLayout;
                            ct = s._has("scattergl"), ut = s._has("splom"), ft = s._has("svg");
                        }
                        yt();
                        var xt = function(t1, e1, r) {
                            if (!t1) return "pointer";
                            if ("nsew" === t1) return r ? "" : "pan" === e1 ? "move" : "crosshair";
                            return t1.toLowerCase() + "-resize";
                        }(at + it, t1._fullLayout.dragmode, gt), bt = z(e1, m + v + "drag", xt, r, s, c, f);
                        if (ot && !gt) return bt.onmousedown = null, bt.style.pointerEvents = "none", bt;
                        var _t, wt, Tt, kt, At, Mt, St, Et, Lt, Ct, Pt = {
                            element: bt,
                            gd: t1,
                            plotinfo: e1
                        };
                        function It() {
                            Pt.plotinfo.selection = !1, M(t1);
                        }
                        function Ot(t1, r) {
                            var i = Pt.gd;
                            if (i._fullLayout._activeShapeIndex >= 0) i._fullLayout._deactivateShape(i);
                            else {
                                var o = i._fullLayout.clickmode;
                                if (H(i), 2 !== t1 || vt || qt(), gt) o.indexOf("select") > -1 && S(r, i, J, K, e1.id, Pt), o.indexOf("event") > -1 && p.click(i, r, e1.id);
                                else if (1 === t1 && vt) {
                                    var s = m ? O : I, c = "s" === m || "w" === v ? 0 : 1, f = s._name + ".range[" + c + "]", h = function(t1, e1) {
                                        var r, n = t1.range[e1], i = Math.abs(n - t1.range[1 - e1]);
                                        return "date" === t1.type ? n : "log" === t1.type ? (r = Math.ceil(Math.max(0, -Math.log(i) / Math.LN10)) + 3, a("." + r + "g")(Math.pow(10, n))) : (r = Math.floor(Math.log(Math.abs(n)) / Math.LN10) - Math.floor(Math.log(i) / Math.LN10) + 4, a("." + String(r) + "g")(n));
                                    }(s, c), d = "left", g = "middle";
                                    if (s.fixedrange) return;
                                    m ? (g = "n" === m ? "top" : "bottom", "right" === s.side && (d = "right")) : "e" === v && (d = "right"), i._context.showAxisRangeEntryBoxes && n.select(bt).call(u.makeEditable, {
                                        gd: i,
                                        immediate: !0,
                                        background: i._fullLayout.paper_bgcolor,
                                        text: String(h),
                                        fill: s.tickfont ? s.tickfont.color : "#444",
                                        horizontalAlign: d,
                                        verticalAlign: g
                                    }).on("edit", function(t1) {
                                        var e1 = s.d2r(t1);
                                        void 0 !== e1 && l.call("_guiRelayout", i, f, e1);
                                    });
                                }
                            }
                        }
                        function zt(e1, r) {
                            if (t1._transitioningWithDuration) return !1;
                            var n = Math.max(0, Math.min(tt, pt * e1 + _t)), i = Math.max(0, Math.min(et, dt * r + wt)), a = Math.abs(n - _t), o = Math.abs(i - wt);
                            function s() {
                                St = "", Tt.r = Tt.l, Tt.t = Tt.b, Lt.attr("d", "M0,0Z");
                            }
                            if (Tt.l = Math.min(_t, n), Tt.r = Math.max(_t, n), Tt.t = Math.min(wt, i), Tt.b = Math.max(wt, i), rt.isSubplotConstrained) a > P || o > P ? (St = "xy", a / tt > o / et ? (o = a * et / tt, wt > i ? Tt.t = wt - o : Tt.b = wt + o) : (a = o * tt / et, _t > n ? Tt.l = _t - a : Tt.r = _t + a), Lt.attr("d", G(Tt))) : s();
                            else if (nt.isSubplotConstrained) {
                                if (a > P || o > P) {
                                    St = "xy";
                                    var l = Math.min(Tt.l / tt, (et - Tt.b) / et), c = Math.max(Tt.r / tt, (et - Tt.t) / et);
                                    Tt.l = l * tt, Tt.r = c * tt, Tt.b = (1 - l) * et, Tt.t = (1 - c) * et, Lt.attr("d", G(Tt));
                                } else s();
                            } else !at || o < Math.min(Math.max(.6 * a, C), P) ? a < C || !it ? s() : (Tt.t = 0, Tt.b = et, St = "x", Lt.attr("d", function(t1, e1) {
                                return "M" + (t1.l - .5) + "," + (e1 - P - .5) + "h-3v" + (2 * P + 1) + "h3ZM" + (t1.r + .5) + "," + (e1 - P - .5) + "h3v" + (2 * P + 1) + "h-3Z";
                            }(Tt, wt))) : !it || a < Math.min(.6 * o, P) ? (Tt.l = 0, Tt.r = tt, St = "y", Lt.attr("d", function(t1, e1) {
                                return "M" + (e1 - P - .5) + "," + (t1.t - .5) + "v-3h" + (2 * P + 1) + "v3ZM" + (e1 - P - .5) + "," + (t1.b + .5) + "v3h" + (2 * P + 1) + "v-3Z";
                            }(Tt, _t))) : (St = "xy", Lt.attr("d", G(Tt)));
                            Tt.w = Tt.r - Tt.l, Tt.h = Tt.b - Tt.t, St && (Ct = !0), t1._dragged = Ct, U(Et, Lt, Tt, At, Mt, kt), Dt(), t1.emit("plotly_relayouting", ht), Mt = !0;
                        }
                        function Dt() {
                            ht = {}, "xy" !== St && "x" !== St || (R(J, Tt.l / tt, Tt.r / tt, ht, rt.xaxes), Vt("x", ht)), "xy" !== St && "y" !== St || (R(K, (et - Tt.b) / et, (et - Tt.t) / et, ht, rt.yaxes), Vt("y", ht));
                        }
                        function Rt() {
                            Dt(), H(t1), Gt(), q(t1);
                        }
                        Pt.prepFn = function(e1, r, n) {
                            var a = Pt.dragmode, s = t1._fullLayout.dragmode;
                            s !== a && (Pt.dragmode = s), yt(), pt = t1._fullLayout._invScaleX, dt = t1._fullLayout._invScaleY, ot || (gt ? e1.shiftKey ? "pan" === s ? s = "zoom" : y(s) || (s = "pan") : e1.ctrlKey && (s = "pan") : s = "pan"), x(s) ? Pt.minDrag = 1 : Pt.minDrag = void 0, y(s) ? (Pt.xaxes = J, Pt.yaxes = K, A(e1, r, n, Pt, s)) : (Pt.clickFn = Ot, y(a) && It(), ot || ("zoom" === s ? (Pt.moveFn = zt, Pt.doneFn = Rt, Pt.minDrag = 1, function(e1, r, n) {
                                var a = bt.getBoundingClientRect();
                                _t = r - a.left, wt = n - a.top, t1._fullLayout._calcInverseTransform(t1);
                                var s = i.apply3DTransform(t1._fullLayout._invTransform)(_t, wt);
                                _t = s[0], wt = s[1], Tt = {
                                    l: _t,
                                    r: _t,
                                    w: 0,
                                    t: wt,
                                    b: wt,
                                    h: 0
                                }, kt = t1._hmpixcount ? t1._hmlumcount / t1._hmpixcount : o(t1._fullLayout.plot_bgcolor).getLuminance(), Mt = !1, St = "xy", Ct = !1, Et = N(mt, kt, Q, $, At = "M0,0H" + tt + "V" + et + "H0V0"), Lt = j(mt, Q, $);
                            }(0, r, n)) : "pan" === s && (Pt.moveFn = Ut, Pt.doneFn = Gt))), t1._fullLayout._redrag = function() {
                                var e1 = t1._dragdata;
                                if (e1 && e1.element === bt) {
                                    var r = t1._fullLayout.dragmode;
                                    y(r) || (yt(), Yt([
                                        0,
                                        0,
                                        tt,
                                        et
                                    ]), Pt.moveFn(e1.dx, e1.dy));
                                }
                            };
                        }, g.init(Pt);
                        var Ft = [
                            0,
                            0,
                            tt,
                            et
                        ], Bt = null, Nt = L.REDRAWDELAY, jt = e1.mainplot ? t1._fullLayout._plots[e1.mainplot] : e1;
                        function Ut(e1, r) {
                            if (e1 *= pt, r *= dt, !t1._transitioningWithDuration) {
                                if (t1._fullLayout._replotting = !0, "ew" === it || "ns" === at) {
                                    var n = it ? -e1 : 0, i = at ? -r : 0;
                                    if (nt.isSubplotConstrained) {
                                        if (it && at) {
                                            var a = (e1 / tt - r / et) / 2;
                                            n = -(e1 = a * tt), i = -(r = -a * et);
                                        }
                                        at ? n = -i * tt / et : i = -n * et / tt;
                                    }
                                    return it && (F(J, e1), Vt("x")), at && (F(K, r), Vt("y")), Yt([
                                        n,
                                        i,
                                        tt,
                                        et
                                    ]), Ht(), void t1.emit("plotly_relayouting", ht);
                                }
                                var o, s, l = "w" === it == ("n" === at) ? 1 : -1;
                                if (it && at && (rt.isSubplotConstrained || nt.isSubplotConstrained)) {
                                    var c = (e1 / tt + l * r / et) / 2;
                                    e1 = c * tt, r = l * c * et;
                                }
                                if ("w" === it ? e1 = p(J, 0, e1) : "e" === it ? e1 = p(J, 1, -e1) : it || (e1 = 0), "n" === at ? r = p(K, 1, r) : "s" === at ? r = p(K, 0, -r) : at || (r = 0), o = "w" === it ? e1 : 0, s = "n" === at ? r : 0, rt.isSubplotConstrained && !nt.isSubplotConstrained || nt.isSubplotConstrained && it && at && l > 0) {
                                    var u;
                                    if (nt.isSubplotConstrained || !it && 1 === at.length) {
                                        for(u = 0; u < J.length; u++)J[u].range = J[u]._r.slice(), E(J[u], 1 - r / et);
                                        o = (e1 = r * tt / et) / 2;
                                    }
                                    if (nt.isSubplotConstrained || !at && 1 === it.length) {
                                        for(u = 0; u < K.length; u++)K[u].range = K[u]._r.slice(), E(K[u], 1 - e1 / tt);
                                        s = (r = e1 * et / tt) / 2;
                                    }
                                }
                                nt.isSubplotConstrained && at || Vt("x"), nt.isSubplotConstrained && it || Vt("y");
                                var f = tt - e1, h = et - r;
                                !nt.isSubplotConstrained || it && at || (it ? (s = o ? 0 : e1 * et / tt, h = f * et / tt) : (o = s ? 0 : r * tt / et, f = h * tt / et)), Yt([
                                    o,
                                    s,
                                    f,
                                    h
                                ]), Ht(), t1.emit("plotly_relayouting", ht);
                            }
                            function p(t1, e1, r) {
                                for(var n, i, a = 1 - e1, o = 0; o < t1.length; o++){
                                    var s = t1[o];
                                    if (!s.fixedrange) {
                                        n = s, i = s._rl[a] + (s._rl[e1] - s._rl[a]) / B(r / s._length);
                                        var l = s.l2r(i);
                                        !1 !== l && void 0 !== l && (s.range[e1] = l);
                                    }
                                }
                                return n._length * (n._rl[e1] - i) / (n._rl[e1] - n._rl[a]);
                            }
                        }
                        function Vt(t1, e1) {
                            for(var r = nt.isSubplotConstrained ? ({
                                x: K,
                                y: J
                            })[t1] : nt[t1 + "axes"], n = nt.isSubplotConstrained ? ({
                                x: J,
                                y: K
                            })[t1] : [], i = 0; i < r.length; i++){
                                var a = r[i], o = a._id, s = nt.xLinks[o] || nt.yLinks[o], l = n[0] || V[s] || Z[s];
                                l && (e1 ? (e1[a._name + ".range[0]"] = e1[l._name + ".range[0]"], e1[a._name + ".range[1]"] = e1[l._name + ".range[1]"]) : a.range = l.range.slice());
                            }
                        }
                        function Ht() {
                            var e1, r = [];
                            function n(t1) {
                                for(e1 = 0; e1 < t1.length; e1++)t1[e1].fixedrange || r.push(t1[e1]._id);
                            }
                            for(st && (n(J), n(rt.xaxes), n(nt.xaxes)), lt && (n(K), n(rt.yaxes), n(nt.yaxes)), ht = {}, e1 = 0; e1 < r.length; e1++){
                                var i = r[e1], a = k(t1, i);
                                d.drawOne(t1, a, {
                                    skipTitle: !0
                                }), ht[a._name + ".range[0]"] = a.range[0], ht[a._name + ".range[1]"] = a.range[1];
                            }
                            d.redrawComponents(t1, r);
                        }
                        function qt() {
                            if (!t1._transitioningWithDuration) {
                                var e1 = t1._context.doubleClick, r = [];
                                it && (r = r.concat(J)), at && (r = r.concat(K)), nt.xaxes && (r = r.concat(nt.xaxes)), nt.yaxes && (r = r.concat(nt.yaxes));
                                var n, i, a, o = {};
                                if ("reset+autosize" === e1) {
                                    for(e1 = "autosize", i = 0; i < r.length; i++)if ((n = r[i])._rangeInitial && (n.range[0] !== n._rangeInitial[0] || n.range[1] !== n._rangeInitial[1]) || !n._rangeInitial && !n.autorange) {
                                        e1 = "reset";
                                        break;
                                    }
                                }
                                if ("autosize" === e1) for(i = 0; i < r.length; i++)(n = r[i]).fixedrange || (o[n._name + ".autorange"] = !0);
                                else if ("reset" === e1) for((it || rt.isSubplotConstrained) && (r = r.concat(rt.xaxes)), at && !rt.isSubplotConstrained && (r = r.concat(rt.yaxes)), rt.isSubplotConstrained && (it ? at || (r = r.concat(K)) : r = r.concat(J)), i = 0; i < r.length; i++)(n = r[i]).fixedrange || (n._rangeInitial ? (a = n._rangeInitial, o[n._name + ".range[0]"] = a[0], o[n._name + ".range[1]"] = a[1]) : o[n._name + ".autorange"] = !0);
                                t1.emit("plotly_doubleclick", null), l.call("_guiRelayout", t1, o);
                            }
                        }
                        function Gt() {
                            Yt([
                                0,
                                0,
                                tt,
                                et
                            ]), i.syncOrAsync([
                                T.previousPromises,
                                function() {
                                    t1._fullLayout._replotting = !1, l.call("_guiRelayout", t1, ht);
                                }
                            ], t1);
                        }
                        function Yt(e1) {
                            var r, n, a, o, s = t1._fullLayout, c = s._plots, u = s._subplots.cartesian;
                            if (ut && l.subplotsRegistry.splom.drag(t1), ct) {
                                for(r = 0; r < u.length; r++)if (a = (n = c[u[r]]).xaxis, o = n.yaxis, n._scene) {
                                    var f = i.simpleMap(a.range, a.r2l), p = i.simpleMap(o.range, o.r2l);
                                    n._scene.update({
                                        range: [
                                            f[0],
                                            p[0],
                                            f[1],
                                            p[1]
                                        ]
                                    });
                                }
                            }
                            if ((ut || ct) && (_(t1), w(t1)), ft) {
                                var d = e1[2] / I._length, g = e1[3] / O._length;
                                for(r = 0; r < u.length; r++){
                                    a = (n = c[u[r]]).xaxis, o = n.yaxis;
                                    var y, x, b, T, k = (st || nt.isSubplotConstrained) && !a.fixedrange && V[a._id], A = (lt || nt.isSubplotConstrained) && !o.fixedrange && Z[o._id];
                                    if (k ? (y = d, b = v || nt.isSubplotConstrained ? e1[0] : Zt(a, y)) : nt.xaHash[a._id] ? (y = d, b = e1[0] * a._length / I._length) : nt.yaHash[a._id] ? (y = g, b = "ns" === at ? -e1[1] * a._length / O._length : Zt(a, y, {
                                        n: "top",
                                        s: "bottom"
                                    }[at])) : b = Xt(a, y = Wt(a, d, g)), A ? (x = g, T = m || nt.isSubplotConstrained ? e1[1] : Zt(o, x)) : nt.yaHash[o._id] ? (x = g, T = e1[1] * o._length / O._length) : nt.xaHash[o._id] ? (x = d, T = "ew" === it ? -e1[0] * o._length / I._length : Zt(o, x, {
                                        e: "right",
                                        w: "left"
                                    }[it])) : T = Xt(o, x = Wt(o, d, g)), y || x) {
                                        y || (y = 1), x || (x = 1);
                                        var M = a._offset - b / y, S = o._offset - T / x;
                                        n.clipRect.call(h.setTranslate, b, T).call(h.setScale, y, x), n.plot.call(h.setTranslate, M, S).call(h.setScale, 1 / y, 1 / x), y === n.xScaleFactor && x === n.yScaleFactor || (h.setPointGroupScale(n.zoomScalePts, y, x), h.setTextPointsScale(n.zoomScaleTxt, y, x)), h.hideOutsideRangePoints(n.clipOnAxisFalseTraces, n), n.xScaleFactor = y, n.yScaleFactor = x;
                                    }
                                }
                            }
                        }
                        function Wt(t1, e1, r) {
                            return t1.fixedrange ? 0 : st && rt.xaHash[t1._id] ? e1 : lt && (rt.isSubplotConstrained ? rt.xaHash : rt.yaHash)[t1._id] ? r : 0;
                        }
                        function Xt(t1, e1) {
                            return e1 ? (t1.range = t1._r.slice(), E(t1, e1), Zt(t1, e1)) : 0;
                        }
                        function Zt(t1, e1, r) {
                            return t1._length * (1 - e1) * b[r || t1.constraintoward || "middle"];
                        }
                        return m.length * v.length != 1 && W(bt, function(e1) {
                            if (t1._context._scrollZoom.cartesian || t1._fullLayout._enablescrollzoom) {
                                if (It(), t1._transitioningWithDuration) return e1.preventDefault(), void e1.stopPropagation();
                                yt(), clearTimeout(Bt);
                                var r = -e1.deltaY;
                                if (isFinite(r) || (r = e1.wheelDelta / 10), isFinite(r)) {
                                    var n, a = Math.exp(-Math.min(Math.max(r, -20), 20) / 200), o = jt.draglayer.select(".nsewdrag").node().getBoundingClientRect(), s = (e1.clientX - o.left) / o.width, l = (o.bottom - e1.clientY) / o.height;
                                    if (st) {
                                        for(v || (s = .5), n = 0; n < J.length; n++)c(J[n], s, a);
                                        Vt("x"), Ft[2] *= a, Ft[0] += Ft[2] * s * (1 / a - 1);
                                    }
                                    if (lt) {
                                        for(m || (l = .5), n = 0; n < K.length; n++)c(K[n], l, a);
                                        Vt("y"), Ft[3] *= a, Ft[1] += Ft[3] * (1 - l) * (1 / a - 1);
                                    }
                                    Yt(Ft), Ht(), t1.emit("plotly_relayouting", ht), Bt = setTimeout(function() {
                                        t1._fullLayout && (Ft = [
                                            0,
                                            0,
                                            tt,
                                            et
                                        ], Gt());
                                    }, Nt), e1.preventDefault();
                                } else i.log("Did not find wheel motion attributes: ", e1);
                            }
                            function c(t1, e1, r) {
                                if (!t1.fixedrange) {
                                    var n = i.simpleMap(t1.range, t1.r2l), a = n[0] + (n[1] - n[0]) * e1;
                                    t1.range = n.map(function(e1) {
                                        return t1.l2r(a + (e1 - a) * r);
                                    });
                                }
                            }
                        }), bt;
                    },
                    makeDragger: O,
                    makeRectDragger: z,
                    makeZoombox: N,
                    makeCorners: j,
                    updateZoombox: U,
                    xyCorners: G,
                    transitionZoombox: V,
                    removeZoombox: H,
                    showDoubleClickNotifier: q,
                    attachWheelEventHandler: W
                };
            },
            {
                "../../components/color": 366,
                "../../components/dragelement": 385,
                "../../components/dragelement/helpers": 384,
                "../../components/drawing": 388,
                "../../components/fx": 406,
                "../../constants/alignment": 471,
                "../../lib": 503,
                "../../lib/clear_gl_canvases": 487,
                "../../lib/setcursor": 524,
                "../../lib/svg_text_utils": 529,
                "../../plot_api/subroutines": 544,
                "../../registry": 638,
                "../plots": 619,
                "./axes": 554,
                "./axis_ids": 558,
                "./constants": 561,
                "./scale_zoom": 574,
                "./select": 575,
                "@plotly/d3": 58,
                "has-passive-events": 229,
                tinycolor2: 312
            }
        ],
        564: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/fx"), a = t1("../../components/dragelement"), o = t1("../../lib/setcursor"), s = t1("./dragbox").makeDragBox, l = t1("./constants").DRAGGERSIZE;
                r.initInteractions = function(t1) {
                    var e1 = t1._fullLayout;
                    if (t1._context.staticPlot) n.select(t1).selectAll(".drag").remove();
                    else if (e1._has("cartesian") || e1._has("splom")) {
                        Object.keys(e1._plots || {}).sort(function(t1, r) {
                            if ((e1._plots[t1].mainplot && !0) === (e1._plots[r].mainplot && !0)) {
                                var n = t1.split("y"), i = r.split("y");
                                return n[0] === i[0] ? Number(n[1] || 1) - Number(i[1] || 1) : Number(n[0] || 1) - Number(i[0] || 1);
                            }
                            return e1._plots[t1].mainplot ? 1 : -1;
                        }).forEach(function(r) {
                            var n = e1._plots[r], o = n.xaxis, c = n.yaxis;
                            if (!n.mainplot) {
                                var u = s(t1, n, o._offset, c._offset, o._length, c._length, "ns", "ew");
                                u.onmousemove = function(e1) {
                                    t1._fullLayout._rehover = function() {
                                        t1._fullLayout._hoversubplot === r && t1._fullLayout._plots[r] && i.hover(t1, e1, r);
                                    }, i.hover(t1, e1, r), t1._fullLayout._lasthover = u, t1._fullLayout._hoversubplot = r;
                                }, u.onmouseout = function(e1) {
                                    t1._dragging || (t1._fullLayout._hoversubplot = null, a.unhover(t1, e1));
                                }, t1._context.showAxisDragHandles && (s(t1, n, o._offset - l, c._offset - l, l, l, "n", "w"), s(t1, n, o._offset + o._length, c._offset - l, l, l, "n", "e"), s(t1, n, o._offset - l, c._offset + c._length, l, l, "s", "w"), s(t1, n, o._offset + o._length, c._offset + c._length, l, l, "s", "e"));
                            }
                            if (t1._context.showAxisDragHandles) {
                                if (r === o._mainSubplot) {
                                    var f = o._mainLinePosition;
                                    "top" === o.side && (f -= l), s(t1, n, o._offset + .1 * o._length, f, .8 * o._length, l, "", "ew"), s(t1, n, o._offset, f, .1 * o._length, l, "", "w"), s(t1, n, o._offset + .9 * o._length, f, .1 * o._length, l, "", "e");
                                }
                                if (r === c._mainSubplot) {
                                    var h = c._mainLinePosition;
                                    "right" !== c.side && (h -= l), s(t1, n, h, c._offset + .1 * c._length, l, .8 * c._length, "ns", ""), s(t1, n, h, c._offset + .9 * c._length, l, .1 * c._length, "s", ""), s(t1, n, h, c._offset, l, .1 * c._length, "n", "");
                                }
                            }
                        });
                        var o = e1._hoverlayer.node();
                        o.onmousemove = function(r) {
                            r.target = t1._fullLayout._lasthover, i.hover(t1, r, e1._hoversubplot);
                        }, o.onclick = function(e1) {
                            e1.target = t1._fullLayout._lasthover, i.click(t1, e1);
                        }, o.onmousedown = function(e1) {
                            t1._fullLayout._lasthover.onmousedown(e1);
                        }, r.updateFx(t1);
                    }
                }, r.updateFx = function(t1) {
                    var e1 = t1._fullLayout, r = "pan" === e1.dragmode ? "move" : "crosshair";
                    o(e1._draggers, r);
                };
            },
            {
                "../../components/dragelement": 385,
                "../../components/fx": 406,
                "../../lib/setcursor": 524,
                "./constants": 561,
                "./dragbox": 563,
                "@plotly/d3": 58
            }
        ],
        565: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    clearOutlineControllers: function(t1) {
                        var e1 = t1._fullLayout._zoomlayer;
                        e1 && e1.selectAll(".outline-controllers").remove();
                    },
                    clearSelect: function(t1) {
                        var e1 = t1._fullLayout._zoomlayer;
                        e1 && e1.selectAll(".select-outline").remove(), t1._fullLayout._drawing = !1;
                    }
                };
            },
            {}
        ],
        566: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").strTranslate;
                function i(t1, e1) {
                    switch(t1.type){
                        case "log":
                            return t1.p2d(e1);
                        case "date":
                            return t1.p2r(e1, 0, t1.calendar);
                        default:
                            return t1.p2r(e1);
                    }
                }
                e1.exports = {
                    p2r: i,
                    r2p: function(t1, e1) {
                        switch(t1.type){
                            case "log":
                                return t1.d2p(e1);
                            case "date":
                                return t1.r2p(e1, 0, t1.calendar);
                            default:
                                return t1.r2p(e1);
                        }
                    },
                    axValue: function(t1) {
                        var e1 = "y" === t1._id.charAt(0) ? 1 : 0;
                        return function(r) {
                            return i(t1, r[e1]);
                        };
                    },
                    getTransform: function(t1) {
                        return n(t1.xaxis._offset, t1.yaxis._offset);
                    }
                };
            },
            {
                "../../lib": 503
            }
        ],
        567: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib"), a = t1("./axis_ids");
                e1.exports = function(t1) {
                    return function(e1, r) {
                        var o = e1[t1];
                        if (Array.isArray(o)) for(var s = n.subplotsRegistry.cartesian, l = s.idRegex, c = r._subplots, u = c.xaxis, f = c.yaxis, h = c.cartesian, p = r._has("cartesian") || r._has("gl2d"), d = 0; d < o.length; d++){
                            var m = o[d];
                            if (i.isPlainObject(m)) {
                                var g = a.cleanId(m.xref, "x", !1), v = a.cleanId(m.yref, "y", !1), y = l.x.test(g), x = l.y.test(v);
                                if (y || x) {
                                    p || i.pushUnique(r._basePlotModules, s);
                                    var b = !1;
                                    y && -1 === u.indexOf(g) && (u.push(g), b = !0), x && -1 === f.indexOf(v) && (f.push(v), b = !0), b && y && x && h.push(g + v);
                                }
                            }
                        }
                    };
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638,
                "./axis_ids": 558
            }
        ],
        568: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../registry"), a = t1("../../lib"), o = t1("../plots"), s = t1("../../components/drawing"), l = t1("../get_data").getModuleCalcData, c = t1("./axis_ids"), u = t1("./constants"), f = t1("../../constants/xmlns_namespaces"), h = a.ensureSingle;
                function p(t1, e1, r) {
                    return a.ensureSingle(t1, e1, r, function(t1) {
                        t1.datum(r);
                    });
                }
                function d(t1, e1, r, a, o) {
                    for(var c, f, h, p = u.traceLayerClasses, d = t1._fullLayout, m = d._modules, g = [], v = [], y = 0; y < m.length; y++){
                        var x = (c = m[y]).name, b = i.modules[x].categories;
                        if (b.svg) {
                            var _ = c.layerName || x + "layer", w = c.plot;
                            h = (f = l(r, w))[0], r = f[1], h.length && g.push({
                                i: p.indexOf(_),
                                className: _,
                                plotMethod: w,
                                cdModule: h
                            }), b.zoomScale && v.push("." + _);
                        }
                    }
                    g.sort(function(t1, e1) {
                        return t1.i - e1.i;
                    });
                    var T = e1.plot.selectAll("g.mlayer").data(g, function(t1) {
                        return t1.className;
                    });
                    if (T.enter().append("g").attr("class", function(t1) {
                        return t1.className;
                    }).classed("mlayer", !0).classed("rangeplot", e1.isRangePlot), T.exit().remove(), T.order(), T.each(function(r) {
                        var i = n.select(this), l = r.className;
                        r.plotMethod(t1, e1, r.cdModule, i, a, o), -1 === u.clipOnAxisFalseQuery.indexOf("." + l) && s.setClipUrl(i, e1.layerClipId, t1);
                    }), d._has("scattergl") && (c = i.getModule("scattergl"), h = l(r, c)[0], c.plot(t1, e1, h)), !t1._context.staticPlot && (e1._hasClipOnAxisFalse && (e1.clipOnAxisFalseTraces = e1.plot.selectAll(u.clipOnAxisFalseQuery.join(",")).selectAll(".trace")), v.length)) {
                        var k = e1.plot.selectAll(v.join(",")).selectAll(".trace");
                        e1.zoomScalePts = k.selectAll("path.point"), e1.zoomScaleTxt = k.selectAll(".textpoint");
                    }
                }
                function m(t1, e1) {
                    var r = e1.plotgroup, n = e1.id, i = u.layerValue2layerClass[e1.xaxis.layer], a = u.layerValue2layerClass[e1.yaxis.layer], o = t1._fullLayout._hasOnlyLargeSploms;
                    if (e1.mainplot) {
                        var s = e1.mainplotinfo, l = s.plotgroup, f = n + "-x", d = n + "-y";
                        e1.gridlayer = s.gridlayer, e1.zerolinelayer = s.zerolinelayer, h(s.overlinesBelow, "path", f), h(s.overlinesBelow, "path", d), h(s.overaxesBelow, "g", f), h(s.overaxesBelow, "g", d), e1.plot = h(s.overplot, "g", n), h(s.overlinesAbove, "path", f), h(s.overlinesAbove, "path", d), h(s.overaxesAbove, "g", f), h(s.overaxesAbove, "g", d), e1.xlines = l.select(".overlines-" + i).select("." + f), e1.ylines = l.select(".overlines-" + a).select("." + d), e1.xaxislayer = l.select(".overaxes-" + i).select("." + f), e1.yaxislayer = l.select(".overaxes-" + a).select("." + d);
                    } else if (o) e1.xlines = h(r, "path", "xlines-above"), e1.ylines = h(r, "path", "ylines-above"), e1.xaxislayer = h(r, "g", "xaxislayer-above"), e1.yaxislayer = h(r, "g", "yaxislayer-above");
                    else {
                        var m = h(r, "g", "layer-subplot");
                        e1.shapelayer = h(m, "g", "shapelayer"), e1.imagelayer = h(m, "g", "imagelayer"), e1.gridlayer = h(r, "g", "gridlayer"), e1.zerolinelayer = h(r, "g", "zerolinelayer"), h(r, "path", "xlines-below"), h(r, "path", "ylines-below"), e1.overlinesBelow = h(r, "g", "overlines-below"), h(r, "g", "xaxislayer-below"), h(r, "g", "yaxislayer-below"), e1.overaxesBelow = h(r, "g", "overaxes-below"), e1.plot = h(r, "g", "plot"), e1.overplot = h(r, "g", "overplot"), e1.xlines = h(r, "path", "xlines-above"), e1.ylines = h(r, "path", "ylines-above"), e1.overlinesAbove = h(r, "g", "overlines-above"), h(r, "g", "xaxislayer-above"), h(r, "g", "yaxislayer-above"), e1.overaxesAbove = h(r, "g", "overaxes-above"), e1.xlines = r.select(".xlines-" + i), e1.ylines = r.select(".ylines-" + a), e1.xaxislayer = r.select(".xaxislayer-" + i), e1.yaxislayer = r.select(".yaxislayer-" + a);
                    }
                    o || (p(e1.gridlayer, "g", e1.xaxis._id), p(e1.gridlayer, "g", e1.yaxis._id), e1.gridlayer.selectAll("g").map(function(t1) {
                        return t1[0];
                    }).sort(c.idSort)), e1.xlines.style("fill", "none").classed("crisp", !0), e1.ylines.style("fill", "none").classed("crisp", !0);
                }
                function g(t1, e1) {
                    if (t1) {
                        var r = {};
                        for(var i in t1.each(function(t1) {
                            var i = t1[0];
                            n.select(this).remove(), v(i, e1), r[i] = !0;
                        }), e1._plots)for(var a = e1._plots[i].overlays || [], o = 0; o < a.length; o++){
                            var s = a[o];
                            r[s.id] && s.plot.selectAll(".trace").remove();
                        }
                    }
                }
                function v(t1, e1) {
                    e1._draggers.selectAll("g." + t1).remove(), e1._defs.select("#clip" + e1._uid + t1 + "plot").remove();
                }
                r.name = "cartesian", r.attr = [
                    "xaxis",
                    "yaxis"
                ], r.idRoot = [
                    "x",
                    "y"
                ], r.idRegex = u.idRegex, r.attrRegex = u.attrRegex, r.attributes = t1("./attributes"), r.layoutAttributes = t1("./layout_attributes"), r.supplyLayoutDefaults = t1("./layout_defaults"), r.transitionAxes = t1("./transition_axes"), r.finalizeSubplots = function(t1, e1) {
                    var r, n, i, o = e1._subplots, s = o.xaxis, l = o.yaxis, f = o.cartesian, h = f.concat(o.gl2d || []), p = {}, d = {};
                    for(r = 0; r < h.length; r++){
                        var m = h[r].split("y");
                        p[m[0]] = 1, d["y" + m[1]] = 1;
                    }
                    for(r = 0; r < s.length; r++)p[n = s[r]] || (i = (t1[c.id2name(n)] || {}).anchor, u.idRegex.y.test(i) || (i = "y"), f.push(n + i), h.push(n + i), d[i] || (d[i] = 1, a.pushUnique(l, i)));
                    for(r = 0; r < l.length; r++)d[i = l[r]] || (n = (t1[c.id2name(i)] || {}).anchor, u.idRegex.x.test(n) || (n = "x"), f.push(n + i), h.push(n + i), p[n] || (p[n] = 1, a.pushUnique(s, n)));
                    if (!h.length) {
                        for(var g in n = "", i = "", t1)if (u.attrRegex.test(g)) "x" === g.charAt(0) ? (!n || +g.substr(5) < +n.substr(5)) && (n = g) : (!i || +g.substr(5) < +i.substr(5)) && (i = g);
                        n = n ? c.name2id(n) : "x", i = i ? c.name2id(i) : "y", s.push(n), l.push(i), f.push(n + i);
                    }
                }, r.plot = function(t1, e1, r, n) {
                    var i, a = t1._fullLayout, o = a._subplots.cartesian, s = t1.calcdata;
                    if (!Array.isArray(e1)) for(e1 = [], i = 0; i < s.length; i++)e1.push(i);
                    for(i = 0; i < o.length; i++){
                        for(var l, c = o[i], u = a._plots[c], f = [], h = 0; h < s.length; h++){
                            var p = s[h], m = p[0].trace;
                            m.xaxis + m.yaxis === c && ((-1 !== e1.indexOf(m.index) || m.carpet) && (l && l[0].trace.xaxis + l[0].trace.yaxis === c && -1 !== [
                                "tonextx",
                                "tonexty",
                                "tonext"
                            ].indexOf(m.fill) && -1 === f.indexOf(l) && f.push(l), f.push(p)), l = p);
                        }
                        d(t1, u, f, r, n);
                    }
                }, r.clean = function(t1, e1, r, n) {
                    var i, a, o, s = n._plots || {}, l = e1._plots || {}, u = n._subplots || {};
                    if (n._hasOnlyLargeSploms && !e1._hasOnlyLargeSploms) for(o in s)(i = s[o]).plotgroup && i.plotgroup.remove();
                    var f = n._has && n._has("gl"), h = e1._has && e1._has("gl");
                    if (f && !h) for(o in s)(i = s[o])._scene && i._scene.destroy();
                    if (u.xaxis && u.yaxis) {
                        var p = c.listIds({
                            _fullLayout: n
                        });
                        for(a = 0; a < p.length; a++){
                            var d = p[a];
                            e1[c.id2name(d)] || n._infolayer.selectAll(".g-" + d + "title").remove();
                        }
                    }
                    var m = n._has && n._has("cartesian"), y = e1._has && e1._has("cartesian");
                    if (m && !y) g(n._cartesianlayer.selectAll(".subplot"), n), n._defs.selectAll(".axesclip").remove(), delete n._axisConstraintGroups, delete n._axisMatchGroups;
                    else if (u.cartesian) for(a = 0; a < u.cartesian.length; a++){
                        var x = u.cartesian[a];
                        if (!l[x]) {
                            var b = "." + x + ",." + x + "-x,." + x + "-y";
                            n._cartesianlayer.selectAll(b).remove(), v(x, n);
                        }
                    }
                }, r.drawFramework = function(t1) {
                    var e1 = t1._fullLayout, r = function(t1) {
                        var e1, r, n, i, a, o, s = t1._fullLayout, l = s._subplots.cartesian, c = l.length, u = [], f = [];
                        for(e1 = 0; e1 < c; e1++){
                            n = l[e1], i = s._plots[n], a = i.xaxis, o = i.yaxis;
                            var h = a._mainAxis, p = o._mainAxis, d = h._id + p._id, m = s._plots[d];
                            i.overlays = [], d !== n && m ? (i.mainplot = d, i.mainplotinfo = m, f.push(n)) : (i.mainplot = void 0, i.mainplotinfo = void 0, u.push(n));
                        }
                        for(e1 = 0; e1 < f.length; e1++)n = f[e1], (i = s._plots[n]).mainplotinfo.overlays.push(i);
                        var g = u.concat(f), v = new Array(c);
                        for(e1 = 0; e1 < c; e1++){
                            n = g[e1], i = s._plots[n], a = i.xaxis, o = i.yaxis;
                            var y = [
                                n,
                                a.layer,
                                o.layer,
                                a.overlaying || "",
                                o.overlaying || ""
                            ];
                            for(r = 0; r < i.overlays.length; r++)y.push(i.overlays[r].id);
                            v[e1] = y;
                        }
                        return v;
                    }(t1), i = e1._cartesianlayer.selectAll(".subplot").data(r, String);
                    i.enter().append("g").attr("class", function(t1) {
                        return "subplot " + t1[0];
                    }), i.order(), i.exit().call(g, e1), i.each(function(r) {
                        var i = r[0], a = e1._plots[i];
                        a.plotgroup = n.select(this), m(t1, a), a.draglayer = h(e1._draggers, "g", i);
                    });
                }, r.rangePlot = function(t1, e1, r) {
                    m(t1, e1), d(t1, e1, r), o.style(t1);
                }, r.toSVG = function(t1) {
                    var e1 = t1._fullLayout._glimages, r = n.select(t1).selectAll(".svg-container");
                    r.filter(function(t1, e1) {
                        return e1 === r.size() - 1;
                    }).selectAll(".gl-canvas-context, .gl-canvas-focus").each(function() {
                        var t1 = this.toDataURL("image/png");
                        e1.append("svg:image").attr({
                            xmlns: f.svg,
                            "xlink:href": t1,
                            preserveAspectRatio: "none",
                            x: 0,
                            y: 0,
                            width: this.style.width,
                            height: this.style.height
                        });
                    });
                }, r.updateFx = t1("./graph_interact").updateFx;
            },
            {
                "../../components/drawing": 388,
                "../../constants/xmlns_namespaces": 480,
                "../../lib": 503,
                "../../registry": 638,
                "../get_data": 593,
                "../plots": 619,
                "./attributes": 552,
                "./axis_ids": 558,
                "./constants": 561,
                "./graph_interact": 564,
                "./layout_attributes": 569,
                "./layout_defaults": 570,
                "./transition_axes": 581,
                "@plotly/d3": 58
            }
        ],
        569: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../font_attributes"), i = t1("../../components/color/attributes"), a = t1("../../components/drawing/attributes").dash, o = t1("../../lib/extend").extendFlat, s = t1("../../plot_api/plot_template").templatedArray, l = t1("../../plots/cartesian/axis_format_attributes").descriptionWithDates, c = t1("../../constants/numerical").ONEDAY, u = t1("./constants"), f = u.HOUR_PATTERN, h = u.WEEKDAY_PATTERN;
                e1.exports = {
                    visible: {
                        valType: "boolean",
                        editType: "plot"
                    },
                    color: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "ticks"
                    },
                    title: {
                        text: {
                            valType: "string",
                            editType: "ticks"
                        },
                        font: n({
                            editType: "ticks"
                        }),
                        standoff: {
                            valType: "number",
                            min: 0,
                            editType: "ticks"
                        },
                        editType: "ticks"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "-",
                            "linear",
                            "log",
                            "date",
                            "category",
                            "multicategory"
                        ],
                        dflt: "-",
                        editType: "calc",
                        _noTemplating: !0
                    },
                    autotypenumbers: {
                        valType: "enumerated",
                        values: [
                            "convert types",
                            "strict"
                        ],
                        dflt: "convert types",
                        editType: "calc"
                    },
                    autorange: {
                        valType: "enumerated",
                        values: [
                            !0,
                            !1,
                            "reversed"
                        ],
                        dflt: !0,
                        editType: "axrange",
                        impliedEdits: {
                            "range[0]": void 0,
                            "range[1]": void 0
                        }
                    },
                    rangemode: {
                        valType: "enumerated",
                        values: [
                            "normal",
                            "tozero",
                            "nonnegative"
                        ],
                        dflt: "normal",
                        editType: "plot"
                    },
                    range: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "axrange",
                                impliedEdits: {
                                    "^autorange": !1
                                },
                                anim: !0
                            },
                            {
                                valType: "any",
                                editType: "axrange",
                                impliedEdits: {
                                    "^autorange": !1
                                },
                                anim: !0
                            }
                        ],
                        editType: "axrange",
                        impliedEdits: {
                            autorange: !1
                        },
                        anim: !0
                    },
                    fixedrange: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    scaleanchor: {
                        valType: "enumerated",
                        values: [
                            u.idRegex.x.toString(),
                            u.idRegex.y.toString()
                        ],
                        editType: "plot"
                    },
                    scaleratio: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "plot"
                    },
                    constrain: {
                        valType: "enumerated",
                        values: [
                            "range",
                            "domain"
                        ],
                        editType: "plot"
                    },
                    constraintoward: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        editType: "plot"
                    },
                    matches: {
                        valType: "enumerated",
                        values: [
                            u.idRegex.x.toString(),
                            u.idRegex.y.toString()
                        ],
                        editType: "calc"
                    },
                    rangebreaks: s("rangebreak", {
                        enabled: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "calc"
                        },
                        bounds: {
                            valType: "info_array",
                            items: [
                                {
                                    valType: "any",
                                    editType: "calc"
                                },
                                {
                                    valType: "any",
                                    editType: "calc"
                                }
                            ],
                            editType: "calc"
                        },
                        pattern: {
                            valType: "enumerated",
                            values: [
                                h,
                                f,
                                ""
                            ],
                            editType: "calc"
                        },
                        values: {
                            valType: "info_array",
                            freeLength: !0,
                            editType: "calc",
                            items: {
                                valType: "any",
                                editType: "calc"
                            }
                        },
                        dvalue: {
                            valType: "number",
                            editType: "calc",
                            min: 0,
                            dflt: c
                        },
                        editType: "calc"
                    }),
                    tickmode: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "linear",
                            "array"
                        ],
                        editType: "ticks",
                        impliedEdits: {
                            tick0: void 0,
                            dtick: void 0
                        }
                    },
                    nticks: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "ticks"
                    },
                    tick0: {
                        valType: "any",
                        editType: "ticks",
                        impliedEdits: {
                            tickmode: "linear"
                        }
                    },
                    dtick: {
                        valType: "any",
                        editType: "ticks",
                        impliedEdits: {
                            tickmode: "linear"
                        }
                    },
                    tickvals: {
                        valType: "data_array",
                        editType: "ticks"
                    },
                    ticktext: {
                        valType: "data_array",
                        editType: "ticks"
                    },
                    ticks: {
                        valType: "enumerated",
                        values: [
                            "outside",
                            "inside",
                            ""
                        ],
                        editType: "ticks"
                    },
                    tickson: {
                        valType: "enumerated",
                        values: [
                            "labels",
                            "boundaries"
                        ],
                        dflt: "labels",
                        editType: "ticks"
                    },
                    ticklabelmode: {
                        valType: "enumerated",
                        values: [
                            "instant",
                            "period"
                        ],
                        dflt: "instant",
                        editType: "ticks"
                    },
                    ticklabelposition: {
                        valType: "enumerated",
                        values: [
                            "outside",
                            "inside",
                            "outside top",
                            "inside top",
                            "outside left",
                            "inside left",
                            "outside right",
                            "inside right",
                            "outside bottom",
                            "inside bottom"
                        ],
                        dflt: "outside",
                        editType: "calc"
                    },
                    ticklabeloverflow: {
                        valType: "enumerated",
                        values: [
                            "allow",
                            "hide past div",
                            "hide past domain"
                        ],
                        editType: "calc"
                    },
                    mirror: {
                        valType: "enumerated",
                        values: [
                            !0,
                            "ticks",
                            !1,
                            "all",
                            "allticks"
                        ],
                        dflt: !1,
                        editType: "ticks+layoutstyle"
                    },
                    ticklen: {
                        valType: "number",
                        min: 0,
                        dflt: 5,
                        editType: "ticks"
                    },
                    tickwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "ticks"
                    },
                    tickcolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "ticks"
                    },
                    showticklabels: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "ticks"
                    },
                    automargin: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "ticks"
                    },
                    showspikes: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "modebar"
                    },
                    spikecolor: {
                        valType: "color",
                        dflt: null,
                        editType: "none"
                    },
                    spikethickness: {
                        valType: "number",
                        dflt: 3,
                        editType: "none"
                    },
                    spikedash: o({}, a, {
                        dflt: "dash",
                        editType: "none"
                    }),
                    spikemode: {
                        valType: "flaglist",
                        flags: [
                            "toaxis",
                            "across",
                            "marker"
                        ],
                        dflt: "toaxis",
                        editType: "none"
                    },
                    spikesnap: {
                        valType: "enumerated",
                        values: [
                            "data",
                            "cursor",
                            "hovered data"
                        ],
                        dflt: "hovered data",
                        editType: "none"
                    },
                    tickfont: n({
                        editType: "ticks"
                    }),
                    tickangle: {
                        valType: "angle",
                        dflt: "auto",
                        editType: "ticks"
                    },
                    tickprefix: {
                        valType: "string",
                        dflt: "",
                        editType: "ticks"
                    },
                    showtickprefix: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "ticks"
                    },
                    ticksuffix: {
                        valType: "string",
                        dflt: "",
                        editType: "ticks"
                    },
                    showticksuffix: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "ticks"
                    },
                    showexponent: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "ticks"
                    },
                    exponentformat: {
                        valType: "enumerated",
                        values: [
                            "none",
                            "e",
                            "E",
                            "power",
                            "SI",
                            "B"
                        ],
                        dflt: "B",
                        editType: "ticks"
                    },
                    minexponent: {
                        valType: "number",
                        dflt: 3,
                        min: 0,
                        editType: "ticks"
                    },
                    separatethousands: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "ticks"
                    },
                    tickformat: {
                        valType: "string",
                        dflt: "",
                        editType: "ticks",
                        description: l("tick label")
                    },
                    tickformatstops: s("tickformatstop", {
                        enabled: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "ticks"
                        },
                        dtickrange: {
                            valType: "info_array",
                            items: [
                                {
                                    valType: "any",
                                    editType: "ticks"
                                },
                                {
                                    valType: "any",
                                    editType: "ticks"
                                }
                            ],
                            editType: "ticks"
                        },
                        value: {
                            valType: "string",
                            dflt: "",
                            editType: "ticks"
                        },
                        editType: "ticks"
                    }),
                    hoverformat: {
                        valType: "string",
                        dflt: "",
                        editType: "none",
                        description: l("hover text")
                    },
                    showline: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "ticks+layoutstyle"
                    },
                    linecolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "layoutstyle"
                    },
                    linewidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "ticks+layoutstyle"
                    },
                    showgrid: {
                        valType: "boolean",
                        editType: "ticks"
                    },
                    gridcolor: {
                        valType: "color",
                        dflt: i.lightLine,
                        editType: "ticks"
                    },
                    gridwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "ticks"
                    },
                    zeroline: {
                        valType: "boolean",
                        editType: "ticks"
                    },
                    zerolinecolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "ticks"
                    },
                    zerolinewidth: {
                        valType: "number",
                        dflt: 1,
                        editType: "ticks"
                    },
                    showdividers: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "ticks"
                    },
                    dividercolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "ticks"
                    },
                    dividerwidth: {
                        valType: "number",
                        dflt: 1,
                        editType: "ticks"
                    },
                    anchor: {
                        valType: "enumerated",
                        values: [
                            "free",
                            u.idRegex.x.toString(),
                            u.idRegex.y.toString()
                        ],
                        editType: "plot"
                    },
                    side: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "bottom",
                            "left",
                            "right"
                        ],
                        editType: "plot"
                    },
                    overlaying: {
                        valType: "enumerated",
                        values: [
                            "free",
                            u.idRegex.x.toString(),
                            u.idRegex.y.toString()
                        ],
                        editType: "plot"
                    },
                    layer: {
                        valType: "enumerated",
                        values: [
                            "above traces",
                            "below traces"
                        ],
                        dflt: "above traces",
                        editType: "plot"
                    },
                    domain: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: "plot"
                            },
                            {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: "plot"
                            }
                        ],
                        dflt: [
                            0,
                            1
                        ],
                        editType: "plot"
                    },
                    position: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "plot"
                    },
                    categoryorder: {
                        valType: "enumerated",
                        values: [
                            "trace",
                            "category ascending",
                            "category descending",
                            "array",
                            "total ascending",
                            "total descending",
                            "min ascending",
                            "min descending",
                            "max ascending",
                            "max descending",
                            "sum ascending",
                            "sum descending",
                            "mean ascending",
                            "mean descending",
                            "median ascending",
                            "median descending"
                        ],
                        dflt: "trace",
                        editType: "calc"
                    },
                    categoryarray: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editType: "calc",
                    _deprecated: {
                        autotick: {
                            valType: "boolean",
                            editType: "ticks"
                        },
                        title: {
                            valType: "string",
                            editType: "ticks"
                        },
                        titlefont: n({
                            editType: "ticks"
                        })
                    }
                };
            },
            {
                "../../components/color/attributes": 365,
                "../../components/drawing/attributes": 387,
                "../../constants/numerical": 479,
                "../../lib/extend": 493,
                "../../plot_api/plot_template": 543,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../font_attributes": 585,
                "./constants": 561
            }
        ],
        570: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/color"), a = t1("../../components/fx/helpers").isUnifiedHover, o = t1("../../components/fx/hovermode_defaults"), s = t1("../../plot_api/plot_template"), l = t1("../layout_attributes"), c = t1("./layout_attributes"), u = t1("./type_defaults"), f = t1("./axis_defaults"), h = t1("./constraints"), p = t1("./position_defaults"), d = t1("./axis_ids"), m = d.id2name, g = d.name2id, v = t1("./constants").AX_ID_PATTERN, y = t1("../../registry"), x = y.traceIs, b = y.getComponentMethod;
                function _(t1, e1, r) {
                    Array.isArray(t1[e1]) ? t1[e1].push(r) : t1[e1] = [
                        r
                    ];
                }
                e1.exports = function(t1, e1, r) {
                    var y, w, T = e1.autotypenumbers, k = {}, A = {}, M = {}, S = {}, E = {}, L = {}, C = {}, P = {}, I = {}, O = {};
                    for(y = 0; y < r.length; y++){
                        var z = r[y];
                        if (x(z, "cartesian") || x(z, "gl2d")) {
                            var D, R;
                            if (z.xaxis) D = m(z.xaxis), _(k, D, z);
                            else if (z.xaxes) for(w = 0; w < z.xaxes.length; w++)_(k, m(z.xaxes[w]), z);
                            if (z.yaxis) R = m(z.yaxis), _(k, R, z);
                            else if (z.yaxes) for(w = 0; w < z.yaxes.length; w++)_(k, m(z.yaxes[w]), z);
                            if ("funnel" === z.type ? "h" === z.orientation ? (D && (A[D] = !0), R && (C[R] = !0)) : R && (M[R] = !0) : "image" === z.type ? (R && (P[R] = !0), D && (P[D] = !0)) : (R && (E[R] = !0, L[R] = !0), x(z, "carpet") && ("carpet" !== z.type || z._cheater) || D && (S[D] = !0)), "carpet" === z.type && z._cheater && D && (A[D] = !0), x(z, "2dMap") && (I[D] = !0, I[R] = !0), x(z, "oriented")) O["h" === z.orientation ? R : D] = !0;
                        }
                    }
                    var F = e1._subplots, B = F.xaxis, N = F.yaxis, j = n.simpleMap(B, m), U = n.simpleMap(N, m), V = j.concat(U), H = i.background;
                    B.length && N.length && (H = n.coerce(t1, e1, l, "plot_bgcolor"));
                    var q, G, Y, W, X, Z = i.combine(H, e1.paper_bgcolor);
                    function J() {
                        var t1 = k[q] || [];
                        X._traceIndices = t1.map(function(t1) {
                            return t1._expandedIndex;
                        }), X._annIndices = [], X._shapeIndices = [], X._imgIndices = [], X._subplotsWith = [], X._counterAxes = [], X._name = X._attr = q, X._id = G;
                    }
                    function K(t1, e1) {
                        return n.coerce(W, X, c, t1, e1);
                    }
                    function Q(t1, e1) {
                        return n.coerce2(W, X, c, t1, e1);
                    }
                    function $(t1) {
                        return "x" === t1 ? N : B;
                    }
                    function tt(e1, r) {
                        for(var n = "x" === e1 ? j : U, i = [], a = 0; a < n.length; a++){
                            var o = n[a];
                            o === r || (t1[o] || {}).overlaying || i.push(g(o));
                        }
                        return i;
                    }
                    var et = {
                        x: $("x"),
                        y: $("y")
                    }, rt = et.x.concat(et.y), nt = {}, it = [];
                    function at() {
                        var t1 = W.matches;
                        v.test(t1) && -1 === rt.indexOf(t1) && (nt[t1] = W.type, it = Object.keys(nt));
                    }
                    var ot = o(t1, e1), st = a(ot);
                    for(y = 0; y < V.length; y++){
                        q = V[y], G = g(q), Y = q.charAt(0), n.isPlainObject(t1[q]) || (t1[q] = {}), W = t1[q], X = s.newContainer(e1, q, Y + "axis"), J();
                        var lt = "x" === Y && !S[q] && A[q] || "y" === Y && !E[q] && M[q], ct = "y" === Y && (!L[q] && C[q] || P[q]), ut = {
                            letter: Y,
                            font: e1.font,
                            outerTicks: I[q],
                            showGrid: !O[q],
                            data: k[q] || [],
                            bgColor: Z,
                            calendar: e1.calendar,
                            automargin: !0,
                            visibleDflt: lt,
                            reverseDflt: ct,
                            autotypenumbersDflt: T,
                            splomStash: ((e1._splomAxes || {})[Y] || {})[G]
                        };
                        K("uirevision", e1.uirevision), u(W, X, K, ut), f(W, X, K, ut, e1);
                        var ft = st && Y === ot.charAt(0), ht = Q("spikecolor", st ? X.color : void 0), pt = Q("spikethickness", st ? 1.5 : void 0), dt = Q("spikedash", st ? "dot" : void 0), mt = Q("spikemode", st ? "across" : void 0), gt = Q("spikesnap");
                        K("showspikes", !!(ft || ht || pt || dt || mt || gt)) || (delete X.spikecolor, delete X.spikethickness, delete X.spikedash, delete X.spikemode, delete X.spikesnap), p(W, X, K, {
                            letter: Y,
                            counterAxes: et[Y],
                            overlayableAxes: tt(Y, q),
                            grid: e1.grid
                        }), K("title.standoff"), at(), X._input = W;
                    }
                    for(y = 0; y < it.length;){
                        G = it[y++], Y = (q = m(G)).charAt(0), n.isPlainObject(t1[q]) || (t1[q] = {}), W = t1[q], X = s.newContainer(e1, q, Y + "axis"), J();
                        var vt = {
                            letter: Y,
                            font: e1.font,
                            outerTicks: I[q],
                            showGrid: !O[q],
                            data: [],
                            bgColor: Z,
                            calendar: e1.calendar,
                            automargin: !0,
                            visibleDflt: !1,
                            reverseDflt: !1,
                            autotypenumbersDflt: T,
                            splomStash: ((e1._splomAxes || {})[Y] || {})[G]
                        };
                        K("uirevision", e1.uirevision), X.type = nt[G] || "linear", f(W, X, K, vt, e1), p(W, X, K, {
                            letter: Y,
                            counterAxes: et[Y],
                            overlayableAxes: tt(Y, q),
                            grid: e1.grid
                        }), K("fixedrange"), at(), X._input = W;
                    }
                    var yt = b("rangeslider", "handleDefaults"), xt = b("rangeselector", "handleDefaults");
                    for(y = 0; y < j.length; y++)q = j[y], W = t1[q], X = e1[q], yt(t1, e1, q), "date" === X.type && xt(W, X, e1, U, X.calendar), K("fixedrange");
                    for(y = 0; y < U.length; y++){
                        q = U[y], W = t1[q], X = e1[q];
                        var bt = e1[m(X.anchor)];
                        K("fixedrange", b("rangeslider", "isVisible")(bt));
                    }
                    h.handleDefaults(t1, e1, {
                        axIds: rt.concat(it).sort(d.idSort),
                        axHasImage: P
                    });
                };
            },
            {
                "../../components/color": 366,
                "../../components/fx/helpers": 402,
                "../../components/fx/hovermode_defaults": 405,
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../../registry": 638,
                "../layout_attributes": 610,
                "./axis_defaults": 556,
                "./axis_ids": 558,
                "./constants": 561,
                "./constraints": 562,
                "./layout_attributes": 569,
                "./position_defaults": 572,
                "./type_defaults": 582
            }
        ],
        571: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("tinycolor2").mix, i = t1("../../components/color/attributes").lightFraction, a = t1("../../lib");
                e1.exports = function(t1, e1, r, o) {
                    var s = (o = o || {}).dfltColor;
                    function l(r, n) {
                        return a.coerce2(t1, e1, o.attributes, r, n);
                    }
                    var c = l("linecolor", s), u = l("linewidth");
                    r("showline", o.showLine || !!c || !!u) || (delete e1.linecolor, delete e1.linewidth);
                    var f = l("gridcolor", n(s, o.bgColor, o.blend || i).toRgbString()), h = l("gridwidth");
                    if (r("showgrid", o.showGrid || !!f || !!h) || (delete e1.gridcolor, delete e1.gridwidth), !o.noZeroLine) {
                        var p = l("zerolinecolor", s), d = l("zerolinewidth");
                        r("zeroline", o.showGrid || !!p || !!d) || (delete e1.zerolinecolor, delete e1.zerolinewidth);
                    }
                };
            },
            {
                "../../components/color/attributes": 365,
                "../../lib": 503,
                tinycolor2: 312
            }
        ],
        572: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib");
                e1.exports = function(t1, e1, r, a) {
                    var o, s, l, c, u = a.counterAxes || [], f = a.overlayableAxes || [], h = a.letter, p = a.grid;
                    p && (s = p._domains[h][p._axisMap[e1._id]], o = p._anchors[e1._id], s && (l = p[h + "side"].split(" ")[0], c = p.domain[h]["right" === l || "top" === l ? 1 : 0])), s = s || [
                        0,
                        1
                    ], o = o || (n(t1.position) ? "free" : u[0] || "free"), l = l || ("x" === h ? "bottom" : "left"), c = c || 0, "free" === i.coerce(t1, e1, {
                        anchor: {
                            valType: "enumerated",
                            values: [
                                "free"
                            ].concat(u),
                            dflt: o
                        }
                    }, "anchor") && r("position", c), i.coerce(t1, e1, {
                        side: {
                            valType: "enumerated",
                            values: "x" === h ? [
                                "bottom",
                                "top"
                            ] : [
                                "left",
                                "right"
                            ],
                            dflt: l
                        }
                    }, "side");
                    var d = !1;
                    if (f.length && (d = i.coerce(t1, e1, {
                        overlaying: {
                            valType: "enumerated",
                            values: [
                                !1
                            ].concat(f),
                            dflt: !1
                        }
                    }, "overlaying")), !d) {
                        var m = r("domain", s);
                        m[0] > m[1] - 1 / 4096 && (e1.domain = s), i.noneOrAll(t1.domain, e1.domain, s);
                    }
                    return r("layer"), e1;
                };
            },
            {
                "../../lib": 503,
                "fast-isnumeric": 190
            }
        ],
        573: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./show_dflt");
                e1.exports = function(t1, e1, r, i, a) {
                    a || (a = {});
                    var o = a.tickSuffixDflt, s = n(t1);
                    r("tickprefix") && r("showtickprefix", s), r("ticksuffix", o) && r("showticksuffix", s);
                };
            },
            {
                "./show_dflt": 577
            }
        ],
        574: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../constants/alignment").FROM_BL;
                e1.exports = function(t1, e1, r) {
                    void 0 === r && (r = n[t1.constraintoward || "center"]);
                    var i = [
                        t1.r2l(t1.range[0]),
                        t1.r2l(t1.range[1])
                    ], a = i[0] + (i[1] - i[0]) * r;
                    t1.range = t1._input.range = [
                        t1.l2r(a + (i[0] - a) * e1),
                        t1.l2r(a + (i[1] - a) * e1)
                    ], t1.setScale();
                };
            },
            {
                "../../constants/alignment": 471
            }
        ],
        575: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("polybooljs"), i = t1("../../registry"), a = t1("../../components/drawing").dashStyle, o = t1("../../components/color"), s = t1("../../components/fx"), l = t1("../../components/fx/helpers").makeEventData, c = t1("../../components/dragelement/helpers"), u = c.freeMode, f = c.rectMode, h = c.drawMode, p = c.openMode, d = c.selectMode, m = t1("../../components/shapes/draw_newshape/display_outlines"), g = t1("../../components/shapes/draw_newshape/helpers").handleEllipse, v = t1("../../components/shapes/draw_newshape/newshapes"), y = t1("../../lib"), x = t1("../../lib/polygon"), b = t1("../../lib/throttle"), _ = t1("./axis_ids").getFromId, w = t1("../../lib/clear_gl_canvases"), T = t1("../../plot_api/subroutines").redrawReglTraces, k = t1("./constants"), A = k.MINSELECT, M = x.filter, S = x.tester, E = t1("./handle_outline").clearSelect, L = t1("./helpers"), C = L.p2r, P = L.axValue, I = L.getTransform;
                function O(t1, e1, r, n, i, a, o) {
                    var s, l, c, u, f, h, d, g, v, y = e1._hoverdata, x = e1._fullLayout.clickmode.indexOf("event") > -1, b = [];
                    if (function(t1) {
                        return t1 && Array.isArray(t1) && !0 !== t1[0].hoverOnBox;
                    }(y)) {
                        F(t1, e1, a);
                        var _ = function(t1, e1) {
                            var r, n, i = t1[0], a = -1, o = [];
                            for(n = 0; n < e1.length; n++)if (r = e1[n], i.fullData._expandedIndex === r.cd[0].trace._expandedIndex) {
                                if (!0 === i.hoverOnBox) break;
                                void 0 !== i.pointNumber ? a = i.pointNumber : void 0 !== i.binNumber && (a = i.binNumber, o = i.pointNumbers);
                                break;
                            }
                            return {
                                pointNumber: a,
                                pointNumbers: o,
                                searchInfo: r
                            };
                        }(y, s = N(e1, r, n, i));
                        if (_.pointNumbers.length > 0 ? function(t1, e1) {
                            var r, n, i, a = [];
                            for(i = 0; i < t1.length; i++)(r = t1[i]).cd[0].trace.selectedpoints && r.cd[0].trace.selectedpoints.length > 0 && a.push(r);
                            if (1 === a.length && a[0] === e1.searchInfo && (n = e1.searchInfo.cd[0].trace).selectedpoints.length === e1.pointNumbers.length) {
                                for(i = 0; i < e1.pointNumbers.length; i++)if (n.selectedpoints.indexOf(e1.pointNumbers[i]) < 0) return !1;
                                return !0;
                            }
                            return !1;
                        }(s, _) : function(t1) {
                            var e1, r, n, i = 0;
                            for(n = 0; n < t1.length; n++)if (e1 = t1[n], (r = e1.cd[0].trace).selectedpoints) {
                                if (r.selectedpoints.length > 1) return !1;
                                if ((i += r.selectedpoints.length) > 1) return !1;
                            }
                            return 1 === i;
                        }(s) && (h = j(_))) {
                            for(o && o.remove(), v = 0; v < s.length; v++)(l = s[v])._module.selectPoints(l, !1);
                            U(e1, s), B(a), x && e1.emit("plotly_deselect", null);
                        } else {
                            for(d = t1.shiftKey && (void 0 !== h ? h : j(_)), c = function(t1, e1, r) {
                                return {
                                    pointNumber: t1,
                                    searchInfo: e1,
                                    subtract: r
                                };
                            }(_.pointNumber, _.searchInfo, d), u = R(a.selectionDefs.concat([
                                c
                            ])), v = 0; v < s.length; v++)if (f = V(s[v]._module.selectPoints(s[v], u), s[v]), b.length) for(var w = 0; w < f.length; w++)b.push(f[w]);
                            else b = f;
                            if (U(e1, s, g = {
                                points: b
                            }), c && a && a.selectionDefs.push(c), o) {
                                var T = a.mergedPolygons, k = p(a.dragmode);
                                m(H(T, k), o, a);
                            }
                            x && e1.emit("plotly_selected", g);
                        }
                    }
                }
                function z(t1) {
                    return "pointNumber" in t1 && "searchInfo" in t1;
                }
                function D(t1) {
                    return {
                        xmin: 0,
                        xmax: 0,
                        ymin: 0,
                        ymax: 0,
                        pts: [],
                        contains: function(e1, r, n, i) {
                            var a = t1.searchInfo.cd[0].trace._expandedIndex;
                            return i.cd[0].trace._expandedIndex === a && n === t1.pointNumber;
                        },
                        isRect: !1,
                        degenerate: !1,
                        subtract: t1.subtract
                    };
                }
                function R(t1) {
                    for(var e1 = [], r = z(t1[0]) ? 0 : t1[0][0][0], n = r, i = z(t1[0]) ? 0 : t1[0][0][1], a = i, o = 0; o < t1.length; o++)if (z(t1[o])) e1.push(D(t1[o]));
                    else {
                        var s = x.tester(t1[o]);
                        s.subtract = t1[o].subtract, e1.push(s), r = Math.min(r, s.xmin), n = Math.max(n, s.xmax), i = Math.min(i, s.ymin), a = Math.max(a, s.ymax);
                    }
                    return {
                        xmin: r,
                        xmax: n,
                        ymin: i,
                        ymax: a,
                        pts: [],
                        contains: function(t1, r, n, i) {
                            for(var a = !1, o = 0; o < e1.length; o++)e1[o].contains(t1, r, n, i) && (a = !1 === e1[o].subtract);
                            return a;
                        },
                        isRect: !1,
                        degenerate: !1
                    };
                }
                function F(t1, e1, r) {
                    e1._fullLayout._drawing = !1;
                    var n = e1._fullLayout, i = r.plotinfo, a = r.dragmode, o = n._lastSelectedSubplot && n._lastSelectedSubplot === i.id, s = (t1.shiftKey || t1.altKey) && !(h(a) && p(a));
                    o && s && i.selection && i.selection.selectionDefs && !r.selectionDefs ? (r.selectionDefs = i.selection.selectionDefs, r.mergedPolygons = i.selection.mergedPolygons) : s && i.selection || B(r), o || (E(e1), n._lastSelectedSubplot = i.id);
                }
                function B(t1) {
                    var e1 = t1.dragmode, r = t1.plotinfo, n = t1.gd;
                    if (n._fullLayout._activeShapeIndex >= 0 && n._fullLayout._deactivateShape(n), h(e1)) {
                        var a = n._fullLayout._zoomlayer.selectAll(".select-outline-" + r.id);
                        if (a && n._fullLayout._drawing) {
                            var o = v(a, t1);
                            o && i.call("_guiRelayout", n, {
                                shapes: o
                            }), n._fullLayout._drawing = !1;
                        }
                    }
                    r.selection = {}, r.selection.selectionDefs = t1.selectionDefs = [], r.selection.mergedPolygons = t1.mergedPolygons = [];
                }
                function N(t1, e1, r, n) {
                    var i, a, o, s = [], l = e1.map(function(t1) {
                        return t1._id;
                    }), c = r.map(function(t1) {
                        return t1._id;
                    });
                    for(o = 0; o < t1.calcdata.length; o++)if (!0 === (a = (i = t1.calcdata[o])[0].trace).visible && a._module && a._module.selectPoints) {
                        if (!n || a.subplot !== n && a.geo !== n) {
                            if ("splom" === a.type && a._xaxes[l[0]] && a._yaxes[c[0]]) {
                                var u = h(a._module, i, e1[0], r[0]);
                                u.scene = t1._fullLayout._splomScenes[a.uid], s.push(u);
                            } else if ("sankey" === a.type) {
                                var f = h(a._module, i, e1[0], r[0]);
                                s.push(f);
                            } else {
                                if (-1 === l.indexOf(a.xaxis)) continue;
                                if (-1 === c.indexOf(a.yaxis)) continue;
                                s.push(h(a._module, i, _(t1, a.xaxis), _(t1, a.yaxis)));
                            }
                        } else s.push(h(a._module, i, e1[0], r[0]));
                    }
                    return s;
                    function h(t1, e1, r, n) {
                        return {
                            _module: t1,
                            cd: e1,
                            xaxis: r,
                            yaxis: n
                        };
                    }
                }
                function j(t1) {
                    var e1 = t1.searchInfo.cd[0].trace, r = t1.pointNumber, n = t1.pointNumbers, i = n.length > 0 ? n[0] : r;
                    return !!e1.selectedpoints && e1.selectedpoints.indexOf(i) > -1;
                }
                function U(t1, e1, r) {
                    var n, a, o, s;
                    for(n = 0; n < e1.length; n++){
                        var l = e1[n].cd[0].trace._fullInput, c = t1._fullLayout._tracePreGUI[l.uid] || {};
                        void 0 === c.selectedpoints && (c.selectedpoints = l._input.selectedpoints || null);
                    }
                    if (r) {
                        var u = r.points || [];
                        for(n = 0; n < e1.length; n++)(s = e1[n].cd[0].trace)._input.selectedpoints = s._fullInput.selectedpoints = [], s._fullInput !== s && (s.selectedpoints = []);
                        for(n = 0; n < u.length; n++){
                            var f = u[n], h = f.data, p = f.fullData;
                            f.pointIndices ? ([].push.apply(h.selectedpoints, f.pointIndices), s._fullInput !== s && [].push.apply(p.selectedpoints, f.pointIndices)) : (h.selectedpoints.push(f.pointIndex), s._fullInput !== s && p.selectedpoints.push(f.pointIndex));
                        }
                    } else for(n = 0; n < e1.length; n++)delete (s = e1[n].cd[0].trace).selectedpoints, delete s._input.selectedpoints, s._fullInput !== s && delete s._fullInput.selectedpoints;
                    var d = !1;
                    for(n = 0; n < e1.length; n++){
                        s = (o = (a = e1[n]).cd)[0].trace, i.traceIs(s, "regl") && (d = !0);
                        var m = a._module, g = m.styleOnSelect || m.style;
                        g && (g(t1, o, o[0].node3), o[0].nodeRangePlot3 && g(t1, o, o[0].nodeRangePlot3));
                    }
                    d && (w(t1), T(t1));
                }
                function V(t1, e1) {
                    if (Array.isArray(t1)) for(var r = e1.cd, n = e1.cd[0].trace, i = 0; i < t1.length; i++)t1[i] = l(t1[i], n, r);
                    return t1;
                }
                function H(t1, e1) {
                    for(var r = [], n = 0; n < t1.length; n++){
                        r[n] = [];
                        for(var i = 0; i < t1[n].length; i++){
                            r[n][i] = [], r[n][i][0] = i ? "L" : "M";
                            for(var a = 0; a < t1[n][i].length; a++)r[n][i].push(t1[n][i][a]);
                        }
                        e1 || r[n].push([
                            "Z",
                            r[n][0][1],
                            r[n][0][2]
                        ]);
                    }
                    return r;
                }
                e1.exports = {
                    prepSelect: function(t1, e1, r, i, l) {
                        var c = u(l), v = f(l), x = p(l), _ = h(l), w = d(l), T = "drawcircle" === l, E = "drawline" === l || T, L = i.gd, z = L._fullLayout, D = z._zoomlayer, j = i.element.getBoundingClientRect(), q = i.plotinfo, G = I(q), Y = e1 - j.left, W = r - j.top;
                        z._calcInverseTransform(L);
                        var X = y.apply3DTransform(z._invTransform)(Y, W);
                        Y = X[0], W = X[1];
                        var Z, J, K, Q, $, tt, et, rt = z._invScaleX, nt = z._invScaleY, it = Y, at = W, ot = "M" + Y + "," + W, st = i.xaxes[0]._length, lt = i.yaxes[0]._length, ct = i.xaxes.concat(i.yaxes), ut = t1.altKey && !(h(l) && x);
                        F(t1, L, i), c && (Z = M([
                            [
                                Y,
                                W
                            ]
                        ], k.BENDPX));
                        var ft = D.selectAll("path.select-outline-" + q.id).data(_ ? [
                            0
                        ] : [
                            1,
                            2
                        ]), ht = z.newshape;
                        ft.enter().append("path").attr("class", function(t1) {
                            return "select-outline select-outline-" + t1 + " select-outline-" + q.id;
                        }).style(_ ? {
                            opacity: ht.opacity / 2,
                            fill: x ? void 0 : ht.fillcolor,
                            stroke: ht.line.color,
                            "stroke-dasharray": a(ht.line.dash, ht.line.width),
                            "stroke-width": ht.line.width + "px"
                        } : {}).attr("fill-rule", ht.fillrule).classed("cursor-move", !!_).attr("transform", G).attr("d", ot + "Z");
                        var pt, dt = D.append("path").attr("class", "zoombox-corners").style({
                            fill: o.background,
                            stroke: o.defaultLine,
                            "stroke-width": 1
                        }).attr("transform", G).attr("d", "M0,0Z"), mt = z._uid + k.SELECTID, gt = [], vt = N(L, i.xaxes, i.yaxes, i.subplot);
                        function yt(t1, e1) {
                            return t1 - e1;
                        }
                        pt = q.fillRangeItems ? q.fillRangeItems : v ? function(t1, e1) {
                            var r = t1.range = {};
                            for($ = 0; $ < ct.length; $++){
                                var n = ct[$], i = n._id.charAt(0);
                                r[n._id] = [
                                    C(n, e1[i + "min"]),
                                    C(n, e1[i + "max"])
                                ].sort(yt);
                            }
                        } : function(t1, e1, r) {
                            var n = t1.lassoPoints = {};
                            for($ = 0; $ < ct.length; $++){
                                var i = ct[$];
                                n[i._id] = r.filtered.map(P(i));
                            }
                        }, i.moveFn = function(t1, e1) {
                            it = Math.max(0, Math.min(st, rt * t1 + Y)), at = Math.max(0, Math.min(lt, nt * e1 + W));
                            var r = Math.abs(it - Y), a = Math.abs(at - W);
                            if (v) {
                                var o, s, l;
                                if (w) {
                                    var u = z.selectdirection;
                                    switch(o = "any" === u ? a < Math.min(.6 * r, A) ? "h" : r < Math.min(.6 * a, A) ? "v" : "d" : u){
                                        case "h":
                                            s = T ? lt / 2 : 0, l = lt;
                                            break;
                                        case "v":
                                            s = T ? st / 2 : 0, l = st;
                                    }
                                }
                                if (_) switch(z.newshape.drawdirection){
                                    case "vertical":
                                        o = "h", s = T ? lt / 2 : 0, l = lt;
                                        break;
                                    case "horizontal":
                                        o = "v", s = T ? st / 2 : 0, l = st;
                                        break;
                                    case "ortho":
                                        r < a ? (o = "h", s = W, l = at) : (o = "v", s = Y, l = it);
                                        break;
                                    default:
                                        o = "d";
                                }
                                "h" === o ? ((Q = E ? g(T, [
                                    it,
                                    s
                                ], [
                                    it,
                                    l
                                ]) : [
                                    [
                                        Y,
                                        s
                                    ],
                                    [
                                        Y,
                                        l
                                    ],
                                    [
                                        it,
                                        l
                                    ],
                                    [
                                        it,
                                        s
                                    ]
                                ]).xmin = E ? it : Math.min(Y, it), Q.xmax = E ? it : Math.max(Y, it), Q.ymin = Math.min(s, l), Q.ymax = Math.max(s, l), dt.attr("d", "M" + Q.xmin + "," + (W - A) + "h-4v" + 2 * A + "h4ZM" + (Q.xmax - 1) + "," + (W - A) + "h4v" + 2 * A + "h-4Z")) : "v" === o ? ((Q = E ? g(T, [
                                    s,
                                    at
                                ], [
                                    l,
                                    at
                                ]) : [
                                    [
                                        s,
                                        W
                                    ],
                                    [
                                        s,
                                        at
                                    ],
                                    [
                                        l,
                                        at
                                    ],
                                    [
                                        l,
                                        W
                                    ]
                                ]).xmin = Math.min(s, l), Q.xmax = Math.max(s, l), Q.ymin = E ? at : Math.min(W, at), Q.ymax = E ? at : Math.max(W, at), dt.attr("d", "M" + (Y - A) + "," + Q.ymin + "v-4h" + 2 * A + "v4ZM" + (Y - A) + "," + (Q.ymax - 1) + "v4h" + 2 * A + "v-4Z")) : "d" === o && ((Q = E ? g(T, [
                                    Y,
                                    W
                                ], [
                                    it,
                                    at
                                ]) : [
                                    [
                                        Y,
                                        W
                                    ],
                                    [
                                        Y,
                                        at
                                    ],
                                    [
                                        it,
                                        at
                                    ],
                                    [
                                        it,
                                        W
                                    ]
                                ]).xmin = Math.min(Y, it), Q.xmax = Math.max(Y, it), Q.ymin = Math.min(W, at), Q.ymax = Math.max(W, at), dt.attr("d", "M0,0Z"));
                            } else c && (Z.addPt([
                                it,
                                at
                            ]), Q = Z.filtered);
                            i.selectionDefs && i.selectionDefs.length ? (K = function(t1, e1, r) {
                                if (r) return n.difference({
                                    regions: t1,
                                    inverted: !1
                                }, {
                                    regions: [
                                        e1
                                    ],
                                    inverted: !1
                                }).regions;
                                return n.union({
                                    regions: t1,
                                    inverted: !1
                                }, {
                                    regions: [
                                        e1
                                    ],
                                    inverted: !1
                                }).regions;
                            }(i.mergedPolygons, Q, ut), Q.subtract = ut, J = R(i.selectionDefs.concat([
                                Q
                            ]))) : (K = [
                                Q
                            ], J = S(Q)), m(H(K, x), ft, i), w && b.throttle(mt, k.SELECTDELAY, function() {
                                var t1;
                                gt = [];
                                var e1, r = [];
                                for($ = 0; $ < vt.length; $++)if (e1 = (tt = vt[$])._module.selectPoints(tt, J), r.push(e1), t1 = V(e1, tt), gt.length) for(var n = 0; n < t1.length; n++)gt.push(t1[n]);
                                else gt = t1;
                                U(L, vt, et = {
                                    points: gt
                                }), pt(et, Q, Z), i.gd.emit("plotly_selecting", et);
                            });
                        }, i.clickFn = function(t1, e1) {
                            if (dt.remove(), L._fullLayout._activeShapeIndex >= 0) L._fullLayout._deactivateShape(L);
                            else if (!_) {
                                var r = z.clickmode;
                                b.done(mt).then(function() {
                                    if (b.clear(mt), 2 === t1) {
                                        for(ft.remove(), $ = 0; $ < vt.length; $++)(tt = vt[$])._module.selectPoints(tt, !1);
                                        U(L, vt), B(i), L.emit("plotly_deselect", null);
                                    } else r.indexOf("select") > -1 && O(e1, L, i.xaxes, i.yaxes, i.subplot, i, ft), "event" === r && L.emit("plotly_selected", void 0);
                                    s.click(L, e1);
                                }).catch(y.error);
                            }
                        }, i.doneFn = function() {
                            dt.remove(), b.done(mt).then(function() {
                                b.clear(mt), i.gd.emit("plotly_selected", et), Q && i.selectionDefs && (Q.subtract = ut, i.selectionDefs.push(Q), i.mergedPolygons.length = 0, [].push.apply(i.mergedPolygons, K)), i.doneFnCompleted && i.doneFnCompleted(gt);
                            }).catch(y.error), _ && B(i);
                        };
                    },
                    clearSelect: E,
                    clearSelectionsCache: B,
                    selectOnClick: O
                };
            },
            {
                "../../components/color": 366,
                "../../components/dragelement/helpers": 384,
                "../../components/drawing": 388,
                "../../components/fx": 406,
                "../../components/fx/helpers": 402,
                "../../components/shapes/draw_newshape/display_outlines": 454,
                "../../components/shapes/draw_newshape/helpers": 455,
                "../../components/shapes/draw_newshape/newshapes": 456,
                "../../lib": 503,
                "../../lib/clear_gl_canvases": 487,
                "../../lib/polygon": 515,
                "../../lib/throttle": 530,
                "../../plot_api/subroutines": 544,
                "../../registry": 638,
                "./axis_ids": 558,
                "./constants": 561,
                "./handle_outline": 565,
                "./helpers": 566,
                polybooljs: 254
            }
        ],
        576: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("d3-time-format").utcFormat, a = t1("../../lib"), o = a.numberFormat, s = t1("fast-isnumeric"), l = a.cleanNumber, c = a.ms2DateTime, u = a.dateTime2ms, f = a.ensureNumber, h = a.isArrayOrTypedArray, p = t1("../../constants/numerical"), d = p.FP_SAFE, m = p.BADNUM, g = p.LOG_CLIP, v = p.ONEWEEK, y = p.ONEDAY, x = p.ONEHOUR, b = p.ONEMIN, _ = p.ONESEC, w = t1("./axis_ids"), T = t1("./constants"), k = T.HOUR_PATTERN, A = T.WEEKDAY_PATTERN;
                function M(t1) {
                    return Math.pow(10, t1);
                }
                function S(t1) {
                    return null != t1;
                }
                e1.exports = function(t1, e1) {
                    e1 = e1 || {};
                    var r = t1._id || "x", p = r.charAt(0);
                    function E(e1, r) {
                        if (e1 > 0) return Math.log(e1) / Math.LN10;
                        if (e1 <= 0 && r && t1.range && 2 === t1.range.length) {
                            var n = t1.range[0], i = t1.range[1];
                            return .5 * (n + i - 2 * g * Math.abs(n - i));
                        }
                        return m;
                    }
                    function L(e1, r, n, i) {
                        if ((i || {}).msUTC && s(e1)) return +e1;
                        var o = u(e1, n || t1.calendar);
                        if (o === m) {
                            if (!s(e1)) return m;
                            e1 = +e1;
                            var l = Math.floor(10 * a.mod(e1 + .05, 1)), c = Math.round(e1 - l / 10);
                            o = u(new Date(c)) + l / 10;
                        }
                        return o;
                    }
                    function C(e1, r, n) {
                        return c(e1, r, n || t1.calendar);
                    }
                    function P(e1) {
                        return t1._categories[Math.round(e1)];
                    }
                    function I(e1) {
                        if (S(e1)) {
                            if (void 0 === t1._categoriesMap && (t1._categoriesMap = {}), void 0 !== t1._categoriesMap[e1]) return t1._categoriesMap[e1];
                            t1._categories.push("number" == typeof e1 ? String(e1) : e1);
                            var r = t1._categories.length - 1;
                            return t1._categoriesMap[e1] = r, r;
                        }
                        return m;
                    }
                    function O(e1) {
                        if (t1._categoriesMap) return t1._categoriesMap[e1];
                    }
                    function z(t1) {
                        var e1 = O(t1);
                        return void 0 !== e1 ? e1 : s(t1) ? +t1 : void 0;
                    }
                    function D(t1) {
                        return s(t1) ? +t1 : O(t1);
                    }
                    function R(t1, e1, r) {
                        return n.round(r + e1 * t1, 2);
                    }
                    function F(t1, e1, r) {
                        return (t1 - r) / e1;
                    }
                    var B = function(e1) {
                        return s(e1) ? R(e1, t1._m, t1._b) : m;
                    }, N = function(e1) {
                        return F(e1, t1._m, t1._b);
                    };
                    if (t1.rangebreaks) {
                        var j = "y" === p;
                        B = function(e1) {
                            if (!s(e1)) return m;
                            var r = t1._rangebreaks.length;
                            if (!r) return R(e1, t1._m, t1._b);
                            var n = j;
                            t1.range[0] > t1.range[1] && (n = !n);
                            for(var i = n ? -1 : 1, a = i * e1, o = 0, l = 0; l < r; l++){
                                var c = i * t1._rangebreaks[l].min, u = i * t1._rangebreaks[l].max;
                                if (a < c) break;
                                if (!(a > u)) {
                                    o = a < (c + u) / 2 ? l : l + 1;
                                    break;
                                }
                                o = l + 1;
                            }
                            var f = t1._B[o] || 0;
                            return isFinite(f) ? R(e1, t1._m2, f) : 0;
                        }, N = function(e1) {
                            var r = t1._rangebreaks.length;
                            if (!r) return F(e1, t1._m, t1._b);
                            for(var n = 0, i = 0; i < r && !(e1 < t1._rangebreaks[i].pmin); i++)e1 > t1._rangebreaks[i].pmax && (n = i + 1);
                            return F(e1, t1._m2, t1._B[n]);
                        };
                    }
                    t1.c2l = "log" === t1.type ? E : f, t1.l2c = "log" === t1.type ? M : f, t1.l2p = B, t1.p2l = N, t1.c2p = "log" === t1.type ? function(t1, e1) {
                        return B(E(t1, e1));
                    } : B, t1.p2c = "log" === t1.type ? function(t1) {
                        return M(N(t1));
                    } : N, -1 !== [
                        "linear",
                        "-"
                    ].indexOf(t1.type) ? (t1.d2r = t1.r2d = t1.d2c = t1.r2c = t1.d2l = t1.r2l = l, t1.c2d = t1.c2r = t1.l2d = t1.l2r = f, t1.d2p = t1.r2p = function(e1) {
                        return t1.l2p(l(e1));
                    }, t1.p2d = t1.p2r = N, t1.cleanPos = f) : "log" === t1.type ? (t1.d2r = t1.d2l = function(t1, e1) {
                        return E(l(t1), e1);
                    }, t1.r2d = t1.r2c = function(t1) {
                        return M(l(t1));
                    }, t1.d2c = t1.r2l = l, t1.c2d = t1.l2r = f, t1.c2r = E, t1.l2d = M, t1.d2p = function(e1, r) {
                        return t1.l2p(t1.d2r(e1, r));
                    }, t1.p2d = function(t1) {
                        return M(N(t1));
                    }, t1.r2p = function(e1) {
                        return t1.l2p(l(e1));
                    }, t1.p2r = N, t1.cleanPos = f) : "date" === t1.type ? (t1.d2r = t1.r2d = a.identity, t1.d2c = t1.r2c = t1.d2l = t1.r2l = L, t1.c2d = t1.c2r = t1.l2d = t1.l2r = C, t1.d2p = t1.r2p = function(e1, r, n) {
                        return t1.l2p(L(e1, 0, n));
                    }, t1.p2d = t1.p2r = function(t1, e1, r) {
                        return C(N(t1), e1, r);
                    }, t1.cleanPos = function(e1) {
                        return a.cleanDate(e1, m, t1.calendar);
                    }) : "category" === t1.type ? (t1.d2c = t1.d2l = I, t1.r2d = t1.c2d = t1.l2d = P, t1.d2r = t1.d2l_noadd = z, t1.r2c = function(e1) {
                        var r = D(e1);
                        return void 0 !== r ? r : t1.fraction2r(.5);
                    }, t1.l2r = t1.c2r = f, t1.r2l = D, t1.d2p = function(e1) {
                        return t1.l2p(t1.r2c(e1));
                    }, t1.p2d = function(t1) {
                        return P(N(t1));
                    }, t1.r2p = t1.d2p, t1.p2r = N, t1.cleanPos = function(t1) {
                        return "string" == typeof t1 && "" !== t1 ? t1 : f(t1);
                    }) : "multicategory" === t1.type && (t1.r2d = t1.c2d = t1.l2d = P, t1.d2r = t1.d2l_noadd = z, t1.r2c = function(e1) {
                        var r = z(e1);
                        return void 0 !== r ? r : t1.fraction2r(.5);
                    }, t1.r2c_just_indices = O, t1.l2r = t1.c2r = f, t1.r2l = z, t1.d2p = function(e1) {
                        return t1.l2p(t1.r2c(e1));
                    }, t1.p2d = function(t1) {
                        return P(N(t1));
                    }, t1.r2p = t1.d2p, t1.p2r = N, t1.cleanPos = function(t1) {
                        return Array.isArray(t1) || "string" == typeof t1 && "" !== t1 ? t1 : f(t1);
                    }, t1.setupMultiCategory = function(n) {
                        var i, o, s = t1._traceIndices, l = t1._matchGroup;
                        if (l && 0 === t1._categories.length) {
                            for(var c in l)if (c !== r) {
                                var u = e1[w.id2name(c)];
                                s = s.concat(u._traceIndices);
                            }
                        }
                        var f = [
                            [
                                0,
                                {}
                            ],
                            [
                                0,
                                {}
                            ]
                        ], d = [];
                        for(i = 0; i < s.length; i++){
                            var m = n[s[i]];
                            if (p in m) {
                                var g = m[p], v = m._length || a.minRowLength(g);
                                if (h(g[0]) && h(g[1])) for(o = 0; o < v; o++){
                                    var y = g[0][o], x = g[1][o];
                                    S(y) && S(x) && (d.push([
                                        y,
                                        x
                                    ]), y in f[0][1] || (f[0][1][y] = f[0][0]++), x in f[1][1] || (f[1][1][x] = f[1][0]++));
                                }
                            }
                        }
                        for(d.sort(function(t1, e1) {
                            var r = f[0][1], n = r[t1[0]] - r[e1[0]];
                            if (n) return n;
                            var i = f[1][1];
                            return i[t1[1]] - i[e1[1]];
                        }), i = 0; i < d.length; i++)I(d[i]);
                    }), t1.fraction2r = function(e1) {
                        var r = t1.r2l(t1.range[0]), n = t1.r2l(t1.range[1]);
                        return t1.l2r(r + e1 * (n - r));
                    }, t1.r2fraction = function(e1) {
                        var r = t1.r2l(t1.range[0]), n = t1.r2l(t1.range[1]);
                        return (t1.r2l(e1) - r) / (n - r);
                    }, t1.cleanRange = function(e1, r) {
                        r || (r = {}), e1 || (e1 = "range");
                        var n, i, o = a.nestedProperty(t1, e1).get();
                        if (i = (i = "date" === t1.type ? a.dfltRange(t1.calendar) : "y" === p ? T.DFLTRANGEY : "realaxis" === t1._name ? [
                            0,
                            1
                        ] : r.dfltRange || T.DFLTRANGEX).slice(), "tozero" !== t1.rangemode && "nonnegative" !== t1.rangemode || (i[0] = 0), o && 2 === o.length) for("date" !== t1.type || t1.autorange || (o[0] = a.cleanDate(o[0], m, t1.calendar), o[1] = a.cleanDate(o[1], m, t1.calendar)), n = 0; n < 2; n++)if ("date" === t1.type) {
                            if (!a.isDateTime(o[n], t1.calendar)) {
                                t1[e1] = i;
                                break;
                            }
                            if (t1.r2l(o[0]) === t1.r2l(o[1])) {
                                var l = a.constrain(t1.r2l(o[0]), a.MIN_MS + 1e3, a.MAX_MS - 1e3);
                                o[0] = t1.l2r(l - 1e3), o[1] = t1.l2r(l + 1e3);
                                break;
                            }
                        } else {
                            if (!s(o[n])) {
                                if (!s(o[1 - n])) {
                                    t1[e1] = i;
                                    break;
                                }
                                o[n] = o[1 - n] * (n ? 10 : .1);
                            }
                            if (o[n] < -d ? o[n] = -d : o[n] > d && (o[n] = d), o[0] === o[1]) {
                                var c = Math.max(1, Math.abs(1e-6 * o[0]));
                                o[0] -= c, o[1] += c;
                            }
                        }
                        else a.nestedProperty(t1, e1).set(i);
                    }, t1.setScale = function(r) {
                        var n = e1._size;
                        if (t1.overlaying) {
                            var i = w.getFromId({
                                _fullLayout: e1
                            }, t1.overlaying);
                            t1.domain = i.domain;
                        }
                        var a = r && t1._r ? "_r" : "range", o = t1.calendar;
                        t1.cleanRange(a);
                        var s, l, c = t1.r2l(t1[a][0], o), u = t1.r2l(t1[a][1], o), f = "y" === p;
                        if ((f ? (t1._offset = n.t + (1 - t1.domain[1]) * n.h, t1._length = n.h * (t1.domain[1] - t1.domain[0]), t1._m = t1._length / (c - u), t1._b = -t1._m * u) : (t1._offset = n.l + t1.domain[0] * n.w, t1._length = n.w * (t1.domain[1] - t1.domain[0]), t1._m = t1._length / (u - c), t1._b = -t1._m * c), t1._rangebreaks = [], t1._lBreaks = 0, t1._m2 = 0, t1._B = [], t1.rangebreaks) && (t1._rangebreaks = t1.locateBreaks(Math.min(c, u), Math.max(c, u)), t1._rangebreaks.length)) {
                            for(s = 0; s < t1._rangebreaks.length; s++)l = t1._rangebreaks[s], t1._lBreaks += Math.abs(l.max - l.min);
                            var h = f;
                            c > u && (h = !h), h && t1._rangebreaks.reverse();
                            var d = h ? -1 : 1;
                            for(t1._m2 = d * t1._length / (Math.abs(u - c) - t1._lBreaks), t1._B.push(-t1._m2 * (f ? u : c)), s = 0; s < t1._rangebreaks.length; s++)l = t1._rangebreaks[s], t1._B.push(t1._B[t1._B.length - 1] - d * t1._m2 * (l.max - l.min));
                            for(s = 0; s < t1._rangebreaks.length; s++)(l = t1._rangebreaks[s]).pmin = B(l.min), l.pmax = B(l.max);
                        }
                        if (!isFinite(t1._m) || !isFinite(t1._b) || t1._length < 0) throw e1._replotting = !1, new Error("Something went wrong with axis scaling");
                    }, t1.maskBreaks = function(e1) {
                        var r, n, i, o, s, c = t1.rangebreaks || [];
                        c._cachedPatterns || (c._cachedPatterns = c.map(function(e1) {
                            return e1.enabled && e1.bounds ? a.simpleMap(e1.bounds, e1.pattern ? l : t1.d2c) : null;
                        })), c._cachedValues || (c._cachedValues = c.map(function(e1) {
                            return e1.enabled && e1.values ? a.simpleMap(e1.values, t1.d2c).sort(a.sorterAsc) : null;
                        }));
                        for(var u = 0; u < c.length; u++){
                            var f = c[u];
                            if (f.enabled) {
                                if (f.bounds) {
                                    var h = f.pattern;
                                    switch(n = (r = c._cachedPatterns[u])[0], i = r[1], h){
                                        case A:
                                            o = (s = new Date(e1)).getUTCDay(), n > i && (i += 7, o < n && (o += 7));
                                            break;
                                        case k:
                                            o = (s = new Date(e1)).getUTCHours() + (s.getUTCMinutes() / 60 + s.getUTCSeconds() / 3600 + s.getUTCMilliseconds() / 36e5), n > i && (i += 24, o < n && (o += 24));
                                            break;
                                        case "":
                                            o = e1;
                                    }
                                    if (o >= n && o < i) return m;
                                } else for(var p = c._cachedValues[u], d = 0; d < p.length; d++)if (i = (n = p[d]) + f.dvalue, e1 >= n && e1 < i) return m;
                            }
                        }
                        return e1;
                    }, t1.locateBreaks = function(e1, r) {
                        var n, i, o, s, c = [];
                        if (!t1.rangebreaks) return c;
                        var u = t1.rangebreaks.slice().sort(function(t1, e1) {
                            return t1.pattern === A && e1.pattern === k ? -1 : e1.pattern === A && t1.pattern === k ? 1 : 0;
                        }), f = function(t1, n) {
                            if ((t1 = a.constrain(t1, e1, r)) !== (n = a.constrain(n, e1, r))) {
                                for(var i = !0, o = 0; o < c.length; o++){
                                    var s = c[o];
                                    t1 < s.max && n >= s.min && (t1 < s.min && (s.min = t1), n > s.max && (s.max = n), i = !1);
                                }
                                i && c.push({
                                    min: t1,
                                    max: n
                                });
                            }
                        };
                        for(n = 0; n < u.length; n++){
                            var h = u[n];
                            if (h.enabled) {
                                if (h.bounds) {
                                    var p = e1, d = r;
                                    h.pattern && (p = Math.floor(p)), o = (i = a.simpleMap(h.bounds, h.pattern ? l : t1.r2l))[0], s = i[1];
                                    var m, g, w = new Date(p);
                                    switch(h.pattern){
                                        case A:
                                            g = v, m = (s - o + (s < o ? 7 : 0)) * y, p += o * y - (w.getUTCDay() * y + w.getUTCHours() * x + w.getUTCMinutes() * b + w.getUTCSeconds() * _ + w.getUTCMilliseconds());
                                            break;
                                        case k:
                                            g = y, m = (s - o + (s < o ? 24 : 0)) * x, p += o * x - (w.getUTCHours() * x + w.getUTCMinutes() * b + w.getUTCSeconds() * _ + w.getUTCMilliseconds());
                                            break;
                                        default:
                                            p = Math.min(i[0], i[1]), m = g = (d = Math.max(i[0], i[1])) - p;
                                    }
                                    for(var T = p; T < d; T += g)f(T, T + m);
                                } else for(var M = a.simpleMap(h.values, t1.d2c), S = 0; S < M.length; S++)f(o = M[S], s = o + h.dvalue);
                            }
                        }
                        return c.sort(function(t1, e1) {
                            return t1.min - e1.min;
                        }), c;
                    }, t1.makeCalcdata = function(e1, r, n) {
                        var i, o, s, l, c = t1.type, u = "date" === c && e1[r + "calendar"];
                        if (r in e1) {
                            if (i = e1[r], l = e1._length || a.minRowLength(i), a.isTypedArray(i) && ("linear" === c || "log" === c)) {
                                if (l === i.length) return i;
                                if (i.subarray) return i.subarray(0, l);
                            }
                            if ("multicategory" === c) return function(t1, e1) {
                                for(var r = new Array(e1), n = 0; n < e1; n++){
                                    var i = (t1[0] || [])[n], a = (t1[1] || [])[n];
                                    r[n] = O([
                                        i,
                                        a
                                    ]);
                                }
                                return r;
                            }(i, l);
                            for(o = new Array(l), s = 0; s < l; s++)o[s] = t1.d2c(i[s], 0, u, n);
                        } else {
                            var f = r + "0" in e1 ? t1.d2c(e1[r + "0"], 0, u) : 0, h = e1["d" + r] ? Number(e1["d" + r]) : 1;
                            for(i = e1[({
                                x: "y",
                                y: "x"
                            })[r]], l = e1._length || i.length, o = new Array(l), s = 0; s < l; s++)o[s] = f + s * h;
                        }
                        if (t1.rangebreaks) for(s = 0; s < l; s++)o[s] = t1.maskBreaks(o[s]);
                        return o;
                    }, t1.isValidRange = function(e1) {
                        return Array.isArray(e1) && 2 === e1.length && s(t1.r2l(e1[0])) && s(t1.r2l(e1[1]));
                    }, t1.isPtWithinRange = function(e1, r) {
                        var n = t1.c2l(e1[p], null, r), i = t1.r2l(t1.range[0]), a = t1.r2l(t1.range[1]);
                        return i < a ? i <= n && n <= a : a <= n && n <= i;
                    }, t1._emptyCategories = function() {
                        t1._categories = [], t1._categoriesMap = {};
                    }, t1.clearCalc = function() {
                        var r = t1._matchGroup;
                        if (r) {
                            var n = null, i = null;
                            for(var a in r){
                                var o = e1[w.id2name(a)];
                                if (o._categories) {
                                    n = o._categories, i = o._categoriesMap;
                                    break;
                                }
                            }
                            n && i ? (t1._categories = n, t1._categoriesMap = i) : t1._emptyCategories();
                        } else t1._emptyCategories();
                        if (t1._initialCategories) for(var s = 0; s < t1._initialCategories.length; s++)I(t1._initialCategories[s]);
                    }, t1.sortByInitialCategories = function() {
                        var n = [];
                        if (t1._emptyCategories(), t1._initialCategories) for(var i = 0; i < t1._initialCategories.length; i++)I(t1._initialCategories[i]);
                        n = n.concat(t1._traceIndices);
                        var a = t1._matchGroup;
                        for(var o in a)if (r !== o) {
                            var s = e1[w.id2name(o)];
                            s._categories = t1._categories, s._categoriesMap = t1._categoriesMap, n = n.concat(s._traceIndices);
                        }
                        return n;
                    };
                    var U = e1._d3locale;
                    "date" === t1.type && (t1._dateFormat = U ? U.timeFormat : i, t1._extraFormat = e1._extraFormat), t1._separators = e1.separators, t1._numFormat = U ? U.numberFormat : o, delete t1._minDtick, delete t1._forceTick0;
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "./axis_ids": 558,
                "./constants": 561,
                "@plotly/d3": 58,
                "d3-time-format": 120,
                "fast-isnumeric": 190
            }
        ],
        577: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    var e1 = [
                        "showexponent",
                        "showtickprefix",
                        "showticksuffix"
                    ].filter(function(e1) {
                        return void 0 !== t1[e1];
                    });
                    if (e1.every(function(r) {
                        return t1[r] === t1[e1[0]];
                    }) || 1 === e1.length) return t1[e1[0]];
                };
            },
            {}
        ],
        578: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/color").contrast, a = t1("./layout_attributes"), o = t1("./show_dflt"), s = t1("../array_container_defaults");
                function l(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, a.tickformatstops, r, i);
                    }
                    r("enabled") && (r("dtickrange"), r("value"));
                }
                e1.exports = function(t1, e1, r, c, u) {
                    u || (u = {});
                    var f = o(t1);
                    if (r("showticklabels")) {
                        var h = u.font || {}, p = e1.color, d = -1 !== (e1.ticklabelposition || "").indexOf("inside") ? i(u.bgColor) : p && p !== a.color.dflt ? p : h.color;
                        if (n.coerceFont(r, "tickfont", {
                            family: h.family,
                            size: h.size,
                            color: d
                        }), u.noAng || r("tickangle"), "category" !== c) {
                            var m = r("tickformat");
                            s(t1, e1, {
                                name: "tickformatstops",
                                inclusionAttr: "enabled",
                                handleItemDefaults: l
                            }), e1.tickformatstops.length || delete e1.tickformatstops, u.noExp || m || "date" === c || (r("showexponent", f), r("exponentformat"), r("minexponent"), r("separatethousands"));
                        }
                    }
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../array_container_defaults": 549,
                "./layout_attributes": 569,
                "./show_dflt": 577
            }
        ],
        579: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./layout_attributes");
                e1.exports = function(t1, e1, r, a) {
                    var o = n.coerce2(t1, e1, i, "ticklen"), s = n.coerce2(t1, e1, i, "tickwidth"), l = n.coerce2(t1, e1, i, "tickcolor", e1.color);
                    r("ticks", a.outerTicks || o || s || l ? "outside" : "") || (delete e1.ticklen, delete e1.tickwidth, delete e1.tickcolor);
                };
            },
            {
                "../../lib": 503,
                "./layout_attributes": 569
            }
        ],
        580: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./clean_ticks"), i = t1("../../lib").isArrayOrTypedArray;
                e1.exports = function(t1, e1, r, a) {
                    function o(r) {
                        var n = t1[r];
                        return void 0 !== n ? n : (e1._template || {})[r];
                    }
                    var s = o("tick0"), l = o("dtick"), c = o("tickvals"), u = r("tickmode", i(c) ? "array" : l ? "linear" : "auto");
                    if ("auto" === u) r("nticks");
                    else if ("linear" === u) {
                        var f = e1.dtick = n.dtick(l, a);
                        e1.tick0 = n.tick0(s, a, e1.calendar, f);
                    } else if ("multicategory" !== a) void 0 === r("tickvals") ? e1.tickmode = "auto" : r("ticktext");
                };
            },
            {
                "../../lib": 503,
                "./clean_ticks": 560
            }
        ],
        581: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../registry"), a = t1("../../lib"), o = t1("../../components/drawing"), s = t1("./axes");
                e1.exports = function(t1, e1, r, l) {
                    var c = t1._fullLayout;
                    if (0 !== e1.length) {
                        var u, f, h, p;
                        l && (u = l());
                        var d = n.ease(r.easing);
                        return t1._transitionData._interruptCallbacks.push(function() {
                            return window.cancelAnimationFrame(p), p = null, function() {
                                for(var r = {}, n = 0; n < e1.length; n++){
                                    var a = e1[n], o = a.plotinfo.xaxis, s = a.plotinfo.yaxis;
                                    a.xr0 && (r[o._name + ".range"] = a.xr0.slice()), a.yr0 && (r[s._name + ".range"] = a.yr0.slice());
                                }
                                return i.call("relayout", t1, r).then(function() {
                                    for(var t1 = 0; t1 < e1.length; t1++)m(e1[t1].plotinfo);
                                });
                            }();
                        }), f = Date.now(), p = window.requestAnimationFrame(function n() {
                            h = Date.now();
                            for(var a = Math.min(1, (h - f) / r.duration), o = d(a), s = 0; s < e1.length; s++)g(e1[s], o);
                            h - f > r.duration ? (!function() {
                                for(var r = {}, n = 0; n < e1.length; n++){
                                    var a = e1[n], o = a.plotinfo.xaxis, s = a.plotinfo.yaxis;
                                    a.xr1 && (r[o._name + ".range"] = a.xr1.slice()), a.yr1 && (r[s._name + ".range"] = a.yr1.slice());
                                }
                                u && u(), i.call("relayout", t1, r).then(function() {
                                    for(var t1 = 0; t1 < e1.length; t1++)m(e1[t1].plotinfo);
                                });
                            }(), p = window.cancelAnimationFrame(n)) : p = window.requestAnimationFrame(n);
                        }), Promise.resolve();
                    }
                    function m(t1) {
                        var e1 = t1.xaxis, r = t1.yaxis;
                        c._defs.select("#" + t1.clipId + "> rect").call(o.setTranslate, 0, 0).call(o.setScale, 1, 1), t1.plot.call(o.setTranslate, e1._offset, r._offset).call(o.setScale, 1, 1);
                        var n = t1.plot.selectAll(".scatterlayer .trace");
                        n.selectAll(".point").call(o.setPointGroupScale, 1, 1), n.selectAll(".textpoint").call(o.setTextPointsScale, 1, 1), n.call(o.hideOutsideRangePoints, t1);
                    }
                    function g(e1, r) {
                        var n = e1.plotinfo, i = n.xaxis, l = n.yaxis, c = i._length, u = l._length, f = !!e1.xr1, h = !!e1.yr1, p = [];
                        if (f) {
                            var d = a.simpleMap(e1.xr0, i.r2l), m = a.simpleMap(e1.xr1, i.r2l), g = d[1] - d[0], v = m[1] - m[0];
                            p[0] = (d[0] * (1 - r) + r * m[0] - d[0]) / (d[1] - d[0]) * c, p[2] = c * (1 - r + r * v / g), i.range[0] = i.l2r(d[0] * (1 - r) + r * m[0]), i.range[1] = i.l2r(d[1] * (1 - r) + r * m[1]);
                        } else p[0] = 0, p[2] = c;
                        if (h) {
                            var y = a.simpleMap(e1.yr0, l.r2l), x = a.simpleMap(e1.yr1, l.r2l), b = y[1] - y[0], _ = x[1] - x[0];
                            p[1] = (y[1] * (1 - r) + r * x[1] - y[1]) / (y[0] - y[1]) * u, p[3] = u * (1 - r + r * _ / b), l.range[0] = i.l2r(y[0] * (1 - r) + r * x[0]), l.range[1] = l.l2r(y[1] * (1 - r) + r * x[1]);
                        } else p[1] = 0, p[3] = u;
                        s.drawOne(t1, i, {
                            skipTitle: !0
                        }), s.drawOne(t1, l, {
                            skipTitle: !0
                        }), s.redrawComponents(t1, [
                            i._id,
                            l._id
                        ]);
                        var w = f ? c / p[2] : 1, T = h ? u / p[3] : 1, k = f ? p[0] : 0, A = h ? p[1] : 0, M = f ? p[0] / p[2] * c : 0, S = h ? p[1] / p[3] * u : 0, E = i._offset - M, L = l._offset - S;
                        n.clipRect.call(o.setTranslate, k, A).call(o.setScale, 1 / w, 1 / T), n.plot.call(o.setTranslate, E, L).call(o.setScale, w, T), o.setPointGroupScale(n.zoomScalePts, 1 / w, 1 / T), o.setTextPointsScale(n.zoomScaleTxt, 1 / w, 1 / T);
                    }
                    s.redrawComponents(t1);
                };
            },
            {
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../registry": 638,
                "./axes": 554,
                "@plotly/d3": 58
            }
        ],
        582: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry").traceIs, i = t1("./axis_autotype");
                function a(t1) {
                    return ({
                        v: "x",
                        h: "y"
                    })[t1.orientation || "v"];
                }
                function o(t1, e1) {
                    var r = a(t1), i = n(t1, "box-violin"), o = n(t1._fullInput || {}, "candlestick");
                    return i && !o && e1 === r && void 0 === t1[r] && void 0 === t1[r + "0"];
                }
                e1.exports = function(t1, e1, r, s) {
                    r("autotypenumbers", s.autotypenumbersDflt), "-" === r("type", (s.splomStash || {}).type) && (!function(t1, e1) {
                        if ("-" !== t1.type) return;
                        var r, s = t1._id, l = s.charAt(0);
                        -1 !== s.indexOf("scene") && (s = l);
                        var c = function(t1, e1, r) {
                            for(var n = 0; n < t1.length; n++){
                                var i = t1[n];
                                if ("splom" === i.type && i._length > 0 && (i["_" + r + "axes"] || {})[e1]) return i;
                                if ((i[r + "axis"] || r) === e1) {
                                    if (o(i, r)) return i;
                                    if ((i[r] || []).length || i[r + "0"]) return i;
                                }
                            }
                        }(e1, s, l);
                        if (!c) return;
                        if ("histogram" === c.type && l === ({
                            v: "y",
                            h: "x"
                        })[c.orientation || "v"]) return void (t1.type = "linear");
                        var u = l + "calendar", f = c[u], h = {
                            noMultiCategory: !n(c, "cartesian") || n(c, "noMultiCategory")
                        };
                        "box" === c.type && c._hasPreCompStats && l === ({
                            h: "x",
                            v: "y"
                        })[c.orientation || "v"] && (h.noMultiCategory = !0);
                        if (h.autotypenumbers = t1.autotypenumbers, o(c, l)) {
                            var p = a(c), d = [];
                            for(r = 0; r < e1.length; r++){
                                var m = e1[r];
                                n(m, "box-violin") && (m[l + "axis"] || l) === s && (void 0 !== m[p] ? d.push(m[p][0]) : void 0 !== m.name ? d.push(m.name) : d.push("text"), m[u] !== f && (f = void 0));
                            }
                            t1.type = i(d, f, h);
                        } else if ("splom" === c.type) {
                            var g = c.dimensions[c._axesDim[s]];
                            g.visible && (t1.type = i(g.values, f, h));
                        } else t1.type = i(c[l] || [
                            c[l + "0"]
                        ], f, h);
                    }(e1, s.data), "-" === e1.type ? e1.type = "linear" : t1.type = e1.type);
                };
            },
            {
                "../../registry": 638,
                "./axis_autotype": 555
            }
        ],
        583: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../registry"), i = t1("../lib");
                function a(t1, e1, r) {
                    var n, a, o, s = !1;
                    if ("data" === e1.type) n = t1._fullData[null !== e1.traces ? e1.traces[0] : 0];
                    else {
                        if ("layout" !== e1.type) return !1;
                        n = t1._fullLayout;
                    }
                    return a = i.nestedProperty(n, e1.prop).get(), (o = r[e1.type] = r[e1.type] || {}).hasOwnProperty(e1.prop) && o[e1.prop] !== a && (s = !0), o[e1.prop] = a, {
                        changed: s,
                        value: a
                    };
                }
                function o(t1, e1) {
                    var r = [], n = e1[0], a = {};
                    if ("string" == typeof n) a[n] = e1[1];
                    else {
                        if (!i.isPlainObject(n)) return r;
                        a = n;
                    }
                    return l(a, function(t1, e1, n) {
                        r.push({
                            type: "layout",
                            prop: t1,
                            value: n
                        });
                    }, "", 0), r;
                }
                function s(t1, e1) {
                    var r, n, a, o, s = [];
                    if (n = e1[0], a = e1[1], r = e1[2], o = {}, "string" == typeof n) o[n] = a;
                    else {
                        if (!i.isPlainObject(n)) return s;
                        o = n, void 0 === r && (r = a);
                    }
                    return void 0 === r && (r = null), l(o, function(e1, n, i) {
                        var a, o;
                        if (Array.isArray(i)) {
                            o = i.slice();
                            var l = Math.min(o.length, t1.data.length);
                            r && (l = Math.min(l, r.length)), a = [];
                            for(var c = 0; c < l; c++)a[c] = r ? r[c] : c;
                        } else o = i, a = r ? r.slice() : null;
                        if (null === a) Array.isArray(o) && (o = o[0]);
                        else if (Array.isArray(a)) {
                            if (!Array.isArray(o)) {
                                var u = o;
                                o = [];
                                for(var f = 0; f < a.length; f++)o[f] = u;
                            }
                            o.length = Math.min(a.length, o.length);
                        }
                        s.push({
                            type: "data",
                            prop: e1,
                            traces: a,
                            value: o
                        });
                    }, "", 0), s;
                }
                function l(t1, e1, r, n) {
                    Object.keys(t1).forEach(function(a) {
                        var o = t1[a];
                        if ("_" !== a[0]) {
                            var s = r + (n > 0 ? "." : "") + a;
                            i.isPlainObject(o) ? l(o, e1, s, n + 1) : e1(s, a, o);
                        }
                    });
                }
                r.manageCommandObserver = function(t1, e1, n, o) {
                    var s = {}, l = !0;
                    e1 && e1._commandObserver && (s = e1._commandObserver), s.cache || (s.cache = {}), s.lookupTable = {};
                    var c = r.hasSimpleAPICommandBindings(t1, n, s.lookupTable);
                    if (e1 && e1._commandObserver) {
                        if (c) return s;
                        if (e1._commandObserver.remove) return e1._commandObserver.remove(), e1._commandObserver = null, s;
                    }
                    if (c) {
                        a(t1, c, s.cache), s.check = function() {
                            if (l) {
                                var e1 = a(t1, c, s.cache);
                                return e1.changed && o && void 0 !== s.lookupTable[e1.value] && (s.disable(), Promise.resolve(o({
                                    value: e1.value,
                                    type: c.type,
                                    prop: c.prop,
                                    traces: c.traces,
                                    index: s.lookupTable[e1.value]
                                })).then(s.enable, s.enable)), e1.changed;
                            }
                        };
                        for(var u = [
                            "plotly_relayout",
                            "plotly_redraw",
                            "plotly_restyle",
                            "plotly_update",
                            "plotly_animatingframe",
                            "plotly_afterplot"
                        ], f = 0; f < u.length; f++)t1._internalOn(u[f], s.check);
                        s.remove = function() {
                            for(var e1 = 0; e1 < u.length; e1++)t1._removeInternalListener(u[e1], s.check);
                        };
                    } else i.log("Unable to automatically bind plot updates to API command"), s.lookupTable = {}, s.remove = function() {};
                    return s.disable = function() {
                        l = !1;
                    }, s.enable = function() {
                        l = !0;
                    }, e1 && (e1._commandObserver = s), s;
                }, r.hasSimpleAPICommandBindings = function(t1, e1, n) {
                    var i, a, o = e1.length;
                    for(i = 0; i < o; i++){
                        var s, l = e1[i], c = l.method, u = l.args;
                        if (Array.isArray(u) || (u = []), !c) return !1;
                        var f = r.computeAPICommandBindings(t1, c, u);
                        if (1 !== f.length) return !1;
                        if (a) {
                            if ((s = f[0]).type !== a.type) return !1;
                            if (s.prop !== a.prop) return !1;
                            if (Array.isArray(a.traces)) {
                                if (!Array.isArray(s.traces)) return !1;
                                s.traces.sort();
                                for(var h = 0; h < a.traces.length; h++)if (a.traces[h] !== s.traces[h]) return !1;
                            } else if (s.prop !== a.prop) return !1;
                        } else a = f[0], Array.isArray(a.traces) && a.traces.sort();
                        var p = (s = f[0]).value;
                        if (Array.isArray(p)) {
                            if (1 !== p.length) return !1;
                            p = p[0];
                        }
                        n && (n[p] = i);
                    }
                    return a;
                }, r.executeAPICommand = function(t1, e1, r) {
                    if ("skip" === e1) return Promise.resolve();
                    var a = n.apiMethodRegistry[e1], o = [
                        t1
                    ];
                    Array.isArray(r) || (r = []);
                    for(var s = 0; s < r.length; s++)o.push(r[s]);
                    return a.apply(null, o).catch(function(t1) {
                        return i.warn("API call to Plotly." + e1 + " rejected.", t1), Promise.reject(t1);
                    });
                }, r.computeAPICommandBindings = function(t1, e1, r) {
                    var n;
                    switch(Array.isArray(r) || (r = []), e1){
                        case "restyle":
                            n = s(t1, r);
                            break;
                        case "relayout":
                            n = o(t1, r);
                            break;
                        case "update":
                            n = s(t1, [
                                r[0],
                                r[2]
                            ]).concat(o(t1, [
                                r[1]
                            ]));
                            break;
                        case "animate":
                            n = function(t1, e1) {
                                return Array.isArray(e1[0]) && 1 === e1[0].length && -1 !== [
                                    "string",
                                    "number"
                                ].indexOf(typeof e1[0][0]) ? [
                                    {
                                        type: "layout",
                                        prop: "_currentFrame",
                                        value: e1[0][0].toString()
                                    }
                                ] : [];
                            }(0, r);
                            break;
                        default:
                            n = [];
                    }
                    return n;
                };
            },
            {
                "../lib": 503,
                "../registry": 638
            }
        ],
        584: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib/extend").extendFlat;
                r.attributes = function(t1, e1) {
                    e1 = e1 || {};
                    var r = {
                        valType: "info_array",
                        editType: (t1 = t1 || {}).editType,
                        items: [
                            {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: t1.editType
                            },
                            {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: t1.editType
                            }
                        ],
                        dflt: [
                            0,
                            1
                        ]
                    }, i = (t1.name && t1.name, t1.trace, e1.description && e1.description, {
                        x: n({}, r, {}),
                        y: n({}, r, {}),
                        editType: t1.editType
                    });
                    return t1.noGridCell || (i.row = {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: t1.editType
                    }, i.column = {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: t1.editType
                    }), i;
                }, r.defaults = function(t1, e1, r, n) {
                    var i = n && n.x || [
                        0,
                        1
                    ], a = n && n.y || [
                        0,
                        1
                    ], o = e1.grid;
                    if (o) {
                        var s = r("domain.column");
                        void 0 !== s && (s < o.columns ? i = o._domains.x[s] : delete t1.domain.column);
                        var l = r("domain.row");
                        void 0 !== l && (l < o.rows ? a = o._domains.y[l] : delete t1.domain.row);
                    }
                    var c = r("domain.x", i), u = r("domain.y", a);
                    c[0] < c[1] || (t1.domain.x = i.slice()), u[0] < u[1] || (t1.domain.y = a.slice());
                };
            },
            {
                "../lib/extend": 493
            }
        ],
        585: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    var e1 = t1.editType, r = t1.colorEditType;
                    void 0 === r && (r = e1);
                    var n = {
                        family: {
                            valType: "string",
                            noBlank: !0,
                            strict: !0,
                            editType: e1
                        },
                        size: {
                            valType: "number",
                            min: 1,
                            editType: e1
                        },
                        color: {
                            valType: "color",
                            editType: r
                        },
                        editType: e1
                    };
                    return t1.autoSize && (n.size.dflt = "auto"), t1.autoColor && (n.color.dflt = "auto"), t1.arrayOk && (n.family.arrayOk = !0, n.size.arrayOk = !0, n.color.arrayOk = !0), n;
                };
            },
            {}
        ],
        586: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    _isLinkedToArray: "frames_entry",
                    group: {
                        valType: "string"
                    },
                    name: {
                        valType: "string"
                    },
                    traces: {
                        valType: "any"
                    },
                    baseframe: {
                        valType: "string"
                    },
                    data: {
                        valType: "any"
                    },
                    layout: {
                        valType: "any"
                    }
                };
            },
            {}
        ],
        587: [
            function(t1, e1, r) {
                "use strict";
                r.projNames = {
                    airy: "airy",
                    aitoff: "aitoff",
                    "albers usa": "albersUsa",
                    albers: "albers",
                    august: "august",
                    "azimuthal equal area": "azimuthalEqualArea",
                    "azimuthal equidistant": "azimuthalEquidistant",
                    baker: "baker",
                    bertin1953: "bertin1953",
                    boggs: "boggs",
                    bonne: "bonne",
                    bottomley: "bottomley",
                    bromley: "bromley",
                    collignon: "collignon",
                    "conic conformal": "conicConformal",
                    "conic equal area": "conicEqualArea",
                    "conic equidistant": "conicEquidistant",
                    craig: "craig",
                    craster: "craster",
                    "cylindrical equal area": "cylindricalEqualArea",
                    "cylindrical stereographic": "cylindricalStereographic",
                    eckert1: "eckert1",
                    eckert2: "eckert2",
                    eckert3: "eckert3",
                    eckert4: "eckert4",
                    eckert5: "eckert5",
                    eckert6: "eckert6",
                    eisenlohr: "eisenlohr",
                    equirectangular: "equirectangular",
                    fahey: "fahey",
                    "foucaut sinusoidal": "foucautSinusoidal",
                    foucaut: "foucaut",
                    ginzburg4: "ginzburg4",
                    ginzburg5: "ginzburg5",
                    ginzburg6: "ginzburg6",
                    ginzburg8: "ginzburg8",
                    ginzburg9: "ginzburg9",
                    gnomonic: "gnomonic",
                    "gringorten quincuncial": "gringortenQuincuncial",
                    gringorten: "gringorten",
                    guyou: "guyou",
                    hammer: "hammer",
                    hill: "hill",
                    homolosine: "homolosine",
                    hufnagel: "hufnagel",
                    hyperelliptical: "hyperelliptical",
                    kavrayskiy7: "kavrayskiy7",
                    lagrange: "lagrange",
                    larrivee: "larrivee",
                    laskowski: "laskowski",
                    loximuthal: "loximuthal",
                    mercator: "mercator",
                    miller: "miller",
                    mollweide: "mollweide",
                    "mt flat polar parabolic": "mtFlatPolarParabolic",
                    "mt flat polar quartic": "mtFlatPolarQuartic",
                    "mt flat polar sinusoidal": "mtFlatPolarSinusoidal",
                    "natural earth": "naturalEarth",
                    "natural earth1": "naturalEarth1",
                    "natural earth2": "naturalEarth2",
                    "nell hammer": "nellHammer",
                    nicolosi: "nicolosi",
                    orthographic: "orthographic",
                    patterson: "patterson",
                    "peirce quincuncial": "peirceQuincuncial",
                    polyconic: "polyconic",
                    "rectangular polyconic": "rectangularPolyconic",
                    robinson: "robinson",
                    satellite: "satellite",
                    "sinu mollweide": "sinuMollweide",
                    sinusoidal: "sinusoidal",
                    stereographic: "stereographic",
                    times: "times",
                    "transverse mercator": "transverseMercator",
                    "van der grinten": "vanDerGrinten",
                    "van der grinten2": "vanDerGrinten2",
                    "van der grinten3": "vanDerGrinten3",
                    "van der grinten4": "vanDerGrinten4",
                    wagner4: "wagner4",
                    wagner6: "wagner6",
                    wiechel: "wiechel",
                    "winkel tripel": "winkel3",
                    winkel3: "winkel3"
                }, r.axesNames = [
                    "lonaxis",
                    "lataxis"
                ], r.lonaxisSpan = {
                    orthographic: 180,
                    "azimuthal equal area": 360,
                    "azimuthal equidistant": 360,
                    "conic conformal": 180,
                    gnomonic: 160,
                    stereographic: 180,
                    "transverse mercator": 180,
                    "*": 360
                }, r.lataxisSpan = {
                    "conic conformal": 150,
                    stereographic: 179.5,
                    "*": 180
                }, r.scopeDefaults = {
                    world: {
                        lonaxisRange: [
                            -180,
                            180
                        ],
                        lataxisRange: [
                            -90,
                            90
                        ],
                        projType: "equirectangular",
                        projRotate: [
                            0,
                            0,
                            0
                        ]
                    },
                    usa: {
                        lonaxisRange: [
                            -180,
                            -50
                        ],
                        lataxisRange: [
                            15,
                            80
                        ],
                        projType: "albers usa"
                    },
                    europe: {
                        lonaxisRange: [
                            -30,
                            60
                        ],
                        lataxisRange: [
                            30,
                            85
                        ],
                        projType: "conic conformal",
                        projRotate: [
                            15,
                            0,
                            0
                        ],
                        projParallels: [
                            0,
                            60
                        ]
                    },
                    asia: {
                        lonaxisRange: [
                            22,
                            160
                        ],
                        lataxisRange: [
                            -15,
                            55
                        ],
                        projType: "mercator",
                        projRotate: [
                            0,
                            0,
                            0
                        ]
                    },
                    africa: {
                        lonaxisRange: [
                            -30,
                            60
                        ],
                        lataxisRange: [
                            -40,
                            40
                        ],
                        projType: "mercator",
                        projRotate: [
                            0,
                            0,
                            0
                        ]
                    },
                    "north america": {
                        lonaxisRange: [
                            -180,
                            -45
                        ],
                        lataxisRange: [
                            5,
                            85
                        ],
                        projType: "conic conformal",
                        projRotate: [
                            -100,
                            0,
                            0
                        ],
                        projParallels: [
                            29.5,
                            45.5
                        ]
                    },
                    "south america": {
                        lonaxisRange: [
                            -100,
                            -30
                        ],
                        lataxisRange: [
                            -60,
                            15
                        ],
                        projType: "mercator",
                        projRotate: [
                            0,
                            0,
                            0
                        ]
                    }
                }, r.clipPad = .001, r.precision = .1, r.landColor = "#F0DC82", r.waterColor = "#3399FF", r.locationmodeToLayer = {
                    "ISO-3": "countries",
                    "USA-states": "subunits",
                    "country names": "countries"
                }, r.sphereSVG = {
                    type: "Sphere"
                }, r.fillLayers = {
                    ocean: 1,
                    land: 1,
                    lakes: 1
                }, r.lineLayers = {
                    subunits: 1,
                    countries: 1,
                    coastlines: 1,
                    rivers: 1,
                    frame: 1
                }, r.layers = [
                    "bg",
                    "ocean",
                    "land",
                    "lakes",
                    "subunits",
                    "countries",
                    "coastlines",
                    "rivers",
                    "lataxis",
                    "lonaxis",
                    "frame",
                    "backplot",
                    "frontplot"
                ], r.layersForChoropleth = [
                    "bg",
                    "ocean",
                    "land",
                    "subunits",
                    "countries",
                    "coastlines",
                    "lataxis",
                    "lonaxis",
                    "frame",
                    "backplot",
                    "rivers",
                    "lakes",
                    "frontplot"
                ], r.layerNameToAdjective = {
                    ocean: "ocean",
                    land: "land",
                    lakes: "lake",
                    subunits: "subunit",
                    countries: "country",
                    coastlines: "coastline",
                    rivers: "river",
                    frame: "frame"
                };
            },
            {}
        ],
        588: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("d3-geo"), a = i.geoPath, o = i.geoDistance, s = t1("d3-geo-projection"), l = t1("../../registry"), c = t1("../../lib"), u = c.strTranslate, f = t1("../../components/color"), h = t1("../../components/drawing"), p = t1("../../components/fx"), d = t1("../plots"), m = t1("../cartesian/axes"), g = t1("../cartesian/autorange").getAutoRange, v = t1("../../components/dragelement"), y = t1("../cartesian/select").prepSelect, x = t1("../cartesian/select").clearSelect, b = t1("../cartesian/select").selectOnClick, _ = t1("./zoom"), w = t1("./constants"), T = t1("../../lib/geo_location_utils"), k = t1("../../lib/topojson_utils"), A = t1("topojson-client").feature;
                function M(t1) {
                    this.id = t1.id, this.graphDiv = t1.graphDiv, this.container = t1.container, this.topojsonURL = t1.topojsonURL, this.isStatic = t1.staticPlot, this.topojsonName = null, this.topojson = null, this.projection = null, this.scope = null, this.viewInitial = null, this.fitScale = null, this.bounds = null, this.midPt = null, this.hasChoropleth = !1, this.traceHash = {}, this.layers = {}, this.basePaths = {}, this.dataPaths = {}, this.dataPoints = {}, this.clipDef = null, this.clipRect = null, this.bgRect = null, this.makeFramework();
                }
                var S = M.prototype;
                function E(t1, e1) {
                    var r = w.clipPad, n = t1[0] + r, i = t1[1] - r, a = e1[0] + r, o = e1[1] - r;
                    n > 0 && i < 0 && (i += 360);
                    var s = (i - n) / 4;
                    return {
                        type: "Polygon",
                        coordinates: [
                            [
                                [
                                    n,
                                    a
                                ],
                                [
                                    n,
                                    o
                                ],
                                [
                                    n + s,
                                    o
                                ],
                                [
                                    n + 2 * s,
                                    o
                                ],
                                [
                                    n + 3 * s,
                                    o
                                ],
                                [
                                    i,
                                    o
                                ],
                                [
                                    i,
                                    a
                                ],
                                [
                                    i - s,
                                    a
                                ],
                                [
                                    i - 2 * s,
                                    a
                                ],
                                [
                                    i - 3 * s,
                                    a
                                ],
                                [
                                    n,
                                    a
                                ]
                            ]
                        ]
                    };
                }
                e1.exports = function(t1) {
                    return new M(t1);
                }, S.plot = function(t1, e1, r) {
                    var n = this, i = e1[this.id], a = [], o = !1;
                    for(var s in w.layerNameToAdjective)if ("frame" !== s && i["show" + s]) {
                        o = !0;
                        break;
                    }
                    for(var l = 0; l < t1.length; l++)if (t1[0][0].trace.locationmode) {
                        o = !0;
                        break;
                    }
                    if (o) {
                        var c = k.getTopojsonName(i);
                        null !== n.topojson && c === n.topojsonName || (n.topojsonName = c, void 0 === PlotlyGeoAssets.topojson[n.topojsonName] && a.push(n.fetchTopojson()));
                    }
                    a = a.concat(T.fetchTraceGeoData(t1)), r.push(new Promise(function(r, i) {
                        Promise.all(a).then(function() {
                            n.topojson = PlotlyGeoAssets.topojson[n.topojsonName], n.update(t1, e1), r();
                        }).catch(i);
                    }));
                }, S.fetchTopojson = function() {
                    var t1 = this, e1 = k.getTopojsonPath(t1.topojsonURL, t1.topojsonName);
                    return new Promise(function(r, i) {
                        n.json(e1, function(n, a) {
                            if (n) return 404 === n.status ? i(new Error([
                                "plotly.js could not find topojson file at",
                                e1,
                                ".",
                                "Make sure the *topojsonURL* plot config option",
                                "is set properly."
                            ].join(" "))) : i(new Error([
                                "unexpected error while fetching topojson file at",
                                e1
                            ].join(" ")));
                            PlotlyGeoAssets.topojson[t1.topojsonName] = a, r();
                        });
                    });
                }, S.update = function(t1, e1) {
                    var r = e1[this.id];
                    this.hasChoropleth = !1;
                    for(var n = 0; n < t1.length; n++){
                        var i = t1[n], a = i[0].trace;
                        "choropleth" === a.type && (this.hasChoropleth = !0), !0 === a.visible && a._length > 0 && a._module.calcGeoJSON(i, e1);
                    }
                    if (!this.updateProjection(t1, e1)) {
                        this.viewInitial && this.scope === r.scope || this.saveViewInitial(r), this.scope = r.scope, this.updateBaseLayers(e1, r), this.updateDims(e1, r), this.updateFx(e1, r), d.generalUpdatePerTraceModule(this.graphDiv, this, t1, r);
                        var o = this.layers.frontplot.select(".scatterlayer");
                        this.dataPoints.point = o.selectAll(".point"), this.dataPoints.text = o.selectAll("text"), this.dataPaths.line = o.selectAll(".js-line");
                        var s = this.layers.backplot.select(".choroplethlayer");
                        this.dataPaths.choropleth = s.selectAll("path"), this.render();
                    }
                }, S.updateProjection = function(t1, e1) {
                    var r = this.graphDiv, n = e1[this.id], l = e1._size, u = n.domain, f = n.projection, h = n.lonaxis, p = n.lataxis, d = h._ax, m = p._ax, v = this.projection = function(t1) {
                        var e1 = t1.projection, r = e1.type, n = w.projNames[r];
                        n = "geo" + c.titleCase(n);
                        for(var l = (i[n] || s[n])(), u = t1._isSatellite ? 180 * Math.acos(1 / e1.distance) / Math.PI : t1._isClipped ? w.lonaxisSpan[r] / 2 : null, f = [
                            "center",
                            "rotate",
                            "parallels",
                            "clipExtent"
                        ], h = function(t1) {
                            return t1 ? l : [];
                        }, p = 0; p < f.length; p++){
                            var d = f[p];
                            "function" != typeof l[d] && (l[d] = h);
                        }
                        l.isLonLatOverEdges = function(t1) {
                            if (null === l(t1)) return !0;
                            if (u) {
                                var e1 = l.rotate();
                                return o(t1, [
                                    -e1[0],
                                    -e1[1]
                                ]) > u * Math.PI / 180;
                            }
                            return !1;
                        }, l.getPath = function() {
                            return a().projection(l);
                        }, l.getBounds = function(t1) {
                            return l.getPath().bounds(t1);
                        }, l.precision(w.precision), t1._isSatellite && l.tilt(e1.tilt).distance(e1.distance);
                        u && l.clipAngle(u - w.clipPad);
                        return l;
                    }(n), y = [
                        [
                            l.l + l.w * u.x[0],
                            l.t + l.h * (1 - u.y[1])
                        ],
                        [
                            l.l + l.w * u.x[1],
                            l.t + l.h * (1 - u.y[0])
                        ]
                    ], x = n.center || {}, b = f.rotation || {}, _ = h.range || [], T = p.range || [];
                    if (n.fitbounds) {
                        d._length = y[1][0] - y[0][0], m._length = y[1][1] - y[0][1], d.range = g(r, d), m.range = g(r, m);
                        var k = (d.range[0] + d.range[1]) / 2, A = (m.range[0] + m.range[1]) / 2;
                        if (n._isScoped) x = {
                            lon: k,
                            lat: A
                        };
                        else if (n._isClipped) {
                            x = {
                                lon: k,
                                lat: A
                            }, b = {
                                lon: k,
                                lat: A,
                                roll: b.roll
                            };
                            var M = f.type, S = w.lonaxisSpan[M] / 2 || 180, L = w.lataxisSpan[M] / 2 || 90;
                            _ = [
                                k - S,
                                k + S
                            ], T = [
                                A - L,
                                A + L
                            ];
                        } else x = {
                            lon: k,
                            lat: A
                        }, b = {
                            lon: k,
                            lat: b.lat,
                            roll: b.roll
                        };
                    }
                    v.center([
                        x.lon - b.lon,
                        x.lat - b.lat
                    ]).rotate([
                        -b.lon,
                        -b.lat,
                        b.roll
                    ]).parallels(f.parallels);
                    var C = E(_, T);
                    v.fitExtent(y, C);
                    var P = this.bounds = v.getBounds(C), I = this.fitScale = v.scale(), O = v.translate();
                    if (n.fitbounds) {
                        var z = v.getBounds(E(d.range, m.range)), D = Math.min((P[1][0] - P[0][0]) / (z[1][0] - z[0][0]), (P[1][1] - P[0][1]) / (z[1][1] - z[0][1]));
                        isFinite(D) ? v.scale(D * I) : c.warn("Something went wrong during" + this.id + "fitbounds computations.");
                    } else v.scale(f.scale * I);
                    var R = this.midPt = [
                        (P[0][0] + P[1][0]) / 2,
                        (P[0][1] + P[1][1]) / 2
                    ];
                    if (v.translate([
                        O[0] + (R[0] - O[0]),
                        O[1] + (R[1] - O[1])
                    ]).clipExtent(P), n._isAlbersUsa) {
                        var F = v([
                            x.lon,
                            x.lat
                        ]), B = v.translate();
                        v.translate([
                            B[0] - (F[0] - B[0]),
                            B[1] - (F[1] - B[1])
                        ]);
                    }
                }, S.updateBaseLayers = function(t1, e1) {
                    var r = this, i = r.topojson, a = r.layers, o = r.basePaths;
                    function s(t1) {
                        return "lonaxis" === t1 || "lataxis" === t1;
                    }
                    function l(t1) {
                        return Boolean(w.lineLayers[t1]);
                    }
                    function c(t1) {
                        return Boolean(w.fillLayers[t1]);
                    }
                    var u = (this.hasChoropleth ? w.layersForChoropleth : w.layers).filter(function(t1) {
                        return l(t1) || c(t1) ? e1["show" + t1] : !s(t1) || e1[t1].showgrid;
                    }), p = r.framework.selectAll(".layer").data(u, String);
                    p.exit().each(function(t1) {
                        delete a[t1], delete o[t1], n.select(this).remove();
                    }), p.enter().append("g").attr("class", function(t1) {
                        return "layer " + t1;
                    }).each(function(t1) {
                        var e1 = a[t1] = n.select(this);
                        "bg" === t1 ? r.bgRect = e1.append("rect").style("pointer-events", "all") : s(t1) ? o[t1] = e1.append("path").style("fill", "none") : "backplot" === t1 ? e1.append("g").classed("choroplethlayer", !0) : "frontplot" === t1 ? e1.append("g").classed("scatterlayer", !0) : l(t1) ? o[t1] = e1.append("path").style("fill", "none").style("stroke-miterlimit", 2) : c(t1) && (o[t1] = e1.append("path").style("stroke", "none"));
                    }), p.order(), p.each(function(r) {
                        var n = o[r], a = w.layerNameToAdjective[r];
                        "frame" === r ? n.datum(w.sphereSVG) : l(r) || c(r) ? n.datum(A(i, i.objects[r])) : s(r) && n.datum(function(t1, e1, r) {
                            var n, i, a, o = e1[t1], s = w.scopeDefaults[e1.scope];
                            "lonaxis" === t1 ? (n = s.lonaxisRange, i = s.lataxisRange, a = function(t1, e1) {
                                return [
                                    t1,
                                    e1
                                ];
                            }) : "lataxis" === t1 && (n = s.lataxisRange, i = s.lonaxisRange, a = function(t1, e1) {
                                return [
                                    e1,
                                    t1
                                ];
                            });
                            var l = {
                                type: "linear",
                                range: [
                                    n[0],
                                    n[1] - 1e-6
                                ],
                                tick0: o.tick0,
                                dtick: o.dtick
                            };
                            m.setConvert(l, r);
                            var c = m.calcTicks(l);
                            e1.isScoped || "lonaxis" !== t1 || c.pop();
                            for(var u = c.length, f = new Array(u), h = 0; h < u; h++)for(var p = c[h].x, d = f[h] = [], g = i[0]; g < i[1] + 2.5; g += 2.5)d.push(a(p, g));
                            return {
                                type: "MultiLineString",
                                coordinates: f
                            };
                        }(r, e1, t1)).call(f.stroke, e1[r].gridcolor).call(h.dashLine, "", e1[r].gridwidth), l(r) ? n.call(f.stroke, e1[a + "color"]).call(h.dashLine, "", e1[a + "width"]) : c(r) && n.call(f.fill, e1[a + "color"]);
                    });
                }, S.updateDims = function(t1, e1) {
                    var r = this.bounds, n = (e1.framewidth || 0) / 2, i = r[0][0] - n, a = r[0][1] - n, o = r[1][0] - i + n, s = r[1][1] - a + n;
                    h.setRect(this.clipRect, i, a, o, s), this.bgRect.call(h.setRect, i, a, o, s).call(f.fill, e1.bgcolor), this.xaxis._offset = i, this.xaxis._length = o, this.yaxis._offset = a, this.yaxis._length = s;
                }, S.updateFx = function(t1, e1) {
                    var r = this, i = r.graphDiv, a = r.bgRect, o = t1.dragmode, s = t1.clickmode;
                    if (!r.isStatic) {
                        var u;
                        "select" === o ? u = function(t1, e1) {
                            (t1.range = {})[r.id] = [
                                h([
                                    e1.xmin,
                                    e1.ymin
                                ]),
                                h([
                                    e1.xmax,
                                    e1.ymax
                                ])
                            ];
                        } : "lasso" === o && (u = function(t1, e1, n) {
                            (t1.lassoPoints = {})[r.id] = n.filtered.map(h);
                        });
                        var f = {
                            element: r.bgRect.node(),
                            gd: i,
                            plotinfo: {
                                id: r.id,
                                xaxis: r.xaxis,
                                yaxis: r.yaxis,
                                fillRangeItems: u
                            },
                            xaxes: [
                                r.xaxis
                            ],
                            yaxes: [
                                r.yaxis
                            ],
                            subplot: r.id,
                            clickFn: function(t1) {
                                2 === t1 && x(i);
                            }
                        };
                        "pan" === o ? (a.node().onmousedown = null, a.call(_(r, e1)), a.on("dblclick.zoom", function() {
                            var t1 = r.viewInitial, e1 = {};
                            for(var n in t1)e1[r.id + "." + n] = t1[n];
                            l.call("_guiRelayout", i, e1), i.emit("plotly_doubleclick", null);
                        }), i._context._scrollZoom.geo || a.on("wheel.zoom", null)) : "select" !== o && "lasso" !== o || (a.on(".zoom", null), f.prepFn = function(t1, e1, r) {
                            y(t1, e1, r, f, o);
                        }, v.init(f)), a.on("mousemove", function() {
                            var t1 = r.projection.invert(c.getPositionFromD3Event());
                            if (!t1) return v.unhover(i, n.event);
                            r.xaxis.p2c = function() {
                                return t1[0];
                            }, r.yaxis.p2c = function() {
                                return t1[1];
                            }, p.hover(i, n.event, r.id);
                        }), a.on("mouseout", function() {
                            i._dragging || v.unhover(i, n.event);
                        }), a.on("click", function() {
                            "select" !== o && "lasso" !== o && (s.indexOf("select") > -1 && b(n.event, i, [
                                r.xaxis
                            ], [
                                r.yaxis
                            ], r.id, f), s.indexOf("event") > -1 && p.click(i, n.event));
                        });
                    }
                    function h(t1) {
                        return r.projection.invert([
                            t1[0] + r.xaxis._offset,
                            t1[1] + r.yaxis._offset
                        ]);
                    }
                }, S.makeFramework = function() {
                    var t1 = this, e1 = t1.graphDiv, r = e1._fullLayout, i = "clip" + r._uid + t1.id;
                    t1.clipDef = r._clips.append("clipPath").attr("id", i), t1.clipRect = t1.clipDef.append("rect"), t1.framework = n.select(t1.container).append("g").attr("class", "geo " + t1.id).call(h.setClipUrl, i, e1), t1.project = function(e1) {
                        var r = t1.projection(e1);
                        return r ? [
                            r[0] - t1.xaxis._offset,
                            r[1] - t1.yaxis._offset
                        ] : [
                            null,
                            null
                        ];
                    }, t1.xaxis = {
                        _id: "x",
                        c2p: function(e1) {
                            return t1.project(e1)[0];
                        }
                    }, t1.yaxis = {
                        _id: "y",
                        c2p: function(e1) {
                            return t1.project(e1)[1];
                        }
                    }, t1.mockAxis = {
                        type: "linear",
                        showexponent: "all",
                        exponentformat: "B"
                    }, m.setConvert(t1.mockAxis, r);
                }, S.saveViewInitial = function(t1) {
                    var e1, r = t1.center || {}, n = t1.projection, i = n.rotation || {};
                    this.viewInitial = {
                        fitbounds: t1.fitbounds,
                        "projection.scale": n.scale
                    }, e1 = t1._isScoped ? {
                        "center.lon": r.lon,
                        "center.lat": r.lat
                    } : t1._isClipped ? {
                        "projection.rotation.lon": i.lon,
                        "projection.rotation.lat": i.lat
                    } : {
                        "center.lon": r.lon,
                        "center.lat": r.lat,
                        "projection.rotation.lon": i.lon
                    }, c.extendFlat(this.viewInitial, e1);
                }, S.render = function() {
                    var t1, e1 = this.projection, r = e1.getPath();
                    function n(t1) {
                        var r = e1(t1.lonlat);
                        return r ? u(r[0], r[1]) : null;
                    }
                    function i(t1) {
                        return e1.isLonLatOverEdges(t1.lonlat) ? "none" : null;
                    }
                    for(t1 in this.basePaths)this.basePaths[t1].attr("d", r);
                    for(t1 in this.dataPaths)this.dataPaths[t1].attr("d", function(t1) {
                        return r(t1.geojson);
                    });
                    for(t1 in this.dataPoints)this.dataPoints[t1].attr("display", i).attr("transform", n);
                };
            },
            {
                "../../components/color": 366,
                "../../components/dragelement": 385,
                "../../components/drawing": 388,
                "../../components/fx": 406,
                "../../lib": 503,
                "../../lib/geo_location_utils": 496,
                "../../lib/topojson_utils": 532,
                "../../registry": 638,
                "../cartesian/autorange": 553,
                "../cartesian/axes": 554,
                "../cartesian/select": 575,
                "../plots": 619,
                "./constants": 587,
                "./zoom": 592,
                "@plotly/d3": 58,
                "d3-geo": 114,
                "d3-geo-projection": 113,
                "topojson-client": 315
            }
        ],
        589: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/get_data").getSubplotCalcData, i = t1("../../lib").counterRegex, a = t1("./geo"), o = "geo", s = i(o), l = {};
                l.geo = {
                    valType: "subplotid",
                    dflt: o,
                    editType: "calc"
                }, e1.exports = {
                    attr: o,
                    name: o,
                    idRoot: o,
                    idRegex: s,
                    attrRegex: s,
                    attributes: l,
                    layoutAttributes: t1("./layout_attributes"),
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    plot: function(t1) {
                        for(var e1 = t1._fullLayout, r = t1.calcdata, i = e1._subplots.geo, s = 0; s < i.length; s++){
                            var l = i[s], c = n(r, o, l), u = e1[l]._subplot;
                            u || (u = a({
                                id: l,
                                graphDiv: t1,
                                container: e1._geolayer.node(),
                                topojsonURL: t1._context.topojsonURL,
                                staticPlot: t1._context.staticPlot
                            }), e1[l]._subplot = u), u.plot(c, e1, t1._promises);
                        }
                    },
                    updateFx: function(t1) {
                        for(var e1 = t1._fullLayout, r = e1._subplots.geo, n = 0; n < r.length; n++){
                            var i = e1[r[n]];
                            i._subplot.updateFx(e1, i);
                        }
                    },
                    clean: function(t1, e1, r, n) {
                        for(var i = n._subplots.geo || [], a = 0; a < i.length; a++){
                            var o = i[a], s = n[o]._subplot;
                            !e1[o] && s && (s.framework.remove(), s.clipDef.remove());
                        }
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plots/get_data": 593,
                "./geo": 588,
                "./layout_attributes": 590,
                "./layout_defaults": 591
            }
        ],
        590: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color/attributes"), i = t1("../domain").attributes, a = t1("./constants"), o = t1("../../plot_api/edit_types").overrideAll, s = t1("../../lib/sort_object_keys"), l = {
                    range: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number"
                            },
                            {
                                valType: "number"
                            }
                        ]
                    },
                    showgrid: {
                        valType: "boolean",
                        dflt: !1
                    },
                    tick0: {
                        valType: "number",
                        dflt: 0
                    },
                    dtick: {
                        valType: "number"
                    },
                    gridcolor: {
                        valType: "color",
                        dflt: n.lightLine
                    },
                    gridwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    }
                };
                (e1.exports = o({
                    domain: i({
                        name: "geo"
                    }, {}),
                    fitbounds: {
                        valType: "enumerated",
                        values: [
                            !1,
                            "locations",
                            "geojson"
                        ],
                        dflt: !1,
                        editType: "plot"
                    },
                    resolution: {
                        valType: "enumerated",
                        values: [
                            110,
                            50
                        ],
                        dflt: 110,
                        coerceNumber: !0
                    },
                    scope: {
                        valType: "enumerated",
                        values: s(a.scopeDefaults),
                        dflt: "world"
                    },
                    projection: {
                        type: {
                            valType: "enumerated",
                            values: s(a.projNames)
                        },
                        rotation: {
                            lon: {
                                valType: "number"
                            },
                            lat: {
                                valType: "number"
                            },
                            roll: {
                                valType: "number"
                            }
                        },
                        tilt: {
                            valType: "number",
                            dflt: 0
                        },
                        distance: {
                            valType: "number",
                            min: 1.001,
                            dflt: 2
                        },
                        parallels: {
                            valType: "info_array",
                            items: [
                                {
                                    valType: "number"
                                },
                                {
                                    valType: "number"
                                }
                            ]
                        },
                        scale: {
                            valType: "number",
                            min: 0,
                            dflt: 1
                        }
                    },
                    center: {
                        lon: {
                            valType: "number"
                        },
                        lat: {
                            valType: "number"
                        }
                    },
                    visible: {
                        valType: "boolean",
                        dflt: !0
                    },
                    showcoastlines: {
                        valType: "boolean"
                    },
                    coastlinecolor: {
                        valType: "color",
                        dflt: n.defaultLine
                    },
                    coastlinewidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    showland: {
                        valType: "boolean",
                        dflt: !1
                    },
                    landcolor: {
                        valType: "color",
                        dflt: a.landColor
                    },
                    showocean: {
                        valType: "boolean",
                        dflt: !1
                    },
                    oceancolor: {
                        valType: "color",
                        dflt: a.waterColor
                    },
                    showlakes: {
                        valType: "boolean",
                        dflt: !1
                    },
                    lakecolor: {
                        valType: "color",
                        dflt: a.waterColor
                    },
                    showrivers: {
                        valType: "boolean",
                        dflt: !1
                    },
                    rivercolor: {
                        valType: "color",
                        dflt: a.waterColor
                    },
                    riverwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    showcountries: {
                        valType: "boolean"
                    },
                    countrycolor: {
                        valType: "color",
                        dflt: n.defaultLine
                    },
                    countrywidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    showsubunits: {
                        valType: "boolean"
                    },
                    subunitcolor: {
                        valType: "color",
                        dflt: n.defaultLine
                    },
                    subunitwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    showframe: {
                        valType: "boolean"
                    },
                    framecolor: {
                        valType: "color",
                        dflt: n.defaultLine
                    },
                    framewidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    },
                    bgcolor: {
                        valType: "color",
                        dflt: n.background
                    },
                    lonaxis: l,
                    lataxis: l
                }, "plot", "from-root")).uirevision = {
                    valType: "any",
                    editType: "none"
                };
            },
            {
                "../../components/color/attributes": 365,
                "../../lib/sort_object_keys": 526,
                "../../plot_api/edit_types": 536,
                "../domain": 584,
                "./constants": 587
            }
        ],
        591: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../subplot_defaults"), a = t1("../get_data").getSubplotData, o = t1("./constants"), s = t1("./layout_attributes"), l = o.axesNames;
                function c(t1, e1, r, i) {
                    var s = a(i.fullData, "geo", i.id).map(function(t1) {
                        return t1._expandedIndex;
                    }), c = r("resolution"), u = r("scope"), f = o.scopeDefaults[u], h = r("projection.type", f.projType), p = e1._isAlbersUsa = "albers usa" === h;
                    p && (u = e1.scope = "usa");
                    var d = e1._isScoped = "world" !== u, m = e1._isSatellite = "satellite" === h, g = e1._isConic = -1 !== h.indexOf("conic") || "albers" === h, v = e1._isClipped = !!o.lonaxisSpan[h];
                    if (!1 === t1.visible) {
                        var y = n.extendDeep({}, e1._template);
                        y.showcoastlines = !1, y.showcountries = !1, y.showframe = !1, y.showlakes = !1, y.showland = !1, y.showocean = !1, y.showrivers = !1, y.showsubunits = !1, y.lonaxis && (y.lonaxis.showgrid = !1), y.lataxis && (y.lataxis.showgrid = !1), e1._template = y;
                    }
                    for(var x = r("visible"), b = 0; b < l.length; b++){
                        var _, w = l[b], T = [
                            30,
                            10
                        ][b];
                        if (d) _ = f[w + "Range"];
                        else {
                            var k = o[w + "Span"], A = (k[h] || k["*"]) / 2, M = r("projection.rotation." + w.substr(0, 3), f.projRotate[b]);
                            _ = [
                                M - A,
                                M + A
                            ];
                        }
                        var S = r(w + ".range", _);
                        r(w + ".tick0"), r(w + ".dtick", T), r(w + ".showgrid", !!x && void 0) && (r(w + ".gridcolor"), r(w + ".gridwidth")), e1[w]._ax = {
                            type: "linear",
                            _id: w.slice(0, 3),
                            _traceIndices: s,
                            setScale: n.identity,
                            c2l: n.identity,
                            r2l: n.identity,
                            autorange: !0,
                            range: S.slice(),
                            _m: 1,
                            _input: {}
                        };
                    }
                    var E = e1.lonaxis.range, L = e1.lataxis.range, C = E[0], P = E[1];
                    C > 0 && P < 0 && (P += 360);
                    var I, O, z, D = (C + P) / 2;
                    if (!p) {
                        var R = d ? f.projRotate : [
                            D,
                            0,
                            0
                        ];
                        I = r("projection.rotation.lon", R[0]), r("projection.rotation.lat", R[1]), r("projection.rotation.roll", R[2]), r("showcoastlines", !d && x) && (r("coastlinecolor"), r("coastlinewidth")), r("showocean", !!x && void 0) && r("oceancolor");
                    }
                    (p ? (O = -96.6, z = 38.7) : (O = d ? D : I, z = (L[0] + L[1]) / 2), r("center.lon", O), r("center.lat", z), m && (r("projection.tilt"), r("projection.distance")), g) && r("projection.parallels", f.projParallels || [
                        0,
                        60
                    ]);
                    r("projection.scale"), r("showland", !!x && void 0) && r("landcolor"), r("showlakes", !!x && void 0) && r("lakecolor"), r("showrivers", !!x && void 0) && (r("rivercolor"), r("riverwidth")), r("showcountries", d && "usa" !== u && x) && (r("countrycolor"), r("countrywidth")), ("usa" === u || "north america" === u && 50 === c) && (r("showsubunits", x), r("subunitcolor"), r("subunitwidth")), d || r("showframe", x) && (r("framecolor"), r("framewidth")), r("bgcolor"), r("fitbounds") && (delete e1.projection.scale, d ? (delete e1.center.lon, delete e1.center.lat) : v ? (delete e1.center.lon, delete e1.center.lat, delete e1.projection.rotation.lon, delete e1.projection.rotation.lat, delete e1.lonaxis.range, delete e1.lataxis.range) : (delete e1.center.lon, delete e1.center.lat, delete e1.projection.rotation.lon));
                }
                e1.exports = function(t1, e1, r) {
                    i(t1, e1, r, {
                        type: "geo",
                        attributes: s,
                        handleDefaults: c,
                        fullData: r,
                        partition: "y"
                    });
                };
            },
            {
                "../../lib": 503,
                "../get_data": 593,
                "../subplot_defaults": 632,
                "./constants": 587,
                "./layout_attributes": 590
            }
        ],
        592: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../../registry"), o = Math.PI / 180, s = 180 / Math.PI, l = {
                    cursor: "pointer"
                }, c = {
                    cursor: "auto"
                };
                function u(t1, e1) {
                    return n.behavior.zoom().translate(e1.translate()).scale(e1.scale());
                }
                function f(t1, e1, r) {
                    var n = t1.id, o = t1.graphDiv, s = o.layout, l = s[n], c = o._fullLayout, u = c[n], f = {}, h = {};
                    function p(t1, e1) {
                        f[n + "." + t1] = i.nestedProperty(l, t1).get(), a.call("_storeDirectGUIEdit", s, c._preGUI, f);
                        var r = i.nestedProperty(u, t1);
                        r.get() !== e1 && (r.set(e1), i.nestedProperty(l, t1).set(e1), h[n + "." + t1] = e1);
                    }
                    r(p), p("projection.scale", e1.scale() / t1.fitScale), p("fitbounds", !1), o.emit("plotly_relayout", h);
                }
                function h(t1, e1) {
                    var r = u(0, e1);
                    function i(r) {
                        var n = e1.invert(t1.midPt);
                        r("center.lon", n[0]), r("center.lat", n[1]);
                    }
                    return r.on("zoomstart", function() {
                        n.select(this).style(l);
                    }).on("zoom", function() {
                        e1.scale(n.event.scale).translate(n.event.translate), t1.render();
                        var r = e1.invert(t1.midPt);
                        t1.graphDiv.emit("plotly_relayouting", {
                            "geo.projection.scale": e1.scale() / t1.fitScale,
                            "geo.center.lon": r[0],
                            "geo.center.lat": r[1]
                        });
                    }).on("zoomend", function() {
                        n.select(this).style(c), f(t1, e1, i);
                    }), r;
                }
                function p(t1, e1) {
                    var r, i, a, o, s, h, p, d, m, g = u(0, e1);
                    function v(t1) {
                        return e1.invert(t1);
                    }
                    function y(r) {
                        var n = e1.rotate(), i = e1.invert(t1.midPt);
                        r("projection.rotation.lon", -n[0]), r("center.lon", i[0]), r("center.lat", i[1]);
                    }
                    return g.on("zoomstart", function() {
                        n.select(this).style(l), r = n.mouse(this), i = e1.rotate(), a = e1.translate(), o = i, s = v(r);
                    }).on("zoom", function() {
                        if (h = n.mouse(this), function(t1) {
                            var r = v(t1);
                            if (!r) return !0;
                            var n = e1(r);
                            return Math.abs(n[0] - t1[0]) > 2 || Math.abs(n[1] - t1[1]) > 2;
                        }(r)) return g.scale(e1.scale()), void g.translate(e1.translate());
                        e1.scale(n.event.scale), e1.translate([
                            a[0],
                            n.event.translate[1]
                        ]), s ? v(h) && (d = v(h), p = [
                            o[0] + (d[0] - s[0]),
                            i[1],
                            i[2]
                        ], e1.rotate(p), o = p) : s = v(r = h), m = !0, t1.render();
                        var l = e1.rotate(), c = e1.invert(t1.midPt);
                        t1.graphDiv.emit("plotly_relayouting", {
                            "geo.projection.scale": e1.scale() / t1.fitScale,
                            "geo.center.lon": c[0],
                            "geo.center.lat": c[1],
                            "geo.projection.rotation.lon": -l[0]
                        });
                    }).on("zoomend", function() {
                        n.select(this).style(c), m && f(t1, e1, y);
                    }), g;
                }
                function d(t1, e1) {
                    var r, i = {
                        r: e1.rotate(),
                        k: e1.scale()
                    }, a = u(0, e1), o = function(t1) {
                        var e1 = 0, r = arguments.length, i = [];
                        for(; ++e1 < r;)i.push(arguments[e1]);
                        var a = n.dispatch.apply(null, i);
                        return a.of = function(e1, r) {
                            return function(i) {
                                var o;
                                try {
                                    o = i.sourceEvent = n.event, i.target = t1, n.event = i, a[i.type].apply(e1, r);
                                } finally{
                                    n.event = o;
                                }
                            };
                        }, a;
                    }(a, "zoomstart", "zoom", "zoomend"), s = 0, h = a.on;
                    function p(t1) {
                        s++ || t1({
                            type: "zoomstart"
                        });
                    }
                    function d(t1) {
                        t1({
                            type: "zoom"
                        });
                    }
                    function b(t1) {
                        --s || t1({
                            type: "zoomend"
                        });
                    }
                    function _(t1) {
                        var r = e1.rotate();
                        t1("projection.rotation.lon", -r[0]), t1("projection.rotation.lat", -r[1]);
                    }
                    return a.on("zoomstart", function() {
                        n.select(this).style(l);
                        var t1 = n.mouse(this), s = e1.rotate(), c = s, u = e1.translate(), f = g(s);
                        r = m(e1, t1), h.call(a, "zoom", function() {
                            var a = n.mouse(this);
                            if (e1.scale(i.k = n.event.scale), r) {
                                if (m(e1, a)) {
                                    e1.rotate(s).translate(u);
                                    var l = m(e1, a), h = y(r, l), p = T(v(f, h)), g = i.r = x(p, r, c);
                                    isFinite(g[0]) && isFinite(g[1]) && isFinite(g[2]) || (g = c), e1.rotate(g), c = g;
                                }
                            } else r = m(e1, t1 = a);
                            d(o.of(this, arguments));
                        }), p(o.of(this, arguments));
                    }).on("zoomend", function() {
                        n.select(this).style(c), h.call(a, "zoom", null), b(o.of(this, arguments)), f(t1, e1, _);
                    }).on("zoom.redraw", function() {
                        t1.render();
                        var r = e1.rotate();
                        t1.graphDiv.emit("plotly_relayouting", {
                            "geo.projection.scale": e1.scale() / t1.fitScale,
                            "geo.projection.rotation.lon": -r[0],
                            "geo.projection.rotation.lat": -r[1]
                        });
                    }), n.rebind(a, o, "on");
                }
                function m(t1, e1) {
                    var r = t1.invert(e1);
                    return r && isFinite(r[0]) && isFinite(r[1]) && function(t1) {
                        var e1 = t1[0] * o, r = t1[1] * o, n = Math.cos(r);
                        return [
                            n * Math.cos(e1),
                            n * Math.sin(e1),
                            Math.sin(r)
                        ];
                    }(r);
                }
                function g(t1) {
                    var e1 = .5 * t1[0] * o, r = .5 * t1[1] * o, n = .5 * t1[2] * o, i = Math.sin(e1), a = Math.cos(e1), s = Math.sin(r), l = Math.cos(r), c = Math.sin(n), u = Math.cos(n);
                    return [
                        a * l * u + i * s * c,
                        i * l * u - a * s * c,
                        a * s * u + i * l * c,
                        a * l * c - i * s * u
                    ];
                }
                function v(t1, e1) {
                    var r = t1[0], n = t1[1], i = t1[2], a = t1[3], o = e1[0], s = e1[1], l = e1[2], c = e1[3];
                    return [
                        r * o - n * s - i * l - a * c,
                        r * s + n * o + i * c - a * l,
                        r * l - n * c + i * o + a * s,
                        r * c + n * l - i * s + a * o
                    ];
                }
                function y(t1, e1) {
                    if (t1 && e1) {
                        var r = function(t1, e1) {
                            return [
                                t1[1] * e1[2] - t1[2] * e1[1],
                                t1[2] * e1[0] - t1[0] * e1[2],
                                t1[0] * e1[1] - t1[1] * e1[0]
                            ];
                        }(t1, e1), n = Math.sqrt(k(r, r)), i = .5 * Math.acos(Math.max(-1, Math.min(1, k(t1, e1)))), a = Math.sin(i) / n;
                        return n && [
                            Math.cos(i),
                            r[2] * a,
                            -r[1] * a,
                            r[0] * a
                        ];
                    }
                }
                function x(t1, e1, r) {
                    var n = w(e1, 2, t1[0]);
                    n = w(n, 1, t1[1]), n = w(n, 0, t1[2] - r[2]);
                    var i, a, o = e1[0], l = e1[1], c = e1[2], u = n[0], f = n[1], h = n[2], p = Math.atan2(l, o) * s, d = Math.sqrt(o * o + l * l);
                    Math.abs(f) > d ? (a = (f > 0 ? 90 : -90) - p, i = 0) : (a = Math.asin(f / d) * s - p, i = Math.sqrt(d * d - f * f));
                    var m = 180 - a - 2 * p, g = (Math.atan2(h, u) - Math.atan2(c, i)) * s, v = (Math.atan2(h, u) - Math.atan2(c, -i)) * s;
                    return b(r[0], r[1], a, g) <= b(r[0], r[1], m, v) ? [
                        a,
                        g,
                        r[2]
                    ] : [
                        m,
                        v,
                        r[2]
                    ];
                }
                function b(t1, e1, r, n) {
                    var i = _(r - t1), a = _(n - e1);
                    return Math.sqrt(i * i + a * a);
                }
                function _(t1) {
                    return (t1 % 360 + 540) % 360 - 180;
                }
                function w(t1, e1, r) {
                    var n = r * o, i = t1.slice(), a = 0 === e1 ? 1 : 0, s = 2 === e1 ? 1 : 2, l = Math.cos(n), c = Math.sin(n);
                    return i[a] = t1[a] * l - t1[s] * c, i[s] = t1[s] * l + t1[a] * c, i;
                }
                function T(t1) {
                    return [
                        Math.atan2(2 * (t1[0] * t1[1] + t1[2] * t1[3]), 1 - 2 * (t1[1] * t1[1] + t1[2] * t1[2])) * s,
                        Math.asin(Math.max(-1, Math.min(1, 2 * (t1[0] * t1[2] - t1[3] * t1[1])))) * s,
                        Math.atan2(2 * (t1[0] * t1[3] + t1[1] * t1[2]), 1 - 2 * (t1[2] * t1[2] + t1[3] * t1[3])) * s
                    ];
                }
                function k(t1, e1) {
                    for(var r = 0, n = 0, i = t1.length; n < i; ++n)r += t1[n] * e1[n];
                    return r;
                }
                e1.exports = function(t1, e1) {
                    var r = t1.projection;
                    return (e1._isScoped ? h : e1._isClipped ? d : p)(t1, r);
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638,
                "@plotly/d3": 58
            }
        ],
        593: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../registry"), i = t1("./cartesian/constants").SUBPLOT_PATTERN;
                r.getSubplotCalcData = function(t1, e1, r) {
                    var i = n.subplotsRegistry[e1];
                    if (!i) return [];
                    for(var a = i.attr, o = [], s = 0; s < t1.length; s++){
                        var l = t1[s];
                        l[0].trace[a] === r && o.push(l);
                    }
                    return o;
                }, r.getModuleCalcData = function(t1, e1) {
                    var r, i = [], a = [];
                    if (!(r = "string" == typeof e1 ? n.getModule(e1).plot : "function" == typeof e1 ? e1 : e1.plot)) return [
                        i,
                        t1
                    ];
                    for(var o = 0; o < t1.length; o++){
                        var s = t1[o], l = s[0].trace;
                        !0 === l.visible && 0 !== l._length && (l._module.plot === r ? i.push(s) : a.push(s));
                    }
                    return [
                        i,
                        a
                    ];
                }, r.getSubplotData = function(t1, e1, r) {
                    if (!n.subplotsRegistry[e1]) return [];
                    var a, o, s, l = n.subplotsRegistry[e1].attr, c = [];
                    if ("gl2d" === e1) {
                        var u = r.match(i);
                        o = "x" + u[1], s = "y" + u[2];
                    }
                    for(var f = 0; f < t1.length; f++)a = t1[f], "gl2d" === e1 && n.traceIs(a, "gl2d") ? a[l[0]] === o && a[l[1]] === s && c.push(a) : a[l] === r && c.push(a);
                    return c;
                };
            },
            {
                "../registry": 638,
                "./cartesian/constants": 561
            }
        ],
        594: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("mouse-change"), i = t1("mouse-wheel"), a = t1("mouse-event-offset"), o = t1("../cartesian/constants"), s = t1("has-passive-events");
                function l(t1, e1) {
                    this.element = t1, this.plot = e1, this.mouseListener = null, this.wheelListener = null, this.lastInputTime = Date.now(), this.lastPos = [
                        0,
                        0
                    ], this.boxEnabled = !1, this.boxInited = !1, this.boxStart = [
                        0,
                        0
                    ], this.boxEnd = [
                        0,
                        0
                    ], this.dragStart = [
                        0,
                        0
                    ];
                }
                e1.exports = function(t1) {
                    var e1 = t1.mouseContainer, r = t1.glplot, c = new l(e1, r);
                    function u() {
                        t1.xaxis.autorange = !1, t1.yaxis.autorange = !1;
                    }
                    function f(e1, n, i) {
                        var a, s, l = t1.calcDataBox(), f = r.viewBox, h = c.lastPos[0], p = c.lastPos[1], d = o.MINDRAG * r.pixelRatio, m = o.MINZOOM * r.pixelRatio;
                        function g(e1, r, n) {
                            var i = Math.min(r, n), a = Math.max(r, n);
                            i !== a ? (l[e1] = i, l[e1 + 2] = a, c.dataBox = l, t1.setRanges(l)) : (t1.selectBox.selectBox = [
                                0,
                                0,
                                1,
                                1
                            ], t1.glplot.setDirty());
                        }
                        switch(n *= r.pixelRatio, i *= r.pixelRatio, i = f[3] - f[1] - i, t1.fullLayout.dragmode){
                            case "zoom":
                                if (e1) {
                                    var v = n / (f[2] - f[0]) * (l[2] - l[0]) + l[0], y = i / (f[3] - f[1]) * (l[3] - l[1]) + l[1];
                                    c.boxInited || (c.boxStart[0] = v, c.boxStart[1] = y, c.dragStart[0] = n, c.dragStart[1] = i), c.boxEnd[0] = v, c.boxEnd[1] = y, c.boxInited = !0, c.boxEnabled || c.boxStart[0] === c.boxEnd[0] && c.boxStart[1] === c.boxEnd[1] || (c.boxEnabled = !0);
                                    var x = Math.abs(c.dragStart[0] - n) < m, b = Math.abs(c.dragStart[1] - i) < m;
                                    if (!function() {
                                        for(var e1 = t1.graphDiv._fullLayout._axisConstraintGroups, r = t1.xaxis._id, n = t1.yaxis._id, i = 0; i < e1.length; i++)if (-1 !== e1[i][r]) {
                                            if (-1 !== e1[i][n]) return !0;
                                            break;
                                        }
                                        return !1;
                                    }() || x && b) x && (c.boxEnd[0] = c.boxStart[0]), b && (c.boxEnd[1] = c.boxStart[1]);
                                    else {
                                        a = c.boxEnd[0] - c.boxStart[0], s = c.boxEnd[1] - c.boxStart[1];
                                        var _ = (l[3] - l[1]) / (l[2] - l[0]);
                                        Math.abs(a * _) > Math.abs(s) ? (c.boxEnd[1] = c.boxStart[1] + Math.abs(a) * _ * (s >= 0 ? 1 : -1), c.boxEnd[1] < l[1] ? (c.boxEnd[1] = l[1], c.boxEnd[0] = c.boxStart[0] + (l[1] - c.boxStart[1]) / Math.abs(_)) : c.boxEnd[1] > l[3] && (c.boxEnd[1] = l[3], c.boxEnd[0] = c.boxStart[0] + (l[3] - c.boxStart[1]) / Math.abs(_))) : (c.boxEnd[0] = c.boxStart[0] + Math.abs(s) / _ * (a >= 0 ? 1 : -1), c.boxEnd[0] < l[0] ? (c.boxEnd[0] = l[0], c.boxEnd[1] = c.boxStart[1] + (l[0] - c.boxStart[0]) * Math.abs(_)) : c.boxEnd[0] > l[2] && (c.boxEnd[0] = l[2], c.boxEnd[1] = c.boxStart[1] + (l[2] - c.boxStart[0]) * Math.abs(_)));
                                    }
                                } else c.boxEnabled ? (a = c.boxStart[0] !== c.boxEnd[0], s = c.boxStart[1] !== c.boxEnd[1], a || s ? (a && (g(0, c.boxStart[0], c.boxEnd[0]), t1.xaxis.autorange = !1), s && (g(1, c.boxStart[1], c.boxEnd[1]), t1.yaxis.autorange = !1), t1.relayoutCallback()) : t1.glplot.setDirty(), c.boxEnabled = !1, c.boxInited = !1) : c.boxInited && (c.boxInited = !1);
                                break;
                            case "pan":
                                c.boxEnabled = !1, c.boxInited = !1, e1 ? (c.panning || (c.dragStart[0] = n, c.dragStart[1] = i), Math.abs(c.dragStart[0] - n) < d && (n = c.dragStart[0]), Math.abs(c.dragStart[1] - i) < d && (i = c.dragStart[1]), a = (h - n) * (l[2] - l[0]) / (r.viewBox[2] - r.viewBox[0]), s = (p - i) * (l[3] - l[1]) / (r.viewBox[3] - r.viewBox[1]), l[0] += a, l[2] += a, l[1] += s, l[3] += s, t1.setRanges(l), c.panning = !0, c.lastInputTime = Date.now(), u(), t1.cameraChanged(), t1.handleAnnotations()) : c.panning && (c.panning = !1, t1.relayoutCallback());
                        }
                        c.lastPos[0] = n, c.lastPos[1] = i;
                    }
                    return c.mouseListener = n(e1, f), e1.addEventListener("touchstart", function(t1) {
                        var r = a(t1.changedTouches[0], e1);
                        f(0, r[0], r[1]), f(1, r[0], r[1]), t1.preventDefault();
                    }, !!s && {
                        passive: !1
                    }), e1.addEventListener("touchmove", function(t1) {
                        t1.preventDefault();
                        var r = a(t1.changedTouches[0], e1);
                        f(1, r[0], r[1]), t1.preventDefault();
                    }, !!s && {
                        passive: !1
                    }), e1.addEventListener("touchend", function(t1) {
                        f(0, c.lastPos[0], c.lastPos[1]), t1.preventDefault();
                    }, !!s && {
                        passive: !1
                    }), c.wheelListener = i(e1, function(e1, n) {
                        if (!t1.scrollZoom) return !1;
                        var i = t1.calcDataBox(), a = r.viewBox, o = c.lastPos[0], s = c.lastPos[1], l = Math.exp(5 * n / (a[3] - a[1])), f = o / (a[2] - a[0]) * (i[2] - i[0]) + i[0], h = s / (a[3] - a[1]) * (i[3] - i[1]) + i[1];
                        return i[0] = (i[0] - f) * l + f, i[2] = (i[2] - f) * l + f, i[1] = (i[1] - h) * l + h, i[3] = (i[3] - h) * l + h, t1.setRanges(i), c.lastInputTime = Date.now(), u(), t1.cameraChanged(), t1.handleAnnotations(), t1.relayoutCallback(), !0;
                    }, !0), c;
                };
            },
            {
                "../cartesian/constants": 561,
                "has-passive-events": 229,
                "mouse-change": 241,
                "mouse-event-offset": 242,
                "mouse-wheel": 244
            }
        ],
        595: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../cartesian/axes"), i = t1("../../lib/str2rgbarray");
                function a(t1) {
                    this.scene = t1, this.gl = t1.gl, this.pixelRatio = t1.pixelRatio, this.screenBox = [
                        0,
                        0,
                        1,
                        1
                    ], this.viewBox = [
                        0,
                        0,
                        1,
                        1
                    ], this.dataBox = [
                        -1,
                        -1,
                        1,
                        1
                    ], this.borderLineEnable = [
                        !1,
                        !1,
                        !1,
                        !1
                    ], this.borderLineWidth = [
                        1,
                        1,
                        1,
                        1
                    ], this.borderLineColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.ticks = [
                        [],
                        []
                    ], this.tickEnable = [
                        !0,
                        !0,
                        !1,
                        !1
                    ], this.tickPad = [
                        15,
                        15,
                        15,
                        15
                    ], this.tickAngle = [
                        0,
                        0,
                        0,
                        0
                    ], this.tickColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.tickMarkLength = [
                        0,
                        0,
                        0,
                        0
                    ], this.tickMarkWidth = [
                        0,
                        0,
                        0,
                        0
                    ], this.tickMarkColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.labels = [
                        "x",
                        "y"
                    ], this.labelEnable = [
                        !0,
                        !0,
                        !1,
                        !1
                    ], this.labelAngle = [
                        0,
                        Math.PI / 2,
                        0,
                        3 * Math.PI / 2
                    ], this.labelPad = [
                        15,
                        15,
                        15,
                        15
                    ], this.labelSize = [
                        12,
                        12
                    ], this.labelFont = [
                        "sans-serif",
                        "sans-serif"
                    ], this.labelColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.title = "", this.titleEnable = !0, this.titleCenter = [
                        0,
                        0,
                        0,
                        0
                    ], this.titleAngle = 0, this.titleColor = [
                        0,
                        0,
                        0,
                        1
                    ], this.titleFont = "sans-serif", this.titleSize = 18, this.gridLineEnable = [
                        !0,
                        !0
                    ], this.gridLineColor = [
                        [
                            0,
                            0,
                            0,
                            .5
                        ],
                        [
                            0,
                            0,
                            0,
                            .5
                        ]
                    ], this.gridLineWidth = [
                        1,
                        1
                    ], this.zeroLineEnable = [
                        !0,
                        !0
                    ], this.zeroLineWidth = [
                        1,
                        1
                    ], this.zeroLineColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.borderColor = [
                        0,
                        0,
                        0,
                        0
                    ], this.backgroundColor = [
                        0,
                        0,
                        0,
                        0
                    ], this.static = this.scene.staticPlot;
                }
                var o = a.prototype, s = [
                    "xaxis",
                    "yaxis"
                ];
                o.merge = function(t1) {
                    var e1, r, n, a, o, l, c, u, f, h, p;
                    for(this.titleEnable = !1, this.backgroundColor = i(t1.plot_bgcolor), h = 0; h < 2; ++h){
                        var d = (e1 = s[h]).charAt(0);
                        for(n = (r = t1[this.scene[e1]._name]).title.text === this.scene.fullLayout._dfltTitle[d] ? "" : r.title.text, p = 0; p <= 2; p += 2)this.labelEnable[h + p] = !1, this.labels[h + p] = n, this.labelColor[h + p] = i(r.title.font.color), this.labelFont[h + p] = r.title.font.family, this.labelSize[h + p] = r.title.font.size, this.labelPad[h + p] = this.getLabelPad(e1, r), this.tickEnable[h + p] = !1, this.tickColor[h + p] = i((r.tickfont || {}).color), this.tickAngle[h + p] = "auto" === r.tickangle ? 0 : Math.PI * -r.tickangle / 180, this.tickPad[h + p] = this.getTickPad(r), this.tickMarkLength[h + p] = 0, this.tickMarkWidth[h + p] = r.tickwidth || 0, this.tickMarkColor[h + p] = i(r.tickcolor), this.borderLineEnable[h + p] = !1, this.borderLineColor[h + p] = i(r.linecolor), this.borderLineWidth[h + p] = r.linewidth || 0;
                        c = this.hasSharedAxis(r), o = this.hasAxisInDfltPos(e1, r) && !c, l = this.hasAxisInAltrPos(e1, r) && !c, a = r.mirror || !1, u = c ? -1 !== String(a).indexOf("all") : !!a, f = c ? "allticks" === a : -1 !== String(a).indexOf("ticks"), o ? this.labelEnable[h] = !0 : l && (this.labelEnable[h + 2] = !0), o ? this.tickEnable[h] = r.showticklabels : l && (this.tickEnable[h + 2] = r.showticklabels), (o || u) && (this.borderLineEnable[h] = r.showline), (l || u) && (this.borderLineEnable[h + 2] = r.showline), (o || f) && (this.tickMarkLength[h] = this.getTickMarkLength(r)), (l || f) && (this.tickMarkLength[h + 2] = this.getTickMarkLength(r)), this.gridLineEnable[h] = r.showgrid, this.gridLineColor[h] = i(r.gridcolor), this.gridLineWidth[h] = r.gridwidth, this.zeroLineEnable[h] = r.zeroline, this.zeroLineColor[h] = i(r.zerolinecolor), this.zeroLineWidth[h] = r.zerolinewidth;
                    }
                }, o.hasSharedAxis = function(t1) {
                    var e1 = this.scene, r = e1.fullLayout._subplots.gl2d;
                    return 0 !== n.findSubplotsWithAxis(r, t1).indexOf(e1.id);
                }, o.hasAxisInDfltPos = function(t1, e1) {
                    var r = e1.side;
                    return "xaxis" === t1 ? "bottom" === r : "yaxis" === t1 ? "left" === r : void 0;
                }, o.hasAxisInAltrPos = function(t1, e1) {
                    var r = e1.side;
                    return "xaxis" === t1 ? "top" === r : "yaxis" === t1 ? "right" === r : void 0;
                }, o.getLabelPad = function(t1, e1) {
                    var r = e1.title.font.size, n = e1.showticklabels;
                    return "xaxis" === t1 ? "top" === e1.side ? r * (1.5 + (n ? 1 : 0)) - 10 : r * (1.5 + (n ? .5 : 0)) - 10 : "yaxis" === t1 ? "right" === e1.side ? 10 + r * (1.5 + (n ? 1 : .5)) : 10 + r * (1.5 + (n ? .5 : 0)) : void 0;
                }, o.getTickPad = function(t1) {
                    return "outside" === t1.ticks ? 10 + t1.ticklen : 15;
                }, o.getTickMarkLength = function(t1) {
                    if (!t1.ticks) return 0;
                    var e1 = t1.ticklen;
                    return "inside" === t1.ticks ? -e1 : e1;
                }, e1.exports = function(t1) {
                    return new a(t1);
                };
            },
            {
                "../../lib/str2rgbarray": 528,
                "../cartesian/axes": 554
            }
        ],
        596: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plot_api/edit_types").overrideAll, i = t1("./scene2d"), a = t1("../layout_attributes"), o = t1("../../constants/xmlns_namespaces"), s = t1("../cartesian/constants"), l = t1("../cartesian"), c = t1("../../components/fx/layout_attributes"), u = t1("../get_data").getSubplotData;
                r.name = "gl2d", r.attr = [
                    "xaxis",
                    "yaxis"
                ], r.idRoot = [
                    "x",
                    "y"
                ], r.idRegex = s.idRegex, r.attrRegex = s.attrRegex, r.attributes = t1("../cartesian/attributes"), r.supplyLayoutDefaults = function(t1, e1, r) {
                    e1._has("cartesian") || l.supplyLayoutDefaults(t1, e1, r);
                }, r.layoutAttrOverrides = n(l.layoutAttributes, "plot", "from-root"), r.baseLayoutAttrOverrides = n({
                    plot_bgcolor: a.plot_bgcolor,
                    hoverlabel: c.hoverlabel
                }, "plot", "nested"), r.plot = function(t1) {
                    for(var e1 = t1._fullLayout, r = t1._fullData, n = e1._subplots.gl2d, a = 0; a < n.length; a++){
                        var o = n[a], s = e1._plots[o], l = u(r, "gl2d", o), c = s._scene2d;
                        void 0 === c && (c = new i({
                            id: o,
                            graphDiv: t1,
                            container: t1.querySelector(".gl-container"),
                            staticPlot: t1._context.staticPlot,
                            plotGlPixelRatio: t1._context.plotGlPixelRatio
                        }, e1), s._scene2d = c), c.plot(l, t1.calcdata, e1, t1.layout);
                    }
                }, r.clean = function(t1, e1, r, n) {
                    for(var i = n._subplots.gl2d || [], a = 0; a < i.length; a++){
                        var o = i[a], s = n._plots[o];
                        if (s._scene2d) {
                            var c = u(t1, "gl2d", o);
                            0 === c.length && (s._scene2d.destroy(), delete n._plots[o]);
                        }
                    }
                    l.clean.apply(this, arguments);
                }, r.drawFramework = function(t1) {
                    t1._context.staticPlot || l.drawFramework(t1);
                }, r.toSVG = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots.gl2d, n = 0; n < r.length; n++){
                        var i = e1._plots[r[n]]._scene2d, a = i.toImage("png");
                        e1._glimages.append("svg:image").attr({
                            xmlns: o.svg,
                            "xlink:href": a,
                            x: 0,
                            y: 0,
                            width: "100%",
                            height: "100%",
                            preserveAspectRatio: "none"
                        }), i.destroy();
                    }
                }, r.updateFx = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots.gl2d, n = 0; n < r.length; n++)e1._plots[r[n]]._scene2d.updateFx(e1.dragmode);
                };
            },
            {
                "../../components/fx/layout_attributes": 407,
                "../../constants/xmlns_namespaces": 480,
                "../../plot_api/edit_types": 536,
                "../cartesian": 568,
                "../cartesian/attributes": 552,
                "../cartesian/constants": 561,
                "../get_data": 593,
                "../layout_attributes": 610,
                "./scene2d": 597
            }
        ],
        597: [
            function(t1, e1, r) {
                "use strict";
                var n, i, a = t1("../../registry"), o = t1("../../plots/cartesian/axes"), s = t1("../../components/fx"), l = t1("../../../stackgl_modules").gl_plot2d, c = t1("../../../stackgl_modules").gl_spikes2d, u = t1("../../../stackgl_modules").gl_select_box, f = t1("webgl-context"), h = t1("./convert"), p = t1("./camera"), d = t1("../../lib/show_no_webgl_msg"), m = t1("../cartesian/constraints"), g = m.enforce, v = m.clean, y = t1("../cartesian/autorange").doAutoRange, x = t1("../../components/dragelement/helpers"), b = x.drawMode, _ = x.selectMode, w = [
                    "xaxis",
                    "yaxis"
                ], T = t1("../cartesian/constants").SUBPLOT_PATTERN;
                function k(t1, e1) {
                    this.container = t1.container, this.graphDiv = t1.graphDiv, this.pixelRatio = t1.plotGlPixelRatio || window.devicePixelRatio, this.id = t1.id, this.staticPlot = !!t1.staticPlot, this.scrollZoom = this.graphDiv._context._scrollZoom.cartesian, this.fullData = null, this.updateRefs(e1), this.makeFramework(), this.stopped || (this.glplotOptions = h(this), this.glplotOptions.merge(e1), this.glplot = l(this.glplotOptions), this.camera = p(this), this.traces = {}, this.spikes = c(this.glplot), this.selectBox = u(this.glplot, {
                        innerFill: !1,
                        outerFill: !0
                    }), this.lastButtonState = 0, this.pickResult = null, this.isMouseOver = !0, this.stopped = !1, this.redraw = this.draw.bind(this), this.redraw());
                }
                e1.exports = k;
                var A = k.prototype;
                A.makeFramework = function() {
                    if (this.staticPlot) {
                        if (!(i || (n = document.createElement("canvas"), i = f({
                            canvas: n,
                            preserveDrawingBuffer: !1,
                            premultipliedAlpha: !0,
                            antialias: !0
                        })))) throw new Error("Error creating static canvas/context for image server");
                        this.canvas = n, this.gl = i;
                    } else {
                        var t1 = this.container.querySelector(".gl-canvas-focus"), e1 = f({
                            canvas: t1,
                            preserveDrawingBuffer: !0,
                            premultipliedAlpha: !0
                        });
                        if (!e1) return d(this), void (this.stopped = !0);
                        this.canvas = t1, this.gl = e1;
                    }
                    var r = this.canvas;
                    r.style.width = "100%", r.style.height = "100%", r.style.position = "absolute", r.style.top = "0px", r.style.left = "0px", r.style["pointer-events"] = "none", this.updateSize(r);
                    var a = this.svgContainer = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    a.style.position = "absolute", a.style.top = a.style.left = "0px", a.style.width = a.style.height = "100%", a.style["z-index"] = 20, a.style["pointer-events"] = "none";
                    var o = this.mouseContainer = document.createElement("div");
                    o.style.position = "absolute", o.style["pointer-events"] = "auto", this.pickCanvas = this.container.querySelector(".gl-canvas-pick");
                    var s = this.container;
                    s.appendChild(a), s.appendChild(o);
                    var l = this;
                    o.addEventListener("mouseout", function() {
                        l.isMouseOver = !1, l.unhover();
                    }), o.addEventListener("mouseover", function() {
                        l.isMouseOver = !0;
                    });
                }, A.toImage = function(t1) {
                    t1 || (t1 = "png"), this.stopped = !0, this.staticPlot && this.container.appendChild(n), this.updateSize(this.canvas);
                    var e1 = this.glplot.gl, r = e1.drawingBufferWidth, i = e1.drawingBufferHeight;
                    e1.clearColor(1, 1, 1, 0), e1.clear(e1.COLOR_BUFFER_BIT | e1.DEPTH_BUFFER_BIT), this.glplot.setDirty(), this.glplot.draw(), e1.bindFramebuffer(e1.FRAMEBUFFER, null);
                    var a = new Uint8Array(r * i * 4);
                    e1.readPixels(0, 0, r, i, e1.RGBA, e1.UNSIGNED_BYTE, a);
                    for(var o = 0, s = i - 1; o < s; ++o, --s)for(var l = 0; l < r; ++l)for(var c = 0; c < 4; ++c){
                        var u = a[4 * (r * o + l) + c];
                        a[4 * (r * o + l) + c] = a[4 * (r * s + l) + c], a[4 * (r * s + l) + c] = u;
                    }
                    var f = document.createElement("canvas");
                    f.width = r, f.height = i;
                    var h, p = f.getContext("2d"), d = p.createImageData(r, i);
                    switch(d.data.set(a), p.putImageData(d, 0, 0), t1){
                        case "jpeg":
                            h = f.toDataURL("image/jpeg");
                            break;
                        case "webp":
                            h = f.toDataURL("image/webp");
                            break;
                        default:
                            h = f.toDataURL("image/png");
                    }
                    return this.staticPlot && this.container.removeChild(n), h;
                }, A.updateSize = function(t1) {
                    t1 || (t1 = this.canvas);
                    var e1 = this.pixelRatio, r = this.fullLayout, n = r.width, i = r.height, a = 0 | Math.ceil(e1 * n), o = 0 | Math.ceil(e1 * i);
                    return t1.width === a && t1.height === o || (t1.width = a, t1.height = o), t1;
                }, A.computeTickMarks = function() {
                    this.xaxis.setScale(), this.yaxis.setScale();
                    for(var t1 = [
                        o.calcTicks(this.xaxis),
                        o.calcTicks(this.yaxis)
                    ], e1 = 0; e1 < 2; ++e1)for(var r = 0; r < t1[e1].length; ++r)t1[e1][r].text = t1[e1][r].text + "";
                    return t1;
                }, A.updateRefs = function(t1) {
                    this.fullLayout = t1;
                    var e1 = this.id.match(T), r = "xaxis" + e1[1], n = "yaxis" + e1[2];
                    this.xaxis = this.fullLayout[r], this.yaxis = this.fullLayout[n];
                }, A.relayoutCallback = function() {
                    var t1 = this.graphDiv, e1 = this.xaxis, r = this.yaxis, n = t1.layout, i = {}, o = i[e1._name + ".range"] = e1.range.slice(), s = i[r._name + ".range"] = r.range.slice();
                    i[e1._name + ".autorange"] = e1.autorange, i[r._name + ".autorange"] = r.autorange, a.call("_storeDirectGUIEdit", t1.layout, t1._fullLayout._preGUI, i);
                    var l = n[e1._name];
                    l.range = o, l.autorange = e1.autorange;
                    var c = n[r._name];
                    c.range = s, c.autorange = r.autorange, i.lastInputTime = this.camera.lastInputTime, t1.emit("plotly_relayout", i);
                }, A.cameraChanged = function() {
                    var t1 = this.camera;
                    this.glplot.setDataBox(this.calcDataBox());
                    var e1 = this.computeTickMarks();
                    (function(t1, e1) {
                        for(var r = 0; r < 2; ++r){
                            var n = t1[r], i = e1[r];
                            if (n.length !== i.length) return !0;
                            for(var a = 0; a < n.length; ++a)if (n[a].x !== i[a].x) return !0;
                        }
                        return !1;
                    })(e1, this.glplotOptions.ticks) && (this.glplotOptions.ticks = e1, this.glplotOptions.dataBox = t1.dataBox, this.glplot.update(this.glplotOptions), this.handleAnnotations());
                }, A.handleAnnotations = function() {
                    for(var t1 = this.graphDiv, e1 = this.fullLayout.annotations, r = 0; r < e1.length; r++){
                        var n = e1[r];
                        n.xref === this.xaxis._id && n.yref === this.yaxis._id && a.getComponentMethod("annotations", "drawOne")(t1, r);
                    }
                }, A.destroy = function() {
                    if (this.glplot) {
                        var t1 = this.traces;
                        t1 && Object.keys(t1).map(function(e1) {
                            t1[e1].dispose(), delete t1[e1];
                        }), this.glplot.dispose(), this.container.removeChild(this.svgContainer), this.container.removeChild(this.mouseContainer), this.fullData = null, this.glplot = null, this.stopped = !0, this.camera.mouseListener.enabled = !1, this.mouseContainer.removeEventListener("wheel", this.camera.wheelListener), this.camera = null;
                    }
                }, A.plot = function(t1, e1, r) {
                    var n = this.glplot;
                    this.updateRefs(r), this.xaxis.clearCalc(), this.yaxis.clearCalc(), this.updateTraces(t1, e1), this.updateFx(r.dragmode);
                    var i = r.width, a = r.height;
                    this.updateSize(this.canvas);
                    var o = this.glplotOptions;
                    o.merge(r), o.screenBox = [
                        0,
                        0,
                        i,
                        a
                    ];
                    var s = {
                        _fullLayout: {
                            _axisConstraintGroups: r._axisConstraintGroups,
                            xaxis: this.xaxis,
                            yaxis: this.yaxis,
                            _size: r._size
                        }
                    };
                    v(s, this.xaxis), v(s, this.yaxis);
                    var l, c, u = r._size, f = this.xaxis.domain, h = this.yaxis.domain;
                    for(o.viewBox = [
                        u.l + f[0] * u.w,
                        u.b + h[0] * u.h,
                        i - u.r - (1 - f[1]) * u.w,
                        a - u.t - (1 - h[1]) * u.h
                    ], this.mouseContainer.style.width = u.w * (f[1] - f[0]) + "px", this.mouseContainer.style.height = u.h * (h[1] - h[0]) + "px", this.mouseContainer.height = u.h * (h[1] - h[0]), this.mouseContainer.style.left = u.l + f[0] * u.w + "px", this.mouseContainer.style.top = u.t + (1 - h[1]) * u.h + "px", c = 0; c < 2; ++c)(l = this[w[c]])._length = o.viewBox[c + 2] - o.viewBox[c], y(this.graphDiv, l), l.setScale();
                    g(s), o.ticks = this.computeTickMarks(), o.dataBox = this.calcDataBox(), o.merge(r), n.update(o), this.glplot.draw();
                }, A.calcDataBox = function() {
                    var t1 = this.xaxis, e1 = this.yaxis, r = t1.range, n = e1.range, i = t1.r2l, a = e1.r2l;
                    return [
                        i(r[0]),
                        a(n[0]),
                        i(r[1]),
                        a(n[1])
                    ];
                }, A.setRanges = function(t1) {
                    var e1 = this.xaxis, r = this.yaxis, n = e1.l2r, i = r.l2r;
                    e1.range = [
                        n(t1[0]),
                        n(t1[2])
                    ], r.range = [
                        i(t1[1]),
                        i(t1[3])
                    ];
                }, A.updateTraces = function(t1, e1) {
                    var r, n, i, a = Object.keys(this.traces);
                    this.fullData = t1;
                    t: for(r = 0; r < a.length; r++){
                        var o = a[r], s = this.traces[o];
                        for(n = 0; n < t1.length; n++)if ((i = t1[n]).uid === o && i.type === s.type) continue t;
                        s.dispose(), delete this.traces[o];
                    }
                    for(r = 0; r < t1.length; r++){
                        i = t1[r];
                        var l = e1[r], c = this.traces[i.uid];
                        c ? c.update(i, l) : (c = i._module.plot(this, i, l), this.traces[i.uid] = c);
                    }
                    this.glplot.objects.sort(function(t1, e1) {
                        return t1._trace.index - e1._trace.index;
                    });
                }, A.updateFx = function(t1) {
                    _(t1) || b(t1) ? (this.pickCanvas.style["pointer-events"] = "none", this.mouseContainer.style["pointer-events"] = "none") : (this.pickCanvas.style["pointer-events"] = "auto", this.mouseContainer.style["pointer-events"] = "auto"), this.mouseContainer.style.cursor = "pan" === t1 ? "move" : "zoom" === t1 ? "crosshair" : null;
                }, A.emitPointAction = function(t1, e1) {
                    for(var r, n = t1.trace.uid, i = t1.pointIndex, a = 0; a < this.fullData.length; a++)this.fullData[a].uid === n && (r = this.fullData[a]);
                    var o = {
                        x: t1.traceCoord[0],
                        y: t1.traceCoord[1],
                        curveNumber: r.index,
                        pointNumber: i,
                        data: r._input,
                        fullData: this.fullData,
                        xaxis: this.xaxis,
                        yaxis: this.yaxis
                    };
                    s.appendArrayPointValue(o, r, i), this.graphDiv.emit(e1, {
                        points: [
                            o
                        ]
                    });
                }, A.draw = function() {
                    if (!this.stopped) {
                        requestAnimationFrame(this.redraw);
                        var t1 = this.glplot, e1 = this.camera, r = e1.mouseListener, n = 1 === this.lastButtonState && 0 === r.buttons, i = this.fullLayout;
                        this.lastButtonState = r.buttons, this.cameraChanged();
                        var a, o = r.x * t1.pixelRatio, l = this.canvas.height - t1.pixelRatio * r.y;
                        if (e1.boxEnabled && "zoom" === i.dragmode) {
                            this.selectBox.enabled = !0;
                            for(var c = this.selectBox.selectBox = [
                                Math.min(e1.boxStart[0], e1.boxEnd[0]),
                                Math.min(e1.boxStart[1], e1.boxEnd[1]),
                                Math.max(e1.boxStart[0], e1.boxEnd[0]),
                                Math.max(e1.boxStart[1], e1.boxEnd[1])
                            ], u = 0; u < 2; u++)e1.boxStart[u] === e1.boxEnd[u] && (c[u] = t1.dataBox[u], c[u + 2] = t1.dataBox[u + 2]);
                            t1.setDirty();
                        } else if (!e1.panning && this.isMouseOver) {
                            this.selectBox.enabled = !1;
                            var f = i._size, h = this.xaxis.domain, p = this.yaxis.domain, d = (a = t1.pick(o / t1.pixelRatio + f.l + h[0] * f.w, l / t1.pixelRatio - (f.t + (1 - p[1]) * f.h))) && a.object._trace.handlePick(a);
                            if (d && n && this.emitPointAction(d, "plotly_click"), a && "skip" !== a.object._trace.hoverinfo && i.hovermode && d && (!this.lastPickResult || this.lastPickResult.traceUid !== d.trace.uid || this.lastPickResult.dataCoord[0] !== d.dataCoord[0] || this.lastPickResult.dataCoord[1] !== d.dataCoord[1])) {
                                var m = d;
                                this.lastPickResult = {
                                    traceUid: d.trace ? d.trace.uid : null,
                                    dataCoord: d.dataCoord.slice()
                                }, this.spikes.update({
                                    center: a.dataCoord
                                }), m.screenCoord = [
                                    ((t1.viewBox[2] - t1.viewBox[0]) * (a.dataCoord[0] - t1.dataBox[0]) / (t1.dataBox[2] - t1.dataBox[0]) + t1.viewBox[0]) / t1.pixelRatio,
                                    (this.canvas.height - (t1.viewBox[3] - t1.viewBox[1]) * (a.dataCoord[1] - t1.dataBox[1]) / (t1.dataBox[3] - t1.dataBox[1]) - t1.viewBox[1]) / t1.pixelRatio
                                ], this.emitPointAction(d, "plotly_hover");
                                var g = this.fullData[m.trace.index] || {}, v = m.pointIndex, y = s.castHoverinfo(g, i, v);
                                if (y && "all" !== y) {
                                    var x = y.split("+");
                                    -1 === x.indexOf("x") && (m.traceCoord[0] = void 0), -1 === x.indexOf("y") && (m.traceCoord[1] = void 0), -1 === x.indexOf("z") && (m.traceCoord[2] = void 0), -1 === x.indexOf("text") && (m.textLabel = void 0), -1 === x.indexOf("name") && (m.name = void 0);
                                }
                                s.loneHover({
                                    x: m.screenCoord[0],
                                    y: m.screenCoord[1],
                                    xLabel: this.hoverFormatter("xaxis", m.traceCoord[0]),
                                    yLabel: this.hoverFormatter("yaxis", m.traceCoord[1]),
                                    zLabel: m.traceCoord[2],
                                    text: m.textLabel,
                                    name: m.name,
                                    color: s.castHoverOption(g, v, "bgcolor") || m.color,
                                    borderColor: s.castHoverOption(g, v, "bordercolor"),
                                    fontFamily: s.castHoverOption(g, v, "font.family"),
                                    fontSize: s.castHoverOption(g, v, "font.size"),
                                    fontColor: s.castHoverOption(g, v, "font.color"),
                                    nameLength: s.castHoverOption(g, v, "namelength"),
                                    textAlign: s.castHoverOption(g, v, "align")
                                }, {
                                    container: this.svgContainer,
                                    gd: this.graphDiv
                                });
                            }
                        }
                        a || this.unhover(), t1.draw();
                    }
                }, A.unhover = function() {
                    this.lastPickResult && (this.spikes.update({}), this.lastPickResult = null, this.graphDiv.emit("plotly_unhover"), s.loneUnhover(this.svgContainer));
                }, A.hoverFormatter = function(t1, e1) {
                    if (void 0 !== e1) {
                        var r = this[t1];
                        return o.tickText(r, r.c2l(e1), "hover").text;
                    }
                };
            },
            {
                "../../../stackgl_modules": 1120,
                "../../components/dragelement/helpers": 384,
                "../../components/fx": 406,
                "../../lib/show_no_webgl_msg": 525,
                "../../plots/cartesian/axes": 554,
                "../../registry": 638,
                "../cartesian/autorange": 553,
                "../cartesian/constants": 561,
                "../cartesian/constraints": 562,
                "./camera": 594,
                "./convert": 595,
                "webgl-context": 331
            }
        ],
        598: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plot_api/edit_types").overrideAll, i = t1("../../components/fx/layout_attributes"), a = t1("./scene"), o = t1("../get_data").getSubplotData, s = t1("../../lib"), l = t1("../../constants/xmlns_namespaces");
                r.name = "gl3d", r.attr = "scene", r.idRoot = "scene", r.idRegex = r.attrRegex = s.counterRegex("scene"), r.attributes = t1("./layout/attributes"), r.layoutAttributes = t1("./layout/layout_attributes"), r.baseLayoutAttrOverrides = n({
                    hoverlabel: i.hoverlabel
                }, "plot", "nested"), r.supplyLayoutDefaults = t1("./layout/defaults"), r.plot = function(t1) {
                    for(var e1 = t1._fullLayout, r = t1._fullData, n = e1._subplots.gl3d, i = 0; i < n.length; i++){
                        var s = n[i], l = o(r, "gl3d", s), c = e1[s], u = c.camera, f = c._scene;
                        f || (f = new a({
                            id: s,
                            graphDiv: t1,
                            container: t1.querySelector(".gl-container"),
                            staticPlot: t1._context.staticPlot,
                            plotGlPixelRatio: t1._context.plotGlPixelRatio,
                            camera: u
                        }, e1), c._scene = f), f.viewInitial || (f.viewInitial = {
                            up: {
                                x: u.up.x,
                                y: u.up.y,
                                z: u.up.z
                            },
                            eye: {
                                x: u.eye.x,
                                y: u.eye.y,
                                z: u.eye.z
                            },
                            center: {
                                x: u.center.x,
                                y: u.center.y,
                                z: u.center.z
                            }
                        }), f.plot(l, e1, t1.layout);
                    }
                }, r.clean = function(t1, e1, r, n) {
                    for(var i = n._subplots.gl3d || [], a = 0; a < i.length; a++){
                        var o = i[a];
                        !e1[o] && n[o]._scene && (n[o]._scene.destroy(), n._infolayer && n._infolayer.selectAll(".annotation-" + o).remove());
                    }
                }, r.toSVG = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots.gl3d, n = e1._size, i = 0; i < r.length; i++){
                        var a = e1[r[i]], o = a.domain, s = a._scene, c = s.toImage("png");
                        e1._glimages.append("svg:image").attr({
                            xmlns: l.svg,
                            "xlink:href": c,
                            x: n.l + n.w * o.x[0],
                            y: n.t + n.h * (1 - o.y[1]),
                            width: n.w * (o.x[1] - o.x[0]),
                            height: n.h * (o.y[1] - o.y[0]),
                            preserveAspectRatio: "none"
                        }), s.destroy();
                    }
                }, r.cleanId = function(t1) {
                    if (t1.match(/^scene[0-9]*$/)) {
                        var e1 = t1.substr(5);
                        return "1" === e1 && (e1 = ""), "scene" + e1;
                    }
                }, r.updateFx = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots.gl3d, n = 0; n < r.length; n++)e1[r[n]]._scene.updateFx(e1.dragmode, e1.hovermode);
                };
            },
            {
                "../../components/fx/layout_attributes": 407,
                "../../constants/xmlns_namespaces": 480,
                "../../lib": 503,
                "../../plot_api/edit_types": 536,
                "../get_data": 593,
                "./layout/attributes": 599,
                "./layout/defaults": 603,
                "./layout/layout_attributes": 604,
                "./scene": 608
            }
        ],
        599: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    scene: {
                        valType: "subplotid",
                        dflt: "scene",
                        editType: "calc+clearAxisTypes"
                    }
                };
            },
            {}
        ],
        600: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../components/color"), i = t1("../../cartesian/layout_attributes"), a = t1("../../../lib/extend").extendFlat, o = t1("../../../plot_api/edit_types").overrideAll;
                e1.exports = o({
                    visible: i.visible,
                    showspikes: {
                        valType: "boolean",
                        dflt: !0
                    },
                    spikesides: {
                        valType: "boolean",
                        dflt: !0
                    },
                    spikethickness: {
                        valType: "number",
                        min: 0,
                        dflt: 2
                    },
                    spikecolor: {
                        valType: "color",
                        dflt: n.defaultLine
                    },
                    showbackground: {
                        valType: "boolean",
                        dflt: !1
                    },
                    backgroundcolor: {
                        valType: "color",
                        dflt: "rgba(204, 204, 204, 0.5)"
                    },
                    showaxeslabels: {
                        valType: "boolean",
                        dflt: !0
                    },
                    color: i.color,
                    categoryorder: i.categoryorder,
                    categoryarray: i.categoryarray,
                    title: {
                        text: i.title.text,
                        font: i.title.font
                    },
                    type: a({}, i.type, {
                        values: [
                            "-",
                            "linear",
                            "log",
                            "date",
                            "category"
                        ]
                    }),
                    autotypenumbers: i.autotypenumbers,
                    autorange: i.autorange,
                    rangemode: i.rangemode,
                    range: a({}, i.range, {
                        items: [
                            {
                                valType: "any",
                                editType: "plot",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            },
                            {
                                valType: "any",
                                editType: "plot",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            }
                        ],
                        anim: !1
                    }),
                    tickmode: i.tickmode,
                    nticks: i.nticks,
                    tick0: i.tick0,
                    dtick: i.dtick,
                    tickvals: i.tickvals,
                    ticktext: i.ticktext,
                    ticks: i.ticks,
                    mirror: i.mirror,
                    ticklen: i.ticklen,
                    tickwidth: i.tickwidth,
                    tickcolor: i.tickcolor,
                    showticklabels: i.showticklabels,
                    tickfont: i.tickfont,
                    tickangle: i.tickangle,
                    tickprefix: i.tickprefix,
                    showtickprefix: i.showtickprefix,
                    ticksuffix: i.ticksuffix,
                    showticksuffix: i.showticksuffix,
                    showexponent: i.showexponent,
                    exponentformat: i.exponentformat,
                    minexponent: i.minexponent,
                    separatethousands: i.separatethousands,
                    tickformat: i.tickformat,
                    tickformatstops: i.tickformatstops,
                    hoverformat: i.hoverformat,
                    showline: i.showline,
                    linecolor: i.linecolor,
                    linewidth: i.linewidth,
                    showgrid: i.showgrid,
                    gridcolor: a({}, i.gridcolor, {
                        dflt: "rgb(204, 204, 204)"
                    }),
                    gridwidth: i.gridwidth,
                    zeroline: i.zeroline,
                    zerolinecolor: i.zerolinecolor,
                    zerolinewidth: i.zerolinewidth,
                    _deprecated: {
                        title: i._deprecated.title,
                        titlefont: i._deprecated.titlefont
                    }
                }, "plot", "from-root");
            },
            {
                "../../../components/color": 366,
                "../../../lib/extend": 493,
                "../../../plot_api/edit_types": 536,
                "../../cartesian/layout_attributes": 569
            }
        ],
        601: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("tinycolor2").mix, i = t1("../../../lib"), a = t1("../../../plot_api/plot_template"), o = t1("./axis_attributes"), s = t1("../../cartesian/type_defaults"), l = t1("../../cartesian/axis_defaults"), c = [
                    "xaxis",
                    "yaxis",
                    "zaxis"
                ];
                e1.exports = function(t1, e1, r) {
                    var u, f;
                    function h(t1, e1) {
                        return i.coerce(u, f, o, t1, e1);
                    }
                    for(var p = 0; p < c.length; p++){
                        var d = c[p];
                        u = t1[d] || {}, (f = a.newContainer(e1, d))._id = d[0] + r.scene, f._name = d, s(u, f, h, r), l(u, f, h, {
                            font: r.font,
                            letter: d[0],
                            data: r.data,
                            showGrid: !0,
                            noTickson: !0,
                            noTicklabelmode: !0,
                            noTicklabelposition: !0,
                            noTicklabeloverflow: !0,
                            bgColor: r.bgColor,
                            calendar: r.calendar
                        }, r.fullLayout), h("gridcolor", n(f.color, r.bgColor, 13600 / 187).toRgbString()), h("title.text", d[0]), f.setScale = i.noop, h("showspikes") && (h("spikesides"), h("spikethickness"), h("spikecolor", f.color)), h("showaxeslabels"), h("showbackground") && h("backgroundcolor");
                    }
                };
            },
            {
                "../../../lib": 503,
                "../../../plot_api/plot_template": 543,
                "../../cartesian/axis_defaults": 556,
                "../../cartesian/type_defaults": 582,
                "./axis_attributes": 600,
                tinycolor2: 312
            }
        ],
        602: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../lib/str2rgbarray"), i = t1("../../../lib"), a = [
                    "xaxis",
                    "yaxis",
                    "zaxis"
                ];
                function o() {
                    this.bounds = [
                        [
                            -10,
                            -10,
                            -10
                        ],
                        [
                            10,
                            10,
                            10
                        ]
                    ], this.ticks = [
                        [],
                        [],
                        []
                    ], this.tickEnable = [
                        !0,
                        !0,
                        !0
                    ], this.tickFont = [
                        "sans-serif",
                        "sans-serif",
                        "sans-serif"
                    ], this.tickSize = [
                        12,
                        12,
                        12
                    ], this.tickAngle = [
                        0,
                        0,
                        0
                    ], this.tickColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.tickPad = [
                        18,
                        18,
                        18
                    ], this.labels = [
                        "x",
                        "y",
                        "z"
                    ], this.labelEnable = [
                        !0,
                        !0,
                        !0
                    ], this.labelFont = [
                        "Open Sans",
                        "Open Sans",
                        "Open Sans"
                    ], this.labelSize = [
                        20,
                        20,
                        20
                    ], this.labelColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.labelPad = [
                        30,
                        30,
                        30
                    ], this.lineEnable = [
                        !0,
                        !0,
                        !0
                    ], this.lineMirror = [
                        !1,
                        !1,
                        !1
                    ], this.lineWidth = [
                        1,
                        1,
                        1
                    ], this.lineColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.lineTickEnable = [
                        !0,
                        !0,
                        !0
                    ], this.lineTickMirror = [
                        !1,
                        !1,
                        !1
                    ], this.lineTickLength = [
                        10,
                        10,
                        10
                    ], this.lineTickWidth = [
                        1,
                        1,
                        1
                    ], this.lineTickColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.gridEnable = [
                        !0,
                        !0,
                        !0
                    ], this.gridWidth = [
                        1,
                        1,
                        1
                    ], this.gridColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.zeroEnable = [
                        !0,
                        !0,
                        !0
                    ], this.zeroLineColor = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.zeroLineWidth = [
                        2,
                        2,
                        2
                    ], this.backgroundEnable = [
                        !0,
                        !0,
                        !0
                    ], this.backgroundColor = [
                        [
                            .8,
                            .8,
                            .8,
                            .5
                        ],
                        [
                            .8,
                            .8,
                            .8,
                            .5
                        ],
                        [
                            .8,
                            .8,
                            .8,
                            .5
                        ]
                    ], this._defaultTickPad = this.tickPad.slice(), this._defaultLabelPad = this.labelPad.slice(), this._defaultLineTickLength = this.lineTickLength.slice();
                }
                o.prototype.merge = function(t1, e1) {
                    for(var r = 0; r < 3; ++r){
                        var o = e1[a[r]];
                        o.visible ? (this.labels[r] = t1._meta ? i.templateString(o.title.text, t1._meta) : o.title.text, "font" in o.title && (o.title.font.color && (this.labelColor[r] = n(o.title.font.color)), o.title.font.family && (this.labelFont[r] = o.title.font.family), o.title.font.size && (this.labelSize[r] = o.title.font.size)), "showline" in o && (this.lineEnable[r] = o.showline), "linecolor" in o && (this.lineColor[r] = n(o.linecolor)), "linewidth" in o && (this.lineWidth[r] = o.linewidth), "showgrid" in o && (this.gridEnable[r] = o.showgrid), "gridcolor" in o && (this.gridColor[r] = n(o.gridcolor)), "gridwidth" in o && (this.gridWidth[r] = o.gridwidth), "log" === o.type ? this.zeroEnable[r] = !1 : "zeroline" in o && (this.zeroEnable[r] = o.zeroline), "zerolinecolor" in o && (this.zeroLineColor[r] = n(o.zerolinecolor)), "zerolinewidth" in o && (this.zeroLineWidth[r] = o.zerolinewidth), "ticks" in o && o.ticks ? this.lineTickEnable[r] = !0 : this.lineTickEnable[r] = !1, "ticklen" in o && (this.lineTickLength[r] = this._defaultLineTickLength[r] = o.ticklen), "tickcolor" in o && (this.lineTickColor[r] = n(o.tickcolor)), "tickwidth" in o && (this.lineTickWidth[r] = o.tickwidth), "tickangle" in o && (this.tickAngle[r] = "auto" === o.tickangle ? -3600 : Math.PI * -o.tickangle / 180), "showticklabels" in o && (this.tickEnable[r] = o.showticklabels), "tickfont" in o && (o.tickfont.color && (this.tickColor[r] = n(o.tickfont.color)), o.tickfont.family && (this.tickFont[r] = o.tickfont.family), o.tickfont.size && (this.tickSize[r] = o.tickfont.size)), "mirror" in o ? -1 !== [
                            "ticks",
                            "all",
                            "allticks"
                        ].indexOf(o.mirror) ? (this.lineTickMirror[r] = !0, this.lineMirror[r] = !0) : !0 === o.mirror ? (this.lineTickMirror[r] = !1, this.lineMirror[r] = !0) : (this.lineTickMirror[r] = !1, this.lineMirror[r] = !1) : this.lineMirror[r] = !1, "showbackground" in o && !1 !== o.showbackground ? (this.backgroundEnable[r] = !0, this.backgroundColor[r] = n(o.backgroundcolor)) : this.backgroundEnable[r] = !1) : (this.tickEnable[r] = !1, this.labelEnable[r] = !1, this.lineEnable[r] = !1, this.lineTickEnable[r] = !1, this.gridEnable[r] = !1, this.zeroEnable[r] = !1, this.backgroundEnable[r] = !1);
                    }
                }, e1.exports = function(t1, e1) {
                    var r = new o;
                    return r.merge(t1, e1), r;
                };
            },
            {
                "../../../lib": 503,
                "../../../lib/str2rgbarray": 528
            }
        ],
        603: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../lib"), i = t1("../../../components/color"), a = t1("../../../registry"), o = t1("../../subplot_defaults"), s = t1("./axis_defaults"), l = t1("./layout_attributes"), c = t1("../../get_data").getSubplotData;
                function u(t1, e1, r, n) {
                    for(var o = r("bgcolor"), l = i.combine(o, n.paper_bgcolor), u = [
                        "up",
                        "center",
                        "eye"
                    ], f = 0; f < u.length; f++)r("camera." + u[f] + ".x"), r("camera." + u[f] + ".y"), r("camera." + u[f] + ".z");
                    r("camera.projection.type");
                    var h = !!r("aspectratio.x") && !!r("aspectratio.y") && !!r("aspectratio.z"), p = r("aspectmode", h ? "manual" : "auto");
                    h || (t1.aspectratio = e1.aspectratio = {
                        x: 1,
                        y: 1,
                        z: 1
                    }, "manual" === p && (e1.aspectmode = "auto"), t1.aspectmode = e1.aspectmode);
                    var d = c(n.fullData, "gl3d", n.id);
                    s(t1, e1, {
                        font: n.font,
                        scene: n.id,
                        data: d,
                        bgColor: l,
                        calendar: n.calendar,
                        autotypenumbersDflt: n.autotypenumbersDflt,
                        fullLayout: n.fullLayout
                    }), a.getComponentMethod("annotations3d", "handleDefaults")(t1, e1, n);
                    var m = n.getDfltFromLayout("dragmode");
                    if (!1 !== m && !m) {
                        if (m = "orbit", t1.camera && t1.camera.up) {
                            var g = t1.camera.up.x, v = t1.camera.up.y, y = t1.camera.up.z;
                            0 !== y && (g && v && y ? y / Math.sqrt(g * g + v * v + y * y) > .999 && (m = "turntable") : m = "turntable");
                        } else m = "turntable";
                    }
                    r("dragmode", m), r("hovermode", n.getDfltFromLayout("hovermode"));
                }
                e1.exports = function(t1, e1, r) {
                    var i = e1._basePlotModules.length > 1;
                    o(t1, e1, r, {
                        type: "gl3d",
                        attributes: l,
                        handleDefaults: u,
                        fullLayout: e1,
                        font: e1.font,
                        fullData: r,
                        getDfltFromLayout: function(e1) {
                            if (!i) return n.validate(t1[e1], l[e1]) ? t1[e1] : void 0;
                        },
                        autotypenumbersDflt: e1.autotypenumbers,
                        paper_bgcolor: e1.paper_bgcolor,
                        calendar: e1.calendar
                    });
                };
            },
            {
                "../../../components/color": 366,
                "../../../lib": 503,
                "../../../registry": 638,
                "../../get_data": 593,
                "../../subplot_defaults": 632,
                "./axis_defaults": 601,
                "./layout_attributes": 604
            }
        ],
        604: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./axis_attributes"), i = t1("../../domain").attributes, a = t1("../../../lib/extend").extendFlat, o = t1("../../../lib").counterRegex;
                function s(t1, e1, r) {
                    return {
                        x: {
                            valType: "number",
                            dflt: t1,
                            editType: "camera"
                        },
                        y: {
                            valType: "number",
                            dflt: e1,
                            editType: "camera"
                        },
                        z: {
                            valType: "number",
                            dflt: r,
                            editType: "camera"
                        },
                        editType: "camera"
                    };
                }
                e1.exports = {
                    _arrayAttrRegexps: [
                        o("scene", ".annotations", !0)
                    ],
                    bgcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)",
                        editType: "plot"
                    },
                    camera: {
                        up: a(s(0, 0, 1), {}),
                        center: a(s(0, 0, 0), {}),
                        eye: a(s(1.25, 1.25, 1.25), {}),
                        projection: {
                            type: {
                                valType: "enumerated",
                                values: [
                                    "perspective",
                                    "orthographic"
                                ],
                                dflt: "perspective",
                                editType: "calc"
                            },
                            editType: "calc"
                        },
                        editType: "camera"
                    },
                    domain: i({
                        name: "scene",
                        editType: "plot"
                    }),
                    aspectmode: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "cube",
                            "data",
                            "manual"
                        ],
                        dflt: "auto",
                        editType: "plot",
                        impliedEdits: {
                            "aspectratio.x": void 0,
                            "aspectratio.y": void 0,
                            "aspectratio.z": void 0
                        }
                    },
                    aspectratio: {
                        x: {
                            valType: "number",
                            min: 0,
                            editType: "plot",
                            impliedEdits: {
                                "^aspectmode": "manual"
                            }
                        },
                        y: {
                            valType: "number",
                            min: 0,
                            editType: "plot",
                            impliedEdits: {
                                "^aspectmode": "manual"
                            }
                        },
                        z: {
                            valType: "number",
                            min: 0,
                            editType: "plot",
                            impliedEdits: {
                                "^aspectmode": "manual"
                            }
                        },
                        editType: "plot",
                        impliedEdits: {
                            aspectmode: "manual"
                        }
                    },
                    xaxis: n,
                    yaxis: n,
                    zaxis: n,
                    dragmode: {
                        valType: "enumerated",
                        values: [
                            "orbit",
                            "turntable",
                            "zoom",
                            "pan",
                            !1
                        ],
                        editType: "plot"
                    },
                    hovermode: {
                        valType: "enumerated",
                        values: [
                            "closest",
                            !1
                        ],
                        dflt: "closest",
                        editType: "modebar"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editType: "plot",
                    _deprecated: {
                        cameraposition: {
                            valType: "info_array",
                            editType: "camera"
                        }
                    }
                };
            },
            {
                "../../../lib": 503,
                "../../../lib/extend": 493,
                "../../domain": 584,
                "./axis_attributes": 600
            }
        ],
        605: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../lib/str2rgbarray"), i = [
                    "xaxis",
                    "yaxis",
                    "zaxis"
                ];
                function a() {
                    this.enabled = [
                        !0,
                        !0,
                        !0
                    ], this.colors = [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ], this.drawSides = [
                        !0,
                        !0,
                        !0
                    ], this.lineWidth = [
                        1,
                        1,
                        1
                    ];
                }
                a.prototype.merge = function(t1) {
                    for(var e1 = 0; e1 < 3; ++e1){
                        var r = t1[i[e1]];
                        r.visible ? (this.enabled[e1] = r.showspikes, this.colors[e1] = n(r.spikecolor), this.drawSides[e1] = r.spikesides, this.lineWidth[e1] = r.spikethickness) : (this.enabled[e1] = !1, this.drawSides[e1] = !1);
                    }
                }, e1.exports = function(t1) {
                    var e1 = new a;
                    return e1.merge(t1), e1;
                };
            },
            {
                "../../../lib/str2rgbarray": 528
            }
        ],
        606: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    for(var e1 = t1.axesOptions, r = t1.glplot.axesPixels, s = t1.fullSceneLayout, l = [
                        [],
                        [],
                        []
                    ], c = 0; c < 3; ++c){
                        var u = s[a[c]];
                        if (u._length = (r[c].hi - r[c].lo) * r[c].pixelsPerDataUnit / t1.dataScale[c], Math.abs(u._length) === 1 / 0 || isNaN(u._length)) l[c] = [];
                        else {
                            u._input_range = u.range.slice(), u.range[0] = r[c].lo / t1.dataScale[c], u.range[1] = r[c].hi / t1.dataScale[c], u._m = 1 / (t1.dataScale[c] * r[c].pixelsPerDataUnit), u.range[0] === u.range[1] && (u.range[0] -= 1, u.range[1] += 1);
                            var f = u.tickmode;
                            if ("auto" === u.tickmode) {
                                u.tickmode = "linear";
                                var h = u.nticks || i.constrain(u._length / 40, 4, 9);
                                n.autoTicks(u, Math.abs(u.range[1] - u.range[0]) / h);
                            }
                            for(var p = n.calcTicks(u, {
                                msUTC: !0
                            }), d = 0; d < p.length; ++d)p[d].x = p[d].x * t1.dataScale[c], "date" === u.type && (p[d].text = p[d].text.replace(/\<br\>/g, " "));
                            l[c] = p, u.tickmode = f;
                        }
                    }
                    e1.ticks = l;
                    for(c = 0; c < 3; ++c){
                        o[c] = .5 * (t1.glplot.bounds[0][c] + t1.glplot.bounds[1][c]);
                        for(d = 0; d < 2; ++d)e1.bounds[d][c] = t1.glplot.bounds[d][c];
                    }
                    t1.contourLevels = function(t1) {
                        for(var e1 = new Array(3), r = 0; r < 3; ++r){
                            for(var n = t1[r], i = new Array(n.length), a = 0; a < n.length; ++a)i[a] = n[a].x;
                            e1[r] = i;
                        }
                        return e1;
                    }(l);
                };
                var n = t1("../../cartesian/axes"), i = t1("../../../lib"), a = [
                    "xaxis",
                    "yaxis",
                    "zaxis"
                ], o = [
                    0,
                    0,
                    0
                ];
            },
            {
                "../../../lib": 503,
                "../../cartesian/axes": 554
            }
        ],
        607: [
            function(t1, e1, r) {
                "use strict";
                function n(t1, e1) {
                    var r, n, i = [
                        0,
                        0,
                        0,
                        0
                    ];
                    for(r = 0; r < 4; ++r)for(n = 0; n < 4; ++n)i[n] += t1[4 * r + n] * e1[r];
                    return i;
                }
                e1.exports = function(t1, e1) {
                    return n(t1.projection, n(t1.view, n(t1.model, [
                        e1[0],
                        e1[1],
                        e1[2],
                        1
                    ])));
                };
            },
            {}
        ],
        608: [
            function(t1, e1, r) {
                "use strict";
                var n, i, a = t1("../../../stackgl_modules").gl_plot3d, o = a.createCamera, s = a.createScene, l = t1("webgl-context"), c = t1("has-passive-events"), u = t1("../../registry"), f = t1("../../lib"), h = f.preserveDrawingBuffer(), p = t1("../../plots/cartesian/axes"), d = t1("../../components/fx"), m = t1("../../lib/str2rgbarray"), g = t1("../../lib/show_no_webgl_msg"), v = t1("./project"), y = t1("./layout/convert"), x = t1("./layout/spikes"), b = t1("./layout/tick_marks");
                function _(t1, e1) {
                    var r = document.createElement("div"), n = t1.container;
                    this.graphDiv = t1.graphDiv;
                    var i = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    i.style.position = "absolute", i.style.top = i.style.left = "0px", i.style.width = i.style.height = "100%", i.style["z-index"] = 20, i.style["pointer-events"] = "none", r.appendChild(i), this.svgContainer = i, r.id = t1.id, r.style.position = "absolute", r.style.top = r.style.left = "0px", r.style.width = r.style.height = "100%", n.appendChild(r), this.fullLayout = e1, this.id = t1.id || "scene", this.fullSceneLayout = e1[this.id], this.plotArgs = [
                        [],
                        {},
                        {}
                    ], this.axesOptions = y(e1, e1[this.id]), this.spikeOptions = x(e1[this.id]), this.container = r, this.staticMode = !!t1.staticPlot, this.pixelRatio = this.pixelRatio || t1.plotGlPixelRatio || 2, this.dataScale = [
                        1,
                        1,
                        1
                    ], this.contourLevels = [
                        [],
                        [],
                        []
                    ], this.convertAnnotations = u.getComponentMethod("annotations3d", "convert"), this.drawAnnotations = u.getComponentMethod("annotations3d", "draw"), this.initializeGLPlot();
                }
                var w = _.prototype;
                w.prepareOptions = function() {
                    var t1 = {
                        canvas: this.canvas,
                        gl: this.gl,
                        glOptions: {
                            preserveDrawingBuffer: h,
                            premultipliedAlpha: !0,
                            antialias: !0
                        },
                        container: this.container,
                        axes: this.axesOptions,
                        spikes: this.spikeOptions,
                        pickRadius: 10,
                        snapToData: !0,
                        autoScale: !0,
                        autoBounds: !1,
                        cameraObject: this.camera,
                        pixelRatio: this.pixelRatio
                    };
                    if (this.staticMode) {
                        if (!(i || (n = document.createElement("canvas"), i = l({
                            canvas: n,
                            preserveDrawingBuffer: !0,
                            premultipliedAlpha: !0,
                            antialias: !0
                        })))) throw new Error("error creating static canvas/context for image server");
                        t1.gl = i, t1.canvas = n;
                    }
                    return t1;
                };
                var T = !0;
                w.tryCreatePlot = function() {
                    var t1 = this.prepareOptions(), e1 = !0;
                    try {
                        this.glplot = s(t1);
                    } catch (r) {
                        if (this.staticMode || !T || h) e1 = !1;
                        else {
                            f.warn([
                                "webgl setup failed possibly due to",
                                "false preserveDrawingBuffer config.",
                                "The mobile/tablet device may not be detected by is-mobile module.",
                                "Enabling preserveDrawingBuffer in second attempt to create webgl scene..."
                            ].join(" "));
                            try {
                                h = t1.glOptions.preserveDrawingBuffer = !0, this.glplot = s(t1);
                            } catch (r) {
                                h = t1.glOptions.preserveDrawingBuffer = !1, e1 = !1;
                            }
                        }
                    }
                    return T = !1, e1;
                }, w.initializeGLCamera = function() {
                    var t1 = this.fullSceneLayout.camera, e1 = "orthographic" === t1.projection.type;
                    this.camera = o(this.container, {
                        center: [
                            t1.center.x,
                            t1.center.y,
                            t1.center.z
                        ],
                        eye: [
                            t1.eye.x,
                            t1.eye.y,
                            t1.eye.z
                        ],
                        up: [
                            t1.up.x,
                            t1.up.y,
                            t1.up.z
                        ],
                        _ortho: e1,
                        zoomMin: .01,
                        zoomMax: 100,
                        mode: "orbit"
                    });
                }, w.initializeGLPlot = function() {
                    var t1 = this;
                    if (t1.initializeGLCamera(), !t1.tryCreatePlot()) return g(t1);
                    t1.traces = {}, t1.make4thDimension();
                    var e1 = t1.graphDiv, r = e1.layout, n = function() {
                        var e1 = {};
                        return t1.isCameraChanged(r) && (e1[t1.id + ".camera"] = t1.getCamera()), t1.isAspectChanged(r) && (e1[t1.id + ".aspectratio"] = t1.glplot.getAspectratio(), "manual" !== r[t1.id].aspectmode && (t1.fullSceneLayout.aspectmode = r[t1.id].aspectmode = e1[t1.id + ".aspectmode"] = "manual")), e1;
                    }, i = function(t1) {
                        if (!1 !== t1.fullSceneLayout.dragmode) {
                            var e1 = n();
                            t1.saveLayout(r), t1.graphDiv.emit("plotly_relayout", e1);
                        }
                    };
                    return t1.glplot.canvas && (t1.glplot.canvas.addEventListener("mouseup", function() {
                        i(t1);
                    }), t1.glplot.canvas.addEventListener("wheel", function(r) {
                        if (e1._context._scrollZoom.gl3d) {
                            if (t1.camera._ortho) {
                                var n = r.deltaX > r.deltaY ? 1.1 : 1 / 1.1, a = t1.glplot.getAspectratio();
                                t1.glplot.setAspectratio({
                                    x: n * a.x,
                                    y: n * a.y,
                                    z: n * a.z
                                });
                            }
                            i(t1);
                        }
                    }, !!c && {
                        passive: !1
                    }), t1.glplot.canvas.addEventListener("mousemove", function() {
                        if (!1 !== t1.fullSceneLayout.dragmode && 0 !== t1.camera.mouseListener.buttons) {
                            var e1 = n();
                            t1.graphDiv.emit("plotly_relayouting", e1);
                        }
                    }), t1.staticMode || t1.glplot.canvas.addEventListener("webglcontextlost", function(r) {
                        e1 && e1.emit && e1.emit("plotly_webglcontextlost", {
                            event: r,
                            layer: t1.id
                        });
                    }, !1)), t1.glplot.oncontextloss = function() {
                        t1.recoverContext();
                    }, t1.glplot.onrender = function() {
                        t1.render();
                    }, !0;
                }, w.render = function() {
                    var t1, e1 = this, r = e1.graphDiv, n = e1.svgContainer, i = e1.container.getBoundingClientRect();
                    r._fullLayout._calcInverseTransform(r);
                    var a = r._fullLayout._invScaleX, o = r._fullLayout._invScaleY, s = i.width * a, l = i.height * o;
                    n.setAttributeNS(null, "viewBox", "0 0 " + s + " " + l), n.setAttributeNS(null, "width", s), n.setAttributeNS(null, "height", l), b(e1), e1.glplot.axes.update(e1.axesOptions);
                    for(var c = Object.keys(e1.traces), u = null, h = e1.glplot.selection, m = 0; m < c.length; ++m)"skip" !== (t1 = e1.traces[c[m]]).data.hoverinfo && t1.handlePick(h) && (u = t1), t1.setContourLevels && t1.setContourLevels();
                    function g(t1, r, n) {
                        var i = e1.fullSceneLayout[t1 + "axis"];
                        return "log" !== i.type && (r = i.d2l(r)), p.hoverLabelText(i, r, n);
                    }
                    if (null !== u) {
                        var y = v(e1.glplot.cameraParams, h.dataCoordinate);
                        t1 = u.data;
                        var x, _ = r._fullData[t1.index], w = h.index, T = {
                            xLabel: g("x", h.traceCoordinate[0], t1.xhoverformat),
                            yLabel: g("y", h.traceCoordinate[1], t1.yhoverformat),
                            zLabel: g("z", h.traceCoordinate[2], t1.zhoverformat)
                        }, k = d.castHoverinfo(_, e1.fullLayout, w), A = (k || "").split("+"), M = k && "all" === k;
                        _.hovertemplate || M || (-1 === A.indexOf("x") && (T.xLabel = void 0), -1 === A.indexOf("y") && (T.yLabel = void 0), -1 === A.indexOf("z") && (T.zLabel = void 0), -1 === A.indexOf("text") && (h.textLabel = void 0), -1 === A.indexOf("name") && (u.name = void 0));
                        var S = [];
                        "cone" === t1.type || "streamtube" === t1.type ? (T.uLabel = g("x", h.traceCoordinate[3], t1.uhoverformat), (M || -1 !== A.indexOf("u")) && S.push("u: " + T.uLabel), T.vLabel = g("y", h.traceCoordinate[4], t1.vhoverformat), (M || -1 !== A.indexOf("v")) && S.push("v: " + T.vLabel), T.wLabel = g("z", h.traceCoordinate[5], t1.whoverformat), (M || -1 !== A.indexOf("w")) && S.push("w: " + T.wLabel), T.normLabel = h.traceCoordinate[6].toPrecision(3), (M || -1 !== A.indexOf("norm")) && S.push("norm: " + T.normLabel), "streamtube" === t1.type && (T.divergenceLabel = h.traceCoordinate[7].toPrecision(3), (M || -1 !== A.indexOf("divergence")) && S.push("divergence: " + T.divergenceLabel)), h.textLabel && S.push(h.textLabel), x = S.join("<br>")) : "isosurface" === t1.type || "volume" === t1.type ? (T.valueLabel = p.hoverLabelText(e1._mockAxis, e1._mockAxis.d2l(h.traceCoordinate[3]), t1.valuehoverformat), S.push("value: " + T.valueLabel), h.textLabel && S.push(h.textLabel), x = S.join("<br>")) : x = h.textLabel;
                        var E = {
                            x: h.traceCoordinate[0],
                            y: h.traceCoordinate[1],
                            z: h.traceCoordinate[2],
                            data: _._input,
                            fullData: _,
                            curveNumber: _.index,
                            pointNumber: w
                        };
                        d.appendArrayPointValue(E, _, w), t1._module.eventData && (E = _._module.eventData(E, h, _, {}, w));
                        var L = {
                            points: [
                                E
                            ]
                        };
                        if (e1.fullSceneLayout.hovermode) {
                            var C = [];
                            d.loneHover({
                                trace: _,
                                x: (.5 + .5 * y[0] / y[3]) * s,
                                y: (.5 - .5 * y[1] / y[3]) * l,
                                xLabel: T.xLabel,
                                yLabel: T.yLabel,
                                zLabel: T.zLabel,
                                text: x,
                                name: u.name,
                                color: d.castHoverOption(_, w, "bgcolor") || u.color,
                                borderColor: d.castHoverOption(_, w, "bordercolor"),
                                fontFamily: d.castHoverOption(_, w, "font.family"),
                                fontSize: d.castHoverOption(_, w, "font.size"),
                                fontColor: d.castHoverOption(_, w, "font.color"),
                                nameLength: d.castHoverOption(_, w, "namelength"),
                                textAlign: d.castHoverOption(_, w, "align"),
                                hovertemplate: f.castOption(_, w, "hovertemplate"),
                                hovertemplateLabels: f.extendFlat({}, E, T),
                                eventData: [
                                    E
                                ]
                            }, {
                                container: n,
                                gd: r,
                                inOut_bbox: C
                            }), E.bbox = C[0];
                        }
                        h.buttons && h.distance < 5 ? r.emit("plotly_click", L) : r.emit("plotly_hover", L), this.oldEventData = L;
                    } else d.loneUnhover(n), this.oldEventData && r.emit("plotly_unhover", this.oldEventData), this.oldEventData = void 0;
                    e1.drawAnnotations(e1);
                }, w.recoverContext = function() {
                    var t1 = this;
                    t1.glplot.dispose();
                    var e1 = function() {
                        t1.glplot.gl.isContextLost() ? requestAnimationFrame(e1) : t1.initializeGLPlot() ? t1.plot.apply(t1, t1.plotArgs) : f.error("Catastrophic and unrecoverable WebGL error. Context lost.");
                    };
                    requestAnimationFrame(e1);
                };
                var k = [
                    "xaxis",
                    "yaxis",
                    "zaxis"
                ];
                function A(t1, e1, r) {
                    for(var n = t1.fullSceneLayout, i = 0; i < 3; i++){
                        var a = k[i], o = a.charAt(0), s = n[a], l = e1[o], c = e1[o + "calendar"], u = e1["_" + o + "length"];
                        if (f.isArrayOrTypedArray(l)) for(var h, p = 0; p < (u || l.length); p++)if (f.isArrayOrTypedArray(l[p])) for(var d = 0; d < l[p].length; ++d)h = s.d2l(l[p][d], 0, c), !isNaN(h) && isFinite(h) && (r[0][i] = Math.min(r[0][i], h), r[1][i] = Math.max(r[1][i], h));
                        else h = s.d2l(l[p], 0, c), !isNaN(h) && isFinite(h) && (r[0][i] = Math.min(r[0][i], h), r[1][i] = Math.max(r[1][i], h));
                        else r[0][i] = Math.min(r[0][i], 0), r[1][i] = Math.max(r[1][i], u - 1);
                    }
                }
                w.plot = function(t1, e1, r) {
                    if (this.plotArgs = [
                        t1,
                        e1,
                        r
                    ], !this.glplot.contextLost) {
                        var n, i, a, o, s, l, c = e1[this.id], u = r[this.id];
                        this.fullLayout = e1, this.fullSceneLayout = c, this.axesOptions.merge(e1, c), this.spikeOptions.merge(c), this.setViewport(c), this.updateFx(c.dragmode, c.hovermode), this.camera.enableWheel = this.graphDiv._context._scrollZoom.gl3d, this.glplot.setClearColor(m(c.bgcolor)), this.setConvert(s), t1 ? Array.isArray(t1) || (t1 = [
                            t1
                        ]) : t1 = [];
                        var f = [
                            [
                                1 / 0,
                                1 / 0,
                                1 / 0
                            ],
                            [
                                -1 / 0,
                                -1 / 0,
                                -1 / 0
                            ]
                        ];
                        for(a = 0; a < t1.length; ++a)!0 === (n = t1[a]).visible && 0 !== n._length && A(this, n, f);
                        !function(t1, e1) {
                            for(var r = t1.fullSceneLayout, n = r.annotations || [], i = 0; i < 3; i++)for(var a = k[i], o = a.charAt(0), s = r[a], l = 0; l < n.length; l++){
                                var c = n[l];
                                if (c.visible) {
                                    var u = s.r2l(c[o]);
                                    !isNaN(u) && isFinite(u) && (e1[0][i] = Math.min(e1[0][i], u), e1[1][i] = Math.max(e1[1][i], u));
                                }
                            }
                        }(this, f);
                        var h = [
                            1,
                            1,
                            1
                        ];
                        for(o = 0; o < 3; ++o)f[1][o] === f[0][o] ? h[o] = 1 : h[o] = 1 / (f[1][o] - f[0][o]);
                        for(this.dataScale = h, this.convertAnnotations(this), a = 0; a < t1.length; ++a)!0 === (n = t1[a]).visible && 0 !== n._length && ((i = this.traces[n.uid]) ? i.data.type === n.type ? i.update(n) : (i.dispose(), i = n._module.plot(this, n), this.traces[n.uid] = i) : (i = n._module.plot(this, n), this.traces[n.uid] = i), i.name = n.name);
                        var p = Object.keys(this.traces);
                        t: for(a = 0; a < p.length; ++a){
                            for(o = 0; o < t1.length; ++o)if (t1[o].uid === p[a] && !0 === t1[o].visible && 0 !== t1[o]._length) continue t;
                            (i = this.traces[p[a]]).dispose(), delete this.traces[p[a]];
                        }
                        this.glplot.objects.sort(function(t1, e1) {
                            return t1._trace.data.index - e1._trace.data.index;
                        });
                        var d, g = [
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                0,
                                0,
                                0
                            ]
                        ], v = [], y = {};
                        for(a = 0; a < 3; ++a){
                            if ((l = (s = c[k[a]]).type) in y ? (y[l].acc *= h[a], y[l].count += 1) : y[l] = {
                                acc: h[a],
                                count: 1
                            }, s.autorange) {
                                g[0][a] = 1 / 0, g[1][a] = -1 / 0;
                                var x = this.glplot.objects, b = this.fullSceneLayout.annotations || [], _ = s._name.charAt(0);
                                for(o = 0; o < x.length; o++){
                                    var w = x[o], T = w.bounds, M = w._trace.data._pad || 0;
                                    "ErrorBars" === w.constructor.name && s._lowerLogErrorBound ? g[0][a] = Math.min(g[0][a], s._lowerLogErrorBound) : g[0][a] = Math.min(g[0][a], T[0][a] / h[a] - M), g[1][a] = Math.max(g[1][a], T[1][a] / h[a] + M);
                                }
                                for(o = 0; o < b.length; o++){
                                    var S = b[o];
                                    if (S.visible) {
                                        var E = s.r2l(S[_]);
                                        g[0][a] = Math.min(g[0][a], E), g[1][a] = Math.max(g[1][a], E);
                                    }
                                }
                                if ("rangemode" in s && "tozero" === s.rangemode && (g[0][a] = Math.min(g[0][a], 0), g[1][a] = Math.max(g[1][a], 0)), g[0][a] > g[1][a]) g[0][a] = -1, g[1][a] = 1;
                                else {
                                    var L = g[1][a] - g[0][a];
                                    g[0][a] -= L / 32, g[1][a] += L / 32;
                                }
                                if ("reversed" === s.autorange) {
                                    var C = g[0][a];
                                    g[0][a] = g[1][a], g[1][a] = C;
                                }
                            } else {
                                var P = s.range;
                                g[0][a] = s.r2l(P[0]), g[1][a] = s.r2l(P[1]);
                            }
                            g[0][a] === g[1][a] && (g[0][a] -= 1, g[1][a] += 1), v[a] = g[1][a] - g[0][a], this.glplot.setBounds(a, {
                                min: g[0][a] * h[a],
                                max: g[1][a] * h[a]
                            });
                        }
                        var I = c.aspectmode;
                        if ("cube" === I) d = [
                            1,
                            1,
                            1
                        ];
                        else if ("manual" === I) {
                            var O = c.aspectratio;
                            d = [
                                O.x,
                                O.y,
                                O.z
                            ];
                        } else {
                            if ("auto" !== I && "data" !== I) throw new Error("scene.js aspectRatio was not one of the enumerated types");
                            var z = [
                                1,
                                1,
                                1
                            ];
                            for(a = 0; a < 3; ++a){
                                var D = y[l = (s = c[k[a]]).type];
                                z[a] = Math.pow(D.acc, 1 / D.count) / h[a];
                            }
                            d = "data" === I || Math.max.apply(null, z) / Math.min.apply(null, z) <= 4 ? z : [
                                1,
                                1,
                                1
                            ];
                        }
                        c.aspectratio.x = u.aspectratio.x = d[0], c.aspectratio.y = u.aspectratio.y = d[1], c.aspectratio.z = u.aspectratio.z = d[2], this.glplot.setAspectratio(c.aspectratio), this.viewInitial.aspectratio || (this.viewInitial.aspectratio = {
                            x: c.aspectratio.x,
                            y: c.aspectratio.y,
                            z: c.aspectratio.z
                        }), this.viewInitial.aspectmode || (this.viewInitial.aspectmode = c.aspectmode);
                        var R = c.domain || null, F = e1._size || null;
                        if (R && F) {
                            var B = this.container.style;
                            B.position = "absolute", B.left = F.l + R.x[0] * F.w + "px", B.top = F.t + (1 - R.y[1]) * F.h + "px", B.width = F.w * (R.x[1] - R.x[0]) + "px", B.height = F.h * (R.y[1] - R.y[0]) + "px";
                        }
                        this.glplot.redraw();
                    }
                }, w.destroy = function() {
                    this.glplot && (this.camera.mouseListener.enabled = !1, this.container.removeEventListener("wheel", this.camera.wheelListener), this.camera = null, this.glplot.dispose(), this.container.parentNode.removeChild(this.container), this.glplot = null);
                }, w.getCamera = function() {
                    var t1;
                    return this.camera.view.recalcMatrix(this.camera.view.lastT()), {
                        up: {
                            x: (t1 = this.camera).up[0],
                            y: t1.up[1],
                            z: t1.up[2]
                        },
                        center: {
                            x: t1.center[0],
                            y: t1.center[1],
                            z: t1.center[2]
                        },
                        eye: {
                            x: t1.eye[0],
                            y: t1.eye[1],
                            z: t1.eye[2]
                        },
                        projection: {
                            type: !0 === t1._ortho ? "orthographic" : "perspective"
                        }
                    };
                }, w.setViewport = function(t1) {
                    var e1, r = t1.camera;
                    this.camera.lookAt.apply(this, [
                        [
                            (e1 = r).eye.x,
                            e1.eye.y,
                            e1.eye.z
                        ],
                        [
                            e1.center.x,
                            e1.center.y,
                            e1.center.z
                        ],
                        [
                            e1.up.x,
                            e1.up.y,
                            e1.up.z
                        ]
                    ]), this.glplot.setAspectratio(t1.aspectratio), "orthographic" === r.projection.type !== this.camera._ortho && (this.glplot.redraw(), this.glplot.clearRGBA(), this.glplot.dispose(), this.initializeGLPlot());
                }, w.isCameraChanged = function(t1) {
                    var e1 = this.getCamera(), r = f.nestedProperty(t1, this.id + ".camera").get();
                    function n(t1, e1, r, n) {
                        var i = [
                            "up",
                            "center",
                            "eye"
                        ], a = [
                            "x",
                            "y",
                            "z"
                        ];
                        return e1[i[r]] && t1[i[r]][a[n]] === e1[i[r]][a[n]];
                    }
                    var i = !1;
                    if (void 0 === r) i = !0;
                    else {
                        for(var a = 0; a < 3; a++)for(var o = 0; o < 3; o++)if (!n(e1, r, a, o)) {
                            i = !0;
                            break;
                        }
                        (!r.projection || e1.projection && e1.projection.type !== r.projection.type) && (i = !0);
                    }
                    return i;
                }, w.isAspectChanged = function(t1) {
                    var e1 = this.glplot.getAspectratio(), r = f.nestedProperty(t1, this.id + ".aspectratio").get();
                    return void 0 === r || r.x !== e1.x || r.y !== e1.y || r.z !== e1.z;
                }, w.saveLayout = function(t1) {
                    var e1, r, n, i, a, o, s = this.fullLayout, l = this.isCameraChanged(t1), c = this.isAspectChanged(t1), h = l || c;
                    if (h) {
                        var p = {};
                        if (l && (e1 = this.getCamera(), n = (r = f.nestedProperty(t1, this.id + ".camera")).get(), p[this.id + ".camera"] = n), c && (i = this.glplot.getAspectratio(), o = (a = f.nestedProperty(t1, this.id + ".aspectratio")).get(), p[this.id + ".aspectratio"] = o), u.call("_storeDirectGUIEdit", t1, s._preGUI, p), l) r.set(e1), f.nestedProperty(s, this.id + ".camera").set(e1);
                        if (c) a.set(i), f.nestedProperty(s, this.id + ".aspectratio").set(i), this.glplot.redraw();
                    }
                    return h;
                }, w.updateFx = function(t1, e1) {
                    var r = this.camera;
                    if (r) {
                        if ("orbit" === t1) r.mode = "orbit", r.keyBindingMode = "rotate";
                        else if ("turntable" === t1) {
                            r.up = [
                                0,
                                0,
                                1
                            ], r.mode = "turntable", r.keyBindingMode = "rotate";
                            var n = this.graphDiv, i = n._fullLayout, a = this.fullSceneLayout.camera, o = a.up.x, s = a.up.y, l = a.up.z;
                            if (l / Math.sqrt(o * o + s * s + l * l) < .999) {
                                var c = this.id + ".camera.up", h = {
                                    x: 0,
                                    y: 0,
                                    z: 1
                                }, p = {};
                                p[c] = h;
                                var d = n.layout;
                                u.call("_storeDirectGUIEdit", d, i._preGUI, p), a.up = h, f.nestedProperty(d, c).set(h);
                            }
                        } else r.keyBindingMode = t1;
                    }
                    this.fullSceneLayout.hovermode = e1;
                }, w.toImage = function(t1) {
                    t1 || (t1 = "png"), this.staticMode && this.container.appendChild(n), this.glplot.redraw();
                    var e1 = this.glplot.gl, r = e1.drawingBufferWidth, i = e1.drawingBufferHeight;
                    e1.bindFramebuffer(e1.FRAMEBUFFER, null);
                    var a = new Uint8Array(r * i * 4);
                    e1.readPixels(0, 0, r, i, e1.RGBA, e1.UNSIGNED_BYTE, a), function(t1, e1, r) {
                        for(var n = 0, i = r - 1; n < i; ++n, --i)for(var a = 0; a < e1; ++a)for(var o = 0; o < 4; ++o){
                            var s = 4 * (e1 * n + a) + o, l = 4 * (e1 * i + a) + o, c = t1[s];
                            t1[s] = t1[l], t1[l] = c;
                        }
                    }(a, r, i), function(t1, e1, r) {
                        for(var n = 0; n < r; ++n)for(var i = 0; i < e1; ++i){
                            var a = 4 * (e1 * n + i), o = t1[a + 3];
                            if (o > 0) for(var s = 255 / o, l = 0; l < 3; ++l)t1[a + l] = Math.min(s * t1[a + l], 255);
                        }
                    }(a, r, i);
                    var o = document.createElement("canvas");
                    o.width = r, o.height = i;
                    var s, l = o.getContext("2d"), c = l.createImageData(r, i);
                    switch(c.data.set(a), l.putImageData(c, 0, 0), t1){
                        case "jpeg":
                            s = o.toDataURL("image/jpeg");
                            break;
                        case "webp":
                            s = o.toDataURL("image/webp");
                            break;
                        default:
                            s = o.toDataURL("image/png");
                    }
                    return this.staticMode && this.container.removeChild(n), s;
                }, w.setConvert = function() {
                    for(var t1 = 0; t1 < 3; t1++){
                        var e1 = this.fullSceneLayout[k[t1]];
                        p.setConvert(e1, this.fullLayout), e1.setScale = f.noop;
                    }
                }, w.make4thDimension = function() {
                    var t1 = this.graphDiv._fullLayout;
                    this._mockAxis = {
                        type: "linear",
                        showexponent: "all",
                        exponentformat: "B"
                    }, p.setConvert(this._mockAxis, t1);
                }, e1.exports = _;
            },
            {
                "../../../stackgl_modules": 1120,
                "../../components/fx": 406,
                "../../lib": 503,
                "../../lib/show_no_webgl_msg": 525,
                "../../lib/str2rgbarray": 528,
                "../../plots/cartesian/axes": 554,
                "../../registry": 638,
                "./layout/convert": 602,
                "./layout/spikes": 605,
                "./layout/tick_marks": 606,
                "./project": 607,
                "has-passive-events": 229,
                "webgl-context": 331
            }
        ],
        609: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n) {
                    n = n || t1.length;
                    for(var i = new Array(n), a = 0; a < n; a++)i[a] = [
                        t1[a],
                        e1[a],
                        r[a]
                    ];
                    return i;
                };
            },
            {}
        ],
        610: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./font_attributes"), i = t1("./animation_attributes"), a = t1("../components/color/attributes"), o = t1("../components/shapes/draw_newshape/attributes"), s = t1("./pad_attributes"), l = t1("../lib/extend").extendFlat, c = n({
                    editType: "calc"
                });
                c.family.dflt = '"Open Sans", verdana, arial, sans-serif', c.size.dflt = 12, c.color.dflt = a.defaultLine, e1.exports = {
                    font: c,
                    title: {
                        text: {
                            valType: "string",
                            editType: "layoutstyle"
                        },
                        font: n({
                            editType: "layoutstyle"
                        }),
                        xref: {
                            valType: "enumerated",
                            dflt: "container",
                            values: [
                                "container",
                                "paper"
                            ],
                            editType: "layoutstyle"
                        },
                        yref: {
                            valType: "enumerated",
                            dflt: "container",
                            values: [
                                "container",
                                "paper"
                            ],
                            editType: "layoutstyle"
                        },
                        x: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .5,
                            editType: "layoutstyle"
                        },
                        y: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: "auto",
                            editType: "layoutstyle"
                        },
                        xanchor: {
                            valType: "enumerated",
                            dflt: "auto",
                            values: [
                                "auto",
                                "left",
                                "center",
                                "right"
                            ],
                            editType: "layoutstyle"
                        },
                        yanchor: {
                            valType: "enumerated",
                            dflt: "auto",
                            values: [
                                "auto",
                                "top",
                                "middle",
                                "bottom"
                            ],
                            editType: "layoutstyle"
                        },
                        pad: l(s({
                            editType: "layoutstyle"
                        }), {}),
                        editType: "layoutstyle"
                    },
                    uniformtext: {
                        mode: {
                            valType: "enumerated",
                            values: [
                                !1,
                                "hide",
                                "show"
                            ],
                            dflt: !1,
                            editType: "plot"
                        },
                        minsize: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    autosize: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "none"
                    },
                    width: {
                        valType: "number",
                        min: 10,
                        dflt: 700,
                        editType: "plot"
                    },
                    height: {
                        valType: "number",
                        min: 10,
                        dflt: 450,
                        editType: "plot"
                    },
                    margin: {
                        l: {
                            valType: "number",
                            min: 0,
                            dflt: 80,
                            editType: "plot"
                        },
                        r: {
                            valType: "number",
                            min: 0,
                            dflt: 80,
                            editType: "plot"
                        },
                        t: {
                            valType: "number",
                            min: 0,
                            dflt: 100,
                            editType: "plot"
                        },
                        b: {
                            valType: "number",
                            min: 0,
                            dflt: 80,
                            editType: "plot"
                        },
                        pad: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        autoexpand: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    computed: {
                        valType: "any",
                        editType: "none"
                    },
                    paper_bgcolor: {
                        valType: "color",
                        dflt: a.background,
                        editType: "plot"
                    },
                    plot_bgcolor: {
                        valType: "color",
                        dflt: a.background,
                        editType: "layoutstyle"
                    },
                    autotypenumbers: {
                        valType: "enumerated",
                        values: [
                            "convert types",
                            "strict"
                        ],
                        dflt: "convert types",
                        editType: "calc"
                    },
                    separators: {
                        valType: "string",
                        editType: "plot"
                    },
                    hidesources: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    },
                    showlegend: {
                        valType: "boolean",
                        editType: "legend"
                    },
                    colorway: {
                        valType: "colorlist",
                        dflt: a.defaults,
                        editType: "calc"
                    },
                    datarevision: {
                        valType: "any",
                        editType: "calc"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editrevision: {
                        valType: "any",
                        editType: "none"
                    },
                    selectionrevision: {
                        valType: "any",
                        editType: "none"
                    },
                    template: {
                        valType: "any",
                        editType: "calc"
                    },
                    newshape: o.newshape,
                    activeshape: o.activeshape,
                    meta: {
                        valType: "any",
                        arrayOk: !0,
                        editType: "plot"
                    },
                    transition: l({}, i.transition, {
                        editType: "none"
                    }),
                    _deprecated: {
                        title: {
                            valType: "string",
                            editType: "layoutstyle"
                        },
                        titlefont: n({
                            editType: "layoutstyle"
                        })
                    }
                };
            },
            {
                "../components/color/attributes": 365,
                "../components/shapes/draw_newshape/attributes": 451,
                "../lib/extend": 493,
                "./animation_attributes": 548,
                "./font_attributes": 585,
                "./pad_attributes": 618
            }
        ],
        611: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib/sort_object_keys"), i = '\xa9 <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', a = [
                    '\xa9 <a target="_blank" href="https://carto.com/">Carto</a>',
                    i
                ].join(" "), o = [
                    'Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>',
                    'under <a target="_blank" href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>',
                    "|",
                    'Data by <a target="_blank" href="https://openstreetmap.org">OpenStreetMap</a> contributors',
                    'under <a target="_blank" href="https://www.openstreetmap.org/copyright">ODbL</a>'
                ].join(" "), s = {
                    "open-street-map": {
                        id: "osm",
                        version: 8,
                        sources: {
                            "plotly-osm-tiles": {
                                type: "raster",
                                attribution: i,
                                tiles: [
                                    "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png",
                                    "https://b.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-osm-tiles",
                                type: "raster",
                                source: "plotly-osm-tiles",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ]
                    },
                    "white-bg": {
                        id: "white-bg",
                        version: 8,
                        sources: {},
                        layers: [
                            {
                                id: "white-bg",
                                type: "background",
                                paint: {
                                    "background-color": "#FFFFFF"
                                },
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ]
                    },
                    "carto-positron": {
                        id: "carto-positron",
                        version: 8,
                        sources: {
                            "plotly-carto-positron": {
                                type: "raster",
                                attribution: a,
                                tiles: [
                                    "https://cartodb-basemaps-c.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-carto-positron",
                                type: "raster",
                                source: "plotly-carto-positron",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ]
                    },
                    "carto-darkmatter": {
                        id: "carto-darkmatter",
                        version: 8,
                        sources: {
                            "plotly-carto-darkmatter": {
                                type: "raster",
                                attribution: a,
                                tiles: [
                                    "https://cartodb-basemaps-c.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png"
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-carto-darkmatter",
                                type: "raster",
                                source: "plotly-carto-darkmatter",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ]
                    },
                    "stamen-terrain": {
                        id: "stamen-terrain",
                        version: 8,
                        sources: {
                            "plotly-stamen-terrain": {
                                type: "raster",
                                attribution: o,
                                tiles: [
                                    "https://stamen-tiles.a.ssl.fastly.net/terrain/{z}/{x}/{y}.png"
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-stamen-terrain",
                                type: "raster",
                                source: "plotly-stamen-terrain",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ]
                    },
                    "stamen-toner": {
                        id: "stamen-toner",
                        version: 8,
                        sources: {
                            "plotly-stamen-toner": {
                                type: "raster",
                                attribution: o,
                                tiles: [
                                    "https://stamen-tiles.a.ssl.fastly.net/toner/{z}/{x}/{y}.png"
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-stamen-toner",
                                type: "raster",
                                source: "plotly-stamen-toner",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ]
                    },
                    "stamen-watercolor": {
                        id: "stamen-watercolor",
                        version: 8,
                        sources: {
                            "plotly-stamen-watercolor": {
                                type: "raster",
                                attribution: [
                                    'Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>',
                                    'under <a target="_blank" href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>',
                                    "|",
                                    'Data by <a target="_blank" href="https://openstreetmap.org">OpenStreetMap</a> contributors',
                                    'under <a target="_blank" href="https://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>'
                                ].join(" "),
                                tiles: [
                                    "https://stamen-tiles.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.png"
                                ],
                                tileSize: 256
                            }
                        },
                        layers: [
                            {
                                id: "plotly-stamen-watercolor",
                                type: "raster",
                                source: "plotly-stamen-watercolor",
                                minzoom: 0,
                                maxzoom: 22
                            }
                        ]
                    }
                }, l = n(s);
                e1.exports = {
                    requiredVersion: "1.10.1",
                    styleUrlPrefix: "mapbox://styles/mapbox/",
                    styleUrlSuffix: "v9",
                    styleValuesMapbox: [
                        "basic",
                        "streets",
                        "outdoors",
                        "light",
                        "dark",
                        "satellite",
                        "satellite-streets"
                    ],
                    styleValueDflt: "basic",
                    stylesNonMapbox: s,
                    styleValuesNonMapbox: l,
                    traceLayerPrefix: "plotly-trace-layer-",
                    layoutLayerPrefix: "plotly-layout-layer-",
                    wrongVersionErrorMsg: [
                        "Your custom plotly.js bundle is not using the correct mapbox-gl version",
                        "Please install mapbox-gl@1.10.1."
                    ].join("\n"),
                    noAccessTokenErrorMsg: [
                        "Missing Mapbox access token.",
                        "Mapbox trace type require a Mapbox access token to be registered.",
                        "For example:",
                        "  Plotly.newPlot(gd, data, layout, { mapboxAccessToken: 'my-access-token' });",
                        "More info here: https://www.mapbox.com/help/define-access-token/"
                    ].join("\n"),
                    missingStyleErrorMsg: [
                        "No valid mapbox style found, please set `mapbox.style` to one of:",
                        l.join(", "),
                        "or register a Mapbox access token to use a Mapbox-served style."
                    ].join("\n"),
                    multipleTokensErrorMsg: [
                        "Set multiple mapbox access token across different mapbox subplot,",
                        "using first token found as mapbox-gl does not allow multipleaccess tokens on the same page."
                    ].join("\n"),
                    mapOnErrorMsg: "Mapbox error.",
                    mapboxLogo: {
                        path0: "m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z",
                        path1: "M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z",
                        path2: "M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z",
                        polygon: "11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34"
                    },
                    styleRules: {
                        map: "overflow:hidden;position:relative;",
                        "missing-css": "display:none;",
                        canary: "background-color:salmon;",
                        "ctrl-bottom-left": "position: absolute; pointer-events: none; z-index: 2; bottom: 0; left: 0;",
                        "ctrl-bottom-right": "position: absolute; pointer-events: none; z-index: 2; right: 0; bottom: 0;",
                        ctrl: "clear: both; pointer-events: auto; transform: translate(0, 0);",
                        "ctrl-attrib.mapboxgl-compact .mapboxgl-ctrl-attrib-inner": "display: none;",
                        "ctrl-attrib.mapboxgl-compact:hover .mapboxgl-ctrl-attrib-inner": "display: block; margin-top:2px",
                        "ctrl-attrib.mapboxgl-compact:hover": "padding: 2px 24px 2px 4px; visibility: visible; margin-top: 6px;",
                        "ctrl-attrib.mapboxgl-compact::after": 'content: ""; cursor: pointer; position: absolute; background-image: url(\'data:image/svg+xml;charset=utf-8,%3Csvg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"%3E %3Cpath fill="%23333333" fill-rule="evenodd" d="M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0"/%3E %3C/svg%3E\'); background-color: rgba(255, 255, 255, 0.5); width: 24px; height: 24px; box-sizing: border-box; border-radius: 12px;',
                        "ctrl-attrib.mapboxgl-compact": "min-height: 20px; padding: 0; margin: 10px; position: relative; background-color: #fff; border-radius: 3px 12px 12px 3px;",
                        "ctrl-bottom-right > .mapboxgl-ctrl-attrib.mapboxgl-compact::after": "bottom: 0; right: 0",
                        "ctrl-bottom-left > .mapboxgl-ctrl-attrib.mapboxgl-compact::after": "bottom: 0; left: 0",
                        "ctrl-bottom-left .mapboxgl-ctrl": "margin: 0 0 10px 10px; float: left;",
                        "ctrl-bottom-right .mapboxgl-ctrl": "margin: 0 10px 10px 0; float: right;",
                        "ctrl-attrib": "color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px",
                        "ctrl-attrib a": "color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px",
                        "ctrl-attrib a:hover": "color: inherit; text-decoration: underline;",
                        "ctrl-attrib .mapbox-improve-map": "font-weight: bold; margin-left: 2px;",
                        "attrib-empty": "display: none;",
                        "ctrl-logo": 'display:block; width: 21px; height: 21px; background-image: url(\'data:image/svg+xml;charset=utf-8,%3C?xml version="1.0" encoding="utf-8"?%3E %3Csvg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21 21" style="enable-background:new 0 0 21 21;" xml:space="preserve"%3E%3Cg transform="translate(0,0.01)"%3E%3Cpath d="m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z" style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3Cpath d="M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpath d="M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpolygon points="11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34 " style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3C/g%3E%3C/svg%3E\')'
                    }
                };
            },
            {
                "../../lib/sort_object_keys": 526
            }
        ],
        612: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = function(t1, e1) {
                    var r = t1.split(" "), i = r[0], a = r[1], o = n.isArrayOrTypedArray(e1) ? n.mean(e1) : e1, s = .5 + o / 100, l = 1.5 + o / 100, c = [
                        "",
                        ""
                    ], u = [
                        0,
                        0
                    ];
                    switch(i){
                        case "top":
                            c[0] = "top", u[1] = -l;
                            break;
                        case "bottom":
                            c[0] = "bottom", u[1] = l;
                    }
                    switch(a){
                        case "left":
                            c[1] = "right", u[0] = -s;
                            break;
                        case "right":
                            c[1] = "left", u[0] = s;
                    }
                    return {
                        anchor: c[0] && c[1] ? c.join("-") : c[0] ? c[0] : c[1] ? c[1] : "center",
                        offset: u
                    };
                };
            },
            {
                "../../lib": 503
            }
        ],
        613: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("mapbox-gl/dist/mapbox-gl-unminified"), i = t1("../../lib"), a = i.strTranslate, o = i.strScale, s = t1("../../plots/get_data").getSubplotCalcData, l = t1("../../constants/xmlns_namespaces"), c = t1("@plotly/d3"), u = t1("../../components/drawing"), f = t1("../../lib/svg_text_utils"), h = t1("./mapbox"), p = r.constants = t1("./constants");
                function d(t1) {
                    return "string" == typeof t1 && (-1 !== p.styleValuesMapbox.indexOf(t1) || 0 === t1.indexOf("mapbox://"));
                }
                r.name = "mapbox", r.attr = "subplot", r.idRoot = "mapbox", r.idRegex = r.attrRegex = i.counterRegex("mapbox"), r.attributes = {
                    subplot: {
                        valType: "subplotid",
                        dflt: "mapbox",
                        editType: "calc"
                    }
                }, r.layoutAttributes = t1("./layout_attributes"), r.supplyLayoutDefaults = t1("./layout_defaults"), r.plot = function(t1) {
                    var e1 = t1._fullLayout, r = t1.calcdata, a = e1._subplots.mapbox;
                    if (n.version !== p.requiredVersion) throw new Error(p.wrongVersionErrorMsg);
                    var o = function(t1, e1) {
                        var r = t1._fullLayout;
                        if ("" === t1._context.mapboxAccessToken) return "";
                        for(var n = [], a = [], o = !1, s = !1, l = 0; l < e1.length; l++){
                            var c = r[e1[l]], u = c.accesstoken;
                            d(c.style) && (u ? i.pushUnique(n, u) : (d(c._input.style) && (i.error("Uses Mapbox map style, but did not set an access token."), o = !0), s = !0)), u && i.pushUnique(a, u);
                        }
                        if (s) {
                            var f = o ? p.noAccessTokenErrorMsg : p.missingStyleErrorMsg;
                            throw i.error(f), new Error(f);
                        }
                        return n.length ? (n.length > 1 && i.warn(p.multipleTokensErrorMsg), n[0]) : (a.length && i.log([
                            "Listed mapbox access token(s)",
                            a.join(","),
                            "but did not use a Mapbox map style, ignoring token(s)."
                        ].join(" ")), "");
                    }(t1, a);
                    n.accessToken = o;
                    for(var l = 0; l < a.length; l++){
                        var c = a[l], u = s(r, "mapbox", c), f = e1[c], m = f._subplot;
                        m || (m = new h(t1, c), e1[c]._subplot = m), m.viewInitial || (m.viewInitial = {
                            center: i.extendFlat({}, f.center),
                            zoom: f.zoom,
                            bearing: f.bearing,
                            pitch: f.pitch
                        }), m.plot(u, e1, t1._promises);
                    }
                }, r.clean = function(t1, e1, r, n) {
                    for(var i = n._subplots.mapbox || [], a = 0; a < i.length; a++){
                        var o = i[a];
                        !e1[o] && n[o]._subplot && n[o]._subplot.destroy();
                    }
                }, r.toSVG = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots.mapbox, n = e1._size, i = 0; i < r.length; i++){
                        var s = e1[r[i]], h = s.domain, d = s._subplot.toImage("png");
                        e1._glimages.append("svg:image").attr({
                            xmlns: l.svg,
                            "xlink:href": d,
                            x: n.l + n.w * h.x[0],
                            y: n.t + n.h * (1 - h.y[1]),
                            width: n.w * (h.x[1] - h.x[0]),
                            height: n.h * (h.y[1] - h.y[0]),
                            preserveAspectRatio: "none"
                        });
                        var m = c.select(s._subplot.div);
                        if (!(null === m.select(".mapboxgl-ctrl-logo").node().offsetParent)) {
                            var g = e1._glimages.append("g");
                            g.attr("transform", a(n.l + n.w * h.x[0] + 10, n.t + n.h * (1 - h.y[0]) - 31)), g.append("path").attr("d", p.mapboxLogo.path0).style({
                                opacity: .9,
                                fill: "#ffffff",
                                "enable-background": "new"
                            }), g.append("path").attr("d", p.mapboxLogo.path1).style("opacity", .35).style("enable-background", "new"), g.append("path").attr("d", p.mapboxLogo.path2).style("opacity", .35).style("enable-background", "new"), g.append("polygon").attr("points", p.mapboxLogo.polygon).style({
                                opacity: .9,
                                fill: "#ffffff",
                                "enable-background": "new"
                            });
                        }
                        var v = m.select(".mapboxgl-ctrl-attrib").text().replace("Improve this map", ""), y = e1._glimages.append("g"), x = y.append("text");
                        x.text(v).classed("static-attribution", !0).attr({
                            "font-size": 12,
                            "font-family": "Arial",
                            color: "rgba(0, 0, 0, 0.75)",
                            "text-anchor": "end",
                            "data-unformatted": v
                        });
                        var b = u.bBox(x.node()), _ = n.w * (h.x[1] - h.x[0]);
                        if (b.width > _ / 2) {
                            var w = v.split("|").join("<br>");
                            x.text(w).attr("data-unformatted", w).call(f.convertToTspans, t1), b = u.bBox(x.node());
                        }
                        x.attr("transform", a(-3, 8 - b.height)), y.insert("rect", ".static-attribution").attr({
                            x: -b.width - 6,
                            y: -b.height - 3,
                            width: b.width + 6,
                            height: b.height + 3,
                            fill: "rgba(255, 255, 255, 0.75)"
                        });
                        var T = 1;
                        b.width + 6 > _ && (T = _ / (b.width + 6));
                        var k = [
                            n.l + n.w * h.x[1],
                            n.t + n.h * (1 - h.y[0])
                        ];
                        y.attr("transform", a(k[0], k[1]) + o(T));
                    }
                }, r.updateFx = function(t1) {
                    for(var e1 = t1._fullLayout, r = e1._subplots.mapbox, n = 0; n < r.length; n++)e1[r[n]]._subplot.updateFx(e1);
                };
            },
            {
                "../../components/drawing": 388,
                "../../constants/xmlns_namespaces": 480,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../plots/get_data": 593,
                "./constants": 611,
                "./layout_attributes": 615,
                "./layout_defaults": 616,
                "./mapbox": 617,
                "@plotly/d3": 58,
                "mapbox-gl/dist/mapbox-gl-unminified": 239
            }
        ],
        614: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../lib/svg_text_utils").sanitizeHTML, a = t1("./convert_text_opts"), o = t1("./constants");
                function s(t1, e1) {
                    this.subplot = t1, this.uid = t1.uid + "-" + e1, this.index = e1, this.idSource = "source-" + this.uid, this.idLayer = o.layoutLayerPrefix + this.uid, this.sourceType = null, this.source = null, this.layerType = null, this.below = null, this.visible = !1;
                }
                var l = s.prototype;
                function c(t1) {
                    if (!t1.visible) return !1;
                    var e1 = t1.source;
                    if (Array.isArray(e1) && e1.length > 0) {
                        for(var r = 0; r < e1.length; r++)if ("string" != typeof e1[r] || 0 === e1[r].length) return !1;
                        return !0;
                    }
                    return n.isPlainObject(e1) || "string" == typeof e1 && e1.length > 0;
                }
                function u(t1) {
                    var e1 = {}, r = {};
                    switch(t1.type){
                        case "circle":
                            n.extendFlat(r, {
                                "circle-radius": t1.circle.radius,
                                "circle-color": t1.color,
                                "circle-opacity": t1.opacity
                            });
                            break;
                        case "line":
                            n.extendFlat(r, {
                                "line-width": t1.line.width,
                                "line-color": t1.color,
                                "line-opacity": t1.opacity,
                                "line-dasharray": t1.line.dash
                            });
                            break;
                        case "fill":
                            n.extendFlat(r, {
                                "fill-color": t1.color,
                                "fill-outline-color": t1.fill.outlinecolor,
                                "fill-opacity": t1.opacity
                            });
                            break;
                        case "symbol":
                            var i = t1.symbol, o = a(i.textposition, i.iconsize);
                            n.extendFlat(e1, {
                                "icon-image": i.icon + "-15",
                                "icon-size": i.iconsize / 10,
                                "text-field": i.text,
                                "text-size": i.textfont.size,
                                "text-anchor": o.anchor,
                                "text-offset": o.offset,
                                "symbol-placement": i.placement
                            }), n.extendFlat(r, {
                                "icon-color": t1.color,
                                "text-color": i.textfont.color,
                                "text-opacity": t1.opacity
                            });
                            break;
                        case "raster":
                            n.extendFlat(r, {
                                "raster-fade-duration": 0,
                                "raster-opacity": t1.opacity
                            });
                    }
                    return {
                        layout: e1,
                        paint: r
                    };
                }
                l.update = function(t1) {
                    this.visible ? this.needsNewImage(t1) ? this.updateImage(t1) : this.needsNewSource(t1) ? (this.removeLayer(), this.updateSource(t1), this.updateLayer(t1)) : this.needsNewLayer(t1) ? this.updateLayer(t1) : this.updateStyle(t1) : (this.updateSource(t1), this.updateLayer(t1)), this.visible = c(t1);
                }, l.needsNewImage = function(t1) {
                    return this.subplot.map.getSource(this.idSource) && "image" === this.sourceType && "image" === t1.sourcetype && (this.source !== t1.source || JSON.stringify(this.coordinates) !== JSON.stringify(t1.coordinates));
                }, l.needsNewSource = function(t1) {
                    return this.sourceType !== t1.sourcetype || JSON.stringify(this.source) !== JSON.stringify(t1.source) || this.layerType !== t1.type;
                }, l.needsNewLayer = function(t1) {
                    return this.layerType !== t1.type || this.below !== this.subplot.belowLookup["layout-" + this.index];
                }, l.lookupBelow = function() {
                    return this.subplot.belowLookup["layout-" + this.index];
                }, l.updateImage = function(t1) {
                    this.subplot.map.getSource(this.idSource).updateImage({
                        url: t1.source,
                        coordinates: t1.coordinates
                    });
                    var e1 = this.findFollowingMapboxLayerId(this.lookupBelow());
                    null !== e1 && this.subplot.map.moveLayer(this.idLayer, e1);
                }, l.updateSource = function(t1) {
                    var e1 = this.subplot.map;
                    if (e1.getSource(this.idSource) && e1.removeSource(this.idSource), this.sourceType = t1.sourcetype, this.source = t1.source, c(t1)) {
                        var r = function(t1) {
                            var e1, r = t1.sourcetype, n = t1.source, a = {
                                type: r
                            };
                            "geojson" === r ? e1 = "data" : "vector" === r ? e1 = "string" == typeof n ? "url" : "tiles" : "raster" === r ? (e1 = "tiles", a.tileSize = 256) : "image" === r && (e1 = "url", a.coordinates = t1.coordinates);
                            a[e1] = n, t1.sourceattribution && (a.attribution = i(t1.sourceattribution));
                            return a;
                        }(t1);
                        e1.addSource(this.idSource, r);
                    }
                }, l.findFollowingMapboxLayerId = function(t1) {
                    if ("traces" === t1) for(var e1 = this.subplot.getMapLayers(), r = 0; r < e1.length; r++){
                        var n = e1[r].id;
                        if ("string" == typeof n && 0 === n.indexOf(o.traceLayerPrefix)) {
                            t1 = n;
                            break;
                        }
                    }
                    return t1;
                }, l.updateLayer = function(t1) {
                    var e1 = this.subplot, r = u(t1), n = this.lookupBelow(), i = this.findFollowingMapboxLayerId(n);
                    this.removeLayer(), c(t1) && e1.addLayer({
                        id: this.idLayer,
                        source: this.idSource,
                        "source-layer": t1.sourcelayer || "",
                        type: t1.type,
                        minzoom: t1.minzoom,
                        maxzoom: t1.maxzoom,
                        layout: r.layout,
                        paint: r.paint
                    }, i), this.layerType = t1.type, this.below = n;
                }, l.updateStyle = function(t1) {
                    if (c(t1)) {
                        var e1 = u(t1);
                        this.subplot.setOptions(this.idLayer, "setLayoutProperty", e1.layout), this.subplot.setOptions(this.idLayer, "setPaintProperty", e1.paint);
                    }
                }, l.removeLayer = function() {
                    var t1 = this.subplot.map;
                    t1.getLayer(this.idLayer) && t1.removeLayer(this.idLayer);
                }, l.dispose = function() {
                    var t1 = this.subplot.map;
                    t1.getLayer(this.idLayer) && t1.removeLayer(this.idLayer), t1.getSource(this.idSource) && t1.removeSource(this.idSource);
                }, e1.exports = function(t1, e1, r) {
                    var n = new s(t1, e1);
                    return n.update(r), n;
                };
            },
            {
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "./constants": 611,
                "./convert_text_opts": 612
            }
        ],
        615: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/color").defaultLine, a = t1("../domain").attributes, o = t1("../font_attributes"), s = t1("../../traces/scatter/attributes").textposition, l = t1("../../plot_api/edit_types").overrideAll, c = t1("../../plot_api/plot_template").templatedArray, u = t1("./constants"), f = o({});
                f.family.dflt = "Open Sans Regular, Arial Unicode MS Regular", (e1.exports = l({
                    _arrayAttrRegexps: [
                        n.counterRegex("mapbox", ".layers", !0)
                    ],
                    domain: a({
                        name: "mapbox"
                    }),
                    accesstoken: {
                        valType: "string",
                        noBlank: !0,
                        strict: !0
                    },
                    style: {
                        valType: "any",
                        values: u.styleValuesMapbox.concat(u.styleValuesNonMapbox),
                        dflt: u.styleValueDflt
                    },
                    center: {
                        lon: {
                            valType: "number",
                            dflt: 0
                        },
                        lat: {
                            valType: "number",
                            dflt: 0
                        }
                    },
                    zoom: {
                        valType: "number",
                        dflt: 1
                    },
                    bearing: {
                        valType: "number",
                        dflt: 0
                    },
                    pitch: {
                        valType: "number",
                        dflt: 0
                    },
                    layers: c("layer", {
                        visible: {
                            valType: "boolean",
                            dflt: !0
                        },
                        sourcetype: {
                            valType: "enumerated",
                            values: [
                                "geojson",
                                "vector",
                                "raster",
                                "image"
                            ],
                            dflt: "geojson"
                        },
                        source: {
                            valType: "any"
                        },
                        sourcelayer: {
                            valType: "string",
                            dflt: ""
                        },
                        sourceattribution: {
                            valType: "string"
                        },
                        type: {
                            valType: "enumerated",
                            values: [
                                "circle",
                                "line",
                                "fill",
                                "symbol",
                                "raster"
                            ],
                            dflt: "circle"
                        },
                        coordinates: {
                            valType: "any"
                        },
                        below: {
                            valType: "string"
                        },
                        color: {
                            valType: "color",
                            dflt: i
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1
                        },
                        minzoom: {
                            valType: "number",
                            min: 0,
                            max: 24,
                            dflt: 0
                        },
                        maxzoom: {
                            valType: "number",
                            min: 0,
                            max: 24,
                            dflt: 24
                        },
                        circle: {
                            radius: {
                                valType: "number",
                                dflt: 15
                            }
                        },
                        line: {
                            width: {
                                valType: "number",
                                dflt: 2
                            },
                            dash: {
                                valType: "data_array"
                            }
                        },
                        fill: {
                            outlinecolor: {
                                valType: "color",
                                dflt: i
                            }
                        },
                        symbol: {
                            icon: {
                                valType: "string",
                                dflt: "marker"
                            },
                            iconsize: {
                                valType: "number",
                                dflt: 10
                            },
                            text: {
                                valType: "string",
                                dflt: ""
                            },
                            placement: {
                                valType: "enumerated",
                                values: [
                                    "point",
                                    "line",
                                    "line-center"
                                ],
                                dflt: "point"
                            },
                            textfont: f,
                            textposition: n.extendFlat({}, s, {
                                arrayOk: !1
                            })
                        }
                    })
                }, "plot", "from-root")).uirevision = {
                    valType: "any",
                    editType: "none"
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../../plot_api/edit_types": 536,
                "../../plot_api/plot_template": 543,
                "../../traces/scatter/attributes": 926,
                "../domain": 584,
                "../font_attributes": 585,
                "./constants": 611
            }
        ],
        616: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../subplot_defaults"), a = t1("../array_container_defaults"), o = t1("./layout_attributes");
                function s(t1, e1, r, n) {
                    r("accesstoken", n.accessToken), r("style"), r("center.lon"), r("center.lat"), r("zoom"), r("bearing"), r("pitch"), a(t1, e1, {
                        name: "layers",
                        handleItemDefaults: l
                    }), e1._input = t1;
                }
                function l(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, o.layers, r, i);
                    }
                    if (r("visible")) {
                        var i, a = r("sourcetype"), s = "raster" === a || "image" === a;
                        r("source"), r("sourceattribution"), "vector" === a && r("sourcelayer"), "image" === a && r("coordinates"), s && (i = "raster");
                        var l = r("type", i);
                        s && "raster" !== l && (l = e1.type = "raster", n.log("Source types *raster* and *image* must drawn *raster* layer type.")), r("below"), r("color"), r("opacity"), r("minzoom"), r("maxzoom"), "circle" === l && r("circle.radius"), "line" === l && (r("line.width"), r("line.dash")), "fill" === l && r("fill.outlinecolor"), "symbol" === l && (r("symbol.icon"), r("symbol.iconsize"), r("symbol.text"), n.coerceFont(r, "symbol.textfont"), r("symbol.textposition"), r("symbol.placement"));
                    }
                }
                e1.exports = function(t1, e1, r) {
                    i(t1, e1, r, {
                        type: "mapbox",
                        attributes: o,
                        handleDefaults: s,
                        partition: "y",
                        accessToken: e1._mapboxAccessToken
                    });
                };
            },
            {
                "../../lib": 503,
                "../array_container_defaults": 549,
                "../subplot_defaults": 632,
                "./layout_attributes": 615
            }
        ],
        617: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("mapbox-gl/dist/mapbox-gl-unminified"), i = t1("../../lib"), a = t1("../../lib/geo_location_utils"), o = t1("../../registry"), s = t1("../cartesian/axes"), l = t1("../../components/dragelement"), c = t1("../../components/fx"), u = t1("../../components/dragelement/helpers"), f = u.rectMode, h = u.drawMode, p = u.selectMode, d = t1("../cartesian/select").prepSelect, m = t1("../cartesian/select").clearSelect, g = t1("../cartesian/select").clearSelectionsCache, v = t1("../cartesian/select").selectOnClick, y = t1("./constants"), x = t1("./layers");
                function b(t1, e1) {
                    this.id = e1, this.gd = t1;
                    var r = t1._fullLayout, n = t1._context;
                    this.container = r._glcontainer.node(), this.isStatic = n.staticPlot, this.uid = r._uid + "-" + this.id, this.div = null, this.xaxis = null, this.yaxis = null, this.createFramework(r), this.map = null, this.accessToken = null, this.styleObj = null, this.traceHash = {}, this.layerList = [], this.belowLookup = {}, this.dragging = !1, this.wheeling = !1;
                }
                var _ = b.prototype;
                _.plot = function(t1, e1, r) {
                    var n, i = this, a = e1[i.id];
                    i.map && a.accesstoken !== i.accessToken && (i.map.remove(), i.map = null, i.styleObj = null, i.traceHash = {}, i.layerList = []), n = i.map ? new Promise(function(r, n) {
                        i.updateMap(t1, e1, r, n);
                    }) : new Promise(function(r, n) {
                        i.createMap(t1, e1, r, n);
                    }), r.push(n);
                }, _.createMap = function(t1, e1, r, i) {
                    var o = this, s = e1[o.id], l = o.styleObj = T(s.style);
                    o.accessToken = s.accesstoken;
                    var c = o.map = new n.Map({
                        container: o.div,
                        style: l.style,
                        center: A(s.center),
                        zoom: s.zoom,
                        bearing: s.bearing,
                        pitch: s.pitch,
                        interactive: !o.isStatic,
                        preserveDrawingBuffer: o.isStatic,
                        doubleClickZoom: !1,
                        boxZoom: !1,
                        attributionControl: !1
                    }).addControl(new n.AttributionControl({
                        compact: !0
                    }));
                    c._canvas.style.left = "0px", c._canvas.style.top = "0px", o.rejectOnError(i), o.isStatic || o.initFx(t1, e1);
                    var u = [];
                    u.push(new Promise(function(t1) {
                        c.once("load", t1);
                    })), u = u.concat(a.fetchTraceGeoData(t1)), Promise.all(u).then(function() {
                        o.fillBelowLookup(t1, e1), o.updateData(t1), o.updateLayout(e1), o.resolveOnRender(r);
                    }).catch(i);
                }, _.updateMap = function(t1, e1, r, n) {
                    var i = this, o = i.map, s = e1[this.id];
                    i.rejectOnError(n);
                    var l = [], c = T(s.style);
                    JSON.stringify(i.styleObj) !== JSON.stringify(c) && (i.styleObj = c, o.setStyle(c.style), i.traceHash = {}, l.push(new Promise(function(t1) {
                        o.once("styledata", t1);
                    }))), l = l.concat(a.fetchTraceGeoData(t1)), Promise.all(l).then(function() {
                        i.fillBelowLookup(t1, e1), i.updateData(t1), i.updateLayout(e1), i.resolveOnRender(r);
                    }).catch(n);
                }, _.fillBelowLookup = function(t1, e1) {
                    var r, n, i = e1[this.id].layers, a = this.belowLookup = {}, o = !1;
                    for(r = 0; r < t1.length; r++){
                        var s = t1[r][0].trace, l = s._module;
                        "string" == typeof s.below ? n = s.below : l.getBelow && (n = l.getBelow(s, this)), "" === n && (o = !0), a["trace-" + s.uid] = n || "";
                    }
                    for(r = 0; r < i.length; r++){
                        var c = i[r];
                        n = "string" == typeof c.below ? c.below : o ? "traces" : "", a["layout-" + r] = n;
                    }
                    var u, f, h = {};
                    for(u in a)h[n = a[u]] ? h[n].push(u) : h[n] = [
                        u
                    ];
                    for(n in h){
                        var p = h[n];
                        if (p.length > 1) for(r = 0; r < p.length; r++)0 === (u = p[r]).indexOf("trace-") ? (f = u.split("trace-")[1], this.traceHash[f] && (this.traceHash[f].below = null)) : 0 === u.indexOf("layout-") && (f = u.split("layout-")[1], this.layerList[f] && (this.layerList[f].below = null));
                    }
                };
                var w = {
                    choroplethmapbox: 0,
                    densitymapbox: 1,
                    scattermapbox: 2
                };
                function T(t1) {
                    var e1 = {};
                    return i.isPlainObject(t1) ? (e1.id = t1.id, e1.style = t1) : "string" == typeof t1 ? (e1.id = t1, -1 !== y.styleValuesMapbox.indexOf(t1) ? e1.style = k(t1) : y.stylesNonMapbox[t1] ? e1.style = y.stylesNonMapbox[t1] : e1.style = t1) : (e1.id = y.styleValueDflt, e1.style = k(y.styleValueDflt)), e1.transition = {
                        duration: 0,
                        delay: 0
                    }, e1;
                }
                function k(t1) {
                    return y.styleUrlPrefix + t1 + "-" + y.styleUrlSuffix;
                }
                function A(t1) {
                    return [
                        t1.lon,
                        t1.lat
                    ];
                }
                _.updateData = function(t1) {
                    var e1, r, n, i, a = this.traceHash, o = t1.slice().sort(function(t1, e1) {
                        return w[t1[0].trace.type] - w[e1[0].trace.type];
                    });
                    for(n = 0; n < o.length; n++){
                        var s = o[n], l = !1;
                        (e1 = a[(r = s[0].trace).uid]) && (e1.type === r.type ? (e1.update(s), l = !0) : e1.dispose()), !l && r._module && (a[r.uid] = r._module.plot(this, s));
                    }
                    var c = Object.keys(a);
                    t: for(n = 0; n < c.length; n++){
                        var u = c[n];
                        for(i = 0; i < t1.length; i++)if (u === (r = t1[i][0].trace).uid) continue t;
                        (e1 = a[u]).dispose(), delete a[u];
                    }
                }, _.updateLayout = function(t1) {
                    var e1 = this.map, r = t1[this.id];
                    this.dragging || this.wheeling || (e1.setCenter(A(r.center)), e1.setZoom(r.zoom), e1.setBearing(r.bearing), e1.setPitch(r.pitch)), this.updateLayers(t1), this.updateFramework(t1), this.updateFx(t1), this.map.resize(), this.gd._context._scrollZoom.mapbox ? e1.scrollZoom.enable() : e1.scrollZoom.disable();
                }, _.resolveOnRender = function(t1) {
                    var e1 = this.map;
                    e1.on("render", function r() {
                        e1.loaded() && (e1.off("render", r), setTimeout(t1, 10));
                    });
                }, _.rejectOnError = function(t1) {
                    var e1 = this.map;
                    function r() {
                        t1(new Error(y.mapOnErrorMsg));
                    }
                    e1.once("error", r), e1.once("style.error", r), e1.once("source.error", r), e1.once("tile.error", r), e1.once("layer.error", r);
                }, _.createFramework = function(t1) {
                    var e1 = this, r = e1.div = document.createElement("div");
                    r.id = e1.uid, r.style.position = "absolute", e1.container.appendChild(r), e1.xaxis = {
                        _id: "x",
                        c2p: function(t1) {
                            return e1.project(t1).x;
                        }
                    }, e1.yaxis = {
                        _id: "y",
                        c2p: function(t1) {
                            return e1.project(t1).y;
                        }
                    }, e1.updateFramework(t1), e1.mockAxis = {
                        type: "linear",
                        showexponent: "all",
                        exponentformat: "B"
                    }, s.setConvert(e1.mockAxis, t1);
                }, _.initFx = function(t1, e1) {
                    var r = this, n = r.gd, i = r.map;
                    function a() {
                        c.loneUnhover(e1._hoverlayer);
                    }
                    function s() {
                        var t1 = r.getView();
                        n.emit("plotly_relayouting", r.getViewEditsWithDerived(t1));
                    }
                    i.on("moveend", function(t1) {
                        if (r.map) {
                            var e1 = n._fullLayout;
                            if (t1.originalEvent || r.wheeling) {
                                var i = e1[r.id];
                                o.call("_storeDirectGUIEdit", n.layout, e1._preGUI, r.getViewEdits(i));
                                var a = r.getView();
                                i._input.center = i.center = a.center, i._input.zoom = i.zoom = a.zoom, i._input.bearing = i.bearing = a.bearing, i._input.pitch = i.pitch = a.pitch, n.emit("plotly_relayout", r.getViewEditsWithDerived(a));
                            }
                            t1.originalEvent && "mouseup" === t1.originalEvent.type ? r.dragging = !1 : r.wheeling && (r.wheeling = !1), e1._rehover && e1._rehover();
                        }
                    }), i.on("wheel", function() {
                        r.wheeling = !0;
                    }), i.on("mousemove", function(t1) {
                        var e1 = r.div.getBoundingClientRect(), a = [
                            t1.originalEvent.offsetX,
                            t1.originalEvent.offsetY
                        ];
                        t1.target.getBoundingClientRect = function() {
                            return e1;
                        }, r.xaxis.p2c = function() {
                            return i.unproject(a).lng;
                        }, r.yaxis.p2c = function() {
                            return i.unproject(a).lat;
                        }, n._fullLayout._rehover = function() {
                            n._fullLayout._hoversubplot === r.id && n._fullLayout[r.id] && c.hover(n, t1, r.id);
                        }, c.hover(n, t1, r.id), n._fullLayout._hoversubplot = r.id;
                    }), i.on("dragstart", function() {
                        r.dragging = !0, a();
                    }), i.on("zoomstart", a), i.on("mouseout", function() {
                        n._fullLayout._hoversubplot = null;
                    }), i.on("drag", s), i.on("zoom", s), i.on("dblclick", function() {
                        var t1 = n._fullLayout[r.id];
                        o.call("_storeDirectGUIEdit", n.layout, n._fullLayout._preGUI, r.getViewEdits(t1));
                        var e1 = r.viewInitial;
                        i.setCenter(A(e1.center)), i.setZoom(e1.zoom), i.setBearing(e1.bearing), i.setPitch(e1.pitch);
                        var a = r.getView();
                        t1._input.center = t1.center = a.center, t1._input.zoom = t1.zoom = a.zoom, t1._input.bearing = t1.bearing = a.bearing, t1._input.pitch = t1.pitch = a.pitch, n.emit("plotly_doubleclick", null), n.emit("plotly_relayout", r.getViewEditsWithDerived(a));
                    }), r.clearSelect = function() {
                        g(r.dragOptions), m(r.dragOptions.gd);
                    }, r.onClickInPanFn = function(t1) {
                        return function(e1) {
                            var i = n._fullLayout.clickmode;
                            i.indexOf("select") > -1 && v(e1.originalEvent, n, [
                                r.xaxis
                            ], [
                                r.yaxis
                            ], r.id, t1), i.indexOf("event") > -1 && c.click(n, e1.originalEvent);
                        };
                    };
                }, _.updateFx = function(t1) {
                    var e1 = this, r = e1.map, n = e1.gd;
                    if (!e1.isStatic) {
                        var a, o = t1.dragmode;
                        a = f(o) ? function(t1, r) {
                            (t1.range = {})[e1.id] = [
                                c([
                                    r.xmin,
                                    r.ymin
                                ]),
                                c([
                                    r.xmax,
                                    r.ymax
                                ])
                            ];
                        } : function(t1, r, n) {
                            (t1.lassoPoints = {})[e1.id] = n.filtered.map(c);
                        };
                        var s = e1.dragOptions;
                        e1.dragOptions = i.extendDeep(s || {}, {
                            dragmode: t1.dragmode,
                            element: e1.div,
                            gd: n,
                            plotinfo: {
                                id: e1.id,
                                domain: t1[e1.id].domain,
                                xaxis: e1.xaxis,
                                yaxis: e1.yaxis,
                                fillRangeItems: a
                            },
                            xaxes: [
                                e1.xaxis
                            ],
                            yaxes: [
                                e1.yaxis
                            ],
                            subplot: e1.id
                        }), r.off("click", e1.onClickInPanHandler), p(o) || h(o) ? (r.dragPan.disable(), r.on("zoomstart", e1.clearSelect), e1.dragOptions.prepFn = function(t1, r, n) {
                            d(t1, r, n, e1.dragOptions, o);
                        }, l.init(e1.dragOptions)) : (r.dragPan.enable(), r.off("zoomstart", e1.clearSelect), e1.div.onmousedown = null, e1.onClickInPanHandler = e1.onClickInPanFn(e1.dragOptions), r.on("click", e1.onClickInPanHandler));
                    }
                    function c(t1) {
                        var r = e1.map.unproject(t1);
                        return [
                            r.lng,
                            r.lat
                        ];
                    }
                }, _.updateFramework = function(t1) {
                    var e1 = t1[this.id].domain, r = t1._size, n = this.div.style;
                    n.width = r.w * (e1.x[1] - e1.x[0]) + "px", n.height = r.h * (e1.y[1] - e1.y[0]) + "px", n.left = r.l + e1.x[0] * r.w + "px", n.top = r.t + (1 - e1.y[1]) * r.h + "px", this.xaxis._offset = r.l + e1.x[0] * r.w, this.xaxis._length = r.w * (e1.x[1] - e1.x[0]), this.yaxis._offset = r.t + (1 - e1.y[1]) * r.h, this.yaxis._length = r.h * (e1.y[1] - e1.y[0]);
                }, _.updateLayers = function(t1) {
                    var e1, r = t1[this.id].layers, n = this.layerList;
                    if (r.length !== n.length) {
                        for(e1 = 0; e1 < n.length; e1++)n[e1].dispose();
                        for(n = this.layerList = [], e1 = 0; e1 < r.length; e1++)n.push(x(this, e1, r[e1]));
                    } else for(e1 = 0; e1 < r.length; e1++)n[e1].update(r[e1]);
                }, _.destroy = function() {
                    this.map && (this.map.remove(), this.map = null, this.container.removeChild(this.div));
                }, _.toImage = function() {
                    return this.map.stop(), this.map.getCanvas().toDataURL();
                }, _.setOptions = function(t1, e1, r) {
                    for(var n in r)this.map[e1](t1, n, r[n]);
                }, _.getMapLayers = function() {
                    return this.map.getStyle().layers;
                }, _.addLayer = function(t1, e1) {
                    var r = this.map;
                    if ("string" == typeof e1) {
                        if ("" === e1) return void r.addLayer(t1, e1);
                        for(var n = this.getMapLayers(), a = 0; a < n.length; a++)if (e1 === n[a].id) return void r.addLayer(t1, e1);
                        i.warn([
                            "Trying to add layer with *below* value",
                            e1,
                            "referencing a layer that does not exist",
                            "or that does not yet exist."
                        ].join(" "));
                    }
                    r.addLayer(t1);
                }, _.project = function(t1) {
                    return this.map.project(new n.LngLat(t1[0], t1[1]));
                }, _.getView = function() {
                    var t1 = this.map, e1 = t1.getCenter(), r = {
                        lon: e1.lng,
                        lat: e1.lat
                    }, n = t1.getCanvas(), i = parseInt(n.style.width), a = parseInt(n.style.height);
                    return {
                        center: r,
                        zoom: t1.getZoom(),
                        bearing: t1.getBearing(),
                        pitch: t1.getPitch(),
                        _derived: {
                            coordinates: [
                                t1.unproject([
                                    0,
                                    0
                                ]).toArray(),
                                t1.unproject([
                                    i,
                                    0
                                ]).toArray(),
                                t1.unproject([
                                    i,
                                    a
                                ]).toArray(),
                                t1.unproject([
                                    0,
                                    a
                                ]).toArray()
                            ]
                        }
                    };
                }, _.getViewEdits = function(t1) {
                    for(var e1 = this.id, r = [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch"
                    ], n = {}, i = 0; i < r.length; i++){
                        var a = r[i];
                        n[e1 + "." + a] = t1[a];
                    }
                    return n;
                }, _.getViewEditsWithDerived = function(t1) {
                    var e1 = this.id, r = this.getViewEdits(t1);
                    return r[e1 + "._derived"] = t1._derived, r;
                }, e1.exports = b;
            },
            {
                "../../components/dragelement": 385,
                "../../components/dragelement/helpers": 384,
                "../../components/fx": 406,
                "../../lib": 503,
                "../../lib/geo_location_utils": 496,
                "../../registry": 638,
                "../cartesian/axes": 554,
                "../cartesian/select": 575,
                "./constants": 611,
                "./layers": 614,
                "mapbox-gl/dist/mapbox-gl-unminified": 239
            }
        ],
        618: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    var e1 = t1.editType;
                    return {
                        t: {
                            valType: "number",
                            dflt: 0,
                            editType: e1
                        },
                        r: {
                            valType: "number",
                            dflt: 0,
                            editType: e1
                        },
                        b: {
                            valType: "number",
                            dflt: 0,
                            editType: e1
                        },
                        l: {
                            valType: "number",
                            dflt: 0,
                            editType: e1
                        },
                        editType: e1
                    };
                };
            },
            {}
        ],
        619: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("d3-time-format").timeFormatLocale, a = t1("d3-format").formatLocale, o = t1("fast-isnumeric"), s = t1("../registry"), l = t1("../plot_api/plot_schema"), c = t1("../plot_api/plot_template"), u = t1("../lib"), f = t1("../components/color"), h = t1("../constants/numerical").BADNUM, p = t1("./cartesian/axis_ids"), d = t1("./cartesian/handle_outline").clearSelect, m = t1("./animation_attributes"), g = t1("./frame_attributes"), v = t1("../plots/get_data").getModuleCalcData, y = u.relinkPrivateKeys, x = u._, b = e1.exports = {};
                u.extendFlat(b, s), b.attributes = t1("./attributes"), b.attributes.type.values = b.allTypes, b.fontAttrs = t1("./font_attributes"), b.layoutAttributes = t1("./layout_attributes"), b.fontWeight = "normal";
                var _ = b.transformsRegistry, w = t1("./command");
                b.executeAPICommand = w.executeAPICommand, b.computeAPICommandBindings = w.computeAPICommandBindings, b.manageCommandObserver = w.manageCommandObserver, b.hasSimpleAPICommandBindings = w.hasSimpleAPICommandBindings, b.redrawText = function(t1) {
                    return t1 = u.getGraphDiv(t1), new Promise(function(e1) {
                        setTimeout(function() {
                            t1._fullLayout && (s.getComponentMethod("annotations", "draw")(t1), s.getComponentMethod("legend", "draw")(t1), s.getComponentMethod("colorbar", "draw")(t1), e1(b.previousPromises(t1)));
                        }, 300);
                    });
                }, b.resize = function(t1) {
                    var e1;
                    t1 = u.getGraphDiv(t1);
                    var r = new Promise(function(r, n) {
                        t1 && !u.isHidden(t1) || n(new Error("Resize must be passed a displayed plot div element.")), t1._redrawTimer && clearTimeout(t1._redrawTimer), t1._resolveResize && (e1 = t1._resolveResize), t1._resolveResize = r, t1._redrawTimer = setTimeout(function() {
                            if (!t1.layout || t1.layout.width && t1.layout.height || u.isHidden(t1)) r(t1);
                            else {
                                delete t1.layout.width, delete t1.layout.height;
                                var e1 = t1.changed;
                                t1.autoplay = !0, s.call("relayout", t1, {
                                    autosize: !0
                                }).then(function() {
                                    t1.changed = e1, t1._resolveResize === r && (delete t1._resolveResize, r(t1));
                                });
                            }
                        }, 100);
                    });
                    return e1 && e1(r), r;
                }, b.previousPromises = function(t1) {
                    if ((t1._promises || []).length) return Promise.all(t1._promises).then(function() {
                        t1._promises = [];
                    });
                }, b.addLinks = function(t1) {
                    if (t1._context.showLink || t1._context.showSources) {
                        var e1 = t1._fullLayout, r = u.ensureSingle(e1._paper, "text", "js-plot-link-container", function(t1) {
                            t1.style({
                                "font-family": '"Open Sans", Arial, sans-serif',
                                "font-size": "12px",
                                fill: f.defaultLine,
                                "pointer-events": "all"
                            }).each(function() {
                                var t1 = n.select(this);
                                t1.append("tspan").classed("js-link-to-tool", !0), t1.append("tspan").classed("js-link-spacer", !0), t1.append("tspan").classed("js-sourcelinks", !0);
                            });
                        }), i = r.node(), a = {
                            y: e1._paper.attr("height") - 9
                        };
                        document.body.contains(i) && i.getComputedTextLength() >= e1.width - 20 ? (a["text-anchor"] = "start", a.x = 5) : (a["text-anchor"] = "end", a.x = e1._paper.attr("width") - 7), r.attr(a);
                        var o = r.select(".js-link-to-tool"), s = r.select(".js-link-spacer"), l = r.select(".js-sourcelinks");
                        t1._context.showSources && t1._context.showSources(t1), t1._context.showLink && function(t1, e1) {
                            e1.text("");
                            var r = e1.append("a").attr({
                                "xlink:xlink:href": "#",
                                class: "link--impt link--embedview",
                                "font-weight": "bold"
                            }).text(t1._context.linkText + " " + String.fromCharCode(187));
                            if (t1._context.sendData) r.on("click", function() {
                                b.sendDataToCloud(t1);
                            });
                            else {
                                var n = window.location.pathname.split("/"), i = window.location.search;
                                r.attr({
                                    "xlink:xlink:show": "new",
                                    "xlink:xlink:href": "/" + n[2].split(".")[0] + "/" + n[1] + i
                                });
                            }
                        }(t1, o), s.text(o.text() && l.text() ? " - " : "");
                    }
                }, b.sendDataToCloud = function(t1) {
                    var e1 = (window.PLOTLYENV || {}).BASE_URL || t1._context.plotlyServerURL;
                    if (e1) {
                        t1.emit("plotly_beforeexport");
                        var r = n.select(t1).append("div").attr("id", "hiddenform").style("display", "none"), i = r.append("form").attr({
                            action: e1 + "/external",
                            method: "post",
                            target: "_blank"
                        });
                        return i.append("input").attr({
                            type: "text",
                            name: "data"
                        }).node().value = b.graphJson(t1, !1, "keepdata"), i.node().submit(), r.remove(), t1.emit("plotly_afterexport"), !1;
                    }
                };
                var T = [
                    "days",
                    "shortDays",
                    "months",
                    "shortMonths",
                    "periods",
                    "dateTime",
                    "date",
                    "time",
                    "decimal",
                    "thousands",
                    "grouping",
                    "currency"
                ], k = [
                    "year",
                    "month",
                    "dayMonth",
                    "dayMonthYear"
                ];
                function A(t1, e1) {
                    var r = t1._context.locale;
                    r || (r = "en-US");
                    var n = !1, i = {};
                    function a(t1) {
                        for(var r = !0, a = 0; a < e1.length; a++){
                            var o = e1[a];
                            i[o] || (t1[o] ? i[o] = t1[o] : r = !1);
                        }
                        r && (n = !0);
                    }
                    for(var o = 0; o < 2; o++){
                        for(var l = t1._context.locales, c = 0; c < 2; c++){
                            var u = (l[r] || {}).format;
                            if (u && (a(u), n)) break;
                            l = s.localeRegistry;
                        }
                        var f = r.split("-")[0];
                        if (n || f === r) break;
                        r = f;
                    }
                    return n || a(s.localeRegistry.en.format), i;
                }
                function M(t1, e1) {
                    var r = {
                        _fullLayout: e1
                    }, n = "x" === t1._id.charAt(0), i = t1._mainAxis._anchorAxis, a = "", o = "", s = "";
                    if (i && (s = i._mainAxis._id, a = n ? t1._id + s : s + t1._id), !a || !e1._plots[a]) {
                        a = "";
                        for(var l = t1._counterAxes, c = 0; c < l.length; c++){
                            var u = l[c], f = n ? t1._id + u : u + t1._id;
                            o || (o = f);
                            var h = p.getFromId(r, u);
                            if (s && h.overlaying === s) {
                                a = f;
                                break;
                            }
                        }
                    }
                    return a || o;
                }
                function S(t1) {
                    var e1 = t1.transforms;
                    if (Array.isArray(e1) && e1.length) for(var r = 0; r < e1.length; r++){
                        var n = e1[r], i = n._module || _[n.type];
                        if (i && i.makesData) return !0;
                    }
                    return !1;
                }
                function E(t1, e1, r, n) {
                    for(var i = t1.transforms, a = [
                        t1
                    ], o = 0; o < i.length; o++){
                        var s = i[o], l = _[s.type];
                        l && l.transform && (a = l.transform(a, {
                            transform: s,
                            fullTrace: t1,
                            fullData: e1,
                            layout: r,
                            fullLayout: n,
                            transformIndex: o
                        }));
                    }
                    return a;
                }
                function L(t1) {
                    return "string" == typeof t1 && "px" === t1.substr(t1.length - 2) && parseFloat(t1);
                }
                function C(t1) {
                    var e1 = t1.margin;
                    if (!t1._size) {
                        var r = t1._size = {
                            l: Math.round(e1.l),
                            r: Math.round(e1.r),
                            t: Math.round(e1.t),
                            b: Math.round(e1.b),
                            p: Math.round(e1.pad)
                        };
                        r.w = Math.round(t1.width) - r.l - r.r, r.h = Math.round(t1.height) - r.t - r.b;
                    }
                    t1._pushmargin || (t1._pushmargin = {}), t1._pushmarginIds || (t1._pushmarginIds = {});
                }
                b.supplyDefaults = function(t1, e1) {
                    var r = e1 && e1.skipUpdateCalc, n = t1._fullLayout || {};
                    if (n._skipDefaults) delete n._skipDefaults;
                    else {
                        var o, l = t1._fullLayout = {}, c = t1.layout || {}, f = t1._fullData || [], h = t1._fullData = [], p = t1.data || [], m = t1.calcdata || [], g = t1._context || {};
                        t1._transitionData || b.createTransitionData(t1), l._dfltTitle = {
                            plot: x(t1, "Click to enter Plot title"),
                            x: x(t1, "Click to enter X axis title"),
                            y: x(t1, "Click to enter Y axis title"),
                            colorbar: x(t1, "Click to enter Colorscale title"),
                            annotation: x(t1, "new text")
                        }, l._traceWord = x(t1, "trace");
                        var v = A(t1, T);
                        if (l._mapboxAccessToken = g.mapboxAccessToken, n._initialAutoSizeIsDone) {
                            var _ = n.width, w = n.height;
                            b.supplyLayoutGlobalDefaults(c, l, v), c.width || (l.width = _), c.height || (l.height = w), b.sanitizeMargins(l);
                        } else {
                            b.supplyLayoutGlobalDefaults(c, l, v);
                            var M = !c.width || !c.height, S = l.autosize, E = g.autosizable;
                            M && (S || E) ? b.plotAutoSize(t1, c, l) : M && b.sanitizeMargins(l), !S && M && (c.width = l.width, c.height = l.height);
                        }
                        l._d3locale = function(t1, e1) {
                            return t1.decimal = e1.charAt(0), t1.thousands = e1.charAt(1), {
                                numberFormat: function(e1) {
                                    try {
                                        e1 = a(t1).format(u.adjustFormat(e1));
                                    } catch (t1) {
                                        return u.warnBadFormat(e1), u.noFormat;
                                    }
                                    return e1;
                                },
                                timeFormat: i(t1).utcFormat
                            };
                        }(v, l.separators), l._extraFormat = A(t1, k), l._initialAutoSizeIsDone = !0, l._dataLength = p.length, l._modules = [], l._visibleModules = [], l._basePlotModules = [];
                        var L = l._subplots = function() {
                            var t1, e1, r = s.collectableSubplotTypes, n = {};
                            if (!r) {
                                r = [];
                                var i = s.subplotsRegistry;
                                for(var a in i){
                                    var o = i[a].attr;
                                    if (o && (r.push(a), Array.isArray(o))) for(e1 = 0; e1 < o.length; e1++)u.pushUnique(r, o[e1]);
                                }
                            }
                            for(t1 = 0; t1 < r.length; t1++)n[r[t1]] = [];
                            return n;
                        }(), P = l._splomAxes = {
                            x: {},
                            y: {}
                        }, I = l._splomSubplots = {};
                        l._splomGridDflt = {}, l._scatterStackOpts = {}, l._firstScatter = {}, l._alignmentOpts = {}, l._colorAxes = {}, l._requestRangeslider = {}, l._traceUids = function(t1, e1) {
                            var r, n, i = e1.length, a = [];
                            for(r = 0; r < t1.length; r++){
                                var o = t1[r]._fullInput;
                                o !== n && a.push(o), n = o;
                            }
                            var s = a.length, l = new Array(i), c = {};
                            function f(t1, e1) {
                                l[e1] = t1, c[t1] = 1;
                            }
                            function h(t1, e1) {
                                if (t1 && "string" == typeof t1 && !c[t1]) return f(t1, e1), !0;
                            }
                            for(r = 0; r < i; r++){
                                var p = e1[r].uid;
                                "number" == typeof p && (p = String(p)), h(p, r) || r < s && h(a[r].uid, r) || f(u.randstr(c), r);
                            }
                            return l;
                        }(f, p), l._globalTransforms = (t1._context || {}).globalTransforms, b.supplyDataDefaults(p, h, c, l);
                        var O = Object.keys(P.x), z = Object.keys(P.y);
                        if (O.length > 1 && z.length > 1) {
                            for(s.getComponentMethod("grid", "sizeDefaults")(c, l), o = 0; o < O.length; o++)u.pushUnique(L.xaxis, O[o]);
                            for(o = 0; o < z.length; o++)u.pushUnique(L.yaxis, z[o]);
                            for(var D in I)u.pushUnique(L.cartesian, D);
                        }
                        if (l._has = b._hasPlotType.bind(l), f.length === h.length) for(o = 0; o < h.length; o++)y(h[o], f[o]);
                        b.supplyLayoutModuleDefaults(c, l, h, t1._transitionData);
                        var R = l._visibleModules, F = [];
                        for(o = 0; o < R.length; o++){
                            var B = R[o].crossTraceDefaults;
                            B && u.pushUnique(F, B);
                        }
                        for(o = 0; o < F.length; o++)F[o](h, l);
                        l._hasOnlyLargeSploms = 1 === l._basePlotModules.length && "splom" === l._basePlotModules[0].name && O.length > 15 && z.length > 15 && 0 === l.shapes.length && 0 === l.images.length, b.linkSubplots(h, l, f, n), b.cleanPlot(h, l, f, n);
                        var N = !(!n._has || !n._has("gl2d")), j = !(!l._has || !l._has("gl2d")), U = !(!n._has || !n._has("cartesian")) || N, V = !(!l._has || !l._has("cartesian")) || j;
                        U && !V ? n._bgLayer.remove() : V && !U && (l._shouldCreateBgLayer = !0), n._zoomlayer && !t1._dragging && d({
                            _fullLayout: n
                        }), function(t1, e1) {
                            var r, n = [];
                            e1.meta && (r = e1._meta = {
                                meta: e1.meta,
                                layout: {
                                    meta: e1.meta
                                }
                            });
                            for(var i = 0; i < t1.length; i++){
                                var a = t1[i];
                                a.meta ? n[a.index] = a._meta = {
                                    meta: a.meta
                                } : e1.meta && (a._meta = {
                                    meta: e1.meta
                                }), e1.meta && (a._meta.layout = {
                                    meta: e1.meta
                                });
                            }
                            n.length && (r || (r = e1._meta = {}), r.data = n);
                        }(h, l), y(l, n), s.getComponentMethod("colorscale", "crossTraceDefaults")(h, l), l._preGUI || (l._preGUI = {}), l._tracePreGUI || (l._tracePreGUI = {});
                        var H, q = l._tracePreGUI, G = {};
                        for(H in q)G[H] = "old";
                        for(o = 0; o < h.length; o++)G[H = h[o]._fullInput.uid] || (q[H] = {}), G[H] = "new";
                        for(H in G)"old" === G[H] && delete q[H];
                        C(l), s.getComponentMethod("rangeslider", "makeData")(l), r || m.length !== h.length || b.supplyDefaultsUpdateCalc(m, h);
                    }
                }, b.supplyDefaultsUpdateCalc = function(t1, e1) {
                    for(var r = 0; r < e1.length; r++){
                        var n = e1[r], i = (t1[r] || [])[0];
                        if (i && i.trace) {
                            var a = i.trace;
                            if (a._hasCalcTransform) {
                                var o, s, l, c = a._arrayAttrs;
                                for(o = 0; o < c.length; o++)s = c[o], l = u.nestedProperty(a, s).get().slice(), u.nestedProperty(n, s).set(l);
                            }
                            i.trace = n;
                        }
                    }
                }, b.createTransitionData = function(t1) {
                    t1._transitionData || (t1._transitionData = {}), t1._transitionData._frames || (t1._transitionData._frames = []), t1._transitionData._frameHash || (t1._transitionData._frameHash = {}), t1._transitionData._counter || (t1._transitionData._counter = 0), t1._transitionData._interruptCallbacks || (t1._transitionData._interruptCallbacks = []);
                }, b._hasPlotType = function(t1) {
                    var e1, r = this._basePlotModules || [];
                    for(e1 = 0; e1 < r.length; e1++)if (r[e1].name === t1) return !0;
                    var n = this._modules || [];
                    for(e1 = 0; e1 < n.length; e1++){
                        var i = n[e1].name;
                        if (i === t1) return !0;
                        var a = s.modules[i];
                        if (a && a.categories[t1]) return !0;
                    }
                    return !1;
                }, b.cleanPlot = function(t1, e1, r, n) {
                    var i, a, o = n._basePlotModules || [];
                    for(i = 0; i < o.length; i++){
                        var s = o[i];
                        s.clean && s.clean(t1, e1, r, n);
                    }
                    var l = n._has && n._has("gl"), c = e1._has && e1._has("gl");
                    l && !c && void 0 !== n._glcontainer && (n._glcontainer.selectAll(".gl-canvas").remove(), n._glcontainer.selectAll(".no-webgl").remove(), n._glcanvas = null);
                    var u = !!n._infolayer;
                    t: for(i = 0; i < r.length; i++){
                        var f = r[i].uid;
                        for(a = 0; a < t1.length; a++){
                            if (f === t1[a].uid) continue t;
                        }
                        u && n._infolayer.select(".cb" + f).remove();
                    }
                }, b.linkSubplots = function(t1, e1, r, n) {
                    var i, a, o = n._plots || {}, l = e1._plots = {}, c = e1._subplots, f = {
                        _fullData: t1,
                        _fullLayout: e1
                    }, h = c.cartesian.concat(c.gl2d || []);
                    for(i = 0; i < h.length; i++){
                        var d, m = h[i], g = o[m], v = p.getFromId(f, m, "x"), y = p.getFromId(f, m, "y");
                        for(g ? d = l[m] = g : (d = l[m] = {}).id = m, v._counterAxes.push(y._id), y._counterAxes.push(v._id), v._subplotsWith.push(m), y._subplotsWith.push(m), d.xaxis = v, d.yaxis = y, d._hasClipOnAxisFalse = !1, a = 0; a < t1.length; a++){
                            var x = t1[a];
                            if (x.xaxis === d.xaxis._id && x.yaxis === d.yaxis._id && !1 === x.cliponaxis) {
                                d._hasClipOnAxisFalse = !0;
                                break;
                            }
                        }
                    }
                    var b, _ = p.list(f, null, !0);
                    for(i = 0; i < _.length; i++){
                        var w = null;
                        (b = _[i]).overlaying && (w = p.getFromId(f, b.overlaying)) && w.overlaying && (b.overlaying = !1, w = null), b._mainAxis = w || b, w && (b.domain = w.domain.slice()), b._anchorAxis = "free" === b.anchor ? null : p.getFromId(f, b.anchor);
                    }
                    for(i = 0; i < _.length; i++)if ((b = _[i])._counterAxes.sort(p.idSort), b._subplotsWith.sort(u.subplotSort), b._mainSubplot = M(b, e1), b._counterAxes.length && (b.spikemode && -1 !== b.spikemode.indexOf("across") || b.automargin && b.mirror && "free" !== b.anchor || s.getComponentMethod("rangeslider", "isVisible")(b))) {
                        var T = 1, k = 0;
                        for(a = 0; a < b._counterAxes.length; a++){
                            var A = p.getFromId(f, b._counterAxes[a]);
                            T = Math.min(T, A.domain[0]), k = Math.max(k, A.domain[1]);
                        }
                        T < k && (b._counterDomainMin = T, b._counterDomainMax = k);
                    }
                }, b.clearExpandedTraceDefaultColors = function(t1) {
                    var e1, r, n;
                    for(r = [], (e1 = t1._module._colorAttrs) || (t1._module._colorAttrs = e1 = [], l.crawl(t1._module.attributes, function(t1, n, i, a) {
                        r[a] = n, r.length = a + 1, "color" === t1.valType && void 0 === t1.dflt && e1.push(r.join("."));
                    })), n = 0; n < e1.length; n++)u.nestedProperty(t1, "_input." + e1[n]).get() || u.nestedProperty(t1, e1[n]).set(null);
                }, b.supplyDataDefaults = function(t1, e1, r, n) {
                    var i, a, o, l = n._modules, f = n._visibleModules, h = n._basePlotModules, p = 0, d = 0;
                    function m(t1) {
                        e1.push(t1);
                        var r = t1._module;
                        r && (u.pushUnique(l, r), !0 === t1.visible && u.pushUnique(f, r), u.pushUnique(h, t1._module.basePlotModule), p++, !1 !== t1._input.visible && d++);
                    }
                    n._transformModules = [];
                    var g = {}, v = [], x = (r.template || {}).data || {}, _ = c.traceTemplater(x);
                    for(i = 0; i < t1.length; i++){
                        if (o = t1[i], (a = _.newTrace(o)).uid = n._traceUids[i], b.supplyTraceDefaults(o, a, d, n, i), a.index = i, a._input = o, a._expandedIndex = p, a.transforms && a.transforms.length) for(var w = !1 !== o.visible && !1 === a.visible, T = E(a, e1, r, n), k = 0; k < T.length; k++){
                            var A = T[k], M = {
                                _template: a._template,
                                type: a.type,
                                uid: a.uid + k
                            };
                            w && !1 === A.visible && delete A.visible, b.supplyTraceDefaults(A, M, p, n, i), y(M, A), M.index = i, M._input = o, M._fullInput = a, M._expandedIndex = p, M._expandedInput = A, m(M);
                        }
                        else a._fullInput = a, a._expandedInput = a, m(a);
                        s.traceIs(a, "carpetAxis") && (g[a.carpet] = a), s.traceIs(a, "carpetDependent") && v.push(i);
                    }
                    for(i = 0; i < v.length; i++)if ((a = e1[v[i]]).visible) {
                        var S = g[a.carpet];
                        a._carpet = S, S && S.visible ? (a.xaxis = S.xaxis, a.yaxis = S.yaxis) : a.visible = !1;
                    }
                }, b.supplyAnimationDefaults = function(t1) {
                    var e1;
                    t1 = t1 || {};
                    var r = {};
                    function n(e1, n) {
                        return u.coerce(t1 || {}, r, m, e1, n);
                    }
                    if (n("mode"), n("direction"), n("fromcurrent"), Array.isArray(t1.frame)) for(r.frame = [], e1 = 0; e1 < t1.frame.length; e1++)r.frame[e1] = b.supplyAnimationFrameDefaults(t1.frame[e1] || {});
                    else r.frame = b.supplyAnimationFrameDefaults(t1.frame || {});
                    if (Array.isArray(t1.transition)) for(r.transition = [], e1 = 0; e1 < t1.transition.length; e1++)r.transition[e1] = b.supplyAnimationTransitionDefaults(t1.transition[e1] || {});
                    else r.transition = b.supplyAnimationTransitionDefaults(t1.transition || {});
                    return r;
                }, b.supplyAnimationFrameDefaults = function(t1) {
                    var e1 = {};
                    function r(r, n) {
                        return u.coerce(t1 || {}, e1, m.frame, r, n);
                    }
                    return r("duration"), r("redraw"), e1;
                }, b.supplyAnimationTransitionDefaults = function(t1) {
                    var e1 = {};
                    function r(r, n) {
                        return u.coerce(t1 || {}, e1, m.transition, r, n);
                    }
                    return r("duration"), r("easing"), e1;
                }, b.supplyFrameDefaults = function(t1) {
                    var e1 = {};
                    function r(r, n) {
                        return u.coerce(t1, e1, g, r, n);
                    }
                    return r("group"), r("name"), r("traces"), r("baseframe"), r("data"), r("layout"), e1;
                }, b.supplyTraceDefaults = function(t1, e1, r, n, i) {
                    var a, o = n.colorway || f.defaults, l = o[r % o.length];
                    function c(r, n) {
                        return u.coerce(t1, e1, b.attributes, r, n);
                    }
                    var h = c("visible");
                    c("type"), c("name", n._traceWord + " " + i), c("uirevision", n.uirevision);
                    var p = b.getModule(e1);
                    if (e1._module = p, p) {
                        var d = p.basePlotModule, m = d.attr, g = d.attributes;
                        if (m && g) {
                            var v = n._subplots, y = "";
                            if (h || "gl2d" !== d.name) {
                                if (Array.isArray(m)) for(a = 0; a < m.length; a++){
                                    var x = m[a], _ = u.coerce(t1, e1, g, x);
                                    v[x] && u.pushUnique(v[x], _), y += _;
                                }
                                else y = u.coerce(t1, e1, g, m);
                                v[d.name] && u.pushUnique(v[d.name], y);
                            }
                        }
                    }
                    return h && (c("customdata"), c("ids"), c("meta"), s.traceIs(e1, "showLegend") ? (u.coerce(t1, e1, p.attributes.showlegend ? p.attributes : b.attributes, "showlegend"), c("legendgroup"), c("legendgrouptitle.text"), c("legendrank"), e1._dfltShowLegend = !0) : e1._dfltShowLegend = !1, p && p.supplyDefaults(t1, e1, l, n), s.traceIs(e1, "noOpacity") || c("opacity"), s.traceIs(e1, "notLegendIsolatable") && (e1.visible = !!e1.visible), s.traceIs(e1, "noHover") || (e1.hovertemplate || u.coerceHoverinfo(t1, e1, n), "parcats" !== e1.type && s.getComponentMethod("fx", "supplyDefaults")(t1, e1, l, n)), p && p.selectPoints && c("selectedpoints"), b.supplyTransformDefaults(t1, e1, n)), e1;
                }, b.hasMakesDataTransform = S, b.supplyTransformDefaults = function(t1, e1, r) {
                    if (e1._length || S(t1)) {
                        var n = r._globalTransforms || [], i = r._transformModules || [];
                        if (Array.isArray(t1.transforms) || 0 !== n.length) for(var a = t1.transforms || [], o = n.concat(a), s = e1.transforms = [], l = 0; l < o.length; l++){
                            var c, f = o[l], h = f.type, p = _[h], d = !(f._module && f._module === p), m = p && "function" == typeof p.transform;
                            p || u.warn("Unrecognized transform type " + h + "."), p && p.supplyDefaults && (d || m) ? ((c = p.supplyDefaults(f, e1, r, t1)).type = h, c._module = p, u.pushUnique(i, p)) : c = u.extendFlat({}, f), s.push(c);
                        }
                    }
                }, b.supplyLayoutGlobalDefaults = function(t1, e1, r) {
                    function n(r, n) {
                        return u.coerce(t1, e1, b.layoutAttributes, r, n);
                    }
                    var i = t1.template;
                    u.isPlainObject(i) && (e1.template = i, e1._template = i.layout, e1._dataTemplate = i.data), n("autotypenumbers");
                    var a = u.coerceFont(n, "font"), o = a.size;
                    u.coerceFont(n, "title.font", u.extendFlat({}, a, {
                        size: Math.round(1.4 * o)
                    })), n("title.text", e1._dfltTitle.plot), n("title.xref"), n("title.yref"), n("title.x"), n("title.y"), n("title.xanchor"), n("title.yanchor"), n("title.pad.t"), n("title.pad.r"), n("title.pad.b"), n("title.pad.l"), n("uniformtext.mode") && n("uniformtext.minsize"), n("autosize", !(t1.width && t1.height)), n("width"), n("height"), n("margin.l"), n("margin.r"), n("margin.t"), n("margin.b"), n("margin.pad"), n("margin.autoexpand"), t1.width && t1.height && b.sanitizeMargins(e1), s.getComponentMethod("grid", "sizeDefaults")(t1, e1), n("paper_bgcolor"), n("separators", r.decimal + r.thousands), n("hidesources"), n("colorway"), n("datarevision");
                    var l = n("uirevision");
                    n("editrevision", l), n("selectionrevision", l), s.getComponentMethod("modebar", "supplyLayoutDefaults")(t1, e1), s.getComponentMethod("shapes", "supplyDrawNewShapeDefaults")(t1, e1, n), n("meta"), u.isPlainObject(t1.transition) && (n("transition.duration"), n("transition.easing"), n("transition.ordering")), s.getComponentMethod("calendars", "handleDefaults")(t1, e1, "calendar"), s.getComponentMethod("fx", "supplyLayoutGlobalDefaults")(t1, e1, n);
                }, b.plotAutoSize = function(t1, e1, r) {
                    var n, i, a = t1._context || {}, s = a.frameMargins, l = u.isPlotDiv(t1);
                    if (l && t1.emit("plotly_autosize"), a.fillFrame) n = window.innerWidth, i = window.innerHeight, document.body.style.overflow = "hidden";
                    else {
                        var c = l ? window.getComputedStyle(t1) : {};
                        if (n = L(c.width) || L(c.maxWidth) || r.width, i = L(c.height) || L(c.maxHeight) || r.height, o(s) && s > 0) {
                            var f = 1 - 2 * s;
                            n = Math.round(f * n), i = Math.round(f * i);
                        }
                    }
                    var h = b.layoutAttributes.width.min, p = b.layoutAttributes.height.min;
                    n < h && (n = h), i < p && (i = p);
                    var d = !e1.width && Math.abs(r.width - n) > 1, m = !e1.height && Math.abs(r.height - i) > 1;
                    (m || d) && (d && (r.width = n), m && (r.height = i)), t1._initialAutoSize || (t1._initialAutoSize = {
                        width: n,
                        height: i
                    }), b.sanitizeMargins(r);
                }, b.supplyLayoutModuleDefaults = function(t1, e1, r, n) {
                    var i, a, o, l = s.componentsRegistry, c = e1._basePlotModules, f = s.subplotsRegistry.cartesian;
                    for(i in l)(o = l[i]).includeBasePlot && o.includeBasePlot(t1, e1);
                    for(var h in c.length || c.push(f), e1._has("cartesian") && (s.getComponentMethod("grid", "contentDefaults")(t1, e1), f.finalizeSubplots(t1, e1)), e1._subplots)e1._subplots[h].sort(u.subplotSort);
                    for(a = 0; a < c.length; a++)(o = c[a]).supplyLayoutDefaults && o.supplyLayoutDefaults(t1, e1, r);
                    var p = e1._modules;
                    for(a = 0; a < p.length; a++)(o = p[a]).supplyLayoutDefaults && o.supplyLayoutDefaults(t1, e1, r);
                    var d = e1._transformModules;
                    for(a = 0; a < d.length; a++)(o = d[a]).supplyLayoutDefaults && o.supplyLayoutDefaults(t1, e1, r, n);
                    for(i in l)(o = l[i]).supplyLayoutDefaults && o.supplyLayoutDefaults(t1, e1, r);
                }, b.purge = function(t1) {
                    var e1 = t1._fullLayout || {};
                    void 0 !== e1._glcontainer && (e1._glcontainer.selectAll(".gl-canvas").remove(), e1._glcontainer.remove(), e1._glcanvas = null), e1._modeBar && e1._modeBar.destroy(), t1._transitionData && (t1._transitionData._interruptCallbacks && (t1._transitionData._interruptCallbacks.length = 0), t1._transitionData._animationRaf && window.cancelAnimationFrame(t1._transitionData._animationRaf)), u.clearThrottle(), u.clearResponsive(t1), delete t1.data, delete t1.layout, delete t1._fullData, delete t1._fullLayout, delete t1.calcdata, delete t1.empty, delete t1.fid, delete t1.undoqueue, delete t1.undonum, delete t1.autoplay, delete t1.changed, delete t1._promises, delete t1._redrawTimer, delete t1._hmlumcount, delete t1._hmpixcount, delete t1._transitionData, delete t1._transitioning, delete t1._initialAutoSize, delete t1._transitioningWithDuration, delete t1._dragging, delete t1._dragged, delete t1._dragdata, delete t1._hoverdata, delete t1._snapshotInProgress, delete t1._editing, delete t1._mouseDownTime, delete t1._legendMouseDownTime, t1.removeAllListeners && t1.removeAllListeners();
                }, b.style = function(t1) {
                    var e1, r = t1._fullLayout._visibleModules, n = [];
                    for(e1 = 0; e1 < r.length; e1++){
                        var i = r[e1];
                        i.style && u.pushUnique(n, i.style);
                    }
                    for(e1 = 0; e1 < n.length; e1++)n[e1](t1);
                }, b.sanitizeMargins = function(t1) {
                    if (t1 && t1.margin) {
                        var e1, r = t1.width, n = t1.height, i = t1.margin, a = r - (i.l + i.r), o = n - (i.t + i.b);
                        a < 0 && (e1 = (r - 1) / (i.l + i.r), i.l = Math.floor(e1 * i.l), i.r = Math.floor(e1 * i.r)), o < 0 && (e1 = (n - 1) / (i.t + i.b), i.t = Math.floor(e1 * i.t), i.b = Math.floor(e1 * i.b));
                    }
                }, b.clearAutoMarginIds = function(t1) {
                    t1._fullLayout._pushmarginIds = {};
                }, b.allowAutoMargin = function(t1, e1) {
                    t1._fullLayout._pushmarginIds[e1] = 1;
                };
                b.autoMargin = function(t1, e1, r) {
                    var n = t1._fullLayout, i = n.width, a = n.height, o = n.margin, s = u.constrain(i - o.l - o.r, 2, 64), l = u.constrain(a - o.t - o.b, 2, 64), c = Math.max(0, i - s), f = Math.max(0, a - l), h = n._pushmargin, p = n._pushmarginIds;
                    if (!1 !== o.autoexpand) {
                        if (r) {
                            var d = r.pad;
                            if (void 0 === d && (d = Math.min(12, o.l, o.r, o.t, o.b)), c) {
                                var m = (r.l + r.r) / c;
                                m > 1 && (r.l /= m, r.r /= m);
                            }
                            if (f) {
                                var g = (r.t + r.b) / f;
                                g > 1 && (r.t /= g, r.b /= g);
                            }
                            var v = void 0 !== r.xl ? r.xl : r.x, y = void 0 !== r.xr ? r.xr : r.x, x = void 0 !== r.yt ? r.yt : r.y, _ = void 0 !== r.yb ? r.yb : r.y;
                            h[e1] = {
                                l: {
                                    val: v,
                                    size: r.l + d
                                },
                                r: {
                                    val: y,
                                    size: r.r + d
                                },
                                b: {
                                    val: _,
                                    size: r.b + d
                                },
                                t: {
                                    val: x,
                                    size: r.t + d
                                }
                            }, p[e1] = 1;
                        } else delete h[e1], delete p[e1];
                        if (!n._replotting) return b.doAutoMargin(t1);
                    }
                }, b.doAutoMargin = function(t1) {
                    var e1 = t1._fullLayout, r = e1.width, n = e1.height;
                    e1._size || (e1._size = {}), C(e1);
                    var i = e1._size, a = e1.margin, l = u.extendFlat({}, i), c = a.l, f = a.r, h = a.t, d = a.b, m = e1._pushmargin, g = e1._pushmarginIds;
                    if (!1 !== e1.margin.autoexpand) {
                        for(var v in m)g[v] || delete m[v];
                        for(var y in m.base = {
                            l: {
                                val: 0,
                                size: c
                            },
                            r: {
                                val: 1,
                                size: f
                            },
                            t: {
                                val: 1,
                                size: h
                            },
                            b: {
                                val: 0,
                                size: d
                            }
                        }, m){
                            var x = m[y].l || {}, _ = m[y].b || {}, w = x.val, T = x.size, k = _.val, A = _.size;
                            for(var M in m){
                                if (o(T) && m[M].r) {
                                    var S = m[M].r.val, E = m[M].r.size;
                                    if (S > w) {
                                        var L = (T * S + (E - r) * w) / (S - w), P = (E * (1 - w) + (T - r) * (1 - S)) / (S - w);
                                        L + P > c + f && (c = L, f = P);
                                    }
                                }
                                if (o(A) && m[M].t) {
                                    var I = m[M].t.val, O = m[M].t.size;
                                    if (I > k) {
                                        var z = (A * I + (O - n) * k) / (I - k), D = (O * (1 - k) + (A - n) * (1 - I)) / (I - k);
                                        z + D > d + h && (d = z, h = D);
                                    }
                                }
                            }
                        }
                    }
                    var R = u.constrain(r - a.l - a.r, 2, 64), F = u.constrain(n - a.t - a.b, 2, 64), B = Math.max(0, r - R), N = Math.max(0, n - F);
                    if (B) {
                        var j = (c + f) / B;
                        j > 1 && (c /= j, f /= j);
                    }
                    if (N) {
                        var U = (d + h) / N;
                        U > 1 && (d /= U, h /= U);
                    }
                    if (i.l = Math.round(c), i.r = Math.round(f), i.t = Math.round(h), i.b = Math.round(d), i.p = Math.round(a.pad), i.w = Math.round(r) - i.l - i.r, i.h = Math.round(n) - i.t - i.b, !e1._replotting && b.didMarginChange(l, i)) {
                        "_redrawFromAutoMarginCount" in e1 ? e1._redrawFromAutoMarginCount++ : e1._redrawFromAutoMarginCount = 1;
                        var V = 3 * (1 + Object.keys(g).length);
                        if (e1._redrawFromAutoMarginCount < V) return s.call("_doPlot", t1);
                        e1._size = l, u.warn("Too many auto-margin redraws.");
                    }
                    !function(t1) {
                        var e1 = p.list(t1, "", !0);
                        [
                            "_adjustTickLabelsOverflow",
                            "_hideCounterAxisInsideTickLabels"
                        ].forEach(function(t1) {
                            for(var r = 0; r < e1.length; r++){
                                var n = e1[r][t1];
                                n && n();
                            }
                        });
                    }(t1);
                };
                var P = [
                    "l",
                    "r",
                    "t",
                    "b",
                    "p",
                    "w",
                    "h"
                ];
                function I(t1, e1, r) {
                    var n = !1;
                    var i = [
                        b.previousPromises,
                        function() {
                            if (t1._transitionData) return t1._transitioning = !1, function(t1) {
                                var e1 = Promise.resolve();
                                if (!t1) return e1;
                                for(; t1.length;)e1 = e1.then(t1.shift());
                                return e1;
                            }(t1._transitionData._interruptCallbacks);
                        },
                        r.prepareFn,
                        b.rehover,
                        function() {
                            return t1.emit("plotly_transitioning", []), new Promise(function(i) {
                                t1._transitioning = !0, e1.duration > 0 && (t1._transitioningWithDuration = !0), t1._transitionData._interruptCallbacks.push(function() {
                                    n = !0;
                                }), r.redraw && t1._transitionData._interruptCallbacks.push(function() {
                                    return s.call("redraw", t1);
                                }), t1._transitionData._interruptCallbacks.push(function() {
                                    t1.emit("plotly_transitioninterrupted", []);
                                });
                                var a = 0, o = 0;
                                function l() {
                                    return a++, function() {
                                        o++, n || o !== a || function(e1) {
                                            if (!t1._transitionData) return;
                                            (function(t1) {
                                                if (t1) for(; t1.length;)t1.shift();
                                            })(t1._transitionData._interruptCallbacks), Promise.resolve().then(function() {
                                                if (r.redraw) return s.call("redraw", t1);
                                            }).then(function() {
                                                t1._transitioning = !1, t1._transitioningWithDuration = !1, t1.emit("plotly_transitioned", []);
                                            }).then(e1);
                                        }(i);
                                    };
                                }
                                r.runFn(l), setTimeout(l());
                            });
                        }
                    ], a = u.syncOrAsync(i, t1);
                    return a && a.then || (a = Promise.resolve()), a.then(function() {
                        return t1;
                    });
                }
                b.didMarginChange = function(t1, e1) {
                    for(var r = 0; r < P.length; r++){
                        var n = P[r], i = t1[n], a = e1[n];
                        if (!o(i) || Math.abs(a - i) > 1) return !0;
                    }
                    return !1;
                }, b.graphJson = function(t1, e1, r, n, i, a) {
                    (i && e1 && !t1._fullData || i && !e1 && !t1._fullLayout) && b.supplyDefaults(t1);
                    var o = i ? t1._fullData : t1.data, s = i ? t1._fullLayout : t1.layout, l = (t1._transitionData || {})._frames;
                    function c(t1, e1) {
                        if ("function" == typeof t1) return e1 ? "_function_" : null;
                        if (u.isPlainObject(t1)) {
                            var n, i = {};
                            return Object.keys(t1).sort().forEach(function(a) {
                                if (-1 === [
                                    "_",
                                    "["
                                ].indexOf(a.charAt(0))) {
                                    if ("function" != typeof t1[a]) {
                                        if ("keepdata" === r) {
                                            if ("src" === a.substr(a.length - 3)) return;
                                        } else if ("keepstream" === r) {
                                            if ("string" == typeof (n = t1[a + "src"]) && n.indexOf(":") > 0 && !u.isPlainObject(t1.stream)) return;
                                        } else if ("keepall" !== r && "string" == typeof (n = t1[a + "src"]) && n.indexOf(":") > 0) return;
                                        i[a] = c(t1[a], e1);
                                    } else e1 && (i[a] = "_function");
                                }
                            }), i;
                        }
                        return Array.isArray(t1) ? t1.map(function(t1) {
                            return c(t1, e1);
                        }) : u.isTypedArray(t1) ? u.simpleMap(t1, u.identity) : u.isJSDate(t1) ? u.ms2DateTimeLocal(+t1) : t1;
                    }
                    var f = {
                        data: (o || []).map(function(t1) {
                            var r = c(t1);
                            return e1 && delete r.fit, r;
                        })
                    };
                    if (!e1 && (f.layout = c(s), i)) {
                        var h = s._size;
                        f.layout.computed = {
                            margin: {
                                b: h.b,
                                l: h.l,
                                r: h.r,
                                t: h.t
                            }
                        };
                    }
                    return l && (f.frames = c(l)), a && (f.config = c(t1._context, !0)), "object" === n ? f : JSON.stringify(f);
                }, b.modifyFrames = function(t1, e1) {
                    var r, n, i, a = t1._transitionData._frames, o = t1._transitionData._frameHash;
                    for(r = 0; r < e1.length; r++)switch((n = e1[r]).type){
                        case "replace":
                            i = n.value;
                            var s = (a[n.index] || {}).name, l = i.name;
                            a[n.index] = o[l] = i, l !== s && (delete o[s], o[l] = i);
                            break;
                        case "insert":
                            o[(i = n.value).name] = i, a.splice(n.index, 0, i);
                            break;
                        case "delete":
                            delete o[(i = a[n.index]).name], a.splice(n.index, 1);
                    }
                    return Promise.resolve();
                }, b.computeFrame = function(t1, e1) {
                    var r, n, i, a, o = t1._transitionData._frameHash;
                    if (!e1) throw new Error("computeFrame must be given a string frame name");
                    var s = o[e1.toString()];
                    if (!s) return !1;
                    for(var l = [
                        s
                    ], c = [
                        s.name
                    ]; s.baseframe && (s = o[s.baseframe.toString()]) && -1 === c.indexOf(s.name);)l.push(s), c.push(s.name);
                    for(var u = {}; s = l.pop();)if (s.layout && (u.layout = b.extendLayout(u.layout, s.layout)), s.data) {
                        if (u.data || (u.data = []), !(n = s.traces)) for(n = [], r = 0; r < s.data.length; r++)n[r] = r;
                        for(u.traces || (u.traces = []), r = 0; r < s.data.length; r++)null != (i = n[r]) && (-1 === (a = u.traces.indexOf(i)) && (a = u.data.length, u.traces[a] = i), u.data[a] = b.extendTrace(u.data[a], s.data[r]));
                    }
                    return u;
                }, b.recomputeFrameHash = function(t1) {
                    for(var e1 = t1._transitionData._frameHash = {}, r = t1._transitionData._frames, n = 0; n < r.length; n++){
                        var i = r[n];
                        i && i.name && (e1[i.name] = i);
                    }
                }, b.extendObjectWithContainers = function(t1, e1, r) {
                    var n, i, a, o, s, l, c, f = u.extendDeepNoArrays({}, e1 || {}), h = u.expandObjectPaths(f), p = {};
                    if (r && r.length) for(a = 0; a < r.length; a++)void 0 === (i = (n = u.nestedProperty(h, r[a])).get()) ? u.nestedProperty(p, r[a]).set(null) : (n.set(null), u.nestedProperty(p, r[a]).set(i));
                    if (t1 = u.extendDeepNoArrays(t1 || {}, h), r && r.length) {
                        for(a = 0; a < r.length; a++)if (l = u.nestedProperty(p, r[a]).get()) {
                            for(c = (s = u.nestedProperty(t1, r[a])).get(), Array.isArray(c) || (c = [], s.set(c)), o = 0; o < l.length; o++){
                                var d = l[o];
                                c[o] = null === d ? null : b.extendObjectWithContainers(c[o], d);
                            }
                            s.set(c);
                        }
                    }
                    return t1;
                }, b.dataArrayContainers = [
                    "transforms",
                    "dimensions"
                ], b.layoutArrayContainers = s.layoutArrayContainers, b.extendTrace = function(t1, e1) {
                    return b.extendObjectWithContainers(t1, e1, b.dataArrayContainers);
                }, b.extendLayout = function(t1, e1) {
                    return b.extendObjectWithContainers(t1, e1, b.layoutArrayContainers);
                }, b.transition = function(t1, e1, r, n, i, a) {
                    var o = {
                        redraw: i.redraw
                    }, s = {}, l = [];
                    return o.prepareFn = function() {
                        for(var i = Array.isArray(e1) ? e1.length : 0, a = n.slice(0, i), o = 0; o < a.length; o++){
                            var c = a[o], f = t1._fullData[c]._module;
                            if (f) {
                                if (f.animatable) {
                                    var h = f.basePlotModule.name;
                                    s[h] || (s[h] = []), s[h].push(c);
                                }
                                t1.data[a[o]] = b.extendTrace(t1.data[a[o]], e1[o]);
                            }
                        }
                        var p = u.expandObjectPaths(u.extendDeepNoArrays({}, r)), d = /^[xy]axis[0-9]*$/;
                        for(var m in p)d.test(m) && delete p[m].range;
                        b.extendLayout(t1.layout, p), delete t1.calcdata, b.supplyDefaults(t1), b.doCalcdata(t1);
                        var g = u.expandObjectPaths(r);
                        if (g) {
                            var v = t1._fullLayout._plots;
                            for(var y in v){
                                var x = v[y], _ = x.xaxis, w = x.yaxis, T = _.range.slice(), k = w.range.slice(), A = null, M = null, S = null, E = null;
                                Array.isArray(g[_._name + ".range"]) ? A = g[_._name + ".range"].slice() : Array.isArray((g[_._name] || {}).range) && (A = g[_._name].range.slice()), Array.isArray(g[w._name + ".range"]) ? M = g[w._name + ".range"].slice() : Array.isArray((g[w._name] || {}).range) && (M = g[w._name].range.slice()), T && A && (_.r2l(T[0]) !== _.r2l(A[0]) || _.r2l(T[1]) !== _.r2l(A[1])) && (S = {
                                    xr0: T,
                                    xr1: A
                                }), k && M && (w.r2l(k[0]) !== w.r2l(M[0]) || w.r2l(k[1]) !== w.r2l(M[1])) && (E = {
                                    yr0: k,
                                    yr1: M
                                }), (S || E) && l.push(u.extendFlat({
                                    plotinfo: x
                                }, S, E));
                            }
                        }
                        return Promise.resolve();
                    }, o.runFn = function(e1) {
                        var n, i, o = t1._fullLayout._basePlotModules, c = l.length;
                        if (r) for(i = 0; i < o.length; i++)o[i].transitionAxes && o[i].transitionAxes(t1, l, a, e1);
                        for(var f in c ? ((n = u.extendFlat({}, a)).duration = 0, delete s.cartesian) : n = a, s){
                            var h = s[f];
                            t1._fullData[h[0]]._module.basePlotModule.plot(t1, h, n, e1);
                        }
                    }, I(t1, a, o);
                }, b.transitionFromReact = function(t1, e1, r, n) {
                    var i = t1._fullLayout, a = i.transition, o = {}, s = [];
                    return o.prepareFn = function() {
                        var t1 = i._plots;
                        for(var a in o.redraw = !1, "some" === e1.anim && (o.redraw = !0), "some" === r.anim && (o.redraw = !0), t1){
                            var l = t1[a], c = l.xaxis, f = l.yaxis, h = n[c._name].range.slice(), p = n[f._name].range.slice(), d = c.range.slice(), m = f.range.slice();
                            c.setScale(), f.setScale();
                            var g = null, v = null;
                            c.r2l(h[0]) === c.r2l(d[0]) && c.r2l(h[1]) === c.r2l(d[1]) || (g = {
                                xr0: h,
                                xr1: d
                            }), f.r2l(p[0]) === f.r2l(m[0]) && f.r2l(p[1]) === f.r2l(m[1]) || (v = {
                                yr0: p,
                                yr1: m
                            }), (g || v) && s.push(u.extendFlat({
                                plotinfo: l
                            }, g, v));
                        }
                        return Promise.resolve();
                    }, o.runFn = function(r) {
                        for(var n, i, o, l = t1._fullData, c = t1._fullLayout._basePlotModules, f = [], h = 0; h < l.length; h++)f.push(h);
                        function p() {
                            if (t1._fullLayout) for(var e1 = 0; e1 < c.length; e1++)c[e1].transitionAxes && c[e1].transitionAxes(t1, s, n, r);
                        }
                        function d() {
                            if (t1._fullLayout) for(var e1 = 0; e1 < c.length; e1++)c[e1].plot(t1, o, i, r);
                        }
                        s.length && e1.anim ? "traces first" === a.ordering ? (n = u.extendFlat({}, a, {
                            duration: 0
                        }), o = f, i = a, setTimeout(p, a.duration), d()) : (n = a, o = null, i = u.extendFlat({}, a, {
                            duration: 0
                        }), setTimeout(d, n.duration), p()) : s.length ? (n = a, p()) : e1.anim && (o = f, i = a, d());
                    }, I(t1, a, o);
                }, b.doCalcdata = function(t1, e1) {
                    var r, n, i, a, o = p.list(t1), c = t1._fullData, f = t1._fullLayout, d = new Array(c.length), m = (t1.calcdata || []).slice();
                    for(t1.calcdata = d, f._numBoxes = 0, f._numViolins = 0, f._violinScaleGroupStats = {}, t1._hmpixcount = 0, t1._hmlumcount = 0, f._piecolormap = {}, f._sunburstcolormap = {}, f._treemapcolormap = {}, f._iciclecolormap = {}, f._funnelareacolormap = {}, i = 0; i < c.length; i++)Array.isArray(e1) && -1 === e1.indexOf(i) && (d[i] = m[i]);
                    for(i = 0; i < c.length; i++)(r = c[i])._arrayAttrs = l.findArrayAttributes(r), r._extremes = {};
                    var g = f._subplots.polar || [];
                    for(i = 0; i < g.length; i++)o.push(f[g[i]].radialaxis, f[g[i]].angularaxis);
                    for(var v in f._colorAxes){
                        var y = f[v];
                        !1 !== y.cauto && (delete y.cmin, delete y.cmax);
                    }
                    var x = !1;
                    function b(e1) {
                        if (r = c[e1], n = r._module, !0 === r.visible && r.transforms) {
                            if (n && n.calc) {
                                var i = n.calc(t1, r);
                                i[0] && i[0].t && i[0].t._scene && delete i[0].t._scene.dirty;
                            }
                            for(a = 0; a < r.transforms.length; a++){
                                var o = r.transforms[a];
                                (n = _[o.type]) && n.calcTransform && (r._hasCalcTransform = !0, x = !0, n.calcTransform(t1, r, o));
                            }
                        }
                    }
                    function w(e1, i) {
                        if (r = c[e1], !!(n = r._module).isContainer === i) {
                            var o = [];
                            if (!0 === r.visible && 0 !== r._length) {
                                delete r._indexToPoints;
                                var s = r.transforms || [];
                                for(a = s.length - 1; a >= 0; a--)if (s[a].enabled) {
                                    r._indexToPoints = s[a]._indexToPoints;
                                    break;
                                }
                                n && n.calc && (o = n.calc(t1, r));
                            }
                            Array.isArray(o) && o[0] || (o = [
                                {
                                    x: h,
                                    y: h
                                }
                            ]), o[0].t || (o[0].t = {}), o[0].trace = r, d[e1] = o;
                        }
                    }
                    for(z(o, c, f), i = 0; i < c.length; i++)w(i, !0);
                    for(i = 0; i < c.length; i++)b(i);
                    for(x && z(o, c, f), i = 0; i < c.length; i++)w(i, !0);
                    for(i = 0; i < c.length; i++)w(i, !1);
                    D(t1);
                    var T = function(t1, e1) {
                        var r, n, i, a, o, l = [];
                        function c(t1, r, n) {
                            var i = r._id.charAt(0);
                            if ("histogram2dcontour" === t1) {
                                var a = r._counterAxes[0], o = p.getFromId(e1, a), s = "x" === i || "x" === a && "category" === o.type, l = "y" === i || "y" === a && "category" === o.type;
                                return function(t1, e1) {
                                    return 0 === t1 || 0 === e1 || s && t1 === n[e1].length - 1 || l && e1 === n.length - 1 ? -1 : ("y" === i ? e1 : t1) - 1;
                                };
                            }
                            return function(t1, e1) {
                                return "y" === i ? e1 : t1;
                            };
                        }
                        var f = {
                            min: function(t1) {
                                return u.aggNums(Math.min, null, t1);
                            },
                            max: function(t1) {
                                return u.aggNums(Math.max, null, t1);
                            },
                            sum: function(t1) {
                                return u.aggNums(function(t1, e1) {
                                    return t1 + e1;
                                }, null, t1);
                            },
                            total: function(t1) {
                                return u.aggNums(function(t1, e1) {
                                    return t1 + e1;
                                }, null, t1);
                            },
                            mean: function(t1) {
                                return u.mean(t1);
                            },
                            median: function(t1) {
                                return u.median(t1);
                            }
                        };
                        for(r = 0; r < t1.length; r++){
                            var h = t1[r];
                            if ("category" === h.type) {
                                var d = h.categoryorder.match(O);
                                if (d) {
                                    var m = d[1], g = d[2], v = h._id.charAt(0), y = "x" === v, x = [];
                                    for(n = 0; n < h._categories.length; n++)x.push([
                                        h._categories[n],
                                        []
                                    ]);
                                    for(n = 0; n < h._traceIndices.length; n++){
                                        var b = h._traceIndices[n], _ = e1._fullData[b];
                                        if (!0 === _.visible) {
                                            var w = _.type;
                                            s.traceIs(_, "histogram") && (delete _._xautoBinFinished, delete _._yautoBinFinished);
                                            var T = "splom" === w, k = "scattergl" === w, A = e1.calcdata[b];
                                            for(i = 0; i < A.length; i++){
                                                var M, S, E = A[i];
                                                if (T) {
                                                    var L = _._axesDim[h._id];
                                                    if (!y) {
                                                        var C = _._diag[L][0];
                                                        C && (h = e1._fullLayout[p.id2name(C)]);
                                                    }
                                                    var P = E.trace.dimensions[L].values;
                                                    for(a = 0; a < P.length; a++)for(M = h._categoriesMap[P[a]], o = 0; o < E.trace.dimensions.length; o++)if (o !== L) {
                                                        var I = E.trace.dimensions[o];
                                                        x[M][1].push(I.values[a]);
                                                    }
                                                } else if (k) {
                                                    for(a = 0; a < E.t.x.length; a++)y ? (M = E.t.x[a], S = E.t.y[a]) : (M = E.t.y[a], S = E.t.x[a]), x[M][1].push(S);
                                                    E.t && E.t._scene && delete E.t._scene.dirty;
                                                } else if (E.hasOwnProperty("z")) {
                                                    S = E.z;
                                                    var z = c(_.type, h, S);
                                                    for(a = 0; a < S.length; a++)for(o = 0; o < S[a].length; o++)(M = z(o, a)) + 1 && x[M][1].push(S[a][o]);
                                                } else for(void 0 === (M = E.p) && (M = E[v]), void 0 === (S = E.s) && (S = E.v), void 0 === S && (S = y ? E.y : E.x), Array.isArray(S) || (S = void 0 === S ? [] : [
                                                    S
                                                ]), a = 0; a < S.length; a++)x[M][1].push(S[a]);
                                            }
                                        }
                                    }
                                    h._categoriesValue = x;
                                    var D = [];
                                    for(n = 0; n < x.length; n++)D.push([
                                        x[n][0],
                                        f[m](x[n][1])
                                    ]);
                                    D.sort(function(t1, e1) {
                                        return t1[1] - e1[1];
                                    }), h._categoriesAggregatedValue = D, h._initialCategories = D.map(function(t1) {
                                        return t1[0];
                                    }), "descending" === g && h._initialCategories.reverse(), l = l.concat(h.sortByInitialCategories());
                                }
                            }
                        }
                        return l;
                    }(o, t1);
                    if (T.length) {
                        for(f._numBoxes = 0, f._numViolins = 0, i = 0; i < T.length; i++)w(T[i], !0);
                        for(i = 0; i < T.length; i++)w(T[i], !1);
                        D(t1);
                    }
                    s.getComponentMethod("fx", "calc")(t1), s.getComponentMethod("errorbars", "calc")(t1);
                };
                var O = /(total|sum|min|max|mean|median) (ascending|descending)/;
                function z(t1, e1, r) {
                    var n = {};
                    function i(t1) {
                        t1.clearCalc(), "multicategory" === t1.type && t1.setupMultiCategory(e1), n[t1._id] = 1;
                    }
                    u.simpleMap(t1, i);
                    for(var a = r._axisMatchGroups || [], o = 0; o < a.length; o++)for(var s in a[o])n[s] || i(r[p.id2name(s)]);
                }
                function D(t1) {
                    var e1, r, n, i = t1._fullLayout, a = i._visibleModules, o = {};
                    for(r = 0; r < a.length; r++){
                        var s = a[r], l = s.crossTraceCalc;
                        if (l) {
                            var c = s.basePlotModule.name;
                            o[c] ? u.pushUnique(o[c], l) : o[c] = [
                                l
                            ];
                        }
                    }
                    for(n in o){
                        var f = o[n], h = i._subplots[n];
                        if (Array.isArray(h)) for(e1 = 0; e1 < h.length; e1++){
                            var p = h[e1], d = "cartesian" === n ? i._plots[p] : i[p];
                            for(r = 0; r < f.length; r++)f[r](t1, d, p);
                        }
                        else for(r = 0; r < f.length; r++)f[r](t1);
                    }
                }
                b.rehover = function(t1) {
                    t1._fullLayout._rehover && t1._fullLayout._rehover();
                }, b.redrag = function(t1) {
                    t1._fullLayout._redrag && t1._fullLayout._redrag();
                }, b.generalUpdatePerTraceModule = function(t1, e1, r, n) {
                    var i, a = e1.traceHash, o = {};
                    for(i = 0; i < r.length; i++){
                        var s = r[i], l = s[0].trace;
                        l.visible && (o[l.type] = o[l.type] || [], o[l.type].push(s));
                    }
                    for(var c in a)if (!o[c]) {
                        var f = a[c][0];
                        f[0].trace.visible = !1, o[c] = [
                            f
                        ];
                    }
                    for(var h in o){
                        var p = o[h];
                        p[0][0].trace._module.plot(t1, e1, u.filterVisible(p), n);
                    }
                    e1.traceHash = o;
                }, b.plotBasePlot = function(t1, e1, r, n, i) {
                    var a = s.getModule(t1), o = v(e1.calcdata, a)[0];
                    a.plot(e1, o, n, i);
                }, b.cleanBasePlot = function(t1, e1, r, n, i) {
                    var a = i._has && i._has(t1), o = r._has && r._has(t1);
                    a && !o && i["_" + t1 + "layer"].selectAll("g.trace").remove();
                };
            },
            {
                "../components/color": 366,
                "../constants/numerical": 479,
                "../lib": 503,
                "../plot_api/plot_schema": 542,
                "../plot_api/plot_template": 543,
                "../plots/get_data": 593,
                "../registry": 638,
                "./animation_attributes": 548,
                "./attributes": 550,
                "./cartesian/axis_ids": 558,
                "./cartesian/handle_outline": 565,
                "./command": 583,
                "./font_attributes": 585,
                "./frame_attributes": 586,
                "./layout_attributes": 610,
                "@plotly/d3": 58,
                "d3-format": 112,
                "d3-time-format": 120,
                "fast-isnumeric": 190
            }
        ],
        620: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attr: "subplot",
                    name: "polar",
                    axisNames: [
                        "angularaxis",
                        "radialaxis"
                    ],
                    axisName2dataArray: {
                        angularaxis: "theta",
                        radialaxis: "r"
                    },
                    layerNames: [
                        "draglayer",
                        "plotbg",
                        "backplot",
                        "angular-grid",
                        "radial-grid",
                        "frontplot",
                        "angular-line",
                        "radial-line",
                        "angular-axis",
                        "radial-axis"
                    ],
                    radialDragBoxSize: 50,
                    angularDragBoxSize: 30,
                    cornerLen: 25,
                    cornerHalfWidth: 2,
                    MINDRAG: 8,
                    MINZOOM: 20,
                    OFFEDGE: 20
                };
            },
            {}
        ],
        621: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../lib/polygon").tester, a = n.findIndexOfMin, o = n.isAngleInsideSector, s = n.angleDelta, l = n.angleDist;
                function c(t1, e1, r, n) {
                    var i, a, o = n[0], s = n[1], l = f(Math.sin(e1) - Math.sin(t1)), c = f(Math.cos(e1) - Math.cos(t1)), u = Math.tan(r), h = f(1 / u), p = l / c, d = s - p * o;
                    return h ? l && c ? a = u * (i = d / (u - p)) : c ? (i = s * h, a = s) : (i = o, a = o * u) : l && c ? (i = 0, a = d) : c ? (i = 0, a = s) : i = a = NaN, [
                        i,
                        a
                    ];
                }
                function u(t1, e1, r, i) {
                    return n.isFullCircle([
                        e1,
                        r
                    ]) ? function(t1, e1) {
                        var r, n = e1.length, i = new Array(n + 1);
                        for(r = 0; r < n; r++){
                            var a = e1[r];
                            i[r] = [
                                t1 * Math.cos(a),
                                t1 * Math.sin(a)
                            ];
                        }
                        return i[r] = i[0].slice(), i;
                    }(t1, i) : function(t1, e1, r, i) {
                        var s, u, f = i.length, h = [];
                        function p(e1) {
                            return [
                                t1 * Math.cos(e1),
                                t1 * Math.sin(e1)
                            ];
                        }
                        function d(t1, e1, r) {
                            return c(t1, e1, r, p(t1));
                        }
                        function m(t1) {
                            return n.mod(t1, f);
                        }
                        function g(t1) {
                            return o(t1, [
                                e1,
                                r
                            ]);
                        }
                        var v = a(i, function(t1) {
                            return g(t1) ? l(t1, e1) : 1 / 0;
                        }), y = d(i[v], i[m(v - 1)], e1);
                        for(h.push(y), s = v, u = 0; u < f; s++, u++){
                            var x = i[m(s)];
                            if (!g(x)) break;
                            h.push(p(x));
                        }
                        var b = a(i, function(t1) {
                            return g(t1) ? l(t1, r) : 1 / 0;
                        }), _ = d(i[b], i[m(b + 1)], r);
                        return h.push(_), h.push([
                            0,
                            0
                        ]), h.push(h[0].slice()), h;
                    }(t1, e1, r, i);
                }
                function f(t1) {
                    return Math.abs(t1) > 1e-10 ? t1 : 0;
                }
                function h(t1, e1, r) {
                    e1 = e1 || 0, r = r || 0;
                    for(var n = t1.length, i = new Array(n), a = 0; a < n; a++){
                        var o = t1[a];
                        i[a] = [
                            e1 + o[0],
                            r - o[1]
                        ];
                    }
                    return i;
                }
                e1.exports = {
                    isPtInsidePolygon: function(t1, e1, r, n, a) {
                        if (!o(e1, n)) return !1;
                        var s, l;
                        r[0] < r[1] ? (s = r[0], l = r[1]) : (s = r[1], l = r[0]);
                        var c = i(u(s, n[0], n[1], a)), f = i(u(l, n[0], n[1], a)), h = [
                            t1 * Math.cos(e1),
                            t1 * Math.sin(e1)
                        ];
                        return f.contains(h) && !c.contains(h);
                    },
                    findPolygonOffset: function(t1, e1, r, n) {
                        for(var i = 1 / 0, a = 1 / 0, o = u(t1, e1, r, n), s = 0; s < o.length; s++){
                            var l = o[s];
                            i = Math.min(i, l[0]), a = Math.min(a, -l[1]);
                        }
                        return [
                            i,
                            a
                        ];
                    },
                    findEnclosingVertexAngles: function(t1, e1) {
                        var r = a(e1, function(e1) {
                            var r = s(e1, t1);
                            return r > 0 ? r : 1 / 0;
                        }), i = n.mod(r + 1, e1.length);
                        return [
                            e1[r],
                            e1[i]
                        ];
                    },
                    findIntersectionXY: c,
                    findXYatLength: function(t1, e1, r, n) {
                        var i = -e1 * r, a = e1 * e1 + 1, o = 2 * (e1 * i - r), s = i * i + r * r - t1 * t1, l = Math.sqrt(o * o - 4 * a * s), c = (-o + l) / (2 * a), u = (-o - l) / (2 * a);
                        return [
                            [
                                c,
                                e1 * c + i + n
                            ],
                            [
                                u,
                                e1 * u + i + n
                            ]
                        ];
                    },
                    clampTiny: f,
                    pathPolygon: function(t1, e1, r, n, i, a) {
                        return "M" + h(u(t1, e1, r, n), i, a).join("L");
                    },
                    pathPolygonAnnulus: function(t1, e1, r, n, i, a, o) {
                        var s, l;
                        t1 < e1 ? (s = t1, l = e1) : (s = e1, l = t1);
                        var c = h(u(s, r, n, i), a, o);
                        return "M" + h(u(l, r, n, i), a, o).reverse().join("L") + "M" + c.join("L");
                    }
                };
            },
            {
                "../../lib": 503,
                "../../lib/polygon": 515
            }
        ],
        622: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../get_data").getSubplotCalcData, i = t1("../../lib").counterRegex, a = t1("./polar"), o = t1("./constants"), s = o.attr, l = o.name, c = i(l), u = {};
                u[s] = {
                    valType: "subplotid",
                    dflt: l,
                    editType: "calc"
                }, e1.exports = {
                    attr: s,
                    name: l,
                    idRoot: l,
                    idRegex: c,
                    attrRegex: c,
                    attributes: u,
                    layoutAttributes: t1("./layout_attributes"),
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    plot: function(t1) {
                        for(var e1 = t1._fullLayout, r = t1.calcdata, i = e1._subplots[l], o = 0; o < i.length; o++){
                            var s = i[o], c = n(r, l, s), u = e1[s]._subplot;
                            u || (u = a(t1, s), e1[s]._subplot = u), u.plot(c, e1, t1._promises);
                        }
                    },
                    clean: function(t1, e1, r, n) {
                        for(var i = n._subplots[l] || [], a = n._has && n._has("gl"), o = e1._has && e1._has("gl"), s = a && !o, c = 0; c < i.length; c++){
                            var u = i[c], f = n[u]._subplot;
                            if (!e1[u] && f) for(var h in f.framework.remove(), f.layers["radial-axis-title"].remove(), f.clipPaths)f.clipPaths[h].remove();
                            s && f._scene && (f._scene.destroy(), f._scene = null);
                        }
                    },
                    toSVG: t1("../cartesian").toSVG
                };
            },
            {
                "../../lib": 503,
                "../cartesian": 568,
                "../get_data": 593,
                "./constants": 620,
                "./layout_attributes": 623,
                "./layout_defaults": 624,
                "./polar": 625
            }
        ],
        623: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color/attributes"), i = t1("../cartesian/layout_attributes"), a = t1("../domain").attributes, o = t1("../../lib").extendFlat, s = t1("../../plot_api/edit_types").overrideAll, l = s({
                    color: i.color,
                    showline: o({}, i.showline, {
                        dflt: !0
                    }),
                    linecolor: i.linecolor,
                    linewidth: i.linewidth,
                    showgrid: o({}, i.showgrid, {
                        dflt: !0
                    }),
                    gridcolor: i.gridcolor,
                    gridwidth: i.gridwidth
                }, "plot", "from-root"), c = s({
                    tickmode: i.tickmode,
                    nticks: i.nticks,
                    tick0: i.tick0,
                    dtick: i.dtick,
                    tickvals: i.tickvals,
                    ticktext: i.ticktext,
                    ticks: i.ticks,
                    ticklen: i.ticklen,
                    tickwidth: i.tickwidth,
                    tickcolor: i.tickcolor,
                    showticklabels: i.showticklabels,
                    showtickprefix: i.showtickprefix,
                    tickprefix: i.tickprefix,
                    showticksuffix: i.showticksuffix,
                    ticksuffix: i.ticksuffix,
                    showexponent: i.showexponent,
                    exponentformat: i.exponentformat,
                    minexponent: i.minexponent,
                    separatethousands: i.separatethousands,
                    tickfont: i.tickfont,
                    tickangle: i.tickangle,
                    tickformat: i.tickformat,
                    tickformatstops: i.tickformatstops,
                    layer: i.layer
                }, "plot", "from-root"), u = {
                    visible: o({}, i.visible, {
                        dflt: !0
                    }),
                    type: o({}, i.type, {
                        values: [
                            "-",
                            "linear",
                            "log",
                            "date",
                            "category"
                        ]
                    }),
                    autotypenumbers: i.autotypenumbers,
                    autorange: o({}, i.autorange, {
                        editType: "plot"
                    }),
                    rangemode: {
                        valType: "enumerated",
                        values: [
                            "tozero",
                            "nonnegative",
                            "normal"
                        ],
                        dflt: "tozero",
                        editType: "calc"
                    },
                    range: o({}, i.range, {
                        items: [
                            {
                                valType: "any",
                                editType: "plot",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            },
                            {
                                valType: "any",
                                editType: "plot",
                                impliedEdits: {
                                    "^autorange": !1
                                }
                            }
                        ],
                        editType: "plot"
                    }),
                    categoryorder: i.categoryorder,
                    categoryarray: i.categoryarray,
                    angle: {
                        valType: "angle",
                        editType: "plot"
                    },
                    side: {
                        valType: "enumerated",
                        values: [
                            "clockwise",
                            "counterclockwise"
                        ],
                        dflt: "clockwise",
                        editType: "plot"
                    },
                    title: {
                        text: o({}, i.title.text, {
                            editType: "plot",
                            dflt: ""
                        }),
                        font: o({}, i.title.font, {
                            editType: "plot"
                        }),
                        editType: "plot"
                    },
                    hoverformat: i.hoverformat,
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editType: "calc",
                    _deprecated: {
                        title: i._deprecated.title,
                        titlefont: i._deprecated.titlefont
                    }
                };
                o(u, l, c);
                var f = {
                    visible: o({}, i.visible, {
                        dflt: !0
                    }),
                    type: {
                        valType: "enumerated",
                        values: [
                            "-",
                            "linear",
                            "category"
                        ],
                        dflt: "-",
                        editType: "calc",
                        _noTemplating: !0
                    },
                    autotypenumbers: i.autotypenumbers,
                    categoryorder: i.categoryorder,
                    categoryarray: i.categoryarray,
                    thetaunit: {
                        valType: "enumerated",
                        values: [
                            "radians",
                            "degrees"
                        ],
                        dflt: "degrees",
                        editType: "calc"
                    },
                    period: {
                        valType: "number",
                        editType: "calc",
                        min: 0
                    },
                    direction: {
                        valType: "enumerated",
                        values: [
                            "counterclockwise",
                            "clockwise"
                        ],
                        dflt: "counterclockwise",
                        editType: "calc"
                    },
                    rotation: {
                        valType: "angle",
                        editType: "calc"
                    },
                    hoverformat: i.hoverformat,
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editType: "calc"
                };
                o(f, l, c), e1.exports = {
                    domain: a({
                        name: "polar",
                        editType: "plot"
                    }),
                    sector: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number",
                                editType: "plot"
                            },
                            {
                                valType: "number",
                                editType: "plot"
                            }
                        ],
                        dflt: [
                            0,
                            360
                        ],
                        editType: "plot"
                    },
                    hole: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "plot"
                    },
                    bgcolor: {
                        valType: "color",
                        editType: "plot",
                        dflt: n.background
                    },
                    radialaxis: u,
                    angularaxis: f,
                    gridshape: {
                        valType: "enumerated",
                        values: [
                            "circular",
                            "linear"
                        ],
                        dflt: "circular",
                        editType: "plot"
                    },
                    uirevision: {
                        valType: "any",
                        editType: "none"
                    },
                    editType: "calc"
                };
            },
            {
                "../../components/color/attributes": 365,
                "../../lib": 503,
                "../../plot_api/edit_types": 536,
                "../cartesian/layout_attributes": 569,
                "../domain": 584
            }
        ],
        624: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/color"), a = t1("../../plot_api/plot_template"), o = t1("../subplot_defaults"), s = t1("../get_data").getSubplotData, l = t1("../cartesian/tick_value_defaults"), c = t1("../cartesian/tick_mark_defaults"), u = t1("../cartesian/tick_label_defaults"), f = t1("../cartesian/prefix_suffix_defaults"), h = t1("../cartesian/category_order_defaults"), p = t1("../cartesian/line_grid_defaults"), d = t1("../cartesian/axis_autotype"), m = t1("./layout_attributes"), g = t1("./set_convert"), v = t1("./constants"), y = v.axisNames;
                function x(t1, e1, r, o) {
                    var d = r("bgcolor");
                    o.bgColor = i.combine(d, o.paper_bgcolor);
                    var x = r("sector");
                    r("hole");
                    var _, w = s(o.fullData, v.name, o.id), T = o.layoutOut;
                    function k(t1, e1) {
                        return r(_ + "." + t1, e1);
                    }
                    for(var A = 0; A < y.length; A++){
                        _ = y[A], n.isPlainObject(t1[_]) || (t1[_] = {});
                        var M = t1[_], S = a.newContainer(e1, _);
                        S._id = S._name = _, S._attr = o.id + "." + _, S._traceIndices = w.map(function(t1) {
                            return t1._expandedIndex;
                        });
                        var E = v.axisName2dataArray[_], L = b(M, S, k, w, E, o);
                        h(M, S, k, {
                            axData: w,
                            dataAttr: E
                        });
                        var C = k("visible");
                        switch(g(S, e1, T), k("uirevision", e1.uirevision), S._m = 1, _){
                            case "radialaxis":
                                var P = k("autorange", !S.isValidRange(M.range));
                                M.autorange = P, !P || "linear" !== L && "-" !== L || k("rangemode"), "reversed" === P && (S._m = -1), k("range"), S.cleanRange("range", {
                                    dfltRange: [
                                        0,
                                        1
                                    ]
                                });
                                break;
                            case "angularaxis":
                                if ("date" === L) {
                                    n.log("Polar plots do not support date angular axes yet.");
                                    for(var I = 0; I < w.length; I++)w[I].visible = !1;
                                    L = M.type = S.type = "linear";
                                }
                                k("linear" === L ? "thetaunit" : "period");
                                var O = k("direction");
                                k("rotation", {
                                    counterclockwise: 0,
                                    clockwise: 90
                                }[O]);
                        }
                        if (f(M, S, k, S.type, {
                            tickSuffixDflt: "degrees" === S.thetaunit ? "\xb0" : void 0
                        }), C) {
                            var z, D, R, F, B = o.font || {};
                            D = (z = k("color")) === M.color ? z : B.color, R = B.size, F = B.family, l(M, S, k, S.type), u(M, S, k, S.type, {
                                font: {
                                    color: D,
                                    size: R,
                                    family: F
                                }
                            }), c(M, S, k, {
                                outerTicks: !0
                            }), p(M, S, k, {
                                dfltColor: z,
                                bgColor: o.bgColor,
                                blend: 60,
                                showLine: !0,
                                showGrid: !0,
                                noZeroLine: !0,
                                attributes: m[_]
                            }), k("layer"), "radialaxis" === _ && (k("side"), k("angle", x[0]), k("title.text"), n.coerceFont(k, "title.font", {
                                color: D,
                                size: n.bigFont(R),
                                family: F
                            }));
                        }
                        "category" !== L && k("hoverformat"), S._input = M;
                    }
                    "category" === e1.angularaxis.type && r("gridshape");
                }
                function b(t1, e1, r, n, i, a) {
                    var o = r("autotypenumbers", a.autotypenumbersDflt);
                    if ("-" === r("type")) {
                        for(var s, l = 0; l < n.length; l++)if (n[l].visible) {
                            s = n[l];
                            break;
                        }
                        s && s[i] && (e1.type = d(s[i], "gregorian", {
                            noMultiCategory: !0,
                            autotypenumbers: o
                        })), "-" === e1.type ? e1.type = "linear" : t1.type = e1.type;
                    }
                    return e1.type;
                }
                e1.exports = function(t1, e1, r) {
                    o(t1, e1, r, {
                        type: v.name,
                        attributes: m,
                        handleDefaults: x,
                        font: e1.font,
                        autotypenumbersDflt: e1.autotypenumbers,
                        paper_bgcolor: e1.paper_bgcolor,
                        fullData: r,
                        layoutOut: e1
                    });
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../cartesian/axis_autotype": 555,
                "../cartesian/category_order_defaults": 559,
                "../cartesian/line_grid_defaults": 571,
                "../cartesian/prefix_suffix_defaults": 573,
                "../cartesian/tick_label_defaults": 578,
                "../cartesian/tick_mark_defaults": 579,
                "../cartesian/tick_value_defaults": 580,
                "../get_data": 593,
                "../subplot_defaults": 632,
                "./constants": 620,
                "./layout_attributes": 623,
                "./set_convert": 626
            }
        ],
        625: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("tinycolor2"), a = t1("../../registry"), o = t1("../../lib"), s = o.strRotate, l = o.strTranslate, c = t1("../../components/color"), u = t1("../../components/drawing"), f = t1("../plots"), h = t1("../../plots/cartesian/axes"), p = t1("../cartesian/set_convert"), d = t1("./set_convert"), m = t1("../cartesian/autorange").doAutoRange, g = t1("../cartesian/dragbox"), v = t1("../../components/dragelement"), y = t1("../../components/fx"), x = t1("../../components/titles"), b = t1("../cartesian/select").prepSelect, _ = t1("../cartesian/select").selectOnClick, w = t1("../cartesian/select").clearSelect, T = t1("../../lib/setcursor"), k = t1("../../lib/clear_gl_canvases"), A = t1("../../plot_api/subroutines").redrawReglTraces, M = t1("../../constants/alignment").MID_SHIFT, S = t1("./constants"), E = t1("./helpers"), L = t1("../smith/helpers"), C = L.smith, P = L.reactanceArc, I = L.resistanceArc, O = L.smithTransform, z = o._, D = o.mod, R = o.deg2rad, F = o.rad2deg;
                function B(t1, e1, r) {
                    this.isSmith = r || !1, this.id = e1, this.gd = t1, this._hasClipOnAxisFalse = null, this.vangles = null, this.radialAxisAngle = null, this.traceHash = {}, this.layers = {}, this.clipPaths = {}, this.clipIds = {}, this.viewInitial = {};
                    var n = t1._fullLayout, i = "clip" + n._uid + e1;
                    this.clipIds.forTraces = i + "-for-traces", this.clipPaths.forTraces = n._clips.append("clipPath").attr("id", this.clipIds.forTraces), this.clipPaths.forTraces.append("path"), this.framework = n["_" + (r ? "smith" : "polar") + "layer"].append("g").attr("class", e1), this.getHole = function(t1) {
                        return this.isSmith ? 0 : t1.hole;
                    }, this.getSector = function(t1) {
                        return this.isSmith ? [
                            0,
                            360
                        ] : t1.sector;
                    }, this.getRadial = function(t1) {
                        return this.isSmith ? t1.realaxis : t1.radialaxis;
                    }, this.getAngular = function(t1) {
                        return this.isSmith ? t1.imaginaryaxis : t1.angularaxis;
                    }, r || (this.radialTickLayout = null, this.angularTickLayout = null);
                }
                var N = B.prototype;
                function j(t1) {
                    var e1 = t1.ticks + String(t1.ticklen) + String(t1.showticklabels);
                    return "side" in t1 && (e1 += t1.side), e1;
                }
                function U(t1, e1) {
                    return e1[o.findIndexOfMin(e1, function(e1) {
                        return o.angleDist(t1, e1);
                    })];
                }
                function V(t1, e1, r) {
                    return e1 ? (t1.attr("display", null), t1.attr(r)) : t1 && t1.attr("display", "none"), t1;
                }
                e1.exports = function(t1, e1, r) {
                    return new B(t1, e1, r);
                }, N.plot = function(t1, e1) {
                    for(var r = e1[this.id], n = !1, i = 0; i < t1.length; i++)if (!1 === t1[i][0].trace.cliponaxis) {
                        n = !0;
                        break;
                    }
                    this._hasClipOnAxisFalse = n, this.updateLayers(e1, r), this.updateLayout(e1, r), f.generalUpdatePerTraceModule(this.gd, this, t1, r), this.updateFx(e1, r), this.isSmith && (delete r.realaxis.range, delete r.imaginaryaxis.range);
                }, N.updateLayers = function(t1, e1) {
                    var r = this.isSmith, i = this.layers, a = this.getRadial(e1), o = this.getAngular(e1), s = S.layerNames, l = s.indexOf("frontplot"), c = s.slice(0, l), u = "below traces" === o.layer, f = "below traces" === a.layer;
                    u && c.push("angular-line"), f && c.push("radial-line"), u && c.push("angular-axis"), f && c.push("radial-axis"), c.push("frontplot"), u || c.push("angular-line"), f || c.push("radial-line"), u || c.push("angular-axis"), f || c.push("radial-axis");
                    var h = (r ? "smith" : "polar") + "sublayer", p = this.framework.selectAll("." + h).data(c, String);
                    p.enter().append("g").attr("class", function(t1) {
                        return h + " " + t1;
                    }).each(function(t1) {
                        var e1 = i[t1] = n.select(this);
                        switch(t1){
                            case "frontplot":
                                r || e1.append("g").classed("barlayer", !0), e1.append("g").classed("scatterlayer", !0);
                                break;
                            case "backplot":
                                e1.append("g").classed("maplayer", !0);
                                break;
                            case "plotbg":
                                i.bg = e1.append("path");
                                break;
                            case "radial-grid":
                            case "angular-grid":
                                e1.style("fill", "none");
                                break;
                            case "radial-line":
                                e1.append("line").style("fill", "none");
                                break;
                            case "angular-line":
                                e1.append("path").style("fill", "none");
                        }
                    }), p.order();
                }, N.updateLayout = function(t1, e1) {
                    var r = this.layers, n = t1._size, i = this.getRadial(e1), a = this.getAngular(e1), o = e1.domain.x, s = e1.domain.y;
                    this.xOffset = n.l + n.w * o[0], this.yOffset = n.t + n.h * (1 - s[1]);
                    var f = this.xLength = n.w * (o[1] - o[0]), h = this.yLength = n.h * (s[1] - s[0]), p = this.getSector(e1);
                    this.sectorInRad = p.map(R);
                    var d, m, g, v, y, x = this.sectorBBox = function(t1) {
                        var e1, r, n, i, a = t1[0], o = t1[1] - a, s = D(a, 360), l = s + o, c = Math.cos(R(s)), u = Math.sin(R(s)), f = Math.cos(R(l)), h = Math.sin(R(l));
                        i = s <= 90 && l >= 90 || s > 90 && l >= 450 ? 1 : u <= 0 && h <= 0 ? 0 : Math.max(u, h);
                        e1 = s <= 180 && l >= 180 || s > 180 && l >= 540 ? -1 : c >= 0 && f >= 0 ? 0 : Math.min(c, f);
                        r = s <= 270 && l >= 270 || s > 270 && l >= 630 ? -1 : u >= 0 && h >= 0 ? 0 : Math.min(u, h);
                        n = l >= 360 ? 1 : c <= 0 && f <= 0 ? 0 : Math.max(c, f);
                        return [
                            e1,
                            r,
                            n,
                            i
                        ];
                    }(p), b = x[2] - x[0], _ = x[3] - x[1], w = h / f, T = Math.abs(_ / b);
                    w > T ? (d = f, y = (h - (m = f * T)) / n.h / 2, g = [
                        o[0],
                        o[1]
                    ], v = [
                        s[0] + y,
                        s[1] - y
                    ]) : (m = h, y = (f - (d = h / T)) / n.w / 2, g = [
                        o[0] + y,
                        o[1] - y
                    ], v = [
                        s[0],
                        s[1]
                    ]), this.xLength2 = d, this.yLength2 = m, this.xDomain2 = g, this.yDomain2 = v;
                    var k, A = this.xOffset2 = n.l + n.w * g[0], M = this.yOffset2 = n.t + n.h * (1 - v[1]), S = this.radius = d / b, E = this.innerRadius = this.getHole(e1) * S, L = this.cx = A - S * x[0], C = this.cy = M + S * x[3], P = this.cxx = L - A, I = this.cyy = C - M, O = i.side;
                    "counterclockwise" === O ? (k = O, O = "top") : "clockwise" === O && (k = O, O = "bottom"), this.radialAxis = this.mockAxis(t1, e1, i, {
                        _id: "x",
                        side: O,
                        _trueSide: k,
                        domain: [
                            E / n.w,
                            S / n.w
                        ]
                    }), this.angularAxis = this.mockAxis(t1, e1, a, {
                        side: "right",
                        domain: [
                            0,
                            Math.PI
                        ],
                        autorange: !1
                    }), this.doAutoRange(t1, e1), this.updateAngularAxis(t1, e1), this.updateRadialAxis(t1, e1), this.updateRadialAxisTitle(t1, e1), this.xaxis = this.mockCartesianAxis(t1, e1, {
                        _id: "x",
                        domain: g
                    }), this.yaxis = this.mockCartesianAxis(t1, e1, {
                        _id: "y",
                        domain: v
                    });
                    var z = this.pathSubplot();
                    this.clipPaths.forTraces.select("path").attr("d", z).attr("transform", l(P, I)), r.frontplot.attr("transform", l(A, M)).call(u.setClipUrl, this._hasClipOnAxisFalse ? null : this.clipIds.forTraces, this.gd), r.bg.attr("d", z).attr("transform", l(L, C)).call(c.fill, e1.bgcolor);
                }, N.mockAxis = function(t1, e1, r, n) {
                    var i = o.extendFlat({}, r, n);
                    return d(i, e1, t1), i;
                }, N.mockCartesianAxis = function(t1, e1, r) {
                    var n = this, i = n.isSmith, a = r._id, s = o.extendFlat({
                        type: "linear"
                    }, r);
                    p(s, t1);
                    var l = {
                        x: [
                            0,
                            2
                        ],
                        y: [
                            1,
                            3
                        ]
                    };
                    return s.setRange = function() {
                        var t1 = n.sectorBBox, r = l[a], i = n.radialAxis._rl, o = (i[1] - i[0]) / (1 - n.getHole(e1));
                        s.range = [
                            t1[r[0]] * o,
                            t1[r[1]] * o
                        ];
                    }, s.isPtWithinRange = "x" !== a || i ? function() {
                        return !0;
                    } : function(t1) {
                        return n.isPtInside(t1);
                    }, s.setRange(), s.setScale(), s;
                }, N.doAutoRange = function(t1, e1) {
                    var r = this.gd, n = this.radialAxis, i = this.getRadial(e1);
                    m(r, n);
                    var a = n.range;
                    i.range = a.slice(), i._input.range = a.slice(), n._rl = [
                        n.r2l(a[0], null, "gregorian"),
                        n.r2l(a[1], null, "gregorian")
                    ];
                }, N.updateRadialAxis = function(t1, e1) {
                    var r = this, n = r.gd, i = r.layers, a = r.radius, u = r.innerRadius, f = r.cx, p = r.cy, d = r.getRadial(e1), m = D(r.getSector(e1)[0], 360), g = r.radialAxis, v = u < a, y = r.isSmith;
                    y || (r.fillViewInitialKey("radialaxis.angle", d.angle), r.fillViewInitialKey("radialaxis.range", g.range.slice()), g.setGeometry()), "auto" === g.tickangle && m > 90 && m <= 270 && (g.tickangle = 180);
                    var x = y ? function(t1) {
                        var e1 = O(r, C([
                            t1.x,
                            0
                        ]));
                        return l(e1[0] - f, e1[1] - p);
                    } : function(t1) {
                        return l(g.l2p(t1.x) + u, 0);
                    }, b = y ? function(t1) {
                        return I(r, t1.x, -1 / 0, 1 / 0);
                    } : function(t1) {
                        return r.pathArc(g.r2p(t1.x) + u);
                    }, _ = j(d);
                    if (r.radialTickLayout !== _ && (i["radial-axis"].selectAll(".xtick").remove(), r.radialTickLayout = _), v) {
                        g.setScale();
                        var w = 0, T = y ? (g.tickvals || []).filter(function(t1) {
                            return t1 >= 0;
                        }).map(function(t1) {
                            return h.tickText(g, t1, !0, !1);
                        }) : h.calcTicks(g), k = y ? T : h.clipEnds(g, T), A = h.getTickSigns(g)[2];
                        y && (("top" === g.ticks && "bottom" === g.side || "bottom" === g.ticks && "top" === g.side) && (A = -A), "top" === g.ticks && "top" === g.side && (w = -g.ticklen), "bottom" === g.ticks && "bottom" === g.side && (w = g.ticklen)), h.drawTicks(n, g, {
                            vals: T,
                            layer: i["radial-axis"],
                            path: h.makeTickPath(g, 0, A),
                            transFn: x,
                            crisp: !1
                        }), h.drawGrid(n, g, {
                            vals: k,
                            layer: i["radial-grid"],
                            path: b,
                            transFn: o.noop,
                            crisp: !1
                        }), h.drawLabels(n, g, {
                            vals: T,
                            layer: i["radial-axis"],
                            transFn: x,
                            labelFns: h.makeLabelFns(g, w)
                        });
                    }
                    var M = r.radialAxisAngle = r.vangles ? F(U(R(d.angle), r.vangles)) : d.angle, S = l(f, p), E = S + s(-M);
                    V(i["radial-axis"], v && (d.showticklabels || d.ticks), {
                        transform: E
                    }), V(i["radial-grid"], v && d.showgrid, {
                        transform: y ? "" : S
                    }), V(i["radial-line"].select("line"), v && d.showline, {
                        x1: y ? -a : u,
                        y1: 0,
                        x2: a,
                        y2: 0,
                        transform: E
                    }).attr("stroke-width", d.linewidth).call(c.stroke, d.linecolor);
                }, N.updateRadialAxisTitle = function(t1, e1, r) {
                    if (!this.isSmith) {
                        var n = this.gd, i = this.radius, a = this.cx, o = this.cy, s = this.getRadial(e1), l = this.id + "title", c = 0;
                        if (s.title) {
                            var f = u.bBox(this.layers["radial-axis"].node()).height, h = s.title.font.size, p = s.side;
                            c = "top" === p ? h : "counterclockwise" === p ? -(f + .4 * h) : f + .8 * h;
                        }
                        var d = void 0 !== r ? r : this.radialAxisAngle, m = R(d), g = Math.cos(m), v = Math.sin(m), y = a + i / 2 * g + c * v, b = o - i / 2 * v + c * g;
                        this.layers["radial-axis-title"] = x.draw(n, l, {
                            propContainer: s,
                            propName: this.id + ".radialaxis.title",
                            placeholder: z(n, "Click to enter radial axis title"),
                            attributes: {
                                x: y,
                                y: b,
                                "text-anchor": "middle"
                            },
                            transform: {
                                rotate: -d
                            }
                        });
                    }
                }, N.updateAngularAxis = function(t1, e1) {
                    var r = this, n = r.gd, i = r.layers, a = r.radius, u = r.innerRadius, f = r.cx, p = r.cy, d = r.getAngular(e1), m = r.angularAxis, g = r.isSmith;
                    g || (r.fillViewInitialKey("angularaxis.rotation", d.rotation), m.setGeometry(), m.setScale());
                    var v = g ? function(t1) {
                        var e1 = O(r, C([
                            0,
                            t1.x
                        ]));
                        return Math.atan2(e1[0] - f, e1[1] - p) - Math.PI / 2;
                    } : function(t1) {
                        return m.t2g(t1.x);
                    };
                    "linear" === m.type && "radians" === m.thetaunit && (m.tick0 = F(m.tick0), m.dtick = F(m.dtick));
                    var y = function(t1) {
                        return l(f + a * Math.cos(t1), p - a * Math.sin(t1));
                    }, x = g ? function(t1) {
                        var e1 = O(r, C([
                            0,
                            t1.x
                        ]));
                        return l(e1[0], e1[1]);
                    } : function(t1) {
                        return y(v(t1));
                    }, b = g ? function(t1) {
                        var e1 = O(r, C([
                            0,
                            t1.x
                        ])), n = Math.atan2(e1[0] - f, e1[1] - p) - Math.PI / 2;
                        return l(e1[0], e1[1]) + s(-F(n));
                    } : function(t1) {
                        var e1 = v(t1);
                        return y(e1) + s(-F(e1));
                    }, _ = g ? function(t1) {
                        return P(r, t1.x, 0, 1 / 0);
                    } : function(t1) {
                        var e1 = v(t1), r = Math.cos(e1), n = Math.sin(e1);
                        return "M" + [
                            f + u * r,
                            p - u * n
                        ] + "L" + [
                            f + a * r,
                            p - a * n
                        ];
                    }, w = h.makeLabelFns(m, 0).labelStandoff, T = {
                        xFn: function(t1) {
                            var e1 = v(t1);
                            return Math.cos(e1) * w;
                        },
                        yFn: function(t1) {
                            var e1 = v(t1), r = Math.sin(e1) > 0 ? .2 : 1;
                            return -Math.sin(e1) * (w + t1.fontSize * r) + Math.abs(Math.cos(e1)) * (t1.fontSize * M);
                        },
                        anchorFn: function(t1) {
                            var e1 = v(t1), r = Math.cos(e1);
                            return Math.abs(r) < .1 ? "middle" : r > 0 ? "start" : "end";
                        },
                        heightFn: function(t1, e1, r) {
                            var n = v(t1);
                            return -0.5 * (1 + Math.sin(n)) * r;
                        }
                    }, k = j(d);
                    r.angularTickLayout !== k && (i["angular-axis"].selectAll("." + m._id + "tick").remove(), r.angularTickLayout = k);
                    var A, S = g ? [
                        1 / 0
                    ].concat(m.tickvals || []).map(function(t1) {
                        return h.tickText(m, t1, !0, !1);
                    }) : h.calcTicks(m);
                    if (g && (S[0].text = "\u221e", S[0].fontSize *= 1.75), "linear" === e1.gridshape ? (A = S.map(v), o.angleDelta(A[0], A[1]) < 0 && (A = A.slice().reverse())) : A = null, r.vangles = A, "category" === m.type && (S = S.filter(function(t1) {
                        return o.isAngleInsideSector(v(t1), r.sectorInRad);
                    })), m.visible) {
                        var E = "inside" === m.ticks ? -1 : 1, L = (m.linewidth || 1) / 2;
                        h.drawTicks(n, m, {
                            vals: S,
                            layer: i["angular-axis"],
                            path: "M" + E * L + ",0h" + E * m.ticklen,
                            transFn: b,
                            crisp: !1
                        }), h.drawGrid(n, m, {
                            vals: S,
                            layer: i["angular-grid"],
                            path: _,
                            transFn: o.noop,
                            crisp: !1
                        }), h.drawLabels(n, m, {
                            vals: S,
                            layer: i["angular-axis"],
                            repositionOnUpdate: !0,
                            transFn: x,
                            labelFns: T
                        });
                    }
                    V(i["angular-line"].select("path"), d.showline, {
                        d: r.pathSubplot(),
                        transform: l(f, p)
                    }).attr("stroke-width", d.linewidth).call(c.stroke, d.linecolor);
                }, N.updateFx = function(t1, e1) {
                    this.gd._context.staticPlot || (!this.isSmith && (this.updateAngularDrag(t1), this.updateRadialDrag(t1, e1, 0), this.updateRadialDrag(t1, e1, 1)), this.updateHoverAndMainDrag(t1));
                }, N.updateHoverAndMainDrag = function(t1) {
                    var e1, r, s = this, c = s.isSmith, u = s.gd, f = s.layers, h = t1._zoomlayer, p = S.MINZOOM, d = S.OFFEDGE, m = s.radius, x = s.innerRadius, T = s.cx, k = s.cy, A = s.cxx, M = s.cyy, L = s.sectorInRad, C = s.vangles, P = s.radialAxis, I = E.clampTiny, O = E.findXYatLength, z = E.findEnclosingVertexAngles, D = S.cornerHalfWidth, R = S.cornerLen / 2, F = g.makeDragger(f, "path", "maindrag", "crosshair");
                    n.select(F).attr("d", s.pathSubplot()).attr("transform", l(T, k)), F.onmousemove = function(t1) {
                        y.hover(u, t1, s.id), u._fullLayout._lasthover = F, u._fullLayout._hoversubplot = s.id;
                    }, F.onmouseout = function(t1) {
                        u._dragging || v.unhover(u, t1);
                    };
                    var B, N, j, U, V, H, q, G, Y, W = {
                        element: F,
                        gd: u,
                        subplot: s.id,
                        plotinfo: {
                            id: s.id,
                            xaxis: s.xaxis,
                            yaxis: s.yaxis
                        },
                        xaxes: [
                            s.xaxis
                        ],
                        yaxes: [
                            s.yaxis
                        ]
                    };
                    function X(t1, e1) {
                        return Math.sqrt(t1 * t1 + e1 * e1);
                    }
                    function Z(t1, e1) {
                        return X(t1 - A, e1 - M);
                    }
                    function J(t1, e1) {
                        return Math.atan2(M - e1, t1 - A);
                    }
                    function K(t1, e1) {
                        return [
                            t1 * Math.cos(e1),
                            t1 * Math.sin(-e1)
                        ];
                    }
                    function Q(t1, e1) {
                        if (0 === t1) return s.pathSector(2 * D);
                        var r = R / t1, n = e1 - r, i = e1 + r, a = Math.max(0, Math.min(t1, m)), o = a - D, l = a + D;
                        return "M" + K(o, n) + "A" + [
                            o,
                            o
                        ] + " 0,0,0 " + K(o, i) + "L" + K(l, i) + "A" + [
                            l,
                            l
                        ] + " 0,0,1 " + K(l, n) + "Z";
                    }
                    function $(t1, e1, r) {
                        if (0 === t1) return s.pathSector(2 * D);
                        var n, i, a = K(t1, e1), o = K(t1, r), l = I((a[0] + o[0]) / 2), c = I((a[1] + o[1]) / 2);
                        if (l && c) {
                            var u = c / l, f = -1 / u, h = O(D, u, l, c);
                            n = O(R, f, h[0][0], h[0][1]), i = O(R, f, h[1][0], h[1][1]);
                        } else {
                            var p, d;
                            c ? (p = R, d = D) : (p = D, d = R), n = [
                                [
                                    l - p,
                                    c - d
                                ],
                                [
                                    l + p,
                                    c - d
                                ]
                            ], i = [
                                [
                                    l - p,
                                    c + d
                                ],
                                [
                                    l + p,
                                    c + d
                                ]
                            ];
                        }
                        return "M" + n.join("L") + "L" + i.reverse().join("L") + "Z";
                    }
                    function tt(t1, e1) {
                        return e1 = Math.max(Math.min(e1, m), x), t1 < d ? t1 = 0 : m - t1 < d ? t1 = m : e1 < d ? e1 = 0 : m - e1 < d && (e1 = m), Math.abs(e1 - t1) > p ? (t1 < e1 ? (j = t1, U = e1) : (j = e1, U = t1), !0) : (j = null, U = null, !1);
                    }
                    function et(t1, e1) {
                        t1 = t1 || V, e1 = e1 || "M0,0Z", G.attr("d", t1), Y.attr("d", e1), g.transitionZoombox(G, Y, H, q), H = !0;
                        var r = {};
                        ot(r), u.emit("plotly_relayouting", r);
                    }
                    function rt(t1, n) {
                        var i, a, o = B + (t1 *= e1), l = N + (n *= r), c = Z(B, N), u = Math.min(Z(o, l), m), f = J(B, N);
                        tt(c, u) && (i = V + s.pathSector(U), j && (i += s.pathSector(j)), a = Q(j, f) + Q(U, f)), et(i, a);
                    }
                    function nt(t1, e1, r, n) {
                        var i = E.findIntersectionXY(r, n, r, [
                            t1 - A,
                            M - e1
                        ]);
                        return X(i[0], i[1]);
                    }
                    function it(t1, e1) {
                        var r, n, i = B + t1, a = N + e1, o = J(B, N), l = J(i, a), c = z(o, C), u = z(l, C);
                        tt(nt(B, N, c[0], c[1]), Math.min(nt(i, a, u[0], u[1]), m)) && (r = V + s.pathSector(U), j && (r += s.pathSector(j)), n = [
                            $(j, c[0], c[1]),
                            $(U, c[0], c[1])
                        ].join(" ")), et(r, n);
                    }
                    function at() {
                        if (g.removeZoombox(u), null !== j && null !== U) {
                            var t1 = {};
                            ot(t1), g.showDoubleClickNotifier(u), a.call("_guiRelayout", u, t1);
                        }
                    }
                    function ot(t1) {
                        var e1 = P._rl, r = (e1[1] - e1[0]) / (1 - x / m) / m, n = [
                            e1[0] + (j - x) * r,
                            e1[0] + (U - x) * r
                        ];
                        t1[s.id + ".radialaxis.range"] = n;
                    }
                    function st(t1, e1) {
                        var r = u._fullLayout.clickmode;
                        if (g.removeZoombox(u), 2 === t1) {
                            var n = {};
                            for(var i in s.viewInitial)n[s.id + "." + i] = s.viewInitial[i];
                            u.emit("plotly_doubleclick", null), a.call("_guiRelayout", u, n);
                        }
                        r.indexOf("select") > -1 && 1 === t1 && _(e1, u, [
                            s.xaxis
                        ], [
                            s.yaxis
                        ], s.id, W), r.indexOf("event") > -1 && y.click(u, e1, s.id);
                    }
                    W.prepFn = function(t1, n, a) {
                        var l = u._fullLayout.dragmode, f = F.getBoundingClientRect();
                        u._fullLayout._calcInverseTransform(u);
                        var p = u._fullLayout._invTransform;
                        e1 = u._fullLayout._invScaleX, r = u._fullLayout._invScaleY;
                        var d = o.apply3DTransform(p)(n - f.left, a - f.top);
                        if (B = d[0], N = d[1], C) {
                            var v = E.findPolygonOffset(m, L[0], L[1], C);
                            B += A + v[0], N += M + v[1];
                        }
                        switch(l){
                            case "zoom":
                                W.clickFn = st, c || (W.moveFn = C ? it : rt, W.doneFn = at, function() {
                                    j = null, U = null, V = s.pathSubplot(), H = !1;
                                    var t1 = u._fullLayout[s.id];
                                    q = i(t1.bgcolor).getLuminance(), (G = g.makeZoombox(h, q, T, k, V)).attr("fill-rule", "evenodd"), Y = g.makeCorners(h, T, k), w(u);
                                }());
                                break;
                            case "select":
                            case "lasso":
                                b(t1, n, a, W, l);
                        }
                    }, v.init(W);
                }, N.updateRadialDrag = function(t1, e1, r) {
                    var i = this, c = i.gd, u = i.layers, f = i.radius, h = i.innerRadius, p = i.cx, d = i.cy, m = i.radialAxis, y = S.radialDragBoxSize, x = y / 2;
                    if (m.visible) {
                        var b, _, T, M = R(i.radialAxisAngle), E = m._rl, L = E[0], C = E[1], P = E[r], I = .75 * (E[1] - E[0]) / (1 - i.getHole(e1)) / f;
                        r ? (b = p + (f + x) * Math.cos(M), _ = d - (f + x) * Math.sin(M), T = "radialdrag") : (b = p + (h - x) * Math.cos(M), _ = d - (h - x) * Math.sin(M), T = "radialdrag-inner");
                        var O, z, D, B = g.makeRectDragger(u, T, "crosshair", -x, -x, y, y), N = {
                            element: B,
                            gd: c
                        };
                        V(n.select(B), m.visible && h < f, {
                            transform: l(b, _)
                        }), N.prepFn = function() {
                            O = null, z = null, D = null, N.moveFn = j, N.doneFn = H, w(c);
                        }, N.clampFn = function(t1, e1) {
                            return Math.sqrt(t1 * t1 + e1 * e1) < S.MINDRAG && (t1 = 0, e1 = 0), [
                                t1,
                                e1
                            ];
                        }, v.init(N);
                    }
                    function j(t1, e1) {
                        if (O) O(t1, e1);
                        else {
                            var n = [
                                t1,
                                -e1
                            ], a = [
                                Math.cos(M),
                                Math.sin(M)
                            ], s = Math.abs(o.dot(n, a) / Math.sqrt(o.dot(n, n)));
                            isNaN(s) || (O = s < .5 ? q : G);
                        }
                        var l = {};
                        !function(t1) {
                            null !== z ? t1[i.id + ".radialaxis.angle"] = z : null !== D && (t1[i.id + ".radialaxis.range[" + r + "]"] = D);
                        }(l), c.emit("plotly_relayouting", l);
                    }
                    function H() {
                        null !== z ? a.call("_guiRelayout", c, i.id + ".radialaxis.angle", z) : null !== D && a.call("_guiRelayout", c, i.id + ".radialaxis.range[" + r + "]", D);
                    }
                    function q(t1, e1) {
                        if (0 !== r) {
                            var n = b + t1, a = _ + e1;
                            z = Math.atan2(d - a, n - p), i.vangles && (z = U(z, i.vangles)), z = F(z);
                            var o = l(p, d) + s(-z);
                            u["radial-axis"].attr("transform", o), u["radial-line"].select("line").attr("transform", o);
                            var c = i.gd._fullLayout, f = c[i.id];
                            i.updateRadialAxisTitle(c, f, z);
                        }
                    }
                    function G(t1, e1) {
                        var n = o.dot([
                            t1,
                            -e1
                        ], [
                            Math.cos(M),
                            Math.sin(M)
                        ]);
                        if (D = P - I * n, I > 0 == (r ? D > L : D < C)) {
                            var s = c._fullLayout, l = s[i.id];
                            m.range[r] = D, m._rl[r] = D, i.updateRadialAxis(s, l), i.xaxis.setRange(), i.xaxis.setScale(), i.yaxis.setRange(), i.yaxis.setScale();
                            var u = !1;
                            for(var f in i.traceHash){
                                var h = i.traceHash[f], p = o.filterVisible(h);
                                h[0][0].trace._module.plot(c, i, p, l), a.traceIs(f, "gl") && p.length && (u = !0);
                            }
                            u && (k(c), A(c));
                        } else D = null;
                    }
                }, N.updateAngularDrag = function(t1) {
                    var e1 = this, r = e1.gd, i = e1.layers, c = e1.radius, f = e1.angularAxis, h = e1.cx, p = e1.cy, d = e1.cxx, m = e1.cyy, y = S.angularDragBoxSize, x = g.makeDragger(i, "path", "angulardrag", "move"), b = {
                        element: x,
                        gd: r
                    };
                    function _(t1, e1) {
                        return Math.atan2(m + y - e1, t1 - d - y);
                    }
                    n.select(x).attr("d", e1.pathAnnulus(c, c + y)).attr("transform", l(h, p)).call(T, "move");
                    var M, E, L, C, P, I, O = i.frontplot.select(".scatterlayer").selectAll(".trace"), z = O.selectAll(".point"), D = O.selectAll(".textpoint");
                    function R(c, g) {
                        var v = e1.gd._fullLayout, y = v[e1.id], x = _(M + c * t1._invScaleX, E + g * t1._invScaleY), b = F(x - I);
                        if (C = L + b, i.frontplot.attr("transform", l(e1.xOffset2, e1.yOffset2) + s([
                            -b,
                            d,
                            m
                        ])), e1.vangles) {
                            P = e1.radialAxisAngle + b;
                            var w = l(h, p) + s(-b), T = l(h, p) + s(-P);
                            i.bg.attr("transform", w), i["radial-grid"].attr("transform", w), i["radial-axis"].attr("transform", T), i["radial-line"].select("line").attr("transform", T), e1.updateRadialAxisTitle(v, y, P);
                        } else e1.clipPaths.forTraces.select("path").attr("transform", l(d, m) + s(b));
                        z.each(function() {
                            var t1 = n.select(this), e1 = u.getTranslate(t1);
                            t1.attr("transform", l(e1.x, e1.y) + s([
                                b
                            ]));
                        }), D.each(function() {
                            var t1 = n.select(this), e1 = t1.select("text"), r = u.getTranslate(t1);
                            t1.attr("transform", s([
                                b,
                                e1.attr("x"),
                                e1.attr("y")
                            ]) + l(r.x, r.y));
                        }), f.rotation = o.modHalf(C, 360), e1.updateAngularAxis(v, y), e1._hasClipOnAxisFalse && !o.isFullCircle(e1.sectorInRad) && O.call(u.hideOutsideRangePoints, e1);
                        var S = !1;
                        for(var R in e1.traceHash)if (a.traceIs(R, "gl")) {
                            var N = e1.traceHash[R], j = o.filterVisible(N);
                            N[0][0].trace._module.plot(r, e1, j, y), j.length && (S = !0);
                        }
                        S && (k(r), A(r));
                        var U = {};
                        B(U), r.emit("plotly_relayouting", U);
                    }
                    function B(t1) {
                        t1[e1.id + ".angularaxis.rotation"] = C, e1.vangles && (t1[e1.id + ".radialaxis.angle"] = P);
                    }
                    function N() {
                        D.select("text").attr("transform", null);
                        var t1 = {};
                        B(t1), a.call("_guiRelayout", r, t1);
                    }
                    b.prepFn = function(n, i, a) {
                        var s = t1[e1.id];
                        L = s.angularaxis.rotation;
                        var l = x.getBoundingClientRect();
                        M = i - l.left, E = a - l.top, r._fullLayout._calcInverseTransform(r);
                        var c = o.apply3DTransform(t1._invTransform)(M, E);
                        M = c[0], E = c[1], I = _(M, E), b.moveFn = R, b.doneFn = N, w(r);
                    }, e1.vangles && !o.isFullCircle(e1.sectorInRad) && (b.prepFn = o.noop, T(n.select(x), null)), v.init(b);
                }, N.isPtInside = function(t1) {
                    if (this.isSmith) return !0;
                    var e1 = this.sectorInRad, r = this.vangles, n = this.angularAxis.c2g(t1.theta), i = this.radialAxis, a = i.c2l(t1.r), s = i._rl;
                    return (r ? E.isPtInsidePolygon : o.isPtInsideSector)(a, n, s, e1, r);
                }, N.pathArc = function(t1) {
                    var e1 = this.sectorInRad, r = this.vangles;
                    return (r ? E.pathPolygon : o.pathArc)(t1, e1[0], e1[1], r);
                }, N.pathSector = function(t1) {
                    var e1 = this.sectorInRad, r = this.vangles;
                    return (r ? E.pathPolygon : o.pathSector)(t1, e1[0], e1[1], r);
                }, N.pathAnnulus = function(t1, e1) {
                    var r = this.sectorInRad, n = this.vangles;
                    return (n ? E.pathPolygonAnnulus : o.pathAnnulus)(t1, e1, r[0], r[1], n);
                }, N.pathSubplot = function() {
                    var t1 = this.innerRadius, e1 = this.radius;
                    return t1 ? this.pathAnnulus(t1, e1) : this.pathSector(e1);
                }, N.fillViewInitialKey = function(t1, e1) {
                    t1 in this.viewInitial || (this.viewInitial[t1] = e1);
                };
            },
            {
                "../../components/color": 366,
                "../../components/dragelement": 385,
                "../../components/drawing": 388,
                "../../components/fx": 406,
                "../../components/titles": 464,
                "../../constants/alignment": 471,
                "../../lib": 503,
                "../../lib/clear_gl_canvases": 487,
                "../../lib/setcursor": 524,
                "../../plot_api/subroutines": 544,
                "../../plots/cartesian/axes": 554,
                "../../registry": 638,
                "../cartesian/autorange": 553,
                "../cartesian/dragbox": 563,
                "../cartesian/select": 575,
                "../cartesian/set_convert": 576,
                "../plots": 619,
                "../smith/helpers": 628,
                "./constants": 620,
                "./helpers": 621,
                "./set_convert": 626,
                "@plotly/d3": 58,
                tinycolor2: 312
            }
        ],
        626: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../cartesian/set_convert"), a = n.deg2rad, o = n.rad2deg;
                e1.exports = function(t1, e1, r) {
                    switch(i(t1, r), t1._id){
                        case "x":
                        case "radialaxis":
                            !function(t1, e1) {
                                var r = e1._subplot;
                                t1.setGeometry = function() {
                                    var e1 = t1._rl[0], n = t1._rl[1], i = r.innerRadius, a = (r.radius - i) / (n - e1), o = i / a, s = e1 > n ? function(t1) {
                                        return t1 <= 0;
                                    } : function(t1) {
                                        return t1 >= 0;
                                    };
                                    t1.c2g = function(r) {
                                        var n = t1.c2l(r) - e1;
                                        return (s(n) ? n : 0) + o;
                                    }, t1.g2c = function(r) {
                                        return t1.l2c(r + e1 - o);
                                    }, t1.g2p = function(t1) {
                                        return t1 * a;
                                    }, t1.c2p = function(e1) {
                                        return t1.g2p(t1.c2g(e1));
                                    };
                                };
                            }(t1, e1);
                            break;
                        case "angularaxis":
                            !function(t1, e1) {
                                var r = t1.type;
                                if ("linear" === r) {
                                    var i = t1.d2c, s = t1.c2d;
                                    t1.d2c = function(t1, e1) {
                                        return function(t1, e1) {
                                            return "degrees" === e1 ? a(t1) : t1;
                                        }(i(t1), e1);
                                    }, t1.c2d = function(t1, e1) {
                                        return s(function(t1, e1) {
                                            return "degrees" === e1 ? o(t1) : t1;
                                        }(t1, e1));
                                    };
                                }
                                t1.makeCalcdata = function(e1, i) {
                                    var a, o, s = e1[i], l = e1._length, c = function(r) {
                                        return t1.d2c(r, e1.thetaunit);
                                    };
                                    if (s) {
                                        if (n.isTypedArray(s) && "linear" === r) {
                                            if (l === s.length) return s;
                                            if (s.subarray) return s.subarray(0, l);
                                        }
                                        for(a = new Array(l), o = 0; o < l; o++)a[o] = c(s[o]);
                                    } else {
                                        var u = i + "0", f = "d" + i, h = u in e1 ? c(e1[u]) : 0, p = e1[f] ? c(e1[f]) : (t1.period || 2 * Math.PI) / l;
                                        for(a = new Array(l), o = 0; o < l; o++)a[o] = h + o * p;
                                    }
                                    return a;
                                }, t1.setGeometry = function() {
                                    var i, s, l, c, u = e1.sector, f = u.map(a), h = {
                                        clockwise: -1,
                                        counterclockwise: 1
                                    }[t1.direction], p = a(t1.rotation), d = function(t1) {
                                        return h * t1 + p;
                                    }, m = function(t1) {
                                        return (t1 - p) / h;
                                    };
                                    switch(r){
                                        case "linear":
                                            s = i = n.identity, c = a, l = o, t1.range = n.isFullCircle(f) ? [
                                                u[0],
                                                u[0] + 360
                                            ] : f.map(m).map(o);
                                            break;
                                        case "category":
                                            var g = t1._categories.length, v = t1.period ? Math.max(t1.period, g) : g;
                                            0 === v && (v = 1), s = c = function(t1) {
                                                return 2 * t1 * Math.PI / v;
                                            }, i = l = function(t1) {
                                                return t1 * v / Math.PI / 2;
                                            }, t1.range = [
                                                0,
                                                v
                                            ];
                                    }
                                    t1.c2g = function(t1) {
                                        return d(s(t1));
                                    }, t1.g2c = function(t1) {
                                        return i(m(t1));
                                    }, t1.t2g = function(t1) {
                                        return d(c(t1));
                                    }, t1.g2t = function(t1) {
                                        return l(m(t1));
                                    };
                                };
                            }(t1, e1);
                    }
                };
            },
            {
                "../../lib": 503,
                "../cartesian/set_convert": 576
            }
        ],
        627: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attr: "subplot",
                    name: "smith",
                    axisNames: [
                        "realaxis",
                        "imaginaryaxis"
                    ],
                    axisName2dataArray: {
                        imaginaryaxis: "imag",
                        realaxis: "real"
                    }
                };
            },
            {}
        ],
        628: [
            function(t1, e1, r) {
                "use strict";
                function n(t1) {
                    return t1 < 0 ? -1 : t1 > 0 ? 1 : 0;
                }
                function i(t1) {
                    var e1 = t1[0], r = t1[1];
                    if (!isFinite(e1) || !isFinite(r)) return [
                        1,
                        0
                    ];
                    var n = (e1 + 1) * (e1 + 1) + r * r;
                    return [
                        (e1 * e1 + r * r - 1) / n,
                        2 * r / n
                    ];
                }
                function a(t1, e1) {
                    var r = e1[0], n = e1[1];
                    return [
                        r * t1.radius + t1.cx,
                        -n * t1.radius + t1.cy
                    ];
                }
                function o(t1, e1) {
                    return e1 * t1.radius;
                }
                e1.exports = {
                    smith: i,
                    reactanceArc: function(t1, e1, r, n) {
                        var s = a(t1, i([
                            r,
                            e1
                        ])), l = s[0], c = s[1], u = a(t1, i([
                            n,
                            e1
                        ])), f = u[0], h = u[1];
                        if (0 === e1) return [
                            "M" + l + "," + c,
                            "L" + f + "," + h
                        ].join(" ");
                        var p = o(t1, 1 / Math.abs(e1));
                        return [
                            "M" + l + "," + c,
                            "A" + p + "," + p + " 0 0," + (e1 < 0 ? 1 : 0) + " " + f + "," + h
                        ].join(" ");
                    },
                    resistanceArc: function(t1, e1, r, s) {
                        var l = o(t1, 1 / (e1 + 1)), c = a(t1, i([
                            e1,
                            r
                        ])), u = c[0], f = c[1], h = a(t1, i([
                            e1,
                            s
                        ])), p = h[0], d = h[1];
                        if (n(r) !== n(s)) {
                            var m = a(t1, i([
                                e1,
                                0
                            ]));
                            return [
                                "M" + u + "," + f,
                                "A" + l + "," + l + " 0 0," + (0 < r ? 0 : 1) + " " + m[0] + "," + m[1],
                                "A" + l + "," + l + " 0 0," + (s < 0 ? 0 : 1) + p + "," + d
                            ].join(" ");
                        }
                        return [
                            "M" + u + "," + f,
                            "A" + l + "," + l + " 0 0," + (s < r ? 0 : 1) + " " + p + "," + d
                        ].join(" ");
                    },
                    smithTransform: a
                };
            },
            {}
        ],
        629: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../get_data").getSubplotCalcData, i = t1("../../lib").counterRegex, a = t1("../polar/polar"), o = t1("./constants"), s = o.attr, l = o.name, c = i(l), u = {};
                u[s] = {
                    valType: "subplotid",
                    dflt: l,
                    editType: "calc"
                }, e1.exports = {
                    attr: s,
                    name: l,
                    idRoot: l,
                    idRegex: c,
                    attrRegex: c,
                    attributes: u,
                    layoutAttributes: t1("./layout_attributes"),
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    plot: function(t1) {
                        for(var e1 = t1._fullLayout, r = t1.calcdata, i = e1._subplots[l], o = 0; o < i.length; o++){
                            var s = i[o], c = n(r, l, s), u = e1[s]._subplot;
                            u || (u = a(t1, s, !0), e1[s]._subplot = u), u.plot(c, e1, t1._promises);
                        }
                    },
                    clean: function(t1, e1, r, n) {
                        for(var i = n._subplots[l] || [], a = 0; a < i.length; a++){
                            var o = i[a], s = n[o]._subplot;
                            if (!e1[o] && s) for(var c in s.framework.remove(), s.clipPaths)s.clipPaths[c].remove();
                        }
                    },
                    toSVG: t1("../cartesian").toSVG
                };
            },
            {
                "../../lib": 503,
                "../cartesian": 568,
                "../get_data": 593,
                "../polar/polar": 625,
                "./constants": 627,
                "./layout_attributes": 630,
                "./layout_defaults": 631
            }
        ],
        630: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color/attributes"), i = t1("../cartesian/layout_attributes"), a = t1("../domain").attributes, o = t1("../../lib").extendFlat, s = t1("../../plot_api/edit_types").overrideAll, l = s({
                    color: i.color,
                    showline: o({}, i.showline, {
                        dflt: !0
                    }),
                    linecolor: i.linecolor,
                    linewidth: i.linewidth,
                    showgrid: o({}, i.showgrid, {
                        dflt: !0
                    }),
                    gridcolor: i.gridcolor,
                    gridwidth: i.gridwidth
                }, "plot", "from-root"), c = s({
                    ticklen: i.ticklen,
                    tickwidth: o({}, i.tickwidth, {
                        dflt: 2
                    }),
                    tickcolor: i.tickcolor,
                    showticklabels: i.showticklabels,
                    showtickprefix: i.showtickprefix,
                    tickprefix: i.tickprefix,
                    showticksuffix: i.showticksuffix,
                    ticksuffix: i.ticksuffix,
                    tickfont: i.tickfont,
                    tickformat: i.tickformat,
                    hoverformat: i.hoverformat,
                    layer: i.layer
                }, "plot", "from-root"), u = o({
                    visible: o({}, i.visible, {
                        dflt: !0
                    }),
                    tickvals: {
                        dflt: [
                            .2,
                            .5,
                            1,
                            2,
                            5
                        ],
                        valType: "data_array",
                        editType: "plot"
                    },
                    tickangle: o({}, i.tickangle, {
                        dflt: 90
                    }),
                    ticks: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "bottom",
                            ""
                        ],
                        editType: "ticks"
                    },
                    side: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "bottom"
                        ],
                        dflt: "top",
                        editType: "plot"
                    },
                    editType: "calc"
                }, l, c), f = o({
                    visible: o({}, i.visible, {
                        dflt: !0
                    }),
                    tickvals: {
                        valType: "data_array",
                        editType: "plot"
                    },
                    ticks: i.ticks,
                    editType: "calc"
                }, l, c);
                e1.exports = {
                    domain: a({
                        name: "smith",
                        editType: "plot"
                    }),
                    bgcolor: {
                        valType: "color",
                        editType: "plot",
                        dflt: n.background
                    },
                    realaxis: u,
                    imaginaryaxis: f,
                    editType: "calc"
                };
            },
            {
                "../../components/color/attributes": 365,
                "../../lib": 503,
                "../../plot_api/edit_types": 536,
                "../cartesian/layout_attributes": 569,
                "../domain": 584
            }
        ],
        631: [
            function(t1, e1, r) {
                "use strict";
                var n, i, a, o = t1("../../lib"), s = t1("../../components/color"), l = t1("../../plot_api/plot_template"), c = t1("../subplot_defaults"), u = t1("../get_data").getSubplotData, f = t1("../cartesian/prefix_suffix_defaults"), h = t1("../cartesian/tick_label_defaults"), p = t1("../cartesian/line_grid_defaults"), d = t1("../cartesian/set_convert"), m = t1("./layout_attributes"), g = t1("./constants"), v = g.axisNames, y = (n = function(t1) {
                    return t1.slice().reverse().map(function(t1) {
                        return -t1;
                    }).concat([
                        0
                    ]).concat(t1);
                }, i = String, a = {}, function(t1) {
                    var e1 = i ? i(t1) : t1;
                    if (e1 in a) return a[e1];
                    var r = n(t1);
                    return a[e1] = r, r;
                });
                function x(t1, e1, r, n) {
                    var i = r("bgcolor");
                    n.bgColor = s.combine(i, n.paper_bgcolor);
                    var a, c = u(n.fullData, g.name, n.id), x = n.layoutOut;
                    function b(t1, e1) {
                        return r(a + "." + t1, e1);
                    }
                    for(var _ = 0; _ < v.length; _++){
                        a = v[_], o.isPlainObject(t1[a]) || (t1[a] = {});
                        var w = t1[a], T = l.newContainer(e1, a);
                        T._id = T._name = a, T._attr = n.id + "." + a, T._traceIndices = c.map(function(t1) {
                            return t1._expandedIndex;
                        });
                        var k = b("visible");
                        if (T.type = "linear", d(T, x), f(w, T, b, T.type), k) {
                            var A, M, S, E, L = "realaxis" === a;
                            if (L && b("side"), L) b("tickvals");
                            else b("tickvals", y(e1.realaxis.tickvals || m.realaxis.tickvals.dflt));
                            var C = n.font || {};
                            k && (M = (A = b("color")) === w.color ? A : C.color, S = C.size, E = C.family), h(w, T, b, T.type, {
                                noAng: !L,
                                noExp: !0,
                                font: {
                                    color: M,
                                    size: S,
                                    family: E
                                }
                            }), o.coerce2(t1, e1, m, a + ".ticklen"), o.coerce2(t1, e1, m, a + ".tickwidth"), o.coerce2(t1, e1, m, a + ".tickcolor", e1.color), b("ticks") || (delete e1[a].ticklen, delete e1[a].tickwidth, delete e1[a].tickcolor), p(w, T, b, {
                                dfltColor: A,
                                bgColor: n.bgColor,
                                blend: 60,
                                showLine: !0,
                                showGrid: !0,
                                noZeroLine: !0,
                                attributes: m[a]
                            }), b("layer");
                        }
                        b("hoverformat"), delete T.type, T._input = w;
                    }
                }
                e1.exports = function(t1, e1, r) {
                    c(t1, e1, r, {
                        noUirevision: !0,
                        type: g.name,
                        attributes: m,
                        handleDefaults: x,
                        font: e1.font,
                        paper_bgcolor: e1.paper_bgcolor,
                        fullData: r,
                        layoutOut: e1
                    });
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../cartesian/line_grid_defaults": 571,
                "../cartesian/prefix_suffix_defaults": 573,
                "../cartesian/set_convert": 576,
                "../cartesian/tick_label_defaults": 578,
                "../get_data": 593,
                "../subplot_defaults": 632,
                "./constants": 627,
                "./layout_attributes": 630
            }
        ],
        632: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = t1("../plot_api/plot_template"), a = t1("./domain").defaults;
                e1.exports = function(t1, e1, r, o) {
                    var s, l, c = o.type, u = o.attributes, f = o.handleDefaults, h = o.partition || "x", p = e1._subplots[c], d = p.length, m = d && p[0].replace(/\d+$/, "");
                    function g(t1, e1) {
                        return n.coerce(s, l, u, t1, e1);
                    }
                    for(var v = 0; v < d; v++){
                        var y = p[v];
                        s = t1[y] ? t1[y] : t1[y] = {}, l = i.newContainer(e1, y, m), o.noUirevision || g("uirevision", e1.uirevision);
                        var x = {};
                        x[h] = [
                            v / d,
                            (v + 1) / d
                        ], a(l, e1, g, x), o.id = y, f(s, l, g, o);
                    }
                };
            },
            {
                "../lib": 503,
                "../plot_api/plot_template": 543,
                "./domain": 584
            }
        ],
        633: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../constants/docs");
                n.FORMAT_LINK, n.DATE_FORMAT_LINK;
                function i(t1) {
                    var e1 = t1.description ? " " + t1.description : "", r = t1.keys || [];
                    if (r.length > 0) {
                        for(var n = [], i = 0; i < r.length; i++)n[i] = "`" + r[i] + "`";
                        e1 += "Finally, the template string has access to ", e1 = 1 === r.length ? "variable " + n[0] : "variables " + n.slice(0, -1).join(", ") + " and " + n.slice(-1) + ".";
                    }
                    return e1;
                }
                r.hovertemplateAttrs = function(t1, e1) {
                    t1 = t1 || {};
                    i(e1 = e1 || {});
                    var r = {
                        valType: "string",
                        dflt: "",
                        editType: t1.editType || "none"
                    };
                    return !1 !== t1.arrayOk && (r.arrayOk = !0), r;
                }, r.texttemplateAttrs = function(t1, e1) {
                    t1 = t1 || {};
                    i(e1 = e1 || {});
                    var r = {
                        valType: "string",
                        dflt: "",
                        editType: t1.editType || "calc"
                    };
                    return !1 !== t1.arrayOk && (r.arrayOk = !0), r;
                };
            },
            {
                "../constants/docs": 474
            }
        ],
        634: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./ternary"), i = t1("../../plots/get_data").getSubplotCalcData, a = t1("../../lib").counterRegex;
                r.name = "ternary";
                var o = r.attr = "subplot";
                r.idRoot = "ternary", r.idRegex = r.attrRegex = a("ternary"), (r.attributes = {})[o] = {
                    valType: "subplotid",
                    dflt: "ternary",
                    editType: "calc"
                }, r.layoutAttributes = t1("./layout_attributes"), r.supplyLayoutDefaults = t1("./layout_defaults"), r.plot = function(t1) {
                    for(var e1 = t1._fullLayout, r = t1.calcdata, a = e1._subplots.ternary, o = 0; o < a.length; o++){
                        var s = a[o], l = i(r, "ternary", s), c = e1[s]._subplot;
                        c || (c = new n({
                            id: s,
                            graphDiv: t1,
                            container: e1._ternarylayer.node()
                        }, e1), e1[s]._subplot = c), c.plot(l, e1, t1._promises);
                    }
                }, r.clean = function(t1, e1, r, n) {
                    for(var i = n._subplots.ternary || [], a = 0; a < i.length; a++){
                        var o = i[a], s = n[o]._subplot;
                        !e1[o] && s && (s.plotContainer.remove(), s.clipDef.remove(), s.clipDefRelative.remove(), s.layers["a-title"].remove(), s.layers["b-title"].remove(), s.layers["c-title"].remove());
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plots/get_data": 593,
                "./layout_attributes": 635,
                "./layout_defaults": 636,
                "./ternary": 637
            }
        ],
        635: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color/attributes"), i = t1("../domain").attributes, a = t1("../cartesian/layout_attributes"), o = t1("../../plot_api/edit_types").overrideAll, s = t1("../../lib/extend").extendFlat, l = {
                    title: {
                        text: a.title.text,
                        font: a.title.font
                    },
                    color: a.color,
                    tickmode: a.tickmode,
                    nticks: s({}, a.nticks, {
                        dflt: 6,
                        min: 1
                    }),
                    tick0: a.tick0,
                    dtick: a.dtick,
                    tickvals: a.tickvals,
                    ticktext: a.ticktext,
                    ticks: a.ticks,
                    ticklen: a.ticklen,
                    tickwidth: a.tickwidth,
                    tickcolor: a.tickcolor,
                    showticklabels: a.showticklabels,
                    showtickprefix: a.showtickprefix,
                    tickprefix: a.tickprefix,
                    showticksuffix: a.showticksuffix,
                    ticksuffix: a.ticksuffix,
                    showexponent: a.showexponent,
                    exponentformat: a.exponentformat,
                    minexponent: a.minexponent,
                    separatethousands: a.separatethousands,
                    tickfont: a.tickfont,
                    tickangle: a.tickangle,
                    tickformat: a.tickformat,
                    tickformatstops: a.tickformatstops,
                    hoverformat: a.hoverformat,
                    showline: s({}, a.showline, {
                        dflt: !0
                    }),
                    linecolor: a.linecolor,
                    linewidth: a.linewidth,
                    showgrid: s({}, a.showgrid, {
                        dflt: !0
                    }),
                    gridcolor: a.gridcolor,
                    gridwidth: a.gridwidth,
                    layer: a.layer,
                    min: {
                        valType: "number",
                        dflt: 0,
                        min: 0
                    },
                    _deprecated: {
                        title: a._deprecated.title,
                        titlefont: a._deprecated.titlefont
                    }
                }, c = e1.exports = o({
                    domain: i({
                        name: "ternary"
                    }),
                    bgcolor: {
                        valType: "color",
                        dflt: n.background
                    },
                    sum: {
                        valType: "number",
                        dflt: 1,
                        min: 0
                    },
                    aaxis: l,
                    baxis: l,
                    caxis: l
                }, "plot", "from-root");
                c.uirevision = {
                    valType: "any",
                    editType: "none"
                }, c.aaxis.uirevision = c.baxis.uirevision = c.caxis.uirevision = {
                    valType: "any",
                    editType: "none"
                };
            },
            {
                "../../components/color/attributes": 365,
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../cartesian/layout_attributes": 569,
                "../domain": 584
            }
        ],
        636: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color"), i = t1("../../plot_api/plot_template"), a = t1("../../lib"), o = t1("../subplot_defaults"), s = t1("../cartesian/tick_label_defaults"), l = t1("../cartesian/prefix_suffix_defaults"), c = t1("../cartesian/tick_mark_defaults"), u = t1("../cartesian/tick_value_defaults"), f = t1("../cartesian/line_grid_defaults"), h = t1("./layout_attributes"), p = [
                    "aaxis",
                    "baxis",
                    "caxis"
                ];
                function d(t1, e1, r, a) {
                    var o, s, l, c = r("bgcolor"), u = r("sum");
                    a.bgColor = n.combine(c, a.paper_bgcolor);
                    for(var f = 0; f < p.length; f++)s = t1[o = p[f]] || {}, (l = i.newContainer(e1, o))._name = o, m(s, l, a, e1);
                    var h = e1.aaxis, d = e1.baxis, g = e1.caxis;
                    h.min + d.min + g.min >= u && (h.min = 0, d.min = 0, g.min = 0, t1.aaxis && delete t1.aaxis.min, t1.baxis && delete t1.baxis.min, t1.caxis && delete t1.caxis.min);
                }
                function m(t1, e1, r, n) {
                    var i = h[e1._name];
                    function o(r, n) {
                        return a.coerce(t1, e1, i, r, n);
                    }
                    o("uirevision", n.uirevision), e1.type = "linear";
                    var p = o("color"), d = p !== i.color.dflt ? p : r.font.color, m = e1._name.charAt(0).toUpperCase(), g = "Component " + m, v = o("title.text", g);
                    e1._hovertitle = v === g ? v : m, a.coerceFont(o, "title.font", {
                        family: r.font.family,
                        size: a.bigFont(r.font.size),
                        color: d
                    }), o("min"), u(t1, e1, o, "linear"), l(t1, e1, o, "linear"), s(t1, e1, o, "linear"), c(t1, e1, o, {
                        outerTicks: !0
                    }), o("showticklabels") && (a.coerceFont(o, "tickfont", {
                        family: r.font.family,
                        size: r.font.size,
                        color: d
                    }), o("tickangle"), o("tickformat")), f(t1, e1, o, {
                        dfltColor: p,
                        bgColor: r.bgColor,
                        blend: 60,
                        showLine: !0,
                        showGrid: !0,
                        noZeroLine: !0,
                        attributes: i
                    }), o("hoverformat"), o("layer");
                }
                e1.exports = function(t1, e1, r) {
                    o(t1, e1, r, {
                        type: "ternary",
                        attributes: h,
                        handleDefaults: d,
                        font: e1.font,
                        paper_bgcolor: e1.paper_bgcolor
                    });
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../cartesian/line_grid_defaults": 571,
                "../cartesian/prefix_suffix_defaults": 573,
                "../cartesian/tick_label_defaults": 578,
                "../cartesian/tick_mark_defaults": 579,
                "../cartesian/tick_value_defaults": 580,
                "../subplot_defaults": 632,
                "./layout_attributes": 635
            }
        ],
        637: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("tinycolor2"), a = t1("../../registry"), o = t1("../../lib"), s = o.strTranslate, l = o._, c = t1("../../components/color"), u = t1("../../components/drawing"), f = t1("../cartesian/set_convert"), h = t1("../../lib/extend").extendFlat, p = t1("../plots"), d = t1("../cartesian/axes"), m = t1("../../components/dragelement"), g = t1("../../components/fx"), v = t1("../../components/dragelement/helpers"), y = v.freeMode, x = v.rectMode, b = t1("../../components/titles"), _ = t1("../cartesian/select").prepSelect, w = t1("../cartesian/select").selectOnClick, T = t1("../cartesian/select").clearSelect, k = t1("../cartesian/select").clearSelectionsCache, A = t1("../cartesian/constants");
                function M(t1, e1) {
                    this.id = t1.id, this.graphDiv = t1.graphDiv, this.init(e1), this.makeFramework(e1), this.aTickLayout = null, this.bTickLayout = null, this.cTickLayout = null;
                }
                e1.exports = M;
                var S = M.prototype;
                S.init = function(t1) {
                    this.container = t1._ternarylayer, this.defs = t1._defs, this.layoutId = t1._uid, this.traceHash = {}, this.layers = {};
                }, S.plot = function(t1, e1) {
                    var r = e1[this.id], n = e1._size;
                    this._hasClipOnAxisFalse = !1;
                    for(var i = 0; i < t1.length; i++)if (!1 === t1[i][0].trace.cliponaxis) {
                        this._hasClipOnAxisFalse = !0;
                        break;
                    }
                    this.updateLayers(r), this.adjustLayout(r, n), p.generalUpdatePerTraceModule(this.graphDiv, this, t1, r), this.layers.plotbg.select("path").call(c.fill, r.bgcolor);
                }, S.makeFramework = function(t1) {
                    var e1 = this.graphDiv, r = t1[this.id], n = this.clipId = "clip" + this.layoutId + this.id, i = this.clipIdRelative = "clip-relative" + this.layoutId + this.id;
                    this.clipDef = o.ensureSingleById(t1._clips, "clipPath", n, function(t1) {
                        t1.append("path").attr("d", "M0,0Z");
                    }), this.clipDefRelative = o.ensureSingleById(t1._clips, "clipPath", i, function(t1) {
                        t1.append("path").attr("d", "M0,0Z");
                    }), this.plotContainer = o.ensureSingle(this.container, "g", this.id), this.updateLayers(r), u.setClipUrl(this.layers.backplot, n, e1), u.setClipUrl(this.layers.grids, n, e1);
                }, S.updateLayers = function(t1) {
                    var e1 = this.layers, r = [
                        "draglayer",
                        "plotbg",
                        "backplot",
                        "grids"
                    ];
                    "below traces" === t1.aaxis.layer && r.push("aaxis", "aline"), "below traces" === t1.baxis.layer && r.push("baxis", "bline"), "below traces" === t1.caxis.layer && r.push("caxis", "cline"), r.push("frontplot"), "above traces" === t1.aaxis.layer && r.push("aaxis", "aline"), "above traces" === t1.baxis.layer && r.push("baxis", "bline"), "above traces" === t1.caxis.layer && r.push("caxis", "cline");
                    var i = this.plotContainer.selectAll("g.toplevel").data(r, String), a = [
                        "agrid",
                        "bgrid",
                        "cgrid"
                    ];
                    i.enter().append("g").attr("class", function(t1) {
                        return "toplevel " + t1;
                    }).each(function(t1) {
                        var r = n.select(this);
                        e1[t1] = r, "frontplot" === t1 ? r.append("g").classed("scatterlayer", !0) : "backplot" === t1 ? r.append("g").classed("maplayer", !0) : "plotbg" === t1 ? r.append("path").attr("d", "M0,0Z") : "aline" === t1 || "bline" === t1 || "cline" === t1 ? r.append("path") : "grids" === t1 && a.forEach(function(t1) {
                            e1[t1] = r.append("g").classed("grid " + t1, !0);
                        });
                    }), i.order();
                };
                var E = Math.sqrt(4 / 3);
                S.adjustLayout = function(t1, e1) {
                    var r, n, i, a, o, l, p = this, d = t1.domain, m = (d.x[0] + d.x[1]) / 2, g = (d.y[0] + d.y[1]) / 2, v = d.x[1] - d.x[0], y = d.y[1] - d.y[0], x = v * e1.w, b = y * e1.h, _ = t1.sum, w = t1.aaxis.min, T = t1.baxis.min, k = t1.caxis.min;
                    x > E * b ? i = (a = b) * E : a = (i = x) / E, o = v * i / x, l = y * a / b, r = e1.l + e1.w * m - i / 2, n = e1.t + e1.h * (1 - g) - a / 2, p.x0 = r, p.y0 = n, p.w = i, p.h = a, p.sum = _, p.xaxis = {
                        type: "linear",
                        range: [
                            w + 2 * k - _,
                            _ - w - 2 * T
                        ],
                        domain: [
                            m - o / 2,
                            m + o / 2
                        ],
                        _id: "x"
                    }, f(p.xaxis, p.graphDiv._fullLayout), p.xaxis.setScale(), p.xaxis.isPtWithinRange = function(t1) {
                        return t1.a >= p.aaxis.range[0] && t1.a <= p.aaxis.range[1] && t1.b >= p.baxis.range[1] && t1.b <= p.baxis.range[0] && t1.c >= p.caxis.range[1] && t1.c <= p.caxis.range[0];
                    }, p.yaxis = {
                        type: "linear",
                        range: [
                            w,
                            _ - T - k
                        ],
                        domain: [
                            g - l / 2,
                            g + l / 2
                        ],
                        _id: "y"
                    }, f(p.yaxis, p.graphDiv._fullLayout), p.yaxis.setScale(), p.yaxis.isPtWithinRange = function() {
                        return !0;
                    };
                    var A = p.yaxis.domain[0], M = p.aaxis = h({}, t1.aaxis, {
                        range: [
                            w,
                            _ - T - k
                        ],
                        side: "left",
                        tickangle: (+t1.aaxis.tickangle || 0) - 30,
                        domain: [
                            A,
                            A + l * E
                        ],
                        anchor: "free",
                        position: 0,
                        _id: "y",
                        _length: i
                    });
                    f(M, p.graphDiv._fullLayout), M.setScale();
                    var S = p.baxis = h({}, t1.baxis, {
                        range: [
                            _ - w - k,
                            T
                        ],
                        side: "bottom",
                        domain: p.xaxis.domain,
                        anchor: "free",
                        position: 0,
                        _id: "x",
                        _length: i
                    });
                    f(S, p.graphDiv._fullLayout), S.setScale();
                    var L = p.caxis = h({}, t1.caxis, {
                        range: [
                            _ - w - T,
                            k
                        ],
                        side: "right",
                        tickangle: (+t1.caxis.tickangle || 0) + 30,
                        domain: [
                            A,
                            A + l * E
                        ],
                        anchor: "free",
                        position: 0,
                        _id: "y",
                        _length: i
                    });
                    f(L, p.graphDiv._fullLayout), L.setScale();
                    var C = "M" + r + "," + (n + a) + "h" + i + "l-" + i / 2 + ",-" + a + "Z";
                    p.clipDef.select("path").attr("d", C), p.layers.plotbg.select("path").attr("d", C);
                    var P = "M0," + a + "h" + i + "l-" + i / 2 + ",-" + a + "Z";
                    p.clipDefRelative.select("path").attr("d", P);
                    var I = s(r, n);
                    p.plotContainer.selectAll(".scatterlayer,.maplayer").attr("transform", I), p.clipDefRelative.select("path").attr("transform", null);
                    var O = s(r - S._offset, n + a);
                    p.layers.baxis.attr("transform", O), p.layers.bgrid.attr("transform", O);
                    var z = s(r + i / 2, n) + "rotate(30)" + s(0, -M._offset);
                    p.layers.aaxis.attr("transform", z), p.layers.agrid.attr("transform", z);
                    var D = s(r + i / 2, n) + "rotate(-30)" + s(0, -L._offset);
                    p.layers.caxis.attr("transform", D), p.layers.cgrid.attr("transform", D), p.drawAxes(!0), p.layers.aline.select("path").attr("d", M.showline ? "M" + r + "," + (n + a) + "l" + i / 2 + ",-" + a : "M0,0").call(c.stroke, M.linecolor || "#000").style("stroke-width", (M.linewidth || 0) + "px"), p.layers.bline.select("path").attr("d", S.showline ? "M" + r + "," + (n + a) + "h" + i : "M0,0").call(c.stroke, S.linecolor || "#000").style("stroke-width", (S.linewidth || 0) + "px"), p.layers.cline.select("path").attr("d", L.showline ? "M" + (r + i / 2) + "," + n + "l" + i / 2 + "," + a : "M0,0").call(c.stroke, L.linecolor || "#000").style("stroke-width", (L.linewidth || 0) + "px"), p.graphDiv._context.staticPlot || p.initInteractions(), u.setClipUrl(p.layers.frontplot, p._hasClipOnAxisFalse ? null : p.clipId, p.graphDiv);
                }, S.drawAxes = function(t1) {
                    var e1 = this.graphDiv, r = this.id.substr(7) + "title", n = this.layers, i = this.aaxis, a = this.baxis, o = this.caxis;
                    if (this.drawAx(i), this.drawAx(a), this.drawAx(o), t1) {
                        var s = Math.max(i.showticklabels ? i.tickfont.size / 2 : 0, (o.showticklabels ? .75 * o.tickfont.size : 0) + ("outside" === o.ticks ? .87 * o.ticklen : 0)), c = (a.showticklabels ? a.tickfont.size : 0) + ("outside" === a.ticks ? a.ticklen : 0) + 3;
                        n["a-title"] = b.draw(e1, "a" + r, {
                            propContainer: i,
                            propName: this.id + ".aaxis.title",
                            placeholder: l(e1, "Click to enter Component A title"),
                            attributes: {
                                x: this.x0 + this.w / 2,
                                y: this.y0 - i.title.font.size / 3 - s,
                                "text-anchor": "middle"
                            }
                        }), n["b-title"] = b.draw(e1, "b" + r, {
                            propContainer: a,
                            propName: this.id + ".baxis.title",
                            placeholder: l(e1, "Click to enter Component B title"),
                            attributes: {
                                x: this.x0 - c,
                                y: this.y0 + this.h + .83 * a.title.font.size + c,
                                "text-anchor": "middle"
                            }
                        }), n["c-title"] = b.draw(e1, "c" + r, {
                            propContainer: o,
                            propName: this.id + ".caxis.title",
                            placeholder: l(e1, "Click to enter Component C title"),
                            attributes: {
                                x: this.x0 + this.w + c,
                                y: this.y0 + this.h + .83 * o.title.font.size + c,
                                "text-anchor": "middle"
                            }
                        });
                    }
                }, S.drawAx = function(t1) {
                    var e1, r = this.graphDiv, n = t1._name, i = n.charAt(0), a = t1._id, s = this.layers[n], l = i + "tickLayout", c = (e1 = t1).ticks + String(e1.ticklen) + String(e1.showticklabels);
                    this[l] !== c && (s.selectAll("." + a + "tick").remove(), this[l] = c), t1.setScale();
                    var u = d.calcTicks(t1), f = d.clipEnds(t1, u), h = d.makeTransTickFn(t1), p = d.getTickSigns(t1)[2], m = o.deg2rad(30), g = p * (t1.linewidth || 1) / 2, v = p * t1.ticklen, y = this.w, x = this.h, b = "b" === i ? "M0," + g + "l" + Math.sin(m) * v + "," + Math.cos(m) * v : "M" + g + ",0l" + Math.cos(m) * v + "," + -Math.sin(m) * v, _ = {
                        a: "M0,0l" + x + ",-" + y / 2,
                        b: "M0,0l-" + y / 2 + ",-" + x,
                        c: "M0,0l-" + x + "," + y / 2
                    }[i];
                    d.drawTicks(r, t1, {
                        vals: "inside" === t1.ticks ? f : u,
                        layer: s,
                        path: b,
                        transFn: h,
                        crisp: !1
                    }), d.drawGrid(r, t1, {
                        vals: f,
                        layer: this.layers[i + "grid"],
                        path: _,
                        transFn: h,
                        crisp: !1
                    }), d.drawLabels(r, t1, {
                        vals: u,
                        layer: s,
                        transFn: h,
                        labelFns: d.makeLabelFns(t1, 0, 30)
                    });
                };
                var L = A.MINZOOM / 2 + .87, C = "m-0.87,.5h" + L + "v3h-" + (L + 5.2) + "l" + (L / 2 + 2.6) + ",-" + (.87 * L + 4.5) + "l2.6,1.5l-" + L / 2 + "," + .87 * L + "Z", P = "m0.87,.5h-" + L + "v3h" + (L + 5.2) + "l-" + (L / 2 + 2.6) + ",-" + (.87 * L + 4.5) + "l-2.6,1.5l" + L / 2 + "," + .87 * L + "Z", I = "m0,1l" + L / 2 + "," + .87 * L + "l2.6,-1.5l-" + (L / 2 + 2.6) + ",-" + (.87 * L + 4.5) + "l-" + (L / 2 + 2.6) + "," + (.87 * L + 4.5) + "l2.6,1.5l" + L / 2 + ",-" + .87 * L + "Z", O = !0;
                function z(t1) {
                    n.select(t1).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
                }
                S.clearSelect = function() {
                    k(this.dragOptions), T(this.dragOptions.gd);
                }, S.initInteractions = function() {
                    var t1, e1, r, n, f, h, p, d, v, b, T, k, M = this, S = M.layers.plotbg.select("path").node(), L = M.graphDiv, D = L._fullLayout._zoomlayer;
                    function R(t1) {
                        var e1 = {};
                        return e1[M.id + ".aaxis.min"] = t1.a, e1[M.id + ".baxis.min"] = t1.b, e1[M.id + ".caxis.min"] = t1.c, e1;
                    }
                    function F(t1, e1) {
                        var r = L._fullLayout.clickmode;
                        z(L), 2 === t1 && (L.emit("plotly_doubleclick", null), a.call("_guiRelayout", L, R({
                            a: 0,
                            b: 0,
                            c: 0
                        }))), r.indexOf("select") > -1 && 1 === t1 && w(e1, L, [
                            M.xaxis
                        ], [
                            M.yaxis
                        ], M.id, M.dragOptions), r.indexOf("event") > -1 && g.click(L, e1, M.id);
                    }
                    function B(t1, e1) {
                        return 1 - e1 / M.h;
                    }
                    function N(t1, e1) {
                        return 1 - (t1 + (M.h - e1) / Math.sqrt(3)) / M.w;
                    }
                    function j(t1, e1) {
                        return (t1 - (M.h - e1) / Math.sqrt(3)) / M.w;
                    }
                    function U(i, a) {
                        var o = r + i * t1, s = n + a * e1, l = Math.max(0, Math.min(1, B(0, n), B(0, s))), c = Math.max(0, Math.min(1, N(r, n), N(o, s))), u = Math.max(0, Math.min(1, j(r, n), j(o, s))), m = (l / 2 + u) * M.w, g = (1 - l / 2 - c) * M.w, y = (m + g) / 2, x = g - m, _ = (1 - l) * M.h, w = _ - x / E;
                        x < A.MINZOOM ? (p = f, T.attr("d", v), k.attr("d", "M0,0Z")) : (p = {
                            a: f.a + l * h,
                            b: f.b + c * h,
                            c: f.c + u * h
                        }, T.attr("d", v + "M" + m + "," + _ + "H" + g + "L" + y + "," + w + "L" + m + "," + _ + "Z"), k.attr("d", "M" + r + "," + n + "m0.5,0.5h5v-2h-5v-5h-2v5h-5v2h5v5h2ZM" + m + "," + _ + C + "M" + g + "," + _ + P + "M" + y + "," + w + I)), b || (T.transition().style("fill", d > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), k.transition().style("opacity", 1).duration(200), b = !0), L.emit("plotly_relayouting", R(p));
                    }
                    function V() {
                        z(L), p !== f && (a.call("_guiRelayout", L, R(p)), O && L.data && L._context.showTips && (o.notifier(l(L, "Double-click to zoom back out"), "long"), O = !1));
                    }
                    function H(t1, e1) {
                        var r = t1 / M.xaxis._m, n = e1 / M.yaxis._m, i = [
                            (p = {
                                a: f.a - n,
                                b: f.b + (r + n) / 2,
                                c: f.c - (r - n) / 2
                            }).a,
                            p.b,
                            p.c
                        ].sort(o.sorterAsc), a = i.indexOf(p.a), l = i.indexOf(p.b), c = i.indexOf(p.c);
                        i[0] < 0 && (i[1] + i[0] / 2 < 0 ? (i[2] += i[0] + i[1], i[0] = i[1] = 0) : (i[2] += i[0] / 2, i[1] += i[0] / 2, i[0] = 0), p = {
                            a: i[a],
                            b: i[l],
                            c: i[c]
                        }, e1 = (f.a - p.a) * M.yaxis._m, t1 = (f.c - p.c - f.b + p.b) * M.xaxis._m);
                        var h = s(M.x0 + t1, M.y0 + e1);
                        M.plotContainer.selectAll(".scatterlayer,.maplayer").attr("transform", h);
                        var d = s(-t1, -e1);
                        M.clipDefRelative.select("path").attr("transform", d), M.aaxis.range = [
                            p.a,
                            M.sum - p.b - p.c
                        ], M.baxis.range = [
                            M.sum - p.a - p.c,
                            p.b
                        ], M.caxis.range = [
                            M.sum - p.a - p.b,
                            p.c
                        ], M.drawAxes(!1), M._hasClipOnAxisFalse && M.plotContainer.select(".scatterlayer").selectAll(".trace").call(u.hideOutsideRangePoints, M), L.emit("plotly_relayouting", R(p));
                    }
                    function q() {
                        a.call("_guiRelayout", L, R(p));
                    }
                    this.dragOptions = {
                        element: S,
                        gd: L,
                        plotinfo: {
                            id: M.id,
                            domain: L._fullLayout[M.id].domain,
                            xaxis: M.xaxis,
                            yaxis: M.yaxis
                        },
                        subplot: M.id,
                        prepFn: function(a, l, u) {
                            M.dragOptions.xaxes = [
                                M.xaxis
                            ], M.dragOptions.yaxes = [
                                M.yaxis
                            ], t1 = L._fullLayout._invScaleX, e1 = L._fullLayout._invScaleY;
                            var m = M.dragOptions.dragmode = L._fullLayout.dragmode;
                            y(m) ? M.dragOptions.minDrag = 1 : M.dragOptions.minDrag = void 0, "zoom" === m ? (M.dragOptions.moveFn = U, M.dragOptions.clickFn = F, M.dragOptions.doneFn = V, function(t1, e1, a) {
                                var l = S.getBoundingClientRect();
                                r = e1 - l.left, n = a - l.top, L._fullLayout._calcInverseTransform(L);
                                var u = L._fullLayout._invTransform, m = o.apply3DTransform(u)(r, n);
                                r = m[0], n = m[1], f = {
                                    a: M.aaxis.range[0],
                                    b: M.baxis.range[1],
                                    c: M.caxis.range[1]
                                }, p = f, h = M.aaxis.range[1] - f.a, d = i(M.graphDiv._fullLayout[M.id].bgcolor).getLuminance(), v = "M0," + M.h + "L" + M.w / 2 + ", 0L" + M.w + "," + M.h + "Z", b = !1, T = D.append("path").attr("class", "zoombox").attr("transform", s(M.x0, M.y0)).style({
                                    fill: d > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
                                    "stroke-width": 0
                                }).attr("d", v), k = D.append("path").attr("class", "zoombox-corners").attr("transform", s(M.x0, M.y0)).style({
                                    fill: c.background,
                                    stroke: c.defaultLine,
                                    "stroke-width": 1,
                                    opacity: 0
                                }).attr("d", "M0,0Z"), M.clearSelect(L);
                            }(0, l, u)) : "pan" === m ? (M.dragOptions.moveFn = H, M.dragOptions.clickFn = F, M.dragOptions.doneFn = q, f = {
                                a: M.aaxis.range[0],
                                b: M.baxis.range[1],
                                c: M.caxis.range[1]
                            }, p = f, M.clearSelect(L)) : (x(m) || y(m)) && _(a, l, u, M.dragOptions, m);
                        }
                    }, S.onmousemove = function(t1) {
                        g.hover(L, t1, M.id), L._fullLayout._lasthover = S, L._fullLayout._hoversubplot = M.id;
                    }, S.onmouseout = function(t1) {
                        L._dragging || m.unhover(L, t1);
                    }, m.init(this.dragOptions);
                };
            },
            {
                "../../components/color": 366,
                "../../components/dragelement": 385,
                "../../components/dragelement/helpers": 384,
                "../../components/drawing": 388,
                "../../components/fx": 406,
                "../../components/titles": 464,
                "../../lib": 503,
                "../../lib/extend": 493,
                "../../registry": 638,
                "../cartesian/axes": 554,
                "../cartesian/constants": 561,
                "../cartesian/select": 575,
                "../cartesian/set_convert": 576,
                "../plots": 619,
                "@plotly/d3": 58,
                tinycolor2: 312
            }
        ],
        638: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./lib/loggers"), i = t1("./lib/noop"), a = t1("./lib/push_unique"), o = t1("./lib/is_plain_object"), s = t1("./lib/dom").addStyleRule, l = t1("./lib/extend"), c = t1("./plots/attributes"), u = t1("./plots/layout_attributes"), f = l.extendFlat, h = l.extendDeepAll;
                function p(t1) {
                    var e1 = t1.name, i = t1.categories, a = t1.meta;
                    if (r.modules[e1]) n.log("Type " + e1 + " already registered");
                    else {
                        r.subplotsRegistry[t1.basePlotModule.name] || function(t1) {
                            var e1 = t1.name;
                            if (r.subplotsRegistry[e1]) return void n.log("Plot type " + e1 + " already registered.");
                            for(var i in v(t1), r.subplotsRegistry[e1] = t1, r.componentsRegistry)b(i, t1.name);
                        }(t1.basePlotModule);
                        for(var o = {}, l = 0; l < i.length; l++)o[i[l]] = !0, r.allCategories[i[l]] = !0;
                        for(var c in r.modules[e1] = {
                            _module: t1,
                            categories: o
                        }, a && Object.keys(a).length && (r.modules[e1].meta = a), r.allTypes.push(e1), r.componentsRegistry)y(c, e1);
                        t1.layoutAttributes && f(r.traceLayoutAttributes, t1.layoutAttributes);
                        var u = t1.basePlotModule, h = u.name;
                        if ("mapbox" === h) {
                            var p = u.constants.styleRules;
                            for(var d in p)s(".js-plotly-plot .plotly .mapboxgl-" + d, p[d]);
                        }
                        "geo" !== h && "mapbox" !== h || false || void 0 !== window.PlotlyGeoAssets || (window.PlotlyGeoAssets = {
                            topojson: {}
                        });
                    }
                }
                function d(t1) {
                    if ("string" != typeof t1.name) throw new Error("Component module *name* must be a string.");
                    var e1 = t1.name;
                    for(var n in r.componentsRegistry[e1] = t1, t1.layoutAttributes && (t1.layoutAttributes._isLinkedToArray && a(r.layoutArrayContainers, e1), v(t1)), r.modules)y(e1, n);
                    for(var i in r.subplotsRegistry)b(e1, i);
                    for(var o in r.transformsRegistry)x(e1, o);
                    t1.schema && t1.schema.layout && h(u, t1.schema.layout);
                }
                function m(t1) {
                    if ("string" != typeof t1.name) throw new Error("Transform module *name* must be a string.");
                    var e1 = "Transform module " + t1.name, i = "function" == typeof t1.transform, a = "function" == typeof t1.calcTransform;
                    if (!i && !a) throw new Error(e1 + " is missing a *transform* or *calcTransform* method.");
                    for(var s in i && a && n.log([
                        e1 + " has both a *transform* and *calcTransform* methods.",
                        "Please note that all *transform* methods are executed",
                        "before all *calcTransform* methods."
                    ].join(" ")), o(t1.attributes) || n.log(e1 + " registered without an *attributes* object."), "function" != typeof t1.supplyDefaults && n.log(e1 + " registered without a *supplyDefaults* method."), r.transformsRegistry[t1.name] = t1, r.componentsRegistry)x(s, t1.name);
                }
                function g(t1) {
                    var e1 = t1.name, n = e1.split("-")[0], i = t1.dictionary, a = t1.format, o = i && Object.keys(i).length, s = a && Object.keys(a).length, l = r.localeRegistry, c = l[e1];
                    if (c || (l[e1] = c = {}), n !== e1) {
                        var u = l[n];
                        u || (l[n] = u = {}), o && u.dictionary === c.dictionary && (u.dictionary = i), s && u.format === c.format && (u.format = a);
                    }
                    o && (c.dictionary = i), s && (c.format = a);
                }
                function v(t1) {
                    if (t1.layoutAttributes) {
                        var e1 = t1.layoutAttributes._arrayAttrRegexps;
                        if (e1) for(var n = 0; n < e1.length; n++)a(r.layoutArrayRegexes, e1[n]);
                    }
                }
                function y(t1, e1) {
                    var n = r.componentsRegistry[t1].schema;
                    if (n && n.traces) {
                        var i = n.traces[e1];
                        i && h(r.modules[e1]._module.attributes, i);
                    }
                }
                function x(t1, e1) {
                    var n = r.componentsRegistry[t1].schema;
                    if (n && n.transforms) {
                        var i = n.transforms[e1];
                        i && h(r.transformsRegistry[e1].attributes, i);
                    }
                }
                function b(t1, e1) {
                    var n = r.componentsRegistry[t1].schema;
                    if (n && n.subplots) {
                        var i = r.subplotsRegistry[e1], a = i.layoutAttributes, o = "subplot" === i.attr ? i.name : i.attr;
                        Array.isArray(o) && (o = o[0]);
                        var s = n.subplots[o];
                        a && s && h(a, s);
                    }
                }
                function _(t1) {
                    return "object" == typeof t1 && (t1 = t1.type), t1;
                }
                r.modules = {}, r.allCategories = {}, r.allTypes = [], r.subplotsRegistry = {}, r.transformsRegistry = {}, r.componentsRegistry = {}, r.layoutArrayContainers = [], r.layoutArrayRegexes = [], r.traceLayoutAttributes = {}, r.localeRegistry = {}, r.apiMethodRegistry = {}, r.collectableSubplotTypes = null, r.register = function(t1) {
                    if (r.collectableSubplotTypes = null, !t1) throw new Error("No argument passed to Plotly.register.");
                    t1 && !Array.isArray(t1) && (t1 = [
                        t1
                    ]);
                    for(var e1 = 0; e1 < t1.length; e1++){
                        var n = t1[e1];
                        if (!n) throw new Error("Invalid module was attempted to be registered!");
                        switch(n.moduleType){
                            case "trace":
                                p(n);
                                break;
                            case "transform":
                                m(n);
                                break;
                            case "component":
                                d(n);
                                break;
                            case "locale":
                                g(n);
                                break;
                            case "apiMethod":
                                var i = n.name;
                                r.apiMethodRegistry[i] = n.fn;
                                break;
                            default:
                                throw new Error("Invalid module was attempted to be registered!");
                        }
                    }
                }, r.getModule = function(t1) {
                    var e1 = r.modules[_(t1)];
                    return !!e1 && e1._module;
                }, r.traceIs = function(t1, e1) {
                    if ("various" === (t1 = _(t1))) return !1;
                    var i = r.modules[t1];
                    return i || (t1 && n.log("Unrecognized trace type " + t1 + "."), i = r.modules[c.type.dflt]), !!i.categories[e1];
                }, r.getTransformIndices = function(t1, e1) {
                    for(var r = [], n = t1.transforms || [], i = 0; i < n.length; i++)n[i].type === e1 && r.push(i);
                    return r;
                }, r.hasTransform = function(t1, e1) {
                    for(var r = t1.transforms || [], n = 0; n < r.length; n++)if (r[n].type === e1) return !0;
                    return !1;
                }, r.getComponentMethod = function(t1, e1) {
                    var n = r.componentsRegistry[t1];
                    return n && n[e1] || i;
                }, r.call = function() {
                    var t1 = arguments[0], e1 = [].slice.call(arguments, 1);
                    return r.apiMethodRegistry[t1].apply(null, e1);
                };
            },
            {
                "./lib/dom": 491,
                "./lib/extend": 493,
                "./lib/is_plain_object": 504,
                "./lib/loggers": 507,
                "./lib/noop": 512,
                "./lib/push_unique": 518,
                "./plots/attributes": 550,
                "./plots/layout_attributes": 610
            }
        ],
        639: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../registry"), i = t1("../lib"), a = i.extendFlat, o = i.extendDeep;
                function s(t1) {
                    var e1;
                    switch(t1){
                        case "themes__thumb":
                            e1 = {
                                autosize: !0,
                                width: 150,
                                height: 150,
                                title: {
                                    text: ""
                                },
                                showlegend: !1,
                                margin: {
                                    l: 5,
                                    r: 5,
                                    t: 5,
                                    b: 5,
                                    pad: 0
                                },
                                annotations: []
                            };
                            break;
                        case "thumbnail":
                            e1 = {
                                title: {
                                    text: ""
                                },
                                hidesources: !0,
                                showlegend: !1,
                                borderwidth: 0,
                                bordercolor: "",
                                margin: {
                                    l: 1,
                                    r: 1,
                                    t: 1,
                                    b: 1,
                                    pad: 0
                                },
                                annotations: []
                            };
                            break;
                        default:
                            e1 = {};
                    }
                    return e1;
                }
                e1.exports = function(t1, e1) {
                    var r, i, l = t1.data, c = t1.layout, u = o([], l), f = o({}, c, s(e1.tileClass)), h = t1._context || {};
                    if (e1.width && (f.width = e1.width), e1.height && (f.height = e1.height), "thumbnail" === e1.tileClass || "themes__thumb" === e1.tileClass) {
                        f.annotations = [];
                        var p = Object.keys(f);
                        for(r = 0; r < p.length; r++)i = p[r], [
                            "xaxis",
                            "yaxis",
                            "zaxis"
                        ].indexOf(i.slice(0, 5)) > -1 && (f[p[r]].title = {
                            text: ""
                        });
                        for(r = 0; r < u.length; r++){
                            var d = u[r];
                            d.showscale = !1, d.marker && (d.marker.showscale = !1), n.traceIs(d, "pie-like") && (d.textposition = "none");
                        }
                    }
                    if (Array.isArray(e1.annotations)) for(r = 0; r < e1.annotations.length; r++)f.annotations.push(e1.annotations[r]);
                    var m = Object.keys(f).filter(function(t1) {
                        return t1.match(/^scene\d*$/);
                    });
                    if (m.length) {
                        var g = {};
                        for("thumbnail" === e1.tileClass && (g = {
                            title: {
                                text: ""
                            },
                            showaxeslabels: !1,
                            showticklabels: !1,
                            linetickenable: !1
                        }), r = 0; r < m.length; r++){
                            var v = f[m[r]];
                            v.xaxis || (v.xaxis = {}), v.yaxis || (v.yaxis = {}), v.zaxis || (v.zaxis = {}), a(v.xaxis, g), a(v.yaxis, g), a(v.zaxis, g), v._scene = null;
                        }
                    }
                    var y = document.createElement("div");
                    e1.tileClass && (y.className = e1.tileClass);
                    var x = {
                        gd: y,
                        td: y,
                        layout: f,
                        data: u,
                        config: {
                            staticPlot: void 0 === e1.staticPlot || e1.staticPlot,
                            plotGlPixelRatio: void 0 === e1.plotGlPixelRatio ? 2 : e1.plotGlPixelRatio,
                            displaylogo: e1.displaylogo || !1,
                            showLink: e1.showLink || !1,
                            showTips: e1.showTips || !1,
                            mapboxAccessToken: h.mapboxAccessToken
                        }
                    };
                    return "transparent" !== e1.setBackground && (x.config.setBackground = e1.setBackground || "opaque"), x.gd.defaultLayout = s(e1.tileClass), x;
                };
            },
            {
                "../lib": 503,
                "../registry": 638
            }
        ],
        640: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = t1("../plot_api/to_image"), a = t1("./filesaver"), o = t1("./helpers");
                e1.exports = function(t1, e1) {
                    var r;
                    return n.isPlainObject(t1) || (r = n.getGraphDiv(t1)), (e1 = e1 || {}).format = e1.format || "png", e1.width = e1.width || null, e1.height = e1.height || null, e1.imageDataOnly = !0, new Promise(function(s, l) {
                        r && r._snapshotInProgress && l(new Error("Snapshotting already in progress.")), n.isIE() && "svg" !== e1.format && l(new Error(o.MSG_IE_BAD_FORMAT)), r && (r._snapshotInProgress = !0);
                        var c = i(t1, e1), u = e1.filename || t1.fn || "newplot";
                        u += "." + e1.format.replace("-", "."), c.then(function(t1) {
                            return r && (r._snapshotInProgress = !1), a(t1, u, e1.format);
                        }).then(function(t1) {
                            s(t1);
                        }).catch(function(t1) {
                            r && (r._snapshotInProgress = !1), l(t1);
                        });
                    });
                };
            },
            {
                "../lib": 503,
                "../plot_api/to_image": 546,
                "./filesaver": 641,
                "./helpers": 642
            }
        ],
        641: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = t1("./helpers");
                e1.exports = function(t1, e1, r) {
                    var a = document.createElement("a"), o = "download" in a;
                    return new Promise(function(s, l) {
                        var c, u;
                        if (n.isIE()) return c = i.createBlob(t1, "svg"), window.navigator.msSaveBlob(c, e1), c = null, s(e1);
                        if (o) return c = i.createBlob(t1, r), u = i.createObjectURL(c), a.href = u, a.download = e1, document.body.appendChild(a), a.click(), document.body.removeChild(a), i.revokeObjectURL(u), c = null, s(e1);
                        if (n.isSafari()) {
                            var f = "svg" === r ? "," : ";base64,";
                            return i.octetStream(f + encodeURIComponent(t1)), s(e1);
                        }
                        l(new Error("download error"));
                    });
                };
            },
            {
                "../lib": 503,
                "./helpers": 642
            }
        ],
        642: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../registry");
                r.getDelay = function(t1) {
                    return t1._has && (t1._has("gl3d") || t1._has("gl2d") || t1._has("mapbox")) ? 500 : 0;
                }, r.getRedrawFunc = function(t1) {
                    return function() {
                        n.getComponentMethod("colorbar", "draw")(t1);
                    };
                }, r.encodeSVG = function(t1) {
                    return "data:image/svg+xml," + encodeURIComponent(t1);
                }, r.encodeJSON = function(t1) {
                    return "data:application/json," + encodeURIComponent(t1);
                };
                var i = window.URL || window.webkitURL;
                r.createObjectURL = function(t1) {
                    return i.createObjectURL(t1);
                }, r.revokeObjectURL = function(t1) {
                    return i.revokeObjectURL(t1);
                }, r.createBlob = function(t1, e1) {
                    if ("svg" === e1) return new window.Blob([
                        t1
                    ], {
                        type: "image/svg+xml;charset=utf-8"
                    });
                    if ("full-json" === e1) return new window.Blob([
                        t1
                    ], {
                        type: "application/json;charset=utf-8"
                    });
                    var r = function(t1) {
                        for(var e1 = t1.length, r = new ArrayBuffer(e1), n = new Uint8Array(r), i = 0; i < e1; i++)n[i] = t1.charCodeAt(i);
                        return r;
                    }(window.atob(t1));
                    return new window.Blob([
                        r
                    ], {
                        type: "image/" + e1
                    });
                }, r.octetStream = function(t1) {
                    document.location.href = "data:application/octet-stream" + t1;
                }, r.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/, r.MSG_IE_BAD_FORMAT = "Sorry IE does not support downloading from canvas. Try {format:'svg'} instead.";
            },
            {
                "../registry": 638
            }
        ],
        643: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./helpers"), i = {
                    getDelay: n.getDelay,
                    getRedrawFunc: n.getRedrawFunc,
                    clone: t1("./cloneplot"),
                    toSVG: t1("./tosvg"),
                    svgToImg: t1("./svgtoimg"),
                    toImage: t1("./toimage"),
                    downloadImage: t1("./download")
                };
                e1.exports = i;
            },
            {
                "./cloneplot": 639,
                "./download": 640,
                "./helpers": 642,
                "./svgtoimg": 644,
                "./toimage": 645,
                "./tosvg": 646
            }
        ],
        644: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = t1("events").EventEmitter, a = t1("./helpers");
                e1.exports = function(t1) {
                    var e1 = t1.emitter || new i, r = new Promise(function(i, o) {
                        var s = window.Image, l = t1.svg, c = t1.format || "png";
                        if (n.isIE() && "svg" !== c) {
                            var u = new Error(a.MSG_IE_BAD_FORMAT);
                            return o(u), t1.promise ? r : e1.emit("error", u);
                        }
                        var f, h, p = t1.canvas, d = t1.scale || 1, m = t1.width || 300, g = t1.height || 150, v = d * m, y = d * g, x = p.getContext("2d"), b = new s;
                        "svg" === c || n.isSafari() ? h = a.encodeSVG(l) : (f = a.createBlob(l, "svg"), h = a.createObjectURL(f)), p.width = v, p.height = y, b.onload = function() {
                            var r;
                            switch(f = null, a.revokeObjectURL(h), "svg" !== c && x.drawImage(b, 0, 0, v, y), c){
                                case "jpeg":
                                    r = p.toDataURL("image/jpeg");
                                    break;
                                case "png":
                                    r = p.toDataURL("image/png");
                                    break;
                                case "webp":
                                    r = p.toDataURL("image/webp");
                                    break;
                                case "svg":
                                    r = h;
                                    break;
                                default:
                                    var n = "Image format is not jpeg, png, svg or webp.";
                                    if (o(new Error(n)), !t1.promise) return e1.emit("error", n);
                            }
                            i(r), t1.promise || e1.emit("success", r);
                        }, b.onerror = function(r) {
                            if (f = null, a.revokeObjectURL(h), o(r), !t1.promise) return e1.emit("error", r);
                        }, b.src = h;
                    });
                    return t1.promise ? r : e1;
                };
            },
            {
                "../lib": 503,
                "./helpers": 642,
                events: 84
            }
        ],
        645: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("events").EventEmitter, i = t1("../registry"), a = t1("../lib"), o = t1("./helpers"), s = t1("./cloneplot"), l = t1("./tosvg"), c = t1("./svgtoimg");
                e1.exports = function(t1, e1) {
                    var r = new n, u = s(t1, {
                        format: "png"
                    }), f = u.gd;
                    f.style.position = "absolute", f.style.left = "-5000px", document.body.appendChild(f);
                    var h = o.getRedrawFunc(f);
                    return i.call("_doPlot", f, u.data, u.layout, u.config).then(h).then(function() {
                        var t1 = o.getDelay(f._fullLayout);
                        setTimeout(function() {
                            var t1 = l(f), n = document.createElement("canvas");
                            n.id = a.randstr(), (r = c({
                                format: e1.format,
                                width: f._fullLayout.width,
                                height: f._fullLayout.height,
                                canvas: n,
                                emitter: r,
                                svg: t1
                            })).clean = function() {
                                f && document.body.removeChild(f);
                            };
                        }, t1);
                    }).catch(function(t1) {
                        r.emit("error", t1);
                    }), r;
                };
            },
            {
                "../lib": 503,
                "../registry": 638,
                "./cloneplot": 639,
                "./helpers": 642,
                "./svgtoimg": 644,
                "./tosvg": 646,
                events: 84
            }
        ],
        646: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../lib"), a = t1("../components/drawing"), o = t1("../components/color"), s = t1("../constants/xmlns_namespaces"), l = /"/g, c = new RegExp('("TOBESTRIPPED)|(TOBESTRIPPED")', "g");
                e1.exports = function(t1, e1, r) {
                    var u, f, h = t1._fullLayout, p = h._paper, d = h._toppaper, m = h.width, g = h.height;
                    p.insert("rect", ":first-child").call(a.setRect, 0, 0, m, g).call(o.fill, h.paper_bgcolor);
                    var v = h._basePlotModules || [];
                    for(u = 0; u < v.length; u++){
                        var y = v[u];
                        y.toSVG && y.toSVG(t1);
                    }
                    if (d) {
                        var x = d.node().childNodes, b = Array.prototype.slice.call(x);
                        for(u = 0; u < b.length; u++){
                            var _ = b[u];
                            _.childNodes.length && p.node().appendChild(_);
                        }
                    }
                    h._draggers && h._draggers.remove(), p.node().style.background = "", p.selectAll("text").attr({
                        "data-unformatted": null,
                        "data-math": null
                    }).each(function() {
                        var t1 = n.select(this);
                        if ("hidden" !== this.style.visibility && "none" !== this.style.display) {
                            t1.style({
                                visibility: null,
                                display: null
                            });
                            var e1 = this.style.fontFamily;
                            e1 && -1 !== e1.indexOf('"') && t1.style("font-family", e1.replace(l, "TOBESTRIPPED"));
                        } else t1.remove();
                    });
                    var w = [];
                    if (h._gradientUrlQueryParts) for(f in h._gradientUrlQueryParts)w.push(f);
                    if (h._patternUrlQueryParts) for(f in h._patternUrlQueryParts)w.push(f);
                    w.length && p.selectAll(w.join(",")).each(function() {
                        var t1 = n.select(this), e1 = this.style.fill;
                        e1 && -1 !== e1.indexOf("url(") && t1.style("fill", e1.replace(l, "TOBESTRIPPED"));
                        var r = this.style.stroke;
                        r && -1 !== r.indexOf("url(") && t1.style("stroke", r.replace(l, "TOBESTRIPPED"));
                    }), "pdf" !== e1 && "eps" !== e1 || p.selectAll("#MathJax_SVG_glyphs path").attr("stroke-width", 0), p.node().setAttributeNS(s.xmlns, "xmlns", s.svg), p.node().setAttributeNS(s.xmlns, "xmlns:xlink", s.xlink), "svg" === e1 && r && (p.attr("width", r * m), p.attr("height", r * g), p.attr("viewBox", "0 0 " + m + " " + g));
                    var T = (new window.XMLSerializer).serializeToString(p.node());
                    return T = function(t1) {
                        var e1 = n.select("body").append("div").style({
                            display: "none"
                        }).html(""), r = t1.replace(/(&[^;]*;)/gi, function(t1) {
                            return "&lt;" === t1 ? "&#60;" : "&rt;" === t1 ? "&#62;" : -1 !== t1.indexOf("<") || -1 !== t1.indexOf(">") ? "" : e1.html(t1).text();
                        });
                        return e1.remove(), r;
                    }(T), T = (T = T.replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, "&amp;")).replace(c, "'"), i.isIE() && (T = (T = (T = T.replace(/"/gi, "'")).replace(/(\('#)([^']*)('\))/gi, '("#$2")')).replace(/(\\')/gi, '"')), T;
                };
            },
            {
                "../components/color": 366,
                "../components/drawing": 388,
                "../constants/xmlns_namespaces": 480,
                "../lib": 503,
                "@plotly/d3": 58
            }
        ],
        647: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = function(t1, e1) {
                    for(var r = 0; r < t1.length; r++)t1[r].i = r;
                    n.mergeArray(e1.text, t1, "tx"), n.mergeArray(e1.hovertext, t1, "htx");
                    var i = e1.marker;
                    if (i) {
                        n.mergeArray(i.opacity, t1, "mo", !0), n.mergeArray(i.color, t1, "mc");
                        var a = i.line;
                        a && (n.mergeArray(a.color, t1, "mlc"), n.mergeArrayCastPositive(a.width, t1, "mlw"));
                    }
                };
            },
            {
                "../../lib": 503
            }
        ],
        648: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/attributes"), i = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, a = t1("../../plots/template_attributes").hovertemplateAttrs, o = t1("../../plots/template_attributes").texttemplateAttrs, s = t1("../../components/colorscale/attributes"), l = t1("../../plots/font_attributes"), c = t1("./constants"), u = t1("../../components/drawing/attributes").pattern, f = t1("../../lib/extend").extendFlat, h = l({
                    editType: "calc",
                    arrayOk: !0,
                    colorEditType: "style"
                }), p = f({}, n.marker.line.width, {
                    dflt: 0
                }), d = f({
                    width: p,
                    editType: "calc"
                }, s("marker.line")), m = f({
                    line: d,
                    editType: "calc"
                }, s("marker"), {
                    opacity: {
                        valType: "number",
                        arrayOk: !0,
                        dflt: 1,
                        min: 0,
                        max: 1,
                        editType: "style"
                    },
                    pattern: u
                });
                e1.exports = {
                    x: n.x,
                    x0: n.x0,
                    dx: n.dx,
                    y: n.y,
                    y0: n.y0,
                    dy: n.dy,
                    xperiod: n.xperiod,
                    yperiod: n.yperiod,
                    xperiod0: n.xperiod0,
                    yperiod0: n.yperiod0,
                    xperiodalignment: n.xperiodalignment,
                    yperiodalignment: n.yperiodalignment,
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    text: n.text,
                    texttemplate: o({
                        editType: "plot"
                    }, {
                        keys: c.eventDataKeys
                    }),
                    hovertext: n.hovertext,
                    hovertemplate: a({}, {
                        keys: c.eventDataKeys
                    }),
                    textposition: {
                        valType: "enumerated",
                        values: [
                            "inside",
                            "outside",
                            "auto",
                            "none"
                        ],
                        dflt: "auto",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    insidetextanchor: {
                        valType: "enumerated",
                        values: [
                            "end",
                            "middle",
                            "start"
                        ],
                        dflt: "end",
                        editType: "plot"
                    },
                    textangle: {
                        valType: "angle",
                        dflt: "auto",
                        editType: "plot"
                    },
                    textfont: f({}, h, {}),
                    insidetextfont: f({}, h, {}),
                    outsidetextfont: f({}, h, {}),
                    constraintext: {
                        valType: "enumerated",
                        values: [
                            "inside",
                            "outside",
                            "both",
                            "none"
                        ],
                        dflt: "both",
                        editType: "calc"
                    },
                    cliponaxis: f({}, n.cliponaxis, {}),
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        editType: "calc+clearAxisTypes"
                    },
                    base: {
                        valType: "any",
                        dflt: null,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    offset: {
                        valType: "number",
                        dflt: null,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    width: {
                        valType: "number",
                        dflt: null,
                        min: 0,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    marker: m,
                    offsetgroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    alignmentgroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    selected: {
                        marker: {
                            opacity: n.selected.marker.opacity,
                            color: n.selected.marker.color,
                            editType: "style"
                        },
                        textfont: n.selected.textfont,
                        editType: "style"
                    },
                    unselected: {
                        marker: {
                            opacity: n.unselected.marker.opacity,
                            color: n.unselected.marker.color,
                            editType: "style"
                        },
                        textfont: n.unselected.textfont,
                        editType: "style"
                    },
                    _deprecated: {
                        bardir: {
                            valType: "enumerated",
                            editType: "calc",
                            values: [
                                "v",
                                "h"
                            ]
                        }
                    }
                };
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../components/drawing/attributes": 387,
                "../../lib/extend": 493,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/font_attributes": 585,
                "../../plots/template_attributes": 633,
                "../scatter/attributes": 926,
                "./constants": 650
            }
        ],
        649: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes"), i = t1("../../plots/cartesian/align_period"), a = t1("../../components/colorscale/helpers").hasColorscale, o = t1("../../components/colorscale/calc"), s = t1("./arrays_to_calcdata"), l = t1("../scatter/calc_selection");
                e1.exports = function(t1, e1) {
                    var r, c, u, f, h, p, d = n.getFromId(t1, e1.xaxis || "x"), m = n.getFromId(t1, e1.yaxis || "y"), g = {
                        msUTC: !(!e1.base && 0 !== e1.base)
                    };
                    "h" === e1.orientation ? (r = d.makeCalcdata(e1, "x", g), u = m.makeCalcdata(e1, "y"), f = i(e1, m, "y", u), h = !!e1.yperiodalignment, p = "y") : (r = m.makeCalcdata(e1, "y", g), u = d.makeCalcdata(e1, "x"), f = i(e1, d, "x", u), h = !!e1.xperiodalignment, p = "x"), c = f.vals;
                    for(var v = Math.min(c.length, r.length), y = new Array(v), x = 0; x < v; x++)y[x] = {
                        p: c[x],
                        s: r[x]
                    }, h && (y[x].orig_p = u[x], y[x][p + "End"] = f.ends[x], y[x][p + "Start"] = f.starts[x]), e1.ids && (y[x].id = String(e1.ids[x]));
                    return a(e1, "marker") && o(t1, e1, {
                        vals: e1.marker.color,
                        containerStr: "marker",
                        cLetter: "c"
                    }), a(e1, "marker.line") && o(t1, e1, {
                        vals: e1.marker.line.color,
                        containerStr: "marker.line",
                        cLetter: "c"
                    }), s(y, e1), l(y, e1), y;
                };
            },
            {
                "../../components/colorscale/calc": 374,
                "../../components/colorscale/helpers": 377,
                "../../plots/cartesian/align_period": 551,
                "../../plots/cartesian/axes": 554,
                "../scatter/calc_selection": 928,
                "./arrays_to_calcdata": 647
            }
        ],
        650: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    TEXTPAD: 3,
                    eventDataKeys: [
                        "value",
                        "label"
                    ]
                };
            },
            {}
        ],
        651: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib").isArrayOrTypedArray, a = t1("../../constants/numerical").BADNUM, o = t1("../../registry"), s = t1("../../plots/cartesian/axes"), l = t1("../../plots/cartesian/constraints").getAxisGroup, c = t1("./sieve.js");
                function u(t1, e1, r, o, u) {
                    if (o.length) {
                        var b, _, w, T;
                        switch(function(t1, e1) {
                            var r, a;
                            for(r = 0; r < e1.length; r++){
                                var o, s = e1[r], l = s[0].trace, c = "funnel" === l.type ? l._base : l.base, u = "h" === l.orientation ? l.xcalendar : l.ycalendar, f = "category" === t1.type || "multicategory" === t1.type ? function() {
                                    return null;
                                } : t1.d2c;
                                if (i(c)) {
                                    for(a = 0; a < Math.min(c.length, s.length); a++)o = f(c[a], 0, u), n(o) ? (s[a].b = +o, s[a].hasB = 1) : s[a].b = 0;
                                    for(; a < s.length; a++)s[a].b = 0;
                                } else {
                                    o = f(c, 0, u);
                                    var h = n(o);
                                    for(o = h ? o : 0, a = 0; a < s.length; a++)s[a].b = o, h && (s[a].hasB = 1);
                                }
                            }
                        }(r, o), u.mode){
                            case "overlay":
                                f(e1, r, o, u);
                                break;
                            case "group":
                                for(b = [], _ = [], w = 0; w < o.length; w++)void 0 === (T = o[w])[0].trace.offset ? _.push(T) : b.push(T);
                                _.length && function(t1, e1, r, n, i) {
                                    var o = new c(n, {
                                        posAxis: e1,
                                        sepNegVal: !1,
                                        overlapNoMerge: !i.norm
                                    });
                                    (function(t1, e1, r, n) {
                                        for(var i = t1._fullLayout, a = r.positions, o = r.distinctPositions, s = r.minDiff, c = r.traces, u = c.length, f = a.length !== o.length, h = s * (1 - n.gap), g = l(i, e1._id) + c[0][0].trace.orientation, v = i._alignmentOpts[g] || {}, y = 0; y < u; y++){
                                            var x, b, _ = c[y], w = _[0].trace, T = v[w.alignmentgroup] || {}, k = Object.keys(T.offsetGroups || {}).length, A = (x = k ? h / k : f ? h / u : h) * (1 - (n.groupgap || 0));
                                            b = k ? ((2 * w._offsetIndex + 1 - k) * x - A) / 2 : f ? ((2 * y + 1 - u) * x - A) / 2 : -A / 2;
                                            var M = _[0].t;
                                            M.barwidth = A, M.poffset = b, M.bargroupwidth = h, M.bardelta = s;
                                        }
                                        r.binWidth = c[0][0].t.barwidth / 100, p(r), d(e1, r), m(e1, r, f);
                                    })(t1, e1, o, i), function(t1, e1) {
                                        for(var r = t1.traces, n = 0; n < r.length; n++){
                                            var i = r[n];
                                            if (void 0 === i[0].trace.base) for(var o = new c([
                                                i
                                            ], {
                                                posAxis: e1,
                                                sepNegVal: !0,
                                                overlapNoMerge: !0
                                            }), s = 0; s < i.length; s++){
                                                var l = i[s];
                                                if (l.p !== a) {
                                                    var u = o.put(l.p, l.b + l.s);
                                                    u && (l.b = u);
                                                }
                                            }
                                        }
                                    }(o, e1), i.norm ? (v(o), y(r, o, i)) : g(r, o);
                                }(t1, e1, r, _, u), b.length && f(e1, r, b, u);
                                break;
                            case "stack":
                            case "relative":
                                for(b = [], _ = [], w = 0; w < o.length; w++)void 0 === (T = o[w])[0].trace.base ? _.push(T) : b.push(T);
                                _.length && function(t1, e1, r, n, i) {
                                    var o = new c(n, {
                                        posAxis: e1,
                                        sepNegVal: "relative" === i.mode,
                                        overlapNoMerge: !(i.norm || "stack" === i.mode || "relative" === i.mode)
                                    });
                                    h(e1, o, i), function(t1, e1, r) {
                                        var n, i, o, l, c, u, f = x(t1), h = e1.traces;
                                        for(l = 0; l < h.length; l++)if (n = h[l], "funnel" === (i = n[0].trace).type) for(c = 0; c < n.length; c++)(u = n[c]).s !== a && e1.put(u.p, -0.5 * u.s);
                                        for(l = 0; l < h.length; l++){
                                            n = h[l], i = n[0].trace, o = "funnel" === i.type;
                                            var p = [];
                                            for(c = 0; c < n.length; c++)if ((u = n[c]).s !== a) {
                                                var d;
                                                d = o ? u.s : u.s + u.b;
                                                var m = e1.put(u.p, d), g = m + d;
                                                u.b = m, u[f] = g, r.norm || (p.push(g), u.hasB && p.push(m));
                                            }
                                            r.norm || (i._extremes[t1._id] = s.findExtremes(t1, p, {
                                                tozero: !0,
                                                padded: !0
                                            }));
                                        }
                                    }(r, o, i);
                                    for(var l = 0; l < n.length; l++)for(var u = n[l], f = 0; f < u.length; f++){
                                        var p = u[f];
                                        if (p.s !== a) p.b + p.s === o.get(p.p, p.s) && (p._outmost = !0);
                                    }
                                    i.norm && y(r, o, i);
                                }(0, e1, r, _, u), b.length && f(e1, r, b, u);
                        }
                        !function(t1, e1) {
                            var r, i, a, o = x(e1), s = {}, l = 1 / 0, c = -1 / 0;
                            for(r = 0; r < t1.length; r++)for(a = t1[r], i = 0; i < a.length; i++){
                                var u = a[i].p;
                                n(u) && (l = Math.min(l, u), c = Math.max(c, u));
                            }
                            var f = 1e4 / (c - l), h = s.round = function(t1) {
                                return String(Math.round(f * (t1 - l)));
                            };
                            for(r = 0; r < t1.length; r++){
                                (a = t1[r])[0].t.extents = s;
                                var p = a[0].t.poffset, d = Array.isArray(p);
                                for(i = 0; i < a.length; i++){
                                    var m = a[i], g = m[o] - m.w / 2;
                                    if (n(g)) {
                                        var v = m[o] + m.w / 2, y = h(m.p);
                                        s[y] ? s[y] = [
                                            Math.min(g, s[y][0]),
                                            Math.max(v, s[y][1])
                                        ] : s[y] = [
                                            g,
                                            v
                                        ];
                                    }
                                    m.p0 = m.p + (d ? p[i] : p), m.p1 = m.p0 + m.w, m.s0 = m.b, m.s1 = m.s0 + m.s;
                                }
                            }
                        }(o, e1);
                    }
                }
                function f(t1, e1, r, n) {
                    for(var i = 0; i < r.length; i++){
                        var a = r[i], o = new c([
                            a
                        ], {
                            posAxis: t1,
                            sepNegVal: !1,
                            overlapNoMerge: !n.norm
                        });
                        h(t1, o, n), n.norm ? (v(o), y(e1, o, n)) : g(e1, o);
                    }
                }
                function h(t1, e1, r) {
                    for(var n = e1.minDiff, i = e1.traces, a = n * (1 - r.gap), o = a * (1 - (r.groupgap || 0)), s = -o / 2, l = 0; l < i.length; l++){
                        var c = i[l][0].t;
                        c.barwidth = o, c.poffset = s, c.bargroupwidth = a, c.bardelta = n;
                    }
                    e1.binWidth = i[0][0].t.barwidth / 100, p(e1), d(t1, e1), m(t1, e1);
                }
                function p(t1) {
                    var e1, r, a = t1.traces;
                    for(e1 = 0; e1 < a.length; e1++){
                        var o, s = a[e1], l = s[0], c = l.trace, u = l.t, f = c._offset || c.offset, h = u.poffset;
                        if (i(f)) {
                            for(o = Array.prototype.slice.call(f, 0, s.length), r = 0; r < o.length; r++)n(o[r]) || (o[r] = h);
                            for(r = o.length; r < s.length; r++)o.push(h);
                            u.poffset = o;
                        } else void 0 !== f && (u.poffset = f);
                        var p = c._width || c.width, d = u.barwidth;
                        if (i(p)) {
                            var m = Array.prototype.slice.call(p, 0, s.length);
                            for(r = 0; r < m.length; r++)n(m[r]) || (m[r] = d);
                            for(r = m.length; r < s.length; r++)m.push(d);
                            if (u.barwidth = m, void 0 === f) {
                                for(o = [], r = 0; r < s.length; r++)o.push(h + (d - m[r]) / 2);
                                u.poffset = o;
                            }
                        } else void 0 !== p && (u.barwidth = p, void 0 === f && (u.poffset = h + (d - p) / 2));
                    }
                }
                function d(t1, e1) {
                    for(var r = e1.traces, n = x(t1), i = 0; i < r.length; i++)for(var a = r[i], o = a[0].t, s = o.poffset, l = Array.isArray(s), c = o.barwidth, u = Array.isArray(c), f = 0; f < a.length; f++){
                        var h = a[f], p = h.w = u ? c[f] : c;
                        h[n] = h.p + (l ? s[f] : s) + p / 2;
                    }
                }
                function m(t1, e1, r) {
                    var n = e1.traces, i = e1.minDiff / 2;
                    s.minDtick(t1, e1.minDiff, e1.distinctPositions[0], r);
                    for(var a = 0; a < n.length; a++){
                        var o, l, c, u, f = n[a], h = f[0], p = h.trace, d = [];
                        for(u = 0; u < f.length; u++)l = (o = f[u]).p - i, c = o.p + i, d.push(l, c);
                        if (p.width || p.offset) {
                            var m = h.t, g = m.poffset, v = m.barwidth, y = Array.isArray(g), x = Array.isArray(v);
                            for(u = 0; u < f.length; u++){
                                o = f[u];
                                var b = y ? g[u] : g, _ = x ? v[u] : v;
                                c = (l = o.p + b) + _, d.push(l, c);
                            }
                        }
                        p._extremes[t1._id] = s.findExtremes(t1, d, {
                            padded: !1
                        });
                    }
                }
                function g(t1, e1) {
                    for(var r = e1.traces, n = x(t1), i = 0; i < r.length; i++){
                        for(var a = r[i], o = a[0].trace, l = [], c = !1, u = 0; u < a.length; u++){
                            var f = a[u], h = f.b, p = h + f.s;
                            f[n] = p, l.push(p), f.hasB && l.push(h), f.hasB && f.b || (c = !0);
                        }
                        o._extremes[t1._id] = s.findExtremes(t1, l, {
                            tozero: c,
                            padded: !0
                        });
                    }
                }
                function v(t1) {
                    for(var e1 = t1.traces, r = 0; r < e1.length; r++)for(var n = e1[r], i = 0; i < n.length; i++){
                        var o = n[i];
                        o.s !== a && t1.put(o.p, o.b + o.s);
                    }
                }
                function y(t1, e1, r) {
                    var i = e1.traces, o = x(t1), l = "fraction" === r.norm ? 1 : 100, c = l / 1e9, u = t1.l2c(t1.c2l(0)), f = "stack" === r.mode ? l : u;
                    function h(e1) {
                        return n(t1.c2l(e1)) && (e1 < u - c || e1 > f + c || !n(u));
                    }
                    for(var p = 0; p < i.length; p++){
                        for(var d = i[p], m = d[0].trace, g = [], v = !1, y = !1, b = 0; b < d.length; b++){
                            var _ = d[b];
                            if (_.s !== a) {
                                var w = Math.abs(l / e1.get(_.p, _.s));
                                _.b *= w, _.s *= w;
                                var T = _.b, k = T + _.s;
                                _[o] = k, g.push(k), y = y || h(k), _.hasB && (g.push(T), y = y || h(T)), _.hasB && _.b || (v = !0);
                            }
                        }
                        m._extremes[t1._id] = s.findExtremes(t1, g, {
                            tozero: v,
                            padded: y
                        });
                    }
                }
                function x(t1) {
                    return t1._id.charAt(0);
                }
                e1.exports = {
                    crossTraceCalc: function(t1, e1) {
                        for(var r = e1.xaxis, n = e1.yaxis, i = t1._fullLayout, a = t1._fullData, s = t1.calcdata, l = [], c = [], f = 0; f < a.length; f++){
                            var h = a[f];
                            if (!0 === h.visible && o.traceIs(h, "bar") && h.xaxis === r._id && h.yaxis === n._id && ("h" === h.orientation ? l.push(s[f]) : c.push(s[f]), h._computePh)) for(var p = t1.calcdata[f], d = 0; d < p.length; d++)"function" == typeof p[d].ph0 && (p[d].ph0 = p[d].ph0()), "function" == typeof p[d].ph1 && (p[d].ph1 = p[d].ph1());
                        }
                        var m = {
                            xCat: "category" === r.type || "multicategory" === r.type,
                            yCat: "category" === n.type || "multicategory" === n.type,
                            mode: i.barmode,
                            norm: i.barnorm,
                            gap: i.bargap,
                            groupgap: i.bargroupgap
                        };
                        u(t1, r, n, c, m), u(t1, n, r, l, m);
                    },
                    setGroupPositions: u
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "../../plots/cartesian/constraints": 562,
                "../../registry": 638,
                "./sieve.js": 661,
                "fast-isnumeric": 190
            }
        ],
        652: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/color"), a = t1("../../registry"), o = t1("../scatter/xy_defaults"), s = t1("../scatter/period_defaults"), l = t1("./style_defaults"), c = t1("../../plots/cartesian/constraints").getAxisGroup, u = t1("./attributes"), f = n.coerceFont;
                function h(t1, e1, r, n) {
                    var i = e1.orientation, a = e1[({
                        v: "x",
                        h: "y"
                    })[i] + "axis"], o = c(r, a) + i, s = r._alignmentOpts || {}, l = n("alignmentgroup"), u = s[o];
                    u || (u = s[o] = {});
                    var f = u[l];
                    f ? f.traces.push(e1) : f = u[l] = {
                        traces: [
                            e1
                        ],
                        alignmentIndex: Object.keys(u).length,
                        offsetGroups: {}
                    };
                    var h = n("offsetgroup"), p = f.offsetGroups, d = p[h];
                    h && (d || (d = p[h] = {
                        offsetIndex: Object.keys(p).length
                    }), e1._offsetIndex = d.offsetIndex);
                }
                function p(t1, e1, r, i, a, o) {
                    var s = !(!1 === (o = o || {}).moduleHasSelected), l = !(!1 === o.moduleHasUnselected), c = !(!1 === o.moduleHasConstrain), u = !(!1 === o.moduleHasCliponaxis), h = !(!1 === o.moduleHasTextangle), p = !(!1 === o.moduleHasInsideanchor), d = !!o.hasPathbar, m = Array.isArray(a) || "auto" === a, g = m || "inside" === a, v = m || "outside" === a;
                    if (g || v) {
                        var y = f(i, "textfont", r.font), x = n.extendFlat({}, y), b = !(t1.textfont && t1.textfont.color);
                        if (b && delete x.color, f(i, "insidetextfont", x), d) {
                            var _ = n.extendFlat({}, y);
                            b && delete _.color, f(i, "pathbar.textfont", _);
                        }
                        v && f(i, "outsidetextfont", y), s && i("selected.textfont.color"), l && i("unselected.textfont.color"), c && i("constraintext"), u && i("cliponaxis"), h && i("textangle"), i("texttemplate");
                    }
                    g && p && i("insidetextanchor");
                }
                e1.exports = {
                    supplyDefaults: function(t1, e1, r, c) {
                        function f(r, i) {
                            return n.coerce(t1, e1, u, r, i);
                        }
                        if (o(t1, e1, c, f)) {
                            s(t1, e1, c, f), f("xhoverformat"), f("yhoverformat"), f("orientation", e1.x && !e1.y ? "h" : "v"), f("base"), f("offset"), f("width"), f("text"), f("hovertext"), f("hovertemplate");
                            var h = f("textposition");
                            p(t1, e1, c, f, h, {
                                moduleHasSelected: !0,
                                moduleHasUnselected: !0,
                                moduleHasConstrain: !0,
                                moduleHasCliponaxis: !0,
                                moduleHasTextangle: !0,
                                moduleHasInsideanchor: !0
                            }), l(t1, e1, f, r, c);
                            var d = (e1.marker.line || {}).color, m = a.getComponentMethod("errorbars", "supplyDefaults");
                            m(t1, e1, d || i.defaultLine, {
                                axis: "y"
                            }), m(t1, e1, d || i.defaultLine, {
                                axis: "x",
                                inherit: "y"
                            }), n.coerceSelectionMarkerOpacity(e1, f);
                        } else e1.visible = !1;
                    },
                    crossTraceDefaults: function(t1, e1) {
                        var r;
                        function i(t1) {
                            return n.coerce(r._input, r, u, t1);
                        }
                        if ("group" === e1.barmode) for(var a = 0; a < t1.length; a++)"bar" === (r = t1[a]).type && (r._input, h(0, r, e1, i));
                    },
                    handleGroupingDefaults: h,
                    handleText: p
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../../plots/cartesian/constraints": 562,
                "../../registry": 638,
                "../scatter/period_defaults": 946,
                "../scatter/xy_defaults": 953,
                "./attributes": 648,
                "./style_defaults": 663
            }
        ],
        653: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r) {
                    return t1.x = "xVal" in e1 ? e1.xVal : e1.x, t1.y = "yVal" in e1 ? e1.yVal : e1.y, e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), "h" === r.orientation ? (t1.label = t1.y, t1.value = t1.x) : (t1.label = t1.x, t1.value = t1.y), t1;
                };
            },
            {}
        ],
        654: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("tinycolor2"), a = t1("../../lib").isArrayOrTypedArray;
                r.coerceString = function(t1, e1, r) {
                    if ("string" == typeof e1) {
                        if (e1 || !t1.noBlank) return e1;
                    } else if (("number" == typeof e1 || !0 === e1) && !t1.strict) return String(e1);
                    return void 0 !== r ? r : t1.dflt;
                }, r.coerceNumber = function(t1, e1, r) {
                    if (n(e1)) {
                        e1 = +e1;
                        var i = t1.min, a = t1.max;
                        if (!(void 0 !== i && e1 < i || void 0 !== a && e1 > a)) return e1;
                    }
                    return void 0 !== r ? r : t1.dflt;
                }, r.coerceColor = function(t1, e1, r) {
                    return i(e1).isValid() ? e1 : void 0 !== r ? r : t1.dflt;
                }, r.coerceEnumerated = function(t1, e1, r) {
                    return t1.coerceNumber && (e1 = +e1), -1 !== t1.values.indexOf(e1) ? e1 : void 0 !== r ? r : t1.dflt;
                }, r.getValue = function(t1, e1) {
                    var r;
                    return Array.isArray(t1) ? e1 < t1.length && (r = t1[e1]) : r = t1, r;
                }, r.getLineWidth = function(t1, e1) {
                    return 0 < e1.mlw ? e1.mlw : a(t1.marker.line.width) ? 0 : t1.marker.line.width;
                };
            },
            {
                "../../lib": 503,
                "fast-isnumeric": 190,
                tinycolor2: 312
            }
        ],
        655: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/fx"), i = t1("../../registry"), a = t1("../../components/color"), o = t1("../../lib").fillText, s = t1("./helpers").getLineWidth, l = t1("../../plots/cartesian/axes").hoverLabelText, c = t1("../../constants/numerical").BADNUM;
                function u(t1, e1, r, i, a) {
                    var s, u, f, h, p, d, m, g = t1.cd, v = g[0].trace, y = g[0].t, x = "closest" === i, b = "waterfall" === v.type, _ = t1.maxHoverDistance, w = t1.maxSpikeDistance;
                    "h" === v.orientation ? (s = r, u = e1, f = "y", h = "x", p = z, d = I) : (s = e1, u = r, f = "x", h = "y", d = z, p = I);
                    var T = v[f + "period"], k = x || T;
                    function A(t1) {
                        return S(t1, -1);
                    }
                    function M(t1) {
                        return S(t1, 1);
                    }
                    function S(t1, e1) {
                        var r = t1.w;
                        return t1[f] + e1 * r / 2;
                    }
                    function E(t1) {
                        return t1[f + "End"] - t1[f + "Start"];
                    }
                    var L = x ? A : T ? function(t1) {
                        return t1.p - E(t1) / 2;
                    } : function(t1) {
                        return Math.min(A(t1), t1.p - y.bardelta / 2);
                    }, C = x ? M : T ? function(t1) {
                        return t1.p + E(t1) / 2;
                    } : function(t1) {
                        return Math.max(M(t1), t1.p + y.bardelta / 2);
                    };
                    function P(t1, e1, r) {
                        return a.finiteRange && (r = 0), n.inbox(t1 - s, e1 - s, r + Math.min(1, Math.abs(e1 - t1) / m) - 1);
                    }
                    function I(t1) {
                        return P(L(t1), C(t1), _);
                    }
                    function O(t1) {
                        var e1 = t1[h];
                        if (b) {
                            var r = Math.abs(t1.rawS) || 0;
                            u > 0 ? e1 += r : u < 0 && (e1 -= r);
                        }
                        return e1;
                    }
                    function z(t1) {
                        var e1 = u, r = t1.b, i = O(t1);
                        return n.inbox(r - e1, i - e1, _ + (i - e1) / (i - r) - 1);
                    }
                    var D = t1[f + "a"], R = t1[h + "a"];
                    m = Math.abs(D.r2c(D.range[1]) - D.r2c(D.range[0]));
                    var F = n.getDistanceFunction(i, p, d, function(t1) {
                        return (p(t1) + d(t1)) / 2;
                    });
                    if (n.getClosest(g, F, t1), !1 !== t1.index && g[t1.index].p !== c) {
                        k || (L = function(t1) {
                            return Math.min(A(t1), t1.p - y.bargroupwidth / 2);
                        }, C = function(t1) {
                            return Math.max(M(t1), t1.p + y.bargroupwidth / 2);
                        });
                        var B = g[t1.index], N = v.base ? B.b + B.s : B.s;
                        t1[h + "0"] = t1[h + "1"] = R.c2p(B[h], !0), t1[h + "LabelVal"] = N;
                        var j = y.extents[y.extents.round(B.p)];
                        t1[f + "0"] = D.c2p(x ? L(B) : j[0], !0), t1[f + "1"] = D.c2p(x ? C(B) : j[1], !0);
                        var U = void 0 !== B.orig_p;
                        return t1[f + "LabelVal"] = U ? B.orig_p : B.p, t1.labelLabel = l(D, t1[f + "LabelVal"], v[f + "hoverformat"]), t1.valueLabel = l(R, t1[h + "LabelVal"], v[h + "hoverformat"]), t1.baseLabel = l(R, B.b, v[h + "hoverformat"]), t1.spikeDistance = (function(t1) {
                            var e1 = u, r = t1.b, i = O(t1);
                            return n.inbox(r - e1, i - e1, w + (i - e1) / (i - r) - 1);
                        }(B) + function(t1) {
                            return P(A(t1), M(t1), w);
                        }(B)) / 2, t1[f + "Spike"] = D.c2p(B.p, !0), o(B, v, t1), t1.hovertemplate = v.hovertemplate, t1;
                    }
                }
                function f(t1, e1) {
                    var r = e1.mcc || t1.marker.color, n = e1.mlcc || t1.marker.line.color, i = s(t1, e1);
                    return a.opacity(r) ? r : a.opacity(n) && i ? n : void 0;
                }
                e1.exports = {
                    hoverPoints: function(t1, e1, r, n, a) {
                        var o = u(t1, e1, r, n, a);
                        if (o) {
                            var s = o.cd, l = s[0].trace, c = s[o.index];
                            return o.color = f(l, c), i.getComponentMethod("errorbars", "hoverInfo")(c, l, o), [
                                o
                            ];
                        }
                    },
                    hoverOnBars: u,
                    getTraceColor: f
                };
            },
            {
                "../../components/color": 366,
                "../../components/fx": 406,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "../../registry": 638,
                "./helpers": 654
            }
        ],
        656: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("./layout_attributes"),
                    supplyDefaults: t1("./defaults").supplyDefaults,
                    crossTraceDefaults: t1("./defaults").crossTraceDefaults,
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    calc: t1("./calc"),
                    crossTraceCalc: t1("./cross_trace_calc").crossTraceCalc,
                    colorbar: t1("../scatter/marker_colorbar"),
                    arraysToCalcdata: t1("./arrays_to_calcdata"),
                    plot: t1("./plot").plot,
                    style: t1("./style").style,
                    styleOnSelect: t1("./style").styleOnSelect,
                    hoverPoints: t1("./hover").hoverPoints,
                    eventData: t1("./event_data"),
                    selectPoints: t1("./select"),
                    moduleType: "trace",
                    name: "bar",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "bar-like",
                        "cartesian",
                        "svg",
                        "bar",
                        "oriented",
                        "errorBarsOK",
                        "showLegend",
                        "zoomScale"
                    ],
                    animatable: !0,
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "../scatter/marker_colorbar": 944,
                "./arrays_to_calcdata": 647,
                "./attributes": 648,
                "./calc": 649,
                "./cross_trace_calc": 651,
                "./defaults": 652,
                "./event_data": 653,
                "./hover": 655,
                "./layout_attributes": 657,
                "./layout_defaults": 658,
                "./plot": 659,
                "./select": 660,
                "./style": 662
            }
        ],
        657: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    barmode: {
                        valType: "enumerated",
                        values: [
                            "stack",
                            "group",
                            "overlay",
                            "relative"
                        ],
                        dflt: "group",
                        editType: "calc"
                    },
                    barnorm: {
                        valType: "enumerated",
                        values: [
                            "",
                            "fraction",
                            "percent"
                        ],
                        dflt: "",
                        editType: "calc"
                    },
                    bargap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "calc"
                    },
                    bargroupgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "calc"
                    }
                };
            },
            {}
        ],
        658: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../plots/cartesian/axes"), a = t1("../../lib"), o = t1("./layout_attributes");
                e1.exports = function(t1, e1, r) {
                    function s(r, n) {
                        return a.coerce(t1, e1, o, r, n);
                    }
                    for(var l = !1, c = !1, u = !1, f = {}, h = s("barmode"), p = 0; p < r.length; p++){
                        var d = r[p];
                        if (n.traceIs(d, "bar") && d.visible) {
                            if (l = !0, "group" === h) {
                                var m = d.xaxis + d.yaxis;
                                f[m] && (u = !0), f[m] = !0;
                            }
                            if (d.visible && "histogram" === d.type) "category" !== i.getFromId({
                                _fullLayout: e1
                            }, d["v" === d.orientation ? "xaxis" : "yaxis"]).type && (c = !0);
                        }
                    }
                    l ? ("overlay" !== h && s("barnorm"), s("bargap", c && !u ? 0 : .2), s("bargroupgap")) : delete e1.barmode;
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "../../registry": 638,
                "./layout_attributes": 657
            }
        ],
        659: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("fast-isnumeric"), a = t1("../../lib"), o = t1("../../lib/svg_text_utils"), s = t1("../../components/color"), l = t1("../../components/drawing"), c = t1("../../registry"), u = t1("../../plots/cartesian/axes").tickText, f = t1("./uniform_text"), h = f.recordMinTextSize, p = f.clearMinTextSize, d = t1("./style"), m = t1("./helpers"), g = t1("./constants"), v = t1("./attributes"), y = v.text, x = v.textposition, b = t1("../../components/fx/helpers").appendArrayPointValue, _ = g.TEXTPAD;
                function w(t1) {
                    return t1.id;
                }
                function T(t1) {
                    if (t1.ids) return w;
                }
                function k(t1, e1) {
                    return t1 < e1 ? 1 : -1;
                }
                function A(t1, e1, r, n) {
                    var i;
                    return !e1.uniformtext.mode && M(r) ? (n && (i = n()), t1.transition().duration(r.duration).ease(r.easing).each("end", function() {
                        i && i();
                    }).each("interrupt", function() {
                        i && i();
                    })) : t1;
                }
                function M(t1) {
                    return t1 && t1.duration > 0;
                }
                function S(t1) {
                    return "auto" === t1 ? 0 : t1;
                }
                function E(t1, e1) {
                    var r = Math.PI / 180 * e1, n = Math.abs(Math.sin(r)), i = Math.abs(Math.cos(r));
                    return {
                        x: t1.width * i + t1.height * n,
                        y: t1.width * n + t1.height * i
                    };
                }
                function L(t1, e1, r, n, i, a) {
                    var o = !!a.isHorizontal, s = !!a.constrained, l = a.angle || 0, c = a.anchor || "end", u = "end" === c, f = "start" === c, h = ((a.leftToRight || 0) + 1) / 2, p = 1 - h, d = i.width, m = i.height, g = Math.abs(e1 - t1), v = Math.abs(n - r), y = g > 2 * _ && v > 2 * _ ? _ : 0;
                    g -= 2 * y, v -= 2 * y;
                    var x = S(l);
                    "auto" !== l || d <= g && m <= v || !(d > g || m > v) || (d > v || m > g) && d < m == g < v || (x += 90);
                    var b = E(i, x), w = 1;
                    s && (w = Math.min(1, g / b.x, v / b.y));
                    var T = i.left * p + i.right * h, A = (i.top + i.bottom) / 2, M = (t1 + _) * p + (e1 - _) * h, L = (r + n) / 2, C = 0, P = 0;
                    if (f || u) {
                        var I = (o ? b.x : b.y) / 2, O = o ? k(t1, e1) : k(r, n);
                        o ? f ? (M = t1 + O * y, C = -O * I) : (M = e1 - O * y, C = O * I) : f ? (L = r + O * y, P = -O * I) : (L = n - O * y, P = O * I);
                    }
                    return {
                        textX: T,
                        textY: A,
                        targetX: M,
                        targetY: L,
                        anchorX: C,
                        anchorY: P,
                        scale: w,
                        rotate: x
                    };
                }
                e1.exports = {
                    plot: function(t1, e1, r, f, g, v) {
                        var w = e1.xaxis, C = e1.yaxis, P = t1._fullLayout;
                        g || (g = {
                            mode: P.barmode,
                            norm: P.barmode,
                            gap: P.bargap,
                            groupgap: P.bargroupgap
                        }, p("bar", P));
                        var I = a.makeTraceGroups(f, r, "trace bars").each(function(r) {
                            var c = n.select(this), f = r[0].trace, p = "waterfall" === f.type, I = "funnel" === f.type, O = "bar" === f.type || I, z = 0;
                            p && f.connector.visible && "between" === f.connector.mode && (z = f.connector.line.width / 2);
                            var D = "h" === f.orientation, R = M(g), F = a.ensureSingle(c, "g", "points"), B = T(f), N = F.selectAll("g.point").data(a.identity, B);
                            N.enter().append("g").classed("point", !0), N.exit().remove(), N.each(function(c, p) {
                                var T, M, I = n.select(this), F = function(t1, e1, r, n) {
                                    var i = [], a = [], o = n ? e1 : r, s = n ? r : e1;
                                    return i[0] = o.c2p(t1.s0, !0), a[0] = s.c2p(t1.p0, !0), i[1] = o.c2p(t1.s1, !0), a[1] = s.c2p(t1.p1, !0), n ? [
                                        i,
                                        a
                                    ] : [
                                        a,
                                        i
                                    ];
                                }(c, w, C, D), B = F[0][0], N = F[0][1], j = F[1][0], U = F[1][1], V = 0 == (D ? N - B : U - j);
                                if (V && O && m.getLineWidth(f, c) && (V = !1), V || (V = !(i(B) && i(N) && i(j) && i(U))), c.isBlank = V, V && (D ? N = B : U = j), z && !V && (D ? (B -= k(B, N) * z, N += k(B, N) * z) : (j -= k(j, U) * z, U += k(j, U) * z)), "waterfall" === f.type) {
                                    if (!V) {
                                        var H = f[c.dir].marker;
                                        T = H.line.width, M = H.color;
                                    }
                                } else T = m.getLineWidth(f, c), M = c.mc || f.marker.color;
                                function q(t1) {
                                    var e1 = n.round(T / 2 % 1, 2);
                                    return 0 === g.gap && 0 === g.groupgap ? n.round(Math.round(t1) - e1, 2) : t1;
                                }
                                if (!t1._context.staticPlot) {
                                    var G = s.opacity(M) < 1 || T > .01 ? q : function(t1, e1, r) {
                                        return r && t1 === e1 ? t1 : Math.abs(t1 - e1) >= 2 ? q(t1) : t1 > e1 ? Math.ceil(t1) : Math.floor(t1);
                                    };
                                    B = G(B, N, D), N = G(N, B, D), j = G(j, U, !D), U = G(U, j, !D);
                                }
                                var Y = A(a.ensureSingle(I, "path"), P, g, v);
                                if (Y.style("vector-effect", "non-scaling-stroke").attr("d", isNaN((N - B) * (U - j)) || V && t1._context.staticPlot ? "M0,0Z" : "M" + B + "," + j + "V" + U + "H" + N + "V" + j + "Z").call(l.setClipUrl, e1.layerClipId, t1), !P.uniformtext.mode && R) {
                                    var W = l.makePointStyleFns(f);
                                    l.singlePointStyle(c, Y, f, W, t1);
                                }
                                !function(t1, e1, r, n, i, s, c, f, p, g, v) {
                                    var w, T = e1.xaxis, M = e1.yaxis, C = t1._fullLayout;
                                    function P(e1, r, n) {
                                        return a.ensureSingle(e1, "text").text(r).attr({
                                            class: "bartext bartext-" + w,
                                            "text-anchor": "middle",
                                            "data-notex": 1
                                        }).call(l.font, n).call(o.convertToTspans, t1);
                                    }
                                    var I = n[0].trace, O = "h" === I.orientation, z = function(t1, e1, r, n, i) {
                                        var o, s = e1[0].trace;
                                        o = s.texttemplate ? function(t1, e1, r, n, i) {
                                            var o = e1[0].trace, s = a.castOption(o, r, "texttemplate");
                                            if (!s) return "";
                                            var l, c, f, h, p = "waterfall" === o.type, d = "funnel" === o.type;
                                            "h" === o.orientation ? (l = "y", c = i, f = "x", h = n) : (l = "x", c = n, f = "y", h = i);
                                            function m(t1) {
                                                return u(h, h.c2l(t1), !0).text;
                                            }
                                            var g = e1[r], v = {};
                                            v.label = g.p, v.labelLabel = v[l + "Label"] = (y = g.p, u(c, c.c2l(y), !0).text);
                                            var y;
                                            var x = a.castOption(o, g.i, "text");
                                            (0 === x || x) && (v.text = x);
                                            v.value = g.s, v.valueLabel = v[f + "Label"] = m(g.s);
                                            var _ = {};
                                            b(_, o, g.i), p && (v.delta = +g.rawS || g.s, v.deltaLabel = m(v.delta), v.final = g.v, v.finalLabel = m(v.final), v.initial = v.final - v.delta, v.initialLabel = m(v.initial));
                                            d && (v.value = g.s, v.valueLabel = m(v.value), v.percentInitial = g.begR, v.percentInitialLabel = a.formatPercent(g.begR), v.percentPrevious = g.difR, v.percentPreviousLabel = a.formatPercent(g.difR), v.percentTotal = g.sumR, v.percenTotalLabel = a.formatPercent(g.sumR));
                                            var w = a.castOption(o, g.i, "customdata");
                                            w && (v.customdata = w);
                                            return a.texttemplateString(s, v, t1._d3locale, _, v, o._meta || {});
                                        }(t1, e1, r, n, i) : s.textinfo ? function(t1, e1, r, n) {
                                            var i = t1[0].trace, o = "h" === i.orientation, s = "waterfall" === i.type, l = "funnel" === i.type;
                                            function c(t1) {
                                                return u(o ? r : n, +t1, !0).text;
                                            }
                                            var f, h = i.textinfo, p = t1[e1], d = h.split("+"), m = [], g = function(t1) {
                                                return -1 !== d.indexOf(t1);
                                            };
                                            g("label") && m.push((v = t1[e1].p, u(o ? n : r, v, !0).text));
                                            var v;
                                            g("text") && (0 === (f = a.castOption(i, p.i, "text")) || f) && m.push(f);
                                            if (s) {
                                                var y = +p.rawS || p.s, x = p.v, b = x - y;
                                                g("initial") && m.push(c(b)), g("delta") && m.push(c(y)), g("final") && m.push(c(x));
                                            }
                                            if (l) {
                                                g("value") && m.push(c(p.s));
                                                var _ = 0;
                                                g("percent initial") && _++, g("percent previous") && _++, g("percent total") && _++;
                                                var w = _ > 1;
                                                g("percent initial") && (f = a.formatPercent(p.begR), w && (f += " of initial"), m.push(f)), g("percent previous") && (f = a.formatPercent(p.difR), w && (f += " of previous"), m.push(f)), g("percent total") && (f = a.formatPercent(p.sumR), w && (f += " of total"), m.push(f));
                                            }
                                            return m.join("<br>");
                                        }(e1, r, n, i) : m.getValue(s.text, r);
                                        return m.coerceString(y, o);
                                    }(C, n, i, T, M);
                                    w = function(t1, e1) {
                                        var r = m.getValue(t1.textposition, e1);
                                        return m.coerceEnumerated(x, r);
                                    }(I, i);
                                    var D = "stack" === g.mode || "relative" === g.mode, R = n[i], F = !D || R._outmost;
                                    if (!z || "none" === w || (R.isBlank || s === c || f === p) && ("auto" === w || "inside" === w)) return void r.select("text").remove();
                                    var B = C.font, N = d.getBarColor(n[i], I), j = d.getInsideTextFont(I, i, B, N), U = d.getOutsideTextFont(I, i, B), V = r.datum();
                                    O ? "log" === T.type && V.s0 <= 0 && (s = T.range[0] < T.range[1] ? 0 : T._length) : "log" === M.type && V.s0 <= 0 && (f = M.range[0] < M.range[1] ? M._length : 0);
                                    var H, q, G, Y, W, X = Math.abs(c - s) - 2 * _, Z = Math.abs(p - f) - 2 * _;
                                    "outside" === w && (F || R.hasB || (w = "inside"));
                                    if ("auto" === w) {
                                        if (F) {
                                            w = "inside", W = a.ensureUniformFontSize(t1, j), H = P(r, z, W), q = l.bBox(H.node()), G = q.width, Y = q.height;
                                            var J = G <= X && Y <= Z, K = G <= Z && Y <= X, Q = O ? X >= G * (Z / Y) : Z >= Y * (X / G);
                                            G > 0 && Y > 0 && (J || K || Q) ? w = "inside" : (w = "outside", H.remove(), H = null);
                                        } else w = "inside";
                                    }
                                    if (!H) {
                                        W = a.ensureUniformFontSize(t1, "outside" === w ? U : j);
                                        var $ = (H = P(r, z, W)).attr("transform");
                                        if (H.attr("transform", ""), q = l.bBox(H.node()), G = q.width, Y = q.height, H.attr("transform", $), G <= 0 || Y <= 0) return void H.remove();
                                    }
                                    var tt, et, rt = I.textangle;
                                    "outside" === w ? (et = "both" === I.constraintext || "outside" === I.constraintext, tt = function(t1, e1, r, n, i, a) {
                                        var o, s = !!a.isHorizontal, l = !!a.constrained, c = a.angle || 0, u = i.width, f = i.height, h = Math.abs(e1 - t1), p = Math.abs(n - r);
                                        o = s ? p > 2 * _ ? _ : 0 : h > 2 * _ ? _ : 0;
                                        var d = 1;
                                        l && (d = s ? Math.min(1, p / f) : Math.min(1, h / u));
                                        var m = S(c), g = E(i, m), v = (s ? g.x : g.y) / 2, y = (i.left + i.right) / 2, x = (i.top + i.bottom) / 2, b = (t1 + e1) / 2, w = (r + n) / 2, T = 0, A = 0, M = s ? k(e1, t1) : k(r, n);
                                        s ? (b = e1 - M * o, T = M * v) : (w = n + M * o, A = -M * v);
                                        return {
                                            textX: y,
                                            textY: x,
                                            targetX: b,
                                            targetY: w,
                                            anchorX: T,
                                            anchorY: A,
                                            scale: d,
                                            rotate: m
                                        };
                                    }(s, c, f, p, q, {
                                        isHorizontal: O,
                                        constrained: et,
                                        angle: rt
                                    })) : (et = "both" === I.constraintext || "inside" === I.constraintext, tt = L(s, c, f, p, q, {
                                        isHorizontal: O,
                                        constrained: et,
                                        angle: rt,
                                        anchor: I.insidetextanchor
                                    }));
                                    tt.fontSize = W.size, h("histogram" === I.type ? "bar" : I.type, tt, C), R.transform = tt, A(H, C, g, v).attr("transform", a.getTextTransform(tt));
                                }(t1, e1, I, r, p, B, N, j, U, g, v), e1.layerClipId && l.hideOutsideRangePoint(c, I.select("text"), w, C, f.xcalendar, f.ycalendar);
                            });
                            var j = !1 === f.cliponaxis;
                            l.setClipUrl(c, j ? null : e1.layerClipId, t1);
                        });
                        c.getComponentMethod("errorbars", "plot")(t1, I, e1, g);
                    },
                    toMoveInsideBar: L
                };
            },
            {
                "../../components/color": 366,
                "../../components/drawing": 388,
                "../../components/fx/helpers": 402,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../plots/cartesian/axes": 554,
                "../../registry": 638,
                "./attributes": 648,
                "./constants": 650,
                "./helpers": 654,
                "./style": 662,
                "./uniform_text": 664,
                "@plotly/d3": 58,
                "fast-isnumeric": 190
            }
        ],
        660: [
            function(t1, e1, r) {
                "use strict";
                function n(t1, e1, r, n, i) {
                    var a = e1.c2p(n ? t1.s0 : t1.p0, !0), o = e1.c2p(n ? t1.s1 : t1.p1, !0), s = r.c2p(n ? t1.p0 : t1.s0, !0), l = r.c2p(n ? t1.p1 : t1.s1, !0);
                    return i ? [
                        (a + o) / 2,
                        (s + l) / 2
                    ] : n ? [
                        o,
                        (s + l) / 2
                    ] : [
                        (a + o) / 2,
                        l
                    ];
                }
                e1.exports = function(t1, e1) {
                    var r, i = t1.cd, a = t1.xaxis, o = t1.yaxis, s = i[0].trace, l = "funnel" === s.type, c = "h" === s.orientation, u = [];
                    if (!1 === e1) for(r = 0; r < i.length; r++)i[r].selected = 0;
                    else for(r = 0; r < i.length; r++){
                        var f = i[r], h = "ct" in f ? f.ct : n(f, a, o, c, l);
                        e1.contains(h, !1, r, t1) ? (u.push({
                            pointNumber: r,
                            x: a.c2d(f.x),
                            y: o.c2d(f.y)
                        }), f.selected = 1) : f.selected = 0;
                    }
                    return u;
                };
            },
            {}
        ],
        661: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = a;
                var n = t1("../../lib").distinctVals, i = t1("../../constants/numerical").BADNUM;
                function a(t1, e1) {
                    this.traces = t1, this.sepNegVal = e1.sepNegVal, this.overlapNoMerge = e1.overlapNoMerge;
                    for(var r = 1 / 0, a = [], o = 0; o < t1.length; o++){
                        for(var s = t1[o], l = 0; l < s.length; l++){
                            var c = s[l];
                            c.p !== i && a.push(c.p);
                        }
                        s[0] && s[0].width1 && (r = Math.min(s[0].width1, r));
                    }
                    this.positions = a;
                    var u = n(a);
                    this.distinctPositions = u.vals, 1 === u.vals.length && r !== 1 / 0 ? this.minDiff = r : this.minDiff = Math.min(u.minDiff, r);
                    var f = (e1.posAxis || {}).type;
                    "category" !== f && "multicategory" !== f || (this.minDiff = 1), this.binWidth = this.minDiff, this.bins = {};
                }
                a.prototype.put = function(t1, e1) {
                    var r = this.getLabel(t1, e1), n = this.bins[r] || 0;
                    return this.bins[r] = n + e1, n;
                }, a.prototype.get = function(t1, e1) {
                    var r = this.getLabel(t1, e1);
                    return this.bins[r] || 0;
                }, a.prototype.getLabel = function(t1, e1) {
                    return (e1 < 0 && this.sepNegVal ? "v" : "^") + (this.overlapNoMerge ? t1 : Math.round(t1 / this.binWidth));
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503
            }
        ],
        662: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/color"), a = t1("../../components/drawing"), o = t1("../../lib"), s = t1("../../registry"), l = t1("./uniform_text").resizeText, c = t1("./attributes"), u = c.textfont, f = c.insidetextfont, h = c.outsidetextfont, p = t1("./helpers");
                function d(t1, e1, r) {
                    a.pointStyle(t1.selectAll("path"), e1, r), m(t1, e1, r);
                }
                function m(t1, e1, r) {
                    t1.selectAll("text").each(function(t1) {
                        var i = n.select(this), s = o.ensureUniformFontSize(r, g(i, t1, e1, r));
                        a.font(i, s);
                    });
                }
                function g(t1, e1, r, n) {
                    var i = n._fullLayout.font, a = r.textfont;
                    if (t1.classed("bartext-inside")) {
                        var o = _(e1, r);
                        a = y(r, e1.i, i, o);
                    } else t1.classed("bartext-outside") && (a = x(r, e1.i, i));
                    return a;
                }
                function v(t1, e1, r) {
                    return b(u, t1.textfont, e1, r);
                }
                function y(t1, e1, r, n) {
                    var a = v(t1, e1, r);
                    return (void 0 === t1._input.textfont || void 0 === t1._input.textfont.color || Array.isArray(t1.textfont.color) && void 0 === t1.textfont.color[e1]) && (a = {
                        color: i.contrast(n),
                        family: a.family,
                        size: a.size
                    }), b(f, t1.insidetextfont, e1, a);
                }
                function x(t1, e1, r) {
                    var n = v(t1, e1, r);
                    return b(h, t1.outsidetextfont, e1, n);
                }
                function b(t1, e1, r, n) {
                    e1 = e1 || {};
                    var i = p.getValue(e1.family, r), a = p.getValue(e1.size, r), o = p.getValue(e1.color, r);
                    return {
                        family: p.coerceString(t1.family, i, n.family),
                        size: p.coerceNumber(t1.size, a, n.size),
                        color: p.coerceColor(t1.color, o, n.color)
                    };
                }
                function _(t1, e1) {
                    return "waterfall" === e1.type ? e1[t1.dir].marker.color : t1.mcc || t1.mc || e1.marker.color;
                }
                e1.exports = {
                    style: function(t1) {
                        var e1 = n.select(t1).selectAll("g.barlayer").selectAll("g.trace");
                        l(t1, e1, "bar");
                        var r = e1.size(), i = t1._fullLayout;
                        e1.style("opacity", function(t1) {
                            return t1[0].trace.opacity;
                        }).each(function(t1) {
                            ("stack" === i.barmode && r > 1 || 0 === i.bargap && 0 === i.bargroupgap && !t1[0].trace.marker.line.width) && n.select(this).attr("shape-rendering", "crispEdges");
                        }), e1.selectAll("g.points").each(function(e1) {
                            d(n.select(this), e1[0].trace, t1);
                        }), s.getComponentMethod("errorbars", "style")(e1);
                    },
                    styleTextPoints: m,
                    styleOnSelect: function(t1, e1, r) {
                        var i = e1[0].trace;
                        i.selectedpoints ? function(t1, e1, r) {
                            a.selectedPointStyle(t1.selectAll("path"), e1), function(t1, e1, r) {
                                t1.each(function(t1) {
                                    var i, s = n.select(this);
                                    if (t1.selected) {
                                        i = o.ensureUniformFontSize(r, g(s, t1, e1, r));
                                        var l = e1.selected.textfont && e1.selected.textfont.color;
                                        l && (i.color = l), a.font(s, i);
                                    } else a.selectedTextStyle(s, e1);
                                });
                            }(t1.selectAll("text"), e1, r);
                        }(r, i, t1) : (d(r, i, t1), s.getComponentMethod("errorbars", "style")(r));
                    },
                    getInsideTextFont: y,
                    getOutsideTextFont: x,
                    getBarColor: _,
                    resizeText: l
                };
            },
            {
                "../../components/color": 366,
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../registry": 638,
                "./attributes": 648,
                "./helpers": 654,
                "./uniform_text": 664,
                "@plotly/d3": 58
            }
        ],
        663: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color"), i = t1("../../components/colorscale/helpers").hasColorscale, a = t1("../../components/colorscale/defaults"), o = t1("../../lib").coercePattern;
                e1.exports = function(t1, e1, r, s, l) {
                    var c = r("marker.color", s), u = i(t1, "marker");
                    u && a(t1, e1, l, r, {
                        prefix: "marker.",
                        cLetter: "c"
                    }), r("marker.line.color", n.defaultLine), i(t1, "marker.line") && a(t1, e1, l, r, {
                        prefix: "marker.line.",
                        cLetter: "c"
                    }), r("marker.line.width"), r("marker.opacity"), o(r, "marker.pattern", c, u), r("selected.marker.color"), r("unselected.marker.color");
                };
            },
            {
                "../../components/color": 366,
                "../../components/colorscale/defaults": 376,
                "../../components/colorscale/helpers": 377,
                "../../lib": 503
            }
        ],
        664: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib");
                function a(t1) {
                    return "_" + t1 + "Text_minsize";
                }
                e1.exports = {
                    recordMinTextSize: function(t1, e1, r) {
                        if (r.uniformtext.mode) {
                            var n = a(t1), i = r.uniformtext.minsize, o = e1.scale * e1.fontSize;
                            e1.hide = o < i, r[n] = r[n] || 1 / 0, e1.hide || (r[n] = Math.min(r[n], Math.max(o, i)));
                        }
                    },
                    clearMinTextSize: function(t1, e1) {
                        e1[a(t1)] = void 0;
                    },
                    resizeText: function(t1, e1, r) {
                        var a = t1._fullLayout, o = a["_" + r + "Text_minsize"];
                        if (o) {
                            var s, l = "hide" === a.uniformtext.mode;
                            switch(r){
                                case "funnelarea":
                                case "pie":
                                case "sunburst":
                                    s = "g.slice";
                                    break;
                                case "treemap":
                                case "icicle":
                                    s = "g.slice, g.pathbar";
                                    break;
                                default:
                                    s = "g.points > g.point";
                            }
                            e1.selectAll(s).each(function(t1) {
                                var e1 = t1.transform;
                                e1 && (e1.scale = l && e1.hide ? 0 : o / e1.fontSize, n.select(this).select("text").attr("transform", i.getTextTransform(e1)));
                            });
                        }
                    }
                };
            },
            {
                "../../lib": 503,
                "@plotly/d3": 58
            }
        ],
        665: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/template_attributes").hovertemplateAttrs, i = t1("../../lib/extend").extendFlat, a = t1("../scatterpolar/attributes"), o = t1("../bar/attributes");
                e1.exports = {
                    r: a.r,
                    theta: a.theta,
                    r0: a.r0,
                    dr: a.dr,
                    theta0: a.theta0,
                    dtheta: a.dtheta,
                    thetaunit: a.thetaunit,
                    base: i({}, o.base, {}),
                    offset: i({}, o.offset, {}),
                    width: i({}, o.width, {}),
                    text: i({}, o.text, {}),
                    hovertext: i({}, o.hovertext, {}),
                    marker: o.marker,
                    hoverinfo: a.hoverinfo,
                    hovertemplate: n(),
                    selected: o.selected,
                    unselected: o.unselected
                };
            },
            {
                "../../lib/extend": 493,
                "../../plots/template_attributes": 633,
                "../bar/attributes": 648,
                "../scatterpolar/attributes": 1e3
            }
        ],
        666: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/helpers").hasColorscale, i = t1("../../components/colorscale/calc"), a = t1("../bar/arrays_to_calcdata"), o = t1("../bar/cross_trace_calc").setGroupPositions, s = t1("../scatter/calc_selection"), l = t1("../../registry").traceIs, c = t1("../../lib").extendFlat;
                e1.exports = {
                    calc: function(t1, e1) {
                        for(var r = t1._fullLayout, o = e1.subplot, l = r[o].radialaxis, c = r[o].angularaxis, u = l.makeCalcdata(e1, "r"), f = c.makeCalcdata(e1, "theta"), h = e1._length, p = new Array(h), d = u, m = f, g = 0; g < h; g++)p[g] = {
                            p: m[g],
                            s: d[g]
                        };
                        function v(t1) {
                            var r = e1[t1];
                            void 0 !== r && (e1["_" + t1] = Array.isArray(r) ? c.makeCalcdata(e1, t1) : c.d2c(r, e1.thetaunit));
                        }
                        return "linear" === c.type && (v("width"), v("offset")), n(e1, "marker") && i(t1, e1, {
                            vals: e1.marker.color,
                            containerStr: "marker",
                            cLetter: "c"
                        }), n(e1, "marker.line") && i(t1, e1, {
                            vals: e1.marker.line.color,
                            containerStr: "marker.line",
                            cLetter: "c"
                        }), a(p, e1), s(p, e1), p;
                    },
                    crossTraceCalc: function(t1, e1, r) {
                        for(var n = t1.calcdata, i = [], a = 0; a < n.length; a++){
                            var s = n[a], u = s[0].trace;
                            !0 === u.visible && l(u, "bar") && u.subplot === r && i.push(s);
                        }
                        var f = c({}, e1.radialaxis, {
                            _id: "x"
                        }), h = e1.angularaxis;
                        o(t1, h, f, i, {
                            mode: e1.barmode,
                            norm: e1.barnorm,
                            gap: e1.bargap,
                            groupgap: e1.bargroupgap
                        });
                    }
                };
            },
            {
                "../../components/colorscale/calc": 374,
                "../../components/colorscale/helpers": 377,
                "../../lib": 503,
                "../../registry": 638,
                "../bar/arrays_to_calcdata": 647,
                "../bar/cross_trace_calc": 651,
                "../scatter/calc_selection": 928
            }
        ],
        667: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../scatterpolar/defaults").handleRThetaDefaults, a = t1("../bar/style_defaults"), o = t1("./attributes");
                e1.exports = function(t1, e1, r, s) {
                    function l(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    i(t1, e1, s, l) ? (l("thetaunit"), l("base"), l("offset"), l("width"), l("text"), l("hovertext"), l("hovertemplate"), a(t1, e1, l, r, s), n.coerceSelectionMarkerOpacity(e1, l)) : e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../bar/style_defaults": 663,
                "../scatterpolar/defaults": 1002,
                "./attributes": 665
            }
        ],
        668: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/fx"), i = t1("../../lib"), a = t1("../bar/hover").getTraceColor, o = i.fillText, s = t1("../scatterpolar/hover").makeHoverPointText, l = t1("../../plots/polar/helpers").isPtInsidePolygon;
                e1.exports = function(t1, e1, r) {
                    var c = t1.cd, u = c[0].trace, f = t1.subplot, h = f.radialAxis, p = f.angularAxis, d = f.vangles, m = d ? l : i.isPtInsideSector, g = t1.maxHoverDistance, v = p._period || 2 * Math.PI, y = Math.abs(h.g2p(Math.sqrt(e1 * e1 + r * r))), x = Math.atan2(r, e1);
                    h.range[0] > h.range[1] && (x += Math.PI);
                    if (n.getClosest(c, function(t1) {
                        return m(y, x, [
                            t1.rp0,
                            t1.rp1
                        ], [
                            t1.thetag0,
                            t1.thetag1
                        ], d) ? g + Math.min(1, Math.abs(t1.thetag1 - t1.thetag0) / v) - 1 + (t1.rp1 - y) / (t1.rp1 - t1.rp0) - 1 : 1 / 0;
                    }, t1), !1 !== t1.index) {
                        var b = c[t1.index];
                        t1.x0 = t1.x1 = b.ct[0], t1.y0 = t1.y1 = b.ct[1];
                        var _ = i.extendFlat({}, b, {
                            r: b.s,
                            theta: b.p
                        });
                        return o(b, u, t1), s(_, u, f, t1), t1.hovertemplate = u.hovertemplate, t1.color = a(u, b), t1.xLabelVal = t1.yLabelVal = void 0, b.s < 0 && (t1.idealAlign = "left"), [
                            t1
                        ];
                    }
                };
            },
            {
                "../../components/fx": 406,
                "../../lib": 503,
                "../../plots/polar/helpers": 621,
                "../bar/hover": 655,
                "../scatterpolar/hover": 1004
            }
        ],
        669: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "barpolar",
                    basePlotModule: t1("../../plots/polar"),
                    categories: [
                        "polar",
                        "bar",
                        "showLegend"
                    ],
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("./layout_attributes"),
                    supplyDefaults: t1("./defaults"),
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    calc: t1("./calc").calc,
                    crossTraceCalc: t1("./calc").crossTraceCalc,
                    plot: t1("./plot"),
                    colorbar: t1("../scatter/marker_colorbar"),
                    formatLabels: t1("../scatterpolar/format_labels"),
                    style: t1("../bar/style").style,
                    styleOnSelect: t1("../bar/style").styleOnSelect,
                    hoverPoints: t1("./hover"),
                    selectPoints: t1("../bar/select"),
                    meta: {}
                };
            },
            {
                "../../plots/polar": 622,
                "../bar/select": 660,
                "../bar/style": 662,
                "../scatter/marker_colorbar": 944,
                "../scatterpolar/format_labels": 1003,
                "./attributes": 665,
                "./calc": 666,
                "./defaults": 667,
                "./hover": 668,
                "./layout_attributes": 670,
                "./layout_defaults": 671,
                "./plot": 672
            }
        ],
        670: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    barmode: {
                        valType: "enumerated",
                        values: [
                            "stack",
                            "overlay"
                        ],
                        dflt: "stack",
                        editType: "calc"
                    },
                    bargap: {
                        valType: "number",
                        dflt: .1,
                        min: 0,
                        max: 1,
                        editType: "calc"
                    }
                };
            },
            {}
        ],
        671: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./layout_attributes");
                e1.exports = function(t1, e1, r) {
                    var a, o = {};
                    function s(r, o) {
                        return n.coerce(t1[a] || {}, e1[a], i, r, o);
                    }
                    for(var l = 0; l < r.length; l++){
                        var c = r[l];
                        "barpolar" === c.type && !0 === c.visible && (o[a = c.subplot] || (s("barmode"), s("bargap"), o[a] = 1));
                    }
                };
            },
            {
                "../../lib": 503,
                "./layout_attributes": 670
            }
        ],
        672: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("fast-isnumeric"), a = t1("../../lib"), o = t1("../../components/drawing"), s = t1("../../plots/polar/helpers");
                e1.exports = function(t1, e1, r) {
                    var l = e1.xaxis, c = e1.yaxis, u = e1.radialAxis, f = e1.angularAxis, h = function(t1) {
                        var e1 = t1.cxx, r = t1.cyy;
                        if (t1.vangles) return function(n, i, o, l) {
                            var c, u;
                            a.angleDelta(o, l) > 0 ? (c = o, u = l) : (c = l, u = o);
                            var f = [
                                s.findEnclosingVertexAngles(c, t1.vangles)[0],
                                (c + u) / 2,
                                s.findEnclosingVertexAngles(u, t1.vangles)[1]
                            ];
                            return s.pathPolygonAnnulus(n, i, c, u, f, e1, r);
                        };
                        return function(t1, n, i, o) {
                            return a.pathAnnulus(t1, n, i, o, e1, r);
                        };
                    }(e1), p = e1.layers.frontplot.select("g.barlayer");
                    a.makeTraceGroups(p, r, "trace bars").each(function() {
                        var r = n.select(this), s = a.ensureSingle(r, "g", "points").selectAll("g.point").data(a.identity);
                        s.enter().append("g").style("vector-effect", "non-scaling-stroke").style("stroke-miterlimit", 2).classed("point", !0), s.exit().remove(), s.each(function(t1) {
                            var e1, r = n.select(this), o = t1.rp0 = u.c2p(t1.s0), s = t1.rp1 = u.c2p(t1.s1), p = t1.thetag0 = f.c2g(t1.p0), d = t1.thetag1 = f.c2g(t1.p1);
                            if (i(o) && i(s) && i(p) && i(d) && o !== s && p !== d) {
                                var m = u.c2g(t1.s1), g = (p + d) / 2;
                                t1.ct = [
                                    l.c2p(m * Math.cos(g)),
                                    c.c2p(m * Math.sin(g))
                                ], e1 = h(o, s, p, d);
                            } else e1 = "M0,0Z";
                            a.ensureSingle(r, "path").attr("d", e1);
                        }), o.setClipUrl(r, e1._hasClipOnAxisFalse ? e1.clipIds.forTraces : null, t1);
                    });
                };
            },
            {
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../plots/polar/helpers": 621,
                "@plotly/d3": 58,
                "fast-isnumeric": 190
            }
        ],
        673: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/attributes"), i = t1("../bar/attributes"), a = t1("../../components/color/attributes"), o = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, s = t1("../../plots/template_attributes").hovertemplateAttrs, l = t1("../../lib/extend").extendFlat, c = n.marker, u = c.line;
                e1.exports = {
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    x0: {
                        valType: "any",
                        editType: "calc+clearAxisTypes"
                    },
                    y0: {
                        valType: "any",
                        editType: "calc+clearAxisTypes"
                    },
                    dx: {
                        valType: "number",
                        editType: "calc"
                    },
                    dy: {
                        valType: "number",
                        editType: "calc"
                    },
                    xperiod: n.xperiod,
                    yperiod: n.yperiod,
                    xperiod0: n.xperiod0,
                    yperiod0: n.yperiod0,
                    xperiodalignment: n.xperiodalignment,
                    yperiodalignment: n.yperiodalignment,
                    xhoverformat: o("x"),
                    yhoverformat: o("y"),
                    name: {
                        valType: "string",
                        editType: "calc+clearAxisTypes"
                    },
                    q1: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    median: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    q3: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    lowerfence: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    upperfence: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    notched: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    notchwidth: {
                        valType: "number",
                        min: 0,
                        max: .5,
                        dflt: .25,
                        editType: "calc"
                    },
                    notchspan: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    boxpoints: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "outliers",
                            "suspectedoutliers",
                            !1
                        ],
                        editType: "calc"
                    },
                    jitter: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "calc"
                    },
                    pointpos: {
                        valType: "number",
                        min: -2,
                        max: 2,
                        editType: "calc"
                    },
                    boxmean: {
                        valType: "enumerated",
                        values: [
                            !0,
                            "sd",
                            !1
                        ],
                        editType: "calc"
                    },
                    mean: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    sd: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        editType: "calc+clearAxisTypes"
                    },
                    quartilemethod: {
                        valType: "enumerated",
                        values: [
                            "linear",
                            "exclusive",
                            "inclusive"
                        ],
                        dflt: "linear",
                        editType: "calc"
                    },
                    width: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    marker: {
                        outliercolor: {
                            valType: "color",
                            dflt: "rgba(0, 0, 0, 0)",
                            editType: "style"
                        },
                        symbol: l({}, c.symbol, {
                            arrayOk: !1,
                            editType: "plot"
                        }),
                        opacity: l({}, c.opacity, {
                            arrayOk: !1,
                            dflt: 1,
                            editType: "style"
                        }),
                        size: l({}, c.size, {
                            arrayOk: !1,
                            editType: "calc"
                        }),
                        color: l({}, c.color, {
                            arrayOk: !1,
                            editType: "style"
                        }),
                        line: {
                            color: l({}, u.color, {
                                arrayOk: !1,
                                dflt: a.defaultLine,
                                editType: "style"
                            }),
                            width: l({}, u.width, {
                                arrayOk: !1,
                                dflt: 0,
                                editType: "style"
                            }),
                            outliercolor: {
                                valType: "color",
                                editType: "style"
                            },
                            outlierwidth: {
                                valType: "number",
                                min: 0,
                                dflt: 1,
                                editType: "style"
                            },
                            editType: "style"
                        },
                        editType: "plot"
                    },
                    line: {
                        color: {
                            valType: "color",
                            editType: "style"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: 2,
                            editType: "style"
                        },
                        editType: "plot"
                    },
                    fillcolor: n.fillcolor,
                    whiskerwidth: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .5,
                        editType: "calc"
                    },
                    offsetgroup: i.offsetgroup,
                    alignmentgroup: i.alignmentgroup,
                    selected: {
                        marker: n.selected.marker,
                        editType: "style"
                    },
                    unselected: {
                        marker: n.unselected.marker,
                        editType: "style"
                    },
                    text: l({}, n.text, {}),
                    hovertext: l({}, n.hovertext, {}),
                    hovertemplate: s({}),
                    hoveron: {
                        valType: "flaglist",
                        flags: [
                            "boxes",
                            "points"
                        ],
                        dflt: "boxes+points",
                        editType: "style"
                    }
                };
            },
            {
                "../../components/color/attributes": 365,
                "../../lib/extend": 493,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/template_attributes": 633,
                "../bar/attributes": 648,
                "../scatter/attributes": 926
            }
        ],
        674: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../plots/cartesian/axes"), a = t1("../../plots/cartesian/align_period"), o = t1("../../lib"), s = t1("../../constants/numerical").BADNUM, l = o._;
                e1.exports = function(t1, e1) {
                    var r, c, y, x, b, _, w, T = t1._fullLayout, k = i.getFromId(t1, e1.xaxis || "x"), A = i.getFromId(t1, e1.yaxis || "y"), M = [], S = "violin" === e1.type ? "_numViolins" : "_numBoxes";
                    "h" === e1.orientation ? (y = k, x = "x", b = A, _ = "y", w = !!e1.yperiodalignment) : (y = A, x = "y", b = k, _ = "x", w = !!e1.xperiodalignment);
                    var E, L, C, P, I, O, z = function(t1, e1, r, i) {
                        var s, l = e1 + "0" in t1, c = "d" + e1 in t1;
                        if (e1 in t1 || l && c) {
                            var u = r.makeCalcdata(t1, e1);
                            return [
                                a(t1, r, e1, u).vals,
                                u
                            ];
                        }
                        s = l ? t1[e1 + "0"] : "name" in t1 && ("category" === r.type || n(t1.name) && -1 !== [
                            "linear",
                            "log"
                        ].indexOf(r.type) || o.isDateTime(t1.name) && "date" === r.type) ? t1.name : i;
                        for(var f = "multicategory" === r.type ? r.r2c_just_indices(s) : r.d2c(s, 0, t1[e1 + "calendar"]), h = t1._length, p = new Array(h), d = 0; d < h; d++)p[d] = f;
                        return [
                            p
                        ];
                    }(e1, _, b, T[S]), D = z[0], R = z[1], F = o.distinctVals(D, b), B = F.vals, N = F.minDiff / 2, j = "all" === (e1.boxpoints || e1.points) ? o.identity : function(t1) {
                        return t1.v < E.lf || t1.v > E.uf;
                    };
                    if (e1._hasPreCompStats) {
                        var U = e1[x], V = function(t1) {
                            return y.d2c((e1[t1] || [])[r]);
                        }, H = 1 / 0, q = -1 / 0;
                        for(r = 0; r < e1._length; r++){
                            var G = D[r];
                            if (n(G)) {
                                if ((E = {}).pos = E[_] = G, w && R && (E.orig_p = R[r]), E.q1 = V("q1"), E.med = V("median"), E.q3 = V("q3"), L = [], U && o.isArrayOrTypedArray(U[r])) for(c = 0; c < U[r].length; c++)(O = y.d2c(U[r][c])) !== s && (u(I = {
                                    v: O,
                                    i: [
                                        r,
                                        c
                                    ]
                                }, e1, [
                                    r,
                                    c
                                ]), L.push(I));
                                if (E.pts = L.sort(f), P = (C = E[x] = L.map(h)).length, E.med !== s && E.q1 !== s && E.q3 !== s && E.med >= E.q1 && E.q3 >= E.med) {
                                    var Y = V("lowerfence");
                                    E.lf = Y !== s && Y <= E.q1 ? Y : p(E, C, P);
                                    var W = V("upperfence");
                                    E.uf = W !== s && W >= E.q3 ? W : d(E, C, P);
                                    var X = V("mean");
                                    E.mean = X !== s ? X : P ? o.mean(C, P) : (E.q1 + E.q3) / 2;
                                    var Z = V("sd");
                                    E.sd = X !== s && Z >= 0 ? Z : P ? o.stdev(C, P, E.mean) : E.q3 - E.q1, E.lo = m(E), E.uo = g(E);
                                    var J = V("notchspan");
                                    J = J !== s && J > 0 ? J : v(E, P), E.ln = E.med - J, E.un = E.med + J;
                                    var K = E.lf, Q = E.uf;
                                    e1.boxpoints && C.length && (K = Math.min(K, C[0]), Q = Math.max(Q, C[P - 1])), e1.notched && (K = Math.min(K, E.ln), Q = Math.max(Q, E.un)), E.min = K, E.max = Q;
                                } else {
                                    var $;
                                    o.warn([
                                        "Invalid input - make sure that q1 <= median <= q3",
                                        "q1 = " + E.q1,
                                        "median = " + E.med,
                                        "q3 = " + E.q3
                                    ].join("\n")), $ = E.med !== s ? E.med : E.q1 !== s ? E.q3 !== s ? (E.q1 + E.q3) / 2 : E.q1 : E.q3 !== s ? E.q3 : 0, E.med = $, E.q1 = E.q3 = $, E.lf = E.uf = $, E.mean = E.sd = $, E.ln = E.un = $, E.min = E.max = $;
                                }
                                H = Math.min(H, E.min), q = Math.max(q, E.max), E.pts2 = L.filter(j), M.push(E);
                            }
                        }
                        e1._extremes[y._id] = i.findExtremes(y, [
                            H,
                            q
                        ], {
                            padded: !0
                        });
                    } else {
                        var tt = y.makeCalcdata(e1, x), et = function(t1, e1) {
                            for(var r = t1.length, n = new Array(r + 1), i = 0; i < r; i++)n[i] = t1[i] - e1;
                            return n[r] = t1[r - 1] + e1, n;
                        }(B, N), rt = B.length, nt = function(t1) {
                            for(var e1 = new Array(t1), r = 0; r < t1; r++)e1[r] = [];
                            return e1;
                        }(rt);
                        for(r = 0; r < e1._length; r++)if (O = tt[r], n(O)) {
                            var it = o.findBin(D[r], et);
                            it >= 0 && it < rt && (u(I = {
                                v: O,
                                i: r
                            }, e1, r), nt[it].push(I));
                        }
                        var at = 1 / 0, ot = -1 / 0, st = e1.quartilemethod, lt = "exclusive" === st, ct = "inclusive" === st;
                        for(r = 0; r < rt; r++)if (nt[r].length > 0) {
                            var ut, ft;
                            if ((E = {}).pos = E[_] = B[r], L = E.pts = nt[r].sort(f), P = (C = E[x] = L.map(h)).length, E.min = C[0], E.max = C[P - 1], E.mean = o.mean(C, P), E.sd = o.stdev(C, P, E.mean), E.med = o.interp(C, .5), P % 2 && (lt || ct)) lt ? (ut = C.slice(0, P / 2), ft = C.slice(P / 2 + 1)) : ct && (ut = C.slice(0, P / 2 + 1), ft = C.slice(P / 2)), E.q1 = o.interp(ut, .5), E.q3 = o.interp(ft, .5);
                            else E.q1 = o.interp(C, .25), E.q3 = o.interp(C, .75);
                            E.lf = p(E, C, P), E.uf = d(E, C, P), E.lo = m(E), E.uo = g(E);
                            var ht = v(E, P);
                            E.ln = E.med - ht, E.un = E.med + ht, at = Math.min(at, E.ln), ot = Math.max(ot, E.un), E.pts2 = L.filter(j), M.push(E);
                        }
                        e1._extremes[y._id] = i.findExtremes(y, e1.notched ? tt.concat([
                            at,
                            ot
                        ]) : tt, {
                            padded: !0
                        });
                    }
                    return function(t1, e1) {
                        if (o.isArrayOrTypedArray(e1.selectedpoints)) for(var r = 0; r < t1.length; r++){
                            for(var n = t1[r].pts || [], i = {}, a = 0; a < n.length; a++)i[n[a].i] = a;
                            o.tagSelected(n, e1, i);
                        }
                    }(M, e1), M.length > 0 ? (M[0].t = {
                        num: T[S],
                        dPos: N,
                        posLetter: _,
                        valLetter: x,
                        labels: {
                            med: l(t1, "median:"),
                            min: l(t1, "min:"),
                            q1: l(t1, "q1:"),
                            q3: l(t1, "q3:"),
                            max: l(t1, "max:"),
                            mean: "sd" === e1.boxmean ? l(t1, "mean \xb1 \u03c3:") : l(t1, "mean:"),
                            lf: l(t1, "lower fence:"),
                            uf: l(t1, "upper fence:")
                        }
                    }, T[S]++, M) : [
                        {
                            t: {
                                empty: !0
                            }
                        }
                    ];
                };
                var c = {
                    text: "tx",
                    hovertext: "htx"
                };
                function u(t1, e1, r) {
                    for(var n in c)o.isArrayOrTypedArray(e1[n]) && (Array.isArray(r) ? o.isArrayOrTypedArray(e1[n][r[0]]) && (t1[c[n]] = e1[n][r[0]][r[1]]) : t1[c[n]] = e1[n][r]);
                }
                function f(t1, e1) {
                    return t1.v - e1.v;
                }
                function h(t1) {
                    return t1.v;
                }
                function p(t1, e1, r) {
                    return 0 === r ? t1.q1 : Math.min(t1.q1, e1[Math.min(o.findBin(2.5 * t1.q1 - 1.5 * t1.q3, e1, !0) + 1, r - 1)]);
                }
                function d(t1, e1, r) {
                    return 0 === r ? t1.q3 : Math.max(t1.q3, e1[Math.max(o.findBin(2.5 * t1.q3 - 1.5 * t1.q1, e1), 0)]);
                }
                function m(t1) {
                    return 4 * t1.q1 - 3 * t1.q3;
                }
                function g(t1) {
                    return 4 * t1.q3 - 3 * t1.q1;
                }
                function v(t1, e1) {
                    return 0 === e1 ? 0 : 1.57 * (t1.q3 - t1.q1) / Math.sqrt(e1);
                }
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../plots/cartesian/align_period": 551,
                "../../plots/cartesian/axes": 554,
                "fast-isnumeric": 190
            }
        ],
        675: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes"), i = t1("../../lib"), a = t1("../../plots/cartesian/constraints").getAxisGroup, o = [
                    "v",
                    "h"
                ];
                function s(t1, e1, r, o) {
                    var s, l, c, u = e1.calcdata, f = e1._fullLayout, h = o._id, p = h.charAt(0), d = [], m = 0;
                    for(s = 0; s < r.length; s++)for(c = u[r[s]], l = 0; l < c.length; l++)d.push(o.c2l(c[l].pos, !0)), m += (c[l].pts2 || []).length;
                    if (d.length) {
                        var g = i.distinctVals(d);
                        "category" !== o.type && "multicategory" !== o.type || (g.minDiff = 1);
                        var v = g.minDiff / 2;
                        n.minDtick(o, g.minDiff, g.vals[0], !0);
                        var y = f["violin" === t1 ? "_numViolins" : "_numBoxes"], x = "group" === f[t1 + "mode"] && y > 1, b = 1 - f[t1 + "gap"], _ = 1 - f[t1 + "groupgap"];
                        for(s = 0; s < r.length; s++){
                            var w, T, k, A, M, S, E = (c = u[r[s]])[0].trace, L = c[0].t, C = E.width, P = E.side;
                            if (C) w = T = A = C / 2, k = 0;
                            else if (w = v, x) {
                                var I = a(f, o._id) + E.orientation, O = (f._alignmentOpts[I] || {})[E.alignmentgroup] || {}, z = Object.keys(O.offsetGroups || {}).length, D = z || y;
                                T = w * b * _ / D, k = 2 * w * (((z ? E._offsetIndex : L.num) + .5) / D - .5) * b, A = w * b / D;
                            } else T = w * b * _, k = 0, A = w;
                            L.dPos = w, L.bPos = k, L.bdPos = T, L.wHover = A;
                            var R, F, B, N, j, U, V = k + T, H = Boolean(C);
                            if ("positive" === P ? (M = w * (C ? 1 : .5), R = V, S = R = k) : "negative" === P ? (M = R = k, S = w * (C ? 1 : .5), F = V) : (M = S = w, R = F = V), (E.boxpoints || E.points) && m > 0) {
                                var q = E.pointpos, G = E.jitter, Y = E.marker.size / 2, W = 0;
                                q + G >= 0 && ((W = V * (q + G)) > M ? (H = !0, j = Y, B = W) : W > R && (j = Y, B = M)), W <= M && (B = M);
                                var X = 0;
                                q - G <= 0 && ((X = -V * (q - G)) > S ? (H = !0, U = Y, N = X) : X > F && (U = Y, N = S)), X <= S && (N = S);
                            } else B = M, N = S;
                            var Z = new Array(c.length);
                            for(l = 0; l < c.length; l++)Z[l] = c[l].pos;
                            E._extremes[h] = n.findExtremes(o, Z, {
                                padded: H,
                                vpadminus: N,
                                vpadplus: B,
                                vpadLinearized: !0,
                                ppadminus: {
                                    x: U,
                                    y: j
                                }[p],
                                ppadplus: {
                                    x: j,
                                    y: U
                                }[p]
                            });
                        }
                    }
                }
                e1.exports = {
                    crossTraceCalc: function(t1, e1) {
                        for(var r = t1.calcdata, n = e1.xaxis, i = e1.yaxis, a = 0; a < o.length; a++){
                            for(var l = o[a], c = "h" === l ? i : n, u = [], f = 0; f < r.length; f++){
                                var h = r[f], p = h[0].t, d = h[0].trace;
                                !0 !== d.visible || "box" !== d.type && "candlestick" !== d.type || p.empty || (d.orientation || "v") !== l || d.xaxis !== n._id || d.yaxis !== i._id || u.push(f);
                            }
                            s("box", t1, u, c);
                        }
                    },
                    setPositionOffset: s
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "../../plots/cartesian/constraints": 562
            }
        ],
        676: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../registry"), a = t1("../../components/color"), o = t1("../scatter/period_defaults"), s = t1("../bar/defaults").handleGroupingDefaults, l = t1("../../plots/cartesian/axis_autotype"), c = t1("./attributes");
                function u(t1, e1, r, a) {
                    function o(t1) {
                        var e1 = 0;
                        return t1 && t1.length && (e1 += 1, n.isArrayOrTypedArray(t1[0]) && t1[0].length && (e1 += 1)), e1;
                    }
                    function s(e1) {
                        return n.validate(t1[e1], c[e1]);
                    }
                    var u, f = r("y"), h = r("x");
                    if ("box" === e1.type) {
                        var p = r("q1"), d = r("median"), m = r("q3");
                        e1._hasPreCompStats = p && p.length && d && d.length && m && m.length, u = Math.min(n.minRowLength(p), n.minRowLength(d), n.minRowLength(m));
                    }
                    var g, v, y = o(f), x = o(h), b = y && n.minRowLength(f), _ = x && n.minRowLength(h), w = a.calendar, T = {
                        autotypenumbers: a.autotypenumbers
                    };
                    if (e1._hasPreCompStats) switch(String(x) + String(y)){
                        case "00":
                            var k = s("x0") || s("dx");
                            g = (s("y0") || s("dy")) && !k ? "h" : "v", v = u;
                            break;
                        case "10":
                            g = "v", v = Math.min(u, _);
                            break;
                        case "20":
                            g = "h", v = Math.min(u, h.length);
                            break;
                        case "01":
                            g = "h", v = Math.min(u, b);
                            break;
                        case "02":
                            g = "v", v = Math.min(u, f.length);
                            break;
                        case "12":
                            g = "v", v = Math.min(u, _, f.length);
                            break;
                        case "21":
                            g = "h", v = Math.min(u, h.length, b);
                            break;
                        case "11":
                            v = 0;
                            break;
                        case "22":
                            var A, M = !1;
                            for(A = 0; A < h.length; A++)if ("category" === l(h[A], w, T)) {
                                M = !0;
                                break;
                            }
                            if (M) g = "v", v = Math.min(u, _, f.length);
                            else {
                                for(A = 0; A < f.length; A++)if ("category" === l(f[A], w, T)) {
                                    M = !0;
                                    break;
                                }
                                M ? (g = "h", v = Math.min(u, h.length, b)) : (g = "v", v = Math.min(u, _, f.length));
                            }
                    }
                    else y > 0 ? (g = "v", v = x > 0 ? Math.min(_, b) : Math.min(b)) : x > 0 ? (g = "h", v = Math.min(_)) : v = 0;
                    if (v) {
                        e1._length = v;
                        var S = r("orientation", g);
                        e1._hasPreCompStats ? "v" === S && 0 === x ? (r("x0", 0), r("dx", 1)) : "h" === S && 0 === y && (r("y0", 0), r("dy", 1)) : "v" === S && 0 === x ? r("x0") : "h" === S && 0 === y && r("y0"), i.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                            "x",
                            "y"
                        ], a);
                    } else e1.visible = !1;
                }
                function f(t1, e1, r, i) {
                    var a = i.prefix, o = n.coerce2(t1, e1, c, "marker.outliercolor"), s = r("marker.line.outliercolor"), l = "outliers";
                    e1._hasPreCompStats ? l = "all" : (o || s) && (l = "suspectedoutliers");
                    var u = r(a + "points", l);
                    u ? (r("jitter", "all" === u ? .3 : 0), r("pointpos", "all" === u ? -1.5 : 0), r("marker.symbol"), r("marker.opacity"), r("marker.size"), r("marker.color", e1.line.color), r("marker.line.color"), r("marker.line.width"), "suspectedoutliers" === u && (r("marker.line.outliercolor", e1.marker.color), r("marker.line.outlierwidth")), r("selected.marker.color"), r("unselected.marker.color"), r("selected.marker.size"), r("unselected.marker.size"), r("text"), r("hovertext")) : delete e1.marker;
                    var f = r("hoveron");
                    "all" !== f && -1 === f.indexOf("points") || r("hovertemplate"), n.coerceSelectionMarkerOpacity(e1, r);
                }
                e1.exports = {
                    supplyDefaults: function(t1, e1, r, i) {
                        function s(r, i) {
                            return n.coerce(t1, e1, c, r, i);
                        }
                        if (u(t1, e1, s, i), !1 !== e1.visible) {
                            o(t1, e1, i, s), s("xhoverformat"), s("yhoverformat");
                            var l = e1._hasPreCompStats;
                            l && (s("lowerfence"), s("upperfence")), s("line.color", (t1.marker || {}).color || r), s("line.width"), s("fillcolor", a.addOpacity(e1.line.color, .5));
                            var h = !1;
                            if (l) {
                                var p = s("mean"), d = s("sd");
                                p && p.length && (h = !0, d && d.length && (h = "sd"));
                            }
                            s("boxmean", h), s("whiskerwidth"), s("width"), s("quartilemethod");
                            var m = !1;
                            if (l) {
                                var g = s("notchspan");
                                g && g.length && (m = !0);
                            } else n.validate(t1.notchwidth, c.notchwidth) && (m = !0);
                            s("notched", m) && s("notchwidth"), f(t1, e1, s, {
                                prefix: "box"
                            });
                        }
                    },
                    crossTraceDefaults: function(t1, e1) {
                        var r, i;
                        function a(t1) {
                            return n.coerce(i._input, i, c, t1);
                        }
                        for(var o = 0; o < t1.length; o++){
                            var l = (i = t1[o]).type;
                            "box" !== l && "violin" !== l || (r = i._input, "group" === e1[l + "mode"] && s(r, i, e1, a));
                        }
                    },
                    handleSampleDefaults: u,
                    handlePointsDefaults: f
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../../plots/cartesian/axis_autotype": 555,
                "../../registry": 638,
                "../bar/defaults": 652,
                "../scatter/period_defaults": 946,
                "./attributes": 673
            }
        ],
        677: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    return e1.hoverOnBox && (t1.hoverOnBox = e1.hoverOnBox), "xVal" in e1 && (t1.x = e1.xVal), "yVal" in e1 && (t1.y = e1.yVal), e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), t1;
                };
            },
            {}
        ],
        678: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes"), i = t1("../../lib"), a = t1("../../components/fx"), o = t1("../../components/color"), s = i.fillText;
                function l(t1, e1, r, s) {
                    var l, c, u, f, h, p, d, m, g, v, y, x, b, _, w = t1.cd, T = t1.xa, k = t1.ya, A = w[0].trace, M = w[0].t, S = "violin" === A.type, E = [], L = M.bdPos, C = M.wHover, P = function(t1) {
                        return u.c2l(t1.pos) + M.bPos - u.c2l(p);
                    };
                    S && "both" !== A.side ? ("positive" === A.side && (g = function(t1) {
                        var e1 = P(t1);
                        return a.inbox(e1, e1 + C, v);
                    }, x = L, b = 0), "negative" === A.side && (g = function(t1) {
                        var e1 = P(t1);
                        return a.inbox(e1 - C, e1, v);
                    }, x = 0, b = L)) : (g = function(t1) {
                        var e1 = P(t1);
                        return a.inbox(e1 - C, e1 + C, v);
                    }, x = b = L), _ = S ? function(t1) {
                        return a.inbox(t1.span[0] - h, t1.span[1] - h, v);
                    } : function(t1) {
                        return a.inbox(t1.min - h, t1.max - h, v);
                    }, "h" === A.orientation ? (h = e1, p = r, d = _, m = g, l = "y", u = k, c = "x", f = T) : (h = r, p = e1, d = g, m = _, l = "x", u = T, c = "y", f = k);
                    var I = Math.min(1, L / Math.abs(u.r2c(u.range[1]) - u.r2c(u.range[0])));
                    function O(t1) {
                        return (d(t1) + m(t1)) / 2;
                    }
                    v = t1.maxHoverDistance - I, y = t1.maxSpikeDistance - I;
                    var z = a.getDistanceFunction(s, d, m, O);
                    if (a.getClosest(w, z, t1), !1 === t1.index) return [];
                    var D = w[t1.index], R = A.line.color, F = (A.marker || {}).color;
                    o.opacity(R) && A.line.width ? t1.color = R : o.opacity(F) && A.boxpoints ? t1.color = F : t1.color = A.fillcolor, t1[l + "0"] = u.c2p(D.pos + M.bPos - b, !0), t1[l + "1"] = u.c2p(D.pos + M.bPos + x, !0), t1[l + "LabelVal"] = void 0 !== D.orig_p ? D.orig_p : D.pos;
                    var B = l + "Spike";
                    t1.spikeDistance = O(D) * y / v, t1[B] = u.c2p(D.pos, !0);
                    var N = {}, j = [
                        "med",
                        "q1",
                        "q3",
                        "min",
                        "max"
                    ];
                    (A.boxmean || (A.meanline || {}).visible) && j.push("mean"), (A.boxpoints || A.points) && j.push("lf", "uf");
                    for(var U = 0; U < j.length; U++){
                        var V = j[U];
                        if (V in D && !(D[V] in N)) {
                            N[D[V]] = !0;
                            var H = D[V], q = f.c2p(H, !0), G = i.extendFlat({}, t1);
                            G.attr = V, G[c + "0"] = G[c + "1"] = q, G[c + "LabelVal"] = H, G[c + "Label"] = (M.labels ? M.labels[V] + " " : "") + n.hoverLabelText(f, H, A[c + "hoverformat"]), G.hoverOnBox = !0, "mean" === V && "sd" in D && "sd" === A.boxmean && (G[c + "err"] = D.sd), t1.name = "", t1.spikeDistance = void 0, t1[B] = void 0, G.hovertemplate = !1, E.push(G);
                        }
                    }
                    return E;
                }
                function c(t1, e1, r) {
                    for(var n, o, l, c = t1.cd, u = t1.xa, f = t1.ya, h = c[0].trace, p = u.c2p(e1), d = f.c2p(r), m = a.quadrature(function(t1) {
                        var e1 = Math.max(3, t1.mrc || 0);
                        return Math.max(Math.abs(u.c2p(t1.x) - p) - e1, 1 - 3 / e1);
                    }, function(t1) {
                        var e1 = Math.max(3, t1.mrc || 0);
                        return Math.max(Math.abs(f.c2p(t1.y) - d) - e1, 1 - 3 / e1);
                    }), g = !1, v = 0; v < c.length; v++){
                        o = c[v];
                        for(var y = 0; y < (o.pts || []).length; y++){
                            var x = m(l = o.pts[y]);
                            x <= t1.distance && (t1.distance = x, g = [
                                v,
                                y
                            ]);
                        }
                    }
                    if (!g) return !1;
                    l = (o = c[g[0]]).pts[g[1]];
                    var b = u.c2p(l.x, !0), _ = f.c2p(l.y, !0), w = l.mrc || 1;
                    n = i.extendFlat({}, t1, {
                        index: l.i,
                        color: (h.marker || {}).color,
                        name: h.name,
                        x0: b - w,
                        x1: b + w,
                        y0: _ - w,
                        y1: _ + w,
                        spikeDistance: t1.distance,
                        hovertemplate: h.hovertemplate
                    });
                    var T, k = o.orig_p, A = void 0 !== k ? k : o.pos;
                    return "h" === h.orientation ? (T = f, n.xLabelVal = l.x, n.yLabelVal = A) : (T = u, n.xLabelVal = A, n.yLabelVal = l.y), n[T._id.charAt(0) + "Spike"] = T.c2p(o.pos, !0), s(l, h, n), n;
                }
                e1.exports = {
                    hoverPoints: function(t1, e1, r, n) {
                        var i, a = t1.cd[0].trace.hoveron, o = [];
                        return -1 !== a.indexOf("boxes") && (o = o.concat(l(t1, e1, r, n))), -1 !== a.indexOf("points") && (i = c(t1, e1, r)), "closest" === n ? i ? [
                            i
                        ] : o : i ? (o.push(i), o) : o;
                    },
                    hoverOnBoxes: l,
                    hoverOnPoints: c
                };
            },
            {
                "../../components/color": 366,
                "../../components/fx": 406,
                "../../lib": 503,
                "../../plots/cartesian/axes": 554
            }
        ],
        679: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("./layout_attributes"),
                    supplyDefaults: t1("./defaults").supplyDefaults,
                    crossTraceDefaults: t1("./defaults").crossTraceDefaults,
                    supplyLayoutDefaults: t1("./layout_defaults").supplyLayoutDefaults,
                    calc: t1("./calc"),
                    crossTraceCalc: t1("./cross_trace_calc").crossTraceCalc,
                    plot: t1("./plot").plot,
                    style: t1("./style").style,
                    styleOnSelect: t1("./style").styleOnSelect,
                    hoverPoints: t1("./hover").hoverPoints,
                    eventData: t1("./event_data"),
                    selectPoints: t1("./select"),
                    moduleType: "trace",
                    name: "box",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "cartesian",
                        "svg",
                        "symbols",
                        "oriented",
                        "box-violin",
                        "showLegend",
                        "boxLayout",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "./attributes": 673,
                "./calc": 674,
                "./cross_trace_calc": 675,
                "./defaults": 676,
                "./event_data": 677,
                "./hover": 678,
                "./layout_attributes": 680,
                "./layout_defaults": 681,
                "./plot": 682,
                "./select": 683,
                "./style": 684
            }
        ],
        680: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    boxmode: {
                        valType: "enumerated",
                        values: [
                            "group",
                            "overlay"
                        ],
                        dflt: "overlay",
                        editType: "calc"
                    },
                    boxgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .3,
                        editType: "calc"
                    },
                    boxgroupgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .3,
                        editType: "calc"
                    }
                };
            },
            {}
        ],
        681: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib"), a = t1("./layout_attributes");
                function o(t1, e1, r, i, a) {
                    for(var o = a + "Layout", s = !1, l = 0; l < r.length; l++){
                        var c = r[l];
                        if (n.traceIs(c, o)) {
                            s = !0;
                            break;
                        }
                    }
                    s && (i(a + "mode"), i(a + "gap"), i(a + "groupgap"));
                }
                e1.exports = {
                    supplyLayoutDefaults: function(t1, e1, r) {
                        o(0, 0, r, function(r, n) {
                            return i.coerce(t1, e1, a, r, n);
                        }, "box");
                    },
                    _supply: o
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638,
                "./layout_attributes": 680
            }
        ],
        682: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../../components/drawing");
                function o(t1, e1, r, a) {
                    var o, s, l = "h" === r.orientation, c = e1.val, u = e1.pos, f = !!u.rangebreaks, h = a.bPos, p = a.wdPos || 0, d = a.bPosPxOffset || 0, m = r.whiskerwidth || 0, g = r.notched || !1, v = g ? 1 - 2 * r.notchwidth : 1;
                    Array.isArray(a.bdPos) ? (o = a.bdPos[0], s = a.bdPos[1]) : (o = a.bdPos, s = a.bdPos);
                    var y = t1.selectAll("path.box").data("violin" !== r.type || r.box.visible ? i.identity : []);
                    y.enter().append("path").style("vector-effect", "non-scaling-stroke").attr("class", "box"), y.exit().remove(), y.each(function(t1) {
                        if (t1.empty) return "M0,0Z";
                        var e1 = u.c2l(t1.pos + h, !0), a = u.l2p(e1 - o) + d, y = u.l2p(e1 + s) + d, x = f ? (a + y) / 2 : u.l2p(e1) + d, b = r.whiskerwidth, _ = f ? a * b + (1 - b) * x : u.l2p(e1 - p) + d, w = f ? y * b + (1 - b) * x : u.l2p(e1 + p) + d, T = u.l2p(e1 - o * v) + d, k = u.l2p(e1 + s * v) + d, A = c.c2p(t1.q1, !0), M = c.c2p(t1.q3, !0), S = i.constrain(c.c2p(t1.med, !0), Math.min(A, M) + 1, Math.max(A, M) - 1), E = void 0 === t1.lf || !1 === r.boxpoints, L = c.c2p(E ? t1.min : t1.lf, !0), C = c.c2p(E ? t1.max : t1.uf, !0), P = c.c2p(t1.ln, !0), I = c.c2p(t1.un, !0);
                        l ? n.select(this).attr("d", "M" + S + "," + T + "V" + k + "M" + A + "," + a + "V" + y + (g ? "H" + P + "L" + S + "," + k + "L" + I + "," + y : "") + "H" + M + "V" + a + (g ? "H" + I + "L" + S + "," + T + "L" + P + "," + a : "") + "ZM" + A + "," + x + "H" + L + "M" + M + "," + x + "H" + C + (0 === m ? "" : "M" + L + "," + _ + "V" + w + "M" + C + "," + _ + "V" + w)) : n.select(this).attr("d", "M" + T + "," + S + "H" + k + "M" + a + "," + A + "H" + y + (g ? "V" + P + "L" + k + "," + S + "L" + y + "," + I : "") + "V" + M + "H" + a + (g ? "V" + I + "L" + T + "," + S + "L" + a + "," + P : "") + "ZM" + x + "," + A + "V" + L + "M" + x + "," + M + "V" + C + (0 === m ? "" : "M" + _ + "," + L + "H" + w + "M" + _ + "," + C + "H" + w));
                    });
                }
                function s(t1, e1, r, n) {
                    var o = e1.x, s = e1.y, l = n.bdPos, c = n.bPos, u = r.boxpoints || r.points;
                    i.seedPseudoRandom();
                    var f = t1.selectAll("g.points").data(u ? function(t1) {
                        return t1.forEach(function(t1) {
                            t1.t = n, t1.trace = r;
                        }), t1;
                    } : []);
                    f.enter().append("g").attr("class", "points"), f.exit().remove();
                    var h = f.selectAll("path").data(function(t1) {
                        var e1, n, a = t1.pts2, o = Math.max((t1.max - t1.min) / 10, t1.q3 - t1.q1), s = 1e-9 * o, f = .01 * o, h = [], p = 0;
                        if (r.jitter) {
                            if (0 === o) for(p = 1, h = new Array(a.length), e1 = 0; e1 < a.length; e1++)h[e1] = 1;
                            else for(e1 = 0; e1 < a.length; e1++){
                                var d = Math.max(0, e1 - 5), m = a[d].v, g = Math.min(a.length - 1, e1 + 5), v = a[g].v;
                                "all" !== u && (a[e1].v < t1.lf ? v = Math.min(v, t1.lf) : m = Math.max(m, t1.uf));
                                var y = Math.sqrt(f * (g - d) / (v - m + s)) || 0;
                                y = i.constrain(Math.abs(y), 0, 1), h.push(y), p = Math.max(y, p);
                            }
                            n = 2 * r.jitter / (p || 1);
                        }
                        for(e1 = 0; e1 < a.length; e1++){
                            var x = a[e1], b = x.v, _ = r.jitter ? n * h[e1] * (i.pseudoRandom() - .5) : 0, w = t1.pos + c + l * (r.pointpos + _);
                            "h" === r.orientation ? (x.y = w, x.x = b) : (x.x = w, x.y = b), "suspectedoutliers" === u && b < t1.uo && b > t1.lo && (x.so = !0);
                        }
                        return a;
                    });
                    h.enter().append("path").classed("point", !0), h.exit().remove(), h.call(a.translatePoints, o, s);
                }
                function l(t1, e1, r, a) {
                    var o, s, l = e1.val, c = e1.pos, u = !!c.rangebreaks, f = a.bPos, h = a.bPosPxOffset || 0, p = r.boxmean || (r.meanline || {}).visible;
                    Array.isArray(a.bdPos) ? (o = a.bdPos[0], s = a.bdPos[1]) : (o = a.bdPos, s = a.bdPos);
                    var d = t1.selectAll("path.mean").data("box" === r.type && r.boxmean || "violin" === r.type && r.box.visible && r.meanline.visible ? i.identity : []);
                    d.enter().append("path").attr("class", "mean").style({
                        fill: "none",
                        "vector-effect": "non-scaling-stroke"
                    }), d.exit().remove(), d.each(function(t1) {
                        var e1 = c.c2l(t1.pos + f, !0), i = c.l2p(e1 - o) + h, a = c.l2p(e1 + s) + h, d = u ? (i + a) / 2 : c.l2p(e1) + h, m = l.c2p(t1.mean, !0), g = l.c2p(t1.mean - t1.sd, !0), v = l.c2p(t1.mean + t1.sd, !0);
                        "h" === r.orientation ? n.select(this).attr("d", "M" + m + "," + i + "V" + a + ("sd" === p ? "m0,0L" + g + "," + d + "L" + m + "," + i + "L" + v + "," + d + "Z" : "")) : n.select(this).attr("d", "M" + i + "," + m + "H" + a + ("sd" === p ? "m0,0L" + d + "," + g + "L" + i + "," + m + "L" + d + "," + v + "Z" : ""));
                    });
                }
                e1.exports = {
                    plot: function(t1, e1, r, a) {
                        var c = e1.xaxis, u = e1.yaxis;
                        i.makeTraceGroups(a, r, "trace boxes").each(function(t1) {
                            var e1, r, i = n.select(this), a = t1[0], f = a.t, h = a.trace;
                            (f.wdPos = f.bdPos * h.whiskerwidth, !0 !== h.visible || f.empty) ? i.remove() : ("h" === h.orientation ? (e1 = u, r = c) : (e1 = c, r = u), o(i, {
                                pos: e1,
                                val: r
                            }, h, f), s(i, {
                                x: c,
                                y: u
                            }, h, f), l(i, {
                                pos: e1,
                                val: r
                            }, h, f));
                        });
                    },
                    plotBoxAndWhiskers: o,
                    plotPoints: s,
                    plotBoxMean: l
                };
            },
            {
                "../../components/drawing": 388,
                "../../lib": 503,
                "@plotly/d3": 58
            }
        ],
        683: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    var r, n, i = t1.cd, a = t1.xaxis, o = t1.yaxis, s = [];
                    if (!1 === e1) for(r = 0; r < i.length; r++)for(n = 0; n < (i[r].pts || []).length; n++)i[r].pts[n].selected = 0;
                    else for(r = 0; r < i.length; r++)for(n = 0; n < (i[r].pts || []).length; n++){
                        var l = i[r].pts[n], c = a.c2p(l.x), u = o.c2p(l.y);
                        e1.contains([
                            c,
                            u
                        ], null, l.i, t1) ? (s.push({
                            pointNumber: l.i,
                            x: a.c2d(l.x),
                            y: o.c2d(l.y)
                        }), l.selected = 1) : l.selected = 0;
                    }
                    return s;
                };
            },
            {}
        ],
        684: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/color"), a = t1("../../components/drawing");
                e1.exports = {
                    style: function(t1, e1, r) {
                        var o = r || n.select(t1).selectAll("g.trace.boxes");
                        o.style("opacity", function(t1) {
                            return t1[0].trace.opacity;
                        }), o.each(function(e1) {
                            var r = n.select(this), o = e1[0].trace, s = o.line.width;
                            function l(t1, e1, r, n) {
                                t1.style("stroke-width", e1 + "px").call(i.stroke, r).call(i.fill, n);
                            }
                            var c = r.selectAll("path.box");
                            if ("candlestick" === o.type) c.each(function(t1) {
                                if (!t1.empty) {
                                    var e1 = n.select(this), r = o[t1.dir];
                                    l(e1, r.line.width, r.line.color, r.fillcolor), e1.style("opacity", o.selectedpoints && !t1.selected ? .3 : 1);
                                }
                            });
                            else {
                                l(c, s, o.line.color, o.fillcolor), r.selectAll("path.mean").style({
                                    "stroke-width": s,
                                    "stroke-dasharray": 2 * s + "px," + s + "px"
                                }).call(i.stroke, o.line.color);
                                var u = r.selectAll("path.point");
                                a.pointStyle(u, o, t1);
                            }
                        });
                    },
                    styleOnSelect: function(t1, e1, r) {
                        var n = e1[0].trace, i = r.selectAll("path.point");
                        n.selectedpoints ? a.selectedPointStyle(i, n) : a.pointStyle(i, n, t1);
                    }
                };
            },
            {
                "../../components/color": 366,
                "../../components/drawing": 388,
                "@plotly/d3": 58
            }
        ],
        685: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").extendFlat, i = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, a = t1("../ohlc/attributes"), o = t1("../box/attributes");
                function s(t1) {
                    return {
                        line: {
                            color: n({}, o.line.color, {
                                dflt: t1
                            }),
                            width: o.line.width,
                            editType: "style"
                        },
                        fillcolor: o.fillcolor,
                        editType: "style"
                    };
                }
                e1.exports = {
                    xperiod: a.xperiod,
                    xperiod0: a.xperiod0,
                    xperiodalignment: a.xperiodalignment,
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    x: a.x,
                    open: a.open,
                    high: a.high,
                    low: a.low,
                    close: a.close,
                    line: {
                        width: n({}, o.line.width, {}),
                        editType: "style"
                    },
                    increasing: s(a.increasing.line.color.dflt),
                    decreasing: s(a.decreasing.line.color.dflt),
                    text: a.text,
                    hovertext: a.hovertext,
                    whiskerwidth: n({}, o.whiskerwidth, {
                        dflt: 0
                    }),
                    hoverlabel: a.hoverlabel
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../box/attributes": 673,
                "../ohlc/attributes": 872
            }
        ],
        686: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axes"), a = t1("../../plots/cartesian/align_period"), o = t1("../ohlc/calc").calcCommon;
                function s(t1, e1, r, n) {
                    return {
                        min: r,
                        q1: Math.min(t1, n),
                        med: n,
                        q3: Math.max(t1, n),
                        max: e1
                    };
                }
                e1.exports = function(t1, e1) {
                    var r = t1._fullLayout, l = i.getFromId(t1, e1.xaxis), c = i.getFromId(t1, e1.yaxis), u = l.makeCalcdata(e1, "x"), f = a(e1, l, "x", u).vals, h = o(t1, e1, u, f, c, s);
                    return h.length ? (n.extendFlat(h[0].t, {
                        num: r._numBoxes,
                        dPos: n.distinctVals(f).minDiff / 2,
                        posLetter: "x",
                        valLetter: "y"
                    }), r._numBoxes++, h) : [
                        {
                            t: {
                                empty: !0
                            }
                        }
                    ];
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/align_period": 551,
                "../../plots/cartesian/axes": 554,
                "../ohlc/calc": 873
            }
        ],
        687: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/color"), a = t1("../ohlc/ohlc_defaults"), o = t1("../scatter/period_defaults"), s = t1("./attributes");
                function l(t1, e1, r, n) {
                    var a = r(n + ".line.color");
                    r(n + ".line.width", e1.line.width), r(n + ".fillcolor", i.addOpacity(a, .5));
                }
                e1.exports = function(t1, e1, r, i) {
                    function c(r, i) {
                        return n.coerce(t1, e1, s, r, i);
                    }
                    a(t1, e1, c, i) ? (o(t1, e1, i, c, {
                        x: !0
                    }), c("xhoverformat"), c("yhoverformat"), c("line.width"), l(t1, e1, c, "increasing"), l(t1, e1, c, "decreasing"), c("text"), c("hovertext"), c("whiskerwidth"), i._requestRangeslider[e1.xaxis] = !0) : e1.visible = !1;
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../ohlc/ohlc_defaults": 877,
                "../scatter/period_defaults": 946,
                "./attributes": 685
            }
        ],
        688: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "candlestick",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "cartesian",
                        "svg",
                        "showLegend",
                        "candlestick",
                        "boxLayout"
                    ],
                    meta: {},
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("../box/layout_attributes"),
                    supplyLayoutDefaults: t1("../box/layout_defaults").supplyLayoutDefaults,
                    crossTraceCalc: t1("../box/cross_trace_calc").crossTraceCalc,
                    supplyDefaults: t1("./defaults"),
                    calc: t1("./calc"),
                    plot: t1("../box/plot").plot,
                    layerName: "boxlayer",
                    style: t1("../box/style").style,
                    hoverPoints: t1("../ohlc/hover").hoverPoints,
                    selectPoints: t1("../ohlc/select")
                };
            },
            {
                "../../plots/cartesian": 568,
                "../box/cross_trace_calc": 675,
                "../box/layout_attributes": 680,
                "../box/layout_defaults": 681,
                "../box/plot": 682,
                "../box/style": 684,
                "../ohlc/hover": 875,
                "../ohlc/select": 879,
                "./attributes": 685,
                "./calc": 686,
                "./defaults": 687
            }
        ],
        689: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./axis_defaults"), i = t1("../../plot_api/plot_template");
                e1.exports = function(t1, e1, r, a, o) {
                    a("a") || (a("da"), a("a0")), a("b") || (a("db"), a("b0")), function(t1, e1, r, a) {
                        [
                            "aaxis",
                            "baxis"
                        ].forEach(function(o) {
                            var s = o.charAt(0), l = t1[o] || {}, c = i.newContainer(e1, o), u = {
                                tickfont: "x",
                                id: s + "axis",
                                letter: s,
                                font: e1.font,
                                name: o,
                                data: t1[s],
                                calendar: e1.calendar,
                                dfltColor: a,
                                bgColor: r.paper_bgcolor,
                                autotypenumbersDflt: r.autotypenumbers,
                                fullLayout: r
                            };
                            n(l, c, u), c._categories = c._categories || [], t1[o] || "-" === l.type || (t1[o] = {
                                type: l.type
                            });
                        });
                    }(t1, e1, r, o);
                };
            },
            {
                "../../plot_api/plot_template": 543,
                "./axis_defaults": 694
            }
        ],
        690: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").isArrayOrTypedArray;
                e1.exports = function(t1) {
                    return function t1(e1, r) {
                        if (!n(e1) || r >= 10) return null;
                        for(var i = 1 / 0, a = -1 / 0, o = e1.length, s = 0; s < o; s++){
                            var l = e1[s];
                            if (n(l)) {
                                var c = t1(l, r + 1);
                                c && (i = Math.min(c[0], i), a = Math.max(c[1], a));
                            } else i = Math.min(l, i), a = Math.max(l, a);
                        }
                        return [
                            i,
                            a
                        ];
                    }(t1, 0);
                };
            },
            {
                "../../lib": 503
            }
        ],
        691: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/font_attributes"), i = t1("./axis_attributes"), a = t1("../../components/color/attributes"), o = n({
                    editType: "calc"
                });
                o.family.dflt = '"Open Sans", verdana, arial, sans-serif', o.size.dflt = 12, o.color.dflt = a.defaultLine, e1.exports = {
                    carpet: {
                        valType: "string",
                        editType: "calc"
                    },
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    a: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    a0: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc"
                    },
                    da: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    b: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    b0: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc"
                    },
                    db: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    cheaterslope: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    aaxis: i,
                    baxis: i,
                    font: o,
                    color: {
                        valType: "color",
                        dflt: a.defaultLine,
                        editType: "plot"
                    },
                    transforms: void 0
                };
            },
            {
                "../../components/color/attributes": 365,
                "../../plots/font_attributes": 585,
                "./axis_attributes": 693
            }
        ],
        692: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").isArrayOrTypedArray;
                e1.exports = function(t1, e1, r, i) {
                    var a, o, s, l, c, u, f, h, p, d, m, g, v, y = n(r) ? "a" : "b", x = ("a" === y ? t1.aaxis : t1.baxis).smoothing, b = "a" === y ? t1.a2i : t1.b2j, _ = "a" === y ? r : i, w = "a" === y ? i : r, T = "a" === y ? e1.a.length : e1.b.length, k = "a" === y ? e1.b.length : e1.a.length, A = Math.floor("a" === y ? t1.b2j(w) : t1.a2i(w)), M = "a" === y ? function(e1) {
                        return t1.evalxy([], e1, A);
                    } : function(e1) {
                        return t1.evalxy([], A, e1);
                    };
                    x && (s = Math.max(0, Math.min(k - 2, A)), l = A - s, o = "a" === y ? function(e1, r) {
                        return t1.dxydi([], e1, s, r, l);
                    } : function(e1, r) {
                        return t1.dxydj([], s, e1, l, r);
                    });
                    var S = b(_[0]), E = b(_[1]), L = S < E ? 1 : -1, C = 1e-8 * (E - S), P = L > 0 ? Math.floor : Math.ceil, I = L > 0 ? Math.ceil : Math.floor, O = L > 0 ? Math.min : Math.max, z = L > 0 ? Math.max : Math.min, D = P(S + C), R = I(E - C), F = [
                        [
                            f = M(S)
                        ]
                    ];
                    for(a = D; a * L < R * L; a += L)c = [], m = z(S, a), v = (g = O(E, a + L)) - m, u = Math.max(0, Math.min(T - 2, Math.floor(.5 * (m + g)))), h = M(g), x && (p = o(u, m - u), d = o(u, g - u), c.push([
                        f[0] + p[0] / 3 * v,
                        f[1] + p[1] / 3 * v
                    ]), c.push([
                        h[0] - d[0] / 3 * v,
                        h[1] - d[1] / 3 * v
                    ])), c.push(h), F.push(c), f = h;
                    return F;
                };
            },
            {
                "../../lib": 503
            }
        ],
        693: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/font_attributes"), i = t1("../../components/color/attributes"), a = t1("../../plots/cartesian/layout_attributes"), o = t1("../../plots/cartesian/axis_format_attributes").descriptionWithDates, s = t1("../../plot_api/edit_types").overrideAll;
                e1.exports = {
                    color: {
                        valType: "color",
                        editType: "calc"
                    },
                    smoothing: {
                        valType: "number",
                        dflt: 1,
                        min: 0,
                        max: 1.3,
                        editType: "calc"
                    },
                    title: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "calc"
                        },
                        font: n({
                            editType: "calc"
                        }),
                        offset: {
                            valType: "number",
                            dflt: 10,
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "-",
                            "linear",
                            "date",
                            "category"
                        ],
                        dflt: "-",
                        editType: "calc"
                    },
                    autotypenumbers: a.autotypenumbers,
                    autorange: {
                        valType: "enumerated",
                        values: [
                            !0,
                            !1,
                            "reversed"
                        ],
                        dflt: !0,
                        editType: "calc"
                    },
                    rangemode: {
                        valType: "enumerated",
                        values: [
                            "normal",
                            "tozero",
                            "nonnegative"
                        ],
                        dflt: "normal",
                        editType: "calc"
                    },
                    range: {
                        valType: "info_array",
                        editType: "calc",
                        items: [
                            {
                                valType: "any",
                                editType: "calc"
                            },
                            {
                                valType: "any",
                                editType: "calc"
                            }
                        ]
                    },
                    fixedrange: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    cheatertype: {
                        valType: "enumerated",
                        values: [
                            "index",
                            "value"
                        ],
                        dflt: "value",
                        editType: "calc"
                    },
                    tickmode: {
                        valType: "enumerated",
                        values: [
                            "linear",
                            "array"
                        ],
                        dflt: "array",
                        editType: "calc"
                    },
                    nticks: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    tickvals: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    ticktext: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    showticklabels: {
                        valType: "enumerated",
                        values: [
                            "start",
                            "end",
                            "both",
                            "none"
                        ],
                        dflt: "start",
                        editType: "calc"
                    },
                    tickfont: n({
                        editType: "calc"
                    }),
                    tickangle: {
                        valType: "angle",
                        dflt: "auto",
                        editType: "calc"
                    },
                    tickprefix: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    showtickprefix: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "calc"
                    },
                    ticksuffix: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    showticksuffix: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "calc"
                    },
                    showexponent: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "first",
                            "last",
                            "none"
                        ],
                        dflt: "all",
                        editType: "calc"
                    },
                    exponentformat: {
                        valType: "enumerated",
                        values: [
                            "none",
                            "e",
                            "E",
                            "power",
                            "SI",
                            "B"
                        ],
                        dflt: "B",
                        editType: "calc"
                    },
                    minexponent: {
                        valType: "number",
                        dflt: 3,
                        min: 0,
                        editType: "calc"
                    },
                    separatethousands: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    tickformat: {
                        valType: "string",
                        dflt: "",
                        editType: "calc",
                        description: o("tick label")
                    },
                    tickformatstops: s(a.tickformatstops, "calc", "from-root"),
                    categoryorder: {
                        valType: "enumerated",
                        values: [
                            "trace",
                            "category ascending",
                            "category descending",
                            "array"
                        ],
                        dflt: "trace",
                        editType: "calc"
                    },
                    categoryarray: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    labelpadding: {
                        valType: "integer",
                        dflt: 10,
                        editType: "calc"
                    },
                    labelprefix: {
                        valType: "string",
                        editType: "calc"
                    },
                    labelsuffix: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    showline: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    linecolor: {
                        valType: "color",
                        dflt: i.defaultLine,
                        editType: "calc"
                    },
                    linewidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc"
                    },
                    gridcolor: {
                        valType: "color",
                        editType: "calc"
                    },
                    gridwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc"
                    },
                    showgrid: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    minorgridcount: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    minorgridwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc"
                    },
                    minorgridcolor: {
                        valType: "color",
                        dflt: i.lightLine,
                        editType: "calc"
                    },
                    startline: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    startlinecolor: {
                        valType: "color",
                        editType: "calc"
                    },
                    startlinewidth: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    endline: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    endlinewidth: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    endlinecolor: {
                        valType: "color",
                        editType: "calc"
                    },
                    tick0: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    dtick: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "calc"
                    },
                    arraytick0: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    arraydtick: {
                        valType: "integer",
                        min: 1,
                        dflt: 1,
                        editType: "calc"
                    },
                    _deprecated: {
                        title: {
                            valType: "string",
                            editType: "calc"
                        },
                        titlefont: n({
                            editType: "calc"
                        }),
                        titleoffset: {
                            valType: "number",
                            dflt: 10,
                            editType: "calc"
                        }
                    },
                    editType: "calc"
                };
            },
            {
                "../../components/color/attributes": 365,
                "../../plot_api/edit_types": 536,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/cartesian/layout_attributes": 569,
                "../../plots/font_attributes": 585
            }
        ],
        694: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./attributes"), i = t1("../../components/color").addOpacity, a = t1("../../registry"), o = t1("../../lib"), s = t1("../../plots/cartesian/tick_value_defaults"), l = t1("../../plots/cartesian/tick_label_defaults"), c = t1("../../plots/cartesian/prefix_suffix_defaults"), u = t1("../../plots/cartesian/category_order_defaults"), f = t1("../../plots/cartesian/set_convert"), h = t1("../../plots/cartesian/axis_autotype");
                e1.exports = function(t1, e1, r) {
                    var p = r.letter, d = r.font || {}, m = n[p + "axis"];
                    function g(r, n) {
                        return o.coerce(t1, e1, m, r, n);
                    }
                    function v(r, n) {
                        return o.coerce2(t1, e1, m, r, n);
                    }
                    r.name && (e1._name = r.name, e1._id = r.name), g("autotypenumbers", r.autotypenumbersDflt);
                    var y = g("type");
                    ("-" === y && (r.data && function(t1, e1) {
                        if ("-" !== t1.type) return;
                        var r = t1._id.charAt(0), n = t1[r + "calendar"];
                        t1.type = h(e1, n, {
                            autotypenumbers: t1.autotypenumbers
                        });
                    }(e1, r.data), "-" === e1.type ? e1.type = "linear" : y = t1.type = e1.type), g("smoothing"), g("cheatertype"), g("showticklabels"), g("labelprefix", p + " = "), g("labelsuffix"), g("showtickprefix"), g("showticksuffix"), g("separatethousands"), g("tickformat"), g("exponentformat"), g("minexponent"), g("showexponent"), g("categoryorder"), g("tickmode"), g("tickvals"), g("ticktext"), g("tick0"), g("dtick"), "array" === e1.tickmode && (g("arraytick0"), g("arraydtick")), g("labelpadding"), e1._hovertitle = p, "date" === y) && a.getComponentMethod("calendars", "handleDefaults")(t1, e1, "calendar", r.calendar);
                    f(e1, r.fullLayout), e1.c2p = o.identity;
                    var x = g("color", r.dfltColor), b = x === t1.color ? x : d.color;
                    g("title.text") && (o.coerceFont(g, "title.font", {
                        family: d.family,
                        size: o.bigFont(d.size),
                        color: b
                    }), g("title.offset")), g("tickangle"), g("autorange", !e1.isValidRange(t1.range)) && g("rangemode"), g("range"), e1.cleanRange(), g("fixedrange"), s(t1, e1, g, y), c(t1, e1, g, y, r), l(t1, e1, g, y, r), u(t1, e1, g, {
                        data: r.data,
                        dataAttr: p
                    });
                    var _ = v("gridcolor", i(x, .3)), w = v("gridwidth"), T = g("showgrid");
                    T || (delete e1.gridcolor, delete e1.gridwidth);
                    var k = v("startlinecolor", x), A = v("startlinewidth", w);
                    g("startline", e1.showgrid || !!k || !!A) || (delete e1.startlinecolor, delete e1.startlinewidth);
                    var M = v("endlinecolor", x), S = v("endlinewidth", w);
                    return g("endline", e1.showgrid || !!M || !!S) || (delete e1.endlinecolor, delete e1.endlinewidth), T ? (g("minorgridcount"), g("minorgridwidth", w), g("minorgridcolor", i(_, .06)), e1.minorgridcount || (delete e1.minorgridwidth, delete e1.minorgridcolor)) : (delete e1.gridcolor, delete e1.gridWidth), "none" === e1.showticklabels && (delete e1.tickfont, delete e1.tickangle, delete e1.showexponent, delete e1.exponentformat, delete e1.minexponent, delete e1.tickformat, delete e1.showticksuffix, delete e1.showtickprefix), e1.showticksuffix || delete e1.ticksuffix, e1.showtickprefix || delete e1.tickprefix, g("tickmode"), e1;
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../../plots/cartesian/axis_autotype": 555,
                "../../plots/cartesian/category_order_defaults": 559,
                "../../plots/cartesian/prefix_suffix_defaults": 573,
                "../../plots/cartesian/set_convert": 576,
                "../../plots/cartesian/tick_label_defaults": 578,
                "../../plots/cartesian/tick_value_defaults": 580,
                "../../registry": 638,
                "./attributes": 691
            }
        ],
        695: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes"), i = t1("../../lib").isArray1D, a = t1("./cheater_basis"), o = t1("./array_minmax"), s = t1("./calc_gridlines"), l = t1("./calc_labels"), c = t1("./calc_clippath"), u = t1("../heatmap/clean_2d_array"), f = t1("./smooth_fill_2d_array"), h = t1("../heatmap/convert_column_xyz"), p = t1("./set_convert");
                e1.exports = function(t1, e1) {
                    var r = n.getFromId(t1, e1.xaxis), d = n.getFromId(t1, e1.yaxis), m = e1.aaxis, g = e1.baxis, v = e1.x, y = e1.y, x = [];
                    v && i(v) && x.push("x"), y && i(y) && x.push("y"), x.length && h(e1, m, g, "a", "b", x);
                    var b = e1._a = e1._a || e1.a, _ = e1._b = e1._b || e1.b;
                    v = e1._x || e1.x, y = e1._y || e1.y;
                    var w = {};
                    if (e1._cheater) {
                        var T = "index" === m.cheatertype ? b.length : b, k = "index" === g.cheatertype ? _.length : _;
                        v = a(T, k, e1.cheaterslope);
                    }
                    e1._x = v = u(v), e1._y = y = u(y), f(v, b, _), f(y, b, _), p(e1), e1.setScale();
                    var A = o(v), M = o(y), S = .5 * (A[1] - A[0]), E = .5 * (A[1] + A[0]), L = .5 * (M[1] - M[0]), C = .5 * (M[1] + M[0]);
                    return A = [
                        E - 1.3 * S,
                        E + 1.3 * S
                    ], M = [
                        C - 1.3 * L,
                        C + 1.3 * L
                    ], e1._extremes[r._id] = n.findExtremes(r, A, {
                        padded: !0
                    }), e1._extremes[d._id] = n.findExtremes(d, M, {
                        padded: !0
                    }), s(e1, "a", "b"), s(e1, "b", "a"), l(e1, m), l(e1, g), w.clipsegments = c(e1._xctrl, e1._yctrl, m, g), w.x = v, w.y = y, w.a = b, w.b = _, [
                        w
                    ];
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "../heatmap/clean_2d_array": 794,
                "../heatmap/convert_column_xyz": 796,
                "./array_minmax": 690,
                "./calc_clippath": 696,
                "./calc_gridlines": 697,
                "./calc_labels": 698,
                "./cheater_basis": 700,
                "./set_convert": 713,
                "./smooth_fill_2d_array": 714
            }
        ],
        696: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n) {
                    var i, a, o, s = [], l = !!r.smoothing, c = !!n.smoothing, u = t1[0].length - 1, f = t1.length - 1;
                    for(i = 0, a = [], o = []; i <= u; i++)a[i] = t1[0][i], o[i] = e1[0][i];
                    for(s.push({
                        x: a,
                        y: o,
                        bicubic: l
                    }), i = 0, a = [], o = []; i <= f; i++)a[i] = t1[i][u], o[i] = e1[i][u];
                    for(s.push({
                        x: a,
                        y: o,
                        bicubic: c
                    }), i = u, a = [], o = []; i >= 0; i--)a[u - i] = t1[f][i], o[u - i] = e1[f][i];
                    for(s.push({
                        x: a,
                        y: o,
                        bicubic: l
                    }), i = f, a = [], o = []; i >= 0; i--)a[f - i] = t1[i][0], o[f - i] = e1[i][0];
                    return s.push({
                        x: a,
                        y: o,
                        bicubic: c
                    }), s;
                };
            },
            {}
        ],
        697: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes"), i = t1("../../lib/extend").extendFlat;
                e1.exports = function(t1, e1, r) {
                    var a, o, s, l, c, u, f, h, p, d, m, g, v, y, x = t1["_" + e1], b = t1[e1 + "axis"], _ = b._gridlines = [], w = b._minorgridlines = [], T = b._boundarylines = [], k = t1["_" + r], A = t1[r + "axis"];
                    "array" === b.tickmode && (b.tickvals = x.slice());
                    var M = t1._xctrl, S = t1._yctrl, E = M[0].length, L = M.length, C = t1._a.length, P = t1._b.length;
                    n.prepTicks(b), "array" === b.tickmode && delete b.tickvals;
                    var I = b.smoothing ? 3 : 1;
                    function O(n) {
                        var i, a, o, s, l, c, u, f, p, d, m, g, v = [], y = [], x = {};
                        if ("b" === e1) for(a = t1.b2j(n), o = Math.floor(Math.max(0, Math.min(P - 2, a))), s = a - o, x.length = P, x.crossLength = C, x.xy = function(e1) {
                            return t1.evalxy([], e1, a);
                        }, x.dxy = function(e1, r) {
                            return t1.dxydi([], e1, o, r, s);
                        }, i = 0; i < C; i++)c = Math.min(C - 2, i), u = i - c, f = t1.evalxy([], i, a), A.smoothing && i > 0 && (p = t1.dxydi([], i - 1, o, 0, s), v.push(l[0] + p[0] / 3), y.push(l[1] + p[1] / 3), d = t1.dxydi([], i - 1, o, 1, s), v.push(f[0] - d[0] / 3), y.push(f[1] - d[1] / 3)), v.push(f[0]), y.push(f[1]), l = f;
                        else for(i = t1.a2i(n), c = Math.floor(Math.max(0, Math.min(C - 2, i))), u = i - c, x.length = C, x.crossLength = P, x.xy = function(e1) {
                            return t1.evalxy([], i, e1);
                        }, x.dxy = function(e1, r) {
                            return t1.dxydj([], c, e1, u, r);
                        }, a = 0; a < P; a++)o = Math.min(P - 2, a), s = a - o, f = t1.evalxy([], i, a), A.smoothing && a > 0 && (m = t1.dxydj([], c, a - 1, u, 0), v.push(l[0] + m[0] / 3), y.push(l[1] + m[1] / 3), g = t1.dxydj([], c, a - 1, u, 1), v.push(f[0] - g[0] / 3), y.push(f[1] - g[1] / 3)), v.push(f[0]), y.push(f[1]), l = f;
                        return x.axisLetter = e1, x.axis = b, x.crossAxis = A, x.value = n, x.constvar = r, x.index = h, x.x = v, x.y = y, x.smoothing = A.smoothing, x;
                    }
                    function z(n) {
                        var i, a, o, s, l, c = [], u = [], f = {};
                        if (f.length = x.length, f.crossLength = k.length, "b" === e1) for(o = Math.max(0, Math.min(P - 2, n)), l = Math.min(1, Math.max(0, n - o)), f.xy = function(e1) {
                            return t1.evalxy([], e1, n);
                        }, f.dxy = function(e1, r) {
                            return t1.dxydi([], e1, o, r, l);
                        }, i = 0; i < E; i++)c[i] = M[n * I][i], u[i] = S[n * I][i];
                        else for(a = Math.max(0, Math.min(C - 2, n)), s = Math.min(1, Math.max(0, n - a)), f.xy = function(e1) {
                            return t1.evalxy([], n, e1);
                        }, f.dxy = function(e1, r) {
                            return t1.dxydj([], a, e1, s, r);
                        }, i = 0; i < L; i++)c[i] = M[i][n * I], u[i] = S[i][n * I];
                        return f.axisLetter = e1, f.axis = b, f.crossAxis = A, f.value = x[n], f.constvar = r, f.index = n, f.x = c, f.y = u, f.smoothing = A.smoothing, f;
                    }
                    if ("array" === b.tickmode) {
                        for(l = 5e-15, u = (c = [
                            Math.floor((x.length - 1 - b.arraytick0) / b.arraydtick * (1 + l)),
                            Math.ceil(-b.arraytick0 / b.arraydtick / (1 + l))
                        ].sort(function(t1, e1) {
                            return t1 - e1;
                        }))[0] - 1, f = c[1] + 1, h = u; h < f; h++)(o = b.arraytick0 + b.arraydtick * h) < 0 || o > x.length - 1 || _.push(i(z(o), {
                            color: b.gridcolor,
                            width: b.gridwidth
                        }));
                        for(h = u; h < f; h++)if (s = b.arraytick0 + b.arraydtick * h, m = Math.min(s + b.arraydtick, x.length - 1), !(s < 0 || s > x.length - 1 || m < 0 || m > x.length - 1)) for(g = x[s], v = x[m], a = 0; a < b.minorgridcount; a++)(y = m - s) <= 0 || (d = g + (v - g) * (a + 1) / (b.minorgridcount + 1) * (b.arraydtick / y)) < x[0] || d > x[x.length - 1] || w.push(i(O(d), {
                            color: b.minorgridcolor,
                            width: b.minorgridwidth
                        }));
                        b.startline && T.push(i(z(0), {
                            color: b.startlinecolor,
                            width: b.startlinewidth
                        })), b.endline && T.push(i(z(x.length - 1), {
                            color: b.endlinecolor,
                            width: b.endlinewidth
                        }));
                    } else {
                        for(l = 5e-15, u = (c = [
                            Math.floor((x[x.length - 1] - b.tick0) / b.dtick * (1 + l)),
                            Math.ceil((x[0] - b.tick0) / b.dtick / (1 + l))
                        ].sort(function(t1, e1) {
                            return t1 - e1;
                        }))[0], f = c[1], h = u; h <= f; h++)p = b.tick0 + b.dtick * h, _.push(i(O(p), {
                            color: b.gridcolor,
                            width: b.gridwidth
                        }));
                        for(h = u - 1; h < f + 1; h++)for(p = b.tick0 + b.dtick * h, a = 0; a < b.minorgridcount; a++)(d = p + b.dtick * (a + 1) / (b.minorgridcount + 1)) < x[0] || d > x[x.length - 1] || w.push(i(O(d), {
                            color: b.minorgridcolor,
                            width: b.minorgridwidth
                        }));
                        b.startline && T.push(i(O(x[0]), {
                            color: b.startlinecolor,
                            width: b.startlinewidth
                        })), b.endline && T.push(i(O(x[x.length - 1]), {
                            color: b.endlinecolor,
                            width: b.endlinewidth
                        }));
                    }
                };
            },
            {
                "../../lib/extend": 493,
                "../../plots/cartesian/axes": 554
            }
        ],
        698: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes"), i = t1("../../lib/extend").extendFlat;
                e1.exports = function(t1, e1) {
                    var r, a, o, s = e1._labels = [], l = e1._gridlines;
                    for(r = 0; r < l.length; r++)o = l[r], -1 !== [
                        "start",
                        "both"
                    ].indexOf(e1.showticklabels) && (a = n.tickText(e1, o.value), i(a, {
                        prefix: void 0,
                        suffix: void 0,
                        endAnchor: !0,
                        xy: o.xy(0),
                        dxy: o.dxy(0, 0),
                        axis: o.axis,
                        length: o.crossAxis.length,
                        font: o.axis.tickfont,
                        isFirst: 0 === r,
                        isLast: r === l.length - 1
                    }), s.push(a)), -1 !== [
                        "end",
                        "both"
                    ].indexOf(e1.showticklabels) && (a = n.tickText(e1, o.value), i(a, {
                        endAnchor: !1,
                        xy: o.xy(o.crossLength - 1),
                        dxy: o.dxy(o.crossLength - 2, 1),
                        axis: o.axis,
                        length: o.crossAxis.length,
                        font: o.axis.tickfont,
                        isFirst: 0 === r,
                        isLast: r === l.length - 1
                    }), s.push(a));
                };
            },
            {
                "../../lib/extend": 493,
                "../../plots/cartesian/axes": 554
            }
        ],
        699: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n) {
                    var i = t1[0] - e1[0], a = t1[1] - e1[1], o = r[0] - e1[0], s = r[1] - e1[1], l = Math.pow(i * i + a * a, .25), c = Math.pow(o * o + s * s, .25), u = (c * c * i - l * l * o) * n, f = (c * c * a - l * l * s) * n, h = c * (l + c) * 3, p = l * (l + c) * 3;
                    return [
                        [
                            e1[0] + (h && u / h),
                            e1[1] + (h && f / h)
                        ],
                        [
                            e1[0] - (p && u / p),
                            e1[1] - (p && f / p)
                        ]
                    ];
                };
            },
            {}
        ],
        700: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").isArrayOrTypedArray;
                e1.exports = function(t1, e1, r) {
                    var i, a, o, s, l, c, u = [], f = n(t1) ? t1.length : t1, h = n(e1) ? e1.length : e1, p = n(t1) ? t1 : null, d = n(e1) ? e1 : null;
                    p && (o = (p.length - 1) / (p[p.length - 1] - p[0]) / (f - 1)), d && (s = (d.length - 1) / (d[d.length - 1] - d[0]) / (h - 1));
                    var m = 1 / 0, g = -1 / 0;
                    for(a = 0; a < h; a++)for(u[a] = [], l = d ? (d[a] - d[0]) * s : a / (h - 1), i = 0; i < f; i++)c = (p ? (p[i] - p[0]) * o : i / (f - 1)) - l * r, m = Math.min(c, m), g = Math.max(c, g), u[a][i] = c;
                    var v = 1 / (g - m), y = -m * v;
                    for(a = 0; a < h; a++)for(i = 0; i < f; i++)u[a][i] = v * u[a][i] + y;
                    return u;
                };
            },
            {
                "../../lib": 503
            }
        ],
        701: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./catmull_rom"), i = t1("../../lib").ensureArray;
                function a(t1, e1, r) {
                    var n = -0.5 * r[0] + 1.5 * e1[0], i = -0.5 * r[1] + 1.5 * e1[1];
                    return [
                        (2 * n + t1[0]) / 3,
                        (2 * i + t1[1]) / 3
                    ];
                }
                e1.exports = function(t1, e1, r, o, s, l) {
                    var c, u, f, h, p, d, m, g, v, y, x = r[0].length, b = r.length, _ = s ? 3 * x - 2 : x, w = l ? 3 * b - 2 : b;
                    for(t1 = i(t1, w), e1 = i(e1, w), f = 0; f < w; f++)t1[f] = i(t1[f], _), e1[f] = i(e1[f], _);
                    for(u = 0, h = 0; u < b; u++, h += l ? 3 : 1)for(p = t1[h], d = e1[h], m = r[u], g = o[u], c = 0, f = 0; c < x; c++, f += s ? 3 : 1)p[f] = m[c], d[f] = g[c];
                    if (s) for(u = 0, h = 0; u < b; u++, h += l ? 3 : 1){
                        for(c = 1, f = 3; c < x - 1; c++, f += 3)v = n([
                            r[u][c - 1],
                            o[u][c - 1]
                        ], [
                            r[u][c],
                            o[u][c]
                        ], [
                            r[u][c + 1],
                            o[u][c + 1]
                        ], s), t1[h][f - 1] = v[0][0], e1[h][f - 1] = v[0][1], t1[h][f + 1] = v[1][0], e1[h][f + 1] = v[1][1];
                        y = a([
                            t1[h][0],
                            e1[h][0]
                        ], [
                            t1[h][2],
                            e1[h][2]
                        ], [
                            t1[h][3],
                            e1[h][3]
                        ]), t1[h][1] = y[0], e1[h][1] = y[1], y = a([
                            t1[h][_ - 1],
                            e1[h][_ - 1]
                        ], [
                            t1[h][_ - 3],
                            e1[h][_ - 3]
                        ], [
                            t1[h][_ - 4],
                            e1[h][_ - 4]
                        ]), t1[h][_ - 2] = y[0], e1[h][_ - 2] = y[1];
                    }
                    if (l) for(f = 0; f < _; f++){
                        for(h = 3; h < w - 3; h += 3)v = n([
                            t1[h - 3][f],
                            e1[h - 3][f]
                        ], [
                            t1[h][f],
                            e1[h][f]
                        ], [
                            t1[h + 3][f],
                            e1[h + 3][f]
                        ], l), t1[h - 1][f] = v[0][0], e1[h - 1][f] = v[0][1], t1[h + 1][f] = v[1][0], e1[h + 1][f] = v[1][1];
                        y = a([
                            t1[0][f],
                            e1[0][f]
                        ], [
                            t1[2][f],
                            e1[2][f]
                        ], [
                            t1[3][f],
                            e1[3][f]
                        ]), t1[1][f] = y[0], e1[1][f] = y[1], y = a([
                            t1[w - 1][f],
                            e1[w - 1][f]
                        ], [
                            t1[w - 3][f],
                            e1[w - 3][f]
                        ], [
                            t1[w - 4][f],
                            e1[w - 4][f]
                        ]), t1[w - 2][f] = y[0], e1[w - 2][f] = y[1];
                    }
                    if (s && l) for(h = 1; h < w; h += (h + 1) % 3 == 0 ? 2 : 1){
                        for(f = 3; f < _ - 3; f += 3)v = n([
                            t1[h][f - 3],
                            e1[h][f - 3]
                        ], [
                            t1[h][f],
                            e1[h][f]
                        ], [
                            t1[h][f + 3],
                            e1[h][f + 3]
                        ], s), t1[h][f - 1] = .5 * (t1[h][f - 1] + v[0][0]), e1[h][f - 1] = .5 * (e1[h][f - 1] + v[0][1]), t1[h][f + 1] = .5 * (t1[h][f + 1] + v[1][0]), e1[h][f + 1] = .5 * (e1[h][f + 1] + v[1][1]);
                        y = a([
                            t1[h][0],
                            e1[h][0]
                        ], [
                            t1[h][2],
                            e1[h][2]
                        ], [
                            t1[h][3],
                            e1[h][3]
                        ]), t1[h][1] = .5 * (t1[h][1] + y[0]), e1[h][1] = .5 * (e1[h][1] + y[1]), y = a([
                            t1[h][_ - 1],
                            e1[h][_ - 1]
                        ], [
                            t1[h][_ - 3],
                            e1[h][_ - 3]
                        ], [
                            t1[h][_ - 4],
                            e1[h][_ - 4]
                        ]), t1[h][_ - 2] = .5 * (t1[h][_ - 2] + y[0]), e1[h][_ - 2] = .5 * (e1[h][_ - 2] + y[1]);
                    }
                    return [
                        t1,
                        e1
                    ];
                };
            },
            {
                "../../lib": 503,
                "./catmull_rom": 699
            }
        ],
        702: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    RELATIVE_CULL_TOLERANCE: 1e-6
                };
            },
            {}
        ],
        703: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r) {
                    return e1 && r ? function(e1, r, n, i, a) {
                        var o, s, l, c, u, f;
                        e1 || (e1 = []), r *= 3, n *= 3;
                        var h = i * i, p = 1 - i, d = p * p, m = p * i * 2, g = -3 * d, v = 3 * (d - m), y = 3 * (m - h), x = 3 * h, b = a * a, _ = b * a, w = 1 - a, T = w * w, k = T * w;
                        for(f = 0; f < t1.length; f++)o = g * (u = t1[f])[n][r] + v * u[n][r + 1] + y * u[n][r + 2] + x * u[n][r + 3], s = g * u[n + 1][r] + v * u[n + 1][r + 1] + y * u[n + 1][r + 2] + x * u[n + 1][r + 3], l = g * u[n + 2][r] + v * u[n + 2][r + 1] + y * u[n + 2][r + 2] + x * u[n + 2][r + 3], c = g * u[n + 3][r] + v * u[n + 3][r + 1] + y * u[n + 3][r + 2] + x * u[n + 3][r + 3], e1[f] = k * o + 3 * (T * a * s + w * b * l) + _ * c;
                        return e1;
                    } : e1 ? function(e1, r, n, i, a) {
                        var o, s, l, c;
                        e1 || (e1 = []), r *= 3;
                        var u = i * i, f = 1 - i, h = f * f, p = f * i * 2, d = -3 * h, m = 3 * (h - p), g = 3 * (p - u), v = 3 * u, y = 1 - a;
                        for(l = 0; l < t1.length; l++)o = d * (c = t1[l])[n][r] + m * c[n][r + 1] + g * c[n][r + 2] + v * c[n][r + 3], s = d * c[n + 1][r] + m * c[n + 1][r + 1] + g * c[n + 1][r + 2] + v * c[n + 1][r + 3], e1[l] = y * o + a * s;
                        return e1;
                    } : r ? function(e1, r, n, i, a) {
                        var o, s, l, c, u, f;
                        e1 || (e1 = []), n *= 3;
                        var h = a * a, p = h * a, d = 1 - a, m = d * d, g = m * d;
                        for(u = 0; u < t1.length; u++)o = (f = t1[u])[n][r + 1] - f[n][r], s = f[n + 1][r + 1] - f[n + 1][r], l = f[n + 2][r + 1] - f[n + 2][r], c = f[n + 3][r + 1] - f[n + 3][r], e1[u] = g * o + 3 * (m * a * s + d * h * l) + p * c;
                        return e1;
                    } : function(e1, r, n, i, a) {
                        var o, s, l, c;
                        e1 || (e1 = []);
                        var u = 1 - a;
                        for(l = 0; l < t1.length; l++)o = (c = t1[l])[n][r + 1] - c[n][r], s = c[n + 1][r + 1] - c[n + 1][r], e1[l] = u * o + a * s;
                        return e1;
                    };
                };
            },
            {}
        ],
        704: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r) {
                    return e1 && r ? function(e1, r, n, i, a) {
                        var o, s, l, c, u, f;
                        e1 || (e1 = []), r *= 3, n *= 3;
                        var h = i * i, p = h * i, d = 1 - i, m = d * d, g = m * d, v = a * a, y = 1 - a, x = y * y, b = y * a * 2, _ = -3 * x, w = 3 * (x - b), T = 3 * (b - v), k = 3 * v;
                        for(f = 0; f < t1.length; f++)o = _ * (u = t1[f])[n][r] + w * u[n + 1][r] + T * u[n + 2][r] + k * u[n + 3][r], s = _ * u[n][r + 1] + w * u[n + 1][r + 1] + T * u[n + 2][r + 1] + k * u[n + 3][r + 1], l = _ * u[n][r + 2] + w * u[n + 1][r + 2] + T * u[n + 2][r + 2] + k * u[n + 3][r + 2], c = _ * u[n][r + 3] + w * u[n + 1][r + 3] + T * u[n + 2][r + 3] + k * u[n + 3][r + 3], e1[f] = g * o + 3 * (m * i * s + d * h * l) + p * c;
                        return e1;
                    } : e1 ? function(e1, r, n, i, a) {
                        var o, s, l, c, u, f;
                        e1 || (e1 = []), r *= 3;
                        var h = a * a, p = h * a, d = 1 - a, m = d * d, g = m * d;
                        for(u = 0; u < t1.length; u++)o = (f = t1[u])[n + 1][r] - f[n][r], s = f[n + 1][r + 1] - f[n][r + 1], l = f[n + 1][r + 2] - f[n][r + 2], c = f[n + 1][r + 3] - f[n][r + 3], e1[u] = g * o + 3 * (m * a * s + d * h * l) + p * c;
                        return e1;
                    } : r ? function(e1, r, n, i, a) {
                        var o, s, l, c;
                        e1 || (e1 = []), n *= 3;
                        var u = 1 - i, f = a * a, h = 1 - a, p = h * h, d = h * a * 2, m = -3 * p, g = 3 * (p - d), v = 3 * (d - f), y = 3 * f;
                        for(l = 0; l < t1.length; l++)o = m * (c = t1[l])[n][r] + g * c[n + 1][r] + v * c[n + 2][r] + y * c[n + 3][r], s = m * c[n][r + 1] + g * c[n + 1][r + 1] + v * c[n + 2][r + 1] + y * c[n + 3][r + 1], e1[l] = u * o + i * s;
                        return e1;
                    } : function(e1, r, n, i, a) {
                        var o, s, l, c;
                        e1 || (e1 = []);
                        var u = 1 - i;
                        for(l = 0; l < t1.length; l++)o = (c = t1[l])[n + 1][r] - c[n][r], s = c[n + 1][r + 1] - c[n][r + 1], e1[l] = u * o + i * s;
                        return e1;
                    };
                };
            },
            {}
        ],
        705: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n, i) {
                    var a = e1 - 2, o = r - 2;
                    return n && i ? function(e1, r, n) {
                        var i, s, l, c, u, f;
                        e1 || (e1 = []);
                        var h = Math.max(0, Math.min(Math.floor(r), a)), p = Math.max(0, Math.min(Math.floor(n), o)), d = Math.max(0, Math.min(1, r - h)), m = Math.max(0, Math.min(1, n - p));
                        h *= 3, p *= 3;
                        var g = d * d, v = g * d, y = 1 - d, x = y * y, b = x * y, _ = m * m, w = _ * m, T = 1 - m, k = T * T, A = k * T;
                        for(f = 0; f < t1.length; f++)i = b * (u = t1[f])[p][h] + 3 * (x * d * u[p][h + 1] + y * g * u[p][h + 2]) + v * u[p][h + 3], s = b * u[p + 1][h] + 3 * (x * d * u[p + 1][h + 1] + y * g * u[p + 1][h + 2]) + v * u[p + 1][h + 3], l = b * u[p + 2][h] + 3 * (x * d * u[p + 2][h + 1] + y * g * u[p + 2][h + 2]) + v * u[p + 2][h + 3], c = b * u[p + 3][h] + 3 * (x * d * u[p + 3][h + 1] + y * g * u[p + 3][h + 2]) + v * u[p + 3][h + 3], e1[f] = A * i + 3 * (k * m * s + T * _ * l) + w * c;
                        return e1;
                    } : n ? function(e1, r, n) {
                        e1 || (e1 = []);
                        var i, s, l, c, u, f, h = Math.max(0, Math.min(Math.floor(r), a)), p = Math.max(0, Math.min(Math.floor(n), o)), d = Math.max(0, Math.min(1, r - h)), m = Math.max(0, Math.min(1, n - p));
                        h *= 3;
                        var g = d * d, v = g * d, y = 1 - d, x = y * y, b = x * y, _ = 1 - m;
                        for(u = 0; u < t1.length; u++)i = _ * (f = t1[u])[p][h] + m * f[p + 1][h], s = _ * f[p][h + 1] + m * f[p + 1][h + 1], l = _ * f[p][h + 2] + m * f[p + 1][h + 1], c = _ * f[p][h + 3] + m * f[p + 1][h + 1], e1[u] = b * i + 3 * (x * d * s + y * g * l) + v * c;
                        return e1;
                    } : i ? function(e1, r, n) {
                        e1 || (e1 = []);
                        var i, s, l, c, u, f, h = Math.max(0, Math.min(Math.floor(r), a)), p = Math.max(0, Math.min(Math.floor(n), o)), d = Math.max(0, Math.min(1, r - h)), m = Math.max(0, Math.min(1, n - p));
                        p *= 3;
                        var g = m * m, v = g * m, y = 1 - m, x = y * y, b = x * y, _ = 1 - d;
                        for(u = 0; u < t1.length; u++)i = _ * (f = t1[u])[p][h] + d * f[p][h + 1], s = _ * f[p + 1][h] + d * f[p + 1][h + 1], l = _ * f[p + 2][h] + d * f[p + 2][h + 1], c = _ * f[p + 3][h] + d * f[p + 3][h + 1], e1[u] = b * i + 3 * (x * m * s + y * g * l) + v * c;
                        return e1;
                    } : function(e1, r, n) {
                        e1 || (e1 = []);
                        var i, s, l, c, u = Math.max(0, Math.min(Math.floor(r), a)), f = Math.max(0, Math.min(Math.floor(n), o)), h = Math.max(0, Math.min(1, r - u)), p = Math.max(0, Math.min(1, n - f)), d = 1 - p, m = 1 - h;
                        for(l = 0; l < t1.length; l++)i = m * (c = t1[l])[f][u] + h * c[f][u + 1], s = m * c[f + 1][u] + h * c[f + 1][u + 1], e1[l] = d * i + p * s;
                        return e1;
                    };
                };
            },
            {}
        ],
        706: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./xy_defaults"), a = t1("./ab_defaults"), o = t1("./attributes"), s = t1("../../components/color/attributes");
                e1.exports = function(t1, e1, r, l) {
                    function c(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    e1._clipPathId = "clip" + e1.uid + "carpet";
                    var u = c("color", s.defaultLine);
                    (n.coerceFont(c, "font"), c("carpet"), a(t1, e1, l, c, u), e1.a && e1.b) ? (e1.a.length < 3 && (e1.aaxis.smoothing = 0), e1.b.length < 3 && (e1.baxis.smoothing = 0), i(t1, e1, c) || (e1.visible = !1), e1._cheater && c("cheaterslope")) : e1.visible = !1;
                };
            },
            {
                "../../components/color/attributes": 365,
                "../../lib": 503,
                "./ab_defaults": 689,
                "./attributes": 691,
                "./xy_defaults": 715
            }
        ],
        707: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    plot: t1("./plot"),
                    calc: t1("./calc"),
                    animatable: !0,
                    isContainer: !0,
                    moduleType: "trace",
                    name: "carpet",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "cartesian",
                        "svg",
                        "carpet",
                        "carpetAxis",
                        "notLegendIsolatable",
                        "noMultiCategory",
                        "noHover",
                        "noSortingByValue"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "./attributes": 691,
                "./calc": 695,
                "./defaults": 706,
                "./plot": 712
            }
        ],
        708: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    for(var r, n = t1._fullData.length, i = 0; i < n; i++){
                        var a = t1._fullData[i];
                        if (a.index !== e1.index && "carpet" === a.type && (r || (r = a), a.carpet === e1.carpet)) return a;
                    }
                    return r;
                };
            },
            {}
        ],
        709: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r) {
                    if (0 === t1.length) return "";
                    var n, i = [], a = r ? 3 : 1;
                    for(n = 0; n < t1.length; n += a)i.push(t1[n] + "," + e1[n]), r && n < t1.length - a && (i.push("C"), i.push([
                        t1[n + 1] + "," + e1[n + 1],
                        t1[n + 2] + "," + e1[n + 2] + " "
                    ].join(" ")));
                    return i.join(r ? "" : "L");
                };
            },
            {}
        ],
        710: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").isArrayOrTypedArray;
                e1.exports = function(t1, e1, r) {
                    var i;
                    for(n(t1) ? t1.length > e1.length && (t1 = t1.slice(0, e1.length)) : t1 = [], i = 0; i < e1.length; i++)t1[i] = r(e1[i]);
                    return t1;
                };
            },
            {
                "../../lib": 503
            }
        ],
        711: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n, i, a) {
                    var o = i[0] * t1.dpdx(e1), s = i[1] * t1.dpdy(r), l = 1, c = 1;
                    if (a) {
                        var u = Math.sqrt(i[0] * i[0] + i[1] * i[1]), f = Math.sqrt(a[0] * a[0] + a[1] * a[1]), h = (i[0] * a[0] + i[1] * a[1]) / u / f;
                        c = Math.max(0, h);
                    }
                    var p = 180 * Math.atan2(s, o) / Math.PI;
                    return p < -90 ? (p += 180, l = -l) : p > 90 && (p -= 180, l = -l), {
                        angle: p,
                        flip: l,
                        p: t1.c2p(n, e1, r),
                        offsetMultplier: c
                    };
                };
            },
            {}
        ],
        712: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/drawing"), a = t1("./map_1d_array"), o = t1("./makepath"), s = t1("./orient_text"), l = t1("../../lib/svg_text_utils"), c = t1("../../lib"), u = c.strRotate, f = c.strTranslate, h = t1("../../constants/alignment");
                function p(t1, e1, r, i, s, l) {
                    var c = "const-" + s + "-lines", u = r.selectAll("." + c).data(l);
                    u.enter().append("path").classed(c, !0).style("vector-effect", "non-scaling-stroke"), u.each(function(r) {
                        var i = r, s = i.x, l = i.y, c = a([], s, t1.c2p), u = a([], l, e1.c2p), f = "M" + o(c, u, i.smoothing);
                        n.select(this).attr("d", f).style("stroke-width", i.width).style("stroke", i.color).style("fill", "none");
                    }), u.exit().remove();
                }
                function d(t1, e1, r, a, o, c, h, p) {
                    var d = c.selectAll("text." + p).data(h);
                    d.enter().append("text").classed(p, !0);
                    var m = 0, g = {};
                    return d.each(function(o, c) {
                        var h;
                        if ("auto" === o.axis.tickangle) h = s(a, e1, r, o.xy, o.dxy);
                        else {
                            var p = (o.axis.tickangle + 180) * Math.PI / 180;
                            h = s(a, e1, r, o.xy, [
                                Math.cos(p),
                                Math.sin(p)
                            ]);
                        }
                        c || (g = {
                            angle: h.angle,
                            flip: h.flip
                        });
                        var d = (o.endAnchor ? -1 : 1) * h.flip, v = n.select(this).attr({
                            "text-anchor": d > 0 ? "start" : "end",
                            "data-notex": 1
                        }).call(i.font, o.font).text(o.text).call(l.convertToTspans, t1), y = i.bBox(this);
                        v.attr("transform", f(h.p[0], h.p[1]) + u(h.angle) + f(o.axis.labelpadding * d, .3 * y.height)), m = Math.max(m, y.width + o.axis.labelpadding);
                    }), d.exit().remove(), g.maxExtent = m, g;
                }
                e1.exports = function(t1, e1, r, i) {
                    var l = e1.xaxis, u = e1.yaxis, f = t1._fullLayout._clips;
                    c.makeTraceGroups(i, r, "trace").each(function(e1) {
                        var r = n.select(this), i = e1[0], h = i.trace, m = h.aaxis, g = h.baxis, y = c.ensureSingle(r, "g", "minorlayer"), x = c.ensureSingle(r, "g", "majorlayer"), b = c.ensureSingle(r, "g", "boundarylayer"), _ = c.ensureSingle(r, "g", "labellayer");
                        r.style("opacity", h.opacity), p(l, u, x, m, "a", m._gridlines), p(l, u, x, g, "b", g._gridlines), p(l, u, y, m, "a", m._minorgridlines), p(l, u, y, g, "b", g._minorgridlines), p(l, u, b, m, "a-boundary", m._boundarylines), p(l, u, b, g, "b-boundary", g._boundarylines);
                        var w = d(t1, l, u, h, i, _, m._labels, "a-label"), T = d(t1, l, u, h, i, _, g._labels, "b-label");
                        !function(t1, e1, r, n, i, a, o, l) {
                            var u, f, h, p, d = c.aggNums(Math.min, null, r.a), m = c.aggNums(Math.max, null, r.a), g = c.aggNums(Math.min, null, r.b), y = c.aggNums(Math.max, null, r.b);
                            u = .5 * (d + m), f = g, h = r.ab2xy(u, f, !0), p = r.dxyda_rough(u, f), void 0 === o.angle && c.extendFlat(o, s(r, i, a, h, r.dxydb_rough(u, f)));
                            v(t1, e1, r, n, h, p, r.aaxis, i, a, o, "a-title"), u = d, f = .5 * (g + y), h = r.ab2xy(u, f, !0), p = r.dxydb_rough(u, f), void 0 === l.angle && c.extendFlat(l, s(r, i, a, h, r.dxyda_rough(u, f)));
                            v(t1, e1, r, n, h, p, r.baxis, i, a, l, "b-title");
                        }(t1, _, h, i, l, u, w, T), function(t1, e1, r, n, i) {
                            var s, l, u, f, h = r.select("#" + t1._clipPathId);
                            h.size() || (h = r.append("clipPath").classed("carpetclip", !0));
                            var p = c.ensureSingle(h, "path", "carpetboundary"), d = e1.clipsegments, m = [];
                            for(f = 0; f < d.length; f++)s = d[f], l = a([], s.x, n.c2p), u = a([], s.y, i.c2p), m.push(o(l, u, s.bicubic));
                            var g = "M" + m.join("L") + "Z";
                            h.attr("id", t1._clipPathId), p.attr("d", g);
                        }(h, i, f, l, u);
                    });
                };
                var m = h.LINE_SPACING, g = (1 - h.MID_SHIFT) / m + 1;
                function v(t1, e1, r, a, o, c, h, p, d, v, y) {
                    var x = [];
                    h.title.text && x.push(h.title.text);
                    var b = e1.selectAll("text." + y).data(x), _ = v.maxExtent;
                    b.enter().append("text").classed(y, !0), b.each(function() {
                        var e1 = s(r, p, d, o, c);
                        -1 === [
                            "start",
                            "both"
                        ].indexOf(h.showticklabels) && (_ = 0);
                        var a = h.title.font.size;
                        _ += a + h.title.offset;
                        var y = (v.angle + (v.flip < 0 ? 180 : 0) - e1.angle + 450) % 360, x = y > 90 && y < 270, b = n.select(this);
                        b.text(h.title.text).call(l.convertToTspans, t1), x && (_ = (-l.lineCount(b) + g) * m * a - _), b.attr("transform", f(e1.p[0], e1.p[1]) + u(e1.angle) + f(0, _)).attr("text-anchor", "middle").call(i.font, h.title.font);
                    }), b.exit().remove();
                }
            },
            {
                "../../components/drawing": 388,
                "../../constants/alignment": 471,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "./makepath": 709,
                "./map_1d_array": 710,
                "./orient_text": 711,
                "@plotly/d3": 58
            }
        ],
        713: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./constants"), i = t1("../../lib/search").findBin, a = t1("./compute_control_points"), o = t1("./create_spline_evaluator"), s = t1("./create_i_derivative_evaluator"), l = t1("./create_j_derivative_evaluator");
                e1.exports = function(t1) {
                    var e1 = t1._a, r = t1._b, c = e1.length, u = r.length, f = t1.aaxis, h = t1.baxis, p = e1[0], d = e1[c - 1], m = r[0], g = r[u - 1], v = e1[e1.length - 1] - e1[0], y = r[r.length - 1] - r[0], x = v * n.RELATIVE_CULL_TOLERANCE, b = y * n.RELATIVE_CULL_TOLERANCE;
                    p -= x, d += x, m -= b, g += b, t1.isVisible = function(t1, e1) {
                        return t1 > p && t1 < d && e1 > m && e1 < g;
                    }, t1.isOccluded = function(t1, e1) {
                        return t1 < p || t1 > d || e1 < m || e1 > g;
                    }, t1.setScale = function() {
                        var e1 = t1._x, r = t1._y, n = a(t1._xctrl, t1._yctrl, e1, r, f.smoothing, h.smoothing);
                        t1._xctrl = n[0], t1._yctrl = n[1], t1.evalxy = o([
                            t1._xctrl,
                            t1._yctrl
                        ], c, u, f.smoothing, h.smoothing), t1.dxydi = s([
                            t1._xctrl,
                            t1._yctrl
                        ], f.smoothing, h.smoothing), t1.dxydj = l([
                            t1._xctrl,
                            t1._yctrl
                        ], f.smoothing, h.smoothing);
                    }, t1.i2a = function(t1) {
                        var r = Math.max(0, Math.floor(t1[0]), c - 2), n = t1[0] - r;
                        return (1 - n) * e1[r] + n * e1[r + 1];
                    }, t1.j2b = function(t1) {
                        var e1 = Math.max(0, Math.floor(t1[1]), c - 2), n = t1[1] - e1;
                        return (1 - n) * r[e1] + n * r[e1 + 1];
                    }, t1.ij2ab = function(e1) {
                        return [
                            t1.i2a(e1[0]),
                            t1.j2b(e1[1])
                        ];
                    }, t1.a2i = function(t1) {
                        var r = Math.max(0, Math.min(i(t1, e1), c - 2)), n = e1[r], a = e1[r + 1];
                        return Math.max(0, Math.min(c - 1, r + (t1 - n) / (a - n)));
                    }, t1.b2j = function(t1) {
                        var e1 = Math.max(0, Math.min(i(t1, r), u - 2)), n = r[e1], a = r[e1 + 1];
                        return Math.max(0, Math.min(u - 1, e1 + (t1 - n) / (a - n)));
                    }, t1.ab2ij = function(e1) {
                        return [
                            t1.a2i(e1[0]),
                            t1.b2j(e1[1])
                        ];
                    }, t1.i2c = function(e1, r) {
                        return t1.evalxy([], e1, r);
                    }, t1.ab2xy = function(n, i, a) {
                        if (!a && (n < e1[0] || n > e1[c - 1] | i < r[0] || i > r[u - 1])) return [
                            !1,
                            !1
                        ];
                        var o = t1.a2i(n), s = t1.b2j(i), l = t1.evalxy([], o, s);
                        if (a) {
                            var f, h, p, d, m = 0, g = 0, v = [];
                            n < e1[0] ? (f = 0, h = 0, m = (n - e1[0]) / (e1[1] - e1[0])) : n > e1[c - 1] ? (f = c - 2, h = 1, m = (n - e1[c - 1]) / (e1[c - 1] - e1[c - 2])) : h = o - (f = Math.max(0, Math.min(c - 2, Math.floor(o)))), i < r[0] ? (p = 0, d = 0, g = (i - r[0]) / (r[1] - r[0])) : i > r[u - 1] ? (p = u - 2, d = 1, g = (i - r[u - 1]) / (r[u - 1] - r[u - 2])) : d = s - (p = Math.max(0, Math.min(u - 2, Math.floor(s)))), m && (t1.dxydi(v, f, p, h, d), l[0] += v[0] * m, l[1] += v[1] * m), g && (t1.dxydj(v, f, p, h, d), l[0] += v[0] * g, l[1] += v[1] * g);
                        }
                        return l;
                    }, t1.c2p = function(t1, e1, r) {
                        return [
                            e1.c2p(t1[0]),
                            r.c2p(t1[1])
                        ];
                    }, t1.p2x = function(t1, e1, r) {
                        return [
                            e1.p2c(t1[0]),
                            r.p2c(t1[1])
                        ];
                    }, t1.dadi = function(t1) {
                        var r = Math.max(0, Math.min(e1.length - 2, t1));
                        return e1[r + 1] - e1[r];
                    }, t1.dbdj = function(t1) {
                        var e1 = Math.max(0, Math.min(r.length - 2, t1));
                        return r[e1 + 1] - r[e1];
                    }, t1.dxyda = function(e1, r, n, i) {
                        var a = t1.dxydi(null, e1, r, n, i), o = t1.dadi(e1, n);
                        return [
                            a[0] / o,
                            a[1] / o
                        ];
                    }, t1.dxydb = function(e1, r, n, i) {
                        var a = t1.dxydj(null, e1, r, n, i), o = t1.dbdj(r, i);
                        return [
                            a[0] / o,
                            a[1] / o
                        ];
                    }, t1.dxyda_rough = function(e1, r, n) {
                        var i = v * (n || .1), a = t1.ab2xy(e1 + i, r, !0), o = t1.ab2xy(e1 - i, r, !0);
                        return [
                            .5 * (a[0] - o[0]) / i,
                            .5 * (a[1] - o[1]) / i
                        ];
                    }, t1.dxydb_rough = function(e1, r, n) {
                        var i = y * (n || .1), a = t1.ab2xy(e1, r + i, !0), o = t1.ab2xy(e1, r - i, !0);
                        return [
                            .5 * (a[0] - o[0]) / i,
                            .5 * (a[1] - o[1]) / i
                        ];
                    }, t1.dpdx = function(t1) {
                        return t1._m;
                    }, t1.dpdy = function(t1) {
                        return t1._m;
                    };
                };
            },
            {
                "../../lib/search": 523,
                "./compute_control_points": 701,
                "./constants": 702,
                "./create_i_derivative_evaluator": 703,
                "./create_j_derivative_evaluator": 704,
                "./create_spline_evaluator": 705
            }
        ],
        714: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = function(t1, e1, r) {
                    var i, a, o, s = [], l = [], c = t1[0].length, u = t1.length;
                    function f(e1, r) {
                        var n, i = 0, a = 0;
                        return e1 > 0 && void 0 !== (n = t1[r][e1 - 1]) && (a++, i += n), e1 < c - 1 && void 0 !== (n = t1[r][e1 + 1]) && (a++, i += n), r > 0 && void 0 !== (n = t1[r - 1][e1]) && (a++, i += n), r < u - 1 && void 0 !== (n = t1[r + 1][e1]) && (a++, i += n), i / Math.max(1, a);
                    }
                    var h, p, d, m, g, v, y, x, b, _, w, T = 0;
                    for(i = 0; i < c; i++)for(a = 0; a < u; a++)void 0 === t1[a][i] && (s.push(i), l.push(a), t1[a][i] = f(i, a)), T = Math.max(T, Math.abs(t1[a][i]));
                    if (!s.length) return t1;
                    var k = 0, A = 0, M = s.length;
                    do {
                        for(k = 0, o = 0; o < M; o++){
                            i = s[o], a = l[o];
                            var S, E, L, C, P, I, O = 0, z = 0;
                            0 === i ? (L = e1[P = Math.min(c - 1, 2)], C = e1[1], S = t1[a][P], z += (E = t1[a][1]) + (E - S) * (e1[0] - C) / (C - L), O++) : i === c - 1 && (L = e1[P = Math.max(0, c - 3)], C = e1[c - 2], S = t1[a][P], z += (E = t1[a][c - 2]) + (E - S) * (e1[c - 1] - C) / (C - L), O++), (0 === i || i === c - 1) && a > 0 && a < u - 1 && (h = r[a + 1] - r[a], z += ((p = r[a] - r[a - 1]) * t1[a + 1][i] + h * t1[a - 1][i]) / (p + h), O++), 0 === a ? (L = r[I = Math.min(u - 1, 2)], C = r[1], S = t1[I][i], z += (E = t1[1][i]) + (E - S) * (r[0] - C) / (C - L), O++) : a === u - 1 && (L = r[I = Math.max(0, u - 3)], C = r[u - 2], S = t1[I][i], z += (E = t1[u - 2][i]) + (E - S) * (r[u - 1] - C) / (C - L), O++), (0 === a || a === u - 1) && i > 0 && i < c - 1 && (h = e1[i + 1] - e1[i], z += ((p = e1[i] - e1[i - 1]) * t1[a][i + 1] + h * t1[a][i - 1]) / (p + h), O++), O ? z /= O : (d = e1[i + 1] - e1[i], m = e1[i] - e1[i - 1], x = (g = r[a + 1] - r[a]) * (v = r[a] - r[a - 1]) * (g + v), z = ((y = d * m * (d + m)) * (v * t1[a + 1][i] + g * t1[a - 1][i]) + x * (m * t1[a][i + 1] + d * t1[a][i - 1])) / (x * (m + d) + y * (v + g))), k += (_ = (b = z - t1[a][i]) / T) * _, w = O ? 0 : .85, t1[a][i] += b * (1 + w);
                        }
                        k = Math.sqrt(k);
                    }while (A++ < 100 && k > 1e-5);
                    return n.log("Smoother converged to", k, "after", A, "iterations"), t1;
                };
            },
            {
                "../../lib": 503
            }
        ],
        715: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").isArray1D;
                e1.exports = function(t1, e1, r) {
                    var i = r("x"), a = i && i.length, o = r("y"), s = o && o.length;
                    if (!a && !s) return !1;
                    if (e1._cheater = !i, a && !n(i) || s && !n(o)) e1._length = null;
                    else {
                        var l = a ? i.length : 1 / 0;
                        s && (l = Math.min(l, o.length)), e1.a && e1.a.length && (l = Math.min(l, e1.a.length)), e1.b && e1.b.length && (l = Math.min(l, e1.b.length)), e1._length = l;
                    }
                    return !0;
                };
            },
            {
                "../../lib": 503
            }
        ],
        716: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/template_attributes").hovertemplateAttrs, i = t1("../scattergeo/attributes"), a = t1("../../components/colorscale/attributes"), o = t1("../../plots/attributes"), s = t1("../../components/color/attributes").defaultLine, l = t1("../../lib/extend").extendFlat, c = i.marker.line;
                e1.exports = l({
                    locations: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    locationmode: i.locationmode,
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    geojson: l({}, i.geojson, {}),
                    featureidkey: i.featureidkey,
                    text: l({}, i.text, {}),
                    hovertext: l({}, i.hovertext, {}),
                    marker: {
                        line: {
                            color: l({}, c.color, {
                                dflt: s
                            }),
                            width: l({}, c.width, {
                                dflt: 1
                            }),
                            editType: "calc"
                        },
                        opacity: {
                            valType: "number",
                            arrayOk: !0,
                            min: 0,
                            max: 1,
                            dflt: 1,
                            editType: "style"
                        },
                        editType: "calc"
                    },
                    selected: {
                        marker: {
                            opacity: i.selected.marker.opacity,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    unselected: {
                        marker: {
                            opacity: i.unselected.marker.opacity,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    hoverinfo: l({}, o.hoverinfo, {
                        editType: "calc",
                        flags: [
                            "location",
                            "z",
                            "text",
                            "name"
                        ]
                    }),
                    hovertemplate: n(),
                    showlegend: l({}, o.showlegend, {
                        dflt: !1
                    })
                }, a("", {
                    cLetter: "z",
                    editTypeOverride: "calc"
                }));
            },
            {
                "../../components/color/attributes": 365,
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/template_attributes": 633,
                "../scattergeo/attributes": 968
            }
        ],
        717: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../constants/numerical").BADNUM, a = t1("../../components/colorscale/calc"), o = t1("../scatter/arrays_to_calcdata"), s = t1("../scatter/calc_selection");
                function l(t1) {
                    return t1 && "string" == typeof t1;
                }
                e1.exports = function(t1, e1) {
                    var r, c = e1._length, u = new Array(c);
                    r = e1.geojson ? function(t1) {
                        return l(t1) || n(t1);
                    } : l;
                    for(var f = 0; f < c; f++){
                        var h = u[f] = {}, p = e1.locations[f], d = e1.z[f];
                        r(p) && n(d) ? (h.loc = p, h.z = d) : (h.loc = null, h.z = i), h.index = f;
                    }
                    return o(u, e1), a(t1, e1, {
                        vals: e1.z,
                        containerStr: "",
                        cLetter: "z"
                    }), s(u, e1), u;
                };
            },
            {
                "../../components/colorscale/calc": 374,
                "../../constants/numerical": 479,
                "../scatter/arrays_to_calcdata": 925,
                "../scatter/calc_selection": 928,
                "fast-isnumeric": 190
            }
        ],
        718: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/colorscale/defaults"), a = t1("./attributes");
                e1.exports = function(t1, e1, r, o) {
                    function s(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var l = s("locations"), c = s("z");
                    if (l && l.length && n.isArrayOrTypedArray(c) && c.length) {
                        e1._length = Math.min(l.length, c.length);
                        var u, f = s("geojson");
                        ("string" == typeof f && "" !== f || n.isPlainObject(f)) && (u = "geojson-id"), "geojson-id" === s("locationmode", u) && s("featureidkey"), s("text"), s("hovertext"), s("hovertemplate"), s("marker.line.width") && s("marker.line.color"), s("marker.opacity"), i(t1, e1, o, s, {
                            prefix: "",
                            cLetter: "z"
                        }), n.coerceSelectionMarkerOpacity(e1, s);
                    } else e1.visible = !1;
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../lib": 503,
                "./attributes": 716
            }
        ],
        719: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n, i) {
                    t1.location = e1.location, t1.z = e1.z;
                    var a = n[i];
                    return a.fIn && a.fIn.properties && (t1.properties = a.fIn.properties), t1.ct = a.ct, t1;
                };
            },
            {}
        ],
        720: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes"), i = t1("./attributes"), a = t1("../../lib").fillText;
                e1.exports = function(t1, e1, r) {
                    var o, s, l, c, u = t1.cd, f = u[0].trace, h = t1.subplot, p = [
                        e1,
                        r
                    ], d = [
                        e1 + 360,
                        r
                    ];
                    for(s = 0; s < u.length; s++)if (c = !1, (o = u[s])._polygons) {
                        for(l = 0; l < o._polygons.length; l++)o._polygons[l].contains(p) && (c = !c), o._polygons[l].contains(d) && (c = !c);
                        if (c) break;
                    }
                    if (c && o) return t1.x0 = t1.x1 = t1.xa.c2p(o.ct), t1.y0 = t1.y1 = t1.ya.c2p(o.ct), t1.index = o.index, t1.location = o.loc, t1.z = o.z, t1.zLabel = n.tickText(h.mockAxis, h.mockAxis.c2l(o.z), "hover").text, t1.hovertemplate = o.hovertemplate, function(t1, e1, r) {
                        if (e1.hovertemplate) return;
                        var n = r.hi || e1.hoverinfo, o = String(r.loc), s = "all" === n ? i.hoverinfo.flags : n.split("+"), l = -1 !== s.indexOf("name"), c = -1 !== s.indexOf("location"), u = -1 !== s.indexOf("z"), f = -1 !== s.indexOf("text"), h = [];
                        !l && c ? t1.nameOverride = o : (l && (t1.nameOverride = e1.name), c && h.push(o));
                        u && h.push(t1.zLabel);
                        f && a(r, e1, h);
                        t1.extraText = h.join("<br>");
                    }(t1, f, o), [
                        t1
                    ];
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "./attributes": 716
            }
        ],
        721: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: t1("../heatmap/colorbar"),
                    calc: t1("./calc"),
                    calcGeoJSON: t1("./plot").calcGeoJSON,
                    plot: t1("./plot").plot,
                    style: t1("./style").style,
                    styleOnSelect: t1("./style").styleOnSelect,
                    hoverPoints: t1("./hover"),
                    eventData: t1("./event_data"),
                    selectPoints: t1("./select"),
                    moduleType: "trace",
                    name: "choropleth",
                    basePlotModule: t1("../../plots/geo"),
                    categories: [
                        "geo",
                        "noOpacity",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/geo": 589,
                "../heatmap/colorbar": 795,
                "./attributes": 716,
                "./calc": 717,
                "./defaults": 718,
                "./event_data": 719,
                "./hover": 720,
                "./plot": 722,
                "./select": 723,
                "./style": 724
            }
        ],
        722: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../../lib/geo_location_utils"), o = t1("../../lib/topojson_utils").getTopojsonFeatures, s = t1("../../plots/cartesian/autorange").findExtremes, l = t1("./style").style;
                e1.exports = {
                    calcGeoJSON: function(t1, e1) {
                        for(var r = t1[0].trace, n = e1[r.geo], i = n._subplot, l = r.locationmode, c = r._length, u = "geojson-id" === l ? a.extractTraceFeature(t1) : o(r, i.topojson), f = [], h = [], p = 0; p < c; p++){
                            var d = t1[p], m = "geojson-id" === l ? d.fOut : a.locationToFeature(l, d.loc, u);
                            if (m) {
                                d.geojson = m, d.ct = m.properties.ct, d._polygons = a.feature2polygons(m);
                                var g = a.computeBbox(m);
                                f.push(g[0], g[2]), h.push(g[1], g[3]);
                            } else d.geojson = null;
                        }
                        if ("geojson" === n.fitbounds && "geojson-id" === l) {
                            var v = a.computeBbox(a.getTraceGeojson(r));
                            f = [
                                v[0],
                                v[2]
                            ], h = [
                                v[1],
                                v[3]
                            ];
                        }
                        var y = {
                            padded: !0
                        };
                        r._extremes.lon = s(n.lonaxis._ax, f, y), r._extremes.lat = s(n.lataxis._ax, h, y);
                    },
                    plot: function(t1, e1, r) {
                        var a = e1.layers.backplot.select(".choroplethlayer");
                        i.makeTraceGroups(a, r, "trace choropleth").each(function(e1) {
                            var r = n.select(this).selectAll("path.choroplethlocation").data(i.identity);
                            r.enter().append("path").classed("choroplethlocation", !0), r.exit().remove(), l(t1, e1);
                        });
                    }
                };
            },
            {
                "../../lib": 503,
                "../../lib/geo_location_utils": 496,
                "../../lib/topojson_utils": 532,
                "../../plots/cartesian/autorange": 553,
                "./style": 724,
                "@plotly/d3": 58
            }
        ],
        723: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    var r, n, i, a, o, s = t1.cd, l = t1.xaxis, c = t1.yaxis, u = [];
                    if (!1 === e1) for(r = 0; r < s.length; r++)s[r].selected = 0;
                    else for(r = 0; r < s.length; r++)(i = (n = s[r]).ct) && (a = l.c2p(i), o = c.c2p(i), e1.contains([
                        a,
                        o
                    ], null, r, t1) ? (u.push({
                        pointNumber: r,
                        lon: i[0],
                        lat: i[1]
                    }), n.selected = 1) : n.selected = 0);
                    return u;
                };
            },
            {}
        ],
        724: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/color"), a = t1("../../components/drawing"), o = t1("../../components/colorscale");
                function s(t1, e1) {
                    var r = e1[0].trace, s = e1[0].node3.selectAll(".choroplethlocation"), l = r.marker || {}, c = l.line || {}, u = o.makeColorScaleFuncFromTrace(r);
                    s.each(function(t1) {
                        n.select(this).attr("fill", u(t1.z)).call(i.stroke, t1.mlc || c.color).call(a.dashLine, "", t1.mlw || c.width || 0).style("opacity", l.opacity);
                    }), a.selectedPointStyle(s, r, t1);
                }
                e1.exports = {
                    style: function(t1, e1) {
                        e1 && s(t1, e1);
                    },
                    styleOnSelect: function(t1, e1) {
                        var r = e1[0].node3, n = e1[0].trace;
                        n.selectedpoints ? a.selectedPointStyle(r.selectAll(".choroplethlocation"), n, t1) : s(t1, e1);
                    }
                };
            },
            {
                "../../components/color": 366,
                "../../components/colorscale": 378,
                "../../components/drawing": 388,
                "@plotly/d3": 58
            }
        ],
        725: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../choropleth/attributes"), i = t1("../../components/colorscale/attributes"), a = t1("../../plots/template_attributes").hovertemplateAttrs, o = t1("../../plots/attributes"), s = t1("../../lib/extend").extendFlat;
                e1.exports = s({
                    locations: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    geojson: {
                        valType: "any",
                        editType: "calc"
                    },
                    featureidkey: s({}, n.featureidkey, {}),
                    below: {
                        valType: "string",
                        editType: "plot"
                    },
                    text: n.text,
                    hovertext: n.hovertext,
                    marker: {
                        line: {
                            color: s({}, n.marker.line.color, {
                                editType: "plot"
                            }),
                            width: s({}, n.marker.line.width, {
                                editType: "plot"
                            }),
                            editType: "calc"
                        },
                        opacity: s({}, n.marker.opacity, {
                            editType: "plot"
                        }),
                        editType: "calc"
                    },
                    selected: {
                        marker: {
                            opacity: s({}, n.selected.marker.opacity, {
                                editType: "plot"
                            }),
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    unselected: {
                        marker: {
                            opacity: s({}, n.unselected.marker.opacity, {
                                editType: "plot"
                            }),
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    hoverinfo: n.hoverinfo,
                    hovertemplate: a({}, {
                        keys: [
                            "properties"
                        ]
                    }),
                    showlegend: s({}, o.showlegend, {
                        dflt: !1
                    })
                }, i("", {
                    cLetter: "z",
                    editTypeOverride: "calc"
                }));
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/template_attributes": 633,
                "../choropleth/attributes": 716
            }
        ],
        726: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = t1("../../components/colorscale"), o = t1("../../components/drawing"), s = t1("../../lib/geojson_utils").makeBlank, l = t1("../../lib/geo_location_utils");
                function c(t1) {
                    var e1, r = t1[0].trace, n = r._opts;
                    if (r.selectedpoints) {
                        for(var a = o.makeSelectedPointStyleFns(r), s = 0; s < t1.length; s++){
                            var l = t1[s];
                            l.fOut && (l.fOut.properties.mo2 = a.selectedOpacityFn(l));
                        }
                        e1 = {
                            type: "identity",
                            property: "mo2"
                        };
                    } else e1 = i.isArrayOrTypedArray(r.marker.opacity) ? {
                        type: "identity",
                        property: "mo"
                    } : r.marker.opacity;
                    return i.extendFlat(n.fill.paint, {
                        "fill-opacity": e1
                    }), i.extendFlat(n.line.paint, {
                        "line-opacity": e1
                    }), n;
                }
                e1.exports = {
                    convert: function(t1) {
                        var e1 = t1[0].trace, r = !0 === e1.visible && 0 !== e1._length, o = {
                            layout: {
                                visibility: "none"
                            },
                            paint: {}
                        }, u = {
                            layout: {
                                visibility: "none"
                            },
                            paint: {}
                        }, f = e1._opts = {
                            fill: o,
                            line: u,
                            geojson: s()
                        };
                        if (!r) return f;
                        var h = l.extractTraceFeature(t1);
                        if (!h) return f;
                        var p, d, m, g = a.makeColorScaleFuncFromTrace(e1), v = e1.marker, y = v.line || {};
                        i.isArrayOrTypedArray(v.opacity) && (p = function(t1) {
                            var e1 = t1.mo;
                            return n(e1) ? +i.constrain(e1, 0, 1) : 0;
                        }), i.isArrayOrTypedArray(y.color) && (d = function(t1) {
                            return t1.mlc;
                        }), i.isArrayOrTypedArray(y.width) && (m = function(t1) {
                            return t1.mlw;
                        });
                        for(var x = 0; x < t1.length; x++){
                            var b = t1[x], _ = b.fOut;
                            if (_) {
                                var w = _.properties;
                                w.fc = g(b.z), p && (w.mo = p(b)), d && (w.mlc = d(b)), m && (w.mlw = m(b)), b.ct = w.ct, b._polygons = l.feature2polygons(_);
                            }
                        }
                        var T = p ? {
                            type: "identity",
                            property: "mo"
                        } : v.opacity;
                        return i.extendFlat(o.paint, {
                            "fill-color": {
                                type: "identity",
                                property: "fc"
                            },
                            "fill-opacity": T
                        }), i.extendFlat(u.paint, {
                            "line-color": d ? {
                                type: "identity",
                                property: "mlc"
                            } : y.color,
                            "line-width": m ? {
                                type: "identity",
                                property: "mlw"
                            } : y.width,
                            "line-opacity": T
                        }), o.layout.visibility = "visible", u.layout.visibility = "visible", f.geojson = {
                            type: "FeatureCollection",
                            features: h
                        }, c(t1), f;
                    },
                    convertOnSelect: c
                };
            },
            {
                "../../components/colorscale": 378,
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../lib/geo_location_utils": 496,
                "../../lib/geojson_utils": 497,
                "fast-isnumeric": 190
            }
        ],
        727: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/colorscale/defaults"), a = t1("./attributes");
                e1.exports = function(t1, e1, r, o) {
                    function s(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var l = s("locations"), c = s("z"), u = s("geojson");
                    n.isArrayOrTypedArray(l) && l.length && n.isArrayOrTypedArray(c) && c.length && ("string" == typeof u && "" !== u || n.isPlainObject(u)) ? (s("featureidkey"), e1._length = Math.min(l.length, c.length), s("below"), s("text"), s("hovertext"), s("hovertemplate"), s("marker.line.width") && s("marker.line.color"), s("marker.opacity"), i(t1, e1, o, s, {
                        prefix: "",
                        cLetter: "z"
                    }), n.coerceSelectionMarkerOpacity(e1, s)) : e1.visible = !1;
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../lib": 503,
                "./attributes": 725
            }
        ],
        728: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: t1("../heatmap/colorbar"),
                    calc: t1("../choropleth/calc"),
                    plot: t1("./plot"),
                    hoverPoints: t1("../choropleth/hover"),
                    eventData: t1("../choropleth/event_data"),
                    selectPoints: t1("../choropleth/select"),
                    styleOnSelect: function(t1, e1) {
                        e1 && e1[0].trace._glTrace.updateOnSelect(e1);
                    },
                    getBelow: function(t1, e1) {
                        for(var r = e1.getMapLayers(), n = r.length - 2; n >= 0; n--){
                            var i = r[n].id;
                            if ("string" == typeof i && 0 === i.indexOf("water")) {
                                for(var a = n + 1; a < r.length; a++)if ("string" == typeof (i = r[a].id) && -1 === i.indexOf("plotly-")) return i;
                            }
                        }
                    },
                    moduleType: "trace",
                    name: "choroplethmapbox",
                    basePlotModule: t1("../../plots/mapbox"),
                    categories: [
                        "mapbox",
                        "gl",
                        "noOpacity",
                        "showLegend"
                    ],
                    meta: {
                        hr_name: "choropleth_mapbox"
                    }
                };
            },
            {
                "../../plots/mapbox": 613,
                "../choropleth/calc": 717,
                "../choropleth/event_data": 719,
                "../choropleth/hover": 720,
                "../choropleth/select": 723,
                "../heatmap/colorbar": 795,
                "./attributes": 725,
                "./defaults": 727,
                "./plot": 729
            }
        ],
        729: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./convert").convert, i = t1("./convert").convertOnSelect, a = t1("../../plots/mapbox/constants").traceLayerPrefix;
                function o(t1, e1) {
                    this.type = "choroplethmapbox", this.subplot = t1, this.uid = e1, this.sourceId = "source-" + e1, this.layerList = [
                        [
                            "fill",
                            a + e1 + "-fill"
                        ],
                        [
                            "line",
                            a + e1 + "-line"
                        ]
                    ], this.below = null;
                }
                var s = o.prototype;
                s.update = function(t1) {
                    this._update(n(t1));
                }, s.updateOnSelect = function(t1) {
                    this._update(i(t1));
                }, s._update = function(t1) {
                    var e1 = this.subplot, r = this.layerList, n = e1.belowLookup["trace-" + this.uid];
                    e1.map.getSource(this.sourceId).setData(t1.geojson), n !== this.below && (this._removeLayers(), this._addLayers(t1, n), this.below = n);
                    for(var i = 0; i < r.length; i++){
                        var a = r[i], o = a[0], s = a[1], l = t1[o];
                        e1.setOptions(s, "setLayoutProperty", l.layout), "visible" === l.layout.visibility && e1.setOptions(s, "setPaintProperty", l.paint);
                    }
                }, s._addLayers = function(t1, e1) {
                    for(var r = this.subplot, n = this.layerList, i = this.sourceId, a = 0; a < n.length; a++){
                        var o = n[a], s = o[0], l = t1[s];
                        r.addLayer({
                            type: s,
                            id: o[1],
                            source: i,
                            layout: l.layout,
                            paint: l.paint
                        }, e1);
                    }
                }, s._removeLayers = function() {
                    for(var t1 = this.subplot.map, e1 = this.layerList, r = e1.length - 1; r >= 0; r--)t1.removeLayer(e1[r][1]);
                }, s.dispose = function() {
                    var t1 = this.subplot.map;
                    this._removeLayers(), t1.removeSource(this.sourceId);
                }, e1.exports = function(t1, e1) {
                    var r = e1[0].trace, i = new o(t1, r.uid), a = i.sourceId, s = n(e1), l = i.below = t1.belowLookup["trace-" + r.uid];
                    return t1.map.addSource(a, {
                        type: "geojson",
                        data: s.geojson
                    }), i._addLayers(s, l), e1[0].trace._glTrace = i, i;
                };
            },
            {
                "../../plots/mapbox/constants": 611,
                "./convert": 726
            }
        ],
        730: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/attributes"), i = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, a = t1("../../plots/template_attributes").hovertemplateAttrs, o = t1("../mesh3d/attributes"), s = t1("../../plots/attributes"), l = t1("../../lib/extend").extendFlat, c = {
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    z: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    u: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    v: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    w: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    sizemode: {
                        valType: "enumerated",
                        values: [
                            "scaled",
                            "absolute"
                        ],
                        editType: "calc",
                        dflt: "scaled"
                    },
                    sizeref: {
                        valType: "number",
                        editType: "calc",
                        min: 0
                    },
                    anchor: {
                        valType: "enumerated",
                        editType: "calc",
                        values: [
                            "tip",
                            "tail",
                            "cm",
                            "center"
                        ],
                        dflt: "cm"
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    hovertemplate: a({
                        editType: "calc"
                    }, {
                        keys: [
                            "norm"
                        ]
                    }),
                    uhoverformat: i("u", 1),
                    vhoverformat: i("v", 1),
                    whoverformat: i("w", 1),
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    zhoverformat: i("z"),
                    showlegend: l({}, s.showlegend, {
                        dflt: !1
                    })
                };
                l(c, n("", {
                    colorAttr: "u/v/w norm",
                    showScaleDflt: !0,
                    editTypeOverride: "calc"
                }));
                [
                    "opacity",
                    "lightposition",
                    "lighting"
                ].forEach(function(t1) {
                    c[t1] = o[t1];
                }), c.hoverinfo = l({}, s.hoverinfo, {
                    editType: "calc",
                    flags: [
                        "x",
                        "y",
                        "z",
                        "u",
                        "v",
                        "w",
                        "norm",
                        "text",
                        "name"
                    ],
                    dflt: "x+y+z+norm+text+name"
                }), c.transforms = void 0, e1.exports = c;
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/template_attributes": 633,
                "../mesh3d/attributes": 867
            }
        ],
        731: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/calc");
                e1.exports = function(t1, e1) {
                    for(var r = e1.u, i = e1.v, a = e1.w, o = Math.min(e1.x.length, e1.y.length, e1.z.length, r.length, i.length, a.length), s = -1 / 0, l = 1 / 0, c = 0; c < o; c++){
                        var u = r[c], f = i[c], h = a[c], p = Math.sqrt(u * u + f * f + h * h);
                        s = Math.max(s, p), l = Math.min(l, p);
                    }
                    e1._len = o, e1._normMax = s, n(t1, e1, {
                        vals: [
                            l,
                            s
                        ],
                        containerStr: "",
                        cLetter: "c"
                    });
                };
            },
            {
                "../../components/colorscale/calc": 374
            }
        ],
        732: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../stackgl_modules").gl_cone3d, i = t1("../../../stackgl_modules").gl_cone3d.createConeMesh, a = t1("../../lib").simpleMap, o = t1("../../lib/gl_format_color").parseColorScale, s = t1("../../components/colorscale").extractOpts, l = t1("../../plots/gl3d/zip3");
                function c(t1, e1) {
                    this.scene = t1, this.uid = e1, this.mesh = null, this.data = null;
                }
                var u = c.prototype;
                u.handlePick = function(t1) {
                    if (t1.object === this.mesh) {
                        var e1 = t1.index = t1.data.index, r = this.data.x[e1], n = this.data.y[e1], i = this.data.z[e1], a = this.data.u[e1], o = this.data.v[e1], s = this.data.w[e1];
                        t1.traceCoordinate = [
                            r,
                            n,
                            i,
                            a,
                            o,
                            s,
                            Math.sqrt(a * a + o * o + s * s)
                        ];
                        var l = this.data.hovertext || this.data.text;
                        return Array.isArray(l) && void 0 !== l[e1] ? t1.textLabel = l[e1] : l && (t1.textLabel = l), !0;
                    }
                };
                var f = {
                    xaxis: 0,
                    yaxis: 1,
                    zaxis: 2
                }, h = {
                    tip: 1,
                    tail: 0,
                    cm: .25,
                    center: .5
                }, p = {
                    tip: 1,
                    tail: 1,
                    cm: .75,
                    center: .5
                };
                function d(t1, e1) {
                    var r = t1.fullSceneLayout, i = t1.dataScale, c = {};
                    function u(t1, e1) {
                        var n = r[e1], o = i[f[e1]];
                        return a(t1, function(t1) {
                            return n.d2l(t1) * o;
                        });
                    }
                    c.vectors = l(u(e1.u, "xaxis"), u(e1.v, "yaxis"), u(e1.w, "zaxis"), e1._len), c.positions = l(u(e1.x, "xaxis"), u(e1.y, "yaxis"), u(e1.z, "zaxis"), e1._len);
                    var d = s(e1);
                    c.colormap = o(e1), c.vertexIntensityBounds = [
                        d.min / e1._normMax,
                        d.max / e1._normMax
                    ], c.coneOffset = h[e1.anchor], "scaled" === e1.sizemode ? c.coneSize = e1.sizeref || .5 : c.coneSize = e1.sizeref && e1._normMax ? e1.sizeref / e1._normMax : .5;
                    var m = n(c), g = e1.lightposition;
                    return m.lightPosition = [
                        g.x,
                        g.y,
                        g.z
                    ], m.ambient = e1.lighting.ambient, m.diffuse = e1.lighting.diffuse, m.specular = e1.lighting.specular, m.roughness = e1.lighting.roughness, m.fresnel = e1.lighting.fresnel, m.opacity = e1.opacity, e1._pad = p[e1.anchor] * m.vectorScale * m.coneScale * e1._normMax, m;
                }
                u.update = function(t1) {
                    this.data = t1;
                    var e1 = d(this.scene, t1);
                    this.mesh.update(e1);
                }, u.dispose = function() {
                    this.scene.glplot.remove(this.mesh), this.mesh.dispose();
                }, e1.exports = function(t1, e1) {
                    var r = t1.glplot.gl, n = d(t1, e1), a = i(r, n), o = new c(t1, e1.uid);
                    return o.mesh = a, o.data = e1, a._trace = o, t1.glplot.add(a), o;
                };
            },
            {
                "../../../stackgl_modules": 1120,
                "../../components/colorscale": 378,
                "../../lib": 503,
                "../../lib/gl_format_color": 499,
                "../../plots/gl3d/zip3": 609
            }
        ],
        733: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/colorscale/defaults"), a = t1("./attributes");
                e1.exports = function(t1, e1, r, o) {
                    function s(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var l = s("u"), c = s("v"), u = s("w"), f = s("x"), h = s("y"), p = s("z");
                    l && l.length && c && c.length && u && u.length && f && f.length && h && h.length && p && p.length ? (s("sizeref"), s("sizemode"), s("anchor"), s("lighting.ambient"), s("lighting.diffuse"), s("lighting.specular"), s("lighting.roughness"), s("lighting.fresnel"), s("lightposition.x"), s("lightposition.y"), s("lightposition.z"), i(t1, e1, o, s, {
                        prefix: "",
                        cLetter: "c"
                    }), s("text"), s("hovertext"), s("hovertemplate"), s("uhoverformat"), s("vhoverformat"), s("whoverformat"), s("xhoverformat"), s("yhoverformat"), s("zhoverformat"), e1._length = null) : e1.visible = !1;
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../lib": 503,
                "./attributes": 730
            }
        ],
        734: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "cone",
                    basePlotModule: t1("../../plots/gl3d"),
                    categories: [
                        "gl3d",
                        "showLegend"
                    ],
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: {
                        min: "cmin",
                        max: "cmax"
                    },
                    calc: t1("./calc"),
                    plot: t1("./convert"),
                    eventData: function(t1, e1) {
                        return t1.norm = e1.traceCoordinate[6], t1;
                    },
                    meta: {}
                };
            },
            {
                "../../plots/gl3d": 598,
                "./attributes": 730,
                "./calc": 731,
                "./convert": 732,
                "./defaults": 733
            }
        ],
        735: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../heatmap/attributes"), i = t1("../scatter/attributes"), a = t1("../../plots/cartesian/axis_format_attributes"), o = a.axisHoverFormat, s = a.descriptionOnlyNumbers, l = t1("../../components/colorscale/attributes"), c = t1("../../components/drawing/attributes").dash, u = t1("../../plots/font_attributes"), f = t1("../../lib/extend").extendFlat, h = t1("../../constants/filter_ops"), p = h.COMPARISON_OPS2, d = h.INTERVAL_OPS, m = i.line;
                e1.exports = f({
                    z: n.z,
                    x: n.x,
                    x0: n.x0,
                    dx: n.dx,
                    y: n.y,
                    y0: n.y0,
                    dy: n.dy,
                    xperiod: n.xperiod,
                    yperiod: n.yperiod,
                    xperiod0: i.xperiod0,
                    yperiod0: i.yperiod0,
                    xperiodalignment: n.xperiodalignment,
                    yperiodalignment: n.yperiodalignment,
                    text: n.text,
                    hovertext: n.hovertext,
                    transpose: n.transpose,
                    xtype: n.xtype,
                    ytype: n.ytype,
                    xhoverformat: o("x"),
                    yhoverformat: o("y"),
                    zhoverformat: o("z", 1),
                    hovertemplate: n.hovertemplate,
                    texttemplate: f({}, n.texttemplate, {}),
                    textfont: f({}, n.textfont, {}),
                    hoverongaps: n.hoverongaps,
                    connectgaps: f({}, n.connectgaps, {}),
                    fillcolor: {
                        valType: "color",
                        editType: "calc"
                    },
                    autocontour: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc",
                        impliedEdits: {
                            "contours.start": void 0,
                            "contours.end": void 0,
                            "contours.size": void 0
                        }
                    },
                    ncontours: {
                        valType: "integer",
                        dflt: 15,
                        min: 1,
                        editType: "calc"
                    },
                    contours: {
                        type: {
                            valType: "enumerated",
                            values: [
                                "levels",
                                "constraint"
                            ],
                            dflt: "levels",
                            editType: "calc"
                        },
                        start: {
                            valType: "number",
                            dflt: null,
                            editType: "plot",
                            impliedEdits: {
                                "^autocontour": !1
                            }
                        },
                        end: {
                            valType: "number",
                            dflt: null,
                            editType: "plot",
                            impliedEdits: {
                                "^autocontour": !1
                            }
                        },
                        size: {
                            valType: "number",
                            dflt: null,
                            min: 0,
                            editType: "plot",
                            impliedEdits: {
                                "^autocontour": !1
                            }
                        },
                        coloring: {
                            valType: "enumerated",
                            values: [
                                "fill",
                                "heatmap",
                                "lines",
                                "none"
                            ],
                            dflt: "fill",
                            editType: "calc"
                        },
                        showlines: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        showlabels: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "plot"
                        },
                        labelfont: u({
                            editType: "plot",
                            colorEditType: "style"
                        }),
                        labelformat: {
                            valType: "string",
                            dflt: "",
                            editType: "plot",
                            description: s("contour label")
                        },
                        operation: {
                            valType: "enumerated",
                            values: [].concat(p).concat(d),
                            dflt: "=",
                            editType: "calc"
                        },
                        value: {
                            valType: "any",
                            dflt: 0,
                            editType: "calc"
                        },
                        editType: "calc",
                        impliedEdits: {
                            autocontour: !1
                        }
                    },
                    line: {
                        color: f({}, m.color, {
                            editType: "style+colorbars"
                        }),
                        width: {
                            valType: "number",
                            min: 0,
                            editType: "style+colorbars"
                        },
                        dash: c,
                        smoothing: f({}, m.smoothing, {}),
                        editType: "plot"
                    }
                }, l("", {
                    cLetter: "z",
                    autoColorDflt: !1,
                    editTypeOverride: "calc"
                }));
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../components/drawing/attributes": 387,
                "../../constants/filter_ops": 475,
                "../../lib/extend": 493,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/font_attributes": 585,
                "../heatmap/attributes": 792,
                "../scatter/attributes": 926
            }
        ],
        736: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale"), i = t1("../heatmap/calc"), a = t1("./set_contours"), o = t1("./end_plus");
                e1.exports = function(t1, e1) {
                    var r = i(t1, e1), s = r[0].z;
                    a(e1, s);
                    var l, c = e1.contours, u = n.extractOpts(e1);
                    if ("heatmap" === c.coloring && u.auto && !1 === e1.autocontour) {
                        var f = c.start, h = o(c), p = c.size || 1, d = Math.floor((h - f) / p) + 1;
                        isFinite(p) || (p = 1, d = 1);
                        var m = f - p / 2;
                        l = [
                            m,
                            m + d * p
                        ];
                    } else l = s;
                    return n.calc(t1, e1, {
                        vals: l,
                        cLetter: "z"
                    }), r;
                };
            },
            {
                "../../components/colorscale": 378,
                "../heatmap/calc": 793,
                "./end_plus": 746,
                "./set_contours": 754
            }
        ],
        737: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    var r, n = t1[0], i = n.z;
                    switch(e1.type){
                        case "levels":
                            var a = Math.min(i[0][0], i[0][1]);
                            for(r = 0; r < t1.length; r++){
                                var o = t1[r];
                                o.prefixBoundary = !o.edgepaths.length && (a > o.level || o.starts.length && a === o.level);
                            }
                            break;
                        case "constraint":
                            if (n.prefixBoundary = !1, n.edgepaths.length) return;
                            var s = n.x.length, l = n.y.length, c = -1 / 0, u = 1 / 0;
                            for(r = 0; r < l; r++)u = Math.min(u, i[r][0]), u = Math.min(u, i[r][s - 1]), c = Math.max(c, i[r][0]), c = Math.max(c, i[r][s - 1]);
                            for(r = 1; r < s - 1; r++)u = Math.min(u, i[0][r]), u = Math.min(u, i[l - 1][r]), c = Math.max(c, i[0][r]), c = Math.max(c, i[l - 1][r]);
                            var f, h, p = e1.value;
                            switch(e1._operation){
                                case ">":
                                    p > c && (n.prefixBoundary = !0);
                                    break;
                                case "<":
                                    (p < u || n.starts.length && p === u) && (n.prefixBoundary = !0);
                                    break;
                                case "[]":
                                    f = Math.min(p[0], p[1]), ((h = Math.max(p[0], p[1])) < u || f > c || n.starts.length && h === u) && (n.prefixBoundary = !0);
                                    break;
                                case "][":
                                    f = Math.min(p[0], p[1]), h = Math.max(p[0], p[1]), f < u && h > c && (n.prefixBoundary = !0);
                            }
                    }
                };
            },
            {}
        ],
        738: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale"), i = t1("./make_color_map"), a = t1("./end_plus");
                e1.exports = {
                    min: "zmin",
                    max: "zmax",
                    calc: function(t1, e1, r) {
                        var o = e1.contours, s = e1.line, l = o.size || 1, c = o.coloring, u = i(e1, {
                            isColorbar: !0
                        });
                        if ("heatmap" === c) {
                            var f = n.extractOpts(e1);
                            r._fillgradient = f.reversescale ? n.flipScale(f.colorscale) : f.colorscale, r._zrange = [
                                f.min,
                                f.max
                            ];
                        } else "fill" === c && (r._fillcolor = u);
                        r._line = {
                            color: "lines" === c ? u : s.color,
                            width: !1 !== o.showlines ? s.width : 0,
                            dash: s.dash
                        }, r._levels = {
                            start: o.start,
                            end: a(o),
                            size: l
                        };
                    }
                };
            },
            {
                "../../components/colorscale": 378,
                "./end_plus": 746,
                "./make_color_map": 751
            }
        ],
        739: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    BOTTOMSTART: [
                        1,
                        9,
                        13,
                        104,
                        713
                    ],
                    TOPSTART: [
                        4,
                        6,
                        7,
                        104,
                        713
                    ],
                    LEFTSTART: [
                        8,
                        12,
                        14,
                        208,
                        1114
                    ],
                    RIGHTSTART: [
                        2,
                        3,
                        11,
                        208,
                        1114
                    ],
                    NEWDELTA: [
                        null,
                        [
                            -1,
                            0
                        ],
                        [
                            0,
                            -1
                        ],
                        [
                            -1,
                            0
                        ],
                        [
                            1,
                            0
                        ],
                        null,
                        [
                            0,
                            -1
                        ],
                        [
                            -1,
                            0
                        ],
                        [
                            0,
                            1
                        ],
                        [
                            0,
                            1
                        ],
                        null,
                        [
                            0,
                            1
                        ],
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            0
                        ],
                        [
                            0,
                            -1
                        ]
                    ],
                    CHOOSESADDLE: {
                        104: [
                            4,
                            1
                        ],
                        208: [
                            2,
                            8
                        ],
                        713: [
                            7,
                            13
                        ],
                        1114: [
                            11,
                            14
                        ]
                    },
                    SADDLEREMAINDER: {
                        1: 4,
                        2: 8,
                        4: 1,
                        7: 13,
                        8: 2,
                        11: 14,
                        13: 7,
                        14: 11
                    },
                    LABELDISTANCE: 2,
                    LABELINCREASE: 10,
                    LABELMIN: 3,
                    LABELMAX: 10,
                    LABELOPTIMIZER: {
                        EDGECOST: 1,
                        ANGLECOST: 1,
                        NEIGHBORCOST: 5,
                        SAMELEVELFACTOR: 10,
                        SAMELEVELDISTANCE: 5,
                        MAXCOST: 100,
                        INITIALSEARCHPOINTS: 10,
                        ITERATIONS: 5
                    }
                };
            },
            {}
        ],
        740: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("./label_defaults"), a = t1("../../components/color"), o = a.addOpacity, s = a.opacity, l = t1("../../constants/filter_ops"), c = l.CONSTRAINT_REDUCTION, u = l.COMPARISON_OPS2;
                e1.exports = function(t1, e1, r, a, l, f) {
                    var h, p, d, m = e1.contours, g = r("contours.operation");
                    (m._operation = c[g], function(t1, e1) {
                        var r;
                        -1 === u.indexOf(e1.operation) ? (t1("contours.value", [
                            0,
                            1
                        ]), Array.isArray(e1.value) ? e1.value.length > 2 ? e1.value = e1.value.slice(2) : 0 === e1.length ? e1.value = [
                            0,
                            1
                        ] : e1.length < 2 ? (r = parseFloat(e1.value[0]), e1.value = [
                            r,
                            r + 1
                        ]) : e1.value = [
                            parseFloat(e1.value[0]),
                            parseFloat(e1.value[1])
                        ] : n(e1.value) && (r = parseFloat(e1.value), e1.value = [
                            r,
                            r + 1
                        ])) : (t1("contours.value", 0), n(e1.value) || (Array.isArray(e1.value) ? e1.value = parseFloat(e1.value[0]) : e1.value = 0));
                    }(r, m), "=" === g ? h = m.showlines = !0 : (h = r("contours.showlines"), d = r("fillcolor", o((t1.line || {}).color || l, .5))), h) && (p = r("line.color", d && s(d) ? o(e1.fillcolor, 1) : l), r("line.width", 2), r("line.dash"));
                    r("line.smoothing"), i(r, a, p, f);
                };
            },
            {
                "../../components/color": 366,
                "../../constants/filter_ops": 475,
                "./label_defaults": 750,
                "fast-isnumeric": 190
            }
        ],
        741: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../constants/filter_ops"), i = t1("fast-isnumeric");
                function a(t1, e1) {
                    var r, a = Array.isArray(e1);
                    function o(t1) {
                        return i(t1) ? +t1 : null;
                    }
                    return -1 !== n.COMPARISON_OPS2.indexOf(t1) ? r = o(a ? e1[0] : e1) : -1 !== n.INTERVAL_OPS.indexOf(t1) ? r = a ? [
                        o(e1[0]),
                        o(e1[1])
                    ] : [
                        o(e1),
                        o(e1)
                    ] : -1 !== n.SET_OPS.indexOf(t1) && (r = a ? e1.map(o) : [
                        o(e1)
                    ]), r;
                }
                function o(t1) {
                    return function(e1) {
                        e1 = a(t1, e1);
                        var r = Math.min(e1[0], e1[1]), n = Math.max(e1[0], e1[1]);
                        return {
                            start: r,
                            end: n,
                            size: n - r
                        };
                    };
                }
                function s(t1) {
                    return function(e1) {
                        return {
                            start: e1 = a(t1, e1),
                            end: 1 / 0,
                            size: 1 / 0
                        };
                    };
                }
                e1.exports = {
                    "[]": o("[]"),
                    "][": o("]["),
                    ">": s(">"),
                    "<": s("<"),
                    "=": s("=")
                };
            },
            {
                "../../constants/filter_ops": 475,
                "fast-isnumeric": 190
            }
        ],
        742: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n) {
                    var i = n("contours.start"), a = n("contours.end"), o = !1 === i || !1 === a, s = r("contours.size");
                    !(o ? e1.autocontour = !0 : r("autocontour", !1)) && s || r("ncontours");
                };
            },
            {}
        ],
        743: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                function i(t1) {
                    return n.extendFlat({}, t1, {
                        edgepaths: n.extendDeep([], t1.edgepaths),
                        paths: n.extendDeep([], t1.paths),
                        starts: n.extendDeep([], t1.starts)
                    });
                }
                e1.exports = function(t1, e1) {
                    var r, a, o, s = function(t1) {
                        return t1.reverse();
                    }, l = function(t1) {
                        return t1;
                    };
                    switch(e1){
                        case "=":
                        case "<":
                            return t1;
                        case ">":
                            for(1 !== t1.length && n.warn("Contour data invalid for the specified inequality operation."), a = t1[0], r = 0; r < a.edgepaths.length; r++)a.edgepaths[r] = s(a.edgepaths[r]);
                            for(r = 0; r < a.paths.length; r++)a.paths[r] = s(a.paths[r]);
                            for(r = 0; r < a.starts.length; r++)a.starts[r] = s(a.starts[r]);
                            return t1;
                        case "][":
                            var c = s;
                            s = l, l = c;
                        case "[]":
                            for(2 !== t1.length && n.warn("Contour data invalid for the specified inequality range operation."), a = i(t1[0]), o = i(t1[1]), r = 0; r < a.edgepaths.length; r++)a.edgepaths[r] = s(a.edgepaths[r]);
                            for(r = 0; r < a.paths.length; r++)a.paths[r] = s(a.paths[r]);
                            for(r = 0; r < a.starts.length; r++)a.starts[r] = s(a.starts[r]);
                            for(; o.edgepaths.length;)a.edgepaths.push(l(o.edgepaths.shift()));
                            for(; o.paths.length;)a.paths.push(l(o.paths.shift()));
                            for(; o.starts.length;)a.starts.push(l(o.starts.shift()));
                            return [
                                a
                            ];
                    }
                };
            },
            {
                "../../lib": 503
            }
        ],
        744: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../heatmap/xyz_defaults"), a = t1("../scatter/period_defaults"), o = t1("./constraint_defaults"), s = t1("./contours_defaults"), l = t1("./style_defaults"), c = t1("../heatmap/label_defaults"), u = t1("./attributes");
                e1.exports = function(t1, e1, r, f) {
                    function h(r, i) {
                        return n.coerce(t1, e1, u, r, i);
                    }
                    if (i(t1, e1, h, f)) {
                        a(t1, e1, f, h), h("xhoverformat"), h("yhoverformat"), h("text"), h("hovertext"), h("hoverongaps"), h("hovertemplate");
                        var p = "constraint" === h("contours.type");
                        h("connectgaps", n.isArray1D(e1.z)), p ? o(t1, e1, h, f, r) : (s(t1, e1, h, function(r) {
                            return n.coerce2(t1, e1, u, r);
                        }), l(t1, e1, h, f)), e1.contours && "heatmap" === e1.contours.coloring && c(h, f);
                    } else e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../heatmap/label_defaults": 802,
                "../heatmap/xyz_defaults": 807,
                "../scatter/period_defaults": 946,
                "./attributes": 735,
                "./constraint_defaults": 740,
                "./contours_defaults": 742,
                "./style_defaults": 756
            }
        ],
        745: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./constraint_mapping"), a = t1("./end_plus");
                e1.exports = function(t1, e1, r) {
                    for(var o = "constraint" === t1.type ? i[t1._operation](t1.value) : t1, s = o.size, l = [], c = a(o), u = r.trace._carpetTrace, f = u ? {
                        xaxis: u.aaxis,
                        yaxis: u.baxis,
                        x: r.a,
                        y: r.b
                    } : {
                        xaxis: e1.xaxis,
                        yaxis: e1.yaxis,
                        x: r.x,
                        y: r.y
                    }, h = o.start; h < c; h += s)if (l.push(n.extendFlat({
                        level: h,
                        crossings: {},
                        starts: [],
                        edgepaths: [],
                        paths: [],
                        z: r.z,
                        smoothing: r.trace.line.smoothing
                    }, f)), l.length > 1e3) {
                        n.warn("Too many contours, clipping at 1000", t1);
                        break;
                    }
                    return l;
                };
            },
            {
                "../../lib": 503,
                "./constraint_mapping": 741,
                "./end_plus": 746
            }
        ],
        746: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    return t1.end + t1.size / 1e6;
                };
            },
            {}
        ],
        747: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./constants");
                function a(t1, e1, r, n) {
                    return Math.abs(t1[0] - e1[0]) < r && Math.abs(t1[1] - e1[1]) < n;
                }
                function o(t1, e1, r, o, l) {
                    var c, u = e1.join(","), f = t1.crossings[u], h = function(t1, e1, r) {
                        var n = 0, a = 0;
                        t1 > 20 && e1 ? 208 === t1 || 1114 === t1 ? n = 0 === r[0] ? 1 : -1 : a = 0 === r[1] ? 1 : -1 : -1 !== i.BOTTOMSTART.indexOf(t1) ? a = 1 : -1 !== i.LEFTSTART.indexOf(t1) ? n = 1 : -1 !== i.TOPSTART.indexOf(t1) ? a = -1 : n = -1;
                        return [
                            n,
                            a
                        ];
                    }(f, r, e1), p = [
                        s(t1, e1, [
                            -h[0],
                            -h[1]
                        ])
                    ], d = t1.z.length, m = t1.z[0].length, g = e1.slice(), v = h.slice();
                    for(c = 0; c < 1e4; c++){
                        if (f > 20 ? (f = i.CHOOSESADDLE[f][(h[0] || h[1]) < 0 ? 0 : 1], t1.crossings[u] = i.SADDLEREMAINDER[f]) : delete t1.crossings[u], !(h = i.NEWDELTA[f])) {
                            n.log("Found bad marching index:", f, e1, t1.level);
                            break;
                        }
                        p.push(s(t1, e1, h)), e1[0] += h[0], e1[1] += h[1], u = e1.join(","), a(p[p.length - 1], p[p.length - 2], o, l) && p.pop();
                        var y = h[0] && (e1[0] < 0 || e1[0] > m - 2) || h[1] && (e1[1] < 0 || e1[1] > d - 2);
                        if (e1[0] === g[0] && e1[1] === g[1] && h[0] === v[0] && h[1] === v[1] || r && y) break;
                        f = t1.crossings[u];
                    }
                    1e4 === c && n.log("Infinite loop in contour?");
                    var x, b, _, w, T, k, A, M, S, E, L, C, P, I, O, z = a(p[0], p[p.length - 1], o, l), D = 0, R = .2 * t1.smoothing, F = [], B = 0;
                    for(c = 1; c < p.length; c++)C = p[c], P = p[c - 1], I = void 0, O = void 0, I = C[2] - P[2], O = C[3] - P[3], D += A = Math.sqrt(I * I + O * O), F.push(A);
                    var N = D / F.length * R;
                    function j(t1) {
                        return p[t1 % p.length];
                    }
                    for(c = p.length - 2; c >= B; c--)if ((x = F[c]) < N) {
                        for(_ = 0, b = c - 1; b >= B && x + F[b] < N; b--)x += F[b];
                        if (z && c === p.length - 2) for(_ = 0; _ < b && x + F[_] < N; _++)x += F[_];
                        T = c - b + _ + 1, k = Math.floor((c + b + _ + 2) / 2), w = z || c !== p.length - 2 ? z || -1 !== b ? T % 2 ? j(k) : [
                            (j(k)[0] + j(k + 1)[0]) / 2,
                            (j(k)[1] + j(k + 1)[1]) / 2
                        ] : p[0] : p[p.length - 1], p.splice(b + 1, c - b + 1, w), c = b + 1, _ && (B = _), z && (c === p.length - 2 ? p[_] = p[p.length - 1] : 0 === c && (p[p.length - 1] = p[0]));
                    }
                    for(p.splice(0, B), c = 0; c < p.length; c++)p[c].length = 2;
                    if (!(p.length < 2)) {
                        if (z) p.pop(), t1.paths.push(p);
                        else {
                            r || n.log("Unclosed interior contour?", t1.level, g.join(","), p.join("L"));
                            var U = !1;
                            for(M = 0; M < t1.edgepaths.length; M++)if (E = t1.edgepaths[M], !U && a(E[0], p[p.length - 1], o, l)) {
                                p.pop(), U = !0;
                                var V = !1;
                                for(S = 0; S < t1.edgepaths.length; S++)if (a((L = t1.edgepaths[S])[L.length - 1], p[0], o, l)) {
                                    V = !0, p.shift(), t1.edgepaths.splice(M, 1), S === M ? t1.paths.push(p.concat(L)) : (S > M && S--, t1.edgepaths[S] = L.concat(p, E));
                                    break;
                                }
                                V || (t1.edgepaths[M] = p.concat(E));
                            }
                            for(M = 0; M < t1.edgepaths.length && !U; M++)a((E = t1.edgepaths[M])[E.length - 1], p[0], o, l) && (p.shift(), t1.edgepaths[M] = E.concat(p), U = !0);
                            U || t1.edgepaths.push(p);
                        }
                    }
                }
                function s(t1, e1, r) {
                    var n = e1[0] + Math.max(r[0], 0), i = e1[1] + Math.max(r[1], 0), a = t1.z[i][n], o = t1.xaxis, s = t1.yaxis;
                    if (r[1]) {
                        var l = (t1.level - a) / (t1.z[i][n + 1] - a), c = (1 !== l ? (1 - l) * o.c2l(t1.x[n]) : 0) + (0 !== l ? l * o.c2l(t1.x[n + 1]) : 0);
                        return [
                            o.c2p(o.l2c(c), !0),
                            s.c2p(t1.y[i], !0),
                            n + l,
                            i
                        ];
                    }
                    var u = (t1.level - a) / (t1.z[i + 1][n] - a), f = (1 !== u ? (1 - u) * s.c2l(t1.y[i]) : 0) + (0 !== u ? u * s.c2l(t1.y[i + 1]) : 0);
                    return [
                        o.c2p(t1.x[n], !0),
                        s.c2p(s.l2c(f), !0),
                        n,
                        i + u
                    ];
                }
                e1.exports = function(t1, e1, r) {
                    var i, a, s, l;
                    for(e1 = e1 || .01, r = r || .01, a = 0; a < t1.length; a++){
                        for(s = t1[a], l = 0; l < s.starts.length; l++)o(s, s.starts[l], "edge", e1, r);
                        for(i = 0; Object.keys(s.crossings).length && i < 1e4;)i++, o(s, Object.keys(s.crossings)[0].split(",").map(Number), void 0, e1, r);
                        1e4 === i && n.log("Infinite loop in contour?");
                    }
                };
            },
            {
                "../../lib": 503,
                "./constants": 739
            }
        ],
        748: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color"), i = t1("../heatmap/hover");
                e1.exports = function(t1, e1, r, a, o) {
                    o || (o = {}), o.isContour = !0;
                    var s = i(t1, e1, r, a, o);
                    return s && s.forEach(function(t1) {
                        var e1 = t1.trace;
                        "constraint" === e1.contours.type && (e1.fillcolor && n.opacity(e1.fillcolor) ? t1.color = n.addOpacity(e1.fillcolor, 1) : e1.contours.showlines && n.opacity(e1.line.color) && (t1.color = n.addOpacity(e1.line.color, 1)));
                    }), s;
                };
            },
            {
                "../../components/color": 366,
                "../heatmap/hover": 799
            }
        ],
        749: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    calc: t1("./calc"),
                    plot: t1("./plot").plot,
                    style: t1("./style"),
                    colorbar: t1("./colorbar"),
                    hoverPoints: t1("./hover"),
                    moduleType: "trace",
                    name: "contour",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "cartesian",
                        "svg",
                        "2dMap",
                        "contour",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "./attributes": 735,
                "./calc": 736,
                "./colorbar": 738,
                "./defaults": 744,
                "./hover": 748,
                "./plot": 753,
                "./style": 755
            }
        ],
        750: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = function(t1, e1, r, i) {
                    if (i || (i = {}), t1("contours.showlabels")) {
                        var a = e1.font;
                        n.coerceFont(t1, "contours.labelfont", {
                            family: a.family,
                            size: a.size,
                            color: r
                        }), t1("contours.labelformat");
                    }
                    !1 !== i.hasHover && t1("zhoverformat");
                };
            },
            {
                "../../lib": 503
            }
        ],
        751: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/colorscale"), a = t1("./end_plus");
                e1.exports = function(t1) {
                    var e1 = t1.contours, r = e1.start, o = a(e1), s = e1.size || 1, l = Math.floor((o - r) / s) + 1, c = "lines" === e1.coloring ? 0 : 1, u = i.extractOpts(t1);
                    isFinite(s) || (s = 1, l = 1);
                    var f, h, p = u.reversescale ? i.flipScale(u.colorscale) : u.colorscale, d = p.length, m = new Array(d), g = new Array(d);
                    if ("heatmap" === e1.coloring) {
                        var v = u.min, y = u.max;
                        for(h = 0; h < d; h++)f = p[h], m[h] = f[0] * (y - v) + v, g[h] = f[1];
                        var x = n.extent([
                            v,
                            y,
                            e1.start,
                            e1.start + s * (l - 1)
                        ]), b = x[v < y ? 0 : 1], _ = x[v < y ? 1 : 0];
                        b !== v && (m.splice(0, 0, b), g.splice(0, 0, g[0])), _ !== y && (m.push(_), g.push(g[g.length - 1]));
                    } else for(h = 0; h < d; h++)f = p[h], m[h] = (f[0] * (l + c - 1) - c / 2) * s + r, g[h] = f[1];
                    return i.makeColorScaleFunc({
                        domain: m,
                        range: g
                    }, {
                        noNumericCheck: !0
                    });
                };
            },
            {
                "../../components/colorscale": 378,
                "./end_plus": 746,
                "@plotly/d3": 58
            }
        ],
        752: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./constants");
                function i(t1, e1) {
                    var r = (e1[0][0] > t1 ? 0 : 1) + (e1[0][1] > t1 ? 0 : 2) + (e1[1][1] > t1 ? 0 : 4) + (e1[1][0] > t1 ? 0 : 8);
                    return 5 === r || 10 === r ? t1 > (e1[0][0] + e1[0][1] + e1[1][0] + e1[1][1]) / 4 ? 5 === r ? 713 : 1114 : 5 === r ? 104 : 208 : 15 === r ? 0 : r;
                }
                e1.exports = function(t1) {
                    var e1, r, a, o, s, l, c, u, f, h = t1[0].z, p = h.length, d = h[0].length, m = 2 === p || 2 === d;
                    for(r = 0; r < p - 1; r++)for(o = [], 0 === r && (o = o.concat(n.BOTTOMSTART)), r === p - 2 && (o = o.concat(n.TOPSTART)), e1 = 0; e1 < d - 1; e1++)for(a = o.slice(), 0 === e1 && (a = a.concat(n.LEFTSTART)), e1 === d - 2 && (a = a.concat(n.RIGHTSTART)), s = e1 + "," + r, l = [
                        [
                            h[r][e1],
                            h[r][e1 + 1]
                        ],
                        [
                            h[r + 1][e1],
                            h[r + 1][e1 + 1]
                        ]
                    ], f = 0; f < t1.length; f++)(c = i((u = t1[f]).level, l)) && (u.crossings[s] = c, -1 !== a.indexOf(c) && (u.starts.push([
                        e1,
                        r
                    ]), m && -1 !== a.indexOf(c, a.indexOf(c) + 1) && u.starts.push([
                        e1,
                        r
                    ])));
                };
            },
            {
                "./constants": 739
            }
        ],
        753: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../../components/drawing"), o = t1("../../components/colorscale"), s = t1("../../lib/svg_text_utils"), l = t1("../../plots/cartesian/axes"), c = t1("../../plots/cartesian/set_convert"), u = t1("../heatmap/plot"), f = t1("./make_crossings"), h = t1("./find_all_paths"), p = t1("./empty_pathinfo"), d = t1("./convert_to_constraints"), m = t1("./close_boundaries"), g = t1("./constants"), v = g.LABELOPTIMIZER;
                function y(t1, e1) {
                    var r, n, o, s, l, c, u, f = "", h = 0, p = t1.edgepaths.map(function(t1, e1) {
                        return e1;
                    }), d = !0;
                    function m(t1) {
                        return Math.abs(t1[1] - e1[2][1]) < .01;
                    }
                    function g(t1) {
                        return Math.abs(t1[0] - e1[0][0]) < .01;
                    }
                    function v(t1) {
                        return Math.abs(t1[0] - e1[2][0]) < .01;
                    }
                    for(; p.length;){
                        for(c = a.smoothopen(t1.edgepaths[h], t1.smoothing), f += d ? c : c.replace(/^M/, "L"), p.splice(p.indexOf(h), 1), r = t1.edgepaths[h][t1.edgepaths[h].length - 1], s = -1, o = 0; o < 4; o++){
                            if (!r) {
                                i.log("Missing end?", h, t1);
                                break;
                            }
                            for(u = r, Math.abs(u[1] - e1[0][1]) < .01 && !v(r) ? n = e1[1] : g(r) ? n = e1[0] : m(r) ? n = e1[3] : v(r) && (n = e1[2]), l = 0; l < t1.edgepaths.length; l++){
                                var y = t1.edgepaths[l][0];
                                Math.abs(r[0] - n[0]) < .01 ? Math.abs(r[0] - y[0]) < .01 && (y[1] - r[1]) * (n[1] - y[1]) >= 0 && (n = y, s = l) : Math.abs(r[1] - n[1]) < .01 ? Math.abs(r[1] - y[1]) < .01 && (y[0] - r[0]) * (n[0] - y[0]) >= 0 && (n = y, s = l) : i.log("endpt to newendpt is not vert. or horz.", r, n, y);
                            }
                            if (r = n, s >= 0) break;
                            f += "L" + n;
                        }
                        if (s === t1.edgepaths.length) {
                            i.log("unclosed perimeter path");
                            break;
                        }
                        h = s, (d = -1 === p.indexOf(h)) && (h = p[0], f += "Z");
                    }
                    for(h = 0; h < t1.paths.length; h++)f += a.smoothclosed(t1.paths[h], t1.smoothing);
                    return f;
                }
                function x(t1, e1, r, n) {
                    var a = e1.width / 2, o = e1.height / 2, s = t1.x, l = t1.y, c = t1.theta, u = Math.cos(c) * a, f = Math.sin(c) * a, h = (s > n.center ? n.right - s : s - n.left) / (u + Math.abs(Math.sin(c) * o)), p = (l > n.middle ? n.bottom - l : l - n.top) / (Math.abs(f) + Math.cos(c) * o);
                    if (h < 1 || p < 1) return 1 / 0;
                    var d = v.EDGECOST * (1 / (h - 1) + 1 / (p - 1));
                    d += v.ANGLECOST * c * c;
                    for(var m = s - u, g = l - f, y = s + u, x = l + f, b = 0; b < r.length; b++){
                        var _ = r[b], w = Math.cos(_.theta) * _.width / 2, T = Math.sin(_.theta) * _.width / 2, k = 2 * i.segmentDistance(m, g, y, x, _.x - w, _.y - T, _.x + w, _.y + T) / (e1.height + _.height), A = _.level === e1.level, M = A ? v.SAMELEVELDISTANCE : 1;
                        if (k <= M) return 1 / 0;
                        d += v.NEIGHBORCOST * (A ? v.SAMELEVELFACTOR : 1) / (k - M);
                    }
                    return d;
                }
                function b(t1) {
                    var e1, r, n = t1.trace._emptypoints, i = [], a = t1.z.length, o = t1.z[0].length, s = [];
                    for(e1 = 0; e1 < o; e1++)s.push(1);
                    for(e1 = 0; e1 < a; e1++)i.push(s.slice());
                    for(e1 = 0; e1 < n.length; e1++)i[(r = n[e1])[0]][r[1]] = 0;
                    return t1.zmask = i, i;
                }
                r.plot = function(t1, e1, o, s) {
                    var l = e1.xaxis, c = e1.yaxis;
                    i.makeTraceGroups(s, o, "contour").each(function(o) {
                        var s = n.select(this), v = o[0], x = v.trace, _ = v.x, w = v.y, T = x.contours, k = p(T, e1, v), A = i.ensureSingle(s, "g", "heatmapcoloring"), M = [];
                        "heatmap" === T.coloring && (M = [
                            o
                        ]), u(t1, e1, M, A), f(k), h(k);
                        var S = l.c2p(_[0], !0), E = l.c2p(_[_.length - 1], !0), L = c.c2p(w[0], !0), C = c.c2p(w[w.length - 1], !0), P = [
                            [
                                S,
                                C
                            ],
                            [
                                E,
                                C
                            ],
                            [
                                E,
                                L
                            ],
                            [
                                S,
                                L
                            ]
                        ], I = k;
                        "constraint" === T.type && (I = d(k, T._operation)), function(t1, e1, r) {
                            var n = i.ensureSingle(t1, "g", "contourbg").selectAll("path").data("fill" === r.coloring ? [
                                0
                            ] : []);
                            n.enter().append("path"), n.exit().remove(), n.attr("d", "M" + e1.join("L") + "Z").style("stroke", "none");
                        }(s, P, T), function(t1, e1, r, a) {
                            var o = "fill" === a.coloring || "constraint" === a.type && "=" !== a._operation, s = "M" + r.join("L") + "Z";
                            o && m(e1, a);
                            var l = i.ensureSingle(t1, "g", "contourfill").selectAll("path").data(o ? e1 : []);
                            l.enter().append("path"), l.exit().remove(), l.each(function(t1) {
                                var e1 = (t1.prefixBoundary ? s : "") + y(t1, r);
                                e1 ? n.select(this).attr("d", e1).style("stroke", "none") : n.select(this).remove();
                            });
                        }(s, I, P, T), function(t1, e1, o, s, l) {
                            var c = i.ensureSingle(t1, "g", "contourlines"), u = !1 !== l.showlines, f = l.showlabels, h = u && f, p = r.createLines(c, u || f, e1), d = r.createLineClip(c, h, o, s.trace.uid), m = t1.selectAll("g.contourlabels").data(f ? [
                                0
                            ] : []);
                            if (m.exit().remove(), m.enter().append("g").classed("contourlabels", !0), f) {
                                var v = [], y = [];
                                i.clearLocationCache();
                                var x = r.labelFormatter(o, s), b = a.tester.append("text").attr("data-notex", 1).call(a.font, l.labelfont), _ = e1[0].xaxis, w = e1[0].yaxis, T = _._length, k = w._length, A = _.range, M = w.range, S = i.aggNums(Math.min, null, s.x), E = i.aggNums(Math.max, null, s.x), L = i.aggNums(Math.min, null, s.y), C = i.aggNums(Math.max, null, s.y), P = Math.max(_.c2p(S, !0), 0), I = Math.min(_.c2p(E, !0), T), O = Math.max(w.c2p(C, !0), 0), z = Math.min(w.c2p(L, !0), k), D = {};
                                A[0] < A[1] ? (D.left = P, D.right = I) : (D.left = I, D.right = P), M[0] < M[1] ? (D.top = O, D.bottom = z) : (D.top = z, D.bottom = O), D.middle = (D.top + D.bottom) / 2, D.center = (D.left + D.right) / 2, v.push([
                                    [
                                        D.left,
                                        D.top
                                    ],
                                    [
                                        D.right,
                                        D.top
                                    ],
                                    [
                                        D.right,
                                        D.bottom
                                    ],
                                    [
                                        D.left,
                                        D.bottom
                                    ]
                                ]);
                                var R = Math.sqrt(T * T + k * k), F = g.LABELDISTANCE * R / Math.max(1, e1.length / g.LABELINCREASE);
                                p.each(function(t1) {
                                    var e1 = r.calcTextOpts(t1.level, x, b, o);
                                    n.select(this).selectAll("path").each(function() {
                                        var t1 = i.getVisibleSegment(this, D, e1.height / 2);
                                        if (t1 && !(t1.len < (e1.width + e1.height) * g.LABELMIN)) for(var n = Math.min(Math.ceil(t1.len / F), g.LABELMAX), a = 0; a < n; a++){
                                            var o = r.findBestTextLocation(this, t1, e1, y, D);
                                            if (!o) break;
                                            r.addLabelData(o, e1, y, v);
                                        }
                                    });
                                }), b.remove(), r.drawLabels(m, y, o, d, h ? v : null);
                            }
                            f && !u && p.remove();
                        }(s, k, t1, v, T), function(t1, e1, r, n, o) {
                            var s = n.trace, l = r._fullLayout._clips, c = "clip" + s.uid, u = l.selectAll("#" + c).data(s.connectgaps ? [] : [
                                0
                            ]);
                            if (u.enter().append("clipPath").classed("contourclip", !0).attr("id", c), u.exit().remove(), !1 === s.connectgaps) {
                                var p = {
                                    level: .9,
                                    crossings: {},
                                    starts: [],
                                    edgepaths: [],
                                    paths: [],
                                    xaxis: e1.xaxis,
                                    yaxis: e1.yaxis,
                                    x: n.x,
                                    y: n.y,
                                    z: b(n),
                                    smoothing: 0
                                };
                                f([
                                    p
                                ]), h([
                                    p
                                ]), m([
                                    p
                                ], {
                                    type: "levels"
                                }), i.ensureSingle(u, "path", "").attr("d", (p.prefixBoundary ? "M" + o.join("L") + "Z" : "") + y(p, o));
                            } else c = null;
                            a.setClipUrl(t1, c, r);
                        }(s, e1, t1, v, P);
                    });
                }, r.createLines = function(t1, e1, r) {
                    var n = r[0].smoothing, i = t1.selectAll("g.contourlevel").data(e1 ? r : []);
                    if (i.exit().remove(), i.enter().append("g").classed("contourlevel", !0), e1) {
                        var o = i.selectAll("path.openline").data(function(t1) {
                            return t1.pedgepaths || t1.edgepaths;
                        });
                        o.exit().remove(), o.enter().append("path").classed("openline", !0), o.attr("d", function(t1) {
                            return a.smoothopen(t1, n);
                        }).style("stroke-miterlimit", 1).style("vector-effect", "non-scaling-stroke");
                        var s = i.selectAll("path.closedline").data(function(t1) {
                            return t1.ppaths || t1.paths;
                        });
                        s.exit().remove(), s.enter().append("path").classed("closedline", !0), s.attr("d", function(t1) {
                            return a.smoothclosed(t1, n);
                        }).style("stroke-miterlimit", 1).style("vector-effect", "non-scaling-stroke");
                    }
                    return i;
                }, r.createLineClip = function(t1, e1, r, n) {
                    var i = e1 ? "clipline" + n : null, o = r._fullLayout._clips.selectAll("#" + i).data(e1 ? [
                        0
                    ] : []);
                    return o.exit().remove(), o.enter().append("clipPath").classed("contourlineclip", !0).attr("id", i), a.setClipUrl(t1, i, r), o;
                }, r.labelFormatter = function(t1, e1) {
                    var r = t1._fullLayout, n = e1.trace, i = n.contours, a = {
                        type: "linear",
                        _id: "ycontour",
                        showexponent: "all",
                        exponentformat: "B"
                    };
                    if (i.labelformat) a.tickformat = i.labelformat, c(a, r);
                    else {
                        var s = o.extractOpts(n);
                        if (s && s.colorbar && s.colorbar._axis) a = s.colorbar._axis;
                        else {
                            if ("constraint" === i.type) {
                                var u = i.value;
                                Array.isArray(u) ? a.range = [
                                    u[0],
                                    u[u.length - 1]
                                ] : a.range = [
                                    u,
                                    u
                                ];
                            } else a.range = [
                                i.start,
                                i.end
                            ], a.nticks = (i.end - i.start) / i.size;
                            a.range[0] === a.range[1] && (a.range[1] += a.range[0] || 1), a.nticks || (a.nticks = 1e3), c(a, r), l.prepTicks(a), a._tmin = null, a._tmax = null;
                        }
                    }
                    return function(t1) {
                        return l.tickText(a, t1).text;
                    };
                }, r.calcTextOpts = function(t1, e1, r, n) {
                    var i = e1(t1);
                    r.text(i).call(s.convertToTspans, n);
                    var o = r.node(), l = a.bBox(o, !0);
                    return {
                        text: i,
                        width: l.width,
                        height: l.height,
                        fontSize: +o.style["font-size"].replace("px", ""),
                        level: t1,
                        dy: (l.top + l.bottom) / 2
                    };
                }, r.findBestTextLocation = function(t1, e1, r, n, a) {
                    var o, s, l, c, u, f = r.width;
                    e1.isClosed ? (s = e1.len / v.INITIALSEARCHPOINTS, o = e1.min + s / 2, l = e1.max) : (s = (e1.len - f) / (v.INITIALSEARCHPOINTS + 1), o = e1.min + s + f / 2, l = e1.max - (s + f) / 2);
                    for(var h = 1 / 0, p = 0; p < v.ITERATIONS; p++){
                        for(var d = o; d < l; d += s){
                            var m = i.getTextLocation(t1, e1.total, d, f), g = x(m, r, n, a);
                            g < h && (h = g, u = m, c = d);
                        }
                        if (h > 2 * v.MAXCOST) break;
                        p && (s /= 2), l = (o = c - s / 2) + 1.5 * s;
                    }
                    if (h <= v.MAXCOST) return u;
                }, r.addLabelData = function(t1, e1, r, n) {
                    var i = e1.fontSize, a = e1.width + i / 3, o = Math.max(0, e1.height - i / 3), s = t1.x, l = t1.y, c = t1.theta, u = Math.sin(c), f = Math.cos(c), h = function(t1, e1) {
                        return [
                            s + t1 * f - e1 * u,
                            l + t1 * u + e1 * f
                        ];
                    }, p = [
                        h(-a / 2, -o / 2),
                        h(-a / 2, o / 2),
                        h(a / 2, o / 2),
                        h(a / 2, -o / 2)
                    ];
                    r.push({
                        text: e1.text,
                        x: s,
                        y: l,
                        dy: e1.dy,
                        theta: c,
                        level: e1.level,
                        width: a,
                        height: o
                    }), n.push(p);
                }, r.drawLabels = function(t1, e1, r, a, o) {
                    var l = t1.selectAll("text").data(e1, function(t1) {
                        return t1.text + "," + t1.x + "," + t1.y + "," + t1.theta;
                    });
                    if (l.exit().remove(), l.enter().append("text").attr({
                        "data-notex": 1,
                        "text-anchor": "middle"
                    }).each(function(t1) {
                        var e1 = t1.x + Math.sin(t1.theta) * t1.dy, i = t1.y - Math.cos(t1.theta) * t1.dy;
                        n.select(this).text(t1.text).attr({
                            x: e1,
                            y: i,
                            transform: "rotate(" + 180 * t1.theta / Math.PI + " " + e1 + " " + i + ")"
                        }).call(s.convertToTspans, r);
                    }), o) {
                        for(var c = "", u = 0; u < o.length; u++)c += "M" + o[u].join("L") + "Z";
                        i.ensureSingle(a, "path", "").attr("d", c);
                    }
                };
            },
            {
                "../../components/colorscale": 378,
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../plots/cartesian/axes": 554,
                "../../plots/cartesian/set_convert": 576,
                "../heatmap/plot": 804,
                "./close_boundaries": 737,
                "./constants": 739,
                "./convert_to_constraints": 743,
                "./empty_pathinfo": 745,
                "./find_all_paths": 747,
                "./make_crossings": 752,
                "@plotly/d3": 58
            }
        ],
        754: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes"), i = t1("../../lib");
                function a(t1, e1, r) {
                    var i = {
                        type: "linear",
                        range: [
                            t1,
                            e1
                        ]
                    };
                    return n.autoTicks(i, (e1 - t1) / (r || 15)), i;
                }
                e1.exports = function(t1, e1) {
                    var r = t1.contours;
                    if (t1.autocontour) {
                        var o = t1.zmin, s = t1.zmax;
                        (t1.zauto || void 0 === o) && (o = i.aggNums(Math.min, null, e1)), (t1.zauto || void 0 === s) && (s = i.aggNums(Math.max, null, e1));
                        var l = a(o, s, t1.ncontours);
                        r.size = l.dtick, r.start = n.tickFirst(l), l.range.reverse(), r.end = n.tickFirst(l), r.start === o && (r.start += r.size), r.end === s && (r.end -= r.size), r.start > r.end && (r.start = r.end = (r.start + r.end) / 2), t1._input.contours || (t1._input.contours = {}), i.extendFlat(t1._input.contours, {
                            start: r.start,
                            end: r.end,
                            size: r.size
                        }), t1._input.autocontour = !0;
                    } else if ("constraint" !== r.type) {
                        var c, u = r.start, f = r.end, h = t1._input.contours;
                        if (u > f && (r.start = h.start = f, f = r.end = h.end = u, u = r.start), !(r.size > 0)) c = u === f ? 1 : a(u, f, t1.ncontours).dtick, h.size = r.size = c;
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554
            }
        ],
        755: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/drawing"), a = t1("../heatmap/style"), o = t1("./make_color_map");
                e1.exports = function(t1) {
                    var e1 = n.select(t1).selectAll("g.contour");
                    e1.style("opacity", function(t1) {
                        return t1[0].trace.opacity;
                    }), e1.each(function(t1) {
                        var e1 = n.select(this), r = t1[0].trace, a = r.contours, s = r.line, l = a.size || 1, c = a.start, u = "constraint" === a.type, f = !u && "lines" === a.coloring, h = !u && "fill" === a.coloring, p = f || h ? o(r) : null;
                        e1.selectAll("g.contourlevel").each(function(t1) {
                            n.select(this).selectAll("path").call(i.lineGroupStyle, s.width, f ? p(t1.level) : s.color, s.dash);
                        });
                        var d = a.labelfont;
                        if (e1.selectAll("g.contourlabels text").each(function(t1) {
                            i.font(n.select(this), {
                                family: d.family,
                                size: d.size,
                                color: d.color || (f ? p(t1.level) : s.color)
                            });
                        }), u) e1.selectAll("g.contourfill path").style("fill", r.fillcolor);
                        else if (h) {
                            var m;
                            e1.selectAll("g.contourfill path").style("fill", function(t1) {
                                return void 0 === m && (m = t1.level), p(t1.level + .5 * l);
                            }), void 0 === m && (m = c), e1.selectAll("g.contourbg path").style("fill", p(m - .5 * l));
                        }
                    }), a(t1);
                };
            },
            {
                "../../components/drawing": 388,
                "../heatmap/style": 805,
                "./make_color_map": 751,
                "@plotly/d3": 58
            }
        ],
        756: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/defaults"), i = t1("./label_defaults");
                e1.exports = function(t1, e1, r, a, o) {
                    var s, l = r("contours.coloring"), c = "";
                    "fill" === l && (s = r("contours.showlines")), !1 !== s && ("lines" !== l && (c = r("line.color", "#000")), r("line.width", .5), r("line.dash")), "none" !== l && (!0 !== t1.showlegend && (e1.showlegend = !1), e1._dfltShowLegend = !1, n(t1, e1, a, r, {
                        prefix: "",
                        cLetter: "z"
                    })), r("line.smoothing"), i(r, a, c, o);
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "./label_defaults": 750
            }
        ],
        757: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../heatmap/attributes"), i = t1("../contour/attributes"), a = t1("../../components/colorscale/attributes"), o = t1("../../lib/extend").extendFlat, s = i.contours;
                e1.exports = o({
                    carpet: {
                        valType: "string",
                        editType: "calc"
                    },
                    z: n.z,
                    a: n.x,
                    a0: n.x0,
                    da: n.dx,
                    b: n.y,
                    b0: n.y0,
                    db: n.dy,
                    text: n.text,
                    hovertext: n.hovertext,
                    transpose: n.transpose,
                    atype: n.xtype,
                    btype: n.ytype,
                    fillcolor: i.fillcolor,
                    autocontour: i.autocontour,
                    ncontours: i.ncontours,
                    contours: {
                        type: s.type,
                        start: s.start,
                        end: s.end,
                        size: s.size,
                        coloring: {
                            valType: "enumerated",
                            values: [
                                "fill",
                                "lines",
                                "none"
                            ],
                            dflt: "fill",
                            editType: "calc"
                        },
                        showlines: s.showlines,
                        showlabels: s.showlabels,
                        labelfont: s.labelfont,
                        labelformat: s.labelformat,
                        operation: s.operation,
                        value: s.value,
                        editType: "calc",
                        impliedEdits: {
                            autocontour: !1
                        }
                    },
                    line: {
                        color: i.line.color,
                        width: i.line.width,
                        dash: i.line.dash,
                        smoothing: i.line.smoothing,
                        editType: "plot"
                    },
                    transforms: void 0
                }, a("", {
                    cLetter: "z",
                    autoColorDflt: !1
                }));
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../contour/attributes": 735,
                "../heatmap/attributes": 792
            }
        ],
        758: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/calc"), i = t1("../../lib"), a = t1("../heatmap/convert_column_xyz"), o = t1("../heatmap/clean_2d_array"), s = t1("../heatmap/interp2d"), l = t1("../heatmap/find_empties"), c = t1("../heatmap/make_bound_array"), u = t1("./defaults"), f = t1("../carpet/lookup_carpetid"), h = t1("../contour/set_contours");
                e1.exports = function(t1, e1) {
                    var r = e1._carpetTrace = f(t1, e1);
                    if (r && r.visible && "legendonly" !== r.visible) {
                        if (!e1.a || !e1.b) {
                            var p = t1.data[r.index], d = t1.data[e1.index];
                            d.a || (d.a = p.a), d.b || (d.b = p.b), u(d, e1, e1._defaultColor, t1._fullLayout);
                        }
                        var m = function(t1, e1) {
                            var r, u, f, h, p, d, m, g = e1._carpetTrace, v = g.aaxis, y = g.baxis;
                            v._minDtick = 0, y._minDtick = 0, i.isArray1D(e1.z) && a(e1, v, y, "a", "b", [
                                "z"
                            ]);
                            r = e1._a = e1._a || e1.a, h = e1._b = e1._b || e1.b, r = r ? v.makeCalcdata(e1, "_a") : [], h = h ? y.makeCalcdata(e1, "_b") : [], u = e1.a0 || 0, f = e1.da || 1, p = e1.b0 || 0, d = e1.db || 1, m = e1._z = o(e1._z || e1.z, e1.transpose), e1._emptypoints = l(m), s(m, e1._emptypoints);
                            var x = i.maxRowLength(m), b = "scaled" === e1.xtype ? "" : r, _ = c(e1, b, u, f, x, v), w = "scaled" === e1.ytype ? "" : h, T = c(e1, w, p, d, m.length, y), k = {
                                a: _,
                                b: T,
                                z: m
                            };
                            "levels" === e1.contours.type && "none" !== e1.contours.coloring && n(t1, e1, {
                                vals: m,
                                containerStr: "",
                                cLetter: "z"
                            });
                            return [
                                k
                            ];
                        }(t1, e1);
                        return h(e1, e1._z), m;
                    }
                };
            },
            {
                "../../components/colorscale/calc": 374,
                "../../lib": 503,
                "../carpet/lookup_carpetid": 708,
                "../contour/set_contours": 754,
                "../heatmap/clean_2d_array": 794,
                "../heatmap/convert_column_xyz": 796,
                "../heatmap/find_empties": 798,
                "../heatmap/interp2d": 801,
                "../heatmap/make_bound_array": 803,
                "./defaults": 759
            }
        ],
        759: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../heatmap/xyz_defaults"), a = t1("./attributes"), o = t1("../contour/constraint_defaults"), s = t1("../contour/contours_defaults"), l = t1("../contour/style_defaults");
                e1.exports = function(t1, e1, r, c) {
                    function u(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    if (u("carpet"), t1.a && t1.b) {
                        if (!i(t1, e1, u, c, "a", "b")) return void (e1.visible = !1);
                        u("text"), "constraint" === u("contours.type") ? o(t1, e1, u, c, r, {
                            hasHover: !1
                        }) : (s(t1, e1, u, function(r) {
                            return n.coerce2(t1, e1, a, r);
                        }), l(t1, e1, u, c, {
                            hasHover: !1
                        }));
                    } else e1._defaultColor = r, e1._length = null;
                };
            },
            {
                "../../lib": 503,
                "../contour/constraint_defaults": 740,
                "../contour/contours_defaults": 742,
                "../contour/style_defaults": 756,
                "../heatmap/xyz_defaults": 807,
                "./attributes": 757
            }
        ],
        760: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: t1("../contour/colorbar"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    style: t1("../contour/style"),
                    moduleType: "trace",
                    name: "contourcarpet",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "cartesian",
                        "svg",
                        "carpet",
                        "contour",
                        "symbols",
                        "showLegend",
                        "hasLines",
                        "carpetDependent",
                        "noHover",
                        "noSortingByValue"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "../contour/colorbar": 738,
                "../contour/style": 755,
                "./attributes": 757,
                "./calc": 758,
                "./defaults": 759,
                "./plot": 761
            }
        ],
        761: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../carpet/map_1d_array"), a = t1("../carpet/makepath"), o = t1("../../components/drawing"), s = t1("../../lib"), l = t1("../contour/make_crossings"), c = t1("../contour/find_all_paths"), u = t1("../contour/plot"), f = t1("../contour/constants"), h = t1("../contour/convert_to_constraints"), p = t1("../contour/empty_pathinfo"), d = t1("../contour/close_boundaries"), m = t1("../carpet/lookup_carpetid"), g = t1("../carpet/axis_aligned_line");
                function v(t1, e1, r) {
                    var n = t1.getPointAtLength(e1), i = t1.getPointAtLength(r), a = i.x - n.x, o = i.y - n.y, s = Math.sqrt(a * a + o * o);
                    return [
                        a / s,
                        o / s
                    ];
                }
                function y(t1) {
                    var e1 = Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
                    return [
                        t1[0] / e1,
                        t1[1] / e1
                    ];
                }
                function x(t1, e1) {
                    var r = Math.abs(t1[0] * e1[0] + t1[1] * e1[1]);
                    return Math.sqrt(1 - r * r) / r;
                }
                e1.exports = function(t1, e1, r, b) {
                    var _ = e1.xaxis, w = e1.yaxis;
                    s.makeTraceGroups(b, r, "contour").each(function(r) {
                        var b = n.select(this), T = r[0], k = T.trace, A = k._carpetTrace = m(t1, k), M = t1.calcdata[A.index][0];
                        if (A.visible && "legendonly" !== A.visible) {
                            var S = T.a, E = T.b, L = k.contours, C = p(L, e1, T), P = "constraint" === L.type, I = L._operation, O = P ? "=" === I ? "lines" : "fill" : L.coloring, z = [
                                [
                                    S[0],
                                    E[E.length - 1]
                                ],
                                [
                                    S[S.length - 1],
                                    E[E.length - 1]
                                ],
                                [
                                    S[S.length - 1],
                                    E[0]
                                ],
                                [
                                    S[0],
                                    E[0]
                                ]
                            ];
                            l(C);
                            var D = 1e-8 * (S[S.length - 1] - S[0]), R = 1e-8 * (E[E.length - 1] - E[0]);
                            c(C, D, R);
                            var F, B, N, j, U = C;
                            "constraint" === L.type && (U = h(C, I)), function(t1, e1) {
                                var r, n, i, a, o, s, l, c, u;
                                for(r = 0; r < t1.length; r++){
                                    for(a = t1[r], o = a.pedgepaths = [], s = a.ppaths = [], n = 0; n < a.edgepaths.length; n++){
                                        for(u = a.edgepaths[n], l = [], i = 0; i < u.length; i++)l[i] = e1(u[i]);
                                        o.push(l);
                                    }
                                    for(n = 0; n < a.paths.length; n++){
                                        for(u = a.paths[n], c = [], i = 0; i < u.length; i++)c[i] = e1(u[i]);
                                        s.push(c);
                                    }
                                }
                            }(C, q);
                            var V = [];
                            for(j = M.clipsegments.length - 1; j >= 0; j--)F = M.clipsegments[j], B = i([], F.x, _.c2p), N = i([], F.y, w.c2p), B.reverse(), N.reverse(), V.push(a(B, N, F.bicubic));
                            var H = "M" + V.join("L") + "Z";
                            !function(t1, e1, r, n, o, l) {
                                var c, u, f, h, p = s.ensureSingle(t1, "g", "contourbg").selectAll("path").data("fill" !== l || o ? [] : [
                                    0
                                ]);
                                p.enter().append("path"), p.exit().remove();
                                var d = [];
                                for(h = 0; h < e1.length; h++)c = e1[h], u = i([], c.x, r.c2p), f = i([], c.y, n.c2p), d.push(a(u, f, c.bicubic));
                                p.attr("d", "M" + d.join("L") + "Z").style("stroke", "none");
                            }(b, M.clipsegments, _, w, P, O), function(t1, e1, r, i, a, l, c, u, f, h, p) {
                                var m = "fill" === h;
                                m && d(a, t1.contours);
                                var v = s.ensureSingle(e1, "g", "contourfill").selectAll("path").data(m ? a : []);
                                v.enter().append("path"), v.exit().remove(), v.each(function(t1) {
                                    var e1 = (t1.prefixBoundary ? p : "") + function(t1, e1, r, n, i, a, l, c) {
                                        var u, f, h, p, d, m, v, y = "", x = e1.edgepaths.map(function(t1, e1) {
                                            return e1;
                                        }), b = !0, _ = 1e-4 * Math.abs(r[0][0] - r[2][0]), w = 1e-4 * Math.abs(r[0][1] - r[2][1]);
                                        function T(t1) {
                                            return Math.abs(t1[1] - r[0][1]) < w;
                                        }
                                        function k(t1) {
                                            return Math.abs(t1[1] - r[2][1]) < w;
                                        }
                                        function A(t1) {
                                            return Math.abs(t1[0] - r[0][0]) < _;
                                        }
                                        function M(t1) {
                                            return Math.abs(t1[0] - r[2][0]) < _;
                                        }
                                        function S(t1, e1) {
                                            var r, n, o, s, u = "";
                                            for(T(t1) && !M(t1) || k(t1) && !A(t1) ? (s = i.aaxis, o = g(i, a, [
                                                t1[0],
                                                e1[0]
                                            ], .5 * (t1[1] + e1[1]))) : (s = i.baxis, o = g(i, a, .5 * (t1[0] + e1[0]), [
                                                t1[1],
                                                e1[1]
                                            ])), r = 1; r < o.length; r++)for(u += s.smoothing ? "C" : "L", n = 0; n < o[r].length; n++){
                                                var f = o[r][n];
                                                u += [
                                                    l.c2p(f[0]),
                                                    c.c2p(f[1])
                                                ] + " ";
                                            }
                                            return u;
                                        }
                                        u = 0, f = null;
                                        for(; x.length;){
                                            var E = e1.edgepaths[u][0];
                                            for(f && (y += S(f, E)), v = o.smoothopen(e1.edgepaths[u].map(n), e1.smoothing), y += b ? v : v.replace(/^M/, "L"), x.splice(x.indexOf(u), 1), f = e1.edgepaths[u][e1.edgepaths[u].length - 1], d = -1, p = 0; p < 4; p++){
                                                if (!f) {
                                                    s.log("Missing end?", u, e1);
                                                    break;
                                                }
                                                for(T(f) && !M(f) ? h = r[1] : A(f) ? h = r[0] : k(f) ? h = r[3] : M(f) && (h = r[2]), m = 0; m < e1.edgepaths.length; m++){
                                                    var L = e1.edgepaths[m][0];
                                                    Math.abs(f[0] - h[0]) < _ ? Math.abs(f[0] - L[0]) < _ && (L[1] - f[1]) * (h[1] - L[1]) >= 0 && (h = L, d = m) : Math.abs(f[1] - h[1]) < w ? Math.abs(f[1] - L[1]) < w && (L[0] - f[0]) * (h[0] - L[0]) >= 0 && (h = L, d = m) : s.log("endpt to newendpt is not vert. or horz.", f, h, L);
                                                }
                                                if (d >= 0) break;
                                                y += S(f, h), f = h;
                                            }
                                            if (d === e1.edgepaths.length) {
                                                s.log("unclosed perimeter path");
                                                break;
                                            }
                                            u = d, (b = -1 === x.indexOf(u)) && (u = x[0], y += S(f, h) + "Z", f = null);
                                        }
                                        for(u = 0; u < e1.paths.length; u++)y += o.smoothclosed(e1.paths[u].map(n), e1.smoothing);
                                        return y;
                                    }(0, t1, l, c, u, f, r, i);
                                    e1 ? n.select(this).attr("d", e1).style("stroke", "none") : n.select(this).remove();
                                });
                            }(k, b, _, w, U, z, q, A, M, O, H), function(t1, e1, r, i, a, l, c) {
                                var h = s.ensureSingle(t1, "g", "contourlines"), p = !1 !== a.showlines, d = a.showlabels, m = p && d, g = u.createLines(h, p || d, e1), b = u.createLineClip(h, m, r, i.trace.uid), _ = t1.selectAll("g.contourlabels").data(d ? [
                                    0
                                ] : []);
                                if (_.exit().remove(), _.enter().append("g").classed("contourlabels", !0), d) {
                                    var w = l.xaxis, T = l.yaxis, k = w._length, A = T._length, M = [
                                        [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                k,
                                                0
                                            ],
                                            [
                                                k,
                                                A
                                            ],
                                            [
                                                0,
                                                A
                                            ]
                                        ]
                                    ], S = [];
                                    s.clearLocationCache();
                                    var E = u.labelFormatter(r, i), L = o.tester.append("text").attr("data-notex", 1).call(o.font, a.labelfont), C = {
                                        left: 0,
                                        right: k,
                                        center: k / 2,
                                        top: 0,
                                        bottom: A,
                                        middle: A / 2
                                    }, P = Math.sqrt(k * k + A * A), I = f.LABELDISTANCE * P / Math.max(1, e1.length / f.LABELINCREASE);
                                    g.each(function(t1) {
                                        var e1 = u.calcTextOpts(t1.level, E, L, r);
                                        n.select(this).selectAll("path").each(function(r) {
                                            var n = s.getVisibleSegment(this, C, e1.height / 2);
                                            if (n && (function(t1, e1, r, n, i, a) {
                                                for(var o, s = 0; s < r.pedgepaths.length; s++)e1 === r.pedgepaths[s] && (o = r.edgepaths[s]);
                                                if (!o) return;
                                                var l = i.a[0], c = i.a[i.a.length - 1], u = i.b[0], f = i.b[i.b.length - 1];
                                                function h(t1, e1) {
                                                    var r, n = 0;
                                                    return (Math.abs(t1[0] - l) < .1 || Math.abs(t1[0] - c) < .1) && (r = y(i.dxydb_rough(t1[0], t1[1], .1)), n = Math.max(n, a * x(e1, r) / 2)), (Math.abs(t1[1] - u) < .1 || Math.abs(t1[1] - f) < .1) && (r = y(i.dxyda_rough(t1[0], t1[1], .1)), n = Math.max(n, a * x(e1, r) / 2)), n;
                                                }
                                                var p = v(t1, 0, 1), d = v(t1, n.total, n.total - 1), m = h(o[0], p), g = n.total - h(o[o.length - 1], d);
                                                n.min < m && (n.min = m);
                                                n.max > g && (n.max = g);
                                                n.len = n.max - n.min;
                                            }(this, r, t1, n, c, e1.height), !(n.len < (e1.width + e1.height) * f.LABELMIN))) for(var i = Math.min(Math.ceil(n.len / I), f.LABELMAX), a = 0; a < i; a++){
                                                var o = u.findBestTextLocation(this, n, e1, S, C);
                                                if (!o) break;
                                                u.addLabelData(o, e1, S, M);
                                            }
                                        });
                                    }), L.remove(), u.drawLabels(_, S, r, b, m ? M : null);
                                }
                                d && !p && g.remove();
                            }(b, C, t1, T, L, e1, A), o.setClipUrl(b, A._clipPathId, t1);
                        }
                        function q(t1) {
                            var e1 = A.ab2xy(t1[0], t1[1], !0);
                            return [
                                _.c2p(e1[0]),
                                w.c2p(e1[1])
                            ];
                        }
                    });
                };
            },
            {
                "../../components/drawing": 388,
                "../../lib": 503,
                "../carpet/axis_aligned_line": 692,
                "../carpet/lookup_carpetid": 708,
                "../carpet/makepath": 709,
                "../carpet/map_1d_array": 710,
                "../contour/close_boundaries": 737,
                "../contour/constants": 739,
                "../contour/convert_to_constraints": 743,
                "../contour/empty_pathinfo": 745,
                "../contour/find_all_paths": 747,
                "../contour/make_crossings": 752,
                "../contour/plot": 753,
                "@plotly/d3": 58
            }
        ],
        762: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/attributes"), i = t1("../../plots/template_attributes").hovertemplateAttrs, a = t1("../../plots/attributes"), o = t1("../scattermapbox/attributes"), s = t1("../../lib/extend").extendFlat;
                e1.exports = s({
                    lon: o.lon,
                    lat: o.lat,
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    radius: {
                        valType: "number",
                        editType: "plot",
                        arrayOk: !0,
                        min: 1,
                        dflt: 30
                    },
                    below: {
                        valType: "string",
                        editType: "plot"
                    },
                    text: o.text,
                    hovertext: o.hovertext,
                    hoverinfo: s({}, a.hoverinfo, {
                        flags: [
                            "lon",
                            "lat",
                            "z",
                            "text",
                            "name"
                        ]
                    }),
                    hovertemplate: i(),
                    showlegend: s({}, a.showlegend, {
                        dflt: !1
                    })
                }, n("", {
                    cLetter: "z",
                    editTypeOverride: "calc"
                }));
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/template_attributes": 633,
                "../scattermapbox/attributes": 991
            }
        ],
        763: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib").isArrayOrTypedArray, a = t1("../../constants/numerical").BADNUM, o = t1("../../components/colorscale/calc"), s = t1("../../lib")._;
                e1.exports = function(t1, e1) {
                    for(var r = e1._length, l = new Array(r), c = e1.z, u = i(c) && c.length, f = 0; f < r; f++){
                        var h = l[f] = {}, p = e1.lon[f], d = e1.lat[f];
                        if (h.lonlat = n(p) && n(d) ? [
                            +p,
                            +d
                        ] : [
                            a,
                            a
                        ], u) {
                            var m = c[f];
                            h.z = n(m) ? m : a;
                        }
                    }
                    return o(t1, e1, {
                        vals: u ? c : [
                            0,
                            1
                        ],
                        containerStr: "",
                        cLetter: "z"
                    }), r && (l[0].t = {
                        labels: {
                            lat: s(t1, "lat:") + " ",
                            lon: s(t1, "lon:") + " "
                        }
                    }), l;
                };
            },
            {
                "../../components/colorscale/calc": 374,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "fast-isnumeric": 190
            }
        ],
        764: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = t1("../../components/color"), o = t1("../../components/colorscale"), s = t1("../../constants/numerical").BADNUM, l = t1("../../lib/geojson_utils").makeBlank;
                e1.exports = function(t1) {
                    var e1 = t1[0].trace, r = !0 === e1.visible && 0 !== e1._length, c = e1._opts = {
                        heatmap: {
                            layout: {
                                visibility: "none"
                            },
                            paint: {}
                        },
                        geojson: l()
                    };
                    if (!r) return c;
                    var u, f = [], h = e1.z, p = e1.radius, d = i.isArrayOrTypedArray(h) && h.length, m = i.isArrayOrTypedArray(p);
                    for(u = 0; u < t1.length; u++){
                        var g = t1[u], v = g.lonlat;
                        if (v[0] !== s) {
                            var y = {};
                            if (d) {
                                var x = g.z;
                                y.z = x !== s ? x : 0;
                            }
                            m && (y.r = n(p[u]) && p[u] > 0 ? +p[u] : 0), f.push({
                                type: "Feature",
                                geometry: {
                                    type: "Point",
                                    coordinates: v
                                },
                                properties: y
                            });
                        }
                    }
                    var b = o.extractOpts(e1), _ = b.reversescale ? o.flipScale(b.colorscale) : b.colorscale, w = _[0][1], T = [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        a.opacity(w) < 1 ? w : a.addOpacity(w, 0)
                    ];
                    for(u = 1; u < _.length; u++)T.push(_[u][0], _[u][1]);
                    var k = [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "get",
                            "z"
                        ],
                        b.min,
                        0,
                        b.max,
                        1
                    ];
                    return i.extendFlat(c.heatmap.paint, {
                        "heatmap-weight": d ? k : 1 / (b.max - b.min),
                        "heatmap-color": T,
                        "heatmap-radius": m ? {
                            type: "identity",
                            property: "r"
                        } : e1.radius,
                        "heatmap-opacity": e1.opacity
                    }), c.geojson = {
                        type: "FeatureCollection",
                        features: f
                    }, c.heatmap.layout.visibility = "visible", c;
                };
            },
            {
                "../../components/color": 366,
                "../../components/colorscale": 378,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../lib/geojson_utils": 497,
                "fast-isnumeric": 190
            }
        ],
        765: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/colorscale/defaults"), a = t1("./attributes");
                e1.exports = function(t1, e1, r, o) {
                    function s(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var l = s("lon") || [], c = s("lat") || [], u = Math.min(l.length, c.length);
                    u ? (e1._length = u, s("z"), s("radius"), s("below"), s("text"), s("hovertext"), s("hovertemplate"), i(t1, e1, o, s, {
                        prefix: "",
                        cLetter: "z"
                    })) : e1.visible = !1;
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../lib": 503,
                "./attributes": 762
            }
        ],
        766: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    return t1.lon = e1.lon, t1.lat = e1.lat, t1.z = e1.z, t1;
                };
            },
            {}
        ],
        767: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes"), i = t1("../scattermapbox/hover").hoverPoints, a = t1("../scattermapbox/hover").getExtraText;
                e1.exports = function(t1, e1, r) {
                    var o = i(t1, e1, r);
                    if (o) {
                        var s = o[0], l = s.cd, c = l[0].trace, u = l[s.index];
                        if (delete s.color, "z" in u) {
                            var f = s.subplot.mockAxis;
                            s.z = u.z, s.zLabel = n.tickText(f, f.c2l(u.z), "hover").text;
                        }
                        return s.extraText = a(c, u, l[0].t.labels), [
                            s
                        ];
                    }
                };
            },
            {
                "../../plots/cartesian/axes": 554,
                "../scattermapbox/hover": 996
            }
        ],
        768: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: t1("../heatmap/colorbar"),
                    formatLabels: t1("../scattermapbox/format_labels"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    hoverPoints: t1("./hover"),
                    eventData: t1("./event_data"),
                    getBelow: function(t1, e1) {
                        for(var r = e1.getMapLayers(), n = 0; n < r.length; n++){
                            var i = r[n], a = i.id;
                            if ("symbol" === i.type && "string" == typeof a && -1 === a.indexOf("plotly-")) return a;
                        }
                    },
                    moduleType: "trace",
                    name: "densitymapbox",
                    basePlotModule: t1("../../plots/mapbox"),
                    categories: [
                        "mapbox",
                        "gl",
                        "showLegend"
                    ],
                    meta: {
                        hr_name: "density_mapbox"
                    }
                };
            },
            {
                "../../plots/mapbox": 613,
                "../heatmap/colorbar": 795,
                "../scattermapbox/format_labels": 995,
                "./attributes": 762,
                "./calc": 763,
                "./defaults": 765,
                "./event_data": 766,
                "./hover": 767,
                "./plot": 769
            }
        ],
        769: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./convert"), i = t1("../../plots/mapbox/constants").traceLayerPrefix;
                function a(t1, e1) {
                    this.type = "densitymapbox", this.subplot = t1, this.uid = e1, this.sourceId = "source-" + e1, this.layerList = [
                        [
                            "heatmap",
                            i + e1 + "-heatmap"
                        ]
                    ], this.below = null;
                }
                var o = a.prototype;
                o.update = function(t1) {
                    var e1 = this.subplot, r = this.layerList, i = n(t1), a = e1.belowLookup["trace-" + this.uid];
                    e1.map.getSource(this.sourceId).setData(i.geojson), a !== this.below && (this._removeLayers(), this._addLayers(i, a), this.below = a);
                    for(var o = 0; o < r.length; o++){
                        var s = r[o], l = s[0], c = s[1], u = i[l];
                        e1.setOptions(c, "setLayoutProperty", u.layout), "visible" === u.layout.visibility && e1.setOptions(c, "setPaintProperty", u.paint);
                    }
                }, o._addLayers = function(t1, e1) {
                    for(var r = this.subplot, n = this.layerList, i = this.sourceId, a = 0; a < n.length; a++){
                        var o = n[a], s = o[0], l = t1[s];
                        r.addLayer({
                            type: s,
                            id: o[1],
                            source: i,
                            layout: l.layout,
                            paint: l.paint
                        }, e1);
                    }
                }, o._removeLayers = function() {
                    for(var t1 = this.subplot.map, e1 = this.layerList, r = e1.length - 1; r >= 0; r--)t1.removeLayer(e1[r][1]);
                }, o.dispose = function() {
                    var t1 = this.subplot.map;
                    this._removeLayers(), t1.removeSource(this.sourceId);
                }, e1.exports = function(t1, e1) {
                    var r = e1[0].trace, i = new a(t1, r.uid), o = i.sourceId, s = n(e1), l = i.below = t1.belowLookup["trace-" + r.uid];
                    return t1.map.addSource(o, {
                        type: "geojson",
                        data: s.geojson
                    }), i._addLayers(s, l), i;
                };
            },
            {
                "../../plots/mapbox/constants": 611,
                "./convert": 764
            }
        ],
        770: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = function(t1, e1) {
                    for(var r = 0; r < t1.length; r++)t1[r].i = r;
                    n.mergeArray(e1.text, t1, "tx"), n.mergeArray(e1.hovertext, t1, "htx");
                    var i = e1.marker;
                    if (i) {
                        n.mergeArray(i.opacity, t1, "mo"), n.mergeArray(i.color, t1, "mc");
                        var a = i.line;
                        a && (n.mergeArray(a.color, t1, "mlc"), n.mergeArrayCastPositive(a.width, t1, "mlw"));
                    }
                };
            },
            {
                "../../lib": 503
            }
        ],
        771: [
            function(t1, e1, r) {
                "use strict";
                var n, i = t1("../bar/attributes"), a = t1("../scatter/attributes").line, o = t1("../../plots/attributes"), s = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, l = t1("../../plots/template_attributes").hovertemplateAttrs, c = t1("../../plots/template_attributes").texttemplateAttrs, u = t1("./constants"), f = t1("../../lib/extend").extendFlat, h = t1("../../components/color");
                e1.exports = {
                    x: i.x,
                    x0: i.x0,
                    dx: i.dx,
                    y: i.y,
                    y0: i.y0,
                    dy: i.dy,
                    xperiod: i.xperiod,
                    yperiod: i.yperiod,
                    xperiod0: i.xperiod0,
                    yperiod0: i.yperiod0,
                    xperiodalignment: i.xperiodalignment,
                    yperiodalignment: i.yperiodalignment,
                    xhoverformat: s("x"),
                    yhoverformat: s("y"),
                    hovertext: i.hovertext,
                    hovertemplate: l({}, {
                        keys: u.eventDataKeys
                    }),
                    hoverinfo: f({}, o.hoverinfo, {
                        flags: [
                            "name",
                            "x",
                            "y",
                            "text",
                            "percent initial",
                            "percent previous",
                            "percent total"
                        ]
                    }),
                    textinfo: {
                        valType: "flaglist",
                        flags: [
                            "label",
                            "text",
                            "percent initial",
                            "percent previous",
                            "percent total",
                            "value"
                        ],
                        extras: [
                            "none"
                        ],
                        editType: "plot",
                        arrayOk: !1
                    },
                    texttemplate: c({
                        editType: "plot"
                    }, {
                        keys: u.eventDataKeys.concat([
                            "label",
                            "value"
                        ])
                    }),
                    text: i.text,
                    textposition: i.textposition,
                    insidetextanchor: f({}, i.insidetextanchor, {
                        dflt: "middle"
                    }),
                    textangle: f({}, i.textangle, {
                        dflt: 0
                    }),
                    textfont: i.textfont,
                    insidetextfont: i.insidetextfont,
                    outsidetextfont: i.outsidetextfont,
                    constraintext: i.constraintext,
                    cliponaxis: i.cliponaxis,
                    orientation: f({}, i.orientation, {}),
                    offset: f({}, i.offset, {
                        arrayOk: !1
                    }),
                    width: f({}, i.width, {
                        arrayOk: !1
                    }),
                    marker: (n = f({}, i.marker), delete n.pattern, n),
                    connector: {
                        fillcolor: {
                            valType: "color",
                            editType: "style"
                        },
                        line: {
                            color: f({}, a.color, {
                                dflt: h.defaultLine
                            }),
                            width: f({}, a.width, {
                                dflt: 0,
                                editType: "plot"
                            }),
                            dash: a.dash,
                            editType: "style"
                        },
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    offsetgroup: i.offsetgroup,
                    alignmentgroup: i.alignmentgroup
                };
            },
            {
                "../../components/color": 366,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/template_attributes": 633,
                "../bar/attributes": 648,
                "../scatter/attributes": 926,
                "./constants": 773
            }
        ],
        772: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes"), i = t1("../../plots/cartesian/align_period"), a = t1("./arrays_to_calcdata"), o = t1("../scatter/calc_selection"), s = t1("../../constants/numerical").BADNUM;
                function l(t1) {
                    return t1 === s ? 0 : t1;
                }
                e1.exports = function(t1, e1) {
                    var r, c, u, f, h, p, d, m, g = n.getFromId(t1, e1.xaxis || "x"), v = n.getFromId(t1, e1.yaxis || "y");
                    "h" === e1.orientation ? (r = g.makeCalcdata(e1, "x"), u = v.makeCalcdata(e1, "y"), f = i(e1, v, "y", u), h = !!e1.yperiodalignment, p = "y") : (r = v.makeCalcdata(e1, "y"), u = g.makeCalcdata(e1, "x"), f = i(e1, g, "x", u), h = !!e1.xperiodalignment, p = "x"), c = f.vals;
                    var y, x = Math.min(c.length, r.length), b = new Array(x);
                    for(e1._base = [], d = 0; d < x; d++){
                        r[d] < 0 && (r[d] = s);
                        var _ = !1;
                        r[d] !== s && d + 1 < x && r[d + 1] !== s && (_ = !0), m = b[d] = {
                            p: c[d],
                            s: r[d],
                            cNext: _
                        }, e1._base[d] = -0.5 * m.s, h && (b[d].orig_p = u[d], b[d][p + "End"] = f.ends[d], b[d][p + "Start"] = f.starts[d]), e1.ids && (m.id = String(e1.ids[d])), 0 === d && (b[0].vTotal = 0), b[0].vTotal += l(m.s), m.begR = l(m.s) / l(b[0].s);
                    }
                    for(d = 0; d < x; d++)(m = b[d]).s !== s && (m.sumR = m.s / b[0].vTotal, m.difR = void 0 !== y ? m.s / y : 1, y = m.s);
                    return a(b, e1), o(b, e1), b;
                };
            },
            {
                "../../constants/numerical": 479,
                "../../plots/cartesian/align_period": 551,
                "../../plots/cartesian/axes": 554,
                "../scatter/calc_selection": 928,
                "./arrays_to_calcdata": 770
            }
        ],
        773: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    eventDataKeys: [
                        "percentInitial",
                        "percentPrevious",
                        "percentTotal"
                    ]
                };
            },
            {}
        ],
        774: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../bar/cross_trace_calc").setGroupPositions;
                e1.exports = function(t1, e1) {
                    var r, i, a = t1._fullLayout, o = t1._fullData, s = t1.calcdata, l = e1.xaxis, c = e1.yaxis, u = [], f = [], h = [];
                    for(i = 0; i < o.length; i++){
                        var p = o[i], d = "h" === p.orientation;
                        !0 === p.visible && p.xaxis === l._id && p.yaxis === c._id && "funnel" === p.type && (r = s[i], d ? h.push(r) : f.push(r), u.push(r));
                    }
                    var m = {
                        mode: a.funnelmode,
                        norm: a.funnelnorm,
                        gap: a.funnelgap,
                        groupgap: a.funnelgroupgap
                    };
                    for(n(t1, l, c, f, m), n(t1, c, l, h, m), i = 0; i < u.length; i++){
                        r = u[i];
                        for(var g = 0; g < r.length; g++)g + 1 < r.length && (r[g].nextP0 = r[g + 1].p0, r[g].nextS0 = r[g + 1].s0, r[g].nextP1 = r[g + 1].p1, r[g].nextS1 = r[g + 1].s1);
                    }
                };
            },
            {
                "../bar/cross_trace_calc": 651
            }
        ],
        775: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../bar/defaults").handleGroupingDefaults, a = t1("../bar/defaults").handleText, o = t1("../scatter/xy_defaults"), s = t1("../scatter/period_defaults"), l = t1("./attributes"), c = t1("../../components/color");
                e1.exports = {
                    supplyDefaults: function(t1, e1, r, i) {
                        function u(r, i) {
                            return n.coerce(t1, e1, l, r, i);
                        }
                        if (o(t1, e1, i, u)) {
                            s(t1, e1, i, u), u("xhoverformat"), u("yhoverformat"), u("orientation", e1.y && !e1.x ? "v" : "h"), u("offset"), u("width");
                            var f = u("text");
                            u("hovertext"), u("hovertemplate");
                            var h = u("textposition");
                            a(t1, e1, i, u, h, {
                                moduleHasSelected: !1,
                                moduleHasUnselected: !1,
                                moduleHasConstrain: !0,
                                moduleHasCliponaxis: !0,
                                moduleHasTextangle: !0,
                                moduleHasInsideanchor: !0
                            }), "none" === e1.textposition || e1.texttemplate || u("textinfo", Array.isArray(f) ? "text+value" : "value");
                            var p = u("marker.color", r);
                            if (u("marker.line.color", c.defaultLine), u("marker.line.width"), u("connector.visible")) u("connector.fillcolor", function(t1) {
                                var e1 = n.isArrayOrTypedArray(t1) ? "#000" : t1;
                                return c.addOpacity(e1, .5 * c.opacity(e1));
                            }(p)), u("connector.line.width") && (u("connector.line.color"), u("connector.line.dash"));
                        } else e1.visible = !1;
                    },
                    crossTraceDefaults: function(t1, e1) {
                        var r, a;
                        function o(t1) {
                            return n.coerce(a._input, a, l, t1);
                        }
                        if ("group" === e1.funnelmode) for(var s = 0; s < t1.length; s++)r = (a = t1[s])._input, i(r, a, e1, o);
                    }
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../bar/defaults": 652,
                "../scatter/period_defaults": 946,
                "../scatter/xy_defaults": 953,
                "./attributes": 771
            }
        ],
        776: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    return t1.x = "xVal" in e1 ? e1.xVal : e1.x, t1.y = "yVal" in e1 ? e1.yVal : e1.y, "percentInitial" in e1 && (t1.percentInitial = e1.percentInitial), "percentPrevious" in e1 && (t1.percentPrevious = e1.percentPrevious), "percentTotal" in e1 && (t1.percentTotal = e1.percentTotal), e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), t1;
                };
            },
            {}
        ],
        777: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color").opacity, i = t1("../bar/hover").hoverOnBars, a = t1("../../lib").formatPercent;
                e1.exports = function(t1, e1, r, o, s) {
                    var l = i(t1, e1, r, o, s);
                    if (l) {
                        var c = l.cd, u = c[0].trace, f = "h" === u.orientation, h = c[l.index];
                        l[(f ? "x" : "y") + "LabelVal"] = h.s, l.percentInitial = h.begR, l.percentInitialLabel = a(h.begR, 1), l.percentPrevious = h.difR, l.percentPreviousLabel = a(h.difR, 1), l.percentTotal = h.sumR, l.percentTotalLabel = a(h.sumR, 1);
                        var p = h.hi || u.hoverinfo, d = [];
                        if (p && "none" !== p && "skip" !== p) {
                            var m = "all" === p, g = p.split("+"), v = function(t1) {
                                return m || -1 !== g.indexOf(t1);
                            };
                            v("percent initial") && d.push(l.percentInitialLabel + " of initial"), v("percent previous") && d.push(l.percentPreviousLabel + " of previous"), v("percent total") && d.push(l.percentTotalLabel + " of total");
                        }
                        return l.extraText = d.join("<br>"), l.color = function(t1, e1) {
                            var r = t1.marker, i = e1.mc || r.color, a = e1.mlc || r.line.color, o = e1.mlw || r.line.width;
                            if (n(i)) return i;
                            if (n(a) && o) return a;
                        }(u, h), [
                            l
                        ];
                    }
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../bar/hover": 655
            }
        ],
        778: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("./layout_attributes"),
                    supplyDefaults: t1("./defaults").supplyDefaults,
                    crossTraceDefaults: t1("./defaults").crossTraceDefaults,
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    calc: t1("./calc"),
                    crossTraceCalc: t1("./cross_trace_calc"),
                    plot: t1("./plot"),
                    style: t1("./style").style,
                    hoverPoints: t1("./hover"),
                    eventData: t1("./event_data"),
                    selectPoints: t1("../bar/select"),
                    moduleType: "trace",
                    name: "funnel",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "bar-like",
                        "cartesian",
                        "svg",
                        "oriented",
                        "showLegend",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "../bar/select": 660,
                "./attributes": 771,
                "./calc": 772,
                "./cross_trace_calc": 774,
                "./defaults": 775,
                "./event_data": 776,
                "./hover": 777,
                "./layout_attributes": 779,
                "./layout_defaults": 780,
                "./plot": 781,
                "./style": 782
            }
        ],
        779: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    funnelmode: {
                        valType: "enumerated",
                        values: [
                            "stack",
                            "group",
                            "overlay"
                        ],
                        dflt: "stack",
                        editType: "calc"
                    },
                    funnelgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "calc"
                    },
                    funnelgroupgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "calc"
                    }
                };
            },
            {}
        ],
        780: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./layout_attributes");
                e1.exports = function(t1, e1, r) {
                    var a = !1;
                    function o(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    for(var s = 0; s < r.length; s++){
                        var l = r[s];
                        if (l.visible && "funnel" === l.type) {
                            a = !0;
                            break;
                        }
                    }
                    a && (o("funnelmode"), o("funnelgap", .2), o("funnelgroupgap"));
                };
            },
            {
                "../../lib": 503,
                "./layout_attributes": 779
            }
        ],
        781: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../../components/drawing"), o = t1("../../constants/numerical").BADNUM, s = t1("../bar/plot"), l = t1("../bar/uniform_text").clearMinTextSize;
                function c(t1, e1, r, n) {
                    var i = [], a = [], o = n ? e1 : r, s = n ? r : e1;
                    return i[0] = o.c2p(t1.s0, !0), a[0] = s.c2p(t1.p0, !0), i[1] = o.c2p(t1.s1, !0), a[1] = s.c2p(t1.p1, !0), i[2] = o.c2p(t1.nextS0, !0), a[2] = s.c2p(t1.nextP0, !0), i[3] = o.c2p(t1.nextS1, !0), a[3] = s.c2p(t1.nextP1, !0), n ? [
                        i,
                        a
                    ] : [
                        a,
                        i
                    ];
                }
                e1.exports = function(t1, e1, r, u) {
                    var f = t1._fullLayout;
                    l("funnel", f), function(t1, e1, r, s) {
                        var l = e1.xaxis, u = e1.yaxis;
                        i.makeTraceGroups(s, r, "trace bars").each(function(r) {
                            var s = n.select(this), f = r[0].trace, h = i.ensureSingle(s, "g", "regions");
                            if (f.connector && f.connector.visible) {
                                var p = "h" === f.orientation, d = h.selectAll("g.region").data(i.identity);
                                d.enter().append("g").classed("region", !0), d.exit().remove();
                                var m = d.size();
                                d.each(function(r, s) {
                                    if (s === m - 1 || r.cNext) {
                                        var f = c(r, l, u, p), h = f[0], d = f[1], g = "";
                                        h[0] !== o && d[0] !== o && h[1] !== o && d[1] !== o && h[2] !== o && d[2] !== o && h[3] !== o && d[3] !== o && (g += p ? "M" + h[0] + "," + d[1] + "L" + h[2] + "," + d[2] + "H" + h[3] + "L" + h[1] + "," + d[1] + "Z" : "M" + h[1] + "," + d[1] + "L" + h[2] + "," + d[3] + "V" + d[2] + "L" + h[1] + "," + d[0] + "Z"), "" === g && (g = "M0,0Z"), i.ensureSingle(n.select(this), "path").attr("d", g).call(a.setClipUrl, e1.layerClipId, t1);
                                    }
                                });
                            } else h.remove();
                        });
                    }(t1, e1, r, u), function(t1, e1, r, o) {
                        var s = e1.xaxis, l = e1.yaxis;
                        i.makeTraceGroups(o, r, "trace bars").each(function(r) {
                            var o = n.select(this), u = r[0].trace, f = i.ensureSingle(o, "g", "lines");
                            if (u.connector && u.connector.visible && u.connector.line.width) {
                                var h = "h" === u.orientation, p = f.selectAll("g.line").data(i.identity);
                                p.enter().append("g").classed("line", !0), p.exit().remove();
                                var d = p.size();
                                p.each(function(r, o) {
                                    if (o === d - 1 || r.cNext) {
                                        var u = c(r, s, l, h), f = u[0], p = u[1], m = "";
                                        void 0 !== f[3] && void 0 !== p[3] && (h ? (m += "M" + f[0] + "," + p[1] + "L" + f[2] + "," + p[2], m += "M" + f[1] + "," + p[1] + "L" + f[3] + "," + p[2]) : (m += "M" + f[1] + "," + p[1] + "L" + f[2] + "," + p[3], m += "M" + f[1] + "," + p[0] + "L" + f[2] + "," + p[2])), "" === m && (m = "M0,0Z"), i.ensureSingle(n.select(this), "path").attr("d", m).call(a.setClipUrl, e1.layerClipId, t1);
                                    }
                                });
                            } else f.remove();
                        });
                    }(t1, e1, r, u), s.plot(t1, e1, r, u, {
                        mode: f.funnelmode,
                        norm: f.funnelmode,
                        gap: f.funnelgap,
                        groupgap: f.funnelgroupgap
                    });
                };
            },
            {
                "../../components/drawing": 388,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../bar/plot": 659,
                "../bar/uniform_text": 664,
                "@plotly/d3": 58
            }
        ],
        782: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/drawing"), a = t1("../../components/color"), o = t1("../../constants/interactions").DESELECTDIM, s = t1("../bar/style"), l = t1("../bar/uniform_text").resizeText, c = s.styleTextPoints;
                e1.exports = {
                    style: function(t1, e1, r) {
                        var s = r || n.select(t1).selectAll("g.funnellayer").selectAll("g.trace");
                        l(t1, s, "funnel"), s.style("opacity", function(t1) {
                            return t1[0].trace.opacity;
                        }), s.each(function(e1) {
                            var r = n.select(this), s = e1[0].trace;
                            r.selectAll(".point > path").each(function(t1) {
                                if (!t1.isBlank) {
                                    var e1 = s.marker;
                                    n.select(this).call(a.fill, t1.mc || e1.color).call(a.stroke, t1.mlc || e1.line.color).call(i.dashLine, e1.line.dash, t1.mlw || e1.line.width).style("opacity", s.selectedpoints && !t1.selected ? o : 1);
                                }
                            }), c(r, s, t1), r.selectAll(".regions").each(function() {
                                n.select(this).selectAll("path").style("stroke-width", 0).call(a.fill, s.connector.fillcolor);
                            }), r.selectAll(".lines").each(function() {
                                var t1 = s.connector.line;
                                i.lineGroupStyle(n.select(this).selectAll("path"), t1.width, t1.color, t1.dash);
                            });
                        });
                    }
                };
            },
            {
                "../../components/color": 366,
                "../../components/drawing": 388,
                "../../constants/interactions": 478,
                "../bar/style": 662,
                "../bar/uniform_text": 664,
                "@plotly/d3": 58
            }
        ],
        783: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../pie/attributes"), i = t1("../../plots/attributes"), a = t1("../../plots/domain").attributes, o = t1("../../plots/template_attributes").hovertemplateAttrs, s = t1("../../plots/template_attributes").texttemplateAttrs, l = t1("../../lib/extend").extendFlat;
                e1.exports = {
                    labels: n.labels,
                    label0: n.label0,
                    dlabel: n.dlabel,
                    values: n.values,
                    marker: {
                        colors: n.marker.colors,
                        line: {
                            color: l({}, n.marker.line.color, {
                                dflt: null
                            }),
                            width: l({}, n.marker.line.width, {
                                dflt: 1
                            }),
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    text: n.text,
                    hovertext: n.hovertext,
                    scalegroup: l({}, n.scalegroup, {}),
                    textinfo: l({}, n.textinfo, {
                        flags: [
                            "label",
                            "text",
                            "value",
                            "percent"
                        ]
                    }),
                    texttemplate: s({
                        editType: "plot"
                    }, {
                        keys: [
                            "label",
                            "color",
                            "value",
                            "text",
                            "percent"
                        ]
                    }),
                    hoverinfo: l({}, i.hoverinfo, {
                        flags: [
                            "label",
                            "text",
                            "value",
                            "percent",
                            "name"
                        ]
                    }),
                    hovertemplate: o({}, {
                        keys: [
                            "label",
                            "color",
                            "value",
                            "text",
                            "percent"
                        ]
                    }),
                    textposition: l({}, n.textposition, {
                        values: [
                            "inside",
                            "none"
                        ],
                        dflt: "inside"
                    }),
                    textfont: n.textfont,
                    insidetextfont: n.insidetextfont,
                    title: {
                        text: n.title.text,
                        font: n.title.font,
                        position: l({}, n.title.position, {
                            values: [
                                "top left",
                                "top center",
                                "top right"
                            ],
                            dflt: "top center"
                        }),
                        editType: "plot"
                    },
                    domain: a({
                        name: "funnelarea",
                        trace: !0,
                        editType: "calc"
                    }),
                    aspectratio: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "plot"
                    },
                    baseratio: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .333,
                        editType: "plot"
                    }
                };
            },
            {
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/domain": 584,
                "../../plots/template_attributes": 633,
                "../pie/attributes": 900
            }
        ],
        784: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/plots");
                r.name = "funnelarea", r.plot = function(t1, e1, i, a) {
                    n.plotBasePlot(r.name, t1, e1, i, a);
                }, r.clean = function(t1, e1, i, a) {
                    n.cleanBasePlot(r.name, t1, e1, i, a);
                };
            },
            {
                "../../plots/plots": 619
            }
        ],
        785: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../pie/calc");
                e1.exports = {
                    calc: function(t1, e1) {
                        return n.calc(t1, e1);
                    },
                    crossTraceCalc: function(t1) {
                        n.crossTraceCalc(t1, {
                            type: "funnelarea"
                        });
                    }
                };
            },
            {
                "../pie/calc": 902
            }
        ],
        786: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./attributes"), a = t1("../../plots/domain").defaults, o = t1("../bar/defaults").handleText, s = t1("../pie/defaults").handleLabelsAndValues;
                e1.exports = function(t1, e1, r, l) {
                    function c(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    var u = c("labels"), f = c("values"), h = s(u, f), p = h.len;
                    if (e1._hasLabels = h.hasLabels, e1._hasValues = h.hasValues, !e1._hasLabels && e1._hasValues && (c("label0"), c("dlabel")), p) {
                        e1._length = p, c("marker.line.width") && c("marker.line.color", l.paper_bgcolor), c("marker.colors"), c("scalegroup");
                        var d, m = c("text"), g = c("texttemplate");
                        if (g || (d = c("textinfo", Array.isArray(m) ? "text+percent" : "percent")), c("hovertext"), c("hovertemplate"), g || d && "none" !== d) {
                            var v = c("textposition");
                            o(t1, e1, l, c, v, {
                                moduleHasSelected: !1,
                                moduleHasUnselected: !1,
                                moduleHasConstrain: !1,
                                moduleHasCliponaxis: !1,
                                moduleHasTextangle: !1,
                                moduleHasInsideanchor: !1
                            });
                        }
                        a(e1, l, c), c("title.text") && (c("title.position"), n.coerceFont(c, "title.font", l.font)), c("aspectratio"), c("baseratio");
                    } else e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../../plots/domain": 584,
                "../bar/defaults": 652,
                "../pie/defaults": 903,
                "./attributes": 783
            }
        ],
        787: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "funnelarea",
                    basePlotModule: t1("./base_plot"),
                    categories: [
                        "pie-like",
                        "funnelarea",
                        "showLegend"
                    ],
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("./layout_attributes"),
                    supplyDefaults: t1("./defaults"),
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    calc: t1("./calc").calc,
                    crossTraceCalc: t1("./calc").crossTraceCalc,
                    plot: t1("./plot"),
                    style: t1("./style"),
                    styleOne: t1("../pie/style_one"),
                    meta: {}
                };
            },
            {
                "../pie/style_one": 911,
                "./attributes": 783,
                "./base_plot": 784,
                "./calc": 785,
                "./defaults": 786,
                "./layout_attributes": 788,
                "./layout_defaults": 789,
                "./plot": 790,
                "./style": 791
            }
        ],
        788: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../pie/layout_attributes").hiddenlabels;
                e1.exports = {
                    hiddenlabels: n,
                    funnelareacolorway: {
                        valType: "colorlist",
                        editType: "calc"
                    },
                    extendfunnelareacolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    }
                };
            },
            {
                "../pie/layout_attributes": 907
            }
        ],
        789: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./layout_attributes");
                e1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    r("hiddenlabels"), r("funnelareacolorway", e1.colorway), r("extendfunnelareacolors");
                };
            },
            {
                "../../lib": 503,
                "./layout_attributes": 788
            }
        ],
        790: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/drawing"), a = t1("../../lib"), o = a.strScale, s = a.strTranslate, l = t1("../../lib/svg_text_utils"), c = t1("../bar/plot").toMoveInsideBar, u = t1("../bar/uniform_text"), f = u.recordMinTextSize, h = u.clearMinTextSize, p = t1("../pie/helpers"), d = t1("../pie/plot"), m = d.attachFxHandlers, g = d.determineInsideTextFont, v = d.layoutAreas, y = d.prerenderTitles, x = d.positionTitleOutside, b = d.formatSliceLabel;
                function _(t1, e1) {
                    return "l" + (e1[0] - t1[0]) + "," + (e1[1] - t1[1]);
                }
                e1.exports = function(t1, e1) {
                    var r = t1._fullLayout;
                    h("funnelarea", r), y(e1, t1), v(e1, r._size), a.makeTraceGroups(r._funnelarealayer, e1, "trace").each(function(e1) {
                        var u = n.select(this), h = e1[0], d = h.trace;
                        !function(t1) {
                            if (!t1.length) return;
                            var e1 = t1[0], r = e1.trace, n = r.aspectratio, i = r.baseratio;
                            i > .999 && (i = .999);
                            var a, o = Math.pow(i, 2), s = e1.vTotal, l = s, c = s * o / (1 - o) / s;
                            function u() {
                                var t1, e1 = {
                                    x: t1 = Math.sqrt(c),
                                    y: -t1
                                };
                                return [
                                    e1.x,
                                    e1.y
                                ];
                            }
                            var f, h, p = [];
                            for(p.push(u()), f = t1.length - 1; f > -1; f--)if (!(h = t1[f]).hidden) {
                                var d = h.v / l;
                                c += d, p.push(u());
                            }
                            var m = 1 / 0, g = -1 / 0;
                            for(f = 0; f < p.length; f++)a = p[f], m = Math.min(m, a[1]), g = Math.max(g, a[1]);
                            for(f = 0; f < p.length; f++)p[f][1] -= (g + m) / 2;
                            var v = p[p.length - 1][0], y = e1.r, x = (g - m) / 2, b = y / v, _ = y / x * n;
                            for(e1.r = _ * x, f = 0; f < p.length; f++)p[f][0] *= b, p[f][1] *= _;
                            var w = [
                                -(a = p[0])[0],
                                a[1]
                            ], T = [
                                a[0],
                                a[1]
                            ], k = 0;
                            for(f = t1.length - 1; f > -1; f--)if (!(h = t1[f]).hidden) {
                                var A = p[k += 1][0], M = p[k][1];
                                h.TL = [
                                    -A,
                                    M
                                ], h.TR = [
                                    A,
                                    M
                                ], h.BL = w, h.BR = T, h.pxmid = (S = h.TR, E = h.BR, [
                                    .5 * (S[0] + E[0]),
                                    .5 * (S[1] + E[1])
                                ]), w = h.TL, T = h.TR;
                            }
                            var S, E;
                        }(e1), u.each(function() {
                            var u = n.select(this).selectAll("g.slice").data(e1);
                            u.enter().append("g").classed("slice", !0), u.exit().remove(), u.each(function(o, s) {
                                if (o.hidden) n.select(this).selectAll("path,g").remove();
                                else {
                                    o.pointNumber = o.i, o.curveNumber = d.index;
                                    var u = h.cx, v = h.cy, y = n.select(this), x = y.selectAll("path.surface").data([
                                        o
                                    ]);
                                    x.enter().append("path").classed("surface", !0).style({
                                        "pointer-events": "all"
                                    }), y.call(m, t1, e1);
                                    var w = "M" + (u + o.TR[0]) + "," + (v + o.TR[1]) + _(o.TR, o.BR) + _(o.BR, o.BL) + _(o.BL, o.TL) + "Z";
                                    x.attr("d", w), b(t1, o, h);
                                    var T = p.castOption(d.textposition, o.pts), k = y.selectAll("g.slicetext").data(o.text && "none" !== T ? [
                                        0
                                    ] : []);
                                    k.enter().append("g").classed("slicetext", !0), k.exit().remove(), k.each(function() {
                                        var h = a.ensureSingle(n.select(this), "text", "", function(t1) {
                                            t1.attr("data-notex", 1);
                                        }), p = a.ensureUniformFontSize(t1, g(d, o, r.font));
                                        h.text(o.text).attr({
                                            class: "slicetext",
                                            transform: "",
                                            "text-anchor": "middle"
                                        }).call(i.font, p).call(l.convertToTspans, t1);
                                        var m, y, x, b = i.bBox(h.node()), _ = Math.min(o.BL[1], o.BR[1]) + v, w = Math.max(o.TL[1], o.TR[1]) + v;
                                        y = Math.max(o.TL[0], o.BL[0]) + u, x = Math.min(o.TR[0], o.BR[0]) + u, (m = c(y, x, _, w, b, {
                                            isHorizontal: !0,
                                            constrained: !0,
                                            angle: 0,
                                            anchor: "middle"
                                        })).fontSize = p.size, f(d.type, m, r), e1[s].transform = m, h.attr("transform", a.getTextTransform(m));
                                    });
                                }
                            });
                            var v = n.select(this).selectAll("g.titletext").data(d.title.text ? [
                                0
                            ] : []);
                            v.enter().append("g").classed("titletext", !0), v.exit().remove(), v.each(function() {
                                var e1 = a.ensureSingle(n.select(this), "text", "", function(t1) {
                                    t1.attr("data-notex", 1);
                                }), c = d.title.text;
                                d._meta && (c = a.templateString(c, d._meta)), e1.text(c).attr({
                                    class: "titletext",
                                    transform: "",
                                    "text-anchor": "middle"
                                }).call(i.font, d.title.font).call(l.convertToTspans, t1);
                                var u = x(h, r._size);
                                e1.attr("transform", s(u.x, u.y) + o(Math.min(1, u.scale)) + s(u.tx, u.ty));
                            });
                        });
                    });
                };
            },
            {
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../bar/plot": 659,
                "../bar/uniform_text": 664,
                "../pie/helpers": 905,
                "../pie/plot": 909,
                "@plotly/d3": 58
            }
        ],
        791: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../pie/style_one"), a = t1("../bar/uniform_text").resizeText;
                e1.exports = function(t1) {
                    var e1 = t1._fullLayout._funnelarealayer.selectAll(".trace");
                    a(t1, e1, "funnelarea"), e1.each(function(t1) {
                        var e1 = t1[0].trace, r = n.select(this);
                        r.style({
                            opacity: e1.opacity
                        }), r.selectAll("path.surface").each(function(t1) {
                            n.select(this).call(i, t1, e1);
                        });
                    });
                };
            },
            {
                "../bar/uniform_text": 664,
                "../pie/style_one": 911,
                "@plotly/d3": 58
            }
        ],
        792: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/attributes"), i = t1("../../plots/attributes"), a = t1("../../plots/font_attributes"), o = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, s = t1("../../plots/template_attributes").hovertemplateAttrs, l = t1("../../plots/template_attributes").texttemplateAttrs, c = t1("../../components/colorscale/attributes"), u = t1("../../lib/extend").extendFlat;
                e1.exports = u({
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    x: u({}, n.x, {
                        impliedEdits: {
                            xtype: "array"
                        }
                    }),
                    x0: u({}, n.x0, {
                        impliedEdits: {
                            xtype: "scaled"
                        }
                    }),
                    dx: u({}, n.dx, {
                        impliedEdits: {
                            xtype: "scaled"
                        }
                    }),
                    y: u({}, n.y, {
                        impliedEdits: {
                            ytype: "array"
                        }
                    }),
                    y0: u({}, n.y0, {
                        impliedEdits: {
                            ytype: "scaled"
                        }
                    }),
                    dy: u({}, n.dy, {
                        impliedEdits: {
                            ytype: "scaled"
                        }
                    }),
                    xperiod: u({}, n.xperiod, {
                        impliedEdits: {
                            xtype: "scaled"
                        }
                    }),
                    yperiod: u({}, n.yperiod, {
                        impliedEdits: {
                            ytype: "scaled"
                        }
                    }),
                    xperiod0: u({}, n.xperiod0, {
                        impliedEdits: {
                            xtype: "scaled"
                        }
                    }),
                    yperiod0: u({}, n.yperiod0, {
                        impliedEdits: {
                            ytype: "scaled"
                        }
                    }),
                    xperiodalignment: u({}, n.xperiodalignment, {
                        impliedEdits: {
                            xtype: "scaled"
                        }
                    }),
                    yperiodalignment: u({}, n.yperiodalignment, {
                        impliedEdits: {
                            ytype: "scaled"
                        }
                    }),
                    text: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    hovertext: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    transpose: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    xtype: {
                        valType: "enumerated",
                        values: [
                            "array",
                            "scaled"
                        ],
                        editType: "calc+clearAxisTypes"
                    },
                    ytype: {
                        valType: "enumerated",
                        values: [
                            "array",
                            "scaled"
                        ],
                        editType: "calc+clearAxisTypes"
                    },
                    zsmooth: {
                        valType: "enumerated",
                        values: [
                            "fast",
                            "best",
                            !1
                        ],
                        dflt: !1,
                        editType: "calc"
                    },
                    hoverongaps: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "none"
                    },
                    connectgaps: {
                        valType: "boolean",
                        editType: "calc"
                    },
                    xgap: {
                        valType: "number",
                        dflt: 0,
                        min: 0,
                        editType: "plot"
                    },
                    ygap: {
                        valType: "number",
                        dflt: 0,
                        min: 0,
                        editType: "plot"
                    },
                    xhoverformat: o("x"),
                    yhoverformat: o("y"),
                    zhoverformat: o("z", 1),
                    hovertemplate: s(),
                    texttemplate: l({
                        arrayOk: !1,
                        editType: "plot"
                    }, {
                        keys: [
                            "x",
                            "y",
                            "z",
                            "text"
                        ]
                    }),
                    textfont: a({
                        editType: "plot",
                        autoSize: !0,
                        autoColor: !0,
                        colorEditType: "style"
                    }),
                    showlegend: u({}, i.showlegend, {
                        dflt: !1
                    })
                }, {
                    transforms: void 0
                }, c("", {
                    cLetter: "z",
                    autoColorDflt: !1
                }));
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/font_attributes": 585,
                "../../plots/template_attributes": 633,
                "../scatter/attributes": 926
            }
        ],
        793: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib"), a = t1("../../plots/cartesian/axes"), o = t1("../../plots/cartesian/align_period"), s = t1("../histogram2d/calc"), l = t1("../../components/colorscale/calc"), c = t1("./convert_column_xyz"), u = t1("./clean_2d_array"), f = t1("./interp2d"), h = t1("./find_empties"), p = t1("./make_bound_array"), d = t1("../../constants/numerical").BADNUM;
                function m(t1) {
                    for(var e1 = [], r = t1.length, n = 0; n < r; n++){
                        var i = t1[n];
                        i !== d && e1.push(i);
                    }
                    return e1;
                }
                e1.exports = function(t1, e1) {
                    var r, g, v, y, x, b, _, w, T, k, A, M = a.getFromId(t1, e1.xaxis || "x"), S = a.getFromId(t1, e1.yaxis || "y"), E = n.traceIs(e1, "contour"), L = n.traceIs(e1, "histogram"), C = n.traceIs(e1, "gl2d"), P = E ? "best" : e1.zsmooth;
                    if (M._minDtick = 0, S._minDtick = 0, L) y = (A = s(t1, e1)).orig_x, r = A.x, g = A.x0, v = A.dx, w = A.orig_y, x = A.y, b = A.y0, _ = A.dy, T = A.z;
                    else {
                        var I = e1.z;
                        i.isArray1D(I) ? (c(e1, M, S, "x", "y", [
                            "z"
                        ]), r = e1._x, x = e1._y, I = e1._z) : (y = e1.x ? M.makeCalcdata(e1, "x") : [], w = e1.y ? S.makeCalcdata(e1, "y") : [], r = o(e1, M, "x", y).vals, x = o(e1, S, "y", w).vals, e1._x = r, e1._y = x), g = e1.x0, v = e1.dx, b = e1.y0, _ = e1.dy, T = u(I, e1, M, S);
                    }
                    function O(t1) {
                        P = e1._input.zsmooth = e1.zsmooth = !1, i.warn('cannot use zsmooth: "fast": ' + t1);
                    }
                    if ((M.rangebreaks || S.rangebreaks) && (T = function(t1, e1, r) {
                        for(var n = [], i = -1, a = 0; a < r.length; a++)if (e1[a] !== d) {
                            i++, n[i] = [];
                            for(var o = 0; o < r[a].length; o++)t1[o] !== d && n[i].push(r[a][o]);
                        }
                        return n;
                    }(r, x, T), L || (r = m(r), x = m(x), e1._x = r, e1._y = x)), L || !E && !e1.connectgaps || (e1._emptypoints = h(T), f(T, e1._emptypoints)), "fast" === P) {
                        if ("log" === M.type || "log" === S.type) O("log axis found");
                        else if (!L) {
                            if (r.length) {
                                var z = (r[r.length - 1] - r[0]) / (r.length - 1), D = Math.abs(z / 100);
                                for(k = 0; k < r.length - 1; k++)if (Math.abs(r[k + 1] - r[k] - z) > D) {
                                    O("x scale is not linear");
                                    break;
                                }
                            }
                            if (x.length && "fast" === P) {
                                var R = (x[x.length - 1] - x[0]) / (x.length - 1), F = Math.abs(R / 100);
                                for(k = 0; k < x.length - 1; k++)if (Math.abs(x[k + 1] - x[k] - R) > F) {
                                    O("y scale is not linear");
                                    break;
                                }
                            }
                        }
                    }
                    var B = i.maxRowLength(T), N = "scaled" === e1.xtype ? "" : r, j = p(e1, N, g, v, B, M), U = "scaled" === e1.ytype ? "" : x, V = p(e1, U, b, _, T.length, S);
                    C || (e1._extremes[M._id] = a.findExtremes(M, j), e1._extremes[S._id] = a.findExtremes(S, V));
                    var H = {
                        x: j,
                        y: V,
                        z: T,
                        text: e1._text || e1.text,
                        hovertext: e1._hovertext || e1.hovertext
                    };
                    if (e1.xperiodalignment && y && (H.orig_x = y), e1.yperiodalignment && w && (H.orig_y = w), N && N.length === j.length - 1 && (H.xCenter = N), U && U.length === V.length - 1 && (H.yCenter = U), L && (H.xRanges = A.xRanges, H.yRanges = A.yRanges, H.pts = A.pts), E || l(t1, e1, {
                        vals: T,
                        cLetter: "z"
                    }), E && e1.contours && "heatmap" === e1.contours.coloring) {
                        var q = {
                            type: "contour" === e1.type ? "heatmap" : "histogram2d",
                            xcalendar: e1.xcalendar,
                            ycalendar: e1.ycalendar
                        };
                        H.xfill = p(q, N, g, v, B, M), H.yfill = p(q, U, b, _, T.length, S);
                    }
                    return [
                        H
                    ];
                };
            },
            {
                "../../components/colorscale/calc": 374,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../plots/cartesian/align_period": 551,
                "../../plots/cartesian/axes": 554,
                "../../registry": 638,
                "../histogram2d/calc": 826,
                "./clean_2d_array": 794,
                "./convert_column_xyz": 796,
                "./find_empties": 798,
                "./interp2d": 801,
                "./make_bound_array": 803
            }
        ],
        794: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = t1("../../constants/numerical").BADNUM;
                e1.exports = function(t1, e1, r, o) {
                    var s, l, c, u, f, h;
                    function p(t1) {
                        if (n(t1)) return +t1;
                    }
                    if (e1 && e1.transpose) {
                        for(s = 0, f = 0; f < t1.length; f++)s = Math.max(s, t1[f].length);
                        if (0 === s) return !1;
                        c = function(t1) {
                            return t1.length;
                        }, u = function(t1, e1, r) {
                            return (t1[r] || [])[e1];
                        };
                    } else s = t1.length, c = function(t1, e1) {
                        return t1[e1].length;
                    }, u = function(t1, e1, r) {
                        return (t1[e1] || [])[r];
                    };
                    var d = function(t1, e1, r) {
                        return e1 === a || r === a ? a : u(t1, e1, r);
                    };
                    function m(t1) {
                        if (e1 && "carpet" !== e1.type && "contourcarpet" !== e1.type && t1 && "category" === t1.type && e1["_" + t1._id.charAt(0)].length) {
                            var r = t1._id.charAt(0), n = {}, o = e1["_" + r + "CategoryMap"] || e1[r];
                            for(f = 0; f < o.length; f++)n[o[f]] = f;
                            return function(e1) {
                                var r = n[t1._categories[e1]];
                                return r + 1 ? r : a;
                            };
                        }
                        return i.identity;
                    }
                    var g = m(r), v = m(o);
                    o && "category" === o.type && (s = o._categories.length);
                    var y = new Array(s);
                    for(f = 0; f < s; f++)for(l = r && "category" === r.type ? r._categories.length : c(t1, f), y[f] = new Array(l), h = 0; h < l; h++)y[f][h] = p(d(t1, v(f), g(h)));
                    return y;
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "fast-isnumeric": 190
            }
        ],
        795: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    min: "zmin",
                    max: "zmax"
                };
            },
            {}
        ],
        796: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../constants/numerical").BADNUM, a = t1("../../plots/cartesian/align_period");
                e1.exports = function(t1, e1, r, o, s, l) {
                    var c = t1._length, u = e1.makeCalcdata(t1, o), f = r.makeCalcdata(t1, s);
                    u = a(t1, e1, o, u).vals, f = a(t1, r, s, f).vals;
                    var h, p, d, m, g = t1.text, v = void 0 !== g && n.isArray1D(g), y = t1.hovertext, x = void 0 !== y && n.isArray1D(y), b = n.distinctVals(u), _ = b.vals, w = n.distinctVals(f), T = w.vals, k = [], A = T.length, M = _.length;
                    for(h = 0; h < l.length; h++)k[h] = n.init2dArray(A, M);
                    v && (d = n.init2dArray(A, M)), x && (m = n.init2dArray(A, M));
                    var S = n.init2dArray(A, M);
                    for(h = 0; h < c; h++)if (u[h] !== i && f[h] !== i) {
                        var E = n.findBin(u[h] + b.minDiff / 2, _), L = n.findBin(f[h] + w.minDiff / 2, T);
                        for(p = 0; p < l.length; p++){
                            var C = t1[l[p]];
                            k[p][L][E] = C[h], S[L][E] = h;
                        }
                        v && (d[L][E] = g[h]), x && (m[L][E] = y[h]);
                    }
                    for(t1["_" + o] = _, t1["_" + s] = T, p = 0; p < l.length; p++)t1["_" + l[p]] = k[p];
                    v && (t1._text = d), x && (t1._hovertext = m), e1 && "category" === e1.type && (t1["_" + o + "CategoryMap"] = _.map(function(t1) {
                        return e1._categories[t1];
                    })), r && "category" === r.type && (t1["_" + s + "CategoryMap"] = T.map(function(t1) {
                        return r._categories[t1];
                    })), t1._after2before = S;
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../plots/cartesian/align_period": 551
            }
        ],
        797: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./xyz_defaults"), a = t1("./label_defaults"), o = t1("../scatter/period_defaults"), s = t1("./style_defaults"), l = t1("../../components/colorscale/defaults"), c = t1("./attributes");
                e1.exports = function(t1, e1, r, u) {
                    function f(r, i) {
                        return n.coerce(t1, e1, c, r, i);
                    }
                    i(t1, e1, f, u) ? (o(t1, e1, u, f), f("xhoverformat"), f("yhoverformat"), f("text"), f("hovertext"), f("hovertemplate"), a(f, u), s(t1, e1, f, u), f("hoverongaps"), f("connectgaps", n.isArray1D(e1.z) && !1 !== e1.zsmooth), l(t1, e1, u, f, {
                        prefix: "",
                        cLetter: "z"
                    })) : e1.visible = !1;
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../lib": 503,
                "../scatter/period_defaults": 946,
                "./attributes": 792,
                "./label_defaults": 802,
                "./style_defaults": 806,
                "./xyz_defaults": 807
            }
        ],
        798: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").maxRowLength;
                e1.exports = function(t1) {
                    var e1, r, i, a, o, s, l, c, u = [], f = {}, h = [], p = t1[0], d = [], m = [
                        0,
                        0,
                        0
                    ], g = n(t1);
                    for(r = 0; r < t1.length; r++)for(e1 = d, d = p, p = t1[r + 1] || [], i = 0; i < g; i++)void 0 === d[i] && ((s = (void 0 !== d[i - 1] ? 1 : 0) + (void 0 !== d[i + 1] ? 1 : 0) + (void 0 !== e1[i] ? 1 : 0) + (void 0 !== p[i] ? 1 : 0)) ? (0 === r && s++, 0 === i && s++, r === t1.length - 1 && s++, i === d.length - 1 && s++, s < 4 && (f[[
                        r,
                        i
                    ]] = [
                        r,
                        i,
                        s
                    ]), u.push([
                        r,
                        i,
                        s
                    ])) : h.push([
                        r,
                        i
                    ]));
                    for(; h.length;){
                        for(l = {}, c = !1, o = h.length - 1; o >= 0; o--)(s = ((f[[
                            (r = (a = h[o])[0]) - 1,
                            i = a[1]
                        ]] || m)[2] + (f[[
                            r + 1,
                            i
                        ]] || m)[2] + (f[[
                            r,
                            i - 1
                        ]] || m)[2] + (f[[
                            r,
                            i + 1
                        ]] || m)[2]) / 20) && (l[a] = [
                            r,
                            i,
                            s
                        ], h.splice(o, 1), c = !0);
                        if (!c) throw "findEmpties iterated with no new neighbors";
                        for(a in l)f[a] = l[a], u.push(l[a]);
                    }
                    return u.sort(function(t1, e1) {
                        return e1[2] - t1[2];
                    });
                };
            },
            {
                "../../lib": 503
            }
        ],
        799: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/fx"), i = t1("../../lib"), a = t1("../../plots/cartesian/axes"), o = t1("../../components/colorscale").extractOpts;
                e1.exports = function(t1, e1, r, s, l) {
                    l || (l = {});
                    var c, u, f, h, p = l.isContour, d = t1.cd[0], m = d.trace, g = t1.xa, v = t1.ya, y = d.x, x = d.y, b = d.z, _ = d.xCenter, w = d.yCenter, T = d.zmask, k = m.zhoverformat, A = y, M = x;
                    if (!1 !== t1.index) {
                        try {
                            f = Math.round(t1.index[1]), h = Math.round(t1.index[0]);
                        } catch (e1) {
                            return void i.error("Error hovering on heatmap, pointNumber must be [row,col], found:", t1.index);
                        }
                        if (f < 0 || f >= b[0].length || h < 0 || h > b.length) return;
                    } else {
                        if (n.inbox(e1 - y[0], e1 - y[y.length - 1], 0) > 0 || n.inbox(r - x[0], r - x[x.length - 1], 0) > 0) return;
                        if (p) {
                            var S;
                            for(A = [
                                2 * y[0] - y[1]
                            ], S = 1; S < y.length; S++)A.push((y[S] + y[S - 1]) / 2);
                            for(A.push([
                                2 * y[y.length - 1] - y[y.length - 2]
                            ]), M = [
                                2 * x[0] - x[1]
                            ], S = 1; S < x.length; S++)M.push((x[S] + x[S - 1]) / 2);
                            M.push([
                                2 * x[x.length - 1] - x[x.length - 2]
                            ]);
                        }
                        f = Math.max(0, Math.min(A.length - 2, i.findBin(e1, A))), h = Math.max(0, Math.min(M.length - 2, i.findBin(r, M)));
                    }
                    var E, L, C = g.c2p(y[f]), P = g.c2p(y[f + 1]), I = v.c2p(x[h]), O = v.c2p(x[h + 1]);
                    p ? (E = d.orig_x || y, L = d.orig_y || x, P = C, c = E[f], O = I, u = L[h]) : (E = d.orig_x || _ || y, L = d.orig_y || w || x, c = _ ? E[f] : (E[f] + E[f + 1]) / 2, u = w ? L[h] : (L[h] + L[h + 1]) / 2, g && "category" === g.type && (c = y[f]), v && "category" === v.type && (u = x[h]), m.zsmooth && (C = P = g.c2p(c), I = O = v.c2p(u)));
                    var z = b[h][f];
                    if (T && !T[h][f] && (z = void 0), void 0 !== z || m.hoverongaps) {
                        var D;
                        Array.isArray(d.hovertext) && Array.isArray(d.hovertext[h]) ? D = d.hovertext[h][f] : Array.isArray(d.text) && Array.isArray(d.text[h]) && (D = d.text[h][f]);
                        var R = o(m), F = {
                            type: "linear",
                            range: [
                                R.min,
                                R.max
                            ],
                            hoverformat: k,
                            _separators: g._separators,
                            _numFormat: g._numFormat
                        }, B = a.tickText(F, z, "hover").text;
                        return [
                            i.extendFlat(t1, {
                                index: m._after2before ? m._after2before[h][f] : [
                                    h,
                                    f
                                ],
                                distance: t1.maxHoverDistance,
                                spikeDistance: t1.maxSpikeDistance,
                                x0: C,
                                x1: P,
                                y0: I,
                                y1: O,
                                xLabelVal: c,
                                yLabelVal: u,
                                zLabelVal: z,
                                zLabel: B,
                                text: D
                            })
                        ];
                    }
                };
            },
            {
                "../../components/colorscale": 378,
                "../../components/fx": 406,
                "../../lib": 503,
                "../../plots/cartesian/axes": 554
            }
        ],
        800: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    colorbar: t1("./colorbar"),
                    style: t1("./style"),
                    hoverPoints: t1("./hover"),
                    moduleType: "trace",
                    name: "heatmap",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "cartesian",
                        "svg",
                        "2dMap",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "./attributes": 792,
                "./calc": 793,
                "./colorbar": 795,
                "./defaults": 797,
                "./hover": 799,
                "./plot": 804,
                "./style": 805
            }
        ],
        801: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = [
                    [
                        -1,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        -1
                    ],
                    [
                        0,
                        1
                    ]
                ];
                function a(t1) {
                    return .5 - .25 * Math.min(1, .5 * t1);
                }
                function o(t1, e1, r) {
                    var n, a, o, s, l, c, u, f, h, p, d, m, g, v = 0;
                    for(s = 0; s < e1.length; s++){
                        for(a = (n = e1[s])[0], o = n[1], d = t1[a][o], p = 0, h = 0, l = 0; l < 4; l++)(u = t1[a + (c = i[l])[0]]) && void 0 !== (f = u[o + c[1]]) && (0 === p ? m = g = f : (m = Math.min(m, f), g = Math.max(g, f)), h++, p += f);
                        if (0 === h) throw "iterateInterp2d order is wrong: no defined neighbors";
                        t1[a][o] = p / h, void 0 === d ? h < 4 && (v = 1) : (t1[a][o] = (1 + r) * t1[a][o] - r * d, g > m && (v = Math.max(v, Math.abs(t1[a][o] - d) / (g - m))));
                    }
                    return v;
                }
                e1.exports = function(t1, e1) {
                    var r, i = 1;
                    for(o(t1, e1), r = 0; r < e1.length && !(e1[r][2] < 4); r++);
                    for(e1 = e1.slice(r), r = 0; r < 100 && i > .01; r++)i = o(t1, e1, a(i));
                    return i > .01 && n.log("interp2d didn't converge quickly", i), t1;
                };
            },
            {
                "../../lib": 503
            }
        ],
        802: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = function(t1, e1) {
                    t1("texttemplate");
                    var r = n.extendFlat({}, e1.font, {
                        color: "auto",
                        size: "auto"
                    });
                    n.coerceFont(t1, "textfont", r);
                };
            },
            {
                "../../lib": 503
            }
        ],
        803: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib").isArrayOrTypedArray;
                e1.exports = function(t1, e1, r, a, o, s) {
                    var l, c, u, f = [], h = n.traceIs(t1, "contour"), p = n.traceIs(t1, "histogram"), d = n.traceIs(t1, "gl2d");
                    if (i(e1) && e1.length > 1 && !p && "category" !== s.type) {
                        var m = e1.length;
                        if (!(m <= o)) return h ? e1.slice(0, o) : e1.slice(0, o + 1);
                        if (h || d) f = e1.slice(0, o);
                        else if (1 === o) f = [
                            e1[0] - .5,
                            e1[0] + .5
                        ];
                        else {
                            for(f = [
                                1.5 * e1[0] - .5 * e1[1]
                            ], u = 1; u < m; u++)f.push(.5 * (e1[u - 1] + e1[u]));
                            f.push(1.5 * e1[m - 1] - .5 * e1[m - 2]);
                        }
                        if (m < o) {
                            var g = f[f.length - 1], v = g - f[f.length - 2];
                            for(u = m; u < o; u++)g += v, f.push(g);
                        }
                    } else {
                        var y = t1[s._id.charAt(0) + "calendar"];
                        if (p) l = s.r2c(r, 0, y);
                        else if (i(e1) && 1 === e1.length) l = e1[0];
                        else if (void 0 === r) l = 0;
                        else l = ("log" === s.type ? s.d2c : s.r2c)(r, 0, y);
                        for(c = a || 1, u = h || d ? 0 : -0.5; u < o; u++)f.push(l + c * u);
                    }
                    return f;
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638
            }
        ],
        804: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("tinycolor2"), a = t1("../../registry"), o = t1("../../components/drawing"), s = t1("../../plots/cartesian/axes"), l = t1("../../lib"), c = t1("../../lib/svg_text_utils"), u = t1("../scatter/format_labels"), f = t1("../../components/color"), h = t1("../../components/colorscale").extractOpts, p = t1("../../components/colorscale").makeColorScaleFuncFromTrace, d = t1("../../constants/xmlns_namespaces"), m = t1("../../constants/alignment").LINE_SPACING;
                function g(t1) {
                    return t1.selectAll("g.heatmap-label");
                }
                function v(t1) {
                    g(t1).remove();
                }
                function y(t1, e1) {
                    var r = e1.length - 2, n = l.constrain(l.findBin(t1, e1), 0, r), i = e1[n], a = e1[n + 1], o = l.constrain(n + (t1 - i) / (a - i) - .5, 0, r), s = Math.round(o), c = Math.abs(o - s);
                    return o && o !== r && c ? {
                        bin0: s,
                        frac: c,
                        bin1: Math.round(s + c / (o - s))
                    } : {
                        bin0: s,
                        bin1: s,
                        frac: 0
                    };
                }
                function x(t1, e1) {
                    var r = e1.length - 1, n = l.constrain(l.findBin(t1, e1), 0, r), i = e1[n], a = (t1 - i) / (e1[n + 1] - i) || 0;
                    return a <= 0 ? {
                        bin0: n,
                        bin1: n,
                        frac: 0
                    } : a < .5 ? {
                        bin0: n,
                        bin1: n + 1,
                        frac: a
                    } : {
                        bin0: n + 1,
                        bin1: n,
                        frac: 1 - a
                    };
                }
                function b(t1, e1, r) {
                    t1[e1] = r[0], t1[e1 + 1] = r[1], t1[e1 + 2] = r[2], t1[e1 + 3] = Math.round(255 * r[3]);
                }
                e1.exports = function(t1, e1, r, _) {
                    var w = e1.xaxis, T = e1.yaxis;
                    l.makeTraceGroups(_, r, "hm").each(function(e1) {
                        var r, _, k, A, M, S, E, L, C = n.select(this), P = e1[0], I = P.trace, O = I.xgap || 0, z = I.ygap || 0, D = P.z, R = P.x, F = P.y, B = P.xCenter, N = P.yCenter, j = a.traceIs(I, "contour"), U = j ? "best" : I.zsmooth, V = D.length, H = l.maxRowLength(D), q = !1, G = !1;
                        for(S = 0; void 0 === r && S < R.length - 1;)r = w.c2p(R[S]), S++;
                        for(S = R.length - 1; void 0 === _ && S > 0;)_ = w.c2p(R[S]), S--;
                        for(_ < r && (k = _, _ = r, r = k, q = !0), S = 0; void 0 === A && S < F.length - 1;)A = T.c2p(F[S]), S++;
                        for(S = F.length - 1; void 0 === M && S > 0;)M = T.c2p(F[S]), S--;
                        if (M < A && (k = A, A = M, M = k, G = !0), j && (B = R, N = F, R = P.xfill, F = P.yfill), "fast" !== U) {
                            var Y = "best" === U ? 0 : .5;
                            r = Math.max(-Y * w._length, r), _ = Math.min((1 + Y) * w._length, _), A = Math.max(-Y * T._length, A), M = Math.min((1 + Y) * T._length, M);
                        }
                        var W, X, Z = Math.round(_ - r), J = Math.round(M - A);
                        if (Z <= 0 || J <= 0) return C.selectAll("image").data([]).exit().remove(), void v(C);
                        "fast" === U ? (W = H, X = V) : (W = Z, X = J);
                        var K = document.createElement("canvas");
                        K.width = W, K.height = X;
                        var Q, $, tt = K.getContext("2d"), et = p(I, {
                            noNumericCheck: !0,
                            returnArray: !0
                        });
                        "fast" === U ? (Q = q ? function(t1) {
                            return H - 1 - t1;
                        } : l.identity, $ = G ? function(t1) {
                            return V - 1 - t1;
                        } : l.identity) : (Q = function(t1) {
                            return l.constrain(Math.round(w.c2p(R[t1]) - r), 0, Z);
                        }, $ = function(t1) {
                            return l.constrain(Math.round(T.c2p(F[t1]) - A), 0, J);
                        });
                        var rt, nt, it, at, ot = $(0), st = [
                            ot,
                            ot
                        ], lt = q ? 0 : 1, ct = G ? 0 : 1, ut = 0, ft = 0, ht = 0, pt = 0;
                        function dt(t1, e1) {
                            if (void 0 !== t1) {
                                var r = et(t1);
                                return r[0] = Math.round(r[0]), r[1] = Math.round(r[1]), r[2] = Math.round(r[2]), ut += e1, ft += r[0] * e1, ht += r[1] * e1, pt += r[2] * e1, r;
                            }
                            return [
                                0,
                                0,
                                0,
                                0
                            ];
                        }
                        function mt(t1, e1, r, n) {
                            var i = t1[r.bin0];
                            if (void 0 === i) return dt(void 0, 1);
                            var a, o = t1[r.bin1], s = e1[r.bin0], l = e1[r.bin1], c = o - i || 0, u = s - i || 0;
                            return a = void 0 === o ? void 0 === l ? 0 : void 0 === s ? 2 * (l - i) : 2 * (2 * l - s - i) / 3 : void 0 === l ? void 0 === s ? 0 : 2 * (2 * i - o - s) / 3 : void 0 === s ? 2 * (2 * l - o - i) / 3 : l + i - o - s, dt(i + r.frac * c + n.frac * (u + r.frac * a));
                        }
                        if (U) {
                            var gt, vt = 0;
                            try {
                                gt = new Uint8Array(Z * J * 4);
                            } catch (t1) {
                                gt = new Array(Z * J * 4);
                            }
                            if ("best" === U) {
                                var yt, xt, bt, _t = B || R, wt = N || F, Tt = new Array(_t.length), kt = new Array(wt.length), At = new Array(Z), Mt = B ? x : y, St = N ? x : y;
                                for(S = 0; S < _t.length; S++)Tt[S] = Math.round(w.c2p(_t[S]) - r);
                                for(S = 0; S < wt.length; S++)kt[S] = Math.round(T.c2p(wt[S]) - A);
                                for(S = 0; S < Z; S++)At[S] = Mt(S, Tt);
                                for(E = 0; E < J; E++)for(xt = D[(yt = St(E, kt)).bin0], bt = D[yt.bin1], S = 0; S < Z; S++, vt += 4)b(gt, vt, at = mt(xt, bt, At[S], yt));
                            } else for(E = 0; E < V; E++)for(it = D[E], st = $(E), S = 0; S < Z; S++)at = dt(it[S], 1), b(gt, vt = 4 * (st * Z + Q(S)), at);
                            var Et = tt.createImageData(Z, J);
                            try {
                                Et.data.set(gt);
                            } catch (t1) {
                                var Lt = Et.data, Ct = Lt.length;
                                for(E = 0; E < Ct; E++)Lt[E] = gt[E];
                            }
                            tt.putImageData(Et, 0, 0);
                        } else {
                            var Pt = Math.floor(O / 2), It = Math.floor(z / 2);
                            for(E = 0; E < V; E++)if (it = D[E], st.reverse(), st[ct] = $(E + 1), st[0] !== st[1] && void 0 !== st[0] && void 0 !== st[1]) for(rt = [
                                nt = Q(0),
                                nt
                            ], S = 0; S < H; S++)rt.reverse(), rt[lt] = Q(S + 1), rt[0] !== rt[1] && void 0 !== rt[0] && void 0 !== rt[1] && (at = dt(it[S], (rt[1] - rt[0]) * (st[1] - st[0])), tt.fillStyle = "rgba(" + at.join(",") + ")", tt.fillRect(rt[0] + Pt, st[0] + It, rt[1] - rt[0] - O, st[1] - st[0] - z));
                        }
                        ft = Math.round(ft / ut), ht = Math.round(ht / ut), pt = Math.round(pt / ut);
                        var Ot = i("rgb(" + ft + "," + ht + "," + pt + ")");
                        t1._hmpixcount = (t1._hmpixcount || 0) + ut, t1._hmlumcount = (t1._hmlumcount || 0) + ut * Ot.getLuminance();
                        var zt = C.selectAll("image").data(e1);
                        zt.enter().append("svg:image").attr({
                            xmlns: d.svg,
                            preserveAspectRatio: "none"
                        }), zt.attr({
                            height: J,
                            width: Z,
                            x: r,
                            y: A,
                            "xlink:href": K.toDataURL("image/png")
                        }), v(C);
                        var Dt = I.texttemplate;
                        if (Dt) {
                            var Rt = h(I), Ft = {
                                type: "linear",
                                range: [
                                    Rt.min,
                                    Rt.max
                                ],
                                _separators: w._separators,
                                _numFormat: w._numFormat
                            }, Bt = "histogram2dcontour" === I.type, Nt = "contour" === I.type, jt = Nt ? V - 1 : V, Ut = Nt ? 1 : 0, Vt = Nt ? H - 1 : H, Ht = [];
                            for(S = Nt ? 1 : 0; S < jt; S++){
                                var qt;
                                if (Nt) qt = P.y[S];
                                else if (Bt) {
                                    if (0 === S || S === V - 1) continue;
                                    qt = P.y[S];
                                } else if (P.yCenter) qt = P.yCenter[S];
                                else {
                                    if (S + 1 === V && void 0 === P.y[S + 1]) continue;
                                    qt = (P.y[S] + P.y[S + 1]) / 2;
                                }
                                var Gt = Math.round(T.c2p(qt));
                                if (!(0 > Gt || Gt > T._length)) for(E = Ut; E < Vt; E++){
                                    var Yt;
                                    if (Nt) Yt = P.x[E];
                                    else if (Bt) {
                                        if (0 === E || E === H - 1) continue;
                                        Yt = P.x[E];
                                    } else if (P.xCenter) Yt = P.xCenter[E];
                                    else {
                                        if (E + 1 === H && void 0 === P.x[E + 1]) continue;
                                        Yt = (P.x[E] + P.x[E + 1]) / 2;
                                    }
                                    var Wt = Math.round(w.c2p(Yt));
                                    if (!(0 > Wt || Wt > w._length)) {
                                        var Xt = u({
                                            x: Yt,
                                            y: qt
                                        }, I, t1._fullLayout);
                                        Xt.x = Yt, Xt.y = qt;
                                        var Zt = P.z[S][E];
                                        void 0 === Zt ? (Xt.z = "", Xt.zLabel = "") : (Xt.z = Zt, Xt.zLabel = s.tickText(Ft, Zt, "hover").text);
                                        var Jt = P.text && P.text[S] && P.text[S][E];
                                        void 0 !== Jt && !1 !== Jt || (Jt = ""), Xt.text = Jt;
                                        var Kt = l.texttemplateString(Dt, Xt, t1._fullLayout._d3locale, Xt, I._meta || {});
                                        if (Kt) {
                                            var Qt = Kt.split("<br>"), $t = Qt.length, te = 0;
                                            for(L = 0; L < $t; L++)te = Math.max(te, Qt[L].length);
                                            Ht.push({
                                                l: $t,
                                                c: te,
                                                t: Kt,
                                                x: Wt,
                                                y: Gt,
                                                z: Zt
                                            });
                                        }
                                    }
                                }
                            }
                            var ee = I.textfont, re = ee.family, ne = ee.size;
                            if (!ne || "auto" === ne) {
                                var ie = 1 / 0, ae = 1 / 0, oe = 0, se = 0;
                                for(L = 0; L < Ht.length; L++){
                                    var le = Ht[L];
                                    if (oe = Math.max(oe, le.l), se = Math.max(se, le.c), L < Ht.length - 1) {
                                        var ce = Ht[L + 1], ue = Math.abs(ce.x - le.x), fe = Math.abs(ce.y - le.y);
                                        ue && (ie = Math.min(ie, ue)), fe && (ae = Math.min(ae, fe));
                                    }
                                }
                                isFinite(ie) && isFinite(ae) ? (ie -= O, ae -= z, ie /= se, ae /= oe, ie /= m / 2, ae /= m, ne = Math.min(Math.floor(ie), Math.floor(ae))) : ne = 12;
                            }
                            if (ne <= 0 || !isFinite(ne)) return;
                            g(C).data(Ht).enter().append("g").classed("heatmap-label", 1).append("text").attr("text-anchor", "middle").each(function(e1) {
                                var r = n.select(this), i = ee.color;
                                i && "auto" !== i || (i = f.contrast("rgba(" + et(e1.z).join() + ")")), r.attr("data-notex", 1).call(c.positionText, function(t1) {
                                    return t1.x;
                                }(e1), function(t1) {
                                    return t1.y - ne * (t1.l * m / 2 - 1);
                                }(e1)).call(o.font, re, ne, i).text(e1.t).call(c.convertToTspans, t1);
                            });
                        }
                    });
                };
            },
            {
                "../../components/color": 366,
                "../../components/colorscale": 378,
                "../../components/drawing": 388,
                "../../constants/alignment": 471,
                "../../constants/xmlns_namespaces": 480,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../plots/cartesian/axes": 554,
                "../../registry": 638,
                "../scatter/format_labels": 935,
                "@plotly/d3": 58,
                tinycolor2: 312
            }
        ],
        805: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3");
                e1.exports = function(t1) {
                    n.select(t1).selectAll(".hm image").style("opacity", function(t1) {
                        return t1.trace.opacity;
                    });
                };
            },
            {
                "@plotly/d3": 58
            }
        ],
        806: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r) {
                    !1 === r("zsmooth") && (r("xgap"), r("ygap")), r("zhoverformat");
                };
            },
            {}
        ],
        807: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = t1("../../registry");
                function o(t1, e1) {
                    var r = e1(t1);
                    return "scaled" === (r ? e1(t1 + "type", "array") : "scaled") && (e1(t1 + "0"), e1("d" + t1)), r;
                }
                e1.exports = function(t1, e1, r, s, l, c) {
                    var u, f, h = r("z");
                    if (l = l || "x", c = c || "y", void 0 === h || !h.length) return 0;
                    if (i.isArray1D(t1.z)) {
                        u = r(l), f = r(c);
                        var p = i.minRowLength(u), d = i.minRowLength(f);
                        if (0 === p || 0 === d) return 0;
                        e1._length = Math.min(p, d, h.length);
                    } else {
                        if (u = o(l, r), f = o(c, r), !function(t1) {
                            for(var e1, r = !0, a = !1, o = !1, s = 0; s < t1.length; s++){
                                if (e1 = t1[s], !i.isArrayOrTypedArray(e1)) {
                                    r = !1;
                                    break;
                                }
                                e1.length > 0 && (a = !0);
                                for(var l = 0; l < e1.length; l++)if (n(e1[l])) {
                                    o = !0;
                                    break;
                                }
                            }
                            return r && a && o;
                        }(h)) return 0;
                        r("transpose"), e1._length = null;
                    }
                    return "heatmapgl" === t1.type || a.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                        l,
                        c
                    ], s), !0;
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638,
                "fast-isnumeric": 190
            }
        ],
        808: [
            function(t1, e1, r) {
                "use strict";
                for(var n = t1("../heatmap/attributes"), i = t1("../../components/colorscale/attributes"), a = t1("../../lib/extend").extendFlat, o = t1("../../plot_api/edit_types").overrideAll, s = [
                    "z",
                    "x",
                    "x0",
                    "dx",
                    "y",
                    "y0",
                    "dy",
                    "text",
                    "transpose",
                    "xtype",
                    "ytype"
                ], l = {}, c = 0; c < s.length; c++){
                    var u = s[c];
                    l[u] = n[u];
                }
                l.zsmooth = {
                    valType: "enumerated",
                    values: [
                        "fast",
                        !1
                    ],
                    dflt: "fast",
                    editType: "calc"
                }, a(l, i("", {
                    cLetter: "z",
                    autoColorDflt: !1
                })), e1.exports = o(l, "calc", "nested");
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../heatmap/attributes": 792
            }
        ],
        809: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../stackgl_modules").gl_heatmap2d, i = t1("../../plots/cartesian/axes"), a = t1("../../lib/str2rgbarray");
                function o(t1, e1) {
                    this.scene = t1, this.uid = e1, this.type = "heatmapgl", this.name = "", this.hoverinfo = "all", this.xData = [], this.yData = [], this.zData = [], this.textLabels = [], this.idToIndex = [], this.bounds = [
                        0,
                        0,
                        0,
                        0
                    ], this.options = {
                        zsmooth: "fast",
                        z: [],
                        x: [],
                        y: [],
                        shape: [
                            0,
                            0
                        ],
                        colorLevels: [
                            0
                        ],
                        colorValues: [
                            0,
                            0,
                            0,
                            1
                        ]
                    }, this.heatmap = n(t1.glplot, this.options), this.heatmap._trace = this;
                }
                var s = o.prototype;
                s.handlePick = function(t1) {
                    var e1 = this.options, r = e1.shape, n = t1.pointId, i = n % r[0], a = Math.floor(n / r[0]), o = n;
                    return {
                        trace: this,
                        dataCoord: t1.dataCoord,
                        traceCoord: [
                            e1.x[i],
                            e1.y[a],
                            e1.z[o]
                        ],
                        textLabel: this.textLabels[n],
                        name: this.name,
                        pointIndex: [
                            a,
                            i
                        ],
                        hoverinfo: this.hoverinfo
                    };
                }, s.update = function(t1, e1) {
                    var r = e1[0];
                    this.index = t1.index, this.name = t1.name, this.hoverinfo = t1.hoverinfo;
                    var n = r.z;
                    this.options.z = [].concat.apply([], n);
                    var o = n[0].length, s = n.length;
                    this.options.shape = [
                        o,
                        s
                    ], this.options.x = r.x, this.options.y = r.y, this.options.zsmooth = t1.zsmooth;
                    var l = function(t1) {
                        for(var e1 = t1.colorscale, r = t1.zmin, n = t1.zmax, i = e1.length, o = new Array(i), s = new Array(4 * i), l = 0; l < i; l++){
                            var c = e1[l], u = a(c[1]);
                            o[l] = r + c[0] * (n - r);
                            for(var f = 0; f < 4; f++)s[4 * l + f] = u[f];
                        }
                        return {
                            colorLevels: o,
                            colorValues: s
                        };
                    }(t1);
                    this.options.colorLevels = l.colorLevels, this.options.colorValues = l.colorValues, this.textLabels = [].concat.apply([], t1.text), this.heatmap.update(this.options);
                    var c, u, f = this.scene.xaxis, h = this.scene.yaxis;
                    !1 === t1.zsmooth && (c = {
                        ppad: r.x[1] - r.x[0]
                    }, u = {
                        ppad: r.y[1] - r.y[0]
                    }), t1._extremes[f._id] = i.findExtremes(f, r.x, c), t1._extremes[h._id] = i.findExtremes(h, r.y, u);
                }, s.dispose = function() {
                    this.heatmap.dispose();
                }, e1.exports = function(t1, e1, r) {
                    var n = new o(t1, e1.uid);
                    return n.update(e1, r), n;
                };
            },
            {
                "../../../stackgl_modules": 1120,
                "../../lib/str2rgbarray": 528,
                "../../plots/cartesian/axes": 554
            }
        ],
        810: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../heatmap/xyz_defaults"), a = t1("../../components/colorscale/defaults"), o = t1("./attributes");
                e1.exports = function(t1, e1, r, s) {
                    function l(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    i(t1, e1, l, s) ? (l("text"), l("zsmooth"), a(t1, e1, s, l, {
                        prefix: "",
                        cLetter: "z"
                    })) : e1.visible = !1;
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../lib": 503,
                "../heatmap/xyz_defaults": 807,
                "./attributes": 808
            }
        ],
        811: [
            function(t1, e1, r) {
                "use strict";
                [
                    "*heatmapgl* trace is deprecated!",
                    "Please consider switching to the *heatmap* or *image* trace types.",
                    "Alternatively you could contribute/sponsor rewriting this trace type",
                    "based on cartesian features and using regl framework."
                ].join(" ");
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: t1("../heatmap/colorbar"),
                    calc: t1("../heatmap/calc"),
                    plot: t1("./convert"),
                    moduleType: "trace",
                    name: "heatmapgl",
                    basePlotModule: t1("../../plots/gl2d"),
                    categories: [
                        "gl",
                        "gl2d",
                        "2dMap"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/gl2d": 596,
                "../heatmap/calc": 793,
                "../heatmap/colorbar": 795,
                "./attributes": 808,
                "./convert": 809,
                "./defaults": 810
            }
        ],
        812: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../bar/attributes"), i = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, a = t1("../../plots/template_attributes").hovertemplateAttrs, o = t1("../../plots/template_attributes").texttemplateAttrs, s = t1("../../plots/font_attributes"), l = t1("./bin_attributes"), c = t1("./constants"), u = t1("../../lib/extend").extendFlat;
                e1.exports = {
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    text: u({}, n.text, {}),
                    hovertext: u({}, n.hovertext, {}),
                    orientation: n.orientation,
                    histfunc: {
                        valType: "enumerated",
                        values: [
                            "count",
                            "sum",
                            "avg",
                            "min",
                            "max"
                        ],
                        dflt: "count",
                        editType: "calc"
                    },
                    histnorm: {
                        valType: "enumerated",
                        values: [
                            "",
                            "percent",
                            "probability",
                            "density",
                            "probability density"
                        ],
                        dflt: "",
                        editType: "calc"
                    },
                    cumulative: {
                        enabled: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "calc"
                        },
                        direction: {
                            valType: "enumerated",
                            values: [
                                "increasing",
                                "decreasing"
                            ],
                            dflt: "increasing",
                            editType: "calc"
                        },
                        currentbin: {
                            valType: "enumerated",
                            values: [
                                "include",
                                "exclude",
                                "half"
                            ],
                            dflt: "include",
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    nbinsx: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    xbins: l("x", !0),
                    nbinsy: {
                        valType: "integer",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    ybins: l("y", !0),
                    autobinx: {
                        valType: "boolean",
                        dflt: null,
                        editType: "calc"
                    },
                    autobiny: {
                        valType: "boolean",
                        dflt: null,
                        editType: "calc"
                    },
                    bingroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    hovertemplate: a({}, {
                        keys: c.eventDataKeys
                    }),
                    texttemplate: o({
                        arrayOk: !1,
                        editType: "plot"
                    }, {
                        keys: [
                            "label",
                            "value"
                        ]
                    }),
                    textposition: u({}, n.textposition, {
                        arrayOk: !1
                    }),
                    textfont: s({
                        arrayOk: !1,
                        editType: "plot",
                        colorEditType: "style"
                    }),
                    outsidetextfont: s({
                        arrayOk: !1,
                        editType: "plot",
                        colorEditType: "style"
                    }),
                    insidetextfont: s({
                        arrayOk: !1,
                        editType: "plot",
                        colorEditType: "style"
                    }),
                    insidetextanchor: n.insidetextanchor,
                    textangle: n.textangle,
                    cliponaxis: n.cliponaxis,
                    constraintext: n.constraintext,
                    marker: n.marker,
                    offsetgroup: n.offsetgroup,
                    alignmentgroup: n.alignmentgroup,
                    selected: n.selected,
                    unselected: n.unselected,
                    _deprecated: {
                        bardir: n._deprecated.bardir
                    }
                };
            },
            {
                "../../lib/extend": 493,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/font_attributes": 585,
                "../../plots/template_attributes": 633,
                "../bar/attributes": 648,
                "./bin_attributes": 814,
                "./constants": 818
            }
        ],
        813: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    for(var r = t1.length, n = 0, i = 0; i < r; i++)e1[i] ? (t1[i] /= e1[i], n += t1[i]) : t1[i] = null;
                    return n;
                };
            },
            {}
        ],
        814: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    return {
                        start: {
                            valType: "any",
                            editType: "calc"
                        },
                        end: {
                            valType: "any",
                            editType: "calc"
                        },
                        size: {
                            valType: "any",
                            editType: "calc"
                        },
                        editType: "calc"
                    };
                };
            },
            {}
        ],
        815: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric");
                e1.exports = {
                    count: function(t1, e1, r) {
                        return r[t1]++, 1;
                    },
                    sum: function(t1, e1, r, i) {
                        var a = i[e1];
                        return n(a) ? (a = Number(a), r[t1] += a, a) : 0;
                    },
                    avg: function(t1, e1, r, i, a) {
                        var o = i[e1];
                        return n(o) && (o = Number(o), r[t1] += o, a[t1]++), 0;
                    },
                    min: function(t1, e1, r, i) {
                        var a = i[e1];
                        if (n(a)) {
                            if (a = Number(a), !n(r[t1])) return r[t1] = a, a;
                            if (r[t1] > a) {
                                var o = a - r[t1];
                                return r[t1] = a, o;
                            }
                        }
                        return 0;
                    },
                    max: function(t1, e1, r, i) {
                        var a = i[e1];
                        if (n(a)) {
                            if (a = Number(a), !n(r[t1])) return r[t1] = a, a;
                            if (r[t1] < a) {
                                var o = a - r[t1];
                                return r[t1] = a, o;
                            }
                        }
                        return 0;
                    }
                };
            },
            {
                "fast-isnumeric": 190
            }
        ],
        816: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../constants/numerical"), i = n.ONEAVGYEAR, a = n.ONEAVGMONTH, o = n.ONEDAY, s = n.ONEHOUR, l = n.ONEMIN, c = n.ONESEC, u = t1("../../plots/cartesian/axes").tickIncrement;
                function f(t1, e1, r, n) {
                    if (t1 * e1 <= 0) return 1 / 0;
                    for(var i = Math.abs(e1 - t1), a = "date" === r.type, o = h(i, a), s = 0; s < 10; s++){
                        var l = h(80 * o, a);
                        if (o === l) break;
                        if (!p(l, t1, e1, a, r, n)) break;
                        o = l;
                    }
                    return o;
                }
                function h(t1, e1) {
                    return e1 && t1 > c ? t1 > o ? t1 > 1.1 * i ? i : t1 > 1.1 * a ? a : o : t1 > s ? s : t1 > l ? l : c : Math.pow(10, Math.floor(Math.log(t1) / Math.LN10));
                }
                function p(t1, e1, r, n, a, s) {
                    if (n && t1 > o) {
                        var l = d(e1, a, s), c = d(r, a, s), u = t1 === i ? 0 : 1;
                        return l[u] !== c[u];
                    }
                    return Math.floor(r / t1) - Math.floor(e1 / t1) > .1;
                }
                function d(t1, e1, r) {
                    var n = e1.c2d(t1, i, r).split("-");
                    return "" === n[0] && (n.unshift(), n[0] = "-" + n[0]), n;
                }
                e1.exports = function(t1, e1, r, n, a) {
                    var s, l, c = -1.1 * e1, h = -0.1 * e1, p = t1 - h, d = r[0], m = r[1], g = Math.min(f(d + h, d + p, n, a), f(m + h, m + p, n, a)), v = Math.min(f(d + c, d + h, n, a), f(m + c, m + h, n, a));
                    if (g > v && v < Math.abs(m - d) / 4e3 ? (s = g, l = !1) : (s = Math.min(g, v), l = !0), "date" === n.type && s > o) {
                        var y = s === i ? 1 : 6, x = s === i ? "M12" : "M1";
                        return function(e1, r) {
                            var o = n.c2d(e1, i, a), s = o.indexOf("-", y);
                            s > 0 && (o = o.substr(0, s));
                            var c = n.d2c(o, 0, a);
                            if (c < e1) {
                                var f = u(c, x, !1, a);
                                (c + f) / 2 < e1 + t1 && (c = f);
                            }
                            return r && l ? u(c, x, !0, a) : c;
                        };
                    }
                    return function(e1, r) {
                        var n = s * Math.round(e1 / s);
                        return n + s / 10 < e1 && n + .9 * s < e1 + t1 && (n += s), r && l && (n -= s), n;
                    };
                };
            },
            {
                "../../constants/numerical": 479,
                "../../plots/cartesian/axes": 554
            }
        ],
        817: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = t1("../../registry"), o = t1("../../plots/cartesian/axes"), s = t1("../bar/arrays_to_calcdata"), l = t1("./bin_functions"), c = t1("./norm_functions"), u = t1("./average"), f = t1("./bin_label_vals");
                function h(t1, e1, r, s, l) {
                    var c, u, f, p, d, m, g, v = s + "bins", y = t1._fullLayout, x = e1["_" + s + "bingroup"], b = y._histogramBinOpts[x], _ = "overlay" === y.barmode, w = function(t1) {
                        return r.r2c(t1, 0, p);
                    }, T = function(t1) {
                        return r.c2r(t1, 0, p);
                    }, k = "date" === r.type ? function(t1) {
                        return t1 || 0 === t1 ? i.cleanDate(t1, null, p) : null;
                    } : function(t1) {
                        return n(t1) ? Number(t1) : null;
                    };
                    function A(t1, e1, r) {
                        e1[t1 + "Found"] ? (e1[t1] = k(e1[t1]), null === e1[t1] && (e1[t1] = r[t1])) : (m[t1] = e1[t1] = r[t1], i.nestedProperty(u[0], v + "." + t1).set(r[t1]));
                    }
                    if (e1["_" + s + "autoBinFinished"]) delete e1["_" + s + "autoBinFinished"];
                    else {
                        u = b.traces;
                        var M = [], S = !0, E = !1, L = !1;
                        for(c = 0; c < u.length; c++)if ((f = u[c]).visible) {
                            var C = b.dirs[c];
                            d = f["_" + C + "pos0"] = r.makeCalcdata(f, C), M = i.concat(M, d), delete f["_" + s + "autoBinFinished"], !0 === e1.visible && (S ? S = !1 : (delete f._autoBin, f["_" + s + "autoBinFinished"] = 1), a.traceIs(f, "2dMap") && (E = !0), "histogram2dcontour" === f.type && (L = !0));
                        }
                        p = u[0][s + "calendar"];
                        var P = o.autoBin(M, r, b.nbins, E, p, b.sizeFound && b.size), I = u[0]._autoBin = {};
                        if (m = I[b.dirs[0]] = {}, L && (b.size || (P.start = T(o.tickIncrement(w(P.start), P.size, !0, p))), void 0 === b.end && (P.end = T(o.tickIncrement(w(P.end), P.size, !1, p)))), _ && !a.traceIs(e1, "2dMap") && 0 === P._dataSpan && "category" !== r.type && "multicategory" !== r.type) {
                            if (l) return [
                                P,
                                d,
                                !0
                            ];
                            P = function(t1, e1, r, n, a) {
                                var o, s, l, c = t1._fullLayout, u = function(t1, e1) {
                                    for(var r = e1.xaxis, n = e1.yaxis, i = e1.orientation, a = [], o = t1._fullData, s = 0; s < o.length; s++){
                                        var l = o[s];
                                        "histogram" === l.type && !0 === l.visible && l.orientation === i && l.xaxis === r && l.yaxis === n && a.push(l);
                                    }
                                    return a;
                                }(t1, e1), f = !1, p = 1 / 0, d = [
                                    e1
                                ];
                                for(o = 0; o < u.length; o++)if ((s = u[o]) === e1) f = !0;
                                else if (f) {
                                    var m = h(t1, s, r, n, !0), g = m[0], v = m[2];
                                    s["_" + n + "autoBinFinished"] = 1, s["_" + n + "pos0"] = m[1], v ? d.push(s) : p = Math.min(p, g.size);
                                } else l = c._histogramBinOpts[s["_" + n + "bingroup"]], p = Math.min(p, l.size || s[a].size);
                                var y = new Array(d.length);
                                for(o = 0; o < d.length; o++)for(var x = d[o]["_" + n + "pos0"], b = 0; b < x.length; b++)if (void 0 !== x[b]) {
                                    y[o] = x[b];
                                    break;
                                }
                                isFinite(p) || (p = i.distinctVals(y).minDiff);
                                for(o = 0; o < d.length; o++){
                                    var _ = (s = d[o])[n + "calendar"], w = {
                                        start: r.c2r(y[o] - p / 2, 0, _),
                                        end: r.c2r(y[o] + p / 2, 0, _),
                                        size: p
                                    };
                                    s._input[a] = s[a] = w, (l = c._histogramBinOpts[s["_" + n + "bingroup"]]) && i.extendFlat(l, w);
                                }
                                return e1[a];
                            }(t1, e1, r, s, v);
                        }
                        (g = f.cumulative || {}).enabled && "include" !== g.currentbin && ("decreasing" === g.direction ? P.start = T(o.tickIncrement(w(P.start), P.size, !0, p)) : P.end = T(o.tickIncrement(w(P.end), P.size, !1, p))), b.size = P.size, b.sizeFound || (m.size = P.size, i.nestedProperty(u[0], v + ".size").set(P.size)), A("start", b, P), A("end", b, P);
                    }
                    d = e1["_" + s + "pos0"], delete e1["_" + s + "pos0"];
                    var O = e1._input[v] || {}, z = i.extendFlat({}, b), D = b.start, R = r.r2l(O.start), F = void 0 !== R;
                    if ((b.startFound || F) && R !== r.r2l(D)) {
                        var B = F ? R : i.aggNums(Math.min, null, d), N = {
                            type: "category" === r.type || "multicategory" === r.type ? "linear" : r.type,
                            r2l: r.r2l,
                            dtick: b.size,
                            tick0: D,
                            calendar: p,
                            range: [
                                B,
                                o.tickIncrement(B, b.size, !1, p)
                            ].map(r.l2r)
                        }, j = o.tickFirst(N);
                        j > r.r2l(B) && (j = o.tickIncrement(j, b.size, !0, p)), z.start = r.l2r(j), F || i.nestedProperty(e1, v + ".start").set(z.start);
                    }
                    var U = b.end, V = r.r2l(O.end), H = void 0 !== V;
                    if ((b.endFound || H) && V !== r.r2l(U)) {
                        var q = H ? V : i.aggNums(Math.max, null, d);
                        z.end = r.l2r(q), H || i.nestedProperty(e1, v + ".start").set(z.end);
                    }
                    var G = "autobin" + s;
                    return !1 === e1._input[G] && (e1._input[v] = i.extendFlat({}, e1[v] || {}), delete e1._input[G], delete e1[G]), [
                        z,
                        d
                    ];
                }
                e1.exports = {
                    calc: function(t1, e1) {
                        var r, a, p, d, m = [], g = [], v = o.getFromId(t1, "h" === e1.orientation ? e1.yaxis : e1.xaxis), y = "h" === e1.orientation ? "y" : "x", x = {
                            x: "y",
                            y: "x"
                        }[y], b = e1[y + "calendar"], _ = e1.cumulative, w = h(t1, e1, v, y), T = w[0], k = w[1], A = "string" == typeof T.size, M = [], S = A ? M : T, E = [], L = [], C = [], P = 0, I = e1.histnorm, O = e1.histfunc, z = -1 !== I.indexOf("density");
                        _.enabled && z && (I = I.replace(/ ?density$/, ""), z = !1);
                        var D, R = "max" === O || "min" === O ? null : 0, F = l.count, B = c[I], N = !1, j = function(t1) {
                            return v.r2c(t1, 0, b);
                        };
                        for(i.isArrayOrTypedArray(e1[x]) && "count" !== O && (D = e1[x], N = "avg" === O, F = l[O]), r = j(T.start), p = j(T.end) + (r - o.tickIncrement(r, T.size, !1, b)) / 1e6; r < p && m.length < 1e6 && (a = o.tickIncrement(r, T.size, !1, b), m.push((r + a) / 2), g.push(R), C.push([]), M.push(r), z && E.push(1 / (a - r)), N && L.push(0), !(a <= r));)r = a;
                        M.push(r), A || "date" !== v.type || (S = {
                            start: j(S.start),
                            end: j(S.end),
                            size: S.size
                        }), t1._fullLayout._roundFnOpts || (t1._fullLayout._roundFnOpts = {});
                        var U = e1["_" + y + "bingroup"], V = {
                            leftGap: 1 / 0,
                            rightGap: 1 / 0
                        };
                        U && (t1._fullLayout._roundFnOpts[U] || (t1._fullLayout._roundFnOpts[U] = V), V = t1._fullLayout._roundFnOpts[U]);
                        var H, q = g.length, G = !0, Y = V.leftGap, W = V.rightGap, X = {};
                        for(r = 0; r < k.length; r++){
                            var Z = k[r];
                            (d = i.findBin(Z, S)) >= 0 && d < q && (P += F(d, r, g, D, L), G && C[d].length && Z !== k[C[d][0]] && (G = !1), C[d].push(r), X[r] = d, Y = Math.min(Y, Z - M[d]), W = Math.min(W, M[d + 1] - Z));
                        }
                        V.leftGap = Y, V.rightGap = W, G || (H = function(e1, r) {
                            return function() {
                                var n = t1._fullLayout._roundFnOpts[U];
                                return f(n.leftGap, n.rightGap, M, v, b)(e1, r);
                            };
                        }), N && (P = u(g, L)), B && B(g, P, E), _.enabled && function(t1, e1, r) {
                            var n, i, a;
                            function o(e1) {
                                a = t1[e1], t1[e1] /= 2;
                            }
                            function s(e1) {
                                i = t1[e1], t1[e1] = a + i / 2, a += i;
                            }
                            if ("half" === r) {
                                if ("increasing" === e1) for(o(0), n = 1; n < t1.length; n++)s(n);
                                else for(o(t1.length - 1), n = t1.length - 2; n >= 0; n--)s(n);
                            } else if ("increasing" === e1) {
                                for(n = 1; n < t1.length; n++)t1[n] += t1[n - 1];
                                "exclude" === r && (t1.unshift(0), t1.pop());
                            } else {
                                for(n = t1.length - 2; n >= 0; n--)t1[n] += t1[n + 1];
                                "exclude" === r && (t1.push(0), t1.shift());
                            }
                        }(g, _.direction, _.currentbin);
                        var J = Math.min(m.length, g.length), K = [], Q = 0, $ = J - 1;
                        for(r = 0; r < J; r++)if (g[r]) {
                            Q = r;
                            break;
                        }
                        for(r = J - 1; r >= Q; r--)if (g[r]) {
                            $ = r;
                            break;
                        }
                        for(r = Q; r <= $; r++)if (n(m[r]) && n(g[r])) {
                            var tt = {
                                p: m[r],
                                s: g[r],
                                b: 0
                            };
                            _.enabled || (tt.pts = C[r], G ? tt.ph0 = tt.ph1 = C[r].length ? k[C[r][0]] : m[r] : (e1._computePh = !0, tt.ph0 = H(M[r]), tt.ph1 = H(M[r + 1], !0))), K.push(tt);
                        }
                        return 1 === K.length && (K[0].width1 = o.tickIncrement(K[0].p, T.size, !1, b) - K[0].p), s(K, e1), i.isArrayOrTypedArray(e1.selectedpoints) && i.tagSelected(K, e1, X), K;
                    },
                    calcAllAutoBins: h
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "../../registry": 638,
                "../bar/arrays_to_calcdata": 647,
                "./average": 813,
                "./bin_functions": 815,
                "./bin_label_vals": 816,
                "./norm_functions": 824,
                "fast-isnumeric": 190
            }
        ],
        818: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    eventDataKeys: [
                        "binNumber"
                    ]
                };
            },
            {}
        ],
        819: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axis_ids"), a = t1("../../registry").traceIs, o = t1("../bar/defaults").handleGroupingDefaults, s = n.nestedProperty, l = t1("../../plots/cartesian/constraints").getAxisGroup, c = [
                    {
                        aStr: {
                            x: "xbins.start",
                            y: "ybins.start"
                        },
                        name: "start"
                    },
                    {
                        aStr: {
                            x: "xbins.end",
                            y: "ybins.end"
                        },
                        name: "end"
                    },
                    {
                        aStr: {
                            x: "xbins.size",
                            y: "ybins.size"
                        },
                        name: "size"
                    },
                    {
                        aStr: {
                            x: "nbinsx",
                            y: "nbinsy"
                        },
                        name: "nbins"
                    }
                ], u = [
                    "x",
                    "y"
                ];
                e1.exports = function(t1, e1) {
                    var r, f, h, p, d, m, g, v = e1._histogramBinOpts = {}, y = [], x = {}, b = [];
                    function _(t1, e1) {
                        return n.coerce(r._input, r, r._module.attributes, t1, e1);
                    }
                    function w(t1) {
                        return "v" === t1.orientation ? "x" : "y";
                    }
                    function T(t1, r, a) {
                        var o = t1.uid + "__" + a;
                        r || (r = o);
                        var s = function(t1, r) {
                            return i.getFromTrace({
                                _fullLayout: e1
                            }, t1, r).type;
                        }(t1, a), l = t1[a + "calendar"] || "", c = v[r], u = !0;
                        c && (s === c.axType && l === c.calendar ? (u = !1, c.traces.push(t1), c.dirs.push(a)) : (r = o, s !== c.axType && n.warn([
                            "Attempted to group the bins of trace",
                            t1.index,
                            "set on a",
                            "type:" + s,
                            "axis",
                            "with bins on",
                            "type:" + c.axType,
                            "axis."
                        ].join(" ")), l !== c.calendar && n.warn([
                            "Attempted to group the bins of trace",
                            t1.index,
                            "set with a",
                            l,
                            "calendar",
                            "with bins",
                            c.calendar ? "on a " + c.calendar + " calendar" : "w/o a set calendar"
                        ].join(" ")))), u && (v[r] = {
                            traces: [
                                t1
                            ],
                            dirs: [
                                a
                            ],
                            axType: s,
                            calendar: t1[a + "calendar"] || ""
                        }), t1["_" + a + "bingroup"] = r;
                    }
                    for(d = 0; d < t1.length; d++)r = t1[d], a(r, "histogram") && (y.push(r), delete r._xautoBinFinished, delete r._yautoBinFinished, a(r, "2dMap") || o(r._input, r, e1, _));
                    var k = e1._alignmentOpts || {};
                    for(d = 0; d < y.length; d++){
                        if (r = y[d], h = "", !a(r, "2dMap")) {
                            if (p = w(r), "group" === e1.barmode && r.alignmentgroup) {
                                var A = r[p + "axis"], M = l(e1, A) + r.orientation;
                                (k[M] || {})[r.alignmentgroup] && (h = M);
                            }
                            h || "overlay" === e1.barmode || (h = l(e1, r.xaxis) + l(e1, r.yaxis) + w(r));
                        }
                        h ? (x[h] || (x[h] = []), x[h].push(r)) : b.push(r);
                    }
                    for(h in x)if (1 !== (f = x[h]).length) {
                        var S = !1;
                        for(f.length && (r = f[0], S = _("bingroup")), h = S || h, d = 0; d < f.length; d++){
                            var E = (r = f[d])._input.bingroup;
                            E && E !== h && n.warn([
                                "Trace",
                                r.index,
                                "must match",
                                "within bingroup",
                                h + ".",
                                "Ignoring its bingroup:",
                                E,
                                "setting."
                            ].join(" ")), r.bingroup = h, T(r, h, w(r));
                        }
                    } else b.push(f[0]);
                    for(d = 0; d < b.length; d++){
                        r = b[d];
                        var L = _("bingroup");
                        if (a(r, "2dMap")) for(g = 0; g < 2; g++){
                            var C = _((p = u[g]) + "bingroup", L ? L + "__" + p : null);
                            T(r, C, p);
                        }
                        else T(r, L, w(r));
                    }
                    for(h in v){
                        var P = v[h];
                        for(f = P.traces, m = 0; m < c.length; m++){
                            var I, O, z = c[m], D = z.name;
                            if ("nbins" !== D || !P.sizeFound) {
                                for(d = 0; d < f.length; d++){
                                    if (r = f[d], p = P.dirs[d], I = z.aStr[p], void 0 !== s(r._input, I).get()) {
                                        P[D] = _(I), P[D + "Found"] = !0;
                                        break;
                                    }
                                    (O = (r._autoBin || {})[p] || {})[D] && s(r, I).set(O[D]);
                                }
                                if ("start" === D || "end" === D) for(; d < f.length; d++)(r = f[d])["_" + p + "bingroup"] && _(I, (O = (r._autoBin || {})[p] || {})[D]);
                                "nbins" !== D || P.sizeFound || P.nbinsFound || (r = f[0], P[D] = _(I));
                            }
                        }
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axis_ids": 558,
                "../../plots/cartesian/constraints": 562,
                "../../registry": 638,
                "../bar/defaults": 652
            }
        ],
        820: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib"), a = t1("../../components/color"), o = t1("../bar/defaults").handleText, s = t1("../bar/style_defaults"), l = t1("./attributes");
                e1.exports = function(t1, e1, r, c) {
                    function u(r, n) {
                        return i.coerce(t1, e1, l, r, n);
                    }
                    var f = u("x"), h = u("y");
                    u("cumulative.enabled") && (u("cumulative.direction"), u("cumulative.currentbin")), u("text");
                    var p = u("textposition");
                    o(t1, e1, c, u, p, {
                        moduleHasSelected: !0,
                        moduleHasUnselected: !0,
                        moduleHasConstrain: !0,
                        moduleHasCliponaxis: !0,
                        moduleHasTextangle: !0,
                        moduleHasInsideanchor: !0
                    }), u("hovertext"), u("hovertemplate"), u("xhoverformat"), u("yhoverformat");
                    var d = u("orientation", h && !f ? "h" : "v"), m = "v" === d ? "x" : "y", g = "v" === d ? "y" : "x", v = f && h ? Math.min(i.minRowLength(f) && i.minRowLength(h)) : i.minRowLength(e1[m] || []);
                    if (v) {
                        e1._length = v, n.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                            "x",
                            "y"
                        ], c), e1[g] && u("histfunc"), u("histnorm"), u("autobin" + m), s(t1, e1, u, r, c), i.coerceSelectionMarkerOpacity(e1, u);
                        var y = (e1.marker.line || {}).color, x = n.getComponentMethod("errorbars", "supplyDefaults");
                        x(t1, e1, y || a.defaultLine, {
                            axis: "y"
                        }), x(t1, e1, y || a.defaultLine, {
                            axis: "x",
                            inherit: "y"
                        });
                    } else e1.visible = !1;
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../../registry": 638,
                "../bar/defaults": 652,
                "../bar/style_defaults": 663,
                "./attributes": 812
            }
        ],
        821: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n, i) {
                    if (t1.x = "xVal" in e1 ? e1.xVal : e1.x, t1.y = "yVal" in e1 ? e1.yVal : e1.y, "zLabelVal" in e1 && (t1.z = e1.zLabelVal), e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), !(r.cumulative || {}).enabled) {
                        var a, o = Array.isArray(i) ? n[0].pts[i[0]][i[1]] : n[i].pts;
                        if (t1.pointNumbers = o, t1.binNumber = t1.pointNumber, delete t1.pointNumber, delete t1.pointIndex, r._indexToPoints) {
                            a = [];
                            for(var s = 0; s < o.length; s++)a = a.concat(r._indexToPoints[o[s]]);
                        } else a = o;
                        t1.pointIndices = a;
                    }
                    return t1;
                };
            },
            {}
        ],
        822: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../bar/hover").hoverPoints, i = t1("../../plots/cartesian/axes").hoverLabelText;
                e1.exports = function(t1, e1, r, a, o) {
                    var s = n(t1, e1, r, a, o);
                    if (s) {
                        var l = (t1 = s[0]).cd[t1.index], c = t1.cd[0].trace;
                        if (!c.cumulative.enabled) {
                            var u = "h" === c.orientation ? "y" : "x";
                            t1[u + "Label"] = i(t1[u + "a"], [
                                l.ph0,
                                l.ph1
                            ], c[u + "hoverformat"]);
                        }
                        return s;
                    }
                };
            },
            {
                "../../plots/cartesian/axes": 554,
                "../bar/hover": 655
            }
        ],
        823: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("../bar/layout_attributes"),
                    supplyDefaults: t1("./defaults"),
                    crossTraceDefaults: t1("./cross_trace_defaults"),
                    supplyLayoutDefaults: t1("../bar/layout_defaults"),
                    calc: t1("./calc").calc,
                    crossTraceCalc: t1("../bar/cross_trace_calc").crossTraceCalc,
                    plot: t1("../bar/plot").plot,
                    layerName: "barlayer",
                    style: t1("../bar/style").style,
                    styleOnSelect: t1("../bar/style").styleOnSelect,
                    colorbar: t1("../scatter/marker_colorbar"),
                    hoverPoints: t1("./hover"),
                    selectPoints: t1("../bar/select"),
                    eventData: t1("./event_data"),
                    moduleType: "trace",
                    name: "histogram",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "bar-like",
                        "cartesian",
                        "svg",
                        "bar",
                        "histogram",
                        "oriented",
                        "errorBarsOK",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "../bar/cross_trace_calc": 651,
                "../bar/layout_attributes": 657,
                "../bar/layout_defaults": 658,
                "../bar/plot": 659,
                "../bar/select": 660,
                "../bar/style": 662,
                "../scatter/marker_colorbar": 944,
                "./attributes": 812,
                "./calc": 817,
                "./cross_trace_defaults": 819,
                "./defaults": 820,
                "./event_data": 821,
                "./hover": 822
            }
        ],
        824: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    percent: function(t1, e1) {
                        for(var r = t1.length, n = 100 / e1, i = 0; i < r; i++)t1[i] *= n;
                    },
                    probability: function(t1, e1) {
                        for(var r = t1.length, n = 0; n < r; n++)t1[n] /= e1;
                    },
                    density: function(t1, e1, r, n) {
                        var i = t1.length;
                        n = n || 1;
                        for(var a = 0; a < i; a++)t1[a] *= r[a] * n;
                    },
                    "probability density": function(t1, e1, r, n) {
                        var i = t1.length;
                        n && (e1 /= n);
                        for(var a = 0; a < i; a++)t1[a] *= r[a] / e1;
                    }
                };
            },
            {}
        ],
        825: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../histogram/attributes"), i = t1("../histogram/bin_attributes"), a = t1("../heatmap/attributes"), o = t1("../../plots/attributes"), s = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, l = t1("../../plots/template_attributes").hovertemplateAttrs, c = t1("../../plots/template_attributes").texttemplateAttrs, u = t1("../../components/colorscale/attributes"), f = t1("../../lib/extend").extendFlat;
                e1.exports = f({
                    x: n.x,
                    y: n.y,
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    marker: {
                        color: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    histnorm: n.histnorm,
                    histfunc: n.histfunc,
                    nbinsx: n.nbinsx,
                    xbins: i("x"),
                    nbinsy: n.nbinsy,
                    ybins: i("y"),
                    autobinx: n.autobinx,
                    autobiny: n.autobiny,
                    bingroup: f({}, n.bingroup, {}),
                    xbingroup: f({}, n.bingroup, {}),
                    ybingroup: f({}, n.bingroup, {}),
                    xgap: a.xgap,
                    ygap: a.ygap,
                    zsmooth: a.zsmooth,
                    xhoverformat: s("x"),
                    yhoverformat: s("y"),
                    zhoverformat: s("z", 1),
                    hovertemplate: l({}, {
                        keys: "z"
                    }),
                    texttemplate: c({
                        arrayOk: !1,
                        editType: "plot"
                    }, {
                        keys: "z"
                    }),
                    textfont: a.textfont,
                    showlegend: f({}, o.showlegend, {
                        dflt: !1
                    })
                }, u("", {
                    cLetter: "z",
                    autoColorDflt: !1
                }));
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/template_attributes": 633,
                "../heatmap/attributes": 792,
                "../histogram/attributes": 812,
                "../histogram/bin_attributes": 814
            }
        ],
        826: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axes"), a = t1("../histogram/bin_functions"), o = t1("../histogram/norm_functions"), s = t1("../histogram/average"), l = t1("../histogram/bin_label_vals"), c = t1("../histogram/calc").calcAllAutoBins;
                function u(t1, e1, r, n) {
                    var i, a = new Array(t1);
                    if (n) for(i = 0; i < t1; i++)a[i] = 1 / (e1[i + 1] - e1[i]);
                    else {
                        var o = 1 / r;
                        for(i = 0; i < t1; i++)a[i] = o;
                    }
                    return a;
                }
                function f(t1, e1) {
                    return {
                        start: t1(e1.start),
                        end: t1(e1.end),
                        size: e1.size
                    };
                }
                function h(t1, e1, r, n, i, a) {
                    var o, s = t1.length - 1, c = new Array(s), u = l(r, n, t1, i, a);
                    for(o = 0; o < s; o++){
                        var f = (e1 || [])[o];
                        c[o] = void 0 === f ? [
                            u(t1[o]),
                            u(t1[o + 1], !0)
                        ] : [
                            f,
                            f
                        ];
                    }
                    return c;
                }
                e1.exports = function(t1, e1) {
                    var r, l, p, d, m = i.getFromId(t1, e1.xaxis), g = i.getFromId(t1, e1.yaxis), v = e1.xcalendar, y = e1.ycalendar, x = function(t1) {
                        return m.r2c(t1, 0, v);
                    }, b = function(t1) {
                        return g.r2c(t1, 0, y);
                    }, _ = c(t1, e1, m, "x"), w = _[0], T = _[1], k = c(t1, e1, g, "y"), A = k[0], M = k[1], S = e1._length;
                    T.length > S && T.splice(S, T.length - S), M.length > S && M.splice(S, M.length - S);
                    var E = [], L = [], C = [], P = "string" == typeof w.size, I = "string" == typeof A.size, O = [], z = [], D = P ? O : w, R = I ? z : A, F = 0, B = [], N = [], j = e1.histnorm, U = e1.histfunc, V = -1 !== j.indexOf("density"), H = "max" === U || "min" === U ? null : 0, q = a.count, G = o[j], Y = !1, W = [], X = [], Z = "z" in e1 ? e1.z : "marker" in e1 && Array.isArray(e1.marker.color) ? e1.marker.color : "";
                    Z && "count" !== U && (Y = "avg" === U, q = a[U]);
                    var J = w.size, K = x(w.start), Q = x(w.end) + (K - i.tickIncrement(K, J, !1, v)) / 1e6;
                    for(r = K; r < Q; r = i.tickIncrement(r, J, !1, v))L.push(H), O.push(r), Y && C.push(0);
                    O.push(r);
                    var $, tt = L.length, et = (r - K) / tt, rt = ($ = K + et / 2, m.c2r($, 0, v)), nt = A.size, it = b(A.start), at = b(A.end) + (it - i.tickIncrement(it, nt, !1, y)) / 1e6;
                    for(r = it; r < at; r = i.tickIncrement(r, nt, !1, y)){
                        E.push(L.slice()), z.push(r);
                        var ot = new Array(tt);
                        for(l = 0; l < tt; l++)ot[l] = [];
                        N.push(ot), Y && B.push(C.slice());
                    }
                    z.push(r);
                    var st = E.length, lt = (r - it) / st, ct = function(t1) {
                        return g.c2r(t1, 0, y);
                    }(it + lt / 2);
                    V && (W = u(L.length, D, et, P), X = u(E.length, R, lt, I)), P || "date" !== m.type || (D = f(x, D)), I || "date" !== g.type || (R = f(b, R));
                    var ut = !0, ft = !0, ht = new Array(tt), pt = new Array(st), dt = 1 / 0, mt = 1 / 0, gt = 1 / 0, vt = 1 / 0;
                    for(r = 0; r < S; r++){
                        var yt = T[r], xt = M[r];
                        p = n.findBin(yt, D), d = n.findBin(xt, R), p >= 0 && p < tt && d >= 0 && d < st && (F += q(p, r, E[d], Z, B[d]), N[d][p].push(r), ut && (void 0 === ht[p] ? ht[p] = yt : ht[p] !== yt && (ut = !1)), ft && (void 0 === pt[d] ? pt[d] = xt : pt[d] !== xt && (ft = !1)), dt = Math.min(dt, yt - O[p]), mt = Math.min(mt, O[p + 1] - yt), gt = Math.min(gt, xt - z[d]), vt = Math.min(vt, z[d + 1] - xt));
                    }
                    if (Y) for(d = 0; d < st; d++)F += s(E[d], B[d]);
                    if (G) for(d = 0; d < st; d++)G(E[d], F, W, X[d]);
                    return {
                        x: T,
                        xRanges: h(O, ut && ht, dt, mt, m, v),
                        x0: rt,
                        dx: et,
                        y: M,
                        yRanges: h(z, ft && pt, gt, vt, g, y),
                        y0: ct,
                        dy: lt,
                        z: E,
                        pts: N
                    };
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "../histogram/average": 813,
                "../histogram/bin_functions": 815,
                "../histogram/bin_label_vals": 816,
                "../histogram/calc": 817,
                "../histogram/norm_functions": 824
            }
        ],
        827: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./sample_defaults"), a = t1("../heatmap/style_defaults"), o = t1("../../components/colorscale/defaults"), s = t1("../heatmap/label_defaults"), l = t1("./attributes");
                e1.exports = function(t1, e1, r, c) {
                    function u(r, i) {
                        return n.coerce(t1, e1, l, r, i);
                    }
                    i(t1, e1, u, c), !1 !== e1.visible && (a(t1, e1, u, c), o(t1, e1, c, u, {
                        prefix: "",
                        cLetter: "z"
                    }), u("hovertemplate"), s(u, c), u("xhoverformat"), u("yhoverformat"));
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../lib": 503,
                "../heatmap/label_defaults": 802,
                "../heatmap/style_defaults": 806,
                "./attributes": 825,
                "./sample_defaults": 830
            }
        ],
        828: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../heatmap/hover"), i = t1("../../plots/cartesian/axes").hoverLabelText;
                e1.exports = function(t1, e1, r, a, o) {
                    var s = n(t1, e1, r, a, o);
                    if (s) {
                        var l = (t1 = s[0]).index, c = l[0], u = l[1], f = t1.cd[0], h = f.trace, p = f.xRanges[u], d = f.yRanges[c];
                        return t1.xLabel = i(t1.xa, [
                            p[0],
                            p[1]
                        ], h.xhoverformat), t1.yLabel = i(t1.ya, [
                            d[0],
                            d[1]
                        ], h.yhoverformat), s;
                    }
                };
            },
            {
                "../../plots/cartesian/axes": 554,
                "../heatmap/hover": 799
            }
        ],
        829: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    crossTraceDefaults: t1("../histogram/cross_trace_defaults"),
                    calc: t1("../heatmap/calc"),
                    plot: t1("../heatmap/plot"),
                    layerName: "heatmaplayer",
                    colorbar: t1("../heatmap/colorbar"),
                    style: t1("../heatmap/style"),
                    hoverPoints: t1("./hover"),
                    eventData: t1("../histogram/event_data"),
                    moduleType: "trace",
                    name: "histogram2d",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "cartesian",
                        "svg",
                        "2dMap",
                        "histogram",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "../heatmap/calc": 793,
                "../heatmap/colorbar": 795,
                "../heatmap/plot": 804,
                "../heatmap/style": 805,
                "../histogram/cross_trace_defaults": 819,
                "../histogram/event_data": 821,
                "./attributes": 825,
                "./defaults": 827,
                "./hover": 828
            }
        ],
        830: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib");
                e1.exports = function(t1, e1, r, a) {
                    var o = r("x"), s = r("y"), l = i.minRowLength(o), c = i.minRowLength(s);
                    l && c ? (e1._length = Math.min(l, c), n.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                        "x",
                        "y"
                    ], a), (r("z") || r("marker.color")) && r("histfunc"), r("histnorm"), r("autobinx"), r("autobiny")) : e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638
            }
        ],
        831: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../histogram2d/attributes"), i = t1("../contour/attributes"), a = t1("../../components/colorscale/attributes"), o = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, s = t1("../../lib/extend").extendFlat;
                e1.exports = s({
                    x: n.x,
                    y: n.y,
                    z: n.z,
                    marker: n.marker,
                    histnorm: n.histnorm,
                    histfunc: n.histfunc,
                    nbinsx: n.nbinsx,
                    xbins: n.xbins,
                    nbinsy: n.nbinsy,
                    ybins: n.ybins,
                    autobinx: n.autobinx,
                    autobiny: n.autobiny,
                    bingroup: n.bingroup,
                    xbingroup: n.xbingroup,
                    ybingroup: n.ybingroup,
                    autocontour: i.autocontour,
                    ncontours: i.ncontours,
                    contours: i.contours,
                    line: {
                        color: i.line.color,
                        width: s({}, i.line.width, {
                            dflt: .5
                        }),
                        dash: i.line.dash,
                        smoothing: i.line.smoothing,
                        editType: "plot"
                    },
                    xhoverformat: o("x"),
                    yhoverformat: o("y"),
                    zhoverformat: o("z", 1),
                    hovertemplate: n.hovertemplate,
                    texttemplate: i.texttemplate,
                    textfont: i.textfont
                }, a("", {
                    cLetter: "z",
                    editTypeOverride: "calc"
                }));
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../contour/attributes": 735,
                "../histogram2d/attributes": 825
            }
        ],
        832: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../histogram2d/sample_defaults"), a = t1("../contour/contours_defaults"), o = t1("../contour/style_defaults"), s = t1("../heatmap/label_defaults"), l = t1("./attributes");
                e1.exports = function(t1, e1, r, c) {
                    function u(r, i) {
                        return n.coerce(t1, e1, l, r, i);
                    }
                    i(t1, e1, u, c), !1 !== e1.visible && (a(t1, e1, u, function(r) {
                        return n.coerce2(t1, e1, l, r);
                    }), o(t1, e1, u, c), u("xhoverformat"), u("yhoverformat"), u("hovertemplate"), e1.contours && "heatmap" === e1.contours.coloring && s(u, c));
                };
            },
            {
                "../../lib": 503,
                "../contour/contours_defaults": 742,
                "../contour/style_defaults": 756,
                "../heatmap/label_defaults": 802,
                "../histogram2d/sample_defaults": 830,
                "./attributes": 831
            }
        ],
        833: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    crossTraceDefaults: t1("../histogram/cross_trace_defaults"),
                    calc: t1("../contour/calc"),
                    plot: t1("../contour/plot").plot,
                    layerName: "contourlayer",
                    style: t1("../contour/style"),
                    colorbar: t1("../contour/colorbar"),
                    hoverPoints: t1("../contour/hover"),
                    moduleType: "trace",
                    name: "histogram2dcontour",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "cartesian",
                        "svg",
                        "2dMap",
                        "contour",
                        "histogram",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "../contour/calc": 736,
                "../contour/colorbar": 738,
                "../contour/hover": 748,
                "../contour/plot": 753,
                "../contour/style": 755,
                "../histogram/cross_trace_defaults": 819,
                "./attributes": 831,
                "./defaults": 832
            }
        ],
        834: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/template_attributes").hovertemplateAttrs, i = t1("../../plots/template_attributes").texttemplateAttrs, a = t1("../../components/colorscale/attributes"), o = t1("../../plots/domain").attributes, s = t1("../pie/attributes"), l = t1("../sunburst/attributes"), c = t1("../treemap/attributes"), u = t1("../treemap/constants"), f = t1("../../lib/extend").extendFlat;
                e1.exports = {
                    labels: l.labels,
                    parents: l.parents,
                    values: l.values,
                    branchvalues: l.branchvalues,
                    count: l.count,
                    level: l.level,
                    maxdepth: l.maxdepth,
                    tiling: {
                        orientation: {
                            valType: "enumerated",
                            values: [
                                "v",
                                "h"
                            ],
                            dflt: "h",
                            editType: "plot"
                        },
                        flip: c.tiling.flip,
                        pad: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        editType: "calc"
                    },
                    marker: f({
                        colors: l.marker.colors,
                        line: l.marker.line,
                        editType: "calc"
                    }, a("marker", {
                        colorAttr: "colors",
                        anim: !1
                    })),
                    leaf: l.leaf,
                    pathbar: c.pathbar,
                    text: s.text,
                    textinfo: l.textinfo,
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: u.eventDataKeys.concat([
                            "label",
                            "value"
                        ])
                    }),
                    hovertext: s.hovertext,
                    hoverinfo: l.hoverinfo,
                    hovertemplate: n({}, {
                        keys: u.eventDataKeys
                    }),
                    textfont: s.textfont,
                    insidetextfont: s.insidetextfont,
                    outsidetextfont: c.outsidetextfont,
                    textposition: c.textposition,
                    sort: s.sort,
                    root: l.root,
                    domain: o({
                        name: "icicle",
                        trace: !0,
                        editType: "calc"
                    })
                };
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/domain": 584,
                "../../plots/template_attributes": 633,
                "../pie/attributes": 900,
                "../sunburst/attributes": 1045,
                "../treemap/attributes": 1071,
                "../treemap/constants": 1074
            }
        ],
        835: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/plots");
                r.name = "icicle", r.plot = function(t1, e1, i, a) {
                    n.plotBasePlot(r.name, t1, e1, i, a);
                }, r.clean = function(t1, e1, i, a) {
                    n.cleanBasePlot(r.name, t1, e1, i, a);
                };
            },
            {
                "../../plots/plots": 619
            }
        ],
        836: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../sunburst/calc");
                r.calc = function(t1, e1) {
                    return n.calc(t1, e1);
                }, r.crossTraceCalc = function(t1) {
                    return n._runCrossTraceCalc("icicle", t1);
                };
            },
            {
                "../sunburst/calc": 1047
            }
        ],
        837: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./attributes"), a = t1("../../components/color"), o = t1("../../plots/domain").defaults, s = t1("../bar/defaults").handleText, l = t1("../bar/constants").TEXTPAD, c = t1("../../components/colorscale"), u = c.hasColorscale, f = c.handleDefaults;
                e1.exports = function(t1, e1, r, c) {
                    function h(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    var p = h("labels"), d = h("parents");
                    if (p && p.length && d && d.length) {
                        var m = h("values");
                        m && m.length ? h("branchvalues") : h("count"), h("level"), h("maxdepth"), h("tiling.orientation"), h("tiling.flip"), h("tiling.pad");
                        var g = h("text");
                        h("texttemplate"), e1.texttemplate || h("textinfo", Array.isArray(g) ? "text+label" : "label"), h("hovertext"), h("hovertemplate");
                        var v = h("pathbar.visible");
                        s(t1, e1, c, h, "auto", {
                            hasPathbar: v,
                            moduleHasSelected: !1,
                            moduleHasUnselected: !1,
                            moduleHasConstrain: !1,
                            moduleHasCliponaxis: !1,
                            moduleHasTextangle: !1,
                            moduleHasInsideanchor: !1
                        }), h("textposition"), h("marker.line.width") && h("marker.line.color", c.paper_bgcolor), h("marker.colors");
                        var y = e1._hasColorscale = u(t1, "marker", "colors") || (t1.marker || {}).coloraxis;
                        y && f(t1, e1, c, h, {
                            prefix: "marker.",
                            cLetter: "c"
                        }), h("leaf.opacity", y ? 1 : .7), e1._hovered = {
                            marker: {
                                line: {
                                    width: 2,
                                    color: a.contrast(c.paper_bgcolor)
                                }
                            }
                        }, v && (h("pathbar.thickness", e1.pathbar.textfont.size + 2 * l), h("pathbar.side"), h("pathbar.edgeshape")), h("sort"), h("root.color"), o(e1, c, h), e1._length = null;
                    } else e1.visible = !1;
                };
            },
            {
                "../../components/color": 366,
                "../../components/colorscale": 378,
                "../../lib": 503,
                "../../plots/domain": 584,
                "../bar/constants": 650,
                "../bar/defaults": 652,
                "./attributes": 834
            }
        ],
        838: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../../components/drawing"), o = t1("../../lib/svg_text_utils"), s = t1("./partition"), l = t1("./style").styleOne, c = t1("../treemap/constants"), u = t1("../sunburst/helpers"), f = t1("../sunburst/fx"), h = t1("../sunburst/plot").formatSliceLabel;
                e1.exports = function(t1, e1, r, p, d) {
                    var m = d.width, g = d.height, v = d.viewX, y = d.viewY, x = d.pathSlice, b = d.toMoveInsideSlice, _ = d.strTransform, w = d.hasTransition, T = d.handleSlicesExit, k = d.makeUpdateSliceInterpolator, A = d.makeUpdateTextInterpolator, M = d.prevEntry, S = t1._fullLayout, E = e1[0].trace, L = -1 !== E.textposition.indexOf("left"), C = -1 !== E.textposition.indexOf("right"), P = -1 !== E.textposition.indexOf("bottom"), I = s(r, [
                        m,
                        g
                    ], {
                        flipX: E.tiling.flip.indexOf("x") > -1,
                        flipY: E.tiling.flip.indexOf("y") > -1,
                        orientation: E.tiling.orientation,
                        pad: {
                            inner: E.tiling.pad
                        },
                        maxDepth: E._maxDepth
                    }).descendants(), O = 1 / 0, z = -1 / 0;
                    I.forEach(function(t1) {
                        var e1 = t1.depth;
                        e1 >= E._maxDepth ? (t1.x0 = t1.x1 = (t1.x0 + t1.x1) / 2, t1.y0 = t1.y1 = (t1.y0 + t1.y1) / 2) : (O = Math.min(O, e1), z = Math.max(z, e1));
                    }), p = p.data(I, u.getPtId), E._maxVisibleLayers = isFinite(z) ? z - O + 1 : 0, p.enter().append("g").classed("slice", !0), T(p, !1, {}, [
                        m,
                        g
                    ], x), p.order();
                    var D = null;
                    if (w && M) {
                        var R = u.getPtId(M);
                        p.each(function(t1) {
                            null === D && u.getPtId(t1) === R && (D = {
                                x0: t1.x0,
                                x1: t1.x1,
                                y0: t1.y0,
                                y1: t1.y1
                            });
                        });
                    }
                    var F = function() {
                        return D || {
                            x0: 0,
                            x1: m,
                            y0: 0,
                            y1: g
                        };
                    }, B = p;
                    return w && (B = B.transition().each("end", function() {
                        var e1 = n.select(this);
                        u.setSliceCursor(e1, t1, {
                            hideOnRoot: !0,
                            hideOnLeaves: !1,
                            isTransitioning: !1
                        });
                    })), B.each(function(s) {
                        s._x0 = v(s.x0), s._x1 = v(s.x1), s._y0 = y(s.y0), s._y1 = y(s.y1), s._hoverX = v(s.x1 - E.tiling.pad), s._hoverY = y(P ? s.y1 - E.tiling.pad / 2 : s.y0 + E.tiling.pad / 2);
                        var p = n.select(this), d = i.ensureSingle(p, "path", "surface", function(t1) {
                            t1.style("pointer-events", "all");
                        });
                        w ? d.transition().attrTween("d", function(t1) {
                            var e1 = k(t1, !1, F(), [
                                m,
                                g
                            ], {
                                orientation: E.tiling.orientation,
                                flipX: E.tiling.flip.indexOf("x") > -1,
                                flipY: E.tiling.flip.indexOf("y") > -1
                            });
                            return function(t1) {
                                return x(e1(t1));
                            };
                        }) : d.attr("d", x), p.call(f, r, t1, e1, {
                            styleOne: l,
                            eventDataKeys: c.eventDataKeys,
                            transitionTime: c.CLICK_TRANSITION_TIME,
                            transitionEasing: c.CLICK_TRANSITION_EASING
                        }).call(u.setSliceCursor, t1, {
                            isTransitioning: t1._transitioning
                        }), d.call(l, s, E, {
                            hovered: !1
                        }), s.x0 === s.x1 || s.y0 === s.y1 ? s._text = "" : s._text = h(s, r, E, e1, S) || "";
                        var T = i.ensureSingle(p, "g", "slicetext"), M = i.ensureSingle(T, "text", "", function(t1) {
                            t1.attr("data-notex", 1);
                        }), I = i.ensureUniformFontSize(t1, u.determineTextFont(E, s, S.font));
                        M.text(s._text || " ").classed("slicetext", !0).attr("text-anchor", C ? "end" : L ? "start" : "middle").call(a.font, I).call(o.convertToTspans, t1), s.textBB = a.bBox(M.node()), s.transform = b(s, {
                            fontSize: I.size
                        }), s.transform.fontSize = I.size, w ? M.transition().attrTween("transform", function(t1) {
                            var e1 = A(t1, !1, F(), [
                                m,
                                g
                            ]);
                            return function(t1) {
                                return _(e1(t1));
                            };
                        }) : M.attr("transform", _(s));
                    }), D;
                };
            },
            {
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../sunburst/fx": 1050,
                "../sunburst/helpers": 1051,
                "../sunburst/plot": 1055,
                "../treemap/constants": 1074,
                "./partition": 842,
                "./style": 844,
                "@plotly/d3": 58
            }
        ],
        839: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "icicle",
                    basePlotModule: t1("./base_plot"),
                    categories: [],
                    animatable: !0,
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("./layout_attributes"),
                    supplyDefaults: t1("./defaults"),
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    calc: t1("./calc").calc,
                    crossTraceCalc: t1("./calc").crossTraceCalc,
                    plot: t1("./plot"),
                    style: t1("./style").style,
                    colorbar: t1("../scatter/marker_colorbar"),
                    meta: {}
                };
            },
            {
                "../scatter/marker_colorbar": 944,
                "./attributes": 834,
                "./base_plot": 835,
                "./calc": 836,
                "./defaults": 837,
                "./layout_attributes": 840,
                "./layout_defaults": 841,
                "./plot": 843,
                "./style": 844
            }
        ],
        840: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    iciclecolorway: {
                        valType: "colorlist",
                        editType: "calc"
                    },
                    extendiciclecolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    }
                };
            },
            {}
        ],
        841: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./layout_attributes");
                e1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    r("iciclecolorway", e1.colorway), r("extendiciclecolors");
                };
            },
            {
                "../../lib": 503,
                "./layout_attributes": 840
            }
        ],
        842: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("d3-hierarchy"), i = t1("../treemap/flip_tree");
                e1.exports = function(t1, e1, r) {
                    var a = r.flipX, o = r.flipY, s = "h" === r.orientation, l = r.maxDepth, c = e1[0], u = e1[1];
                    l && (c = (t1.height + 1) * e1[0] / Math.min(t1.height + 1, l), u = (t1.height + 1) * e1[1] / Math.min(t1.height + 1, l));
                    var f = n.partition().padding(r.pad.inner).size(s ? [
                        e1[1],
                        c
                    ] : [
                        e1[0],
                        u
                    ])(t1);
                    return (s || a || o) && i(f, e1, {
                        swapXY: s,
                        flipX: a,
                        flipY: o
                    }), f;
                };
            },
            {
                "../treemap/flip_tree": 1079,
                "d3-hierarchy": 115
            }
        ],
        843: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../treemap/draw"), i = t1("./draw_descendants");
                e1.exports = function(t1, e1, r, a) {
                    return n(t1, e1, r, a, {
                        type: "icicle",
                        drawDescendants: i
                    });
                };
            },
            {
                "../treemap/draw": 1076,
                "./draw_descendants": 838
            }
        ],
        844: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/color"), a = t1("../../lib"), o = t1("../bar/uniform_text").resizeText;
                function s(t1, e1, r) {
                    var n = e1.data.data, o = !e1.children, s = n.i, l = a.castOption(r, s, "marker.line.color") || i.defaultLine, c = a.castOption(r, s, "marker.line.width") || 0;
                    t1.style("stroke-width", c).call(i.fill, n.color).call(i.stroke, l).style("opacity", o ? r.leaf.opacity : null);
                }
                e1.exports = {
                    style: function(t1) {
                        var e1 = t1._fullLayout._iciclelayer.selectAll(".trace");
                        o(t1, e1, "icicle"), e1.each(function(t1) {
                            var e1 = n.select(this), r = t1[0].trace;
                            e1.style("opacity", r.opacity), e1.selectAll("path.surface").each(function(t1) {
                                n.select(this).call(s, t1, r);
                            });
                        });
                    },
                    styleOne: s
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../bar/uniform_text": 664,
                "@plotly/d3": 58
            }
        ],
        845: [
            function(t1, e1, r) {
                "use strict";
                for(var n = t1("../../plots/attributes"), i = t1("../../plots/template_attributes").hovertemplateAttrs, a = t1("../../lib/extend").extendFlat, o = t1("./constants").colormodel, s = [
                    "rgb",
                    "rgba",
                    "rgba256",
                    "hsl",
                    "hsla"
                ], l = [], c = [], u = 0; u < s.length; u++){
                    var f = o[s[u]];
                    l.push("For the `" + s[u] + "` colormodel, it is [" + (f.zminDflt || f.min).join(", ") + "]."), c.push("For the `" + s[u] + "` colormodel, it is [" + (f.zmaxDflt || f.max).join(", ") + "].");
                }
                e1.exports = a({
                    source: {
                        valType: "string",
                        editType: "calc"
                    },
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    colormodel: {
                        valType: "enumerated",
                        values: s,
                        editType: "calc"
                    },
                    zsmooth: {
                        valType: "enumerated",
                        values: [
                            "fast",
                            !1
                        ],
                        dflt: !1,
                        editType: "plot"
                    },
                    zmin: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number",
                                editType: "calc"
                            },
                            {
                                valType: "number",
                                editType: "calc"
                            },
                            {
                                valType: "number",
                                editType: "calc"
                            },
                            {
                                valType: "number",
                                editType: "calc"
                            }
                        ],
                        editType: "calc"
                    },
                    zmax: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number",
                                editType: "calc"
                            },
                            {
                                valType: "number",
                                editType: "calc"
                            },
                            {
                                valType: "number",
                                editType: "calc"
                            },
                            {
                                valType: "number",
                                editType: "calc"
                            }
                        ],
                        editType: "calc"
                    },
                    x0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes"
                    },
                    y0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes"
                    },
                    dx: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    dy: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    text: {
                        valType: "data_array",
                        editType: "plot"
                    },
                    hovertext: {
                        valType: "data_array",
                        editType: "plot"
                    },
                    hoverinfo: a({}, n.hoverinfo, {
                        flags: [
                            "x",
                            "y",
                            "z",
                            "color",
                            "name",
                            "text"
                        ],
                        dflt: "x+y+z+text+name"
                    }),
                    hovertemplate: i({}, {
                        keys: [
                            "z",
                            "color",
                            "colormodel"
                        ]
                    }),
                    transforms: void 0
                });
            },
            {
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/template_attributes": 633,
                "./constants": 847
            }
        ],
        846: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./constants"), a = t1("fast-isnumeric"), o = t1("../../plots/cartesian/axes"), s = t1("../../lib").maxRowLength, l = t1("./helpers").getImageSize;
                function c(t1, e1, r, i) {
                    return function(a) {
                        return n.constrain((a - t1) * e1, r, i);
                    };
                }
                function u(t1, e1) {
                    return function(r) {
                        return n.constrain(r, t1, e1);
                    };
                }
                e1.exports = function(t1, e1) {
                    var r, n;
                    if (e1._hasZ) r = e1.z.length, n = s(e1.z);
                    else if (e1._hasSource) {
                        var f = l(e1.source);
                        r = f.height, n = f.width;
                    }
                    var h, p = o.getFromId(t1, e1.xaxis || "x"), d = o.getFromId(t1, e1.yaxis || "y"), m = p.d2c(e1.x0) - e1.dx / 2, g = d.d2c(e1.y0) - e1.dy / 2, v = [
                        m,
                        m + n * e1.dx
                    ], y = [
                        g,
                        g + r * e1.dy
                    ];
                    if (p && "log" === p.type) for(h = 0; h < n; h++)v.push(m + h * e1.dx);
                    if (d && "log" === d.type) for(h = 0; h < r; h++)y.push(g + h * e1.dy);
                    return e1._extremes[p._id] = o.findExtremes(p, v), e1._extremes[d._id] = o.findExtremes(d, y), e1._scaler = function(t1) {
                        var e1 = i.colormodel[t1.colormodel], r = (e1.colormodel || t1.colormodel).length;
                        t1._sArray = [];
                        for(var n = 0; n < r; n++)e1.min[n] !== t1.zmin[n] || e1.max[n] !== t1.zmax[n] ? t1._sArray.push(c(t1.zmin[n], (e1.max[n] - e1.min[n]) / (t1.zmax[n] - t1.zmin[n]), e1.min[n], e1.max[n])) : t1._sArray.push(u(e1.min[n], e1.max[n]));
                        return function(e1) {
                            for(var n = e1.slice(0, r), i = 0; i < r; i++){
                                var o = n[i];
                                if (!a(o)) return !1;
                                n[i] = t1._sArray[i](o);
                            }
                            return n;
                        };
                    }(e1), [
                        {
                            x0: m,
                            y0: g,
                            z: e1.z,
                            w: n,
                            h: r
                        }
                    ];
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "./constants": 847,
                "./helpers": 850,
                "fast-isnumeric": 190
            }
        ],
        847: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    colormodel: {
                        rgb: {
                            min: [
                                0,
                                0,
                                0
                            ],
                            max: [
                                255,
                                255,
                                255
                            ],
                            fmt: function(t1) {
                                return t1.slice(0, 3);
                            },
                            suffix: [
                                "",
                                "",
                                ""
                            ]
                        },
                        rgba: {
                            min: [
                                0,
                                0,
                                0,
                                0
                            ],
                            max: [
                                255,
                                255,
                                255,
                                1
                            ],
                            fmt: function(t1) {
                                return t1.slice(0, 4);
                            },
                            suffix: [
                                "",
                                "",
                                "",
                                ""
                            ]
                        },
                        rgba256: {
                            colormodel: "rgba",
                            zminDflt: [
                                0,
                                0,
                                0,
                                0
                            ],
                            zmaxDflt: [
                                255,
                                255,
                                255,
                                255
                            ],
                            min: [
                                0,
                                0,
                                0,
                                0
                            ],
                            max: [
                                255,
                                255,
                                255,
                                1
                            ],
                            fmt: function(t1) {
                                return t1.slice(0, 4);
                            },
                            suffix: [
                                "",
                                "",
                                "",
                                ""
                            ]
                        },
                        hsl: {
                            min: [
                                0,
                                0,
                                0
                            ],
                            max: [
                                360,
                                100,
                                100
                            ],
                            fmt: function(t1) {
                                var e1 = t1.slice(0, 3);
                                return e1[1] = e1[1] + "%", e1[2] = e1[2] + "%", e1;
                            },
                            suffix: [
                                "\xb0",
                                "%",
                                "%"
                            ]
                        },
                        hsla: {
                            min: [
                                0,
                                0,
                                0,
                                0
                            ],
                            max: [
                                360,
                                100,
                                100,
                                1
                            ],
                            fmt: function(t1) {
                                var e1 = t1.slice(0, 4);
                                return e1[1] = e1[1] + "%", e1[2] = e1[2] + "%", e1;
                            },
                            suffix: [
                                "\xb0",
                                "%",
                                "%",
                                ""
                            ]
                        }
                    },
                    pixelatedStyle: [
                        "image-rendering: optimizeSpeed",
                        "image-rendering: -moz-crisp-edges",
                        "image-rendering: -o-crisp-edges",
                        "image-rendering: -webkit-optimize-contrast",
                        "image-rendering: optimize-contrast",
                        "image-rendering: crisp-edges",
                        "image-rendering: pixelated",
                        ""
                    ].join("; ")
                };
            },
            {}
        ],
        848: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./attributes"), a = t1("./constants"), o = t1("../../snapshot/helpers").IMAGE_URL_PREFIX;
                e1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    r("source"), e1.source && !e1.source.match(o) && delete e1.source, e1._hasSource = !!e1.source;
                    var s, l = r("z");
                    (e1._hasZ = !(void 0 === l || !l.length || !l[0] || !l[0].length), e1._hasZ || e1._hasSource) ? (r("x0"), r("y0"), r("dx"), r("dy"), e1._hasZ ? (r("colormodel", "rgb"), r("zmin", (s = a.colormodel[e1.colormodel]).zminDflt || s.min), r("zmax", s.zmaxDflt || s.max)) : e1._hasSource && (e1.colormodel = "rgba256", s = a.colormodel[e1.colormodel], e1.zmin = s.zminDflt, e1.zmax = s.zmaxDflt), r("zsmooth"), r("text"), r("hovertext"), r("hovertemplate"), e1._length = null) : e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../../snapshot/helpers": 642,
                "./attributes": 845,
                "./constants": 847
            }
        ],
        849: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    return "xVal" in e1 && (t1.x = e1.xVal), "yVal" in e1 && (t1.y = e1.yVal), e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), t1.color = e1.color, t1.colormodel = e1.trace.colormodel, t1.z || (t1.z = e1.color), t1;
                };
            },
            {}
        ],
        850: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("probe-image-size/sync"), i = t1("../../snapshot/helpers").IMAGE_URL_PREFIX, a = t1("buffer/").Buffer;
                r.getImageSize = function(t1) {
                    var e1 = t1.replace(i, ""), r = new a(e1, "base64");
                    return n(r);
                };
            },
            {
                "../../snapshot/helpers": 642,
                "buffer/": 85,
                "probe-image-size/sync": 276
            }
        ],
        851: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/fx"), i = t1("../../lib"), a = t1("./constants");
                e1.exports = function(t1, e1, r) {
                    var o = t1.cd[0], s = o.trace, l = t1.xa, c = t1.ya;
                    if (!(n.inbox(e1 - o.x0, e1 - (o.x0 + o.w * s.dx), 0) > 0 || n.inbox(r - o.y0, r - (o.y0 + o.h * s.dy), 0) > 0)) {
                        var u, f = Math.floor((e1 - o.x0) / s.dx), h = Math.floor(Math.abs(r - o.y0) / s.dy);
                        if (s._hasZ ? u = o.z[h][f] : s._hasSource && (u = s._canvas.el.getContext("2d").getImageData(f, h, 1, 1).data), u) {
                            var p, d = o.hi || s.hoverinfo;
                            if (d) {
                                var m = d.split("+");
                                -1 !== m.indexOf("all") && (m = [
                                    "color"
                                ]), -1 !== m.indexOf("color") && (p = !0);
                            }
                            var g, v = a.colormodel[s.colormodel], y = v.colormodel || s.colormodel, x = y.length, b = s._scaler(u), _ = v.suffix, w = [];
                            (s.hovertemplate || p) && (w.push("[" + [
                                b[0] + _[0],
                                b[1] + _[1],
                                b[2] + _[2]
                            ].join(", ")), 4 === x && w.push(", " + b[3] + _[3]), w.push("]"), w = w.join(""), t1.extraText = y.toUpperCase() + ": " + w), Array.isArray(s.hovertext) && Array.isArray(s.hovertext[h]) ? g = s.hovertext[h][f] : Array.isArray(s.text) && Array.isArray(s.text[h]) && (g = s.text[h][f]);
                            var T = c.c2p(o.y0 + (h + .5) * s.dy), k = o.x0 + (f + .5) * s.dx, A = o.y0 + (h + .5) * s.dy, M = "[" + u.slice(0, s.colormodel.length).join(", ") + "]";
                            return [
                                i.extendFlat(t1, {
                                    index: [
                                        h,
                                        f
                                    ],
                                    x0: l.c2p(o.x0 + f * s.dx),
                                    x1: l.c2p(o.x0 + (f + 1) * s.dx),
                                    y0: T,
                                    y1: T,
                                    color: b,
                                    xVal: k,
                                    xLabelVal: k,
                                    yVal: A,
                                    yLabelVal: A,
                                    zLabelVal: M,
                                    text: g,
                                    hovertemplateLabels: {
                                        zLabel: M,
                                        colorLabel: w,
                                        "color[0]Label": b[0] + _[0],
                                        "color[1]Label": b[1] + _[1],
                                        "color[2]Label": b[2] + _[2],
                                        "color[3]Label": b[3] + _[3]
                                    }
                                })
                            ];
                        }
                    }
                };
            },
            {
                "../../components/fx": 406,
                "../../lib": 503,
                "./constants": 847
            }
        ],
        852: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    style: t1("./style"),
                    hoverPoints: t1("./hover"),
                    eventData: t1("./event_data"),
                    moduleType: "trace",
                    name: "image",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "cartesian",
                        "svg",
                        "2dMap",
                        "noSortingByValue"
                    ],
                    animatable: !1,
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "./attributes": 845,
                "./calc": 846,
                "./defaults": 848,
                "./event_data": 849,
                "./hover": 851,
                "./plot": 853,
                "./style": 854
            }
        ],
        853: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = i.strTranslate, o = t1("../../constants/xmlns_namespaces"), s = t1("./constants"), l = i.isIOS() || i.isSafari() || i.isIE();
                e1.exports = function(t1, e1, r, c) {
                    var u = e1.xaxis, f = e1.yaxis, h = !(l || t1._context._exportedPlot);
                    i.makeTraceGroups(c, r, "im").each(function(e1) {
                        var r = n.select(this), l = e1[0], c = l.trace, p = ("fast" === c.zsmooth || !1 === c.zsmooth && h) && !c._hasZ && c._hasSource && "linear" === u.type && "linear" === f.type;
                        c._realImage = p;
                        var d, m, g, v, y, x, b = l.z, _ = l.x0, w = l.y0, T = l.w, k = l.h, A = c.dx, M = c.dy;
                        for(x = 0; void 0 === d && x < T;)d = u.c2p(_ + x * A), x++;
                        for(x = T; void 0 === m && x > 0;)m = u.c2p(_ + x * A), x--;
                        for(x = 0; void 0 === v && x < k;)v = f.c2p(w + x * M), x++;
                        for(x = k; void 0 === y && x > 0;)y = f.c2p(w + x * M), x--;
                        if (m < d && (g = m, m = d, d = g), y < v && (g = v, v = y, y = g), !p) d = Math.max(-0.5 * u._length, d), m = Math.min(1.5 * u._length, m), v = Math.max(-0.5 * f._length, v), y = Math.min(1.5 * f._length, y);
                        var S = Math.round(m - d), E = Math.round(y - v);
                        if (S <= 0 || E <= 0) r.selectAll("image").data([]).exit().remove();
                        else {
                            var L = r.selectAll("image").data([
                                e1
                            ]);
                            L.enter().append("svg:image").attr({
                                xmlns: o.svg,
                                preserveAspectRatio: "none"
                            }), L.exit().remove();
                            var C = !1 === c.zsmooth ? s.pixelatedStyle : "";
                            if (p) {
                                var P = i.simpleMap(u.range, u.r2l), I = i.simpleMap(f.range, f.r2l), O = P[1] < P[0], z = I[1] > I[0];
                                if (O || z) {
                                    var D = d + S / 2, R = v + E / 2;
                                    C += "transform:" + a(D + "px", R + "px") + "scale(" + (O ? -1 : 1) + "," + (z ? -1 : 1) + ")" + a(-D + "px", -R + "px") + ";";
                                }
                            }
                            L.attr("style", C);
                            var F = new Promise(function(t1) {
                                if (c._hasZ) t1();
                                else if (c._hasSource) {
                                    if (c._canvas && c._canvas.el.width === T && c._canvas.el.height === k && c._canvas.source === c.source) t1();
                                    else {
                                        var e1 = document.createElement("canvas");
                                        e1.width = T, e1.height = k;
                                        var r = e1.getContext("2d");
                                        c._image = c._image || new Image;
                                        var n = c._image;
                                        n.onload = function() {
                                            r.drawImage(n, 0, 0), c._canvas = {
                                                el: e1,
                                                source: c.source
                                            }, t1();
                                        }, n.setAttribute("src", c.source);
                                    }
                                }
                            }).then(function() {
                                var t1;
                                if (c._hasZ) t1 = B(function(t1, e1) {
                                    return b[e1][t1];
                                }).toDataURL("image/png");
                                else if (c._hasSource) {
                                    if (p) t1 = c.source;
                                    else {
                                        var e1 = c._canvas.el.getContext("2d").getImageData(0, 0, T, k).data;
                                        t1 = B(function(t1, r) {
                                            var n = 4 * (r * T + t1);
                                            return [
                                                e1[n],
                                                e1[n + 1],
                                                e1[n + 2],
                                                e1[n + 3]
                                            ];
                                        }).toDataURL("image/png");
                                    }
                                }
                                L.attr({
                                    "xlink:href": t1,
                                    height: E,
                                    width: S,
                                    x: d,
                                    y: v
                                });
                            });
                            t1._promises.push(F);
                        }
                        function B(t1) {
                            var e1 = document.createElement("canvas");
                            e1.width = S, e1.height = E;
                            var r, n = e1.getContext("2d"), a = function(t1) {
                                return i.constrain(Math.round(u.c2p(_ + t1 * A) - d), 0, S);
                            }, o = function(t1) {
                                return i.constrain(Math.round(f.c2p(w + t1 * M) - v), 0, E);
                            }, h = s.colormodel[c.colormodel], p = h.colormodel || c.colormodel, m = h.fmt;
                            for(x = 0; x < l.w; x++){
                                var g = a(x), y = a(x + 1);
                                if (y !== g && !isNaN(y) && !isNaN(g)) for(var b = 0; b < l.h; b++){
                                    var T = o(b), k = o(b + 1);
                                    k === T || isNaN(k) || isNaN(T) || !t1(x, b) || (r = c._scaler(t1(x, b)), n.fillStyle = r ? p + "(" + m(r).join(",") + ")" : "rgba(0,0,0,0)", n.fillRect(g, T, y - g, k - T));
                                }
                            }
                            return e1;
                        }
                    });
                };
            },
            {
                "../../constants/xmlns_namespaces": 480,
                "../../lib": 503,
                "./constants": 847,
                "@plotly/d3": 58
            }
        ],
        854: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3");
                e1.exports = function(t1) {
                    n.select(t1).selectAll(".im image").style("opacity", function(t1) {
                        return t1[0].trace.opacity;
                    });
                };
            },
            {
                "@plotly/d3": 58
            }
        ],
        855: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib/extend").extendFlat, i = t1("../../lib/extend").extendDeep, a = t1("../../plot_api/edit_types").overrideAll, o = t1("../../plots/font_attributes"), s = t1("../../components/color/attributes"), l = t1("../../plots/domain").attributes, c = t1("../../plots/cartesian/layout_attributes"), u = t1("../../plot_api/plot_template").templatedArray, f = t1("../../constants/delta.js"), h = t1("../../plots/cartesian/axis_format_attributes").descriptionOnlyNumbers, p = o({
                    editType: "plot",
                    colorEditType: "plot"
                }), d = {
                    color: {
                        valType: "color",
                        editType: "plot"
                    },
                    line: {
                        color: {
                            valType: "color",
                            dflt: s.defaultLine,
                            editType: "plot"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        editType: "calc"
                    },
                    thickness: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "plot"
                    },
                    editType: "calc"
                }, m = {
                    valType: "info_array",
                    items: [
                        {
                            valType: "number",
                            editType: "plot"
                        },
                        {
                            valType: "number",
                            editType: "plot"
                        }
                    ],
                    editType: "plot"
                }, g = u("step", i({}, d, {
                    range: m
                }));
                e1.exports = {
                    mode: {
                        valType: "flaglist",
                        editType: "calc",
                        flags: [
                            "number",
                            "delta",
                            "gauge"
                        ],
                        dflt: "number"
                    },
                    value: {
                        valType: "number",
                        editType: "calc",
                        anim: !0
                    },
                    align: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ],
                        editType: "plot"
                    },
                    domain: l({
                        name: "indicator",
                        trace: !0,
                        editType: "calc"
                    }),
                    title: {
                        text: {
                            valType: "string",
                            editType: "plot"
                        },
                        align: {
                            valType: "enumerated",
                            values: [
                                "left",
                                "center",
                                "right"
                            ],
                            editType: "plot"
                        },
                        font: n({}, p, {}),
                        editType: "plot"
                    },
                    number: {
                        valueformat: {
                            valType: "string",
                            dflt: "",
                            editType: "plot",
                            description: h("value")
                        },
                        font: n({}, p, {}),
                        prefix: {
                            valType: "string",
                            dflt: "",
                            editType: "plot"
                        },
                        suffix: {
                            valType: "string",
                            dflt: "",
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    delta: {
                        reference: {
                            valType: "number",
                            editType: "calc"
                        },
                        position: {
                            valType: "enumerated",
                            values: [
                                "top",
                                "bottom",
                                "left",
                                "right"
                            ],
                            dflt: "bottom",
                            editType: "plot"
                        },
                        relative: {
                            valType: "boolean",
                            editType: "plot",
                            dflt: !1
                        },
                        valueformat: {
                            valType: "string",
                            editType: "plot",
                            description: h("value")
                        },
                        increasing: {
                            symbol: {
                                valType: "string",
                                dflt: f.INCREASING.SYMBOL,
                                editType: "plot"
                            },
                            color: {
                                valType: "color",
                                dflt: f.INCREASING.COLOR,
                                editType: "plot"
                            },
                            editType: "plot"
                        },
                        decreasing: {
                            symbol: {
                                valType: "string",
                                dflt: f.DECREASING.SYMBOL,
                                editType: "plot"
                            },
                            color: {
                                valType: "color",
                                dflt: f.DECREASING.COLOR,
                                editType: "plot"
                            },
                            editType: "plot"
                        },
                        font: n({}, p, {}),
                        editType: "calc"
                    },
                    gauge: {
                        shape: {
                            valType: "enumerated",
                            editType: "plot",
                            dflt: "angular",
                            values: [
                                "angular",
                                "bullet"
                            ]
                        },
                        bar: i({}, d, {
                            color: {
                                dflt: "green"
                            }
                        }),
                        bgcolor: {
                            valType: "color",
                            editType: "plot"
                        },
                        bordercolor: {
                            valType: "color",
                            dflt: s.defaultLine,
                            editType: "plot"
                        },
                        borderwidth: {
                            valType: "number",
                            min: 0,
                            dflt: 1,
                            editType: "plot"
                        },
                        axis: a({
                            range: m,
                            visible: n({}, c.visible, {
                                dflt: !0
                            }),
                            tickmode: c.tickmode,
                            nticks: c.nticks,
                            tick0: c.tick0,
                            dtick: c.dtick,
                            tickvals: c.tickvals,
                            ticktext: c.ticktext,
                            ticks: n({}, c.ticks, {
                                dflt: "outside"
                            }),
                            ticklen: c.ticklen,
                            tickwidth: c.tickwidth,
                            tickcolor: c.tickcolor,
                            showticklabels: c.showticklabels,
                            tickfont: o({}),
                            tickangle: c.tickangle,
                            tickformat: c.tickformat,
                            tickformatstops: c.tickformatstops,
                            tickprefix: c.tickprefix,
                            showtickprefix: c.showtickprefix,
                            ticksuffix: c.ticksuffix,
                            showticksuffix: c.showticksuffix,
                            separatethousands: c.separatethousands,
                            exponentformat: c.exponentformat,
                            minexponent: c.minexponent,
                            showexponent: c.showexponent,
                            editType: "plot"
                        }, "plot"),
                        steps: g,
                        threshold: {
                            line: {
                                color: n({}, d.line.color, {}),
                                width: n({}, d.line.width, {
                                    dflt: 1
                                }),
                                editType: "plot"
                            },
                            thickness: n({}, d.thickness, {
                                dflt: .85
                            }),
                            value: {
                                valType: "number",
                                editType: "calc",
                                dflt: !1
                            },
                            editType: "plot"
                        },
                        editType: "plot"
                    }
                };
            },
            {
                "../../components/color/attributes": 365,
                "../../constants/delta.js": 473,
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../../plot_api/plot_template": 543,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/cartesian/layout_attributes": 569,
                "../../plots/domain": 584,
                "../../plots/font_attributes": 585
            }
        ],
        856: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/plots");
                r.name = "indicator", r.plot = function(t1, e1, i, a) {
                    n.plotBasePlot(r.name, t1, e1, i, a);
                }, r.clean = function(t1, e1, i, a) {
                    n.cleanBasePlot(r.name, t1, e1, i, a);
                };
            },
            {
                "../../plots/plots": 619
            }
        ],
        857: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    calc: function(t1, e1) {
                        var r = [], n = e1.value;
                        "number" != typeof e1._lastValue && (e1._lastValue = e1.value);
                        var i = e1._lastValue, a = i;
                        return e1._hasDelta && "number" == typeof e1.delta.reference && (a = e1.delta.reference), r[0] = {
                            y: n,
                            lastY: i,
                            delta: n - a,
                            relativeDelta: (n - a) / a
                        }, r;
                    }
                };
            },
            {}
        ],
        858: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    defaultNumberFontSize: 80,
                    bulletNumberDomainSize: .25,
                    bulletPadding: .025,
                    innerRadius: .75,
                    valueThickness: .5,
                    titlePadding: 5,
                    horizontalPadding: 10
                };
            },
            {}
        ],
        859: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./attributes"), a = t1("../../plots/domain").defaults, o = t1("../../plot_api/plot_template"), s = t1("../../plots/array_container_defaults"), l = t1("./constants.js"), c = t1("../../plots/cartesian/tick_value_defaults"), u = t1("../../plots/cartesian/tick_mark_defaults"), f = t1("../../plots/cartesian/tick_label_defaults"), h = t1("../../plots/cartesian/prefix_suffix_defaults");
                function p(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i.gauge.steps, r, a);
                    }
                    r("color"), r("line.color"), r("line.width"), r("range"), r("thickness");
                }
                e1.exports = {
                    supplyDefaults: function(t1, e1, r, d) {
                        function m(r, a) {
                            return n.coerce(t1, e1, i, r, a);
                        }
                        a(e1, d, m), m("mode"), e1._hasNumber = -1 !== e1.mode.indexOf("number"), e1._hasDelta = -1 !== e1.mode.indexOf("delta"), e1._hasGauge = -1 !== e1.mode.indexOf("gauge");
                        var g = m("value");
                        e1._range = [
                            0,
                            "number" == typeof g ? 1.5 * g : 1
                        ];
                        var v, y, x, b, _, w, T = new Array(2);
                        function k(t1, e1) {
                            return n.coerce(x, b, i.gauge, t1, e1);
                        }
                        function A(t1, e1) {
                            return n.coerce(_, w, i.gauge.axis, t1, e1);
                        }
                        if (e1._hasNumber && (m("number.valueformat"), m("number.font.color", d.font.color), m("number.font.family", d.font.family), m("number.font.size"), void 0 === e1.number.font.size && (e1.number.font.size = l.defaultNumberFontSize, T[0] = !0), m("number.prefix"), m("number.suffix"), v = e1.number.font.size), e1._hasDelta && (m("delta.font.color", d.font.color), m("delta.font.family", d.font.family), m("delta.font.size"), void 0 === e1.delta.font.size && (e1.delta.font.size = (e1._hasNumber ? .5 : 1) * (v || l.defaultNumberFontSize), T[1] = !0), m("delta.reference", e1.value), m("delta.relative"), m("delta.valueformat", e1.delta.relative ? "2%" : ""), m("delta.increasing.symbol"), m("delta.increasing.color"), m("delta.decreasing.symbol"), m("delta.decreasing.color"), m("delta.position"), y = e1.delta.font.size), e1._scaleNumbers = (!e1._hasNumber || T[0]) && (!e1._hasDelta || T[1]) || !1, m("title.font.color", d.font.color), m("title.font.family", d.font.family), m("title.font.size", .25 * (v || y || l.defaultNumberFontSize)), m("title.text"), e1._hasGauge) {
                            (x = t1.gauge) || (x = {}), b = o.newContainer(e1, "gauge"), k("shape"), (e1._isBullet = "bullet" === e1.gauge.shape) || m("title.align", "center"), (e1._isAngular = "angular" === e1.gauge.shape) || m("align", "center"), k("bgcolor", d.paper_bgcolor), k("borderwidth"), k("bordercolor"), k("bar.color"), k("bar.line.color"), k("bar.line.width"), k("bar.thickness", l.valueThickness * ("bullet" === e1.gauge.shape ? .5 : 1)), s(x, b, {
                                name: "steps",
                                handleItemDefaults: p
                            }), k("threshold.value"), k("threshold.thickness"), k("threshold.line.width"), k("threshold.line.color"), _ = {}, x && (_ = x.axis || {}), w = o.newContainer(b, "axis"), A("visible"), e1._range = A("range", e1._range);
                            var M = {
                                outerTicks: !0
                            };
                            c(_, w, A, "linear"), h(_, w, A, "linear", M), f(_, w, A, "linear", M), u(_, w, A, M);
                        } else m("title.align", "center"), m("align", "center"), e1._isAngular = e1._isBullet = !1;
                        e1._length = null;
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../../plots/array_container_defaults": 549,
                "../../plots/cartesian/prefix_suffix_defaults": 573,
                "../../plots/cartesian/tick_label_defaults": 578,
                "../../plots/cartesian/tick_mark_defaults": 579,
                "../../plots/cartesian/tick_value_defaults": 580,
                "../../plots/domain": 584,
                "./attributes": 855,
                "./constants.js": 858
            }
        ],
        860: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "indicator",
                    basePlotModule: t1("./base_plot"),
                    categories: [
                        "svg",
                        "noOpacity",
                        "noHover"
                    ],
                    animatable: !0,
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults").supplyDefaults,
                    calc: t1("./calc").calc,
                    plot: t1("./plot"),
                    meta: {}
                };
            },
            {
                "./attributes": 855,
                "./base_plot": 856,
                "./calc": 857,
                "./defaults": 859,
                "./plot": 861
            }
        ],
        861: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("d3-interpolate").interpolate, a = t1("d3-interpolate").interpolateNumber, o = t1("../../lib"), s = o.strScale, l = o.strTranslate, c = o.rad2deg, u = t1("../../constants/alignment").MID_SHIFT, f = t1("../../components/drawing"), h = t1("./constants"), p = t1("../../lib/svg_text_utils"), d = t1("../../plots/cartesian/axes"), m = t1("../../plots/cartesian/axis_defaults"), g = t1("../../plots/cartesian/position_defaults"), v = t1("../../plots/cartesian/layout_attributes"), y = t1("../../components/color"), x = {
                    left: "start",
                    center: "middle",
                    right: "end"
                }, b = {
                    left: 0,
                    center: .5,
                    right: 1
                }, _ = /[yzafpn\xb5mkMGTPEZY]/;
                function w(t1) {
                    return t1 && t1.duration > 0;
                }
                function T(t1) {
                    t1.each(function(t1) {
                        y.stroke(n.select(this), t1.line.color);
                    }).each(function(t1) {
                        y.fill(n.select(this), t1.color);
                    }).style("stroke-width", function(t1) {
                        return t1.line.width;
                    });
                }
                function k(t1, e1, r) {
                    var n = t1._fullLayout, i = o.extendFlat({
                        type: "linear",
                        ticks: "outside",
                        range: r,
                        showline: !0
                    }, e1), a = {
                        type: "linear",
                        _id: "x" + e1._id
                    }, s = {
                        letter: "x",
                        font: n.font,
                        noHover: !0,
                        noTickson: !0
                    };
                    function l(t1, e1) {
                        return o.coerce(i, a, v, t1, e1);
                    }
                    return m(i, a, l, s, n), g(i, a, l, s), a;
                }
                function A(t1, e1, r) {
                    return [
                        Math.min(e1 / t1.width, r / t1.height),
                        t1,
                        e1 + "x" + r
                    ];
                }
                function M(t1, e1, r, i) {
                    var a = document.createElementNS("http://www.w3.org/2000/svg", "text"), o = n.select(a);
                    return o.text(t1).attr("x", 0).attr("y", 0).attr("text-anchor", r).attr("data-unformatted", t1).call(p.convertToTspans, i).call(f.font, e1), f.bBox(o.node());
                }
                function S(t1, e1, r, n, i, a) {
                    var s = "_cache" + e1;
                    t1[s] && t1[s].key === i || (t1[s] = {
                        key: i,
                        value: r
                    });
                    var l = o.aggNums(a, null, [
                        t1[s].value,
                        n
                    ], 2);
                    return t1[s].value = l, l;
                }
                e1.exports = function(t1, e1, r, m) {
                    var g, v = t1._fullLayout;
                    w(r) && m && (g = m()), o.makeTraceGroups(v._indicatorlayer, e1, "trace").each(function(e1) {
                        var m, E, L, C, P, I = e1[0].trace, O = n.select(this), z = I._hasGauge, D = I._isAngular, R = I._isBullet, F = I.domain, B = {
                            w: v._size.w * (F.x[1] - F.x[0]),
                            h: v._size.h * (F.y[1] - F.y[0]),
                            l: v._size.l + v._size.w * F.x[0],
                            r: v._size.r + v._size.w * (1 - F.x[1]),
                            t: v._size.t + v._size.h * (1 - F.y[1]),
                            b: v._size.b + v._size.h * F.y[0]
                        }, N = B.l + B.w / 2, j = B.t + B.h / 2, U = Math.min(B.w / 2, B.h), V = h.innerRadius * U, H = I.align || "center";
                        if (E = j, z) {
                            if (D && (m = N, E = j + U / 2, L = function(t1) {
                                return function(t1, e1) {
                                    var r = Math.sqrt(t1.width / 2 * (t1.width / 2) + t1.height * t1.height);
                                    return [
                                        e1 / r,
                                        t1,
                                        e1
                                    ];
                                }(t1, .9 * V);
                            }), R) {
                                var q = h.bulletPadding, G = 1 - h.bulletNumberDomainSize + q;
                                m = B.l + (G + (1 - G) * b[H]) * B.w, L = function(t1) {
                                    return A(t1, (h.bulletNumberDomainSize - q) * B.w, B.h);
                                };
                            }
                        } else m = B.l + b[H] * B.w, L = function(t1) {
                            return A(t1, B.w, B.h);
                        };
                        !function(t1, e1, r, i) {
                            var c, u, h, m = r[0].trace, g = i.numbersX, v = i.numbersY, T = m.align || "center", A = x[T], E = i.transitionOpts, L = i.onComplete, C = o.ensureSingle(e1, "g", "numbers"), P = [];
                            m._hasNumber && P.push("number");
                            m._hasDelta && (P.push("delta"), "left" === m.delta.position && P.reverse());
                            var I = C.selectAll("text").data(P);
                            function O(e1, r, n, i) {
                                if (!e1.match("s") || n >= 0 == i >= 0 || r(n).slice(-1).match(_) || r(i).slice(-1).match(_)) return r;
                                var a = e1.slice().replace("s", "f").replace(/\d+/, function(t1) {
                                    return parseInt(t1) - 1;
                                }), o = k(t1, {
                                    tickformat: a
                                });
                                return function(t1) {
                                    return Math.abs(t1) < 1 ? d.tickText(o, t1).text : r(t1);
                                };
                            }
                            I.enter().append("text"), I.attr("text-anchor", function() {
                                return A;
                            }).attr("class", function(t1) {
                                return t1;
                            }).attr("x", null).attr("y", null).attr("dx", null).attr("dy", null), I.exit().remove();
                            var z, D = m.mode + m.align;
                            m._hasDelta && (z = function() {
                                var e1 = k(t1, {
                                    tickformat: m.delta.valueformat
                                }, m._range);
                                e1.setScale(), d.prepTicks(e1);
                                var i = function(t1) {
                                    return d.tickText(e1, t1).text;
                                }, o = function(t1) {
                                    return m.delta.relative ? t1.relativeDelta : t1.delta;
                                }, s = function(t1, e1) {
                                    return 0 === t1 || "number" != typeof t1 || isNaN(t1) ? "-" : (t1 > 0 ? m.delta.increasing.symbol : m.delta.decreasing.symbol) + e1(t1);
                                }, l = function(t1) {
                                    return t1.delta >= 0 ? m.delta.increasing.color : m.delta.decreasing.color;
                                };
                                void 0 === m._deltaLastValue && (m._deltaLastValue = o(r[0]));
                                var c = C.select("text.delta");
                                function h() {
                                    c.text(s(o(r[0]), i)).call(y.fill, l(r[0])).call(p.convertToTspans, t1);
                                }
                                return c.call(f.font, m.delta.font).call(y.fill, l({
                                    delta: m._deltaLastValue
                                })), w(E) ? c.transition().duration(E.duration).ease(E.easing).tween("text", function() {
                                    var t1 = n.select(this), e1 = o(r[0]), c = m._deltaLastValue, u = O(m.delta.valueformat, i, c, e1), f = a(c, e1);
                                    return m._deltaLastValue = e1, function(e1) {
                                        t1.text(s(f(e1), u)), t1.call(y.fill, l({
                                            delta: f(e1)
                                        }));
                                    };
                                }).each("end", function() {
                                    h(), L && L();
                                }).each("interrupt", function() {
                                    h(), L && L();
                                }) : h(), u = M(s(o(r[0]), i), m.delta.font, A, t1), c;
                            }(), D += m.delta.position + m.delta.font.size + m.delta.font.family + m.delta.valueformat, D += m.delta.increasing.symbol + m.delta.decreasing.symbol, h = u);
                            m._hasNumber && (!function() {
                                var e1 = k(t1, {
                                    tickformat: m.number.valueformat
                                }, m._range);
                                e1.setScale(), d.prepTicks(e1);
                                var i = function(t1) {
                                    return d.tickText(e1, t1).text;
                                }, o = m.number.suffix, s = m.number.prefix, l = C.select("text.number");
                                function u() {
                                    var e1 = "number" == typeof r[0].y ? s + i(r[0].y) + o : "-";
                                    l.text(e1).call(f.font, m.number.font).call(p.convertToTspans, t1);
                                }
                                w(E) ? l.transition().duration(E.duration).ease(E.easing).each("end", function() {
                                    u(), L && L();
                                }).each("interrupt", function() {
                                    u(), L && L();
                                }).attrTween("text", function() {
                                    var t1 = n.select(this), e1 = a(r[0].lastY, r[0].y);
                                    m._lastValue = r[0].y;
                                    var l = O(m.number.valueformat, i, r[0].lastY, r[0].y);
                                    return function(r) {
                                        t1.text(s + l(e1(r)) + o);
                                    };
                                }) : u(), c = M(s + i(r[0].y) + o, m.number.font, A, t1);
                            }(), D += m.number.font.size + m.number.font.family + m.number.valueformat + m.number.suffix + m.number.prefix, h = c);
                            if (m._hasDelta && m._hasNumber) {
                                var R, F, B = [
                                    (c.left + c.right) / 2,
                                    (c.top + c.bottom) / 2
                                ], N = [
                                    (u.left + u.right) / 2,
                                    (u.top + u.bottom) / 2
                                ], j = .75 * m.delta.font.size;
                                "left" === m.delta.position && (R = S(m, "deltaPos", 0, -1 * (c.width * b[m.align] + u.width * (1 - b[m.align]) + j), D, Math.min), F = B[1] - N[1], h = {
                                    width: c.width + u.width + j,
                                    height: Math.max(c.height, u.height),
                                    left: u.left + R,
                                    right: c.right,
                                    top: Math.min(c.top, u.top + F),
                                    bottom: Math.max(c.bottom, u.bottom + F)
                                }), "right" === m.delta.position && (R = S(m, "deltaPos", 0, c.width * (1 - b[m.align]) + u.width * b[m.align] + j, D, Math.max), F = B[1] - N[1], h = {
                                    width: c.width + u.width + j,
                                    height: Math.max(c.height, u.height),
                                    left: c.left,
                                    right: u.right + R,
                                    top: Math.min(c.top, u.top + F),
                                    bottom: Math.max(c.bottom, u.bottom + F)
                                }), "bottom" === m.delta.position && (R = null, F = u.height, h = {
                                    width: Math.max(c.width, u.width),
                                    height: c.height + u.height,
                                    left: Math.min(c.left, u.left),
                                    right: Math.max(c.right, u.right),
                                    top: c.bottom - c.height,
                                    bottom: c.bottom + u.height
                                }), "top" === m.delta.position && (R = null, F = c.top, h = {
                                    width: Math.max(c.width, u.width),
                                    height: c.height + u.height,
                                    left: Math.min(c.left, u.left),
                                    right: Math.max(c.right, u.right),
                                    top: c.bottom - c.height - u.height,
                                    bottom: c.bottom
                                }), z.attr({
                                    dx: R,
                                    dy: F
                                });
                            }
                            (m._hasNumber || m._hasDelta) && C.attr("transform", function() {
                                var t1 = i.numbersScaler(h);
                                D += t1[2];
                                var e1, r = S(m, "numbersScale", 1, t1[0], D, Math.min);
                                m._scaleNumbers || (r = 1), e1 = m._isAngular ? v - r * h.bottom : v - r * (h.top + h.bottom) / 2, m._numbersTop = r * h.top + e1;
                                var n = h[T];
                                "center" === T && (n = (h.left + h.right) / 2);
                                var a = g - r * n;
                                return a = S(m, "numbersTranslate", 0, a, D, Math.max), l(a, e1) + s(r);
                            });
                        }(t1, O, e1, {
                            numbersX: m,
                            numbersY: E,
                            numbersScaler: L,
                            transitionOpts: r,
                            onComplete: g
                        }), z && (C = {
                            range: I.gauge.axis.range,
                            color: I.gauge.bgcolor,
                            line: {
                                color: I.gauge.bordercolor,
                                width: 0
                            },
                            thickness: 1
                        }, P = {
                            range: I.gauge.axis.range,
                            color: "rgba(0, 0, 0, 0)",
                            line: {
                                color: I.gauge.bordercolor,
                                width: I.gauge.borderwidth
                            },
                            thickness: 1
                        });
                        var Y = O.selectAll("g.angular").data(D ? e1 : []);
                        Y.exit().remove();
                        var W = O.selectAll("g.angularaxis").data(D ? e1 : []);
                        W.exit().remove(), D && function(t1, e1, r, a) {
                            var o, s, f, h, p = r[0].trace, m = a.size, g = a.radius, v = a.innerRadius, y = a.gaugeBg, x = a.gaugeOutline, b = [
                                m.l + m.w / 2,
                                m.t + m.h / 2 + g / 2
                            ], _ = a.gauge, A = a.layer, M = a.transitionOpts, S = a.onComplete, E = Math.PI / 2;
                            function L(t1) {
                                var e1 = p.gauge.axis.range[0], r = (t1 - e1) / (p.gauge.axis.range[1] - e1) * Math.PI - E;
                                return r < -E ? -E : r > E ? E : r;
                            }
                            function C(t1) {
                                return n.svg.arc().innerRadius((v + g) / 2 - t1 / 2 * (g - v)).outerRadius((v + g) / 2 + t1 / 2 * (g - v)).startAngle(-E);
                            }
                            function P(t1) {
                                t1.attr("d", function(t1) {
                                    return C(t1.thickness).startAngle(L(t1.range[0])).endAngle(L(t1.range[1]))();
                                });
                            }
                            _.enter().append("g").classed("angular", !0), _.attr("transform", l(b[0], b[1])), A.enter().append("g").classed("angularaxis", !0).classed("crisp", !0), A.selectAll("g.xangularaxistick,path,text").remove(), (o = k(t1, p.gauge.axis)).type = "linear", o.range = p.gauge.axis.range, o._id = "xangularaxis", o.ticklabeloverflow = "allow", o.setScale();
                            var I = function(t1) {
                                return (o.range[0] - t1.x) / (o.range[1] - o.range[0]) * Math.PI + Math.PI;
                            }, O = {}, z = d.makeLabelFns(o, 0).labelStandoff;
                            O.xFn = function(t1) {
                                var e1 = I(t1);
                                return Math.cos(e1) * z;
                            }, O.yFn = function(t1) {
                                var e1 = I(t1), r = Math.sin(e1) > 0 ? .2 : 1;
                                return -Math.sin(e1) * (z + t1.fontSize * r) + Math.abs(Math.cos(e1)) * (t1.fontSize * u);
                            }, O.anchorFn = function(t1) {
                                var e1 = I(t1), r = Math.cos(e1);
                                return Math.abs(r) < .1 ? "middle" : r > 0 ? "start" : "end";
                            }, O.heightFn = function(t1, e1, r) {
                                var n = I(t1);
                                return -0.5 * (1 + Math.sin(n)) * r;
                            };
                            var D = function(t1) {
                                return l(b[0] + g * Math.cos(t1), b[1] - g * Math.sin(t1));
                            };
                            f = function(t1) {
                                return D(I(t1));
                            };
                            if (s = d.calcTicks(o), h = d.getTickSigns(o)[2], o.visible) {
                                h = "inside" === o.ticks ? -1 : 1;
                                var R = (o.linewidth || 1) / 2;
                                d.drawTicks(t1, o, {
                                    vals: s,
                                    layer: A,
                                    path: "M" + h * R + ",0h" + h * o.ticklen,
                                    transFn: function(t1) {
                                        var e1 = I(t1);
                                        return D(e1) + "rotate(" + -c(e1) + ")";
                                    }
                                }), d.drawLabels(t1, o, {
                                    vals: s,
                                    layer: A,
                                    transFn: f,
                                    labelFns: O
                                });
                            }
                            var F = [
                                y
                            ].concat(p.gauge.steps), B = _.selectAll("g.bg-arc").data(F);
                            B.enter().append("g").classed("bg-arc", !0).append("path"), B.select("path").call(P).call(T), B.exit().remove();
                            var N = C(p.gauge.bar.thickness), j = _.selectAll("g.value-arc").data([
                                p.gauge.bar
                            ]);
                            j.enter().append("g").classed("value-arc", !0).append("path");
                            var U = j.select("path");
                            w(M) ? (U.transition().duration(M.duration).ease(M.easing).each("end", function() {
                                S && S();
                            }).each("interrupt", function() {
                                S && S();
                            }).attrTween("d", (V = N, H = L(r[0].lastY), q = L(r[0].y), function() {
                                var t1 = i(H, q);
                                return function(e1) {
                                    return V.endAngle(t1(e1))();
                                };
                            })), p._lastValue = r[0].y) : U.attr("d", "number" == typeof r[0].y ? N.endAngle(L(r[0].y)) : "M0,0Z");
                            var V, H, q;
                            U.call(T), j.exit().remove(), F = [];
                            var G = p.gauge.threshold.value;
                            (G || 0 === G) && F.push({
                                range: [
                                    G,
                                    G
                                ],
                                color: p.gauge.threshold.color,
                                line: {
                                    color: p.gauge.threshold.line.color,
                                    width: p.gauge.threshold.line.width
                                },
                                thickness: p.gauge.threshold.thickness
                            });
                            var Y = _.selectAll("g.threshold-arc").data(F);
                            Y.enter().append("g").classed("threshold-arc", !0).append("path"), Y.select("path").call(P).call(T), Y.exit().remove();
                            var W = _.selectAll("g.gauge-outline").data([
                                x
                            ]);
                            W.enter().append("g").classed("gauge-outline", !0).append("path"), W.select("path").call(P).call(T), W.exit().remove();
                        }(t1, 0, e1, {
                            radius: U,
                            innerRadius: V,
                            gauge: Y,
                            layer: W,
                            size: B,
                            gaugeBg: C,
                            gaugeOutline: P,
                            transitionOpts: r,
                            onComplete: g
                        });
                        var X = O.selectAll("g.bullet").data(R ? e1 : []);
                        X.exit().remove();
                        var Z = O.selectAll("g.bulletaxis").data(R ? e1 : []);
                        Z.exit().remove(), R && function(t1, e1, r, n) {
                            var i, a, o, s, c, u = r[0].trace, f = n.gauge, p = n.layer, m = n.gaugeBg, g = n.gaugeOutline, v = n.size, x = u.domain, b = n.transitionOpts, _ = n.onComplete;
                            f.enter().append("g").classed("bullet", !0), f.attr("transform", l(v.l, v.t)), p.enter().append("g").classed("bulletaxis", !0).classed("crisp", !0), p.selectAll("g.xbulletaxistick,path,text").remove();
                            var A = v.h, M = u.gauge.bar.thickness * A, S = x.x[0], E = x.x[0] + (x.x[1] - x.x[0]) * (u._hasNumber || u._hasDelta ? 1 - h.bulletNumberDomainSize : 1);
                            (i = k(t1, u.gauge.axis))._id = "xbulletaxis", i.domain = [
                                S,
                                E
                            ], i.setScale(), a = d.calcTicks(i), o = d.makeTransTickFn(i), s = d.getTickSigns(i)[2], c = v.t + v.h, i.visible && (d.drawTicks(t1, i, {
                                vals: "inside" === i.ticks ? d.clipEnds(i, a) : a,
                                layer: p,
                                path: d.makeTickPath(i, c, s),
                                transFn: o
                            }), d.drawLabels(t1, i, {
                                vals: a,
                                layer: p,
                                transFn: o,
                                labelFns: d.makeLabelFns(i, c)
                            }));
                            function L(t1) {
                                t1.attr("width", function(t1) {
                                    return Math.max(0, i.c2p(t1.range[1]) - i.c2p(t1.range[0]));
                                }).attr("x", function(t1) {
                                    return i.c2p(t1.range[0]);
                                }).attr("y", function(t1) {
                                    return .5 * (1 - t1.thickness) * A;
                                }).attr("height", function(t1) {
                                    return t1.thickness * A;
                                });
                            }
                            var C = [
                                m
                            ].concat(u.gauge.steps), P = f.selectAll("g.bg-bullet").data(C);
                            P.enter().append("g").classed("bg-bullet", !0).append("rect"), P.select("rect").call(L).call(T), P.exit().remove();
                            var I = f.selectAll("g.value-bullet").data([
                                u.gauge.bar
                            ]);
                            I.enter().append("g").classed("value-bullet", !0).append("rect"), I.select("rect").attr("height", M).attr("y", (A - M) / 2).call(T), w(b) ? I.select("rect").transition().duration(b.duration).ease(b.easing).each("end", function() {
                                _ && _();
                            }).each("interrupt", function() {
                                _ && _();
                            }).attr("width", Math.max(0, i.c2p(Math.min(u.gauge.axis.range[1], r[0].y)))) : I.select("rect").attr("width", "number" == typeof r[0].y ? Math.max(0, i.c2p(Math.min(u.gauge.axis.range[1], r[0].y))) : 0);
                            I.exit().remove();
                            var O = r.filter(function() {
                                return u.gauge.threshold.value || 0 === u.gauge.threshold.value;
                            }), z = f.selectAll("g.threshold-bullet").data(O);
                            z.enter().append("g").classed("threshold-bullet", !0).append("line"), z.select("line").attr("x1", i.c2p(u.gauge.threshold.value)).attr("x2", i.c2p(u.gauge.threshold.value)).attr("y1", (1 - u.gauge.threshold.thickness) / 2 * A).attr("y2", (1 - (1 - u.gauge.threshold.thickness) / 2) * A).call(y.stroke, u.gauge.threshold.line.color).style("stroke-width", u.gauge.threshold.line.width), z.exit().remove();
                            var D = f.selectAll("g.gauge-outline").data([
                                g
                            ]);
                            D.enter().append("g").classed("gauge-outline", !0).append("rect"), D.select("rect").call(L).call(T), D.exit().remove();
                        }(t1, 0, e1, {
                            gauge: X,
                            layer: Z,
                            size: B,
                            gaugeBg: C,
                            gaugeOutline: P,
                            transitionOpts: r,
                            onComplete: g
                        });
                        var J = O.selectAll("text.title").data(e1);
                        J.exit().remove(), J.enter().append("text").classed("title", !0), J.attr("text-anchor", function() {
                            return R ? x.right : x[I.title.align];
                        }).text(I.title.text).call(f.font, I.title.font).call(p.convertToTspans, t1), J.attr("transform", function() {
                            var t1, e1 = B.l + B.w * b[I.title.align], r = h.titlePadding, n = f.bBox(J.node());
                            if (z) {
                                if (D) {
                                    if (I.gauge.axis.visible) t1 = f.bBox(W.node()).top - r - n.bottom;
                                    else t1 = B.t + B.h / 2 - U / 2 - n.bottom - r;
                                }
                                R && (t1 = E - (n.top + n.bottom) / 2, e1 = B.l - h.bulletPadding * B.w);
                            } else t1 = I._numbersTop - r - n.bottom;
                            return l(e1, t1);
                        });
                    });
                };
            },
            {
                "../../components/color": 366,
                "../../components/drawing": 388,
                "../../constants/alignment": 471,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../plots/cartesian/axes": 554,
                "../../plots/cartesian/axis_defaults": 556,
                "../../plots/cartesian/layout_attributes": 569,
                "../../plots/cartesian/position_defaults": 572,
                "./constants": 858,
                "@plotly/d3": 58,
                "d3-interpolate": 116
            }
        ],
        862: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/attributes"), i = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, a = t1("../../plots/template_attributes").hovertemplateAttrs, o = t1("../mesh3d/attributes"), s = t1("../../plots/attributes"), l = t1("../../lib/extend").extendFlat, c = t1("../../plot_api/edit_types").overrideAll;
                var u = e1.exports = c(l({
                    x: {
                        valType: "data_array"
                    },
                    y: {
                        valType: "data_array"
                    },
                    z: {
                        valType: "data_array"
                    },
                    value: {
                        valType: "data_array"
                    },
                    isomin: {
                        valType: "number"
                    },
                    isomax: {
                        valType: "number"
                    },
                    surface: {
                        show: {
                            valType: "boolean",
                            dflt: !0
                        },
                        count: {
                            valType: "integer",
                            dflt: 2,
                            min: 1
                        },
                        fill: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1
                        },
                        pattern: {
                            valType: "flaglist",
                            flags: [
                                "A",
                                "B",
                                "C",
                                "D",
                                "E"
                            ],
                            extras: [
                                "all",
                                "odd",
                                "even"
                            ],
                            dflt: "all"
                        }
                    },
                    spaceframe: {
                        show: {
                            valType: "boolean",
                            dflt: !1
                        },
                        fill: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .15
                        }
                    },
                    slices: {
                        x: {
                            show: {
                                valType: "boolean",
                                dflt: !1
                            },
                            locations: {
                                valType: "data_array",
                                dflt: []
                            },
                            fill: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            }
                        },
                        y: {
                            show: {
                                valType: "boolean",
                                dflt: !1
                            },
                            locations: {
                                valType: "data_array",
                                dflt: []
                            },
                            fill: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            }
                        },
                        z: {
                            show: {
                                valType: "boolean",
                                dflt: !1
                            },
                            locations: {
                                valType: "data_array",
                                dflt: []
                            },
                            fill: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            }
                        }
                    },
                    caps: {
                        x: {
                            show: {
                                valType: "boolean",
                                dflt: !0
                            },
                            fill: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            }
                        },
                        y: {
                            show: {
                                valType: "boolean",
                                dflt: !0
                            },
                            fill: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            }
                        },
                        z: {
                            show: {
                                valType: "boolean",
                                dflt: !0
                            },
                            fill: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            }
                        }
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0
                    },
                    hovertemplate: a(),
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    zhoverformat: i("z"),
                    valuehoverformat: i("value", 1),
                    showlegend: l({}, s.showlegend, {
                        dflt: !1
                    })
                }, n("", {
                    colorAttr: "`value`",
                    showScaleDflt: !0,
                    editTypeOverride: "calc"
                }), {
                    opacity: o.opacity,
                    lightposition: o.lightposition,
                    lighting: o.lighting,
                    flatshading: o.flatshading,
                    contour: o.contour,
                    hoverinfo: l({}, s.hoverinfo)
                }), "calc", "nested");
                u.flatshading.dflt = !0, u.lighting.facenormalsepsilon.dflt = 0, u.x.editType = u.y.editType = u.z.editType = u.value.editType = "calc+clearAxisTypes", u.transforms = void 0;
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../../plots/attributes": 550,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/template_attributes": 633,
                "../mesh3d/attributes": 867
            }
        ],
        863: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/calc"), i = t1("../streamtube/calc").processGrid, a = t1("../streamtube/calc").filter;
                e1.exports = function(t1, e1) {
                    e1._len = Math.min(e1.x.length, e1.y.length, e1.z.length, e1.value.length), e1._x = a(e1.x, e1._len), e1._y = a(e1.y, e1._len), e1._z = a(e1.z, e1._len), e1._value = a(e1.value, e1._len);
                    var r = i(e1);
                    e1._gridFill = r.fill, e1._Xs = r.Xs, e1._Ys = r.Ys, e1._Zs = r.Zs, e1._len = r.len;
                    for(var o = 1 / 0, s = -1 / 0, l = 0; l < e1._len; l++){
                        var c = e1._value[l];
                        o = Math.min(o, c), s = Math.max(s, c);
                    }
                    e1._minValues = o, e1._maxValues = s, e1._vMin = void 0 === e1.isomin || null === e1.isomin ? o : e1.isomin, e1._vMax = void 0 === e1.isomax || null === e1.isomin ? s : e1.isomax, n(t1, e1, {
                        vals: [
                            e1._vMin,
                            e1._vMax
                        ],
                        containerStr: "",
                        cLetter: "c"
                    });
                };
            },
            {
                "../../components/colorscale/calc": 374,
                "../streamtube/calc": 1041
            }
        ],
        864: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../stackgl_modules").gl_mesh3d, i = t1("../../lib/gl_format_color").parseColorScale, a = t1("../../lib/str2rgbarray"), o = t1("../../components/colorscale").extractOpts, s = t1("../../plots/gl3d/zip3"), l = function(t1, e1) {
                    for(var r = e1.length - 1; r > 0; r--){
                        var n = Math.min(e1[r], e1[r - 1]), i = Math.max(e1[r], e1[r - 1]);
                        if (i > n && n < t1 && t1 <= i) return {
                            id: r,
                            distRatio: (i - t1) / (i - n)
                        };
                    }
                    return {
                        id: 0,
                        distRatio: 0
                    };
                };
                function c(t1, e1, r) {
                    this.scene = t1, this.uid = r, this.mesh = e1, this.name = "", this.data = null, this.showContour = !1;
                }
                var u = c.prototype;
                u.handlePick = function(t1) {
                    if (t1.object === this.mesh) {
                        var e1 = t1.data.index, r = this.data._meshX[e1], n = this.data._meshY[e1], i = this.data._meshZ[e1], a = this.data._Ys.length, o = this.data._Zs.length, s = l(r, this.data._Xs).id, c = l(n, this.data._Ys).id, u = l(i, this.data._Zs).id, f = t1.index = u + o * c + o * a * s;
                        t1.traceCoordinate = [
                            this.data._meshX[f],
                            this.data._meshY[f],
                            this.data._meshZ[f],
                            this.data._value[f]
                        ];
                        var h = this.data.hovertext || this.data.text;
                        return Array.isArray(h) && void 0 !== h[f] ? t1.textLabel = h[f] : h && (t1.textLabel = h), !0;
                    }
                }, u.update = function(t1) {
                    var e1 = this.scene, r = e1.fullSceneLayout;
                    function n(t1, e1, r, n) {
                        return e1.map(function(e1) {
                            return t1.d2l(e1, 0, n) * r;
                        });
                    }
                    this.data = h(t1);
                    var l = {
                        positions: s(n(r.xaxis, t1._meshX, e1.dataScale[0], t1.xcalendar), n(r.yaxis, t1._meshY, e1.dataScale[1], t1.ycalendar), n(r.zaxis, t1._meshZ, e1.dataScale[2], t1.zcalendar)),
                        cells: s(t1._meshI, t1._meshJ, t1._meshK),
                        lightPosition: [
                            t1.lightposition.x,
                            t1.lightposition.y,
                            t1.lightposition.z
                        ],
                        ambient: t1.lighting.ambient,
                        diffuse: t1.lighting.diffuse,
                        specular: t1.lighting.specular,
                        roughness: t1.lighting.roughness,
                        fresnel: t1.lighting.fresnel,
                        vertexNormalsEpsilon: t1.lighting.vertexnormalsepsilon,
                        faceNormalsEpsilon: t1.lighting.facenormalsepsilon,
                        opacity: t1.opacity,
                        contourEnable: t1.contour.show,
                        contourColor: a(t1.contour.color).slice(0, 3),
                        contourWidth: t1.contour.width,
                        useFacetNormals: t1.flatshading
                    }, c = o(t1);
                    l.vertexIntensity = t1._meshIntensity, l.vertexIntensityBounds = [
                        c.min,
                        c.max
                    ], l.colormap = i(t1), this.mesh.update(l);
                }, u.dispose = function() {
                    this.scene.glplot.remove(this.mesh), this.mesh.dispose();
                };
                var f = [
                    "xyz",
                    "xzy",
                    "yxz",
                    "yzx",
                    "zxy",
                    "zyx"
                ];
                function h(t1) {
                    t1._meshI = [], t1._meshJ = [], t1._meshK = [];
                    var e1, r, n, i, a, o, s, c = t1.surface.show, u = t1.spaceframe.show, h = t1.surface.fill, p = t1.spaceframe.fill, d = !1, m = !1, g = 0, v = t1._Xs, y = t1._Ys, x = t1._Zs, b = v.length, _ = y.length, w = x.length, T = f.indexOf(t1._gridFill.replace(/-/g, "").replace(/\+/g, "")), k = function(t1, e1, r) {
                        switch(T){
                            case 5:
                                return r + w * e1 + w * _ * t1;
                            case 4:
                                return r + w * t1 + w * b * e1;
                            case 3:
                                return e1 + _ * r + _ * w * t1;
                            case 2:
                                return e1 + _ * t1 + _ * b * r;
                            case 1:
                                return t1 + b * r + b * w * e1;
                            default:
                                return t1 + b * e1 + b * _ * r;
                        }
                    }, A = t1._minValues, M = t1._maxValues, S = t1._vMin, E = t1._vMax;
                    function L(t1, e1, s) {
                        for(var l = o.length, c = r; c < l; c++)if (t1 === n[c] && e1 === i[c] && s === a[c]) return c;
                        return -1;
                    }
                    function C() {
                        r = e1;
                    }
                    function P() {
                        n = [], i = [], a = [], o = [], e1 = 0, C();
                    }
                    function I(t1, r, s, l) {
                        return n.push(t1), i.push(r), a.push(s), o.push(l), ++e1 - 1;
                    }
                    function O(t1, e1, r) {
                        for(var n = [], i = 0; i < t1.length; i++)n[i] = t1[i] * (1 - r) + r * e1[i];
                        return n;
                    }
                    function z(t1) {
                        s = t1;
                    }
                    function D(t1, e1) {
                        return "all" === t1 || null === t1 || t1.indexOf(e1) > -1;
                    }
                    function R(t1, e1) {
                        return null === t1 ? e1 : t1;
                    }
                    function F(e1, r, n) {
                        C();
                        var i, a, o, l = [
                            r
                        ], c = [
                            n
                        ];
                        if (s >= 1) l = [
                            r
                        ], c = [
                            n
                        ];
                        else if (s > 0) {
                            var u = function(t1, e1) {
                                var r = t1[0], n = t1[1], i = t1[2], a = function(t1, e1, r) {
                                    for(var n = [], i = 0; i < t1.length; i++)n[i] = (t1[i] + e1[i] + r[i]) / 3;
                                    return n;
                                }(r, n, i), o = Math.sqrt(1 - s), l = O(a, r, o), c = O(a, n, o), u = O(a, i, o), f = e1[0], h = e1[1], p = e1[2];
                                return {
                                    xyzv: [
                                        [
                                            r,
                                            n,
                                            c
                                        ],
                                        [
                                            c,
                                            l,
                                            r
                                        ],
                                        [
                                            n,
                                            i,
                                            u
                                        ],
                                        [
                                            u,
                                            c,
                                            n
                                        ],
                                        [
                                            i,
                                            r,
                                            l
                                        ],
                                        [
                                            l,
                                            u,
                                            i
                                        ]
                                    ],
                                    abc: [
                                        [
                                            f,
                                            h,
                                            -1
                                        ],
                                        [
                                            -1,
                                            -1,
                                            f
                                        ],
                                        [
                                            h,
                                            p,
                                            -1
                                        ],
                                        [
                                            -1,
                                            -1,
                                            h
                                        ],
                                        [
                                            p,
                                            f,
                                            -1
                                        ],
                                        [
                                            -1,
                                            -1,
                                            p
                                        ]
                                    ]
                                };
                            }(r, n);
                            l = u.xyzv, c = u.abc;
                        }
                        for(var f = 0; f < l.length; f++){
                            r = l[f], n = c[f];
                            for(var h = [], p = 0; p < 3; p++){
                                var d = r[p][0], m = r[p][1], v = r[p][2], y = r[p][3], x = n[p] > -1 ? n[p] : L(d, m, v);
                                h[p] = x > -1 ? x : I(d, m, v, R(e1, y));
                            }
                            i = h[0], a = h[1], o = h[2], t1._meshI.push(i), t1._meshJ.push(a), t1._meshK.push(o), ++g;
                        }
                    }
                    function B(t1, e1, r, n) {
                        var i = t1[3];
                        i < r && (i = r), i > n && (i = n);
                        for(var a = (t1[3] - i) / (t1[3] - e1[3] + 1e-9), o = [], s = 0; s < 4; s++)o[s] = (1 - a) * t1[s] + a * e1[s];
                        return o;
                    }
                    function N(t1, e1, r) {
                        return t1 >= e1 && t1 <= r;
                    }
                    function j(t1) {
                        var e1 = .001 * (E - S);
                        return t1 >= S - e1 && t1 <= E + e1;
                    }
                    function U(e1) {
                        for(var r = [], n = 0; n < 4; n++){
                            var i = e1[n];
                            r.push([
                                t1._x[i],
                                t1._y[i],
                                t1._z[i],
                                t1._value[i]
                            ]);
                        }
                        return r;
                    }
                    function V(t1, e1, r, n, i, a) {
                        a || (a = 1), r = [
                            -1,
                            -1,
                            -1
                        ];
                        var o = !1, s = [
                            N(e1[0][3], n, i),
                            N(e1[1][3], n, i),
                            N(e1[2][3], n, i)
                        ];
                        if (!s[0] && !s[1] && !s[2]) return !1;
                        var l = function(t1, e1, r) {
                            return j(e1[0][3]) && j(e1[1][3]) && j(e1[2][3]) ? (F(t1, e1, r), !0) : a < 3 && V(t1, e1, r, S, E, ++a);
                        };
                        if (s[0] && s[1] && s[2]) return l(t1, e1, r) || o;
                        var c = !1;
                        return [
                            [
                                0,
                                1,
                                2
                            ],
                            [
                                2,
                                0,
                                1
                            ],
                            [
                                1,
                                2,
                                0
                            ]
                        ].forEach(function(a) {
                            if (s[a[0]] && s[a[1]] && !s[a[2]]) {
                                var u = e1[a[0]], f = e1[a[1]], h = e1[a[2]], p = B(h, u, n, i), d = B(h, f, n, i);
                                o = l(t1, [
                                    d,
                                    p,
                                    u
                                ], [
                                    -1,
                                    -1,
                                    r[a[0]]
                                ]) || o, o = l(t1, [
                                    u,
                                    f,
                                    d
                                ], [
                                    r[a[0]],
                                    r[a[1]],
                                    -1
                                ]) || o, c = !0;
                            }
                        }), c || [
                            [
                                0,
                                1,
                                2
                            ],
                            [
                                1,
                                2,
                                0
                            ],
                            [
                                2,
                                0,
                                1
                            ]
                        ].forEach(function(a) {
                            if (s[a[0]] && !s[a[1]] && !s[a[2]]) {
                                var u = e1[a[0]], f = e1[a[1]], h = e1[a[2]], p = B(f, u, n, i), d = B(h, u, n, i);
                                o = l(t1, [
                                    d,
                                    p,
                                    u
                                ], [
                                    -1,
                                    -1,
                                    r[a[0]]
                                ]) || o, c = !0;
                            }
                        }), o;
                    }
                    function H(t1, e1, r, n) {
                        var i = !1, a = U(e1), o = [
                            N(a[0][3], r, n),
                            N(a[1][3], r, n),
                            N(a[2][3], r, n),
                            N(a[3][3], r, n)
                        ];
                        if (!(o[0] || o[1] || o[2] || o[3])) return i;
                        if (o[0] && o[1] && o[2] && o[3]) return m && (i = function(t1, e1, r) {
                            var n = function(n, i, a) {
                                F(t1, [
                                    e1[n],
                                    e1[i],
                                    e1[a]
                                ], [
                                    r[n],
                                    r[i],
                                    r[a]
                                ]);
                            };
                            n(0, 1, 2), n(3, 0, 1), n(2, 3, 0), n(1, 2, 3);
                        }(t1, a, e1) || i), i;
                        var s = !1;
                        return [
                            [
                                0,
                                1,
                                2,
                                3
                            ],
                            [
                                3,
                                0,
                                1,
                                2
                            ],
                            [
                                2,
                                3,
                                0,
                                1
                            ],
                            [
                                1,
                                2,
                                3,
                                0
                            ]
                        ].forEach(function(l) {
                            if (o[l[0]] && o[l[1]] && o[l[2]] && !o[l[3]]) {
                                var c = a[l[0]], u = a[l[1]], f = a[l[2]], h = a[l[3]];
                                if (m) i = F(t1, [
                                    c,
                                    u,
                                    f
                                ], [
                                    e1[l[0]],
                                    e1[l[1]],
                                    e1[l[2]]
                                ]) || i;
                                else {
                                    var p = B(h, c, r, n), d = B(h, u, r, n), g = B(h, f, r, n);
                                    i = F(null, [
                                        p,
                                        d,
                                        g
                                    ], [
                                        -1,
                                        -1,
                                        -1
                                    ]) || i;
                                }
                                s = !0;
                            }
                        }), s ? i : ([
                            [
                                0,
                                1,
                                2,
                                3
                            ],
                            [
                                1,
                                2,
                                3,
                                0
                            ],
                            [
                                2,
                                3,
                                0,
                                1
                            ],
                            [
                                3,
                                0,
                                1,
                                2
                            ],
                            [
                                0,
                                2,
                                3,
                                1
                            ],
                            [
                                1,
                                3,
                                2,
                                0
                            ]
                        ].forEach(function(l) {
                            if (o[l[0]] && o[l[1]] && !o[l[2]] && !o[l[3]]) {
                                var c = a[l[0]], u = a[l[1]], f = a[l[2]], h = a[l[3]], p = B(f, c, r, n), d = B(f, u, r, n), g = B(h, u, r, n), v = B(h, c, r, n);
                                m ? (i = F(t1, [
                                    c,
                                    v,
                                    p
                                ], [
                                    e1[l[0]],
                                    -1,
                                    -1
                                ]) || i, i = F(t1, [
                                    u,
                                    d,
                                    g
                                ], [
                                    e1[l[1]],
                                    -1,
                                    -1
                                ]) || i) : i = function(t1, e1, r) {
                                    var n = function(n, i, a) {
                                        F(t1, [
                                            e1[n],
                                            e1[i],
                                            e1[a]
                                        ], [
                                            r[n],
                                            r[i],
                                            r[a]
                                        ]);
                                    };
                                    n(0, 1, 2), n(2, 3, 0);
                                }(null, [
                                    p,
                                    d,
                                    g,
                                    v
                                ], [
                                    -1,
                                    -1,
                                    -1,
                                    -1
                                ]) || i, s = !0;
                            }
                        }), s || [
                            [
                                0,
                                1,
                                2,
                                3
                            ],
                            [
                                1,
                                2,
                                3,
                                0
                            ],
                            [
                                2,
                                3,
                                0,
                                1
                            ],
                            [
                                3,
                                0,
                                1,
                                2
                            ]
                        ].forEach(function(l) {
                            if (o[l[0]] && !o[l[1]] && !o[l[2]] && !o[l[3]]) {
                                var c = a[l[0]], u = a[l[1]], f = a[l[2]], h = a[l[3]], p = B(u, c, r, n), d = B(f, c, r, n), g = B(h, c, r, n);
                                m ? (i = F(t1, [
                                    c,
                                    p,
                                    d
                                ], [
                                    e1[l[0]],
                                    -1,
                                    -1
                                ]) || i, i = F(t1, [
                                    c,
                                    d,
                                    g
                                ], [
                                    e1[l[0]],
                                    -1,
                                    -1
                                ]) || i, i = F(t1, [
                                    c,
                                    g,
                                    p
                                ], [
                                    e1[l[0]],
                                    -1,
                                    -1
                                ]) || i) : i = F(null, [
                                    p,
                                    d,
                                    g
                                ], [
                                    -1,
                                    -1,
                                    -1
                                ]) || i, s = !0;
                            }
                        }), i);
                    }
                    function q(t1, e1, r, n, i, a, o, s, l, c, u) {
                        var f = !1;
                        return d && (D(t1, "A") && (f = H(null, [
                            e1,
                            r,
                            n,
                            a
                        ], c, u) || f), D(t1, "B") && (f = H(null, [
                            r,
                            n,
                            i,
                            l
                        ], c, u) || f), D(t1, "C") && (f = H(null, [
                            r,
                            a,
                            o,
                            l
                        ], c, u) || f), D(t1, "D") && (f = H(null, [
                            n,
                            a,
                            s,
                            l
                        ], c, u) || f), D(t1, "E") && (f = H(null, [
                            r,
                            n,
                            a,
                            l
                        ], c, u) || f)), m && (f = H(t1, [
                            r,
                            n,
                            a,
                            l
                        ], c, u) || f), f;
                    }
                    function G(t1, e1, r, n, i, a, o, s) {
                        return [
                            !0 === s[0] || V(t1, U([
                                e1,
                                r,
                                n
                            ]), [
                                e1,
                                r,
                                n
                            ], a, o),
                            !0 === s[1] || V(t1, U([
                                n,
                                i,
                                e1
                            ]), [
                                n,
                                i,
                                e1
                            ], a, o)
                        ];
                    }
                    function Y(t1, e1, r, n, i, a, o, s, l) {
                        return s ? G(t1, e1, r, i, n, a, o, l) : G(t1, r, i, n, e1, a, o, l);
                    }
                    function W(t1, e1, r, n, i, a, o) {
                        var s, l, c, u, f = !1, h = function() {
                            f = V(t1, [
                                s,
                                l,
                                c
                            ], [
                                -1,
                                -1,
                                -1
                            ], i, a) || f, f = V(t1, [
                                c,
                                u,
                                s
                            ], [
                                -1,
                                -1,
                                -1
                            ], i, a) || f;
                        }, p = o[0], d = o[1], m = o[2];
                        return p && (s = O(U([
                            k(e1, r - 0, n - 0)
                        ])[0], U([
                            k(e1 - 1, r - 0, n - 0)
                        ])[0], p), l = O(U([
                            k(e1, r - 0, n - 1)
                        ])[0], U([
                            k(e1 - 1, r - 0, n - 1)
                        ])[0], p), c = O(U([
                            k(e1, r - 1, n - 1)
                        ])[0], U([
                            k(e1 - 1, r - 1, n - 1)
                        ])[0], p), u = O(U([
                            k(e1, r - 1, n - 0)
                        ])[0], U([
                            k(e1 - 1, r - 1, n - 0)
                        ])[0], p), h()), d && (s = O(U([
                            k(e1 - 0, r, n - 0)
                        ])[0], U([
                            k(e1 - 0, r - 1, n - 0)
                        ])[0], d), l = O(U([
                            k(e1 - 0, r, n - 1)
                        ])[0], U([
                            k(e1 - 0, r - 1, n - 1)
                        ])[0], d), c = O(U([
                            k(e1 - 1, r, n - 1)
                        ])[0], U([
                            k(e1 - 1, r - 1, n - 1)
                        ])[0], d), u = O(U([
                            k(e1 - 1, r, n - 0)
                        ])[0], U([
                            k(e1 - 1, r - 1, n - 0)
                        ])[0], d), h()), m && (s = O(U([
                            k(e1 - 0, r - 0, n)
                        ])[0], U([
                            k(e1 - 0, r - 0, n - 1)
                        ])[0], m), l = O(U([
                            k(e1 - 0, r - 1, n)
                        ])[0], U([
                            k(e1 - 0, r - 1, n - 1)
                        ])[0], m), c = O(U([
                            k(e1 - 1, r - 1, n)
                        ])[0], U([
                            k(e1 - 1, r - 1, n - 1)
                        ])[0], m), u = O(U([
                            k(e1 - 1, r - 0, n)
                        ])[0], U([
                            k(e1 - 1, r - 0, n - 1)
                        ])[0], m), h()), f;
                    }
                    function X(t1, e1, r, n, i, a, o, s, l, c, u, f) {
                        var h = t1;
                        return f ? (d && "even" === t1 && (h = null), q(h, e1, r, n, i, a, o, s, l, c, u)) : (d && "odd" === t1 && (h = null), q(h, l, s, o, a, i, n, r, e1, c, u));
                    }
                    function Z(t1, e1, r, n, i) {
                        for(var a = [], o = 0, s = 0; s < e1.length; s++)for(var l = e1[s], c = 1; c < w; c++)for(var u = 1; u < _; u++)a.push(Y(t1, k(l, u - 1, c - 1), k(l, u - 1, c), k(l, u, c - 1), k(l, u, c), r, n, (l + u + c) % 2, i && i[o] ? i[o] : [])), o++;
                        return a;
                    }
                    function J(t1, e1, r, n, i) {
                        for(var a = [], o = 0, s = 0; s < e1.length; s++)for(var l = e1[s], c = 1; c < b; c++)for(var u = 1; u < w; u++)a.push(Y(t1, k(c - 1, l, u - 1), k(c, l, u - 1), k(c - 1, l, u), k(c, l, u), r, n, (c + l + u) % 2, i && i[o] ? i[o] : [])), o++;
                        return a;
                    }
                    function K(t1, e1, r, n, i) {
                        for(var a = [], o = 0, s = 0; s < e1.length; s++)for(var l = e1[s], c = 1; c < _; c++)for(var u = 1; u < b; u++)a.push(Y(t1, k(u - 1, c - 1, l), k(u - 1, c, l), k(u, c - 1, l), k(u, c, l), r, n, (u + c + l) % 2, i && i[o] ? i[o] : [])), o++;
                        return a;
                    }
                    function Q(t1, e1, r) {
                        for(var n = 1; n < w; n++)for(var i = 1; i < _; i++)for(var a = 1; a < b; a++)X(t1, k(a - 1, i - 1, n - 1), k(a - 1, i - 1, n), k(a - 1, i, n - 1), k(a - 1, i, n), k(a, i - 1, n - 1), k(a, i - 1, n), k(a, i, n - 1), k(a, i, n), e1, r, (a + i + n) % 2);
                    }
                    function $(t1, e1, r) {
                        d = !0, Q(t1, e1, r), d = !1;
                    }
                    function tt(t1, e1, r, n, i, a) {
                        for(var o = [], s = 0, l = 0; l < e1.length; l++)for(var c = e1[l], u = 1; u < w; u++)for(var f = 1; f < _; f++)o.push(W(t1, c, f, u, r, n, i[l], a && a[s] && a[s])), s++;
                        return o;
                    }
                    function et(t1, e1, r, n, i, a) {
                        for(var o = [], s = 0, l = 0; l < e1.length; l++)for(var c = e1[l], u = 1; u < b; u++)for(var f = 1; f < w; f++)o.push(W(t1, u, c, f, r, n, i[l], a && a[s] && a[s])), s++;
                        return o;
                    }
                    function rt(t1, e1, r, n, i, a) {
                        for(var o = [], s = 0, l = 0; l < e1.length; l++)for(var c = e1[l], u = 1; u < _; u++)for(var f = 1; f < b; f++)o.push(W(t1, f, u, c, r, n, i[l], a && a[s] && a[s])), s++;
                        return o;
                    }
                    function nt(t1, e1) {
                        for(var r = [], n = t1; n < e1; n++)r.push(n);
                        return r;
                    }
                    return function() {
                        if (P(), function() {
                            for(var e1 = 0; e1 < b; e1++)for(var r = 0; r < _; r++)for(var n = 0; n < w; n++){
                                var i = k(e1, r, n);
                                I(t1._x[i], t1._y[i], t1._z[i], t1._value[i]);
                            }
                        }(), u && p && (z(p), m = !0, Q(null, S, E), m = !1), c && h) {
                            z(h);
                            for(var e1 = t1.surface.pattern, r = t1.surface.count, s = 0; s < r; s++){
                                var f = 1 === r ? .5 : s / (r - 1), d = (1 - f) * S + f * E, T = Math.abs(d - A) > Math.abs(d - M) ? [
                                    A,
                                    d
                                ] : [
                                    d,
                                    M
                                ];
                                $(e1, T[0], T[1]);
                            }
                        }
                        var L = [
                            [
                                Math.min(S, M),
                                Math.max(S, M)
                            ],
                            [
                                Math.min(A, E),
                                Math.max(A, E)
                            ]
                        ];
                        [
                            "x",
                            "y",
                            "z"
                        ].forEach(function(e1) {
                            for(var r = [], n = 0; n < L.length; n++){
                                var i = 0, a = L[n][0], o = L[n][1], s = t1.slices[e1];
                                if (s.show && s.fill) {
                                    z(s.fill);
                                    var c = [], u = [], f = [];
                                    if (s.locations.length) for(var h = 0; h < s.locations.length; h++){
                                        var p = l(s.locations[h], "x" === e1 ? v : "y" === e1 ? y : x);
                                        0 === p.distRatio ? c.push(p.id) : p.id > 0 && (u.push(p.id), "x" === e1 ? f.push([
                                            p.distRatio,
                                            0,
                                            0
                                        ]) : "y" === e1 ? f.push([
                                            0,
                                            p.distRatio,
                                            0
                                        ]) : f.push([
                                            0,
                                            0,
                                            p.distRatio
                                        ]));
                                    }
                                    else c = nt(1, "x" === e1 ? b - 1 : "y" === e1 ? _ - 1 : w - 1);
                                    u.length > 0 && (r[i] = "x" === e1 ? tt(null, u, a, o, f, r[i]) : "y" === e1 ? et(null, u, a, o, f, r[i]) : rt(null, u, a, o, f, r[i]), i++), c.length > 0 && (r[i] = "x" === e1 ? Z(null, c, a, o, r[i]) : "y" === e1 ? J(null, c, a, o, r[i]) : K(null, c, a, o, r[i]), i++);
                                }
                                var d = t1.caps[e1];
                                d.show && d.fill && (z(d.fill), r[i] = "x" === e1 ? Z(null, [
                                    0,
                                    b - 1
                                ], a, o, r[i]) : "y" === e1 ? J(null, [
                                    0,
                                    _ - 1
                                ], a, o, r[i]) : K(null, [
                                    0,
                                    w - 1
                                ], a, o, r[i]), i++);
                            }
                        }), 0 === g && P(), t1._meshX = n, t1._meshY = i, t1._meshZ = a, t1._meshIntensity = o, t1._Xs = v, t1._Ys = y, t1._Zs = x;
                    }(), t1;
                }
                e1.exports = {
                    findNearestOnAxis: l,
                    generateIsoMeshes: h,
                    createIsosurfaceTrace: function(t1, e1) {
                        var r = t1.glplot.gl, i = n({
                            gl: r
                        }), a = new c(t1, i, e1.uid);
                        return i._trace = a, a.update(e1), t1.glplot.add(i), a;
                    }
                };
            },
            {
                "../../../stackgl_modules": 1120,
                "../../components/colorscale": 378,
                "../../lib/gl_format_color": 499,
                "../../lib/str2rgbarray": 528,
                "../../plots/gl3d/zip3": 609
            }
        ],
        865: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../registry"), a = t1("./attributes"), o = t1("../../components/colorscale/defaults");
                function s(t1, e1, r, n, a) {
                    var s = a("isomin"), l = a("isomax");
                    null != l && null != s && s > l && (e1.isomin = null, e1.isomax = null);
                    var c = a("x"), u = a("y"), f = a("z"), h = a("value");
                    c && c.length && u && u.length && f && f.length && h && h.length ? (i.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                        "x",
                        "y",
                        "z"
                    ], n), a("valuehoverformat"), [
                        "x",
                        "y",
                        "z"
                    ].forEach(function(t1) {
                        a(t1 + "hoverformat");
                        var e1 = "caps." + t1;
                        a(e1 + ".show") && a(e1 + ".fill");
                        var r = "slices." + t1;
                        a(r + ".show") && (a(r + ".fill"), a(r + ".locations"));
                    }), a("spaceframe.show") && a("spaceframe.fill"), a("surface.show") && (a("surface.count"), a("surface.fill"), a("surface.pattern")), a("contour.show") && (a("contour.color"), a("contour.width")), [
                        "text",
                        "hovertext",
                        "hovertemplate",
                        "lighting.ambient",
                        "lighting.diffuse",
                        "lighting.specular",
                        "lighting.roughness",
                        "lighting.fresnel",
                        "lighting.vertexnormalsepsilon",
                        "lighting.facenormalsepsilon",
                        "lightposition.x",
                        "lightposition.y",
                        "lightposition.z",
                        "flatshading",
                        "opacity"
                    ].forEach(function(t1) {
                        a(t1);
                    }), o(t1, e1, n, a, {
                        prefix: "",
                        cLetter: "c"
                    }), e1._length = null) : e1.visible = !1;
                }
                e1.exports = {
                    supplyDefaults: function(t1, e1, r, i) {
                        s(t1, e1, r, i, function(r, i) {
                            return n.coerce(t1, e1, a, r, i);
                        });
                    },
                    supplyIsoDefaults: s
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../lib": 503,
                "../../registry": 638,
                "./attributes": 862
            }
        ],
        866: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults").supplyDefaults,
                    calc: t1("./calc"),
                    colorbar: {
                        min: "cmin",
                        max: "cmax"
                    },
                    plot: t1("./convert").createIsosurfaceTrace,
                    moduleType: "trace",
                    name: "isosurface",
                    basePlotModule: t1("../../plots/gl3d"),
                    categories: [
                        "gl3d",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/gl3d": 598,
                "./attributes": 862,
                "./calc": 863,
                "./convert": 864,
                "./defaults": 865
            }
        ],
        867: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/attributes"), i = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, a = t1("../../plots/template_attributes").hovertemplateAttrs, o = t1("../surface/attributes"), s = t1("../../plots/attributes"), l = t1("../../lib/extend").extendFlat;
                e1.exports = l({
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    z: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    i: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    j: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    k: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    hovertemplate: a({
                        editType: "calc"
                    }),
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    zhoverformat: i("z"),
                    delaunayaxis: {
                        valType: "enumerated",
                        values: [
                            "x",
                            "y",
                            "z"
                        ],
                        dflt: "z",
                        editType: "calc"
                    },
                    alphahull: {
                        valType: "number",
                        dflt: -1,
                        editType: "calc"
                    },
                    intensity: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    intensitymode: {
                        valType: "enumerated",
                        values: [
                            "vertex",
                            "cell"
                        ],
                        dflt: "vertex",
                        editType: "calc"
                    },
                    color: {
                        valType: "color",
                        editType: "calc"
                    },
                    vertexcolor: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    facecolor: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    transforms: void 0
                }, n("", {
                    colorAttr: "`intensity`",
                    showScaleDflt: !0,
                    editTypeOverride: "calc"
                }), {
                    opacity: o.opacity,
                    flatshading: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    contour: {
                        show: l({}, o.contours.x.show, {}),
                        color: o.contours.x.color,
                        width: o.contours.x.width,
                        editType: "calc"
                    },
                    lightposition: {
                        x: l({}, o.lightposition.x, {
                            dflt: 1e5
                        }),
                        y: l({}, o.lightposition.y, {
                            dflt: 1e5
                        }),
                        z: l({}, o.lightposition.z, {
                            dflt: 0
                        }),
                        editType: "calc"
                    },
                    lighting: l({
                        vertexnormalsepsilon: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1e-12,
                            editType: "calc"
                        },
                        facenormalsepsilon: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1e-6,
                            editType: "calc"
                        },
                        editType: "calc"
                    }, o.lighting),
                    hoverinfo: l({}, s.hoverinfo, {
                        editType: "calc"
                    }),
                    showlegend: l({}, s.showlegend, {
                        dflt: !1
                    })
                });
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/template_attributes": 633,
                "../surface/attributes": 1057
            }
        ],
        868: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/calc");
                e1.exports = function(t1, e1) {
                    e1.intensity && n(t1, e1, {
                        vals: e1.intensity,
                        containerStr: "",
                        cLetter: "c"
                    });
                };
            },
            {
                "../../components/colorscale/calc": 374
            }
        ],
        869: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../stackgl_modules").gl_mesh3d, i = t1("../../../stackgl_modules").delaunay_triangulate, a = t1("../../../stackgl_modules").alpha_shape, o = t1("../../../stackgl_modules").convex_hull, s = t1("../../lib/gl_format_color").parseColorScale, l = t1("../../lib/str2rgbarray"), c = t1("../../components/colorscale").extractOpts, u = t1("../../plots/gl3d/zip3");
                function f(t1, e1, r) {
                    this.scene = t1, this.uid = r, this.mesh = e1, this.name = "", this.color = "#fff", this.data = null, this.showContour = !1;
                }
                var h = f.prototype;
                function p(t1) {
                    for(var e1 = [], r = t1.length, n = 0; n < r; n++)e1[n] = l(t1[n]);
                    return e1;
                }
                function d(t1, e1, r, n) {
                    for(var i = [], a = e1.length, o = 0; o < a; o++)i[o] = t1.d2l(e1[o], 0, n) * r;
                    return i;
                }
                function m(t1) {
                    for(var e1 = [], r = t1.length, n = 0; n < r; n++)e1[n] = Math.round(t1[n]);
                    return e1;
                }
                function g(t1, e1) {
                    for(var r = t1.length, n = 0; n < r; n++)if (t1[n] <= -0.5 || t1[n] >= e1 - .5) return !1;
                    return !0;
                }
                h.handlePick = function(t1) {
                    if (t1.object === this.mesh) {
                        var e1 = t1.index = t1.data.index;
                        t1.data._cellCenter ? t1.traceCoordinate = t1.data.dataCoordinate : t1.traceCoordinate = [
                            this.data.x[e1],
                            this.data.y[e1],
                            this.data.z[e1]
                        ];
                        var r = this.data.hovertext || this.data.text;
                        return Array.isArray(r) && void 0 !== r[e1] ? t1.textLabel = r[e1] : r && (t1.textLabel = r), !0;
                    }
                }, h.update = function(t1) {
                    var e1 = this.scene, r = e1.fullSceneLayout;
                    this.data = t1;
                    var n, f = t1.x.length, h = u(d(r.xaxis, t1.x, e1.dataScale[0], t1.xcalendar), d(r.yaxis, t1.y, e1.dataScale[1], t1.ycalendar), d(r.zaxis, t1.z, e1.dataScale[2], t1.zcalendar));
                    if (t1.i && t1.j && t1.k) {
                        if (t1.i.length !== t1.j.length || t1.j.length !== t1.k.length || !g(t1.i, f) || !g(t1.j, f) || !g(t1.k, f)) return;
                        n = u(m(t1.i), m(t1.j), m(t1.k));
                    } else n = 0 === t1.alphahull ? o(h) : t1.alphahull > 0 ? a(t1.alphahull, h) : function(t1, e1) {
                        for(var r = [
                            "x",
                            "y",
                            "z"
                        ].indexOf(t1), n = [], a = e1.length, o = 0; o < a; o++)n[o] = [
                            e1[o][(r + 1) % 3],
                            e1[o][(r + 2) % 3]
                        ];
                        return i(n);
                    }(t1.delaunayaxis, h);
                    var v = {
                        positions: h,
                        cells: n,
                        lightPosition: [
                            t1.lightposition.x,
                            t1.lightposition.y,
                            t1.lightposition.z
                        ],
                        ambient: t1.lighting.ambient,
                        diffuse: t1.lighting.diffuse,
                        specular: t1.lighting.specular,
                        roughness: t1.lighting.roughness,
                        fresnel: t1.lighting.fresnel,
                        vertexNormalsEpsilon: t1.lighting.vertexnormalsepsilon,
                        faceNormalsEpsilon: t1.lighting.facenormalsepsilon,
                        opacity: t1.opacity,
                        contourEnable: t1.contour.show,
                        contourColor: l(t1.contour.color).slice(0, 3),
                        contourWidth: t1.contour.width,
                        useFacetNormals: t1.flatshading
                    };
                    if (t1.intensity) {
                        var y = c(t1);
                        this.color = "#fff";
                        var x = t1.intensitymode;
                        v[x + "Intensity"] = t1.intensity, v[x + "IntensityBounds"] = [
                            y.min,
                            y.max
                        ], v.colormap = s(t1);
                    } else t1.vertexcolor ? (this.color = t1.vertexcolor[0], v.vertexColors = p(t1.vertexcolor)) : t1.facecolor ? (this.color = t1.facecolor[0], v.cellColors = p(t1.facecolor)) : (this.color = t1.color, v.meshColor = l(t1.color));
                    this.mesh.update(v);
                }, h.dispose = function() {
                    this.scene.glplot.remove(this.mesh), this.mesh.dispose();
                }, e1.exports = function(t1, e1) {
                    var r = t1.glplot.gl, i = n({
                        gl: r
                    }), a = new f(t1, i, e1.uid);
                    return i._trace = a, a.update(e1), t1.glplot.add(i), a;
                };
            },
            {
                "../../../stackgl_modules": 1120,
                "../../components/colorscale": 378,
                "../../lib/gl_format_color": 499,
                "../../lib/str2rgbarray": 528,
                "../../plots/gl3d/zip3": 609
            }
        ],
        870: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib"), a = t1("../../components/colorscale/defaults"), o = t1("./attributes");
                e1.exports = function(t1, e1, r, s) {
                    function l(r, n) {
                        return i.coerce(t1, e1, o, r, n);
                    }
                    function c(t1) {
                        var e1 = t1.map(function(t1) {
                            var e1 = l(t1);
                            return e1 && i.isArrayOrTypedArray(e1) ? e1 : null;
                        });
                        return e1.every(function(t1) {
                            return t1 && t1.length === e1[0].length;
                        }) && e1;
                    }
                    c([
                        "x",
                        "y",
                        "z"
                    ]) ? (c([
                        "i",
                        "j",
                        "k"
                    ]), (!e1.i || e1.j && e1.k) && (!e1.j || e1.k && e1.i) && (!e1.k || e1.i && e1.j) ? (n.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                        "x",
                        "y",
                        "z"
                    ], s), [
                        "lighting.ambient",
                        "lighting.diffuse",
                        "lighting.specular",
                        "lighting.roughness",
                        "lighting.fresnel",
                        "lighting.vertexnormalsepsilon",
                        "lighting.facenormalsepsilon",
                        "lightposition.x",
                        "lightposition.y",
                        "lightposition.z",
                        "flatshading",
                        "alphahull",
                        "delaunayaxis",
                        "opacity"
                    ].forEach(function(t1) {
                        l(t1);
                    }), l("contour.show") && (l("contour.color"), l("contour.width")), "intensity" in t1 ? (l("intensity"), l("intensitymode"), a(t1, e1, s, l, {
                        prefix: "",
                        cLetter: "c"
                    })) : (e1.showscale = !1, "facecolor" in t1 ? l("facecolor") : "vertexcolor" in t1 ? l("vertexcolor") : l("color", r)), l("text"), l("hovertext"), l("hovertemplate"), l("xhoverformat"), l("yhoverformat"), l("zhoverformat"), e1._length = null) : e1.visible = !1) : e1.visible = !1;
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../lib": 503,
                "../../registry": 638,
                "./attributes": 867
            }
        ],
        871: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    calc: t1("./calc"),
                    colorbar: {
                        min: "cmin",
                        max: "cmax"
                    },
                    plot: t1("./convert"),
                    moduleType: "trace",
                    name: "mesh3d",
                    basePlotModule: t1("../../plots/gl3d"),
                    categories: [
                        "gl3d",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/gl3d": 598,
                "./attributes": 867,
                "./calc": 868,
                "./convert": 869,
                "./defaults": 870
            }
        ],
        872: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").extendFlat, i = t1("../scatter/attributes"), a = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, o = t1("../../components/drawing/attributes").dash, s = t1("../../components/fx/attributes"), l = t1("../../constants/delta.js"), c = l.INCREASING.COLOR, u = l.DECREASING.COLOR, f = i.line;
                function h(t1) {
                    return {
                        line: {
                            color: n({}, f.color, {
                                dflt: t1
                            }),
                            width: f.width,
                            dash: o,
                            editType: "style"
                        },
                        editType: "style"
                    };
                }
                e1.exports = {
                    xperiod: i.xperiod,
                    xperiod0: i.xperiod0,
                    xperiodalignment: i.xperiodalignment,
                    xhoverformat: a("x"),
                    yhoverformat: a("y"),
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    open: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    high: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    low: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    close: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    line: {
                        width: n({}, f.width, {}),
                        dash: n({}, o, {}),
                        editType: "style"
                    },
                    increasing: h(c),
                    decreasing: h(u),
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    tickwidth: {
                        valType: "number",
                        min: 0,
                        max: .5,
                        dflt: .3,
                        editType: "calc"
                    },
                    hoverlabel: n({}, s.hoverlabel, {
                        split: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "style"
                        }
                    })
                };
            },
            {
                "../../components/drawing/attributes": 387,
                "../../components/fx/attributes": 397,
                "../../constants/delta.js": 473,
                "../../lib": 503,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../scatter/attributes": 926
            }
        ],
        873: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = n._, a = t1("../../plots/cartesian/axes"), o = t1("../../plots/cartesian/align_period"), s = t1("../../constants/numerical").BADNUM;
                function l(t1, e1, r, n) {
                    return {
                        o: t1,
                        h: e1,
                        l: r,
                        c: n
                    };
                }
                function c(t1, e1, r, o, l, c) {
                    for(var u = l.makeCalcdata(e1, "open"), f = l.makeCalcdata(e1, "high"), h = l.makeCalcdata(e1, "low"), p = l.makeCalcdata(e1, "close"), d = Array.isArray(e1.text), m = Array.isArray(e1.hovertext), g = !0, v = null, y = !!e1.xperiodalignment, x = [], b = 0; b < o.length; b++){
                        var _ = o[b], w = u[b], T = f[b], k = h[b], A = p[b];
                        if (_ !== s && w !== s && T !== s && k !== s && A !== s) {
                            A === w ? null !== v && A !== v && (g = A > v) : g = A > w, v = A;
                            var M = c(w, T, k, A);
                            M.pos = _, M.yc = (w + A) / 2, M.i = b, M.dir = g ? "increasing" : "decreasing", M.x = M.pos, M.y = [
                                k,
                                T
                            ], y && (M.orig_p = r[b]), d && (M.tx = e1.text[b]), m && (M.htx = e1.hovertext[b]), x.push(M);
                        } else x.push({
                            pos: _,
                            empty: !0
                        });
                    }
                    return e1._extremes[l._id] = a.findExtremes(l, n.concat(h, f), {
                        padded: !0
                    }), x.length && (x[0].t = {
                        labels: {
                            open: i(t1, "open:") + " ",
                            high: i(t1, "high:") + " ",
                            low: i(t1, "low:") + " ",
                            close: i(t1, "close:") + " "
                        }
                    }), x;
                }
                e1.exports = {
                    calc: function(t1, e1) {
                        var r = a.getFromId(t1, e1.xaxis), i = a.getFromId(t1, e1.yaxis), s = function(t1, e1, r) {
                            var i = r._minDiff;
                            if (!i) {
                                var a, s = t1._fullData, l = [];
                                for(i = 1 / 0, a = 0; a < s.length; a++){
                                    var c = s[a];
                                    if ("ohlc" === c.type && !0 === c.visible && c.xaxis === e1._id) {
                                        l.push(c);
                                        var u = e1.makeCalcdata(c, "x");
                                        c._origX = u;
                                        var f = o(r, e1, "x", u).vals;
                                        c._xcalc = f;
                                        var h = n.distinctVals(f).minDiff;
                                        h && isFinite(h) && (i = Math.min(i, h));
                                    }
                                }
                                for(i === 1 / 0 && (i = 1), a = 0; a < l.length; a++)l[a]._minDiff = i;
                            }
                            return i * r.tickwidth;
                        }(t1, r, e1), u = e1._minDiff;
                        e1._minDiff = null;
                        var f = e1._origX;
                        e1._origX = null;
                        var h = e1._xcalc;
                        e1._xcalc = null;
                        var p = c(t1, e1, f, h, i, l);
                        return e1._extremes[r._id] = a.findExtremes(r, h, {
                            vpad: u / 2
                        }), p.length ? (n.extendFlat(p[0].t, {
                            wHover: u / 2,
                            tickLen: s
                        }), p) : [
                            {
                                t: {
                                    empty: !0
                                }
                            }
                        ];
                    },
                    calcCommon: c
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../plots/cartesian/align_period": 551,
                "../../plots/cartesian/axes": 554
            }
        ],
        874: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./ohlc_defaults"), a = t1("../scatter/period_defaults"), o = t1("./attributes");
                function s(t1, e1, r, n) {
                    r(n + ".line.color"), r(n + ".line.width", e1.line.width), r(n + ".line.dash", e1.line.dash);
                }
                e1.exports = function(t1, e1, r, l) {
                    function c(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    i(t1, e1, c, l) ? (a(t1, e1, l, c, {
                        x: !0
                    }), c("xhoverformat"), c("yhoverformat"), c("line.width"), c("line.dash"), s(t1, e1, c, "increasing"), s(t1, e1, c, "decreasing"), c("text"), c("hovertext"), c("tickwidth"), l._requestRangeslider[e1.xaxis] = !0) : e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../scatter/period_defaults": 946,
                "./attributes": 872,
                "./ohlc_defaults": 877
            }
        ],
        875: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes"), i = t1("../../lib"), a = t1("../../components/fx"), o = t1("../../components/color"), s = t1("../../lib").fillText, l = t1("../../constants/delta.js"), c = {
                    increasing: l.INCREASING.SYMBOL,
                    decreasing: l.DECREASING.SYMBOL
                };
                function u(t1, e1, r, n) {
                    var i, s, l = t1.cd, c = t1.xa, u = l[0].trace, f = l[0].t, h = u.type, p = "ohlc" === h ? "l" : "min", d = "ohlc" === h ? "h" : "max", m = f.bPos || 0, g = f.bdPos || f.tickLen, v = f.wHover, y = Math.min(1, g / Math.abs(c.r2c(c.range[1]) - c.r2c(c.range[0])));
                    function x(t1) {
                        var r = function(t1) {
                            return t1.pos + m - e1;
                        }(t1);
                        return a.inbox(r - v, r + v, i);
                    }
                    function b(t1) {
                        var e1 = t1[p], n = t1[d];
                        return e1 === n || a.inbox(e1 - r, n - r, i);
                    }
                    function _(t1) {
                        return (x(t1) + b(t1)) / 2;
                    }
                    i = t1.maxHoverDistance - y, s = t1.maxSpikeDistance - y;
                    var w = a.getDistanceFunction(n, x, b, _);
                    if (a.getClosest(l, w, t1), !1 === t1.index) return null;
                    var T = l[t1.index];
                    if (T.empty) return null;
                    var k = u[T.dir], A = k.line.color;
                    return o.opacity(A) && k.line.width ? t1.color = A : t1.color = k.fillcolor, t1.x0 = c.c2p(T.pos + m - g, !0), t1.x1 = c.c2p(T.pos + m + g, !0), t1.xLabelVal = void 0 !== T.orig_p ? T.orig_p : T.pos, t1.spikeDistance = _(T) * s / i, t1.xSpike = c.c2p(T.pos, !0), t1;
                }
                function f(t1, e1, r, a) {
                    var o = t1.cd, s = t1.ya, l = o[0].trace, c = o[0].t, f = [], h = u(t1, e1, r, a);
                    if (!h) return [];
                    var p = o[h.index].hi || l.hoverinfo, d = p.split("+");
                    if (!("all" === p || -1 !== d.indexOf("y"))) return [];
                    for(var m = [
                        "high",
                        "open",
                        "close",
                        "low"
                    ], g = {}, v = 0; v < m.length; v++){
                        var y, x = m[v], b = l[x][h.index], _ = s.c2p(b, !0);
                        b in g ? (y = g[b]).yLabel += "<br>" + c.labels[x] + n.hoverLabelText(s, b, l.yhoverformat) : ((y = i.extendFlat({}, h)).y0 = y.y1 = _, y.yLabelVal = b, y.yLabel = c.labels[x] + n.hoverLabelText(s, b, l.yhoverformat), y.name = "", f.push(y), g[b] = y);
                    }
                    return f;
                }
                function h(t1, e1, r, i) {
                    var a = t1.cd, o = t1.ya, l = a[0].trace, f = a[0].t, h = u(t1, e1, r, i);
                    if (!h) return [];
                    var p = a[h.index], d = h.index = p.i, m = p.dir;
                    function g(t1) {
                        return f.labels[t1] + n.hoverLabelText(o, l[t1][d], l.yhoverformat);
                    }
                    var v = p.hi || l.hoverinfo, y = v.split("+"), x = "all" === v, b = x || -1 !== y.indexOf("y"), _ = x || -1 !== y.indexOf("text"), w = b ? [
                        g("open"),
                        g("high"),
                        g("low"),
                        g("close") + "  " + c[m]
                    ] : [];
                    return _ && s(p, l, w), h.extraText = w.join("<br>"), h.y0 = h.y1 = o.c2p(p.yc, !0), [
                        h
                    ];
                }
                e1.exports = {
                    hoverPoints: function(t1, e1, r, n) {
                        return t1.cd[0].trace.hoverlabel.split ? f(t1, e1, r, n) : h(t1, e1, r, n);
                    },
                    hoverSplit: f,
                    hoverOnPoints: h
                };
            },
            {
                "../../components/color": 366,
                "../../components/fx": 406,
                "../../constants/delta.js": 473,
                "../../lib": 503,
                "../../plots/cartesian/axes": 554
            }
        ],
        876: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "ohlc",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "cartesian",
                        "svg",
                        "showLegend"
                    ],
                    meta: {},
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    calc: t1("./calc").calc,
                    plot: t1("./plot"),
                    style: t1("./style"),
                    hoverPoints: t1("./hover").hoverPoints,
                    selectPoints: t1("./select")
                };
            },
            {
                "../../plots/cartesian": 568,
                "./attributes": 872,
                "./calc": 873,
                "./defaults": 874,
                "./hover": 875,
                "./plot": 878,
                "./select": 879,
                "./style": 880
            }
        ],
        877: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib");
                e1.exports = function(t1, e1, r, a) {
                    var o = r("x"), s = r("open"), l = r("high"), c = r("low"), u = r("close");
                    if (r("hoverlabel.split"), n.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                        "x"
                    ], a), s && l && c && u) {
                        var f = Math.min(s.length, l.length, c.length, u.length);
                        return o && (f = Math.min(f, i.minRowLength(o))), e1._length = f, f;
                    }
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638
            }
        ],
        878: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib");
                e1.exports = function(t1, e1, r, a) {
                    var o = e1.yaxis, s = e1.xaxis, l = !!s.rangebreaks;
                    i.makeTraceGroups(a, r, "trace ohlc").each(function(t1) {
                        var e1 = n.select(this), r = t1[0], a = r.t;
                        if (!0 !== r.trace.visible || a.empty) e1.remove();
                        else {
                            var c = a.tickLen, u = e1.selectAll("path").data(i.identity);
                            u.enter().append("path"), u.exit().remove(), u.attr("d", function(t1) {
                                if (t1.empty) return "M0,0Z";
                                var e1 = s.c2p(t1.pos - c, !0), r = s.c2p(t1.pos + c, !0), n = l ? (e1 + r) / 2 : s.c2p(t1.pos, !0);
                                return "M" + e1 + "," + o.c2p(t1.o, !0) + "H" + n + "M" + n + "," + o.c2p(t1.h, !0) + "V" + o.c2p(t1.l, !0) + "M" + r + "," + o.c2p(t1.c, !0) + "H" + n;
                            });
                        }
                    });
                };
            },
            {
                "../../lib": 503,
                "@plotly/d3": 58
            }
        ],
        879: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    var r, n = t1.cd, i = t1.xaxis, a = t1.yaxis, o = [], s = n[0].t.bPos || 0;
                    if (!1 === e1) for(r = 0; r < n.length; r++)n[r].selected = 0;
                    else for(r = 0; r < n.length; r++){
                        var l = n[r];
                        e1.contains([
                            i.c2p(l.pos + s),
                            a.c2p(l.yc)
                        ], null, l.i, t1) ? (o.push({
                            pointNumber: l.i,
                            x: i.c2d(l.pos),
                            y: a.c2d(l.yc)
                        }), l.selected = 1) : l.selected = 0;
                    }
                    return o;
                };
            },
            {}
        ],
        880: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/drawing"), a = t1("../../components/color");
                e1.exports = function(t1, e1, r) {
                    var o = r || n.select(t1).selectAll("g.ohlclayer").selectAll("g.trace");
                    o.style("opacity", function(t1) {
                        return t1[0].trace.opacity;
                    }), o.each(function(t1) {
                        var e1 = t1[0].trace;
                        n.select(this).selectAll("path").each(function(t1) {
                            if (!t1.empty) {
                                var r = e1[t1.dir].line;
                                n.select(this).style("fill", "none").call(a.stroke, r.color).call(i.dashLine, r.dash, r.width).style("opacity", e1.selectedpoints && !t1.selected ? .3 : 1);
                            }
                        });
                    });
                };
            },
            {
                "../../components/color": 366,
                "../../components/drawing": 388,
                "@plotly/d3": 58
            }
        ],
        881: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib/extend").extendFlat, i = t1("../../plots/attributes"), a = t1("../../plots/font_attributes"), o = t1("../../components/colorscale/attributes"), s = t1("../../plots/template_attributes").hovertemplateAttrs, l = t1("../../plots/domain").attributes, c = n({
                    editType: "calc"
                }, o("line", {
                    editTypeOverride: "calc"
                }), {
                    shape: {
                        valType: "enumerated",
                        values: [
                            "linear",
                            "hspline"
                        ],
                        dflt: "linear",
                        editType: "plot"
                    },
                    hovertemplate: s({
                        editType: "plot",
                        arrayOk: !1
                    }, {
                        keys: [
                            "count",
                            "probability"
                        ]
                    })
                });
                e1.exports = {
                    domain: l({
                        name: "parcats",
                        trace: !0,
                        editType: "calc"
                    }),
                    hoverinfo: n({}, i.hoverinfo, {
                        flags: [
                            "count",
                            "probability"
                        ],
                        editType: "plot",
                        arrayOk: !1
                    }),
                    hoveron: {
                        valType: "enumerated",
                        values: [
                            "category",
                            "color",
                            "dimension"
                        ],
                        dflt: "category",
                        editType: "plot"
                    },
                    hovertemplate: s({
                        editType: "plot",
                        arrayOk: !1
                    }, {
                        keys: [
                            "count",
                            "probability",
                            "category",
                            "categorycount",
                            "colorcount",
                            "bandcolorcount"
                        ]
                    }),
                    arrangement: {
                        valType: "enumerated",
                        values: [
                            "perpendicular",
                            "freeform",
                            "fixed"
                        ],
                        dflt: "perpendicular",
                        editType: "plot"
                    },
                    bundlecolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    sortpaths: {
                        valType: "enumerated",
                        values: [
                            "forward",
                            "backward"
                        ],
                        dflt: "forward",
                        editType: "plot"
                    },
                    labelfont: a({
                        editType: "calc"
                    }),
                    tickfont: a({
                        editType: "calc"
                    }),
                    dimensions: {
                        _isLinkedToArray: "dimension",
                        label: {
                            valType: "string",
                            editType: "calc"
                        },
                        categoryorder: {
                            valType: "enumerated",
                            values: [
                                "trace",
                                "category ascending",
                                "category descending",
                                "array"
                            ],
                            dflt: "trace",
                            editType: "calc"
                        },
                        categoryarray: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        ticktext: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        values: {
                            valType: "data_array",
                            dflt: [],
                            editType: "calc"
                        },
                        displayindex: {
                            valType: "integer",
                            editType: "calc"
                        },
                        editType: "calc",
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "calc"
                        }
                    },
                    line: c,
                    counts: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    customdata: void 0,
                    hoverlabel: void 0,
                    ids: void 0,
                    legendgroup: void 0,
                    legendrank: void 0,
                    opacity: void 0,
                    selectedpoints: void 0,
                    showlegend: void 0
                };
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/domain": 584,
                "../../plots/font_attributes": 585,
                "../../plots/template_attributes": 633
            }
        ],
        882: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/get_data").getModuleCalcData, i = t1("./plot");
                r.name = "parcats", r.plot = function(t1, e1, r, a) {
                    var o = n(t1.calcdata, "parcats");
                    if (o.length) {
                        var s = o[0];
                        i(t1, s, r, a);
                    }
                }, r.clean = function(t1, e1, r, n) {
                    var i = n._has && n._has("parcats"), a = e1._has && e1._has("parcats");
                    i && !a && n._paperdiv.selectAll(".parcats").remove();
                };
            },
            {
                "../../plots/get_data": 593,
                "./plot": 887
            }
        ],
        883: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib/gup").wrap, i = t1("../../components/colorscale/helpers").hasColorscale, a = t1("../../components/colorscale/calc"), o = t1("../../lib/filter_unique.js"), s = t1("../../components/drawing"), l = t1("../../lib"), c = t1("fast-isnumeric");
                function u(t1, e1, r) {
                    t1.valueInds.push(e1), t1.count += r;
                }
                function f(t1, e1, r) {
                    return {
                        categoryInds: t1,
                        color: e1,
                        rawColor: r,
                        valueInds: [],
                        count: 0
                    };
                }
                function h(t1, e1, r) {
                    t1.valueInds.push(e1), t1.count += r;
                }
                e1.exports = function(t1, e1) {
                    var r = l.filterVisible(e1.dimensions);
                    if (0 === r.length) return [];
                    var p, d, m, g = r.map(function(t1) {
                        var e1;
                        if ("trace" === t1.categoryorder) e1 = null;
                        else if ("array" === t1.categoryorder) e1 = t1.categoryarray;
                        else {
                            e1 = o(t1.values);
                            for(var r = !0, n = 0; n < e1.length; n++)if (!c(e1[n])) {
                                r = !1;
                                break;
                            }
                            e1.sort(r ? l.sorterAsc : void 0), "category descending" === t1.categoryorder && (e1 = e1.reverse());
                        }
                        return function(t1, e1) {
                            e1 = null == e1 ? [] : e1.map(function(t1) {
                                return t1;
                            });
                            var r = {}, n = {}, i = [];
                            e1.forEach(function(t1, e1) {
                                r[t1] = 0, n[t1] = e1;
                            });
                            for(var a = 0; a < t1.length; a++){
                                var o, s = t1[a];
                                void 0 === r[s] ? (r[s] = 1, o = e1.push(s) - 1, n[s] = o) : (r[s]++, o = n[s]), i.push(o);
                            }
                            var l = e1.map(function(t1) {
                                return r[t1];
                            });
                            return {
                                uniqueValues: e1,
                                uniqueCounts: l,
                                inds: i
                            };
                        }(t1.values, e1);
                    });
                    p = l.isArrayOrTypedArray(e1.counts) ? e1.counts : [
                        e1.counts
                    ], function(t1) {
                        var e1;
                        if (function(t1) {
                            for(var e1 = new Array(t1.length), r = 0; r < t1.length; r++){
                                if (t1[r] < 0 || t1[r] >= t1.length) return !1;
                                if (void 0 !== e1[t1[r]]) return !1;
                                e1[t1[r]] = !0;
                            }
                            return !0;
                        }(t1.map(function(t1) {
                            return t1.displayindex;
                        }))) for(e1 = 0; e1 < t1.length; e1++)t1[e1]._displayindex = t1[e1].displayindex;
                        else for(e1 = 0; e1 < t1.length; e1++)t1[e1]._displayindex = e1;
                    }(r), r.forEach(function(t1, e1) {
                        !function(t1, e1) {
                            t1._categoryarray = e1.uniqueValues, null === t1.ticktext || void 0 === t1.ticktext ? t1._ticktext = [] : t1._ticktext = t1.ticktext.slice();
                            for(var r = t1._ticktext.length; r < e1.uniqueValues.length; r++)t1._ticktext.push(e1.uniqueValues[r]);
                        }(t1, g[e1]);
                    });
                    var v, y = e1.line;
                    y ? (i(e1, "line") && a(t1, e1, {
                        vals: e1.line.color,
                        containerStr: "line",
                        cLetter: "c"
                    }), v = s.tryColorscale(y)) : v = l.identity;
                    var x, b, _, w, T, k = r[0].values.length, A = {}, M = g.map(function(t1) {
                        return t1.inds;
                    });
                    for(m = 0, x = 0; x < k; x++){
                        var S = [];
                        for(b = 0; b < M.length; b++)S.push(M[b][x]);
                        d = p[x % p.length], m += d;
                        var E = (_ = x, w = void 0, T = void 0, l.isArrayOrTypedArray(y.color) ? T = w = y.color[_ % y.color.length] : w = y.color, {
                            color: v(w),
                            rawColor: T
                        }), L = S + "-" + E.rawColor;
                        void 0 === A[L] && (A[L] = f(S, E.color, E.rawColor)), h(A[L], x, d);
                    }
                    var C, P = r.map(function(t1, e1) {
                        return function(t1, e1, r, n, i) {
                            return {
                                dimensionInd: t1,
                                containerInd: e1,
                                displayInd: r,
                                dimensionLabel: n,
                                count: i,
                                categories: [],
                                dragX: null
                            };
                        }(e1, t1._index, t1._displayindex, t1.label, m);
                    });
                    for(x = 0; x < k; x++)for(d = p[x % p.length], b = 0; b < P.length; b++){
                        var I = P[b].containerInd, O = g[b].inds[x], z = P[b].categories;
                        if (void 0 === z[O]) {
                            var D = e1.dimensions[I]._categoryarray[O], R = e1.dimensions[I]._ticktext[O];
                            z[O] = {
                                dimensionInd: b,
                                categoryInd: C = O,
                                categoryValue: D,
                                displayInd: C,
                                categoryLabel: R,
                                valueInds: [],
                                count: 0,
                                dragY: null
                            };
                        }
                        u(z[O], x, d);
                    }
                    return n(function(t1, e1, r) {
                        var n = t1.map(function(t1) {
                            return t1.categories.length;
                        }).reduce(function(t1, e1) {
                            return Math.max(t1, e1);
                        });
                        return {
                            dimensions: t1,
                            paths: e1,
                            trace: void 0,
                            maxCats: n,
                            count: r
                        };
                    }(P, A, m));
                };
            },
            {
                "../../components/colorscale/calc": 374,
                "../../components/colorscale/helpers": 377,
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../lib/filter_unique.js": 494,
                "../../lib/gup": 500,
                "fast-isnumeric": 190
            }
        ],
        884: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/colorscale/helpers").hasColorscale, a = t1("../../components/colorscale/defaults"), o = t1("../../plots/domain").defaults, s = t1("../../plots/array_container_defaults"), l = t1("./attributes"), c = t1("../parcoords/merge_length");
                function u(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, l.dimensions, r, i);
                    }
                    var i = r("values"), a = r("visible");
                    if (i && i.length || (a = e1.visible = !1), a) {
                        r("label"), r("displayindex", e1._index);
                        var o, s = t1.categoryarray, c = Array.isArray(s) && s.length > 0;
                        c && (o = "array");
                        var u = r("categoryorder", o);
                        "array" === u ? (r("categoryarray"), r("ticktext")) : (delete t1.categoryarray, delete t1.ticktext), c || "array" !== u || (e1.categoryorder = "trace");
                    }
                }
                e1.exports = function(t1, e1, r, f) {
                    function h(r, i) {
                        return n.coerce(t1, e1, l, r, i);
                    }
                    var p = s(t1, e1, {
                        name: "dimensions",
                        handleItemDefaults: u
                    }), d = function(t1, e1, r, o, s) {
                        s("line.shape"), s("line.hovertemplate");
                        var l = s("line.color", o.colorway[0]);
                        if (i(t1, "line") && n.isArrayOrTypedArray(l)) {
                            if (l.length) return s("line.colorscale"), a(t1, e1, o, s, {
                                prefix: "line.",
                                cLetter: "c"
                            }), l.length;
                            e1.line.color = r;
                        }
                        return 1 / 0;
                    }(t1, e1, r, f, h);
                    o(e1, f, h), Array.isArray(p) && p.length || (e1.visible = !1), c(e1, p, "values", d), h("hoveron"), h("hovertemplate"), h("arrangement"), h("bundlecolors"), h("sortpaths"), h("counts");
                    var m = {
                        family: f.font.family,
                        size: Math.round(f.font.size),
                        color: f.font.color
                    };
                    n.coerceFont(h, "labelfont", m);
                    var g = {
                        family: f.font.family,
                        size: Math.round(f.font.size / 1.2),
                        color: f.font.color
                    };
                    n.coerceFont(h, "tickfont", g);
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../components/colorscale/helpers": 377,
                "../../lib": 503,
                "../../plots/array_container_defaults": 549,
                "../../plots/domain": 584,
                "../parcoords/merge_length": 897,
                "./attributes": 881
            }
        ],
        885: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    colorbar: {
                        container: "line",
                        min: "cmin",
                        max: "cmax"
                    },
                    moduleType: "trace",
                    name: "parcats",
                    basePlotModule: t1("./base_plot"),
                    categories: [
                        "noOpacity"
                    ],
                    meta: {}
                };
            },
            {
                "./attributes": 881,
                "./base_plot": 882,
                "./calc": 883,
                "./defaults": 884,
                "./plot": 887
            }
        ],
        886: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("d3-interpolate").interpolateNumber, a = t1("../../plot_api/plot_api"), o = t1("../../components/fx"), s = t1("../../lib"), l = s.strTranslate, c = t1("../../components/drawing"), u = t1("tinycolor2"), f = t1("../../lib/svg_text_utils");
                function h(t1, e1, r, i) {
                    var a = t1.map(F.bind(0, e1, r)), o = i.selectAll("g.parcatslayer").data([
                        null
                    ]);
                    o.enter().append("g").attr("class", "parcatslayer").style("pointer-events", "all");
                    var u = o.selectAll("g.trace.parcats").data(a, p), h = u.enter().append("g").attr("class", "trace parcats");
                    u.attr("transform", function(t1) {
                        return l(t1.x, t1.y);
                    }), h.append("g").attr("class", "paths");
                    var y = u.select("g.paths").selectAll("path.path").data(function(t1) {
                        return t1.paths;
                    }, p);
                    y.attr("fill", function(t1) {
                        return t1.model.color;
                    });
                    var x = y.enter().append("path").attr("class", "path").attr("stroke-opacity", 0).attr("fill", function(t1) {
                        return t1.model.color;
                    }).attr("fill-opacity", 0);
                    _(x), y.attr("d", function(t1) {
                        return t1.svgD;
                    }), x.empty() || y.sort(m), y.exit().remove(), y.on("mouseover", g).on("mouseout", v).on("click", b), h.append("g").attr("class", "dimensions");
                    var w = u.select("g.dimensions").selectAll("g.dimension").data(function(t1) {
                        return t1.dimensions;
                    }, p);
                    w.enter().append("g").attr("class", "dimension"), w.attr("transform", function(t1) {
                        return l(t1.x, 0);
                    }), w.exit().remove();
                    var A = w.selectAll("g.category").data(function(t1) {
                        return t1.categories;
                    }, p), M = A.enter().append("g").attr("class", "category");
                    A.attr("transform", function(t1) {
                        return l(0, t1.y);
                    }), M.append("rect").attr("class", "catrect").attr("pointer-events", "none"), A.select("rect.catrect").attr("fill", "none").attr("width", function(t1) {
                        return t1.width;
                    }).attr("height", function(t1) {
                        return t1.height;
                    }), T(M);
                    var S = A.selectAll("rect.bandrect").data(function(t1) {
                        return t1.bands;
                    }, p);
                    S.each(function() {
                        s.raiseToTop(this);
                    }), S.attr("fill", function(t1) {
                        return t1.color;
                    });
                    var E = S.enter().append("rect").attr("class", "bandrect").attr("stroke-opacity", 0).attr("fill", function(t1) {
                        return t1.color;
                    }).attr("fill-opacity", 0);
                    S.attr("fill", function(t1) {
                        return t1.color;
                    }).attr("width", function(t1) {
                        return t1.width;
                    }).attr("height", function(t1) {
                        return t1.height;
                    }).attr("y", function(t1) {
                        return t1.y;
                    }).attr("cursor", function(t1) {
                        return "fixed" === t1.parcatsViewModel.arrangement ? "default" : "perpendicular" === t1.parcatsViewModel.arrangement ? "ns-resize" : "move";
                    }), k(E), S.exit().remove(), M.append("text").attr("class", "catlabel").attr("pointer-events", "none");
                    var z = e1._fullLayout.paper_bgcolor;
                    A.select("text.catlabel").attr("text-anchor", function(t1) {
                        return d(t1) ? "start" : "end";
                    }).attr("alignment-baseline", "middle").style("text-shadow", f.makeTextShadow(z)).style("fill", "rgb(0, 0, 0)").attr("x", function(t1) {
                        return d(t1) ? t1.width + 5 : -5;
                    }).attr("y", function(t1) {
                        return t1.height / 2;
                    }).text(function(t1) {
                        return t1.model.categoryLabel;
                    }).each(function(t1) {
                        c.font(n.select(this), t1.parcatsViewModel.categorylabelfont), f.convertToTspans(n.select(this), e1);
                    }), M.append("text").attr("class", "dimlabel"), A.select("text.dimlabel").attr("text-anchor", "middle").attr("alignment-baseline", "baseline").attr("cursor", function(t1) {
                        return "fixed" === t1.parcatsViewModel.arrangement ? "default" : "ew-resize";
                    }).attr("x", function(t1) {
                        return t1.width / 2;
                    }).attr("y", -5).text(function(t1, e1) {
                        return 0 === e1 ? t1.parcatsViewModel.model.dimensions[t1.model.dimensionInd].dimensionLabel : null;
                    }).each(function(t1) {
                        c.font(n.select(this), t1.parcatsViewModel.labelfont);
                    }), A.selectAll("rect.bandrect").on("mouseover", L).on("mouseout", C), A.exit().remove(), w.call(n.behavior.drag().origin(function(t1) {
                        return {
                            x: t1.x,
                            y: 0
                        };
                    }).on("dragstart", P).on("drag", I).on("dragend", O)), u.each(function(t1) {
                        t1.traceSelection = n.select(this), t1.pathSelection = n.select(this).selectAll("g.paths").selectAll("path.path"), t1.dimensionSelection = n.select(this).selectAll("g.dimensions").selectAll("g.dimension");
                    }), u.exit().remove();
                }
                function p(t1) {
                    return t1.key;
                }
                function d(t1) {
                    var e1 = t1.parcatsViewModel.dimensions.length, r = t1.parcatsViewModel.dimensions[e1 - 1].model.dimensionInd;
                    return t1.model.dimensionInd === r;
                }
                function m(t1, e1) {
                    return t1.model.rawColor > e1.model.rawColor ? 1 : t1.model.rawColor < e1.model.rawColor ? -1 : 0;
                }
                function g(t1) {
                    if (!t1.parcatsViewModel.dragDimension && -1 === t1.parcatsViewModel.hoverinfoItems.indexOf("skip")) {
                        s.raiseToTop(this), w(n.select(this));
                        var e1 = y(t1), r = x(t1);
                        if (t1.parcatsViewModel.graphDiv.emit("plotly_hover", {
                            points: e1,
                            event: n.event,
                            constraints: r
                        }), -1 === t1.parcatsViewModel.hoverinfoItems.indexOf("none")) {
                            var i, a, l, c = n.mouse(this)[0], f = t1.parcatsViewModel.graphDiv, h = t1.parcatsViewModel.trace, p = f._fullLayout, d = p._paperdiv.node().getBoundingClientRect(), m = t1.parcatsViewModel.graphDiv.getBoundingClientRect();
                            for(l = 0; l < t1.leftXs.length - 1; l++)if (t1.leftXs[l] + t1.dimWidths[l] - 2 <= c && c <= t1.leftXs[l + 1] + 2) {
                                var g = t1.parcatsViewModel.dimensions[l], v = t1.parcatsViewModel.dimensions[l + 1];
                                i = (g.x + g.width + v.x) / 2, a = (t1.topYs[l] + t1.topYs[l + 1] + t1.height) / 2;
                                break;
                            }
                            var b = t1.parcatsViewModel.x + i, _ = t1.parcatsViewModel.y + a, T = u.mostReadable(t1.model.color, [
                                "black",
                                "white"
                            ]), k = t1.model.count, A = k / t1.parcatsViewModel.model.count, M = {
                                countLabel: k,
                                probabilityLabel: A.toFixed(3)
                            }, S = [];
                            -1 !== t1.parcatsViewModel.hoverinfoItems.indexOf("count") && S.push([
                                "Count:",
                                M.countLabel
                            ].join(" ")), -1 !== t1.parcatsViewModel.hoverinfoItems.indexOf("probability") && S.push([
                                "P:",
                                M.probabilityLabel
                            ].join(" "));
                            var E = S.join("<br>"), L = n.mouse(f)[0];
                            o.loneHover({
                                trace: h,
                                x: b - d.left + m.left,
                                y: _ - d.top + m.top,
                                text: E,
                                color: t1.model.color,
                                borderColor: "black",
                                fontFamily: 'Monaco, "Courier New", monospace',
                                fontSize: 10,
                                fontColor: T,
                                idealAlign: L < b ? "right" : "left",
                                hovertemplate: (h.line || {}).hovertemplate,
                                hovertemplateLabels: M,
                                eventData: [
                                    {
                                        data: h._input,
                                        fullData: h,
                                        count: k,
                                        probability: A
                                    }
                                ]
                            }, {
                                container: p._hoverlayer.node(),
                                outerContainer: p._paper.node(),
                                gd: f
                            });
                        }
                    }
                }
                function v(t1) {
                    if (!t1.parcatsViewModel.dragDimension && (_(n.select(this)), o.loneUnhover(t1.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node()), t1.parcatsViewModel.pathSelection.sort(m), -1 === t1.parcatsViewModel.hoverinfoItems.indexOf("skip"))) {
                        var e1 = y(t1), r = x(t1);
                        t1.parcatsViewModel.graphDiv.emit("plotly_unhover", {
                            points: e1,
                            event: n.event,
                            constraints: r
                        });
                    }
                }
                function y(t1) {
                    for(var e1 = [], r = z(t1.parcatsViewModel), n = 0; n < t1.model.valueInds.length; n++){
                        var i = t1.model.valueInds[n];
                        e1.push({
                            curveNumber: r,
                            pointNumber: i
                        });
                    }
                    return e1;
                }
                function x(t1) {
                    for(var e1 = {}, r = t1.parcatsViewModel.model.dimensions, n = 0; n < r.length; n++){
                        var i = r[n], a = i.categories[t1.model.categoryInds[n]];
                        e1[i.containerInd] = a.categoryValue;
                    }
                    return void 0 !== t1.model.rawColor && (e1.color = t1.model.rawColor), e1;
                }
                function b(t1) {
                    if (-1 === t1.parcatsViewModel.hoverinfoItems.indexOf("skip")) {
                        var e1 = y(t1), r = x(t1);
                        t1.parcatsViewModel.graphDiv.emit("plotly_click", {
                            points: e1,
                            event: n.event,
                            constraints: r
                        });
                    }
                }
                function _(t1) {
                    t1.attr("fill", function(t1) {
                        return t1.model.color;
                    }).attr("fill-opacity", .6).attr("stroke", "lightgray").attr("stroke-width", .2).attr("stroke-opacity", 1);
                }
                function w(t1) {
                    t1.attr("fill-opacity", .8).attr("stroke", function(t1) {
                        return u.mostReadable(t1.model.color, [
                            "black",
                            "white"
                        ]);
                    }).attr("stroke-width", .3);
                }
                function T(t1) {
                    t1.select("rect.catrect").attr("stroke", "black").attr("stroke-width", 1).attr("stroke-opacity", 1);
                }
                function k(t1) {
                    t1.attr("stroke", "black").attr("stroke-width", .2).attr("stroke-opacity", 1).attr("fill-opacity", 1);
                }
                function A(t1) {
                    var e1 = t1.parcatsViewModel.pathSelection, r = t1.categoryViewModel.model.dimensionInd, n = t1.categoryViewModel.model.categoryInd;
                    return e1.filter(function(e1) {
                        return e1.model.categoryInds[r] === n && e1.model.color === t1.color;
                    });
                }
                function M(t1, e1, r) {
                    var i = n.select(t1).datum(), a = i.categoryViewModel.model, o = i.parcatsViewModel.graphDiv, s = n.select(t1.parentNode).selectAll("rect.bandrect"), l = [];
                    s.each(function(t1) {
                        A(t1).each(function(t1) {
                            Array.prototype.push.apply(l, y(t1));
                        });
                    });
                    var c = {};
                    c[a.dimensionInd] = a.categoryValue, o.emit(e1, {
                        points: l,
                        event: r,
                        constraints: c
                    });
                }
                function S(t1, e1, r) {
                    var i = n.select(t1).datum(), a = i.categoryViewModel.model, o = i.parcatsViewModel.graphDiv, s = A(i), l = [];
                    s.each(function(t1) {
                        Array.prototype.push.apply(l, y(t1));
                    });
                    var c = {};
                    c[a.dimensionInd] = a.categoryValue, void 0 !== i.rawColor && (c.color = i.rawColor), o.emit(e1, {
                        points: l,
                        event: r,
                        constraints: c
                    });
                }
                function E(t1, e1, r) {
                    t1._fullLayout._calcInverseTransform(t1);
                    var i, a, o = t1._fullLayout._invScaleX, s = t1._fullLayout._invScaleY, l = n.select(r.parentNode).select("rect.catrect"), c = l.node().getBoundingClientRect(), u = l.datum(), f = u.parcatsViewModel, h = f.model.dimensions[u.model.dimensionInd], p = f.trace, d = c.top + c.height / 2;
                    f.dimensions.length > 1 && h.displayInd === f.dimensions.length - 1 ? (i = c.left, a = "left") : (i = c.left + c.width, a = "right");
                    var m = u.model.count, g = u.model.categoryLabel, v = m / u.parcatsViewModel.model.count, y = {
                        countLabel: m,
                        categoryLabel: g,
                        probabilityLabel: v.toFixed(3)
                    }, x = [];
                    -1 !== u.parcatsViewModel.hoverinfoItems.indexOf("count") && x.push([
                        "Count:",
                        y.countLabel
                    ].join(" ")), -1 !== u.parcatsViewModel.hoverinfoItems.indexOf("probability") && x.push([
                        "P(" + y.categoryLabel + "):",
                        y.probabilityLabel
                    ].join(" "));
                    var b = x.join("<br>");
                    return {
                        trace: p,
                        x: o * (i - e1.left),
                        y: s * (d - e1.top),
                        text: b,
                        color: "lightgray",
                        borderColor: "black",
                        fontFamily: 'Monaco, "Courier New", monospace',
                        fontSize: 12,
                        fontColor: "black",
                        idealAlign: a,
                        hovertemplate: p.hovertemplate,
                        hovertemplateLabels: y,
                        eventData: [
                            {
                                data: p._input,
                                fullData: p,
                                count: m,
                                category: g,
                                probability: v
                            }
                        ]
                    };
                }
                function L(t1) {
                    if (!t1.parcatsViewModel.dragDimension && -1 === t1.parcatsViewModel.hoverinfoItems.indexOf("skip")) {
                        if (n.mouse(this)[1] < -1) return;
                        var e1, r = t1.parcatsViewModel.graphDiv, i = r._fullLayout, a = i._paperdiv.node().getBoundingClientRect(), l = t1.parcatsViewModel.hoveron;
                        if ("color" === l ? (!function(t1) {
                            var e1 = n.select(t1).datum(), r = A(e1);
                            w(r), r.each(function() {
                                s.raiseToTop(this);
                            }), n.select(t1.parentNode).selectAll("rect.bandrect").filter(function(t1) {
                                return t1.color === e1.color;
                            }).each(function() {
                                s.raiseToTop(this), n.select(this).attr("stroke", "black").attr("stroke-width", 1.5);
                            });
                        }(this), S(this, "plotly_hover", n.event)) : (!function(t1) {
                            n.select(t1.parentNode).selectAll("rect.bandrect").each(function(t1) {
                                var e1 = A(t1);
                                w(e1), e1.each(function() {
                                    s.raiseToTop(this);
                                });
                            }), n.select(t1.parentNode).select("rect.catrect").attr("stroke", "black").attr("stroke-width", 2.5);
                        }(this), M(this, "plotly_hover", n.event)), -1 === t1.parcatsViewModel.hoverinfoItems.indexOf("none")) "category" === l ? e1 = E(r, a, this) : "color" === l ? e1 = function(t1, e1, r) {
                            t1._fullLayout._calcInverseTransform(t1);
                            var i, a, o = t1._fullLayout._invScaleX, s = t1._fullLayout._invScaleY, l = r.getBoundingClientRect(), c = n.select(r).datum(), f = c.categoryViewModel, h = f.parcatsViewModel, p = h.model.dimensions[f.model.dimensionInd], d = h.trace, m = l.y + l.height / 2;
                            h.dimensions.length > 1 && p.displayInd === h.dimensions.length - 1 ? (i = l.left, a = "left") : (i = l.left + l.width, a = "right");
                            var g = f.model.categoryLabel, v = c.parcatsViewModel.model.count, y = 0;
                            c.categoryViewModel.bands.forEach(function(t1) {
                                t1.color === c.color && (y += t1.count);
                            });
                            var x = f.model.count, b = 0;
                            h.pathSelection.each(function(t1) {
                                t1.model.color === c.color && (b += t1.model.count);
                            });
                            var _ = y / v, w = y / b, T = y / x, k = {
                                countLabel: v,
                                categoryLabel: g,
                                probabilityLabel: _.toFixed(3)
                            }, A = [];
                            -1 !== f.parcatsViewModel.hoverinfoItems.indexOf("count") && A.push([
                                "Count:",
                                k.countLabel
                            ].join(" ")), -1 !== f.parcatsViewModel.hoverinfoItems.indexOf("probability") && (A.push("P(color \u2229 " + g + "): " + k.probabilityLabel), A.push("P(" + g + " | color): " + w.toFixed(3)), A.push("P(color | " + g + "): " + T.toFixed(3)));
                            var M = A.join("<br>"), S = u.mostReadable(c.color, [
                                "black",
                                "white"
                            ]);
                            return {
                                trace: d,
                                x: o * (i - e1.left),
                                y: s * (m - e1.top),
                                text: M,
                                color: c.color,
                                borderColor: "black",
                                fontFamily: 'Monaco, "Courier New", monospace',
                                fontColor: S,
                                fontSize: 10,
                                idealAlign: a,
                                hovertemplate: d.hovertemplate,
                                hovertemplateLabels: k,
                                eventData: [
                                    {
                                        data: d._input,
                                        fullData: d,
                                        category: g,
                                        count: v,
                                        probability: _,
                                        categorycount: x,
                                        colorcount: b,
                                        bandcolorcount: y
                                    }
                                ]
                            };
                        }(r, a, this) : "dimension" === l && (e1 = function(t1, e1, r) {
                            var i = [];
                            return n.select(r.parentNode.parentNode).selectAll("g.category").select("rect.catrect").each(function() {
                                i.push(E(t1, e1, this));
                            }), i;
                        }(r, a, this)), e1 && o.loneHover(e1, {
                            container: i._hoverlayer.node(),
                            outerContainer: i._paper.node(),
                            gd: r
                        });
                    }
                }
                function C(t1) {
                    var e1 = t1.parcatsViewModel;
                    if (!e1.dragDimension && (_(e1.pathSelection), T(e1.dimensionSelection.selectAll("g.category")), k(e1.dimensionSelection.selectAll("g.category").selectAll("rect.bandrect")), o.loneUnhover(e1.graphDiv._fullLayout._hoverlayer.node()), e1.pathSelection.sort(m), -1 === e1.hoverinfoItems.indexOf("skip"))) "color" === t1.parcatsViewModel.hoveron ? S(this, "plotly_unhover", n.event) : M(this, "plotly_unhover", n.event);
                }
                function P(t1) {
                    "fixed" !== t1.parcatsViewModel.arrangement && (t1.dragDimensionDisplayInd = t1.model.displayInd, t1.initialDragDimensionDisplayInds = t1.parcatsViewModel.model.dimensions.map(function(t1) {
                        return t1.displayInd;
                    }), t1.dragHasMoved = !1, t1.dragCategoryDisplayInd = null, n.select(this).selectAll("g.category").select("rect.catrect").each(function(e1) {
                        var r = n.mouse(this)[0], i = n.mouse(this)[1];
                        -2 <= r && r <= e1.width + 2 && -2 <= i && i <= e1.height + 2 && (t1.dragCategoryDisplayInd = e1.model.displayInd, t1.initialDragCategoryDisplayInds = t1.model.categories.map(function(t1) {
                            return t1.displayInd;
                        }), e1.model.dragY = e1.y, s.raiseToTop(this.parentNode), n.select(this.parentNode).selectAll("rect.bandrect").each(function(e1) {
                            e1.y < i && i <= e1.y + e1.height && (t1.potentialClickBand = this);
                        }));
                    }), t1.parcatsViewModel.dragDimension = t1, o.loneUnhover(t1.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node()));
                }
                function I(t1) {
                    if ("fixed" !== t1.parcatsViewModel.arrangement && (t1.dragHasMoved = !0, null !== t1.dragDimensionDisplayInd)) {
                        var e1 = t1.dragDimensionDisplayInd, r = e1 - 1, i = e1 + 1, a = t1.parcatsViewModel.dimensions[e1];
                        if (null !== t1.dragCategoryDisplayInd) {
                            var o = a.categories[t1.dragCategoryDisplayInd];
                            o.model.dragY += n.event.dy;
                            var s = o.model.dragY, l = o.model.displayInd, c = a.categories, u = c[l - 1], f = c[l + 1];
                            void 0 !== u && s < u.y + u.height / 2 && (o.model.displayInd = u.model.displayInd, u.model.displayInd = l), void 0 !== f && s + o.height > f.y + f.height / 2 && (o.model.displayInd = f.model.displayInd, f.model.displayInd = l), t1.dragCategoryDisplayInd = o.model.displayInd;
                        }
                        if (null === t1.dragCategoryDisplayInd || "freeform" === t1.parcatsViewModel.arrangement) {
                            a.model.dragX = n.event.x;
                            var h = t1.parcatsViewModel.dimensions[r], p = t1.parcatsViewModel.dimensions[i];
                            void 0 !== h && a.model.dragX < h.x + h.width && (a.model.displayInd = h.model.displayInd, h.model.displayInd = e1), void 0 !== p && a.model.dragX + a.width > p.x && (a.model.displayInd = p.model.displayInd, p.model.displayInd = t1.dragDimensionDisplayInd), t1.dragDimensionDisplayInd = a.model.displayInd;
                        }
                        j(t1.parcatsViewModel), N(t1.parcatsViewModel), R(t1.parcatsViewModel), D(t1.parcatsViewModel);
                    }
                }
                function O(t1) {
                    if ("fixed" !== t1.parcatsViewModel.arrangement && null !== t1.dragDimensionDisplayInd) {
                        n.select(this).selectAll("text").attr("font-weight", "normal");
                        var e1 = {}, r = z(t1.parcatsViewModel), i = t1.parcatsViewModel.model.dimensions.map(function(t1) {
                            return t1.displayInd;
                        }), o = t1.initialDragDimensionDisplayInds.some(function(t1, e1) {
                            return t1 !== i[e1];
                        });
                        o && i.forEach(function(r, n) {
                            var i = t1.parcatsViewModel.model.dimensions[n].containerInd;
                            e1["dimensions[" + i + "].displayindex"] = r;
                        });
                        var s = !1;
                        if (null !== t1.dragCategoryDisplayInd) {
                            var l = t1.model.categories.map(function(t1) {
                                return t1.displayInd;
                            });
                            if (s = t1.initialDragCategoryDisplayInds.some(function(t1, e1) {
                                return t1 !== l[e1];
                            })) {
                                var c = t1.model.categories.slice().sort(function(t1, e1) {
                                    return t1.displayInd - e1.displayInd;
                                }), u = c.map(function(t1) {
                                    return t1.categoryValue;
                                }), f = c.map(function(t1) {
                                    return t1.categoryLabel;
                                });
                                e1["dimensions[" + t1.model.containerInd + "].categoryarray"] = [
                                    u
                                ], e1["dimensions[" + t1.model.containerInd + "].ticktext"] = [
                                    f
                                ], e1["dimensions[" + t1.model.containerInd + "].categoryorder"] = "array";
                            }
                        }
                        if (-1 === t1.parcatsViewModel.hoverinfoItems.indexOf("skip") && !t1.dragHasMoved && t1.potentialClickBand && ("color" === t1.parcatsViewModel.hoveron ? S(t1.potentialClickBand, "plotly_click", n.event.sourceEvent) : M(t1.potentialClickBand, "plotly_click", n.event.sourceEvent)), t1.model.dragX = null, null !== t1.dragCategoryDisplayInd) t1.parcatsViewModel.dimensions[t1.dragDimensionDisplayInd].categories[t1.dragCategoryDisplayInd].model.dragY = null, t1.dragCategoryDisplayInd = null;
                        t1.dragDimensionDisplayInd = null, t1.parcatsViewModel.dragDimension = null, t1.dragHasMoved = null, t1.potentialClickBand = null, j(t1.parcatsViewModel), N(t1.parcatsViewModel), n.transition().duration(300).ease("cubic-in-out").each(function() {
                            R(t1.parcatsViewModel, !0), D(t1.parcatsViewModel, !0);
                        }).each("end", function() {
                            (o || s) && a.restyle(t1.parcatsViewModel.graphDiv, e1, [
                                r
                            ]);
                        });
                    }
                }
                function z(t1) {
                    for(var e1, r = t1.graphDiv._fullData, n = 0; n < r.length; n++)if (t1.key === r[n].uid) {
                        e1 = n;
                        break;
                    }
                    return e1;
                }
                function D(t1, e1) {
                    var r;
                    void 0 === e1 && (e1 = !1), t1.pathSelection.data(function(t1) {
                        return t1.paths;
                    }, p), (r = t1.pathSelection, e1 ? r.transition() : r).attr("d", function(t1) {
                        return t1.svgD;
                    });
                }
                function R(t1, e1) {
                    function r(t1) {
                        return e1 ? t1.transition() : t1;
                    }
                    void 0 === e1 && (e1 = !1), t1.dimensionSelection.data(function(t1) {
                        return t1.dimensions;
                    }, p);
                    var i = t1.dimensionSelection.selectAll("g.category").data(function(t1) {
                        return t1.categories;
                    }, p);
                    r(t1.dimensionSelection).attr("transform", function(t1) {
                        return l(t1.x, 0);
                    }), r(i).attr("transform", function(t1) {
                        return l(0, t1.y);
                    }), i.select(".dimlabel").text(function(t1, e1) {
                        return 0 === e1 ? t1.parcatsViewModel.model.dimensions[t1.model.dimensionInd].dimensionLabel : null;
                    }), i.select(".catlabel").attr("text-anchor", function(t1) {
                        return d(t1) ? "start" : "end";
                    }).attr("x", function(t1) {
                        return d(t1) ? t1.width + 5 : -5;
                    }).each(function(t1) {
                        var e1, r;
                        d(t1) ? (e1 = t1.width + 5, r = "start") : (e1 = -5, r = "end"), n.select(this).selectAll("tspan").attr("x", e1).attr("text-anchor", r);
                    });
                    var a = i.selectAll("rect.bandrect").data(function(t1) {
                        return t1.bands;
                    }, p), o = a.enter().append("rect").attr("class", "bandrect").attr("cursor", "move").attr("stroke-opacity", 0).attr("fill", function(t1) {
                        return t1.color;
                    }).attr("fill-opacity", 0);
                    a.attr("fill", function(t1) {
                        return t1.color;
                    }).attr("width", function(t1) {
                        return t1.width;
                    }).attr("height", function(t1) {
                        return t1.height;
                    }).attr("y", function(t1) {
                        return t1.y;
                    }), k(o), a.each(function() {
                        s.raiseToTop(this);
                    }), a.exit().remove();
                }
                function F(t1, e1, r) {
                    var n, i = r[0], a = e1.margin || {
                        l: 80,
                        r: 80,
                        t: 100,
                        b: 80
                    }, o = i.trace, s = o.domain, l = e1.width, c = e1.height, u = Math.floor(l * (s.x[1] - s.x[0])), f = Math.floor(c * (s.y[1] - s.y[0])), h = s.x[0] * l + a.l, p = e1.height - s.y[1] * e1.height + a.t, d = o.line.shape;
                    n = "all" === o.hoverinfo ? [
                        "count",
                        "probability"
                    ] : (o.hoverinfo || "").split("+");
                    var m = {
                        trace: o,
                        key: o.uid,
                        model: i,
                        x: h,
                        y: p,
                        width: u,
                        height: f,
                        hoveron: o.hoveron,
                        hoverinfoItems: n,
                        arrangement: o.arrangement,
                        bundlecolors: o.bundlecolors,
                        sortpaths: o.sortpaths,
                        labelfont: o.labelfont,
                        categorylabelfont: o.tickfont,
                        pathShape: d,
                        dragDimension: null,
                        margin: a,
                        paths: [],
                        dimensions: [],
                        graphDiv: t1,
                        traceSelection: null,
                        pathSelection: null,
                        dimensionSelection: null
                    };
                    return i.dimensions && (j(m), N(m)), m;
                }
                function B(t1, e1, r, n, a) {
                    var o, s, l = [], c = [];
                    for(s = 0; s < r.length - 1; s++)o = i(r[s] + t1[s], t1[s + 1]), l.push(o(a)), c.push(o(1 - a));
                    var u = "M " + t1[0] + "," + e1[0];
                    for(u += "l" + r[0] + ",0 ", s = 1; s < r.length; s++)u += "C" + l[s - 1] + "," + e1[s - 1] + " " + c[s - 1] + "," + e1[s] + " " + t1[s] + "," + e1[s], u += "l" + r[s] + ",0 ";
                    for(u += "l0," + n + " ", u += "l -" + r[r.length - 1] + ",0 ", s = r.length - 2; s >= 0; s--)u += "C" + c[s] + "," + (e1[s + 1] + n) + " " + l[s] + "," + (e1[s] + n) + " " + (t1[s] + r[s]) + "," + (e1[s] + n), u += "l-" + r[s] + ",0 ";
                    return u += "Z";
                }
                function N(t1) {
                    var e1 = t1.dimensions, r = t1.model, n = e1.map(function(t1) {
                        return t1.categories.map(function(t1) {
                            return t1.y;
                        });
                    }), i = t1.model.dimensions.map(function(t1) {
                        return t1.categories.map(function(t1) {
                            return t1.displayInd;
                        });
                    }), a = t1.model.dimensions.map(function(t1) {
                        return t1.displayInd;
                    }), o = t1.dimensions.map(function(t1) {
                        return t1.model.dimensionInd;
                    }), s = e1.map(function(t1) {
                        return t1.x;
                    }), l = e1.map(function(t1) {
                        return t1.width;
                    }), c = [];
                    for(var u in r.paths)r.paths.hasOwnProperty(u) && c.push(r.paths[u]);
                    function f(t1) {
                        var e1 = t1.categoryInds.map(function(t1, e1) {
                            return i[e1][t1];
                        });
                        return o.map(function(t1) {
                            return e1[t1];
                        });
                    }
                    c.sort(function(e1, r) {
                        var n = f(e1), i = f(r);
                        return "backward" === t1.sortpaths && (n.reverse(), i.reverse()), n.push(e1.valueInds[0]), i.push(r.valueInds[0]), t1.bundlecolors && (n.unshift(e1.rawColor), i.unshift(r.rawColor)), n < i ? -1 : n > i ? 1 : 0;
                    });
                    for(var h = new Array(c.length), p = e1[0].model.count, d = e1[0].categories.map(function(t1) {
                        return t1.height;
                    }).reduce(function(t1, e1) {
                        return t1 + e1;
                    }), m = 0; m < c.length; m++){
                        var g, v = c[m];
                        g = p > 0 ? d * (v.count / p) : 0;
                        for(var y, x = new Array(n.length), b = 0; b < v.categoryInds.length; b++){
                            var _ = v.categoryInds[b], w = i[b][_], T = a[b];
                            x[T] = n[T][w], n[T][w] += g;
                            var k = t1.dimensions[T].categories[w], A = k.bands.length, M = k.bands[A - 1];
                            if (void 0 === M || v.rawColor !== M.rawColor) {
                                var S = void 0 === M ? 0 : M.y + M.height;
                                k.bands.push({
                                    key: S,
                                    color: v.color,
                                    rawColor: v.rawColor,
                                    height: g,
                                    width: k.width,
                                    count: v.count,
                                    y: S,
                                    categoryViewModel: k,
                                    parcatsViewModel: t1
                                });
                            } else {
                                var E = k.bands[A - 1];
                                E.height += g, E.count += v.count;
                            }
                        }
                        y = "hspline" === t1.pathShape ? B(s, x, l, g, .5) : B(s, x, l, g, 0), h[m] = {
                            key: v.valueInds[0],
                            model: v,
                            height: g,
                            leftXs: s,
                            topYs: x,
                            dimWidths: l,
                            svgD: y,
                            parcatsViewModel: t1
                        };
                    }
                    t1.paths = h;
                }
                function j(t1) {
                    var e1 = t1.model.dimensions.map(function(t1) {
                        return {
                            displayInd: t1.displayInd,
                            dimensionInd: t1.dimensionInd
                        };
                    });
                    e1.sort(function(t1, e1) {
                        return t1.displayInd - e1.displayInd;
                    });
                    var r = [];
                    for(var n in e1){
                        var i = e1[n].dimensionInd, a = t1.model.dimensions[i];
                        r.push(U(t1, a));
                    }
                    t1.dimensions = r;
                }
                function U(t1, e1) {
                    var r, n = t1.model.dimensions.length, i = e1.displayInd;
                    r = 40 + (n > 1 ? (t1.width - 80 - 16) / (n - 1) : 0) * i;
                    var a, o, s, l, c, u = [], f = t1.model.maxCats, h = e1.categories.length, p = e1.count, d = t1.height - 8 * (f - 1), m = 8 * (f - h) / 2, g = e1.categories.map(function(t1) {
                        return {
                            displayInd: t1.displayInd,
                            categoryInd: t1.categoryInd
                        };
                    });
                    for(g.sort(function(t1, e1) {
                        return t1.displayInd - e1.displayInd;
                    }), c = 0; c < h; c++)l = g[c].categoryInd, o = e1.categories[l], a = p > 0 ? o.count / p * d : 0, s = {
                        key: o.valueInds[0],
                        model: o,
                        width: 16,
                        height: a,
                        y: null !== o.dragY ? o.dragY : m,
                        bands: [],
                        parcatsViewModel: t1
                    }, m = m + a + 8, u.push(s);
                    return {
                        key: e1.dimensionInd,
                        x: null !== e1.dragX ? e1.dragX : r,
                        y: 0,
                        width: 16,
                        model: e1,
                        categories: u,
                        parcatsViewModel: t1,
                        dragCategoryDisplayInd: null,
                        dragDimensionDisplayInd: null,
                        initialDragDimensionDisplayInds: null,
                        initialDragCategoryDisplayInds: null,
                        dragHasMoved: null,
                        potentialClickBand: null
                    };
                }
                e1.exports = function(t1, e1, r, n) {
                    h(r, t1, n, e1);
                };
            },
            {
                "../../components/drawing": 388,
                "../../components/fx": 406,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../plot_api/plot_api": 540,
                "@plotly/d3": 58,
                "d3-interpolate": 116,
                tinycolor2: 312
            }
        ],
        887: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./parcats");
                e1.exports = function(t1, e1, r, i) {
                    var a = t1._fullLayout, o = a._paper, s = a._size;
                    n(t1, o, e1, {
                        width: s.w,
                        height: s.h,
                        margin: {
                            t: s.t,
                            r: s.r,
                            b: s.b,
                            l: s.l
                        }
                    }, r, i);
                };
            },
            {
                "./parcats": 886
            }
        ],
        888: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/attributes"), i = t1("../../plots/cartesian/layout_attributes"), a = t1("../../plots/font_attributes"), o = t1("../../plots/domain").attributes, s = t1("../../lib/extend").extendFlat, l = t1("../../plot_api/plot_template").templatedArray;
                e1.exports = {
                    domain: o({
                        name: "parcoords",
                        trace: !0,
                        editType: "plot"
                    }),
                    labelangle: {
                        valType: "angle",
                        dflt: 0,
                        editType: "plot"
                    },
                    labelside: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "bottom"
                        ],
                        dflt: "top",
                        editType: "plot"
                    },
                    labelfont: a({
                        editType: "plot"
                    }),
                    tickfont: a({
                        editType: "plot"
                    }),
                    rangefont: a({
                        editType: "plot"
                    }),
                    dimensions: l("dimension", {
                        label: {
                            valType: "string",
                            editType: "plot"
                        },
                        tickvals: s({}, i.tickvals, {
                            editType: "plot"
                        }),
                        ticktext: s({}, i.ticktext, {
                            editType: "plot"
                        }),
                        tickformat: s({}, i.tickformat, {
                            editType: "plot"
                        }),
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        range: {
                            valType: "info_array",
                            items: [
                                {
                                    valType: "number",
                                    editType: "plot"
                                },
                                {
                                    valType: "number",
                                    editType: "plot"
                                }
                            ],
                            editType: "plot"
                        },
                        constraintrange: {
                            valType: "info_array",
                            freeLength: !0,
                            dimensions: "1-2",
                            items: [
                                {
                                    valType: "any",
                                    editType: "plot"
                                },
                                {
                                    valType: "any",
                                    editType: "plot"
                                }
                            ],
                            editType: "plot"
                        },
                        multiselect: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        values: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        editType: "calc"
                    }),
                    line: s({
                        editType: "calc"
                    }, n("line", {
                        colorscaleDflt: "Viridis",
                        autoColorDflt: !1,
                        editTypeOverride: "calc"
                    }))
                };
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plot_api/plot_template": 543,
                "../../plots/cartesian/layout_attributes": 569,
                "../../plots/domain": 584,
                "../../plots/font_attributes": 585
            }
        ],
        889: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./constants"), i = t1("@plotly/d3"), a = t1("../../lib/gup").keyFun, o = t1("../../lib/gup").repeat, s = t1("../../lib").sorterAsc, l = t1("../../lib").strTranslate, c = n.bar.snapRatio;
                function u(t1, e1) {
                    return t1 * (1 - c) + e1 * c;
                }
                var f = n.bar.snapClose;
                function h(t1, e1) {
                    return t1 * (1 - f) + e1 * f;
                }
                function p(t1, e1, r, n) {
                    if (function(t1, e1) {
                        for(var r = 0; r < e1.length; r++)if (t1 >= e1[r][0] && t1 <= e1[r][1]) return !0;
                        return !1;
                    }(r, n)) return r;
                    var i = t1 ? -1 : 1, a = 0, o = e1.length - 1;
                    if (i < 0) {
                        var s = a;
                        a = o, o = s;
                    }
                    for(var l = e1[a], c = l, f = a; i * f < i * o; f += i){
                        var p = f + i, d = e1[p];
                        if (i * r < i * h(l, d)) return u(l, c);
                        if (i * r < i * d || p === o) return u(d, l);
                        c = l, l = d;
                    }
                }
                function d(t1) {
                    t1.attr("x", -n.bar.captureWidth / 2).attr("width", n.bar.captureWidth);
                }
                function m(t1) {
                    t1.attr("visibility", "visible").style("visibility", "visible").attr("fill", "yellow").attr("opacity", 0);
                }
                function g(t1) {
                    if (!t1.brush.filterSpecified) return "0," + t1.height;
                    for(var e1, r, n, i = v(t1.brush.filter.getConsolidated(), t1.height), a = [
                        0
                    ], o = i.length ? i[0][0] : null, s = 0; s < i.length; s++)r = (e1 = i[s])[1] - e1[0], a.push(o), a.push(r), (n = s + 1) < i.length && (o = i[n][0] - e1[1]);
                    return a.push(t1.height), a;
                }
                function v(t1, e1) {
                    return t1.map(function(t1) {
                        return t1.map(function(t1) {
                            return Math.max(0, t1 * e1);
                        }).sort(s);
                    });
                }
                function y() {
                    i.select(document.body).style("cursor", null);
                }
                function x(t1) {
                    t1.attr("stroke-dasharray", g);
                }
                function b(t1, e1) {
                    var r = i.select(t1).selectAll(".highlight, .highlight-shadow");
                    x(e1 ? r.transition().duration(n.bar.snapDuration).each("end", e1) : r);
                }
                function _(t1, e1) {
                    var r, i = t1.brush, a = NaN, o = {};
                    if (i.filterSpecified) {
                        var s = t1.height, l = i.filter.getConsolidated(), c = v(l, s), u = NaN, f = NaN, h = NaN;
                        for(r = 0; r <= c.length; r++){
                            var p = c[r];
                            if (p && p[0] <= e1 && e1 <= p[1]) {
                                u = r;
                                break;
                            }
                            if (f = r ? r - 1 : NaN, p && p[0] > e1) {
                                h = r;
                                break;
                            }
                        }
                        if (a = u, isNaN(a) && (a = isNaN(f) || isNaN(h) ? isNaN(f) ? h : f : e1 - c[f][1] < c[h][0] - e1 ? f : h), !isNaN(a)) {
                            var d = c[a], m = function(t1, e1) {
                                var r = n.bar.handleHeight;
                                if (!(e1 > t1[1] + r || e1 < t1[0] - r)) return e1 >= .9 * t1[1] + .1 * t1[0] ? "n" : e1 <= .9 * t1[0] + .1 * t1[1] ? "s" : "ns";
                            }(d, e1);
                            m && (o.interval = l[a], o.intervalPix = d, o.region = m);
                        }
                    }
                    if (t1.ordinal && !o.region) {
                        var g = t1.unitTickvals, y = t1.unitToPaddedPx.invert(e1);
                        for(r = 0; r < g.length; r++){
                            var x = [
                                .25 * g[Math.max(r - 1, 0)] + .75 * g[r],
                                .25 * g[Math.min(r + 1, g.length - 1)] + .75 * g[r]
                            ];
                            if (y >= x[0] && y <= x[1]) {
                                o.clickableOrdinalRange = x;
                                break;
                            }
                        }
                    }
                    return o;
                }
                function w(t1, e1) {
                    i.event.sourceEvent.stopPropagation();
                    var r = e1.height - i.mouse(t1)[1] - 2 * n.verticalPadding, a = e1.brush.svgBrush;
                    a.wasDragged = !0, a._dragging = !0, a.grabbingBar ? a.newExtent = [
                        r - a.grabPoint,
                        r + a.barLength - a.grabPoint
                    ].map(e1.unitToPaddedPx.invert) : a.newExtent = [
                        a.startExtent,
                        e1.unitToPaddedPx.invert(r)
                    ].sort(s), e1.brush.filterSpecified = !0, a.extent = a.stayingIntervals.concat([
                        a.newExtent
                    ]), a.brushCallback(e1), b(t1.parentNode);
                }
                function T(t1, e1) {
                    var r = _(e1, e1.height - i.mouse(t1)[1] - 2 * n.verticalPadding), a = "crosshair";
                    r.clickableOrdinalRange ? a = "pointer" : r.region && (a = r.region + "-resize"), i.select(document.body).style("cursor", a);
                }
                function k(t1) {
                    t1.on("mousemove", function(t1) {
                        i.event.preventDefault(), t1.parent.inBrushDrag || T(this, t1);
                    }).on("mouseleave", function(t1) {
                        t1.parent.inBrushDrag || y();
                    }).call(i.behavior.drag().on("dragstart", function(t1) {
                        !function(t1, e1) {
                            i.event.sourceEvent.stopPropagation();
                            var r = e1.height - i.mouse(t1)[1] - 2 * n.verticalPadding, a = e1.unitToPaddedPx.invert(r), o = e1.brush, s = _(e1, r), l = s.interval, c = o.svgBrush;
                            if (c.wasDragged = !1, c.grabbingBar = "ns" === s.region, c.grabbingBar) {
                                var u = l.map(e1.unitToPaddedPx);
                                c.grabPoint = r - u[0] - n.verticalPadding, c.barLength = u[1] - u[0];
                            }
                            c.clickableOrdinalRange = s.clickableOrdinalRange, c.stayingIntervals = e1.multiselect && o.filterSpecified ? o.filter.getConsolidated() : [], l && (c.stayingIntervals = c.stayingIntervals.filter(function(t1) {
                                return t1[0] !== l[0] && t1[1] !== l[1];
                            })), c.startExtent = s.region ? l["s" === s.region ? 1 : 0] : a, e1.parent.inBrushDrag = !0, c.brushStartCallback();
                        }(this, t1);
                    }).on("drag", function(t1) {
                        w(this, t1);
                    }).on("dragend", function(t1) {
                        !function(t1, e1) {
                            var r = e1.brush, n = r.filter, a = r.svgBrush;
                            a._dragging || (T(t1, e1), w(t1, e1), e1.brush.svgBrush.wasDragged = !1), a._dragging = !1, i.event.sourceEvent.stopPropagation();
                            var o = a.grabbingBar;
                            if (a.grabbingBar = !1, a.grabLocation = void 0, e1.parent.inBrushDrag = !1, y(), !a.wasDragged) return a.wasDragged = void 0, a.clickableOrdinalRange ? r.filterSpecified && e1.multiselect ? a.extent.push(a.clickableOrdinalRange) : (a.extent = [
                                a.clickableOrdinalRange
                            ], r.filterSpecified = !0) : o ? (a.extent = a.stayingIntervals, 0 === a.extent.length && M(r)) : M(r), a.brushCallback(e1), b(t1.parentNode), void a.brushEndCallback(r.filterSpecified ? n.getConsolidated() : []);
                            var s = function() {
                                n.set(n.getConsolidated());
                            };
                            if (e1.ordinal) {
                                var l = e1.unitTickvals;
                                l[l.length - 1] < l[0] && l.reverse(), a.newExtent = [
                                    p(0, l, a.newExtent[0], a.stayingIntervals),
                                    p(1, l, a.newExtent[1], a.stayingIntervals)
                                ];
                                var c = a.newExtent[1] > a.newExtent[0];
                                a.extent = a.stayingIntervals.concat(c ? [
                                    a.newExtent
                                ] : []), a.extent.length || M(r), a.brushCallback(e1), c ? b(t1.parentNode, s) : (s(), b(t1.parentNode));
                            } else s();
                            a.brushEndCallback(r.filterSpecified ? n.getConsolidated() : []);
                        }(this, t1);
                    }));
                }
                function A(t1, e1) {
                    return t1[0] - e1[0];
                }
                function M(t1) {
                    t1.filterSpecified = !1, t1.svgBrush.extent = [
                        [
                            -1 / 0,
                            1 / 0
                        ]
                    ];
                }
                function S(t1) {
                    for(var e1, r = t1.slice(), n = [], i = r.shift(); i;){
                        for(e1 = i.slice(); (i = r.shift()) && i[0] <= e1[1];)e1[1] = Math.max(e1[1], i[1]);
                        n.push(e1);
                    }
                    return 1 === n.length && n[0][0] > n[0][1] && (n = []), n;
                }
                e1.exports = {
                    makeBrush: function(t1, e1, r, n, i, a) {
                        var o, l = function() {
                            var t1, e1, r = [];
                            return {
                                set: function(n) {
                                    1 === (r = n.map(function(t1) {
                                        return t1.slice().sort(s);
                                    }).sort(A)).length && r[0][0] === -1 / 0 && r[0][1] === 1 / 0 && (r = [
                                        [
                                            0,
                                            -1
                                        ]
                                    ]), t1 = S(r), e1 = r.reduce(function(t1, e1) {
                                        return [
                                            Math.min(t1[0], e1[0]),
                                            Math.max(t1[1], e1[1])
                                        ];
                                    }, [
                                        1 / 0,
                                        -1 / 0
                                    ]);
                                },
                                get: function() {
                                    return r.slice();
                                },
                                getConsolidated: function() {
                                    return t1;
                                },
                                getBounds: function() {
                                    return e1;
                                }
                            };
                        }();
                        return l.set(r), {
                            filter: l,
                            filterSpecified: e1,
                            svgBrush: {
                                extent: [],
                                brushStartCallback: n,
                                brushCallback: (o = i, function(t1) {
                                    var e1 = t1.brush, r = (function(t1) {
                                        return t1.svgBrush.extent.map(function(t1) {
                                            return t1.slice();
                                        });
                                    })(e1).slice();
                                    e1.filter.set(r), o();
                                }),
                                brushEndCallback: a
                            }
                        };
                    },
                    ensureAxisBrush: function(t1, e1) {
                        var r = t1.selectAll("." + n.cn.axisBrush).data(o, a);
                        r.enter().append("g").classed(n.cn.axisBrush, !0), function(t1, e1) {
                            var r = t1.selectAll(".background").data(o);
                            r.enter().append("rect").classed("background", !0).call(d).call(m).style("pointer-events", "auto").attr("transform", l(0, n.verticalPadding)), r.call(k).attr("height", function(t1) {
                                return t1.height - n.verticalPadding;
                            });
                            var i = t1.selectAll(".highlight-shadow").data(o);
                            i.enter().append("line").classed("highlight-shadow", !0).attr("x", -n.bar.width / 2).attr("stroke-width", n.bar.width + n.bar.strokeWidth).attr("stroke", e1).attr("opacity", n.bar.strokeOpacity).attr("stroke-linecap", "butt"), i.attr("y1", function(t1) {
                                return t1.height;
                            }).call(x);
                            var a = t1.selectAll(".highlight").data(o);
                            a.enter().append("line").classed("highlight", !0).attr("x", -n.bar.width / 2).attr("stroke-width", n.bar.width - n.bar.strokeWidth).attr("stroke", n.bar.fillColor).attr("opacity", n.bar.fillOpacity).attr("stroke-linecap", "butt"), a.attr("y1", function(t1) {
                                return t1.height;
                            }).call(x);
                        }(r, e1);
                    },
                    cleanRanges: function(t1, e1) {
                        if (Array.isArray(t1[0]) ? (t1 = t1.map(function(t1) {
                            return t1.sort(s);
                        }), t1 = e1.multiselect ? S(t1.sort(A)) : [
                            t1[0]
                        ]) : t1 = [
                            t1.sort(s)
                        ], e1.tickvals) {
                            var r = e1.tickvals.slice().sort(s);
                            if (!(t1 = t1.map(function(t1) {
                                var e1 = [
                                    p(0, r, t1[0], []),
                                    p(1, r, t1[1], [])
                                ];
                                if (e1[1] > e1[0]) return e1;
                            }).filter(function(t1) {
                                return t1;
                            })).length) return;
                        }
                        return t1.length > 1 ? t1 : t1[0];
                    }
                };
            },
            {
                "../../lib": 503,
                "../../lib/gup": 500,
                "./constants": 892,
                "@plotly/d3": 58
            }
        ],
        890: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../plots/get_data").getModuleCalcData, a = t1("./plot"), o = t1("../../constants/xmlns_namespaces");
                r.name = "parcoords", r.plot = function(t1) {
                    var e1 = i(t1.calcdata, "parcoords")[0];
                    e1.length && a(t1, e1);
                }, r.clean = function(t1, e1, r, n) {
                    var i = n._has && n._has("parcoords"), a = e1._has && e1._has("parcoords");
                    i && !a && (n._paperdiv.selectAll(".parcoords").remove(), n._glimages.selectAll("*").remove());
                }, r.toSVG = function(t1) {
                    var e1 = t1._fullLayout._glimages, r = n.select(t1).selectAll(".svg-container");
                    r.filter(function(t1, e1) {
                        return e1 === r.size() - 1;
                    }).selectAll(".gl-canvas-context, .gl-canvas-focus").each(function() {
                        var t1 = this.toDataURL("image/png");
                        e1.append("svg:image").attr({
                            xmlns: o.svg,
                            "xlink:href": t1,
                            preserveAspectRatio: "none",
                            x: 0,
                            y: 0,
                            width: this.style.width,
                            height: this.style.height
                        });
                    }), window.setTimeout(function() {
                        n.selectAll("#filterBarPattern").attr("id", "filterBarPattern");
                    }, 60);
                };
            },
            {
                "../../constants/xmlns_namespaces": 480,
                "../../plots/get_data": 593,
                "./plot": 899,
                "@plotly/d3": 58
            }
        ],
        891: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").isArrayOrTypedArray, i = t1("../../components/colorscale"), a = t1("../../lib/gup").wrap;
                e1.exports = function(t1, e1) {
                    var r, o;
                    return i.hasColorscale(e1, "line") && n(e1.line.color) ? (r = e1.line.color, o = i.extractOpts(e1.line).colorscale, i.calc(t1, e1, {
                        vals: r,
                        containerStr: "line",
                        cLetter: "c"
                    })) : (r = function(t1) {
                        for(var e1 = new Array(t1), r = 0; r < t1; r++)e1[r] = .5;
                        return e1;
                    }(e1._length), o = [
                        [
                            0,
                            e1.line.color
                        ],
                        [
                            1,
                            e1.line.color
                        ]
                    ]), a({
                        lineColor: r,
                        cscale: o
                    });
                };
            },
            {
                "../../components/colorscale": 378,
                "../../lib": 503,
                "../../lib/gup": 500
            }
        ],
        892: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    maxDimensionCount: 60,
                    overdrag: 45,
                    verticalPadding: 2,
                    tickDistance: 50,
                    canvasPixelRatio: 1,
                    blockLineCount: 5e3,
                    layers: [
                        "contextLineLayer",
                        "focusLineLayer",
                        "pickLineLayer"
                    ],
                    axisTitleOffset: 28,
                    axisExtentOffset: 10,
                    deselectedLineColor: "#777",
                    bar: {
                        width: 4,
                        captureWidth: 10,
                        fillColor: "magenta",
                        fillOpacity: 1,
                        snapDuration: 150,
                        snapRatio: .25,
                        snapClose: .01,
                        strokeOpacity: 1,
                        strokeWidth: 1,
                        handleHeight: 8,
                        handleOpacity: 1,
                        handleOverlap: 0
                    },
                    cn: {
                        axisExtentText: "axis-extent-text",
                        parcoordsLineLayers: "parcoords-line-layers",
                        parcoordsLineLayer: "parcoords-lines",
                        parcoords: "parcoords",
                        parcoordsControlView: "parcoords-control-view",
                        yAxis: "y-axis",
                        axisOverlays: "axis-overlays",
                        axis: "axis",
                        axisHeading: "axis-heading",
                        axisTitle: "axis-title",
                        axisExtent: "axis-extent",
                        axisExtentTop: "axis-extent-top",
                        axisExtentTopText: "axis-extent-top-text",
                        axisExtentBottom: "axis-extent-bottom",
                        axisExtentBottomText: "axis-extent-bottom-text",
                        axisBrush: "axis-brush"
                    },
                    id: {
                        filterBarPattern: "filter-bar-pattern"
                    }
                };
            },
            {}
        ],
        893: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/colorscale/helpers").hasColorscale, a = t1("../../components/colorscale/defaults"), o = t1("../../plots/domain").defaults, s = t1("../../plots/array_container_defaults"), l = t1("../../plots/cartesian/axes"), c = t1("./attributes"), u = t1("./axisbrush"), f = t1("./constants").maxDimensionCount, h = t1("./merge_length");
                function p(t1, e1, r, i) {
                    function a(r, i) {
                        return n.coerce(t1, e1, c.dimensions, r, i);
                    }
                    var o = a("values"), s = a("visible");
                    if (o && o.length || (s = e1.visible = !1), s) {
                        a("label"), a("tickvals"), a("ticktext"), a("tickformat");
                        var f = a("range");
                        e1._ax = {
                            _id: "y",
                            type: "linear",
                            showexponent: "all",
                            exponentformat: "B",
                            range: f
                        }, l.setConvert(e1._ax, i.layout), a("multiselect");
                        var h = a("constraintrange");
                        h && (e1.constraintrange = u.cleanRanges(h, e1));
                    }
                }
                e1.exports = function(t1, e1, r, l) {
                    function u(r, i) {
                        return n.coerce(t1, e1, c, r, i);
                    }
                    var d = t1.dimensions;
                    Array.isArray(d) && d.length > f && (n.log("parcoords traces support up to " + f + " dimensions at the moment"), d.splice(f));
                    var m = s(t1, e1, {
                        name: "dimensions",
                        layout: l,
                        handleItemDefaults: p
                    }), g = function(t1, e1, r, o, s) {
                        var l = s("line.color", r);
                        if (i(t1, "line") && n.isArrayOrTypedArray(l)) {
                            if (l.length) return s("line.colorscale"), a(t1, e1, o, s, {
                                prefix: "line.",
                                cLetter: "c"
                            }), l.length;
                            e1.line.color = r;
                        }
                        return 1 / 0;
                    }(t1, e1, r, l, u);
                    o(e1, l, u), Array.isArray(m) && m.length || (e1.visible = !1), h(e1, m, "values", g);
                    var v = {
                        family: l.font.family,
                        size: Math.round(l.font.size / 1.2),
                        color: l.font.color
                    };
                    n.coerceFont(u, "labelfont", v), n.coerceFont(u, "tickfont", v), n.coerceFont(u, "rangefont", v), u("labelangle"), u("labelside");
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../components/colorscale/helpers": 377,
                "../../lib": 503,
                "../../plots/array_container_defaults": 549,
                "../../plots/cartesian/axes": 554,
                "../../plots/domain": 584,
                "./attributes": 888,
                "./axisbrush": 889,
                "./constants": 892,
                "./merge_length": 897
            }
        ],
        894: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").isTypedArray;
                r.convertTypedArray = function(t1) {
                    return n(t1) ? Array.prototype.slice.call(t1) : t1;
                }, r.isOrdinal = function(t1) {
                    return !!t1.tickvals;
                }, r.isVisible = function(t1) {
                    return t1.visible || !("visible" in t1);
                };
            },
            {
                "../../lib": 503
            }
        ],
        895: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    colorbar: {
                        container: "line",
                        min: "cmin",
                        max: "cmax"
                    },
                    moduleType: "trace",
                    name: "parcoords",
                    basePlotModule: t1("./base_plot"),
                    categories: [
                        "gl",
                        "regl",
                        "noOpacity",
                        "noHover"
                    ],
                    meta: {}
                };
            },
            {
                "./attributes": 888,
                "./base_plot": 890,
                "./calc": 891,
                "./defaults": 893,
                "./plot": 899
            }
        ],
        896: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("glslify"), i = n([
                    "precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nattribute vec4 p01_04, p05_08, p09_12, p13_16,\n               p17_20, p21_24, p25_28, p29_32,\n               p33_36, p37_40, p41_44, p45_48,\n               p49_52, p53_56, p57_60, colors;\n\nuniform mat4 dim0A, dim1A, dim0B, dim1B, dim0C, dim1C, dim0D, dim1D,\n             loA, hiA, loB, hiB, loC, hiC, loD, hiD;\n\nuniform vec2 resolution, viewBoxPos, viewBoxSize;\nuniform float maskHeight;\nuniform float drwLayer; // 0: context, 1: focus, 2: pick\nuniform vec4 contextColor;\nuniform sampler2D maskTexture, palette;\n\nbool isPick    = (drwLayer > 1.5);\nbool isContext = (drwLayer < 0.5);\n\nconst vec4 ZEROS = vec4(0.0, 0.0, 0.0, 0.0);\nconst vec4 UNITS = vec4(1.0, 1.0, 1.0, 1.0);\n\nfloat val(mat4 p, mat4 v) {\n    return dot(matrixCompMult(p, v) * UNITS, UNITS);\n}\n\nfloat axisY(float ratio, mat4 A, mat4 B, mat4 C, mat4 D) {\n    float y1 = val(A, dim0A) + val(B, dim0B) + val(C, dim0C) + val(D, dim0D);\n    float y2 = val(A, dim1A) + val(B, dim1B) + val(C, dim1C) + val(D, dim1D);\n    return y1 * (1.0 - ratio) + y2 * ratio;\n}\n\nint iMod(int a, int b) {\n    return a - b * (a / b);\n}\n\nbool fOutside(float p, float lo, float hi) {\n    return (lo < hi) && (lo > p || p > hi);\n}\n\nbool vOutside(vec4 p, vec4 lo, vec4 hi) {\n    return (\n        fOutside(p[0], lo[0], hi[0]) ||\n        fOutside(p[1], lo[1], hi[1]) ||\n        fOutside(p[2], lo[2], hi[2]) ||\n        fOutside(p[3], lo[3], hi[3])\n    );\n}\n\nbool mOutside(mat4 p, mat4 lo, mat4 hi) {\n    return (\n        vOutside(p[0], lo[0], hi[0]) ||\n        vOutside(p[1], lo[1], hi[1]) ||\n        vOutside(p[2], lo[2], hi[2]) ||\n        vOutside(p[3], lo[3], hi[3])\n    );\n}\n\nbool outsideBoundingBox(mat4 A, mat4 B, mat4 C, mat4 D) {\n    return mOutside(A, loA, hiA) ||\n           mOutside(B, loB, hiB) ||\n           mOutside(C, loC, hiC) ||\n           mOutside(D, loD, hiD);\n}\n\nbool outsideRasterMask(mat4 A, mat4 B, mat4 C, mat4 D) {\n    mat4 pnts[4];\n    pnts[0] = A;\n    pnts[1] = B;\n    pnts[2] = C;\n    pnts[3] = D;\n\n    for(int i = 0; i < 4; ++i) {\n        for(int j = 0; j < 4; ++j) {\n            for(int k = 0; k < 4; ++k) {\n                if(0 == iMod(\n                    int(255.0 * texture2D(maskTexture,\n                        vec2(\n                            (float(i * 2 + j / 2) + 0.5) / 8.0,\n                            (pnts[i][j][k] * (maskHeight - 1.0) + 1.0) / maskHeight\n                        ))[3]\n                    ) / int(pow(2.0, float(iMod(j * 4 + k, 8)))),\n                    2\n                )) return true;\n            }\n        }\n    }\n    return false;\n}\n\nvec4 position(bool isContext, float v, mat4 A, mat4 B, mat4 C, mat4 D) {\n    float x = 0.5 * sign(v) + 0.5;\n    float y = axisY(x, A, B, C, D);\n    float z = 1.0 - abs(v);\n\n    z += isContext ? 0.0 : 2.0 * float(\n        outsideBoundingBox(A, B, C, D) ||\n        outsideRasterMask(A, B, C, D)\n    );\n\n    return vec4(\n        2.0 * (vec2(x, y) * viewBoxSize + viewBoxPos) / resolution - 1.0,\n        z,\n        1.0\n    );\n}\n\nvoid main() {\n    mat4 A = mat4(p01_04, p05_08, p09_12, p13_16);\n    mat4 B = mat4(p17_20, p21_24, p25_28, p29_32);\n    mat4 C = mat4(p33_36, p37_40, p41_44, p45_48);\n    mat4 D = mat4(p49_52, p53_56, p57_60, ZEROS);\n\n    float v = colors[3];\n\n    gl_Position = position(isContext, v, A, B, C, D);\n\n    fragColor =\n        isContext ? vec4(contextColor) :\n        isPick ? vec4(colors.rgb, 1.0) : texture2D(palette, vec2(abs(v), 0.5));\n}\n"
                ]), a = n([
                    "precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n    gl_FragColor = fragColor;\n}\n"
                ]), o = t1("./constants").maxDimensionCount, s = t1("../../lib"), l = new Uint8Array(4), c = new Uint8Array(4), u = {
                    shape: [
                        256,
                        1
                    ],
                    format: "rgba",
                    type: "uint8",
                    mag: "nearest",
                    min: "nearest"
                };
                function f(t1, e1, r, n, i) {
                    var a = t1._gl;
                    a.enable(a.SCISSOR_TEST), a.scissor(e1, r, n, i), t1.clear({
                        color: [
                            0,
                            0,
                            0,
                            0
                        ],
                        depth: 1
                    });
                }
                function h(t1, e1, r, n, i, a) {
                    var o = a.key;
                    r.drawCompleted || (!function(t1) {
                        t1.read({
                            x: 0,
                            y: 0,
                            width: 1,
                            height: 1,
                            data: l
                        });
                    }(t1), r.drawCompleted = !0), function s(l) {
                        var c = Math.min(n, i - l * n);
                        0 === l && (window.cancelAnimationFrame(r.currentRafs[o]), delete r.currentRafs[o], f(t1, a.scissorX, a.scissorY, a.scissorWidth, a.viewBoxSize[1])), r.clearOnly || (a.count = 2 * c, a.offset = 2 * l * n, e1(a), l * n + c < i && (r.currentRafs[o] = window.requestAnimationFrame(function() {
                            s(l + 1);
                        })), r.drawCompleted = !1);
                    }(0);
                }
                function p(t1, e1) {
                    for(var r = new Array(256), n = 0; n < 256; n++)r[n] = t1(n / 255).concat(e1);
                    return r;
                }
                function d(t1, e1) {
                    return (t1 >>> 8 * e1) % 256 / 255;
                }
                function m(t1, e1, r) {
                    for(var n = new Array(8 * e1), i = 0, a = 0; a < e1; a++)for(var o = 0; o < 2; o++)for(var s = 0; s < 4; s++){
                        var l = 4 * t1 + s, c = r[64 * a + l];
                        63 === l && 0 === o && (c *= -1), n[i++] = c;
                    }
                    return n;
                }
                function g(t1) {
                    var e1 = "0" + t1;
                    return e1.substr(e1.length - 2);
                }
                function v(t1) {
                    return t1 < o ? "p" + g(t1 + 1) + "_" + g(t1 + 4) : "colors";
                }
                function y(t1, e1, r, n, i, a, o, l, c, u, f, h, p, d) {
                    for(var m = [
                        [],
                        []
                    ], g = 0; g < 64; g++)m[0][g] = g === i ? 1 : 0, m[1][g] = g === a ? 1 : 0;
                    o *= d, l *= d, c *= d, u *= d;
                    var v = t1.lines.canvasOverdrag * d, y = t1.domain, x = t1.canvasWidth * d, b = t1.canvasHeight * d, _ = t1.pad.l * d, w = t1.pad.b * d, T = t1.layoutHeight * d, k = t1.layoutWidth * d, A = t1.deselectedLines.color;
                    return s.extendFlat({
                        key: f,
                        resolution: [
                            x,
                            b
                        ],
                        viewBoxPos: [
                            o + v,
                            l
                        ],
                        viewBoxSize: [
                            c,
                            u
                        ],
                        i0: i,
                        i1: a,
                        dim0A: m[0].slice(0, 16),
                        dim0B: m[0].slice(16, 32),
                        dim0C: m[0].slice(32, 48),
                        dim0D: m[0].slice(48, 64),
                        dim1A: m[1].slice(0, 16),
                        dim1B: m[1].slice(16, 32),
                        dim1C: m[1].slice(32, 48),
                        dim1D: m[1].slice(48, 64),
                        drwLayer: h,
                        contextColor: [
                            A[0] / 255,
                            A[1] / 255,
                            A[2] / 255,
                            A[3] < 1 ? A[3] : Math.max(1 / 255, Math.pow(1 / t1.lines.color.length, 1 / 3))
                        ],
                        scissorX: (n === e1 ? 0 : o + v) + (_ - v) + k * y.x[0],
                        scissorWidth: (n === r ? x - o + v : c + .5) + (n === e1 ? o + v : 0),
                        scissorY: l + w + T * y.y[0],
                        scissorHeight: u,
                        viewportX: _ - v + k * y.x[0],
                        viewportY: w + T * y.y[0],
                        viewportWidth: x,
                        viewportHeight: b
                    }, p);
                }
                function x(t1) {
                    var e1 = Math.max(0, Math.floor(2047 * t1[0]), 0), r = Math.min(2047, Math.ceil(2047 * t1[1]), 2047);
                    return [
                        Math.min(e1, r),
                        Math.max(e1, r)
                    ];
                }
                e1.exports = function(t1, e1) {
                    var r, n, l, g, b, _ = e1.context, w = e1.pick, T = e1.regl, k = T._gl, A = k.getParameter(k.ALIASED_LINE_WIDTH_RANGE), M = Math.max(A[0], Math.min(A[1], e1.viewModel.plotGlPixelRatio)), S = {
                        currentRafs: {},
                        drawCompleted: !0,
                        clearOnly: !1
                    }, E = function(t1) {
                        for(var e1 = {}, r = 0; r <= o; r += 4)e1[v(r)] = t1.buffer({
                            usage: "dynamic",
                            type: "float",
                            data: new Uint8Array(0)
                        });
                        return e1;
                    }(T), L = T.texture(u), C = [];
                    I(e1);
                    var P = T({
                        profile: !1,
                        blend: {
                            enable: _,
                            func: {
                                srcRGB: "src alpha",
                                dstRGB: "one minus src alpha",
                                srcAlpha: 1,
                                dstAlpha: 1
                            },
                            equation: {
                                rgb: "add",
                                alpha: "add"
                            },
                            color: [
                                0,
                                0,
                                0,
                                0
                            ]
                        },
                        depth: {
                            enable: !_,
                            mask: !0,
                            func: "less",
                            range: [
                                0,
                                1
                            ]
                        },
                        cull: {
                            enable: !0,
                            face: "back"
                        },
                        scissor: {
                            enable: !0,
                            box: {
                                x: T.prop("scissorX"),
                                y: T.prop("scissorY"),
                                width: T.prop("scissorWidth"),
                                height: T.prop("scissorHeight")
                            }
                        },
                        viewport: {
                            x: T.prop("viewportX"),
                            y: T.prop("viewportY"),
                            width: T.prop("viewportWidth"),
                            height: T.prop("viewportHeight")
                        },
                        dither: !1,
                        vert: i,
                        frag: a,
                        primitive: "lines",
                        lineWidth: M,
                        attributes: E,
                        uniforms: {
                            resolution: T.prop("resolution"),
                            viewBoxPos: T.prop("viewBoxPos"),
                            viewBoxSize: T.prop("viewBoxSize"),
                            dim0A: T.prop("dim0A"),
                            dim1A: T.prop("dim1A"),
                            dim0B: T.prop("dim0B"),
                            dim1B: T.prop("dim1B"),
                            dim0C: T.prop("dim0C"),
                            dim1C: T.prop("dim1C"),
                            dim0D: T.prop("dim0D"),
                            dim1D: T.prop("dim1D"),
                            loA: T.prop("loA"),
                            hiA: T.prop("hiA"),
                            loB: T.prop("loB"),
                            hiB: T.prop("hiB"),
                            loC: T.prop("loC"),
                            hiC: T.prop("hiC"),
                            loD: T.prop("loD"),
                            hiD: T.prop("hiD"),
                            palette: L,
                            contextColor: T.prop("contextColor"),
                            maskTexture: T.prop("maskTexture"),
                            drwLayer: T.prop("drwLayer"),
                            maskHeight: T.prop("maskHeight")
                        },
                        offset: T.prop("offset"),
                        count: T.prop("count")
                    });
                    function I(t1) {
                        r = t1.model, n = t1.viewModel, l = n.dimensions.slice(), g = l[0] ? l[0].values.length : 0;
                        var e1 = r.lines, i = w ? e1.color.map(function(t1, r) {
                            return r / e1.color.length;
                        }) : e1.color, a = function(t1, e1, r) {
                            for(var n, i = new Array(t1 * (o + 4)), a = 0, s = 0; s < t1; s++){
                                for(var l = 0; l < o; l++)i[a++] = l < e1.length ? e1[l].paddedUnitValues[s] : .5;
                                i[a++] = d(s, 2), i[a++] = d(s, 1), i[a++] = d(s, 0), i[a++] = (n = r[s], Math.max(1e-6, Math.min(.999999, n)));
                            }
                            return i;
                        }(g, l, i);
                        !function(t1, e1, r) {
                            for(var n = 0; n <= o; n += 4)t1[v(n)](m(n / 4, e1, r));
                        }(E, g, a), _ || w || (L = T.texture(s.extendFlat({
                            data: p(r.unitToColor, 255)
                        }, u)));
                    }
                    return {
                        render: function(t1, e1, n) {
                            var i, a, o, s = t1.length, c = 1 / 0, u = -1 / 0;
                            for(i = 0; i < s; i++)t1[i].dim0.canvasX < c && (c = t1[i].dim0.canvasX, a = i), t1[i].dim1.canvasX > u && (u = t1[i].dim1.canvasX, o = i);
                            0 === s && f(T, 0, 0, r.canvasWidth, r.canvasHeight);
                            var p = function(t1) {
                                var e1, r, n, i = [
                                    [],
                                    []
                                ];
                                for(n = 0; n < 64; n++){
                                    var a = !t1 && n < l.length ? l[n].brush.filter.getBounds() : [
                                        -1 / 0,
                                        1 / 0
                                    ];
                                    i[0][n] = a[0], i[1][n] = a[1];
                                }
                                var o = new Array(16384);
                                for(e1 = 0; e1 < 16384; e1++)o[e1] = 255;
                                if (!t1) for(e1 = 0; e1 < l.length; e1++){
                                    var s = e1 % 8, c = (e1 - s) / 8, u = Math.pow(2, s), f = l[e1].brush.filter.get();
                                    if (!(f.length < 2)) {
                                        var h = x(f[0])[1];
                                        for(r = 1; r < f.length; r++){
                                            var p = x(f[r]);
                                            for(n = h + 1; n < p[0]; n++)o[8 * n + c] &= ~u;
                                            h = Math.max(h, p[1]);
                                        }
                                    }
                                }
                                var d = {
                                    shape: [
                                        8,
                                        2048
                                    ],
                                    format: "alpha",
                                    type: "uint8",
                                    mag: "nearest",
                                    min: "nearest",
                                    data: o
                                };
                                return b ? b(d) : b = T.texture(d), {
                                    maskTexture: b,
                                    maskHeight: 2048,
                                    loA: i[0].slice(0, 16),
                                    loB: i[0].slice(16, 32),
                                    loC: i[0].slice(32, 48),
                                    loD: i[0].slice(48, 64),
                                    hiA: i[1].slice(0, 16),
                                    hiB: i[1].slice(16, 32),
                                    hiC: i[1].slice(32, 48),
                                    hiD: i[1].slice(48, 64)
                                };
                            }(_);
                            for(i = 0; i < s; i++){
                                var d = t1[i], m = d.dim0.crossfilterDimensionIndex, v = d.dim1.crossfilterDimensionIndex, k = d.canvasX, A = d.canvasY, M = k + d.panelSizeX, E = d.plotGlPixelRatio;
                                if (e1 || !C[m] || C[m][0] !== k || C[m][1] !== M) {
                                    C[m] = [
                                        k,
                                        M
                                    ];
                                    var L = y(r, a, o, i, m, v, k, A, d.panelSizeX, d.panelSizeY, d.dim0.crossfilterDimensionIndex, _ ? 0 : w ? 2 : 1, p, E);
                                    S.clearOnly = n;
                                    var I = e1 ? r.lines.blockLineCount : g;
                                    h(T, P, S, I, g, L);
                                }
                            }
                        },
                        readPixel: function(t1, e1) {
                            return T.read({
                                x: t1,
                                y: e1,
                                width: 1,
                                height: 1,
                                data: c
                            }), c;
                        },
                        readPixels: function(t1, e1, r, n) {
                            var i = new Uint8Array(4 * r * n);
                            return T.read({
                                x: t1,
                                y: e1,
                                width: r,
                                height: n,
                                data: i
                            }), i;
                        },
                        destroy: function() {
                            for(var e1 in t1.style["pointer-events"] = "none", L.destroy(), b && b.destroy(), E)E[e1].destroy();
                        },
                        update: I
                    };
                };
            },
            {
                "../../lib": 503,
                "./constants": 892,
                glslify: 227
            }
        ],
        897: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n) {
                    var i, a;
                    for(n || (n = 1 / 0), i = 0; i < e1.length; i++)(a = e1[i]).visible && (n = Math.min(n, a[r].length));
                    for(n === 1 / 0 && (n = 0), t1._length = n, i = 0; i < e1.length; i++)(a = e1[i]).visible && (a._length = n);
                    return n;
                };
            },
            {}
        ],
        898: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = i.numberFormat, o = t1("color-rgba"), s = t1("../../plots/cartesian/axes"), l = i.strRotate, c = i.strTranslate, u = t1("../../lib/svg_text_utils"), f = t1("../../components/drawing"), h = t1("../../components/colorscale"), p = t1("../../lib/gup"), d = p.keyFun, m = p.repeat, g = p.unwrap, v = t1("./helpers"), y = t1("./constants"), x = t1("./axisbrush"), b = t1("./lines");
                function _(t1, e1, r) {
                    return i.aggNums(t1, null, e1, r);
                }
                function w(t1, e1) {
                    return k(_(Math.min, t1, e1), _(Math.max, t1, e1));
                }
                function T(t1) {
                    var e1 = t1.range;
                    return e1 ? k(e1[0], e1[1]) : w(t1.values, t1._length);
                }
                function k(t1, e1) {
                    return !isNaN(t1) && isFinite(t1) || (t1 = 0), !isNaN(e1) && isFinite(e1) || (e1 = 0), t1 === e1 && (0 === t1 ? (t1 -= 1, e1 += 1) : (t1 *= .9, e1 *= 1.1)), [
                        t1,
                        e1
                    ];
                }
                function A(t1, e1, r, i, o) {
                    var s, l, c = T(r);
                    return i ? n.scale.ordinal().domain(i.map((s = a(r.tickformat), l = o, l ? function(t1, e1) {
                        var r = l[e1];
                        return null == r ? s(t1) : r;
                    } : s))).range(i.map(function(r) {
                        var n = (r - c[0]) / (c[1] - c[0]);
                        return t1 - e1 + n * (2 * e1 - t1);
                    })) : n.scale.linear().domain(c).range([
                        t1 - e1,
                        e1
                    ]);
                }
                function M(t1) {
                    if (t1.tickvals) {
                        var e1 = T(t1);
                        return n.scale.ordinal().domain(t1.tickvals).range(t1.tickvals.map(function(t1) {
                            return (t1 - e1[0]) / (e1[1] - e1[0]);
                        }));
                    }
                }
                function S(t1) {
                    var e1 = t1.map(function(t1) {
                        return t1[0];
                    }), r = t1.map(function(t1) {
                        var e1 = o(t1[1]);
                        return n.rgb("rgb(" + e1[0] + "," + e1[1] + "," + e1[2] + ")");
                    }), i = "rgb".split("").map(function(t1) {
                        var i;
                        return n.scale.linear().clamp(!0).domain(e1).range(r.map((i = t1, function(t1) {
                            return t1[i];
                        })));
                    });
                    return function(t1) {
                        return i.map(function(e1) {
                            return e1(t1);
                        });
                    };
                }
                function E(t1) {
                    return t1.dimensions.some(function(t1) {
                        return t1.brush.filterSpecified;
                    });
                }
                function L(t1, e1, r) {
                    var a = g(e1), s = a.trace, l = v.convertTypedArray(a.lineColor), c = s.line, u = {
                        color: o(y.deselectedLineColor)
                    }, f = h.extractOpts(c), p = f.reversescale ? h.flipScale(a.cscale) : a.cscale, d = s.domain, m = s.dimensions, x = t1.width, b = s.labelangle, _ = s.labelside, w = s.labelfont, k = s.tickfont, A = s.rangefont, M = i.extendDeepNoArrays({}, c, {
                        color: l.map(n.scale.linear().domain(T({
                            values: l,
                            range: [
                                f.min,
                                f.max
                            ],
                            _length: s._length
                        }))),
                        blockLineCount: y.blockLineCount,
                        canvasOverdrag: y.overdrag * y.canvasPixelRatio
                    }), E = Math.floor(x * (d.x[1] - d.x[0])), L = Math.floor(t1.height * (d.y[1] - d.y[0])), C = t1.margin || {
                        l: 80,
                        r: 80,
                        t: 100,
                        b: 80
                    }, P = E, I = L;
                    return {
                        key: r,
                        colCount: m.filter(v.isVisible).length,
                        dimensions: m,
                        tickDistance: y.tickDistance,
                        unitToColor: S(p),
                        lines: M,
                        deselectedLines: u,
                        labelAngle: b,
                        labelSide: _,
                        labelFont: w,
                        tickFont: k,
                        rangeFont: A,
                        layoutWidth: x,
                        layoutHeight: t1.height,
                        domain: d,
                        translateX: d.x[0] * x,
                        translateY: t1.height - d.y[1] * t1.height,
                        pad: C,
                        canvasWidth: P * y.canvasPixelRatio + 2 * M.canvasOverdrag,
                        canvasHeight: I * y.canvasPixelRatio,
                        width: P,
                        height: I,
                        canvasPixelRatio: y.canvasPixelRatio
                    };
                }
                function C(t1, e1, r) {
                    var o = r.width, s = r.height, l = r.dimensions, c = r.canvasPixelRatio, u = function(t1) {
                        return o * t1 / Math.max(1, r.colCount - 1);
                    }, f = y.verticalPadding / s, h = function(t1, e1) {
                        return n.scale.linear().range([
                            e1,
                            t1 - e1
                        ]);
                    }(s, y.verticalPadding), p = {
                        key: r.key,
                        xScale: u,
                        model: r,
                        inBrushDrag: !1
                    }, d = {};
                    return p.dimensions = l.filter(v.isVisible).map(function(o, l) {
                        var m = function(t1, e1) {
                            return n.scale.linear().domain(T(t1)).range([
                                e1,
                                1 - e1
                            ]);
                        }(o, f), g = d[o.label];
                        d[o.label] = (g || 0) + 1;
                        var b = o.label + (g ? "__" + g : ""), _ = o.constraintrange, w = _ && _.length;
                        w && !Array.isArray(_[0]) && (_ = [
                            _
                        ]);
                        var k = w ? _.map(function(t1) {
                            return t1.map(m);
                        }) : [
                            [
                                -1 / 0,
                                1 / 0
                            ]
                        ], S = o.values;
                        S.length > o._length && (S = S.slice(0, o._length));
                        var L, C = o.tickvals;
                        function P(t1, e1) {
                            return {
                                val: t1,
                                text: L[e1]
                            };
                        }
                        function I(t1, e1) {
                            return t1.val - e1.val;
                        }
                        if (Array.isArray(C) && C.length) {
                            L = o.ticktext, Array.isArray(L) && L.length ? L.length > C.length ? L = L.slice(0, C.length) : C.length > L.length && (C = C.slice(0, L.length)) : L = C.map(a(o.tickformat));
                            for(var O = 1; O < C.length; O++)if (C[O] < C[O - 1]) {
                                for(var z = C.map(P).sort(I), D = 0; D < C.length; D++)C[D] = z[D].val, L[D] = z[D].text;
                                break;
                            }
                        } else C = void 0;
                        return S = v.convertTypedArray(S), {
                            key: b,
                            label: o.label,
                            tickFormat: o.tickformat,
                            tickvals: C,
                            ticktext: L,
                            ordinal: v.isOrdinal(o),
                            multiselect: o.multiselect,
                            xIndex: l,
                            crossfilterDimensionIndex: l,
                            visibleIndex: o._index,
                            height: s,
                            values: S,
                            paddedUnitValues: S.map(m),
                            unitTickvals: C && C.map(m),
                            xScale: u,
                            x: u(l),
                            canvasX: u(l) * c,
                            unitToPaddedPx: h,
                            domainScale: A(s, y.verticalPadding, o, C, L),
                            ordinalScale: M(o),
                            parent: p,
                            model: r,
                            brush: x.makeBrush(t1, w, k, function() {
                                t1.linePickActive(!1);
                            }, function() {
                                var e1 = p;
                                e1.focusLayer && e1.focusLayer.render(e1.panels, !0);
                                var r = E(e1);
                                !t1.contextShown() && r ? (e1.contextLayer && e1.contextLayer.render(e1.panels, !0), t1.contextShown(!0)) : t1.contextShown() && !r && (e1.contextLayer && e1.contextLayer.render(e1.panels, !0, !0), t1.contextShown(!1));
                            }, function(r) {
                                if (p.focusLayer.render(p.panels, !0), p.pickLayer && p.pickLayer.render(p.panels, !0), t1.linePickActive(!0), e1 && e1.filterChanged) {
                                    var n = m.invert, a = r.map(function(t1) {
                                        return t1.map(n).sort(i.sorterAsc);
                                    }).sort(function(t1, e1) {
                                        return t1[0] - e1[0];
                                    });
                                    e1.filterChanged(p.key, o._index, a);
                                }
                            })
                        };
                    }), p;
                }
                function P(t1) {
                    t1.classed(y.cn.axisExtentText, !0).attr("text-anchor", "middle").style("cursor", "default");
                }
                function I(t1, e1) {
                    var r = "top" === e1 ? 1 : -1, n = t1 * Math.PI / 180;
                    return {
                        dir: r,
                        dx: Math.sin(n),
                        dy: Math.cos(n),
                        degrees: t1
                    };
                }
                function O(t1, e1, r) {
                    for(var n = e1.panels || (e1.panels = []), i = t1.data(), a = 0; a < i.length - 1; a++){
                        var o = n[a] || (n[a] = {}), s = i[a], l = i[a + 1];
                        o.dim0 = s, o.dim1 = l, o.canvasX = s.canvasX, o.panelSizeX = l.canvasX - s.canvasX, o.panelSizeY = e1.model.canvasHeight, o.y = 0, o.canvasY = 0, o.plotGlPixelRatio = r;
                    }
                }
                function z(t1, e1) {
                    return s.tickText(t1._ax, e1, !1).text;
                }
                function D(t1, e1) {
                    if (t1.ordinal) return "";
                    var r = t1.domainScale.domain(), n = r[e1 ? r.length - 1 : 0];
                    return z(t1.model.dimensions[t1.visibleIndex], n);
                }
                e1.exports = function(t1, e1, r, a) {
                    var o = t1._fullLayout, h = o._toppaper, p = o._glcontainer, _ = t1._context.plotGlPixelRatio, T = t1._fullLayout.paper_bgcolor;
                    !function(t1) {
                        for(var e1 = 0; e1 < t1.length; e1++)for(var r = 0; r < t1[e1].length; r++)for(var n = t1[e1][r].trace, i = n.dimensions, a = 0; a < i.length; a++){
                            var o = i[a].values, l = i[a]._ax;
                            l && (l.range ? l.range = k(l.range[0], l.range[1]) : l.range = w(o, n._length), l.dtick || (l.dtick = .01 * (Math.abs(l.range[1] - l.range[0]) || 1)), l.tickformat = i[a].tickformat, s.calcTicks(l), l.cleanRange());
                        }
                    }(e1);
                    var A, M, S = (A = !0, M = !1, {
                        linePickActive: function(t1) {
                            return arguments.length ? A = !!t1 : A;
                        },
                        contextShown: function(t1) {
                            return arguments.length ? M = !!t1 : M;
                        }
                    }), R = e1.filter(function(t1) {
                        return g(t1).trace.visible;
                    }).map(L.bind(0, r)).map(C.bind(0, S, a));
                    p.each(function(t1, e1) {
                        return i.extendFlat(t1, R[e1]);
                    });
                    var F = p.selectAll(".gl-canvas").each(function(t1) {
                        t1.viewModel = R[0], t1.viewModel.plotGlPixelRatio = _, t1.viewModel.paperColor = T, t1.model = t1.viewModel ? t1.viewModel.model : null;
                    }), B = null;
                    F.filter(function(t1) {
                        return t1.pick;
                    }).style("pointer-events", "auto").on("mousemove", function(t1) {
                        if (S.linePickActive() && t1.lineLayer && a && a.hover) {
                            var e1 = n.event, r = this.width, i = this.height, o = n.mouse(this), s = o[0], l = o[1];
                            if (s < 0 || l < 0 || s >= r || l >= i) return;
                            var c = t1.lineLayer.readPixel(s, i - 1 - l), u = 0 !== c[3], f = u ? c[2] + 256 * (c[1] + 256 * c[0]) : null, h = {
                                x: s,
                                y: l,
                                clientX: e1.clientX,
                                clientY: e1.clientY,
                                dataIndex: t1.model.key,
                                curveNumber: f
                            };
                            f !== B && (u ? a.hover(h) : a.unhover && a.unhover(h), B = f);
                        }
                    }), F.style("opacity", function(t1) {
                        return t1.pick ? 0 : 1;
                    }), h.style("background", "rgba(255, 255, 255, 0)");
                    var N = h.selectAll("." + y.cn.parcoords).data(R, d);
                    N.exit().remove(), N.enter().append("g").classed(y.cn.parcoords, !0).style("shape-rendering", "crispEdges").style("pointer-events", "none"), N.attr("transform", function(t1) {
                        return c(t1.model.translateX, t1.model.translateY);
                    });
                    var j = N.selectAll("." + y.cn.parcoordsControlView).data(m, d);
                    j.enter().append("g").classed(y.cn.parcoordsControlView, !0), j.attr("transform", function(t1) {
                        return c(t1.model.pad.l, t1.model.pad.t);
                    });
                    var U = j.selectAll("." + y.cn.yAxis).data(function(t1) {
                        return t1.dimensions;
                    }, d);
                    U.enter().append("g").classed(y.cn.yAxis, !0), j.each(function(t1) {
                        O(U, t1, _);
                    }), F.each(function(t1) {
                        if (t1.viewModel) {
                            !t1.lineLayer || a ? t1.lineLayer = b(this, t1) : t1.lineLayer.update(t1), (t1.key || 0 === t1.key) && (t1.viewModel[t1.key] = t1.lineLayer);
                            var e1 = !t1.context || a;
                            t1.lineLayer.render(t1.viewModel.panels, e1);
                        }
                    }), U.attr("transform", function(t1) {
                        return c(t1.xScale(t1.xIndex), 0);
                    }), U.call(n.behavior.drag().origin(function(t1) {
                        return t1;
                    }).on("drag", function(t1) {
                        var e1 = t1.parent;
                        S.linePickActive(!1), t1.x = Math.max(-y.overdrag, Math.min(t1.model.width + y.overdrag, n.event.x)), t1.canvasX = t1.x * t1.model.canvasPixelRatio, U.sort(function(t1, e1) {
                            return t1.x - e1.x;
                        }).each(function(e1, r) {
                            e1.xIndex = r, e1.x = t1 === e1 ? e1.x : e1.xScale(e1.xIndex), e1.canvasX = e1.x * e1.model.canvasPixelRatio;
                        }), O(U, e1, _), U.filter(function(e1) {
                            return 0 !== Math.abs(t1.xIndex - e1.xIndex);
                        }).attr("transform", function(t1) {
                            return c(t1.xScale(t1.xIndex), 0);
                        }), n.select(this).attr("transform", c(t1.x, 0)), U.each(function(r, n, i) {
                            i === t1.parent.key && (e1.dimensions[n] = r);
                        }), e1.contextLayer && e1.contextLayer.render(e1.panels, !1, !E(e1)), e1.focusLayer.render && e1.focusLayer.render(e1.panels);
                    }).on("dragend", function(t1) {
                        var e1 = t1.parent;
                        t1.x = t1.xScale(t1.xIndex), t1.canvasX = t1.x * t1.model.canvasPixelRatio, O(U, e1, _), n.select(this).attr("transform", function(t1) {
                            return c(t1.x, 0);
                        }), e1.contextLayer && e1.contextLayer.render(e1.panels, !1, !E(e1)), e1.focusLayer && e1.focusLayer.render(e1.panels), e1.pickLayer && e1.pickLayer.render(e1.panels, !0), S.linePickActive(!0), a && a.axesMoved && a.axesMoved(e1.key, e1.dimensions.map(function(t1) {
                            return t1.crossfilterDimensionIndex;
                        }));
                    })), U.exit().remove();
                    var V = U.selectAll("." + y.cn.axisOverlays).data(m, d);
                    V.enter().append("g").classed(y.cn.axisOverlays, !0), V.selectAll("." + y.cn.axis).remove();
                    var H = V.selectAll("." + y.cn.axis).data(m, d);
                    H.enter().append("g").classed(y.cn.axis, !0), H.each(function(t1) {
                        var e1 = t1.model.height / t1.model.tickDistance, r = t1.domainScale, i = r.domain();
                        n.select(this).call(n.svg.axis().orient("left").tickSize(4).outerTickSize(2).ticks(e1, t1.tickFormat).tickValues(t1.ordinal ? i : null).tickFormat(function(e1) {
                            return v.isOrdinal(t1) ? e1 : z(t1.model.dimensions[t1.visibleIndex], e1);
                        }).scale(r)), f.font(H.selectAll("text"), t1.model.tickFont);
                    }), H.selectAll(".domain, .tick>line").attr("fill", "none").attr("stroke", "black").attr("stroke-opacity", .25).attr("stroke-width", "1px"), H.selectAll("text").style("text-shadow", u.makeTextShadow(T)).style("cursor", "default");
                    var q = V.selectAll("." + y.cn.axisHeading).data(m, d);
                    q.enter().append("g").classed(y.cn.axisHeading, !0);
                    var G = q.selectAll("." + y.cn.axisTitle).data(m, d);
                    G.enter().append("text").classed(y.cn.axisTitle, !0).attr("text-anchor", "middle").style("cursor", "ew-resize").style("pointer-events", "auto"), G.text(function(t1) {
                        return t1.label;
                    }).each(function(e1) {
                        var r = n.select(this);
                        f.font(r, e1.model.labelFont), u.convertToTspans(r, t1);
                    }).attr("transform", function(t1) {
                        var e1 = I(t1.model.labelAngle, t1.model.labelSide), r = y.axisTitleOffset;
                        return (e1.dir > 0 ? "" : c(0, 2 * r + t1.model.height)) + l(e1.degrees) + c(-r * e1.dx, -r * e1.dy);
                    }).attr("text-anchor", function(t1) {
                        var e1 = I(t1.model.labelAngle, t1.model.labelSide);
                        return 2 * Math.abs(e1.dx) > Math.abs(e1.dy) ? e1.dir * e1.dx < 0 ? "start" : "end" : "middle";
                    });
                    var Y = V.selectAll("." + y.cn.axisExtent).data(m, d);
                    Y.enter().append("g").classed(y.cn.axisExtent, !0);
                    var W = Y.selectAll("." + y.cn.axisExtentTop).data(m, d);
                    W.enter().append("g").classed(y.cn.axisExtentTop, !0), W.attr("transform", c(0, -y.axisExtentOffset));
                    var X = W.selectAll("." + y.cn.axisExtentTopText).data(m, d);
                    X.enter().append("text").classed(y.cn.axisExtentTopText, !0).call(P), X.text(function(t1) {
                        return D(t1, !0);
                    }).each(function(t1) {
                        f.font(n.select(this), t1.model.rangeFont);
                    });
                    var Z = Y.selectAll("." + y.cn.axisExtentBottom).data(m, d);
                    Z.enter().append("g").classed(y.cn.axisExtentBottom, !0), Z.attr("transform", function(t1) {
                        return c(0, t1.model.height + y.axisExtentOffset);
                    });
                    var J = Z.selectAll("." + y.cn.axisExtentBottomText).data(m, d);
                    J.enter().append("text").classed(y.cn.axisExtentBottomText, !0).attr("dy", "0.75em").call(P), J.text(function(t1) {
                        return D(t1, !1);
                    }).each(function(t1) {
                        f.font(n.select(this), t1.model.rangeFont);
                    }), x.ensureAxisBrush(V, T);
                };
            },
            {
                "../../components/colorscale": 378,
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../lib/gup": 500,
                "../../lib/svg_text_utils": 529,
                "../../plots/cartesian/axes": 554,
                "./axisbrush": 889,
                "./constants": 892,
                "./helpers": 894,
                "./lines": 896,
                "@plotly/d3": 58,
                "color-rgba": 91
            }
        ],
        899: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./parcoords"), i = t1("../../lib/prepare_regl"), a = t1("./helpers").isVisible;
                function o(t1, e1, r) {
                    var n = e1.indexOf(r), i = t1.indexOf(n);
                    return -1 === i && (i += e1.length), i;
                }
                e1.exports = function(t1, e1) {
                    var r = t1._fullLayout;
                    if (i(t1)) {
                        var s = {}, l = {}, c = {}, u = {}, f = r._size;
                        e1.forEach(function(e1, r) {
                            var n = e1[0].trace;
                            c[r] = n.index;
                            var i = u[r] = n._fullInput.index;
                            s[r] = t1.data[i].dimensions, l[r] = t1.data[i].dimensions.slice();
                        });
                        n(t1, e1, {
                            width: f.w,
                            height: f.h,
                            margin: {
                                t: f.t,
                                r: f.r,
                                b: f.b,
                                l: f.l
                            }
                        }, {
                            filterChanged: function(e1, n, i) {
                                var a = l[e1][n], o = i.map(function(t1) {
                                    return t1.slice();
                                }), s = "dimensions[" + n + "].constraintrange", f = r._tracePreGUI[t1._fullData[c[e1]]._fullInput.uid];
                                if (void 0 === f[s]) {
                                    var h = a.constraintrange;
                                    f[s] = h || null;
                                }
                                var p = t1._fullData[c[e1]].dimensions[n];
                                o.length ? (1 === o.length && (o = o[0]), a.constraintrange = o, p.constraintrange = o.slice(), o = [
                                    o
                                ]) : (delete a.constraintrange, delete p.constraintrange, o = null);
                                var d = {};
                                d[s] = o, t1.emit("plotly_restyle", [
                                    d,
                                    [
                                        u[e1]
                                    ]
                                ]);
                            },
                            hover: function(e1) {
                                t1.emit("plotly_hover", e1);
                            },
                            unhover: function(e1) {
                                t1.emit("plotly_unhover", e1);
                            },
                            axesMoved: function(e1, r) {
                                var n = function(t1, e1) {
                                    return function(r, n) {
                                        return o(t1, e1, r) - o(t1, e1, n);
                                    };
                                }(r, l[e1].filter(a));
                                s[e1].sort(n), l[e1].filter(function(t1) {
                                    return !a(t1);
                                }).sort(function(t1) {
                                    return l[e1].indexOf(t1);
                                }).forEach(function(t1) {
                                    s[e1].splice(s[e1].indexOf(t1), 1), s[e1].splice(l[e1].indexOf(t1), 0, t1);
                                }), t1.emit("plotly_restyle", [
                                    {
                                        dimensions: [
                                            s[e1]
                                        ]
                                    },
                                    [
                                        u[e1]
                                    ]
                                ]);
                            }
                        });
                    }
                };
            },
            {
                "../../lib/prepare_regl": 516,
                "./helpers": 894,
                "./parcoords": 898
            }
        ],
        900: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/attributes"), i = t1("../../plots/domain").attributes, a = t1("../../plots/font_attributes"), o = t1("../../components/color/attributes"), s = t1("../../plots/template_attributes").hovertemplateAttrs, l = t1("../../plots/template_attributes").texttemplateAttrs, c = t1("../../lib/extend").extendFlat, u = a({
                    editType: "plot",
                    arrayOk: !0,
                    colorEditType: "plot"
                });
                e1.exports = {
                    labels: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    label0: {
                        valType: "number",
                        dflt: 0,
                        editType: "calc"
                    },
                    dlabel: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    values: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    marker: {
                        colors: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        line: {
                            color: {
                                valType: "color",
                                dflt: o.defaultLine,
                                arrayOk: !0,
                                editType: "style"
                            },
                            width: {
                                valType: "number",
                                min: 0,
                                dflt: 0,
                                arrayOk: !0,
                                editType: "style"
                            },
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    text: {
                        valType: "data_array",
                        editType: "plot"
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "style"
                    },
                    scalegroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    textinfo: {
                        valType: "flaglist",
                        flags: [
                            "label",
                            "text",
                            "value",
                            "percent"
                        ],
                        extras: [
                            "none"
                        ],
                        editType: "calc"
                    },
                    hoverinfo: c({}, n.hoverinfo, {
                        flags: [
                            "label",
                            "text",
                            "value",
                            "percent",
                            "name"
                        ]
                    }),
                    hovertemplate: s({}, {
                        keys: [
                            "label",
                            "color",
                            "value",
                            "percent",
                            "text"
                        ]
                    }),
                    texttemplate: l({
                        editType: "plot"
                    }, {
                        keys: [
                            "label",
                            "color",
                            "value",
                            "percent",
                            "text"
                        ]
                    }),
                    textposition: {
                        valType: "enumerated",
                        values: [
                            "inside",
                            "outside",
                            "auto",
                            "none"
                        ],
                        dflt: "auto",
                        arrayOk: !0,
                        editType: "plot"
                    },
                    textfont: c({}, u, {}),
                    insidetextorientation: {
                        valType: "enumerated",
                        values: [
                            "horizontal",
                            "radial",
                            "tangential",
                            "auto"
                        ],
                        dflt: "auto",
                        editType: "plot"
                    },
                    insidetextfont: c({}, u, {}),
                    outsidetextfont: c({}, u, {}),
                    automargin: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    },
                    title: {
                        text: {
                            valType: "string",
                            dflt: "",
                            editType: "plot"
                        },
                        font: c({}, u, {}),
                        position: {
                            valType: "enumerated",
                            values: [
                                "top left",
                                "top center",
                                "top right",
                                "middle center",
                                "bottom left",
                                "bottom center",
                                "bottom right"
                            ],
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    domain: i({
                        name: "pie",
                        trace: !0,
                        editType: "calc"
                    }),
                    hole: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "calc"
                    },
                    sort: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    direction: {
                        valType: "enumerated",
                        values: [
                            "clockwise",
                            "counterclockwise"
                        ],
                        dflt: "counterclockwise",
                        editType: "calc"
                    },
                    rotation: {
                        valType: "number",
                        min: -360,
                        max: 360,
                        dflt: 0,
                        editType: "calc"
                    },
                    pull: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        arrayOk: !0,
                        editType: "calc"
                    },
                    _deprecated: {
                        title: {
                            valType: "string",
                            dflt: "",
                            editType: "calc"
                        },
                        titlefont: c({}, u, {}),
                        titleposition: {
                            valType: "enumerated",
                            values: [
                                "top left",
                                "top center",
                                "top right",
                                "middle center",
                                "bottom left",
                                "bottom center",
                                "bottom right"
                            ],
                            editType: "calc"
                        }
                    }
                };
            },
            {
                "../../components/color/attributes": 365,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/domain": 584,
                "../../plots/font_attributes": 585,
                "../../plots/template_attributes": 633
            }
        ],
        901: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/plots");
                r.name = "pie", r.plot = function(t1, e1, i, a) {
                    n.plotBasePlot(r.name, t1, e1, i, a);
                }, r.clean = function(t1, e1, i, a) {
                    n.cleanBasePlot(r.name, t1, e1, i, a);
                };
            },
            {
                "../../plots/plots": 619
            }
        ],
        902: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("tinycolor2"), a = t1("../../components/color"), o = {};
                function s(t1) {
                    return function(e1, r) {
                        return !!e1 && !!(e1 = i(e1)).isValid() && (e1 = a.addOpacity(e1, e1.getAlpha()), t1[r] || (t1[r] = e1), e1);
                    };
                }
                function l(t1, e1) {
                    var r, n = JSON.stringify(t1), a = e1[n];
                    if (!a) {
                        for(a = t1.slice(), r = 0; r < t1.length; r++)a.push(i(t1[r]).lighten(20).toHexString());
                        for(r = 0; r < t1.length; r++)a.push(i(t1[r]).darken(20).toHexString());
                        e1[n] = a;
                    }
                    return a;
                }
                e1.exports = {
                    calc: function(t1, e1) {
                        var r, i, a = [], o = t1._fullLayout, l = o.hiddenlabels || [], c = e1.labels, u = e1.marker.colors || [], f = e1.values, h = e1._length, p = e1._hasValues && h;
                        if (e1.dlabel) for(c = new Array(h), r = 0; r < h; r++)c[r] = String(e1.label0 + r * e1.dlabel);
                        var d = {}, m = s(o["_" + e1.type + "colormap"]), g = 0, v = !1;
                        for(r = 0; r < h; r++){
                            var y, x, b;
                            if (p) {
                                if (y = f[r], !n(y)) continue;
                                y = +y;
                            } else y = 1;
                            void 0 !== (x = c[r]) && "" !== x || (x = r);
                            var _ = d[x = String(x)];
                            void 0 === _ ? (d[x] = a.length, (b = -1 !== l.indexOf(x)) || (g += y), a.push({
                                v: y,
                                label: x,
                                color: m(u[r], x),
                                i: r,
                                pts: [
                                    r
                                ],
                                hidden: b
                            })) : (v = !0, (i = a[_]).v += y, i.pts.push(r), i.hidden || (g += y), !1 === i.color && u[r] && (i.color = m(u[r], x)));
                        }
                        return a = a.filter(function(t1) {
                            return t1.v >= 0;
                        }), ("funnelarea" === e1.type ? v : e1.sort) && a.sort(function(t1, e1) {
                            return e1.v - t1.v;
                        }), a[0] && (a[0].vTotal = g), a;
                    },
                    crossTraceCalc: function(t1, e1) {
                        var r = (e1 || {}).type;
                        r || (r = "pie");
                        var n = t1._fullLayout, i = t1.calcdata, a = n[r + "colorway"], s = n["_" + r + "colormap"];
                        n["extend" + r + "colors"] && (a = l(a, o));
                        for(var c = 0, u = 0; u < i.length; u++){
                            var f = i[u];
                            if (f[0].trace.type === r) for(var h = 0; h < f.length; h++){
                                var p = f[h];
                                !1 === p.color && (s[p.label] ? p.color = s[p.label] : (s[p.label] = p.color = a[c % a.length], c++));
                            }
                        }
                    },
                    makePullColorFn: s,
                    generateExtendedColors: l
                };
            },
            {
                "../../components/color": 366,
                "fast-isnumeric": 190,
                tinycolor2: 312
            }
        ],
        903: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = t1("./attributes"), o = t1("../../plots/domain").defaults, s = t1("../bar/defaults").handleText;
                function l(t1, e1) {
                    var r = Array.isArray(t1), a = i.isArrayOrTypedArray(e1), o = Math.min(r ? t1.length : 1 / 0, a ? e1.length : 1 / 0);
                    if (isFinite(o) || (o = 0), o && a) {
                        for(var s, l = 0; l < o; l++){
                            var c = e1[l];
                            if (n(c) && c > 0) {
                                s = !0;
                                break;
                            }
                        }
                        s || (o = 0);
                    }
                    return {
                        hasLabels: r,
                        hasValues: a,
                        len: o
                    };
                }
                e1.exports = {
                    handleLabelsAndValues: l,
                    supplyDefaults: function(t1, e1, r, n) {
                        function c(r, n) {
                            return i.coerce(t1, e1, a, r, n);
                        }
                        var u = l(c("labels"), c("values")), f = u.len;
                        if (e1._hasLabels = u.hasLabels, e1._hasValues = u.hasValues, !e1._hasLabels && e1._hasValues && (c("label0"), c("dlabel")), f) {
                            e1._length = f, c("marker.line.width") && c("marker.line.color"), c("marker.colors"), c("scalegroup");
                            var h, p = c("text"), d = c("texttemplate");
                            if (d || (h = c("textinfo", Array.isArray(p) ? "text+percent" : "percent")), c("hovertext"), c("hovertemplate"), d || h && "none" !== h) {
                                var m = c("textposition");
                                s(t1, e1, n, c, m, {
                                    moduleHasSelected: !1,
                                    moduleHasUnselected: !1,
                                    moduleHasConstrain: !1,
                                    moduleHasCliponaxis: !1,
                                    moduleHasTextangle: !1,
                                    moduleHasInsideanchor: !1
                                }), (Array.isArray(m) || "auto" === m || "outside" === m) && c("automargin"), ("inside" === m || "auto" === m || Array.isArray(m)) && c("insidetextorientation");
                            }
                            o(e1, n, c);
                            var g = c("hole");
                            if (c("title.text")) {
                                var v = c("title.position", g ? "middle center" : "top center");
                                g || "middle center" !== v || (e1.title.position = "top center"), i.coerceFont(c, "title.font", n.font);
                            }
                            c("sort"), c("direction"), c("rotation"), c("pull");
                        } else e1.visible = !1;
                    }
                };
            },
            {
                "../../lib": 503,
                "../../plots/domain": 584,
                "../bar/defaults": 652,
                "./attributes": 900,
                "fast-isnumeric": 190
            }
        ],
        904: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/fx/helpers").appendArrayMultiPointValues;
                e1.exports = function(t1, e1) {
                    var r = {
                        curveNumber: e1.index,
                        pointNumbers: t1.pts,
                        data: e1._input,
                        fullData: e1,
                        label: t1.label,
                        color: t1.color,
                        value: t1.v,
                        percent: t1.percent,
                        text: t1.text,
                        bbox: t1.bbox,
                        v: t1.v
                    };
                    return 1 === t1.pts.length && (r.pointNumber = r.i = t1.pts[0]), n(r, e1, t1.pts), "funnelarea" === e1.type && (delete r.v, delete r.i), r;
                };
            },
            {
                "../../components/fx/helpers": 402
            }
        ],
        905: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                function i(t1) {
                    return -1 !== t1.indexOf("e") ? t1.replace(/[.]?0+e/, "e") : -1 !== t1.indexOf(".") ? t1.replace(/[.]?0+$/, "") : t1;
                }
                r.formatPiePercent = function(t1, e1) {
                    var r = i((100 * t1).toPrecision(3));
                    return n.numSeparate(r, e1) + "%";
                }, r.formatPieValue = function(t1, e1) {
                    var r = i(t1.toPrecision(10));
                    return n.numSeparate(r, e1);
                }, r.getFirstFilled = function(t1, e1) {
                    if (Array.isArray(t1)) for(var r = 0; r < e1.length; r++){
                        var n = t1[e1[r]];
                        if (n || 0 === n || "" === n) return n;
                    }
                }, r.castOption = function(t1, e1) {
                    return Array.isArray(t1) ? r.getFirstFilled(t1, e1) : t1 || void 0;
                }, r.getRotationAngle = function(t1) {
                    return ("auto" === t1 ? 0 : t1) * Math.PI / 180;
                };
            },
            {
                "../../lib": 503
            }
        ],
        906: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults").supplyDefaults,
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    layoutAttributes: t1("./layout_attributes"),
                    calc: t1("./calc").calc,
                    crossTraceCalc: t1("./calc").crossTraceCalc,
                    plot: t1("./plot").plot,
                    style: t1("./style"),
                    styleOne: t1("./style_one"),
                    moduleType: "trace",
                    name: "pie",
                    basePlotModule: t1("./base_plot"),
                    categories: [
                        "pie-like",
                        "pie",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            {
                "./attributes": 900,
                "./base_plot": 901,
                "./calc": 902,
                "./defaults": 903,
                "./layout_attributes": 907,
                "./layout_defaults": 908,
                "./plot": 909,
                "./style": 910,
                "./style_one": 911
            }
        ],
        907: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    hiddenlabels: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    piecolorway: {
                        valType: "colorlist",
                        editType: "calc"
                    },
                    extendpiecolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    }
                };
            },
            {}
        ],
        908: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./layout_attributes");
                e1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    r("hiddenlabels"), r("piecolorway", e1.colorway), r("extendpiecolors");
                };
            },
            {
                "../../lib": 503,
                "./layout_attributes": 907
            }
        ],
        909: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../plots/plots"), a = t1("../../components/fx"), o = t1("../../components/color"), s = t1("../../components/drawing"), l = t1("../../lib"), c = l.strScale, u = l.strTranslate, f = t1("../../lib/svg_text_utils"), h = t1("../bar/uniform_text"), p = h.recordMinTextSize, d = h.clearMinTextSize, m = t1("../bar/constants").TEXTPAD, g = t1("./helpers"), v = t1("./event_data"), y = t1("../../lib").isValidTextValue;
                function x(t1, e1, r) {
                    var i = r[0], o = i.cx, s = i.cy, c = i.trace, u = "funnelarea" === c.type;
                    "_hasHoverLabel" in c || (c._hasHoverLabel = !1), "_hasHoverEvent" in c || (c._hasHoverEvent = !1), t1.on("mouseover", function(t1) {
                        var r = e1._fullLayout, f = e1._fullData[c.index];
                        if (!e1._dragging && !1 !== r.hovermode) {
                            var h = f.hoverinfo;
                            if (Array.isArray(h) && (h = a.castHoverinfo({
                                hoverinfo: [
                                    g.castOption(h, t1.pts)
                                ],
                                _module: c._module
                            }, r, 0)), "all" === h && (h = "label+text+value+percent+name"), f.hovertemplate || "none" !== h && "skip" !== h && h) {
                                var p = t1.rInscribed || 0, d = o + t1.pxmid[0] * (1 - p), m = s + t1.pxmid[1] * (1 - p), y = r.separators, x = [];
                                if (h && -1 !== h.indexOf("label") && x.push(t1.label), t1.text = g.castOption(f.hovertext || f.text, t1.pts), h && -1 !== h.indexOf("text")) {
                                    var b = t1.text;
                                    l.isValidTextValue(b) && x.push(b);
                                }
                                t1.value = t1.v, t1.valueLabel = g.formatPieValue(t1.v, y), h && -1 !== h.indexOf("value") && x.push(t1.valueLabel), t1.percent = t1.v / i.vTotal, t1.percentLabel = g.formatPiePercent(t1.percent, y), h && -1 !== h.indexOf("percent") && x.push(t1.percentLabel);
                                var _ = f.hoverlabel, w = _.font, T = [];
                                a.loneHover({
                                    trace: c,
                                    x0: d - p * i.r,
                                    x1: d + p * i.r,
                                    y: m,
                                    _x0: u ? o + t1.TL[0] : d - p * i.r,
                                    _x1: u ? o + t1.TR[0] : d + p * i.r,
                                    _y0: u ? s + t1.TL[1] : m - p * i.r,
                                    _y1: u ? s + t1.BL[1] : m + p * i.r,
                                    text: x.join("<br>"),
                                    name: f.hovertemplate || -1 !== h.indexOf("name") ? f.name : void 0,
                                    idealAlign: t1.pxmid[0] < 0 ? "left" : "right",
                                    color: g.castOption(_.bgcolor, t1.pts) || t1.color,
                                    borderColor: g.castOption(_.bordercolor, t1.pts),
                                    fontFamily: g.castOption(w.family, t1.pts),
                                    fontSize: g.castOption(w.size, t1.pts),
                                    fontColor: g.castOption(w.color, t1.pts),
                                    nameLength: g.castOption(_.namelength, t1.pts),
                                    textAlign: g.castOption(_.align, t1.pts),
                                    hovertemplate: g.castOption(f.hovertemplate, t1.pts),
                                    hovertemplateLabels: t1,
                                    eventData: [
                                        v(t1, f)
                                    ]
                                }, {
                                    container: r._hoverlayer.node(),
                                    outerContainer: r._paper.node(),
                                    gd: e1,
                                    inOut_bbox: T
                                }), t1.bbox = T[0], c._hasHoverLabel = !0;
                            }
                            c._hasHoverEvent = !0, e1.emit("plotly_hover", {
                                points: [
                                    v(t1, f)
                                ],
                                event: n.event
                            });
                        }
                    }), t1.on("mouseout", function(t1) {
                        var r = e1._fullLayout, i = e1._fullData[c.index], o = n.select(this).datum();
                        c._hasHoverEvent && (t1.originalEvent = n.event, e1.emit("plotly_unhover", {
                            points: [
                                v(o, i)
                            ],
                            event: n.event
                        }), c._hasHoverEvent = !1), c._hasHoverLabel && (a.loneUnhover(r._hoverlayer.node()), c._hasHoverLabel = !1);
                    }), t1.on("click", function(t1) {
                        var r = e1._fullLayout, i = e1._fullData[c.index];
                        e1._dragging || !1 === r.hovermode || (e1._hoverdata = [
                            v(t1, i)
                        ], a.click(e1, n.event));
                    });
                }
                function b(t1, e1, r) {
                    var n = g.castOption(t1.insidetextfont.color, e1.pts);
                    !n && t1._input.textfont && (n = g.castOption(t1._input.textfont.color, e1.pts));
                    var i = g.castOption(t1.insidetextfont.family, e1.pts) || g.castOption(t1.textfont.family, e1.pts) || r.family, a = g.castOption(t1.insidetextfont.size, e1.pts) || g.castOption(t1.textfont.size, e1.pts) || r.size;
                    return {
                        color: n || o.contrast(e1.color),
                        family: i,
                        size: a
                    };
                }
                function _(t1, e1) {
                    for(var r, n, i = 0; i < t1.length; i++)if ((n = (r = t1[i][0]).trace).title.text) {
                        var a = n.title.text;
                        n._meta && (a = l.templateString(a, n._meta));
                        var o = s.tester.append("text").attr("data-notex", 1).text(a).call(s.font, n.title.font).call(f.convertToTspans, e1), c = s.bBox(o.node(), !0);
                        r.titleBox = {
                            width: c.width,
                            height: c.height
                        }, o.remove();
                    }
                }
                function w(t1, e1, r) {
                    var n = r.r || e1.rpx1, i = e1.rInscribed;
                    if (e1.startangle === e1.stopangle) return {
                        rCenter: 1 - i,
                        scale: 0,
                        rotate: 0,
                        textPosAngle: 0
                    };
                    var a, o = e1.ring, s = 1 === o && Math.abs(e1.startangle - e1.stopangle) === 2 * Math.PI, l = e1.halfangle, c = e1.midangle, u = r.trace.insidetextorientation, f = "horizontal" === u, h = "tangential" === u, p = "radial" === u, d = "auto" === u, m = [];
                    if (!d) {
                        var g, v = function(r, i) {
                            if (function(t1, e1) {
                                var r = t1.startangle, n = t1.stopangle;
                                return r > e1 && e1 > n || r < e1 && e1 < n;
                            }(e1, r)) {
                                var s = Math.abs(r - e1.startangle), l = Math.abs(r - e1.stopangle), c = s < l ? s : l;
                                (a = "tan" === i ? k(t1, n, o, c, 0) : T(t1, n, o, c, Math.PI / 2)).textPosAngle = r, m.push(a);
                            }
                        };
                        if (f || h) {
                            for(g = 4; g >= -4; g -= 2)v(Math.PI * g, "tan");
                            for(g = 4; g >= -4; g -= 2)v(Math.PI * (g + 1), "tan");
                        }
                        if (f || p) {
                            for(g = 4; g >= -4; g -= 2)v(Math.PI * (g + 1.5), "rad");
                            for(g = 4; g >= -4; g -= 2)v(Math.PI * (g + .5), "rad");
                        }
                    }
                    if (s || d || f) {
                        var y = Math.sqrt(t1.width * t1.width + t1.height * t1.height);
                        if ((a = {
                            scale: i * n * 2 / y,
                            rCenter: 1 - i,
                            rotate: 0
                        }).textPosAngle = (e1.startangle + e1.stopangle) / 2, a.scale >= 1) return a;
                        m.push(a);
                    }
                    (d || p) && ((a = T(t1, n, o, l, c)).textPosAngle = (e1.startangle + e1.stopangle) / 2, m.push(a)), (d || h) && ((a = k(t1, n, o, l, c)).textPosAngle = (e1.startangle + e1.stopangle) / 2, m.push(a));
                    for(var x = 0, b = 0, _ = 0; _ < m.length; _++){
                        var w = m[_].scale;
                        if (b < w && (b = w, x = _), !d && b >= 1) break;
                    }
                    return m[x];
                }
                function T(t1, e1, r, n, i) {
                    e1 = Math.max(0, e1 - 2 * m);
                    var a = t1.width / t1.height, o = S(a, n, e1, r);
                    return {
                        scale: 2 * o / t1.height,
                        rCenter: A(a, o / e1),
                        rotate: M(i)
                    };
                }
                function k(t1, e1, r, n, i) {
                    e1 = Math.max(0, e1 - 2 * m);
                    var a = t1.height / t1.width, o = S(a, n, e1, r);
                    return {
                        scale: 2 * o / t1.width,
                        rCenter: A(a, o / e1),
                        rotate: M(i + Math.PI / 2)
                    };
                }
                function A(t1, e1) {
                    return Math.cos(e1) - t1 * e1;
                }
                function M(t1) {
                    return (180 / Math.PI * t1 + 720) % 180 - 90;
                }
                function S(t1, e1, r, n) {
                    var i = t1 + 1 / (2 * Math.tan(e1));
                    return r * Math.min(1 / (Math.sqrt(i * i + .5) + i), n / (Math.sqrt(t1 * t1 + n / 2) + t1));
                }
                function E(t1, e1) {
                    return t1.v !== e1.vTotal || e1.trace.hole ? Math.min(1 / (1 + 1 / Math.sin(t1.halfangle)), t1.ring / 2) : 1;
                }
                function L(t1, e1) {
                    var r = e1.pxmid[0], n = e1.pxmid[1], i = t1.width / 2, a = t1.height / 2;
                    return r < 0 && (i *= -1), n < 0 && (a *= -1), {
                        scale: 1,
                        rCenter: 1,
                        rotate: 0,
                        x: i + Math.abs(a) * (i > 0 ? 1 : -1) / 2,
                        y: a / (1 + r * r / (n * n)),
                        outside: !0
                    };
                }
                function C(t1, e1) {
                    var r, n, i, a = t1.trace, o = {
                        x: t1.cx,
                        y: t1.cy
                    }, s = {
                        tx: 0,
                        ty: 0
                    };
                    s.ty += a.title.font.size, i = I(a), -1 !== a.title.position.indexOf("top") ? (o.y -= (1 + i) * t1.r, s.ty -= t1.titleBox.height) : -1 !== a.title.position.indexOf("bottom") && (o.y += (1 + i) * t1.r);
                    var l, c, u = (l = t1.r, c = t1.trace.aspectratio, l / (void 0 === c ? 1 : c)), f = e1.w * (a.domain.x[1] - a.domain.x[0]) / 2;
                    return -1 !== a.title.position.indexOf("left") ? (f += u, o.x -= (1 + i) * u, s.tx += t1.titleBox.width / 2) : -1 !== a.title.position.indexOf("center") ? f *= 2 : -1 !== a.title.position.indexOf("right") && (f += u, o.x += (1 + i) * u, s.tx -= t1.titleBox.width / 2), r = f / t1.titleBox.width, n = P(t1, e1) / t1.titleBox.height, {
                        x: o.x,
                        y: o.y,
                        scale: Math.min(r, n),
                        tx: s.tx,
                        ty: s.ty
                    };
                }
                function P(t1, e1) {
                    var r = t1.trace, n = e1.h * (r.domain.y[1] - r.domain.y[0]);
                    return Math.min(t1.titleBox.height, n / 2);
                }
                function I(t1) {
                    var e1, r = t1.pull;
                    if (!r) return 0;
                    if (Array.isArray(r)) for(r = 0, e1 = 0; e1 < t1.pull.length; e1++)t1.pull[e1] > r && (r = t1.pull[e1]);
                    return r;
                }
                function O(t1, e1) {
                    for(var r = [], n = 0; n < t1.length; n++){
                        var i = t1[n][0], a = i.trace, o = a.domain, s = e1.w * (o.x[1] - o.x[0]), l = e1.h * (o.y[1] - o.y[0]);
                        a.title.text && "middle center" !== a.title.position && (l -= P(i, e1));
                        var c = s / 2, u = l / 2;
                        "funnelarea" !== a.type || a.scalegroup || (u /= a.aspectratio), i.r = Math.min(c, u) / (1 + I(a)), i.cx = e1.l + e1.w * (a.domain.x[1] + a.domain.x[0]) / 2, i.cy = e1.t + e1.h * (1 - a.domain.y[0]) - l / 2, a.title.text && -1 !== a.title.position.indexOf("bottom") && (i.cy -= P(i, e1)), a.scalegroup && -1 === r.indexOf(a.scalegroup) && r.push(a.scalegroup);
                    }
                    !function(t1, e1) {
                        for(var r, n, i, a = 0; a < e1.length; a++){
                            var o = 1 / 0, s = e1[a];
                            for(n = 0; n < t1.length; n++)if (r = t1[n][0], (i = r.trace).scalegroup === s) {
                                var l;
                                if ("pie" === i.type) l = r.r * r.r;
                                else if ("funnelarea" === i.type) {
                                    var c, u;
                                    i.aspectratio > 1 ? (c = r.r, u = c / i.aspectratio) : (u = r.r, c = u * i.aspectratio), c *= (1 + i.baseratio) / 2, l = c * u;
                                }
                                o = Math.min(o, l / r.vTotal);
                            }
                            for(n = 0; n < t1.length; n++)if (r = t1[n][0], (i = r.trace).scalegroup === s) {
                                var f = o * r.vTotal;
                                "funnelarea" === i.type && (f /= (1 + i.baseratio) / 2, f /= i.aspectratio), r.r = Math.sqrt(f);
                            }
                        }
                    }(t1, r);
                }
                function z(t1, e1) {
                    return [
                        t1 * Math.sin(e1),
                        -t1 * Math.cos(e1)
                    ];
                }
                function D(t1, e1, r) {
                    var n = t1._fullLayout, i = r.trace, a = i.texttemplate, o = i.textinfo;
                    if (!a && o && "none" !== o) {
                        var s, c = o.split("+"), u = function(t1) {
                            return -1 !== c.indexOf(t1);
                        }, f = u("label"), h = u("text"), p = u("value"), d = u("percent"), m = n.separators;
                        if (s = f ? [
                            e1.label
                        ] : [], h) {
                            var v = g.getFirstFilled(i.text, e1.pts);
                            y(v) && s.push(v);
                        }
                        p && s.push(g.formatPieValue(e1.v, m)), d && s.push(g.formatPiePercent(e1.v / r.vTotal, m)), e1.text = s.join("<br>");
                    }
                    if (a) {
                        var x = l.castOption(i, e1.i, "texttemplate");
                        if (x) {
                            var b = function(t1) {
                                return {
                                    label: t1.label,
                                    value: t1.v,
                                    valueLabel: g.formatPieValue(t1.v, n.separators),
                                    percent: t1.v / r.vTotal,
                                    percentLabel: g.formatPiePercent(t1.v / r.vTotal, n.separators),
                                    color: t1.color,
                                    text: t1.text,
                                    customdata: l.castOption(i, t1.i, "customdata")
                                };
                            }(e1), _ = g.getFirstFilled(i.text, e1.pts);
                            (y(_) || "" === _) && (b.text = _), e1.text = l.texttemplateString(x, b, t1._fullLayout._d3locale, b, i._meta || {});
                        } else e1.text = "";
                    }
                }
                function R(t1, e1) {
                    var r = t1.rotate * Math.PI / 180, n = Math.cos(r), i = Math.sin(r), a = (e1.left + e1.right) / 2, o = (e1.top + e1.bottom) / 2;
                    t1.textX = a * n - o * i, t1.textY = a * i + o * n, t1.noCenter = !0;
                }
                e1.exports = {
                    plot: function(t1, e1) {
                        var r = t1._fullLayout, a = r._size;
                        d("pie", r), _(e1, t1), O(e1, a);
                        var h = l.makeTraceGroups(r._pielayer, e1, "trace").each(function(e1) {
                            var h = n.select(this), d = e1[0], m = d.trace;
                            !function(t1) {
                                var e1, r, n, i = t1[0], a = i.r, o = i.trace, s = g.getRotationAngle(o.rotation), l = 2 * Math.PI / i.vTotal, c = "px0", u = "px1";
                                if ("counterclockwise" === o.direction) {
                                    for(e1 = 0; e1 < t1.length && t1[e1].hidden; e1++);
                                    if (e1 === t1.length) return;
                                    s += l * t1[e1].v, l *= -1, c = "px1", u = "px0";
                                }
                                for(n = z(a, s), e1 = 0; e1 < t1.length; e1++)(r = t1[e1]).hidden || (r[c] = n, r.startangle = s, s += l * r.v / 2, r.pxmid = z(a, s), r.midangle = s, s += l * r.v / 2, n = z(a, s), r.stopangle = s, r[u] = n, r.largeArc = r.v > i.vTotal / 2 ? 1 : 0, r.halfangle = Math.PI * Math.min(r.v / i.vTotal, .5), r.ring = 1 - o.hole, r.rInscribed = E(r, i));
                            }(e1), h.attr("stroke-linejoin", "round"), h.each(function() {
                                var v = n.select(this).selectAll("g.slice").data(e1);
                                v.enter().append("g").classed("slice", !0), v.exit().remove();
                                var y = [
                                    [
                                        [],
                                        []
                                    ],
                                    [
                                        [],
                                        []
                                    ]
                                ], _ = !1;
                                v.each(function(i, a) {
                                    if (i.hidden) n.select(this).selectAll("path,g").remove();
                                    else {
                                        i.pointNumber = i.i, i.curveNumber = m.index, y[i.pxmid[1] < 0 ? 0 : 1][i.pxmid[0] < 0 ? 0 : 1].push(i);
                                        var o = d.cx, c = d.cy, u = n.select(this), h = u.selectAll("path.surface").data([
                                            i
                                        ]);
                                        if (h.enter().append("path").classed("surface", !0).style({
                                            "pointer-events": "all"
                                        }), u.call(x, t1, e1), m.pull) {
                                            var v = +g.castOption(m.pull, i.pts) || 0;
                                            v > 0 && (o += v * i.pxmid[0], c += v * i.pxmid[1]);
                                        }
                                        i.cxFinal = o, i.cyFinal = c;
                                        var T = m.hole;
                                        if (i.v === d.vTotal) {
                                            var k = "M" + (o + i.px0[0]) + "," + (c + i.px0[1]) + C(i.px0, i.pxmid, !0, 1) + C(i.pxmid, i.px0, !0, 1) + "Z";
                                            T ? h.attr("d", "M" + (o + T * i.px0[0]) + "," + (c + T * i.px0[1]) + C(i.px0, i.pxmid, !1, T) + C(i.pxmid, i.px0, !1, T) + "Z" + k) : h.attr("d", k);
                                        } else {
                                            var A = C(i.px0, i.px1, !0, 1);
                                            if (T) {
                                                var M = 1 - T;
                                                h.attr("d", "M" + (o + T * i.px1[0]) + "," + (c + T * i.px1[1]) + C(i.px1, i.px0, !1, T) + "l" + M * i.px0[0] + "," + M * i.px0[1] + A + "Z");
                                            } else h.attr("d", "M" + o + "," + c + "l" + i.px0[0] + "," + i.px0[1] + A + "Z");
                                        }
                                        D(t1, i, d);
                                        var S = g.castOption(m.textposition, i.pts), E = u.selectAll("g.slicetext").data(i.text && "none" !== S ? [
                                            0
                                        ] : []);
                                        E.enter().append("g").classed("slicetext", !0), E.exit().remove(), E.each(function() {
                                            var u = l.ensureSingle(n.select(this), "text", "", function(t1) {
                                                t1.attr("data-notex", 1);
                                            }), h = l.ensureUniformFontSize(t1, "outside" === S ? function(t1, e1, r) {
                                                var n = g.castOption(t1.outsidetextfont.color, e1.pts) || g.castOption(t1.textfont.color, e1.pts) || r.color, i = g.castOption(t1.outsidetextfont.family, e1.pts) || g.castOption(t1.textfont.family, e1.pts) || r.family, a = g.castOption(t1.outsidetextfont.size, e1.pts) || g.castOption(t1.textfont.size, e1.pts) || r.size;
                                                return {
                                                    color: n,
                                                    family: i,
                                                    size: a
                                                };
                                            }(m, i, r.font) : b(m, i, r.font));
                                            u.text(i.text).attr({
                                                class: "slicetext",
                                                transform: "",
                                                "text-anchor": "middle"
                                            }).call(s.font, h).call(f.convertToTspans, t1);
                                            var v, y = s.bBox(u.node());
                                            if ("outside" === S) v = L(y, i);
                                            else if (v = w(y, i, d), "auto" === S && v.scale < 1) {
                                                var x = l.ensureUniformFontSize(t1, m.outsidetextfont);
                                                u.call(s.font, x), v = L(y = s.bBox(u.node()), i);
                                            }
                                            var T = v.textPosAngle, k = void 0 === T ? i.pxmid : z(d.r, T);
                                            if (v.targetX = o + k[0] * v.rCenter + (v.x || 0), v.targetY = c + k[1] * v.rCenter + (v.y || 0), R(v, y), v.outside) {
                                                var A = v.targetY;
                                                i.yLabelMin = A - y.height / 2, i.yLabelMid = A, i.yLabelMax = A + y.height / 2, i.labelExtraX = 0, i.labelExtraY = 0, _ = !0;
                                            }
                                            v.fontSize = h.size, p(m.type, v, r), e1[a].transform = v, u.attr("transform", l.getTextTransform(v));
                                        });
                                    }
                                    function C(t1, e1, r, n) {
                                        var a = n * (e1[0] - t1[0]), o = n * (e1[1] - t1[1]);
                                        return "a" + n * d.r + "," + n * d.r + " 0 " + i.largeArc + (r ? " 1 " : " 0 ") + a + "," + o;
                                    }
                                });
                                var T = n.select(this).selectAll("g.titletext").data(m.title.text ? [
                                    0
                                ] : []);
                                if (T.enter().append("g").classed("titletext", !0), T.exit().remove(), T.each(function() {
                                    var e1, r = l.ensureSingle(n.select(this), "text", "", function(t1) {
                                        t1.attr("data-notex", 1);
                                    }), i = m.title.text;
                                    m._meta && (i = l.templateString(i, m._meta)), r.text(i).attr({
                                        class: "titletext",
                                        transform: "",
                                        "text-anchor": "middle"
                                    }).call(s.font, m.title.font).call(f.convertToTspans, t1), e1 = "middle center" === m.title.position ? function(t1) {
                                        var e1 = Math.sqrt(t1.titleBox.width * t1.titleBox.width + t1.titleBox.height * t1.titleBox.height);
                                        return {
                                            x: t1.cx,
                                            y: t1.cy,
                                            scale: t1.trace.hole * t1.r * 2 / e1,
                                            tx: 0,
                                            ty: -t1.titleBox.height / 2 + t1.trace.title.font.size
                                        };
                                    }(d) : C(d, a), r.attr("transform", u(e1.x, e1.y) + c(Math.min(1, e1.scale)) + u(e1.tx, e1.ty));
                                }), _ && function(t1, e1) {
                                    var r, n, i, a, o, s, l, c, u, f, h, p, d;
                                    function m(t1, e1) {
                                        return t1.pxmid[1] - e1.pxmid[1];
                                    }
                                    function v(t1, e1) {
                                        return e1.pxmid[1] - t1.pxmid[1];
                                    }
                                    function y(t1, r) {
                                        r || (r = {});
                                        var i, c, u, h, p = r.labelExtraY + (n ? r.yLabelMax : r.yLabelMin), d = n ? t1.yLabelMin : t1.yLabelMax, m = n ? t1.yLabelMax : t1.yLabelMin, v = t1.cyFinal + o(t1.px0[1], t1.px1[1]), y = p - d;
                                        if (y * l > 0 && (t1.labelExtraY = y), Array.isArray(e1.pull)) for(c = 0; c < f.length; c++)(u = f[c]) === t1 || (g.castOption(e1.pull, t1.pts) || 0) >= (g.castOption(e1.pull, u.pts) || 0) || ((t1.pxmid[1] - u.pxmid[1]) * l > 0 ? (y = u.cyFinal + o(u.px0[1], u.px1[1]) - d - t1.labelExtraY) * l > 0 && (t1.labelExtraY += y) : (m + t1.labelExtraY - v) * l > 0 && (i = 3 * s * Math.abs(c - f.indexOf(t1)), (h = u.cxFinal + a(u.px0[0], u.px1[0]) + i - (t1.cxFinal + t1.pxmid[0]) - t1.labelExtraX) * s > 0 && (t1.labelExtraX += h)));
                                    }
                                    for(n = 0; n < 2; n++)for(i = n ? m : v, o = n ? Math.max : Math.min, l = n ? 1 : -1, r = 0; r < 2; r++){
                                        for(a = r ? Math.max : Math.min, s = r ? 1 : -1, (c = t1[n][r]).sort(i), u = t1[1 - n][r], f = u.concat(c), p = [], h = 0; h < c.length; h++)void 0 !== c[h].yLabelMid && p.push(c[h]);
                                        for(d = !1, h = 0; n && h < u.length; h++)if (void 0 !== u[h].yLabelMid) {
                                            d = u[h];
                                            break;
                                        }
                                        for(h = 0; h < p.length; h++){
                                            var x = h && p[h - 1];
                                            d && !h && (x = d), y(p[h], x);
                                        }
                                    }
                                }(y, m), function(t1, e1) {
                                    t1.each(function(t1) {
                                        var r = n.select(this);
                                        if (t1.labelExtraX || t1.labelExtraY) {
                                            var i = r.select("g.slicetext text");
                                            t1.transform.targetX += t1.labelExtraX, t1.transform.targetY += t1.labelExtraY, i.attr("transform", l.getTextTransform(t1.transform));
                                            var a = t1.cxFinal + t1.pxmid[0], s = "M" + a + "," + (t1.cyFinal + t1.pxmid[1]), c = (t1.yLabelMax - t1.yLabelMin) * (t1.pxmid[0] < 0 ? -1 : 1) / 4;
                                            if (t1.labelExtraX) {
                                                var u = t1.labelExtraX * t1.pxmid[1] / t1.pxmid[0], f = t1.yLabelMid + t1.labelExtraY - (t1.cyFinal + t1.pxmid[1]);
                                                Math.abs(u) > Math.abs(f) ? s += "l" + f * t1.pxmid[0] / t1.pxmid[1] + "," + f + "H" + (a + t1.labelExtraX + c) : s += "l" + t1.labelExtraX + "," + u + "v" + (f - u) + "h" + c;
                                            } else s += "V" + (t1.yLabelMid + t1.labelExtraY) + "h" + c;
                                            l.ensureSingle(r, "path", "textline").call(o.stroke, e1.outsidetextfont.color).attr({
                                                "stroke-width": Math.min(2, e1.outsidetextfont.size / 8),
                                                d: s,
                                                fill: "none"
                                            });
                                        } else r.select("path.textline").remove();
                                    });
                                }(v, m), _ && m.automargin) {
                                    var k = s.bBox(h.node()), A = m.domain, M = a.w * (A.x[1] - A.x[0]), S = a.h * (A.y[1] - A.y[0]), E = (.5 * M - d.r) / a.w, P = (.5 * S - d.r) / a.h;
                                    i.autoMargin(t1, "pie." + m.uid + ".automargin", {
                                        xl: A.x[0] - E,
                                        xr: A.x[1] + E,
                                        yb: A.y[0] - P,
                                        yt: A.y[1] + P,
                                        l: Math.max(d.cx - d.r - k.left, 0),
                                        r: Math.max(k.right - (d.cx + d.r), 0),
                                        b: Math.max(k.bottom - (d.cy + d.r), 0),
                                        t: Math.max(d.cy - d.r - k.top, 0),
                                        pad: 5
                                    });
                                }
                            });
                        });
                        setTimeout(function() {
                            h.selectAll("tspan").each(function() {
                                var t1 = n.select(this);
                                t1.attr("dy") && t1.attr("dy", t1.attr("dy"));
                            });
                        }, 0);
                    },
                    formatSliceLabel: D,
                    transformInsideText: w,
                    determineInsideTextFont: b,
                    positionTitleOutside: C,
                    prerenderTitles: _,
                    layoutAreas: O,
                    attachFxHandlers: x,
                    computeTransform: R
                };
            },
            {
                "../../components/color": 366,
                "../../components/drawing": 388,
                "../../components/fx": 406,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../../plots/plots": 619,
                "../bar/constants": 650,
                "../bar/uniform_text": 664,
                "./event_data": 904,
                "./helpers": 905,
                "@plotly/d3": 58
            }
        ],
        910: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("./style_one"), a = t1("../bar/uniform_text").resizeText;
                e1.exports = function(t1) {
                    var e1 = t1._fullLayout._pielayer.selectAll(".trace");
                    a(t1, e1, "pie"), e1.each(function(t1) {
                        var e1 = t1[0].trace, r = n.select(this);
                        r.style({
                            opacity: e1.opacity
                        }), r.selectAll("path.surface").each(function(t1) {
                            n.select(this).call(i, t1, e1);
                        });
                    });
                };
            },
            {
                "../bar/uniform_text": 664,
                "./style_one": 911,
                "@plotly/d3": 58
            }
        ],
        911: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color"), i = t1("./helpers").castOption;
                e1.exports = function(t1, e1, r) {
                    var a = r.marker.line, o = i(a.color, e1.pts) || n.defaultLine, s = i(a.width, e1.pts) || 0;
                    t1.style("stroke-width", s).call(n.fill, e1.color).call(n.stroke, o);
                };
            },
            {
                "../../components/color": 366,
                "./helpers": 905
            }
        ],
        912: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/attributes");
                e1.exports = {
                    x: n.x,
                    y: n.y,
                    xy: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    indices: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    xbounds: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    ybounds: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    text: n.text,
                    marker: {
                        color: {
                            valType: "color",
                            arrayOk: !1,
                            editType: "calc"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1,
                            arrayOk: !1,
                            editType: "calc"
                        },
                        blend: {
                            valType: "boolean",
                            dflt: null,
                            editType: "calc"
                        },
                        sizemin: {
                            valType: "number",
                            min: .1,
                            max: 2,
                            dflt: .5,
                            editType: "calc"
                        },
                        sizemax: {
                            valType: "number",
                            min: .1,
                            dflt: 20,
                            editType: "calc"
                        },
                        border: {
                            color: {
                                valType: "color",
                                arrayOk: !1,
                                editType: "calc"
                            },
                            arearatio: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 0,
                                editType: "calc"
                            },
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    transforms: void 0
                };
            },
            {
                "../scatter/attributes": 926
            }
        ],
        913: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../stackgl_modules").gl_pointcloud2d, i = t1("../../lib/str2rgbarray"), a = t1("../../plots/cartesian/autorange").findExtremes, o = t1("../scatter/get_trace_color");
                function s(t1, e1) {
                    this.scene = t1, this.uid = e1, this.type = "pointcloud", this.pickXData = [], this.pickYData = [], this.xData = [], this.yData = [], this.textLabels = [], this.color = "rgb(0, 0, 0)", this.name = "", this.hoverinfo = "all", this.idToIndex = new Int32Array(0), this.bounds = [
                        0,
                        0,
                        0,
                        0
                    ], this.pointcloudOptions = {
                        positions: new Float32Array(0),
                        idToIndex: this.idToIndex,
                        sizemin: .5,
                        sizemax: 12,
                        color: [
                            0,
                            0,
                            0,
                            1
                        ],
                        areaRatio: 1,
                        borderColor: [
                            0,
                            0,
                            0,
                            1
                        ]
                    }, this.pointcloud = n(t1.glplot, this.pointcloudOptions), this.pointcloud._trace = this;
                }
                var l = s.prototype;
                l.handlePick = function(t1) {
                    var e1 = this.idToIndex[t1.pointId];
                    return {
                        trace: this,
                        dataCoord: t1.dataCoord,
                        traceCoord: this.pickXYData ? [
                            this.pickXYData[2 * e1],
                            this.pickXYData[2 * e1 + 1]
                        ] : [
                            this.pickXData[e1],
                            this.pickYData[e1]
                        ],
                        textLabel: Array.isArray(this.textLabels) ? this.textLabels[e1] : this.textLabels,
                        color: this.color,
                        name: this.name,
                        pointIndex: e1,
                        hoverinfo: this.hoverinfo
                    };
                }, l.update = function(t1) {
                    this.index = t1.index, this.textLabels = t1.text, this.name = t1.name, this.hoverinfo = t1.hoverinfo, this.bounds = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], this.updateFast(t1), this.color = o(t1, {});
                }, l.updateFast = function(t1) {
                    var e1, r, n, o, s, l, c = this.xData = this.pickXData = t1.x, u = this.yData = this.pickYData = t1.y, f = this.pickXYData = t1.xy, h = t1.xbounds && t1.ybounds, p = t1.indices, d = this.bounds;
                    if (f) {
                        if (n = f, e1 = f.length >>> 1, h) d[0] = t1.xbounds[0], d[2] = t1.xbounds[1], d[1] = t1.ybounds[0], d[3] = t1.ybounds[1];
                        else for(l = 0; l < e1; l++)o = n[2 * l], s = n[2 * l + 1], o < d[0] && (d[0] = o), o > d[2] && (d[2] = o), s < d[1] && (d[1] = s), s > d[3] && (d[3] = s);
                        if (p) r = p;
                        else for(r = new Int32Array(e1), l = 0; l < e1; l++)r[l] = l;
                    } else for(e1 = c.length, n = new Float32Array(2 * e1), r = new Int32Array(e1), l = 0; l < e1; l++)o = c[l], s = u[l], r[l] = l, n[2 * l] = o, n[2 * l + 1] = s, o < d[0] && (d[0] = o), o > d[2] && (d[2] = o), s < d[1] && (d[1] = s), s > d[3] && (d[3] = s);
                    this.idToIndex = r, this.pointcloudOptions.idToIndex = r, this.pointcloudOptions.positions = n;
                    var m = i(t1.marker.color), g = i(t1.marker.border.color), v = t1.opacity * t1.marker.opacity;
                    m[3] *= v, this.pointcloudOptions.color = m;
                    var y = t1.marker.blend;
                    if (null === y) y = c.length < 100 || u.length < 100;
                    this.pointcloudOptions.blend = y, g[3] *= v, this.pointcloudOptions.borderColor = g;
                    var x = t1.marker.sizemin, b = Math.max(t1.marker.sizemax, t1.marker.sizemin);
                    this.pointcloudOptions.sizeMin = x, this.pointcloudOptions.sizeMax = b, this.pointcloudOptions.areaRatio = t1.marker.border.arearatio, this.pointcloud.update(this.pointcloudOptions);
                    var _ = this.scene.xaxis, w = this.scene.yaxis, T = b / 2 || .5;
                    t1._extremes[_._id] = a(_, [
                        d[0],
                        d[2]
                    ], {
                        ppad: T
                    }), t1._extremes[w._id] = a(w, [
                        d[1],
                        d[3]
                    ], {
                        ppad: T
                    });
                }, l.dispose = function() {
                    this.pointcloud.dispose();
                }, e1.exports = function(t1, e1) {
                    var r = new s(t1, e1.uid);
                    return r.update(e1), r;
                };
            },
            {
                "../../../stackgl_modules": 1120,
                "../../lib/str2rgbarray": 528,
                "../../plots/cartesian/autorange": 553,
                "../scatter/get_trace_color": 936
            }
        ],
        914: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./attributes");
                e1.exports = function(t1, e1, r) {
                    function a(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    a("x"), a("y"), a("xbounds"), a("ybounds"), t1.xy && t1.xy instanceof Float32Array && (e1.xy = t1.xy), t1.indices && t1.indices instanceof Int32Array && (e1.indices = t1.indices), a("text"), a("marker.color", r), a("marker.opacity"), a("marker.blend"), a("marker.sizemin"), a("marker.sizemax"), a("marker.border.color", r), a("marker.border.arearatio"), e1._length = null;
                };
            },
            {
                "../../lib": 503,
                "./attributes": 912
            }
        ],
        915: [
            function(t1, e1, r) {
                "use strict";
                [
                    "*pointcloud* trace is deprecated!",
                    "Please consider switching to the *scattergl* trace type."
                ].join(" ");
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    calc: t1("../scatter3d/calc"),
                    plot: t1("./convert"),
                    moduleType: "trace",
                    name: "pointcloud",
                    basePlotModule: t1("../../plots/gl2d"),
                    categories: [
                        "gl",
                        "gl2d",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/gl2d": 596,
                "../scatter3d/calc": 955,
                "./attributes": 912,
                "./convert": 913,
                "./defaults": 914
            }
        ],
        916: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/font_attributes"), i = t1("../../plots/attributes"), a = t1("../../components/color/attributes"), o = t1("../../components/fx/attributes"), s = t1("../../plots/domain").attributes, l = t1("../../plots/template_attributes").hovertemplateAttrs, c = t1("../../components/colorscale/attributes"), u = t1("../../plot_api/plot_template").templatedArray, f = t1("../../plots/cartesian/axis_format_attributes").descriptionOnlyNumbers, h = t1("../../lib/extend").extendFlat, p = t1("../../plot_api/edit_types").overrideAll;
                (e1.exports = p({
                    hoverinfo: h({}, i.hoverinfo, {
                        flags: [],
                        arrayOk: !1
                    }),
                    hoverlabel: o.hoverlabel,
                    domain: s({
                        name: "sankey",
                        trace: !0
                    }),
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        dflt: "h"
                    },
                    valueformat: {
                        valType: "string",
                        dflt: ".3s",
                        description: f("value")
                    },
                    valuesuffix: {
                        valType: "string",
                        dflt: ""
                    },
                    arrangement: {
                        valType: "enumerated",
                        values: [
                            "snap",
                            "perpendicular",
                            "freeform",
                            "fixed"
                        ],
                        dflt: "snap"
                    },
                    textfont: n({}),
                    customdata: void 0,
                    node: {
                        label: {
                            valType: "data_array",
                            dflt: []
                        },
                        groups: {
                            valType: "info_array",
                            impliedEdits: {
                                x: [],
                                y: []
                            },
                            dimensions: 2,
                            freeLength: !0,
                            dflt: [],
                            items: {
                                valType: "number",
                                editType: "calc"
                            }
                        },
                        x: {
                            valType: "data_array",
                            dflt: []
                        },
                        y: {
                            valType: "data_array",
                            dflt: []
                        },
                        color: {
                            valType: "color",
                            arrayOk: !0
                        },
                        customdata: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        line: {
                            color: {
                                valType: "color",
                                dflt: a.defaultLine,
                                arrayOk: !0
                            },
                            width: {
                                valType: "number",
                                min: 0,
                                dflt: .5,
                                arrayOk: !0
                            }
                        },
                        pad: {
                            valType: "number",
                            arrayOk: !1,
                            min: 0,
                            dflt: 20
                        },
                        thickness: {
                            valType: "number",
                            arrayOk: !1,
                            min: 1,
                            dflt: 20
                        },
                        hoverinfo: {
                            valType: "enumerated",
                            values: [
                                "all",
                                "none",
                                "skip"
                            ],
                            dflt: "all"
                        },
                        hoverlabel: o.hoverlabel,
                        hovertemplate: l({}, {
                            keys: [
                                "value",
                                "label"
                            ]
                        })
                    },
                    link: {
                        label: {
                            valType: "data_array",
                            dflt: []
                        },
                        color: {
                            valType: "color",
                            arrayOk: !0
                        },
                        customdata: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        line: {
                            color: {
                                valType: "color",
                                dflt: a.defaultLine,
                                arrayOk: !0
                            },
                            width: {
                                valType: "number",
                                min: 0,
                                dflt: 0,
                                arrayOk: !0
                            }
                        },
                        source: {
                            valType: "data_array",
                            dflt: []
                        },
                        target: {
                            valType: "data_array",
                            dflt: []
                        },
                        value: {
                            valType: "data_array",
                            dflt: []
                        },
                        hoverinfo: {
                            valType: "enumerated",
                            values: [
                                "all",
                                "none",
                                "skip"
                            ],
                            dflt: "all"
                        },
                        hoverlabel: o.hoverlabel,
                        hovertemplate: l({}, {
                            keys: [
                                "value",
                                "label"
                            ]
                        }),
                        colorscales: u("concentrationscales", {
                            editType: "calc",
                            label: {
                                valType: "string",
                                editType: "calc",
                                dflt: ""
                            },
                            cmax: {
                                valType: "number",
                                editType: "calc",
                                dflt: 1
                            },
                            cmin: {
                                valType: "number",
                                editType: "calc",
                                dflt: 0
                            },
                            colorscale: h(c().colorscale, {
                                dflt: [
                                    [
                                        0,
                                        "white"
                                    ],
                                    [
                                        1,
                                        "black"
                                    ]
                                ]
                            })
                        })
                    }
                }, "calc", "nested")).transforms = void 0;
            },
            {
                "../../components/color/attributes": 365,
                "../../components/colorscale/attributes": 373,
                "../../components/fx/attributes": 397,
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../../plot_api/plot_template": 543,
                "../../plots/attributes": 550,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/domain": 584,
                "../../plots/font_attributes": 585,
                "../../plots/template_attributes": 633
            }
        ],
        917: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plot_api/edit_types").overrideAll, i = t1("../../plots/get_data").getModuleCalcData, a = t1("./plot"), o = t1("../../components/fx/layout_attributes"), s = t1("../../lib/setcursor"), l = t1("../../components/dragelement"), c = t1("../../plots/cartesian/select").prepSelect, u = t1("../../lib"), f = t1("../../registry");
                function h(t1, e1) {
                    var r = t1._fullData[e1], n = t1._fullLayout, i = n.dragmode, a = "pan" === n.dragmode ? "move" : "crosshair", o = r._bgRect;
                    if ("pan" !== i && "zoom" !== i) {
                        s(o, a);
                        var h = {
                            _id: "x",
                            c2p: u.identity,
                            _offset: r._sankey.translateX,
                            _length: r._sankey.width
                        }, p = {
                            _id: "y",
                            c2p: u.identity,
                            _offset: r._sankey.translateY,
                            _length: r._sankey.height
                        }, d = {
                            gd: t1,
                            element: o.node(),
                            plotinfo: {
                                id: e1,
                                xaxis: h,
                                yaxis: p,
                                fillRangeItems: u.noop
                            },
                            subplot: e1,
                            xaxes: [
                                h
                            ],
                            yaxes: [
                                p
                            ],
                            doneFnCompleted: function(r) {
                                var n, i = t1._fullData[e1], a = i.node.groups.slice(), o = [];
                                function s(t1) {
                                    for(var e1 = i._sankey.graph.nodes, r = 0; r < e1.length; r++)if (e1[r].pointNumber === t1) return e1[r];
                                }
                                for(var l = 0; l < r.length; l++){
                                    var c = s(r[l].pointNumber);
                                    if (c) {
                                        if (c.group) {
                                            for(var u = 0; u < c.childrenNodes.length; u++)o.push(c.childrenNodes[u].pointNumber);
                                            a[c.pointNumber - i.node._count] = !1;
                                        } else o.push(c.pointNumber);
                                    }
                                }
                                n = a.filter(Boolean).concat([
                                    o
                                ]), f.call("_guiRestyle", t1, {
                                    "node.groups": [
                                        n
                                    ]
                                }, e1);
                            },
                            prepFn: function(t1, e1, r) {
                                c(t1, e1, r, d, i);
                            }
                        };
                        l.init(d);
                    }
                }
                r.name = "sankey", r.baseLayoutAttrOverrides = n({
                    hoverlabel: o.hoverlabel
                }, "plot", "nested"), r.plot = function(t1) {
                    var e1 = i(t1.calcdata, "sankey")[0];
                    a(t1, e1), r.updateFx(t1);
                }, r.clean = function(t1, e1, r, n) {
                    var i = n._has && n._has("sankey"), a = e1._has && e1._has("sankey");
                    i && !a && (n._paperdiv.selectAll(".sankey").remove(), n._paperdiv.selectAll(".bgsankey").remove());
                }, r.updateFx = function(t1) {
                    for(var e1 = 0; e1 < t1._fullData.length; e1++)h(t1, e1);
                };
            },
            {
                "../../components/dragelement": 385,
                "../../components/fx/layout_attributes": 407,
                "../../lib": 503,
                "../../lib/setcursor": 524,
                "../../plot_api/edit_types": 536,
                "../../plots/cartesian/select": 575,
                "../../plots/get_data": 593,
                "../../registry": 638,
                "./plot": 922
            }
        ],
        918: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("strongly-connected-components"), i = t1("../../lib"), a = t1("../../lib/gup").wrap, o = i.isArrayOrTypedArray, s = i.isIndex, l = t1("../../components/colorscale");
                function c(t1) {
                    var e1, r = t1.node, a = t1.link, c = [], u = o(a.color), f = o(a.customdata), h = {}, p = {}, d = a.colorscales.length;
                    for(e1 = 0; e1 < d; e1++){
                        var m = a.colorscales[e1], g = l.extractScale(m, {
                            cLetter: "c"
                        }), v = l.makeColorScaleFunc(g);
                        p[m.label] = v;
                    }
                    var y = 0;
                    for(e1 = 0; e1 < a.value.length; e1++)a.source[e1] > y && (y = a.source[e1]), a.target[e1] > y && (y = a.target[e1]);
                    var x, b = y + 1;
                    t1.node._count = b;
                    var _ = t1.node.groups, w = {};
                    for(e1 = 0; e1 < _.length; e1++){
                        var T = _[e1];
                        for(x = 0; x < T.length; x++){
                            var k = T[x], A = b + e1;
                            w.hasOwnProperty(k) ? i.warn("Node " + k + " is already part of a group.") : w[k] = A;
                        }
                    }
                    var M = {
                        source: [],
                        target: []
                    };
                    for(e1 = 0; e1 < a.value.length; e1++){
                        var S = a.value[e1], E = a.source[e1], L = a.target[e1];
                        if (S > 0 && s(E, b) && s(L, b) && (!w.hasOwnProperty(E) || !w.hasOwnProperty(L) || w[E] !== w[L])) {
                            w.hasOwnProperty(L) && (L = w[L]), w.hasOwnProperty(E) && (E = w[E]), L = +L, h[E = +E] = h[L] = !0;
                            var C = "";
                            a.label && a.label[e1] && (C = a.label[e1]);
                            var P = null;
                            C && p.hasOwnProperty(C) && (P = p[C]), c.push({
                                pointNumber: e1,
                                label: C,
                                color: u ? a.color[e1] : a.color,
                                customdata: f ? a.customdata[e1] : a.customdata,
                                concentrationscale: P,
                                source: E,
                                target: L,
                                value: +S
                            }), M.source.push(E), M.target.push(L);
                        }
                    }
                    var I = b + _.length, O = o(r.color), z = o(r.customdata), D = [];
                    for(e1 = 0; e1 < I; e1++)if (h[e1]) {
                        var R = r.label[e1];
                        D.push({
                            group: e1 > b - 1,
                            childrenNodes: [],
                            pointNumber: e1,
                            label: R,
                            color: O ? r.color[e1] : r.color,
                            customdata: z ? r.customdata[e1] : r.customdata
                        });
                    }
                    var F = !1;
                    return function(t1, e1, r) {
                        for(var a = i.init2dArray(t1, 0), o = 0; o < Math.min(e1.length, r.length); o++)if (i.isIndex(e1[o], t1) && i.isIndex(r[o], t1)) {
                            if (e1[o] === r[o]) return !0;
                            a[e1[o]].push(r[o]);
                        }
                        return n(a).components.some(function(t1) {
                            return t1.length > 1;
                        });
                    }(I, M.source, M.target) && (F = !0), {
                        circular: F,
                        links: c,
                        nodes: D,
                        groups: _,
                        groupLookup: w
                    };
                }
                e1.exports = function(t1, e1) {
                    var r = c(e1);
                    return a({
                        circular: r.circular,
                        _nodes: r.nodes,
                        _links: r.links,
                        _groups: r.groups,
                        _groupLookup: r.groupLookup
                    });
                };
            },
            {
                "../../components/colorscale": 378,
                "../../lib": 503,
                "../../lib/gup": 500,
                "strongly-connected-components": 306
            }
        ],
        919: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    nodeTextOffsetHorizontal: 4,
                    nodeTextOffsetVertical: 3,
                    nodePadAcross: 10,
                    sankeyIterations: 50,
                    forceIterations: 5,
                    forceTicksPerFrame: 10,
                    duration: 500,
                    ease: "linear",
                    cn: {
                        sankey: "sankey",
                        sankeyLinks: "sankey-links",
                        sankeyLink: "sankey-link",
                        sankeyNodeSet: "sankey-node-set",
                        sankeyNode: "sankey-node",
                        nodeRect: "node-rect",
                        nodeLabel: "node-label"
                    }
                };
            },
            {}
        ],
        920: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./attributes"), a = t1("../../components/color"), o = t1("tinycolor2"), s = t1("../../plots/domain").defaults, l = t1("../../components/fx/hoverlabel_defaults"), c = t1("../../plot_api/plot_template"), u = t1("../../plots/array_container_defaults");
                function f(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i.link.colorscales, r, a);
                    }
                    r("label"), r("cmin"), r("cmax"), r("colorscale");
                }
                e1.exports = function(t1, e1, r, h) {
                    function p(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    var d = n.extendDeep(h.hoverlabel, t1.hoverlabel), m = t1.node, g = c.newContainer(e1, "node");
                    function v(t1, e1) {
                        return n.coerce(m, g, i.node, t1, e1);
                    }
                    v("label"), v("groups"), v("x"), v("y"), v("pad"), v("thickness"), v("line.color"), v("line.width"), v("hoverinfo", t1.hoverinfo), l(m, g, v, d), v("hovertemplate");
                    var y = h.colorway;
                    v("color", g.label.map(function(t1, e1) {
                        return a.addOpacity(function(t1) {
                            return y[t1 % y.length];
                        }(e1), .8);
                    })), v("customdata");
                    var x = t1.link || {}, b = c.newContainer(e1, "link");
                    function _(t1, e1) {
                        return n.coerce(x, b, i.link, t1, e1);
                    }
                    _("label"), _("source"), _("target"), _("value"), _("line.color"), _("line.width"), _("hoverinfo", t1.hoverinfo), l(x, b, _, d), _("hovertemplate");
                    var w, T = o(h.paper_bgcolor).getLuminance() < .333 ? "rgba(255, 255, 255, 0.6)" : "rgba(0, 0, 0, 0.2)";
                    _("color", n.repeat(T, b.value.length)), _("customdata"), u(x, b, {
                        name: "colorscales",
                        handleItemDefaults: f
                    }), s(e1, h, p), p("orientation"), p("valueformat"), p("valuesuffix"), g.x.length && g.y.length && (w = "freeform"), p("arrangement", w), n.coerceFont(p, "textfont", n.extendFlat({}, h.font)), e1._length = null;
                };
            },
            {
                "../../components/color": 366,
                "../../components/fx/hoverlabel_defaults": 404,
                "../../lib": 503,
                "../../plot_api/plot_template": 543,
                "../../plots/array_container_defaults": 549,
                "../../plots/domain": 584,
                "./attributes": 916,
                tinycolor2: 312
            }
        ],
        921: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    moduleType: "trace",
                    name: "sankey",
                    basePlotModule: t1("./base_plot"),
                    selectPoints: t1("./select.js"),
                    categories: [
                        "noOpacity"
                    ],
                    meta: {}
                };
            },
            {
                "./attributes": 916,
                "./base_plot": 917,
                "./calc": 918,
                "./defaults": 920,
                "./plot": 922,
                "./select.js": 924
            }
        ],
        922: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = i.numberFormat, o = t1("./render"), s = t1("../../components/fx"), l = t1("../../components/color"), c = t1("./constants").cn, u = i._;
                function f(t1) {
                    return "" !== t1;
                }
                function h(t1, e1) {
                    return t1.filter(function(t1) {
                        return t1.key === e1.traceId;
                    });
                }
                function p(t1, e1) {
                    n.select(t1).select("path").style("fill-opacity", e1), n.select(t1).select("rect").style("fill-opacity", e1);
                }
                function d(t1) {
                    n.select(t1).select("text.name").style("fill", "black");
                }
                function m(t1) {
                    return function(e1) {
                        return -1 !== t1.node.sourceLinks.indexOf(e1.link) || -1 !== t1.node.targetLinks.indexOf(e1.link);
                    };
                }
                function g(t1) {
                    return function(e1) {
                        return -1 !== e1.node.sourceLinks.indexOf(t1.link) || -1 !== e1.node.targetLinks.indexOf(t1.link);
                    };
                }
                function v(t1, e1, r) {
                    e1 && r && h(r, e1).selectAll("." + c.sankeyLink).filter(m(e1)).call(x.bind(0, e1, r, !1));
                }
                function y(t1, e1, r) {
                    e1 && r && h(r, e1).selectAll("." + c.sankeyLink).filter(m(e1)).call(b.bind(0, e1, r, !1));
                }
                function x(t1, e1, r, n) {
                    var i = n.datum().link.label;
                    n.style("fill-opacity", function(t1) {
                        if (!t1.link.concentrationscale) return .4;
                    }), i && h(e1, t1).selectAll("." + c.sankeyLink).filter(function(t1) {
                        return t1.link.label === i;
                    }).style("fill-opacity", function(t1) {
                        if (!t1.link.concentrationscale) return .4;
                    }), r && h(e1, t1).selectAll("." + c.sankeyNode).filter(g(t1)).call(v);
                }
                function b(t1, e1, r, n) {
                    var i = n.datum().link.label;
                    n.style("fill-opacity", function(t1) {
                        return t1.tinyColorAlpha;
                    }), i && h(e1, t1).selectAll("." + c.sankeyLink).filter(function(t1) {
                        return t1.link.label === i;
                    }).style("fill-opacity", function(t1) {
                        return t1.tinyColorAlpha;
                    }), r && h(e1, t1).selectAll(c.sankeyNode).filter(g(t1)).call(y);
                }
                function _(t1, e1) {
                    var r = t1.hoverlabel || {}, n = i.nestedProperty(r, e1).get();
                    return !Array.isArray(n) && n;
                }
                e1.exports = function(t1, e1) {
                    for(var r = t1._fullLayout, i = r._paper, h = r._size, m = 0; m < t1._fullData.length; m++)if (t1._fullData[m].visible && t1._fullData[m].type === c.sankey && !t1._fullData[m]._viewInitial) {
                        var g = t1._fullData[m].node;
                        t1._fullData[m]._viewInitial = {
                            node: {
                                groups: g.groups.slice(),
                                x: g.x.slice(),
                                y: g.y.slice()
                            }
                        };
                    }
                    var w = u(t1, "source:") + " ", T = u(t1, "target:") + " ", k = u(t1, "concentration:") + " ", A = u(t1, "incoming flow count:") + " ", M = u(t1, "outgoing flow count:") + " ";
                    o(t1, i, e1, {
                        width: h.w,
                        height: h.h,
                        margin: {
                            t: h.t,
                            r: h.r,
                            b: h.b,
                            l: h.l
                        }
                    }, {
                        linkEvents: {
                            hover: function(e1, r, i) {
                                !1 !== t1._fullLayout.hovermode && (n.select(e1).call(x.bind(0, r, i, !0)), "skip" !== r.link.trace.link.hoverinfo && (r.link.fullData = r.link.trace, t1.emit("plotly_hover", {
                                    event: n.event,
                                    points: [
                                        r.link
                                    ]
                                })));
                            },
                            follow: function(e1, i) {
                                if (!1 !== t1._fullLayout.hovermode) {
                                    var o = i.link.trace.link;
                                    if ("none" !== o.hoverinfo && "skip" !== o.hoverinfo) {
                                        for(var c = [], u = 0, h = 0; h < i.flow.links.length; h++){
                                            var m = i.flow.links[h];
                                            if ("closest" !== t1._fullLayout.hovermode || i.link.pointNumber === m.pointNumber) {
                                                i.link.pointNumber === m.pointNumber && (u = h), m.fullData = m.trace, o = i.link.trace.link;
                                                var g = y(m), v = {
                                                    valueLabel: a(i.valueFormat)(m.value) + i.valueSuffix
                                                };
                                                c.push({
                                                    x: g[0],
                                                    y: g[1],
                                                    name: v.valueLabel,
                                                    text: [
                                                        m.label || "",
                                                        w + m.source.label,
                                                        T + m.target.label,
                                                        m.concentrationscale ? k + a("%0.2f")(m.flow.labelConcentration) : ""
                                                    ].filter(f).join("<br>"),
                                                    color: _(o, "bgcolor") || l.addOpacity(m.color, 1),
                                                    borderColor: _(o, "bordercolor"),
                                                    fontFamily: _(o, "font.family"),
                                                    fontSize: _(o, "font.size"),
                                                    fontColor: _(o, "font.color"),
                                                    nameLength: _(o, "namelength"),
                                                    textAlign: _(o, "align"),
                                                    idealAlign: n.event.x < g[0] ? "right" : "left",
                                                    hovertemplate: o.hovertemplate,
                                                    hovertemplateLabels: v,
                                                    eventData: [
                                                        m
                                                    ]
                                                });
                                            }
                                        }
                                        s.loneHover(c, {
                                            container: r._hoverlayer.node(),
                                            outerContainer: r._paper.node(),
                                            gd: t1,
                                            anchorIndex: u
                                        }).each(function() {
                                            i.link.concentrationscale || p(this, .65), d(this);
                                        });
                                    }
                                }
                                function y(t1) {
                                    var e1, r;
                                    t1.circular ? (e1 = (t1.circularPathData.leftInnerExtent + t1.circularPathData.rightInnerExtent) / 2, r = t1.circularPathData.verticalFullExtent) : (e1 = (t1.source.x1 + t1.target.x0) / 2, r = (t1.y0 + t1.y1) / 2);
                                    var n = [
                                        e1,
                                        r
                                    ];
                                    return "v" === t1.trace.orientation && n.reverse(), n[0] += i.parent.translateX, n[1] += i.parent.translateY, n;
                                }
                            },
                            unhover: function(e1, i, a) {
                                !1 !== t1._fullLayout.hovermode && (n.select(e1).call(b.bind(0, i, a, !0)), "skip" !== i.link.trace.link.hoverinfo && (i.link.fullData = i.link.trace, t1.emit("plotly_unhover", {
                                    event: n.event,
                                    points: [
                                        i.link
                                    ]
                                })), s.loneUnhover(r._hoverlayer.node()));
                            },
                            select: function(e1, r) {
                                var i = r.link;
                                i.originalEvent = n.event, t1._hoverdata = [
                                    i
                                ], s.click(t1, {
                                    target: !0
                                });
                            }
                        },
                        nodeEvents: {
                            hover: function(e1, r, i) {
                                !1 !== t1._fullLayout.hovermode && (n.select(e1).call(v, r, i), "skip" !== r.node.trace.node.hoverinfo && (r.node.fullData = r.node.trace, t1.emit("plotly_hover", {
                                    event: n.event,
                                    points: [
                                        r.node
                                    ]
                                })));
                            },
                            follow: function(e1, i) {
                                if (!1 !== t1._fullLayout.hovermode) {
                                    var o = i.node.trace.node;
                                    if ("none" !== o.hoverinfo && "skip" !== o.hoverinfo) {
                                        var l = n.select(e1).select("." + c.nodeRect), u = t1._fullLayout._paperdiv.node().getBoundingClientRect(), h = l.node().getBoundingClientRect(), m = h.left - 2 - u.left, g = h.right + 2 - u.left, v = h.top + h.height / 4 - u.top, y = {
                                            valueLabel: a(i.valueFormat)(i.node.value) + i.valueSuffix
                                        };
                                        i.node.fullData = i.node.trace, t1._fullLayout._calcInverseTransform(t1);
                                        var x = t1._fullLayout._invScaleX, b = t1._fullLayout._invScaleY, w = s.loneHover({
                                            x0: x * m,
                                            x1: x * g,
                                            y: b * v,
                                            name: a(i.valueFormat)(i.node.value) + i.valueSuffix,
                                            text: [
                                                i.node.label,
                                                A + i.node.targetLinks.length,
                                                M + i.node.sourceLinks.length
                                            ].filter(f).join("<br>"),
                                            color: _(o, "bgcolor") || i.tinyColorHue,
                                            borderColor: _(o, "bordercolor"),
                                            fontFamily: _(o, "font.family"),
                                            fontSize: _(o, "font.size"),
                                            fontColor: _(o, "font.color"),
                                            nameLength: _(o, "namelength"),
                                            textAlign: _(o, "align"),
                                            idealAlign: "left",
                                            hovertemplate: o.hovertemplate,
                                            hovertemplateLabels: y,
                                            eventData: [
                                                i.node
                                            ]
                                        }, {
                                            container: r._hoverlayer.node(),
                                            outerContainer: r._paper.node(),
                                            gd: t1
                                        });
                                        p(w, .85), d(w);
                                    }
                                }
                            },
                            unhover: function(e1, i, a) {
                                !1 !== t1._fullLayout.hovermode && (n.select(e1).call(y, i, a), "skip" !== i.node.trace.node.hoverinfo && (i.node.fullData = i.node.trace, t1.emit("plotly_unhover", {
                                    event: n.event,
                                    points: [
                                        i.node
                                    ]
                                })), s.loneUnhover(r._hoverlayer.node()));
                            },
                            select: function(e1, r, i) {
                                var a = r.node;
                                a.originalEvent = n.event, t1._hoverdata = [
                                    a
                                ], n.select(e1).call(y, r, i), s.click(t1, {
                                    target: !0
                                });
                            }
                        }
                    });
                };
            },
            {
                "../../components/color": 366,
                "../../components/fx": 406,
                "../../lib": 503,
                "./constants": 919,
                "./render": 923,
                "@plotly/d3": 58
            }
        ],
        923: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("d3-force"), i = t1("d3-interpolate").interpolateNumber, a = t1("@plotly/d3"), o = t1("@plotly/d3-sankey"), s = t1("@plotly/d3-sankey-circular"), l = t1("./constants"), c = t1("tinycolor2"), u = t1("../../components/color"), f = t1("../../components/drawing"), h = t1("../../lib"), p = h.strTranslate, d = h.strRotate, m = t1("../../lib/gup"), g = m.keyFun, v = m.repeat, y = m.unwrap, x = t1("../../lib/svg_text_utils"), b = t1("../../registry"), _ = t1("../../constants/alignment"), w = _.CAP_SHIFT, T = _.LINE_SPACING;
                function k(t1, e1, r) {
                    var n, i = y(e1), a = i.trace, u = a.domain, f = "h" === a.orientation, p = a.node.pad, d = a.node.thickness, m = t1.width * (u.x[1] - u.x[0]), g = t1.height * (u.y[1] - u.y[0]), v = i._nodes, x = i._links, b = i.circular;
                    (n = b ? s.sankeyCircular().circularLinkGap(0) : o.sankey()).iterations(l.sankeyIterations).size(f ? [
                        m,
                        g
                    ] : [
                        g,
                        m
                    ]).nodeWidth(d).nodePadding(p).nodeId(function(t1) {
                        return t1.pointNumber;
                    }).nodes(v).links(x);
                    var _, w, T, k = n();
                    for(var A in n.nodePadding() < p && h.warn("node.pad was reduced to ", n.nodePadding(), " to fit within the figure."), i._groupLookup){
                        var M, S = parseInt(i._groupLookup[A]);
                        for(_ = 0; _ < k.nodes.length; _++)if (k.nodes[_].pointNumber === S) {
                            M = k.nodes[_];
                            break;
                        }
                        if (M) {
                            var E = {
                                pointNumber: parseInt(A),
                                x0: M.x0,
                                x1: M.x1,
                                y0: M.y0,
                                y1: M.y1,
                                partOfGroup: !0,
                                sourceLinks: [],
                                targetLinks: []
                            };
                            k.nodes.unshift(E), M.childrenNodes.unshift(E);
                        }
                    }
                    if (function() {
                        for(_ = 0; _ < k.nodes.length; _++){
                            var t1, e1, r = k.nodes[_], n = {};
                            for(w = 0; w < r.targetLinks.length; w++)t1 = (e1 = r.targetLinks[w]).source.pointNumber + ":" + e1.target.pointNumber, n.hasOwnProperty(t1) || (n[t1] = []), n[t1].push(e1);
                            var i = Object.keys(n);
                            for(w = 0; w < i.length; w++){
                                var a = n[t1 = i[w]], o = 0, s = {};
                                for(T = 0; T < a.length; T++)s[(e1 = a[T]).label] || (s[e1.label] = 0), s[e1.label] += e1.value, o += e1.value;
                                for(T = 0; T < a.length; T++)(e1 = a[T]).flow = {
                                    value: o,
                                    labelConcentration: s[e1.label] / o,
                                    concentration: e1.value / o,
                                    links: a
                                }, e1.concentrationscale && (e1.color = c(e1.concentrationscale(e1.flow.labelConcentration)));
                            }
                            var l = 0;
                            for(w = 0; w < r.sourceLinks.length; w++)l += r.sourceLinks[w].value;
                            for(w = 0; w < r.sourceLinks.length; w++)(e1 = r.sourceLinks[w]).concentrationOut = e1.value / l;
                            var u = 0;
                            for(w = 0; w < r.targetLinks.length; w++)u += r.targetLinks[w].value;
                            for(w = 0; w < r.targetLinks.length; w++)(e1 = r.targetLinks[w]).concenrationIn = e1.value / u;
                        }
                    }(), a.node.x.length && a.node.y.length) {
                        for(_ = 0; _ < Math.min(a.node.x.length, a.node.y.length, k.nodes.length); _++)if (a.node.x[_] && a.node.y[_]) {
                            var L = [
                                a.node.x[_] * m,
                                a.node.y[_] * g
                            ];
                            k.nodes[_].x0 = L[0] - d / 2, k.nodes[_].x1 = L[0] + d / 2;
                            var C = k.nodes[_].y1 - k.nodes[_].y0;
                            k.nodes[_].y0 = L[1] - C / 2, k.nodes[_].y1 = L[1] + C / 2;
                        }
                        if ("snap" === a.arrangement) !function(t1) {
                            t1.forEach(function(t1) {
                                var e1, r, n, i = 0, a = t1.length;
                                for(t1.sort(function(t1, e1) {
                                    return t1.y0 - e1.y0;
                                }), n = 0; n < a; ++n)(e1 = t1[n]).y0 >= i || (r = i - e1.y0) > 1e-6 && (e1.y0 += r, e1.y1 += r), i = e1.y1 + p;
                            });
                        }(function(t1) {
                            var e1, r, n = t1.map(function(t1, e1) {
                                return {
                                    x0: t1.x0,
                                    index: e1
                                };
                            }).sort(function(t1, e1) {
                                return t1.x0 - e1.x0;
                            }), i = [], a = -1, o = -1 / 0;
                            for(_ = 0; _ < n.length; _++){
                                var s = t1[n[_].index];
                                s.x0 > o + d && (a += 1, e1 = s.x0), o = s.x0, i[a] || (i[a] = []), i[a].push(s), r = e1 - s.x0, s.x0 += r, s.x1 += r;
                            }
                            return i;
                        }(v = k.nodes));
                        n.update(k);
                    }
                    return {
                        circular: b,
                        key: r,
                        trace: a,
                        guid: h.randstr(),
                        horizontal: f,
                        width: m,
                        height: g,
                        nodePad: a.node.pad,
                        nodeLineColor: a.node.line.color,
                        nodeLineWidth: a.node.line.width,
                        linkLineColor: a.link.line.color,
                        linkLineWidth: a.link.line.width,
                        valueFormat: a.valueformat,
                        valueSuffix: a.valuesuffix,
                        textFont: a.textfont,
                        translateX: u.x[0] * t1.width + t1.margin.l,
                        translateY: t1.height - u.y[1] * t1.height + t1.margin.t,
                        dragParallel: f ? g : m,
                        dragPerpendicular: f ? m : g,
                        arrangement: a.arrangement,
                        sankey: n,
                        graph: k,
                        forceLayouts: {},
                        interactionState: {
                            dragInProgress: !1,
                            hovered: !1
                        }
                    };
                }
                function A(t1, e1, r) {
                    var n = c(e1.color), i = e1.source.label + "|" + e1.target.label + "__" + r;
                    return e1.trace = t1.trace, e1.curveNumber = t1.trace.index, {
                        circular: t1.circular,
                        key: i,
                        traceId: t1.key,
                        pointNumber: e1.pointNumber,
                        link: e1,
                        tinyColorHue: u.tinyRGB(n),
                        tinyColorAlpha: n.getAlpha(),
                        linkPath: M,
                        linkLineColor: t1.linkLineColor,
                        linkLineWidth: t1.linkLineWidth,
                        valueFormat: t1.valueFormat,
                        valueSuffix: t1.valueSuffix,
                        sankey: t1.sankey,
                        parent: t1,
                        interactionState: t1.interactionState,
                        flow: e1.flow
                    };
                }
                function M() {
                    return function(t1) {
                        if (t1.link.circular) return e1 = t1.link, r = e1.width / 2, n = e1.circularPathData, "top" === e1.circularLinkType ? "M " + n.targetX + " " + (n.targetY + r) + " L" + n.rightInnerExtent + " " + (n.targetY + r) + "A" + (n.rightLargeArcRadius + r) + " " + (n.rightSmallArcRadius + r) + " 0 0 1 " + (n.rightFullExtent - r) + " " + (n.targetY - n.rightSmallArcRadius) + "L" + (n.rightFullExtent - r) + " " + n.verticalRightInnerExtent + "A" + (n.rightLargeArcRadius + r) + " " + (n.rightLargeArcRadius + r) + " 0 0 1 " + n.rightInnerExtent + " " + (n.verticalFullExtent - r) + "L" + n.leftInnerExtent + " " + (n.verticalFullExtent - r) + "A" + (n.leftLargeArcRadius + r) + " " + (n.leftLargeArcRadius + r) + " 0 0 1 " + (n.leftFullExtent + r) + " " + n.verticalLeftInnerExtent + "L" + (n.leftFullExtent + r) + " " + (n.sourceY - n.leftSmallArcRadius) + "A" + (n.leftLargeArcRadius + r) + " " + (n.leftSmallArcRadius + r) + " 0 0 1 " + n.leftInnerExtent + " " + (n.sourceY + r) + "L" + n.sourceX + " " + (n.sourceY + r) + "L" + n.sourceX + " " + (n.sourceY - r) + "L" + n.leftInnerExtent + " " + (n.sourceY - r) + "A" + (n.leftLargeArcRadius - r) + " " + (n.leftSmallArcRadius - r) + " 0 0 0 " + (n.leftFullExtent - r) + " " + (n.sourceY - n.leftSmallArcRadius) + "L" + (n.leftFullExtent - r) + " " + n.verticalLeftInnerExtent + "A" + (n.leftLargeArcRadius - r) + " " + (n.leftLargeArcRadius - r) + " 0 0 0 " + n.leftInnerExtent + " " + (n.verticalFullExtent + r) + "L" + n.rightInnerExtent + " " + (n.verticalFullExtent + r) + "A" + (n.rightLargeArcRadius - r) + " " + (n.rightLargeArcRadius - r) + " 0 0 0 " + (n.rightFullExtent + r) + " " + n.verticalRightInnerExtent + "L" + (n.rightFullExtent + r) + " " + (n.targetY - n.rightSmallArcRadius) + "A" + (n.rightLargeArcRadius - r) + " " + (n.rightSmallArcRadius - r) + " 0 0 0 " + n.rightInnerExtent + " " + (n.targetY - r) + "L" + n.targetX + " " + (n.targetY - r) + "Z" : "M " + n.targetX + " " + (n.targetY - r) + " L" + n.rightInnerExtent + " " + (n.targetY - r) + "A" + (n.rightLargeArcRadius + r) + " " + (n.rightSmallArcRadius + r) + " 0 0 0 " + (n.rightFullExtent - r) + " " + (n.targetY + n.rightSmallArcRadius) + "L" + (n.rightFullExtent - r) + " " + n.verticalRightInnerExtent + "A" + (n.rightLargeArcRadius + r) + " " + (n.rightLargeArcRadius + r) + " 0 0 0 " + n.rightInnerExtent + " " + (n.verticalFullExtent + r) + "L" + n.leftInnerExtent + " " + (n.verticalFullExtent + r) + "A" + (n.leftLargeArcRadius + r) + " " + (n.leftLargeArcRadius + r) + " 0 0 0 " + (n.leftFullExtent + r) + " " + n.verticalLeftInnerExtent + "L" + (n.leftFullExtent + r) + " " + (n.sourceY + n.leftSmallArcRadius) + "A" + (n.leftLargeArcRadius + r) + " " + (n.leftSmallArcRadius + r) + " 0 0 0 " + n.leftInnerExtent + " " + (n.sourceY - r) + "L" + n.sourceX + " " + (n.sourceY - r) + "L" + n.sourceX + " " + (n.sourceY + r) + "L" + n.leftInnerExtent + " " + (n.sourceY + r) + "A" + (n.leftLargeArcRadius - r) + " " + (n.leftSmallArcRadius - r) + " 0 0 1 " + (n.leftFullExtent - r) + " " + (n.sourceY + n.leftSmallArcRadius) + "L" + (n.leftFullExtent - r) + " " + n.verticalLeftInnerExtent + "A" + (n.leftLargeArcRadius - r) + " " + (n.leftLargeArcRadius - r) + " 0 0 1 " + n.leftInnerExtent + " " + (n.verticalFullExtent - r) + "L" + n.rightInnerExtent + " " + (n.verticalFullExtent - r) + "A" + (n.rightLargeArcRadius - r) + " " + (n.rightLargeArcRadius - r) + " 0 0 1 " + (n.rightFullExtent + r) + " " + n.verticalRightInnerExtent + "L" + (n.rightFullExtent + r) + " " + (n.targetY + n.rightSmallArcRadius) + "A" + (n.rightLargeArcRadius - r) + " " + (n.rightSmallArcRadius - r) + " 0 0 1 " + n.rightInnerExtent + " " + (n.targetY + r) + "L" + n.targetX + " " + (n.targetY + r) + "Z";
                        var e1, r, n, a = t1.link.source.x1, o = t1.link.target.x0, s = i(a, o), l = s(.5), c = s(.5), u = t1.link.y0 - t1.link.width / 2, f = t1.link.y0 + t1.link.width / 2, h = t1.link.y1 - t1.link.width / 2, p = t1.link.y1 + t1.link.width / 2;
                        return "M" + a + "," + u + "C" + l + "," + u + " " + c + "," + h + " " + o + "," + h + "L" + o + "," + p + "C" + c + "," + p + " " + l + "," + f + " " + a + "," + f + "Z";
                    };
                }
                function S(t1, e1) {
                    var r = c(e1.color), n = l.nodePadAcross, i = t1.nodePad / 2;
                    e1.dx = e1.x1 - e1.x0, e1.dy = e1.y1 - e1.y0;
                    var a = e1.dx, o = Math.max(.5, e1.dy), s = "node_" + e1.pointNumber;
                    return e1.group && (s = h.randstr()), e1.trace = t1.trace, e1.curveNumber = t1.trace.index, {
                        index: e1.pointNumber,
                        key: s,
                        partOfGroup: e1.partOfGroup || !1,
                        group: e1.group,
                        traceId: t1.key,
                        trace: t1.trace,
                        node: e1,
                        nodePad: t1.nodePad,
                        nodeLineColor: t1.nodeLineColor,
                        nodeLineWidth: t1.nodeLineWidth,
                        textFont: t1.textFont,
                        size: t1.horizontal ? t1.height : t1.width,
                        visibleWidth: Math.ceil(a),
                        visibleHeight: o,
                        zoneX: -n,
                        zoneY: -i,
                        zoneWidth: a + 2 * n,
                        zoneHeight: o + 2 * i,
                        labelY: t1.horizontal ? e1.dy / 2 + 1 : e1.dx / 2 + 1,
                        left: 1 === e1.originalLayer,
                        sizeAcross: t1.width,
                        forceLayouts: t1.forceLayouts,
                        horizontal: t1.horizontal,
                        darkBackground: r.getBrightness() <= 128,
                        tinyColorHue: u.tinyRGB(r),
                        tinyColorAlpha: r.getAlpha(),
                        valueFormat: t1.valueFormat,
                        valueSuffix: t1.valueSuffix,
                        sankey: t1.sankey,
                        graph: t1.graph,
                        arrangement: t1.arrangement,
                        uniqueNodeLabelPathId: [
                            t1.guid,
                            t1.key,
                            s
                        ].join("_"),
                        interactionState: t1.interactionState,
                        figure: t1
                    };
                }
                function E(t1) {
                    t1.attr("transform", function(t1) {
                        return p(t1.node.x0.toFixed(3), t1.node.y0.toFixed(3));
                    });
                }
                function L(t1) {
                    t1.call(E);
                }
                function C(t1, e1) {
                    t1.call(L), e1.attr("d", M());
                }
                function P(t1) {
                    t1.attr("width", function(t1) {
                        return t1.node.x1 - t1.node.x0;
                    }).attr("height", function(t1) {
                        return t1.visibleHeight;
                    });
                }
                function I(t1) {
                    return t1.link.width > 1 || t1.linkLineWidth > 0;
                }
                function O(t1) {
                    return p(t1.translateX, t1.translateY) + (t1.horizontal ? "matrix(1 0 0 1 0 0)" : "matrix(0 1 1 0 0 0)");
                }
                function z(t1, e1, r) {
                    t1.on(".basic", null).on("mouseover.basic", function(t1) {
                        t1.interactionState.dragInProgress || t1.partOfGroup || (r.hover(this, t1, e1), t1.interactionState.hovered = [
                            this,
                            t1
                        ]);
                    }).on("mousemove.basic", function(t1) {
                        t1.interactionState.dragInProgress || t1.partOfGroup || (r.follow(this, t1), t1.interactionState.hovered = [
                            this,
                            t1
                        ]);
                    }).on("mouseout.basic", function(t1) {
                        t1.interactionState.dragInProgress || t1.partOfGroup || (r.unhover(this, t1, e1), t1.interactionState.hovered = !1);
                    }).on("click.basic", function(t1) {
                        t1.interactionState.hovered && (r.unhover(this, t1, e1), t1.interactionState.hovered = !1), t1.interactionState.dragInProgress || t1.partOfGroup || r.select(this, t1, e1);
                    });
                }
                function D(t1, e1, r, i) {
                    var o = a.behavior.drag().origin(function(t1) {
                        return {
                            x: t1.node.x0 + t1.visibleWidth / 2,
                            y: t1.node.y0 + t1.visibleHeight / 2
                        };
                    }).on("dragstart", function(a) {
                        if ("fixed" !== a.arrangement && (h.ensureSingle(i._fullLayout._infolayer, "g", "dragcover", function(t1) {
                            i._fullLayout._dragCover = t1;
                        }), h.raiseToTop(this), a.interactionState.dragInProgress = a.node, F(a.node), a.interactionState.hovered && (r.nodeEvents.unhover.apply(0, a.interactionState.hovered), a.interactionState.hovered = !1), "snap" === a.arrangement)) {
                            var o = a.traceId + "|" + a.key;
                            a.forceLayouts[o] ? a.forceLayouts[o].alpha(1) : function(t1, e1, r, i) {
                                !function(t1) {
                                    for(var e1 = 0; e1 < t1.length; e1++)t1[e1].y = (t1[e1].y0 + t1[e1].y1) / 2, t1[e1].x = (t1[e1].x0 + t1[e1].x1) / 2;
                                }(r.graph.nodes);
                                var a = r.graph.nodes.filter(function(t1) {
                                    return t1.originalX === r.node.originalX;
                                }).filter(function(t1) {
                                    return !t1.partOfGroup;
                                });
                                r.forceLayouts[e1] = n.forceSimulation(a).alphaDecay(0).force("collide", n.forceCollide().radius(function(t1) {
                                    return t1.dy / 2 + r.nodePad / 2;
                                }).strength(1).iterations(l.forceIterations)).force("constrain", function(t1, e1, r, n) {
                                    return function() {
                                        for(var t1 = 0, i = 0; i < r.length; i++){
                                            var a = r[i];
                                            a === n.interactionState.dragInProgress ? (a.x = a.lastDraggedX, a.y = a.lastDraggedY) : (a.vx = (a.originalX - a.x) / l.forceTicksPerFrame, a.y = Math.min(n.size - a.dy / 2, Math.max(a.dy / 2, a.y))), t1 = Math.max(t1, Math.abs(a.vx), Math.abs(a.vy));
                                        }
                                        !n.interactionState.dragInProgress && t1 < .1 && n.forceLayouts[e1].alpha() > 0 && n.forceLayouts[e1].alpha(0);
                                    };
                                }(0, e1, a, r)).stop();
                            }(0, o, a), function(t1, e1, r, n, i) {
                                window.requestAnimationFrame(function a() {
                                    var o;
                                    for(o = 0; o < l.forceTicksPerFrame; o++)r.forceLayouts[n].tick();
                                    if (function(t1) {
                                        for(var e1 = 0; e1 < t1.length; e1++)t1[e1].y0 = t1[e1].y - t1[e1].dy / 2, t1[e1].y1 = t1[e1].y0 + t1[e1].dy, t1[e1].x0 = t1[e1].x - t1[e1].dx / 2, t1[e1].x1 = t1[e1].x0 + t1[e1].dx;
                                    }(r.graph.nodes), r.sankey.update(r.graph), C(t1.filter(B(r)), e1), r.forceLayouts[n].alpha() > 0) window.requestAnimationFrame(a);
                                    else {
                                        var s = r.node.originalX;
                                        r.node.x0 = s - r.visibleWidth / 2, r.node.x1 = s + r.visibleWidth / 2, R(r, i);
                                    }
                                });
                            }(t1, e1, a, o, i);
                        }
                    }).on("drag", function(r) {
                        if ("fixed" !== r.arrangement) {
                            var n = a.event.x, i = a.event.y;
                            "snap" === r.arrangement ? (r.node.x0 = n - r.visibleWidth / 2, r.node.x1 = n + r.visibleWidth / 2, r.node.y0 = i - r.visibleHeight / 2, r.node.y1 = i + r.visibleHeight / 2) : ("freeform" === r.arrangement && (r.node.x0 = n - r.visibleWidth / 2, r.node.x1 = n + r.visibleWidth / 2), i = Math.max(0, Math.min(r.size - r.visibleHeight / 2, i)), r.node.y0 = i - r.visibleHeight / 2, r.node.y1 = i + r.visibleHeight / 2), F(r.node), "snap" !== r.arrangement && (r.sankey.update(r.graph), C(t1.filter(B(r)), e1));
                        }
                    }).on("dragend", function(t1) {
                        if ("fixed" !== t1.arrangement) {
                            t1.interactionState.dragInProgress = !1;
                            for(var e1 = 0; e1 < t1.node.childrenNodes.length; e1++)t1.node.childrenNodes[e1].x = t1.node.x, t1.node.childrenNodes[e1].y = t1.node.y;
                            "snap" !== t1.arrangement && R(t1, i);
                        }
                    });
                    t1.on(".drag", null).call(o);
                }
                function R(t1, e1) {
                    for(var r = [], n = [], i = 0; i < t1.graph.nodes.length; i++){
                        var a = (t1.graph.nodes[i].x0 + t1.graph.nodes[i].x1) / 2, o = (t1.graph.nodes[i].y0 + t1.graph.nodes[i].y1) / 2;
                        r.push(a / t1.figure.width), n.push(o / t1.figure.height);
                    }
                    b.call("_guiRestyle", e1, {
                        "node.x": [
                            r
                        ],
                        "node.y": [
                            n
                        ]
                    }, t1.trace.index).then(function() {
                        e1._fullLayout._dragCover && e1._fullLayout._dragCover.remove();
                    });
                }
                function F(t1) {
                    t1.lastDraggedX = t1.x0 + t1.dx / 2, t1.lastDraggedY = t1.y0 + t1.dy / 2;
                }
                function B(t1) {
                    return function(e1) {
                        return e1.node.originalX === t1.node.originalX;
                    };
                }
                e1.exports = function(t1, e1, r, n, i) {
                    var o = !1;
                    h.ensureSingle(t1._fullLayout._infolayer, "g", "first-render", function() {
                        o = !0;
                    });
                    var s = t1._fullLayout._dragCover, m = r.filter(function(t1) {
                        return y(t1).trace.visible;
                    }).map(k.bind(null, n)), b = e1.selectAll("." + l.cn.sankey).data(m, g);
                    b.exit().remove(), b.enter().append("g").classed(l.cn.sankey, !0).style("box-sizing", "content-box").style("position", "absolute").style("left", 0).style("shape-rendering", "geometricPrecision").style("pointer-events", "auto").attr("transform", O), b.each(function(e1, r) {
                        t1._fullData[r]._sankey = e1;
                        var n = "bgsankey-" + e1.trace.uid + "-" + r;
                        h.ensureSingle(t1._fullLayout._draggers, "rect", n), t1._fullData[r]._bgRect = a.select("." + n), t1._fullData[r]._bgRect.style("pointer-events", "all").attr("width", e1.width).attr("height", e1.height).attr("x", e1.translateX).attr("y", e1.translateY).classed("bgsankey", !0).style({
                            fill: "transparent",
                            "stroke-width": 0
                        });
                    }), b.transition().ease(l.ease).duration(l.duration).attr("transform", O);
                    var _ = b.selectAll("." + l.cn.sankeyLinks).data(v, g);
                    _.enter().append("g").classed(l.cn.sankeyLinks, !0).style("fill", "none");
                    var L = _.selectAll("." + l.cn.sankeyLink).data(function(t1) {
                        return t1.graph.links.filter(function(t1) {
                            return t1.value;
                        }).map(A.bind(null, t1));
                    }, g);
                    L.enter().append("path").classed(l.cn.sankeyLink, !0).call(z, b, i.linkEvents), L.style("stroke", function(t1) {
                        return I(t1) ? u.tinyRGB(c(t1.linkLineColor)) : t1.tinyColorHue;
                    }).style("stroke-opacity", function(t1) {
                        return I(t1) ? u.opacity(t1.linkLineColor) : t1.tinyColorAlpha;
                    }).style("fill", function(t1) {
                        return t1.tinyColorHue;
                    }).style("fill-opacity", function(t1) {
                        return t1.tinyColorAlpha;
                    }).style("stroke-width", function(t1) {
                        return I(t1) ? t1.linkLineWidth : 1;
                    }).attr("d", M()), L.style("opacity", function() {
                        return t1._context.staticPlot || o || s ? 1 : 0;
                    }).transition().ease(l.ease).duration(l.duration).style("opacity", 1), L.exit().transition().ease(l.ease).duration(l.duration).style("opacity", 0).remove();
                    var C = b.selectAll("." + l.cn.sankeyNodeSet).data(v, g);
                    C.enter().append("g").classed(l.cn.sankeyNodeSet, !0), C.style("cursor", function(t1) {
                        switch(t1.arrangement){
                            case "fixed":
                                return "default";
                            case "perpendicular":
                                return "ns-resize";
                            default:
                                return "move";
                        }
                    });
                    var R = C.selectAll("." + l.cn.sankeyNode).data(function(t1) {
                        var e1 = t1.graph.nodes;
                        return function(t1) {
                            var e1, r = [];
                            for(e1 = 0; e1 < t1.length; e1++)t1[e1].originalX = (t1[e1].x0 + t1[e1].x1) / 2, t1[e1].originalY = (t1[e1].y0 + t1[e1].y1) / 2, -1 === r.indexOf(t1[e1].originalX) && r.push(t1[e1].originalX);
                            for(r.sort(function(t1, e1) {
                                return t1 - e1;
                            }), e1 = 0; e1 < t1.length; e1++)t1[e1].originalLayerIndex = r.indexOf(t1[e1].originalX), t1[e1].originalLayer = t1[e1].originalLayerIndex / (r.length - 1);
                        }(e1), e1.map(S.bind(null, t1));
                    }, g);
                    R.enter().append("g").classed(l.cn.sankeyNode, !0).call(E).style("opacity", function(e1) {
                        return !t1._context.staticPlot && !o || e1.partOfGroup ? 0 : 1;
                    }), R.call(z, b, i.nodeEvents).call(D, L, i, t1), R.transition().ease(l.ease).duration(l.duration).call(E).style("opacity", function(t1) {
                        return t1.partOfGroup ? 0 : 1;
                    }), R.exit().transition().ease(l.ease).duration(l.duration).style("opacity", 0).remove();
                    var F = R.selectAll("." + l.cn.nodeRect).data(v);
                    F.enter().append("rect").classed(l.cn.nodeRect, !0).call(P), F.style("stroke-width", function(t1) {
                        return t1.nodeLineWidth;
                    }).style("stroke", function(t1) {
                        return u.tinyRGB(c(t1.nodeLineColor));
                    }).style("stroke-opacity", function(t1) {
                        return u.opacity(t1.nodeLineColor);
                    }).style("fill", function(t1) {
                        return t1.tinyColorHue;
                    }).style("fill-opacity", function(t1) {
                        return t1.tinyColorAlpha;
                    }), F.transition().ease(l.ease).duration(l.duration).call(P);
                    var B = R.selectAll("." + l.cn.nodeLabel).data(v);
                    B.enter().append("text").classed(l.cn.nodeLabel, !0).style("cursor", "default"), B.attr("data-notex", 1).text(function(t1) {
                        return t1.node.label;
                    }).each(function(e1) {
                        var r = a.select(this);
                        f.font(r, e1.textFont), x.convertToTspans(r, t1);
                    }).style("text-shadow", x.makeTextShadow(t1._fullLayout.paper_bgcolor)).attr("text-anchor", function(t1) {
                        return t1.horizontal && t1.left ? "end" : "start";
                    }).attr("transform", function(t1) {
                        var e1 = a.select(this), r = x.lineCount(e1), n = t1.textFont.size * ((r - 1) * T - w), i = t1.nodeLineWidth / 2 + 3, o = ((t1.horizontal ? t1.visibleHeight : t1.visibleWidth) - n) / 2;
                        t1.horizontal && (t1.left ? i = -i : i += t1.visibleWidth);
                        var s = t1.horizontal ? "" : "scale(-1,1)" + d(90);
                        return p(t1.horizontal ? i : o, t1.horizontal ? o : i) + s;
                    }), B.transition().ease(l.ease).duration(l.duration);
                };
            },
            {
                "../../components/color": 366,
                "../../components/drawing": 388,
                "../../constants/alignment": 471,
                "../../lib": 503,
                "../../lib/gup": 500,
                "../../lib/svg_text_utils": 529,
                "../../registry": 638,
                "./constants": 919,
                "@plotly/d3": 58,
                "@plotly/d3-sankey": 57,
                "@plotly/d3-sankey-circular": 56,
                "d3-force": 111,
                "d3-interpolate": 116,
                tinycolor2: 312
            }
        ],
        924: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    for(var r = [], n = t1.cd[0].trace, i = n._sankey.graph.nodes, a = 0; a < i.length; a++){
                        var o = i[a];
                        if (!o.partOfGroup) {
                            var s = [
                                (o.x0 + o.x1) / 2,
                                (o.y0 + o.y1) / 2
                            ];
                            "v" === n.orientation && s.reverse(), e1 && e1.contains(s, !1, a, t1) && r.push({
                                pointNumber: o.pointNumber
                            });
                        }
                    }
                    return r;
                };
            },
            {}
        ],
        925: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = function(t1, e1) {
                    for(var r = 0; r < t1.length; r++)t1[r].i = r;
                    n.mergeArray(e1.text, t1, "tx"), n.mergeArray(e1.texttemplate, t1, "txt"), n.mergeArray(e1.hovertext, t1, "htx"), n.mergeArray(e1.customdata, t1, "data"), n.mergeArray(e1.textposition, t1, "tp"), e1.textfont && (n.mergeArrayCastPositive(e1.textfont.size, t1, "ts"), n.mergeArray(e1.textfont.color, t1, "tc"), n.mergeArray(e1.textfont.family, t1, "tf"));
                    var i = e1.marker;
                    if (i) {
                        n.mergeArrayCastPositive(i.size, t1, "ms"), n.mergeArrayCastPositive(i.opacity, t1, "mo"), n.mergeArray(i.symbol, t1, "mx"), n.mergeArray(i.color, t1, "mc");
                        var a = i.line;
                        i.line && (n.mergeArray(a.color, t1, "mlc"), n.mergeArrayCastPositive(a.width, t1, "mlw"));
                        var o = i.gradient;
                        o && "none" !== o.type && (n.mergeArray(o.type, t1, "mgt"), n.mergeArray(o.color, t1, "mgc"));
                    }
                };
            },
            {
                "../../lib": 503
            }
        ],
        926: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, i = t1("../../plots/template_attributes").texttemplateAttrs, a = t1("../../plots/template_attributes").hovertemplateAttrs, o = t1("../../components/colorscale/attributes"), s = t1("../../plots/font_attributes"), l = t1("../../components/drawing/attributes").dash, c = t1("../../components/drawing"), u = t1("./constants"), f = t1("../../lib/extend").extendFlat;
                e1.exports = {
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes",
                        anim: !0
                    },
                    x0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes",
                        anim: !0
                    },
                    dx: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc",
                        anim: !0
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes",
                        anim: !0
                    },
                    y0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes",
                        anim: !0
                    },
                    dy: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc",
                        anim: !0
                    },
                    xperiod: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc"
                    },
                    yperiod: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc"
                    },
                    xperiod0: {
                        valType: "any",
                        editType: "calc"
                    },
                    yperiod0: {
                        valType: "any",
                        editType: "calc"
                    },
                    xperiodalignment: {
                        valType: "enumerated",
                        values: [
                            "start",
                            "middle",
                            "end"
                        ],
                        dflt: "middle",
                        editType: "calc"
                    },
                    yperiodalignment: {
                        valType: "enumerated",
                        values: [
                            "start",
                            "middle",
                            "end"
                        ],
                        dflt: "middle",
                        editType: "calc"
                    },
                    xhoverformat: n("x"),
                    yhoverformat: n("y"),
                    stackgroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        editType: "calc"
                    },
                    groupnorm: {
                        valType: "enumerated",
                        values: [
                            "",
                            "fraction",
                            "percent"
                        ],
                        dflt: "",
                        editType: "calc"
                    },
                    stackgaps: {
                        valType: "enumerated",
                        values: [
                            "infer zero",
                            "interpolate"
                        ],
                        dflt: "infer zero",
                        editType: "calc"
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    texttemplate: i({}, {}),
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0,
                        editType: "style"
                    },
                    mode: {
                        valType: "flaglist",
                        flags: [
                            "lines",
                            "markers",
                            "text"
                        ],
                        extras: [
                            "none"
                        ],
                        editType: "calc"
                    },
                    hoveron: {
                        valType: "flaglist",
                        flags: [
                            "points",
                            "fills"
                        ],
                        editType: "style"
                    },
                    hovertemplate: a({}, {
                        keys: u.eventDataKeys
                    }),
                    line: {
                        color: {
                            valType: "color",
                            editType: "style",
                            anim: !0
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: 2,
                            editType: "style",
                            anim: !0
                        },
                        shape: {
                            valType: "enumerated",
                            values: [
                                "linear",
                                "spline",
                                "hv",
                                "vh",
                                "hvh",
                                "vhv"
                            ],
                            dflt: "linear",
                            editType: "plot"
                        },
                        smoothing: {
                            valType: "number",
                            min: 0,
                            max: 1.3,
                            dflt: 1,
                            editType: "plot"
                        },
                        dash: f({}, l, {
                            editType: "style"
                        }),
                        simplify: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    connectgaps: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    cliponaxis: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    fill: {
                        valType: "enumerated",
                        values: [
                            "none",
                            "tozeroy",
                            "tozerox",
                            "tonexty",
                            "tonextx",
                            "toself",
                            "tonext"
                        ],
                        editType: "calc"
                    },
                    fillcolor: {
                        valType: "color",
                        editType: "style",
                        anim: !0
                    },
                    marker: f({
                        symbol: {
                            valType: "enumerated",
                            values: c.symbolList,
                            dflt: "circle",
                            arrayOk: !0,
                            editType: "style"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            arrayOk: !0,
                            editType: "style",
                            anim: !0
                        },
                        size: {
                            valType: "number",
                            min: 0,
                            dflt: 6,
                            arrayOk: !0,
                            editType: "calc",
                            anim: !0
                        },
                        maxdisplayed: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "plot"
                        },
                        sizeref: {
                            valType: "number",
                            dflt: 1,
                            editType: "calc"
                        },
                        sizemin: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            editType: "calc"
                        },
                        sizemode: {
                            valType: "enumerated",
                            values: [
                                "diameter",
                                "area"
                            ],
                            dflt: "diameter",
                            editType: "calc"
                        },
                        line: f({
                            width: {
                                valType: "number",
                                min: 0,
                                arrayOk: !0,
                                editType: "style",
                                anim: !0
                            },
                            editType: "calc"
                        }, o("marker.line", {
                            anim: !0
                        })),
                        gradient: {
                            type: {
                                valType: "enumerated",
                                values: [
                                    "radial",
                                    "horizontal",
                                    "vertical",
                                    "none"
                                ],
                                arrayOk: !0,
                                dflt: "none",
                                editType: "calc"
                            },
                            color: {
                                valType: "color",
                                arrayOk: !0,
                                editType: "calc"
                            },
                            editType: "calc"
                        },
                        editType: "calc"
                    }, o("marker", {
                        anim: !0
                    })),
                    selected: {
                        marker: {
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: "style"
                            },
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            size: {
                                valType: "number",
                                min: 0,
                                editType: "style"
                            },
                            editType: "style"
                        },
                        textfont: {
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            editType: "style"
                        },
                        editType: "style"
                    },
                    unselected: {
                        marker: {
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                editType: "style"
                            },
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            size: {
                                valType: "number",
                                min: 0,
                                editType: "style"
                            },
                            editType: "style"
                        },
                        textfont: {
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            editType: "style"
                        },
                        editType: "style"
                    },
                    textposition: {
                        valType: "enumerated",
                        values: [
                            "top left",
                            "top center",
                            "top right",
                            "middle left",
                            "middle center",
                            "middle right",
                            "bottom left",
                            "bottom center",
                            "bottom right"
                        ],
                        dflt: "middle center",
                        arrayOk: !0,
                        editType: "calc"
                    },
                    textfont: s({
                        editType: "calc",
                        colorEditType: "style",
                        arrayOk: !0
                    })
                };
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../components/drawing": 388,
                "../../components/drawing/attributes": 387,
                "../../lib/extend": 493,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/font_attributes": 585,
                "../../plots/template_attributes": 633,
                "./constants": 930
            }
        ],
        927: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = t1("../../plots/cartesian/axes"), o = t1("../../plots/cartesian/align_period"), s = t1("../../constants/numerical").BADNUM, l = t1("./subtypes"), c = t1("./colorscale_calc"), u = t1("./arrays_to_calcdata"), f = t1("./calc_selection");
                function h(t1, e1, r, n, i, o, s) {
                    var c = e1._length, u = t1._fullLayout, f = r._id, h = n._id, p = u._firstScatter[m(e1)] === e1.uid, d = (g(e1, u, r, n) || {}).orientation, v = e1.fill;
                    r._minDtick = 0, n._minDtick = 0;
                    var y = {
                        padded: !0
                    }, x = {
                        padded: !0
                    };
                    s && (y.ppad = x.ppad = s);
                    var b = c < 2 || i[0] !== i[c - 1] || o[0] !== o[c - 1];
                    b && ("tozerox" === v || "tonextx" === v && (p || "h" === d)) ? y.tozero = !0 : (e1.error_y || {}).visible || "tonexty" !== v && "tozeroy" !== v && (l.hasMarkers(e1) || l.hasText(e1)) || (y.padded = !1, y.ppad = 0), b && ("tozeroy" === v || "tonexty" === v && (p || "v" === d)) ? x.tozero = !0 : "tonextx" !== v && "tozerox" !== v || (x.padded = !1), f && (e1._extremes[f] = a.findExtremes(r, i, y)), h && (e1._extremes[h] = a.findExtremes(n, o, x));
                }
                function p(t1, e1) {
                    if (l.hasMarkers(t1)) {
                        var r, n = t1.marker, o = 1.6 * (t1.marker.sizeref || 1);
                        if (r = "area" === t1.marker.sizemode ? function(t1) {
                            return Math.max(Math.sqrt((t1 || 0) / o), 3);
                        } : function(t1) {
                            return Math.max((t1 || 0) / o, 3);
                        }, i.isArrayOrTypedArray(n.size)) {
                            var s = {
                                type: "linear"
                            };
                            a.setConvert(s);
                            for(var c = s.makeCalcdata(t1.marker, "size"), u = new Array(e1), f = 0; f < e1; f++)u[f] = r(c[f]);
                            return u;
                        }
                        return r(n.size);
                    }
                }
                function d(t1, e1) {
                    var r = m(e1), n = t1._firstScatter;
                    n[r] || (n[r] = e1.uid);
                }
                function m(t1) {
                    var e1 = t1.stackgroup;
                    return t1.xaxis + t1.yaxis + t1.type + (e1 ? "-" + e1 : "");
                }
                function g(t1, e1, r, n) {
                    var i = t1.stackgroup;
                    if (i) {
                        var a = e1._scatterStackOpts[r._id + n._id][i], o = "v" === a.orientation ? n : r;
                        return "linear" === o.type || "log" === o.type ? a : void 0;
                    }
                }
                e1.exports = {
                    calc: function(t1, e1) {
                        var r, l, m, v, y, x, b = t1._fullLayout, _ = a.getFromId(t1, e1.xaxis || "x"), w = a.getFromId(t1, e1.yaxis || "y"), T = _.makeCalcdata(e1, "x"), k = w.makeCalcdata(e1, "y"), A = o(e1, _, "x", T), M = o(e1, w, "y", k), S = A.vals, E = M.vals, L = e1._length, C = new Array(L), P = e1.ids, I = g(e1, b, _, w), O = !1;
                        d(b, e1);
                        var z, D = "x", R = "y";
                        I ? (i.pushUnique(I.traceIndices, e1._expandedIndex), (r = "v" === I.orientation) ? (R = "s", z = "x") : (D = "s", z = "y"), y = "interpolate" === I.stackgaps) : h(t1, e1, _, w, S, E, p(e1, L));
                        var F = !!e1.xperiodalignment, B = !!e1.yperiodalignment;
                        for(l = 0; l < L; l++){
                            var N = C[l] = {}, j = n(S[l]), U = n(E[l]);
                            j && U ? (N[D] = S[l], N[R] = E[l], F && (N.orig_x = T[l], N.xEnd = A.ends[l], N.xStart = A.starts[l]), B && (N.orig_y = k[l], N.yEnd = M.ends[l], N.yStart = M.starts[l])) : I && (r ? j : U) ? (N[z] = r ? S[l] : E[l], N.gap = !0, y ? (N.s = s, O = !0) : N.s = 0) : N[D] = N[R] = s, P && (N.id = String(P[l]));
                        }
                        if (u(C, e1), c(t1, e1), f(C, e1), I) {
                            for(l = 0; l < C.length;)C[l][z] === s ? C.splice(l, 1) : l++;
                            if (i.sort(C, function(t1, e1) {
                                return t1[z] - e1[z] || t1.i - e1.i;
                            }), O) {
                                for(l = 0; l < C.length - 1 && C[l].gap;)l++;
                                for((x = C[l].s) || (x = C[l].s = 0), m = 0; m < l; m++)C[m].s = x;
                                for(v = C.length - 1; v > l && C[v].gap;)v--;
                                for(x = C[v].s, m = C.length - 1; m > v; m--)C[m].s = x;
                                for(; l < v;)if (C[++l].gap) {
                                    for(m = l + 1; C[m].gap;)m++;
                                    for(var V = C[l - 1][z], H = C[l - 1].s, q = (C[m].s - H) / (C[m][z] - V); l < m;)C[l].s = H + (C[l][z] - V) * q, l++;
                                }
                            }
                        }
                        return C;
                    },
                    calcMarkerSize: p,
                    calcAxisExpansion: h,
                    setFirstScatter: d,
                    getStackOpts: g
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../plots/cartesian/align_period": 551,
                "../../plots/cartesian/axes": 554,
                "./arrays_to_calcdata": 925,
                "./calc_selection": 928,
                "./colorscale_calc": 929,
                "./subtypes": 951,
                "fast-isnumeric": 190
            }
        ],
        928: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = function(t1, e1) {
                    n.isArrayOrTypedArray(e1.selectedpoints) && n.tagSelected(t1, e1);
                };
            },
            {
                "../../lib": 503
            }
        ],
        929: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/helpers").hasColorscale, i = t1("../../components/colorscale/calc"), a = t1("./subtypes");
                e1.exports = function(t1, e1) {
                    a.hasLines(e1) && n(e1, "line") && i(t1, e1, {
                        vals: e1.line.color,
                        containerStr: "line",
                        cLetter: "c"
                    }), a.hasMarkers(e1) && (n(e1, "marker") && i(t1, e1, {
                        vals: e1.marker.color,
                        containerStr: "marker",
                        cLetter: "c"
                    }), n(e1, "marker.line") && i(t1, e1, {
                        vals: e1.marker.line.color,
                        containerStr: "marker.line",
                        cLetter: "c"
                    }));
                };
            },
            {
                "../../components/colorscale/calc": 374,
                "../../components/colorscale/helpers": 377,
                "./subtypes": 951
            }
        ],
        930: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    PTS_LINESONLY: 20,
                    minTolerance: .2,
                    toleranceGrowth: 10,
                    maxScreensAway: 20,
                    eventDataKeys: []
                };
            },
            {}
        ],
        931: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./calc");
                function i(t1, e1, r, n, i, a, o) {
                    i[n] = !0;
                    var s = {
                        i: null,
                        gap: !0,
                        s: 0
                    };
                    if (s[o] = r, t1.splice(e1, 0, s), e1 && r === t1[e1 - 1][o]) {
                        var l = t1[e1 - 1];
                        s.s = l.s, s.i = l.i, s.gap = l.gap;
                    } else a && (s.s = function(t1, e1, r, n) {
                        var i = t1[e1 - 1], a = t1[e1 + 1];
                        return a ? i ? i.s + (a.s - i.s) * (r - i[n]) / (a[n] - i[n]) : a.s : i.s;
                    }(t1, e1, r, o));
                    e1 || (t1[0].t = t1[1].t, t1[0].trace = t1[1].trace, delete t1[1].t, delete t1[1].trace);
                }
                e1.exports = function(t1, e1) {
                    var r = e1.xaxis, a = e1.yaxis, o = r._id + a._id, s = t1._fullLayout._scatterStackOpts[o];
                    if (s) {
                        var l, c, u, f, h, p, d, m, g, v, y, x, b, _, w, T = t1.calcdata;
                        for(var k in s){
                            var A = (v = s[k]).traceIndices;
                            if (A.length) {
                                for(y = "interpolate" === v.stackgaps, x = v.groupnorm, "v" === v.orientation ? (b = "x", _ = "y") : (b = "y", _ = "x"), w = new Array(A.length), l = 0; l < w.length; l++)w[l] = !1;
                                p = T[A[0]];
                                var M = new Array(p.length);
                                for(l = 0; l < p.length; l++)M[l] = p[l][b];
                                for(l = 1; l < A.length; l++){
                                    for(h = T[A[l]], c = u = 0; c < h.length; c++){
                                        for(d = h[c][b]; d > M[u] && u < M.length; u++)i(h, c, M[u], l, w, y, b), c++;
                                        if (d !== M[u]) {
                                            for(f = 0; f < l; f++)i(T[A[f]], u, d, f, w, y, b);
                                            M.splice(u, 0, d);
                                        }
                                        u++;
                                    }
                                    for(; u < M.length; u++)i(h, c, M[u], l, w, y, b), c++;
                                }
                                var S = M.length;
                                for(c = 0; c < p.length; c++){
                                    for(m = p[c][_] = p[c].s, l = 1; l < A.length; l++)(h = T[A[l]])[0].trace._rawLength = h[0].trace._length, h[0].trace._length = S, m += h[c].s, h[c][_] = m;
                                    if (x) for(g = ("fraction" === x ? m : m / 100) || 1, l = 0; l < A.length; l++){
                                        var E = T[A[l]][c];
                                        E[_] /= g, E.sNorm = E.s / g;
                                    }
                                }
                                for(l = 0; l < A.length; l++){
                                    var L = (h = T[A[l]])[0].trace, C = n.calcMarkerSize(L, L._rawLength), P = Array.isArray(C);
                                    if (C && w[l] || P) {
                                        var I = C;
                                        for(C = new Array(S), c = 0; c < S; c++)C[c] = h[c].gap ? 0 : P ? I[h[c].i] : I;
                                    }
                                    var O = new Array(S), z = new Array(S);
                                    for(c = 0; c < S; c++)O[c] = h[c].x, z[c] = h[c].y;
                                    n.calcAxisExpansion(t1, L, r, a, O, z, C), h[0].t.orientation = v.orientation;
                                }
                            }
                        }
                    }
                };
            },
            {
                "./calc": 927
            }
        ],
        932: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1) {
                    for(var e1 = 0; e1 < t1.length; e1++){
                        var r = t1[e1];
                        if ("scatter" === r.type) {
                            var n = r.fill;
                            if ("none" !== n && "toself" !== n && (r.opacity = void 0, "tonexty" === n || "tonextx" === n)) for(var i = e1 - 1; i >= 0; i--){
                                var a = t1[i];
                                if ("scatter" === a.type && a.xaxis === r.xaxis && a.yaxis === r.yaxis) {
                                    a.opacity = void 0;
                                    break;
                                }
                            }
                        }
                    }
                };
            },
            {}
        ],
        933: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../registry"), a = t1("./attributes"), o = t1("./constants"), s = t1("./subtypes"), l = t1("./xy_defaults"), c = t1("./period_defaults"), u = t1("./stack_defaults"), f = t1("./marker_defaults"), h = t1("./line_defaults"), p = t1("./line_shape_defaults"), d = t1("./text_defaults"), m = t1("./fillcolor_defaults");
                e1.exports = function(t1, e1, r, g) {
                    function v(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var y = l(t1, e1, g, v);
                    if (y || (e1.visible = !1), e1.visible) {
                        c(t1, e1, g, v), v("xhoverformat"), v("yhoverformat");
                        var x = u(t1, e1, g, v), b = !x && y < o.PTS_LINESONLY ? "lines+markers" : "lines";
                        v("text"), v("hovertext"), v("mode", b), s.hasLines(e1) && (h(t1, e1, r, g, v), p(t1, e1, v), v("connectgaps"), v("line.simplify")), s.hasMarkers(e1) && f(t1, e1, r, g, v, {
                            gradient: !0
                        }), s.hasText(e1) && (v("texttemplate"), d(t1, e1, g, v));
                        var _ = [];
                        (s.hasMarkers(e1) || s.hasText(e1)) && (v("cliponaxis"), v("marker.maxdisplayed"), _.push("points")), v("fill", x ? x.fillDflt : "none"), "none" !== e1.fill && (m(t1, e1, r, v), s.hasLines(e1) || p(t1, e1, v));
                        var w = (e1.line || {}).color, T = (e1.marker || {}).color;
                        "tonext" !== e1.fill && "toself" !== e1.fill || _.push("fills"), v("hoveron", _.join("+") || "points"), "fills" !== e1.hoveron && v("hovertemplate");
                        var k = i.getComponentMethod("errorbars", "supplyDefaults");
                        k(t1, e1, w || T || r, {
                            axis: "y"
                        }), k(t1, e1, w || T || r, {
                            axis: "x",
                            inherit: "y"
                        }), n.coerceSelectionMarkerOpacity(e1, v);
                    }
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638,
                "./attributes": 926,
                "./constants": 930,
                "./fillcolor_defaults": 934,
                "./line_defaults": 939,
                "./line_shape_defaults": 941,
                "./marker_defaults": 945,
                "./period_defaults": 946,
                "./stack_defaults": 949,
                "./subtypes": 951,
                "./text_defaults": 952,
                "./xy_defaults": 953
            }
        ],
        934: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color"), i = t1("../../lib").isArrayOrTypedArray;
                e1.exports = function(t1, e1, r, a) {
                    var o = !1;
                    if (e1.marker) {
                        var s = e1.marker.color, l = (e1.marker.line || {}).color;
                        s && !i(s) ? o = s : l && !i(l) && (o = l);
                    }
                    a("fillcolor", n.addOpacity((e1.line || {}).color || o || r, .5));
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503
            }
        ],
        935: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes");
                e1.exports = function(t1, e1, r) {
                    var i = {}, a = {
                        _fullLayout: r
                    }, o = n.getFromTrace(a, e1, "x"), s = n.getFromTrace(a, e1, "y");
                    return i.xLabel = n.tickText(o, o.c2l(t1.x), !0).text, i.yLabel = n.tickText(s, s.c2l(t1.y), !0).text, i;
                };
            },
            {
                "../../plots/cartesian/axes": 554
            }
        ],
        936: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color"), i = t1("./subtypes");
                e1.exports = function(t1, e1) {
                    var r, a;
                    if ("lines" === t1.mode) return (r = t1.line.color) && n.opacity(r) ? r : t1.fillcolor;
                    if ("none" === t1.mode) return t1.fill ? t1.fillcolor : "";
                    var o = e1.mcc || (t1.marker || {}).color, s = e1.mlcc || ((t1.marker || {}).line || {}).color;
                    return (a = o && n.opacity(o) ? o : s && n.opacity(s) && (e1.mlw || ((t1.marker || {}).line || {}).width) ? s : "") ? n.opacity(a) < .3 ? n.addOpacity(a, .3) : a : (r = (t1.line || {}).color) && n.opacity(r) && i.hasLines(t1) && t1.line.width ? r : t1.fillcolor;
                };
            },
            {
                "../../components/color": 366,
                "./subtypes": 951
            }
        ],
        937: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/fx"), a = t1("../../registry"), o = t1("./get_trace_color"), s = t1("../../components/color"), l = n.fillText;
                e1.exports = function(t1, e1, r, c) {
                    var u = t1.cd, f = u[0].trace, h = t1.xa, p = t1.ya, d = h.c2p(e1), m = p.c2p(r), g = [
                        d,
                        m
                    ], v = f.hoveron || "", y = -1 !== f.mode.indexOf("markers") ? 3 : .5, x = !!f.xperiodalignment, b = !!f.yperiodalignment;
                    if (-1 !== v.indexOf("points")) {
                        var _ = function(t1) {
                            var e1 = Math.max(y, t1.mrc || 0), r = h.c2p(t1.x) - d, n = p.c2p(t1.y) - m;
                            return Math.max(Math.sqrt(r * r + n * n) - e1, 1 - y / e1);
                        }, w = i.getDistanceFunction(c, function(t1) {
                            if (x) {
                                var e1 = h.c2p(t1.xStart), r = h.c2p(t1.xEnd);
                                return d >= Math.min(e1, r) && d <= Math.max(e1, r) ? 0 : 1 / 0;
                            }
                            var n = Math.max(3, t1.mrc || 0), i = 1 - 1 / n, a = Math.abs(h.c2p(t1.x) - d);
                            return a < n ? i * a / n : a - n + i;
                        }, function(t1) {
                            if (b) {
                                var e1 = p.c2p(t1.yStart), r = p.c2p(t1.yEnd);
                                return m >= Math.min(e1, r) && m <= Math.max(e1, r) ? 0 : 1 / 0;
                            }
                            var n = Math.max(3, t1.mrc || 0), i = 1 - 1 / n, a = Math.abs(p.c2p(t1.y) - m);
                            return a < n ? i * a / n : a - n + i;
                        }, _);
                        if (i.getClosest(u, w, t1), !1 !== t1.index) {
                            var T = u[t1.index], k = h.c2p(T.x, !0), A = p.c2p(T.y, !0), M = T.mrc || 1;
                            t1.index = T.i;
                            var S = u[0].t.orientation, E = S && (T.sNorm || T.s), L = "h" === S ? E : void 0 !== T.orig_x ? T.orig_x : T.x, C = "v" === S ? E : void 0 !== T.orig_y ? T.orig_y : T.y;
                            return n.extendFlat(t1, {
                                color: o(f, T),
                                x0: k - M,
                                x1: k + M,
                                xLabelVal: L,
                                y0: A - M,
                                y1: A + M,
                                yLabelVal: C,
                                spikeDistance: _(T),
                                hovertemplate: f.hovertemplate
                            }), l(T, f, t1), a.getComponentMethod("errorbars", "hoverInfo")(T, f, t1), [
                                t1
                            ];
                        }
                    }
                    if (-1 !== v.indexOf("fills") && f._polygons) {
                        var P, I, O, z, D, R, F, B, N, j = f._polygons, U = [], V = !1, H = 1 / 0, q = -1 / 0, G = 1 / 0, Y = -1 / 0;
                        for(P = 0; P < j.length; P++)(O = j[P]).contains(g) && (V = !V, U.push(O), G = Math.min(G, O.ymin), Y = Math.max(Y, O.ymax));
                        if (V) {
                            var W = ((G = Math.max(G, 0)) + (Y = Math.min(Y, p._length))) / 2;
                            for(P = 0; P < U.length; P++)for(z = U[P].pts, I = 1; I < z.length; I++)(B = z[I - 1][1]) > W != (N = z[I][1]) >= W && (R = z[I - 1][0], F = z[I][0], N - B && (D = R + (F - R) * (W - B) / (N - B), H = Math.min(H, D), q = Math.max(q, D)));
                            H = Math.max(H, 0), q = Math.min(q, h._length);
                            var X = s.defaultLine;
                            return s.opacity(f.fillcolor) ? X = f.fillcolor : s.opacity((f.line || {}).color) && (X = f.line.color), n.extendFlat(t1, {
                                distance: t1.maxHoverDistance,
                                x0: H,
                                x1: q,
                                y0: W,
                                y1: W,
                                color: X,
                                hovertemplate: !1
                            }), delete t1.index, f.text && !Array.isArray(f.text) ? t1.text = String(f.text) : t1.text = f.name, [
                                t1
                            ];
                        }
                    }
                };
            },
            {
                "../../components/color": 366,
                "../../components/fx": 406,
                "../../lib": 503,
                "../../registry": 638,
                "./get_trace_color": 936
            }
        ],
        938: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./subtypes");
                e1.exports = {
                    hasLines: n.hasLines,
                    hasMarkers: n.hasMarkers,
                    hasText: n.hasText,
                    isBubble: n.isBubble,
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    crossTraceDefaults: t1("./cross_trace_defaults"),
                    calc: t1("./calc").calc,
                    crossTraceCalc: t1("./cross_trace_calc"),
                    arraysToCalcdata: t1("./arrays_to_calcdata"),
                    plot: t1("./plot"),
                    colorbar: t1("./marker_colorbar"),
                    formatLabels: t1("./format_labels"),
                    style: t1("./style").style,
                    styleOnSelect: t1("./style").styleOnSelect,
                    hoverPoints: t1("./hover"),
                    selectPoints: t1("./select"),
                    animatable: !0,
                    moduleType: "trace",
                    name: "scatter",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "cartesian",
                        "svg",
                        "symbols",
                        "errorBarsOK",
                        "showLegend",
                        "scatter-like",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "./arrays_to_calcdata": 925,
                "./attributes": 926,
                "./calc": 927,
                "./cross_trace_calc": 931,
                "./cross_trace_defaults": 932,
                "./defaults": 933,
                "./format_labels": 935,
                "./hover": 937,
                "./marker_colorbar": 944,
                "./plot": 947,
                "./select": 948,
                "./style": 950,
                "./subtypes": 951
            }
        ],
        939: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").isArrayOrTypedArray, i = t1("../../components/colorscale/helpers").hasColorscale, a = t1("../../components/colorscale/defaults");
                e1.exports = function(t1, e1, r, o, s, l) {
                    var c = (t1.marker || {}).color;
                    (s("line.color", r), i(t1, "line")) ? a(t1, e1, o, s, {
                        prefix: "line.",
                        cLetter: "c"
                    }) : s("line.color", !n(c) && c || r);
                    s("line.width"), (l || {}).noDash || s("line.dash");
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../components/colorscale/helpers": 377,
                "../../lib": 503
            }
        ],
        940: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../constants/numerical"), i = n.BADNUM, a = n.LOG_CLIP, o = a + .5, s = a - .5, l = t1("../../lib"), c = l.segmentsIntersect, u = l.constrain, f = t1("./constants");
                e1.exports = function(t1, e1) {
                    var r, n, a, h, p, d, m, g, v, y, x, b, _, w, T, k, A, M, S = e1.xaxis, E = e1.yaxis, L = "log" === S.type, C = "log" === E.type, P = S._length, I = E._length, O = e1.connectGaps, z = e1.baseTolerance, D = e1.shape, R = "linear" === D, F = e1.fill && "none" !== e1.fill, B = [], N = f.minTolerance, j = t1.length, U = new Array(j), V = 0;
                    function H(r) {
                        var n = t1[r];
                        if (!n) return !1;
                        var a = e1.linearized ? S.l2p(n.x) : S.c2p(n.x), l = e1.linearized ? E.l2p(n.y) : E.c2p(n.y);
                        if (a === i) {
                            if (L && (a = S.c2p(n.x, !0)), a === i) return !1;
                            C && l === i && (a *= Math.abs(S._m * I * (S._m > 0 ? o : s) / (E._m * P * (E._m > 0 ? o : s)))), a *= 1e3;
                        }
                        if (l === i) {
                            if (C && (l = E.c2p(n.y, !0)), l === i) return !1;
                            l *= 1e3;
                        }
                        return [
                            a,
                            l
                        ];
                    }
                    function q(t1, e1, r, n) {
                        var i = r - t1, a = n - e1, o = .5 - t1, s = .5 - e1, l = i * i + a * a, c = i * o + a * s;
                        if (c > 0 && c < l) {
                            var u = o * a - s * i;
                            if (u * u < l) return !0;
                        }
                    }
                    function G(t1, e1) {
                        var r = t1[0] / P, n = t1[1] / I, i = Math.max(0, -r, r - 1, -n, n - 1);
                        return i && void 0 !== A && q(r, n, A, M) && (i = 0), i && e1 && q(r, n, e1[0] / P, e1[1] / I) && (i = 0), (1 + f.toleranceGrowth * i) * z;
                    }
                    function Y(t1, e1) {
                        var r = t1[0] - e1[0], n = t1[1] - e1[1];
                        return Math.sqrt(r * r + n * n);
                    }
                    var W, X, Z, J, K, Q, $, tt = f.maxScreensAway, et = -P * tt, rt = P * (1 + tt), nt = -I * tt, it = I * (1 + tt), at = [
                        [
                            et,
                            nt,
                            rt,
                            nt
                        ],
                        [
                            rt,
                            nt,
                            rt,
                            it
                        ],
                        [
                            rt,
                            it,
                            et,
                            it
                        ],
                        [
                            et,
                            it,
                            et,
                            nt
                        ]
                    ];
                    function ot(t1) {
                        if (t1[0] < et || t1[0] > rt || t1[1] < nt || t1[1] > it) return [
                            u(t1[0], et, rt),
                            u(t1[1], nt, it)
                        ];
                    }
                    function st(t1, e1) {
                        return t1[0] === e1[0] && (t1[0] === et || t1[0] === rt) || t1[1] === e1[1] && (t1[1] === nt || t1[1] === it) || void 0;
                    }
                    function lt(t1, e1, r) {
                        return function(n, i) {
                            var a = ot(n), o = ot(i), s = [];
                            if (a && o && st(a, o)) return s;
                            a && s.push(a), o && s.push(o);
                            var c = 2 * l.constrain((n[t1] + i[t1]) / 2, e1, r) - ((a || n)[t1] + (o || i)[t1]);
                            c && ((a && o ? c > 0 == a[t1] > o[t1] ? a : o : a || o)[t1] += c);
                            return s;
                        };
                    }
                    function ct(t1) {
                        var e1 = t1[0], r = t1[1], n = e1 === U[V - 1][0], i = r === U[V - 1][1];
                        if (!n || !i) {
                            if (V > 1) {
                                var a = e1 === U[V - 2][0], o = r === U[V - 2][1];
                                n && (e1 === et || e1 === rt) && a ? o ? V-- : U[V - 1] = t1 : i && (r === nt || r === it) && o ? a ? V-- : U[V - 1] = t1 : U[V++] = t1;
                            } else U[V++] = t1;
                        }
                    }
                    function ut(t1) {
                        U[V - 1][0] !== t1[0] && U[V - 1][1] !== t1[1] && ct([
                            Z,
                            J
                        ]), ct(t1), K = null, Z = J = 0;
                    }
                    function ft(t1) {
                        if (A = t1[0] / P, M = t1[1] / I, W = t1[0] < et ? et : t1[0] > rt ? rt : 0, X = t1[1] < nt ? nt : t1[1] > it ? it : 0, W || X) {
                            if (V) {
                                if (K) {
                                    var e1 = $(K, t1);
                                    e1.length > 1 && (ut(e1[0]), U[V++] = e1[1]);
                                } else Q = $(U[V - 1], t1)[0], U[V++] = Q;
                            } else U[V++] = [
                                W || t1[0],
                                X || t1[1]
                            ];
                            var r = U[V - 1];
                            W && X && (r[0] !== W || r[1] !== X) ? (K && (Z !== W && J !== X ? ct(Z && J ? (n = K, a = (i = t1)[0] - n[0], o = (i[1] - n[1]) / a, (n[1] * i[0] - i[1] * n[0]) / a > 0 ? [
                                o > 0 ? et : rt,
                                it
                            ] : [
                                o > 0 ? rt : et,
                                nt
                            ]) : [
                                Z || W,
                                J || X
                            ]) : Z && J && ct([
                                Z,
                                J
                            ])), ct([
                                W,
                                X
                            ])) : Z - W && J - X && ct([
                                W || Z,
                                X || J
                            ]), K = t1, Z = W, J = X;
                        } else K && ut($(K, t1)[0]), U[V++] = t1;
                        var n, i, a, o;
                    }
                    for("linear" === D || "spline" === D ? $ = function(t1, e1) {
                        for(var r = [], n = 0, i = 0; i < 4; i++){
                            var a = at[i], o = c(t1[0], t1[1], e1[0], e1[1], a[0], a[1], a[2], a[3]);
                            o && (!n || Math.abs(o.x - r[0][0]) > 1 || Math.abs(o.y - r[0][1]) > 1) && (o = [
                                o.x,
                                o.y
                            ], n && Y(o, t1) < Y(r[0], t1) ? r.unshift(o) : r.push(o), n++);
                        }
                        return r;
                    } : "hv" === D || "vh" === D ? $ = function(t1, e1) {
                        var r = [], n = ot(t1), i = ot(e1);
                        return n && i && st(n, i) || (n && r.push(n), i && r.push(i)), r;
                    } : "hvh" === D ? $ = lt(0, et, rt) : "vhv" === D && ($ = lt(1, nt, it)), r = 0; r < j; r++)if (n = H(r)) {
                        for(V = 0, K = null, ft(n), r++; r < j; r++){
                            if (!(h = H(r))) {
                                if (O) continue;
                                break;
                            }
                            if (R && e1.simplify) {
                                var ht = H(r + 1);
                                if (y = Y(h, n), F && (0 === V || V === j - 1) || !(y < G(h, ht) * N)) {
                                    for(g = [
                                        (h[0] - n[0]) / y,
                                        (h[1] - n[1]) / y
                                    ], p = n, x = y, b = w = T = 0, m = !1, a = h, r++; r < t1.length; r++){
                                        if (d = ht, ht = H(r + 1), !d) {
                                            if (O) continue;
                                            break;
                                        }
                                        if (k = (v = [
                                            d[0] - n[0],
                                            d[1] - n[1]
                                        ])[0] * g[1] - v[1] * g[0], w = Math.min(w, k), (T = Math.max(T, k)) - w > G(d, ht)) break;
                                        a = d, (_ = v[0] * g[0] + v[1] * g[1]) > x ? (x = _, h = d, m = !1) : _ < b && (b = _, p = d, m = !0);
                                    }
                                    if (m ? (ft(h), a !== p && ft(p)) : (p !== n && ft(p), a !== h && ft(h)), ft(a), r >= t1.length || !d) break;
                                    ft(d), n = d;
                                }
                            } else ft(h);
                        }
                        K && ct([
                            Z || K[0],
                            J || K[1]
                        ]), B.push(U.slice(0, V));
                    }
                    return B;
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "./constants": 930
            }
        ],
        941: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r) {
                    "spline" === r("line.shape") && r("line.smoothing");
                };
            },
            {}
        ],
        942: [
            function(t1, e1, r) {
                "use strict";
                var n = {
                    tonextx: 1,
                    tonexty: 1,
                    tonext: 1
                };
                e1.exports = function(t1, e1, r) {
                    var i, a, o, s, l, c = {}, u = !1, f = -1, h = 0, p = -1;
                    for(a = 0; a < r.length; a++)(o = (i = r[a][0].trace).stackgroup || "") ? o in c ? l = c[o] : (l = c[o] = h, h++) : i.fill in n && p >= 0 ? l = p : (l = p = h, h++), l < f && (u = !0), i._groupIndex = f = l;
                    var d = r.slice();
                    u && d.sort(function(t1, e1) {
                        var r = t1[0].trace, n = e1[0].trace;
                        return r._groupIndex - n._groupIndex || r.index - n.index;
                    });
                    var m = {};
                    for(a = 0; a < d.length; a++)o = (i = d[a][0].trace).stackgroup || "", !0 === i.visible ? (i._nexttrace = null, i.fill in n && (s = m[o], i._prevtrace = s || null, s && (s._nexttrace = i)), i._ownfill = i.fill && ("tozero" === i.fill.substr(0, 6) || "toself" === i.fill || "to" === i.fill.substr(0, 2) && !i._prevtrace), m[o] = i) : i._prevtrace = i._nexttrace = i._ownfill = null;
                    return d;
                };
            },
            {}
        ],
        943: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric");
                e1.exports = function(t1, e1) {
                    e1 || (e1 = 2);
                    var r = t1.marker, i = r.sizeref || 1, a = r.sizemin || 0, o = "area" === r.sizemode ? function(t1) {
                        return Math.sqrt(t1 / i);
                    } : function(t1) {
                        return t1 / i;
                    };
                    return function(t1) {
                        var r = o(t1 / e1);
                        return n(r) && r > 0 ? Math.max(r, a) : 0;
                    };
                };
            },
            {
                "fast-isnumeric": 190
            }
        ],
        944: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    container: "marker",
                    min: "cmin",
                    max: "cmax"
                };
            },
            {}
        ],
        945: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color"), i = t1("../../components/colorscale/helpers").hasColorscale, a = t1("../../components/colorscale/defaults"), o = t1("./subtypes");
                e1.exports = function(t1, e1, r, s, l, c) {
                    var u = o.isBubble(t1), f = (t1.line || {}).color;
                    (c = c || {}, f && (r = f), l("marker.symbol"), l("marker.opacity", u ? .7 : 1), l("marker.size"), l("marker.color", r), i(t1, "marker") && a(t1, e1, s, l, {
                        prefix: "marker.",
                        cLetter: "c"
                    }), c.noSelect || (l("selected.marker.color"), l("unselected.marker.color"), l("selected.marker.size"), l("unselected.marker.size")), c.noLine || (l("marker.line.color", f && !Array.isArray(f) && e1.marker.color !== f ? f : u ? n.background : n.defaultLine), i(t1, "marker.line") && a(t1, e1, s, l, {
                        prefix: "marker.line.",
                        cLetter: "c"
                    }), l("marker.line.width", u ? 1 : 0)), u && (l("marker.sizeref"), l("marker.sizemin"), l("marker.sizemode")), c.gradient) && "none" !== l("marker.gradient.type") && l("marker.gradient.color");
                };
            },
            {
                "../../components/color": 366,
                "../../components/colorscale/defaults": 376,
                "../../components/colorscale/helpers": 377,
                "./subtypes": 951
            }
        ],
        946: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib").dateTick0, i = t1("../../constants/numerical").ONEWEEK;
                function a(t1, e1) {
                    return n(e1, t1 % i == 0 ? 1 : 0);
                }
                e1.exports = function(t1, e1, r, n, i) {
                    if (i || (i = {
                        x: !0,
                        y: !0
                    }), i.x) {
                        var o = n("xperiod");
                        o && (n("xperiod0", a(o, e1.xcalendar)), n("xperiodalignment"));
                    }
                    if (i.y) {
                        var s = n("yperiod");
                        s && (n("yperiod0", a(s, e1.ycalendar)), n("yperiodalignment"));
                    }
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503
            }
        ],
        947: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../registry"), a = t1("../../lib"), o = a.ensureSingle, s = a.identity, l = t1("../../components/drawing"), c = t1("./subtypes"), u = t1("./line_points"), f = t1("./link_traces"), h = t1("../../lib/polygon").tester;
                function p(t1, e1, r, f, p, d, m) {
                    var g;
                    !function(t1, e1, r, i, o) {
                        var s = r.xaxis, l = r.yaxis, u = n.extent(a.simpleMap(s.range, s.r2c)), f = n.extent(a.simpleMap(l.range, l.r2c)), h = i[0].trace;
                        if (!c.hasMarkers(h)) return;
                        var p = h.marker.maxdisplayed;
                        if (0 === p) return;
                        var d = i.filter(function(t1) {
                            return t1.x >= u[0] && t1.x <= u[1] && t1.y >= f[0] && t1.y <= f[1];
                        }), m = Math.ceil(d.length / p), g = 0;
                        o.forEach(function(t1, r) {
                            var n = t1[0].trace;
                            c.hasMarkers(n) && n.marker.maxdisplayed > 0 && r < e1 && g++;
                        });
                        var v = Math.round(g * m / 3 + Math.floor(g / 3) * m / 7.1);
                        i.forEach(function(t1) {
                            delete t1.vis;
                        }), d.forEach(function(t1, e1) {
                            0 === Math.round((e1 + v) % m) && (t1.vis = !0);
                        });
                    }(0, e1, r, f, p);
                    var v = !!m && m.duration > 0;
                    function y(t1) {
                        return v ? t1.transition() : t1;
                    }
                    var x = r.xaxis, b = r.yaxis, _ = f[0].trace, w = _.line, T = n.select(d), k = o(T, "g", "errorbars"), A = o(T, "g", "lines"), M = o(T, "g", "points"), S = o(T, "g", "text");
                    if (i.getComponentMethod("errorbars", "plot")(t1, k, r, m), !0 === _.visible) {
                        var E, L;
                        y(T).style("opacity", _.opacity);
                        var C = _.fill.charAt(_.fill.length - 1);
                        "x" !== C && "y" !== C && (C = ""), f[0][r.isRangePlot ? "nodeRangePlot3" : "node3"] = T;
                        var P, I, O = "", z = [], D = _._prevtrace;
                        D && (O = D._prevRevpath || "", L = D._nextFill, z = D._polygons);
                        var R, F, B, N, j, U, V, H = "", q = "", G = [], Y = a.noop;
                        if (E = _._ownFill, c.hasLines(_) || "none" !== _.fill) {
                            for(L && L.datum(f), -1 !== [
                                "hv",
                                "vh",
                                "hvh",
                                "vhv"
                            ].indexOf(w.shape) ? (R = l.steps(w.shape), F = l.steps(w.shape.split("").reverse().join(""))) : R = F = "spline" === w.shape ? function(t1) {
                                var e1 = t1[t1.length - 1];
                                return t1.length > 1 && t1[0][0] === e1[0] && t1[0][1] === e1[1] ? l.smoothclosed(t1.slice(1), w.smoothing) : l.smoothopen(t1, w.smoothing);
                            } : function(t1) {
                                return "M" + t1.join("L");
                            }, B = function(t1) {
                                return F(t1.reverse());
                            }, G = u(f, {
                                xaxis: x,
                                yaxis: b,
                                connectGaps: _.connectgaps,
                                baseTolerance: Math.max(w.width || 1, 3) / 4,
                                shape: w.shape,
                                simplify: w.simplify,
                                fill: _.fill
                            }), V = _._polygons = new Array(G.length), g = 0; g < G.length; g++)_._polygons[g] = h(G[g]);
                            G.length && (N = G[0][0], U = (j = G[G.length - 1])[j.length - 1]), Y = function(t1) {
                                return function(e1) {
                                    if (P = R(e1), I = B(e1), H ? C ? (H += "L" + P.substr(1), q = I + "L" + q.substr(1)) : (H += "Z" + P, q = I + "Z" + q) : (H = P, q = I), c.hasLines(_) && e1.length > 1) {
                                        var r = n.select(this);
                                        if (r.datum(f), t1) y(r.style("opacity", 0).attr("d", P).call(l.lineGroupStyle)).style("opacity", 1);
                                        else {
                                            var i = y(r);
                                            i.attr("d", P), l.singleLineStyle(f, i);
                                        }
                                    }
                                };
                            };
                        }
                        var W = A.selectAll(".js-line").data(G);
                        y(W.exit()).style("opacity", 0).remove(), W.each(Y(!1)), W.enter().append("path").classed("js-line", !0).style("vector-effect", "non-scaling-stroke").call(l.lineGroupStyle).each(Y(!0)), l.setClipUrl(W, r.layerClipId, t1), G.length ? (E ? (E.datum(f), N && U && (C ? ("y" === C ? N[1] = U[1] = b.c2p(0, !0) : "x" === C && (N[0] = U[0] = x.c2p(0, !0)), y(E).attr("d", "M" + U + "L" + N + "L" + H.substr(1)).call(l.singleFillStyle)) : y(E).attr("d", H + "Z").call(l.singleFillStyle))) : L && ("tonext" === _.fill.substr(0, 6) && H && O ? ("tonext" === _.fill ? y(L).attr("d", H + "Z" + O + "Z").call(l.singleFillStyle) : y(L).attr("d", H + "L" + O.substr(1) + "Z").call(l.singleFillStyle), _._polygons = _._polygons.concat(z)) : (Z(L), _._polygons = null)), _._prevRevpath = q, _._prevPolygons = V) : (E ? Z(E) : L && Z(L), _._polygons = _._prevRevpath = _._prevPolygons = null), M.datum(f), S.datum(f), function(e1, i, a) {
                            var o, u = a[0].trace, f = c.hasMarkers(u), h = c.hasText(u), p = tt(u), d = et, m = et;
                            if (f || h) {
                                var g = s, _ = u.stackgroup, w = _ && "infer zero" === t1._fullLayout._scatterStackOpts[x._id + b._id][_].stackgaps;
                                u.marker.maxdisplayed || u._needsCull ? g = w ? K : J : _ && !w && (g = Q), f && (d = g), h && (m = g);
                            }
                            var T, k = (o = e1.selectAll("path.point").data(d, p)).enter().append("path").classed("point", !0);
                            v && k.call(l.pointStyle, u, t1).call(l.translatePoints, x, b).style("opacity", 0).transition().style("opacity", 1), o.order(), f && (T = l.makePointStyleFns(u)), o.each(function(e1) {
                                var i = n.select(this), a = y(i);
                                l.translatePoint(e1, a, x, b) ? (l.singlePointStyle(e1, a, u, T, t1), r.layerClipId && l.hideOutsideRangePoint(e1, a, x, b, u.xcalendar, u.ycalendar), u.customdata && i.classed("plotly-customdata", null !== e1.data && void 0 !== e1.data)) : a.remove();
                            }), v ? o.exit().transition().style("opacity", 0).remove() : o.exit().remove(), (o = i.selectAll("g").data(m, p)).enter().append("g").classed("textpoint", !0).append("text"), o.order(), o.each(function(t1) {
                                var e1 = n.select(this), i = y(e1.select("text"));
                                l.translatePoint(t1, i, x, b) ? r.layerClipId && l.hideOutsideRangePoint(t1, e1, x, b, u.xcalendar, u.ycalendar) : e1.remove();
                            }), o.selectAll("text").call(l.textPointStyle, u, t1).each(function(t1) {
                                var e1 = x.c2p(t1.x), r = b.c2p(t1.y);
                                n.select(this).selectAll("tspan.line").each(function() {
                                    y(n.select(this)).attr({
                                        x: e1,
                                        y: r
                                    });
                                });
                            }), o.exit().remove();
                        }(M, S, f);
                        var X = !1 === _.cliponaxis ? null : r.layerClipId;
                        l.setClipUrl(M, X, t1), l.setClipUrl(S, X, t1);
                    }
                    function Z(t1) {
                        y(t1).attr("d", "M0,0Z");
                    }
                    function J(t1) {
                        return t1.filter(function(t1) {
                            return !t1.gap && t1.vis;
                        });
                    }
                    function K(t1) {
                        return t1.filter(function(t1) {
                            return t1.vis;
                        });
                    }
                    function Q(t1) {
                        return t1.filter(function(t1) {
                            return !t1.gap;
                        });
                    }
                    function $(t1) {
                        return t1.id;
                    }
                    function tt(t1) {
                        if (t1.ids) return $;
                    }
                    function et() {
                        return !1;
                    }
                }
                e1.exports = function(t1, e1, r, i, a, c) {
                    var u, h, d = !a, m = !!a && a.duration > 0, g = f(t1, e1, r);
                    ((u = i.selectAll("g.trace").data(g, function(t1) {
                        return t1[0].trace.uid;
                    })).enter().append("g").attr("class", function(t1) {
                        return "trace scatter trace" + t1[0].trace.uid;
                    }).style("stroke-miterlimit", 2), u.order(), function(t1, e1, r) {
                        e1.each(function(e1) {
                            var i = o(n.select(this), "g", "fills");
                            l.setClipUrl(i, r.layerClipId, t1);
                            var a = e1[0].trace, c = [];
                            a._ownfill && c.push("_ownFill"), a._nexttrace && c.push("_nextFill");
                            var u = i.selectAll("g").data(c, s);
                            u.enter().append("g"), u.exit().each(function(t1) {
                                a[t1] = null;
                            }).remove(), u.order().each(function(t1) {
                                a[t1] = o(n.select(this), "path", "js-fill");
                            });
                        });
                    }(t1, u, e1), m) ? (c && (h = c()), n.transition().duration(a.duration).ease(a.easing).each("end", function() {
                        h && h();
                    }).each("interrupt", function() {
                        h && h();
                    }).each(function() {
                        i.selectAll("g.trace").each(function(r, n) {
                            p(t1, n, e1, r, g, this, a);
                        });
                    })) : u.each(function(r, n) {
                        p(t1, n, e1, r, g, this, a);
                    });
                    d && u.exit().remove(), i.selectAll("path:not([d])").remove();
                };
            },
            {
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../lib/polygon": 515,
                "../../registry": 638,
                "./line_points": 940,
                "./link_traces": 942,
                "./subtypes": 951,
                "@plotly/d3": 58
            }
        ],
        948: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./subtypes");
                e1.exports = function(t1, e1) {
                    var r, i, a, o, s = t1.cd, l = t1.xaxis, c = t1.yaxis, u = [], f = s[0].trace;
                    if (!n.hasMarkers(f) && !n.hasText(f)) return [];
                    if (!1 === e1) for(r = 0; r < s.length; r++)s[r].selected = 0;
                    else for(r = 0; r < s.length; r++)i = s[r], a = l.c2p(i.x), o = c.c2p(i.y), null !== i.i && e1.contains([
                        a,
                        o
                    ], !1, r, t1) ? (u.push({
                        pointNumber: i.i,
                        x: l.c2d(i.x),
                        y: c.c2d(i.y)
                    }), i.selected = 1) : i.selected = 0;
                    return u;
                };
            },
            {
                "./subtypes": 951
            }
        ],
        949: [
            function(t1, e1, r) {
                "use strict";
                var n = [
                    "orientation",
                    "groupnorm",
                    "stackgaps"
                ];
                e1.exports = function(t1, e1, r, i) {
                    var a = r._scatterStackOpts, o = i("stackgroup");
                    if (o) {
                        var s = e1.xaxis + e1.yaxis, l = a[s];
                        l || (l = a[s] = {});
                        var c = l[o], u = !1;
                        c ? c.traces.push(e1) : (c = l[o] = {
                            traceIndices: [],
                            traces: [
                                e1
                            ]
                        }, u = !0);
                        for(var f = {
                            orientation: e1.x && !e1.y ? "h" : "v"
                        }, h = 0; h < n.length; h++){
                            var p = n[h], d = p + "Found";
                            if (!c[d]) {
                                var m = void 0 !== t1[p], g = "orientation" === p;
                                if ((m || u) && (c[p] = i(p, f[p]), g && (c.fillDflt = "h" === c[p] ? "tonextx" : "tonexty"), m && (c[d] = !0, !u && (delete c.traces[0][p], g)))) for(var v = 0; v < c.traces.length - 1; v++){
                                    var y = c.traces[v];
                                    y._input.fill !== y.fill && (y.fill = c.fillDflt);
                                }
                            }
                        }
                        return c;
                    }
                };
            },
            {}
        ],
        950: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/drawing"), a = t1("../../registry");
                function o(t1, e1, r) {
                    i.pointStyle(t1.selectAll("path.point"), e1, r);
                }
                function s(t1, e1, r) {
                    i.textPointStyle(t1.selectAll("text"), e1, r);
                }
                e1.exports = {
                    style: function(t1) {
                        var e1 = n.select(t1).selectAll("g.trace.scatter");
                        e1.style("opacity", function(t1) {
                            return t1[0].trace.opacity;
                        }), e1.selectAll("g.points").each(function(e1) {
                            o(n.select(this), e1.trace || e1[0].trace, t1);
                        }), e1.selectAll("g.text").each(function(e1) {
                            s(n.select(this), e1.trace || e1[0].trace, t1);
                        }), e1.selectAll("g.trace path.js-line").call(i.lineGroupStyle), e1.selectAll("g.trace path.js-fill").call(i.fillGroupStyle), a.getComponentMethod("errorbars", "style")(e1);
                    },
                    stylePoints: o,
                    styleText: s,
                    styleOnSelect: function(t1, e1, r) {
                        var n = e1[0].trace;
                        n.selectedpoints ? (i.selectedPointStyle(r.selectAll("path.point"), n), i.selectedTextStyle(r.selectAll("text"), n)) : (o(r, n, t1), s(r, n, t1));
                    }
                };
            },
            {
                "../../components/drawing": 388,
                "../../registry": 638,
                "@plotly/d3": 58
            }
        ],
        951: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = {
                    hasLines: function(t1) {
                        return t1.visible && t1.mode && -1 !== t1.mode.indexOf("lines");
                    },
                    hasMarkers: function(t1) {
                        return t1.visible && (t1.mode && -1 !== t1.mode.indexOf("markers") || "splom" === t1.type);
                    },
                    hasText: function(t1) {
                        return t1.visible && t1.mode && -1 !== t1.mode.indexOf("text");
                    },
                    isBubble: function(t1) {
                        return n.isPlainObject(t1.marker) && n.isArrayOrTypedArray(t1.marker.size);
                    }
                };
            },
            {
                "../../lib": 503
            }
        ],
        952: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = function(t1, e1, r, i, a) {
                    a = a || {}, i("textposition"), n.coerceFont(i, "textfont", r.font), a.noSelect || (i("selected.textfont.color"), i("unselected.textfont.color"));
                };
            },
            {
                "../../lib": 503
            }
        ],
        953: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../registry");
                e1.exports = function(t1, e1, r, a) {
                    var o, s = a("x"), l = a("y");
                    if (i.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                        "x",
                        "y"
                    ], r), s) {
                        var c = n.minRowLength(s);
                        l ? o = Math.min(c, n.minRowLength(l)) : (o = c, a("y0"), a("dy"));
                    } else {
                        if (!l) return 0;
                        o = n.minRowLength(l), a("x0"), a("dx");
                    }
                    return e1._length = o, o;
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638
            }
        ],
        954: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/attributes"), i = t1("../../components/colorscale/attributes"), a = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, o = t1("../../plots/template_attributes").hovertemplateAttrs, s = t1("../../plots/template_attributes").texttemplateAttrs, l = t1("../../plots/attributes"), c = t1("../../constants/gl3d_dashes"), u = t1("../../constants/gl3d_markers"), f = t1("../../lib/extend").extendFlat, h = t1("../../plot_api/edit_types").overrideAll, p = t1("../../lib/sort_object_keys"), d = n.line, m = n.marker, g = m.line, v = f({
                    width: d.width,
                    dash: {
                        valType: "enumerated",
                        values: p(c),
                        dflt: "solid"
                    }
                }, i("line"));
                var y = e1.exports = h({
                    x: n.x,
                    y: n.y,
                    z: {
                        valType: "data_array"
                    },
                    text: f({}, n.text, {}),
                    texttemplate: s({}, {}),
                    hovertext: f({}, n.hovertext, {}),
                    hovertemplate: o(),
                    xhoverformat: a("x"),
                    yhoverformat: a("y"),
                    zhoverformat: a("z"),
                    mode: f({}, n.mode, {
                        dflt: "lines+markers"
                    }),
                    surfaceaxis: {
                        valType: "enumerated",
                        values: [
                            -1,
                            0,
                            1,
                            2
                        ],
                        dflt: -1
                    },
                    surfacecolor: {
                        valType: "color"
                    },
                    projection: {
                        x: {
                            show: {
                                valType: "boolean",
                                dflt: !1
                            },
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            },
                            scale: {
                                valType: "number",
                                min: 0,
                                max: 10,
                                dflt: 2 / 3
                            }
                        },
                        y: {
                            show: {
                                valType: "boolean",
                                dflt: !1
                            },
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            },
                            scale: {
                                valType: "number",
                                min: 0,
                                max: 10,
                                dflt: 2 / 3
                            }
                        },
                        z: {
                            show: {
                                valType: "boolean",
                                dflt: !1
                            },
                            opacity: {
                                valType: "number",
                                min: 0,
                                max: 1,
                                dflt: 1
                            },
                            scale: {
                                valType: "number",
                                min: 0,
                                max: 10,
                                dflt: 2 / 3
                            }
                        }
                    },
                    connectgaps: n.connectgaps,
                    line: v,
                    marker: f({
                        symbol: {
                            valType: "enumerated",
                            values: p(u),
                            dflt: "circle",
                            arrayOk: !0
                        },
                        size: f({}, m.size, {
                            dflt: 8
                        }),
                        sizeref: m.sizeref,
                        sizemin: m.sizemin,
                        sizemode: m.sizemode,
                        opacity: f({}, m.opacity, {
                            arrayOk: !1
                        }),
                        colorbar: m.colorbar,
                        line: f({
                            width: f({}, g.width, {
                                arrayOk: !1
                            })
                        }, i("marker.line"))
                    }, i("marker")),
                    textposition: f({}, n.textposition, {
                        dflt: "top center"
                    }),
                    textfont: {
                        color: n.textfont.color,
                        size: n.textfont.size,
                        family: f({}, n.textfont.family, {
                            arrayOk: !1
                        })
                    },
                    opacity: l.opacity,
                    hoverinfo: f({}, l.hoverinfo)
                }, "calc", "nested");
                y.x.editType = y.y.editType = y.z.editType = "calc+clearAxisTypes";
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../constants/gl3d_dashes": 476,
                "../../constants/gl3d_markers": 477,
                "../../lib/extend": 493,
                "../../lib/sort_object_keys": 526,
                "../../plot_api/edit_types": 536,
                "../../plots/attributes": 550,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/template_attributes": 633,
                "../scatter/attributes": 926
            }
        ],
        955: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/arrays_to_calcdata"), i = t1("../scatter/colorscale_calc");
                e1.exports = function(t1, e1) {
                    var r = [
                        {
                            x: !1,
                            y: !1,
                            trace: e1,
                            t: {}
                        }
                    ];
                    return n(r, e1), i(t1, e1), r;
                };
            },
            {
                "../scatter/arrays_to_calcdata": 925,
                "../scatter/colorscale_calc": 929
            }
        ],
        956: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry");
                function i(t1, e1, r, i) {
                    if (!e1 || !e1.visible) return null;
                    for(var a = n.getComponentMethod("errorbars", "makeComputeError")(e1), o = new Array(t1.length), s = 0; s < t1.length; s++){
                        var l = a(+t1[s], s);
                        if ("log" === i.type) {
                            var c = i.c2l(t1[s]), u = t1[s] - l[0], f = t1[s] + l[1];
                            if (o[s] = [
                                (i.c2l(u, !0) - c) * r,
                                (i.c2l(f, !0) - c) * r
                            ], u > 0) {
                                var h = i.c2l(u);
                                i._lowerLogErrorBound || (i._lowerLogErrorBound = h), i._lowerErrorBound = Math.min(i._lowerLogErrorBound, h);
                            }
                        } else o[s] = [
                            -l[0] * r,
                            l[1] * r
                        ];
                    }
                    return o;
                }
                e1.exports = function(t1, e1, r) {
                    var n = [
                        i(t1.x, t1.error_x, e1[0], r.xaxis),
                        i(t1.y, t1.error_y, e1[1], r.yaxis),
                        i(t1.z, t1.error_z, e1[2], r.zaxis)
                    ], a = function(t1) {
                        for(var e1 = 0; e1 < t1.length; e1++)if (t1[e1]) return t1[e1].length;
                        return 0;
                    }(n);
                    if (0 === a) return null;
                    for(var o = new Array(a), s = 0; s < a; s++){
                        for(var l = [
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                0,
                                0,
                                0
                            ]
                        ], c = 0; c < 3; c++)if (n[c]) for(var u = 0; u < 2; u++)l[u][c] = n[c][s][u];
                        o[s] = l;
                    }
                    return o;
                };
            },
            {
                "../../registry": 638
            }
        ],
        957: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../stackgl_modules").gl_line3d, i = t1("../../../stackgl_modules").gl_scatter3d, a = t1("../../../stackgl_modules").gl_error3d, o = t1("../../../stackgl_modules").gl_mesh3d, s = t1("../../../stackgl_modules").delaunay_triangulate, l = t1("../../lib"), c = t1("../../lib/str2rgbarray"), u = t1("../../lib/gl_format_color").formatColor, f = t1("../scatter/make_bubble_size_func"), h = t1("../../constants/gl3d_dashes"), p = t1("../../constants/gl3d_markers"), d = t1("../../plots/cartesian/axes"), m = t1("../../components/fx/helpers").appendArrayPointValue, g = t1("./calc_errors");
                function v(t1, e1) {
                    this.scene = t1, this.uid = e1, this.linePlot = null, this.scatterPlot = null, this.errorBars = null, this.textMarkers = null, this.delaunayMesh = null, this.color = null, this.mode = "", this.dataPoints = [], this.axesBounds = [
                        [
                            -1 / 0,
                            -1 / 0,
                            -1 / 0
                        ],
                        [
                            1 / 0,
                            1 / 0,
                            1 / 0
                        ]
                    ], this.textLabels = null, this.data = null;
                }
                var y = v.prototype;
                function x(t1) {
                    return null == t1 ? 0 : t1.indexOf("left") > -1 ? -1 : t1.indexOf("right") > -1 ? 1 : 0;
                }
                function b(t1) {
                    return null == t1 ? 0 : t1.indexOf("top") > -1 ? -1 : t1.indexOf("bottom") > -1 ? 1 : 0;
                }
                function _(t1, e1) {
                    return e1(4 * t1);
                }
                function w(t1) {
                    return p[t1];
                }
                function T(t1, e1, r, n, i) {
                    var a = null;
                    if (l.isArrayOrTypedArray(t1)) {
                        a = [];
                        for(var o = 0; o < e1; o++)void 0 === t1[o] ? a[o] = n : a[o] = r(t1[o], i);
                    } else a = r(t1, l.identity);
                    return a;
                }
                function k(t1, e1) {
                    var r, n, i, a, o, s, h = [], p = t1.fullSceneLayout, v = t1.dataScale, y = p.xaxis, k = p.yaxis, A = p.zaxis, M = e1.marker, S = e1.line, E = e1.x || [], L = e1.y || [], C = e1.z || [], P = E.length, I = e1.xcalendar, O = e1.ycalendar, z = e1.zcalendar;
                    for(o = 0; o < P; o++)r = y.d2l(E[o], 0, I) * v[0], n = k.d2l(L[o], 0, O) * v[1], i = A.d2l(C[o], 0, z) * v[2], h[o] = [
                        r,
                        n,
                        i
                    ];
                    if (Array.isArray(e1.text)) s = e1.text;
                    else if (void 0 !== e1.text) for(s = new Array(P), o = 0; o < P; o++)s[o] = e1.text;
                    function D(t1, e1) {
                        var r = p[t1];
                        return d.tickText(r, r.d2l(e1), !0).text;
                    }
                    var R = e1.texttemplate;
                    if (R) {
                        var F = t1.fullLayout._d3locale, B = Array.isArray(R), N = B ? Math.min(R.length, P) : P, j = B ? function(t1) {
                            return R[t1];
                        } : function() {
                            return R;
                        };
                        for(s = new Array(N), o = 0; o < N; o++){
                            var U = {
                                x: E[o],
                                y: L[o],
                                z: C[o]
                            }, V = {
                                xLabel: D("xaxis", E[o]),
                                yLabel: D("yaxis", L[o]),
                                zLabel: D("zaxis", C[o])
                            }, H = {};
                            m(H, e1, o);
                            var q = e1._meta || {};
                            s[o] = l.texttemplateString(j(o), V, F, H, U, q);
                        }
                    }
                    if (a = {
                        position: h,
                        mode: e1.mode,
                        text: s
                    }, "line" in e1 && (a.lineColor = u(S, 1, P), a.lineWidth = S.width, a.lineDashes = S.dash), "marker" in e1) {
                        var G = f(e1);
                        a.scatterColor = u(M, 1, P), a.scatterSize = T(M.size, P, _, 20, G), a.scatterMarker = T(M.symbol, P, w, "\u25cf"), a.scatterLineWidth = M.line.width, a.scatterLineColor = u(M.line, 1, P), a.scatterAngle = 0;
                    }
                    "textposition" in e1 && (a.textOffset = function(t1) {
                        var e1 = [
                            0,
                            0
                        ];
                        if (Array.isArray(t1)) for(var r = 0; r < t1.length; r++)e1[r] = [
                            0,
                            0
                        ], t1[r] && (e1[r][0] = x(t1[r]), e1[r][1] = b(t1[r]));
                        else e1[0] = x(t1), e1[1] = b(t1);
                        return e1;
                    }(e1.textposition), a.textColor = u(e1.textfont, 1, P), a.textSize = T(e1.textfont.size, P, l.identity, 12), a.textFont = e1.textfont.family, a.textAngle = 0);
                    var Y = [
                        "x",
                        "y",
                        "z"
                    ];
                    for(a.project = [
                        !1,
                        !1,
                        !1
                    ], a.projectScale = [
                        1,
                        1,
                        1
                    ], a.projectOpacity = [
                        1,
                        1,
                        1
                    ], o = 0; o < 3; ++o){
                        var W = e1.projection[Y[o]];
                        (a.project[o] = W.show) && (a.projectOpacity[o] = W.opacity, a.projectScale[o] = W.scale);
                    }
                    a.errorBounds = g(e1, v, p);
                    var X = function(t1) {
                        for(var e1 = [
                            0,
                            0,
                            0
                        ], r = [
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                0,
                                0,
                                0
                            ]
                        ], n = [
                            1,
                            1,
                            1
                        ], i = 0; i < 3; i++){
                            var a = t1[i];
                            a && !1 !== a.copy_zstyle && !1 !== t1[2].visible && (a = t1[2]), a && a.visible && (e1[i] = a.width / 2, r[i] = c(a.color), n[i] = a.thickness);
                        }
                        return {
                            capSize: e1,
                            color: r,
                            lineWidth: n
                        };
                    }([
                        e1.error_x,
                        e1.error_y,
                        e1.error_z
                    ]);
                    return a.errorColor = X.color, a.errorLineWidth = X.lineWidth, a.errorCapSize = X.capSize, a.delaunayAxis = e1.surfaceaxis, a.delaunayColor = c(e1.surfacecolor), a;
                }
                function A(t1) {
                    if (l.isArrayOrTypedArray(t1)) {
                        var e1 = t1[0];
                        return l.isArrayOrTypedArray(e1) && (t1 = e1), "rgb(" + t1.slice(0, 3).map(function(t1) {
                            return Math.round(255 * t1);
                        }) + ")";
                    }
                    return null;
                }
                function M(t1) {
                    return l.isArrayOrTypedArray(t1) ? 4 === t1.length && "number" == typeof t1[0] ? A(t1) : t1.map(A) : null;
                }
                y.handlePick = function(t1) {
                    if (t1.object && (t1.object === this.linePlot || t1.object === this.delaunayMesh || t1.object === this.textMarkers || t1.object === this.scatterPlot)) {
                        var e1 = t1.index = t1.data.index;
                        return t1.object.highlight && t1.object.highlight(null), this.scatterPlot && (t1.object = this.scatterPlot, this.scatterPlot.highlight(t1.data)), t1.textLabel = "", this.textLabels && (Array.isArray(this.textLabels) ? (this.textLabels[e1] || 0 === this.textLabels[e1]) && (t1.textLabel = this.textLabels[e1]) : t1.textLabel = this.textLabels), t1.traceCoordinate = [
                            this.data.x[e1],
                            this.data.y[e1],
                            this.data.z[e1]
                        ], !0;
                    }
                }, y.update = function(t1) {
                    var e1, r, l, c, u = this.scene.glplot.gl, f = h.solid;
                    this.data = t1;
                    var p = k(this.scene, t1);
                    "mode" in p && (this.mode = p.mode), "lineDashes" in p && p.lineDashes in h && (f = h[p.lineDashes]), this.color = M(p.scatterColor) || M(p.lineColor), this.dataPoints = p.position, e1 = {
                        gl: this.scene.glplot.gl,
                        position: p.position,
                        color: p.lineColor,
                        lineWidth: p.lineWidth || 1,
                        dashes: f[0],
                        dashScale: f[1],
                        opacity: t1.opacity,
                        connectGaps: t1.connectgaps
                    }, -1 !== this.mode.indexOf("lines") ? this.linePlot ? this.linePlot.update(e1) : (this.linePlot = n(e1), this.linePlot._trace = this, this.scene.glplot.add(this.linePlot)) : this.linePlot && (this.scene.glplot.remove(this.linePlot), this.linePlot.dispose(), this.linePlot = null);
                    var d = t1.opacity;
                    if (t1.marker && t1.marker.opacity && (d *= t1.marker.opacity), r = {
                        gl: this.scene.glplot.gl,
                        position: p.position,
                        color: p.scatterColor,
                        size: p.scatterSize,
                        glyph: p.scatterMarker,
                        opacity: d,
                        orthographic: !0,
                        lineWidth: p.scatterLineWidth,
                        lineColor: p.scatterLineColor,
                        project: p.project,
                        projectScale: p.projectScale,
                        projectOpacity: p.projectOpacity
                    }, -1 !== this.mode.indexOf("markers") ? this.scatterPlot ? this.scatterPlot.update(r) : (this.scatterPlot = i(r), this.scatterPlot._trace = this, this.scatterPlot.highlightScale = 1, this.scene.glplot.add(this.scatterPlot)) : this.scatterPlot && (this.scene.glplot.remove(this.scatterPlot), this.scatterPlot.dispose(), this.scatterPlot = null), c = {
                        gl: this.scene.glplot.gl,
                        position: p.position,
                        glyph: p.text,
                        color: p.textColor,
                        size: p.textSize,
                        angle: p.textAngle,
                        alignment: p.textOffset,
                        font: p.textFont,
                        orthographic: !0,
                        lineWidth: 0,
                        project: !1,
                        opacity: t1.opacity
                    }, this.textLabels = t1.hovertext || t1.text, -1 !== this.mode.indexOf("text") ? this.textMarkers ? this.textMarkers.update(c) : (this.textMarkers = i(c), this.textMarkers._trace = this, this.textMarkers.highlightScale = 1, this.scene.glplot.add(this.textMarkers)) : this.textMarkers && (this.scene.glplot.remove(this.textMarkers), this.textMarkers.dispose(), this.textMarkers = null), l = {
                        gl: this.scene.glplot.gl,
                        position: p.position,
                        color: p.errorColor,
                        error: p.errorBounds,
                        lineWidth: p.errorLineWidth,
                        capSize: p.errorCapSize,
                        opacity: t1.opacity
                    }, this.errorBars ? p.errorBounds ? this.errorBars.update(l) : (this.scene.glplot.remove(this.errorBars), this.errorBars.dispose(), this.errorBars = null) : p.errorBounds && (this.errorBars = a(l), this.errorBars._trace = this, this.scene.glplot.add(this.errorBars)), p.delaunayAxis >= 0) {
                        var m = function(t1, e1, r) {
                            var n, i = (r + 1) % 3, a = (r + 2) % 3, o = [], l = [];
                            for(n = 0; n < t1.length; ++n){
                                var c = t1[n];
                                !isNaN(c[i]) && isFinite(c[i]) && !isNaN(c[a]) && isFinite(c[a]) && (o.push([
                                    c[i],
                                    c[a]
                                ]), l.push(n));
                            }
                            var u = s(o);
                            for(n = 0; n < u.length; ++n)for(var f = u[n], h = 0; h < f.length; ++h)f[h] = l[f[h]];
                            return {
                                positions: t1,
                                cells: u,
                                meshColor: e1
                            };
                        }(p.position, p.delaunayColor, p.delaunayAxis);
                        m.opacity = t1.opacity, this.delaunayMesh ? this.delaunayMesh.update(m) : (m.gl = u, this.delaunayMesh = o(m), this.delaunayMesh._trace = this, this.scene.glplot.add(this.delaunayMesh));
                    } else this.delaunayMesh && (this.scene.glplot.remove(this.delaunayMesh), this.delaunayMesh.dispose(), this.delaunayMesh = null);
                }, y.dispose = function() {
                    this.linePlot && (this.scene.glplot.remove(this.linePlot), this.linePlot.dispose()), this.scatterPlot && (this.scene.glplot.remove(this.scatterPlot), this.scatterPlot.dispose()), this.errorBars && (this.scene.glplot.remove(this.errorBars), this.errorBars.dispose()), this.textMarkers && (this.scene.glplot.remove(this.textMarkers), this.textMarkers.dispose()), this.delaunayMesh && (this.scene.glplot.remove(this.delaunayMesh), this.delaunayMesh.dispose());
                }, e1.exports = function(t1, e1) {
                    var r = new v(t1, e1.uid);
                    return r.update(e1), r;
                };
            },
            {
                "../../../stackgl_modules": 1120,
                "../../components/fx/helpers": 402,
                "../../constants/gl3d_dashes": 476,
                "../../constants/gl3d_markers": 477,
                "../../lib": 503,
                "../../lib/gl_format_color": 499,
                "../../lib/str2rgbarray": 528,
                "../../plots/cartesian/axes": 554,
                "../scatter/make_bubble_size_func": 943,
                "./calc_errors": 956
            }
        ],
        958: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib"), a = t1("../scatter/subtypes"), o = t1("../scatter/marker_defaults"), s = t1("../scatter/line_defaults"), l = t1("../scatter/text_defaults"), c = t1("./attributes");
                e1.exports = function(t1, e1, r, u) {
                    function f(r, n) {
                        return i.coerce(t1, e1, c, r, n);
                    }
                    if (function(t1, e1, r, i) {
                        var a = 0, o = r("x"), s = r("y"), l = r("z");
                        n.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                            "x",
                            "y",
                            "z"
                        ], i), o && s && l && (a = Math.min(o.length, s.length, l.length), e1._length = e1._xlength = e1._ylength = e1._zlength = a);
                        return a;
                    }(t1, e1, f, u)) {
                        f("text"), f("hovertext"), f("hovertemplate"), f("xhoverformat"), f("yhoverformat"), f("zhoverformat"), f("mode"), a.hasLines(e1) && (f("connectgaps"), s(t1, e1, r, u, f)), a.hasMarkers(e1) && o(t1, e1, r, u, f, {
                            noSelect: !0
                        }), a.hasText(e1) && (f("texttemplate"), l(t1, e1, u, f, {
                            noSelect: !0
                        }));
                        var h = (e1.line || {}).color, p = (e1.marker || {}).color;
                        f("surfaceaxis") >= 0 && f("surfacecolor", h || p);
                        for(var d = [
                            "x",
                            "y",
                            "z"
                        ], m = 0; m < 3; ++m){
                            var g = "projection." + d[m];
                            f(g + ".show") && (f(g + ".opacity"), f(g + ".scale"));
                        }
                        var v = n.getComponentMethod("errorbars", "supplyDefaults");
                        v(t1, e1, h || p || r, {
                            axis: "z"
                        }), v(t1, e1, h || p || r, {
                            axis: "y",
                            inherit: "z"
                        }), v(t1, e1, h || p || r, {
                            axis: "x",
                            inherit: "z"
                        });
                    } else e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638,
                "../scatter/line_defaults": 939,
                "../scatter/marker_defaults": 945,
                "../scatter/subtypes": 951,
                "../scatter/text_defaults": 952,
                "./attributes": 954
            }
        ],
        959: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    plot: t1("./convert"),
                    attributes: t1("./attributes"),
                    markerSymbols: t1("../../constants/gl3d_markers"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: [
                        {
                            container: "marker",
                            min: "cmin",
                            max: "cmax"
                        },
                        {
                            container: "line",
                            min: "cmin",
                            max: "cmax"
                        }
                    ],
                    calc: t1("./calc"),
                    moduleType: "trace",
                    name: "scatter3d",
                    basePlotModule: t1("../../plots/gl3d"),
                    categories: [
                        "gl3d",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    meta: {}
                };
            },
            {
                "../../constants/gl3d_markers": 477,
                "../../plots/gl3d": 598,
                "./attributes": 954,
                "./calc": 955,
                "./convert": 957,
                "./defaults": 958
            }
        ],
        960: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/attributes"), i = t1("../../plots/attributes"), a = t1("../../plots/template_attributes").hovertemplateAttrs, o = t1("../../plots/template_attributes").texttemplateAttrs, s = t1("../../components/colorscale/attributes"), l = t1("../../lib/extend").extendFlat, c = n.marker, u = n.line, f = c.line;
                e1.exports = {
                    carpet: {
                        valType: "string",
                        editType: "calc"
                    },
                    a: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    b: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    mode: l({}, n.mode, {
                        dflt: "markers"
                    }),
                    text: l({}, n.text, {}),
                    texttemplate: o({
                        editType: "plot"
                    }, {
                        keys: [
                            "a",
                            "b",
                            "text"
                        ]
                    }),
                    hovertext: l({}, n.hovertext, {}),
                    line: {
                        color: u.color,
                        width: u.width,
                        dash: u.dash,
                        shape: l({}, u.shape, {
                            values: [
                                "linear",
                                "spline"
                            ]
                        }),
                        smoothing: u.smoothing,
                        editType: "calc"
                    },
                    connectgaps: n.connectgaps,
                    fill: l({}, n.fill, {
                        values: [
                            "none",
                            "toself",
                            "tonext"
                        ],
                        dflt: "none"
                    }),
                    fillcolor: n.fillcolor,
                    marker: l({
                        symbol: c.symbol,
                        opacity: c.opacity,
                        maxdisplayed: c.maxdisplayed,
                        size: c.size,
                        sizeref: c.sizeref,
                        sizemin: c.sizemin,
                        sizemode: c.sizemode,
                        line: l({
                            width: f.width,
                            editType: "calc"
                        }, s("marker.line")),
                        gradient: c.gradient,
                        editType: "calc"
                    }, s("marker")),
                    textfont: n.textfont,
                    textposition: n.textposition,
                    selected: n.selected,
                    unselected: n.unselected,
                    hoverinfo: l({}, i.hoverinfo, {
                        flags: [
                            "a",
                            "b",
                            "text",
                            "name"
                        ]
                    }),
                    hoveron: n.hoveron,
                    hovertemplate: a()
                };
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/template_attributes": 633,
                "../scatter/attributes": 926
            }
        ],
        961: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../scatter/colorscale_calc"), a = t1("../scatter/arrays_to_calcdata"), o = t1("../scatter/calc_selection"), s = t1("../scatter/calc").calcMarkerSize, l = t1("../carpet/lookup_carpetid");
                e1.exports = function(t1, e1) {
                    var r = e1._carpetTrace = l(t1, e1);
                    if (r && r.visible && "legendonly" !== r.visible) {
                        var c;
                        e1.xaxis = r.xaxis, e1.yaxis = r.yaxis;
                        var u, f, h = e1._length, p = new Array(h), d = !1;
                        for(c = 0; c < h; c++)if (u = e1.a[c], f = e1.b[c], n(u) && n(f)) {
                            var m = r.ab2xy(+u, +f, !0), g = r.isVisible(+u, +f);
                            g || (d = !0), p[c] = {
                                x: m[0],
                                y: m[1],
                                a: u,
                                b: f,
                                vis: g
                            };
                        } else p[c] = {
                            x: !1,
                            y: !1
                        };
                        return e1._needsCull = d, p[0].carpet = r, p[0].trace = e1, s(e1, h), i(t1, e1), a(p, e1), o(p, e1), p;
                    }
                };
            },
            {
                "../carpet/lookup_carpetid": 708,
                "../scatter/arrays_to_calcdata": 925,
                "../scatter/calc": 927,
                "../scatter/calc_selection": 928,
                "../scatter/colorscale_calc": 929,
                "fast-isnumeric": 190
            }
        ],
        962: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../scatter/constants"), a = t1("../scatter/subtypes"), o = t1("../scatter/marker_defaults"), s = t1("../scatter/line_defaults"), l = t1("../scatter/line_shape_defaults"), c = t1("../scatter/text_defaults"), u = t1("../scatter/fillcolor_defaults"), f = t1("./attributes");
                e1.exports = function(t1, e1, r, h) {
                    function p(r, i) {
                        return n.coerce(t1, e1, f, r, i);
                    }
                    p("carpet"), e1.xaxis = "x", e1.yaxis = "y";
                    var d = p("a"), m = p("b"), g = Math.min(d.length, m.length);
                    if (g) {
                        e1._length = g, p("text"), p("texttemplate"), p("hovertext"), p("mode", g < i.PTS_LINESONLY ? "lines+markers" : "lines"), a.hasLines(e1) && (s(t1, e1, r, h, p), l(t1, e1, p), p("connectgaps")), a.hasMarkers(e1) && o(t1, e1, r, h, p, {
                            gradient: !0
                        }), a.hasText(e1) && c(t1, e1, h, p);
                        var v = [];
                        (a.hasMarkers(e1) || a.hasText(e1)) && (p("marker.maxdisplayed"), v.push("points")), p("fill"), "none" !== e1.fill && (u(t1, e1, r, p), a.hasLines(e1) || l(t1, e1, p)), "tonext" !== e1.fill && "toself" !== e1.fill || v.push("fills"), "fills" !== p("hoveron", v.join("+") || "points") && p("hovertemplate"), n.coerceSelectionMarkerOpacity(e1, p);
                    } else e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../scatter/constants": 930,
                "../scatter/fillcolor_defaults": 934,
                "../scatter/line_defaults": 939,
                "../scatter/line_shape_defaults": 941,
                "../scatter/marker_defaults": 945,
                "../scatter/subtypes": 951,
                "../scatter/text_defaults": 952,
                "./attributes": 960
            }
        ],
        963: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n, i) {
                    var a = n[i];
                    return t1.a = a.a, t1.b = a.b, t1.y = a.y, t1;
                };
            },
            {}
        ],
        964: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    var r = {}, n = e1._carpet, i = n.ab2ij([
                        t1.a,
                        t1.b
                    ]), a = Math.floor(i[0]), o = i[0] - a, s = Math.floor(i[1]), l = i[1] - s, c = n.evalxy([], a, s, o, l);
                    return r.yLabel = c[1].toFixed(3), r;
                };
            },
            {}
        ],
        965: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/hover"), i = t1("../../lib").fillText;
                e1.exports = function(t1, e1, r, a) {
                    var o = n(t1, e1, r, a);
                    if (o && !1 !== o[0].index) {
                        var s = o[0];
                        if (void 0 === s.index) {
                            var l = 1 - s.y0 / t1.ya._length, c = t1.xa._length, u = c * l / 2, f = c - u;
                            return s.x0 = Math.max(Math.min(s.x0, f), u), s.x1 = Math.max(Math.min(s.x1, f), u), o;
                        }
                        var h = s.cd[s.index];
                        s.a = h.a, s.b = h.b, s.xLabelVal = void 0, s.yLabelVal = void 0;
                        var p = s.trace, d = p._carpet, m = p._module.formatLabels(h, p);
                        s.yLabel = m.yLabel, delete s.text;
                        var g = [];
                        if (!p.hovertemplate) {
                            var v = (h.hi || p.hoverinfo).split("+");
                            -1 !== v.indexOf("all") && (v = [
                                "a",
                                "b",
                                "text"
                            ]), -1 !== v.indexOf("a") && y(d.aaxis, h.a), -1 !== v.indexOf("b") && y(d.baxis, h.b), g.push("y: " + s.yLabel), -1 !== v.indexOf("text") && i(h, p, g), s.extraText = g.join("<br>");
                        }
                        return o;
                    }
                    function y(t1, e1) {
                        var r;
                        r = t1.labelprefix && t1.labelprefix.length > 0 ? t1.labelprefix.replace(/ = $/, "") : t1._hovertitle, g.push(r + ": " + e1.toFixed(3) + t1.labelsuffix);
                    }
                };
            },
            {
                "../../lib": 503,
                "../scatter/hover": 937
            }
        ],
        966: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: t1("../scatter/marker_colorbar"),
                    formatLabels: t1("./format_labels"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    style: t1("../scatter/style").style,
                    styleOnSelect: t1("../scatter/style").styleOnSelect,
                    hoverPoints: t1("./hover"),
                    selectPoints: t1("../scatter/select"),
                    eventData: t1("./event_data"),
                    moduleType: "trace",
                    name: "scattercarpet",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "svg",
                        "carpet",
                        "symbols",
                        "showLegend",
                        "carpetDependent",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "../scatter/marker_colorbar": 944,
                "../scatter/select": 948,
                "../scatter/style": 950,
                "./attributes": 960,
                "./calc": 961,
                "./defaults": 962,
                "./event_data": 963,
                "./format_labels": 964,
                "./hover": 965,
                "./plot": 967
            }
        ],
        967: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/plot"), i = t1("../../plots/cartesian/axes"), a = t1("../../components/drawing");
                e1.exports = function(t1, e1, r, o) {
                    var s, l, c, u = r[0][0].carpet, f = {
                        xaxis: i.getFromId(t1, u.xaxis || "x"),
                        yaxis: i.getFromId(t1, u.yaxis || "y"),
                        plot: e1.plot
                    };
                    for(n(t1, f, r, o), s = 0; s < r.length; s++)l = r[s][0].trace, c = o.selectAll("g.trace" + l.uid + " .js-line"), a.setClipUrl(c, r[s][0].carpet._clipPathId, t1);
                };
            },
            {
                "../../components/drawing": 388,
                "../../plots/cartesian/axes": 554,
                "../scatter/plot": 947
            }
        ],
        968: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/template_attributes").hovertemplateAttrs, i = t1("../../plots/template_attributes").texttemplateAttrs, a = t1("../scatter/attributes"), o = t1("../../plots/attributes"), s = t1("../../components/colorscale/attributes"), l = t1("../../components/drawing/attributes").dash, c = t1("../../lib/extend").extendFlat, u = t1("../../plot_api/edit_types").overrideAll, f = a.marker, h = a.line, p = f.line;
                e1.exports = u({
                    lon: {
                        valType: "data_array"
                    },
                    lat: {
                        valType: "data_array"
                    },
                    locations: {
                        valType: "data_array"
                    },
                    locationmode: {
                        valType: "enumerated",
                        values: [
                            "ISO-3",
                            "USA-states",
                            "country names",
                            "geojson-id"
                        ],
                        dflt: "ISO-3"
                    },
                    geojson: {
                        valType: "any",
                        editType: "calc"
                    },
                    featureidkey: {
                        valType: "string",
                        editType: "calc",
                        dflt: "id"
                    },
                    mode: c({}, a.mode, {
                        dflt: "markers"
                    }),
                    text: c({}, a.text, {}),
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: [
                            "lat",
                            "lon",
                            "location",
                            "text"
                        ]
                    }),
                    hovertext: c({}, a.hovertext, {}),
                    textfont: a.textfont,
                    textposition: a.textposition,
                    line: {
                        color: h.color,
                        width: h.width,
                        dash: l
                    },
                    connectgaps: a.connectgaps,
                    marker: c({
                        symbol: f.symbol,
                        opacity: f.opacity,
                        size: f.size,
                        sizeref: f.sizeref,
                        sizemin: f.sizemin,
                        sizemode: f.sizemode,
                        colorbar: f.colorbar,
                        line: c({
                            width: p.width
                        }, s("marker.line")),
                        gradient: f.gradient
                    }, s("marker")),
                    fill: {
                        valType: "enumerated",
                        values: [
                            "none",
                            "toself"
                        ],
                        dflt: "none"
                    },
                    fillcolor: a.fillcolor,
                    selected: a.selected,
                    unselected: a.unselected,
                    hoverinfo: c({}, o.hoverinfo, {
                        flags: [
                            "lon",
                            "lat",
                            "location",
                            "text",
                            "name"
                        ]
                    }),
                    hovertemplate: n()
                }, "calc", "nested");
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../components/drawing/attributes": 387,
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../../plots/attributes": 550,
                "../../plots/template_attributes": 633,
                "../scatter/attributes": 926
            }
        ],
        969: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../constants/numerical").BADNUM, a = t1("../scatter/colorscale_calc"), o = t1("../scatter/arrays_to_calcdata"), s = t1("../scatter/calc_selection"), l = t1("../../lib")._;
                function c(t1) {
                    return t1 && "string" == typeof t1;
                }
                e1.exports = function(t1, e1) {
                    var r, u = Array.isArray(e1.locations), f = u ? e1.locations.length : e1._length, h = new Array(f);
                    r = e1.geojson ? function(t1) {
                        return c(t1) || n(t1);
                    } : c;
                    for(var p = 0; p < f; p++){
                        var d = h[p] = {};
                        if (u) {
                            var m = e1.locations[p];
                            d.loc = r(m) ? m : null;
                        } else {
                            var g = e1.lon[p], v = e1.lat[p];
                            n(g) && n(v) ? d.lonlat = [
                                +g,
                                +v
                            ] : d.lonlat = [
                                i,
                                i
                            ];
                        }
                    }
                    return o(h, e1), a(t1, e1), s(h, e1), f && (h[0].t = {
                        labels: {
                            lat: l(t1, "lat:") + " ",
                            lon: l(t1, "lon:") + " "
                        }
                    }), h;
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../scatter/arrays_to_calcdata": 925,
                "../scatter/calc_selection": 928,
                "../scatter/colorscale_calc": 929,
                "fast-isnumeric": 190
            }
        ],
        970: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../scatter/subtypes"), a = t1("../scatter/marker_defaults"), o = t1("../scatter/line_defaults"), s = t1("../scatter/text_defaults"), l = t1("../scatter/fillcolor_defaults"), c = t1("./attributes");
                e1.exports = function(t1, e1, r, u) {
                    function f(r, i) {
                        return n.coerce(t1, e1, c, r, i);
                    }
                    var h, p = f("locations");
                    if (p && p.length) {
                        var d, m = f("geojson");
                        ("string" == typeof m && "" !== m || n.isPlainObject(m)) && (d = "geojson-id"), "geojson-id" === f("locationmode", d) && f("featureidkey"), h = p.length;
                    } else {
                        var g = f("lon") || [], v = f("lat") || [];
                        h = Math.min(g.length, v.length);
                    }
                    h ? (e1._length = h, f("text"), f("hovertext"), f("hovertemplate"), f("mode"), i.hasLines(e1) && (o(t1, e1, r, u, f), f("connectgaps")), i.hasMarkers(e1) && a(t1, e1, r, u, f, {
                        gradient: !0
                    }), i.hasText(e1) && (f("texttemplate"), s(t1, e1, u, f)), f("fill"), "none" !== e1.fill && l(t1, e1, r, f), n.coerceSelectionMarkerOpacity(e1, f)) : e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../scatter/fillcolor_defaults": 934,
                "../scatter/line_defaults": 939,
                "../scatter/marker_defaults": 945,
                "../scatter/subtypes": 951,
                "../scatter/text_defaults": 952,
                "./attributes": 968
            }
        ],
        971: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n, i) {
                    t1.lon = e1.lon, t1.lat = e1.lat, t1.location = e1.loc ? e1.loc : null;
                    var a = n[i];
                    return a.fIn && a.fIn.properties && (t1.properties = a.fIn.properties), t1;
                };
            },
            {}
        ],
        972: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes");
                e1.exports = function(t1, e1, r) {
                    var i = {}, a = r[e1.geo]._subplot.mockAxis, o = t1.lonlat;
                    return i.lonLabel = n.tickText(a, a.c2l(o[0]), !0).text, i.latLabel = n.tickText(a, a.c2l(o[1]), !0).text, i;
                };
            },
            {
                "../../plots/cartesian/axes": 554
            }
        ],
        973: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/fx"), i = t1("../../constants/numerical").BADNUM, a = t1("../scatter/get_trace_color"), o = t1("../../lib").fillText, s = t1("./attributes");
                e1.exports = function(t1, e1, r) {
                    var l = t1.cd, c = l[0].trace, u = t1.xa, f = t1.ya, h = t1.subplot, p = h.projection.isLonLatOverEdges, d = h.project;
                    if (n.getClosest(l, function(t1) {
                        var n = t1.lonlat;
                        if (n[0] === i) return 1 / 0;
                        if (p(n)) return 1 / 0;
                        var a = d(n), o = d([
                            e1,
                            r
                        ]), s = Math.abs(a[0] - o[0]), l = Math.abs(a[1] - o[1]), c = Math.max(3, t1.mrc || 0);
                        return Math.max(Math.sqrt(s * s + l * l) - c, 1 - 3 / c);
                    }, t1), !1 !== t1.index) {
                        var m = l[t1.index], g = m.lonlat, v = [
                            u.c2p(g),
                            f.c2p(g)
                        ], y = m.mrc || 1;
                        t1.x0 = v[0] - y, t1.x1 = v[0] + y, t1.y0 = v[1] - y, t1.y1 = v[1] + y, t1.loc = m.loc, t1.lon = g[0], t1.lat = g[1];
                        var x = {};
                        x[c.geo] = {
                            _subplot: h
                        };
                        var b = c._module.formatLabels(m, c, x);
                        return t1.lonLabel = b.lonLabel, t1.latLabel = b.latLabel, t1.color = a(c, m), t1.extraText = function(t1, e1, r, n) {
                            if (t1.hovertemplate) return;
                            var i = e1.hi || t1.hoverinfo, a = "all" === i ? s.hoverinfo.flags : i.split("+"), l = -1 !== a.indexOf("location") && Array.isArray(t1.locations), c = -1 !== a.indexOf("lon"), u = -1 !== a.indexOf("lat"), f = -1 !== a.indexOf("text"), h = [];
                            function p(t1) {
                                return t1 + "\xb0";
                            }
                            l ? h.push(e1.loc) : c && u ? h.push("(" + p(r.latLabel) + ", " + p(r.lonLabel) + ")") : c ? h.push(n.lon + p(r.lonLabel)) : u && h.push(n.lat + p(r.latLabel));
                            f && o(e1, t1, h);
                            return h.join("<br>");
                        }(c, m, t1, l[0].t.labels), t1.hovertemplate = c.hovertemplate, [
                            t1
                        ];
                    }
                };
            },
            {
                "../../components/fx": 406,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../scatter/get_trace_color": 936,
                "./attributes": 968
            }
        ],
        974: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: t1("../scatter/marker_colorbar"),
                    formatLabels: t1("./format_labels"),
                    calc: t1("./calc"),
                    calcGeoJSON: t1("./plot").calcGeoJSON,
                    plot: t1("./plot").plot,
                    style: t1("./style"),
                    styleOnSelect: t1("../scatter/style").styleOnSelect,
                    hoverPoints: t1("./hover"),
                    eventData: t1("./event_data"),
                    selectPoints: t1("./select"),
                    moduleType: "trace",
                    name: "scattergeo",
                    basePlotModule: t1("../../plots/geo"),
                    categories: [
                        "geo",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/geo": 589,
                "../scatter/marker_colorbar": 944,
                "../scatter/style": 950,
                "./attributes": 968,
                "./calc": 969,
                "./defaults": 970,
                "./event_data": 971,
                "./format_labels": 972,
                "./hover": 973,
                "./plot": 975,
                "./select": 976,
                "./style": 977
            }
        ],
        975: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../../lib/topojson_utils").getTopojsonFeatures, o = t1("../../lib/geojson_utils"), s = t1("../../lib/geo_location_utils"), l = t1("../../plots/cartesian/autorange").findExtremes, c = t1("../../constants/numerical").BADNUM, u = t1("../scatter/calc").calcMarkerSize, f = t1("../scatter/subtypes"), h = t1("./style");
                e1.exports = {
                    calcGeoJSON: function(t1, e1) {
                        var r, n, i = t1[0].trace, o = e1[i.geo], f = o._subplot, h = i._length;
                        if (Array.isArray(i.locations)) {
                            var p = i.locationmode, d = "geojson-id" === p ? s.extractTraceFeature(t1) : a(i, f.topojson);
                            for(r = 0; r < h; r++){
                                n = t1[r];
                                var m = "geojson-id" === p ? n.fOut : s.locationToFeature(p, n.loc, d);
                                n.lonlat = m ? m.properties.ct : [
                                    c,
                                    c
                                ];
                            }
                        }
                        var g, v, y = {
                            padded: !0
                        };
                        if ("geojson" === o.fitbounds && "geojson-id" === i.locationmode) {
                            var x = s.computeBbox(s.getTraceGeojson(i));
                            g = [
                                x[0],
                                x[2]
                            ], v = [
                                x[1],
                                x[3]
                            ];
                        } else {
                            for(g = new Array(h), v = new Array(h), r = 0; r < h; r++)n = t1[r], g[r] = n.lonlat[0], v[r] = n.lonlat[1];
                            y.ppad = u(i, h);
                        }
                        i._extremes.lon = l(o.lonaxis._ax, g, y), i._extremes.lat = l(o.lataxis._ax, v, y);
                    },
                    plot: function(t1, e1, r) {
                        var a = e1.layers.frontplot.select(".scatterlayer"), s = i.makeTraceGroups(a, r, "trace scattergeo");
                        function l(t1, e1) {
                            t1.lonlat[0] === c && n.select(e1).remove();
                        }
                        s.selectAll("*").remove(), s.each(function(e1) {
                            var r = n.select(this), a = e1[0].trace;
                            if (f.hasLines(a) || "none" !== a.fill) {
                                var s = o.calcTraceToLineCoords(e1), c = "none" !== a.fill ? o.makePolygon(s) : o.makeLine(s);
                                r.selectAll("path.js-line").data([
                                    {
                                        geojson: c,
                                        trace: a
                                    }
                                ]).enter().append("path").classed("js-line", !0).style("stroke-miterlimit", 2);
                            }
                            f.hasMarkers(a) && r.selectAll("path.point").data(i.identity).enter().append("path").classed("point", !0).each(function(t1) {
                                l(t1, this);
                            }), f.hasText(a) && r.selectAll("g").data(i.identity).enter().append("g").append("text").each(function(t1) {
                                l(t1, this);
                            }), h(t1, e1);
                        });
                    }
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../lib/geo_location_utils": 496,
                "../../lib/geojson_utils": 497,
                "../../lib/topojson_utils": 532,
                "../../plots/cartesian/autorange": 553,
                "../scatter/calc": 927,
                "../scatter/subtypes": 951,
                "./style": 977,
                "@plotly/d3": 58
            }
        ],
        976: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/subtypes"), i = t1("../../constants/numerical").BADNUM;
                e1.exports = function(t1, e1) {
                    var r, a, o, s, l, c = t1.cd, u = t1.xaxis, f = t1.yaxis, h = [], p = c[0].trace;
                    if (!n.hasMarkers(p) && !n.hasText(p)) return [];
                    if (!1 === e1) for(l = 0; l < c.length; l++)c[l].selected = 0;
                    else for(l = 0; l < c.length; l++)(a = (r = c[l]).lonlat)[0] !== i && (o = u.c2p(a), s = f.c2p(a), e1.contains([
                        o,
                        s
                    ], null, l, t1) ? (h.push({
                        pointNumber: l,
                        lon: a[0],
                        lat: a[1]
                    }), r.selected = 1) : r.selected = 0);
                    return h;
                };
            },
            {
                "../../constants/numerical": 479,
                "../scatter/subtypes": 951
            }
        ],
        977: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/drawing"), a = t1("../../components/color"), o = t1("../scatter/style"), s = o.stylePoints, l = o.styleText;
                e1.exports = function(t1, e1) {
                    e1 && function(t1, e1) {
                        var r = e1[0].trace, o = e1[0].node3;
                        o.style("opacity", e1[0].trace.opacity), s(o, r, t1), l(o, r, t1), o.selectAll("path.js-line").style("fill", "none").each(function(t1) {
                            var e1 = n.select(this), r = t1.trace, o = r.line || {};
                            e1.call(a.stroke, o.color).call(i.dashLine, o.dash || "", o.width || 0), "none" !== r.fill && e1.call(a.fill, r.fillcolor);
                        });
                    }(t1, e1);
                };
            },
            {
                "../../components/color": 366,
                "../../components/drawing": 388,
                "../scatter/style": 950,
                "@plotly/d3": 58
            }
        ],
        978: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/attributes"), i = t1("../scatter/attributes"), a = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, o = t1("../../components/colorscale/attributes"), s = t1("../../lib/sort_object_keys"), l = t1("../../lib/extend").extendFlat, c = t1("../../plot_api/edit_types").overrideAll, u = t1("./constants").DASHES, f = i.line, h = i.marker, p = h.line, d = e1.exports = c({
                    x: i.x,
                    x0: i.x0,
                    dx: i.dx,
                    y: i.y,
                    y0: i.y0,
                    dy: i.dy,
                    xperiod: i.xperiod,
                    yperiod: i.yperiod,
                    xperiod0: i.xperiod0,
                    yperiod0: i.yperiod0,
                    xperiodalignment: i.xperiodalignment,
                    yperiodalignment: i.yperiodalignment,
                    xhoverformat: a("x"),
                    yhoverformat: a("y"),
                    text: i.text,
                    hovertext: i.hovertext,
                    textposition: i.textposition,
                    textfont: i.textfont,
                    mode: {
                        valType: "flaglist",
                        flags: [
                            "lines",
                            "markers",
                            "text"
                        ],
                        extras: [
                            "none"
                        ]
                    },
                    line: {
                        color: f.color,
                        width: f.width,
                        shape: {
                            valType: "enumerated",
                            values: [
                                "linear",
                                "hv",
                                "vh",
                                "hvh",
                                "vhv"
                            ],
                            dflt: "linear",
                            editType: "plot"
                        },
                        dash: {
                            valType: "enumerated",
                            values: s(u),
                            dflt: "solid"
                        }
                    },
                    marker: l({}, o("marker"), {
                        symbol: h.symbol,
                        size: h.size,
                        sizeref: h.sizeref,
                        sizemin: h.sizemin,
                        sizemode: h.sizemode,
                        opacity: h.opacity,
                        colorbar: h.colorbar,
                        line: l({}, o("marker.line"), {
                            width: p.width
                        })
                    }),
                    connectgaps: i.connectgaps,
                    fill: l({}, i.fill, {
                        dflt: "none"
                    }),
                    fillcolor: i.fillcolor,
                    selected: {
                        marker: i.selected.marker,
                        textfont: i.selected.textfont
                    },
                    unselected: {
                        marker: i.unselected.marker,
                        textfont: i.unselected.textfont
                    },
                    opacity: n.opacity
                }, "calc", "nested");
                d.x.editType = d.y.editType = d.x0.editType = d.y0.editType = "calc+clearAxisTypes", d.hovertemplate = i.hovertemplate, d.texttemplate = i.texttemplate;
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../lib/sort_object_keys": 526,
                "../../plot_api/edit_types": 536,
                "../../plots/attributes": 550,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../scatter/attributes": 926,
                "./constants": 980
            }
        ],
        979: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/point-cluster"), i = t1("../../lib"), a = t1("../../plots/cartesian/axis_ids"), o = t1("../../plots/cartesian/autorange").findExtremes, s = t1("../../plots/cartesian/align_period"), l = t1("../scatter/calc"), c = l.calcMarkerSize, u = l.calcAxisExpansion, f = l.setFirstScatter, h = t1("../scatter/colorscale_calc"), p = t1("./convert"), d = t1("./scene_update"), m = t1("../../constants/numerical").BADNUM, g = t1("./constants").TOO_MANY_POINTS;
                function v(t1, e1, r) {
                    var n = t1._extremes[e1._id], i = o(e1, r._bnds, {
                        padded: !0
                    });
                    n.min = n.min.concat(i.min), n.max = n.max.concat(i.max);
                }
                e1.exports = function(t1, e1) {
                    var r, o = t1._fullLayout, l = a.getFromId(t1, e1.xaxis), y = a.getFromId(t1, e1.yaxis), x = o._plots[e1.xaxis + e1.yaxis], b = e1._length, _ = b >= g, w = 2 * b, T = {}, k = l.makeCalcdata(e1, "x"), A = y.makeCalcdata(e1, "y"), M = s(e1, l, "x", k), S = s(e1, y, "y", A), E = M.vals, L = S.vals;
                    e1._x = E, e1._y = L, e1.xperiodalignment && (e1._origX = k, e1._xStarts = M.starts, e1._xEnds = M.ends), e1.yperiodalignment && (e1._origY = A, e1._yStarts = S.starts, e1._yEnds = S.ends);
                    var C = new Array(w), P = new Array(b);
                    for(r = 0; r < b; r++)C[2 * r] = E[r] === m ? NaN : E[r], C[2 * r + 1] = L[r] === m ? NaN : L[r], P[r] = r;
                    if ("log" === l.type) for(r = 0; r < w; r += 2)C[r] = l.c2l(C[r]);
                    if ("log" === y.type) for(r = 1; r < w; r += 2)C[r] = y.c2l(C[r]);
                    _ && "log" !== l.type && "log" !== y.type ? T.tree = n(C) : T.ids = P, h(t1, e1);
                    var I, O = function(t1, e1, r, n, a, o) {
                        var s = p.style(t1, r);
                        s.marker && (s.marker.positions = n);
                        s.line && n.length > 1 && i.extendFlat(s.line, p.linePositions(t1, r, n));
                        if (s.errorX || s.errorY) {
                            var l = p.errorBarPositions(t1, r, n, a, o);
                            s.errorX && i.extendFlat(s.errorX, l.x), s.errorY && i.extendFlat(s.errorY, l.y);
                        }
                        s.text && (i.extendFlat(s.text, {
                            positions: n
                        }, p.textPosition(t1, r, s.text, s.marker)), i.extendFlat(s.textSel, {
                            positions: n
                        }, p.textPosition(t1, r, s.text, s.markerSel)), i.extendFlat(s.textUnsel, {
                            positions: n
                        }, p.textPosition(t1, r, s.text, s.markerUnsel)));
                        return s;
                    }(t1, 0, e1, C, E, L), z = d(t1, x);
                    return f(o, e1), _ ? O.marker && (I = O.marker.sizeAvg || Math.max(O.marker.size, 3)) : I = c(e1, b), u(t1, e1, l, y, E, L, I), O.errorX && v(e1, l, O.errorX), O.errorY && v(e1, y, O.errorY), O.fill && !z.fill2d && (z.fill2d = !0), O.marker && !z.scatter2d && (z.scatter2d = !0), O.line && !z.line2d && (z.line2d = !0), !O.errorX && !O.errorY || z.error2d || (z.error2d = !0), O.text && !z.glText && (z.glText = !0), O.marker && (O.marker.snap = b), z.lineOptions.push(O.line), z.errorXOptions.push(O.errorX), z.errorYOptions.push(O.errorY), z.fillOptions.push(O.fill), z.markerOptions.push(O.marker), z.markerSelectedOptions.push(O.markerSel), z.markerUnselectedOptions.push(O.markerUnsel), z.textOptions.push(O.text), z.textSelectedOptions.push(O.textSel), z.textUnselectedOptions.push(O.textUnsel), z.selectBatch.push([]), z.unselectBatch.push([]), T._scene = z, T.index = z.count, T.x = E, T.y = L, T.positions = C, z.count++, [
                        {
                            x: !1,
                            y: !1,
                            t: T,
                            trace: e1
                        }
                    ];
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../plots/cartesian/align_period": 551,
                "../../plots/cartesian/autorange": 553,
                "../../plots/cartesian/axis_ids": 558,
                "../scatter/calc": 927,
                "../scatter/colorscale_calc": 929,
                "./constants": 980,
                "./convert": 981,
                "./scene_update": 989,
                "@plotly/point-cluster": 59
            }
        ],
        980: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    TOO_MANY_POINTS: 1e5,
                    SYMBOL_SDF_SIZE: 200,
                    SYMBOL_SIZE: 20,
                    SYMBOL_STROKE: 1,
                    DOT_RE: /-dot/,
                    OPEN_RE: /-open/,
                    DASHES: {
                        solid: [
                            1
                        ],
                        dot: [
                            1,
                            1
                        ],
                        dash: [
                            4,
                            1
                        ],
                        longdash: [
                            8,
                            1
                        ],
                        dashdot: [
                            4,
                            1,
                            1,
                            1
                        ],
                        longdashdot: [
                            8,
                            1,
                            1,
                            1
                        ]
                    }
                };
            },
            {}
        ],
        981: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("svg-path-sdf"), a = t1("color-normalize"), o = t1("../../registry"), s = t1("../../lib"), l = t1("../../components/drawing"), c = t1("../../plots/cartesian/axis_ids"), u = t1("../../lib/gl_format_color").formatColor, f = t1("../scatter/subtypes"), h = t1("../scatter/make_bubble_size_func"), p = t1("./helpers"), d = t1("./constants"), m = t1("../../constants/interactions").DESELECTDIM, g = {
                    start: 1,
                    left: 1,
                    end: -1,
                    right: -1,
                    middle: 0,
                    center: 0,
                    bottom: 1,
                    top: -1
                }, v = t1("../../components/fx/helpers").appendArrayPointValue;
                function y(t1, e1) {
                    var r, i = t1._fullLayout, a = e1._length, o = e1.textfont, l = e1.textposition, c = Array.isArray(l) ? l : [
                        l
                    ], u = o.color, f = o.size, h = o.family, p = {}, d = t1._context.plotGlPixelRatio, m = e1.texttemplate;
                    if (m) {
                        p.text = [];
                        var g = i._d3locale, y = Array.isArray(m), x = y ? Math.min(m.length, a) : a, b = y ? function(t1) {
                            return m[t1];
                        } : function() {
                            return m;
                        };
                        for(r = 0; r < x; r++){
                            var _ = {
                                i: r
                            }, w = e1._module.formatLabels(_, e1, i), T = {};
                            v(T, e1, r);
                            var k = e1._meta || {};
                            p.text.push(s.texttemplateString(b(r), w, g, T, _, k));
                        }
                    } else Array.isArray(e1.text) && e1.text.length < a ? p.text = e1.text.slice() : p.text = e1.text;
                    if (Array.isArray(p.text)) for(r = p.text.length; r < a; r++)p.text[r] = "";
                    for(p.opacity = e1.opacity, p.font = {}, p.align = [], p.baseline = [], r = 0; r < c.length; r++){
                        var A = c[r].split(/\s+/);
                        switch(A[1]){
                            case "left":
                                p.align.push("right");
                                break;
                            case "right":
                                p.align.push("left");
                                break;
                            default:
                                p.align.push(A[1]);
                        }
                        switch(A[0]){
                            case "top":
                                p.baseline.push("bottom");
                                break;
                            case "bottom":
                                p.baseline.push("top");
                                break;
                            default:
                                p.baseline.push(A[0]);
                        }
                    }
                    if (Array.isArray(u)) for(p.color = new Array(a), r = 0; r < a; r++)p.color[r] = u[r];
                    else p.color = u;
                    if (s.isArrayOrTypedArray(f) || Array.isArray(h)) for(p.font = new Array(a), r = 0; r < a; r++){
                        var M = p.font[r] = {};
                        M.size = (s.isTypedArray(f) ? f[r] : Array.isArray(f) ? n(f[r]) ? f[r] : 0 : f) * d, M.family = Array.isArray(h) ? h[r] : h;
                    }
                    else p.font = {
                        size: f * d,
                        family: h
                    };
                    return p;
                }
                function x(t1) {
                    var e1, r, n = t1._length, i = t1.marker, o = {}, l = s.isArrayOrTypedArray(i.symbol), c = s.isArrayOrTypedArray(i.color), f = s.isArrayOrTypedArray(i.line.color), d = s.isArrayOrTypedArray(i.opacity), m = s.isArrayOrTypedArray(i.size), g = s.isArrayOrTypedArray(i.line.width);
                    if (l || (r = p.isOpenSymbol(i.symbol)), l || c || f || d) {
                        o.colors = new Array(n), o.borderColors = new Array(n);
                        var v = u(i, i.opacity, n), y = u(i.line, i.opacity, n);
                        if (!Array.isArray(y[0])) {
                            var x = y;
                            for(y = Array(n), e1 = 0; e1 < n; e1++)y[e1] = x;
                        }
                        if (!Array.isArray(v[0])) {
                            var b = v;
                            for(v = Array(n), e1 = 0; e1 < n; e1++)v[e1] = b;
                        }
                        for(o.colors = v, o.borderColors = y, e1 = 0; e1 < n; e1++){
                            if (l) {
                                var _ = i.symbol[e1];
                                r = p.isOpenSymbol(_);
                            }
                            r && (y[e1] = v[e1].slice(), v[e1] = v[e1].slice(), v[e1][3] = 0);
                        }
                        o.opacity = t1.opacity;
                    } else r ? (o.color = a(i.color, "uint8"), o.color[3] = 0, o.borderColor = a(i.color, "uint8")) : (o.color = a(i.color, "uint8"), o.borderColor = a(i.line.color, "uint8")), o.opacity = t1.opacity * i.opacity;
                    if (l) for(o.markers = new Array(n), e1 = 0; e1 < n; e1++)o.markers[e1] = E(i.symbol[e1]);
                    else o.marker = E(i.symbol);
                    var w, T = h(t1, 1);
                    if (m || g) {
                        var k, A = o.sizes = new Array(n), M = o.borderSizes = new Array(n), S = 0;
                        if (m) {
                            for(e1 = 0; e1 < n; e1++)A[e1] = T(i.size[e1]), S += A[e1];
                            k = S / n;
                        } else for(w = T(i.size), e1 = 0; e1 < n; e1++)A[e1] = w;
                        if (g) for(e1 = 0; e1 < n; e1++)M[e1] = i.line.width[e1];
                        else for(w = i.line.width, e1 = 0; e1 < n; e1++)M[e1] = w;
                        o.sizeAvg = k;
                    } else o.size = T(i && i.size || 10), o.borderSizes = T(i.line.width);
                    return o;
                }
                function b(t1, e1) {
                    var r = t1.marker, n = {};
                    return e1 ? (e1.marker && e1.marker.symbol ? n = x(s.extendFlat({}, r, e1.marker)) : e1.marker && (e1.marker.size && (n.size = e1.marker.size), e1.marker.color && (n.colors = e1.marker.color), void 0 !== e1.marker.opacity && (n.opacity = e1.marker.opacity)), n) : n;
                }
                function _(t1, e1, r) {
                    var n = {};
                    if (!r) return n;
                    if (r.textfont) {
                        var i = {
                            opacity: 1,
                            text: e1.text,
                            texttemplate: e1.texttemplate,
                            textposition: e1.textposition,
                            textfont: s.extendFlat({}, e1.textfont)
                        };
                        r.textfont && s.extendFlat(i.textfont, r.textfont), n = y(t1, i);
                    }
                    return n;
                }
                function w(t1, e1, r) {
                    var n = {
                        capSize: 2 * e1.width * r,
                        lineWidth: e1.thickness * r,
                        color: e1.color
                    };
                    return e1.copy_ystyle && (n = t1.error_y), n;
                }
                var T = d.SYMBOL_SDF_SIZE, k = d.SYMBOL_SIZE, A = d.SYMBOL_STROKE, M = {}, S = l.symbolFuncs[0](.05 * k);
                function E(t1) {
                    if ("circle" === t1) return null;
                    var e1, r, n = l.symbolNumber(t1), a = l.symbolFuncs[n % 100], o = !!l.symbolNoDot[n % 100], s = !!l.symbolNoFill[n % 100], c = p.isDotSymbol(t1);
                    return M[t1] ? M[t1] : (e1 = c && !o ? a(1.1 * k) + S : a(k), r = i(e1, {
                        w: T,
                        h: T,
                        viewBox: [
                            -k,
                            -k,
                            k,
                            k
                        ],
                        stroke: s ? A : -A
                    }), M[t1] = r, r || null);
                }
                e1.exports = {
                    style: function(t1, e1) {
                        var r, n = {
                            marker: void 0,
                            markerSel: void 0,
                            markerUnsel: void 0,
                            line: void 0,
                            fill: void 0,
                            errorX: void 0,
                            errorY: void 0,
                            text: void 0,
                            textSel: void 0,
                            textUnsel: void 0
                        }, i = t1._context.plotGlPixelRatio;
                        if (!0 !== e1.visible) return n;
                        if (f.hasText(e1) && (n.text = y(t1, e1), n.textSel = _(t1, e1, e1.selected), n.textUnsel = _(t1, e1, e1.unselected)), f.hasMarkers(e1) && (n.marker = x(e1), n.markerSel = b(e1, e1.selected), n.markerUnsel = b(e1, e1.unselected), !e1.unselected && s.isArrayOrTypedArray(e1.marker.opacity))) {
                            var a = e1.marker.opacity;
                            for(n.markerUnsel.opacity = new Array(a.length), r = 0; r < a.length; r++)n.markerUnsel.opacity[r] = m * a[r];
                        }
                        if (f.hasLines(e1)) {
                            n.line = {
                                overlay: !0,
                                thickness: e1.line.width * i,
                                color: e1.line.color,
                                opacity: e1.opacity
                            };
                            var o = (d.DASHES[e1.line.dash] || [
                                1
                            ]).slice();
                            for(r = 0; r < o.length; ++r)o[r] *= e1.line.width * i;
                            n.line.dashes = o;
                        }
                        return e1.error_x && e1.error_x.visible && (n.errorX = w(e1, e1.error_x, i)), e1.error_y && e1.error_y.visible && (n.errorY = w(e1, e1.error_y, i)), e1.fill && "none" !== e1.fill && (n.fill = {
                            closed: !0,
                            fill: e1.fillcolor,
                            thickness: 0
                        }), n;
                    },
                    markerStyle: x,
                    markerSelection: b,
                    linePositions: function(t1, e1, r) {
                        var n, i, a = r.length, o = a / 2;
                        if (f.hasLines(e1) && o) {
                            if ("hv" === e1.line.shape) {
                                for(n = [], i = 0; i < o - 1; i++)isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) ? n.push(NaN, NaN, NaN, NaN) : (n.push(r[2 * i], r[2 * i + 1]), isNaN(r[2 * i + 2]) || isNaN(r[2 * i + 3]) ? n.push(NaN, NaN) : n.push(r[2 * i + 2], r[2 * i + 1]));
                                n.push(r[a - 2], r[a - 1]);
                            } else if ("hvh" === e1.line.shape) {
                                for(n = [], i = 0; i < o - 1; i++)if (isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) || isNaN(r[2 * i + 2]) || isNaN(r[2 * i + 3])) isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) ? n.push(NaN, NaN) : n.push(r[2 * i], r[2 * i + 1]), n.push(NaN, NaN);
                                else {
                                    var s = (r[2 * i] + r[2 * i + 2]) / 2;
                                    n.push(r[2 * i], r[2 * i + 1], s, r[2 * i + 1], s, r[2 * i + 3]);
                                }
                                n.push(r[a - 2], r[a - 1]);
                            } else if ("vhv" === e1.line.shape) {
                                for(n = [], i = 0; i < o - 1; i++)if (isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) || isNaN(r[2 * i + 2]) || isNaN(r[2 * i + 3])) isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) ? n.push(NaN, NaN) : n.push(r[2 * i], r[2 * i + 1]), n.push(NaN, NaN);
                                else {
                                    var l = (r[2 * i + 1] + r[2 * i + 3]) / 2;
                                    n.push(r[2 * i], r[2 * i + 1], r[2 * i], l, r[2 * i + 2], l);
                                }
                                n.push(r[a - 2], r[a - 1]);
                            } else if ("vh" === e1.line.shape) {
                                for(n = [], i = 0; i < o - 1; i++)isNaN(r[2 * i]) || isNaN(r[2 * i + 1]) ? n.push(NaN, NaN, NaN, NaN) : (n.push(r[2 * i], r[2 * i + 1]), isNaN(r[2 * i + 2]) || isNaN(r[2 * i + 3]) ? n.push(NaN, NaN) : n.push(r[2 * i], r[2 * i + 3]));
                                n.push(r[a - 2], r[a - 1]);
                            } else n = r;
                        }
                        var c = !1;
                        for(i = 0; i < n.length; i++)if (isNaN(n[i])) {
                            c = !0;
                            break;
                        }
                        var u = c || n.length > d.TOO_MANY_POINTS || f.hasMarkers(e1) ? "rect" : "round";
                        if (c && e1.connectgaps) {
                            var h = n[0], p = n[1];
                            for(i = 0; i < n.length; i += 2)isNaN(n[i]) || isNaN(n[i + 1]) ? (n[i] = h, n[i + 1] = p) : (h = n[i], p = n[i + 1]);
                        }
                        return {
                            join: u,
                            positions: n
                        };
                    },
                    errorBarPositions: function(t1, e1, r, i, a) {
                        var s = o.getComponentMethod("errorbars", "makeComputeError"), l = c.getFromId(t1, e1.xaxis), u = c.getFromId(t1, e1.yaxis), f = r.length / 2, h = {};
                        function p(t1, i) {
                            var a = i._id.charAt(0), o = e1["error_" + a];
                            if (o && o.visible && ("linear" === i.type || "log" === i.type)) {
                                for(var l = s(o), c = {
                                    x: 0,
                                    y: 1
                                }[a], u = {
                                    x: [
                                        0,
                                        1,
                                        2,
                                        3
                                    ],
                                    y: [
                                        2,
                                        3,
                                        0,
                                        1
                                    ]
                                }[a], p = new Float64Array(4 * f), d = 1 / 0, m = -1 / 0, g = 0, v = 0; g < f; g++, v += 4){
                                    var y = t1[g];
                                    if (n(y)) {
                                        var x = r[2 * g + c], b = l(y, g), _ = b[0], w = b[1];
                                        if (n(_) && n(w)) {
                                            var T = y - _, k = y + w;
                                            p[v + u[0]] = x - i.c2l(T), p[v + u[1]] = i.c2l(k) - x, p[v + u[2]] = 0, p[v + u[3]] = 0, d = Math.min(d, y - _), m = Math.max(m, y + w);
                                        }
                                    }
                                }
                                h[a] = {
                                    positions: r,
                                    errors: p,
                                    _bnds: [
                                        d,
                                        m
                                    ]
                                };
                            }
                        }
                        return p(i, l), p(a, u), h;
                    },
                    textPosition: function(t1, e1, r, n) {
                        var i, a = e1._length, o = {};
                        if (f.hasMarkers(e1)) {
                            var s = r.font, l = r.align, c = r.baseline;
                            for(o.offset = new Array(a), i = 0; i < a; i++){
                                var u = n.sizes ? n.sizes[i] : n.size, h = Array.isArray(s) ? s[i].size : s.size, p = Array.isArray(l) ? l.length > 1 ? l[i] : l[0] : l, d = Array.isArray(c) ? c.length > 1 ? c[i] : c[0] : c, m = g[p], v = g[d], y = u ? u / .8 + 1 : 0, x = -v * y - .5 * v;
                                o.offset[i] = [
                                    m * y / h,
                                    x / h
                                ];
                            }
                        }
                        return o;
                    }
                };
            },
            {
                "../../components/drawing": 388,
                "../../components/fx/helpers": 402,
                "../../constants/interactions": 478,
                "../../lib": 503,
                "../../lib/gl_format_color": 499,
                "../../plots/cartesian/axis_ids": 558,
                "../../registry": 638,
                "../scatter/make_bubble_size_func": 943,
                "../scatter/subtypes": 951,
                "./constants": 980,
                "./helpers": 985,
                "color-normalize": 89,
                "fast-isnumeric": 190,
                "svg-path-sdf": 310
            }
        ],
        982: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../registry"), a = t1("./helpers"), o = t1("./attributes"), s = t1("../scatter/constants"), l = t1("../scatter/subtypes"), c = t1("../scatter/xy_defaults"), u = t1("../scatter/period_defaults"), f = t1("../scatter/marker_defaults"), h = t1("../scatter/line_defaults"), p = t1("../scatter/fillcolor_defaults"), d = t1("../scatter/text_defaults");
                e1.exports = function(t1, e1, r, m) {
                    function g(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    var v = !!t1.marker && a.isOpenSymbol(t1.marker.symbol), y = l.isBubble(t1), x = c(t1, e1, m, g);
                    if (x) {
                        u(t1, e1, m, g), g("xhoverformat"), g("yhoverformat");
                        var b = x < s.PTS_LINESONLY ? "lines+markers" : "lines";
                        g("text"), g("hovertext"), g("hovertemplate"), g("mode", b), l.hasLines(e1) && (g("connectgaps"), h(t1, e1, r, m, g), g("line.shape")), l.hasMarkers(e1) && (f(t1, e1, r, m, g), g("marker.line.width", v || y ? 1 : 0)), l.hasText(e1) && (g("texttemplate"), d(t1, e1, m, g));
                        var _ = (e1.line || {}).color, w = (e1.marker || {}).color;
                        g("fill"), "none" !== e1.fill && p(t1, e1, r, g);
                        var T = i.getComponentMethod("errorbars", "supplyDefaults");
                        T(t1, e1, _ || w || r, {
                            axis: "y"
                        }), T(t1, e1, _ || w || r, {
                            axis: "x",
                            inherit: "y"
                        }), n.coerceSelectionMarkerOpacity(e1, g);
                    } else e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638,
                "../scatter/constants": 930,
                "../scatter/fillcolor_defaults": 934,
                "../scatter/line_defaults": 939,
                "../scatter/marker_defaults": 945,
                "../scatter/period_defaults": 946,
                "../scatter/subtypes": 951,
                "../scatter/text_defaults": 952,
                "../scatter/xy_defaults": 953,
                "./attributes": 978,
                "./helpers": 985
            }
        ],
        983: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/color"), a = t1("../../constants/interactions").DESELECTDIM;
                e1.exports = {
                    styleTextSelection: function(t1) {
                        var e1, r, o = t1[0], s = o.trace, l = o.t, c = l._scene, u = l.index, f = c.selectBatch[u], h = c.unselectBatch[u], p = c.textOptions[u], d = c.textSelectedOptions[u] || {}, m = c.textUnselectedOptions[u] || {}, g = n.extendFlat({}, p);
                        if (f.length || h.length) {
                            var v = d.color, y = m.color, x = p.color, b = Array.isArray(x);
                            for(g.color = new Array(s._length), e1 = 0; e1 < f.length; e1++)r = f[e1], g.color[r] = v || (b ? x[r] : x);
                            for(e1 = 0; e1 < h.length; e1++){
                                r = h[e1];
                                var _ = b ? x[r] : x;
                                g.color[r] = y || (v ? _ : i.addOpacity(_, a));
                            }
                        }
                        c.glText[u].update(g);
                    }
                };
            },
            {
                "../../components/color": 366,
                "../../constants/interactions": 478,
                "../../lib": 503
            }
        ],
        984: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/format_labels");
                e1.exports = function(t1, e1, r) {
                    var i = t1.i;
                    return "x" in t1 || (t1.x = e1._x[i]), "y" in t1 || (t1.y = e1._y[i]), n(t1, e1, r);
                };
            },
            {
                "../scatter/format_labels": 935
            }
        ],
        985: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./constants");
                r.isOpenSymbol = function(t1) {
                    return "string" == typeof t1 ? n.OPEN_RE.test(t1) : t1 % 200 > 100;
                }, r.isDotSymbol = function(t1) {
                    return "string" == typeof t1 ? n.DOT_RE.test(t1) : t1 > 200;
                };
            },
            {
                "./constants": 980
            }
        ],
        986: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib"), a = t1("../scatter/get_trace_color");
                function o(t1, e1, r, o) {
                    var s = t1.xa, l = t1.ya, c = t1.distance, u = t1.dxy, f = t1.index, h = {
                        pointNumber: f,
                        x: e1[f],
                        y: r[f]
                    };
                    h.tx = Array.isArray(o.text) ? o.text[f] : o.text, h.htx = Array.isArray(o.hovertext) ? o.hovertext[f] : o.hovertext, h.data = Array.isArray(o.customdata) ? o.customdata[f] : o.customdata, h.tp = Array.isArray(o.textposition) ? o.textposition[f] : o.textposition;
                    var p = o.textfont;
                    p && (h.ts = i.isArrayOrTypedArray(p.size) ? p.size[f] : p.size, h.tc = Array.isArray(p.color) ? p.color[f] : p.color, h.tf = Array.isArray(p.family) ? p.family[f] : p.family);
                    var d = o.marker;
                    d && (h.ms = i.isArrayOrTypedArray(d.size) ? d.size[f] : d.size, h.mo = i.isArrayOrTypedArray(d.opacity) ? d.opacity[f] : d.opacity, h.mx = i.isArrayOrTypedArray(d.symbol) ? d.symbol[f] : d.symbol, h.mc = i.isArrayOrTypedArray(d.color) ? d.color[f] : d.color);
                    var m = d && d.line;
                    m && (h.mlc = Array.isArray(m.color) ? m.color[f] : m.color, h.mlw = i.isArrayOrTypedArray(m.width) ? m.width[f] : m.width);
                    var g = d && d.gradient;
                    g && "none" !== g.type && (h.mgt = Array.isArray(g.type) ? g.type[f] : g.type, h.mgc = Array.isArray(g.color) ? g.color[f] : g.color);
                    var v = s.c2p(h.x, !0), y = l.c2p(h.y, !0), x = h.mrc || 1, b = o.hoverlabel;
                    b && (h.hbg = Array.isArray(b.bgcolor) ? b.bgcolor[f] : b.bgcolor, h.hbc = Array.isArray(b.bordercolor) ? b.bordercolor[f] : b.bordercolor, h.hts = i.isArrayOrTypedArray(b.font.size) ? b.font.size[f] : b.font.size, h.htc = Array.isArray(b.font.color) ? b.font.color[f] : b.font.color, h.htf = Array.isArray(b.font.family) ? b.font.family[f] : b.font.family, h.hnl = i.isArrayOrTypedArray(b.namelength) ? b.namelength[f] : b.namelength);
                    var _ = o.hoverinfo;
                    _ && (h.hi = Array.isArray(_) ? _[f] : _);
                    var w = o.hovertemplate;
                    w && (h.ht = Array.isArray(w) ? w[f] : w);
                    var T = {};
                    T[t1.index] = h;
                    var k = o._origX, A = o._origY, M = i.extendFlat({}, t1, {
                        color: a(o, h),
                        x0: v - x,
                        x1: v + x,
                        xLabelVal: k ? k[f] : h.x,
                        y0: y - x,
                        y1: y + x,
                        yLabelVal: A ? A[f] : h.y,
                        cd: T,
                        distance: c,
                        spikeDistance: u,
                        hovertemplate: h.ht
                    });
                    return h.htx ? M.text = h.htx : h.tx ? M.text = h.tx : o.text && (M.text = o.text), i.fillText(h, o, M), n.getComponentMethod("errorbars", "hoverInfo")(h, o, M), M;
                }
                e1.exports = {
                    hoverPoints: function(t1, e1, r, n) {
                        var i, a, s, l, c, u, f, h, p, d, m = t1.cd, g = m[0].t, v = m[0].trace, y = t1.xa, x = t1.ya, b = g.x, _ = g.y, w = y.c2p(e1), T = x.c2p(r), k = t1.distance;
                        if (g.tree) {
                            var A = y.p2c(w - k), M = y.p2c(w + k), S = x.p2c(T - k), E = x.p2c(T + k);
                            i = "x" === n ? g.tree.range(Math.min(A, M), Math.min(x._rl[0], x._rl[1]), Math.max(A, M), Math.max(x._rl[0], x._rl[1])) : g.tree.range(Math.min(A, M), Math.min(S, E), Math.max(A, M), Math.max(S, E));
                        } else i = g.ids;
                        var L = k;
                        if ("x" === n) {
                            var C = !!v.xperiodalignment, P = !!v.yperiodalignment;
                            for(u = 0; u < i.length; u++){
                                if (l = b[a = i[u]], f = Math.abs(y.c2p(l) - w), C) {
                                    var I = y.c2p(v._xStarts[a]), O = y.c2p(v._xEnds[a]);
                                    f = w >= Math.min(I, O) && w <= Math.max(I, O) ? 0 : 1 / 0;
                                }
                                if (f < L) {
                                    if (L = f, c = _[a], h = x.c2p(c) - T, P) {
                                        var z = x.c2p(v._yStarts[a]), D = x.c2p(v._yEnds[a]);
                                        h = T >= Math.min(z, D) && T <= Math.max(z, D) ? 0 : 1 / 0;
                                    }
                                    d = Math.sqrt(f * f + h * h), s = i[u];
                                }
                            }
                        } else for(u = i.length - 1; u > -1; u--)l = b[a = i[u]], c = _[a], f = y.c2p(l) - w, h = x.c2p(c) - T, (p = Math.sqrt(f * f + h * h)) < L && (L = d = p, s = a);
                        return t1.index = s, t1.distance = L, t1.dxy = d, void 0 === s ? [
                            t1
                        ] : [
                            o(t1, b, _, v)
                        ];
                    },
                    calcHover: o
                };
            },
            {
                "../../lib": 503,
                "../../registry": 638,
                "../scatter/get_trace_color": 936
            }
        ],
        987: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./hover");
                e1.exports = {
                    moduleType: "trace",
                    name: "scattergl",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "gl",
                        "regl",
                        "cartesian",
                        "symbols",
                        "errorBarsOK",
                        "showLegend",
                        "scatter-like"
                    ],
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    crossTraceDefaults: t1("../scatter/cross_trace_defaults"),
                    colorbar: t1("../scatter/marker_colorbar"),
                    formatLabels: t1("./format_labels"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    hoverPoints: n.hoverPoints,
                    selectPoints: t1("./select"),
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "../scatter/cross_trace_defaults": 932,
                "../scatter/marker_colorbar": 944,
                "./attributes": 978,
                "./calc": 979,
                "./defaults": 982,
                "./format_labels": 984,
                "./hover": 986,
                "./plot": 988,
                "./select": 990
            }
        ],
        988: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("regl-scatter2d"), i = t1("regl-line2d"), a = t1("regl-error2d"), o = t1("gl-text"), s = t1("../../lib"), l = t1("../../components/dragelement/helpers").selectMode, c = t1("../../lib/prepare_regl"), u = t1("../scatter/subtypes"), f = t1("../scatter/link_traces"), h = t1("./edit_style").styleTextSelection;
                function p(t1, e1, r, n) {
                    var i = t1._size, a = t1.width * n, o = t1.height * n, s = i.l * n, l = i.b * n, c = i.r * n, u = i.t * n, f = i.w * n, h = i.h * n;
                    return [
                        s + e1.domain[0] * f,
                        l + r.domain[0] * h,
                        a - c - (1 - e1.domain[1]) * f,
                        o - u - (1 - r.domain[1]) * h
                    ];
                }
                e1.exports = function(t1, e1, r) {
                    if (r.length) {
                        var d, m, g = t1._fullLayout, v = e1._scene, y = e1.xaxis, x = e1.yaxis;
                        if (v) {
                            if (c(t1, [
                                "ANGLE_instanced_arrays",
                                "OES_element_index_uint"
                            ])) {
                                var b = v.count, _ = g._glcanvas.data()[0].regl;
                                if (f(t1, e1, r), v.dirty) {
                                    if (!0 === v.error2d && (v.error2d = a(_)), !0 === v.line2d && (v.line2d = i(_)), !0 === v.scatter2d && (v.scatter2d = n(_)), !0 === v.fill2d && (v.fill2d = i(_)), !0 === v.glText) for(v.glText = new Array(b), d = 0; d < b; d++)v.glText[d] = new o(_);
                                    if (v.glText) {
                                        if (b > v.glText.length) {
                                            var w = b - v.glText.length;
                                            for(d = 0; d < w; d++)v.glText.push(new o(_));
                                        } else if (b < v.glText.length) {
                                            var T = v.glText.length - b;
                                            v.glText.splice(b, T).forEach(function(t1) {
                                                t1.destroy();
                                            });
                                        }
                                        for(d = 0; d < b; d++)v.glText[d].update(v.textOptions[d]);
                                    }
                                    if (v.line2d && (v.line2d.update(v.lineOptions), v.lineOptions = v.lineOptions.map(function(t1) {
                                        if (t1 && t1.positions) {
                                            for(var e1 = t1.positions, r = 0; r < e1.length && (isNaN(e1[r]) || isNaN(e1[r + 1]));)r += 2;
                                            for(var n = e1.length - 2; n > r && (isNaN(e1[n]) || isNaN(e1[n + 1]));)n -= 2;
                                            t1.positions = e1.slice(r, n + 2);
                                        }
                                        return t1;
                                    }), v.line2d.update(v.lineOptions)), v.error2d) {
                                        var k = (v.errorXOptions || []).concat(v.errorYOptions || []);
                                        v.error2d.update(k);
                                    }
                                    v.scatter2d && v.scatter2d.update(v.markerOptions), v.fillOrder = s.repeat(null, b), v.fill2d && (v.fillOptions = v.fillOptions.map(function(t1, e1) {
                                        var n = r[e1];
                                        if (t1 && n && n[0] && n[0].trace) {
                                            var i, a, o = n[0], s = o.trace, l = o.t, c = v.lineOptions[e1], u = [];
                                            s._ownfill && u.push(e1), s._nexttrace && u.push(e1 + 1), u.length && (v.fillOrder[e1] = u);
                                            var f, h, p = [], d = c && c.positions || l.positions;
                                            if ("tozeroy" === s.fill) {
                                                for(f = 0; f < d.length && isNaN(d[f + 1]);)f += 2;
                                                for(h = d.length - 2; h > f && isNaN(d[h + 1]);)h -= 2;
                                                0 !== d[f + 1] && (p = [
                                                    d[f],
                                                    0
                                                ]), p = p.concat(d.slice(f, h + 2)), 0 !== d[h + 1] && (p = p.concat([
                                                    d[h],
                                                    0
                                                ]));
                                            } else if ("tozerox" === s.fill) {
                                                for(f = 0; f < d.length && isNaN(d[f]);)f += 2;
                                                for(h = d.length - 2; h > f && isNaN(d[h]);)h -= 2;
                                                0 !== d[f] && (p = [
                                                    0,
                                                    d[f + 1]
                                                ]), p = p.concat(d.slice(f, h + 2)), 0 !== d[h] && (p = p.concat([
                                                    0,
                                                    d[h + 1]
                                                ]));
                                            } else if ("toself" === s.fill || "tonext" === s.fill) {
                                                for(p = [], i = 0, t1.splitNull = !0, a = 0; a < d.length; a += 2)(isNaN(d[a]) || isNaN(d[a + 1])) && ((p = p.concat(d.slice(i, a))).push(d[i], d[i + 1]), p.push(null, null), i = a + 2);
                                                p = p.concat(d.slice(i)), i && p.push(d[i], d[i + 1]);
                                            } else {
                                                var m = s._nexttrace;
                                                if (m) {
                                                    var g = v.lineOptions[e1 + 1];
                                                    if (g) {
                                                        var y = g.positions;
                                                        if ("tonexty" === s.fill) {
                                                            for(p = d.slice(), e1 = Math.floor(y.length / 2); e1--;){
                                                                var x = y[2 * e1], b = y[2 * e1 + 1];
                                                                isNaN(x) || isNaN(b) || p.push(x, b);
                                                            }
                                                            t1.fill = m.fillcolor;
                                                        }
                                                    }
                                                }
                                            }
                                            if (s._prevtrace && "tonext" === s._prevtrace.fill) {
                                                var _ = v.lineOptions[e1 - 1].positions, w = p.length / 2, T = [
                                                    i = w
                                                ];
                                                for(a = 0; a < _.length; a += 2)(isNaN(_[a]) || isNaN(_[a + 1])) && (T.push(a / 2 + w + 1), i = a + 2);
                                                p = p.concat(_), t1.hole = T;
                                            }
                                            return t1.fillmode = s.fill, t1.opacity = s.opacity, t1.positions = p, t1;
                                        }
                                    }), v.fill2d.update(v.fillOptions));
                                }
                                var A = g.dragmode, M = l(A), S = g.clickmode.indexOf("select") > -1;
                                for(d = 0; d < b; d++){
                                    var E = r[d][0], L = E.trace, C = E.t, P = C.index, I = L._length, O = C.x, z = C.y;
                                    if (L.selectedpoints || M || S) {
                                        if (M || (M = !0), L.selectedpoints) {
                                            var D = v.selectBatch[P] = s.selIndices2selPoints(L), R = {};
                                            for(m = 0; m < D.length; m++)R[D[m]] = 1;
                                            var F = [];
                                            for(m = 0; m < I; m++)R[m] || F.push(m);
                                            v.unselectBatch[P] = F;
                                        }
                                        var B = C.xpx = new Array(I), N = C.ypx = new Array(I);
                                        for(m = 0; m < I; m++)B[m] = y.c2p(O[m]), N[m] = x.c2p(z[m]);
                                    } else C.xpx = C.ypx = null;
                                }
                                if (M) {
                                    if (v.select2d || (v.select2d = n(g._glcanvas.data()[1].regl)), v.scatter2d) {
                                        var j = new Array(b);
                                        for(d = 0; d < b; d++)j[d] = v.selectBatch[d].length || v.unselectBatch[d].length ? v.markerUnselectedOptions[d] : {};
                                        v.scatter2d.update(j);
                                    }
                                    v.select2d && (v.select2d.update(v.markerOptions), v.select2d.update(v.markerSelectedOptions)), v.glText && r.forEach(function(t1) {
                                        var e1 = ((t1 || [])[0] || {}).trace || {};
                                        u.hasText(e1) && h(t1);
                                    });
                                } else v.scatter2d && v.scatter2d.update(v.markerOptions);
                                var U = {
                                    viewport: p(g, y, x, t1._context.plotGlPixelRatio),
                                    range: [
                                        (y._rl || y.range)[0],
                                        (x._rl || x.range)[0],
                                        (y._rl || y.range)[1],
                                        (x._rl || x.range)[1]
                                    ]
                                }, V = s.repeat(U, v.count);
                                v.fill2d && v.fill2d.update(V), v.line2d && v.line2d.update(V), v.error2d && v.error2d.update(V.concat(V)), v.scatter2d && v.scatter2d.update(V), v.select2d && v.select2d.update(V), v.glText && v.glText.forEach(function(t1) {
                                    t1.update(U);
                                });
                            } else v.init();
                        }
                    }
                };
            },
            {
                "../../components/dragelement/helpers": 384,
                "../../lib": 503,
                "../../lib/prepare_regl": 516,
                "../scatter/link_traces": 942,
                "../scatter/subtypes": 951,
                "./edit_style": 983,
                "gl-text": 225,
                "regl-error2d": 279,
                "regl-line2d": 280,
                "regl-scatter2d": 281
            }
        ],
        989: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = function(t1, e1) {
                    var r = e1._scene, i = {
                        count: 0,
                        dirty: !0,
                        lineOptions: [],
                        fillOptions: [],
                        markerOptions: [],
                        markerSelectedOptions: [],
                        markerUnselectedOptions: [],
                        errorXOptions: [],
                        errorYOptions: [],
                        textOptions: [],
                        textSelectedOptions: [],
                        textUnselectedOptions: [],
                        selectBatch: [],
                        unselectBatch: []
                    }, a = {
                        fill2d: !1,
                        scatter2d: !1,
                        error2d: !1,
                        line2d: !1,
                        glText: !1,
                        select2d: !1
                    };
                    return e1._scene || ((r = e1._scene = {}).init = function() {
                        n.extendFlat(r, a, i);
                    }, r.init(), r.update = function(t1) {
                        var e1 = n.repeat(t1, r.count);
                        if (r.fill2d && r.fill2d.update(e1), r.scatter2d && r.scatter2d.update(e1), r.line2d && r.line2d.update(e1), r.error2d && r.error2d.update(e1.concat(e1)), r.select2d && r.select2d.update(e1), r.glText) for(var i = 0; i < r.count; i++)r.glText[i].update(t1);
                    }, r.draw = function() {
                        for(var t1 = r.count, e1 = r.fill2d, i = r.error2d, a = r.line2d, o = r.scatter2d, s = r.glText, l = r.select2d, c = r.selectBatch, u = r.unselectBatch, f = 0; f < t1; f++){
                            if (e1 && r.fillOrder[f] && e1.draw(r.fillOrder[f]), a && r.lineOptions[f] && a.draw(f), i && (r.errorXOptions[f] && i.draw(f), r.errorYOptions[f] && i.draw(f + t1)), o && r.markerOptions[f]) {
                                if (u[f].length) {
                                    var h = n.repeat([], r.count);
                                    h[f] = u[f], o.draw(h);
                                } else c[f].length || o.draw(f);
                            }
                            s[f] && r.textOptions[f] && s[f].render();
                        }
                        l && l.draw(c), r.dirty = !1;
                    }, r.destroy = function() {
                        r.fill2d && r.fill2d.destroy && r.fill2d.destroy(), r.scatter2d && r.scatter2d.destroy && r.scatter2d.destroy(), r.error2d && r.error2d.destroy && r.error2d.destroy(), r.line2d && r.line2d.destroy && r.line2d.destroy(), r.select2d && r.select2d.destroy && r.select2d.destroy(), r.glText && r.glText.forEach(function(t1) {
                            t1.destroy && t1.destroy();
                        }), r.lineOptions = null, r.fillOptions = null, r.markerOptions = null, r.markerSelectedOptions = null, r.markerUnselectedOptions = null, r.errorXOptions = null, r.errorYOptions = null, r.textOptions = null, r.textSelectedOptions = null, r.textUnselectedOptions = null, r.selectBatch = null, r.unselectBatch = null, e1._scene = null;
                    }), r.dirty || n.extendFlat(r, i), r;
                };
            },
            {
                "../../lib": 503
            }
        ],
        990: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/subtypes"), i = t1("./edit_style").styleTextSelection;
                e1.exports = function(t1, e1) {
                    var r = t1.cd, a = t1.xaxis, o = t1.yaxis, s = [], l = r[0].trace, c = r[0].t, u = l._length, f = c.x, h = c.y, p = c._scene, d = c.index;
                    if (!p) return s;
                    var m = n.hasText(l), g = n.hasMarkers(l), v = !g && !m;
                    if (!0 !== l.visible || v) return s;
                    var y = [], x = [];
                    if (!1 !== e1 && !e1.degenerate) for(var b = 0; b < u; b++)e1.contains([
                        c.xpx[b],
                        c.ypx[b]
                    ], !1, b, t1) ? (y.push(b), s.push({
                        pointNumber: b,
                        x: a.c2d(f[b]),
                        y: o.c2d(h[b])
                    })) : x.push(b);
                    if (g) {
                        var _ = p.scatter2d;
                        if (y.length || x.length) {
                            if (!p.selectBatch[d].length && !p.unselectBatch[d].length) {
                                var w = new Array(p.count);
                                w[d] = p.markerUnselectedOptions[d], _.update.apply(_, w);
                            }
                        } else {
                            var T = new Array(p.count);
                            T[d] = p.markerOptions[d], _.update.apply(_, T);
                        }
                    }
                    return p.selectBatch[d] = y, p.unselectBatch[d] = x, m && i(r), s;
                };
            },
            {
                "../scatter/subtypes": 951,
                "./edit_style": 983
            }
        ],
        991: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/template_attributes").hovertemplateAttrs, i = t1("../../plots/template_attributes").texttemplateAttrs, a = t1("../scattergeo/attributes"), o = t1("../scatter/attributes"), s = t1("../../plots/mapbox/layout_attributes"), l = t1("../../plots/attributes"), c = t1("../../components/colorscale/attributes"), u = t1("../../lib/extend").extendFlat, f = t1("../../plot_api/edit_types").overrideAll, h = a.line, p = a.marker;
                e1.exports = f({
                    lon: a.lon,
                    lat: a.lat,
                    mode: u({}, o.mode, {
                        dflt: "markers"
                    }),
                    text: u({}, o.text, {}),
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: [
                            "lat",
                            "lon",
                            "text"
                        ]
                    }),
                    hovertext: u({}, o.hovertext, {}),
                    line: {
                        color: h.color,
                        width: h.width
                    },
                    connectgaps: o.connectgaps,
                    marker: u({
                        symbol: {
                            valType: "string",
                            dflt: "circle",
                            arrayOk: !0
                        },
                        angle: {
                            valType: "number",
                            dflt: "auto",
                            arrayOk: !0
                        },
                        allowoverlap: {
                            valType: "boolean",
                            dflt: !1
                        },
                        opacity: p.opacity,
                        size: p.size,
                        sizeref: p.sizeref,
                        sizemin: p.sizemin,
                        sizemode: p.sizemode
                    }, c("marker")),
                    fill: a.fill,
                    fillcolor: o.fillcolor,
                    textfont: s.layers.symbol.textfont,
                    textposition: s.layers.symbol.textposition,
                    below: {
                        valType: "string"
                    },
                    selected: {
                        marker: o.selected.marker
                    },
                    unselected: {
                        marker: o.unselected.marker
                    },
                    hoverinfo: u({}, l.hoverinfo, {
                        flags: [
                            "lon",
                            "lat",
                            "text",
                            "name"
                        ]
                    }),
                    hovertemplate: n()
                }, "calc", "nested");
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../../plots/attributes": 550,
                "../../plots/mapbox/layout_attributes": 615,
                "../../plots/template_attributes": 633,
                "../scatter/attributes": 926,
                "../scattergeo/attributes": 968
            }
        ],
        992: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../lib"), a = t1("../../constants/numerical").BADNUM, o = t1("../../lib/geojson_utils"), s = t1("../../components/colorscale"), l = t1("../../components/drawing"), c = t1("../scatter/make_bubble_size_func"), u = t1("../scatter/subtypes"), f = t1("../../plots/mapbox/convert_text_opts"), h = t1("../../components/fx/helpers").appendArrayPointValue, p = t1("../../lib/svg_text_utils").NEWLINES, d = t1("../../lib/svg_text_utils").BR_TAG_ALL;
                function m() {
                    return {
                        geojson: o.makeBlank(),
                        layout: {
                            visibility: "none"
                        },
                        paint: {}
                    };
                }
                function g(t1, e1) {
                    return i.isArrayOrTypedArray(t1) ? e1 ? function(e1) {
                        return n(t1[e1]) ? +t1[e1] : 0;
                    } : function(e1) {
                        return t1[e1];
                    } : t1 ? function() {
                        return t1;
                    } : v;
                }
                function v() {
                    return "";
                }
                function y(t1) {
                    return t1[0] === a;
                }
                e1.exports = function(t1, e1) {
                    var r, a = e1[0].trace, x = !0 === a.visible && 0 !== a._length, b = "none" !== a.fill, _ = u.hasLines(a), w = u.hasMarkers(a), T = u.hasText(a), k = w && "circle" === a.marker.symbol, A = w && "circle" !== a.marker.symbol, M = m(), S = m(), E = m(), L = m(), C = {
                        fill: M,
                        line: S,
                        circle: E,
                        symbol: L
                    };
                    if (!x) return C;
                    if ((b || _) && (r = o.calcTraceToLineCoords(e1)), b && (M.geojson = o.makePolygon(r), M.layout.visibility = "visible", i.extendFlat(M.paint, {
                        "fill-color": a.fillcolor
                    })), _ && (S.geojson = o.makeLine(r), S.layout.visibility = "visible", i.extendFlat(S.paint, {
                        "line-width": a.line.width,
                        "line-color": a.line.color,
                        "line-opacity": a.opacity
                    })), k) {
                        var P = function(t1) {
                            var e1, r, a, o, u = t1[0].trace, f = u.marker, h = u.selectedpoints, p = i.isArrayOrTypedArray(f.color), d = i.isArrayOrTypedArray(f.size), m = i.isArrayOrTypedArray(f.opacity);
                            function g(t1) {
                                return u.opacity * t1;
                            }
                            p && (r = s.hasColorscale(u, "marker") ? s.makeColorScaleFuncFromTrace(f) : i.identity);
                            d && (a = c(u));
                            m && (o = function(t1) {
                                return g(n(t1) ? +i.constrain(t1, 0, 1) : 0);
                            });
                            var v, x = [];
                            for(e1 = 0; e1 < t1.length; e1++){
                                var b = t1[e1], _ = b.lonlat;
                                if (!y(_)) {
                                    var w = {};
                                    r && (w.mcc = b.mcc = r(b.mc)), a && (w.mrc = b.mrc = a(b.ms)), o && (w.mo = o(b.mo)), h && (w.selected = b.selected || 0), x.push({
                                        type: "Feature",
                                        geometry: {
                                            type: "Point",
                                            coordinates: _
                                        },
                                        properties: w
                                    });
                                }
                            }
                            if (h) for(v = l.makeSelectedPointStyleFns(u), e1 = 0; e1 < x.length; e1++){
                                var T = x[e1].properties;
                                v.selectedOpacityFn && (T.mo = g(v.selectedOpacityFn(T))), v.selectedColorFn && (T.mcc = v.selectedColorFn(T)), v.selectedSizeFn && (T.mrc = v.selectedSizeFn(T));
                            }
                            var k;
                            return {
                                geojson: {
                                    type: "FeatureCollection",
                                    features: x
                                },
                                mcc: p || v && v.selectedColorFn ? {
                                    type: "identity",
                                    property: "mcc"
                                } : f.color,
                                mrc: d || v && v.selectedSizeFn ? {
                                    type: "identity",
                                    property: "mrc"
                                } : (k = f.size, k / 2),
                                mo: m || v && v.selectedOpacityFn ? {
                                    type: "identity",
                                    property: "mo"
                                } : g(f.opacity)
                            };
                        }(e1);
                        E.geojson = P.geojson, E.layout.visibility = "visible", i.extendFlat(E.paint, {
                            "circle-color": P.mcc,
                            "circle-radius": P.mrc,
                            "circle-opacity": P.mo
                        });
                    }
                    if ((A || T) && (L.geojson = function(t1, e1) {
                        for(var r = e1._fullLayout, n = t1[0].trace, a = n.marker || {}, o = a.symbol, s = a.angle, l = "circle" !== o ? g(o) : v, c = "auto" !== s ? g(s, !0) : v, f = u.hasText(n) ? g(n.text) : v, m = [], x = 0; x < t1.length; x++){
                            var b = t1[x];
                            if (!y(b.lonlat)) {
                                var _, w = n.texttemplate;
                                if (w) {
                                    var T = Array.isArray(w) ? w[x] || "" : w, k = n._module.formatLabels(b, n, r), A = {};
                                    h(A, n, b.i);
                                    var M = n._meta || {};
                                    _ = i.texttemplateString(T, k, r._d3locale, A, b, M);
                                } else _ = f(x);
                                _ && (_ = _.replace(p, "").replace(d, "\n")), m.push({
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: b.lonlat
                                    },
                                    properties: {
                                        symbol: l(x),
                                        angle: c(x),
                                        text: _
                                    }
                                });
                            }
                        }
                        return {
                            type: "FeatureCollection",
                            features: m
                        };
                    }(e1, t1), i.extendFlat(L.layout, {
                        visibility: "visible",
                        "icon-image": "{symbol}-15",
                        "text-field": "{text}"
                    }), A && (i.extendFlat(L.layout, {
                        "icon-size": a.marker.size / 10
                    }), "angle" in a.marker && "auto" !== a.marker.angle && i.extendFlat(L.layout, {
                        "icon-rotate": {
                            type: "identity",
                            property: "angle"
                        },
                        "icon-rotation-alignment": "map"
                    }), L.layout["icon-allow-overlap"] = a.marker.allowoverlap, i.extendFlat(L.paint, {
                        "icon-opacity": a.opacity * a.marker.opacity,
                        "icon-color": a.marker.color
                    })), T)) {
                        var I = (a.marker || {}).size, O = f(a.textposition, I);
                        i.extendFlat(L.layout, {
                            "text-size": a.textfont.size,
                            "text-anchor": O.anchor,
                            "text-offset": O.offset
                        }), i.extendFlat(L.paint, {
                            "text-color": a.textfont.color,
                            "text-opacity": a.opacity
                        });
                    }
                    return C;
                };
            },
            {
                "../../components/colorscale": 378,
                "../../components/drawing": 388,
                "../../components/fx/helpers": 402,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../lib/geojson_utils": 497,
                "../../lib/svg_text_utils": 529,
                "../../plots/mapbox/convert_text_opts": 612,
                "../scatter/make_bubble_size_func": 943,
                "../scatter/subtypes": 951,
                "fast-isnumeric": 190
            }
        ],
        993: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../scatter/subtypes"), a = t1("../scatter/marker_defaults"), o = t1("../scatter/line_defaults"), s = t1("../scatter/text_defaults"), l = t1("../scatter/fillcolor_defaults"), c = t1("./attributes");
                e1.exports = function(t1, e1, r, u) {
                    function f(r, i) {
                        return n.coerce(t1, e1, c, r, i);
                    }
                    if (function(t1, e1, r) {
                        var n = r("lon") || [], i = r("lat") || [], a = Math.min(n.length, i.length);
                        return e1._length = a, a;
                    }(0, e1, f)) {
                        if (f("text"), f("texttemplate"), f("hovertext"), f("hovertemplate"), f("mode"), f("below"), i.hasLines(e1) && (o(t1, e1, r, u, f, {
                            noDash: !0
                        }), f("connectgaps")), i.hasMarkers(e1)) {
                            a(t1, e1, r, u, f, {
                                noLine: !0
                            }), f("marker.allowoverlap"), f("marker.angle");
                            var h = e1.marker;
                            "circle" !== h.symbol && (n.isArrayOrTypedArray(h.size) && (h.size = h.size[0]), n.isArrayOrTypedArray(h.color) && (h.color = h.color[0]));
                        }
                        i.hasText(e1) && s(t1, e1, u, f, {
                            noSelect: !0
                        }), f("fill"), "none" !== e1.fill && l(t1, e1, r, f), n.coerceSelectionMarkerOpacity(e1, f);
                    } else e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../scatter/fillcolor_defaults": 934,
                "../scatter/line_defaults": 939,
                "../scatter/marker_defaults": 945,
                "../scatter/subtypes": 951,
                "../scatter/text_defaults": 952,
                "./attributes": 991
            }
        ],
        994: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    return t1.lon = e1.lon, t1.lat = e1.lat, t1;
                };
            },
            {}
        ],
        995: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes");
                e1.exports = function(t1, e1, r) {
                    var i = {}, a = r[e1.subplot]._subplot.mockAxis, o = t1.lonlat;
                    return i.lonLabel = n.tickText(a, a.c2l(o[0]), !0).text, i.latLabel = n.tickText(a, a.c2l(o[1]), !0).text, i;
                };
            },
            {
                "../../plots/cartesian/axes": 554
            }
        ],
        996: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/fx"), i = t1("../../lib"), a = t1("../scatter/get_trace_color"), o = i.fillText, s = t1("../../constants/numerical").BADNUM;
                function l(t1, e1, r) {
                    if (!t1.hovertemplate) {
                        var n = (e1.hi || t1.hoverinfo).split("+"), i = -1 !== n.indexOf("all"), a = -1 !== n.indexOf("lon"), s = -1 !== n.indexOf("lat"), l = e1.lonlat, c = [];
                        return i || a && s ? c.push("(" + u(l[1]) + ", " + u(l[0]) + ")") : a ? c.push(r.lon + u(l[0])) : s && c.push(r.lat + u(l[1])), (i || -1 !== n.indexOf("text")) && o(e1, t1, c), c.join("<br>");
                    }
                    function u(t1) {
                        return t1 + "\xb0";
                    }
                }
                e1.exports = {
                    hoverPoints: function(t1, e1, r) {
                        var o = t1.cd, c = o[0].trace, u = t1.xa, f = t1.ya, h = t1.subplot, p = 360 * (e1 >= 0 ? Math.floor((e1 + 180) / 360) : Math.ceil((e1 - 180) / 360)), d = e1 - p;
                        if (n.getClosest(o, function(t1) {
                            var e1 = t1.lonlat;
                            if (e1[0] === s) return 1 / 0;
                            var n = i.modHalf(e1[0], 360), a = e1[1], o = h.project([
                                n,
                                a
                            ]), l = o.x - u.c2p([
                                d,
                                a
                            ]), c = o.y - f.c2p([
                                n,
                                r
                            ]), p = Math.max(3, t1.mrc || 0);
                            return Math.max(Math.sqrt(l * l + c * c) - p, 1 - 3 / p);
                        }, t1), !1 !== t1.index) {
                            var m = o[t1.index], g = m.lonlat, v = [
                                i.modHalf(g[0], 360) + p,
                                g[1]
                            ], y = u.c2p(v), x = f.c2p(v), b = m.mrc || 1;
                            t1.x0 = y - b, t1.x1 = y + b, t1.y0 = x - b, t1.y1 = x + b;
                            var _ = {};
                            _[c.subplot] = {
                                _subplot: h
                            };
                            var w = c._module.formatLabels(m, c, _);
                            return t1.lonLabel = w.lonLabel, t1.latLabel = w.latLabel, t1.color = a(c, m), t1.extraText = l(c, m, o[0].t.labels), t1.hovertemplate = c.hovertemplate, [
                                t1
                            ];
                        }
                    },
                    getExtraText: l
                };
            },
            {
                "../../components/fx": 406,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../scatter/get_trace_color": 936
            }
        ],
        997: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: t1("../scatter/marker_colorbar"),
                    formatLabels: t1("./format_labels"),
                    calc: t1("../scattergeo/calc"),
                    plot: t1("./plot"),
                    hoverPoints: t1("./hover").hoverPoints,
                    eventData: t1("./event_data"),
                    selectPoints: t1("./select"),
                    styleOnSelect: function(t1, e1) {
                        e1 && e1[0].trace._glTrace.update(e1);
                    },
                    moduleType: "trace",
                    name: "scattermapbox",
                    basePlotModule: t1("../../plots/mapbox"),
                    categories: [
                        "mapbox",
                        "gl",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/mapbox": 613,
                "../scatter/marker_colorbar": 944,
                "../scattergeo/calc": 969,
                "./attributes": 991,
                "./defaults": 993,
                "./event_data": 994,
                "./format_labels": 995,
                "./hover": 996,
                "./plot": 998,
                "./select": 999
            }
        ],
        998: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./convert"), i = t1("../../plots/mapbox/constants").traceLayerPrefix, a = [
                    "fill",
                    "line",
                    "circle",
                    "symbol"
                ];
                function o(t1, e1) {
                    this.type = "scattermapbox", this.subplot = t1, this.uid = e1, this.sourceIds = {
                        fill: "source-" + e1 + "-fill",
                        line: "source-" + e1 + "-line",
                        circle: "source-" + e1 + "-circle",
                        symbol: "source-" + e1 + "-symbol"
                    }, this.layerIds = {
                        fill: i + e1 + "-fill",
                        line: i + e1 + "-line",
                        circle: i + e1 + "-circle",
                        symbol: i + e1 + "-symbol"
                    }, this.below = null;
                }
                var s = o.prototype;
                s.addSource = function(t1, e1) {
                    this.subplot.map.addSource(this.sourceIds[t1], {
                        type: "geojson",
                        data: e1.geojson
                    });
                }, s.setSourceData = function(t1, e1) {
                    this.subplot.map.getSource(this.sourceIds[t1]).setData(e1.geojson);
                }, s.addLayer = function(t1, e1, r) {
                    this.subplot.addLayer({
                        type: t1,
                        id: this.layerIds[t1],
                        source: this.sourceIds[t1],
                        layout: e1.layout,
                        paint: e1.paint
                    }, r);
                }, s.update = function(t1) {
                    var e1, r, i, o = this.subplot, s = o.map, l = n(o.gd, t1), c = o.belowLookup["trace-" + this.uid];
                    if (c !== this.below) {
                        for(e1 = a.length - 1; e1 >= 0; e1--)r = a[e1], s.removeLayer(this.layerIds[r]);
                        for(e1 = 0; e1 < a.length; e1++)i = l[r = a[e1]], this.addLayer(r, i, c);
                        this.below = c;
                    }
                    for(e1 = 0; e1 < a.length; e1++)i = l[r = a[e1]], o.setOptions(this.layerIds[r], "setLayoutProperty", i.layout), "visible" === i.layout.visibility && (this.setSourceData(r, i), o.setOptions(this.layerIds[r], "setPaintProperty", i.paint));
                    t1[0].trace._glTrace = this;
                }, s.dispose = function() {
                    for(var t1 = this.subplot.map, e1 = a.length - 1; e1 >= 0; e1--){
                        var r = a[e1];
                        t1.removeLayer(this.layerIds[r]), t1.removeSource(this.sourceIds[r]);
                    }
                }, e1.exports = function(t1, e1) {
                    for(var r = e1[0].trace, i = new o(t1, r.uid), s = n(t1.gd, e1), l = i.below = t1.belowLookup["trace-" + r.uid], c = 0; c < a.length; c++){
                        var u = a[c], f = s[u];
                        i.addSource(u, f), i.addLayer(u, f, l);
                    }
                    return e1[0].trace._glTrace = i, i;
                };
            },
            {
                "../../plots/mapbox/constants": 611,
                "./convert": 992
            }
        ],
        999: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../scatter/subtypes"), a = t1("../../constants/numerical").BADNUM;
                e1.exports = function(t1, e1) {
                    var r, o = t1.cd, s = t1.xaxis, l = t1.yaxis, c = [], u = o[0].trace;
                    if (!i.hasMarkers(u)) return [];
                    if (!1 === e1) for(r = 0; r < o.length; r++)o[r].selected = 0;
                    else for(r = 0; r < o.length; r++){
                        var f = o[r], h = f.lonlat;
                        if (h[0] !== a) {
                            var p = [
                                n.modHalf(h[0], 360),
                                h[1]
                            ], d = [
                                s.c2p(p),
                                l.c2p(p)
                            ];
                            e1.contains(d, null, r, t1) ? (c.push({
                                pointNumber: r,
                                lon: h[0],
                                lat: h[1]
                            }), f.selected = 1) : f.selected = 0;
                        }
                    }
                    return c;
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../scatter/subtypes": 951
            }
        ],
        1e3: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/template_attributes").hovertemplateAttrs, i = t1("../../plots/template_attributes").texttemplateAttrs, a = t1("../../lib/extend").extendFlat, o = t1("../scatter/attributes"), s = t1("../../plots/attributes"), l = o.line;
                e1.exports = {
                    mode: o.mode,
                    r: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    theta: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    r0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes"
                    },
                    dr: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    theta0: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc+clearAxisTypes"
                    },
                    dtheta: {
                        valType: "number",
                        editType: "calc"
                    },
                    thetaunit: {
                        valType: "enumerated",
                        values: [
                            "radians",
                            "degrees",
                            "gradians"
                        ],
                        dflt: "degrees",
                        editType: "calc+clearAxisTypes"
                    },
                    text: o.text,
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: [
                            "r",
                            "theta",
                            "text"
                        ]
                    }),
                    hovertext: o.hovertext,
                    line: {
                        color: l.color,
                        width: l.width,
                        dash: l.dash,
                        shape: a({}, l.shape, {
                            values: [
                                "linear",
                                "spline"
                            ]
                        }),
                        smoothing: l.smoothing,
                        editType: "calc"
                    },
                    connectgaps: o.connectgaps,
                    marker: o.marker,
                    cliponaxis: a({}, o.cliponaxis, {
                        dflt: !1
                    }),
                    textposition: o.textposition,
                    textfont: o.textfont,
                    fill: a({}, o.fill, {
                        values: [
                            "none",
                            "toself",
                            "tonext"
                        ],
                        dflt: "none"
                    }),
                    fillcolor: o.fillcolor,
                    hoverinfo: a({}, s.hoverinfo, {
                        flags: [
                            "r",
                            "theta",
                            "text",
                            "name"
                        ]
                    }),
                    hoveron: o.hoveron,
                    hovertemplate: n(),
                    selected: o.selected,
                    unselected: o.unselected
                };
            },
            {
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/template_attributes": 633,
                "../scatter/attributes": 926
            }
        ],
        1001: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../constants/numerical").BADNUM, a = t1("../../plots/cartesian/axes"), o = t1("../scatter/colorscale_calc"), s = t1("../scatter/arrays_to_calcdata"), l = t1("../scatter/calc_selection"), c = t1("../scatter/calc").calcMarkerSize;
                e1.exports = function(t1, e1) {
                    for(var r = t1._fullLayout, u = e1.subplot, f = r[u].radialaxis, h = r[u].angularaxis, p = f.makeCalcdata(e1, "r"), d = h.makeCalcdata(e1, "theta"), m = e1._length, g = new Array(m), v = 0; v < m; v++){
                        var y = p[v], x = d[v], b = g[v] = {};
                        n(y) && n(x) ? (b.r = y, b.theta = x) : b.r = i;
                    }
                    var _ = c(e1, m);
                    return e1._extremes.x = a.findExtremes(f, p, {
                        ppad: _
                    }), o(t1, e1), s(g, e1), l(g, e1), g;
                };
            },
            {
                "../../constants/numerical": 479,
                "../../plots/cartesian/axes": 554,
                "../scatter/arrays_to_calcdata": 925,
                "../scatter/calc": 927,
                "../scatter/calc_selection": 928,
                "../scatter/colorscale_calc": 929,
                "fast-isnumeric": 190
            }
        ],
        1002: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../scatter/subtypes"), a = t1("../scatter/marker_defaults"), o = t1("../scatter/line_defaults"), s = t1("../scatter/line_shape_defaults"), l = t1("../scatter/text_defaults"), c = t1("../scatter/fillcolor_defaults"), u = t1("../scatter/constants").PTS_LINESONLY, f = t1("./attributes");
                function h(t1, e1, r, n) {
                    var i, a = n("r"), o = n("theta");
                    if (a) o ? i = Math.min(a.length, o.length) : (i = a.length, n("theta0"), n("dtheta"));
                    else {
                        if (!o) return 0;
                        i = e1.theta.length, n("r0"), n("dr");
                    }
                    return e1._length = i, i;
                }
                e1.exports = {
                    handleRThetaDefaults: h,
                    supplyDefaults: function(t1, e1, r, p) {
                        function d(r, i) {
                            return n.coerce(t1, e1, f, r, i);
                        }
                        var m = h(t1, e1, p, d);
                        if (m) {
                            d("thetaunit"), d("mode", m < u ? "lines+markers" : "lines"), d("text"), d("hovertext"), "fills" !== e1.hoveron && d("hovertemplate"), i.hasLines(e1) && (o(t1, e1, r, p, d), s(t1, e1, d), d("connectgaps")), i.hasMarkers(e1) && a(t1, e1, r, p, d, {
                                gradient: !0
                            }), i.hasText(e1) && (d("texttemplate"), l(t1, e1, p, d));
                            var g = [];
                            (i.hasMarkers(e1) || i.hasText(e1)) && (d("cliponaxis"), d("marker.maxdisplayed"), g.push("points")), d("fill"), "none" !== e1.fill && (c(t1, e1, r, d), i.hasLines(e1) || s(t1, e1, d)), "tonext" !== e1.fill && "toself" !== e1.fill || g.push("fills"), d("hoveron", g.join("+") || "points"), n.coerceSelectionMarkerOpacity(e1, d);
                        } else e1.visible = !1;
                    }
                };
            },
            {
                "../../lib": 503,
                "../scatter/constants": 930,
                "../scatter/fillcolor_defaults": 934,
                "../scatter/line_defaults": 939,
                "../scatter/line_shape_defaults": 941,
                "../scatter/marker_defaults": 945,
                "../scatter/subtypes": 951,
                "../scatter/text_defaults": 952,
                "./attributes": 1e3
            }
        ],
        1003: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axes");
                e1.exports = function(t1, e1, r) {
                    var a, o, s = {}, l = r[e1.subplot]._subplot;
                    l ? (a = l.radialAxis, o = l.angularAxis) : (a = (l = r[e1.subplot]).radialaxis, o = l.angularaxis);
                    var c = a.c2l(t1.r);
                    s.rLabel = i.tickText(a, c, !0).text;
                    var u = "degrees" === o.thetaunit ? n.rad2deg(t1.theta) : t1.theta;
                    return s.thetaLabel = i.tickText(o, u, !0).text, s;
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554
            }
        ],
        1004: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/hover");
                function i(t1, e1, r, n) {
                    var i = r.radialAxis, a = r.angularAxis;
                    i._hovertitle = "r", a._hovertitle = "\u03b8";
                    var o = {};
                    o[e1.subplot] = {
                        _subplot: r
                    };
                    var s = e1._module.formatLabels(t1, e1, o);
                    n.rLabel = s.rLabel, n.thetaLabel = s.thetaLabel;
                    var l = t1.hi || e1.hoverinfo, c = [];
                    function u(t1, e1) {
                        c.push(t1._hovertitle + ": " + e1);
                    }
                    if (!e1.hovertemplate) {
                        var f = l.split("+");
                        -1 !== f.indexOf("all") && (f = [
                            "r",
                            "theta",
                            "text"
                        ]), -1 !== f.indexOf("r") && u(i, n.rLabel), -1 !== f.indexOf("theta") && u(a, n.thetaLabel), -1 !== f.indexOf("text") && n.text && (c.push(n.text), delete n.text), n.extraText = c.join("<br>");
                    }
                }
                e1.exports = {
                    hoverPoints: function(t1, e1, r, a) {
                        var o = n(t1, e1, r, a);
                        if (o && !1 !== o[0].index) {
                            var s = o[0];
                            if (void 0 === s.index) return o;
                            var l = t1.subplot, c = s.cd[s.index], u = s.trace;
                            if (l.isPtInside(c)) return s.xLabelVal = void 0, s.yLabelVal = void 0, i(c, u, l, s), s.hovertemplate = u.hovertemplate, o;
                        }
                    },
                    makeHoverPointText: i
                };
            },
            {
                "../scatter/hover": 937
            }
        ],
        1005: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "scatterpolar",
                    basePlotModule: t1("../../plots/polar"),
                    categories: [
                        "polar",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults").supplyDefaults,
                    colorbar: t1("../scatter/marker_colorbar"),
                    formatLabels: t1("./format_labels"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    style: t1("../scatter/style").style,
                    styleOnSelect: t1("../scatter/style").styleOnSelect,
                    hoverPoints: t1("./hover").hoverPoints,
                    selectPoints: t1("../scatter/select"),
                    meta: {}
                };
            },
            {
                "../../plots/polar": 622,
                "../scatter/marker_colorbar": 944,
                "../scatter/select": 948,
                "../scatter/style": 950,
                "./attributes": 1e3,
                "./calc": 1001,
                "./defaults": 1002,
                "./format_labels": 1003,
                "./hover": 1004,
                "./plot": 1006
            }
        ],
        1006: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/plot"), i = t1("../../constants/numerical").BADNUM;
                e1.exports = function(t1, e1, r) {
                    for(var a = e1.layers.frontplot.select("g.scatterlayer"), o = {
                        xaxis: e1.xaxis,
                        yaxis: e1.yaxis,
                        plot: e1.framework,
                        layerClipId: e1._hasClipOnAxisFalse ? e1.clipIds.forTraces : null
                    }, s = e1.radialAxis, l = e1.angularAxis, c = 0; c < r.length; c++)for(var u = r[c], f = 0; f < u.length; f++){
                        var h = u[f], p = h.r;
                        if (p === i) h.x = h.y = i;
                        else {
                            var d = s.c2g(p), m = l.c2g(h.theta);
                            h.x = d * Math.cos(m), h.y = d * Math.sin(m);
                        }
                    }
                    n(t1, o, r, a);
                };
            },
            {
                "../../constants/numerical": 479,
                "../scatter/plot": 947
            }
        ],
        1007: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatterpolar/attributes"), i = t1("../scattergl/attributes"), a = t1("../../plots/template_attributes").texttemplateAttrs;
                e1.exports = {
                    mode: n.mode,
                    r: n.r,
                    theta: n.theta,
                    r0: n.r0,
                    dr: n.dr,
                    theta0: n.theta0,
                    dtheta: n.dtheta,
                    thetaunit: n.thetaunit,
                    text: n.text,
                    texttemplate: a({
                        editType: "plot"
                    }, {
                        keys: [
                            "r",
                            "theta",
                            "text"
                        ]
                    }),
                    hovertext: n.hovertext,
                    hovertemplate: n.hovertemplate,
                    line: i.line,
                    connectgaps: i.connectgaps,
                    marker: i.marker,
                    fill: i.fill,
                    fillcolor: i.fillcolor,
                    textposition: i.textposition,
                    textfont: i.textfont,
                    hoverinfo: n.hoverinfo,
                    selected: n.selected,
                    unselected: n.unselected
                };
            },
            {
                "../../plots/template_attributes": 633,
                "../scattergl/attributes": 978,
                "../scatterpolar/attributes": 1e3
            }
        ],
        1008: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/colorscale_calc"), i = t1("../scatter/calc").calcMarkerSize, a = t1("../scattergl/convert"), o = t1("../../plots/cartesian/axes"), s = t1("../scattergl/constants").TOO_MANY_POINTS;
                e1.exports = function(t1, e1) {
                    var r = t1._fullLayout, l = e1.subplot, c = r[l].radialaxis, u = r[l].angularaxis, f = e1._r = c.makeCalcdata(e1, "r"), h = e1._theta = u.makeCalcdata(e1, "theta"), p = e1._length, d = {};
                    p < f.length && (f = f.slice(0, p)), p < h.length && (h = h.slice(0, p)), d.r = f, d.theta = h, n(t1, e1);
                    var m, g = d.opts = a.style(t1, e1);
                    return p < s ? m = i(e1, p) : g.marker && (m = 2 * (g.marker.sizeAvg || Math.max(g.marker.size, 3))), e1._extremes.x = o.findExtremes(c, f, {
                        ppad: m
                    }), [
                        {
                            x: !1,
                            y: !1,
                            t: d,
                            trace: e1
                        }
                    ];
                };
            },
            {
                "../../plots/cartesian/axes": 554,
                "../scatter/calc": 927,
                "../scatter/colorscale_calc": 929,
                "../scattergl/constants": 980,
                "../scattergl/convert": 981
            }
        ],
        1009: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../scatter/subtypes"), a = t1("../scatterpolar/defaults").handleRThetaDefaults, o = t1("../scatter/marker_defaults"), s = t1("../scatter/line_defaults"), l = t1("../scatter/text_defaults"), c = t1("../scatter/fillcolor_defaults"), u = t1("../scatter/constants").PTS_LINESONLY, f = t1("./attributes");
                e1.exports = function(t1, e1, r, h) {
                    function p(r, i) {
                        return n.coerce(t1, e1, f, r, i);
                    }
                    var d = a(t1, e1, h, p);
                    d ? (p("thetaunit"), p("mode", d < u ? "lines+markers" : "lines"), p("text"), p("hovertext"), "fills" !== e1.hoveron && p("hovertemplate"), i.hasLines(e1) && (s(t1, e1, r, h, p), p("connectgaps")), i.hasMarkers(e1) && o(t1, e1, r, h, p), i.hasText(e1) && (p("texttemplate"), l(t1, e1, h, p)), p("fill"), "none" !== e1.fill && c(t1, e1, r, p), n.coerceSelectionMarkerOpacity(e1, p)) : e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../scatter/constants": 930,
                "../scatter/fillcolor_defaults": 934,
                "../scatter/line_defaults": 939,
                "../scatter/marker_defaults": 945,
                "../scatter/subtypes": 951,
                "../scatter/text_defaults": 952,
                "../scatterpolar/defaults": 1002,
                "./attributes": 1007
            }
        ],
        1010: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatterpolar/format_labels");
                e1.exports = function(t1, e1, r) {
                    var i = t1.i;
                    return "r" in t1 || (t1.r = e1._r[i]), "theta" in t1 || (t1.theta = e1._theta[i]), n(t1, e1, r);
                };
            },
            {
                "../scatterpolar/format_labels": 1003
            }
        ],
        1011: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scattergl/hover"), i = t1("../scatterpolar/hover").makeHoverPointText;
                e1.exports = {
                    hoverPoints: function(t1, e1, r, a) {
                        var o = t1.cd[0].t, s = o.r, l = o.theta, c = n.hoverPoints(t1, e1, r, a);
                        if (c && !1 !== c[0].index) {
                            var u = c[0];
                            if (void 0 === u.index) return c;
                            var f = t1.subplot, h = u.cd[u.index], p = u.trace;
                            if (h.r = s[u.index], h.theta = l[u.index], f.isPtInside(h)) return u.xLabelVal = void 0, u.yLabelVal = void 0, i(h, p, f, u), c;
                        }
                    }
                };
            },
            {
                "../scattergl/hover": 986,
                "../scatterpolar/hover": 1004
            }
        ],
        1012: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "scatterpolargl",
                    basePlotModule: t1("../../plots/polar"),
                    categories: [
                        "gl",
                        "regl",
                        "polar",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: t1("../scatter/marker_colorbar"),
                    formatLabels: t1("./format_labels"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    hoverPoints: t1("./hover").hoverPoints,
                    selectPoints: t1("../scattergl/select"),
                    meta: {}
                };
            },
            {
                "../../plots/polar": 622,
                "../scatter/marker_colorbar": 944,
                "../scattergl/select": 990,
                "./attributes": 1007,
                "./calc": 1008,
                "./defaults": 1009,
                "./format_labels": 1010,
                "./hover": 1011,
                "./plot": 1013
            }
        ],
        1013: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/point-cluster"), i = t1("fast-isnumeric"), a = t1("../scattergl/plot"), o = t1("../scattergl/scene_update"), s = t1("../scattergl/convert"), l = t1("../../lib"), c = t1("../scattergl/constants").TOO_MANY_POINTS;
                e1.exports = function(t1, e1, r) {
                    if (r.length) {
                        var u = e1.radialAxis, f = e1.angularAxis, h = o(t1, e1);
                        return r.forEach(function(r) {
                            if (r && r[0] && r[0].trace) {
                                var a, o = r[0], p = o.trace, d = o.t, m = p._length, g = d.r, v = d.theta, y = d.opts, x = g.slice(), b = v.slice();
                                for(a = 0; a < g.length; a++)e1.isPtInside({
                                    r: g[a],
                                    theta: v[a]
                                }) || (x[a] = NaN, b[a] = NaN);
                                var _ = new Array(2 * m), w = Array(m), T = Array(m);
                                for(a = 0; a < m; a++){
                                    var k, A, M = x[a];
                                    if (i(M)) {
                                        var S = u.c2g(M), E = f.c2g(b[a], p.thetaunit);
                                        k = S * Math.cos(E), A = S * Math.sin(E);
                                    } else k = A = NaN;
                                    w[a] = _[2 * a] = k, T[a] = _[2 * a + 1] = A;
                                }
                                d.tree = n(_), y.marker && m >= c && (y.marker.cluster = d.tree), y.marker && (y.markerSel.positions = y.markerUnsel.positions = y.marker.positions = _), y.line && _.length > 1 && l.extendFlat(y.line, s.linePositions(t1, p, _)), y.text && (l.extendFlat(y.text, {
                                    positions: _
                                }, s.textPosition(t1, p, y.text, y.marker)), l.extendFlat(y.textSel, {
                                    positions: _
                                }, s.textPosition(t1, p, y.text, y.markerSel)), l.extendFlat(y.textUnsel, {
                                    positions: _
                                }, s.textPosition(t1, p, y.text, y.markerUnsel))), y.fill && !h.fill2d && (h.fill2d = !0), y.marker && !h.scatter2d && (h.scatter2d = !0), y.line && !h.line2d && (h.line2d = !0), y.text && !h.glText && (h.glText = !0), h.lineOptions.push(y.line), h.fillOptions.push(y.fill), h.markerOptions.push(y.marker), h.markerSelectedOptions.push(y.markerSel), h.markerUnselectedOptions.push(y.markerUnsel), h.textOptions.push(y.text), h.textSelectedOptions.push(y.textSel), h.textUnselectedOptions.push(y.textUnsel), h.selectBatch.push([]), h.unselectBatch.push([]), d.x = w, d.y = T, d.rawx = w, d.rawy = T, d.r = g, d.theta = v, d.positions = _, d._scene = h, d.index = h.count, h.count++;
                            }
                        }), a(t1, e1, r);
                    }
                };
            },
            {
                "../../lib": 503,
                "../scattergl/constants": 980,
                "../scattergl/convert": 981,
                "../scattergl/plot": 988,
                "../scattergl/scene_update": 989,
                "@plotly/point-cluster": 59,
                "fast-isnumeric": 190
            }
        ],
        1014: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/template_attributes").hovertemplateAttrs, i = t1("../../plots/template_attributes").texttemplateAttrs, a = t1("../../lib/extend").extendFlat, o = t1("../scatter/attributes"), s = t1("../../plots/attributes"), l = o.line;
                e1.exports = {
                    mode: o.mode,
                    real: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    imag: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    text: o.text,
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: [
                            "real",
                            "imag",
                            "text"
                        ]
                    }),
                    hovertext: o.hovertext,
                    line: {
                        color: l.color,
                        width: l.width,
                        dash: l.dash,
                        shape: a({}, l.shape, {
                            values: [
                                "linear",
                                "spline"
                            ]
                        }),
                        smoothing: l.smoothing,
                        editType: "calc"
                    },
                    connectgaps: o.connectgaps,
                    marker: o.marker,
                    cliponaxis: a({}, o.cliponaxis, {
                        dflt: !1
                    }),
                    textposition: o.textposition,
                    textfont: o.textfont,
                    fill: a({}, o.fill, {
                        values: [
                            "none",
                            "toself",
                            "tonext"
                        ],
                        dflt: "none"
                    }),
                    fillcolor: o.fillcolor,
                    hoverinfo: a({}, s.hoverinfo, {
                        flags: [
                            "real",
                            "imag",
                            "text",
                            "name"
                        ]
                    }),
                    hoveron: o.hoveron,
                    hovertemplate: n(),
                    selected: o.selected,
                    unselected: o.unselected
                };
            },
            {
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/template_attributes": 633,
                "../scatter/attributes": 926
            }
        ],
        1015: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../../constants/numerical").BADNUM, a = t1("../scatter/colorscale_calc"), o = t1("../scatter/arrays_to_calcdata"), s = t1("../scatter/calc_selection"), l = t1("../scatter/calc").calcMarkerSize;
                e1.exports = function(t1, e1) {
                    for(var r = t1._fullLayout, c = e1.subplot, u = r[c].realaxis, f = r[c].imaginaryaxis, h = u.makeCalcdata(e1, "real"), p = f.makeCalcdata(e1, "imag"), d = e1._length, m = new Array(d), g = 0; g < d; g++){
                        var v = h[g], y = p[g], x = m[g] = {};
                        n(v) && n(y) ? (x.real = v, x.imag = y) : x.real = i;
                    }
                    return l(e1, d), a(t1, e1), o(m, e1), s(m, e1), m;
                };
            },
            {
                "../../constants/numerical": 479,
                "../scatter/arrays_to_calcdata": 925,
                "../scatter/calc": 927,
                "../scatter/calc_selection": 928,
                "../scatter/colorscale_calc": 929,
                "fast-isnumeric": 190
            }
        ],
        1016: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../scatter/subtypes"), a = t1("../scatter/marker_defaults"), o = t1("../scatter/line_defaults"), s = t1("../scatter/line_shape_defaults"), l = t1("../scatter/text_defaults"), c = t1("../scatter/fillcolor_defaults"), u = t1("../scatter/constants").PTS_LINESONLY, f = t1("./attributes");
                e1.exports = function(t1, e1, r, h) {
                    function p(r, i) {
                        return n.coerce(t1, e1, f, r, i);
                    }
                    var d = function(t1, e1, r, n) {
                        var i, a = n("real"), o = n("imag");
                        a && o && (i = Math.min(a.length, o.length));
                        return e1._length = i, i;
                    }(0, e1, 0, p);
                    if (d) {
                        p("mode", d < u ? "lines+markers" : "lines"), p("text"), p("hovertext"), "fills" !== e1.hoveron && p("hovertemplate"), i.hasLines(e1) && (o(t1, e1, r, h, p), s(t1, e1, p), p("connectgaps")), i.hasMarkers(e1) && a(t1, e1, r, h, p, {
                            gradient: !0
                        }), i.hasText(e1) && (p("texttemplate"), l(t1, e1, h, p));
                        var m = [];
                        (i.hasMarkers(e1) || i.hasText(e1)) && (p("cliponaxis"), p("marker.maxdisplayed"), m.push("points")), p("fill"), "none" !== e1.fill && (c(t1, e1, r, p), i.hasLines(e1) || s(t1, e1, p)), "tonext" !== e1.fill && "toself" !== e1.fill || m.push("fills"), p("hoveron", m.join("+") || "points"), n.coerceSelectionMarkerOpacity(e1, p);
                    } else e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../scatter/constants": 930,
                "../scatter/fillcolor_defaults": 934,
                "../scatter/line_defaults": 939,
                "../scatter/line_shape_defaults": 941,
                "../scatter/marker_defaults": 945,
                "../scatter/subtypes": 951,
                "../scatter/text_defaults": 952,
                "./attributes": 1014
            }
        ],
        1017: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes");
                e1.exports = function(t1, e1, r) {
                    var i = {}, a = r[e1.subplot]._subplot;
                    return i.realLabel = n.tickText(a.radialAxis, t1.real, !0).text, i.imagLabel = n.tickText(a.angularAxis, t1.imag, !0).text, i;
                };
            },
            {
                "../../plots/cartesian/axes": 554
            }
        ],
        1018: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/hover");
                function i(t1, e1, r, n) {
                    var i = r.radialAxis, a = r.angularAxis;
                    i._hovertitle = "real", a._hovertitle = "imag";
                    var o = {};
                    o[e1.subplot] = {
                        _subplot: r
                    };
                    var s = e1._module.formatLabels(t1, e1, o);
                    n.realLabel = s.realLabel, n.imagLabel = s.imagLabel;
                    var l = t1.hi || e1.hoverinfo, c = [];
                    function u(t1, e1) {
                        c.push(t1._hovertitle + ": " + e1);
                    }
                    if (!e1.hovertemplate) {
                        var f = l.split("+");
                        -1 !== f.indexOf("all") && (f = [
                            "real",
                            "imag",
                            "text"
                        ]), -1 !== f.indexOf("real") && u(i, n.realLabel), -1 !== f.indexOf("imag") && u(a, n.imagLabel), -1 !== f.indexOf("text") && n.text && (c.push(n.text), delete n.text), n.extraText = c.join("<br>");
                    }
                }
                e1.exports = {
                    hoverPoints: function(t1, e1, r, a) {
                        var o = n(t1, e1, r, a);
                        if (o && !1 !== o[0].index) {
                            var s = o[0];
                            if (void 0 === s.index) return o;
                            var l = t1.subplot, c = s.cd[s.index], u = s.trace;
                            if (l.isPtInside(c)) return s.xLabelVal = void 0, s.yLabelVal = void 0, i(c, u, l, s), s.hovertemplate = u.hovertemplate, o;
                        }
                    },
                    makeHoverPointText: i
                };
            },
            {
                "../scatter/hover": 937
            }
        ],
        1019: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "scattersmith",
                    basePlotModule: t1("../../plots/smith"),
                    categories: [
                        "smith",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: t1("../scatter/marker_colorbar"),
                    formatLabels: t1("./format_labels"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    style: t1("../scatter/style").style,
                    styleOnSelect: t1("../scatter/style").styleOnSelect,
                    hoverPoints: t1("./hover").hoverPoints,
                    selectPoints: t1("../scatter/select"),
                    meta: {}
                };
            },
            {
                "../../plots/smith": 629,
                "../scatter/marker_colorbar": 944,
                "../scatter/select": 948,
                "../scatter/style": 950,
                "./attributes": 1014,
                "./calc": 1015,
                "./defaults": 1016,
                "./format_labels": 1017,
                "./hover": 1018,
                "./plot": 1020
            }
        ],
        1020: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/plot"), i = t1("../../constants/numerical").BADNUM, a = t1("../../plots/smith/helpers").smith;
                e1.exports = function(t1, e1, r) {
                    for(var o = e1.layers.frontplot.select("g.scatterlayer"), s = {
                        xaxis: e1.xaxis,
                        yaxis: e1.yaxis,
                        plot: e1.framework,
                        layerClipId: e1._hasClipOnAxisFalse ? e1.clipIds.forTraces : null
                    }, l = 0; l < r.length; l++)for(var c = r[l], u = 0; u < c.length; u++){
                        var f = c[u], h = f.real;
                        if (h === i) f.x = f.y = i;
                        else {
                            var p = a([
                                h,
                                f.imag
                            ]);
                            f.x = p[0], f.y = p[1];
                        }
                    }
                    n(t1, s, r, o);
                };
            },
            {
                "../../constants/numerical": 479,
                "../../plots/smith/helpers": 628,
                "../scatter/plot": 947
            }
        ],
        1021: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/template_attributes").hovertemplateAttrs, i = t1("../../plots/template_attributes").texttemplateAttrs, a = t1("../scatter/attributes"), o = t1("../../plots/attributes"), s = t1("../../components/colorscale/attributes"), l = t1("../../components/drawing/attributes").dash, c = t1("../../lib/extend").extendFlat, u = a.marker, f = a.line, h = u.line;
                e1.exports = {
                    a: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    b: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    c: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    sum: {
                        valType: "number",
                        dflt: 0,
                        min: 0,
                        editType: "calc"
                    },
                    mode: c({}, a.mode, {
                        dflt: "markers"
                    }),
                    text: c({}, a.text, {}),
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: [
                            "a",
                            "b",
                            "c",
                            "text"
                        ]
                    }),
                    hovertext: c({}, a.hovertext, {}),
                    line: {
                        color: f.color,
                        width: f.width,
                        dash: l,
                        shape: c({}, f.shape, {
                            values: [
                                "linear",
                                "spline"
                            ]
                        }),
                        smoothing: f.smoothing,
                        editType: "calc"
                    },
                    connectgaps: a.connectgaps,
                    cliponaxis: a.cliponaxis,
                    fill: c({}, a.fill, {
                        values: [
                            "none",
                            "toself",
                            "tonext"
                        ],
                        dflt: "none"
                    }),
                    fillcolor: a.fillcolor,
                    marker: c({
                        symbol: u.symbol,
                        opacity: u.opacity,
                        maxdisplayed: u.maxdisplayed,
                        size: u.size,
                        sizeref: u.sizeref,
                        sizemin: u.sizemin,
                        sizemode: u.sizemode,
                        line: c({
                            width: h.width,
                            editType: "calc"
                        }, s("marker.line")),
                        gradient: u.gradient,
                        editType: "calc"
                    }, s("marker")),
                    textfont: a.textfont,
                    textposition: a.textposition,
                    selected: a.selected,
                    unselected: a.unselected,
                    hoverinfo: c({}, o.hoverinfo, {
                        flags: [
                            "a",
                            "b",
                            "c",
                            "text",
                            "name"
                        ]
                    }),
                    hoveron: a.hoveron,
                    hovertemplate: n()
                };
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../components/drawing/attributes": 387,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/template_attributes": 633,
                "../scatter/attributes": 926
            }
        ],
        1022: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("fast-isnumeric"), i = t1("../scatter/colorscale_calc"), a = t1("../scatter/arrays_to_calcdata"), o = t1("../scatter/calc_selection"), s = t1("../scatter/calc").calcMarkerSize, l = [
                    "a",
                    "b",
                    "c"
                ], c = {
                    a: [
                        "b",
                        "c"
                    ],
                    b: [
                        "a",
                        "c"
                    ],
                    c: [
                        "a",
                        "b"
                    ]
                };
                e1.exports = function(t1, e1) {
                    var r, u, f, h, p, d, m = t1._fullLayout[e1.subplot].sum, g = e1.sum || m, v = {
                        a: e1.a,
                        b: e1.b,
                        c: e1.c
                    };
                    for(r = 0; r < l.length; r++)if (!v[f = l[r]]) {
                        for(p = v[c[f][0]], d = v[c[f][1]], h = new Array(p.length), u = 0; u < p.length; u++)h[u] = g - p[u] - d[u];
                        v[f] = h;
                    }
                    var y, x, b, _, w, T, k = e1._length, A = new Array(k);
                    for(r = 0; r < k; r++)y = v.a[r], x = v.b[r], b = v.c[r], n(y) && n(x) && n(b) ? (1 !== (_ = m / ((y = +y) + (x = +x) + (b = +b))) && (y *= _, x *= _, b *= _), T = y, w = b - x, A[r] = {
                        x: w,
                        y: T,
                        a: y,
                        b: x,
                        c: b
                    }) : A[r] = {
                        x: !1,
                        y: !1
                    };
                    return s(e1, k), i(t1, e1), a(A, e1), o(A, e1), A;
                };
            },
            {
                "../scatter/arrays_to_calcdata": 925,
                "../scatter/calc": 927,
                "../scatter/calc_selection": 928,
                "../scatter/colorscale_calc": 929,
                "fast-isnumeric": 190
            }
        ],
        1023: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../scatter/constants"), a = t1("../scatter/subtypes"), o = t1("../scatter/marker_defaults"), s = t1("../scatter/line_defaults"), l = t1("../scatter/line_shape_defaults"), c = t1("../scatter/text_defaults"), u = t1("../scatter/fillcolor_defaults"), f = t1("./attributes");
                e1.exports = function(t1, e1, r, h) {
                    function p(r, i) {
                        return n.coerce(t1, e1, f, r, i);
                    }
                    var d, m = p("a"), g = p("b"), v = p("c");
                    if (m ? (d = m.length, g ? (d = Math.min(d, g.length), v && (d = Math.min(d, v.length))) : d = v ? Math.min(d, v.length) : 0) : g && v && (d = Math.min(g.length, v.length)), d) {
                        e1._length = d, p("sum"), p("text"), p("hovertext"), "fills" !== e1.hoveron && p("hovertemplate"), p("mode", d < i.PTS_LINESONLY ? "lines+markers" : "lines"), a.hasLines(e1) && (s(t1, e1, r, h, p), l(t1, e1, p), p("connectgaps")), a.hasMarkers(e1) && o(t1, e1, r, h, p, {
                            gradient: !0
                        }), a.hasText(e1) && (p("texttemplate"), c(t1, e1, h, p));
                        var y = [];
                        (a.hasMarkers(e1) || a.hasText(e1)) && (p("cliponaxis"), p("marker.maxdisplayed"), y.push("points")), p("fill"), "none" !== e1.fill && (u(t1, e1, r, p), a.hasLines(e1) || l(t1, e1, p)), "tonext" !== e1.fill && "toself" !== e1.fill || y.push("fills"), p("hoveron", y.join("+") || "points"), n.coerceSelectionMarkerOpacity(e1, p);
                    } else e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../scatter/constants": 930,
                "../scatter/fillcolor_defaults": 934,
                "../scatter/line_defaults": 939,
                "../scatter/line_shape_defaults": 941,
                "../scatter/marker_defaults": 945,
                "../scatter/subtypes": 951,
                "../scatter/text_defaults": 952,
                "./attributes": 1021
            }
        ],
        1024: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1, r, n, i) {
                    if (e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), n[i]) {
                        var a = n[i];
                        t1.a = a.a, t1.b = a.b, t1.c = a.c;
                    } else t1.a = e1.a, t1.b = e1.b, t1.c = e1.c;
                    return t1;
                };
            },
            {}
        ],
        1025: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes");
                e1.exports = function(t1, e1, r) {
                    var i = {}, a = r[e1.subplot]._subplot;
                    return i.aLabel = n.tickText(a.aaxis, t1.a, !0).text, i.bLabel = n.tickText(a.baxis, t1.b, !0).text, i.cLabel = n.tickText(a.caxis, t1.c, !0).text, i;
                };
            },
            {
                "../../plots/cartesian/axes": 554
            }
        ],
        1026: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/hover");
                e1.exports = function(t1, e1, r, i) {
                    var a = n(t1, e1, r, i);
                    if (a && !1 !== a[0].index) {
                        var o = a[0];
                        if (void 0 === o.index) {
                            var s = 1 - o.y0 / t1.ya._length, l = t1.xa._length, c = l * s / 2, u = l - c;
                            return o.x0 = Math.max(Math.min(o.x0, u), c), o.x1 = Math.max(Math.min(o.x1, u), c), a;
                        }
                        var f = o.cd[o.index], h = o.trace, p = o.subplot;
                        o.a = f.a, o.b = f.b, o.c = f.c, o.xLabelVal = void 0, o.yLabelVal = void 0;
                        var d = {};
                        d[h.subplot] = {
                            _subplot: p
                        };
                        var m = h._module.formatLabels(f, h, d);
                        o.aLabel = m.aLabel, o.bLabel = m.bLabel, o.cLabel = m.cLabel;
                        var g = f.hi || h.hoverinfo, v = [];
                        if (!h.hovertemplate) {
                            var y = g.split("+");
                            -1 !== y.indexOf("all") && (y = [
                                "a",
                                "b",
                                "c"
                            ]), -1 !== y.indexOf("a") && x(p.aaxis, o.aLabel), -1 !== y.indexOf("b") && x(p.baxis, o.bLabel), -1 !== y.indexOf("c") && x(p.caxis, o.cLabel);
                        }
                        return o.extraText = v.join("<br>"), o.hovertemplate = h.hovertemplate, a;
                    }
                    function x(t1, e1) {
                        v.push(t1._hovertitle + ": " + e1);
                    }
                };
            },
            {
                "../scatter/hover": 937
            }
        ],
        1027: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: t1("../scatter/marker_colorbar"),
                    formatLabels: t1("./format_labels"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    style: t1("../scatter/style").style,
                    styleOnSelect: t1("../scatter/style").styleOnSelect,
                    hoverPoints: t1("./hover"),
                    selectPoints: t1("../scatter/select"),
                    eventData: t1("./event_data"),
                    moduleType: "trace",
                    name: "scatterternary",
                    basePlotModule: t1("../../plots/ternary"),
                    categories: [
                        "ternary",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/ternary": 634,
                "../scatter/marker_colorbar": 944,
                "../scatter/select": 948,
                "../scatter/style": 950,
                "./attributes": 1021,
                "./calc": 1022,
                "./defaults": 1023,
                "./event_data": 1024,
                "./format_labels": 1025,
                "./hover": 1026,
                "./plot": 1028
            }
        ],
        1028: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/plot");
                e1.exports = function(t1, e1, r) {
                    var i = e1.plotContainer;
                    i.select(".scatterlayer").selectAll("*").remove();
                    var a = {
                        xaxis: e1.xaxis,
                        yaxis: e1.yaxis,
                        plot: i,
                        layerClipId: e1._hasClipOnAxisFalse ? e1.clipIdRelative : null
                    }, o = e1.layers.frontplot.select("g.scatterlayer");
                    n(t1, a, r, o);
                };
            },
            {
                "../scatter/plot": 947
            }
        ],
        1029: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../scatter/attributes"), i = t1("../../components/colorscale/attributes"), a = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, o = t1("../../plots/template_attributes").hovertemplateAttrs, s = t1("../scattergl/attributes"), l = t1("../../plots/cartesian/constants").idRegex, c = t1("../../plot_api/plot_template").templatedArray, u = t1("../../lib/extend").extendFlat, f = n.marker, h = f.line, p = u(i("marker.line", {
                    editTypeOverride: "calc"
                }), {
                    width: u({}, h.width, {
                        editType: "calc"
                    }),
                    editType: "calc"
                }), d = u(i("marker"), {
                    symbol: f.symbol,
                    size: u({}, f.size, {
                        editType: "markerSize"
                    }),
                    sizeref: f.sizeref,
                    sizemin: f.sizemin,
                    sizemode: f.sizemode,
                    opacity: f.opacity,
                    colorbar: f.colorbar,
                    line: p,
                    editType: "calc"
                });
                function m(t1) {
                    return {
                        valType: "info_array",
                        freeLength: !0,
                        editType: "calc",
                        items: {
                            valType: "subplotid",
                            regex: l[t1],
                            editType: "plot"
                        }
                    };
                }
                d.color.editType = d.cmin.editType = d.cmax.editType = "style", e1.exports = {
                    dimensions: c("dimension", {
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "calc"
                        },
                        label: {
                            valType: "string",
                            editType: "calc"
                        },
                        values: {
                            valType: "data_array",
                            editType: "calc+clearAxisTypes"
                        },
                        axis: {
                            type: {
                                valType: "enumerated",
                                values: [
                                    "linear",
                                    "log",
                                    "date",
                                    "category"
                                ],
                                editType: "calc+clearAxisTypes"
                            },
                            matches: {
                                valType: "boolean",
                                dflt: !1,
                                editType: "calc"
                            },
                            editType: "calc+clearAxisTypes"
                        },
                        editType: "calc+clearAxisTypes"
                    }),
                    text: u({}, s.text, {}),
                    hovertext: u({}, s.hovertext, {}),
                    hovertemplate: o(),
                    xhoverformat: a("x"),
                    yhoverformat: a("y"),
                    marker: d,
                    xaxes: m("x"),
                    yaxes: m("y"),
                    diagonal: {
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    showupperhalf: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    showlowerhalf: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    selected: {
                        marker: s.selected.marker,
                        editType: "calc"
                    },
                    unselected: {
                        marker: s.unselected.marker,
                        editType: "calc"
                    },
                    opacity: s.opacity
                };
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plot_api/plot_template": 543,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/cartesian/constants": 561,
                "../../plots/template_attributes": 633,
                "../scatter/attributes": 926,
                "../scattergl/attributes": 978
            }
        ],
        1030: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("regl-line2d"), i = t1("../../registry"), a = t1("../../lib/prepare_regl"), o = t1("../../plots/get_data").getModuleCalcData, s = t1("../../plots/cartesian"), l = t1("../../plots/cartesian/axis_ids").getFromId, c = t1("../../plots/cartesian/axes").shouldShowZeroLine;
                function u(t1, e1, r) {
                    for(var n = r.matrixOptions.data.length, i = e1._visibleDims, a = r.viewOpts.ranges = new Array(n), o = 0; o < i.length; o++){
                        var s = i[o], c = a[o] = new Array(4), u = l(t1, e1._diag[s][0]);
                        u && (c[0] = u.r2l(u.range[0]), c[2] = u.r2l(u.range[1]));
                        var f = l(t1, e1._diag[s][1]);
                        f && (c[1] = f.r2l(f.range[0]), c[3] = f.r2l(f.range[1]));
                    }
                    r.selectBatch.length || r.unselectBatch.length ? r.matrix.update({
                        ranges: a
                    }, {
                        ranges: a
                    }) : r.matrix.update({
                        ranges: a
                    });
                }
                function f(t1) {
                    var e1 = t1._fullLayout, r = e1._glcanvas.data()[0].regl, i = e1._splomGrid;
                    i || (i = e1._splomGrid = n(r)), i.update(function(t1) {
                        var e1, r = t1._context.plotGlPixelRatio, n = t1._fullLayout, i = n._size, a = [
                            0,
                            0,
                            n.width * r,
                            n.height * r
                        ], o = {};
                        function s(t1, e1, n, i, s, l) {
                            n *= r, i *= r, s *= r, l *= r;
                            var c = e1[t1 + "color"], u = e1[t1 + "width"], f = String(c + u);
                            f in o ? o[f].data.push(NaN, NaN, n, i, s, l) : o[f] = {
                                data: [
                                    n,
                                    i,
                                    s,
                                    l
                                ],
                                join: "rect",
                                thickness: u * r,
                                color: c,
                                viewport: a,
                                range: a,
                                overlay: !1
                            };
                        }
                        for(e1 in n._splomSubplots){
                            var l, u, f = n._plots[e1], h = f.xaxis, p = f.yaxis, d = h._gridVals, m = p._gridVals, g = h._offset, v = h._length, y = p._length, x = i.b + p.domain[0] * i.h, b = -p._m, _ = -b * p.r2l(p.range[0], p.calendar);
                            if (h.showgrid) for(e1 = 0; e1 < d.length; e1++)l = g + h.l2p(d[e1].x), s("grid", h, l, x, l, x + y);
                            if (p.showgrid) for(e1 = 0; e1 < m.length; e1++)u = x + _ + b * m[e1].x, s("grid", p, g, u, g + v, u);
                            c(t1, h, p) && (l = g + h.l2p(0), s("zeroline", h, l, x, l, x + y)), c(t1, p, h) && s("zeroline", p, g, u = x + _ + 0, g + v, u);
                        }
                        var w = [];
                        for(e1 in o)w.push(o[e1]);
                        return w;
                    }(t1));
                }
                e1.exports = {
                    name: "splom",
                    attr: s.attr,
                    attrRegex: s.attrRegex,
                    layoutAttributes: s.layoutAttributes,
                    supplyLayoutDefaults: s.supplyLayoutDefaults,
                    drawFramework: s.drawFramework,
                    plot: function(t1) {
                        var e1 = t1._fullLayout, r = i.getModule("splom"), n = o(t1.calcdata, r)[0];
                        a(t1, [
                            "ANGLE_instanced_arrays",
                            "OES_element_index_uint"
                        ]) && (e1._hasOnlyLargeSploms && f(t1), r.plot(t1, {}, n));
                    },
                    drag: function(t1) {
                        var e1 = t1.calcdata, r = t1._fullLayout;
                        r._hasOnlyLargeSploms && f(t1);
                        for(var n = 0; n < e1.length; n++){
                            var i = e1[n][0].trace, a = r._splomScenes[i.uid];
                            "splom" === i.type && a && a.matrix && u(t1, i, a);
                        }
                    },
                    updateGrid: f,
                    clean: function(t1, e1, r, n) {
                        var i, a = {};
                        if (n._splomScenes) {
                            for(i = 0; i < t1.length; i++){
                                var o = t1[i];
                                "splom" === o.type && (a[o.uid] = 1);
                            }
                            for(i = 0; i < r.length; i++){
                                var l = r[i];
                                if (!a[l.uid]) {
                                    var c = n._splomScenes[l.uid];
                                    c && c.destroy && c.destroy(), n._splomScenes[l.uid] = null, delete n._splomScenes[l.uid];
                                }
                            }
                        }
                        0 === Object.keys(n._splomScenes || {}).length && delete n._splomScenes, n._splomGrid && !e1._hasOnlyLargeSploms && n._hasOnlyLargeSploms && (n._splomGrid.destroy(), n._splomGrid = null, delete n._splomGrid), s.clean(t1, e1, r, n);
                    },
                    updateFx: s.updateFx,
                    toSVG: s.toSVG
                };
            },
            {
                "../../lib/prepare_regl": 516,
                "../../plots/cartesian": 568,
                "../../plots/cartesian/axes": 554,
                "../../plots/cartesian/axis_ids": 558,
                "../../plots/get_data": 593,
                "../../registry": 638,
                "regl-line2d": 280
            }
        ],
        1031: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axis_ids"), a = t1("../scatter/calc").calcMarkerSize, o = t1("../scatter/calc").calcAxisExpansion, s = t1("../scatter/colorscale_calc"), l = t1("../scattergl/convert").markerSelection, c = t1("../scattergl/convert").markerStyle, u = t1("./scene_update"), f = t1("../../constants/numerical").BADNUM, h = t1("../scattergl/constants").TOO_MANY_POINTS;
                e1.exports = function(t1, e1) {
                    var r, p, d, m, g, v, y = e1.dimensions, x = e1._length, b = {}, _ = b.cdata = [], w = b.data = [], T = e1._visibleDims = [];
                    function k(t1, r) {
                        for(var i = t1.makeCalcdata({
                            v: r.values,
                            vcalendar: e1.calendar
                        }, "v"), a = 0; a < i.length; a++)i[a] = i[a] === f ? NaN : i[a];
                        _.push(i), w.push("log" === t1.type ? n.simpleMap(i, t1.c2l) : i);
                    }
                    for(r = 0; r < y.length; r++)if ((d = y[r]).visible) {
                        if (m = i.getFromId(t1, e1._diag[r][0]), g = i.getFromId(t1, e1._diag[r][1]), m && g && m.type !== g.type) {
                            n.log("Skipping splom dimension " + r + " with conflicting axis types");
                            continue;
                        }
                        m ? (k(m, d), g && "category" === g.type && (g._categories = m._categories.slice())) : k(g, d), T.push(r);
                    }
                    for(s(t1, e1), n.extendFlat(b, c(e1)), v = _.length * x > h ? b.sizeAvg || Math.max(b.size, 3) : a(e1, x), p = 0; p < T.length; p++)d = y[r = T[p]], m = i.getFromId(t1, e1._diag[r][0]) || {}, g = i.getFromId(t1, e1._diag[r][1]) || {}, o(t1, e1, m, g, _[p], _[p], v);
                    var A = u(t1, e1);
                    return A.matrix || (A.matrix = !0), A.matrixOptions = b, A.selectedOptions = l(e1, e1.selected), A.unselectedOptions = l(e1, e1.unselected), [
                        {
                            x: !1,
                            y: !1,
                            t: {},
                            trace: e1
                        }
                    ];
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../plots/cartesian/axis_ids": 558,
                "../scatter/calc": 927,
                "../scatter/colorscale_calc": 929,
                "../scattergl/constants": 980,
                "../scattergl/convert": 981,
                "./scene_update": 1038
            }
        ],
        1032: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/array_container_defaults"), a = t1("./attributes"), o = t1("../scatter/subtypes"), s = t1("../scatter/marker_defaults"), l = t1("../parcoords/merge_length"), c = t1("../scattergl/helpers").isOpenSymbol;
                function u(t1, e1) {
                    function r(r, i) {
                        return n.coerce(t1, e1, a.dimensions, r, i);
                    }
                    r("label");
                    var i = r("values");
                    i && i.length ? r("visible") : e1.visible = !1, r("axis.type"), r("axis.matches");
                }
                e1.exports = function(t1, e1, r, f) {
                    function h(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var p = i(t1, e1, {
                        name: "dimensions",
                        handleItemDefaults: u
                    }), d = h("diagonal.visible"), m = h("showupperhalf"), g = h("showlowerhalf");
                    if (l(e1, p, "values") && (d || m || g)) {
                        h("text"), h("hovertext"), h("hovertemplate"), h("xhoverformat"), h("yhoverformat"), s(t1, e1, r, f, h);
                        var v = c(e1.marker.symbol), y = o.isBubble(e1);
                        h("marker.line.width", v || y ? 1 : 0), function(t1, e1, r, n) {
                            var i, a, o = e1.dimensions, s = o.length, l = e1.showupperhalf, c = e1.showlowerhalf, u = e1.diagonal.visible, f = new Array(s), h = new Array(s);
                            for(i = 0; i < s; i++){
                                var p = i ? i + 1 : "";
                                f[i] = "x" + p, h[i] = "y" + p;
                            }
                            var d = n("xaxes", f), m = n("yaxes", h), g = e1._diag = new Array(s);
                            e1._xaxes = {}, e1._yaxes = {};
                            var v = [], y = [];
                            function x(t1, n, i, a) {
                                if (t1) {
                                    var o = t1.charAt(0), s = r._splomAxes[o];
                                    if (e1["_" + o + "axes"][t1] = 1, a.push(t1), !(t1 in s)) {
                                        var l = s[t1] = {};
                                        i && (l.label = i.label || "", i.visible && i.axis && (i.axis.type && (l.type = i.axis.type), i.axis.matches && (l.matches = n)));
                                    }
                                }
                            }
                            var b = !u && !c, _ = !u && !l;
                            for(e1._axesDim = {}, i = 0; i < s; i++){
                                var w = o[i], T = 0 === i, k = i === s - 1, A = T && b || k && _ ? void 0 : d[i], M = T && _ || k && b ? void 0 : m[i];
                                x(A, M, w, v), x(M, A, w, y), g[i] = [
                                    A,
                                    M
                                ], e1._axesDim[A] = i, e1._axesDim[M] = i;
                            }
                            for(i = 0; i < v.length; i++)for(a = 0; a < y.length; a++){
                                var S = v[i] + y[a];
                                i > a && l || i < a && c ? r._splomSubplots[S] = 1 : i !== a || !u && c && l || (r._splomSubplots[S] = 1);
                            }
                            (!c || !u && l && c) && (r._splomGridDflt.xside = "bottom", r._splomGridDflt.yside = "left");
                        }(0, e1, f, h), n.coerceSelectionMarkerOpacity(e1, h);
                    } else e1.visible = !1;
                };
            },
            {
                "../../lib": 503,
                "../../plots/array_container_defaults": 549,
                "../parcoords/merge_length": 897,
                "../scatter/marker_defaults": 945,
                "../scatter/subtypes": 951,
                "../scattergl/helpers": 985,
                "./attributes": 1029
            }
        ],
        1033: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../scatter/colorscale_calc"), a = t1("../scattergl/convert").markerStyle;
                e1.exports = function(t1, e1) {
                    var r = e1.trace, o = t1._fullLayout._splomScenes[r.uid];
                    if (o) {
                        i(t1, r), n.extendFlat(o.matrixOptions, a(r));
                        var s = n.extendFlat({}, o.matrixOptions, o.viewOpts);
                        o.matrix.update(s, null);
                    }
                };
            },
            {
                "../../lib": 503,
                "../scatter/colorscale_calc": 929,
                "../scattergl/convert": 981
            }
        ],
        1034: [
            function(t1, e1, r) {
                "use strict";
                r.getDimIndex = function(t1, e1) {
                    for(var r = e1._id, n = {
                        x: 0,
                        y: 1
                    }[r.charAt(0)], i = t1._visibleDims, a = 0; a < i.length; a++){
                        var o = i[a];
                        if (t1._diag[o][n] === r) return a;
                    }
                    return !1;
                };
            },
            {}
        ],
        1035: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./helpers"), i = t1("../scattergl/hover").calcHover;
                e1.exports = {
                    hoverPoints: function(t1, e1, r) {
                        var a = t1.cd[0].trace, o = t1.scene.matrixOptions.cdata, s = t1.xa, l = t1.ya, c = s.c2p(e1), u = l.c2p(r), f = t1.distance, h = n.getDimIndex(a, s), p = n.getDimIndex(a, l);
                        if (!1 === h || !1 === p) return [
                            t1
                        ];
                        for(var d, m, g = o[h], v = o[p], y = f, x = 0; x < g.length; x++){
                            var b = g[x], _ = v[x], w = s.c2p(b) - c, T = l.c2p(_) - u, k = Math.sqrt(w * w + T * T);
                            k < y && (y = m = k, d = x);
                        }
                        return t1.index = d, t1.distance = y, t1.dxy = m, void 0 === d ? [
                            t1
                        ] : [
                            i(t1, g, v, a)
                        ];
                    }
                };
            },
            {
                "../scattergl/hover": 986,
                "./helpers": 1034
            }
        ],
        1036: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../components/grid");
                e1.exports = {
                    moduleType: "trace",
                    name: "splom",
                    basePlotModule: t1("./base_plot"),
                    categories: [
                        "gl",
                        "regl",
                        "cartesian",
                        "symbols",
                        "showLegend",
                        "scatter-like"
                    ],
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: t1("../scatter/marker_colorbar"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    hoverPoints: t1("./hover").hoverPoints,
                    selectPoints: t1("./select"),
                    editStyle: t1("./edit_style"),
                    meta: {}
                }, n.register(i);
            },
            {
                "../../components/grid": 410,
                "../../registry": 638,
                "../scatter/marker_colorbar": 944,
                "./attributes": 1029,
                "./base_plot": 1030,
                "./calc": 1031,
                "./defaults": 1032,
                "./edit_style": 1033,
                "./hover": 1035,
                "./plot": 1037,
                "./select": 1039
            }
        ],
        1037: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("regl-splom"), i = t1("../../lib"), a = t1("../../plots/cartesian/axis_ids"), o = t1("../../components/dragelement/helpers").selectMode;
                function s(t1, e1) {
                    var r, s, l, c, u, f = t1._fullLayout, h = f._size, p = e1.trace, d = e1.t, m = f._splomScenes[p.uid], g = m.matrixOptions, v = g.cdata, y = f._glcanvas.data()[0].regl, x = f.dragmode;
                    if (0 !== v.length) {
                        g.lower = p.showupperhalf, g.upper = p.showlowerhalf, g.diagonal = p.diagonal.visible;
                        var b = p._visibleDims, _ = v.length, w = m.viewOpts = {};
                        for(w.ranges = new Array(_), w.domains = new Array(_), u = 0; u < b.length; u++){
                            l = b[u];
                            var T = w.ranges[u] = new Array(4), k = w.domains[u] = new Array(4);
                            (r = a.getFromId(t1, p._diag[l][0])) && (T[0] = r._rl[0], T[2] = r._rl[1], k[0] = r.domain[0], k[2] = r.domain[1]), (s = a.getFromId(t1, p._diag[l][1])) && (T[1] = s._rl[0], T[3] = s._rl[1], k[1] = s.domain[0], k[3] = s.domain[1]);
                        }
                        var A = t1._context.plotGlPixelRatio, M = h.l * A, S = h.b * A, E = h.w * A, L = h.h * A;
                        w.viewport = [
                            M,
                            S,
                            E + M,
                            L + S
                        ], !0 === m.matrix && (m.matrix = n(y));
                        var C = f.clickmode.indexOf("select") > -1, P = !0;
                        if (o(x) || !!p.selectedpoints || C) {
                            var I = p._length;
                            if (p.selectedpoints) {
                                m.selectBatch = p.selectedpoints;
                                var O = p.selectedpoints, z = {};
                                for(l = 0; l < O.length; l++)z[O[l]] = !0;
                                var D = [];
                                for(l = 0; l < I; l++)z[l] || D.push(l);
                                m.unselectBatch = D;
                            }
                            var R = d.xpx = new Array(_), F = d.ypx = new Array(_);
                            for(u = 0; u < b.length; u++){
                                if (l = b[u], r = a.getFromId(t1, p._diag[l][0])) for(R[u] = new Array(I), c = 0; c < I; c++)R[u][c] = r.c2p(v[u][c]);
                                if (s = a.getFromId(t1, p._diag[l][1])) for(F[u] = new Array(I), c = 0; c < I; c++)F[u][c] = s.c2p(v[u][c]);
                            }
                            if (m.selectBatch.length || m.unselectBatch.length) {
                                var B = i.extendFlat({}, g, m.unselectedOptions, w), N = i.extendFlat({}, g, m.selectedOptions, w);
                                m.matrix.update(B, N), P = !1;
                            }
                        } else d.xpx = d.ypx = null;
                        if (P) {
                            var j = i.extendFlat({}, g, w);
                            m.matrix.update(j, null);
                        }
                    }
                }
                e1.exports = function(t1, e1, r) {
                    if (r.length) for(var n = 0; n < r.length; n++)s(t1, r[n][0]);
                };
            },
            {
                "../../components/dragelement/helpers": 384,
                "../../lib": 503,
                "../../plots/cartesian/axis_ids": 558,
                "regl-splom": 282
            }
        ],
        1038: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib");
                e1.exports = function(t1, e1) {
                    var r = t1._fullLayout, i = e1.uid, a = r._splomScenes;
                    a || (a = r._splomScenes = {});
                    var o = {
                        dirty: !0,
                        selectBatch: [],
                        unselectBatch: []
                    }, s = a[e1.uid];
                    return s || ((s = a[i] = n.extendFlat({}, o, {
                        matrix: !1,
                        selectBatch: [],
                        unselectBatch: []
                    })).draw = function() {
                        s.matrix && s.matrix.draw && (s.selectBatch.length || s.unselectBatch.length ? s.matrix.draw(s.unselectBatch, s.selectBatch) : s.matrix.draw()), s.dirty = !1;
                    }, s.destroy = function() {
                        s.matrix && s.matrix.destroy && s.matrix.destroy(), s.matrixOptions = null, s.selectBatch = null, s.unselectBatch = null, s = null;
                    }), s.dirty || n.extendFlat(s, o), s;
                };
            },
            {
                "../../lib": 503
            }
        ],
        1039: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../scatter/subtypes"), a = t1("./helpers");
                e1.exports = function(t1, e1) {
                    var r = t1.cd, o = r[0].trace, s = r[0].t, l = t1.scene, c = l.matrixOptions.cdata, u = t1.xaxis, f = t1.yaxis, h = [];
                    if (!l) return h;
                    var p = !i.hasMarkers(o) && !i.hasText(o);
                    if (!0 !== o.visible || p) return h;
                    var d = a.getDimIndex(o, u), m = a.getDimIndex(o, f);
                    if (!1 === d || !1 === m) return h;
                    var g = s.xpx[d], v = s.ypx[m], y = c[d], x = c[m], b = [], _ = [];
                    if (!1 !== e1 && !e1.degenerate) for(var w = 0; w < y.length; w++)e1.contains([
                        g[w],
                        v[w]
                    ], null, w, t1) ? (b.push(w), h.push({
                        pointNumber: w,
                        x: y[w],
                        y: x[w]
                    })) : _.push(w);
                    var T = l.matrixOptions;
                    return b.length || _.length ? l.selectBatch.length || l.unselectBatch.length || l.matrix.update(l.unselectedOptions, n.extendFlat({}, T, l.selectedOptions, l.viewOpts)) : l.matrix.update(T, null), l.selectBatch = b, l.unselectBatch = _, h;
                };
            },
            {
                "../../lib": 503,
                "../scatter/subtypes": 951,
                "./helpers": 1034
            }
        ],
        1040: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/attributes"), i = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, a = t1("../../plots/template_attributes").hovertemplateAttrs, o = t1("../mesh3d/attributes"), s = t1("../../plots/attributes"), l = t1("../../lib/extend").extendFlat, c = {
                    x: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    z: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    u: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    v: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    w: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    starts: {
                        x: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        y: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        z: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    maxdisplayed: {
                        valType: "integer",
                        min: 0,
                        dflt: 1e3,
                        editType: "calc"
                    },
                    sizeref: {
                        valType: "number",
                        editType: "calc",
                        min: 0,
                        dflt: 1
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    hovertemplate: a({
                        editType: "calc"
                    }, {
                        keys: [
                            "tubex",
                            "tubey",
                            "tubez",
                            "tubeu",
                            "tubev",
                            "tubew",
                            "norm",
                            "divergence"
                        ]
                    }),
                    uhoverformat: i("u", 1),
                    vhoverformat: i("v", 1),
                    whoverformat: i("w", 1),
                    xhoverformat: i("x"),
                    yhoverformat: i("y"),
                    zhoverformat: i("z"),
                    showlegend: l({}, s.showlegend, {
                        dflt: !1
                    })
                };
                l(c, n("", {
                    colorAttr: "u/v/w norm",
                    showScaleDflt: !0,
                    editTypeOverride: "calc"
                }));
                [
                    "opacity",
                    "lightposition",
                    "lighting"
                ].forEach(function(t1) {
                    c[t1] = o[t1];
                }), c.hoverinfo = l({}, s.hoverinfo, {
                    editType: "calc",
                    flags: [
                        "x",
                        "y",
                        "z",
                        "u",
                        "v",
                        "w",
                        "norm",
                        "divergence",
                        "text",
                        "name"
                    ],
                    dflt: "x+y+z+norm+text+name"
                }), c.transforms = void 0, e1.exports = c;
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/template_attributes": 633,
                "../mesh3d/attributes": 867
            }
        ],
        1041: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/colorscale/calc");
                function a(t1) {
                    var e1, r, i, a, s, l, c, u, f, h, p, d, m = t1._x, g = t1._y, v = t1._z, y = t1._len, x = -1 / 0, b = 1 / 0, _ = -1 / 0, w = 1 / 0, T = -1 / 0, k = 1 / 0, A = "";
                    for(y && (c = m[0], f = g[0], p = v[0]), y > 1 && (u = m[y - 1], h = g[y - 1], d = v[y - 1]), e1 = 0; e1 < y; e1++)x = Math.max(x, m[e1]), b = Math.min(b, m[e1]), _ = Math.max(_, g[e1]), w = Math.min(w, g[e1]), T = Math.max(T, v[e1]), k = Math.min(k, v[e1]), a || m[e1] === c || (a = !0, A += "x"), s || g[e1] === f || (s = !0, A += "y"), l || v[e1] === p || (l = !0, A += "z");
                    a || (A += "x"), s || (A += "y"), l || (A += "z");
                    var M = o(t1._x), S = o(t1._y), E = o(t1._z);
                    A = (A = (A = A.replace("x", (c > u ? "-" : "+") + "x")).replace("y", (f > h ? "-" : "+") + "y")).replace("z", (p > d ? "-" : "+") + "z");
                    var L = function() {
                        y = 0, M = [], S = [], E = [];
                    };
                    (!y || y < M.length * S.length * E.length) && L();
                    var C = function(t1) {
                        return "x" === t1 ? m : "y" === t1 ? g : v;
                    }, P = function(t1) {
                        return "x" === t1 ? M : "y" === t1 ? S : E;
                    }, I = function(t1) {
                        return t1[y - 1] < t1[0] ? -1 : 1;
                    }, O = C(A[1]), z = C(A[3]), D = C(A[5]), R = P(A[1]).length, F = P(A[3]).length, B = P(A[5]).length, N = !1, j = function(t1, e1, r) {
                        return R * (F * t1 + e1) + r;
                    }, U = I(C(A[1])), V = I(C(A[3])), H = I(C(A[5]));
                    for(e1 = 0; e1 < B - 1; e1++){
                        for(r = 0; r < F - 1; r++){
                            for(i = 0; i < R - 1; i++){
                                var q = j(e1, r, i), G = j(e1, r, i + 1), Y = j(e1, r + 1, i), W = j(e1 + 1, r, i);
                                if (O[q] * U < O[G] * U && z[q] * V < z[Y] * V && D[q] * H < D[W] * H || (N = !0), N) break;
                            }
                            if (N) break;
                        }
                        if (N) break;
                    }
                    return N && (n.warn("Encountered arbitrary coordinates! Unable to input data grid."), L()), {
                        xMin: b,
                        yMin: w,
                        zMin: k,
                        xMax: x,
                        yMax: _,
                        zMax: T,
                        Xs: M,
                        Ys: S,
                        Zs: E,
                        len: y,
                        fill: A
                    };
                }
                function o(t1) {
                    return n.distinctVals(t1).vals;
                }
                function s(t1, e1) {
                    if (void 0 === e1 && (e1 = t1.length), n.isTypedArray(t1)) return t1.subarray(0, e1);
                    for(var r = [], i = 0; i < e1; i++)r[i] = +t1[i];
                    return r;
                }
                e1.exports = {
                    calc: function(t1, e1) {
                        e1._len = Math.min(e1.u.length, e1.v.length, e1.w.length, e1.x.length, e1.y.length, e1.z.length), e1._u = s(e1.u, e1._len), e1._v = s(e1.v, e1._len), e1._w = s(e1.w, e1._len), e1._x = s(e1.x, e1._len), e1._y = s(e1.y, e1._len), e1._z = s(e1.z, e1._len);
                        var r = a(e1);
                        e1._gridFill = r.fill, e1._Xs = r.Xs, e1._Ys = r.Ys, e1._Zs = r.Zs, e1._len = r.len;
                        var n, o, l, c = 0;
                        e1.starts && (n = s(e1.starts.x || []), o = s(e1.starts.y || []), l = s(e1.starts.z || []), c = Math.min(n.length, o.length, l.length)), e1._startsX = n || [], e1._startsY = o || [], e1._startsZ = l || [];
                        var u, f = 0, h = 1 / 0;
                        for(u = 0; u < e1._len; u++){
                            var p = e1._u[u], d = e1._v[u], m = e1._w[u], g = Math.sqrt(p * p + d * d + m * m);
                            f = Math.max(f, g), h = Math.min(h, g);
                        }
                        for(i(t1, e1, {
                            vals: [
                                h,
                                f
                            ],
                            containerStr: "",
                            cLetter: "c"
                        }), u = 0; u < c; u++){
                            var v = n[u];
                            r.xMax = Math.max(r.xMax, v), r.xMin = Math.min(r.xMin, v);
                            var y = o[u];
                            r.yMax = Math.max(r.yMax, y), r.yMin = Math.min(r.yMin, y);
                            var x = l[u];
                            r.zMax = Math.max(r.zMax, x), r.zMin = Math.min(r.zMin, x);
                        }
                        e1._slen = c, e1._normMax = f, e1._xbnds = [
                            r.xMin,
                            r.xMax
                        ], e1._ybnds = [
                            r.yMin,
                            r.yMax
                        ], e1._zbnds = [
                            r.zMin,
                            r.zMax
                        ];
                    },
                    filter: s,
                    processGrid: a
                };
            },
            {
                "../../components/colorscale/calc": 374,
                "../../lib": 503
            }
        ],
        1042: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../stackgl_modules").gl_streamtube3d, i = n.createTubeMesh, a = t1("../../lib"), o = t1("../../lib/gl_format_color").parseColorScale, s = t1("../../components/colorscale").extractOpts, l = t1("../../plots/gl3d/zip3"), c = {
                    xaxis: 0,
                    yaxis: 1,
                    zaxis: 2
                };
                function u(t1, e1) {
                    this.scene = t1, this.uid = e1, this.mesh = null, this.data = null;
                }
                var f = u.prototype;
                function h(t1) {
                    var e1 = t1.length;
                    return e1 > 2 ? t1.slice(1, e1 - 1) : 2 === e1 ? [
                        (t1[0] + t1[1]) / 2
                    ] : t1;
                }
                function p(t1) {
                    var e1 = t1.length;
                    return 1 === e1 ? [
                        .5,
                        .5
                    ] : [
                        t1[1] - t1[0],
                        t1[e1 - 1] - t1[e1 - 2]
                    ];
                }
                function d(t1, e1) {
                    var r = t1.fullSceneLayout, i = t1.dataScale, u = e1._len, f = {};
                    function d(t1, e1) {
                        var n = r[e1], o = i[c[e1]];
                        return a.simpleMap(t1, function(t1) {
                            return n.d2l(t1) * o;
                        });
                    }
                    if (f.vectors = l(d(e1._u, "xaxis"), d(e1._v, "yaxis"), d(e1._w, "zaxis"), u), !u) return {
                        positions: [],
                        cells: []
                    };
                    var m = d(e1._Xs, "xaxis"), g = d(e1._Ys, "yaxis"), v = d(e1._Zs, "zaxis");
                    if (f.meshgrid = [
                        m,
                        g,
                        v
                    ], f.gridFill = e1._gridFill, e1._slen) f.startingPositions = l(d(e1._startsX, "xaxis"), d(e1._startsY, "yaxis"), d(e1._startsZ, "zaxis"));
                    else {
                        for(var y = g[0], x = h(m), b = h(v), _ = new Array(x.length * b.length), w = 0, T = 0; T < x.length; T++)for(var k = 0; k < b.length; k++)_[w++] = [
                            x[T],
                            y,
                            b[k]
                        ];
                        f.startingPositions = _;
                    }
                    f.colormap = o(e1), f.tubeSize = e1.sizeref, f.maxLength = e1.maxdisplayed;
                    var A = d(e1._xbnds, "xaxis"), M = d(e1._ybnds, "yaxis"), S = d(e1._zbnds, "zaxis"), E = p(m), L = p(g), C = p(v), P = [
                        [
                            A[0] - E[0],
                            M[0] - L[0],
                            S[0] - C[0]
                        ],
                        [
                            A[1] + E[1],
                            M[1] + L[1],
                            S[1] + C[1]
                        ]
                    ], I = n(f, P), O = s(e1);
                    I.vertexIntensityBounds = [
                        O.min / e1._normMax,
                        O.max / e1._normMax
                    ];
                    var z = e1.lightposition;
                    return I.lightPosition = [
                        z.x,
                        z.y,
                        z.z
                    ], I.ambient = e1.lighting.ambient, I.diffuse = e1.lighting.diffuse, I.specular = e1.lighting.specular, I.roughness = e1.lighting.roughness, I.fresnel = e1.lighting.fresnel, I.opacity = e1.opacity, e1._pad = I.tubeScale * e1.sizeref * 2, I;
                }
                f.handlePick = function(t1) {
                    var e1 = this.scene.fullSceneLayout, r = this.scene.dataScale;
                    function n(t1, n) {
                        var i = e1[n], a = r[c[n]];
                        return i.l2c(t1) / a;
                    }
                    if (t1.object === this.mesh) {
                        var i = t1.data.position, a = t1.data.velocity;
                        return t1.traceCoordinate = [
                            n(i[0], "xaxis"),
                            n(i[1], "yaxis"),
                            n(i[2], "zaxis"),
                            n(a[0], "xaxis"),
                            n(a[1], "yaxis"),
                            n(a[2], "zaxis"),
                            t1.data.intensity * this.data._normMax,
                            t1.data.divergence
                        ], t1.textLabel = this.data.hovertext || this.data.text, !0;
                    }
                }, f.update = function(t1) {
                    this.data = t1;
                    var e1 = d(this.scene, t1);
                    this.mesh.update(e1);
                }, f.dispose = function() {
                    this.scene.glplot.remove(this.mesh), this.mesh.dispose();
                }, e1.exports = function(t1, e1) {
                    var r = t1.glplot.gl, n = d(t1, e1), a = i(r, n), o = new u(t1, e1.uid);
                    return o.mesh = a, o.data = e1, a._trace = o, t1.glplot.add(a), o;
                };
            },
            {
                "../../../stackgl_modules": 1120,
                "../../components/colorscale": 378,
                "../../lib": 503,
                "../../lib/gl_format_color": 499,
                "../../plots/gl3d/zip3": 609
            }
        ],
        1043: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/colorscale/defaults"), a = t1("./attributes");
                e1.exports = function(t1, e1, r, o) {
                    function s(r, i) {
                        return n.coerce(t1, e1, a, r, i);
                    }
                    var l = s("u"), c = s("v"), u = s("w"), f = s("x"), h = s("y"), p = s("z");
                    l && l.length && c && c.length && u && u.length && f && f.length && h && h.length && p && p.length ? (s("starts.x"), s("starts.y"), s("starts.z"), s("maxdisplayed"), s("sizeref"), s("lighting.ambient"), s("lighting.diffuse"), s("lighting.specular"), s("lighting.roughness"), s("lighting.fresnel"), s("lightposition.x"), s("lightposition.y"), s("lightposition.z"), i(t1, e1, o, s, {
                        prefix: "",
                        cLetter: "c"
                    }), s("text"), s("hovertext"), s("hovertemplate"), s("uhoverformat"), s("vhoverformat"), s("whoverformat"), s("xhoverformat"), s("yhoverformat"), s("zhoverformat"), e1._length = null) : e1.visible = !1;
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../lib": 503,
                "./attributes": 1040
            }
        ],
        1044: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "streamtube",
                    basePlotModule: t1("../../plots/gl3d"),
                    categories: [
                        "gl3d",
                        "showLegend"
                    ],
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    colorbar: {
                        min: "cmin",
                        max: "cmax"
                    },
                    calc: t1("./calc").calc,
                    plot: t1("./convert"),
                    eventData: function(t1, e1) {
                        return t1.tubex = t1.x, t1.tubey = t1.y, t1.tubez = t1.z, t1.tubeu = e1.traceCoordinate[3], t1.tubev = e1.traceCoordinate[4], t1.tubew = e1.traceCoordinate[5], t1.norm = e1.traceCoordinate[6], t1.divergence = e1.traceCoordinate[7], delete t1.x, delete t1.y, delete t1.z, t1;
                    },
                    meta: {}
                };
            },
            {
                "../../plots/gl3d": 598,
                "./attributes": 1040,
                "./calc": 1041,
                "./convert": 1042,
                "./defaults": 1043
            }
        ],
        1045: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/attributes"), i = t1("../../plots/template_attributes").hovertemplateAttrs, a = t1("../../plots/template_attributes").texttemplateAttrs, o = t1("../../components/colorscale/attributes"), s = t1("../../plots/domain").attributes, l = t1("../pie/attributes"), c = t1("./constants"), u = t1("../../lib/extend").extendFlat;
                e1.exports = {
                    labels: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    parents: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    values: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    branchvalues: {
                        valType: "enumerated",
                        values: [
                            "remainder",
                            "total"
                        ],
                        dflt: "remainder",
                        editType: "calc"
                    },
                    count: {
                        valType: "flaglist",
                        flags: [
                            "branches",
                            "leaves"
                        ],
                        dflt: "leaves",
                        editType: "calc"
                    },
                    level: {
                        valType: "any",
                        editType: "plot",
                        anim: !0
                    },
                    maxdepth: {
                        valType: "integer",
                        editType: "plot",
                        dflt: -1
                    },
                    marker: u({
                        colors: {
                            valType: "data_array",
                            editType: "calc"
                        },
                        line: {
                            color: u({}, l.marker.line.color, {
                                dflt: null
                            }),
                            width: u({}, l.marker.line.width, {
                                dflt: 1
                            }),
                            editType: "calc"
                        },
                        editType: "calc"
                    }, o("marker", {
                        colorAttr: "colors",
                        anim: !1
                    })),
                    leaf: {
                        opacity: {
                            valType: "number",
                            editType: "style",
                            min: 0,
                            max: 1
                        },
                        editType: "plot"
                    },
                    text: l.text,
                    textinfo: {
                        valType: "flaglist",
                        flags: [
                            "label",
                            "text",
                            "value",
                            "current path",
                            "percent root",
                            "percent entry",
                            "percent parent"
                        ],
                        extras: [
                            "none"
                        ],
                        editType: "plot"
                    },
                    texttemplate: a({
                        editType: "plot"
                    }, {
                        keys: c.eventDataKeys.concat([
                            "label",
                            "value"
                        ])
                    }),
                    hovertext: l.hovertext,
                    hoverinfo: u({}, n.hoverinfo, {
                        flags: [
                            "label",
                            "text",
                            "value",
                            "name",
                            "current path",
                            "percent root",
                            "percent entry",
                            "percent parent"
                        ],
                        dflt: "label+text+value+name"
                    }),
                    hovertemplate: i({}, {
                        keys: c.eventDataKeys
                    }),
                    textfont: l.textfont,
                    insidetextorientation: l.insidetextorientation,
                    insidetextfont: l.insidetextfont,
                    outsidetextfont: u({}, l.outsidetextfont, {}),
                    rotation: {
                        valType: "angle",
                        dflt: 0,
                        editType: "plot"
                    },
                    sort: l.sort,
                    root: {
                        color: {
                            valType: "color",
                            editType: "calc",
                            dflt: "rgba(0,0,0,0)"
                        },
                        editType: "calc"
                    },
                    domain: s({
                        name: "sunburst",
                        trace: !0,
                        editType: "calc"
                    })
                };
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/domain": 584,
                "../../plots/template_attributes": 633,
                "../pie/attributes": 900,
                "./constants": 1048
            }
        ],
        1046: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/plots");
                r.name = "sunburst", r.plot = function(t1, e1, i, a) {
                    n.plotBasePlot(r.name, t1, e1, i, a);
                }, r.clean = function(t1, e1, i, a) {
                    n.cleanBasePlot(r.name, t1, e1, i, a);
                };
            },
            {
                "../../plots/plots": 619
            }
        ],
        1047: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("d3-hierarchy"), i = t1("fast-isnumeric"), a = t1("../../lib"), o = t1("../../components/colorscale").makeColorScaleFuncFromTrace, s = t1("../pie/calc").makePullColorFn, l = t1("../pie/calc").generateExtendedColors, c = t1("../../components/colorscale").calc, u = t1("../../constants/numerical").ALMOST_EQUAL, f = {}, h = {}, p = {};
                r.calc = function(t1, e1) {
                    var r, l, f, h, p, d, m = t1._fullLayout, g = e1.ids, v = a.isArrayOrTypedArray(g), y = e1.labels, x = e1.parents, b = e1.values, _ = a.isArrayOrTypedArray(b), w = [], T = {}, k = {}, A = function(t1) {
                        return t1 || "number" == typeof t1;
                    }, M = function(t1) {
                        return !_ || i(b[t1]) && b[t1] >= 0;
                    };
                    v ? (r = Math.min(g.length, x.length), l = function(t1) {
                        return A(g[t1]) && M(t1);
                    }, f = function(t1) {
                        return String(g[t1]);
                    }) : (r = Math.min(y.length, x.length), l = function(t1) {
                        return A(y[t1]) && M(t1);
                    }, f = function(t1) {
                        return String(y[t1]);
                    }), _ && (r = Math.min(r, b.length));
                    for(var S = 0; S < r; S++)if (l(S)) {
                        var E = f(S), L = A(x[S]) ? String(x[S]) : "", C = {
                            i: S,
                            id: E,
                            pid: L,
                            label: A(y[S]) ? String(y[S]) : ""
                        };
                        _ && (C.v = +b[S]), w.push(C), p = E, T[h = L] ? T[h].push(p) : T[h] = [
                            p
                        ], k[p] = 1;
                    }
                    if (T[""]) {
                        if (T[""].length > 1) {
                            for(var P = a.randstr(), I = 0; I < w.length; I++)"" === w[I].pid && (w[I].pid = P);
                            w.unshift({
                                hasMultipleRoots: !0,
                                id: P,
                                pid: "",
                                label: ""
                            });
                        }
                    } else {
                        var O, z = [];
                        for(O in T)k[O] || z.push(O);
                        if (1 !== z.length) return a.warn([
                            "Multiple implied roots, cannot build",
                            e1.type,
                            "hierarchy of",
                            e1.name + ".",
                            "These roots include:",
                            z.join(", ")
                        ].join(" "));
                        O = z[0], w.unshift({
                            hasImpliedRoot: !0,
                            id: O,
                            pid: "",
                            label: O
                        });
                    }
                    try {
                        d = n.stratify().id(function(t1) {
                            return t1.id;
                        }).parentId(function(t1) {
                            return t1.pid;
                        })(w);
                    } catch (t1) {
                        return a.warn([
                            "Failed to build",
                            e1.type,
                            "hierarchy of",
                            e1.name + ".",
                            "Error:",
                            t1.message
                        ].join(" "));
                    }
                    var D = n.hierarchy(d), R = !1;
                    if (_) switch(e1.branchvalues){
                        case "remainder":
                            D.sum(function(t1) {
                                return t1.data.v;
                            });
                            break;
                        case "total":
                            D.each(function(t1) {
                                var r = t1.data.data, n = r.v;
                                if (t1.children) {
                                    var i = t1.children.reduce(function(t1, e1) {
                                        return t1 + e1.data.data.v;
                                    }, 0);
                                    if ((r.hasImpliedRoot || r.hasMultipleRoots) && (n = i), n < i * u) return R = !0, a.warn([
                                        "Total value for node",
                                        t1.data.data.id,
                                        "of",
                                        e1.name,
                                        "is smaller than the sum of its children.",
                                        "\nparent value =",
                                        n,
                                        "\nchildren sum =",
                                        i
                                    ].join(" "));
                                }
                                t1.value = n;
                            });
                    }
                    else !function t1(e1, r, n) {
                        var i = 0, a = e1.children;
                        if (a) {
                            for(var o = a.length, s = 0; s < o; s++)i += t1(a[s], r, n);
                            n.branches && i++;
                        } else n.leaves && i++;
                        e1.value = e1.data.data.value = i, r._values || (r._values = []);
                        return r._values[e1.data.data.i] = i, i;
                    }(D, e1, {
                        branches: -1 !== e1.count.indexOf("branches"),
                        leaves: -1 !== e1.count.indexOf("leaves")
                    });
                    if (!R) {
                        var F, B;
                        e1.sort && D.sort(function(t1, e1) {
                            return e1.value - t1.value;
                        });
                        var N = e1.marker.colors || [], j = !!N.length;
                        return e1._hasColorscale ? (j || (N = _ ? e1.values : e1._values), c(t1, e1, {
                            vals: N,
                            containerStr: "marker",
                            cLetter: "c"
                        }), B = o(e1.marker)) : F = s(m["_" + e1.type + "colormap"]), D.each(function(t1) {
                            var r = t1.data.data;
                            r.color = e1._hasColorscale ? B(N[r.i]) : F(N[r.i], r.id);
                        }), w[0].hierarchy = D, w;
                    }
                }, r._runCrossTraceCalc = function(t1, e1) {
                    var r = e1._fullLayout, n = e1.calcdata, i = r[t1 + "colorway"], a = r["_" + t1 + "colormap"];
                    r["extend" + t1 + "colors"] && (i = l(i, "icicle" === t1 ? p : "treemap" === t1 ? h : f));
                    var o, s = 0;
                    function c(t1) {
                        var e1 = t1.data.data, r = e1.id;
                        !1 === e1.color && (a[r] ? e1.color = a[r] : t1.parent ? t1.parent.parent ? e1.color = t1.parent.data.data.color : (a[r] = e1.color = i[s % i.length], s++) : e1.color = o);
                    }
                    for(var u = 0; u < n.length; u++){
                        var d = n[u][0];
                        d.trace.type === t1 && d.hierarchy && (o = d.trace.root.color, d.hierarchy.each(c));
                    }
                }, r.crossTraceCalc = function(t1) {
                    return r._runCrossTraceCalc("sunburst", t1);
                };
            },
            {
                "../../components/colorscale": 378,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../pie/calc": 902,
                "d3-hierarchy": 115,
                "fast-isnumeric": 190
            }
        ],
        1048: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    CLICK_TRANSITION_TIME: 750,
                    CLICK_TRANSITION_EASING: "linear",
                    eventDataKeys: [
                        "currentPath",
                        "root",
                        "entry",
                        "percentRoot",
                        "percentEntry",
                        "percentParent"
                    ]
                };
            },
            {}
        ],
        1049: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./attributes"), a = t1("../../plots/domain").defaults, o = t1("../bar/defaults").handleText, s = t1("../../components/colorscale"), l = s.hasColorscale, c = s.handleDefaults;
                e1.exports = function(t1, e1, r, s) {
                    function u(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    var f = u("labels"), h = u("parents");
                    if (f && f.length && h && h.length) {
                        var p = u("values");
                        p && p.length ? u("branchvalues") : u("count"), u("level"), u("maxdepth"), u("marker.line.width") && u("marker.line.color", s.paper_bgcolor), u("marker.colors");
                        var d = e1._hasColorscale = l(t1, "marker", "colors") || (t1.marker || {}).coloraxis;
                        d && c(t1, e1, s, u, {
                            prefix: "marker.",
                            cLetter: "c"
                        }), u("leaf.opacity", d ? 1 : .7);
                        var m = u("text");
                        u("texttemplate"), e1.texttemplate || u("textinfo", Array.isArray(m) ? "text+label" : "label"), u("hovertext"), u("hovertemplate");
                        o(t1, e1, s, u, "auto", {
                            moduleHasSelected: !1,
                            moduleHasUnselected: !1,
                            moduleHasConstrain: !1,
                            moduleHasCliponaxis: !1,
                            moduleHasTextangle: !1,
                            moduleHasInsideanchor: !1
                        }), u("insidetextorientation"), u("sort"), u("rotation"), u("root.color"), a(e1, s, u), e1._length = null;
                    } else e1.visible = !1;
                };
            },
            {
                "../../components/colorscale": 378,
                "../../lib": 503,
                "../../plots/domain": 584,
                "../bar/defaults": 652,
                "./attributes": 1045
            }
        ],
        1050: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../registry"), a = t1("../../components/fx/helpers").appendArrayPointValue, o = t1("../../components/fx"), s = t1("../../lib"), l = t1("../../lib/events"), c = t1("./helpers"), u = t1("../pie/helpers").formatPieValue;
                function f(t1, e1, r) {
                    for(var n = t1.data.data, i = {
                        curveNumber: e1.index,
                        pointNumber: n.i,
                        data: e1._input,
                        fullData: e1
                    }, o = 0; o < r.length; o++){
                        var s = r[o];
                        s in t1 && (i[s] = t1[s]);
                    }
                    return "parentString" in t1 && !c.isHierarchyRoot(t1) && (i.parent = t1.parentString), a(i, e1, n.i), i;
                }
                e1.exports = function(t1, e1, r, a, h) {
                    var p = a[0], d = p.trace, m = p.hierarchy, g = "sunburst" === d.type, v = "treemap" === d.type || "icicle" === d.type;
                    "_hasHoverLabel" in d || (d._hasHoverLabel = !1), "_hasHoverEvent" in d || (d._hasHoverEvent = !1);
                    t1.on("mouseover", function(i) {
                        var a = r._fullLayout;
                        if (!r._dragging && !1 !== a.hovermode) {
                            var l, y = r._fullData[d.index], x = i.data.data, b = x.i, _ = c.isHierarchyRoot(i), w = c.getParent(m, i), T = c.getValue(i), k = function(t1) {
                                return s.castOption(y, b, t1);
                            }, A = k("hovertemplate"), M = o.castHoverinfo(y, a, b), S = a.separators;
                            if (A || M && "none" !== M && "skip" !== M) {
                                var E, L;
                                g && (E = p.cx + i.pxmid[0] * (1 - i.rInscribed), L = p.cy + i.pxmid[1] * (1 - i.rInscribed)), v && (E = i._hoverX, L = i._hoverY);
                                var C, P = {}, I = [], O = [], z = function(t1) {
                                    return -1 !== I.indexOf(t1);
                                };
                                M && (I = "all" === M ? y._module.attributes.hoverinfo.flags : M.split("+")), P.label = x.label, z("label") && P.label && O.push(P.label), x.hasOwnProperty("v") && (P.value = x.v, P.valueLabel = u(P.value, S), z("value") && O.push(P.valueLabel)), P.currentPath = i.currentPath = c.getPath(i.data), z("current path") && !_ && O.push(P.currentPath);
                                var D = [], R = function() {
                                    -1 === D.indexOf(C) && (O.push(C), D.push(C));
                                };
                                P.percentParent = i.percentParent = T / c.getValue(w), P.parent = i.parentString = c.getPtLabel(w), z("percent parent") && (C = c.formatPercent(P.percentParent, S) + " of " + P.parent, R()), P.percentEntry = i.percentEntry = T / c.getValue(e1), P.entry = i.entry = c.getPtLabel(e1), !z("percent entry") || _ || i.onPathbar || (C = c.formatPercent(P.percentEntry, S) + " of " + P.entry, R()), P.percentRoot = i.percentRoot = T / c.getValue(m), P.root = i.root = c.getPtLabel(m), z("percent root") && !_ && (C = c.formatPercent(P.percentRoot, S) + " of " + P.root, R()), P.text = k("hovertext") || k("text"), z("text") && (C = P.text, s.isValidTextValue(C) && O.push(C)), l = [
                                    f(i, y, h.eventDataKeys)
                                ];
                                var F = {
                                    trace: y,
                                    y: L,
                                    _x0: i._x0,
                                    _x1: i._x1,
                                    _y0: i._y0,
                                    _y1: i._y1,
                                    text: O.join("<br>"),
                                    name: A || z("name") ? y.name : void 0,
                                    color: k("hoverlabel.bgcolor") || x.color,
                                    borderColor: k("hoverlabel.bordercolor"),
                                    fontFamily: k("hoverlabel.font.family"),
                                    fontSize: k("hoverlabel.font.size"),
                                    fontColor: k("hoverlabel.font.color"),
                                    nameLength: k("hoverlabel.namelength"),
                                    textAlign: k("hoverlabel.align"),
                                    hovertemplate: A,
                                    hovertemplateLabels: P,
                                    eventData: l
                                };
                                g && (F.x0 = E - i.rInscribed * i.rpx1, F.x1 = E + i.rInscribed * i.rpx1, F.idealAlign = i.pxmid[0] < 0 ? "left" : "right"), v && (F.x = E, F.idealAlign = E < 0 ? "left" : "right");
                                var B = [];
                                o.loneHover(F, {
                                    container: a._hoverlayer.node(),
                                    outerContainer: a._paper.node(),
                                    gd: r,
                                    inOut_bbox: B
                                }), l[0].bbox = B[0], d._hasHoverLabel = !0;
                            }
                            if (v) {
                                var N = t1.select("path.surface");
                                h.styleOne(N, i, y, {
                                    hovered: !0
                                });
                            }
                            d._hasHoverEvent = !0, r.emit("plotly_hover", {
                                points: l || [
                                    f(i, y, h.eventDataKeys)
                                ],
                                event: n.event
                            });
                        }
                    }), t1.on("mouseout", function(e1) {
                        var i = r._fullLayout, a = r._fullData[d.index], s = n.select(this).datum();
                        if (d._hasHoverEvent && (e1.originalEvent = n.event, r.emit("plotly_unhover", {
                            points: [
                                f(s, a, h.eventDataKeys)
                            ],
                            event: n.event
                        }), d._hasHoverEvent = !1), d._hasHoverLabel && (o.loneUnhover(i._hoverlayer.node()), d._hasHoverLabel = !1), v) {
                            var l = t1.select("path.surface");
                            h.styleOne(l, s, a, {
                                hovered: !1
                            });
                        }
                    }), t1.on("click", function(t1) {
                        var e1 = r._fullLayout, a = r._fullData[d.index], s = g && (c.isHierarchyRoot(t1) || c.isLeaf(t1)), u = c.getPtId(t1), p = c.isEntry(t1) ? c.findEntryWithChild(m, u) : c.findEntryWithLevel(m, u), v = c.getPtId(p), y = {
                            points: [
                                f(t1, a, h.eventDataKeys)
                            ],
                            event: n.event
                        };
                        s || (y.nextLevel = v);
                        var x = l.triggerHandler(r, "plotly_" + d.type + "click", y);
                        if (!1 !== x && e1.hovermode && (r._hoverdata = [
                            f(t1, a, h.eventDataKeys)
                        ], o.click(r, n.event)), !s && !1 !== x && !r._dragging && !r._transitioning) {
                            i.call("_storeDirectGUIEdit", a, e1._tracePreGUI[a.uid], {
                                level: a.level
                            });
                            var b = {
                                data: [
                                    {
                                        level: v
                                    }
                                ],
                                traces: [
                                    d.index
                                ]
                            }, _ = {
                                frame: {
                                    redraw: !1,
                                    duration: h.transitionTime
                                },
                                transition: {
                                    duration: h.transitionTime,
                                    easing: h.transitionEasing
                                },
                                mode: "immediate",
                                fromcurrent: !0
                            };
                            o.loneUnhover(e1._hoverlayer.node()), i.call("animate", r, b, _);
                        }
                    });
                };
            },
            {
                "../../components/fx": 406,
                "../../components/fx/helpers": 402,
                "../../lib": 503,
                "../../lib/events": 492,
                "../../registry": 638,
                "../pie/helpers": 905,
                "./helpers": 1051,
                "@plotly/d3": 58
            }
        ],
        1051: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/color"), a = t1("../../lib/setcursor"), o = t1("../pie/helpers");
                function s(t1) {
                    return t1.data.data.pid;
                }
                r.findEntryWithLevel = function(t1, e1) {
                    var n;
                    return e1 && t1.eachAfter(function(t1) {
                        if (r.getPtId(t1) === e1) return n = t1.copy();
                    }), n || t1;
                }, r.findEntryWithChild = function(t1, e1) {
                    var n;
                    return t1.eachAfter(function(t1) {
                        for(var i = t1.children || [], a = 0; a < i.length; a++){
                            var o = i[a];
                            if (r.getPtId(o) === e1) return n = t1.copy();
                        }
                    }), n || t1;
                }, r.isEntry = function(t1) {
                    return !t1.parent;
                }, r.isLeaf = function(t1) {
                    return !t1.children;
                }, r.getPtId = function(t1) {
                    return t1.data.data.id;
                }, r.getPtLabel = function(t1) {
                    return t1.data.data.label;
                }, r.getValue = function(t1) {
                    return t1.value;
                }, r.isHierarchyRoot = function(t1) {
                    return "" === s(t1);
                }, r.setSliceCursor = function(t1, e1, n) {
                    var i = n.isTransitioning;
                    if (!i) {
                        var o = t1.datum();
                        i = n.hideOnRoot && r.isHierarchyRoot(o) || n.hideOnLeaves && r.isLeaf(o);
                    }
                    a(t1, i ? null : "pointer");
                }, r.getInsideTextFontKey = function(t1, e1, r, i, a) {
                    var o = (a || {}).onPathbar ? "pathbar.textfont" : "insidetextfont", s = r.data.data.i;
                    return n.castOption(e1, s, o + "." + t1) || n.castOption(e1, s, "textfont." + t1) || i.size;
                }, r.getOutsideTextFontKey = function(t1, e1, r, i) {
                    var a = r.data.data.i;
                    return n.castOption(e1, a, "outsidetextfont." + t1) || n.castOption(e1, a, "textfont." + t1) || i.size;
                }, r.isOutsideText = function(t1, e1) {
                    return !t1._hasColorscale && r.isHierarchyRoot(e1);
                }, r.determineTextFont = function(t1, e1, a, o) {
                    return r.isOutsideText(t1, e1) ? function(t1, e1, n) {
                        return {
                            color: r.getOutsideTextFontKey("color", t1, e1, n),
                            family: r.getOutsideTextFontKey("family", t1, e1, n),
                            size: r.getOutsideTextFontKey("size", t1, e1, n)
                        };
                    }(t1, e1, a) : function(t1, e1, a, o) {
                        var s = (o || {}).onPathbar, l = e1.data.data, c = l.i, u = n.castOption(t1, c, (s ? "pathbar.textfont" : "insidetextfont") + ".color");
                        return !u && t1._input.textfont && (u = n.castOption(t1._input, c, "textfont.color")), {
                            color: u || i.contrast(l.color),
                            family: r.getInsideTextFontKey("family", t1, e1, a, o),
                            size: r.getInsideTextFontKey("size", t1, e1, a, o)
                        };
                    }(t1, e1, a, o);
                }, r.hasTransition = function(t1) {
                    return !!(t1 && t1.duration > 0);
                }, r.getMaxDepth = function(t1) {
                    return t1.maxdepth >= 0 ? t1.maxdepth : 1 / 0;
                }, r.isHeader = function(t1, e1) {
                    return !(r.isLeaf(t1) || t1.depth === e1._maxDepth - 1);
                }, r.getParent = function(t1, e1) {
                    return r.findEntryWithLevel(t1, s(e1));
                }, r.listPath = function(t1, e1) {
                    var n = t1.parent;
                    if (!n) return [];
                    var i = e1 ? [
                        n.data[e1]
                    ] : [
                        n
                    ];
                    return r.listPath(n, e1).concat(i);
                }, r.getPath = function(t1) {
                    return r.listPath(t1, "label").join("/") + "/";
                }, r.formatValue = o.formatPieValue, r.formatPercent = function(t1, e1) {
                    var r = n.formatPercent(t1, 0);
                    return "0%" === r && (r = o.formatPiePercent(t1, e1)), r;
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../../lib/setcursor": 524,
                "../pie/helpers": 905
            }
        ],
        1052: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "sunburst",
                    basePlotModule: t1("./base_plot"),
                    categories: [],
                    animatable: !0,
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("./layout_attributes"),
                    supplyDefaults: t1("./defaults"),
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    calc: t1("./calc").calc,
                    crossTraceCalc: t1("./calc").crossTraceCalc,
                    plot: t1("./plot").plot,
                    style: t1("./style").style,
                    colorbar: t1("../scatter/marker_colorbar"),
                    meta: {}
                };
            },
            {
                "../scatter/marker_colorbar": 944,
                "./attributes": 1045,
                "./base_plot": 1046,
                "./calc": 1047,
                "./defaults": 1049,
                "./layout_attributes": 1053,
                "./layout_defaults": 1054,
                "./plot": 1055,
                "./style": 1056
            }
        ],
        1053: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    sunburstcolorway: {
                        valType: "colorlist",
                        editType: "calc"
                    },
                    extendsunburstcolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    }
                };
            },
            {}
        ],
        1054: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./layout_attributes");
                e1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    r("sunburstcolorway", e1.colorway), r("extendsunburstcolors");
                };
            },
            {
                "../../lib": 503,
                "./layout_attributes": 1053
            }
        ],
        1055: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("d3-hierarchy"), a = t1("d3-interpolate").interpolate, o = t1("../../components/drawing"), s = t1("../../lib"), l = t1("../../lib/svg_text_utils"), c = t1("../bar/uniform_text"), u = c.recordMinTextSize, f = c.clearMinTextSize, h = t1("../pie/plot"), p = t1("../pie/helpers").getRotationAngle, d = h.computeTransform, m = h.transformInsideText, g = t1("./style").styleOne, v = t1("../bar/style").resizeText, y = t1("./fx"), x = t1("./constants"), b = t1("./helpers");
                function _(t1, e1, c, f) {
                    var h = t1._fullLayout, v = !h.uniformtext.mode && b.hasTransition(f), _ = n.select(c).selectAll("g.slice"), T = e1[0], k = T.trace, A = T.hierarchy, M = b.findEntryWithLevel(A, k.level), S = b.getMaxDepth(k), E = h._size, L = k.domain, C = E.w * (L.x[1] - L.x[0]), P = E.h * (L.y[1] - L.y[0]), I = .5 * Math.min(C, P), O = T.cx = E.l + E.w * (L.x[1] + L.x[0]) / 2, z = T.cy = E.t + E.h * (1 - L.y[0]) - P / 2;
                    if (!M) return _.remove();
                    var D = null, R = {};
                    v && _.each(function(t1) {
                        R[b.getPtId(t1)] = {
                            rpx0: t1.rpx0,
                            rpx1: t1.rpx1,
                            x0: t1.x0,
                            x1: t1.x1,
                            transform: t1.transform
                        }, !D && b.isEntry(t1) && (D = t1);
                    });
                    var F = (function(t1) {
                        return i.partition().size([
                            2 * Math.PI,
                            t1.height + 1
                        ])(t1);
                    })(M).descendants(), B = M.height + 1, N = 0, j = S;
                    T.hasMultipleRoots && b.isHierarchyRoot(M) && (F = F.slice(1), B -= 1, N = 1, j += 1), F = F.filter(function(t1) {
                        return t1.y1 <= j;
                    });
                    var U = p(k.rotation);
                    U && F.forEach(function(t1) {
                        t1.x0 += U, t1.x1 += U;
                    });
                    var V = Math.min(B, S), H = function(t1) {
                        return (t1 - N) / V * I;
                    }, q = function(t1, e1) {
                        return [
                            t1 * Math.cos(e1),
                            -t1 * Math.sin(e1)
                        ];
                    }, G = function(t1) {
                        return s.pathAnnulus(t1.rpx0, t1.rpx1, t1.x0, t1.x1, O, z);
                    }, Y = function(t1) {
                        return O + w(t1)[0] * (t1.transform.rCenter || 0) + (t1.transform.x || 0);
                    }, W = function(t1) {
                        return z + w(t1)[1] * (t1.transform.rCenter || 0) + (t1.transform.y || 0);
                    };
                    (_ = _.data(F, b.getPtId)).enter().append("g").classed("slice", !0), v ? _.exit().transition().each(function() {
                        var t1 = n.select(this);
                        t1.select("path.surface").transition().attrTween("d", function(t1) {
                            var e1 = function(t1) {
                                var e1, r = b.getPtId(t1), n = R[r], i = R[b.getPtId(M)];
                                if (i) {
                                    var o = (t1.x1 > i.x1 ? 2 * Math.PI : 0) + U;
                                    e1 = t1.rpx1 < i.rpx1 ? {
                                        x0: t1.x0,
                                        x1: t1.x1,
                                        rpx0: 0,
                                        rpx1: 0
                                    } : {
                                        x0: o,
                                        x1: o,
                                        rpx0: t1.rpx0,
                                        rpx1: t1.rpx1
                                    };
                                } else {
                                    var s, l = b.getPtId(t1.parent);
                                    _.each(function(t1) {
                                        if (b.getPtId(t1) === l) return s = t1;
                                    });
                                    var c, u = s.children;
                                    u.forEach(function(t1, e1) {
                                        if (b.getPtId(t1) === r) return c = e1;
                                    });
                                    var f = u.length, h = a(s.x0, s.x1);
                                    e1 = {
                                        rpx0: I,
                                        rpx1: I,
                                        x0: h(c / f),
                                        x1: h((c + 1) / f)
                                    };
                                }
                                return a(n, e1);
                            }(t1);
                            return function(t1) {
                                return G(e1(t1));
                            };
                        }), t1.select("g.slicetext").attr("opacity", 0);
                    }).remove() : _.exit().remove(), _.order();
                    var X = null;
                    if (v && D) {
                        var Z = b.getPtId(D);
                        _.each(function(t1) {
                            null === X && b.getPtId(t1) === Z && (X = t1.x1);
                        });
                    }
                    var J = _;
                    function K(t1) {
                        var e1 = t1.parent, r = R[b.getPtId(e1)], n = {};
                        if (r) {
                            var i = e1.children, o = i.indexOf(t1), s = i.length, l = a(r.x0, r.x1);
                            n.x0 = l(o / s), n.x1 = l(o / s);
                        } else n.x0 = n.x1 = 0;
                        return n;
                    }
                    v && (J = J.transition().each("end", function() {
                        var e1 = n.select(this);
                        b.setSliceCursor(e1, t1, {
                            hideOnRoot: !0,
                            hideOnLeaves: !0,
                            isTransitioning: !1
                        });
                    })), J.each(function(i) {
                        var c = n.select(this), f = s.ensureSingle(c, "path", "surface", function(t1) {
                            t1.style("pointer-events", "all");
                        });
                        i.rpx0 = H(i.y0), i.rpx1 = H(i.y1), i.xmid = (i.x0 + i.x1) / 2, i.pxmid = q(i.rpx1, i.xmid), i.midangle = -(i.xmid - Math.PI / 2), i.startangle = -(i.x0 - Math.PI / 2), i.stopangle = -(i.x1 - Math.PI / 2), i.halfangle = .5 * Math.min(s.angleDelta(i.x0, i.x1) || Math.PI, Math.PI), i.ring = 1 - i.rpx0 / i.rpx1, i.rInscribed = function(t1) {
                            return 0 === t1.rpx0 && s.isFullCircle([
                                t1.x0,
                                t1.x1
                            ]) ? 1 : Math.max(0, Math.min(1 / (1 + 1 / Math.sin(t1.halfangle)), t1.ring / 2));
                        }(i), v ? f.transition().attrTween("d", function(t1) {
                            var e1 = function(t1) {
                                var e1, r = R[b.getPtId(t1)], n = {
                                    x0: t1.x0,
                                    x1: t1.x1,
                                    rpx0: t1.rpx0,
                                    rpx1: t1.rpx1
                                };
                                if (r) e1 = r;
                                else if (D) {
                                    if (t1.parent) {
                                        if (X) {
                                            var i = (t1.x1 > X ? 2 * Math.PI : 0) + U;
                                            e1 = {
                                                x0: i,
                                                x1: i
                                            };
                                        } else e1 = {
                                            rpx0: I,
                                            rpx1: I
                                        }, s.extendFlat(e1, K(t1));
                                    } else e1 = {
                                        rpx0: 0,
                                        rpx1: 0
                                    };
                                } else e1 = {
                                    x0: U,
                                    x1: U
                                };
                                return a(e1, n);
                            }(t1);
                            return function(t1) {
                                return G(e1(t1));
                            };
                        }) : f.attr("d", G), c.call(y, M, t1, e1, {
                            eventDataKeys: x.eventDataKeys,
                            transitionTime: x.CLICK_TRANSITION_TIME,
                            transitionEasing: x.CLICK_TRANSITION_EASING
                        }).call(b.setSliceCursor, t1, {
                            hideOnRoot: !0,
                            hideOnLeaves: !0,
                            isTransitioning: t1._transitioning
                        }), f.call(g, i, k);
                        var p = s.ensureSingle(c, "g", "slicetext"), _ = s.ensureSingle(p, "text", "", function(t1) {
                            t1.attr("data-notex", 1);
                        }), w = s.ensureUniformFontSize(t1, b.determineTextFont(k, i, h.font));
                        _.text(r.formatSliceLabel(i, M, k, e1, h)).classed("slicetext", !0).attr("text-anchor", "middle").call(o.font, w).call(l.convertToTspans, t1);
                        var A = o.bBox(_.node());
                        i.transform = m(A, i, T), i.transform.targetX = Y(i), i.transform.targetY = W(i);
                        var S = function(t1, e1) {
                            var r = t1.transform;
                            return d(r, e1), r.fontSize = w.size, u(k.type, r, h), s.getTextTransform(r);
                        };
                        v ? _.transition().attrTween("transform", function(t1) {
                            var e1 = function(t1) {
                                var e1, r = R[b.getPtId(t1)], n = t1.transform;
                                if (r) e1 = r;
                                else if (e1 = {
                                    rpx1: t1.rpx1,
                                    transform: {
                                        textPosAngle: n.textPosAngle,
                                        scale: 0,
                                        rotate: n.rotate,
                                        rCenter: n.rCenter,
                                        x: n.x,
                                        y: n.y
                                    }
                                }, D) {
                                    if (t1.parent) {
                                        if (X) {
                                            var i = t1.x1 > X ? 2 * Math.PI : 0;
                                            e1.x0 = e1.x1 = i;
                                        } else s.extendFlat(e1, K(t1));
                                    } else e1.x0 = e1.x1 = U;
                                } else e1.x0 = e1.x1 = U;
                                var o = a(e1.transform.textPosAngle, t1.transform.textPosAngle), l = a(e1.rpx1, t1.rpx1), c = a(e1.x0, t1.x0), f = a(e1.x1, t1.x1), p = a(e1.transform.scale, n.scale), d = a(e1.transform.rotate, n.rotate), m = 0 === n.rCenter ? 3 : 0 === e1.transform.rCenter ? 1 / 3 : 1, g = a(e1.transform.rCenter, n.rCenter);
                                return function(t1) {
                                    var e1 = l(t1), r = c(t1), i = f(t1), a = function(t1) {
                                        return g(Math.pow(t1, m));
                                    }(t1), s = {
                                        pxmid: q(e1, (r + i) / 2),
                                        rpx1: e1,
                                        transform: {
                                            textPosAngle: o(t1),
                                            rCenter: a,
                                            x: n.x,
                                            y: n.y
                                        }
                                    };
                                    return u(k.type, n, h), {
                                        transform: {
                                            targetX: Y(s),
                                            targetY: W(s),
                                            scale: p(t1),
                                            rotate: d(t1),
                                            rCenter: a
                                        }
                                    };
                                };
                            }(t1);
                            return function(t1) {
                                return S(e1(t1), A);
                            };
                        }) : _.attr("transform", S(i, A));
                    });
                }
                function w(t1) {
                    var e1, r;
                    return e1 = t1.rpx1, r = t1.transform.textPosAngle, [
                        e1 * Math.sin(r),
                        -e1 * Math.cos(r)
                    ];
                }
                r.plot = function(t1, e1, r, i) {
                    var a, o, s = t1._fullLayout, l = s._sunburstlayer, c = !r, u = !s.uniformtext.mode && b.hasTransition(r);
                    (f("sunburst", s), (a = l.selectAll("g.trace.sunburst").data(e1, function(t1) {
                        return t1[0].trace.uid;
                    })).enter().append("g").classed("trace", !0).classed("sunburst", !0).attr("stroke-linejoin", "round"), a.order(), u) ? (i && (o = i()), n.transition().duration(r.duration).ease(r.easing).each("end", function() {
                        o && o();
                    }).each("interrupt", function() {
                        o && o();
                    }).each(function() {
                        l.selectAll("g.trace").each(function(e1) {
                            _(t1, e1, this, r);
                        });
                    })) : (a.each(function(e1) {
                        _(t1, e1, this, r);
                    }), s.uniformtext.mode && v(t1, s._sunburstlayer.selectAll(".trace"), "sunburst"));
                    c && a.exit().remove();
                }, r.formatSliceLabel = function(t1, e1, r, n, i) {
                    var a = r.texttemplate, o = r.textinfo;
                    if (!(a || o && "none" !== o)) return "";
                    var l = i.separators, c = n[0], u = t1.data.data, f = c.hierarchy, h = b.isHierarchyRoot(t1), p = b.getParent(f, t1), d = b.getValue(t1);
                    if (!a) {
                        var m, g = o.split("+"), v = function(t1) {
                            return -1 !== g.indexOf(t1);
                        }, y = [];
                        if (v("label") && u.label && y.push(u.label), u.hasOwnProperty("v") && v("value") && y.push(b.formatValue(u.v, l)), !h) {
                            v("current path") && y.push(b.getPath(t1.data));
                            var x = 0;
                            v("percent parent") && x++, v("percent entry") && x++, v("percent root") && x++;
                            var _ = x > 1;
                            if (x) {
                                var w, T = function(t1) {
                                    m = b.formatPercent(w, l), _ && (m += " of " + t1), y.push(m);
                                };
                                v("percent parent") && !h && (w = d / b.getValue(p), T("parent")), v("percent entry") && (w = d / b.getValue(e1), T("entry")), v("percent root") && (w = d / b.getValue(f), T("root"));
                            }
                        }
                        return v("text") && (m = s.castOption(r, u.i, "text"), s.isValidTextValue(m) && y.push(m)), y.join("<br>");
                    }
                    var k = s.castOption(r, u.i, "texttemplate");
                    if (!k) return "";
                    var A = {};
                    u.label && (A.label = u.label), u.hasOwnProperty("v") && (A.value = u.v, A.valueLabel = b.formatValue(u.v, l)), A.currentPath = b.getPath(t1.data), h || (A.percentParent = d / b.getValue(p), A.percentParentLabel = b.formatPercent(A.percentParent, l), A.parent = b.getPtLabel(p)), A.percentEntry = d / b.getValue(e1), A.percentEntryLabel = b.formatPercent(A.percentEntry, l), A.entry = b.getPtLabel(e1), A.percentRoot = d / b.getValue(f), A.percentRootLabel = b.formatPercent(A.percentRoot, l), A.root = b.getPtLabel(f), u.hasOwnProperty("color") && (A.color = u.color);
                    var M = s.castOption(r, u.i, "text");
                    return (s.isValidTextValue(M) || "" === M) && (A.text = M), A.customdata = s.castOption(r, u.i, "customdata"), s.texttemplateString(k, A, i._d3locale, A, r._meta || {});
                };
            },
            {
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../bar/style": 662,
                "../bar/uniform_text": 664,
                "../pie/helpers": 905,
                "../pie/plot": 909,
                "./constants": 1048,
                "./fx": 1050,
                "./helpers": 1051,
                "./style": 1056,
                "@plotly/d3": 58,
                "d3-hierarchy": 115,
                "d3-interpolate": 116
            }
        ],
        1056: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/color"), a = t1("../../lib"), o = t1("../bar/uniform_text").resizeText;
                function s(t1, e1, r) {
                    var n = e1.data.data, o = !e1.children, s = n.i, l = a.castOption(r, s, "marker.line.color") || i.defaultLine, c = a.castOption(r, s, "marker.line.width") || 0;
                    t1.style("stroke-width", c).call(i.fill, n.color).call(i.stroke, l).style("opacity", o ? r.leaf.opacity : null);
                }
                e1.exports = {
                    style: function(t1) {
                        var e1 = t1._fullLayout._sunburstlayer.selectAll(".trace");
                        o(t1, e1, "sunburst"), e1.each(function(t1) {
                            var e1 = n.select(this), r = t1[0].trace;
                            e1.style("opacity", r.opacity), e1.selectAll("path.surface").each(function(t1) {
                                n.select(this).call(s, t1, r);
                            });
                        });
                    },
                    styleOne: s
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../bar/uniform_text": 664,
                "@plotly/d3": 58
            }
        ],
        1057: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/color"), i = t1("../../components/colorscale/attributes"), a = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, o = t1("../../plots/template_attributes").hovertemplateAttrs, s = t1("../../plots/attributes"), l = t1("../../lib/extend").extendFlat, c = t1("../../plot_api/edit_types").overrideAll;
                function u(t1) {
                    return {
                        show: {
                            valType: "boolean",
                            dflt: !1
                        },
                        start: {
                            valType: "number",
                            dflt: null,
                            editType: "plot"
                        },
                        end: {
                            valType: "number",
                            dflt: null,
                            editType: "plot"
                        },
                        size: {
                            valType: "number",
                            dflt: null,
                            min: 0,
                            editType: "plot"
                        },
                        project: {
                            x: {
                                valType: "boolean",
                                dflt: !1
                            },
                            y: {
                                valType: "boolean",
                                dflt: !1
                            },
                            z: {
                                valType: "boolean",
                                dflt: !1
                            }
                        },
                        color: {
                            valType: "color",
                            dflt: n.defaultLine
                        },
                        usecolormap: {
                            valType: "boolean",
                            dflt: !1
                        },
                        width: {
                            valType: "number",
                            min: 1,
                            max: 16,
                            dflt: 2
                        },
                        highlight: {
                            valType: "boolean",
                            dflt: !0
                        },
                        highlightcolor: {
                            valType: "color",
                            dflt: n.defaultLine
                        },
                        highlightwidth: {
                            valType: "number",
                            min: 1,
                            max: 16,
                            dflt: 2
                        }
                    };
                }
                var f = e1.exports = c(l({
                    z: {
                        valType: "data_array"
                    },
                    x: {
                        valType: "data_array"
                    },
                    y: {
                        valType: "data_array"
                    },
                    text: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0
                    },
                    hovertext: {
                        valType: "string",
                        dflt: "",
                        arrayOk: !0
                    },
                    hovertemplate: o(),
                    xhoverformat: a("x"),
                    yhoverformat: a("y"),
                    zhoverformat: a("z"),
                    connectgaps: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    surfacecolor: {
                        valType: "data_array"
                    }
                }, i("", {
                    colorAttr: "z or surfacecolor",
                    showScaleDflt: !0,
                    autoColorDflt: !1,
                    editTypeOverride: "calc"
                }), {
                    contours: {
                        x: u(),
                        y: u(),
                        z: u()
                    },
                    hidesurface: {
                        valType: "boolean",
                        dflt: !1
                    },
                    lightposition: {
                        x: {
                            valType: "number",
                            min: -100000,
                            max: 1e5,
                            dflt: 10
                        },
                        y: {
                            valType: "number",
                            min: -100000,
                            max: 1e5,
                            dflt: 1e4
                        },
                        z: {
                            valType: "number",
                            min: -100000,
                            max: 1e5,
                            dflt: 0
                        }
                    },
                    lighting: {
                        ambient: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .8
                        },
                        diffuse: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .8
                        },
                        specular: {
                            valType: "number",
                            min: 0,
                            max: 2,
                            dflt: .05
                        },
                        roughness: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .5
                        },
                        fresnel: {
                            valType: "number",
                            min: 0,
                            max: 5,
                            dflt: .2
                        }
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1
                    },
                    opacityscale: {
                        valType: "any",
                        editType: "calc"
                    },
                    _deprecated: {
                        zauto: l({}, i.zauto, {}),
                        zmin: l({}, i.zmin, {}),
                        zmax: l({}, i.zmax, {})
                    },
                    hoverinfo: l({}, s.hoverinfo),
                    showlegend: l({}, s.showlegend, {
                        dflt: !1
                    })
                }), "calc", "nested");
                f.x.editType = f.y.editType = f.z.editType = "calc+clearAxisTypes", f.transforms = void 0;
            },
            {
                "../../components/color": 366,
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../../plots/attributes": 550,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/template_attributes": 633
            }
        ],
        1058: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/calc");
                e1.exports = function(t1, e1) {
                    e1.surfacecolor ? n(t1, e1, {
                        vals: e1.surfacecolor,
                        containerStr: "",
                        cLetter: "c"
                    }) : n(t1, e1, {
                        vals: e1.z,
                        containerStr: "",
                        cLetter: "c"
                    });
                };
            },
            {
                "../../components/colorscale/calc": 374
            }
        ],
        1059: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../stackgl_modules").gl_surface3d, i = t1("../../../stackgl_modules").ndarray, a = t1("../../../stackgl_modules").ndarray_linear_interpolate.d2, o = t1("../heatmap/interp2d"), s = t1("../heatmap/find_empties"), l = t1("../../lib").isArrayOrTypedArray, c = t1("../../lib/gl_format_color").parseColorScale, u = t1("../../lib/str2rgbarray"), f = t1("../../components/colorscale").extractOpts;
                function h(t1, e1, r) {
                    this.scene = t1, this.uid = r, this.surface = e1, this.data = null, this.showContour = [
                        !1,
                        !1,
                        !1
                    ], this.contourStart = [
                        null,
                        null,
                        null
                    ], this.contourEnd = [
                        null,
                        null,
                        null
                    ], this.contourSize = [
                        0,
                        0,
                        0
                    ], this.minValues = [
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], this.maxValues = [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ], this.dataScaleX = 1, this.dataScaleY = 1, this.refineData = !0, this.objectOffset = [
                        0,
                        0,
                        0
                    ];
                }
                var p = h.prototype;
                p.getXat = function(t1, e1, r, n) {
                    var i = l(this.data.x) ? l(this.data.x[0]) ? this.data.x[e1][t1] : this.data.x[t1] : t1;
                    return void 0 === r ? i : n.d2l(i, 0, r);
                }, p.getYat = function(t1, e1, r, n) {
                    var i = l(this.data.y) ? l(this.data.y[0]) ? this.data.y[e1][t1] : this.data.y[e1] : e1;
                    return void 0 === r ? i : n.d2l(i, 0, r);
                }, p.getZat = function(t1, e1, r, n) {
                    var i = this.data.z[e1][t1];
                    return null === i && this.data.connectgaps && this.data._interpolatedZ && (i = this.data._interpolatedZ[e1][t1]), void 0 === r ? i : n.d2l(i, 0, r);
                }, p.handlePick = function(t1) {
                    if (t1.object === this.surface) {
                        var e1 = (t1.data.index[0] - 1) / this.dataScaleX - 1, r = (t1.data.index[1] - 1) / this.dataScaleY - 1, n = Math.max(Math.min(Math.round(e1), this.data.z[0].length - 1), 0), i = Math.max(Math.min(Math.round(r), this.data._ylength - 1), 0);
                        t1.index = [
                            n,
                            i
                        ], t1.traceCoordinate = [
                            this.getXat(n, i),
                            this.getYat(n, i),
                            this.getZat(n, i)
                        ], t1.dataCoordinate = [
                            this.getXat(n, i, this.data.xcalendar, this.scene.fullSceneLayout.xaxis),
                            this.getYat(n, i, this.data.ycalendar, this.scene.fullSceneLayout.yaxis),
                            this.getZat(n, i, this.data.zcalendar, this.scene.fullSceneLayout.zaxis)
                        ];
                        for(var a = 0; a < 3; a++){
                            var o = t1.dataCoordinate[a];
                            null != o && (t1.dataCoordinate[a] *= this.scene.dataScale[a]);
                        }
                        var s = this.data.hovertext || this.data.text;
                        return Array.isArray(s) && s[i] && void 0 !== s[i][n] ? t1.textLabel = s[i][n] : t1.textLabel = s || "", t1.data.dataCoordinate = t1.dataCoordinate.slice(), this.surface.highlight(t1.data), this.scene.glplot.spikes.position = t1.dataCoordinate, !0;
                    }
                };
                var d = [
                    2,
                    3,
                    5,
                    7,
                    11,
                    13,
                    17,
                    19,
                    23,
                    29,
                    31,
                    37,
                    41,
                    43,
                    47,
                    53,
                    59,
                    61,
                    67,
                    71,
                    73,
                    79,
                    83,
                    89,
                    97,
                    101,
                    103,
                    107,
                    109,
                    113,
                    127,
                    131,
                    137,
                    139,
                    149,
                    151,
                    157,
                    163,
                    167,
                    173,
                    179,
                    181,
                    191,
                    193,
                    197,
                    199,
                    211,
                    223,
                    227,
                    229,
                    233,
                    239,
                    241,
                    251,
                    257,
                    263,
                    269,
                    271,
                    277,
                    281,
                    283,
                    293,
                    307,
                    311,
                    313,
                    317,
                    331,
                    337,
                    347,
                    349,
                    353,
                    359,
                    367,
                    373,
                    379,
                    383,
                    389,
                    397,
                    401,
                    409,
                    419,
                    421,
                    431,
                    433,
                    439,
                    443,
                    449,
                    457,
                    461,
                    463,
                    467,
                    479,
                    487,
                    491,
                    499,
                    503,
                    509,
                    521,
                    523,
                    541,
                    547,
                    557,
                    563,
                    569,
                    571,
                    577,
                    587,
                    593,
                    599,
                    601,
                    607,
                    613,
                    617,
                    619,
                    631,
                    641,
                    643,
                    647,
                    653,
                    659,
                    661,
                    673,
                    677,
                    683,
                    691,
                    701,
                    709,
                    719,
                    727,
                    733,
                    739,
                    743,
                    751,
                    757,
                    761,
                    769,
                    773,
                    787,
                    797,
                    809,
                    811,
                    821,
                    823,
                    827,
                    829,
                    839,
                    853,
                    857,
                    859,
                    863,
                    877,
                    881,
                    883,
                    887,
                    907,
                    911,
                    919,
                    929,
                    937,
                    941,
                    947,
                    953,
                    967,
                    971,
                    977,
                    983,
                    991,
                    997,
                    1009,
                    1013,
                    1019,
                    1021,
                    1031,
                    1033,
                    1039,
                    1049,
                    1051,
                    1061,
                    1063,
                    1069,
                    1087,
                    1091,
                    1093,
                    1097,
                    1103,
                    1109,
                    1117,
                    1123,
                    1129,
                    1151,
                    1153,
                    1163,
                    1171,
                    1181,
                    1187,
                    1193,
                    1201,
                    1213,
                    1217,
                    1223,
                    1229,
                    1231,
                    1237,
                    1249,
                    1259,
                    1277,
                    1279,
                    1283,
                    1289,
                    1291,
                    1297,
                    1301,
                    1303,
                    1307,
                    1319,
                    1321,
                    1327,
                    1361,
                    1367,
                    1373,
                    1381,
                    1399,
                    1409,
                    1423,
                    1427,
                    1429,
                    1433,
                    1439,
                    1447,
                    1451,
                    1453,
                    1459,
                    1471,
                    1481,
                    1483,
                    1487,
                    1489,
                    1493,
                    1499,
                    1511,
                    1523,
                    1531,
                    1543,
                    1549,
                    1553,
                    1559,
                    1567,
                    1571,
                    1579,
                    1583,
                    1597,
                    1601,
                    1607,
                    1609,
                    1613,
                    1619,
                    1621,
                    1627,
                    1637,
                    1657,
                    1663,
                    1667,
                    1669,
                    1693,
                    1697,
                    1699,
                    1709,
                    1721,
                    1723,
                    1733,
                    1741,
                    1747,
                    1753,
                    1759,
                    1777,
                    1783,
                    1787,
                    1789,
                    1801,
                    1811,
                    1823,
                    1831,
                    1847,
                    1861,
                    1867,
                    1871,
                    1873,
                    1877,
                    1879,
                    1889,
                    1901,
                    1907,
                    1913,
                    1931,
                    1933,
                    1949,
                    1951,
                    1973,
                    1979,
                    1987,
                    1993,
                    1997,
                    1999,
                    2003,
                    2011,
                    2017,
                    2027,
                    2029,
                    2039,
                    2053,
                    2063,
                    2069,
                    2081,
                    2083,
                    2087,
                    2089,
                    2099,
                    2111,
                    2113,
                    2129,
                    2131,
                    2137,
                    2141,
                    2143,
                    2153,
                    2161,
                    2179,
                    2203,
                    2207,
                    2213,
                    2221,
                    2237,
                    2239,
                    2243,
                    2251,
                    2267,
                    2269,
                    2273,
                    2281,
                    2287,
                    2293,
                    2297,
                    2309,
                    2311,
                    2333,
                    2339,
                    2341,
                    2347,
                    2351,
                    2357,
                    2371,
                    2377,
                    2381,
                    2383,
                    2389,
                    2393,
                    2399,
                    2411,
                    2417,
                    2423,
                    2437,
                    2441,
                    2447,
                    2459,
                    2467,
                    2473,
                    2477,
                    2503,
                    2521,
                    2531,
                    2539,
                    2543,
                    2549,
                    2551,
                    2557,
                    2579,
                    2591,
                    2593,
                    2609,
                    2617,
                    2621,
                    2633,
                    2647,
                    2657,
                    2659,
                    2663,
                    2671,
                    2677,
                    2683,
                    2687,
                    2689,
                    2693,
                    2699,
                    2707,
                    2711,
                    2713,
                    2719,
                    2729,
                    2731,
                    2741,
                    2749,
                    2753,
                    2767,
                    2777,
                    2789,
                    2791,
                    2797,
                    2801,
                    2803,
                    2819,
                    2833,
                    2837,
                    2843,
                    2851,
                    2857,
                    2861,
                    2879,
                    2887,
                    2897,
                    2903,
                    2909,
                    2917,
                    2927,
                    2939,
                    2953,
                    2957,
                    2963,
                    2969,
                    2971,
                    2999
                ];
                function m(t1, e1) {
                    if (t1 < e1) return 0;
                    for(var r = 0; 0 === Math.floor(t1 % e1);)t1 /= e1, r++;
                    return r;
                }
                function g(t1) {
                    for(var e1 = [], r = 0; r < d.length; r++){
                        var n = d[r];
                        e1.push(m(t1, n));
                    }
                    return e1;
                }
                function v(t1) {
                    for(var e1 = g(t1), r = t1, n = 0; n < d.length; n++)if (e1[n] > 0) {
                        r = d[n];
                        break;
                    }
                    return r;
                }
                function y(t1, e1) {
                    if (!(t1 < 1 || e1 < 1)) {
                        for(var r = g(t1), n = g(e1), i = 1, a = 0; a < d.length; a++)i *= Math.pow(d[a], Math.max(r[a], n[a]));
                        return i;
                    }
                }
                p.calcXnums = function(t1) {
                    var e1, r = [];
                    for(e1 = 1; e1 < t1; e1++){
                        var n = this.getXat(e1 - 1, 0), i = this.getXat(e1, 0);
                        r[e1 - 1] = i !== n && null != n && null != i ? Math.abs(i - n) : 0;
                    }
                    var a = 0;
                    for(e1 = 1; e1 < t1; e1++)a += r[e1 - 1];
                    for(e1 = 1; e1 < t1; e1++)0 === r[e1 - 1] ? r[e1 - 1] = 1 : r[e1 - 1] = Math.round(a / r[e1 - 1]);
                    return r;
                }, p.calcYnums = function(t1) {
                    var e1, r = [];
                    for(e1 = 1; e1 < t1; e1++){
                        var n = this.getYat(0, e1 - 1), i = this.getYat(0, e1);
                        r[e1 - 1] = i !== n && null != n && null != i ? Math.abs(i - n) : 0;
                    }
                    var a = 0;
                    for(e1 = 1; e1 < t1; e1++)a += r[e1 - 1];
                    for(e1 = 1; e1 < t1; e1++)0 === r[e1 - 1] ? r[e1 - 1] = 1 : r[e1 - 1] = Math.round(a / r[e1 - 1]);
                    return r;
                };
                var x = [
                    1,
                    2,
                    4,
                    6,
                    12,
                    24,
                    36,
                    48,
                    60,
                    120,
                    180,
                    240,
                    360,
                    720,
                    840,
                    1260
                ], b = x[9], _ = x[13];
                function w(t1, e1, r) {
                    var n = r[8] + r[2] * e1[0] + r[5] * e1[1];
                    return t1[0] = (r[6] + r[0] * e1[0] + r[3] * e1[1]) / n, t1[1] = (r[7] + r[1] * e1[0] + r[4] * e1[1]) / n, t1;
                }
                function T(t1, e1, r) {
                    return function(t1, e1, r, n) {
                        for(var i = [
                            0,
                            0
                        ], o = t1.shape[0], s = t1.shape[1], l = 0; l < o; l++)for(var c = 0; c < s; c++)r(i, [
                            l,
                            c
                        ], n), t1.set(l, c, a(e1, i[0], i[1]));
                    }(t1, e1, w, r), t1;
                }
                function k(t1, e1) {
                    for(var r = !1, n = 0; n < t1.length; n++)if (e1 === t1[n]) {
                        r = !0;
                        break;
                    }
                    !1 === r && t1.push(e1);
                }
                p.estimateScale = function(t1, e1) {
                    for(var r = 1 + function(t1) {
                        if (0 !== t1.length) {
                            for(var e1 = 1, r = 0; r < t1.length; r++)e1 = y(e1, t1[r]);
                            return e1;
                        }
                    }(0 === e1 ? this.calcXnums(t1) : this.calcYnums(t1)); r < b;)r *= 2;
                    for(; r > _;)r--, r /= v(r), ++r < b && (r = _);
                    var n = Math.round(r / t1);
                    return n > 1 ? n : 1;
                }, p.refineCoords = function(t1) {
                    for(var e1 = this.dataScaleX, r = this.dataScaleY, n = t1[0].shape[0], a = t1[0].shape[1], o = 0 | Math.floor(t1[0].shape[0] * e1 + 1), s = 0 | Math.floor(t1[0].shape[1] * r + 1), l = 1 + n + 1, c = 1 + a + 1, u = i(new Float32Array(l * c), [
                        l,
                        c
                    ]), f = [
                        1 / e1,
                        0,
                        0,
                        0,
                        1 / r,
                        0,
                        0,
                        0,
                        1
                    ], h = 0; h < t1.length; ++h){
                        this.surface.padField(u, t1[h]);
                        var p = i(new Float32Array(o * s), [
                            o,
                            s
                        ]);
                        T(p, u, f), t1[h] = p;
                    }
                }, p.setContourLevels = function() {
                    var t1, e1, r, n = [
                        [],
                        [],
                        []
                    ], i = [
                        !1,
                        !1,
                        !1
                    ], a = !1;
                    for(t1 = 0; t1 < 3; ++t1)if (this.showContour[t1] && (a = !0, this.contourSize[t1] > 0 && null !== this.contourStart[t1] && null !== this.contourEnd[t1] && this.contourEnd[t1] > this.contourStart[t1])) for(i[t1] = !0, e1 = this.contourStart[t1]; e1 < this.contourEnd[t1]; e1 += this.contourSize[t1])r = e1 * this.scene.dataScale[t1], k(n[t1], r);
                    if (a) {
                        var o = [
                            [],
                            [],
                            []
                        ];
                        for(t1 = 0; t1 < 3; ++t1)this.showContour[t1] && (o[t1] = i[t1] ? n[t1] : this.scene.contourLevels[t1]);
                        this.surface.update({
                            levels: o
                        });
                    }
                }, p.update = function(t1) {
                    var e1, r, n, a, l = this.scene, h = l.fullSceneLayout, p = this.surface, d = c(t1), m = l.dataScale, g = t1.z[0].length, v = t1._ylength, y = l.contourLevels;
                    this.data = t1;
                    var x = [];
                    for(e1 = 0; e1 < 3; e1++)for(x[e1] = [], r = 0; r < g; r++)x[e1][r] = [];
                    for(r = 0; r < g; r++)for(n = 0; n < v; n++)x[0][r][n] = this.getXat(r, n, t1.xcalendar, h.xaxis), x[1][r][n] = this.getYat(r, n, t1.ycalendar, h.yaxis), x[2][r][n] = this.getZat(r, n, t1.zcalendar, h.zaxis);
                    if (t1.connectgaps) for(t1._emptypoints = s(x[2]), o(x[2], t1._emptypoints), t1._interpolatedZ = [], r = 0; r < g; r++)for(t1._interpolatedZ[r] = [], n = 0; n < v; n++)t1._interpolatedZ[r][n] = x[2][r][n];
                    for(e1 = 0; e1 < 3; e1++)for(r = 0; r < g; r++)for(n = 0; n < v; n++)null == (a = x[e1][r][n]) ? x[e1][r][n] = NaN : a = x[e1][r][n] *= m[e1];
                    for(e1 = 0; e1 < 3; e1++)for(r = 0; r < g; r++)for(n = 0; n < v; n++)null != (a = x[e1][r][n]) && (this.minValues[e1] > a && (this.minValues[e1] = a), this.maxValues[e1] < a && (this.maxValues[e1] = a));
                    for(e1 = 0; e1 < 3; e1++)this.objectOffset[e1] = .5 * (this.minValues[e1] + this.maxValues[e1]);
                    for(e1 = 0; e1 < 3; e1++)for(r = 0; r < g; r++)for(n = 0; n < v; n++)null != (a = x[e1][r][n]) && (x[e1][r][n] -= this.objectOffset[e1]);
                    var b = [
                        i(new Float32Array(g * v), [
                            g,
                            v
                        ]),
                        i(new Float32Array(g * v), [
                            g,
                            v
                        ]),
                        i(new Float32Array(g * v), [
                            g,
                            v
                        ])
                    ];
                    for(e1 = 0; e1 < 3; e1++)for(r = 0; r < g; r++)for(n = 0; n < v; n++)b[e1].set(r, n, x[e1][r][n]);
                    x = [];
                    var w = {
                        colormap: d,
                        levels: [
                            [],
                            [],
                            []
                        ],
                        showContour: [
                            !0,
                            !0,
                            !0
                        ],
                        showSurface: !t1.hidesurface,
                        contourProject: [
                            [
                                !1,
                                !1,
                                !1
                            ],
                            [
                                !1,
                                !1,
                                !1
                            ],
                            [
                                !1,
                                !1,
                                !1
                            ]
                        ],
                        contourWidth: [
                            1,
                            1,
                            1
                        ],
                        contourColor: [
                            [
                                1,
                                1,
                                1,
                                1
                            ],
                            [
                                1,
                                1,
                                1,
                                1
                            ],
                            [
                                1,
                                1,
                                1,
                                1
                            ]
                        ],
                        contourTint: [
                            1,
                            1,
                            1
                        ],
                        dynamicColor: [
                            [
                                1,
                                1,
                                1,
                                1
                            ],
                            [
                                1,
                                1,
                                1,
                                1
                            ],
                            [
                                1,
                                1,
                                1,
                                1
                            ]
                        ],
                        dynamicWidth: [
                            1,
                            1,
                            1
                        ],
                        dynamicTint: [
                            1,
                            1,
                            1
                        ],
                        opacityscale: t1.opacityscale,
                        opacity: t1.opacity
                    }, T = f(t1);
                    if (w.intensityBounds = [
                        T.min,
                        T.max
                    ], t1.surfacecolor) {
                        var k = i(new Float32Array(g * v), [
                            g,
                            v
                        ]);
                        for(r = 0; r < g; r++)for(n = 0; n < v; n++)k.set(r, n, t1.surfacecolor[n][r]);
                        b.push(k);
                    } else w.intensityBounds[0] *= m[2], w.intensityBounds[1] *= m[2];
                    (_ < b[0].shape[0] || _ < b[0].shape[1]) && (this.refineData = !1), !0 === this.refineData && (this.dataScaleX = this.estimateScale(b[0].shape[0], 0), this.dataScaleY = this.estimateScale(b[0].shape[1], 1), 1 === this.dataScaleX && 1 === this.dataScaleY || this.refineCoords(b)), t1.surfacecolor && (w.intensity = b.pop());
                    var A = [
                        !0,
                        !0,
                        !0
                    ], M = [
                        "x",
                        "y",
                        "z"
                    ];
                    for(e1 = 0; e1 < 3; ++e1){
                        var S = t1.contours[M[e1]];
                        A[e1] = S.highlight, w.showContour[e1] = S.show || S.highlight, w.showContour[e1] && (w.contourProject[e1] = [
                            S.project.x,
                            S.project.y,
                            S.project.z
                        ], S.show ? (this.showContour[e1] = !0, w.levels[e1] = y[e1], p.highlightColor[e1] = w.contourColor[e1] = u(S.color), S.usecolormap ? p.highlightTint[e1] = w.contourTint[e1] = 0 : p.highlightTint[e1] = w.contourTint[e1] = 1, w.contourWidth[e1] = S.width, this.contourStart[e1] = S.start, this.contourEnd[e1] = S.end, this.contourSize[e1] = S.size) : (this.showContour[e1] = !1, this.contourStart[e1] = null, this.contourEnd[e1] = null, this.contourSize[e1] = 0), S.highlight && (w.dynamicColor[e1] = u(S.highlightcolor), w.dynamicWidth[e1] = S.highlightwidth));
                    }
                    (function(t1) {
                        var e1 = t1[0].rgb, r = t1[t1.length - 1].rgb;
                        return e1[0] === r[0] && e1[1] === r[1] && e1[2] === r[2] && e1[3] === r[3];
                    })(d) && (w.vertexColor = !0), w.objectOffset = this.objectOffset, w.coords = b, p.update(w), p.visible = t1.visible, p.enableDynamic = A, p.enableHighlight = A, p.snapToData = !0, "lighting" in t1 && (p.ambientLight = t1.lighting.ambient, p.diffuseLight = t1.lighting.diffuse, p.specularLight = t1.lighting.specular, p.roughness = t1.lighting.roughness, p.fresnel = t1.lighting.fresnel), "lightposition" in t1 && (p.lightPosition = [
                        t1.lightposition.x,
                        t1.lightposition.y,
                        t1.lightposition.z
                    ]);
                }, p.dispose = function() {
                    this.scene.glplot.remove(this.surface), this.surface.dispose();
                }, e1.exports = function(t1, e1) {
                    var r = t1.glplot.gl, i = n({
                        gl: r
                    }), a = new h(t1, i, e1.uid);
                    return i._trace = a, a.update(e1), t1.glplot.add(i), a;
                };
            },
            {
                "../../../stackgl_modules": 1120,
                "../../components/colorscale": 378,
                "../../lib": 503,
                "../../lib/gl_format_color": 499,
                "../../lib/str2rgbarray": 528,
                "../heatmap/find_empties": 798,
                "../heatmap/interp2d": 801
            }
        ],
        1060: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../registry"), i = t1("../../lib"), a = t1("../../components/colorscale/defaults"), o = t1("./attributes");
                function s(t1, e1, r, n) {
                    var i = n("opacityscale");
                    "max" === i ? e1.opacityscale = [
                        [
                            0,
                            .1
                        ],
                        [
                            1,
                            1
                        ]
                    ] : "min" === i ? e1.opacityscale = [
                        [
                            0,
                            1
                        ],
                        [
                            1,
                            .1
                        ]
                    ] : "extremes" === i ? e1.opacityscale = function(t1, e1) {
                        for(var r = [], n = 0; n < 32; n++){
                            var i = n / 31, a = e1 + (1 - e1) * (1 - Math.pow(Math.sin(t1 * i * Math.PI), 2));
                            r.push([
                                i,
                                Math.max(0, Math.min(1, a))
                            ]);
                        }
                        return r;
                    }(1, .1) : function(t1) {
                        var e1 = 0;
                        if (!Array.isArray(t1) || t1.length < 2) return !1;
                        if (!t1[0] || !t1[t1.length - 1]) return !1;
                        if (0 != +t1[0][0] || 1 != +t1[t1.length - 1][0]) return !1;
                        for(var r = 0; r < t1.length; r++){
                            var n = t1[r];
                            if (2 !== n.length || +n[0] < e1) return !1;
                            e1 = +n[0];
                        }
                        return !0;
                    }(i) || (e1.opacityscale = void 0);
                }
                function l(t1, e1, r) {
                    e1 in t1 && !(r in t1) && (t1[r] = t1[e1]);
                }
                e1.exports = {
                    supplyDefaults: function(t1, e1, r, c) {
                        var u, f;
                        function h(r, n) {
                            return i.coerce(t1, e1, o, r, n);
                        }
                        var p = h("x"), d = h("y"), m = h("z");
                        if (!m || !m.length || p && p.length < 1 || d && d.length < 1) e1.visible = !1;
                        else {
                            e1._xlength = Array.isArray(p) && i.isArrayOrTypedArray(p[0]) ? m.length : m[0].length, e1._ylength = m.length, n.getComponentMethod("calendars", "handleTraceDefaults")(t1, e1, [
                                "x",
                                "y",
                                "z"
                            ], c), h("text"), h("hovertext"), h("hovertemplate"), h("xhoverformat"), h("yhoverformat"), h("zhoverformat"), [
                                "lighting.ambient",
                                "lighting.diffuse",
                                "lighting.specular",
                                "lighting.roughness",
                                "lighting.fresnel",
                                "lightposition.x",
                                "lightposition.y",
                                "lightposition.z",
                                "hidesurface",
                                "connectgaps",
                                "opacity"
                            ].forEach(function(t1) {
                                h(t1);
                            });
                            var g = h("surfacecolor"), v = [
                                "x",
                                "y",
                                "z"
                            ];
                            for(u = 0; u < 3; ++u){
                                var y = "contours." + v[u], x = h(y + ".show"), b = h(y + ".highlight");
                                if (x || b) for(f = 0; f < 3; ++f)h(y + ".project." + v[f]);
                                x && (h(y + ".color"), h(y + ".width"), h(y + ".usecolormap")), b && (h(y + ".highlightcolor"), h(y + ".highlightwidth")), h(y + ".start"), h(y + ".end"), h(y + ".size");
                            }
                            g || (l(t1, "zmin", "cmin"), l(t1, "zmax", "cmax"), l(t1, "zauto", "cauto")), a(t1, e1, c, h, {
                                prefix: "",
                                cLetter: "c"
                            }), s(t1, e1, c, h), e1._length = null;
                        }
                    },
                    opacityscaleDefaults: s
                };
            },
            {
                "../../components/colorscale/defaults": 376,
                "../../lib": 503,
                "../../registry": 638,
                "./attributes": 1057
            }
        ],
        1061: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults").supplyDefaults,
                    colorbar: {
                        min: "cmin",
                        max: "cmax"
                    },
                    calc: t1("./calc"),
                    plot: t1("./convert"),
                    moduleType: "trace",
                    name: "surface",
                    basePlotModule: t1("../../plots/gl3d"),
                    categories: [
                        "gl3d",
                        "2dMap",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/gl3d": 598,
                "./attributes": 1057,
                "./calc": 1058,
                "./convert": 1059,
                "./defaults": 1060
            }
        ],
        1062: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/annotations/attributes"), i = t1("../../lib/extend").extendFlat, a = t1("../../plot_api/edit_types").overrideAll, o = t1("../../plots/font_attributes"), s = t1("../../plots/domain").attributes, l = t1("../../plots/cartesian/axis_format_attributes").descriptionOnlyNumbers;
                (e1.exports = a({
                    domain: s({
                        name: "table",
                        trace: !0
                    }),
                    columnwidth: {
                        valType: "number",
                        arrayOk: !0,
                        dflt: null
                    },
                    columnorder: {
                        valType: "data_array"
                    },
                    header: {
                        values: {
                            valType: "data_array",
                            dflt: []
                        },
                        format: {
                            valType: "data_array",
                            dflt: [],
                            description: l("cell value")
                        },
                        prefix: {
                            valType: "string",
                            arrayOk: !0,
                            dflt: null
                        },
                        suffix: {
                            valType: "string",
                            arrayOk: !0,
                            dflt: null
                        },
                        height: {
                            valType: "number",
                            dflt: 28
                        },
                        align: i({}, n.align, {
                            arrayOk: !0
                        }),
                        line: {
                            width: {
                                valType: "number",
                                arrayOk: !0,
                                dflt: 1
                            },
                            color: {
                                valType: "color",
                                arrayOk: !0,
                                dflt: "grey"
                            }
                        },
                        fill: {
                            color: {
                                valType: "color",
                                arrayOk: !0,
                                dflt: "white"
                            }
                        },
                        font: i({}, o({
                            arrayOk: !0
                        }))
                    },
                    cells: {
                        values: {
                            valType: "data_array",
                            dflt: []
                        },
                        format: {
                            valType: "data_array",
                            dflt: [],
                            description: l("cell value")
                        },
                        prefix: {
                            valType: "string",
                            arrayOk: !0,
                            dflt: null
                        },
                        suffix: {
                            valType: "string",
                            arrayOk: !0,
                            dflt: null
                        },
                        height: {
                            valType: "number",
                            dflt: 20
                        },
                        align: i({}, n.align, {
                            arrayOk: !0
                        }),
                        line: {
                            width: {
                                valType: "number",
                                arrayOk: !0,
                                dflt: 1
                            },
                            color: {
                                valType: "color",
                                arrayOk: !0,
                                dflt: "grey"
                            }
                        },
                        fill: {
                            color: {
                                valType: "color",
                                arrayOk: !0,
                                dflt: "white"
                            }
                        },
                        font: i({}, o({
                            arrayOk: !0
                        }))
                    }
                }, "calc", "from-root")).transforms = void 0;
            },
            {
                "../../components/annotations/attributes": 349,
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/domain": 584,
                "../../plots/font_attributes": 585
            }
        ],
        1063: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/get_data").getModuleCalcData, i = t1("./plot");
                r.name = "table", r.plot = function(t1) {
                    var e1 = n(t1.calcdata, "table")[0];
                    e1.length && i(t1, e1);
                }, r.clean = function(t1, e1, r, n) {
                    var i = n._has && n._has("table"), a = e1._has && e1._has("table");
                    i && !a && n._paperdiv.selectAll(".table").remove();
                };
            },
            {
                "../../plots/get_data": 593,
                "./plot": 1070
            }
        ],
        1064: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib/gup").wrap;
                e1.exports = function() {
                    return n({});
                };
            },
            {
                "../../lib/gup": 500
            }
        ],
        1065: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    cellPad: 8,
                    columnExtentOffset: 10,
                    columnTitleOffset: 28,
                    emptyHeaderHeight: 16,
                    latexCheck: /^\$.*\$$/,
                    goldenRatio: 1.618,
                    lineBreaker: "<br>",
                    maxDimensionCount: 60,
                    overdrag: 45,
                    releaseTransitionDuration: 120,
                    releaseTransitionEase: "cubic-out",
                    scrollbarCaptureWidth: 18,
                    scrollbarHideDelay: 1e3,
                    scrollbarHideDuration: 1e3,
                    scrollbarOffset: 5,
                    scrollbarWidth: 8,
                    transitionDuration: 100,
                    transitionEase: "cubic-out",
                    uplift: 5,
                    wrapSpacer: " ",
                    wrapSplitCharacter: " ",
                    cn: {
                        table: "table",
                        tableControlView: "table-control-view",
                        scrollBackground: "scroll-background",
                        yColumn: "y-column",
                        columnBlock: "column-block",
                        scrollAreaClip: "scroll-area-clip",
                        scrollAreaClipRect: "scroll-area-clip-rect",
                        columnBoundary: "column-boundary",
                        columnBoundaryClippath: "column-boundary-clippath",
                        columnBoundaryRect: "column-boundary-rect",
                        columnCells: "column-cells",
                        columnCell: "column-cell",
                        cellRect: "cell-rect",
                        cellText: "cell-text",
                        cellTextHolder: "cell-text-holder",
                        scrollbarKit: "scrollbar-kit",
                        scrollbar: "scrollbar",
                        scrollbarSlider: "scrollbar-slider",
                        scrollbarGlyph: "scrollbar-glyph",
                        scrollbarCaptureZone: "scrollbar-capture-zone"
                    }
                };
            },
            {}
        ],
        1066: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./constants"), i = t1("../../lib/extend").extendFlat, a = t1("fast-isnumeric");
                function o(t1) {
                    if (Array.isArray(t1)) {
                        for(var e1 = 0, r = 0; r < t1.length; r++)e1 = Math.max(e1, o(t1[r]));
                        return e1;
                    }
                    return t1;
                }
                function s(t1, e1) {
                    return t1 + e1;
                }
                function l(t1) {
                    var e1, r = t1.slice(), n = 1 / 0, i = 0;
                    for(e1 = 0; e1 < r.length; e1++)Array.isArray(r[e1]) || (r[e1] = [
                        r[e1]
                    ]), n = Math.min(n, r[e1].length), i = Math.max(i, r[e1].length);
                    if (n !== i) for(e1 = 0; e1 < r.length; e1++){
                        var a = i - r[e1].length;
                        a && (r[e1] = r[e1].concat(c(a)));
                    }
                    return r;
                }
                function c(t1) {
                    for(var e1 = new Array(t1), r = 0; r < t1; r++)e1[r] = "";
                    return e1;
                }
                function u(t1) {
                    return t1.calcdata.columns.reduce(function(e1, r) {
                        return r.xIndex < t1.xIndex ? e1 + r.columnWidth : e1;
                    }, 0);
                }
                function f(t1, e1) {
                    return Object.keys(t1).map(function(r) {
                        return i({}, t1[r], {
                            auxiliaryBlocks: e1
                        });
                    });
                }
                function h(t1, e1) {
                    for(var r, n = {}, i = 0, a = 0, o = {
                        firstRowIndex: null,
                        lastRowIndex: null,
                        rows: []
                    }, s = 0, l = 0, c = 0; c < t1.length; c++)r = t1[c], o.rows.push({
                        rowIndex: c,
                        rowHeight: r
                    }), ((a += r) >= e1 || c === t1.length - 1) && (n[i] = o, o.key = l++, o.firstRowIndex = s, o.lastRowIndex = c, o = {
                        firstRowIndex: null,
                        lastRowIndex: null,
                        rows: []
                    }, i += a, s = c + 1, a = 0);
                    return n;
                }
                e1.exports = function(t1, e1) {
                    var r = l(e1.cells.values), p = function(t1) {
                        return t1.slice(e1.header.values.length, t1.length);
                    }, d = l(e1.header.values);
                    d.length && !d[0].length && (d[0] = [
                        ""
                    ], d = l(d));
                    var m = d.concat(p(r).map(function() {
                        return c((d[0] || [
                            ""
                        ]).length);
                    })), g = e1.domain, v = Math.floor(t1._fullLayout._size.w * (g.x[1] - g.x[0])), y = Math.floor(t1._fullLayout._size.h * (g.y[1] - g.y[0])), x = e1.header.values.length ? m[0].map(function() {
                        return e1.header.height;
                    }) : [
                        n.emptyHeaderHeight
                    ], b = r.length ? r[0].map(function() {
                        return e1.cells.height;
                    }) : [], _ = x.reduce(s, 0), w = h(b, y - _ + n.uplift), T = f(h(x, _), []), k = f(w, T), A = {}, M = e1._fullInput.columnorder.concat(p(r.map(function(t1, e1) {
                        return e1;
                    }))), S = m.map(function(t1, r) {
                        var n = Array.isArray(e1.columnwidth) ? e1.columnwidth[Math.min(r, e1.columnwidth.length - 1)] : e1.columnwidth;
                        return a(n) ? Number(n) : 1;
                    }), E = S.reduce(s, 0);
                    S = S.map(function(t1) {
                        return t1 / E * v;
                    });
                    var L = Math.max(o(e1.header.line.width), o(e1.cells.line.width)), C = {
                        key: e1.uid + t1._context.staticPlot,
                        translateX: g.x[0] * t1._fullLayout._size.w,
                        translateY: t1._fullLayout._size.h * (1 - g.y[1]),
                        size: t1._fullLayout._size,
                        width: v,
                        maxLineWidth: L,
                        height: y,
                        columnOrder: M,
                        groupHeight: y,
                        rowBlocks: k,
                        headerRowBlocks: T,
                        scrollY: 0,
                        cells: i({}, e1.cells, {
                            values: r
                        }),
                        headerCells: i({}, e1.header, {
                            values: m
                        }),
                        gdColumns: m.map(function(t1) {
                            return t1[0];
                        }),
                        gdColumnsOriginalOrder: m.map(function(t1) {
                            return t1[0];
                        }),
                        prevPages: [
                            0,
                            0
                        ],
                        scrollbarState: {
                            scrollbarScrollInProgress: !1
                        },
                        columns: m.map(function(t1, e1) {
                            var r = A[t1];
                            return A[t1] = (r || 0) + 1, {
                                key: t1 + "__" + A[t1],
                                label: t1,
                                specIndex: e1,
                                xIndex: M[e1],
                                xScale: u,
                                x: void 0,
                                calcdata: void 0,
                                columnWidth: S[e1]
                            };
                        })
                    };
                    return C.columns.forEach(function(t1) {
                        t1.calcdata = C, t1.x = u(t1);
                    }), C;
                };
            },
            {
                "../../lib/extend": 493,
                "./constants": 1065,
                "fast-isnumeric": 190
            }
        ],
        1067: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib/extend").extendFlat;
                r.splitToPanels = function(t1) {
                    var e1 = [
                        0,
                        0
                    ], r = n({}, t1, {
                        key: "header",
                        type: "header",
                        page: 0,
                        prevPages: e1,
                        currentRepaint: [
                            null,
                            null
                        ],
                        dragHandle: !0,
                        values: t1.calcdata.headerCells.values[t1.specIndex],
                        rowBlocks: t1.calcdata.headerRowBlocks,
                        calcdata: n({}, t1.calcdata, {
                            cells: t1.calcdata.headerCells
                        })
                    });
                    return [
                        n({}, t1, {
                            key: "cells1",
                            type: "cells",
                            page: 0,
                            prevPages: e1,
                            currentRepaint: [
                                null,
                                null
                            ],
                            dragHandle: !1,
                            values: t1.calcdata.cells.values[t1.specIndex],
                            rowBlocks: t1.calcdata.rowBlocks
                        }),
                        n({}, t1, {
                            key: "cells2",
                            type: "cells",
                            page: 1,
                            prevPages: e1,
                            currentRepaint: [
                                null,
                                null
                            ],
                            dragHandle: !1,
                            values: t1.calcdata.cells.values[t1.specIndex],
                            rowBlocks: t1.calcdata.rowBlocks
                        }),
                        r
                    ];
                }, r.splitToCells = function(t1) {
                    var e1 = function(t1) {
                        var e1 = t1.rowBlocks[t1.page], r = e1 ? e1.rows[0].rowIndex : 0, n = e1 ? r + e1.rows.length : 0;
                        return [
                            r,
                            n
                        ];
                    }(t1);
                    return (t1.values || []).slice(e1[0], e1[1]).map(function(r, n) {
                        return {
                            keyWithinBlock: n + ("string" == typeof r && r.match(/[<$&> ]/) ? "_keybuster_" + Math.random() : ""),
                            key: e1[0] + n,
                            column: t1,
                            calcdata: t1.calcdata,
                            page: t1.page,
                            rowBlocks: t1.rowBlocks,
                            value: r
                        };
                    });
                };
            },
            {
                "../../lib/extend": 493
            }
        ],
        1068: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./attributes"), a = t1("../../plots/domain").defaults;
                e1.exports = function(t1, e1, r, o) {
                    function s(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    a(e1, o, s), s("columnwidth"), s("header.values"), s("header.format"), s("header.align"), s("header.prefix"), s("header.suffix"), s("header.height"), s("header.line.width"), s("header.line.color"), s("header.fill.color"), n.coerceFont(s, "header.font", n.extendFlat({}, o.font)), function(t1, e1) {
                        for(var r = t1.columnorder || [], n = t1.header.values.length, i = r.slice(0, n), a = i.slice().sort(function(t1, e1) {
                            return t1 - e1;
                        }), o = i.map(function(t1) {
                            return a.indexOf(t1);
                        }), s = o.length; s < n; s++)o.push(s);
                        e1("columnorder", o);
                    }(e1, s), s("cells.values"), s("cells.format"), s("cells.align"), s("cells.prefix"), s("cells.suffix"), s("cells.height"), s("cells.line.width"), s("cells.line.color"), s("cells.fill.color"), n.coerceFont(s, "cells.font", n.extendFlat({}, o.font)), e1._length = null;
                };
            },
            {
                "../../lib": 503,
                "../../plots/domain": 584,
                "./attributes": 1062
            }
        ],
        1069: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    calc: t1("./calc"),
                    plot: t1("./plot"),
                    moduleType: "trace",
                    name: "table",
                    basePlotModule: t1("./base_plot"),
                    categories: [
                        "noOpacity"
                    ],
                    meta: {}
                };
            },
            {
                "./attributes": 1062,
                "./base_plot": 1063,
                "./calc": 1064,
                "./defaults": 1068,
                "./plot": 1070
            }
        ],
        1070: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./constants"), i = t1("@plotly/d3"), a = t1("../../lib").numberFormat, o = t1("../../lib/gup"), s = t1("../../components/drawing"), l = t1("../../lib/svg_text_utils"), c = t1("../../lib").raiseToTop, u = t1("../../lib").strTranslate, f = t1("../../lib").cancelTransition, h = t1("./data_preparation_helper"), p = t1("./data_split_helpers"), d = t1("../../components/color");
                function m(t1) {
                    return Math.ceil(t1.calcdata.maxLineWidth / 2);
                }
                function g(t1, e1) {
                    return "clip" + t1._fullLayout._uid + "_scrollAreaBottomClip_" + e1.key;
                }
                function v(t1, e1) {
                    return "clip" + t1._fullLayout._uid + "_columnBoundaryClippath_" + e1.calcdata.key + "_" + e1.specIndex;
                }
                function y(t1) {
                    return [].concat.apply([], t1.map(function(t1) {
                        return t1;
                    })).map(function(t1) {
                        return t1.__data__;
                    });
                }
                function x(t1, e1, r) {
                    var a = t1.selectAll("." + n.cn.scrollbarKit).data(o.repeat, o.keyFun);
                    a.enter().append("g").classed(n.cn.scrollbarKit, !0).style("shape-rendering", "geometricPrecision"), a.each(function(t1) {
                        var e1 = t1.scrollbarState;
                        e1.totalHeight = function(t1) {
                            var e1 = t1.rowBlocks;
                            return D(e1, e1.length - 1) + (e1.length ? R(e1[e1.length - 1], 1 / 0) : 1);
                        }(t1), e1.scrollableAreaHeight = t1.groupHeight - S(t1), e1.currentlyVisibleHeight = Math.min(e1.totalHeight, e1.scrollableAreaHeight), e1.ratio = e1.currentlyVisibleHeight / e1.totalHeight, e1.barLength = Math.max(e1.ratio * e1.currentlyVisibleHeight, n.goldenRatio * n.scrollbarWidth), e1.barWiggleRoom = e1.currentlyVisibleHeight - e1.barLength, e1.wiggleRoom = Math.max(0, e1.totalHeight - e1.scrollableAreaHeight), e1.topY = 0 === e1.barWiggleRoom ? 0 : t1.scrollY / e1.wiggleRoom * e1.barWiggleRoom, e1.bottomY = e1.topY + e1.barLength, e1.dragMultiplier = e1.wiggleRoom / e1.barWiggleRoom;
                    }).attr("transform", function(t1) {
                        var e1 = t1.width + n.scrollbarWidth / 2 + n.scrollbarOffset;
                        return u(e1, S(t1));
                    });
                    var s = a.selectAll("." + n.cn.scrollbar).data(o.repeat, o.keyFun);
                    s.enter().append("g").classed(n.cn.scrollbar, !0);
                    var l = s.selectAll("." + n.cn.scrollbarSlider).data(o.repeat, o.keyFun);
                    l.enter().append("g").classed(n.cn.scrollbarSlider, !0), l.attr("transform", function(t1) {
                        return u(0, t1.scrollbarState.topY || 0);
                    });
                    var c = l.selectAll("." + n.cn.scrollbarGlyph).data(o.repeat, o.keyFun);
                    c.enter().append("line").classed(n.cn.scrollbarGlyph, !0).attr("stroke", "black").attr("stroke-width", n.scrollbarWidth).attr("stroke-linecap", "round").attr("y1", n.scrollbarWidth / 2), c.attr("y2", function(t1) {
                        return t1.scrollbarState.barLength - n.scrollbarWidth / 2;
                    }).attr("stroke-opacity", function(t1) {
                        return t1.columnDragInProgress || !t1.scrollbarState.barWiggleRoom || r ? 0 : .4;
                    }), c.transition().delay(0).duration(0), c.transition().delay(n.scrollbarHideDelay).duration(n.scrollbarHideDuration).attr("stroke-opacity", 0);
                    var f = s.selectAll("." + n.cn.scrollbarCaptureZone).data(o.repeat, o.keyFun);
                    f.enter().append("line").classed(n.cn.scrollbarCaptureZone, !0).attr("stroke", "white").attr("stroke-opacity", .01).attr("stroke-width", n.scrollbarCaptureWidth).attr("stroke-linecap", "butt").attr("y1", 0).on("mousedown", function(r) {
                        var n = i.event.y, a = this.getBoundingClientRect(), o = r.scrollbarState, s = n - a.top, l = i.scale.linear().domain([
                            0,
                            o.scrollableAreaHeight
                        ]).range([
                            0,
                            o.totalHeight
                        ]).clamp(!0);
                        o.topY <= s && s <= o.bottomY || L(e1, t1, null, l(s - o.barLength / 2))(r);
                    }).call(i.behavior.drag().origin(function(t1) {
                        return i.event.stopPropagation(), t1.scrollbarState.scrollbarScrollInProgress = !0, t1;
                    }).on("drag", L(e1, t1)).on("dragend", function() {})), f.attr("y2", function(t1) {
                        return t1.scrollbarState.scrollableAreaHeight;
                    }), e1._context.staticPlot && (c.remove(), f.remove());
                }
                function b(t1, e1, r, a) {
                    var l = function(t1) {
                        var e1 = t1.selectAll("." + n.cn.columnCell).data(p.splitToCells, function(t1) {
                            return t1.keyWithinBlock;
                        });
                        return e1.enter().append("g").classed(n.cn.columnCell, !0), e1.exit().remove(), e1;
                    }(function(t1) {
                        var e1 = t1.selectAll("." + n.cn.columnCells).data(o.repeat, o.keyFun);
                        return e1.enter().append("g").classed(n.cn.columnCells, !0), e1.exit().remove(), e1;
                    }(r));
                    !function(t1) {
                        t1.each(function(t1, e1) {
                            var r = t1.calcdata.cells.font, n = t1.column.specIndex, i = {
                                size: T(r.size, n, e1),
                                color: T(r.color, n, e1),
                                family: T(r.family, n, e1)
                            };
                            t1.rowNumber = t1.key, t1.align = T(t1.calcdata.cells.align, n, e1), t1.cellBorderWidth = T(t1.calcdata.cells.line.width, n, e1), t1.font = i;
                        });
                    }(l), function(t1) {
                        t1.attr("width", function(t1) {
                            return t1.column.columnWidth;
                        }).attr("stroke-width", function(t1) {
                            return t1.cellBorderWidth;
                        }).each(function(t1) {
                            var e1 = i.select(this);
                            d.stroke(e1, T(t1.calcdata.cells.line.color, t1.column.specIndex, t1.rowNumber)), d.fill(e1, T(t1.calcdata.cells.fill.color, t1.column.specIndex, t1.rowNumber));
                        });
                    }(function(t1) {
                        var e1 = t1.selectAll("." + n.cn.cellRect).data(o.repeat, function(t1) {
                            return t1.keyWithinBlock;
                        });
                        return e1.enter().append("rect").classed(n.cn.cellRect, !0), e1;
                    }(l));
                    var c = function(t1) {
                        var e1 = t1.selectAll("." + n.cn.cellText).data(o.repeat, function(t1) {
                            return t1.keyWithinBlock;
                        });
                        return e1.enter().append("text").classed(n.cn.cellText, !0).style("cursor", function() {
                            return "auto";
                        }).on("mousedown", function() {
                            i.event.stopPropagation();
                        }), e1;
                    }(function(t1) {
                        var e1 = t1.selectAll("." + n.cn.cellTextHolder).data(o.repeat, function(t1) {
                            return t1.keyWithinBlock;
                        });
                        return e1.enter().append("g").classed(n.cn.cellTextHolder, !0).style("shape-rendering", "geometricPrecision"), e1;
                    }(l));
                    !function(t1) {
                        t1.each(function(t1) {
                            s.font(i.select(this), t1.font);
                        });
                    }(c), _(c, e1, a, t1), z(l);
                }
                function _(t1, e1, r, o) {
                    t1.text(function(t1) {
                        var e1 = t1.column.specIndex, r = t1.rowNumber, i = t1.value, o = "string" == typeof i, s = o && i.match(/<br>/i), l = !o || s;
                        t1.mayHaveMarkup = o && i.match(/[<&>]/);
                        var c, u = "string" == typeof (c = i) && c.match(n.latexCheck);
                        t1.latex = u;
                        var f, h, p = u ? "" : T(t1.calcdata.cells.prefix, e1, r) || "", d = u ? "" : T(t1.calcdata.cells.suffix, e1, r) || "", m = u ? null : T(t1.calcdata.cells.format, e1, r) || null, g = p + (m ? a(m)(t1.value) : t1.value) + d;
                        if (t1.wrappingNeeded = !t1.wrapped && !l && !u && (f = w(g)), t1.cellHeightMayIncrease = s || u || t1.mayHaveMarkup || (void 0 === f ? w(g) : f), t1.needsConvertToTspans = t1.mayHaveMarkup || t1.wrappingNeeded || t1.latex, t1.wrappingNeeded) {
                            var v = (" " === n.wrapSplitCharacter ? g.replace(/<a href=/gi, "<a_href=") : g).split(n.wrapSplitCharacter), y = " " === n.wrapSplitCharacter ? v.map(function(t1) {
                                return t1.replace(/<a_href=/gi, "<a href=");
                            }) : v;
                            t1.fragments = y.map(function(t1) {
                                return {
                                    text: t1,
                                    width: null
                                };
                            }), t1.fragments.push({
                                fragment: n.wrapSpacer,
                                width: null
                            }), h = y.join(n.lineBreaker) + n.lineBreaker + n.wrapSpacer;
                        } else delete t1.fragments, h = g;
                        return h;
                    }).attr("dy", function(t1) {
                        return t1.needsConvertToTspans ? 0 : "0.75em";
                    }).each(function(t1) {
                        var a = i.select(this), s = t1.wrappingNeeded ? P : I;
                        t1.needsConvertToTspans ? l.convertToTspans(a, o, s(r, this, e1, o, t1)) : i.select(this.parentNode).attr("transform", function(t1) {
                            return u(O(t1), n.cellPad);
                        }).attr("text-anchor", function(t1) {
                            return ({
                                left: "start",
                                center: "middle",
                                right: "end"
                            })[t1.align];
                        });
                    });
                }
                function w(t1) {
                    return -1 !== t1.indexOf(n.wrapSplitCharacter);
                }
                function T(t1, e1, r) {
                    if (Array.isArray(t1)) {
                        var n = t1[Math.min(e1, t1.length - 1)];
                        return Array.isArray(n) ? n[Math.min(r, n.length - 1)] : n;
                    }
                    return t1;
                }
                function k(t1, e1, r) {
                    t1.transition().ease(n.releaseTransitionEase).duration(n.releaseTransitionDuration).attr("transform", u(e1.x, r));
                }
                function A(t1) {
                    return "cells" === t1.type;
                }
                function M(t1) {
                    return "header" === t1.type;
                }
                function S(t1) {
                    return (t1.rowBlocks.length ? t1.rowBlocks[0].auxiliaryBlocks : []).reduce(function(t1, e1) {
                        return t1 + R(e1, 1 / 0);
                    }, 0);
                }
                function E(t1, e1, r) {
                    var n = y(e1)[0];
                    if (void 0 !== n) {
                        var i = n.rowBlocks, a = n.calcdata, o = D(i, i.length), s = n.calcdata.groupHeight - S(n), l = a.scrollY = Math.max(0, Math.min(o - s, a.scrollY)), c = function(t1, e1, r) {
                            for(var n = [], i = 0, a = 0; a < t1.length; a++){
                                for(var o = t1[a], s = o.rows, l = 0, c = 0; c < s.length; c++)l += s[c].rowHeight;
                                o.allRowsHeight = l;
                                e1 < i + l && e1 + r > i && n.push(a), i += l;
                            }
                            return n;
                        }(i, l, s);
                        1 === c.length && (c[0] === i.length - 1 ? c.unshift(c[0] - 1) : c.push(c[0] + 1)), c[0] % 2 && c.reverse(), e1.each(function(t1, e1) {
                            t1.page = c[e1], t1.scrollY = l;
                        }), e1.attr("transform", function(t1) {
                            var e1 = D(t1.rowBlocks, t1.page) - t1.scrollY;
                            return u(0, e1);
                        }), t1 && (C(t1, r, e1, c, n.prevPages, n, 0), C(t1, r, e1, c, n.prevPages, n, 1), x(r, t1));
                    }
                }
                function L(t1, e1, r, a) {
                    return function(o) {
                        var s = o.calcdata ? o.calcdata : o, l = e1.filter(function(t1) {
                            return s.key === t1.key;
                        }), c = r || s.scrollbarState.dragMultiplier, u = s.scrollY;
                        s.scrollY = void 0 === a ? s.scrollY + c * i.event.dy : a;
                        var f = l.selectAll("." + n.cn.yColumn).selectAll("." + n.cn.columnBlock).filter(A);
                        return E(t1, f, l), s.scrollY === u;
                    };
                }
                function C(t1, e1, r, n, i, a, o) {
                    n[o] !== i[o] && (clearTimeout(a.currentRepaint[o]), a.currentRepaint[o] = setTimeout(function() {
                        var a = r.filter(function(t1, e1) {
                            return e1 === o && n[e1] !== i[e1];
                        });
                        b(t1, e1, a, r), i[o] = n[o];
                    }));
                }
                function P(t1, e1, r, a) {
                    return function() {
                        var o = i.select(e1.parentNode);
                        o.each(function(t1) {
                            var e1 = t1.fragments;
                            o.selectAll("tspan.line").each(function(t1, r) {
                                e1[r].width = this.getComputedTextLength();
                            });
                            var r, i, a = e1[e1.length - 1].width, s = e1.slice(0, -1), l = [], c = 0, u = t1.column.columnWidth - 2 * n.cellPad;
                            for(t1.value = ""; s.length;)c + (i = (r = s.shift()).width + a) > u && (t1.value += l.join(n.wrapSpacer) + n.lineBreaker, l = [], c = 0), l.push(r.text), c += i;
                            c && (t1.value += l.join(n.wrapSpacer)), t1.wrapped = !0;
                        }), o.selectAll("tspan.line").remove(), _(o.select("." + n.cn.cellText), r, t1, a), i.select(e1.parentNode.parentNode).call(z);
                    };
                }
                function I(t1, e1, r, a, o) {
                    return function() {
                        if (!o.settledY) {
                            var s = i.select(e1.parentNode), l = B(o), c = o.key - l.firstRowIndex, f = l.rows[c].rowHeight, h = o.cellHeightMayIncrease ? e1.parentNode.getBoundingClientRect().height + 2 * n.cellPad : f, p = Math.max(h, f);
                            p - l.rows[c].rowHeight && (l.rows[c].rowHeight = p, t1.selectAll("." + n.cn.columnCell).call(z), E(null, t1.filter(A), 0), x(r, a, !0)), s.attr("transform", function() {
                                var t1 = this.parentNode.getBoundingClientRect(), e1 = i.select(this.parentNode).select("." + n.cn.cellRect).node().getBoundingClientRect(), r = this.transform.baseVal.consolidate(), a = e1.top - t1.top + (r ? r.matrix.f : n.cellPad);
                                return u(O(o, i.select(this.parentNode).select("." + n.cn.cellTextHolder).node().getBoundingClientRect().width), a);
                            }), o.settledY = !0;
                        }
                    };
                }
                function O(t1, e1) {
                    switch(t1.align){
                        case "left":
                            return n.cellPad;
                        case "right":
                            return t1.column.columnWidth - (e1 || 0) - n.cellPad;
                        case "center":
                            return (t1.column.columnWidth - (e1 || 0)) / 2;
                        default:
                            return n.cellPad;
                    }
                }
                function z(t1) {
                    t1.attr("transform", function(t1) {
                        var e1 = t1.rowBlocks[0].auxiliaryBlocks.reduce(function(t1, e1) {
                            return t1 + R(e1, 1 / 0);
                        }, 0), r = R(B(t1), t1.key);
                        return u(0, r + e1);
                    }).selectAll("." + n.cn.cellRect).attr("height", function(t1) {
                        var e1, r;
                        return (e1 = B(t1), r = t1.key, e1.rows[r - e1.firstRowIndex]).rowHeight;
                    });
                }
                function D(t1, e1) {
                    for(var r = 0, n = e1 - 1; n >= 0; n--)r += F(t1[n]);
                    return r;
                }
                function R(t1, e1) {
                    for(var r = 0, n = 0; n < t1.rows.length && t1.rows[n].rowIndex < e1; n++)r += t1.rows[n].rowHeight;
                    return r;
                }
                function F(t1) {
                    var e1 = t1.allRowsHeight;
                    if (void 0 !== e1) return e1;
                    for(var r = 0, n = 0; n < t1.rows.length; n++)r += t1.rows[n].rowHeight;
                    return t1.allRowsHeight = r, r;
                }
                function B(t1) {
                    return t1.rowBlocks[t1.page];
                }
                e1.exports = function(t1, e1) {
                    var r = !t1._context.staticPlot, a = t1._fullLayout._paper.selectAll("." + n.cn.table).data(e1.map(function(e1) {
                        var r = o.unwrap(e1).trace;
                        return h(t1, r);
                    }), o.keyFun);
                    a.exit().remove(), a.enter().append("g").classed(n.cn.table, !0).attr("overflow", "visible").style("box-sizing", "content-box").style("position", "absolute").style("left", 0).style("overflow", "visible").style("shape-rendering", "crispEdges").style("pointer-events", "all"), a.attr("width", function(t1) {
                        return t1.width + t1.size.l + t1.size.r;
                    }).attr("height", function(t1) {
                        return t1.height + t1.size.t + t1.size.b;
                    }).attr("transform", function(t1) {
                        return u(t1.translateX, t1.translateY);
                    });
                    var l = a.selectAll("." + n.cn.tableControlView).data(o.repeat, o.keyFun), d = l.enter().append("g").classed(n.cn.tableControlView, !0).style("box-sizing", "content-box");
                    if (r) {
                        var _ = "onwheel" in document ? "wheel" : "mousewheel";
                        d.on("mousemove", function(e1) {
                            l.filter(function(t1) {
                                return e1 === t1;
                            }).call(x, t1);
                        }).on(_, function(e1) {
                            if (!e1.scrollbarState.wheeling) {
                                e1.scrollbarState.wheeling = !0;
                                var r = e1.scrollY + i.event.deltaY;
                                L(t1, l, null, r)(e1) || (i.event.stopPropagation(), i.event.preventDefault()), e1.scrollbarState.wheeling = !1;
                            }
                        }).call(x, t1, !0);
                    }
                    l.attr("transform", function(t1) {
                        return u(t1.size.l, t1.size.t);
                    });
                    var w = l.selectAll("." + n.cn.scrollBackground).data(o.repeat, o.keyFun);
                    w.enter().append("rect").classed(n.cn.scrollBackground, !0).attr("fill", "none"), w.attr("width", function(t1) {
                        return t1.width;
                    }).attr("height", function(t1) {
                        return t1.height;
                    }), l.each(function(e1) {
                        s.setClipUrl(i.select(this), g(t1, e1), t1);
                    });
                    var T = l.selectAll("." + n.cn.yColumn).data(function(t1) {
                        return t1.columns;
                    }, o.keyFun);
                    T.enter().append("g").classed(n.cn.yColumn, !0), T.exit().remove(), T.attr("transform", function(t1) {
                        return u(t1.x, 0);
                    }), r && T.call(i.behavior.drag().origin(function(e1) {
                        return k(i.select(this), e1, -n.uplift), c(this), e1.calcdata.columnDragInProgress = !0, x(l.filter(function(t1) {
                            return e1.calcdata.key === t1.key;
                        }), t1), e1;
                    }).on("drag", function(t1) {
                        var e1 = i.select(this), r = function(e1) {
                            return (t1 === e1 ? i.event.x : e1.x) + e1.columnWidth / 2;
                        };
                        t1.x = Math.max(-n.overdrag, Math.min(t1.calcdata.width + n.overdrag - t1.columnWidth, i.event.x)), y(T).filter(function(e1) {
                            return e1.calcdata.key === t1.calcdata.key;
                        }).sort(function(t1, e1) {
                            return r(t1) - r(e1);
                        }).forEach(function(e1, r) {
                            e1.xIndex = r, e1.x = t1 === e1 ? e1.x : e1.xScale(e1);
                        }), T.filter(function(e1) {
                            return t1 !== e1;
                        }).transition().ease(n.transitionEase).duration(n.transitionDuration).attr("transform", function(t1) {
                            return u(t1.x, 0);
                        }), e1.call(f).attr("transform", u(t1.x, -n.uplift));
                    }).on("dragend", function(e1) {
                        var r = i.select(this), n = e1.calcdata;
                        e1.x = e1.xScale(e1), e1.calcdata.columnDragInProgress = !1, k(r, e1, 0), function(t1, e1, r) {
                            var n = e1.gdColumnsOriginalOrder;
                            e1.gdColumns.sort(function(t1, e1) {
                                return r[n.indexOf(t1)] - r[n.indexOf(e1)];
                            }), e1.columnorder = r, t1.emit("plotly_restyle");
                        }(t1, n, n.columns.map(function(t1) {
                            return t1.xIndex;
                        }));
                    })), T.each(function(e1) {
                        s.setClipUrl(i.select(this), v(t1, e1), t1);
                    });
                    var S = T.selectAll("." + n.cn.columnBlock).data(p.splitToPanels, o.keyFun);
                    S.enter().append("g").classed(n.cn.columnBlock, !0).attr("id", function(t1) {
                        return t1.key;
                    }), S.style("cursor", function(t1) {
                        return t1.dragHandle ? "ew-resize" : t1.calcdata.scrollbarState.barWiggleRoom ? "ns-resize" : "default";
                    });
                    var C = S.filter(M), P = S.filter(A);
                    r && P.call(i.behavior.drag().origin(function(t1) {
                        return i.event.stopPropagation(), t1;
                    }).on("drag", L(t1, l, -1)).on("dragend", function() {})), b(t1, l, C, S), b(t1, l, P, S);
                    var I = l.selectAll("." + n.cn.scrollAreaClip).data(o.repeat, o.keyFun);
                    I.enter().append("clipPath").classed(n.cn.scrollAreaClip, !0).attr("id", function(e1) {
                        return g(t1, e1);
                    });
                    var O = I.selectAll("." + n.cn.scrollAreaClipRect).data(o.repeat, o.keyFun);
                    O.enter().append("rect").classed(n.cn.scrollAreaClipRect, !0).attr("x", -n.overdrag).attr("y", -n.uplift).attr("fill", "none"), O.attr("width", function(t1) {
                        return t1.width + 2 * n.overdrag;
                    }).attr("height", function(t1) {
                        return t1.height + n.uplift;
                    }), T.selectAll("." + n.cn.columnBoundary).data(o.repeat, o.keyFun).enter().append("g").classed(n.cn.columnBoundary, !0);
                    var z = T.selectAll("." + n.cn.columnBoundaryClippath).data(o.repeat, o.keyFun);
                    z.enter().append("clipPath").classed(n.cn.columnBoundaryClippath, !0), z.attr("id", function(e1) {
                        return v(t1, e1);
                    });
                    var D = z.selectAll("." + n.cn.columnBoundaryRect).data(o.repeat, o.keyFun);
                    D.enter().append("rect").classed(n.cn.columnBoundaryRect, !0).attr("fill", "none"), D.attr("width", function(t1) {
                        return t1.columnWidth + 2 * m(t1);
                    }).attr("height", function(t1) {
                        return t1.calcdata.height + 2 * m(t1) + n.uplift;
                    }).attr("x", function(t1) {
                        return -m(t1);
                    }).attr("y", function(t1) {
                        return -m(t1);
                    }), E(null, P, l);
                };
            },
            {
                "../../components/color": 366,
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../lib/gup": 500,
                "../../lib/svg_text_utils": 529,
                "./constants": 1065,
                "./data_preparation_helper": 1066,
                "./data_split_helpers": 1067,
                "@plotly/d3": 58
            }
        ],
        1071: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/template_attributes").hovertemplateAttrs, i = t1("../../plots/template_attributes").texttemplateAttrs, a = t1("../../components/colorscale/attributes"), o = t1("../../plots/domain").attributes, s = t1("../pie/attributes"), l = t1("../sunburst/attributes"), c = t1("./constants"), u = t1("../../lib/extend").extendFlat;
                e1.exports = {
                    labels: l.labels,
                    parents: l.parents,
                    values: l.values,
                    branchvalues: l.branchvalues,
                    count: l.count,
                    level: l.level,
                    maxdepth: l.maxdepth,
                    tiling: {
                        packing: {
                            valType: "enumerated",
                            values: [
                                "squarify",
                                "binary",
                                "dice",
                                "slice",
                                "slice-dice",
                                "dice-slice"
                            ],
                            dflt: "squarify",
                            editType: "plot"
                        },
                        squarifyratio: {
                            valType: "number",
                            min: 1,
                            dflt: 1,
                            editType: "plot"
                        },
                        flip: {
                            valType: "flaglist",
                            flags: [
                                "x",
                                "y"
                            ],
                            dflt: "",
                            editType: "plot"
                        },
                        pad: {
                            valType: "number",
                            min: 0,
                            dflt: 3,
                            editType: "plot"
                        },
                        editType: "calc"
                    },
                    marker: u({
                        pad: {
                            t: {
                                valType: "number",
                                min: 0,
                                editType: "plot"
                            },
                            l: {
                                valType: "number",
                                min: 0,
                                editType: "plot"
                            },
                            r: {
                                valType: "number",
                                min: 0,
                                editType: "plot"
                            },
                            b: {
                                valType: "number",
                                min: 0,
                                editType: "plot"
                            },
                            editType: "calc"
                        },
                        colors: l.marker.colors,
                        depthfade: {
                            valType: "enumerated",
                            values: [
                                !0,
                                !1,
                                "reversed"
                            ],
                            editType: "style"
                        },
                        line: l.marker.line,
                        editType: "calc"
                    }, a("marker", {
                        colorAttr: "colors",
                        anim: !1
                    })),
                    pathbar: {
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        side: {
                            valType: "enumerated",
                            values: [
                                "top",
                                "bottom"
                            ],
                            dflt: "top",
                            editType: "plot"
                        },
                        edgeshape: {
                            valType: "enumerated",
                            values: [
                                ">",
                                "<",
                                "|",
                                "/",
                                "\\"
                            ],
                            dflt: ">",
                            editType: "plot"
                        },
                        thickness: {
                            valType: "number",
                            min: 12,
                            editType: "plot"
                        },
                        textfont: u({}, s.textfont, {}),
                        editType: "calc"
                    },
                    text: s.text,
                    textinfo: l.textinfo,
                    texttemplate: i({
                        editType: "plot"
                    }, {
                        keys: c.eventDataKeys.concat([
                            "label",
                            "value"
                        ])
                    }),
                    hovertext: s.hovertext,
                    hoverinfo: l.hoverinfo,
                    hovertemplate: n({}, {
                        keys: c.eventDataKeys
                    }),
                    textfont: s.textfont,
                    insidetextfont: s.insidetextfont,
                    outsidetextfont: u({}, s.outsidetextfont, {}),
                    textposition: {
                        valType: "enumerated",
                        values: [
                            "top left",
                            "top center",
                            "top right",
                            "middle left",
                            "middle center",
                            "middle right",
                            "bottom left",
                            "bottom center",
                            "bottom right"
                        ],
                        dflt: "top left",
                        editType: "plot"
                    },
                    sort: s.sort,
                    root: l.root,
                    domain: o({
                        name: "treemap",
                        trace: !0,
                        editType: "calc"
                    })
                };
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plots/domain": 584,
                "../../plots/template_attributes": 633,
                "../pie/attributes": 900,
                "../sunburst/attributes": 1045,
                "./constants": 1074
            }
        ],
        1072: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/plots");
                r.name = "treemap", r.plot = function(t1, e1, i, a) {
                    n.plotBasePlot(r.name, t1, e1, i, a);
                }, r.clean = function(t1, e1, i, a) {
                    n.cleanBasePlot(r.name, t1, e1, i, a);
                };
            },
            {
                "../../plots/plots": 619
            }
        ],
        1073: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../sunburst/calc");
                r.calc = function(t1, e1) {
                    return n.calc(t1, e1);
                }, r.crossTraceCalc = function(t1) {
                    return n._runCrossTraceCalc("treemap", t1);
                };
            },
            {
                "../sunburst/calc": 1047
            }
        ],
        1074: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    CLICK_TRANSITION_TIME: 750,
                    CLICK_TRANSITION_EASING: "poly",
                    eventDataKeys: [
                        "currentPath",
                        "root",
                        "entry",
                        "percentRoot",
                        "percentEntry",
                        "percentParent"
                    ],
                    gapWithPathbar: 1
                };
            },
            {}
        ],
        1075: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./attributes"), a = t1("../../components/color"), o = t1("../../plots/domain").defaults, s = t1("../bar/defaults").handleText, l = t1("../bar/constants").TEXTPAD, c = t1("../../components/colorscale"), u = c.hasColorscale, f = c.handleDefaults;
                e1.exports = function(t1, e1, r, c) {
                    function h(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    var p = h("labels"), d = h("parents");
                    if (p && p.length && d && d.length) {
                        var m = h("values");
                        m && m.length ? h("branchvalues") : h("count"), h("level"), h("maxdepth"), "squarify" === h("tiling.packing") && h("tiling.squarifyratio"), h("tiling.flip"), h("tiling.pad");
                        var g = h("text");
                        h("texttemplate"), e1.texttemplate || h("textinfo", Array.isArray(g) ? "text+label" : "label"), h("hovertext"), h("hovertemplate");
                        var v = h("pathbar.visible");
                        s(t1, e1, c, h, "auto", {
                            hasPathbar: v,
                            moduleHasSelected: !1,
                            moduleHasUnselected: !1,
                            moduleHasConstrain: !1,
                            moduleHasCliponaxis: !1,
                            moduleHasTextangle: !1,
                            moduleHasInsideanchor: !1
                        }), h("textposition");
                        var y = -1 !== e1.textposition.indexOf("bottom");
                        h("marker.line.width") && h("marker.line.color", c.paper_bgcolor);
                        var x = h("marker.colors");
                        (e1._hasColorscale = u(t1, "marker", "colors") || (t1.marker || {}).coloraxis) ? f(t1, e1, c, h, {
                            prefix: "marker.",
                            cLetter: "c"
                        }) : h("marker.depthfade", !(x || []).length);
                        var b = 2 * e1.textfont.size;
                        h("marker.pad.t", y ? b / 4 : b), h("marker.pad.l", b / 4), h("marker.pad.r", b / 4), h("marker.pad.b", y ? b : b / 4), e1._hovered = {
                            marker: {
                                line: {
                                    width: 2,
                                    color: a.contrast(c.paper_bgcolor)
                                }
                            }
                        }, v && (h("pathbar.thickness", e1.pathbar.textfont.size + 2 * l), h("pathbar.side"), h("pathbar.edgeshape")), h("sort"), h("root.color"), o(e1, c, h), e1._length = null;
                    } else e1.visible = !1;
                };
            },
            {
                "../../components/color": 366,
                "../../components/colorscale": 378,
                "../../lib": 503,
                "../../plots/domain": 584,
                "../bar/constants": 650,
                "../bar/defaults": 652,
                "./attributes": 1071
            }
        ],
        1076: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../sunburst/helpers"), a = t1("../bar/uniform_text").clearMinTextSize, o = t1("../bar/style").resizeText, s = t1("./plot_one");
                e1.exports = function(t1, e1, r, l, c) {
                    var u, f, h = c.type, p = c.drawDescendants, d = t1._fullLayout, m = d["_" + h + "layer"], g = !r;
                    (a(h, d), (u = m.selectAll("g.trace." + h).data(e1, function(t1) {
                        return t1[0].trace.uid;
                    })).enter().append("g").classed("trace", !0).classed(h, !0), u.order(), !d.uniformtext.mode && i.hasTransition(r)) ? (l && (f = l()), n.transition().duration(r.duration).ease(r.easing).each("end", function() {
                        f && f();
                    }).each("interrupt", function() {
                        f && f();
                    }).each(function() {
                        m.selectAll("g.trace").each(function(e1) {
                            s(t1, e1, this, r, p);
                        });
                    })) : (u.each(function(e1) {
                        s(t1, e1, this, r, p);
                    }), d.uniformtext.mode && o(t1, m.selectAll(".trace"), h));
                    g && u.exit().remove();
                };
            },
            {
                "../bar/style": 662,
                "../bar/uniform_text": 664,
                "../sunburst/helpers": 1051,
                "./plot_one": 1085,
                "@plotly/d3": 58
            }
        ],
        1077: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../../components/drawing"), o = t1("../../lib/svg_text_utils"), s = t1("./partition"), l = t1("./style").styleOne, c = t1("./constants"), u = t1("../sunburst/helpers"), f = t1("../sunburst/fx");
                e1.exports = function(t1, e1, r, h, p) {
                    var d = p.barDifY, m = p.width, g = p.height, v = p.viewX, y = p.viewY, x = p.pathSlice, b = p.toMoveInsideSlice, _ = p.strTransform, w = p.hasTransition, T = p.handleSlicesExit, k = p.makeUpdateSliceInterpolator, A = p.makeUpdateTextInterpolator, M = {}, S = t1._fullLayout, E = e1[0], L = E.trace, C = E.hierarchy, P = m / L._entryDepth, I = u.listPath(r.data, "id"), O = s(C.copy(), [
                        m,
                        g
                    ], {
                        packing: "dice",
                        pad: {
                            inner: 0,
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0
                        }
                    }).descendants();
                    (O = O.filter(function(t1) {
                        var e1 = I.indexOf(t1.data.id);
                        return -1 !== e1 && (t1.x0 = P * e1, t1.x1 = P * (e1 + 1), t1.y0 = d, t1.y1 = d + g, t1.onPathbar = !0, !0);
                    })).reverse(), (h = h.data(O, u.getPtId)).enter().append("g").classed("pathbar", !0), T(h, !0, M, [
                        m,
                        g
                    ], x), h.order();
                    var z = h;
                    w && (z = z.transition().each("end", function() {
                        var e1 = n.select(this);
                        u.setSliceCursor(e1, t1, {
                            hideOnRoot: !1,
                            hideOnLeaves: !1,
                            isTransitioning: !1
                        });
                    })), z.each(function(s) {
                        s._x0 = v(s.x0), s._x1 = v(s.x1), s._y0 = y(s.y0), s._y1 = y(s.y1), s._hoverX = v(s.x1 - Math.min(m, g) / 2), s._hoverY = y(s.y1 - g / 2);
                        var h = n.select(this), p = i.ensureSingle(h, "path", "surface", function(t1) {
                            t1.style("pointer-events", "all");
                        });
                        w ? p.transition().attrTween("d", function(t1) {
                            var e1 = k(t1, !0, M, [
                                m,
                                g
                            ]);
                            return function(t1) {
                                return x(e1(t1));
                            };
                        }) : p.attr("d", x), h.call(f, r, t1, e1, {
                            styleOne: l,
                            eventDataKeys: c.eventDataKeys,
                            transitionTime: c.CLICK_TRANSITION_TIME,
                            transitionEasing: c.CLICK_TRANSITION_EASING
                        }).call(u.setSliceCursor, t1, {
                            hideOnRoot: !1,
                            hideOnLeaves: !1,
                            isTransitioning: t1._transitioning
                        }), p.call(l, s, L, {
                            hovered: !1
                        }), s._text = (u.getPtLabel(s) || "").split("<br>").join(" ") || "";
                        var d = i.ensureSingle(h, "g", "slicetext"), T = i.ensureSingle(d, "text", "", function(t1) {
                            t1.attr("data-notex", 1);
                        }), E = i.ensureUniformFontSize(t1, u.determineTextFont(L, s, S.font, {
                            onPathbar: !0
                        }));
                        T.text(s._text || " ").classed("slicetext", !0).attr("text-anchor", "start").call(a.font, E).call(o.convertToTspans, t1), s.textBB = a.bBox(T.node()), s.transform = b(s, {
                            fontSize: E.size,
                            onPathbar: !0
                        }), s.transform.fontSize = E.size, w ? T.transition().attrTween("transform", function(t1) {
                            var e1 = A(t1, !0, M, [
                                m,
                                g
                            ]);
                            return function(t1) {
                                return _(e1(t1));
                            };
                        }) : T.attr("transform", _(s));
                    });
                };
            },
            {
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../sunburst/fx": 1050,
                "../sunburst/helpers": 1051,
                "./constants": 1074,
                "./partition": 1083,
                "./style": 1086,
                "@plotly/d3": 58
            }
        ],
        1078: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../../components/drawing"), o = t1("../../lib/svg_text_utils"), s = t1("./partition"), l = t1("./style").styleOne, c = t1("./constants"), u = t1("../sunburst/helpers"), f = t1("../sunburst/fx"), h = t1("../sunburst/plot").formatSliceLabel;
                e1.exports = function(t1, e1, r, p, d) {
                    var m = d.width, g = d.height, v = d.viewX, y = d.viewY, x = d.pathSlice, b = d.toMoveInsideSlice, _ = d.strTransform, w = d.hasTransition, T = d.handleSlicesExit, k = d.makeUpdateSliceInterpolator, A = d.makeUpdateTextInterpolator, M = d.prevEntry, S = t1._fullLayout, E = e1[0].trace, L = -1 !== E.textposition.indexOf("left"), C = -1 !== E.textposition.indexOf("right"), P = -1 !== E.textposition.indexOf("bottom"), I = !P && !E.marker.pad.t || P && !E.marker.pad.b, O = s(r, [
                        m,
                        g
                    ], {
                        packing: E.tiling.packing,
                        squarifyratio: E.tiling.squarifyratio,
                        flipX: E.tiling.flip.indexOf("x") > -1,
                        flipY: E.tiling.flip.indexOf("y") > -1,
                        pad: {
                            inner: E.tiling.pad,
                            top: E.marker.pad.t,
                            left: E.marker.pad.l,
                            right: E.marker.pad.r,
                            bottom: E.marker.pad.b
                        }
                    }).descendants(), z = 1 / 0, D = -1 / 0;
                    O.forEach(function(t1) {
                        var e1 = t1.depth;
                        e1 >= E._maxDepth ? (t1.x0 = t1.x1 = (t1.x0 + t1.x1) / 2, t1.y0 = t1.y1 = (t1.y0 + t1.y1) / 2) : (z = Math.min(z, e1), D = Math.max(D, e1));
                    }), p = p.data(O, u.getPtId), E._maxVisibleLayers = isFinite(D) ? D - z + 1 : 0, p.enter().append("g").classed("slice", !0), T(p, !1, {}, [
                        m,
                        g
                    ], x), p.order();
                    var R = null;
                    if (w && M) {
                        var F = u.getPtId(M);
                        p.each(function(t1) {
                            null === R && u.getPtId(t1) === F && (R = {
                                x0: t1.x0,
                                x1: t1.x1,
                                y0: t1.y0,
                                y1: t1.y1
                            });
                        });
                    }
                    var B = function() {
                        return R || {
                            x0: 0,
                            x1: m,
                            y0: 0,
                            y1: g
                        };
                    }, N = p;
                    return w && (N = N.transition().each("end", function() {
                        var e1 = n.select(this);
                        u.setSliceCursor(e1, t1, {
                            hideOnRoot: !0,
                            hideOnLeaves: !1,
                            isTransitioning: !1
                        });
                    })), N.each(function(s) {
                        var p = u.isHeader(s, E);
                        s._x0 = v(s.x0), s._x1 = v(s.x1), s._y0 = y(s.y0), s._y1 = y(s.y1), s._hoverX = v(s.x1 - E.marker.pad.r), s._hoverY = y(P ? s.y1 - E.marker.pad.b / 2 : s.y0 + E.marker.pad.t / 2);
                        var d = n.select(this), T = i.ensureSingle(d, "path", "surface", function(t1) {
                            t1.style("pointer-events", "all");
                        });
                        w ? T.transition().attrTween("d", function(t1) {
                            var e1 = k(t1, !1, B(), [
                                m,
                                g
                            ]);
                            return function(t1) {
                                return x(e1(t1));
                            };
                        }) : T.attr("d", x), d.call(f, r, t1, e1, {
                            styleOne: l,
                            eventDataKeys: c.eventDataKeys,
                            transitionTime: c.CLICK_TRANSITION_TIME,
                            transitionEasing: c.CLICK_TRANSITION_EASING
                        }).call(u.setSliceCursor, t1, {
                            isTransitioning: t1._transitioning
                        }), T.call(l, s, E, {
                            hovered: !1
                        }), s.x0 === s.x1 || s.y0 === s.y1 ? s._text = "" : s._text = p ? I ? "" : u.getPtLabel(s) || "" : h(s, r, E, e1, S) || "";
                        var M = i.ensureSingle(d, "g", "slicetext"), O = i.ensureSingle(M, "text", "", function(t1) {
                            t1.attr("data-notex", 1);
                        }), z = i.ensureUniformFontSize(t1, u.determineTextFont(E, s, S.font));
                        O.text(s._text || " ").classed("slicetext", !0).attr("text-anchor", C ? "end" : L || p ? "start" : "middle").call(a.font, z).call(o.convertToTspans, t1), s.textBB = a.bBox(O.node()), s.transform = b(s, {
                            fontSize: z.size,
                            isHeader: p
                        }), s.transform.fontSize = z.size, w ? O.transition().attrTween("transform", function(t1) {
                            var e1 = A(t1, !1, B(), [
                                m,
                                g
                            ]);
                            return function(t1) {
                                return _(e1(t1));
                            };
                        }) : O.attr("transform", _(s));
                    }), R;
                };
            },
            {
                "../../components/drawing": 388,
                "../../lib": 503,
                "../../lib/svg_text_utils": 529,
                "../sunburst/fx": 1050,
                "../sunburst/helpers": 1051,
                "../sunburst/plot": 1055,
                "./constants": 1074,
                "./partition": 1083,
                "./style": 1086,
                "@plotly/d3": 58
            }
        ],
        1079: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function t1(e1, r, n) {
                    var i;
                    n.swapXY && (i = e1.x0, e1.x0 = e1.y0, e1.y0 = i, i = e1.x1, e1.x1 = e1.y1, e1.y1 = i), n.flipX && (i = e1.x0, e1.x0 = r[0] - e1.x1, e1.x1 = r[0] - i), n.flipY && (i = e1.y0, e1.y0 = r[1] - e1.y1, e1.y1 = r[1] - i);
                    var a = e1.children;
                    if (a) for(var o = 0; o < a.length; o++)t1(a[o], r, n);
                };
            },
            {}
        ],
        1080: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    moduleType: "trace",
                    name: "treemap",
                    basePlotModule: t1("./base_plot"),
                    categories: [],
                    animatable: !0,
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("./layout_attributes"),
                    supplyDefaults: t1("./defaults"),
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    calc: t1("./calc").calc,
                    crossTraceCalc: t1("./calc").crossTraceCalc,
                    plot: t1("./plot"),
                    style: t1("./style").style,
                    colorbar: t1("../scatter/marker_colorbar"),
                    meta: {}
                };
            },
            {
                "../scatter/marker_colorbar": 944,
                "./attributes": 1071,
                "./base_plot": 1072,
                "./calc": 1073,
                "./defaults": 1075,
                "./layout_attributes": 1081,
                "./layout_defaults": 1082,
                "./plot": 1084,
                "./style": 1086
            }
        ],
        1081: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    treemapcolorway: {
                        valType: "colorlist",
                        editType: "calc"
                    },
                    extendtreemapcolors: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    }
                };
            },
            {}
        ],
        1082: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./layout_attributes");
                e1.exports = function(t1, e1) {
                    function r(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    r("treemapcolorway", e1.colorway), r("extendtreemapcolors");
                };
            },
            {
                "../../lib": 503,
                "./layout_attributes": 1081
            }
        ],
        1083: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("d3-hierarchy"), i = t1("./flip_tree");
                e1.exports = function(t1, e1, r) {
                    var a, o = r.flipX, s = r.flipY, l = "dice-slice" === r.packing, c = r.pad[s ? "bottom" : "top"], u = r.pad[o ? "right" : "left"], f = r.pad[o ? "left" : "right"], h = r.pad[s ? "top" : "bottom"];
                    l && (a = u, u = c, c = a, a = f, f = h, h = a);
                    var p = n.treemap().tile(function(t1, e1) {
                        switch(t1){
                            case "squarify":
                                return n.treemapSquarify.ratio(e1);
                            case "binary":
                                return n.treemapBinary;
                            case "dice":
                                return n.treemapDice;
                            case "slice":
                                return n.treemapSlice;
                            default:
                                return n.treemapSliceDice;
                        }
                    }(r.packing, r.squarifyratio)).paddingInner(r.pad.inner).paddingLeft(u).paddingRight(f).paddingTop(c).paddingBottom(h).size(l ? [
                        e1[1],
                        e1[0]
                    ] : e1)(t1);
                    return (l || o || s) && i(p, e1, {
                        swapXY: l,
                        flipX: o,
                        flipY: s
                    }), p;
                };
            },
            {
                "./flip_tree": 1079,
                "d3-hierarchy": 115
            }
        ],
        1084: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("./draw"), i = t1("./draw_descendants");
                e1.exports = function(t1, e1, r, a) {
                    return n(t1, e1, r, a, {
                        type: "treemap",
                        drawDescendants: i
                    });
                };
            },
            {
                "./draw": 1076,
                "./draw_descendants": 1078
            }
        ],
        1085: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("d3-interpolate").interpolate, a = t1("../sunburst/helpers"), o = t1("../../lib"), s = t1("../bar/constants").TEXTPAD, l = t1("../bar/plot").toMoveInsideBar, c = t1("../bar/uniform_text").recordMinTextSize, u = t1("./constants"), f = t1("./draw_ancestors");
                function h(t1) {
                    return a.isHierarchyRoot(t1) ? "" : a.getPtId(t1);
                }
                e1.exports = function(t1, e1, r, p, d) {
                    var m = t1._fullLayout, g = e1[0], v = g.trace, y = "icicle" === v.type, x = g.hierarchy, b = a.findEntryWithLevel(x, v.level), _ = n.select(r), w = _.selectAll("g.pathbar"), T = _.selectAll("g.slice");
                    if (!b) return w.remove(), void T.remove();
                    var k = a.isHierarchyRoot(b), A = !m.uniformtext.mode && a.hasTransition(p), M = a.getMaxDepth(v), S = m._size, E = v.domain, L = S.w * (E.x[1] - E.x[0]), C = S.h * (E.y[1] - E.y[0]), P = L, I = v.pathbar.thickness, O = v.marker.line.width + u.gapWithPathbar, z = v.pathbar.visible ? v.pathbar.side.indexOf("bottom") > -1 ? C + O : -(I + O) : 0, D = {
                        x0: P,
                        x1: P,
                        y0: z,
                        y1: z + I
                    }, R = function(t1, e1, r) {
                        var n = v.tiling.pad, i = function(t1) {
                            return t1 - n <= e1.x0;
                        }, a = function(t1) {
                            return t1 + n >= e1.x1;
                        }, o = function(t1) {
                            return t1 - n <= e1.y0;
                        }, s = function(t1) {
                            return t1 + n >= e1.y1;
                        };
                        return t1.x0 === e1.x0 && t1.x1 === e1.x1 && t1.y0 === e1.y0 && t1.y1 === e1.y1 ? {
                            x0: t1.x0,
                            x1: t1.x1,
                            y0: t1.y0,
                            y1: t1.y1
                        } : {
                            x0: i(t1.x0 - n) ? 0 : a(t1.x0 - n) ? r[0] : t1.x0,
                            x1: i(t1.x1 + n) ? 0 : a(t1.x1 + n) ? r[0] : t1.x1,
                            y0: o(t1.y0 - n) ? 0 : s(t1.y0 - n) ? r[1] : t1.y0,
                            y1: o(t1.y1 + n) ? 0 : s(t1.y1 + n) ? r[1] : t1.y1
                        };
                    }, F = null, B = {}, N = {}, j = null, U = function(t1, e1) {
                        return e1 ? B[h(t1)] : N[h(t1)];
                    }, V = function(t1, e1, r, n) {
                        if (e1) return B[h(x)] || D;
                        var i = N[v.level] || r;
                        return function(t1) {
                            return t1.data.depth - b.data.depth < M;
                        }(t1) ? R(t1, i, n) : {};
                    };
                    g.hasMultipleRoots && k && M++, v._maxDepth = M, v._backgroundColor = m.paper_bgcolor, v._entryDepth = b.data.depth, v._atRootLevel = k;
                    var H = -L / 2 + S.l + S.w * (E.x[1] + E.x[0]) / 2, q = -C / 2 + S.t + S.h * (1 - (E.y[1] + E.y[0]) / 2), G = function(t1) {
                        return H + t1;
                    }, Y = function(t1) {
                        return q + t1;
                    }, W = Y(0), X = G(0), Z = function(t1) {
                        return X + t1;
                    }, J = function(t1) {
                        return W + t1;
                    };
                    function K(t1, e1) {
                        return t1 + "," + e1;
                    }
                    var Q = Z(0), $ = function(t1) {
                        t1.x = Math.max(Q, t1.x);
                    }, tt = v.pathbar.edgeshape, et = function(t1, e1) {
                        var r = t1.x0, n = t1.x1, i = t1.y0, a = t1.y1, o = t1.textBB, u = function(t1) {
                            return -1 !== v.textposition.indexOf(t1);
                        }, f = u("bottom"), h = u("top") || e1.isHeader && !f ? "start" : f ? "end" : "middle", p = u("right"), d = u("left") || e1.onPathbar ? -1 : p ? 1 : 0, g = v[y ? "tiling" : "marker"].pad;
                        if (e1.isHeader) {
                            if ((r += (y ? g : g.l) - s) >= (n -= (y ? g : g.r) - s)) {
                                var x = (r + n) / 2;
                                r = x, n = x;
                            }
                            var b;
                            f ? i < (b = a - (y ? g : g.b)) && b < a && (i = b) : i < (b = i + (y ? g : g.t)) && b < a && (a = b);
                        }
                        var _ = l(r, n, i, a, o, {
                            isHorizontal: !1,
                            constrained: !0,
                            angle: 0,
                            anchor: h,
                            leftToRight: d
                        });
                        return _.fontSize = e1.fontSize, _.targetX = G(_.targetX), _.targetY = Y(_.targetY), isNaN(_.targetX) || isNaN(_.targetY) ? {} : (r !== n && i !== a && c(v.type, _, m), {
                            scale: _.scale,
                            rotate: _.rotate,
                            textX: _.textX,
                            textY: _.textY,
                            anchorX: _.anchorX,
                            anchorY: _.anchorY,
                            targetX: _.targetX,
                            targetY: _.targetY
                        });
                    }, rt = function(t1, e1) {
                        for(var r, n = 0, i = t1; !r && n < M;)n++, (i = i.parent) ? r = U(i, e1) : n = M;
                        return r || {};
                    }, nt = function(t1, e1, r, n, a) {
                        var s, l = U(t1, e1);
                        if (l) s = l;
                        else if (e1) s = D;
                        else if (F) {
                            if (t1.parent) {
                                var c = j || r;
                                c && !e1 ? s = R(t1, c, n) : (s = {}, o.extendFlat(s, rt(t1, e1)));
                            } else s = o.extendFlat({}, t1), y && ("h" === a.orientation ? a.flipX ? s.x0 = t1.x1 : s.x1 = 0 : a.flipY ? s.y0 = t1.y1 : s.y1 = 0);
                        } else s = {};
                        return i(s, {
                            x0: t1.x0,
                            x1: t1.x1,
                            y0: t1.y0,
                            y1: t1.y1
                        });
                    }, it = function(t1, e1, r, n) {
                        var s = U(t1, e1), l = {}, u = V(t1, e1, r, n);
                        o.extendFlat(l, {
                            transform: et({
                                x0: u.x0,
                                x1: u.x1,
                                y0: u.y0,
                                y1: u.y1,
                                textBB: t1.textBB,
                                _text: t1._text
                            }, {
                                isHeader: a.isHeader(t1, v)
                            })
                        }), s ? l = s : t1.parent && o.extendFlat(l, rt(t1, e1));
                        var f = t1.transform;
                        return t1.x0 !== t1.x1 && t1.y0 !== t1.y1 && c(v.type, f, m), i(l, {
                            transform: {
                                scale: f.scale,
                                rotate: f.rotate,
                                textX: f.textX,
                                textY: f.textY,
                                anchorX: f.anchorX,
                                anchorY: f.anchorY,
                                targetX: f.targetX,
                                targetY: f.targetY
                            }
                        });
                    }, at = function(t1, e1, r, a, o) {
                        var s = a[0], l = a[1];
                        A ? t1.exit().transition().each(function() {
                            var t1 = n.select(this);
                            t1.select("path.surface").transition().attrTween("d", function(t1) {
                                var r = function(t1, e1, r, n) {
                                    var a, o = U(t1, e1);
                                    if (e1) a = D;
                                    else {
                                        var s = U(b, e1);
                                        a = s ? R(t1, s, n) : {};
                                    }
                                    return i(o, a);
                                }(t1, e1, 0, [
                                    s,
                                    l
                                ]);
                                return function(t1) {
                                    return o(r(t1));
                                };
                            }), t1.select("g.slicetext").attr("opacity", 0);
                        }).remove() : t1.exit().remove();
                    }, ot = function(t1) {
                        var e1 = t1.transform;
                        return t1.x0 !== t1.x1 && t1.y0 !== t1.y1 && c(v.type, e1, m), o.getTextTransform({
                            textX: e1.textX,
                            textY: e1.textY,
                            anchorX: e1.anchorX,
                            anchorY: e1.anchorY,
                            targetX: e1.targetX,
                            targetY: e1.targetY,
                            scale: e1.scale,
                            rotate: e1.rotate
                        });
                    };
                    A && (w.each(function(t1) {
                        B[h(t1)] = {
                            x0: t1.x0,
                            x1: t1.x1,
                            y0: t1.y0,
                            y1: t1.y1
                        }, t1.transform && (B[h(t1)].transform = {
                            textX: t1.transform.textX,
                            textY: t1.transform.textY,
                            anchorX: t1.transform.anchorX,
                            anchorY: t1.transform.anchorY,
                            targetX: t1.transform.targetX,
                            targetY: t1.transform.targetY,
                            scale: t1.transform.scale,
                            rotate: t1.transform.rotate
                        });
                    }), T.each(function(t1) {
                        N[h(t1)] = {
                            x0: t1.x0,
                            x1: t1.x1,
                            y0: t1.y0,
                            y1: t1.y1
                        }, t1.transform && (N[h(t1)].transform = {
                            textX: t1.transform.textX,
                            textY: t1.transform.textY,
                            anchorX: t1.transform.anchorX,
                            anchorY: t1.transform.anchorY,
                            targetX: t1.transform.targetX,
                            targetY: t1.transform.targetY,
                            scale: t1.transform.scale,
                            rotate: t1.transform.rotate
                        }), !F && a.isEntry(t1) && (F = t1);
                    })), j = d(t1, e1, b, T, {
                        width: L,
                        height: C,
                        viewX: G,
                        viewY: Y,
                        pathSlice: function(t1) {
                            var e1 = G(t1.x0), r = G(t1.x1), n = Y(t1.y0), i = Y(t1.y1), a = r - e1, o = i - n;
                            if (!a || !o) return "";
                            return "M" + K(e1, n + 0) + "L" + K(r - 0, n) + "L" + K(r, i - 0) + "L" + K(e1 + 0, i) + "Z";
                        },
                        toMoveInsideSlice: et,
                        prevEntry: F,
                        makeUpdateSliceInterpolator: nt,
                        makeUpdateTextInterpolator: it,
                        handleSlicesExit: at,
                        hasTransition: A,
                        strTransform: ot
                    }), v.pathbar.visible ? f(t1, e1, b, w, {
                        barDifY: z,
                        width: P,
                        height: I,
                        viewX: Z,
                        viewY: J,
                        pathSlice: function(t1) {
                            var e1 = Z(Math.max(Math.min(t1.x0, t1.x0), 0)), r = Z(Math.min(Math.max(t1.x1, t1.x1), P)), n = J(t1.y0), i = J(t1.y1), a = I / 2, o = {}, s = {};
                            o.x = e1, s.x = r, o.y = s.y = (n + i) / 2;
                            var l = {
                                x: e1,
                                y: n
                            }, c = {
                                x: r,
                                y: n
                            }, u = {
                                x: r,
                                y: i
                            }, f = {
                                x: e1,
                                y: i
                            };
                            return ">" === tt ? (l.x -= a, c.x -= a, u.x -= a, f.x -= a) : "/" === tt ? (u.x -= a, f.x -= a, o.x -= a / 2, s.x -= a / 2) : "\\" === tt ? (l.x -= a, c.x -= a, o.x -= a / 2, s.x -= a / 2) : "<" === tt && (o.x -= a, s.x -= a), $(l), $(f), $(o), $(c), $(u), $(s), "M" + K(l.x, l.y) + "L" + K(c.x, c.y) + "L" + K(s.x, s.y) + "L" + K(u.x, u.y) + "L" + K(f.x, f.y) + "L" + K(o.x, o.y) + "Z";
                        },
                        toMoveInsideSlice: et,
                        makeUpdateSliceInterpolator: nt,
                        makeUpdateTextInterpolator: it,
                        handleSlicesExit: at,
                        hasTransition: A,
                        strTransform: ot
                    }) : w.remove();
                };
            },
            {
                "../../lib": 503,
                "../bar/constants": 650,
                "../bar/plot": 659,
                "../bar/uniform_text": 664,
                "../sunburst/helpers": 1051,
                "./constants": 1074,
                "./draw_ancestors": 1077,
                "@plotly/d3": 58,
                "d3-interpolate": 116
            }
        ],
        1086: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/color"), a = t1("../../lib"), o = t1("../sunburst/helpers"), s = t1("../bar/uniform_text").resizeText;
                function l(t1, e1, r, n) {
                    var s, l, c = (n || {}).hovered, u = e1.data.data, f = u.i, h = u.color, p = o.isHierarchyRoot(e1), d = 1;
                    if (c) s = r._hovered.marker.line.color, l = r._hovered.marker.line.width;
                    else if (p && h === r.root.color) d = 100, s = "rgba(0,0,0,0)", l = 0;
                    else if (s = a.castOption(r, f, "marker.line.color") || i.defaultLine, l = a.castOption(r, f, "marker.line.width") || 0, !r._hasColorscale && !e1.onPathbar) {
                        var m = r.marker.depthfade;
                        if (m) {
                            var g, v = i.combine(i.addOpacity(r._backgroundColor, .75), h);
                            if (!0 === m) {
                                var y = o.getMaxDepth(r);
                                g = isFinite(y) ? o.isLeaf(e1) ? 0 : r._maxVisibleLayers - (e1.data.depth - r._entryDepth) : e1.data.height + 1;
                            } else g = e1.data.depth - r._entryDepth, r._atRootLevel || g++;
                            if (g > 0) for(var x = 0; x < g; x++){
                                var b = .5 * x / g;
                                h = i.combine(i.addOpacity(v, b), h);
                            }
                        }
                    }
                    t1.style("stroke-width", l).call(i.fill, h).call(i.stroke, s).style("opacity", d);
                }
                e1.exports = {
                    style: function(t1) {
                        var e1 = t1._fullLayout._treemaplayer.selectAll(".trace");
                        s(t1, e1, "treemap"), e1.each(function(t1) {
                            var e1 = n.select(this), r = t1[0].trace;
                            e1.style("opacity", r.opacity), e1.selectAll("path.surface").each(function(t1) {
                                n.select(this).call(l, t1, r, {
                                    hovered: !1
                                });
                            });
                        });
                    },
                    styleOne: l
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../bar/uniform_text": 664,
                "../sunburst/helpers": 1051,
                "@plotly/d3": 58
            }
        ],
        1087: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../box/attributes"), i = t1("../../lib/extend").extendFlat, a = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat;
                e1.exports = {
                    y: n.y,
                    x: n.x,
                    x0: n.x0,
                    y0: n.y0,
                    xhoverformat: a("x"),
                    yhoverformat: a("y"),
                    name: i({}, n.name, {}),
                    orientation: i({}, n.orientation, {}),
                    bandwidth: {
                        valType: "number",
                        min: 0,
                        editType: "calc"
                    },
                    scalegroup: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    scalemode: {
                        valType: "enumerated",
                        values: [
                            "width",
                            "count"
                        ],
                        dflt: "width",
                        editType: "calc"
                    },
                    spanmode: {
                        valType: "enumerated",
                        values: [
                            "soft",
                            "hard",
                            "manual"
                        ],
                        dflt: "soft",
                        editType: "calc"
                    },
                    span: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "calc"
                            },
                            {
                                valType: "any",
                                editType: "calc"
                            }
                        ],
                        editType: "calc"
                    },
                    line: {
                        color: {
                            valType: "color",
                            editType: "style"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: 2,
                            editType: "style"
                        },
                        editType: "plot"
                    },
                    fillcolor: n.fillcolor,
                    points: i({}, n.boxpoints, {}),
                    jitter: i({}, n.jitter, {}),
                    pointpos: i({}, n.pointpos, {}),
                    width: i({}, n.width, {}),
                    marker: n.marker,
                    text: n.text,
                    hovertext: n.hovertext,
                    hovertemplate: n.hovertemplate,
                    box: {
                        visible: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "plot"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: .25,
                            editType: "plot"
                        },
                        fillcolor: {
                            valType: "color",
                            editType: "style"
                        },
                        line: {
                            color: {
                                valType: "color",
                                editType: "style"
                            },
                            width: {
                                valType: "number",
                                min: 0,
                                editType: "style"
                            },
                            editType: "style"
                        },
                        editType: "plot"
                    },
                    meanline: {
                        visible: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "plot"
                        },
                        color: {
                            valType: "color",
                            editType: "style"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            editType: "style"
                        },
                        editType: "plot"
                    },
                    side: {
                        valType: "enumerated",
                        values: [
                            "both",
                            "positive",
                            "negative"
                        ],
                        dflt: "both",
                        editType: "calc"
                    },
                    offsetgroup: n.offsetgroup,
                    alignmentgroup: n.alignmentgroup,
                    selected: n.selected,
                    unselected: n.unselected,
                    hoveron: {
                        valType: "flaglist",
                        flags: [
                            "violins",
                            "points",
                            "kde"
                        ],
                        dflt: "violins+points+kde",
                        extras: [
                            "all"
                        ],
                        editType: "style"
                    }
                };
            },
            {
                "../../lib/extend": 493,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../box/attributes": 673
            }
        ],
        1088: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axes"), a = t1("../box/calc"), o = t1("./helpers"), s = t1("../../constants/numerical").BADNUM;
                function l(t1, e1, r) {
                    var i = e1.max - e1.min;
                    if (!i) return t1.bandwidth ? t1.bandwidth : 0;
                    if (t1.bandwidth) return Math.max(t1.bandwidth, i / 1e4);
                    var a = r.length, o = n.stdev(r, a - 1, e1.mean);
                    return Math.max(function(t1, e1, r) {
                        return 1.059 * Math.min(e1, r / 1.349) * Math.pow(t1, -0.2);
                    }(a, o, e1.q3 - e1.q1), i / 100);
                }
                function c(t1, e1, r, n) {
                    var a, o = t1.spanmode, l = t1.span || [], c = [
                        e1.min,
                        e1.max
                    ], u = [
                        e1.min - 2 * n,
                        e1.max + 2 * n
                    ];
                    function f(n) {
                        var i = l[n], a = "multicategory" === r.type ? r.r2c(i) : r.d2c(i, 0, t1[e1.valLetter + "calendar"]);
                        return a === s ? u[n] : a;
                    }
                    var h = {
                        type: "linear",
                        range: a = "soft" === o ? u : "hard" === o ? c : [
                            f(0),
                            f(1)
                        ]
                    };
                    return i.setConvert(h), h.cleanRange(), a;
                }
                e1.exports = function(t1, e1) {
                    var r = a(t1, e1);
                    if (r[0].t.empty) return r;
                    for(var s = t1._fullLayout, u = i.getFromId(t1, e1["h" === e1.orientation ? "xaxis" : "yaxis"]), f = 1 / 0, h = -1 / 0, p = 0, d = 0, m = 0; m < r.length; m++){
                        var g = r[m], v = g.pts.map(o.extractVal), y = g.bandwidth = l(e1, g, v), x = g.span = c(e1, g, u, y);
                        if (g.min === g.max && 0 === y) x = g.span = [
                            g.min,
                            g.max
                        ], g.density = [
                            {
                                v: 1,
                                t: x[0]
                            }
                        ], g.bandwidth = y, p = Math.max(p, 1);
                        else {
                            var b = x[1] - x[0], _ = Math.ceil(b / (y / 3)), w = b / _;
                            if (!isFinite(w) || !isFinite(_)) return n.error("Something went wrong with computing the violin span"), r[0].t.empty = !0, r;
                            var T = o.makeKDE(g, e1, v);
                            g.density = new Array(_);
                            for(var k = 0, A = x[0]; A < x[1] + w / 2; k++, A += w){
                                var M = T(A);
                                g.density[k] = {
                                    v: M,
                                    t: A
                                }, p = Math.max(p, M);
                            }
                        }
                        d = Math.max(d, v.length), f = Math.min(f, x[0]), h = Math.max(h, x[1]);
                    }
                    var S = i.findExtremes(u, [
                        f,
                        h
                    ], {
                        padded: !0
                    });
                    if (e1._extremes[u._id] = S, e1.width) r[0].t.maxKDE = p;
                    else {
                        var E = s._violinScaleGroupStats, L = e1.scalegroup, C = E[L];
                        C ? (C.maxKDE = Math.max(C.maxKDE, p), C.maxCount = Math.max(C.maxCount, d)) : E[L] = {
                            maxKDE: p,
                            maxCount: d
                        };
                    }
                    return r[0].t.labels.kde = n._(t1, "kde:"), r;
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "../box/calc": 674,
                "./helpers": 1091
            }
        ],
        1089: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../box/cross_trace_calc").setPositionOffset, i = [
                    "v",
                    "h"
                ];
                e1.exports = function(t1, e1) {
                    for(var r = t1.calcdata, a = e1.xaxis, o = e1.yaxis, s = 0; s < i.length; s++){
                        for(var l = i[s], c = "h" === l ? o : a, u = [], f = 0; f < r.length; f++){
                            var h = r[f], p = h[0].t, d = h[0].trace;
                            !0 !== d.visible || "violin" !== d.type || p.empty || d.orientation !== l || d.xaxis !== a._id || d.yaxis !== o._id || u.push(f);
                        }
                        n("violin", t1, u, c);
                    }
                };
            },
            {
                "../box/cross_trace_calc": 675
            }
        ],
        1090: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../components/color"), a = t1("../box/defaults"), o = t1("./attributes");
                e1.exports = function(t1, e1, r, s) {
                    function l(r, i) {
                        return n.coerce(t1, e1, o, r, i);
                    }
                    function c(r, i) {
                        return n.coerce2(t1, e1, o, r, i);
                    }
                    if (a.handleSampleDefaults(t1, e1, l, s), !1 !== e1.visible) {
                        l("bandwidth"), l("side"), l("width") || (l("scalegroup", e1.name), l("scalemode"));
                        var u, f = l("span");
                        Array.isArray(f) && (u = "manual"), l("spanmode", u);
                        var h = l("line.color", (t1.marker || {}).color || r), p = l("line.width"), d = l("fillcolor", i.addOpacity(e1.line.color, .5));
                        a.handlePointsDefaults(t1, e1, l, {
                            prefix: ""
                        });
                        var m = c("box.width"), g = c("box.fillcolor", d), v = c("box.line.color", h), y = c("box.line.width", p);
                        l("box.visible", Boolean(m || g || v || y)) || (e1.box = {
                            visible: !1
                        });
                        var x = c("meanline.color", h), b = c("meanline.width", p);
                        l("meanline.visible", Boolean(x || b)) || (e1.meanline = {
                            visible: !1
                        });
                    }
                };
            },
            {
                "../../components/color": 366,
                "../../lib": 503,
                "../box/defaults": 676,
                "./attributes": 1087
            }
        ],
        1091: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = function(t1) {
                    return 1 / Math.sqrt(2 * Math.PI) * Math.exp(-0.5 * t1 * t1);
                };
                r.makeKDE = function(t1, e1, r) {
                    var n = r.length, a = i, o = t1.bandwidth, s = 1 / (n * o);
                    return function(t1) {
                        for(var e1 = 0, i = 0; i < n; i++)e1 += a((t1 - r[i]) / o);
                        return s * e1;
                    };
                }, r.getPositionOnKdePath = function(t1, e1, r) {
                    var i, a;
                    "h" === e1.orientation ? (i = "y", a = "x") : (i = "x", a = "y");
                    var o = n.findPointOnPath(t1.path, r, a, {
                        pathLength: t1.pathLength
                    }), s = t1.posCenterPx, l = o[i];
                    return [
                        l,
                        "both" === e1.side ? 2 * s - l : s
                    ];
                }, r.getKdeValue = function(t1, e1, n) {
                    var i = t1.pts.map(r.extractVal);
                    return r.makeKDE(t1, e1, i)(n) / t1.posDensityScale;
                }, r.extractVal = function(t1) {
                    return t1.v;
                };
            },
            {
                "../../lib": 503
            }
        ],
        1092: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../../plots/cartesian/axes"), a = t1("../box/hover"), o = t1("./helpers");
                e1.exports = function(t1, e1, r, s, l) {
                    l || (l = {});
                    var c, u, f = l.hoverLayer, h = t1.cd, p = h[0].trace, d = p.hoveron, m = -1 !== d.indexOf("violins"), g = -1 !== d.indexOf("kde"), v = [];
                    if (m || g) {
                        var y = a.hoverOnBoxes(t1, e1, r, s);
                        if (g && y.length > 0) {
                            var x, b, _, w, T, k = t1.xa, A = t1.ya;
                            "h" === p.orientation ? (T = e1, x = "y", _ = A, b = "x", w = k) : (T = r, x = "x", _ = k, b = "y", w = A);
                            var M = h[t1.index];
                            if (T >= M.span[0] && T <= M.span[1]) {
                                var S = n.extendFlat({}, t1), E = w.c2p(T, !0), L = o.getKdeValue(M, p, T), C = o.getPositionOnKdePath(M, p, E), P = _._offset, I = _._length;
                                S[x + "0"] = C[0], S[x + "1"] = C[1], S[b + "0"] = S[b + "1"] = E, S[b + "Label"] = b + ": " + i.hoverLabelText(w, T, p[b + "hoverformat"]) + ", " + h[0].t.labels.kde + " " + L.toFixed(3), S.spikeDistance = y[0].spikeDistance;
                                var O = x + "Spike";
                                S[O] = y[0][O], y[0].spikeDistance = void 0, y[0][O] = void 0, S.hovertemplate = !1, v.push(S), (u = {
                                    stroke: t1.color
                                })[x + "1"] = n.constrain(P + C[0], P, P + I), u[x + "2"] = n.constrain(P + C[1], P, P + I), u[b + "1"] = u[b + "2"] = w._offset + E;
                            }
                        }
                        m && (v = v.concat(y));
                    }
                    -1 !== d.indexOf("points") && (c = a.hoverOnPoints(t1, e1, r));
                    var z = f.selectAll(".violinline-" + p.uid).data(u ? [
                        0
                    ] : []);
                    return z.enter().append("line").classed("violinline-" + p.uid, !0).attr("stroke-width", 1.5), z.exit().remove(), z.attr(u), "closest" === s ? c ? [
                        c
                    ] : v : c ? (v.push(c), v) : v;
                };
            },
            {
                "../../lib": 503,
                "../../plots/cartesian/axes": 554,
                "../box/hover": 678,
                "./helpers": 1091
            }
        ],
        1093: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("./layout_attributes"),
                    supplyDefaults: t1("./defaults"),
                    crossTraceDefaults: t1("../box/defaults").crossTraceDefaults,
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    calc: t1("./calc"),
                    crossTraceCalc: t1("./cross_trace_calc"),
                    plot: t1("./plot"),
                    style: t1("./style"),
                    styleOnSelect: t1("../scatter/style").styleOnSelect,
                    hoverPoints: t1("./hover"),
                    selectPoints: t1("../box/select"),
                    moduleType: "trace",
                    name: "violin",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "cartesian",
                        "svg",
                        "symbols",
                        "oriented",
                        "box-violin",
                        "showLegend",
                        "violinLayout",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "../box/defaults": 676,
                "../box/select": 683,
                "../scatter/style": 950,
                "./attributes": 1087,
                "./calc": 1088,
                "./cross_trace_calc": 1089,
                "./defaults": 1090,
                "./hover": 1092,
                "./layout_attributes": 1094,
                "./layout_defaults": 1095,
                "./plot": 1096,
                "./style": 1097
            }
        ],
        1094: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../box/layout_attributes"), i = t1("../../lib").extendFlat;
                e1.exports = {
                    violinmode: i({}, n.boxmode, {}),
                    violingap: i({}, n.boxgap, {}),
                    violingroupgap: i({}, n.boxgroupgap, {})
                };
            },
            {
                "../../lib": 503,
                "../box/layout_attributes": 680
            }
        ],
        1095: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./layout_attributes"), a = t1("../box/layout_defaults");
                e1.exports = function(t1, e1, r) {
                    a._supply(t1, e1, r, function(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }, "violin");
                };
            },
            {
                "../../lib": 503,
                "../box/layout_defaults": 681,
                "./layout_attributes": 1094
            }
        ],
        1096: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../../components/drawing"), o = t1("../box/plot"), s = t1("../scatter/line_points"), l = t1("./helpers");
                e1.exports = function(t1, e1, r, c) {
                    var u = t1._fullLayout, f = e1.xaxis, h = e1.yaxis;
                    function p(t1) {
                        var e1 = s(t1, {
                            xaxis: f,
                            yaxis: h,
                            connectGaps: !0,
                            baseTolerance: .75,
                            shape: "spline",
                            simplify: !0,
                            linearized: !0
                        });
                        return a.smoothopen(e1[0], 1);
                    }
                    i.makeTraceGroups(c, r, "trace violins").each(function(t1) {
                        var r = n.select(this), a = t1[0], s = a.t, c = a.trace;
                        if (!0 !== c.visible || s.empty) r.remove();
                        else {
                            var d = s.bPos, m = s.bdPos, g = e1[s.valLetter + "axis"], v = e1[s.posLetter + "axis"], y = "both" === c.side, x = y || "positive" === c.side, b = y || "negative" === c.side, _ = r.selectAll("path.violin").data(i.identity);
                            _.enter().append("path").style("vector-effect", "non-scaling-stroke").attr("class", "violin"), _.exit().remove(), _.each(function(t1) {
                                var e1, r, i, a, o, l, f, h, _ = n.select(this), w = t1.density, T = w.length, k = v.c2l(t1.pos + d, !0), A = v.l2p(k);
                                if (c.width) e1 = s.maxKDE / m;
                                else {
                                    var M = u._violinScaleGroupStats[c.scalegroup];
                                    e1 = "count" === c.scalemode ? M.maxKDE / m * (M.maxCount / t1.pts.length) : M.maxKDE / m;
                                }
                                if (x) {
                                    for(f = new Array(T), o = 0; o < T; o++)(h = f[o] = {})[s.posLetter] = k + w[o].v / e1, h[s.valLetter] = g.c2l(w[o].t, !0);
                                    r = p(f);
                                }
                                if (b) {
                                    for(f = new Array(T), l = 0, o = T - 1; l < T; l++, o--)(h = f[l] = {})[s.posLetter] = k - w[o].v / e1, h[s.valLetter] = g.c2l(w[o].t, !0);
                                    i = p(f);
                                }
                                if (y) a = r + "L" + i.substr(1) + "Z";
                                else {
                                    var S = [
                                        A,
                                        g.c2p(w[0].t)
                                    ], E = [
                                        A,
                                        g.c2p(w[T - 1].t)
                                    ];
                                    "h" === c.orientation && (S.reverse(), E.reverse()), a = x ? "M" + S + "L" + r.substr(1) + "L" + E : "M" + E + "L" + i.substr(1) + "L" + S;
                                }
                                _.attr("d", a), t1.posCenterPx = A, t1.posDensityScale = e1 * m, t1.path = _.node(), t1.pathLength = t1.path.getTotalLength() / (y ? 2 : 1);
                            });
                            var w, T, k, A = c.box, M = A.width, S = (A.line || {}).width;
                            y ? (w = m * M, T = 0) : x ? (w = [
                                0,
                                m * M / 2
                            ], T = S * ({
                                x: 1,
                                y: -1
                            })[s.posLetter]) : (w = [
                                m * M / 2,
                                0
                            ], T = S * ({
                                x: -1,
                                y: 1
                            })[s.posLetter]), o.plotBoxAndWhiskers(r, {
                                pos: v,
                                val: g
                            }, c, {
                                bPos: d,
                                bdPos: w,
                                bPosPxOffset: T
                            }), o.plotBoxMean(r, {
                                pos: v,
                                val: g
                            }, c, {
                                bPos: d,
                                bdPos: w,
                                bPosPxOffset: T
                            }), !c.box.visible && c.meanline.visible && (k = i.identity);
                            var E = r.selectAll("path.meanline").data(k || []);
                            E.enter().append("path").attr("class", "meanline").style("fill", "none").style("vector-effect", "non-scaling-stroke"), E.exit().remove(), E.each(function(t1) {
                                var e1 = g.c2p(t1.mean, !0), r = l.getPositionOnKdePath(t1, c, e1);
                                n.select(this).attr("d", "h" === c.orientation ? "M" + e1 + "," + r[0] + "V" + r[1] : "M" + r[0] + "," + e1 + "H" + r[1]);
                            }), o.plotPoints(r, {
                                x: f,
                                y: h
                            }, c, s);
                        }
                    });
                };
            },
            {
                "../../components/drawing": 388,
                "../../lib": 503,
                "../box/plot": 682,
                "../scatter/line_points": 940,
                "./helpers": 1091,
                "@plotly/d3": 58
            }
        ],
        1097: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/color"), a = t1("../scatter/style").stylePoints;
                e1.exports = function(t1) {
                    var e1 = n.select(t1).selectAll("g.trace.violins");
                    e1.style("opacity", function(t1) {
                        return t1[0].trace.opacity;
                    }), e1.each(function(e1) {
                        var r = e1[0].trace, o = n.select(this), s = r.box || {}, l = s.line || {}, c = r.meanline || {}, u = c.width;
                        o.selectAll("path.violin").style("stroke-width", r.line.width + "px").call(i.stroke, r.line.color).call(i.fill, r.fillcolor), o.selectAll("path.box").style("stroke-width", l.width + "px").call(i.stroke, l.color).call(i.fill, s.fillcolor);
                        var f = {
                            "stroke-width": u + "px",
                            "stroke-dasharray": 2 * u + "px," + u + "px"
                        };
                        o.selectAll("path.mean").style(f).call(i.stroke, c.color), o.selectAll("path.meanline").style(f).call(i.stroke, c.color), a(o, r, t1);
                    });
                };
            },
            {
                "../../components/color": 366,
                "../scatter/style": 950,
                "@plotly/d3": 58
            }
        ],
        1098: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../components/colorscale/attributes"), i = t1("../isosurface/attributes"), a = t1("../surface/attributes"), o = t1("../../plots/attributes"), s = t1("../../lib/extend").extendFlat, l = t1("../../plot_api/edit_types").overrideAll, c = e1.exports = l(s({
                    x: i.x,
                    y: i.y,
                    z: i.z,
                    value: i.value,
                    isomin: i.isomin,
                    isomax: i.isomax,
                    surface: i.surface,
                    spaceframe: {
                        show: {
                            valType: "boolean",
                            dflt: !1
                        },
                        fill: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: 1
                        }
                    },
                    slices: i.slices,
                    caps: i.caps,
                    text: i.text,
                    hovertext: i.hovertext,
                    xhoverformat: i.xhoverformat,
                    yhoverformat: i.yhoverformat,
                    zhoverformat: i.zhoverformat,
                    valuehoverformat: i.valuehoverformat,
                    hovertemplate: i.hovertemplate
                }, n("", {
                    colorAttr: "`value`",
                    showScaleDflt: !0,
                    editTypeOverride: "calc"
                }), {
                    colorbar: i.colorbar,
                    opacity: i.opacity,
                    opacityscale: a.opacityscale,
                    lightposition: i.lightposition,
                    lighting: i.lighting,
                    flatshading: i.flatshading,
                    contour: i.contour,
                    hoverinfo: s({}, o.hoverinfo),
                    showlegend: s({}, o.showlegend, {
                        dflt: !1
                    })
                }), "calc", "nested");
                c.x.editType = c.y.editType = c.z.editType = c.value.editType = "calc+clearAxisTypes", c.transforms = void 0;
            },
            {
                "../../components/colorscale/attributes": 373,
                "../../lib/extend": 493,
                "../../plot_api/edit_types": 536,
                "../../plots/attributes": 550,
                "../isosurface/attributes": 862,
                "../surface/attributes": 1057
            }
        ],
        1099: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../../stackgl_modules").gl_mesh3d, i = t1("../../lib/gl_format_color").parseColorScale, a = t1("../../lib/str2rgbarray"), o = t1("../../components/colorscale").extractOpts, s = t1("../../plots/gl3d/zip3"), l = t1("../isosurface/convert").findNearestOnAxis, c = t1("../isosurface/convert").generateIsoMeshes;
                function u(t1, e1, r) {
                    this.scene = t1, this.uid = r, this.mesh = e1, this.name = "", this.data = null, this.showContour = !1;
                }
                var f = u.prototype;
                f.handlePick = function(t1) {
                    if (t1.object === this.mesh) {
                        var e1 = t1.data.index, r = this.data._meshX[e1], n = this.data._meshY[e1], i = this.data._meshZ[e1], a = this.data._Ys.length, o = this.data._Zs.length, s = l(r, this.data._Xs).id, c = l(n, this.data._Ys).id, u = l(i, this.data._Zs).id, f = t1.index = u + o * c + o * a * s;
                        t1.traceCoordinate = [
                            this.data._meshX[f],
                            this.data._meshY[f],
                            this.data._meshZ[f],
                            this.data._value[f]
                        ];
                        var h = this.data.hovertext || this.data.text;
                        return Array.isArray(h) && void 0 !== h[f] ? t1.textLabel = h[f] : h && (t1.textLabel = h), !0;
                    }
                }, f.update = function(t1) {
                    var e1 = this.scene, r = e1.fullSceneLayout;
                    function n(t1, e1, r, n) {
                        return e1.map(function(e1) {
                            return t1.d2l(e1, 0, n) * r;
                        });
                    }
                    this.data = c(t1);
                    var l = {
                        positions: s(n(r.xaxis, t1._meshX, e1.dataScale[0], t1.xcalendar), n(r.yaxis, t1._meshY, e1.dataScale[1], t1.ycalendar), n(r.zaxis, t1._meshZ, e1.dataScale[2], t1.zcalendar)),
                        cells: s(t1._meshI, t1._meshJ, t1._meshK),
                        lightPosition: [
                            t1.lightposition.x,
                            t1.lightposition.y,
                            t1.lightposition.z
                        ],
                        ambient: t1.lighting.ambient,
                        diffuse: t1.lighting.diffuse,
                        specular: t1.lighting.specular,
                        roughness: t1.lighting.roughness,
                        fresnel: t1.lighting.fresnel,
                        vertexNormalsEpsilon: t1.lighting.vertexnormalsepsilon,
                        faceNormalsEpsilon: t1.lighting.facenormalsepsilon,
                        opacity: t1.opacity,
                        opacityscale: t1.opacityscale,
                        contourEnable: t1.contour.show,
                        contourColor: a(t1.contour.color).slice(0, 3),
                        contourWidth: t1.contour.width,
                        useFacetNormals: t1.flatshading
                    }, u = o(t1);
                    l.vertexIntensity = t1._meshIntensity, l.vertexIntensityBounds = [
                        u.min,
                        u.max
                    ], l.colormap = i(t1), this.mesh.update(l);
                }, f.dispose = function() {
                    this.scene.glplot.remove(this.mesh), this.mesh.dispose();
                }, e1.exports = function(t1, e1) {
                    var r = t1.glplot.gl, i = n({
                        gl: r
                    }), a = new u(t1, i, e1.uid);
                    return i._trace = a, a.update(e1), t1.glplot.add(i), a;
                };
            },
            {
                "../../../stackgl_modules": 1120,
                "../../components/colorscale": 378,
                "../../lib/gl_format_color": 499,
                "../../lib/str2rgbarray": 528,
                "../../plots/gl3d/zip3": 609,
                "../isosurface/convert": 864
            }
        ],
        1100: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./attributes"), a = t1("../isosurface/defaults").supplyIsoDefaults, o = t1("../surface/defaults").opacityscaleDefaults;
                e1.exports = function(t1, e1, r, s) {
                    function l(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    a(t1, e1, r, s, l), o(t1, e1, s, l);
                };
            },
            {
                "../../lib": 503,
                "../isosurface/defaults": 865,
                "../surface/defaults": 1060,
                "./attributes": 1098
            }
        ],
        1101: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    supplyDefaults: t1("./defaults"),
                    calc: t1("../isosurface/calc"),
                    colorbar: {
                        min: "cmin",
                        max: "cmax"
                    },
                    plot: t1("./convert"),
                    moduleType: "trace",
                    name: "volume",
                    basePlotModule: t1("../../plots/gl3d"),
                    categories: [
                        "gl3d",
                        "showLegend"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/gl3d": 598,
                "../isosurface/calc": 863,
                "./attributes": 1098,
                "./convert": 1099,
                "./defaults": 1100
            }
        ],
        1102: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../bar/attributes"), i = t1("../scatter/attributes").line, a = t1("../../plots/attributes"), o = t1("../../plots/cartesian/axis_format_attributes").axisHoverFormat, s = t1("../../plots/template_attributes").hovertemplateAttrs, l = t1("../../plots/template_attributes").texttemplateAttrs, c = t1("./constants"), u = t1("../../lib/extend").extendFlat, f = t1("../../components/color");
                function h(t1) {
                    return {
                        marker: {
                            color: u({}, n.marker.color, {
                                arrayOk: !1,
                                editType: "style"
                            }),
                            line: {
                                color: u({}, n.marker.line.color, {
                                    arrayOk: !1,
                                    editType: "style"
                                }),
                                width: u({}, n.marker.line.width, {
                                    arrayOk: !1,
                                    editType: "style"
                                }),
                                editType: "style"
                            },
                            editType: "style"
                        },
                        editType: "style"
                    };
                }
                e1.exports = {
                    measure: {
                        valType: "data_array",
                        dflt: [],
                        editType: "calc"
                    },
                    base: {
                        valType: "number",
                        dflt: null,
                        arrayOk: !1,
                        editType: "calc"
                    },
                    x: n.x,
                    x0: n.x0,
                    dx: n.dx,
                    y: n.y,
                    y0: n.y0,
                    dy: n.dy,
                    xperiod: n.xperiod,
                    yperiod: n.yperiod,
                    xperiod0: n.xperiod0,
                    yperiod0: n.yperiod0,
                    xperiodalignment: n.xperiodalignment,
                    yperiodalignment: n.yperiodalignment,
                    xhoverformat: o("x"),
                    yhoverformat: o("y"),
                    hovertext: n.hovertext,
                    hovertemplate: s({}, {
                        keys: c.eventDataKeys
                    }),
                    hoverinfo: u({}, a.hoverinfo, {
                        flags: [
                            "name",
                            "x",
                            "y",
                            "text",
                            "initial",
                            "delta",
                            "final"
                        ]
                    }),
                    textinfo: {
                        valType: "flaglist",
                        flags: [
                            "label",
                            "text",
                            "initial",
                            "delta",
                            "final"
                        ],
                        extras: [
                            "none"
                        ],
                        editType: "plot",
                        arrayOk: !1
                    },
                    texttemplate: l({
                        editType: "plot"
                    }, {
                        keys: c.eventDataKeys.concat([
                            "label"
                        ])
                    }),
                    text: n.text,
                    textposition: n.textposition,
                    insidetextanchor: n.insidetextanchor,
                    textangle: n.textangle,
                    textfont: n.textfont,
                    insidetextfont: n.insidetextfont,
                    outsidetextfont: n.outsidetextfont,
                    constraintext: n.constraintext,
                    cliponaxis: n.cliponaxis,
                    orientation: n.orientation,
                    offset: n.offset,
                    width: n.width,
                    increasing: h(),
                    decreasing: h(),
                    totals: h(),
                    connector: {
                        line: {
                            color: u({}, i.color, {
                                dflt: f.defaultLine
                            }),
                            width: u({}, i.width, {
                                editType: "plot"
                            }),
                            dash: i.dash,
                            editType: "plot"
                        },
                        mode: {
                            valType: "enumerated",
                            values: [
                                "spanning",
                                "between"
                            ],
                            dflt: "between",
                            editType: "plot"
                        },
                        visible: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    offsetgroup: n.offsetgroup,
                    alignmentgroup: n.alignmentgroup
                };
            },
            {
                "../../components/color": 366,
                "../../lib/extend": 493,
                "../../plots/attributes": 550,
                "../../plots/cartesian/axis_format_attributes": 557,
                "../../plots/template_attributes": 633,
                "../bar/attributes": 648,
                "../scatter/attributes": 926,
                "./constants": 1104
            }
        ],
        1103: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes"), i = t1("../../plots/cartesian/align_period"), a = t1("../../lib").mergeArray, o = t1("../scatter/calc_selection"), s = t1("../../constants/numerical").BADNUM;
                function l(t1) {
                    return "a" === t1 || "absolute" === t1;
                }
                function c(t1) {
                    return "t" === t1 || "total" === t1;
                }
                e1.exports = function(t1, e1) {
                    var r, u, f, h, p, d, m = n.getFromId(t1, e1.xaxis || "x"), g = n.getFromId(t1, e1.yaxis || "y");
                    "h" === e1.orientation ? (r = m.makeCalcdata(e1, "x"), f = g.makeCalcdata(e1, "y"), h = i(e1, g, "y", f), p = !!e1.yperiodalignment, d = "y") : (r = g.makeCalcdata(e1, "y"), f = m.makeCalcdata(e1, "x"), h = i(e1, m, "x", f), p = !!e1.xperiodalignment, d = "x"), u = h.vals;
                    for(var v, y = Math.min(u.length, r.length), x = new Array(y), b = 0, _ = !1, w = 0; w < y; w++){
                        var T = r[w] || 0, k = !1;
                        (r[w] !== s || c(e1.measure[w]) || l(e1.measure[w])) && w + 1 < y && (r[w + 1] !== s || c(e1.measure[w + 1]) || l(e1.measure[w + 1])) && (k = !0);
                        var A = x[w] = {
                            i: w,
                            p: u[w],
                            s: T,
                            rawS: T,
                            cNext: k
                        };
                        l(e1.measure[w]) ? (b = A.s, A.isSum = !0, A.dir = "totals", A.s = b) : c(e1.measure[w]) ? (A.isSum = !0, A.dir = "totals", A.s = b) : (A.isSum = !1, A.dir = A.rawS < 0 ? "decreasing" : "increasing", v = A.s, A.s = b + v, b += v), "totals" === A.dir && (_ = !0), p && (x[w].orig_p = f[w], x[w][d + "End"] = h.ends[w], x[w][d + "Start"] = h.starts[w]), e1.ids && (A.id = String(e1.ids[w])), A.v = (e1.base || 0) + b;
                    }
                    return x.length && (x[0].hasTotals = _), a(e1.text, x, "tx"), a(e1.hovertext, x, "htx"), o(x, e1), x;
                };
            },
            {
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../../plots/cartesian/align_period": 551,
                "../../plots/cartesian/axes": 554,
                "../scatter/calc_selection": 928
            }
        ],
        1104: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    eventDataKeys: [
                        "initial",
                        "delta",
                        "final"
                    ]
                };
            },
            {}
        ],
        1105: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../bar/cross_trace_calc").setGroupPositions;
                e1.exports = function(t1, e1) {
                    var r, i, a = t1._fullLayout, o = t1._fullData, s = t1.calcdata, l = e1.xaxis, c = e1.yaxis, u = [], f = [], h = [];
                    for(i = 0; i < o.length; i++){
                        var p = o[i];
                        !0 === p.visible && p.xaxis === l._id && p.yaxis === c._id && "waterfall" === p.type && (r = s[i], "h" === p.orientation ? h.push(r) : f.push(r), u.push(r));
                    }
                    var d = {
                        mode: a.waterfallmode,
                        norm: a.waterfallnorm,
                        gap: a.waterfallgap,
                        groupgap: a.waterfallgroupgap
                    };
                    for(n(t1, l, c, f, d), n(t1, c, l, h, d), i = 0; i < u.length; i++){
                        r = u[i];
                        for(var m = 0; m < r.length; m++){
                            var g = r[m];
                            !1 === g.isSum && (g.s0 += 0 === m ? 0 : r[m - 1].s), m + 1 < r.length && (r[m].nextP0 = r[m + 1].p0, r[m].nextS0 = r[m + 1].s0);
                        }
                    }
                };
            },
            {
                "../bar/cross_trace_calc": 651
            }
        ],
        1106: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("../bar/defaults").handleGroupingDefaults, a = t1("../bar/defaults").handleText, o = t1("../scatter/xy_defaults"), s = t1("../scatter/period_defaults"), l = t1("./attributes"), c = t1("../../components/color"), u = t1("../../constants/delta.js"), f = u.INCREASING.COLOR, h = u.DECREASING.COLOR;
                function p(t1, e1, r) {
                    t1(e1 + ".marker.color", r), t1(e1 + ".marker.line.color", c.defaultLine), t1(e1 + ".marker.line.width");
                }
                e1.exports = {
                    supplyDefaults: function(t1, e1, r, i) {
                        function c(r, i) {
                            return n.coerce(t1, e1, l, r, i);
                        }
                        if (o(t1, e1, i, c)) {
                            s(t1, e1, i, c), c("xhoverformat"), c("yhoverformat"), c("measure"), c("orientation", e1.x && !e1.y ? "h" : "v"), c("base"), c("offset"), c("width"), c("text"), c("hovertext"), c("hovertemplate");
                            var u = c("textposition");
                            if (a(t1, e1, i, c, u, {
                                moduleHasSelected: !1,
                                moduleHasUnselected: !1,
                                moduleHasConstrain: !0,
                                moduleHasCliponaxis: !0,
                                moduleHasTextangle: !0,
                                moduleHasInsideanchor: !0
                            }), "none" !== e1.textposition && (c("texttemplate"), e1.texttemplate || c("textinfo")), p(c, "increasing", f), p(c, "decreasing", h), p(c, "totals", "#4499FF"), c("connector.visible")) c("connector.mode"), c("connector.line.width") && (c("connector.line.color"), c("connector.line.dash"));
                        } else e1.visible = !1;
                    },
                    crossTraceDefaults: function(t1, e1) {
                        var r, a;
                        function o(t1) {
                            return n.coerce(a._input, a, l, t1);
                        }
                        if ("group" === e1.waterfallmode) for(var s = 0; s < t1.length; s++)r = (a = t1[s])._input, i(r, a, e1, o);
                    }
                };
            },
            {
                "../../components/color": 366,
                "../../constants/delta.js": 473,
                "../../lib": 503,
                "../bar/defaults": 652,
                "../scatter/period_defaults": 946,
                "../scatter/xy_defaults": 953,
                "./attributes": 1102
            }
        ],
        1107: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = function(t1, e1) {
                    return t1.x = "xVal" in e1 ? e1.xVal : e1.x, t1.y = "yVal" in e1 ? e1.yVal : e1.y, "initial" in e1 && (t1.initial = e1.initial), "delta" in e1 && (t1.delta = e1.delta), "final" in e1 && (t1.final = e1.final), e1.xa && (t1.xaxis = e1.xa), e1.ya && (t1.yaxis = e1.ya), t1;
                };
            },
            {}
        ],
        1108: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../plots/cartesian/axes").hoverLabelText, i = t1("../../components/color").opacity, a = t1("../bar/hover").hoverOnBars, o = t1("../../constants/delta.js"), s = o.INCREASING.SYMBOL, l = o.DECREASING.SYMBOL;
                e1.exports = function(t1, e1, r, o, c) {
                    var u = a(t1, e1, r, o, c);
                    if (u) {
                        var f = u.cd, h = f[0].trace, p = "h" === h.orientation, d = p ? "x" : "y", m = p ? t1.xa : t1.ya, g = f[u.index], v = g.isSum ? g.b + g.s : g.rawS;
                        if (!g.isSum) {
                            u.initial = g.b + g.s - v, u.delta = v, u.final = u.initial + u.delta;
                            var y = k(Math.abs(u.delta));
                            u.deltaLabel = v < 0 ? "(" + y + ")" : y, u.finalLabel = k(u.final), u.initialLabel = k(u.initial);
                        }
                        var x = g.hi || h.hoverinfo, b = [];
                        if (x && "none" !== x && "skip" !== x) {
                            var _ = "all" === x, w = x.split("+"), T = function(t1) {
                                return _ || -1 !== w.indexOf(t1);
                            };
                            g.isSum || (!T("final") || T(p ? "x" : "y") || b.push(u.finalLabel), T("delta") && (v < 0 ? b.push(u.deltaLabel + " " + l) : b.push(u.deltaLabel + " " + s)), T("initial") && b.push("Initial: " + u.initialLabel));
                        }
                        return b.length && (u.extraText = b.join("<br>")), u.color = function(t1, e1) {
                            var r = t1[e1.dir].marker, n = r.color, a = r.line.color, o = r.line.width;
                            if (i(n)) return n;
                            if (i(a) && o) return a;
                        }(h, g), [
                            u
                        ];
                    }
                    function k(t1) {
                        return n(m, t1, h[d + "hoverformat"]);
                    }
                };
            },
            {
                "../../components/color": 366,
                "../../constants/delta.js": 473,
                "../../plots/cartesian/axes": 554,
                "../bar/hover": 655
            }
        ],
        1109: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    attributes: t1("./attributes"),
                    layoutAttributes: t1("./layout_attributes"),
                    supplyDefaults: t1("./defaults").supplyDefaults,
                    crossTraceDefaults: t1("./defaults").crossTraceDefaults,
                    supplyLayoutDefaults: t1("./layout_defaults"),
                    calc: t1("./calc"),
                    crossTraceCalc: t1("./cross_trace_calc"),
                    plot: t1("./plot"),
                    style: t1("./style").style,
                    hoverPoints: t1("./hover"),
                    eventData: t1("./event_data"),
                    selectPoints: t1("../bar/select"),
                    moduleType: "trace",
                    name: "waterfall",
                    basePlotModule: t1("../../plots/cartesian"),
                    categories: [
                        "bar-like",
                        "cartesian",
                        "svg",
                        "oriented",
                        "showLegend",
                        "zoomScale"
                    ],
                    meta: {}
                };
            },
            {
                "../../plots/cartesian": 568,
                "../bar/select": 660,
                "./attributes": 1102,
                "./calc": 1103,
                "./cross_trace_calc": 1105,
                "./defaults": 1106,
                "./event_data": 1107,
                "./hover": 1108,
                "./layout_attributes": 1110,
                "./layout_defaults": 1111,
                "./plot": 1112,
                "./style": 1113
            }
        ],
        1110: [
            function(t1, e1, r) {
                "use strict";
                e1.exports = {
                    waterfallmode: {
                        valType: "enumerated",
                        values: [
                            "group",
                            "overlay"
                        ],
                        dflt: "group",
                        editType: "calc"
                    },
                    waterfallgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        editType: "calc"
                    },
                    waterfallgroupgap: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 0,
                        editType: "calc"
                    }
                };
            },
            {}
        ],
        1111: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../../lib"), i = t1("./layout_attributes");
                e1.exports = function(t1, e1, r) {
                    var a = !1;
                    function o(r, a) {
                        return n.coerce(t1, e1, i, r, a);
                    }
                    for(var s = 0; s < r.length; s++){
                        var l = r[s];
                        if (l.visible && "waterfall" === l.type) {
                            a = !0;
                            break;
                        }
                    }
                    a && (o("waterfallmode"), o("waterfallgap", .2), o("waterfallgroupgap"));
                };
            },
            {
                "../../lib": 503,
                "./layout_attributes": 1110
            }
        ],
        1112: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../lib"), a = t1("../../components/drawing"), o = t1("../../constants/numerical").BADNUM, s = t1("../bar/plot"), l = t1("../bar/uniform_text").clearMinTextSize;
                e1.exports = function(t1, e1, r, c) {
                    var u = t1._fullLayout;
                    l("waterfall", u), s.plot(t1, e1, r, c, {
                        mode: u.waterfallmode,
                        norm: u.waterfallmode,
                        gap: u.waterfallgap,
                        groupgap: u.waterfallgroupgap
                    }), function(t1, e1, r, s) {
                        var l = e1.xaxis, c = e1.yaxis;
                        i.makeTraceGroups(s, r, "trace bars").each(function(r) {
                            var s = n.select(this), u = r[0].trace, f = i.ensureSingle(s, "g", "lines");
                            if (u.connector && u.connector.visible) {
                                var h = "h" === u.orientation, p = u.connector.mode, d = f.selectAll("g.line").data(i.identity);
                                d.enter().append("g").classed("line", !0), d.exit().remove();
                                var m = d.size();
                                d.each(function(r, s) {
                                    if (s === m - 1 || r.cNext) {
                                        var u = function(t1, e1, r, n) {
                                            var i = [], a = [], o = n ? e1 : r, s = n ? r : e1;
                                            return i[0] = o.c2p(t1.s0, !0), a[0] = s.c2p(t1.p0, !0), i[1] = o.c2p(t1.s1, !0), a[1] = s.c2p(t1.p1, !0), i[2] = o.c2p(t1.nextS0, !0), a[2] = s.c2p(t1.nextP0, !0), n ? [
                                                i,
                                                a
                                            ] : [
                                                a,
                                                i
                                            ];
                                        }(r, l, c, h), f = u[0], d = u[1], g = "";
                                        f[0] !== o && d[0] !== o && f[1] !== o && d[1] !== o && ("spanning" === p && !r.isSum && s > 0 && (g += h ? "M" + f[0] + "," + d[1] + "V" + d[0] : "M" + f[1] + "," + d[0] + "H" + f[0]), "between" !== p && (r.isSum || s < m - 1) && (g += h ? "M" + f[1] + "," + d[0] + "V" + d[1] : "M" + f[0] + "," + d[1] + "H" + f[1]), f[2] !== o && d[2] !== o && (g += h ? "M" + f[1] + "," + d[1] + "V" + d[2] : "M" + f[1] + "," + d[1] + "H" + f[2])), "" === g && (g = "M0,0Z"), i.ensureSingle(n.select(this), "path").attr("d", g).call(a.setClipUrl, e1.layerClipId, t1);
                                    }
                                });
                            } else f.remove();
                        });
                    }(t1, e1, r, c);
                };
            },
            {
                "../../components/drawing": 388,
                "../../constants/numerical": 479,
                "../../lib": 503,
                "../bar/plot": 659,
                "../bar/uniform_text": 664,
                "@plotly/d3": 58
            }
        ],
        1113: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("@plotly/d3"), i = t1("../../components/drawing"), a = t1("../../components/color"), o = t1("../../constants/interactions").DESELECTDIM, s = t1("../bar/style"), l = t1("../bar/uniform_text").resizeText, c = s.styleTextPoints;
                e1.exports = {
                    style: function(t1, e1, r) {
                        var s = r || n.select(t1).selectAll("g.waterfalllayer").selectAll("g.trace");
                        l(t1, s, "waterfall"), s.style("opacity", function(t1) {
                            return t1[0].trace.opacity;
                        }), s.each(function(e1) {
                            var r = n.select(this), s = e1[0].trace;
                            r.selectAll(".point > path").each(function(t1) {
                                if (!t1.isBlank) {
                                    var e1 = s[t1.dir].marker;
                                    n.select(this).call(a.fill, e1.color).call(a.stroke, e1.line.color).call(i.dashLine, e1.line.dash, e1.line.width).style("opacity", s.selectedpoints && !t1.selected ? o : 1);
                                }
                            }), c(r, s, t1), r.selectAll(".lines").each(function() {
                                var t1 = s.connector.line;
                                i.lineGroupStyle(n.select(this).selectAll("path"), t1.width, t1.color, t1.dash);
                            });
                        });
                    }
                };
            },
            {
                "../../components/color": 366,
                "../../components/drawing": 388,
                "../../constants/interactions": 478,
                "../bar/style": 662,
                "../bar/uniform_text": 664,
                "@plotly/d3": 58
            }
        ],
        1114: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../plots/cartesian/axes"), i = t1("../lib"), a = t1("../plot_api/plot_schema"), o = t1("./helpers").pointsAccessorFunction, s = t1("../constants/numerical").BADNUM;
                r.moduleType = "transform", r.name = "aggregate";
                var l = r.attributes = {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    groups: {
                        valType: "string",
                        strict: !0,
                        noBlank: !0,
                        arrayOk: !0,
                        dflt: "x",
                        editType: "calc"
                    },
                    aggregations: {
                        _isLinkedToArray: "aggregation",
                        target: {
                            valType: "string",
                            editType: "calc"
                        },
                        func: {
                            valType: "enumerated",
                            values: [
                                "count",
                                "sum",
                                "avg",
                                "median",
                                "mode",
                                "rms",
                                "stddev",
                                "min",
                                "max",
                                "first",
                                "last",
                                "change",
                                "range"
                            ],
                            dflt: "first",
                            editType: "calc"
                        },
                        funcmode: {
                            valType: "enumerated",
                            values: [
                                "sample",
                                "population"
                            ],
                            dflt: "sample",
                            editType: "calc"
                        },
                        enabled: {
                            valType: "boolean",
                            dflt: !0,
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    editType: "calc"
                }, c = l.aggregations;
                function u(t1, e1, r, a) {
                    if (a.enabled) {
                        for(var o = a.target, l = i.nestedProperty(e1, o), c = l.get(), u = function(t1, e1) {
                            var r = t1.func, n = e1.d2c, a = e1.c2d;
                            switch(r){
                                case "count":
                                    return f;
                                case "first":
                                    return h;
                                case "last":
                                    return p;
                                case "sum":
                                    return function(t1, e1) {
                                        for(var r = 0, i = 0; i < e1.length; i++){
                                            var o = n(t1[e1[i]]);
                                            o !== s && (r += o);
                                        }
                                        return a(r);
                                    };
                                case "avg":
                                    return function(t1, e1) {
                                        for(var r = 0, i = 0, o = 0; o < e1.length; o++){
                                            var l = n(t1[e1[o]]);
                                            l !== s && (r += l, i++);
                                        }
                                        return i ? a(r / i) : s;
                                    };
                                case "min":
                                    return function(t1, e1) {
                                        for(var r = 1 / 0, i = 0; i < e1.length; i++){
                                            var o = n(t1[e1[i]]);
                                            o !== s && (r = Math.min(r, o));
                                        }
                                        return r === 1 / 0 ? s : a(r);
                                    };
                                case "max":
                                    return function(t1, e1) {
                                        for(var r = -1 / 0, i = 0; i < e1.length; i++){
                                            var o = n(t1[e1[i]]);
                                            o !== s && (r = Math.max(r, o));
                                        }
                                        return r === -1 / 0 ? s : a(r);
                                    };
                                case "range":
                                    return function(t1, e1) {
                                        for(var r = 1 / 0, i = -1 / 0, o = 0; o < e1.length; o++){
                                            var l = n(t1[e1[o]]);
                                            l !== s && (r = Math.min(r, l), i = Math.max(i, l));
                                        }
                                        return i === -1 / 0 || r === 1 / 0 ? s : a(i - r);
                                    };
                                case "change":
                                    return function(t1, e1) {
                                        var r = n(t1[e1[0]]), i = n(t1[e1[e1.length - 1]]);
                                        return r === s || i === s ? s : a(i - r);
                                    };
                                case "median":
                                    return function(t1, e1) {
                                        for(var r = [], o = 0; o < e1.length; o++){
                                            var l = n(t1[e1[o]]);
                                            l !== s && r.push(l);
                                        }
                                        if (!r.length) return s;
                                        r.sort(i.sorterAsc);
                                        var c = (r.length - 1) / 2;
                                        return a((r[Math.floor(c)] + r[Math.ceil(c)]) / 2);
                                    };
                                case "mode":
                                    return function(t1, e1) {
                                        for(var r = {}, i = 0, o = s, l = 0; l < e1.length; l++){
                                            var c = n(t1[e1[l]]);
                                            if (c !== s) {
                                                var u = r[c] = (r[c] || 0) + 1;
                                                u > i && (i = u, o = c);
                                            }
                                        }
                                        return i ? a(o) : s;
                                    };
                                case "rms":
                                    return function(t1, e1) {
                                        for(var r = 0, i = 0, o = 0; o < e1.length; o++){
                                            var l = n(t1[e1[o]]);
                                            l !== s && (r += l * l, i++);
                                        }
                                        return i ? a(Math.sqrt(r / i)) : s;
                                    };
                                case "stddev":
                                    return function(e1, r) {
                                        var i, a = 0, o = 0, l = 1, c = s;
                                        for(i = 0; i < r.length && c === s; i++)c = n(e1[r[i]]);
                                        if (c === s) return s;
                                        for(; i < r.length; i++){
                                            var u = n(e1[r[i]]);
                                            if (u !== s) {
                                                var f = u - c;
                                                a += f, o += f * f, l++;
                                            }
                                        }
                                        var h = "sample" === t1.funcmode ? l - 1 : l;
                                        return h ? Math.sqrt((o - a * a / l) / h) : 0;
                                    };
                            }
                        }(a, n.getDataConversions(t1, e1, o, c)), d = new Array(r.length), m = 0; m < r.length; m++)d[m] = u(c, r[m]);
                        l.set(d), "count" === a.func && i.pushUnique(e1._arrayAttrs, o);
                    }
                }
                function f(t1, e1) {
                    return e1.length;
                }
                function h(t1, e1) {
                    return t1[e1[0]];
                }
                function p(t1, e1) {
                    return t1[e1[e1.length - 1]];
                }
                r.supplyDefaults = function(t1, e1) {
                    var r, n = {};
                    function o(e1, r) {
                        return i.coerce(t1, n, l, e1, r);
                    }
                    if (!o("enabled")) return n;
                    var s = a.findArrayAttributes(e1), u = {};
                    for(r = 0; r < s.length; r++)u[s[r]] = 1;
                    var f = o("groups");
                    if (!Array.isArray(f)) {
                        if (!u[f]) return n.enabled = !1, n;
                        u[f] = 0;
                    }
                    var h, p = t1.aggregations || [], d = n.aggregations = new Array(p.length);
                    function m(t1, e1) {
                        return i.coerce(p[r], h, c, t1, e1);
                    }
                    for(r = 0; r < p.length; r++){
                        h = {
                            _index: r
                        };
                        var g = m("target"), v = m("func");
                        m("enabled") && g && (u[g] || "count" === v && void 0 === u[g]) ? ("stddev" === v && m("funcmode"), u[g] = 0, d[r] = h) : d[r] = {
                            enabled: !1,
                            _index: r
                        };
                    }
                    for(r = 0; r < s.length; r++)u[s[r]] && d.push({
                        target: s[r],
                        func: c.func.dflt,
                        enabled: !0,
                        _index: -1
                    });
                    return n;
                }, r.calcTransform = function(t1, e1, r) {
                    if (r.enabled) {
                        var n = r.groups, a = i.getTargetArray(e1, {
                            target: n
                        });
                        if (a) {
                            var s, l, c, f, h = {}, p = {}, d = [], m = o(e1.transforms, r), g = a.length;
                            for(e1._length && (g = Math.min(g, e1._length)), s = 0; s < g; s++)void 0 === (c = h[l = a[s]]) ? (h[l] = d.length, f = [
                                s
                            ], d.push(f), p[h[l]] = m(s)) : (d[c].push(s), p[h[l]] = (p[h[l]] || []).concat(m(s)));
                            r._indexToPoints = p;
                            var v = r.aggregations;
                            for(s = 0; s < v.length; s++)u(t1, e1, d, v[s]);
                            "string" == typeof n && u(t1, e1, d, {
                                target: n,
                                func: "first",
                                enabled: !0
                            }), e1._length = d.length;
                        }
                    }
                };
            },
            {
                "../constants/numerical": 479,
                "../lib": 503,
                "../plot_api/plot_schema": 542,
                "../plots/cartesian/axes": 554,
                "./helpers": 1117
            }
        ],
        1115: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = t1("../registry"), a = t1("../plots/cartesian/axes"), o = t1("./helpers").pointsAccessorFunction, s = t1("../constants/filter_ops"), l = s.COMPARISON_OPS, c = s.INTERVAL_OPS, u = s.SET_OPS;
                r.moduleType = "transform", r.name = "filter", r.attributes = {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    target: {
                        valType: "string",
                        strict: !0,
                        noBlank: !0,
                        arrayOk: !0,
                        dflt: "x",
                        editType: "calc"
                    },
                    operation: {
                        valType: "enumerated",
                        values: [].concat(l).concat(c).concat(u),
                        dflt: "=",
                        editType: "calc"
                    },
                    value: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc"
                    },
                    preservegaps: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    editType: "calc"
                }, r.supplyDefaults = function(t1) {
                    var e1 = {};
                    function a(i, a) {
                        return n.coerce(t1, e1, r.attributes, i, a);
                    }
                    if (a("enabled")) {
                        var o = a("target");
                        if (n.isArrayOrTypedArray(o) && 0 === o.length) return e1.enabled = !1, e1;
                        a("preservegaps"), a("operation"), a("value");
                        var s = i.getComponentMethod("calendars", "handleDefaults");
                        s(t1, e1, "valuecalendar", null), s(t1, e1, "targetcalendar", null);
                    }
                    return e1;
                }, r.calcTransform = function(t1, e1, r) {
                    if (r.enabled) {
                        var i = n.getTargetArray(e1, r);
                        if (i) {
                            var s = r.target, f = i.length;
                            e1._length && (f = Math.min(f, e1._length));
                            var h = r.targetcalendar, p = e1._arrayAttrs, d = r.preservegaps;
                            if ("string" == typeof s) {
                                var m = n.nestedProperty(e1, s + "calendar").get();
                                m && (h = m);
                            }
                            var g, v, y = function(t1, e1, r) {
                                var n = t1.operation, i = t1.value, a = Array.isArray(i);
                                function o(t1) {
                                    return -1 !== t1.indexOf(n);
                                }
                                var s, f = function(r) {
                                    return e1(r, 0, t1.valuecalendar);
                                }, h = function(t1) {
                                    return e1(t1, 0, r);
                                };
                                o(l) ? s = f(a ? i[0] : i) : o(c) ? s = a ? [
                                    f(i[0]),
                                    f(i[1])
                                ] : [
                                    f(i),
                                    f(i)
                                ] : o(u) && (s = a ? i.map(f) : [
                                    f(i)
                                ]);
                                switch(n){
                                    case "=":
                                        return function(t1) {
                                            return h(t1) === s;
                                        };
                                    case "!=":
                                        return function(t1) {
                                            return h(t1) !== s;
                                        };
                                    case "<":
                                        return function(t1) {
                                            return h(t1) < s;
                                        };
                                    case "<=":
                                        return function(t1) {
                                            return h(t1) <= s;
                                        };
                                    case ">":
                                        return function(t1) {
                                            return h(t1) > s;
                                        };
                                    case ">=":
                                        return function(t1) {
                                            return h(t1) >= s;
                                        };
                                    case "[]":
                                        return function(t1) {
                                            var e1 = h(t1);
                                            return e1 >= s[0] && e1 <= s[1];
                                        };
                                    case "()":
                                        return function(t1) {
                                            var e1 = h(t1);
                                            return e1 > s[0] && e1 < s[1];
                                        };
                                    case "[)":
                                        return function(t1) {
                                            var e1 = h(t1);
                                            return e1 >= s[0] && e1 < s[1];
                                        };
                                    case "(]":
                                        return function(t1) {
                                            var e1 = h(t1);
                                            return e1 > s[0] && e1 <= s[1];
                                        };
                                    case "][":
                                        return function(t1) {
                                            var e1 = h(t1);
                                            return e1 <= s[0] || e1 >= s[1];
                                        };
                                    case ")(":
                                        return function(t1) {
                                            var e1 = h(t1);
                                            return e1 < s[0] || e1 > s[1];
                                        };
                                    case "](":
                                        return function(t1) {
                                            var e1 = h(t1);
                                            return e1 <= s[0] || e1 > s[1];
                                        };
                                    case ")[":
                                        return function(t1) {
                                            var e1 = h(t1);
                                            return e1 < s[0] || e1 >= s[1];
                                        };
                                    case "{}":
                                        return function(t1) {
                                            return -1 !== s.indexOf(h(t1));
                                        };
                                    case "}{":
                                        return function(t1) {
                                            return -1 === s.indexOf(h(t1));
                                        };
                                }
                            }(r, a.getDataToCoordFunc(t1, e1, s, i), h), x = {}, b = {}, _ = 0;
                            d ? (g = function(t1) {
                                x[t1.astr] = n.extendDeep([], t1.get()), t1.set(new Array(f));
                            }, v = function(t1, e1) {
                                var r = x[t1.astr][e1];
                                t1.get()[e1] = r;
                            }) : (g = function(t1) {
                                x[t1.astr] = n.extendDeep([], t1.get()), t1.set([]);
                            }, v = function(t1, e1) {
                                var r = x[t1.astr][e1];
                                t1.get().push(r);
                            }), k(g);
                            for(var w = o(e1.transforms, r), T = 0; T < f; T++)y(i[T]) ? (k(v, T), b[_++] = w(T)) : d && _++;
                            r._indexToPoints = b, e1._length = _;
                        }
                    }
                    function k(t1, r) {
                        for(var i = 0; i < p.length; i++)t1(n.nestedProperty(e1, p[i]), r);
                    }
                };
            },
            {
                "../constants/filter_ops": 475,
                "../lib": 503,
                "../plots/cartesian/axes": 554,
                "../registry": 638,
                "./helpers": 1117
            }
        ],
        1116: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = t1("../plot_api/plot_schema"), a = t1("../plots/plots"), o = t1("./helpers").pointsAccessorFunction;
                function s(t1, e1) {
                    var r, s, l, c, u, f, h, p, d, m, g = e1.transform, v = e1.transformIndex, y = t1.transforms[v].groups, x = o(t1.transforms, g);
                    if (!n.isArrayOrTypedArray(y) || 0 === y.length) return [
                        t1
                    ];
                    var b = n.filterUnique(y), _ = new Array(b.length), w = y.length, T = i.findArrayAttributes(t1), k = g.styles || [], A = {};
                    for(r = 0; r < k.length; r++)A[k[r].target] = k[r].value;
                    g.styles && (m = n.keyedContainer(g, "styles", "target", "value.name"));
                    var M = {}, S = {};
                    for(r = 0; r < b.length; r++){
                        M[f = b[r]] = r, S[f] = 0, (h = _[r] = n.extendDeepNoArrays({}, t1))._group = f, h.transforms[v]._indexToPoints = {};
                        var E = null;
                        for(m && (E = m.get(f)), h.name = E || "" === E ? E : n.templateString(g.nameformat, {
                            trace: t1.name,
                            group: f
                        }), p = h.transforms, h.transforms = [], s = 0; s < p.length; s++)h.transforms[s] = n.extendDeepNoArrays({}, p[s]);
                        for(s = 0; s < T.length; s++)n.nestedProperty(h, T[s]).set([]);
                    }
                    for(l = 0; l < T.length; l++){
                        for(c = T[l], s = 0, d = []; s < b.length; s++)d[s] = n.nestedProperty(_[s], c).get();
                        for(u = n.nestedProperty(t1, c).get(), s = 0; s < w; s++)d[M[y[s]]].push(u[s]);
                    }
                    for(s = 0; s < w; s++)(h = _[M[y[s]]]).transforms[v]._indexToPoints[S[y[s]]] = x(s), S[y[s]]++;
                    for(r = 0; r < b.length; r++)f = b[r], h = _[r], a.clearExpandedTraceDefaultColors(h), h = n.extendDeepNoArrays(h, A[f] || {});
                    return _;
                }
                r.moduleType = "transform", r.name = "groupby", r.attributes = {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    groups: {
                        valType: "data_array",
                        dflt: [],
                        editType: "calc"
                    },
                    nameformat: {
                        valType: "string",
                        editType: "calc"
                    },
                    styles: {
                        _isLinkedToArray: "style",
                        target: {
                            valType: "string",
                            editType: "calc"
                        },
                        value: {
                            valType: "any",
                            dflt: {},
                            editType: "calc",
                            _compareAsJSON: !0
                        },
                        editType: "calc"
                    },
                    editType: "calc"
                }, r.supplyDefaults = function(t1, e1, i) {
                    var a, o = {};
                    function s(e1, i) {
                        return n.coerce(t1, o, r.attributes, e1, i);
                    }
                    if (!s("enabled")) return o;
                    s("groups"), s("nameformat", i._dataLength > 1 ? "%{group} (%{trace})" : "%{group}");
                    var l = t1.styles, c = o.styles = [];
                    if (l) for(a = 0; a < l.length; a++){
                        var u = c[a] = {};
                        n.coerce(l[a], c[a], r.attributes.styles, "target");
                        var f = n.coerce(l[a], c[a], r.attributes.styles, "value");
                        n.isPlainObject(f) ? u.value = n.extendDeep({}, f) : f && delete u.value;
                    }
                    return o;
                }, r.transform = function(t1, e1) {
                    var r, n, i, a = [];
                    for(n = 0; n < t1.length; n++)for(r = s(t1[n], e1), i = 0; i < r.length; i++)a.push(r[i]);
                    return a;
                };
            },
            {
                "../lib": 503,
                "../plot_api/plot_schema": 542,
                "../plots/plots": 619,
                "./helpers": 1117
            }
        ],
        1117: [
            function(t1, e1, r) {
                "use strict";
                r.pointsAccessorFunction = function(t1, e1) {
                    for(var r, n, i = 0; i < t1.length && (r = t1[i]) !== e1; i++)r._indexToPoints && !1 !== r.enabled && (n = r._indexToPoints);
                    return n ? function(t1) {
                        return n[t1];
                    } : function(t1) {
                        return [
                            t1
                        ];
                    };
                };
            },
            {}
        ],
        1118: [
            function(t1, e1, r) {
                "use strict";
                var n = t1("../lib"), i = t1("../plots/cartesian/axes"), a = t1("./helpers").pointsAccessorFunction, o = t1("../constants/numerical").BADNUM;
                r.moduleType = "transform", r.name = "sort", r.attributes = {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    target: {
                        valType: "string",
                        strict: !0,
                        noBlank: !0,
                        arrayOk: !0,
                        dflt: "x",
                        editType: "calc"
                    },
                    order: {
                        valType: "enumerated",
                        values: [
                            "ascending",
                            "descending"
                        ],
                        dflt: "ascending",
                        editType: "calc"
                    },
                    editType: "calc"
                }, r.supplyDefaults = function(t1) {
                    var e1 = {};
                    function i(i, a) {
                        return n.coerce(t1, e1, r.attributes, i, a);
                    }
                    return i("enabled") && (i("target"), i("order")), e1;
                }, r.calcTransform = function(t1, e1, r) {
                    if (r.enabled) {
                        var s = n.getTargetArray(e1, r);
                        if (s) {
                            var l = r.target, c = s.length;
                            e1._length && (c = Math.min(c, e1._length));
                            var u, f, h = e1._arrayAttrs, p = function(t1, e1, r, n) {
                                var i, a = new Array(n), s = new Array(n);
                                for(i = 0; i < n; i++)a[i] = {
                                    v: e1[i],
                                    i: i
                                };
                                for(a.sort(function(t1, e1) {
                                    switch(t1.order){
                                        case "ascending":
                                            return function(t1, r) {
                                                var n = e1(t1.v), i = e1(r.v);
                                                return n === o ? 1 : i === o ? -1 : n - i;
                                            };
                                        case "descending":
                                            return function(t1, r) {
                                                var n = e1(t1.v), i = e1(r.v);
                                                return n === o ? 1 : i === o ? -1 : i - n;
                                            };
                                    }
                                }(t1, r)), i = 0; i < n; i++)s[i] = a[i].i;
                                return s;
                            }(r, s, i.getDataToCoordFunc(t1, e1, l, s), c), d = a(e1.transforms, r), m = {};
                            for(u = 0; u < h.length; u++){
                                var g = n.nestedProperty(e1, h[u]), v = g.get(), y = new Array(c);
                                for(f = 0; f < c; f++)y[f] = v[p[f]];
                                g.set(y);
                            }
                            for(f = 0; f < c; f++)m[f] = d(p[f]);
                            r._indexToPoints = m, e1._length = c;
                        }
                    }
                };
            },
            {
                "../constants/numerical": 479,
                "../lib": 503,
                "../plots/cartesian/axes": 554,
                "./helpers": 1117
            }
        ],
        1119: [
            function(t1, e1, r) {
                "use strict";
                r.version = "2.8.0";
            },
            {}
        ],
        1120: [
            function(t1, e1, r) {
                (function(n) {
                    (function() {
                        !function(t1) {
                            "object" == typeof r && void 0 !== e1 ? e1.exports = t1() : ("undefined" != typeof window ? window : void 0 !== n ? n : "undefined" != typeof self ? self : this).stackgl = t1();
                        }(function() {
                            return (function e1(r, n, i) {
                                function a(s, l) {
                                    if (!n[s]) {
                                        if (!r[s]) {
                                            var c = "function" == typeof t1 && t1;
                                            if (!l && c) return c(s, !0);
                                            if (o) return o(s, !0);
                                            var u = new Error("Cannot find module '" + s + "'");
                                            throw u.code = "MODULE_NOT_FOUND", u;
                                        }
                                        var f = n[s] = {
                                            exports: {}
                                        };
                                        r[s][0].call(f.exports, function(t1) {
                                            return a(r[s][1][t1] || t1);
                                        }, f, f.exports, e1, r, n, i);
                                    }
                                    return n[s].exports;
                                }
                                for(var o = "function" == typeof t1 && t1, s = 0; s < i.length; s++)a(i[s]);
                                return a;
                            })({
                                1: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        r.byteLength = function(t1) {
                                            var e1 = c(t1), r = e1[0], n = e1[1];
                                            return 3 * (r + n) / 4 - n;
                                        }, r.toByteArray = function(t1) {
                                            var e1, r, n = c(t1), o = n[0], s = n[1], l = new a(function(t1, e1, r) {
                                                return 3 * (e1 + r) / 4 - r;
                                            }(0, o, s)), u = 0, f = s > 0 ? o - 4 : o;
                                            for(r = 0; r < f; r += 4)e1 = i[t1.charCodeAt(r)] << 18 | i[t1.charCodeAt(r + 1)] << 12 | i[t1.charCodeAt(r + 2)] << 6 | i[t1.charCodeAt(r + 3)], l[u++] = e1 >> 16 & 255, l[u++] = e1 >> 8 & 255, l[u++] = 255 & e1;
                                            2 === s && (e1 = i[t1.charCodeAt(r)] << 2 | i[t1.charCodeAt(r + 1)] >> 4, l[u++] = 255 & e1);
                                            1 === s && (e1 = i[t1.charCodeAt(r)] << 10 | i[t1.charCodeAt(r + 1)] << 4 | i[t1.charCodeAt(r + 2)] >> 2, l[u++] = e1 >> 8 & 255, l[u++] = 255 & e1);
                                            return l;
                                        }, r.fromByteArray = function(t1) {
                                            for(var e1, r = t1.length, i = r % 3, a = [], o = 0, s = r - i; o < s; o += 16383)a.push(u(t1, o, o + 16383 > s ? s : o + 16383));
                                            1 === i ? (e1 = t1[r - 1], a.push(n[e1 >> 2] + n[e1 << 4 & 63] + "==")) : 2 === i && (e1 = (t1[r - 2] << 8) + t1[r - 1], a.push(n[e1 >> 10] + n[e1 >> 4 & 63] + n[e1 << 2 & 63] + "="));
                                            return a.join("");
                                        };
                                        for(var n = [], i = [], a = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, l = o.length; s < l; ++s)n[s] = o[s], i[o.charCodeAt(s)] = s;
                                        function c(t1) {
                                            var e1 = t1.length;
                                            if (e1 % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                                            var r = t1.indexOf("=");
                                            return -1 === r && (r = e1), [
                                                r,
                                                r === e1 ? 0 : 4 - r % 4
                                            ];
                                        }
                                        function u(t1, e1, r) {
                                            for(var i, a, o = [], s = e1; s < r; s += 3)i = (t1[s] << 16 & 16711680) + (t1[s + 1] << 8 & 65280) + (255 & t1[s + 2]), o.push(n[(a = i) >> 18 & 63] + n[a >> 12 & 63] + n[a >> 6 & 63] + n[63 & a]);
                                            return o.join("");
                                        }
                                        i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
                                    },
                                    {}
                                ],
                                2: [
                                    function(t1, e1, r) {},
                                    {}
                                ],
                                3: [
                                    function(t1, e1, r) {
                                        (function(e1) {
                                            (function() {
                                                /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ "use strict";
                                                var e1 = t1("base64-js"), n = t1("ieee754");
                                                r.Buffer = a, r.SlowBuffer = function(t1) {
                                                    +t1 != t1 && (t1 = 0);
                                                    return a.alloc(+t1);
                                                }, r.INSPECT_MAX_BYTES = 50;
                                                function i(t1) {
                                                    if (t1 > 2147483647) throw new RangeError('The value "' + t1 + '" is invalid for option "size"');
                                                    var e1 = new Uint8Array(t1);
                                                    return e1.__proto__ = a.prototype, e1;
                                                }
                                                function a(t1, e1, r) {
                                                    if ("number" == typeof t1) {
                                                        if ("string" == typeof e1) throw new TypeError('The "string" argument must be of type string. Received type number');
                                                        return l(t1);
                                                    }
                                                    return o(t1, e1, r);
                                                }
                                                function o(t1, e1, r) {
                                                    if ("string" == typeof t1) return function(t1, e1) {
                                                        "string" == typeof e1 && "" !== e1 || (e1 = "utf8");
                                                        if (!a.isEncoding(e1)) throw new TypeError("Unknown encoding: " + e1);
                                                        var r = 0 | f(t1, e1), n = i(r), o = n.write(t1, e1);
                                                        o !== r && (n = n.slice(0, o));
                                                        return n;
                                                    }(t1, e1);
                                                    if (ArrayBuffer.isView(t1)) return c(t1);
                                                    if (null == t1) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t1);
                                                    if (B(t1, ArrayBuffer) || t1 && B(t1.buffer, ArrayBuffer)) return function(t1, e1, r) {
                                                        if (e1 < 0 || t1.byteLength < e1) throw new RangeError('"offset" is outside of buffer bounds');
                                                        if (t1.byteLength < e1 + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                                        var n;
                                                        n = void 0 === e1 && void 0 === r ? new Uint8Array(t1) : void 0 === r ? new Uint8Array(t1, e1) : new Uint8Array(t1, e1, r);
                                                        return n.__proto__ = a.prototype, n;
                                                    }(t1, e1, r);
                                                    if ("number" == typeof t1) throw new TypeError('The "value" argument must not be of type number. Received type number');
                                                    var n = t1.valueOf && t1.valueOf();
                                                    if (null != n && n !== t1) return a.from(n, e1, r);
                                                    var o = function(t1) {
                                                        if (a.isBuffer(t1)) {
                                                            var e1 = 0 | u(t1.length), r = i(e1);
                                                            return 0 === r.length || t1.copy(r, 0, 0, e1), r;
                                                        }
                                                        if (void 0 !== t1.length) return "number" != typeof t1.length || N(t1.length) ? i(0) : c(t1);
                                                        if ("Buffer" === t1.type && Array.isArray(t1.data)) return c(t1.data);
                                                    }(t1);
                                                    if (o) return o;
                                                    if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof t1[Symbol.toPrimitive]) return a.from(t1[Symbol.toPrimitive]("string"), e1, r);
                                                    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t1);
                                                }
                                                function s(t1) {
                                                    if ("number" != typeof t1) throw new TypeError('"size" argument must be of type number');
                                                    if (t1 < 0) throw new RangeError('The value "' + t1 + '" is invalid for option "size"');
                                                }
                                                function l(t1) {
                                                    return s(t1), i(t1 < 0 ? 0 : 0 | u(t1));
                                                }
                                                function c(t1) {
                                                    for(var e1 = t1.length < 0 ? 0 : 0 | u(t1.length), r = i(e1), n = 0; n < e1; n += 1)r[n] = 255 & t1[n];
                                                    return r;
                                                }
                                                function u(t1) {
                                                    if (t1 >= 2147483647) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + 2147483647..toString(16) + " bytes");
                                                    return 0 | t1;
                                                }
                                                function f(t1, e1) {
                                                    if (a.isBuffer(t1)) return t1.length;
                                                    if (ArrayBuffer.isView(t1) || B(t1, ArrayBuffer)) return t1.byteLength;
                                                    if ("string" != typeof t1) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof t1);
                                                    var r = t1.length, n = arguments.length > 2 && !0 === arguments[2];
                                                    if (!n && 0 === r) return 0;
                                                    for(var i = !1;;)switch(e1){
                                                        case "ascii":
                                                        case "latin1":
                                                        case "binary":
                                                            return r;
                                                        case "utf8":
                                                        case "utf-8":
                                                            return D(t1).length;
                                                        case "ucs2":
                                                        case "ucs-2":
                                                        case "utf16le":
                                                        case "utf-16le":
                                                            return 2 * r;
                                                        case "hex":
                                                            return r >>> 1;
                                                        case "base64":
                                                            return R(t1).length;
                                                        default:
                                                            if (i) return n ? -1 : D(t1).length;
                                                            e1 = ("" + e1).toLowerCase(), i = !0;
                                                    }
                                                }
                                                function h(t1, e1, r) {
                                                    var n = !1;
                                                    if ((void 0 === e1 || e1 < 0) && (e1 = 0), e1 > this.length) return "";
                                                    if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                                                    if ((r >>>= 0) <= (e1 >>>= 0)) return "";
                                                    for(t1 || (t1 = "utf8");;)switch(t1){
                                                        case "hex":
                                                            return M(this, e1, r);
                                                        case "utf8":
                                                        case "utf-8":
                                                            return T(this, e1, r);
                                                        case "ascii":
                                                            return k(this, e1, r);
                                                        case "latin1":
                                                        case "binary":
                                                            return A(this, e1, r);
                                                        case "base64":
                                                            return w(this, e1, r);
                                                        case "ucs2":
                                                        case "ucs-2":
                                                        case "utf16le":
                                                        case "utf-16le":
                                                            return S(this, e1, r);
                                                        default:
                                                            if (n) throw new TypeError("Unknown encoding: " + t1);
                                                            t1 = (t1 + "").toLowerCase(), n = !0;
                                                    }
                                                }
                                                function p(t1, e1, r) {
                                                    var n = t1[e1];
                                                    t1[e1] = t1[r], t1[r] = n;
                                                }
                                                function d(t1, e1, r, n, i) {
                                                    if (0 === t1.length) return -1;
                                                    if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), N(r = +r) && (r = i ? 0 : t1.length - 1), r < 0 && (r = t1.length + r), r >= t1.length) {
                                                        if (i) return -1;
                                                        r = t1.length - 1;
                                                    } else if (r < 0) {
                                                        if (!i) return -1;
                                                        r = 0;
                                                    }
                                                    if ("string" == typeof e1 && (e1 = a.from(e1, n)), a.isBuffer(e1)) return 0 === e1.length ? -1 : m(t1, e1, r, n, i);
                                                    if ("number" == typeof e1) return e1 &= 255, "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t1, e1, r) : Uint8Array.prototype.lastIndexOf.call(t1, e1, r) : m(t1, [
                                                        e1
                                                    ], r, n, i);
                                                    throw new TypeError("val must be string, number or Buffer");
                                                }
                                                function m(t1, e1, r, n, i) {
                                                    var a, o = 1, s = t1.length, l = e1.length;
                                                    if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                                                        if (t1.length < 2 || e1.length < 2) return -1;
                                                        o = 2, s /= 2, l /= 2, r /= 2;
                                                    }
                                                    function c(t1, e1) {
                                                        return 1 === o ? t1[e1] : t1.readUInt16BE(e1 * o);
                                                    }
                                                    if (i) {
                                                        var u = -1;
                                                        for(a = r; a < s; a++)if (c(t1, a) === c(e1, -1 === u ? 0 : a - u)) {
                                                            if (-1 === u && (u = a), a - u + 1 === l) return u * o;
                                                        } else -1 !== u && (a -= a - u), u = -1;
                                                    } else for(r + l > s && (r = s - l), a = r; a >= 0; a--){
                                                        for(var f = !0, h = 0; h < l; h++)if (c(t1, a + h) !== c(e1, h)) {
                                                            f = !1;
                                                            break;
                                                        }
                                                        if (f) return a;
                                                    }
                                                    return -1;
                                                }
                                                function g(t1, e1, r, n) {
                                                    r = Number(r) || 0;
                                                    var i = t1.length - r;
                                                    n ? (n = Number(n)) > i && (n = i) : n = i;
                                                    var a = e1.length;
                                                    n > a / 2 && (n = a / 2);
                                                    for(var o = 0; o < n; ++o){
                                                        var s = parseInt(e1.substr(2 * o, 2), 16);
                                                        if (N(s)) return o;
                                                        t1[r + o] = s;
                                                    }
                                                    return o;
                                                }
                                                function v(t1, e1, r, n) {
                                                    return F(D(e1, t1.length - r), t1, r, n);
                                                }
                                                function y(t1, e1, r, n) {
                                                    return F(function(t1) {
                                                        for(var e1 = [], r = 0; r < t1.length; ++r)e1.push(255 & t1.charCodeAt(r));
                                                        return e1;
                                                    }(e1), t1, r, n);
                                                }
                                                function x(t1, e1, r, n) {
                                                    return y(t1, e1, r, n);
                                                }
                                                function b(t1, e1, r, n) {
                                                    return F(R(e1), t1, r, n);
                                                }
                                                function _(t1, e1, r, n) {
                                                    return F(function(t1, e1) {
                                                        for(var r, n, i, a = [], o = 0; o < t1.length && !((e1 -= 2) < 0); ++o)r = t1.charCodeAt(o), n = r >> 8, i = r % 256, a.push(i), a.push(n);
                                                        return a;
                                                    }(e1, t1.length - r), t1, r, n);
                                                }
                                                function w(t1, r, n) {
                                                    return 0 === r && n === t1.length ? e1.fromByteArray(t1) : e1.fromByteArray(t1.slice(r, n));
                                                }
                                                function T(t1, e1, r) {
                                                    r = Math.min(t1.length, r);
                                                    for(var n = [], i = e1; i < r;){
                                                        var a, o, s, l, c = t1[i], u = null, f = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
                                                        if (i + f <= r) switch(f){
                                                            case 1:
                                                                c < 128 && (u = c);
                                                                break;
                                                            case 2:
                                                                128 == (192 & (a = t1[i + 1])) && (l = (31 & c) << 6 | 63 & a) > 127 && (u = l);
                                                                break;
                                                            case 3:
                                                                a = t1[i + 1], o = t1[i + 2], 128 == (192 & a) && 128 == (192 & o) && (l = (15 & c) << 12 | (63 & a) << 6 | 63 & o) > 2047 && (l < 55296 || l > 57343) && (u = l);
                                                                break;
                                                            case 4:
                                                                a = t1[i + 1], o = t1[i + 2], s = t1[i + 3], 128 == (192 & a) && 128 == (192 & o) && 128 == (192 & s) && (l = (15 & c) << 18 | (63 & a) << 12 | (63 & o) << 6 | 63 & s) > 65535 && l < 1114112 && (u = l);
                                                        }
                                                        null === u ? (u = 65533, f = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += f;
                                                    }
                                                    return function(t1) {
                                                        var e1 = t1.length;
                                                        if (e1 <= 4096) return String.fromCharCode.apply(String, t1);
                                                        var r = "", n = 0;
                                                        for(; n < e1;)r += String.fromCharCode.apply(String, t1.slice(n, n += 4096));
                                                        return r;
                                                    }(n);
                                                }
                                                r.kMaxLength = 2147483647, a.TYPED_ARRAY_SUPPORT = function() {
                                                    try {
                                                        var t1 = new Uint8Array(1);
                                                        return t1.__proto__ = {
                                                            __proto__: Uint8Array.prototype,
                                                            foo: function() {
                                                                return 42;
                                                            }
                                                        }, 42 === t1.foo();
                                                    } catch (t1) {
                                                        return !1;
                                                    }
                                                }(), a.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(a.prototype, "parent", {
                                                    enumerable: !0,
                                                    get: function() {
                                                        if (a.isBuffer(this)) return this.buffer;
                                                    }
                                                }), Object.defineProperty(a.prototype, "offset", {
                                                    enumerable: !0,
                                                    get: function() {
                                                        if (a.isBuffer(this)) return this.byteOffset;
                                                    }
                                                }), "undefined" != typeof Symbol && null != Symbol.species && a[Symbol.species] === a && Object.defineProperty(a, Symbol.species, {
                                                    value: null,
                                                    configurable: !0,
                                                    enumerable: !1,
                                                    writable: !1
                                                }), a.poolSize = 8192, a.from = function(t1, e1, r) {
                                                    return o(t1, e1, r);
                                                }, a.prototype.__proto__ = Uint8Array.prototype, a.__proto__ = Uint8Array, a.alloc = function(t1, e1, r) {
                                                    return function(t1, e1, r) {
                                                        return s(t1), t1 <= 0 ? i(t1) : void 0 !== e1 ? "string" == typeof r ? i(t1).fill(e1, r) : i(t1).fill(e1) : i(t1);
                                                    }(t1, e1, r);
                                                }, a.allocUnsafe = function(t1) {
                                                    return l(t1);
                                                }, a.allocUnsafeSlow = function(t1) {
                                                    return l(t1);
                                                }, a.isBuffer = function(t1) {
                                                    return null != t1 && !0 === t1._isBuffer && t1 !== a.prototype;
                                                }, a.compare = function(t1, e1) {
                                                    if (B(t1, Uint8Array) && (t1 = a.from(t1, t1.offset, t1.byteLength)), B(e1, Uint8Array) && (e1 = a.from(e1, e1.offset, e1.byteLength)), !a.isBuffer(t1) || !a.isBuffer(e1)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                                                    if (t1 === e1) return 0;
                                                    for(var r = t1.length, n = e1.length, i = 0, o = Math.min(r, n); i < o; ++i)if (t1[i] !== e1[i]) {
                                                        r = t1[i], n = e1[i];
                                                        break;
                                                    }
                                                    return r < n ? -1 : n < r ? 1 : 0;
                                                }, a.isEncoding = function(t1) {
                                                    switch(String(t1).toLowerCase()){
                                                        case "hex":
                                                        case "utf8":
                                                        case "utf-8":
                                                        case "ascii":
                                                        case "latin1":
                                                        case "binary":
                                                        case "base64":
                                                        case "ucs2":
                                                        case "ucs-2":
                                                        case "utf16le":
                                                        case "utf-16le":
                                                            return !0;
                                                        default:
                                                            return !1;
                                                    }
                                                }, a.concat = function(t1, e1) {
                                                    if (!Array.isArray(t1)) throw new TypeError('"list" argument must be an Array of Buffers');
                                                    if (0 === t1.length) return a.alloc(0);
                                                    var r;
                                                    if (void 0 === e1) for(e1 = 0, r = 0; r < t1.length; ++r)e1 += t1[r].length;
                                                    var n = a.allocUnsafe(e1), i = 0;
                                                    for(r = 0; r < t1.length; ++r){
                                                        var o = t1[r];
                                                        if (B(o, Uint8Array) && (o = a.from(o)), !a.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
                                                        o.copy(n, i), i += o.length;
                                                    }
                                                    return n;
                                                }, a.byteLength = f, a.prototype._isBuffer = !0, a.prototype.swap16 = function() {
                                                    var t1 = this.length;
                                                    if (t1 % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                                                    for(var e1 = 0; e1 < t1; e1 += 2)p(this, e1, e1 + 1);
                                                    return this;
                                                }, a.prototype.swap32 = function() {
                                                    var t1 = this.length;
                                                    if (t1 % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                                                    for(var e1 = 0; e1 < t1; e1 += 4)p(this, e1, e1 + 3), p(this, e1 + 1, e1 + 2);
                                                    return this;
                                                }, a.prototype.swap64 = function() {
                                                    var t1 = this.length;
                                                    if (t1 % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                                                    for(var e1 = 0; e1 < t1; e1 += 8)p(this, e1, e1 + 7), p(this, e1 + 1, e1 + 6), p(this, e1 + 2, e1 + 5), p(this, e1 + 3, e1 + 4);
                                                    return this;
                                                }, a.prototype.toString = function() {
                                                    var t1 = this.length;
                                                    return 0 === t1 ? "" : 0 === arguments.length ? T(this, 0, t1) : h.apply(this, arguments);
                                                }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(t1) {
                                                    if (!a.isBuffer(t1)) throw new TypeError("Argument must be a Buffer");
                                                    return this === t1 || 0 === a.compare(this, t1);
                                                }, a.prototype.inspect = function() {
                                                    var t1 = "", e1 = r.INSPECT_MAX_BYTES;
                                                    return t1 = this.toString("hex", 0, e1).replace(/(.{2})/g, "$1 ").trim(), this.length > e1 && (t1 += " ... "), "<Buffer " + t1 + ">";
                                                }, a.prototype.compare = function(t1, e1, r, n, i) {
                                                    if (B(t1, Uint8Array) && (t1 = a.from(t1, t1.offset, t1.byteLength)), !a.isBuffer(t1)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof t1);
                                                    if (void 0 === e1 && (e1 = 0), void 0 === r && (r = t1 ? t1.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e1 < 0 || r > t1.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                                                    if (n >= i && e1 >= r) return 0;
                                                    if (n >= i) return -1;
                                                    if (e1 >= r) return 1;
                                                    if (this === t1) return 0;
                                                    for(var o = (i >>>= 0) - (n >>>= 0), s = (r >>>= 0) - (e1 >>>= 0), l = Math.min(o, s), c = this.slice(n, i), u = t1.slice(e1, r), f = 0; f < l; ++f)if (c[f] !== u[f]) {
                                                        o = c[f], s = u[f];
                                                        break;
                                                    }
                                                    return o < s ? -1 : s < o ? 1 : 0;
                                                }, a.prototype.includes = function(t1, e1, r) {
                                                    return -1 !== this.indexOf(t1, e1, r);
                                                }, a.prototype.indexOf = function(t1, e1, r) {
                                                    return d(this, t1, e1, r, !0);
                                                }, a.prototype.lastIndexOf = function(t1, e1, r) {
                                                    return d(this, t1, e1, r, !1);
                                                }, a.prototype.write = function(t1, e1, r, n) {
                                                    if (void 0 === e1) n = "utf8", r = this.length, e1 = 0;
                                                    else if (void 0 === r && "string" == typeof e1) n = e1, r = this.length, e1 = 0;
                                                    else {
                                                        if (!isFinite(e1)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                                        e1 >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                                                    }
                                                    var i = this.length - e1;
                                                    if ((void 0 === r || r > i) && (r = i), t1.length > 0 && (r < 0 || e1 < 0) || e1 > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                                                    n || (n = "utf8");
                                                    for(var a = !1;;)switch(n){
                                                        case "hex":
                                                            return g(this, t1, e1, r);
                                                        case "utf8":
                                                        case "utf-8":
                                                            return v(this, t1, e1, r);
                                                        case "ascii":
                                                            return y(this, t1, e1, r);
                                                        case "latin1":
                                                        case "binary":
                                                            return x(this, t1, e1, r);
                                                        case "base64":
                                                            return b(this, t1, e1, r);
                                                        case "ucs2":
                                                        case "ucs-2":
                                                        case "utf16le":
                                                        case "utf-16le":
                                                            return _(this, t1, e1, r);
                                                        default:
                                                            if (a) throw new TypeError("Unknown encoding: " + n);
                                                            n = ("" + n).toLowerCase(), a = !0;
                                                    }
                                                }, a.prototype.toJSON = function() {
                                                    return {
                                                        type: "Buffer",
                                                        data: Array.prototype.slice.call(this._arr || this, 0)
                                                    };
                                                };
                                                function k(t1, e1, r) {
                                                    var n = "";
                                                    r = Math.min(t1.length, r);
                                                    for(var i = e1; i < r; ++i)n += String.fromCharCode(127 & t1[i]);
                                                    return n;
                                                }
                                                function A(t1, e1, r) {
                                                    var n = "";
                                                    r = Math.min(t1.length, r);
                                                    for(var i = e1; i < r; ++i)n += String.fromCharCode(t1[i]);
                                                    return n;
                                                }
                                                function M(t1, e1, r) {
                                                    var n = t1.length;
                                                    (!e1 || e1 < 0) && (e1 = 0), (!r || r < 0 || r > n) && (r = n);
                                                    for(var i = "", a = e1; a < r; ++a)i += z(t1[a]);
                                                    return i;
                                                }
                                                function S(t1, e1, r) {
                                                    for(var n = t1.slice(e1, r), i = "", a = 0; a < n.length; a += 2)i += String.fromCharCode(n[a] + 256 * n[a + 1]);
                                                    return i;
                                                }
                                                function E(t1, e1, r) {
                                                    if (t1 % 1 != 0 || t1 < 0) throw new RangeError("offset is not uint");
                                                    if (t1 + e1 > r) throw new RangeError("Trying to access beyond buffer length");
                                                }
                                                function L(t1, e1, r, n, i, o) {
                                                    if (!a.isBuffer(t1)) throw new TypeError('"buffer" argument must be a Buffer instance');
                                                    if (e1 > i || e1 < o) throw new RangeError('"value" argument is out of bounds');
                                                    if (r + n > t1.length) throw new RangeError("Index out of range");
                                                }
                                                function C(t1, e1, r, n, i, a) {
                                                    if (r + n > t1.length) throw new RangeError("Index out of range");
                                                    if (r < 0) throw new RangeError("Index out of range");
                                                }
                                                function P(t1, e1, r, i, a) {
                                                    return e1 = +e1, r >>>= 0, a || C(t1, 0, r, 4), n.write(t1, e1, r, i, 23, 4), r + 4;
                                                }
                                                function I(t1, e1, r, i, a) {
                                                    return e1 = +e1, r >>>= 0, a || C(t1, 0, r, 8), n.write(t1, e1, r, i, 52, 8), r + 8;
                                                }
                                                a.prototype.slice = function(t1, e1) {
                                                    var r = this.length;
                                                    (t1 = ~~t1) < 0 ? (t1 += r) < 0 && (t1 = 0) : t1 > r && (t1 = r), (e1 = void 0 === e1 ? r : ~~e1) < 0 ? (e1 += r) < 0 && (e1 = 0) : e1 > r && (e1 = r), e1 < t1 && (e1 = t1);
                                                    var n = this.subarray(t1, e1);
                                                    return n.__proto__ = a.prototype, n;
                                                }, a.prototype.readUIntLE = function(t1, e1, r) {
                                                    t1 >>>= 0, e1 >>>= 0, r || E(t1, e1, this.length);
                                                    for(var n = this[t1], i = 1, a = 0; ++a < e1 && (i *= 256);)n += this[t1 + a] * i;
                                                    return n;
                                                }, a.prototype.readUIntBE = function(t1, e1, r) {
                                                    t1 >>>= 0, e1 >>>= 0, r || E(t1, e1, this.length);
                                                    for(var n = this[t1 + --e1], i = 1; e1 > 0 && (i *= 256);)n += this[t1 + --e1] * i;
                                                    return n;
                                                }, a.prototype.readUInt8 = function(t1, e1) {
                                                    return t1 >>>= 0, e1 || E(t1, 1, this.length), this[t1];
                                                }, a.prototype.readUInt16LE = function(t1, e1) {
                                                    return t1 >>>= 0, e1 || E(t1, 2, this.length), this[t1] | this[t1 + 1] << 8;
                                                }, a.prototype.readUInt16BE = function(t1, e1) {
                                                    return t1 >>>= 0, e1 || E(t1, 2, this.length), this[t1] << 8 | this[t1 + 1];
                                                }, a.prototype.readUInt32LE = function(t1, e1) {
                                                    return t1 >>>= 0, e1 || E(t1, 4, this.length), (this[t1] | this[t1 + 1] << 8 | this[t1 + 2] << 16) + 16777216 * this[t1 + 3];
                                                }, a.prototype.readUInt32BE = function(t1, e1) {
                                                    return t1 >>>= 0, e1 || E(t1, 4, this.length), 16777216 * this[t1] + (this[t1 + 1] << 16 | this[t1 + 2] << 8 | this[t1 + 3]);
                                                }, a.prototype.readIntLE = function(t1, e1, r) {
                                                    t1 >>>= 0, e1 >>>= 0, r || E(t1, e1, this.length);
                                                    for(var n = this[t1], i = 1, a = 0; ++a < e1 && (i *= 256);)n += this[t1 + a] * i;
                                                    return n >= (i *= 128) && (n -= Math.pow(2, 8 * e1)), n;
                                                }, a.prototype.readIntBE = function(t1, e1, r) {
                                                    t1 >>>= 0, e1 >>>= 0, r || E(t1, e1, this.length);
                                                    for(var n = e1, i = 1, a = this[t1 + --n]; n > 0 && (i *= 256);)a += this[t1 + --n] * i;
                                                    return a >= (i *= 128) && (a -= Math.pow(2, 8 * e1)), a;
                                                }, a.prototype.readInt8 = function(t1, e1) {
                                                    return t1 >>>= 0, e1 || E(t1, 1, this.length), 128 & this[t1] ? -1 * (255 - this[t1] + 1) : this[t1];
                                                }, a.prototype.readInt16LE = function(t1, e1) {
                                                    t1 >>>= 0, e1 || E(t1, 2, this.length);
                                                    var r = this[t1] | this[t1 + 1] << 8;
                                                    return 32768 & r ? 4294901760 | r : r;
                                                }, a.prototype.readInt16BE = function(t1, e1) {
                                                    t1 >>>= 0, e1 || E(t1, 2, this.length);
                                                    var r = this[t1 + 1] | this[t1] << 8;
                                                    return 32768 & r ? 4294901760 | r : r;
                                                }, a.prototype.readInt32LE = function(t1, e1) {
                                                    return t1 >>>= 0, e1 || E(t1, 4, this.length), this[t1] | this[t1 + 1] << 8 | this[t1 + 2] << 16 | this[t1 + 3] << 24;
                                                }, a.prototype.readInt32BE = function(t1, e1) {
                                                    return t1 >>>= 0, e1 || E(t1, 4, this.length), this[t1] << 24 | this[t1 + 1] << 16 | this[t1 + 2] << 8 | this[t1 + 3];
                                                }, a.prototype.readFloatLE = function(t1, e1) {
                                                    return t1 >>>= 0, e1 || E(t1, 4, this.length), n.read(this, t1, !0, 23, 4);
                                                }, a.prototype.readFloatBE = function(t1, e1) {
                                                    return t1 >>>= 0, e1 || E(t1, 4, this.length), n.read(this, t1, !1, 23, 4);
                                                }, a.prototype.readDoubleLE = function(t1, e1) {
                                                    return t1 >>>= 0, e1 || E(t1, 8, this.length), n.read(this, t1, !0, 52, 8);
                                                }, a.prototype.readDoubleBE = function(t1, e1) {
                                                    return t1 >>>= 0, e1 || E(t1, 8, this.length), n.read(this, t1, !1, 52, 8);
                                                }, a.prototype.writeUIntLE = function(t1, e1, r, n) {
                                                    (t1 = +t1, e1 >>>= 0, r >>>= 0, n) || L(this, t1, e1, r, Math.pow(2, 8 * r) - 1, 0);
                                                    var i = 1, a = 0;
                                                    for(this[e1] = 255 & t1; ++a < r && (i *= 256);)this[e1 + a] = t1 / i & 255;
                                                    return e1 + r;
                                                }, a.prototype.writeUIntBE = function(t1, e1, r, n) {
                                                    (t1 = +t1, e1 >>>= 0, r >>>= 0, n) || L(this, t1, e1, r, Math.pow(2, 8 * r) - 1, 0);
                                                    var i = r - 1, a = 1;
                                                    for(this[e1 + i] = 255 & t1; --i >= 0 && (a *= 256);)this[e1 + i] = t1 / a & 255;
                                                    return e1 + r;
                                                }, a.prototype.writeUInt8 = function(t1, e1, r) {
                                                    return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 1, 255, 0), this[e1] = 255 & t1, e1 + 1;
                                                }, a.prototype.writeUInt16LE = function(t1, e1, r) {
                                                    return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 2, 65535, 0), this[e1] = 255 & t1, this[e1 + 1] = t1 >>> 8, e1 + 2;
                                                }, a.prototype.writeUInt16BE = function(t1, e1, r) {
                                                    return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 2, 65535, 0), this[e1] = t1 >>> 8, this[e1 + 1] = 255 & t1, e1 + 2;
                                                }, a.prototype.writeUInt32LE = function(t1, e1, r) {
                                                    return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 4, 4294967295, 0), this[e1 + 3] = t1 >>> 24, this[e1 + 2] = t1 >>> 16, this[e1 + 1] = t1 >>> 8, this[e1] = 255 & t1, e1 + 4;
                                                }, a.prototype.writeUInt32BE = function(t1, e1, r) {
                                                    return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 4, 4294967295, 0), this[e1] = t1 >>> 24, this[e1 + 1] = t1 >>> 16, this[e1 + 2] = t1 >>> 8, this[e1 + 3] = 255 & t1, e1 + 4;
                                                }, a.prototype.writeIntLE = function(t1, e1, r, n) {
                                                    if (t1 = +t1, e1 >>>= 0, !n) {
                                                        var i = Math.pow(2, 8 * r - 1);
                                                        L(this, t1, e1, r, i - 1, -i);
                                                    }
                                                    var a = 0, o = 1, s = 0;
                                                    for(this[e1] = 255 & t1; ++a < r && (o *= 256);)t1 < 0 && 0 === s && 0 !== this[e1 + a - 1] && (s = 1), this[e1 + a] = (t1 / o >> 0) - s & 255;
                                                    return e1 + r;
                                                }, a.prototype.writeIntBE = function(t1, e1, r, n) {
                                                    if (t1 = +t1, e1 >>>= 0, !n) {
                                                        var i = Math.pow(2, 8 * r - 1);
                                                        L(this, t1, e1, r, i - 1, -i);
                                                    }
                                                    var a = r - 1, o = 1, s = 0;
                                                    for(this[e1 + a] = 255 & t1; --a >= 0 && (o *= 256);)t1 < 0 && 0 === s && 0 !== this[e1 + a + 1] && (s = 1), this[e1 + a] = (t1 / o >> 0) - s & 255;
                                                    return e1 + r;
                                                }, a.prototype.writeInt8 = function(t1, e1, r) {
                                                    return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 1, 127, -128), t1 < 0 && (t1 = 255 + t1 + 1), this[e1] = 255 & t1, e1 + 1;
                                                }, a.prototype.writeInt16LE = function(t1, e1, r) {
                                                    return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 2, 32767, -32768), this[e1] = 255 & t1, this[e1 + 1] = t1 >>> 8, e1 + 2;
                                                }, a.prototype.writeInt16BE = function(t1, e1, r) {
                                                    return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 2, 32767, -32768), this[e1] = t1 >>> 8, this[e1 + 1] = 255 & t1, e1 + 2;
                                                }, a.prototype.writeInt32LE = function(t1, e1, r) {
                                                    return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 4, 2147483647, -2147483648), this[e1] = 255 & t1, this[e1 + 1] = t1 >>> 8, this[e1 + 2] = t1 >>> 16, this[e1 + 3] = t1 >>> 24, e1 + 4;
                                                }, a.prototype.writeInt32BE = function(t1, e1, r) {
                                                    return t1 = +t1, e1 >>>= 0, r || L(this, t1, e1, 4, 2147483647, -2147483648), t1 < 0 && (t1 = 4294967295 + t1 + 1), this[e1] = t1 >>> 24, this[e1 + 1] = t1 >>> 16, this[e1 + 2] = t1 >>> 8, this[e1 + 3] = 255 & t1, e1 + 4;
                                                }, a.prototype.writeFloatLE = function(t1, e1, r) {
                                                    return P(this, t1, e1, !0, r);
                                                }, a.prototype.writeFloatBE = function(t1, e1, r) {
                                                    return P(this, t1, e1, !1, r);
                                                }, a.prototype.writeDoubleLE = function(t1, e1, r) {
                                                    return I(this, t1, e1, !0, r);
                                                }, a.prototype.writeDoubleBE = function(t1, e1, r) {
                                                    return I(this, t1, e1, !1, r);
                                                }, a.prototype.copy = function(t1, e1, r, n) {
                                                    if (!a.isBuffer(t1)) throw new TypeError("argument should be a Buffer");
                                                    if (r || (r = 0), n || 0 === n || (n = this.length), e1 >= t1.length && (e1 = t1.length), e1 || (e1 = 0), n > 0 && n < r && (n = r), n === r) return 0;
                                                    if (0 === t1.length || 0 === this.length) return 0;
                                                    if (e1 < 0) throw new RangeError("targetStart out of bounds");
                                                    if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                                                    if (n < 0) throw new RangeError("sourceEnd out of bounds");
                                                    n > this.length && (n = this.length), t1.length - e1 < n - r && (n = t1.length - e1 + r);
                                                    var i = n - r;
                                                    if (this === t1 && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(e1, r, n);
                                                    else if (this === t1 && r < e1 && e1 < n) for(var o = i - 1; o >= 0; --o)t1[o + e1] = this[o + r];
                                                    else Uint8Array.prototype.set.call(t1, this.subarray(r, n), e1);
                                                    return i;
                                                }, a.prototype.fill = function(t1, e1, r, n) {
                                                    if ("string" == typeof t1) {
                                                        if ("string" == typeof e1 ? (n = e1, e1 = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                                                        if ("string" == typeof n && !a.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                                                        if (1 === t1.length) {
                                                            var i = t1.charCodeAt(0);
                                                            ("utf8" === n && i < 128 || "latin1" === n) && (t1 = i);
                                                        }
                                                    } else "number" == typeof t1 && (t1 &= 255);
                                                    if (e1 < 0 || this.length < e1 || this.length < r) throw new RangeError("Out of range index");
                                                    if (r <= e1) return this;
                                                    var o;
                                                    if (e1 >>>= 0, r = void 0 === r ? this.length : r >>> 0, t1 || (t1 = 0), "number" == typeof t1) for(o = e1; o < r; ++o)this[o] = t1;
                                                    else {
                                                        var s = a.isBuffer(t1) ? t1 : a.from(t1, n), l = s.length;
                                                        if (0 === l) throw new TypeError('The value "' + t1 + '" is invalid for argument "value"');
                                                        for(o = 0; o < r - e1; ++o)this[o + e1] = s[o % l];
                                                    }
                                                    return this;
                                                };
                                                var O = /[^+/0-9A-Za-z-_]/g;
                                                function z(t1) {
                                                    return t1 < 16 ? "0" + t1.toString(16) : t1.toString(16);
                                                }
                                                function D(t1, e1) {
                                                    var r;
                                                    e1 = e1 || 1 / 0;
                                                    for(var n = t1.length, i = null, a = [], o = 0; o < n; ++o){
                                                        if ((r = t1.charCodeAt(o)) > 55295 && r < 57344) {
                                                            if (!i) {
                                                                if (r > 56319) {
                                                                    (e1 -= 3) > -1 && a.push(239, 191, 189);
                                                                    continue;
                                                                }
                                                                if (o + 1 === n) {
                                                                    (e1 -= 3) > -1 && a.push(239, 191, 189);
                                                                    continue;
                                                                }
                                                                i = r;
                                                                continue;
                                                            }
                                                            if (r < 56320) {
                                                                (e1 -= 3) > -1 && a.push(239, 191, 189), i = r;
                                                                continue;
                                                            }
                                                            r = 65536 + (i - 55296 << 10 | r - 56320);
                                                        } else i && (e1 -= 3) > -1 && a.push(239, 191, 189);
                                                        if (i = null, r < 128) {
                                                            if ((e1 -= 1) < 0) break;
                                                            a.push(r);
                                                        } else if (r < 2048) {
                                                            if ((e1 -= 2) < 0) break;
                                                            a.push(r >> 6 | 192, 63 & r | 128);
                                                        } else if (r < 65536) {
                                                            if ((e1 -= 3) < 0) break;
                                                            a.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                                                        } else {
                                                            if (!(r < 1114112)) throw new Error("Invalid code point");
                                                            if ((e1 -= 4) < 0) break;
                                                            a.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                                                        }
                                                    }
                                                    return a;
                                                }
                                                function R(t1) {
                                                    return e1.toByteArray(function(t1) {
                                                        if ((t1 = (t1 = t1.split("=")[0]).trim().replace(O, "")).length < 2) return "";
                                                        for(; t1.length % 4 != 0;)t1 += "=";
                                                        return t1;
                                                    }(t1));
                                                }
                                                function F(t1, e1, r, n) {
                                                    for(var i = 0; i < n && !(i + r >= e1.length || i >= t1.length); ++i)e1[i + r] = t1[i];
                                                    return i;
                                                }
                                                function B(t1, e1) {
                                                    return t1 instanceof e1 || null != t1 && null != t1.constructor && null != t1.constructor.name && t1.constructor.name === e1.name;
                                                }
                                                function N(t1) {
                                                    return t1 != t1;
                                                }
                                            }).call(this);
                                        }).call(this, t1("buffer").Buffer);
                                    },
                                    {
                                        "base64-js": 1,
                                        buffer: 3,
                                        ieee754: 4
                                    }
                                ],
                                4: [
                                    function(t1, e1, r) {
                                        r.read = function(t1, e1, r, n, i) {
                                            var a, o, s = 8 * i - n - 1, l = (1 << s) - 1, c = l >> 1, u = -7, f = r ? i - 1 : 0, h = r ? -1 : 1, p = t1[e1 + f];
                                            for(f += h, a = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; a = 256 * a + t1[e1 + f], f += h, u -= 8);
                                            for(o = a & (1 << -u) - 1, a >>= -u, u += n; u > 0; o = 256 * o + t1[e1 + f], f += h, u -= 8);
                                            if (0 === a) a = 1 - c;
                                            else {
                                                if (a === l) return o ? NaN : 1 / 0 * (p ? -1 : 1);
                                                o += Math.pow(2, n), a -= c;
                                            }
                                            return (p ? -1 : 1) * o * Math.pow(2, a - n);
                                        }, r.write = function(t1, e1, r, n, i, a) {
                                            var o, s, l, c = 8 * a - i - 1, u = (1 << c) - 1, f = u >> 1, h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = n ? 0 : a - 1, d = n ? 1 : -1, m = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0;
                                            for(e1 = Math.abs(e1), isNaN(e1) || e1 === 1 / 0 ? (s = isNaN(e1) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e1) / Math.LN2), e1 * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (e1 += o + f >= 1 ? h / l : h * Math.pow(2, 1 - f)) * l >= 2 && (o++, l /= 2), o + f >= u ? (s = 0, o = u) : o + f >= 1 ? (s = (e1 * l - 1) * Math.pow(2, i), o += f) : (s = e1 * Math.pow(2, f - 1) * Math.pow(2, i), o = 0)); i >= 8; t1[r + p] = 255 & s, p += d, s /= 256, i -= 8);
                                            for(o = o << i | s, c += i; c > 0; t1[r + p] = 255 & o, p += d, o /= 256, c -= 8);
                                            t1[r + p - d] |= 128 * m;
                                        };
                                    },
                                    {}
                                ],
                                5: [
                                    function(t1, e1, r) {
                                        var n, i, a = e1.exports = {};
                                        function o() {
                                            throw new Error("setTimeout has not been defined");
                                        }
                                        function s() {
                                            throw new Error("clearTimeout has not been defined");
                                        }
                                        function l(t1) {
                                            if (n === setTimeout) return setTimeout(t1, 0);
                                            if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(t1, 0);
                                            try {
                                                return n(t1, 0);
                                            } catch (e1) {
                                                try {
                                                    return n.call(null, t1, 0);
                                                } catch (e1) {
                                                    return n.call(this, t1, 0);
                                                }
                                            }
                                        }
                                        !function() {
                                            try {
                                                n = "function" == typeof setTimeout ? setTimeout : o;
                                            } catch (t1) {
                                                n = o;
                                            }
                                            try {
                                                i = "function" == typeof clearTimeout ? clearTimeout : s;
                                            } catch (t1) {
                                                i = s;
                                            }
                                        }();
                                        var c, u = [], f = !1, h = -1;
                                        function p() {
                                            f && c && (f = !1, c.length ? u = c.concat(u) : h = -1, u.length && d());
                                        }
                                        function d() {
                                            if (!f) {
                                                var t1 = l(p);
                                                f = !0;
                                                for(var e1 = u.length; e1;){
                                                    for(c = u, u = []; ++h < e1;)c && c[h].run();
                                                    h = -1, e1 = u.length;
                                                }
                                                c = null, f = !1, function(t1) {
                                                    if (i === clearTimeout) return clearTimeout(t1);
                                                    if ((i === s || !i) && clearTimeout) return i = clearTimeout, clearTimeout(t1);
                                                    try {
                                                        i(t1);
                                                    } catch (e1) {
                                                        try {
                                                            return i.call(null, t1);
                                                        } catch (e1) {
                                                            return i.call(this, t1);
                                                        }
                                                    }
                                                }(t1);
                                            }
                                        }
                                        function m(t1, e1) {
                                            this.fun = t1, this.array = e1;
                                        }
                                        function g() {}
                                        a.nextTick = function(t1) {
                                            var e1 = new Array(arguments.length - 1);
                                            if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)e1[r - 1] = arguments[r];
                                            u.push(new m(t1, e1)), 1 !== u.length || f || l(d);
                                        }, m.prototype.run = function() {
                                            this.fun.apply(null, this.array);
                                        }, a.title = "browser", a.browser = !0, a.env = {}, a.argv = [], a.version = "", a.versions = {}, a.on = g, a.addListener = g, a.once = g, a.off = g, a.removeListener = g, a.removeAllListeners = g, a.emit = g, a.prependListener = g, a.prependOnceListener = g, a.listeners = function(t1) {
                                            return [];
                                        }, a.binding = function(t1) {
                                            throw new Error("process.binding is not supported");
                                        }, a.cwd = function() {
                                            return "/";
                                        }, a.chdir = function(t1) {
                                            throw new Error("process.chdir is not supported");
                                        }, a.umask = function() {
                                            return 0;
                                        };
                                    },
                                    {}
                                ],
                                6: [
                                    function(t1, e1, r) {
                                        e1.exports = {
                                            alpha_shape: t1("alpha-shape"),
                                            convex_hull: t1("convex-hull"),
                                            delaunay_triangulate: t1("delaunay-triangulate"),
                                            gl_cone3d: t1("gl-cone3d"),
                                            gl_error3d: t1("gl-error3d"),
                                            gl_heatmap2d: t1("gl-heatmap2d"),
                                            gl_line3d: t1("gl-line3d"),
                                            gl_mesh3d: t1("gl-mesh3d"),
                                            gl_plot2d: t1("gl-plot2d"),
                                            gl_plot3d: t1("gl-plot3d"),
                                            gl_pointcloud2d: t1("gl-pointcloud2d"),
                                            gl_scatter3d: t1("gl-scatter3d"),
                                            gl_select_box: t1("gl-select-box"),
                                            gl_spikes2d: t1("gl-spikes2d"),
                                            gl_streamtube3d: t1("gl-streamtube3d"),
                                            gl_surface3d: t1("gl-surface3d"),
                                            ndarray: t1("ndarray"),
                                            ndarray_linear_interpolate: t1("ndarray-linear-interpolate")
                                        };
                                    },
                                    {
                                        "alpha-shape": 12,
                                        "convex-hull": 58,
                                        "delaunay-triangulate": 63,
                                        "gl-cone3d": 79,
                                        "gl-error3d": 84,
                                        "gl-heatmap2d": 88,
                                        "gl-line3d": 91,
                                        "gl-mesh3d": 112,
                                        "gl-plot2d": 118,
                                        "gl-plot3d": 121,
                                        "gl-pointcloud2d": 123,
                                        "gl-scatter3d": 128,
                                        "gl-select-box": 130,
                                        "gl-spikes2d": 139,
                                        "gl-streamtube3d": 143,
                                        "gl-surface3d": 145,
                                        ndarray: 259,
                                        "ndarray-linear-interpolate": 253
                                    }
                                ],
                                7: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = (t1 = t1 || {}).eye || [
                                                0,
                                                0,
                                                1
                                            ], r = t1.center || [
                                                0,
                                                0,
                                                0
                                            ], s = t1.up || [
                                                0,
                                                1,
                                                0
                                            ], l = t1.distanceLimits || [
                                                0,
                                                1 / 0
                                            ], c = t1.mode || "turntable", u = n(), f = i(), h = a();
                                            return u.setDistanceLimits(l[0], l[1]), u.lookAt(0, e1, r, s), f.setDistanceLimits(l[0], l[1]), f.lookAt(0, e1, r, s), h.setDistanceLimits(l[0], l[1]), h.lookAt(0, e1, r, s), new o({
                                                turntable: u,
                                                orbit: f,
                                                matrix: h
                                            }, c);
                                        };
                                        var n = t1("turntable-camera-controller"), i = t1("orbit-camera-controller"), a = t1("matrix-camera-controller");
                                        function o(t1, e1) {
                                            this._controllerNames = Object.keys(t1), this._controllerList = this._controllerNames.map(function(e1) {
                                                return t1[e1];
                                            }), this._mode = e1, this._active = t1[e1], this._active || (this._mode = "turntable", this._active = t1.turntable), this.modes = this._controllerNames, this.computedMatrix = this._active.computedMatrix, this.computedEye = this._active.computedEye, this.computedUp = this._active.computedUp, this.computedCenter = this._active.computedCenter, this.computedRadius = this._active.computedRadius;
                                        }
                                        var s = o.prototype;
                                        s.flush = function(t1) {
                                            for(var e1 = this._controllerList, r = 0; r < e1.length; ++r)e1[r].flush(t1);
                                        }, s.idle = function(t1) {
                                            for(var e1 = this._controllerList, r = 0; r < e1.length; ++r)e1[r].idle(t1);
                                        }, s.lookAt = function(t1, e1, r, n) {
                                            for(var i = this._controllerList, a = 0; a < i.length; ++a)i[a].lookAt(t1, e1, r, n);
                                        }, s.rotate = function(t1, e1, r, n) {
                                            for(var i = this._controllerList, a = 0; a < i.length; ++a)i[a].rotate(t1, e1, r, n);
                                        }, s.pan = function(t1, e1, r, n) {
                                            for(var i = this._controllerList, a = 0; a < i.length; ++a)i[a].pan(t1, e1, r, n);
                                        }, s.translate = function(t1, e1, r, n) {
                                            for(var i = this._controllerList, a = 0; a < i.length; ++a)i[a].translate(t1, e1, r, n);
                                        }, s.setMatrix = function(t1, e1) {
                                            for(var r = this._controllerList, n = 0; n < r.length; ++n)r[n].setMatrix(t1, e1);
                                        }, s.setDistanceLimits = function(t1, e1) {
                                            for(var r = this._controllerList, n = 0; n < r.length; ++n)r[n].setDistanceLimits(t1, e1);
                                        }, s.setDistance = function(t1, e1) {
                                            for(var r = this._controllerList, n = 0; n < r.length; ++n)r[n].setDistance(t1, e1);
                                        }, s.recalcMatrix = function(t1) {
                                            this._active.recalcMatrix(t1);
                                        }, s.getDistance = function(t1) {
                                            return this._active.getDistance(t1);
                                        }, s.getDistanceLimits = function(t1) {
                                            return this._active.getDistanceLimits(t1);
                                        }, s.lastT = function() {
                                            return this._active.lastT();
                                        }, s.setMode = function(t1) {
                                            if (t1 !== this._mode) {
                                                var e1 = this._controllerNames.indexOf(t1);
                                                if (!(e1 < 0)) {
                                                    var r = this._active, n = this._controllerList[e1], i = Math.max(r.lastT(), n.lastT());
                                                    r.recalcMatrix(i), n.setMatrix(i, r.computedMatrix), this._active = n, this._mode = t1, this.computedMatrix = this._active.computedMatrix, this.computedEye = this._active.computedEye, this.computedUp = this._active.computedUp, this.computedCenter = this._active.computedCenter, this.computedRadius = this._active.computedRadius;
                                                }
                                            }
                                        }, s.getMode = function() {
                                            return this._mode;
                                        };
                                    },
                                    {
                                        "matrix-camera-controller": 245,
                                        "orbit-camera-controller": 263,
                                        "turntable-camera-controller": 305
                                    }
                                ],
                                8: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = "undefined" == typeof WeakMap ? t1("weak-map") : WeakMap, i = t1("gl-buffer"), a = t1("gl-vao"), o = new n;
                                        e1.exports = function(t1) {
                                            var e1 = o.get(t1), r = e1 && (e1._triangleBuffer.handle || e1._triangleBuffer.buffer);
                                            if (!r || !t1.isBuffer(r)) {
                                                var n = i(t1, new Float32Array([
                                                    -1,
                                                    -1,
                                                    -1,
                                                    4,
                                                    4,
                                                    -1
                                                ]));
                                                (e1 = a(t1, [
                                                    {
                                                        buffer: n,
                                                        type: t1.FLOAT,
                                                        size: 2
                                                    }
                                                ]))._triangleBuffer = n, o.set(t1, e1);
                                            }
                                            e1.bind(), t1.drawArrays(t1.TRIANGLES, 0, 3), e1.unbind();
                                        };
                                    },
                                    {
                                        "gl-buffer": 78,
                                        "gl-vao": 150,
                                        "weak-map": 313
                                    }
                                ],
                                9: [
                                    function(t1, e1, r) {
                                        var n = t1("pad-left");
                                        e1.exports = function(t1, e1, r) {
                                            e1 = "number" == typeof e1 ? e1 : 1, r = r || ": ";
                                            var i = t1.split(/\r?\n/), a = String(i.length + e1 - 1).length;
                                            return i.map(function(t1, i) {
                                                var o = i + e1, s = String(o).length;
                                                return n(o, a - s) + r + t1;
                                            }).join("\n");
                                        };
                                    },
                                    {
                                        "pad-left": 264
                                    }
                                ],
                                10: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = t1.length;
                                            if (0 === e1) return [];
                                            if (1 === e1) return [
                                                0
                                            ];
                                            for(var r = t1[0].length, n = [
                                                t1[0]
                                            ], a = [
                                                0
                                            ], o = 1; o < e1; ++o)if (n.push(t1[o]), i(n, r)) {
                                                if (a.push(o), a.length === r + 1) return a;
                                            } else n.pop();
                                            return a;
                                        };
                                        var n = t1("robust-orientation");
                                        function i(t1, e1) {
                                            for(var r = new Array(e1 + 1), i = 0; i < t1.length; ++i)r[i] = t1[i];
                                            for(i = 0; i <= t1.length; ++i){
                                                for(var a = t1.length; a <= e1; ++a){
                                                    for(var o = new Array(e1), s = 0; s < e1; ++s)o[s] = Math.pow(a + 1 - i, s);
                                                    r[a] = o;
                                                }
                                                if (n.apply(void 0, r)) return !0;
                                            }
                                            return !1;
                                        }
                                    },
                                    {
                                        "robust-orientation": 284
                                    }
                                ],
                                11: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            return n(e1).filter(function(r) {
                                                for(var n = new Array(r.length), a = 0; a < r.length; ++a)n[a] = e1[r[a]];
                                                return i(n) * t1 < 1;
                                            });
                                        };
                                        var n = t1("delaunay-triangulate"), i = t1("circumradius");
                                    },
                                    {
                                        circumradius: 49,
                                        "delaunay-triangulate": 63
                                    }
                                ],
                                12: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return i(n(t1, e1));
                                        };
                                        var n = t1("alpha-complex"), i = t1("simplicial-complex-boundary");
                                    },
                                    {
                                        "alpha-complex": 11,
                                        "simplicial-complex-boundary": 290
                                    }
                                ],
                                13: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            return atob(t1);
                                        };
                                    },
                                    {}
                                ],
                                14: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            for(var r = e1.length, a = new Array(r + 1), o = 0; o < r; ++o){
                                                for(var s = new Array(r + 1), l = 0; l <= r; ++l)s[l] = t1[l][o];
                                                a[o] = s;
                                            }
                                            a[r] = new Array(r + 1);
                                            for(o = 0; o <= r; ++o)a[r][o] = 1;
                                            var c = new Array(r + 1);
                                            for(o = 0; o < r; ++o)c[o] = e1[o];
                                            c[r] = 1;
                                            var u = n(a, c), f = i(u[r + 1]);
                                            0 === f && (f = 1);
                                            var h = new Array(r + 1);
                                            for(o = 0; o <= r; ++o)h[o] = i(u[o]) / f;
                                            return h;
                                        };
                                        var n = t1("robust-linear-solve");
                                        function i(t1) {
                                            for(var e1 = 0, r = 0; r < t1.length; ++r)e1 += t1[r];
                                            return e1;
                                        }
                                    },
                                    {
                                        "robust-linear-solve": 283
                                    }
                                ],
                                15: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./lib/rationalize");
                                        e1.exports = function(t1, e1) {
                                            return n(t1[0].mul(e1[1]).add(e1[0].mul(t1[1])), t1[1].mul(e1[1]));
                                        };
                                    },
                                    {
                                        "./lib/rationalize": 25
                                    }
                                ],
                                16: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            return t1[0].mul(e1[1]).cmp(e1[0].mul(t1[1]));
                                        };
                                    },
                                    {}
                                ],
                                17: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./lib/rationalize");
                                        e1.exports = function(t1, e1) {
                                            return n(t1[0].mul(e1[1]), t1[1].mul(e1[0]));
                                        };
                                    },
                                    {
                                        "./lib/rationalize": 25
                                    }
                                ],
                                18: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./is-rat"), i = t1("./lib/is-bn"), a = t1("./lib/num-to-bn"), o = t1("./lib/str-to-bn"), s = t1("./lib/rationalize"), l = t1("./div");
                                        e1.exports = function t1(e1, r) {
                                            if (n(e1)) return r ? l(e1, t1(r)) : [
                                                e1[0].clone(),
                                                e1[1].clone()
                                            ];
                                            var c, u, f = 0;
                                            if (i(e1)) c = e1.clone();
                                            else if ("string" == typeof e1) c = o(e1);
                                            else {
                                                if (0 === e1) return [
                                                    a(0),
                                                    a(1)
                                                ];
                                                if (e1 === Math.floor(e1)) c = a(e1);
                                                else {
                                                    for(; e1 !== Math.floor(e1);)e1 *= Math.pow(2, 256), f -= 256;
                                                    c = a(e1);
                                                }
                                            }
                                            if (n(r)) c.mul(r[1]), u = r[0].clone();
                                            else if (i(r)) u = r.clone();
                                            else if ("string" == typeof r) u = o(r);
                                            else if (r) {
                                                if (r === Math.floor(r)) u = a(r);
                                                else {
                                                    for(; r !== Math.floor(r);)r *= Math.pow(2, 256), f += 256;
                                                    u = a(r);
                                                }
                                            } else u = a(1);
                                            f > 0 ? c = c.ushln(f) : f < 0 && (u = u.ushln(-f));
                                            return s(c, u);
                                        };
                                    },
                                    {
                                        "./div": 17,
                                        "./is-rat": 19,
                                        "./lib/is-bn": 23,
                                        "./lib/num-to-bn": 24,
                                        "./lib/rationalize": 25,
                                        "./lib/str-to-bn": 26
                                    }
                                ],
                                19: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./lib/is-bn");
                                        e1.exports = function(t1) {
                                            return Array.isArray(t1) && 2 === t1.length && n(t1[0]) && n(t1[1]);
                                        };
                                    },
                                    {
                                        "./lib/is-bn": 23
                                    }
                                ],
                                20: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("bn.js");
                                        e1.exports = function(t1) {
                                            return t1.cmp(new n(0));
                                        };
                                    },
                                    {
                                        "bn.js": 33
                                    }
                                ],
                                21: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./bn-sign");
                                        e1.exports = function(t1) {
                                            var e1 = t1.length, r = t1.words, i = 0;
                                            if (1 === e1) i = r[0];
                                            else if (2 === e1) i = r[0] + 67108864 * r[1];
                                            else for(var a = 0; a < e1; a++){
                                                var o = r[a];
                                                i += o * Math.pow(67108864, a);
                                            }
                                            return n(t1) * i;
                                        };
                                    },
                                    {
                                        "./bn-sign": 20
                                    }
                                ],
                                22: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("double-bits"), i = t1("bit-twiddle").countTrailingZeros;
                                        e1.exports = function(t1) {
                                            var e1 = i(n.lo(t1));
                                            if (e1 < 32) return e1;
                                            var r = i(n.hi(t1));
                                            if (r > 20) return 52;
                                            return r + 32;
                                        };
                                    },
                                    {
                                        "bit-twiddle": 32,
                                        "double-bits": 64
                                    }
                                ],
                                23: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        t1("bn.js");
                                        e1.exports = function(t1) {
                                            return t1 && "object" == typeof t1 && Boolean(t1.words);
                                        };
                                    },
                                    {
                                        "bn.js": 33
                                    }
                                ],
                                24: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("bn.js"), i = t1("double-bits");
                                        e1.exports = function(t1) {
                                            var e1 = i.exponent(t1);
                                            return e1 < 52 ? new n(t1) : new n(t1 * Math.pow(2, 52 - e1)).ushln(e1 - 52);
                                        };
                                    },
                                    {
                                        "bn.js": 33,
                                        "double-bits": 64
                                    }
                                ],
                                25: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./num-to-bn"), i = t1("./bn-sign");
                                        e1.exports = function(t1, e1) {
                                            var r = i(t1), a = i(e1);
                                            if (0 === r) return [
                                                n(0),
                                                n(1)
                                            ];
                                            if (0 === a) return [
                                                n(0),
                                                n(0)
                                            ];
                                            a < 0 && (t1 = t1.neg(), e1 = e1.neg());
                                            var o = t1.gcd(e1);
                                            if (o.cmpn(1)) return [
                                                t1.div(o),
                                                e1.div(o)
                                            ];
                                            return [
                                                t1,
                                                e1
                                            ];
                                        };
                                    },
                                    {
                                        "./bn-sign": 20,
                                        "./num-to-bn": 24
                                    }
                                ],
                                26: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("bn.js");
                                        e1.exports = function(t1) {
                                            return new n(t1);
                                        };
                                    },
                                    {
                                        "bn.js": 33
                                    }
                                ],
                                27: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./lib/rationalize");
                                        e1.exports = function(t1, e1) {
                                            return n(t1[0].mul(e1[0]), t1[1].mul(e1[1]));
                                        };
                                    },
                                    {
                                        "./lib/rationalize": 25
                                    }
                                ],
                                28: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./lib/bn-sign");
                                        e1.exports = function(t1) {
                                            return n(t1[0]) * n(t1[1]);
                                        };
                                    },
                                    {
                                        "./lib/bn-sign": 20
                                    }
                                ],
                                29: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./lib/rationalize");
                                        e1.exports = function(t1, e1) {
                                            return n(t1[0].mul(e1[1]).sub(t1[1].mul(e1[0])), t1[1].mul(e1[1]));
                                        };
                                    },
                                    {
                                        "./lib/rationalize": 25
                                    }
                                ],
                                30: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./lib/bn-to-num"), i = t1("./lib/ctz");
                                        e1.exports = function(t1) {
                                            var e1 = t1[0], r = t1[1];
                                            if (0 === e1.cmpn(0)) return 0;
                                            var a = e1.abs().divmod(r.abs()), o = a.div, s = n(o), l = a.mod, c = e1.negative !== r.negative ? -1 : 1;
                                            if (0 === l.cmpn(0)) return c * s;
                                            if (s) {
                                                var u = i(s) + 4, f = n(l.ushln(u).divRound(r));
                                                return c * (s + f * Math.pow(2, -u));
                                            }
                                            var h = r.bitLength() - l.bitLength() + 53;
                                            f = n(l.ushln(h).divRound(r));
                                            return h < 1023 ? c * f * Math.pow(2, -h) : (f *= Math.pow(2, -1023), c * f * Math.pow(2, 1023 - h));
                                        };
                                    },
                                    {
                                        "./lib/bn-to-num": 21,
                                        "./lib/ctz": 22
                                    }
                                ],
                                31: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        function n(t1, e1, r, n, i) {
                                            for(var a = i + 1; n <= i;){
                                                var o = n + i >>> 1, s = t1[o];
                                                (void 0 !== r ? r(s, e1) : s - e1) >= 0 ? (a = o, i = o - 1) : n = o + 1;
                                            }
                                            return a;
                                        }
                                        function i(t1, e1, r, n, i) {
                                            for(var a = i + 1; n <= i;){
                                                var o = n + i >>> 1, s = t1[o];
                                                (void 0 !== r ? r(s, e1) : s - e1) > 0 ? (a = o, i = o - 1) : n = o + 1;
                                            }
                                            return a;
                                        }
                                        function a(t1, e1, r, n, i) {
                                            for(var a = n - 1; n <= i;){
                                                var o = n + i >>> 1, s = t1[o];
                                                (void 0 !== r ? r(s, e1) : s - e1) < 0 ? (a = o, n = o + 1) : i = o - 1;
                                            }
                                            return a;
                                        }
                                        function o(t1, e1, r, n, i) {
                                            for(var a = n - 1; n <= i;){
                                                var o = n + i >>> 1, s = t1[o];
                                                (void 0 !== r ? r(s, e1) : s - e1) <= 0 ? (a = o, n = o + 1) : i = o - 1;
                                            }
                                            return a;
                                        }
                                        function s(t1, e1, r, n, i) {
                                            for(; n <= i;){
                                                var a = n + i >>> 1, o = t1[a], s = void 0 !== r ? r(o, e1) : o - e1;
                                                if (0 === s) return a;
                                                s <= 0 ? n = a + 1 : i = a - 1;
                                            }
                                            return -1;
                                        }
                                        function l(t1, e1, r, n, i, a) {
                                            return "function" == typeof r ? a(t1, e1, r, void 0 === n ? 0 : 0 | n, void 0 === i ? t1.length - 1 : 0 | i) : a(t1, e1, void 0, void 0 === r ? 0 : 0 | r, void 0 === n ? t1.length - 1 : 0 | n);
                                        }
                                        e1.exports = {
                                            ge: function(t1, e1, r, i, a) {
                                                return l(t1, e1, r, i, a, n);
                                            },
                                            gt: function(t1, e1, r, n, a) {
                                                return l(t1, e1, r, n, a, i);
                                            },
                                            lt: function(t1, e1, r, n, i) {
                                                return l(t1, e1, r, n, i, a);
                                            },
                                            le: function(t1, e1, r, n, i) {
                                                return l(t1, e1, r, n, i, o);
                                            },
                                            eq: function(t1, e1, r, n, i) {
                                                return l(t1, e1, r, n, i, s);
                                            }
                                        };
                                    },
                                    {}
                                ],
                                32: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        function n(t1) {
                                            var e1 = 32;
                                            return (t1 &= -t1) && e1--, 65535 & t1 && (e1 -= 16), 16711935 & t1 && (e1 -= 8), 252645135 & t1 && (e1 -= 4), 858993459 & t1 && (e1 -= 2), 1431655765 & t1 && (e1 -= 1), e1;
                                        }
                                        r.INT_BITS = 32, r.INT_MAX = 2147483647, r.INT_MIN = -2147483648, r.sign = function(t1) {
                                            return (t1 > 0) - (t1 < 0);
                                        }, r.abs = function(t1) {
                                            var e1 = t1 >> 31;
                                            return (t1 ^ e1) - e1;
                                        }, r.min = function(t1, e1) {
                                            return e1 ^ (t1 ^ e1) & -(t1 < e1);
                                        }, r.max = function(t1, e1) {
                                            return t1 ^ (t1 ^ e1) & -(t1 < e1);
                                        }, r.isPow2 = function(t1) {
                                            return !(t1 & t1 - 1 || !t1);
                                        }, r.log2 = function(t1) {
                                            var e1, r;
                                            return e1 = (t1 > 65535) << 4, e1 |= r = ((t1 >>>= e1) > 255) << 3, e1 |= r = ((t1 >>>= r) > 15) << 2, (e1 |= r = ((t1 >>>= r) > 3) << 1) | (t1 >>>= r) >> 1;
                                        }, r.log10 = function(t1) {
                                            return t1 >= 1e9 ? 9 : t1 >= 1e8 ? 8 : t1 >= 1e7 ? 7 : t1 >= 1e6 ? 6 : t1 >= 1e5 ? 5 : t1 >= 1e4 ? 4 : t1 >= 1e3 ? 3 : t1 >= 100 ? 2 : t1 >= 10 ? 1 : 0;
                                        }, r.popCount = function(t1) {
                                            return 16843009 * ((t1 = (858993459 & (t1 -= t1 >>> 1 & 1431655765)) + (t1 >>> 2 & 858993459)) + (t1 >>> 4) & 252645135) >>> 24;
                                        }, r.countTrailingZeros = n, r.nextPow2 = function(t1) {
                                            return t1 += 0 === t1, --t1, t1 |= t1 >>> 1, t1 |= t1 >>> 2, t1 |= t1 >>> 4, t1 |= t1 >>> 8, (t1 |= t1 >>> 16) + 1;
                                        }, r.prevPow2 = function(t1) {
                                            return t1 |= t1 >>> 1, t1 |= t1 >>> 2, t1 |= t1 >>> 4, t1 |= t1 >>> 8, (t1 |= t1 >>> 16) - (t1 >>> 1);
                                        }, r.parity = function(t1) {
                                            return t1 ^= t1 >>> 16, t1 ^= t1 >>> 8, t1 ^= t1 >>> 4, 27030 >>> (t1 &= 15) & 1;
                                        };
                                        var i = new Array(256);
                                        !function(t1) {
                                            for(var e1 = 0; e1 < 256; ++e1){
                                                var r = e1, n = e1, i = 7;
                                                for(r >>>= 1; r; r >>>= 1)n <<= 1, n |= 1 & r, --i;
                                                t1[e1] = n << i & 255;
                                            }
                                        }(i), r.reverse = function(t1) {
                                            return i[255 & t1] << 24 | i[t1 >>> 8 & 255] << 16 | i[t1 >>> 16 & 255] << 8 | i[t1 >>> 24 & 255];
                                        }, r.interleave2 = function(t1, e1) {
                                            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 &= 65535) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 &= 65535) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
                                        }, r.deinterleave2 = function(t1, e1) {
                                            return (t1 = 65535 & ((t1 = 16711935 & ((t1 = 252645135 & ((t1 = 858993459 & ((t1 = t1 >>> e1 & 1431655765) | t1 >>> 1)) | t1 >>> 2)) | t1 >>> 4)) | t1 >>> 16)) << 16 >> 16;
                                        }, r.interleave3 = function(t1, e1, r) {
                                            return t1 = 1227133513 & ((t1 = 3272356035 & ((t1 = 251719695 & ((t1 = 4278190335 & ((t1 &= 1023) | t1 << 16)) | t1 << 8)) | t1 << 4)) | t1 << 2), (t1 |= (e1 = 1227133513 & ((e1 = 3272356035 & ((e1 = 251719695 & ((e1 = 4278190335 & ((e1 &= 1023) | e1 << 16)) | e1 << 8)) | e1 << 4)) | e1 << 2)) << 1) | (r = 1227133513 & ((r = 3272356035 & ((r = 251719695 & ((r = 4278190335 & ((r &= 1023) | r << 16)) | r << 8)) | r << 4)) | r << 2)) << 2;
                                        }, r.deinterleave3 = function(t1, e1) {
                                            return (t1 = 1023 & ((t1 = 4278190335 & ((t1 = 251719695 & ((t1 = 3272356035 & ((t1 = t1 >>> e1 & 1227133513) | t1 >>> 2)) | t1 >>> 4)) | t1 >>> 8)) | t1 >>> 16)) << 22 >> 22;
                                        }, r.nextCombination = function(t1) {
                                            var e1 = t1 | t1 - 1;
                                            return e1 + 1 | (~e1 & -~e1) - 1 >>> n(t1) + 1;
                                        };
                                    },
                                    {}
                                ],
                                33: [
                                    function(t1, e1, r) {
                                        !function(e1, r) {
                                            "use strict";
                                            function n(t1, e1) {
                                                if (!t1) throw new Error(e1 || "Assertion failed");
                                            }
                                            function i(t1, e1) {
                                                t1.super_ = e1;
                                                var r = function() {};
                                                r.prototype = e1.prototype, t1.prototype = new r, t1.prototype.constructor = t1;
                                            }
                                            function a(t1, e1, r) {
                                                if (a.isBN(t1)) return t1;
                                                this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== t1 && ("le" !== e1 && "be" !== e1 || (r = e1, e1 = 10), this._init(t1 || 0, e1 || 10, r || "be"));
                                            }
                                            var o;
                                            "object" == typeof e1 ? e1.exports = a : r.BN = a, a.BN = a, a.wordSize = 26;
                                            try {
                                                o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : t1("buffer").Buffer;
                                            } catch (t1) {}
                                            function s(t1, e1) {
                                                var r = t1.charCodeAt(e1);
                                                return r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : r - 48 & 15;
                                            }
                                            function l(t1, e1, r) {
                                                var n = s(t1, r);
                                                return r - 1 >= e1 && (n |= s(t1, r - 1) << 4), n;
                                            }
                                            function c(t1, e1, r, n) {
                                                for(var i = 0, a = Math.min(t1.length, r), o = e1; o < a; o++){
                                                    var s = t1.charCodeAt(o) - 48;
                                                    i *= n, i += s >= 49 ? s - 49 + 10 : s >= 17 ? s - 17 + 10 : s;
                                                }
                                                return i;
                                            }
                                            a.isBN = function(t1) {
                                                return t1 instanceof a || null !== t1 && "object" == typeof t1 && t1.constructor.wordSize === a.wordSize && Array.isArray(t1.words);
                                            }, a.max = function(t1, e1) {
                                                return t1.cmp(e1) > 0 ? t1 : e1;
                                            }, a.min = function(t1, e1) {
                                                return t1.cmp(e1) < 0 ? t1 : e1;
                                            }, a.prototype._init = function(t1, e1, r) {
                                                if ("number" == typeof t1) return this._initNumber(t1, e1, r);
                                                if ("object" == typeof t1) return this._initArray(t1, e1, r);
                                                "hex" === e1 && (e1 = 16), n(e1 === (0 | e1) && e1 >= 2 && e1 <= 36);
                                                var i = 0;
                                                "-" === (t1 = t1.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < t1.length && (16 === e1 ? this._parseHex(t1, i, r) : (this._parseBase(t1, e1, i), "le" === r && this._initArray(this.toArray(), e1, r)));
                                            }, a.prototype._initNumber = function(t1, e1, r) {
                                                t1 < 0 && (this.negative = 1, t1 = -t1), t1 < 67108864 ? (this.words = [
                                                    67108863 & t1
                                                ], this.length = 1) : t1 < 4503599627370496 ? (this.words = [
                                                    67108863 & t1,
                                                    t1 / 67108864 & 67108863
                                                ], this.length = 2) : (n(t1 < 9007199254740992), this.words = [
                                                    67108863 & t1,
                                                    t1 / 67108864 & 67108863,
                                                    1
                                                ], this.length = 3), "le" === r && this._initArray(this.toArray(), e1, r);
                                            }, a.prototype._initArray = function(t1, e1, r) {
                                                if (n("number" == typeof t1.length), t1.length <= 0) return this.words = [
                                                    0
                                                ], this.length = 1, this;
                                                this.length = Math.ceil(t1.length / 3), this.words = new Array(this.length);
                                                for(var i = 0; i < this.length; i++)this.words[i] = 0;
                                                var a, o, s = 0;
                                                if ("be" === r) for(i = t1.length - 1, a = 0; i >= 0; i -= 3)o = t1[i] | t1[i - 1] << 8 | t1[i - 2] << 16, this.words[a] |= o << s & 67108863, this.words[a + 1] = o >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, a++);
                                                else if ("le" === r) for(i = 0, a = 0; i < t1.length; i += 3)o = t1[i] | t1[i + 1] << 8 | t1[i + 2] << 16, this.words[a] |= o << s & 67108863, this.words[a + 1] = o >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, a++);
                                                return this.strip();
                                            }, a.prototype._parseHex = function(t1, e1, r) {
                                                this.length = Math.ceil((t1.length - e1) / 6), this.words = new Array(this.length);
                                                for(var n = 0; n < this.length; n++)this.words[n] = 0;
                                                var i, a = 0, o = 0;
                                                if ("be" === r) for(n = t1.length - 1; n >= e1; n -= 2)i = l(t1, e1, n) << a, this.words[o] |= 67108863 & i, a >= 18 ? (a -= 18, o += 1, this.words[o] |= i >>> 26) : a += 8;
                                                else for(n = (t1.length - e1) % 2 == 0 ? e1 + 1 : e1; n < t1.length; n += 2)i = l(t1, e1, n) << a, this.words[o] |= 67108863 & i, a >= 18 ? (a -= 18, o += 1, this.words[o] |= i >>> 26) : a += 8;
                                                this.strip();
                                            }, a.prototype._parseBase = function(t1, e1, r) {
                                                this.words = [
                                                    0
                                                ], this.length = 1;
                                                for(var n = 0, i = 1; i <= 67108863; i *= e1)n++;
                                                n--, i = i / e1 | 0;
                                                for(var a = t1.length - r, o = a % n, s = Math.min(a, a - o) + r, l = 0, u = r; u < s; u += n)l = c(t1, u, u + n, e1), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                                                if (0 !== o) {
                                                    var f = 1;
                                                    for(l = c(t1, u, t1.length, e1), u = 0; u < o; u++)f *= e1;
                                                    this.imuln(f), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                                                }
                                                this.strip();
                                            }, a.prototype.copy = function(t1) {
                                                t1.words = new Array(this.length);
                                                for(var e1 = 0; e1 < this.length; e1++)t1.words[e1] = this.words[e1];
                                                t1.length = this.length, t1.negative = this.negative, t1.red = this.red;
                                            }, a.prototype.clone = function() {
                                                var t1 = new a(null);
                                                return this.copy(t1), t1;
                                            }, a.prototype._expand = function(t1) {
                                                for(; this.length < t1;)this.words[this.length++] = 0;
                                                return this;
                                            }, a.prototype.strip = function() {
                                                for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                                                return this._normSign();
                                            }, a.prototype._normSign = function() {
                                                return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                                            }, a.prototype.inspect = function() {
                                                return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                                            };
                                            var u = [
                                                "",
                                                "0",
                                                "00",
                                                "000",
                                                "0000",
                                                "00000",
                                                "000000",
                                                "0000000",
                                                "00000000",
                                                "000000000",
                                                "0000000000",
                                                "00000000000",
                                                "000000000000",
                                                "0000000000000",
                                                "00000000000000",
                                                "000000000000000",
                                                "0000000000000000",
                                                "00000000000000000",
                                                "000000000000000000",
                                                "0000000000000000000",
                                                "00000000000000000000",
                                                "000000000000000000000",
                                                "0000000000000000000000",
                                                "00000000000000000000000",
                                                "000000000000000000000000",
                                                "0000000000000000000000000"
                                            ], f = [
                                                0,
                                                0,
                                                25,
                                                16,
                                                12,
                                                11,
                                                10,
                                                9,
                                                8,
                                                8,
                                                7,
                                                7,
                                                7,
                                                7,
                                                6,
                                                6,
                                                6,
                                                6,
                                                6,
                                                6,
                                                6,
                                                5,
                                                5,
                                                5,
                                                5,
                                                5,
                                                5,
                                                5,
                                                5,
                                                5,
                                                5,
                                                5,
                                                5,
                                                5,
                                                5,
                                                5,
                                                5
                                            ], h = [
                                                0,
                                                0,
                                                33554432,
                                                43046721,
                                                16777216,
                                                48828125,
                                                60466176,
                                                40353607,
                                                16777216,
                                                43046721,
                                                1e7,
                                                19487171,
                                                35831808,
                                                62748517,
                                                7529536,
                                                11390625,
                                                16777216,
                                                24137569,
                                                34012224,
                                                47045881,
                                                64e6,
                                                4084101,
                                                5153632,
                                                6436343,
                                                7962624,
                                                9765625,
                                                11881376,
                                                14348907,
                                                17210368,
                                                20511149,
                                                243e5,
                                                28629151,
                                                33554432,
                                                39135393,
                                                45435424,
                                                52521875,
                                                60466176
                                            ];
                                            function p(t1, e1, r) {
                                                r.negative = e1.negative ^ t1.negative;
                                                var n = t1.length + e1.length | 0;
                                                r.length = n, n = n - 1 | 0;
                                                var i = 0 | t1.words[0], a = 0 | e1.words[0], o = i * a, s = 67108863 & o, l = o / 67108864 | 0;
                                                r.words[0] = s;
                                                for(var c = 1; c < n; c++){
                                                    for(var u = l >>> 26, f = 67108863 & l, h = Math.min(c, e1.length - 1), p = Math.max(0, c - t1.length + 1); p <= h; p++){
                                                        var d = c - p | 0;
                                                        u += (o = (i = 0 | t1.words[d]) * (a = 0 | e1.words[p]) + f) / 67108864 | 0, f = 67108863 & o;
                                                    }
                                                    r.words[c] = 0 | f, l = 0 | u;
                                                }
                                                return 0 !== l ? r.words[c] = 0 | l : r.length--, r.strip();
                                            }
                                            a.prototype.toString = function(t1, e1) {
                                                var r;
                                                if (e1 = 0 | e1 || 1, 16 === (t1 = t1 || 10) || "hex" === t1) {
                                                    r = "";
                                                    for(var i = 0, a = 0, o = 0; o < this.length; o++){
                                                        var s = this.words[o], l = (16777215 & (s << i | a)).toString(16);
                                                        r = 0 !== (a = s >>> 24 - i & 16777215) || o !== this.length - 1 ? u[6 - l.length] + l + r : l + r, (i += 2) >= 26 && (i -= 26, o--);
                                                    }
                                                    for(0 !== a && (r = a.toString(16) + r); r.length % e1 != 0;)r = "0" + r;
                                                    return 0 !== this.negative && (r = "-" + r), r;
                                                }
                                                if (t1 === (0 | t1) && t1 >= 2 && t1 <= 36) {
                                                    var c = f[t1], p = h[t1];
                                                    r = "";
                                                    var d = this.clone();
                                                    for(d.negative = 0; !d.isZero();){
                                                        var m = d.modn(p).toString(t1);
                                                        r = (d = d.idivn(p)).isZero() ? m + r : u[c - m.length] + m + r;
                                                    }
                                                    for(this.isZero() && (r = "0" + r); r.length % e1 != 0;)r = "0" + r;
                                                    return 0 !== this.negative && (r = "-" + r), r;
                                                }
                                                n(!1, "Base should be between 2 and 36");
                                            }, a.prototype.toNumber = function() {
                                                var t1 = this.words[0];
                                                return 2 === this.length ? t1 += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? t1 += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -t1 : t1;
                                            }, a.prototype.toJSON = function() {
                                                return this.toString(16);
                                            }, a.prototype.toBuffer = function(t1, e1) {
                                                return n(void 0 !== o), this.toArrayLike(o, t1, e1);
                                            }, a.prototype.toArray = function(t1, e1) {
                                                return this.toArrayLike(Array, t1, e1);
                                            }, a.prototype.toArrayLike = function(t1, e1, r) {
                                                var i = this.byteLength(), a = r || Math.max(1, i);
                                                n(i <= a, "byte array longer than desired length"), n(a > 0, "Requested array length <= 0"), this.strip();
                                                var o, s, l = "le" === e1, c = new t1(a), u = this.clone();
                                                if (l) {
                                                    for(s = 0; !u.isZero(); s++)o = u.andln(255), u.iushrn(8), c[s] = o;
                                                    for(; s < a; s++)c[s] = 0;
                                                } else {
                                                    for(s = 0; s < a - i; s++)c[s] = 0;
                                                    for(s = 0; !u.isZero(); s++)o = u.andln(255), u.iushrn(8), c[a - s - 1] = o;
                                                }
                                                return c;
                                            }, Math.clz32 ? a.prototype._countBits = function(t1) {
                                                return 32 - Math.clz32(t1);
                                            } : a.prototype._countBits = function(t1) {
                                                var e1 = t1, r = 0;
                                                return e1 >= 4096 && (r += 13, e1 >>>= 13), e1 >= 64 && (r += 7, e1 >>>= 7), e1 >= 8 && (r += 4, e1 >>>= 4), e1 >= 2 && (r += 2, e1 >>>= 2), r + e1;
                                            }, a.prototype._zeroBits = function(t1) {
                                                if (0 === t1) return 26;
                                                var e1 = t1, r = 0;
                                                return 0 == (8191 & e1) && (r += 13, e1 >>>= 13), 0 == (127 & e1) && (r += 7, e1 >>>= 7), 0 == (15 & e1) && (r += 4, e1 >>>= 4), 0 == (3 & e1) && (r += 2, e1 >>>= 2), 0 == (1 & e1) && r++, r;
                                            }, a.prototype.bitLength = function() {
                                                var t1 = this.words[this.length - 1], e1 = this._countBits(t1);
                                                return 26 * (this.length - 1) + e1;
                                            }, a.prototype.zeroBits = function() {
                                                if (this.isZero()) return 0;
                                                for(var t1 = 0, e1 = 0; e1 < this.length; e1++){
                                                    var r = this._zeroBits(this.words[e1]);
                                                    if (t1 += r, 26 !== r) break;
                                                }
                                                return t1;
                                            }, a.prototype.byteLength = function() {
                                                return Math.ceil(this.bitLength() / 8);
                                            }, a.prototype.toTwos = function(t1) {
                                                return 0 !== this.negative ? this.abs().inotn(t1).iaddn(1) : this.clone();
                                            }, a.prototype.fromTwos = function(t1) {
                                                return this.testn(t1 - 1) ? this.notn(t1).iaddn(1).ineg() : this.clone();
                                            }, a.prototype.isNeg = function() {
                                                return 0 !== this.negative;
                                            }, a.prototype.neg = function() {
                                                return this.clone().ineg();
                                            }, a.prototype.ineg = function() {
                                                return this.isZero() || (this.negative ^= 1), this;
                                            }, a.prototype.iuor = function(t1) {
                                                for(; this.length < t1.length;)this.words[this.length++] = 0;
                                                for(var e1 = 0; e1 < t1.length; e1++)this.words[e1] = this.words[e1] | t1.words[e1];
                                                return this.strip();
                                            }, a.prototype.ior = function(t1) {
                                                return n(0 == (this.negative | t1.negative)), this.iuor(t1);
                                            }, a.prototype.or = function(t1) {
                                                return this.length > t1.length ? this.clone().ior(t1) : t1.clone().ior(this);
                                            }, a.prototype.uor = function(t1) {
                                                return this.length > t1.length ? this.clone().iuor(t1) : t1.clone().iuor(this);
                                            }, a.prototype.iuand = function(t1) {
                                                var e1;
                                                e1 = this.length > t1.length ? t1 : this;
                                                for(var r = 0; r < e1.length; r++)this.words[r] = this.words[r] & t1.words[r];
                                                return this.length = e1.length, this.strip();
                                            }, a.prototype.iand = function(t1) {
                                                return n(0 == (this.negative | t1.negative)), this.iuand(t1);
                                            }, a.prototype.and = function(t1) {
                                                return this.length > t1.length ? this.clone().iand(t1) : t1.clone().iand(this);
                                            }, a.prototype.uand = function(t1) {
                                                return this.length > t1.length ? this.clone().iuand(t1) : t1.clone().iuand(this);
                                            }, a.prototype.iuxor = function(t1) {
                                                var e1, r;
                                                this.length > t1.length ? (e1 = this, r = t1) : (e1 = t1, r = this);
                                                for(var n = 0; n < r.length; n++)this.words[n] = e1.words[n] ^ r.words[n];
                                                if (this !== e1) for(; n < e1.length; n++)this.words[n] = e1.words[n];
                                                return this.length = e1.length, this.strip();
                                            }, a.prototype.ixor = function(t1) {
                                                return n(0 == (this.negative | t1.negative)), this.iuxor(t1);
                                            }, a.prototype.xor = function(t1) {
                                                return this.length > t1.length ? this.clone().ixor(t1) : t1.clone().ixor(this);
                                            }, a.prototype.uxor = function(t1) {
                                                return this.length > t1.length ? this.clone().iuxor(t1) : t1.clone().iuxor(this);
                                            }, a.prototype.inotn = function(t1) {
                                                n("number" == typeof t1 && t1 >= 0);
                                                var e1 = 0 | Math.ceil(t1 / 26), r = t1 % 26;
                                                this._expand(e1), r > 0 && e1--;
                                                for(var i = 0; i < e1; i++)this.words[i] = 67108863 & ~this.words[i];
                                                return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
                                            }, a.prototype.notn = function(t1) {
                                                return this.clone().inotn(t1);
                                            }, a.prototype.setn = function(t1, e1) {
                                                n("number" == typeof t1 && t1 >= 0);
                                                var r = t1 / 26 | 0, i = t1 % 26;
                                                return this._expand(r + 1), this.words[r] = e1 ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
                                            }, a.prototype.iadd = function(t1) {
                                                var e1, r, n;
                                                if (0 !== this.negative && 0 === t1.negative) return this.negative = 0, e1 = this.isub(t1), this.negative ^= 1, this._normSign();
                                                if (0 === this.negative && 0 !== t1.negative) return t1.negative = 0, e1 = this.isub(t1), t1.negative = 1, e1._normSign();
                                                this.length > t1.length ? (r = this, n = t1) : (r = t1, n = this);
                                                for(var i = 0, a = 0; a < n.length; a++)e1 = (0 | r.words[a]) + (0 | n.words[a]) + i, this.words[a] = 67108863 & e1, i = e1 >>> 26;
                                                for(; 0 !== i && a < r.length; a++)e1 = (0 | r.words[a]) + i, this.words[a] = 67108863 & e1, i = e1 >>> 26;
                                                if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                                                else if (r !== this) for(; a < r.length; a++)this.words[a] = r.words[a];
                                                return this;
                                            }, a.prototype.add = function(t1) {
                                                var e1;
                                                return 0 !== t1.negative && 0 === this.negative ? (t1.negative = 0, e1 = this.sub(t1), t1.negative ^= 1, e1) : 0 === t1.negative && 0 !== this.negative ? (this.negative = 0, e1 = t1.sub(this), this.negative = 1, e1) : this.length > t1.length ? this.clone().iadd(t1) : t1.clone().iadd(this);
                                            }, a.prototype.isub = function(t1) {
                                                if (0 !== t1.negative) {
                                                    t1.negative = 0;
                                                    var e1 = this.iadd(t1);
                                                    return t1.negative = 1, e1._normSign();
                                                }
                                                if (0 !== this.negative) return this.negative = 0, this.iadd(t1), this.negative = 1, this._normSign();
                                                var r, n, i = this.cmp(t1);
                                                if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                                                i > 0 ? (r = this, n = t1) : (r = t1, n = this);
                                                for(var a = 0, o = 0; o < n.length; o++)a = (e1 = (0 | r.words[o]) - (0 | n.words[o]) + a) >> 26, this.words[o] = 67108863 & e1;
                                                for(; 0 !== a && o < r.length; o++)a = (e1 = (0 | r.words[o]) + a) >> 26, this.words[o] = 67108863 & e1;
                                                if (0 === a && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                                                return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this.strip();
                                            }, a.prototype.sub = function(t1) {
                                                return this.clone().isub(t1);
                                            };
                                            var d = function(t1, e1, r) {
                                                var n, i, a, o = t1.words, s = e1.words, l = r.words, c = 0, u = 0 | o[0], f = 8191 & u, h = u >>> 13, p = 0 | o[1], d = 8191 & p, m = p >>> 13, g = 0 | o[2], v = 8191 & g, y = g >>> 13, x = 0 | o[3], b = 8191 & x, _ = x >>> 13, w = 0 | o[4], T = 8191 & w, k = w >>> 13, A = 0 | o[5], M = 8191 & A, S = A >>> 13, E = 0 | o[6], L = 8191 & E, C = E >>> 13, P = 0 | o[7], I = 8191 & P, O = P >>> 13, z = 0 | o[8], D = 8191 & z, R = z >>> 13, F = 0 | o[9], B = 8191 & F, N = F >>> 13, j = 0 | s[0], U = 8191 & j, V = j >>> 13, H = 0 | s[1], q = 8191 & H, G = H >>> 13, Y = 0 | s[2], W = 8191 & Y, X = Y >>> 13, Z = 0 | s[3], J = 8191 & Z, K = Z >>> 13, Q = 0 | s[4], $ = 8191 & Q, tt = Q >>> 13, et = 0 | s[5], rt = 8191 & et, nt = et >>> 13, it = 0 | s[6], at = 8191 & it, ot = it >>> 13, st = 0 | s[7], lt = 8191 & st, ct = st >>> 13, ut = 0 | s[8], ft = 8191 & ut, ht = ut >>> 13, pt = 0 | s[9], dt = 8191 & pt, mt = pt >>> 13;
                                                r.negative = t1.negative ^ e1.negative, r.length = 19;
                                                var gt = (c + (n = Math.imul(f, U)) | 0) + ((8191 & (i = (i = Math.imul(f, V)) + Math.imul(h, U) | 0)) << 13) | 0;
                                                c = ((a = Math.imul(h, V)) + (i >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, n = Math.imul(d, U), i = (i = Math.imul(d, V)) + Math.imul(m, U) | 0, a = Math.imul(m, V);
                                                var vt = (c + (n = n + Math.imul(f, q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, G) | 0) + Math.imul(h, q) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(h, G) | 0) + (i >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, n = Math.imul(v, U), i = (i = Math.imul(v, V)) + Math.imul(y, U) | 0, a = Math.imul(y, V), n = n + Math.imul(d, q) | 0, i = (i = i + Math.imul(d, G) | 0) + Math.imul(m, q) | 0, a = a + Math.imul(m, G) | 0;
                                                var yt = (c + (n = n + Math.imul(f, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, X) | 0) + Math.imul(h, W) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(h, X) | 0) + (i >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, n = Math.imul(b, U), i = (i = Math.imul(b, V)) + Math.imul(_, U) | 0, a = Math.imul(_, V), n = n + Math.imul(v, q) | 0, i = (i = i + Math.imul(v, G) | 0) + Math.imul(y, q) | 0, a = a + Math.imul(y, G) | 0, n = n + Math.imul(d, W) | 0, i = (i = i + Math.imul(d, X) | 0) + Math.imul(m, W) | 0, a = a + Math.imul(m, X) | 0;
                                                var xt = (c + (n = n + Math.imul(f, J) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, K) | 0) + Math.imul(h, J) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(h, K) | 0) + (i >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, n = Math.imul(T, U), i = (i = Math.imul(T, V)) + Math.imul(k, U) | 0, a = Math.imul(k, V), n = n + Math.imul(b, q) | 0, i = (i = i + Math.imul(b, G) | 0) + Math.imul(_, q) | 0, a = a + Math.imul(_, G) | 0, n = n + Math.imul(v, W) | 0, i = (i = i + Math.imul(v, X) | 0) + Math.imul(y, W) | 0, a = a + Math.imul(y, X) | 0, n = n + Math.imul(d, J) | 0, i = (i = i + Math.imul(d, K) | 0) + Math.imul(m, J) | 0, a = a + Math.imul(m, K) | 0;
                                                var bt = (c + (n = n + Math.imul(f, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, tt) | 0) + Math.imul(h, $) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(h, tt) | 0) + (i >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, n = Math.imul(M, U), i = (i = Math.imul(M, V)) + Math.imul(S, U) | 0, a = Math.imul(S, V), n = n + Math.imul(T, q) | 0, i = (i = i + Math.imul(T, G) | 0) + Math.imul(k, q) | 0, a = a + Math.imul(k, G) | 0, n = n + Math.imul(b, W) | 0, i = (i = i + Math.imul(b, X) | 0) + Math.imul(_, W) | 0, a = a + Math.imul(_, X) | 0, n = n + Math.imul(v, J) | 0, i = (i = i + Math.imul(v, K) | 0) + Math.imul(y, J) | 0, a = a + Math.imul(y, K) | 0, n = n + Math.imul(d, $) | 0, i = (i = i + Math.imul(d, tt) | 0) + Math.imul(m, $) | 0, a = a + Math.imul(m, tt) | 0;
                                                var _t = (c + (n = n + Math.imul(f, rt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, nt) | 0) + Math.imul(h, rt) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(h, nt) | 0) + (i >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863, n = Math.imul(L, U), i = (i = Math.imul(L, V)) + Math.imul(C, U) | 0, a = Math.imul(C, V), n = n + Math.imul(M, q) | 0, i = (i = i + Math.imul(M, G) | 0) + Math.imul(S, q) | 0, a = a + Math.imul(S, G) | 0, n = n + Math.imul(T, W) | 0, i = (i = i + Math.imul(T, X) | 0) + Math.imul(k, W) | 0, a = a + Math.imul(k, X) | 0, n = n + Math.imul(b, J) | 0, i = (i = i + Math.imul(b, K) | 0) + Math.imul(_, J) | 0, a = a + Math.imul(_, K) | 0, n = n + Math.imul(v, $) | 0, i = (i = i + Math.imul(v, tt) | 0) + Math.imul(y, $) | 0, a = a + Math.imul(y, tt) | 0, n = n + Math.imul(d, rt) | 0, i = (i = i + Math.imul(d, nt) | 0) + Math.imul(m, rt) | 0, a = a + Math.imul(m, nt) | 0;
                                                var wt = (c + (n = n + Math.imul(f, at) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, ot) | 0) + Math.imul(h, at) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(h, ot) | 0) + (i >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, n = Math.imul(I, U), i = (i = Math.imul(I, V)) + Math.imul(O, U) | 0, a = Math.imul(O, V), n = n + Math.imul(L, q) | 0, i = (i = i + Math.imul(L, G) | 0) + Math.imul(C, q) | 0, a = a + Math.imul(C, G) | 0, n = n + Math.imul(M, W) | 0, i = (i = i + Math.imul(M, X) | 0) + Math.imul(S, W) | 0, a = a + Math.imul(S, X) | 0, n = n + Math.imul(T, J) | 0, i = (i = i + Math.imul(T, K) | 0) + Math.imul(k, J) | 0, a = a + Math.imul(k, K) | 0, n = n + Math.imul(b, $) | 0, i = (i = i + Math.imul(b, tt) | 0) + Math.imul(_, $) | 0, a = a + Math.imul(_, tt) | 0, n = n + Math.imul(v, rt) | 0, i = (i = i + Math.imul(v, nt) | 0) + Math.imul(y, rt) | 0, a = a + Math.imul(y, nt) | 0, n = n + Math.imul(d, at) | 0, i = (i = i + Math.imul(d, ot) | 0) + Math.imul(m, at) | 0, a = a + Math.imul(m, ot) | 0;
                                                var Tt = (c + (n = n + Math.imul(f, lt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, ct) | 0) + Math.imul(h, lt) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(h, ct) | 0) + (i >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, n = Math.imul(D, U), i = (i = Math.imul(D, V)) + Math.imul(R, U) | 0, a = Math.imul(R, V), n = n + Math.imul(I, q) | 0, i = (i = i + Math.imul(I, G) | 0) + Math.imul(O, q) | 0, a = a + Math.imul(O, G) | 0, n = n + Math.imul(L, W) | 0, i = (i = i + Math.imul(L, X) | 0) + Math.imul(C, W) | 0, a = a + Math.imul(C, X) | 0, n = n + Math.imul(M, J) | 0, i = (i = i + Math.imul(M, K) | 0) + Math.imul(S, J) | 0, a = a + Math.imul(S, K) | 0, n = n + Math.imul(T, $) | 0, i = (i = i + Math.imul(T, tt) | 0) + Math.imul(k, $) | 0, a = a + Math.imul(k, tt) | 0, n = n + Math.imul(b, rt) | 0, i = (i = i + Math.imul(b, nt) | 0) + Math.imul(_, rt) | 0, a = a + Math.imul(_, nt) | 0, n = n + Math.imul(v, at) | 0, i = (i = i + Math.imul(v, ot) | 0) + Math.imul(y, at) | 0, a = a + Math.imul(y, ot) | 0, n = n + Math.imul(d, lt) | 0, i = (i = i + Math.imul(d, ct) | 0) + Math.imul(m, lt) | 0, a = a + Math.imul(m, ct) | 0;
                                                var kt = (c + (n = n + Math.imul(f, ft) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, ht) | 0) + Math.imul(h, ft) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(h, ht) | 0) + (i >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, n = Math.imul(B, U), i = (i = Math.imul(B, V)) + Math.imul(N, U) | 0, a = Math.imul(N, V), n = n + Math.imul(D, q) | 0, i = (i = i + Math.imul(D, G) | 0) + Math.imul(R, q) | 0, a = a + Math.imul(R, G) | 0, n = n + Math.imul(I, W) | 0, i = (i = i + Math.imul(I, X) | 0) + Math.imul(O, W) | 0, a = a + Math.imul(O, X) | 0, n = n + Math.imul(L, J) | 0, i = (i = i + Math.imul(L, K) | 0) + Math.imul(C, J) | 0, a = a + Math.imul(C, K) | 0, n = n + Math.imul(M, $) | 0, i = (i = i + Math.imul(M, tt) | 0) + Math.imul(S, $) | 0, a = a + Math.imul(S, tt) | 0, n = n + Math.imul(T, rt) | 0, i = (i = i + Math.imul(T, nt) | 0) + Math.imul(k, rt) | 0, a = a + Math.imul(k, nt) | 0, n = n + Math.imul(b, at) | 0, i = (i = i + Math.imul(b, ot) | 0) + Math.imul(_, at) | 0, a = a + Math.imul(_, ot) | 0, n = n + Math.imul(v, lt) | 0, i = (i = i + Math.imul(v, ct) | 0) + Math.imul(y, lt) | 0, a = a + Math.imul(y, ct) | 0, n = n + Math.imul(d, ft) | 0, i = (i = i + Math.imul(d, ht) | 0) + Math.imul(m, ft) | 0, a = a + Math.imul(m, ht) | 0;
                                                var At = (c + (n = n + Math.imul(f, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(f, mt) | 0) + Math.imul(h, dt) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(h, mt) | 0) + (i >>> 13) | 0) + (At >>> 26) | 0, At &= 67108863, n = Math.imul(B, q), i = (i = Math.imul(B, G)) + Math.imul(N, q) | 0, a = Math.imul(N, G), n = n + Math.imul(D, W) | 0, i = (i = i + Math.imul(D, X) | 0) + Math.imul(R, W) | 0, a = a + Math.imul(R, X) | 0, n = n + Math.imul(I, J) | 0, i = (i = i + Math.imul(I, K) | 0) + Math.imul(O, J) | 0, a = a + Math.imul(O, K) | 0, n = n + Math.imul(L, $) | 0, i = (i = i + Math.imul(L, tt) | 0) + Math.imul(C, $) | 0, a = a + Math.imul(C, tt) | 0, n = n + Math.imul(M, rt) | 0, i = (i = i + Math.imul(M, nt) | 0) + Math.imul(S, rt) | 0, a = a + Math.imul(S, nt) | 0, n = n + Math.imul(T, at) | 0, i = (i = i + Math.imul(T, ot) | 0) + Math.imul(k, at) | 0, a = a + Math.imul(k, ot) | 0, n = n + Math.imul(b, lt) | 0, i = (i = i + Math.imul(b, ct) | 0) + Math.imul(_, lt) | 0, a = a + Math.imul(_, ct) | 0, n = n + Math.imul(v, ft) | 0, i = (i = i + Math.imul(v, ht) | 0) + Math.imul(y, ft) | 0, a = a + Math.imul(y, ht) | 0;
                                                var Mt = (c + (n = n + Math.imul(d, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, mt) | 0) + Math.imul(m, dt) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(m, mt) | 0) + (i >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, n = Math.imul(B, W), i = (i = Math.imul(B, X)) + Math.imul(N, W) | 0, a = Math.imul(N, X), n = n + Math.imul(D, J) | 0, i = (i = i + Math.imul(D, K) | 0) + Math.imul(R, J) | 0, a = a + Math.imul(R, K) | 0, n = n + Math.imul(I, $) | 0, i = (i = i + Math.imul(I, tt) | 0) + Math.imul(O, $) | 0, a = a + Math.imul(O, tt) | 0, n = n + Math.imul(L, rt) | 0, i = (i = i + Math.imul(L, nt) | 0) + Math.imul(C, rt) | 0, a = a + Math.imul(C, nt) | 0, n = n + Math.imul(M, at) | 0, i = (i = i + Math.imul(M, ot) | 0) + Math.imul(S, at) | 0, a = a + Math.imul(S, ot) | 0, n = n + Math.imul(T, lt) | 0, i = (i = i + Math.imul(T, ct) | 0) + Math.imul(k, lt) | 0, a = a + Math.imul(k, ct) | 0, n = n + Math.imul(b, ft) | 0, i = (i = i + Math.imul(b, ht) | 0) + Math.imul(_, ft) | 0, a = a + Math.imul(_, ht) | 0;
                                                var St = (c + (n = n + Math.imul(v, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(v, mt) | 0) + Math.imul(y, dt) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(y, mt) | 0) + (i >>> 13) | 0) + (St >>> 26) | 0, St &= 67108863, n = Math.imul(B, J), i = (i = Math.imul(B, K)) + Math.imul(N, J) | 0, a = Math.imul(N, K), n = n + Math.imul(D, $) | 0, i = (i = i + Math.imul(D, tt) | 0) + Math.imul(R, $) | 0, a = a + Math.imul(R, tt) | 0, n = n + Math.imul(I, rt) | 0, i = (i = i + Math.imul(I, nt) | 0) + Math.imul(O, rt) | 0, a = a + Math.imul(O, nt) | 0, n = n + Math.imul(L, at) | 0, i = (i = i + Math.imul(L, ot) | 0) + Math.imul(C, at) | 0, a = a + Math.imul(C, ot) | 0, n = n + Math.imul(M, lt) | 0, i = (i = i + Math.imul(M, ct) | 0) + Math.imul(S, lt) | 0, a = a + Math.imul(S, ct) | 0, n = n + Math.imul(T, ft) | 0, i = (i = i + Math.imul(T, ht) | 0) + Math.imul(k, ft) | 0, a = a + Math.imul(k, ht) | 0;
                                                var Et = (c + (n = n + Math.imul(b, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(b, mt) | 0) + Math.imul(_, dt) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(_, mt) | 0) + (i >>> 13) | 0) + (Et >>> 26) | 0, Et &= 67108863, n = Math.imul(B, $), i = (i = Math.imul(B, tt)) + Math.imul(N, $) | 0, a = Math.imul(N, tt), n = n + Math.imul(D, rt) | 0, i = (i = i + Math.imul(D, nt) | 0) + Math.imul(R, rt) | 0, a = a + Math.imul(R, nt) | 0, n = n + Math.imul(I, at) | 0, i = (i = i + Math.imul(I, ot) | 0) + Math.imul(O, at) | 0, a = a + Math.imul(O, ot) | 0, n = n + Math.imul(L, lt) | 0, i = (i = i + Math.imul(L, ct) | 0) + Math.imul(C, lt) | 0, a = a + Math.imul(C, ct) | 0, n = n + Math.imul(M, ft) | 0, i = (i = i + Math.imul(M, ht) | 0) + Math.imul(S, ft) | 0, a = a + Math.imul(S, ht) | 0;
                                                var Lt = (c + (n = n + Math.imul(T, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(T, mt) | 0) + Math.imul(k, dt) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(k, mt) | 0) + (i >>> 13) | 0) + (Lt >>> 26) | 0, Lt &= 67108863, n = Math.imul(B, rt), i = (i = Math.imul(B, nt)) + Math.imul(N, rt) | 0, a = Math.imul(N, nt), n = n + Math.imul(D, at) | 0, i = (i = i + Math.imul(D, ot) | 0) + Math.imul(R, at) | 0, a = a + Math.imul(R, ot) | 0, n = n + Math.imul(I, lt) | 0, i = (i = i + Math.imul(I, ct) | 0) + Math.imul(O, lt) | 0, a = a + Math.imul(O, ct) | 0, n = n + Math.imul(L, ft) | 0, i = (i = i + Math.imul(L, ht) | 0) + Math.imul(C, ft) | 0, a = a + Math.imul(C, ht) | 0;
                                                var Ct = (c + (n = n + Math.imul(M, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, mt) | 0) + Math.imul(S, dt) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(S, mt) | 0) + (i >>> 13) | 0) + (Ct >>> 26) | 0, Ct &= 67108863, n = Math.imul(B, at), i = (i = Math.imul(B, ot)) + Math.imul(N, at) | 0, a = Math.imul(N, ot), n = n + Math.imul(D, lt) | 0, i = (i = i + Math.imul(D, ct) | 0) + Math.imul(R, lt) | 0, a = a + Math.imul(R, ct) | 0, n = n + Math.imul(I, ft) | 0, i = (i = i + Math.imul(I, ht) | 0) + Math.imul(O, ft) | 0, a = a + Math.imul(O, ht) | 0;
                                                var Pt = (c + (n = n + Math.imul(L, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(L, mt) | 0) + Math.imul(C, dt) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(C, mt) | 0) + (i >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, n = Math.imul(B, lt), i = (i = Math.imul(B, ct)) + Math.imul(N, lt) | 0, a = Math.imul(N, ct), n = n + Math.imul(D, ft) | 0, i = (i = i + Math.imul(D, ht) | 0) + Math.imul(R, ft) | 0, a = a + Math.imul(R, ht) | 0;
                                                var It = (c + (n = n + Math.imul(I, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(I, mt) | 0) + Math.imul(O, dt) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(O, mt) | 0) + (i >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, n = Math.imul(B, ft), i = (i = Math.imul(B, ht)) + Math.imul(N, ft) | 0, a = Math.imul(N, ht);
                                                var Ot = (c + (n = n + Math.imul(D, dt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(D, mt) | 0) + Math.imul(R, dt) | 0)) << 13) | 0;
                                                c = ((a = a + Math.imul(R, mt) | 0) + (i >>> 13) | 0) + (Ot >>> 26) | 0, Ot &= 67108863;
                                                var zt = (c + (n = Math.imul(B, dt)) | 0) + ((8191 & (i = (i = Math.imul(B, mt)) + Math.imul(N, dt) | 0)) << 13) | 0;
                                                return c = ((a = Math.imul(N, mt)) + (i >>> 13) | 0) + (zt >>> 26) | 0, zt &= 67108863, l[0] = gt, l[1] = vt, l[2] = yt, l[3] = xt, l[4] = bt, l[5] = _t, l[6] = wt, l[7] = Tt, l[8] = kt, l[9] = At, l[10] = Mt, l[11] = St, l[12] = Et, l[13] = Lt, l[14] = Ct, l[15] = Pt, l[16] = It, l[17] = Ot, l[18] = zt, 0 !== c && (l[19] = c, r.length++), r;
                                            };
                                            function m(t1, e1, r) {
                                                return (new g).mulp(t1, e1, r);
                                            }
                                            function g(t1, e1) {
                                                this.x = t1, this.y = e1;
                                            }
                                            Math.imul || (d = p), a.prototype.mulTo = function(t1, e1) {
                                                var r = this.length + t1.length;
                                                return 10 === this.length && 10 === t1.length ? d(this, t1, e1) : r < 63 ? p(this, t1, e1) : r < 1024 ? function(t1, e1, r) {
                                                    r.negative = e1.negative ^ t1.negative, r.length = t1.length + e1.length;
                                                    for(var n = 0, i = 0, a = 0; a < r.length - 1; a++){
                                                        var o = i;
                                                        i = 0;
                                                        for(var s = 67108863 & n, l = Math.min(a, e1.length - 1), c = Math.max(0, a - t1.length + 1); c <= l; c++){
                                                            var u = a - c, f = (0 | t1.words[u]) * (0 | e1.words[c]), h = 67108863 & f;
                                                            s = 67108863 & (h = h + s | 0), i += (o = (o = o + (f / 67108864 | 0) | 0) + (h >>> 26) | 0) >>> 26, o &= 67108863;
                                                        }
                                                        r.words[a] = s, n = o, o = i;
                                                    }
                                                    return 0 !== n ? r.words[a] = n : r.length--, r.strip();
                                                }(this, t1, e1) : m(this, t1, e1);
                                            }, g.prototype.makeRBT = function(t1) {
                                                for(var e1 = new Array(t1), r = a.prototype._countBits(t1) - 1, n = 0; n < t1; n++)e1[n] = this.revBin(n, r, t1);
                                                return e1;
                                            }, g.prototype.revBin = function(t1, e1, r) {
                                                if (0 === t1 || t1 === r - 1) return t1;
                                                for(var n = 0, i = 0; i < e1; i++)n |= (1 & t1) << e1 - i - 1, t1 >>= 1;
                                                return n;
                                            }, g.prototype.permute = function(t1, e1, r, n, i, a) {
                                                for(var o = 0; o < a; o++)n[o] = e1[t1[o]], i[o] = r[t1[o]];
                                            }, g.prototype.transform = function(t1, e1, r, n, i, a) {
                                                this.permute(a, t1, e1, r, n, i);
                                                for(var o = 1; o < i; o <<= 1)for(var s = o << 1, l = Math.cos(2 * Math.PI / s), c = Math.sin(2 * Math.PI / s), u = 0; u < i; u += s)for(var f = l, h = c, p = 0; p < o; p++){
                                                    var d = r[u + p], m = n[u + p], g = r[u + p + o], v = n[u + p + o], y = f * g - h * v;
                                                    v = f * v + h * g, g = y, r[u + p] = d + g, n[u + p] = m + v, r[u + p + o] = d - g, n[u + p + o] = m - v, p !== s && (y = l * f - c * h, h = l * h + c * f, f = y);
                                                }
                                            }, g.prototype.guessLen13b = function(t1, e1) {
                                                var r = 1 | Math.max(e1, t1), n = 1 & r, i = 0;
                                                for(r = r / 2 | 0; r; r >>>= 1)i++;
                                                return 1 << i + 1 + n;
                                            }, g.prototype.conjugate = function(t1, e1, r) {
                                                if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                                                    var i = t1[n];
                                                    t1[n] = t1[r - n - 1], t1[r - n - 1] = i, i = e1[n], e1[n] = -e1[r - n - 1], e1[r - n - 1] = -i;
                                                }
                                            }, g.prototype.normalize13b = function(t1, e1) {
                                                for(var r = 0, n = 0; n < e1 / 2; n++){
                                                    var i = 8192 * Math.round(t1[2 * n + 1] / e1) + Math.round(t1[2 * n] / e1) + r;
                                                    t1[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                                                }
                                                return t1;
                                            }, g.prototype.convert13b = function(t1, e1, r, i) {
                                                for(var a = 0, o = 0; o < e1; o++)a += 0 | t1[o], r[2 * o] = 8191 & a, a >>>= 13, r[2 * o + 1] = 8191 & a, a >>>= 13;
                                                for(o = 2 * e1; o < i; ++o)r[o] = 0;
                                                n(0 === a), n(0 == (-8192 & a));
                                            }, g.prototype.stub = function(t1) {
                                                for(var e1 = new Array(t1), r = 0; r < t1; r++)e1[r] = 0;
                                                return e1;
                                            }, g.prototype.mulp = function(t1, e1, r) {
                                                var n = 2 * this.guessLen13b(t1.length, e1.length), i = this.makeRBT(n), a = this.stub(n), o = new Array(n), s = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), f = new Array(n), h = r.words;
                                                h.length = n, this.convert13b(t1.words, t1.length, o, n), this.convert13b(e1.words, e1.length, c, n), this.transform(o, a, s, l, n, i), this.transform(c, a, u, f, n, i);
                                                for(var p = 0; p < n; p++){
                                                    var d = s[p] * u[p] - l[p] * f[p];
                                                    l[p] = s[p] * f[p] + l[p] * u[p], s[p] = d;
                                                }
                                                return this.conjugate(s, l, n), this.transform(s, l, h, a, n, i), this.conjugate(h, a, n), this.normalize13b(h, n), r.negative = t1.negative ^ e1.negative, r.length = t1.length + e1.length, r.strip();
                                            }, a.prototype.mul = function(t1) {
                                                var e1 = new a(null);
                                                return e1.words = new Array(this.length + t1.length), this.mulTo(t1, e1);
                                            }, a.prototype.mulf = function(t1) {
                                                var e1 = new a(null);
                                                return e1.words = new Array(this.length + t1.length), m(this, t1, e1);
                                            }, a.prototype.imul = function(t1) {
                                                return this.clone().mulTo(t1, this);
                                            }, a.prototype.imuln = function(t1) {
                                                n("number" == typeof t1), n(t1 < 67108864);
                                                for(var e1 = 0, r = 0; r < this.length; r++){
                                                    var i = (0 | this.words[r]) * t1, a = (67108863 & i) + (67108863 & e1);
                                                    e1 >>= 26, e1 += i / 67108864 | 0, e1 += a >>> 26, this.words[r] = 67108863 & a;
                                                }
                                                return 0 !== e1 && (this.words[r] = e1, this.length++), this;
                                            }, a.prototype.muln = function(t1) {
                                                return this.clone().imuln(t1);
                                            }, a.prototype.sqr = function() {
                                                return this.mul(this);
                                            }, a.prototype.isqr = function() {
                                                return this.imul(this.clone());
                                            }, a.prototype.pow = function(t1) {
                                                var e1 = function(t1) {
                                                    for(var e1 = new Array(t1.bitLength()), r = 0; r < e1.length; r++){
                                                        var n = r / 26 | 0, i = r % 26;
                                                        e1[r] = (t1.words[n] & 1 << i) >>> i;
                                                    }
                                                    return e1;
                                                }(t1);
                                                if (0 === e1.length) return new a(1);
                                                for(var r = this, n = 0; n < e1.length && 0 === e1[n]; n++, r = r.sqr());
                                                if (++n < e1.length) for(var i = r.sqr(); n < e1.length; n++, i = i.sqr())0 !== e1[n] && (r = r.mul(i));
                                                return r;
                                            }, a.prototype.iushln = function(t1) {
                                                n("number" == typeof t1 && t1 >= 0);
                                                var e1, r = t1 % 26, i = (t1 - r) / 26, a = 67108863 >>> 26 - r << 26 - r;
                                                if (0 !== r) {
                                                    var o = 0;
                                                    for(e1 = 0; e1 < this.length; e1++){
                                                        var s = this.words[e1] & a, l = (0 | this.words[e1]) - s << r;
                                                        this.words[e1] = l | o, o = s >>> 26 - r;
                                                    }
                                                    o && (this.words[e1] = o, this.length++);
                                                }
                                                if (0 !== i) {
                                                    for(e1 = this.length - 1; e1 >= 0; e1--)this.words[e1 + i] = this.words[e1];
                                                    for(e1 = 0; e1 < i; e1++)this.words[e1] = 0;
                                                    this.length += i;
                                                }
                                                return this.strip();
                                            }, a.prototype.ishln = function(t1) {
                                                return n(0 === this.negative), this.iushln(t1);
                                            }, a.prototype.iushrn = function(t1, e1, r) {
                                                var i;
                                                n("number" == typeof t1 && t1 >= 0), i = e1 ? (e1 - e1 % 26) / 26 : 0;
                                                var a = t1 % 26, o = Math.min((t1 - a) / 26, this.length), s = 67108863 ^ 67108863 >>> a << a, l = r;
                                                if (i -= o, i = Math.max(0, i), l) {
                                                    for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                                                    l.length = o;
                                                }
                                                if (0 === o) ;
                                                else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                                                else this.words[0] = 0, this.length = 1;
                                                var u = 0;
                                                for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                                                    var f = 0 | this.words[c];
                                                    this.words[c] = u << 26 - a | f >>> a, u = f & s;
                                                }
                                                return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
                                            }, a.prototype.ishrn = function(t1, e1, r) {
                                                return n(0 === this.negative), this.iushrn(t1, e1, r);
                                            }, a.prototype.shln = function(t1) {
                                                return this.clone().ishln(t1);
                                            }, a.prototype.ushln = function(t1) {
                                                return this.clone().iushln(t1);
                                            }, a.prototype.shrn = function(t1) {
                                                return this.clone().ishrn(t1);
                                            }, a.prototype.ushrn = function(t1) {
                                                return this.clone().iushrn(t1);
                                            }, a.prototype.testn = function(t1) {
                                                n("number" == typeof t1 && t1 >= 0);
                                                var e1 = t1 % 26, r = (t1 - e1) / 26, i = 1 << e1;
                                                return !(this.length <= r) && !!(this.words[r] & i);
                                            }, a.prototype.imaskn = function(t1) {
                                                n("number" == typeof t1 && t1 >= 0);
                                                var e1 = t1 % 26, r = (t1 - e1) / 26;
                                                if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                                                if (0 !== e1 && r++, this.length = Math.min(r, this.length), 0 !== e1) {
                                                    var i = 67108863 ^ 67108863 >>> e1 << e1;
                                                    this.words[this.length - 1] &= i;
                                                }
                                                return this.strip();
                                            }, a.prototype.maskn = function(t1) {
                                                return this.clone().imaskn(t1);
                                            }, a.prototype.iaddn = function(t1) {
                                                return n("number" == typeof t1), n(t1 < 67108864), t1 < 0 ? this.isubn(-t1) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < t1 ? (this.words[0] = t1 - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(t1), this.negative = 1, this) : this._iaddn(t1);
                                            }, a.prototype._iaddn = function(t1) {
                                                this.words[0] += t1;
                                                for(var e1 = 0; e1 < this.length && this.words[e1] >= 67108864; e1++)this.words[e1] -= 67108864, e1 === this.length - 1 ? this.words[e1 + 1] = 1 : this.words[e1 + 1]++;
                                                return this.length = Math.max(this.length, e1 + 1), this;
                                            }, a.prototype.isubn = function(t1) {
                                                if (n("number" == typeof t1), n(t1 < 67108864), t1 < 0) return this.iaddn(-t1);
                                                if (0 !== this.negative) return this.negative = 0, this.iaddn(t1), this.negative = 1, this;
                                                if (this.words[0] -= t1, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                                                else for(var e1 = 0; e1 < this.length && this.words[e1] < 0; e1++)this.words[e1] += 67108864, this.words[e1 + 1] -= 1;
                                                return this.strip();
                                            }, a.prototype.addn = function(t1) {
                                                return this.clone().iaddn(t1);
                                            }, a.prototype.subn = function(t1) {
                                                return this.clone().isubn(t1);
                                            }, a.prototype.iabs = function() {
                                                return this.negative = 0, this;
                                            }, a.prototype.abs = function() {
                                                return this.clone().iabs();
                                            }, a.prototype._ishlnsubmul = function(t1, e1, r) {
                                                var i, a, o = t1.length + r;
                                                this._expand(o);
                                                var s = 0;
                                                for(i = 0; i < t1.length; i++){
                                                    a = (0 | this.words[i + r]) + s;
                                                    var l = (0 | t1.words[i]) * e1;
                                                    s = ((a -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & a;
                                                }
                                                for(; i < this.length - r; i++)s = (a = (0 | this.words[i + r]) + s) >> 26, this.words[i + r] = 67108863 & a;
                                                if (0 === s) return this.strip();
                                                for(n(-1 === s), s = 0, i = 0; i < this.length; i++)s = (a = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & a;
                                                return this.negative = 1, this.strip();
                                            }, a.prototype._wordDiv = function(t1, e1) {
                                                var r = (this.length, t1.length), n = this.clone(), i = t1, o = 0 | i.words[i.length - 1];
                                                0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                                                var s, l = n.length - i.length;
                                                if ("mod" !== e1) {
                                                    (s = new a(null)).length = l + 1, s.words = new Array(s.length);
                                                    for(var c = 0; c < s.length; c++)s.words[c] = 0;
                                                }
                                                var u = n.clone()._ishlnsubmul(i, 1, l);
                                                0 === u.negative && (n = u, s && (s.words[l] = 1));
                                                for(var f = l - 1; f >= 0; f--){
                                                    var h = 67108864 * (0 | n.words[i.length + f]) + (0 | n.words[i.length + f - 1]);
                                                    for(h = Math.min(h / o | 0, 67108863), n._ishlnsubmul(i, h, f); 0 !== n.negative;)h--, n.negative = 0, n._ishlnsubmul(i, 1, f), n.isZero() || (n.negative ^= 1);
                                                    s && (s.words[f] = h);
                                                }
                                                return s && s.strip(), n.strip(), "div" !== e1 && 0 !== r && n.iushrn(r), {
                                                    div: s || null,
                                                    mod: n
                                                };
                                            }, a.prototype.divmod = function(t1, e1, r) {
                                                var i, o, s;
                                                return n(!t1.isZero()), this.isZero() ? {
                                                    div: new a(0),
                                                    mod: new a(0)
                                                } : 0 !== this.negative && 0 === t1.negative ? (s = this.neg().divmod(t1, e1), "mod" !== e1 && (i = s.div.neg()), "div" !== e1 && (o = s.mod.neg(), r && 0 !== o.negative && o.iadd(t1)), {
                                                    div: i,
                                                    mod: o
                                                }) : 0 === this.negative && 0 !== t1.negative ? (s = this.divmod(t1.neg(), e1), "mod" !== e1 && (i = s.div.neg()), {
                                                    div: i,
                                                    mod: s.mod
                                                }) : 0 != (this.negative & t1.negative) ? (s = this.neg().divmod(t1.neg(), e1), "div" !== e1 && (o = s.mod.neg(), r && 0 !== o.negative && o.isub(t1)), {
                                                    div: s.div,
                                                    mod: o
                                                }) : t1.length > this.length || this.cmp(t1) < 0 ? {
                                                    div: new a(0),
                                                    mod: this
                                                } : 1 === t1.length ? "div" === e1 ? {
                                                    div: this.divn(t1.words[0]),
                                                    mod: null
                                                } : "mod" === e1 ? {
                                                    div: null,
                                                    mod: new a(this.modn(t1.words[0]))
                                                } : {
                                                    div: this.divn(t1.words[0]),
                                                    mod: new a(this.modn(t1.words[0]))
                                                } : this._wordDiv(t1, e1);
                                            }, a.prototype.div = function(t1) {
                                                return this.divmod(t1, "div", !1).div;
                                            }, a.prototype.mod = function(t1) {
                                                return this.divmod(t1, "mod", !1).mod;
                                            }, a.prototype.umod = function(t1) {
                                                return this.divmod(t1, "mod", !0).mod;
                                            }, a.prototype.divRound = function(t1) {
                                                var e1 = this.divmod(t1);
                                                if (e1.mod.isZero()) return e1.div;
                                                var r = 0 !== e1.div.negative ? e1.mod.isub(t1) : e1.mod, n = t1.ushrn(1), i = t1.andln(1), a = r.cmp(n);
                                                return a < 0 || 1 === i && 0 === a ? e1.div : 0 !== e1.div.negative ? e1.div.isubn(1) : e1.div.iaddn(1);
                                            }, a.prototype.modn = function(t1) {
                                                n(t1 <= 67108863);
                                                for(var e1 = 67108864 % t1, r = 0, i = this.length - 1; i >= 0; i--)r = (e1 * r + (0 | this.words[i])) % t1;
                                                return r;
                                            }, a.prototype.idivn = function(t1) {
                                                n(t1 <= 67108863);
                                                for(var e1 = 0, r = this.length - 1; r >= 0; r--){
                                                    var i = (0 | this.words[r]) + 67108864 * e1;
                                                    this.words[r] = i / t1 | 0, e1 = i % t1;
                                                }
                                                return this.strip();
                                            }, a.prototype.divn = function(t1) {
                                                return this.clone().idivn(t1);
                                            }, a.prototype.egcd = function(t1) {
                                                n(0 === t1.negative), n(!t1.isZero());
                                                var e1 = this, r = t1.clone();
                                                e1 = 0 !== e1.negative ? e1.umod(t1) : e1.clone();
                                                for(var i = new a(1), o = new a(0), s = new a(0), l = new a(1), c = 0; e1.isEven() && r.isEven();)e1.iushrn(1), r.iushrn(1), ++c;
                                                for(var u = r.clone(), f = e1.clone(); !e1.isZero();){
                                                    for(var h = 0, p = 1; 0 == (e1.words[0] & p) && h < 26; ++h, p <<= 1);
                                                    if (h > 0) for(e1.iushrn(h); h-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(f)), i.iushrn(1), o.iushrn(1);
                                                    for(var d = 0, m = 1; 0 == (r.words[0] & m) && d < 26; ++d, m <<= 1);
                                                    if (d > 0) for(r.iushrn(d); d-- > 0;)(s.isOdd() || l.isOdd()) && (s.iadd(u), l.isub(f)), s.iushrn(1), l.iushrn(1);
                                                    e1.cmp(r) >= 0 ? (e1.isub(r), i.isub(s), o.isub(l)) : (r.isub(e1), s.isub(i), l.isub(o));
                                                }
                                                return {
                                                    a: s,
                                                    b: l,
                                                    gcd: r.iushln(c)
                                                };
                                            }, a.prototype._invmp = function(t1) {
                                                n(0 === t1.negative), n(!t1.isZero());
                                                var e1 = this, r = t1.clone();
                                                e1 = 0 !== e1.negative ? e1.umod(t1) : e1.clone();
                                                for(var i, o = new a(1), s = new a(0), l = r.clone(); e1.cmpn(1) > 0 && r.cmpn(1) > 0;){
                                                    for(var c = 0, u = 1; 0 == (e1.words[0] & u) && c < 26; ++c, u <<= 1);
                                                    if (c > 0) for(e1.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                                                    for(var f = 0, h = 1; 0 == (r.words[0] & h) && f < 26; ++f, h <<= 1);
                                                    if (f > 0) for(r.iushrn(f); f-- > 0;)s.isOdd() && s.iadd(l), s.iushrn(1);
                                                    e1.cmp(r) >= 0 ? (e1.isub(r), o.isub(s)) : (r.isub(e1), s.isub(o));
                                                }
                                                return (i = 0 === e1.cmpn(1) ? o : s).cmpn(0) < 0 && i.iadd(t1), i;
                                            }, a.prototype.gcd = function(t1) {
                                                if (this.isZero()) return t1.abs();
                                                if (t1.isZero()) return this.abs();
                                                var e1 = this.clone(), r = t1.clone();
                                                e1.negative = 0, r.negative = 0;
                                                for(var n = 0; e1.isEven() && r.isEven(); n++)e1.iushrn(1), r.iushrn(1);
                                                for(;;){
                                                    for(; e1.isEven();)e1.iushrn(1);
                                                    for(; r.isEven();)r.iushrn(1);
                                                    var i = e1.cmp(r);
                                                    if (i < 0) {
                                                        var a = e1;
                                                        e1 = r, r = a;
                                                    } else if (0 === i || 0 === r.cmpn(1)) break;
                                                    e1.isub(r);
                                                }
                                                return r.iushln(n);
                                            }, a.prototype.invm = function(t1) {
                                                return this.egcd(t1).a.umod(t1);
                                            }, a.prototype.isEven = function() {
                                                return 0 == (1 & this.words[0]);
                                            }, a.prototype.isOdd = function() {
                                                return 1 == (1 & this.words[0]);
                                            }, a.prototype.andln = function(t1) {
                                                return this.words[0] & t1;
                                            }, a.prototype.bincn = function(t1) {
                                                n("number" == typeof t1);
                                                var e1 = t1 % 26, r = (t1 - e1) / 26, i = 1 << e1;
                                                if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                                                for(var a = i, o = r; 0 !== a && o < this.length; o++){
                                                    var s = 0 | this.words[o];
                                                    a = (s += a) >>> 26, s &= 67108863, this.words[o] = s;
                                                }
                                                return 0 !== a && (this.words[o] = a, this.length++), this;
                                            }, a.prototype.isZero = function() {
                                                return 1 === this.length && 0 === this.words[0];
                                            }, a.prototype.cmpn = function(t1) {
                                                var e1, r = t1 < 0;
                                                if (0 !== this.negative && !r) return -1;
                                                if (0 === this.negative && r) return 1;
                                                if (this.strip(), this.length > 1) e1 = 1;
                                                else {
                                                    r && (t1 = -t1), n(t1 <= 67108863, "Number is too big");
                                                    var i = 0 | this.words[0];
                                                    e1 = i === t1 ? 0 : i < t1 ? -1 : 1;
                                                }
                                                return 0 !== this.negative ? 0 | -e1 : e1;
                                            }, a.prototype.cmp = function(t1) {
                                                if (0 !== this.negative && 0 === t1.negative) return -1;
                                                if (0 === this.negative && 0 !== t1.negative) return 1;
                                                var e1 = this.ucmp(t1);
                                                return 0 !== this.negative ? 0 | -e1 : e1;
                                            }, a.prototype.ucmp = function(t1) {
                                                if (this.length > t1.length) return 1;
                                                if (this.length < t1.length) return -1;
                                                for(var e1 = 0, r = this.length - 1; r >= 0; r--){
                                                    var n = 0 | this.words[r], i = 0 | t1.words[r];
                                                    if (n !== i) {
                                                        n < i ? e1 = -1 : n > i && (e1 = 1);
                                                        break;
                                                    }
                                                }
                                                return e1;
                                            }, a.prototype.gtn = function(t1) {
                                                return 1 === this.cmpn(t1);
                                            }, a.prototype.gt = function(t1) {
                                                return 1 === this.cmp(t1);
                                            }, a.prototype.gten = function(t1) {
                                                return this.cmpn(t1) >= 0;
                                            }, a.prototype.gte = function(t1) {
                                                return this.cmp(t1) >= 0;
                                            }, a.prototype.ltn = function(t1) {
                                                return -1 === this.cmpn(t1);
                                            }, a.prototype.lt = function(t1) {
                                                return -1 === this.cmp(t1);
                                            }, a.prototype.lten = function(t1) {
                                                return this.cmpn(t1) <= 0;
                                            }, a.prototype.lte = function(t1) {
                                                return this.cmp(t1) <= 0;
                                            }, a.prototype.eqn = function(t1) {
                                                return 0 === this.cmpn(t1);
                                            }, a.prototype.eq = function(t1) {
                                                return 0 === this.cmp(t1);
                                            }, a.red = function(t1) {
                                                return new T(t1);
                                            }, a.prototype.toRed = function(t1) {
                                                return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), t1.convertTo(this)._forceRed(t1);
                                            }, a.prototype.fromRed = function() {
                                                return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                                            }, a.prototype._forceRed = function(t1) {
                                                return this.red = t1, this;
                                            }, a.prototype.forceRed = function(t1) {
                                                return n(!this.red, "Already a number in reduction context"), this._forceRed(t1);
                                            }, a.prototype.redAdd = function(t1) {
                                                return n(this.red, "redAdd works only with red numbers"), this.red.add(this, t1);
                                            }, a.prototype.redIAdd = function(t1) {
                                                return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t1);
                                            }, a.prototype.redSub = function(t1) {
                                                return n(this.red, "redSub works only with red numbers"), this.red.sub(this, t1);
                                            }, a.prototype.redISub = function(t1) {
                                                return n(this.red, "redISub works only with red numbers"), this.red.isub(this, t1);
                                            }, a.prototype.redShl = function(t1) {
                                                return n(this.red, "redShl works only with red numbers"), this.red.shl(this, t1);
                                            }, a.prototype.redMul = function(t1) {
                                                return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t1), this.red.mul(this, t1);
                                            }, a.prototype.redIMul = function(t1) {
                                                return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t1), this.red.imul(this, t1);
                                            }, a.prototype.redSqr = function() {
                                                return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                                            }, a.prototype.redISqr = function() {
                                                return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                                            }, a.prototype.redSqrt = function() {
                                                return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                                            }, a.prototype.redInvm = function() {
                                                return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                                            }, a.prototype.redNeg = function() {
                                                return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                                            }, a.prototype.redPow = function(t1) {
                                                return n(this.red && !t1.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t1);
                                            };
                                            var v = {
                                                k256: null,
                                                p224: null,
                                                p192: null,
                                                p25519: null
                                            };
                                            function y(t1, e1) {
                                                this.name = t1, this.p = new a(e1, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                                            }
                                            function x() {
                                                y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                                            }
                                            function b() {
                                                y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                                            }
                                            function _() {
                                                y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                                            }
                                            function w() {
                                                y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                                            }
                                            function T(t1) {
                                                if ("string" == typeof t1) {
                                                    var e1 = a._prime(t1);
                                                    this.m = e1.p, this.prime = e1;
                                                } else n(t1.gtn(1), "modulus must be greater than 1"), this.m = t1, this.prime = null;
                                            }
                                            function k(t1) {
                                                T.call(this, t1), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                                            }
                                            y.prototype._tmp = function() {
                                                var t1 = new a(null);
                                                return t1.words = new Array(Math.ceil(this.n / 13)), t1;
                                            }, y.prototype.ireduce = function(t1) {
                                                var e1, r = t1;
                                                do this.split(r, this.tmp), e1 = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                                                while (e1 > this.n);
                                                var n = e1 < this.n ? -1 : r.ucmp(this.p);
                                                return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                                            }, y.prototype.split = function(t1, e1) {
                                                t1.iushrn(this.n, 0, e1);
                                            }, y.prototype.imulK = function(t1) {
                                                return t1.imul(this.k);
                                            }, i(x, y), x.prototype.split = function(t1, e1) {
                                                for(var r = Math.min(t1.length, 9), n = 0; n < r; n++)e1.words[n] = t1.words[n];
                                                if (e1.length = r, t1.length <= 9) return t1.words[0] = 0, void (t1.length = 1);
                                                var i = t1.words[9];
                                                for(e1.words[e1.length++] = 4194303 & i, n = 10; n < t1.length; n++){
                                                    var a = 0 | t1.words[n];
                                                    t1.words[n - 10] = (4194303 & a) << 4 | i >>> 22, i = a;
                                                }
                                                i >>>= 22, t1.words[n - 10] = i, 0 === i && t1.length > 10 ? t1.length -= 10 : t1.length -= 9;
                                            }, x.prototype.imulK = function(t1) {
                                                t1.words[t1.length] = 0, t1.words[t1.length + 1] = 0, t1.length += 2;
                                                for(var e1 = 0, r = 0; r < t1.length; r++){
                                                    var n = 0 | t1.words[r];
                                                    e1 += 977 * n, t1.words[r] = 67108863 & e1, e1 = 64 * n + (e1 / 67108864 | 0);
                                                }
                                                return 0 === t1.words[t1.length - 1] && (t1.length--, 0 === t1.words[t1.length - 1] && t1.length--), t1;
                                            }, i(b, y), i(_, y), i(w, y), w.prototype.imulK = function(t1) {
                                                for(var e1 = 0, r = 0; r < t1.length; r++){
                                                    var n = 19 * (0 | t1.words[r]) + e1, i = 67108863 & n;
                                                    n >>>= 26, t1.words[r] = i, e1 = n;
                                                }
                                                return 0 !== e1 && (t1.words[t1.length++] = e1), t1;
                                            }, a._prime = function(t1) {
                                                if (v[t1]) return v[t1];
                                                var e1;
                                                if ("k256" === t1) e1 = new x;
                                                else if ("p224" === t1) e1 = new b;
                                                else if ("p192" === t1) e1 = new _;
                                                else {
                                                    if ("p25519" !== t1) throw new Error("Unknown prime " + t1);
                                                    e1 = new w;
                                                }
                                                return v[t1] = e1, e1;
                                            }, T.prototype._verify1 = function(t1) {
                                                n(0 === t1.negative, "red works only with positives"), n(t1.red, "red works only with red numbers");
                                            }, T.prototype._verify2 = function(t1, e1) {
                                                n(0 == (t1.negative | e1.negative), "red works only with positives"), n(t1.red && t1.red === e1.red, "red works only with red numbers");
                                            }, T.prototype.imod = function(t1) {
                                                return this.prime ? this.prime.ireduce(t1)._forceRed(this) : t1.umod(this.m)._forceRed(this);
                                            }, T.prototype.neg = function(t1) {
                                                return t1.isZero() ? t1.clone() : this.m.sub(t1)._forceRed(this);
                                            }, T.prototype.add = function(t1, e1) {
                                                this._verify2(t1, e1);
                                                var r = t1.add(e1);
                                                return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                                            }, T.prototype.iadd = function(t1, e1) {
                                                this._verify2(t1, e1);
                                                var r = t1.iadd(e1);
                                                return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                                            }, T.prototype.sub = function(t1, e1) {
                                                this._verify2(t1, e1);
                                                var r = t1.sub(e1);
                                                return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                                            }, T.prototype.isub = function(t1, e1) {
                                                this._verify2(t1, e1);
                                                var r = t1.isub(e1);
                                                return r.cmpn(0) < 0 && r.iadd(this.m), r;
                                            }, T.prototype.shl = function(t1, e1) {
                                                return this._verify1(t1), this.imod(t1.ushln(e1));
                                            }, T.prototype.imul = function(t1, e1) {
                                                return this._verify2(t1, e1), this.imod(t1.imul(e1));
                                            }, T.prototype.mul = function(t1, e1) {
                                                return this._verify2(t1, e1), this.imod(t1.mul(e1));
                                            }, T.prototype.isqr = function(t1) {
                                                return this.imul(t1, t1.clone());
                                            }, T.prototype.sqr = function(t1) {
                                                return this.mul(t1, t1);
                                            }, T.prototype.sqrt = function(t1) {
                                                if (t1.isZero()) return t1.clone();
                                                var e1 = this.m.andln(3);
                                                if (n(e1 % 2 == 1), 3 === e1) {
                                                    var r = this.m.add(new a(1)).iushrn(2);
                                                    return this.pow(t1, r);
                                                }
                                                for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                                                n(!i.isZero());
                                                var s = new a(1).toRed(this), l = s.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                                                for(u = new a(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                                                for(var f = this.pow(u, i), h = this.pow(t1, i.addn(1).iushrn(1)), p = this.pow(t1, i), d = o; 0 !== p.cmp(s);){
                                                    for(var m = p, g = 0; 0 !== m.cmp(s); g++)m = m.redSqr();
                                                    n(g < d);
                                                    var v = this.pow(f, new a(1).iushln(d - g - 1));
                                                    h = h.redMul(v), f = v.redSqr(), p = p.redMul(f), d = g;
                                                }
                                                return h;
                                            }, T.prototype.invm = function(t1) {
                                                var e1 = t1._invmp(this.m);
                                                return 0 !== e1.negative ? (e1.negative = 0, this.imod(e1).redNeg()) : this.imod(e1);
                                            }, T.prototype.pow = function(t1, e1) {
                                                if (e1.isZero()) return new a(1).toRed(this);
                                                if (0 === e1.cmpn(1)) return t1.clone();
                                                var r = new Array(16);
                                                r[0] = new a(1).toRed(this), r[1] = t1;
                                                for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], t1);
                                                var i = r[0], o = 0, s = 0, l = e1.bitLength() % 26;
                                                for(0 === l && (l = 26), n = e1.length - 1; n >= 0; n--){
                                                    for(var c = e1.words[n], u = l - 1; u >= 0; u--){
                                                        var f = c >> u & 1;
                                                        i !== r[0] && (i = this.sqr(i)), 0 !== f || 0 !== o ? (o <<= 1, o |= f, (4 === ++s || 0 === n && 0 === u) && (i = this.mul(i, r[o]), s = 0, o = 0)) : s = 0;
                                                    }
                                                    l = 26;
                                                }
                                                return i;
                                            }, T.prototype.convertTo = function(t1) {
                                                var e1 = t1.umod(this.m);
                                                return e1 === t1 ? e1.clone() : e1;
                                            }, T.prototype.convertFrom = function(t1) {
                                                var e1 = t1.clone();
                                                return e1.red = null, e1;
                                            }, a.mont = function(t1) {
                                                return new k(t1);
                                            }, i(k, T), k.prototype.convertTo = function(t1) {
                                                return this.imod(t1.ushln(this.shift));
                                            }, k.prototype.convertFrom = function(t1) {
                                                var e1 = this.imod(t1.mul(this.rinv));
                                                return e1.red = null, e1;
                                            }, k.prototype.imul = function(t1, e1) {
                                                if (t1.isZero() || e1.isZero()) return t1.words[0] = 0, t1.length = 1, t1;
                                                var r = t1.imul(e1), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), a = i;
                                                return i.cmp(this.m) >= 0 ? a = i.isub(this.m) : i.cmpn(0) < 0 && (a = i.iadd(this.m)), a._forceRed(this);
                                            }, k.prototype.mul = function(t1, e1) {
                                                if (t1.isZero() || e1.isZero()) return new a(0)._forceRed(this);
                                                var r = t1.mul(e1), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                                                return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                                            }, k.prototype.invm = function(t1) {
                                                return this.imod(t1._invmp(this.m).mul(this.r2))._forceRed(this);
                                            };
                                        }(void 0 === e1 || e1, this);
                                    },
                                    {
                                        buffer: 2
                                    }
                                ],
                                34: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1, r, n, i = t1.length, a = 0;
                                            for(e1 = 0; e1 < i; ++e1)a += t1[e1].length;
                                            var o = new Array(a), s = 0;
                                            for(e1 = 0; e1 < i; ++e1){
                                                var l = t1[e1], c = l.length;
                                                for(r = 0; r < c; ++r){
                                                    var u = o[s++] = new Array(c - 1), f = 0;
                                                    for(n = 0; n < c; ++n)n !== r && (u[f++] = l[n]);
                                                    if (1 & r) {
                                                        var h = u[1];
                                                        u[1] = u[0], u[0] = h;
                                                    }
                                                }
                                            }
                                            return o;
                                        };
                                    },
                                    {}
                                ],
                                35: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r) {
                                            switch(arguments.length){
                                                case 1:
                                                    return f(t1);
                                                case 2:
                                                    return "function" == typeof e1 ? c(t1, t1, e1, !0) : h(t1, e1);
                                                case 3:
                                                    return c(t1, e1, r, !1);
                                                default:
                                                    throw new Error("box-intersect: Invalid arguments");
                                            }
                                        };
                                        var n, i = t1("typedarray-pool"), a = t1("./lib/sweep"), o = t1("./lib/intersect");
                                        function s(t1, e1) {
                                            for(var r = 0; r < t1; ++r)if (!(e1[r] <= e1[r + t1])) return !0;
                                            return !1;
                                        }
                                        function l(t1, e1, r, n) {
                                            for(var i = 0, a = 0, o = 0, l = t1.length; o < l; ++o){
                                                var c = t1[o];
                                                if (!s(e1, c)) {
                                                    for(var u = 0; u < 2 * e1; ++u)r[i++] = c[u];
                                                    n[a++] = o;
                                                }
                                            }
                                            return a;
                                        }
                                        function c(t1, e1, r, n) {
                                            var s = t1.length, c = e1.length;
                                            if (!(s <= 0 || c <= 0)) {
                                                var u = t1[0].length >>> 1;
                                                if (!(u <= 0)) {
                                                    var f, h = i.mallocDouble(2 * u * s), p = i.mallocInt32(s);
                                                    if ((s = l(t1, u, h, p)) > 0) {
                                                        if (1 === u && n) a.init(s), f = a.sweepComplete(u, r, 0, s, h, p, 0, s, h, p);
                                                        else {
                                                            var d = i.mallocDouble(2 * u * c), m = i.mallocInt32(c);
                                                            (c = l(e1, u, d, m)) > 0 && (a.init(s + c), f = 1 === u ? a.sweepBipartite(u, r, 0, s, h, p, 0, c, d, m) : o(u, r, n, s, h, p, c, d, m), i.free(d), i.free(m));
                                                        }
                                                        i.free(h), i.free(p);
                                                    }
                                                    return f;
                                                }
                                            }
                                        }
                                        function u(t1, e1) {
                                            n.push([
                                                t1,
                                                e1
                                            ]);
                                        }
                                        function f(t1) {
                                            return n = [], c(t1, t1, u, !0), n;
                                        }
                                        function h(t1, e1) {
                                            return n = [], c(t1, e1, u, !1), n;
                                        }
                                    },
                                    {
                                        "./lib/intersect": 37,
                                        "./lib/sweep": 41,
                                        "typedarray-pool": 308
                                    }
                                ],
                                36: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        function n(t1) {
                                            return t1 ? function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                                return i - n > l - s ? function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                                    for(var f = 2 * t1, h = n, p = f * n; h < i; ++h, p += f){
                                                        var d = a[e1 + p], m = a[e1 + p + t1], g = o[h];
                                                        t: for(var v = s, y = f * s; v < l; ++v, y += f){
                                                            var x = c[e1 + y], b = c[e1 + y + t1], _ = u[v];
                                                            if (!(b < d || m < x)) {
                                                                for(var w = e1 + 1; w < t1; ++w){
                                                                    var T = a[w + p], k = a[w + t1 + p], A = c[w + y], M = c[w + t1 + y];
                                                                    if (k < A || M < T) continue t;
                                                                }
                                                                var S = r(g, _);
                                                                if (void 0 !== S) return S;
                                                            }
                                                        }
                                                    }
                                                }(t1, e1, r, n, i, a, o, s, l, c, u) : function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                                    for(var f = 2 * t1, h = s, p = f * s; h < l; ++h, p += f){
                                                        var d = c[e1 + p], m = c[e1 + p + t1], g = u[h];
                                                        t: for(var v = n, y = f * n; v < i; ++v, y += f){
                                                            var x = a[e1 + y], b = a[e1 + y + t1], _ = o[v];
                                                            if (!(m < x || b < d)) {
                                                                for(var w = e1 + 1; w < t1; ++w){
                                                                    var T = a[w + y], k = a[w + t1 + y], A = c[w + p], M = c[w + t1 + p];
                                                                    if (k < A || M < T) continue t;
                                                                }
                                                                var S = r(_, g);
                                                                if (void 0 !== S) return S;
                                                            }
                                                        }
                                                    }
                                                }(t1, e1, r, n, i, a, o, s, l, c, u);
                                            } : function(t1, e1, r, n, i, a, o, s, l, c, u, f) {
                                                return a - i > c - l ? n ? function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                                    for(var f = 2 * t1, h = n, p = f * n; h < i; ++h, p += f){
                                                        var d = a[e1 + p], m = a[e1 + p + t1], g = o[h];
                                                        t: for(var v = s, y = f * s; v < l; ++v, y += f){
                                                            var x = c[e1 + y], b = u[v];
                                                            if (!(x <= d || m < x)) {
                                                                for(var _ = e1 + 1; _ < t1; ++_){
                                                                    var w = a[_ + p], T = a[_ + t1 + p], k = c[_ + y], A = c[_ + t1 + y];
                                                                    if (T < k || A < w) continue t;
                                                                }
                                                                var M = r(b, g);
                                                                if (void 0 !== M) return M;
                                                            }
                                                        }
                                                    }
                                                }(t1, e1, r, i, a, o, s, l, c, u, f) : function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                                    for(var f = 2 * t1, h = n, p = f * n; h < i; ++h, p += f){
                                                        var d = a[e1 + p], m = a[e1 + p + t1], g = o[h];
                                                        t: for(var v = s, y = f * s; v < l; ++v, y += f){
                                                            var x = c[e1 + y], b = u[v];
                                                            if (!(x < d || m < x)) {
                                                                for(var _ = e1 + 1; _ < t1; ++_){
                                                                    var w = a[_ + p], T = a[_ + t1 + p], k = c[_ + y], A = c[_ + t1 + y];
                                                                    if (T < k || A < w) continue t;
                                                                }
                                                                var M = r(g, b);
                                                                if (void 0 !== M) return M;
                                                            }
                                                        }
                                                    }
                                                }(t1, e1, r, i, a, o, s, l, c, u, f) : n ? function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                                    for(var f = 2 * t1, h = s, p = f * s; h < l; ++h, p += f){
                                                        var d = c[e1 + p], m = u[h];
                                                        t: for(var g = n, v = f * n; g < i; ++g, v += f){
                                                            var y = a[e1 + v], x = a[e1 + v + t1], b = o[g];
                                                            if (!(d <= y || x < d)) {
                                                                for(var _ = e1 + 1; _ < t1; ++_){
                                                                    var w = a[_ + v], T = a[_ + t1 + v], k = c[_ + p], A = c[_ + t1 + p];
                                                                    if (T < k || A < w) continue t;
                                                                }
                                                                var M = r(m, b);
                                                                if (void 0 !== M) return M;
                                                            }
                                                        }
                                                    }
                                                }(t1, e1, r, i, a, o, s, l, c, u, f) : function(t1, e1, r, n, i, a, o, s, l, c, u) {
                                                    for(var f = 2 * t1, h = s, p = f * s; h < l; ++h, p += f){
                                                        var d = c[e1 + p], m = u[h];
                                                        t: for(var g = n, v = f * n; g < i; ++g, v += f){
                                                            var y = a[e1 + v], x = a[e1 + v + t1], b = o[g];
                                                            if (!(d < y || x < d)) {
                                                                for(var _ = e1 + 1; _ < t1; ++_){
                                                                    var w = a[_ + v], T = a[_ + t1 + v], k = c[_ + p], A = c[_ + t1 + p];
                                                                    if (T < k || A < w) continue t;
                                                                }
                                                                var M = r(b, m);
                                                                if (void 0 !== M) return M;
                                                            }
                                                        }
                                                    }
                                                }(t1, e1, r, i, a, o, s, l, c, u, f);
                                            };
                                        }
                                        r.partial = n(!1), r.full = n(!0);
                                    },
                                    {}
                                ],
                                37: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r, a, u, w, T, k, A) {
                                            !function(t1, e1) {
                                                var r = 8 * i.log2(e1 + 1) * (t1 + 1) | 0, a = i.nextPow2(6 * r);
                                                v.length < a && (n.free(v), v = n.mallocInt32(a));
                                                var o = i.nextPow2(2 * r);
                                                y.length < o && (n.free(y), y = n.mallocDouble(o));
                                            }(t1, a + T);
                                            var M, S = 0, E = 2 * t1;
                                            x(S++, 0, 0, a, 0, T, r ? 16 : 0, -1 / 0, 1 / 0), r || x(S++, 0, 0, T, 0, a, 1, -1 / 0, 1 / 0);
                                            for(; S > 0;){
                                                var L = 6 * (S -= 1), C = v[L], P = v[L + 1], I = v[L + 2], O = v[L + 3], z = v[L + 4], D = v[L + 5], R = 2 * S, F = y[R], B = y[R + 1], N = 1 & D, j = !!(16 & D), U = u, V = w, H = k, q = A;
                                                if (N && (U = k, V = A, H = u, q = w), !(2 & D && (I = p(t1, C, P, I, U, V, B), P >= I) || 4 & D && (P = d(t1, C, P, I, U, V, F)) >= I)) {
                                                    var G = I - P, Y = z - O;
                                                    if (j) {
                                                        if (t1 * G * (G + Y) < 4194304) {
                                                            if (void 0 !== (M = l.scanComplete(t1, C, e1, P, I, U, V, O, z, H, q))) return M;
                                                            continue;
                                                        }
                                                    } else {
                                                        if (t1 * Math.min(G, Y) < 128) {
                                                            if (void 0 !== (M = o(t1, C, e1, N, P, I, U, V, O, z, H, q))) return M;
                                                            continue;
                                                        }
                                                        if (t1 * G * Y < 4194304) {
                                                            if (void 0 !== (M = l.scanBipartite(t1, C, e1, N, P, I, U, V, O, z, H, q))) return M;
                                                            continue;
                                                        }
                                                    }
                                                    var W = f(t1, C, P, I, U, V, F, B);
                                                    if (P < W) {
                                                        if (t1 * (W - P) < 128) {
                                                            if (void 0 !== (M = s(t1, C + 1, e1, P, W, U, V, O, z, H, q))) return M;
                                                        } else if (C === t1 - 2) {
                                                            if (void 0 !== (M = N ? l.sweepBipartite(t1, e1, O, z, H, q, P, W, U, V) : l.sweepBipartite(t1, e1, P, W, U, V, O, z, H, q))) return M;
                                                        } else x(S++, C + 1, P, W, O, z, N, -1 / 0, 1 / 0), x(S++, C + 1, O, z, P, W, 1 ^ N, -1 / 0, 1 / 0);
                                                    }
                                                    if (W < I) {
                                                        var X = c(t1, C, O, z, H, q), Z = H[E * X + C], J = h(t1, C, X, z, H, q, Z);
                                                        if (J < z && x(S++, C, W, I, J, z, (4 | N) + (j ? 16 : 0), Z, B), O < X && x(S++, C, W, I, O, X, (2 | N) + (j ? 16 : 0), F, Z), X + 1 === J) {
                                                            if (void 0 !== (M = j ? _(t1, C, e1, W, I, U, V, X, H, q[X]) : b(t1, C, e1, N, W, I, U, V, X, H, q[X]))) return M;
                                                        } else if (X < J) {
                                                            var K;
                                                            if (j) {
                                                                if (K = m(t1, C, W, I, U, V, Z), W < K) {
                                                                    var Q = h(t1, C, W, K, U, V, Z);
                                                                    if (C === t1 - 2) {
                                                                        if (W < Q && void 0 !== (M = l.sweepComplete(t1, e1, W, Q, U, V, X, J, H, q))) return M;
                                                                        if (Q < K && void 0 !== (M = l.sweepBipartite(t1, e1, Q, K, U, V, X, J, H, q))) return M;
                                                                    } else W < Q && x(S++, C + 1, W, Q, X, J, 16, -1 / 0, 1 / 0), Q < K && (x(S++, C + 1, Q, K, X, J, 0, -1 / 0, 1 / 0), x(S++, C + 1, X, J, Q, K, 1, -1 / 0, 1 / 0));
                                                                }
                                                            } else K = N ? g(t1, C, W, I, U, V, Z) : m(t1, C, W, I, U, V, Z), W < K && (C === t1 - 2 ? M = N ? l.sweepBipartite(t1, e1, X, J, H, q, W, K, U, V) : l.sweepBipartite(t1, e1, W, K, U, V, X, J, H, q) : (x(S++, C + 1, W, K, X, J, N, -1 / 0, 1 / 0), x(S++, C + 1, X, J, W, K, 1 ^ N, -1 / 0, 1 / 0)));
                                                        }
                                                    }
                                                }
                                            }
                                        };
                                        var n = t1("typedarray-pool"), i = t1("bit-twiddle"), a = t1("./brute"), o = a.partial, s = a.full, l = t1("./sweep"), c = t1("./median"), u = t1("./partition"), f = u("!(lo>=p0)&&!(p1>=hi)"), h = u("lo===p0"), p = u("lo<p0"), d = u("hi<=p0"), m = u("lo<=p0&&p0<=hi"), g = u("lo<p0&&p0<=hi"), v = n.mallocInt32(1024), y = n.mallocDouble(1024);
                                        function x(t1, e1, r, n, i, a, o, s, l) {
                                            var c = 6 * t1;
                                            v[c] = e1, v[c + 1] = r, v[c + 2] = n, v[c + 3] = i, v[c + 4] = a, v[c + 5] = o;
                                            var u = 2 * t1;
                                            y[u] = s, y[u + 1] = l;
                                        }
                                        function b(t1, e1, r, n, i, a, o, s, l, c, u) {
                                            var f = 2 * t1, h = l * f, p = c[h + e1];
                                            t: for(var d = i, m = i * f; d < a; ++d, m += f){
                                                var g = o[m + e1], v = o[m + e1 + t1];
                                                if (!(p < g || v < p) && (!n || p !== g)) {
                                                    for(var y, x = s[d], b = e1 + 1; b < t1; ++b){
                                                        g = o[m + b], v = o[m + b + t1];
                                                        var _ = c[h + b], w = c[h + b + t1];
                                                        if (v < _ || w < g) continue t;
                                                    }
                                                    if (void 0 !== (y = n ? r(u, x) : r(x, u))) return y;
                                                }
                                            }
                                        }
                                        function _(t1, e1, r, n, i, a, o, s, l, c) {
                                            var u = 2 * t1, f = s * u, h = l[f + e1];
                                            t: for(var p = n, d = n * u; p < i; ++p, d += u){
                                                var m = o[p];
                                                if (m !== c) {
                                                    var g = a[d + e1], v = a[d + e1 + t1];
                                                    if (!(h < g || v < h)) {
                                                        for(var y = e1 + 1; y < t1; ++y){
                                                            g = a[d + y], v = a[d + y + t1];
                                                            var x = l[f + y], b = l[f + y + t1];
                                                            if (v < x || b < g) continue t;
                                                        }
                                                        var _ = r(m, c);
                                                        if (void 0 !== _) return _;
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    {
                                        "./brute": 36,
                                        "./median": 38,
                                        "./partition": 39,
                                        "./sweep": 41,
                                        "bit-twiddle": 32,
                                        "typedarray-pool": 308
                                    }
                                ],
                                38: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r, a, o, s) {
                                            if (a <= r + 1) return r;
                                            var l = r, c = a, u = a + r >>> 1, f = 2 * t1, h = u, p = o[f * u + e1];
                                            for(; l < c;){
                                                if (c - l < 8) {
                                                    i(t1, e1, l, c, o, s), p = o[f * u + e1];
                                                    break;
                                                }
                                                var d = c - l, m = Math.random() * d + l | 0, g = o[f * m + e1], v = Math.random() * d + l | 0, y = o[f * v + e1], x = Math.random() * d + l | 0, b = o[f * x + e1];
                                                g <= y ? b >= y ? (h = v, p = y) : g >= b ? (h = m, p = g) : (h = x, p = b) : y >= b ? (h = v, p = y) : b >= g ? (h = m, p = g) : (h = x, p = b);
                                                for(var _ = f * (c - 1), w = f * h, T = 0; T < f; ++T, ++_, ++w){
                                                    var k = o[_];
                                                    o[_] = o[w], o[w] = k;
                                                }
                                                var A = s[c - 1];
                                                s[c - 1] = s[h], s[h] = A, h = n(t1, e1, l, c - 1, o, s, p);
                                                for(_ = f * (c - 1), w = f * h, T = 0; T < f; ++T, ++_, ++w){
                                                    k = o[_];
                                                    o[_] = o[w], o[w] = k;
                                                }
                                                A = s[c - 1];
                                                if (s[c - 1] = s[h], s[h] = A, u < h) {
                                                    for(c = h - 1; l < c && o[f * (c - 1) + e1] === p;)c -= 1;
                                                    c += 1;
                                                } else {
                                                    if (!(h < u)) break;
                                                    for(l = h + 1; l < c && o[f * l + e1] === p;)l += 1;
                                                }
                                            }
                                            return n(t1, e1, r, u, o, s, o[f * u + e1]);
                                        };
                                        var n = t1("./partition")("lo<p0");
                                        function i(t1, e1, r, n, i, a) {
                                            for(var o = 2 * t1, s = o * (r + 1) + e1, l = r + 1; l < n; ++l, s += o)for(var c = i[s], u = l, f = o * (l - 1); u > r && i[f + e1] > c; --u, f -= o){
                                                for(var h = f, p = f + o, d = 0; d < o; ++d, ++h, ++p){
                                                    var m = i[h];
                                                    i[h] = i[p], i[p] = m;
                                                }
                                                var g = a[u];
                                                a[u] = a[u - 1], a[u - 1] = g;
                                            }
                                        }
                                    },
                                    {
                                        "./partition": 39
                                    }
                                ],
                                39: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            return n[t1];
                                        };
                                        var n = {
                                            "lo===p0": function(t1, e1, r, n, i, a, o) {
                                                for(var s = 2 * t1, l = s * r, c = l, u = r, f = e1, h = r; n > h; ++h, l += s)if (i[l + f] === o) {
                                                    if (u === h) u += 1, c += s;
                                                    else {
                                                        for(var p = 0; s > p; ++p){
                                                            var d = i[l + p];
                                                            i[l + p] = i[c], i[c++] = d;
                                                        }
                                                        var m = a[h];
                                                        a[h] = a[u], a[u++] = m;
                                                    }
                                                }
                                                return u;
                                            },
                                            "lo<p0": function(t1, e1, r, n, i, a, o) {
                                                for(var s = 2 * t1, l = s * r, c = l, u = r, f = e1, h = r; n > h; ++h, l += s)if (i[l + f] < o) {
                                                    if (u === h) u += 1, c += s;
                                                    else {
                                                        for(var p = 0; s > p; ++p){
                                                            var d = i[l + p];
                                                            i[l + p] = i[c], i[c++] = d;
                                                        }
                                                        var m = a[h];
                                                        a[h] = a[u], a[u++] = m;
                                                    }
                                                }
                                                return u;
                                            },
                                            "lo<=p0": function(t1, e1, r, n, i, a, o) {
                                                for(var s = 2 * t1, l = s * r, c = l, u = r, f = t1 + e1, h = r; n > h; ++h, l += s)if (i[l + f] <= o) {
                                                    if (u === h) u += 1, c += s;
                                                    else {
                                                        for(var p = 0; s > p; ++p){
                                                            var d = i[l + p];
                                                            i[l + p] = i[c], i[c++] = d;
                                                        }
                                                        var m = a[h];
                                                        a[h] = a[u], a[u++] = m;
                                                    }
                                                }
                                                return u;
                                            },
                                            "hi<=p0": function(t1, e1, r, n, i, a, o) {
                                                for(var s = 2 * t1, l = s * r, c = l, u = r, f = t1 + e1, h = r; n > h; ++h, l += s)if (i[l + f] <= o) {
                                                    if (u === h) u += 1, c += s;
                                                    else {
                                                        for(var p = 0; s > p; ++p){
                                                            var d = i[l + p];
                                                            i[l + p] = i[c], i[c++] = d;
                                                        }
                                                        var m = a[h];
                                                        a[h] = a[u], a[u++] = m;
                                                    }
                                                }
                                                return u;
                                            },
                                            "lo<p0&&p0<=hi": function(t1, e1, r, n, i, a, o) {
                                                for(var s = 2 * t1, l = s * r, c = l, u = r, f = e1, h = t1 + e1, p = r; n > p; ++p, l += s){
                                                    var d = i[l + f], m = i[l + h];
                                                    if (d < o && o <= m) {
                                                        if (u === p) u += 1, c += s;
                                                        else {
                                                            for(var g = 0; s > g; ++g){
                                                                var v = i[l + g];
                                                                i[l + g] = i[c], i[c++] = v;
                                                            }
                                                            var y = a[p];
                                                            a[p] = a[u], a[u++] = y;
                                                        }
                                                    }
                                                }
                                                return u;
                                            },
                                            "lo<=p0&&p0<=hi": function(t1, e1, r, n, i, a, o) {
                                                for(var s = 2 * t1, l = s * r, c = l, u = r, f = e1, h = t1 + e1, p = r; n > p; ++p, l += s){
                                                    var d = i[l + f], m = i[l + h];
                                                    if (d <= o && o <= m) {
                                                        if (u === p) u += 1, c += s;
                                                        else {
                                                            for(var g = 0; s > g; ++g){
                                                                var v = i[l + g];
                                                                i[l + g] = i[c], i[c++] = v;
                                                            }
                                                            var y = a[p];
                                                            a[p] = a[u], a[u++] = y;
                                                        }
                                                    }
                                                }
                                                return u;
                                            },
                                            "!(lo>=p0)&&!(p1>=hi)": function(t1, e1, r, n, i, a, o, s) {
                                                for(var l = 2 * t1, c = l * r, u = c, f = r, h = e1, p = t1 + e1, d = r; n > d; ++d, c += l){
                                                    var m = i[c + h], g = i[c + p];
                                                    if (!(m >= o || s >= g)) {
                                                        if (f === d) f += 1, u += l;
                                                        else {
                                                            for(var v = 0; l > v; ++v){
                                                                var y = i[c + v];
                                                                i[c + v] = i[u], i[u++] = y;
                                                            }
                                                            var x = a[d];
                                                            a[d] = a[f], a[f++] = x;
                                                        }
                                                    }
                                                }
                                                return f;
                                            }
                                        };
                                    },
                                    {}
                                ],
                                40: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            e1 <= 128 ? n(0, e1 - 1, t1) : function t1(e1, r, u) {
                                                var f = (r - e1 + 1) / 6 | 0, h = e1 + f, p = r - f, d = e1 + r >> 1, m = d - f, g = d + f, v = h, y = m, x = d, b = g, _ = p, w = e1 + 1, T = r - 1, k = 0;
                                                l(v, y, u) && (k = v, v = y, y = k);
                                                l(b, _, u) && (k = b, b = _, _ = k);
                                                l(v, x, u) && (k = v, v = x, x = k);
                                                l(y, x, u) && (k = y, y = x, x = k);
                                                l(v, b, u) && (k = v, v = b, b = k);
                                                l(x, b, u) && (k = x, x = b, b = k);
                                                l(y, _, u) && (k = y, y = _, _ = k);
                                                l(y, x, u) && (k = y, y = x, x = k);
                                                l(b, _, u) && (k = b, b = _, _ = k);
                                                for(var A = u[2 * y], M = u[2 * y + 1], S = u[2 * b], E = u[2 * b + 1], L = 2 * v, C = 2 * x, P = 2 * _, I = 2 * h, O = 2 * d, z = 2 * p, D = 0; D < 2; ++D){
                                                    var R = u[L + D], F = u[C + D], B = u[P + D];
                                                    u[I + D] = R, u[O + D] = F, u[z + D] = B;
                                                }
                                                a(m, e1, u), a(g, r, u);
                                                for(var N = w; N <= T; ++N)if (c(N, A, M, u)) N !== w && i(N, w, u), ++w;
                                                else if (!c(N, S, E, u)) for(;;){
                                                    if (c(T, S, E, u)) {
                                                        c(T, A, M, u) ? (o(N, w, T, u), ++w, --T) : (i(N, T, u), --T);
                                                        break;
                                                    }
                                                    if (--T < N) break;
                                                }
                                                s(e1, w - 1, A, M, u), s(r, T + 1, S, E, u), w - 2 - e1 <= 32 ? n(e1, w - 2, u) : t1(e1, w - 2, u);
                                                r - (T + 2) <= 32 ? n(T + 2, r, u) : t1(T + 2, r, u);
                                                T - w <= 32 ? n(w, T, u) : t1(w, T, u);
                                            }(0, e1 - 1, t1);
                                        };
                                        function n(t1, e1, r) {
                                            for(var n = 2 * (t1 + 1), i = t1 + 1; i <= e1; ++i){
                                                for(var a = r[n++], o = r[n++], s = i, l = n - 2; s-- > t1;){
                                                    var c = r[l - 2], u = r[l - 1];
                                                    if (c < a) break;
                                                    if (c === a && u < o) break;
                                                    r[l] = c, r[l + 1] = u, l -= 2;
                                                }
                                                r[l] = a, r[l + 1] = o;
                                            }
                                        }
                                        function i(t1, e1, r) {
                                            e1 *= 2;
                                            var n = r[t1 *= 2], i = r[t1 + 1];
                                            r[t1] = r[e1], r[t1 + 1] = r[e1 + 1], r[e1] = n, r[e1 + 1] = i;
                                        }
                                        function a(t1, e1, r) {
                                            e1 *= 2, r[t1 *= 2] = r[e1], r[t1 + 1] = r[e1 + 1];
                                        }
                                        function o(t1, e1, r, n) {
                                            e1 *= 2, r *= 2;
                                            var i = n[t1 *= 2], a = n[t1 + 1];
                                            n[t1] = n[e1], n[t1 + 1] = n[e1 + 1], n[e1] = n[r], n[e1 + 1] = n[r + 1], n[r] = i, n[r + 1] = a;
                                        }
                                        function s(t1, e1, r, n, i) {
                                            e1 *= 2, i[t1 *= 2] = i[e1], i[e1] = r, i[t1 + 1] = i[e1 + 1], i[e1 + 1] = n;
                                        }
                                        function l(t1, e1, r) {
                                            e1 *= 2;
                                            var n = r[t1 *= 2], i = r[e1];
                                            return !(n < i) && (n !== i || r[t1 + 1] > r[e1 + 1]);
                                        }
                                        function c(t1, e1, r, n) {
                                            var i = n[t1 *= 2];
                                            return i < e1 || i === e1 && n[t1 + 1] < r;
                                        }
                                    },
                                    {}
                                ],
                                41: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = {
                                            init: function(t1) {
                                                var e1 = i.nextPow2(t1);
                                                o.length < e1 && (n.free(o), o = n.mallocInt32(e1));
                                                s.length < e1 && (n.free(s), s = n.mallocInt32(e1));
                                                l.length < e1 && (n.free(l), l = n.mallocInt32(e1));
                                                c.length < e1 && (n.free(c), c = n.mallocInt32(e1));
                                                u.length < e1 && (n.free(u), u = n.mallocInt32(e1));
                                                f.length < e1 && (n.free(f), f = n.mallocInt32(e1));
                                                var r = 8 * e1;
                                                h.length < r && (n.free(h), h = n.mallocDouble(r));
                                            },
                                            sweepBipartite: function(t1, e1, r, n, i, u, f, m, g, v) {
                                                for(var y = 0, x = 2 * t1, b = t1 - 1, _ = x - 1, w = r; w < n; ++w){
                                                    var T = u[w], k = x * w;
                                                    h[y++] = i[k + b], h[y++] = -(T + 1), h[y++] = i[k + _], h[y++] = T;
                                                }
                                                for(w = f; w < m; ++w){
                                                    T = v[w] + 268435456;
                                                    var A = x * w;
                                                    h[y++] = g[A + b], h[y++] = -T, h[y++] = g[A + _], h[y++] = T;
                                                }
                                                var M = y >>> 1;
                                                a(h, M);
                                                var S = 0, E = 0;
                                                for(w = 0; w < M; ++w){
                                                    var L = 0 | h[2 * w + 1];
                                                    if (L >= 268435456) p(l, c, E--, L = L - 268435456 | 0);
                                                    else if (L >= 0) p(o, s, S--, L);
                                                    else if (L <= -268435456) {
                                                        L = -L - 268435456 | 0;
                                                        for(var C = 0; C < S; ++C){
                                                            if (void 0 !== (P = e1(o[C], L))) return P;
                                                        }
                                                        d(l, c, E++, L);
                                                    } else {
                                                        L = -L - 1 | 0;
                                                        for(C = 0; C < E; ++C){
                                                            var P;
                                                            if (void 0 !== (P = e1(L, l[C]))) return P;
                                                        }
                                                        d(o, s, S++, L);
                                                    }
                                                }
                                            },
                                            sweepComplete: function(t1, e1, r, n, i, m, g, v, y, x) {
                                                for(var b = 0, _ = 2 * t1, w = t1 - 1, T = _ - 1, k = r; k < n; ++k){
                                                    var A = m[k] + 1 << 1, M = _ * k;
                                                    h[b++] = i[M + w], h[b++] = -A, h[b++] = i[M + T], h[b++] = A;
                                                }
                                                for(k = g; k < v; ++k){
                                                    A = x[k] + 1 << 1;
                                                    var S = _ * k;
                                                    h[b++] = y[S + w], h[b++] = 1 | -A, h[b++] = y[S + T], h[b++] = 1 | A;
                                                }
                                                var E = b >>> 1;
                                                a(h, E);
                                                var L = 0, C = 0, P = 0;
                                                for(k = 0; k < E; ++k){
                                                    var I = 0 | h[2 * k + 1], O = 1 & I;
                                                    if (k < E - 1 && I >> 1 == h[2 * k + 3] >> 1 && (O = 2, k += 1), I < 0) {
                                                        for(var z = -(I >> 1) - 1, D = 0; D < P; ++D){
                                                            if (void 0 !== (R = e1(u[D], z))) return R;
                                                        }
                                                        if (0 !== O) for(D = 0; D < L; ++D){
                                                            if (void 0 !== (R = e1(o[D], z))) return R;
                                                        }
                                                        if (1 !== O) for(D = 0; D < C; ++D){
                                                            var R;
                                                            if (void 0 !== (R = e1(l[D], z))) return R;
                                                        }
                                                        0 === O ? d(o, s, L++, z) : 1 === O ? d(l, c, C++, z) : 2 === O && d(u, f, P++, z);
                                                    } else {
                                                        z = (I >> 1) - 1;
                                                        0 === O ? p(o, s, L--, z) : 1 === O ? p(l, c, C--, z) : 2 === O && p(u, f, P--, z);
                                                    }
                                                }
                                            },
                                            scanBipartite: function(t1, e1, r, n, i, l, c, u, f, m, g, v) {
                                                var y = 0, x = 2 * t1, b = e1, _ = e1 + t1, w = 1, T = 1;
                                                n ? T = 268435456 : w = 268435456;
                                                for(var k = i; k < l; ++k){
                                                    var A = k + w, M = x * k;
                                                    h[y++] = c[M + b], h[y++] = -A, h[y++] = c[M + _], h[y++] = A;
                                                }
                                                for(k = f; k < m; ++k){
                                                    A = k + T;
                                                    var S = x * k;
                                                    h[y++] = g[S + b], h[y++] = -A;
                                                }
                                                var E = y >>> 1;
                                                a(h, E);
                                                var L = 0;
                                                for(k = 0; k < E; ++k){
                                                    var C = 0 | h[2 * k + 1];
                                                    if (C < 0) {
                                                        var P = !1;
                                                        if ((A = -C) >= 268435456 ? (P = !n, A -= 268435456) : (P = !!n, A -= 1), P) d(o, s, L++, A);
                                                        else {
                                                            var I = v[A], O = x * A, z = g[O + e1 + 1], D = g[O + e1 + 1 + t1];
                                                            t: for(var R = 0; R < L; ++R){
                                                                var F = o[R], B = x * F;
                                                                if (!(D < c[B + e1 + 1] || c[B + e1 + 1 + t1] < z)) {
                                                                    for(var N = e1 + 2; N < t1; ++N)if (g[O + N + t1] < c[B + N] || c[B + N + t1] < g[O + N]) continue t;
                                                                    var j, U = u[F];
                                                                    if (void 0 !== (j = n ? r(I, U) : r(U, I))) return j;
                                                                }
                                                            }
                                                        }
                                                    } else p(o, s, L--, C - w);
                                                }
                                            },
                                            scanComplete: function(t1, e1, r, n, i, s, l, c, u, f, p) {
                                                for(var d = 0, m = 2 * t1, g = e1, v = e1 + t1, y = n; y < i; ++y){
                                                    var x = y + 268435456, b = m * y;
                                                    h[d++] = s[b + g], h[d++] = -x, h[d++] = s[b + v], h[d++] = x;
                                                }
                                                for(y = c; y < u; ++y){
                                                    x = y + 1;
                                                    var _ = m * y;
                                                    h[d++] = f[_ + g], h[d++] = -x;
                                                }
                                                var w = d >>> 1;
                                                a(h, w);
                                                var T = 0;
                                                for(y = 0; y < w; ++y){
                                                    var k = 0 | h[2 * y + 1];
                                                    if (k < 0) {
                                                        if ((x = -k) >= 268435456) o[T++] = x - 268435456;
                                                        else {
                                                            var A = p[x -= 1], M = m * x, S = f[M + e1 + 1], E = f[M + e1 + 1 + t1];
                                                            t: for(var L = 0; L < T; ++L){
                                                                var C = o[L], P = l[C];
                                                                if (P === A) break;
                                                                var I = m * C;
                                                                if (!(E < s[I + e1 + 1] || s[I + e1 + 1 + t1] < S)) {
                                                                    for(var O = e1 + 2; O < t1; ++O)if (f[M + O + t1] < s[I + O] || s[I + O + t1] < f[M + O]) continue t;
                                                                    var z = r(P, A);
                                                                    if (void 0 !== z) return z;
                                                                }
                                                            }
                                                        }
                                                    } else {
                                                        for(x = k - 268435456, L = T - 1; L >= 0; --L)if (o[L] === x) {
                                                            for(O = L + 1; O < T; ++O)o[O - 1] = o[O];
                                                            break;
                                                        }
                                                        --T;
                                                    }
                                                }
                                            }
                                        };
                                        var n = t1("typedarray-pool"), i = t1("bit-twiddle"), a = t1("./sort"), o = n.mallocInt32(1024), s = n.mallocInt32(1024), l = n.mallocInt32(1024), c = n.mallocInt32(1024), u = n.mallocInt32(1024), f = n.mallocInt32(1024), h = n.mallocDouble(8192);
                                        function p(t1, e1, r, n) {
                                            var i = e1[n], a = t1[r - 1];
                                            t1[i] = a, e1[a] = i;
                                        }
                                        function d(t1, e1, r, n) {
                                            t1[r] = n, e1[n] = r;
                                        }
                                    },
                                    {
                                        "./sort": 40,
                                        "bit-twiddle": 32,
                                        "typedarray-pool": 308
                                    }
                                ],
                                42: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./lib/monotone"), i = t1("./lib/triangulation"), a = t1("./lib/delaunay"), o = t1("./lib/filter");
                                        function s(t1) {
                                            return [
                                                Math.min(t1[0], t1[1]),
                                                Math.max(t1[0], t1[1])
                                            ];
                                        }
                                        function l(t1, e1) {
                                            return t1[0] - e1[0] || t1[1] - e1[1];
                                        }
                                        function c(t1, e1, r) {
                                            return e1 in t1 ? t1[e1] : r;
                                        }
                                        e1.exports = function(t1, e1, r) {
                                            Array.isArray(e1) ? (r = r || {}, e1 = e1 || []) : (r = e1 || {}, e1 = []);
                                            var u = !!c(r, "delaunay", !0), f = !!c(r, "interior", !0), h = !!c(r, "exterior", !0), p = !!c(r, "infinity", !1);
                                            if (!f && !h || 0 === t1.length) return [];
                                            var d = n(t1, e1);
                                            if (u || f !== h || p) {
                                                for(var m = i(t1.length, function(t1) {
                                                    return t1.map(s).sort(l);
                                                }(e1)), g = 0; g < d.length; ++g){
                                                    var v = d[g];
                                                    m.addTriangle(v[0], v[1], v[2]);
                                                }
                                                return u && a(t1, m), h ? f ? p ? o(m, 0, p) : m.cells() : o(m, 1, p) : o(m, -1);
                                            }
                                            return d;
                                        };
                                    },
                                    {
                                        "./lib/delaunay": 43,
                                        "./lib/filter": 44,
                                        "./lib/monotone": 45,
                                        "./lib/triangulation": 46
                                    }
                                ],
                                43: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("robust-in-sphere")[4];
                                        t1("binary-search-bounds");
                                        function i(t1, e1, r, i, a, o) {
                                            var s = e1.opposite(i, a);
                                            if (!(s < 0)) {
                                                if (a < i) {
                                                    var l = i;
                                                    i = a, a = l, l = o, o = s, s = l;
                                                }
                                                e1.isConstraint(i, a) || n(t1[i], t1[a], t1[o], t1[s]) < 0 && r.push(i, a);
                                            }
                                        }
                                        e1.exports = function(t1, e1) {
                                            for(var r = [], a = t1.length, o = e1.stars, s = 0; s < a; ++s)for(var l = o[s], c = 1; c < l.length; c += 2)if (!((p = l[c]) < s) && !e1.isConstraint(s, p)) {
                                                for(var u = l[c - 1], f = -1, h = 1; h < l.length; h += 2)if (l[h - 1] === p) {
                                                    f = l[h];
                                                    break;
                                                }
                                                f < 0 || n(t1[s], t1[p], t1[u], t1[f]) < 0 && r.push(s, p);
                                            }
                                            for(; r.length > 0;){
                                                for(var p = r.pop(), d = (s = r.pop(), u = -1, f = -1, l = o[s], 1); d < l.length; d += 2){
                                                    var m = l[d - 1], g = l[d];
                                                    m === p ? f = g : g === p && (u = m);
                                                }
                                                u < 0 || f < 0 || n(t1[s], t1[p], t1[u], t1[f]) >= 0 || (e1.flip(s, p), i(t1, e1, r, u, s, f), i(t1, e1, r, s, f, u), i(t1, e1, r, f, p, u), i(t1, e1, r, p, u, f));
                                            }
                                        };
                                    },
                                    {
                                        "binary-search-bounds": 31,
                                        "robust-in-sphere": 282
                                    }
                                ],
                                44: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n, i = t1("binary-search-bounds");
                                        function a(t1, e1, r, n, i, a, o) {
                                            this.cells = t1, this.neighbor = e1, this.flags = n, this.constraint = r, this.active = i, this.next = a, this.boundary = o;
                                        }
                                        function o(t1, e1) {
                                            return t1[0] - e1[0] || t1[1] - e1[1] || t1[2] - e1[2];
                                        }
                                        e1.exports = function(t1, e1, r) {
                                            var n = function(t1, e1) {
                                                for(var r = t1.cells(), n = r.length, i = 0; i < n; ++i){
                                                    var s = (v = r[i])[0], l = v[1], c = v[2];
                                                    l < c ? l < s && (v[0] = l, v[1] = c, v[2] = s) : c < s && (v[0] = c, v[1] = s, v[2] = l);
                                                }
                                                r.sort(o);
                                                var u = new Array(n);
                                                for(i = 0; i < u.length; ++i)u[i] = 0;
                                                var f = [], h = [], p = new Array(3 * n), d = new Array(3 * n), m = null;
                                                e1 && (m = []);
                                                var g = new a(r, p, d, u, f, h, m);
                                                for(i = 0; i < n; ++i)for(var v = r[i], y = 0; y < 3; ++y){
                                                    s = v[y], l = v[(y + 1) % 3];
                                                    var x = p[3 * i + y] = g.locate(l, s, t1.opposite(l, s)), b = d[3 * i + y] = t1.isConstraint(s, l);
                                                    x < 0 && (b ? h.push(i) : (f.push(i), u[i] = 1), e1 && m.push([
                                                        l,
                                                        s,
                                                        -1
                                                    ]));
                                                }
                                                return g;
                                            }(t1, r);
                                            if (0 === e1) return r ? n.cells.concat(n.boundary) : n.cells;
                                            var i = 1, s = n.active, l = n.next, c = n.flags, u = n.cells, f = n.constraint, h = n.neighbor;
                                            for(; s.length > 0 || l.length > 0;){
                                                for(; s.length > 0;){
                                                    var p = s.pop();
                                                    if (c[p] !== -i) {
                                                        c[p] = i;
                                                        u[p];
                                                        for(var d = 0; d < 3; ++d){
                                                            var m = h[3 * p + d];
                                                            m >= 0 && 0 === c[m] && (f[3 * p + d] ? l.push(m) : (s.push(m), c[m] = i));
                                                        }
                                                    }
                                                }
                                                var g = l;
                                                l = s, s = g, l.length = 0, i = -i;
                                            }
                                            var v = function(t1, e1, r) {
                                                for(var n = 0, i = 0; i < t1.length; ++i)e1[i] === r && (t1[n++] = t1[i]);
                                                return t1.length = n, t1;
                                            }(u, c, e1);
                                            if (r) return v.concat(n.boundary);
                                            return v;
                                        }, a.prototype.locate = (n = [
                                            0,
                                            0,
                                            0
                                        ], function(t1, e1, r) {
                                            var a = t1, s = e1, l = r;
                                            return e1 < r ? e1 < t1 && (a = e1, s = r, l = t1) : r < t1 && (a = r, s = t1, l = e1), a < 0 ? -1 : (n[0] = a, n[1] = s, n[2] = l, i.eq(this.cells, n, o));
                                        });
                                    },
                                    {
                                        "binary-search-bounds": 31
                                    }
                                ],
                                45: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("binary-search-bounds"), i = t1("robust-orientation")[3];
                                        function a(t1, e1, r, n, i) {
                                            this.a = t1, this.b = e1, this.idx = r, this.lowerIds = n, this.upperIds = i;
                                        }
                                        function o(t1, e1, r, n) {
                                            this.a = t1, this.b = e1, this.type = r, this.idx = n;
                                        }
                                        function s(t1, e1) {
                                            var r = t1.a[0] - e1.a[0] || t1.a[1] - e1.a[1] || t1.type - e1.type;
                                            return r || (0 !== t1.type && (r = i(t1.a, t1.b, e1.b)) ? r : t1.idx - e1.idx);
                                        }
                                        function l(t1, e1) {
                                            return i(t1.a, t1.b, e1);
                                        }
                                        function c(t1, e1, r, a, o) {
                                            for(var s = n.lt(e1, a, l), c = n.gt(e1, a, l), u = s; u < c; ++u){
                                                for(var f = e1[u], h = f.lowerIds, p = h.length; p > 1 && i(r[h[p - 2]], r[h[p - 1]], a) > 0;)t1.push([
                                                    h[p - 1],
                                                    h[p - 2],
                                                    o
                                                ]), p -= 1;
                                                h.length = p, h.push(o);
                                                var d = f.upperIds;
                                                for(p = d.length; p > 1 && i(r[d[p - 2]], r[d[p - 1]], a) < 0;)t1.push([
                                                    d[p - 2],
                                                    d[p - 1],
                                                    o
                                                ]), p -= 1;
                                                d.length = p, d.push(o);
                                            }
                                        }
                                        function u(t1, e1) {
                                            var r;
                                            return (r = t1.a[0] < e1.a[0] ? i(t1.a, t1.b, e1.a) : i(e1.b, e1.a, t1.a)) ? r : (r = e1.b[0] < t1.b[0] ? i(t1.a, t1.b, e1.b) : i(e1.b, e1.a, t1.b)) || t1.idx - e1.idx;
                                        }
                                        function f(t1, e1, r) {
                                            var i = n.le(t1, r, u), o = t1[i], s = o.upperIds, l = s[s.length - 1];
                                            o.upperIds = [
                                                l
                                            ], t1.splice(i + 1, 0, new a(r.a, r.b, r.idx, [
                                                l
                                            ], s));
                                        }
                                        function h(t1, e1, r) {
                                            var i = r.a;
                                            r.a = r.b, r.b = i;
                                            var a = n.eq(t1, r, u), o = t1[a];
                                            t1[a - 1].upperIds = o.upperIds, t1.splice(a, 1);
                                        }
                                        e1.exports = function(t1, e1) {
                                            for(var r = t1.length, n = e1.length, i = [], l = 0; l < r; ++l)i.push(new o(t1[l], null, 0, l));
                                            for(l = 0; l < n; ++l){
                                                var u = e1[l], p = t1[u[0]], d = t1[u[1]];
                                                p[0] < d[0] ? i.push(new o(p, d, 2, l), new o(d, p, 1, l)) : p[0] > d[0] && i.push(new o(d, p, 2, l), new o(p, d, 1, l));
                                            }
                                            i.sort(s);
                                            for(var m = i[0].a[0] - (1 + Math.abs(i[0].a[0])) * Math.pow(2, -52), g = [
                                                new a([
                                                    m,
                                                    1
                                                ], [
                                                    m,
                                                    0
                                                ], -1, [], [], [], [])
                                            ], v = [], y = (l = 0, i.length); l < y; ++l){
                                                var x = i[l], b = x.type;
                                                0 === b ? c(v, g, t1, x.a, x.idx) : 2 === b ? f(g, t1, x) : h(g, t1, x);
                                            }
                                            return v;
                                        };
                                    },
                                    {
                                        "binary-search-bounds": 31,
                                        "robust-orientation": 284
                                    }
                                ],
                                46: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("binary-search-bounds");
                                        function i(t1, e1) {
                                            this.stars = t1, this.edges = e1;
                                        }
                                        e1.exports = function(t1, e1) {
                                            for(var r = new Array(t1), n = 0; n < t1; ++n)r[n] = [];
                                            return new i(r, e1);
                                        };
                                        var a = i.prototype;
                                        function o(t1, e1, r) {
                                            for(var n = 1, i = t1.length; n < i; n += 2)if (t1[n - 1] === e1 && t1[n] === r) return t1[n - 1] = t1[i - 2], t1[n] = t1[i - 1], void (t1.length = i - 2);
                                        }
                                        a.isConstraint = function() {
                                            var t1 = [
                                                0,
                                                0
                                            ];
                                            function e1(t1, e1) {
                                                return t1[0] - e1[0] || t1[1] - e1[1];
                                            }
                                            return function(r, i) {
                                                return t1[0] = Math.min(r, i), t1[1] = Math.max(r, i), n.eq(this.edges, t1, e1) >= 0;
                                            };
                                        }(), a.removeTriangle = function(t1, e1, r) {
                                            var n = this.stars;
                                            o(n[t1], e1, r), o(n[e1], r, t1), o(n[r], t1, e1);
                                        }, a.addTriangle = function(t1, e1, r) {
                                            var n = this.stars;
                                            n[t1].push(e1, r), n[e1].push(r, t1), n[r].push(t1, e1);
                                        }, a.opposite = function(t1, e1) {
                                            for(var r = this.stars[e1], n = 1, i = r.length; n < i; n += 2)if (r[n] === t1) return r[n - 1];
                                            return -1;
                                        }, a.flip = function(t1, e1) {
                                            var r = this.opposite(t1, e1), n = this.opposite(e1, t1);
                                            this.removeTriangle(t1, e1, r), this.removeTriangle(e1, t1, n), this.addTriangle(t1, n, r), this.addTriangle(e1, r, n);
                                        }, a.edges = function() {
                                            for(var t1 = this.stars, e1 = [], r = 0, n = t1.length; r < n; ++r)for(var i = t1[r], a = 0, o = i.length; a < o; a += 2)e1.push([
                                                i[a],
                                                i[a + 1]
                                            ]);
                                            return e1;
                                        }, a.cells = function() {
                                            for(var t1 = this.stars, e1 = [], r = 0, n = t1.length; r < n; ++r)for(var i = t1[r], a = 0, o = i.length; a < o; a += 2){
                                                var s = i[a], l = i[a + 1];
                                                r < Math.min(s, l) && e1.push([
                                                    r,
                                                    s,
                                                    l
                                                ]);
                                            }
                                            return e1;
                                        };
                                    },
                                    {
                                        "binary-search-bounds": 31
                                    }
                                ],
                                47: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            for(var e1 = 1, r = 1; r < t1.length; ++r)for(var n = 0; n < r; ++n)if (t1[r] < t1[n]) e1 = -e1;
                                            else if (t1[n] === t1[r]) return 0;
                                            return e1;
                                        };
                                    },
                                    {}
                                ],
                                48: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("dup"), i = t1("robust-linear-solve");
                                        function a(t1, e1) {
                                            for(var r = 0, n = t1.length, i = 0; i < n; ++i)r += t1[i] * e1[i];
                                            return r;
                                        }
                                        function o(t1) {
                                            var e1 = t1.length;
                                            if (0 === e1) return [];
                                            t1[0].length;
                                            var r = n([
                                                t1.length + 1,
                                                t1.length + 1
                                            ], 1), o = n([
                                                t1.length + 1
                                            ], 1);
                                            r[e1][e1] = 0;
                                            for(var s = 0; s < e1; ++s){
                                                for(var l = 0; l <= s; ++l)r[l][s] = r[s][l] = 2 * a(t1[s], t1[l]);
                                                o[s] = a(t1[s], t1[s]);
                                            }
                                            var c = i(r, o), u = 0, f = c[e1 + 1];
                                            for(s = 0; s < f.length; ++s)u += f[s];
                                            var h = new Array(e1);
                                            for(s = 0; s < e1; ++s){
                                                f = c[s];
                                                var p = 0;
                                                for(l = 0; l < f.length; ++l)p += f[l];
                                                h[s] = p / u;
                                            }
                                            return h;
                                        }
                                        function s(t1) {
                                            if (0 === t1.length) return [];
                                            for(var e1 = t1[0].length, r = n([
                                                e1
                                            ]), i = o(t1), a = 0; a < t1.length; ++a)for(var s = 0; s < e1; ++s)r[s] += t1[a][s] * i[a];
                                            return r;
                                        }
                                        s.barycenetric = o, e1.exports = s;
                                    },
                                    {
                                        dup: 65,
                                        "robust-linear-solve": 283
                                    }
                                ],
                                49: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            for(var e1 = n(t1), r = 0, i = 0; i < t1.length; ++i)for(var a = t1[i], o = 0; o < e1.length; ++o)r += Math.pow(a[o] - e1[o], 2);
                                            return Math.sqrt(r / t1.length);
                                        };
                                        var n = t1("circumcenter");
                                    },
                                    {
                                        circumcenter: 48
                                    }
                                ],
                                50: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r) {
                                            var n;
                                            if (r) {
                                                n = e1;
                                                for(var i = new Array(e1.length), a = 0; a < e1.length; ++a){
                                                    var o = e1[a];
                                                    i[a] = [
                                                        o[0],
                                                        o[1],
                                                        r[a]
                                                    ];
                                                }
                                                e1 = i;
                                            }
                                            var s = function(t1, e1, r) {
                                                var n = d(t1, [], p(t1));
                                                return v(e1, n, r), !!n;
                                            }(t1, e1, !!r);
                                            for(; y(t1, e1, !!r);)s = !0;
                                            if (r && s) {
                                                n.length = 0, r.length = 0;
                                                for(a = 0; a < e1.length; ++a){
                                                    o = e1[a];
                                                    n.push([
                                                        o[0],
                                                        o[1]
                                                    ]), r.push(o[2]);
                                                }
                                            }
                                            return s;
                                        };
                                        var n = t1("union-find"), i = t1("box-intersect"), a = t1("robust-segment-intersect"), o = t1("big-rat"), s = t1("big-rat/cmp"), l = t1("big-rat/to-float"), c = t1("rat-vec"), u = t1("nextafter"), f = t1("./lib/rat-seg-intersect");
                                        function h(t1) {
                                            var e1 = l(t1);
                                            return [
                                                u(e1, -1 / 0),
                                                u(e1, 1 / 0)
                                            ];
                                        }
                                        function p(t1) {
                                            for(var e1 = new Array(t1.length), r = 0; r < t1.length; ++r){
                                                var n = t1[r];
                                                e1[r] = [
                                                    u(n[0], -1 / 0),
                                                    u(n[1], -1 / 0),
                                                    u(n[0], 1 / 0),
                                                    u(n[1], 1 / 0)
                                                ];
                                            }
                                            return e1;
                                        }
                                        function d(t1, e1, r) {
                                            for(var a = e1.length, o = new n(a), s = [], l = 0; l < e1.length; ++l){
                                                var c = e1[l], f = h(c[0]), p = h(c[1]);
                                                s.push([
                                                    u(f[0], -1 / 0),
                                                    u(p[0], -1 / 0),
                                                    u(f[1], 1 / 0),
                                                    u(p[1], 1 / 0)
                                                ]);
                                            }
                                            i(s, function(t1, e1) {
                                                o.link(t1, e1);
                                            });
                                            var d = !0, m = new Array(a);
                                            for(l = 0; l < a; ++l)(v = o.find(l)) !== l && (d = !1, t1[v] = [
                                                Math.min(t1[l][0], t1[v][0]),
                                                Math.min(t1[l][1], t1[v][1])
                                            ]);
                                            if (d) return null;
                                            var g = 0;
                                            for(l = 0; l < a; ++l){
                                                var v;
                                                (v = o.find(l)) === l ? (m[l] = g, t1[g++] = t1[l]) : m[l] = -1;
                                            }
                                            t1.length = g;
                                            for(l = 0; l < a; ++l)m[l] < 0 && (m[l] = m[o.find(l)]);
                                            return m;
                                        }
                                        function m(t1, e1) {
                                            return t1[0] - e1[0] || t1[1] - e1[1];
                                        }
                                        function g(t1, e1) {
                                            var r = t1[0] - e1[0] || t1[1] - e1[1];
                                            return r || (t1[2] < e1[2] ? -1 : t1[2] > e1[2] ? 1 : 0);
                                        }
                                        function v(t1, e1, r) {
                                            if (0 !== t1.length) {
                                                if (e1) for(var n = 0; n < t1.length; ++n){
                                                    var i = e1[(o = t1[n])[0]], a = e1[o[1]];
                                                    o[0] = Math.min(i, a), o[1] = Math.max(i, a);
                                                }
                                                else for(n = 0; n < t1.length; ++n){
                                                    var o;
                                                    i = (o = t1[n])[0], a = o[1];
                                                    o[0] = Math.min(i, a), o[1] = Math.max(i, a);
                                                }
                                                r ? t1.sort(g) : t1.sort(m);
                                                var s = 1;
                                                for(n = 1; n < t1.length; ++n){
                                                    var l = t1[n - 1], c = t1[n];
                                                    (c[0] !== l[0] || c[1] !== l[1] || r && c[2] !== l[2]) && (t1[s++] = c);
                                                }
                                                t1.length = s;
                                            }
                                        }
                                        function y(t1, e1, r) {
                                            var n = function(t1, e1) {
                                                for(var r = new Array(e1.length), n = 0; n < e1.length; ++n){
                                                    var i = e1[n], a = t1[i[0]], o = t1[i[1]];
                                                    r[n] = [
                                                        u(Math.min(a[0], o[0]), -1 / 0),
                                                        u(Math.min(a[1], o[1]), -1 / 0),
                                                        u(Math.max(a[0], o[0]), 1 / 0),
                                                        u(Math.max(a[1], o[1]), 1 / 0)
                                                    ];
                                                }
                                                return r;
                                            }(t1, e1), h = function(t1, e1, r) {
                                                var n = [];
                                                return i(r, function(r, i) {
                                                    var o = e1[r], s = e1[i];
                                                    if (o[0] !== s[0] && o[0] !== s[1] && o[1] !== s[0] && o[1] !== s[1]) {
                                                        var l = t1[o[0]], c = t1[o[1]], u = t1[s[0]], f = t1[s[1]];
                                                        a(l, c, u, f) && n.push([
                                                            r,
                                                            i
                                                        ]);
                                                    }
                                                }), n;
                                            }(t1, e1, n), m = p(t1), g = function(t1, e1, r, n) {
                                                var o = [];
                                                return i(r, n, function(r, n) {
                                                    var i = e1[r];
                                                    if (i[0] !== n && i[1] !== n) {
                                                        var s = t1[n], l = t1[i[0]], c = t1[i[1]];
                                                        a(l, c, s, s) && o.push([
                                                            r,
                                                            n
                                                        ]);
                                                    }
                                                }), o;
                                            }(t1, e1, n, m), y = d(t1, function(t1, e1, r, n, i) {
                                                var a, u, h = t1.map(function(t1) {
                                                    return [
                                                        o(t1[0]),
                                                        o(t1[1])
                                                    ];
                                                });
                                                for(a = 0; a < r.length; ++a){
                                                    var p = r[a];
                                                    u = p[0];
                                                    var d = p[1], m = e1[u], g = e1[d], v = f(c(t1[m[0]]), c(t1[m[1]]), c(t1[g[0]]), c(t1[g[1]]));
                                                    if (v) {
                                                        var y = t1.length;
                                                        t1.push([
                                                            l(v[0]),
                                                            l(v[1])
                                                        ]), h.push(v), n.push([
                                                            u,
                                                            y
                                                        ], [
                                                            d,
                                                            y
                                                        ]);
                                                    }
                                                }
                                                for(n.sort(function(t1, e1) {
                                                    if (t1[0] !== e1[0]) return t1[0] - e1[0];
                                                    var r = h[t1[1]], n = h[e1[1]];
                                                    return s(r[0], n[0]) || s(r[1], n[1]);
                                                }), a = n.length - 1; a >= 0; --a){
                                                    var x = e1[u = (S = n[a])[0]], b = x[0], _ = x[1], w = t1[b], T = t1[_];
                                                    if ((w[0] - T[0] || w[1] - T[1]) < 0) {
                                                        var k = b;
                                                        b = _, _ = k;
                                                    }
                                                    x[0] = b;
                                                    var A, M = x[1] = S[1];
                                                    for(i && (A = x[2]); a > 0 && n[a - 1][0] === u;){
                                                        var S, E = (S = n[--a])[1];
                                                        i ? e1.push([
                                                            M,
                                                            E,
                                                            A
                                                        ]) : e1.push([
                                                            M,
                                                            E
                                                        ]), M = E;
                                                    }
                                                    i ? e1.push([
                                                        M,
                                                        _,
                                                        A
                                                    ]) : e1.push([
                                                        M,
                                                        _
                                                    ]);
                                                }
                                                return h;
                                            }(t1, e1, h, g, r));
                                            return v(e1, y, r), !!y || h.length > 0 || g.length > 0;
                                        }
                                    },
                                    {
                                        "./lib/rat-seg-intersect": 51,
                                        "big-rat": 18,
                                        "big-rat/cmp": 16,
                                        "big-rat/to-float": 30,
                                        "box-intersect": 35,
                                        nextafter: 260,
                                        "rat-vec": 273,
                                        "robust-segment-intersect": 287,
                                        "union-find": 309
                                    }
                                ],
                                51: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r, n) {
                                            var a = s(e1, t1), f = s(n, r), h = u(a, f);
                                            if (0 === o(h)) return null;
                                            var p = s(t1, r), d = u(f, p), m = i(d, h), g = c(a, m);
                                            return l(t1, g);
                                        };
                                        var n = t1("big-rat/mul"), i = t1("big-rat/div"), a = t1("big-rat/sub"), o = t1("big-rat/sign"), s = t1("rat-vec/sub"), l = t1("rat-vec/add"), c = t1("rat-vec/muls");
                                        function u(t1, e1) {
                                            return a(n(t1[0], e1[1]), n(t1[1], e1[0]));
                                        }
                                    },
                                    {
                                        "big-rat/div": 17,
                                        "big-rat/mul": 27,
                                        "big-rat/sign": 28,
                                        "big-rat/sub": 29,
                                        "rat-vec/add": 272,
                                        "rat-vec/muls": 274,
                                        "rat-vec/sub": 275
                                    }
                                ],
                                52: [
                                    function(t1, e1, r) {
                                        e1.exports = {
                                            jet: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        131
                                                    ]
                                                },
                                                {
                                                    index: .125,
                                                    rgb: [
                                                        0,
                                                        60,
                                                        170
                                                    ]
                                                },
                                                {
                                                    index: .375,
                                                    rgb: [
                                                        5,
                                                        255,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: .625,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .875,
                                                    rgb: [
                                                        250,
                                                        0,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        128,
                                                        0,
                                                        0
                                                    ]
                                                }
                                            ],
                                            hsv: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        255,
                                                        0,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .169,
                                                    rgb: [
                                                        253,
                                                        255,
                                                        2
                                                    ]
                                                },
                                                {
                                                    index: .173,
                                                    rgb: [
                                                        247,
                                                        255,
                                                        2
                                                    ]
                                                },
                                                {
                                                    index: .337,
                                                    rgb: [
                                                        0,
                                                        252,
                                                        4
                                                    ]
                                                },
                                                {
                                                    index: .341,
                                                    rgb: [
                                                        0,
                                                        252,
                                                        10
                                                    ]
                                                },
                                                {
                                                    index: .506,
                                                    rgb: [
                                                        1,
                                                        249,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: .671,
                                                    rgb: [
                                                        2,
                                                        0,
                                                        253
                                                    ]
                                                },
                                                {
                                                    index: .675,
                                                    rgb: [
                                                        8,
                                                        0,
                                                        253
                                                    ]
                                                },
                                                {
                                                    index: .839,
                                                    rgb: [
                                                        255,
                                                        0,
                                                        251
                                                    ]
                                                },
                                                {
                                                    index: .843,
                                                    rgb: [
                                                        255,
                                                        0,
                                                        245
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        0,
                                                        6
                                                    ]
                                                }
                                            ],
                                            hot: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .3,
                                                    rgb: [
                                                        230,
                                                        0,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .6,
                                                    rgb: [
                                                        255,
                                                        210,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        255
                                                    ]
                                                }
                                            ],
                                            spring: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        255,
                                                        0,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        0
                                                    ]
                                                }
                                            ],
                                            summer: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        128,
                                                        102
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        102
                                                    ]
                                                }
                                            ],
                                            autumn: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        255,
                                                        0,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        0
                                                    ]
                                                }
                                            ],
                                            winter: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        0,
                                                        255,
                                                        128
                                                    ]
                                                }
                                            ],
                                            bone: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .376,
                                                    rgb: [
                                                        84,
                                                        84,
                                                        116
                                                    ]
                                                },
                                                {
                                                    index: .753,
                                                    rgb: [
                                                        169,
                                                        200,
                                                        200
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        255
                                                    ]
                                                }
                                            ],
                                            copper: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .804,
                                                    rgb: [
                                                        255,
                                                        160,
                                                        102
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        199,
                                                        127
                                                    ]
                                                }
                                            ],
                                            greys: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        255
                                                    ]
                                                }
                                            ],
                                            yignbu: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        8,
                                                        29,
                                                        88
                                                    ]
                                                },
                                                {
                                                    index: .125,
                                                    rgb: [
                                                        37,
                                                        52,
                                                        148
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        34,
                                                        94,
                                                        168
                                                    ]
                                                },
                                                {
                                                    index: .375,
                                                    rgb: [
                                                        29,
                                                        145,
                                                        192
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        65,
                                                        182,
                                                        196
                                                    ]
                                                },
                                                {
                                                    index: .625,
                                                    rgb: [
                                                        127,
                                                        205,
                                                        187
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        199,
                                                        233,
                                                        180
                                                    ]
                                                },
                                                {
                                                    index: .875,
                                                    rgb: [
                                                        237,
                                                        248,
                                                        217
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        217
                                                    ]
                                                }
                                            ],
                                            greens: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        68,
                                                        27
                                                    ]
                                                },
                                                {
                                                    index: .125,
                                                    rgb: [
                                                        0,
                                                        109,
                                                        44
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        35,
                                                        139,
                                                        69
                                                    ]
                                                },
                                                {
                                                    index: .375,
                                                    rgb: [
                                                        65,
                                                        171,
                                                        93
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        116,
                                                        196,
                                                        118
                                                    ]
                                                },
                                                {
                                                    index: .625,
                                                    rgb: [
                                                        161,
                                                        217,
                                                        155
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        199,
                                                        233,
                                                        192
                                                    ]
                                                },
                                                {
                                                    index: .875,
                                                    rgb: [
                                                        229,
                                                        245,
                                                        224
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        247,
                                                        252,
                                                        245
                                                    ]
                                                }
                                            ],
                                            yiorrd: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        128,
                                                        0,
                                                        38
                                                    ]
                                                },
                                                {
                                                    index: .125,
                                                    rgb: [
                                                        189,
                                                        0,
                                                        38
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        227,
                                                        26,
                                                        28
                                                    ]
                                                },
                                                {
                                                    index: .375,
                                                    rgb: [
                                                        252,
                                                        78,
                                                        42
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        253,
                                                        141,
                                                        60
                                                    ]
                                                },
                                                {
                                                    index: .625,
                                                    rgb: [
                                                        254,
                                                        178,
                                                        76
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        254,
                                                        217,
                                                        118
                                                    ]
                                                },
                                                {
                                                    index: .875,
                                                    rgb: [
                                                        255,
                                                        237,
                                                        160
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        204
                                                    ]
                                                }
                                            ],
                                            bluered: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        0,
                                                        0
                                                    ]
                                                }
                                            ],
                                            rdbu: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        5,
                                                        10,
                                                        172
                                                    ]
                                                },
                                                {
                                                    index: .35,
                                                    rgb: [
                                                        106,
                                                        137,
                                                        247
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        190,
                                                        190,
                                                        190
                                                    ]
                                                },
                                                {
                                                    index: .6,
                                                    rgb: [
                                                        220,
                                                        170,
                                                        132
                                                    ]
                                                },
                                                {
                                                    index: .7,
                                                    rgb: [
                                                        230,
                                                        145,
                                                        90
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        178,
                                                        10,
                                                        28
                                                    ]
                                                }
                                            ],
                                            picnic: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: .1,
                                                    rgb: [
                                                        51,
                                                        153,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: .2,
                                                    rgb: [
                                                        102,
                                                        204,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: .3,
                                                    rgb: [
                                                        153,
                                                        204,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: .4,
                                                    rgb: [
                                                        204,
                                                        204,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: .6,
                                                    rgb: [
                                                        255,
                                                        204,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: .7,
                                                    rgb: [
                                                        255,
                                                        153,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: .8,
                                                    rgb: [
                                                        255,
                                                        102,
                                                        204
                                                    ]
                                                },
                                                {
                                                    index: .9,
                                                    rgb: [
                                                        255,
                                                        102,
                                                        102
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        0,
                                                        0
                                                    ]
                                                }
                                            ],
                                            rainbow: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        150,
                                                        0,
                                                        90
                                                    ]
                                                },
                                                {
                                                    index: .125,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        200
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        0,
                                                        25,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: .375,
                                                    rgb: [
                                                        0,
                                                        152,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        44,
                                                        255,
                                                        150
                                                    ]
                                                },
                                                {
                                                    index: .625,
                                                    rgb: [
                                                        151,
                                                        255,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        255,
                                                        234,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .875,
                                                    rgb: [
                                                        255,
                                                        111,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        0,
                                                        0
                                                    ]
                                                }
                                            ],
                                            portland: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        12,
                                                        51,
                                                        131
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        10,
                                                        136,
                                                        186
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        242,
                                                        211,
                                                        56
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        242,
                                                        143,
                                                        56
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        217,
                                                        30,
                                                        30
                                                    ]
                                                }
                                            ],
                                            blackbody: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .2,
                                                    rgb: [
                                                        230,
                                                        0,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .4,
                                                    rgb: [
                                                        230,
                                                        210,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .7,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        255
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        160,
                                                        200,
                                                        255
                                                    ]
                                                }
                                            ],
                                            earth: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        130
                                                    ]
                                                },
                                                {
                                                    index: .1,
                                                    rgb: [
                                                        0,
                                                        180,
                                                        180
                                                    ]
                                                },
                                                {
                                                    index: .2,
                                                    rgb: [
                                                        40,
                                                        210,
                                                        40
                                                    ]
                                                },
                                                {
                                                    index: .4,
                                                    rgb: [
                                                        230,
                                                        230,
                                                        50
                                                    ]
                                                },
                                                {
                                                    index: .6,
                                                    rgb: [
                                                        120,
                                                        70,
                                                        20
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        255
                                                    ]
                                                }
                                            ],
                                            electric: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .15,
                                                    rgb: [
                                                        30,
                                                        0,
                                                        100
                                                    ]
                                                },
                                                {
                                                    index: .4,
                                                    rgb: [
                                                        120,
                                                        0,
                                                        100
                                                    ]
                                                },
                                                {
                                                    index: .6,
                                                    rgb: [
                                                        160,
                                                        90,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .8,
                                                    rgb: [
                                                        230,
                                                        200,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        250,
                                                        220
                                                    ]
                                                }
                                            ],
                                            alpha: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        255,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        255,
                                                        255,
                                                        1
                                                    ]
                                                }
                                            ],
                                            viridis: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        68,
                                                        1,
                                                        84
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        71,
                                                        44,
                                                        122
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        59,
                                                        81,
                                                        139
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        44,
                                                        113,
                                                        142
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        33,
                                                        144,
                                                        141
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        39,
                                                        173,
                                                        129
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        92,
                                                        200,
                                                        99
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        170,
                                                        220,
                                                        50
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        253,
                                                        231,
                                                        37
                                                    ]
                                                }
                                            ],
                                            inferno: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        4
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        31,
                                                        12,
                                                        72
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        85,
                                                        15,
                                                        109
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        136,
                                                        34,
                                                        106
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        186,
                                                        54,
                                                        85
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        227,
                                                        89,
                                                        51
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        249,
                                                        140,
                                                        10
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        249,
                                                        201,
                                                        50
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        252,
                                                        255,
                                                        164
                                                    ]
                                                }
                                            ],
                                            magma: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        4
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        28,
                                                        16,
                                                        68
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        79,
                                                        18,
                                                        123
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        129,
                                                        37,
                                                        129
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        181,
                                                        54,
                                                        122
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        229,
                                                        80,
                                                        100
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        251,
                                                        135,
                                                        97
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        254,
                                                        194,
                                                        135
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        252,
                                                        253,
                                                        191
                                                    ]
                                                }
                                            ],
                                            plasma: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        13,
                                                        8,
                                                        135
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        75,
                                                        3,
                                                        161
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        125,
                                                        3,
                                                        168
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        168,
                                                        34,
                                                        150
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        203,
                                                        70,
                                                        121
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        229,
                                                        107,
                                                        93
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        248,
                                                        148,
                                                        65
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        253,
                                                        195,
                                                        40
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        240,
                                                        249,
                                                        33
                                                    ]
                                                }
                                            ],
                                            warm: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        125,
                                                        0,
                                                        179
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        172,
                                                        0,
                                                        187
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        219,
                                                        0,
                                                        170
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        255,
                                                        0,
                                                        130
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        255,
                                                        63,
                                                        74
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        255,
                                                        123,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        234,
                                                        176,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        190,
                                                        228,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        147,
                                                        255,
                                                        0
                                                    ]
                                                }
                                            ],
                                            cool: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        125,
                                                        0,
                                                        179
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        116,
                                                        0,
                                                        218
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        98,
                                                        74,
                                                        237
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        68,
                                                        146,
                                                        231
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        0,
                                                        204,
                                                        197
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        0,
                                                        247,
                                                        146
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        0,
                                                        255,
                                                        88
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        40,
                                                        255,
                                                        8
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        147,
                                                        255,
                                                        0
                                                    ]
                                                }
                                            ],
                                            "rainbow-soft": [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        125,
                                                        0,
                                                        179
                                                    ]
                                                },
                                                {
                                                    index: .1,
                                                    rgb: [
                                                        199,
                                                        0,
                                                        180
                                                    ]
                                                },
                                                {
                                                    index: .2,
                                                    rgb: [
                                                        255,
                                                        0,
                                                        121
                                                    ]
                                                },
                                                {
                                                    index: .3,
                                                    rgb: [
                                                        255,
                                                        108,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .4,
                                                    rgb: [
                                                        222,
                                                        194,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        150,
                                                        255,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .6,
                                                    rgb: [
                                                        0,
                                                        255,
                                                        55
                                                    ]
                                                },
                                                {
                                                    index: .7,
                                                    rgb: [
                                                        0,
                                                        246,
                                                        150
                                                    ]
                                                },
                                                {
                                                    index: .8,
                                                    rgb: [
                                                        50,
                                                        167,
                                                        222
                                                    ]
                                                },
                                                {
                                                    index: .9,
                                                    rgb: [
                                                        103,
                                                        51,
                                                        235
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        124,
                                                        0,
                                                        186
                                                    ]
                                                }
                                            ],
                                            bathymetry: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        40,
                                                        26,
                                                        44
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        59,
                                                        49,
                                                        90
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        64,
                                                        76,
                                                        139
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        63,
                                                        110,
                                                        151
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        72,
                                                        142,
                                                        158
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        85,
                                                        174,
                                                        163
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        120,
                                                        206,
                                                        163
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        187,
                                                        230,
                                                        172
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        253,
                                                        254,
                                                        204
                                                    ]
                                                }
                                            ],
                                            cdom: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        47,
                                                        15,
                                                        62
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        87,
                                                        23,
                                                        86
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        130,
                                                        28,
                                                        99
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        171,
                                                        41,
                                                        96
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        206,
                                                        67,
                                                        86
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        230,
                                                        106,
                                                        84
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        242,
                                                        149,
                                                        103
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        249,
                                                        193,
                                                        135
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        254,
                                                        237,
                                                        176
                                                    ]
                                                }
                                            ],
                                            chlorophyll: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        18,
                                                        36,
                                                        20
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        25,
                                                        63,
                                                        41
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        24,
                                                        91,
                                                        59
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        13,
                                                        119,
                                                        72
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        18,
                                                        148,
                                                        80
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        80,
                                                        173,
                                                        89
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        132,
                                                        196,
                                                        122
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        175,
                                                        221,
                                                        162
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        215,
                                                        249,
                                                        208
                                                    ]
                                                }
                                            ],
                                            density: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        54,
                                                        14,
                                                        36
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        89,
                                                        23,
                                                        80
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        110,
                                                        45,
                                                        132
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        120,
                                                        77,
                                                        178
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        120,
                                                        113,
                                                        213
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        115,
                                                        151,
                                                        228
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        134,
                                                        185,
                                                        227
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        177,
                                                        214,
                                                        227
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        230,
                                                        241,
                                                        241
                                                    ]
                                                }
                                            ],
                                            "freesurface-blue": [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        30,
                                                        4,
                                                        110
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        47,
                                                        14,
                                                        176
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        41,
                                                        45,
                                                        236
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        25,
                                                        99,
                                                        212
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        68,
                                                        131,
                                                        200
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        114,
                                                        156,
                                                        197
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        157,
                                                        181,
                                                        203
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        200,
                                                        208,
                                                        216
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        241,
                                                        237,
                                                        236
                                                    ]
                                                }
                                            ],
                                            "freesurface-red": [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        60,
                                                        9,
                                                        18
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        100,
                                                        17,
                                                        27
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        142,
                                                        20,
                                                        29
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        177,
                                                        43,
                                                        27
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        192,
                                                        87,
                                                        63
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        205,
                                                        125,
                                                        105
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        216,
                                                        162,
                                                        148
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        227,
                                                        199,
                                                        193
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        241,
                                                        237,
                                                        236
                                                    ]
                                                }
                                            ],
                                            oxygen: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        64,
                                                        5,
                                                        5
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        106,
                                                        6,
                                                        15
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        144,
                                                        26,
                                                        7
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        168,
                                                        64,
                                                        3
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        188,
                                                        100,
                                                        4
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        206,
                                                        136,
                                                        11
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        220,
                                                        174,
                                                        25
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        231,
                                                        215,
                                                        44
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        248,
                                                        254,
                                                        105
                                                    ]
                                                }
                                            ],
                                            par: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        51,
                                                        20,
                                                        24
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        90,
                                                        32,
                                                        35
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        129,
                                                        44,
                                                        34
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        159,
                                                        68,
                                                        25
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        182,
                                                        99,
                                                        19
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        199,
                                                        134,
                                                        22
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        212,
                                                        171,
                                                        35
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        221,
                                                        210,
                                                        54
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        225,
                                                        253,
                                                        75
                                                    ]
                                                }
                                            ],
                                            phase: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        145,
                                                        105,
                                                        18
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        184,
                                                        71,
                                                        38
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        186,
                                                        58,
                                                        115
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        160,
                                                        71,
                                                        185
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        110,
                                                        97,
                                                        218
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        50,
                                                        123,
                                                        164
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        31,
                                                        131,
                                                        110
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        77,
                                                        129,
                                                        34
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        145,
                                                        105,
                                                        18
                                                    ]
                                                }
                                            ],
                                            salinity: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        42,
                                                        24,
                                                        108
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        33,
                                                        50,
                                                        162
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        15,
                                                        90,
                                                        145
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        40,
                                                        118,
                                                        137
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        59,
                                                        146,
                                                        135
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        79,
                                                        175,
                                                        126
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        120,
                                                        203,
                                                        104
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        193,
                                                        221,
                                                        100
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        253,
                                                        239,
                                                        154
                                                    ]
                                                }
                                            ],
                                            temperature: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        4,
                                                        35,
                                                        51
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        23,
                                                        51,
                                                        122
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        85,
                                                        59,
                                                        157
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        129,
                                                        79,
                                                        143
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        175,
                                                        95,
                                                        130
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        222,
                                                        112,
                                                        101
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        249,
                                                        146,
                                                        66
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        249,
                                                        196,
                                                        65
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        232,
                                                        250,
                                                        91
                                                    ]
                                                }
                                            ],
                                            turbidity: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        34,
                                                        31,
                                                        27
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        65,
                                                        50,
                                                        41
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        98,
                                                        69,
                                                        52
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        131,
                                                        89,
                                                        57
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        161,
                                                        112,
                                                        59
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        185,
                                                        140,
                                                        66
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        202,
                                                        174,
                                                        88
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        216,
                                                        209,
                                                        126
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        233,
                                                        246,
                                                        171
                                                    ]
                                                }
                                            ],
                                            "velocity-blue": [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        17,
                                                        32,
                                                        64
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        35,
                                                        52,
                                                        116
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        29,
                                                        81,
                                                        156
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        31,
                                                        113,
                                                        162
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        50,
                                                        144,
                                                        169
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        87,
                                                        173,
                                                        176
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        149,
                                                        196,
                                                        189
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        203,
                                                        221,
                                                        211
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        254,
                                                        251,
                                                        230
                                                    ]
                                                }
                                            ],
                                            "velocity-green": [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        23,
                                                        35,
                                                        19
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        24,
                                                        64,
                                                        38
                                                    ]
                                                },
                                                {
                                                    index: .25,
                                                    rgb: [
                                                        11,
                                                        95,
                                                        45
                                                    ]
                                                },
                                                {
                                                    index: .38,
                                                    rgb: [
                                                        39,
                                                        123,
                                                        35
                                                    ]
                                                },
                                                {
                                                    index: .5,
                                                    rgb: [
                                                        95,
                                                        146,
                                                        12
                                                    ]
                                                },
                                                {
                                                    index: .63,
                                                    rgb: [
                                                        152,
                                                        165,
                                                        18
                                                    ]
                                                },
                                                {
                                                    index: .75,
                                                    rgb: [
                                                        201,
                                                        186,
                                                        69
                                                    ]
                                                },
                                                {
                                                    index: .88,
                                                    rgb: [
                                                        233,
                                                        216,
                                                        137
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        255,
                                                        253,
                                                        205
                                                    ]
                                                }
                                            ],
                                            cubehelix: [
                                                {
                                                    index: 0,
                                                    rgb: [
                                                        0,
                                                        0,
                                                        0
                                                    ]
                                                },
                                                {
                                                    index: .07,
                                                    rgb: [
                                                        22,
                                                        5,
                                                        59
                                                    ]
                                                },
                                                {
                                                    index: .13,
                                                    rgb: [
                                                        60,
                                                        4,
                                                        105
                                                    ]
                                                },
                                                {
                                                    index: .2,
                                                    rgb: [
                                                        109,
                                                        1,
                                                        135
                                                    ]
                                                },
                                                {
                                                    index: .27,
                                                    rgb: [
                                                        161,
                                                        0,
                                                        147
                                                    ]
                                                },
                                                {
                                                    index: .33,
                                                    rgb: [
                                                        210,
                                                        2,
                                                        142
                                                    ]
                                                },
                                                {
                                                    index: .4,
                                                    rgb: [
                                                        251,
                                                        11,
                                                        123
                                                    ]
                                                },
                                                {
                                                    index: .47,
                                                    rgb: [
                                                        255,
                                                        29,
                                                        97
                                                    ]
                                                },
                                                {
                                                    index: .53,
                                                    rgb: [
                                                        255,
                                                        54,
                                                        69
                                                    ]
                                                },
                                                {
                                                    index: .6,
                                                    rgb: [
                                                        255,
                                                        85,
                                                        46
                                                    ]
                                                },
                                                {
                                                    index: .67,
                                                    rgb: [
                                                        255,
                                                        120,
                                                        34
                                                    ]
                                                },
                                                {
                                                    index: .73,
                                                    rgb: [
                                                        255,
                                                        157,
                                                        37
                                                    ]
                                                },
                                                {
                                                    index: .8,
                                                    rgb: [
                                                        241,
                                                        191,
                                                        57
                                                    ]
                                                },
                                                {
                                                    index: .87,
                                                    rgb: [
                                                        224,
                                                        220,
                                                        93
                                                    ]
                                                },
                                                {
                                                    index: .93,
                                                    rgb: [
                                                        218,
                                                        241,
                                                        142
                                                    ]
                                                },
                                                {
                                                    index: 1,
                                                    rgb: [
                                                        227,
                                                        253,
                                                        198
                                                    ]
                                                }
                                            ]
                                        };
                                    },
                                    {}
                                ],
                                53: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./colorScale"), i = t1("lerp");
                                        function a(t1) {
                                            return [
                                                t1[0] / 255,
                                                t1[1] / 255,
                                                t1[2] / 255,
                                                t1[3]
                                            ];
                                        }
                                        function o(t1) {
                                            for(var e1, r = "#", n = 0; n < 3; ++n)r += ("00" + (e1 = (e1 = t1[n]).toString(16))).substr(e1.length);
                                            return r;
                                        }
                                        function s(t1) {
                                            return "rgba(" + t1.join(",") + ")";
                                        }
                                        e1.exports = function(t1) {
                                            var e1, r, l, c, u, f, h, p, d, m;
                                            t1 || (t1 = {});
                                            p = (t1.nshades || 72) - 1, h = t1.format || "hex", (f = t1.colormap) || (f = "jet");
                                            if ("string" == typeof f) {
                                                if (f = f.toLowerCase(), !n[f]) throw Error(f + " not a supported colorscale");
                                                u = n[f];
                                            } else {
                                                if (!Array.isArray(f)) throw Error("unsupported colormap option", f);
                                                u = f.slice();
                                            }
                                            if (u.length > p + 1) throw new Error(f + " map requires nshades to be at least size " + u.length);
                                            d = Array.isArray(t1.alpha) ? 2 !== t1.alpha.length ? [
                                                1,
                                                1
                                            ] : t1.alpha.slice() : "number" == typeof t1.alpha ? [
                                                t1.alpha,
                                                t1.alpha
                                            ] : [
                                                1,
                                                1
                                            ];
                                            e1 = u.map(function(t1) {
                                                return Math.round(t1.index * p);
                                            }), d[0] = Math.min(Math.max(d[0], 0), 1), d[1] = Math.min(Math.max(d[1], 0), 1);
                                            var g = u.map(function(t1, e1) {
                                                var r = u[e1].index, n = u[e1].rgb.slice();
                                                return 4 === n.length && n[3] >= 0 && n[3] <= 1 || (n[3] = d[0] + (d[1] - d[0]) * r), n;
                                            }), v = [];
                                            for(m = 0; m < e1.length - 1; ++m){
                                                c = e1[m + 1] - e1[m], r = g[m], l = g[m + 1];
                                                for(var y = 0; y < c; y++){
                                                    var x = y / c;
                                                    v.push([
                                                        Math.round(i(r[0], l[0], x)),
                                                        Math.round(i(r[1], l[1], x)),
                                                        Math.round(i(r[2], l[2], x)),
                                                        i(r[3], l[3], x)
                                                    ]);
                                                }
                                            }
                                            v.push(u[u.length - 1].rgb.concat(d[1])), "hex" === h ? v = v.map(o) : "rgbaString" === h ? v = v.map(s) : "float" === h && (v = v.map(a));
                                            return v;
                                        };
                                    },
                                    {
                                        "./colorScale": 52,
                                        lerp: 240
                                    }
                                ],
                                54: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r, a) {
                                            var o = n(e1, r, a);
                                            if (0 === o) {
                                                var s = i(n(t1, e1, r)), c = i(n(t1, e1, a));
                                                if (s === c) {
                                                    if (0 === s) {
                                                        var u = l(t1, e1, r), f = l(t1, e1, a);
                                                        return u === f ? 0 : u ? 1 : -1;
                                                    }
                                                    return 0;
                                                }
                                                return 0 === c ? s > 0 || l(t1, e1, a) ? -1 : 1 : 0 === s ? c > 0 || l(t1, e1, r) ? 1 : -1 : i(c - s);
                                            }
                                            var h = n(t1, e1, r);
                                            return h > 0 ? o > 0 && n(t1, e1, a) > 0 ? 1 : -1 : h < 0 ? o > 0 || n(t1, e1, a) > 0 ? 1 : -1 : n(t1, e1, a) > 0 || l(t1, e1, r) ? 1 : -1;
                                        };
                                        var n = t1("robust-orientation"), i = t1("signum"), a = t1("two-sum"), o = t1("robust-product"), s = t1("robust-sum");
                                        function l(t1, e1, r) {
                                            var n = a(t1[0], -e1[0]), i = a(t1[1], -e1[1]), l = a(r[0], -e1[0]), c = a(r[1], -e1[1]), u = s(o(n, l), o(i, c));
                                            return u[u.length - 1] >= 0;
                                        }
                                    },
                                    {
                                        "robust-orientation": 284,
                                        "robust-product": 285,
                                        "robust-sum": 289,
                                        signum: 55,
                                        "two-sum": 307
                                    }
                                ],
                                55: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            return t1 < 0 ? -1 : t1 > 0 ? 1 : 0;
                                        };
                                    },
                                    {}
                                ],
                                56: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = t1.length, a = t1.length - e1.length;
                                            if (a) return a;
                                            switch(r){
                                                case 0:
                                                    return 0;
                                                case 1:
                                                    return t1[0] - e1[0];
                                                case 2:
                                                    return t1[0] + t1[1] - e1[0] - e1[1] || n(t1[0], t1[1]) - n(e1[0], e1[1]);
                                                case 3:
                                                    var o = t1[0] + t1[1], s = e1[0] + e1[1];
                                                    if (a = o + t1[2] - (s + e1[2])) return a;
                                                    var l = n(t1[0], t1[1]), c = n(e1[0], e1[1]);
                                                    return n(l, t1[2]) - n(c, e1[2]) || n(l + t1[2], o) - n(c + e1[2], s);
                                                case 4:
                                                    var u = t1[0], f = t1[1], h = t1[2], p = t1[3], d = e1[0], m = e1[1], g = e1[2], v = e1[3];
                                                    return u + f + h + p - (d + m + g + v) || n(u, f, h, p) - n(d, m, g, v, d) || n(u + f, u + h, u + p, f + h, f + p, h + p) - n(d + m, d + g, d + v, m + g, m + v, g + v) || n(u + f + h, u + f + p, u + h + p, f + h + p) - n(d + m + g, d + m + v, d + g + v, m + g + v);
                                                default:
                                                    for(var y = t1.slice().sort(i), x = e1.slice().sort(i), b = 0; b < r; ++b)if (a = y[b] - x[b]) return a;
                                                    return 0;
                                            }
                                        };
                                        var n = Math.min;
                                        function i(t1, e1) {
                                            return t1 - e1;
                                        }
                                    },
                                    {}
                                ],
                                57: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("compare-cell"), i = t1("cell-orientation");
                                        e1.exports = function(t1, e1) {
                                            return n(t1, e1) || i(t1) - i(e1);
                                        };
                                    },
                                    {
                                        "cell-orientation": 47,
                                        "compare-cell": 56
                                    }
                                ],
                                58: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./lib/ch1d"), i = t1("./lib/ch2d"), a = t1("./lib/chnd");
                                        e1.exports = function(t1) {
                                            var e1 = t1.length;
                                            if (0 === e1) return [];
                                            if (1 === e1) return [
                                                [
                                                    0
                                                ]
                                            ];
                                            var r = t1[0].length;
                                            if (0 === r) return [];
                                            if (1 === r) return n(t1);
                                            if (2 === r) return i(t1);
                                            return a(t1, r);
                                        };
                                    },
                                    {
                                        "./lib/ch1d": 59,
                                        "./lib/ch2d": 60,
                                        "./lib/chnd": 61
                                    }
                                ],
                                59: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            for(var e1 = 0, r = 0, n = 1; n < t1.length; ++n)t1[n][0] < t1[e1][0] && (e1 = n), t1[n][0] > t1[r][0] && (r = n);
                                            return e1 < r ? [
                                                [
                                                    e1
                                                ],
                                                [
                                                    r
                                                ]
                                            ] : e1 > r ? [
                                                [
                                                    r
                                                ],
                                                [
                                                    e1
                                                ]
                                            ] : [
                                                [
                                                    e1
                                                ]
                                            ];
                                        };
                                    },
                                    {}
                                ],
                                60: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = n(t1), r = e1.length;
                                            if (r <= 2) return [];
                                            for(var i = new Array(r), a = e1[r - 1], o = 0; o < r; ++o){
                                                var s = e1[o];
                                                i[o] = [
                                                    a,
                                                    s
                                                ], a = s;
                                            }
                                            return i;
                                        };
                                        var n = t1("monotone-convex-hull-2d");
                                    },
                                    {
                                        "monotone-convex-hull-2d": 246
                                    }
                                ],
                                61: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            try {
                                                return n(t1, !0);
                                            } catch (o) {
                                                var r = i(t1);
                                                if (r.length <= e1) return [];
                                                var a = function(t1, e1) {
                                                    for(var r = t1.length, n = new Array(r), i = 0; i < e1.length; ++i)n[i] = t1[e1[i]];
                                                    var a = e1.length;
                                                    for(i = 0; i < r; ++i)e1.indexOf(i) < 0 && (n[a++] = t1[i]);
                                                    return n;
                                                }(t1, r);
                                                return function(t1, e1) {
                                                    for(var r = t1.length, n = e1.length, i = 0; i < r; ++i)for(var a = t1[i], o = 0; o < a.length; ++o){
                                                        var s = a[o];
                                                        if (s < n) a[o] = e1[s];
                                                        else {
                                                            s -= n;
                                                            for(var l = 0; l < n; ++l)s >= e1[l] && (s += 1);
                                                            a[o] = s;
                                                        }
                                                    }
                                                    return t1;
                                                }(n(a, !0), r);
                                            }
                                        };
                                        var n = t1("incremental-convex-hull"), i = t1("affine-hull");
                                    },
                                    {
                                        "affine-hull": 10,
                                        "incremental-convex-hull": 233
                                    }
                                ],
                                62: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r, n, i, a) {
                                            var o = i - 1, s = i * i, l = o * o, c = (1 + 2 * i) * l, u = i * l, f = s * (3 - 2 * i), h = s * o;
                                            if (t1.length) {
                                                a || (a = new Array(t1.length));
                                                for(var p = t1.length - 1; p >= 0; --p)a[p] = c * t1[p] + u * e1[p] + f * r[p] + h * n[p];
                                                return a;
                                            }
                                            return c * t1 + u * e1 + f * r + h * n;
                                        }, e1.exports.derivative = function(t1, e1, r, n, i, a) {
                                            var o = 6 * i * i - 6 * i, s = 3 * i * i - 4 * i + 1, l = -6 * i * i + 6 * i, c = 3 * i * i - 2 * i;
                                            if (t1.length) {
                                                a || (a = new Array(t1.length));
                                                for(var u = t1.length - 1; u >= 0; --u)a[u] = o * t1[u] + s * e1[u] + l * r[u] + c * n[u];
                                                return a;
                                            }
                                            return o * t1 + s * e1 + l * r[u] + c * n;
                                        };
                                    },
                                    {}
                                ],
                                63: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("incremental-convex-hull"), i = t1("uniq");
                                        function a(t1, e1) {
                                            this.point = t1, this.index = e1;
                                        }
                                        function o(t1, e1) {
                                            for(var r = t1.point, n = e1.point, i = r.length, a = 0; a < i; ++a){
                                                var o = n[a] - r[a];
                                                if (o) return o;
                                            }
                                            return 0;
                                        }
                                        e1.exports = function(t1, e1) {
                                            var r = t1.length;
                                            if (0 === r) return [];
                                            var s = t1[0].length;
                                            if (s < 1) return [];
                                            if (1 === s) return function(t1, e1, r) {
                                                if (1 === t1) return r ? [
                                                    [
                                                        -1,
                                                        0
                                                    ]
                                                ] : [];
                                                var n = e1.map(function(t1, e1) {
                                                    return [
                                                        t1[0],
                                                        e1
                                                    ];
                                                });
                                                n.sort(function(t1, e1) {
                                                    return t1[0] - e1[0];
                                                });
                                                for(var i = new Array(t1 - 1), a = 1; a < t1; ++a){
                                                    var o = n[a - 1], s = n[a];
                                                    i[a - 1] = [
                                                        o[1],
                                                        s[1]
                                                    ];
                                                }
                                                r && i.push([
                                                    -1,
                                                    i[0][1]
                                                ], [
                                                    i[t1 - 1][1],
                                                    -1
                                                ]);
                                                return i;
                                            }(r, t1, e1);
                                            for(var l = new Array(r), c = 1, u = 0; u < r; ++u){
                                                for(var f = t1[u], h = new Array(s + 1), p = 0, d = 0; d < s; ++d){
                                                    var m = f[d];
                                                    h[d] = m, p += m * m;
                                                }
                                                h[s] = p, l[u] = new a(h, u), c = Math.max(p, c);
                                            }
                                            i(l, o), r = l.length;
                                            var g = new Array(r + s + 1), v = new Array(r + s + 1), y = (s + 1) * (s + 1) * c, x = new Array(s + 1);
                                            for(u = 0; u <= s; ++u)x[u] = 0;
                                            x[s] = y, g[0] = x.slice(), v[0] = -1;
                                            for(u = 0; u <= s; ++u)(h = x.slice())[u] = 1, g[u + 1] = h, v[u + 1] = -1;
                                            for(u = 0; u < r; ++u){
                                                var b = l[u];
                                                g[u + s + 1] = b.point, v[u + s + 1] = b.index;
                                            }
                                            var _ = n(g, !1);
                                            _ = e1 ? _.filter(function(t1) {
                                                for(var e1 = 0, r = 0; r <= s; ++r){
                                                    var n = v[t1[r]];
                                                    if (n < 0 && ++e1 >= 2) return !1;
                                                    t1[r] = n;
                                                }
                                                return !0;
                                            }) : _.filter(function(t1) {
                                                for(var e1 = 0; e1 <= s; ++e1){
                                                    var r = v[t1[e1]];
                                                    if (r < 0) return !1;
                                                    t1[e1] = r;
                                                }
                                                return !0;
                                            });
                                            if (1 & s) for(u = 0; u < _.length; ++u){
                                                h = (b = _[u])[0];
                                                b[0] = b[1], b[1] = h;
                                            }
                                            return _;
                                        };
                                    },
                                    {
                                        "incremental-convex-hull": 233,
                                        uniq: 310
                                    }
                                ],
                                64: [
                                    function(t1, e1, r) {
                                        (function(t1) {
                                            (function() {
                                                var r = !1;
                                                if ("undefined" != typeof Float64Array) {
                                                    var n = new Float64Array(1), i = new Uint32Array(n.buffer);
                                                    if (n[0] = 1, r = !0, 1072693248 === i[1]) e1.exports = function(t1) {
                                                        return n[0] = t1, [
                                                            i[0],
                                                            i[1]
                                                        ];
                                                    }, e1.exports.pack = function(t1, e1) {
                                                        return i[0] = t1, i[1] = e1, n[0];
                                                    }, e1.exports.lo = function(t1) {
                                                        return n[0] = t1, i[0];
                                                    }, e1.exports.hi = function(t1) {
                                                        return n[0] = t1, i[1];
                                                    };
                                                    else if (1072693248 === i[0]) e1.exports = function(t1) {
                                                        return n[0] = t1, [
                                                            i[1],
                                                            i[0]
                                                        ];
                                                    }, e1.exports.pack = function(t1, e1) {
                                                        return i[1] = t1, i[0] = e1, n[0];
                                                    }, e1.exports.lo = function(t1) {
                                                        return n[0] = t1, i[1];
                                                    }, e1.exports.hi = function(t1) {
                                                        return n[0] = t1, i[0];
                                                    };
                                                    else r = !1;
                                                }
                                                if (!r) {
                                                    var a = new t1(8);
                                                    e1.exports = function(t1) {
                                                        return a.writeDoubleLE(t1, 0, !0), [
                                                            a.readUInt32LE(0, !0),
                                                            a.readUInt32LE(4, !0)
                                                        ];
                                                    }, e1.exports.pack = function(t1, e1) {
                                                        return a.writeUInt32LE(t1, 0, !0), a.writeUInt32LE(e1, 4, !0), a.readDoubleLE(0, !0);
                                                    }, e1.exports.lo = function(t1) {
                                                        return a.writeDoubleLE(t1, 0, !0), a.readUInt32LE(0, !0);
                                                    }, e1.exports.hi = function(t1) {
                                                        return a.writeDoubleLE(t1, 0, !0), a.readUInt32LE(4, !0);
                                                    };
                                                }
                                                e1.exports.sign = function(t1) {
                                                    return e1.exports.hi(t1) >>> 31;
                                                }, e1.exports.exponent = function(t1) {
                                                    return (e1.exports.hi(t1) << 1 >>> 21) - 1023;
                                                }, e1.exports.fraction = function(t1) {
                                                    var r = e1.exports.lo(t1), n = e1.exports.hi(t1), i = 1048575 & n;
                                                    return 2146435072 & n && (i += 1048576), [
                                                        r,
                                                        i
                                                    ];
                                                }, e1.exports.denormalized = function(t1) {
                                                    return !(2146435072 & e1.exports.hi(t1));
                                                };
                                            }).call(this);
                                        }).call(this, t1("buffer").Buffer);
                                    },
                                    {
                                        buffer: 3
                                    }
                                ],
                                65: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            switch(void 0 === e1 && (e1 = 0), typeof t1){
                                                case "number":
                                                    if (t1 > 0) return function(t1, e1) {
                                                        var r, n;
                                                        for(r = new Array(t1), n = 0; n < t1; ++n)r[n] = e1;
                                                        return r;
                                                    }(0 | t1, e1);
                                                    break;
                                                case "object":
                                                    if ("number" == typeof t1.length) return function t1(e1, r, n) {
                                                        var i = 0 | e1[n];
                                                        if (i <= 0) return [];
                                                        var a, o = new Array(i);
                                                        if (n === e1.length - 1) for(a = 0; a < i; ++a)o[a] = r;
                                                        else for(a = 0; a < i; ++a)o[a] = t1(e1, r, n + 1);
                                                        return o;
                                                    }(t1, e1, 0);
                                            }
                                            return [];
                                        };
                                    },
                                    {}
                                ],
                                66: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            var r = t1.length;
                                            if ("number" != typeof e1) {
                                                e1 = 0;
                                                for(var i = 0; i < r; ++i){
                                                    var a = t1[i];
                                                    e1 = Math.max(e1, a[0], a[1]);
                                                }
                                                e1 = 1 + (0 | e1);
                                            }
                                            e1 |= 0;
                                            var o = new Array(e1);
                                            for(i = 0; i < e1; ++i)o[i] = [];
                                            for(i = 0; i < r; ++i){
                                                a = t1[i];
                                                o[a[0]].push(a[1]), o[a[1]].push(a[0]);
                                            }
                                            for(var s = 0; s < e1; ++s)n(o[s], function(t1, e1) {
                                                return t1 - e1;
                                            });
                                            return o;
                                        };
                                        var n = t1("uniq");
                                    },
                                    {
                                        uniq: 310
                                    }
                                ],
                                67: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r) {
                                            var n = e1 || 0, i = r || 1;
                                            return [
                                                [
                                                    t1[12] + t1[0],
                                                    t1[13] + t1[1],
                                                    t1[14] + t1[2],
                                                    t1[15] + t1[3]
                                                ],
                                                [
                                                    t1[12] - t1[0],
                                                    t1[13] - t1[1],
                                                    t1[14] - t1[2],
                                                    t1[15] - t1[3]
                                                ],
                                                [
                                                    t1[12] + t1[4],
                                                    t1[13] + t1[5],
                                                    t1[14] + t1[6],
                                                    t1[15] + t1[7]
                                                ],
                                                [
                                                    t1[12] - t1[4],
                                                    t1[13] - t1[5],
                                                    t1[14] - t1[6],
                                                    t1[15] - t1[7]
                                                ],
                                                [
                                                    n * t1[12] + t1[8],
                                                    n * t1[13] + t1[9],
                                                    n * t1[14] + t1[10],
                                                    n * t1[15] + t1[11]
                                                ],
                                                [
                                                    i * t1[12] - t1[8],
                                                    i * t1[13] - t1[9],
                                                    i * t1[14] - t1[10],
                                                    i * t1[15] - t1[11]
                                                ]
                                            ];
                                        };
                                    },
                                    {}
                                ],
                                68: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r) {
                                            switch(arguments.length){
                                                case 0:
                                                    return new o([
                                                        0
                                                    ], [
                                                        0
                                                    ], 0);
                                                case 1:
                                                    return "number" == typeof t1 ? new o(n = l(t1), n, 0) : new o(t1, l(t1.length), 0);
                                                case 2:
                                                    if ("number" == typeof e1) {
                                                        var n = l(t1.length);
                                                        return new o(t1, n, +e1);
                                                    }
                                                    r = 0;
                                                case 3:
                                                    if (t1.length !== e1.length) throw new Error("state and velocity lengths must match");
                                                    return new o(t1, e1, r);
                                            }
                                        };
                                        var n = t1("cubic-hermite"), i = t1("binary-search-bounds");
                                        function a(t1, e1, r) {
                                            return Math.min(e1, Math.max(t1, r));
                                        }
                                        function o(t1, e1, r) {
                                            this.dimension = t1.length, this.bounds = [
                                                new Array(this.dimension),
                                                new Array(this.dimension)
                                            ];
                                            for(var n = 0; n < this.dimension; ++n)this.bounds[0][n] = -1 / 0, this.bounds[1][n] = 1 / 0;
                                            this._state = t1.slice().reverse(), this._velocity = e1.slice().reverse(), this._time = [
                                                r
                                            ], this._scratch = [
                                                t1.slice(),
                                                t1.slice(),
                                                t1.slice(),
                                                t1.slice(),
                                                t1.slice()
                                            ];
                                        }
                                        var s = o.prototype;
                                        function l(t1) {
                                            for(var e1 = new Array(t1), r = 0; r < t1; ++r)e1[r] = 0;
                                            return e1;
                                        }
                                        s.flush = function(t1) {
                                            var e1 = i.gt(this._time, t1) - 1;
                                            e1 <= 0 || (this._time.splice(0, e1), this._state.splice(0, e1 * this.dimension), this._velocity.splice(0, e1 * this.dimension));
                                        }, s.curve = function(t1) {
                                            var e1 = this._time, r = e1.length, o = i.le(e1, t1), s = this._scratch[0], l = this._state, c = this._velocity, u = this.dimension, f = this.bounds;
                                            if (o < 0) for(var h = u - 1, p = 0; p < u; ++p, --h)s[p] = l[h];
                                            else if (o >= r - 1) {
                                                h = l.length - 1;
                                                var d = t1 - e1[r - 1];
                                                for(p = 0; p < u; ++p, --h)s[p] = l[h] + d * c[h];
                                            } else {
                                                h = u * (o + 1) - 1;
                                                var m = e1[o], g = e1[o + 1] - m || 1, v = this._scratch[1], y = this._scratch[2], x = this._scratch[3], b = this._scratch[4], _ = !0;
                                                for(p = 0; p < u; ++p, --h)v[p] = l[h], x[p] = c[h] * g, y[p] = l[h + u], b[p] = c[h + u] * g, _ = _ && v[p] === y[p] && x[p] === b[p] && 0 === x[p];
                                                if (_) for(p = 0; p < u; ++p)s[p] = v[p];
                                                else n(v, x, y, b, (t1 - m) / g, s);
                                            }
                                            var w = f[0], T = f[1];
                                            for(p = 0; p < u; ++p)s[p] = a(w[p], T[p], s[p]);
                                            return s;
                                        }, s.dcurve = function(t1) {
                                            var e1 = this._time, r = e1.length, a = i.le(e1, t1), o = this._scratch[0], s = this._state, l = this._velocity, c = this.dimension;
                                            if (a >= r - 1) for(var u = s.length - 1, f = (e1[r - 1], 0); f < c; ++f, --u)o[f] = l[u];
                                            else {
                                                u = c * (a + 1) - 1;
                                                var h = e1[a], p = e1[a + 1] - h || 1, d = this._scratch[1], m = this._scratch[2], g = this._scratch[3], v = this._scratch[4], y = !0;
                                                for(f = 0; f < c; ++f, --u)d[f] = s[u], g[f] = l[u] * p, m[f] = s[u + c], v[f] = l[u + c] * p, y = y && d[f] === m[f] && g[f] === v[f] && 0 === g[f];
                                                if (y) for(f = 0; f < c; ++f)o[f] = 0;
                                                else {
                                                    n.derivative(d, g, m, v, (t1 - h) / p, o);
                                                    for(f = 0; f < c; ++f)o[f] /= p;
                                                }
                                            }
                                            return o;
                                        }, s.lastT = function() {
                                            var t1 = this._time;
                                            return t1[t1.length - 1];
                                        }, s.stable = function() {
                                            for(var t1 = this._velocity, e1 = t1.length, r = this.dimension - 1; r >= 0; --r)if (t1[--e1]) return !1;
                                            return !0;
                                        }, s.jump = function(t1) {
                                            var e1 = this.lastT(), r = this.dimension;
                                            if (!(t1 < e1 || arguments.length !== r + 1)) {
                                                var n = this._state, i = this._velocity, o = n.length - this.dimension, s = this.bounds, l = s[0], c = s[1];
                                                this._time.push(e1, t1);
                                                for(var u = 0; u < 2; ++u)for(var f = 0; f < r; ++f)n.push(n[o++]), i.push(0);
                                                this._time.push(t1);
                                                for(f = r; f > 0; --f)n.push(a(l[f - 1], c[f - 1], arguments[f])), i.push(0);
                                            }
                                        }, s.push = function(t1) {
                                            var e1 = this.lastT(), r = this.dimension;
                                            if (!(t1 < e1 || arguments.length !== r + 1)) {
                                                var n = this._state, i = this._velocity, o = n.length - this.dimension, s = t1 - e1, l = this.bounds, c = l[0], u = l[1], f = s > 1e-6 ? 1 / s : 0;
                                                this._time.push(t1);
                                                for(var h = r; h > 0; --h){
                                                    var p = a(c[h - 1], u[h - 1], arguments[h]);
                                                    n.push(p), i.push((p - n[o++]) * f);
                                                }
                                            }
                                        }, s.set = function(t1) {
                                            var e1 = this.dimension;
                                            if (!(t1 < this.lastT() || arguments.length !== e1 + 1)) {
                                                var r = this._state, n = this._velocity, i = this.bounds, o = i[0], s = i[1];
                                                this._time.push(t1);
                                                for(var l = e1; l > 0; --l)r.push(a(o[l - 1], s[l - 1], arguments[l])), n.push(0);
                                            }
                                        }, s.move = function(t1) {
                                            var e1 = this.lastT(), r = this.dimension;
                                            if (!(t1 <= e1 || arguments.length !== r + 1)) {
                                                var n = this._state, i = this._velocity, o = n.length - this.dimension, s = this.bounds, l = s[0], c = s[1], u = t1 - e1, f = u > 1e-6 ? 1 / u : 0;
                                                this._time.push(t1);
                                                for(var h = r; h > 0; --h){
                                                    var p = arguments[h];
                                                    n.push(a(l[h - 1], c[h - 1], n[o++] + p)), i.push(p * f);
                                                }
                                            }
                                        }, s.idle = function(t1) {
                                            var e1 = this.lastT();
                                            if (!(t1 < e1)) {
                                                var r = this.dimension, n = this._state, i = this._velocity, o = n.length - r, s = this.bounds, l = s[0], c = s[1], u = t1 - e1;
                                                this._time.push(t1);
                                                for(var f = r - 1; f >= 0; --f)n.push(a(l[f], c[f], n[o] + u * i[o])), i.push(0), o += 1;
                                            }
                                        };
                                    },
                                    {
                                        "binary-search-bounds": 31,
                                        "cubic-hermite": 62
                                    }
                                ],
                                69: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            return new s(t1 || m, null);
                                        };
                                        function n(t1, e1, r, n, i, a) {
                                            this._color = t1, this.key = e1, this.value = r, this.left = n, this.right = i, this._count = a;
                                        }
                                        function i(t1) {
                                            return new n(t1._color, t1.key, t1.value, t1.left, t1.right, t1._count);
                                        }
                                        function a(t1, e1) {
                                            return new n(t1, e1.key, e1.value, e1.left, e1.right, e1._count);
                                        }
                                        function o(t1) {
                                            t1._count = 1 + (t1.left ? t1.left._count : 0) + (t1.right ? t1.right._count : 0);
                                        }
                                        function s(t1, e1) {
                                            this._compare = t1, this.root = e1;
                                        }
                                        var l = s.prototype;
                                        function c(t1, e1) {
                                            var r;
                                            if (e1.left && (r = c(t1, e1.left))) return r;
                                            return (r = t1(e1.key, e1.value)) || (e1.right ? c(t1, e1.right) : void 0);
                                        }
                                        function u(t1, e1, r, n) {
                                            if (e1(t1, n.key) <= 0) {
                                                var i;
                                                if (n.left) {
                                                    if (i = u(t1, e1, r, n.left)) return i;
                                                }
                                                if (i = r(n.key, n.value)) return i;
                                            }
                                            if (n.right) return u(t1, e1, r, n.right);
                                        }
                                        function f(t1, e1, r, n, i) {
                                            var a, o = r(t1, i.key), s = r(e1, i.key);
                                            if (o <= 0) {
                                                if (i.left && (a = f(t1, e1, r, n, i.left))) return a;
                                                if (s > 0 && (a = n(i.key, i.value))) return a;
                                            }
                                            if (s > 0 && i.right) return f(t1, e1, r, n, i.right);
                                        }
                                        function h(t1, e1) {
                                            this.tree = t1, this._stack = e1;
                                        }
                                        Object.defineProperty(l, "keys", {
                                            get: function() {
                                                var t1 = [];
                                                return this.forEach(function(e1, r) {
                                                    t1.push(e1);
                                                }), t1;
                                            }
                                        }), Object.defineProperty(l, "values", {
                                            get: function() {
                                                var t1 = [];
                                                return this.forEach(function(e1, r) {
                                                    t1.push(r);
                                                }), t1;
                                            }
                                        }), Object.defineProperty(l, "length", {
                                            get: function() {
                                                return this.root ? this.root._count : 0;
                                            }
                                        }), l.insert = function(t1, e1) {
                                            for(var r = this._compare, i = this.root, l = [], c = []; i;){
                                                var u = r(t1, i.key);
                                                l.push(i), c.push(u), i = u <= 0 ? i.left : i.right;
                                            }
                                            l.push(new n(0, t1, e1, null, null, 1));
                                            for(var f = l.length - 2; f >= 0; --f){
                                                i = l[f];
                                                c[f] <= 0 ? l[f] = new n(i._color, i.key, i.value, l[f + 1], i.right, i._count + 1) : l[f] = new n(i._color, i.key, i.value, i.left, l[f + 1], i._count + 1);
                                            }
                                            for(f = l.length - 1; f > 1; --f){
                                                var h = l[f - 1];
                                                i = l[f];
                                                if (1 === h._color || 1 === i._color) break;
                                                var p = l[f - 2];
                                                if (p.left === h) {
                                                    if (h.left === i) {
                                                        if (!(d = p.right) || 0 !== d._color) {
                                                            if (p._color = 0, p.left = h.right, h._color = 1, h.right = p, l[f - 2] = h, l[f - 1] = i, o(p), o(h), f >= 3) (m = l[f - 3]).left === p ? m.left = h : m.right = h;
                                                            break;
                                                        }
                                                        h._color = 1, p.right = a(1, d), p._color = 0, f -= 1;
                                                    } else {
                                                        if (!(d = p.right) || 0 !== d._color) {
                                                            if (h.right = i.left, p._color = 0, p.left = i.right, i._color = 1, i.left = h, i.right = p, l[f - 2] = i, l[f - 1] = h, o(p), o(h), o(i), f >= 3) (m = l[f - 3]).left === p ? m.left = i : m.right = i;
                                                            break;
                                                        }
                                                        h._color = 1, p.right = a(1, d), p._color = 0, f -= 1;
                                                    }
                                                } else if (h.right === i) {
                                                    if (!(d = p.left) || 0 !== d._color) {
                                                        if (p._color = 0, p.right = h.left, h._color = 1, h.left = p, l[f - 2] = h, l[f - 1] = i, o(p), o(h), f >= 3) (m = l[f - 3]).right === p ? m.right = h : m.left = h;
                                                        break;
                                                    }
                                                    h._color = 1, p.left = a(1, d), p._color = 0, f -= 1;
                                                } else {
                                                    var d;
                                                    if (!(d = p.left) || 0 !== d._color) {
                                                        var m;
                                                        if (h.left = i.right, p._color = 0, p.right = i.left, i._color = 1, i.right = h, i.left = p, l[f - 2] = i, l[f - 1] = h, o(p), o(h), o(i), f >= 3) (m = l[f - 3]).right === p ? m.right = i : m.left = i;
                                                        break;
                                                    }
                                                    h._color = 1, p.left = a(1, d), p._color = 0, f -= 1;
                                                }
                                            }
                                            return l[0]._color = 1, new s(r, l[0]);
                                        }, l.forEach = function(t1, e1, r) {
                                            if (this.root) switch(arguments.length){
                                                case 1:
                                                    return c(t1, this.root);
                                                case 2:
                                                    return u(e1, this._compare, t1, this.root);
                                                case 3:
                                                    if (this._compare(e1, r) >= 0) return;
                                                    return f(e1, r, this._compare, t1, this.root);
                                            }
                                        }, Object.defineProperty(l, "begin", {
                                            get: function() {
                                                for(var t1 = [], e1 = this.root; e1;)t1.push(e1), e1 = e1.left;
                                                return new h(this, t1);
                                            }
                                        }), Object.defineProperty(l, "end", {
                                            get: function() {
                                                for(var t1 = [], e1 = this.root; e1;)t1.push(e1), e1 = e1.right;
                                                return new h(this, t1);
                                            }
                                        }), l.at = function(t1) {
                                            if (t1 < 0) return new h(this, []);
                                            for(var e1 = this.root, r = [];;){
                                                if (r.push(e1), e1.left) {
                                                    if (t1 < e1.left._count) {
                                                        e1 = e1.left;
                                                        continue;
                                                    }
                                                    t1 -= e1.left._count;
                                                }
                                                if (!t1) return new h(this, r);
                                                if (t1 -= 1, !e1.right) break;
                                                if (t1 >= e1.right._count) break;
                                                e1 = e1.right;
                                            }
                                            return new h(this, []);
                                        }, l.ge = function(t1) {
                                            for(var e1 = this._compare, r = this.root, n = [], i = 0; r;){
                                                var a = e1(t1, r.key);
                                                n.push(r), a <= 0 && (i = n.length), r = a <= 0 ? r.left : r.right;
                                            }
                                            return n.length = i, new h(this, n);
                                        }, l.gt = function(t1) {
                                            for(var e1 = this._compare, r = this.root, n = [], i = 0; r;){
                                                var a = e1(t1, r.key);
                                                n.push(r), a < 0 && (i = n.length), r = a < 0 ? r.left : r.right;
                                            }
                                            return n.length = i, new h(this, n);
                                        }, l.lt = function(t1) {
                                            for(var e1 = this._compare, r = this.root, n = [], i = 0; r;){
                                                var a = e1(t1, r.key);
                                                n.push(r), a > 0 && (i = n.length), r = a <= 0 ? r.left : r.right;
                                            }
                                            return n.length = i, new h(this, n);
                                        }, l.le = function(t1) {
                                            for(var e1 = this._compare, r = this.root, n = [], i = 0; r;){
                                                var a = e1(t1, r.key);
                                                n.push(r), a >= 0 && (i = n.length), r = a < 0 ? r.left : r.right;
                                            }
                                            return n.length = i, new h(this, n);
                                        }, l.find = function(t1) {
                                            for(var e1 = this._compare, r = this.root, n = []; r;){
                                                var i = e1(t1, r.key);
                                                if (n.push(r), 0 === i) return new h(this, n);
                                                r = i <= 0 ? r.left : r.right;
                                            }
                                            return new h(this, []);
                                        }, l.remove = function(t1) {
                                            var e1 = this.find(t1);
                                            return e1 ? e1.remove() : this;
                                        }, l.get = function(t1) {
                                            for(var e1 = this._compare, r = this.root; r;){
                                                var n = e1(t1, r.key);
                                                if (0 === n) return r.value;
                                                r = n <= 0 ? r.left : r.right;
                                            }
                                        };
                                        var p = h.prototype;
                                        function d(t1, e1) {
                                            t1.key = e1.key, t1.value = e1.value, t1.left = e1.left, t1.right = e1.right, t1._color = e1._color, t1._count = e1._count;
                                        }
                                        function m(t1, e1) {
                                            return t1 < e1 ? -1 : t1 > e1 ? 1 : 0;
                                        }
                                        Object.defineProperty(p, "valid", {
                                            get: function() {
                                                return this._stack.length > 0;
                                            }
                                        }), Object.defineProperty(p, "node", {
                                            get: function() {
                                                return this._stack.length > 0 ? this._stack[this._stack.length - 1] : null;
                                            },
                                            enumerable: !0
                                        }), p.clone = function() {
                                            return new h(this.tree, this._stack.slice());
                                        }, p.remove = function() {
                                            var t1 = this._stack;
                                            if (0 === t1.length) return this.tree;
                                            var e1 = new Array(t1.length), r = t1[t1.length - 1];
                                            e1[e1.length - 1] = new n(r._color, r.key, r.value, r.left, r.right, r._count);
                                            for(var l = t1.length - 2; l >= 0; --l)(r = t1[l]).left === t1[l + 1] ? e1[l] = new n(r._color, r.key, r.value, e1[l + 1], r.right, r._count) : e1[l] = new n(r._color, r.key, r.value, r.left, e1[l + 1], r._count);
                                            if ((r = e1[e1.length - 1]).left && r.right) {
                                                var c = e1.length;
                                                for(r = r.left; r.right;)e1.push(r), r = r.right;
                                                var u = e1[c - 1];
                                                e1.push(new n(r._color, u.key, u.value, r.left, r.right, r._count)), e1[c - 1].key = r.key, e1[c - 1].value = r.value;
                                                for(l = e1.length - 2; l >= c; --l)r = e1[l], e1[l] = new n(r._color, r.key, r.value, r.left, e1[l + 1], r._count);
                                                e1[c - 1].left = e1[c];
                                            }
                                            if (0 === (r = e1[e1.length - 1])._color) {
                                                var f = e1[e1.length - 2];
                                                f.left === r ? f.left = null : f.right === r && (f.right = null), e1.pop();
                                                for(l = 0; l < e1.length; ++l)e1[l]._count--;
                                                return new s(this.tree._compare, e1[0]);
                                            }
                                            if (r.left || r.right) {
                                                r.left ? d(r, r.left) : r.right && d(r, r.right), r._color = 1;
                                                for(l = 0; l < e1.length - 1; ++l)e1[l]._count--;
                                                return new s(this.tree._compare, e1[0]);
                                            }
                                            if (1 === e1.length) return new s(this.tree._compare, null);
                                            for(l = 0; l < e1.length; ++l)e1[l]._count--;
                                            var h = e1[e1.length - 2];
                                            return function(t1) {
                                                for(var e1, r, n, s, l = t1.length - 1; l >= 0; --l){
                                                    if (e1 = t1[l], 0 === l) return void (e1._color = 1);
                                                    if ((r = t1[l - 1]).left === e1) {
                                                        if ((n = r.right).right && 0 === n.right._color) {
                                                            if (s = (n = r.right = i(n)).right = i(n.right), r.right = n.left, n.left = r, n.right = s, n._color = r._color, e1._color = 1, r._color = 1, s._color = 1, o(r), o(n), l > 1) (c = t1[l - 2]).left === r ? c.left = n : c.right = n;
                                                            return void (t1[l - 1] = n);
                                                        }
                                                        if (n.left && 0 === n.left._color) {
                                                            if (s = (n = r.right = i(n)).left = i(n.left), r.right = s.left, n.left = s.right, s.left = r, s.right = n, s._color = r._color, r._color = 1, n._color = 1, e1._color = 1, o(r), o(n), o(s), l > 1) (c = t1[l - 2]).left === r ? c.left = s : c.right = s;
                                                            return void (t1[l - 1] = s);
                                                        }
                                                        if (1 === n._color) {
                                                            if (0 === r._color) return r._color = 1, void (r.right = a(0, n));
                                                            r.right = a(0, n);
                                                            continue;
                                                        }
                                                        n = i(n), r.right = n.left, n.left = r, n._color = r._color, r._color = 0, o(r), o(n), l > 1 && ((c = t1[l - 2]).left === r ? c.left = n : c.right = n), t1[l - 1] = n, t1[l] = r, l + 1 < t1.length ? t1[l + 1] = e1 : t1.push(e1), l += 2;
                                                    } else {
                                                        if ((n = r.left).left && 0 === n.left._color) {
                                                            if (s = (n = r.left = i(n)).left = i(n.left), r.left = n.right, n.right = r, n.left = s, n._color = r._color, e1._color = 1, r._color = 1, s._color = 1, o(r), o(n), l > 1) (c = t1[l - 2]).right === r ? c.right = n : c.left = n;
                                                            return void (t1[l - 1] = n);
                                                        }
                                                        if (n.right && 0 === n.right._color) {
                                                            if (s = (n = r.left = i(n)).right = i(n.right), r.left = s.right, n.right = s.left, s.right = r, s.left = n, s._color = r._color, r._color = 1, n._color = 1, e1._color = 1, o(r), o(n), o(s), l > 1) (c = t1[l - 2]).right === r ? c.right = s : c.left = s;
                                                            return void (t1[l - 1] = s);
                                                        }
                                                        if (1 === n._color) {
                                                            if (0 === r._color) return r._color = 1, void (r.left = a(0, n));
                                                            r.left = a(0, n);
                                                            continue;
                                                        }
                                                        var c;
                                                        n = i(n), r.left = n.right, n.right = r, n._color = r._color, r._color = 0, o(r), o(n), l > 1 && ((c = t1[l - 2]).right === r ? c.right = n : c.left = n), t1[l - 1] = n, t1[l] = r, l + 1 < t1.length ? t1[l + 1] = e1 : t1.push(e1), l += 2;
                                                    }
                                                }
                                            }(e1), h.left === r ? h.left = null : h.right = null, new s(this.tree._compare, e1[0]);
                                        }, Object.defineProperty(p, "key", {
                                            get: function() {
                                                if (this._stack.length > 0) return this._stack[this._stack.length - 1].key;
                                            },
                                            enumerable: !0
                                        }), Object.defineProperty(p, "value", {
                                            get: function() {
                                                if (this._stack.length > 0) return this._stack[this._stack.length - 1].value;
                                            },
                                            enumerable: !0
                                        }), Object.defineProperty(p, "index", {
                                            get: function() {
                                                var t1 = 0, e1 = this._stack;
                                                if (0 === e1.length) {
                                                    var r = this.tree.root;
                                                    return r ? r._count : 0;
                                                }
                                                e1[e1.length - 1].left && (t1 = e1[e1.length - 1].left._count);
                                                for(var n = e1.length - 2; n >= 0; --n)e1[n + 1] === e1[n].right && (++t1, e1[n].left && (t1 += e1[n].left._count));
                                                return t1;
                                            },
                                            enumerable: !0
                                        }), p.next = function() {
                                            var t1 = this._stack;
                                            if (0 !== t1.length) {
                                                var e1 = t1[t1.length - 1];
                                                if (e1.right) for(e1 = e1.right; e1;)t1.push(e1), e1 = e1.left;
                                                else for(t1.pop(); t1.length > 0 && t1[t1.length - 1].right === e1;)e1 = t1[t1.length - 1], t1.pop();
                                            }
                                        }, Object.defineProperty(p, "hasNext", {
                                            get: function() {
                                                var t1 = this._stack;
                                                if (0 === t1.length) return !1;
                                                if (t1[t1.length - 1].right) return !0;
                                                for(var e1 = t1.length - 1; e1 > 0; --e1)if (t1[e1 - 1].left === t1[e1]) return !0;
                                                return !1;
                                            }
                                        }), p.update = function(t1) {
                                            var e1 = this._stack;
                                            if (0 === e1.length) throw new Error("Can't update empty node!");
                                            var r = new Array(e1.length), i = e1[e1.length - 1];
                                            r[r.length - 1] = new n(i._color, i.key, t1, i.left, i.right, i._count);
                                            for(var a = e1.length - 2; a >= 0; --a)(i = e1[a]).left === e1[a + 1] ? r[a] = new n(i._color, i.key, i.value, r[a + 1], i.right, i._count) : r[a] = new n(i._color, i.key, i.value, i.left, r[a + 1], i._count);
                                            return new s(this.tree._compare, r[0]);
                                        }, p.prev = function() {
                                            var t1 = this._stack;
                                            if (0 !== t1.length) {
                                                var e1 = t1[t1.length - 1];
                                                if (e1.left) for(e1 = e1.left; e1;)t1.push(e1), e1 = e1.right;
                                                else for(t1.pop(); t1.length > 0 && t1[t1.length - 1].left === e1;)e1 = t1[t1.length - 1], t1.pop();
                                            }
                                        }, Object.defineProperty(p, "hasPrev", {
                                            get: function() {
                                                var t1 = this._stack;
                                                if (0 === t1.length) return !1;
                                                if (t1[t1.length - 1].left) return !0;
                                                for(var e1 = t1.length - 1; e1 > 0; --e1)if (t1[e1 - 1].right === t1[e1]) return !0;
                                                return !1;
                                            }
                                        });
                                    },
                                    {}
                                ],
                                70: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            var r = new u(t1);
                                            return r.update(e1), r;
                                        };
                                        var n = t1("./lib/text.js"), i = t1("./lib/lines.js"), a = t1("./lib/background.js"), o = t1("./lib/cube.js"), s = t1("./lib/ticks.js"), l = new Float32Array([
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ]);
                                        function c(t1, e1) {
                                            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1;
                                        }
                                        function u(t1) {
                                            this.gl = t1, this.pixelRatio = 1, this.bounds = [
                                                [
                                                    -10,
                                                    -10,
                                                    -10
                                                ],
                                                [
                                                    10,
                                                    10,
                                                    10
                                                ]
                                            ], this.ticks = [
                                                [],
                                                [],
                                                []
                                            ], this.autoTicks = !0, this.tickSpacing = [
                                                1,
                                                1,
                                                1
                                            ], this.tickEnable = [
                                                !0,
                                                !0,
                                                !0
                                            ], this.tickFont = [
                                                "sans-serif",
                                                "sans-serif",
                                                "sans-serif"
                                            ], this.tickSize = [
                                                12,
                                                12,
                                                12
                                            ], this.tickAngle = [
                                                0,
                                                0,
                                                0
                                            ], this.tickAlign = [
                                                "auto",
                                                "auto",
                                                "auto"
                                            ], this.tickColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.tickPad = [
                                                10,
                                                10,
                                                10
                                            ], this.lastCubeProps = {
                                                cubeEdges: [
                                                    0,
                                                    0,
                                                    0
                                                ],
                                                axis: [
                                                    0,
                                                    0,
                                                    0
                                                ]
                                            }, this.labels = [
                                                "x",
                                                "y",
                                                "z"
                                            ], this.labelEnable = [
                                                !0,
                                                !0,
                                                !0
                                            ], this.labelFont = "sans-serif", this.labelSize = [
                                                20,
                                                20,
                                                20
                                            ], this.labelAngle = [
                                                0,
                                                0,
                                                0
                                            ], this.labelAlign = [
                                                "auto",
                                                "auto",
                                                "auto"
                                            ], this.labelColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.labelPad = [
                                                10,
                                                10,
                                                10
                                            ], this.lineEnable = [
                                                !0,
                                                !0,
                                                !0
                                            ], this.lineMirror = [
                                                !1,
                                                !1,
                                                !1
                                            ], this.lineWidth = [
                                                1,
                                                1,
                                                1
                                            ], this.lineColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.lineTickEnable = [
                                                !0,
                                                !0,
                                                !0
                                            ], this.lineTickMirror = [
                                                !1,
                                                !1,
                                                !1
                                            ], this.lineTickLength = [
                                                0,
                                                0,
                                                0
                                            ], this.lineTickWidth = [
                                                1,
                                                1,
                                                1
                                            ], this.lineTickColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.gridEnable = [
                                                !0,
                                                !0,
                                                !0
                                            ], this.gridWidth = [
                                                1,
                                                1,
                                                1
                                            ], this.gridColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.zeroEnable = [
                                                !0,
                                                !0,
                                                !0
                                            ], this.zeroLineColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.zeroLineWidth = [
                                                2,
                                                2,
                                                2
                                            ], this.backgroundEnable = [
                                                !1,
                                                !1,
                                                !1
                                            ], this.backgroundColor = [
                                                [
                                                    .8,
                                                    .8,
                                                    .8,
                                                    .5
                                                ],
                                                [
                                                    .8,
                                                    .8,
                                                    .8,
                                                    .5
                                                ],
                                                [
                                                    .8,
                                                    .8,
                                                    .8,
                                                    .5
                                                ]
                                            ], this._firstInit = !0, this._text = null, this._lines = null, this._background = a(t1);
                                        }
                                        var f = u.prototype;
                                        function h() {
                                            this.primalOffset = [
                                                0,
                                                0,
                                                0
                                            ], this.primalMinor = [
                                                0,
                                                0,
                                                0
                                            ], this.mirrorOffset = [
                                                0,
                                                0,
                                                0
                                            ], this.mirrorMinor = [
                                                0,
                                                0,
                                                0
                                            ];
                                        }
                                        f.update = function(t1) {
                                            function e1(e1, r, n) {
                                                if (n in t1) {
                                                    var i, a = t1[n], o = this[n];
                                                    (e1 ? Array.isArray(a) && Array.isArray(a[0]) : Array.isArray(a)) ? this[n] = i = [
                                                        r(a[0]),
                                                        r(a[1]),
                                                        r(a[2])
                                                    ] : this[n] = i = [
                                                        r(a),
                                                        r(a),
                                                        r(a)
                                                    ];
                                                    for(var s = 0; s < 3; ++s)if (i[s] !== o[s]) return !0;
                                                }
                                                return !1;
                                            }
                                            t1 = t1 || {};
                                            var r, a = e1.bind(this, !1, Number), o = e1.bind(this, !1, Boolean), l = e1.bind(this, !1, String), c = e1.bind(this, !0, function(t1) {
                                                if (Array.isArray(t1)) {
                                                    if (3 === t1.length) return [
                                                        +t1[0],
                                                        +t1[1],
                                                        +t1[2],
                                                        1
                                                    ];
                                                    if (4 === t1.length) return [
                                                        +t1[0],
                                                        +t1[1],
                                                        +t1[2],
                                                        +t1[3]
                                                    ];
                                                }
                                                return [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ];
                                            }), u = !1, f = !1;
                                            if ("bounds" in t1) for(var h = t1.bounds, p = 0; p < 2; ++p)for(var d = 0; d < 3; ++d)h[p][d] !== this.bounds[p][d] && (f = !0), this.bounds[p][d] = h[p][d];
                                            if ("ticks" in t1) {
                                                r = t1.ticks, u = !0, this.autoTicks = !1;
                                                for(p = 0; p < 3; ++p)this.tickSpacing[p] = 0;
                                            } else a("tickSpacing") && (this.autoTicks = !0, f = !0);
                                            if (this._firstInit && ("ticks" in t1 || "tickSpacing" in t1 || (this.autoTicks = !0), f = !0, u = !0, this._firstInit = !1), f && this.autoTicks && (r = s.create(this.bounds, this.tickSpacing), u = !0), u) {
                                                for(p = 0; p < 3; ++p)r[p].sort(function(t1, e1) {
                                                    return t1.x - e1.x;
                                                });
                                                s.equal(r, this.ticks) ? u = !1 : this.ticks = r;
                                            }
                                            o("tickEnable"), l("tickFont") && (u = !0), a("tickSize"), a("tickAngle"), a("tickPad"), c("tickColor");
                                            var m = l("labels");
                                            l("labelFont") && (m = !0), o("labelEnable"), a("labelSize"), a("labelPad"), c("labelColor"), o("lineEnable"), o("lineMirror"), a("lineWidth"), c("lineColor"), o("lineTickEnable"), o("lineTickMirror"), a("lineTickLength"), a("lineTickWidth"), c("lineTickColor"), o("gridEnable"), a("gridWidth"), c("gridColor"), o("zeroEnable"), c("zeroLineColor"), a("zeroLineWidth"), o("backgroundEnable"), c("backgroundColor"), this._text ? this._text && (m || u) && this._text.update(this.bounds, this.labels, this.labelFont, this.ticks, this.tickFont) : this._text = n(this.gl, this.bounds, this.labels, this.labelFont, this.ticks, this.tickFont), this._lines && u && (this._lines.dispose(), this._lines = null), this._lines || (this._lines = i(this.gl, this.bounds, this.ticks));
                                        };
                                        var p = [
                                            new h,
                                            new h,
                                            new h
                                        ];
                                        function d(t1, e1, r, n, i) {
                                            for(var a = t1.primalOffset, o = t1.primalMinor, s = t1.mirrorOffset, l = t1.mirrorMinor, c = n[e1], u = 0; u < 3; ++u)if (e1 !== u) {
                                                var f = a, h = s, p = o, d = l;
                                                c & 1 << u && (f = s, h = a, p = l, d = o), f[u] = r[0][u], h[u] = r[1][u], i[u] > 0 ? (p[u] = -1, d[u] = 0) : (p[u] = 0, d[u] = 1);
                                            }
                                        }
                                        var m = [
                                            0,
                                            0,
                                            0
                                        ], g = {
                                            model: l,
                                            view: l,
                                            projection: l,
                                            _ortho: !1
                                        };
                                        f.isOpaque = function() {
                                            return !0;
                                        }, f.isTransparent = function() {
                                            return !1;
                                        }, f.drawTransparent = function(t1) {};
                                        var v = [
                                            0,
                                            0,
                                            0
                                        ], y = [
                                            0,
                                            0,
                                            0
                                        ], x = [
                                            0,
                                            0,
                                            0
                                        ];
                                        f.draw = function(t1) {
                                            t1 = t1 || g;
                                            for(var e1 = this.gl, r = t1.model || l, n = t1.view || l, i = t1.projection || l, a = this.bounds, s = t1._ortho || !1, u = o(r, n, i, a, s), f = u.cubeEdges, h = u.axis, b = n[12], _ = n[13], w = n[14], T = n[15], k = (s ? 2 : 1) * this.pixelRatio * (i[3] * b + i[7] * _ + i[11] * w + i[15] * T) / e1.drawingBufferHeight, A = 0; A < 3; ++A)this.lastCubeProps.cubeEdges[A] = f[A], this.lastCubeProps.axis[A] = h[A];
                                            var M = p;
                                            for(A = 0; A < 3; ++A)d(p[A], A, this.bounds, f, h);
                                            e1 = this.gl;
                                            var S, E = m;
                                            for(A = 0; A < 3; ++A)this.backgroundEnable[A] ? E[A] = h[A] : E[A] = 0;
                                            this._background.draw(r, n, i, a, E, this.backgroundColor), this._lines.bind(r, n, i, this);
                                            for(A = 0; A < 3; ++A){
                                                var L = [
                                                    0,
                                                    0,
                                                    0
                                                ];
                                                h[A] > 0 ? L[A] = a[1][A] : L[A] = a[0][A];
                                                for(var C = 0; C < 2; ++C){
                                                    var P = (A + 1 + C) % 3, I = (A + 1 + (1 ^ C)) % 3;
                                                    this.gridEnable[P] && this._lines.drawGrid(P, I, this.bounds, L, this.gridColor[P], this.gridWidth[P] * this.pixelRatio);
                                                }
                                                for(C = 0; C < 2; ++C){
                                                    P = (A + 1 + C) % 3, I = (A + 1 + (1 ^ C)) % 3;
                                                    this.zeroEnable[I] && Math.min(a[0][I], a[1][I]) <= 0 && Math.max(a[0][I], a[1][I]) >= 0 && this._lines.drawZero(P, I, this.bounds, L, this.zeroLineColor[I], this.zeroLineWidth[I] * this.pixelRatio);
                                                }
                                            }
                                            for(A = 0; A < 3; ++A){
                                                this.lineEnable[A] && this._lines.drawAxisLine(A, this.bounds, M[A].primalOffset, this.lineColor[A], this.lineWidth[A] * this.pixelRatio), this.lineMirror[A] && this._lines.drawAxisLine(A, this.bounds, M[A].mirrorOffset, this.lineColor[A], this.lineWidth[A] * this.pixelRatio);
                                                var O = c(v, M[A].primalMinor), z = c(y, M[A].mirrorMinor), D = this.lineTickLength;
                                                for(C = 0; C < 3; ++C){
                                                    var R = k / r[5 * C];
                                                    O[C] *= D[C] * R, z[C] *= D[C] * R;
                                                }
                                                this.lineTickEnable[A] && this._lines.drawAxisTicks(A, M[A].primalOffset, O, this.lineTickColor[A], this.lineTickWidth[A] * this.pixelRatio), this.lineTickMirror[A] && this._lines.drawAxisTicks(A, M[A].mirrorOffset, z, this.lineTickColor[A], this.lineTickWidth[A] * this.pixelRatio);
                                            }
                                            this._lines.unbind(), this._text.bind(r, n, i, this.pixelRatio);
                                            var F, B;
                                            function N(t1) {
                                                (B = [
                                                    0,
                                                    0,
                                                    0
                                                ])[t1] = 1;
                                            }
                                            function j(t1, e1, r) {
                                                var n = (t1 + 1) % 3, i = (t1 + 2) % 3, a = e1[n], o = e1[i], s = r[n], l = r[i];
                                                a > 0 && l > 0 || a > 0 && l < 0 || a < 0 && l > 0 || a < 0 && l < 0 ? N(n) : (o > 0 && s > 0 || o > 0 && s < 0 || o < 0 && s > 0 || o < 0 && s < 0) && N(i);
                                            }
                                            for(A = 0; A < 3; ++A){
                                                var U = M[A].primalMinor, V = M[A].mirrorMinor, H = c(x, M[A].primalOffset);
                                                for(C = 0; C < 3; ++C)this.lineTickEnable[A] && (H[C] += k * U[C] * Math.max(this.lineTickLength[C], 0) / r[5 * C]);
                                                var q = [
                                                    0,
                                                    0,
                                                    0
                                                ];
                                                if (q[A] = 1, this.tickEnable[A]) {
                                                    -3600 === this.tickAngle[A] ? (this.tickAngle[A] = 0, this.tickAlign[A] = "auto") : this.tickAlign[A] = -1, F = 1, "auto" === (S = [
                                                        this.tickAlign[A],
                                                        .5,
                                                        F
                                                    ])[0] ? S[0] = 0 : S[0] = parseInt("" + S[0]), B = [
                                                        0,
                                                        0,
                                                        0
                                                    ], j(A, U, V);
                                                    for(C = 0; C < 3; ++C)H[C] += k * U[C] * this.tickPad[C] / r[5 * C];
                                                    this._text.drawTicks(A, this.tickSize[A], this.tickAngle[A], H, this.tickColor[A], q, B, S);
                                                }
                                                if (this.labelEnable[A]) {
                                                    F = 0, B = [
                                                        0,
                                                        0,
                                                        0
                                                    ], this.labels[A].length > 4 && (N(A), F = 1), "auto" === (S = [
                                                        this.labelAlign[A],
                                                        .5,
                                                        F
                                                    ])[0] ? S[0] = 0 : S[0] = parseInt("" + S[0]);
                                                    for(C = 0; C < 3; ++C)H[C] += k * U[C] * this.labelPad[C] / r[5 * C];
                                                    H[A] += .5 * (a[0][A] + a[1][A]), this._text.drawLabel(A, this.labelSize[A], this.labelAngle[A], H, this.labelColor[A], [
                                                        0,
                                                        0,
                                                        0
                                                    ], B, S);
                                                }
                                            }
                                            this._text.unbind();
                                        }, f.dispose = function() {
                                            this._text.dispose(), this._lines.dispose(), this._background.dispose(), this._lines = null, this._text = null, this._background = null, this.gl = null;
                                        };
                                    },
                                    {
                                        "./lib/background.js": 71,
                                        "./lib/cube.js": 72,
                                        "./lib/lines.js": 73,
                                        "./lib/text.js": 75,
                                        "./lib/ticks.js": 76
                                    }
                                ],
                                71: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            for(var e1 = [], r = [], s = 0, l = 0; l < 3; ++l)for(var c = (l + 1) % 3, u = (l + 2) % 3, f = [
                                                0,
                                                0,
                                                0
                                            ], h = [
                                                0,
                                                0,
                                                0
                                            ], p = -1; p <= 1; p += 2){
                                                r.push(s, s + 2, s + 1, s + 1, s + 2, s + 3), f[l] = p, h[l] = p;
                                                for(var d = -1; d <= 1; d += 2){
                                                    f[c] = d;
                                                    for(var m = -1; m <= 1; m += 2)f[u] = m, e1.push(f[0], f[1], f[2], h[0], h[1], h[2]), s += 1;
                                                }
                                                var g = c;
                                                c = u, u = g;
                                            }
                                            var v = n(t1, new Float32Array(e1)), y = n(t1, new Uint16Array(r), t1.ELEMENT_ARRAY_BUFFER), x = i(t1, [
                                                {
                                                    buffer: v,
                                                    type: t1.FLOAT,
                                                    size: 3,
                                                    offset: 0,
                                                    stride: 24
                                                },
                                                {
                                                    buffer: v,
                                                    type: t1.FLOAT,
                                                    size: 3,
                                                    offset: 12,
                                                    stride: 24
                                                }
                                            ], y), b = a(t1);
                                            return b.attributes.position.location = 0, b.attributes.normal.location = 1, new o(t1, v, x, b);
                                        };
                                        var n = t1("gl-buffer"), i = t1("gl-vao"), a = t1("./shaders").bg;
                                        function o(t1, e1, r, n) {
                                            this.gl = t1, this.buffer = e1, this.vao = r, this.shader = n;
                                        }
                                        var s = o.prototype;
                                        s.draw = function(t1, e1, r, n, i, a) {
                                            for(var o = !1, s = 0; s < 3; ++s)o = o || i[s];
                                            if (o) {
                                                var l = this.gl;
                                                l.enable(l.POLYGON_OFFSET_FILL), l.polygonOffset(1, 2), this.shader.bind(), this.shader.uniforms = {
                                                    model: t1,
                                                    view: e1,
                                                    projection: r,
                                                    bounds: n,
                                                    enable: i,
                                                    colors: a
                                                }, this.vao.bind(), this.vao.draw(this.gl.TRIANGLES, 36), this.vao.unbind(), l.disable(l.POLYGON_OFFSET_FILL);
                                            }
                                        }, s.dispose = function() {
                                            this.vao.dispose(), this.buffer.dispose(), this.shader.dispose();
                                        };
                                    },
                                    {
                                        "./shaders": 74,
                                        "gl-buffer": 78,
                                        "gl-vao": 150
                                    }
                                ],
                                72: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r, a, p) {
                                            i(s, e1, t1), i(s, r, s);
                                            for(var y = 0, x = 0; x < 2; ++x){
                                                u[2] = a[x][2];
                                                for(var b = 0; b < 2; ++b){
                                                    u[1] = a[b][1];
                                                    for(var _ = 0; _ < 2; ++_)u[0] = a[_][0], h(l[y], u, s), y += 1;
                                                }
                                            }
                                            var w = -1;
                                            for(x = 0; x < 8; ++x){
                                                for(var T = l[x][3], k = 0; k < 3; ++k)c[x][k] = l[x][k] / T;
                                                p && (c[x][2] *= -1), T < 0 && (w < 0 || c[x][2] < c[w][2]) && (w = x);
                                            }
                                            if (w < 0) {
                                                w = 0;
                                                for(var A = 0; A < 3; ++A){
                                                    for(var M = (A + 2) % 3, S = (A + 1) % 3, E = -1, L = -1, C = 0; C < 2; ++C){
                                                        var P = (O = C << A) + (C << M) + (1 - C << S), I = O + (1 - C << M) + (C << S);
                                                        o(c[O], c[P], c[I], f) < 0 || (C ? E = 1 : L = 1);
                                                    }
                                                    if (E < 0 || L < 0) L > E && (w |= 1 << A);
                                                    else {
                                                        for(C = 0; C < 2; ++C){
                                                            P = (O = C << A) + (C << M) + (1 - C << S), I = O + (1 - C << M) + (C << S);
                                                            var O, z = d([
                                                                l[O],
                                                                l[P],
                                                                l[I],
                                                                l[O + (1 << M) + (1 << S)]
                                                            ]);
                                                            C ? E = z : L = z;
                                                        }
                                                        L > E && (w |= 1 << A);
                                                    }
                                                }
                                            }
                                            var D = 7 ^ w, R = -1;
                                            for(x = 0; x < 8; ++x)x !== w && x !== D && (R < 0 || c[R][1] > c[x][1]) && (R = x);
                                            var F = -1;
                                            for(x = 0; x < 3; ++x)if ((N = R ^ 1 << x) !== w && N !== D) F < 0 && (F = N), (S = c[N])[0] < c[F][0] && (F = N);
                                            var B = -1;
                                            for(x = 0; x < 3; ++x){
                                                var N;
                                                if ((N = R ^ 1 << x) !== w && N !== D && N !== F) B < 0 && (B = N), (S = c[N])[0] > c[B][0] && (B = N);
                                            }
                                            var j = m;
                                            j[0] = j[1] = j[2] = 0, j[n.log2(F ^ R)] = R & F, j[n.log2(R ^ B)] = R & B;
                                            var U = 7 ^ B;
                                            U === w || U === D ? (U = 7 ^ F, j[n.log2(B ^ U)] = U & B) : j[n.log2(F ^ U)] = U & F;
                                            var V = g, H = w;
                                            for(A = 0; A < 3; ++A)V[A] = H & 1 << A ? -1 : 1;
                                            return v;
                                        };
                                        var n = t1("bit-twiddle"), i = t1("gl-mat4/multiply"), a = t1("split-polygon"), o = t1("robust-orientation"), s = new Array(16), l = new Array(8), c = new Array(8), u = new Array(3), f = [
                                            0,
                                            0,
                                            0
                                        ];
                                        function h(t1, e1, r) {
                                            for(var n = 0; n < 4; ++n){
                                                t1[n] = r[12 + n];
                                                for(var i = 0; i < 3; ++i)t1[n] += e1[i] * r[4 * i + n];
                                            }
                                        }
                                        !function() {
                                            for(var t1 = 0; t1 < 8; ++t1)l[t1] = [
                                                1,
                                                1,
                                                1,
                                                1
                                            ], c[t1] = [
                                                1,
                                                1,
                                                1
                                            ];
                                        }();
                                        var p = [
                                            [
                                                0,
                                                0,
                                                1,
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0,
                                                -1,
                                                1,
                                                0
                                            ],
                                            [
                                                0,
                                                -1,
                                                0,
                                                1,
                                                0
                                            ],
                                            [
                                                0,
                                                1,
                                                0,
                                                1,
                                                0
                                            ],
                                            [
                                                -1,
                                                0,
                                                0,
                                                1,
                                                0
                                            ],
                                            [
                                                1,
                                                0,
                                                0,
                                                1,
                                                0
                                            ]
                                        ];
                                        function d(t1) {
                                            for(var e1 = 0; e1 < p.length; ++e1)if ((t1 = a.positive(t1, p[e1])).length < 3) return 0;
                                            var r = t1[0], n = r[0] / r[3], i = r[1] / r[3], o = 0;
                                            for(e1 = 1; e1 + 1 < t1.length; ++e1){
                                                var s = t1[e1], l = t1[e1 + 1], c = s[0] / s[3] - n, u = s[1] / s[3] - i, f = l[0] / l[3] - n, h = l[1] / l[3] - i;
                                                o += Math.abs(c * h - u * f);
                                            }
                                            return o;
                                        }
                                        var m = [
                                            1,
                                            1,
                                            1
                                        ], g = [
                                            0,
                                            0,
                                            0
                                        ], v = {
                                            cubeEdges: m,
                                            axis: g
                                        };
                                    },
                                    {
                                        "bit-twiddle": 32,
                                        "gl-mat4/multiply": 100,
                                        "robust-orientation": 284,
                                        "split-polygon": 300
                                    }
                                ],
                                73: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r) {
                                            var o = [], s = [
                                                0,
                                                0,
                                                0
                                            ], l = [
                                                0,
                                                0,
                                                0
                                            ], c = [
                                                0,
                                                0,
                                                0
                                            ], u = [
                                                0,
                                                0,
                                                0
                                            ];
                                            o.push(0, 0, 1, 0, 1, 1, 0, 0, -1, 0, 0, -1, 0, 1, 1, 0, 1, -1);
                                            for(var f = 0; f < 3; ++f){
                                                for(var h = o.length / 3 | 0, d = 0; d < r[f].length; ++d){
                                                    var m = +r[f][d].x;
                                                    o.push(m, 0, 1, m, 1, 1, m, 0, -1, m, 0, -1, m, 1, 1, m, 1, -1);
                                                }
                                                var g = o.length / 3 | 0;
                                                s[f] = h, l[f] = g - h;
                                                h = o.length / 3 | 0;
                                                for(var v = 0; v < r[f].length; ++v){
                                                    m = +r[f][v].x;
                                                    o.push(m, 0, 1, m, 1, 1, m, 0, -1, m, 0, -1, m, 1, 1, m, 1, -1);
                                                }
                                                g = o.length / 3 | 0;
                                                c[f] = h, u[f] = g - h;
                                            }
                                            var y = n(t1, new Float32Array(o)), x = i(t1, [
                                                {
                                                    buffer: y,
                                                    type: t1.FLOAT,
                                                    size: 3,
                                                    stride: 0,
                                                    offset: 0
                                                }
                                            ]), b = a(t1);
                                            return b.attributes.position.location = 0, new p(t1, y, x, b, l, s, u, c);
                                        };
                                        var n = t1("gl-buffer"), i = t1("gl-vao"), a = t1("./shaders").line, o = [
                                            0,
                                            0,
                                            0
                                        ], s = [
                                            0,
                                            0,
                                            0
                                        ], l = [
                                            0,
                                            0,
                                            0
                                        ], c = [
                                            0,
                                            0,
                                            0
                                        ], u = [
                                            1,
                                            1
                                        ];
                                        function f(t1) {
                                            return t1[0] = t1[1] = t1[2] = 0, t1;
                                        }
                                        function h(t1, e1) {
                                            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1;
                                        }
                                        function p(t1, e1, r, n, i, a, o, s) {
                                            this.gl = t1, this.vertBuffer = e1, this.vao = r, this.shader = n, this.tickCount = i, this.tickOffset = a, this.gridCount = o, this.gridOffset = s;
                                        }
                                        var d = p.prototype;
                                        d.bind = function(t1, e1, r) {
                                            this.shader.bind(), this.shader.uniforms.model = t1, this.shader.uniforms.view = e1, this.shader.uniforms.projection = r, u[0] = this.gl.drawingBufferWidth, u[1] = this.gl.drawingBufferHeight, this.shader.uniforms.screenShape = u, this.vao.bind();
                                        }, d.unbind = function() {
                                            this.vao.unbind();
                                        }, d.drawAxisLine = function(t1, e1, r, n, i) {
                                            var a = f(s);
                                            this.shader.uniforms.majorAxis = s, a[t1] = e1[1][t1] - e1[0][t1], this.shader.uniforms.minorAxis = a;
                                            var o, u = h(c, r);
                                            u[t1] += e1[0][t1], this.shader.uniforms.offset = u, this.shader.uniforms.lineWidth = i, this.shader.uniforms.color = n, (o = f(l))[(t1 + 2) % 3] = 1, this.shader.uniforms.screenAxis = o, this.vao.draw(this.gl.TRIANGLES, 6), (o = f(l))[(t1 + 1) % 3] = 1, this.shader.uniforms.screenAxis = o, this.vao.draw(this.gl.TRIANGLES, 6);
                                        }, d.drawAxisTicks = function(t1, e1, r, n, i) {
                                            if (this.tickCount[t1]) {
                                                var a = f(o);
                                                a[t1] = 1, this.shader.uniforms.majorAxis = a, this.shader.uniforms.offset = e1, this.shader.uniforms.minorAxis = r, this.shader.uniforms.color = n, this.shader.uniforms.lineWidth = i;
                                                var s = f(l);
                                                s[t1] = 1, this.shader.uniforms.screenAxis = s, this.vao.draw(this.gl.TRIANGLES, this.tickCount[t1], this.tickOffset[t1]);
                                            }
                                        }, d.drawGrid = function(t1, e1, r, n, i, a) {
                                            if (this.gridCount[t1]) {
                                                var u = f(s);
                                                u[e1] = r[1][e1] - r[0][e1], this.shader.uniforms.minorAxis = u;
                                                var p = h(c, n);
                                                p[e1] += r[0][e1], this.shader.uniforms.offset = p;
                                                var d = f(o);
                                                d[t1] = 1, this.shader.uniforms.majorAxis = d;
                                                var m = f(l);
                                                m[t1] = 1, this.shader.uniforms.screenAxis = m, this.shader.uniforms.lineWidth = a, this.shader.uniforms.color = i, this.vao.draw(this.gl.TRIANGLES, this.gridCount[t1], this.gridOffset[t1]);
                                            }
                                        }, d.drawZero = function(t1, e1, r, n, i, a) {
                                            var o = f(s);
                                            this.shader.uniforms.majorAxis = o, o[t1] = r[1][t1] - r[0][t1], this.shader.uniforms.minorAxis = o;
                                            var u = h(c, n);
                                            u[t1] += r[0][t1], this.shader.uniforms.offset = u;
                                            var p = f(l);
                                            p[e1] = 1, this.shader.uniforms.screenAxis = p, this.shader.uniforms.lineWidth = a, this.shader.uniforms.color = i, this.vao.draw(this.gl.TRIANGLES, 6);
                                        }, d.dispose = function() {
                                            this.vao.dispose(), this.vertBuffer.dispose(), this.shader.dispose();
                                        };
                                    },
                                    {
                                        "./shaders": 74,
                                        "gl-buffer": 78,
                                        "gl-vao": 150
                                    }
                                ],
                                74: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("glslify"), i = t1("gl-shader"), a = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, majorAxis, minorAxis, screenAxis;\nuniform float lineWidth;\nuniform vec2 screenShape;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * view * model * vec4(p, 1.0);\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nvoid main() {\n  vec3 major = position.x * majorAxis;\n  vec3 minor = position.y * minorAxis;\n\n  vec3 vPosition = major + minor + offset;\n  vec3 pPosition = project(vPosition);\n  vec3 offset = project(vPosition + screenAxis * position.z);\n\n  vec2 screen = normalize((offset - pPosition).xy * screenShape) / screenShape;\n\n  gl_Position = vec4(pPosition + vec3(0.5 * screen * lineWidth, 0), 1.0);\n}\n"
                                        ]), o = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"
                                        ]);
                                        r.line = function(t1) {
                                            return i(t1, a, o, null, [
                                                {
                                                    name: "position",
                                                    type: "vec3"
                                                }
                                            ]);
                                        };
                                        var s = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, axis, alignDir, alignOpt;\nuniform float scale, angle, pixelScale;\nuniform vec2 resolution;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * view * model * vec4(p, 1.0);\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nfloat computeViewAngle(vec3 a, vec3 b) {\n  vec3 A = project(a);\n  vec3 B = project(b);\n\n  return atan(\n    (B.y - A.y) * resolution.y,\n    (B.x - A.x) * resolution.x\n  );\n}\n\nconst float PI = 3.141592;\nconst float TWO_PI = 2.0 * PI;\nconst float HALF_PI = 0.5 * PI;\nconst float ONE_AND_HALF_PI = 1.5 * PI;\n\nint option = int(floor(alignOpt.x + 0.001));\nfloat hv_ratio =       alignOpt.y;\nbool enableAlign =    (alignOpt.z != 0.0);\n\nfloat mod_angle(float a) {\n  return mod(a, PI);\n}\n\nfloat positive_angle(float a) {\n  return mod_angle((a < 0.0) ?\n    a + TWO_PI :\n    a\n  );\n}\n\nfloat look_upwards(float a) {\n  float b = positive_angle(a);\n  return ((b > HALF_PI) && (b <= ONE_AND_HALF_PI)) ?\n    b - PI :\n    b;\n}\n\nfloat look_horizontal_or_vertical(float a, float ratio) {\n  // ratio controls the ratio between being horizontal to (vertical + horizontal)\n  // if ratio is set to 0.5 then it is 50%, 50%.\n  // when using a higher ratio e.g. 0.75 the result would\n  // likely be more horizontal than vertical.\n\n  float b = positive_angle(a);\n\n  return\n    (b < (      ratio) * HALF_PI) ? 0.0 :\n    (b < (2.0 - ratio) * HALF_PI) ? -HALF_PI :\n    (b < (2.0 + ratio) * HALF_PI) ? 0.0 :\n    (b < (4.0 - ratio) * HALF_PI) ? HALF_PI :\n                                    0.0;\n}\n\nfloat roundTo(float a, float b) {\n  return float(b * floor((a + 0.5 * b) / b));\n}\n\nfloat look_round_n_directions(float a, int n) {\n  float b = positive_angle(a);\n  float div = TWO_PI / float(n);\n  float c = roundTo(b, div);\n  return look_upwards(c);\n}\n\nfloat applyAlignOption(float rawAngle, float delta) {\n  return\n    (option >  2) ? look_round_n_directions(rawAngle + delta, option) :       // option 3-n: round to n directions\n    (option == 2) ? look_horizontal_or_vertical(rawAngle + delta, hv_ratio) : // horizontal or vertical\n    (option == 1) ? rawAngle + delta :       // use free angle, and flip to align with one direction of the axis\n    (option == 0) ? look_upwards(rawAngle) : // use free angle, and stay upwards\n    (option ==-1) ? 0.0 :                    // useful for backward compatibility, all texts remains horizontal\n                    rawAngle;                // otherwise return back raw input angle\n}\n\nbool isAxisTitle = (axis.x == 0.0) &&\n                   (axis.y == 0.0) &&\n                   (axis.z == 0.0);\n\nvoid main() {\n  //Compute world offset\n  float axisDistance = position.z;\n  vec3 dataPosition = axisDistance * axis + offset;\n\n  float beta = angle; // i.e. user defined attributes for each tick\n\n  float axisAngle;\n  float clipAngle;\n  float flip;\n\n  if (enableAlign) {\n    axisAngle = (isAxisTitle) ? HALF_PI :\n                      computeViewAngle(dataPosition, dataPosition + axis);\n    clipAngle = computeViewAngle(dataPosition, dataPosition + alignDir);\n\n    axisAngle += (sin(axisAngle) < 0.0) ? PI : 0.0;\n    clipAngle += (sin(clipAngle) < 0.0) ? PI : 0.0;\n\n    flip = (dot(vec2(cos(axisAngle), sin(axisAngle)),\n                vec2(sin(clipAngle),-cos(clipAngle))) > 0.0) ? 1.0 : 0.0;\n\n    beta += applyAlignOption(clipAngle, flip * PI);\n  }\n\n  //Compute plane offset\n  vec2 planeCoord = position.xy * pixelScale;\n\n  mat2 planeXform = scale * mat2(\n     cos(beta), sin(beta),\n    -sin(beta), cos(beta)\n  );\n\n  vec2 viewOffset = 2.0 * planeXform * planeCoord / resolution;\n\n  //Compute clip position\n  vec3 clipPosition = project(dataPosition);\n\n  //Apply text offset in clip coordinates\n  clipPosition += vec3(viewOffset, 0.0);\n\n  //Done\n  gl_Position = vec4(clipPosition, 1.0);\n}"
                                        ]), l = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"
                                        ]);
                                        r.text = function(t1) {
                                            return i(t1, s, l, null, [
                                                {
                                                    name: "position",
                                                    type: "vec3"
                                                }
                                            ]);
                                        };
                                        var c = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec3 normal;\n\nuniform mat4 model, view, projection;\nuniform vec3 enable;\nuniform vec3 bounds[2];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n\n  vec3 signAxis = sign(bounds[1] - bounds[0]);\n\n  vec3 realNormal = signAxis * normal;\n\n  if(dot(realNormal, enable) > 0.0) {\n    vec3 minRange = min(bounds[0], bounds[1]);\n    vec3 maxRange = max(bounds[0], bounds[1]);\n    vec3 nPosition = mix(minRange, maxRange, 0.5 * (position + 1.0));\n    gl_Position = projection * view * model * vec4(nPosition, 1.0);\n  } else {\n    gl_Position = vec4(0,0,0,0);\n  }\n\n  colorChannel = abs(realNormal);\n}"
                                        ]), u = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 colors[3];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n  gl_FragColor = colorChannel.x * colors[0] +\n                 colorChannel.y * colors[1] +\n                 colorChannel.z * colors[2];\n}"
                                        ]);
                                        r.bg = function(t1) {
                                            return i(t1, c, u, null, [
                                                {
                                                    name: "position",
                                                    type: "vec3"
                                                },
                                                {
                                                    name: "normal",
                                                    type: "vec3"
                                                }
                                            ]);
                                        };
                                    },
                                    {
                                        "gl-shader": 132,
                                        glslify: 231
                                    }
                                ],
                                75: [
                                    function(t1, e1, r) {
                                        (function(r) {
                                            (function() {
                                                "use strict";
                                                e1.exports = function(t1, e1, r, a, s, l) {
                                                    var u = n(t1), f = i(t1, [
                                                        {
                                                            buffer: u,
                                                            size: 3
                                                        }
                                                    ]), h = o(t1);
                                                    h.attributes.position.location = 0;
                                                    var p = new c(t1, h, u, f);
                                                    return p.update(e1, r, a, s, l), p;
                                                };
                                                var n = t1("gl-buffer"), i = t1("gl-vao"), a = t1("vectorize-text"), o = t1("./shaders").text, s = window || r.global || {}, l = s.__TEXT_CACHE || {};
                                                s.__TEXT_CACHE = {};
                                                function c(t1, e1, r, n) {
                                                    this.gl = t1, this.shader = e1, this.buffer = r, this.vao = n, this.tickOffset = this.tickCount = this.labelOffset = this.labelCount = null;
                                                }
                                                var u = c.prototype, f = [
                                                    0,
                                                    0
                                                ];
                                                u.bind = function(t1, e1, r, n) {
                                                    this.vao.bind(), this.shader.bind();
                                                    var i = this.shader.uniforms;
                                                    i.model = t1, i.view = e1, i.projection = r, i.pixelScale = n, f[0] = this.gl.drawingBufferWidth, f[1] = this.gl.drawingBufferHeight, this.shader.uniforms.resolution = f;
                                                }, u.unbind = function() {
                                                    this.vao.unbind();
                                                }, u.update = function(t1, e1, r, n, i) {
                                                    var o = [];
                                                    function s(t1, e1, r, n, i, s) {
                                                        var c = l[r];
                                                        c || (c = l[r] = {});
                                                        var u = c[e1];
                                                        u || (u = c[e1] = function(t1, e1) {
                                                            try {
                                                                return a(t1, e1);
                                                            } catch (e1) {
                                                                return console.warn('error vectorizing text:"' + t1 + '" error:', e1), {
                                                                    cells: [],
                                                                    positions: []
                                                                };
                                                            }
                                                        }(e1, {
                                                            triangles: !0,
                                                            font: r,
                                                            textAlign: "center",
                                                            textBaseline: "middle",
                                                            lineSpacing: i,
                                                            styletags: s
                                                        }));
                                                        for(var f = (n || 12) / 12, h = u.positions, p = u.cells, d = 0, m = p.length; d < m; ++d)for(var g = p[d], v = 2; v >= 0; --v){
                                                            var y = h[g[v]];
                                                            o.push(f * y[0], -f * y[1], t1);
                                                        }
                                                    }
                                                    for(var c = [
                                                        0,
                                                        0,
                                                        0
                                                    ], u = [
                                                        0,
                                                        0,
                                                        0
                                                    ], f = [
                                                        0,
                                                        0,
                                                        0
                                                    ], h = [
                                                        0,
                                                        0,
                                                        0
                                                    ], p = {
                                                        breaklines: !0,
                                                        bolds: !0,
                                                        italics: !0,
                                                        subscripts: !0,
                                                        superscripts: !0
                                                    }, d = 0; d < 3; ++d){
                                                        f[d] = o.length / 3 | 0, s(.5 * (t1[0][d] + t1[1][d]), e1[d], r[d], 12, 1.25, p), h[d] = (o.length / 3 | 0) - f[d], c[d] = o.length / 3 | 0;
                                                        for(var m = 0; m < n[d].length; ++m)n[d][m].text && s(n[d][m].x, n[d][m].text, n[d][m].font || i, n[d][m].fontSize || 12, 1.25, p);
                                                        u[d] = (o.length / 3 | 0) - c[d];
                                                    }
                                                    this.buffer.update(o), this.tickOffset = c, this.tickCount = u, this.labelOffset = f, this.labelCount = h;
                                                }, u.drawTicks = function(t1, e1, r, n, i, a, o, s) {
                                                    this.tickCount[t1] && (this.shader.uniforms.axis = a, this.shader.uniforms.color = i, this.shader.uniforms.angle = r, this.shader.uniforms.scale = e1, this.shader.uniforms.offset = n, this.shader.uniforms.alignDir = o, this.shader.uniforms.alignOpt = s, this.vao.draw(this.gl.TRIANGLES, this.tickCount[t1], this.tickOffset[t1]));
                                                }, u.drawLabel = function(t1, e1, r, n, i, a, o, s) {
                                                    this.labelCount[t1] && (this.shader.uniforms.axis = a, this.shader.uniforms.color = i, this.shader.uniforms.angle = r, this.shader.uniforms.scale = e1, this.shader.uniforms.offset = n, this.shader.uniforms.alignDir = o, this.shader.uniforms.alignOpt = s, this.vao.draw(this.gl.TRIANGLES, this.labelCount[t1], this.labelOffset[t1]));
                                                }, u.dispose = function() {
                                                    this.shader.dispose(), this.vao.dispose(), this.buffer.dispose();
                                                };
                                            }).call(this);
                                        }).call(this, t1("_process"));
                                    },
                                    {
                                        "./shaders": 74,
                                        _process: 5,
                                        "gl-buffer": 78,
                                        "gl-vao": 150,
                                        "vectorize-text": 311
                                    }
                                ],
                                76: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        function n(t1, e1) {
                                            var r = t1 + "", n = r.indexOf("."), i = 0;
                                            n >= 0 && (i = r.length - n - 1);
                                            var a = Math.pow(10, i), o = Math.round(t1 * e1 * a), s = o + "";
                                            if (s.indexOf("e") >= 0) return s;
                                            var l = o / a, c = o % a;
                                            o < 0 ? (l = 0 | -Math.ceil(l), c = 0 | -c) : (l = 0 | Math.floor(l), c |= 0);
                                            var u = "" + l;
                                            if (o < 0 && (u = "-" + u), i) {
                                                for(var f = "" + c; f.length < i;)f = "0" + f;
                                                return u + "." + f;
                                            }
                                            return u;
                                        }
                                        r.create = function(t1, e1) {
                                            for(var r = [], i = 0; i < 3; ++i){
                                                for(var a = [], o = (t1[0][i], t1[1][i], 0); o * e1[i] <= t1[1][i]; ++o)a.push({
                                                    x: o * e1[i],
                                                    text: n(e1[i], o)
                                                });
                                                for(o = -1; o * e1[i] >= t1[0][i]; --o)a.push({
                                                    x: o * e1[i],
                                                    text: n(e1[i], o)
                                                });
                                                r.push(a);
                                            }
                                            return r;
                                        }, r.equal = function(t1, e1) {
                                            for(var r = 0; r < 3; ++r){
                                                if (t1[r].length !== e1[r].length) return !1;
                                                for(var n = 0; n < t1[r].length; ++n){
                                                    var i = t1[r][n], a = e1[r][n];
                                                    if (i.x !== a.x || i.text !== a.text || i.font !== a.font || i.fontColor !== a.fontColor || i.fontSize !== a.fontSize || i.dx !== a.dx || i.dy !== a.dy) return !1;
                                                }
                                            }
                                            return !0;
                                        };
                                    },
                                    {}
                                ],
                                77: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r, l, f) {
                                            var h = e1.model || c, p = e1.view || c, v = e1.projection || c, y = e1._ortho || !1, x = t1.bounds, b = (f = f || a(h, p, v, x, y)).axis;
                                            o(u, p, h), o(u, v, u);
                                            for(var _ = m, w = 0; w < 3; ++w)_[w].lo = 1 / 0, _[w].hi = -1 / 0, _[w].pixelsPerDataUnit = 1 / 0;
                                            var T = n(s(u, u));
                                            s(u, u);
                                            for(var k = 0; k < 3; ++k){
                                                var A = (k + 1) % 3, M = (k + 2) % 3, S = g;
                                                t: for(w = 0; w < 2; ++w){
                                                    var E = [];
                                                    if (b[k] < 0 != !!w) {
                                                        S[k] = x[w][k];
                                                        for(var L = 0; L < 2; ++L){
                                                            S[A] = x[L ^ w][A];
                                                            for(var C = 0; C < 2; ++C)S[M] = x[C ^ L ^ w][M], E.push(S.slice());
                                                        }
                                                        var P = y ? 5 : 4;
                                                        for(L = P; L === P; ++L){
                                                            if (0 === E.length) continue t;
                                                            E = i.positive(E, T[L]);
                                                        }
                                                        for(L = 0; L < E.length; ++L){
                                                            M = E[L];
                                                            var I = d(g, u, M, r, l);
                                                            for(C = 0; C < 3; ++C)_[C].lo = Math.min(_[C].lo, M[C]), _[C].hi = Math.max(_[C].hi, M[C]), C !== k && (_[C].pixelsPerDataUnit = Math.min(_[C].pixelsPerDataUnit, Math.abs(I[C])));
                                                        }
                                                    }
                                                }
                                            }
                                            return _;
                                        };
                                        var n = t1("extract-frustum-planes"), i = t1("split-polygon"), a = t1("./lib/cube.js"), o = t1("gl-mat4/multiply"), s = t1("gl-mat4/transpose"), l = t1("gl-vec4/transformMat4"), c = new Float32Array([
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ]), u = new Float32Array(16);
                                        function f(t1, e1, r) {
                                            this.lo = t1, this.hi = e1, this.pixelsPerDataUnit = r;
                                        }
                                        var h = [
                                            0,
                                            0,
                                            0,
                                            1
                                        ], p = [
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                        function d(t1, e1, r, n, i) {
                                            for(var a = 0; a < 3; ++a){
                                                for(var o = h, s = p, c = 0; c < 3; ++c)s[c] = o[c] = r[c];
                                                s[3] = o[3] = 1, s[a] += 1, l(s, s, e1), s[3] < 0 && (t1[a] = 1 / 0), o[a] -= 1, l(o, o, e1), o[3] < 0 && (t1[a] = 1 / 0);
                                                var u = (o[0] / o[3] - s[0] / s[3]) * n, f = (o[1] / o[3] - s[1] / s[3]) * i;
                                                t1[a] = .25 * Math.sqrt(u * u + f * f);
                                            }
                                            return t1;
                                        }
                                        var m = [
                                            new f(1 / 0, -1 / 0, 1 / 0),
                                            new f(1 / 0, -1 / 0, 1 / 0),
                                            new f(1 / 0, -1 / 0, 1 / 0)
                                        ], g = [
                                            0,
                                            0,
                                            0
                                        ];
                                    },
                                    {
                                        "./lib/cube.js": 72,
                                        "extract-frustum-planes": 67,
                                        "gl-mat4/multiply": 100,
                                        "gl-mat4/transpose": 109,
                                        "gl-vec4/transformMat4": 221,
                                        "split-polygon": 300
                                    }
                                ],
                                78: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("typedarray-pool"), i = t1("ndarray-ops"), a = t1("ndarray"), o = [
                                            "uint8",
                                            "uint8_clamped",
                                            "uint16",
                                            "uint32",
                                            "int8",
                                            "int16",
                                            "int32",
                                            "float32"
                                        ];
                                        function s(t1, e1, r, n, i) {
                                            this.gl = t1, this.type = e1, this.handle = r, this.length = n, this.usage = i;
                                        }
                                        var l = s.prototype;
                                        function c(t1, e1, r, n, i, a) {
                                            var o = i.length * i.BYTES_PER_ELEMENT;
                                            if (a < 0) return t1.bufferData(e1, i, n), o;
                                            if (o + a > r) throw new Error("gl-buffer: If resizing buffer, must not specify offset");
                                            return t1.bufferSubData(e1, a, i), r;
                                        }
                                        function u(t1, e1) {
                                            for(var r = n.malloc(t1.length, e1), i = t1.length, a = 0; a < i; ++a)r[a] = t1[a];
                                            return r;
                                        }
                                        l.bind = function() {
                                            this.gl.bindBuffer(this.type, this.handle);
                                        }, l.unbind = function() {
                                            this.gl.bindBuffer(this.type, null);
                                        }, l.dispose = function() {
                                            this.gl.deleteBuffer(this.handle);
                                        }, l.update = function(t1, e1) {
                                            if ("number" != typeof e1 && (e1 = -1), this.bind(), "object" == typeof t1 && void 0 !== t1.shape) {
                                                var r = t1.dtype;
                                                if (o.indexOf(r) < 0 && (r = "float32"), this.type === this.gl.ELEMENT_ARRAY_BUFFER) r = gl.getExtension("OES_element_index_uint") && "uint16" !== r ? "uint32" : "uint16";
                                                if (r === t1.dtype && function(t1, e1) {
                                                    for(var r = 1, n = e1.length - 1; n >= 0; --n){
                                                        if (e1[n] !== r) return !1;
                                                        r *= t1[n];
                                                    }
                                                    return !0;
                                                }(t1.shape, t1.stride)) 0 === t1.offset && t1.data.length === t1.shape[0] ? this.length = c(this.gl, this.type, this.length, this.usage, t1.data, e1) : this.length = c(this.gl, this.type, this.length, this.usage, t1.data.subarray(t1.offset, t1.shape[0]), e1);
                                                else {
                                                    var s = n.malloc(t1.size, r), l = a(s, t1.shape);
                                                    i.assign(l, t1), this.length = c(this.gl, this.type, this.length, this.usage, e1 < 0 ? s : s.subarray(0, t1.size), e1), n.free(s);
                                                }
                                            } else if (Array.isArray(t1)) {
                                                var f;
                                                f = this.type === this.gl.ELEMENT_ARRAY_BUFFER ? u(t1, "uint16") : u(t1, "float32"), this.length = c(this.gl, this.type, this.length, this.usage, e1 < 0 ? f : f.subarray(0, t1.length), e1), n.free(f);
                                            } else if ("object" == typeof t1 && "number" == typeof t1.length) this.length = c(this.gl, this.type, this.length, this.usage, t1, e1);
                                            else {
                                                if ("number" != typeof t1 && void 0 !== t1) throw new Error("gl-buffer: Invalid data type");
                                                if (e1 >= 0) throw new Error("gl-buffer: Cannot specify offset when resizing buffer");
                                                (t1 |= 0) <= 0 && (t1 = 1), this.gl.bufferData(this.type, 0 | t1, this.usage), this.length = t1;
                                            }
                                        }, e1.exports = function(t1, e1, r, n) {
                                            if (r = r || t1.ARRAY_BUFFER, n = n || t1.DYNAMIC_DRAW, r !== t1.ARRAY_BUFFER && r !== t1.ELEMENT_ARRAY_BUFFER) throw new Error("gl-buffer: Invalid type for webgl buffer, must be either gl.ARRAY_BUFFER or gl.ELEMENT_ARRAY_BUFFER");
                                            if (n !== t1.DYNAMIC_DRAW && n !== t1.STATIC_DRAW && n !== t1.STREAM_DRAW) throw new Error("gl-buffer: Invalid usage for buffer, must be either gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW");
                                            var i = t1.createBuffer(), a = new s(t1, r, i, 0, n);
                                            return a.update(e1), a;
                                        };
                                    },
                                    {
                                        ndarray: 259,
                                        "ndarray-ops": 254,
                                        "typedarray-pool": 308
                                    }
                                ],
                                79: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("gl-vec3");
                                        e1.exports = function(t1, e1) {
                                            var r = t1.positions, i = t1.vectors, a = {
                                                positions: [],
                                                vertexIntensity: [],
                                                vertexIntensityBounds: t1.vertexIntensityBounds,
                                                vectors: [],
                                                cells: [],
                                                coneOffset: t1.coneOffset,
                                                colormap: t1.colormap
                                            };
                                            if (0 === t1.positions.length) return e1 && (e1[0] = [
                                                0,
                                                0,
                                                0
                                            ], e1[1] = [
                                                0,
                                                0,
                                                0
                                            ]), a;
                                            for(var o = 0, s = 1 / 0, l = -1 / 0, c = 1 / 0, u = -1 / 0, f = 1 / 0, h = -1 / 0, p = null, d = null, m = [], g = 1 / 0, v = !1, y = 0; y < r.length; y++){
                                                var x = r[y];
                                                s = Math.min(x[0], s), l = Math.max(x[0], l), c = Math.min(x[1], c), u = Math.max(x[1], u), f = Math.min(x[2], f), h = Math.max(x[2], h);
                                                var b = i[y];
                                                if (n.length(b) > o && (o = n.length(b)), y) {
                                                    var _ = 2 * n.distance(p, x) / (n.length(d) + n.length(b));
                                                    _ ? (g = Math.min(g, _), v = !1) : v = !0;
                                                }
                                                v || (p = x, d = b), m.push(b);
                                            }
                                            var w = [
                                                s,
                                                c,
                                                f
                                            ], T = [
                                                l,
                                                u,
                                                h
                                            ];
                                            e1 && (e1[0] = w, e1[1] = T), 0 === o && (o = 1);
                                            var k = 1 / o;
                                            isFinite(g) || (g = 1), a.vectorScale = g;
                                            var A = t1.coneSize || .5;
                                            t1.absoluteConeSize && (A = t1.absoluteConeSize * k), a.coneScale = A;
                                            y = 0;
                                            for(var M = 0; y < r.length; y++)for(var S = (x = r[y])[0], E = x[1], L = x[2], C = m[y], P = n.length(C) * k, I = 0; I < 8; I++){
                                                a.positions.push([
                                                    S,
                                                    E,
                                                    L,
                                                    M++
                                                ]), a.positions.push([
                                                    S,
                                                    E,
                                                    L,
                                                    M++
                                                ]), a.positions.push([
                                                    S,
                                                    E,
                                                    L,
                                                    M++
                                                ]), a.positions.push([
                                                    S,
                                                    E,
                                                    L,
                                                    M++
                                                ]), a.positions.push([
                                                    S,
                                                    E,
                                                    L,
                                                    M++
                                                ]), a.positions.push([
                                                    S,
                                                    E,
                                                    L,
                                                    M++
                                                ]), a.vectors.push(C), a.vectors.push(C), a.vectors.push(C), a.vectors.push(C), a.vectors.push(C), a.vectors.push(C), a.vertexIntensity.push(P, P, P), a.vertexIntensity.push(P, P, P);
                                                var O = a.positions.length;
                                                a.cells.push([
                                                    O - 6,
                                                    O - 5,
                                                    O - 4
                                                ], [
                                                    O - 3,
                                                    O - 2,
                                                    O - 1
                                                ]);
                                            }
                                            return a;
                                        };
                                        var i = t1("./lib/shaders");
                                        e1.exports.createMesh = t1("./create_mesh"), e1.exports.createConeMesh = function(t1, r) {
                                            return e1.exports.createMesh(t1, r, {
                                                shaders: i,
                                                traceType: "cone"
                                            });
                                        };
                                    },
                                    {
                                        "./create_mesh": 80,
                                        "./lib/shaders": 81,
                                        "gl-vec3": 169
                                    }
                                ],
                                80: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("gl-shader"), i = t1("gl-buffer"), a = t1("gl-vao"), o = t1("gl-texture2d"), s = t1("gl-mat4/multiply"), l = t1("gl-mat4/invert"), c = t1("ndarray"), u = t1("colormap"), f = [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                        function h(t1, e1, r, n, i, a, o, s, l, c, u) {
                                            this.gl = t1, this.pixelRatio = 1, this.cells = [], this.positions = [], this.intensity = [], this.texture = e1, this.dirty = !0, this.triShader = r, this.pickShader = n, this.trianglePositions = i, this.triangleVectors = a, this.triangleColors = s, this.triangleUVs = l, this.triangleIds = o, this.triangleVAO = c, this.triangleCount = 0, this.pickId = 1, this.bounds = [
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ],
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ]
                                            ], this.clipBounds = [
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ],
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ]
                                            ], this.lightPosition = [
                                                1e5,
                                                1e5,
                                                0
                                            ], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.opacity = 1, this.traceType = u, this.tubeScale = 1, this.coneScale = 2, this.vectorScale = 1, this.coneOffset = .25, this._model = f, this._view = f, this._projection = f, this._resolution = [
                                                1,
                                                1
                                            ];
                                        }
                                        var p = h.prototype;
                                        function d(t1, e1) {
                                            var r = n(t1, e1.meshShader.vertex, e1.meshShader.fragment, null, e1.meshShader.attributes);
                                            return r.attributes.position.location = 0, r.attributes.color.location = 2, r.attributes.uv.location = 3, r.attributes.vector.location = 4, r;
                                        }
                                        function m(t1, e1) {
                                            var r = n(t1, e1.pickShader.vertex, e1.pickShader.fragment, null, e1.pickShader.attributes);
                                            return r.attributes.position.location = 0, r.attributes.id.location = 1, r.attributes.vector.location = 4, r;
                                        }
                                        p.isOpaque = function() {
                                            return this.opacity >= 1;
                                        }, p.isTransparent = function() {
                                            return this.opacity < 1;
                                        }, p.pickSlots = 1, p.setPickBase = function(t1) {
                                            this.pickId = t1;
                                        }, p.update = function(t1) {
                                            t1 = t1 || {};
                                            var e1 = this.gl;
                                            this.dirty = !0, "lightPosition" in t1 && (this.lightPosition = t1.lightPosition), "opacity" in t1 && (this.opacity = t1.opacity), "ambient" in t1 && (this.ambientLight = t1.ambient), "diffuse" in t1 && (this.diffuseLight = t1.diffuse), "specular" in t1 && (this.specularLight = t1.specular), "roughness" in t1 && (this.roughness = t1.roughness), "fresnel" in t1 && (this.fresnel = t1.fresnel), void 0 !== t1.tubeScale && (this.tubeScale = t1.tubeScale), void 0 !== t1.vectorScale && (this.vectorScale = t1.vectorScale), void 0 !== t1.coneScale && (this.coneScale = t1.coneScale), void 0 !== t1.coneOffset && (this.coneOffset = t1.coneOffset), t1.colormap && (this.texture.shape = [
                                                256,
                                                256
                                            ], this.texture.minFilter = e1.LINEAR_MIPMAP_LINEAR, this.texture.magFilter = e1.LINEAR, this.texture.setPixels(function(t1) {
                                                for(var e1 = u({
                                                    colormap: t1,
                                                    nshades: 256,
                                                    format: "rgba"
                                                }), r = new Uint8Array(1024), n = 0; n < 256; ++n){
                                                    for(var i = e1[n], a = 0; a < 3; ++a)r[4 * n + a] = i[a];
                                                    r[4 * n + 3] = 255 * i[3];
                                                }
                                                return c(r, [
                                                    256,
                                                    256,
                                                    4
                                                ], [
                                                    4,
                                                    0,
                                                    1
                                                ]);
                                            }(t1.colormap)), this.texture.generateMipmap());
                                            var r = t1.cells, n = t1.positions, i = t1.vectors;
                                            if (n && r && i) {
                                                var a = [], o = [], s = [], l = [], f = [];
                                                this.cells = r, this.positions = n, this.vectors = i;
                                                var h = t1.meshColor || [
                                                    1,
                                                    1,
                                                    1,
                                                    1
                                                ], p = t1.vertexIntensity, d = 1 / 0, m = -1 / 0;
                                                if (p) {
                                                    if (t1.vertexIntensityBounds) d = +t1.vertexIntensityBounds[0], m = +t1.vertexIntensityBounds[1];
                                                    else for(var g = 0; g < p.length; ++g){
                                                        var v = p[g];
                                                        d = Math.min(d, v), m = Math.max(m, v);
                                                    }
                                                } else for(g = 0; g < n.length; ++g){
                                                    v = n[g][2];
                                                    d = Math.min(d, v), m = Math.max(m, v);
                                                }
                                                this.intensity = p || function(t1) {
                                                    for(var e1 = t1.length, r = new Array(e1), n = 0; n < e1; ++n)r[n] = t1[n][2];
                                                    return r;
                                                }(n), this.bounds = [
                                                    [
                                                        1 / 0,
                                                        1 / 0,
                                                        1 / 0
                                                    ],
                                                    [
                                                        -1 / 0,
                                                        -1 / 0,
                                                        -1 / 0
                                                    ]
                                                ];
                                                for(g = 0; g < n.length; ++g)for(var y = n[g], x = 0; x < 3; ++x)!isNaN(y[x]) && isFinite(y[x]) && (this.bounds[0][x] = Math.min(this.bounds[0][x], y[x]), this.bounds[1][x] = Math.max(this.bounds[1][x], y[x]));
                                                var b = 0;
                                                t: for(g = 0; g < r.length; ++g){
                                                    var _ = r[g];
                                                    switch(_.length){
                                                        case 3:
                                                            for(x = 0; x < 3; ++x){
                                                                y = n[T = _[x]];
                                                                for(var w = 0; w < 3; ++w)if (isNaN(y[w]) || !isFinite(y[w])) continue t;
                                                            }
                                                            for(x = 0; x < 3; ++x){
                                                                var T;
                                                                y = n[T = _[2 - x]];
                                                                a.push(y[0], y[1], y[2], y[3]);
                                                                var k = i[T];
                                                                o.push(k[0], k[1], k[2], k[3] || 0);
                                                                var A, M = h;
                                                                3 === M.length ? s.push(M[0], M[1], M[2], 1) : s.push(M[0], M[1], M[2], M[3]), A = p ? [
                                                                    (p[T] - d) / (m - d),
                                                                    0
                                                                ] : [
                                                                    (y[2] - d) / (m - d),
                                                                    0
                                                                ], l.push(A[0], A[1]), f.push(g);
                                                            }
                                                            b += 1;
                                                    }
                                                }
                                                this.triangleCount = b, this.trianglePositions.update(a), this.triangleVectors.update(o), this.triangleColors.update(s), this.triangleUVs.update(l), this.triangleIds.update(new Uint32Array(f));
                                            }
                                        }, p.drawTransparent = p.draw = function(t1) {
                                            t1 = t1 || {};
                                            for(var e1 = this.gl, r = t1.model || f, n = t1.view || f, i = t1.projection || f, a = [
                                                [
                                                    -1000000,
                                                    -1000000,
                                                    -1000000
                                                ],
                                                [
                                                    1e6,
                                                    1e6,
                                                    1e6
                                                ]
                                            ], o = 0; o < 3; ++o)a[0][o] = Math.max(a[0][o], this.clipBounds[0][o]), a[1][o] = Math.min(a[1][o], this.clipBounds[1][o]);
                                            var c = {
                                                model: r,
                                                view: n,
                                                projection: i,
                                                inverseModel: f.slice(),
                                                clipBounds: a,
                                                kambient: this.ambientLight,
                                                kdiffuse: this.diffuseLight,
                                                kspecular: this.specularLight,
                                                roughness: this.roughness,
                                                fresnel: this.fresnel,
                                                eyePosition: [
                                                    0,
                                                    0,
                                                    0
                                                ],
                                                lightPosition: [
                                                    0,
                                                    0,
                                                    0
                                                ],
                                                opacity: this.opacity,
                                                tubeScale: this.tubeScale,
                                                vectorScale: this.vectorScale,
                                                coneScale: this.coneScale,
                                                coneOffset: this.coneOffset,
                                                texture: 0
                                            };
                                            c.inverseModel = l(c.inverseModel, c.model), e1.disable(e1.CULL_FACE), this.texture.bind(0);
                                            var u = new Array(16);
                                            s(u, c.view, c.model), s(u, c.projection, u), l(u, u);
                                            for(o = 0; o < 3; ++o)c.eyePosition[o] = u[12 + o] / u[15];
                                            var h = u[15];
                                            for(o = 0; o < 3; ++o)h += this.lightPosition[o] * u[4 * o + 3];
                                            for(o = 0; o < 3; ++o){
                                                for(var p = u[12 + o], d = 0; d < 3; ++d)p += u[4 * d + o] * this.lightPosition[d];
                                                c.lightPosition[o] = p / h;
                                            }
                                            if (this.triangleCount > 0) {
                                                var m = this.triShader;
                                                m.bind(), m.uniforms = c, this.triangleVAO.bind(), e1.drawArrays(e1.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind();
                                            }
                                        }, p.drawPick = function(t1) {
                                            t1 = t1 || {};
                                            for(var e1 = this.gl, r = t1.model || f, n = t1.view || f, i = t1.projection || f, a = [
                                                [
                                                    -1000000,
                                                    -1000000,
                                                    -1000000
                                                ],
                                                [
                                                    1e6,
                                                    1e6,
                                                    1e6
                                                ]
                                            ], o = 0; o < 3; ++o)a[0][o] = Math.max(a[0][o], this.clipBounds[0][o]), a[1][o] = Math.min(a[1][o], this.clipBounds[1][o]);
                                            this._model = [].slice.call(r), this._view = [].slice.call(n), this._projection = [].slice.call(i), this._resolution = [
                                                e1.drawingBufferWidth,
                                                e1.drawingBufferHeight
                                            ];
                                            var s = {
                                                model: r,
                                                view: n,
                                                projection: i,
                                                clipBounds: a,
                                                tubeScale: this.tubeScale,
                                                vectorScale: this.vectorScale,
                                                coneScale: this.coneScale,
                                                coneOffset: this.coneOffset,
                                                pickId: this.pickId / 255
                                            }, l = this.pickShader;
                                            l.bind(), l.uniforms = s, this.triangleCount > 0 && (this.triangleVAO.bind(), e1.drawArrays(e1.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind());
                                        }, p.pick = function(t1) {
                                            if (!t1) return null;
                                            if (t1.id !== this.pickId) return null;
                                            var e1 = t1.value[0] + 256 * t1.value[1] + 65536 * t1.value[2], r = this.cells[e1], n = this.positions[r[1]].slice(0, 3), i = {
                                                position: n,
                                                dataCoordinate: n,
                                                index: Math.floor(r[1] / 48)
                                            };
                                            return "cone" === this.traceType ? i.index = Math.floor(r[1] / 48) : "streamtube" === this.traceType && (i.intensity = this.intensity[r[1]], i.velocity = this.vectors[r[1]].slice(0, 3), i.divergence = this.vectors[r[1]][3], i.index = e1), i;
                                        }, p.dispose = function() {
                                            this.texture.dispose(), this.triShader.dispose(), this.pickShader.dispose(), this.triangleVAO.dispose(), this.trianglePositions.dispose(), this.triangleVectors.dispose(), this.triangleColors.dispose(), this.triangleUVs.dispose(), this.triangleIds.dispose();
                                        }, e1.exports = function(t1, e1, r) {
                                            var n = r.shaders;
                                            1 === arguments.length && (t1 = (e1 = t1).gl);
                                            var s = d(t1, n), l = m(t1, n), u = o(t1, c(new Uint8Array([
                                                255,
                                                255,
                                                255,
                                                255
                                            ]), [
                                                1,
                                                1,
                                                4
                                            ]));
                                            u.generateMipmap(), u.minFilter = t1.LINEAR_MIPMAP_LINEAR, u.magFilter = t1.LINEAR;
                                            var f = i(t1), p = i(t1), g = i(t1), v = i(t1), y = i(t1), x = a(t1, [
                                                {
                                                    buffer: f,
                                                    type: t1.FLOAT,
                                                    size: 4
                                                },
                                                {
                                                    buffer: y,
                                                    type: t1.UNSIGNED_BYTE,
                                                    size: 4,
                                                    normalized: !0
                                                },
                                                {
                                                    buffer: g,
                                                    type: t1.FLOAT,
                                                    size: 4
                                                },
                                                {
                                                    buffer: v,
                                                    type: t1.FLOAT,
                                                    size: 2
                                                },
                                                {
                                                    buffer: p,
                                                    type: t1.FLOAT,
                                                    size: 4
                                                }
                                            ]), b = new h(t1, u, s, l, f, p, y, g, v, x, r.traceType || "cone");
                                            return b.update(e1), b;
                                        };
                                    },
                                    {
                                        colormap: 53,
                                        "gl-buffer": 78,
                                        "gl-mat4/invert": 98,
                                        "gl-mat4/multiply": 100,
                                        "gl-shader": 132,
                                        "gl-texture2d": 146,
                                        "gl-vao": 150,
                                        ndarray: 259
                                    }
                                ],
                                81: [
                                    function(t1, e1, r) {
                                        var n = t1("glslify"), i = n([
                                            "precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec3 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, coneScale, coneOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * conePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(conePosition, 1.0);\n  vec4 t_position  = view * conePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = conePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"
                                        ]), a = n([
                                            "#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"
                                        ]), o = n([
                                            "precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float vectorScale, coneScale, coneOffset;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector.xyz), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n  gl_Position = projection * view * conePosition;\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"
                                        ]), s = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"
                                        ]);
                                        r.meshShader = {
                                            vertex: i,
                                            fragment: a,
                                            attributes: [
                                                {
                                                    name: "position",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "color",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "uv",
                                                    type: "vec2"
                                                },
                                                {
                                                    name: "vector",
                                                    type: "vec3"
                                                }
                                            ]
                                        }, r.pickShader = {
                                            vertex: o,
                                            fragment: s,
                                            attributes: [
                                                {
                                                    name: "position",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "id",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "vector",
                                                    type: "vec3"
                                                }
                                            ]
                                        };
                                    },
                                    {
                                        glslify: 231
                                    }
                                ],
                                82: [
                                    function(t1, e1, r) {
                                        e1.exports = {
                                            0: "NONE",
                                            1: "ONE",
                                            2: "LINE_LOOP",
                                            3: "LINE_STRIP",
                                            4: "TRIANGLES",
                                            5: "TRIANGLE_STRIP",
                                            6: "TRIANGLE_FAN",
                                            256: "DEPTH_BUFFER_BIT",
                                            512: "NEVER",
                                            513: "LESS",
                                            514: "EQUAL",
                                            515: "LEQUAL",
                                            516: "GREATER",
                                            517: "NOTEQUAL",
                                            518: "GEQUAL",
                                            519: "ALWAYS",
                                            768: "SRC_COLOR",
                                            769: "ONE_MINUS_SRC_COLOR",
                                            770: "SRC_ALPHA",
                                            771: "ONE_MINUS_SRC_ALPHA",
                                            772: "DST_ALPHA",
                                            773: "ONE_MINUS_DST_ALPHA",
                                            774: "DST_COLOR",
                                            775: "ONE_MINUS_DST_COLOR",
                                            776: "SRC_ALPHA_SATURATE",
                                            1024: "STENCIL_BUFFER_BIT",
                                            1028: "FRONT",
                                            1029: "BACK",
                                            1032: "FRONT_AND_BACK",
                                            1280: "INVALID_ENUM",
                                            1281: "INVALID_VALUE",
                                            1282: "INVALID_OPERATION",
                                            1285: "OUT_OF_MEMORY",
                                            1286: "INVALID_FRAMEBUFFER_OPERATION",
                                            2304: "CW",
                                            2305: "CCW",
                                            2849: "LINE_WIDTH",
                                            2884: "CULL_FACE",
                                            2885: "CULL_FACE_MODE",
                                            2886: "FRONT_FACE",
                                            2928: "DEPTH_RANGE",
                                            2929: "DEPTH_TEST",
                                            2930: "DEPTH_WRITEMASK",
                                            2931: "DEPTH_CLEAR_VALUE",
                                            2932: "DEPTH_FUNC",
                                            2960: "STENCIL_TEST",
                                            2961: "STENCIL_CLEAR_VALUE",
                                            2962: "STENCIL_FUNC",
                                            2963: "STENCIL_VALUE_MASK",
                                            2964: "STENCIL_FAIL",
                                            2965: "STENCIL_PASS_DEPTH_FAIL",
                                            2966: "STENCIL_PASS_DEPTH_PASS",
                                            2967: "STENCIL_REF",
                                            2968: "STENCIL_WRITEMASK",
                                            2978: "VIEWPORT",
                                            3024: "DITHER",
                                            3042: "BLEND",
                                            3088: "SCISSOR_BOX",
                                            3089: "SCISSOR_TEST",
                                            3106: "COLOR_CLEAR_VALUE",
                                            3107: "COLOR_WRITEMASK",
                                            3317: "UNPACK_ALIGNMENT",
                                            3333: "PACK_ALIGNMENT",
                                            3379: "MAX_TEXTURE_SIZE",
                                            3386: "MAX_VIEWPORT_DIMS",
                                            3408: "SUBPIXEL_BITS",
                                            3410: "RED_BITS",
                                            3411: "GREEN_BITS",
                                            3412: "BLUE_BITS",
                                            3413: "ALPHA_BITS",
                                            3414: "DEPTH_BITS",
                                            3415: "STENCIL_BITS",
                                            3553: "TEXTURE_2D",
                                            4352: "DONT_CARE",
                                            4353: "FASTEST",
                                            4354: "NICEST",
                                            5120: "BYTE",
                                            5121: "UNSIGNED_BYTE",
                                            5122: "SHORT",
                                            5123: "UNSIGNED_SHORT",
                                            5124: "INT",
                                            5125: "UNSIGNED_INT",
                                            5126: "FLOAT",
                                            5386: "INVERT",
                                            5890: "TEXTURE",
                                            6401: "STENCIL_INDEX",
                                            6402: "DEPTH_COMPONENT",
                                            6406: "ALPHA",
                                            6407: "RGB",
                                            6408: "RGBA",
                                            6409: "LUMINANCE",
                                            6410: "LUMINANCE_ALPHA",
                                            7680: "KEEP",
                                            7681: "REPLACE",
                                            7682: "INCR",
                                            7683: "DECR",
                                            7936: "VENDOR",
                                            7937: "RENDERER",
                                            7938: "VERSION",
                                            9728: "NEAREST",
                                            9729: "LINEAR",
                                            9984: "NEAREST_MIPMAP_NEAREST",
                                            9985: "LINEAR_MIPMAP_NEAREST",
                                            9986: "NEAREST_MIPMAP_LINEAR",
                                            9987: "LINEAR_MIPMAP_LINEAR",
                                            10240: "TEXTURE_MAG_FILTER",
                                            10241: "TEXTURE_MIN_FILTER",
                                            10242: "TEXTURE_WRAP_S",
                                            10243: "TEXTURE_WRAP_T",
                                            10497: "REPEAT",
                                            10752: "POLYGON_OFFSET_UNITS",
                                            16384: "COLOR_BUFFER_BIT",
                                            32769: "CONSTANT_COLOR",
                                            32770: "ONE_MINUS_CONSTANT_COLOR",
                                            32771: "CONSTANT_ALPHA",
                                            32772: "ONE_MINUS_CONSTANT_ALPHA",
                                            32773: "BLEND_COLOR",
                                            32774: "FUNC_ADD",
                                            32777: "BLEND_EQUATION_RGB",
                                            32778: "FUNC_SUBTRACT",
                                            32779: "FUNC_REVERSE_SUBTRACT",
                                            32819: "UNSIGNED_SHORT_4_4_4_4",
                                            32820: "UNSIGNED_SHORT_5_5_5_1",
                                            32823: "POLYGON_OFFSET_FILL",
                                            32824: "POLYGON_OFFSET_FACTOR",
                                            32854: "RGBA4",
                                            32855: "RGB5_A1",
                                            32873: "TEXTURE_BINDING_2D",
                                            32926: "SAMPLE_ALPHA_TO_COVERAGE",
                                            32928: "SAMPLE_COVERAGE",
                                            32936: "SAMPLE_BUFFERS",
                                            32937: "SAMPLES",
                                            32938: "SAMPLE_COVERAGE_VALUE",
                                            32939: "SAMPLE_COVERAGE_INVERT",
                                            32968: "BLEND_DST_RGB",
                                            32969: "BLEND_SRC_RGB",
                                            32970: "BLEND_DST_ALPHA",
                                            32971: "BLEND_SRC_ALPHA",
                                            33071: "CLAMP_TO_EDGE",
                                            33170: "GENERATE_MIPMAP_HINT",
                                            33189: "DEPTH_COMPONENT16",
                                            33306: "DEPTH_STENCIL_ATTACHMENT",
                                            33635: "UNSIGNED_SHORT_5_6_5",
                                            33648: "MIRRORED_REPEAT",
                                            33901: "ALIASED_POINT_SIZE_RANGE",
                                            33902: "ALIASED_LINE_WIDTH_RANGE",
                                            33984: "TEXTURE0",
                                            33985: "TEXTURE1",
                                            33986: "TEXTURE2",
                                            33987: "TEXTURE3",
                                            33988: "TEXTURE4",
                                            33989: "TEXTURE5",
                                            33990: "TEXTURE6",
                                            33991: "TEXTURE7",
                                            33992: "TEXTURE8",
                                            33993: "TEXTURE9",
                                            33994: "TEXTURE10",
                                            33995: "TEXTURE11",
                                            33996: "TEXTURE12",
                                            33997: "TEXTURE13",
                                            33998: "TEXTURE14",
                                            33999: "TEXTURE15",
                                            34e3: "TEXTURE16",
                                            34001: "TEXTURE17",
                                            34002: "TEXTURE18",
                                            34003: "TEXTURE19",
                                            34004: "TEXTURE20",
                                            34005: "TEXTURE21",
                                            34006: "TEXTURE22",
                                            34007: "TEXTURE23",
                                            34008: "TEXTURE24",
                                            34009: "TEXTURE25",
                                            34010: "TEXTURE26",
                                            34011: "TEXTURE27",
                                            34012: "TEXTURE28",
                                            34013: "TEXTURE29",
                                            34014: "TEXTURE30",
                                            34015: "TEXTURE31",
                                            34016: "ACTIVE_TEXTURE",
                                            34024: "MAX_RENDERBUFFER_SIZE",
                                            34041: "DEPTH_STENCIL",
                                            34055: "INCR_WRAP",
                                            34056: "DECR_WRAP",
                                            34067: "TEXTURE_CUBE_MAP",
                                            34068: "TEXTURE_BINDING_CUBE_MAP",
                                            34069: "TEXTURE_CUBE_MAP_POSITIVE_X",
                                            34070: "TEXTURE_CUBE_MAP_NEGATIVE_X",
                                            34071: "TEXTURE_CUBE_MAP_POSITIVE_Y",
                                            34072: "TEXTURE_CUBE_MAP_NEGATIVE_Y",
                                            34073: "TEXTURE_CUBE_MAP_POSITIVE_Z",
                                            34074: "TEXTURE_CUBE_MAP_NEGATIVE_Z",
                                            34076: "MAX_CUBE_MAP_TEXTURE_SIZE",
                                            34338: "VERTEX_ATTRIB_ARRAY_ENABLED",
                                            34339: "VERTEX_ATTRIB_ARRAY_SIZE",
                                            34340: "VERTEX_ATTRIB_ARRAY_STRIDE",
                                            34341: "VERTEX_ATTRIB_ARRAY_TYPE",
                                            34342: "CURRENT_VERTEX_ATTRIB",
                                            34373: "VERTEX_ATTRIB_ARRAY_POINTER",
                                            34466: "NUM_COMPRESSED_TEXTURE_FORMATS",
                                            34467: "COMPRESSED_TEXTURE_FORMATS",
                                            34660: "BUFFER_SIZE",
                                            34661: "BUFFER_USAGE",
                                            34816: "STENCIL_BACK_FUNC",
                                            34817: "STENCIL_BACK_FAIL",
                                            34818: "STENCIL_BACK_PASS_DEPTH_FAIL",
                                            34819: "STENCIL_BACK_PASS_DEPTH_PASS",
                                            34877: "BLEND_EQUATION_ALPHA",
                                            34921: "MAX_VERTEX_ATTRIBS",
                                            34922: "VERTEX_ATTRIB_ARRAY_NORMALIZED",
                                            34930: "MAX_TEXTURE_IMAGE_UNITS",
                                            34962: "ARRAY_BUFFER",
                                            34963: "ELEMENT_ARRAY_BUFFER",
                                            34964: "ARRAY_BUFFER_BINDING",
                                            34965: "ELEMENT_ARRAY_BUFFER_BINDING",
                                            34975: "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING",
                                            35040: "STREAM_DRAW",
                                            35044: "STATIC_DRAW",
                                            35048: "DYNAMIC_DRAW",
                                            35632: "FRAGMENT_SHADER",
                                            35633: "VERTEX_SHADER",
                                            35660: "MAX_VERTEX_TEXTURE_IMAGE_UNITS",
                                            35661: "MAX_COMBINED_TEXTURE_IMAGE_UNITS",
                                            35663: "SHADER_TYPE",
                                            35664: "FLOAT_VEC2",
                                            35665: "FLOAT_VEC3",
                                            35666: "FLOAT_VEC4",
                                            35667: "INT_VEC2",
                                            35668: "INT_VEC3",
                                            35669: "INT_VEC4",
                                            35670: "BOOL",
                                            35671: "BOOL_VEC2",
                                            35672: "BOOL_VEC3",
                                            35673: "BOOL_VEC4",
                                            35674: "FLOAT_MAT2",
                                            35675: "FLOAT_MAT3",
                                            35676: "FLOAT_MAT4",
                                            35678: "SAMPLER_2D",
                                            35680: "SAMPLER_CUBE",
                                            35712: "DELETE_STATUS",
                                            35713: "COMPILE_STATUS",
                                            35714: "LINK_STATUS",
                                            35715: "VALIDATE_STATUS",
                                            35716: "INFO_LOG_LENGTH",
                                            35717: "ATTACHED_SHADERS",
                                            35718: "ACTIVE_UNIFORMS",
                                            35719: "ACTIVE_UNIFORM_MAX_LENGTH",
                                            35720: "SHADER_SOURCE_LENGTH",
                                            35721: "ACTIVE_ATTRIBUTES",
                                            35722: "ACTIVE_ATTRIBUTE_MAX_LENGTH",
                                            35724: "SHADING_LANGUAGE_VERSION",
                                            35725: "CURRENT_PROGRAM",
                                            36003: "STENCIL_BACK_REF",
                                            36004: "STENCIL_BACK_VALUE_MASK",
                                            36005: "STENCIL_BACK_WRITEMASK",
                                            36006: "FRAMEBUFFER_BINDING",
                                            36007: "RENDERBUFFER_BINDING",
                                            36048: "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE",
                                            36049: "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME",
                                            36050: "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL",
                                            36051: "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE",
                                            36053: "FRAMEBUFFER_COMPLETE",
                                            36054: "FRAMEBUFFER_INCOMPLETE_ATTACHMENT",
                                            36055: "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT",
                                            36057: "FRAMEBUFFER_INCOMPLETE_DIMENSIONS",
                                            36061: "FRAMEBUFFER_UNSUPPORTED",
                                            36064: "COLOR_ATTACHMENT0",
                                            36096: "DEPTH_ATTACHMENT",
                                            36128: "STENCIL_ATTACHMENT",
                                            36160: "FRAMEBUFFER",
                                            36161: "RENDERBUFFER",
                                            36162: "RENDERBUFFER_WIDTH",
                                            36163: "RENDERBUFFER_HEIGHT",
                                            36164: "RENDERBUFFER_INTERNAL_FORMAT",
                                            36168: "STENCIL_INDEX8",
                                            36176: "RENDERBUFFER_RED_SIZE",
                                            36177: "RENDERBUFFER_GREEN_SIZE",
                                            36178: "RENDERBUFFER_BLUE_SIZE",
                                            36179: "RENDERBUFFER_ALPHA_SIZE",
                                            36180: "RENDERBUFFER_DEPTH_SIZE",
                                            36181: "RENDERBUFFER_STENCIL_SIZE",
                                            36194: "RGB565",
                                            36336: "LOW_FLOAT",
                                            36337: "MEDIUM_FLOAT",
                                            36338: "HIGH_FLOAT",
                                            36339: "LOW_INT",
                                            36340: "MEDIUM_INT",
                                            36341: "HIGH_INT",
                                            36346: "SHADER_COMPILER",
                                            36347: "MAX_VERTEX_UNIFORM_VECTORS",
                                            36348: "MAX_VARYING_VECTORS",
                                            36349: "MAX_FRAGMENT_UNIFORM_VECTORS",
                                            37440: "UNPACK_FLIP_Y_WEBGL",
                                            37441: "UNPACK_PREMULTIPLY_ALPHA_WEBGL",
                                            37442: "CONTEXT_LOST_WEBGL",
                                            37443: "UNPACK_COLORSPACE_CONVERSION_WEBGL",
                                            37444: "BROWSER_DEFAULT_WEBGL"
                                        };
                                    },
                                    {}
                                ],
                                83: [
                                    function(t1, e1, r) {
                                        var n = t1("./1.0/numbers");
                                        e1.exports = function(t1) {
                                            return n[t1];
                                        };
                                    },
                                    {
                                        "./1.0/numbers": 82
                                    }
                                ],
                                84: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = t1.gl, r = n(e1), o = i(e1, [
                                                {
                                                    buffer: r,
                                                    type: e1.FLOAT,
                                                    size: 3,
                                                    offset: 0,
                                                    stride: 40
                                                },
                                                {
                                                    buffer: r,
                                                    type: e1.FLOAT,
                                                    size: 4,
                                                    offset: 12,
                                                    stride: 40
                                                },
                                                {
                                                    buffer: r,
                                                    type: e1.FLOAT,
                                                    size: 3,
                                                    offset: 28,
                                                    stride: 40
                                                }
                                            ]), l = a(e1);
                                            l.attributes.position.location = 0, l.attributes.color.location = 1, l.attributes.offset.location = 2;
                                            var c = new s(e1, r, o, l);
                                            return c.update(t1), c;
                                        };
                                        var n = t1("gl-buffer"), i = t1("gl-vao"), a = t1("./shaders/index"), o = [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                        function s(t1, e1, r, n) {
                                            this.gl = t1, this.shader = n, this.buffer = e1, this.vao = r, this.pixelRatio = 1, this.bounds = [
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ],
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ]
                                            ], this.clipBounds = [
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ],
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ]
                                            ], this.lineWidth = [
                                                1,
                                                1,
                                                1
                                            ], this.capSize = [
                                                10,
                                                10,
                                                10
                                            ], this.lineCount = [
                                                0,
                                                0,
                                                0
                                            ], this.lineOffset = [
                                                0,
                                                0,
                                                0
                                            ], this.opacity = 1, this.hasAlpha = !1;
                                        }
                                        var l = s.prototype;
                                        function c(t1, e1) {
                                            for(var r = 0; r < 3; ++r)t1[0][r] = Math.min(t1[0][r], e1[r]), t1[1][r] = Math.max(t1[1][r], e1[r]);
                                        }
                                        l.isOpaque = function() {
                                            return !this.hasAlpha;
                                        }, l.isTransparent = function() {
                                            return this.hasAlpha;
                                        }, l.drawTransparent = l.draw = function(t1) {
                                            var e1 = this.gl, r = this.shader.uniforms;
                                            this.shader.bind();
                                            var n = r.view = t1.view || o, i = r.projection = t1.projection || o;
                                            r.model = t1.model || o, r.clipBounds = this.clipBounds, r.opacity = this.opacity;
                                            var a = n[12], s = n[13], l = n[14], c = n[15], u = (t1._ortho || !1 ? 2 : 1) * this.pixelRatio * (i[3] * a + i[7] * s + i[11] * l + i[15] * c) / e1.drawingBufferHeight;
                                            this.vao.bind();
                                            for(var f = 0; f < 3; ++f)e1.lineWidth(this.lineWidth[f] * this.pixelRatio), r.capSize = this.capSize[f] * u, this.lineCount[f] && e1.drawArrays(e1.LINES, this.lineOffset[f], this.lineCount[f]);
                                            this.vao.unbind();
                                        };
                                        var u = function() {
                                            for(var t1 = new Array(3), e1 = 0; e1 < 3; ++e1){
                                                for(var r = [], n = 1; n <= 2; ++n)for(var i = -1; i <= 1; i += 2){
                                                    var a = [
                                                        0,
                                                        0,
                                                        0
                                                    ];
                                                    a[(n + e1) % 3] = i, r.push(a);
                                                }
                                                t1[e1] = r;
                                            }
                                            return t1;
                                        }();
                                        function f(t1, e1, r, n) {
                                            for(var i = u[n], a = 0; a < i.length; ++a){
                                                var o = i[a];
                                                t1.push(e1[0], e1[1], e1[2], r[0], r[1], r[2], r[3], o[0], o[1], o[2]);
                                            }
                                            return i.length;
                                        }
                                        l.update = function(t1) {
                                            "lineWidth" in (t1 = t1 || {}) && (this.lineWidth = t1.lineWidth, Array.isArray(this.lineWidth) || (this.lineWidth = [
                                                this.lineWidth,
                                                this.lineWidth,
                                                this.lineWidth
                                            ])), "capSize" in t1 && (this.capSize = t1.capSize, Array.isArray(this.capSize) || (this.capSize = [
                                                this.capSize,
                                                this.capSize,
                                                this.capSize
                                            ])), this.hasAlpha = !1, "opacity" in t1 && (this.opacity = +t1.opacity, this.opacity < 1 && (this.hasAlpha = !0));
                                            var e1 = t1.color || [
                                                [
                                                    0,
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0
                                                ]
                                            ], r = t1.position, n = t1.error;
                                            if (Array.isArray(e1[0]) || (e1 = [
                                                e1,
                                                e1,
                                                e1
                                            ]), r && n) {
                                                var i = [], a = r.length, o = 0;
                                                this.bounds = [
                                                    [
                                                        1 / 0,
                                                        1 / 0,
                                                        1 / 0
                                                    ],
                                                    [
                                                        -1 / 0,
                                                        -1 / 0,
                                                        -1 / 0
                                                    ]
                                                ], this.lineCount = [
                                                    0,
                                                    0,
                                                    0
                                                ];
                                                for(var s = 0; s < 3; ++s){
                                                    this.lineOffset[s] = o;
                                                    t: for(var l = 0; l < a; ++l){
                                                        for(var u = r[l], h = 0; h < 3; ++h)if (isNaN(u[h]) || !isFinite(u[h])) continue t;
                                                        var p = n[l], d = e1[s];
                                                        if (Array.isArray(d[0]) && (d = e1[l]), 3 === d.length ? d = [
                                                            d[0],
                                                            d[1],
                                                            d[2],
                                                            1
                                                        ] : 4 === d.length && (d = [
                                                            d[0],
                                                            d[1],
                                                            d[2],
                                                            d[3]
                                                        ], !this.hasAlpha && d[3] < 1 && (this.hasAlpha = !0)), !isNaN(p[0][s]) && !isNaN(p[1][s])) {
                                                            var m;
                                                            if (p[0][s] < 0) (m = u.slice())[s] += p[0][s], i.push(u[0], u[1], u[2], d[0], d[1], d[2], d[3], 0, 0, 0, m[0], m[1], m[2], d[0], d[1], d[2], d[3], 0, 0, 0), c(this.bounds, m), o += 2 + f(i, m, d, s);
                                                            if (p[1][s] > 0) (m = u.slice())[s] += p[1][s], i.push(u[0], u[1], u[2], d[0], d[1], d[2], d[3], 0, 0, 0, m[0], m[1], m[2], d[0], d[1], d[2], d[3], 0, 0, 0), c(this.bounds, m), o += 2 + f(i, m, d, s);
                                                        }
                                                    }
                                                    this.lineCount[s] = o - this.lineOffset[s];
                                                }
                                                this.buffer.update(i);
                                            }
                                        }, l.dispose = function() {
                                            this.shader.dispose(), this.buffer.dispose(), this.vao.dispose();
                                        };
                                    },
                                    {
                                        "./shaders/index": 85,
                                        "gl-buffer": 78,
                                        "gl-vao": 150
                                    }
                                ],
                                85: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("glslify"), i = t1("gl-shader"), a = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, offset;\nattribute vec4 color;\nuniform mat4 model, view, projection;\nuniform float capSize;\nvarying vec4 fragColor;\nvarying vec3 fragPosition;\n\nvoid main() {\n  vec4 worldPosition  = model * vec4(position, 1.0);\n  worldPosition       = (worldPosition / worldPosition.w) + vec4(capSize * offset, 0.0);\n  gl_Position         = projection * view * worldPosition;\n  fragColor           = color;\n  fragPosition        = position;\n}"
                                        ]), o = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float opacity;\nvarying vec3 fragPosition;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], fragPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  gl_FragColor = opacity * fragColor;\n}"
                                        ]);
                                        e1.exports = function(t1) {
                                            return i(t1, a, o, null, [
                                                {
                                                    name: "position",
                                                    type: "vec3"
                                                },
                                                {
                                                    name: "color",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "offset",
                                                    type: "vec3"
                                                }
                                            ]);
                                        };
                                    },
                                    {
                                        "gl-shader": 132,
                                        glslify: 231
                                    }
                                ],
                                86: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("gl-texture2d");
                                        e1.exports = function(t1, e1, r, n) {
                                            i || (i = t1.FRAMEBUFFER_UNSUPPORTED, a = t1.FRAMEBUFFER_INCOMPLETE_ATTACHMENT, o = t1.FRAMEBUFFER_INCOMPLETE_DIMENSIONS, s = t1.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT);
                                            var c = t1.getExtension("WEBGL_draw_buffers");
                                            !l && c && function(t1, e1) {
                                                var r = t1.getParameter(e1.MAX_COLOR_ATTACHMENTS_WEBGL);
                                                l = new Array(r + 1);
                                                for(var n = 0; n <= r; ++n){
                                                    for(var i = new Array(r), a = 0; a < n; ++a)i[a] = t1.COLOR_ATTACHMENT0 + a;
                                                    for(a = n; a < r; ++a)i[a] = t1.NONE;
                                                    l[n] = i;
                                                }
                                            }(t1, c);
                                            Array.isArray(e1) && (n = r, r = 0 | e1[1], e1 = 0 | e1[0]);
                                            if ("number" != typeof e1) throw new Error("gl-fbo: Missing shape parameter");
                                            var u = t1.getParameter(t1.MAX_RENDERBUFFER_SIZE);
                                            if (e1 < 0 || e1 > u || r < 0 || r > u) throw new Error("gl-fbo: Parameters are too large for FBO");
                                            var f = 1;
                                            if ("color" in (n = n || {})) {
                                                if ((f = Math.max(0 | n.color, 0)) < 0) throw new Error("gl-fbo: Must specify a nonnegative number of colors");
                                                if (f > 1) {
                                                    if (!c) throw new Error("gl-fbo: Multiple draw buffer extension not supported");
                                                    if (f > t1.getParameter(c.MAX_COLOR_ATTACHMENTS_WEBGL)) throw new Error("gl-fbo: Context does not support " + f + " draw buffers");
                                                }
                                            }
                                            var h = t1.UNSIGNED_BYTE, p = t1.getExtension("OES_texture_float");
                                            if (n.float && f > 0) {
                                                if (!p) throw new Error("gl-fbo: Context does not support floating point textures");
                                                h = t1.FLOAT;
                                            } else n.preferFloat && f > 0 && p && (h = t1.FLOAT);
                                            var m = !0;
                                            "depth" in n && (m = !!n.depth);
                                            var g = !1;
                                            "stencil" in n && (g = !!n.stencil);
                                            return new d(t1, e1, r, h, f, m, g, c);
                                        };
                                        var i, a, o, s, l = null;
                                        function c(t1) {
                                            return [
                                                t1.getParameter(t1.FRAMEBUFFER_BINDING),
                                                t1.getParameter(t1.RENDERBUFFER_BINDING),
                                                t1.getParameter(t1.TEXTURE_BINDING_2D)
                                            ];
                                        }
                                        function u(t1, e1) {
                                            t1.bindFramebuffer(t1.FRAMEBUFFER, e1[0]), t1.bindRenderbuffer(t1.RENDERBUFFER, e1[1]), t1.bindTexture(t1.TEXTURE_2D, e1[2]);
                                        }
                                        function f(t1) {
                                            switch(t1){
                                                case i:
                                                    throw new Error("gl-fbo: Framebuffer unsupported");
                                                case a:
                                                    throw new Error("gl-fbo: Framebuffer incomplete attachment");
                                                case o:
                                                    throw new Error("gl-fbo: Framebuffer incomplete dimensions");
                                                case s:
                                                    throw new Error("gl-fbo: Framebuffer incomplete missing attachment");
                                                default:
                                                    throw new Error("gl-fbo: Framebuffer failed for unspecified reason");
                                            }
                                        }
                                        function h(t1, e1, r, i, a, o) {
                                            if (!i) return null;
                                            var s = n(t1, e1, r, a, i);
                                            return s.magFilter = t1.NEAREST, s.minFilter = t1.NEAREST, s.mipSamples = 1, s.bind(), t1.framebufferTexture2D(t1.FRAMEBUFFER, o, t1.TEXTURE_2D, s.handle, 0), s;
                                        }
                                        function p(t1, e1, r, n, i) {
                                            var a = t1.createRenderbuffer();
                                            return t1.bindRenderbuffer(t1.RENDERBUFFER, a), t1.renderbufferStorage(t1.RENDERBUFFER, n, e1, r), t1.framebufferRenderbuffer(t1.FRAMEBUFFER, i, t1.RENDERBUFFER, a), a;
                                        }
                                        function d(t1, e1, r, n, i, a, o, s) {
                                            this.gl = t1, this._shape = [
                                                0 | e1,
                                                0 | r
                                            ], this._destroyed = !1, this._ext = s, this.color = new Array(i);
                                            for(var d = 0; d < i; ++d)this.color[d] = null;
                                            this._color_rb = null, this.depth = null, this._depth_rb = null, this._colorType = n, this._useDepth = a, this._useStencil = o;
                                            var m = this, g = [
                                                0 | e1,
                                                0 | r
                                            ];
                                            Object.defineProperties(g, {
                                                0: {
                                                    get: function() {
                                                        return m._shape[0];
                                                    },
                                                    set: function(t1) {
                                                        return m.width = t1;
                                                    }
                                                },
                                                1: {
                                                    get: function() {
                                                        return m._shape[1];
                                                    },
                                                    set: function(t1) {
                                                        return m.height = t1;
                                                    }
                                                }
                                            }), this._shapeVector = g, function(t1) {
                                                var e1 = c(t1.gl), r = t1.gl, n = t1.handle = r.createFramebuffer(), i = t1._shape[0], a = t1._shape[1], o = t1.color.length, s = t1._ext, d = t1._useStencil, m = t1._useDepth, g = t1._colorType;
                                                r.bindFramebuffer(r.FRAMEBUFFER, n);
                                                for(var v = 0; v < o; ++v)t1.color[v] = h(r, i, a, g, r.RGBA, r.COLOR_ATTACHMENT0 + v);
                                                0 === o ? (t1._color_rb = p(r, i, a, r.RGBA4, r.COLOR_ATTACHMENT0), s && s.drawBuffersWEBGL(l[0])) : o > 1 && s.drawBuffersWEBGL(l[o]);
                                                var y = r.getExtension("WEBGL_depth_texture");
                                                y ? d ? t1.depth = h(r, i, a, y.UNSIGNED_INT_24_8_WEBGL, r.DEPTH_STENCIL, r.DEPTH_STENCIL_ATTACHMENT) : m && (t1.depth = h(r, i, a, r.UNSIGNED_SHORT, r.DEPTH_COMPONENT, r.DEPTH_ATTACHMENT)) : m && d ? t1._depth_rb = p(r, i, a, r.DEPTH_STENCIL, r.DEPTH_STENCIL_ATTACHMENT) : m ? t1._depth_rb = p(r, i, a, r.DEPTH_COMPONENT16, r.DEPTH_ATTACHMENT) : d && (t1._depth_rb = p(r, i, a, r.STENCIL_INDEX, r.STENCIL_ATTACHMENT));
                                                var x = r.checkFramebufferStatus(r.FRAMEBUFFER);
                                                if (x !== r.FRAMEBUFFER_COMPLETE) {
                                                    t1._destroyed = !0, r.bindFramebuffer(r.FRAMEBUFFER, null), r.deleteFramebuffer(t1.handle), t1.handle = null, t1.depth && (t1.depth.dispose(), t1.depth = null), t1._depth_rb && (r.deleteRenderbuffer(t1._depth_rb), t1._depth_rb = null);
                                                    for(v = 0; v < t1.color.length; ++v)t1.color[v].dispose(), t1.color[v] = null;
                                                    t1._color_rb && (r.deleteRenderbuffer(t1._color_rb), t1._color_rb = null), u(r, e1), f(x);
                                                }
                                                u(r, e1);
                                            }(this);
                                        }
                                        var m = d.prototype;
                                        function g(t1, e1, r) {
                                            if (t1._destroyed) throw new Error("gl-fbo: Can't resize destroyed FBO");
                                            if (t1._shape[0] !== e1 || t1._shape[1] !== r) {
                                                var n = t1.gl, i = n.getParameter(n.MAX_RENDERBUFFER_SIZE);
                                                if (e1 < 0 || e1 > i || r < 0 || r > i) throw new Error("gl-fbo: Can't resize FBO, invalid dimensions");
                                                t1._shape[0] = e1, t1._shape[1] = r;
                                                for(var a = c(n), o = 0; o < t1.color.length; ++o)t1.color[o].shape = t1._shape;
                                                t1._color_rb && (n.bindRenderbuffer(n.RENDERBUFFER, t1._color_rb), n.renderbufferStorage(n.RENDERBUFFER, n.RGBA4, t1._shape[0], t1._shape[1])), t1.depth && (t1.depth.shape = t1._shape), t1._depth_rb && (n.bindRenderbuffer(n.RENDERBUFFER, t1._depth_rb), t1._useDepth && t1._useStencil ? n.renderbufferStorage(n.RENDERBUFFER, n.DEPTH_STENCIL, t1._shape[0], t1._shape[1]) : t1._useDepth ? n.renderbufferStorage(n.RENDERBUFFER, n.DEPTH_COMPONENT16, t1._shape[0], t1._shape[1]) : t1._useStencil && n.renderbufferStorage(n.RENDERBUFFER, n.STENCIL_INDEX, t1._shape[0], t1._shape[1])), n.bindFramebuffer(n.FRAMEBUFFER, t1.handle);
                                                var s = n.checkFramebufferStatus(n.FRAMEBUFFER);
                                                s !== n.FRAMEBUFFER_COMPLETE && (t1.dispose(), u(n, a), f(s)), u(n, a);
                                            }
                                        }
                                        Object.defineProperties(m, {
                                            shape: {
                                                get: function() {
                                                    return this._destroyed ? [
                                                        0,
                                                        0
                                                    ] : this._shapeVector;
                                                },
                                                set: function(t1) {
                                                    if (Array.isArray(t1) || (t1 = [
                                                        0 | t1,
                                                        0 | t1
                                                    ]), 2 !== t1.length) throw new Error("gl-fbo: Shape vector must be length 2");
                                                    var e1 = 0 | t1[0], r = 0 | t1[1];
                                                    return g(this, e1, r), [
                                                        e1,
                                                        r
                                                    ];
                                                },
                                                enumerable: !1
                                            },
                                            width: {
                                                get: function() {
                                                    return this._destroyed ? 0 : this._shape[0];
                                                },
                                                set: function(t1) {
                                                    return g(this, t1 |= 0, this._shape[1]), t1;
                                                },
                                                enumerable: !1
                                            },
                                            height: {
                                                get: function() {
                                                    return this._destroyed ? 0 : this._shape[1];
                                                },
                                                set: function(t1) {
                                                    return t1 |= 0, g(this, this._shape[0], t1), t1;
                                                },
                                                enumerable: !1
                                            }
                                        }), m.bind = function() {
                                            if (!this._destroyed) {
                                                var t1 = this.gl;
                                                t1.bindFramebuffer(t1.FRAMEBUFFER, this.handle), t1.viewport(0, 0, this._shape[0], this._shape[1]);
                                            }
                                        }, m.dispose = function() {
                                            if (!this._destroyed) {
                                                this._destroyed = !0;
                                                var t1 = this.gl;
                                                t1.deleteFramebuffer(this.handle), this.handle = null, this.depth && (this.depth.dispose(), this.depth = null), this._depth_rb && (t1.deleteRenderbuffer(this._depth_rb), this._depth_rb = null);
                                                for(var e1 = 0; e1 < this.color.length; ++e1)this.color[e1].dispose(), this.color[e1] = null;
                                                this._color_rb && (t1.deleteRenderbuffer(this._color_rb), this._color_rb = null);
                                            }
                                        };
                                    },
                                    {
                                        "gl-texture2d": 146
                                    }
                                ],
                                87: [
                                    function(t1, e1, r) {
                                        var n = t1("sprintf-js").sprintf, i = t1("gl-constants/lookup"), a = t1("glsl-shader-name"), o = t1("add-line-numbers");
                                        e1.exports = function(t1, e1, r) {
                                            "use strict";
                                            var s = a(e1) || "of unknown name (see npm glsl-shader-name)", l = "unknown type";
                                            void 0 !== r && (l = r === i.FRAGMENT_SHADER ? "fragment" : "vertex");
                                            for(var c = n("Error compiling %s shader %s:\n", l, s), u = n("%s%s", c, t1), f = t1.split("\n"), h = {}, p = 0; p < f.length; p++){
                                                var d = f[p];
                                                if ("" !== d && "\0" !== d) {
                                                    var m = parseInt(d.split(":")[2]);
                                                    if (isNaN(m)) throw new Error(n("Could not parse error: %s", d));
                                                    h[m] = d;
                                                }
                                            }
                                            var g = o(e1).split("\n");
                                            for(p = 0; p < g.length; p++)if (h[p + 3] || h[p + 2] || h[p + 1]) {
                                                var v = g[p];
                                                if (c += v + "\n", h[p + 1]) {
                                                    var y = h[p + 1];
                                                    y = y.substr(y.split(":", 3).join(":").length + 1).trim(), c += n("^^^ %s\n\n", y);
                                                }
                                            }
                                            return {
                                                long: c.trim(),
                                                short: u.trim()
                                            };
                                        };
                                    },
                                    {
                                        "add-line-numbers": 9,
                                        "gl-constants/lookup": 83,
                                        "glsl-shader-name": 223,
                                        "sprintf-js": 301
                                    }
                                ],
                                88: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            var r = t1.gl, n = o(r, l.vertex, l.fragment), i = o(r, l.pickVertex, l.pickFragment), a = s(r), u = s(r), f = s(r), h = s(r), p = new c(t1, n, i, a, u, f, h);
                                            return p.update(e1), t1.addObject(p), p;
                                        };
                                        var n = t1("binary-search-bounds"), i = t1("iota-array"), a = t1("typedarray-pool"), o = t1("gl-shader"), s = t1("gl-buffer"), l = t1("./lib/shaders");
                                        function c(t1, e1, r, n, i, a, o) {
                                            this.plot = t1, this.shader = e1, this.pickShader = r, this.positionBuffer = n, this.weightBuffer = i, this.colorBuffer = a, this.idBuffer = o, this.xData = [], this.yData = [], this.shape = [
                                                0,
                                                0
                                            ], this.bounds = [
                                                1 / 0,
                                                1 / 0,
                                                -1 / 0,
                                                -1 / 0
                                            ], this.pickOffset = 0;
                                        }
                                        var u, f = c.prototype, h = [
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            1,
                                            1,
                                            0,
                                            1,
                                            1,
                                            0,
                                            1
                                        ];
                                        f.draw = (u = [
                                            1,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            1
                                        ], function() {
                                            var t1 = this.plot, e1 = this.shader, r = this.bounds, n = this.numVertices;
                                            if (!(n <= 0)) {
                                                var i = t1.gl, a = t1.dataBox, o = r[2] - r[0], s = r[3] - r[1], l = a[2] - a[0], c = a[3] - a[1];
                                                u[0] = 2 * o / l, u[4] = 2 * s / c, u[6] = 2 * (r[0] - a[0]) / l - 1, u[7] = 2 * (r[1] - a[1]) / c - 1, e1.bind();
                                                var f = e1.uniforms;
                                                f.viewTransform = u, f.shape = this.shape;
                                                var h = e1.attributes;
                                                this.positionBuffer.bind(), h.position.pointer(), this.weightBuffer.bind(), h.weight.pointer(i.UNSIGNED_BYTE, !1), this.colorBuffer.bind(), h.color.pointer(i.UNSIGNED_BYTE, !0), i.drawArrays(i.TRIANGLES, 0, n);
                                            }
                                        }), f.drawPick = function() {
                                            var t1 = [
                                                1,
                                                0,
                                                0,
                                                0,
                                                1,
                                                0,
                                                0,
                                                0,
                                                1
                                            ], e1 = [
                                                0,
                                                0,
                                                0,
                                                0
                                            ];
                                            return function(r) {
                                                var n = this.plot, i = this.pickShader, a = this.bounds, o = this.numVertices;
                                                if (!(o <= 0)) {
                                                    var s = n.gl, l = n.dataBox, c = a[2] - a[0], u = a[3] - a[1], f = l[2] - l[0], h = l[3] - l[1];
                                                    t1[0] = 2 * c / f, t1[4] = 2 * u / h, t1[6] = 2 * (a[0] - l[0]) / f - 1, t1[7] = 2 * (a[1] - l[1]) / h - 1;
                                                    for(var p = 0; p < 4; ++p)e1[p] = r >> 8 * p & 255;
                                                    this.pickOffset = r, i.bind();
                                                    var d = i.uniforms;
                                                    d.viewTransform = t1, d.pickOffset = e1, d.shape = this.shape;
                                                    var m = i.attributes;
                                                    return this.positionBuffer.bind(), m.position.pointer(), this.weightBuffer.bind(), m.weight.pointer(s.UNSIGNED_BYTE, !1), this.idBuffer.bind(), m.pickId.pointer(s.UNSIGNED_BYTE, !1), s.drawArrays(s.TRIANGLES, 0, o), r + this.shape[0] * this.shape[1];
                                                }
                                            };
                                        }(), f.pick = function(t1, e1, r) {
                                            var n = this.pickOffset, i = this.shape[0] * this.shape[1];
                                            if (r < n || r >= n + i) return null;
                                            var a = r - n, o = this.xData, s = this.yData;
                                            return {
                                                object: this,
                                                pointId: a,
                                                dataCoord: [
                                                    o[a % this.shape[0]],
                                                    s[a / this.shape[0] | 0]
                                                ]
                                            };
                                        }, f.update = function(t1) {
                                            var e1 = (t1 = t1 || {}).shape || [
                                                0,
                                                0
                                            ], r = t1.x || i(e1[0]), o = t1.y || i(e1[1]), s = t1.z || new Float32Array(e1[0] * e1[1]), l = !1 !== t1.zsmooth;
                                            this.xData = r, this.yData = o;
                                            var c, u, f, p, d = t1.colorLevels || [
                                                0
                                            ], m = t1.colorValues || [
                                                0,
                                                0,
                                                0,
                                                1
                                            ], g = d.length, v = this.bounds;
                                            l ? (c = v[0] = r[0], u = v[1] = o[0], f = v[2] = r[r.length - 1], p = v[3] = o[o.length - 1]) : (c = v[0] = r[0] + (r[1] - r[0]) / 2, u = v[1] = o[0] + (o[1] - o[0]) / 2, f = v[2] = r[r.length - 1] + (r[r.length - 1] - r[r.length - 2]) / 2, p = v[3] = o[o.length - 1] + (o[o.length - 1] - o[o.length - 2]) / 2);
                                            var y = 1 / (f - c), x = 1 / (p - u), b = e1[0], _ = e1[1];
                                            this.shape = [
                                                b,
                                                _
                                            ];
                                            var w = (l ? (b - 1) * (_ - 1) : b * _) * (h.length >>> 1);
                                            this.numVertices = w;
                                            for(var T = a.mallocUint8(4 * w), k = a.mallocFloat32(2 * w), A = a.mallocUint8(2 * w), M = a.mallocUint32(w), S = 0, E = l ? b - 1 : b, L = l ? _ - 1 : _, C = 0; C < L; ++C){
                                                var P, I;
                                                l ? (P = x * (o[C] - u), I = x * (o[C + 1] - u)) : (P = C < _ - 1 ? x * (o[C] - (o[C + 1] - o[C]) / 2 - u) : x * (o[C] - (o[C] - o[C - 1]) / 2 - u), I = C < _ - 1 ? x * (o[C] + (o[C + 1] - o[C]) / 2 - u) : x * (o[C] + (o[C] - o[C - 1]) / 2 - u));
                                                for(var O = 0; O < E; ++O){
                                                    var z, D;
                                                    l ? (z = y * (r[O] - c), D = y * (r[O + 1] - c)) : (z = O < b - 1 ? y * (r[O] - (r[O + 1] - r[O]) / 2 - c) : y * (r[O] - (r[O] - r[O - 1]) / 2 - c), D = O < b - 1 ? y * (r[O] + (r[O + 1] - r[O]) / 2 - c) : y * (r[O] + (r[O] - r[O - 1]) / 2 - c));
                                                    for(var R = 0; R < h.length; R += 2){
                                                        var F, B, N, j, U = h[R], V = h[R + 1], H = s[l ? (C + V) * b + (O + U) : C * b + O], q = n.le(d, H);
                                                        if (q < 0) F = m[0], B = m[1], N = m[2], j = m[3];
                                                        else if (q === g - 1) F = m[4 * g - 4], B = m[4 * g - 3], N = m[4 * g - 2], j = m[4 * g - 1];
                                                        else {
                                                            var G = (H - d[q]) / (d[q + 1] - d[q]), Y = 1 - G, W = 4 * q, X = 4 * (q + 1);
                                                            F = Y * m[W] + G * m[X], B = Y * m[W + 1] + G * m[X + 1], N = Y * m[W + 2] + G * m[X + 2], j = Y * m[W + 3] + G * m[X + 3];
                                                        }
                                                        T[4 * S] = 255 * F, T[4 * S + 1] = 255 * B, T[4 * S + 2] = 255 * N, T[4 * S + 3] = 255 * j, k[2 * S] = .5 * z + .5 * D, k[2 * S + 1] = .5 * P + .5 * I, A[2 * S] = U, A[2 * S + 1] = V, M[S] = C * b + O, S += 1;
                                                    }
                                                }
                                            }
                                            this.positionBuffer.update(k), this.weightBuffer.update(A), this.colorBuffer.update(T), this.idBuffer.update(M), a.free(k), a.free(T), a.free(A), a.free(M);
                                        }, f.dispose = function() {
                                            this.shader.dispose(), this.pickShader.dispose(), this.positionBuffer.dispose(), this.weightBuffer.dispose(), this.colorBuffer.dispose(), this.idBuffer.dispose(), this.plot.removeObject(this);
                                        };
                                    },
                                    {
                                        "./lib/shaders": 89,
                                        "binary-search-bounds": 31,
                                        "gl-buffer": 78,
                                        "gl-shader": 132,
                                        "iota-array": 235,
                                        "typedarray-pool": 308
                                    }
                                ],
                                89: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("glslify");
                                        e1.exports = {
                                            fragment: n([
                                                "precision lowp float;\n#define GLSLIFY 1\nvarying vec4 fragColor;\nvoid main() {\n  gl_FragColor = vec4(fragColor.rgb * fragColor.a, fragColor.a);\n}\n"
                                            ]),
                                            vertex: n([
                                                "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 color;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  fragColor = color;\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"
                                            ]),
                                            pickFragment: n([
                                                "precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nuniform vec2 shape;\nuniform vec4 pickOffset;\n\nvoid main() {\n  vec2 d = step(.5, vWeight);\n  vec4 id = fragId + pickOffset;\n  id.x += d.x + d.y*shape.x;\n\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  gl_FragColor = id/255.;\n}\n"
                                            ]),
                                            pickVertex: n([
                                                "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nvoid main() {\n  vWeight = weight;\n\n  fragId = pickId;\n\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"
                                            ])
                                        };
                                    },
                                    {
                                        glslify: 231
                                    }
                                ],
                                90: [
                                    function(t1, e1, r) {
                                        var n = t1("glslify"), i = t1("gl-shader"), a = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, nextPosition;\nattribute float arcLength, lineWidth;\nattribute vec4 color;\n\nuniform vec2 screenShape;\nuniform float pixelRatio;\nuniform mat4 model, view, projection;\n\nvarying vec4 fragColor;\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\n\nvec4 project(vec3 p) {\n  return projection * view * model * vec4(p, 1.0);\n}\n\nvoid main() {\n  vec4 startPoint = project(position);\n  vec4 endPoint   = project(nextPosition);\n\n  vec2 A = startPoint.xy / startPoint.w;\n  vec2 B =   endPoint.xy /   endPoint.w;\n\n  float clipAngle = atan(\n    (B.y - A.y) * screenShape.y,\n    (B.x - A.x) * screenShape.x\n  );\n\n  vec2 offset = 0.5 * pixelRatio * lineWidth * vec2(\n    sin(clipAngle),\n    -cos(clipAngle)\n  ) / screenShape;\n\n  gl_Position = vec4(startPoint.xy + startPoint.w * offset, startPoint.zw);\n\n  worldPosition = position;\n  pixelArcLength = arcLength;\n  fragColor = color;\n}\n"
                                        ]), o = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3      clipBounds[2];\nuniform sampler2D dashTexture;\nuniform float     dashScale;\nuniform float     opacity;\n\nvarying vec3    worldPosition;\nvarying float   pixelArcLength;\nvarying vec4    fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], worldPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  float dashWeight = texture2D(dashTexture, vec2(dashScale * pixelArcLength, 0)).r;\n  if(dashWeight < 0.5) {\n    discard;\n  }\n  gl_FragColor = fragColor * opacity;\n}\n"
                                        ]), s = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\n#define FLOAT_MAX  1.70141184e38\n#define FLOAT_MIN  1.17549435e-38\n\n// https://github.com/mikolalysenko/glsl-read-float/blob/master/index.glsl\nvec4 packFloat(float v) {\n  float av = abs(v);\n\n  //Handle special cases\n  if(av < FLOAT_MIN) {\n    return vec4(0.0, 0.0, 0.0, 0.0);\n  } else if(v > FLOAT_MAX) {\n    return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n  } else if(v < -FLOAT_MAX) {\n    return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n  }\n\n  vec4 c = vec4(0,0,0,0);\n\n  //Compute exponent and mantissa\n  float e = floor(log2(av));\n  float m = av * pow(2.0, -e) - 1.0;\n\n  //Unpack mantissa\n  c[1] = floor(128.0 * m);\n  m -= c[1] / 128.0;\n  c[2] = floor(32768.0 * m);\n  m -= c[2] / 32768.0;\n  c[3] = floor(8388608.0 * m);\n\n  //Unpack exponent\n  float ebias = e + 127.0;\n  c[0] = floor(ebias / 2.0);\n  ebias -= c[0] * 2.0;\n  c[1] += floor(ebias) * 128.0;\n\n  //Unpack sign bit\n  c[0] += 128.0 * step(0.0, -v);\n\n  //Scale back to range\n  return c / 255.0;\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform float pickId;\nuniform vec3 clipBounds[2];\n\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], worldPosition)) discard;\n\n  gl_FragColor = vec4(pickId/255.0, packFloat(pixelArcLength).xyz);\n}"
                                        ]), l = [
                                            {
                                                name: "position",
                                                type: "vec3"
                                            },
                                            {
                                                name: "nextPosition",
                                                type: "vec3"
                                            },
                                            {
                                                name: "arcLength",
                                                type: "float"
                                            },
                                            {
                                                name: "lineWidth",
                                                type: "float"
                                            },
                                            {
                                                name: "color",
                                                type: "vec4"
                                            }
                                        ];
                                        r.createShader = function(t1) {
                                            return i(t1, a, o, null, l);
                                        }, r.createPickShader = function(t1) {
                                            return i(t1, a, s, null, l);
                                        };
                                    },
                                    {
                                        "gl-shader": 132,
                                        glslify: 231
                                    }
                                ],
                                91: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = t1.gl || t1.scene && t1.scene.gl, r = f(e1);
                                            r.attributes.position.location = 0, r.attributes.nextPosition.location = 1, r.attributes.arcLength.location = 2, r.attributes.lineWidth.location = 3, r.attributes.color.location = 4;
                                            var o = h(e1);
                                            o.attributes.position.location = 0, o.attributes.nextPosition.location = 1, o.attributes.arcLength.location = 2, o.attributes.lineWidth.location = 3, o.attributes.color.location = 4;
                                            for(var s = n(e1), l = i(e1, [
                                                {
                                                    buffer: s,
                                                    size: 3,
                                                    offset: 0,
                                                    stride: 48
                                                },
                                                {
                                                    buffer: s,
                                                    size: 3,
                                                    offset: 12,
                                                    stride: 48
                                                },
                                                {
                                                    buffer: s,
                                                    size: 1,
                                                    offset: 24,
                                                    stride: 48
                                                },
                                                {
                                                    buffer: s,
                                                    size: 1,
                                                    offset: 28,
                                                    stride: 48
                                                },
                                                {
                                                    buffer: s,
                                                    size: 4,
                                                    offset: 32,
                                                    stride: 48
                                                }
                                            ]), u = c(new Array(1024), [
                                                256,
                                                1,
                                                4
                                            ]), p = 0; p < 1024; ++p)u.data[p] = 255;
                                            var d = a(e1, u);
                                            d.wrap = e1.REPEAT;
                                            var m = new v(e1, r, o, s, l, d);
                                            return m.update(t1), m;
                                        };
                                        var n = t1("gl-buffer"), i = t1("gl-vao"), a = t1("gl-texture2d"), o = new Uint8Array(4), s = new Float32Array(o.buffer);
                                        var l = t1("binary-search-bounds"), c = t1("ndarray"), u = t1("./lib/shaders"), f = u.createShader, h = u.createPickShader, p = [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                        function d(t1, e1) {
                                            for(var r = 0, n = 0; n < 3; ++n){
                                                var i = t1[n] - e1[n];
                                                r += i * i;
                                            }
                                            return Math.sqrt(r);
                                        }
                                        function m(t1) {
                                            for(var e1 = [
                                                [
                                                    -1000000,
                                                    -1000000,
                                                    -1000000
                                                ],
                                                [
                                                    1e6,
                                                    1e6,
                                                    1e6
                                                ]
                                            ], r = 0; r < 3; ++r)e1[0][r] = Math.max(t1[0][r], e1[0][r]), e1[1][r] = Math.min(t1[1][r], e1[1][r]);
                                            return e1;
                                        }
                                        function g(t1, e1, r, n) {
                                            this.arcLength = t1, this.position = e1, this.index = r, this.dataCoordinate = n;
                                        }
                                        function v(t1, e1, r, n, i, a) {
                                            this.gl = t1, this.shader = e1, this.pickShader = r, this.buffer = n, this.vao = i, this.clipBounds = [
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ],
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ]
                                            ], this.points = [], this.arcLength = [], this.vertexCount = 0, this.bounds = [
                                                [
                                                    0,
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0
                                                ]
                                            ], this.pickId = 0, this.lineWidth = 1, this.texture = a, this.dashScale = 1, this.opacity = 1, this.hasAlpha = !1, this.dirty = !0, this.pixelRatio = 1;
                                        }
                                        var y = v.prototype;
                                        y.isTransparent = function() {
                                            return this.hasAlpha;
                                        }, y.isOpaque = function() {
                                            return !this.hasAlpha;
                                        }, y.pickSlots = 1, y.setPickBase = function(t1) {
                                            this.pickId = t1;
                                        }, y.drawTransparent = y.draw = function(t1) {
                                            if (this.vertexCount) {
                                                var e1 = this.gl, r = this.shader, n = this.vao;
                                                r.bind(), r.uniforms = {
                                                    model: t1.model || p,
                                                    view: t1.view || p,
                                                    projection: t1.projection || p,
                                                    clipBounds: m(this.clipBounds),
                                                    dashTexture: this.texture.bind(),
                                                    dashScale: this.dashScale / this.arcLength[this.arcLength.length - 1],
                                                    opacity: this.opacity,
                                                    screenShape: [
                                                        e1.drawingBufferWidth,
                                                        e1.drawingBufferHeight
                                                    ],
                                                    pixelRatio: this.pixelRatio
                                                }, n.bind(), n.draw(e1.TRIANGLE_STRIP, this.vertexCount), n.unbind();
                                            }
                                        }, y.drawPick = function(t1) {
                                            if (this.vertexCount) {
                                                var e1 = this.gl, r = this.pickShader, n = this.vao;
                                                r.bind(), r.uniforms = {
                                                    model: t1.model || p,
                                                    view: t1.view || p,
                                                    projection: t1.projection || p,
                                                    pickId: this.pickId,
                                                    clipBounds: m(this.clipBounds),
                                                    screenShape: [
                                                        e1.drawingBufferWidth,
                                                        e1.drawingBufferHeight
                                                    ],
                                                    pixelRatio: this.pixelRatio
                                                }, n.bind(), n.draw(e1.TRIANGLE_STRIP, this.vertexCount), n.unbind();
                                            }
                                        }, y.update = function(t1) {
                                            var e1, r;
                                            this.dirty = !0;
                                            var n = !!t1.connectGaps;
                                            "dashScale" in t1 && (this.dashScale = t1.dashScale), this.hasAlpha = !1, "opacity" in t1 && (this.opacity = +t1.opacity, this.opacity < 1 && (this.hasAlpha = !0));
                                            var i = [], a = [], o = [], s = 0, u = 0, f = [
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ],
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ]
                                            ], h = t1.position || t1.positions;
                                            if (h) {
                                                var p = t1.color || t1.colors || [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ], m = t1.lineWidth || 1, g = !1;
                                                t: for(e1 = 1; e1 < h.length; ++e1){
                                                    var v, y, x, b = h[e1 - 1], _ = h[e1];
                                                    for(a.push(s), o.push(b.slice()), r = 0; r < 3; ++r){
                                                        if (isNaN(b[r]) || isNaN(_[r]) || !isFinite(b[r]) || !isFinite(_[r])) {
                                                            if (!n && i.length > 0) {
                                                                for(var w = 0; w < 24; ++w)i.push(i[i.length - 12]);
                                                                u += 2, g = !0;
                                                            }
                                                            continue t;
                                                        }
                                                        f[0][r] = Math.min(f[0][r], b[r], _[r]), f[1][r] = Math.max(f[1][r], b[r], _[r]);
                                                    }
                                                    Array.isArray(p[0]) ? (v = p.length > e1 - 1 ? p[e1 - 1] : p.length > 0 ? p[p.length - 1] : [
                                                        0,
                                                        0,
                                                        0,
                                                        1
                                                    ], y = p.length > e1 ? p[e1] : p.length > 0 ? p[p.length - 1] : [
                                                        0,
                                                        0,
                                                        0,
                                                        1
                                                    ]) : v = y = p, 3 === v.length && (v = [
                                                        v[0],
                                                        v[1],
                                                        v[2],
                                                        1
                                                    ]), 3 === y.length && (y = [
                                                        y[0],
                                                        y[1],
                                                        y[2],
                                                        1
                                                    ]), !this.hasAlpha && v[3] < 1 && (this.hasAlpha = !0), x = Array.isArray(m) ? m.length > e1 - 1 ? m[e1 - 1] : m.length > 0 ? m[m.length - 1] : [
                                                        0,
                                                        0,
                                                        0,
                                                        1
                                                    ] : m;
                                                    var T = s;
                                                    if (s += d(b, _), g) {
                                                        for(r = 0; r < 2; ++r)i.push(b[0], b[1], b[2], _[0], _[1], _[2], T, x, v[0], v[1], v[2], v[3]);
                                                        u += 2, g = !1;
                                                    }
                                                    i.push(b[0], b[1], b[2], _[0], _[1], _[2], T, x, v[0], v[1], v[2], v[3], b[0], b[1], b[2], _[0], _[1], _[2], T, -x, v[0], v[1], v[2], v[3], _[0], _[1], _[2], b[0], b[1], b[2], s, -x, y[0], y[1], y[2], y[3], _[0], _[1], _[2], b[0], b[1], b[2], s, x, y[0], y[1], y[2], y[3]), u += 4;
                                                }
                                            }
                                            if (this.buffer.update(i), a.push(s), o.push(h[h.length - 1].slice()), this.bounds = f, this.vertexCount = u, this.points = o, this.arcLength = a, "dashes" in t1) {
                                                var k = t1.dashes.slice();
                                                for(k.unshift(0), e1 = 1; e1 < k.length; ++e1)k[e1] = k[e1 - 1] + k[e1];
                                                var A = c(new Array(1024), [
                                                    256,
                                                    1,
                                                    4
                                                ]);
                                                for(e1 = 0; e1 < 256; ++e1){
                                                    for(r = 0; r < 4; ++r)A.set(e1, 0, r, 0);
                                                    1 & l.le(k, k[k.length - 1] * e1 / 255) ? A.set(e1, 0, 0, 0) : A.set(e1, 0, 0, 255);
                                                }
                                                this.texture.setPixels(A);
                                            }
                                        }, y.dispose = function() {
                                            this.shader.dispose(), this.vao.dispose(), this.buffer.dispose();
                                        }, y.pick = function(t1) {
                                            if (!t1) return null;
                                            if (t1.id !== this.pickId) return null;
                                            var e1 = function(t1, e1, r, n) {
                                                return o[0] = n, o[1] = r, o[2] = e1, o[3] = t1, s[0];
                                            }(t1.value[0], t1.value[1], t1.value[2], 0), r = l.le(this.arcLength, e1);
                                            if (r < 0) return null;
                                            if (r === this.arcLength.length - 1) return new g(this.arcLength[this.arcLength.length - 1], this.points[this.points.length - 1].slice(), r);
                                            for(var n = this.points[r], i = this.points[Math.min(r + 1, this.points.length - 1)], a = (e1 - this.arcLength[r]) / (this.arcLength[r + 1] - this.arcLength[r]), c = 1 - a, u = [
                                                0,
                                                0,
                                                0
                                            ], f = 0; f < 3; ++f)u[f] = c * n[f] + a * i[f];
                                            var h = Math.min(a < .5 ? r : r + 1, this.points.length - 1);
                                            return new g(e1, u, h, this.points[h]);
                                        };
                                    },
                                    {
                                        "./lib/shaders": 90,
                                        "binary-search-bounds": 31,
                                        "gl-buffer": 78,
                                        "gl-texture2d": 146,
                                        "gl-vao": 150,
                                        ndarray: 259
                                    }
                                ],
                                92: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            var e1 = new Float32Array(16);
                                            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
                                        };
                                    },
                                    {}
                                ],
                                93: [
                                    function(t1, e1, r) {
                                        e1.exports = function() {
                                            var t1 = new Float32Array(16);
                                            return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                                        };
                                    },
                                    {}
                                ],
                                94: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            var e1 = t1[0], r = t1[1], n = t1[2], i = t1[3], a = t1[4], o = t1[5], s = t1[6], l = t1[7], c = t1[8], u = t1[9], f = t1[10], h = t1[11], p = t1[12], d = t1[13], m = t1[14], g = t1[15];
                                            return (e1 * o - r * a) * (f * g - h * m) - (e1 * s - n * a) * (u * g - h * d) + (e1 * l - i * a) * (u * m - f * d) + (r * s - n * o) * (c * g - h * p) - (r * l - i * o) * (c * m - f * p) + (n * l - i * s) * (c * d - u * p);
                                        };
                                    },
                                    {}
                                ],
                                95: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = r + r, s = n + n, l = i + i, c = r * o, u = n * o, f = n * s, h = i * o, p = i * s, d = i * l, m = a * o, g = a * s, v = a * l;
                                            return t1[0] = 1 - f - d, t1[1] = u + v, t1[2] = h - g, t1[3] = 0, t1[4] = u - v, t1[5] = 1 - c - d, t1[6] = p + m, t1[7] = 0, t1[8] = h + g, t1[9] = p - m, t1[10] = 1 - c - f, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                                        };
                                    },
                                    {}
                                ],
                                96: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = n + n, l = i + i, c = a + a, u = n * s, f = n * l, h = n * c, p = i * l, d = i * c, m = a * c, g = o * s, v = o * l, y = o * c;
                                            return t1[0] = 1 - (p + m), t1[1] = f + y, t1[2] = h - v, t1[3] = 0, t1[4] = f - y, t1[5] = 1 - (u + m), t1[6] = d + g, t1[7] = 0, t1[8] = h + v, t1[9] = d - g, t1[10] = 1 - (u + p), t1[11] = 0, t1[12] = r[0], t1[13] = r[1], t1[14] = r[2], t1[15] = 1, t1;
                                        };
                                    },
                                    {}
                                ],
                                97: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
                                        };
                                    },
                                    {}
                                ],
                                98: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = e1[4], s = e1[5], l = e1[6], c = e1[7], u = e1[8], f = e1[9], h = e1[10], p = e1[11], d = e1[12], m = e1[13], g = e1[14], v = e1[15], y = r * s - n * o, x = r * l - i * o, b = r * c - a * o, _ = n * l - i * s, w = n * c - a * s, T = i * c - a * l, k = u * m - f * d, A = u * g - h * d, M = u * v - p * d, S = f * g - h * m, E = f * v - p * m, L = h * v - p * g, C = y * L - x * E + b * S + _ * M - w * A + T * k;
                                            if (!C) return null;
                                            return C = 1 / C, t1[0] = (s * L - l * E + c * S) * C, t1[1] = (i * E - n * L - a * S) * C, t1[2] = (m * T - g * w + v * _) * C, t1[3] = (h * w - f * T - p * _) * C, t1[4] = (l * M - o * L - c * A) * C, t1[5] = (r * L - i * M + a * A) * C, t1[6] = (g * b - d * T - v * x) * C, t1[7] = (u * T - h * b + p * x) * C, t1[8] = (o * E - s * M + c * k) * C, t1[9] = (n * M - r * E - a * k) * C, t1[10] = (d * w - m * b + v * y) * C, t1[11] = (f * b - u * w - p * y) * C, t1[12] = (s * A - o * S - l * k) * C, t1[13] = (r * S - n * A + i * k) * C, t1[14] = (m * x - d * _ - g * y) * C, t1[15] = (u * _ - f * x + h * y) * C, t1;
                                        };
                                    },
                                    {}
                                ],
                                99: [
                                    function(t1, e1, r) {
                                        var n = t1("./identity");
                                        e1.exports = function(t1, e1, r, i) {
                                            var a, o, s, l, c, u, f, h, p, d, m = e1[0], g = e1[1], v = e1[2], y = i[0], x = i[1], b = i[2], _ = r[0], w = r[1], T = r[2];
                                            if (Math.abs(m - _) < 1e-6 && Math.abs(g - w) < 1e-6 && Math.abs(v - T) < 1e-6) return n(t1);
                                            f = m - _, h = g - w, p = v - T, d = 1 / Math.sqrt(f * f + h * h + p * p), a = x * (p *= d) - b * (h *= d), o = b * (f *= d) - y * p, s = y * h - x * f, (d = Math.sqrt(a * a + o * o + s * s)) ? (a *= d = 1 / d, o *= d, s *= d) : (a = 0, o = 0, s = 0);
                                            l = h * s - p * o, c = p * a - f * s, u = f * o - h * a, (d = Math.sqrt(l * l + c * c + u * u)) ? (l *= d = 1 / d, c *= d, u *= d) : (l = 0, c = 0, u = 0);
                                            return t1[0] = a, t1[1] = l, t1[2] = f, t1[3] = 0, t1[4] = o, t1[5] = c, t1[6] = h, t1[7] = 0, t1[8] = s, t1[9] = u, t1[10] = p, t1[11] = 0, t1[12] = -(a * m + o * g + s * v), t1[13] = -(l * m + c * g + u * v), t1[14] = -(f * m + h * g + p * v), t1[15] = 1, t1;
                                        };
                                    },
                                    {
                                        "./identity": 97
                                    }
                                ],
                                100: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], f = e1[8], h = e1[9], p = e1[10], d = e1[11], m = e1[12], g = e1[13], v = e1[14], y = e1[15], x = r[0], b = r[1], _ = r[2], w = r[3];
                                            return t1[0] = x * n + b * s + _ * f + w * m, t1[1] = x * i + b * l + _ * h + w * g, t1[2] = x * a + b * c + _ * p + w * v, t1[3] = x * o + b * u + _ * d + w * y, x = r[4], b = r[5], _ = r[6], w = r[7], t1[4] = x * n + b * s + _ * f + w * m, t1[5] = x * i + b * l + _ * h + w * g, t1[6] = x * a + b * c + _ * p + w * v, t1[7] = x * o + b * u + _ * d + w * y, x = r[8], b = r[9], _ = r[10], w = r[11], t1[8] = x * n + b * s + _ * f + w * m, t1[9] = x * i + b * l + _ * h + w * g, t1[10] = x * a + b * c + _ * p + w * v, t1[11] = x * o + b * u + _ * d + w * y, x = r[12], b = r[13], _ = r[14], w = r[15], t1[12] = x * n + b * s + _ * f + w * m, t1[13] = x * i + b * l + _ * h + w * g, t1[14] = x * a + b * c + _ * p + w * v, t1[15] = x * o + b * u + _ * d + w * y, t1;
                                        };
                                    },
                                    {}
                                ],
                                101: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n, i, a, o) {
                                            var s = 1 / (e1 - r), l = 1 / (n - i), c = 1 / (a - o);
                                            return t1[0] = -2 * s, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * c, t1[11] = 0, t1[12] = (e1 + r) * s, t1[13] = (i + n) * l, t1[14] = (o + a) * c, t1[15] = 1, t1;
                                        };
                                    },
                                    {}
                                ],
                                102: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n, i) {
                                            var a = 1 / Math.tan(e1 / 2), o = 1 / (n - i);
                                            return t1[0] = a / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = a, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = (i + n) * o, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[14] = 2 * i * n * o, t1[15] = 0, t1;
                                        };
                                    },
                                    {}
                                ],
                                103: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n) {
                                            var i, a, o, s, l, c, u, f, h, p, d, m, g, v, y, x, b, _, w, T, k, A, M, S, E = n[0], L = n[1], C = n[2], P = Math.sqrt(E * E + L * L + C * C);
                                            if (Math.abs(P) < 1e-6) return null;
                                            E *= P = 1 / P, L *= P, C *= P, i = Math.sin(r), a = Math.cos(r), o = 1 - a, s = e1[0], l = e1[1], c = e1[2], u = e1[3], f = e1[4], h = e1[5], p = e1[6], d = e1[7], m = e1[8], g = e1[9], v = e1[10], y = e1[11], x = E * E * o + a, b = L * E * o + C * i, _ = C * E * o - L * i, w = E * L * o - C * i, T = L * L * o + a, k = C * L * o + E * i, A = E * C * o + L * i, M = L * C * o - E * i, S = C * C * o + a, t1[0] = s * x + f * b + m * _, t1[1] = l * x + h * b + g * _, t1[2] = c * x + p * b + v * _, t1[3] = u * x + d * b + y * _, t1[4] = s * w + f * T + m * k, t1[5] = l * w + h * T + g * k, t1[6] = c * w + p * T + v * k, t1[7] = u * w + d * T + y * k, t1[8] = s * A + f * M + m * S, t1[9] = l * A + h * M + g * S, t1[10] = c * A + p * M + v * S, t1[11] = u * A + d * M + y * S, e1 !== t1 && (t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]);
                                            return t1;
                                        };
                                    },
                                    {}
                                ],
                                104: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = Math.sin(r), i = Math.cos(r), a = e1[4], o = e1[5], s = e1[6], l = e1[7], c = e1[8], u = e1[9], f = e1[10], h = e1[11];
                                            e1 !== t1 && (t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]);
                                            return t1[4] = a * i + c * n, t1[5] = o * i + u * n, t1[6] = s * i + f * n, t1[7] = l * i + h * n, t1[8] = c * i - a * n, t1[9] = u * i - o * n, t1[10] = f * i - s * n, t1[11] = h * i - l * n, t1;
                                        };
                                    },
                                    {}
                                ],
                                105: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], l = e1[3], c = e1[8], u = e1[9], f = e1[10], h = e1[11];
                                            e1 !== t1 && (t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]);
                                            return t1[0] = a * i - c * n, t1[1] = o * i - u * n, t1[2] = s * i - f * n, t1[3] = l * i - h * n, t1[8] = a * n + c * i, t1[9] = o * n + u * i, t1[10] = s * n + f * i, t1[11] = l * n + h * i, t1;
                                        };
                                    },
                                    {}
                                ],
                                106: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = Math.sin(r), i = Math.cos(r), a = e1[0], o = e1[1], s = e1[2], l = e1[3], c = e1[4], u = e1[5], f = e1[6], h = e1[7];
                                            e1 !== t1 && (t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15]);
                                            return t1[0] = a * i + c * n, t1[1] = o * i + u * n, t1[2] = s * i + f * n, t1[3] = l * i + h * n, t1[4] = c * i - a * n, t1[5] = u * i - o * n, t1[6] = f * i - s * n, t1[7] = h * i - l * n, t1;
                                        };
                                    },
                                    {}
                                ],
                                107: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = r[0], i = r[1], a = r[2];
                                            return t1[0] = e1[0] * n, t1[1] = e1[1] * n, t1[2] = e1[2] * n, t1[3] = e1[3] * n, t1[4] = e1[4] * i, t1[5] = e1[5] * i, t1[6] = e1[6] * i, t1[7] = e1[7] * i, t1[8] = e1[8] * a, t1[9] = e1[9] * a, t1[10] = e1[10] * a, t1[11] = e1[11] * a, t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
                                        };
                                    },
                                    {}
                                ],
                                108: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n, i, a, o, s, l, c, u, f, h, p, d, m = r[0], g = r[1], v = r[2];
                                            e1 === t1 ? (t1[12] = e1[0] * m + e1[4] * g + e1[8] * v + e1[12], t1[13] = e1[1] * m + e1[5] * g + e1[9] * v + e1[13], t1[14] = e1[2] * m + e1[6] * g + e1[10] * v + e1[14], t1[15] = e1[3] * m + e1[7] * g + e1[11] * v + e1[15]) : (n = e1[0], i = e1[1], a = e1[2], o = e1[3], s = e1[4], l = e1[5], c = e1[6], u = e1[7], f = e1[8], h = e1[9], p = e1[10], d = e1[11], t1[0] = n, t1[1] = i, t1[2] = a, t1[3] = o, t1[4] = s, t1[5] = l, t1[6] = c, t1[7] = u, t1[8] = f, t1[9] = h, t1[10] = p, t1[11] = d, t1[12] = n * m + s * g + f * v + e1[12], t1[13] = i * m + l * g + h * v + e1[13], t1[14] = a * m + c * g + p * v + e1[14], t1[15] = o * m + u * g + d * v + e1[15]);
                                            return t1;
                                        };
                                    },
                                    {}
                                ],
                                109: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            if (t1 === e1) {
                                                var r = e1[1], n = e1[2], i = e1[3], a = e1[6], o = e1[7], s = e1[11];
                                                t1[1] = e1[4], t1[2] = e1[8], t1[3] = e1[12], t1[4] = r, t1[6] = e1[9], t1[7] = e1[13], t1[8] = n, t1[9] = a, t1[11] = e1[14], t1[12] = i, t1[13] = o, t1[14] = s;
                                            } else t1[0] = e1[0], t1[1] = e1[4], t1[2] = e1[8], t1[3] = e1[12], t1[4] = e1[1], t1[5] = e1[5], t1[6] = e1[9], t1[7] = e1[13], t1[8] = e1[2], t1[9] = e1[6], t1[10] = e1[10], t1[11] = e1[14], t1[12] = e1[3], t1[13] = e1[7], t1[14] = e1[11], t1[15] = e1[15];
                                            return t1;
                                        };
                                    },
                                    {}
                                ],
                                110: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("barycentric"), i = t1("polytope-closest-point/lib/closest_point_2d.js");
                                        function a(t1, e1) {
                                            for(var r = [
                                                0,
                                                0,
                                                0,
                                                0
                                            ], n = 0; n < 4; ++n)for(var i = 0; i < 4; ++i)r[i] += t1[4 * n + i] * e1[n];
                                            return r;
                                        }
                                        function o(t1, e1, r, n, i) {
                                            for(var o = a(n, a(r, a(e1, [
                                                t1[0],
                                                t1[1],
                                                t1[2],
                                                1
                                            ]))), s = 0; s < 3; ++s)o[s] /= o[3];
                                            return [
                                                .5 * i[0] * (1 + o[0]),
                                                .5 * i[1] * (1 - o[1])
                                            ];
                                        }
                                        function s(t1, e1) {
                                            for(var r = [
                                                0,
                                                0,
                                                0
                                            ], n = 0; n < t1.length; ++n)for(var i = t1[n], a = e1[n], o = 0; o < 3; ++o)r[o] += a * i[o];
                                            return r;
                                        }
                                        e1.exports = function(t1, e1, r, a, l, c) {
                                            if (1 === t1.length) return [
                                                0,
                                                t1[0].slice()
                                            ];
                                            for(var u = new Array(t1.length), f = 0; f < t1.length; ++f)u[f] = o(t1[f], r, a, l, c);
                                            var h = 0, p = 1 / 0;
                                            for(f = 0; f < u.length; ++f){
                                                for(var d = 0, m = 0; m < 2; ++m)d += Math.pow(u[f][m] - e1[m], 2);
                                                d < p && (p = d, h = f);
                                            }
                                            var g = function(t1, e1) {
                                                if (2 === t1.length) {
                                                    for(var r = 0, a = 0, o = 0; o < 2; ++o)r += Math.pow(e1[o] - t1[0][o], 2), a += Math.pow(e1[o] - t1[1][o], 2);
                                                    return r = Math.sqrt(r), a = Math.sqrt(a), r + a < 1e-6 ? [
                                                        1,
                                                        0
                                                    ] : [
                                                        a / (r + a),
                                                        r / (a + r)
                                                    ];
                                                }
                                                if (3 === t1.length) {
                                                    var s = [
                                                        0,
                                                        0
                                                    ];
                                                    return i(t1[0], t1[1], t1[2], e1, s), n(t1, s);
                                                }
                                                return [];
                                            }(u, e1), v = 0;
                                            for(f = 0; f < 3; ++f){
                                                if (g[f] < -0.001 || g[f] > 1.0001) return null;
                                                v += g[f];
                                            }
                                            if (Math.abs(v - 1) > .001) return null;
                                            return [
                                                h,
                                                s(t1, g),
                                                g
                                            ];
                                        };
                                    },
                                    {
                                        barycentric: 14,
                                        "polytope-closest-point/lib/closest_point_2d.js": 270
                                    }
                                ],
                                111: [
                                    function(t1, e1, r) {
                                        var n = t1("glslify"), i = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, normal;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model\n           , view\n           , projection\n           , inverseModel;\nuniform vec3 eyePosition\n           , lightPosition;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvec4 project(vec3 p) {\n  return projection * view * model * vec4(p, 1.0);\n}\n\nvoid main() {\n  gl_Position      = project(position);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * vec4(position , 1.0);\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal  = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  f_color          = color;\n  f_data           = position;\n  f_uv             = uv;\n}\n"
                                        ]), a = n([
                                            "#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\n//#pragma glslify: beckmann = require(glsl-specular-beckmann) // used in gl-surface3d\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness\n            , fresnel\n            , kambient\n            , kdiffuse\n            , kspecular;\nuniform sampler2D texture;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (f_color.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], f_data)\n  ) discard;\n\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  //float specular = max(0.0, beckmann(L, V, N, roughness)); // used in gl-surface3d\n\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = vec4(f_color.rgb, 1.0) * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * f_color.a;\n}\n"
                                        ]), o = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model, view, projection;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n  f_color = color;\n  f_data  = position;\n  f_uv    = uv;\n}"
                                        ]), s = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_data)) discard;\n\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"
                                        ]), l = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\nattribute float pointSize;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0 ,0.0 ,0.0);\n  } else {\n    gl_Position = projection * view * model * vec4(position, 1.0);\n  }\n  gl_PointSize = pointSize;\n  f_color = color;\n  f_uv = uv;\n}"
                                        ]), c = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  vec2 pointR = gl_PointCoord.xy - vec2(0.5, 0.5);\n  if(dot(pointR, pointR) > 0.25) {\n    discard;\n  }\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"
                                        ]), u = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n  f_id        = id;\n  f_position  = position;\n}"
                                        ]), f = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"
                                        ]), h = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3  position;\nattribute float pointSize;\nattribute vec4  id;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0, 0.0, 0.0);\n  } else {\n    gl_Position  = projection * view * model * vec4(position, 1.0);\n    gl_PointSize = pointSize;\n  }\n  f_id         = id;\n  f_position   = position;\n}"
                                        ]), p = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n}"
                                        ]), d = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nuniform vec3 contourColor;\n\nvoid main() {\n  gl_FragColor = vec4(contourColor, 1.0);\n}\n"
                                        ]);
                                        r.meshShader = {
                                            vertex: i,
                                            fragment: a,
                                            attributes: [
                                                {
                                                    name: "position",
                                                    type: "vec3"
                                                },
                                                {
                                                    name: "normal",
                                                    type: "vec3"
                                                },
                                                {
                                                    name: "color",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "uv",
                                                    type: "vec2"
                                                }
                                            ]
                                        }, r.wireShader = {
                                            vertex: o,
                                            fragment: s,
                                            attributes: [
                                                {
                                                    name: "position",
                                                    type: "vec3"
                                                },
                                                {
                                                    name: "color",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "uv",
                                                    type: "vec2"
                                                }
                                            ]
                                        }, r.pointShader = {
                                            vertex: l,
                                            fragment: c,
                                            attributes: [
                                                {
                                                    name: "position",
                                                    type: "vec3"
                                                },
                                                {
                                                    name: "color",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "uv",
                                                    type: "vec2"
                                                },
                                                {
                                                    name: "pointSize",
                                                    type: "float"
                                                }
                                            ]
                                        }, r.pickShader = {
                                            vertex: u,
                                            fragment: f,
                                            attributes: [
                                                {
                                                    name: "position",
                                                    type: "vec3"
                                                },
                                                {
                                                    name: "id",
                                                    type: "vec4"
                                                }
                                            ]
                                        }, r.pointPickShader = {
                                            vertex: h,
                                            fragment: f,
                                            attributes: [
                                                {
                                                    name: "position",
                                                    type: "vec3"
                                                },
                                                {
                                                    name: "pointSize",
                                                    type: "float"
                                                },
                                                {
                                                    name: "id",
                                                    type: "vec4"
                                                }
                                            ]
                                        }, r.contourShader = {
                                            vertex: p,
                                            fragment: d,
                                            attributes: [
                                                {
                                                    name: "position",
                                                    type: "vec3"
                                                }
                                            ]
                                        };
                                    },
                                    {
                                        glslify: 231
                                    }
                                ],
                                112: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("gl-shader"), i = t1("gl-buffer"), a = t1("gl-vao"), o = t1("gl-texture2d"), s = t1("normals"), l = t1("gl-mat4/multiply"), c = t1("gl-mat4/invert"), u = t1("ndarray"), f = t1("colormap"), h = t1("simplicial-complex-contour"), p = t1("typedarray-pool"), d = t1("./lib/shaders"), m = t1("./lib/closest-point"), g = d.meshShader, v = d.wireShader, y = d.pointShader, x = d.pickShader, b = d.pointPickShader, _ = d.contourShader, w = [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                        function T(t1, e1, r, n, i, a, o, s, l, c, u, f, h, p, d, m, g, v, y, x, b, _, T, k, A, M, S) {
                                            this.gl = t1, this.pixelRatio = 1, this.cells = [], this.positions = [], this.intensity = [], this.texture = e1, this.dirty = !0, this.triShader = r, this.lineShader = n, this.pointShader = i, this.pickShader = a, this.pointPickShader = o, this.contourShader = s, this.trianglePositions = l, this.triangleColors = u, this.triangleNormals = h, this.triangleUVs = f, this.triangleIds = c, this.triangleVAO = p, this.triangleCount = 0, this.lineWidth = 1, this.edgePositions = d, this.edgeColors = g, this.edgeUVs = v, this.edgeIds = m, this.edgeVAO = y, this.edgeCount = 0, this.pointPositions = x, this.pointColors = _, this.pointUVs = T, this.pointSizes = k, this.pointIds = b, this.pointVAO = A, this.pointCount = 0, this.contourLineWidth = 1, this.contourPositions = M, this.contourVAO = S, this.contourCount = 0, this.contourColor = [
                                                0,
                                                0,
                                                0
                                            ], this.contourEnable = !0, this.pickVertex = !0, this.pickId = 1, this.bounds = [
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ],
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ]
                                            ], this.clipBounds = [
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ],
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ]
                                            ], this.lightPosition = [
                                                1e5,
                                                1e5,
                                                0
                                            ], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.opacity = 1, this.hasAlpha = !1, this.opacityscale = !1, this._model = w, this._view = w, this._projection = w, this._resolution = [
                                                1,
                                                1
                                            ];
                                        }
                                        var k = T.prototype;
                                        function A(t1, e1) {
                                            if (!e1) return 1;
                                            if (!e1.length) return 1;
                                            for(var r = 0; r < e1.length; ++r){
                                                if (e1.length < 2) return 1;
                                                if (e1[r][0] === t1) return e1[r][1];
                                                if (e1[r][0] > t1 && r > 0) {
                                                    var n = (e1[r][0] - t1) / (e1[r][0] - e1[r - 1][0]);
                                                    return e1[r][1] * (1 - n) + n * e1[r - 1][1];
                                                }
                                            }
                                            return 1;
                                        }
                                        function M(t1) {
                                            var e1 = n(t1, g.vertex, g.fragment);
                                            return e1.attributes.position.location = 0, e1.attributes.color.location = 2, e1.attributes.uv.location = 3, e1.attributes.normal.location = 4, e1;
                                        }
                                        function S(t1) {
                                            var e1 = n(t1, v.vertex, v.fragment);
                                            return e1.attributes.position.location = 0, e1.attributes.color.location = 2, e1.attributes.uv.location = 3, e1;
                                        }
                                        function E(t1) {
                                            var e1 = n(t1, y.vertex, y.fragment);
                                            return e1.attributes.position.location = 0, e1.attributes.color.location = 2, e1.attributes.uv.location = 3, e1.attributes.pointSize.location = 4, e1;
                                        }
                                        function L(t1) {
                                            var e1 = n(t1, x.vertex, x.fragment);
                                            return e1.attributes.position.location = 0, e1.attributes.id.location = 1, e1;
                                        }
                                        function C(t1) {
                                            var e1 = n(t1, b.vertex, b.fragment);
                                            return e1.attributes.position.location = 0, e1.attributes.id.location = 1, e1.attributes.pointSize.location = 4, e1;
                                        }
                                        function P(t1) {
                                            var e1 = n(t1, _.vertex, _.fragment);
                                            return e1.attributes.position.location = 0, e1;
                                        }
                                        k.isOpaque = function() {
                                            return !this.hasAlpha;
                                        }, k.isTransparent = function() {
                                            return this.hasAlpha;
                                        }, k.pickSlots = 1, k.setPickBase = function(t1) {
                                            this.pickId = t1;
                                        }, k.highlight = function(t1) {
                                            if (t1 && this.contourEnable) {
                                                for(var e1 = h(this.cells, this.intensity, t1.intensity), r = e1.cells, n = e1.vertexIds, i = e1.vertexWeights, a = r.length, o = p.mallocFloat32(6 * a), s = 0, l = 0; l < a; ++l)for(var c = r[l], u = 0; u < 2; ++u){
                                                    var f = c[0];
                                                    2 === c.length && (f = c[u]);
                                                    for(var d = n[f][0], m = n[f][1], g = i[f], v = 1 - g, y = this.positions[d], x = this.positions[m], b = 0; b < 3; ++b)o[s++] = g * y[b] + v * x[b];
                                                }
                                                this.contourCount = s / 3 | 0, this.contourPositions.update(o.subarray(0, s)), p.free(o);
                                            } else this.contourCount = 0;
                                        }, k.update = function(t1) {
                                            t1 = t1 || {};
                                            var e1 = this.gl;
                                            this.dirty = !0, "contourEnable" in t1 && (this.contourEnable = t1.contourEnable), "contourColor" in t1 && (this.contourColor = t1.contourColor), "lineWidth" in t1 && (this.lineWidth = t1.lineWidth), "lightPosition" in t1 && (this.lightPosition = t1.lightPosition), this.hasAlpha = !1, "opacity" in t1 && (this.opacity = t1.opacity, this.opacity < 1 && (this.hasAlpha = !0)), "opacityscale" in t1 && (this.opacityscale = t1.opacityscale, this.hasAlpha = !0), "ambient" in t1 && (this.ambientLight = t1.ambient), "diffuse" in t1 && (this.diffuseLight = t1.diffuse), "specular" in t1 && (this.specularLight = t1.specular), "roughness" in t1 && (this.roughness = t1.roughness), "fresnel" in t1 && (this.fresnel = t1.fresnel), t1.texture ? (this.texture.dispose(), this.texture = o(e1, t1.texture)) : t1.colormap && (this.texture.shape = [
                                                256,
                                                256
                                            ], this.texture.minFilter = e1.LINEAR_MIPMAP_LINEAR, this.texture.magFilter = e1.LINEAR, this.texture.setPixels(function(t1, e1) {
                                                for(var r = f({
                                                    colormap: t1,
                                                    nshades: 256,
                                                    format: "rgba"
                                                }), n = new Uint8Array(1024), i = 0; i < 256; ++i){
                                                    for(var a = r[i], o = 0; o < 3; ++o)n[4 * i + o] = a[o];
                                                    n[4 * i + 3] = e1 ? 255 * A(i / 255, e1) : 255 * a[3];
                                                }
                                                return u(n, [
                                                    256,
                                                    256,
                                                    4
                                                ], [
                                                    4,
                                                    0,
                                                    1
                                                ]);
                                            }(t1.colormap, this.opacityscale)), this.texture.generateMipmap());
                                            var r = t1.cells, n = t1.positions;
                                            if (n && r) {
                                                var i = [], a = [], l = [], c = [], h = [], p = [], d = [], m = [], g = [], v = [], y = [], x = [], b = [], _ = [];
                                                this.cells = r, this.positions = n;
                                                var w = t1.vertexNormals, T = t1.cellNormals, k = void 0 === t1.vertexNormalsEpsilon ? 1e-6 : t1.vertexNormalsEpsilon, M = void 0 === t1.faceNormalsEpsilon ? 1e-6 : t1.faceNormalsEpsilon;
                                                t1.useFacetNormals && !T && (T = s.faceNormals(r, n, M)), T || w || (w = s.vertexNormals(r, n, k));
                                                var S = t1.vertexColors, E = t1.cellColors, L = t1.meshColor || [
                                                    1,
                                                    1,
                                                    1,
                                                    1
                                                ], C = t1.vertexUVs, P = t1.vertexIntensity, I = t1.cellUVs, O = t1.cellIntensity, z = 1 / 0, D = -1 / 0;
                                                if (!C && !I) {
                                                    if (P) {
                                                        if (t1.vertexIntensityBounds) z = +t1.vertexIntensityBounds[0], D = +t1.vertexIntensityBounds[1];
                                                        else for(var R = 0; R < P.length; ++R){
                                                            var F = P[R];
                                                            z = Math.min(z, F), D = Math.max(D, F);
                                                        }
                                                    } else if (O) {
                                                        if (t1.cellIntensityBounds) z = +t1.cellIntensityBounds[0], D = +t1.cellIntensityBounds[1];
                                                        else for(R = 0; R < O.length; ++R){
                                                            F = O[R];
                                                            z = Math.min(z, F), D = Math.max(D, F);
                                                        }
                                                    } else for(R = 0; R < n.length; ++R){
                                                        F = n[R][2];
                                                        z = Math.min(z, F), D = Math.max(D, F);
                                                    }
                                                }
                                                this.intensity = P || O || function(t1) {
                                                    for(var e1 = t1.length, r = new Array(e1), n = 0; n < e1; ++n)r[n] = t1[n][2];
                                                    return r;
                                                }(n), this.pickVertex = !(O || E);
                                                var B = t1.pointSizes, N = t1.pointSize || 1;
                                                this.bounds = [
                                                    [
                                                        1 / 0,
                                                        1 / 0,
                                                        1 / 0
                                                    ],
                                                    [
                                                        -1 / 0,
                                                        -1 / 0,
                                                        -1 / 0
                                                    ]
                                                ];
                                                for(R = 0; R < n.length; ++R)for(var j = n[R], U = 0; U < 3; ++U)!isNaN(j[U]) && isFinite(j[U]) && (this.bounds[0][U] = Math.min(this.bounds[0][U], j[U]), this.bounds[1][U] = Math.max(this.bounds[1][U], j[U]));
                                                var V = 0, H = 0, q = 0;
                                                t: for(R = 0; R < r.length; ++R){
                                                    var G = r[R];
                                                    switch(G.length){
                                                        case 1:
                                                            for(j = n[W = G[0]], U = 0; U < 3; ++U)if (isNaN(j[U]) || !isFinite(j[U])) continue t;
                                                            v.push(j[0], j[1], j[2]), X = S ? S[W] : E ? E[R] : L, this.opacityscale && P ? a.push(X[0], X[1], X[2], this.opacity * A((P[W] - z) / (D - z), this.opacityscale)) : 3 === X.length ? y.push(X[0], X[1], X[2], this.opacity) : (y.push(X[0], X[1], X[2], X[3] * this.opacity), X[3] < 1 && (this.hasAlpha = !0)), Z = C ? C[W] : P ? [
                                                                (P[W] - z) / (D - z),
                                                                0
                                                            ] : I ? I[R] : O ? [
                                                                (O[R] - z) / (D - z),
                                                                0
                                                            ] : [
                                                                (j[2] - z) / (D - z),
                                                                0
                                                            ], x.push(Z[0], Z[1]), B ? b.push(B[W]) : b.push(N), _.push(R), q += 1;
                                                            break;
                                                        case 2:
                                                            for(U = 0; U < 2; ++U){
                                                                j = n[W = G[U]];
                                                                for(var Y = 0; Y < 3; ++Y)if (isNaN(j[Y]) || !isFinite(j[Y])) continue t;
                                                            }
                                                            for(U = 0; U < 2; ++U){
                                                                j = n[W = G[U]];
                                                                p.push(j[0], j[1], j[2]), X = S ? S[W] : E ? E[R] : L, this.opacityscale && P ? a.push(X[0], X[1], X[2], this.opacity * A((P[W] - z) / (D - z), this.opacityscale)) : 3 === X.length ? d.push(X[0], X[1], X[2], this.opacity) : (d.push(X[0], X[1], X[2], X[3] * this.opacity), X[3] < 1 && (this.hasAlpha = !0)), Z = C ? C[W] : P ? [
                                                                    (P[W] - z) / (D - z),
                                                                    0
                                                                ] : I ? I[R] : O ? [
                                                                    (O[R] - z) / (D - z),
                                                                    0
                                                                ] : [
                                                                    (j[2] - z) / (D - z),
                                                                    0
                                                                ], m.push(Z[0], Z[1]), g.push(R);
                                                            }
                                                            H += 1;
                                                            break;
                                                        case 3:
                                                            for(U = 0; U < 3; ++U)for(j = n[W = G[U]], Y = 0; Y < 3; ++Y)if (isNaN(j[Y]) || !isFinite(j[Y])) continue t;
                                                            for(U = 0; U < 3; ++U){
                                                                var W, X, Z, J;
                                                                j = n[W = G[2 - U]];
                                                                i.push(j[0], j[1], j[2]), (X = S ? S[W] : E ? E[R] : L) ? this.opacityscale && P ? a.push(X[0], X[1], X[2], this.opacity * A((P[W] - z) / (D - z), this.opacityscale)) : 3 === X.length ? a.push(X[0], X[1], X[2], this.opacity) : (a.push(X[0], X[1], X[2], X[3] * this.opacity), X[3] < 1 && (this.hasAlpha = !0)) : a.push(.5, .5, .5, 1), Z = C ? C[W] : P ? [
                                                                    (P[W] - z) / (D - z),
                                                                    0
                                                                ] : I ? I[R] : O ? [
                                                                    (O[R] - z) / (D - z),
                                                                    0
                                                                ] : [
                                                                    (j[2] - z) / (D - z),
                                                                    0
                                                                ], c.push(Z[0], Z[1]), J = w ? w[W] : T[R], l.push(J[0], J[1], J[2]), h.push(R);
                                                            }
                                                            V += 1;
                                                    }
                                                }
                                                this.pointCount = q, this.edgeCount = H, this.triangleCount = V, this.pointPositions.update(v), this.pointColors.update(y), this.pointUVs.update(x), this.pointSizes.update(b), this.pointIds.update(new Uint32Array(_)), this.edgePositions.update(p), this.edgeColors.update(d), this.edgeUVs.update(m), this.edgeIds.update(new Uint32Array(g)), this.trianglePositions.update(i), this.triangleColors.update(a), this.triangleUVs.update(c), this.triangleNormals.update(l), this.triangleIds.update(new Uint32Array(h));
                                            }
                                        }, k.drawTransparent = k.draw = function(t1) {
                                            t1 = t1 || {};
                                            for(var e1 = this.gl, r = t1.model || w, n = t1.view || w, i = t1.projection || w, a = [
                                                [
                                                    -1000000,
                                                    -1000000,
                                                    -1000000
                                                ],
                                                [
                                                    1e6,
                                                    1e6,
                                                    1e6
                                                ]
                                            ], o = 0; o < 3; ++o)a[0][o] = Math.max(a[0][o], this.clipBounds[0][o]), a[1][o] = Math.min(a[1][o], this.clipBounds[1][o]);
                                            var s = {
                                                model: r,
                                                view: n,
                                                projection: i,
                                                inverseModel: w.slice(),
                                                clipBounds: a,
                                                kambient: this.ambientLight,
                                                kdiffuse: this.diffuseLight,
                                                kspecular: this.specularLight,
                                                roughness: this.roughness,
                                                fresnel: this.fresnel,
                                                eyePosition: [
                                                    0,
                                                    0,
                                                    0
                                                ],
                                                lightPosition: [
                                                    0,
                                                    0,
                                                    0
                                                ],
                                                contourColor: this.contourColor,
                                                texture: 0
                                            };
                                            s.inverseModel = c(s.inverseModel, s.model), e1.disable(e1.CULL_FACE), this.texture.bind(0);
                                            var u = new Array(16);
                                            l(u, s.view, s.model), l(u, s.projection, u), c(u, u);
                                            for(o = 0; o < 3; ++o)s.eyePosition[o] = u[12 + o] / u[15];
                                            var f, h = u[15];
                                            for(o = 0; o < 3; ++o)h += this.lightPosition[o] * u[4 * o + 3];
                                            for(o = 0; o < 3; ++o){
                                                for(var p = u[12 + o], d = 0; d < 3; ++d)p += u[4 * d + o] * this.lightPosition[d];
                                                s.lightPosition[o] = p / h;
                                            }
                                            this.triangleCount > 0 && ((f = this.triShader).bind(), f.uniforms = s, this.triangleVAO.bind(), e1.drawArrays(e1.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind());
                                            this.edgeCount > 0 && this.lineWidth > 0 && ((f = this.lineShader).bind(), f.uniforms = s, this.edgeVAO.bind(), e1.lineWidth(this.lineWidth * this.pixelRatio), e1.drawArrays(e1.LINES, 0, 2 * this.edgeCount), this.edgeVAO.unbind());
                                            this.pointCount > 0 && ((f = this.pointShader).bind(), f.uniforms = s, this.pointVAO.bind(), e1.drawArrays(e1.POINTS, 0, this.pointCount), this.pointVAO.unbind());
                                            this.contourEnable && this.contourCount > 0 && this.contourLineWidth > 0 && ((f = this.contourShader).bind(), f.uniforms = s, this.contourVAO.bind(), e1.drawArrays(e1.LINES, 0, this.contourCount), this.contourVAO.unbind());
                                        }, k.drawPick = function(t1) {
                                            t1 = t1 || {};
                                            for(var e1 = this.gl, r = t1.model || w, n = t1.view || w, i = t1.projection || w, a = [
                                                [
                                                    -1000000,
                                                    -1000000,
                                                    -1000000
                                                ],
                                                [
                                                    1e6,
                                                    1e6,
                                                    1e6
                                                ]
                                            ], o = 0; o < 3; ++o)a[0][o] = Math.max(a[0][o], this.clipBounds[0][o]), a[1][o] = Math.min(a[1][o], this.clipBounds[1][o]);
                                            this._model = [].slice.call(r), this._view = [].slice.call(n), this._projection = [].slice.call(i), this._resolution = [
                                                e1.drawingBufferWidth,
                                                e1.drawingBufferHeight
                                            ];
                                            var s, l = {
                                                model: r,
                                                view: n,
                                                projection: i,
                                                clipBounds: a,
                                                pickId: this.pickId / 255
                                            };
                                            ((s = this.pickShader).bind(), s.uniforms = l, this.triangleCount > 0 && (this.triangleVAO.bind(), e1.drawArrays(e1.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind()), this.edgeCount > 0 && (this.edgeVAO.bind(), e1.lineWidth(this.lineWidth * this.pixelRatio), e1.drawArrays(e1.LINES, 0, 2 * this.edgeCount), this.edgeVAO.unbind()), this.pointCount > 0) && ((s = this.pointPickShader).bind(), s.uniforms = l, this.pointVAO.bind(), e1.drawArrays(e1.POINTS, 0, this.pointCount), this.pointVAO.unbind());
                                        }, k.pick = function(t1) {
                                            if (!t1) return null;
                                            if (t1.id !== this.pickId) return null;
                                            for(var e1 = t1.value[0] + 256 * t1.value[1] + 65536 * t1.value[2], r = this.cells[e1], n = this.positions, i = new Array(r.length), a = 0; a < r.length; ++a)i[a] = n[r[a]];
                                            var o = t1.coord[0], s = t1.coord[1];
                                            if (!this.pickVertex) {
                                                var l = this.positions[r[0]], c = this.positions[r[1]], u = this.positions[r[2]], f = [
                                                    (l[0] + c[0] + u[0]) / 3,
                                                    (l[1] + c[1] + u[1]) / 3,
                                                    (l[2] + c[2] + u[2]) / 3
                                                ];
                                                return {
                                                    _cellCenter: !0,
                                                    position: [
                                                        o,
                                                        s
                                                    ],
                                                    index: e1,
                                                    cell: r,
                                                    cellId: e1,
                                                    intensity: this.intensity[e1],
                                                    dataCoordinate: f
                                                };
                                            }
                                            var h = m(i, [
                                                o * this.pixelRatio,
                                                this._resolution[1] - s * this.pixelRatio
                                            ], this._model, this._view, this._projection, this._resolution);
                                            if (!h) return null;
                                            var p = h[2], d = 0;
                                            for(a = 0; a < r.length; ++a)d += p[a] * this.intensity[r[a]];
                                            return {
                                                position: h[1],
                                                index: r[h[0]],
                                                cell: r,
                                                cellId: e1,
                                                intensity: d,
                                                dataCoordinate: this.positions[r[h[0]]]
                                            };
                                        }, k.dispose = function() {
                                            this.texture.dispose(), this.triShader.dispose(), this.lineShader.dispose(), this.pointShader.dispose(), this.pickShader.dispose(), this.pointPickShader.dispose(), this.triangleVAO.dispose(), this.trianglePositions.dispose(), this.triangleColors.dispose(), this.triangleUVs.dispose(), this.triangleNormals.dispose(), this.triangleIds.dispose(), this.edgeVAO.dispose(), this.edgePositions.dispose(), this.edgeColors.dispose(), this.edgeUVs.dispose(), this.edgeIds.dispose(), this.pointVAO.dispose(), this.pointPositions.dispose(), this.pointColors.dispose(), this.pointUVs.dispose(), this.pointSizes.dispose(), this.pointIds.dispose(), this.contourVAO.dispose(), this.contourPositions.dispose(), this.contourShader.dispose();
                                        }, e1.exports = function(t1, e1) {
                                            1 === arguments.length && (t1 = (e1 = t1).gl);
                                            var r = t1.getExtension("OES_standard_derivatives") || t1.getExtension("MOZ_OES_standard_derivatives") || t1.getExtension("WEBKIT_OES_standard_derivatives");
                                            if (!r) throw new Error("derivatives not supported");
                                            var n = M(t1), s = S(t1), l = E(t1), c = L(t1), f = C(t1), h = P(t1), p = o(t1, u(new Uint8Array([
                                                255,
                                                255,
                                                255,
                                                255
                                            ]), [
                                                1,
                                                1,
                                                4
                                            ]));
                                            p.generateMipmap(), p.minFilter = t1.LINEAR_MIPMAP_LINEAR, p.magFilter = t1.LINEAR;
                                            var d = i(t1), m = i(t1), g = i(t1), v = i(t1), y = i(t1), x = a(t1, [
                                                {
                                                    buffer: d,
                                                    type: t1.FLOAT,
                                                    size: 3
                                                },
                                                {
                                                    buffer: y,
                                                    type: t1.UNSIGNED_BYTE,
                                                    size: 4,
                                                    normalized: !0
                                                },
                                                {
                                                    buffer: m,
                                                    type: t1.FLOAT,
                                                    size: 4
                                                },
                                                {
                                                    buffer: g,
                                                    type: t1.FLOAT,
                                                    size: 2
                                                },
                                                {
                                                    buffer: v,
                                                    type: t1.FLOAT,
                                                    size: 3
                                                }
                                            ]), b = i(t1), _ = i(t1), w = i(t1), k = i(t1), A = a(t1, [
                                                {
                                                    buffer: b,
                                                    type: t1.FLOAT,
                                                    size: 3
                                                },
                                                {
                                                    buffer: k,
                                                    type: t1.UNSIGNED_BYTE,
                                                    size: 4,
                                                    normalized: !0
                                                },
                                                {
                                                    buffer: _,
                                                    type: t1.FLOAT,
                                                    size: 4
                                                },
                                                {
                                                    buffer: w,
                                                    type: t1.FLOAT,
                                                    size: 2
                                                }
                                            ]), I = i(t1), O = i(t1), z = i(t1), D = i(t1), R = i(t1), F = a(t1, [
                                                {
                                                    buffer: I,
                                                    type: t1.FLOAT,
                                                    size: 3
                                                },
                                                {
                                                    buffer: R,
                                                    type: t1.UNSIGNED_BYTE,
                                                    size: 4,
                                                    normalized: !0
                                                },
                                                {
                                                    buffer: O,
                                                    type: t1.FLOAT,
                                                    size: 4
                                                },
                                                {
                                                    buffer: z,
                                                    type: t1.FLOAT,
                                                    size: 2
                                                },
                                                {
                                                    buffer: D,
                                                    type: t1.FLOAT,
                                                    size: 1
                                                }
                                            ]), B = i(t1), N = a(t1, [
                                                {
                                                    buffer: B,
                                                    type: t1.FLOAT,
                                                    size: 3
                                                }
                                            ]), j = new T(t1, p, n, s, l, c, f, h, d, y, m, g, v, x, b, k, _, w, A, I, R, O, z, D, F, B, N);
                                            return j.update(e1), j;
                                        };
                                    },
                                    {
                                        "./lib/closest-point": 110,
                                        "./lib/shaders": 111,
                                        colormap: 53,
                                        "gl-buffer": 78,
                                        "gl-mat4/invert": 98,
                                        "gl-mat4/multiply": 100,
                                        "gl-shader": 132,
                                        "gl-texture2d": 146,
                                        "gl-vao": 150,
                                        ndarray: 259,
                                        normals: 261,
                                        "simplicial-complex-contour": 291,
                                        "typedarray-pool": 308
                                    }
                                ],
                                113: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = t1.gl, r = n(e1, [
                                                0,
                                                0,
                                                0,
                                                1,
                                                1,
                                                0,
                                                1,
                                                1
                                            ]), s = i(e1, a.boxVert, a.lineFrag);
                                            return new o(t1, r, s);
                                        };
                                        var n = t1("gl-buffer"), i = t1("gl-shader"), a = t1("./shaders");
                                        function o(t1, e1, r) {
                                            this.plot = t1, this.vbo = e1, this.shader = r;
                                        }
                                        var s, l, c = o.prototype;
                                        c.bind = function() {
                                            var t1 = this.shader;
                                            this.vbo.bind(), this.shader.bind(), t1.attributes.coord.pointer(), t1.uniforms.screenBox = this.plot.screenBox;
                                        }, c.drawBox = (s = [
                                            0,
                                            0
                                        ], l = [
                                            0,
                                            0
                                        ], function(t1, e1, r, n, i) {
                                            var a = this.plot, o = this.shader, c = a.gl;
                                            s[0] = t1, s[1] = e1, l[0] = r, l[1] = n, o.uniforms.lo = s, o.uniforms.hi = l, o.uniforms.color = i, c.drawArrays(c.TRIANGLE_STRIP, 0, 4);
                                        }), c.dispose = function() {
                                            this.vbo.dispose(), this.shader.dispose();
                                        };
                                    },
                                    {
                                        "./shaders": 116,
                                        "gl-buffer": 78,
                                        "gl-shader": 132
                                    }
                                ],
                                114: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = t1.gl, r = n(e1), a = i(e1, o.gridVert, o.gridFrag), l = i(e1, o.tickVert, o.gridFrag);
                                            return new s(t1, r, a, l);
                                        };
                                        var n = t1("gl-buffer"), i = t1("gl-shader"), a = t1("binary-search-bounds"), o = t1("./shaders");
                                        function s(t1, e1, r, n) {
                                            this.plot = t1, this.vbo = e1, this.shader = r, this.tickShader = n, this.ticks = [
                                                [],
                                                []
                                            ];
                                        }
                                        function l(t1, e1) {
                                            return t1 - e1;
                                        }
                                        var c, u, f, h, p, d = s.prototype;
                                        d.draw = (c = [
                                            0,
                                            0
                                        ], u = [
                                            0,
                                            0
                                        ], f = [
                                            0,
                                            0
                                        ], function() {
                                            for(var t1 = this.plot, e1 = this.vbo, r = this.shader, n = this.ticks, i = t1.gl, a = t1._tickBounds, o = t1.dataBox, s = t1.viewBox, l = t1.gridLineWidth, h = t1.gridLineColor, p = t1.gridLineEnable, d = t1.pixelRatio, m = 0; m < 2; ++m){
                                                var g = a[m], v = a[m + 2] - g, y = .5 * (o[m + 2] + o[m]), x = o[m + 2] - o[m];
                                                u[m] = 2 * v / x, c[m] = 2 * (g - y) / x;
                                            }
                                            r.bind(), e1.bind(), r.attributes.dataCoord.pointer(), r.uniforms.dataShift = c, r.uniforms.dataScale = u;
                                            var b = 0;
                                            for(m = 0; m < 2; ++m){
                                                f[0] = f[1] = 0, f[m] = 1, r.uniforms.dataAxis = f, r.uniforms.lineWidth = l[m] / (s[m + 2] - s[m]) * d, r.uniforms.color = h[m];
                                                var _ = 6 * n[m].length;
                                                p[m] && _ && i.drawArrays(i.TRIANGLES, b, _), b += _;
                                            }
                                        }), d.drawTickMarks = function() {
                                            var t1 = [
                                                0,
                                                0
                                            ], e1 = [
                                                0,
                                                0
                                            ], r = [
                                                1,
                                                0
                                            ], n = [
                                                0,
                                                1
                                            ], i = [
                                                0,
                                                0
                                            ], o = [
                                                0,
                                                0
                                            ];
                                            return function() {
                                                for(var s = this.plot, c = this.vbo, u = this.tickShader, f = this.ticks, h = s.gl, p = s._tickBounds, d = s.dataBox, m = s.viewBox, g = s.pixelRatio, v = s.screenBox, y = v[2] - v[0], x = v[3] - v[1], b = m[2] - m[0], _ = m[3] - m[1], w = 0; w < 2; ++w){
                                                    var T = p[w], k = p[w + 2] - T, A = .5 * (d[w + 2] + d[w]), M = d[w + 2] - d[w];
                                                    e1[w] = 2 * k / M, t1[w] = 2 * (T - A) / M;
                                                }
                                                e1[0] *= b / y, t1[0] *= b / y, e1[1] *= _ / x, t1[1] *= _ / x, u.bind(), c.bind(), u.attributes.dataCoord.pointer();
                                                var S = u.uniforms;
                                                S.dataShift = t1, S.dataScale = e1;
                                                var E = s.tickMarkLength, L = s.tickMarkWidth, C = s.tickMarkColor, P = 6 * f[0].length, I = Math.min(a.ge(f[0], (d[0] - p[0]) / (p[2] - p[0]), l), f[0].length), O = Math.min(a.gt(f[0], (d[2] - p[0]) / (p[2] - p[0]), l), f[0].length), z = 0 + 6 * I, D = 6 * Math.max(0, O - I), R = Math.min(a.ge(f[1], (d[1] - p[1]) / (p[3] - p[1]), l), f[1].length), F = Math.min(a.gt(f[1], (d[3] - p[1]) / (p[3] - p[1]), l), f[1].length), B = P + 6 * R, N = 6 * Math.max(0, F - R);
                                                i[0] = 2 * (m[0] - E[1]) / y - 1, i[1] = (m[3] + m[1]) / x - 1, o[0] = E[1] * g / y, o[1] = L[1] * g / x, N && (S.color = C[1], S.tickScale = o, S.dataAxis = n, S.screenOffset = i, h.drawArrays(h.TRIANGLES, B, N)), i[0] = (m[2] + m[0]) / y - 1, i[1] = 2 * (m[1] - E[0]) / x - 1, o[0] = L[0] * g / y, o[1] = E[0] * g / x, D && (S.color = C[0], S.tickScale = o, S.dataAxis = r, S.screenOffset = i, h.drawArrays(h.TRIANGLES, z, D)), i[0] = 2 * (m[2] + E[3]) / y - 1, i[1] = (m[3] + m[1]) / x - 1, o[0] = E[3] * g / y, o[1] = L[3] * g / x, N && (S.color = C[3], S.tickScale = o, S.dataAxis = n, S.screenOffset = i, h.drawArrays(h.TRIANGLES, B, N)), i[0] = (m[2] + m[0]) / y - 1, i[1] = 2 * (m[3] + E[2]) / x - 1, o[0] = L[2] * g / y, o[1] = E[2] * g / x, D && (S.color = C[2], S.tickScale = o, S.dataAxis = r, S.screenOffset = i, h.drawArrays(h.TRIANGLES, z, D));
                                            };
                                        }(), d.update = (h = [
                                            1,
                                            1,
                                            -1,
                                            -1,
                                            1,
                                            -1
                                        ], p = [
                                            1,
                                            -1,
                                            1,
                                            1,
                                            -1,
                                            -1
                                        ], function(t1) {
                                            for(var e1 = t1.ticks, r = t1.bounds, n = new Float32Array(18 * (e1[0].length + e1[1].length)), i = (this.plot.zeroLineEnable, 0), a = [
                                                [],
                                                []
                                            ], o = 0; o < 2; ++o)for(var s = a[o], l = e1[o], c = r[o], u = r[o + 2], f = 0; f < l.length; ++f){
                                                var d = (l[f].x - c) / (u - c);
                                                s.push(d);
                                                for(var m = 0; m < 6; ++m)n[i++] = d, n[i++] = h[m], n[i++] = p[m];
                                            }
                                            this.ticks = a, this.vbo.update(n);
                                        }), d.dispose = function() {
                                            this.vbo.dispose(), this.shader.dispose(), this.tickShader.dispose();
                                        };
                                    },
                                    {
                                        "./shaders": 116,
                                        "binary-search-bounds": 31,
                                        "gl-buffer": 78,
                                        "gl-shader": 132
                                    }
                                ],
                                115: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = t1.gl, r = n(e1, [
                                                -1,
                                                -1,
                                                -1,
                                                1,
                                                1,
                                                -1,
                                                1,
                                                1
                                            ]), s = i(e1, a.lineVert, a.lineFrag);
                                            return new o(t1, r, s);
                                        };
                                        var n = t1("gl-buffer"), i = t1("gl-shader"), a = t1("./shaders");
                                        function o(t1, e1, r) {
                                            this.plot = t1, this.vbo = e1, this.shader = r;
                                        }
                                        var s, l, c = o.prototype;
                                        c.bind = function() {
                                            var t1 = this.shader;
                                            this.vbo.bind(), this.shader.bind(), t1.attributes.coord.pointer(), t1.uniforms.screenBox = this.plot.screenBox;
                                        }, c.drawLine = (s = [
                                            0,
                                            0
                                        ], l = [
                                            0,
                                            0
                                        ], function(t1, e1, r, n, i, a) {
                                            var o = this.plot, c = this.shader, u = o.gl;
                                            s[0] = t1, s[1] = e1, l[0] = r, l[1] = n, c.uniforms.start = s, c.uniforms.end = l, c.uniforms.width = i * o.pixelRatio, c.uniforms.color = a, u.drawArrays(u.TRIANGLE_STRIP, 0, 4);
                                        }), c.dispose = function() {
                                            this.vbo.dispose(), this.shader.dispose();
                                        };
                                    },
                                    {
                                        "./shaders": 116,
                                        "gl-buffer": 78,
                                        "gl-shader": 132
                                    }
                                ],
                                116: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("glslify"), i = n([
                                            "precision lowp float;\n#define GLSLIFY 1\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = vec4(color.xyz * color.w, color.w);\n}\n"
                                        ]);
                                        e1.exports = {
                                            lineVert: n([
                                                "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 start, end;\nuniform float width;\n\nvec2 perp(vec2 v) {\n  return vec2(v.y, -v.x);\n}\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  vec2 delta = normalize(perp(start - end));\n  vec2 offset = mix(start, end, 0.5 * (coord.y+1.0));\n  gl_Position = vec4(screen(offset + 0.5 * width * delta * coord.x), 0, 1);\n}\n"
                                            ]),
                                            lineFrag: i,
                                            textVert: n([
                                                "#define GLSLIFY 1\nattribute vec3 textCoordinate;\n\nuniform vec2 dataScale, dataShift, dataAxis, screenOffset, textScale;\nuniform float angle;\n\nvoid main() {\n  float dataOffset  = textCoordinate.z;\n  vec2 glyphOffset  = textCoordinate.xy;\n  mat2 glyphMatrix = mat2(cos(angle), sin(angle), -sin(angle), cos(angle));\n  vec2 screenCoordinate = dataAxis * (dataScale * dataOffset + dataShift) +\n    glyphMatrix * glyphOffset * textScale + screenOffset;\n  gl_Position = vec4(screenCoordinate, 0, 1);\n}\n"
                                            ]),
                                            textFrag: i,
                                            gridVert: n([
                                                "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale;\nuniform float lineWidth;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  pos += 10.0 * dataCoord.y * vec2(dataAxis.y, -dataAxis.x) + dataCoord.z * lineWidth;\n  gl_Position = vec4(pos, 0, 1);\n}\n"
                                            ]),
                                            gridFrag: i,
                                            boxVert: n([
                                                "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 lo, hi;\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  gl_Position = vec4(screen(mix(lo, hi, coord)), 0, 1);\n}\n"
                                            ]),
                                            tickVert: n([
                                                "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale, screenOffset, tickScale;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  gl_Position = vec4(pos + tickScale*dataCoord.yz + screenOffset, 0, 1);\n}\n"
                                            ])
                                        };
                                    },
                                    {
                                        glslify: 231
                                    }
                                ],
                                117: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = t1.gl, r = n(e1), a = i(e1, s.textVert, s.textFrag);
                                            return new l(t1, r, a);
                                        };
                                        var n = t1("gl-buffer"), i = t1("gl-shader"), a = t1("text-cache"), o = t1("binary-search-bounds"), s = t1("./shaders");
                                        function l(t1, e1, r) {
                                            this.plot = t1, this.vbo = e1, this.shader = r, this.tickOffset = [
                                                [],
                                                []
                                            ], this.tickX = [
                                                [],
                                                []
                                            ], this.labelOffset = [
                                                0,
                                                0
                                            ], this.labelCount = [
                                                0,
                                                0
                                            ];
                                        }
                                        var c, u, f, h, p, d, m = l.prototype;
                                        m.drawTicks = (c = [
                                            0,
                                            0
                                        ], u = [
                                            0,
                                            0
                                        ], f = [
                                            0,
                                            0
                                        ], function(t1) {
                                            var e1 = this.plot, r = this.shader, n = this.tickX[t1], i = this.tickOffset[t1], a = e1.gl, s = e1.viewBox, l = e1.dataBox, h = e1.screenBox, p = e1.pixelRatio, d = e1.tickEnable, m = e1.tickPad, g = e1.tickColor, v = e1.tickAngle, y = e1.labelEnable, x = e1.labelPad, b = e1.labelColor, _ = e1.labelAngle, w = this.labelOffset[t1], T = this.labelCount[t1], k = o.lt(n, l[t1]), A = o.le(n, l[t1 + 2]);
                                            c[0] = c[1] = 0, c[t1] = 1, u[t1] = (s[2 + t1] + s[t1]) / (h[2 + t1] - h[t1]) - 1;
                                            var M = 2 / h[2 + (1 ^ t1)] - h[1 ^ t1];
                                            u[1 ^ t1] = M * s[1 ^ t1] - 1, d[t1] && (u[1 ^ t1] -= M * p * m[t1], k < A && i[A] > i[k] && (r.uniforms.dataAxis = c, r.uniforms.screenOffset = u, r.uniforms.color = g[t1], r.uniforms.angle = v[t1], a.drawArrays(a.TRIANGLES, i[k], i[A] - i[k]))), y[t1] && T && (u[1 ^ t1] -= M * p * x[t1], r.uniforms.dataAxis = f, r.uniforms.screenOffset = u, r.uniforms.color = b[t1], r.uniforms.angle = _[t1], a.drawArrays(a.TRIANGLES, w, T)), u[1 ^ t1] = M * s[2 + (1 ^ t1)] - 1, d[t1 + 2] && (u[1 ^ t1] += M * p * m[t1 + 2], k < A && i[A] > i[k] && (r.uniforms.dataAxis = c, r.uniforms.screenOffset = u, r.uniforms.color = g[t1 + 2], r.uniforms.angle = v[t1 + 2], a.drawArrays(a.TRIANGLES, i[k], i[A] - i[k]))), y[t1 + 2] && T && (u[1 ^ t1] += M * p * x[t1 + 2], r.uniforms.dataAxis = f, r.uniforms.screenOffset = u, r.uniforms.color = b[t1 + 2], r.uniforms.angle = _[t1 + 2], a.drawArrays(a.TRIANGLES, w, T));
                                        }), m.drawTitle = function() {
                                            var t1 = [
                                                0,
                                                0
                                            ], e1 = [
                                                0,
                                                0
                                            ];
                                            return function() {
                                                var r = this.plot, n = this.shader, i = r.gl, a = r.screenBox, o = r.titleCenter, s = r.titleAngle, l = r.titleColor, c = r.pixelRatio;
                                                if (this.titleCount) {
                                                    for(var u = 0; u < 2; ++u)e1[u] = 2 * (o[u] * c - a[u]) / (a[2 + u] - a[u]) - 1;
                                                    n.bind(), n.uniforms.dataAxis = t1, n.uniforms.screenOffset = e1, n.uniforms.angle = s, n.uniforms.color = l, i.drawArrays(i.TRIANGLES, this.titleOffset, this.titleCount);
                                                }
                                            };
                                        }(), m.bind = (h = [
                                            0,
                                            0
                                        ], p = [
                                            0,
                                            0
                                        ], d = [
                                            0,
                                            0
                                        ], function() {
                                            var t1 = this.plot, e1 = this.shader, r = t1._tickBounds, n = t1.dataBox, i = t1.screenBox, a = t1.viewBox;
                                            e1.bind();
                                            for(var o = 0; o < 2; ++o){
                                                var s = r[o], l = r[o + 2] - s, c = .5 * (n[o + 2] + n[o]), u = n[o + 2] - n[o], f = a[o], m = a[o + 2] - f, g = i[o], v = i[o + 2] - g;
                                                p[o] = 2 * l / u * m / v, h[o] = 2 * (s - c) / u * m / v;
                                            }
                                            d[1] = 2 * t1.pixelRatio / (i[3] - i[1]), d[0] = d[1] * (i[3] - i[1]) / (i[2] - i[0]), e1.uniforms.dataScale = p, e1.uniforms.dataShift = h, e1.uniforms.textScale = d, this.vbo.bind(), e1.attributes.textCoordinate.pointer();
                                        }), m.update = function(t1) {
                                            var e1, r, n, i, o, s = [], l = t1.ticks, c = t1.bounds;
                                            for(o = 0; o < 2; ++o){
                                                var u = [
                                                    Math.floor(s.length / 3)
                                                ], f = [
                                                    -1 / 0
                                                ], h = l[o];
                                                for(e1 = 0; e1 < h.length; ++e1){
                                                    var p = h[e1], d = p.x, m = p.text, g = p.font || "sans-serif";
                                                    i = p.fontSize || 12;
                                                    for(var v = 1 / (c[o + 2] - c[o]), y = c[o], x = m.split("\n"), b = 0; b < x.length; b++)for(n = a(g, x[b]).data, r = 0; r < n.length; r += 2)s.push(n[r] * i, -n[r + 1] * i - b * i * 1.2, (d - y) * v);
                                                    u.push(Math.floor(s.length / 3)), f.push(d);
                                                }
                                                this.tickOffset[o] = u, this.tickX[o] = f;
                                            }
                                            for(o = 0; o < 2; ++o){
                                                for(this.labelOffset[o] = Math.floor(s.length / 3), n = a(t1.labelFont[o], t1.labels[o], {
                                                    textAlign: "center"
                                                }).data, i = t1.labelSize[o], e1 = 0; e1 < n.length; e1 += 2)s.push(n[e1] * i, -n[e1 + 1] * i, 0);
                                                this.labelCount[o] = Math.floor(s.length / 3) - this.labelOffset[o];
                                            }
                                            for(this.titleOffset = Math.floor(s.length / 3), n = a(t1.titleFont, t1.title).data, i = t1.titleSize, e1 = 0; e1 < n.length; e1 += 2)s.push(n[e1] * i, -n[e1 + 1] * i, 0);
                                            this.titleCount = Math.floor(s.length / 3) - this.titleOffset, this.vbo.update(s);
                                        }, m.dispose = function() {
                                            this.vbo.dispose(), this.shader.dispose();
                                        };
                                    },
                                    {
                                        "./shaders": 116,
                                        "binary-search-bounds": 31,
                                        "gl-buffer": 78,
                                        "gl-shader": 132,
                                        "text-cache": 303
                                    }
                                ],
                                118: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = t1.gl, r = n(e1, [
                                                e1.drawingBufferWidth,
                                                e1.drawingBufferHeight
                                            ]), c = new l(e1, r);
                                            return c.grid = i(c), c.text = a(c), c.line = o(c), c.box = s(c), c.update(t1), c;
                                        };
                                        var n = t1("gl-select-static"), i = t1("./lib/grid"), a = t1("./lib/text"), o = t1("./lib/line"), s = t1("./lib/box");
                                        function l(t1, e1) {
                                            this.gl = t1, this.pickBuffer = e1, this.screenBox = [
                                                0,
                                                0,
                                                t1.drawingBufferWidth,
                                                t1.drawingBufferHeight
                                            ], this.viewBox = [
                                                0,
                                                0,
                                                0,
                                                0
                                            ], this.dataBox = [
                                                -10,
                                                -10,
                                                10,
                                                10
                                            ], this.gridLineEnable = [
                                                !0,
                                                !0
                                            ], this.gridLineWidth = [
                                                1,
                                                1
                                            ], this.gridLineColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.pixelRatio = 1, this.tickMarkLength = [
                                                0,
                                                0,
                                                0,
                                                0
                                            ], this.tickMarkWidth = [
                                                0,
                                                0,
                                                0,
                                                0
                                            ], this.tickMarkColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.tickPad = [
                                                15,
                                                15,
                                                15,
                                                15
                                            ], this.tickAngle = [
                                                0,
                                                0,
                                                0,
                                                0
                                            ], this.tickEnable = [
                                                !0,
                                                !0,
                                                !0,
                                                !0
                                            ], this.tickColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.labelPad = [
                                                15,
                                                15,
                                                15,
                                                15
                                            ], this.labelAngle = [
                                                0,
                                                Math.PI / 2,
                                                0,
                                                3 * Math.PI / 2
                                            ], this.labelEnable = [
                                                !0,
                                                !0,
                                                !0,
                                                !0
                                            ], this.labelColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.titleCenter = [
                                                0,
                                                0
                                            ], this.titleEnable = !0, this.titleAngle = 0, this.titleColor = [
                                                0,
                                                0,
                                                0,
                                                1
                                            ], this.borderColor = [
                                                0,
                                                0,
                                                0,
                                                0
                                            ], this.backgroundColor = [
                                                0,
                                                0,
                                                0,
                                                0
                                            ], this.zeroLineEnable = [
                                                !0,
                                                !0
                                            ], this.zeroLineWidth = [
                                                4,
                                                4
                                            ], this.zeroLineColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.borderLineEnable = [
                                                !0,
                                                !0,
                                                !0,
                                                !0
                                            ], this.borderLineWidth = [
                                                2,
                                                2,
                                                2,
                                                2
                                            ], this.borderLineColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.grid = null, this.text = null, this.line = null, this.box = null, this.objects = [], this.overlays = [], this._tickBounds = [
                                                1 / 0,
                                                1 / 0,
                                                -1 / 0,
                                                -1 / 0
                                            ], this.static = !1, this.dirty = !1, this.pickDirty = !1, this.pickDelay = 120, this.pickRadius = 10, this._pickTimeout = null, this._drawPick = this.drawPick.bind(this), this._depthCounter = 0;
                                        }
                                        var c = l.prototype;
                                        function u(t1) {
                                            for(var e1 = t1.slice(), r = 0; r < e1.length; ++r)e1[r] = e1[r].slice();
                                            return e1;
                                        }
                                        function f(t1, e1) {
                                            return t1.x - e1.x;
                                        }
                                        c.setDirty = function() {
                                            this.dirty = this.pickDirty = !0;
                                        }, c.setOverlayDirty = function() {
                                            this.dirty = !0;
                                        }, c.nextDepthValue = function() {
                                            return this._depthCounter++ / 65536;
                                        }, c.draw = function() {
                                            var t1 = this.gl, e1 = this.screenBox, r = this.viewBox, n = this.dataBox, i = this.pixelRatio, a = this.grid, o = this.line, s = this.text, l = this.objects;
                                            if (this._depthCounter = 0, this.pickDirty && (this._pickTimeout && clearTimeout(this._pickTimeout), this.pickDirty = !1, this._pickTimeout = setTimeout(this._drawPick, this.pickDelay)), this.dirty) {
                                                if (this.dirty = !1, t1.bindFramebuffer(t1.FRAMEBUFFER, null), t1.enable(t1.SCISSOR_TEST), t1.disable(t1.DEPTH_TEST), t1.depthFunc(t1.LESS), t1.depthMask(!1), t1.enable(t1.BLEND), t1.blendEquation(t1.FUNC_ADD, t1.FUNC_ADD), t1.blendFunc(t1.ONE, t1.ONE_MINUS_SRC_ALPHA), this.borderColor) {
                                                    t1.scissor(e1[0], e1[1], e1[2] - e1[0], e1[3] - e1[1]);
                                                    var c = this.borderColor;
                                                    t1.clearColor(c[0] * c[3], c[1] * c[3], c[2] * c[3], c[3]), t1.clear(t1.COLOR_BUFFER_BIT | t1.DEPTH_BUFFER_BIT);
                                                }
                                                t1.scissor(r[0], r[1], r[2] - r[0], r[3] - r[1]), t1.viewport(r[0], r[1], r[2] - r[0], r[3] - r[1]);
                                                var u = this.backgroundColor;
                                                t1.clearColor(u[0] * u[3], u[1] * u[3], u[2] * u[3], u[3]), t1.clear(t1.COLOR_BUFFER_BIT), a.draw();
                                                var f = this.zeroLineEnable, h = this.zeroLineColor, p = this.zeroLineWidth;
                                                if (f[0] || f[1]) {
                                                    o.bind();
                                                    for(var d = 0; d < 2; ++d)if (f[d] && n[d] <= 0 && n[d + 2] >= 0) {
                                                        var m = e1[d] - n[d] * (e1[d + 2] - e1[d]) / (n[d + 2] - n[d]);
                                                        0 === d ? o.drawLine(m, e1[1], m, e1[3], p[d], h[d]) : o.drawLine(e1[0], m, e1[2], m, p[d], h[d]);
                                                    }
                                                }
                                                for(d = 0; d < l.length; ++d)l[d].draw();
                                                t1.viewport(e1[0], e1[1], e1[2] - e1[0], e1[3] - e1[1]), t1.scissor(e1[0], e1[1], e1[2] - e1[0], e1[3] - e1[1]), this.grid.drawTickMarks(), o.bind();
                                                var g = this.borderLineEnable, v = this.borderLineWidth, y = this.borderLineColor;
                                                for(g[1] && o.drawLine(r[0], r[1] - .5 * v[1] * i, r[0], r[3] + .5 * v[3] * i, v[1], y[1]), g[0] && o.drawLine(r[0] - .5 * v[0] * i, r[1], r[2] + .5 * v[2] * i, r[1], v[0], y[0]), g[3] && o.drawLine(r[2], r[1] - .5 * v[1] * i, r[2], r[3] + .5 * v[3] * i, v[3], y[3]), g[2] && o.drawLine(r[0] - .5 * v[0] * i, r[3], r[2] + .5 * v[2] * i, r[3], v[2], y[2]), s.bind(), d = 0; d < 2; ++d)s.drawTicks(d);
                                                this.titleEnable && s.drawTitle();
                                                var x = this.overlays;
                                                for(d = 0; d < x.length; ++d)x[d].draw();
                                                t1.disable(t1.SCISSOR_TEST), t1.disable(t1.BLEND), t1.depthMask(!0);
                                            }
                                        }, c.drawPick = function() {
                                            if (!this.static) {
                                                var t1 = this.pickBuffer;
                                                this.gl, this._pickTimeout = null, t1.begin();
                                                for(var e1 = 1, r = this.objects, n = 0; n < r.length; ++n)e1 = r[n].drawPick(e1);
                                                t1.end();
                                            }
                                        }, c.pick = function(t1, e1) {
                                            if (!this.static) {
                                                var r = this.pixelRatio, n = this.pickPixelRatio, i = this.viewBox, a = 0 | Math.round((t1 - i[0] / r) * n), o = 0 | Math.round((e1 - i[1] / r) * n), s = this.pickBuffer.query(a, o, this.pickRadius);
                                                if (!s) return null;
                                                for(var l = s.id + (s.value[0] << 8) + (s.value[1] << 16) + (s.value[2] << 24), c = this.objects, u = 0; u < c.length; ++u){
                                                    var f = c[u].pick(a, o, l);
                                                    if (f) return f;
                                                }
                                                return null;
                                            }
                                        }, c.setScreenBox = function(t1) {
                                            var e1 = this.screenBox, r = this.pixelRatio;
                                            e1[0] = 0 | Math.round(t1[0] * r), e1[1] = 0 | Math.round(t1[1] * r), e1[2] = 0 | Math.round(t1[2] * r), e1[3] = 0 | Math.round(t1[3] * r), this.setDirty();
                                        }, c.setDataBox = function(t1) {
                                            var e1 = this.dataBox;
                                            (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3]) && (e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], this.setDirty());
                                        }, c.setViewBox = function(t1) {
                                            var e1 = this.pixelRatio, r = this.viewBox;
                                            r[0] = 0 | Math.round(t1[0] * e1), r[1] = 0 | Math.round(t1[1] * e1), r[2] = 0 | Math.round(t1[2] * e1), r[3] = 0 | Math.round(t1[3] * e1);
                                            var n = this.pickPixelRatio;
                                            this.pickBuffer.shape = [
                                                0 | Math.round((t1[2] - t1[0]) * n),
                                                0 | Math.round((t1[3] - t1[1]) * n)
                                            ], this.setDirty();
                                        }, c.update = function(t1) {
                                            t1 = t1 || {};
                                            var e1 = this.gl;
                                            this.pixelRatio = t1.pixelRatio || 1;
                                            var r = this.pixelRatio;
                                            this.pickPixelRatio = Math.max(r, 1), this.setScreenBox(t1.screenBox || [
                                                0,
                                                0,
                                                e1.drawingBufferWidth / r,
                                                e1.drawingBufferHeight / r
                                            ]);
                                            this.screenBox;
                                            this.setViewBox(t1.viewBox || [
                                                .125 * (this.screenBox[2] - this.screenBox[0]) / r,
                                                .125 * (this.screenBox[3] - this.screenBox[1]) / r,
                                                .875 * (this.screenBox[2] - this.screenBox[0]) / r,
                                                .875 * (this.screenBox[3] - this.screenBox[1]) / r
                                            ]);
                                            var n = this.viewBox, i = (n[2] - n[0]) / (n[3] - n[1]);
                                            this.setDataBox(t1.dataBox || [
                                                -10,
                                                -10 / i,
                                                10,
                                                10 / i
                                            ]), this.borderColor = !1 !== t1.borderColor && (t1.borderColor || [
                                                0,
                                                0,
                                                0,
                                                0
                                            ]).slice(), this.backgroundColor = (t1.backgroundColor || [
                                                0,
                                                0,
                                                0,
                                                0
                                            ]).slice(), this.gridLineEnable = (t1.gridLineEnable || [
                                                !0,
                                                !0
                                            ]).slice(), this.gridLineWidth = (t1.gridLineWidth || [
                                                1,
                                                1
                                            ]).slice(), this.gridLineColor = u(t1.gridLineColor || [
                                                [
                                                    .5,
                                                    .5,
                                                    .5,
                                                    1
                                                ],
                                                [
                                                    .5,
                                                    .5,
                                                    .5,
                                                    1
                                                ]
                                            ]), this.zeroLineEnable = (t1.zeroLineEnable || [
                                                !0,
                                                !0
                                            ]).slice(), this.zeroLineWidth = (t1.zeroLineWidth || [
                                                4,
                                                4
                                            ]).slice(), this.zeroLineColor = u(t1.zeroLineColor || [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ]), this.tickMarkLength = (t1.tickMarkLength || [
                                                0,
                                                0,
                                                0,
                                                0
                                            ]).slice(), this.tickMarkWidth = (t1.tickMarkWidth || [
                                                0,
                                                0,
                                                0,
                                                0
                                            ]).slice(), this.tickMarkColor = u(t1.tickMarkColor || [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ]), this.titleCenter = (t1.titleCenter || [
                                                .5 * (n[0] + n[2]) / r,
                                                (n[3] + 120) / r
                                            ]).slice(), this.titleEnable = !("titleEnable" in t1) || !!t1.titleEnable, this.titleAngle = t1.titleAngle || 0, this.titleColor = (t1.titleColor || [
                                                0,
                                                0,
                                                0,
                                                1
                                            ]).slice(), this.labelPad = (t1.labelPad || [
                                                15,
                                                15,
                                                15,
                                                15
                                            ]).slice(), this.labelAngle = (t1.labelAngle || [
                                                0,
                                                Math.PI / 2,
                                                0,
                                                3 * Math.PI / 2
                                            ]).slice(), this.labelEnable = (t1.labelEnable || [
                                                !0,
                                                !0,
                                                !0,
                                                !0
                                            ]).slice(), this.labelColor = u(t1.labelColor || [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ]), this.tickPad = (t1.tickPad || [
                                                15,
                                                15,
                                                15,
                                                15
                                            ]).slice(), this.tickAngle = (t1.tickAngle || [
                                                0,
                                                0,
                                                0,
                                                0
                                            ]).slice(), this.tickEnable = (t1.tickEnable || [
                                                !0,
                                                !0,
                                                !0,
                                                !0
                                            ]).slice(), this.tickColor = u(t1.tickColor || [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ]), this.borderLineEnable = (t1.borderLineEnable || [
                                                !0,
                                                !0,
                                                !0,
                                                !0
                                            ]).slice(), this.borderLineWidth = (t1.borderLineWidth || [
                                                2,
                                                2,
                                                2,
                                                2
                                            ]).slice(), this.borderLineColor = u(t1.borderLineColor || [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ]);
                                            var a = t1.ticks || [
                                                [],
                                                []
                                            ], o = this._tickBounds;
                                            o[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                                            for(var s = 0; s < 2; ++s){
                                                var l = a[s].slice(0);
                                                0 !== l.length && (l.sort(f), o[s] = Math.min(o[s], l[0].x), o[s + 2] = Math.max(o[s + 2], l[l.length - 1].x));
                                            }
                                            this.grid.update({
                                                bounds: o,
                                                ticks: a
                                            }), this.text.update({
                                                bounds: o,
                                                ticks: a,
                                                labels: t1.labels || [
                                                    "x",
                                                    "y"
                                                ],
                                                labelSize: t1.labelSize || [
                                                    12,
                                                    12
                                                ],
                                                labelFont: t1.labelFont || [
                                                    "sans-serif",
                                                    "sans-serif"
                                                ],
                                                title: t1.title || "",
                                                titleSize: t1.titleSize || 18,
                                                titleFont: t1.titleFont || "sans-serif"
                                            }), this.static = !!t1.static, this.setDirty();
                                        }, c.dispose = function() {
                                            this.box.dispose(), this.grid.dispose(), this.text.dispose(), this.line.dispose();
                                            for(var t1 = this.objects.length - 1; t1 >= 0; --t1)this.objects[t1].dispose();
                                            this.objects.length = 0;
                                            for(t1 = this.overlays.length - 1; t1 >= 0; --t1)this.overlays[t1].dispose();
                                            this.overlays.length = 0, this.gl = null;
                                        }, c.addObject = function(t1) {
                                            this.objects.indexOf(t1) < 0 && (this.objects.push(t1), this.setDirty());
                                        }, c.removeObject = function(t1) {
                                            for(var e1 = this.objects, r = 0; r < e1.length; ++r)if (e1[r] === t1) {
                                                e1.splice(r, 1), this.setDirty();
                                                break;
                                            }
                                        }, c.addOverlay = function(t1) {
                                            this.overlays.indexOf(t1) < 0 && (this.overlays.push(t1), this.setOverlayDirty());
                                        }, c.removeOverlay = function(t1) {
                                            for(var e1 = this.overlays, r = 0; r < e1.length; ++r)if (e1[r] === t1) {
                                                e1.splice(r, 1), this.setOverlayDirty();
                                                break;
                                            }
                                        };
                                    },
                                    {
                                        "./lib/box": 113,
                                        "./lib/grid": 114,
                                        "./lib/line": 115,
                                        "./lib/text": 117,
                                        "gl-select-static": 131
                                    }
                                ],
                                119: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            t1 = t1 || document.body, e1 = e1 || {};
                                            var r = [
                                                .01,
                                                1 / 0
                                            ];
                                            "distanceLimits" in e1 && (r[0] = e1.distanceLimits[0], r[1] = e1.distanceLimits[1]);
                                            "zoomMin" in e1 && (r[0] = e1.zoomMin);
                                            "zoomMax" in e1 && (r[1] = e1.zoomMax);
                                            var c = i({
                                                center: e1.center || [
                                                    0,
                                                    0,
                                                    0
                                                ],
                                                up: e1.up || [
                                                    0,
                                                    1,
                                                    0
                                                ],
                                                eye: e1.eye || [
                                                    0,
                                                    0,
                                                    10
                                                ],
                                                mode: e1.mode || "orbit",
                                                distanceLimits: r
                                            }), u = [
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0
                                            ], f = 0, h = t1.clientWidth, p = t1.clientHeight, d = {
                                                keyBindingMode: "rotate",
                                                enableWheel: !0,
                                                view: c,
                                                element: t1,
                                                delay: e1.delay || 16,
                                                rotateSpeed: e1.rotateSpeed || 1,
                                                zoomSpeed: e1.zoomSpeed || 1,
                                                translateSpeed: e1.translateSpeed || 1,
                                                flipX: !!e1.flipX,
                                                flipY: !!e1.flipY,
                                                modes: c.modes,
                                                _ortho: e1._ortho || e1.projection && "orthographic" === e1.projection.type || !1,
                                                tick: function() {
                                                    var e1 = n(), r = this.delay, i = e1 - 2 * r;
                                                    c.idle(e1 - r), c.recalcMatrix(i), c.flush(e1 - (100 + 2 * r));
                                                    for(var a = !0, o = c.computedMatrix, s = 0; s < 16; ++s)a = a && u[s] === o[s], u[s] = o[s];
                                                    var l = t1.clientWidth === h && t1.clientHeight === p;
                                                    return h = t1.clientWidth, p = t1.clientHeight, a ? !l : (f = Math.exp(c.computedRadius[0]), !0);
                                                },
                                                lookAt: function(t1, e1, r) {
                                                    c.lookAt(c.lastT(), t1, e1, r);
                                                },
                                                rotate: function(t1, e1, r) {
                                                    c.rotate(c.lastT(), t1, e1, r);
                                                },
                                                pan: function(t1, e1, r) {
                                                    c.pan(c.lastT(), t1, e1, r);
                                                },
                                                translate: function(t1, e1, r) {
                                                    c.translate(c.lastT(), t1, e1, r);
                                                }
                                            };
                                            return Object.defineProperties(d, {
                                                matrix: {
                                                    get: function() {
                                                        return c.computedMatrix;
                                                    },
                                                    set: function(t1) {
                                                        return c.setMatrix(c.lastT(), t1), c.computedMatrix;
                                                    },
                                                    enumerable: !0
                                                },
                                                mode: {
                                                    get: function() {
                                                        return c.getMode();
                                                    },
                                                    set: function(t1) {
                                                        var e1 = c.computedUp.slice(), r = c.computedEye.slice(), i = c.computedCenter.slice();
                                                        if (c.setMode(t1), "turntable" === t1) {
                                                            var a = n();
                                                            c._active.lookAt(a, r, i, e1), c._active.lookAt(a + 500, r, i, [
                                                                0,
                                                                0,
                                                                1
                                                            ]), c._active.flush(a);
                                                        }
                                                        return c.getMode();
                                                    },
                                                    enumerable: !0
                                                },
                                                center: {
                                                    get: function() {
                                                        return c.computedCenter;
                                                    },
                                                    set: function(t1) {
                                                        return c.lookAt(c.lastT(), null, t1), c.computedCenter;
                                                    },
                                                    enumerable: !0
                                                },
                                                eye: {
                                                    get: function() {
                                                        return c.computedEye;
                                                    },
                                                    set: function(t1) {
                                                        return c.lookAt(c.lastT(), t1), c.computedEye;
                                                    },
                                                    enumerable: !0
                                                },
                                                up: {
                                                    get: function() {
                                                        return c.computedUp;
                                                    },
                                                    set: function(t1) {
                                                        return c.lookAt(c.lastT(), null, null, t1), c.computedUp;
                                                    },
                                                    enumerable: !0
                                                },
                                                distance: {
                                                    get: function() {
                                                        return f;
                                                    },
                                                    set: function(t1) {
                                                        return c.setDistance(c.lastT(), t1), t1;
                                                    },
                                                    enumerable: !0
                                                },
                                                distanceLimits: {
                                                    get: function() {
                                                        return c.getDistanceLimits(r);
                                                    },
                                                    set: function(t1) {
                                                        return c.setDistanceLimits(t1), t1;
                                                    },
                                                    enumerable: !0
                                                }
                                            }), t1.addEventListener("contextmenu", function(t1) {
                                                return t1.preventDefault(), !1;
                                            }), d._lastX = -1, d._lastY = -1, d._lastMods = {
                                                shift: !1,
                                                control: !1,
                                                alt: !1,
                                                meta: !1
                                            }, d.enableMouseListeners = function() {
                                                function e1(e1, r, i, a) {
                                                    var o = d.keyBindingMode;
                                                    if (!1 !== o) {
                                                        var s = "rotate" === o, l = "pan" === o, u = "zoom" === o, h = !!a.control, p = !!a.alt, m = !!a.shift, g = !!(1 & e1), v = !!(2 & e1), y = !!(4 & e1), x = 1 / t1.clientHeight, b = x * (r - d._lastX), _ = x * (i - d._lastY), w = d.flipX ? 1 : -1, T = d.flipY ? 1 : -1, k = Math.PI * d.rotateSpeed, A = n();
                                                        if (-1 !== d._lastX && -1 !== d._lastY && ((s && g && !h && !p && !m || g && !h && !p && m) && c.rotate(A, w * k * b, -T * k * _, 0), (l && g && !h && !p && !m || v || g && h && !p && !m) && c.pan(A, -d.translateSpeed * b * f, d.translateSpeed * _ * f, 0), u && g && !h && !p && !m || y || g && !h && p && !m)) {
                                                            var M = -d.zoomSpeed * _ / window.innerHeight * (A - c.lastT()) * 100;
                                                            c.pan(A, 0, 0, f * (Math.exp(M) - 1));
                                                        }
                                                        return d._lastX = r, d._lastY = i, d._lastMods = a, !0;
                                                    }
                                                }
                                                d.mouseListener = a(t1, e1), t1.addEventListener("touchstart", function(r) {
                                                    var n = s(r.changedTouches[0], t1);
                                                    e1(0, n[0], n[1], d._lastMods), e1(1, n[0], n[1], d._lastMods);
                                                }, !!l && {
                                                    passive: !0
                                                }), t1.addEventListener("touchmove", function(r) {
                                                    var n = s(r.changedTouches[0], t1);
                                                    e1(1, n[0], n[1], d._lastMods), r.preventDefault();
                                                }, !!l && {
                                                    passive: !1
                                                }), t1.addEventListener("touchend", function(t1) {
                                                    e1(0, d._lastX, d._lastY, d._lastMods);
                                                }, !!l && {
                                                    passive: !0
                                                }), d.wheelListener = o(t1, function(t1, e1) {
                                                    if (!1 !== d.keyBindingMode && d.enableWheel) {
                                                        var r = d.flipX ? 1 : -1, i = d.flipY ? 1 : -1, a = n();
                                                        if (Math.abs(t1) > Math.abs(e1)) c.rotate(a, 0, 0, -t1 * r * Math.PI * d.rotateSpeed / window.innerWidth);
                                                        else if (!d._ortho) {
                                                            var o = -d.zoomSpeed * i * e1 / window.innerHeight * (a - c.lastT()) / 20;
                                                            c.pan(a, 0, 0, f * (Math.exp(o) - 1));
                                                        }
                                                    }
                                                }, !0);
                                            }, d.enableMouseListeners(), d;
                                        };
                                        var n = t1("right-now"), i = t1("3d-view"), a = t1("mouse-change"), o = t1("mouse-wheel"), s = t1("mouse-event-offset"), l = t1("has-passive-events");
                                    },
                                    {
                                        "3d-view": 7,
                                        "has-passive-events": 232,
                                        "mouse-change": 247,
                                        "mouse-event-offset": 248,
                                        "mouse-wheel": 250,
                                        "right-now": 278
                                    }
                                ],
                                120: [
                                    function(t1, e1, r) {
                                        var n = t1("glslify"), i = t1("gl-shader"), a = n([
                                            "precision mediump float;\n#define GLSLIFY 1\nattribute vec2 position;\nvarying vec2 uv;\nvoid main() {\n  uv = position;\n  gl_Position = vec4(position, 0, 1);\n}"
                                        ]), o = n([
                                            "precision mediump float;\n#define GLSLIFY 1\n\nuniform sampler2D accumBuffer;\nvarying vec2 uv;\n\nvoid main() {\n  vec4 accum = texture2D(accumBuffer, 0.5 * (uv + 1.0));\n  gl_FragColor = min(vec4(1,1,1,1), accum);\n}"
                                        ]);
                                        e1.exports = function(t1) {
                                            return i(t1, a, o, null, [
                                                {
                                                    name: "position",
                                                    type: "vec2"
                                                }
                                            ]);
                                        };
                                    },
                                    {
                                        "gl-shader": 132,
                                        glslify: 231
                                    }
                                ],
                                121: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./camera.js"), i = t1("gl-axes3d"), a = t1("gl-axes3d/properties"), o = t1("gl-spikes3d"), s = t1("gl-select-static"), l = t1("gl-fbo"), c = t1("a-big-triangle"), u = t1("mouse-change"), f = t1("gl-mat4/perspective"), h = t1("gl-mat4/ortho"), p = t1("./lib/shader"), d = t1("is-mobile")({
                                            tablet: !0,
                                            featureDetect: !0
                                        });
                                        function m() {
                                            this.mouse = [
                                                -1,
                                                -1
                                            ], this.screen = null, this.distance = 1 / 0, this.index = null, this.dataCoordinate = null, this.dataPosition = null, this.object = null, this.data = null;
                                        }
                                        function g(t1) {
                                            var e1 = Math.round(Math.log(Math.abs(t1)) / Math.log(10));
                                            if (e1 < 0) {
                                                var r = Math.round(Math.pow(10, -e1));
                                                return Math.ceil(t1 * r) / r;
                                            }
                                            if (e1 > 0) {
                                                r = Math.round(Math.pow(10, e1));
                                                return Math.ceil(t1 / r) * r;
                                            }
                                            return Math.ceil(t1);
                                        }
                                        function v(t1) {
                                            return "boolean" != typeof t1 || t1;
                                        }
                                        e1.exports = {
                                            createScene: function(t1) {
                                                (t1 = t1 || {}).camera = t1.camera || {};
                                                var e1 = t1.canvas;
                                                if (!e1) {
                                                    if (e1 = document.createElement("canvas"), t1.container) t1.container.appendChild(e1);
                                                    else document.body.appendChild(e1);
                                                }
                                                var r = t1.gl;
                                                r || (t1.glOptions && (d = !!t1.glOptions.preserveDrawingBuffer), r = function(t1, e1) {
                                                    var r = null;
                                                    try {
                                                        (r = t1.getContext("webgl", e1)) || (r = t1.getContext("experimental-webgl", e1));
                                                    } catch (t1) {
                                                        return null;
                                                    }
                                                    return r;
                                                }(e1, t1.glOptions || {
                                                    premultipliedAlpha: !0,
                                                    antialias: !0,
                                                    preserveDrawingBuffer: d
                                                }));
                                                if (!r) throw new Error("webgl not supported");
                                                var y = t1.bounds || [
                                                    [
                                                        -10,
                                                        -10,
                                                        -10
                                                    ],
                                                    [
                                                        10,
                                                        10,
                                                        10
                                                    ]
                                                ], x = new m, b = l(r, r.drawingBufferWidth, r.drawingBufferHeight, {
                                                    preferFloat: !d
                                                }), _ = p(r), w = t1.cameraObject && !0 === t1.cameraObject._ortho || t1.camera.projection && "orthographic" === t1.camera.projection.type || !1, T = {
                                                    eye: t1.camera.eye || [
                                                        2,
                                                        0,
                                                        0
                                                    ],
                                                    center: t1.camera.center || [
                                                        0,
                                                        0,
                                                        0
                                                    ],
                                                    up: t1.camera.up || [
                                                        0,
                                                        1,
                                                        0
                                                    ],
                                                    zoomMin: t1.camera.zoomMax || .1,
                                                    zoomMax: t1.camera.zoomMin || 100,
                                                    mode: t1.camera.mode || "turntable",
                                                    _ortho: w
                                                }, k = t1.axes || {}, A = i(r, k);
                                                A.enable = !k.disable;
                                                var M = t1.spikes || {}, S = o(r, M), E = [], L = [], C = [], P = [], I = !0, O = !0, z = new Array(16), D = new Array(16), R = {
                                                    view: null,
                                                    projection: z,
                                                    model: D,
                                                    _ortho: !1
                                                }, F = (O = !0, [
                                                    r.drawingBufferWidth,
                                                    r.drawingBufferHeight
                                                ]), B = t1.cameraObject || n(e1, T), N = {
                                                    gl: r,
                                                    contextLost: !1,
                                                    pixelRatio: t1.pixelRatio || 1,
                                                    canvas: e1,
                                                    selection: x,
                                                    camera: B,
                                                    axes: A,
                                                    axesPixels: null,
                                                    spikes: S,
                                                    bounds: y,
                                                    objects: E,
                                                    shape: F,
                                                    aspect: t1.aspectRatio || [
                                                        1,
                                                        1,
                                                        1
                                                    ],
                                                    pickRadius: t1.pickRadius || 10,
                                                    zNear: t1.zNear || .01,
                                                    zFar: t1.zFar || 1e3,
                                                    fovy: t1.fovy || Math.PI / 4,
                                                    clearColor: t1.clearColor || [
                                                        0,
                                                        0,
                                                        0,
                                                        0
                                                    ],
                                                    autoResize: v(t1.autoResize),
                                                    autoBounds: v(t1.autoBounds),
                                                    autoScale: !!t1.autoScale,
                                                    autoCenter: v(t1.autoCenter),
                                                    clipToBounds: v(t1.clipToBounds),
                                                    snapToData: !!t1.snapToData,
                                                    onselect: t1.onselect || null,
                                                    onrender: t1.onrender || null,
                                                    onclick: t1.onclick || null,
                                                    cameraParams: R,
                                                    oncontextloss: null,
                                                    mouseListener: null,
                                                    _stopped: !1,
                                                    getAspectratio: function() {
                                                        return {
                                                            x: this.aspect[0],
                                                            y: this.aspect[1],
                                                            z: this.aspect[2]
                                                        };
                                                    },
                                                    setAspectratio: function(t1) {
                                                        this.aspect[0] = t1.x, this.aspect[1] = t1.y, this.aspect[2] = t1.z, O = !0;
                                                    },
                                                    setBounds: function(t1, e1) {
                                                        this.bounds[0][t1] = e1.min, this.bounds[1][t1] = e1.max;
                                                    },
                                                    setClearColor: function(t1) {
                                                        this.clearColor = t1;
                                                    },
                                                    clearRGBA: function() {
                                                        this.gl.clearColor(this.clearColor[0], this.clearColor[1], this.clearColor[2], this.clearColor[3]), this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
                                                    }
                                                }, j = [
                                                    r.drawingBufferWidth / N.pixelRatio | 0,
                                                    r.drawingBufferHeight / N.pixelRatio | 0
                                                ];
                                                function U() {
                                                    if (!N._stopped && N.autoResize) {
                                                        var t1 = e1.parentNode, r = 1, n = 1;
                                                        t1 && t1 !== document.body ? (r = t1.clientWidth, n = t1.clientHeight) : (r = window.innerWidth, n = window.innerHeight);
                                                        var i = 0 | Math.ceil(r * N.pixelRatio), a = 0 | Math.ceil(n * N.pixelRatio);
                                                        if (i !== e1.width || a !== e1.height) {
                                                            e1.width = i, e1.height = a;
                                                            var o = e1.style;
                                                            o.position = o.position || "absolute", o.left = "0px", o.top = "0px", o.width = r + "px", o.height = n + "px", I = !0;
                                                        }
                                                    }
                                                }
                                                N.autoResize && U();
                                                function V() {
                                                    for(var t1 = E.length, e1 = P.length, n = 0; n < e1; ++n)C[n] = 0;
                                                    t: for(n = 0; n < t1; ++n){
                                                        var i = E[n], a = i.pickSlots;
                                                        if (a) {
                                                            for(var o = 0; o < e1; ++o)if (C[o] + a < 255) {
                                                                L[n] = o, i.setPickBase(C[o] + 1), C[o] += a;
                                                                continue t;
                                                            }
                                                            var l = s(r, F);
                                                            L[n] = e1, P.push(l), C.push(a), i.setPickBase(1), e1 += 1;
                                                        } else L[n] = -1;
                                                    }
                                                    for(; e1 > 0 && 0 === C[e1 - 1];)C.pop(), P.pop().dispose();
                                                }
                                                function H() {
                                                    if (N.contextLost) return !0;
                                                    r.isContextLost() && (N.contextLost = !0, N.mouseListener.enabled = !1, N.selection.object = null, N.oncontextloss && N.oncontextloss());
                                                }
                                                window.addEventListener("resize", U), N.update = function(t1) {
                                                    N._stopped || (t1 = t1 || {}, I = !0, O = !0);
                                                }, N.add = function(t1) {
                                                    N._stopped || (t1.axes = A, E.push(t1), L.push(-1), I = !0, O = !0, V());
                                                }, N.remove = function(t1) {
                                                    if (!N._stopped) {
                                                        var e1 = E.indexOf(t1);
                                                        e1 < 0 || (E.splice(e1, 1), L.pop(), I = !0, O = !0, V());
                                                    }
                                                }, N.dispose = function() {
                                                    if (!N._stopped && (N._stopped = !0, window.removeEventListener("resize", U), e1.removeEventListener("webglcontextlost", H), N.mouseListener.enabled = !1, !N.contextLost)) {
                                                        A.dispose(), S.dispose();
                                                        for(var t1 = 0; t1 < E.length; ++t1)E[t1].dispose();
                                                        b.dispose();
                                                        for(t1 = 0; t1 < P.length; ++t1)P[t1].dispose();
                                                        _.dispose(), r = null, A = null, S = null, E = [];
                                                    }
                                                }, N._mouseRotating = !1, N._prevButtons = 0, N.enableMouseListeners = function() {
                                                    N.mouseListener = u(e1, function(t1, e1, r) {
                                                        if (!N._stopped) {
                                                            var n = P.length, i = E.length, a = x.object;
                                                            x.distance = 1 / 0, x.mouse[0] = e1, x.mouse[1] = r, x.object = null, x.screen = null, x.dataCoordinate = x.dataPosition = null;
                                                            var o = !1;
                                                            if (t1 && N._prevButtons) N._mouseRotating = !0;
                                                            else {
                                                                N._mouseRotating && (O = !0), N._mouseRotating = !1;
                                                                for(var s = 0; s < n; ++s){
                                                                    var l = P[s].query(e1, j[1] - r - 1, N.pickRadius);
                                                                    if (l) {
                                                                        if (l.distance > x.distance) continue;
                                                                        for(var c = 0; c < i; ++c){
                                                                            var u = E[c];
                                                                            if (L[c] === s) {
                                                                                var f = u.pick(l);
                                                                                f && (x.buttons = t1, x.screen = l.coord, x.distance = l.distance, x.object = u, x.index = f.distance, x.dataPosition = f.position, x.dataCoordinate = f.dataCoordinate, x.data = f, o = !0);
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            a && a !== x.object && (a.highlight && a.highlight(null), I = !0), x.object && (x.object.highlight && x.object.highlight(x.data), I = !0), (o = o || x.object !== a) && N.onselect && N.onselect(x), 1 & t1 && !(1 & N._prevButtons) && N.onclick && N.onclick(x), N._prevButtons = t1;
                                                        }
                                                    });
                                                }, e1.addEventListener("webglcontextlost", H);
                                                var q = [
                                                    [
                                                        1 / 0,
                                                        1 / 0,
                                                        1 / 0
                                                    ],
                                                    [
                                                        -1 / 0,
                                                        -1 / 0,
                                                        -1 / 0
                                                    ]
                                                ], G = [
                                                    q[0].slice(),
                                                    q[1].slice()
                                                ];
                                                function Y() {
                                                    if (!H()) {
                                                        U();
                                                        var t1 = N.camera.tick();
                                                        R.view = N.camera.matrix, I = I || t1, O = O || t1, A.pixelRatio = N.pixelRatio, S.pixelRatio = N.pixelRatio;
                                                        var e1 = E.length, n = q[0], i = q[1];
                                                        n[0] = n[1] = n[2] = 1 / 0, i[0] = i[1] = i[2] = -1 / 0;
                                                        for(var o = 0; o < e1; ++o){
                                                            (C = E[o]).pixelRatio = N.pixelRatio, C.axes = N.axes, I = I || !!C.dirty, O = O || !!C.dirty;
                                                            var s = C.bounds;
                                                            if (s) for(var l = s[0], u = s[1], p = 0; p < 3; ++p)n[p] = Math.min(n[p], l[p]), i[p] = Math.max(i[p], u[p]);
                                                        }
                                                        var d = N.bounds;
                                                        if (N.autoBounds) for(p = 0; p < 3; ++p){
                                                            if (i[p] < n[p]) n[p] = -1, i[p] = 1;
                                                            else {
                                                                n[p] === i[p] && (n[p] -= 1, i[p] += 1);
                                                                var m = .05 * (i[p] - n[p]);
                                                                n[p] = n[p] - m, i[p] = i[p] + m;
                                                            }
                                                            d[0][p] = n[p], d[1][p] = i[p];
                                                        }
                                                        var v = !1;
                                                        for(p = 0; p < 3; ++p)v = v || G[0][p] !== d[0][p] || G[1][p] !== d[1][p], G[0][p] = d[0][p], G[1][p] = d[1][p];
                                                        if (O = O || v, I = I || v) {
                                                            if (v) {
                                                                var y = [
                                                                    0,
                                                                    0,
                                                                    0
                                                                ];
                                                                for(o = 0; o < 3; ++o)y[o] = g((d[1][o] - d[0][o]) / 10);
                                                                A.autoTicks ? A.update({
                                                                    bounds: d,
                                                                    tickSpacing: y
                                                                }) : A.update({
                                                                    bounds: d
                                                                });
                                                            }
                                                            var T = r.drawingBufferWidth, k = r.drawingBufferHeight;
                                                            F[0] = T, F[1] = k, j[0] = 0 | Math.max(T / N.pixelRatio, 1), j[1] = 0 | Math.max(k / N.pixelRatio, 1), function(t1, e1) {
                                                                var r = t1.bounds, n = t1.cameraParams, i = n.projection, a = n.model, o = t1.gl.drawingBufferWidth, s = t1.gl.drawingBufferHeight, l = t1.zNear, c = t1.zFar, u = t1.fovy, p = o / s;
                                                                e1 ? (h(i, -p, p, -1, 1, l, c), n._ortho = !0) : (f(i, u, p, l, c), n._ortho = !1);
                                                                for(var d = 0; d < 16; ++d)a[d] = 0;
                                                                a[15] = 1;
                                                                var m = 0;
                                                                for(d = 0; d < 3; ++d)m = Math.max(m, r[1][d] - r[0][d]);
                                                                for(d = 0; d < 3; ++d)t1.autoScale ? a[5 * d] = t1.aspect[d] / (r[1][d] - r[0][d]) : a[5 * d] = 1 / m, t1.autoCenter && (a[12 + d] = .5 * -a[5 * d] * (r[0][d] + r[1][d]));
                                                            }(N, w);
                                                            for(o = 0; o < e1; ++o)(C = E[o]).axesBounds = d, N.clipToBounds && (C.clipBounds = d);
                                                            x.object && (N.snapToData ? S.position = x.dataCoordinate : S.position = x.dataPosition, S.bounds = d), O && (O = !1, function() {
                                                                if (!H()) {
                                                                    r.colorMask(!0, !0, !0, !0), r.depthMask(!0), r.disable(r.BLEND), r.enable(r.DEPTH_TEST), r.depthFunc(r.LEQUAL);
                                                                    for(var t1 = E.length, e1 = P.length, n = 0; n < e1; ++n){
                                                                        var i = P[n];
                                                                        i.shape = j, i.begin();
                                                                        for(var a = 0; a < t1; ++a)if (L[a] === n) {
                                                                            var o = E[a];
                                                                            o.drawPick && (o.pixelRatio = 1, o.drawPick(R));
                                                                        }
                                                                        i.end();
                                                                    }
                                                                }
                                                            }()), N.axesPixels = a(N.axes, R, T, k), N.onrender && N.onrender(), r.bindFramebuffer(r.FRAMEBUFFER, null), r.viewport(0, 0, T, k), N.clearRGBA(), r.depthMask(!0), r.colorMask(!0, !0, !0, !0), r.enable(r.DEPTH_TEST), r.depthFunc(r.LEQUAL), r.disable(r.BLEND), r.disable(r.CULL_FACE);
                                                            var M = !1;
                                                            A.enable && (M = M || A.isTransparent(), A.draw(R)), S.axes = A, x.object && S.draw(R), r.disable(r.CULL_FACE);
                                                            for(o = 0; o < e1; ++o)(C = E[o]).axes = A, C.pixelRatio = N.pixelRatio, C.isOpaque && C.isOpaque() && C.draw(R), C.isTransparent && C.isTransparent() && (M = !0);
                                                            if (M) {
                                                                b.shape = F, b.bind(), r.clear(r.DEPTH_BUFFER_BIT), r.colorMask(!1, !1, !1, !1), r.depthMask(!0), r.depthFunc(r.LESS), A.enable && A.isTransparent() && A.drawTransparent(R);
                                                                for(o = 0; o < e1; ++o)(C = E[o]).isOpaque && C.isOpaque() && C.draw(R);
                                                                r.enable(r.BLEND), r.blendEquation(r.FUNC_ADD), r.blendFunc(r.ONE, r.ONE_MINUS_SRC_ALPHA), r.colorMask(!0, !0, !0, !0), r.depthMask(!1), r.clearColor(0, 0, 0, 0), r.clear(r.COLOR_BUFFER_BIT), A.isTransparent() && A.drawTransparent(R);
                                                                for(o = 0; o < e1; ++o){
                                                                    var C;
                                                                    (C = E[o]).isTransparent && C.isTransparent() && C.drawTransparent(R);
                                                                }
                                                                r.bindFramebuffer(r.FRAMEBUFFER, null), r.blendFunc(r.ONE, r.ONE_MINUS_SRC_ALPHA), r.disable(r.DEPTH_TEST), _.bind(), b.color[0].bind(0), _.uniforms.accumBuffer = 0, c(r), r.disable(r.BLEND);
                                                            }
                                                            I = !1;
                                                            for(o = 0; o < e1; ++o)E[o].dirty = !1;
                                                        }
                                                    }
                                                }
                                                return N.enableMouseListeners(), function t1() {
                                                    if (N._stopped || N.contextLost) return;
                                                    Y(), requestAnimationFrame(t1);
                                                }(), N.redraw = function() {
                                                    N._stopped || (I = !0, Y());
                                                }, N;
                                            },
                                            createCamera: n
                                        };
                                    },
                                    {
                                        "./camera.js": 119,
                                        "./lib/shader": 120,
                                        "a-big-triangle": 8,
                                        "gl-axes3d": 70,
                                        "gl-axes3d/properties": 77,
                                        "gl-fbo": 86,
                                        "gl-mat4/ortho": 101,
                                        "gl-mat4/perspective": 102,
                                        "gl-select-static": 131,
                                        "gl-spikes3d": 141,
                                        "is-mobile": 238,
                                        "mouse-change": 247
                                    }
                                ],
                                122: [
                                    function(t1, e1, r) {
                                        var n = t1("glslify");
                                        r.pointVertex = n([
                                            "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform float pointCloud;\n\nhighp float rand(vec2 co) {\n  highp float a = 12.9898;\n  highp float b = 78.233;\n  highp float c = 43758.5453;\n  highp float d = dot(co.xy, vec2(a, b));\n  highp float e = mod(d, 3.14);\n  return fract(sin(e) * c);\n}\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n    // if we don't jitter the point size a bit, overall point cloud\n    // saturation 'jumps' on zooming, which is disturbing and confusing\n  gl_PointSize = pointSize * ((19.5 + rand(position)) / 20.0);\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    // get the same square surface as circle would be\n    gl_PointSize *= 0.886;\n  }\n}"
                                        ]), r.pointFragment = n([
                                            "precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color, borderColor;\nuniform float centerFraction;\nuniform float pointCloud;\n\nvoid main() {\n  float radius;\n  vec4 baseColor;\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    if(centerFraction == 1.0) {\n      gl_FragColor = color;\n    } else {\n      gl_FragColor = mix(borderColor, color, centerFraction);\n    }\n  } else {\n    radius = length(2.0 * gl_PointCoord.xy - 1.0);\n    if(radius > 1.0) {\n      discard;\n    }\n    baseColor = mix(borderColor, color, step(radius, centerFraction));\n    gl_FragColor = vec4(baseColor.rgb * baseColor.a, baseColor.a);\n  }\n}\n"
                                        ]), r.pickVertex = n([
                                            "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform vec4 pickOffset;\n\nvarying vec4 fragId;\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n  gl_PointSize = pointSize;\n\n  vec4 id = pickId + pickOffset;\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  fragId = id;\n}\n"
                                        ]), r.pickFragment = n([
                                            "precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\n\nvoid main() {\n  float radius = length(2.0 * gl_PointCoord.xy - 1.0);\n  if(radius > 1.0) {\n    discard;\n  }\n  gl_FragColor = fragId / 255.0;\n}\n"
                                        ]);
                                    },
                                    {
                                        glslify: 231
                                    }
                                ],
                                123: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("gl-shader"), i = t1("gl-buffer"), a = t1("typedarray-pool"), o = t1("./lib/shader");
                                        function s(t1, e1, r, n, i) {
                                            this.plot = t1, this.offsetBuffer = e1, this.pickBuffer = r, this.shader = n, this.pickShader = i, this.sizeMin = .5, this.sizeMinCap = 2, this.sizeMax = 20, this.areaRatio = 1, this.pointCount = 0, this.color = [
                                                1,
                                                0,
                                                0,
                                                1
                                            ], this.borderColor = [
                                                0,
                                                0,
                                                0,
                                                1
                                            ], this.blend = !1, this.pickOffset = 0, this.points = null;
                                        }
                                        e1.exports = function(t1, e1) {
                                            var r = t1.gl, a = i(r), l = i(r), c = n(r, o.pointVertex, o.pointFragment), u = n(r, o.pickVertex, o.pickFragment), f = new s(t1, a, l, c, u);
                                            return f.update(e1), t1.addObject(f), f;
                                        };
                                        var l, c, u = s.prototype;
                                        u.dispose = function() {
                                            this.shader.dispose(), this.pickShader.dispose(), this.offsetBuffer.dispose(), this.pickBuffer.dispose(), this.plot.removeObject(this);
                                        }, u.update = function(t1) {
                                            var e1;
                                            function r(e1, r) {
                                                return e1 in t1 ? t1[e1] : r;
                                            }
                                            t1 = t1 || {}, this.sizeMin = r("sizeMin", .5), this.sizeMax = r("sizeMax", 20), this.color = r("color", [
                                                1,
                                                0,
                                                0,
                                                1
                                            ]).slice(), this.areaRatio = r("areaRatio", 1), this.borderColor = r("borderColor", [
                                                0,
                                                0,
                                                0,
                                                1
                                            ]).slice(), this.blend = r("blend", !1);
                                            var n = t1.positions.length >>> 1, i = t1.positions instanceof Float32Array, o = t1.idToIndex instanceof Int32Array && t1.idToIndex.length >= n, s = t1.positions, l = i ? s : a.mallocFloat32(s.length), c = o ? t1.idToIndex : a.mallocInt32(n);
                                            if (i || l.set(s), !o) for(l.set(s), e1 = 0; e1 < n; e1++)c[e1] = e1;
                                            this.points = s, this.offsetBuffer.update(l), this.pickBuffer.update(c), i || a.free(l), o || a.free(c), this.pointCount = n, this.pickOffset = 0;
                                        }, u.unifiedDraw = (l = [
                                            1,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            1
                                        ], c = [
                                            0,
                                            0,
                                            0,
                                            0
                                        ], function(t1) {
                                            var e1 = void 0 !== t1, r = e1 ? this.pickShader : this.shader, n = this.plot.gl, i = this.plot.dataBox;
                                            if (0 === this.pointCount) return t1;
                                            var a = i[2] - i[0], o = i[3] - i[1], s = function(t1, e1) {
                                                var r, n = 0, i = t1.length >>> 1;
                                                for(r = 0; r < i; r++){
                                                    var a = t1[2 * r], o = t1[2 * r + 1];
                                                    a >= e1[0] && a <= e1[2] && o >= e1[1] && o <= e1[3] && n++;
                                                }
                                                return n;
                                            }(this.points, i), u = this.plot.pickPixelRatio * Math.max(Math.min(this.sizeMinCap, this.sizeMin), Math.min(this.sizeMax, this.sizeMax / Math.pow(s, .33333)));
                                            l[0] = 2 / a, l[4] = 2 / o, l[6] = -2 * i[0] / a - 1, l[7] = -2 * i[1] / o - 1, this.offsetBuffer.bind(), r.bind(), r.attributes.position.pointer(), r.uniforms.matrix = l, r.uniforms.color = this.color, r.uniforms.borderColor = this.borderColor, r.uniforms.pointCloud = u < 5, r.uniforms.pointSize = u, r.uniforms.centerFraction = Math.min(1, Math.max(0, Math.sqrt(1 - this.areaRatio))), e1 && (c[0] = 255 & t1, c[1] = t1 >> 8 & 255, c[2] = t1 >> 16 & 255, c[3] = t1 >> 24 & 255, this.pickBuffer.bind(), r.attributes.pickId.pointer(n.UNSIGNED_BYTE), r.uniforms.pickOffset = c, this.pickOffset = t1);
                                            var f = n.getParameter(n.BLEND), h = n.getParameter(n.DITHER);
                                            return f && !this.blend && n.disable(n.BLEND), h && n.disable(n.DITHER), n.drawArrays(n.POINTS, 0, this.pointCount), f && !this.blend && n.enable(n.BLEND), h && n.enable(n.DITHER), t1 + this.pointCount;
                                        }), u.draw = u.unifiedDraw, u.drawPick = u.unifiedDraw, u.pick = function(t1, e1, r) {
                                            var n = this.pickOffset, i = this.pointCount;
                                            if (r < n || r >= n + i) return null;
                                            var a = r - n, o = this.points;
                                            return {
                                                object: this,
                                                pointId: a,
                                                dataCoord: [
                                                    o[2 * a],
                                                    o[2 * a + 1]
                                                ]
                                            };
                                        };
                                    },
                                    {
                                        "./lib/shader": 122,
                                        "gl-buffer": 78,
                                        "gl-shader": 132,
                                        "typedarray-pool": 308
                                    }
                                ],
                                124: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n) {
                                            var i, a, o, s, l, c = e1[0], u = e1[1], f = e1[2], h = e1[3], p = r[0], d = r[1], m = r[2], g = r[3];
                                            (a = c * p + u * d + f * m + h * g) < 0 && (a = -a, p = -p, d = -d, m = -m, g = -g);
                                            1 - a > 1e-6 ? (i = Math.acos(a), o = Math.sin(i), s = Math.sin((1 - n) * i) / o, l = Math.sin(n * i) / o) : (s = 1 - n, l = n);
                                            return t1[0] = s * c + l * p, t1[1] = s * u + l * d, t1[2] = s * f + l * m, t1[3] = s * h + l * g, t1;
                                        };
                                    },
                                    {}
                                ],
                                125: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            return t1 || 0 === t1 ? t1.toString() : "";
                                        };
                                    },
                                    {}
                                ],
                                126: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("vectorize-text");
                                        e1.exports = function(t1, e1, r) {
                                            var a = i[e1];
                                            a || (a = i[e1] = {});
                                            if (t1 in a) return a[t1];
                                            var o = {
                                                textAlign: "center",
                                                textBaseline: "middle",
                                                lineHeight: 1,
                                                font: e1,
                                                lineSpacing: 1.25,
                                                styletags: {
                                                    breaklines: !0,
                                                    bolds: !0,
                                                    italics: !0,
                                                    subscripts: !0,
                                                    superscripts: !0
                                                },
                                                triangles: !0
                                            }, s = n(t1, o);
                                            o.triangles = !1;
                                            var l, c, u = n(t1, o);
                                            if (r && 1 !== r) {
                                                for(l = 0; l < s.positions.length; ++l)for(c = 0; c < s.positions[l].length; ++c)s.positions[l][c] /= r;
                                                for(l = 0; l < u.positions.length; ++l)for(c = 0; c < u.positions[l].length; ++c)u.positions[l][c] /= r;
                                            }
                                            var f = [
                                                [
                                                    1 / 0,
                                                    1 / 0
                                                ],
                                                [
                                                    -1 / 0,
                                                    -1 / 0
                                                ]
                                            ], h = u.positions.length;
                                            for(l = 0; l < h; ++l){
                                                var p = u.positions[l];
                                                for(c = 0; c < 2; ++c)f[0][c] = Math.min(f[0][c], p[c]), f[1][c] = Math.max(f[1][c], p[c]);
                                            }
                                            return a[t1] = [
                                                s,
                                                u,
                                                f
                                            ];
                                        };
                                        var i = {};
                                    },
                                    {
                                        "vectorize-text": 311
                                    }
                                ],
                                127: [
                                    function(t1, e1, r) {
                                        var n = t1("gl-shader"), i = t1("glslify"), a = i([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform vec4 highlightId;\nuniform float highlightScale;\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = 1.0;\n    if(distance(highlightId, id) < 0.0001) {\n      scale = highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1);\n    vec4 viewPosition = view * worldPosition;\n    viewPosition = viewPosition / viewPosition.w;\n    vec4 clipPosition = projection * (viewPosition + scale * vec4(glyph.x, -glyph.y, 0, 0));\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"
                                        ]), o = i([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float highlightScale, pixelRatio;\nuniform vec4 highlightId;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = pixelRatio;\n    if(distance(highlightId.bgr, id.bgr) < 0.001) {\n      scale *= highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1.0);\n    vec4 viewPosition = view * worldPosition;\n    vec4 clipPosition = projection * viewPosition;\n    clipPosition /= clipPosition.w;\n\n    gl_Position = clipPosition + vec4(screenSize * scale * vec2(glyph.x, -glyph.y), 0.0, 0.0);\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"
                                        ]), s = i([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform float highlightScale;\nuniform vec4 highlightId;\nuniform vec3 axes[2];\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float scale, pixelRatio;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float lscale = pixelRatio * scale;\n    if(distance(highlightId, id) < 0.0001) {\n      lscale *= highlightScale;\n    }\n\n    vec4 clipCenter   = projection * view * model * vec4(position, 1);\n    vec3 dataPosition = position + 0.5*lscale*(axes[0] * glyph.x + axes[1] * glyph.y) * clipCenter.w * screenSize.y;\n    vec4 clipPosition = projection * view * model * vec4(dataPosition, 1);\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = dataPosition;\n  }\n}\n"
                                        ]), l = i([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float opacity;\n\nvarying vec4 interpColor;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (\n    outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate) ||\n    interpColor.a * opacity == 0.\n  ) discard;\n  gl_FragColor = interpColor * opacity;\n}\n"
                                        ]), c = i([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float pickGroup;\n\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate)) discard;\n\n  gl_FragColor = vec4(pickGroup, pickId.bgr);\n}"
                                        ]), u = [
                                            {
                                                name: "position",
                                                type: "vec3"
                                            },
                                            {
                                                name: "color",
                                                type: "vec4"
                                            },
                                            {
                                                name: "glyph",
                                                type: "vec2"
                                            },
                                            {
                                                name: "id",
                                                type: "vec4"
                                            }
                                        ], f = {
                                            vertex: a,
                                            fragment: l,
                                            attributes: u
                                        }, h = {
                                            vertex: o,
                                            fragment: l,
                                            attributes: u
                                        }, p = {
                                            vertex: s,
                                            fragment: l,
                                            attributes: u
                                        }, d = {
                                            vertex: a,
                                            fragment: c,
                                            attributes: u
                                        }, m = {
                                            vertex: o,
                                            fragment: c,
                                            attributes: u
                                        }, g = {
                                            vertex: s,
                                            fragment: c,
                                            attributes: u
                                        };
                                        function v(t1, e1) {
                                            var r = n(t1, e1), i = r.attributes;
                                            return i.position.location = 0, i.color.location = 1, i.glyph.location = 2, i.id.location = 3, r;
                                        }
                                        r.createPerspective = function(t1) {
                                            return v(t1, f);
                                        }, r.createOrtho = function(t1) {
                                            return v(t1, h);
                                        }, r.createProject = function(t1) {
                                            return v(t1, p);
                                        }, r.createPickPerspective = function(t1) {
                                            return v(t1, d);
                                        }, r.createPickOrtho = function(t1) {
                                            return v(t1, m);
                                        }, r.createPickProject = function(t1) {
                                            return v(t1, g);
                                        };
                                    },
                                    {
                                        "gl-shader": 132,
                                        glslify: 231
                                    }
                                ],
                                128: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("is-string-blank"), i = t1("gl-buffer"), a = t1("gl-vao"), o = t1("typedarray-pool"), s = t1("gl-mat4/multiply"), l = t1("./lib/shaders"), c = t1("./lib/glyphs"), u = t1("./lib/get-simple-string"), f = [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                        function h(t1, e1) {
                                            var r = t1[0], n = t1[1], i = t1[2], a = t1[3];
                                            return t1[0] = e1[0] * r + e1[4] * n + e1[8] * i + e1[12] * a, t1[1] = e1[1] * r + e1[5] * n + e1[9] * i + e1[13] * a, t1[2] = e1[2] * r + e1[6] * n + e1[10] * i + e1[14] * a, t1[3] = e1[3] * r + e1[7] * n + e1[11] * i + e1[15] * a, t1;
                                        }
                                        function p(t1, e1, r, n) {
                                            return h(n, n), h(n, n), h(n, n);
                                        }
                                        function d(t1, e1) {
                                            this.index = t1, this.dataCoordinate = this.position = e1;
                                        }
                                        function m(t1) {
                                            return !0 === t1 || t1 > 1 ? 1 : t1;
                                        }
                                        function g(t1, e1, r, n, i, a, o, s, l, c, u, f) {
                                            this.gl = t1, this.pixelRatio = 1, this.shader = e1, this.orthoShader = r, this.projectShader = n, this.pointBuffer = i, this.colorBuffer = a, this.glyphBuffer = o, this.idBuffer = s, this.vao = l, this.vertexCount = 0, this.lineVertexCount = 0, this.opacity = 1, this.hasAlpha = !1, this.lineWidth = 0, this.projectScale = [
                                                2 / 3,
                                                2 / 3,
                                                2 / 3
                                            ], this.projectOpacity = [
                                                1,
                                                1,
                                                1
                                            ], this.projectHasAlpha = !1, this.pickId = 0, this.pickPerspectiveShader = c, this.pickOrthoShader = u, this.pickProjectShader = f, this.points = [], this._selectResult = new d(0, [
                                                0,
                                                0,
                                                0
                                            ]), this.useOrtho = !0, this.bounds = [
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ],
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ]
                                            ], this.axesProject = [
                                                !0,
                                                !0,
                                                !0
                                            ], this.axesBounds = [
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ],
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ]
                                            ], this.highlightId = [
                                                1,
                                                1,
                                                1,
                                                1
                                            ], this.highlightScale = 2, this.clipBounds = [
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ],
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ]
                                            ], this.dirty = !0;
                                        }
                                        e1.exports = function(t1) {
                                            var e1 = t1.gl, r = l.createPerspective(e1), n = l.createOrtho(e1), o = l.createProject(e1), s = l.createPickPerspective(e1), c = l.createPickOrtho(e1), u = l.createPickProject(e1), f = i(e1), h = i(e1), p = i(e1), d = i(e1), m = a(e1, [
                                                {
                                                    buffer: f,
                                                    size: 3,
                                                    type: e1.FLOAT
                                                },
                                                {
                                                    buffer: h,
                                                    size: 4,
                                                    type: e1.FLOAT
                                                },
                                                {
                                                    buffer: p,
                                                    size: 2,
                                                    type: e1.FLOAT
                                                },
                                                {
                                                    buffer: d,
                                                    size: 4,
                                                    type: e1.UNSIGNED_BYTE,
                                                    normalized: !0
                                                }
                                            ]), v = new g(e1, r, n, o, f, h, p, d, m, s, c, u);
                                            return v.update(t1), v;
                                        };
                                        var v = g.prototype;
                                        v.pickSlots = 1, v.setPickBase = function(t1) {
                                            this.pickId = t1;
                                        }, v.isTransparent = function() {
                                            if (this.hasAlpha) return !0;
                                            for(var t1 = 0; t1 < 3; ++t1)if (this.axesProject[t1] && this.projectHasAlpha) return !0;
                                            return !1;
                                        }, v.isOpaque = function() {
                                            if (!this.hasAlpha) return !0;
                                            for(var t1 = 0; t1 < 3; ++t1)if (this.axesProject[t1] && !this.projectHasAlpha) return !0;
                                            return !1;
                                        };
                                        var y = [
                                            0,
                                            0
                                        ], x = [
                                            0,
                                            0,
                                            0
                                        ], b = [
                                            0,
                                            0,
                                            0
                                        ], _ = [
                                            0,
                                            0,
                                            0,
                                            1
                                        ], w = [
                                            0,
                                            0,
                                            0,
                                            1
                                        ], T = f.slice(), k = [
                                            0,
                                            0,
                                            0
                                        ], A = [
                                            [
                                                0,
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0,
                                                0
                                            ]
                                        ];
                                        function M(t1) {
                                            return t1[0] = t1[1] = t1[2] = 0, t1;
                                        }
                                        function S(t1, e1) {
                                            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = 1, t1;
                                        }
                                        function E(t1, e1, r, n) {
                                            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[r] = n, t1;
                                        }
                                        function L(t1, e1, r, n) {
                                            var i, a = e1.axesProject, o = e1.gl, l = t1.uniforms, c = r.model || f, u = r.view || f, h = r.projection || f, d = e1.axesBounds, m = function(t1) {
                                                for(var e1 = A, r = 0; r < 2; ++r)for(var n = 0; n < 3; ++n)e1[r][n] = Math.max(Math.min(t1[r][n], 1e8), -100000000);
                                                return e1;
                                            }(e1.clipBounds);
                                            i = e1.axes && e1.axes.lastCubeProps ? e1.axes.lastCubeProps.axis : [
                                                1,
                                                1,
                                                1
                                            ], y[0] = 2 / o.drawingBufferWidth, y[1] = 2 / o.drawingBufferHeight, t1.bind(), l.view = u, l.projection = h, l.screenSize = y, l.highlightId = e1.highlightId, l.highlightScale = e1.highlightScale, l.clipBounds = m, l.pickGroup = e1.pickId / 255, l.pixelRatio = n;
                                            for(var g = 0; g < 3; ++g)if (a[g]) {
                                                l.scale = e1.projectScale[g], l.opacity = e1.projectOpacity[g];
                                                for(var v = T, L = 0; L < 16; ++L)v[L] = 0;
                                                for(L = 0; L < 4; ++L)v[5 * L] = 1;
                                                v[5 * g] = 0, i[g] < 0 ? v[12 + g] = d[0][g] : v[12 + g] = d[1][g], s(v, c, v), l.model = v;
                                                var C = (g + 1) % 3, P = (g + 2) % 3, I = M(x), O = M(b);
                                                I[C] = 1, O[P] = 1;
                                                var z = p(0, 0, 0, S(_, I)), D = p(0, 0, 0, S(w, O));
                                                if (Math.abs(z[1]) > Math.abs(D[1])) {
                                                    var R = z;
                                                    z = D, D = R, R = I, I = O, O = R;
                                                    var F = C;
                                                    C = P, P = F;
                                                }
                                                z[0] < 0 && (I[C] = -1), D[1] > 0 && (O[P] = -1);
                                                var B = 0, N = 0;
                                                for(L = 0; L < 4; ++L)B += Math.pow(c[4 * C + L], 2), N += Math.pow(c[4 * P + L], 2);
                                                I[C] /= Math.sqrt(B), O[P] /= Math.sqrt(N), l.axes[0] = I, l.axes[1] = O, l.fragClipBounds[0] = E(k, m[0], g, -100000000), l.fragClipBounds[1] = E(k, m[1], g, 1e8), e1.vao.bind(), e1.vao.draw(o.TRIANGLES, e1.vertexCount), e1.lineWidth > 0 && (o.lineWidth(e1.lineWidth * n), e1.vao.draw(o.LINES, e1.lineVertexCount, e1.vertexCount)), e1.vao.unbind();
                                            }
                                        }
                                        var C = [
                                            [
                                                -100000000,
                                                -100000000,
                                                -100000000
                                            ],
                                            [
                                                1e8,
                                                1e8,
                                                1e8
                                            ]
                                        ];
                                        function P(t1, e1, r, n, i, a, o) {
                                            var s = r.gl;
                                            if ((a === r.projectHasAlpha || o) && L(e1, r, n, i), a === r.hasAlpha || o) {
                                                t1.bind();
                                                var l = t1.uniforms;
                                                l.model = n.model || f, l.view = n.view || f, l.projection = n.projection || f, y[0] = 2 / s.drawingBufferWidth, y[1] = 2 / s.drawingBufferHeight, l.screenSize = y, l.highlightId = r.highlightId, l.highlightScale = r.highlightScale, l.fragClipBounds = C, l.clipBounds = r.axes.bounds, l.opacity = r.opacity, l.pickGroup = r.pickId / 255, l.pixelRatio = i, r.vao.bind(), r.vao.draw(s.TRIANGLES, r.vertexCount), r.lineWidth > 0 && (s.lineWidth(r.lineWidth * i), r.vao.draw(s.LINES, r.lineVertexCount, r.vertexCount)), r.vao.unbind();
                                            }
                                        }
                                        function I(t1, e1, r, i) {
                                            var a;
                                            a = Array.isArray(t1) ? e1 < t1.length ? t1[e1] : void 0 : t1, a = u(a);
                                            var o = !0;
                                            n(a) && (a = "\u25bc", o = !1);
                                            var s = c(a, r, i);
                                            return {
                                                mesh: s[0],
                                                lines: s[1],
                                                bounds: s[2],
                                                visible: o
                                            };
                                        }
                                        v.draw = function(t1) {
                                            P(this.useOrtho ? this.orthoShader : this.shader, this.projectShader, this, t1, this.pixelRatio, !1, !1);
                                        }, v.drawTransparent = function(t1) {
                                            P(this.useOrtho ? this.orthoShader : this.shader, this.projectShader, this, t1, this.pixelRatio, !0, !1);
                                        }, v.drawPick = function(t1) {
                                            P(this.useOrtho ? this.pickOrthoShader : this.pickPerspectiveShader, this.pickProjectShader, this, t1, 1, !0, !0);
                                        }, v.pick = function(t1) {
                                            if (!t1) return null;
                                            if (t1.id !== this.pickId) return null;
                                            var e1 = t1.value[2] + (t1.value[1] << 8) + (t1.value[0] << 16);
                                            if (e1 >= this.pointCount || e1 < 0) return null;
                                            var r = this.points[e1], n = this._selectResult;
                                            n.index = e1;
                                            for(var i = 0; i < 3; ++i)n.position[i] = n.dataCoordinate[i] = r[i];
                                            return n;
                                        }, v.highlight = function(t1) {
                                            if (t1) {
                                                var e1 = t1.index, r = 255 & e1, n = e1 >> 8 & 255, i = e1 >> 16 & 255;
                                                this.highlightId = [
                                                    r / 255,
                                                    n / 255,
                                                    i / 255,
                                                    0
                                                ];
                                            } else this.highlightId = [
                                                1,
                                                1,
                                                1,
                                                1
                                            ];
                                        }, v.update = function(t1) {
                                            if ("perspective" in (t1 = t1 || {}) && (this.useOrtho = !t1.perspective), "orthographic" in t1 && (this.useOrtho = !!t1.orthographic), "lineWidth" in t1 && (this.lineWidth = t1.lineWidth), "project" in t1) {
                                                if (Array.isArray(t1.project)) this.axesProject = t1.project;
                                                else {
                                                    var e1 = !!t1.project;
                                                    this.axesProject = [
                                                        e1,
                                                        e1,
                                                        e1
                                                    ];
                                                }
                                            }
                                            if ("projectScale" in t1) {
                                                if (Array.isArray(t1.projectScale)) this.projectScale = t1.projectScale.slice();
                                                else {
                                                    var r = +t1.projectScale;
                                                    this.projectScale = [
                                                        r,
                                                        r,
                                                        r
                                                    ];
                                                }
                                            }
                                            if (this.projectHasAlpha = !1, "projectOpacity" in t1) {
                                                if (Array.isArray(t1.projectOpacity)) this.projectOpacity = t1.projectOpacity.slice();
                                                else {
                                                    r = +t1.projectOpacity;
                                                    this.projectOpacity = [
                                                        r,
                                                        r,
                                                        r
                                                    ];
                                                }
                                                for(var n = 0; n < 3; ++n)this.projectOpacity[n] = m(this.projectOpacity[n]), this.projectOpacity[n] < 1 && (this.projectHasAlpha = !0);
                                            }
                                            this.hasAlpha = !1, "opacity" in t1 && (this.opacity = m(t1.opacity), this.opacity < 1 && (this.hasAlpha = !0)), this.dirty = !0;
                                            var i, a, s = t1.position, l = t1.font || "normal", c = t1.alignment || [
                                                0,
                                                0
                                            ];
                                            if (2 === c.length) i = c[0], a = c[1];
                                            else {
                                                i = [], a = [];
                                                for(n = 0; n < c.length; ++n)i[n] = c[n][0], a[n] = c[n][1];
                                            }
                                            var u = [
                                                1 / 0,
                                                1 / 0,
                                                1 / 0
                                            ], f = [
                                                -1 / 0,
                                                -1 / 0,
                                                -1 / 0
                                            ], h = t1.glyph, p = t1.color, d = t1.size, g = t1.angle, v = t1.lineColor, y = -1, x = 0, b = 0, _ = 0;
                                            if (s.length) {
                                                _ = s.length;
                                                t: for(n = 0; n < _; ++n){
                                                    for(var w = s[n], T = 0; T < 3; ++T)if (isNaN(w[T]) || !isFinite(w[T])) continue t;
                                                    var k = (N = I(h, n, l, this.pixelRatio)).mesh, A = N.lines, M = N.bounds;
                                                    x += 3 * k.cells.length, b += 2 * A.edges.length;
                                                }
                                            }
                                            var S = x + b, E = o.mallocFloat(3 * S), L = o.mallocFloat(4 * S), C = o.mallocFloat(2 * S), P = o.mallocUint32(S);
                                            if (S > 0) {
                                                var O = 0, z = x, D = [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ], R = [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ], F = Array.isArray(p) && Array.isArray(p[0]), B = Array.isArray(v) && Array.isArray(v[0]);
                                                t: for(n = 0; n < _; ++n){
                                                    y += 1;
                                                    for(w = s[n], T = 0; T < 3; ++T){
                                                        if (isNaN(w[T]) || !isFinite(w[T])) continue t;
                                                        f[T] = Math.max(f[T], w[T]), u[T] = Math.min(u[T], w[T]);
                                                    }
                                                    k = (N = I(h, n, l, this.pixelRatio)).mesh, A = N.lines, M = N.bounds;
                                                    var N, j = N.visible;
                                                    if (j) {
                                                        if (Array.isArray(p)) {
                                                            if (3 === (U = F ? n < p.length ? p[n] : [
                                                                0,
                                                                0,
                                                                0,
                                                                0
                                                            ] : p).length) {
                                                                for(T = 0; T < 3; ++T)D[T] = U[T];
                                                                D[3] = 1;
                                                            } else if (4 === U.length) {
                                                                for(T = 0; T < 4; ++T)D[T] = U[T];
                                                                !this.hasAlpha && U[3] < 1 && (this.hasAlpha = !0);
                                                            }
                                                        } else D[0] = D[1] = D[2] = 0, D[3] = 1;
                                                    } else D = [
                                                        1,
                                                        1,
                                                        1,
                                                        0
                                                    ];
                                                    if (j) {
                                                        if (Array.isArray(v)) {
                                                            var U;
                                                            if (3 === (U = B ? n < v.length ? v[n] : [
                                                                0,
                                                                0,
                                                                0,
                                                                0
                                                            ] : v).length) {
                                                                for(T = 0; T < 3; ++T)R[T] = U[T];
                                                                R[T] = 1;
                                                            } else if (4 === U.length) {
                                                                for(T = 0; T < 4; ++T)R[T] = U[T];
                                                                !this.hasAlpha && U[3] < 1 && (this.hasAlpha = !0);
                                                            }
                                                        } else R[0] = R[1] = R[2] = 0, R[3] = 1;
                                                    } else R = [
                                                        1,
                                                        1,
                                                        1,
                                                        0
                                                    ];
                                                    var V = .5;
                                                    j ? Array.isArray(d) ? V = n < d.length ? +d[n] : 12 : d ? V = +d : this.useOrtho && (V = 12) : V = 0;
                                                    var H = 0;
                                                    Array.isArray(g) ? H = n < g.length ? +g[n] : 0 : g && (H = +g);
                                                    var q = Math.cos(H), G = Math.sin(H);
                                                    for(w = s[n], T = 0; T < 3; ++T)f[T] = Math.max(f[T], w[T]), u[T] = Math.min(u[T], w[T]);
                                                    var Y = i, W = a;
                                                    Y = 0;
                                                    Array.isArray(i) ? Y = n < i.length ? i[n] : 0 : i && (Y = i);
                                                    W = 0;
                                                    Array.isArray(a) ? W = n < a.length ? a[n] : 0 : a && (W = a);
                                                    var X = [
                                                        Y *= Y > 0 ? 1 - M[0][0] : Y < 0 ? 1 + M[1][0] : 1,
                                                        W *= W > 0 ? 1 - M[0][1] : W < 0 ? 1 + M[1][1] : 1
                                                    ], Z = k.cells || [], J = k.positions || [];
                                                    for(T = 0; T < Z.length; ++T)for(var K = Z[T], Q = 0; Q < 3; ++Q){
                                                        for(var $ = 0; $ < 3; ++$)E[3 * O + $] = w[$];
                                                        for($ = 0; $ < 4; ++$)L[4 * O + $] = D[$];
                                                        P[O] = y;
                                                        var tt = J[K[Q]];
                                                        C[2 * O] = V * (q * tt[0] - G * tt[1] + X[0]), C[2 * O + 1] = V * (G * tt[0] + q * tt[1] + X[1]), O += 1;
                                                    }
                                                    for(Z = A.edges, J = A.positions, T = 0; T < Z.length; ++T)for(K = Z[T], Q = 0; Q < 2; ++Q){
                                                        for($ = 0; $ < 3; ++$)E[3 * z + $] = w[$];
                                                        for($ = 0; $ < 4; ++$)L[4 * z + $] = R[$];
                                                        P[z] = y;
                                                        tt = J[K[Q]];
                                                        C[2 * z] = V * (q * tt[0] - G * tt[1] + X[0]), C[2 * z + 1] = V * (G * tt[0] + q * tt[1] + X[1]), z += 1;
                                                    }
                                                }
                                            }
                                            this.bounds = [
                                                u,
                                                f
                                            ], this.points = s, this.pointCount = s.length, this.vertexCount = x, this.lineVertexCount = b, this.pointBuffer.update(E), this.colorBuffer.update(L), this.glyphBuffer.update(C), this.idBuffer.update(P), o.free(E), o.free(L), o.free(C), o.free(P);
                                        }, v.dispose = function() {
                                            this.shader.dispose(), this.orthoShader.dispose(), this.pickPerspectiveShader.dispose(), this.pickOrthoShader.dispose(), this.vao.dispose(), this.pointBuffer.dispose(), this.colorBuffer.dispose(), this.glyphBuffer.dispose(), this.idBuffer.dispose();
                                        };
                                    },
                                    {
                                        "./lib/get-simple-string": 125,
                                        "./lib/glyphs": 126,
                                        "./lib/shaders": 127,
                                        "gl-buffer": 78,
                                        "gl-mat4/multiply": 100,
                                        "gl-vao": 150,
                                        "is-string-blank": 239,
                                        "typedarray-pool": 308
                                    }
                                ],
                                129: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("glslify");
                                        r.boxVertex = n([
                                            "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 vertex;\n\nuniform vec2 cornerA, cornerB;\n\nvoid main() {\n  gl_Position = vec4(mix(cornerA, cornerB, vertex), 0, 1);\n}\n"
                                        ]), r.boxFragment = n([
                                            "precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color;\n\nvoid main() {\n  gl_FragColor = color;\n}\n"
                                        ]);
                                    },
                                    {
                                        glslify: 231
                                    }
                                ],
                                130: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("gl-shader"), i = t1("gl-buffer"), a = t1("./lib/shaders");
                                        function o(t1, e1, r) {
                                            this.plot = t1, this.boxBuffer = e1, this.boxShader = r, this.enabled = !0, this.selectBox = [
                                                1 / 0,
                                                1 / 0,
                                                -1 / 0,
                                                -1 / 0
                                            ], this.borderColor = [
                                                0,
                                                0,
                                                0,
                                                1
                                            ], this.innerFill = !1, this.innerColor = [
                                                0,
                                                0,
                                                0,
                                                .25
                                            ], this.outerFill = !0, this.outerColor = [
                                                0,
                                                0,
                                                0,
                                                .5
                                            ], this.borderWidth = 10;
                                        }
                                        e1.exports = function(t1, e1) {
                                            var r = t1.gl, s = i(r, [
                                                0,
                                                0,
                                                0,
                                                1,
                                                1,
                                                0,
                                                1,
                                                1
                                            ]), l = n(r, a.boxVertex, a.boxFragment), c = new o(t1, s, l);
                                            return c.update(e1), t1.addOverlay(c), c;
                                        };
                                        var s = o.prototype;
                                        s.draw = function() {
                                            if (this.enabled) {
                                                var t1 = this.plot, e1 = this.selectBox, r = this.borderWidth, n = (this.innerFill, this.innerColor), i = (this.outerFill, this.outerColor), a = this.borderColor, o = t1.box, s = t1.screenBox, l = t1.dataBox, c = t1.viewBox, u = t1.pixelRatio, f = (e1[0] - l[0]) * (c[2] - c[0]) / (l[2] - l[0]) + c[0], h = (e1[1] - l[1]) * (c[3] - c[1]) / (l[3] - l[1]) + c[1], p = (e1[2] - l[0]) * (c[2] - c[0]) / (l[2] - l[0]) + c[0], d = (e1[3] - l[1]) * (c[3] - c[1]) / (l[3] - l[1]) + c[1];
                                                if (f = Math.max(f, c[0]), h = Math.max(h, c[1]), p = Math.min(p, c[2]), d = Math.min(d, c[3]), !(p < f || d < h)) {
                                                    o.bind();
                                                    var m = s[2] - s[0], g = s[3] - s[1];
                                                    if (this.outerFill && (o.drawBox(0, 0, m, h, i), o.drawBox(0, h, f, d, i), o.drawBox(0, d, m, g, i), o.drawBox(p, h, m, d, i)), this.innerFill && o.drawBox(f, h, p, d, n), r > 0) {
                                                        var v = r * u;
                                                        o.drawBox(f - v, h - v, p + v, h + v, a), o.drawBox(f - v, d - v, p + v, d + v, a), o.drawBox(f - v, h - v, f + v, d + v, a), o.drawBox(p - v, h - v, p + v, d + v, a);
                                                    }
                                                }
                                            }
                                        }, s.update = function(t1) {
                                            t1 = t1 || {}, this.innerFill = !!t1.innerFill, this.outerFill = !!t1.outerFill, this.innerColor = (t1.innerColor || [
                                                0,
                                                0,
                                                0,
                                                .5
                                            ]).slice(), this.outerColor = (t1.outerColor || [
                                                0,
                                                0,
                                                0,
                                                .5
                                            ]).slice(), this.borderColor = (t1.borderColor || [
                                                0,
                                                0,
                                                0,
                                                1
                                            ]).slice(), this.borderWidth = t1.borderWidth || 0, this.selectBox = (t1.selectBox || this.selectBox).slice();
                                        }, s.dispose = function() {
                                            this.boxBuffer.dispose(), this.boxShader.dispose(), this.plot.removeOverlay(this);
                                        };
                                    },
                                    {
                                        "./lib/shaders": 129,
                                        "gl-buffer": 78,
                                        "gl-shader": 132
                                    }
                                ],
                                131: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            var r = e1[0], a = e1[1], o = n(t1, r, a, {}), s = i.mallocUint8(r * a * 4);
                                            return new l(t1, o, s);
                                        };
                                        var n = t1("gl-fbo"), i = t1("typedarray-pool"), a = t1("ndarray"), o = t1("bit-twiddle").nextPow2;
                                        function s(t1, e1, r, n, i) {
                                            this.coord = [
                                                t1,
                                                e1
                                            ], this.id = r, this.value = n, this.distance = i;
                                        }
                                        function l(t1, e1, r) {
                                            this.gl = t1, this.fbo = e1, this.buffer = r, this._readTimeout = null;
                                            var n = this;
                                            this._readCallback = function() {
                                                n.gl && (e1.bind(), t1.readPixels(0, 0, e1.shape[0], e1.shape[1], t1.RGBA, t1.UNSIGNED_BYTE, n.buffer), n._readTimeout = null);
                                            };
                                        }
                                        var c = l.prototype;
                                        Object.defineProperty(c, "shape", {
                                            get: function() {
                                                return this.gl ? this.fbo.shape.slice() : [
                                                    0,
                                                    0
                                                ];
                                            },
                                            set: function(t1) {
                                                if (this.gl) {
                                                    this.fbo.shape = t1;
                                                    var e1 = this.fbo.shape[0], r = this.fbo.shape[1];
                                                    if (r * e1 * 4 > this.buffer.length) {
                                                        i.free(this.buffer);
                                                        for(var n = this.buffer = i.mallocUint8(o(r * e1 * 4)), a = 0; a < r * e1 * 4; ++a)n[a] = 255;
                                                    }
                                                    return t1;
                                                }
                                            }
                                        }), c.begin = function() {
                                            var t1 = this.gl;
                                            this.shape;
                                            t1 && (this.fbo.bind(), t1.clearColor(1, 1, 1, 1), t1.clear(t1.COLOR_BUFFER_BIT | t1.DEPTH_BUFFER_BIT));
                                        }, c.end = function() {
                                            var t1 = this.gl;
                                            t1 && (t1.bindFramebuffer(t1.FRAMEBUFFER, null), this._readTimeout || clearTimeout(this._readTimeout), this._readTimeout = setTimeout(this._readCallback, 1));
                                        }, c.query = function(t1, e1, r) {
                                            if (!this.gl) return null;
                                            var n = this.fbo.shape.slice();
                                            t1 |= 0, e1 |= 0, "number" != typeof r && (r = 1);
                                            var i = 0 | Math.min(Math.max(t1 - r, 0), n[0]), o = 0 | Math.min(Math.max(t1 + r, 0), n[0]), l = 0 | Math.min(Math.max(e1 - r, 0), n[1]), c = 0 | Math.min(Math.max(e1 + r, 0), n[1]);
                                            if (o <= i || c <= l) return null;
                                            var u = [
                                                o - i,
                                                c - l
                                            ], f = a(this.buffer, [
                                                u[0],
                                                u[1],
                                                4
                                            ], [
                                                4,
                                                4 * n[0],
                                                1
                                            ], 4 * (i + n[0] * l)), h = function(t1, e1, r) {
                                                for(var n = 1e8, i = -1, a = -1, o = t1.shape[0], s = t1.shape[1], l = 0; l < o; l++)for(var c = 0; c < s; c++){
                                                    var u = t1.get(l, c, 0), f = t1.get(l, c, 1), h = t1.get(l, c, 2), p = t1.get(l, c, 3);
                                                    if (u < 255 || f < 255 || h < 255 || p < 255) {
                                                        var d = e1 - l, m = r - c, g = d * d + m * m;
                                                        g < n && (n = g, i = l, a = c);
                                                    }
                                                }
                                                return [
                                                    i,
                                                    a,
                                                    n
                                                ];
                                            }(f.hi(u[0], u[1], 1), r, r), p = h[0], d = h[1];
                                            return p < 0 || Math.pow(this.radius, 2) < h[2] ? null : new s(p + i | 0, d + l | 0, f.get(p, d, 0), [
                                                f.get(p, d, 1),
                                                f.get(p, d, 2),
                                                f.get(p, d, 3)
                                            ], Math.sqrt(h[2]));
                                        }, c.dispose = function() {
                                            this.gl && (this.fbo.dispose(), i.free(this.buffer), this.gl = null, this._readTimeout && clearTimeout(this._readTimeout));
                                        };
                                    },
                                    {
                                        "bit-twiddle": 32,
                                        "gl-fbo": 86,
                                        ndarray: 259,
                                        "typedarray-pool": 308
                                    }
                                ],
                                132: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./lib/create-uniforms"), i = t1("./lib/create-attributes"), a = t1("./lib/reflect"), o = t1("./lib/shader-cache"), s = t1("./lib/runtime-reflect"), l = t1("./lib/GLError");
                                        function c(t1) {
                                            this.gl = t1, this.gl.lastAttribCount = 0, this._vref = this._fref = this._relink = this.vertShader = this.fragShader = this.program = this.attributes = this.uniforms = this.types = null;
                                        }
                                        var u = c.prototype;
                                        function f(t1, e1) {
                                            return t1.name < e1.name ? -1 : 1;
                                        }
                                        u.bind = function() {
                                            var t1;
                                            this.program || this._relink();
                                            var e1 = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_ATTRIBUTES), r = this.gl.lastAttribCount;
                                            if (e1 > r) for(t1 = r; t1 < e1; t1++)this.gl.enableVertexAttribArray(t1);
                                            else if (r > e1) for(t1 = e1; t1 < r; t1++)this.gl.disableVertexAttribArray(t1);
                                            this.gl.lastAttribCount = e1, this.gl.useProgram(this.program);
                                        }, u.dispose = function() {
                                            for(var t1 = this.gl.lastAttribCount, e1 = 0; e1 < t1; e1++)this.gl.disableVertexAttribArray(e1);
                                            this.gl.lastAttribCount = 0, this._fref && this._fref.dispose(), this._vref && this._vref.dispose(), this.attributes = this.types = this.vertShader = this.fragShader = this.program = this._relink = this._fref = this._vref = null;
                                        }, u.update = function(t1, e1, r, c) {
                                            if (!e1 || 1 === arguments.length) {
                                                var u = t1;
                                                t1 = u.vertex, e1 = u.fragment, r = u.uniforms, c = u.attributes;
                                            }
                                            var h = this, p = h.gl, d = h._vref;
                                            h._vref = o.shader(p, p.VERTEX_SHADER, t1), d && d.dispose(), h.vertShader = h._vref.shader;
                                            var m = this._fref;
                                            if (h._fref = o.shader(p, p.FRAGMENT_SHADER, e1), m && m.dispose(), h.fragShader = h._fref.shader, !r || !c) {
                                                var g = p.createProgram();
                                                if (p.attachShader(g, h.fragShader), p.attachShader(g, h.vertShader), p.linkProgram(g), !p.getProgramParameter(g, p.LINK_STATUS)) {
                                                    var v = p.getProgramInfoLog(g);
                                                    throw new l(v, "Error linking program:" + v);
                                                }
                                                r = r || s.uniforms(p, g), c = c || s.attributes(p, g), p.deleteProgram(g);
                                            }
                                            (c = c.slice()).sort(f);
                                            var y, x = [], b = [], _ = [];
                                            for(y = 0; y < c.length; ++y){
                                                var w = c[y];
                                                if (w.type.indexOf("mat") >= 0) {
                                                    for(var T = 0 | w.type.charAt(w.type.length - 1), k = new Array(T), A = 0; A < T; ++A)k[A] = _.length, b.push(w.name + "[" + A + "]"), "number" == typeof w.location ? _.push(w.location + A) : Array.isArray(w.location) && w.location.length === T && "number" == typeof w.location[A] ? _.push(0 | w.location[A]) : _.push(-1);
                                                    x.push({
                                                        name: w.name,
                                                        type: w.type,
                                                        locations: k
                                                    });
                                                } else x.push({
                                                    name: w.name,
                                                    type: w.type,
                                                    locations: [
                                                        _.length
                                                    ]
                                                }), b.push(w.name), "number" == typeof w.location ? _.push(0 | w.location) : _.push(-1);
                                            }
                                            var M = 0;
                                            for(y = 0; y < _.length; ++y)if (_[y] < 0) {
                                                for(; _.indexOf(M) >= 0;)M += 1;
                                                _[y] = M;
                                            }
                                            var S = new Array(r.length);
                                            function E() {
                                                h.program = o.program(p, h._vref, h._fref, b, _);
                                                for(var t1 = 0; t1 < r.length; ++t1)S[t1] = p.getUniformLocation(h.program, r[t1].name);
                                            }
                                            E(), h._relink = E, h.types = {
                                                uniforms: a(r),
                                                attributes: a(c)
                                            }, h.attributes = i(p, h, x, _), Object.defineProperty(h, "uniforms", n(p, h, r, S));
                                        }, e1.exports = function(t1, e1, r, n, i) {
                                            var a = new c(t1);
                                            return a.update(e1, r, n, i), a;
                                        };
                                    },
                                    {
                                        "./lib/GLError": 133,
                                        "./lib/create-attributes": 134,
                                        "./lib/create-uniforms": 135,
                                        "./lib/reflect": 136,
                                        "./lib/runtime-reflect": 137,
                                        "./lib/shader-cache": 138
                                    }
                                ],
                                133: [
                                    function(t1, e1, r) {
                                        function n(t1, e1, r) {
                                            this.shortMessage = e1 || "", this.longMessage = r || "", this.rawError = t1 || "", this.message = "gl-shader: " + (e1 || t1 || "") + (r ? "\n" + r : ""), this.stack = (new Error).stack;
                                        }
                                        n.prototype = new Error, n.prototype.name = "GLError", n.prototype.constructor = n, e1.exports = n;
                                    },
                                    {}
                                ],
                                134: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r, i) {
                                            for(var a = {}, o = 0, c = r.length; o < c; ++o){
                                                var u = r[o], f = u.name, h = u.type, p = u.locations;
                                                switch(h){
                                                    case "bool":
                                                    case "int":
                                                    case "float":
                                                        s(t1, e1, p[0], i, 1, a, f);
                                                        break;
                                                    default:
                                                        if (h.indexOf("vec") >= 0) {
                                                            if ((d = h.charCodeAt(h.length - 1) - 48) < 2 || d > 4) throw new n("", "Invalid data type for attribute " + f + ": " + h);
                                                            s(t1, e1, p[0], i, d, a, f);
                                                        } else {
                                                            if (!(h.indexOf("mat") >= 0)) throw new n("", "Unknown data type for attribute " + f + ": " + h);
                                                            var d;
                                                            if ((d = h.charCodeAt(h.length - 1) - 48) < 2 || d > 4) throw new n("", "Invalid data type for attribute " + f + ": " + h);
                                                            l(t1, e1, p, i, d, a, f);
                                                        }
                                                }
                                            }
                                            return a;
                                        };
                                        var n = t1("./GLError");
                                        function i(t1, e1, r, n, i, a) {
                                            this._gl = t1, this._wrapper = e1, this._index = r, this._locations = n, this._dimension = i, this._constFunc = a;
                                        }
                                        var a = i.prototype;
                                        a.pointer = function(t1, e1, r, n) {
                                            var i = this._gl, a = this._locations[this._index];
                                            i.vertexAttribPointer(a, this._dimension, t1 || i.FLOAT, !!e1, r || 0, n || 0), i.enableVertexAttribArray(a);
                                        }, a.set = function(t1, e1, r, n) {
                                            return this._constFunc(this._locations[this._index], t1, e1, r, n);
                                        }, Object.defineProperty(a, "location", {
                                            get: function() {
                                                return this._locations[this._index];
                                            },
                                            set: function(t1) {
                                                return t1 !== this._locations[this._index] && (this._locations[this._index] = 0 | t1, this._wrapper.program = null), 0 | t1;
                                            }
                                        });
                                        var o = [
                                            function(t1, e1, r) {
                                                return void 0 === r.length ? t1.vertexAttrib1f(e1, r) : t1.vertexAttrib1fv(e1, r);
                                            },
                                            function(t1, e1, r, n) {
                                                return void 0 === r.length ? t1.vertexAttrib2f(e1, r, n) : t1.vertexAttrib2fv(e1, r);
                                            },
                                            function(t1, e1, r, n, i) {
                                                return void 0 === r.length ? t1.vertexAttrib3f(e1, r, n, i) : t1.vertexAttrib3fv(e1, r);
                                            },
                                            function(t1, e1, r, n, i, a) {
                                                return void 0 === r.length ? t1.vertexAttrib4f(e1, r, n, i, a) : t1.vertexAttrib4fv(e1, r);
                                            }
                                        ];
                                        function s(t1, e1, r, n, a, s, l) {
                                            var c = o[a], u = new i(t1, e1, r, n, a, c);
                                            Object.defineProperty(s, l, {
                                                set: function(e1) {
                                                    return t1.disableVertexAttribArray(n[r]), c(t1, n[r], e1), e1;
                                                },
                                                get: function() {
                                                    return u;
                                                },
                                                enumerable: !0
                                            });
                                        }
                                        function l(t1, e1, r, n, i, a, o) {
                                            for(var l = new Array(i), c = new Array(i), u = 0; u < i; ++u)s(t1, e1, r[u], n, i, l, u), c[u] = l[u];
                                            Object.defineProperty(l, "location", {
                                                set: function(t1) {
                                                    if (Array.isArray(t1)) for(var e1 = 0; e1 < i; ++e1)c[e1].location = t1[e1];
                                                    else for(e1 = 0; e1 < i; ++e1)c[e1].location = t1 + e1;
                                                    return t1;
                                                },
                                                get: function() {
                                                    for(var t1 = new Array(i), e1 = 0; e1 < i; ++e1)t1[e1] = n[r[e1]];
                                                    return t1;
                                                },
                                                enumerable: !0
                                            }), l.pointer = function(e1, a, o, s) {
                                                e1 = e1 || t1.FLOAT, a = !!a, o = o || i * i, s = s || 0;
                                                for(var l = 0; l < i; ++l){
                                                    var c = n[r[l]];
                                                    t1.vertexAttribPointer(c, i, e1, a, o, s + l * i), t1.enableVertexAttribArray(c);
                                                }
                                            };
                                            var f = new Array(i), h = t1["vertexAttrib" + i + "fv"];
                                            Object.defineProperty(a, o, {
                                                set: function(e1) {
                                                    for(var a = 0; a < i; ++a){
                                                        var o = n[r[a]];
                                                        if (t1.disableVertexAttribArray(o), Array.isArray(e1[0])) h.call(t1, o, e1[a]);
                                                        else {
                                                            for(var s = 0; s < i; ++s)f[s] = e1[i * a + s];
                                                            h.call(t1, o, f);
                                                        }
                                                    }
                                                    return e1;
                                                },
                                                get: function() {
                                                    return l;
                                                },
                                                enumerable: !0
                                            });
                                        }
                                    },
                                    {
                                        "./GLError": 133
                                    }
                                ],
                                135: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./reflect"), i = t1("./GLError");
                                        function a(t1) {
                                            return function() {
                                                return t1;
                                            };
                                        }
                                        function o(t1, e1) {
                                            for(var r = new Array(t1), n = 0; n < t1; ++n)r[n] = e1;
                                            return r;
                                        }
                                        e1.exports = function(t1, e1, r, s) {
                                            function l(e1) {
                                                return function(n) {
                                                    for(var a = function t1(e1, r) {
                                                        if ("object" != typeof r) return [
                                                            [
                                                                e1,
                                                                r
                                                            ]
                                                        ];
                                                        var n = [];
                                                        for(var i in r){
                                                            var a = r[i], o = e1;
                                                            parseInt(i) + "" === i ? o += "[" + i + "]" : o += "." + i, "object" == typeof a ? n.push.apply(n, t1(o, a)) : n.push([
                                                                o,
                                                                a
                                                            ]);
                                                        }
                                                        return n;
                                                    }("", e1), o = 0; o < a.length; ++o){
                                                        var l = a[o], c = l[0], u = l[1];
                                                        if (s[u]) {
                                                            var f = n;
                                                            if ("string" == typeof c && (0 === c.indexOf(".") || 0 === c.indexOf("["))) {
                                                                var h = c;
                                                                if (0 === c.indexOf(".") && (h = c.slice(1)), h.indexOf("]") === h.length - 1) {
                                                                    var p = h.indexOf("["), d = h.slice(0, p), m = h.slice(p + 1, h.length - 1);
                                                                    f = d ? n[d][m] : n[m];
                                                                } else f = n[h];
                                                            }
                                                            var g, v = r[u].type;
                                                            switch(v){
                                                                case "bool":
                                                                case "int":
                                                                case "sampler2D":
                                                                case "samplerCube":
                                                                    t1.uniform1i(s[u], f);
                                                                    break;
                                                                case "float":
                                                                    t1.uniform1f(s[u], f);
                                                                    break;
                                                                default:
                                                                    var y = v.indexOf("vec");
                                                                    if (!(0 <= y && y <= 1 && v.length === 4 + y)) {
                                                                        if (0 === v.indexOf("mat") && 4 === v.length) {
                                                                            if ((g = v.charCodeAt(v.length - 1) - 48) < 2 || g > 4) throw new i("", "Invalid uniform dimension type for matrix " + name + ": " + v);
                                                                            t1["uniformMatrix" + g + "fv"](s[u], !1, f);
                                                                            break;
                                                                        }
                                                                        throw new i("", "Unknown uniform data type for " + name + ": " + v);
                                                                    }
                                                                    if ((g = v.charCodeAt(v.length - 1) - 48) < 2 || g > 4) throw new i("", "Invalid data type");
                                                                    switch(v.charAt(0)){
                                                                        case "b":
                                                                        case "i":
                                                                            t1["uniform" + g + "iv"](s[u], f);
                                                                            break;
                                                                        case "v":
                                                                            t1["uniform" + g + "fv"](s[u], f);
                                                                            break;
                                                                        default:
                                                                            throw new i("", "Unrecognized data type for vector " + name + ": " + v);
                                                                    }
                                                            }
                                                        }
                                                    }
                                                };
                                            }
                                            function c(t1, e1, n) {
                                                if ("object" == typeof n) {
                                                    var c = u(n);
                                                    Object.defineProperty(t1, e1, {
                                                        get: a(c),
                                                        set: l(n),
                                                        enumerable: !0,
                                                        configurable: !1
                                                    });
                                                } else s[n] ? Object.defineProperty(t1, e1, {
                                                    get: (f = n, function(t1, e1, r) {
                                                        return t1.getUniform(e1.program, r[f]);
                                                    }),
                                                    set: l(n),
                                                    enumerable: !0,
                                                    configurable: !1
                                                }) : t1[e1] = function(t1) {
                                                    switch(t1){
                                                        case "bool":
                                                            return !1;
                                                        case "int":
                                                        case "sampler2D":
                                                        case "samplerCube":
                                                        case "float":
                                                            return 0;
                                                        default:
                                                            var e1 = t1.indexOf("vec");
                                                            if (0 <= e1 && e1 <= 1 && t1.length === 4 + e1) {
                                                                if ((r = t1.charCodeAt(t1.length - 1) - 48) < 2 || r > 4) throw new i("", "Invalid data type");
                                                                return "b" === t1.charAt(0) ? o(r, !1) : o(r, 0);
                                                            }
                                                            if (0 === t1.indexOf("mat") && 4 === t1.length) {
                                                                var r;
                                                                if ((r = t1.charCodeAt(t1.length - 1) - 48) < 2 || r > 4) throw new i("", "Invalid uniform dimension type for matrix " + name + ": " + t1);
                                                                return o(r * r, 0);
                                                            }
                                                            throw new i("", "Unknown uniform data type for " + name + ": " + t1);
                                                    }
                                                }(r[n].type);
                                                var f;
                                            }
                                            function u(t1) {
                                                var e1;
                                                if (Array.isArray(t1)) {
                                                    e1 = new Array(t1.length);
                                                    for(var r = 0; r < t1.length; ++r)c(e1, r, t1[r]);
                                                } else for(var n in e1 = {}, t1)c(e1, n, t1[n]);
                                                return e1;
                                            }
                                            var f = n(r, !0);
                                            return {
                                                get: a(u(f)),
                                                set: l(f),
                                                enumerable: !0,
                                                configurable: !0
                                            };
                                        };
                                    },
                                    {
                                        "./GLError": 133,
                                        "./reflect": 136
                                    }
                                ],
                                136: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            for(var r = {}, n = 0; n < t1.length; ++n)for(var i = t1[n].name.split("."), a = r, o = 0; o < i.length; ++o){
                                                var s = i[o].split("[");
                                                if (s.length > 1) {
                                                    s[0] in a || (a[s[0]] = []), a = a[s[0]];
                                                    for(var l = 1; l < s.length; ++l){
                                                        var c = parseInt(s[l]);
                                                        l < s.length - 1 || o < i.length - 1 ? (c in a || (l < s.length - 1 ? a[c] = [] : a[c] = {}), a = a[c]) : a[c] = e1 ? n : t1[n].type;
                                                    }
                                                } else o < i.length - 1 ? (s[0] in a || (a[s[0]] = {}), a = a[s[0]]) : a[s[0]] = e1 ? n : t1[n].type;
                                            }
                                            return r;
                                        };
                                    },
                                    {}
                                ],
                                137: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        r.uniforms = function(t1, e1) {
                                            for(var r = t1.getProgramParameter(e1, t1.ACTIVE_UNIFORMS), n = [], i = 0; i < r; ++i){
                                                var o = t1.getActiveUniform(e1, i);
                                                if (o) {
                                                    var s = a(t1, o.type);
                                                    if (o.size > 1) for(var l = 0; l < o.size; ++l)n.push({
                                                        name: o.name.replace("[0]", "[" + l + "]"),
                                                        type: s
                                                    });
                                                    else n.push({
                                                        name: o.name,
                                                        type: s
                                                    });
                                                }
                                            }
                                            return n;
                                        }, r.attributes = function(t1, e1) {
                                            for(var r = t1.getProgramParameter(e1, t1.ACTIVE_ATTRIBUTES), n = [], i = 0; i < r; ++i){
                                                var o = t1.getActiveAttrib(e1, i);
                                                o && n.push({
                                                    name: o.name,
                                                    type: a(t1, o.type)
                                                });
                                            }
                                            return n;
                                        };
                                        var n = {
                                            FLOAT: "float",
                                            FLOAT_VEC2: "vec2",
                                            FLOAT_VEC3: "vec3",
                                            FLOAT_VEC4: "vec4",
                                            INT: "int",
                                            INT_VEC2: "ivec2",
                                            INT_VEC3: "ivec3",
                                            INT_VEC4: "ivec4",
                                            BOOL: "bool",
                                            BOOL_VEC2: "bvec2",
                                            BOOL_VEC3: "bvec3",
                                            BOOL_VEC4: "bvec4",
                                            FLOAT_MAT2: "mat2",
                                            FLOAT_MAT3: "mat3",
                                            FLOAT_MAT4: "mat4",
                                            SAMPLER_2D: "sampler2D",
                                            SAMPLER_CUBE: "samplerCube"
                                        }, i = null;
                                        function a(t1, e1) {
                                            if (!i) {
                                                var r = Object.keys(n);
                                                i = {};
                                                for(var a = 0; a < r.length; ++a){
                                                    var o = r[a];
                                                    i[t1[o]] = n[o];
                                                }
                                            }
                                            return i[e1];
                                        }
                                    },
                                    {}
                                ],
                                138: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        r.shader = function(t1, e1, r) {
                                            return u(t1).getShaderReference(e1, r);
                                        }, r.program = function(t1, e1, r, n, i) {
                                            return u(t1).getProgram(e1, r, n, i);
                                        };
                                        var n = t1("./GLError"), i = t1("gl-format-compiler-error"), a = new ("undefined" == typeof WeakMap ? t1("weakmap-shim") : WeakMap), o = 0;
                                        function s(t1, e1, r, n, i, a, o) {
                                            this.id = t1, this.src = e1, this.type = r, this.shader = n, this.count = a, this.programs = [], this.cache = o;
                                        }
                                        function l(t1) {
                                            this.gl = t1, this.shaders = [
                                                {},
                                                {}
                                            ], this.programs = {};
                                        }
                                        s.prototype.dispose = function() {
                                            if (0 == --this.count) {
                                                for(var t1 = this.cache, e1 = t1.gl, r = this.programs, n = 0, i = r.length; n < i; ++n){
                                                    var a = t1.programs[r[n]];
                                                    a && (delete t1.programs[n], e1.deleteProgram(a));
                                                }
                                                e1.deleteShader(this.shader), delete t1.shaders[this.type === e1.FRAGMENT_SHADER | 0][this.src];
                                            }
                                        };
                                        var c = l.prototype;
                                        function u(t1) {
                                            var e1 = a.get(t1);
                                            return e1 || (e1 = new l(t1), a.set(t1, e1)), e1;
                                        }
                                        c.getShaderReference = function(t1, e1) {
                                            var r = this.gl, a = this.shaders[t1 === r.FRAGMENT_SHADER | 0], l = a[e1];
                                            if (l && r.isShader(l.shader)) l.count += 1;
                                            else {
                                                var c = function(t1, e1, r) {
                                                    var a = t1.createShader(e1);
                                                    if (t1.shaderSource(a, r), t1.compileShader(a), !t1.getShaderParameter(a, t1.COMPILE_STATUS)) {
                                                        var o = t1.getShaderInfoLog(a);
                                                        try {
                                                            var s = i(o, r, e1);
                                                        } catch (t1) {
                                                            throw console.warn("Failed to format compiler error: " + t1), new n(o, "Error compiling shader:\n" + o);
                                                        }
                                                        throw new n(o, s.short, s.long);
                                                    }
                                                    return a;
                                                }(r, t1, e1);
                                                l = a[e1] = new s(o++, e1, t1, c, [], 1, this);
                                            }
                                            return l;
                                        }, c.getProgram = function(t1, e1, r, i) {
                                            var a = [
                                                t1.id,
                                                e1.id,
                                                r.join(":"),
                                                i.join(":")
                                            ].join("@"), o = this.programs[a];
                                            return o && this.gl.isProgram(o) || (this.programs[a] = o = function(t1, e1, r, i, a) {
                                                var o = t1.createProgram();
                                                t1.attachShader(o, e1), t1.attachShader(o, r);
                                                for(var s = 0; s < i.length; ++s)t1.bindAttribLocation(o, a[s], i[s]);
                                                if (t1.linkProgram(o), !t1.getProgramParameter(o, t1.LINK_STATUS)) {
                                                    var l = t1.getProgramInfoLog(o);
                                                    throw new n(l, "Error linking program: " + l);
                                                }
                                                return o;
                                            }(this.gl, t1.shader, e1.shader, r, i), t1.programs.push(a), e1.programs.push(a)), o;
                                        };
                                    },
                                    {
                                        "./GLError": 133,
                                        "gl-format-compiler-error": 87,
                                        "weakmap-shim": 316
                                    }
                                ],
                                139: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        function n(t1) {
                                            this.plot = t1, this.enable = [
                                                !0,
                                                !0,
                                                !1,
                                                !1
                                            ], this.width = [
                                                1,
                                                1,
                                                1,
                                                1
                                            ], this.color = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.center = [
                                                1 / 0,
                                                1 / 0
                                            ];
                                        }
                                        e1.exports = function(t1, e1) {
                                            var r = new n(t1);
                                            return r.update(e1), t1.addOverlay(r), r;
                                        };
                                        var i = n.prototype;
                                        i.update = function(t1) {
                                            t1 = t1 || {}, this.enable = (t1.enable || [
                                                !0,
                                                !0,
                                                !1,
                                                !1
                                            ]).slice(), this.width = (t1.width || [
                                                1,
                                                1,
                                                1,
                                                1
                                            ]).slice(), this.color = (t1.color || [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ]).map(function(t1) {
                                                return t1.slice();
                                            }), this.center = (t1.center || [
                                                1 / 0,
                                                1 / 0
                                            ]).slice(), this.plot.setOverlayDirty();
                                        }, i.draw = function() {
                                            var t1 = this.enable, e1 = this.width, r = this.color, n = this.center, i = this.plot, a = i.line, o = i.dataBox, s = i.viewBox;
                                            if (a.bind(), o[0] <= n[0] && n[0] <= o[2] && o[1] <= n[1] && n[1] <= o[3]) {
                                                var l = s[0] + (n[0] - o[0]) / (o[2] - o[0]) * (s[2] - s[0]), c = s[1] + (n[1] - o[1]) / (o[3] - o[1]) * (s[3] - s[1]);
                                                t1[0] && a.drawLine(l, c, s[0], c, e1[0], r[0]), t1[1] && a.drawLine(l, c, l, s[1], e1[1], r[1]), t1[2] && a.drawLine(l, c, s[2], c, e1[2], r[2]), t1[3] && a.drawLine(l, c, l, s[3], e1[3], r[3]);
                                            }
                                        }, i.dispose = function() {
                                            this.plot.removeOverlay(this);
                                        };
                                    },
                                    {}
                                ],
                                140: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("glslify"), i = t1("gl-shader"), a = n([
                                            "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 position, color;\nattribute float weight;\n\nuniform mat4 model, view, projection;\nuniform vec3 coordinates[3];\nuniform vec4 colors[3];\nuniform vec2 screenShape;\nuniform float lineWidth;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vertexPosition = mix(coordinates[0],\n    mix(coordinates[2], coordinates[1], 0.5 * (position + 1.0)), abs(position));\n\n  vec4 clipPos = projection * view * model * vec4(vertexPosition, 1.0);\n  vec2 clipOffset = (projection * view * model * vec4(color, 0.0)).xy;\n  vec2 delta = weight * clipOffset * screenShape;\n  vec2 lineOffset = normalize(vec2(delta.y, -delta.x)) / screenShape;\n\n  gl_Position   = vec4(clipPos.xy + clipPos.w * 0.5 * lineWidth * lineOffset, clipPos.z, clipPos.w);\n  fragColor     = color.x * colors[0] + color.y * colors[1] + color.z * colors[2];\n}\n"
                                        ]), o = n([
                                            "precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n  gl_FragColor = fragColor;\n}"
                                        ]);
                                        e1.exports = function(t1) {
                                            return i(t1, a, o, null, [
                                                {
                                                    name: "position",
                                                    type: "vec3"
                                                },
                                                {
                                                    name: "color",
                                                    type: "vec3"
                                                },
                                                {
                                                    name: "weight",
                                                    type: "float"
                                                }
                                            ]);
                                        };
                                    },
                                    {
                                        "gl-shader": 132,
                                        glslify: 231
                                    }
                                ],
                                141: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("gl-buffer"), i = t1("gl-vao"), a = t1("./shaders/index");
                                        e1.exports = function(t1, e1) {
                                            var r = [];
                                            function o(t1, e1, n, i, a, o) {
                                                var s = [
                                                    t1,
                                                    e1,
                                                    n,
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ];
                                                s[i + 3] = 1, s[i] = a, r.push.apply(r, s), s[6] = -1, r.push.apply(r, s), s[i] = o, r.push.apply(r, s), r.push.apply(r, s), s[6] = 1, r.push.apply(r, s), s[i] = a, r.push.apply(r, s);
                                            }
                                            o(0, 0, 0, 0, 0, 1), o(0, 0, 0, 1, 0, 1), o(0, 0, 0, 2, 0, 1), o(1, 0, 0, 1, -1, 1), o(1, 0, 0, 2, -1, 1), o(0, 1, 0, 0, -1, 1), o(0, 1, 0, 2, -1, 1), o(0, 0, 1, 0, -1, 1), o(0, 0, 1, 1, -1, 1);
                                            var l = n(t1, r), c = i(t1, [
                                                {
                                                    type: t1.FLOAT,
                                                    buffer: l,
                                                    size: 3,
                                                    offset: 0,
                                                    stride: 28
                                                },
                                                {
                                                    type: t1.FLOAT,
                                                    buffer: l,
                                                    size: 3,
                                                    offset: 12,
                                                    stride: 28
                                                },
                                                {
                                                    type: t1.FLOAT,
                                                    buffer: l,
                                                    size: 1,
                                                    offset: 24,
                                                    stride: 28
                                                }
                                            ]), u = a(t1);
                                            u.attributes.position.location = 0, u.attributes.color.location = 1, u.attributes.weight.location = 2;
                                            var f = new s(t1, l, c, u);
                                            return f.update(e1), f;
                                        };
                                        var o = [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                        function s(t1, e1, r, n) {
                                            this.gl = t1, this.buffer = e1, this.vao = r, this.shader = n, this.pixelRatio = 1, this.bounds = [
                                                [
                                                    -1000,
                                                    -1000,
                                                    -1000
                                                ],
                                                [
                                                    1e3,
                                                    1e3,
                                                    1e3
                                                ]
                                            ], this.position = [
                                                0,
                                                0,
                                                0
                                            ], this.lineWidth = [
                                                2,
                                                2,
                                                2
                                            ], this.colors = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.enabled = [
                                                !0,
                                                !0,
                                                !0
                                            ], this.drawSides = [
                                                !0,
                                                !0,
                                                !0
                                            ], this.axes = null;
                                        }
                                        var l = s.prototype, c = [
                                            0,
                                            0,
                                            0
                                        ], u = [
                                            0,
                                            0,
                                            0
                                        ], f = [
                                            0,
                                            0
                                        ];
                                        l.isTransparent = function() {
                                            return !1;
                                        }, l.drawTransparent = function(t1) {}, l.draw = function(t1) {
                                            var e1 = this.gl, r = this.vao, n = this.shader;
                                            r.bind(), n.bind();
                                            var i, a = t1.model || o, s = t1.view || o, l = t1.projection || o;
                                            this.axes && (i = this.axes.lastCubeProps.axis);
                                            for(var h = c, p = u, d = 0; d < 3; ++d)i && i[d] < 0 ? (h[d] = this.bounds[0][d], p[d] = this.bounds[1][d]) : (h[d] = this.bounds[1][d], p[d] = this.bounds[0][d]);
                                            f[0] = e1.drawingBufferWidth, f[1] = e1.drawingBufferHeight, n.uniforms.model = a, n.uniforms.view = s, n.uniforms.projection = l, n.uniforms.coordinates = [
                                                this.position,
                                                h,
                                                p
                                            ], n.uniforms.colors = this.colors, n.uniforms.screenShape = f;
                                            for(d = 0; d < 3; ++d)n.uniforms.lineWidth = this.lineWidth[d] * this.pixelRatio, this.enabled[d] && (r.draw(e1.TRIANGLES, 6, 6 * d), this.drawSides[d] && r.draw(e1.TRIANGLES, 12, 18 + 12 * d));
                                            r.unbind();
                                        }, l.update = function(t1) {
                                            t1 && ("bounds" in t1 && (this.bounds = t1.bounds), "position" in t1 && (this.position = t1.position), "lineWidth" in t1 && (this.lineWidth = t1.lineWidth), "colors" in t1 && (this.colors = t1.colors), "enabled" in t1 && (this.enabled = t1.enabled), "drawSides" in t1 && (this.drawSides = t1.drawSides));
                                        }, l.dispose = function() {
                                            this.vao.dispose(), this.buffer.dispose(), this.shader.dispose();
                                        };
                                    },
                                    {
                                        "./shaders/index": 140,
                                        "gl-buffer": 78,
                                        "gl-vao": 150
                                    }
                                ],
                                142: [
                                    function(t1, e1, r) {
                                        var n = t1("glslify"), i = n([
                                            "precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, tubeScale;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * tubePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(tubePosition, 1.0);\n  vec4 t_position  = view * tubePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = tubePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"
                                        ]), a = n([
                                            "#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"
                                        ]), o = n([
                                            "precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float tubeScale;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  gl_Position = projection * view * tubePosition;\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"
                                        ]), s = n([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"
                                        ]);
                                        r.meshShader = {
                                            vertex: i,
                                            fragment: a,
                                            attributes: [
                                                {
                                                    name: "position",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "color",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "uv",
                                                    type: "vec2"
                                                },
                                                {
                                                    name: "vector",
                                                    type: "vec4"
                                                }
                                            ]
                                        }, r.pickShader = {
                                            vertex: o,
                                            fragment: s,
                                            attributes: [
                                                {
                                                    name: "position",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "id",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "vector",
                                                    type: "vec4"
                                                }
                                            ]
                                        };
                                    },
                                    {
                                        glslify: 231
                                    }
                                ],
                                143: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("gl-vec3"), i = t1("gl-vec4"), a = [
                                            "xyz",
                                            "xzy",
                                            "yxz",
                                            "yzx",
                                            "zxy",
                                            "zyx"
                                        ], o = function(t1, e1, r, a) {
                                            for(var o = 0, s = 0; s < t1.length; s++)for(var l = t1[s].velocities, c = 0; c < l.length; c++)o = Math.max(o, n.length(l[c]));
                                            var u = t1.map(function(t1) {
                                                return function(t1, e1, r, a) {
                                                    for(var o = t1.points, s = t1.velocities, l = t1.divergences, c = [], u = [], f = [], h = [], p = [], d = [], m = 0, g = 0, v = i.create(), y = i.create(), x = 0; x < o.length; x++){
                                                        var b = o[x], _ = s[x], w = l[x];
                                                        0 === e1 && (w = .05 * r), g = n.length(_) / a, v = i.create(), n.copy(v, _), v[3] = w;
                                                        for(var T = 0; T < 8; T++)p[T] = [
                                                            b[0],
                                                            b[1],
                                                            b[2],
                                                            T
                                                        ];
                                                        if (h.length > 0) for(T = 0; T < 8; T++){
                                                            var k = (T + 1) % 8;
                                                            c.push(h[T], p[T], p[k], p[k], h[k], h[T]), f.push(y, v, v, v, y, y), d.push(m, g, g, g, m, m);
                                                            var A = c.length;
                                                            u.push([
                                                                A - 6,
                                                                A - 5,
                                                                A - 4
                                                            ], [
                                                                A - 3,
                                                                A - 2,
                                                                A - 1
                                                            ]);
                                                        }
                                                        var M = h;
                                                        h = p, p = M;
                                                        var S = y;
                                                        y = v, v = S;
                                                        var E = m;
                                                        m = g, g = E;
                                                    }
                                                    return {
                                                        positions: c,
                                                        cells: u,
                                                        vectors: f,
                                                        vertexIntensity: d
                                                    };
                                                }(t1, r, a, o);
                                            }), f = [], h = [], p = [], d = [];
                                            for(s = 0; s < u.length; s++){
                                                var m = u[s], g = f.length;
                                                f = f.concat(m.positions), p = p.concat(m.vectors), d = d.concat(m.vertexIntensity);
                                                for(c = 0; c < m.cells.length; c++){
                                                    var v = m.cells[c], y = [];
                                                    h.push(y);
                                                    for(var x = 0; x < v.length; x++)y.push(v[x] + g);
                                                }
                                            }
                                            return {
                                                positions: f,
                                                cells: h,
                                                vectors: p,
                                                vertexIntensity: d,
                                                colormap: e1
                                            };
                                        }, s = function(t1, e1) {
                                            var r, n = t1.length;
                                            for(r = 0; r < n; r++){
                                                var i = t1[r];
                                                if (i === e1) return r;
                                                if (i > e1) return r - 1;
                                            }
                                            return r;
                                        }, l = function(t1, e1, r) {
                                            return t1 < e1 ? e1 : t1 > r ? r : t1;
                                        }, c = function(t1) {
                                            var e1 = 1 / 0;
                                            t1.sort(function(t1, e1) {
                                                return t1 - e1;
                                            });
                                            for(var r = t1.length, n = 1; n < r; n++){
                                                var i = Math.abs(t1[n] - t1[n - 1]);
                                                i < e1 && (e1 = i);
                                            }
                                            return e1;
                                        };
                                        e1.exports = function(t1, e1) {
                                            var r = t1.startingPositions, i = t1.maxLength || 1e3, u = t1.tubeSize || 1, f = t1.absoluteTubeSize, h = t1.gridFill || "+x+y+z", p = {};
                                            -1 !== h.indexOf("-x") && (p.reversedX = !0), -1 !== h.indexOf("-y") && (p.reversedY = !0), -1 !== h.indexOf("-z") && (p.reversedZ = !0), p.filled = a.indexOf(h.replace(/-/g, "").replace(/\+/g, ""));
                                            var d = t1.getVelocity || function(e1) {
                                                return function(t1, e1, r) {
                                                    var i = e1.vectors, a = e1.meshgrid, o = t1[0], c = t1[1], u = t1[2], f = a[0].length, h = a[1].length, p = a[2].length, d = s(a[0], o), m = s(a[1], c), g = s(a[2], u), v = d + 1, y = m + 1, x = g + 1;
                                                    if (d = l(d, 0, f - 1), v = l(v, 0, f - 1), m = l(m, 0, h - 1), y = l(y, 0, h - 1), g = l(g, 0, p - 1), x = l(x, 0, p - 1), d < 0 || m < 0 || g < 0 || v > f - 1 || y > h - 1 || x > p - 1) return n.create();
                                                    var b, _, w, T, k, A, M = a[0][d], S = a[0][v], E = a[1][m], L = a[1][y], C = a[2][g], P = (o - M) / (S - M), I = (c - E) / (L - E), O = (u - C) / (a[2][x] - C);
                                                    switch(isFinite(P) || (P = .5), isFinite(I) || (I = .5), isFinite(O) || (O = .5), r.reversedX && (d = f - 1 - d, v = f - 1 - v), r.reversedY && (m = h - 1 - m, y = h - 1 - y), r.reversedZ && (g = p - 1 - g, x = p - 1 - x), r.filled){
                                                        case 5:
                                                            k = g, A = x, w = m * p, T = y * p, b = d * p * h, _ = v * p * h;
                                                            break;
                                                        case 4:
                                                            k = g, A = x, b = d * p, _ = v * p, w = m * p * f, T = y * p * f;
                                                            break;
                                                        case 3:
                                                            w = m, T = y, k = g * h, A = x * h, b = d * h * p, _ = v * h * p;
                                                            break;
                                                        case 2:
                                                            w = m, T = y, b = d * h, _ = v * h, k = g * h * f, A = x * h * f;
                                                            break;
                                                        case 1:
                                                            b = d, _ = v, k = g * f, A = x * f, w = m * f * p, T = y * f * p;
                                                            break;
                                                        default:
                                                            b = d, _ = v, w = m * f, T = y * f, k = g * f * h, A = x * f * h;
                                                    }
                                                    var z = i[b + w + k], D = i[b + w + A], R = i[b + T + k], F = i[b + T + A], B = i[_ + w + k], N = i[_ + w + A], j = i[_ + T + k], U = i[_ + T + A], V = n.create(), H = n.create(), q = n.create(), G = n.create();
                                                    n.lerp(V, z, B, P), n.lerp(H, D, N, P), n.lerp(q, R, j, P), n.lerp(G, F, U, P);
                                                    var Y = n.create(), W = n.create();
                                                    n.lerp(Y, V, q, I), n.lerp(W, H, G, I);
                                                    var X = n.create();
                                                    return n.lerp(X, Y, W, O), X;
                                                }(e1, t1, p);
                                            }, m = t1.getDivergence || function(t1, e1) {
                                                var r = n.create(), i = 1e-4;
                                                n.add(r, t1, [
                                                    i,
                                                    0,
                                                    0
                                                ]);
                                                var a = d(r);
                                                n.subtract(a, a, e1), n.scale(a, a, 1 / i), n.add(r, t1, [
                                                    0,
                                                    i,
                                                    0
                                                ]);
                                                var o = d(r);
                                                n.subtract(o, o, e1), n.scale(o, o, 1 / i), n.add(r, t1, [
                                                    0,
                                                    0,
                                                    i
                                                ]);
                                                var s = d(r);
                                                return n.subtract(s, s, e1), n.scale(s, s, 1 / i), n.add(r, a, o), n.add(r, r, s), r;
                                            }, g = [], v = e1[0][0], y = e1[0][1], x = e1[0][2], b = e1[1][0], _ = e1[1][1], w = e1[1][2], T = function(t1) {
                                                var e1 = t1[0], r = t1[1], n = t1[2];
                                                return !(e1 < v || e1 > b || r < y || r > _ || n < x || n > w);
                                            }, k = 10 * n.distance(e1[0], e1[1]) / i, A = k * k, M = 1, S = 0, E = r.length;
                                            E > 1 && (M = function(t1) {
                                                for(var e1 = [], r = [], n = [], i = {}, a = {}, o = {}, s = t1.length, l = 0; l < s; l++){
                                                    var u = t1[l], f = u[0], h = u[1], p = u[2];
                                                    i[f] || (e1.push(f), i[f] = !0), a[h] || (r.push(h), a[h] = !0), o[p] || (n.push(p), o[p] = !0);
                                                }
                                                var d = c(e1), m = c(r), g = c(n), v = Math.min(d, m, g);
                                                return isFinite(v) ? v : 1;
                                            }(r));
                                            for(var L = 0; L < E; L++){
                                                var C = n.create();
                                                n.copy(C, r[L]);
                                                var P = [
                                                    C
                                                ], I = [], O = d(C), z = C;
                                                I.push(O);
                                                var D = [], R = m(C, O), F = n.length(R);
                                                isFinite(F) && F > S && (S = F), D.push(F), g.push({
                                                    points: P,
                                                    velocities: I,
                                                    divergences: D
                                                });
                                                for(var B = 0; B < 100 * i && P.length < i && T(C);){
                                                    B++;
                                                    var N = n.clone(O), j = n.squaredLength(N);
                                                    if (0 === j) break;
                                                    if (j > A && n.scale(N, N, k / Math.sqrt(j)), n.add(N, N, C), O = d(N), n.squaredDistance(z, N) - A > -0.0001 * A) {
                                                        P.push(N), z = N, I.push(O);
                                                        R = m(N, O), F = n.length(R);
                                                        isFinite(F) && F > S && (S = F), D.push(F);
                                                    }
                                                    C = N;
                                                }
                                            }
                                            var U = o(g, t1.colormap, S, M);
                                            return f ? U.tubeScale = f : (0 === S && (S = 1), U.tubeScale = .5 * u * M / S), U;
                                        };
                                        var u = t1("./lib/shaders"), f = t1("gl-cone3d").createMesh;
                                        e1.exports.createTubeMesh = function(t1, e1) {
                                            return f(t1, e1, {
                                                shaders: u,
                                                traceType: "streamtube"
                                            });
                                        };
                                    },
                                    {
                                        "./lib/shaders": 142,
                                        "gl-cone3d": 79,
                                        "gl-vec3": 169,
                                        "gl-vec4": 205
                                    }
                                ],
                                144: [
                                    function(t1, e1, r) {
                                        var n = t1("gl-shader"), i = t1("glslify"), a = i([
                                            "precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute vec3 f;\nattribute vec3 normal;\n\nuniform vec3 objectOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 lightPosition, eyePosition;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 localCoordinate = vec3(uv.zw, f.x);\n  worldCoordinate = objectOffset + localCoordinate;\n  vec4 worldPosition = model * vec4(worldCoordinate, 1.0);\n  vec4 clipPosition = projection * view * worldPosition;\n  gl_Position = clipPosition;\n  kill = f.y;\n  value = f.z;\n  planeCoordinate = uv.xy;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * worldPosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  lightDirection = lightPosition - cameraCoordinate.xyz;\n  eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  surfaceNormal  = normalize((vec4(normal,0) * inverseModel).xyz);\n}\n"
                                        ]), o = i([
                                            "precision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat beckmannSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness) {\n  return beckmannDistribution(dot(surfaceNormal, normalize(lightDirection + viewDirection)), roughness);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 lowerBound, upperBound;\nuniform float contourTint;\nuniform vec4 contourColor;\nuniform sampler2D colormap;\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform float vertexColor;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  if (\n    kill > 0.0 ||\n    vColor.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], worldCoordinate)\n  ) discard;\n\n  vec3 N = normalize(surfaceNormal);\n  vec3 V = normalize(eyeDirection);\n  vec3 L = normalize(lightDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = max(beckmannSpecular(L, V, N, roughness), 0.);\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  //decide how to interpolate color \u2014 in vertex or in fragment\n  vec4 surfaceColor =\n    step(vertexColor, .5) * texture2D(colormap, vec2(value, value)) +\n    step(.5, vertexColor) * vColor;\n\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = mix(litColor, contourColor, contourTint) * opacity;\n}\n"
                                        ]), s = i([
                                            "precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute float f;\n\nuniform vec3 objectOffset;\nuniform mat3 permutation;\nuniform mat4 model, view, projection;\nuniform float height, zOffset;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 dataCoordinate = permutation * vec3(uv.xy, height);\n  worldCoordinate = objectOffset + dataCoordinate;\n  vec4 worldPosition = model * vec4(worldCoordinate, 1.0);\n\n  vec4 clipPosition = projection * view * worldPosition;\n  clipPosition.z += zOffset;\n\n  gl_Position = clipPosition;\n  value = f + objectOffset.z;\n  kill = -1.0;\n  planeCoordinate = uv.zw;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Don't do lighting for contours\n  surfaceNormal   = vec3(1,0,0);\n  eyeDirection    = vec3(0,1,0);\n  lightDirection  = vec3(0,0,1);\n}\n"
                                        ]), l = i([
                                            "precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec2 shape;\nuniform vec3 clipBounds[2];\nuniform float pickId;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 surfaceNormal;\n\nvec2 splitFloat(float v) {\n  float vh = 255.0 * v;\n  float upper = floor(vh);\n  float lower = fract(vh);\n  return vec2(upper / 255.0, floor(lower * 16.0) / 16.0);\n}\n\nvoid main() {\n  if ((kill > 0.0) ||\n      (outOfRange(clipBounds[0], clipBounds[1], worldCoordinate))) discard;\n\n  vec2 ux = splitFloat(planeCoordinate.x / shape.x);\n  vec2 uy = splitFloat(planeCoordinate.y / shape.y);\n  gl_FragColor = vec4(pickId, ux.x, uy.x, ux.y + (uy.y/16.0));\n}\n"
                                        ]);
                                        r.createShader = function(t1) {
                                            var e1 = n(t1, a, o, null, [
                                                {
                                                    name: "uv",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "f",
                                                    type: "vec3"
                                                },
                                                {
                                                    name: "normal",
                                                    type: "vec3"
                                                }
                                            ]);
                                            return e1.attributes.uv.location = 0, e1.attributes.f.location = 1, e1.attributes.normal.location = 2, e1;
                                        }, r.createPickShader = function(t1) {
                                            var e1 = n(t1, a, l, null, [
                                                {
                                                    name: "uv",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "f",
                                                    type: "vec3"
                                                },
                                                {
                                                    name: "normal",
                                                    type: "vec3"
                                                }
                                            ]);
                                            return e1.attributes.uv.location = 0, e1.attributes.f.location = 1, e1.attributes.normal.location = 2, e1;
                                        }, r.createContourShader = function(t1) {
                                            var e1 = n(t1, s, o, null, [
                                                {
                                                    name: "uv",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "f",
                                                    type: "float"
                                                }
                                            ]);
                                            return e1.attributes.uv.location = 0, e1.attributes.f.location = 1, e1;
                                        }, r.createPickContourShader = function(t1) {
                                            var e1 = n(t1, s, l, null, [
                                                {
                                                    name: "uv",
                                                    type: "vec4"
                                                },
                                                {
                                                    name: "f",
                                                    type: "float"
                                                }
                                            ]);
                                            return e1.attributes.uv.location = 0, e1.attributes.f.location = 1, e1;
                                        };
                                    },
                                    {
                                        "gl-shader": 132,
                                        glslify: 231
                                    }
                                ],
                                145: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = t1.gl, r = y(e1), n = b(e1), s = x(e1), l = _(e1), c = i(e1), u = a(e1, [
                                                {
                                                    buffer: c,
                                                    size: 4,
                                                    stride: 40,
                                                    offset: 0
                                                },
                                                {
                                                    buffer: c,
                                                    size: 3,
                                                    stride: 40,
                                                    offset: 16
                                                },
                                                {
                                                    buffer: c,
                                                    size: 3,
                                                    stride: 40,
                                                    offset: 28
                                                }
                                            ]), f = i(e1), h = a(e1, [
                                                {
                                                    buffer: f,
                                                    size: 4,
                                                    stride: 20,
                                                    offset: 0
                                                },
                                                {
                                                    buffer: f,
                                                    size: 1,
                                                    stride: 20,
                                                    offset: 16
                                                }
                                            ]), p = i(e1), d = a(e1, [
                                                {
                                                    buffer: p,
                                                    size: 2,
                                                    type: e1.FLOAT
                                                }
                                            ]), m = o(e1, 1, 256, e1.RGBA, e1.UNSIGNED_BYTE);
                                            m.minFilter = e1.LINEAR, m.magFilter = e1.LINEAR;
                                            var g = new M(e1, [
                                                0,
                                                0
                                            ], [
                                                [
                                                    0,
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0
                                                ]
                                            ], r, n, c, u, m, s, l, f, h, p, d, [
                                                0,
                                                0,
                                                0
                                            ]), v = {
                                                levels: [
                                                    [],
                                                    [],
                                                    []
                                                ]
                                            };
                                            for(var w in t1)v[w] = t1[w];
                                            return v.colormap = v.colormap || "jet", g.update(v), g;
                                        };
                                        var n = t1("bit-twiddle"), i = t1("gl-buffer"), a = t1("gl-vao"), o = t1("gl-texture2d"), s = t1("typedarray-pool"), l = t1("colormap"), c = t1("ndarray-ops"), u = t1("ndarray-pack"), f = t1("ndarray"), h = t1("surface-nets"), p = t1("gl-mat4/multiply"), d = t1("gl-mat4/invert"), m = t1("binary-search-bounds"), g = t1("ndarray-gradient"), v = t1("./lib/shaders"), y = v.createShader, x = v.createContourShader, b = v.createPickShader, _ = v.createPickContourShader, w = [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ], T = [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                1
                                            ],
                                            [
                                                1,
                                                0
                                            ],
                                            [
                                                1,
                                                1
                                            ],
                                            [
                                                1,
                                                0
                                            ],
                                            [
                                                0,
                                                1
                                            ]
                                        ], k = [
                                            [
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0
                                            ]
                                        ];
                                        function A(t1, e1, r, n, i) {
                                            this.position = t1, this.index = e1, this.uv = r, this.level = n, this.dataCoordinate = i;
                                        }
                                        !function() {
                                            for(var t1 = 0; t1 < 3; ++t1){
                                                var e1 = k[t1], r = (t1 + 2) % 3;
                                                e1[(t1 + 1) % 3 + 0] = 1, e1[r + 3] = 1, e1[t1 + 6] = 1;
                                            }
                                        }();
                                        function M(t1, e1, r, n, i, a, o, l, c, u, h, p, d, m, g) {
                                            this.gl = t1, this.shape = e1, this.bounds = r, this.objectOffset = g, this.intensityBounds = [], this._shader = n, this._pickShader = i, this._coordinateBuffer = a, this._vao = o, this._colorMap = l, this._contourShader = c, this._contourPickShader = u, this._contourBuffer = h, this._contourVAO = p, this._contourOffsets = [
                                                [],
                                                [],
                                                []
                                            ], this._contourCounts = [
                                                [],
                                                [],
                                                []
                                            ], this._vertexCount = 0, this._pickResult = new A([
                                                0,
                                                0,
                                                0
                                            ], [
                                                0,
                                                0
                                            ], [
                                                0,
                                                0
                                            ], [
                                                0,
                                                0,
                                                0
                                            ], [
                                                0,
                                                0,
                                                0
                                            ]), this._dynamicBuffer = d, this._dynamicVAO = m, this._dynamicOffsets = [
                                                0,
                                                0,
                                                0
                                            ], this._dynamicCounts = [
                                                0,
                                                0,
                                                0
                                            ], this.contourWidth = [
                                                1,
                                                1,
                                                1
                                            ], this.contourLevels = [
                                                [
                                                    1
                                                ],
                                                [
                                                    1
                                                ],
                                                [
                                                    1
                                                ]
                                            ], this.contourTint = [
                                                0,
                                                0,
                                                0
                                            ], this.contourColor = [
                                                [
                                                    .5,
                                                    .5,
                                                    .5,
                                                    1
                                                ],
                                                [
                                                    .5,
                                                    .5,
                                                    .5,
                                                    1
                                                ],
                                                [
                                                    .5,
                                                    .5,
                                                    .5,
                                                    1
                                                ]
                                            ], this.showContour = !0, this.showSurface = !0, this.enableHighlight = [
                                                !0,
                                                !0,
                                                !0
                                            ], this.highlightColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.highlightTint = [
                                                1,
                                                1,
                                                1
                                            ], this.highlightLevel = [
                                                -1,
                                                -1,
                                                -1
                                            ], this.enableDynamic = [
                                                !0,
                                                !0,
                                                !0
                                            ], this.dynamicLevel = [
                                                NaN,
                                                NaN,
                                                NaN
                                            ], this.dynamicColor = [
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            ], this.dynamicTint = [
                                                1,
                                                1,
                                                1
                                            ], this.dynamicWidth = [
                                                1,
                                                1,
                                                1
                                            ], this.axesBounds = [
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ],
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ]
                                            ], this.surfaceProject = [
                                                !1,
                                                !1,
                                                !1
                                            ], this.contourProject = [
                                                [
                                                    !1,
                                                    !1,
                                                    !1
                                                ],
                                                [
                                                    !1,
                                                    !1,
                                                    !1
                                                ],
                                                [
                                                    !1,
                                                    !1,
                                                    !1
                                                ]
                                            ], this.colorBounds = [
                                                !1,
                                                !1
                                            ], this._field = [
                                                f(s.mallocFloat(1024), [
                                                    0,
                                                    0
                                                ]),
                                                f(s.mallocFloat(1024), [
                                                    0,
                                                    0
                                                ]),
                                                f(s.mallocFloat(1024), [
                                                    0,
                                                    0
                                                ])
                                            ], this.pickId = 1, this.clipBounds = [
                                                [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ],
                                                [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ]
                                            ], this.snapToData = !1, this.pixelRatio = 1, this.opacity = 1, this.lightPosition = [
                                                10,
                                                1e4,
                                                0
                                            ], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.vertexColor = 0, this.dirty = !0;
                                        }
                                        var S = M.prototype;
                                        S.genColormap = function(t1, e1) {
                                            var r = !1, n = u([
                                                l({
                                                    colormap: t1,
                                                    nshades: 256,
                                                    format: "rgba"
                                                }).map(function(t1, n) {
                                                    var i = e1 ? function(t1, e1) {
                                                        if (!e1) return 1;
                                                        if (!e1.length) return 1;
                                                        for(var r = 0; r < e1.length; ++r){
                                                            if (e1.length < 2) return 1;
                                                            if (e1[r][0] === t1) return e1[r][1];
                                                            if (e1[r][0] > t1 && r > 0) {
                                                                var n = (e1[r][0] - t1) / (e1[r][0] - e1[r - 1][0]);
                                                                return e1[r][1] * (1 - n) + n * e1[r - 1][1];
                                                            }
                                                        }
                                                        return 1;
                                                    }(n / 255, e1) : t1[3];
                                                    return i < 1 && (r = !0), [
                                                        t1[0],
                                                        t1[1],
                                                        t1[2],
                                                        255 * i
                                                    ];
                                                })
                                            ]);
                                            return c.divseq(n, 255), this.hasAlphaScale = r, n;
                                        }, S.isTransparent = function() {
                                            return this.opacity < 1 || this.hasAlphaScale;
                                        }, S.isOpaque = function() {
                                            return !this.isTransparent();
                                        }, S.pickSlots = 1, S.setPickBase = function(t1) {
                                            this.pickId = t1;
                                        };
                                        var E = [
                                            0,
                                            0,
                                            0
                                        ], L = {
                                            showSurface: !1,
                                            showContour: !1,
                                            projections: [
                                                w.slice(),
                                                w.slice(),
                                                w.slice()
                                            ],
                                            clipBounds: [
                                                [
                                                    [
                                                        0,
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                [
                                                    [
                                                        0,
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                [
                                                    [
                                                        0,
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0,
                                                        0
                                                    ]
                                                ]
                                            ]
                                        };
                                        function C(t1, e1) {
                                            var r, n, i, a = e1.axes && e1.axes.lastCubeProps.axis || E, o = e1.showSurface, s = e1.showContour;
                                            for(r = 0; r < 3; ++r)for(o = o || e1.surfaceProject[r], n = 0; n < 3; ++n)s = s || e1.contourProject[r][n];
                                            for(r = 0; r < 3; ++r){
                                                var l = L.projections[r];
                                                for(n = 0; n < 16; ++n)l[n] = 0;
                                                for(n = 0; n < 4; ++n)l[5 * n] = 1;
                                                l[5 * r] = 0, l[12 + r] = e1.axesBounds[+(a[r] > 0)][r], p(l, t1.model, l);
                                                var c = L.clipBounds[r];
                                                for(i = 0; i < 2; ++i)for(n = 0; n < 3; ++n)c[i][n] = t1.clipBounds[i][n];
                                                c[0][r] = -100000000, c[1][r] = 1e8;
                                            }
                                            return L.showSurface = o, L.showContour = s, L;
                                        }
                                        var P = {
                                            model: w,
                                            view: w,
                                            projection: w,
                                            inverseModel: w.slice(),
                                            lowerBound: [
                                                0,
                                                0,
                                                0
                                            ],
                                            upperBound: [
                                                0,
                                                0,
                                                0
                                            ],
                                            colorMap: 0,
                                            clipBounds: [
                                                [
                                                    0,
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0
                                                ]
                                            ],
                                            height: 0,
                                            contourTint: 0,
                                            contourColor: [
                                                0,
                                                0,
                                                0,
                                                1
                                            ],
                                            permutation: [
                                                1,
                                                0,
                                                0,
                                                0,
                                                1,
                                                0,
                                                0,
                                                0,
                                                1
                                            ],
                                            zOffset: -0.0001,
                                            objectOffset: [
                                                0,
                                                0,
                                                0
                                            ],
                                            kambient: 1,
                                            kdiffuse: 1,
                                            kspecular: 1,
                                            lightPosition: [
                                                1e3,
                                                1e3,
                                                1e3
                                            ],
                                            eyePosition: [
                                                0,
                                                0,
                                                0
                                            ],
                                            roughness: 1,
                                            fresnel: 1,
                                            opacity: 1,
                                            vertexColor: 0
                                        }, I = w.slice(), O = [
                                            1,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                        function z(t1, e1) {
                                            t1 = t1 || {};
                                            var r = this.gl;
                                            r.disable(r.CULL_FACE), this._colorMap.bind(0);
                                            var n = P;
                                            n.model = t1.model || w, n.view = t1.view || w, n.projection = t1.projection || w, n.lowerBound = [
                                                this.bounds[0][0],
                                                this.bounds[0][1],
                                                this.colorBounds[0] || this.bounds[0][2]
                                            ], n.upperBound = [
                                                this.bounds[1][0],
                                                this.bounds[1][1],
                                                this.colorBounds[1] || this.bounds[1][2]
                                            ], n.objectOffset = this.objectOffset, n.contourColor = this.contourColor[0], n.inverseModel = d(n.inverseModel, n.model);
                                            for(var i = 0; i < 2; ++i)for(var a = n.clipBounds[i], o = 0; o < 3; ++o)a[o] = Math.min(Math.max(this.clipBounds[i][o], -100000000), 1e8);
                                            n.kambient = this.ambientLight, n.kdiffuse = this.diffuseLight, n.kspecular = this.specularLight, n.roughness = this.roughness, n.fresnel = this.fresnel, n.opacity = this.opacity, n.height = 0, n.permutation = O, n.vertexColor = this.vertexColor;
                                            var s = I;
                                            for(p(s, n.view, n.model), p(s, n.projection, s), d(s, s), i = 0; i < 3; ++i)n.eyePosition[i] = s[12 + i] / s[15];
                                            var l = s[15];
                                            for(i = 0; i < 3; ++i)l += this.lightPosition[i] * s[4 * i + 3];
                                            for(i = 0; i < 3; ++i){
                                                var c = s[12 + i];
                                                for(o = 0; o < 3; ++o)c += s[4 * o + i] * this.lightPosition[o];
                                                n.lightPosition[i] = c / l;
                                            }
                                            var u = C(n, this);
                                            if (u.showSurface) {
                                                for(this._shader.bind(), this._shader.uniforms = n, this._vao.bind(), this.showSurface && this._vertexCount && this._vao.draw(r.TRIANGLES, this._vertexCount), i = 0; i < 3; ++i)this.surfaceProject[i] && this.vertexCount && (this._shader.uniforms.model = u.projections[i], this._shader.uniforms.clipBounds = u.clipBounds[i], this._vao.draw(r.TRIANGLES, this._vertexCount));
                                                this._vao.unbind();
                                            }
                                            if (u.showContour) {
                                                var f = this._contourShader;
                                                n.kambient = 1, n.kdiffuse = 0, n.kspecular = 0, n.opacity = 1, f.bind(), f.uniforms = n;
                                                var h = this._contourVAO;
                                                for(h.bind(), i = 0; i < 3; ++i)for(f.uniforms.permutation = k[i], r.lineWidth(this.contourWidth[i] * this.pixelRatio), o = 0; o < this.contourLevels[i].length; ++o)o === this.highlightLevel[i] ? (f.uniforms.contourColor = this.highlightColor[i], f.uniforms.contourTint = this.highlightTint[i]) : 0 !== o && o - 1 !== this.highlightLevel[i] || (f.uniforms.contourColor = this.contourColor[i], f.uniforms.contourTint = this.contourTint[i]), this._contourCounts[i][o] && (f.uniforms.height = this.contourLevels[i][o], h.draw(r.LINES, this._contourCounts[i][o], this._contourOffsets[i][o]));
                                                for(i = 0; i < 3; ++i)for(f.uniforms.model = u.projections[i], f.uniforms.clipBounds = u.clipBounds[i], o = 0; o < 3; ++o)if (this.contourProject[i][o]) {
                                                    f.uniforms.permutation = k[o], r.lineWidth(this.contourWidth[o] * this.pixelRatio);
                                                    for(var m = 0; m < this.contourLevels[o].length; ++m)m === this.highlightLevel[o] ? (f.uniforms.contourColor = this.highlightColor[o], f.uniforms.contourTint = this.highlightTint[o]) : 0 !== m && m - 1 !== this.highlightLevel[o] || (f.uniforms.contourColor = this.contourColor[o], f.uniforms.contourTint = this.contourTint[o]), this._contourCounts[o][m] && (f.uniforms.height = this.contourLevels[o][m], h.draw(r.LINES, this._contourCounts[o][m], this._contourOffsets[o][m]));
                                                }
                                                for(h.unbind(), (h = this._dynamicVAO).bind(), i = 0; i < 3; ++i)if (0 !== this._dynamicCounts[i]) for(f.uniforms.model = n.model, f.uniforms.clipBounds = n.clipBounds, f.uniforms.permutation = k[i], r.lineWidth(this.dynamicWidth[i] * this.pixelRatio), f.uniforms.contourColor = this.dynamicColor[i], f.uniforms.contourTint = this.dynamicTint[i], f.uniforms.height = this.dynamicLevel[i], h.draw(r.LINES, this._dynamicCounts[i], this._dynamicOffsets[i]), o = 0; o < 3; ++o)this.contourProject[o][i] && (f.uniforms.model = u.projections[o], f.uniforms.clipBounds = u.clipBounds[o], h.draw(r.LINES, this._dynamicCounts[i], this._dynamicOffsets[i]));
                                                h.unbind();
                                            }
                                        }
                                        S.draw = function(t1) {
                                            return z.call(this, t1, !1);
                                        }, S.drawTransparent = function(t1) {
                                            return z.call(this, t1, !0);
                                        };
                                        var D = {
                                            model: w,
                                            view: w,
                                            projection: w,
                                            inverseModel: w,
                                            clipBounds: [
                                                [
                                                    0,
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0,
                                                    0
                                                ]
                                            ],
                                            height: 0,
                                            shape: [
                                                0,
                                                0
                                            ],
                                            pickId: 0,
                                            lowerBound: [
                                                0,
                                                0,
                                                0
                                            ],
                                            upperBound: [
                                                0,
                                                0,
                                                0
                                            ],
                                            zOffset: 0,
                                            objectOffset: [
                                                0,
                                                0,
                                                0
                                            ],
                                            permutation: [
                                                1,
                                                0,
                                                0,
                                                0,
                                                1,
                                                0,
                                                0,
                                                0,
                                                1
                                            ],
                                            lightPosition: [
                                                0,
                                                0,
                                                0
                                            ],
                                            eyePosition: [
                                                0,
                                                0,
                                                0
                                            ]
                                        };
                                        function R(t1, e1) {
                                            return Array.isArray(t1) ? [
                                                e1(t1[0]),
                                                e1(t1[1]),
                                                e1(t1[2])
                                            ] : [
                                                e1(t1),
                                                e1(t1),
                                                e1(t1)
                                            ];
                                        }
                                        function F(t1) {
                                            return Array.isArray(t1) ? 3 === t1.length ? [
                                                t1[0],
                                                t1[1],
                                                t1[2],
                                                1
                                            ] : [
                                                t1[0],
                                                t1[1],
                                                t1[2],
                                                t1[3]
                                            ] : [
                                                0,
                                                0,
                                                0,
                                                1
                                            ];
                                        }
                                        function B(t1) {
                                            if (Array.isArray(t1)) {
                                                if (Array.isArray(t1)) return [
                                                    F(t1[0]),
                                                    F(t1[1]),
                                                    F(t1[2])
                                                ];
                                                var e1 = F(t1);
                                                return [
                                                    e1.slice(),
                                                    e1.slice(),
                                                    e1.slice()
                                                ];
                                            }
                                        }
                                        S.drawPick = function(t1) {
                                            t1 = t1 || {};
                                            var e1 = this.gl;
                                            e1.disable(e1.CULL_FACE);
                                            var r = D;
                                            r.model = t1.model || w, r.view = t1.view || w, r.projection = t1.projection || w, r.shape = this._field[2].shape, r.pickId = this.pickId / 255, r.lowerBound = this.bounds[0], r.upperBound = this.bounds[1], r.objectOffset = this.objectOffset, r.permutation = O;
                                            for(var n = 0; n < 2; ++n)for(var i = r.clipBounds[n], a = 0; a < 3; ++a)i[a] = Math.min(Math.max(this.clipBounds[n][a], -100000000), 1e8);
                                            var o = C(r, this);
                                            if (o.showSurface) {
                                                for(this._pickShader.bind(), this._pickShader.uniforms = r, this._vao.bind(), this._vao.draw(e1.TRIANGLES, this._vertexCount), n = 0; n < 3; ++n)this.surfaceProject[n] && (this._pickShader.uniforms.model = o.projections[n], this._pickShader.uniforms.clipBounds = o.clipBounds[n], this._vao.draw(e1.TRIANGLES, this._vertexCount));
                                                this._vao.unbind();
                                            }
                                            if (o.showContour) {
                                                var s = this._contourPickShader;
                                                s.bind(), s.uniforms = r;
                                                var l = this._contourVAO;
                                                for(l.bind(), a = 0; a < 3; ++a)for(e1.lineWidth(this.contourWidth[a] * this.pixelRatio), s.uniforms.permutation = k[a], n = 0; n < this.contourLevels[a].length; ++n)this._contourCounts[a][n] && (s.uniforms.height = this.contourLevels[a][n], l.draw(e1.LINES, this._contourCounts[a][n], this._contourOffsets[a][n]));
                                                for(n = 0; n < 3; ++n)for(s.uniforms.model = o.projections[n], s.uniforms.clipBounds = o.clipBounds[n], a = 0; a < 3; ++a)if (this.contourProject[n][a]) {
                                                    s.uniforms.permutation = k[a], e1.lineWidth(this.contourWidth[a] * this.pixelRatio);
                                                    for(var c = 0; c < this.contourLevels[a].length; ++c)this._contourCounts[a][c] && (s.uniforms.height = this.contourLevels[a][c], l.draw(e1.LINES, this._contourCounts[a][c], this._contourOffsets[a][c]));
                                                }
                                                l.unbind();
                                            }
                                        }, S.pick = function(t1) {
                                            if (!t1) return null;
                                            if (t1.id !== this.pickId) return null;
                                            var e1 = this._field[2].shape, r = this._pickResult, n = e1[0] * (t1.value[0] + (t1.value[2] >> 4) / 16) / 255, i = Math.floor(n), a = n - i, o = e1[1] * (t1.value[1] + (15 & t1.value[2]) / 16) / 255, s = Math.floor(o), l = o - s;
                                            i += 1, s += 1;
                                            var c = r.position;
                                            c[0] = c[1] = c[2] = 0;
                                            for(var u = 0; u < 2; ++u)for(var f = u ? a : 1 - a, h = 0; h < 2; ++h)for(var p = i + u, d = s + h, g = f * (h ? l : 1 - l), v = 0; v < 3; ++v)c[v] += this._field[v].get(p, d) * g;
                                            for(var y = this._pickResult.level, x = 0; x < 3; ++x)if (y[x] = m.le(this.contourLevels[x], c[x]), y[x] < 0) this.contourLevels[x].length > 0 && (y[x] = 0);
                                            else if (y[x] < this.contourLevels[x].length - 1) {
                                                var b = this.contourLevels[x][y[x]], _ = this.contourLevels[x][y[x] + 1];
                                                Math.abs(b - c[x]) > Math.abs(_ - c[x]) && (y[x] += 1);
                                            }
                                            for(r.index[0] = a < .5 ? i : i + 1, r.index[1] = l < .5 ? s : s + 1, r.uv[0] = n / e1[0], r.uv[1] = o / e1[1], v = 0; v < 3; ++v)r.dataCoordinate[v] = this._field[v].get(r.index[0], r.index[1]);
                                            return r;
                                        }, S.padField = function(t1, e1) {
                                            var r = e1.shape.slice(), n = t1.shape.slice();
                                            c.assign(t1.lo(1, 1).hi(r[0], r[1]), e1), c.assign(t1.lo(1).hi(r[0], 1), e1.hi(r[0], 1)), c.assign(t1.lo(1, n[1] - 1).hi(r[0], 1), e1.lo(0, r[1] - 1).hi(r[0], 1)), c.assign(t1.lo(0, 1).hi(1, r[1]), e1.hi(1)), c.assign(t1.lo(n[0] - 1, 1).hi(1, r[1]), e1.lo(r[0] - 1)), t1.set(0, 0, e1.get(0, 0)), t1.set(0, n[1] - 1, e1.get(0, r[1] - 1)), t1.set(n[0] - 1, 0, e1.get(r[0] - 1, 0)), t1.set(n[0] - 1, n[1] - 1, e1.get(r[0] - 1, r[1] - 1));
                                        }, S.update = function(t1) {
                                            t1 = t1 || {}, this.objectOffset = t1.objectOffset || this.objectOffset, this.dirty = !0, "contourWidth" in t1 && (this.contourWidth = R(t1.contourWidth, Number)), "showContour" in t1 && (this.showContour = R(t1.showContour, Boolean)), "showSurface" in t1 && (this.showSurface = !!t1.showSurface), "contourTint" in t1 && (this.contourTint = R(t1.contourTint, Boolean)), "contourColor" in t1 && (this.contourColor = B(t1.contourColor)), "contourProject" in t1 && (this.contourProject = R(t1.contourProject, function(t1) {
                                                return R(t1, Boolean);
                                            })), "surfaceProject" in t1 && (this.surfaceProject = t1.surfaceProject), "dynamicColor" in t1 && (this.dynamicColor = B(t1.dynamicColor)), "dynamicTint" in t1 && (this.dynamicTint = R(t1.dynamicTint, Number)), "dynamicWidth" in t1 && (this.dynamicWidth = R(t1.dynamicWidth, Number)), "opacity" in t1 && (this.opacity = t1.opacity), "opacityscale" in t1 && (this.opacityscale = t1.opacityscale), "colorBounds" in t1 && (this.colorBounds = t1.colorBounds), "vertexColor" in t1 && (this.vertexColor = t1.vertexColor ? 1 : 0), "colormap" in t1 && this._colorMap.setPixels(this.genColormap(t1.colormap, this.opacityscale));
                                            var e1 = t1.field || t1.coords && t1.coords[2] || null, r = !1;
                                            if (e1 || (e1 = this._field[2].shape[0] || this._field[2].shape[2] ? this._field[2].lo(1, 1).hi(this._field[2].shape[0] - 2, this._field[2].shape[1] - 2) : this._field[2].hi(0, 0)), "field" in t1 || "coords" in t1) {
                                                var i = (e1.shape[0] + 2) * (e1.shape[1] + 2);
                                                i > this._field[2].data.length && (s.freeFloat(this._field[2].data), this._field[2].data = s.mallocFloat(n.nextPow2(i))), this._field[2] = f(this._field[2].data, [
                                                    e1.shape[0] + 2,
                                                    e1.shape[1] + 2
                                                ]), this.padField(this._field[2], e1), this.shape = e1.shape.slice();
                                                for(var a = this.shape, o = 0; o < 2; ++o)this._field[2].size > this._field[o].data.length && (s.freeFloat(this._field[o].data), this._field[o].data = s.mallocFloat(this._field[2].size)), this._field[o] = f(this._field[o].data, [
                                                    a[0] + 2,
                                                    a[1] + 2
                                                ]);
                                                if (t1.coords) {
                                                    var l = t1.coords;
                                                    if (!Array.isArray(l) || 3 !== l.length) throw new Error("gl-surface: invalid coordinates for x/y");
                                                    for(o = 0; o < 2; ++o){
                                                        var c = l[o];
                                                        for(v = 0; v < 2; ++v)if (c.shape[v] !== a[v]) throw new Error("gl-surface: coords have incorrect shape");
                                                        this.padField(this._field[o], c);
                                                    }
                                                } else if (t1.ticks) {
                                                    var u = t1.ticks;
                                                    if (!Array.isArray(u) || 2 !== u.length) throw new Error("gl-surface: invalid ticks");
                                                    for(o = 0; o < 2; ++o){
                                                        var p = u[o];
                                                        if ((Array.isArray(p) || p.length) && (p = f(p)), p.shape[0] !== a[o]) throw new Error("gl-surface: invalid tick length");
                                                        var d = f(p.data, a);
                                                        d.stride[o] = p.stride[0], d.stride[1 ^ o] = 0, this.padField(this._field[o], d);
                                                    }
                                                } else {
                                                    for(o = 0; o < 2; ++o){
                                                        var m = [
                                                            0,
                                                            0
                                                        ];
                                                        m[o] = 1, this._field[o] = f(this._field[o].data, [
                                                            a[0] + 2,
                                                            a[1] + 2
                                                        ], m, 0);
                                                    }
                                                    this._field[0].set(0, 0, 0);
                                                    for(var v = 0; v < a[0]; ++v)this._field[0].set(v + 1, 0, v);
                                                    for(this._field[0].set(a[0] + 1, 0, a[0] - 1), this._field[1].set(0, 0, 0), v = 0; v < a[1]; ++v)this._field[1].set(0, v + 1, v);
                                                    this._field[1].set(0, a[1] + 1, a[1] - 1);
                                                }
                                                var y = this._field, x = f(s.mallocFloat(3 * y[2].size * 2), [
                                                    3,
                                                    a[0] + 2,
                                                    a[1] + 2,
                                                    2
                                                ]);
                                                for(o = 0; o < 3; ++o)g(x.pick(o), y[o], "mirror");
                                                var b = f(s.mallocFloat(3 * y[2].size), [
                                                    a[0] + 2,
                                                    a[1] + 2,
                                                    3
                                                ]);
                                                for(o = 0; o < a[0] + 2; ++o)for(v = 0; v < a[1] + 2; ++v){
                                                    var _ = x.get(0, o, v, 0), w = x.get(0, o, v, 1), k = x.get(1, o, v, 0), A = x.get(1, o, v, 1), M = x.get(2, o, v, 0), S = x.get(2, o, v, 1), E = k * S - A * M, L = M * w - S * _, C = _ * A - w * k, P = Math.sqrt(E * E + L * L + C * C);
                                                    P < 1e-8 ? (P = Math.max(Math.abs(E), Math.abs(L), Math.abs(C))) < 1e-8 ? (C = 1, L = E = 0, P = 1) : P = 1 / P : P = 1 / Math.sqrt(P), b.set(o, v, 0, E * P), b.set(o, v, 1, L * P), b.set(o, v, 2, C * P);
                                                }
                                                s.free(x.data);
                                                var I = [
                                                    1 / 0,
                                                    1 / 0,
                                                    1 / 0
                                                ], O = [
                                                    -1 / 0,
                                                    -1 / 0,
                                                    -1 / 0
                                                ], z = 1 / 0, D = -1 / 0, F = (a[0] - 1) * (a[1] - 1) * 6, N = s.mallocFloat(n.nextPow2(10 * F)), j = 0, U = 0;
                                                for(o = 0; o < a[0] - 1; ++o)t: for(v = 0; v < a[1] - 1; ++v){
                                                    for(var V = 0; V < 2; ++V)for(var H = 0; H < 2; ++H)for(var q = 0; q < 3; ++q){
                                                        var G = this._field[q].get(1 + o + V, 1 + v + H);
                                                        if (isNaN(G) || !isFinite(G)) continue t;
                                                    }
                                                    for(q = 0; q < 6; ++q){
                                                        var Y = o + T[q][0], W = v + T[q][1], X = this._field[0].get(Y + 1, W + 1), Z = this._field[1].get(Y + 1, W + 1);
                                                        G = this._field[2].get(Y + 1, W + 1), E = b.get(Y + 1, W + 1, 0), L = b.get(Y + 1, W + 1, 1), C = b.get(Y + 1, W + 1, 2), t1.intensity && (J = t1.intensity.get(Y, W));
                                                        var J = t1.intensity ? t1.intensity.get(Y, W) : G + this.objectOffset[2];
                                                        N[j++] = Y, N[j++] = W, N[j++] = X, N[j++] = Z, N[j++] = G, N[j++] = 0, N[j++] = J, N[j++] = E, N[j++] = L, N[j++] = C, I[0] = Math.min(I[0], X + this.objectOffset[0]), I[1] = Math.min(I[1], Z + this.objectOffset[1]), I[2] = Math.min(I[2], G + this.objectOffset[2]), z = Math.min(z, J), O[0] = Math.max(O[0], X + this.objectOffset[0]), O[1] = Math.max(O[1], Z + this.objectOffset[1]), O[2] = Math.max(O[2], G + this.objectOffset[2]), D = Math.max(D, J), U += 1;
                                                    }
                                                }
                                                for(t1.intensityBounds && (z = +t1.intensityBounds[0], D = +t1.intensityBounds[1]), o = 6; o < j; o += 10)N[o] = (N[o] - z) / (D - z);
                                                this._vertexCount = U, this._coordinateBuffer.update(N.subarray(0, j)), s.freeFloat(N), s.free(b.data), this.bounds = [
                                                    I,
                                                    O
                                                ], this.intensity = t1.intensity || this._field[2], this.intensityBounds[0] === z && this.intensityBounds[1] === D || (r = !0), this.intensityBounds = [
                                                    z,
                                                    D
                                                ];
                                            }
                                            if ("levels" in t1) {
                                                var K = t1.levels;
                                                for(K = Array.isArray(K[0]) ? K.slice() : [
                                                    [],
                                                    [],
                                                    K
                                                ], o = 0; o < 3; ++o)K[o] = K[o].slice(), K[o].sort(function(t1, e1) {
                                                    return t1 - e1;
                                                });
                                                for(o = 0; o < 3; ++o)for(v = 0; v < K[o].length; ++v)K[o][v] -= this.objectOffset[o];
                                                t: for(o = 0; o < 3; ++o){
                                                    if (K[o].length !== this.contourLevels[o].length) {
                                                        r = !0;
                                                        break;
                                                    }
                                                    for(v = 0; v < K[o].length; ++v)if (K[o][v] !== this.contourLevels[o][v]) {
                                                        r = !0;
                                                        break t;
                                                    }
                                                }
                                                this.contourLevels = K;
                                            }
                                            if (r) {
                                                y = this._field, a = this.shape;
                                                for(var Q = [], $ = 0; $ < 3; ++$){
                                                    var tt = this.contourLevels[$], et = [], rt = [], nt = [
                                                        0,
                                                        0,
                                                        0
                                                    ];
                                                    for(o = 0; o < tt.length; ++o){
                                                        var it = h(this._field[$], tt[o]);
                                                        et.push(Q.length / 5 | 0), U = 0;
                                                        t: for(v = 0; v < it.cells.length; ++v){
                                                            var at = it.cells[v];
                                                            for(q = 0; q < 2; ++q){
                                                                var ot = it.positions[at[q]], st = ot[0], lt = 0 | Math.floor(st), ct = st - lt, ut = ot[1], ft = 0 | Math.floor(ut), ht = ut - ft, pt = !1;
                                                                e: for(var dt = 0; dt < 3; ++dt){
                                                                    nt[dt] = 0;
                                                                    var mt = ($ + dt + 1) % 3;
                                                                    for(V = 0; V < 2; ++V){
                                                                        var gt = V ? ct : 1 - ct;
                                                                        for(Y = 0 | Math.min(Math.max(lt + V, 0), a[0]), H = 0; H < 2; ++H){
                                                                            var vt = H ? ht : 1 - ht;
                                                                            if (W = 0 | Math.min(Math.max(ft + H, 0), a[1]), G = dt < 2 ? this._field[mt].get(Y, W) : (this.intensity.get(Y, W) - this.intensityBounds[0]) / (this.intensityBounds[1] - this.intensityBounds[0]), !isFinite(G) || isNaN(G)) {
                                                                                pt = !0;
                                                                                break e;
                                                                            }
                                                                            var yt = gt * vt;
                                                                            nt[dt] += yt * G;
                                                                        }
                                                                    }
                                                                }
                                                                if (pt) {
                                                                    if (q > 0) {
                                                                        for(var xt = 0; xt < 5; ++xt)Q.pop();
                                                                        U -= 1;
                                                                    }
                                                                    continue t;
                                                                }
                                                                Q.push(nt[0], nt[1], ot[0], ot[1], nt[2]), U += 1;
                                                            }
                                                        }
                                                        rt.push(U);
                                                    }
                                                    this._contourOffsets[$] = et, this._contourCounts[$] = rt;
                                                }
                                                var bt = s.mallocFloat(Q.length);
                                                for(o = 0; o < Q.length; ++o)bt[o] = Q[o];
                                                this._contourBuffer.update(bt), s.freeFloat(bt);
                                            }
                                        }, S.dispose = function() {
                                            this._shader.dispose(), this._vao.dispose(), this._coordinateBuffer.dispose(), this._colorMap.dispose(), this._contourBuffer.dispose(), this._contourVAO.dispose(), this._contourShader.dispose(), this._contourPickShader.dispose(), this._dynamicBuffer.dispose(), this._dynamicVAO.dispose();
                                            for(var t1 = 0; t1 < 3; ++t1)s.freeFloat(this._field[t1].data);
                                        }, S.highlight = function(t1) {
                                            var e1, r;
                                            if (!t1) return this._dynamicCounts = [
                                                0,
                                                0,
                                                0
                                            ], this.dyanamicLevel = [
                                                NaN,
                                                NaN,
                                                NaN
                                            ], void (this.highlightLevel = [
                                                -1,
                                                -1,
                                                -1
                                            ]);
                                            for(e1 = 0; e1 < 3; ++e1)this.enableHighlight[e1] ? this.highlightLevel[e1] = t1.level[e1] : this.highlightLevel[e1] = -1;
                                            for(r = this.snapToData ? t1.dataCoordinate : t1.position, e1 = 0; e1 < 3; ++e1)r[e1] -= this.objectOffset[e1];
                                            if (this.enableDynamic[0] && r[0] !== this.dynamicLevel[0] || this.enableDynamic[1] && r[1] !== this.dynamicLevel[1] || this.enableDynamic[2] && r[2] !== this.dynamicLevel[2]) {
                                                for(var n = 0, i = this.shape, a = s.mallocFloat(12 * i[0] * i[1]), o = 0; o < 3; ++o)if (this.enableDynamic[o]) {
                                                    this.dynamicLevel[o] = r[o];
                                                    var l = (o + 1) % 3, c = (o + 2) % 3, u = this._field[o], f = this._field[l], p = this._field[c], d = h(u, r[o]), m = d.cells, g = d.positions;
                                                    for(this._dynamicOffsets[o] = n, e1 = 0; e1 < m.length; ++e1)for(var v = m[e1], y = 0; y < 2; ++y){
                                                        var x = g[v[y]], b = +x[0], _ = 0 | b, w = 0 | Math.min(_ + 1, i[0]), T = b - _, k = 1 - T, A = +x[1], M = 0 | A, S = 0 | Math.min(M + 1, i[1]), E = A - M, L = 1 - E, C = k * L, P = k * E, I = T * L, O = T * E, z = C * f.get(_, M) + P * f.get(_, S) + I * f.get(w, M) + O * f.get(w, S), D = C * p.get(_, M) + P * p.get(_, S) + I * p.get(w, M) + O * p.get(w, S);
                                                        if (isNaN(z) || isNaN(D)) {
                                                            y && (n -= 1);
                                                            break;
                                                        }
                                                        a[2 * n + 0] = z, a[2 * n + 1] = D, n += 1;
                                                    }
                                                    this._dynamicCounts[o] = n - this._dynamicOffsets[o];
                                                } else this.dynamicLevel[o] = NaN, this._dynamicCounts[o] = 0;
                                                this._dynamicBuffer.update(a.subarray(0, 2 * n)), s.freeFloat(a);
                                            }
                                        };
                                    },
                                    {
                                        "./lib/shaders": 144,
                                        "binary-search-bounds": 31,
                                        "bit-twiddle": 32,
                                        colormap: 53,
                                        "gl-buffer": 78,
                                        "gl-mat4/invert": 98,
                                        "gl-mat4/multiply": 100,
                                        "gl-texture2d": 146,
                                        "gl-vao": 150,
                                        ndarray: 259,
                                        "ndarray-gradient": 252,
                                        "ndarray-ops": 254,
                                        "ndarray-pack": 255,
                                        "surface-nets": 302,
                                        "typedarray-pool": 308
                                    }
                                ],
                                146: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("ndarray"), i = t1("ndarray-ops"), a = t1("typedarray-pool");
                                        e1.exports = function(t1) {
                                            if (arguments.length <= 1) throw new Error("gl-texture2d: Missing arguments for texture2d constructor");
                                            o || c(t1);
                                            if ("number" == typeof arguments[1]) return v(t1, arguments[1], arguments[2], arguments[3] || t1.RGBA, arguments[4] || t1.UNSIGNED_BYTE);
                                            if (Array.isArray(arguments[1])) return v(t1, 0 | arguments[1][0], 0 | arguments[1][1], arguments[2] || t1.RGBA, arguments[3] || t1.UNSIGNED_BYTE);
                                            if ("object" == typeof arguments[1]) {
                                                var e1 = arguments[1], r = u(e1) ? e1 : e1.raw;
                                                if (r) return y(t1, r, 0 | e1.width, 0 | e1.height, arguments[2] || t1.RGBA, arguments[3] || t1.UNSIGNED_BYTE);
                                                if (e1.shape && e1.data && e1.stride) return x(t1, e1);
                                            }
                                            throw new Error("gl-texture2d: Invalid arguments for texture2d constructor");
                                        };
                                        var o = null, s = null, l = null;
                                        function c(t1) {
                                            o = [
                                                t1.LINEAR,
                                                t1.NEAREST_MIPMAP_LINEAR,
                                                t1.LINEAR_MIPMAP_NEAREST,
                                                t1.LINEAR_MIPMAP_NEAREST
                                            ], s = [
                                                t1.NEAREST,
                                                t1.LINEAR,
                                                t1.NEAREST_MIPMAP_NEAREST,
                                                t1.NEAREST_MIPMAP_LINEAR,
                                                t1.LINEAR_MIPMAP_NEAREST,
                                                t1.LINEAR_MIPMAP_LINEAR
                                            ], l = [
                                                t1.REPEAT,
                                                t1.CLAMP_TO_EDGE,
                                                t1.MIRRORED_REPEAT
                                            ];
                                        }
                                        function u(t1) {
                                            return "undefined" != typeof HTMLCanvasElement && t1 instanceof HTMLCanvasElement || "undefined" != typeof HTMLImageElement && t1 instanceof HTMLImageElement || "undefined" != typeof HTMLVideoElement && t1 instanceof HTMLVideoElement || "undefined" != typeof ImageData && t1 instanceof ImageData;
                                        }
                                        var f = function(t1, e1) {
                                            i.muls(t1, e1, 255);
                                        };
                                        function h(t1, e1, r) {
                                            var n = t1.gl, i = n.getParameter(n.MAX_TEXTURE_SIZE);
                                            if (e1 < 0 || e1 > i || r < 0 || r > i) throw new Error("gl-texture2d: Invalid texture size");
                                            return t1._shape = [
                                                e1,
                                                r
                                            ], t1.bind(), n.texImage2D(n.TEXTURE_2D, 0, t1.format, e1, r, 0, t1.format, t1.type, null), t1._mipLevels = [
                                                0
                                            ], t1;
                                        }
                                        function p(t1, e1, r, n, i, a) {
                                            this.gl = t1, this.handle = e1, this.format = i, this.type = a, this._shape = [
                                                r,
                                                n
                                            ], this._mipLevels = [
                                                0
                                            ], this._magFilter = t1.NEAREST, this._minFilter = t1.NEAREST, this._wrapS = t1.CLAMP_TO_EDGE, this._wrapT = t1.CLAMP_TO_EDGE, this._anisoSamples = 1;
                                            var o = this, s = [
                                                this._wrapS,
                                                this._wrapT
                                            ];
                                            Object.defineProperties(s, [
                                                {
                                                    get: function() {
                                                        return o._wrapS;
                                                    },
                                                    set: function(t1) {
                                                        return o.wrapS = t1;
                                                    }
                                                },
                                                {
                                                    get: function() {
                                                        return o._wrapT;
                                                    },
                                                    set: function(t1) {
                                                        return o.wrapT = t1;
                                                    }
                                                }
                                            ]), this._wrapVector = s;
                                            var l = [
                                                this._shape[0],
                                                this._shape[1]
                                            ];
                                            Object.defineProperties(l, [
                                                {
                                                    get: function() {
                                                        return o._shape[0];
                                                    },
                                                    set: function(t1) {
                                                        return o.width = t1;
                                                    }
                                                },
                                                {
                                                    get: function() {
                                                        return o._shape[1];
                                                    },
                                                    set: function(t1) {
                                                        return o.height = t1;
                                                    }
                                                }
                                            ]), this._shapeVector = l;
                                        }
                                        var d = p.prototype;
                                        function m(t1, e1) {
                                            return 3 === t1.length ? 1 === e1[2] && e1[1] === t1[0] * t1[2] && e1[0] === t1[2] : 1 === e1[0] && e1[1] === t1[0];
                                        }
                                        function g(t1) {
                                            var e1 = t1.createTexture();
                                            return t1.bindTexture(t1.TEXTURE_2D, e1), t1.texParameteri(t1.TEXTURE_2D, t1.TEXTURE_MIN_FILTER, t1.NEAREST), t1.texParameteri(t1.TEXTURE_2D, t1.TEXTURE_MAG_FILTER, t1.NEAREST), t1.texParameteri(t1.TEXTURE_2D, t1.TEXTURE_WRAP_S, t1.CLAMP_TO_EDGE), t1.texParameteri(t1.TEXTURE_2D, t1.TEXTURE_WRAP_T, t1.CLAMP_TO_EDGE), e1;
                                        }
                                        function v(t1, e1, r, n, i) {
                                            var a = t1.getParameter(t1.MAX_TEXTURE_SIZE);
                                            if (e1 < 0 || e1 > a || r < 0 || r > a) throw new Error("gl-texture2d: Invalid texture shape");
                                            if (i === t1.FLOAT && !t1.getExtension("OES_texture_float")) throw new Error("gl-texture2d: Floating point textures not supported on this platform");
                                            var o = g(t1);
                                            return t1.texImage2D(t1.TEXTURE_2D, 0, n, e1, r, 0, n, i, null), new p(t1, o, e1, r, n, i);
                                        }
                                        function y(t1, e1, r, n, i, a) {
                                            var o = g(t1);
                                            return t1.texImage2D(t1.TEXTURE_2D, 0, i, i, a, e1), new p(t1, o, r, n, i, a);
                                        }
                                        function x(t1, e1) {
                                            var r = e1.dtype, o = e1.shape.slice(), s = t1.getParameter(t1.MAX_TEXTURE_SIZE);
                                            if (o[0] < 0 || o[0] > s || o[1] < 0 || o[1] > s) throw new Error("gl-texture2d: Invalid texture size");
                                            var l = m(o, e1.stride.slice()), c = 0;
                                            "float32" === r ? c = t1.FLOAT : "float64" === r ? (c = t1.FLOAT, l = !1, r = "float32") : "uint8" === r ? c = t1.UNSIGNED_BYTE : (c = t1.UNSIGNED_BYTE, l = !1, r = "uint8");
                                            var u, h, d = 0;
                                            if (2 === o.length) d = t1.LUMINANCE, o = [
                                                o[0],
                                                o[1],
                                                1
                                            ], e1 = n(e1.data, o, [
                                                e1.stride[0],
                                                e1.stride[1],
                                                1
                                            ], e1.offset);
                                            else {
                                                if (3 !== o.length) throw new Error("gl-texture2d: Invalid shape for texture");
                                                if (1 === o[2]) d = t1.ALPHA;
                                                else if (2 === o[2]) d = t1.LUMINANCE_ALPHA;
                                                else if (3 === o[2]) d = t1.RGB;
                                                else {
                                                    if (4 !== o[2]) throw new Error("gl-texture2d: Invalid shape for pixel coords");
                                                    d = t1.RGBA;
                                                }
                                            }
                                            c !== t1.FLOAT || t1.getExtension("OES_texture_float") || (c = t1.UNSIGNED_BYTE, l = !1);
                                            var v = e1.size;
                                            if (l) u = 0 === e1.offset && e1.data.length === v ? e1.data : e1.data.subarray(e1.offset, e1.offset + v);
                                            else {
                                                var y = [
                                                    o[2],
                                                    o[2] * o[0],
                                                    1
                                                ];
                                                h = a.malloc(v, r);
                                                var x = n(h, o, y, 0);
                                                "float32" !== r && "float64" !== r || c !== t1.UNSIGNED_BYTE ? i.assign(x, e1) : f(x, e1), u = h.subarray(0, v);
                                            }
                                            var b = g(t1);
                                            return t1.texImage2D(t1.TEXTURE_2D, 0, d, o[0], o[1], 0, d, c, u), l || a.free(h), new p(t1, b, o[0], o[1], d, c);
                                        }
                                        Object.defineProperties(d, {
                                            minFilter: {
                                                get: function() {
                                                    return this._minFilter;
                                                },
                                                set: function(t1) {
                                                    this.bind();
                                                    var e1 = this.gl;
                                                    if (this.type === e1.FLOAT && o.indexOf(t1) >= 0 && (e1.getExtension("OES_texture_float_linear") || (t1 = e1.NEAREST)), s.indexOf(t1) < 0) throw new Error("gl-texture2d: Unknown filter mode " + t1);
                                                    return e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MIN_FILTER, t1), this._minFilter = t1;
                                                }
                                            },
                                            magFilter: {
                                                get: function() {
                                                    return this._magFilter;
                                                },
                                                set: function(t1) {
                                                    this.bind();
                                                    var e1 = this.gl;
                                                    if (this.type === e1.FLOAT && o.indexOf(t1) >= 0 && (e1.getExtension("OES_texture_float_linear") || (t1 = e1.NEAREST)), s.indexOf(t1) < 0) throw new Error("gl-texture2d: Unknown filter mode " + t1);
                                                    return e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MAG_FILTER, t1), this._magFilter = t1;
                                                }
                                            },
                                            mipSamples: {
                                                get: function() {
                                                    return this._anisoSamples;
                                                },
                                                set: function(t1) {
                                                    var e1 = this._anisoSamples;
                                                    if (this._anisoSamples = 0 | Math.max(t1, 1), e1 !== this._anisoSamples) {
                                                        var r = this.gl.getExtension("EXT_texture_filter_anisotropic");
                                                        r && this.gl.texParameterf(this.gl.TEXTURE_2D, r.TEXTURE_MAX_ANISOTROPY_EXT, this._anisoSamples);
                                                    }
                                                    return this._anisoSamples;
                                                }
                                            },
                                            wrapS: {
                                                get: function() {
                                                    return this._wrapS;
                                                },
                                                set: function(t1) {
                                                    if (this.bind(), l.indexOf(t1) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + t1);
                                                    return this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, t1), this._wrapS = t1;
                                                }
                                            },
                                            wrapT: {
                                                get: function() {
                                                    return this._wrapT;
                                                },
                                                set: function(t1) {
                                                    if (this.bind(), l.indexOf(t1) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + t1);
                                                    return this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, t1), this._wrapT = t1;
                                                }
                                            },
                                            wrap: {
                                                get: function() {
                                                    return this._wrapVector;
                                                },
                                                set: function(t1) {
                                                    if (Array.isArray(t1) || (t1 = [
                                                        t1,
                                                        t1
                                                    ]), 2 !== t1.length) throw new Error("gl-texture2d: Must specify wrap mode for rows and columns");
                                                    for(var e1 = 0; e1 < 2; ++e1)if (l.indexOf(t1[e1]) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + t1);
                                                    this._wrapS = t1[0], this._wrapT = t1[1];
                                                    var r = this.gl;
                                                    return this.bind(), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, this._wrapS), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, this._wrapT), t1;
                                                }
                                            },
                                            shape: {
                                                get: function() {
                                                    return this._shapeVector;
                                                },
                                                set: function(t1) {
                                                    if (Array.isArray(t1)) {
                                                        if (2 !== t1.length) throw new Error("gl-texture2d: Invalid texture shape");
                                                    } else t1 = [
                                                        0 | t1,
                                                        0 | t1
                                                    ];
                                                    return h(this, 0 | t1[0], 0 | t1[1]), [
                                                        0 | t1[0],
                                                        0 | t1[1]
                                                    ];
                                                }
                                            },
                                            width: {
                                                get: function() {
                                                    return this._shape[0];
                                                },
                                                set: function(t1) {
                                                    return h(this, t1 |= 0, this._shape[1]), t1;
                                                }
                                            },
                                            height: {
                                                get: function() {
                                                    return this._shape[1];
                                                },
                                                set: function(t1) {
                                                    return t1 |= 0, h(this, this._shape[0], t1), t1;
                                                }
                                            }
                                        }), d.bind = function(t1) {
                                            var e1 = this.gl;
                                            return void 0 !== t1 && e1.activeTexture(e1.TEXTURE0 + (0 | t1)), e1.bindTexture(e1.TEXTURE_2D, this.handle), void 0 !== t1 ? 0 | t1 : e1.getParameter(e1.ACTIVE_TEXTURE) - e1.TEXTURE0;
                                        }, d.dispose = function() {
                                            this.gl.deleteTexture(this.handle);
                                        }, d.generateMipmap = function() {
                                            this.bind(), this.gl.generateMipmap(this.gl.TEXTURE_2D);
                                            for(var t1 = Math.min(this._shape[0], this._shape[1]), e1 = 0; t1 > 0; ++e1, t1 >>>= 1)this._mipLevels.indexOf(e1) < 0 && this._mipLevels.push(e1);
                                        }, d.setPixels = function(t1, e1, r, o) {
                                            var s = this.gl;
                                            this.bind(), Array.isArray(e1) ? (o = r, r = 0 | e1[1], e1 = 0 | e1[0]) : (e1 = e1 || 0, r = r || 0), o = o || 0;
                                            var l = u(t1) ? t1 : t1.raw;
                                            if (l) this._mipLevels.indexOf(o) < 0 ? (s.texImage2D(s.TEXTURE_2D, 0, this.format, this.format, this.type, l), this._mipLevels.push(o)) : s.texSubImage2D(s.TEXTURE_2D, o, e1, r, this.format, this.type, l);
                                            else {
                                                if (!(t1.shape && t1.stride && t1.data)) throw new Error("gl-texture2d: Unsupported data type");
                                                if (t1.shape.length < 2 || e1 + t1.shape[1] > this._shape[1] >>> o || r + t1.shape[0] > this._shape[0] >>> o || e1 < 0 || r < 0) throw new Error("gl-texture2d: Texture dimensions are out of bounds");
                                                !function(t1, e1, r, o, s, l, c, u) {
                                                    var h = u.dtype, p = u.shape.slice();
                                                    if (p.length < 2 || p.length > 3) throw new Error("gl-texture2d: Invalid ndarray, must be 2d or 3d");
                                                    var d = 0, g = 0, v = m(p, u.stride.slice());
                                                    "float32" === h ? d = t1.FLOAT : "float64" === h ? (d = t1.FLOAT, v = !1, h = "float32") : "uint8" === h ? d = t1.UNSIGNED_BYTE : (d = t1.UNSIGNED_BYTE, v = !1, h = "uint8");
                                                    if (2 === p.length) g = t1.LUMINANCE, p = [
                                                        p[0],
                                                        p[1],
                                                        1
                                                    ], u = n(u.data, p, [
                                                        u.stride[0],
                                                        u.stride[1],
                                                        1
                                                    ], u.offset);
                                                    else {
                                                        if (3 !== p.length) throw new Error("gl-texture2d: Invalid shape for texture");
                                                        if (1 === p[2]) g = t1.ALPHA;
                                                        else if (2 === p[2]) g = t1.LUMINANCE_ALPHA;
                                                        else if (3 === p[2]) g = t1.RGB;
                                                        else {
                                                            if (4 !== p[2]) throw new Error("gl-texture2d: Invalid shape for pixel coords");
                                                            g = t1.RGBA;
                                                        }
                                                        p[2];
                                                    }
                                                    g !== t1.LUMINANCE && g !== t1.ALPHA || s !== t1.LUMINANCE && s !== t1.ALPHA || (g = s);
                                                    if (g !== s) throw new Error("gl-texture2d: Incompatible texture format for setPixels");
                                                    var y = u.size, x = c.indexOf(o) < 0;
                                                    x && c.push(o);
                                                    if (d === l && v) 0 === u.offset && u.data.length === y ? x ? t1.texImage2D(t1.TEXTURE_2D, o, s, p[0], p[1], 0, s, l, u.data) : t1.texSubImage2D(t1.TEXTURE_2D, o, e1, r, p[0], p[1], s, l, u.data) : x ? t1.texImage2D(t1.TEXTURE_2D, o, s, p[0], p[1], 0, s, l, u.data.subarray(u.offset, u.offset + y)) : t1.texSubImage2D(t1.TEXTURE_2D, o, e1, r, p[0], p[1], s, l, u.data.subarray(u.offset, u.offset + y));
                                                    else {
                                                        var b;
                                                        b = l === t1.FLOAT ? a.mallocFloat32(y) : a.mallocUint8(y);
                                                        var _ = n(b, p, [
                                                            p[2],
                                                            p[2] * p[0],
                                                            1
                                                        ]);
                                                        d === t1.FLOAT && l === t1.UNSIGNED_BYTE ? f(_, u) : i.assign(_, u), x ? t1.texImage2D(t1.TEXTURE_2D, o, s, p[0], p[1], 0, s, l, b.subarray(0, y)) : t1.texSubImage2D(t1.TEXTURE_2D, o, e1, r, p[0], p[1], s, l, b.subarray(0, y)), l === t1.FLOAT ? a.freeFloat32(b) : a.freeUint8(b);
                                                    }
                                                }(s, e1, r, o, this.format, this.type, this._mipLevels, t1);
                                            }
                                        };
                                    },
                                    {
                                        ndarray: 259,
                                        "ndarray-ops": 254,
                                        "typedarray-pool": 308
                                    }
                                ],
                                147: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r) {
                                            e1 ? e1.bind() : t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, null);
                                            var n = 0 | t1.getParameter(t1.MAX_VERTEX_ATTRIBS);
                                            if (r) {
                                                if (r.length > n) throw new Error("gl-vao: Too many vertex attributes");
                                                for(var i = 0; i < r.length; ++i){
                                                    var a = r[i];
                                                    if (a.buffer) {
                                                        var o = a.buffer, s = a.size || 4, l = a.type || t1.FLOAT, c = !!a.normalized, u = a.stride || 0, f = a.offset || 0;
                                                        o.bind(), t1.enableVertexAttribArray(i), t1.vertexAttribPointer(i, s, l, c, u, f);
                                                    } else {
                                                        if ("number" == typeof a) t1.vertexAttrib1f(i, a);
                                                        else if (1 === a.length) t1.vertexAttrib1f(i, a[0]);
                                                        else if (2 === a.length) t1.vertexAttrib2f(i, a[0], a[1]);
                                                        else if (3 === a.length) t1.vertexAttrib3f(i, a[0], a[1], a[2]);
                                                        else {
                                                            if (4 !== a.length) throw new Error("gl-vao: Invalid vertex attribute");
                                                            t1.vertexAttrib4f(i, a[0], a[1], a[2], a[3]);
                                                        }
                                                        t1.disableVertexAttribArray(i);
                                                    }
                                                }
                                                for(; i < n; ++i)t1.disableVertexAttribArray(i);
                                            } else {
                                                t1.bindBuffer(t1.ARRAY_BUFFER, null);
                                                for(i = 0; i < n; ++i)t1.disableVertexAttribArray(i);
                                            }
                                        };
                                    },
                                    {}
                                ],
                                148: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./do-bind.js");
                                        function i(t1) {
                                            this.gl = t1, this._elements = null, this._attributes = null, this._elementsType = t1.UNSIGNED_SHORT;
                                        }
                                        i.prototype.bind = function() {
                                            n(this.gl, this._elements, this._attributes);
                                        }, i.prototype.update = function(t1, e1, r) {
                                            this._elements = e1, this._attributes = t1, this._elementsType = r || this.gl.UNSIGNED_SHORT;
                                        }, i.prototype.dispose = function() {}, i.prototype.unbind = function() {}, i.prototype.draw = function(t1, e1, r) {
                                            r = r || 0;
                                            var n = this.gl;
                                            this._elements ? n.drawElements(t1, e1, this._elementsType, r) : n.drawArrays(t1, r, e1);
                                        }, e1.exports = function(t1) {
                                            return new i(t1);
                                        };
                                    },
                                    {
                                        "./do-bind.js": 147
                                    }
                                ],
                                149: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./do-bind.js");
                                        function i(t1, e1, r, n, i, a) {
                                            this.location = t1, this.dimension = e1, this.a = r, this.b = n, this.c = i, this.d = a;
                                        }
                                        function a(t1, e1, r) {
                                            this.gl = t1, this._ext = e1, this.handle = r, this._attribs = [], this._useElements = !1, this._elementsType = t1.UNSIGNED_SHORT;
                                        }
                                        i.prototype.bind = function(t1) {
                                            switch(this.dimension){
                                                case 1:
                                                    t1.vertexAttrib1f(this.location, this.a);
                                                    break;
                                                case 2:
                                                    t1.vertexAttrib2f(this.location, this.a, this.b);
                                                    break;
                                                case 3:
                                                    t1.vertexAttrib3f(this.location, this.a, this.b, this.c);
                                                    break;
                                                case 4:
                                                    t1.vertexAttrib4f(this.location, this.a, this.b, this.c, this.d);
                                            }
                                        }, a.prototype.bind = function() {
                                            this._ext.bindVertexArrayOES(this.handle);
                                            for(var t1 = 0; t1 < this._attribs.length; ++t1)this._attribs[t1].bind(this.gl);
                                        }, a.prototype.unbind = function() {
                                            this._ext.bindVertexArrayOES(null);
                                        }, a.prototype.dispose = function() {
                                            this._ext.deleteVertexArrayOES(this.handle);
                                        }, a.prototype.update = function(t1, e1, r) {
                                            if (this.bind(), n(this.gl, e1, t1), this.unbind(), this._attribs.length = 0, t1) for(var a = 0; a < t1.length; ++a){
                                                var o = t1[a];
                                                "number" == typeof o ? this._attribs.push(new i(a, 1, o)) : Array.isArray(o) && this._attribs.push(new i(a, o.length, o[0], o[1], o[2], o[3]));
                                            }
                                            this._useElements = !!e1, this._elementsType = r || this.gl.UNSIGNED_SHORT;
                                        }, a.prototype.draw = function(t1, e1, r) {
                                            r = r || 0;
                                            var n = this.gl;
                                            this._useElements ? n.drawElements(t1, e1, this._elementsType, r) : n.drawArrays(t1, r, e1);
                                        }, e1.exports = function(t1, e1) {
                                            return new a(t1, e1, e1.createVertexArrayOES());
                                        };
                                    },
                                    {
                                        "./do-bind.js": 147
                                    }
                                ],
                                150: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./lib/vao-native.js"), i = t1("./lib/vao-emulated.js");
                                        function a(t1) {
                                            this.bindVertexArrayOES = t1.bindVertexArray.bind(t1), this.createVertexArrayOES = t1.createVertexArray.bind(t1), this.deleteVertexArrayOES = t1.deleteVertexArray.bind(t1);
                                        }
                                        e1.exports = function(t1, e1, r, o) {
                                            var s, l = t1.createVertexArray ? new a(t1) : t1.getExtension("OES_vertex_array_object");
                                            return (s = l ? n(t1, l) : i(t1)).update(e1, r, o), s;
                                        };
                                    },
                                    {
                                        "./lib/vao-emulated.js": 148,
                                        "./lib/vao-native.js": 149
                                    }
                                ],
                                151: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = e1[0] + r[0], t1[1] = e1[1] + r[1], t1[2] = e1[2] + r[2], t1;
                                        };
                                    },
                                    {}
                                ],
                                152: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = n(t1[0], t1[1], t1[2]), o = n(e1[0], e1[1], e1[2]);
                                            i(r, r), i(o, o);
                                            var s = a(r, o);
                                            return s > 1 ? 0 : Math.acos(s);
                                        };
                                        var n = t1("./fromValues"), i = t1("./normalize"), a = t1("./dot");
                                    },
                                    {
                                        "./dot": 162,
                                        "./fromValues": 168,
                                        "./normalize": 179
                                    }
                                ],
                                153: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return t1[0] = Math.ceil(e1[0]), t1[1] = Math.ceil(e1[1]), t1[2] = Math.ceil(e1[2]), t1;
                                        };
                                    },
                                    {}
                                ],
                                154: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            var e1 = new Float32Array(3);
                                            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1;
                                        };
                                    },
                                    {}
                                ],
                                155: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1;
                                        };
                                    },
                                    {}
                                ],
                                156: [
                                    function(t1, e1, r) {
                                        e1.exports = function() {
                                            var t1 = new Float32Array(3);
                                            return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1;
                                        };
                                    },
                                    {}
                                ],
                                157: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = e1[0], i = e1[1], a = e1[2], o = r[0], s = r[1], l = r[2];
                                            return t1[0] = i * l - a * s, t1[1] = a * o - n * l, t1[2] = n * s - i * o, t1;
                                        };
                                    },
                                    {}
                                ],
                                158: [
                                    function(t1, e1, r) {
                                        e1.exports = t1("./distance");
                                    },
                                    {
                                        "./distance": 159
                                    }
                                ],
                                159: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = e1[0] - t1[0], n = e1[1] - t1[1], i = e1[2] - t1[2];
                                            return Math.sqrt(r * r + n * n + i * i);
                                        };
                                    },
                                    {}
                                ],
                                160: [
                                    function(t1, e1, r) {
                                        e1.exports = t1("./divide");
                                    },
                                    {
                                        "./divide": 161
                                    }
                                ],
                                161: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = e1[0] / r[0], t1[1] = e1[1] / r[1], t1[2] = e1[2] / r[2], t1;
                                        };
                                    },
                                    {}
                                ],
                                162: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2];
                                        };
                                    },
                                    {}
                                ],
                                163: [
                                    function(t1, e1, r) {
                                        e1.exports = 1e-6;
                                    },
                                    {}
                                ],
                                164: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = t1[0], i = t1[1], a = t1[2], o = e1[0], s = e1[1], l = e1[2];
                                            return Math.abs(r - o) <= n * Math.max(1, Math.abs(r), Math.abs(o)) && Math.abs(i - s) <= n * Math.max(1, Math.abs(i), Math.abs(s)) && Math.abs(a - l) <= n * Math.max(1, Math.abs(a), Math.abs(l));
                                        };
                                        var n = t1("./epsilon");
                                    },
                                    {
                                        "./epsilon": 163
                                    }
                                ],
                                165: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return t1[0] === e1[0] && t1[1] === e1[1] && t1[2] === e1[2];
                                        };
                                    },
                                    {}
                                ],
                                166: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return t1[0] = Math.floor(e1[0]), t1[1] = Math.floor(e1[1]), t1[2] = Math.floor(e1[2]), t1;
                                        };
                                    },
                                    {}
                                ],
                                167: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, i, a, o) {
                                            var s, l;
                                            e1 || (e1 = 3);
                                            r || (r = 0);
                                            l = i ? Math.min(i * e1 + r, t1.length) : t1.length;
                                            for(s = r; s < l; s += e1)n[0] = t1[s], n[1] = t1[s + 1], n[2] = t1[s + 2], a(n, n, o), t1[s] = n[0], t1[s + 1] = n[1], t1[s + 2] = n[2];
                                            return t1;
                                        };
                                        var n = t1("./create")();
                                    },
                                    {
                                        "./create": 156
                                    }
                                ],
                                168: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = new Float32Array(3);
                                            return n[0] = t1, n[1] = e1, n[2] = r, n;
                                        };
                                    },
                                    {}
                                ],
                                169: [
                                    function(t1, e1, r) {
                                        e1.exports = {
                                            EPSILON: t1("./epsilon"),
                                            create: t1("./create"),
                                            clone: t1("./clone"),
                                            angle: t1("./angle"),
                                            fromValues: t1("./fromValues"),
                                            copy: t1("./copy"),
                                            set: t1("./set"),
                                            equals: t1("./equals"),
                                            exactEquals: t1("./exactEquals"),
                                            add: t1("./add"),
                                            subtract: t1("./subtract"),
                                            sub: t1("./sub"),
                                            multiply: t1("./multiply"),
                                            mul: t1("./mul"),
                                            divide: t1("./divide"),
                                            div: t1("./div"),
                                            min: t1("./min"),
                                            max: t1("./max"),
                                            floor: t1("./floor"),
                                            ceil: t1("./ceil"),
                                            round: t1("./round"),
                                            scale: t1("./scale"),
                                            scaleAndAdd: t1("./scaleAndAdd"),
                                            distance: t1("./distance"),
                                            dist: t1("./dist"),
                                            squaredDistance: t1("./squaredDistance"),
                                            sqrDist: t1("./sqrDist"),
                                            length: t1("./length"),
                                            len: t1("./len"),
                                            squaredLength: t1("./squaredLength"),
                                            sqrLen: t1("./sqrLen"),
                                            negate: t1("./negate"),
                                            inverse: t1("./inverse"),
                                            normalize: t1("./normalize"),
                                            dot: t1("./dot"),
                                            cross: t1("./cross"),
                                            lerp: t1("./lerp"),
                                            random: t1("./random"),
                                            transformMat4: t1("./transformMat4"),
                                            transformMat3: t1("./transformMat3"),
                                            transformQuat: t1("./transformQuat"),
                                            rotateX: t1("./rotateX"),
                                            rotateY: t1("./rotateY"),
                                            rotateZ: t1("./rotateZ"),
                                            forEach: t1("./forEach")
                                        };
                                    },
                                    {
                                        "./add": 151,
                                        "./angle": 152,
                                        "./ceil": 153,
                                        "./clone": 154,
                                        "./copy": 155,
                                        "./create": 156,
                                        "./cross": 157,
                                        "./dist": 158,
                                        "./distance": 159,
                                        "./div": 160,
                                        "./divide": 161,
                                        "./dot": 162,
                                        "./epsilon": 163,
                                        "./equals": 164,
                                        "./exactEquals": 165,
                                        "./floor": 166,
                                        "./forEach": 167,
                                        "./fromValues": 168,
                                        "./inverse": 170,
                                        "./len": 171,
                                        "./length": 172,
                                        "./lerp": 173,
                                        "./max": 174,
                                        "./min": 175,
                                        "./mul": 176,
                                        "./multiply": 177,
                                        "./negate": 178,
                                        "./normalize": 179,
                                        "./random": 180,
                                        "./rotateX": 181,
                                        "./rotateY": 182,
                                        "./rotateZ": 183,
                                        "./round": 184,
                                        "./scale": 185,
                                        "./scaleAndAdd": 186,
                                        "./set": 187,
                                        "./sqrDist": 188,
                                        "./sqrLen": 189,
                                        "./squaredDistance": 190,
                                        "./squaredLength": 191,
                                        "./sub": 192,
                                        "./subtract": 193,
                                        "./transformMat3": 194,
                                        "./transformMat4": 195,
                                        "./transformQuat": 196
                                    }
                                ],
                                170: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return t1[0] = 1 / e1[0], t1[1] = 1 / e1[1], t1[2] = 1 / e1[2], t1;
                                        };
                                    },
                                    {}
                                ],
                                171: [
                                    function(t1, e1, r) {
                                        e1.exports = t1("./length");
                                    },
                                    {
                                        "./length": 172
                                    }
                                ],
                                172: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            var e1 = t1[0], r = t1[1], n = t1[2];
                                            return Math.sqrt(e1 * e1 + r * r + n * n);
                                        };
                                    },
                                    {}
                                ],
                                173: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n) {
                                            var i = e1[0], a = e1[1], o = e1[2];
                                            return t1[0] = i + n * (r[0] - i), t1[1] = a + n * (r[1] - a), t1[2] = o + n * (r[2] - o), t1;
                                        };
                                    },
                                    {}
                                ],
                                174: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = Math.max(e1[0], r[0]), t1[1] = Math.max(e1[1], r[1]), t1[2] = Math.max(e1[2], r[2]), t1;
                                        };
                                    },
                                    {}
                                ],
                                175: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = Math.min(e1[0], r[0]), t1[1] = Math.min(e1[1], r[1]), t1[2] = Math.min(e1[2], r[2]), t1;
                                        };
                                    },
                                    {}
                                ],
                                176: [
                                    function(t1, e1, r) {
                                        e1.exports = t1("./multiply");
                                    },
                                    {
                                        "./multiply": 177
                                    }
                                ],
                                177: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = e1[0] * r[0], t1[1] = e1[1] * r[1], t1[2] = e1[2] * r[2], t1;
                                        };
                                    },
                                    {}
                                ],
                                178: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return t1[0] = -e1[0], t1[1] = -e1[1], t1[2] = -e1[2], t1;
                                        };
                                    },
                                    {}
                                ],
                                179: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = e1[0], n = e1[1], i = e1[2], a = r * r + n * n + i * i;
                                            a > 0 && (a = 1 / Math.sqrt(a), t1[0] = e1[0] * a, t1[1] = e1[1] * a, t1[2] = e1[2] * a);
                                            return t1;
                                        };
                                    },
                                    {}
                                ],
                                180: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            e1 = e1 || 1;
                                            var r = 2 * Math.random() * Math.PI, n = 2 * Math.random() - 1, i = Math.sqrt(1 - n * n) * e1;
                                            return t1[0] = Math.cos(r) * i, t1[1] = Math.sin(r) * i, t1[2] = n * e1, t1;
                                        };
                                    },
                                    {}
                                ],
                                181: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n) {
                                            var i = r[1], a = r[2], o = e1[1] - i, s = e1[2] - a, l = Math.sin(n), c = Math.cos(n);
                                            return t1[0] = e1[0], t1[1] = i + o * c - s * l, t1[2] = a + o * l + s * c, t1;
                                        };
                                    },
                                    {}
                                ],
                                182: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n) {
                                            var i = r[0], a = r[2], o = e1[0] - i, s = e1[2] - a, l = Math.sin(n), c = Math.cos(n);
                                            return t1[0] = i + s * l + o * c, t1[1] = e1[1], t1[2] = a + s * c - o * l, t1;
                                        };
                                    },
                                    {}
                                ],
                                183: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n) {
                                            var i = r[0], a = r[1], o = e1[0] - i, s = e1[1] - a, l = Math.sin(n), c = Math.cos(n);
                                            return t1[0] = i + o * c - s * l, t1[1] = a + o * l + s * c, t1[2] = e1[2], t1;
                                        };
                                    },
                                    {}
                                ],
                                184: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return t1[0] = Math.round(e1[0]), t1[1] = Math.round(e1[1]), t1[2] = Math.round(e1[2]), t1;
                                        };
                                    },
                                    {}
                                ],
                                185: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1;
                                        };
                                    },
                                    {}
                                ],
                                186: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n) {
                                            return t1[0] = e1[0] + r[0] * n, t1[1] = e1[1] + r[1] * n, t1[2] = e1[2] + r[2] * n, t1;
                                        };
                                    },
                                    {}
                                ],
                                187: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n) {
                                            return t1[0] = e1, t1[1] = r, t1[2] = n, t1;
                                        };
                                    },
                                    {}
                                ],
                                188: [
                                    function(t1, e1, r) {
                                        e1.exports = t1("./squaredDistance");
                                    },
                                    {
                                        "./squaredDistance": 190
                                    }
                                ],
                                189: [
                                    function(t1, e1, r) {
                                        e1.exports = t1("./squaredLength");
                                    },
                                    {
                                        "./squaredLength": 191
                                    }
                                ],
                                190: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = e1[0] - t1[0], n = e1[1] - t1[1], i = e1[2] - t1[2];
                                            return r * r + n * n + i * i;
                                        };
                                    },
                                    {}
                                ],
                                191: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            var e1 = t1[0], r = t1[1], n = t1[2];
                                            return e1 * e1 + r * r + n * n;
                                        };
                                    },
                                    {}
                                ],
                                192: [
                                    function(t1, e1, r) {
                                        e1.exports = t1("./subtract");
                                    },
                                    {
                                        "./subtract": 193
                                    }
                                ],
                                193: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = e1[0] - r[0], t1[1] = e1[1] - r[1], t1[2] = e1[2] - r[2], t1;
                                        };
                                    },
                                    {}
                                ],
                                194: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = e1[0], i = e1[1], a = e1[2];
                                            return t1[0] = n * r[0] + i * r[3] + a * r[6], t1[1] = n * r[1] + i * r[4] + a * r[7], t1[2] = n * r[2] + i * r[5] + a * r[8], t1;
                                        };
                                    },
                                    {}
                                ],
                                195: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = e1[0], i = e1[1], a = e1[2], o = r[3] * n + r[7] * i + r[11] * a + r[15];
                                            return o = o || 1, t1[0] = (r[0] * n + r[4] * i + r[8] * a + r[12]) / o, t1[1] = (r[1] * n + r[5] * i + r[9] * a + r[13]) / o, t1[2] = (r[2] * n + r[6] * i + r[10] * a + r[14]) / o, t1;
                                        };
                                    },
                                    {}
                                ],
                                196: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = e1[0], i = e1[1], a = e1[2], o = r[0], s = r[1], l = r[2], c = r[3], u = c * n + s * a - l * i, f = c * i + l * n - o * a, h = c * a + o * i - s * n, p = -o * n - s * i - l * a;
                                            return t1[0] = u * c + p * -o + f * -l - h * -s, t1[1] = f * c + p * -s + h * -o - u * -l, t1[2] = h * c + p * -l + u * -s - f * -o, t1;
                                        };
                                    },
                                    {}
                                ],
                                197: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = e1[0] + r[0], t1[1] = e1[1] + r[1], t1[2] = e1[2] + r[2], t1[3] = e1[3] + r[3], t1;
                                        };
                                    },
                                    {}
                                ],
                                198: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            var e1 = new Float32Array(4);
                                            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1;
                                        };
                                    },
                                    {}
                                ],
                                199: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1;
                                        };
                                    },
                                    {}
                                ],
                                200: [
                                    function(t1, e1, r) {
                                        e1.exports = function() {
                                            var t1 = new Float32Array(4);
                                            return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1;
                                        };
                                    },
                                    {}
                                ],
                                201: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = e1[0] - t1[0], n = e1[1] - t1[1], i = e1[2] - t1[2], a = e1[3] - t1[3];
                                            return Math.sqrt(r * r + n * n + i * i + a * a);
                                        };
                                    },
                                    {}
                                ],
                                202: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = e1[0] / r[0], t1[1] = e1[1] / r[1], t1[2] = e1[2] / r[2], t1[3] = e1[3] / r[3], t1;
                                        };
                                    },
                                    {}
                                ],
                                203: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return t1[0] * e1[0] + t1[1] * e1[1] + t1[2] * e1[2] + t1[3] * e1[3];
                                        };
                                    },
                                    {}
                                ],
                                204: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n) {
                                            var i = new Float32Array(4);
                                            return i[0] = t1, i[1] = e1, i[2] = r, i[3] = n, i;
                                        };
                                    },
                                    {}
                                ],
                                205: [
                                    function(t1, e1, r) {
                                        e1.exports = {
                                            create: t1("./create"),
                                            clone: t1("./clone"),
                                            fromValues: t1("./fromValues"),
                                            copy: t1("./copy"),
                                            set: t1("./set"),
                                            add: t1("./add"),
                                            subtract: t1("./subtract"),
                                            multiply: t1("./multiply"),
                                            divide: t1("./divide"),
                                            min: t1("./min"),
                                            max: t1("./max"),
                                            scale: t1("./scale"),
                                            scaleAndAdd: t1("./scaleAndAdd"),
                                            distance: t1("./distance"),
                                            squaredDistance: t1("./squaredDistance"),
                                            length: t1("./length"),
                                            squaredLength: t1("./squaredLength"),
                                            negate: t1("./negate"),
                                            inverse: t1("./inverse"),
                                            normalize: t1("./normalize"),
                                            dot: t1("./dot"),
                                            lerp: t1("./lerp"),
                                            random: t1("./random"),
                                            transformMat4: t1("./transformMat4"),
                                            transformQuat: t1("./transformQuat")
                                        };
                                    },
                                    {
                                        "./add": 197,
                                        "./clone": 198,
                                        "./copy": 199,
                                        "./create": 200,
                                        "./distance": 201,
                                        "./divide": 202,
                                        "./dot": 203,
                                        "./fromValues": 204,
                                        "./inverse": 206,
                                        "./length": 207,
                                        "./lerp": 208,
                                        "./max": 209,
                                        "./min": 210,
                                        "./multiply": 211,
                                        "./negate": 212,
                                        "./normalize": 213,
                                        "./random": 214,
                                        "./scale": 215,
                                        "./scaleAndAdd": 216,
                                        "./set": 217,
                                        "./squaredDistance": 218,
                                        "./squaredLength": 219,
                                        "./subtract": 220,
                                        "./transformMat4": 221,
                                        "./transformQuat": 222
                                    }
                                ],
                                206: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return t1[0] = 1 / e1[0], t1[1] = 1 / e1[1], t1[2] = 1 / e1[2], t1[3] = 1 / e1[3], t1;
                                        };
                                    },
                                    {}
                                ],
                                207: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            var e1 = t1[0], r = t1[1], n = t1[2], i = t1[3];
                                            return Math.sqrt(e1 * e1 + r * r + n * n + i * i);
                                        };
                                    },
                                    {}
                                ],
                                208: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n) {
                                            var i = e1[0], a = e1[1], o = e1[2], s = e1[3];
                                            return t1[0] = i + n * (r[0] - i), t1[1] = a + n * (r[1] - a), t1[2] = o + n * (r[2] - o), t1[3] = s + n * (r[3] - s), t1;
                                        };
                                    },
                                    {}
                                ],
                                209: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = Math.max(e1[0], r[0]), t1[1] = Math.max(e1[1], r[1]), t1[2] = Math.max(e1[2], r[2]), t1[3] = Math.max(e1[3], r[3]), t1;
                                        };
                                    },
                                    {}
                                ],
                                210: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = Math.min(e1[0], r[0]), t1[1] = Math.min(e1[1], r[1]), t1[2] = Math.min(e1[2], r[2]), t1[3] = Math.min(e1[3], r[3]), t1;
                                        };
                                    },
                                    {}
                                ],
                                211: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = e1[0] * r[0], t1[1] = e1[1] * r[1], t1[2] = e1[2] * r[2], t1[3] = e1[3] * r[3], t1;
                                        };
                                    },
                                    {}
                                ],
                                212: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            return t1[0] = -e1[0], t1[1] = -e1[1], t1[2] = -e1[2], t1[3] = -e1[3], t1;
                                        };
                                    },
                                    {}
                                ],
                                213: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = r * r + n * n + i * i + a * a;
                                            o > 0 && (o = 1 / Math.sqrt(o), t1[0] = r * o, t1[1] = n * o, t1[2] = i * o, t1[3] = a * o);
                                            return t1;
                                        };
                                    },
                                    {}
                                ],
                                214: [
                                    function(t1, e1, r) {
                                        var n = t1("./normalize"), i = t1("./scale");
                                        e1.exports = function(t1, e1) {
                                            return e1 = e1 || 1, t1[0] = Math.random(), t1[1] = Math.random(), t1[2] = Math.random(), t1[3] = Math.random(), n(t1, t1), i(t1, t1, e1), t1;
                                        };
                                    },
                                    {
                                        "./normalize": 213,
                                        "./scale": 215
                                    }
                                ],
                                215: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = e1[0] * r, t1[1] = e1[1] * r, t1[2] = e1[2] * r, t1[3] = e1[3] * r, t1;
                                        };
                                    },
                                    {}
                                ],
                                216: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n) {
                                            return t1[0] = e1[0] + r[0] * n, t1[1] = e1[1] + r[1] * n, t1[2] = e1[2] + r[2] * n, t1[3] = e1[3] + r[3] * n, t1;
                                        };
                                    },
                                    {}
                                ],
                                217: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n, i) {
                                            return t1[0] = e1, t1[1] = r, t1[2] = n, t1[3] = i, t1;
                                        };
                                    },
                                    {}
                                ],
                                218: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = e1[0] - t1[0], n = e1[1] - t1[1], i = e1[2] - t1[2], a = e1[3] - t1[3];
                                            return r * r + n * n + i * i + a * a;
                                        };
                                    },
                                    {}
                                ],
                                219: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            var e1 = t1[0], r = t1[1], n = t1[2], i = t1[3];
                                            return e1 * e1 + r * r + n * n + i * i;
                                        };
                                    },
                                    {}
                                ],
                                220: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1[0] = e1[0] - r[0], t1[1] = e1[1] - r[1], t1[2] = e1[2] - r[2], t1[3] = e1[3] - r[3], t1;
                                        };
                                    },
                                    {}
                                ],
                                221: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = e1[0], i = e1[1], a = e1[2], o = e1[3];
                                            return t1[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * o, t1[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * o, t1[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * o, t1[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * o, t1;
                                        };
                                    },
                                    {}
                                ],
                                222: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            var n = e1[0], i = e1[1], a = e1[2], o = r[0], s = r[1], l = r[2], c = r[3], u = c * n + s * a - l * i, f = c * i + l * n - o * a, h = c * a + o * i - s * n, p = -o * n - s * i - l * a;
                                            return t1[0] = u * c + p * -o + f * -l - h * -s, t1[1] = f * c + p * -s + h * -o - u * -l, t1[2] = h * c + p * -l + u * -s - f * -o, t1[3] = e1[3], t1;
                                        };
                                    },
                                    {}
                                ],
                                223: [
                                    function(t1, e1, r) {
                                        var n = t1("glsl-tokenizer"), i = t1("atob-lite");
                                        e1.exports = function(t1) {
                                            for(var e1 = Array.isArray(t1) ? t1 : n(t1), r = 0; r < e1.length; r++){
                                                var a = e1[r];
                                                if ("preprocessor" === a.type) {
                                                    var o = a.data.match(/\#define\s+SHADER_NAME(_B64)?\s+(.+)$/);
                                                    if (o && o[2]) {
                                                        var s = o[1], l = o[2];
                                                        return (s ? i(l) : l).trim();
                                                    }
                                                }
                                            }
                                        };
                                    },
                                    {
                                        "atob-lite": 13,
                                        "glsl-tokenizer": 230
                                    }
                                ],
                                224: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            var e1, r, c, u = 0, f = 0, h = 999, p = [], d = [], m = 1, g = 0, v = 0, y = !1, x = !1, b = "", _ = a, w = n;
                                            "300 es" === (t1 = t1 || {}).version && (_ = s, w = o);
                                            var T = {}, k = {};
                                            for(u = 0; u < _.length; u++)T[_[u]] = !0;
                                            for(u = 0; u < w.length; u++)k[w[u]] = !0;
                                            return function(t1) {
                                                return d = [], null !== t1 ? function(t1) {
                                                    u = 0, t1.toString && (t1 = t1.toString());
                                                    var r;
                                                    b += t1.replace(/\r\n/g, "\n"), c = b.length;
                                                    for(; e1 = b[u], u < c;){
                                                        switch(r = u, h){
                                                            case 0:
                                                                u = L();
                                                                break;
                                                            case 1:
                                                            case 2:
                                                                u = E();
                                                                break;
                                                            case 3:
                                                                u = C();
                                                                break;
                                                            case 4:
                                                                u = O();
                                                                break;
                                                            case 11:
                                                                u = I();
                                                                break;
                                                            case 5:
                                                                u = z();
                                                                break;
                                                            case 9999:
                                                                u = D();
                                                                break;
                                                            case 9:
                                                                u = S();
                                                                break;
                                                            case 999:
                                                                u = M();
                                                        }
                                                        if (r !== u) switch(b[r]){
                                                            case "\n":
                                                                g = 0, ++m;
                                                                break;
                                                            default:
                                                                ++g;
                                                        }
                                                    }
                                                    return f += u, b = b.slice(u), d;
                                                }(t1) : function(t1) {
                                                    p.length && A(p.join(""));
                                                    return h = 10, A("(eof)"), d;
                                                }();
                                            };
                                            function A(t1) {
                                                t1.length && d.push({
                                                    type: l[h],
                                                    data: t1,
                                                    position: v,
                                                    line: m,
                                                    column: g
                                                });
                                            }
                                            function M() {
                                                return p = p.length ? [] : p, "/" === r && "*" === e1 ? (v = f + u - 1, h = 0, r = e1, u + 1) : "/" === r && "/" === e1 ? (v = f + u - 1, h = 1, r = e1, u + 1) : "#" === e1 ? (h = 2, v = f + u, u) : /\s/.test(e1) ? (h = 9, v = f + u, u) : (y = /\d/.test(e1), x = /[^\w_]/.test(e1), v = f + u, h = y ? 4 : x ? 3 : 9999, u);
                                            }
                                            function S() {
                                                return /[^\s]/g.test(e1) ? (A(p.join("")), h = 999, u) : (p.push(e1), r = e1, u + 1);
                                            }
                                            function E() {
                                                return "\r" !== e1 && "\n" !== e1 || "\\" === r ? (p.push(e1), r = e1, u + 1) : (A(p.join("")), h = 999, u);
                                            }
                                            function L() {
                                                return "/" === e1 && "*" === r ? (p.push(e1), A(p.join("")), h = 999, u + 1) : (p.push(e1), r = e1, u + 1);
                                            }
                                            function C() {
                                                if ("." === r && /\d/.test(e1)) return h = 5, u;
                                                if ("/" === r && "*" === e1) return h = 0, u;
                                                if ("/" === r && "/" === e1) return h = 1, u;
                                                if ("." === e1 && p.length) {
                                                    for(; P(p););
                                                    return h = 5, u;
                                                }
                                                if (";" === e1 || ")" === e1 || "(" === e1) {
                                                    if (p.length) for(; P(p););
                                                    return A(e1), h = 999, u + 1;
                                                }
                                                var t1 = 2 === p.length && "=" !== e1;
                                                if (/[\w_\d\s]/.test(e1) || t1) {
                                                    for(; P(p););
                                                    return h = 999, u;
                                                }
                                                return p.push(e1), r = e1, u + 1;
                                            }
                                            function P(t1) {
                                                for(var e1, r, n = 0;;){
                                                    if (e1 = i.indexOf(t1.slice(0, t1.length + n).join("")), r = i[e1], -1 === e1) {
                                                        if (n-- + t1.length > 0) continue;
                                                        r = t1.slice(0, 1).join("");
                                                    }
                                                    return A(r), v += r.length, (p = p.slice(r.length)).length;
                                                }
                                            }
                                            function I() {
                                                return /[^a-fA-F0-9]/.test(e1) ? (A(p.join("")), h = 999, u) : (p.push(e1), r = e1, u + 1);
                                            }
                                            function O() {
                                                return "." === e1 || /[eE]/.test(e1) ? (p.push(e1), h = 5, r = e1, u + 1) : "x" === e1 && 1 === p.length && "0" === p[0] ? (h = 11, p.push(e1), r = e1, u + 1) : /[^\d]/.test(e1) ? (A(p.join("")), h = 999, u) : (p.push(e1), r = e1, u + 1);
                                            }
                                            function z() {
                                                return "f" === e1 && (p.push(e1), r = e1, u += 1), /[eE]/.test(e1) ? (p.push(e1), r = e1, u + 1) : ("-" !== e1 && "+" !== e1 || !/[eE]/.test(r)) && /[^\d]/.test(e1) ? (A(p.join("")), h = 999, u) : (p.push(e1), r = e1, u + 1);
                                            }
                                            function D() {
                                                if (/[^\d\w_]/.test(e1)) {
                                                    var t1 = p.join("");
                                                    return h = k[t1] ? 8 : T[t1] ? 7 : 6, A(p.join("")), h = 999, u;
                                                }
                                                return p.push(e1), r = e1, u + 1;
                                            }
                                        };
                                        var n = t1("./lib/literals"), i = t1("./lib/operators"), a = t1("./lib/builtins"), o = t1("./lib/literals-300es"), s = t1("./lib/builtins-300es"), l = [
                                            "block-comment",
                                            "line-comment",
                                            "preprocessor",
                                            "operator",
                                            "integer",
                                            "float",
                                            "ident",
                                            "builtin",
                                            "keyword",
                                            "whitespace",
                                            "eof",
                                            "integer"
                                        ];
                                    },
                                    {
                                        "./lib/builtins": 226,
                                        "./lib/builtins-300es": 225,
                                        "./lib/literals": 228,
                                        "./lib/literals-300es": 227,
                                        "./lib/operators": 229
                                    }
                                ],
                                225: [
                                    function(t1, e1, r) {
                                        var n = t1("./builtins");
                                        n = n.slice().filter(function(t1) {
                                            return !/^(gl\_|texture)/.test(t1);
                                        }), e1.exports = n.concat([
                                            "gl_VertexID",
                                            "gl_InstanceID",
                                            "gl_Position",
                                            "gl_PointSize",
                                            "gl_FragCoord",
                                            "gl_FrontFacing",
                                            "gl_FragDepth",
                                            "gl_PointCoord",
                                            "gl_MaxVertexAttribs",
                                            "gl_MaxVertexUniformVectors",
                                            "gl_MaxVertexOutputVectors",
                                            "gl_MaxFragmentInputVectors",
                                            "gl_MaxVertexTextureImageUnits",
                                            "gl_MaxCombinedTextureImageUnits",
                                            "gl_MaxTextureImageUnits",
                                            "gl_MaxFragmentUniformVectors",
                                            "gl_MaxDrawBuffers",
                                            "gl_MinProgramTexelOffset",
                                            "gl_MaxProgramTexelOffset",
                                            "gl_DepthRangeParameters",
                                            "gl_DepthRange",
                                            "trunc",
                                            "round",
                                            "roundEven",
                                            "isnan",
                                            "isinf",
                                            "floatBitsToInt",
                                            "floatBitsToUint",
                                            "intBitsToFloat",
                                            "uintBitsToFloat",
                                            "packSnorm2x16",
                                            "unpackSnorm2x16",
                                            "packUnorm2x16",
                                            "unpackUnorm2x16",
                                            "packHalf2x16",
                                            "unpackHalf2x16",
                                            "outerProduct",
                                            "transpose",
                                            "determinant",
                                            "inverse",
                                            "texture",
                                            "textureSize",
                                            "textureProj",
                                            "textureLod",
                                            "textureOffset",
                                            "texelFetch",
                                            "texelFetchOffset",
                                            "textureProjOffset",
                                            "textureLodOffset",
                                            "textureProjLod",
                                            "textureProjLodOffset",
                                            "textureGrad",
                                            "textureGradOffset",
                                            "textureProjGrad",
                                            "textureProjGradOffset"
                                        ]);
                                    },
                                    {
                                        "./builtins": 226
                                    }
                                ],
                                226: [
                                    function(t1, e1, r) {
                                        e1.exports = [
                                            "abs",
                                            "acos",
                                            "all",
                                            "any",
                                            "asin",
                                            "atan",
                                            "ceil",
                                            "clamp",
                                            "cos",
                                            "cross",
                                            "dFdx",
                                            "dFdy",
                                            "degrees",
                                            "distance",
                                            "dot",
                                            "equal",
                                            "exp",
                                            "exp2",
                                            "faceforward",
                                            "floor",
                                            "fract",
                                            "gl_BackColor",
                                            "gl_BackLightModelProduct",
                                            "gl_BackLightProduct",
                                            "gl_BackMaterial",
                                            "gl_BackSecondaryColor",
                                            "gl_ClipPlane",
                                            "gl_ClipVertex",
                                            "gl_Color",
                                            "gl_DepthRange",
                                            "gl_DepthRangeParameters",
                                            "gl_EyePlaneQ",
                                            "gl_EyePlaneR",
                                            "gl_EyePlaneS",
                                            "gl_EyePlaneT",
                                            "gl_Fog",
                                            "gl_FogCoord",
                                            "gl_FogFragCoord",
                                            "gl_FogParameters",
                                            "gl_FragColor",
                                            "gl_FragCoord",
                                            "gl_FragData",
                                            "gl_FragDepth",
                                            "gl_FragDepthEXT",
                                            "gl_FrontColor",
                                            "gl_FrontFacing",
                                            "gl_FrontLightModelProduct",
                                            "gl_FrontLightProduct",
                                            "gl_FrontMaterial",
                                            "gl_FrontSecondaryColor",
                                            "gl_LightModel",
                                            "gl_LightModelParameters",
                                            "gl_LightModelProducts",
                                            "gl_LightProducts",
                                            "gl_LightSource",
                                            "gl_LightSourceParameters",
                                            "gl_MaterialParameters",
                                            "gl_MaxClipPlanes",
                                            "gl_MaxCombinedTextureImageUnits",
                                            "gl_MaxDrawBuffers",
                                            "gl_MaxFragmentUniformComponents",
                                            "gl_MaxLights",
                                            "gl_MaxTextureCoords",
                                            "gl_MaxTextureImageUnits",
                                            "gl_MaxTextureUnits",
                                            "gl_MaxVaryingFloats",
                                            "gl_MaxVertexAttribs",
                                            "gl_MaxVertexTextureImageUnits",
                                            "gl_MaxVertexUniformComponents",
                                            "gl_ModelViewMatrix",
                                            "gl_ModelViewMatrixInverse",
                                            "gl_ModelViewMatrixInverseTranspose",
                                            "gl_ModelViewMatrixTranspose",
                                            "gl_ModelViewProjectionMatrix",
                                            "gl_ModelViewProjectionMatrixInverse",
                                            "gl_ModelViewProjectionMatrixInverseTranspose",
                                            "gl_ModelViewProjectionMatrixTranspose",
                                            "gl_MultiTexCoord0",
                                            "gl_MultiTexCoord1",
                                            "gl_MultiTexCoord2",
                                            "gl_MultiTexCoord3",
                                            "gl_MultiTexCoord4",
                                            "gl_MultiTexCoord5",
                                            "gl_MultiTexCoord6",
                                            "gl_MultiTexCoord7",
                                            "gl_Normal",
                                            "gl_NormalMatrix",
                                            "gl_NormalScale",
                                            "gl_ObjectPlaneQ",
                                            "gl_ObjectPlaneR",
                                            "gl_ObjectPlaneS",
                                            "gl_ObjectPlaneT",
                                            "gl_Point",
                                            "gl_PointCoord",
                                            "gl_PointParameters",
                                            "gl_PointSize",
                                            "gl_Position",
                                            "gl_ProjectionMatrix",
                                            "gl_ProjectionMatrixInverse",
                                            "gl_ProjectionMatrixInverseTranspose",
                                            "gl_ProjectionMatrixTranspose",
                                            "gl_SecondaryColor",
                                            "gl_TexCoord",
                                            "gl_TextureEnvColor",
                                            "gl_TextureMatrix",
                                            "gl_TextureMatrixInverse",
                                            "gl_TextureMatrixInverseTranspose",
                                            "gl_TextureMatrixTranspose",
                                            "gl_Vertex",
                                            "greaterThan",
                                            "greaterThanEqual",
                                            "inversesqrt",
                                            "length",
                                            "lessThan",
                                            "lessThanEqual",
                                            "log",
                                            "log2",
                                            "matrixCompMult",
                                            "max",
                                            "min",
                                            "mix",
                                            "mod",
                                            "normalize",
                                            "not",
                                            "notEqual",
                                            "pow",
                                            "radians",
                                            "reflect",
                                            "refract",
                                            "sign",
                                            "sin",
                                            "smoothstep",
                                            "sqrt",
                                            "step",
                                            "tan",
                                            "texture2D",
                                            "texture2DLod",
                                            "texture2DProj",
                                            "texture2DProjLod",
                                            "textureCube",
                                            "textureCubeLod",
                                            "texture2DLodEXT",
                                            "texture2DProjLodEXT",
                                            "textureCubeLodEXT",
                                            "texture2DGradEXT",
                                            "texture2DProjGradEXT",
                                            "textureCubeGradEXT"
                                        ];
                                    },
                                    {}
                                ],
                                227: [
                                    function(t1, e1, r) {
                                        var n = t1("./literals");
                                        e1.exports = n.slice().concat([
                                            "layout",
                                            "centroid",
                                            "smooth",
                                            "case",
                                            "mat2x2",
                                            "mat2x3",
                                            "mat2x4",
                                            "mat3x2",
                                            "mat3x3",
                                            "mat3x4",
                                            "mat4x2",
                                            "mat4x3",
                                            "mat4x4",
                                            "uvec2",
                                            "uvec3",
                                            "uvec4",
                                            "samplerCubeShadow",
                                            "sampler2DArray",
                                            "sampler2DArrayShadow",
                                            "isampler2D",
                                            "isampler3D",
                                            "isamplerCube",
                                            "isampler2DArray",
                                            "usampler2D",
                                            "usampler3D",
                                            "usamplerCube",
                                            "usampler2DArray",
                                            "coherent",
                                            "restrict",
                                            "readonly",
                                            "writeonly",
                                            "resource",
                                            "atomic_uint",
                                            "noperspective",
                                            "patch",
                                            "sample",
                                            "subroutine",
                                            "common",
                                            "partition",
                                            "active",
                                            "filter",
                                            "image1D",
                                            "image2D",
                                            "image3D",
                                            "imageCube",
                                            "iimage1D",
                                            "iimage2D",
                                            "iimage3D",
                                            "iimageCube",
                                            "uimage1D",
                                            "uimage2D",
                                            "uimage3D",
                                            "uimageCube",
                                            "image1DArray",
                                            "image2DArray",
                                            "iimage1DArray",
                                            "iimage2DArray",
                                            "uimage1DArray",
                                            "uimage2DArray",
                                            "image1DShadow",
                                            "image2DShadow",
                                            "image1DArrayShadow",
                                            "image2DArrayShadow",
                                            "imageBuffer",
                                            "iimageBuffer",
                                            "uimageBuffer",
                                            "sampler1DArray",
                                            "sampler1DArrayShadow",
                                            "isampler1D",
                                            "isampler1DArray",
                                            "usampler1D",
                                            "usampler1DArray",
                                            "isampler2DRect",
                                            "usampler2DRect",
                                            "samplerBuffer",
                                            "isamplerBuffer",
                                            "usamplerBuffer",
                                            "sampler2DMS",
                                            "isampler2DMS",
                                            "usampler2DMS",
                                            "sampler2DMSArray",
                                            "isampler2DMSArray",
                                            "usampler2DMSArray"
                                        ]);
                                    },
                                    {
                                        "./literals": 228
                                    }
                                ],
                                228: [
                                    function(t1, e1, r) {
                                        e1.exports = [
                                            "precision",
                                            "highp",
                                            "mediump",
                                            "lowp",
                                            "attribute",
                                            "const",
                                            "uniform",
                                            "varying",
                                            "break",
                                            "continue",
                                            "do",
                                            "for",
                                            "while",
                                            "if",
                                            "else",
                                            "in",
                                            "out",
                                            "inout",
                                            "float",
                                            "int",
                                            "uint",
                                            "void",
                                            "bool",
                                            "true",
                                            "false",
                                            "discard",
                                            "return",
                                            "mat2",
                                            "mat3",
                                            "mat4",
                                            "vec2",
                                            "vec3",
                                            "vec4",
                                            "ivec2",
                                            "ivec3",
                                            "ivec4",
                                            "bvec2",
                                            "bvec3",
                                            "bvec4",
                                            "sampler1D",
                                            "sampler2D",
                                            "sampler3D",
                                            "samplerCube",
                                            "sampler1DShadow",
                                            "sampler2DShadow",
                                            "struct",
                                            "asm",
                                            "class",
                                            "union",
                                            "enum",
                                            "typedef",
                                            "template",
                                            "this",
                                            "packed",
                                            "goto",
                                            "switch",
                                            "default",
                                            "inline",
                                            "noinline",
                                            "volatile",
                                            "public",
                                            "static",
                                            "extern",
                                            "external",
                                            "interface",
                                            "long",
                                            "short",
                                            "double",
                                            "half",
                                            "fixed",
                                            "unsigned",
                                            "input",
                                            "output",
                                            "hvec2",
                                            "hvec3",
                                            "hvec4",
                                            "dvec2",
                                            "dvec3",
                                            "dvec4",
                                            "fvec2",
                                            "fvec3",
                                            "fvec4",
                                            "sampler2DRect",
                                            "sampler3DRect",
                                            "sampler2DRectShadow",
                                            "sizeof",
                                            "cast",
                                            "namespace",
                                            "using"
                                        ];
                                    },
                                    {}
                                ],
                                229: [
                                    function(t1, e1, r) {
                                        e1.exports = [
                                            "<<=",
                                            ">>=",
                                            "++",
                                            "--",
                                            "<<",
                                            ">>",
                                            "<=",
                                            ">=",
                                            "==",
                                            "!=",
                                            "&&",
                                            "||",
                                            "+=",
                                            "-=",
                                            "*=",
                                            "/=",
                                            "%=",
                                            "&=",
                                            "^^",
                                            "^=",
                                            "|=",
                                            "(",
                                            ")",
                                            "[",
                                            "]",
                                            ".",
                                            "!",
                                            "~",
                                            "*",
                                            "/",
                                            "%",
                                            "+",
                                            "-",
                                            "<",
                                            ">",
                                            "&",
                                            "^",
                                            "|",
                                            "?",
                                            ":",
                                            "=",
                                            ",",
                                            ";",
                                            "{",
                                            "}"
                                        ];
                                    },
                                    {}
                                ],
                                230: [
                                    function(t1, e1, r) {
                                        var n = t1("./index");
                                        e1.exports = function(t1, e1) {
                                            var r = n(e1), i = [];
                                            return i = (i = i.concat(r(t1))).concat(r(null));
                                        };
                                    },
                                    {
                                        "./index": 224
                                    }
                                ],
                                231: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            "string" == typeof t1 && (t1 = [
                                                t1
                                            ]);
                                            for(var e1 = [].slice.call(arguments, 1), r = [], n = 0; n < t1.length - 1; n++)r.push(t1[n], e1[n] || "");
                                            return r.push(t1[n]), r.join("");
                                        };
                                    },
                                    {}
                                ],
                                232: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("is-browser");
                                        e1.exports = n && function() {
                                            var t1 = !1;
                                            try {
                                                var e1 = Object.defineProperty({}, "passive", {
                                                    get: function() {
                                                        t1 = !0;
                                                    }
                                                });
                                                window.addEventListener("test", null, e1), window.removeEventListener("test", null, e1);
                                            } catch (e1) {
                                                t1 = !1;
                                            }
                                            return t1;
                                        }();
                                    },
                                    {
                                        "is-browser": 236
                                    }
                                ],
                                233: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            var r = t1.length;
                                            if (0 === r) throw new Error("Must have at least d+1 points");
                                            var i = t1[0].length;
                                            if (r <= i) throw new Error("Must input at least d+1 points");
                                            var o = t1.slice(0, i + 1), s = n.apply(void 0, o);
                                            if (0 === s) throw new Error("Input not in general position");
                                            for(var l = new Array(i + 1), u = 0; u <= i; ++u)l[u] = u;
                                            s < 0 && (l[0] = 1, l[1] = 0);
                                            var f = new a(l, new Array(i + 1), !1), h = f.adjacent, p = new Array(i + 2);
                                            for(u = 0; u <= i; ++u){
                                                for(var d = l.slice(), m = 0; m <= i; ++m)m === u && (d[m] = -1);
                                                var g = d[0];
                                                d[0] = d[1], d[1] = g;
                                                var v = new a(d, new Array(i + 1), !0);
                                                h[u] = v, p[u] = v;
                                            }
                                            p[i + 1] = f;
                                            for(u = 0; u <= i; ++u){
                                                d = h[u].vertices;
                                                var y = h[u].adjacent;
                                                for(m = 0; m <= i; ++m){
                                                    var x = d[m];
                                                    if (x < 0) y[m] = f;
                                                    else for(var b = 0; b <= i; ++b)h[b].vertices.indexOf(x) < 0 && (y[m] = h[b]);
                                                }
                                            }
                                            var _ = new c(i, o, p), w = !!e1;
                                            for(u = i + 1; u < r; ++u)_.insert(t1[u], w);
                                            return _.boundary();
                                        };
                                        var n = t1("robust-orientation"), i = t1("simplicial-complex").compareCells;
                                        function a(t1, e1, r) {
                                            this.vertices = t1, this.adjacent = e1, this.boundary = r, this.lastVisited = -1;
                                        }
                                        function o(t1, e1, r) {
                                            this.vertices = t1, this.cell = e1, this.index = r;
                                        }
                                        function s(t1, e1) {
                                            return i(t1.vertices, e1.vertices);
                                        }
                                        a.prototype.flip = function() {
                                            var t1 = this.vertices[0];
                                            this.vertices[0] = this.vertices[1], this.vertices[1] = t1;
                                            var e1 = this.adjacent[0];
                                            this.adjacent[0] = this.adjacent[1], this.adjacent[1] = e1;
                                        };
                                        var l = [];
                                        function c(t1, e1, r) {
                                            this.dimension = t1, this.vertices = e1, this.simplices = r, this.interior = r.filter(function(t1) {
                                                return !t1.boundary;
                                            }), this.tuple = new Array(t1 + 1);
                                            for(var i = 0; i <= t1; ++i)this.tuple[i] = this.vertices[i];
                                            var a, o = l[t1];
                                            o || (o = l[t1] = ((a = n[t1 + 1]) || (a = n), function(t1) {
                                                return function() {
                                                    var e1 = this.tuple;
                                                    return t1.apply(this, e1);
                                                };
                                            }(a))), this.orient = o;
                                        }
                                        var u = c.prototype;
                                        u.handleBoundaryDegeneracy = function(t1, e1) {
                                            var r = this.dimension, n = this.vertices.length - 1, i = this.tuple, a = this.vertices, o = [
                                                t1
                                            ];
                                            for(t1.lastVisited = -n; o.length > 0;)for(var s = (t1 = o.pop()).adjacent, l = 0; l <= r; ++l){
                                                var c = s[l];
                                                if (c.boundary && !(c.lastVisited <= -n)) {
                                                    for(var u = c.vertices, f = 0; f <= r; ++f){
                                                        var h = u[f];
                                                        i[f] = h < 0 ? e1 : a[h];
                                                    }
                                                    var p = this.orient();
                                                    if (p > 0) return c;
                                                    c.lastVisited = -n, 0 === p && o.push(c);
                                                }
                                            }
                                            return null;
                                        }, u.walk = function(t1, e1) {
                                            var r = this.vertices.length - 1, n = this.dimension, i = this.vertices, a = this.tuple, o = e1 ? this.interior.length * Math.random() | 0 : this.interior.length - 1, s = this.interior[o];
                                            t: for(; !s.boundary;){
                                                for(var l = s.vertices, c = s.adjacent, u = 0; u <= n; ++u)a[u] = i[l[u]];
                                                s.lastVisited = r;
                                                for(u = 0; u <= n; ++u){
                                                    var f = c[u];
                                                    if (!(f.lastVisited >= r)) {
                                                        var h = a[u];
                                                        a[u] = t1;
                                                        var p = this.orient();
                                                        if (a[u] = h, p < 0) {
                                                            s = f;
                                                            continue t;
                                                        }
                                                        f.boundary ? f.lastVisited = -r : f.lastVisited = r;
                                                    }
                                                }
                                                return;
                                            }
                                            return s;
                                        }, u.addPeaks = function(t1, e1) {
                                            var r = this.vertices.length - 1, n = this.dimension, i = this.vertices, l = this.tuple, c = this.interior, u = this.simplices, f = [
                                                e1
                                            ];
                                            e1.lastVisited = r, e1.vertices[e1.vertices.indexOf(-1)] = r, e1.boundary = !1, c.push(e1);
                                            for(var h = []; f.length > 0;){
                                                var p = (e1 = f.pop()).vertices, d = e1.adjacent, m = p.indexOf(r);
                                                if (!(m < 0)) {
                                                    for(var g = 0; g <= n; ++g)if (g !== m) {
                                                        var v = d[g];
                                                        if (v.boundary && !(v.lastVisited >= r)) {
                                                            var y = v.vertices;
                                                            if (v.lastVisited !== -r) {
                                                                for(var x = 0, b = 0; b <= n; ++b)y[b] < 0 ? (x = b, l[b] = t1) : l[b] = i[y[b]];
                                                                if (this.orient() > 0) {
                                                                    y[x] = r, v.boundary = !1, c.push(v), f.push(v), v.lastVisited = r;
                                                                    continue;
                                                                }
                                                                v.lastVisited = -r;
                                                            }
                                                            var _ = v.adjacent, w = p.slice(), T = d.slice(), k = new a(w, T, !0);
                                                            u.push(k);
                                                            var A = _.indexOf(e1);
                                                            if (!(A < 0)) {
                                                                _[A] = k, T[m] = v, w[g] = -1, T[g] = e1, d[g] = k, k.flip();
                                                                for(b = 0; b <= n; ++b){
                                                                    var M = w[b];
                                                                    if (!(M < 0 || M === r)) {
                                                                        for(var S = new Array(n - 1), E = 0, L = 0; L <= n; ++L){
                                                                            var C = w[L];
                                                                            C < 0 || L === b || (S[E++] = C);
                                                                        }
                                                                        h.push(new o(S, k, b));
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            h.sort(s);
                                            for(g = 0; g + 1 < h.length; g += 2){
                                                var P = h[g], I = h[g + 1], O = P.index, z = I.index;
                                                O < 0 || z < 0 || (P.cell.adjacent[P.index] = I.cell, I.cell.adjacent[I.index] = P.cell);
                                            }
                                        }, u.insert = function(t1, e1) {
                                            var r = this.vertices;
                                            r.push(t1);
                                            var n = this.walk(t1, e1);
                                            if (n) {
                                                for(var i = this.dimension, a = this.tuple, o = 0; o <= i; ++o){
                                                    var s = n.vertices[o];
                                                    a[o] = s < 0 ? t1 : r[s];
                                                }
                                                var l = this.orient(a);
                                                l < 0 || (0 !== l || (n = this.handleBoundaryDegeneracy(n, t1))) && this.addPeaks(t1, n);
                                            }
                                        }, u.boundary = function() {
                                            for(var t1 = this.dimension, e1 = [], r = this.simplices, n = r.length, i = 0; i < n; ++i){
                                                var a = r[i];
                                                if (a.boundary) {
                                                    for(var o = new Array(t1), s = a.vertices, l = 0, c = 0, u = 0; u <= t1; ++u)s[u] >= 0 ? o[l++] = s[u] : c = 1 & u;
                                                    if (c === (1 & t1)) {
                                                        var f = o[0];
                                                        o[0] = o[1], o[1] = f;
                                                    }
                                                    e1.push(o);
                                                }
                                            }
                                            return e1;
                                        };
                                    },
                                    {
                                        "robust-orientation": 284,
                                        "simplicial-complex": 293
                                    }
                                ],
                                234: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("binary-search-bounds");
                                        function i(t1, e1, r, n, i) {
                                            this.mid = t1, this.left = e1, this.right = r, this.leftPoints = n, this.rightPoints = i, this.count = (e1 ? e1.count : 0) + (r ? r.count : 0) + n.length;
                                        }
                                        e1.exports = function(t1) {
                                            if (!t1 || 0 === t1.length) return new v(null);
                                            return new v(g(t1));
                                        };
                                        var a = i.prototype;
                                        function o(t1, e1) {
                                            t1.mid = e1.mid, t1.left = e1.left, t1.right = e1.right, t1.leftPoints = e1.leftPoints, t1.rightPoints = e1.rightPoints, t1.count = e1.count;
                                        }
                                        function s(t1, e1) {
                                            var r = g(e1);
                                            t1.mid = r.mid, t1.left = r.left, t1.right = r.right, t1.leftPoints = r.leftPoints, t1.rightPoints = r.rightPoints, t1.count = r.count;
                                        }
                                        function l(t1, e1) {
                                            var r = t1.intervals([]);
                                            r.push(e1), s(t1, r);
                                        }
                                        function c(t1, e1) {
                                            var r = t1.intervals([]), n = r.indexOf(e1);
                                            return n < 0 ? 0 : (r.splice(n, 1), s(t1, r), 1);
                                        }
                                        function u(t1, e1, r) {
                                            for(var n = 0; n < t1.length && t1[n][0] <= e1; ++n){
                                                var i = r(t1[n]);
                                                if (i) return i;
                                            }
                                        }
                                        function f(t1, e1, r) {
                                            for(var n = t1.length - 1; n >= 0 && t1[n][1] >= e1; --n){
                                                var i = r(t1[n]);
                                                if (i) return i;
                                            }
                                        }
                                        function h(t1, e1) {
                                            for(var r = 0; r < t1.length; ++r){
                                                var n = e1(t1[r]);
                                                if (n) return n;
                                            }
                                        }
                                        function p(t1, e1) {
                                            return t1 - e1;
                                        }
                                        function d(t1, e1) {
                                            var r = t1[0] - e1[0];
                                            return r || t1[1] - e1[1];
                                        }
                                        function m(t1, e1) {
                                            var r = t1[1] - e1[1];
                                            return r || t1[0] - e1[0];
                                        }
                                        function g(t1) {
                                            if (0 === t1.length) return null;
                                            for(var e1 = [], r = 0; r < t1.length; ++r)e1.push(t1[r][0], t1[r][1]);
                                            e1.sort(p);
                                            var n = e1[e1.length >> 1], a = [], o = [], s = [];
                                            for(r = 0; r < t1.length; ++r){
                                                var l = t1[r];
                                                l[1] < n ? a.push(l) : n < l[0] ? o.push(l) : s.push(l);
                                            }
                                            var c = s, u = s.slice();
                                            return c.sort(d), u.sort(m), new i(n, g(a), g(o), c, u);
                                        }
                                        function v(t1) {
                                            this.root = t1;
                                        }
                                        a.intervals = function(t1) {
                                            return t1.push.apply(t1, this.leftPoints), this.left && this.left.intervals(t1), this.right && this.right.intervals(t1), t1;
                                        }, a.insert = function(t1) {
                                            var e1 = this.count - this.leftPoints.length;
                                            if (this.count += 1, t1[1] < this.mid) this.left ? 4 * (this.left.count + 1) > 3 * (e1 + 1) ? l(this, t1) : this.left.insert(t1) : this.left = g([
                                                t1
                                            ]);
                                            else if (t1[0] > this.mid) this.right ? 4 * (this.right.count + 1) > 3 * (e1 + 1) ? l(this, t1) : this.right.insert(t1) : this.right = g([
                                                t1
                                            ]);
                                            else {
                                                var r = n.ge(this.leftPoints, t1, d), i = n.ge(this.rightPoints, t1, m);
                                                this.leftPoints.splice(r, 0, t1), this.rightPoints.splice(i, 0, t1);
                                            }
                                        }, a.remove = function(t1) {
                                            var e1 = this.count - this.leftPoints;
                                            if (t1[1] < this.mid) return this.left ? 4 * (this.right ? this.right.count : 0) > 3 * (e1 - 1) ? c(this, t1) : 2 === (s = this.left.remove(t1)) ? (this.left = null, this.count -= 1, 1) : (1 === s && (this.count -= 1), s) : 0;
                                            if (t1[0] > this.mid) return this.right ? 4 * (this.left ? this.left.count : 0) > 3 * (e1 - 1) ? c(this, t1) : 2 === (s = this.right.remove(t1)) ? (this.right = null, this.count -= 1, 1) : (1 === s && (this.count -= 1), s) : 0;
                                            if (1 === this.count) return this.leftPoints[0] === t1 ? 2 : 0;
                                            if (1 === this.leftPoints.length && this.leftPoints[0] === t1) {
                                                if (this.left && this.right) {
                                                    for(var r = this, i = this.left; i.right;)r = i, i = i.right;
                                                    if (r === this) i.right = this.right;
                                                    else {
                                                        var a = this.left, s = this.right;
                                                        r.count -= i.count, r.right = i.left, i.left = a, i.right = s;
                                                    }
                                                    o(this, i), this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
                                                } else this.left ? o(this, this.left) : o(this, this.right);
                                                return 1;
                                            }
                                            for(a = n.ge(this.leftPoints, t1, d); a < this.leftPoints.length && this.leftPoints[a][0] === t1[0]; ++a)if (this.leftPoints[a] === t1) {
                                                this.count -= 1, this.leftPoints.splice(a, 1);
                                                for(s = n.ge(this.rightPoints, t1, m); s < this.rightPoints.length && this.rightPoints[s][1] === t1[1]; ++s)if (this.rightPoints[s] === t1) return this.rightPoints.splice(s, 1), 1;
                                            }
                                            return 0;
                                        }, a.queryPoint = function(t1, e1) {
                                            if (t1 < this.mid) {
                                                if (this.left) {
                                                    if (r = this.left.queryPoint(t1, e1)) return r;
                                                }
                                                return u(this.leftPoints, t1, e1);
                                            }
                                            if (t1 > this.mid) {
                                                var r;
                                                if (this.right) {
                                                    if (r = this.right.queryPoint(t1, e1)) return r;
                                                }
                                                return f(this.rightPoints, t1, e1);
                                            }
                                            return h(this.leftPoints, e1);
                                        }, a.queryInterval = function(t1, e1, r) {
                                            var n;
                                            if (t1 < this.mid && this.left && (n = this.left.queryInterval(t1, e1, r))) return n;
                                            if (e1 > this.mid && this.right && (n = this.right.queryInterval(t1, e1, r))) return n;
                                            return e1 < this.mid ? u(this.leftPoints, e1, r) : t1 > this.mid ? f(this.rightPoints, t1, r) : h(this.leftPoints, r);
                                        };
                                        var y = v.prototype;
                                        y.insert = function(t1) {
                                            this.root ? this.root.insert(t1) : this.root = new i(t1[0], null, null, [
                                                t1
                                            ], [
                                                t1
                                            ]);
                                        }, y.remove = function(t1) {
                                            if (this.root) {
                                                var e1 = this.root.remove(t1);
                                                return 2 === e1 && (this.root = null), 0 !== e1;
                                            }
                                            return !1;
                                        }, y.queryPoint = function(t1, e1) {
                                            if (this.root) return this.root.queryPoint(t1, e1);
                                        }, y.queryInterval = function(t1, e1, r) {
                                            if (t1 <= e1 && this.root) return this.root.queryInterval(t1, e1, r);
                                        }, Object.defineProperty(y, "count", {
                                            get: function() {
                                                return this.root ? this.root.count : 0;
                                            }
                                        }), Object.defineProperty(y, "intervals", {
                                            get: function() {
                                                return this.root ? this.root.intervals([]) : [];
                                            }
                                        });
                                    },
                                    {
                                        "binary-search-bounds": 31
                                    }
                                ],
                                235: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            for(var e1 = new Array(t1), r = 0; r < t1; ++r)e1[r] = r;
                                            return e1;
                                        };
                                    },
                                    {}
                                ],
                                236: [
                                    function(t1, e1, r) {
                                        e1.exports = !0;
                                    },
                                    {}
                                ],
                                237: [
                                    function(t1, e1, r) {
                                        function n(t1) {
                                            return !!t1.constructor && "function" == typeof t1.constructor.isBuffer && t1.constructor.isBuffer(t1);
                                        }
                                        /*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ e1.exports = function(t1) {
                                            return null != t1 && (n(t1) || function(t1) {
                                                return "function" == typeof t1.readFloatLE && "function" == typeof t1.slice && n(t1.slice(0, 0));
                                            }(t1) || !!t1._isBuffer);
                                        };
                                    },
                                    {}
                                ],
                                238: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = a, e1.exports.isMobile = a, e1.exports.default = a;
                                        var n = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i, i = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;
                                        function a(t1) {
                                            t1 || (t1 = {});
                                            var e1 = t1.ua;
                                            if (e1 || "undefined" == typeof navigator || (e1 = navigator.userAgent), e1 && e1.headers && "string" == typeof e1.headers["user-agent"] && (e1 = e1.headers["user-agent"]), "string" != typeof e1) return !1;
                                            var r = t1.tablet ? i.test(e1) : n.test(e1);
                                            return !r && t1.tablet && t1.featureDetect && navigator && navigator.maxTouchPoints > 1 && -1 !== e1.indexOf("Macintosh") && -1 !== e1.indexOf("Safari") && (r = !0), r;
                                        }
                                    },
                                    {}
                                ],
                                239: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            for(var e1, r = t1.length, n = 0; n < r; n++)if (((e1 = t1.charCodeAt(n)) < 9 || e1 > 13) && 32 !== e1 && 133 !== e1 && 160 !== e1 && 5760 !== e1 && 6158 !== e1 && (e1 < 8192 || e1 > 8205) && 8232 !== e1 && 8233 !== e1 && 8239 !== e1 && 8287 !== e1 && 8288 !== e1 && 12288 !== e1 && 65279 !== e1) return !1;
                                            return !0;
                                        };
                                    },
                                    {}
                                ],
                                240: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r) {
                                            return t1 * (1 - r) + e1 * r;
                                        };
                                    },
                                    {}
                                ],
                                241: [
                                    function(t1, e1, r) {
                                        var n = t1("./normalize"), i = t1("gl-mat4/create"), a = t1("gl-mat4/clone"), o = t1("gl-mat4/determinant"), s = t1("gl-mat4/invert"), l = t1("gl-mat4/transpose"), c = {
                                            length: t1("gl-vec3/length"),
                                            normalize: t1("gl-vec3/normalize"),
                                            dot: t1("gl-vec3/dot"),
                                            cross: t1("gl-vec3/cross")
                                        }, u = i(), f = i(), h = [
                                            0,
                                            0,
                                            0,
                                            0
                                        ], p = [
                                            [
                                                0,
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0,
                                                0
                                            ]
                                        ], d = [
                                            0,
                                            0,
                                            0
                                        ];
                                        function m(t1, e1, r, n, i) {
                                            t1[0] = e1[0] * n + r[0] * i, t1[1] = e1[1] * n + r[1] * i, t1[2] = e1[2] * n + r[2] * i;
                                        }
                                        e1.exports = function(t1, e1, r, i, g, v) {
                                            if (e1 || (e1 = [
                                                0,
                                                0,
                                                0
                                            ]), r || (r = [
                                                0,
                                                0,
                                                0
                                            ]), i || (i = [
                                                0,
                                                0,
                                                0
                                            ]), g || (g = [
                                                0,
                                                0,
                                                0,
                                                1
                                            ]), v || (v = [
                                                0,
                                                0,
                                                0,
                                                1
                                            ]), !n(u, t1)) return !1;
                                            if (a(f, u), f[3] = 0, f[7] = 0, f[11] = 0, f[15] = 1, Math.abs(o(f) < 1e-8)) return !1;
                                            var y, x, b, _, w, T, k, A = u[3], M = u[7], S = u[11], E = u[12], L = u[13], C = u[14], P = u[15];
                                            if (0 !== A || 0 !== M || 0 !== S) {
                                                if (h[0] = A, h[1] = M, h[2] = S, h[3] = P, !s(f, f)) return !1;
                                                l(f, f), y = g, b = f, _ = (x = h)[0], w = x[1], T = x[2], k = x[3], y[0] = b[0] * _ + b[4] * w + b[8] * T + b[12] * k, y[1] = b[1] * _ + b[5] * w + b[9] * T + b[13] * k, y[2] = b[2] * _ + b[6] * w + b[10] * T + b[14] * k, y[3] = b[3] * _ + b[7] * w + b[11] * T + b[15] * k;
                                            } else g[0] = g[1] = g[2] = 0, g[3] = 1;
                                            if (e1[0] = E, e1[1] = L, e1[2] = C, function(t1, e1) {
                                                t1[0][0] = e1[0], t1[0][1] = e1[1], t1[0][2] = e1[2], t1[1][0] = e1[4], t1[1][1] = e1[5], t1[1][2] = e1[6], t1[2][0] = e1[8], t1[2][1] = e1[9], t1[2][2] = e1[10];
                                            }(p, u), r[0] = c.length(p[0]), c.normalize(p[0], p[0]), i[0] = c.dot(p[0], p[1]), m(p[1], p[1], p[0], 1, -i[0]), r[1] = c.length(p[1]), c.normalize(p[1], p[1]), i[0] /= r[1], i[1] = c.dot(p[0], p[2]), m(p[2], p[2], p[0], 1, -i[1]), i[2] = c.dot(p[1], p[2]), m(p[2], p[2], p[1], 1, -i[2]), r[2] = c.length(p[2]), c.normalize(p[2], p[2]), i[1] /= r[2], i[2] /= r[2], c.cross(d, p[1], p[2]), c.dot(p[0], d) < 0) for(var I = 0; I < 3; I++)r[I] *= -1, p[I][0] *= -1, p[I][1] *= -1, p[I][2] *= -1;
                                            return v[0] = .5 * Math.sqrt(Math.max(1 + p[0][0] - p[1][1] - p[2][2], 0)), v[1] = .5 * Math.sqrt(Math.max(1 - p[0][0] + p[1][1] - p[2][2], 0)), v[2] = .5 * Math.sqrt(Math.max(1 - p[0][0] - p[1][1] + p[2][2], 0)), v[3] = .5 * Math.sqrt(Math.max(1 + p[0][0] + p[1][1] + p[2][2], 0)), p[2][1] > p[1][2] && (v[0] = -v[0]), p[0][2] > p[2][0] && (v[1] = -v[1]), p[1][0] > p[0][1] && (v[2] = -v[2]), !0;
                                        };
                                    },
                                    {
                                        "./normalize": 242,
                                        "gl-mat4/clone": 92,
                                        "gl-mat4/create": 93,
                                        "gl-mat4/determinant": 94,
                                        "gl-mat4/invert": 98,
                                        "gl-mat4/transpose": 109,
                                        "gl-vec3/cross": 157,
                                        "gl-vec3/dot": 162,
                                        "gl-vec3/length": 172,
                                        "gl-vec3/normalize": 179
                                    }
                                ],
                                242: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = e1[15];
                                            if (0 === r) return !1;
                                            for(var n = 1 / r, i = 0; i < 16; i++)t1[i] = e1[i] * n;
                                            return !0;
                                        };
                                    },
                                    {}
                                ],
                                243: [
                                    function(t1, e1, r) {
                                        var n = t1("gl-vec3/lerp"), i = t1("mat4-recompose"), a = t1("mat4-decompose"), o = t1("gl-mat4/determinant"), s = t1("quat-slerp"), l = f(), c = f(), u = f();
                                        function f() {
                                            return {
                                                translate: h(),
                                                scale: h(1),
                                                skew: h(),
                                                perspective: [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ],
                                                quaternion: [
                                                    0,
                                                    0,
                                                    0,
                                                    1
                                                ]
                                            };
                                        }
                                        function h(t1) {
                                            return [
                                                t1 || 0,
                                                t1 || 0,
                                                t1 || 0
                                            ];
                                        }
                                        e1.exports = function(t1, e1, r, f) {
                                            if (0 === o(e1) || 0 === o(r)) return !1;
                                            var h = a(e1, l.translate, l.scale, l.skew, l.perspective, l.quaternion), p = a(r, c.translate, c.scale, c.skew, c.perspective, c.quaternion);
                                            return !(!h || !p) && (n(u.translate, l.translate, c.translate, f), n(u.skew, l.skew, c.skew, f), n(u.scale, l.scale, c.scale, f), n(u.perspective, l.perspective, c.perspective, f), s(u.quaternion, l.quaternion, c.quaternion, f), i(t1, u.translate, u.scale, u.skew, u.perspective, u.quaternion), !0);
                                        };
                                    },
                                    {
                                        "gl-mat4/determinant": 94,
                                        "gl-vec3/lerp": 173,
                                        "mat4-decompose": 241,
                                        "mat4-recompose": 244,
                                        "quat-slerp": 271
                                    }
                                ],
                                244: [
                                    function(t1, e1, r) {
                                        var n = {
                                            identity: t1("gl-mat4/identity"),
                                            translate: t1("gl-mat4/translate"),
                                            multiply: t1("gl-mat4/multiply"),
                                            create: t1("gl-mat4/create"),
                                            scale: t1("gl-mat4/scale"),
                                            fromRotationTranslation: t1("gl-mat4/fromRotationTranslation")
                                        }, i = (n.create(), n.create());
                                        e1.exports = function(t1, e1, r, a, o, s) {
                                            return n.identity(t1), n.fromRotationTranslation(t1, s, e1), t1[3] = o[0], t1[7] = o[1], t1[11] = o[2], t1[15] = o[3], n.identity(i), 0 !== a[2] && (i[9] = a[2], n.multiply(t1, t1, i)), 0 !== a[1] && (i[9] = 0, i[8] = a[1], n.multiply(t1, t1, i)), 0 !== a[0] && (i[8] = 0, i[4] = a[0], n.multiply(t1, t1, i)), n.scale(t1, t1, r), t1;
                                        };
                                    },
                                    {
                                        "gl-mat4/create": 93,
                                        "gl-mat4/fromRotationTranslation": 96,
                                        "gl-mat4/identity": 97,
                                        "gl-mat4/multiply": 100,
                                        "gl-mat4/scale": 107,
                                        "gl-mat4/translate": 108
                                    }
                                ],
                                245: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("binary-search-bounds"), i = t1("mat4-interpolate"), a = t1("gl-mat4/invert"), o = t1("gl-mat4/rotateX"), s = t1("gl-mat4/rotateY"), l = t1("gl-mat4/rotateZ"), c = t1("gl-mat4/lookAt"), u = t1("gl-mat4/translate"), f = (t1("gl-mat4/scale"), t1("gl-vec3/normalize")), h = [
                                            0,
                                            0,
                                            0
                                        ];
                                        function p(t1) {
                                            this._components = t1.slice(), this._time = [
                                                0
                                            ], this.prevMatrix = t1.slice(), this.nextMatrix = t1.slice(), this.computedMatrix = t1.slice(), this.computedInverse = t1.slice(), this.computedEye = [
                                                0,
                                                0,
                                                0
                                            ], this.computedUp = [
                                                0,
                                                0,
                                                0
                                            ], this.computedCenter = [
                                                0,
                                                0,
                                                0
                                            ], this.computedRadius = [
                                                0
                                            ], this._limits = [
                                                -1 / 0,
                                                1 / 0
                                            ];
                                        }
                                        e1.exports = function(t1) {
                                            return new p((t1 = t1 || {}).matrix || [
                                                1,
                                                0,
                                                0,
                                                0,
                                                0,
                                                1,
                                                0,
                                                0,
                                                0,
                                                0,
                                                1,
                                                0,
                                                0,
                                                0,
                                                0,
                                                1
                                            ]);
                                        };
                                        var d = p.prototype;
                                        d.recalcMatrix = function(t1) {
                                            var e1 = this._time, r = n.le(e1, t1), o = this.computedMatrix;
                                            if (!(r < 0)) {
                                                var s = this._components;
                                                if (r === e1.length - 1) for(var l = 16 * r, c = 0; c < 16; ++c)o[c] = s[l++];
                                                else {
                                                    var u = e1[r + 1] - e1[r], h = (l = 16 * r, this.prevMatrix), p = !0;
                                                    for(c = 0; c < 16; ++c)h[c] = s[l++];
                                                    var d = this.nextMatrix;
                                                    for(c = 0; c < 16; ++c)d[c] = s[l++], p = p && h[c] === d[c];
                                                    if (u < 1e-6 || p) for(c = 0; c < 16; ++c)o[c] = h[c];
                                                    else i(o, h, d, (t1 - e1[r]) / u);
                                                }
                                                var m = this.computedUp;
                                                m[0] = o[1], m[1] = o[5], m[2] = o[9], f(m, m);
                                                var g = this.computedInverse;
                                                a(g, o);
                                                var v = this.computedEye, y = g[15];
                                                v[0] = g[12] / y, v[1] = g[13] / y, v[2] = g[14] / y;
                                                var x = this.computedCenter, b = Math.exp(this.computedRadius[0]);
                                                for(c = 0; c < 3; ++c)x[c] = v[c] - o[2 + 4 * c] * b;
                                            }
                                        }, d.idle = function(t1) {
                                            if (!(t1 < this.lastT())) {
                                                for(var e1 = this._components, r = e1.length - 16, n = 0; n < 16; ++n)e1.push(e1[r++]);
                                                this._time.push(t1);
                                            }
                                        }, d.flush = function(t1) {
                                            var e1 = n.gt(this._time, t1) - 2;
                                            e1 < 0 || (this._time.splice(0, e1), this._components.splice(0, 16 * e1));
                                        }, d.lastT = function() {
                                            return this._time[this._time.length - 1];
                                        }, d.lookAt = function(t1, e1, r, n) {
                                            this.recalcMatrix(t1), e1 = e1 || this.computedEye, r = r || h, n = n || this.computedUp, this.setMatrix(t1, c(this.computedMatrix, e1, r, n));
                                            for(var i = 0, a = 0; a < 3; ++a)i += Math.pow(r[a] - e1[a], 2);
                                            i = Math.log(Math.sqrt(i)), this.computedRadius[0] = i;
                                        }, d.rotate = function(t1, e1, r, n) {
                                            this.recalcMatrix(t1);
                                            var i = this.computedInverse;
                                            e1 && s(i, i, e1), r && o(i, i, r), n && l(i, i, n), this.setMatrix(t1, a(this.computedMatrix, i));
                                        };
                                        var m = [
                                            0,
                                            0,
                                            0
                                        ];
                                        d.pan = function(t1, e1, r, n) {
                                            m[0] = -(e1 || 0), m[1] = -(r || 0), m[2] = -(n || 0), this.recalcMatrix(t1);
                                            var i = this.computedInverse;
                                            u(i, i, m), this.setMatrix(t1, a(i, i));
                                        }, d.translate = function(t1, e1, r, n) {
                                            m[0] = e1 || 0, m[1] = r || 0, m[2] = n || 0, this.recalcMatrix(t1);
                                            var i = this.computedMatrix;
                                            u(i, i, m), this.setMatrix(t1, i);
                                        }, d.setMatrix = function(t1, e1) {
                                            if (!(t1 < this.lastT())) {
                                                this._time.push(t1);
                                                for(var r = 0; r < 16; ++r)this._components.push(e1[r]);
                                            }
                                        }, d.setDistance = function(t1, e1) {
                                            this.computedRadius[0] = e1;
                                        }, d.setDistanceLimits = function(t1, e1) {
                                            var r = this._limits;
                                            r[0] = t1, r[1] = e1;
                                        }, d.getDistanceLimits = function(t1) {
                                            var e1 = this._limits;
                                            return t1 ? (t1[0] = e1[0], t1[1] = e1[1], t1) : e1;
                                        };
                                    },
                                    {
                                        "binary-search-bounds": 31,
                                        "gl-mat4/invert": 98,
                                        "gl-mat4/lookAt": 99,
                                        "gl-mat4/rotateX": 104,
                                        "gl-mat4/rotateY": 105,
                                        "gl-mat4/rotateZ": 106,
                                        "gl-mat4/scale": 107,
                                        "gl-mat4/translate": 108,
                                        "gl-vec3/normalize": 179,
                                        "mat4-interpolate": 243
                                    }
                                ],
                                246: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = t1.length;
                                            if (e1 < 3) {
                                                for(var r = new Array(e1), i = 0; i < e1; ++i)r[i] = i;
                                                return 2 === e1 && t1[0][0] === t1[1][0] && t1[0][1] === t1[1][1] ? [
                                                    0
                                                ] : r;
                                            }
                                            var a = new Array(e1);
                                            for(i = 0; i < e1; ++i)a[i] = i;
                                            a.sort(function(e1, r) {
                                                var n = t1[e1][0] - t1[r][0];
                                                return n || t1[e1][1] - t1[r][1];
                                            });
                                            var o = [
                                                a[0],
                                                a[1]
                                            ], s = [
                                                a[0],
                                                a[1]
                                            ];
                                            for(i = 2; i < e1; ++i){
                                                for(var l = a[i], c = t1[l], u = o.length; u > 1 && n(t1[o[u - 2]], t1[o[u - 1]], c) <= 0;)u -= 1, o.pop();
                                                for(o.push(l), u = s.length; u > 1 && n(t1[s[u - 2]], t1[s[u - 1]], c) >= 0;)u -= 1, s.pop();
                                                s.push(l);
                                            }
                                            r = new Array(s.length + o.length - 2);
                                            for(var f = 0, h = (i = 0, o.length); i < h; ++i)r[f++] = o[i];
                                            for(var p = s.length - 2; p > 0; --p)r[f++] = s[p];
                                            return r;
                                        };
                                        var n = t1("robust-orientation")[3];
                                    },
                                    {
                                        "robust-orientation": 284
                                    }
                                ],
                                247: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            e1 || (e1 = t1, t1 = window);
                                            var r = 0, i = 0, a = 0, o = {
                                                shift: !1,
                                                alt: !1,
                                                control: !1,
                                                meta: !1
                                            }, s = !1;
                                            function l(t1) {
                                                var e1 = !1;
                                                return "altKey" in t1 && (e1 = e1 || t1.altKey !== o.alt, o.alt = !!t1.altKey), "shiftKey" in t1 && (e1 = e1 || t1.shiftKey !== o.shift, o.shift = !!t1.shiftKey), "ctrlKey" in t1 && (e1 = e1 || t1.ctrlKey !== o.control, o.control = !!t1.ctrlKey), "metaKey" in t1 && (e1 = e1 || t1.metaKey !== o.meta, o.meta = !!t1.metaKey), e1;
                                            }
                                            function c(t1, s) {
                                                var c = n.x(s), u = n.y(s);
                                                "buttons" in s && (t1 = 0 | s.buttons), (t1 !== r || c !== i || u !== a || l(s)) && (r = 0 | t1, i = c || 0, a = u || 0, e1 && e1(r, i, a, o));
                                            }
                                            function u(t1) {
                                                c(0, t1);
                                            }
                                            function f() {
                                                (r || i || a || o.shift || o.alt || o.meta || o.control) && (i = a = 0, r = 0, o.shift = o.alt = o.control = o.meta = !1, e1 && e1(0, 0, 0, o));
                                            }
                                            function h(t1) {
                                                l(t1) && e1 && e1(r, i, a, o);
                                            }
                                            function p(t1) {
                                                0 === n.buttons(t1) ? c(0, t1) : c(r, t1);
                                            }
                                            function d(t1) {
                                                c(r | n.buttons(t1), t1);
                                            }
                                            function m(t1) {
                                                c(r & ~n.buttons(t1), t1);
                                            }
                                            function g() {
                                                s || (s = !0, t1.addEventListener("mousemove", p), t1.addEventListener("mousedown", d), t1.addEventListener("mouseup", m), t1.addEventListener("mouseleave", u), t1.addEventListener("mouseenter", u), t1.addEventListener("mouseout", u), t1.addEventListener("mouseover", u), t1.addEventListener("blur", f), t1.addEventListener("keyup", h), t1.addEventListener("keydown", h), t1.addEventListener("keypress", h), t1 !== window && (window.addEventListener("blur", f), window.addEventListener("keyup", h), window.addEventListener("keydown", h), window.addEventListener("keypress", h)));
                                            }
                                            g();
                                            var v = {
                                                element: t1
                                            };
                                            return Object.defineProperties(v, {
                                                enabled: {
                                                    get: function() {
                                                        return s;
                                                    },
                                                    set: function(e1) {
                                                        e1 ? g() : function() {
                                                            if (!s) return;
                                                            s = !1, t1.removeEventListener("mousemove", p), t1.removeEventListener("mousedown", d), t1.removeEventListener("mouseup", m), t1.removeEventListener("mouseleave", u), t1.removeEventListener("mouseenter", u), t1.removeEventListener("mouseout", u), t1.removeEventListener("mouseover", u), t1.removeEventListener("blur", f), t1.removeEventListener("keyup", h), t1.removeEventListener("keydown", h), t1.removeEventListener("keypress", h), t1 !== window && (window.removeEventListener("blur", f), window.removeEventListener("keyup", h), window.removeEventListener("keydown", h), window.removeEventListener("keypress", h));
                                                        }();
                                                    },
                                                    enumerable: !0
                                                },
                                                buttons: {
                                                    get: function() {
                                                        return r;
                                                    },
                                                    enumerable: !0
                                                },
                                                x: {
                                                    get: function() {
                                                        return i;
                                                    },
                                                    enumerable: !0
                                                },
                                                y: {
                                                    get: function() {
                                                        return a;
                                                    },
                                                    enumerable: !0
                                                },
                                                mods: {
                                                    get: function() {
                                                        return o;
                                                    },
                                                    enumerable: !0
                                                }
                                            }), v;
                                        };
                                        var n = t1("mouse-event");
                                    },
                                    {
                                        "mouse-event": 249
                                    }
                                ],
                                248: [
                                    function(t1, e1, r) {
                                        var n = {
                                            left: 0,
                                            top: 0
                                        };
                                        e1.exports = function(t1, e1, r) {
                                            e1 = e1 || t1.currentTarget || t1.srcElement, Array.isArray(r) || (r = [
                                                0,
                                                0
                                            ]);
                                            var i = t1.clientX || 0, a = t1.clientY || 0, o = (s = e1, s === window || s === document || s === document.body ? n : s.getBoundingClientRect());
                                            var s;
                                            return r[0] = i - o.left, r[1] = a - o.top, r;
                                        };
                                    },
                                    {}
                                ],
                                249: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        function n(t1) {
                                            return t1.target || t1.srcElement || window;
                                        }
                                        r.buttons = function(t1) {
                                            if ("object" == typeof t1) {
                                                if ("buttons" in t1) return t1.buttons;
                                                if ("which" in t1) {
                                                    if (2 === (e1 = t1.which)) return 4;
                                                    if (3 === e1) return 2;
                                                    if (e1 > 0) return 1 << e1 - 1;
                                                } else if ("button" in t1) {
                                                    var e1;
                                                    if (1 === (e1 = t1.button)) return 4;
                                                    if (2 === e1) return 2;
                                                    if (e1 >= 0) return 1 << e1;
                                                }
                                            }
                                            return 0;
                                        }, r.element = n, r.x = function(t1) {
                                            if ("object" == typeof t1) {
                                                if ("offsetX" in t1) return t1.offsetX;
                                                var e1 = n(t1).getBoundingClientRect();
                                                return t1.clientX - e1.left;
                                            }
                                            return 0;
                                        }, r.y = function(t1) {
                                            if ("object" == typeof t1) {
                                                if ("offsetY" in t1) return t1.offsetY;
                                                var e1 = n(t1).getBoundingClientRect();
                                                return t1.clientY - e1.top;
                                            }
                                            return 0;
                                        };
                                    },
                                    {}
                                ],
                                250: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("to-px");
                                        e1.exports = function(t1, e1, r) {
                                            "function" == typeof t1 && (r = !!e1, e1 = t1, t1 = window);
                                            var i = n("ex", t1), a = function(t1) {
                                                r && t1.preventDefault();
                                                var n = t1.deltaX || 0, a = t1.deltaY || 0, o = t1.deltaZ || 0, s = 1;
                                                switch(t1.deltaMode){
                                                    case 1:
                                                        s = i;
                                                        break;
                                                    case 2:
                                                        s = window.innerHeight;
                                                }
                                                if (a *= s, o *= s, (n *= s) || a || o) return e1(n, a, o, t1);
                                            };
                                            return t1.addEventListener("wheel", a), a;
                                        };
                                    },
                                    {
                                        "to-px": 304
                                    }
                                ],
                                251: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("typedarray-pool");
                                        e1.exports = function(t1) {
                                            function e1(t1) {
                                                throw new Error("ndarray-extract-contour: " + t1);
                                            }
                                            "object" != typeof t1 && e1("Must specify arguments");
                                            var r = t1.order;
                                            Array.isArray(r) || e1("Must specify order");
                                            var a = t1.arrayArguments || 1;
                                            a < 1 && e1("Must have at least one array argument");
                                            var o = t1.scalarArguments || 0;
                                            o < 0 && e1("Scalar arg count must be > 0");
                                            "function" != typeof t1.vertex && e1("Must specify vertex creation function");
                                            "function" != typeof t1.cell && e1("Must specify cell creation function");
                                            "function" != typeof t1.phase && e1("Must specify phase function");
                                            for(var s = t1.getters || [], l = new Array(a), c = 0; c < a; ++c)s.indexOf(c) >= 0 ? l[c] = !0 : l[c] = !1;
                                            return function(t1, e1, r, a, o, s) {
                                                var l = [
                                                    s,
                                                    o
                                                ].join(",");
                                                return (0, i[l])(t1, e1, r, n.mallocUint32, n.freeUint32);
                                            }(t1.vertex, t1.cell, t1.phase, 0, r, l);
                                        };
                                        var i = {
                                            "false,0,1": function(t1, e1, r, n, i) {
                                                return function(a, o, s, l) {
                                                    var c, u = 0 | a.shape[0], f = 0 | a.shape[1], h = a.data, p = 0 | a.offset, d = 0 | a.stride[0], m = 0 | a.stride[1], g = p, v = 0 | -d, y = 0, x = 0 | -m, b = 0, _ = -d - m | 0, w = 0, T = 0 | d, k = m - d * u | 0, A = 0, M = 0, S = 0, E = 2 * u | 0, L = n(E), C = n(E), P = 0, I = 0, O = -1, z = -1, D = 0, R = 0 | -u, F = 0 | u, B = 0, N = -u - 1 | 0, j = u - 1 | 0, U = 0, V = 0, H = 0;
                                                    for(A = 0; A < u; ++A)L[P++] = r(h[g], o, s, l), g += T;
                                                    if (g += k, f > 0) {
                                                        if (M = 1, L[P++] = r(h[g], o, s, l), g += T, u > 0) for(A = 1, c = h[g], I = L[P] = r(c, o, s, l), D = L[P + O], B = L[P + R], U = L[P + N], I === D && I === B && I === U || (y = h[g + v], b = h[g + x], w = h[g + _], t1(A, M, c, y, b, w, I, D, B, U, o, s, l), V = C[P] = S++), P += 1, g += T, A = 2; A < u; ++A)c = h[g], I = L[P] = r(c, o, s, l), D = L[P + O], B = L[P + R], U = L[P + N], I === D && I === B && I === U || (y = h[g + v], b = h[g + x], w = h[g + _], t1(A, M, c, y, b, w, I, D, B, U, o, s, l), V = C[P] = S++, U !== D && e1(C[P + O], V, w, y, U, D, o, s, l)), P += 1, g += T;
                                                        for(g += k, P = 0, H = O, O = z, z = H, H = R, R = F, F = H, H = N, N = j, j = H, M = 2; M < f; ++M){
                                                            if (L[P++] = r(h[g], o, s, l), g += T, u > 0) for(A = 1, c = h[g], I = L[P] = r(c, o, s, l), D = L[P + O], B = L[P + R], U = L[P + N], I === D && I === B && I === U || (y = h[g + v], b = h[g + x], w = h[g + _], t1(A, M, c, y, b, w, I, D, B, U, o, s, l), V = C[P] = S++, U !== B && e1(C[P + R], V, b, w, B, U, o, s, l)), P += 1, g += T, A = 2; A < u; ++A)c = h[g], I = L[P] = r(c, o, s, l), D = L[P + O], B = L[P + R], U = L[P + N], I === D && I === B && I === U || (y = h[g + v], b = h[g + x], w = h[g + _], t1(A, M, c, y, b, w, I, D, B, U, o, s, l), V = C[P] = S++, U !== B && e1(C[P + R], V, b, w, B, U, o, s, l), U !== D && e1(C[P + O], V, w, y, U, D, o, s, l)), P += 1, g += T;
                                                            1 & M && (P = 0), H = O, O = z, z = H, H = R, R = F, F = H, H = N, N = j, j = H, g += k;
                                                        }
                                                    }
                                                    i(C), i(L);
                                                };
                                            },
                                            "false,1,0": function(t1, e1, r, n, i) {
                                                return function(a, o, s, l) {
                                                    var c, u = 0 | a.shape[0], f = 0 | a.shape[1], h = a.data, p = 0 | a.offset, d = 0 | a.stride[0], m = 0 | a.stride[1], g = p, v = 0 | -d, y = 0, x = 0 | -m, b = 0, _ = -d - m | 0, w = 0, T = 0 | m, k = d - m * f | 0, A = 0, M = 0, S = 0, E = 2 * f | 0, L = n(E), C = n(E), P = 0, I = 0, O = -1, z = -1, D = 0, R = 0 | -f, F = 0 | f, B = 0, N = -f - 1 | 0, j = f - 1 | 0, U = 0, V = 0, H = 0;
                                                    for(M = 0; M < f; ++M)L[P++] = r(h[g], o, s, l), g += T;
                                                    if (g += k, u > 0) {
                                                        if (A = 1, L[P++] = r(h[g], o, s, l), g += T, f > 0) for(M = 1, c = h[g], I = L[P] = r(c, o, s, l), B = L[P + R], D = L[P + O], U = L[P + N], I === B && I === D && I === U || (y = h[g + v], b = h[g + x], w = h[g + _], t1(A, M, c, y, b, w, I, B, D, U, o, s, l), V = C[P] = S++), P += 1, g += T, M = 2; M < f; ++M)c = h[g], I = L[P] = r(c, o, s, l), B = L[P + R], D = L[P + O], U = L[P + N], I === B && I === D && I === U || (y = h[g + v], b = h[g + x], w = h[g + _], t1(A, M, c, y, b, w, I, B, D, U, o, s, l), V = C[P] = S++, U !== D && e1(C[P + O], V, b, w, D, U, o, s, l)), P += 1, g += T;
                                                        for(g += k, P = 0, H = R, R = F, F = H, H = O, O = z, z = H, H = N, N = j, j = H, A = 2; A < u; ++A){
                                                            if (L[P++] = r(h[g], o, s, l), g += T, f > 0) for(M = 1, c = h[g], I = L[P] = r(c, o, s, l), B = L[P + R], D = L[P + O], U = L[P + N], I === B && I === D && I === U || (y = h[g + v], b = h[g + x], w = h[g + _], t1(A, M, c, y, b, w, I, B, D, U, o, s, l), V = C[P] = S++, U !== B && e1(C[P + R], V, w, y, U, B, o, s, l)), P += 1, g += T, M = 2; M < f; ++M)c = h[g], I = L[P] = r(c, o, s, l), B = L[P + R], D = L[P + O], U = L[P + N], I === B && I === D && I === U || (y = h[g + v], b = h[g + x], w = h[g + _], t1(A, M, c, y, b, w, I, B, D, U, o, s, l), V = C[P] = S++, U !== D && e1(C[P + O], V, b, w, D, U, o, s, l), U !== B && e1(C[P + R], V, w, y, U, B, o, s, l)), P += 1, g += T;
                                                            1 & A && (P = 0), H = R, R = F, F = H, H = O, O = z, z = H, H = N, N = j, j = H, g += k;
                                                        }
                                                    }
                                                    i(C), i(L);
                                                };
                                            }
                                        };
                                    },
                                    {
                                        "typedarray-pool": 308
                                    }
                                ],
                                252: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("dup"), i = {
                                            zero: function(t1, e1, r, n) {
                                                var i = t1[0];
                                                n |= 0;
                                                var a = 0, o = r[0];
                                                for(a = 0; a < i; ++a)e1[n] = 0, n += o;
                                            },
                                            fdTemplate1: function(t1, e1, r, n, i, a, o) {
                                                var s = t1[0], l = r[0], c = -1 * l, u = l;
                                                n |= 0, o |= 0;
                                                var f = 0, h = l, p = a[0];
                                                for(f = 0; f < s; ++f)i[o] = .5 * (e1[n + c] - e1[n + u]), n += h, o += p;
                                            },
                                            fdTemplate2: function(t1, e1, r, n, i, a, o, s, l, c) {
                                                var u = t1[0], f = t1[1], h = r[0], p = r[1], d = a[0], m = a[1], g = l[0], v = l[1], y = -1 * h, x = h, b = -1 * p, _ = p;
                                                n |= 0, o |= 0, c |= 0;
                                                var w = 0, T = 0, k = p, A = h - f * p, M = m, S = d - f * m, E = v, L = g - f * v;
                                                for(T = 0; T < u; ++T){
                                                    for(w = 0; w < f; ++w)i[o] = .5 * (e1[n + y] - e1[n + x]), s[c] = .5 * (e1[n + b] - e1[n + _]), n += k, o += M, c += E;
                                                    n += A, o += S, c += L;
                                                }
                                            }
                                        }, a = {
                                            cdiff: function(t1) {
                                                var e1 = {};
                                                return function(r, n, i) {
                                                    var a = r.dtype, o = r.order, s = n.dtype, l = n.order, c = i.dtype, u = i.order, f = [
                                                        a,
                                                        o.join(),
                                                        s,
                                                        l.join(),
                                                        c,
                                                        u.join()
                                                    ].join(), h = e1[f];
                                                    return h || (e1[f] = h = t1([
                                                        a,
                                                        o,
                                                        s,
                                                        l,
                                                        c,
                                                        u
                                                    ])), h(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset, i.data, i.stride, 0 | i.offset);
                                                };
                                            },
                                            zero: function(t1) {
                                                var e1 = {};
                                                return function(r) {
                                                    var n = r.dtype, i = r.order, a = [
                                                        n,
                                                        i.join()
                                                    ].join(), o = e1[a];
                                                    return o || (e1[a] = o = t1([
                                                        n,
                                                        i
                                                    ])), o(r.shape.slice(0), r.data, r.stride, 0 | r.offset);
                                                };
                                            },
                                            fdTemplate1: function(t1) {
                                                var e1 = {};
                                                return function(r, n) {
                                                    var i = r.dtype, a = r.order, o = n.dtype, s = n.order, l = [
                                                        i,
                                                        a.join(),
                                                        o,
                                                        s.join()
                                                    ].join(), c = e1[l];
                                                    return c || (e1[l] = c = t1([
                                                        i,
                                                        a,
                                                        o,
                                                        s
                                                    ])), c(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset);
                                                };
                                            },
                                            fdTemplate2: function(t1) {
                                                var e1 = {};
                                                return function(r, n, i) {
                                                    var a = r.dtype, o = r.order, s = n.dtype, l = n.order, c = i.dtype, u = i.order, f = [
                                                        a,
                                                        o.join(),
                                                        s,
                                                        l.join(),
                                                        c,
                                                        u.join()
                                                    ].join(), h = e1[f];
                                                    return h || (e1[f] = h = t1([
                                                        a,
                                                        o,
                                                        s,
                                                        l,
                                                        c,
                                                        u
                                                    ])), h(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset, i.data, i.stride, 0 | i.offset);
                                                };
                                            }
                                        };
                                        function o(t1) {
                                            return (0, a[t1.funcName])(s.bind(void 0, t1));
                                        }
                                        function s(t1) {
                                            return i[t1.funcName];
                                        }
                                        function l(t1) {
                                            return o({
                                                funcName: t1.funcName
                                            });
                                        }
                                        var c = {}, u = {}, f = l({
                                            funcName: "cdiff"
                                        }), h = l({
                                            funcName: "zero"
                                        });
                                        function p(t1) {
                                            return t1 in c ? c[t1] : c[t1] = l({
                                                funcName: "fdTemplate" + t1
                                            });
                                        }
                                        function d(t1, e1, r, n) {
                                            return function(t1, i) {
                                                var a = i.shape.slice();
                                                return a[0] > 2 && a[1] > 2 && n(i.pick(-1, -1).lo(1, 1).hi(a[0] - 2, a[1] - 2), t1.pick(-1, -1, 0).lo(1, 1).hi(a[0] - 2, a[1] - 2), t1.pick(-1, -1, 1).lo(1, 1).hi(a[0] - 2, a[1] - 2)), a[1] > 2 && (r(i.pick(0, -1).lo(1).hi(a[1] - 2), t1.pick(0, -1, 1).lo(1).hi(a[1] - 2)), e1(t1.pick(0, -1, 0).lo(1).hi(a[1] - 2))), a[1] > 2 && (r(i.pick(a[0] - 1, -1).lo(1).hi(a[1] - 2), t1.pick(a[0] - 1, -1, 1).lo(1).hi(a[1] - 2)), e1(t1.pick(a[0] - 1, -1, 0).lo(1).hi(a[1] - 2))), a[0] > 2 && (r(i.pick(-1, 0).lo(1).hi(a[0] - 2), t1.pick(-1, 0, 0).lo(1).hi(a[0] - 2)), e1(t1.pick(-1, 0, 1).lo(1).hi(a[0] - 2))), a[0] > 2 && (r(i.pick(-1, a[1] - 1).lo(1).hi(a[0] - 2), t1.pick(-1, a[1] - 1, 0).lo(1).hi(a[0] - 2)), e1(t1.pick(-1, a[1] - 1, 1).lo(1).hi(a[0] - 2))), t1.set(0, 0, 0, 0), t1.set(0, 0, 1, 0), t1.set(a[0] - 1, 0, 0, 0), t1.set(a[0] - 1, 0, 1, 0), t1.set(0, a[1] - 1, 0, 0), t1.set(0, a[1] - 1, 1, 0), t1.set(a[0] - 1, a[1] - 1, 0, 0), t1.set(a[0] - 1, a[1] - 1, 1, 0), t1;
                                            };
                                        }
                                        e1.exports = function(t1, e1, r) {
                                            return Array.isArray(r) || (r = n(e1.dimension, "string" == typeof r ? r : "clamp")), 0 === e1.size ? t1 : 0 === e1.dimension ? (t1.set(0), t1) : (function(t1) {
                                                var e1 = t1.join();
                                                if (a = u[e1]) return a;
                                                for(var r = t1.length, n = [
                                                    f,
                                                    h
                                                ], i = 1; i <= r; ++i)n.push(p(i));
                                                var a = d.apply(void 0, n);
                                                return u[e1] = a, a;
                                            })(r)(t1, e1);
                                        };
                                    },
                                    {
                                        dup: 65
                                    }
                                ],
                                253: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        function n(t1, e1) {
                                            var r = Math.floor(e1), n = e1 - r, i = 0 <= r && r < t1.shape[0], a = 0 <= r + 1 && r + 1 < t1.shape[0];
                                            return (1 - n) * (i ? +t1.get(r) : 0) + n * (a ? +t1.get(r + 1) : 0);
                                        }
                                        function i(t1, e1, r) {
                                            var n = Math.floor(e1), i = e1 - n, a = 0 <= n && n < t1.shape[0], o = 0 <= n + 1 && n + 1 < t1.shape[0], s = Math.floor(r), l = r - s, c = 0 <= s && s < t1.shape[1], u = 0 <= s + 1 && s + 1 < t1.shape[1], f = a && c ? t1.get(n, s) : 0, h = a && u ? t1.get(n, s + 1) : 0;
                                            return (1 - l) * ((1 - i) * f + i * (o && c ? t1.get(n + 1, s) : 0)) + l * ((1 - i) * h + i * (o && u ? t1.get(n + 1, s + 1) : 0));
                                        }
                                        function a(t1, e1, r, n) {
                                            var i = Math.floor(e1), a = e1 - i, o = 0 <= i && i < t1.shape[0], s = 0 <= i + 1 && i + 1 < t1.shape[0], l = Math.floor(r), c = r - l, u = 0 <= l && l < t1.shape[1], f = 0 <= l + 1 && l + 1 < t1.shape[1], h = Math.floor(n), p = n - h, d = 0 <= h && h < t1.shape[2], m = 0 <= h + 1 && h + 1 < t1.shape[2], g = o && u && d ? t1.get(i, l, h) : 0, v = o && f && d ? t1.get(i, l + 1, h) : 0, y = s && u && d ? t1.get(i + 1, l, h) : 0, x = s && f && d ? t1.get(i + 1, l + 1, h) : 0, b = o && u && m ? t1.get(i, l, h + 1) : 0, _ = o && f && m ? t1.get(i, l + 1, h + 1) : 0;
                                            return (1 - p) * ((1 - c) * ((1 - a) * g + a * y) + c * ((1 - a) * v + a * x)) + p * ((1 - c) * ((1 - a) * b + a * (s && u && m ? t1.get(i + 1, l, h + 1) : 0)) + c * ((1 - a) * _ + a * (s && f && m ? t1.get(i + 1, l + 1, h + 1) : 0)));
                                        }
                                        function o(t1) {
                                            var e1, r, n = 0 | t1.shape.length, i = new Array(n), a = new Array(n), o = new Array(n), s = new Array(n);
                                            for(e1 = 0; e1 < n; ++e1)r = +arguments[e1 + 1], i[e1] = Math.floor(r), a[e1] = r - i[e1], o[e1] = 0 <= i[e1] && i[e1] < t1.shape[e1], s[e1] = 0 <= i[e1] + 1 && i[e1] + 1 < t1.shape[e1];
                                            var l, c, u, f = 0;
                                            t: for(e1 = 0; e1 < 1 << n; ++e1){
                                                for(c = 1, u = t1.offset, l = 0; l < n; ++l)if (e1 & 1 << l) {
                                                    if (!s[l]) continue t;
                                                    c *= a[l], u += t1.stride[l] * (i[l] + 1);
                                                } else {
                                                    if (!o[l]) continue t;
                                                    c *= 1 - a[l], u += t1.stride[l] * i[l];
                                                }
                                                f += c * t1.data[u];
                                            }
                                            return f;
                                        }
                                        e1.exports = function(t1, e1, r, s) {
                                            switch(t1.shape.length){
                                                case 0:
                                                    return 0;
                                                case 1:
                                                    return n(t1, e1);
                                                case 2:
                                                    return i(t1, e1, r);
                                                case 3:
                                                    return a(t1, e1, r, s);
                                                default:
                                                    return o.apply(void 0, arguments);
                                            }
                                        }, e1.exports.d1 = n, e1.exports.d2 = i, e1.exports.d3 = a;
                                    },
                                    {}
                                ],
                                254: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = {
                                            "float64,2,1,0": function() {
                                                return function(t1, e1, r, n, i) {
                                                    var a = t1[0], o = t1[1], s = t1[2], l = r[0], c = r[1], u = r[2];
                                                    n |= 0;
                                                    var f = 0, h = 0, p = 0, d = u, m = c - s * u, g = l - o * c;
                                                    for(p = 0; p < a; ++p){
                                                        for(h = 0; h < o; ++h){
                                                            for(f = 0; f < s; ++f)e1[n] /= i, n += d;
                                                            n += m;
                                                        }
                                                        n += g;
                                                    }
                                                };
                                            },
                                            "uint8,2,0,1,float64,2,1,0": function() {
                                                return function(t1, e1, r, n, i, a, o, s) {
                                                    for(var l = t1[0], c = t1[1], u = t1[2], f = r[0], h = r[1], p = r[2], d = a[0], m = a[1], g = a[2], v = n |= 0, y = o |= 0, x = 0 | t1[0]; x > 0;){
                                                        x < 64 ? (l = x, x = 0) : (l = 64, x -= 64);
                                                        for(var b = 0 | t1[1]; b > 0;){
                                                            b < 64 ? (c = b, b = 0) : (c = 64, b -= 64), n = v + x * f + b * h, o = y + x * d + b * m;
                                                            var _ = 0, w = 0, T = 0, k = p, A = f - u * p, M = h - l * f, S = g, E = d - u * g, L = m - l * d;
                                                            for(T = 0; T < c; ++T){
                                                                for(w = 0; w < l; ++w){
                                                                    for(_ = 0; _ < u; ++_)e1[n] = i[o] * s, n += k, o += S;
                                                                    n += A, o += E;
                                                                }
                                                                n += M, o += L;
                                                            }
                                                        }
                                                    }
                                                };
                                            },
                                            "float32,1,0,float32,1,0": function() {
                                                return function(t1, e1, r, n, i, a, o) {
                                                    var s = t1[0], l = t1[1], c = r[0], u = r[1], f = a[0], h = a[1];
                                                    n |= 0, o |= 0;
                                                    var p = 0, d = 0, m = u, g = c - l * u, v = h, y = f - l * h;
                                                    for(d = 0; d < s; ++d){
                                                        for(p = 0; p < l; ++p)e1[n] = i[o], n += m, o += v;
                                                        n += g, o += y;
                                                    }
                                                };
                                            },
                                            "float32,1,0,float32,0,1": function() {
                                                return function(t1, e1, r, n, i, a, o) {
                                                    for(var s = t1[0], l = t1[1], c = r[0], u = r[1], f = a[0], h = a[1], p = n |= 0, d = o |= 0, m = 0 | t1[1]; m > 0;){
                                                        m < 64 ? (l = m, m = 0) : (l = 64, m -= 64);
                                                        for(var g = 0 | t1[0]; g > 0;){
                                                            g < 64 ? (s = g, g = 0) : (s = 64, g -= 64), n = p + m * u + g * c, o = d + m * h + g * f;
                                                            var v = 0, y = 0, x = u, b = c - l * u, _ = h, w = f - l * h;
                                                            for(y = 0; y < s; ++y){
                                                                for(v = 0; v < l; ++v)e1[n] = i[o], n += x, o += _;
                                                                n += b, o += w;
                                                            }
                                                        }
                                                    }
                                                };
                                            },
                                            "uint8,2,0,1,uint8,1,2,0": function() {
                                                return function(t1, e1, r, n, i, a, o) {
                                                    for(var s = t1[0], l = t1[1], c = t1[2], u = r[0], f = r[1], h = r[2], p = a[0], d = a[1], m = a[2], g = n |= 0, v = o |= 0, y = 0 | t1[2]; y > 0;){
                                                        y < 64 ? (c = y, y = 0) : (c = 64, y -= 64);
                                                        for(var x = 0 | t1[0]; x > 0;){
                                                            x < 64 ? (s = x, x = 0) : (s = 64, x -= 64);
                                                            for(var b = 0 | t1[1]; b > 0;){
                                                                b < 64 ? (l = b, b = 0) : (l = 64, b -= 64), n = g + y * h + x * u + b * f, o = v + y * m + x * p + b * d;
                                                                var _ = 0, w = 0, T = 0, k = h, A = u - c * h, M = f - s * u, S = m, E = p - c * m, L = d - s * p;
                                                                for(T = 0; T < l; ++T){
                                                                    for(w = 0; w < s; ++w){
                                                                        for(_ = 0; _ < c; ++_)e1[n] = i[o], n += k, o += S;
                                                                        n += A, o += E;
                                                                    }
                                                                    n += M, o += L;
                                                                }
                                                            }
                                                        }
                                                    }
                                                };
                                            },
                                            "uint8,2,0,1,array,2,0,1": function() {
                                                return function(t1, e1, r, n, i, a, o) {
                                                    var s = t1[0], l = t1[1], c = t1[2], u = r[0], f = r[1], h = r[2], p = a[0], d = a[1], m = a[2];
                                                    n |= 0, o |= 0;
                                                    var g = 0, v = 0, y = 0, x = h, b = u - c * h, _ = f - s * u, w = m, T = p - c * m, k = d - s * p;
                                                    for(y = 0; y < l; ++y){
                                                        for(v = 0; v < s; ++v){
                                                            for(g = 0; g < c; ++g)e1[n] = i[o], n += x, o += w;
                                                            n += b, o += T;
                                                        }
                                                        n += _, o += k;
                                                    }
                                                };
                                            }
                                        };
                                        var i = function(t1, e1) {
                                            var r = e1.join(",");
                                            return (0, n[r])();
                                        }, a = {
                                            mul: function(t1) {
                                                var e1 = {};
                                                return function(r, n, i) {
                                                    var a = r.dtype, o = r.order, s = n.dtype, l = n.order, c = i.dtype, u = i.order, f = [
                                                        a,
                                                        o.join(),
                                                        s,
                                                        l.join(),
                                                        c,
                                                        u.join()
                                                    ].join(), h = e1[f];
                                                    return h || (e1[f] = h = t1([
                                                        a,
                                                        o,
                                                        s,
                                                        l,
                                                        c,
                                                        u
                                                    ])), h(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset, i.data, i.stride, 0 | i.offset);
                                                };
                                            },
                                            muls: function(t1) {
                                                var e1 = {};
                                                return function(r, n, i) {
                                                    var a = r.dtype, o = r.order, s = n.dtype, l = n.order, c = [
                                                        a,
                                                        o.join(),
                                                        s,
                                                        l.join()
                                                    ].join(), u = e1[c];
                                                    return u || (e1[c] = u = t1([
                                                        a,
                                                        o,
                                                        s,
                                                        l
                                                    ])), u(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset, i);
                                                };
                                            },
                                            mulseq: function(t1) {
                                                var e1 = {};
                                                return function(r, n) {
                                                    var i = r.dtype, a = r.order, o = [
                                                        i,
                                                        a.join()
                                                    ].join(), s = e1[o];
                                                    return s || (e1[o] = s = t1([
                                                        i,
                                                        a
                                                    ])), s(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n);
                                                };
                                            },
                                            div: function(t1) {
                                                var e1 = {};
                                                return function(r, n, i) {
                                                    var a = r.dtype, o = r.order, s = n.dtype, l = n.order, c = i.dtype, u = i.order, f = [
                                                        a,
                                                        o.join(),
                                                        s,
                                                        l.join(),
                                                        c,
                                                        u.join()
                                                    ].join(), h = e1[f];
                                                    return h || (e1[f] = h = t1([
                                                        a,
                                                        o,
                                                        s,
                                                        l,
                                                        c,
                                                        u
                                                    ])), h(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset, i.data, i.stride, 0 | i.offset);
                                                };
                                            },
                                            divs: function(t1) {
                                                var e1 = {};
                                                return function(r, n, i) {
                                                    var a = r.dtype, o = r.order, s = n.dtype, l = n.order, c = [
                                                        a,
                                                        o.join(),
                                                        s,
                                                        l.join()
                                                    ].join(), u = e1[c];
                                                    return u || (e1[c] = u = t1([
                                                        a,
                                                        o,
                                                        s,
                                                        l
                                                    ])), u(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset, i);
                                                };
                                            },
                                            divseq: function(t1) {
                                                var e1 = {};
                                                return function(r, n) {
                                                    var i = r.dtype, a = r.order, o = [
                                                        i,
                                                        a.join()
                                                    ].join(), s = e1[o];
                                                    return s || (e1[o] = s = t1([
                                                        i,
                                                        a
                                                    ])), s(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n);
                                                };
                                            },
                                            assign: function(t1) {
                                                var e1 = {};
                                                return function(r, n) {
                                                    var i = r.dtype, a = r.order, o = n.dtype, s = n.order, l = [
                                                        i,
                                                        a.join(),
                                                        o,
                                                        s.join()
                                                    ].join(), c = e1[l];
                                                    return c || (e1[l] = c = t1([
                                                        i,
                                                        a,
                                                        o,
                                                        s
                                                    ])), c(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n.data, n.stride, 0 | n.offset);
                                                };
                                            }
                                        };
                                        function o(t1) {
                                            var e1;
                                            return e1 = {
                                                funcName: t1.funcName
                                            }, (0, a[e1.funcName])(i.bind(void 0, e1));
                                        }
                                        var s = {
                                            mul: "*",
                                            div: "/"
                                        };
                                        !function() {
                                            for(var t1 in s)r[t1] = o({
                                                funcName: t1
                                            }), r[t1 + "s"] = o({
                                                funcName: t1 + "s"
                                            }), r[t1 + "seq"] = o({
                                                funcName: t1 + "seq"
                                            });
                                        }(), r.assign = o({
                                            funcName: "assign"
                                        });
                                    },
                                    {}
                                ],
                                255: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("ndarray"), i = t1("./doConvert.js");
                                        e1.exports = function(t1, e1) {
                                            for(var r = [], a = t1, o = 1; Array.isArray(a);)r.push(a.length), o *= a.length, a = a[0];
                                            return 0 === r.length ? n() : (e1 || (e1 = n(new Float64Array(o), r)), i(e1, t1), e1);
                                        };
                                    },
                                    {
                                        "./doConvert.js": 256,
                                        ndarray: 259
                                    }
                                ],
                                256: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n, i = function() {
                                            return function(t1, e1, r, n, i) {
                                                var a = t1[0], o = t1[1], s = t1[2], l = r[0], c = r[1], u = r[2], f = [
                                                    0,
                                                    0,
                                                    0
                                                ];
                                                n |= 0;
                                                var h = 0, p = 0, d = 0, m = u, g = c - s * u, v = l - o * c;
                                                for(d = 0; d < a; ++d){
                                                    for(p = 0; p < o; ++p){
                                                        for(h = 0; h < s; ++h){
                                                            var y, x = i;
                                                            for(y = 0; y < f.length - 1; ++y)x = x[f[y]];
                                                            e1[n] = x[f[f.length - 1]], n += m, ++f[2];
                                                        }
                                                        n += g, f[2] -= s, ++f[1];
                                                    }
                                                    n += v, f[1] -= o, ++f[0];
                                                }
                                            };
                                        };
                                        e1.exports = (n = {
                                            funcName: "convert"
                                        }, function(t1) {
                                            var e1 = {};
                                            return function(r, n) {
                                                var i = r.dtype, a = r.order, o = [
                                                    i,
                                                    a.join()
                                                ].join(), s = e1[o];
                                                return s || (e1[o] = s = t1([
                                                    i,
                                                    a
                                                ])), s(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n);
                                            };
                                        }(i.bind(void 0, n)));
                                    },
                                    {}
                                ],
                                257: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("typedarray-pool");
                                        function i(t1) {
                                            switch(t1){
                                                case "uint32":
                                                    return [
                                                        n.mallocUint32,
                                                        n.freeUint32
                                                    ];
                                                default:
                                                    return null;
                                            }
                                        }
                                        var a = {
                                            "uint32,1,0": function(t1, e1) {
                                                return function(r, n, i, a, o, s, l, c, u, f, h) {
                                                    var p, d, m, g, v, y, x, b, _ = r * o + a, w = t1(c);
                                                    for(p = r + 1; p <= n; ++p){
                                                        for(d = p, m = _ += o, v = 0, y = _, g = 0; g < c; ++g)w[v++] = i[y], y += u;
                                                        t: for(; d-- > r;){
                                                            v = 0, y = m - o;
                                                            e: for(g = 0; g < c; ++g){
                                                                if ((x = i[y]) < (b = w[v])) break t;
                                                                if (x > b) break e;
                                                                y += f, v += h;
                                                            }
                                                            for(v = m, y = m - o, g = 0; g < c; ++g)i[v] = i[y], v += u, y += u;
                                                            m -= o;
                                                        }
                                                        for(v = m, y = 0, g = 0; g < c; ++g)i[v] = w[y++], v += u;
                                                    }
                                                    e1(w);
                                                };
                                            }
                                        };
                                        var o = {
                                            "uint32,1,0": function(t1, e1, r) {
                                                return function n(i, a, o, s, l, c, u, f, h, p, d) {
                                                    var m, g, v, y, x, b, _, w, T, k, A, M, S, E, L, C, P, I, O, z, D, R, F, B, N, j = (a - i + 1) / 6 | 0, U = i + j, V = a - j, H = i + a >> 1, q = H - j, G = H + j, Y = U, W = q, X = H, Z = G, J = V, K = i + 1, Q = a - 1, $ = !0, tt = 0, et = 0, rt = 0, nt = f, it = e1(nt), at = e1(nt);
                                                    A = l * Y, M = l * W, N = s;
                                                    t: for(k = 0; k < f; ++k){
                                                        if (w = M + N, (rt = o[_ = A + N] - o[w]) > 0) {
                                                            g = Y, Y = W, W = g;
                                                            break t;
                                                        }
                                                        if (rt < 0) break t;
                                                        N += p;
                                                    }
                                                    A = l * Z, M = l * J, N = s;
                                                    t: for(k = 0; k < f; ++k){
                                                        if (w = M + N, (rt = o[_ = A + N] - o[w]) > 0) {
                                                            g = Z, Z = J, J = g;
                                                            break t;
                                                        }
                                                        if (rt < 0) break t;
                                                        N += p;
                                                    }
                                                    A = l * Y, M = l * X, N = s;
                                                    t: for(k = 0; k < f; ++k){
                                                        if (w = M + N, (rt = o[_ = A + N] - o[w]) > 0) {
                                                            g = Y, Y = X, X = g;
                                                            break t;
                                                        }
                                                        if (rt < 0) break t;
                                                        N += p;
                                                    }
                                                    A = l * W, M = l * X, N = s;
                                                    t: for(k = 0; k < f; ++k){
                                                        if (w = M + N, (rt = o[_ = A + N] - o[w]) > 0) {
                                                            g = W, W = X, X = g;
                                                            break t;
                                                        }
                                                        if (rt < 0) break t;
                                                        N += p;
                                                    }
                                                    A = l * Y, M = l * Z, N = s;
                                                    t: for(k = 0; k < f; ++k){
                                                        if (w = M + N, (rt = o[_ = A + N] - o[w]) > 0) {
                                                            g = Y, Y = Z, Z = g;
                                                            break t;
                                                        }
                                                        if (rt < 0) break t;
                                                        N += p;
                                                    }
                                                    A = l * X, M = l * Z, N = s;
                                                    t: for(k = 0; k < f; ++k){
                                                        if (w = M + N, (rt = o[_ = A + N] - o[w]) > 0) {
                                                            g = X, X = Z, Z = g;
                                                            break t;
                                                        }
                                                        if (rt < 0) break t;
                                                        N += p;
                                                    }
                                                    A = l * W, M = l * J, N = s;
                                                    t: for(k = 0; k < f; ++k){
                                                        if (w = M + N, (rt = o[_ = A + N] - o[w]) > 0) {
                                                            g = W, W = J, J = g;
                                                            break t;
                                                        }
                                                        if (rt < 0) break t;
                                                        N += p;
                                                    }
                                                    A = l * W, M = l * X, N = s;
                                                    t: for(k = 0; k < f; ++k){
                                                        if (w = M + N, (rt = o[_ = A + N] - o[w]) > 0) {
                                                            g = W, W = X, X = g;
                                                            break t;
                                                        }
                                                        if (rt < 0) break t;
                                                        N += p;
                                                    }
                                                    A = l * Z, M = l * J, N = s;
                                                    t: for(k = 0; k < f; ++k){
                                                        if (w = M + N, (rt = o[_ = A + N] - o[w]) > 0) {
                                                            g = Z, Z = J, J = g;
                                                            break t;
                                                        }
                                                        if (rt < 0) break t;
                                                        N += p;
                                                    }
                                                    for(A = l * Y, M = l * W, S = l * X, E = l * Z, L = l * J, C = l * U, P = l * H, I = l * V, B = 0, N = s, k = 0; k < f; ++k)_ = A + N, w = M + N, T = S + N, O = E + N, z = L + N, D = C + N, R = P + N, F = I + N, it[B] = o[w], at[B] = o[O], $ = $ && it[B] === at[B], v = o[_], y = o[T], x = o[z], o[D] = v, o[R] = y, o[F] = x, ++B, N += h;
                                                    for(A = l * q, M = l * i, N = s, k = 0; k < f; ++k)w = M + N, o[_ = A + N] = o[w], N += h;
                                                    for(A = l * G, M = l * a, N = s, k = 0; k < f; ++k)w = M + N, o[_ = A + N] = o[w], N += h;
                                                    if ($) for(b = K; b <= Q; ++b){
                                                        _ = s + b * l, B = 0;
                                                        t: for(k = 0; k < f && 0 === (rt = o[_] - it[B]); ++k)B += d, _ += p;
                                                        if (0 !== rt) {
                                                            if (rt < 0) {
                                                                if (b !== K) for(A = l * b, M = l * K, N = s, k = 0; k < f; ++k)w = M + N, m = o[_ = A + N], o[_] = o[w], o[w] = m, N += h;
                                                                ++K;
                                                            } else for(;;){
                                                                _ = s + Q * l, B = 0;
                                                                t: for(k = 0; k < f && 0 === (rt = o[_] - it[B]); ++k)B += d, _ += p;
                                                                if (!(rt > 0)) {
                                                                    if (rt < 0) {
                                                                        for(A = l * b, M = l * K, S = l * Q, N = s, k = 0; k < f; ++k)w = M + N, T = S + N, m = o[_ = A + N], o[_] = o[w], o[w] = o[T], o[T] = m, N += h;
                                                                        ++K, --Q;
                                                                        break;
                                                                    }
                                                                    for(A = l * b, M = l * Q, N = s, k = 0; k < f; ++k)w = M + N, m = o[_ = A + N], o[_] = o[w], o[w] = m, N += h;
                                                                    --Q;
                                                                    break;
                                                                }
                                                                Q--;
                                                            }
                                                        }
                                                    }
                                                    else for(b = K; b <= Q; ++b){
                                                        _ = s + b * l, B = 0;
                                                        t: for(k = 0; k < f && 0 === (tt = o[_] - it[B]); ++k)B += d, _ += p;
                                                        if (tt < 0) {
                                                            if (b !== K) for(A = l * b, M = l * K, N = s, k = 0; k < f; ++k)w = M + N, m = o[_ = A + N], o[_] = o[w], o[w] = m, N += h;
                                                            ++K;
                                                        } else {
                                                            _ = s + b * l, B = 0;
                                                            t: for(k = 0; k < f && 0 === (et = o[_] - at[B]); ++k)B += d, _ += p;
                                                            if (et > 0) for(;;){
                                                                _ = s + Q * l, B = 0;
                                                                t: for(k = 0; k < f && 0 === (rt = o[_] - at[B]); ++k)B += d, _ += p;
                                                                if (!(rt > 0)) {
                                                                    _ = s + Q * l, B = 0;
                                                                    t: for(k = 0; k < f && 0 === (rt = o[_] - it[B]); ++k)B += d, _ += p;
                                                                    if (rt < 0) {
                                                                        for(A = l * b, M = l * K, S = l * Q, N = s, k = 0; k < f; ++k)w = M + N, T = S + N, m = o[_ = A + N], o[_] = o[w], o[w] = o[T], o[T] = m, N += h;
                                                                        ++K, --Q;
                                                                    } else {
                                                                        for(A = l * b, M = l * Q, N = s, k = 0; k < f; ++k)w = M + N, m = o[_ = A + N], o[_] = o[w], o[w] = m, N += h;
                                                                        --Q;
                                                                    }
                                                                    break;
                                                                }
                                                                if (--Q < b) break;
                                                            }
                                                        }
                                                    }
                                                    for(A = l * i, M = l * (K - 1), B = 0, N = s, k = 0; k < f; ++k)w = M + N, o[_ = A + N] = o[w], o[w] = it[B], ++B, N += h;
                                                    for(A = l * a, M = l * (Q + 1), B = 0, N = s, k = 0; k < f; ++k)w = M + N, o[_ = A + N] = o[w], o[w] = at[B], ++B, N += h;
                                                    if (K - 2 - i <= 32 ? t1(i, K - 2, o, s, l, c, u, f, h, p, d) : n(i, K - 2, o, s, l, c, u, f, h, p, d), a - (Q + 2) <= 32 ? t1(Q + 2, a, o, s, l, c, u, f, h, p, d) : n(Q + 2, a, o, s, l, c, u, f, h, p, d), $) return r(it), void r(at);
                                                    if (K < U && Q > V) {
                                                        t: for(;;){
                                                            for(_ = s + K * l, B = 0, N = s, k = 0; k < f; ++k){
                                                                if (o[_] !== it[B]) break t;
                                                                ++B, _ += h;
                                                            }
                                                            ++K;
                                                        }
                                                        t: for(;;){
                                                            for(_ = s + Q * l, B = 0, N = s, k = 0; k < f; ++k){
                                                                if (o[_] !== at[B]) break t;
                                                                ++B, _ += h;
                                                            }
                                                            --Q;
                                                        }
                                                        for(b = K; b <= Q; ++b){
                                                            _ = s + b * l, B = 0;
                                                            t: for(k = 0; k < f && 0 === (tt = o[_] - it[B]); ++k)B += d, _ += p;
                                                            if (0 === tt) {
                                                                if (b !== K) for(A = l * b, M = l * K, N = s, k = 0; k < f; ++k)w = M + N, m = o[_ = A + N], o[_] = o[w], o[w] = m, N += h;
                                                                ++K;
                                                            } else {
                                                                _ = s + b * l, B = 0;
                                                                t: for(k = 0; k < f && 0 === (et = o[_] - at[B]); ++k)B += d, _ += p;
                                                                if (0 === et) for(;;){
                                                                    _ = s + Q * l, B = 0;
                                                                    t: for(k = 0; k < f && 0 === (rt = o[_] - at[B]); ++k)B += d, _ += p;
                                                                    if (0 !== rt) {
                                                                        _ = s + Q * l, B = 0;
                                                                        t: for(k = 0; k < f && 0 === (rt = o[_] - it[B]); ++k)B += d, _ += p;
                                                                        if (rt < 0) {
                                                                            for(A = l * b, M = l * K, S = l * Q, N = s, k = 0; k < f; ++k)w = M + N, T = S + N, m = o[_ = A + N], o[_] = o[w], o[w] = o[T], o[T] = m, N += h;
                                                                            ++K, --Q;
                                                                        } else {
                                                                            for(A = l * b, M = l * Q, N = s, k = 0; k < f; ++k)w = M + N, m = o[_ = A + N], o[_] = o[w], o[w] = m, N += h;
                                                                            --Q;
                                                                        }
                                                                        break;
                                                                    }
                                                                    if (--Q < b) break;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    r(it), r(at), Q - K <= 32 ? t1(K, Q, o, s, l, c, u, f, h, p, d) : n(K, Q, o, s, l, c, u, f, h, p, d);
                                                };
                                            }
                                        };
                                        var s = {
                                            "uint32,1,0": function(t1, e1) {
                                                return function(r) {
                                                    var n = r.data, i = 0 | r.offset, a = r.shape, o = r.stride, s = 0 | o[0], l = 0 | a[0], c = 0 | o[1], u = 0 | a[1], f = c, h = c;
                                                    l <= 32 ? t1(0, l - 1, n, i, s, c, l, u, f, h, 1) : e1(0, l - 1, n, i, s, c, l, u, f, h, 1);
                                                };
                                            }
                                        };
                                        e1.exports = function(t1, e1) {
                                            var r = [
                                                e1,
                                                t1
                                            ].join(","), n = s[r], l = function(t1, e1) {
                                                var r = i(e1), n = [
                                                    e1,
                                                    t1
                                                ].join(","), o = a[n];
                                                return r ? o(r[0], r[1]) : o();
                                            }(t1, e1), c = function(t1, e1, r) {
                                                var n = i(e1), a = [
                                                    e1,
                                                    t1
                                                ].join(","), s = o[a];
                                                return t1.length > 1 && n ? s(r, n[0], n[1]) : s(r);
                                            }(t1, e1, l);
                                            return n(l, c);
                                        };
                                    },
                                    {
                                        "typedarray-pool": 308
                                    }
                                ],
                                258: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("./lib/compile_sort.js"), i = {};
                                        e1.exports = function(t1) {
                                            var e1 = t1.order, r = t1.dtype, a = [
                                                e1,
                                                r
                                            ].join(":"), o = i[a];
                                            return o || (i[a] = o = n(e1, r)), o(t1), t1;
                                        };
                                    },
                                    {
                                        "./lib/compile_sort.js": 257
                                    }
                                ],
                                259: [
                                    function(t1, e1, r) {
                                        var n = t1("is-buffer"), i = "undefined" != typeof Float64Array;
                                        function a(t1, e1) {
                                            return t1[0] - e1[0];
                                        }
                                        function o() {
                                            var t1, e1 = this.stride, r = new Array(e1.length);
                                            for(t1 = 0; t1 < r.length; ++t1)r[t1] = [
                                                Math.abs(e1[t1]),
                                                t1
                                            ];
                                            r.sort(a);
                                            var n = new Array(r.length);
                                            for(t1 = 0; t1 < n.length; ++t1)n[t1] = r[t1][1];
                                            return n;
                                        }
                                        var s = {
                                            T: function(t1) {
                                                function e1(t1) {
                                                    this.data = t1;
                                                }
                                                var r = e1.prototype;
                                                return r.dtype = t1, r.index = function() {
                                                    return -1;
                                                }, r.size = 0, r.dimension = -1, r.shape = r.stride = r.order = [], r.lo = r.hi = r.transpose = r.step = function() {
                                                    return new e1(this.data);
                                                }, r.get = r.set = function() {}, r.pick = function() {
                                                    return null;
                                                }, function(t1) {
                                                    return new e1(t1);
                                                };
                                            },
                                            0: function(t1, e1) {
                                                function r(t1, e1) {
                                                    this.data = t1, this.offset = e1;
                                                }
                                                var n = r.prototype;
                                                return n.dtype = t1, n.index = function() {
                                                    return this.offset;
                                                }, n.dimension = 0, n.size = 1, n.shape = n.stride = n.order = [], n.lo = n.hi = n.transpose = n.step = function() {
                                                    return new r(this.data, this.offset);
                                                }, n.pick = function() {
                                                    return e1(this.data);
                                                }, n.valueOf = n.get = function() {
                                                    return "generic" === t1 ? this.data.get(this.offset) : this.data[this.offset];
                                                }, n.set = function(e1) {
                                                    return "generic" === t1 ? this.data.set(this.offset, e1) : this.data[this.offset] = e1;
                                                }, function(t1, e1, n, i) {
                                                    return new r(t1, i);
                                                };
                                            },
                                            1: function(t1, e1, r) {
                                                function n(t1, e1, r, n) {
                                                    this.data = t1, this.shape = [
                                                        e1
                                                    ], this.stride = [
                                                        r
                                                    ], this.offset = 0 | n;
                                                }
                                                var i = n.prototype;
                                                return i.dtype = t1, i.dimension = 1, Object.defineProperty(i, "size", {
                                                    get: function() {
                                                        return this.shape[0];
                                                    }
                                                }), i.order = [
                                                    0
                                                ], i.set = function(e1, r) {
                                                    return "generic" === t1 ? this.data.set(this.offset + this.stride[0] * e1, r) : this.data[this.offset + this.stride[0] * e1] = r;
                                                }, i.get = function(e1) {
                                                    return "generic" === t1 ? this.data.get(this.offset + this.stride[0] * e1) : this.data[this.offset + this.stride[0] * e1];
                                                }, i.index = function(t1) {
                                                    return this.offset + this.stride[0] * t1;
                                                }, i.hi = function(t1) {
                                                    return new n(this.data, "number" != typeof t1 || t1 < 0 ? this.shape[0] : 0 | t1, this.stride[0], this.offset);
                                                }, i.lo = function(t1) {
                                                    var e1 = this.offset, r = 0, i = this.shape[0], a = this.stride[0];
                                                    return "number" == typeof t1 && t1 >= 0 && (e1 += a * (r = 0 | t1), i -= r), new n(this.data, i, a, e1);
                                                }, i.step = function(t1) {
                                                    var e1 = this.shape[0], r = this.stride[0], i = this.offset, a = 0, o = Math.ceil;
                                                    return "number" == typeof t1 && ((a = 0 | t1) < 0 ? (i += r * (e1 - 1), e1 = o(-e1 / a)) : e1 = o(e1 / a), r *= a), new n(this.data, e1, r, i);
                                                }, i.transpose = function(t1) {
                                                    t1 = void 0 === t1 ? 0 : 0 | t1;
                                                    var e1 = this.shape, r = this.stride;
                                                    return new n(this.data, e1[t1], r[t1], this.offset);
                                                }, i.pick = function(t1) {
                                                    var r = [], n = [], i = this.offset;
                                                    return "number" == typeof t1 && t1 >= 0 ? i = i + this.stride[0] * t1 | 0 : (r.push(this.shape[0]), n.push(this.stride[0])), (0, e1[r.length + 1])(this.data, r, n, i);
                                                }, function(t1, e1, r, i) {
                                                    return new n(t1, e1[0], r[0], i);
                                                };
                                            },
                                            2: function(t1, e1, r) {
                                                function n(t1, e1, r, n, i, a) {
                                                    this.data = t1, this.shape = [
                                                        e1,
                                                        r
                                                    ], this.stride = [
                                                        n,
                                                        i
                                                    ], this.offset = 0 | a;
                                                }
                                                var i = n.prototype;
                                                return i.dtype = t1, i.dimension = 2, Object.defineProperty(i, "size", {
                                                    get: function() {
                                                        return this.shape[0] * this.shape[1];
                                                    }
                                                }), Object.defineProperty(i, "order", {
                                                    get: function() {
                                                        return Math.abs(this.stride[0]) > Math.abs(this.stride[1]) ? [
                                                            1,
                                                            0
                                                        ] : [
                                                            0,
                                                            1
                                                        ];
                                                    }
                                                }), i.set = function(e1, r, n) {
                                                    return "generic" === t1 ? this.data.set(this.offset + this.stride[0] * e1 + this.stride[1] * r, n) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r] = n;
                                                }, i.get = function(e1, r) {
                                                    return "generic" === t1 ? this.data.get(this.offset + this.stride[0] * e1 + this.stride[1] * r) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r];
                                                }, i.index = function(t1, e1) {
                                                    return this.offset + this.stride[0] * t1 + this.stride[1] * e1;
                                                }, i.hi = function(t1, e1) {
                                                    return new n(this.data, "number" != typeof t1 || t1 < 0 ? this.shape[0] : 0 | t1, "number" != typeof e1 || e1 < 0 ? this.shape[1] : 0 | e1, this.stride[0], this.stride[1], this.offset);
                                                }, i.lo = function(t1, e1) {
                                                    var r = this.offset, i = 0, a = this.shape[0], o = this.shape[1], s = this.stride[0], l = this.stride[1];
                                                    return "number" == typeof t1 && t1 >= 0 && (r += s * (i = 0 | t1), a -= i), "number" == typeof e1 && e1 >= 0 && (r += l * (i = 0 | e1), o -= i), new n(this.data, a, o, s, l, r);
                                                }, i.step = function(t1, e1) {
                                                    var r = this.shape[0], i = this.shape[1], a = this.stride[0], o = this.stride[1], s = this.offset, l = 0, c = Math.ceil;
                                                    return "number" == typeof t1 && ((l = 0 | t1) < 0 ? (s += a * (r - 1), r = c(-r / l)) : r = c(r / l), a *= l), "number" == typeof e1 && ((l = 0 | e1) < 0 ? (s += o * (i - 1), i = c(-i / l)) : i = c(i / l), o *= l), new n(this.data, r, i, a, o, s);
                                                }, i.transpose = function(t1, e1) {
                                                    t1 = void 0 === t1 ? 0 : 0 | t1, e1 = void 0 === e1 ? 1 : 0 | e1;
                                                    var r = this.shape, i = this.stride;
                                                    return new n(this.data, r[t1], r[e1], i[t1], i[e1], this.offset);
                                                }, i.pick = function(t1, r) {
                                                    var n = [], i = [], a = this.offset;
                                                    return "number" == typeof t1 && t1 >= 0 ? a = a + this.stride[0] * t1 | 0 : (n.push(this.shape[0]), i.push(this.stride[0])), "number" == typeof r && r >= 0 ? a = a + this.stride[1] * r | 0 : (n.push(this.shape[1]), i.push(this.stride[1])), (0, e1[n.length + 1])(this.data, n, i, a);
                                                }, function(t1, e1, r, i) {
                                                    return new n(t1, e1[0], e1[1], r[0], r[1], i);
                                                };
                                            },
                                            3: function(t1, e1, r) {
                                                function n(t1, e1, r, n, i, a, o, s) {
                                                    this.data = t1, this.shape = [
                                                        e1,
                                                        r,
                                                        n
                                                    ], this.stride = [
                                                        i,
                                                        a,
                                                        o
                                                    ], this.offset = 0 | s;
                                                }
                                                var i = n.prototype;
                                                return i.dtype = t1, i.dimension = 3, Object.defineProperty(i, "size", {
                                                    get: function() {
                                                        return this.shape[0] * this.shape[1] * this.shape[2];
                                                    }
                                                }), Object.defineProperty(i, "order", {
                                                    get: function() {
                                                        var t1 = Math.abs(this.stride[0]), e1 = Math.abs(this.stride[1]), r = Math.abs(this.stride[2]);
                                                        return t1 > e1 ? e1 > r ? [
                                                            2,
                                                            1,
                                                            0
                                                        ] : t1 > r ? [
                                                            1,
                                                            2,
                                                            0
                                                        ] : [
                                                            1,
                                                            0,
                                                            2
                                                        ] : t1 > r ? [
                                                            2,
                                                            0,
                                                            1
                                                        ] : r > e1 ? [
                                                            0,
                                                            1,
                                                            2
                                                        ] : [
                                                            0,
                                                            2,
                                                            1
                                                        ];
                                                    }
                                                }), i.set = function(e1, r, n, i) {
                                                    return "generic" === t1 ? this.data.set(this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n, i) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n] = i;
                                                }, i.get = function(e1, r, n) {
                                                    return "generic" === t1 ? this.data.get(this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n];
                                                }, i.index = function(t1, e1, r) {
                                                    return this.offset + this.stride[0] * t1 + this.stride[1] * e1 + this.stride[2] * r;
                                                }, i.hi = function(t1, e1, r) {
                                                    return new n(this.data, "number" != typeof t1 || t1 < 0 ? this.shape[0] : 0 | t1, "number" != typeof e1 || e1 < 0 ? this.shape[1] : 0 | e1, "number" != typeof r || r < 0 ? this.shape[2] : 0 | r, this.stride[0], this.stride[1], this.stride[2], this.offset);
                                                }, i.lo = function(t1, e1, r) {
                                                    var i = this.offset, a = 0, o = this.shape[0], s = this.shape[1], l = this.shape[2], c = this.stride[0], u = this.stride[1], f = this.stride[2];
                                                    return "number" == typeof t1 && t1 >= 0 && (i += c * (a = 0 | t1), o -= a), "number" == typeof e1 && e1 >= 0 && (i += u * (a = 0 | e1), s -= a), "number" == typeof r && r >= 0 && (i += f * (a = 0 | r), l -= a), new n(this.data, o, s, l, c, u, f, i);
                                                }, i.step = function(t1, e1, r) {
                                                    var i = this.shape[0], a = this.shape[1], o = this.shape[2], s = this.stride[0], l = this.stride[1], c = this.stride[2], u = this.offset, f = 0, h = Math.ceil;
                                                    return "number" == typeof t1 && ((f = 0 | t1) < 0 ? (u += s * (i - 1), i = h(-i / f)) : i = h(i / f), s *= f), "number" == typeof e1 && ((f = 0 | e1) < 0 ? (u += l * (a - 1), a = h(-a / f)) : a = h(a / f), l *= f), "number" == typeof r && ((f = 0 | r) < 0 ? (u += c * (o - 1), o = h(-o / f)) : o = h(o / f), c *= f), new n(this.data, i, a, o, s, l, c, u);
                                                }, i.transpose = function(t1, e1, r) {
                                                    t1 = void 0 === t1 ? 0 : 0 | t1, e1 = void 0 === e1 ? 1 : 0 | e1, r = void 0 === r ? 2 : 0 | r;
                                                    var i = this.shape, a = this.stride;
                                                    return new n(this.data, i[t1], i[e1], i[r], a[t1], a[e1], a[r], this.offset);
                                                }, i.pick = function(t1, r, n) {
                                                    var i = [], a = [], o = this.offset;
                                                    return "number" == typeof t1 && t1 >= 0 ? o = o + this.stride[0] * t1 | 0 : (i.push(this.shape[0]), a.push(this.stride[0])), "number" == typeof r && r >= 0 ? o = o + this.stride[1] * r | 0 : (i.push(this.shape[1]), a.push(this.stride[1])), "number" == typeof n && n >= 0 ? o = o + this.stride[2] * n | 0 : (i.push(this.shape[2]), a.push(this.stride[2])), (0, e1[i.length + 1])(this.data, i, a, o);
                                                }, function(t1, e1, r, i) {
                                                    return new n(t1, e1[0], e1[1], e1[2], r[0], r[1], r[2], i);
                                                };
                                            },
                                            4: function(t1, e1, r) {
                                                function n(t1, e1, r, n, i, a, o, s, l, c) {
                                                    this.data = t1, this.shape = [
                                                        e1,
                                                        r,
                                                        n,
                                                        i
                                                    ], this.stride = [
                                                        a,
                                                        o,
                                                        s,
                                                        l
                                                    ], this.offset = 0 | c;
                                                }
                                                var i = n.prototype;
                                                return i.dtype = t1, i.dimension = 4, Object.defineProperty(i, "size", {
                                                    get: function() {
                                                        return this.shape[0] * this.shape[1] * this.shape[2] * this.shape[3];
                                                    }
                                                }), Object.defineProperty(i, "order", {
                                                    get: r
                                                }), i.set = function(e1, r, n, i, a) {
                                                    return "generic" === t1 ? this.data.set(this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i, a) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i] = a;
                                                }, i.get = function(e1, r, n, i) {
                                                    return "generic" === t1 ? this.data.get(this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i];
                                                }, i.index = function(t1, e1, r, n) {
                                                    return this.offset + this.stride[0] * t1 + this.stride[1] * e1 + this.stride[2] * r + this.stride[3] * n;
                                                }, i.hi = function(t1, e1, r, i) {
                                                    return new n(this.data, "number" != typeof t1 || t1 < 0 ? this.shape[0] : 0 | t1, "number" != typeof e1 || e1 < 0 ? this.shape[1] : 0 | e1, "number" != typeof r || r < 0 ? this.shape[2] : 0 | r, "number" != typeof i || i < 0 ? this.shape[3] : 0 | i, this.stride[0], this.stride[1], this.stride[2], this.stride[3], this.offset);
                                                }, i.lo = function(t1, e1, r, i) {
                                                    var a = this.offset, o = 0, s = this.shape[0], l = this.shape[1], c = this.shape[2], u = this.shape[3], f = this.stride[0], h = this.stride[1], p = this.stride[2], d = this.stride[3];
                                                    return "number" == typeof t1 && t1 >= 0 && (a += f * (o = 0 | t1), s -= o), "number" == typeof e1 && e1 >= 0 && (a += h * (o = 0 | e1), l -= o), "number" == typeof r && r >= 0 && (a += p * (o = 0 | r), c -= o), "number" == typeof i && i >= 0 && (a += d * (o = 0 | i), u -= o), new n(this.data, s, l, c, u, f, h, p, d, a);
                                                }, i.step = function(t1, e1, r, i) {
                                                    var a = this.shape[0], o = this.shape[1], s = this.shape[2], l = this.shape[3], c = this.stride[0], u = this.stride[1], f = this.stride[2], h = this.stride[3], p = this.offset, d = 0, m = Math.ceil;
                                                    return "number" == typeof t1 && ((d = 0 | t1) < 0 ? (p += c * (a - 1), a = m(-a / d)) : a = m(a / d), c *= d), "number" == typeof e1 && ((d = 0 | e1) < 0 ? (p += u * (o - 1), o = m(-o / d)) : o = m(o / d), u *= d), "number" == typeof r && ((d = 0 | r) < 0 ? (p += f * (s - 1), s = m(-s / d)) : s = m(s / d), f *= d), "number" == typeof i && ((d = 0 | i) < 0 ? (p += h * (l - 1), l = m(-l / d)) : l = m(l / d), h *= d), new n(this.data, a, o, s, l, c, u, f, h, p);
                                                }, i.transpose = function(t1, e1, r, i) {
                                                    t1 = void 0 === t1 ? 0 : 0 | t1, e1 = void 0 === e1 ? 1 : 0 | e1, r = void 0 === r ? 2 : 0 | r, i = void 0 === i ? 3 : 0 | i;
                                                    var a = this.shape, o = this.stride;
                                                    return new n(this.data, a[t1], a[e1], a[r], a[i], o[t1], o[e1], o[r], o[i], this.offset);
                                                }, i.pick = function(t1, r, n, i) {
                                                    var a = [], o = [], s = this.offset;
                                                    return "number" == typeof t1 && t1 >= 0 ? s = s + this.stride[0] * t1 | 0 : (a.push(this.shape[0]), o.push(this.stride[0])), "number" == typeof r && r >= 0 ? s = s + this.stride[1] * r | 0 : (a.push(this.shape[1]), o.push(this.stride[1])), "number" == typeof n && n >= 0 ? s = s + this.stride[2] * n | 0 : (a.push(this.shape[2]), o.push(this.stride[2])), "number" == typeof i && i >= 0 ? s = s + this.stride[3] * i | 0 : (a.push(this.shape[3]), o.push(this.stride[3])), (0, e1[a.length + 1])(this.data, a, o, s);
                                                }, function(t1, e1, r, i) {
                                                    return new n(t1, e1[0], e1[1], e1[2], e1[3], r[0], r[1], r[2], r[3], i);
                                                };
                                            },
                                            5: function(t1, e1, r) {
                                                function n(t1, e1, r, n, i, a, o, s, l, c, u, f) {
                                                    this.data = t1, this.shape = [
                                                        e1,
                                                        r,
                                                        n,
                                                        i,
                                                        a
                                                    ], this.stride = [
                                                        o,
                                                        s,
                                                        l,
                                                        c,
                                                        u
                                                    ], this.offset = 0 | f;
                                                }
                                                var i = n.prototype;
                                                return i.dtype = t1, i.dimension = 5, Object.defineProperty(i, "size", {
                                                    get: function() {
                                                        return this.shape[0] * this.shape[1] * this.shape[2] * this.shape[3] * this.shape[4];
                                                    }
                                                }), Object.defineProperty(i, "order", {
                                                    get: r
                                                }), i.set = function(e1, r, n, i, a, o) {
                                                    return "generic" === t1 ? this.data.set(this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i + this.stride[4] * a, o) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i + this.stride[4] * a] = o;
                                                }, i.get = function(e1, r, n, i, a) {
                                                    return "generic" === t1 ? this.data.get(this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i + this.stride[4] * a) : this.data[this.offset + this.stride[0] * e1 + this.stride[1] * r + this.stride[2] * n + this.stride[3] * i + this.stride[4] * a];
                                                }, i.index = function(t1, e1, r, n, i) {
                                                    return this.offset + this.stride[0] * t1 + this.stride[1] * e1 + this.stride[2] * r + this.stride[3] * n + this.stride[4] * i;
                                                }, i.hi = function(t1, e1, r, i, a) {
                                                    return new n(this.data, "number" != typeof t1 || t1 < 0 ? this.shape[0] : 0 | t1, "number" != typeof e1 || e1 < 0 ? this.shape[1] : 0 | e1, "number" != typeof r || r < 0 ? this.shape[2] : 0 | r, "number" != typeof i || i < 0 ? this.shape[3] : 0 | i, "number" != typeof a || a < 0 ? this.shape[4] : 0 | a, this.stride[0], this.stride[1], this.stride[2], this.stride[3], this.stride[4], this.offset);
                                                }, i.lo = function(t1, e1, r, i, a) {
                                                    var o = this.offset, s = 0, l = this.shape[0], c = this.shape[1], u = this.shape[2], f = this.shape[3], h = this.shape[4], p = this.stride[0], d = this.stride[1], m = this.stride[2], g = this.stride[3], v = this.stride[4];
                                                    return "number" == typeof t1 && t1 >= 0 && (o += p * (s = 0 | t1), l -= s), "number" == typeof e1 && e1 >= 0 && (o += d * (s = 0 | e1), c -= s), "number" == typeof r && r >= 0 && (o += m * (s = 0 | r), u -= s), "number" == typeof i && i >= 0 && (o += g * (s = 0 | i), f -= s), "number" == typeof a && a >= 0 && (o += v * (s = 0 | a), h -= s), new n(this.data, l, c, u, f, h, p, d, m, g, v, o);
                                                }, i.step = function(t1, e1, r, i, a) {
                                                    var o = this.shape[0], s = this.shape[1], l = this.shape[2], c = this.shape[3], u = this.shape[4], f = this.stride[0], h = this.stride[1], p = this.stride[2], d = this.stride[3], m = this.stride[4], g = this.offset, v = 0, y = Math.ceil;
                                                    return "number" == typeof t1 && ((v = 0 | t1) < 0 ? (g += f * (o - 1), o = y(-o / v)) : o = y(o / v), f *= v), "number" == typeof e1 && ((v = 0 | e1) < 0 ? (g += h * (s - 1), s = y(-s / v)) : s = y(s / v), h *= v), "number" == typeof r && ((v = 0 | r) < 0 ? (g += p * (l - 1), l = y(-l / v)) : l = y(l / v), p *= v), "number" == typeof i && ((v = 0 | i) < 0 ? (g += d * (c - 1), c = y(-c / v)) : c = y(c / v), d *= v), "number" == typeof a && ((v = 0 | a) < 0 ? (g += m * (u - 1), u = y(-u / v)) : u = y(u / v), m *= v), new n(this.data, o, s, l, c, u, f, h, p, d, m, g);
                                                }, i.transpose = function(t1, e1, r, i, a) {
                                                    t1 = void 0 === t1 ? 0 : 0 | t1, e1 = void 0 === e1 ? 1 : 0 | e1, r = void 0 === r ? 2 : 0 | r, i = void 0 === i ? 3 : 0 | i, a = void 0 === a ? 4 : 0 | a;
                                                    var o = this.shape, s = this.stride;
                                                    return new n(this.data, o[t1], o[e1], o[r], o[i], o[a], s[t1], s[e1], s[r], s[i], s[a], this.offset);
                                                }, i.pick = function(t1, r, n, i, a) {
                                                    var o = [], s = [], l = this.offset;
                                                    return "number" == typeof t1 && t1 >= 0 ? l = l + this.stride[0] * t1 | 0 : (o.push(this.shape[0]), s.push(this.stride[0])), "number" == typeof r && r >= 0 ? l = l + this.stride[1] * r | 0 : (o.push(this.shape[1]), s.push(this.stride[1])), "number" == typeof n && n >= 0 ? l = l + this.stride[2] * n | 0 : (o.push(this.shape[2]), s.push(this.stride[2])), "number" == typeof i && i >= 0 ? l = l + this.stride[3] * i | 0 : (o.push(this.shape[3]), s.push(this.stride[3])), "number" == typeof a && a >= 0 ? l = l + this.stride[4] * a | 0 : (o.push(this.shape[4]), s.push(this.stride[4])), (0, e1[o.length + 1])(this.data, o, s, l);
                                                }, function(t1, e1, r, i) {
                                                    return new n(t1, e1[0], e1[1], e1[2], e1[3], e1[4], r[0], r[1], r[2], r[3], r[4], i);
                                                };
                                            }
                                        };
                                        function l(t1, e1) {
                                            var r = -1 === e1 ? "T" : String(e1), n = s[r];
                                            return -1 === e1 ? n(t1) : 0 === e1 ? n(t1, c[t1][0]) : n(t1, c[t1], o);
                                        }
                                        var c = {
                                            generic: [],
                                            buffer: [],
                                            array: [],
                                            float32: [],
                                            float64: [],
                                            int8: [],
                                            int16: [],
                                            int32: [],
                                            uint8_clamped: [],
                                            uint8: [],
                                            uint16: [],
                                            uint32: [],
                                            bigint64: [],
                                            biguint64: []
                                        };
                                        e1.exports = function(t1, e1, r, a) {
                                            if (void 0 === t1) return (0, c.array[0])([]);
                                            "number" == typeof t1 && (t1 = [
                                                t1
                                            ]), void 0 === e1 && (e1 = [
                                                t1.length
                                            ]);
                                            var o = e1.length;
                                            if (void 0 === r) {
                                                r = new Array(o);
                                                for(var s = o - 1, u = 1; s >= 0; --s)r[s] = u, u *= e1[s];
                                            }
                                            if (void 0 === a) {
                                                a = 0;
                                                for(s = 0; s < o; ++s)r[s] < 0 && (a -= (e1[s] - 1) * r[s]);
                                            }
                                            for(var f = function(t1) {
                                                if (n(t1)) return "buffer";
                                                if (i) switch(Object.prototype.toString.call(t1)){
                                                    case "[object Float64Array]":
                                                        return "float64";
                                                    case "[object Float32Array]":
                                                        return "float32";
                                                    case "[object Int8Array]":
                                                        return "int8";
                                                    case "[object Int16Array]":
                                                        return "int16";
                                                    case "[object Int32Array]":
                                                        return "int32";
                                                    case "[object Uint8ClampedArray]":
                                                        return "uint8_clamped";
                                                    case "[object Uint8Array]":
                                                        return "uint8";
                                                    case "[object Uint16Array]":
                                                        return "uint16";
                                                    case "[object Uint32Array]":
                                                        return "uint32";
                                                    case "[object BigInt64Array]":
                                                        return "bigint64";
                                                    case "[object BigUint64Array]":
                                                        return "biguint64";
                                                }
                                                return Array.isArray(t1) ? "array" : "generic";
                                            }(t1), h = c[f]; h.length <= o + 1;)h.push(l(f, h.length - 1));
                                            return (0, h[o + 1])(t1, e1, r, a);
                                        };
                                    },
                                    {
                                        "is-buffer": 237
                                    }
                                ],
                                260: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("double-bits"), i = Math.pow(2, -1074);
                                        e1.exports = function(t1, e1) {
                                            if (isNaN(t1) || isNaN(e1)) return NaN;
                                            if (t1 === e1) return t1;
                                            if (0 === t1) return e1 < 0 ? -i : i;
                                            var r = n.hi(t1), a = n.lo(t1);
                                            e1 > t1 == t1 > 0 ? a === 4294967295 ? (r += 1, a = 0) : a += 1 : 0 === a ? (a = 4294967295, r -= 1) : a -= 1;
                                            return n.pack(a, r);
                                        };
                                    },
                                    {
                                        "double-bits": 64
                                    }
                                ],
                                261: [
                                    function(t1, e1, r) {
                                        r.vertexNormals = function(t1, e1, r) {
                                            for(var n = e1.length, i = new Array(n), a = void 0 === r ? 1e-6 : r, o = 0; o < n; ++o)i[o] = [
                                                0,
                                                0,
                                                0
                                            ];
                                            for(o = 0; o < t1.length; ++o)for(var s = t1[o], l = 0, c = s[s.length - 1], u = s[0], f = 0; f < s.length; ++f){
                                                l = c, c = u, u = s[(f + 1) % s.length];
                                                for(var h = e1[l], p = e1[c], d = e1[u], m = new Array(3), g = 0, v = new Array(3), y = 0, x = 0; x < 3; ++x)m[x] = h[x] - p[x], g += m[x] * m[x], v[x] = d[x] - p[x], y += v[x] * v[x];
                                                if (g * y > a) {
                                                    var b = i[c], _ = 1 / Math.sqrt(g * y);
                                                    for(x = 0; x < 3; ++x){
                                                        var w = (x + 1) % 3, T = (x + 2) % 3;
                                                        b[x] += _ * (v[w] * m[T] - v[T] * m[w]);
                                                    }
                                                }
                                            }
                                            for(o = 0; o < n; ++o){
                                                b = i[o];
                                                var k = 0;
                                                for(x = 0; x < 3; ++x)k += b[x] * b[x];
                                                if (k > a) for(_ = 1 / Math.sqrt(k), x = 0; x < 3; ++x)b[x] *= _;
                                                else for(x = 0; x < 3; ++x)b[x] = 0;
                                            }
                                            return i;
                                        }, r.faceNormals = function(t1, e1, r) {
                                            for(var n = t1.length, i = new Array(n), a = void 0 === r ? 1e-6 : r, o = 0; o < n; ++o){
                                                for(var s = t1[o], l = new Array(3), c = 0; c < 3; ++c)l[c] = e1[s[c]];
                                                var u = new Array(3), f = new Array(3);
                                                for(c = 0; c < 3; ++c)u[c] = l[1][c] - l[0][c], f[c] = l[2][c] - l[0][c];
                                                var h = new Array(3), p = 0;
                                                for(c = 0; c < 3; ++c){
                                                    var d = (c + 1) % 3, m = (c + 2) % 3;
                                                    h[c] = u[d] * f[m] - u[m] * f[d], p += h[c] * h[c];
                                                }
                                                p = p > a ? 1 / Math.sqrt(p) : 0;
                                                for(c = 0; c < 3; ++c)h[c] *= p;
                                                i[o] = h;
                                            }
                                            return i;
                                        };
                                    },
                                    {}
                                ],
                                262: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r, n, i, a, o, s, l, c) {
                                            var u = e1 + a + c;
                                            if (f > 0) {
                                                var f = Math.sqrt(u + 1);
                                                t1[0] = .5 * (o - l) / f, t1[1] = .5 * (s - n) / f, t1[2] = .5 * (r - a) / f, t1[3] = .5 * f;
                                            } else {
                                                var h = Math.max(e1, a, c);
                                                f = Math.sqrt(2 * h - u + 1);
                                                e1 >= h ? (t1[0] = .5 * f, t1[1] = .5 * (i + r) / f, t1[2] = .5 * (s + n) / f, t1[3] = .5 * (o - l) / f) : a >= h ? (t1[0] = .5 * (r + i) / f, t1[1] = .5 * f, t1[2] = .5 * (l + o) / f, t1[3] = .5 * (s - n) / f) : (t1[0] = .5 * (n + s) / f, t1[1] = .5 * (o + l) / f, t1[2] = .5 * f, t1[3] = .5 * (r - i) / f);
                                            }
                                            return t1;
                                        };
                                    },
                                    {}
                                ],
                                263: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = (t1 = t1 || {}).center || [
                                                0,
                                                0,
                                                0
                                            ], r = t1.rotation || [
                                                0,
                                                0,
                                                0,
                                                1
                                            ], n = t1.radius || 1;
                                            e1 = [].slice.call(e1, 0, 3), u(r = [].slice.call(r, 0, 4), r);
                                            var i = new f(r, e1, Math.log(n));
                                            i.setDistanceLimits(t1.zoomMin, t1.zoomMax), ("eye" in t1 || "up" in t1) && i.lookAt(0, t1.eye, t1.center, t1.up);
                                            return i;
                                        };
                                        var n = t1("filtered-vector"), i = t1("gl-mat4/lookAt"), a = t1("gl-mat4/fromQuat"), o = t1("gl-mat4/invert"), s = t1("./lib/quatFromFrame");
                                        function l(t1, e1, r) {
                                            return Math.sqrt(Math.pow(t1, 2) + Math.pow(e1, 2) + Math.pow(r, 2));
                                        }
                                        function c(t1, e1, r, n) {
                                            return Math.sqrt(Math.pow(t1, 2) + Math.pow(e1, 2) + Math.pow(r, 2) + Math.pow(n, 2));
                                        }
                                        function u(t1, e1) {
                                            var r = e1[0], n = e1[1], i = e1[2], a = e1[3], o = c(r, n, i, a);
                                            o > 1e-6 ? (t1[0] = r / o, t1[1] = n / o, t1[2] = i / o, t1[3] = a / o) : (t1[0] = t1[1] = t1[2] = 0, t1[3] = 1);
                                        }
                                        function f(t1, e1, r) {
                                            this.radius = n([
                                                r
                                            ]), this.center = n(e1), this.rotation = n(t1), this.computedRadius = this.radius.curve(0), this.computedCenter = this.center.curve(0), this.computedRotation = this.rotation.curve(0), this.computedUp = [
                                                .1,
                                                0,
                                                0
                                            ], this.computedEye = [
                                                .1,
                                                0,
                                                0
                                            ], this.computedMatrix = [
                                                .1,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0,
                                                0
                                            ], this.recalcMatrix(0);
                                        }
                                        var h = f.prototype;
                                        h.lastT = function() {
                                            return Math.max(this.radius.lastT(), this.center.lastT(), this.rotation.lastT());
                                        }, h.recalcMatrix = function(t1) {
                                            this.radius.curve(t1), this.center.curve(t1), this.rotation.curve(t1);
                                            var e1 = this.computedRotation;
                                            u(e1, e1);
                                            var r = this.computedMatrix;
                                            a(r, e1);
                                            var n = this.computedCenter, i = this.computedEye, o = this.computedUp, s = Math.exp(this.computedRadius[0]);
                                            i[0] = n[0] + s * r[2], i[1] = n[1] + s * r[6], i[2] = n[2] + s * r[10], o[0] = r[1], o[1] = r[5], o[2] = r[9];
                                            for(var l = 0; l < 3; ++l){
                                                for(var c = 0, f = 0; f < 3; ++f)c += r[l + 4 * f] * i[f];
                                                r[12 + l] = -c;
                                            }
                                        }, h.getMatrix = function(t1, e1) {
                                            this.recalcMatrix(t1);
                                            var r = this.computedMatrix;
                                            if (e1) {
                                                for(var n = 0; n < 16; ++n)e1[n] = r[n];
                                                return e1;
                                            }
                                            return r;
                                        }, h.idle = function(t1) {
                                            this.center.idle(t1), this.radius.idle(t1), this.rotation.idle(t1);
                                        }, h.flush = function(t1) {
                                            this.center.flush(t1), this.radius.flush(t1), this.rotation.flush(t1);
                                        }, h.pan = function(t1, e1, r, n) {
                                            e1 = e1 || 0, r = r || 0, n = n || 0, this.recalcMatrix(t1);
                                            var i = this.computedMatrix, a = i[1], o = i[5], s = i[9], c = l(a, o, s);
                                            a /= c, o /= c, s /= c;
                                            var u = i[0], f = i[4], h = i[8], p = u * a + f * o + h * s, d = l(u -= a * p, f -= o * p, h -= s * p);
                                            u /= d, f /= d, h /= d;
                                            var m = i[2], g = i[6], v = i[10], y = m * a + g * o + v * s, x = m * u + g * f + v * h, b = l(m -= y * a + x * u, g -= y * o + x * f, v -= y * s + x * h);
                                            m /= b, g /= b, v /= b;
                                            var _ = u * e1 + a * r, w = f * e1 + o * r, T = h * e1 + s * r;
                                            this.center.move(t1, _, w, T);
                                            var k = Math.exp(this.computedRadius[0]);
                                            k = Math.max(1e-4, k + n), this.radius.set(t1, Math.log(k));
                                        }, h.rotate = function(t1, e1, r, n) {
                                            this.recalcMatrix(t1), e1 = e1 || 0, r = r || 0;
                                            var i = this.computedMatrix, a = i[0], o = i[4], s = i[8], u = i[1], f = i[5], h = i[9], p = i[2], d = i[6], m = i[10], g = e1 * a + r * u, v = e1 * o + r * f, y = e1 * s + r * h, x = -(d * y - m * v), b = -(m * g - p * y), _ = -(p * v - d * g), w = Math.sqrt(Math.max(0, 1 - Math.pow(x, 2) - Math.pow(b, 2) - Math.pow(_, 2))), T = c(x, b, _, w);
                                            T > 1e-6 ? (x /= T, b /= T, _ /= T, w /= T) : (x = b = _ = 0, w = 1);
                                            var k = this.computedRotation, A = k[0], M = k[1], S = k[2], E = k[3], L = A * w + E * x + M * _ - S * b, C = M * w + E * b + S * x - A * _, P = S * w + E * _ + A * b - M * x, I = E * w - A * x - M * b - S * _;
                                            if (n) {
                                                x = p, b = d, _ = m;
                                                var O = Math.sin(n) / l(x, b, _);
                                                x *= O, b *= O, _ *= O, I = I * (w = Math.cos(e1)) - (L = L * w + I * x + C * _ - P * b) * x - (C = C * w + I * b + P * x - L * _) * b - (P = P * w + I * _ + L * b - C * x) * _;
                                            }
                                            var z = c(L, C, P, I);
                                            z > 1e-6 ? (L /= z, C /= z, P /= z, I /= z) : (L = C = P = 0, I = 1), this.rotation.set(t1, L, C, P, I);
                                        }, h.lookAt = function(t1, e1, r, n) {
                                            this.recalcMatrix(t1), r = r || this.computedCenter, e1 = e1 || this.computedEye, n = n || this.computedUp;
                                            var a = this.computedMatrix;
                                            i(a, e1, r, n);
                                            var o = this.computedRotation;
                                            s(o, a[0], a[1], a[2], a[4], a[5], a[6], a[8], a[9], a[10]), u(o, o), this.rotation.set(t1, o[0], o[1], o[2], o[3]);
                                            for(var l = 0, c = 0; c < 3; ++c)l += Math.pow(r[c] - e1[c], 2);
                                            this.radius.set(t1, .5 * Math.log(Math.max(l, 1e-6))), this.center.set(t1, r[0], r[1], r[2]);
                                        }, h.translate = function(t1, e1, r, n) {
                                            this.center.move(t1, e1 || 0, r || 0, n || 0);
                                        }, h.setMatrix = function(t1, e1) {
                                            var r = this.computedRotation;
                                            s(r, e1[0], e1[1], e1[2], e1[4], e1[5], e1[6], e1[8], e1[9], e1[10]), u(r, r), this.rotation.set(t1, r[0], r[1], r[2], r[3]);
                                            var n = this.computedMatrix;
                                            o(n, e1);
                                            var i = n[15];
                                            if (Math.abs(i) > 1e-6) {
                                                var a = n[12] / i, l = n[13] / i, c = n[14] / i;
                                                this.recalcMatrix(t1);
                                                var f = Math.exp(this.computedRadius[0]);
                                                this.center.set(t1, a - n[2] * f, l - n[6] * f, c - n[10] * f), this.radius.idle(t1);
                                            } else this.center.idle(t1), this.radius.idle(t1);
                                        }, h.setDistance = function(t1, e1) {
                                            e1 > 0 && this.radius.set(t1, Math.log(e1));
                                        }, h.setDistanceLimits = function(t1, e1) {
                                            t1 = t1 > 0 ? Math.log(t1) : -1 / 0, e1 = e1 > 0 ? Math.log(e1) : 1 / 0, e1 = Math.max(e1, t1), this.radius.bounds[0][0] = t1, this.radius.bounds[1][0] = e1;
                                        }, h.getDistanceLimits = function(t1) {
                                            var e1 = this.radius.bounds;
                                            return t1 ? (t1[0] = Math.exp(e1[0][0]), t1[1] = Math.exp(e1[1][0]), t1) : [
                                                Math.exp(e1[0][0]),
                                                Math.exp(e1[1][0])
                                            ];
                                        }, h.toJSON = function() {
                                            return this.recalcMatrix(this.lastT()), {
                                                center: this.computedCenter.slice(),
                                                rotation: this.computedRotation.slice(),
                                                distance: Math.log(this.computedRadius[0]),
                                                zoomMin: this.radius.bounds[0][0],
                                                zoomMax: this.radius.bounds[1][0]
                                            };
                                        }, h.fromJSON = function(t1) {
                                            var e1 = this.lastT(), r = t1.center;
                                            r && this.center.set(e1, r[0], r[1], r[2]);
                                            var n = t1.rotation;
                                            n && this.rotation.set(e1, n[0], n[1], n[2], n[3]);
                                            var i = t1.distance;
                                            i && i > 0 && this.radius.set(e1, Math.log(i)), this.setDistanceLimits(t1.zoomMin, t1.zoomMax);
                                        };
                                    },
                                    {
                                        "./lib/quatFromFrame": 262,
                                        "filtered-vector": 68,
                                        "gl-mat4/fromQuat": 95,
                                        "gl-mat4/invert": 98,
                                        "gl-mat4/lookAt": 99
                                    }
                                ],
                                264: [
                                    function(t1, e1, r) {
                                        /*!
 * pad-left <https://github.com/jonschlinkert/pad-left>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT license.
 */ "use strict";
                                        var n = t1("repeat-string");
                                        e1.exports = function(t1, e1, r) {
                                            return n(r = void 0 !== r ? r + "" : " ", e1) + t1;
                                        };
                                    },
                                    {
                                        "repeat-string": 277
                                    }
                                ],
                                265: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            e1 || (e1 = [
                                                0,
                                                ""
                                            ]), t1 = String(t1);
                                            var r = parseFloat(t1, 10);
                                            return e1[0] = r, e1[1] = t1.match(/[\d.\-\+]*\s*(.*)/)[1] || "", e1;
                                        };
                                    },
                                    {}
                                ],
                                266: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            for(var r = 0 | e1.length, i = t1.length, a = [
                                                new Array(r),
                                                new Array(r)
                                            ], o = 0; o < r; ++o)a[0][o] = [], a[1][o] = [];
                                            for(o = 0; o < i; ++o){
                                                var s = t1[o];
                                                a[0][s[0]].push(s), a[1][s[1]].push(s);
                                            }
                                            var l = [];
                                            for(o = 0; o < r; ++o)a[0][o].length + a[1][o].length === 0 && l.push([
                                                o
                                            ]);
                                            function c(t1, e1) {
                                                var r = a[e1][t1[e1]];
                                                r.splice(r.indexOf(t1), 1);
                                            }
                                            function u(t1, r, i) {
                                                for(var o, s, l, u = 0; u < 2; ++u)if (a[u][r].length > 0) {
                                                    o = a[u][r][0], l = u;
                                                    break;
                                                }
                                                s = o[1 ^ l];
                                                for(var f = 0; f < 2; ++f)for(var h = a[f][r], p = 0; p < h.length; ++p){
                                                    var d = h[p], m = d[1 ^ f];
                                                    n(e1[t1], e1[r], e1[s], e1[m]) > 0 && (o = d, s = m, l = f);
                                                }
                                                return i || o && c(o, l), s;
                                            }
                                            function f(t1, r) {
                                                var i = a[r][t1][0], o = [
                                                    t1
                                                ];
                                                c(i, r);
                                                for(var s = i[1 ^ r];;){
                                                    for(; s !== t1;)o.push(s), s = u(o[o.length - 2], s, !1);
                                                    if (a[0][t1].length + a[1][t1].length === 0) break;
                                                    var l = o[o.length - 1], f = t1, h = o[1], p = u(l, f, !0);
                                                    if (n(e1[l], e1[f], e1[h], e1[p]) < 0) break;
                                                    o.push(t1), s = u(l, f);
                                                }
                                                return o;
                                            }
                                            function h(t1, e1) {
                                                return e1[1] === e1[e1.length - 1];
                                            }
                                            for(o = 0; o < r; ++o)for(var p = 0; p < 2; ++p){
                                                for(var d = []; a[p][o].length > 0;){
                                                    a[0][o].length;
                                                    var m = f(o, p);
                                                    h(0, m) ? d.push.apply(d, m) : (d.length > 0 && l.push(d), d = m);
                                                }
                                                d.length > 0 && l.push(d);
                                            }
                                            return l;
                                        };
                                        var n = t1("compare-angle");
                                    },
                                    {
                                        "compare-angle": 54
                                    }
                                ],
                                267: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            for(var r = n(t1, e1.length), i = new Array(e1.length), a = new Array(e1.length), o = [], s = 0; s < e1.length; ++s){
                                                var l = r[s].length;
                                                a[s] = l, i[s] = !0, l <= 1 && o.push(s);
                                            }
                                            for(; o.length > 0;){
                                                var c = o.pop();
                                                i[c] = !1;
                                                var u = r[c];
                                                for(s = 0; s < u.length; ++s){
                                                    var f = u[s];
                                                    0 == --a[f] && o.push(f);
                                                }
                                            }
                                            var h = new Array(e1.length), p = [];
                                            for(s = 0; s < e1.length; ++s)if (i[s]) {
                                                c = p.length;
                                                h[s] = c, p.push(e1[s]);
                                            } else h[s] = -1;
                                            var d = [];
                                            for(s = 0; s < t1.length; ++s){
                                                var m = t1[s];
                                                i[m[0]] && i[m[1]] && d.push([
                                                    h[m[0]],
                                                    h[m[1]]
                                                ]);
                                            }
                                            return [
                                                d,
                                                p
                                            ];
                                        };
                                        var n = t1("edges-to-adjacency-list");
                                    },
                                    {
                                        "edges-to-adjacency-list": 66
                                    }
                                ],
                                268: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            var r = c(t1, e1);
                                            t1 = r[0];
                                            for(var f = (e1 = r[1]).length, h = (t1.length, n(t1, e1.length)), p = 0; p < f; ++p)if (h[p].length % 2 == 1) throw new Error("planar-graph-to-polyline: graph must be manifold");
                                            var d = i(t1, e1);
                                            var m = (d = d.filter(function(t1) {
                                                for(var r = t1.length, n = [
                                                    0
                                                ], i = 0; i < r; ++i){
                                                    var a = e1[t1[i]], l = e1[t1[(i + 1) % r]], c = o(-a[0], a[1]), u = o(-a[0], l[1]), f = o(l[0], a[1]), h = o(l[0], l[1]);
                                                    n = s(n, s(s(c, u), s(f, h)));
                                                }
                                                return n[n.length - 1] > 0;
                                            })).length, g = new Array(m), v = new Array(m);
                                            for(p = 0; p < m; ++p){
                                                g[p] = p;
                                                var y = new Array(m), x = d[p].map(function(t1) {
                                                    return e1[t1];
                                                }), b = a([
                                                    x
                                                ]), _ = 0;
                                                t: for(var w = 0; w < m; ++w)if (y[w] = 0, p !== w) {
                                                    for(var T = (H = d[w]).length, k = 0; k < T; ++k){
                                                        var A = b(e1[H[k]]);
                                                        if (0 !== A) {
                                                            A < 0 && (y[w] = 1, _ += 1);
                                                            continue t;
                                                        }
                                                    }
                                                    y[w] = 1, _ += 1;
                                                }
                                                v[p] = [
                                                    _,
                                                    p,
                                                    y
                                                ];
                                            }
                                            v.sort(function(t1, e1) {
                                                return e1[0] - t1[0];
                                            });
                                            for(p = 0; p < m; ++p){
                                                var M = (y = v[p])[1], S = y[2];
                                                for(w = 0; w < m; ++w)S[w] && (g[w] = M);
                                            }
                                            var E = function(t1) {
                                                for(var e1 = new Array(t1), r = 0; r < t1; ++r)e1[r] = [];
                                                return e1;
                                            }(m);
                                            for(p = 0; p < m; ++p)E[p].push(g[p]), E[g[p]].push(p);
                                            var L = {}, C = u(f, !1);
                                            for(p = 0; p < m; ++p)for(T = (H = d[p]).length, w = 0; w < T; ++w){
                                                var P = H[w], I = H[(w + 1) % T], O = Math.min(P, I) + ":" + Math.max(P, I);
                                                if (O in L) {
                                                    var z = L[O];
                                                    E[z].push(p), E[p].push(z), C[P] = C[I] = !0;
                                                } else L[O] = p;
                                            }
                                            function D(t1) {
                                                for(var e1 = t1.length, r = 0; r < e1; ++r)if (!C[t1[r]]) return !1;
                                                return !0;
                                            }
                                            var R = [], F = u(m, -1);
                                            for(p = 0; p < m; ++p)g[p] !== p || D(d[p]) ? F[p] = -1 : (R.push(p), F[p] = 0);
                                            r = [];
                                            for(; R.length > 0;){
                                                var B = R.pop(), N = E[B];
                                                l(N, function(t1, e1) {
                                                    return t1 - e1;
                                                });
                                                var j, U = N.length, V = F[B];
                                                if (0 === V) {
                                                    var H = d[B];
                                                    j = [
                                                        H
                                                    ];
                                                }
                                                for(p = 0; p < U; ++p){
                                                    var q = N[p];
                                                    if (!(F[q] >= 0)) {
                                                        if (F[q] = 1 ^ V, R.push(q), 0 === V) D(H = d[q]) || (H.reverse(), j.push(H));
                                                    }
                                                }
                                                0 === V && r.push(j);
                                            }
                                            return r;
                                        };
                                        var n = t1("edges-to-adjacency-list"), i = t1("planar-dual"), a = t1("point-in-big-polygon"), o = t1("two-product"), s = t1("robust-sum"), l = t1("uniq"), c = t1("./lib/trim-leaves");
                                        function u(t1, e1) {
                                            for(var r = new Array(t1), n = 0; n < t1; ++n)r[n] = e1;
                                            return r;
                                        }
                                    },
                                    {
                                        "./lib/trim-leaves": 267,
                                        "edges-to-adjacency-list": 66,
                                        "planar-dual": 266,
                                        "point-in-big-polygon": 269,
                                        "robust-sum": 289,
                                        "two-product": 306,
                                        uniq: 310
                                    }
                                ],
                                269: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1) {
                                            for(var e1 = t1.length, r = [], a = [], s = 0; s < e1; ++s)for(var u = t1[s], f = u.length, h = f - 1, p = 0; p < f; h = p++){
                                                var d = u[h], m = u[p];
                                                d[0] === m[0] ? a.push([
                                                    d,
                                                    m
                                                ]) : r.push([
                                                    d,
                                                    m
                                                ]);
                                            }
                                            if (0 === r.length) return 0 === a.length ? c : (g = l(a), function(t1) {
                                                return g(t1[0], t1[1]) ? 0 : 1;
                                            });
                                            var g;
                                            var v = i(r), y = function(t1, e1) {
                                                return function(r) {
                                                    var i = o.le(e1, r[0]);
                                                    if (i < 0) return 1;
                                                    var a = t1[i];
                                                    if (!a) {
                                                        if (!(i > 0 && e1[i] === r[0])) return 1;
                                                        a = t1[i - 1];
                                                    }
                                                    for(var s = 1; a;){
                                                        var l = a.key, c = n(r, l[0], l[1]);
                                                        if (l[0][0] < l[1][0]) {
                                                            if (c < 0) a = a.left;
                                                            else {
                                                                if (!(c > 0)) return 0;
                                                                s = -1, a = a.right;
                                                            }
                                                        } else if (c > 0) a = a.left;
                                                        else {
                                                            if (!(c < 0)) return 0;
                                                            s = 1, a = a.right;
                                                        }
                                                    }
                                                    return s;
                                                };
                                            }(v.slabs, v.coordinates);
                                            return 0 === a.length ? y : function(t1, e1) {
                                                return function(r) {
                                                    return t1(r[0], r[1]) ? 0 : e1(r);
                                                };
                                            }(l(a), y);
                                        };
                                        var n = t1("robust-orientation")[3], i = t1("slab-decomposition"), a = t1("interval-tree-1d"), o = t1("binary-search-bounds");
                                        function s() {
                                            return !0;
                                        }
                                        function l(t1) {
                                            for(var e1 = {}, r = 0; r < t1.length; ++r){
                                                var n = t1[r], i = n[0][0], o = n[0][1], l = n[1][1], c = [
                                                    Math.min(o, l),
                                                    Math.max(o, l)
                                                ];
                                                i in e1 ? e1[i].push(c) : e1[i] = [
                                                    c
                                                ];
                                            }
                                            var u = {}, f = Object.keys(e1);
                                            for(r = 0; r < f.length; ++r){
                                                var h = e1[f[r]];
                                                u[f[r]] = a(h);
                                            }
                                            return function(t1) {
                                                return function(e1, r) {
                                                    var n = t1[e1];
                                                    return !!n && !!n.queryPoint(r, s);
                                                };
                                            }(u);
                                        }
                                        function c(t1) {
                                            return 1;
                                        }
                                    },
                                    {
                                        "binary-search-bounds": 31,
                                        "interval-tree-1d": 234,
                                        "robust-orientation": 284,
                                        "slab-decomposition": 299
                                    }
                                ],
                                270: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = new Float64Array(4), i = new Float64Array(4), a = new Float64Array(4);
                                        e1.exports = function(t1, e1, r, o, s) {
                                            n.length < o.length && (n = new Float64Array(o.length), i = new Float64Array(o.length), a = new Float64Array(o.length));
                                            for(var l = 0; l < o.length; ++l)n[l] = t1[l] - o[l], i[l] = e1[l] - t1[l], a[l] = r[l] - t1[l];
                                            var c = 0, u = 0, f = 0, h = 0, p = 0, d = 0;
                                            for(l = 0; l < o.length; ++l){
                                                var m = i[l], g = a[l], v = n[l];
                                                c += m * m, u += m * g, f += g * g, h += v * m, p += v * g, d += v * v;
                                            }
                                            var y, x, b, _, w, T = Math.abs(c * f - u * u), k = u * p - f * h, A = u * h - c * p;
                                            if (k + A <= T) {
                                                if (k < 0) A < 0 && h < 0 ? (A = 0, -h >= c ? (k = 1, y = c + 2 * h + d) : y = h * (k = -h / c) + d) : (k = 0, p >= 0 ? (A = 0, y = d) : -p >= f ? (A = 1, y = f + 2 * p + d) : y = p * (A = -p / f) + d);
                                                else if (A < 0) A = 0, h >= 0 ? (k = 0, y = d) : -h >= c ? (k = 1, y = c + 2 * h + d) : y = h * (k = -h / c) + d;
                                                else {
                                                    var M = 1 / T;
                                                    y = (k *= M) * (c * k + u * (A *= M) + 2 * h) + A * (u * k + f * A + 2 * p) + d;
                                                }
                                            } else k < 0 ? (b = f + p) > (x = u + h) ? (_ = b - x) >= (w = c - 2 * u + f) ? (k = 1, A = 0, y = c + 2 * h + d) : y = (k = _ / w) * (c * k + u * (A = 1 - k) + 2 * h) + A * (u * k + f * A + 2 * p) + d : (k = 0, b <= 0 ? (A = 1, y = f + 2 * p + d) : p >= 0 ? (A = 0, y = d) : y = p * (A = -p / f) + d) : A < 0 ? (b = c + h) > (x = u + p) ? (_ = b - x) >= (w = c - 2 * u + f) ? (A = 1, k = 0, y = f + 2 * p + d) : y = (k = 1 - (A = _ / w)) * (c * k + u * A + 2 * h) + A * (u * k + f * A + 2 * p) + d : (A = 0, b <= 0 ? (k = 1, y = c + 2 * h + d) : h >= 0 ? (k = 0, y = d) : y = h * (k = -h / c) + d) : (_ = f + p - u - h) <= 0 ? (k = 0, A = 1, y = f + 2 * p + d) : _ >= (w = c - 2 * u + f) ? (k = 1, A = 0, y = c + 2 * h + d) : y = (k = _ / w) * (c * k + u * (A = 1 - k) + 2 * h) + A * (u * k + f * A + 2 * p) + d;
                                            var S = 1 - k - A;
                                            for(l = 0; l < o.length; ++l)s[l] = S * t1[l] + k * e1[l] + A * r[l];
                                            return y < 0 ? 0 : y;
                                        };
                                    },
                                    {}
                                ],
                                271: [
                                    function(t1, e1, r) {
                                        e1.exports = t1("gl-quat/slerp");
                                    },
                                    {
                                        "gl-quat/slerp": 124
                                    }
                                ],
                                272: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("big-rat/add");
                                        e1.exports = function(t1, e1) {
                                            for(var r = t1.length, i = new Array(r), a = 0; a < r; ++a)i[a] = n(t1[a], e1[a]);
                                            return i;
                                        };
                                    },
                                    {
                                        "big-rat/add": 15
                                    }
                                ],
                                273: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            for(var e1 = new Array(t1.length), r = 0; r < t1.length; ++r)e1[r] = n(t1[r]);
                                            return e1;
                                        };
                                        var n = t1("big-rat");
                                    },
                                    {
                                        "big-rat": 18
                                    }
                                ],
                                274: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("big-rat"), i = t1("big-rat/mul");
                                        e1.exports = function(t1, e1) {
                                            for(var r = n(e1), a = t1.length, o = new Array(a), s = 0; s < a; ++s)o[s] = i(t1[s], r);
                                            return o;
                                        };
                                    },
                                    {
                                        "big-rat": 18,
                                        "big-rat/mul": 27
                                    }
                                ],
                                275: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("big-rat/sub");
                                        e1.exports = function(t1, e1) {
                                            for(var r = t1.length, i = new Array(r), a = 0; a < r; ++a)i[a] = n(t1[a], e1[a]);
                                            return i;
                                        };
                                    },
                                    {
                                        "big-rat/sub": 29
                                    }
                                ],
                                276: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("compare-cell"), i = t1("compare-oriented-cell"), a = t1("cell-orientation");
                                        e1.exports = function(t1) {
                                            t1.sort(i);
                                            for(var e1 = t1.length, r = 0, o = 0; o < e1; ++o){
                                                var s = t1[o], l = a(s);
                                                if (0 !== l) {
                                                    if (r > 0) {
                                                        var c = t1[r - 1];
                                                        if (0 === n(s, c) && a(c) !== l) {
                                                            r -= 1;
                                                            continue;
                                                        }
                                                    }
                                                    t1[r++] = s;
                                                }
                                            }
                                            return t1.length = r, t1;
                                        };
                                    },
                                    {
                                        "cell-orientation": 47,
                                        "compare-cell": 56,
                                        "compare-oriented-cell": 57
                                    }
                                ],
                                277: [
                                    function(t1, e1, r) {
                                        /*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ "use strict";
                                        var n, i = "";
                                        e1.exports = function(t1, e1) {
                                            if ("string" != typeof t1) throw new TypeError("expected a string");
                                            if (1 === e1) return t1;
                                            if (2 === e1) return t1 + t1;
                                            var r = t1.length * e1;
                                            if (n !== t1 || void 0 === n) n = t1, i = "";
                                            else if (i.length >= r) return i.substr(0, r);
                                            for(; r > i.length && e1 > 1;)1 & e1 && (i += t1), e1 >>= 1, t1 += t1;
                                            return i = (i += t1).substr(0, r);
                                        };
                                    },
                                    {}
                                ],
                                278: [
                                    function(t1, e1, r) {
                                        (function(t1) {
                                            (function() {
                                                e1.exports = t1.performance && t1.performance.now ? function() {
                                                    return performance.now();
                                                } : Date.now || function() {
                                                    return +new Date;
                                                };
                                            }).call(this);
                                        }).call(this, void 0 !== n ? n : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ],
                                279: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            for(var e1 = t1.length, r = t1[t1.length - 1], n = e1, i = e1 - 2; i >= 0; --i){
                                                var a = r, o = t1[i];
                                                (l = o - ((r = a + o) - a)) && (t1[--n] = r, r = l);
                                            }
                                            var s = 0;
                                            for(i = n; i < e1; ++i){
                                                var l;
                                                a = t1[i];
                                                (l = (o = r) - ((r = a + o) - a)) && (t1[s++] = l);
                                            }
                                            return t1[s++] = r, t1.length = s, t1;
                                        };
                                    },
                                    {}
                                ],
                                280: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("two-product"), i = t1("robust-sum"), a = t1("robust-scale"), o = t1("robust-compress");
                                        function s(t1, e1, r, n) {
                                            return function(e1) {
                                                return n(t1(r(e1[0][0], e1[1][1]), r(-e1[0][1], e1[1][0])));
                                            };
                                        }
                                        function l(t1, e1, r, n) {
                                            return function(i) {
                                                return n(t1(e1(t1(r(i[1][1], i[2][2]), r(-i[1][2], i[2][1])), i[0][0]), t1(e1(t1(r(i[1][0], i[2][2]), r(-i[1][2], i[2][0])), -i[0][1]), e1(t1(r(i[1][0], i[2][1]), r(-i[1][1], i[2][0])), i[0][2]))));
                                            };
                                        }
                                        function c(t1) {
                                            return (2 === t1 ? s : 3 === t1 ? l : void 0)(i, a, n, o);
                                        }
                                        var u = [
                                            function() {
                                                return [
                                                    0
                                                ];
                                            },
                                            function(t1) {
                                                return [
                                                    t1[0][0]
                                                ];
                                            }
                                        ];
                                        function f(t1, e1, r, n, i, a) {
                                            return function(o) {
                                                switch(o.length){
                                                    case 0:
                                                        return t1(o);
                                                    case 1:
                                                        return e1(o);
                                                    case 2:
                                                        return r(o);
                                                    case 3:
                                                        return n(o);
                                                }
                                                var s = i[o.length];
                                                return s || (s = i[o.length] = a(o.length)), s(o);
                                            };
                                        }
                                        !function() {
                                            for(; u.length < 4;)u.push(c(u.length));
                                            e1.exports = f.apply(void 0, u.concat([
                                                u,
                                                c
                                            ]));
                                            for(var t1 = 0; t1 < u.length; ++t1)e1.exports[t1] = u[t1];
                                        }();
                                    },
                                    {
                                        "robust-compress": 279,
                                        "robust-scale": 286,
                                        "robust-sum": 289,
                                        "two-product": 306
                                    }
                                ],
                                281: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("two-product"), i = t1("robust-sum");
                                        e1.exports = function(t1, e1) {
                                            for(var r = n(t1[0], e1[0]), a = 1; a < t1.length; ++a)r = i(r, n(t1[a], e1[a]));
                                            return r;
                                        };
                                    },
                                    {
                                        "robust-sum": 289,
                                        "two-product": 306
                                    }
                                ],
                                282: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("two-product"), i = t1("robust-sum"), a = t1("robust-subtract"), o = t1("robust-scale");
                                        function s(t1) {
                                            return (3 === t1 ? l : 4 === t1 ? c : 5 === t1 ? u : f)(i, a, n, o);
                                        }
                                        function l(t1, e1, r, n) {
                                            return function(i, a, o) {
                                                var s = r(i[0], i[0]), l = n(s, a[0]), c = n(s, o[0]), u = r(a[0], a[0]), f = n(u, i[0]), h = n(u, o[0]), p = r(o[0], o[0]), d = n(p, i[0]), m = n(p, a[0]), g = t1(e1(m, h), e1(f, l)), v = e1(d, c), y = e1(g, v);
                                                return y[y.length - 1];
                                            };
                                        }
                                        function c(t1, e1, r, n) {
                                            return function(i, a, o, s) {
                                                var l = t1(r(i[0], i[0]), r(i[1], i[1])), c = n(l, a[0]), u = n(l, o[0]), f = n(l, s[0]), h = t1(r(a[0], a[0]), r(a[1], a[1])), p = n(h, i[0]), d = n(h, o[0]), m = n(h, s[0]), g = t1(r(o[0], o[0]), r(o[1], o[1])), v = n(g, i[0]), y = n(g, a[0]), x = n(g, s[0]), b = t1(r(s[0], s[0]), r(s[1], s[1])), _ = n(b, i[0]), w = n(b, a[0]), T = n(b, o[0]), k = t1(t1(n(e1(T, x), a[1]), t1(n(e1(w, m), -o[1]), n(e1(y, d), s[1]))), t1(n(e1(w, m), i[1]), t1(n(e1(_, f), -a[1]), n(e1(p, c), s[1])))), A = t1(t1(n(e1(T, x), i[1]), t1(n(e1(_, f), -o[1]), n(e1(v, u), s[1]))), t1(n(e1(y, d), i[1]), t1(n(e1(v, u), -a[1]), n(e1(p, c), o[1])))), M = e1(k, A);
                                                return M[M.length - 1];
                                            };
                                        }
                                        function u(t1, e1, r, n) {
                                            return function(i, a, o, s, l) {
                                                var c = t1(r(i[0], i[0]), t1(r(i[1], i[1]), r(i[2], i[2]))), u = n(c, a[0]), f = n(c, o[0]), h = n(c, s[0]), p = n(c, l[0]), d = t1(r(a[0], a[0]), t1(r(a[1], a[1]), r(a[2], a[2]))), m = n(d, i[0]), g = n(d, o[0]), v = n(d, s[0]), y = n(d, l[0]), x = t1(r(o[0], o[0]), t1(r(o[1], o[1]), r(o[2], o[2]))), b = n(x, i[0]), _ = n(x, a[0]), w = n(x, s[0]), T = n(x, l[0]), k = t1(r(s[0], s[0]), t1(r(s[1], s[1]), r(s[2], s[2]))), A = n(k, i[0]), M = n(k, a[0]), S = n(k, o[0]), E = n(k, l[0]), L = t1(r(l[0], l[0]), t1(r(l[1], l[1]), r(l[2], l[2]))), C = n(L, i[0]), P = n(L, a[0]), I = n(L, o[0]), O = n(L, s[0]), z = t1(t1(t1(n(t1(n(e1(O, E), o[1]), t1(n(e1(I, T), -s[1]), n(e1(S, w), l[1]))), a[2]), t1(n(t1(n(e1(O, E), a[1]), t1(n(e1(P, y), -s[1]), n(e1(M, v), l[1]))), -o[2]), n(t1(n(e1(I, T), a[1]), t1(n(e1(P, y), -o[1]), n(e1(_, g), l[1]))), s[2]))), t1(n(t1(n(e1(S, w), a[1]), t1(n(e1(M, v), -o[1]), n(e1(_, g), s[1]))), -l[2]), t1(n(t1(n(e1(O, E), a[1]), t1(n(e1(P, y), -s[1]), n(e1(M, v), l[1]))), i[2]), n(t1(n(e1(O, E), i[1]), t1(n(e1(C, p), -s[1]), n(e1(A, h), l[1]))), -a[2])))), t1(t1(n(t1(n(e1(P, y), i[1]), t1(n(e1(C, p), -a[1]), n(e1(m, u), l[1]))), s[2]), t1(n(t1(n(e1(M, v), i[1]), t1(n(e1(A, h), -a[1]), n(e1(m, u), s[1]))), -l[2]), n(t1(n(e1(S, w), a[1]), t1(n(e1(M, v), -o[1]), n(e1(_, g), s[1]))), i[2]))), t1(n(t1(n(e1(S, w), i[1]), t1(n(e1(A, h), -o[1]), n(e1(b, f), s[1]))), -a[2]), t1(n(t1(n(e1(M, v), i[1]), t1(n(e1(A, h), -a[1]), n(e1(m, u), s[1]))), o[2]), n(t1(n(e1(_, g), i[1]), t1(n(e1(b, f), -a[1]), n(e1(m, u), o[1]))), -s[2]))))), D = t1(t1(t1(n(t1(n(e1(O, E), o[1]), t1(n(e1(I, T), -s[1]), n(e1(S, w), l[1]))), i[2]), n(t1(n(e1(O, E), i[1]), t1(n(e1(C, p), -s[1]), n(e1(A, h), l[1]))), -o[2])), t1(n(t1(n(e1(I, T), i[1]), t1(n(e1(C, p), -o[1]), n(e1(b, f), l[1]))), s[2]), n(t1(n(e1(S, w), i[1]), t1(n(e1(A, h), -o[1]), n(e1(b, f), s[1]))), -l[2]))), t1(t1(n(t1(n(e1(I, T), a[1]), t1(n(e1(P, y), -o[1]), n(e1(_, g), l[1]))), i[2]), n(t1(n(e1(I, T), i[1]), t1(n(e1(C, p), -o[1]), n(e1(b, f), l[1]))), -a[2])), t1(n(t1(n(e1(P, y), i[1]), t1(n(e1(C, p), -a[1]), n(e1(m, u), l[1]))), o[2]), n(t1(n(e1(_, g), i[1]), t1(n(e1(b, f), -a[1]), n(e1(m, u), o[1]))), -l[2])))), R = e1(z, D);
                                                return R[R.length - 1];
                                            };
                                        }
                                        function f(t1, e1, r, n) {
                                            return function(i, a, o, s, l, c) {
                                                var u = t1(t1(r(i[0], i[0]), r(i[1], i[1])), t1(r(i[2], i[2]), r(i[3], i[3]))), f = n(u, a[0]), h = n(u, o[0]), p = n(u, s[0]), d = n(u, l[0]), m = n(u, c[0]), g = t1(t1(r(a[0], a[0]), r(a[1], a[1])), t1(r(a[2], a[2]), r(a[3], a[3]))), v = n(g, i[0]), y = n(g, o[0]), x = n(g, s[0]), b = n(g, l[0]), _ = n(g, c[0]), w = t1(t1(r(o[0], o[0]), r(o[1], o[1])), t1(r(o[2], o[2]), r(o[3], o[3]))), T = n(w, i[0]), k = n(w, a[0]), A = n(w, s[0]), M = n(w, l[0]), S = n(w, c[0]), E = t1(t1(r(s[0], s[0]), r(s[1], s[1])), t1(r(s[2], s[2]), r(s[3], s[3]))), L = n(E, i[0]), C = n(E, a[0]), P = n(E, o[0]), I = n(E, l[0]), O = n(E, c[0]), z = t1(t1(r(l[0], l[0]), r(l[1], l[1])), t1(r(l[2], l[2]), r(l[3], l[3]))), D = n(z, i[0]), R = n(z, a[0]), F = n(z, o[0]), B = n(z, s[0]), N = n(z, c[0]), j = t1(t1(r(c[0], c[0]), r(c[1], c[1])), t1(r(c[2], c[2]), r(c[3], c[3]))), U = n(j, i[0]), V = n(j, a[0]), H = n(j, o[0]), q = n(j, s[0]), G = n(j, l[0]), Y = t1(t1(t1(n(t1(t1(n(t1(n(e1(G, N), s[1]), t1(n(e1(q, O), -l[1]), n(e1(B, I), c[1]))), o[2]), n(t1(n(e1(G, N), o[1]), t1(n(e1(H, S), -l[1]), n(e1(F, M), c[1]))), -s[2])), t1(n(t1(n(e1(q, O), o[1]), t1(n(e1(H, S), -s[1]), n(e1(P, A), c[1]))), l[2]), n(t1(n(e1(B, I), o[1]), t1(n(e1(F, M), -s[1]), n(e1(P, A), l[1]))), -c[2]))), a[3]), t1(n(t1(t1(n(t1(n(e1(G, N), s[1]), t1(n(e1(q, O), -l[1]), n(e1(B, I), c[1]))), a[2]), n(t1(n(e1(G, N), a[1]), t1(n(e1(V, _), -l[1]), n(e1(R, b), c[1]))), -s[2])), t1(n(t1(n(e1(q, O), a[1]), t1(n(e1(V, _), -s[1]), n(e1(C, x), c[1]))), l[2]), n(t1(n(e1(B, I), a[1]), t1(n(e1(R, b), -s[1]), n(e1(C, x), l[1]))), -c[2]))), -o[3]), n(t1(t1(n(t1(n(e1(G, N), o[1]), t1(n(e1(H, S), -l[1]), n(e1(F, M), c[1]))), a[2]), n(t1(n(e1(G, N), a[1]), t1(n(e1(V, _), -l[1]), n(e1(R, b), c[1]))), -o[2])), t1(n(t1(n(e1(H, S), a[1]), t1(n(e1(V, _), -o[1]), n(e1(k, y), c[1]))), l[2]), n(t1(n(e1(F, M), a[1]), t1(n(e1(R, b), -o[1]), n(e1(k, y), l[1]))), -c[2]))), s[3]))), t1(t1(n(t1(t1(n(t1(n(e1(q, O), o[1]), t1(n(e1(H, S), -s[1]), n(e1(P, A), c[1]))), a[2]), n(t1(n(e1(q, O), a[1]), t1(n(e1(V, _), -s[1]), n(e1(C, x), c[1]))), -o[2])), t1(n(t1(n(e1(H, S), a[1]), t1(n(e1(V, _), -o[1]), n(e1(k, y), c[1]))), s[2]), n(t1(n(e1(P, A), a[1]), t1(n(e1(C, x), -o[1]), n(e1(k, y), s[1]))), -c[2]))), -l[3]), n(t1(t1(n(t1(n(e1(B, I), o[1]), t1(n(e1(F, M), -s[1]), n(e1(P, A), l[1]))), a[2]), n(t1(n(e1(B, I), a[1]), t1(n(e1(R, b), -s[1]), n(e1(C, x), l[1]))), -o[2])), t1(n(t1(n(e1(F, M), a[1]), t1(n(e1(R, b), -o[1]), n(e1(k, y), l[1]))), s[2]), n(t1(n(e1(P, A), a[1]), t1(n(e1(C, x), -o[1]), n(e1(k, y), s[1]))), -l[2]))), c[3])), t1(n(t1(t1(n(t1(n(e1(G, N), s[1]), t1(n(e1(q, O), -l[1]), n(e1(B, I), c[1]))), a[2]), n(t1(n(e1(G, N), a[1]), t1(n(e1(V, _), -l[1]), n(e1(R, b), c[1]))), -s[2])), t1(n(t1(n(e1(q, O), a[1]), t1(n(e1(V, _), -s[1]), n(e1(C, x), c[1]))), l[2]), n(t1(n(e1(B, I), a[1]), t1(n(e1(R, b), -s[1]), n(e1(C, x), l[1]))), -c[2]))), i[3]), n(t1(t1(n(t1(n(e1(G, N), s[1]), t1(n(e1(q, O), -l[1]), n(e1(B, I), c[1]))), i[2]), n(t1(n(e1(G, N), i[1]), t1(n(e1(U, m), -l[1]), n(e1(D, d), c[1]))), -s[2])), t1(n(t1(n(e1(q, O), i[1]), t1(n(e1(U, m), -s[1]), n(e1(L, p), c[1]))), l[2]), n(t1(n(e1(B, I), i[1]), t1(n(e1(D, d), -s[1]), n(e1(L, p), l[1]))), -c[2]))), -a[3])))), t1(t1(t1(n(t1(t1(n(t1(n(e1(G, N), a[1]), t1(n(e1(V, _), -l[1]), n(e1(R, b), c[1]))), i[2]), n(t1(n(e1(G, N), i[1]), t1(n(e1(U, m), -l[1]), n(e1(D, d), c[1]))), -a[2])), t1(n(t1(n(e1(V, _), i[1]), t1(n(e1(U, m), -a[1]), n(e1(v, f), c[1]))), l[2]), n(t1(n(e1(R, b), i[1]), t1(n(e1(D, d), -a[1]), n(e1(v, f), l[1]))), -c[2]))), s[3]), n(t1(t1(n(t1(n(e1(q, O), a[1]), t1(n(e1(V, _), -s[1]), n(e1(C, x), c[1]))), i[2]), n(t1(n(e1(q, O), i[1]), t1(n(e1(U, m), -s[1]), n(e1(L, p), c[1]))), -a[2])), t1(n(t1(n(e1(V, _), i[1]), t1(n(e1(U, m), -a[1]), n(e1(v, f), c[1]))), s[2]), n(t1(n(e1(C, x), i[1]), t1(n(e1(L, p), -a[1]), n(e1(v, f), s[1]))), -c[2]))), -l[3])), t1(n(t1(t1(n(t1(n(e1(B, I), a[1]), t1(n(e1(R, b), -s[1]), n(e1(C, x), l[1]))), i[2]), n(t1(n(e1(B, I), i[1]), t1(n(e1(D, d), -s[1]), n(e1(L, p), l[1]))), -a[2])), t1(n(t1(n(e1(R, b), i[1]), t1(n(e1(D, d), -a[1]), n(e1(v, f), l[1]))), s[2]), n(t1(n(e1(C, x), i[1]), t1(n(e1(L, p), -a[1]), n(e1(v, f), s[1]))), -l[2]))), c[3]), n(t1(t1(n(t1(n(e1(q, O), o[1]), t1(n(e1(H, S), -s[1]), n(e1(P, A), c[1]))), a[2]), n(t1(n(e1(q, O), a[1]), t1(n(e1(V, _), -s[1]), n(e1(C, x), c[1]))), -o[2])), t1(n(t1(n(e1(H, S), a[1]), t1(n(e1(V, _), -o[1]), n(e1(k, y), c[1]))), s[2]), n(t1(n(e1(P, A), a[1]), t1(n(e1(C, x), -o[1]), n(e1(k, y), s[1]))), -c[2]))), i[3]))), t1(t1(n(t1(t1(n(t1(n(e1(q, O), o[1]), t1(n(e1(H, S), -s[1]), n(e1(P, A), c[1]))), i[2]), n(t1(n(e1(q, O), i[1]), t1(n(e1(U, m), -s[1]), n(e1(L, p), c[1]))), -o[2])), t1(n(t1(n(e1(H, S), i[1]), t1(n(e1(U, m), -o[1]), n(e1(T, h), c[1]))), s[2]), n(t1(n(e1(P, A), i[1]), t1(n(e1(L, p), -o[1]), n(e1(T, h), s[1]))), -c[2]))), -a[3]), n(t1(t1(n(t1(n(e1(q, O), a[1]), t1(n(e1(V, _), -s[1]), n(e1(C, x), c[1]))), i[2]), n(t1(n(e1(q, O), i[1]), t1(n(e1(U, m), -s[1]), n(e1(L, p), c[1]))), -a[2])), t1(n(t1(n(e1(V, _), i[1]), t1(n(e1(U, m), -a[1]), n(e1(v, f), c[1]))), s[2]), n(t1(n(e1(C, x), i[1]), t1(n(e1(L, p), -a[1]), n(e1(v, f), s[1]))), -c[2]))), o[3])), t1(n(t1(t1(n(t1(n(e1(H, S), a[1]), t1(n(e1(V, _), -o[1]), n(e1(k, y), c[1]))), i[2]), n(t1(n(e1(H, S), i[1]), t1(n(e1(U, m), -o[1]), n(e1(T, h), c[1]))), -a[2])), t1(n(t1(n(e1(V, _), i[1]), t1(n(e1(U, m), -a[1]), n(e1(v, f), c[1]))), o[2]), n(t1(n(e1(k, y), i[1]), t1(n(e1(T, h), -a[1]), n(e1(v, f), o[1]))), -c[2]))), -s[3]), n(t1(t1(n(t1(n(e1(P, A), a[1]), t1(n(e1(C, x), -o[1]), n(e1(k, y), s[1]))), i[2]), n(t1(n(e1(P, A), i[1]), t1(n(e1(L, p), -o[1]), n(e1(T, h), s[1]))), -a[2])), t1(n(t1(n(e1(C, x), i[1]), t1(n(e1(L, p), -a[1]), n(e1(v, f), s[1]))), o[2]), n(t1(n(e1(k, y), i[1]), t1(n(e1(T, h), -a[1]), n(e1(v, f), o[1]))), -s[2]))), c[3]))))), W = t1(t1(t1(n(t1(t1(n(t1(n(e1(G, N), s[1]), t1(n(e1(q, O), -l[1]), n(e1(B, I), c[1]))), o[2]), n(t1(n(e1(G, N), o[1]), t1(n(e1(H, S), -l[1]), n(e1(F, M), c[1]))), -s[2])), t1(n(t1(n(e1(q, O), o[1]), t1(n(e1(H, S), -s[1]), n(e1(P, A), c[1]))), l[2]), n(t1(n(e1(B, I), o[1]), t1(n(e1(F, M), -s[1]), n(e1(P, A), l[1]))), -c[2]))), i[3]), t1(n(t1(t1(n(t1(n(e1(G, N), s[1]), t1(n(e1(q, O), -l[1]), n(e1(B, I), c[1]))), i[2]), n(t1(n(e1(G, N), i[1]), t1(n(e1(U, m), -l[1]), n(e1(D, d), c[1]))), -s[2])), t1(n(t1(n(e1(q, O), i[1]), t1(n(e1(U, m), -s[1]), n(e1(L, p), c[1]))), l[2]), n(t1(n(e1(B, I), i[1]), t1(n(e1(D, d), -s[1]), n(e1(L, p), l[1]))), -c[2]))), -o[3]), n(t1(t1(n(t1(n(e1(G, N), o[1]), t1(n(e1(H, S), -l[1]), n(e1(F, M), c[1]))), i[2]), n(t1(n(e1(G, N), i[1]), t1(n(e1(U, m), -l[1]), n(e1(D, d), c[1]))), -o[2])), t1(n(t1(n(e1(H, S), i[1]), t1(n(e1(U, m), -o[1]), n(e1(T, h), c[1]))), l[2]), n(t1(n(e1(F, M), i[1]), t1(n(e1(D, d), -o[1]), n(e1(T, h), l[1]))), -c[2]))), s[3]))), t1(t1(n(t1(t1(n(t1(n(e1(q, O), o[1]), t1(n(e1(H, S), -s[1]), n(e1(P, A), c[1]))), i[2]), n(t1(n(e1(q, O), i[1]), t1(n(e1(U, m), -s[1]), n(e1(L, p), c[1]))), -o[2])), t1(n(t1(n(e1(H, S), i[1]), t1(n(e1(U, m), -o[1]), n(e1(T, h), c[1]))), s[2]), n(t1(n(e1(P, A), i[1]), t1(n(e1(L, p), -o[1]), n(e1(T, h), s[1]))), -c[2]))), -l[3]), n(t1(t1(n(t1(n(e1(B, I), o[1]), t1(n(e1(F, M), -s[1]), n(e1(P, A), l[1]))), i[2]), n(t1(n(e1(B, I), i[1]), t1(n(e1(D, d), -s[1]), n(e1(L, p), l[1]))), -o[2])), t1(n(t1(n(e1(F, M), i[1]), t1(n(e1(D, d), -o[1]), n(e1(T, h), l[1]))), s[2]), n(t1(n(e1(P, A), i[1]), t1(n(e1(L, p), -o[1]), n(e1(T, h), s[1]))), -l[2]))), c[3])), t1(n(t1(t1(n(t1(n(e1(G, N), o[1]), t1(n(e1(H, S), -l[1]), n(e1(F, M), c[1]))), a[2]), n(t1(n(e1(G, N), a[1]), t1(n(e1(V, _), -l[1]), n(e1(R, b), c[1]))), -o[2])), t1(n(t1(n(e1(H, S), a[1]), t1(n(e1(V, _), -o[1]), n(e1(k, y), c[1]))), l[2]), n(t1(n(e1(F, M), a[1]), t1(n(e1(R, b), -o[1]), n(e1(k, y), l[1]))), -c[2]))), i[3]), n(t1(t1(n(t1(n(e1(G, N), o[1]), t1(n(e1(H, S), -l[1]), n(e1(F, M), c[1]))), i[2]), n(t1(n(e1(G, N), i[1]), t1(n(e1(U, m), -l[1]), n(e1(D, d), c[1]))), -o[2])), t1(n(t1(n(e1(H, S), i[1]), t1(n(e1(U, m), -o[1]), n(e1(T, h), c[1]))), l[2]), n(t1(n(e1(F, M), i[1]), t1(n(e1(D, d), -o[1]), n(e1(T, h), l[1]))), -c[2]))), -a[3])))), t1(t1(t1(n(t1(t1(n(t1(n(e1(G, N), a[1]), t1(n(e1(V, _), -l[1]), n(e1(R, b), c[1]))), i[2]), n(t1(n(e1(G, N), i[1]), t1(n(e1(U, m), -l[1]), n(e1(D, d), c[1]))), -a[2])), t1(n(t1(n(e1(V, _), i[1]), t1(n(e1(U, m), -a[1]), n(e1(v, f), c[1]))), l[2]), n(t1(n(e1(R, b), i[1]), t1(n(e1(D, d), -a[1]), n(e1(v, f), l[1]))), -c[2]))), o[3]), n(t1(t1(n(t1(n(e1(H, S), a[1]), t1(n(e1(V, _), -o[1]), n(e1(k, y), c[1]))), i[2]), n(t1(n(e1(H, S), i[1]), t1(n(e1(U, m), -o[1]), n(e1(T, h), c[1]))), -a[2])), t1(n(t1(n(e1(V, _), i[1]), t1(n(e1(U, m), -a[1]), n(e1(v, f), c[1]))), o[2]), n(t1(n(e1(k, y), i[1]), t1(n(e1(T, h), -a[1]), n(e1(v, f), o[1]))), -c[2]))), -l[3])), t1(n(t1(t1(n(t1(n(e1(F, M), a[1]), t1(n(e1(R, b), -o[1]), n(e1(k, y), l[1]))), i[2]), n(t1(n(e1(F, M), i[1]), t1(n(e1(D, d), -o[1]), n(e1(T, h), l[1]))), -a[2])), t1(n(t1(n(e1(R, b), i[1]), t1(n(e1(D, d), -a[1]), n(e1(v, f), l[1]))), o[2]), n(t1(n(e1(k, y), i[1]), t1(n(e1(T, h), -a[1]), n(e1(v, f), o[1]))), -l[2]))), c[3]), n(t1(t1(n(t1(n(e1(B, I), o[1]), t1(n(e1(F, M), -s[1]), n(e1(P, A), l[1]))), a[2]), n(t1(n(e1(B, I), a[1]), t1(n(e1(R, b), -s[1]), n(e1(C, x), l[1]))), -o[2])), t1(n(t1(n(e1(F, M), a[1]), t1(n(e1(R, b), -o[1]), n(e1(k, y), l[1]))), s[2]), n(t1(n(e1(P, A), a[1]), t1(n(e1(C, x), -o[1]), n(e1(k, y), s[1]))), -l[2]))), i[3]))), t1(t1(n(t1(t1(n(t1(n(e1(B, I), o[1]), t1(n(e1(F, M), -s[1]), n(e1(P, A), l[1]))), i[2]), n(t1(n(e1(B, I), i[1]), t1(n(e1(D, d), -s[1]), n(e1(L, p), l[1]))), -o[2])), t1(n(t1(n(e1(F, M), i[1]), t1(n(e1(D, d), -o[1]), n(e1(T, h), l[1]))), s[2]), n(t1(n(e1(P, A), i[1]), t1(n(e1(L, p), -o[1]), n(e1(T, h), s[1]))), -l[2]))), -a[3]), n(t1(t1(n(t1(n(e1(B, I), a[1]), t1(n(e1(R, b), -s[1]), n(e1(C, x), l[1]))), i[2]), n(t1(n(e1(B, I), i[1]), t1(n(e1(D, d), -s[1]), n(e1(L, p), l[1]))), -a[2])), t1(n(t1(n(e1(R, b), i[1]), t1(n(e1(D, d), -a[1]), n(e1(v, f), l[1]))), s[2]), n(t1(n(e1(C, x), i[1]), t1(n(e1(L, p), -a[1]), n(e1(v, f), s[1]))), -l[2]))), o[3])), t1(n(t1(t1(n(t1(n(e1(F, M), a[1]), t1(n(e1(R, b), -o[1]), n(e1(k, y), l[1]))), i[2]), n(t1(n(e1(F, M), i[1]), t1(n(e1(D, d), -o[1]), n(e1(T, h), l[1]))), -a[2])), t1(n(t1(n(e1(R, b), i[1]), t1(n(e1(D, d), -a[1]), n(e1(v, f), l[1]))), o[2]), n(t1(n(e1(k, y), i[1]), t1(n(e1(T, h), -a[1]), n(e1(v, f), o[1]))), -l[2]))), -s[3]), n(t1(t1(n(t1(n(e1(P, A), a[1]), t1(n(e1(C, x), -o[1]), n(e1(k, y), s[1]))), i[2]), n(t1(n(e1(P, A), i[1]), t1(n(e1(L, p), -o[1]), n(e1(T, h), s[1]))), -a[2])), t1(n(t1(n(e1(C, x), i[1]), t1(n(e1(L, p), -a[1]), n(e1(v, f), s[1]))), o[2]), n(t1(n(e1(k, y), i[1]), t1(n(e1(T, h), -a[1]), n(e1(v, f), o[1]))), -s[2]))), l[3]))))), X = e1(Y, W);
                                                return X[X.length - 1];
                                            };
                                        }
                                        var h = [
                                            function() {
                                                return 0;
                                            },
                                            function() {
                                                return 0;
                                            },
                                            function() {
                                                return 0;
                                            }
                                        ];
                                        function p(t1) {
                                            var e1 = h[t1.length];
                                            return e1 || (e1 = h[t1.length] = s(t1.length)), e1.apply(void 0, t1);
                                        }
                                        function d(t1, e1, r, n, i, a, o, s) {
                                            return function(e1, r, l, c, u, f) {
                                                switch(arguments.length){
                                                    case 0:
                                                    case 1:
                                                        return 0;
                                                    case 2:
                                                        return n(e1, r);
                                                    case 3:
                                                        return i(e1, r, l);
                                                    case 4:
                                                        return a(e1, r, l, c);
                                                    case 5:
                                                        return o(e1, r, l, c, u);
                                                    case 6:
                                                        return s(e1, r, l, c, u, f);
                                                }
                                                for(var h = new Array(arguments.length), p = 0; p < arguments.length; ++p)h[p] = arguments[p];
                                                return t1(h);
                                            };
                                        }
                                        !function() {
                                            for(; h.length <= 6;)h.push(s(h.length));
                                            e1.exports = d.apply(void 0, [
                                                p
                                            ].concat(h));
                                            for(var t1 = 0; t1 <= 6; ++t1)e1.exports[t1] = h[t1];
                                        }();
                                    },
                                    {
                                        "robust-scale": 286,
                                        "robust-subtract": 288,
                                        "robust-sum": 289,
                                        "two-product": 306
                                    }
                                ],
                                283: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("robust-determinant");
                                        function i(t1) {
                                            var e1 = 2 === t1 ? a : o;
                                            return e1(t1 < 3 ? n[t1] : n);
                                        }
                                        function a(t1) {
                                            return function(e1, r) {
                                                return [
                                                    t1([
                                                        [
                                                            +r[0],
                                                            +e1[0][1]
                                                        ],
                                                        [
                                                            +r[1],
                                                            +e1[1][1]
                                                        ]
                                                    ]),
                                                    t1([
                                                        [
                                                            +e1[0][0],
                                                            +r[0]
                                                        ],
                                                        [
                                                            +e1[1][0],
                                                            +r[1]
                                                        ]
                                                    ]),
                                                    t1(e1)
                                                ];
                                            };
                                        }
                                        function o(t1) {
                                            return function(e1, r) {
                                                return [
                                                    t1([
                                                        [
                                                            +r[0],
                                                            +e1[0][1],
                                                            +e1[0][2]
                                                        ],
                                                        [
                                                            +r[1],
                                                            +e1[1][1],
                                                            +e1[1][2]
                                                        ],
                                                        [
                                                            +r[2],
                                                            +e1[2][1],
                                                            +e1[2][2]
                                                        ]
                                                    ]),
                                                    t1([
                                                        [
                                                            +e1[0][0],
                                                            +r[0],
                                                            +e1[0][2]
                                                        ],
                                                        [
                                                            +e1[1][0],
                                                            +r[1],
                                                            +e1[1][2]
                                                        ],
                                                        [
                                                            +e1[2][0],
                                                            +r[2],
                                                            +e1[2][2]
                                                        ]
                                                    ]),
                                                    t1([
                                                        [
                                                            +e1[0][0],
                                                            +e1[0][1],
                                                            +r[0]
                                                        ],
                                                        [
                                                            +e1[1][0],
                                                            +e1[1][1],
                                                            +r[1]
                                                        ],
                                                        [
                                                            +e1[2][0],
                                                            +e1[2][1],
                                                            +r[2]
                                                        ]
                                                    ]),
                                                    t1(e1)
                                                ];
                                            };
                                        }
                                        var s = [
                                            function() {
                                                return [
                                                    [
                                                        0
                                                    ]
                                                ];
                                            },
                                            function(t1, e1) {
                                                return [
                                                    [
                                                        e1[0]
                                                    ],
                                                    [
                                                        t1[0][0]
                                                    ]
                                                ];
                                            }
                                        ];
                                        function l(t1, e1, r, n, i, a) {
                                            return function(o, s) {
                                                switch(o.length){
                                                    case 0:
                                                        return t1(o, s);
                                                    case 1:
                                                        return e1(o, s);
                                                    case 2:
                                                        return r(o, s);
                                                    case 3:
                                                        return n(o, s);
                                                }
                                                var l = i[o.length];
                                                return l || (l = i[o.length] = a(o.length)), l(o, s);
                                            };
                                        }
                                        !function() {
                                            for(; s.length <= 3;)s.push(i(s.length));
                                            e1.exports = l.apply(void 0, s.concat([
                                                s,
                                                i
                                            ]));
                                            for(var t1 = 0; t1 < 3; ++t1)e1.exports[t1] = s[t1];
                                        }();
                                    },
                                    {
                                        "robust-determinant": 280
                                    }
                                ],
                                284: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("two-product"), i = t1("robust-sum"), a = t1("robust-scale"), o = t1("robust-subtract");
                                        function s(t1, e1, r, n) {
                                            return function(r, i, a) {
                                                var o = t1(t1(e1(i[1], a[0]), e1(-a[1], i[0])), t1(e1(r[1], i[0]), e1(-i[1], r[0]))), s = t1(e1(r[1], a[0]), e1(-a[1], r[0])), l = n(o, s);
                                                return l[l.length - 1];
                                            };
                                        }
                                        function l(t1, e1, r, n) {
                                            return function(i, a, o, s) {
                                                var l = t1(t1(r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), a[2]), t1(r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), -o[2]), r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), s[2]))), t1(r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), i[2]), t1(r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), s[2])))), c = t1(t1(r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), i[2]), t1(r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), -o[2]), r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), s[2]))), t1(r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), i[2]), t1(r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), o[2])))), u = n(l, c);
                                                return u[u.length - 1];
                                            };
                                        }
                                        function c(t1, e1, r, n) {
                                            return function(i, a, o, s, l) {
                                                var c = t1(t1(t1(r(t1(r(t1(e1(s[1], l[0]), e1(-l[1], s[0])), o[2]), t1(r(t1(e1(o[1], l[0]), e1(-l[1], o[0])), -s[2]), r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), l[2]))), a[3]), t1(r(t1(r(t1(e1(s[1], l[0]), e1(-l[1], s[0])), a[2]), t1(r(t1(e1(a[1], l[0]), e1(-l[1], a[0])), -s[2]), r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), l[2]))), -o[3]), r(t1(r(t1(e1(o[1], l[0]), e1(-l[1], o[0])), a[2]), t1(r(t1(e1(a[1], l[0]), e1(-l[1], a[0])), -o[2]), r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), l[2]))), s[3]))), t1(r(t1(r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), a[2]), t1(r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), -o[2]), r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), s[2]))), -l[3]), t1(r(t1(r(t1(e1(s[1], l[0]), e1(-l[1], s[0])), a[2]), t1(r(t1(e1(a[1], l[0]), e1(-l[1], a[0])), -s[2]), r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), l[2]))), i[3]), r(t1(r(t1(e1(s[1], l[0]), e1(-l[1], s[0])), i[2]), t1(r(t1(e1(i[1], l[0]), e1(-l[1], i[0])), -s[2]), r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), l[2]))), -a[3])))), t1(t1(r(t1(r(t1(e1(a[1], l[0]), e1(-l[1], a[0])), i[2]), t1(r(t1(e1(i[1], l[0]), e1(-l[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), l[2]))), s[3]), t1(r(t1(r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), i[2]), t1(r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), s[2]))), -l[3]), r(t1(r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), a[2]), t1(r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), -o[2]), r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), s[2]))), i[3]))), t1(r(t1(r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), i[2]), t1(r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), -o[2]), r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), s[2]))), -a[3]), t1(r(t1(r(t1(e1(a[1], s[0]), e1(-s[1], a[0])), i[2]), t1(r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), s[2]))), o[3]), r(t1(r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), i[2]), t1(r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), o[2]))), -s[3]))))), u = t1(t1(t1(r(t1(r(t1(e1(s[1], l[0]), e1(-l[1], s[0])), o[2]), t1(r(t1(e1(o[1], l[0]), e1(-l[1], o[0])), -s[2]), r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), l[2]))), i[3]), r(t1(r(t1(e1(s[1], l[0]), e1(-l[1], s[0])), i[2]), t1(r(t1(e1(i[1], l[0]), e1(-l[1], i[0])), -s[2]), r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), l[2]))), -o[3])), t1(r(t1(r(t1(e1(o[1], l[0]), e1(-l[1], o[0])), i[2]), t1(r(t1(e1(i[1], l[0]), e1(-l[1], i[0])), -o[2]), r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), l[2]))), s[3]), r(t1(r(t1(e1(o[1], s[0]), e1(-s[1], o[0])), i[2]), t1(r(t1(e1(i[1], s[0]), e1(-s[1], i[0])), -o[2]), r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), s[2]))), -l[3]))), t1(t1(r(t1(r(t1(e1(o[1], l[0]), e1(-l[1], o[0])), a[2]), t1(r(t1(e1(a[1], l[0]), e1(-l[1], a[0])), -o[2]), r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), l[2]))), i[3]), r(t1(r(t1(e1(o[1], l[0]), e1(-l[1], o[0])), i[2]), t1(r(t1(e1(i[1], l[0]), e1(-l[1], i[0])), -o[2]), r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), l[2]))), -a[3])), t1(r(t1(r(t1(e1(a[1], l[0]), e1(-l[1], a[0])), i[2]), t1(r(t1(e1(i[1], l[0]), e1(-l[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), l[2]))), o[3]), r(t1(r(t1(e1(a[1], o[0]), e1(-o[1], a[0])), i[2]), t1(r(t1(e1(i[1], o[0]), e1(-o[1], i[0])), -a[2]), r(t1(e1(i[1], a[0]), e1(-a[1], i[0])), o[2]))), -l[3])))), f = n(c, u);
                                                return f[f.length - 1];
                                            };
                                        }
                                        function u(t1) {
                                            return (3 === t1 ? s : 4 === t1 ? l : c)(i, n, a, o);
                                        }
                                        var f = u(3), h = u(4), p = [
                                            function() {
                                                return 0;
                                            },
                                            function() {
                                                return 0;
                                            },
                                            function(t1, e1) {
                                                return e1[0] - t1[0];
                                            },
                                            function(t1, e1, r) {
                                                var n, i = (t1[1] - r[1]) * (e1[0] - r[0]), a = (t1[0] - r[0]) * (e1[1] - r[1]), o = i - a;
                                                if (i > 0) {
                                                    if (a <= 0) return o;
                                                    n = i + a;
                                                } else {
                                                    if (!(i < 0)) return o;
                                                    if (a >= 0) return o;
                                                    n = -(i + a);
                                                }
                                                var s = 33306690738754716e-32 * n;
                                                return o >= s || o <= -s ? o : f(t1, e1, r);
                                            },
                                            function(t1, e1, r, n) {
                                                var i = t1[0] - n[0], a = e1[0] - n[0], o = r[0] - n[0], s = t1[1] - n[1], l = e1[1] - n[1], c = r[1] - n[1], u = t1[2] - n[2], f = e1[2] - n[2], p = r[2] - n[2], d = a * c, m = o * l, g = o * s, v = i * c, y = i * l, x = a * s, b = u * (d - m) + f * (g - v) + p * (y - x), _ = 7771561172376103e-31 * ((Math.abs(d) + Math.abs(m)) * Math.abs(u) + (Math.abs(g) + Math.abs(v)) * Math.abs(f) + (Math.abs(y) + Math.abs(x)) * Math.abs(p));
                                                return b > _ || -b > _ ? b : h(t1, e1, r, n);
                                            }
                                        ];
                                        function d(t1) {
                                            var e1 = p[t1.length];
                                            return e1 || (e1 = p[t1.length] = u(t1.length)), e1.apply(void 0, t1);
                                        }
                                        function m(t1, e1, r, n, i, a, o) {
                                            return function(e1, r, s, l, c) {
                                                switch(arguments.length){
                                                    case 0:
                                                    case 1:
                                                        return 0;
                                                    case 2:
                                                        return n(e1, r);
                                                    case 3:
                                                        return i(e1, r, s);
                                                    case 4:
                                                        return a(e1, r, s, l);
                                                    case 5:
                                                        return o(e1, r, s, l, c);
                                                }
                                                for(var u = new Array(arguments.length), f = 0; f < arguments.length; ++f)u[f] = arguments[f];
                                                return t1(u);
                                            };
                                        }
                                        !function() {
                                            for(; p.length <= 5;)p.push(u(p.length));
                                            e1.exports = m.apply(void 0, [
                                                d
                                            ].concat(p));
                                            for(var t1 = 0; t1 <= 5; ++t1)e1.exports[t1] = p[t1];
                                        }();
                                    },
                                    {
                                        "robust-scale": 286,
                                        "robust-subtract": 288,
                                        "robust-sum": 289,
                                        "two-product": 306
                                    }
                                ],
                                285: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("robust-sum"), i = t1("robust-scale");
                                        e1.exports = function(t1, e1) {
                                            if (1 === t1.length) return i(e1, t1[0]);
                                            if (1 === e1.length) return i(t1, e1[0]);
                                            if (0 === t1.length || 0 === e1.length) return [
                                                0
                                            ];
                                            var r = [
                                                0
                                            ];
                                            if (t1.length < e1.length) for(var a = 0; a < t1.length; ++a)r = n(r, i(e1, t1[a]));
                                            else for(a = 0; a < e1.length; ++a)r = n(r, i(t1, e1[a]));
                                            return r;
                                        };
                                    },
                                    {
                                        "robust-scale": 286,
                                        "robust-sum": 289
                                    }
                                ],
                                286: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("two-product"), i = t1("two-sum");
                                        e1.exports = function(t1, e1) {
                                            var r = t1.length;
                                            if (1 === r) {
                                                var a = n(t1[0], e1);
                                                return a[0] ? a : [
                                                    a[1]
                                                ];
                                            }
                                            var o = new Array(2 * r), s = [
                                                .1,
                                                .1
                                            ], l = [
                                                .1,
                                                .1
                                            ], c = 0;
                                            n(t1[0], e1, s), s[0] && (o[c++] = s[0]);
                                            for(var u = 1; u < r; ++u){
                                                n(t1[u], e1, l);
                                                var f = s[1];
                                                i(f, l[0], s), s[0] && (o[c++] = s[0]);
                                                var h = l[1], p = s[1], d = h + p, m = p - (d - h);
                                                s[1] = d, m && (o[c++] = m);
                                            }
                                            s[1] && (o[c++] = s[1]);
                                            0 === c && (o[c++] = 0);
                                            return o.length = c, o;
                                        };
                                    },
                                    {
                                        "two-product": 306,
                                        "two-sum": 307
                                    }
                                ],
                                287: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r, i) {
                                            var a = n(t1, r, i), o = n(e1, r, i);
                                            if (a > 0 && o > 0 || a < 0 && o < 0) return !1;
                                            var s = n(r, t1, e1), l = n(i, t1, e1);
                                            if (s > 0 && l > 0 || s < 0 && l < 0) return !1;
                                            if (0 === a && 0 === o && 0 === s && 0 === l) return function(t1, e1, r, n) {
                                                for(var i = 0; i < 2; ++i){
                                                    var a = t1[i], o = e1[i], s = Math.min(a, o), l = Math.max(a, o), c = r[i], u = n[i], f = Math.min(c, u);
                                                    if (Math.max(c, u) < s || l < f) return !1;
                                                }
                                                return !0;
                                            }(t1, e1, r, i);
                                            return !0;
                                        };
                                        var n = t1("robust-orientation")[3];
                                    },
                                    {
                                        "robust-orientation": 284
                                    }
                                ],
                                288: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            var r = 0 | t1.length, n = 0 | e1.length;
                                            if (1 === r && 1 === n) return function(t1, e1) {
                                                var r = t1 + e1, n = r - t1, i = t1 - (r - n) + (e1 - n);
                                                if (i) return [
                                                    i,
                                                    r
                                                ];
                                                return [
                                                    r
                                                ];
                                            }(t1[0], -e1[0]);
                                            var i, a, o = new Array(r + n), s = 0, l = 0, c = 0, u = Math.abs, f = t1[l], h = u(f), p = -e1[c], d = u(p);
                                            h < d ? (a = f, (l += 1) < r && (f = t1[l], h = u(f))) : (a = p, (c += 1) < n && (p = -e1[c], d = u(p)));
                                            l < r && h < d || c >= n ? (i = f, (l += 1) < r && (f = t1[l], h = u(f))) : (i = p, (c += 1) < n && (p = -e1[c], d = u(p)));
                                            var m, g, v = i + a, y = v - i, x = a - y, b = x, _ = v;
                                            for(; l < r && c < n;)h < d ? (i = f, (l += 1) < r && (f = t1[l], h = u(f))) : (i = p, (c += 1) < n && (p = -e1[c], d = u(p))), (x = (a = b) - (y = (v = i + a) - i)) && (o[s++] = x), b = _ - ((m = _ + v) - (g = m - _)) + (v - g), _ = m;
                                            for(; l < r;)(x = (a = b) - (y = (v = (i = f) + a) - i)) && (o[s++] = x), b = _ - ((m = _ + v) - (g = m - _)) + (v - g), _ = m, (l += 1) < r && (f = t1[l]);
                                            for(; c < n;)(x = (a = b) - (y = (v = (i = p) + a) - i)) && (o[s++] = x), b = _ - ((m = _ + v) - (g = m - _)) + (v - g), _ = m, (c += 1) < n && (p = -e1[c]);
                                            b && (o[s++] = b);
                                            _ && (o[s++] = _);
                                            s || (o[s++] = 0);
                                            return o.length = s, o;
                                        };
                                    },
                                    {}
                                ],
                                289: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            var r = 0 | t1.length, n = 0 | e1.length;
                                            if (1 === r && 1 === n) return function(t1, e1) {
                                                var r = t1 + e1, n = r - t1, i = t1 - (r - n) + (e1 - n);
                                                if (i) return [
                                                    i,
                                                    r
                                                ];
                                                return [
                                                    r
                                                ];
                                            }(t1[0], e1[0]);
                                            var i, a, o = new Array(r + n), s = 0, l = 0, c = 0, u = Math.abs, f = t1[l], h = u(f), p = e1[c], d = u(p);
                                            h < d ? (a = f, (l += 1) < r && (f = t1[l], h = u(f))) : (a = p, (c += 1) < n && (p = e1[c], d = u(p)));
                                            l < r && h < d || c >= n ? (i = f, (l += 1) < r && (f = t1[l], h = u(f))) : (i = p, (c += 1) < n && (p = e1[c], d = u(p)));
                                            var m, g, v = i + a, y = v - i, x = a - y, b = x, _ = v;
                                            for(; l < r && c < n;)h < d ? (i = f, (l += 1) < r && (f = t1[l], h = u(f))) : (i = p, (c += 1) < n && (p = e1[c], d = u(p))), (x = (a = b) - (y = (v = i + a) - i)) && (o[s++] = x), b = _ - ((m = _ + v) - (g = m - _)) + (v - g), _ = m;
                                            for(; l < r;)(x = (a = b) - (y = (v = (i = f) + a) - i)) && (o[s++] = x), b = _ - ((m = _ + v) - (g = m - _)) + (v - g), _ = m, (l += 1) < r && (f = t1[l]);
                                            for(; c < n;)(x = (a = b) - (y = (v = (i = p) + a) - i)) && (o[s++] = x), b = _ - ((m = _ + v) - (g = m - _)) + (v - g), _ = m, (c += 1) < n && (p = e1[c]);
                                            b && (o[s++] = b);
                                            _ && (o[s++] = _);
                                            s || (o[s++] = 0);
                                            return o.length = s, o;
                                        };
                                    },
                                    {}
                                ],
                                290: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            return i(n(t1));
                                        };
                                        var n = t1("boundary-cells"), i = t1("reduce-simplicial-complex");
                                    },
                                    {
                                        "boundary-cells": 34,
                                        "reduce-simplicial-complex": 276
                                    }
                                ],
                                291: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r, s) {
                                            r = r || 0, void 0 === s && (s = function(t1) {
                                                for(var e1 = t1.length, r = 0, n = 0; n < e1; ++n)r = 0 | Math.max(r, t1[n].length);
                                                return r - 1;
                                            }(t1));
                                            if (0 === t1.length || s < 1) return {
                                                cells: [],
                                                vertexIds: [],
                                                vertexWeights: []
                                            };
                                            var l = function(t1, e1) {
                                                for(var r = t1.length, n = i.mallocUint8(r), a = 0; a < r; ++a)n[a] = t1[a] < e1 | 0;
                                                return n;
                                            }(e1, +r), c = function(t1, e1) {
                                                for(var r = t1.length, o = e1 * (e1 + 1) / 2 * r | 0, s = i.mallocUint32(2 * o), l = 0, c = 0; c < r; ++c)for(var u = t1[c], f = (e1 = u.length, 0); f < e1; ++f)for(var h = 0; h < f; ++h){
                                                    var p = u[h], d = u[f];
                                                    s[l++] = 0 | Math.min(p, d), s[l++] = 0 | Math.max(p, d);
                                                }
                                                a(n(s, [
                                                    l / 2 | 0,
                                                    2
                                                ]));
                                                var m = 2;
                                                for(c = 2; c < l; c += 2)s[c - 2] === s[c] && s[c - 1] === s[c + 1] || (s[m++] = s[c], s[m++] = s[c + 1]);
                                                return n(s, [
                                                    m / 2 | 0,
                                                    2
                                                ]);
                                            }(t1, s), u = function(t1, e1, r, a) {
                                                for(var o = t1.data, s = t1.shape[0], l = i.mallocDouble(s), c = 0, u = 0; u < s; ++u){
                                                    var f = o[2 * u], h = o[2 * u + 1];
                                                    if (r[f] !== r[h]) {
                                                        var p = e1[f], d = e1[h];
                                                        o[2 * c] = f, o[2 * c + 1] = h, l[c++] = (d - a) / (d - p);
                                                    }
                                                }
                                                return t1.shape[0] = c, n(l, [
                                                    c
                                                ]);
                                            }(c, e1, l, +r), f = function(t1, e1) {
                                                var r = i.mallocInt32(2 * e1), n = t1.shape[0], a = t1.data;
                                                r[0] = 0;
                                                for(var o = 0, s = 0; s < n; ++s){
                                                    var l = a[2 * s];
                                                    if (l !== o) {
                                                        for(r[2 * o + 1] = s; ++o < l;)r[2 * o] = s, r[2 * o + 1] = s;
                                                        r[2 * o] = s;
                                                    }
                                                }
                                                r[2 * o + 1] = n;
                                                for(; ++o < e1;)r[2 * o] = r[2 * o + 1] = n;
                                                return r;
                                            }(c, 0 | e1.length), h = o(s)(t1, c.data, f, l), p = function(t1) {
                                                for(var e1 = 0 | t1.shape[0], r = t1.data, n = new Array(e1), i = 0; i < e1; ++i)n[i] = [
                                                    r[2 * i],
                                                    r[2 * i + 1]
                                                ];
                                                return n;
                                            }(c), d = [].slice.call(u.data, 0, u.shape[0]);
                                            return i.free(l), i.free(c.data), i.free(u.data), i.free(f), {
                                                cells: h,
                                                vertexIds: p,
                                                vertexWeights: d
                                            };
                                        };
                                        var n = t1("ndarray"), i = t1("typedarray-pool"), a = t1("ndarray-sort"), o = t1("./lib/codegen");
                                    },
                                    {
                                        "./lib/codegen": 292,
                                        ndarray: 259,
                                        "ndarray-sort": 258,
                                        "typedarray-pool": 308
                                    }
                                ],
                                292: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            return n[t1]();
                                        };
                                        var n = [
                                            function() {
                                                return function(t1, e1, r, n) {
                                                    for(var i = t1.length, a = 0; a < i; ++a)t1[a].length;
                                                    return [];
                                                };
                                            },
                                            function() {
                                                function t1(t1, e1, r, n) {
                                                    for(var i = 0 | Math.min(r, n), a = 0 | Math.max(r, n), o = t1[2 * i], s = t1[2 * i + 1]; o < s;){
                                                        var l = o + s >> 1, c = e1[2 * l + 1];
                                                        if (c === a) return l;
                                                        a < c ? s = l : o = l + 1;
                                                    }
                                                    return o;
                                                }
                                                return function(e1, r, n, i) {
                                                    for(var a = e1.length, o = [], s = 0; s < a; ++s){
                                                        var l = e1[s];
                                                        if (2 === l.length) {
                                                            var c = (i[l[0]] << 0) + (i[l[1]] << 1);
                                                            if (0 === c || 3 === c) continue;
                                                            switch(c){
                                                                case 0:
                                                                    break;
                                                                case 1:
                                                                    o.push([
                                                                        t1(n, r, l[0], l[1])
                                                                    ]);
                                                                    break;
                                                                case 2:
                                                                    o.push([
                                                                        t1(n, r, l[1], l[0])
                                                                    ]);
                                                            }
                                                        }
                                                    }
                                                    return o;
                                                };
                                            },
                                            function() {
                                                function t1(t1, e1, r, n) {
                                                    for(var i = 0 | Math.min(r, n), a = 0 | Math.max(r, n), o = t1[2 * i], s = t1[2 * i + 1]; o < s;){
                                                        var l = o + s >> 1, c = e1[2 * l + 1];
                                                        if (c === a) return l;
                                                        a < c ? s = l : o = l + 1;
                                                    }
                                                    return o;
                                                }
                                                return function(e1, r, n, i) {
                                                    for(var a = e1.length, o = [], s = 0; s < a; ++s){
                                                        var l = e1[s], c = l.length;
                                                        if (3 === c) {
                                                            if (0 === (u = (i[l[0]] << 0) + (i[l[1]] << 1) + (i[l[2]] << 2)) || 7 === u) continue;
                                                            switch(u){
                                                                case 0:
                                                                    break;
                                                                case 1:
                                                                    o.push([
                                                                        t1(n, r, l[0], l[2]),
                                                                        t1(n, r, l[0], l[1])
                                                                    ]);
                                                                    break;
                                                                case 2:
                                                                    o.push([
                                                                        t1(n, r, l[1], l[0]),
                                                                        t1(n, r, l[1], l[2])
                                                                    ]);
                                                                    break;
                                                                case 3:
                                                                    o.push([
                                                                        t1(n, r, l[0], l[2]),
                                                                        t1(n, r, l[1], l[2])
                                                                    ]);
                                                                    break;
                                                                case 4:
                                                                    o.push([
                                                                        t1(n, r, l[2], l[1]),
                                                                        t1(n, r, l[2], l[0])
                                                                    ]);
                                                                    break;
                                                                case 5:
                                                                    o.push([
                                                                        t1(n, r, l[2], l[1]),
                                                                        t1(n, r, l[0], l[1])
                                                                    ]);
                                                                    break;
                                                                case 6:
                                                                    o.push([
                                                                        t1(n, r, l[1], l[0]),
                                                                        t1(n, r, l[2], l[0])
                                                                    ]);
                                                            }
                                                        } else if (2 === c) {
                                                            var u;
                                                            if (0 === (u = (i[l[0]] << 0) + (i[l[1]] << 1)) || 3 === u) continue;
                                                            switch(u){
                                                                case 0:
                                                                    break;
                                                                case 1:
                                                                    o.push([
                                                                        t1(n, r, l[0], l[1])
                                                                    ]);
                                                                    break;
                                                                case 2:
                                                                    o.push([
                                                                        t1(n, r, l[1], l[0])
                                                                    ]);
                                                            }
                                                        }
                                                    }
                                                    return o;
                                                };
                                            },
                                            function() {
                                                function t1(t1, e1, r, n) {
                                                    for(var i = 0 | Math.min(r, n), a = 0 | Math.max(r, n), o = t1[2 * i], s = t1[2 * i + 1]; o < s;){
                                                        var l = o + s >> 1, c = e1[2 * l + 1];
                                                        if (c === a) return l;
                                                        a < c ? s = l : o = l + 1;
                                                    }
                                                    return o;
                                                }
                                                return function(e1, r, n, i) {
                                                    for(var a = e1.length, o = [], s = 0; s < a; ++s){
                                                        var l = e1[s], c = l.length;
                                                        if (4 === c) {
                                                            if (0 === (u = (i[l[0]] << 0) + (i[l[1]] << 1) + (i[l[2]] << 2) + (i[l[3]] << 3)) || 15 === u) continue;
                                                            switch(u){
                                                                case 0:
                                                                    break;
                                                                case 1:
                                                                    o.push([
                                                                        t1(n, r, l[0], l[1]),
                                                                        t1(n, r, l[0], l[2]),
                                                                        t1(n, r, l[0], l[3])
                                                                    ]);
                                                                    break;
                                                                case 2:
                                                                    o.push([
                                                                        t1(n, r, l[1], l[2]),
                                                                        t1(n, r, l[1], l[0]),
                                                                        t1(n, r, l[1], l[3])
                                                                    ]);
                                                                    break;
                                                                case 3:
                                                                    o.push([
                                                                        t1(n, r, l[1], l[2]),
                                                                        t1(n, r, l[0], l[2]),
                                                                        t1(n, r, l[0], l[3])
                                                                    ], [
                                                                        t1(n, r, l[1], l[3]),
                                                                        t1(n, r, l[1], l[2]),
                                                                        t1(n, r, l[0], l[3])
                                                                    ]);
                                                                    break;
                                                                case 4:
                                                                    o.push([
                                                                        t1(n, r, l[2], l[0]),
                                                                        t1(n, r, l[2], l[1]),
                                                                        t1(n, r, l[2], l[3])
                                                                    ]);
                                                                    break;
                                                                case 5:
                                                                    o.push([
                                                                        t1(n, r, l[0], l[1]),
                                                                        t1(n, r, l[2], l[1]),
                                                                        t1(n, r, l[0], l[3])
                                                                    ], [
                                                                        t1(n, r, l[2], l[1]),
                                                                        t1(n, r, l[2], l[3]),
                                                                        t1(n, r, l[0], l[3])
                                                                    ]);
                                                                    break;
                                                                case 6:
                                                                    o.push([
                                                                        t1(n, r, l[2], l[0]),
                                                                        t1(n, r, l[1], l[0]),
                                                                        t1(n, r, l[1], l[3])
                                                                    ], [
                                                                        t1(n, r, l[2], l[3]),
                                                                        t1(n, r, l[2], l[0]),
                                                                        t1(n, r, l[1], l[3])
                                                                    ]);
                                                                    break;
                                                                case 7:
                                                                    o.push([
                                                                        t1(n, r, l[0], l[3]),
                                                                        t1(n, r, l[1], l[3]),
                                                                        t1(n, r, l[2], l[3])
                                                                    ]);
                                                                    break;
                                                                case 8:
                                                                    o.push([
                                                                        t1(n, r, l[3], l[1]),
                                                                        t1(n, r, l[3], l[0]),
                                                                        t1(n, r, l[3], l[2])
                                                                    ]);
                                                                    break;
                                                                case 9:
                                                                    o.push([
                                                                        t1(n, r, l[3], l[1]),
                                                                        t1(n, r, l[0], l[1]),
                                                                        t1(n, r, l[0], l[2])
                                                                    ], [
                                                                        t1(n, r, l[3], l[2]),
                                                                        t1(n, r, l[3], l[1]),
                                                                        t1(n, r, l[0], l[2])
                                                                    ]);
                                                                    break;
                                                                case 10:
                                                                    o.push([
                                                                        t1(n, r, l[1], l[0]),
                                                                        t1(n, r, l[3], l[0]),
                                                                        t1(n, r, l[1], l[2])
                                                                    ], [
                                                                        t1(n, r, l[3], l[0]),
                                                                        t1(n, r, l[3], l[2]),
                                                                        t1(n, r, l[1], l[2])
                                                                    ]);
                                                                    break;
                                                                case 11:
                                                                    o.push([
                                                                        t1(n, r, l[1], l[2]),
                                                                        t1(n, r, l[0], l[2]),
                                                                        t1(n, r, l[3], l[2])
                                                                    ]);
                                                                    break;
                                                                case 12:
                                                                    o.push([
                                                                        t1(n, r, l[3], l[0]),
                                                                        t1(n, r, l[2], l[0]),
                                                                        t1(n, r, l[2], l[1])
                                                                    ], [
                                                                        t1(n, r, l[3], l[1]),
                                                                        t1(n, r, l[3], l[0]),
                                                                        t1(n, r, l[2], l[1])
                                                                    ]);
                                                                    break;
                                                                case 13:
                                                                    o.push([
                                                                        t1(n, r, l[0], l[1]),
                                                                        t1(n, r, l[2], l[1]),
                                                                        t1(n, r, l[3], l[1])
                                                                    ]);
                                                                    break;
                                                                case 14:
                                                                    o.push([
                                                                        t1(n, r, l[2], l[0]),
                                                                        t1(n, r, l[1], l[0]),
                                                                        t1(n, r, l[3], l[0])
                                                                    ]);
                                                            }
                                                        } else if (3 === c) {
                                                            if (0 === (u = (i[l[0]] << 0) + (i[l[1]] << 1) + (i[l[2]] << 2)) || 7 === u) continue;
                                                            switch(u){
                                                                case 0:
                                                                    break;
                                                                case 1:
                                                                    o.push([
                                                                        t1(n, r, l[0], l[2]),
                                                                        t1(n, r, l[0], l[1])
                                                                    ]);
                                                                    break;
                                                                case 2:
                                                                    o.push([
                                                                        t1(n, r, l[1], l[0]),
                                                                        t1(n, r, l[1], l[2])
                                                                    ]);
                                                                    break;
                                                                case 3:
                                                                    o.push([
                                                                        t1(n, r, l[0], l[2]),
                                                                        t1(n, r, l[1], l[2])
                                                                    ]);
                                                                    break;
                                                                case 4:
                                                                    o.push([
                                                                        t1(n, r, l[2], l[1]),
                                                                        t1(n, r, l[2], l[0])
                                                                    ]);
                                                                    break;
                                                                case 5:
                                                                    o.push([
                                                                        t1(n, r, l[2], l[1]),
                                                                        t1(n, r, l[0], l[1])
                                                                    ]);
                                                                    break;
                                                                case 6:
                                                                    o.push([
                                                                        t1(n, r, l[1], l[0]),
                                                                        t1(n, r, l[2], l[0])
                                                                    ]);
                                                            }
                                                        } else if (2 === c) {
                                                            var u;
                                                            if (0 === (u = (i[l[0]] << 0) + (i[l[1]] << 1)) || 3 === u) continue;
                                                            switch(u){
                                                                case 0:
                                                                    break;
                                                                case 1:
                                                                    o.push([
                                                                        t1(n, r, l[0], l[1])
                                                                    ]);
                                                                    break;
                                                                case 2:
                                                                    o.push([
                                                                        t1(n, r, l[1], l[0])
                                                                    ]);
                                                            }
                                                        }
                                                    }
                                                    return o;
                                                };
                                            }
                                        ];
                                    },
                                    {}
                                ],
                                293: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("bit-twiddle"), i = t1("union-find");
                                        function a(t1, e1) {
                                            var r = t1.length, n = t1.length - e1.length, i = Math.min;
                                            if (n) return n;
                                            switch(r){
                                                case 0:
                                                    return 0;
                                                case 1:
                                                    return t1[0] - e1[0];
                                                case 2:
                                                    return (s = t1[0] + t1[1] - e1[0] - e1[1]) || i(t1[0], t1[1]) - i(e1[0], e1[1]);
                                                case 3:
                                                    var a = t1[0] + t1[1], o = e1[0] + e1[1];
                                                    if (s = a + t1[2] - (o + e1[2])) return s;
                                                    var s, l = i(t1[0], t1[1]), c = i(e1[0], e1[1]);
                                                    return (s = i(l, t1[2]) - i(c, e1[2])) || i(l + t1[2], a) - i(c + e1[2], o);
                                                default:
                                                    var u = t1.slice(0);
                                                    u.sort();
                                                    var f = e1.slice(0);
                                                    f.sort();
                                                    for(var h = 0; h < r; ++h)if (n = u[h] - f[h]) return n;
                                                    return 0;
                                            }
                                        }
                                        function o(t1, e1) {
                                            return a(t1[0], e1[0]);
                                        }
                                        function s(t1, e1) {
                                            if (e1) {
                                                for(var r = t1.length, n = new Array(r), i = 0; i < r; ++i)n[i] = [
                                                    t1[i],
                                                    e1[i]
                                                ];
                                                n.sort(o);
                                                for(i = 0; i < r; ++i)t1[i] = n[i][0], e1[i] = n[i][1];
                                                return t1;
                                            }
                                            return t1.sort(a), t1;
                                        }
                                        function l(t1) {
                                            if (0 === t1.length) return [];
                                            for(var e1 = 1, r = t1.length, n = 1; n < r; ++n){
                                                var i = t1[n];
                                                if (a(i, t1[n - 1])) {
                                                    if (n === e1) {
                                                        e1++;
                                                        continue;
                                                    }
                                                    t1[e1++] = i;
                                                }
                                            }
                                            return t1.length = e1, t1;
                                        }
                                        function c(t1, e1) {
                                            for(var r = 0, n = t1.length - 1, i = -1; r <= n;){
                                                var o = r + n >> 1, s = a(t1[o], e1);
                                                s <= 0 ? (0 === s && (i = o), r = o + 1) : s > 0 && (n = o - 1);
                                            }
                                            return i;
                                        }
                                        function u(t1, e1) {
                                            for(var r = new Array(t1.length), i = 0, o = r.length; i < o; ++i)r[i] = [];
                                            for(var s = [], l = (i = 0, e1.length); i < l; ++i)for(var u = e1[i], f = u.length, h = 1, p = 1 << f; h < p; ++h){
                                                s.length = n.popCount(h);
                                                for(var d = 0, m = 0; m < f; ++m)h & 1 << m && (s[d++] = u[m]);
                                                var g = c(t1, s);
                                                if (!(g < 0)) for(; r[g++].push(i), !(g >= t1.length || 0 !== a(t1[g], s)););
                                            }
                                            return r;
                                        }
                                        function f(t1, e1) {
                                            if (e1 < 0) return [];
                                            for(var r = [], i = (1 << e1 + 1) - 1, a = 0; a < t1.length; ++a)for(var o = t1[a], l = i; l < 1 << o.length; l = n.nextCombination(l)){
                                                for(var c = new Array(e1 + 1), u = 0, f = 0; f < o.length; ++f)l & 1 << f && (c[u++] = o[f]);
                                                r.push(c);
                                            }
                                            return s(r);
                                        }
                                        r.dimension = function(t1) {
                                            for(var e1 = 0, r = Math.max, n = 0, i = t1.length; n < i; ++n)e1 = r(e1, t1[n].length);
                                            return e1 - 1;
                                        }, r.countVertices = function(t1) {
                                            for(var e1 = -1, r = Math.max, n = 0, i = t1.length; n < i; ++n)for(var a = t1[n], o = 0, s = a.length; o < s; ++o)e1 = r(e1, a[o]);
                                            return e1 + 1;
                                        }, r.cloneCells = function(t1) {
                                            for(var e1 = new Array(t1.length), r = 0, n = t1.length; r < n; ++r)e1[r] = t1[r].slice(0);
                                            return e1;
                                        }, r.compareCells = a, r.normalize = s, r.unique = l, r.findCell = c, r.incidence = u, r.dual = function(t1, e1) {
                                            if (!e1) return u(l(f(t1, 0)), t1);
                                            for(var r = new Array(e1), n = 0; n < e1; ++n)r[n] = [];
                                            n = 0;
                                            for(var i = t1.length; n < i; ++n)for(var a = t1[n], o = 0, s = a.length; o < s; ++o)r[a[o]].push(n);
                                            return r;
                                        }, r.explode = function(t1) {
                                            for(var e1 = [], r = 0, n = t1.length; r < n; ++r)for(var i = t1[r], a = 0 | i.length, o = 1, l = 1 << a; o < l; ++o){
                                                for(var c = [], u = 0; u < a; ++u)o >>> u & 1 && c.push(i[u]);
                                                e1.push(c);
                                            }
                                            return s(e1);
                                        }, r.skeleton = f, r.boundary = function(t1) {
                                            for(var e1 = [], r = 0, n = t1.length; r < n; ++r)for(var i = t1[r], a = 0, o = i.length; a < o; ++a){
                                                for(var l = new Array(i.length - 1), c = 0, u = 0; c < o; ++c)c !== a && (l[u++] = i[c]);
                                                e1.push(l);
                                            }
                                            return s(e1);
                                        }, r.connectedComponents = function(t1, e1) {
                                            return e1 ? function(t1, e1) {
                                                for(var r = new i(e1), n = 0; n < t1.length; ++n)for(var a = t1[n], o = 0; o < a.length; ++o)for(var s = o + 1; s < a.length; ++s)r.link(a[o], a[s]);
                                                var l = [], c = r.ranks;
                                                for(n = 0; n < c.length; ++n)c[n] = -1;
                                                for(n = 0; n < t1.length; ++n){
                                                    var u = r.find(t1[n][0]);
                                                    c[u] < 0 ? (c[u] = l.length, l.push([
                                                        t1[n].slice(0)
                                                    ])) : l[c[u]].push(t1[n].slice(0));
                                                }
                                                return l;
                                            }(t1, e1) : function(t1) {
                                                for(var e1 = l(s(f(t1, 0))), r = new i(e1.length), n = 0; n < t1.length; ++n)for(var a = t1[n], o = 0; o < a.length; ++o)for(var u = c(e1, [
                                                    a[o]
                                                ]), h = o + 1; h < a.length; ++h)r.link(u, c(e1, [
                                                    a[h]
                                                ]));
                                                var p = [], d = r.ranks;
                                                for(n = 0; n < d.length; ++n)d[n] = -1;
                                                for(n = 0; n < t1.length; ++n){
                                                    var m = r.find(c(e1, [
                                                        t1[n][0]
                                                    ]));
                                                    d[m] < 0 ? (d[m] = p.length, p.push([
                                                        t1[n].slice(0)
                                                    ])) : p[d[m]].push(t1[n].slice(0));
                                                }
                                                return p;
                                            }(t1);
                                        };
                                    },
                                    {
                                        "bit-twiddle": 32,
                                        "union-find": 309
                                    }
                                ],
                                294: [
                                    function(t1, e1, r) {
                                        arguments[4][32][0].apply(r, arguments);
                                    },
                                    {
                                        dup: 32
                                    }
                                ],
                                295: [
                                    function(t1, e1, r) {
                                        arguments[4][293][0].apply(r, arguments);
                                    },
                                    {
                                        "bit-twiddle": 294,
                                        dup: 293,
                                        "union-find": 296
                                    }
                                ],
                                296: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        function n(t1) {
                                            this.roots = new Array(t1), this.ranks = new Array(t1);
                                            for(var e1 = 0; e1 < t1; ++e1)this.roots[e1] = e1, this.ranks[e1] = 0;
                                        }
                                        e1.exports = n, n.prototype.length = function() {
                                            return this.roots.length;
                                        }, n.prototype.makeSet = function() {
                                            var t1 = this.roots.length;
                                            return this.roots.push(t1), this.ranks.push(0), t1;
                                        }, n.prototype.find = function(t1) {
                                            for(var e1 = this.roots; e1[t1] !== t1;){
                                                var r = e1[t1];
                                                e1[t1] = e1[r], t1 = r;
                                            }
                                            return t1;
                                        }, n.prototype.link = function(t1, e1) {
                                            var r = this.find(t1), n = this.find(e1);
                                            if (r !== n) {
                                                var i = this.ranks, a = this.roots, o = i[r], s = i[n];
                                                o < s ? a[r] = n : s < o ? a[n] = r : (a[n] = r, ++i[r]);
                                            }
                                        };
                                    },
                                    {}
                                ],
                                297: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r) {
                                            for(var a = e1.length, o = t1.length, s = new Array(a), l = new Array(a), c = new Array(a), u = new Array(a), f = 0; f < a; ++f)s[f] = l[f] = -1, c[f] = 1 / 0, u[f] = !1;
                                            for(f = 0; f < o; ++f){
                                                var h = t1[f];
                                                if (2 !== h.length) throw new Error("Input must be a graph");
                                                var p = h[1], d = h[0];
                                                -1 !== l[d] ? l[d] = -2 : l[d] = p, -1 !== s[p] ? s[p] = -2 : s[p] = d;
                                            }
                                            function m(t1) {
                                                if (u[t1]) return 1 / 0;
                                                var r, i, a, o, c, f = s[t1], h = l[t1];
                                                return f < 0 || h < 0 ? 1 / 0 : (r = e1[t1], i = e1[f], a = e1[h], o = Math.abs(n(r, i, a)), c = Math.sqrt(Math.pow(i[0] - a[0], 2) + Math.pow(i[1] - a[1], 2)), o / c);
                                            }
                                            function g(t1, e1) {
                                                var r = k[t1], n = k[e1];
                                                k[t1] = n, k[e1] = r, A[r] = e1, A[n] = t1;
                                            }
                                            function v(t1) {
                                                return c[k[t1]];
                                            }
                                            function y(t1) {
                                                return 1 & t1 ? t1 - 1 >> 1 : (t1 >> 1) - 1;
                                            }
                                            function x(t1) {
                                                for(var e1 = v(t1);;){
                                                    var r = e1, n = 2 * t1 + 1, i = 2 * (t1 + 1), a = t1;
                                                    if (n < M) {
                                                        var o = v(n);
                                                        o < r && (a = n, r = o);
                                                    }
                                                    if (i < M) v(i) < r && (a = i);
                                                    if (a === t1) return t1;
                                                    g(t1, a), t1 = a;
                                                }
                                            }
                                            function b(t1) {
                                                for(var e1 = v(t1); t1 > 0;){
                                                    var r = y(t1);
                                                    if (r >= 0) {
                                                        if (e1 < v(r)) {
                                                            g(t1, r), t1 = r;
                                                            continue;
                                                        }
                                                    }
                                                    return t1;
                                                }
                                            }
                                            function _() {
                                                if (M > 0) {
                                                    var t1 = k[0];
                                                    return g(0, M - 1), M -= 1, x(0), t1;
                                                }
                                                return -1;
                                            }
                                            function w(t1, e1) {
                                                var r = k[t1];
                                                return c[r] === e1 ? t1 : (c[r] = -1 / 0, b(t1), _(), c[r] = e1, b((M += 1) - 1));
                                            }
                                            function T(t1) {
                                                if (!u[t1]) {
                                                    u[t1] = !0;
                                                    var e1 = s[t1], r = l[t1];
                                                    s[r] >= 0 && (s[r] = e1), l[e1] >= 0 && (l[e1] = r), A[e1] >= 0 && w(A[e1], m(e1)), A[r] >= 0 && w(A[r], m(r));
                                                }
                                            }
                                            var k = [], A = new Array(a);
                                            for(f = 0; f < a; ++f)(c[f] = m(f)) < 1 / 0 ? (A[f] = k.length, k.push(f)) : A[f] = -1;
                                            var M = k.length;
                                            for(f = M >> 1; f >= 0; --f)x(f);
                                            for(;;){
                                                var S = _();
                                                if (S < 0 || c[S] > r) break;
                                                T(S);
                                            }
                                            var E = [];
                                            for(f = 0; f < a; ++f)u[f] || (A[f] = E.length, E.push(e1[f].slice()));
                                            E.length;
                                            function L(t1, e1) {
                                                if (t1[e1] < 0) return e1;
                                                var r = e1, n = e1;
                                                do {
                                                    var i = t1[n];
                                                    if (!u[n] || i < 0 || i === n) break;
                                                    if (i = t1[n = i], !u[n] || i < 0 || i === n) break;
                                                    n = i, r = t1[r];
                                                }while (r !== n);
                                                for(var a = e1; a !== n; a = t1[a])t1[a] = n;
                                                return n;
                                            }
                                            var C = [];
                                            return t1.forEach(function(t1) {
                                                var e1 = L(s, t1[0]), r = L(l, t1[1]);
                                                if (e1 >= 0 && r >= 0 && e1 !== r) {
                                                    var n = A[e1], i = A[r];
                                                    n !== i && C.push([
                                                        n,
                                                        i
                                                    ]);
                                                }
                                            }), i.unique(i.normalize(C)), {
                                                positions: E,
                                                edges: C
                                            };
                                        };
                                        var n = t1("robust-orientation"), i = t1("simplicial-complex");
                                    },
                                    {
                                        "robust-orientation": 284,
                                        "simplicial-complex": 295
                                    }
                                ],
                                298: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            var r, a, o, s;
                                            if (e1[0][0] < e1[1][0]) r = e1[0], a = e1[1];
                                            else {
                                                if (!(e1[0][0] > e1[1][0])) return i(e1, t1);
                                                r = e1[1], a = e1[0];
                                            }
                                            if (t1[0][0] < t1[1][0]) o = t1[0], s = t1[1];
                                            else {
                                                if (!(t1[0][0] > t1[1][0])) return -i(t1, e1);
                                                o = t1[1], s = t1[0];
                                            }
                                            var l = n(r, a, s), c = n(r, a, o);
                                            if (l < 0) {
                                                if (c <= 0) return l;
                                            } else if (l > 0) {
                                                if (c >= 0) return l;
                                            } else if (c) return c;
                                            if (l = n(s, o, a), c = n(s, o, r), l < 0) {
                                                if (c <= 0) return l;
                                            } else if (l > 0) {
                                                if (c >= 0) return l;
                                            } else if (c) return c;
                                            return a[0] - s[0];
                                        };
                                        var n = t1("robust-orientation");
                                        function i(t1, e1) {
                                            var r, i, a, o;
                                            if (e1[0][0] < e1[1][0]) r = e1[0], i = e1[1];
                                            else {
                                                if (!(e1[0][0] > e1[1][0])) {
                                                    var s = Math.min(t1[0][1], t1[1][1]), l = Math.max(t1[0][1], t1[1][1]), c = Math.min(e1[0][1], e1[1][1]), u = Math.max(e1[0][1], e1[1][1]);
                                                    return l < c ? l - c : s > u ? s - u : l - u;
                                                }
                                                r = e1[1], i = e1[0];
                                            }
                                            t1[0][1] < t1[1][1] ? (a = t1[0], o = t1[1]) : (a = t1[1], o = t1[0]);
                                            var f = n(i, r, a);
                                            return f || (f = n(i, r, o)) || o - i;
                                        }
                                    },
                                    {
                                        "robust-orientation": 284
                                    }
                                ],
                                299: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            for(var e1 = t1.length, r = 2 * e1, n = new Array(r), a = 0; a < e1; ++a){
                                                var l = t1[a], c = l[0][0] < l[1][0];
                                                n[2 * a] = new f(l[0][0], l, c, a), n[2 * a + 1] = new f(l[1][0], l, !c, a);
                                            }
                                            n.sort(function(t1, e1) {
                                                var r = t1.x - e1.x;
                                                return r || (r = t1.create - e1.create) || Math.min(t1.segment[0][1], t1.segment[1][1]) - Math.min(e1.segment[0][1], e1.segment[1][1]);
                                            });
                                            var h = i(o), p = [], d = [], m = [];
                                            for(a = 0; a < r;){
                                                for(var g = n[a].x, v = []; a < r;){
                                                    var y = n[a];
                                                    if (y.x !== g) break;
                                                    a += 1, y.segment[0][0] === y.x && y.segment[1][0] === y.x ? y.create && (y.segment[0][1] < y.segment[1][1] ? (v.push(new u(y.segment[0][1], y.index, !0, !0)), v.push(new u(y.segment[1][1], y.index, !1, !1))) : (v.push(new u(y.segment[1][1], y.index, !0, !1)), v.push(new u(y.segment[0][1], y.index, !1, !0)))) : h = y.create ? h.insert(y.segment, y.index) : h.remove(y.segment);
                                                }
                                                p.push(h.root), d.push(g), m.push(v);
                                            }
                                            return new s(p, d, m);
                                        };
                                        var n = t1("binary-search-bounds"), i = t1("functional-red-black-tree"), a = t1("robust-orientation"), o = t1("./lib/order-segments");
                                        function s(t1, e1, r) {
                                            this.slabs = t1, this.coordinates = e1, this.horizontal = r;
                                        }
                                        function l(t1, e1) {
                                            return t1.y - e1;
                                        }
                                        function c(t1, e1) {
                                            for(var r = null; t1;){
                                                var n, i, o = t1.key;
                                                o[0][0] < o[1][0] ? (n = o[0], i = o[1]) : (n = o[1], i = o[0]);
                                                var s = a(n, i, e1);
                                                if (s < 0) t1 = t1.left;
                                                else if (s > 0) {
                                                    if (e1[0] !== o[1][0]) r = t1, t1 = t1.right;
                                                    else {
                                                        if (l = c(t1.right, e1)) return l;
                                                        t1 = t1.left;
                                                    }
                                                } else {
                                                    if (e1[0] !== o[1][0]) return t1;
                                                    var l;
                                                    if (l = c(t1.right, e1)) return l;
                                                    t1 = t1.left;
                                                }
                                            }
                                            return r;
                                        }
                                        function u(t1, e1, r, n) {
                                            this.y = t1, this.index = e1, this.start = r, this.closed = n;
                                        }
                                        function f(t1, e1, r, n) {
                                            this.x = t1, this.segment = e1, this.create = r, this.index = n;
                                        }
                                        s.prototype.castUp = function(t1) {
                                            var e1 = n.le(this.coordinates, t1[0]);
                                            if (e1 < 0) return -1;
                                            this.slabs[e1];
                                            var r = c(this.slabs[e1], t1), i = -1;
                                            if (r && (i = r.value), this.coordinates[e1] === t1[0]) {
                                                var s = null;
                                                if (r && (s = r.key), e1 > 0) {
                                                    var u = c(this.slabs[e1 - 1], t1);
                                                    u && (s ? o(u.key, s) > 0 && (s = u.key, i = u.value) : (i = u.value, s = u.key));
                                                }
                                                var f = this.horizontal[e1];
                                                if (f.length > 0) {
                                                    var h = n.ge(f, t1[1], l);
                                                    if (h < f.length) {
                                                        var p = f[h];
                                                        if (t1[1] === p.y) {
                                                            if (p.closed) return p.index;
                                                            for(; h < f.length - 1 && f[h + 1].y === t1[1];)if ((p = f[h += 1]).closed) return p.index;
                                                            if (p.y === t1[1] && !p.start) {
                                                                if ((h += 1) >= f.length) return i;
                                                                p = f[h];
                                                            }
                                                        }
                                                        if (p.start) {
                                                            if (s) {
                                                                var d = a(s[0], s[1], [
                                                                    t1[0],
                                                                    p.y
                                                                ]);
                                                                s[0][0] > s[1][0] && (d = -d), d > 0 && (i = p.index);
                                                            } else i = p.index;
                                                        } else p.y !== t1[1] && (i = p.index);
                                                    }
                                                }
                                            }
                                            return i;
                                        };
                                    },
                                    {
                                        "./lib/order-segments": 298,
                                        "binary-search-bounds": 31,
                                        "functional-red-black-tree": 69,
                                        "robust-orientation": 284
                                    }
                                ],
                                300: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("robust-dot-product"), i = t1("robust-sum");
                                        function a(t1, e1) {
                                            var r = i(n(t1, e1), [
                                                e1[e1.length - 1]
                                            ]);
                                            return r[r.length - 1];
                                        }
                                        function o(t1, e1, r, n) {
                                            var i = -e1 / (n - e1);
                                            i < 0 ? i = 0 : i > 1 && (i = 1);
                                            for(var a = 1 - i, o = t1.length, s = new Array(o), l = 0; l < o; ++l)s[l] = i * t1[l] + a * r[l];
                                            return s;
                                        }
                                        e1.exports = function(t1, e1) {
                                            for(var r = [], n = [], i = a(t1[t1.length - 1], e1), s = t1[t1.length - 1], l = t1[0], c = 0; c < t1.length; ++c, s = l){
                                                var u = a(l = t1[c], e1);
                                                if (i < 0 && u > 0 || i > 0 && u < 0) {
                                                    var f = o(s, u, l, i);
                                                    r.push(f), n.push(f.slice());
                                                }
                                                u < 0 ? n.push(l.slice()) : u > 0 ? r.push(l.slice()) : (r.push(l.slice()), n.push(l.slice())), i = u;
                                            }
                                            return {
                                                positive: r,
                                                negative: n
                                            };
                                        }, e1.exports.positive = function(t1, e1) {
                                            for(var r = [], n = a(t1[t1.length - 1], e1), i = t1[t1.length - 1], s = t1[0], l = 0; l < t1.length; ++l, i = s){
                                                var c = a(s = t1[l], e1);
                                                (n < 0 && c > 0 || n > 0 && c < 0) && r.push(o(i, c, s, n)), c >= 0 && r.push(s.slice()), n = c;
                                            }
                                            return r;
                                        }, e1.exports.negative = function(t1, e1) {
                                            for(var r = [], n = a(t1[t1.length - 1], e1), i = t1[t1.length - 1], s = t1[0], l = 0; l < t1.length; ++l, i = s){
                                                var c = a(s = t1[l], e1);
                                                (n < 0 && c > 0 || n > 0 && c < 0) && r.push(o(i, c, s, n)), c <= 0 && r.push(s.slice()), n = c;
                                            }
                                            return r;
                                        };
                                    },
                                    {
                                        "robust-dot-product": 281,
                                        "robust-sum": 289
                                    }
                                ],
                                301: [
                                    function(t1, e1, r) {
                                        !function() {
                                            "use strict";
                                            var t1 = {
                                                not_string: /[^s]/,
                                                not_bool: /[^t]/,
                                                not_type: /[^T]/,
                                                not_primitive: /[^v]/,
                                                number: /[diefg]/,
                                                numeric_arg: /[bcdiefguxX]/,
                                                json: /[j]/,
                                                not_json: /[^j]/,
                                                text: /^[^\x25]+/,
                                                modulo: /^\x25{2}/,
                                                placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
                                                key: /^([a-z_][a-z_\d]*)/i,
                                                key_access: /^\.([a-z_][a-z_\d]*)/i,
                                                index_access: /^\[(\d+)\]/,
                                                sign: /^[+-]/
                                            };
                                            function e1(t1) {
                                                return i(o(t1), arguments);
                                            }
                                            function n(t1, r) {
                                                return e1.apply(null, [
                                                    t1
                                                ].concat(r || []));
                                            }
                                            function i(r, n) {
                                                var i, a, o, s, l, c, u, f, h, p = 1, d = r.length, m = "";
                                                for(a = 0; a < d; a++)if ("string" == typeof r[a]) m += r[a];
                                                else if ("object" == typeof r[a]) {
                                                    if ((s = r[a]).keys) for(i = n[p], o = 0; o < s.keys.length; o++){
                                                        if (null == i) throw new Error(e1('[sprintf] Cannot access property "%s" of undefined value "%s"', s.keys[o], s.keys[o - 1]));
                                                        i = i[s.keys[o]];
                                                    }
                                                    else i = s.param_no ? n[s.param_no] : n[p++];
                                                    if (t1.not_type.test(s.type) && t1.not_primitive.test(s.type) && i instanceof Function && (i = i()), t1.numeric_arg.test(s.type) && "number" != typeof i && isNaN(i)) throw new TypeError(e1("[sprintf] expecting number but found %T", i));
                                                    switch(t1.number.test(s.type) && (f = i >= 0), s.type){
                                                        case "b":
                                                            i = parseInt(i, 10).toString(2);
                                                            break;
                                                        case "c":
                                                            i = String.fromCharCode(parseInt(i, 10));
                                                            break;
                                                        case "d":
                                                        case "i":
                                                            i = parseInt(i, 10);
                                                            break;
                                                        case "j":
                                                            i = JSON.stringify(i, null, s.width ? parseInt(s.width) : 0);
                                                            break;
                                                        case "e":
                                                            i = s.precision ? parseFloat(i).toExponential(s.precision) : parseFloat(i).toExponential();
                                                            break;
                                                        case "f":
                                                            i = s.precision ? parseFloat(i).toFixed(s.precision) : parseFloat(i);
                                                            break;
                                                        case "g":
                                                            i = s.precision ? String(Number(i.toPrecision(s.precision))) : parseFloat(i);
                                                            break;
                                                        case "o":
                                                            i = (parseInt(i, 10) >>> 0).toString(8);
                                                            break;
                                                        case "s":
                                                            i = String(i), i = s.precision ? i.substring(0, s.precision) : i;
                                                            break;
                                                        case "t":
                                                            i = String(!!i), i = s.precision ? i.substring(0, s.precision) : i;
                                                            break;
                                                        case "T":
                                                            i = Object.prototype.toString.call(i).slice(8, -1).toLowerCase(), i = s.precision ? i.substring(0, s.precision) : i;
                                                            break;
                                                        case "u":
                                                            i = parseInt(i, 10) >>> 0;
                                                            break;
                                                        case "v":
                                                            i = i.valueOf(), i = s.precision ? i.substring(0, s.precision) : i;
                                                            break;
                                                        case "x":
                                                            i = (parseInt(i, 10) >>> 0).toString(16);
                                                            break;
                                                        case "X":
                                                            i = (parseInt(i, 10) >>> 0).toString(16).toUpperCase();
                                                    }
                                                    t1.json.test(s.type) ? m += i : (!t1.number.test(s.type) || f && !s.sign ? h = "" : (h = f ? "+" : "-", i = i.toString().replace(t1.sign, "")), c = s.pad_char ? "0" === s.pad_char ? "0" : s.pad_char.charAt(1) : " ", u = s.width - (h + i).length, l = s.width && u > 0 ? c.repeat(u) : "", m += s.align ? h + i + l : "0" === c ? h + l + i : l + h + i);
                                                }
                                                return m;
                                            }
                                            var a = Object.create(null);
                                            function o(e1) {
                                                if (a[e1]) return a[e1];
                                                for(var r, n = e1, i = [], o = 0; n;){
                                                    if (null !== (r = t1.text.exec(n))) i.push(r[0]);
                                                    else if (null !== (r = t1.modulo.exec(n))) i.push("%");
                                                    else {
                                                        if (null === (r = t1.placeholder.exec(n))) throw new SyntaxError("[sprintf] unexpected placeholder");
                                                        if (r[2]) {
                                                            o |= 1;
                                                            var s = [], l = r[2], c = [];
                                                            if (null === (c = t1.key.exec(l))) throw new SyntaxError("[sprintf] failed to parse named argument key");
                                                            for(s.push(c[1]); "" !== (l = l.substring(c[0].length));)if (null !== (c = t1.key_access.exec(l))) s.push(c[1]);
                                                            else {
                                                                if (null === (c = t1.index_access.exec(l))) throw new SyntaxError("[sprintf] failed to parse named argument key");
                                                                s.push(c[1]);
                                                            }
                                                            r[2] = s;
                                                        } else o |= 2;
                                                        if (3 === o) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                                                        i.push({
                                                            placeholder: r[0],
                                                            param_no: r[1],
                                                            keys: r[2],
                                                            sign: r[3],
                                                            pad_char: r[4],
                                                            align: r[5],
                                                            width: r[6],
                                                            precision: r[7],
                                                            type: r[8]
                                                        });
                                                    }
                                                    n = n.substring(r[0].length);
                                                }
                                                return a[e1] = i;
                                            }
                                            void 0 !== r && (r.sprintf = e1, r.vsprintf = n), "undefined" != typeof window && (window.sprintf = e1, window.vsprintf = n);
                                        }();
                                    },
                                    {}
                                ],
                                302: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            if (t1.dimension <= 0) return {
                                                positions: [],
                                                cells: []
                                            };
                                            if (1 === t1.dimension) return function(t1, e1) {
                                                for(var r = i(t1, e1), n = r.length, a = new Array(n), o = new Array(n), s = 0; s < n; ++s)a[s] = [
                                                    r[s]
                                                ], o[s] = [
                                                    s
                                                ];
                                                return {
                                                    positions: a,
                                                    cells: o
                                                };
                                            }(t1, e1);
                                            var r = t1.order.join() + "-" + t1.dtype, s = o[r];
                                            e1 = +e1 || 0;
                                            s || (s = o[r] = function(t1, e1) {
                                                var r = t1.length + "d", i = a[r];
                                                if (i) return i(n, t1, e1);
                                            }(t1.order, t1.dtype));
                                            return s(t1, e1);
                                        };
                                        var n = t1("ndarray-extract-contour"), i = t1("zero-crossings"), a = {
                                            "2d": function(t1, e1, r) {
                                                var n = t1({
                                                    order: e1,
                                                    scalarArguments: 3,
                                                    getters: "generic" === r ? [
                                                        0
                                                    ] : void 0,
                                                    phase: function(t1, e1, r, n) {
                                                        return t1 > n | 0;
                                                    },
                                                    vertex: function(t1, e1, r, n, i, a, o, s, l, c, u, f, h) {
                                                        var p = (o << 0) + (s << 1) + (l << 2) + (c << 3) | 0;
                                                        if (0 !== p && 15 !== p) switch(p){
                                                            case 0:
                                                                u.push([
                                                                    t1 - .5,
                                                                    e1 - .5
                                                                ]);
                                                                break;
                                                            case 1:
                                                                u.push([
                                                                    t1 - .25 - .25 * (n + r - 2 * h) / (r - n),
                                                                    e1 - .25 - .25 * (i + r - 2 * h) / (r - i)
                                                                ]);
                                                                break;
                                                            case 2:
                                                                u.push([
                                                                    t1 - .75 - .25 * (-n - r + 2 * h) / (n - r),
                                                                    e1 - .25 - .25 * (a + n - 2 * h) / (n - a)
                                                                ]);
                                                                break;
                                                            case 3:
                                                                u.push([
                                                                    t1 - .5,
                                                                    e1 - .5 - .5 * (i + r + a + n - 4 * h) / (r - i + n - a)
                                                                ]);
                                                                break;
                                                            case 4:
                                                                u.push([
                                                                    t1 - .25 - .25 * (a + i - 2 * h) / (i - a),
                                                                    e1 - .75 - .25 * (-i - r + 2 * h) / (i - r)
                                                                ]);
                                                                break;
                                                            case 5:
                                                                u.push([
                                                                    t1 - .5 - .5 * (n + r + a + i - 4 * h) / (r - n + i - a),
                                                                    e1 - .5
                                                                ]);
                                                                break;
                                                            case 6:
                                                                u.push([
                                                                    t1 - .5 - .25 * (-n - r + a + i) / (n - r + i - a),
                                                                    e1 - .5 - .25 * (-i - r + a + n) / (i - r + n - a)
                                                                ]);
                                                                break;
                                                            case 7:
                                                                u.push([
                                                                    t1 - .75 - .25 * (a + i - 2 * h) / (i - a),
                                                                    e1 - .75 - .25 * (a + n - 2 * h) / (n - a)
                                                                ]);
                                                                break;
                                                            case 8:
                                                                u.push([
                                                                    t1 - .75 - .25 * (-a - i + 2 * h) / (a - i),
                                                                    e1 - .75 - .25 * (-a - n + 2 * h) / (a - n)
                                                                ]);
                                                                break;
                                                            case 9:
                                                                u.push([
                                                                    t1 - .5 - .25 * (n + r + -a - i) / (r - n + a - i),
                                                                    e1 - .5 - .25 * (i + r + -a - n) / (r - i + a - n)
                                                                ]);
                                                                break;
                                                            case 10:
                                                                u.push([
                                                                    t1 - .5 - .5 * (-n - r - a - i + 4 * h) / (n - r + a - i),
                                                                    e1 - .5
                                                                ]);
                                                                break;
                                                            case 11:
                                                                u.push([
                                                                    t1 - .25 - .25 * (-a - i + 2 * h) / (a - i),
                                                                    e1 - .75 - .25 * (i + r - 2 * h) / (r - i)
                                                                ]);
                                                                break;
                                                            case 12:
                                                                u.push([
                                                                    t1 - .5,
                                                                    e1 - .5 - .5 * (-i - r - a - n + 4 * h) / (i - r + a - n)
                                                                ]);
                                                                break;
                                                            case 13:
                                                                u.push([
                                                                    t1 - .75 - .25 * (n + r - 2 * h) / (r - n),
                                                                    e1 - .25 - .25 * (-a - n + 2 * h) / (a - n)
                                                                ]);
                                                                break;
                                                            case 14:
                                                                u.push([
                                                                    t1 - .25 - .25 * (-n - r + 2 * h) / (n - r),
                                                                    e1 - .25 - .25 * (-i - r + 2 * h) / (i - r)
                                                                ]);
                                                                break;
                                                            case 15:
                                                                u.push([
                                                                    t1 - .5,
                                                                    e1 - .5
                                                                ]);
                                                        }
                                                    },
                                                    cell: function(t1, e1, r, n, i, a, o, s, l) {
                                                        i ? s.push([
                                                            t1,
                                                            e1
                                                        ]) : s.push([
                                                            e1,
                                                            t1
                                                        ]);
                                                    }
                                                });
                                                return function(t1, e1) {
                                                    var r = [], i = [];
                                                    return n(t1, r, i, e1), {
                                                        positions: r,
                                                        cells: i
                                                    };
                                                };
                                            }
                                        };
                                        var o = {};
                                    },
                                    {
                                        "ndarray-extract-contour": 251,
                                        "zero-crossings": 318
                                    }
                                ],
                                303: [
                                    function(t1, e1, r) {
                                        (function(r) {
                                            (function() {
                                                "use strict";
                                                e1.exports = function t1(e1, r, i) {
                                                    i = i || {};
                                                    var o = a[e1];
                                                    o || (o = a[e1] = {
                                                        " ": {
                                                            data: new Float32Array(0),
                                                            shape: .2
                                                        }
                                                    });
                                                    var s = o[r];
                                                    if (!s) {
                                                        if (r.length <= 1 || !/\d/.test(r)) s = o[r] = function(t1) {
                                                            for(var e1 = t1.cells, r = t1.positions, n = new Float32Array(6 * e1.length), i = 0, a = 0, o = 0; o < e1.length; ++o)for(var s = e1[o], l = 0; l < 3; ++l){
                                                                var c = r[s[l]];
                                                                n[i++] = c[0], n[i++] = c[1] + 1.4, a = Math.max(c[0], a);
                                                            }
                                                            return {
                                                                data: n,
                                                                shape: a
                                                            };
                                                        }(n(r, {
                                                            triangles: !0,
                                                            font: e1,
                                                            textAlign: i.textAlign || "left",
                                                            textBaseline: "alphabetic",
                                                            styletags: {
                                                                breaklines: !0,
                                                                bolds: !0,
                                                                italics: !0,
                                                                subscripts: !0,
                                                                superscripts: !0
                                                            }
                                                        }));
                                                        else {
                                                            for(var l = r.split(/(\d|\s)/), c = new Array(l.length), u = 0, f = 0, h = 0; h < l.length; ++h)c[h] = t1(e1, l[h]), u += c[h].data.length, f += c[h].shape, h > 0 && (f += .02);
                                                            var p = new Float32Array(u), d = 0, m = -0.5 * f;
                                                            for(h = 0; h < c.length; ++h){
                                                                for(var g = c[h].data, v = 0; v < g.length; v += 2)p[d++] = g[v] + m, p[d++] = g[v + 1];
                                                                m += c[h].shape + .02;
                                                            }
                                                            s = o[r] = {
                                                                data: p,
                                                                shape: f
                                                            };
                                                        }
                                                    }
                                                    return s;
                                                };
                                                var n = t1("vectorize-text"), i = window || r.global || {}, a = i.__TEXT_CACHE || {};
                                                i.__TEXT_CACHE = {};
                                            }).call(this);
                                        }).call(this, t1("_process"));
                                    },
                                    {
                                        _process: 5,
                                        "vectorize-text": 311
                                    }
                                ],
                                304: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n = t1("parse-unit");
                                        e1.exports = a;
                                        function i(t1, e1) {
                                            var r = n(getComputedStyle(t1).getPropertyValue(e1));
                                            return r[0] * a(r[1], t1);
                                        }
                                        function a(t1, e1) {
                                            switch(e1 = e1 || document.body, t1 = (t1 || "px").trim().toLowerCase(), e1 !== window && e1 !== document || (e1 = document.body), t1){
                                                case "%":
                                                    return e1.clientHeight / 100;
                                                case "ch":
                                                case "ex":
                                                    return function(t1, e1) {
                                                        var r = document.createElement("div");
                                                        r.style["font-size"] = "128" + t1, e1.appendChild(r);
                                                        var n = i(r, "font-size") / 128;
                                                        return e1.removeChild(r), n;
                                                    }(t1, e1);
                                                case "em":
                                                    return i(e1, "font-size");
                                                case "rem":
                                                    return i(document.body, "font-size");
                                                case "vw":
                                                    return window.innerWidth / 100;
                                                case "vh":
                                                    return window.innerHeight / 100;
                                                case "vmin":
                                                    return Math.min(window.innerWidth, window.innerHeight) / 100;
                                                case "vmax":
                                                    return Math.max(window.innerWidth, window.innerHeight) / 100;
                                                case "in":
                                                    return 96;
                                                case "cm":
                                                    return 96 / 2.54;
                                                case "mm":
                                                    return 96 / 25.4;
                                                case "pt":
                                                    return 96 / 72;
                                                case "pc":
                                                    return 16;
                                            }
                                            return 1;
                                        }
                                    },
                                    {
                                        "parse-unit": 265
                                    }
                                ],
                                305: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1) {
                                            var e1 = (t1 = t1 || {}).center || [
                                                0,
                                                0,
                                                0
                                            ], r = t1.up || [
                                                0,
                                                1,
                                                0
                                            ], n = t1.right || f(r), i = t1.radius || 1, a = t1.theta || 0, u = t1.phi || 0;
                                            if (e1 = [].slice.call(e1, 0, 3), r = [].slice.call(r, 0, 3), s(r, r), n = [].slice.call(n, 0, 3), s(n, n), "eye" in t1) {
                                                var p = t1.eye, d = [
                                                    p[0] - e1[0],
                                                    p[1] - e1[1],
                                                    p[2] - e1[2]
                                                ];
                                                o(n, d, r), c(n[0], n[1], n[2]) < 1e-6 ? n = f(r) : s(n, n), i = c(d[0], d[1], d[2]);
                                                var m = l(r, d) / i, g = l(n, d) / i;
                                                u = Math.acos(m), a = Math.acos(g);
                                            }
                                            return i = Math.log(i), new h(t1.zoomMin, t1.zoomMax, e1, r, n, i, a, u);
                                        };
                                        var n = t1("filtered-vector"), i = t1("gl-mat4/invert"), a = t1("gl-mat4/rotate"), o = t1("gl-vec3/cross"), s = t1("gl-vec3/normalize"), l = t1("gl-vec3/dot");
                                        function c(t1, e1, r) {
                                            return Math.sqrt(Math.pow(t1, 2) + Math.pow(e1, 2) + Math.pow(r, 2));
                                        }
                                        function u(t1) {
                                            return Math.min(1, Math.max(-1, t1));
                                        }
                                        function f(t1) {
                                            var e1 = Math.abs(t1[0]), r = Math.abs(t1[1]), n = Math.abs(t1[2]), i = [
                                                0,
                                                0,
                                                0
                                            ];
                                            e1 > Math.max(r, n) ? i[2] = 1 : r > Math.max(e1, n) ? i[0] = 1 : i[1] = 1;
                                            for(var a = 0, o = 0, l = 0; l < 3; ++l)a += t1[l] * t1[l], o += i[l] * t1[l];
                                            for(l = 0; l < 3; ++l)i[l] -= o / a * t1[l];
                                            return s(i, i), i;
                                        }
                                        function h(t1, e1, r, i, a, o, s, l) {
                                            this.center = n(r), this.up = n(i), this.right = n(a), this.radius = n([
                                                o
                                            ]), this.angle = n([
                                                s,
                                                l
                                            ]), this.angle.bounds = [
                                                [
                                                    -1 / 0,
                                                    -Math.PI / 2
                                                ],
                                                [
                                                    1 / 0,
                                                    Math.PI / 2
                                                ]
                                            ], this.setDistanceLimits(t1, e1), this.computedCenter = this.center.curve(0), this.computedUp = this.up.curve(0), this.computedRight = this.right.curve(0), this.computedRadius = this.radius.curve(0), this.computedAngle = this.angle.curve(0), this.computedToward = [
                                                0,
                                                0,
                                                0
                                            ], this.computedEye = [
                                                0,
                                                0,
                                                0
                                            ], this.computedMatrix = new Array(16);
                                            for(var c = 0; c < 16; ++c)this.computedMatrix[c] = .5;
                                            this.recalcMatrix(0);
                                        }
                                        var p = h.prototype;
                                        p.setDistanceLimits = function(t1, e1) {
                                            t1 = t1 > 0 ? Math.log(t1) : -1 / 0, e1 = e1 > 0 ? Math.log(e1) : 1 / 0, e1 = Math.max(e1, t1), this.radius.bounds[0][0] = t1, this.radius.bounds[1][0] = e1;
                                        }, p.getDistanceLimits = function(t1) {
                                            var e1 = this.radius.bounds[0];
                                            return t1 ? (t1[0] = Math.exp(e1[0][0]), t1[1] = Math.exp(e1[1][0]), t1) : [
                                                Math.exp(e1[0][0]),
                                                Math.exp(e1[1][0])
                                            ];
                                        }, p.recalcMatrix = function(t1) {
                                            this.center.curve(t1), this.up.curve(t1), this.right.curve(t1), this.radius.curve(t1), this.angle.curve(t1);
                                            for(var e1 = this.computedUp, r = this.computedRight, n = 0, i = 0, a = 0; a < 3; ++a)i += e1[a] * r[a], n += e1[a] * e1[a];
                                            var l = Math.sqrt(n), u = 0;
                                            for(a = 0; a < 3; ++a)r[a] -= e1[a] * i / n, u += r[a] * r[a], e1[a] /= l;
                                            var f = Math.sqrt(u);
                                            for(a = 0; a < 3; ++a)r[a] /= f;
                                            var h = this.computedToward;
                                            o(h, e1, r), s(h, h);
                                            var p = Math.exp(this.computedRadius[0]), d = this.computedAngle[0], m = this.computedAngle[1], g = Math.cos(d), v = Math.sin(d), y = Math.cos(m), x = Math.sin(m), b = this.computedCenter, _ = g * y, w = v * y, T = x, k = -g * x, A = -v * x, M = y, S = this.computedEye, E = this.computedMatrix;
                                            for(a = 0; a < 3; ++a){
                                                var L = _ * r[a] + w * h[a] + T * e1[a];
                                                E[4 * a + 1] = k * r[a] + A * h[a] + M * e1[a], E[4 * a + 2] = L, E[4 * a + 3] = 0;
                                            }
                                            var C = E[1], P = E[5], I = E[9], O = E[2], z = E[6], D = E[10], R = P * D - I * z, F = I * O - C * D, B = C * z - P * O, N = c(R, F, B);
                                            R /= N, F /= N, B /= N, E[0] = R, E[4] = F, E[8] = B;
                                            for(a = 0; a < 3; ++a)S[a] = b[a] + E[2 + 4 * a] * p;
                                            for(a = 0; a < 3; ++a){
                                                u = 0;
                                                for(var j = 0; j < 3; ++j)u += E[a + 4 * j] * S[j];
                                                E[12 + a] = -u;
                                            }
                                            E[15] = 1;
                                        }, p.getMatrix = function(t1, e1) {
                                            this.recalcMatrix(t1);
                                            var r = this.computedMatrix;
                                            if (e1) {
                                                for(var n = 0; n < 16; ++n)e1[n] = r[n];
                                                return e1;
                                            }
                                            return r;
                                        };
                                        var d = [
                                            0,
                                            0,
                                            0
                                        ];
                                        p.rotate = function(t1, e1, r, n) {
                                            if (this.angle.move(t1, e1, r), n) {
                                                this.recalcMatrix(t1);
                                                var i = this.computedMatrix;
                                                d[0] = i[2], d[1] = i[6], d[2] = i[10];
                                                for(var o = this.computedUp, s = this.computedRight, l = this.computedToward, c = 0; c < 3; ++c)i[4 * c] = o[c], i[4 * c + 1] = s[c], i[4 * c + 2] = l[c];
                                                a(i, i, n, d);
                                                for(c = 0; c < 3; ++c)o[c] = i[4 * c], s[c] = i[4 * c + 1];
                                                this.up.set(t1, o[0], o[1], o[2]), this.right.set(t1, s[0], s[1], s[2]);
                                            }
                                        }, p.pan = function(t1, e1, r, n) {
                                            e1 = e1 || 0, r = r || 0, n = n || 0, this.recalcMatrix(t1);
                                            var i = this.computedMatrix, a = (Math.exp(this.computedRadius[0]), i[1]), o = i[5], s = i[9], l = c(a, o, s);
                                            a /= l, o /= l, s /= l;
                                            var u = i[0], f = i[4], h = i[8], p = u * a + f * o + h * s, d = c(u -= a * p, f -= o * p, h -= s * p), m = (u /= d) * e1 + a * r, g = (f /= d) * e1 + o * r, v = (h /= d) * e1 + s * r;
                                            this.center.move(t1, m, g, v);
                                            var y = Math.exp(this.computedRadius[0]);
                                            y = Math.max(1e-4, y + n), this.radius.set(t1, Math.log(y));
                                        }, p.translate = function(t1, e1, r, n) {
                                            this.center.move(t1, e1 || 0, r || 0, n || 0);
                                        }, p.setMatrix = function(t1, e1, r, n) {
                                            var a = 1;
                                            "number" == typeof r && (a = 0 | r), (a < 0 || a > 3) && (a = 1);
                                            var o = (a + 2) % 3;
                                            e1 || (this.recalcMatrix(t1), e1 = this.computedMatrix);
                                            var s = e1[a], l = e1[a + 4], f = e1[a + 8];
                                            if (n) {
                                                var h = Math.abs(s), p = Math.abs(l), d = Math.abs(f), m = Math.max(h, p, d);
                                                h === m ? (s = s < 0 ? -1 : 1, l = f = 0) : d === m ? (f = f < 0 ? -1 : 1, s = l = 0) : (l = l < 0 ? -1 : 1, s = f = 0);
                                            } else {
                                                var g = c(s, l, f);
                                                s /= g, l /= g, f /= g;
                                            }
                                            var v, y, x = e1[o], b = e1[o + 4], _ = e1[o + 8], w = x * s + b * l + _ * f, T = c(x -= s * w, b -= l * w, _ -= f * w), k = l * (_ /= T) - f * (b /= T), A = f * (x /= T) - s * _, M = s * b - l * x, S = c(k, A, M);
                                            if (k /= S, A /= S, M /= S, this.center.jump(t1, q, G, Y), this.radius.idle(t1), this.up.jump(t1, s, l, f), this.right.jump(t1, x, b, _), 2 === a) {
                                                var E = e1[1], L = e1[5], C = e1[9], P = E * x + L * b + C * _, I = E * k + L * A + C * M;
                                                v = R < 0 ? -Math.PI / 2 : Math.PI / 2, y = Math.atan2(I, P);
                                            } else {
                                                var O = e1[2], z = e1[6], D = e1[10], R = O * s + z * l + D * f, F = O * x + z * b + D * _, B = O * k + z * A + D * M;
                                                v = Math.asin(u(R)), y = Math.atan2(B, F);
                                            }
                                            this.angle.jump(t1, y, v), this.recalcMatrix(t1);
                                            var N = e1[2], j = e1[6], U = e1[10], V = this.computedMatrix;
                                            i(V, e1);
                                            var H = V[15], q = V[12] / H, G = V[13] / H, Y = V[14] / H, W = Math.exp(this.computedRadius[0]);
                                            this.center.jump(t1, q - N * W, G - j * W, Y - U * W);
                                        }, p.lastT = function() {
                                            return Math.max(this.center.lastT(), this.up.lastT(), this.right.lastT(), this.radius.lastT(), this.angle.lastT());
                                        }, p.idle = function(t1) {
                                            this.center.idle(t1), this.up.idle(t1), this.right.idle(t1), this.radius.idle(t1), this.angle.idle(t1);
                                        }, p.flush = function(t1) {
                                            this.center.flush(t1), this.up.flush(t1), this.right.flush(t1), this.radius.flush(t1), this.angle.flush(t1);
                                        }, p.setDistance = function(t1, e1) {
                                            e1 > 0 && this.radius.set(t1, Math.log(e1));
                                        }, p.lookAt = function(t1, e1, r, n) {
                                            this.recalcMatrix(t1), e1 = e1 || this.computedEye, r = r || this.computedCenter;
                                            var i = (n = n || this.computedUp)[0], a = n[1], o = n[2], s = c(i, a, o);
                                            if (!(s < 1e-6)) {
                                                i /= s, a /= s, o /= s;
                                                var l = e1[0] - r[0], f = e1[1] - r[1], h = e1[2] - r[2], p = c(l, f, h);
                                                if (!(p < 1e-6)) {
                                                    l /= p, f /= p, h /= p;
                                                    var d = this.computedRight, m = d[0], g = d[1], v = d[2], y = i * m + a * g + o * v, x = c(m -= y * i, g -= y * a, v -= y * o);
                                                    if (!(x < .01 && (x = c(m = a * h - o * f, g = o * l - i * h, v = i * f - a * l)) < 1e-6)) {
                                                        m /= x, g /= x, v /= x, this.up.set(t1, i, a, o), this.right.set(t1, m, g, v), this.center.set(t1, r[0], r[1], r[2]), this.radius.set(t1, Math.log(p));
                                                        var b = a * v - o * g, _ = o * m - i * v, w = i * g - a * m, T = c(b, _, w), k = i * l + a * f + o * h, A = m * l + g * f + v * h, M = (b /= T) * l + (_ /= T) * f + (w /= T) * h, S = Math.asin(u(k)), E = Math.atan2(M, A), L = this.angle._state, C = L[L.length - 1], P = L[L.length - 2];
                                                        C %= 2 * Math.PI;
                                                        var I = Math.abs(C + 2 * Math.PI - E), O = Math.abs(C - E), z = Math.abs(C - 2 * Math.PI - E);
                                                        I < O && (C += 2 * Math.PI), z < O && (C -= 2 * Math.PI), this.angle.jump(this.angle.lastT(), C, P), this.angle.set(t1, E, S);
                                                    }
                                                }
                                            }
                                        };
                                    },
                                    {
                                        "filtered-vector": 68,
                                        "gl-mat4/invert": 98,
                                        "gl-mat4/rotate": 103,
                                        "gl-vec3/cross": 157,
                                        "gl-vec3/dot": 162,
                                        "gl-vec3/normalize": 179
                                    }
                                ],
                                306: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r) {
                                            var i = t1 * e1, a = n * t1, o = a - (a - t1), s = t1 - o, l = n * e1, c = l - (l - e1), u = e1 - c, f = s * u - (i - o * c - s * c - o * u);
                                            if (r) return r[0] = f, r[1] = i, r;
                                            return [
                                                f,
                                                i
                                            ];
                                        };
                                        var n = +(Math.pow(2, 27) + 1);
                                    },
                                    {}
                                ],
                                307: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r) {
                                            var n = t1 + e1, i = n - t1, a = e1 - i, o = t1 - (n - i);
                                            if (r) return r[0] = o + a, r[1] = n, r;
                                            return [
                                                o + a,
                                                n
                                            ];
                                        };
                                    },
                                    {}
                                ],
                                308: [
                                    function(t1, e1, r) {
                                        (function(e1) {
                                            (function() {
                                                "use strict";
                                                var n = t1("bit-twiddle"), i = t1("dup"), a = t1("buffer").Buffer;
                                                e1.__TYPEDARRAY_POOL || (e1.__TYPEDARRAY_POOL = {
                                                    UINT8: i([
                                                        32,
                                                        0
                                                    ]),
                                                    UINT16: i([
                                                        32,
                                                        0
                                                    ]),
                                                    UINT32: i([
                                                        32,
                                                        0
                                                    ]),
                                                    BIGUINT64: i([
                                                        32,
                                                        0
                                                    ]),
                                                    INT8: i([
                                                        32,
                                                        0
                                                    ]),
                                                    INT16: i([
                                                        32,
                                                        0
                                                    ]),
                                                    INT32: i([
                                                        32,
                                                        0
                                                    ]),
                                                    BIGINT64: i([
                                                        32,
                                                        0
                                                    ]),
                                                    FLOAT: i([
                                                        32,
                                                        0
                                                    ]),
                                                    DOUBLE: i([
                                                        32,
                                                        0
                                                    ]),
                                                    DATA: i([
                                                        32,
                                                        0
                                                    ]),
                                                    UINT8C: i([
                                                        32,
                                                        0
                                                    ]),
                                                    BUFFER: i([
                                                        32,
                                                        0
                                                    ])
                                                });
                                                var o = "undefined" != typeof Uint8ClampedArray, s = "undefined" != typeof BigUint64Array, l = "undefined" != typeof BigInt64Array, c = e1.__TYPEDARRAY_POOL;
                                                c.UINT8C || (c.UINT8C = i([
                                                    32,
                                                    0
                                                ])), c.BIGUINT64 || (c.BIGUINT64 = i([
                                                    32,
                                                    0
                                                ])), c.BIGINT64 || (c.BIGINT64 = i([
                                                    32,
                                                    0
                                                ])), c.BUFFER || (c.BUFFER = i([
                                                    32,
                                                    0
                                                ]));
                                                var u = c.DATA, f = c.BUFFER;
                                                function h(t1) {
                                                    if (t1) {
                                                        var e1 = t1.length || t1.byteLength, r = n.log2(e1);
                                                        u[r].push(t1);
                                                    }
                                                }
                                                function p(t1) {
                                                    t1 = n.nextPow2(t1);
                                                    var e1 = n.log2(t1), r = u[e1];
                                                    return r.length > 0 ? r.pop() : new ArrayBuffer(t1);
                                                }
                                                function d(t1) {
                                                    return new Uint8Array(p(t1), 0, t1);
                                                }
                                                function m(t1) {
                                                    return new Uint16Array(p(2 * t1), 0, t1);
                                                }
                                                function g(t1) {
                                                    return new Uint32Array(p(4 * t1), 0, t1);
                                                }
                                                function v(t1) {
                                                    return new Int8Array(p(t1), 0, t1);
                                                }
                                                function y(t1) {
                                                    return new Int16Array(p(2 * t1), 0, t1);
                                                }
                                                function x(t1) {
                                                    return new Int32Array(p(4 * t1), 0, t1);
                                                }
                                                function b(t1) {
                                                    return new Float32Array(p(4 * t1), 0, t1);
                                                }
                                                function _(t1) {
                                                    return new Float64Array(p(8 * t1), 0, t1);
                                                }
                                                function w(t1) {
                                                    return o ? new Uint8ClampedArray(p(t1), 0, t1) : d(t1);
                                                }
                                                function T(t1) {
                                                    return s ? new BigUint64Array(p(8 * t1), 0, t1) : null;
                                                }
                                                function k(t1) {
                                                    return l ? new BigInt64Array(p(8 * t1), 0, t1) : null;
                                                }
                                                function A(t1) {
                                                    return new DataView(p(t1), 0, t1);
                                                }
                                                function M(t1) {
                                                    t1 = n.nextPow2(t1);
                                                    var e1 = n.log2(t1), r = f[e1];
                                                    return r.length > 0 ? r.pop() : new a(t1);
                                                }
                                                r.free = function(t1) {
                                                    if (a.isBuffer(t1)) f[n.log2(t1.length)].push(t1);
                                                    else {
                                                        if ("[object ArrayBuffer]" !== Object.prototype.toString.call(t1) && (t1 = t1.buffer), !t1) return;
                                                        var e1 = t1.length || t1.byteLength, r = 0 | n.log2(e1);
                                                        u[r].push(t1);
                                                    }
                                                }, r.freeUint8 = r.freeUint16 = r.freeUint32 = r.freeBigUint64 = r.freeInt8 = r.freeInt16 = r.freeInt32 = r.freeBigInt64 = r.freeFloat32 = r.freeFloat = r.freeFloat64 = r.freeDouble = r.freeUint8Clamped = r.freeDataView = function(t1) {
                                                    h(t1.buffer);
                                                }, r.freeArrayBuffer = h, r.freeBuffer = function(t1) {
                                                    f[n.log2(t1.length)].push(t1);
                                                }, r.malloc = function(t1, e1) {
                                                    if (void 0 === e1 || "arraybuffer" === e1) return p(t1);
                                                    switch(e1){
                                                        case "uint8":
                                                            return d(t1);
                                                        case "uint16":
                                                            return m(t1);
                                                        case "uint32":
                                                            return g(t1);
                                                        case "int8":
                                                            return v(t1);
                                                        case "int16":
                                                            return y(t1);
                                                        case "int32":
                                                            return x(t1);
                                                        case "float":
                                                        case "float32":
                                                            return b(t1);
                                                        case "double":
                                                        case "float64":
                                                            return _(t1);
                                                        case "uint8_clamped":
                                                            return w(t1);
                                                        case "bigint64":
                                                            return k(t1);
                                                        case "biguint64":
                                                            return T(t1);
                                                        case "buffer":
                                                            return M(t1);
                                                        case "data":
                                                        case "dataview":
                                                            return A(t1);
                                                        default:
                                                            return null;
                                                    }
                                                    return null;
                                                }, r.mallocArrayBuffer = p, r.mallocUint8 = d, r.mallocUint16 = m, r.mallocUint32 = g, r.mallocInt8 = v, r.mallocInt16 = y, r.mallocInt32 = x, r.mallocFloat32 = r.mallocFloat = b, r.mallocFloat64 = r.mallocDouble = _, r.mallocUint8Clamped = w, r.mallocBigUint64 = T, r.mallocBigInt64 = k, r.mallocDataView = A, r.mallocBuffer = M, r.clearCache = function() {
                                                    for(var t1 = 0; t1 < 32; ++t1)c.UINT8[t1].length = 0, c.UINT16[t1].length = 0, c.UINT32[t1].length = 0, c.INT8[t1].length = 0, c.INT16[t1].length = 0, c.INT32[t1].length = 0, c.FLOAT[t1].length = 0, c.DOUBLE[t1].length = 0, c.BIGUINT64[t1].length = 0, c.BIGINT64[t1].length = 0, c.UINT8C[t1].length = 0, u[t1].length = 0, f[t1].length = 0;
                                                };
                                            }).call(this);
                                        }).call(this, void 0 !== n ? n : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {
                                        "bit-twiddle": 32,
                                        buffer: 3,
                                        dup: 65
                                    }
                                ],
                                309: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        function n(t1) {
                                            this.roots = new Array(t1), this.ranks = new Array(t1);
                                            for(var e1 = 0; e1 < t1; ++e1)this.roots[e1] = e1, this.ranks[e1] = 0;
                                        }
                                        e1.exports = n;
                                        var i = n.prototype;
                                        Object.defineProperty(i, "length", {
                                            get: function() {
                                                return this.roots.length;
                                            }
                                        }), i.makeSet = function() {
                                            var t1 = this.roots.length;
                                            return this.roots.push(t1), this.ranks.push(0), t1;
                                        }, i.find = function(t1) {
                                            for(var e1 = t1, r = this.roots; r[t1] !== t1;)t1 = r[t1];
                                            for(; r[e1] !== t1;){
                                                var n = r[e1];
                                                r[e1] = t1, e1 = n;
                                            }
                                            return t1;
                                        }, i.link = function(t1, e1) {
                                            var r = this.find(t1), n = this.find(e1);
                                            if (r !== n) {
                                                var i = this.ranks, a = this.roots, o = i[r], s = i[n];
                                                o < s ? a[r] = n : s < o ? a[n] = r : (a[n] = r, ++i[r]);
                                            }
                                        };
                                    },
                                    {}
                                ],
                                310: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1, r) {
                                            return 0 === t1.length ? t1 : e1 ? (r || t1.sort(e1), function(t1, e1) {
                                                for(var r = 1, n = t1.length, i = t1[0], a = t1[0], o = 1; o < n; ++o)if (a = i, e1(i = t1[o], a)) {
                                                    if (o === r) {
                                                        r++;
                                                        continue;
                                                    }
                                                    t1[r++] = i;
                                                }
                                                return t1.length = r, t1;
                                            }(t1, e1)) : (r || t1.sort(), function(t1) {
                                                for(var e1 = 1, r = t1.length, n = t1[0], i = t1[0], a = 1; a < r; ++a, i = n)if (i = n, (n = t1[a]) !== i) {
                                                    if (a === e1) {
                                                        e1++;
                                                        continue;
                                                    }
                                                    t1[e1++] = n;
                                                }
                                                return t1.length = e1, t1;
                                            }(t1));
                                        };
                                    },
                                    {}
                                ],
                                311: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            "object" == typeof e1 && null !== e1 || (e1 = {});
                                            return n(t1, e1.canvas || i, e1.context || a, e1);
                                        };
                                        var n = t1("./lib/vtext"), i = null, a = null;
                                        "undefined" != typeof document && ((i = document.createElement("canvas")).width = 8192, i.height = 1024, a = i.getContext("2d"));
                                    },
                                    {
                                        "./lib/vtext": 312
                                    }
                                ],
                                312: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1, r, n) {
                                            var a = 64, o = 1.25, s = {
                                                breaklines: !1,
                                                bolds: !1,
                                                italics: !1,
                                                subscripts: !1,
                                                superscripts: !1
                                            };
                                            n && (n.size && n.size > 0 && (a = n.size), n.lineSpacing && n.lineSpacing > 0 && (o = n.lineSpacing), n.styletags && n.styletags.breaklines && (s.breaklines = !!n.styletags.breaklines), n.styletags && n.styletags.bolds && (s.bolds = !!n.styletags.bolds), n.styletags && n.styletags.italics && (s.italics = !!n.styletags.italics), n.styletags && n.styletags.subscripts && (s.subscripts = !!n.styletags.subscripts), n.styletags && n.styletags.superscripts && (s.superscripts = !!n.styletags.superscripts));
                                            return r.font = [
                                                n.fontStyle,
                                                n.fontVariant,
                                                n.fontWeight,
                                                a + "px",
                                                n.font
                                            ].filter(function(t1) {
                                                return t1;
                                            }).join(" "), r.textAlign = "start", r.textBaseline = "alphabetic", r.direction = "ltr", h(function(t1, e1, r, n, a, o) {
                                                r = r.replace(/\n/g, ""), r = !0 === o.breaklines ? r.replace(/\<br\>/g, "\n") : r.replace(/\<br\>/g, " ");
                                                var s = "", l = [];
                                                for(p = 0; p < r.length; ++p)l[p] = s;
                                                !0 === o.bolds && (l = c("b", "b|", r, l));
                                                !0 === o.italics && (l = c("i", "i|", r, l));
                                                !0 === o.superscripts && (l = c("sup", "+1", r, l));
                                                !0 === o.subscripts && (l = c("sub", "-1", r, l));
                                                var u = [], f = "";
                                                for(p = 0; p < r.length; ++p)null !== l[p] && (f += r[p], u.push(l[p]));
                                                var h, p, d, m, g, v = f.split("\n"), y = v.length, x = Math.round(a * n), b = n, _ = 2 * n, w = 0, T = y * x + _;
                                                t1.height < T && (t1.height = T);
                                                e1.fillStyle = "#000", e1.fillRect(0, 0, t1.width, t1.height), e1.fillStyle = "#fff";
                                                var k = 0, A = "";
                                                function M() {
                                                    if ("" !== A) {
                                                        var t1 = e1.measureText(A).width;
                                                        e1.fillText(A, b + d, _ + m), d += t1;
                                                    }
                                                }
                                                function S() {
                                                    return Math.round(g) + "px ";
                                                }
                                                function E(t1, r) {
                                                    var n = "" + e1.font;
                                                    if (!0 === o.subscripts) {
                                                        var i = t1.indexOf("-"), a = r.indexOf("-"), s = i > -1 ? parseInt(t1[1 + i]) : 0, l = a > -1 ? parseInt(r[1 + a]) : 0;
                                                        s !== l && (n = n.replace(S(), "?px "), g *= Math.pow(.75, l - s), n = n.replace("?px ", S())), m += .25 * x * (l - s);
                                                    }
                                                    if (!0 === o.superscripts) {
                                                        var c = t1.indexOf("+"), u = r.indexOf("+"), f = c > -1 ? parseInt(t1[1 + c]) : 0, h = u > -1 ? parseInt(r[1 + u]) : 0;
                                                        f !== h && (n = n.replace(S(), "?px "), g *= Math.pow(.75, h - f), n = n.replace("?px ", S())), m -= .25 * x * (h - f);
                                                    }
                                                    if (!0 === o.bolds) {
                                                        var p = t1.indexOf("b|") > -1, d = r.indexOf("b|") > -1;
                                                        !p && d && (n = v ? n.replace("italic ", "italic bold ") : "bold " + n), p && !d && (n = n.replace("bold ", ""));
                                                    }
                                                    if (!0 === o.italics) {
                                                        var v = t1.indexOf("i|") > -1, y = r.indexOf("i|") > -1;
                                                        !v && y && (n = "italic " + n), v && !y && (n = n.replace("italic ", ""));
                                                    }
                                                    e1.font = n;
                                                }
                                                for(h = 0; h < y; ++h){
                                                    var L = v[h] + "\n";
                                                    for(d = 0, m = h * x, g = n, A = "", p = 0; p < L.length; ++p){
                                                        var C = p + k < u.length ? u[p + k] : u[u.length - 1];
                                                        s === C ? A += L[p] : (M(), A = L[p], void 0 !== C && (E(s, C), s = C));
                                                    }
                                                    M(), k += L.length;
                                                    var P = 0 | Math.round(d + 2 * b);
                                                    w < P && (w = P);
                                                }
                                                var I = w, O = _ + x * y;
                                                return i(e1.getImageData(0, 0, I, O).data, [
                                                    O,
                                                    I,
                                                    4
                                                ]).pick(-1, -1, 0).transpose(1, 0);
                                            }(e1, r, t1, a, o, s), n, a);
                                        }, e1.exports.processPixels = h;
                                        var n = t1("surface-nets"), i = t1("ndarray"), a = t1("simplify-planar-graph"), o = t1("clean-pslg"), s = t1("cdt2d"), l = t1("planar-graph-to-polyline");
                                        function c(t1, e1, r, n) {
                                            for(var i = "<" + t1 + ">", a = "</" + t1 + ">", o = i.length, s = a.length, l = "+" === e1[0] || "-" === e1[0], c = 0, u = -s; c > -1 && -1 !== (c = r.indexOf(i, c)) && -1 !== (u = r.indexOf(a, c + o)) && !(u <= c);){
                                                for(var f = c; f < u + s; ++f)if (f < c + o || f >= u) n[f] = null, r = r.substr(0, f) + " " + r.substr(f + 1);
                                                else if (null !== n[f]) {
                                                    var h = n[f].indexOf(e1[0]);
                                                    -1 === h ? n[f] += e1 : l && (n[f] = n[f].substr(0, h + 1) + (1 + parseInt(n[f][h + 1])) + n[f].substr(h + 2));
                                                }
                                                var p = c + o, d = r.substr(p, u - p).indexOf(i);
                                                c = -1 !== d ? d : u + s;
                                            }
                                            return n;
                                        }
                                        function u(t1, e1) {
                                            var r = n(t1, 128);
                                            return e1 ? a(r.cells, r.positions, .25) : {
                                                edges: r.cells,
                                                positions: r.positions
                                            };
                                        }
                                        function f(t1, e1, r, n) {
                                            var i = u(t1, n), a = function(t1, e1, r) {
                                                for(var n = e1.textAlign || "start", i = e1.textBaseline || "alphabetic", a = [
                                                    1073741824,
                                                    1073741824
                                                ], o = [
                                                    0,
                                                    0
                                                ], s = t1.length, l = 0; l < s; ++l)for(var c = t1[l], u = 0; u < 2; ++u)a[u] = 0 | Math.min(a[u], c[u]), o[u] = 0 | Math.max(o[u], c[u]);
                                                var f = 0;
                                                switch(n){
                                                    case "center":
                                                        f = -0.5 * (a[0] + o[0]);
                                                        break;
                                                    case "right":
                                                    case "end":
                                                        f = -o[0];
                                                        break;
                                                    case "left":
                                                    case "start":
                                                        f = -a[0];
                                                        break;
                                                    default:
                                                        throw new Error("vectorize-text: Unrecognized textAlign: '" + n + "'");
                                                }
                                                var h = 0;
                                                switch(i){
                                                    case "hanging":
                                                    case "top":
                                                        h = -a[1];
                                                        break;
                                                    case "middle":
                                                        h = -0.5 * (a[1] + o[1]);
                                                        break;
                                                    case "alphabetic":
                                                    case "ideographic":
                                                        h = -3 * r;
                                                        break;
                                                    case "bottom":
                                                        h = -o[1];
                                                        break;
                                                    default:
                                                        throw new Error("vectorize-text: Unrecoginized textBaseline: '" + i + "'");
                                                }
                                                var p = 1 / r;
                                                return "lineHeight" in e1 ? p *= +e1.lineHeight : "width" in e1 ? p = e1.width / (o[0] - a[0]) : "height" in e1 && (p = e1.height / (o[1] - a[1])), t1.map(function(t1) {
                                                    return [
                                                        p * (t1[0] + f),
                                                        p * (t1[1] + h)
                                                    ];
                                                });
                                            }(i.positions, e1, r), c = i.edges, f = "ccw" === e1.orientation;
                                            if (o(a, c), e1.polygons || e1.polygon || e1.polyline) {
                                                for(var h = l(c, a), p = new Array(h.length), d = 0; d < h.length; ++d){
                                                    for(var m = h[d], g = new Array(m.length), v = 0; v < m.length; ++v){
                                                        for(var y = m[v], x = new Array(y.length), b = 0; b < y.length; ++b)x[b] = a[y[b]].slice();
                                                        f && x.reverse(), g[v] = x;
                                                    }
                                                    p[d] = g;
                                                }
                                                return p;
                                            }
                                            return e1.triangles || e1.triangulate || e1.triangle ? {
                                                cells: s(a, c, {
                                                    delaunay: !1,
                                                    exterior: !1,
                                                    interior: !0
                                                }),
                                                positions: a
                                            } : {
                                                edges: c,
                                                positions: a
                                            };
                                        }
                                        function h(t1, e1, r) {
                                            try {
                                                return f(t1, e1, r, !0);
                                            } catch (t1) {}
                                            try {
                                                return f(t1, e1, r, !1);
                                            } catch (t1) {}
                                            return e1.polygons || e1.polyline || e1.polygon ? [] : e1.triangles || e1.triangulate || e1.triangle ? {
                                                cells: [],
                                                positions: []
                                            } : {
                                                edges: [],
                                                positions: []
                                            };
                                        }
                                    },
                                    {
                                        cdt2d: 42,
                                        "clean-pslg": 50,
                                        ndarray: 259,
                                        "planar-graph-to-polyline": 268,
                                        "simplify-planar-graph": 297,
                                        "surface-nets": 302
                                    }
                                ],
                                313: [
                                    function(t1, e1, r) {
                                        !function() {
                                            "use strict";
                                            if ("undefined" == typeof ses || !ses.ok || ses.ok()) {
                                                "undefined" != typeof ses && (ses.weakMapPermitHostObjects = m);
                                                var t1 = !1;
                                                if ("function" == typeof WeakMap) {
                                                    var r = WeakMap;
                                                    if ("undefined" != typeof navigator && /Firefox/.test(navigator.userAgent)) ;
                                                    else {
                                                        var n = new r, i = Object.freeze({});
                                                        if (n.set(i, 1), 1 === n.get(i)) return void (e1.exports = WeakMap);
                                                        t1 = !0;
                                                    }
                                                }
                                                Object.prototype.hasOwnProperty;
                                                var a = Object.getOwnPropertyNames, o = Object.defineProperty, s = Object.isExtensible, l = "weakmap:ident:" + Math.random() + "___";
                                                if ("undefined" != typeof crypto && "function" == typeof crypto.getRandomValues && "function" == typeof ArrayBuffer && "function" == typeof Uint8Array) {
                                                    var c = new ArrayBuffer(25), u = new Uint8Array(c);
                                                    crypto.getRandomValues(u), l = "weakmap:rand:" + Array.prototype.map.call(u, function(t1) {
                                                        return (t1 % 36).toString(36);
                                                    }).join("") + "___";
                                                }
                                                if (o(Object, "getOwnPropertyNames", {
                                                    value: function(t1) {
                                                        return a(t1).filter(g);
                                                    }
                                                }), "getPropertyNames" in Object) {
                                                    var f = Object.getPropertyNames;
                                                    o(Object, "getPropertyNames", {
                                                        value: function(t1) {
                                                            return f(t1).filter(g);
                                                        }
                                                    });
                                                }
                                                !function() {
                                                    var t1 = Object.freeze;
                                                    o(Object, "freeze", {
                                                        value: function(e1) {
                                                            return v(e1), t1(e1);
                                                        }
                                                    });
                                                    var e1 = Object.seal;
                                                    o(Object, "seal", {
                                                        value: function(t1) {
                                                            return v(t1), e1(t1);
                                                        }
                                                    });
                                                    var r = Object.preventExtensions;
                                                    o(Object, "preventExtensions", {
                                                        value: function(t1) {
                                                            return v(t1), r(t1);
                                                        }
                                                    });
                                                }();
                                                var h = !1, p = 0, d = function() {
                                                    this instanceof d || x();
                                                    var t1 = [], e1 = [], r = p++;
                                                    return Object.create(d.prototype, {
                                                        get___: {
                                                            value: y(function(n, i) {
                                                                var a, o = v(n);
                                                                return o ? r in o ? o[r] : i : (a = t1.indexOf(n)) >= 0 ? e1[a] : i;
                                                            })
                                                        },
                                                        has___: {
                                                            value: y(function(e1) {
                                                                var n = v(e1);
                                                                return n ? r in n : t1.indexOf(e1) >= 0;
                                                            })
                                                        },
                                                        set___: {
                                                            value: y(function(n, i) {
                                                                var a, o = v(n);
                                                                return o ? o[r] = i : (a = t1.indexOf(n)) >= 0 ? e1[a] = i : (a = t1.length, e1[a] = i, t1[a] = n), this;
                                                            })
                                                        },
                                                        delete___: {
                                                            value: y(function(n) {
                                                                var i, a, o = v(n);
                                                                return o ? r in o && delete o[r] : !((i = t1.indexOf(n)) < 0) && (a = t1.length - 1, t1[i] = void 0, e1[i] = e1[a], t1[i] = t1[a], t1.length = a, e1.length = a, !0);
                                                            })
                                                        }
                                                    });
                                                };
                                                d.prototype = Object.create(Object.prototype, {
                                                    get: {
                                                        value: function(t1, e1) {
                                                            return this.get___(t1, e1);
                                                        },
                                                        writable: !0,
                                                        configurable: !0
                                                    },
                                                    has: {
                                                        value: function(t1) {
                                                            return this.has___(t1);
                                                        },
                                                        writable: !0,
                                                        configurable: !0
                                                    },
                                                    set: {
                                                        value: function(t1, e1) {
                                                            return this.set___(t1, e1);
                                                        },
                                                        writable: !0,
                                                        configurable: !0
                                                    },
                                                    delete: {
                                                        value: function(t1) {
                                                            return this.delete___(t1);
                                                        },
                                                        writable: !0,
                                                        configurable: !0
                                                    }
                                                }), "function" == typeof r ? function() {
                                                    function n() {
                                                        this instanceof d || x();
                                                        var e1, n = new r, i = void 0, a = !1;
                                                        return e1 = t1 ? function(t1, e1) {
                                                            return n.set(t1, e1), n.has(t1) || (i || (i = new d), i.set(t1, e1)), this;
                                                        } : function(t1, e1) {
                                                            if (a) try {
                                                                n.set(t1, e1);
                                                            } catch (r) {
                                                                i || (i = new d), i.set___(t1, e1);
                                                            }
                                                            else n.set(t1, e1);
                                                            return this;
                                                        }, Object.create(d.prototype, {
                                                            get___: {
                                                                value: y(function(t1, e1) {
                                                                    return i ? n.has(t1) ? n.get(t1) : i.get___(t1, e1) : n.get(t1, e1);
                                                                })
                                                            },
                                                            has___: {
                                                                value: y(function(t1) {
                                                                    return n.has(t1) || !!i && i.has___(t1);
                                                                })
                                                            },
                                                            set___: {
                                                                value: y(e1)
                                                            },
                                                            delete___: {
                                                                value: y(function(t1) {
                                                                    var e1 = !!n.delete(t1);
                                                                    return i && i.delete___(t1) || e1;
                                                                })
                                                            },
                                                            permitHostObjects___: {
                                                                value: y(function(t1) {
                                                                    if (t1 !== m) throw new Error("bogus call to permitHostObjects___");
                                                                    a = !0;
                                                                })
                                                            }
                                                        });
                                                    }
                                                    t1 && "undefined" != typeof Proxy && (Proxy = void 0), n.prototype = d.prototype, e1.exports = n, Object.defineProperty(WeakMap.prototype, "constructor", {
                                                        value: WeakMap,
                                                        enumerable: !1,
                                                        configurable: !0,
                                                        writable: !0
                                                    });
                                                }() : ("undefined" != typeof Proxy && (Proxy = void 0), e1.exports = d);
                                            }
                                            function m(t1) {
                                                t1.permitHostObjects___ && t1.permitHostObjects___(m);
                                            }
                                            function g(t1) {
                                                return !("weakmap:" == t1.substr(0, 8) && "___" === t1.substr(t1.length - 3));
                                            }
                                            function v(t1) {
                                                if (t1 !== Object(t1)) throw new TypeError("Not an object: " + t1);
                                                var e1 = t1[l];
                                                if (e1 && e1.key === t1) return e1;
                                                if (s(t1)) {
                                                    e1 = {
                                                        key: t1
                                                    };
                                                    try {
                                                        return o(t1, l, {
                                                            value: e1,
                                                            writable: !1,
                                                            enumerable: !1,
                                                            configurable: !1
                                                        }), e1;
                                                    } catch (t1) {
                                                        return;
                                                    }
                                                }
                                            }
                                            function y(t1) {
                                                return t1.prototype = null, Object.freeze(t1);
                                            }
                                            function x() {
                                                h || "undefined" == typeof console || (h = !0, console.warn("WeakMap should be invoked as new WeakMap(), not WeakMap(). This will be an error in the future."));
                                            }
                                        }();
                                    },
                                    {}
                                ],
                                314: [
                                    function(t1, e1, r) {
                                        var n = t1("./hidden-store.js");
                                        e1.exports = function() {
                                            var t1 = {};
                                            return function(e1) {
                                                if (("object" != typeof e1 || null === e1) && "function" != typeof e1) throw new Error("Weakmap-shim: Key must be object");
                                                var r = e1.valueOf(t1);
                                                return r && r.identity === t1 ? r : n(e1, t1);
                                            };
                                        };
                                    },
                                    {
                                        "./hidden-store.js": 315
                                    }
                                ],
                                315: [
                                    function(t1, e1, r) {
                                        e1.exports = function(t1, e1) {
                                            var r = {
                                                identity: e1
                                            }, n = t1.valueOf;
                                            return Object.defineProperty(t1, "valueOf", {
                                                value: function(t1) {
                                                    return t1 !== e1 ? n.apply(this, arguments) : r;
                                                },
                                                writable: !0
                                            }), r;
                                        };
                                    },
                                    {}
                                ],
                                316: [
                                    function(t1, e1, r) {
                                        var n = t1("./create-store.js");
                                        e1.exports = function() {
                                            var t1 = n();
                                            return {
                                                get: function(e1, r) {
                                                    var n = t1(e1);
                                                    return n.hasOwnProperty("value") ? n.value : r;
                                                },
                                                set: function(e1, r) {
                                                    return t1(e1).value = r, this;
                                                },
                                                has: function(e1) {
                                                    return "value" in t1(e1);
                                                },
                                                delete: function(e1) {
                                                    return delete t1(e1).value;
                                                }
                                            };
                                        };
                                    },
                                    {
                                        "./create-store.js": 314
                                    }
                                ],
                                317: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        var n, i = function() {
                                            return function(t1, e1, r, n, i, a) {
                                                var o = t1[0], s = r[0], l = [
                                                    0
                                                ], c = s;
                                                n |= 0;
                                                var u = 0, f = s;
                                                for(u = 0; u < o; ++u){
                                                    var h = e1[n] - a, p = e1[n + c] - a;
                                                    h >= 0 != p >= 0 && i.push(l[0] + .5 + .5 * (h + p) / (h - p)), n += f, ++l[0];
                                                }
                                            };
                                        };
                                        e1.exports = (n = {
                                            funcName: "zeroCrossings"
                                        }, function(t1) {
                                            var e1 = {};
                                            return function(r, n, i) {
                                                var a = r.dtype, o = r.order, s = [
                                                    a,
                                                    o.join()
                                                ].join(), l = e1[s];
                                                return l || (e1[s] = l = t1([
                                                    a,
                                                    o
                                                ])), l(r.shape.slice(0), r.data, r.stride, 0 | r.offset, n, i);
                                            };
                                        }(i.bind(void 0, n)));
                                    },
                                    {}
                                ],
                                318: [
                                    function(t1, e1, r) {
                                        "use strict";
                                        e1.exports = function(t1, e1) {
                                            var r = [];
                                            return e1 = +e1 || 0, n(t1.hi(t1.shape[0] - 1), r, e1), r;
                                        };
                                        var n = t1("./lib/zc-core");
                                    },
                                    {
                                        "./lib/zc-core": 317
                                    }
                                ]
                            }, {}, [
                                6
                            ])(6);
                        });
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        27
    ])(27);
});

});




parcelRegister("3zkxi", function(module, exports) {
"use strict";
var $299491fee9ab9e92$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._genericMathOp = void 0;

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $299491fee9ab9e92$var$series_1 = $299491fee9ab9e92$var$__importDefault((parcelRequire("hIkcL")));

var $299491fee9ab9e92$var$utils_1 = $299491fee9ab9e92$var$__importDefault((parcelRequire("5MA6C")));
var $299491fee9ab9e92$var$utils = new $299491fee9ab9e92$var$utils_1.default();
/**
 * Generic function for performing math operations on a series
 * @param object
 *
 * ndframe ==> The current Series
 *
 * other ==> The Series or number to perform math operation with
 *
 * operation ==> The type of operation to perform
*/ function $299491fee9ab9e92$var$_genericMathOp(_a) {
    var ndFrame = _a.ndFrame, other = _a.other, operation = _a.operation;
    if (typeof other === 'number') {
        //broadcast operation
        var newData = void 0;
        switch(operation){
            case 'add':
                newData = ndFrame.values.map(function(ele) {
                    return ele + other;
                });
                return newData;
            case 'sub':
                newData = ndFrame.values.map(function(ele) {
                    return ele - other;
                });
                return newData;
            case 'mul':
                newData = ndFrame.values.map(function(ele) {
                    return ele * other;
                });
                return newData;
            case 'div':
                newData = ndFrame.values.map(function(ele) {
                    return ele / other;
                });
                return newData;
            case 'mod':
                newData = ndFrame.values.map(function(ele) {
                    return ele % other;
                });
                return newData;
            case 'pow':
                newData = ndFrame.values.map(function(ele) {
                    return Math.pow(ele, other);
                });
                return newData;
            case 'minimum':
                newData = ndFrame.values.map(function(ele) {
                    return Math.min(ele, other);
                });
                return newData;
            case 'maximum':
                newData = ndFrame.values.map(function(ele) {
                    return Math.max(ele, other);
                });
                return newData;
            default:
                throw new Error(operation + " is not implemented");
        }
    } else if (other instanceof $299491fee9ab9e92$var$series_1.default) {
        $299491fee9ab9e92$var$utils.checkSeriesOpCompactibility({
            firstSeries: ndFrame,
            secondSeries: other,
            operation: operation
        });
        var newData = void 0;
        switch(operation){
            case 'add':
                newData = ndFrame.values.map(function(ele, index) {
                    return ele + other.values[index];
                });
                return newData;
            case 'sub':
                newData = ndFrame.values.map(function(ele, index) {
                    return ele - other.values[index];
                });
                return newData;
            case 'mul':
                newData = ndFrame.values.map(function(ele, index) {
                    return ele * other.values[index];
                });
                return newData;
            case 'div':
                newData = ndFrame.values.map(function(ele, index) {
                    return ele / other.values[index];
                });
                return newData;
            case 'mod':
                newData = ndFrame.values.map(function(ele, index) {
                    return ele % other.values[index];
                });
                return newData;
            case 'pow':
                newData = ndFrame.values.map(function(ele, index) {
                    return Math.pow(ele, other.values[index]);
                });
                return newData;
            case 'minimum':
                newData = ndFrame.values.map(function(ele, index) {
                    return Math.min(ele, other.values[index]);
                });
                return newData;
            case 'maximum':
                newData = ndFrame.values.map(function(ele, index) {
                    return Math.max(ele, other.values[index]);
                });
                return newData;
            default:
                throw new Error(operation + " is not implemented");
        }
    } else if (Array.isArray(other)) {
        if (other.length !== ndFrame.values.length) throw new Error("ParamError: Length of array must be equal to length of Series");
        var newData = void 0;
        switch(operation){
            case 'add':
                newData = ndFrame.values.map(function(ele, index) {
                    return ele + other[index];
                });
                return newData;
            case 'sub':
                newData = ndFrame.values.map(function(ele, index) {
                    return ele - other[index];
                });
                return newData;
            case 'mul':
                newData = ndFrame.values.map(function(ele, index) {
                    return ele * other[index];
                });
                return newData;
            case 'div':
                newData = ndFrame.values.map(function(ele, index) {
                    return ele / other[index];
                });
                return newData;
            case 'mod':
                newData = ndFrame.values.map(function(ele, index) {
                    return ele % other[index];
                });
                return newData;
            case 'pow':
                newData = ndFrame.values.map(function(ele, index) {
                    return Math.pow(ele, other[index]);
                });
                return newData;
            case 'minimum':
                newData = ndFrame.values.map(function(ele, index) {
                    return Math.min(ele, other[index]);
                });
                return newData;
            case 'maximum':
                newData = ndFrame.values.map(function(ele, index) {
                    return Math.max(ele, other[index]);
                });
                return newData;
        }
    } else throw new Error("ParamError: value for other not supported. It must be either a scalar, Array or Series");
}
module.exports._genericMathOp = $299491fee9ab9e92$var$_genericMathOp;

});

parcelRegister("5iins", function(module, exports) {
"use strict";
var $3dace38e77d1c5a4$var$__assign = module.exports && module.exports.__assign || function() {
    $3dace38e77d1c5a4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3dace38e77d1c5a4$var$__assign.apply(this, arguments);
};
var $3dace38e77d1c5a4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3dace38e77d1c5a4$var$utils_1 = $3dace38e77d1c5a4$var$__importDefault((parcelRequire("5MA6C")));
var $3dace38e77d1c5a4$var$utils = new $3dace38e77d1c5a4$var$utils_1.default();
/**
 * Exposes numerous String methods. All methods are applied Element-wise
 */ var $3dace38e77d1c5a4$var$Str = /** @class */ function() {
    function Str(series) {
        this.series = series;
        this.values = series.values;
    }
    Str.prototype.toLowerCase = function(options) {
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).toLowerCase());
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.toUpperCase = function(options) {
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).toUpperCase());
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.capitalize = function(options) {
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else {
                var firstChar = ("" + val).slice(0, 1);
                var leftChar = ("" + val).slice(1);
                var newStr = "" + firstChar.toUpperCase() + leftChar.toLowerCase();
                newArr.push(newStr);
            }
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.charAt = function(index, options) {
        if (index === void 0) index = 0;
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).charAt(index));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.concat = function(other, position, options) {
        if (position === void 0) position = 1;
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        if (Array.isArray(other)) for(var i = 0; i < other.length; i++){
            var leftStr = "" + this.values[i];
            var rightStr = "" + other[i];
            if (position == 1) newArr.push(leftStr.concat(rightStr));
            else newArr.push(rightStr.concat(leftStr));
        }
        else this.values.map(function(val) {
            if (position == 1) {
                if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
                else newArr.push(("" + val).concat("" + other));
            } else if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(other.concat("" + val));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.startsWith = function(str, options) {
        if (str === void 0) str = "";
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.forEach(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).startsWith(str));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.endsWith = function(str, options) {
        if (str === void 0) str = "";
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).endsWith(str));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.includes = function(str, options) {
        if (str === void 0) str = "";
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).includes(str));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.indexOf = function(str, options) {
        if (str === void 0) str = "";
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).indexOf(str));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.lastIndexOf = function(str, options) {
        if (str === void 0) str = "";
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).lastIndexOf(str));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.replace = function(searchValue, replaceValue, options) {
        if (searchValue === void 0) searchValue = "";
        if (replaceValue === void 0) replaceValue = "";
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).replace(searchValue, replaceValue));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.repeat = function(num, options) {
        if (num === void 0) num = 1;
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).repeat(num));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.search = function(str, options) {
        if (str === void 0) str = "";
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).search(str));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.slice = function(startIndex, endIndex, options) {
        if (startIndex === void 0) startIndex = 0;
        if (endIndex === void 0) endIndex = 1;
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).slice(startIndex, endIndex));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.split = function(splitVal, options) {
        if (splitVal === void 0) splitVal = " ";
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push("" + String(val).split(splitVal));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.substr = function(startIndex, num, options) {
        if (startIndex === void 0) startIndex = 0;
        if (num === void 0) num = 1;
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push("" + String(val).substr(startIndex, num));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.substring = function(startIndex, endIndex, options) {
        if (startIndex === void 0) startIndex = 0;
        if (endIndex === void 0) endIndex = 1;
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push("" + String(val).substring(startIndex, endIndex));
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.trim = function(options) {
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).trim());
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.join = function(valToJoin, joinChar, options) {
        if (valToJoin === void 0) valToJoin = "";
        if (joinChar === void 0) joinChar = " ";
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else {
                var leftChar = val;
                var rightChar = valToJoin;
                var new_char = "" + leftChar + joinChar + rightChar;
                newArr.push(new_char);
            }
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    Str.prototype.len = function(options) {
        var inplace = $3dace38e77d1c5a4$var$__assign({
            inplace: false
        }, options).inplace;
        var newArr = [];
        this.values.map(function(val) {
            if ($3dace38e77d1c5a4$var$utils.isEmpty(val)) newArr.push(NaN);
            else newArr.push(("" + val).length);
        });
        if (inplace) {
            this.series.$setValues(newArr);
            this.series.print();
        } else {
            var sf = this.series.copy();
            sf.$setValues(newArr);
            return sf;
        }
    };
    return Str;
}();
module.exports.default = $3dace38e77d1c5a4$var$Str;

});

parcelRegister("7umVJ", function(module, exports) {
"use strict";
var $573d1f2e38931f6e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toDateTime = void 0;

var $573d1f2e38931f6e$var$series_1 = $573d1f2e38931f6e$var$__importDefault((parcelRequire("hIkcL")));
var $573d1f2e38931f6e$var$WEEK_NAME = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var $573d1f2e38931f6e$var$MONTH_NAME = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
/**
 * Format and handle all datetime operations on Series or Array of date strings
 * @param data Series or Array of date strings
 */ var $573d1f2e38931f6e$var$TimeSeries = /** @class */ function() {
    function TimeSeries(data) {
        if (data instanceof $573d1f2e38931f6e$var$series_1.default) this.$dateObjectArray = this.processData(data.values);
        else this.$dateObjectArray = this.processData(data);
    }
    /**
     * Processed the data values into internal structure for easy access
     * @param dateArray An array of date strings
    */ TimeSeries.prototype.processData = function(dateArray) {
        var values = dateArray.map(function(dateString) {
            return new Date("" + dateString);
        });
        return values;
    };
    /**
     *  Returns the month, in local time.
     * @example
     * ```
     * import { Series } from "danfojs-node"
     * const data = [
     * "2019-01-01",
     * "2019-02-01",
     * "2019-03-01",
     * "2019-04-01",
     * ]
     * const df = new Series(data)
     * const dfNew = df.dt.month()
     * console.log(dfNew.values)
     * // [1, 2, 3, 4]
     * ```
    */ TimeSeries.prototype.month = function() {
        var newValues = this.$dateObjectArray.map(function(date) {
            return date.getMonth();
        });
        return new $573d1f2e38931f6e$var$series_1.default(newValues);
    };
    /**
     * Returns the day of the week, in local time
     * @example
     * ```
     * import { Series } from "danfojs-node"
     * const data = [
     * "2019-01-01",
     * "2019-02-01",
     * "2019-03-01",
     * "2019-04-01",
     * ]
     * const df = new Series(data)
     * const dayOfWeek = df.dt.dayOfWeek()
     * console.log(dayOfWeek.values)
     * ```
    */ TimeSeries.prototype.dayOfWeek = function() {
        var newValues = this.$dateObjectArray.map(function(date) {
            return date.getDay();
        });
        return new $573d1f2e38931f6e$var$series_1.default(newValues);
    };
    /**
     * Returns the year, in local time
     * @example
     * ```
     * import { Series } from "danfojs-node"
     * const data = [
     * "2019-01-01",
     * "2019-02-01",
     * "2021-03-01",
     * "2020-04-01",
     * ]
     * const df = new Series(data)
     * const year = df.dt.year()
     * console.log(year.values)
     * // [2019, 2019, 2021, 2020]
     * ```
    */ TimeSeries.prototype.year = function() {
        var newValues = this.$dateObjectArray.map(function(date) {
            return date.getFullYear();
        });
        return new $573d1f2e38931f6e$var$series_1.default(newValues);
    };
    /**
     *  Returns the name of the month, in local time
     * @example
     * ```
     * import { Series } from "danfojs-node"
     * const data = [
     * "2019-01-01",
     * "2019-02-01",
     * "2021-03-01",
     * "2020-04-01",
     * ]
     * const df = new Series(data)
     * const monthName = df.dt.monthName().values
     * console.log(monthName)
     * // ["January", "February", "March", "April"]
     * ```
    */ TimeSeries.prototype.monthName = function() {
        var newValues = this.$dateObjectArray.map(function(date) {
            return $573d1f2e38931f6e$var$MONTH_NAME[date.getMonth()];
        });
        return new $573d1f2e38931f6e$var$series_1.default(newValues);
    };
    /**
     * Returns the name of the day, of the week, in local time
     * @example
     * ```
     * import { Series } from "danfojs-node"
     * const data = [
     * "2019-01-01",
     * "2019-02-01",
     * "2021-03-01",
     * "2020-04-01",
     * ]
     * const df = new Series(data)
     * const dayOfWeekName = df.dt.dayOfWeekName().values
     * console.log(dayOfWeekName)
     * ```
    */ TimeSeries.prototype.dayOfWeekName = function() {
        var newValues = this.$dateObjectArray.map(function(date) {
            return $573d1f2e38931f6e$var$WEEK_NAME[date.getDay()];
        });
        return new $573d1f2e38931f6e$var$series_1.default(newValues);
    };
    /**
     * Returns the day of the month, in local time
     * @example
     * ```
     * import { Series } from "danfojs-node"
     * const data = [
     * "2019-01-01",
     * "2019-02-05",
     * "2021-03-02",
     * "2020-04-01",
     * ]
     * const df = new Series(data)
     * const dayOfMonth = df.dt.dayOfMonth().values
     * console.log(dayOfMonth)
     * // [1, 5, 2, 1]
     * ```
    */ TimeSeries.prototype.dayOfMonth = function() {
        var newValues = this.$dateObjectArray.map(function(date) {
            return date.getDate();
        });
        return new $573d1f2e38931f6e$var$series_1.default(newValues);
    };
    /**
     * Returns the hour of the day, in local time
     * @example
     * ```
     * import { Series } from "danfojs-node"
     * const data = [
     * "2019-01-01",
     * "2019-02-05",
     * "2021-03-02",
     * "2020-04-01",
     * ]
     * const df = new Series(data)
     * const hour = df.dt.hour().values
     * console.log(hour)
     * // [0, 0, 0, 0]
     * ```
    */ TimeSeries.prototype.hours = function() {
        var newValues = this.$dateObjectArray.map(function(date) {
            return date.getHours();
        });
        return new $573d1f2e38931f6e$var$series_1.default(newValues);
    };
    /**
     * Returns the second of the day, in local time
     * @example
     * ```
     * import { Series } from "danfojs-node"
     * const data = [
     * "2019-01-01",
     * "2019-02-05",
     * "2021-03-02",
     * "2020-04-01",
     * ]
     * const df = new Series(data)
     * const second = df.dt.second().values
     * console.log(second)
     * ```
    */ TimeSeries.prototype.seconds = function() {
        var newValues = this.$dateObjectArray.map(function(date) {
            return date.getSeconds();
        });
        return new $573d1f2e38931f6e$var$series_1.default(newValues);
    };
    /**
     * Returns the minute of the day, in local time
     * @example
     * ```
     * import { Series } from "danfojs-node"
     * const data = [
     * "2019-01-01",
     * "2019-02-05",
     * "2021-03-02",
     * "2020-04-01",
     * ]
     * const df = new Series(data)
     * const minute = df.dt.minute().values
     * console.log(minute)
     * ```
    */ TimeSeries.prototype.minutes = function() {
        var newValues = this.$dateObjectArray.map(function(date) {
            return date.getMinutes();
        });
        return new $573d1f2e38931f6e$var$series_1.default(newValues);
    };
    /**
     * Returns the Date as JavaScript standard Date object
     * @example
     * ```
     * import { Series } from "danfojs-node"
     * const data = [
     * "2019-01-01",
     * "2019-02-05",
     * "2021-03-02",
     * "2020-04-01",
     * ]
     *
     * const df = new Series(data)
     * const date = df.dt.toDate().values
     * console.log(date)
     * ```
    */ TimeSeries.prototype.date = function() {
        var newValues = this.$dateObjectArray.map(function(date) {
            return date.toLocaleString();
        });
        return new $573d1f2e38931f6e$var$series_1.default(newValues);
    };
    return TimeSeries;
}();
module.exports.default = $573d1f2e38931f6e$var$TimeSeries;
var $573d1f2e38931f6e$var$toDateTime = function(data) {
    return new $573d1f2e38931f6e$var$TimeSeries(data);
};
module.exports.toDateTime = $573d1f2e38931f6e$var$toDateTime;

});


parcelRegister("eFBgL", function(module, exports) {
"use strict";
/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $aae1cdf6fb9c5ec2$var$__assign = module.exports && module.exports.__assign || function() {
    $aae1cdf6fb9c5ec2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aae1cdf6fb9c5ec2$var$__assign.apply(this, arguments);
};
var $aae1cdf6fb9c5ec2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aae1cdf6fb9c5ec2$var$series_1 = $aae1cdf6fb9c5ec2$var$__importDefault((parcelRequire("hIkcL")));

var $aae1cdf6fb9c5ec2$var$frame_1 = $aae1cdf6fb9c5ec2$var$__importDefault((parcelRequire("6QWdY")));

var $aae1cdf6fb9c5ec2$var$utils_1 = $aae1cdf6fb9c5ec2$var$__importDefault((parcelRequire("5MA6C")));

var $aae1cdf6fb9c5ec2$var$tensorflowlib_1 = $aae1cdf6fb9c5ec2$var$__importDefault((parcelRequire("iySBu")));
var $aae1cdf6fb9c5ec2$var$utils = new $aae1cdf6fb9c5ec2$var$utils_1.default();
/**
 * Transform features by scaling each feature to a given range.
 * This estimator scales and translates each feature individually such
 * that it is in the given range on the training set, e.g. between the maximum and minimum value.
*/ var $aae1cdf6fb9c5ec2$var$MinMaxScaler = /** @class */ function() {
    function MinMaxScaler() {
        this.$max = $aae1cdf6fb9c5ec2$var$tensorflowlib_1.default.tensor1d([]);
        this.$min = $aae1cdf6fb9c5ec2$var$tensorflowlib_1.default.tensor1d([]);
    }
    MinMaxScaler.prototype.$getTensor = function(data) {
        var $tensorArray;
        if (data instanceof Array) {
            if ($aae1cdf6fb9c5ec2$var$utils.is1DArray(data)) $tensorArray = $aae1cdf6fb9c5ec2$var$tensorflowlib_1.default.tensor1d(data);
            else $tensorArray = $aae1cdf6fb9c5ec2$var$tensorflowlib_1.default.tensor2d(data);
        } else if (data instanceof $aae1cdf6fb9c5ec2$var$frame_1.default || data instanceof $aae1cdf6fb9c5ec2$var$series_1.default) $tensorArray = data.tensor;
        else if (data instanceof $aae1cdf6fb9c5ec2$var$tensorflowlib_1.default.Tensor) $tensorArray = data;
        else throw new Error("ParamError: data must be one of Array, Tensor, DataFrame or Series");
        return $tensorArray;
    };
    /**
     * Fits a MinMaxScaler to the data
     * @param data Array, Tensor, DataFrame or Series object
     * @returns MinMaxScaler
     * @example
     * const scaler = new MinMaxScaler()
     * scaler.fit([1, 2, 3, 4, 5])
     * // MinMaxScaler {
     * //   $max: [5],
     * //   $min: [1]
     * // }
     *
     */ MinMaxScaler.prototype.fit = function(data) {
        var tensorArray = this.$getTensor(data);
        this.$max = tensorArray.max(0);
        this.$min = tensorArray.min(0);
        return this;
    };
    /**
     * Transform the data using the fitted scaler
     * @param data Array, Tensor, DataFrame or Series object
     * @returns Array, Tensor, DataFrame or Series object
     * @example
     * const scaler = new MinMaxScaler()
     * scaler.fit([1, 2, 3, 4, 5])
     * scaler.transform([1, 2, 3, 4, 5])
     * // [0, 0.25, 0.5, 0.75, 1]
     * */ MinMaxScaler.prototype.transform = function(data) {
        var tensorArray = this.$getTensor(data);
        var outputData = tensorArray.sub(this.$min).div(this.$max.sub(this.$min));
        if (Array.isArray(data)) return outputData.arraySync();
        else if (data instanceof $aae1cdf6fb9c5ec2$var$series_1.default) return new $aae1cdf6fb9c5ec2$var$series_1.default(outputData, {
            index: data.index
        });
        else if (data instanceof $aae1cdf6fb9c5ec2$var$frame_1.default) return new $aae1cdf6fb9c5ec2$var$frame_1.default(outputData, {
            index: data.index,
            columns: data.columns,
            config: $aae1cdf6fb9c5ec2$var$__assign({}, data.config)
        });
        else return outputData;
    };
    /**
     * Fit the data and transform it
     * @param data Array, Tensor, DataFrame or Series object
     * @returns Array, Tensor, DataFrame or Series object
     * @example
     * const scaler = new MinMaxScaler()
     * scaler.fitTransform([1, 2, 3, 4, 5])
     * // [0, 0.25, 0.5, 0.75, 1]
     * */ MinMaxScaler.prototype.fitTransform = function(data) {
        this.fit(data);
        return this.transform(data);
    };
    /**
     * Inverse transform the data using the fitted scaler
     * @param data Array, Tensor, DataFrame or Series object
     * @returns Array, Tensor, DataFrame or Series object
     * @example
     * const scaler = new MinMaxScaler()
     * scaler.fit([1, 2, 3, 4, 5])
     * scaler.inverseTransform([0, 0.25, 0.5, 0.75, 1])
     * // [1, 2, 3, 4, 5]
     * */ MinMaxScaler.prototype.inverseTransform = function(data) {
        var tensorArray = this.$getTensor(data);
        var outputData = tensorArray.mul(this.$max.sub(this.$min)).add(this.$min);
        if (Array.isArray(data)) return outputData.arraySync();
        else if (data instanceof $aae1cdf6fb9c5ec2$var$series_1.default) return new $aae1cdf6fb9c5ec2$var$series_1.default(outputData, {
            index: data.index
        });
        else if (data instanceof $aae1cdf6fb9c5ec2$var$frame_1.default) return new $aae1cdf6fb9c5ec2$var$frame_1.default(outputData, {
            index: data.index,
            columns: data.columns,
            config: $aae1cdf6fb9c5ec2$var$__assign({}, data.config)
        });
        else return outputData;
    };
    return MinMaxScaler;
}();
module.exports.default = $aae1cdf6fb9c5ec2$var$MinMaxScaler;

});

parcelRegister("4dUaX", function(module, exports) {
"use strict";
/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $3133f3a6c6e54412$var$__assign = module.exports && module.exports.__assign || function() {
    $3133f3a6c6e54412$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3133f3a6c6e54412$var$__assign.apply(this, arguments);
};
var $3133f3a6c6e54412$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3133f3a6c6e54412$var$tensorflowlib_1 = $3133f3a6c6e54412$var$__importDefault((parcelRequire("iySBu")));

var $3133f3a6c6e54412$var$series_1 = $3133f3a6c6e54412$var$__importDefault((parcelRequire("hIkcL")));

var $3133f3a6c6e54412$var$frame_1 = $3133f3a6c6e54412$var$__importDefault((parcelRequire("6QWdY")));

var $3133f3a6c6e54412$var$utils_1 = $3133f3a6c6e54412$var$__importDefault((parcelRequire("5MA6C")));
var $3133f3a6c6e54412$var$utils = new $3133f3a6c6e54412$var$utils_1.default();
/**
 * Standardize features by removing the mean and scaling to unit variance.
 * The standard score of a sample x is calculated as: `z = (x - u) / s`,
 * where `u` is the mean of the training samples, and `s` is the standard deviation of the training samples.
 */ var $3133f3a6c6e54412$var$StandardScaler = /** @class */ function() {
    function StandardScaler() {
        this.$std = $3133f3a6c6e54412$var$tensorflowlib_1.default.tensor1d([]);
        this.$mean = $3133f3a6c6e54412$var$tensorflowlib_1.default.tensor1d([]);
    }
    StandardScaler.prototype.$getTensor = function(data) {
        var $tensorArray;
        if (data instanceof Array) {
            if ($3133f3a6c6e54412$var$utils.is1DArray(data)) $tensorArray = $3133f3a6c6e54412$var$tensorflowlib_1.default.tensor1d(data);
            else $tensorArray = $3133f3a6c6e54412$var$tensorflowlib_1.default.tensor2d(data);
        } else if (data instanceof $3133f3a6c6e54412$var$frame_1.default || data instanceof $3133f3a6c6e54412$var$series_1.default) $tensorArray = data.tensor;
        else if (data instanceof $3133f3a6c6e54412$var$tensorflowlib_1.default.Tensor) $tensorArray = data;
        else throw new Error("ParamError: data must be one of Array, DataFrame or Series");
        return $tensorArray;
    };
    /**
     * Fit a StandardScaler to the data.
     * @param data Array, Tensor, DataFrame or Series object
     * @returns StandardScaler
     * @example
     * const scaler = new StandardScaler()
     * scaler.fit([1, 2, 3, 4, 5])
     */ StandardScaler.prototype.fit = function(data) {
        var tensorArray = this.$getTensor(data);
        this.$std = $3133f3a6c6e54412$var$tensorflowlib_1.default.moments(tensorArray, 0).variance.sqrt();
        this.$mean = tensorArray.mean(0);
        return this;
    };
    /**
     * Transform the data using the fitted scaler
     * @param data Array, Tensor, DataFrame or Series object
     * @returns Array, Tensor, DataFrame or Series object
     * @example
     * const scaler = new StandardScaler()
     * scaler.fit([1, 2, 3, 4, 5])
     * scaler.transform([1, 2, 3, 4, 5])
     * // [0.0, 0.0, 0.0, 0.0, 0.0]
     * */ StandardScaler.prototype.transform = function(data) {
        var tensorArray = this.$getTensor(data);
        var outputData = tensorArray.sub(this.$mean).div(this.$std);
        if (Array.isArray(data)) return outputData.arraySync();
        else if (data instanceof $3133f3a6c6e54412$var$series_1.default) return new $3133f3a6c6e54412$var$series_1.default(outputData, {
            index: data.index
        });
        else if (data instanceof $3133f3a6c6e54412$var$frame_1.default) return new $3133f3a6c6e54412$var$frame_1.default(outputData, {
            index: data.index,
            columns: data.columns,
            config: $3133f3a6c6e54412$var$__assign({}, data.config)
        });
        else return outputData;
    };
    /**
     * Fit and transform the data using the fitted scaler
     * @param data Array, Tensor, DataFrame or Series object
     * @returns Array, Tensor, DataFrame or Series object
     * @example
     * const scaler = new StandardScaler()
     * scaler.fit([1, 2, 3, 4, 5])
     * scaler.fitTransform([1, 2, 3, 4, 5])
     * // [0.0, 0.0, 0.0, 0.0, 0.0]
     * */ StandardScaler.prototype.fitTransform = function(data) {
        this.fit(data);
        return this.transform(data);
    };
    /**
     * Inverse transform the data using the fitted scaler
     * @param data Array, Tensor, DataFrame or Series object
     * @returns Array, Tensor, DataFrame or Series object
     * @example
     * const scaler = new StandardScaler()
     * scaler.fit([1, 2, 3, 4, 5])
     * scaler.transform([1, 2, 3, 4, 5])
     * // [0.0, 0.0, 0.0, 0.0, 0.0]
     * scaler.inverseTransform([0.0, 0.0, 0.0, 0.0, 0.0])
     * // [1, 2, 3, 4, 5]
     * */ StandardScaler.prototype.inverseTransform = function(data) {
        var tensorArray = this.$getTensor(data);
        var outputData = tensorArray.mul(this.$std).add(this.$mean);
        if (Array.isArray(data)) return outputData.arraySync();
        else if (data instanceof $3133f3a6c6e54412$var$series_1.default) return new $3133f3a6c6e54412$var$series_1.default(outputData, {
            index: data.index
        });
        else if (data instanceof $3133f3a6c6e54412$var$frame_1.default) return new $3133f3a6c6e54412$var$frame_1.default(outputData, {
            index: data.index,
            columns: data.columns,
            config: $3133f3a6c6e54412$var$__assign({}, data.config)
        });
        else return outputData;
    };
    return StandardScaler;
}();
module.exports.default = $3133f3a6c6e54412$var$StandardScaler;

});

parcelRegister("cMNpa", function(module, exports) {
"use strict";
/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $94f04a86abf2563d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $94f04a86abf2563d$var$tensorflowlib_1 = $94f04a86abf2563d$var$__importDefault((parcelRequire("iySBu")));

var $94f04a86abf2563d$var$series_1 = $94f04a86abf2563d$var$__importDefault((parcelRequire("hIkcL")));

var $94f04a86abf2563d$var$utils_1 = $94f04a86abf2563d$var$__importDefault((parcelRequire("5MA6C")));
var $94f04a86abf2563d$var$utils = new $94f04a86abf2563d$var$utils_1.default();
/**
 * Encode target labels with value between 0 and n_classes-1.
 */ var $94f04a86abf2563d$var$LabelEncoder = /** @class */ function() {
    function LabelEncoder() {
        this.$labels = {};
    }
    LabelEncoder.prototype.$getData = function(data) {
        var $data;
        if (data instanceof Array) {
            if ($94f04a86abf2563d$var$utils.is1DArray(data)) $data = data;
            else throw new Error("ValueError: data must be a 1D array.");
        } else if (data instanceof $94f04a86abf2563d$var$series_1.default) $data = data.values;
        else if (data instanceof $94f04a86abf2563d$var$tensorflowlib_1.default.Tensor) $data = data.arraySync();
        else throw new Error("ParamError: data must be one of Array, 1d Tensor or Series.");
        return $data;
    };
    /**
     * Maps values to unique integer labels between 0 and n_classes-1.
     * @param data 1d array of labels, Tensor, or  Series to fit.
     * @example
     * ```
     * const encoder = new LabelEncoder()
     * encoder.fit(["a", "b", "c", "d"])
     * ```
    */ LabelEncoder.prototype.fit = function(data) {
        var $data = this.$getData(data);
        var dataSet = Array.from(new Set($data));
        var tempObj = {};
        dataSet.forEach(function(value, index) {
            tempObj[value] = index;
        });
        this.$labels = tempObj;
        return this;
    };
    /**
     * Encode labels with value between 0 and n_classes-1.
     * @param data 1d array of labels, Tensor, or  Series to be encoded.
     * @example
     * ```
     * const encoder = new LabelEncoder()
     * encoder.fit(["a", "b", "c", "d"])
     * console.log(encoder.transform(["a", "b", "c", "d"]))
     * // [0, 1, 2, 3]
     * ```
    */ LabelEncoder.prototype.transform = function(data) {
        var _this = this;
        var $data = this.$getData(data);
        var encodedData = $data.map(function(value) {
            var label = _this.$labels[value] !== undefined ? _this.$labels[value] : -1;
            return label;
        });
        if (data instanceof Array) return encodedData;
        else if (data instanceof $94f04a86abf2563d$var$series_1.default) return new $94f04a86abf2563d$var$series_1.default(encodedData);
        else return $94f04a86abf2563d$var$tensorflowlib_1.default.tensor1d(encodedData);
    };
    /**
     * Fit and transform data in one step.
     * @param data 1d array of labels, Tensor, or  Series to be encoded.
     * @example
     * ```
     * const encoder = new LabelEncoder()
     * encoder.fitTransform(["a", "b", "c", "d"])
     * // [0, 1, 2, 3]
     * ```
     */ LabelEncoder.prototype.fitTransform = function(data) {
        this.fit(data);
        return this.transform(data);
    };
    /**
     * Inverse transform values back to original values.
     * @param data 1d array of labels, Tensor, or  Series to be decoded.
     * @example
     * ```
     * const encoder = new LabelEncoder()
     * encoder.fit(["a", "b", "c", "d"])
     * console.log(encoder.inverseTransform([0, 1, 2, 3]))
     * // ["a", "b", "c", "d"]
     * ```
    */ LabelEncoder.prototype.inverseTransform = function(data) {
        var _this = this;
        var $data = this.$getData(data);
        var tempData = $data.map(function(value) {
            return Object.keys(_this.$labels).find(function(key) {
                return _this.$labels[key] === value;
            });
        });
        var decodedData = tempData.map(function(value) {
            if (isNaN(parseInt(value))) return value;
            else return Number(value);
        });
        if (data instanceof Array) return decodedData;
        else if (data instanceof $94f04a86abf2563d$var$series_1.default) return new $94f04a86abf2563d$var$series_1.default(decodedData);
        else return $94f04a86abf2563d$var$tensorflowlib_1.default.tensor1d(decodedData);
    };
    Object.defineProperty(LabelEncoder.prototype, "nClasses", {
        /**
         * Get the number of classes.
         * @returns number of classes.
         * @example
         * ```
         * const encoder = new LabelEncoder()
         * encoder.fit(["a", "b", "c", "d"])
         * console.log(encoder.nClasses)
         * // 4
         * ```
         */ get: function() {
            return Object.keys(this.$labels).length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LabelEncoder.prototype, "classes", {
        /**
         * Get the mapping of classes to integers.
         * @returns mapping of classes to integers.
         * @example
         * ```
         * const encoder = new LabelEncoder()
         * encoder.fit(["a", "b", "c", "d"])
         * console.log(encoder.classes)
         * // {a: 0, b: 1, c: 2, d: 3}
         * ```
        */ get: function() {
            return this.$labels;
        },
        enumerable: false,
        configurable: true
    });
    return LabelEncoder;
}();
module.exports.default = $94f04a86abf2563d$var$LabelEncoder;

});

parcelRegister("hUaPm", function(module, exports) {
"use strict";
/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $d09010b551b2c6c4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d09010b551b2c6c4$var$frame_1 = $d09010b551b2c6c4$var$__importDefault((parcelRequire("6QWdY")));

var $d09010b551b2c6c4$var$tensorflowlib_1 = $d09010b551b2c6c4$var$__importDefault((parcelRequire("iySBu")));

var $d09010b551b2c6c4$var$series_1 = $d09010b551b2c6c4$var$__importDefault((parcelRequire("hIkcL")));

var $d09010b551b2c6c4$var$utils_1 = $d09010b551b2c6c4$var$__importDefault((parcelRequire("5MA6C")));
var $d09010b551b2c6c4$var$utils = new $d09010b551b2c6c4$var$utils_1.default();
/**
 * Fits a OneHotEncoder to the data.
 * @example
 * ```js
 * const encoder = new OneHotEncoder()
 * encoder.fit(["a", "b", "c"])
 * ```
*/ var $d09010b551b2c6c4$var$OneHotEncoder = /** @class */ function() {
    function OneHotEncoder() {
        this.$labels = [];
    }
    OneHotEncoder.prototype.$getData = function(data) {
        var $data;
        if (data instanceof Array) {
            if ($d09010b551b2c6c4$var$utils.is1DArray(data)) $data = data;
            else throw new Error("ValueError: data must be a 1D array.");
        } else if (data instanceof $d09010b551b2c6c4$var$series_1.default) $data = data.values;
        else if (data instanceof $d09010b551b2c6c4$var$tensorflowlib_1.default.Tensor) $data = data.arraySync();
        else throw new Error("ParamError: data must be one of Array, 1d Tensor or Series.");
        return $data;
    };
    /**
     * Fits a OneHotEncoder to the data.
     * @param data 1d array of labels, Tensor, or  Series to be encoded.
     * @returns OneHotEncoder
     * @example
     * ```js
     * const encoder = new OneHotEncoder()
     * encoder.fit(["a", "b", "c"])
     * ```
    */ OneHotEncoder.prototype.fit = function(data) {
        var $data = this.$getData(data);
        var dataSet = Array.from(new Set($data));
        this.$labels = dataSet;
        return this;
    };
    /**
     * Encodes the data using the fitted OneHotEncoder.
     * @param data 1d array of labels, Tensor, or  Series to be encoded.
     * @example
     * ```js
     * const encoder = new OneHotEncoder()
     * encoder.fit(["a", "b", "c"])
     * encoder.transform(["a", "b", "c"])
     * ```
     */ OneHotEncoder.prototype.transform = function(data) {
        var $data = this.$getData(data);
        var oneHotArr = $d09010b551b2c6c4$var$utils.zeros($data.length, this.$labels.length);
        for(var i = 0; i < $data.length; i++){
            var index = this.$labels.indexOf($data[i]);
            oneHotArr[i][index] = 1;
        }
        if (data instanceof Array) return oneHotArr;
        else if (data instanceof $d09010b551b2c6c4$var$series_1.default) return new $d09010b551b2c6c4$var$frame_1.default(oneHotArr, {
            index: data.index
        });
        else return $d09010b551b2c6c4$var$tensorflowlib_1.default.tensor1d(oneHotArr);
    };
    /**
     * Fit and transform the data using the fitted OneHotEncoder.
     * @param data 1d array of labels, Tensor, or  Series to be encoded.
     * @example
     * ```js
     * const encoder = new OneHotEncoder()
     * encoder.fitTransform(["a", "b", "c"])
     * ```
     */ OneHotEncoder.prototype.fitTransform = function(data) {
        this.fit(data);
        return this.transform(data);
    };
    return OneHotEncoder;
}();
module.exports.default = $d09010b551b2c6c4$var$OneHotEncoder;

});

parcelRegister("89ENH", function(module, exports) {
"use strict";
/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $5efed01e3660a987$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $5efed01e3660a987$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5efed01e3660a987$var$frame_1 = $5efed01e3660a987$var$__importDefault((parcelRequire("6QWdY")));

var $5efed01e3660a987$var$utils_1 = $5efed01e3660a987$var$__importDefault((parcelRequire("5MA6C")));
var $5efed01e3660a987$var$utils = new $5efed01e3660a987$var$utils_1.default();
var $5efed01e3660a987$var$Merge = /** @class */ function() {
    function Merge(_a) {
        var left = _a.left, right = _a.right, on = _a.on, how = _a.how;
        this.leftColIndex = [];
        this.rightColIndex = [];
        this.left = left;
        this.right = right;
        this.on = on;
        this.how = how;
        //Obtain the column index of the column will
        //want to merge on for both left and right dataframe
        for(var i = 0; i < this.on.length; i++){
            var key = this.on[i];
            if (this.left.columns.includes(key) && this.right.columns.includes(key)) {
                var leftIndex = this.left.columns.indexOf(key);
                var rightIndex = this.right.columns.indexOf(key);
                this.leftColIndex.push(leftIndex);
                this.rightColIndex.push(rightIndex);
            }
        }
    }
    /**
     * Generate key combination base on the columns we want to merge on
     * e.g  df = {
     *  key1: ["KO", "K0", "K3", "K4"],
     *  Key2: ["K1", "K1", "K3", "K5"],
     *  A: [1,2,3,4]
     *  B: [3,4,5,6]
     * }
     * keycomb = generateKeyCombination(df.values, [0,1])
     * This should output
     * {
     *  'k0_k1': {
     *      filters: [[1,3], [2,4]], # the value of other columns in thesame row with the combination keys
     *      combValues: ["KO", "k1"] # the combination key from column Key1 (index 2) and key2 (index 1)
     *  },
     *  'K3_K3 : {
     *      filters: [[3,5]],
     *      combValues: ['K3', 'k3']
     *  },
     *  'k4_k5' : {
     *      filters: [[4,6]]
     *      combValues: ['K4', 'K5']
     *  }
     * }
     * This key combination will be generated for both left and right dataframe
     * @param values
     * @param colIndex
     */ Merge.prototype.generateKeyCombination = function(values, colIndex) {
        var colKeyComb = {};
        for(var i = 0; i < values.length; i++){
            var rowValues = values[i];
            var rowKeyCombValues = [];
            for(var j = 0; j < colIndex.length; j++){
                var index = colIndex[j];
                rowKeyCombValues.push(rowValues[index]);
            }
            var rowKeyComb = rowKeyCombValues.join('_');
            var otherValues = rowValues.filter(function(val, index) {
                return !colIndex.includes(index);
            });
            if ($5efed01e3660a987$var$utils.keyInObject(colKeyComb, rowKeyComb)) colKeyComb[rowKeyComb].filters.push(otherValues);
            else colKeyComb[rowKeyComb] = {
                filters: [
                    otherValues
                ],
                combValues: rowKeyCombValues
            };
        }
        return colKeyComb;
    };
    /**
     * Generate columns for the newly generated merged DataFrame
     * e.g df = {
     *  key1: ["KO", "K0", "K3", "K4"],
     *  Key2: ["K1", "K1", "K3", "K5"],
     *  A: [1,2,3,4]
     *  B: [3,4,5,6]
     * }
     * df2 = {
     *  key1: ["KO", "K0", "K3", "K4"],
     *  Key2: ["K1", "K1", "K3", "K5"],
     *  A: [1,2,3,4]
     *  c: [3,4,5,6]
     * }
     * And both dataframe are to be merged on `key1` and `key2`
     * the newly generated column will be of the form
     * columns = ['key1', 'Key2', 'A', 'A_1', 'B', 'C']
     * Notice 'A_1' , this because both DataFrame as column A and 1 is the
     * number of duplicate of that column
     */ Merge.prototype.createColumns = function() {
        var self = this;
        this.leftCol = self.left.columns.filter(function(_, index) {
            return !self.leftColIndex.includes(index);
        });
        this.rightCol = self.right.columns.filter(function(_, index) {
            return !self.rightColIndex.includes(index);
        });
        this.columns = $5efed01e3660a987$var$__spreadArray([], this.on, true);
        var duplicateColumn = {};
        var tempColumn = $5efed01e3660a987$var$__spreadArray([], this.leftCol, true);
        tempColumn.push.apply(tempColumn, this.rightCol);
        for(var i = 0; i < tempColumn.length; i++){
            var col = tempColumn[i];
            if ($5efed01e3660a987$var$utils.keyInObject(duplicateColumn, col)) {
                var columnName = col + "_" + duplicateColumn[col];
                this.columns.push(columnName);
                duplicateColumn[col] += 1;
            } else {
                this.columns.push(col);
                duplicateColumn[col] = 1;
            }
        }
    };
    /**
     * The basic methos perform the underneath operation of generating
     * the merge dataframe; using the combination keys generated from
     * bothe left and right DataFrame
     * e.g df = {
     *  key1: ["KO", "K0", "K3", "K4"],
     *  Key2: ["K1", "K1", "K3", "K5"],
     *  A: [1,2,3,4]
     *  B: [3,4,5,6]
     * }
     * df2 = {
     *  key1: ["KO", "K0", "K3", "K4"],
     *  Key2: ["K1", "K2", "K4", "K5"],
     *  A: [3,6,8,9]
     *  c: [2,4,6,8]
     * }
     * Running generatekeyCombination on both left and right data frame
     * we should have
     * leftKeyDict = {
     *  'k0_k1': {
     *      filters: [[1,3], [2,4]],
     *      combValues: ["KO", "k1"]
     *  },
     *  'K3_K3' : {
     *      filters: [[3,5]],
     *      combValues: ['K3', 'k3']
     *  },
     *  'k4_k5' : {
     *      filters: [[4,6]]
     *      combValues: ['K4', 'K5']
     *  }
     * }
     * rightKeyDict = {
     *  'k0_k1': {
     *      filters: [[3,2]],
     *      combValues: ["KO", "k1"]
     *  },
     *  'K0_K2': {
     *      filters: [[6,4]],
     *      combValues: ['K0', 'K2']
     *  },
     *  'K3_K4' : {
     *      filters: [[8,9]],
     *      combValues: ['K3', 'k4']
     *  },
     *  'k4_k5' : {
     *      filters: [[9,8]]
     *      combValues: ['K4', 'K5']
     *  }
     * }
     * The `keys` is generated base on the type of merge operation we want to
     * perform. If we assume we are performing `outer` merge (which is a set of the
     * key combination from both leftKeyDict and rightKeyDict) then Keys should be
     * this
     * keys = ['K0_K1', 'K3_K3', 'k4_k5', 'K0_K2', 'k3_k4']
     * The Keys, leftKeyDict and rightKeyDict are used to generated DataFrame data,
     * by looping through the Keys and checking if leftKeyDict and rightKeyDict as the
     * key if one of them does not the column in that row will be NaN
     * e.g Data for each row base on keys
     * COLUMNS = ['key1', 'Key2', 'A', 'B', 'A_1', 'C']
     * 'K0_K1':  ['K0',   'K1',   1,    3 ,   3,   2 ]
     * 'K0_K1':  ['K0',   'K1',   2,    4,   NaN, NaN]
     * 'K3_K3':  ['k3',   'K3',   3,    5,  NaN,  NaN]
     * 'K4_K5':  ['K4',   'K5',   4,    6,  9,    8]
     * 'k0_K2':  ['k0',   'K2'    NaN,  NaN, 6,   4]
     * 'k3_k4':  ['K3',   'K4',   NaN,  NaN, 8, 6]
     *
     * @param keys
     * @param leftKeyDict
     * @param rightKeyDict
     */ Merge.prototype.basic = function(keys, leftKeyDict, rightKeyDict) {
        var _a, _b;
        var data = [];
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if ($5efed01e3660a987$var$utils.keyInObject(leftKeyDict, key)) {
                var leftRows = leftKeyDict[key].filters;
                var leftCombValues = leftKeyDict[key].combValues;
                for(var lIndex = 0; lIndex < leftRows.length; lIndex++){
                    var leftRow = leftRows[lIndex];
                    if ($5efed01e3660a987$var$utils.keyInObject(rightKeyDict, key)) {
                        var rightRows = rightKeyDict[key].filters;
                        for(var rIndex = 0; rIndex < rightRows.length; rIndex++){
                            var rightRow = rightRows[rIndex];
                            var combineData = leftCombValues.slice(0);
                            combineData.push.apply(combineData, leftRow);
                            combineData.push.apply(combineData, rightRow);
                            data.push(combineData);
                        }
                    } else {
                        var nanArray = Array((_a = this.rightCol) === null || _a === void 0 ? void 0 : _a.length).fill(NaN);
                        var combineData = leftCombValues.slice(0);
                        combineData.push.apply(combineData, leftRow);
                        combineData.push.apply(combineData, nanArray);
                        data.push(combineData);
                    }
                }
            } else {
                var rightRows = rightKeyDict[key].filters;
                var rightCombValues = rightKeyDict[key].combValues;
                for(var i_1 = 0; i_1 < rightRows.length; i_1++){
                    var rightRow = rightRows[i_1];
                    var nanArray = Array((_b = this.leftCol) === null || _b === void 0 ? void 0 : _b.length).fill(NaN);
                    var combineData = rightCombValues.slice(0);
                    combineData.push.apply(combineData, nanArray);
                    combineData.push.apply(combineData, rightRow);
                    data.push(combineData);
                }
            }
        }
        return data;
    };
    /**
     * Generate outer key from leftKeyDict and rightKeyDict
     * The Key pass into basic method is the union of
     * leftKeyDict and rightKeyDict
     * @param leftKeyDict
     * @param rightKeyDict
     */ Merge.prototype.outer = function(leftKeyDict, rightKeyDict) {
        var keys = Object.keys(leftKeyDict);
        keys.push.apply(keys, Object.keys(rightKeyDict));
        var UniqueKeys = Array.from(new Set(keys));
        var data = this.basic(UniqueKeys, leftKeyDict, rightKeyDict);
        return data;
    };
    /**
     * Generate Key for basic method,
     * the key geneerated is the intersection of
     * leftKeyDict and rightKeyDict
     * @param leftKeyDict
     * @param rightKeyDict
     */ Merge.prototype.inner = function(leftKeyDict, rightKeyDict) {
        var leftKey = Object.keys(leftKeyDict);
        var rightKey = Object.keys(rightKeyDict);
        var keys = leftKey.filter(function(val) {
            return rightKey.includes(val);
        });
        var data = this.basic(keys, leftKeyDict, rightKeyDict);
        return data;
    };
    /**
     * The key is the leftKeyDict
     * @param leftKeyDict
     * @param rightKeyDict
     */ Merge.prototype.leftMerge = function(leftKeyDict, rightKeyDict) {
        var keys = Object.keys(leftKeyDict);
        var data = this.basic(keys, leftKeyDict, rightKeyDict);
        return data;
    };
    /**
     * The key is the rightKeyDict
     * @param leftKeyDict
     * @param rightKeyDict
     */ Merge.prototype.rightMerge = function(leftKeyDict, rightKeyDict) {
        var keys = Object.keys(rightKeyDict);
        var data = this.basic(keys, leftKeyDict, rightKeyDict);
        return data;
    };
    /**
     * Perform the merge operation
     * 1) Obtain both left and right dataframe values
     * 2) Generate the leftkeyDict and rightKeyDict
     * 3) Generate new merge columns
     * 4) check how merge is to be done and apply the
     * right methods
     */ Merge.prototype.operation = function() {
        var leftValues = this.left.values;
        var rightValues = this.right.values;
        var leftKeyDict = this.generateKeyCombination(leftValues, this.leftColIndex);
        var rightKeyDict = this.generateKeyCombination(rightValues, this.rightColIndex);
        this.createColumns();
        var data = [];
        switch(this.how){
            case "outer":
                data = this.outer(leftKeyDict, rightKeyDict);
                break;
            case "inner":
                data = this.inner(leftKeyDict, rightKeyDict);
                break;
            case "left":
                data = this.leftMerge(leftKeyDict, rightKeyDict);
                break;
            case "right":
                data = this.rightMerge(leftKeyDict, rightKeyDict);
                break;
        }
        var columns = this.columns;
        return new $5efed01e3660a987$var$frame_1.default(data, {
            columns: $5efed01e3660a987$var$__spreadArray([], columns, true)
        });
    };
    return Merge;
}();
/**
 * Perform merge operation between two DataFrame
 * @param params : {
 * left: DataFrame
 * right: DataFrame
 * on: Array<string>
 * how: "outer" | "inner" | "left" | "right"
 * }
 */ function $5efed01e3660a987$var$merge(params) {
    var mergeClass = new $5efed01e3660a987$var$Merge(params);
    return mergeClass.operation();
}
module.exports.default = $5efed01e3660a987$var$merge;

});

parcelRegister("6oCk2", function(module, exports) {
"use strict";
var $4a82b5fbb9f8789e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $4a82b5fbb9f8789e$var$utils_1 = $4a82b5fbb9f8789e$var$__importDefault((parcelRequire("5MA6C")));
var $4a82b5fbb9f8789e$var$utils = new $4a82b5fbb9f8789e$var$utils_1.default();
var $4a82b5fbb9f8789e$var$DateRange = /** @class */ function() {
    function DateRange(_a) {
        var start = _a.start, end = _a.end, offset = _a.offset, freq = _a.freq, period = _a.period;
        this.start = start;
        this.end = end;
        this.offset = offset;
        this.freq = freq ? freq : "D";
        this.period = period;
        this.freqList = [
            "M",
            "D",
            "s",
            "H",
            "m",
            "Y"
        ];
        if (this.freq.length == 1) {
            if (!this.freqList.includes(this.freq)) throw new Error("invalid freq " + this.freq);
        } else {
            this.offset = parseInt(this.freq.slice(0, -1));
            if (!Number.isFinite(this.offset)) throw new Error("invalid freq offset " + this.freq.slice(0, -1));
            this.freq = this.freq.slice(-1);
            if (!this.freqList.includes(this.freq)) throw new Error("invalid freq " + this.freq);
        }
    }
    DateRange.prototype.range = function() {
        var _this = this;
        var start = this.start;
        var period = this.period;
        var end = this.end;
        var offset = this.offset;
        var startDate;
        var endDate;
        var startRange;
        var endRange;
        if (start && end) {
            startDate = new Date(start);
            startRange = this.freqType(startDate, this.freq);
            endDate = new Date(end);
            endRange = this.freqType(endDate, this.freq);
            var startYear = startDate.getFullYear();
            var endYear = endDate.getFullYear();
            if (startYear <= endYear && startDate.getMonth() !== endDate.getMonth()) {
                if (this.freq == "M") endRange = this.monthEnd(startDate, endDate);
                else if (this.freq === "D") endRange = this.dayEnd(startDate, endDate) - startRange;
            }
            var rangeArray_1 = $4a82b5fbb9f8789e$var$utils.range(startRange, endRange);
            if (offset) rangeArray_1 = this.offsetCount(rangeArray_1, offset);
            var dateRange_1 = rangeArray_1.map(function(x) {
                return _this.setDateProps(startDate, _this.freq, x);
            });
            dateRange_1[dateRange_1.length - 1] = endDate;
            var dateString_1 = this.toLocalString(dateRange_1);
            return dateString_1;
        } else if (start && !end) {
            startDate = new Date(start);
            startRange = this.freqType(startDate, this.freq);
            period;
            endRange = offset ? period * offset - 1 : period - 1;
            if (startRange > endRange) endRange = endRange + startRange;
            var rangeArray_2 = $4a82b5fbb9f8789e$var$utils.range(startRange, endRange);
            if (offset) rangeArray_2 = this.offsetCount(rangeArray_2, offset);
            var dateRange_2 = rangeArray_2.map(function(x) {
                return _this.setDateProps(startDate, _this.freq, x);
            });
            var dateString_2 = this.toLocalString(dateRange_2);
            return dateString_2;
        }
        // if end and not start given
        endDate = new Date(end);
        endRange = this.freqType(endDate, this.freq);
        period;
        startRange = endRange - period + 1;
        var rangeArray = $4a82b5fbb9f8789e$var$utils.range(startRange, endRange);
        if (offset) rangeArray = this.offsetCount(rangeArray, offset);
        var dateRange = rangeArray.map(function(x) {
            return _this.setDateProps(endDate, _this.freq, x);
        });
        var dateString = this.toLocalString(dateRange);
        return dateString;
    };
    /**
     * @param date Date
     * @param ftype string:  frequency type, month, Year, day etc
     * @param number
     */ DateRange.prototype.freqType = function(date, ftype) {
        var rslt = 0;
        switch(ftype){
            case "M":
                rslt = date.getMonth();
                break;
            case "Y":
                rslt = date.getFullYear();
                break;
            case "s":
                rslt = date.getSeconds();
                break;
            case "D":
                rslt = date.getDate();
                break;
            case "H":
                rslt = date.getHours();
                break;
            case "m":
                rslt = date.getMinutes();
                break;
        }
        return rslt;
    };
    DateRange.prototype.offsetCount = function(dArray, offset) {
        var rArray = [];
        for(var i = 0; i < dArray.length; i += offset)rArray.push(dArray[i]);
        return rArray;
    };
    DateRange.prototype.setDateProps = function(date, ftype, val) {
        var newDate = new Date(date.valueOf());
        switch(ftype){
            case "M":
                if (Array.isArray(val)) {
                    newDate.setFullYear(newDate.getFullYear() + val[0]);
                    newDate.setMonth(val[1]);
                } else newDate.setMonth(val);
                break;
            case "Y":
                newDate.setFullYear(val);
                break;
            case "s":
                newDate.setSeconds(val);
                break;
            case "D":
                newDate.setDate(val);
                break;
            case "H":
                newDate.setHours(val);
                break;
            case "m":
                newDate.setMinutes(val);
                break;
        }
        return newDate;
    };
    DateRange.prototype.toLocalString = function(dArray) {
        var r_array = dArray.map(function(x) {
            return x.toLocaleString();
        });
        return r_array;
    };
    DateRange.prototype.monthEnd = function(startDate, endDate) {
        var endMonth = endDate.getMonth();
        var diffYear = endDate.getFullYear() - startDate.getFullYear();
        var endRange = 12 * diffYear + endMonth;
        return endRange;
    };
    DateRange.prototype.monthRange = function(range) {
        var minus;
        var yVal = 0;
        var dateRange = range.map(function(x) {
            if (x > 11) {
                if (x % 12 == 0) {
                    minus = x;
                    yVal = x / 12;
                    return [
                        yVal,
                        x - minus
                    ];
                } else return [
                    yVal,
                    x - minus
                ];
            }
            return [
                yVal,
                x
            ];
        });
        return dateRange;
    };
    DateRange.prototype.dayEnd = function(startDate, endDate) {
        var monthEnd = this.monthEnd(startDate, endDate);
        var range = $4a82b5fbb9f8789e$var$utils.range(startDate.getMonth(), monthEnd);
        var mRange = this.monthRange(range);
        var sum = 0;
        for(var i = 0; i < mRange.length; i++){
            var val = mRange[i];
            var dDate = void 0;
            if (i === mRange.length - 1) dDate = new Date(startDate.getUTCFullYear() + val[0], val[1], endDate.getDate()).getDate();
            else dDate = new Date(startDate.getUTCFullYear() + val[0], val[1], 0).getDate();
            sum += dDate;
        }
        return sum;
    };
    return DateRange;
}();
/**
 * Generate sequence of Dates
 * @param start : signify the date to start with
 * @param end : signify the date to end with
 * @param period :  the total number of date to generate
 * @param offset : set the date range offset
 * @param freq: set the date range frequency and offset
 * @return string[]
 */ function $4a82b5fbb9f8789e$var$dateRange(param) {
    var dateRange = new $4a82b5fbb9f8789e$var$DateRange(param);
    return dateRange.range();
}
module.exports.default = $4a82b5fbb9f8789e$var$dateRange;

});




parcelRegister("i9wNk", function(module, exports) {
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/ ((e, t)=>{
    "function" == typeof define && define.amd ? define([], t) : module.exports = t();
})(module.exports, function r() {
    var n = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n ? n : {};
    var d, s = !n.document && !!n.postMessage, a = n.IS_PAPA_WORKER || !1, o = {}, h = 0, v = {};
    function u(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = b(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new i(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(t, e) {
            var i = parseInt(this._config.skipFirstNLines) || 0;
            if (this.isFirstChunk && 0 < i) {
                let e = this._config.newline;
                e || (r = this._config.quoteChar || '"', e = this._handle.guessLineEndings(t, r)), t = [
                    ...t.split(e).slice(i)
                ].join(e);
            }
            this.isFirstChunk && U(this._config.beforeFirstChunk) && void 0 !== (r = this._config.beforeFirstChunk(t)) && (t = r), this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + t, r = (this._partialLine = "", this._handle.parse(i, this._baseIndex, !this._finished));
            if (!this._handle.paused() && !this._handle.aborted()) {
                t = r.meta.cursor, i = (this._finished || (this._partialLine = i.substring(t - this._baseIndex), this._baseIndex = t), r && r.data && (this._rowCount += r.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview);
                if (a) n.postMessage({
                    results: r,
                    workerId: v.WORKER_ID,
                    finished: i
                });
                else if (U(this._config.chunk) && !e) {
                    if (this._config.chunk(r, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    this._completeResults = r = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(r.data), this._completeResults.errors = this._completeResults.errors.concat(r.errors), this._completeResults.meta = r.meta), this._completed || !i || !U(this._config.complete) || r && r.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), i || r && r.meta.paused || this._nextChunk(), r;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            U(this._config.error) ? this._config.error(e) : a && this._config.error && n.postMessage({
                workerId: v.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function f(e) {
        var r;
        (e = e || {}).chunkSize || (e.chunkSize = v.RemoteChunkSize), u.call(this, e), this._nextChunk = s ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (r = new XMLHttpRequest, this._config.withCredentials && (r.withCredentials = this._config.withCredentials), s || (r.onload = y(this._chunkLoaded, this), r.onerror = y(this._chunkError, this)), r.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s), this._config.downloadRequestHeaders) {
                    var e, t = this._config.downloadRequestHeaders;
                    for(e in t)r.setRequestHeader(e, t[e]);
                }
                var i;
                this._config.chunkSize && (i = this._start + this._config.chunkSize - 1, r.setRequestHeader("Range", "bytes=" + this._start + "-" + i));
                try {
                    r.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                s && 0 === r.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === r.readyState && (r.status < 200 || 400 <= r.status ? this._chunkError() : (this._start += this._config.chunkSize || r.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e)=>null !== (e = e.getResponseHeader("Content-Range")) ? parseInt(e.substring(e.lastIndexOf("/") + 1)) : -1)(r), this.parseChunk(r.responseText)));
        }, this._chunkError = function(e) {
            e = r.statusText || e;
            this._sendError(new Error(e));
        };
    }
    function l(e) {
        (e = e || {}).chunkSize || (e.chunkSize = v.LocalChunkSize), u.call(this, e);
        var i, r, n = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, r = e.slice || e.webkitSlice || e.mozSlice, n ? ((i = new FileReader).onload = y(this._chunkLoaded, this), i.onerror = y(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input, t = (this._config.chunkSize && (t = Math.min(this._start + this._config.chunkSize, this._input.size), e = r.call(e, this._start, t)), i.readAsText(e, this._config.encoding));
            n || this._chunkLoaded({
                target: {
                    result: t
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function c(e) {
        var i;
        u.call(this, e = e || {}), this.stream = function(e) {
            return i = e, this._nextChunk();
        }, this._nextChunk = function() {
            var e, t;
            if (!this._finished) return e = this._config.chunkSize, i = e ? (t = i.substring(0, e), i.substring(e)) : (t = i, ""), this._finished = !i, this.parseChunk(t);
        };
    }
    function p(e) {
        u.call(this, e = e || {});
        var t = [], i = !0, r = !1;
        this.pause = function() {
            u.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            u.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            r && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : i = !0;
        }, this._streamData = y(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), i && (i = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = y(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = y(function() {
            this._streamCleanUp(), r = !0, this._streamData("");
        }, this), this._streamCleanUp = y(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function i(m) {
        var n, s, a, t, o = Math.pow(2, 53), h = -o, u = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, d = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, i = this, r = 0, f = 0, l = !1, e = !1, c = [], p = {
            data: [],
            errors: [],
            meta: {}
        };
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            if (p && a && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + v.DefaultDelimiter + "'"), a = !1), m.skipEmptyLines && (p.data = p.data.filter(function(e) {
                return !y(e);
            })), _()) {
                if (p) {
                    if (Array.isArray(p.data[0])) {
                        for(var e = 0; _() && e < p.data.length; e++)p.data[e].forEach(t);
                        p.data.splice(0, 1);
                    } else p.data.forEach(t);
                }
                function t(e, t) {
                    U(m.transformHeader) && (e = m.transformHeader(e, t)), c.push(e);
                }
            }
            function i(e, t) {
                for(var i = m.header ? {} : [], r = 0; r < e.length; r++){
                    var n = r, s = e[r], s = ((e, t)=>((e)=>(m.dynamicTypingFunction && void 0 === m.dynamicTyping[e] && (m.dynamicTyping[e] = m.dynamicTypingFunction(e)), !0 === (m.dynamicTyping[e] || m.dynamicTyping)))(e) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (((e)=>{
                            if (u.test(e)) {
                                e = parseFloat(e);
                                if (h < e && e < o) return 1;
                            }
                        })(t) ? parseFloat(t) : d.test(t) ? new Date(t) : "" === t ? null : t) : t)(n = m.header ? r >= c.length ? "__parsed_extra" : c[r] : n, s = m.transform ? m.transform(s, n) : s);
                    "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                }
                return m.header && (r > c.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + c.length + " fields but parsed " + r, f + t) : r < c.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + c.length + " fields but parsed " + r, f + t)), i;
            }
            var r;
            p && (m.header || m.dynamicTyping || m.transform) && (r = 1, !p.data.length || Array.isArray(p.data[0]) ? (p.data = p.data.map(i), r = p.data.length) : p.data = i(p.data, 0), m.header && p.meta && (p.meta.fields = c), f += r);
        }
        function _() {
            return m.header && 0 === c.length;
        }
        function k(e, t, i, r) {
            e = {
                type: e,
                code: t,
                message: i
            };
            void 0 !== r && (e.row = r), p.errors.push(e);
        }
        U(m.step) && (t = m.step, m.step = function(e) {
            p = e, _() ? g() : (g(), 0 !== p.data.length && (r += e.data.length, m.preview && r > m.preview ? s.abort() : (p.data = p.data[0], t(p, i))));
        }), this.parse = function(e, t, i) {
            var r = m.quoteChar || '"', r = (m.newline || (m.newline = this.guessLineEndings(e, r)), a = !1, m.delimiter ? U(m.delimiter) && (m.delimiter = m.delimiter(e), p.meta.delimiter = m.delimiter) : ((r = ((e, t, i, r, n)=>{
                var s, a, o, h;
                n = n || [
                    ",",
                    "\t",
                    "|",
                    ";",
                    v.RECORD_SEP,
                    v.UNIT_SEP
                ];
                for(var u = 0; u < n.length; u++){
                    for(var d, f = n[u], l = 0, c = 0, p = 0, g = (o = void 0, new E({
                        comments: r,
                        delimiter: f,
                        newline: t,
                        preview: 10
                    }).parse(e)), _ = 0; _ < g.data.length; _++)i && y(g.data[_]) ? p++ : (d = g.data[_].length, c += d, void 0 === o ? o = d : 0 < d && (l += Math.abs(d - o), o = d));
                    0 < g.data.length && (c /= g.data.length - p), (void 0 === a || l <= a) && (void 0 === h || h < c) && 1.99 < c && (a = l, s = f, h = c);
                }
                return {
                    successful: !!(m.delimiter = s),
                    bestDelimiter: s
                };
            })(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess)).successful ? m.delimiter = r.bestDelimiter : (a = !0, m.delimiter = v.DefaultDelimiter), p.meta.delimiter = m.delimiter), b(m));
            return m.preview && m.header && r.preview++, n = e, s = new E(r), p = s.parse(n, t, i), g(), l ? {
                meta: {
                    paused: !0
                }
            } : p || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return l;
        }, this.pause = function() {
            l = !0, s.abort(), n = U(m.chunk) ? "" : n.substring(s.getCharIndex());
        }, this.resume = function() {
            i.streamer._halted ? (l = !1, i.streamer.parseChunk(n, !0)) : setTimeout(i.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, s.abort(), p.meta.aborted = !0, U(m.complete) && m.complete(p), n = "";
        }, this.guessLineEndings = function(e, t) {
            e = e.substring(0, 1048576);
            var t = new RegExp(P(t) + "([^]*?)" + P(t), "gm"), i = (e = e.replace(t, "")).split("\r"), t = e.split("\n"), e = 1 < t.length && t[0].length < i[0].length;
            if (1 === i.length || e) return "\n";
            for(var r = 0, n = 0; n < i.length; n++)"\n" === i[n][0] && r++;
            return r >= i.length / 2 ? "\r\n" : "\r";
        };
    }
    function P(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(C) {
        var S = (C = C || {}).delimiter, O = C.newline, x = C.comments, I = C.step, A = C.preview, T = C.fastMode, D = null, L = !1, F = null == C.quoteChar ? '"' : C.quoteChar, j = F;
        if (void 0 !== C.escapeChar && (j = C.escapeChar), ("string" != typeof S || -1 < v.BAD_DELIMITERS.indexOf(S)) && (S = ","), x === S) throw new Error("Comment character same as delimiter");
        !0 === x ? x = "#" : ("string" != typeof x || -1 < v.BAD_DELIMITERS.indexOf(x)) && (x = !1), "\n" !== O && "\r" !== O && "\r\n" !== O && (O = "\n");
        var z = 0, M = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = S.length, s = O.length, a = x.length, o = U(I), h = [], u = [], d = [], f = z = 0;
            if (!i) return w();
            if (T || !1 !== T && -1 === i.indexOf(F)) {
                for(var l = i.split(O), c = 0; c < l.length; c++){
                    if (d = l[c], z += d.length, c !== l.length - 1) z += O.length;
                    else if (r) return w();
                    if (!x || d.substring(0, a) !== x) {
                        if (o) {
                            if (h = [], k(d.split(S)), R(), M) return w();
                        } else k(d.split(S));
                        if (A && A <= c) return h = h.slice(0, A), w(!0);
                    }
                }
                return w();
            }
            for(var p = i.indexOf(S, z), g = i.indexOf(O, z), _ = new RegExp(P(j) + P(F), "g"), m = i.indexOf(F, z);;)if (i[z] === F) for(m = z, z++;;){
                if (-1 === (m = i.indexOf(F, m + 1))) return r || u.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: h.length,
                    index: z
                }), E();
                if (m === n - 1) return E(i.substring(z, m).replace(_, F));
                if (F === j && i[m + 1] === j) m++;
                else if (F === j || 0 === m || i[m - 1] !== j) {
                    -1 !== p && p < m + 1 && (p = i.indexOf(S, m + 1));
                    var y = v(-1 === (g = -1 !== g && g < m + 1 ? i.indexOf(O, m + 1) : g) ? p : Math.min(p, g));
                    if (i.substr(m + 1 + y, e) === S) {
                        d.push(i.substring(z, m).replace(_, F)), i[z = m + 1 + y + e] !== F && (m = i.indexOf(F, z)), p = i.indexOf(S, z), g = i.indexOf(O, z);
                        break;
                    }
                    y = v(g);
                    if (i.substring(m + 1 + y, m + 1 + y + s) === O) {
                        if (d.push(i.substring(z, m).replace(_, F)), b(m + 1 + y + s), p = i.indexOf(S, z), m = i.indexOf(F, z), o && (R(), M)) return w();
                        if (A && h.length >= A) return w(!0);
                        break;
                    }
                    u.push({
                        type: "Quotes",
                        code: "InvalidQuotes",
                        message: "Trailing quote on quoted field is malformed",
                        row: h.length,
                        index: z
                    }), m++;
                }
            }
            else if (x && 0 === d.length && i.substring(z, z + a) === x) {
                if (-1 === g) return w();
                z = g + s, g = i.indexOf(O, z), p = i.indexOf(S, z);
            } else if (-1 !== p && (p < g || -1 === g)) d.push(i.substring(z, p)), z = p + e, p = i.indexOf(S, z);
            else {
                if (-1 === g) break;
                if (d.push(i.substring(z, g)), b(g + s), o && (R(), M)) return w();
                if (A && h.length >= A) return w(!0);
            }
            return E();
            function k(e) {
                h.push(e), f = z;
            }
            function v(e) {
                var t = 0;
                return t = -1 !== e && (e = i.substring(m + 1, e)) && "" === e.trim() ? e.length : t;
            }
            function E(e) {
                return r || (void 0 === e && (e = i.substring(z)), d.push(e), z = n, k(d), o && R()), w();
            }
            function b(e) {
                z = e, k(d), d = [], g = i.indexOf(O, z);
            }
            function w(e) {
                if (C.header && !t && h.length && !L) {
                    var s = h[0], a = Object.create(null), o = new Set(s);
                    let n = !1;
                    for(let r = 0; r < s.length; r++){
                        let i = s[r];
                        if (a[i = U(C.transformHeader) ? C.transformHeader(i, r) : i]) {
                            let e, t = a[i];
                            for(; e = i + "_" + t, t++, o.has(e););
                            o.add(e), s[r] = e, a[i]++, n = !0, (D = null === D ? {} : D)[e] = i;
                        } else a[i] = 1, s[r] = i;
                        o.add(i);
                    }
                    n && console.warn("Duplicate headers found and renamed."), L = !0;
                }
                return {
                    data: h,
                    errors: u,
                    meta: {
                        delimiter: S,
                        linebreak: O,
                        aborted: M,
                        truncated: !!e,
                        cursor: f + (t || 0),
                        renamedHeaders: D
                    }
                };
            }
            function R() {
                I(w()), h = [], u = [];
            }
        }, this.abort = function() {
            M = !0;
        }, this.getCharIndex = function() {
            return z;
        };
    }
    function g(e) {
        var t = e.data, i = o[t.workerId], r = !1;
        if (t.error) i.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    r = !0, _(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: m,
                resume: m
            };
            if (U(i.userStep)) {
                for(var s = 0; s < t.results.data.length && (i.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !r); s++);
                delete t.results;
            } else U(i.userChunk) && (i.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !r && _(t.workerId, t.results);
    }
    function _(e, t) {
        var i = o[e];
        U(i.userComplete) && i.userComplete(t), i.terminate(), delete o[e];
    }
    function m() {
        throw new Error("Not implemented.");
    }
    function b(e) {
        if ("object" != typeof e || null === e) return e;
        var t, i = Array.isArray(e) ? [] : {};
        for(t in e)i[t] = b(e[t]);
        return i;
    }
    function y(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function U(e) {
        return "function" == typeof e;
    }
    return v.parse = function(e, t) {
        var i = (t = t || {}).dynamicTyping || !1;
        U(i) && (t.dynamicTypingFunction = i, i = {});
        if (t.dynamicTyping = i, t.transform = !!U(t.transform) && t.transform, !t.worker || !v.WORKERS_SUPPORTED) return i = null, v.NODE_STREAM_INPUT, "string" == typeof e ? (e = ((e)=>65279 !== e.charCodeAt(0) ? e : e.slice(1))(e), i = new (t.download ? f : c)(t)) : !0 === e.readable && U(e.read) && U(e.on) ? i = new p(t) : (n.File && e instanceof File || e instanceof Object) && (i = new l(t)), i.stream(e);
        (i = (()=>{
            var e;
            return !!v.WORKERS_SUPPORTED && (e = (()=>{
                var e = n.URL || n.webkitURL || null, t = r.toString();
                return v.BLOB_URL || (v.BLOB_URL = e.createObjectURL(new Blob([
                    "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                    "(",
                    t,
                    ")();"
                ], {
                    type: "text/javascript"
                })));
            })(), (e = new n.Worker(e)).onmessage = g, e.id = h++, o[e.id] = e);
        })()).userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = U(t.step), t.chunk = U(t.chunk), t.complete = U(t.complete), t.error = U(t.error), delete t.worker, i.postMessage({
            input: e,
            config: t,
            workerId: i.id
        });
    }, v.unparse = function(e, t) {
        var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, i = !1, r = null, o = !1, h = ((()=>{
            if ("object" == typeof t) {
                if ("string" != typeof t.delimiter || v.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter), "boolean" != typeof t.quotes && "function" != typeof t.quotes && !Array.isArray(t.quotes) || (n = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (i = t.skipEmptyLines), "string" == typeof t.newline && (y = t.newline), "string" == typeof t.quoteChar && (s = t.quoteChar), "boolean" == typeof t.header && (_ = t.header), Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    r = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s), t.escapeFormulae instanceof RegExp ? o = t.escapeFormulae : "boolean" == typeof t.escapeFormulae && t.escapeFormulae && (o = /^[=+\-@\t\r].*$/);
            }
        })(), new RegExp(P(s), "g"));
        "string" == typeof e && (e = JSON.parse(e));
        if (Array.isArray(e)) {
            if (!e.length || Array.isArray(e[0])) return u(null, e, i);
            if ("object" == typeof e[0]) return u(r || Object.keys(e[0]), e, i);
        } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || r), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
            e.data
        ])), u(e.fields || [], e.data || [], i);
        throw new Error("Unable to serialize unrecognized input");
        function u(e, t, i) {
            var r = "", n = ("string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t)), Array.isArray(e) && 0 < e.length), s = !Array.isArray(t[0]);
            if (n && _) {
                for(var a = 0; a < e.length; a++)0 < a && (r += m), r += k(e[a], a);
                0 < t.length && (r += y);
            }
            for(var o = 0; o < t.length; o++){
                var h = (n ? e : t[o]).length, u = !1, d = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                if (i && !n && (u = "greedy" === i ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === i && n) {
                    for(var f = [], l = 0; l < h; l++){
                        var c = s ? e[l] : l;
                        f.push(t[o][c]);
                    }
                    u = "" === f.join("").trim();
                }
                if (!u) {
                    for(var p = 0; p < h; p++){
                        0 < p && !d && (r += m);
                        var g = n && s ? e[p] : p;
                        r += k(t[o][g], p);
                    }
                    o < t.length - 1 && (!i || 0 < h && !d) && (r += y);
                }
            }
            return r;
        }
        function k(e, t) {
            var i, r;
            return null == e ? "" : e.constructor === Date ? JSON.stringify(e).slice(1, 25) : (r = !1, o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0), i = e.toString().replace(h, a), (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || ((e, t)=>{
                for(var i = 0; i < t.length; i++)if (-1 < e.indexOf(t[i])) return !0;
                return !1;
            })(i, v.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i);
        }
    }, v.RECORD_SEP = String.fromCharCode(30), v.UNIT_SEP = String.fromCharCode(31), v.BYTE_ORDER_MARK = "\ufeff", v.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        v.BYTE_ORDER_MARK
    ], v.WORKERS_SUPPORTED = !s && !!n.Worker, v.NODE_STREAM_INPUT = 1, v.LocalChunkSize = 10485760, v.RemoteChunkSize = 5242880, v.DefaultDelimiter = ",", v.Parser = E, v.ParserHandle = i, v.NetworkStreamer = f, v.FileStreamer = l, v.StringStreamer = c, v.ReadableStreamStreamer = p, n.jQuery && ((d = n.jQuery).fn.parse = function(o) {
        var i = o.config || {}, h = [];
        return this.each(function(e) {
            if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && n.FileReader) || !this.files || 0 === this.files.length) return !0;
            for(var t = 0; t < this.files.length; t++)h.push({
                file: this.files[t],
                inputElem: this,
                instanceConfig: d.extend({}, i)
            });
        }), e(), this;
        function e() {
            if (0 === h.length) U(o.complete) && o.complete();
            else {
                var e, t, i, r, n = h[0];
                if (U(o.before)) {
                    var s = o.before(n.file, n.inputElem);
                    if ("object" == typeof s) {
                        if ("abort" === s.action) return e = "AbortError", t = n.file, i = n.inputElem, r = s.reason, void (U(o.error) && o.error({
                            name: e
                        }, t, i, r));
                        if ("skip" === s.action) return void u();
                        "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                    } else if ("skip" === s) return void u();
                }
                var a = n.instanceConfig.complete;
                n.instanceConfig.complete = function(e) {
                    U(a) && a(e, n.file, n.inputElem), u();
                }, v.parse(n.file, n.instanceConfig);
            }
        }
        function u() {
            h.splice(0, 1), e();
        }
    }), a && (n.onmessage = function(e) {
        e = e.data;
        void 0 === v.WORKER_ID && e && (v.WORKER_ID = e.workerId);
        "string" == typeof e.input ? n.postMessage({
            workerId: v.WORKER_ID,
            results: v.parse(e.input, e.config),
            finished: !0
        }) : (n.File && e.input instanceof File || e.input instanceof Object) && (e = v.parse(e.input, e.config)) && n.postMessage({
            workerId: v.WORKER_ID,
            results: e,
            finished: !0
        });
    }), (f.prototype = Object.create(u.prototype)).constructor = f, (l.prototype = Object.create(u.prototype)).constructor = l, (c.prototype = Object.create(c.prototype)).constructor = c, (p.prototype = Object.create(u.prototype)).constructor = p, v;
});

});

parcelRegister("ie8g1", function(module, exports) {
"use strict";
var $d44ff08f039057b8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d44ff08f039057b8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $d44ff08f039057b8$var$frame_1 = $d44ff08f039057b8$var$__importDefault((parcelRequire("6QWdY")));
/**
 * Two-dimensional ndarray with axis labels.
 * The object supports both integer- and label-based indexing and provides a host of methods for performing operations involving the index.
 * Operations between DataFrame (+, -, /, , *) align values based on their associated index values– they need not be the same length.
 * @param data 2D Array, JSON, Tensor, Block of data.
 * @param options.index Array of numeric or string names for subseting array. If not specified, indexes are auto generated.
 * @param options.columns Array of column names. If not specified, column names are auto generated.
 * @param options.dtypes Array of data types for each the column. If not specified, dtypes are/is inferred.
 * @param options.config General configuration object for extending or setting NDframe behavior.
 */ var $d44ff08f039057b8$var$DataFrame = /** @class */ function(_super) {
    $d44ff08f039057b8$var$__extends(DataFrame, _super);
    function DataFrame(data, options) {
        if (options === void 0) options = {};
        return _super.call(this, data, options) || this;
    }
    return DataFrame;
}($d44ff08f039057b8$var$frame_1.default);
module.exports.default = $d44ff08f039057b8$var$DataFrame;

});

parcelRegister("4NwBO", function(module, exports) {
"use strict";
var $37e508746c66f1e2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $37e508746c66f1e2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/**
*  @license
* Copyright 2022 JsData. All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.

* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
* ==========================================================================
*/ var $37e508746c66f1e2$var$series_1 = $37e508746c66f1e2$var$__importDefault((parcelRequire("hIkcL")));
/**
 * One-dimensional ndarray with axis labels.
 * The object supports both integer- and label-based indexing and provides a host of methods for performing operations involving the index.
 * Operations between Series (+, -, /, , *) align values based on their associated index values – they need not be the same length.
 * @param data 1D Array, JSON, Tensor, Block of data.
 * @param options.index Array of numeric or string index for subseting array. If not specified, indices are auto generated.
 * @param options.columns Column name. This is like the name of the Series. If not specified, column name is set to 0.
 * @param options.dtypes Data types of the Series data. If not specified, dtypes is inferred.
 * @param options.config General configuration object for extending or setting Series behavior.
 */ var $37e508746c66f1e2$var$Series = /** @class */ function(_super) {
    $37e508746c66f1e2$var$__extends(Series, _super);
    function Series(data, options) {
        if (options === void 0) options = {};
        return _super.call(this, data, options) || this;
    }
    return Series;
}($37e508746c66f1e2$var$series_1.default);
module.exports.default = $37e508746c66f1e2$var$Series;

});


/* Tabulator v6.3.1 (c) Oliver Folkerd 2025 */ class $517dee46856d349e$var$CoreFeature {
    constructor(table){
        this.table = table;
    }
    //////////////////////////////////////////
    /////////////// DataLoad /////////////////
    //////////////////////////////////////////
    reloadData(data, silent, columnsChanged) {
        return this.table.dataLoader.load(data, undefined, undefined, undefined, silent, columnsChanged);
    }
    //////////////////////////////////////////
    ///////////// Localization ///////////////
    //////////////////////////////////////////
    langText() {
        return this.table.modules.localize.getText(...arguments);
    }
    langBind() {
        return this.table.modules.localize.bind(...arguments);
    }
    langLocale() {
        return this.table.modules.localize.getLocale(...arguments);
    }
    //////////////////////////////////////////
    ////////// Inter Table Comms /////////////
    //////////////////////////////////////////
    commsConnections() {
        return this.table.modules.comms.getConnections(...arguments);
    }
    commsSend() {
        return this.table.modules.comms.send(...arguments);
    }
    //////////////////////////////////////////
    //////////////// Layout  /////////////////
    //////////////////////////////////////////
    layoutMode() {
        return this.table.modules.layout.getMode();
    }
    layoutRefresh(force) {
        return this.table.modules.layout.layout(force);
    }
    //////////////////////////////////////////
    /////////////// Event Bus ////////////////
    //////////////////////////////////////////
    subscribe() {
        return this.table.eventBus.subscribe(...arguments);
    }
    unsubscribe() {
        return this.table.eventBus.unsubscribe(...arguments);
    }
    subscribed(key) {
        return this.table.eventBus.subscribed(key);
    }
    subscriptionChange() {
        return this.table.eventBus.subscriptionChange(...arguments);
    }
    dispatch() {
        return this.table.eventBus.dispatch(...arguments);
    }
    chain() {
        return this.table.eventBus.chain(...arguments);
    }
    confirm() {
        return this.table.eventBus.confirm(...arguments);
    }
    dispatchExternal() {
        return this.table.externalEvents.dispatch(...arguments);
    }
    subscribedExternal(key) {
        return this.table.externalEvents.subscribed(key);
    }
    subscriptionChangeExternal() {
        return this.table.externalEvents.subscriptionChange(...arguments);
    }
    //////////////////////////////////////////
    //////////////// Options /////////////////
    //////////////////////////////////////////
    options(key) {
        return this.table.options[key];
    }
    setOption(key, value) {
        if (typeof value !== "undefined") this.table.options[key] = value;
        return this.table.options[key];
    }
    //////////////////////////////////////////
    /////////// Deprecation Checks ///////////
    //////////////////////////////////////////
    deprecationCheck(oldOption, newOption, convert) {
        return this.table.deprecationAdvisor.check(oldOption, newOption, convert);
    }
    deprecationCheckMsg(oldOption, msg) {
        return this.table.deprecationAdvisor.checkMsg(oldOption, msg);
    }
    deprecationMsg(msg) {
        return this.table.deprecationAdvisor.msg(msg);
    }
    //////////////////////////////////////////
    //////////////// Modules /////////////////
    //////////////////////////////////////////
    module(key) {
        return this.table.module(key);
    }
}
class $517dee46856d349e$var$Helpers {
    static elVisible(el) {
        return !(el.offsetWidth <= 0 && el.offsetHeight <= 0);
    }
    static elOffset(el) {
        var box = el.getBoundingClientRect();
        return {
            top: box.top + window.pageYOffset - document.documentElement.clientTop,
            left: box.left + window.pageXOffset - document.documentElement.clientLeft
        };
    }
    static retrieveNestedData(separator, field, data) {
        var structure = separator ? field.split(separator) : [
            field
        ], length = structure.length, output;
        for(let i = 0; i < length; i++){
            data = data[structure[i]];
            output = data;
            if (!data) break;
        }
        return output;
    }
    static deepClone(obj, clone, list = []) {
        var objectProto = {}.__proto__, arrayProto = [].__proto__;
        if (!clone) clone = Object.assign(Array.isArray(obj) ? [] : {}, obj);
        for(var i in obj){
            let subject = obj[i], match, copy;
            if (subject != null && typeof subject === "object" && (subject.__proto__ === objectProto || subject.__proto__ === arrayProto)) {
                match = list.findIndex((item)=>{
                    return item.subject === subject;
                });
                if (match > -1) clone[i] = list[match].copy;
                else {
                    copy = Object.assign(Array.isArray(subject) ? [] : {}, subject);
                    list.unshift({
                        subject: subject,
                        copy: copy
                    });
                    clone[i] = this.deepClone(subject, copy, list);
                }
            }
        }
        return clone;
    }
}
let $517dee46856d349e$var$Popup$1 = class Popup extends $517dee46856d349e$var$CoreFeature {
    constructor(table, element, parent){
        super(table);
        this.element = element;
        this.container = this._lookupContainer();
        this.parent = parent;
        this.reversedX = false;
        this.childPopup = null;
        this.blurable = false;
        this.blurCallback = null;
        this.blurEventsBound = false;
        this.renderedCallback = null;
        this.visible = false;
        this.hideable = true;
        this.element.classList.add("tabulator-popup-container");
        this.blurEvent = this.hide.bind(this, false);
        this.escEvent = this._escapeCheck.bind(this);
        this.destroyBinding = this.tableDestroyed.bind(this);
        this.destroyed = false;
    }
    tableDestroyed() {
        this.destroyed = true;
        this.hide(true);
    }
    _lookupContainer() {
        var container = this.table.options.popupContainer;
        if (typeof container === "string") {
            container = document.querySelector(container);
            if (!container) console.warn("Menu Error - no container element found matching selector:", this.table.options.popupContainer, "(defaulting to document body)");
        } else if (container === true) container = this.table.element;
        if (container && !this._checkContainerIsParent(container)) {
            container = false;
            console.warn("Menu Error - container element does not contain this table:", this.table.options.popupContainer, "(defaulting to document body)");
        }
        if (!container) container = document.body;
        return container;
    }
    _checkContainerIsParent(container, element = this.table.element) {
        if (container === element) return true;
        else return element.parentNode ? this._checkContainerIsParent(container, element.parentNode) : false;
    }
    renderCallback(callback) {
        this.renderedCallback = callback;
    }
    containerEventCoords(e) {
        var touch = !(e instanceof MouseEvent);
        var x = touch ? e.touches[0].pageX : e.pageX;
        var y = touch ? e.touches[0].pageY : e.pageY;
        if (this.container !== document.body) {
            let parentOffset = $517dee46856d349e$var$Helpers.elOffset(this.container);
            x -= parentOffset.left;
            y -= parentOffset.top;
        }
        return {
            x: x,
            y: y
        };
    }
    elementPositionCoords(element, position = "right") {
        var offset = $517dee46856d349e$var$Helpers.elOffset(element), containerOffset, x, y;
        if (this.container !== document.body) {
            containerOffset = $517dee46856d349e$var$Helpers.elOffset(this.container);
            offset.left -= containerOffset.left;
            offset.top -= containerOffset.top;
        }
        switch(position){
            case "right":
                x = offset.left + element.offsetWidth;
                y = offset.top - 1;
                break;
            case "bottom":
                x = offset.left;
                y = offset.top + element.offsetHeight;
                break;
            case "left":
                x = offset.left;
                y = offset.top - 1;
                break;
            case "top":
                x = offset.left;
                y = offset.top;
                break;
            case "center":
                x = offset.left + element.offsetWidth / 2;
                y = offset.top + element.offsetHeight / 2;
                break;
        }
        return {
            x: x,
            y: y,
            offset: offset
        };
    }
    show(origin, position) {
        var x, y, parentEl, parentOffset, coords;
        if (this.destroyed || this.table.destroyed) return this;
        if (origin instanceof HTMLElement) {
            parentEl = origin;
            coords = this.elementPositionCoords(origin, position);
            parentOffset = coords.offset;
            x = coords.x;
            y = coords.y;
        } else if (typeof origin === "number") {
            parentOffset = {
                top: 0,
                left: 0
            };
            x = origin;
            y = position;
        } else {
            coords = this.containerEventCoords(origin);
            x = coords.x;
            y = coords.y;
            this.reversedX = false;
        }
        this.element.style.top = y + "px";
        this.element.style.left = x + "px";
        this.container.appendChild(this.element);
        if (typeof this.renderedCallback === "function") this.renderedCallback();
        this._fitToScreen(x, y, parentEl, parentOffset, position);
        this.visible = true;
        this.subscribe("table-destroy", this.destroyBinding);
        this.element.addEventListener("mousedown", (e)=>{
            e.stopPropagation();
        });
        return this;
    }
    _fitToScreen(x, y, parentEl, parentOffset, position) {
        var scrollTop = this.container === document.body ? document.documentElement.scrollTop : this.container.scrollTop;
        //move menu to start on right edge if it is too close to the edge of the screen
        if (x + this.element.offsetWidth >= this.container.offsetWidth || this.reversedX) {
            this.element.style.left = "";
            if (parentEl) this.element.style.right = this.container.offsetWidth - parentOffset.left + "px";
            else this.element.style.right = this.container.offsetWidth - x + "px";
            this.reversedX = true;
        }
        //move menu to start on bottom edge if it is too close to the edge of the screen
        let offsetHeight = Math.max(this.container.offsetHeight, scrollTop ? this.container.scrollHeight : 0);
        if (y + this.element.offsetHeight > offsetHeight) {
            if (parentEl) switch(position){
                case "bottom":
                    this.element.style.top = parseInt(this.element.style.top) - this.element.offsetHeight - parentEl.offsetHeight - 1 + "px";
                    break;
                default:
                    this.element.style.top = parseInt(this.element.style.top) - this.element.offsetHeight + parentEl.offsetHeight + 1 + "px";
            }
            else this.element.style.height = offsetHeight + "px";
        }
    }
    isVisible() {
        return this.visible;
    }
    hideOnBlur(callback) {
        this.blurable = true;
        if (this.visible) {
            setTimeout(()=>{
                if (this.visible) {
                    this.table.rowManager.element.addEventListener("scroll", this.blurEvent);
                    this.subscribe("cell-editing", this.blurEvent);
                    document.body.addEventListener("click", this.blurEvent);
                    document.body.addEventListener("contextmenu", this.blurEvent);
                    document.body.addEventListener("mousedown", this.blurEvent);
                    window.addEventListener("resize", this.blurEvent);
                    document.body.addEventListener("keydown", this.escEvent);
                    this.blurEventsBound = true;
                }
            }, 100);
            this.blurCallback = callback;
        }
        return this;
    }
    _escapeCheck(e) {
        if (e.keyCode == 27) this.hide();
    }
    blockHide() {
        this.hideable = false;
    }
    restoreHide() {
        this.hideable = true;
    }
    hide(silent = false) {
        if (this.visible && this.hideable) {
            if (this.blurable && this.blurEventsBound) {
                document.body.removeEventListener("keydown", this.escEvent);
                document.body.removeEventListener("click", this.blurEvent);
                document.body.removeEventListener("contextmenu", this.blurEvent);
                document.body.removeEventListener("mousedown", this.blurEvent);
                window.removeEventListener("resize", this.blurEvent);
                this.table.rowManager.element.removeEventListener("scroll", this.blurEvent);
                this.unsubscribe("cell-editing", this.blurEvent);
                this.blurEventsBound = false;
            }
            if (this.childPopup) this.childPopup.hide();
            if (this.parent) this.parent.childPopup = null;
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
            this.visible = false;
            if (this.blurCallback && !silent) this.blurCallback();
            this.unsubscribe("table-destroy", this.destroyBinding);
        }
        return this;
    }
    child(element) {
        if (this.childPopup) this.childPopup.hide();
        this.childPopup = new Popup(this.table, element, this);
        return this.childPopup;
    }
};
class $517dee46856d349e$export$c3a9d7ff17e4f3ed extends $517dee46856d349e$var$CoreFeature {
    constructor(table, name){
        super(table);
        this._handler = null;
    }
    initialize() {
    // setup module when table is initialized, to be overridden in module
    }
    ///////////////////////////////////
    ////// Options Registration ///////
    ///////////////////////////////////
    registerTableOption(key, value) {
        this.table.optionsList.register(key, value);
    }
    registerColumnOption(key, value) {
        this.table.columnManager.optionsList.register(key, value);
    }
    ///////////////////////////////////
    /// Public Function Registration ///
    ///////////////////////////////////
    registerTableFunction(name, func) {
        if (typeof this.table[name] === "undefined") this.table[name] = (...args)=>{
            this.table.initGuard(name);
            return func(...args);
        };
        else console.warn("Unable to bind table function, name already in use", name);
    }
    registerComponentFunction(component, func, handler) {
        return this.table.componentFunctionBinder.bind(component, func, handler);
    }
    ///////////////////////////////////
    ////////// Data Pipeline //////////
    ///////////////////////////////////
    registerDataHandler(handler, priority) {
        this.table.rowManager.registerDataPipelineHandler(handler, priority);
        this._handler = handler;
    }
    registerDisplayHandler(handler, priority) {
        this.table.rowManager.registerDisplayPipelineHandler(handler, priority);
        this._handler = handler;
    }
    displayRows(adjust) {
        var index = this.table.rowManager.displayRows.length - 1, lookupIndex;
        if (this._handler) {
            lookupIndex = this.table.rowManager.displayPipeline.findIndex((item)=>{
                return item.handler === this._handler;
            });
            if (lookupIndex > -1) index = lookupIndex;
        }
        if (adjust) index = index + adjust;
        if (this._handler) {
            if (index > -1) return this.table.rowManager.getDisplayRows(index);
            else return this.activeRows();
        }
    }
    activeRows() {
        return this.table.rowManager.activeRows;
    }
    refreshData(renderInPosition, handler) {
        if (!handler) handler = this._handler;
        if (handler) this.table.rowManager.refreshActiveData(handler, false, renderInPosition);
    }
    ///////////////////////////////////
    //////// Footer Management ////////
    ///////////////////////////////////
    footerAppend(element) {
        return this.table.footerManager.append(element);
    }
    footerPrepend(element) {
        return this.table.footerManager.prepend(element);
    }
    footerRemove(element) {
        return this.table.footerManager.remove(element);
    }
    ///////////////////////////////////
    //////// Popups Management ////////
    ///////////////////////////////////
    popup(menuEl, menuContainer) {
        return new $517dee46856d349e$var$Popup$1(this.table, menuEl, menuContainer);
    }
    ///////////////////////////////////
    //////// Alert Management ////////
    ///////////////////////////////////
    alert(content, type) {
        return this.table.alertManager.alert(content, type);
    }
    clearAlert() {
        return this.table.alertManager.clear();
    }
}
var $517dee46856d349e$var$defaultAccessors = {
    rownum: function(value, data, type, params, column, row) {
        return row.getPosition();
    }
};
class $517dee46856d349e$export$bf9f5472bce61c69 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "accessor";
    //load defaults
    static accessors = $517dee46856d349e$var$defaultAccessors;
    constructor(table){
        super(table);
        this.allowedTypes = [
            "",
            "data",
            "download",
            "clipboard",
            "print",
            "htmlOutput"
        ]; //list of accessor types
        this.registerColumnOption("accessor");
        this.registerColumnOption("accessorParams");
        this.registerColumnOption("accessorData");
        this.registerColumnOption("accessorDataParams");
        this.registerColumnOption("accessorDownload");
        this.registerColumnOption("accessorDownloadParams");
        this.registerColumnOption("accessorClipboard");
        this.registerColumnOption("accessorClipboardParams");
        this.registerColumnOption("accessorPrint");
        this.registerColumnOption("accessorPrintParams");
        this.registerColumnOption("accessorHtmlOutput");
        this.registerColumnOption("accessorHtmlOutputParams");
    }
    initialize() {
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("row-data-retrieve", this.transformRow.bind(this));
    }
    //initialize column accessor
    initializeColumn(column) {
        var match = false, config = {};
        this.allowedTypes.forEach((type)=>{
            var key = "accessor" + (type.charAt(0).toUpperCase() + type.slice(1)), accessor;
            if (column.definition[key]) {
                accessor = this.lookupAccessor(column.definition[key]);
                if (accessor) {
                    match = true;
                    config[key] = {
                        accessor: accessor,
                        params: column.definition[key + "Params"] || {}
                    };
                }
            }
        });
        if (match) column.modules.accessor = config;
    }
    lookupAccessor(value) {
        var accessor = false;
        //set column accessor
        switch(typeof value){
            case "string":
                if ($517dee46856d349e$export$bf9f5472bce61c69.accessors[value]) accessor = $517dee46856d349e$export$bf9f5472bce61c69.accessors[value];
                else console.warn("Accessor Error - No such accessor found, ignoring: ", value);
                break;
            case "function":
                accessor = value;
                break;
        }
        return accessor;
    }
    //apply accessor to row
    transformRow(row, type) {
        var key = "accessor" + (type.charAt(0).toUpperCase() + type.slice(1)), rowComponent = row.getComponent();
        //clone data object with deep copy to isolate internal data from returned result
        var data = $517dee46856d349e$var$Helpers.deepClone(row.data || {});
        this.table.columnManager.traverse(function(column) {
            var value, accessor, params, colComponent;
            if (column.modules.accessor) {
                accessor = column.modules.accessor[key] || column.modules.accessor.accessor || false;
                if (accessor) {
                    value = column.getFieldValue(data);
                    if (value != "undefined") {
                        colComponent = column.getComponent();
                        params = typeof accessor.params === "function" ? accessor.params(value, data, type, colComponent, rowComponent) : accessor.params;
                        column.setFieldValue(data, accessor.accessor(value, data, type, params, colComponent, rowComponent));
                    }
                }
            }
        });
        return data;
    }
}
var $517dee46856d349e$var$defaultConfig = {
    method: "GET"
};
function $517dee46856d349e$var$generateParamsList$1(data, prefix) {
    var output = [];
    prefix = prefix || "";
    if (Array.isArray(data)) data.forEach((item, i)=>{
        output = output.concat($517dee46856d349e$var$generateParamsList$1(item, prefix ? prefix + "[" + i + "]" : i));
    });
    else if (typeof data === "object") for(var key in data)output = output.concat($517dee46856d349e$var$generateParamsList$1(data[key], prefix ? prefix + "[" + key + "]" : key));
    else output.push({
        key: prefix,
        value: data
    });
    return output;
}
function $517dee46856d349e$var$serializeParams(params) {
    var output = $517dee46856d349e$var$generateParamsList$1(params), encoded = [];
    output.forEach(function(item) {
        encoded.push(encodeURIComponent(item.key) + "=" + encodeURIComponent(item.value));
    });
    return encoded.join("&");
}
function $517dee46856d349e$var$urlBuilder(url, config, params) {
    if (url) {
        if (params && Object.keys(params).length) {
            if (!config.method || config.method.toLowerCase() == "get") {
                config.method = "get";
                url += (url.includes("?") ? "&" : "?") + $517dee46856d349e$var$serializeParams(params);
            }
        }
    }
    return url;
}
function $517dee46856d349e$var$defaultLoaderPromise(url, config, params) {
    var contentType;
    return new Promise((resolve, reject)=>{
        //set url
        url = this.urlGenerator.call(this.table, url, config, params);
        //set body content if not GET request
        if (config.method.toUpperCase() != "GET") {
            contentType = typeof this.table.options.ajaxContentType === "object" ? this.table.options.ajaxContentType : this.contentTypeFormatters[this.table.options.ajaxContentType];
            if (contentType) {
                for(var key in contentType.headers){
                    if (!config.headers) config.headers = {};
                    if (typeof config.headers[key] === "undefined") config.headers[key] = contentType.headers[key];
                }
                config.body = contentType.body.call(this, url, config, params);
            } else console.warn("Ajax Error - Invalid ajaxContentType value:", this.table.options.ajaxContentType);
        }
        if (url) {
            //configure headers
            if (typeof config.headers === "undefined") config.headers = {};
            if (typeof config.headers.Accept === "undefined") config.headers.Accept = "application/json";
            if (typeof config.headers["X-Requested-With"] === "undefined") config.headers["X-Requested-With"] = "XMLHttpRequest";
            if (typeof config.mode === "undefined") config.mode = "cors";
            if (config.mode == "cors") {
                if (typeof config.headers["Origin"] === "undefined") config.headers["Origin"] = window.location.origin;
                if (typeof config.credentials === "undefined") config.credentials = 'same-origin';
            } else if (typeof config.credentials === "undefined") config.credentials = 'include';
            //send request
            fetch(url, config).then((response)=>{
                if (response.ok) response.json().then((data)=>{
                    resolve(data);
                }).catch((error)=>{
                    reject(error);
                    console.warn("Ajax Load Error - Invalid JSON returned", error);
                });
                else {
                    console.error("Ajax Load Error - Connection Error: " + response.status, response.statusText);
                    reject(response);
                }
            }).catch((error)=>{
                console.error("Ajax Load Error - Connection Error: ", error);
                reject(error);
            });
        } else {
            console.warn("Ajax Load Error - No URL Set");
            resolve([]);
        }
    });
}
function $517dee46856d349e$var$generateParamsList(data, prefix) {
    var output = [];
    prefix = prefix || "";
    if (Array.isArray(data)) data.forEach((item, i)=>{
        output = output.concat($517dee46856d349e$var$generateParamsList(item, prefix ? prefix + "[" + i + "]" : i));
    });
    else if (typeof data === "object") for(var key in data)output = output.concat($517dee46856d349e$var$generateParamsList(data[key], prefix ? prefix + "[" + key + "]" : key));
    else output.push({
        key: prefix,
        value: data
    });
    return output;
}
var $517dee46856d349e$var$defaultContentTypeFormatters = {
    "json": {
        headers: {
            'Content-Type': 'application/json'
        },
        body: function(url, config, params) {
            return JSON.stringify(params);
        }
    },
    "form": {
        headers: {},
        body: function(url, config, params) {
            var output = $517dee46856d349e$var$generateParamsList(params), form = new FormData();
            output.forEach(function(item) {
                form.append(item.key, item.value);
            });
            return form;
        }
    }
};
class $517dee46856d349e$export$b25c9f93be571d3a extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "ajax";
    //load defaults
    static defaultConfig = $517dee46856d349e$var$defaultConfig;
    static defaultURLGenerator = $517dee46856d349e$var$urlBuilder;
    static defaultLoaderPromise = $517dee46856d349e$var$defaultLoaderPromise;
    static contentTypeFormatters = $517dee46856d349e$var$defaultContentTypeFormatters;
    constructor(table){
        super(table);
        this.config = {}; //hold config object for ajax request
        this.url = ""; //request URL
        this.urlGenerator = false;
        this.params = false; //request parameters
        this.loaderPromise = false;
        this.registerTableOption("ajaxURL", false); //url for ajax loading
        this.registerTableOption("ajaxURLGenerator", false);
        this.registerTableOption("ajaxParams", {}); //params for ajax loading
        this.registerTableOption("ajaxConfig", "get"); //ajax request type
        this.registerTableOption("ajaxContentType", "form"); //ajax request type
        this.registerTableOption("ajaxRequestFunc", false); //promise function
        this.registerTableOption("ajaxRequesting", function() {});
        this.registerTableOption("ajaxResponse", false);
        this.contentTypeFormatters = $517dee46856d349e$export$b25c9f93be571d3a.contentTypeFormatters;
    }
    //initialize setup options
    initialize() {
        this.loaderPromise = this.table.options.ajaxRequestFunc || $517dee46856d349e$export$b25c9f93be571d3a.defaultLoaderPromise;
        this.urlGenerator = this.table.options.ajaxURLGenerator || $517dee46856d349e$export$b25c9f93be571d3a.defaultURLGenerator;
        if (this.table.options.ajaxURL) this.setUrl(this.table.options.ajaxURL);
        this.setDefaultConfig(this.table.options.ajaxConfig);
        this.registerTableFunction("getAjaxUrl", this.getUrl.bind(this));
        this.subscribe("data-loading", this.requestDataCheck.bind(this));
        this.subscribe("data-params", this.requestParams.bind(this));
        this.subscribe("data-load", this.requestData.bind(this));
    }
    requestParams(data, config, silent, params) {
        var ajaxParams = this.table.options.ajaxParams;
        if (ajaxParams) {
            if (typeof ajaxParams === "function") ajaxParams = ajaxParams.call(this.table);
            params = Object.assign(Object.assign({}, ajaxParams), params);
        }
        return params;
    }
    requestDataCheck(data, params, config, silent) {
        return !!(!data && this.url || typeof data === "string");
    }
    requestData(url, params, config, silent, previousData) {
        var ajaxConfig;
        if (!previousData && this.requestDataCheck(url)) {
            if (url) this.setUrl(url);
            ajaxConfig = this.generateConfig(config);
            return this.sendRequest(this.url, params, ajaxConfig);
        } else return previousData;
    }
    setDefaultConfig(config = {}) {
        this.config = Object.assign({}, $517dee46856d349e$export$b25c9f93be571d3a.defaultConfig);
        if (typeof config == "string") this.config.method = config;
        else Object.assign(this.config, config);
    }
    //load config object
    generateConfig(config = {}) {
        var ajaxConfig = Object.assign({}, this.config);
        if (typeof config == "string") ajaxConfig.method = config;
        else Object.assign(ajaxConfig, config);
        return ajaxConfig;
    }
    //set request url
    setUrl(url) {
        this.url = url;
    }
    //get request url
    getUrl() {
        return this.url;
    }
    //send ajax request
    sendRequest(url, params, config) {
        if (this.table.options.ajaxRequesting.call(this.table, url, params) !== false) return this.loaderPromise(url, config, params).then((data)=>{
            if (this.table.options.ajaxResponse) data = this.table.options.ajaxResponse.call(this.table, url, params, data);
            return data;
        });
        else return Promise.reject();
    }
}
var $517dee46856d349e$var$defaultPasteActions = {
    replace: function(data) {
        return this.table.setData(data);
    },
    update: function(data) {
        return this.table.updateOrAddData(data);
    },
    insert: function(data) {
        return this.table.addData(data);
    }
};
var $517dee46856d349e$var$defaultPasteParsers = {
    table: function(clipboard) {
        var data = [], headerFindSuccess = true, columns = this.table.columnManager.columns, columnMap = [], rows = [];
        //get data from clipboard into array of columns and rows.
        clipboard = clipboard.split("\n");
        clipboard.forEach(function(row) {
            data.push(row.split("\t"));
        });
        if (data.length && !(data.length === 1 && data[0].length < 2)) {
            //check if headers are present by title
            data[0].forEach(function(value) {
                var column = columns.find(function(column) {
                    return value && column.definition.title && value.trim() && column.definition.title.trim() === value.trim();
                });
                if (column) columnMap.push(column);
                else headerFindSuccess = false;
            });
            //check if column headers are present by field
            if (!headerFindSuccess) {
                headerFindSuccess = true;
                columnMap = [];
                data[0].forEach(function(value) {
                    var column = columns.find(function(column) {
                        return value && column.field && value.trim() && column.field.trim() === value.trim();
                    });
                    if (column) columnMap.push(column);
                    else headerFindSuccess = false;
                });
                if (!headerFindSuccess) columnMap = this.table.columnManager.columnsByIndex;
            }
            //remove header row if found
            if (headerFindSuccess) data.shift();
            data.forEach(function(item) {
                var row = {};
                item.forEach(function(value, i) {
                    if (columnMap[i]) row[columnMap[i].field] = value;
                });
                rows.push(row);
            });
            return rows;
        } else return false;
    }
};
var $517dee46856d349e$var$bindings$2 = {
    copyToClipboard: [
        "ctrl + 67",
        "meta + 67"
    ]
};
var $517dee46856d349e$var$actions$2 = {
    copyToClipboard: function(e) {
        if (!this.table.modules.edit.currentCell) {
            if (this.table.modExists("clipboard", true)) this.table.modules.clipboard.copy(false, true);
        }
    }
};
var $517dee46856d349e$var$extensions$4 = {
    keybindings: {
        bindings: $517dee46856d349e$var$bindings$2,
        actions: $517dee46856d349e$var$actions$2
    }
};
class $517dee46856d349e$export$3a36bd45ca02edda extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "clipboard";
    static moduleExtensions = $517dee46856d349e$var$extensions$4;
    //load defaults
    static pasteActions = $517dee46856d349e$var$defaultPasteActions;
    static pasteParsers = $517dee46856d349e$var$defaultPasteParsers;
    constructor(table){
        super(table);
        this.mode = true;
        this.pasteParser = function() {};
        this.pasteAction = function() {};
        this.customSelection = false;
        this.rowRange = false;
        this.blocked = true; //block copy actions not originating from this command
        this.registerTableOption("clipboard", false); //enable clipboard
        this.registerTableOption("clipboardCopyStyled", true); //formatted table data
        this.registerTableOption("clipboardCopyConfig", false); //clipboard config
        this.registerTableOption("clipboardCopyFormatter", false); //DEPRECATED - REMOVE in 5.0
        this.registerTableOption("clipboardCopyRowRange", "active"); //restrict clipboard to visible rows only
        this.registerTableOption("clipboardPasteParser", "table"); //convert pasted clipboard data to rows
        this.registerTableOption("clipboardPasteAction", "insert"); //how to insert pasted data into the table
        this.registerColumnOption("clipboard");
        this.registerColumnOption("titleClipboard");
    }
    initialize() {
        this.mode = this.table.options.clipboard;
        this.rowRange = this.table.options.clipboardCopyRowRange;
        if (this.mode === true || this.mode === "copy") this.table.element.addEventListener("copy", (e)=>{
            var plain, html, list;
            if (!this.blocked) {
                e.preventDefault();
                if (this.customSelection) {
                    plain = this.customSelection;
                    if (this.table.options.clipboardCopyFormatter) plain = this.table.options.clipboardCopyFormatter("plain", plain);
                } else {
                    list = this.table.modules.export.generateExportList(this.table.options.clipboardCopyConfig, this.table.options.clipboardCopyStyled, this.rowRange, "clipboard");
                    html = this.table.modules.export.generateHTMLTable(list);
                    plain = html ? this.generatePlainContent(list) : "";
                    if (this.table.options.clipboardCopyFormatter) {
                        plain = this.table.options.clipboardCopyFormatter("plain", plain);
                        html = this.table.options.clipboardCopyFormatter("html", html);
                    }
                }
                if (window.clipboardData && window.clipboardData.setData) window.clipboardData.setData('Text', plain);
                else if (e.clipboardData && e.clipboardData.setData) {
                    e.clipboardData.setData('text/plain', plain);
                    if (html) e.clipboardData.setData('text/html', html);
                } else if (e.originalEvent && e.originalEvent.clipboardData.setData) {
                    e.originalEvent.clipboardData.setData('text/plain', plain);
                    if (html) e.originalEvent.clipboardData.setData('text/html', html);
                }
                this.dispatchExternal("clipboardCopied", plain, html);
                this.reset();
            }
        });
        if (this.mode === true || this.mode === "paste") this.table.element.addEventListener("paste", (e)=>{
            this.paste(e);
        });
        this.setPasteParser(this.table.options.clipboardPasteParser);
        this.setPasteAction(this.table.options.clipboardPasteAction);
        this.registerTableFunction("copyToClipboard", this.copy.bind(this));
    }
    reset() {
        this.blocked = true;
        this.customSelection = false;
    }
    generatePlainContent(list) {
        var output = [];
        list.forEach((row)=>{
            var rowData = [];
            row.columns.forEach((col)=>{
                var value = "";
                if (col) {
                    if (row.type === "group") col.value = col.component.getKey();
                    if (col.value === null) value = "";
                    else switch(typeof col.value){
                        case "object":
                            value = JSON.stringify(col.value);
                            break;
                        case "undefined":
                            value = "";
                            break;
                        default:
                            value = col.value;
                    }
                }
                rowData.push(value);
            });
            output.push(rowData.join("\t"));
        });
        return output.join("\n");
    }
    copy(range, internal) {
        var sel, textRange;
        this.blocked = false;
        this.customSelection = false;
        if (this.mode === true || this.mode === "copy") {
            this.rowRange = range || this.table.options.clipboardCopyRowRange;
            if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
                range = document.createRange();
                range.selectNodeContents(this.table.element);
                sel = window.getSelection();
                if (sel.toString() && internal) this.customSelection = sel.toString();
                sel.removeAllRanges();
                sel.addRange(range);
            } else if (typeof document.selection != "undefined" && typeof document.body.createTextRange != "undefined") {
                textRange = document.body.createTextRange();
                textRange.moveToElementText(this.table.element);
                textRange.select();
            }
            document.execCommand('copy');
            if (sel) sel.removeAllRanges();
        }
    }
    //PASTE EVENT HANDLING
    setPasteAction(action) {
        switch(typeof action){
            case "string":
                this.pasteAction = $517dee46856d349e$export$3a36bd45ca02edda.pasteActions[action];
                if (!this.pasteAction) console.warn("Clipboard Error - No such paste action found:", action);
                break;
            case "function":
                this.pasteAction = action;
                break;
        }
    }
    setPasteParser(parser) {
        switch(typeof parser){
            case "string":
                this.pasteParser = $517dee46856d349e$export$3a36bd45ca02edda.pasteParsers[parser];
                if (!this.pasteParser) console.warn("Clipboard Error - No such paste parser found:", parser);
                break;
            case "function":
                this.pasteParser = parser;
                break;
        }
    }
    paste(e) {
        var data, rowData, rows;
        if (this.checkPasteOrigin(e)) {
            data = this.getPasteData(e);
            rowData = this.pasteParser.call(this, data);
            if (rowData) {
                e.preventDefault();
                if (this.table.modExists("mutator")) rowData = this.mutateData(rowData);
                rows = this.pasteAction.call(this, rowData);
                this.dispatchExternal("clipboardPasted", data, rowData, rows);
            } else this.dispatchExternal("clipboardPasteError", data);
        }
    }
    mutateData(data) {
        var output = [];
        if (Array.isArray(data)) data.forEach((row)=>{
            output.push(this.table.modules.mutator.transformRow(row, "clipboard"));
        });
        else output = data;
        return output;
    }
    checkPasteOrigin(e) {
        var valid = true;
        var blocked = this.confirm("clipboard-paste", [
            e
        ]);
        if (blocked || ![
            "DIV",
            "SPAN"
        ].includes(e.target.tagName)) valid = false;
        return valid;
    }
    getPasteData(e) {
        var data;
        if (window.clipboardData && window.clipboardData.getData) data = window.clipboardData.getData('Text');
        else if (e.clipboardData && e.clipboardData.getData) data = e.clipboardData.getData('text/plain');
        else if (e.originalEvent && e.originalEvent.clipboardData.getData) data = e.originalEvent.clipboardData.getData('text/plain');
        return data;
    }
}
class $517dee46856d349e$export$3ef2519bf7055551 {
    constructor(row){
        this._row = row;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._row.table.componentFunctionBinder.handle("row", target._row, name);
            }
        });
    }
    getData(transform) {
        return this._row.getData(transform);
    }
    getElement() {
        return this._row.getElement();
    }
    getTable() {
        return this._row.table;
    }
    getCells() {
        var cells = [];
        this._row.getCells().forEach(function(cell) {
            cells.push(cell.getComponent());
        });
        return cells;
    }
    getCell(column) {
        var cell = this._row.getCell(column);
        return cell ? cell.getComponent() : false;
    }
    _getSelf() {
        return this._row;
    }
}
//public cell object
class $517dee46856d349e$export$1919f52c249c72c9 {
    constructor(cell){
        this._cell = cell;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._cell.table.componentFunctionBinder.handle("cell", target._cell, name);
            }
        });
    }
    getValue() {
        return this._cell.getValue();
    }
    getOldValue() {
        return this._cell.getOldValue();
    }
    getInitialValue() {
        return this._cell.initialValue;
    }
    getElement() {
        return this._cell.getElement();
    }
    getRow() {
        return this._cell.row.getComponent();
    }
    getData(transform) {
        return this._cell.row.getData(transform);
    }
    getType() {
        return "cell";
    }
    getField() {
        return this._cell.column.getField();
    }
    getColumn() {
        return this._cell.column.getComponent();
    }
    setValue(value, mutate) {
        if (typeof mutate == "undefined") mutate = true;
        this._cell.setValue(value, mutate);
    }
    restoreOldValue() {
        this._cell.setValueActual(this._cell.getOldValue());
    }
    restoreInitialValue() {
        this._cell.setValueActual(this._cell.initialValue);
    }
    checkHeight() {
        this._cell.checkHeight();
    }
    getTable() {
        return this._cell.table;
    }
    _getSelf() {
        return this._cell;
    }
}
class $517dee46856d349e$var$Cell extends $517dee46856d349e$var$CoreFeature {
    constructor(column, row){
        super(column.table);
        this.table = column.table;
        this.column = column;
        this.row = row;
        this.element = null;
        this.value = null;
        this.initialValue;
        this.oldValue = null;
        this.modules = {};
        this.height = null;
        this.width = null;
        this.minWidth = null;
        this.component = null;
        this.loaded = false; //track if the cell has been added to the DOM yet
        this.build();
    }
    //////////////// Setup Functions /////////////////
    //generate element
    build() {
        this.generateElement();
        this.setWidth();
        this._configureCell();
        this.setValueActual(this.column.getFieldValue(this.row.data));
        this.initialValue = this.value;
    }
    generateElement() {
        this.element = document.createElement('div');
        this.element.className = "tabulator-cell";
        this.element.setAttribute("role", "gridcell");
        if (this.column.isRowHeader) this.element.classList.add("tabulator-row-header");
    }
    _configureCell() {
        var element = this.element, field = this.column.getField(), vertAligns = {
            top: "flex-start",
            bottom: "flex-end",
            middle: "center"
        }, hozAligns = {
            left: "flex-start",
            right: "flex-end",
            center: "center"
        };
        //set text alignment
        element.style.textAlign = this.column.hozAlign;
        if (this.column.vertAlign) {
            element.style.display = "inline-flex";
            element.style.alignItems = vertAligns[this.column.vertAlign] || "";
            if (this.column.hozAlign) element.style.justifyContent = hozAligns[this.column.hozAlign] || "";
        }
        if (field) element.setAttribute("tabulator-field", field);
        //add class to cell if needed
        if (this.column.definition.cssClass) {
            var classNames = this.column.definition.cssClass.split(" ");
            classNames.forEach((className)=>{
                element.classList.add(className);
            });
        }
        this.dispatch("cell-init", this);
        //hide cell if not visible
        if (!this.column.visible) this.hide();
    }
    //generate cell contents
    _generateContents() {
        var val;
        val = this.chain("cell-format", this, null, ()=>{
            return this.element.innerHTML = this.value;
        });
        switch(typeof val){
            case "object":
                if (val instanceof Node) {
                    //clear previous cell contents
                    while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
                    this.element.appendChild(val);
                } else {
                    this.element.innerHTML = "";
                    if (val != null) console.warn("Format Error - Formatter has returned a type of object, the only valid formatter object return is an instance of Node, the formatter returned:", val);
                }
                break;
            case "undefined":
                this.element.innerHTML = "";
                break;
            default:
                this.element.innerHTML = val;
        }
    }
    cellRendered() {
        this.dispatch("cell-rendered", this);
    }
    //////////////////// Getters ////////////////////
    getElement(containerOnly) {
        if (!this.loaded) {
            this.loaded = true;
            if (!containerOnly) this.layoutElement();
        }
        return this.element;
    }
    getValue() {
        return this.value;
    }
    getOldValue() {
        return this.oldValue;
    }
    //////////////////// Actions ////////////////////
    setValue(value, mutate, force) {
        var changed = this.setValueProcessData(value, mutate, force);
        if (changed) {
            this.dispatch("cell-value-updated", this);
            this.cellRendered();
            if (this.column.definition.cellEdited) this.column.definition.cellEdited.call(this.table, this.getComponent());
            this.dispatchExternal("cellEdited", this.getComponent());
            if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.table.rowManager.getData());
        }
    }
    setValueProcessData(value, mutate, force) {
        var changed = false;
        if (this.value !== value || force) {
            changed = true;
            if (mutate) value = this.chain("cell-value-changing", [
                this,
                value
            ], null, value);
        }
        this.setValueActual(value);
        if (changed) this.dispatch("cell-value-changed", this);
        return changed;
    }
    setValueActual(value) {
        this.oldValue = this.value;
        this.value = value;
        this.dispatch("cell-value-save-before", this);
        this.column.setFieldValue(this.row.data, value);
        this.dispatch("cell-value-save-after", this);
        if (this.loaded) this.layoutElement();
    }
    layoutElement() {
        this._generateContents();
        this.dispatch("cell-layout", this);
    }
    setWidth() {
        this.width = this.column.width;
        this.element.style.width = this.column.widthStyled;
    }
    clearWidth() {
        this.width = "";
        this.element.style.width = "";
    }
    getWidth() {
        return this.width || this.element.offsetWidth;
    }
    setMinWidth() {
        this.minWidth = this.column.minWidth;
        this.element.style.minWidth = this.column.minWidthStyled;
    }
    setMaxWidth() {
        this.maxWidth = this.column.maxWidth;
        this.element.style.maxWidth = this.column.maxWidthStyled;
    }
    checkHeight() {
        // var height = this.element.css("height");
        this.row.reinitializeHeight();
    }
    clearHeight() {
        this.element.style.height = "";
        this.height = null;
        this.dispatch("cell-height", this, "");
    }
    setHeight() {
        this.height = this.row.height;
        this.element.style.height = this.row.heightStyled;
        this.dispatch("cell-height", this, this.row.heightStyled);
    }
    getHeight() {
        return this.height || this.element.offsetHeight;
    }
    show() {
        this.element.style.display = this.column.vertAlign ? "inline-flex" : "";
    }
    hide() {
        this.element.style.display = "none";
    }
    delete() {
        this.dispatch("cell-delete", this);
        if (!this.table.rowManager.redrawBlock && this.element.parentNode) this.element.parentNode.removeChild(this.element);
        this.element = false;
        this.column.deleteCell(this);
        this.row.deleteCell(this);
        this.calcs = {};
    }
    getIndex() {
        return this.row.getCellIndex(this);
    }
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $517dee46856d349e$export$1919f52c249c72c9(this);
        return this.component;
    }
}
//public column object
class $517dee46856d349e$export$11bb209ad3a8e411 {
    constructor(column){
        this._column = column;
        this.type = "ColumnComponent";
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._column.table.componentFunctionBinder.handle("column", target._column, name);
            }
        });
    }
    getElement() {
        return this._column.getElement();
    }
    getDefinition() {
        return this._column.getDefinition();
    }
    getField() {
        return this._column.getField();
    }
    getTitleDownload() {
        return this._column.getTitleDownload();
    }
    getCells() {
        var cells = [];
        this._column.cells.forEach(function(cell) {
            cells.push(cell.getComponent());
        });
        return cells;
    }
    isVisible() {
        return this._column.visible;
    }
    show() {
        if (this._column.isGroup) this._column.columns.forEach(function(column) {
            column.show();
        });
        else this._column.show();
    }
    hide() {
        if (this._column.isGroup) this._column.columns.forEach(function(column) {
            column.hide();
        });
        else this._column.hide();
    }
    toggle() {
        if (this._column.visible) this.hide();
        else this.show();
    }
    delete() {
        return this._column.delete();
    }
    getSubColumns() {
        var output = [];
        if (this._column.columns.length) this._column.columns.forEach(function(column) {
            output.push(column.getComponent());
        });
        return output;
    }
    getParentColumn() {
        return this._column.getParentComponent();
    }
    _getSelf() {
        return this._column;
    }
    scrollTo(position, ifVisible) {
        return this._column.table.columnManager.scrollToColumn(this._column, position, ifVisible);
    }
    getTable() {
        return this._column.table;
    }
    move(to, after) {
        var toColumn = this._column.table.columnManager.findColumn(to);
        if (toColumn) this._column.table.columnManager.moveColumn(this._column, toColumn, after);
        else console.warn("Move Error - No matching column found:", toColumn);
    }
    getNextColumn() {
        var nextCol = this._column.nextColumn();
        return nextCol ? nextCol.getComponent() : false;
    }
    getPrevColumn() {
        var prevCol = this._column.prevColumn();
        return prevCol ? prevCol.getComponent() : false;
    }
    updateDefinition(updates) {
        return this._column.updateDefinition(updates);
    }
    getWidth() {
        return this._column.getWidth();
    }
    setWidth(width) {
        var result;
        if (width === true) result = this._column.reinitializeWidth(true);
        else result = this._column.setWidth(width);
        this._column.table.columnManager.rerenderColumns(true);
        return result;
    }
}
var $517dee46856d349e$var$defaultColumnOptions = {
    "title": undefined,
    "field": undefined,
    "columns": undefined,
    "visible": undefined,
    "hozAlign": undefined,
    "vertAlign": undefined,
    "width": undefined,
    "minWidth": 40,
    "maxWidth": undefined,
    "maxInitialWidth": undefined,
    "cssClass": undefined,
    "variableHeight": undefined,
    "headerVertical": undefined,
    "headerHozAlign": undefined,
    "headerWordWrap": false,
    "editableTitle": undefined
};
class $517dee46856d349e$var$Column extends $517dee46856d349e$var$CoreFeature {
    static defaultOptionList = $517dee46856d349e$var$defaultColumnOptions;
    constructor(def, parent, rowHeader){
        super(parent.table);
        this.definition = def; //column definition
        this.parent = parent; //hold parent object
        this.type = "column"; //type of element
        this.columns = []; //child columns
        this.cells = []; //cells bound to this column
        this.isGroup = false;
        this.isRowHeader = rowHeader;
        this.element = this.createElement(); //column header element
        this.contentElement = false;
        this.titleHolderElement = false;
        this.titleElement = false;
        this.groupElement = this.createGroupElement(); //column group holder element
        this.hozAlign = ""; //horizontal text alignment
        this.vertAlign = ""; //vert text alignment
        //multi dimensional filed handling
        this.field = "";
        this.fieldStructure = "";
        this.getFieldValue = "";
        this.setFieldValue = "";
        this.titleDownload = null;
        this.titleFormatterRendered = false;
        this.mapDefinitions();
        this.setField(this.definition.field);
        this.modules = {}; //hold module variables;
        this.width = null; //column width
        this.widthStyled = ""; //column width pre-styled to improve render efficiency
        this.maxWidth = null; //column maximum width
        this.maxWidthStyled = ""; //column maximum pre-styled to improve render efficiency
        this.maxInitialWidth = null;
        this.minWidth = null; //column minimum width
        this.minWidthStyled = ""; //column minimum pre-styled to improve render efficiency
        this.widthFixed = false; //user has specified a width for this column
        this.visible = true; //default visible state
        this.component = null;
        //initialize column
        if (this.definition.columns) {
            this.isGroup = true;
            this.definition.columns.forEach((def, i)=>{
                var newCol = new $517dee46856d349e$var$Column(def, this);
                this.attachColumn(newCol);
            });
            this.checkColumnVisibility();
        } else parent.registerColumnField(this);
        this._initialize();
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-col");
        el.setAttribute("role", "columnheader");
        el.setAttribute("aria-sort", "none");
        if (this.isRowHeader) el.classList.add("tabulator-row-header");
        switch(this.table.options.columnHeaderVertAlign){
            case "middle":
                el.style.justifyContent = "center";
                break;
            case "bottom":
                el.style.justifyContent = "flex-end";
                break;
        }
        return el;
    }
    createGroupElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-col-group-cols");
        return el;
    }
    mapDefinitions() {
        var defaults = this.table.options.columnDefaults;
        //map columnDefaults onto column definitions
        if (defaults) {
            for(let key in defaults)if (typeof this.definition[key] === "undefined") this.definition[key] = defaults[key];
        }
        this.definition = this.table.columnManager.optionsList.generate($517dee46856d349e$var$Column.defaultOptionList, this.definition);
    }
    checkDefinition() {
        Object.keys(this.definition).forEach((key)=>{
            if ($517dee46856d349e$var$Column.defaultOptionList.indexOf(key) === -1) console.warn("Invalid column definition option in '" + (this.field || this.definition.title) + "' column:", key);
        });
    }
    setField(field) {
        this.field = field;
        this.fieldStructure = field ? this.table.options.nestedFieldSeparator ? field.split(this.table.options.nestedFieldSeparator) : [
            field
        ] : [];
        this.getFieldValue = this.fieldStructure.length > 1 ? this._getNestedData : this._getFlatData;
        this.setFieldValue = this.fieldStructure.length > 1 ? this._setNestedData : this._setFlatData;
    }
    //register column position with column manager
    registerColumnPosition(column) {
        this.parent.registerColumnPosition(column);
    }
    //register column position with column manager
    registerColumnField(column) {
        this.parent.registerColumnField(column);
    }
    //trigger position registration
    reRegisterPosition() {
        if (this.isGroup) this.columns.forEach(function(column) {
            column.reRegisterPosition();
        });
        else this.registerColumnPosition(this);
    }
    //build header element
    _initialize() {
        var def = this.definition;
        while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
        if (def.headerVertical) {
            this.element.classList.add("tabulator-col-vertical");
            if (def.headerVertical === "flip") this.element.classList.add("tabulator-col-vertical-flip");
        }
        this.contentElement = this._buildColumnHeaderContent();
        this.element.appendChild(this.contentElement);
        if (this.isGroup) this._buildGroupHeader();
        else this._buildColumnHeader();
        this.dispatch("column-init", this);
    }
    //build header element for header
    _buildColumnHeader() {
        var def = this.definition;
        this.dispatch("column-layout", this);
        //set column visibility
        if (typeof def.visible != "undefined") {
            if (def.visible) this.show(true);
            else this.hide(true);
        }
        //assign additional css classes to column header
        if (def.cssClass) {
            var classNames = def.cssClass.split(" ");
            classNames.forEach((className)=>{
                this.element.classList.add(className);
            });
        }
        if (def.field) this.element.setAttribute("tabulator-field", def.field);
        //set min width if present
        this.setMinWidth(parseInt(def.minWidth));
        if (def.maxInitialWidth) this.maxInitialWidth = parseInt(def.maxInitialWidth);
        if (def.maxWidth) this.setMaxWidth(parseInt(def.maxWidth));
        this.reinitializeWidth();
        //set horizontal text alignment
        this.hozAlign = this.definition.hozAlign;
        this.vertAlign = this.definition.vertAlign;
        this.titleElement.style.textAlign = this.definition.headerHozAlign;
    }
    _buildColumnHeaderContent() {
        var contentElement = document.createElement("div");
        contentElement.classList.add("tabulator-col-content");
        this.titleHolderElement = document.createElement("div");
        this.titleHolderElement.classList.add("tabulator-col-title-holder");
        contentElement.appendChild(this.titleHolderElement);
        this.titleElement = this._buildColumnHeaderTitle();
        this.titleHolderElement.appendChild(this.titleElement);
        return contentElement;
    }
    //build title element of column
    _buildColumnHeaderTitle() {
        var def = this.definition;
        var titleHolderElement = document.createElement("div");
        titleHolderElement.classList.add("tabulator-col-title");
        if (def.headerWordWrap) titleHolderElement.classList.add("tabulator-col-title-wrap");
        if (def.editableTitle) {
            var titleElement = document.createElement("input");
            titleElement.classList.add("tabulator-title-editor");
            titleElement.addEventListener("click", (e)=>{
                e.stopPropagation();
                titleElement.focus();
            });
            titleElement.addEventListener("mousedown", (e)=>{
                e.stopPropagation();
            });
            titleElement.addEventListener("change", ()=>{
                def.title = titleElement.value;
                this.dispatchExternal("columnTitleChanged", this.getComponent());
            });
            titleHolderElement.appendChild(titleElement);
            if (def.field) this.langBind("columns|" + def.field, (text)=>{
                titleElement.value = text || def.title || "&nbsp;";
            });
            else titleElement.value = def.title || "&nbsp;";
        } else if (def.field) this.langBind("columns|" + def.field, (text)=>{
            this._formatColumnHeaderTitle(titleHolderElement, text || def.title || "&nbsp;");
        });
        else this._formatColumnHeaderTitle(titleHolderElement, def.title || "&nbsp;");
        return titleHolderElement;
    }
    _formatColumnHeaderTitle(el, title) {
        var contents = this.chain("column-format", [
            this,
            title,
            el
        ], null, ()=>{
            return title;
        });
        switch(typeof contents){
            case "object":
                if (contents instanceof Node) el.appendChild(contents);
                else {
                    el.innerHTML = "";
                    console.warn("Format Error - Title formatter has returned a type of object, the only valid formatter object return is an instance of Node, the formatter returned:", contents);
                }
                break;
            case "undefined":
                el.innerHTML = "";
                break;
            default:
                el.innerHTML = contents;
        }
    }
    //build header element for column group
    _buildGroupHeader() {
        this.element.classList.add("tabulator-col-group");
        this.element.setAttribute("role", "columngroup");
        this.element.setAttribute("aria-title", this.definition.title);
        //asign additional css classes to column header
        if (this.definition.cssClass) {
            var classNames = this.definition.cssClass.split(" ");
            classNames.forEach((className)=>{
                this.element.classList.add(className);
            });
        }
        this.titleElement.style.textAlign = this.definition.headerHozAlign;
        this.element.appendChild(this.groupElement);
    }
    //flat field lookup
    _getFlatData(data) {
        return data[this.field];
    }
    //nested field lookup
    _getNestedData(data) {
        var dataObj = data, structure = this.fieldStructure, length = structure.length, output;
        for(let i = 0; i < length; i++){
            dataObj = dataObj[structure[i]];
            output = dataObj;
            if (!dataObj) break;
        }
        return output;
    }
    //flat field set
    _setFlatData(data, value) {
        if (this.field) data[this.field] = value;
    }
    //nested field set
    _setNestedData(data, value) {
        var dataObj = data, structure = this.fieldStructure, length = structure.length;
        for(let i = 0; i < length; i++)if (i == length - 1) dataObj[structure[i]] = value;
        else {
            if (!dataObj[structure[i]]) {
                if (typeof value !== "undefined") dataObj[structure[i]] = {};
                else break;
            }
            dataObj = dataObj[structure[i]];
        }
    }
    //attach column to this group
    attachColumn(column) {
        if (this.groupElement) {
            this.columns.push(column);
            this.groupElement.appendChild(column.getElement());
            column.columnRendered();
        } else console.warn("Column Warning - Column being attached to another column instead of column group");
    }
    //vertically align header in column
    verticalAlign(alignment, height) {
        //calculate height of column header and group holder element
        var parentHeight = this.parent.isGroup ? this.parent.getGroupElement().clientHeight : height || this.parent.getHeadersElement().clientHeight;
        // var parentHeight = this.parent.isGroup ? this.parent.getGroupElement().clientHeight : this.parent.getHeadersElement().clientHeight;
        this.element.style.height = parentHeight + "px";
        this.dispatch("column-height", this, this.element.style.height);
        if (this.isGroup) this.groupElement.style.minHeight = parentHeight - this.contentElement.offsetHeight + "px";
        //vertically align cell contents
        // if(!this.isGroup && alignment !== "top"){
        // 	if(alignment === "bottom"){
        // 		this.element.style.paddingTop = (this.element.clientHeight - this.contentElement.offsetHeight) + "px";
        // 	}else{
        // 		this.element.style.paddingTop = ((this.element.clientHeight - this.contentElement.offsetHeight) / 2) + "px";
        // 	}
        // }
        this.columns.forEach(function(column) {
            column.verticalAlign(alignment);
        });
    }
    //clear vertical alignment
    clearVerticalAlign() {
        this.element.style.paddingTop = "";
        this.element.style.height = "";
        this.element.style.minHeight = "";
        this.groupElement.style.minHeight = "";
        this.columns.forEach(function(column) {
            column.clearVerticalAlign();
        });
        this.dispatch("column-height", this, "");
    }
    //// Retrieve Column Information ////
    //return column header element
    getElement() {
        return this.element;
    }
    //return column group element
    getGroupElement() {
        return this.groupElement;
    }
    //return field name
    getField() {
        return this.field;
    }
    getTitleDownload() {
        return this.titleDownload;
    }
    //return the first column in a group
    getFirstColumn() {
        if (!this.isGroup) return this;
        else {
            if (this.columns.length) return this.columns[0].getFirstColumn();
            else return false;
        }
    }
    //return the last column in a group
    getLastColumn() {
        if (!this.isGroup) return this;
        else {
            if (this.columns.length) return this.columns[this.columns.length - 1].getLastColumn();
            else return false;
        }
    }
    //return all columns in a group
    getColumns(traverse) {
        var columns = [];
        if (traverse) this.columns.forEach((column)=>{
            columns.push(column);
            columns = columns.concat(column.getColumns(true));
        });
        else columns = this.columns;
        return columns;
    }
    //return all columns in a group
    getCells() {
        return this.cells;
    }
    //retrieve the top column in a group of columns
    getTopColumn() {
        if (this.parent.isGroup) return this.parent.getTopColumn();
        else return this;
    }
    //return column definition object
    getDefinition(updateBranches) {
        var colDefs = [];
        if (this.isGroup && updateBranches) {
            this.columns.forEach(function(column) {
                colDefs.push(column.getDefinition(true));
            });
            this.definition.columns = colDefs;
        }
        return this.definition;
    }
    //////////////////// Actions ////////////////////
    checkColumnVisibility() {
        var visible = false;
        this.columns.forEach(function(column) {
            if (column.visible) visible = true;
        });
        if (visible) {
            this.show();
            this.dispatchExternal("columnVisibilityChanged", this.getComponent(), false);
        } else this.hide();
    }
    //show column
    show(silent, responsiveToggle) {
        if (!this.visible) {
            this.visible = true;
            this.element.style.display = "";
            if (this.parent.isGroup) this.parent.checkColumnVisibility();
            this.cells.forEach(function(cell) {
                cell.show();
            });
            if (!this.isGroup && this.width === null) this.reinitializeWidth();
            this.table.columnManager.verticalAlignHeaders();
            this.dispatch("column-show", this, responsiveToggle);
            if (!silent) this.dispatchExternal("columnVisibilityChanged", this.getComponent(), true);
            if (this.parent.isGroup) this.parent.matchChildWidths();
            if (!this.silent) this.table.columnManager.rerenderColumns();
        }
    }
    //hide column
    hide(silent, responsiveToggle) {
        if (this.visible) {
            this.visible = false;
            this.element.style.display = "none";
            this.table.columnManager.verticalAlignHeaders();
            if (this.parent.isGroup) this.parent.checkColumnVisibility();
            this.cells.forEach(function(cell) {
                cell.hide();
            });
            this.dispatch("column-hide", this, responsiveToggle);
            if (!silent) this.dispatchExternal("columnVisibilityChanged", this.getComponent(), false);
            if (this.parent.isGroup) this.parent.matchChildWidths();
            if (!this.silent) this.table.columnManager.rerenderColumns();
        }
    }
    matchChildWidths() {
        var childWidth = 0;
        if (this.contentElement && this.columns.length) {
            this.columns.forEach(function(column) {
                if (column.visible) childWidth += column.getWidth();
            });
            this.contentElement.style.maxWidth = childWidth - 1 + "px";
            if (this.table.initialized) this.element.style.width = childWidth + "px";
            if (this.parent.isGroup) this.parent.matchChildWidths();
        }
    }
    removeChild(child) {
        var index = this.columns.indexOf(child);
        if (index > -1) this.columns.splice(index, 1);
        if (!this.columns.length) this.delete();
    }
    setWidth(width) {
        this.widthFixed = true;
        this.setWidthActual(width);
    }
    setWidthActual(width) {
        if (isNaN(width)) width = Math.floor(this.table.element.clientWidth / 100 * parseInt(width));
        width = Math.max(this.minWidth, width);
        if (this.maxWidth) width = Math.min(this.maxWidth, width);
        this.width = width;
        this.widthStyled = width ? width + "px" : "";
        this.element.style.width = this.widthStyled;
        if (!this.isGroup) this.cells.forEach(function(cell) {
            cell.setWidth();
        });
        if (this.parent.isGroup) this.parent.matchChildWidths();
        this.dispatch("column-width", this);
        if (this.subscribedExternal("columnWidth")) this.dispatchExternal("columnWidth", this.getComponent());
    }
    checkCellHeights() {
        var rows = [];
        this.cells.forEach(function(cell) {
            if (cell.row.heightInitialized) {
                if (cell.row.getElement().offsetParent !== null) {
                    rows.push(cell.row);
                    cell.row.clearCellHeight();
                } else cell.row.heightInitialized = false;
            }
        });
        rows.forEach(function(row) {
            row.calcHeight();
        });
        rows.forEach(function(row) {
            row.setCellHeight();
        });
    }
    getWidth() {
        var width = 0;
        if (this.isGroup) this.columns.forEach(function(column) {
            if (column.visible) width += column.getWidth();
        });
        else width = this.width;
        return width;
    }
    getLeftOffset() {
        var offset = this.element.offsetLeft;
        if (this.parent.isGroup) offset += this.parent.getLeftOffset();
        return offset;
    }
    getHeight() {
        return Math.ceil(this.element.getBoundingClientRect().height);
    }
    setMinWidth(minWidth) {
        if (this.maxWidth && minWidth > this.maxWidth) {
            minWidth = this.maxWidth;
            console.warn("the minWidth (" + minWidth + "px) for column '" + this.field + "' cannot be bigger that its maxWidth (" + this.maxWidthStyled + ")");
        }
        this.minWidth = minWidth;
        this.minWidthStyled = minWidth ? minWidth + "px" : "";
        this.element.style.minWidth = this.minWidthStyled;
        this.cells.forEach(function(cell) {
            cell.setMinWidth();
        });
    }
    setMaxWidth(maxWidth) {
        if (this.minWidth && maxWidth < this.minWidth) {
            maxWidth = this.minWidth;
            console.warn("the maxWidth (" + maxWidth + "px) for column '" + this.field + "' cannot be smaller that its minWidth (" + this.minWidthStyled + ")");
        }
        this.maxWidth = maxWidth;
        this.maxWidthStyled = maxWidth ? maxWidth + "px" : "";
        this.element.style.maxWidth = this.maxWidthStyled;
        this.cells.forEach(function(cell) {
            cell.setMaxWidth();
        });
    }
    delete() {
        return new Promise((resolve, reject)=>{
            if (this.isGroup) this.columns.forEach(function(column) {
                column.delete();
            });
            this.dispatch("column-delete", this);
            var cellCount = this.cells.length;
            for(let i = 0; i < cellCount; i++)this.cells[0].delete();
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
            this.element = false;
            this.contentElement = false;
            this.titleElement = false;
            this.groupElement = false;
            if (this.parent.isGroup) this.parent.removeChild(this);
            this.table.columnManager.deregisterColumn(this);
            this.table.columnManager.rerenderColumns(true);
            this.dispatch("column-deleted", this);
            resolve();
        });
    }
    columnRendered() {
        if (this.titleFormatterRendered) this.titleFormatterRendered();
        this.dispatch("column-rendered", this);
    }
    //////////////// Cell Management /////////////////
    //generate cell for this column
    generateCell(row) {
        var cell = new $517dee46856d349e$var$Cell(this, row);
        this.cells.push(cell);
        return cell;
    }
    nextColumn() {
        var index = this.table.columnManager.findColumnIndex(this);
        return index > -1 ? this._nextVisibleColumn(index + 1) : false;
    }
    _nextVisibleColumn(index) {
        var column = this.table.columnManager.getColumnByIndex(index);
        return !column || column.visible ? column : this._nextVisibleColumn(index + 1);
    }
    prevColumn() {
        var index = this.table.columnManager.findColumnIndex(this);
        return index > -1 ? this._prevVisibleColumn(index - 1) : false;
    }
    _prevVisibleColumn(index) {
        var column = this.table.columnManager.getColumnByIndex(index);
        return !column || column.visible ? column : this._prevVisibleColumn(index - 1);
    }
    reinitializeWidth(force) {
        this.widthFixed = false;
        //set width if present
        if (typeof this.definition.width !== "undefined" && !force) // maxInitialWidth ignored here as width specified
        this.setWidth(this.definition.width);
        this.dispatch("column-width-fit-before", this);
        this.fitToData(force);
        this.dispatch("column-width-fit-after", this);
    }
    //set column width to maximum cell width for non group columns
    fitToData(force) {
        if (this.isGroup) return;
        if (!this.widthFixed) {
            this.element.style.width = "";
            this.cells.forEach((cell)=>{
                cell.clearWidth();
            });
        }
        var maxWidth = this.element.offsetWidth;
        if (!this.width || !this.widthFixed) {
            this.cells.forEach((cell)=>{
                var width = cell.getWidth();
                if (width > maxWidth) maxWidth = width;
            });
            if (maxWidth) {
                var setTo = maxWidth + 1;
                if (force) this.setWidth(setTo);
                else {
                    if (this.maxInitialWidth && !force) setTo = Math.min(setTo, this.maxInitialWidth);
                    this.setWidthActual(setTo);
                }
            }
        }
    }
    updateDefinition(updates) {
        var definition;
        if (!this.isGroup) {
            if (!this.parent.isGroup) {
                definition = Object.assign({}, this.getDefinition());
                definition = Object.assign(definition, updates);
                return this.table.columnManager.addColumn(definition, false, this).then((column)=>{
                    if (definition.field == this.field) this.field = false; //clear field name to prevent deletion of duplicate column from arrays
                    return this.delete().then(()=>{
                        return column.getComponent();
                    });
                });
            } else {
                console.error("Column Update Error - The updateDefinition function is only available on ungrouped columns");
                return Promise.reject("Column Update Error - The updateDefinition function is only available on columns, not column groups");
            }
        } else {
            console.error("Column Update Error - The updateDefinition function is only available on ungrouped columns");
            return Promise.reject("Column Update Error - The updateDefinition function is only available on columns, not column groups");
        }
    }
    deleteCell(cell) {
        var index = this.cells.indexOf(cell);
        if (index > -1) this.cells.splice(index, 1);
    }
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $517dee46856d349e$export$11bb209ad3a8e411(this);
        return this.component;
    }
    getPosition() {
        return this.table.columnManager.getVisibleColumnsByIndex().indexOf(this) + 1;
    }
    getParentComponent() {
        return this.parent instanceof $517dee46856d349e$var$Column ? this.parent.getComponent() : false;
    }
}
//public row object
class $517dee46856d349e$export$5df91075f5ba4651 {
    constructor(row){
        this._row = row;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._row.table.componentFunctionBinder.handle("row", target._row, name);
            }
        });
    }
    getData(transform) {
        return this._row.getData(transform);
    }
    getElement() {
        return this._row.getElement();
    }
    getCells() {
        var cells = [];
        this._row.getCells().forEach(function(cell) {
            cells.push(cell.getComponent());
        });
        return cells;
    }
    getCell(column) {
        var cell = this._row.getCell(column);
        return cell ? cell.getComponent() : false;
    }
    getIndex() {
        return this._row.getData("data")[this._row.table.options.index];
    }
    getPosition() {
        return this._row.getPosition();
    }
    watchPosition(callback) {
        return this._row.watchPosition(callback);
    }
    delete() {
        return this._row.delete();
    }
    scrollTo(position, ifVisible) {
        return this._row.table.rowManager.scrollToRow(this._row, position, ifVisible);
    }
    move(to, after) {
        this._row.moveToRow(to, after);
    }
    update(data) {
        return this._row.updateData(data);
    }
    normalizeHeight() {
        this._row.normalizeHeight(true);
    }
    _getSelf() {
        return this._row;
    }
    reformat() {
        return this._row.reinitialize();
    }
    getTable() {
        return this._row.table;
    }
    getNextRow() {
        var row = this._row.nextRow();
        return row ? row.getComponent() : row;
    }
    getPrevRow() {
        var row = this._row.prevRow();
        return row ? row.getComponent() : row;
    }
}
class $517dee46856d349e$var$Row extends $517dee46856d349e$var$CoreFeature {
    constructor(data, parent, type = "row"){
        super(parent.table);
        this.parent = parent;
        this.data = {};
        this.type = type; //type of element
        this.element = false;
        this.modules = {}; //hold module variables;
        this.cells = [];
        this.height = 0; //hold element height
        this.heightStyled = ""; //hold element height pre-styled to improve render efficiency
        this.manualHeight = false; //user has manually set row height
        this.outerHeight = 0; //hold elements outer height
        this.initialized = false; //element has been rendered
        this.heightInitialized = false; //element has resized cells to fit
        this.position = 0; //store position of element in row list
        this.positionWatchers = [];
        this.component = null;
        this.created = false;
        this.setData(data);
    }
    create() {
        if (!this.created) {
            this.created = true;
            this.generateElement();
        }
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-row");
        el.setAttribute("role", "row");
        this.element = el;
    }
    getElement() {
        this.create();
        return this.element;
    }
    detachElement() {
        if (this.element && this.element.parentNode) this.element.parentNode.removeChild(this.element);
    }
    generateElement() {
        this.createElement();
        this.dispatch("row-init", this);
    }
    generateCells() {
        this.cells = this.table.columnManager.generateCells(this);
    }
    //functions to setup on first render
    initialize(force, inFragment) {
        this.create();
        if (!this.initialized || force) {
            this.deleteCells();
            while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
            this.dispatch("row-layout-before", this);
            this.generateCells();
            this.initialized = true;
            this.table.columnManager.renderer.renderRowCells(this, inFragment);
            if (force) this.normalizeHeight();
            this.dispatch("row-layout", this);
            if (this.table.options.rowFormatter) this.table.options.rowFormatter(this.getComponent());
            this.dispatch("row-layout-after", this);
        } else this.table.columnManager.renderer.rerenderRowCells(this, inFragment);
    }
    rendered() {
        this.cells.forEach((cell)=>{
            cell.cellRendered();
        });
    }
    reinitializeHeight() {
        this.heightInitialized = false;
        if (this.element && this.element.offsetParent !== null) this.normalizeHeight(true);
    }
    deinitialize() {
        this.initialized = false;
    }
    deinitializeHeight() {
        this.heightInitialized = false;
    }
    reinitialize(children) {
        this.initialized = false;
        this.heightInitialized = false;
        if (!this.manualHeight) {
            this.height = 0;
            this.heightStyled = "";
        }
        if (this.element && this.element.offsetParent !== null) this.initialize(true);
        this.dispatch("row-relayout", this);
    }
    //get heights when doing bulk row style calcs in virtual DOM
    calcHeight(force) {
        var maxHeight = 0, minHeight = 0;
        if (this.table.options.rowHeight) this.height = this.table.options.rowHeight;
        else {
            minHeight = this.calcMinHeight();
            maxHeight = this.calcMaxHeight();
            if (force) this.height = Math.max(maxHeight, minHeight);
            else this.height = this.manualHeight ? this.height : Math.max(maxHeight, minHeight);
        }
        this.heightStyled = this.height ? this.height + "px" : "";
        this.outerHeight = this.element.offsetHeight;
    }
    calcMinHeight() {
        return this.table.options.resizableRows ? this.element.clientHeight : 0;
    }
    calcMaxHeight() {
        var maxHeight = 0;
        this.cells.forEach(function(cell) {
            var height = cell.getHeight();
            if (height > maxHeight) maxHeight = height;
        });
        return maxHeight;
    }
    //set of cells
    setCellHeight() {
        this.cells.forEach(function(cell) {
            cell.setHeight();
        });
        this.heightInitialized = true;
    }
    clearCellHeight() {
        this.cells.forEach(function(cell) {
            cell.clearHeight();
        });
    }
    //normalize the height of elements in the row
    normalizeHeight(force) {
        if (force && !this.table.options.rowHeight) this.clearCellHeight();
        this.calcHeight(force);
        this.setCellHeight();
    }
    //set height of rows
    setHeight(height, force) {
        if (this.height != height || force) {
            this.manualHeight = true;
            this.height = height;
            this.heightStyled = height ? height + "px" : "";
            this.setCellHeight();
            // this.outerHeight = this.element.outerHeight();
            this.outerHeight = this.element.offsetHeight;
            if (this.subscribedExternal("rowHeight")) this.dispatchExternal("rowHeight", this.getComponent());
        }
    }
    //return rows outer height
    getHeight() {
        return this.outerHeight;
    }
    //return rows outer Width
    getWidth() {
        return this.element.offsetWidth;
    }
    //////////////// Cell Management /////////////////
    deleteCell(cell) {
        var index = this.cells.indexOf(cell);
        if (index > -1) this.cells.splice(index, 1);
    }
    //////////////// Data Management /////////////////
    setData(data) {
        this.data = this.chain("row-data-init-before", [
            this,
            data
        ], undefined, data);
        this.dispatch("row-data-init-after", this);
    }
    //update the rows data
    updateData(updatedData) {
        var visible = this.element && $517dee46856d349e$var$Helpers.elVisible(this.element), tempData = {}, newRowData;
        return new Promise((resolve, reject)=>{
            if (typeof updatedData === "string") updatedData = JSON.parse(updatedData);
            this.dispatch("row-data-save-before", this);
            if (this.subscribed("row-data-changing")) {
                tempData = Object.assign(tempData, this.data);
                tempData = Object.assign(tempData, updatedData);
            }
            newRowData = this.chain("row-data-changing", [
                this,
                tempData,
                updatedData
            ], null, updatedData);
            //set data
            for(let attrname in newRowData)this.data[attrname] = newRowData[attrname];
            this.dispatch("row-data-save-after", this);
            //update affected cells only
            for(let attrname in updatedData){
                let columns = this.table.columnManager.getColumnsByFieldRoot(attrname);
                columns.forEach((column)=>{
                    let cell = this.getCell(column.getField());
                    if (cell) {
                        let value = column.getFieldValue(newRowData);
                        if (cell.getValue() !== value) {
                            cell.setValueProcessData(value);
                            if (visible) cell.cellRendered();
                        }
                    }
                });
            }
            //Partial reinitialization if visible
            if (visible) {
                this.normalizeHeight(true);
                if (this.table.options.rowFormatter) this.table.options.rowFormatter(this.getComponent());
            } else {
                this.initialized = false;
                this.height = 0;
                this.heightStyled = "";
            }
            this.dispatch("row-data-changed", this, visible, updatedData);
            //this.reinitialize();
            this.dispatchExternal("rowUpdated", this.getComponent());
            if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.table.rowManager.getData());
            resolve();
        });
    }
    getData(transform) {
        if (transform) return this.chain("row-data-retrieve", [
            this,
            transform
        ], null, this.data);
        return this.data;
    }
    getCell(column) {
        var match = false;
        column = this.table.columnManager.findColumn(column);
        if (!this.initialized && this.cells.length === 0) this.generateCells();
        match = this.cells.find(function(cell) {
            return cell.column === column;
        });
        return match;
    }
    getCellIndex(findCell) {
        return this.cells.findIndex(function(cell) {
            return cell === findCell;
        });
    }
    findCell(subject) {
        return this.cells.find((cell)=>{
            return cell.element === subject;
        });
    }
    getCells() {
        if (!this.initialized && this.cells.length === 0) this.generateCells();
        return this.cells;
    }
    nextRow() {
        var row = this.table.rowManager.nextDisplayRow(this, true);
        return row || false;
    }
    prevRow() {
        var row = this.table.rowManager.prevDisplayRow(this, true);
        return row || false;
    }
    moveToRow(to, before) {
        var toRow = this.table.rowManager.findRow(to);
        if (toRow) {
            this.table.rowManager.moveRowActual(this, toRow, !before);
            this.table.rowManager.refreshActiveData("display", false, true);
        } else console.warn("Move Error - No matching row found:", to);
    }
    ///////////////////// Actions  /////////////////////
    delete() {
        this.dispatch("row-delete", this);
        this.deleteActual();
        return Promise.resolve();
    }
    deleteActual(blockRedraw) {
        this.detachModules();
        this.table.rowManager.deleteRow(this, blockRedraw);
        this.deleteCells();
        this.initialized = false;
        this.heightInitialized = false;
        this.element = false;
        this.dispatch("row-deleted", this);
    }
    detachModules() {
        this.dispatch("row-deleting", this);
    }
    deleteCells() {
        var cellCount = this.cells.length;
        for(let i = 0; i < cellCount; i++)this.cells[0].delete();
    }
    wipe() {
        this.detachModules();
        this.deleteCells();
        if (this.element) {
            while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
            if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        }
        this.element = false;
        this.modules = {};
    }
    isDisplayed() {
        return this.table.rowManager.getDisplayRows().includes(this);
    }
    getPosition() {
        return this.isDisplayed() ? this.position : false;
    }
    setPosition(position) {
        if (position != this.position) {
            this.position = position;
            this.positionWatchers.forEach((callback)=>{
                callback(this.position);
            });
        }
    }
    watchPosition(callback) {
        this.positionWatchers.push(callback);
        callback(this.position);
    }
    getGroup() {
        return this.modules.group || false;
    }
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $517dee46856d349e$export$5df91075f5ba4651(this);
        return this.component;
    }
}
var $517dee46856d349e$var$defaultCalculations = {
    "avg": function(values, data, calcParams) {
        var output = 0, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : 2;
        if (values.length) {
            output = values.reduce(function(sum, value) {
                return Number(sum) + Number(value);
            });
            output = output / values.length;
            output = precision !== false ? output.toFixed(precision) : output;
        }
        return parseFloat(output).toString();
    },
    "max": function(values, data, calcParams) {
        var output = null, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : false;
        values.forEach(function(value) {
            value = Number(value);
            if (value > output || output === null) output = value;
        });
        return output !== null ? precision !== false ? output.toFixed(precision) : output : "";
    },
    "min": function(values, data, calcParams) {
        var output = null, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : false;
        values.forEach(function(value) {
            value = Number(value);
            if (value < output || output === null) output = value;
        });
        return output !== null ? precision !== false ? output.toFixed(precision) : output : "";
    },
    "sum": function(values, data, calcParams) {
        var output = 0, precision = typeof calcParams.precision !== "undefined" ? calcParams.precision : false;
        if (values.length) values.forEach(function(value) {
            value = Number(value);
            output += !isNaN(value) ? Number(value) : 0;
        });
        return precision !== false ? output.toFixed(precision) : output;
    },
    "concat": function(values, data, calcParams) {
        var output = 0;
        if (values.length) output = values.reduce(function(sum, value) {
            return String(sum) + String(value);
        });
        return output;
    },
    "count": function(values, data, calcParams) {
        var output = 0;
        if (values.length) values.forEach(function(value) {
            if (value) output++;
        });
        return output;
    },
    "unique": function(values, data, calcParams) {
        var unique = values.filter((value, index)=>{
            return (values || value === 0) && values.indexOf(value) === index;
        });
        return unique.length;
    }
};
class $517dee46856d349e$export$840b3bc55b30dec6 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "columnCalcs";
    //load defaults
    static calculations = $517dee46856d349e$var$defaultCalculations;
    constructor(table){
        super(table);
        this.topCalcs = [];
        this.botCalcs = [];
        this.genColumn = false;
        this.topElement = this.createElement();
        this.botElement = this.createElement();
        this.topRow = false;
        this.botRow = false;
        this.topInitialized = false;
        this.botInitialized = false;
        this.blocked = false;
        this.recalcAfterBlock = false;
        this.registerTableOption("columnCalcs", true);
        this.registerColumnOption("topCalc");
        this.registerColumnOption("topCalcParams");
        this.registerColumnOption("topCalcFormatter");
        this.registerColumnOption("topCalcFormatterParams");
        this.registerColumnOption("bottomCalc");
        this.registerColumnOption("bottomCalcParams");
        this.registerColumnOption("bottomCalcFormatter");
        this.registerColumnOption("bottomCalcFormatterParams");
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-calcs-holder");
        return el;
    }
    initialize() {
        this.genColumn = new $517dee46856d349e$var$Column({
            field: "value"
        }, this);
        this.subscribe("cell-value-changed", this.cellValueChanged.bind(this));
        this.subscribe("column-init", this.initializeColumnCheck.bind(this));
        this.subscribe("row-deleted", this.rowsUpdated.bind(this));
        this.subscribe("scroll-horizontal", this.scrollHorizontal.bind(this));
        this.subscribe("row-added", this.rowsUpdated.bind(this));
        this.subscribe("column-moved", this.recalcActiveRows.bind(this));
        this.subscribe("column-add", this.recalcActiveRows.bind(this));
        this.subscribe("data-refreshed", this.recalcActiveRowsRefresh.bind(this));
        this.subscribe("table-redraw", this.tableRedraw.bind(this));
        this.subscribe("rows-visible", this.visibleRows.bind(this));
        this.subscribe("scrollbar-vertical", this.adjustForScrollbar.bind(this));
        this.subscribe("redraw-blocked", this.blockRedraw.bind(this));
        this.subscribe("redraw-restored", this.restoreRedraw.bind(this));
        this.subscribe("table-redrawing", this.resizeHolderWidth.bind(this));
        this.subscribe("column-resized", this.resizeHolderWidth.bind(this));
        this.subscribe("column-show", this.resizeHolderWidth.bind(this));
        this.subscribe("column-hide", this.resizeHolderWidth.bind(this));
        this.registerTableFunction("getCalcResults", this.getResults.bind(this));
        this.registerTableFunction("recalc", this.userRecalc.bind(this));
        this.resizeHolderWidth();
    }
    resizeHolderWidth() {
        this.topElement.style.minWidth = this.table.columnManager.headersElement.offsetWidth + "px";
    }
    tableRedraw(force) {
        this.recalc(this.table.rowManager.activeRows);
        if (force) this.redraw();
    }
    blockRedraw() {
        this.blocked = true;
        this.recalcAfterBlock = false;
    }
    restoreRedraw() {
        this.blocked = false;
        if (this.recalcAfterBlock) {
            this.recalcAfterBlock = false;
            this.recalcActiveRowsRefresh();
        }
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userRecalc() {
        this.recalc(this.table.rowManager.activeRows);
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    blockCheck() {
        if (this.blocked) this.recalcAfterBlock = true;
        return this.blocked;
    }
    visibleRows(viewable, rows) {
        if (this.topRow) rows.unshift(this.topRow);
        if (this.botRow) rows.push(this.botRow);
        return rows;
    }
    rowsUpdated(row) {
        if (this.table.options.groupBy) this.recalcRowGroup(row);
        else this.recalcActiveRows();
    }
    recalcActiveRowsRefresh() {
        if (this.table.options.groupBy && this.table.options.dataTreeStartExpanded && this.table.options.dataTree) this.recalcAll();
        else this.recalcActiveRows();
    }
    recalcActiveRows() {
        this.recalc(this.table.rowManager.activeRows);
    }
    cellValueChanged(cell) {
        if (cell.column.definition.topCalc || cell.column.definition.bottomCalc) {
            if (this.table.options.groupBy) {
                if (this.table.options.columnCalcs == "table" || this.table.options.columnCalcs == "both") this.recalcActiveRows();
                if (this.table.options.columnCalcs != "table") this.recalcRowGroup(cell.row);
            } else this.recalcActiveRows();
        }
    }
    initializeColumnCheck(column) {
        if (column.definition.topCalc || column.definition.bottomCalc) this.initializeColumn(column);
    }
    //initialize column calcs
    initializeColumn(column) {
        var def = column.definition;
        var config = {
            topCalcParams: def.topCalcParams || {},
            botCalcParams: def.bottomCalcParams || {}
        };
        if (def.topCalc) {
            switch(typeof def.topCalc){
                case "string":
                    if ($517dee46856d349e$export$840b3bc55b30dec6.calculations[def.topCalc]) config.topCalc = $517dee46856d349e$export$840b3bc55b30dec6.calculations[def.topCalc];
                    else console.warn("Column Calc Error - No such calculation found, ignoring: ", def.topCalc);
                    break;
                case "function":
                    config.topCalc = def.topCalc;
                    break;
            }
            if (config.topCalc) {
                column.modules.columnCalcs = config;
                this.topCalcs.push(column);
                if (this.table.options.columnCalcs != "group") this.initializeTopRow();
            }
        }
        if (def.bottomCalc) {
            switch(typeof def.bottomCalc){
                case "string":
                    if ($517dee46856d349e$export$840b3bc55b30dec6.calculations[def.bottomCalc]) config.botCalc = $517dee46856d349e$export$840b3bc55b30dec6.calculations[def.bottomCalc];
                    else console.warn("Column Calc Error - No such calculation found, ignoring: ", def.bottomCalc);
                    break;
                case "function":
                    config.botCalc = def.bottomCalc;
                    break;
            }
            if (config.botCalc) {
                column.modules.columnCalcs = config;
                this.botCalcs.push(column);
                if (this.table.options.columnCalcs != "group") this.initializeBottomRow();
            }
        }
    }
    //dummy functions to handle being mock column manager
    registerColumnField() {}
    removeCalcs() {
        var changed = false;
        if (this.topInitialized) {
            this.topInitialized = false;
            this.topElement.parentNode.removeChild(this.topElement);
            changed = true;
        }
        if (this.botInitialized) {
            this.botInitialized = false;
            this.footerRemove(this.botElement);
            changed = true;
        }
        if (changed) this.table.rowManager.adjustTableSize();
    }
    reinitializeCalcs() {
        if (this.topCalcs.length) this.initializeTopRow();
        if (this.botCalcs.length) this.initializeBottomRow();
    }
    initializeTopRow() {
        var fragment = document.createDocumentFragment();
        if (!this.topInitialized) {
            fragment.appendChild(document.createElement("br"));
            fragment.appendChild(this.topElement);
            this.table.columnManager.getContentsElement().insertBefore(fragment, this.table.columnManager.headersElement.nextSibling);
            this.topInitialized = true;
        }
    }
    initializeBottomRow() {
        if (!this.botInitialized) {
            this.footerPrepend(this.botElement);
            this.botInitialized = true;
        }
    }
    scrollHorizontal(left) {
        if (this.botInitialized && this.botRow) this.botElement.scrollLeft = left;
    }
    recalc(rows) {
        var data, row;
        if (!this.blockCheck()) {
            if (this.topInitialized || this.botInitialized) {
                data = this.rowsToData(rows);
                if (this.topInitialized) {
                    if (this.topRow) this.topRow.deleteCells();
                    row = this.generateRow("top", data);
                    this.topRow = row;
                    while(this.topElement.firstChild)this.topElement.removeChild(this.topElement.firstChild);
                    this.topElement.appendChild(row.getElement());
                    row.initialize(true);
                }
                if (this.botInitialized) {
                    if (this.botRow) this.botRow.deleteCells();
                    row = this.generateRow("bottom", data);
                    this.botRow = row;
                    while(this.botElement.firstChild)this.botElement.removeChild(this.botElement.firstChild);
                    this.botElement.appendChild(row.getElement());
                    row.initialize(true);
                }
                this.table.rowManager.adjustTableSize();
                //set resizable handles
                if (this.table.modExists("frozenColumns")) this.table.modules.frozenColumns.layout();
            }
        }
    }
    recalcRowGroup(row) {
        this.recalcGroup(this.table.modules.groupRows.getRowGroup(row));
    }
    recalcAll() {
        if (this.topCalcs.length || this.botCalcs.length) {
            if (this.table.options.columnCalcs !== "group") this.recalcActiveRows();
            if (this.table.options.groupBy && this.table.options.columnCalcs !== "table") {
                var groups = this.table.modules.groupRows.getChildGroups();
                groups.forEach((group)=>{
                    this.recalcGroup(group);
                });
            }
        }
    }
    recalcGroup(group) {
        var data, rowData;
        if (!this.blockCheck()) {
            if (group) {
                if (group.calcs) {
                    if (group.calcs.bottom) {
                        data = this.rowsToData(group.rows);
                        rowData = this.generateRowData("bottom", data);
                        group.calcs.bottom.updateData(rowData);
                        group.calcs.bottom.reinitialize();
                    }
                    if (group.calcs.top) {
                        data = this.rowsToData(group.rows);
                        rowData = this.generateRowData("top", data);
                        group.calcs.top.updateData(rowData);
                        group.calcs.top.reinitialize();
                    }
                }
            }
        }
    }
    //generate top stats row
    generateTopRow(rows) {
        return this.generateRow("top", this.rowsToData(rows));
    }
    //generate bottom stats row
    generateBottomRow(rows) {
        return this.generateRow("bottom", this.rowsToData(rows));
    }
    rowsToData(rows) {
        var data = [], hasDataTreeColumnCalcs = this.table.options.dataTree && this.table.options.dataTreeChildColumnCalcs, dataTree = this.table.modules.dataTree;
        rows.forEach((row)=>{
            data.push(row.getData());
            if (hasDataTreeColumnCalcs && row.modules.dataTree?.open) this.rowsToData(dataTree.getFilteredTreeChildren(row)).forEach((dataRow)=>{
                data.push(row);
            });
        });
        return data;
    }
    //generate stats row
    generateRow(pos, data) {
        var rowData = this.generateRowData(pos, data), row;
        if (this.table.modExists("mutator")) this.table.modules.mutator.disable();
        row = new $517dee46856d349e$var$Row(rowData, this, "calc");
        if (this.table.modExists("mutator")) this.table.modules.mutator.enable();
        row.getElement().classList.add("tabulator-calcs", "tabulator-calcs-" + pos);
        row.component = false;
        row.getComponent = ()=>{
            if (!row.component) row.component = new $517dee46856d349e$export$3ef2519bf7055551(row);
            return row.component;
        };
        row.generateCells = ()=>{
            var cells = [];
            this.table.columnManager.columnsByIndex.forEach((column)=>{
                //set field name of mock column
                this.genColumn.setField(column.getField());
                this.genColumn.hozAlign = column.hozAlign;
                if (column.definition[pos + "CalcFormatter"] && this.table.modExists("format")) this.genColumn.modules.format = {
                    formatter: this.table.modules.format.lookupFormatter(column.definition[pos + "CalcFormatter"]),
                    params: column.definition[pos + "CalcFormatterParams"] || {}
                };
                else this.genColumn.modules.format = {
                    formatter: this.table.modules.format.lookupFormatter("plaintext"),
                    params: {}
                };
                //ensure css class definition is replicated to calculation cell
                this.genColumn.definition.cssClass = column.definition.cssClass;
                //generate cell and assign to correct column
                var cell = new $517dee46856d349e$var$Cell(this.genColumn, row);
                cell.getElement();
                cell.column = column;
                cell.setWidth();
                column.cells.push(cell);
                cells.push(cell);
                if (!column.visible) cell.hide();
            });
            row.cells = cells;
        };
        return row;
    }
    //generate stats row
    generateRowData(pos, data) {
        var rowData = {}, calcs = pos == "top" ? this.topCalcs : this.botCalcs, type = pos == "top" ? "topCalc" : "botCalc", params, paramKey;
        calcs.forEach(function(column) {
            var values = [];
            if (column.modules.columnCalcs && column.modules.columnCalcs[type]) {
                data.forEach(function(item) {
                    values.push(column.getFieldValue(item));
                });
                paramKey = type + "Params";
                params = typeof column.modules.columnCalcs[paramKey] === "function" ? column.modules.columnCalcs[paramKey](values, data) : column.modules.columnCalcs[paramKey];
                column.setFieldValue(rowData, column.modules.columnCalcs[type](values, data, params));
            }
        });
        return rowData;
    }
    hasTopCalcs() {
        return !!this.topCalcs.length;
    }
    hasBottomCalcs() {
        return !!this.botCalcs.length;
    }
    //handle table redraw
    redraw() {
        if (this.topRow) this.topRow.normalizeHeight(true);
        if (this.botRow) this.botRow.normalizeHeight(true);
    }
    //return the calculated
    getResults() {
        var results = {}, groups;
        if (this.table.options.groupBy && this.table.modExists("groupRows")) {
            groups = this.table.modules.groupRows.getGroups(true);
            groups.forEach((group)=>{
                results[group.getKey()] = this.getGroupResults(group);
            });
        } else results = {
            top: this.topRow ? this.topRow.getData() : {},
            bottom: this.botRow ? this.botRow.getData() : {}
        };
        return results;
    }
    //get results from a group
    getGroupResults(group) {
        var groupObj = group._getSelf(), subGroups = group.getSubGroups(), subGroupResults = {}, results = {};
        subGroups.forEach((subgroup)=>{
            subGroupResults[subgroup.getKey()] = this.getGroupResults(subgroup);
        });
        results = {
            top: groupObj.calcs.top ? groupObj.calcs.top.getData() : {},
            bottom: groupObj.calcs.bottom ? groupObj.calcs.bottom.getData() : {},
            groups: subGroupResults
        };
        return results;
    }
    adjustForScrollbar(width) {
        if (this.botRow) {
            if (this.table.rtl) this.botElement.style.paddingLeft = width + "px";
            else this.botElement.style.paddingRight = width + "px";
        }
    }
}
class $517dee46856d349e$export$a5a9878f12569c04 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "dataTree";
    constructor(table){
        super(table);
        this.indent = 10;
        this.field = "";
        this.collapseEl = null;
        this.expandEl = null;
        this.branchEl = null;
        this.elementField = false;
        this.startOpen = function() {};
        this.registerTableOption("dataTree", false); //enable data tree
        this.registerTableOption("dataTreeFilter", true); //filter child rows
        this.registerTableOption("dataTreeSort", true); //sort child rows
        this.registerTableOption("dataTreeElementColumn", false);
        this.registerTableOption("dataTreeBranchElement", true); //show data tree branch element
        this.registerTableOption("dataTreeChildIndent", 9); //data tree child indent in px
        this.registerTableOption("dataTreeChildField", "_children"); //data tre column field to look for child rows
        this.registerTableOption("dataTreeCollapseElement", false); //data tree row collapse element
        this.registerTableOption("dataTreeExpandElement", false); //data tree row expand element
        this.registerTableOption("dataTreeStartExpanded", false);
        this.registerTableOption("dataTreeChildColumnCalcs", false); //include visible data tree rows in column calculations
        this.registerTableOption("dataTreeSelectPropagate", false); //selecting a parent row selects its children
        //register component functions
        this.registerComponentFunction("row", "treeCollapse", this.collapseRow.bind(this));
        this.registerComponentFunction("row", "treeExpand", this.expandRow.bind(this));
        this.registerComponentFunction("row", "treeToggle", this.toggleRow.bind(this));
        this.registerComponentFunction("row", "getTreeParent", this.getTreeParent.bind(this));
        this.registerComponentFunction("row", "getTreeChildren", this.getRowChildren.bind(this));
        this.registerComponentFunction("row", "addTreeChild", this.addTreeChildRow.bind(this));
        this.registerComponentFunction("row", "isTreeExpanded", this.isRowExpanded.bind(this));
    }
    initialize() {
        if (this.table.options.dataTree) {
            var dummyEl = null, options = this.table.options;
            this.field = options.dataTreeChildField;
            this.indent = options.dataTreeChildIndent;
            if (this.options("movableRows")) console.warn("The movableRows option is not available with dataTree enabled, moving of child rows could result in unpredictable behavior");
            if (options.dataTreeBranchElement) {
                if (options.dataTreeBranchElement === true) {
                    this.branchEl = document.createElement("div");
                    this.branchEl.classList.add("tabulator-data-tree-branch");
                } else if (typeof options.dataTreeBranchElement === "string") {
                    dummyEl = document.createElement("div");
                    dummyEl.innerHTML = options.dataTreeBranchElement;
                    this.branchEl = dummyEl.firstChild;
                } else this.branchEl = options.dataTreeBranchElement;
            } else {
                this.branchEl = document.createElement("div");
                this.branchEl.classList.add("tabulator-data-tree-branch-empty");
            }
            if (options.dataTreeCollapseElement) {
                if (typeof options.dataTreeCollapseElement === "string") {
                    dummyEl = document.createElement("div");
                    dummyEl.innerHTML = options.dataTreeCollapseElement;
                    this.collapseEl = dummyEl.firstChild;
                } else this.collapseEl = options.dataTreeCollapseElement;
            } else {
                this.collapseEl = document.createElement("div");
                this.collapseEl.classList.add("tabulator-data-tree-control");
                this.collapseEl.tabIndex = 0;
                this.collapseEl.innerHTML = "<div class='tabulator-data-tree-control-collapse'></div>";
            }
            if (options.dataTreeExpandElement) {
                if (typeof options.dataTreeExpandElement === "string") {
                    dummyEl = document.createElement("div");
                    dummyEl.innerHTML = options.dataTreeExpandElement;
                    this.expandEl = dummyEl.firstChild;
                } else this.expandEl = options.dataTreeExpandElement;
            } else {
                this.expandEl = document.createElement("div");
                this.expandEl.classList.add("tabulator-data-tree-control");
                this.expandEl.tabIndex = 0;
                this.expandEl.innerHTML = "<div class='tabulator-data-tree-control-expand'></div>";
            }
            switch(typeof options.dataTreeStartExpanded){
                case "boolean":
                    this.startOpen = function(row, index) {
                        return options.dataTreeStartExpanded;
                    };
                    break;
                case "function":
                    this.startOpen = options.dataTreeStartExpanded;
                    break;
                default:
                    this.startOpen = function(row, index) {
                        return options.dataTreeStartExpanded[index];
                    };
                    break;
            }
            this.subscribe("row-init", this.initializeRow.bind(this));
            this.subscribe("row-layout-after", this.layoutRow.bind(this));
            this.subscribe("row-deleting", this.rowDeleting.bind(this));
            this.subscribe("row-deleted", this.rowDelete.bind(this), 0);
            this.subscribe("row-data-changed", this.rowDataChanged.bind(this), 10);
            this.subscribe("cell-value-updated", this.cellValueChanged.bind(this));
            this.subscribe("edit-cancelled", this.cellValueChanged.bind(this));
            this.subscribe("column-moving-rows", this.columnMoving.bind(this));
            this.subscribe("table-built", this.initializeElementField.bind(this));
            this.subscribe("table-redrawing", this.tableRedrawing.bind(this));
            this.registerDisplayHandler(this.getRows.bind(this), 30);
        }
    }
    tableRedrawing(force) {
        var rows;
        if (force) {
            rows = this.table.rowManager.getRows();
            rows.forEach((row)=>{
                this.reinitializeRowChildren(row);
            });
        }
    }
    initializeElementField() {
        var firstCol = this.table.columnManager.getFirstVisibleColumn();
        this.elementField = this.table.options.dataTreeElementColumn || (firstCol ? firstCol.field : false);
    }
    getRowChildren(row) {
        return this.getTreeChildren(row, true);
    }
    columnMoving() {
        var rows = [];
        this.table.rowManager.rows.forEach((row)=>{
            rows = rows.concat(this.getTreeChildren(row, false, true));
        });
        return rows;
    }
    rowDataChanged(row, visible, updatedData) {
        if (this.redrawNeeded(updatedData)) {
            this.initializeRow(row);
            if (visible) {
                this.layoutRow(row);
                this.refreshData(true);
            }
        }
    }
    cellValueChanged(cell) {
        var field = cell.column.getField();
        if (field === this.elementField) this.layoutRow(cell.row);
    }
    initializeRow(row) {
        var childArray = row.getData()[this.field];
        var isArray = Array.isArray(childArray);
        var children = isArray || !isArray && typeof childArray === "object" && childArray !== null;
        if (!children && row.modules.dataTree && row.modules.dataTree.branchEl) row.modules.dataTree.branchEl.parentNode.removeChild(row.modules.dataTree.branchEl);
        if (!children && row.modules.dataTree && row.modules.dataTree.controlEl) row.modules.dataTree.controlEl.parentNode.removeChild(row.modules.dataTree.controlEl);
        row.modules.dataTree = {
            index: row.modules.dataTree ? row.modules.dataTree.index : 0,
            open: children ? row.modules.dataTree ? row.modules.dataTree.open : this.startOpen(row.getComponent(), 0) : false,
            controlEl: row.modules.dataTree && children ? row.modules.dataTree.controlEl : false,
            branchEl: row.modules.dataTree && children ? row.modules.dataTree.branchEl : false,
            parent: row.modules.dataTree ? row.modules.dataTree.parent : false,
            children: children
        };
    }
    reinitializeRowChildren(row) {
        var children = this.getTreeChildren(row, false, true);
        children.forEach(function(child) {
            child.reinitialize(true);
        });
    }
    layoutRow(row) {
        var cell = this.elementField ? row.getCell(this.elementField) : row.getCells()[0], el = cell.getElement(), config = row.modules.dataTree;
        if (config.branchEl) {
            if (config.branchEl.parentNode) config.branchEl.parentNode.removeChild(config.branchEl);
            config.branchEl = false;
        }
        if (config.controlEl) {
            if (config.controlEl.parentNode) config.controlEl.parentNode.removeChild(config.controlEl);
            config.controlEl = false;
        }
        this.generateControlElement(row, el);
        row.getElement().classList.add("tabulator-tree-level-" + config.index);
        if (config.index) {
            if (this.branchEl) {
                config.branchEl = this.branchEl.cloneNode(true);
                el.insertBefore(config.branchEl, el.firstChild);
                if (this.table.rtl) config.branchEl.style.marginRight = (config.branchEl.offsetWidth + config.branchEl.style.marginLeft) * (config.index - 1) + config.index * this.indent + "px";
                else config.branchEl.style.marginLeft = (config.branchEl.offsetWidth + config.branchEl.style.marginRight) * (config.index - 1) + config.index * this.indent + "px";
            } else if (this.table.rtl) el.style.paddingRight = parseInt(window.getComputedStyle(el, null).getPropertyValue('padding-right')) + config.index * this.indent + "px";
            else el.style.paddingLeft = parseInt(window.getComputedStyle(el, null).getPropertyValue('padding-left')) + config.index * this.indent + "px";
        }
    }
    generateControlElement(row, el) {
        var config = row.modules.dataTree, oldControl = config.controlEl;
        el = el || row.getCells()[0].getElement();
        if (config.children !== false) {
            if (config.open) {
                config.controlEl = this.collapseEl.cloneNode(true);
                config.controlEl.addEventListener("click", (e)=>{
                    e.stopPropagation();
                    this.collapseRow(row);
                });
            } else {
                config.controlEl = this.expandEl.cloneNode(true);
                config.controlEl.addEventListener("click", (e)=>{
                    e.stopPropagation();
                    this.expandRow(row);
                });
            }
            config.controlEl.addEventListener("mousedown", (e)=>{
                e.stopPropagation();
            });
            if (oldControl && oldControl.parentNode === el) oldControl.parentNode.replaceChild(config.controlEl, oldControl);
            else el.insertBefore(config.controlEl, el.firstChild);
        }
    }
    getRows(rows) {
        var output = [];
        rows.forEach((row, i)=>{
            var config, children;
            output.push(row);
            if (row instanceof $517dee46856d349e$var$Row) {
                row.create();
                config = row.modules.dataTree;
                if (!config.index && config.children !== false) {
                    children = this.getChildren(row, false, true);
                    children.forEach((child)=>{
                        child.create();
                        output.push(child);
                    });
                }
            }
        });
        return output;
    }
    getChildren(row, allChildren, sortOnly) {
        var config = row.modules.dataTree, children = [], output = [];
        if (config.children !== false && (config.open || allChildren)) {
            if (!Array.isArray(config.children)) config.children = this.generateChildren(row);
            if (this.table.modExists("filter") && this.table.options.dataTreeFilter) children = this.table.modules.filter.filter(config.children);
            else children = config.children;
            if (this.table.modExists("sort") && this.table.options.dataTreeSort) this.table.modules.sort.sort(children, sortOnly);
            children.forEach((child)=>{
                output.push(child);
                var subChildren = this.getChildren(child, false, true);
                subChildren.forEach((sub)=>{
                    output.push(sub);
                });
            });
        }
        return output;
    }
    generateChildren(row) {
        var children = [];
        var childArray = row.getData()[this.field];
        if (!Array.isArray(childArray)) childArray = [
            childArray
        ];
        childArray.forEach((childData)=>{
            var childRow = new $517dee46856d349e$var$Row(childData || {}, this.table.rowManager);
            childRow.create();
            childRow.modules.dataTree.index = row.modules.dataTree.index + 1;
            childRow.modules.dataTree.parent = row;
            if (childRow.modules.dataTree.children) childRow.modules.dataTree.open = this.startOpen(childRow.getComponent(), childRow.modules.dataTree.index);
            children.push(childRow);
        });
        return children;
    }
    expandRow(row, silent) {
        var config = row.modules.dataTree;
        if (config.children !== false) {
            config.open = true;
            row.reinitialize();
            this.refreshData(true);
            this.dispatchExternal("dataTreeRowExpanded", row.getComponent(), row.modules.dataTree.index);
        }
    }
    collapseRow(row) {
        var config = row.modules.dataTree;
        if (config.children !== false) {
            config.open = false;
            row.reinitialize();
            this.refreshData(true);
            this.dispatchExternal("dataTreeRowCollapsed", row.getComponent(), row.modules.dataTree.index);
        }
    }
    toggleRow(row) {
        var config = row.modules.dataTree;
        if (config.children !== false) {
            if (config.open) this.collapseRow(row);
            else this.expandRow(row);
        }
    }
    isRowExpanded(row) {
        return row.modules.dataTree.open;
    }
    getTreeParent(row) {
        return row.modules.dataTree.parent ? row.modules.dataTree.parent.getComponent() : false;
    }
    getTreeParentRoot(row) {
        return row.modules.dataTree && row.modules.dataTree.parent ? this.getTreeParentRoot(row.modules.dataTree.parent) : row;
    }
    getFilteredTreeChildren(row) {
        var config = row.modules.dataTree, output = [], children;
        if (config.children) {
            if (!Array.isArray(config.children)) config.children = this.generateChildren(row);
            if (this.table.modExists("filter") && this.table.options.dataTreeFilter) children = this.table.modules.filter.filter(config.children);
            else children = config.children;
            children.forEach((childRow)=>{
                if (childRow instanceof $517dee46856d349e$var$Row) output.push(childRow);
            });
        }
        return output;
    }
    rowDeleting(row) {
        var config = row.modules.dataTree;
        if (config && config.children && Array.isArray(config.children)) config.children.forEach((childRow)=>{
            if (childRow instanceof $517dee46856d349e$var$Row) childRow.wipe();
        });
    }
    rowDelete(row) {
        var parent = row.modules.dataTree.parent, childIndex;
        if (parent) {
            childIndex = this.findChildIndex(row, parent);
            if (childIndex !== false) parent.data[this.field].splice(childIndex, 1);
            if (!parent.data[this.field].length) delete parent.data[this.field];
            this.initializeRow(parent);
            this.layoutRow(parent);
        }
        this.refreshData(true);
    }
    addTreeChildRow(row, data, top, index) {
        var childIndex = false;
        if (typeof data === "string") data = JSON.parse(data);
        if (!Array.isArray(row.data[this.field])) {
            row.data[this.field] = [];
            row.modules.dataTree.open = this.startOpen(row.getComponent(), row.modules.dataTree.index);
        }
        if (typeof index !== "undefined") {
            childIndex = this.findChildIndex(index, row);
            if (childIndex !== false) row.data[this.field].splice(top ? childIndex : childIndex + 1, 0, data);
        }
        if (childIndex === false) {
            if (top) row.data[this.field].unshift(data);
            else row.data[this.field].push(data);
        }
        this.initializeRow(row);
        this.layoutRow(row);
        this.refreshData(true);
    }
    findChildIndex(subject, parent) {
        var match = false;
        if (typeof subject == "object") {
            if (subject instanceof $517dee46856d349e$var$Row) //subject is row element
            match = subject.data;
            else if (subject instanceof $517dee46856d349e$export$5df91075f5ba4651) //subject is public row component
            match = subject._getSelf().data;
            else if (typeof HTMLElement !== "undefined" && subject instanceof HTMLElement) {
                if (parent.modules.dataTree) {
                    match = parent.modules.dataTree.children.find((childRow)=>{
                        return childRow instanceof $517dee46856d349e$var$Row ? childRow.element === subject : false;
                    });
                    if (match) match = match.data;
                }
            } else if (subject === null) match = false;
        } else if (typeof subject == "undefined") match = false;
        else //subject should be treated as the index of the row
        match = parent.data[this.field].find((row)=>{
            return row.data[this.table.options.index] == subject;
        });
        if (match) {
            if (Array.isArray(parent.data[this.field])) match = parent.data[this.field].indexOf(match);
            if (match == -1) match = false;
        }
        //catch all for any other type of input
        return match;
    }
    getTreeChildren(row, component, recurse) {
        var config = row.modules.dataTree, output = [];
        if (config && config.children) {
            if (!Array.isArray(config.children)) config.children = this.generateChildren(row);
            config.children.forEach((childRow)=>{
                if (childRow instanceof $517dee46856d349e$var$Row) {
                    output.push(component ? childRow.getComponent() : childRow);
                    if (recurse) this.getTreeChildren(childRow, component, recurse).forEach((child)=>{
                        output.push(child);
                    });
                }
            });
        }
        return output;
    }
    getChildField() {
        return this.field;
    }
    redrawNeeded(data) {
        return (this.field ? typeof data[this.field] !== "undefined" : false) || (this.elementField ? typeof data[this.elementField] !== "undefined" : false);
    }
}
function $517dee46856d349e$var$csv$1(list, options = {}, setFileContents) {
    var delimiter = options.delimiter ? options.delimiter : ",", fileContents = [], headers = [];
    list.forEach((row)=>{
        var item = [];
        switch(row.type){
            case "group":
                console.warn("Download Warning - CSV downloader cannot process row groups");
                break;
            case "calc":
                console.warn("Download Warning - CSV downloader cannot process column calculations");
                break;
            case "header":
                row.columns.forEach((col, i)=>{
                    if (col && col.depth === 1) headers[i] = typeof col.value == "undefined" || col.value === null ? "" : '"' + String(col.value).split('"').join('""') + '"';
                });
                break;
            case "row":
                row.columns.forEach((col)=>{
                    if (col) {
                        switch(typeof col.value){
                            case "object":
                                col.value = col.value !== null ? JSON.stringify(col.value) : "";
                                break;
                            case "undefined":
                                col.value = "";
                                break;
                        }
                        item.push('"' + String(col.value).split('"').join('""') + '"');
                    }
                });
                fileContents.push(item.join(delimiter));
                break;
        }
    });
    if (headers.length) fileContents.unshift(headers.join(delimiter));
    fileContents = fileContents.join("\n");
    if (options.bom) fileContents = "\ufeff" + fileContents;
    setFileContents(fileContents, "text/csv");
}
function $517dee46856d349e$var$json$2(list, options, setFileContents) {
    var fileContents = [];
    list.forEach((row)=>{
        var item = {};
        switch(row.type){
            case "header":
                break;
            case "group":
                console.warn("Download Warning - JSON downloader cannot process row groups");
                break;
            case "calc":
                console.warn("Download Warning - JSON downloader cannot process column calculations");
                break;
            case "row":
                row.columns.forEach((col)=>{
                    if (col) item[col.component.getTitleDownload() || col.component.getField()] = col.value;
                });
                fileContents.push(item);
                break;
        }
    });
    fileContents = JSON.stringify(fileContents, null, '\t');
    setFileContents(fileContents, "application/json");
}
function $517dee46856d349e$var$pdf(list, options = {}, setFileContents) {
    var header = [], body = [], autoTableParams = {}, rowGroupStyles = options.rowGroupStyles || {
        fontStyle: "bold",
        fontSize: 12,
        cellPadding: 6,
        fillColor: 220
    }, rowCalcStyles = options.rowCalcStyles || {
        fontStyle: "bold",
        fontSize: 10,
        cellPadding: 4,
        fillColor: 232
    }, jsPDFParams = options.jsPDF || {}, title = options.title ? options.title : "", jspdfLib, doc;
    if (!jsPDFParams.orientation) jsPDFParams.orientation = options.orientation || "landscape";
    if (!jsPDFParams.unit) jsPDFParams.unit = "pt";
    //parse row list
    list.forEach((row)=>{
        switch(row.type){
            case "header":
                header.push(parseRow(row));
                break;
            case "group":
                body.push(parseRow(row, rowGroupStyles));
                break;
            case "calc":
                body.push(parseRow(row, rowCalcStyles));
                break;
            case "row":
                body.push(parseRow(row));
                break;
        }
    });
    function parseRow(row, styles) {
        var rowData = [];
        row.columns.forEach((col)=>{
            var cell;
            if (col) {
                switch(typeof col.value){
                    case "object":
                        col.value = col.value !== null ? JSON.stringify(col.value) : "";
                        break;
                    case "undefined":
                        col.value = "";
                        break;
                }
                cell = {
                    content: col.value,
                    colSpan: col.width,
                    rowSpan: col.height
                };
                if (styles) cell.styles = styles;
                rowData.push(cell);
            }
        });
        return rowData;
    }
    //configure PDF
    jspdfLib = this.dependencyRegistry.lookup("jspdf", "jsPDF");
    doc = new jspdfLib(jsPDFParams); //set document to landscape, better for most tables
    if (options.autoTable) {
        if (typeof options.autoTable === "function") autoTableParams = options.autoTable(doc) || {};
        else autoTableParams = options.autoTable;
    }
    if (title) autoTableParams.didDrawPage = function(data) {
        doc.text(title, 40, 30);
    };
    autoTableParams.head = header;
    autoTableParams.body = body;
    doc.autoTable(autoTableParams);
    if (options.documentProcessing) options.documentProcessing(doc);
    setFileContents(doc.output("arraybuffer"), "application/pdf");
}
function $517dee46856d349e$var$xlsx$1(list, options, setFileContents) {
    var self = this, sheetName = options.sheetName || "Sheet1", XLSXLib = this.dependencyRegistry.lookup("XLSX"), workbook = XLSXLib.utils.book_new(), tableFeatures = new $517dee46856d349e$var$CoreFeature(this), compression = 'compress' in options ? options.compress : true, writeOptions = options.writeOptions || {
        bookType: 'xlsx',
        bookSST: true,
        compression: compression
    }, output;
    writeOptions.type = 'binary';
    workbook.SheetNames = [];
    workbook.Sheets = {};
    function generateSheet() {
        var rows = [], merges = [], worksheet = {}, range = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: list[0] ? list[0].columns.reduce((a, b)=>a + (b && b.width ? b.width : 1), 0) : 0,
                r: list.length
            }
        };
        //parse row list
        list.forEach((row, i)=>{
            var rowData = [];
            row.columns.forEach(function(col, j) {
                if (col) {
                    rowData.push(!(col.value instanceof Date) && typeof col.value === "object" ? JSON.stringify(col.value) : col.value);
                    if (col.width > 1 || col.height > -1) {
                        if (col.height > 1 || col.width > 1) merges.push({
                            s: {
                                r: i,
                                c: j
                            },
                            e: {
                                r: i + col.height - 1,
                                c: j + col.width - 1
                            }
                        });
                    }
                } else rowData.push("");
            });
            rows.push(rowData);
        });
        //convert rows to worksheet
        XLSXLib.utils.sheet_add_aoa(worksheet, rows);
        worksheet['!ref'] = XLSXLib.utils.encode_range(range);
        if (merges.length) worksheet["!merges"] = merges;
        return worksheet;
    }
    if (options.sheetOnly) {
        setFileContents(generateSheet());
        return;
    }
    if (options.sheets) {
        for(var sheet in options.sheets)if (options.sheets[sheet] === true) {
            workbook.SheetNames.push(sheet);
            workbook.Sheets[sheet] = generateSheet();
        } else {
            workbook.SheetNames.push(sheet);
            tableFeatures.commsSend(options.sheets[sheet], "download", "intercept", {
                type: "xlsx",
                options: {
                    sheetOnly: true
                },
                active: self.active,
                intercept: function(data) {
                    workbook.Sheets[sheet] = data;
                }
            });
        }
    } else {
        workbook.SheetNames.push(sheetName);
        workbook.Sheets[sheetName] = generateSheet();
    }
    if (options.documentProcessing) workbook = options.documentProcessing(workbook);
    //convert workbook to binary array
    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
    output = XLSXLib.write(workbook, writeOptions);
    setFileContents(s2ab(output), "application/octet-stream");
}
function $517dee46856d349e$var$html$1(list, options, setFileContents) {
    if (this.modExists("export", true)) setFileContents(this.modules.export.generateHTMLTable(list), "text/html");
}
function $517dee46856d349e$var$jsonLines(list, options, setFileContents) {
    const fileContents = [];
    list.forEach((row)=>{
        const item = {};
        switch(row.type){
            case "header":
                break;
            case "group":
                console.warn("Download Warning - JSON downloader cannot process row groups");
                break;
            case "calc":
                console.warn("Download Warning - JSON downloader cannot process column calculations");
                break;
            case "row":
                row.columns.forEach((col)=>{
                    if (col) item[col.component.getTitleDownload() || col.component.getField()] = col.value;
                });
                fileContents.push(JSON.stringify(item));
                break;
        }
    });
    setFileContents(fileContents.join("\n"), "application/x-ndjson");
}
var $517dee46856d349e$var$defaultDownloaders = {
    csv: $517dee46856d349e$var$csv$1,
    json: $517dee46856d349e$var$json$2,
    jsonLines: $517dee46856d349e$var$jsonLines,
    pdf: $517dee46856d349e$var$pdf,
    xlsx: $517dee46856d349e$var$xlsx$1,
    html: $517dee46856d349e$var$html$1
};
class $517dee46856d349e$export$6dd96c6d41f32a97 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "download";
    //load defaults
    static downloaders = $517dee46856d349e$var$defaultDownloaders;
    constructor(table){
        super(table);
        this.registerTableOption("downloadEncoder", function(data, mimeType) {
            return new Blob([
                data
            ], {
                type: mimeType
            });
        }); //function to manipulate download data
        this.registerTableOption("downloadConfig", {}); //download config
        this.registerTableOption("downloadRowRange", "active"); //restrict download to active rows only
        this.registerColumnOption("download");
        this.registerColumnOption("titleDownload");
    }
    initialize() {
        this.deprecatedOptionsCheck();
        this.registerTableFunction("download", this.download.bind(this));
        this.registerTableFunction("downloadToTab", this.downloadToTab.bind(this));
    }
    deprecatedOptionsCheck() {}
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    downloadToTab(type, filename, options, active) {
        this.download(type, filename, options, active, true);
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    //trigger file download
    download(type, filename, options, range, interceptCallback) {
        var downloadFunc = false;
        function buildLink(data, mime) {
            if (interceptCallback) {
                if (interceptCallback === true) this.triggerDownload(data, mime, type, filename, true);
                else interceptCallback(data);
            } else this.triggerDownload(data, mime, type, filename);
        }
        if (typeof type == "function") downloadFunc = type;
        else if ($517dee46856d349e$export$6dd96c6d41f32a97.downloaders[type]) downloadFunc = $517dee46856d349e$export$6dd96c6d41f32a97.downloaders[type];
        else console.warn("Download Error - No such download type found: ", type);
        if (downloadFunc) {
            var list = this.generateExportList(range);
            downloadFunc.call(this.table, list, options || {}, buildLink.bind(this));
        }
    }
    generateExportList(range) {
        var list = this.table.modules.export.generateExportList(this.table.options.downloadConfig, false, range || this.table.options.downloadRowRange, "download");
        //assign group header formatter
        var groupHeader = this.table.options.groupHeaderDownload;
        if (groupHeader && !Array.isArray(groupHeader)) groupHeader = [
            groupHeader
        ];
        list.forEach((row)=>{
            var group;
            if (row.type === "group") {
                group = row.columns[0];
                if (groupHeader && groupHeader[row.indent]) group.value = groupHeader[row.indent](group.value, row.component._group.getRowCount(), row.component._group.getData(), row.component);
            }
        });
        return list;
    }
    triggerDownload(data, mime, type, filename, newTab) {
        var element = document.createElement('a'), blob = this.table.options.downloadEncoder(data, mime);
        if (blob) {
            if (newTab) window.open(window.URL.createObjectURL(blob));
            else {
                filename = filename || "Tabulator." + (typeof type === "function" ? "txt" : type);
                if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, filename);
                else {
                    element.setAttribute('href', window.URL.createObjectURL(blob));
                    //set file title
                    element.setAttribute('download', filename);
                    //trigger download
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    //remove temporary link element
                    document.body.removeChild(element);
                }
            }
            this.dispatchExternal("downloadComplete");
        }
    }
    commsReceived(table, action, data) {
        switch(action){
            case "intercept":
                this.download(data.type, "", data.options, data.active, data.intercept);
                break;
        }
    }
}
function $517dee46856d349e$var$maskInput(el, options) {
    var mask = options.mask, maskLetter = typeof options.maskLetterChar !== "undefined" ? options.maskLetterChar : "A", maskNumber = typeof options.maskNumberChar !== "undefined" ? options.maskNumberChar : "9", maskWildcard = typeof options.maskWildcardChar !== "undefined" ? options.maskWildcardChar : "*";
    function fillSymbols(index) {
        var symbol = mask[index];
        if (typeof symbol !== "undefined" && symbol !== maskWildcard && symbol !== maskLetter && symbol !== maskNumber) {
            el.value = el.value + "" + symbol;
            fillSymbols(index + 1);
        }
    }
    el.addEventListener("keydown", (e)=>{
        var index = el.value.length, char = e.key;
        if (e.keyCode > 46 && !e.ctrlKey && !e.metaKey) {
            if (index >= mask.length) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            } else switch(mask[index]){
                case maskLetter:
                    if (char.toUpperCase() == char.toLowerCase()) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    break;
                case maskNumber:
                    if (isNaN(char)) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    break;
                case maskWildcard:
                    break;
                default:
                    if (char !== mask[index]) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
            }
        }
        return;
    });
    el.addEventListener("keyup", (e)=>{
        if (e.keyCode > 46) {
            if (options.maskAutoFill) fillSymbols(el.value.length);
        }
    });
    if (!el.placeholder) el.placeholder = mask;
    if (options.maskAutoFill) fillSymbols(el.value.length);
}
//input element
function $517dee46856d349e$var$input(cell, onRendered, success, cancel, editorParams) {
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.setAttribute("type", editorParams.search ? "search" : "text");
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = typeof cellValue !== "undefined" ? cellValue : "";
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange(e) {
        if ((cellValue === null || typeof cellValue === "undefined") && input.value !== "" || input.value !== cellValue) {
            if (success(input.value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur or change
    input.addEventListener("change", onChange);
    input.addEventListener("blur", onChange);
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
        }
    });
    if (editorParams.mask) $517dee46856d349e$var$maskInput(input, editorParams);
    return input;
}
//resizable text area element
function $517dee46856d349e$var$textarea$1(cell, onRendered, success, cancel, editorParams) {
    var cellValue = cell.getValue(), vertNav = editorParams.verticalNavigation || "hybrid", value = String(cellValue !== null && typeof cellValue !== "undefined" ? cellValue : ""), input = document.createElement("textarea"), scrollHeight = 0;
    //create and style input
    input.style.display = "block";
    input.style.padding = "2px";
    input.style.height = "100%";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    input.style.whiteSpace = "pre-wrap";
    input.style.resize = "none";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = value;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            input.scrollHeight;
            input.style.height = input.scrollHeight + "px";
            cell.getRow().normalizeHeight();
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange(e) {
        if ((cellValue === null || typeof cellValue === "undefined") && input.value !== "" || input.value !== cellValue) {
            if (success(input.value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
            setTimeout(function() {
                cell.getRow().normalizeHeight();
            }, 300);
        } else cancel();
    }
    //submit new value on blur or change
    input.addEventListener("change", onChange);
    input.addEventListener("blur", onChange);
    input.addEventListener("keyup", function() {
        input.style.height = "";
        var heightNow = input.scrollHeight;
        input.style.height = heightNow + "px";
        if (heightNow != scrollHeight) {
            scrollHeight = heightNow;
            cell.getRow().normalizeHeight();
        }
    });
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 13:
                if (e.shiftKey && editorParams.shiftEnterSubmit) onChange();
                break;
            case 27:
                cancel();
                break;
            case 38:
                if (vertNav == "editor" || vertNav == "hybrid" && input.selectionStart) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
            case 40:
                if (vertNav == "editor" || vertNav == "hybrid" && input.selectionStart !== input.value.length) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
        }
    });
    if (editorParams.mask) $517dee46856d349e$var$maskInput(input, editorParams);
    return input;
}
//input element with type of number
function $517dee46856d349e$var$number$1(cell, onRendered, success, cancel, editorParams) {
    var cellValue = cell.getValue(), vertNav = editorParams.verticalNavigation || "editor", input = document.createElement("input");
    input.setAttribute("type", "number");
    if (typeof editorParams.max != "undefined") input.setAttribute("max", editorParams.max);
    if (typeof editorParams.min != "undefined") input.setAttribute("min", editorParams.min);
    if (typeof editorParams.step != "undefined") input.setAttribute("step", editorParams.step);
    //create and style input
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = cellValue;
    var blurFunc = function(e) {
        onChange();
    };
    onRendered(function() {
        if (cell.getType() === "cell") {
            //submit new value on blur
            input.removeEventListener("blur", blurFunc);
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            //submit new value on blur
            input.addEventListener("blur", blurFunc);
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value;
        if (!isNaN(value) && value !== "") value = Number(value);
        if (value !== cellValue) {
            if (success(value)) cellValue = value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 13:
                // case 9:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
        }
    });
    if (editorParams.mask) $517dee46856d349e$var$maskInput(input, editorParams);
    return input;
}
//input element with type of number
function $517dee46856d349e$var$range(cell, onRendered, success, cancel, editorParams) {
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.setAttribute("type", "range");
    if (typeof editorParams.max != "undefined") input.setAttribute("max", editorParams.max);
    if (typeof editorParams.min != "undefined") input.setAttribute("min", editorParams.min);
    if (typeof editorParams.step != "undefined") input.setAttribute("step", editorParams.step);
    //create and style input
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
        }
    });
    function onChange() {
        var value = input.value;
        if (!isNaN(value) && value !== "") value = Number(value);
        if (value != cellValue) {
            if (success(value)) cellValue = value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        onChange();
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 13:
                // case 9:
                onChange();
                break;
            case 27:
                cancel();
                break;
        }
    });
    return input;
}
//input element
function $517dee46856d349e$var$date$1(cell, onRendered, success, cancel, editorParams) {
    var inputFormat = editorParams.format, vertNav = editorParams.verticalNavigation || "editor", DT = inputFormat ? window.DateTime || luxon.DateTime : null;
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    function convertDate(value) {
        var newDatetime;
        if (DT.isDateTime(value)) newDatetime = value;
        else if (inputFormat === "iso") newDatetime = DT.fromISO(String(value));
        else newDatetime = DT.fromFormat(String(value), inputFormat);
        return newDatetime.toFormat("yyyy-MM-dd");
    }
    input.type = "date";
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.max) input.setAttribute("max", inputFormat ? convertDate(editorParams.max) : editorParams.max);
    if (editorParams.min) input.setAttribute("min", inputFormat ? convertDate(editorParams.min) : editorParams.min);
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    cellValue = typeof cellValue !== "undefined" ? cellValue : "";
    if (inputFormat) {
        if (DT) cellValue = convertDate(cellValue);
        else console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js");
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value, luxDate;
        if ((cellValue === null || typeof cellValue === "undefined") && value !== "" || value !== cellValue) {
            if (value && inputFormat) {
                luxDate = DT.fromFormat(String(value), "yyyy-MM-dd");
                switch(inputFormat){
                    case true:
                        value = luxDate;
                        break;
                    case "iso":
                        value = luxDate.toISO();
                        break;
                    default:
                        value = luxDate.toFormat(inputFormat);
                }
            }
            if (success(value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        if (e.relatedTarget || e.rangeParent || e.explicitOriginalTarget !== input) onChange(); // only on a "true" blur; not when focusing browser's date/time picker
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
        }
    });
    return input;
}
//input element
function $517dee46856d349e$var$time$1(cell, onRendered, success, cancel, editorParams) {
    var inputFormat = editorParams.format, vertNav = editorParams.verticalNavigation || "editor", DT = inputFormat ? window.DateTime || luxon.DateTime : null, newDatetime;
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.type = "time";
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    cellValue = typeof cellValue !== "undefined" ? cellValue : "";
    if (inputFormat) {
        if (DT) {
            if (DT.isDateTime(cellValue)) newDatetime = cellValue;
            else if (inputFormat === "iso") newDatetime = DT.fromISO(String(cellValue));
            else newDatetime = DT.fromFormat(String(cellValue), inputFormat);
            cellValue = newDatetime.toFormat("HH:mm");
        } else console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js");
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() == "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value, luxTime;
        if ((cellValue === null || typeof cellValue === "undefined") && value !== "" || value !== cellValue) {
            if (value && inputFormat) {
                luxTime = DT.fromFormat(String(value), "hh:mm");
                switch(inputFormat){
                    case true:
                        value = luxTime;
                        break;
                    case "iso":
                        value = luxTime.toISO();
                        break;
                    default:
                        value = luxTime.toFormat(inputFormat);
                }
            }
            if (success(value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        if (e.relatedTarget || e.rangeParent || e.explicitOriginalTarget !== input) onChange(); // only on a "true" blur; not when focusing browser's date/time picker
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
        }
    });
    return input;
}
//input element
function $517dee46856d349e$var$datetime$2(cell, onRendered, success, cancel, editorParams) {
    var inputFormat = editorParams.format, vertNav = editorParams.verticalNavigation || "editor", DT = inputFormat ? this.table.dependencyRegistry.lookup([
        "luxon",
        "DateTime"
    ], "DateTime") : null, newDatetime;
    //create and style input
    var cellValue = cell.getValue(), input = document.createElement("input");
    input.type = "datetime-local";
    input.style.padding = "4px";
    input.style.width = "100%";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    cellValue = typeof cellValue !== "undefined" ? cellValue : "";
    if (inputFormat) {
        if (DT) {
            if (DT.isDateTime(cellValue)) newDatetime = cellValue;
            else if (inputFormat === "iso") newDatetime = DT.fromISO(String(cellValue));
            else newDatetime = DT.fromFormat(String(cellValue), inputFormat);
            cellValue = newDatetime.toFormat("yyyy-MM-dd") + "T" + newDatetime.toFormat("HH:mm");
        } else console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js");
    }
    input.value = cellValue;
    onRendered(function() {
        if (cell.getType() === "cell") {
            input.focus({
                preventScroll: true
            });
            input.style.height = "100%";
            if (editorParams.selectContents) input.select();
        }
    });
    function onChange() {
        var value = input.value, luxDateTime;
        if ((cellValue === null || typeof cellValue === "undefined") && value !== "" || value !== cellValue) {
            if (value && inputFormat) {
                luxDateTime = DT.fromISO(String(value));
                switch(inputFormat){
                    case true:
                        value = luxDateTime;
                        break;
                    case "iso":
                        value = luxDateTime.toISO();
                        break;
                    default:
                        value = luxDateTime.toFormat(inputFormat);
                }
            }
            if (success(value)) cellValue = input.value; //persist value if successfully validated incase editor is used as header filter
        } else cancel();
    }
    //submit new value on blur
    input.addEventListener("blur", function(e) {
        if (e.relatedTarget || e.rangeParent || e.explicitOriginalTarget !== input) onChange(); // only on a "true" blur; not when focusing browser's date/time picker
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            // case 9:
            case 13:
                onChange();
                break;
            case 27:
                cancel();
                break;
            case 35:
            case 36:
                e.stopPropagation();
                break;
            case 38:
            case 40:
                if (vertNav == "editor") {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
                break;
        }
    });
    return input;
}
let $517dee46856d349e$var$Edit$1 = class Edit {
    constructor(editor, cell, onRendered, success, cancel, editorParams){
        this.edit = editor;
        this.table = editor.table;
        this.cell = cell;
        this.params = this._initializeParams(editorParams);
        this.data = [];
        this.displayItems = [];
        this.currentItems = [];
        this.focusedItem = null;
        this.input = this._createInputElement();
        this.listEl = this._createListElement();
        this.initialValues = null;
        this.isFilter = cell.getType() === "header";
        this.filterTimeout = null;
        this.filtered = false;
        this.typing = false;
        this.values = [];
        this.popup = null;
        this.listIteration = 0;
        this.lastAction = "";
        this.filterTerm = "";
        this.blurable = true;
        this.actions = {
            success: success,
            cancel: cancel
        };
        this._deprecatedOptionsCheck();
        this._initializeValue();
        onRendered(this._onRendered.bind(this));
    }
    _deprecatedOptionsCheck() {
    // if(this.params.listItemFormatter){
    // 	this.cell.getTable().deprecationAdvisor.msg("The listItemFormatter editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    // if(this.params.sortValuesList){
    // 	this.cell.getTable().deprecationAdvisor.msg("The sortValuesList editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    // if(this.params.searchFunc){
    // 	this.cell.getTable().deprecationAdvisor.msg("The searchFunc editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    // if(this.params.searchingPlaceholder){
    // 	this.cell.getTable().deprecationAdvisor.msg("The searchingPlaceholder editor param has been deprecated, please see the latest editor documentation for updated options");
    // }
    }
    _initializeValue() {
        var initialValue = this.cell.getValue();
        if (typeof initialValue === "undefined" && typeof this.params.defaultValue !== "undefined") initialValue = this.params.defaultValue;
        this.initialValues = this.params.multiselect ? initialValue : [
            initialValue
        ];
        if (this.isFilter) {
            this.input.value = this.initialValues ? this.initialValues.join(",") : "";
            this.headerFilterInitialListGen();
        }
    }
    _onRendered() {
        var cellEl = this.cell.getElement();
        function clickStop(e) {
            e.stopPropagation();
        }
        if (!this.isFilter) {
            this.input.style.height = "100%";
            this.input.focus({
                preventScroll: true
            });
        }
        cellEl.addEventListener("click", clickStop);
        setTimeout(()=>{
            cellEl.removeEventListener("click", clickStop);
        }, 1000);
        this.input.addEventListener("mousedown", this._preventPopupBlur.bind(this));
    }
    _createListElement() {
        var listEl = document.createElement("div");
        listEl.classList.add("tabulator-edit-list");
        listEl.addEventListener("mousedown", this._preventBlur.bind(this));
        listEl.addEventListener("keydown", this._inputKeyDown.bind(this));
        return listEl;
    }
    _setListWidth() {
        var element = this.isFilter ? this.input : this.cell.getElement();
        this.listEl.style.minWidth = element.offsetWidth + "px";
        if (this.params.maxWidth) {
            if (this.params.maxWidth === true) this.listEl.style.maxWidth = element.offsetWidth + "px";
            else if (typeof this.params.maxWidth === "number") this.listEl.style.maxWidth = this.params.maxWidth + "px";
            else this.listEl.style.maxWidth = this.params.maxWidth;
        }
    }
    _createInputElement() {
        var attribs = this.params.elementAttributes;
        var input = document.createElement("input");
        input.setAttribute("type", this.params.clearable ? "search" : "text");
        input.style.padding = "4px";
        input.style.width = "100%";
        input.style.boxSizing = "border-box";
        if (!this.params.autocomplete) {
            input.style.cursor = "default";
            input.style.caretColor = "transparent";
        // input.readOnly = (this.edit.currentCell != false);
        }
        if (attribs && typeof attribs == "object") {
            for(let key in attribs)if (key.charAt(0) == "+") {
                key = key.slice(1);
                input.setAttribute(key, input.getAttribute(key) + attribs["+" + key]);
            } else input.setAttribute(key, attribs[key]);
        }
        if (this.params.mask) $517dee46856d349e$var$maskInput(input, this.params);
        this._bindInputEvents(input);
        return input;
    }
    _initializeParams(params) {
        var valueKeys = [
            "values",
            "valuesURL",
            "valuesLookup"
        ], valueCheck;
        params = Object.assign({}, params);
        params.verticalNavigation = params.verticalNavigation || "editor";
        params.placeholderLoading = typeof params.placeholderLoading === "undefined" ? "Searching ..." : params.placeholderLoading;
        params.placeholderEmpty = typeof params.placeholderEmpty === "undefined" ? "No Results Found" : params.placeholderEmpty;
        params.filterDelay = typeof params.filterDelay === "undefined" ? 300 : params.filterDelay;
        params.emptyValue = Object.keys(params).includes("emptyValue") ? params.emptyValue : "";
        valueCheck = Object.keys(params).filter((key)=>valueKeys.includes(key)).length;
        if (!valueCheck) console.warn("list editor config error - either the values, valuesURL, or valuesLookup option must be set");
        else if (valueCheck > 1) console.warn("list editor config error - only one of the values, valuesURL, or valuesLookup options can be set on the same editor");
        if (params.autocomplete) {
            if (params.multiselect) {
                params.multiselect = false;
                console.warn("list editor config error - multiselect option is not available when autocomplete is enabled");
            }
        } else {
            if (params.freetext) {
                params.freetext = false;
                console.warn("list editor config error - freetext option is only available when autocomplete is enabled");
            }
            if (params.filterFunc) {
                params.filterFunc = false;
                console.warn("list editor config error - filterFunc option is only available when autocomplete is enabled");
            }
            if (params.filterRemote) {
                params.filterRemote = false;
                console.warn("list editor config error - filterRemote option is only available when autocomplete is enabled");
            }
            if (params.mask) {
                params.mask = false;
                console.warn("list editor config error - mask option is only available when autocomplete is enabled");
            }
            if (params.allowEmpty) {
                params.allowEmpty = false;
                console.warn("list editor config error - allowEmpty option is only available when autocomplete is enabled");
            }
            if (params.listOnEmpty) {
                params.listOnEmpty = false;
                console.warn("list editor config error - listOnEmpty option is only available when autocomplete is enabled");
            }
        }
        if (params.filterRemote && !(typeof params.valuesLookup === "function" || params.valuesURL)) {
            params.filterRemote = false;
            console.warn("list editor config error - filterRemote option should only be used when values list is populated from a remote source");
        }
        return params;
    }
    //////////////////////////////////////
    ////////// Event Handling ////////////
    //////////////////////////////////////
    _bindInputEvents(input) {
        input.addEventListener("focus", this._inputFocus.bind(this));
        input.addEventListener("click", this._inputClick.bind(this));
        input.addEventListener("blur", this._inputBlur.bind(this));
        input.addEventListener("keydown", this._inputKeyDown.bind(this));
        input.addEventListener("search", this._inputSearch.bind(this));
        if (this.params.autocomplete) input.addEventListener("keyup", this._inputKeyUp.bind(this));
    }
    _inputFocus(e) {
        this.rebuildOptionsList();
    }
    _filter() {
        if (this.params.filterRemote) {
            clearTimeout(this.filterTimeout);
            this.filterTimeout = setTimeout(()=>{
                this.rebuildOptionsList();
            }, this.params.filterDelay);
        } else this._filterList();
    }
    _inputClick(e) {
        e.stopPropagation();
    }
    _inputBlur(e) {
        if (this.blurable) {
            if (this.popup) this.popup.hide();
            else this._resolveValue(true);
        }
    }
    _inputSearch() {
        this._clearChoices();
    }
    _inputKeyDown(e) {
        switch(e.keyCode){
            case 38:
                this._keyUp(e);
                break;
            case 40:
                this._keyDown(e);
                break;
            case 37:
            case 39:
                this._keySide(e);
                break;
            case 13:
                this._keyEnter();
                break;
            case 27:
                this._keyEsc();
                break;
            case 36:
            case 35:
                this._keyHomeEnd(e);
                break;
            case 9:
                this._keyTab(e);
                break;
            default:
                this._keySelectLetter(e);
        }
    }
    _inputKeyUp(e) {
        switch(e.keyCode){
            case 38:
            case 37:
            case 39:
            case 40:
            case 13:
            case 27:
                break;
            default:
                this._keyAutoCompLetter(e);
        }
    }
    _preventPopupBlur() {
        if (this.popup) this.popup.blockHide();
        setTimeout(()=>{
            if (this.popup) this.popup.restoreHide();
        }, 10);
    }
    _preventBlur() {
        this.blurable = false;
        setTimeout(()=>{
            this.blurable = true;
        }, 10);
    }
    //////////////////////////////////////
    //////// Keyboard Navigation /////////
    //////////////////////////////////////
    _keyTab(e) {
        if (this.params.autocomplete && this.lastAction === "typing") this._resolveValue(true);
        else if (this.focusedItem) this._chooseItem(this.focusedItem, true);
    }
    _keyUp(e) {
        var index = this.displayItems.indexOf(this.focusedItem);
        if (this.params.verticalNavigation == "editor" || this.params.verticalNavigation == "hybrid" && index) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            if (index > 0) this._focusItem(this.displayItems[index - 1]);
        }
    }
    _keyDown(e) {
        var index = this.displayItems.indexOf(this.focusedItem);
        if (this.params.verticalNavigation == "editor" || this.params.verticalNavigation == "hybrid" && index < this.displayItems.length - 1) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            if (index < this.displayItems.length - 1) {
                if (index == -1) this._focusItem(this.displayItems[0]);
                else this._focusItem(this.displayItems[index + 1]);
            }
        }
    }
    _keySide(e) {
        if (!this.params.autocomplete) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
        }
    }
    _keyEnter(e) {
        if (this.params.autocomplete && this.lastAction === "typing") this._resolveValue(true);
        else if (this.focusedItem) this._chooseItem(this.focusedItem);
    }
    _keyEsc(e) {
        this._cancel();
    }
    _keyHomeEnd(e) {
        if (this.params.autocomplete) //prevent table navigation while using input element
        e.stopImmediatePropagation();
    }
    _keySelectLetter(e) {
        if (!this.params.autocomplete) {
            // if(this.edit.currentCell === false){
            e.preventDefault();
            // }
            if (e.keyCode >= 38 && e.keyCode <= 90) this._scrollToValue(e.keyCode);
        }
    }
    _keyAutoCompLetter(e) {
        this._filter();
        this.lastAction = "typing";
        this.typing = true;
    }
    _scrollToValue(char) {
        clearTimeout(this.filterTimeout);
        var character = String.fromCharCode(char).toLowerCase();
        this.filterTerm += character.toLowerCase();
        var match = this.displayItems.find((item)=>{
            return typeof item.label !== "undefined" && item.label.toLowerCase().startsWith(this.filterTerm);
        });
        if (match) this._focusItem(match);
        this.filterTimeout = setTimeout(()=>{
            this.filterTerm = "";
        }, 800);
    }
    _focusItem(item) {
        this.lastAction = "focus";
        if (this.focusedItem && this.focusedItem.element) this.focusedItem.element.classList.remove("focused");
        this.focusedItem = item;
        if (item && item.element) {
            item.element.classList.add("focused");
            item.element.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'start'
            });
        }
    }
    //////////////////////////////////////
    /////// Data List Generation /////////
    //////////////////////////////////////
    headerFilterInitialListGen() {
        this._generateOptions(true);
    }
    rebuildOptionsList() {
        this._generateOptions().then(this._sortOptions.bind(this)).then(this._buildList.bind(this)).then(this._showList.bind(this)).catch((e)=>{
            if (!Number.isInteger(e)) console.error("List generation error", e);
        });
    }
    _filterList() {
        this._buildList(this._filterOptions());
        this._showList();
    }
    _generateOptions(silent) {
        var values = [];
        var iteration = ++this.listIteration;
        this.filtered = false;
        if (this.params.values) values = this.params.values;
        else if (this.params.valuesURL) values = this._ajaxRequest(this.params.valuesURL, this.input.value);
        else {
            if (typeof this.params.valuesLookup === "function") values = this.params.valuesLookup(this.cell, this.input.value);
            else if (this.params.valuesLookup) values = this._uniqueColumnValues(this.params.valuesLookupField);
        }
        if (values instanceof Promise) {
            if (!silent) this._addPlaceholder(this.params.placeholderLoading);
            return values.then().then((responseValues)=>{
                if (this.listIteration === iteration) return this._parseList(responseValues);
                else return Promise.reject(iteration);
            });
        } else return Promise.resolve(this._parseList(values));
    }
    _addPlaceholder(contents) {
        var placeholder = document.createElement("div");
        if (typeof contents === "function") contents = contents(this.cell.getComponent(), this.listEl);
        if (contents) {
            this._clearList();
            if (contents instanceof HTMLElement) placeholder = contents;
            else {
                placeholder.classList.add("tabulator-edit-list-placeholder");
                placeholder.innerHTML = contents;
            }
            this.listEl.appendChild(placeholder);
            this._showList();
        }
    }
    _ajaxRequest(url, term) {
        var params = this.params.filterRemote ? {
            term: term
        } : {};
        url = $517dee46856d349e$var$urlBuilder(url, {}, params);
        return fetch(url).then((response)=>{
            if (response.ok) return response.json().catch((error)=>{
                console.warn("List Ajax Load Error - Invalid JSON returned", error);
                return Promise.reject(error);
            });
            else {
                console.error("List Ajax Load Error - Connection Error: " + response.status, response.statusText);
                return Promise.reject(response);
            }
        }).catch((error)=>{
            console.error("List Ajax Load Error - Connection Error: ", error);
            return Promise.reject(error);
        });
    }
    _uniqueColumnValues(field) {
        var output = {}, data = this.table.getData(this.params.valuesLookup), column;
        if (field) column = this.table.columnManager.getColumnByField(field);
        else column = this.cell.getColumn()._getSelf();
        if (column) data.forEach((row)=>{
            var val = column.getFieldValue(row);
            if (!this._emptyValueCheck(val)) {
                if (this.params.multiselect && Array.isArray(val)) val.forEach((item)=>{
                    if (!this._emptyValueCheck(item)) output[item] = true;
                });
                else output[val] = true;
            }
        });
        else {
            console.warn("unable to find matching column to create select lookup list:", field);
            output = [];
        }
        return Object.keys(output);
    }
    _emptyValueCheck(value) {
        return value === null || typeof value === "undefined" || value === "";
    }
    _parseList(inputValues) {
        var data = [];
        if (!Array.isArray(inputValues)) inputValues = Object.entries(inputValues).map(([key, value])=>{
            return {
                label: value,
                value: key
            };
        });
        inputValues.forEach((value)=>{
            if (typeof value !== "object") value = {
                label: value,
                value: value
            };
            this._parseListItem(value, data, 0);
        });
        if (!this.currentItems.length && this.params.freetext) {
            this.input.value = this.initialValues;
            this.typing = true;
            this.lastAction = "typing";
        }
        this.data = data;
        return data;
    }
    _parseListItem(option, data, level) {
        var item = {};
        if (option.options) item = this._parseListGroup(option, level + 1);
        else {
            item = {
                label: option.label,
                value: option.value,
                itemParams: option.itemParams,
                elementAttributes: option.elementAttributes,
                element: false,
                selected: false,
                visible: true,
                level: level,
                original: option
            };
            if (this.initialValues && this.initialValues.indexOf(option.value) > -1) this._chooseItem(item, true);
        }
        data.push(item);
    }
    _parseListGroup(option, level) {
        var item = {
            label: option.label,
            group: true,
            itemParams: option.itemParams,
            elementAttributes: option.elementAttributes,
            element: false,
            visible: true,
            level: level,
            options: [],
            original: option
        };
        option.options.forEach((child)=>{
            this._parseListItem(child, item.options, level);
        });
        return item;
    }
    _sortOptions(options) {
        var sorter;
        if (this.params.sort) {
            sorter = typeof this.params.sort === "function" ? this.params.sort : this._defaultSortFunction.bind(this);
            this._sortGroup(sorter, options);
        }
        return options;
    }
    _sortGroup(sorter, options) {
        options.sort((a, b)=>{
            return sorter(a.label, b.label, a.value, b.value, a.original, b.original);
        });
        options.forEach((option)=>{
            if (option.group) this._sortGroup(sorter, option.options);
        });
    }
    _defaultSortFunction(as, bs) {
        var a, b, a1, b1, i = 0, L, rx = /(\d+)|(\D+)/g, rd = /\d/;
        var emptyAlign = 0;
        if (this.params.sort === "desc") [as, bs] = [
            bs,
            as
        ];
        //handle empty values
        if (!as && as !== 0) emptyAlign = !bs && bs !== 0 ? 0 : -1;
        else if (!bs && bs !== 0) emptyAlign = 1;
        else {
            if (isFinite(as) && isFinite(bs)) return as - bs;
            a = String(as).toLowerCase();
            b = String(bs).toLowerCase();
            if (a === b) return 0;
            if (!(rd.test(a) && rd.test(b))) return a > b ? 1 : -1;
            a = a.match(rx);
            b = b.match(rx);
            L = a.length > b.length ? b.length : a.length;
            while(i < L){
                a1 = a[i];
                b1 = b[i++];
                if (a1 !== b1) {
                    if (isFinite(a1) && isFinite(b1)) {
                        if (a1.charAt(0) === "0") a1 = "." + a1;
                        if (b1.charAt(0) === "0") b1 = "." + b1;
                        return a1 - b1;
                    } else return a1 > b1 ? 1 : -1;
                }
            }
            return a.length > b.length;
        }
        return emptyAlign;
    }
    _filterOptions() {
        var filterFunc = this.params.filterFunc || this._defaultFilterFunc, term = this.input.value;
        if (term) {
            this.filtered = true;
            this.data.forEach((item)=>{
                this._filterItem(filterFunc, term, item);
            });
        } else this.filtered = false;
        return this.data;
    }
    _filterItem(func, term, item) {
        var matches = false;
        if (!item.group) item.visible = func(term, item.label, item.value, item.original);
        else {
            item.options.forEach((option)=>{
                if (this._filterItem(func, term, option)) matches = true;
            });
            item.visible = matches;
        }
        return item.visible;
    }
    _defaultFilterFunc(term, label, value, item) {
        term = String(term).toLowerCase();
        if (label !== null && typeof label !== "undefined") {
            if (String(label).toLowerCase().indexOf(term) > -1 || String(value).toLowerCase().indexOf(term) > -1) return true;
        }
        return false;
    }
    //////////////////////////////////////
    /////////// Display List /////////////
    //////////////////////////////////////
    _clearList() {
        while(this.listEl.firstChild)this.listEl.removeChild(this.listEl.firstChild);
        this.displayItems = [];
    }
    _buildList(data) {
        this._clearList();
        data.forEach((option)=>{
            this._buildItem(option);
        });
        if (!this.displayItems.length) this._addPlaceholder(this.params.placeholderEmpty);
    }
    _buildItem(item) {
        var el = item.element, contents;
        if (!this.filtered || item.visible) {
            if (!el) {
                el = document.createElement("div");
                el.tabIndex = 0;
                contents = this.params.itemFormatter ? this.params.itemFormatter(item.label, item.value, item.original, el) : item.label;
                if (contents instanceof HTMLElement) el.appendChild(contents);
                else el.innerHTML = contents;
                if (item.group) el.classList.add("tabulator-edit-list-group");
                else el.classList.add("tabulator-edit-list-item");
                el.classList.add("tabulator-edit-list-group-level-" + item.level);
                if (item.elementAttributes && typeof item.elementAttributes == "object") {
                    for(let key in item.elementAttributes)if (key.charAt(0) == "+") {
                        key = key.slice(1);
                        el.setAttribute(key, this.input.getAttribute(key) + item.elementAttributes["+" + key]);
                    } else el.setAttribute(key, item.elementAttributes[key]);
                }
                if (item.group) el.addEventListener("click", this._groupClick.bind(this, item));
                else el.addEventListener("click", this._itemClick.bind(this, item));
                el.addEventListener("mousedown", this._preventBlur.bind(this));
                item.element = el;
            }
            this._styleItem(item);
            this.listEl.appendChild(el);
            if (item.group) item.options.forEach((option)=>{
                this._buildItem(option);
            });
            else this.displayItems.push(item);
        }
    }
    _showList() {
        var startVis = this.popup && this.popup.isVisible();
        if (this.input.parentNode) {
            if (this.params.autocomplete && this.input.value === "" && !this.params.listOnEmpty) {
                if (this.popup) this.popup.hide(true);
                return;
            }
            this._setListWidth();
            if (!this.popup) this.popup = this.edit.popup(this.listEl);
            this.popup.show(this.cell.getElement(), "bottom");
            if (!startVis) setTimeout(()=>{
                this.popup.hideOnBlur(this._resolveValue.bind(this, true));
            }, 10);
        }
    }
    _styleItem(item) {
        if (item && item.element) {
            if (item.selected) item.element.classList.add("active");
            else item.element.classList.remove("active");
        }
    }
    //////////////////////////////////////
    ///////// User Interaction ///////////
    //////////////////////////////////////
    _itemClick(item, e) {
        e.stopPropagation();
        this._chooseItem(item);
    }
    _groupClick(item, e) {
        e.stopPropagation();
    }
    //////////////////////////////////////
    ////// Current Item Management ///////
    //////////////////////////////////////
    _cancel() {
        this.popup.hide(true);
        this.actions.cancel();
    }
    _clearChoices() {
        this.typing = true;
        this.currentItems.forEach((item)=>{
            item.selected = false;
            this._styleItem(item);
        });
        this.currentItems = [];
        this.focusedItem = null;
    }
    _chooseItem(item, silent) {
        var index;
        this.typing = false;
        if (this.params.multiselect) {
            index = this.currentItems.indexOf(item);
            if (index > -1) {
                this.currentItems.splice(index, 1);
                item.selected = false;
            } else {
                this.currentItems.push(item);
                item.selected = true;
            }
            this.input.value = this.currentItems.map((item)=>item.label).join(",");
            this._styleItem(item);
        } else {
            this.currentItems = [
                item
            ];
            item.selected = true;
            this.input.value = item.label;
            this._styleItem(item);
            if (!silent) this._resolveValue();
        }
        this._focusItem(item);
    }
    _resolveValue(blur) {
        var output, initialValue;
        if (this.popup) this.popup.hide(true);
        if (this.params.multiselect) output = this.currentItems.map((item)=>item.value);
        else {
            if (blur && this.params.autocomplete && this.typing) {
                if (this.params.freetext || this.params.allowEmpty && this.input.value === "") output = this.input.value;
                else {
                    this.actions.cancel();
                    return;
                }
            } else if (this.currentItems[0]) output = this.currentItems[0].value;
            else {
                initialValue = Array.isArray(this.initialValues) ? this.initialValues[0] : this.initialValues;
                if (initialValue === null || typeof initialValue === "undefined" || initialValue === "") output = initialValue;
                else output = this.params.emptyValue;
            }
        }
        if (output === "") output = this.params.emptyValue;
        this.actions.success(output);
        if (this.isFilter) {
            this.initialValues = output && !Array.isArray(output) ? [
                output
            ] : output;
            this.currentItems = [];
        }
    }
};
function $517dee46856d349e$var$list(cell, onRendered, success, cancel, editorParams) {
    var list = new $517dee46856d349e$var$Edit$1(this, cell, onRendered, success, cancel, editorParams);
    return list.input;
}
//star rating
function $517dee46856d349e$var$star$1(cell, onRendered, success, cancel, editorParams) {
    var self = this, element = cell.getElement(), value = cell.getValue(), maxStars = element.getElementsByTagName("svg").length || 5, size = element.getElementsByTagName("svg")[0] ? element.getElementsByTagName("svg")[0].getAttribute("width") : 14, stars = [], starsHolder = document.createElement("div"), star = document.createElementNS('http://www.w3.org/2000/svg', "svg");
    //change star type
    function starChange(val) {
        stars.forEach(function(star, i) {
            if (i < val) {
                if (self.table.browser == "ie") star.setAttribute("class", "tabulator-star-active");
                else star.classList.replace("tabulator-star-inactive", "tabulator-star-active");
                star.innerHTML = '<polygon fill="#488CE9" stroke="#014AAE" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
            } else {
                if (self.table.browser == "ie") star.setAttribute("class", "tabulator-star-inactive");
                else star.classList.replace("tabulator-star-active", "tabulator-star-inactive");
                star.innerHTML = '<polygon fill="#010155" stroke="#686868" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
            }
        });
    }
    //build stars
    function buildStar(i) {
        var starHolder = document.createElement("span");
        var nextStar = star.cloneNode(true);
        stars.push(nextStar);
        starHolder.addEventListener("mouseenter", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            starChange(i);
        });
        starHolder.addEventListener("mousemove", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        });
        starHolder.addEventListener("click", function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            success(i);
            element.blur();
        });
        starHolder.appendChild(nextStar);
        starsHolder.appendChild(starHolder);
    }
    //handle keyboard navigation value change
    function changeValue(val) {
        value = val;
        starChange(val);
    }
    //style cell
    element.style.whiteSpace = "nowrap";
    element.style.overflow = "hidden";
    element.style.textOverflow = "ellipsis";
    //style holding element
    starsHolder.style.verticalAlign = "middle";
    starsHolder.style.display = "inline-block";
    starsHolder.style.padding = "4px";
    //style star
    star.setAttribute("width", size);
    star.setAttribute("height", size);
    star.setAttribute("viewBox", "0 0 512 512");
    star.setAttribute("xml:space", "preserve");
    star.style.padding = "0 1px";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            starsHolder.setAttribute(key, starsHolder.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else starsHolder.setAttribute(key, editorParams.elementAttributes[key]);
    }
    //create correct number of stars
    for(var i = 1; i <= maxStars; i++)buildStar(i);
    //ensure value does not exceed number of stars
    value = Math.min(parseInt(value), maxStars);
    // set initial styling of stars
    starChange(value);
    starsHolder.addEventListener("mousemove", function(e) {
        starChange(0);
    });
    starsHolder.addEventListener("click", function(e) {
        success(0);
    });
    element.addEventListener("blur", function(e) {
        cancel();
    });
    //allow key based navigation
    element.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 39:
                changeValue(value + 1);
                break;
            case 37:
                changeValue(value - 1);
                break;
            case 13:
                success(value);
                break;
            case 27:
                cancel();
                break;
        }
    });
    return starsHolder;
}
//draggable progress bar
function $517dee46856d349e$var$progress$1(cell, onRendered, success, cancel, editorParams) {
    var element = cell.getElement(), max = typeof editorParams.max === "undefined" ? element.getElementsByTagName("div")[0] && element.getElementsByTagName("div")[0].getAttribute("max") || 100 : editorParams.max, min = typeof editorParams.min === "undefined" ? element.getElementsByTagName("div")[0] && element.getElementsByTagName("div")[0].getAttribute("min") || 0 : editorParams.min, percent = (max - min) / 100, value = cell.getValue() || 0, handle = document.createElement("div"), bar = document.createElement("div"), mouseDrag, mouseDragWidth;
    //set new value
    function updateValue() {
        var style = window.getComputedStyle(element, null);
        var calcVal = percent * Math.round(bar.offsetWidth / ((element.clientWidth - parseInt(style.getPropertyValue("padding-left")) - parseInt(style.getPropertyValue("padding-right"))) / 100)) + min;
        success(calcVal);
        element.setAttribute("aria-valuenow", calcVal);
        element.setAttribute("aria-label", value);
    }
    //style handle
    handle.style.position = "absolute";
    handle.style.right = "0";
    handle.style.top = "0";
    handle.style.bottom = "0";
    handle.style.width = "5px";
    handle.classList.add("tabulator-progress-handle");
    //style bar
    bar.style.display = "inline-block";
    bar.style.position = "relative";
    // bar.style.top = "8px";
    // bar.style.bottom = "8px";
    // bar.style.left = "4px";
    // bar.style.marginRight = "4px";
    bar.style.height = "100%";
    bar.style.backgroundColor = "#488CE9";
    bar.style.maxWidth = "100%";
    bar.style.minWidth = "0%";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            bar.setAttribute(key, bar.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else bar.setAttribute(key, editorParams.elementAttributes[key]);
    }
    //style cell
    element.style.padding = "4px 4px";
    //make sure value is in range
    value = Math.min(parseFloat(value), max);
    value = Math.max(parseFloat(value), min);
    //workout percentage
    value = Math.round((value - min) / percent);
    // bar.style.right = value + "%";
    bar.style.width = value + "%";
    element.setAttribute("aria-valuemin", min);
    element.setAttribute("aria-valuemax", max);
    bar.appendChild(handle);
    handle.addEventListener("mousedown", function(e) {
        mouseDrag = e.screenX;
        mouseDragWidth = bar.offsetWidth;
    });
    handle.addEventListener("mouseover", function() {
        handle.style.cursor = "ew-resize";
    });
    element.addEventListener("mousemove", function(e) {
        if (mouseDrag) bar.style.width = mouseDragWidth + e.screenX - mouseDrag + "px";
    });
    element.addEventListener("mouseup", function(e) {
        if (mouseDrag) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            mouseDrag = false;
            mouseDragWidth = false;
            updateValue();
        }
    });
    //allow key based navigation
    element.addEventListener("keydown", function(e) {
        switch(e.keyCode){
            case 39:
                e.preventDefault();
                bar.style.width = bar.clientWidth + element.clientWidth / 100 + "px";
                break;
            case 37:
                e.preventDefault();
                bar.style.width = bar.clientWidth - element.clientWidth / 100 + "px";
                break;
            case 9:
            case 13:
                updateValue();
                break;
            case 27:
                cancel();
                break;
        }
    });
    element.addEventListener("blur", function() {
        cancel();
    });
    return bar;
}
//checkbox
function $517dee46856d349e$var$tickCross$1(cell, onRendered, success, cancel, editorParams) {
    var value = cell.getValue(), input = document.createElement("input"), tristate = editorParams.tristate, indetermValue = typeof editorParams.indeterminateValue === "undefined" ? null : editorParams.indeterminateValue, indetermState = false, trueValueSet = Object.keys(editorParams).includes("trueValue"), falseValueSet = Object.keys(editorParams).includes("falseValue");
    input.setAttribute("type", "checkbox");
    input.style.marginTop = "5px";
    input.style.boxSizing = "border-box";
    if (editorParams.elementAttributes && typeof editorParams.elementAttributes == "object") {
        for(let key in editorParams.elementAttributes)if (key.charAt(0) == "+") {
            key = key.slice(1);
            input.setAttribute(key, input.getAttribute(key) + editorParams.elementAttributes["+" + key]);
        } else input.setAttribute(key, editorParams.elementAttributes[key]);
    }
    input.value = value;
    if (tristate && (typeof value === "undefined" || value === indetermValue || value === "")) {
        indetermState = true;
        input.indeterminate = true;
    }
    if (this.table.browser != "firefox" && this.table.browser != "safari") onRendered(function() {
        if (cell.getType() === "cell") input.focus({
            preventScroll: true
        });
    });
    input.checked = trueValueSet ? value === editorParams.trueValue : value === true || value === "true" || value === "True" || value === 1;
    function setValue(blur) {
        var checkedValue = input.checked;
        if (trueValueSet && checkedValue) checkedValue = editorParams.trueValue;
        else if (falseValueSet && !checkedValue) checkedValue = editorParams.falseValue;
        if (tristate) {
            if (!blur) {
                if (input.checked && !indetermState) {
                    input.checked = false;
                    input.indeterminate = true;
                    indetermState = true;
                    return indetermValue;
                } else {
                    indetermState = false;
                    return checkedValue;
                }
            } else {
                if (indetermState) return indetermValue;
                else return checkedValue;
            }
        } else return checkedValue;
    }
    //submit new value on blur
    input.addEventListener("change", function(e) {
        success(setValue());
    });
    input.addEventListener("blur", function(e) {
        success(setValue(true));
    });
    //submit new value on enter
    input.addEventListener("keydown", function(e) {
        if (e.keyCode == 13) success(setValue());
        if (e.keyCode == 27) cancel();
    });
    return input;
}
function $517dee46856d349e$var$adaptable$1(cell, onRendered, success, cancel, params) {
    var column = cell._getSelf().column, lookup, editorFunc, editorParams;
    function defaultLookup(cell) {
        var value = cell.getValue(), editor = "input";
        switch(typeof value){
            case "number":
                editor = "number";
                break;
            case "boolean":
                editor = "tickCross";
                break;
            case "string":
                if (value.includes("\n")) editor = "textarea";
                break;
        }
        return editor;
    }
    lookup = params.editorLookup ? params.editorLookup(cell) : defaultLookup(cell);
    if (params.paramsLookup) editorParams = typeof params.paramsLookup === "function" ? params.paramsLookup(lookup, cell) : params.paramsLookup[lookup];
    editorFunc = this.table.modules.edit.lookupEditor(lookup, column);
    return editorFunc.call(this, cell, onRendered, success, cancel, editorParams || {});
}
var $517dee46856d349e$var$defaultEditors = {
    input: $517dee46856d349e$var$input,
    textarea: $517dee46856d349e$var$textarea$1,
    number: $517dee46856d349e$var$number$1,
    range: $517dee46856d349e$var$range,
    date: $517dee46856d349e$var$date$1,
    time: $517dee46856d349e$var$time$1,
    datetime: $517dee46856d349e$var$datetime$2,
    list: $517dee46856d349e$var$list,
    star: $517dee46856d349e$var$star$1,
    progress: $517dee46856d349e$var$progress$1,
    tickCross: $517dee46856d349e$var$tickCross$1,
    adaptable: $517dee46856d349e$var$adaptable$1
};
class $517dee46856d349e$export$2394e2d3d2175314 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "edit";
    //load defaults
    static editors = $517dee46856d349e$var$defaultEditors;
    constructor(table){
        super(table);
        this.currentCell = false; //hold currently editing cell
        this.mouseClick = false; //hold mousedown state to prevent click binding being overridden by editor opening
        this.recursionBlock = false; //prevent focus recursion
        this.invalidEdit = false;
        this.editedCells = [];
        this.convertEmptyValues = false;
        this.editors = $517dee46856d349e$export$2394e2d3d2175314.editors;
        this.registerTableOption("editTriggerEvent", "focus");
        this.registerTableOption("editorEmptyValue");
        this.registerTableOption("editorEmptyValueFunc", this.emptyValueCheck.bind(this));
        this.registerColumnOption("editable");
        this.registerColumnOption("editor");
        this.registerColumnOption("editorParams");
        this.registerColumnOption("editorEmptyValue");
        this.registerColumnOption("editorEmptyValueFunc");
        this.registerColumnOption("cellEditing");
        this.registerColumnOption("cellEdited");
        this.registerColumnOption("cellEditCancelled");
        this.registerTableFunction("getEditedCells", this.getEditedCells.bind(this));
        this.registerTableFunction("clearCellEdited", this.clearCellEdited.bind(this));
        this.registerTableFunction("navigatePrev", this.navigatePrev.bind(this));
        this.registerTableFunction("navigateNext", this.navigateNext.bind(this));
        this.registerTableFunction("navigateLeft", this.navigateLeft.bind(this));
        this.registerTableFunction("navigateRight", this.navigateRight.bind(this));
        this.registerTableFunction("navigateUp", this.navigateUp.bind(this));
        this.registerTableFunction("navigateDown", this.navigateDown.bind(this));
        this.registerComponentFunction("cell", "isEdited", this.cellIsEdited.bind(this));
        this.registerComponentFunction("cell", "clearEdited", this.clearEdited.bind(this));
        this.registerComponentFunction("cell", "edit", this.editCell.bind(this));
        this.registerComponentFunction("cell", "cancelEdit", this.cellCancelEdit.bind(this));
        this.registerComponentFunction("cell", "navigatePrev", this.navigatePrev.bind(this));
        this.registerComponentFunction("cell", "navigateNext", this.navigateNext.bind(this));
        this.registerComponentFunction("cell", "navigateLeft", this.navigateLeft.bind(this));
        this.registerComponentFunction("cell", "navigateRight", this.navigateRight.bind(this));
        this.registerComponentFunction("cell", "navigateUp", this.navigateUp.bind(this));
        this.registerComponentFunction("cell", "navigateDown", this.navigateDown.bind(this));
    }
    initialize() {
        this.subscribe("cell-init", this.bindEditor.bind(this));
        this.subscribe("cell-delete", this.clearEdited.bind(this));
        this.subscribe("cell-value-changed", this.updateCellClass.bind(this));
        this.subscribe("column-layout", this.initializeColumnCheck.bind(this));
        this.subscribe("column-delete", this.columnDeleteCheck.bind(this));
        this.subscribe("row-deleting", this.rowDeleteCheck.bind(this));
        this.subscribe("row-layout", this.rowEditableCheck.bind(this));
        this.subscribe("data-refreshing", this.cancelEdit.bind(this));
        this.subscribe("clipboard-paste", this.pasteBlocker.bind(this));
        this.subscribe("keybinding-nav-prev", this.navigatePrev.bind(this, undefined));
        this.subscribe("keybinding-nav-next", this.keybindingNavigateNext.bind(this));
        // this.subscribe("keybinding-nav-left", this.navigateLeft.bind(this, undefined));
        // this.subscribe("keybinding-nav-right", this.navigateRight.bind(this, undefined));
        this.subscribe("keybinding-nav-up", this.navigateUp.bind(this, undefined));
        this.subscribe("keybinding-nav-down", this.navigateDown.bind(this, undefined));
        if (Object.keys(this.table.options).includes("editorEmptyValue")) this.convertEmptyValues = true;
    }
    ///////////////////////////////////
    ///////// Paste Negation //////////
    ///////////////////////////////////
    pasteBlocker(e) {
        if (this.currentCell) return true;
    }
    ///////////////////////////////////
    ////// Keybinding Functions ///////
    ///////////////////////////////////
    keybindingNavigateNext(e) {
        var cell = this.currentCell, newRow = this.options("tabEndNewRow");
        if (cell) {
            if (!this.navigateNext(cell, e)) {
                if (newRow) {
                    cell.getElement().firstChild.blur();
                    if (!this.invalidEdit) {
                        if (newRow === true) newRow = this.table.addRow({});
                        else if (typeof newRow == "function") newRow = this.table.addRow(newRow(cell.row.getComponent()));
                        else newRow = this.table.addRow(Object.assign({}, newRow));
                        newRow.then(()=>{
                            setTimeout(()=>{
                                cell.getComponent().navigateNext();
                            });
                        });
                    }
                }
            }
        }
    }
    ///////////////////////////////////
    ///////// Cell Functions //////////
    ///////////////////////////////////
    cellIsEdited(cell) {
        return !!cell.modules.edit && cell.modules.edit.edited;
    }
    cellCancelEdit(cell) {
        if (cell === this.currentCell) this.table.modules.edit.cancelEdit();
        else console.warn("Cancel Editor Error - This cell is not currently being edited ");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    updateCellClass(cell) {
        if (this.allowEdit(cell)) cell.getElement().classList.add("tabulator-editable");
        else cell.getElement().classList.remove("tabulator-editable");
    }
    clearCellEdited(cells) {
        if (!cells) cells = this.table.modules.edit.getEditedCells();
        if (!Array.isArray(cells)) cells = [
            cells
        ];
        cells.forEach((cell)=>{
            this.table.modules.edit.clearEdited(cell._getSelf());
        });
    }
    navigatePrev(cell = this.currentCell, e) {
        var nextCell, prevRow;
        if (cell) {
            if (e) e.preventDefault();
            nextCell = this.navigateLeft();
            if (nextCell) return true;
            else {
                prevRow = this.table.rowManager.prevDisplayRow(cell.row, true);
                if (prevRow) {
                    nextCell = this.findPrevEditableCell(prevRow, prevRow.cells.length);
                    if (nextCell) {
                        nextCell.getComponent().edit();
                        return true;
                    }
                }
            }
        }
        return false;
    }
    navigateNext(cell = this.currentCell, e) {
        var nextCell, nextRow;
        if (cell) {
            if (e) e.preventDefault();
            nextCell = this.navigateRight();
            if (nextCell) return true;
            else {
                nextRow = this.table.rowManager.nextDisplayRow(cell.row, true);
                if (nextRow) {
                    nextCell = this.findNextEditableCell(nextRow, -1);
                    if (nextCell) {
                        nextCell.getComponent().edit();
                        return true;
                    }
                }
            }
        }
        return false;
    }
    navigateLeft(cell = this.currentCell, e) {
        var index, nextCell;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextCell = this.findPrevEditableCell(cell.row, index);
            if (nextCell) {
                nextCell.getComponent().edit();
                return true;
            }
        }
        return false;
    }
    navigateRight(cell = this.currentCell, e) {
        var index, nextCell;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextCell = this.findNextEditableCell(cell.row, index);
            if (nextCell) {
                nextCell.getComponent().edit();
                return true;
            }
        }
        return false;
    }
    navigateUp(cell = this.currentCell, e) {
        var index, nextRow;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextRow = this.table.rowManager.prevDisplayRow(cell.row, true);
            if (nextRow) {
                nextRow.cells[index].getComponent().edit();
                return true;
            }
        }
        return false;
    }
    navigateDown(cell = this.currentCell, e) {
        var index, nextRow;
        if (cell) {
            if (e) e.preventDefault();
            index = cell.getIndex();
            nextRow = this.table.rowManager.nextDisplayRow(cell.row, true);
            if (nextRow) {
                nextRow.cells[index].getComponent().edit();
                return true;
            }
        }
        return false;
    }
    findNextEditableCell(row, index) {
        var nextCell = false;
        if (index < row.cells.length - 1) for(var i = index + 1; i < row.cells.length; i++){
            let cell = row.cells[i];
            if (cell.column.modules.edit && $517dee46856d349e$var$Helpers.elVisible(cell.getElement())) {
                let allowEdit = this.allowEdit(cell);
                if (allowEdit) {
                    nextCell = cell;
                    break;
                }
            }
        }
        return nextCell;
    }
    findPrevEditableCell(row, index) {
        var prevCell = false;
        if (index > 0) for(var i = index - 1; i >= 0; i--){
            let cell = row.cells[i];
            if (cell.column.modules.edit && $517dee46856d349e$var$Helpers.elVisible(cell.getElement())) {
                let allowEdit = this.allowEdit(cell);
                if (allowEdit) {
                    prevCell = cell;
                    break;
                }
            }
        }
        return prevCell;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumnCheck(column) {
        if (typeof column.definition.editor !== "undefined") this.initializeColumn(column);
    }
    columnDeleteCheck(column) {
        if (this.currentCell && this.currentCell.column === column) this.cancelEdit();
    }
    rowDeleteCheck(row) {
        if (this.currentCell && this.currentCell.row === row) this.cancelEdit();
    }
    rowEditableCheck(row) {
        row.getCells().forEach((cell)=>{
            if (cell.column.modules.edit && typeof cell.column.modules.edit.check === "function") this.updateCellClass(cell);
        });
    }
    //initialize column editor
    initializeColumn(column) {
        var convertEmpty = Object.keys(column.definition).includes("editorEmptyValue");
        var config = {
            editor: false,
            blocked: false,
            check: column.definition.editable,
            params: column.definition.editorParams || {},
            convertEmptyValues: convertEmpty,
            editorEmptyValue: column.definition.editorEmptyValue,
            editorEmptyValueFunc: column.definition.editorEmptyValueFunc
        };
        //set column editor
        config.editor = this.lookupEditor(column.definition.editor, column);
        if (config.editor) column.modules.edit = config;
    }
    lookupEditor(editor, column) {
        var editorFunc;
        switch(typeof editor){
            case "string":
                if (this.editors[editor]) editorFunc = this.editors[editor];
                else console.warn("Editor Error - No such editor found: ", editor);
                break;
            case "function":
                editorFunc = editor;
                break;
            case "boolean":
                if (editor === true) {
                    if (typeof column.definition.formatter !== "function") {
                        if (this.editors[column.definition.formatter]) editorFunc = this.editors[column.definition.formatter];
                        else editorFunc = this.editors["input"];
                    } else console.warn("Editor Error - Cannot auto lookup editor for a custom formatter: ", column.definition.formatter);
                }
                break;
        }
        return editorFunc;
    }
    getCurrentCell() {
        return this.currentCell ? this.currentCell.getComponent() : false;
    }
    clearEditor(cancel) {
        var cell = this.currentCell, cellEl;
        this.invalidEdit = false;
        if (cell) {
            this.currentCell = false;
            cellEl = cell.getElement();
            this.dispatch("edit-editor-clear", cell, cancel);
            cellEl.classList.remove("tabulator-editing");
            while(cellEl.firstChild)cellEl.removeChild(cellEl.firstChild);
            cell.row.getElement().classList.remove("tabulator-editing");
            cell.table.element.classList.remove("tabulator-editing");
        }
    }
    cancelEdit() {
        if (this.currentCell) {
            var cell = this.currentCell;
            var component = this.currentCell.getComponent();
            this.clearEditor(true);
            cell.setValueActual(cell.getValue());
            cell.cellRendered();
            if (cell.column.definition.editor == "textarea" || cell.column.definition.variableHeight) cell.row.normalizeHeight(true);
            if (cell.column.definition.cellEditCancelled) cell.column.definition.cellEditCancelled.call(this.table, component);
            this.dispatch("edit-cancelled", cell);
            this.dispatchExternal("cellEditCancelled", component);
        }
    }
    //return a formatted value for a cell
    bindEditor(cell) {
        if (cell.column.modules.edit) {
            var self = this, element = cell.getElement(true);
            this.updateCellClass(cell);
            element.setAttribute("tabindex", 0);
            element.addEventListener("mousedown", function(e) {
                if (e.button === 2) e.preventDefault();
                else self.mouseClick = true;
            });
            if (this.options("editTriggerEvent") === "dblclick") element.addEventListener("dblclick", function(e) {
                if (!element.classList.contains("tabulator-editing")) {
                    element.focus({
                        preventScroll: true
                    });
                    self.edit(cell, e, false);
                }
            });
            if (this.options("editTriggerEvent") === "focus" || this.options("editTriggerEvent") === "click") element.addEventListener("click", function(e) {
                if (!element.classList.contains("tabulator-editing")) {
                    element.focus({
                        preventScroll: true
                    });
                    self.edit(cell, e, false);
                }
            });
            if (this.options("editTriggerEvent") === "focus") element.addEventListener("focus", function(e) {
                if (!self.recursionBlock) self.edit(cell, e, false);
            });
        }
    }
    focusCellNoEvent(cell, block) {
        this.recursionBlock = true;
        if (!(block && this.table.browser === "ie")) cell.getElement().focus({
            preventScroll: true
        });
        this.recursionBlock = false;
    }
    editCell(cell, forceEdit) {
        this.focusCellNoEvent(cell);
        this.edit(cell, false, forceEdit);
    }
    focusScrollAdjust(cell) {
        if (this.table.rowManager.getRenderMode() == "virtual") {
            var topEdge = this.table.rowManager.element.scrollTop, bottomEdge = this.table.rowManager.element.clientHeight + this.table.rowManager.element.scrollTop, rowEl = cell.row.getElement();
            if (rowEl.offsetTop < topEdge) this.table.rowManager.element.scrollTop -= topEdge - rowEl.offsetTop;
            else if (rowEl.offsetTop + rowEl.offsetHeight > bottomEdge) this.table.rowManager.element.scrollTop += rowEl.offsetTop + rowEl.offsetHeight - bottomEdge;
            var leftEdge = this.table.rowManager.element.scrollLeft, rightEdge = this.table.rowManager.element.clientWidth + this.table.rowManager.element.scrollLeft, cellEl = cell.getElement();
            if (this.table.modExists("frozenColumns")) {
                leftEdge += parseInt(this.table.modules.frozenColumns.leftMargin || 0);
                rightEdge -= parseInt(this.table.modules.frozenColumns.rightMargin || 0);
            }
            if (this.table.options.renderHorizontal === "virtual") {
                leftEdge -= parseInt(this.table.columnManager.renderer.vDomPadLeft);
                rightEdge -= parseInt(this.table.columnManager.renderer.vDomPadLeft);
            }
            if (cellEl.offsetLeft < leftEdge) this.table.rowManager.element.scrollLeft -= leftEdge - cellEl.offsetLeft;
            else if (cellEl.offsetLeft + cellEl.offsetWidth > rightEdge) this.table.rowManager.element.scrollLeft += cellEl.offsetLeft + cellEl.offsetWidth - rightEdge;
        }
    }
    allowEdit(cell) {
        var check = cell.column.modules.edit ? true : false;
        if (cell.column.modules.edit) switch(typeof cell.column.modules.edit.check){
            case "function":
                if (cell.row.initialized) check = cell.column.modules.edit.check(cell.getComponent());
                break;
            case "string":
                check = !!cell.row.data[cell.column.modules.edit.check];
                break;
            case "boolean":
                check = cell.column.modules.edit.check;
                break;
        }
        return check;
    }
    edit(cell, e, forceEdit) {
        var self = this, allowEdit = true, rendered = function() {}, element = cell.getElement(), editFinished = false, cellEditor, component, params;
        //prevent editing if another cell is refusing to leave focus (eg. validation fail)
        if (this.currentCell) {
            if (!this.invalidEdit && this.currentCell !== cell) this.cancelEdit();
            return;
        }
        //handle successful value change
        function success(value) {
            if (self.currentCell === cell && !editFinished) {
                var valid = self.chain("edit-success", [
                    cell,
                    value
                ], true, true);
                if (valid === true || self.table.options.validationMode === "highlight") {
                    editFinished = true;
                    self.clearEditor();
                    if (!cell.modules.edit) cell.modules.edit = {};
                    cell.modules.edit.edited = true;
                    if (self.editedCells.indexOf(cell) == -1) self.editedCells.push(cell);
                    value = self.transformEmptyValues(value, cell);
                    cell.setValue(value, true);
                    return valid === true;
                } else {
                    editFinished = true;
                    self.invalidEdit = true;
                    self.focusCellNoEvent(cell, true);
                    rendered();
                    setTimeout(()=>{
                        editFinished = false;
                    }, 10);
                    return false;
                }
            }
        }
        //handle aborted edit
        function cancel() {
            // editFinished = true;
            if (self.currentCell === cell && !editFinished) self.cancelEdit();
        }
        function onRendered(callback) {
            rendered = callback;
        }
        if (!cell.column.modules.edit.blocked) {
            if (e) e.stopPropagation();
            allowEdit = this.allowEdit(cell);
            if (allowEdit || forceEdit) {
                self.cancelEdit();
                self.currentCell = cell;
                this.focusScrollAdjust(cell);
                component = cell.getComponent();
                if (this.mouseClick) {
                    this.mouseClick = false;
                    if (cell.column.definition.cellClick) cell.column.definition.cellClick.call(this.table, e, component);
                }
                if (cell.column.definition.cellEditing) cell.column.definition.cellEditing.call(this.table, component);
                this.dispatch("cell-editing", cell);
                this.dispatchExternal("cellEditing", component);
                params = typeof cell.column.modules.edit.params === "function" ? cell.column.modules.edit.params(component) : cell.column.modules.edit.params;
                cellEditor = cell.column.modules.edit.editor.call(self, component, onRendered, success, cancel, params);
                //if editor returned, add to DOM, if false, abort edit
                if (this.currentCell && cellEditor !== false) {
                    if (cellEditor instanceof Node) {
                        element.classList.add("tabulator-editing");
                        cell.row.getElement().classList.add("tabulator-editing");
                        cell.table.element.classList.add("tabulator-editing");
                        while(element.firstChild)element.removeChild(element.firstChild);
                        element.appendChild(cellEditor);
                        //trigger onRendered Callback
                        rendered();
                        //prevent editing from triggering rowClick event
                        var children = element.children;
                        for(var i = 0; i < children.length; i++)children[i].addEventListener("click", function(e) {
                            e.stopPropagation();
                        });
                    } else {
                        console.warn("Edit Error - Editor should return an instance of Node, the editor returned:", cellEditor);
                        this.blur(element);
                        return false;
                    }
                } else {
                    this.blur(element);
                    return false;
                }
                return true;
            } else {
                this.mouseClick = false;
                this.blur(element);
                return false;
            }
        } else {
            this.mouseClick = false;
            this.blur(element);
            return false;
        }
    }
    emptyValueCheck(value) {
        return value === "" || value === null || typeof value === "undefined";
    }
    transformEmptyValues(value, cell) {
        var mod = cell.column.modules.edit, convert = mod.convertEmptyValues || this.convertEmptyValues, checkFunc;
        if (convert) {
            checkFunc = mod.editorEmptyValueFunc || this.options("editorEmptyValueFunc");
            if (checkFunc && checkFunc(value)) value = mod.convertEmptyValues ? mod.editorEmptyValue : this.options("editorEmptyValue");
        }
        return value;
    }
    blur(element) {
        if (!this.confirm("edit-blur", [
            element
        ])) element.blur();
    }
    getEditedCells() {
        var output = [];
        this.editedCells.forEach((cell)=>{
            output.push(cell.getComponent());
        });
        return output;
    }
    clearEdited(cell) {
        var editIndex;
        if (cell.modules.edit && cell.modules.edit.edited) {
            cell.modules.edit.edited = false;
            this.dispatch("edit-edited-clear", cell);
        }
        editIndex = this.editedCells.indexOf(cell);
        if (editIndex > -1) this.editedCells.splice(editIndex, 1);
    }
}
class $517dee46856d349e$var$ExportRow {
    constructor(type, columns, component, indent){
        this.type = type;
        this.columns = columns;
        this.component = component || false;
        this.indent = indent || 0;
    }
}
class $517dee46856d349e$var$ExportColumn {
    constructor(value, component, width, height, depth){
        this.value = value;
        this.component = component || false;
        this.width = width;
        this.height = height;
        this.depth = depth;
    }
}
var $517dee46856d349e$var$columnLookups$1 = {};
var $517dee46856d349e$var$rowLookups$1 = {
    visible: function() {
        return this.rowManager.getVisibleRows(false, true);
    },
    all: function() {
        return this.rowManager.rows;
    },
    selected: function() {
        return this.modules.selectRow.selectedRows;
    },
    active: function() {
        if (this.options.pagination) return this.rowManager.getDisplayRows(this.rowManager.displayRows.length - 2);
        else return this.rowManager.getDisplayRows();
    }
};
class $517dee46856d349e$export$4e0f34fd9829977c extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "export";
    static columnLookups = $517dee46856d349e$var$columnLookups$1;
    static rowLookups = $517dee46856d349e$var$rowLookups$1;
    constructor(table){
        super(table);
        this.config = {};
        this.cloneTableStyle = true;
        this.colVisProp = "";
        this.colVisPropAttach = "";
        this.registerTableOption("htmlOutputConfig", false); //html output config
        this.registerColumnOption("htmlOutput");
        this.registerColumnOption("titleHtmlOutput");
    }
    initialize() {
        this.registerTableFunction("getHtml", this.getHtml.bind(this));
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    generateExportList(config, style, range, colVisProp) {
        var headers, body, columns, colLookup;
        this.cloneTableStyle = style;
        this.config = config || {};
        this.colVisProp = colVisProp;
        this.colVisPropAttach = this.colVisProp.charAt(0).toUpperCase() + this.colVisProp.slice(1);
        colLookup = $517dee46856d349e$export$4e0f34fd9829977c.columnLookups[range];
        if (colLookup) {
            columns = colLookup.call(this.table);
            columns = columns.filter((col)=>this.columnVisCheck(col));
        }
        headers = this.config.columnHeaders !== false ? this.headersToExportRows(this.generateColumnGroupHeaders(columns)) : [];
        if (columns) columns = columns.map((col)=>col.getComponent());
        body = this.bodyToExportRows(this.rowLookup(range), columns);
        return headers.concat(body);
    }
    generateTable(config, style, range, colVisProp) {
        var list = this.generateExportList(config, style, range, colVisProp);
        return this.generateTableElement(list);
    }
    rowLookup(range) {
        var rows = [], rowLookup;
        if (typeof range == "function") range.call(this.table).forEach((row)=>{
            row = this.table.rowManager.findRow(row);
            if (row) rows.push(row);
        });
        else {
            rowLookup = $517dee46856d349e$export$4e0f34fd9829977c.rowLookups[range] || $517dee46856d349e$export$4e0f34fd9829977c.rowLookups["active"];
            rows = rowLookup.call(this.table);
        }
        return Object.assign([], rows);
    }
    generateColumnGroupHeaders(columns) {
        var output = [];
        if (!columns) columns = this.config.columnGroups !== false ? this.table.columnManager.columns : this.table.columnManager.columnsByIndex;
        columns.forEach((column)=>{
            var colData = this.processColumnGroup(column);
            if (colData) output.push(colData);
        });
        return output;
    }
    processColumnGroup(column) {
        var subGroups = column.columns, maxDepth = 0, title = column.definition["title" + this.colVisPropAttach] || column.definition.title;
        var groupData = {
            title: title,
            column: column,
            depth: 1
        };
        if (subGroups.length) {
            groupData.subGroups = [];
            groupData.width = 0;
            subGroups.forEach((subGroup)=>{
                var subGroupData = this.processColumnGroup(subGroup);
                if (subGroupData) {
                    groupData.width += subGroupData.width;
                    groupData.subGroups.push(subGroupData);
                    if (subGroupData.depth > maxDepth) maxDepth = subGroupData.depth;
                }
            });
            groupData.depth += maxDepth;
            if (!groupData.width) return false;
        } else {
            if (this.columnVisCheck(column)) groupData.width = 1;
            else return false;
        }
        return groupData;
    }
    columnVisCheck(column) {
        var visProp = column.definition[this.colVisProp];
        if (this.config.rowHeaders === false && column.isRowHeader) return false;
        if (typeof visProp === "function") visProp = visProp.call(this.table, column.getComponent());
        if (visProp === false || visProp === true) return visProp;
        return column.visible && column.field;
    }
    headersToExportRows(columns) {
        var headers = [], headerDepth = 0, exportRows = [];
        function parseColumnGroup(column, level) {
            var depth = headerDepth - level;
            if (typeof headers[level] === "undefined") headers[level] = [];
            column.height = column.subGroups ? 1 : depth - column.depth + 1;
            headers[level].push(column);
            if (column.height > 1) for(let i = 1; i < column.height; i++){
                if (typeof headers[level + i] === "undefined") headers[level + i] = [];
                headers[level + i].push(false);
            }
            if (column.width > 1) for(let i = 1; i < column.width; i++)headers[level].push(false);
            if (column.subGroups) column.subGroups.forEach(function(subGroup) {
                parseColumnGroup(subGroup, level + 1);
            });
        }
        //calculate maximum header depth
        columns.forEach(function(column) {
            if (column.depth > headerDepth) headerDepth = column.depth;
        });
        columns.forEach(function(column) {
            parseColumnGroup(column, 0);
        });
        headers.forEach((header)=>{
            var columns = [];
            header.forEach((col)=>{
                if (col) {
                    let title = typeof col.title === "undefined" ? "" : col.title;
                    columns.push(new $517dee46856d349e$var$ExportColumn(title, col.column.getComponent(), col.width, col.height, col.depth));
                } else columns.push(null);
            });
            exportRows.push(new $517dee46856d349e$var$ExportRow("header", columns));
        });
        return exportRows;
    }
    bodyToExportRows(rows, columns = []) {
        var exportRows = [];
        if (columns.length === 0) this.table.columnManager.columnsByIndex.forEach((column)=>{
            if (this.columnVisCheck(column)) columns.push(column.getComponent());
        });
        if (this.config.columnCalcs !== false && this.table.modExists("columnCalcs")) {
            if (this.table.modules.columnCalcs.topInitialized) rows.unshift(this.table.modules.columnCalcs.topRow);
            if (this.table.modules.columnCalcs.botInitialized) rows.push(this.table.modules.columnCalcs.botRow);
        }
        rows = rows.filter((row)=>{
            switch(row.type){
                case "group":
                    return this.config.rowGroups !== false;
                case "calc":
                    return this.config.columnCalcs !== false;
                case "row":
                    return !(this.table.options.dataTree && this.config.dataTree === false && row.modules.dataTree.parent);
            }
            return true;
        });
        rows.forEach((row, i)=>{
            var rowData = row.getData(this.colVisProp);
            var exportCols = [];
            var indent = 0;
            switch(row.type){
                case "group":
                    indent = row.level;
                    exportCols.push(new $517dee46856d349e$var$ExportColumn(row.key, row.getComponent(), columns.length, 1));
                    break;
                case "calc":
                case "row":
                    columns.forEach((col)=>{
                        exportCols.push(new $517dee46856d349e$var$ExportColumn(col._column.getFieldValue(rowData), col, 1, 1));
                    });
                    if (this.table.options.dataTree && this.config.dataTree !== false) indent = row.modules.dataTree.index;
                    break;
            }
            exportRows.push(new $517dee46856d349e$var$ExportRow(row.type, exportCols, row.getComponent(), indent));
        });
        return exportRows;
    }
    generateTableElement(list) {
        var table = document.createElement("table"), headerEl = document.createElement("thead"), bodyEl = document.createElement("tbody"), styles = this.lookupTableStyles(), rowFormatter = this.table.options["rowFormatter" + this.colVisPropAttach], setup = {};
        setup.rowFormatter = rowFormatter !== null ? rowFormatter : this.table.options.rowFormatter;
        if (this.table.options.dataTree && this.config.dataTree !== false && this.table.modExists("columnCalcs")) setup.treeElementField = this.table.modules.dataTree.elementField;
        //assign group header formatter
        setup.groupHeader = this.table.options["groupHeader" + this.colVisPropAttach];
        if (setup.groupHeader && !Array.isArray(setup.groupHeader)) setup.groupHeader = [
            setup.groupHeader
        ];
        table.classList.add("tabulator-print-table");
        this.mapElementStyles(this.table.columnManager.getHeadersElement(), headerEl, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom",
            "background-color",
            "color",
            "font-weight",
            "font-family",
            "font-size"
        ]);
        if (list.length > 1000) console.warn("It may take a long time to render an HTML table with more than 1000 rows");
        list.forEach((row, i)=>{
            let rowEl;
            switch(row.type){
                case "header":
                    headerEl.appendChild(this.generateHeaderElement(row, setup, styles));
                    break;
                case "group":
                    bodyEl.appendChild(this.generateGroupElement(row, setup, styles));
                    break;
                case "calc":
                    bodyEl.appendChild(this.generateCalcElement(row, setup, styles));
                    break;
                case "row":
                    rowEl = this.generateRowElement(row, setup, styles);
                    this.mapElementStyles(i % 2 && styles.evenRow ? styles.evenRow : styles.oddRow, rowEl, [
                        "border-top",
                        "border-left",
                        "border-right",
                        "border-bottom",
                        "color",
                        "font-weight",
                        "font-family",
                        "font-size",
                        "background-color"
                    ]);
                    bodyEl.appendChild(rowEl);
                    break;
            }
        });
        if (headerEl.innerHTML) table.appendChild(headerEl);
        table.appendChild(bodyEl);
        this.mapElementStyles(this.table.element, table, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom"
        ]);
        return table;
    }
    lookupTableStyles() {
        var styles = {};
        //lookup row styles
        if (this.cloneTableStyle && window.getComputedStyle) {
            styles.oddRow = this.table.element.querySelector(".tabulator-row-odd:not(.tabulator-group):not(.tabulator-calcs)");
            styles.evenRow = this.table.element.querySelector(".tabulator-row-even:not(.tabulator-group):not(.tabulator-calcs)");
            styles.calcRow = this.table.element.querySelector(".tabulator-row.tabulator-calcs");
            styles.firstRow = this.table.element.querySelector(".tabulator-row:not(.tabulator-group):not(.tabulator-calcs)");
            styles.firstGroup = this.table.element.getElementsByClassName("tabulator-group")[0];
            if (styles.firstRow) {
                styles.styleCells = styles.firstRow.getElementsByClassName("tabulator-cell");
                styles.styleRowHeader = styles.firstRow.getElementsByClassName("tabulator-row-header")[0];
                styles.firstCell = styles.styleCells[0];
                styles.lastCell = styles.styleCells[styles.styleCells.length - 1];
            }
        }
        return styles;
    }
    generateHeaderElement(row, setup, styles) {
        var rowEl = document.createElement("tr");
        row.columns.forEach((column)=>{
            if (column) {
                var cellEl = document.createElement("th");
                var classNames = column.component._column.definition.cssClass ? column.component._column.definition.cssClass.split(" ") : [];
                cellEl.colSpan = column.width;
                cellEl.rowSpan = column.height;
                cellEl.innerHTML = column.value;
                if (this.cloneTableStyle) cellEl.style.boxSizing = "border-box";
                classNames.forEach(function(className) {
                    cellEl.classList.add(className);
                });
                this.mapElementStyles(column.component.getElement(), cellEl, [
                    "text-align",
                    "border-left",
                    "border-right",
                    "background-color",
                    "color",
                    "font-weight",
                    "font-family",
                    "font-size"
                ]);
                this.mapElementStyles(column.component._column.contentElement, cellEl, [
                    "padding-top",
                    "padding-left",
                    "padding-right",
                    "padding-bottom"
                ]);
                if (column.component._column.visible) this.mapElementStyles(column.component.getElement(), cellEl, [
                    "width"
                ]);
                else if (column.component._column.definition.width) cellEl.style.width = column.component._column.definition.width + "px";
                if (column.component._column.parent && column.component._column.parent.isGroup) this.mapElementStyles(column.component._column.parent.groupElement, cellEl, [
                    "border-top"
                ]);
                else this.mapElementStyles(column.component.getElement(), cellEl, [
                    "border-top"
                ]);
                if (column.component._column.isGroup) this.mapElementStyles(column.component.getElement(), cellEl, [
                    "border-bottom"
                ]);
                else this.mapElementStyles(this.table.columnManager.getElement(), cellEl, [
                    "border-bottom"
                ]);
                rowEl.appendChild(cellEl);
            }
        });
        return rowEl;
    }
    generateGroupElement(row, setup, styles) {
        var rowEl = document.createElement("tr"), cellEl = document.createElement("td"), group = row.columns[0];
        rowEl.classList.add("tabulator-print-table-row");
        if (setup.groupHeader && setup.groupHeader[row.indent]) group.value = setup.groupHeader[row.indent](group.value, row.component._group.getRowCount(), row.component._group.getData(), row.component);
        else if (setup.groupHeader !== false) group.value = row.component._group.generator(group.value, row.component._group.getRowCount(), row.component._group.getData(), row.component);
        cellEl.colSpan = group.width;
        cellEl.innerHTML = group.value;
        rowEl.classList.add("tabulator-print-table-group");
        rowEl.classList.add("tabulator-group-level-" + row.indent);
        if (group.component.isVisible()) rowEl.classList.add("tabulator-group-visible");
        this.mapElementStyles(styles.firstGroup, rowEl, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom",
            "color",
            "font-weight",
            "font-family",
            "font-size",
            "background-color"
        ]);
        this.mapElementStyles(styles.firstGroup, cellEl, [
            "padding-top",
            "padding-left",
            "padding-right",
            "padding-bottom"
        ]);
        rowEl.appendChild(cellEl);
        return rowEl;
    }
    generateCalcElement(row, setup, styles) {
        var rowEl = this.generateRowElement(row, setup, styles);
        rowEl.classList.add("tabulator-print-table-calcs");
        this.mapElementStyles(styles.calcRow, rowEl, [
            "border-top",
            "border-left",
            "border-right",
            "border-bottom",
            "color",
            "font-weight",
            "font-family",
            "font-size",
            "background-color"
        ]);
        return rowEl;
    }
    generateRowElement(row, setup, styles) {
        var rowEl = document.createElement("tr");
        rowEl.classList.add("tabulator-print-table-row");
        row.columns.forEach((col, i)=>{
            if (col) {
                var cellEl = document.createElement("td"), column = col.component._column, table = this.table, index = table.columnManager.findColumnIndex(column), value = col.value, cellStyle, styleProps;
                var cellWrapper = {
                    modules: {},
                    getValue: function() {
                        return value;
                    },
                    getField: function() {
                        return column.definition.field;
                    },
                    getElement: function() {
                        return cellEl;
                    },
                    getType: function() {
                        return "cell";
                    },
                    getColumn: function() {
                        return column.getComponent();
                    },
                    getData: function() {
                        return row.component.getData();
                    },
                    getRow: function() {
                        return row.component;
                    },
                    getTable: function() {
                        return table;
                    },
                    getComponent: function() {
                        return cellWrapper;
                    },
                    column: column
                };
                var classNames = column.definition.cssClass ? column.definition.cssClass.split(" ") : [];
                classNames.forEach(function(className) {
                    cellEl.classList.add(className);
                });
                if (this.table.modExists("format") && this.config.formatCells !== false) value = this.table.modules.format.formatExportValue(cellWrapper, this.colVisProp);
                else switch(typeof value){
                    case "object":
                        value = value !== null ? JSON.stringify(value) : "";
                        break;
                    case "undefined":
                        value = "";
                        break;
                }
                if (value instanceof Node) cellEl.appendChild(value);
                else cellEl.innerHTML = value;
                styleProps = [
                    "padding-top",
                    "padding-left",
                    "padding-right",
                    "padding-bottom",
                    "border-top",
                    "border-left",
                    "border-right",
                    "border-bottom",
                    "color",
                    "font-weight",
                    "font-family",
                    "font-size",
                    "text-align"
                ];
                if (column.isRowHeader) {
                    cellStyle = styles.styleRowHeader;
                    styleProps.push("background-color");
                } else cellStyle = styles.styleCells && styles.styleCells[index] ? styles.styleCells[index] : styles.firstCell;
                if (cellStyle) {
                    this.mapElementStyles(cellStyle, cellEl, styleProps);
                    if (column.definition.align) cellEl.style.textAlign = column.definition.align;
                }
                if (this.table.options.dataTree && this.config.dataTree !== false) {
                    if (setup.treeElementField && setup.treeElementField == column.field || !setup.treeElementField && i == 0) {
                        if (row.component._row.modules.dataTree.controlEl) cellEl.insertBefore(row.component._row.modules.dataTree.controlEl.cloneNode(true), cellEl.firstChild);
                        if (row.component._row.modules.dataTree.branchEl) cellEl.insertBefore(row.component._row.modules.dataTree.branchEl.cloneNode(true), cellEl.firstChild);
                    }
                }
                rowEl.appendChild(cellEl);
                if (cellWrapper.modules.format && cellWrapper.modules.format.renderedCallback) cellWrapper.modules.format.renderedCallback();
            }
        });
        if (setup.rowFormatter && row.type === "row" && this.config.formatCells !== false) {
            let formatComponent = Object.assign(row.component);
            formatComponent.getElement = function() {
                return rowEl;
            };
            setup.rowFormatter(row.component);
        }
        return rowEl;
    }
    generateHTMLTable(list) {
        var holder = document.createElement("div");
        holder.appendChild(this.generateTableElement(list));
        return holder.innerHTML;
    }
    getHtml(visible, style, config, colVisProp) {
        var list = this.generateExportList(config || this.table.options.htmlOutputConfig, style, visible, colVisProp || "htmlOutput");
        return this.generateHTMLTable(list);
    }
    mapElementStyles(from, to, props) {
        if (this.cloneTableStyle && from && to) {
            var lookup = {
                "background-color": "backgroundColor",
                "color": "fontColor",
                "width": "width",
                "font-weight": "fontWeight",
                "font-family": "fontFamily",
                "font-size": "fontSize",
                "text-align": "textAlign",
                "border-top": "borderTop",
                "border-left": "borderLeft",
                "border-right": "borderRight",
                "border-bottom": "borderBottom",
                "padding-top": "paddingTop",
                "padding-left": "paddingLeft",
                "padding-right": "paddingRight",
                "padding-bottom": "paddingBottom"
            };
            if (window.getComputedStyle) {
                var fromStyle = window.getComputedStyle(from);
                props.forEach(function(prop) {
                    if (!to.style[lookup[prop]]) to.style[lookup[prop]] = fromStyle.getPropertyValue(prop);
                });
            }
        }
    }
}
var $517dee46856d349e$var$defaultFilters = {
    //equal to
    "=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal == filterVal ? true : false;
    },
    //less than
    "<": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal < filterVal ? true : false;
    },
    //less than or equal to
    "<=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal <= filterVal ? true : false;
    },
    //greater than
    ">": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal > filterVal ? true : false;
    },
    //greater than or equal to
    ">=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal >= filterVal ? true : false;
    },
    //not equal to
    "!=": function(filterVal, rowVal, rowData, filterParams) {
        return rowVal != filterVal ? true : false;
    },
    "regex": function(filterVal, rowVal, rowData, filterParams) {
        if (typeof filterVal == "string") filterVal = new RegExp(filterVal);
        return filterVal.test(rowVal);
    },
    //contains the string
    "like": function(filterVal, rowVal, rowData, filterParams) {
        if (filterVal === null || typeof filterVal === "undefined") return rowVal === filterVal ? true : false;
        else {
            if (typeof rowVal !== 'undefined' && rowVal !== null) return String(rowVal).toLowerCase().indexOf(filterVal.toLowerCase()) > -1;
            else return false;
        }
    },
    //contains the keywords
    "keywords": function(filterVal, rowVal, rowData, filterParams) {
        var keywords = filterVal.toLowerCase().split(typeof filterParams.separator === "undefined" ? " " : filterParams.separator), value = String(rowVal === null || typeof rowVal === "undefined" ? "" : rowVal).toLowerCase(), matches = [];
        keywords.forEach((keyword)=>{
            if (value.includes(keyword)) matches.push(true);
        });
        return filterParams.matchAll ? matches.length === keywords.length : !!matches.length;
    },
    //starts with the string
    "starts": function(filterVal, rowVal, rowData, filterParams) {
        if (filterVal === null || typeof filterVal === "undefined") return rowVal === filterVal ? true : false;
        else {
            if (typeof rowVal !== 'undefined' && rowVal !== null) return String(rowVal).toLowerCase().startsWith(filterVal.toLowerCase());
            else return false;
        }
    },
    //ends with the string
    "ends": function(filterVal, rowVal, rowData, filterParams) {
        if (filterVal === null || typeof filterVal === "undefined") return rowVal === filterVal ? true : false;
        else {
            if (typeof rowVal !== 'undefined' && rowVal !== null) return String(rowVal).toLowerCase().endsWith(filterVal.toLowerCase());
            else return false;
        }
    },
    //in array
    "in": function(filterVal, rowVal, rowData, filterParams) {
        if (Array.isArray(filterVal)) return filterVal.length ? filterVal.indexOf(rowVal) > -1 : true;
        else {
            console.warn("Filter Error - filter value is not an array:", filterVal);
            return false;
        }
    }
};
class $517dee46856d349e$export$2e3bebbdf3339a4e extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "filter";
    //load defaults
    static filters = $517dee46856d349e$var$defaultFilters;
    constructor(table){
        super(table);
        this.filterList = []; //hold filter list
        this.headerFilters = {}; //hold column filters
        this.headerFilterColumns = []; //hold columns that use header filters
        this.prevHeaderFilterChangeCheck = "";
        this.prevHeaderFilterChangeCheck = "{}";
        this.changed = false; //has filtering changed since last render
        this.tableInitialized = false;
        this.registerTableOption("filterMode", "local"); //local or remote filtering
        this.registerTableOption("initialFilter", false); //initial filtering criteria
        this.registerTableOption("initialHeaderFilter", false); //initial header filtering criteria
        this.registerTableOption("headerFilterLiveFilterDelay", 300); //delay before updating column after user types in header filter
        this.registerTableOption("placeholderHeaderFilter", false); //placeholder when header filter is empty
        this.registerColumnOption("headerFilter");
        this.registerColumnOption("headerFilterPlaceholder");
        this.registerColumnOption("headerFilterParams");
        this.registerColumnOption("headerFilterEmptyCheck");
        this.registerColumnOption("headerFilterFunc");
        this.registerColumnOption("headerFilterFuncParams");
        this.registerColumnOption("headerFilterLiveFilter");
        this.registerTableFunction("searchRows", this.searchRows.bind(this));
        this.registerTableFunction("searchData", this.searchData.bind(this));
        this.registerTableFunction("setFilter", this.userSetFilter.bind(this));
        this.registerTableFunction("refreshFilter", this.userRefreshFilter.bind(this));
        this.registerTableFunction("addFilter", this.userAddFilter.bind(this));
        this.registerTableFunction("getFilters", this.getFilters.bind(this));
        this.registerTableFunction("setHeaderFilterFocus", this.userSetHeaderFilterFocus.bind(this));
        this.registerTableFunction("getHeaderFilterValue", this.userGetHeaderFilterValue.bind(this));
        this.registerTableFunction("setHeaderFilterValue", this.userSetHeaderFilterValue.bind(this));
        this.registerTableFunction("getHeaderFilters", this.getHeaderFilters.bind(this));
        this.registerTableFunction("removeFilter", this.userRemoveFilter.bind(this));
        this.registerTableFunction("clearFilter", this.userClearFilter.bind(this));
        this.registerTableFunction("clearHeaderFilter", this.userClearHeaderFilter.bind(this));
        this.registerComponentFunction("column", "headerFilterFocus", this.setHeaderFilterFocus.bind(this));
        this.registerComponentFunction("column", "reloadHeaderFilter", this.reloadHeaderFilter.bind(this));
        this.registerComponentFunction("column", "getHeaderFilterValue", this.getHeaderFilterValue.bind(this));
        this.registerComponentFunction("column", "setHeaderFilterValue", this.setHeaderFilterValue.bind(this));
    }
    initialize() {
        this.subscribe("column-init", this.initializeColumnHeaderFilter.bind(this));
        this.subscribe("column-width-fit-before", this.hideHeaderFilterElements.bind(this));
        this.subscribe("column-width-fit-after", this.showHeaderFilterElements.bind(this));
        this.subscribe("table-built", this.tableBuilt.bind(this));
        this.subscribe("placeholder", this.generatePlaceholder.bind(this));
        if (this.table.options.filterMode === "remote") this.subscribe("data-params", this.remoteFilterParams.bind(this));
        this.registerDataHandler(this.filter.bind(this), 10);
    }
    tableBuilt() {
        if (this.table.options.initialFilter) this.setFilter(this.table.options.initialFilter);
        if (this.table.options.initialHeaderFilter) this.table.options.initialHeaderFilter.forEach((item)=>{
            var column = this.table.columnManager.findColumn(item.field);
            if (column) this.setHeaderFilterValue(column, item.value);
            else {
                console.warn("Column Filter Error - No matching column found:", item.field);
                return false;
            }
        });
        this.tableInitialized = true;
    }
    remoteFilterParams(data, config, silent, params) {
        params.filter = this.getFilters(true, true);
        return params;
    }
    generatePlaceholder(text) {
        if (this.table.options.placeholderHeaderFilter && Object.keys(this.headerFilters).length) return this.table.options.placeholderHeaderFilter;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    //set standard filters
    userSetFilter(field, type, value, params) {
        this.setFilter(field, type, value, params);
        this.refreshFilter();
    }
    //set standard filters
    userRefreshFilter() {
        this.refreshFilter();
    }
    //add filter to array
    userAddFilter(field, type, value, params) {
        this.addFilter(field, type, value, params);
        this.refreshFilter();
    }
    userSetHeaderFilterFocus(field) {
        var column = this.table.columnManager.findColumn(field);
        if (column) this.setHeaderFilterFocus(column);
        else {
            console.warn("Column Filter Focus Error - No matching column found:", field);
            return false;
        }
    }
    userGetHeaderFilterValue(field) {
        var column = this.table.columnManager.findColumn(field);
        if (column) return this.getHeaderFilterValue(column);
        else console.warn("Column Filter Error - No matching column found:", field);
    }
    userSetHeaderFilterValue(field, value) {
        var column = this.table.columnManager.findColumn(field);
        if (column) this.setHeaderFilterValue(column, value);
        else {
            console.warn("Column Filter Error - No matching column found:", field);
            return false;
        }
    }
    //remove filter from array
    userRemoveFilter(field, type, value) {
        this.removeFilter(field, type, value);
        this.refreshFilter();
    }
    //clear filters
    userClearFilter(all) {
        this.clearFilter(all);
        this.refreshFilter();
    }
    //clear header filters
    userClearHeaderFilter() {
        this.clearHeaderFilter();
        this.refreshFilter();
    }
    //search for specific row components
    searchRows(field, type, value) {
        return this.search("rows", field, type, value);
    }
    //search for specific data
    searchData(field, type, value) {
        return this.search("data", field, type, value);
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumnHeaderFilter(column) {
        var def = column.definition;
        if (def.headerFilter) this.initializeColumn(column);
    }
    //initialize column header filter
    initializeColumn(column, value) {
        var self = this, field = column.getField();
        //handle successfully value change
        function success(value) {
            var filterType = column.modules.filter.tagType == "input" && column.modules.filter.attrType == "text" || column.modules.filter.tagType == "textarea" ? "partial" : "match", type = "", filterChangeCheck = "", filterFunc;
            if (typeof column.modules.filter.prevSuccess === "undefined" || column.modules.filter.prevSuccess !== value) {
                column.modules.filter.prevSuccess = value;
                if (!column.modules.filter.emptyFunc(value)) {
                    column.modules.filter.value = value;
                    switch(typeof column.definition.headerFilterFunc){
                        case "string":
                            if ($517dee46856d349e$export$2e3bebbdf3339a4e.filters[column.definition.headerFilterFunc]) {
                                type = column.definition.headerFilterFunc;
                                filterFunc = function(data) {
                                    var params = column.definition.headerFilterFuncParams || {};
                                    var fieldVal = column.getFieldValue(data);
                                    params = typeof params === "function" ? params(value, fieldVal, data) : params;
                                    return $517dee46856d349e$export$2e3bebbdf3339a4e.filters[column.definition.headerFilterFunc](value, fieldVal, data, params);
                                };
                            } else console.warn("Header Filter Error - Matching filter function not found: ", column.definition.headerFilterFunc);
                            break;
                        case "function":
                            filterFunc = function(data) {
                                var params = column.definition.headerFilterFuncParams || {};
                                var fieldVal = column.getFieldValue(data);
                                params = typeof params === "function" ? params(value, fieldVal, data) : params;
                                return column.definition.headerFilterFunc(value, fieldVal, data, params);
                            };
                            type = filterFunc;
                            break;
                    }
                    if (!filterFunc) switch(filterType){
                        case "partial":
                            filterFunc = function(data) {
                                var colVal = column.getFieldValue(data);
                                if (typeof colVal !== 'undefined' && colVal !== null) return String(colVal).toLowerCase().indexOf(String(value).toLowerCase()) > -1;
                                else return false;
                            };
                            type = "like";
                            break;
                        default:
                            filterFunc = function(data) {
                                return column.getFieldValue(data) == value;
                            };
                            type = "=";
                    }
                    self.headerFilters[field] = {
                        value: value,
                        func: filterFunc,
                        type: type
                    };
                } else delete self.headerFilters[field];
                column.modules.filter.value = value;
                filterChangeCheck = JSON.stringify(self.headerFilters);
                if (self.prevHeaderFilterChangeCheck !== filterChangeCheck) {
                    self.prevHeaderFilterChangeCheck = filterChangeCheck;
                    self.trackChanges();
                    self.refreshFilter();
                }
            }
            return true;
        }
        column.modules.filter = {
            success: success,
            attrType: false,
            tagType: false,
            emptyFunc: false
        };
        this.generateHeaderFilterElement(column);
    }
    generateHeaderFilterElement(column, initialValue, reinitialize) {
        var self = this, success = column.modules.filter.success, field = column.getField(), filterElement, editor, editorElement, cellWrapper, typingTimer, searchTrigger, params, onRenderedCallback;
        column.modules.filter.value = initialValue;
        //handle aborted edit
        function cancel() {}
        function onRendered(callback) {
            onRenderedCallback = callback;
        }
        if (column.modules.filter.headerElement && column.modules.filter.headerElement.parentNode) column.contentElement.removeChild(column.modules.filter.headerElement.parentNode);
        if (field) {
            //set empty value function
            column.modules.filter.emptyFunc = column.definition.headerFilterEmptyCheck || function(value) {
                return !value && value !== 0;
            };
            filterElement = document.createElement("div");
            filterElement.classList.add("tabulator-header-filter");
            //set column editor
            switch(typeof column.definition.headerFilter){
                case "string":
                    if (self.table.modules.edit.editors[column.definition.headerFilter]) {
                        editor = self.table.modules.edit.editors[column.definition.headerFilter];
                        if ((column.definition.headerFilter === "tick" || column.definition.headerFilter === "tickCross") && !column.definition.headerFilterEmptyCheck) column.modules.filter.emptyFunc = function(value) {
                            return value !== true && value !== false;
                        };
                    } else console.warn("Filter Error - Cannot build header filter, No such editor found: ", column.definition.editor);
                    break;
                case "function":
                    editor = column.definition.headerFilter;
                    break;
                case "boolean":
                    if (column.modules.edit && column.modules.edit.editor) editor = column.modules.edit.editor;
                    else if (column.definition.formatter && self.table.modules.edit.editors[column.definition.formatter]) {
                        editor = self.table.modules.edit.editors[column.definition.formatter];
                        if ((column.definition.formatter === "tick" || column.definition.formatter === "tickCross") && !column.definition.headerFilterEmptyCheck) column.modules.filter.emptyFunc = function(value) {
                            return value !== true && value !== false;
                        };
                    } else editor = self.table.modules.edit.editors["input"];
                    break;
            }
            if (editor) {
                cellWrapper = {
                    getValue: function() {
                        return typeof initialValue !== "undefined" ? initialValue : "";
                    },
                    getField: function() {
                        return column.definition.field;
                    },
                    getElement: function() {
                        return filterElement;
                    },
                    getColumn: function() {
                        return column.getComponent();
                    },
                    getTable: ()=>{
                        return this.table;
                    },
                    getType: ()=>{
                        return "header";
                    },
                    getRow: function() {
                        return {
                            normalizeHeight: function() {}
                        };
                    }
                };
                params = column.definition.headerFilterParams || {};
                params = typeof params === "function" ? params.call(self.table, cellWrapper) : params;
                editorElement = editor.call(this.table.modules.edit, cellWrapper, onRendered, success, cancel, params);
                if (!editorElement) {
                    console.warn("Filter Error - Cannot add filter to " + field + " column, editor returned a value of false");
                    return;
                }
                if (!(editorElement instanceof Node)) {
                    console.warn("Filter Error - Cannot add filter to " + field + " column, editor should return an instance of Node, the editor returned:", editorElement);
                    return;
                }
                //set Placeholder Text
                self.langBind("headerFilters|columns|" + column.definition.field, function(value) {
                    editorElement.setAttribute("placeholder", typeof value !== "undefined" && value ? value : column.definition.headerFilterPlaceholder || self.langText("headerFilters|default"));
                });
                //focus on element on click
                editorElement.addEventListener("click", function(e) {
                    e.stopPropagation();
                    editorElement.focus();
                });
                editorElement.addEventListener("focus", (e)=>{
                    var left = this.table.columnManager.contentsElement.scrollLeft;
                    var headerPos = this.table.rowManager.element.scrollLeft;
                    if (left !== headerPos) {
                        this.table.rowManager.scrollHorizontal(left);
                        this.table.columnManager.scrollHorizontal(left);
                    }
                });
                //live update filters as user types
                typingTimer = false;
                searchTrigger = function(e) {
                    if (typingTimer) clearTimeout(typingTimer);
                    typingTimer = setTimeout(function() {
                        success(editorElement.value);
                    }, self.table.options.headerFilterLiveFilterDelay);
                };
                column.modules.filter.headerElement = editorElement;
                column.modules.filter.attrType = editorElement.hasAttribute("type") ? editorElement.getAttribute("type").toLowerCase() : "";
                column.modules.filter.tagType = editorElement.tagName.toLowerCase();
                if (column.definition.headerFilterLiveFilter !== false) {
                    if (!(column.definition.headerFilter === 'autocomplete' || column.definition.headerFilter === 'tickCross' || (column.definition.editor === 'autocomplete' || column.definition.editor === 'tickCross') && column.definition.headerFilter === true)) {
                        editorElement.addEventListener("keyup", searchTrigger);
                        editorElement.addEventListener("search", searchTrigger);
                        //update number filtered columns on change
                        if (column.modules.filter.attrType == "number") editorElement.addEventListener("change", function(e) {
                            success(editorElement.value);
                        });
                        //change text inputs to search inputs to allow for clearing of field
                        if (column.modules.filter.attrType == "text" && this.table.browser !== "ie") editorElement.setAttribute("type", "search");
                    }
                    //prevent input and select elements from propagating click to column sorters etc
                    if (column.modules.filter.tagType == "input" || column.modules.filter.tagType == "select" || column.modules.filter.tagType == "textarea") editorElement.addEventListener("mousedown", function(e) {
                        e.stopPropagation();
                    });
                }
                filterElement.appendChild(editorElement);
                column.contentElement.appendChild(filterElement);
                if (!reinitialize) self.headerFilterColumns.push(column);
                if (onRenderedCallback) onRenderedCallback();
            }
        } else console.warn("Filter Error - Cannot add header filter, column has no field set:", column.definition.title);
    }
    //hide all header filter elements (used to ensure correct column widths in "fitData" layout mode)
    hideHeaderFilterElements() {
        this.headerFilterColumns.forEach(function(column) {
            if (column.modules.filter && column.modules.filter.headerElement) column.modules.filter.headerElement.style.display = 'none';
        });
    }
    //show all header filter elements (used to ensure correct column widths in "fitData" layout mode)
    showHeaderFilterElements() {
        this.headerFilterColumns.forEach(function(column) {
            if (column.modules.filter && column.modules.filter.headerElement) column.modules.filter.headerElement.style.display = '';
        });
    }
    //programmatically set focus of header filter
    setHeaderFilterFocus(column) {
        if (column.modules.filter && column.modules.filter.headerElement) column.modules.filter.headerElement.focus();
        else console.warn("Column Filter Focus Error - No header filter set on column:", column.getField());
    }
    //programmatically get value of header filter
    getHeaderFilterValue(column) {
        if (column.modules.filter && column.modules.filter.headerElement) return column.modules.filter.value;
        else console.warn("Column Filter Error - No header filter set on column:", column.getField());
    }
    //programmatically set value of header filter
    setHeaderFilterValue(column, value) {
        if (column) {
            if (column.modules.filter && column.modules.filter.headerElement) {
                this.generateHeaderFilterElement(column, value, true);
                column.modules.filter.success(value);
            } else console.warn("Column Filter Error - No header filter set on column:", column.getField());
        }
    }
    reloadHeaderFilter(column) {
        if (column) {
            if (column.modules.filter && column.modules.filter.headerElement) this.generateHeaderFilterElement(column, column.modules.filter.value, true);
            else console.warn("Column Filter Error - No header filter set on column:", column.getField());
        }
    }
    refreshFilter() {
        if (this.tableInitialized) {
            if (this.table.options.filterMode === "remote") this.reloadData(null, false, false);
            else this.refreshData(true);
        }
    //TODO - Persist left position of row manager
    // left = this.scrollLeft;
    // this.scrollHorizontal(left);
    }
    //check if the filters has changed since last use
    trackChanges() {
        this.changed = true;
        this.dispatch("filter-changed");
    }
    //check if the filters has changed since last use
    hasChanged() {
        var changed = this.changed;
        this.changed = false;
        return changed;
    }
    //set standard filters
    setFilter(field, type, value, params) {
        this.filterList = [];
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value,
                params: params
            }
        ];
        this.addFilter(field);
    }
    //add filter to array
    addFilter(field, type, value, params) {
        var changed = false;
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value,
                params: params
            }
        ];
        field.forEach((filter)=>{
            filter = this.findFilter(filter);
            if (filter) {
                this.filterList.push(filter);
                changed = true;
            }
        });
        if (changed) this.trackChanges();
    }
    findFilter(filter) {
        var column;
        if (Array.isArray(filter)) return this.findSubFilters(filter);
        var filterFunc = false;
        if (typeof filter.field == "function") filterFunc = function(data) {
            return filter.field(data, filter.type || {}); // pass params to custom filter function
        };
        else if ($517dee46856d349e$export$2e3bebbdf3339a4e.filters[filter.type]) {
            column = this.table.columnManager.getColumnByField(filter.field);
            if (column) filterFunc = function(data) {
                return $517dee46856d349e$export$2e3bebbdf3339a4e.filters[filter.type](filter.value, column.getFieldValue(data), data, filter.params || {});
            };
            else filterFunc = function(data) {
                return $517dee46856d349e$export$2e3bebbdf3339a4e.filters[filter.type](filter.value, data[filter.field], data, filter.params || {});
            };
        } else console.warn("Filter Error - No such filter type found, ignoring: ", filter.type);
        filter.func = filterFunc;
        return filter.func ? filter : false;
    }
    findSubFilters(filters) {
        var output = [];
        filters.forEach((filter)=>{
            filter = this.findFilter(filter);
            if (filter) output.push(filter);
        });
        return output.length ? output : false;
    }
    //get all filters
    getFilters(all, ajax) {
        var output = [];
        if (all) output = this.getHeaderFilters();
        if (ajax) output.forEach(function(item) {
            if (typeof item.type == "function") item.type = "function";
        });
        output = output.concat(this.filtersToArray(this.filterList, ajax));
        return output;
    }
    //filter to Object
    filtersToArray(filterList, ajax) {
        var output = [];
        filterList.forEach((filter)=>{
            var item;
            if (Array.isArray(filter)) output.push(this.filtersToArray(filter, ajax));
            else {
                item = {
                    field: filter.field,
                    type: filter.type,
                    value: filter.value
                };
                if (ajax) {
                    if (typeof item.type == "function") item.type = "function";
                }
                output.push(item);
            }
        });
        return output;
    }
    //get all filters
    getHeaderFilters() {
        var output = [];
        for(var key in this.headerFilters)output.push({
            field: key,
            type: this.headerFilters[key].type,
            value: this.headerFilters[key].value
        });
        return output;
    }
    //remove filter from array
    removeFilter(field, type, value) {
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value
            }
        ];
        field.forEach((filter)=>{
            var index = -1;
            if (typeof filter.field == "object") index = this.filterList.findIndex((element)=>{
                return filter === element;
            });
            else index = this.filterList.findIndex((element)=>{
                return filter.field === element.field && filter.type === element.type && filter.value === element.value;
            });
            if (index > -1) this.filterList.splice(index, 1);
            else console.warn("Filter Error - No matching filter type found, ignoring: ", filter.type);
        });
        this.trackChanges();
    }
    //clear filters
    clearFilter(all) {
        this.filterList = [];
        if (all) this.clearHeaderFilter();
        this.trackChanges();
    }
    //clear header filters
    clearHeaderFilter() {
        this.headerFilters = {};
        this.prevHeaderFilterChangeCheck = "{}";
        this.headerFilterColumns.forEach((column)=>{
            if (typeof column.modules.filter.value !== "undefined") delete column.modules.filter.value;
            column.modules.filter.prevSuccess = undefined;
            this.reloadHeaderFilter(column);
        });
        this.trackChanges();
    }
    //search data and return matching rows
    search(searchType, field, type, value) {
        var activeRows = [], filterList = [];
        if (!Array.isArray(field)) field = [
            {
                field: field,
                type: type,
                value: value
            }
        ];
        field.forEach((filter)=>{
            filter = this.findFilter(filter);
            if (filter) filterList.push(filter);
        });
        this.table.rowManager.rows.forEach((row)=>{
            var match = true;
            filterList.forEach((filter)=>{
                if (!this.filterRecurse(filter, row.getData())) match = false;
            });
            if (match) activeRows.push(searchType === "data" ? row.getData("data") : row.getComponent());
        });
        return activeRows;
    }
    //filter row array
    filter(rowList, filters) {
        var activeRows = [], activeRowComponents = [];
        if (this.subscribedExternal("dataFiltering")) this.dispatchExternal("dataFiltering", this.getFilters(true));
        if (this.table.options.filterMode !== "remote" && (this.filterList.length || Object.keys(this.headerFilters).length)) rowList.forEach((row)=>{
            if (this.filterRow(row)) activeRows.push(row);
        });
        else activeRows = rowList.slice(0);
        if (this.subscribedExternal("dataFiltered")) {
            activeRows.forEach((row)=>{
                activeRowComponents.push(row.getComponent());
            });
            this.dispatchExternal("dataFiltered", this.getFilters(true), activeRowComponents);
        }
        return activeRows;
    }
    //filter individual row
    filterRow(row, filters) {
        var match = true, data = row.getData();
        this.filterList.forEach((filter)=>{
            if (!this.filterRecurse(filter, data)) match = false;
        });
        for(var field in this.headerFilters)if (!this.headerFilters[field].func(data)) match = false;
        return match;
    }
    filterRecurse(filter, data) {
        var match = false;
        if (Array.isArray(filter)) filter.forEach((subFilter)=>{
            if (this.filterRecurse(subFilter, data)) match = true;
        });
        else match = filter.func(data);
        return match;
    }
}
function $517dee46856d349e$var$plaintext(cell, formatterParams, onRendered) {
    return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
}
function $517dee46856d349e$var$html(cell, formatterParams, onRendered) {
    return cell.getValue();
}
function $517dee46856d349e$var$textarea(cell, formatterParams, onRendered) {
    cell.getElement().style.whiteSpace = "pre-wrap";
    return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
}
function $517dee46856d349e$var$money(cell, formatterParams, onRendered) {
    var floatVal = parseFloat(cell.getValue()), sign = "", number, integer, decimal, rgx, value;
    var decimalSym = formatterParams.decimal || ".";
    var thousandSym = formatterParams.thousand || ",";
    var negativeSign = formatterParams.negativeSign || "-";
    var symbol = formatterParams.symbol || "";
    var after = !!formatterParams.symbolAfter;
    var precision = typeof formatterParams.precision !== "undefined" ? formatterParams.precision : 2;
    if (isNaN(floatVal)) return this.emptyToSpace(this.sanitizeHTML(cell.getValue()));
    if (floatVal < 0) {
        floatVal = Math.abs(floatVal);
        sign = negativeSign;
    }
    number = precision !== false ? floatVal.toFixed(precision) : floatVal;
    number = String(number).split(".");
    integer = number[0];
    decimal = number.length > 1 ? decimalSym + number[1] : "";
    if (formatterParams.thousand !== false) {
        rgx = /(\d+)(\d{3})/;
        while(rgx.test(integer))integer = integer.replace(rgx, "$1" + thousandSym + "$2");
    }
    value = integer + decimal;
    if (sign === true) {
        value = "(" + value + ")";
        return after ? value + symbol : symbol + value;
    } else return after ? sign + value + symbol : sign + symbol + value;
}
function $517dee46856d349e$var$link(cell, formatterParams, onRendered) {
    var value = cell.getValue(), urlPrefix = formatterParams.urlPrefix || "", download = formatterParams.download, label = value, el = document.createElement("a"), data;
    function labelTraverse(path, data) {
        var item = path.shift(), value = data[item];
        if (path.length && typeof value === "object") return labelTraverse(path, value);
        return value;
    }
    if (formatterParams.labelField) {
        data = cell.getData();
        label = labelTraverse(formatterParams.labelField.split(this.table.options.nestedFieldSeparator), data);
    }
    if (formatterParams.label) switch(typeof formatterParams.label){
        case "string":
            label = formatterParams.label;
            break;
        case "function":
            label = formatterParams.label(cell);
            break;
    }
    if (label) {
        if (formatterParams.urlField) {
            data = cell.getData();
            value = $517dee46856d349e$var$Helpers.retrieveNestedData(this.table.options.nestedFieldSeparator, formatterParams.urlField, data);
        }
        if (formatterParams.url) switch(typeof formatterParams.url){
            case "string":
                value = formatterParams.url;
                break;
            case "function":
                value = formatterParams.url(cell);
                break;
        }
        el.setAttribute("href", urlPrefix + value);
        if (formatterParams.target) el.setAttribute("target", formatterParams.target);
        if (formatterParams.download) {
            if (typeof download == "function") download = download(cell);
            else download = download === true ? "" : download;
            el.setAttribute("download", download);
        }
        el.innerHTML = this.emptyToSpace(this.sanitizeHTML(label));
        return el;
    } else return "&nbsp;";
}
function $517dee46856d349e$var$image(cell, formatterParams, onRendered) {
    var el = document.createElement("img"), src = cell.getValue();
    if (formatterParams.urlPrefix) src = formatterParams.urlPrefix + cell.getValue();
    if (formatterParams.urlSuffix) src = src + formatterParams.urlSuffix;
    el.setAttribute("src", src);
    switch(typeof formatterParams.height){
        case "number":
            el.style.height = formatterParams.height + "px";
            break;
        case "string":
            el.style.height = formatterParams.height;
            break;
    }
    switch(typeof formatterParams.width){
        case "number":
            el.style.width = formatterParams.width + "px";
            break;
        case "string":
            el.style.width = formatterParams.width;
            break;
    }
    el.addEventListener("load", function() {
        cell.getRow().normalizeHeight();
    });
    return el;
}
function $517dee46856d349e$var$tickCross(cell, formatterParams, onRendered) {
    var value = cell.getValue(), element = cell.getElement(), empty = formatterParams.allowEmpty, truthy = formatterParams.allowTruthy, trueValueSet = Object.keys(formatterParams).includes("trueValue"), tick = typeof formatterParams.tickElement !== "undefined" ? formatterParams.tickElement : '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#2DC214" clip-rule="evenodd" d="M21.652,3.211c-0.293-0.295-0.77-0.295-1.061,0L9.41,14.34  c-0.293,0.297-0.771,0.297-1.062,0L3.449,9.351C3.304,9.203,3.114,9.13,2.923,9.129C2.73,9.128,2.534,9.201,2.387,9.351  l-2.165,1.946C0.078,11.445,0,11.63,0,11.823c0,0.194,0.078,0.397,0.223,0.544l4.94,5.184c0.292,0.296,0.771,0.776,1.062,1.07  l2.124,2.141c0.292,0.293,0.769,0.293,1.062,0l14.366-14.34c0.293-0.294,0.293-0.777,0-1.071L21.652,3.211z" fill-rule="evenodd"/></svg>', cross = typeof formatterParams.crossElement !== "undefined" ? formatterParams.crossElement : '<svg enable-background="new 0 0 24 24" height="14" width="14"  viewBox="0 0 24 24" xml:space="preserve" ><path fill="#CE1515" d="M22.245,4.015c0.313,0.313,0.313,0.826,0,1.139l-6.276,6.27c-0.313,0.312-0.313,0.826,0,1.14l6.273,6.272  c0.313,0.313,0.313,0.826,0,1.14l-2.285,2.277c-0.314,0.312-0.828,0.312-1.142,0l-6.271-6.271c-0.313-0.313-0.828-0.313-1.141,0  l-6.276,6.267c-0.313,0.313-0.828,0.313-1.141,0l-2.282-2.28c-0.313-0.313-0.313-0.826,0-1.14l6.278-6.269  c0.313-0.312,0.313-0.826,0-1.14L1.709,5.147c-0.314-0.313-0.314-0.827,0-1.14l2.284-2.278C4.308,1.417,4.821,1.417,5.135,1.73  L11.405,8c0.314,0.314,0.828,0.314,1.141,0.001l6.276-6.267c0.312-0.312,0.826-0.312,1.141,0L22.245,4.015z"/></svg>';
    if (trueValueSet && value === formatterParams.trueValue || !trueValueSet && (truthy && value || value === true || value === "true" || value === "True" || value === 1 || value === "1")) {
        element.setAttribute("aria-checked", true);
        return tick || "";
    } else if (empty && (value === "null" || value === "" || value === null || typeof value === "undefined")) {
        element.setAttribute("aria-checked", "mixed");
        return "";
    } else {
        element.setAttribute("aria-checked", false);
        return cross || "";
    }
}
function $517dee46856d349e$var$datetime$1(cell, formatterParams, onRendered) {
    var DT = this.table.dependencyRegistry.lookup([
        "luxon",
        "DateTime"
    ], "DateTime");
    var inputFormat = formatterParams.inputFormat || "yyyy-MM-dd HH:mm:ss";
    var outputFormat = formatterParams.outputFormat || "dd/MM/yyyy HH:mm:ss";
    var invalid = typeof formatterParams.invalidPlaceholder !== "undefined" ? formatterParams.invalidPlaceholder : "";
    var value = cell.getValue();
    if (typeof DT != "undefined") {
        var newDatetime;
        if (DT.isDateTime(value)) newDatetime = value;
        else if (inputFormat === "iso") newDatetime = DT.fromISO(String(value));
        else newDatetime = DT.fromFormat(String(value), inputFormat);
        if (newDatetime.isValid) {
            if (formatterParams.timezone) newDatetime = newDatetime.setZone(formatterParams.timezone);
            return newDatetime.toFormat(outputFormat);
        } else {
            if (invalid === true || !value) return value;
            else if (typeof invalid === "function") return invalid(value);
            else return invalid;
        }
    } else console.error("Format Error - 'datetime' formatter is dependant on luxon.js");
}
function $517dee46856d349e$var$datetimediff(cell, formatterParams, onRendered) {
    var DT = this.table.dependencyRegistry.lookup([
        "luxon",
        "DateTime"
    ], "DateTime");
    var inputFormat = formatterParams.inputFormat || "yyyy-MM-dd HH:mm:ss";
    var invalid = typeof formatterParams.invalidPlaceholder !== "undefined" ? formatterParams.invalidPlaceholder : "";
    var suffix = typeof formatterParams.suffix !== "undefined" ? formatterParams.suffix : false;
    var unit = typeof formatterParams.unit !== "undefined" ? formatterParams.unit : "days";
    var humanize = typeof formatterParams.humanize !== "undefined" ? formatterParams.humanize : false;
    var date = typeof formatterParams.date !== "undefined" ? formatterParams.date : DT.now();
    var value = cell.getValue();
    if (typeof DT != "undefined") {
        var newDatetime;
        if (DT.isDateTime(value)) newDatetime = value;
        else if (inputFormat === "iso") newDatetime = DT.fromISO(String(value));
        else newDatetime = DT.fromFormat(String(value), inputFormat);
        if (newDatetime.isValid) {
            if (humanize) return newDatetime.diff(date, unit).toHuman() + (suffix ? " " + suffix : "");
            else return parseInt(newDatetime.diff(date, unit)[unit]) + (suffix ? " " + suffix : "");
        } else {
            if (invalid === true) return value;
            else if (typeof invalid === "function") return invalid(value);
            else return invalid;
        }
    } else console.error("Format Error - 'datetimediff' formatter is dependant on luxon.js");
}
function $517dee46856d349e$var$lookup(cell, formatterParams, onRendered) {
    var value = cell.getValue();
    if (typeof formatterParams[value] === "undefined") {
        console.warn('Missing display value for ' + value);
        return value;
    }
    return formatterParams[value];
}
function $517dee46856d349e$var$star(cell, formatterParams, onRendered) {
    var value = cell.getValue(), element = cell.getElement(), maxStars = formatterParams && formatterParams.stars ? formatterParams.stars : 5, stars = document.createElement("span"), star = document.createElementNS('http://www.w3.org/2000/svg', "svg"), starActive = '<polygon fill="#FFEA00" stroke="#C1AB60" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>', starInactive = '<polygon fill="#D2D2D2" stroke="#686868" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
    //style stars holder
    stars.style.verticalAlign = "middle";
    //style star
    star.setAttribute("width", "14");
    star.setAttribute("height", "14");
    star.setAttribute("viewBox", "0 0 512 512");
    star.setAttribute("xml:space", "preserve");
    star.style.padding = "0 1px";
    value = value && !isNaN(value) ? parseInt(value) : 0;
    value = Math.max(0, Math.min(value, maxStars));
    for(var i = 1; i <= maxStars; i++){
        var nextStar = star.cloneNode(true);
        nextStar.innerHTML = i <= value ? starActive : starInactive;
        stars.appendChild(nextStar);
    }
    element.style.whiteSpace = "nowrap";
    element.style.overflow = "hidden";
    element.style.textOverflow = "ellipsis";
    element.setAttribute("aria-label", value);
    return stars;
}
function $517dee46856d349e$var$traffic(cell, formatterParams, onRendered) {
    var value = this.sanitizeHTML(cell.getValue()) || 0, el = document.createElement("span"), max = formatterParams && formatterParams.max ? formatterParams.max : 100, min = formatterParams && formatterParams.min ? formatterParams.min : 0, colors = formatterParams && typeof formatterParams.color !== "undefined" ? formatterParams.color : [
        "red",
        "orange",
        "green"
    ], color = "#666666", percent, percentValue;
    if (isNaN(value) || typeof cell.getValue() === "undefined") return;
    el.classList.add("tabulator-traffic-light");
    //make sure value is in range
    percentValue = parseFloat(value) <= max ? parseFloat(value) : max;
    percentValue = parseFloat(percentValue) >= min ? parseFloat(percentValue) : min;
    //workout percentage
    percent = (max - min) / 100;
    percentValue = Math.round((percentValue - min) / percent);
    //set color
    switch(typeof colors){
        case "string":
            color = colors;
            break;
        case "function":
            color = colors(value);
            break;
        case "object":
            if (Array.isArray(colors)) {
                var unit = 100 / colors.length;
                var index = Math.floor(percentValue / unit);
                index = Math.min(index, colors.length - 1);
                index = Math.max(index, 0);
                color = colors[index];
                break;
            }
    }
    el.style.backgroundColor = color;
    return el;
}
function $517dee46856d349e$var$progress(cell, formatterParams = {}, onRendered) {
    var value = this.sanitizeHTML(cell.getValue()) || 0, element = cell.getElement(), max = formatterParams.max ? formatterParams.max : 100, min = formatterParams.min ? formatterParams.min : 0, legendAlign = formatterParams.legendAlign ? formatterParams.legendAlign : "center", percent, percentValue, color, legend, legendColor;
    //make sure value is in range
    percentValue = parseFloat(value) <= max ? parseFloat(value) : max;
    percentValue = parseFloat(percentValue) >= min ? parseFloat(percentValue) : min;
    //workout percentage
    percent = (max - min) / 100;
    percentValue = Math.round((percentValue - min) / percent);
    //set bar color
    switch(typeof formatterParams.color){
        case "string":
            color = formatterParams.color;
            break;
        case "function":
            color = formatterParams.color(value);
            break;
        case "object":
            if (Array.isArray(formatterParams.color)) {
                let unit = 100 / formatterParams.color.length;
                let index = Math.floor(percentValue / unit);
                index = Math.min(index, formatterParams.color.length - 1);
                index = Math.max(index, 0);
                color = formatterParams.color[index];
                break;
            }
        default:
            color = "#2DC214";
    }
    //generate legend
    switch(typeof formatterParams.legend){
        case "string":
            legend = formatterParams.legend;
            break;
        case "function":
            legend = formatterParams.legend(value);
            break;
        case "boolean":
            legend = value;
            break;
        default:
            legend = false;
    }
    //set legend color
    switch(typeof formatterParams.legendColor){
        case "string":
            legendColor = formatterParams.legendColor;
            break;
        case "function":
            legendColor = formatterParams.legendColor(value);
            break;
        case "object":
            if (Array.isArray(formatterParams.legendColor)) {
                let unit = 100 / formatterParams.legendColor.length;
                let index = Math.floor(percentValue / unit);
                index = Math.min(index, formatterParams.legendColor.length - 1);
                index = Math.max(index, 0);
                legendColor = formatterParams.legendColor[index];
            }
            break;
        default:
            legendColor = "#000";
    }
    element.style.minWidth = "30px";
    element.style.position = "relative";
    element.setAttribute("aria-label", percentValue);
    var barEl = document.createElement("div");
    barEl.style.display = "inline-block";
    barEl.style.width = percentValue + "%";
    barEl.style.backgroundColor = color;
    barEl.style.height = "100%";
    barEl.setAttribute('data-max', max);
    barEl.setAttribute('data-min', min);
    var barContainer = document.createElement("div");
    barContainer.style.position = "relative";
    barContainer.style.width = "100%";
    barContainer.style.height = "100%";
    if (legend) {
        var legendEl = document.createElement("div");
        legendEl.style.position = "absolute";
        legendEl.style.top = 0;
        legendEl.style.left = 0;
        legendEl.style.textAlign = legendAlign;
        legendEl.style.width = "100%";
        legendEl.style.color = legendColor;
        legendEl.innerHTML = legend;
    }
    onRendered(function() {
        //handle custom element needed if formatter is to be included in printed/downloaded output
        if (!(cell instanceof $517dee46856d349e$export$1919f52c249c72c9)) {
            var holderEl = document.createElement("div");
            holderEl.style.position = "absolute";
            holderEl.style.top = "4px";
            holderEl.style.bottom = "4px";
            holderEl.style.left = "4px";
            holderEl.style.right = "4px";
            element.appendChild(holderEl);
            element = holderEl;
        }
        element.appendChild(barContainer);
        barContainer.appendChild(barEl);
        if (legend) barContainer.appendChild(legendEl);
    });
    return "";
}
function $517dee46856d349e$var$color(cell, formatterParams, onRendered) {
    cell.getElement().style.backgroundColor = this.sanitizeHTML(cell.getValue());
    return "";
}
function $517dee46856d349e$var$buttonTick(cell, formatterParams, onRendered) {
    return '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#2DC214" clip-rule="evenodd" d="M21.652,3.211c-0.293-0.295-0.77-0.295-1.061,0L9.41,14.34  c-0.293,0.297-0.771,0.297-1.062,0L3.449,9.351C3.304,9.203,3.114,9.13,2.923,9.129C2.73,9.128,2.534,9.201,2.387,9.351  l-2.165,1.946C0.078,11.445,0,11.63,0,11.823c0,0.194,0.078,0.397,0.223,0.544l4.94,5.184c0.292,0.296,0.771,0.776,1.062,1.07  l2.124,2.141c0.292,0.293,0.769,0.293,1.062,0l14.366-14.34c0.293-0.294,0.293-0.777,0-1.071L21.652,3.211z" fill-rule="evenodd"/></svg>';
}
function $517dee46856d349e$var$buttonCross(cell, formatterParams, onRendered) {
    return '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#CE1515" d="M22.245,4.015c0.313,0.313,0.313,0.826,0,1.139l-6.276,6.27c-0.313,0.312-0.313,0.826,0,1.14l6.273,6.272  c0.313,0.313,0.313,0.826,0,1.14l-2.285,2.277c-0.314,0.312-0.828,0.312-1.142,0l-6.271-6.271c-0.313-0.313-0.828-0.313-1.141,0  l-6.276,6.267c-0.313,0.313-0.828,0.313-1.141,0l-2.282-2.28c-0.313-0.313-0.313-0.826,0-1.14l6.278-6.269  c0.313-0.312,0.313-0.826,0-1.14L1.709,5.147c-0.314-0.313-0.314-0.827,0-1.14l2.284-2.278C4.308,1.417,4.821,1.417,5.135,1.73  L11.405,8c0.314,0.314,0.828,0.314,1.141,0.001l6.276-6.267c0.312-0.312,0.826-0.312,1.141,0L22.245,4.015z"/></svg>';
}
function $517dee46856d349e$var$toggle(cell, formatterParams, onRendered) {
    var value = cell.getValue(), size = formatterParams.size || 15, sizePx = size + "px", containEl, switchEl, onValue = formatterParams.hasOwnProperty("onValue") ? formatterParams.onValue : true, offValue = formatterParams.hasOwnProperty("offValue") ? formatterParams.offValue : false, state = formatterParams.onTruthy ? value : value === onValue;
    containEl = document.createElement("div");
    containEl.classList.add("tabulator-toggle");
    if (state) {
        containEl.classList.add("tabulator-toggle-on");
        containEl.style.flexDirection = "row-reverse";
        if (formatterParams.onColor) containEl.style.background = formatterParams.onColor;
    } else if (formatterParams.offColor) containEl.style.background = formatterParams.offColor;
    containEl.style.width = 2.5 * size + "px";
    containEl.style.borderRadius = sizePx;
    if (formatterParams.clickable) containEl.addEventListener("click", (e)=>{
        cell.setValue(state ? offValue : onValue);
    });
    switchEl = document.createElement("div");
    switchEl.classList.add("tabulator-toggle-switch");
    switchEl.style.height = sizePx;
    switchEl.style.width = sizePx;
    switchEl.style.borderRadius = sizePx;
    containEl.appendChild(switchEl);
    return containEl;
}
function $517dee46856d349e$var$rownum(cell, formatterParams, onRendered) {
    var content = document.createElement("span");
    var row = cell.getRow();
    var table = cell.getTable();
    row.watchPosition((position)=>{
        if (formatterParams.relativeToPage) position += table.modules.page.getPageSize() * (table.modules.page.getPage() - 1);
        content.innerText = position;
    });
    return content;
}
function $517dee46856d349e$var$handle(cell, formatterParams, onRendered) {
    cell.getElement().classList.add("tabulator-row-handle");
    return "<div class='tabulator-row-handle-box'><div class='tabulator-row-handle-bar'></div><div class='tabulator-row-handle-bar'></div><div class='tabulator-row-handle-bar'></div></div>";
}
function $517dee46856d349e$var$adaptable(cell, params, onRendered) {
    var lookup, formatterFunc, formatterParams;
    function defaultLookup(cell) {
        var value = cell.getValue(), formatter = "plaintext";
        switch(typeof value){
            case "boolean":
                formatter = "tickCross";
                break;
            case "string":
                if (value.includes("\n")) formatter = "textarea";
                break;
        }
        return formatter;
    }
    lookup = params.formatterLookup ? params.formatterLookup(cell) : defaultLookup(cell);
    if (params.paramsLookup) formatterParams = typeof params.paramsLookup === "function" ? params.paramsLookup(lookup, cell) : params.paramsLookup[lookup];
    formatterFunc = this.table.modules.format.lookupFormatter(lookup);
    return formatterFunc.call(this, cell, formatterParams || {}, onRendered);
}
function $517dee46856d349e$var$array$2(cell, formatterParams, onRendered) {
    var delimiter = formatterParams.delimiter || ",", value = cell.getValue(), table = this.table, valueMap;
    if (formatterParams.valueMap) {
        if (typeof formatterParams.valueMap === "string") valueMap = function(value) {
            return value.map((item)=>{
                return $517dee46856d349e$var$Helpers.retrieveNestedData(table.options.nestedFieldSeparator, formatterParams.valueMap, item);
            });
        };
        else valueMap = formatterParams.valueMap;
    }
    if (Array.isArray(value)) {
        if (valueMap) value = valueMap(value);
        return value.join(delimiter);
    } else return value;
}
function $517dee46856d349e$var$json$1(cell, formatterParams, onRendered) {
    var indent = formatterParams.indent || "\t", multiline = typeof formatterParams.multiline === "undefined" ? true : formatterParams.multiline, replacer = formatterParams.replacer || null, value = cell.getValue();
    if (multiline) cell.getElement().style.whiteSpace = "pre-wrap";
    return JSON.stringify(value, replacer, indent);
}
var $517dee46856d349e$var$defaultFormatters = {
    plaintext: $517dee46856d349e$var$plaintext,
    html: $517dee46856d349e$var$html,
    textarea: $517dee46856d349e$var$textarea,
    money: $517dee46856d349e$var$money,
    link: $517dee46856d349e$var$link,
    image: $517dee46856d349e$var$image,
    tickCross: $517dee46856d349e$var$tickCross,
    datetime: $517dee46856d349e$var$datetime$1,
    datetimediff: $517dee46856d349e$var$datetimediff,
    lookup: $517dee46856d349e$var$lookup,
    star: $517dee46856d349e$var$star,
    traffic: $517dee46856d349e$var$traffic,
    progress: $517dee46856d349e$var$progress,
    color: $517dee46856d349e$var$color,
    buttonTick: $517dee46856d349e$var$buttonTick,
    buttonCross: $517dee46856d349e$var$buttonCross,
    toggle: $517dee46856d349e$var$toggle,
    rownum: $517dee46856d349e$var$rownum,
    handle: $517dee46856d349e$var$handle,
    adaptable: $517dee46856d349e$var$adaptable,
    array: $517dee46856d349e$var$array$2,
    json: $517dee46856d349e$var$json$1
};
class $517dee46856d349e$export$5634f967e02d772d extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "format";
    //load defaults
    static formatters = $517dee46856d349e$var$defaultFormatters;
    constructor(table){
        super(table);
        this.registerColumnOption("formatter");
        this.registerColumnOption("formatterParams");
        this.registerColumnOption("formatterPrint");
        this.registerColumnOption("formatterPrintParams");
        this.registerColumnOption("formatterClipboard");
        this.registerColumnOption("formatterClipboardParams");
        this.registerColumnOption("formatterHtmlOutput");
        this.registerColumnOption("formatterHtmlOutputParams");
        this.registerColumnOption("titleFormatter");
        this.registerColumnOption("titleFormatterParams");
    }
    initialize() {
        this.subscribe("cell-format", this.formatValue.bind(this));
        this.subscribe("cell-rendered", this.cellRendered.bind(this));
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("column-format", this.formatHeader.bind(this));
    }
    //initialize column formatter
    initializeColumn(column) {
        column.modules.format = this.lookupTypeFormatter(column, "");
        if (typeof column.definition.formatterPrint !== "undefined") column.modules.format.print = this.lookupTypeFormatter(column, "Print");
        if (typeof column.definition.formatterClipboard !== "undefined") column.modules.format.clipboard = this.lookupTypeFormatter(column, "Clipboard");
        if (typeof column.definition.formatterHtmlOutput !== "undefined") column.modules.format.htmlOutput = this.lookupTypeFormatter(column, "HtmlOutput");
    }
    lookupTypeFormatter(column, type) {
        var config = {
            params: column.definition["formatter" + type + "Params"] || {}
        }, formatter = column.definition["formatter" + type];
        config.formatter = this.lookupFormatter(formatter);
        return config;
    }
    lookupFormatter(formatter) {
        var formatterFunc;
        //set column formatter
        switch(typeof formatter){
            case "string":
                if ($517dee46856d349e$export$5634f967e02d772d.formatters[formatter]) formatterFunc = $517dee46856d349e$export$5634f967e02d772d.formatters[formatter];
                else {
                    console.warn("Formatter Error - No such formatter found: ", formatter);
                    formatterFunc = $517dee46856d349e$export$5634f967e02d772d.formatters.plaintext;
                }
                break;
            case "function":
                formatterFunc = formatter;
                break;
            default:
                formatterFunc = $517dee46856d349e$export$5634f967e02d772d.formatters.plaintext;
                break;
        }
        return formatterFunc;
    }
    cellRendered(cell) {
        if (cell.modules.format && cell.modules.format.renderedCallback && !cell.modules.format.rendered) {
            cell.modules.format.renderedCallback();
            cell.modules.format.rendered = true;
        }
    }
    //return a formatted value for a column header
    formatHeader(column, title, el) {
        var formatter, params, onRendered, mockCell;
        if (column.definition.titleFormatter) {
            formatter = this.lookupFormatter(column.definition.titleFormatter);
            onRendered = (callback)=>{
                column.titleFormatterRendered = callback;
            };
            mockCell = {
                getValue: function() {
                    return title;
                },
                getElement: function() {
                    return el;
                },
                getType: function() {
                    return "header";
                },
                getColumn: function() {
                    return column.getComponent();
                },
                getTable: ()=>{
                    return this.table;
                }
            };
            params = column.definition.titleFormatterParams || {};
            params = typeof params === "function" ? params() : params;
            return formatter.call(this, mockCell, params, onRendered);
        } else return title;
    }
    //return a formatted value for a cell
    formatValue(cell) {
        var component = cell.getComponent(), params = typeof cell.column.modules.format.params === "function" ? cell.column.modules.format.params(component) : cell.column.modules.format.params;
        function onRendered(callback) {
            if (!cell.modules.format) cell.modules.format = {};
            cell.modules.format.renderedCallback = callback;
            cell.modules.format.rendered = false;
        }
        return cell.column.modules.format.formatter.call(this, component, params, onRendered);
    }
    formatExportValue(cell, type) {
        var formatter = cell.column.modules.format[type], params;
        if (formatter) {
            params = typeof formatter.params === "function" ? formatter.params(cell.getComponent()) : formatter.params;
            function onRendered(callback) {
                if (!cell.modules.format) cell.modules.format = {};
                cell.modules.format.renderedCallback = callback;
                cell.modules.format.rendered = false;
            }
            return formatter.formatter.call(this, cell.getComponent(), params, onRendered);
        } else return this.formatValue(cell);
    }
    sanitizeHTML(value) {
        if (value) {
            var entityMap = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;',
                '/': '&#x2F;',
                '`': '&#x60;',
                '=': '&#x3D;'
            };
            return String(value).replace(/[&<>"'`=/]/g, function(s) {
                return entityMap[s];
            });
        } else return value;
    }
    emptyToSpace(value) {
        return value === null || typeof value === "undefined" || value === "" ? "&nbsp;" : value;
    }
}
class $517dee46856d349e$export$c00c4e95a253fbf9 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "frozenColumns";
    constructor(table){
        super(table);
        this.leftColumns = [];
        this.rightColumns = [];
        this.initializationMode = "left";
        this.active = false;
        this.blocked = true;
        this.registerColumnOption("frozen");
    }
    //reset initial state
    reset() {
        this.initializationMode = "left";
        this.leftColumns = [];
        this.rightColumns = [];
        this.active = false;
    }
    initialize() {
        this.subscribe("cell-layout", this.layoutCell.bind(this));
        this.subscribe("column-init", this.initializeColumn.bind(this));
        this.subscribe("column-width", this.layout.bind(this));
        this.subscribe("row-layout-after", this.layoutRow.bind(this));
        this.subscribe("table-layout", this.layout.bind(this));
        this.subscribe("columns-loading", this.reset.bind(this));
        this.subscribe("column-add", this.reinitializeColumns.bind(this));
        this.subscribe("column-deleted", this.reinitializeColumns.bind(this));
        this.subscribe("column-hide", this.reinitializeColumns.bind(this));
        this.subscribe("column-show", this.reinitializeColumns.bind(this));
        this.subscribe("columns-loaded", this.reinitializeColumns.bind(this));
        this.subscribe("table-redraw", this.layout.bind(this));
        this.subscribe("layout-refreshing", this.blockLayout.bind(this));
        this.subscribe("layout-refreshed", this.unblockLayout.bind(this));
        this.subscribe("scrollbar-vertical", this.adjustForScrollbar.bind(this));
    }
    blockLayout() {
        this.blocked = true;
    }
    unblockLayout() {
        this.blocked = false;
    }
    layoutCell(cell) {
        this.layoutElement(cell.element, cell.column);
    }
    reinitializeColumns() {
        this.reset();
        this.table.columnManager.columnsByIndex.forEach((column)=>{
            this.initializeColumn(column);
        });
        this.layout();
    }
    //initialize specific column
    initializeColumn(column) {
        var config = {
            margin: 0,
            edge: false
        };
        if (!column.isGroup) {
            if (this.frozenCheck(column)) {
                config.position = this.initializationMode;
                if (this.initializationMode == "left") this.leftColumns.push(column);
                else this.rightColumns.unshift(column);
                this.active = true;
                column.modules.frozen = config;
            } else this.initializationMode = "right";
        }
    }
    frozenCheck(column) {
        if (column.parent.isGroup && column.definition.frozen) console.warn("Frozen Column Error - Parent column group must be frozen, not individual columns or sub column groups");
        if (column.parent.isGroup) return this.frozenCheck(column.parent);
        else return column.definition.frozen;
    }
    //layout calculation rows
    layoutCalcRows() {
        if (this.table.modExists("columnCalcs")) {
            if (this.table.modules.columnCalcs.topInitialized && this.table.modules.columnCalcs.topRow) this.layoutRow(this.table.modules.columnCalcs.topRow);
            if (this.table.modules.columnCalcs.botInitialized && this.table.modules.columnCalcs.botRow) this.layoutRow(this.table.modules.columnCalcs.botRow);
            if (this.table.modExists("groupRows")) this.layoutGroupCalcs(this.table.modules.groupRows.getGroups());
        }
    }
    layoutGroupCalcs(groups) {
        groups.forEach((group)=>{
            if (group.calcs.top) this.layoutRow(group.calcs.top);
            if (group.calcs.bottom) this.layoutRow(group.calcs.bottom);
            if (group.groupList && group.groupList.length) this.layoutGroupCalcs(group.groupList);
        });
    }
    //calculate column positions and layout headers
    layoutColumnPosition(allCells) {
        var leftParents = [];
        var leftMargin = 0;
        var rightMargin = 0;
        this.leftColumns.forEach((column, i)=>{
            column.modules.frozen.marginValue = leftMargin;
            column.modules.frozen.margin = column.modules.frozen.marginValue + "px";
            if (column.visible) leftMargin += column.getWidth();
            if (i == this.leftColumns.length - 1) column.modules.frozen.edge = true;
            else column.modules.frozen.edge = false;
            if (column.parent.isGroup) {
                var parentEl = this.getColGroupParentElement(column);
                if (!leftParents.includes(parentEl)) {
                    this.layoutElement(parentEl, column);
                    leftParents.push(parentEl);
                }
                parentEl.classList.toggle("tabulator-frozen-left", column.modules.frozen.edge && column.modules.frozen.position === "left");
                parentEl.classList.toggle("tabulator-frozen-right", column.modules.frozen.edge && column.modules.frozen.position === "right");
            } else this.layoutElement(column.getElement(), column);
            if (allCells) column.cells.forEach((cell)=>{
                this.layoutElement(cell.getElement(true), column);
            });
        });
        this.rightColumns.forEach((column, i)=>{
            column.modules.frozen.marginValue = rightMargin;
            column.modules.frozen.margin = column.modules.frozen.marginValue + "px";
            if (column.visible) rightMargin += column.getWidth();
            if (i == this.rightColumns.length - 1) column.modules.frozen.edge = true;
            else column.modules.frozen.edge = false;
            if (column.parent.isGroup) this.layoutElement(this.getColGroupParentElement(column), column);
            else this.layoutElement(column.getElement(), column);
            if (allCells) column.cells.forEach((cell)=>{
                this.layoutElement(cell.getElement(true), column);
            });
        });
    }
    getColGroupParentElement(column) {
        return column.parent.isGroup ? this.getColGroupParentElement(column.parent) : column.getElement();
    }
    //layout columns appropriately
    layout() {
        if (this.active && !this.blocked) {
            //calculate left columns
            this.layoutColumnPosition();
            this.reinitializeRows();
            this.layoutCalcRows();
        }
    }
    reinitializeRows() {
        var visibleRows = this.table.rowManager.getVisibleRows(true);
        var otherRows = this.table.rowManager.getRows().filter((row)=>!visibleRows.includes(row));
        otherRows.forEach((row)=>{
            row.deinitialize();
        });
        visibleRows.forEach((row)=>{
            if (row.type === "row") this.layoutRow(row);
        });
    }
    layoutRow(row) {
        if (this.table.options.layout === "fitDataFill" && this.rightColumns.length) this.table.rowManager.getTableElement().style.minWidth = "calc(100% - " + this.rightMargin + ")";
        this.leftColumns.forEach((column)=>{
            var cell = row.getCell(column);
            if (cell) this.layoutElement(cell.getElement(true), column);
        });
        this.rightColumns.forEach((column)=>{
            var cell = row.getCell(column);
            if (cell) this.layoutElement(cell.getElement(true), column);
        });
    }
    layoutElement(element, column) {
        var position;
        if (column.modules.frozen && element) {
            element.style.position = "sticky";
            if (this.table.rtl) position = column.modules.frozen.position === "left" ? "right" : "left";
            else position = column.modules.frozen.position;
            element.style[position] = column.modules.frozen.margin;
            element.classList.add("tabulator-frozen");
            element.classList.toggle("tabulator-frozen-left", column.modules.frozen.edge && column.modules.frozen.position === "left");
            element.classList.toggle("tabulator-frozen-right", column.modules.frozen.edge && column.modules.frozen.position === "right");
        }
    }
    adjustForScrollbar(width) {
        if (this.rightColumns.length) this.table.columnManager.getContentsElement().style.width = "calc(100% - " + width + "px)";
    }
    getFrozenColumns() {
        return this.leftColumns.concat(this.rightColumns);
    }
    _calcSpace(columns, index) {
        var width = 0;
        for(let i = 0; i < index; i++)if (columns[i].visible) width += columns[i].getWidth();
        return width;
    }
}
class $517dee46856d349e$export$6e51ce5331c5fffa extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "frozenRows";
    constructor(table){
        super(table);
        this.topElement = document.createElement("div");
        this.rows = [];
        //register component functions
        this.registerComponentFunction("row", "freeze", this.freezeRow.bind(this));
        this.registerComponentFunction("row", "unfreeze", this.unfreezeRow.bind(this));
        this.registerComponentFunction("row", "isFrozen", this.isRowFrozen.bind(this));
        //register table options
        this.registerTableOption("frozenRowsField", "id"); //field to choose frozen rows by
        this.registerTableOption("frozenRows", false); //holder for frozen row identifiers
    }
    initialize() {
        var fragment = document.createDocumentFragment();
        this.rows = [];
        this.topElement.classList.add("tabulator-frozen-rows-holder");
        fragment.appendChild(document.createElement("br"));
        fragment.appendChild(this.topElement);
        // this.table.columnManager.element.append(this.topElement);
        this.table.columnManager.getContentsElement().insertBefore(fragment, this.table.columnManager.headersElement.nextSibling);
        this.subscribe("row-deleting", this.detachRow.bind(this));
        this.subscribe("rows-visible", this.visibleRows.bind(this));
        this.registerDisplayHandler(this.getRows.bind(this), 10);
        if (this.table.options.frozenRows) {
            this.subscribe("data-processed", this.initializeRows.bind(this));
            this.subscribe("row-added", this.initializeRow.bind(this));
            this.subscribe("table-redrawing", this.resizeHolderWidth.bind(this));
            this.subscribe("column-resized", this.resizeHolderWidth.bind(this));
            this.subscribe("column-show", this.resizeHolderWidth.bind(this));
            this.subscribe("column-hide", this.resizeHolderWidth.bind(this));
        }
        this.resizeHolderWidth();
    }
    resizeHolderWidth() {
        this.topElement.style.minWidth = this.table.columnManager.headersElement.offsetWidth + "px";
    }
    initializeRows() {
        this.table.rowManager.getRows().forEach((row)=>{
            this.initializeRow(row);
        });
    }
    initializeRow(row) {
        var frozenRows = this.table.options.frozenRows, rowType = typeof frozenRows;
        if (rowType === "number") {
            if (row.getPosition() && row.getPosition() + this.rows.length <= frozenRows) this.freezeRow(row);
        } else if (rowType === "function") {
            if (frozenRows.call(this.table, row.getComponent())) this.freezeRow(row);
        } else if (Array.isArray(frozenRows)) {
            if (frozenRows.includes(row.data[this.options("frozenRowsField")])) this.freezeRow(row);
        }
    }
    isRowFrozen(row) {
        var index = this.rows.indexOf(row);
        return index > -1;
    }
    isFrozen() {
        return !!this.rows.length;
    }
    visibleRows(viewable, rows) {
        this.rows.forEach((row)=>{
            rows.push(row);
        });
        return rows;
    }
    //filter frozen rows out of display data
    getRows(rows) {
        var output = rows.slice(0);
        this.rows.forEach(function(row) {
            var index = output.indexOf(row);
            if (index > -1) output.splice(index, 1);
        });
        return output;
    }
    freezeRow(row) {
        if (!row.modules.frozen) {
            row.modules.frozen = true;
            this.topElement.appendChild(row.getElement());
            row.initialize();
            row.normalizeHeight();
            this.rows.push(row);
            this.refreshData(false, "display");
            this.table.rowManager.adjustTableSize();
            this.styleRows();
        } else console.warn("Freeze Error - Row is already frozen");
    }
    unfreezeRow(row) {
        if (row.modules.frozen) {
            row.modules.frozen = false;
            this.detachRow(row);
            this.table.rowManager.adjustTableSize();
            this.refreshData(false, "display");
            if (this.rows.length) this.styleRows();
        } else console.warn("Freeze Error - Row is already unfrozen");
    }
    detachRow(row) {
        var index = this.rows.indexOf(row);
        if (index > -1) {
            var rowEl = row.getElement();
            if (rowEl.parentNode) rowEl.parentNode.removeChild(rowEl);
            this.rows.splice(index, 1);
        }
    }
    styleRows(row) {
        this.rows.forEach((row, i)=>{
            this.table.rowManager.styleRow(row, i);
        });
    }
}
//public group object
class $517dee46856d349e$export$450247cd99a94b80 {
    constructor(group){
        this._group = group;
        this.type = "GroupComponent";
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._group.groupManager.table.componentFunctionBinder.handle("group", target._group, name);
            }
        });
    }
    getKey() {
        return this._group.key;
    }
    getField() {
        return this._group.field;
    }
    getElement() {
        return this._group.element;
    }
    getRows() {
        return this._group.getRows(true);
    }
    getSubGroups() {
        return this._group.getSubGroups(true);
    }
    getParentGroup() {
        return this._group.parent ? this._group.parent.getComponent() : false;
    }
    isVisible() {
        return this._group.visible;
    }
    show() {
        this._group.show();
    }
    hide() {
        this._group.hide();
    }
    toggle() {
        this._group.toggleVisibility();
    }
    scrollTo(position, ifVisible) {
        return this._group.groupManager.table.rowManager.scrollToRow(this._group, position, ifVisible);
    }
    _getSelf() {
        return this._group;
    }
    getTable() {
        return this._group.groupManager.table;
    }
}
//Group functions
class $517dee46856d349e$var$Group {
    constructor(groupManager, parent, level, key, field, generator, oldGroup){
        this.groupManager = groupManager;
        this.parent = parent;
        this.key = key;
        this.level = level;
        this.field = field;
        this.hasSubGroups = level < groupManager.groupIDLookups.length - 1;
        this.addRow = this.hasSubGroups ? this._addRowToGroup : this._addRow;
        this.type = "group"; //type of element
        this.old = oldGroup;
        this.rows = [];
        this.groups = [];
        this.groupList = [];
        this.generator = generator;
        this.element = false;
        this.elementContents = false;
        this.height = 0;
        this.outerHeight = 0;
        this.initialized = false;
        this.calcs = {};
        this.initialized = false;
        this.modules = {};
        this.arrowElement = false;
        this.visible = oldGroup ? oldGroup.visible : typeof groupManager.startOpen[level] !== "undefined" ? groupManager.startOpen[level] : groupManager.startOpen[0];
        this.component = null;
        this.createElements();
        this.addBindings();
        this.createValueGroups();
    }
    wipe(elementsOnly) {
        if (!elementsOnly) {
            if (this.groupList.length) this.groupList.forEach(function(group) {
                group.wipe();
            });
            else this.rows.forEach((row)=>{
                if (row.modules) delete row.modules.group;
            });
        }
        this.element = false;
        this.arrowElement = false;
        this.elementContents = false;
    }
    createElements() {
        var arrow = document.createElement("div");
        arrow.classList.add("tabulator-arrow");
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-row");
        this.element.classList.add("tabulator-group");
        this.element.classList.add("tabulator-group-level-" + this.level);
        this.element.setAttribute("role", "rowgroup");
        this.arrowElement = document.createElement("div");
        this.arrowElement.classList.add("tabulator-group-toggle");
        this.arrowElement.appendChild(arrow);
        //setup movable rows
        if (this.groupManager.table.options.movableRows !== false && this.groupManager.table.modExists("moveRow")) this.groupManager.table.modules.moveRow.initializeGroupHeader(this);
    }
    createValueGroups() {
        var level = this.level + 1;
        if (this.groupManager.allowedValues && this.groupManager.allowedValues[level]) this.groupManager.allowedValues[level].forEach((value)=>{
            this._createGroup(value, level);
        });
    }
    addBindings() {
        var toggleElement;
        if (this.groupManager.table.options.groupToggleElement) {
            toggleElement = this.groupManager.table.options.groupToggleElement == "arrow" ? this.arrowElement : this.element;
            toggleElement.addEventListener("click", (e)=>{
                if (this.groupManager.table.options.groupToggleElement === "arrow") {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
                //allow click event to propagate before toggling visibility
                setTimeout(()=>{
                    this.toggleVisibility();
                });
            });
        }
    }
    _createGroup(groupID, level) {
        var groupKey = level + "_" + groupID;
        var group = new $517dee46856d349e$var$Group(this.groupManager, this, level, groupID, this.groupManager.groupIDLookups[level].field, this.groupManager.headerGenerator[level] || this.groupManager.headerGenerator[0], this.old ? this.old.groups[groupKey] : false);
        this.groups[groupKey] = group;
        this.groupList.push(group);
    }
    _addRowToGroup(row) {
        var level = this.level + 1;
        if (this.hasSubGroups) {
            var groupID = this.groupManager.groupIDLookups[level].func(row.getData()), groupKey = level + "_" + groupID;
            if (this.groupManager.allowedValues && this.groupManager.allowedValues[level]) {
                if (this.groups[groupKey]) this.groups[groupKey].addRow(row);
            } else {
                if (!this.groups[groupKey]) this._createGroup(groupID, level);
                this.groups[groupKey].addRow(row);
            }
        }
    }
    _addRow(row) {
        this.rows.push(row);
        row.modules.group = this;
    }
    insertRow(row, to, after) {
        var data = this.conformRowData({});
        row.updateData(data);
        var toIndex = this.rows.indexOf(to);
        if (toIndex > -1) {
            if (after) this.rows.splice(toIndex + 1, 0, row);
            else this.rows.splice(toIndex, 0, row);
        } else if (after) this.rows.push(row);
        else this.rows.unshift(row);
        row.modules.group = this;
        // this.generateGroupHeaderContents();
        if (this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.options.columnCalcs != "table") this.groupManager.table.modules.columnCalcs.recalcGroup(this);
        this.groupManager.updateGroupRows(true);
    }
    scrollHeader(left) {
        if (this.arrowElement) {
            this.arrowElement.style.marginLeft = left;
            this.groupList.forEach(function(child) {
                child.scrollHeader(left);
            });
        }
    }
    getRowIndex(row) {}
    //update row data to match grouping constraints
    conformRowData(data) {
        if (this.field) data[this.field] = this.key;
        else console.warn("Data Conforming Error - Cannot conform row data to match new group as groupBy is a function");
        if (this.parent) data = this.parent.conformRowData(data);
        return data;
    }
    removeRow(row) {
        var index = this.rows.indexOf(row);
        var el = row.getElement();
        if (index > -1) this.rows.splice(index, 1);
        if (!this.groupManager.table.options.groupValues && !this.rows.length) {
            if (this.parent) this.parent.removeGroup(this);
            else this.groupManager.removeGroup(this);
            this.groupManager.updateGroupRows(true);
        } else {
            if (el.parentNode) el.parentNode.removeChild(el);
            if (!this.groupManager.blockRedraw) {
                this.generateGroupHeaderContents();
                if (this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.options.columnCalcs != "table") this.groupManager.table.modules.columnCalcs.recalcGroup(this);
            }
        }
    }
    removeGroup(group) {
        var groupKey = group.level + "_" + group.key, index;
        if (this.groups[groupKey]) {
            delete this.groups[groupKey];
            index = this.groupList.indexOf(group);
            if (index > -1) this.groupList.splice(index, 1);
            if (!this.groupList.length) {
                if (this.parent) this.parent.removeGroup(this);
                else this.groupManager.removeGroup(this);
            }
        }
    }
    getHeadersAndRows() {
        var output = [];
        output.push(this);
        this._visSet();
        if (this.calcs.top) {
            this.calcs.top.detachElement();
            this.calcs.top.deleteCells();
        }
        if (this.calcs.bottom) {
            this.calcs.bottom.detachElement();
            this.calcs.bottom.deleteCells();
        }
        if (this.visible) {
            if (this.groupList.length) this.groupList.forEach(function(group) {
                output = output.concat(group.getHeadersAndRows());
            });
            else {
                if (this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.modules.columnCalcs.hasTopCalcs()) {
                    this.calcs.top = this.groupManager.table.modules.columnCalcs.generateTopRow(this.rows);
                    output.push(this.calcs.top);
                }
                output = output.concat(this.rows);
                if (this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.modules.columnCalcs.hasBottomCalcs()) {
                    this.calcs.bottom = this.groupManager.table.modules.columnCalcs.generateBottomRow(this.rows);
                    output.push(this.calcs.bottom);
                }
            }
        } else {
            if (!this.groupList.length && this.groupManager.table.options.columnCalcs != "table") {
                if (this.groupManager.table.modExists("columnCalcs")) {
                    if (this.groupManager.table.modules.columnCalcs.hasTopCalcs()) {
                        if (this.groupManager.table.options.groupClosedShowCalcs) {
                            this.calcs.top = this.groupManager.table.modules.columnCalcs.generateTopRow(this.rows);
                            output.push(this.calcs.top);
                        }
                    }
                    if (this.groupManager.table.modules.columnCalcs.hasBottomCalcs()) {
                        if (this.groupManager.table.options.groupClosedShowCalcs) {
                            this.calcs.bottom = this.groupManager.table.modules.columnCalcs.generateBottomRow(this.rows);
                            output.push(this.calcs.bottom);
                        }
                    }
                }
            }
        }
        return output;
    }
    getData(visible, transform) {
        var output = [];
        this._visSet();
        if (!visible || visible && this.visible) this.rows.forEach((row)=>{
            output.push(row.getData(transform || "data"));
        });
        return output;
    }
    getRowCount() {
        var count = 0;
        if (this.groupList.length) this.groupList.forEach((group)=>{
            count += group.getRowCount();
        });
        else count = this.rows.length;
        return count;
    }
    toggleVisibility() {
        if (this.visible) this.hide();
        else this.show();
    }
    hide() {
        this.visible = false;
        if (this.groupManager.table.rowManager.getRenderMode() == "basic" && !this.groupManager.table.options.pagination) {
            this.element.classList.remove("tabulator-group-visible");
            if (this.groupList.length) this.groupList.forEach((group)=>{
                var rows = group.getHeadersAndRows();
                rows.forEach((row)=>{
                    row.detachElement();
                });
            });
            else this.rows.forEach((row)=>{
                var rowEl = row.getElement();
                rowEl.parentNode.removeChild(rowEl);
            });
            this.groupManager.updateGroupRows(true);
        } else this.groupManager.updateGroupRows(true);
        this.groupManager.table.externalEvents.dispatch("groupVisibilityChanged", this.getComponent(), false);
    }
    show() {
        this.visible = true;
        if (this.groupManager.table.rowManager.getRenderMode() == "basic" && !this.groupManager.table.options.pagination) {
            this.element.classList.add("tabulator-group-visible");
            var prev = this.generateElement();
            if (this.groupList.length) this.groupList.forEach((group)=>{
                var rows = group.getHeadersAndRows();
                rows.forEach((row)=>{
                    var rowEl = row.getElement();
                    prev.parentNode.insertBefore(rowEl, prev.nextSibling);
                    row.initialize();
                    prev = rowEl;
                });
            });
            else this.rows.forEach((row)=>{
                var rowEl = row.getElement();
                prev.parentNode.insertBefore(rowEl, prev.nextSibling);
                row.initialize();
                prev = rowEl;
            });
            this.groupManager.updateGroupRows(true);
        } else this.groupManager.updateGroupRows(true);
        this.groupManager.table.externalEvents.dispatch("groupVisibilityChanged", this.getComponent(), true);
    }
    _visSet() {
        var data = [];
        if (typeof this.visible == "function") {
            this.rows.forEach(function(row) {
                data.push(row.getData());
            });
            this.visible = this.visible(this.key, this.getRowCount(), data, this.getComponent());
        }
    }
    getRowGroup(row) {
        var match = false;
        if (this.groupList.length) this.groupList.forEach(function(group) {
            var result = group.getRowGroup(row);
            if (result) match = result;
        });
        else if (this.rows.find(function(item) {
            return item === row;
        })) match = this;
        return match;
    }
    getSubGroups(component) {
        var output = [];
        this.groupList.forEach(function(child) {
            output.push(component ? child.getComponent() : child);
        });
        return output;
    }
    getRows(component, includeChildren) {
        var output = [];
        if (includeChildren && this.groupList.length) this.groupList.forEach((group)=>{
            output = output.concat(group.getRows(component, includeChildren));
        });
        else this.rows.forEach(function(row) {
            output.push(component ? row.getComponent() : row);
        });
        return output;
    }
    generateGroupHeaderContents() {
        var data = [];
        var rows = this.getRows(false, true);
        rows.forEach(function(row) {
            data.push(row.getData());
        });
        this.elementContents = this.generator(this.key, this.getRowCount(), data, this.getComponent());
        while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
        if (typeof this.elementContents === "string") this.element.innerHTML = this.elementContents;
        else this.element.appendChild(this.elementContents);
        this.element.insertBefore(this.arrowElement, this.element.firstChild);
    }
    getPath(path = []) {
        path.unshift(this.key);
        if (this.parent) this.parent.getPath(path);
        return path;
    }
    ////////////// Standard Row Functions //////////////
    getElement() {
        return this.elementContents ? this.element : this.generateElement();
    }
    generateElement() {
        this.addBindings = false;
        this._visSet();
        if (this.visible) this.element.classList.add("tabulator-group-visible");
        else this.element.classList.remove("tabulator-group-visible");
        for(var i = 0; i < this.element.childNodes.length; ++i)this.element.childNodes[i].parentNode.removeChild(this.element.childNodes[i]);
        this.generateGroupHeaderContents();
        // this.addBindings();
        return this.element;
    }
    detachElement() {
        if (this.element && this.element.parentNode) this.element.parentNode.removeChild(this.element);
    }
    //normalize the height of elements in the row
    normalizeHeight() {
        this.setHeight(this.element.clientHeight);
    }
    initialize(force) {
        if (!this.initialized || force) {
            this.normalizeHeight();
            this.initialized = true;
        }
    }
    reinitialize() {
        this.initialized = false;
        this.height = 0;
        if ($517dee46856d349e$var$Helpers.elVisible(this.element)) this.initialize(true);
    }
    setHeight(height) {
        if (this.height != height) {
            this.height = height;
            this.outerHeight = this.element.offsetHeight;
        }
    }
    //return rows outer height
    getHeight() {
        return this.outerHeight;
    }
    getGroup() {
        return this;
    }
    reinitializeHeight() {}
    calcHeight() {}
    setCellHeight() {}
    clearCellHeight() {}
    deinitializeHeight() {}
    rendered() {}
    //////////////// Object Generation /////////////////
    getComponent() {
        if (!this.component) this.component = new $517dee46856d349e$export$450247cd99a94b80(this);
        return this.component;
    }
}
class $517dee46856d349e$export$41e6b6ec902cbe0a extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "groupRows";
    constructor(table){
        super(table);
        this.groupIDLookups = false; //enable table grouping and set field to group by
        this.startOpen = [
            function() {
                return false;
            }
        ]; //starting state of group
        this.headerGenerator = [
            function() {
                return "";
            }
        ];
        this.groupList = []; //ordered list of groups
        this.allowedValues = false;
        this.groups = {}; //hold row groups
        this.displayHandler = this.getRows.bind(this);
        this.blockRedraw = false;
        //register table options
        this.registerTableOption("groupBy", false); //enable table grouping and set field to group by
        this.registerTableOption("groupStartOpen", true); //starting state of group
        this.registerTableOption("groupValues", false);
        this.registerTableOption("groupUpdateOnCellEdit", false);
        this.registerTableOption("groupHeader", false); //header generation function
        this.registerTableOption("groupHeaderPrint", null);
        this.registerTableOption("groupHeaderClipboard", null);
        this.registerTableOption("groupHeaderHtmlOutput", null);
        this.registerTableOption("groupHeaderDownload", null);
        this.registerTableOption("groupToggleElement", "arrow");
        this.registerTableOption("groupClosedShowCalcs", false);
        //register table functions
        this.registerTableFunction("setGroupBy", this.setGroupBy.bind(this));
        this.registerTableFunction("setGroupValues", this.setGroupValues.bind(this));
        this.registerTableFunction("setGroupStartOpen", this.setGroupStartOpen.bind(this));
        this.registerTableFunction("setGroupHeader", this.setGroupHeader.bind(this));
        this.registerTableFunction("getGroups", this.userGetGroups.bind(this));
        this.registerTableFunction("getGroupedData", this.userGetGroupedData.bind(this));
        //register component functions
        this.registerComponentFunction("row", "getGroup", this.rowGetGroup.bind(this));
    }
    //initialize group configuration
    initialize() {
        this.subscribe("table-destroy", this._blockRedrawing.bind(this));
        this.subscribe("rows-wipe", this._blockRedrawing.bind(this));
        this.subscribe("rows-wiped", this._restore_redrawing.bind(this));
        if (this.table.options.groupBy) {
            if (this.table.options.groupUpdateOnCellEdit) {
                this.subscribe("cell-value-updated", this.cellUpdated.bind(this));
                this.subscribe("row-data-changed", this.reassignRowToGroup.bind(this), 0);
            }
            this.subscribe("table-built", this.configureGroupSetup.bind(this));
            this.subscribe("row-deleting", this.rowDeleting.bind(this));
            this.subscribe("row-deleted", this.rowsUpdated.bind(this));
            this.subscribe("scroll-horizontal", this.scrollHeaders.bind(this));
            this.subscribe("rows-wipe", this.wipe.bind(this));
            this.subscribe("rows-added", this.rowsUpdated.bind(this));
            this.subscribe("row-moving", this.rowMoving.bind(this));
            this.subscribe("row-adding-index", this.rowAddingIndex.bind(this));
            this.subscribe("rows-sample", this.rowSample.bind(this));
            this.subscribe("render-virtual-fill", this.virtualRenderFill.bind(this));
            this.registerDisplayHandler(this.displayHandler, 20);
            this.initialized = true;
        }
    }
    _blockRedrawing() {
        this.blockRedraw = true;
    }
    _restore_redrawing() {
        this.blockRedraw = false;
    }
    configureGroupSetup() {
        if (this.table.options.groupBy) {
            var groupBy = this.table.options.groupBy, startOpen = this.table.options.groupStartOpen, groupHeader = this.table.options.groupHeader;
            this.allowedValues = this.table.options.groupValues;
            if (Array.isArray(groupBy) && Array.isArray(groupHeader) && groupBy.length > groupHeader.length) console.warn("Error creating group headers, groupHeader array is shorter than groupBy array");
            this.headerGenerator = [
                function() {
                    return "";
                }
            ];
            this.startOpen = [
                function() {
                    return false;
                }
            ]; //starting state of group
            this.langBind("groups|item", (langValue, lang)=>{
                this.headerGenerator[0] = (value, count, data)=>{
                    return (typeof value === "undefined" ? "" : value) + "<span>(" + count + " " + (count === 1 ? langValue : lang.groups.items) + ")</span>";
                };
            });
            this.groupIDLookups = [];
            if (groupBy) {
                if (this.table.modExists("columnCalcs") && this.table.options.columnCalcs != "table" && this.table.options.columnCalcs != "both") this.table.modules.columnCalcs.removeCalcs();
            } else if (this.table.modExists("columnCalcs") && this.table.options.columnCalcs != "group") {
                var cols = this.table.columnManager.getRealColumns();
                cols.forEach((col)=>{
                    if (col.definition.topCalc) this.table.modules.columnCalcs.initializeTopRow();
                    if (col.definition.bottomCalc) this.table.modules.columnCalcs.initializeBottomRow();
                });
            }
            if (!Array.isArray(groupBy)) groupBy = [
                groupBy
            ];
            groupBy.forEach((group, i)=>{
                var lookupFunc, column;
                if (typeof group == "function") lookupFunc = group;
                else {
                    column = this.table.columnManager.getColumnByField(group);
                    if (column) lookupFunc = function(data) {
                        return column.getFieldValue(data);
                    };
                    else lookupFunc = function(data) {
                        return data[group];
                    };
                }
                this.groupIDLookups.push({
                    field: typeof group === "function" ? false : group,
                    func: lookupFunc,
                    values: this.allowedValues ? this.allowedValues[i] : false
                });
            });
            if (startOpen) {
                if (!Array.isArray(startOpen)) startOpen = [
                    startOpen
                ];
                startOpen.forEach((level)=>{});
                this.startOpen = startOpen;
            }
            if (groupHeader) this.headerGenerator = Array.isArray(groupHeader) ? groupHeader : [
                groupHeader
            ];
        } else {
            this.groupList = [];
            this.groups = {};
        }
    }
    rowSample(rows, prevValue) {
        if (this.table.options.groupBy) {
            var group = this.getGroups(false)[0];
            prevValue.push(group.getRows(false)[0]);
        }
        return prevValue;
    }
    virtualRenderFill() {
        var el = this.table.rowManager.tableElement;
        var rows = this.table.rowManager.getVisibleRows();
        if (this.table.options.groupBy) {
            rows = rows.filter((row)=>{
                return row.type !== "group";
            });
            el.style.minWidth = !rows.length ? this.table.columnManager.getWidth() + "px" : "";
        } else return rows;
    }
    rowAddingIndex(row, index, top) {
        if (this.table.options.groupBy) {
            this.assignRowToGroup(row);
            var groupRows = row.modules.group.rows;
            if (groupRows.length > 1) {
                if (!index || index && groupRows.indexOf(index) == -1) {
                    if (top) {
                        if (groupRows[0] !== row) {
                            index = groupRows[0];
                            this.table.rowManager.moveRowInArray(row.modules.group.rows, row, index, !top);
                        }
                    } else if (groupRows[groupRows.length - 1] !== row) {
                        index = groupRows[groupRows.length - 1];
                        this.table.rowManager.moveRowInArray(row.modules.group.rows, row, index, !top);
                    }
                } else this.table.rowManager.moveRowInArray(row.modules.group.rows, row, index, !top);
            }
            return index;
        }
    }
    trackChanges() {
        this.dispatch("group-changed");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    setGroupBy(groups) {
        this.table.options.groupBy = groups;
        if (!this.initialized) this.initialize();
        this.configureGroupSetup();
        if (!groups && this.table.modExists("columnCalcs") && this.table.options.columnCalcs === true) this.table.modules.columnCalcs.reinitializeCalcs();
        this.refreshData();
        this.trackChanges();
    }
    setGroupValues(groupValues) {
        this.table.options.groupValues = groupValues;
        this.configureGroupSetup();
        this.refreshData();
        this.trackChanges();
    }
    setGroupStartOpen(values) {
        this.table.options.groupStartOpen = values;
        this.configureGroupSetup();
        if (this.table.options.groupBy) {
            this.refreshData();
            this.trackChanges();
        } else console.warn("Grouping Update - cant refresh view, no groups have been set");
    }
    setGroupHeader(values) {
        this.table.options.groupHeader = values;
        this.configureGroupSetup();
        if (this.table.options.groupBy) {
            this.refreshData();
            this.trackChanges();
        } else console.warn("Grouping Update - cant refresh view, no groups have been set");
    }
    userGetGroups(values) {
        return this.getGroups(true);
    }
    // get grouped table data in the same format as getData()
    userGetGroupedData() {
        return this.table.options.groupBy ? this.getGroupedData() : this.getData();
    }
    ///////////////////////////////////////
    ///////// Component Functions /////////
    ///////////////////////////////////////
    rowGetGroup(row) {
        return row.modules.group ? row.modules.group.getComponent() : false;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    rowMoving(from, to, after) {
        if (this.table.options.groupBy) {
            if (!after && to instanceof $517dee46856d349e$var$Group) to = this.table.rowManager.prevDisplayRow(from) || to;
            var toGroup = to instanceof $517dee46856d349e$var$Group ? to : to.modules.group;
            var fromGroup = from instanceof $517dee46856d349e$var$Group ? from : from.modules.group;
            if (toGroup === fromGroup) this.table.rowManager.moveRowInArray(toGroup.rows, from, to, after);
            else {
                if (fromGroup) fromGroup.removeRow(from);
                toGroup.insertRow(from, to, after);
            }
        }
    }
    rowDeleting(row) {
        //remove from group
        if (this.table.options.groupBy && row.modules.group) row.modules.group.removeRow(row);
    }
    rowsUpdated(row) {
        if (this.table.options.groupBy) this.updateGroupRows(true);
    }
    cellUpdated(cell) {
        if (this.table.options.groupBy) this.reassignRowToGroup(cell.row);
    }
    //return appropriate rows with group headers
    getRows(rows) {
        if (this.table.options.groupBy && this.groupIDLookups.length) {
            this.dispatchExternal("dataGrouping");
            this.generateGroups(rows);
            if (this.subscribedExternal("dataGrouped")) this.dispatchExternal("dataGrouped", this.getGroups(true));
            return this.updateGroupRows();
        } else return rows.slice(0);
    }
    getGroups(component) {
        var groupComponents = [];
        this.groupList.forEach(function(group) {
            groupComponents.push(component ? group.getComponent() : group);
        });
        return groupComponents;
    }
    getChildGroups(group) {
        var groupComponents = [];
        if (!group) group = this;
        group.groupList.forEach((child)=>{
            if (child.groupList.length) groupComponents = groupComponents.concat(this.getChildGroups(child));
            else groupComponents.push(child);
        });
        return groupComponents;
    }
    wipe() {
        if (this.table.options.groupBy) {
            this.groupList.forEach(function(group) {
                group.wipe();
            });
            this.groupList = [];
            this.groups = {};
        }
    }
    pullGroupListData(groupList) {
        var groupListData = [];
        groupList.forEach((group)=>{
            var groupHeader = {};
            groupHeader.level = 0;
            groupHeader.rowCount = 0;
            groupHeader.headerContent = "";
            var childData = [];
            if (group.hasSubGroups) {
                childData = this.pullGroupListData(group.groupList);
                groupHeader.level = group.level;
                groupHeader.rowCount = childData.length - group.groupList.length; // data length minus number of sub-headers
                groupHeader.headerContent = group.generator(group.key, groupHeader.rowCount, group.rows, group);
                groupListData.push(groupHeader);
                groupListData = groupListData.concat(childData);
            } else {
                groupHeader.level = group.level;
                groupHeader.headerContent = group.generator(group.key, group.rows.length, group.rows, group);
                groupHeader.rowCount = group.getRows().length;
                groupListData.push(groupHeader);
                group.getRows().forEach((row)=>{
                    groupListData.push(row.getData("data"));
                });
            }
        });
        return groupListData;
    }
    getGroupedData() {
        return this.pullGroupListData(this.groupList);
    }
    getRowGroup(row) {
        var match = false;
        if (this.options("dataTree")) row = this.table.modules.dataTree.getTreeParentRoot(row);
        this.groupList.forEach((group)=>{
            var result = group.getRowGroup(row);
            if (result) match = result;
        });
        return match;
    }
    countGroups() {
        return this.groupList.length;
    }
    generateGroups(rows) {
        var oldGroups = this.groups;
        this.groups = {};
        this.groupList = [];
        if (this.allowedValues && this.allowedValues[0]) {
            this.allowedValues[0].forEach((value)=>{
                this.createGroup(value, 0, oldGroups);
            });
            rows.forEach((row)=>{
                this.assignRowToExistingGroup(row, oldGroups);
            });
        } else rows.forEach((row)=>{
            this.assignRowToGroup(row, oldGroups);
        });
        Object.values(oldGroups).forEach((group)=>{
            group.wipe(true);
        });
    }
    createGroup(groupID, level, oldGroups) {
        var groupKey = level + "_" + groupID, group;
        oldGroups = oldGroups || [];
        group = new $517dee46856d349e$var$Group(this, false, level, groupID, this.groupIDLookups[0].field, this.headerGenerator[0], oldGroups[groupKey]);
        this.groups[groupKey] = group;
        this.groupList.push(group);
    }
    assignRowToExistingGroup(row, oldGroups) {
        var groupID = this.groupIDLookups[0].func(row.getData()), groupKey = "0_" + groupID;
        if (this.groups[groupKey]) this.groups[groupKey].addRow(row);
    }
    assignRowToGroup(row, oldGroups) {
        var groupID = this.groupIDLookups[0].func(row.getData()), newGroupNeeded = !this.groups["0_" + groupID];
        if (newGroupNeeded) this.createGroup(groupID, 0, oldGroups);
        this.groups["0_" + groupID].addRow(row);
        return !newGroupNeeded;
    }
    reassignRowToGroup(row) {
        if (row.type === "row") {
            var oldRowGroup = row.modules.group, oldGroupPath = oldRowGroup.getPath(), newGroupPath = this.getExpectedPath(row), samePath;
            // figure out if new group path is the same as old group path
            samePath = oldGroupPath.length == newGroupPath.length && oldGroupPath.every((element, index)=>{
                return element === newGroupPath[index];
            });
            // refresh if they new path and old path aren't the same (aka the row's groupings have changed)
            if (!samePath) {
                oldRowGroup.removeRow(row);
                this.assignRowToGroup(row, this.groups);
                this.refreshData(true);
            }
        }
    }
    getExpectedPath(row) {
        var groupPath = [], rowData = row.getData();
        this.groupIDLookups.forEach((groupId)=>{
            groupPath.push(groupId.func(rowData));
        });
        return groupPath;
    }
    updateGroupRows(force) {
        var output = [];
        if (!this.blockRedraw) {
            this.groupList.forEach((group)=>{
                output = output.concat(group.getHeadersAndRows());
            });
            if (force) this.refreshData(true);
        }
        return output;
    }
    scrollHeaders(left) {
        if (this.table.options.groupBy) {
            if (this.table.options.renderHorizontal === "virtual") left -= this.table.columnManager.renderer.vDomPadLeft;
            left = left + "px";
            this.groupList.forEach((group)=>{
                group.scrollHeader(left);
            });
        }
    }
    removeGroup(group) {
        var groupKey = group.level + "_" + group.key, index;
        if (this.groups[groupKey]) {
            delete this.groups[groupKey];
            index = this.groupList.indexOf(group);
            if (index > -1) this.groupList.splice(index, 1);
        }
    }
    checkBasicModeGroupHeaderWidth() {
        var element = this.table.rowManager.tableElement, onlyGroupHeaders = true;
        this.table.rowManager.getDisplayRows().forEach((row, index)=>{
            this.table.rowManager.styleRow(row, index);
            element.appendChild(row.getElement());
            row.initialize(true);
            if (row.type !== "group") onlyGroupHeaders = false;
        });
        if (onlyGroupHeaders) element.style.minWidth = this.table.columnManager.getWidth() + "px";
        else element.style.minWidth = "";
    }
}
var $517dee46856d349e$var$defaultUndoers = {
    cellEdit: function(action) {
        action.component.setValueProcessData(action.data.oldValue);
        action.component.cellRendered();
    },
    rowAdd: function(action) {
        action.component.deleteActual();
        this.table.rowManager.checkPlaceholder();
    },
    rowDelete: function(action) {
        var newRow = this.table.rowManager.addRowActual(action.data.data, action.data.pos, action.data.index);
        if (this.table.options.groupBy && this.table.modExists("groupRows")) this.table.modules.groupRows.updateGroupRows(true);
        this._rebindRow(action.component, newRow);
        this.table.rowManager.checkPlaceholder();
    },
    rowMove: function(action) {
        var after = action.data.posFrom - action.data.posTo > 0;
        this.table.rowManager.moveRowActual(action.component, this.table.rowManager.getRowFromPosition(action.data.posFrom), after);
        this.table.rowManager.regenerateRowPositions();
        this.table.rowManager.reRenderInPosition();
    }
};
var $517dee46856d349e$var$defaultRedoers = {
    cellEdit: function(action) {
        action.component.setValueProcessData(action.data.newValue);
        action.component.cellRendered();
    },
    rowAdd: function(action) {
        var newRow = this.table.rowManager.addRowActual(action.data.data, action.data.pos, action.data.index);
        if (this.table.options.groupBy && this.table.modExists("groupRows")) this.table.modules.groupRows.updateGroupRows(true);
        this._rebindRow(action.component, newRow);
        this.table.rowManager.checkPlaceholder();
    },
    rowDelete: function(action) {
        action.component.deleteActual();
        this.table.rowManager.checkPlaceholder();
    },
    rowMove: function(action) {
        this.table.rowManager.moveRowActual(action.component, this.table.rowManager.getRowFromPosition(action.data.posTo), action.data.after);
        this.table.rowManager.regenerateRowPositions();
        this.table.rowManager.reRenderInPosition();
    }
};
var $517dee46856d349e$var$bindings$1 = {
    undo: [
        "ctrl + 90",
        "meta + 90"
    ],
    redo: [
        "ctrl + 89",
        "meta + 89"
    ]
};
var $517dee46856d349e$var$actions$1 = {
    undo: function(e) {
        var cell = false;
        if (this.table.options.history && this.table.modExists("history") && this.table.modExists("edit")) {
            cell = this.table.modules.edit.currentCell;
            if (!cell) {
                e.preventDefault();
                this.table.modules.history.undo();
            }
        }
    },
    redo: function(e) {
        var cell = false;
        if (this.table.options.history && this.table.modExists("history") && this.table.modExists("edit")) {
            cell = this.table.modules.edit.currentCell;
            if (!cell) {
                e.preventDefault();
                this.table.modules.history.redo();
            }
        }
    }
};
var $517dee46856d349e$var$extensions$3 = {
    keybindings: {
        bindings: $517dee46856d349e$var$bindings$1,
        actions: $517dee46856d349e$var$actions$1
    }
};
class $517dee46856d349e$export$173658fc60691186 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "history";
    static moduleExtensions = $517dee46856d349e$var$extensions$3;
    //load defaults
    static undoers = $517dee46856d349e$var$defaultUndoers;
    static redoers = $517dee46856d349e$var$defaultRedoers;
    constructor(table){
        super(table);
        this.history = [];
        this.index = -1;
        this.registerTableOption("history", false); //enable edit history
    }
    initialize() {
        if (this.table.options.history) {
            this.subscribe("cell-value-updated", this.cellUpdated.bind(this));
            this.subscribe("cell-delete", this.clearComponentHistory.bind(this));
            this.subscribe("row-delete", this.rowDeleted.bind(this));
            this.subscribe("rows-wipe", this.clear.bind(this));
            this.subscribe("row-added", this.rowAdded.bind(this));
            this.subscribe("row-move", this.rowMoved.bind(this));
        }
        this.registerTableFunction("undo", this.undo.bind(this));
        this.registerTableFunction("redo", this.redo.bind(this));
        this.registerTableFunction("getHistoryUndoSize", this.getHistoryUndoSize.bind(this));
        this.registerTableFunction("getHistoryRedoSize", this.getHistoryRedoSize.bind(this));
        this.registerTableFunction("clearHistory", this.clear.bind(this));
    }
    rowMoved(from, to, after) {
        this.action("rowMove", from, {
            posFrom: from.getPosition(),
            posTo: to.getPosition(),
            to: to,
            after: after
        });
    }
    rowAdded(row, data, pos, index) {
        this.action("rowAdd", row, {
            data: data,
            pos: pos,
            index: index
        });
    }
    rowDeleted(row) {
        var index, rows;
        if (this.table.options.groupBy) {
            rows = row.getComponent().getGroup()._getSelf().rows;
            index = rows.indexOf(row);
            if (index) index = rows[index - 1];
        } else {
            index = row.table.rowManager.getRowIndex(row);
            if (index) index = row.table.rowManager.rows[index - 1];
        }
        this.action("rowDelete", row, {
            data: row.getData(),
            pos: !index,
            index: index
        });
    }
    cellUpdated(cell) {
        this.action("cellEdit", cell, {
            oldValue: cell.oldValue,
            newValue: cell.value
        });
    }
    clear() {
        this.history = [];
        this.index = -1;
    }
    action(type, component, data) {
        this.history = this.history.slice(0, this.index + 1);
        this.history.push({
            type: type,
            component: component,
            data: data
        });
        this.index++;
    }
    getHistoryUndoSize() {
        return this.index + 1;
    }
    getHistoryRedoSize() {
        return this.history.length - (this.index + 1);
    }
    clearComponentHistory(component) {
        var index = this.history.findIndex(function(item) {
            return item.component === component;
        });
        if (index > -1) {
            this.history.splice(index, 1);
            if (index <= this.index) this.index--;
            this.clearComponentHistory(component);
        }
    }
    undo() {
        if (this.index > -1) {
            let action = this.history[this.index];
            $517dee46856d349e$export$173658fc60691186.undoers[action.type].call(this, action);
            this.index--;
            this.dispatchExternal("historyUndo", action.type, action.component.getComponent(), action.data);
            return true;
        } else {
            console.warn(this.options("history") ? "History Undo Error - No more history to undo" : "History module not enabled");
            return false;
        }
    }
    redo() {
        if (this.history.length - 1 > this.index) {
            this.index++;
            let action = this.history[this.index];
            $517dee46856d349e$export$173658fc60691186.redoers[action.type].call(this, action);
            this.dispatchExternal("historyRedo", action.type, action.component.getComponent(), action.data);
            return true;
        } else {
            console.warn(this.options("history") ? "History Redo Error - No more history to redo" : "History module not enabled");
            return false;
        }
    }
    //rebind rows to new element after deletion
    _rebindRow(oldRow, newRow) {
        this.history.forEach(function(action) {
            if (action.component instanceof $517dee46856d349e$var$Row) {
                if (action.component === oldRow) action.component = newRow;
            } else if (action.component instanceof $517dee46856d349e$var$Cell) {
                if (action.component.row === oldRow) {
                    var field = action.component.column.getField();
                    if (field) action.component = newRow.getCell(field);
                }
            }
        });
    }
}
class $517dee46856d349e$export$b0b448c470bac827 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "htmlTableImport";
    constructor(table){
        super(table);
        this.fieldIndex = [];
        this.hasIndex = false;
    }
    initialize() {
        this.tableElementCheck();
    }
    tableElementCheck() {
        if (this.table.originalElement && this.table.originalElement.tagName === "TABLE") {
            if (this.table.originalElement.childNodes.length) this.parseTable();
            else console.warn("Unable to parse data from empty table tag, Tabulator should be initialized on a div tag unless importing data from a table element.");
        }
    }
    parseTable() {
        var element = this.table.originalElement, options = this.table.options, headers = element.getElementsByTagName("th"), rows = element.getElementsByTagName("tbody")[0], data = [];
        this.hasIndex = false;
        this.dispatchExternal("htmlImporting");
        rows = rows ? rows.getElementsByTagName("tr") : [];
        //check for Tabulator inline options
        this._extractOptions(element, options);
        if (headers.length) this._extractHeaders(headers, rows);
        else this._generateBlankHeaders(headers, rows);
        //iterate through table rows and build data set
        for(var index = 0; index < rows.length; index++){
            var row = rows[index], cells = row.getElementsByTagName("td"), item = {};
            //create index if the don't exist in table
            if (!this.hasIndex) item[options.index] = index;
            for(var i = 0; i < cells.length; i++){
                var cell = cells[i];
                if (typeof this.fieldIndex[i] !== "undefined") item[this.fieldIndex[i]] = cell.innerHTML;
            }
            //add row data to item
            data.push(item);
        }
        options.data = data;
        this.dispatchExternal("htmlImported");
    }
    //extract tabulator attribute options
    _extractOptions(element, options, defaultOptions) {
        var attributes = element.attributes;
        var optionsArr = defaultOptions ? Object.keys(defaultOptions) : Object.keys(options);
        var optionsList = {};
        optionsArr.forEach((item)=>{
            optionsList[item.toLowerCase()] = item;
        });
        for(var index in attributes){
            var attrib = attributes[index];
            var name;
            if (attrib && typeof attrib == "object" && attrib.name && attrib.name.indexOf("tabulator-") === 0) {
                name = attrib.name.replace("tabulator-", "");
                if (typeof optionsList[name] !== "undefined") options[optionsList[name]] = this._attribValue(attrib.value);
            }
        }
    }
    //get value of attribute
    _attribValue(value) {
        if (value === "true") return true;
        if (value === "false") return false;
        return value;
    }
    //find column if it has already been defined
    _findCol(title) {
        var match = this.table.options.columns.find((column)=>{
            return column.title === title;
        });
        return match || false;
    }
    //extract column from headers
    _extractHeaders(headers, rows) {
        for(var index = 0; index < headers.length; index++){
            var header = headers[index], exists = false, col = this._findCol(header.textContent), width;
            if (col) exists = true;
            else col = {
                title: header.textContent.trim()
            };
            if (!col.field) col.field = header.textContent.trim().toLowerCase().replaceAll(" ", "_");
            width = header.getAttribute("width");
            if (width && !col.width) col.width = width;
            //check for Tabulator inline options
            this._extractOptions(header, col, this.table.columnManager.optionsList.registeredDefaults);
            this.fieldIndex[index] = col.field;
            if (col.field == this.table.options.index) this.hasIndex = true;
            if (!exists) this.table.options.columns.push(col);
        }
    }
    //generate blank headers
    _generateBlankHeaders(headers, rows) {
        for(var index = 0; index < headers.length; index++){
            var header = headers[index], col = {
                title: "",
                field: "col" + index
            };
            this.fieldIndex[index] = col.field;
            var width = header.getAttribute("width");
            if (width) col.width = width;
            this.table.options.columns.push(col);
        }
    }
}
function $517dee46856d349e$var$csv(input) {
    var data = [], row = 0, col = 0, inQuote = false;
    //Iterate over each character
    for(let index = 0; index < input.length; index++){
        let char = input[index], nextChar = input[index + 1];
        //Initialize empty row
        if (!data[row]) data[row] = [];
        //Initialize empty column
        if (!data[row][col]) data[row][col] = "";
        //Handle quotation mark inside string
        if (char == '"' && inQuote && nextChar == '"') {
            data[row][col] += char;
            index++;
            continue;
        }
        //Begin / End Quote
        if (char == '"') {
            inQuote = !inQuote;
            continue;
        }
        //Next column (if not in quote)
        if (char == ',' && !inQuote) {
            col++;
            continue;
        }
        //New row if new line and not in quote (CRLF) 
        if (char == '\r' && nextChar == '\n' && !inQuote) {
            col = 0;
            row++;
            index++;
            continue;
        }
        //New row if new line and not in quote (CR or LF) 
        if ((char == '\r' || char == '\n') && !inQuote) {
            col = 0;
            row++;
            continue;
        }
        //Normal Character, append to column
        data[row][col] += char;
    }
    return data;
}
function $517dee46856d349e$var$json(input) {
    try {
        return JSON.parse(input);
    } catch (e) {
        console.warn("JSON Import Error - File contents is invalid JSON", e);
        return Promise.reject();
    }
}
function $517dee46856d349e$var$array$1(input) {
    return input;
}
function $517dee46856d349e$var$xlsx(input) {
    var XLSXLib = this.dependencyRegistry.lookup("XLSX"), workbook2 = XLSXLib.read(input), sheet = workbook2.Sheets[workbook2.SheetNames[0]];
    return XLSXLib.utils.sheet_to_json(sheet, {
        header: 1
    });
}
var $517dee46856d349e$var$defaultImporters = {
    csv: $517dee46856d349e$var$csv,
    json: $517dee46856d349e$var$json,
    array: $517dee46856d349e$var$array$1,
    xlsx: $517dee46856d349e$var$xlsx
};
class $517dee46856d349e$export$bceca318c211ca25 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "import";
    //load defaults
    static importers = $517dee46856d349e$var$defaultImporters;
    constructor(table){
        super(table);
        this.registerTableOption("importFormat");
        this.registerTableOption("importReader", "text");
        this.registerTableOption("importHeaderTransform");
        this.registerTableOption("importValueTransform");
        this.registerTableOption("importDataValidator");
        this.registerTableOption("importFileValidator");
    }
    initialize() {
        this.registerTableFunction("import", this.importFromFile.bind(this));
        if (this.table.options.importFormat) {
            this.subscribe("data-loading", this.loadDataCheck.bind(this), 10);
            this.subscribe("data-load", this.loadData.bind(this), 10);
        }
    }
    loadDataCheck(data) {
        return this.table.options.importFormat && (typeof data === "string" || Array.isArray(data) && data.length && Array.isArray(data));
    }
    loadData(data, params, config, silent, previousData) {
        return this.importData(this.lookupImporter(), data).then(this.structureData.bind(this)).catch((err)=>{
            console.error("Import Error:", err || "Unable to import data");
            return Promise.reject(err);
        });
    }
    lookupImporter(importFormat) {
        var importer;
        if (!importFormat) importFormat = this.table.options.importFormat;
        if (typeof importFormat === "string") importer = $517dee46856d349e$export$bceca318c211ca25.importers[importFormat];
        else importer = importFormat;
        if (!importer) console.error("Import Error - Importer not found:", importFormat);
        return importer;
    }
    importFromFile(importFormat, extension, importReader) {
        var importer = this.lookupImporter(importFormat);
        if (importer) return this.pickFile(extension, importReader).then(this.importData.bind(this, importer)).then(this.structureData.bind(this)).then(this.mutateData.bind(this)).then(this.validateData.bind(this)).then(this.setData.bind(this)).catch((err)=>{
            this.dispatch("import-error", err);
            this.dispatchExternal("importError", err);
            console.error("Import Error:", err || "Unable to import file");
            this.table.dataLoader.alertError();
            setTimeout(()=>{
                this.table.dataLoader.clearAlert();
            }, 3000);
            return Promise.reject(err);
        });
    }
    pickFile(extensions, importReader) {
        return new Promise((resolve, reject)=>{
            var input = document.createElement("input");
            input.type = "file";
            input.accept = extensions;
            input.addEventListener("change", (e)=>{
                var file = input.files[0], reader = new FileReader(), valid = this.validateFile(file);
                if (valid === true) {
                    this.dispatch("import-importing", input.files);
                    this.dispatchExternal("importImporting", input.files);
                    switch(importReader || this.table.options.importReader){
                        case "buffer":
                            reader.readAsArrayBuffer(file);
                            break;
                        case "binary":
                            reader.readAsBinaryString(file);
                            break;
                        case "url":
                            reader.readAsDataURL(file);
                            break;
                        case "text":
                        default:
                            reader.readAsText(file);
                    }
                    reader.onload = (e)=>{
                        resolve(reader.result);
                    };
                    reader.onerror = (e)=>{
                        console.warn("File Load Error - Unable to read file");
                        reject(e);
                    };
                } else reject(valid);
            });
            this.dispatch("import-choose");
            this.dispatchExternal("importChoose");
            input.click();
        });
    }
    importData(importer, fileContents) {
        var data;
        this.table.dataLoader.alertLoader();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                data = importer.call(this.table, fileContents);
                if (data instanceof Promise) resolve(data);
                else data ? resolve(data) : reject();
            }, 10);
        });
    }
    structureData(parsedData) {
        var data = [];
        if (Array.isArray(parsedData) && parsedData.length && Array.isArray(parsedData[0])) {
            if (this.table.options.autoColumns) data = this.structureArrayToObject(parsedData);
            else data = this.structureArrayToColumns(parsedData);
            return data;
        } else return parsedData;
    }
    mutateData(data) {
        var output = [];
        if (Array.isArray(data)) data.forEach((row)=>{
            output.push(this.table.modules.mutator.transformRow(row, "import"));
        });
        else output = data;
        return output;
    }
    transformHeader(headers) {
        var output = [];
        if (this.table.options.importHeaderTransform) headers.forEach((item)=>{
            output.push(this.table.options.importHeaderTransform.call(this.table, item, headers));
        });
        else return headers;
        return output;
    }
    transformData(row) {
        var output = [];
        if (this.table.options.importValueTransform) row.forEach((item)=>{
            output.push(this.table.options.importValueTransform.call(this.table, item, row));
        });
        else return row;
        return output;
    }
    structureArrayToObject(parsedData) {
        var columns = this.transformHeader(parsedData.shift());
        var data = parsedData.map((values)=>{
            var row = {};
            values = this.transformData(values);
            columns.forEach((key, i)=>{
                row[key] = values[i];
            });
            return row;
        });
        return data;
    }
    structureArrayToColumns(parsedData) {
        var data = [], firstRow = this.transformHeader(parsedData[0]), columns = this.table.getColumns();
        //remove first row if it is the column names
        if (columns[0] && firstRow[0]) {
            if (columns[0].getDefinition().title === firstRow[0]) parsedData.shift();
        }
        //convert row arrays to objects
        parsedData.forEach((rowData)=>{
            var row = {};
            rowData = this.transformData(rowData);
            rowData.forEach((value, index)=>{
                var column = columns[index];
                if (column) row[column.getField()] = value;
            });
            data.push(row);
        });
        return data;
    }
    validateFile(file) {
        if (this.table.options.importFileValidator) return this.table.options.importFileValidator.call(this.table, file);
        return true;
    }
    validateData(data) {
        var result;
        if (this.table.options.importDataValidator) {
            result = this.table.options.importDataValidator.call(this.table, data);
            if (result === true) return data;
            else return Promise.reject(result);
        }
        return data;
    }
    setData(data) {
        this.dispatch("import-imported", data);
        this.dispatchExternal("importImported", data);
        this.table.dataLoader.clearAlert();
        return this.table.setData(data);
    }
}
class $517dee46856d349e$export$69fa60f71dd0541a extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "interaction";
    constructor(table){
        super(table);
        this.eventMap = {
            //row events
            rowClick: "row-click",
            rowDblClick: "row-dblclick",
            rowContext: "row-contextmenu",
            rowMouseEnter: "row-mouseenter",
            rowMouseLeave: "row-mouseleave",
            rowMouseOver: "row-mouseover",
            rowMouseOut: "row-mouseout",
            rowMouseMove: "row-mousemove",
            rowMouseDown: "row-mousedown",
            rowMouseUp: "row-mouseup",
            rowTap: "row",
            rowDblTap: "row",
            rowTapHold: "row",
            //cell events
            cellClick: "cell-click",
            cellDblClick: "cell-dblclick",
            cellContext: "cell-contextmenu",
            cellMouseEnter: "cell-mouseenter",
            cellMouseLeave: "cell-mouseleave",
            cellMouseOver: "cell-mouseover",
            cellMouseOut: "cell-mouseout",
            cellMouseMove: "cell-mousemove",
            cellMouseDown: "cell-mousedown",
            cellMouseUp: "cell-mouseup",
            cellTap: "cell",
            cellDblTap: "cell",
            cellTapHold: "cell",
            //column header events
            headerClick: "column-click",
            headerDblClick: "column-dblclick",
            headerContext: "column-contextmenu",
            headerMouseEnter: "column-mouseenter",
            headerMouseLeave: "column-mouseleave",
            headerMouseOver: "column-mouseover",
            headerMouseOut: "column-mouseout",
            headerMouseMove: "column-mousemove",
            headerMouseDown: "column-mousedown",
            headerMouseUp: "column-mouseup",
            headerTap: "column",
            headerDblTap: "column",
            headerTapHold: "column",
            //group header
            groupClick: "group-click",
            groupDblClick: "group-dblclick",
            groupContext: "group-contextmenu",
            groupMouseEnter: "group-mouseenter",
            groupMouseLeave: "group-mouseleave",
            groupMouseOver: "group-mouseover",
            groupMouseOut: "group-mouseout",
            groupMouseMove: "group-mousemove",
            groupMouseDown: "group-mousedown",
            groupMouseUp: "group-mouseup",
            groupTap: "group",
            groupDblTap: "group",
            groupTapHold: "group"
        };
        this.subscribers = {};
        this.touchSubscribers = {};
        this.columnSubscribers = {};
        this.touchWatchers = {
            row: {
                tap: null,
                tapDbl: null,
                tapHold: null
            },
            cell: {
                tap: null,
                tapDbl: null,
                tapHold: null
            },
            column: {
                tap: null,
                tapDbl: null,
                tapHold: null
            },
            group: {
                tap: null,
                tapDbl: null,
                tapHold: null
            }
        };
        this.registerColumnOption("headerClick");
        this.registerColumnOption("headerDblClick");
        this.registerColumnOption("headerContext");
        this.registerColumnOption("headerMouseEnter");
        this.registerColumnOption("headerMouseLeave");
        this.registerColumnOption("headerMouseOver");
        this.registerColumnOption("headerMouseOut");
        this.registerColumnOption("headerMouseMove");
        this.registerColumnOption("headerMouseDown");
        this.registerColumnOption("headerMouseUp");
        this.registerColumnOption("headerTap");
        this.registerColumnOption("headerDblTap");
        this.registerColumnOption("headerTapHold");
        this.registerColumnOption("cellClick");
        this.registerColumnOption("cellDblClick");
        this.registerColumnOption("cellContext");
        this.registerColumnOption("cellMouseEnter");
        this.registerColumnOption("cellMouseLeave");
        this.registerColumnOption("cellMouseOver");
        this.registerColumnOption("cellMouseOut");
        this.registerColumnOption("cellMouseMove");
        this.registerColumnOption("cellMouseDown");
        this.registerColumnOption("cellMouseUp");
        this.registerColumnOption("cellTap");
        this.registerColumnOption("cellDblTap");
        this.registerColumnOption("cellTapHold");
    }
    initialize() {
        this.initializeExternalEvents();
        this.subscribe("column-init", this.initializeColumn.bind(this));
        this.subscribe("cell-dblclick", this.cellContentsSelectionFixer.bind(this));
        this.subscribe("scroll-horizontal", this.clearTouchWatchers.bind(this));
        this.subscribe("scroll-vertical", this.clearTouchWatchers.bind(this));
    }
    clearTouchWatchers() {
        var types = Object.values(this.touchWatchers);
        types.forEach((type)=>{
            for(let key in type)type[key] = null;
        });
    }
    cellContentsSelectionFixer(e, cell) {
        var range;
        if (this.table.modExists("edit")) {
            if (this.table.modules.edit.currentCell === cell) return; //prevent instant selection of editor content
        }
        e.preventDefault();
        try {
            if (document.selection) {
                range = document.body.createTextRange();
                range.moveToElementText(cell.getElement());
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNode(cell.getElement());
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
        } catch (e) {}
    }
    initializeExternalEvents() {
        for(let key in this.eventMap)this.subscriptionChangeExternal(key, this.subscriptionChanged.bind(this, key));
    }
    subscriptionChanged(key, added) {
        if (added) {
            if (!this.subscribers[key]) {
                if (this.eventMap[key].includes("-")) {
                    this.subscribers[key] = this.handle.bind(this, key);
                    this.subscribe(this.eventMap[key], this.subscribers[key]);
                } else this.subscribeTouchEvents(key);
            }
        } else {
            if (this.eventMap[key].includes("-")) {
                if (this.subscribers[key] && !this.columnSubscribers[key] && !this.subscribedExternal(key)) {
                    this.unsubscribe(this.eventMap[key], this.subscribers[key]);
                    delete this.subscribers[key];
                }
            } else this.unsubscribeTouchEvents(key);
        }
    }
    subscribeTouchEvents(key) {
        var type = this.eventMap[key];
        if (!this.touchSubscribers[type + "-touchstart"]) {
            this.touchSubscribers[type + "-touchstart"] = this.handleTouch.bind(this, type, "start");
            this.touchSubscribers[type + "-touchend"] = this.handleTouch.bind(this, type, "end");
            this.subscribe(type + "-touchstart", this.touchSubscribers[type + "-touchstart"]);
            this.subscribe(type + "-touchend", this.touchSubscribers[type + "-touchend"]);
        }
        this.subscribers[key] = true;
    }
    unsubscribeTouchEvents(key) {
        var noTouch = true, type = this.eventMap[key];
        if (this.subscribers[key] && !this.subscribedExternal(key)) {
            delete this.subscribers[key];
            for(let i in this.eventMap){
                if (this.eventMap[i] === type) {
                    if (this.subscribers[i]) noTouch = false;
                }
            }
            if (noTouch) {
                this.unsubscribe(type + "-touchstart", this.touchSubscribers[type + "-touchstart"]);
                this.unsubscribe(type + "-touchend", this.touchSubscribers[type + "-touchend"]);
                delete this.touchSubscribers[type + "-touchstart"];
                delete this.touchSubscribers[type + "-touchend"];
            }
        }
    }
    initializeColumn(column) {
        var def = column.definition;
        for(let key in this.eventMap)if (def[key]) {
            this.subscriptionChanged(key, true);
            if (!this.columnSubscribers[key]) this.columnSubscribers[key] = [];
            this.columnSubscribers[key].push(column);
        }
    }
    handle(action, e, component) {
        this.dispatchEvent(action, e, component);
    }
    handleTouch(type, action, e, component) {
        var watchers = this.touchWatchers[type];
        if (type === "column") type = "header";
        switch(action){
            case "start":
                watchers.tap = true;
                clearTimeout(watchers.tapHold);
                watchers.tapHold = setTimeout(()=>{
                    clearTimeout(watchers.tapHold);
                    watchers.tapHold = null;
                    watchers.tap = null;
                    clearTimeout(watchers.tapDbl);
                    watchers.tapDbl = null;
                    this.dispatchEvent(type + "TapHold", e, component);
                }, 1000);
                break;
            case "end":
                if (watchers.tap) {
                    watchers.tap = null;
                    this.dispatchEvent(type + "Tap", e, component);
                }
                if (watchers.tapDbl) {
                    clearTimeout(watchers.tapDbl);
                    watchers.tapDbl = null;
                    this.dispatchEvent(type + "DblTap", e, component);
                } else watchers.tapDbl = setTimeout(()=>{
                    clearTimeout(watchers.tapDbl);
                    watchers.tapDbl = null;
                }, 300);
                clearTimeout(watchers.tapHold);
                watchers.tapHold = null;
                break;
        }
    }
    dispatchEvent(action, e, component) {
        var componentObj = component.getComponent(), callback;
        if (this.columnSubscribers[action]) {
            if (component instanceof $517dee46856d349e$var$Cell) callback = component.column.definition[action];
            else if (component instanceof $517dee46856d349e$var$Column) callback = component.definition[action];
            if (callback) callback(e, componentObj);
        }
        this.dispatchExternal(action, e, componentObj);
    }
}
var $517dee46856d349e$var$defaultBindings = {
    navPrev: "shift + 9",
    navNext: 9,
    navUp: 38,
    navDown: 40,
    navLeft: 37,
    navRight: 39,
    scrollPageUp: 33,
    scrollPageDown: 34,
    scrollToStart: 36,
    scrollToEnd: 35
};
var $517dee46856d349e$var$defaultActions = {
    keyBlock: function(e) {
        e.stopPropagation();
        e.preventDefault();
    },
    scrollPageUp: function(e) {
        var rowManager = this.table.rowManager, newPos = rowManager.scrollTop - rowManager.element.clientHeight;
        e.preventDefault();
        if (rowManager.displayRowsCount) {
            if (newPos >= 0) rowManager.element.scrollTop = newPos;
            else rowManager.scrollToRow(rowManager.getDisplayRows()[0]);
        }
        this.table.element.focus();
    },
    scrollPageDown: function(e) {
        var rowManager = this.table.rowManager, newPos = rowManager.scrollTop + rowManager.element.clientHeight, scrollMax = rowManager.element.scrollHeight;
        e.preventDefault();
        if (rowManager.displayRowsCount) {
            if (newPos <= scrollMax) rowManager.element.scrollTop = newPos;
            else rowManager.scrollToRow(rowManager.getDisplayRows()[rowManager.displayRowsCount - 1]);
        }
        this.table.element.focus();
    },
    scrollToStart: function(e) {
        var rowManager = this.table.rowManager;
        e.preventDefault();
        if (rowManager.displayRowsCount) rowManager.scrollToRow(rowManager.getDisplayRows()[0]);
        this.table.element.focus();
    },
    scrollToEnd: function(e) {
        var rowManager = this.table.rowManager;
        e.preventDefault();
        if (rowManager.displayRowsCount) rowManager.scrollToRow(rowManager.getDisplayRows()[rowManager.displayRowsCount - 1]);
        this.table.element.focus();
    },
    navPrev: function(e) {
        this.dispatch("keybinding-nav-prev", e);
    },
    navNext: function(e) {
        this.dispatch("keybinding-nav-next", e);
    },
    navLeft: function(e) {
        this.dispatch("keybinding-nav-left", e);
    },
    navRight: function(e) {
        this.dispatch("keybinding-nav-right", e);
    },
    navUp: function(e) {
        this.dispatch("keybinding-nav-up", e);
    },
    navDown: function(e) {
        this.dispatch("keybinding-nav-down", e);
    }
};
class $517dee46856d349e$export$a0ff4f1c226a7cef extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "keybindings";
    //load defaults
    static bindings = $517dee46856d349e$var$defaultBindings;
    static actions = $517dee46856d349e$var$defaultActions;
    constructor(table){
        super(table);
        this.watchKeys = null;
        this.pressedKeys = null;
        this.keyupBinding = false;
        this.keydownBinding = false;
        this.registerTableOption("keybindings", {}); //array for keybindings
        this.registerTableOption("tabEndNewRow", false); //create new row when tab to end of table
    }
    initialize() {
        var bindings = this.table.options.keybindings, mergedBindings = {};
        this.watchKeys = {};
        this.pressedKeys = [];
        if (bindings !== false) {
            Object.assign(mergedBindings, $517dee46856d349e$export$a0ff4f1c226a7cef.bindings);
            Object.assign(mergedBindings, bindings);
            this.mapBindings(mergedBindings);
            this.bindEvents();
        }
        this.subscribe("table-destroy", this.clearBindings.bind(this));
    }
    mapBindings(bindings) {
        for(let key in bindings){
            if ($517dee46856d349e$export$a0ff4f1c226a7cef.actions[key]) {
                if (bindings[key]) {
                    if (typeof bindings[key] !== "object") bindings[key] = [
                        bindings[key]
                    ];
                    bindings[key].forEach((binding)=>{
                        var bindingList = Array.isArray(binding) ? binding : [
                            binding
                        ];
                        bindingList.forEach((item)=>{
                            this.mapBinding(key, item);
                        });
                    });
                }
            } else console.warn("Key Binding Error - no such action:", key);
        }
    }
    mapBinding(action, symbolsList) {
        var binding = {
            action: $517dee46856d349e$export$a0ff4f1c226a7cef.actions[action],
            keys: [],
            ctrl: false,
            shift: false,
            meta: false
        };
        var symbols = symbolsList.toString().toLowerCase().split(" ").join("").split("+");
        symbols.forEach((symbol)=>{
            switch(symbol){
                case "ctrl":
                    binding.ctrl = true;
                    break;
                case "shift":
                    binding.shift = true;
                    break;
                case "meta":
                    binding.meta = true;
                    break;
                default:
                    symbol = isNaN(symbol) ? symbol.toUpperCase().charCodeAt(0) : parseInt(symbol);
                    binding.keys.push(symbol);
                    if (!this.watchKeys[symbol]) this.watchKeys[symbol] = [];
                    this.watchKeys[symbol].push(binding);
            }
        });
    }
    bindEvents() {
        var self = this;
        this.keyupBinding = function(e) {
            var code = e.keyCode;
            var bindings = self.watchKeys[code];
            if (bindings) {
                self.pressedKeys.push(code);
                bindings.forEach(function(binding) {
                    self.checkBinding(e, binding);
                });
            }
        };
        this.keydownBinding = function(e) {
            var code = e.keyCode;
            var bindings = self.watchKeys[code];
            if (bindings) {
                var index = self.pressedKeys.indexOf(code);
                if (index > -1) self.pressedKeys.splice(index, 1);
            }
        };
        this.table.element.addEventListener("keydown", this.keyupBinding);
        this.table.element.addEventListener("keyup", this.keydownBinding);
    }
    clearBindings() {
        if (this.keyupBinding) this.table.element.removeEventListener("keydown", this.keyupBinding);
        if (this.keydownBinding) this.table.element.removeEventListener("keyup", this.keydownBinding);
    }
    checkBinding(e, binding) {
        var match = true;
        if (e.ctrlKey == binding.ctrl && e.shiftKey == binding.shift && e.metaKey == binding.meta) {
            binding.keys.forEach((key)=>{
                var index = this.pressedKeys.indexOf(key);
                if (index == -1) match = false;
            });
            if (match) binding.action.call(this, e);
            return true;
        }
        return false;
    }
}
class $517dee46856d349e$export$f1ab43fc4c3c5ce0 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "menu";
    constructor(table){
        super(table);
        this.menuContainer = null;
        this.nestedMenuBlock = false;
        this.currentComponent = null;
        this.rootPopup = null;
        this.columnSubscribers = {};
        // this.registerTableOption("menuContainer", undefined); //deprecated
        this.registerTableOption("rowContextMenu", false);
        this.registerTableOption("rowClickMenu", false);
        this.registerTableOption("rowDblClickMenu", false);
        this.registerTableOption("groupContextMenu", false);
        this.registerTableOption("groupClickMenu", false);
        this.registerTableOption("groupDblClickMenu", false);
        this.registerColumnOption("headerContextMenu");
        this.registerColumnOption("headerClickMenu");
        this.registerColumnOption("headerDblClickMenu");
        this.registerColumnOption("headerMenu");
        this.registerColumnOption("headerMenuIcon");
        this.registerColumnOption("contextMenu");
        this.registerColumnOption("clickMenu");
        this.registerColumnOption("dblClickMenu");
    }
    initialize() {
        this.deprecatedOptionsCheck();
        this.initializeRowWatchers();
        this.initializeGroupWatchers();
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    deprecatedOptionsCheck() {
    // if(!this.deprecationCheck("menuContainer", "popupContainer")){
    // 	this.table.options.popupContainer = this.table.options.menuContainer;
    // }
    }
    initializeRowWatchers() {
        if (this.table.options.rowContextMenu) {
            this.subscribe("row-contextmenu", this.loadMenuEvent.bind(this, this.table.options.rowContextMenu));
            this.table.on("rowTapHold", this.loadMenuEvent.bind(this, this.table.options.rowContextMenu));
        }
        if (this.table.options.rowClickMenu) this.subscribe("row-click", this.loadMenuEvent.bind(this, this.table.options.rowClickMenu));
        if (this.table.options.rowDblClickMenu) this.subscribe("row-dblclick", this.loadMenuEvent.bind(this, this.table.options.rowDblClickMenu));
    }
    initializeGroupWatchers() {
        if (this.table.options.groupContextMenu) {
            this.subscribe("group-contextmenu", this.loadMenuEvent.bind(this, this.table.options.groupContextMenu));
            this.table.on("groupTapHold", this.loadMenuEvent.bind(this, this.table.options.groupContextMenu));
        }
        if (this.table.options.groupClickMenu) this.subscribe("group-click", this.loadMenuEvent.bind(this, this.table.options.groupClickMenu));
        if (this.table.options.groupDblClickMenu) this.subscribe("group-dblclick", this.loadMenuEvent.bind(this, this.table.options.groupDblClickMenu));
    }
    initializeColumn(column) {
        var def = column.definition;
        //handle column events
        if (def.headerContextMenu && !this.columnSubscribers.headerContextMenu) {
            this.columnSubscribers.headerContextMenu = this.loadMenuTableColumnEvent.bind(this, "headerContextMenu");
            this.subscribe("column-contextmenu", this.columnSubscribers.headerContextMenu);
            this.table.on("headerTapHold", this.loadMenuTableColumnEvent.bind(this, "headerContextMenu"));
        }
        if (def.headerClickMenu && !this.columnSubscribers.headerClickMenu) {
            this.columnSubscribers.headerClickMenu = this.loadMenuTableColumnEvent.bind(this, "headerClickMenu");
            this.subscribe("column-click", this.columnSubscribers.headerClickMenu);
        }
        if (def.headerDblClickMenu && !this.columnSubscribers.headerDblClickMenu) {
            this.columnSubscribers.headerDblClickMenu = this.loadMenuTableColumnEvent.bind(this, "headerDblClickMenu");
            this.subscribe("column-dblclick", this.columnSubscribers.headerDblClickMenu);
        }
        if (def.headerMenu) this.initializeColumnHeaderMenu(column);
        //handle cell events
        if (def.contextMenu && !this.columnSubscribers.contextMenu) {
            this.columnSubscribers.contextMenu = this.loadMenuTableCellEvent.bind(this, "contextMenu");
            this.subscribe("cell-contextmenu", this.columnSubscribers.contextMenu);
            this.table.on("cellTapHold", this.loadMenuTableCellEvent.bind(this, "contextMenu"));
        }
        if (def.clickMenu && !this.columnSubscribers.clickMenu) {
            this.columnSubscribers.clickMenu = this.loadMenuTableCellEvent.bind(this, "clickMenu");
            this.subscribe("cell-click", this.columnSubscribers.clickMenu);
        }
        if (def.dblClickMenu && !this.columnSubscribers.dblClickMenu) {
            this.columnSubscribers.dblClickMenu = this.loadMenuTableCellEvent.bind(this, "dblClickMenu");
            this.subscribe("cell-dblclick", this.columnSubscribers.dblClickMenu);
        }
    }
    initializeColumnHeaderMenu(column) {
        var icon = column.definition.headerMenuIcon, headerMenuEl;
        headerMenuEl = document.createElement("span");
        headerMenuEl.classList.add("tabulator-header-popup-button");
        if (icon) {
            if (typeof icon === "function") icon = icon(column.getComponent());
            if (icon instanceof HTMLElement) headerMenuEl.appendChild(icon);
            else headerMenuEl.innerHTML = icon;
        } else headerMenuEl.innerHTML = "&vellip;";
        headerMenuEl.addEventListener("click", (e)=>{
            e.stopPropagation();
            e.preventDefault();
            this.loadMenuEvent(column.definition.headerMenu, e, column);
        });
        column.titleElement.insertBefore(headerMenuEl, column.titleElement.firstChild);
    }
    loadMenuTableCellEvent(option, e, cell) {
        if (cell._cell) cell = cell._cell;
        if (cell.column.definition[option]) this.loadMenuEvent(cell.column.definition[option], e, cell);
    }
    loadMenuTableColumnEvent(option, e, column) {
        if (column._column) column = column._column;
        if (column.definition[option]) this.loadMenuEvent(column.definition[option], e, column);
    }
    loadMenuEvent(menu, e, component) {
        if (component._group) component = component._group;
        else if (component._row) component = component._row;
        menu = typeof menu == "function" ? menu.call(this.table, e, component.getComponent()) : menu;
        this.loadMenu(e, component, menu);
    }
    loadMenu(e, component, menu, parentEl, parentPopup) {
        var touch = !(e instanceof MouseEvent), menuEl = document.createElement("div"), popup;
        menuEl.classList.add("tabulator-menu");
        if (!touch) e.preventDefault();
        //abort if no menu set
        if (!menu || !menu.length) return;
        if (!parentEl) {
            if (this.nestedMenuBlock) {
                //abort if child menu already open
                if (this.rootPopup) return;
            } else this.nestedMenuBlock = setTimeout(()=>{
                this.nestedMenuBlock = false;
            }, 100);
            if (this.rootPopup) this.rootPopup.hide();
            this.rootPopup = popup = this.popup(menuEl);
        } else popup = parentPopup.child(menuEl);
        menu.forEach((item)=>{
            var itemEl = document.createElement("div"), label = item.label, disabled = item.disabled;
            if (item.separator) itemEl.classList.add("tabulator-menu-separator");
            else {
                itemEl.classList.add("tabulator-menu-item");
                if (typeof label == "function") label = label.call(this.table, component.getComponent());
                if (label instanceof Node) itemEl.appendChild(label);
                else itemEl.innerHTML = label;
                if (typeof disabled == "function") disabled = disabled.call(this.table, component.getComponent());
                if (disabled) {
                    itemEl.classList.add("tabulator-menu-item-disabled");
                    itemEl.addEventListener("click", (e)=>{
                        e.stopPropagation();
                    });
                } else {
                    if (item.menu && item.menu.length) itemEl.addEventListener("click", (e)=>{
                        e.stopPropagation();
                        this.loadMenu(e, component, item.menu, itemEl, popup);
                    });
                    else if (item.action) itemEl.addEventListener("click", (e)=>{
                        item.action(e, component.getComponent());
                    });
                }
                if (item.menu && item.menu.length) itemEl.classList.add("tabulator-menu-item-submenu");
            }
            menuEl.appendChild(itemEl);
        });
        menuEl.addEventListener("click", (e)=>{
            if (this.rootPopup) this.rootPopup.hide();
        });
        popup.show(parentEl || e);
        if (popup === this.rootPopup) {
            this.rootPopup.hideOnBlur(()=>{
                this.rootPopup = null;
                if (this.currentComponent) {
                    this.dispatch("menu-closed", menu, popup);
                    this.dispatchExternal("menuClosed", this.currentComponent.getComponent());
                    this.currentComponent = null;
                }
            });
            this.currentComponent = component;
            this.dispatch("menu-opened", menu, popup);
            this.dispatchExternal("menuOpened", component.getComponent());
        }
    }
}
class $517dee46856d349e$export$9ab7496e9b38c128 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "moveColumn";
    constructor(table){
        super(table);
        this.placeholderElement = this.createPlaceholderElement();
        this.hoverElement = false; //floating column header element
        this.checkTimeout = false; //click check timeout holder
        this.checkPeriod = 250; //period to wait on mousedown to consider this a move and not a click
        this.moving = false; //currently moving column
        this.toCol = false; //destination column
        this.toColAfter = false; //position of moving column relative to the destination column
        this.startX = 0; //starting position within header element
        this.autoScrollMargin = 40; //auto scroll on edge when within margin
        this.autoScrollStep = 5; //auto scroll distance in pixels
        this.autoScrollTimeout = false; //auto scroll timeout
        this.touchMove = false;
        this.moveHover = this.moveHover.bind(this);
        this.endMove = this.endMove.bind(this);
        this.registerTableOption("movableColumns", false); //enable movable columns
    }
    createPlaceholderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-col");
        el.classList.add("tabulator-col-placeholder");
        return el;
    }
    initialize() {
        if (this.table.options.movableColumns) {
            this.subscribe("column-init", this.initializeColumn.bind(this));
            this.subscribe("alert-show", this.abortMove.bind(this));
        }
    }
    abortMove() {
        clearTimeout(this.checkTimeout);
    }
    initializeColumn(column) {
        var self = this, config = {}, colEl;
        if (!column.modules.frozen && !column.isGroup && !column.isRowHeader) {
            colEl = column.getElement();
            config.mousemove = (function(e) {
                if (column.parent === self.moving.parent) {
                    if ((self.touchMove ? e.touches[0].pageX : e.pageX) - $517dee46856d349e$var$Helpers.elOffset(colEl).left + self.table.columnManager.contentsElement.scrollLeft > column.getWidth() / 2) {
                        if (self.toCol !== column || !self.toColAfter) {
                            colEl.parentNode.insertBefore(self.placeholderElement, colEl.nextSibling);
                            self.moveColumn(column, true);
                        }
                    } else if (self.toCol !== column || self.toColAfter) {
                        colEl.parentNode.insertBefore(self.placeholderElement, colEl);
                        self.moveColumn(column, false);
                    }
                }
            }).bind(self);
            colEl.addEventListener("mousedown", function(e) {
                self.touchMove = false;
                if (e.which === 1) self.checkTimeout = setTimeout(function() {
                    self.startMove(e, column);
                }, self.checkPeriod);
            });
            colEl.addEventListener("mouseup", function(e) {
                if (e.which === 1) {
                    if (self.checkTimeout) clearTimeout(self.checkTimeout);
                }
            });
            self.bindTouchEvents(column);
        }
        column.modules.moveColumn = config;
    }
    bindTouchEvents(column) {
        var colEl = column.getElement(), startXMove = false, nextCol, prevCol, nextColWidth, prevColWidth, nextColWidthLast, prevColWidthLast;
        colEl.addEventListener("touchstart", (e)=>{
            this.checkTimeout = setTimeout(()=>{
                this.touchMove = true;
                nextCol = column.nextColumn();
                nextColWidth = nextCol ? nextCol.getWidth() / 2 : 0;
                prevCol = column.prevColumn();
                prevColWidth = prevCol ? prevCol.getWidth() / 2 : 0;
                nextColWidthLast = 0;
                prevColWidthLast = 0;
                startXMove = false;
                this.startMove(e, column);
            }, this.checkPeriod);
        }, {
            passive: true
        });
        colEl.addEventListener("touchmove", (e)=>{
            var diff, moveToCol;
            if (this.moving) {
                this.moveHover(e);
                if (!startXMove) startXMove = e.touches[0].pageX;
                diff = e.touches[0].pageX - startXMove;
                if (diff > 0) {
                    if (nextCol && diff - nextColWidthLast > nextColWidth) {
                        moveToCol = nextCol;
                        if (moveToCol !== column) {
                            startXMove = e.touches[0].pageX;
                            moveToCol.getElement().parentNode.insertBefore(this.placeholderElement, moveToCol.getElement().nextSibling);
                            this.moveColumn(moveToCol, true);
                        }
                    }
                } else if (prevCol && -diff - prevColWidthLast > prevColWidth) {
                    moveToCol = prevCol;
                    if (moveToCol !== column) {
                        startXMove = e.touches[0].pageX;
                        moveToCol.getElement().parentNode.insertBefore(this.placeholderElement, moveToCol.getElement());
                        this.moveColumn(moveToCol, false);
                    }
                }
                if (moveToCol) {
                    nextCol = moveToCol.nextColumn();
                    nextColWidthLast = nextColWidth;
                    nextColWidth = nextCol ? nextCol.getWidth() / 2 : 0;
                    prevCol = moveToCol.prevColumn();
                    prevColWidthLast = prevColWidth;
                    prevColWidth = prevCol ? prevCol.getWidth() / 2 : 0;
                }
            }
        }, {
            passive: true
        });
        colEl.addEventListener("touchend", (e)=>{
            if (this.checkTimeout) clearTimeout(this.checkTimeout);
            if (this.moving) this.endMove(e);
        });
    }
    startMove(e, column) {
        var element = column.getElement(), headerElement = this.table.columnManager.getContentsElement(), headersElement = this.table.columnManager.getHeadersElement();
        //Prevent moving columns when range selection is active
        if (this.table.modules.selectRange && this.table.modules.selectRange.columnSelection) {
            if (this.table.modules.selectRange.mousedown && this.table.modules.selectRange.selecting === "column") return;
        }
        this.moving = column;
        this.startX = (this.touchMove ? e.touches[0].pageX : e.pageX) - $517dee46856d349e$var$Helpers.elOffset(element).left;
        this.table.element.classList.add("tabulator-block-select");
        //create placeholder
        this.placeholderElement.style.width = column.getWidth() + "px";
        this.placeholderElement.style.height = column.getHeight() + "px";
        element.parentNode.insertBefore(this.placeholderElement, element);
        element.parentNode.removeChild(element);
        //create hover element
        this.hoverElement = element.cloneNode(true);
        this.hoverElement.classList.add("tabulator-moving");
        headerElement.appendChild(this.hoverElement);
        this.hoverElement.style.left = "0";
        this.hoverElement.style.bottom = headerElement.clientHeight - headersElement.offsetHeight + "px";
        if (!this.touchMove) {
            this._bindMouseMove();
            document.body.addEventListener("mousemove", this.moveHover);
            document.body.addEventListener("mouseup", this.endMove);
        }
        this.moveHover(e);
        this.dispatch("column-moving", e, this.moving);
    }
    _bindMouseMove() {
        this.table.columnManager.columnsByIndex.forEach(function(column) {
            if (column.modules.moveColumn.mousemove) column.getElement().addEventListener("mousemove", column.modules.moveColumn.mousemove);
        });
    }
    _unbindMouseMove() {
        this.table.columnManager.columnsByIndex.forEach(function(column) {
            if (column.modules.moveColumn.mousemove) column.getElement().removeEventListener("mousemove", column.modules.moveColumn.mousemove);
        });
    }
    moveColumn(column, after) {
        var movingCells = this.moving.getCells();
        this.toCol = column;
        this.toColAfter = after;
        if (after) column.getCells().forEach(function(cell, i) {
            var cellEl = cell.getElement(true);
            if (cellEl.parentNode && movingCells[i]) cellEl.parentNode.insertBefore(movingCells[i].getElement(), cellEl.nextSibling);
        });
        else column.getCells().forEach(function(cell, i) {
            var cellEl = cell.getElement(true);
            if (cellEl.parentNode && movingCells[i]) cellEl.parentNode.insertBefore(movingCells[i].getElement(), cellEl);
        });
    }
    endMove(e) {
        if (e.which === 1 || this.touchMove) {
            this._unbindMouseMove();
            this.placeholderElement.parentNode.insertBefore(this.moving.getElement(), this.placeholderElement.nextSibling);
            this.placeholderElement.parentNode.removeChild(this.placeholderElement);
            this.hoverElement.parentNode.removeChild(this.hoverElement);
            this.table.element.classList.remove("tabulator-block-select");
            if (this.toCol) this.table.columnManager.moveColumnActual(this.moving, this.toCol, this.toColAfter);
            this.moving = false;
            this.toCol = false;
            this.toColAfter = false;
            if (!this.touchMove) {
                document.body.removeEventListener("mousemove", this.moveHover);
                document.body.removeEventListener("mouseup", this.endMove);
            }
        }
    }
    moveHover(e) {
        var columnHolder = this.table.columnManager.getContentsElement(), scrollLeft = columnHolder.scrollLeft, xPos = (this.touchMove ? e.touches[0].pageX : e.pageX) - $517dee46856d349e$var$Helpers.elOffset(columnHolder).left + scrollLeft, scrollPos;
        this.hoverElement.style.left = xPos - this.startX + "px";
        if (xPos - scrollLeft < this.autoScrollMargin) {
            if (!this.autoScrollTimeout) this.autoScrollTimeout = setTimeout(()=>{
                scrollPos = Math.max(0, scrollLeft - 5);
                this.table.rowManager.getElement().scrollLeft = scrollPos;
                this.autoScrollTimeout = false;
            }, 1);
        }
        if (scrollLeft + columnHolder.clientWidth - xPos < this.autoScrollMargin) {
            if (!this.autoScrollTimeout) this.autoScrollTimeout = setTimeout(()=>{
                scrollPos = Math.min(columnHolder.clientWidth, scrollLeft + 5);
                this.table.rowManager.getElement().scrollLeft = scrollPos;
                this.autoScrollTimeout = false;
            }, 1);
        }
    }
}
var $517dee46856d349e$var$defaultSenders = {
    delete: function(fromRow, toRow, toTable) {
        fromRow.delete();
    }
};
var $517dee46856d349e$var$defaultReceivers = {
    insert: function(fromRow, toRow, fromTable) {
        this.table.addRow(fromRow.getData(), undefined, toRow);
        return true;
    },
    add: function(fromRow, toRow, fromTable) {
        this.table.addRow(fromRow.getData());
        return true;
    },
    update: function(fromRow, toRow, fromTable) {
        if (toRow) {
            toRow.update(fromRow.getData());
            return true;
        }
        return false;
    },
    replace: function(fromRow, toRow, fromTable) {
        if (toRow) {
            this.table.addRow(fromRow.getData(), undefined, toRow);
            toRow.delete();
            return true;
        }
        return false;
    }
};
class $517dee46856d349e$export$7815d73158f0bb2d extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "moveRow";
    //load defaults
    static senders = $517dee46856d349e$var$defaultSenders;
    static receivers = $517dee46856d349e$var$defaultReceivers;
    constructor(table){
        super(table);
        this.placeholderElement = this.createPlaceholderElement();
        this.hoverElement = false; //floating row header element
        this.checkTimeout = false; //click check timeout holder
        this.checkPeriod = 150; //period to wait on mousedown to consider this a move and not a click
        this.moving = false; //currently moving row
        this.toRow = false; //destination row
        this.toRowAfter = false; //position of moving row relative to the destination row
        this.hasHandle = false; //row has handle instead of fully movable row
        this.startY = 0; //starting Y position within header element
        this.startX = 0; //starting X position within header element
        this.moveHover = this.moveHover.bind(this);
        this.endMove = this.endMove.bind(this);
        this.tableRowDropEvent = false;
        this.touchMove = false;
        this.connection = false;
        this.connectionSelectorsTables = false;
        this.connectionSelectorsElements = false;
        this.connectionElements = [];
        this.connections = [];
        this.connectedTable = false;
        this.connectedRow = false;
        this.registerTableOption("movableRows", false); //enable movable rows
        this.registerTableOption("movableRowsConnectedTables", false); //tables for movable rows to be connected to
        this.registerTableOption("movableRowsConnectedElements", false); //other elements for movable rows to be connected to
        this.registerTableOption("movableRowsSender", false);
        this.registerTableOption("movableRowsReceiver", "insert");
        this.registerColumnOption("rowHandle");
    }
    createPlaceholderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-row");
        el.classList.add("tabulator-row-placeholder");
        return el;
    }
    initialize() {
        if (this.table.options.movableRows) {
            this.connectionSelectorsTables = this.table.options.movableRowsConnectedTables;
            this.connectionSelectorsElements = this.table.options.movableRowsConnectedElements;
            this.connection = this.connectionSelectorsTables || this.connectionSelectorsElements;
            this.subscribe("cell-init", this.initializeCell.bind(this));
            this.subscribe("column-init", this.initializeColumn.bind(this));
            this.subscribe("row-init", this.initializeRow.bind(this));
        }
    }
    initializeGroupHeader(group) {
        var self = this, config = {};
        //inter table drag drop
        config.mouseup = (function(e) {
            self.tableRowDrop(e, group);
        }).bind(self);
        //same table drag drop
        config.mousemove = (function(e) {
            var rowEl;
            if (e.pageY - $517dee46856d349e$var$Helpers.elOffset(group.element).top + self.table.rowManager.element.scrollTop > group.getHeight() / 2) {
                if (self.toRow !== group || !self.toRowAfter) {
                    rowEl = group.getElement();
                    rowEl.parentNode.insertBefore(self.placeholderElement, rowEl.nextSibling);
                    self.moveRow(group, true);
                }
            } else if (self.toRow !== group || self.toRowAfter) {
                rowEl = group.getElement();
                if (rowEl.previousSibling) {
                    rowEl.parentNode.insertBefore(self.placeholderElement, rowEl);
                    self.moveRow(group, false);
                }
            }
        }).bind(self);
        group.modules.moveRow = config;
    }
    initializeRow(row) {
        var self = this, config = {}, rowEl;
        //inter table drag drop
        config.mouseup = (function(e) {
            self.tableRowDrop(e, row);
        }).bind(self);
        //same table drag drop
        config.mousemove = (function(e) {
            var rowEl = row.getElement();
            if (e.pageY - $517dee46856d349e$var$Helpers.elOffset(rowEl).top + self.table.rowManager.element.scrollTop > row.getHeight() / 2) {
                if (self.toRow !== row || !self.toRowAfter) {
                    rowEl.parentNode.insertBefore(self.placeholderElement, rowEl.nextSibling);
                    self.moveRow(row, true);
                }
            } else if (self.toRow !== row || self.toRowAfter) {
                rowEl.parentNode.insertBefore(self.placeholderElement, rowEl);
                self.moveRow(row, false);
            }
        }).bind(self);
        if (!this.hasHandle) {
            rowEl = row.getElement();
            rowEl.addEventListener("mousedown", function(e) {
                if (e.which === 1) self.checkTimeout = setTimeout(function() {
                    self.startMove(e, row);
                }, self.checkPeriod);
            });
            rowEl.addEventListener("mouseup", function(e) {
                if (e.which === 1) {
                    if (self.checkTimeout) clearTimeout(self.checkTimeout);
                }
            });
            this.bindTouchEvents(row, row.getElement());
        }
        row.modules.moveRow = config;
    }
    initializeColumn(column) {
        if (column.definition.rowHandle && this.table.options.movableRows !== false) this.hasHandle = true;
    }
    initializeCell(cell) {
        if (cell.column.definition.rowHandle && this.table.options.movableRows !== false) {
            var self = this, cellEl = cell.getElement(true);
            cellEl.addEventListener("mousedown", function(e) {
                if (e.which === 1) self.checkTimeout = setTimeout(function() {
                    self.startMove(e, cell.row);
                }, self.checkPeriod);
            });
            cellEl.addEventListener("mouseup", function(e) {
                if (e.which === 1) {
                    if (self.checkTimeout) clearTimeout(self.checkTimeout);
                }
            });
            this.bindTouchEvents(cell.row, cellEl);
        }
    }
    bindTouchEvents(row, element) {
        var startYMove = false, nextRow, prevRow, nextRowHeight, prevRowHeight, nextRowHeightLast, prevRowHeightLast;
        element.addEventListener("touchstart", (e)=>{
            this.checkTimeout = setTimeout(()=>{
                this.touchMove = true;
                nextRow = row.nextRow();
                nextRowHeight = nextRow ? nextRow.getHeight() / 2 : 0;
                prevRow = row.prevRow();
                prevRowHeight = prevRow ? prevRow.getHeight() / 2 : 0;
                nextRowHeightLast = 0;
                prevRowHeightLast = 0;
                startYMove = false;
                this.startMove(e, row);
            }, this.checkPeriod);
        }, {
            passive: true
        });
        this.moving, this.toRow, this.toRowAfter;
        element.addEventListener("touchmove", (e)=>{
            var diff, moveToRow;
            if (this.moving) {
                e.preventDefault();
                this.moveHover(e);
                if (!startYMove) startYMove = e.touches[0].pageY;
                diff = e.touches[0].pageY - startYMove;
                if (diff > 0) {
                    if (nextRow && diff - nextRowHeightLast > nextRowHeight) {
                        moveToRow = nextRow;
                        if (moveToRow !== row) {
                            startYMove = e.touches[0].pageY;
                            moveToRow.getElement().parentNode.insertBefore(this.placeholderElement, moveToRow.getElement().nextSibling);
                            this.moveRow(moveToRow, true);
                        }
                    }
                } else if (prevRow && -diff - prevRowHeightLast > prevRowHeight) {
                    moveToRow = prevRow;
                    if (moveToRow !== row) {
                        startYMove = e.touches[0].pageY;
                        moveToRow.getElement().parentNode.insertBefore(this.placeholderElement, moveToRow.getElement());
                        this.moveRow(moveToRow, false);
                    }
                }
                if (moveToRow) {
                    nextRow = moveToRow.nextRow();
                    nextRowHeightLast = nextRowHeight;
                    nextRowHeight = nextRow ? nextRow.getHeight() / 2 : 0;
                    prevRow = moveToRow.prevRow();
                    prevRowHeightLast = prevRowHeight;
                    prevRowHeight = prevRow ? prevRow.getHeight() / 2 : 0;
                }
            }
        });
        element.addEventListener("touchend", (e)=>{
            if (this.checkTimeout) clearTimeout(this.checkTimeout);
            if (this.moving) {
                this.endMove(e);
                this.touchMove = false;
            }
        });
    }
    _bindMouseMove() {
        this.table.rowManager.getDisplayRows().forEach((row)=>{
            if ((row.type === "row" || row.type === "group") && row.modules.moveRow && row.modules.moveRow.mousemove) row.getElement().addEventListener("mousemove", row.modules.moveRow.mousemove);
        });
    }
    _unbindMouseMove() {
        this.table.rowManager.getDisplayRows().forEach((row)=>{
            if ((row.type === "row" || row.type === "group") && row.modules.moveRow && row.modules.moveRow.mousemove) row.getElement().removeEventListener("mousemove", row.modules.moveRow.mousemove);
        });
    }
    startMove(e, row) {
        var element = row.getElement();
        this.setStartPosition(e, row);
        this.moving = row;
        this.table.element.classList.add("tabulator-block-select");
        //create placeholder
        this.placeholderElement.style.width = row.getWidth() + "px";
        this.placeholderElement.style.height = row.getHeight() + "px";
        if (!this.connection) {
            element.parentNode.insertBefore(this.placeholderElement, element);
            element.parentNode.removeChild(element);
        } else {
            this.table.element.classList.add("tabulator-movingrow-sending");
            this.connectToTables(row);
        }
        //create hover element
        this.hoverElement = element.cloneNode(true);
        this.hoverElement.classList.add("tabulator-moving");
        if (this.connection) {
            document.body.appendChild(this.hoverElement);
            this.hoverElement.style.left = "0";
            this.hoverElement.style.top = "0";
            this.hoverElement.style.width = this.table.element.clientWidth + "px";
            this.hoverElement.style.whiteSpace = "nowrap";
            this.hoverElement.style.overflow = "hidden";
            this.hoverElement.style.pointerEvents = "none";
        } else {
            this.table.rowManager.getTableElement().appendChild(this.hoverElement);
            this.hoverElement.style.left = "0";
            this.hoverElement.style.top = "0";
            this._bindMouseMove();
        }
        document.body.addEventListener("mousemove", this.moveHover);
        document.body.addEventListener("mouseup", this.endMove);
        this.dispatchExternal("rowMoving", row.getComponent());
        this.moveHover(e);
    }
    setStartPosition(e, row) {
        var pageX = this.touchMove ? e.touches[0].pageX : e.pageX, pageY = this.touchMove ? e.touches[0].pageY : e.pageY, element, position;
        element = row.getElement();
        if (this.connection) {
            position = element.getBoundingClientRect();
            this.startX = position.left - pageX + window.pageXOffset;
            this.startY = position.top - pageY + window.pageYOffset;
        } else this.startY = pageY - element.getBoundingClientRect().top;
    }
    endMove(e) {
        if (!e || e.which === 1 || this.touchMove) {
            this._unbindMouseMove();
            if (!this.connection) {
                this.placeholderElement.parentNode.insertBefore(this.moving.getElement(), this.placeholderElement.nextSibling);
                this.placeholderElement.parentNode.removeChild(this.placeholderElement);
            }
            this.hoverElement.parentNode.removeChild(this.hoverElement);
            this.table.element.classList.remove("tabulator-block-select");
            if (this.toRow) this.table.rowManager.moveRow(this.moving, this.toRow, this.toRowAfter);
            else this.dispatchExternal("rowMoveCancelled", this.moving.getComponent());
            this.moving = false;
            this.toRow = false;
            this.toRowAfter = false;
            document.body.removeEventListener("mousemove", this.moveHover);
            document.body.removeEventListener("mouseup", this.endMove);
            if (this.connection) {
                this.table.element.classList.remove("tabulator-movingrow-sending");
                this.disconnectFromTables();
            }
        }
    }
    moveRow(row, after) {
        this.toRow = row;
        this.toRowAfter = after;
    }
    moveHover(e) {
        if (this.connection) this.moveHoverConnections.call(this, e);
        else this.moveHoverTable.call(this, e);
    }
    moveHoverTable(e) {
        var rowHolder = this.table.rowManager.getElement(), scrollTop = rowHolder.scrollTop, yPos = (this.touchMove ? e.touches[0].pageY : e.pageY) - rowHolder.getBoundingClientRect().top + scrollTop;
        this.hoverElement.style.top = Math.min(yPos - this.startY, this.table.rowManager.element.scrollHeight - this.hoverElement.offsetHeight) + "px";
    }
    moveHoverConnections(e) {
        this.hoverElement.style.left = this.startX + (this.touchMove ? e.touches[0].pageX : e.pageX) + "px";
        this.hoverElement.style.top = this.startY + (this.touchMove ? e.touches[0].pageY : e.pageY) + "px";
    }
    elementRowDrop(e, element, row) {
        this.dispatchExternal("movableRowsElementDrop", e, element, row ? row.getComponent() : false);
    }
    //establish connection with other tables
    connectToTables(row) {
        var connectionTables;
        if (this.connectionSelectorsTables) {
            connectionTables = this.commsConnections(this.connectionSelectorsTables);
            this.dispatchExternal("movableRowsSendingStart", connectionTables);
            this.commsSend(this.connectionSelectorsTables, "moveRow", "connect", {
                row: row
            });
        }
        if (this.connectionSelectorsElements) {
            this.connectionElements = [];
            if (!Array.isArray(this.connectionSelectorsElements)) this.connectionSelectorsElements = [
                this.connectionSelectorsElements
            ];
            this.connectionSelectorsElements.forEach((query)=>{
                if (typeof query === "string") this.connectionElements = this.connectionElements.concat(Array.prototype.slice.call(document.querySelectorAll(query)));
                else this.connectionElements.push(query);
            });
            this.connectionElements.forEach((element)=>{
                var dropEvent = (e)=>{
                    this.elementRowDrop(e, element, this.moving);
                };
                element.addEventListener("mouseup", dropEvent);
                element.tabulatorElementDropEvent = dropEvent;
                element.classList.add("tabulator-movingrow-receiving");
            });
        }
    }
    //disconnect from other tables
    disconnectFromTables() {
        var connectionTables;
        if (this.connectionSelectorsTables) {
            connectionTables = this.commsConnections(this.connectionSelectorsTables);
            this.dispatchExternal("movableRowsSendingStop", connectionTables);
            this.commsSend(this.connectionSelectorsTables, "moveRow", "disconnect");
        }
        this.connectionElements.forEach((element)=>{
            element.classList.remove("tabulator-movingrow-receiving");
            element.removeEventListener("mouseup", element.tabulatorElementDropEvent);
            delete element.tabulatorElementDropEvent;
        });
    }
    //accept incomming connection
    connect(table, row) {
        if (!this.connectedTable) {
            this.connectedTable = table;
            this.connectedRow = row;
            this.table.element.classList.add("tabulator-movingrow-receiving");
            this.table.rowManager.getDisplayRows().forEach((row)=>{
                if (row.type === "row" && row.modules.moveRow && row.modules.moveRow.mouseup) row.getElement().addEventListener("mouseup", row.modules.moveRow.mouseup);
            });
            this.tableRowDropEvent = this.tableRowDrop.bind(this);
            this.table.element.addEventListener("mouseup", this.tableRowDropEvent);
            this.dispatchExternal("movableRowsReceivingStart", row, table);
            return true;
        } else {
            console.warn("Move Row Error - Table cannot accept connection, already connected to table:", this.connectedTable);
            return false;
        }
    }
    //close incoming connection
    disconnect(table) {
        if (table === this.connectedTable) {
            this.connectedTable = false;
            this.connectedRow = false;
            this.table.element.classList.remove("tabulator-movingrow-receiving");
            this.table.rowManager.getDisplayRows().forEach((row)=>{
                if (row.type === "row" && row.modules.moveRow && row.modules.moveRow.mouseup) row.getElement().removeEventListener("mouseup", row.modules.moveRow.mouseup);
            });
            this.table.element.removeEventListener("mouseup", this.tableRowDropEvent);
            this.dispatchExternal("movableRowsReceivingStop", table);
        } else console.warn("Move Row Error - trying to disconnect from non connected table");
    }
    dropComplete(table, row, success) {
        var sender = false;
        if (success) {
            switch(typeof this.table.options.movableRowsSender){
                case "string":
                    sender = $517dee46856d349e$export$7815d73158f0bb2d.senders[this.table.options.movableRowsSender];
                    break;
                case "function":
                    sender = this.table.options.movableRowsSender;
                    break;
            }
            if (sender) sender.call(this, this.moving ? this.moving.getComponent() : undefined, row ? row.getComponent() : undefined, table);
            else if (this.table.options.movableRowsSender) console.warn("Mover Row Error - no matching sender found:", this.table.options.movableRowsSender);
            this.dispatchExternal("movableRowsSent", this.moving.getComponent(), row ? row.getComponent() : undefined, table);
        } else this.dispatchExternal("movableRowsSentFailed", this.moving.getComponent(), row ? row.getComponent() : undefined, table);
        this.endMove();
    }
    tableRowDrop(e, row) {
        var receiver = false, success = false;
        e.stopImmediatePropagation();
        switch(typeof this.table.options.movableRowsReceiver){
            case "string":
                receiver = $517dee46856d349e$export$7815d73158f0bb2d.receivers[this.table.options.movableRowsReceiver];
                break;
            case "function":
                receiver = this.table.options.movableRowsReceiver;
                break;
        }
        if (receiver) success = receiver.call(this, this.connectedRow.getComponent(), row ? row.getComponent() : undefined, this.connectedTable);
        else console.warn("Mover Row Error - no matching receiver found:", this.table.options.movableRowsReceiver);
        if (success) this.dispatchExternal("movableRowsReceived", this.connectedRow.getComponent(), row ? row.getComponent() : undefined, this.connectedTable);
        else this.dispatchExternal("movableRowsReceivedFailed", this.connectedRow.getComponent(), row ? row.getComponent() : undefined, this.connectedTable);
        this.commsSend(this.connectedTable, "moveRow", "dropcomplete", {
            row: row,
            success: success
        });
    }
    commsReceived(table, action, data) {
        switch(action){
            case "connect":
                return this.connect(table, data.row);
            case "disconnect":
                return this.disconnect(table);
            case "dropcomplete":
                return this.dropComplete(table, data.row, data.success);
        }
    }
}
var $517dee46856d349e$var$defaultMutators = {};
class $517dee46856d349e$export$d0f669567356cabd extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "mutator";
    //load defaults
    static mutators = $517dee46856d349e$var$defaultMutators;
    constructor(table){
        super(table);
        this.allowedTypes = [
            "",
            "data",
            "edit",
            "clipboard",
            "import"
        ]; //list of mutation types
        this.enabled = true;
        this.registerColumnOption("mutator");
        this.registerColumnOption("mutatorParams");
        this.registerColumnOption("mutatorData");
        this.registerColumnOption("mutatorDataParams");
        this.registerColumnOption("mutatorEdit");
        this.registerColumnOption("mutatorEditParams");
        this.registerColumnOption("mutatorClipboard");
        this.registerColumnOption("mutatorClipboardParams");
        this.registerColumnOption("mutatorImport");
        this.registerColumnOption("mutatorImportParams");
        this.registerColumnOption("mutateLink");
    }
    initialize() {
        this.subscribe("cell-value-changing", this.transformCell.bind(this));
        this.subscribe("cell-value-changed", this.mutateLink.bind(this));
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("row-data-init-before", this.rowDataChanged.bind(this));
        this.subscribe("row-data-changing", this.rowDataChanged.bind(this));
    }
    rowDataChanged(row, tempData, updatedData) {
        return this.transformRow(tempData, "data", updatedData);
    }
    //initialize column mutator
    initializeColumn(column) {
        var match = false, config = {};
        this.allowedTypes.forEach((type)=>{
            var key = "mutator" + (type.charAt(0).toUpperCase() + type.slice(1)), mutator;
            if (column.definition[key]) {
                mutator = this.lookupMutator(column.definition[key]);
                if (mutator) {
                    match = true;
                    config[key] = {
                        mutator: mutator,
                        params: column.definition[key + "Params"] || {}
                    };
                }
            }
        });
        if (match) column.modules.mutate = config;
    }
    lookupMutator(value) {
        var mutator = false;
        //set column mutator
        switch(typeof value){
            case "string":
                if ($517dee46856d349e$export$d0f669567356cabd.mutators[value]) mutator = $517dee46856d349e$export$d0f669567356cabd.mutators[value];
                else console.warn("Mutator Error - No such mutator found, ignoring: ", value);
                break;
            case "function":
                mutator = value;
                break;
        }
        return mutator;
    }
    //apply mutator to row
    transformRow(data, type, updatedData) {
        var key = "mutator" + (type.charAt(0).toUpperCase() + type.slice(1)), value;
        // console.log("key", key)
        if (this.enabled) this.table.columnManager.traverse((column)=>{
            var mutator, params, component;
            if (column.modules.mutate) {
                mutator = column.modules.mutate[key] || column.modules.mutate.mutator || false;
                if (mutator) {
                    value = column.getFieldValue(typeof updatedData !== "undefined" ? updatedData : data);
                    if (type == "data" && !updatedData || typeof value !== "undefined") {
                        component = column.getComponent();
                        params = typeof mutator.params === "function" ? mutator.params(value, data, type, component) : mutator.params;
                        column.setFieldValue(data, mutator.mutator(value, data, type, params, component));
                    }
                }
            }
        });
        return data;
    }
    //apply mutator to new cell value
    transformCell(cell, value) {
        if (cell.column.modules.mutate) {
            var mutator = cell.column.modules.mutate.mutatorEdit || cell.column.modules.mutate.mutator || false, tempData = {};
            if (mutator) {
                tempData = Object.assign(tempData, cell.row.getData());
                cell.column.setFieldValue(tempData, value);
                return mutator.mutator(value, tempData, "edit", mutator.params, cell.getComponent());
            }
        }
        return value;
    }
    mutateLink(cell) {
        var links = cell.column.definition.mutateLink;
        if (links) {
            if (!Array.isArray(links)) links = [
                links
            ];
            links.forEach((link)=>{
                var linkCell = cell.row.getCell(link);
                if (linkCell) linkCell.setValue(linkCell.getValue(), true, true);
            });
        }
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
}
function $517dee46856d349e$var$rows(pageSize, currentRow, currentPage, totalRows, totalPages) {
    var el = document.createElement("span"), showingEl = document.createElement("span"), valueEl = document.createElement("span"), ofEl = document.createElement("span"), totalEl = document.createElement("span"), rowsEl = document.createElement("span");
    this.table.modules.localize.langBind("pagination|counter|showing", (value)=>{
        showingEl.innerHTML = value;
    });
    this.table.modules.localize.langBind("pagination|counter|of", (value)=>{
        ofEl.innerHTML = value;
    });
    this.table.modules.localize.langBind("pagination|counter|rows", (value)=>{
        rowsEl.innerHTML = value;
    });
    if (totalRows) {
        valueEl.innerHTML = " " + currentRow + "-" + Math.min(currentRow + pageSize - 1, totalRows) + " ";
        totalEl.innerHTML = " " + totalRows + " ";
        el.appendChild(showingEl);
        el.appendChild(valueEl);
        el.appendChild(ofEl);
        el.appendChild(totalEl);
        el.appendChild(rowsEl);
    } else {
        valueEl.innerHTML = " 0 ";
        el.appendChild(showingEl);
        el.appendChild(valueEl);
        el.appendChild(rowsEl);
    }
    return el;
}
function $517dee46856d349e$var$pages(pageSize, currentRow, currentPage, totalRows, totalPages) {
    var el = document.createElement("span"), showingEl = document.createElement("span"), valueEl = document.createElement("span"), ofEl = document.createElement("span"), totalEl = document.createElement("span"), rowsEl = document.createElement("span");
    this.table.modules.localize.langBind("pagination|counter|showing", (value)=>{
        showingEl.innerHTML = value;
    });
    valueEl.innerHTML = " " + currentPage + " ";
    this.table.modules.localize.langBind("pagination|counter|of", (value)=>{
        ofEl.innerHTML = value;
    });
    totalEl.innerHTML = " " + totalPages + " ";
    this.table.modules.localize.langBind("pagination|counter|pages", (value)=>{
        rowsEl.innerHTML = value;
    });
    el.appendChild(showingEl);
    el.appendChild(valueEl);
    el.appendChild(ofEl);
    el.appendChild(totalEl);
    el.appendChild(rowsEl);
    return el;
}
var $517dee46856d349e$var$defaultPageCounters = {
    rows: $517dee46856d349e$var$rows,
    pages: $517dee46856d349e$var$pages
};
class $517dee46856d349e$export$7eba6c45a494ceac extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "page";
    //load defaults
    static pageCounters = $517dee46856d349e$var$defaultPageCounters;
    constructor(table){
        super(table);
        this.mode = "local";
        this.progressiveLoad = false;
        this.element = null;
        this.pageCounterElement = null;
        this.pageCounter = null;
        this.size = 0;
        this.page = 1;
        this.count = 5;
        this.max = 1;
        this.remoteRowCountEstimate = null;
        this.initialLoad = true;
        this.dataChanging = false; //flag to check if data is being changed by this module
        this.pageSizes = [];
        this.registerTableOption("pagination", false); //set pagination type
        this.registerTableOption("paginationMode", "local"); //local or remote pagination
        this.registerTableOption("paginationSize", false); //set number of rows to a page
        this.registerTableOption("paginationInitialPage", 1); //initial page to show on load
        this.registerTableOption("paginationCounter", false); // set pagination counter
        this.registerTableOption("paginationCounterElement", false); // set pagination counter
        this.registerTableOption("paginationButtonCount", 5); // set count of page button
        this.registerTableOption("paginationSizeSelector", false); //add pagination size selector element
        this.registerTableOption("paginationElement", false); //element to hold pagination numbers
        // this.registerTableOption("paginationDataSent", {}); //pagination data sent to the server
        // this.registerTableOption("paginationDataReceived", {}); //pagination data received from the server
        this.registerTableOption("paginationAddRow", "page"); //add rows on table or page
        this.registerTableOption("paginationOutOfRange", false); //reset the current page when the last page < this.page, values: false|function|any value accepted by setPage()
        this.registerTableOption("progressiveLoad", false); //progressive loading
        this.registerTableOption("progressiveLoadDelay", 0); //delay between requests
        this.registerTableOption("progressiveLoadScrollMargin", 0); //margin before scroll begins
        this.registerTableFunction("setMaxPage", this.setMaxPage.bind(this));
        this.registerTableFunction("setPage", this.setPage.bind(this));
        this.registerTableFunction("setPageToRow", this.userSetPageToRow.bind(this));
        this.registerTableFunction("setPageSize", this.userSetPageSize.bind(this));
        this.registerTableFunction("getPageSize", this.getPageSize.bind(this));
        this.registerTableFunction("previousPage", this.previousPage.bind(this));
        this.registerTableFunction("nextPage", this.nextPage.bind(this));
        this.registerTableFunction("getPage", this.getPage.bind(this));
        this.registerTableFunction("getPageMax", this.getPageMax.bind(this));
        //register component functions
        this.registerComponentFunction("row", "pageTo", this.setPageToRow.bind(this));
    }
    initialize() {
        if (this.table.options.pagination) {
            this.subscribe("row-deleted", this.rowsUpdated.bind(this));
            this.subscribe("row-added", this.rowsUpdated.bind(this));
            this.subscribe("data-processed", this.initialLoadComplete.bind(this));
            this.subscribe("table-built", this.calculatePageSizes.bind(this));
            this.subscribe("footer-redraw", this.footerRedraw.bind(this));
            if (this.table.options.paginationAddRow == "page") this.subscribe("row-adding-position", this.rowAddingPosition.bind(this));
            if (this.table.options.paginationMode === "remote") {
                this.subscribe("data-params", this.remotePageParams.bind(this));
                this.subscribe("data-loaded", this._parseRemoteData.bind(this));
            }
            if (this.table.options.progressiveLoad) console.error("Progressive Load Error - Pagination and progressive load cannot be used at the same time");
            this.registerDisplayHandler(this.restOnRenderBefore.bind(this), 40);
            this.registerDisplayHandler(this.getRows.bind(this), 50);
            this.createElements();
            this.initializePageCounter();
            this.initializePaginator();
        } else if (this.table.options.progressiveLoad) {
            this.subscribe("data-params", this.remotePageParams.bind(this));
            this.subscribe("data-loaded", this._parseRemoteData.bind(this));
            this.subscribe("table-built", this.calculatePageSizes.bind(this));
            this.subscribe("data-processed", this.initialLoadComplete.bind(this));
            this.initializeProgressive(this.table.options.progressiveLoad);
            if (this.table.options.progressiveLoad === "scroll") this.subscribe("scroll-vertical", this.scrollVertical.bind(this));
        }
    }
    rowAddingPosition(row, top) {
        var rowManager = this.table.rowManager, displayRows = rowManager.getDisplayRows(), index;
        if (top) {
            if (displayRows.length) index = displayRows[0];
            else if (rowManager.activeRows.length) {
                index = rowManager.activeRows[rowManager.activeRows.length - 1];
                top = false;
            }
        } else if (displayRows.length) {
            index = displayRows[displayRows.length - 1];
            top = displayRows.length < this.size ? false : true;
        }
        return {
            index: index,
            top: top
        };
    }
    calculatePageSizes() {
        var testElRow, testElCell;
        if (this.table.options.paginationSize) this.size = this.table.options.paginationSize;
        else {
            testElRow = document.createElement("div");
            testElRow.classList.add("tabulator-row");
            testElRow.style.visibility = "hidden";
            testElCell = document.createElement("div");
            testElCell.classList.add("tabulator-cell");
            testElCell.innerHTML = "Page Row Test";
            testElRow.appendChild(testElCell);
            this.table.rowManager.getTableElement().appendChild(testElRow);
            this.size = Math.floor(this.table.rowManager.getElement().clientHeight / testElRow.offsetHeight);
            this.table.rowManager.getTableElement().removeChild(testElRow);
        }
        this.dispatchExternal("pageSizeChanged", this.size);
        this.generatePageSizeSelectList();
    }
    initialLoadComplete() {
        this.initialLoad = false;
    }
    remotePageParams(data, config, silent, params) {
        if (!this.initialLoad) {
            if (this.progressiveLoad && !silent || !this.progressiveLoad && !this.dataChanging) this.reset(true);
        }
        //configure request params
        params.page = this.page;
        //set page size if defined
        if (this.size) params.size = this.size;
        return params;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userSetPageToRow(row) {
        if (this.table.options.pagination) {
            row = this.table.rowManager.findRow(row);
            if (row) return this.setPageToRow(row);
        }
        return Promise.reject();
    }
    userSetPageSize(size) {
        if (this.table.options.pagination) {
            this.setPageSize(size);
            return this.setPage(1);
        } else return false;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    scrollVertical(top, dir) {
        var element, diff, margin;
        if (!dir && !this.table.dataLoader.loading) {
            element = this.table.rowManager.getElement();
            diff = element.scrollHeight - element.clientHeight - top;
            margin = this.table.options.progressiveLoadScrollMargin || element.clientHeight * 2;
            if (diff < margin) this.nextPage().catch(()=>{}); //consume the exception thrown when on the last page
        }
    }
    restOnRenderBefore(rows, renderInPosition) {
        if (!renderInPosition) {
            if (this.mode === "local") this.reset();
        }
        return rows;
    }
    rowsUpdated() {
        this.refreshData(true, "all");
    }
    createElements() {
        var button;
        this.element = document.createElement("span");
        this.element.classList.add("tabulator-paginator");
        this.pagesElement = document.createElement("span");
        this.pagesElement.classList.add("tabulator-pages");
        button = document.createElement("button");
        button.classList.add("tabulator-page");
        button.setAttribute("type", "button");
        button.setAttribute("role", "button");
        button.setAttribute("aria-label", "");
        button.setAttribute("title", "");
        this.firstBut = button.cloneNode(true);
        this.firstBut.setAttribute("data-page", "first");
        this.prevBut = button.cloneNode(true);
        this.prevBut.setAttribute("data-page", "prev");
        this.nextBut = button.cloneNode(true);
        this.nextBut.setAttribute("data-page", "next");
        this.lastBut = button.cloneNode(true);
        this.lastBut.setAttribute("data-page", "last");
        if (this.table.options.paginationSizeSelector) {
            this.pageSizeSelect = document.createElement("select");
            this.pageSizeSelect.classList.add("tabulator-page-size");
        }
    }
    generatePageSizeSelectList() {
        var pageSizes = [];
        if (this.pageSizeSelect) {
            if (Array.isArray(this.table.options.paginationSizeSelector)) {
                pageSizes = this.table.options.paginationSizeSelector;
                this.pageSizes = pageSizes;
                if (this.pageSizes.indexOf(this.size) == -1) pageSizes.unshift(this.size);
            } else if (this.pageSizes.indexOf(this.size) == -1) {
                pageSizes = [];
                for(let i = 1; i < 5; i++)pageSizes.push(this.size * i);
                this.pageSizes = pageSizes;
            } else pageSizes = this.pageSizes;
            while(this.pageSizeSelect.firstChild)this.pageSizeSelect.removeChild(this.pageSizeSelect.firstChild);
            pageSizes.forEach((item)=>{
                var itemEl = document.createElement("option");
                itemEl.value = item;
                if (item === true) this.langBind("pagination|all", function(value) {
                    itemEl.innerHTML = value;
                });
                else itemEl.innerHTML = item;
                this.pageSizeSelect.appendChild(itemEl);
            });
            this.pageSizeSelect.value = this.size;
        }
    }
    initializePageCounter() {
        var counter = this.table.options.paginationCounter, pageCounter = null;
        if (counter) {
            if (typeof counter === "function") pageCounter = counter;
            else pageCounter = $517dee46856d349e$export$7eba6c45a494ceac.pageCounters[counter];
            if (pageCounter) {
                this.pageCounter = pageCounter;
                this.pageCounterElement = document.createElement("span");
                this.pageCounterElement.classList.add("tabulator-page-counter");
            } else console.warn("Pagination Error - No such page counter found: ", counter);
        }
    }
    //setup pagination
    initializePaginator(hidden) {
        var pageSelectLabel, paginationCounterHolder;
        if (!hidden) {
            //build pagination element
            //bind localizations
            this.langBind("pagination|first", (value)=>{
                this.firstBut.innerHTML = value;
            });
            this.langBind("pagination|first_title", (value)=>{
                this.firstBut.setAttribute("aria-label", value);
                this.firstBut.setAttribute("title", value);
            });
            this.langBind("pagination|prev", (value)=>{
                this.prevBut.innerHTML = value;
            });
            this.langBind("pagination|prev_title", (value)=>{
                this.prevBut.setAttribute("aria-label", value);
                this.prevBut.setAttribute("title", value);
            });
            this.langBind("pagination|next", (value)=>{
                this.nextBut.innerHTML = value;
            });
            this.langBind("pagination|next_title", (value)=>{
                this.nextBut.setAttribute("aria-label", value);
                this.nextBut.setAttribute("title", value);
            });
            this.langBind("pagination|last", (value)=>{
                this.lastBut.innerHTML = value;
            });
            this.langBind("pagination|last_title", (value)=>{
                this.lastBut.setAttribute("aria-label", value);
                this.lastBut.setAttribute("title", value);
            });
            //click bindings
            this.firstBut.addEventListener("click", ()=>{
                this.setPage(1);
            });
            this.prevBut.addEventListener("click", ()=>{
                this.previousPage();
            });
            this.nextBut.addEventListener("click", ()=>{
                this.nextPage();
            });
            this.lastBut.addEventListener("click", ()=>{
                this.setPage(this.max);
            });
            if (this.table.options.paginationElement) this.element = this.table.options.paginationElement;
            if (this.pageSizeSelect) {
                pageSelectLabel = document.createElement("label");
                this.langBind("pagination|page_size", (value)=>{
                    this.pageSizeSelect.setAttribute("aria-label", value);
                    this.pageSizeSelect.setAttribute("title", value);
                    pageSelectLabel.innerHTML = value;
                });
                this.element.appendChild(pageSelectLabel);
                this.element.appendChild(this.pageSizeSelect);
                this.pageSizeSelect.addEventListener("change", (e)=>{
                    this.setPageSize(this.pageSizeSelect.value == "true" ? true : this.pageSizeSelect.value);
                    this.setPage(1);
                });
            }
            //append to DOM
            this.element.appendChild(this.firstBut);
            this.element.appendChild(this.prevBut);
            this.element.appendChild(this.pagesElement);
            this.element.appendChild(this.nextBut);
            this.element.appendChild(this.lastBut);
            if (!this.table.options.paginationElement) {
                if (this.table.options.paginationCounter) {
                    if (this.table.options.paginationCounterElement) {
                        if (this.table.options.paginationCounterElement instanceof HTMLElement) this.table.options.paginationCounterElement.appendChild(this.pageCounterElement);
                        else if (typeof this.table.options.paginationCounterElement === "string") {
                            paginationCounterHolder = document.querySelector(this.table.options.paginationCounterElement);
                            if (paginationCounterHolder) paginationCounterHolder.appendChild(this.pageCounterElement);
                            else console.warn("Pagination Error - Unable to find element matching paginationCounterElement selector:", this.table.options.paginationCounterElement);
                        }
                    } else this.footerAppend(this.pageCounterElement);
                }
                this.footerAppend(this.element);
            }
            this.page = this.table.options.paginationInitialPage;
            this.count = this.table.options.paginationButtonCount;
        }
        //set default values
        this.mode = this.table.options.paginationMode;
    }
    initializeProgressive(mode) {
        this.initializePaginator(true);
        this.mode = "progressive_" + mode;
        this.progressiveLoad = true;
    }
    trackChanges() {
        this.dispatch("page-changed");
    }
    //calculate maximum page from number of rows
    setMaxRows(rowCount) {
        if (!rowCount) this.max = 1;
        else this.max = this.size === true ? 1 : Math.ceil(rowCount / this.size);
        if (this.page > this.max) this.page = this.max;
    }
    //reset to first page without triggering action
    reset(force) {
        if (!this.initialLoad) {
            if (this.mode == "local" || force) {
                this.page = 1;
                this.trackChanges();
            }
        }
    }
    //set the maximum page
    setMaxPage(max) {
        max = parseInt(max);
        this.max = max || 1;
        if (this.page > this.max) {
            this.page = this.max;
            this.trigger();
        }
    }
    //set current page number
    setPage(page) {
        switch(page){
            case "first":
                return this.setPage(1);
            case "prev":
                return this.previousPage();
            case "next":
                return this.nextPage();
            case "last":
                return this.setPage(this.max);
        }
        page = parseInt(page);
        if (page > 0 && page <= this.max || this.mode !== "local") {
            this.page = page;
            this.trackChanges();
            return this.trigger();
        } else {
            console.warn("Pagination Error - Requested page is out of range of 1 - " + this.max + ":", page);
            return Promise.reject();
        }
    }
    setPageToRow(row) {
        var rows = this.displayRows(-1);
        var index = rows.indexOf(row);
        if (index > -1) {
            var page = this.size === true ? 1 : Math.ceil((index + 1) / this.size);
            return this.setPage(page);
        } else {
            console.warn("Pagination Error - Requested row is not visible");
            return Promise.reject();
        }
    }
    setPageSize(size) {
        if (size !== true) size = parseInt(size);
        if (size > 0) {
            this.size = size;
            this.dispatchExternal("pageSizeChanged", size);
        }
        if (this.pageSizeSelect) // this.pageSizeSelect.value = size;
        this.generatePageSizeSelectList();
        this.trackChanges();
    }
    _setPageCounter(totalRows, size, currentRow) {
        var content;
        if (this.pageCounter) {
            if (this.mode === "remote") {
                size = this.size;
                currentRow = (this.page - 1) * this.size + 1;
                totalRows = this.remoteRowCountEstimate;
            }
            content = this.pageCounter.call(this, size, currentRow, this.page, totalRows, this.max);
            switch(typeof content){
                case "object":
                    if (content instanceof Node) {
                        //clear previous cell contents
                        while(this.pageCounterElement.firstChild)this.pageCounterElement.removeChild(this.pageCounterElement.firstChild);
                        this.pageCounterElement.appendChild(content);
                    } else {
                        this.pageCounterElement.innerHTML = "";
                        if (content != null) console.warn("Page Counter Error - Page Counter has returned a type of object, the only valid page counter object return is an instance of Node, the page counter returned:", content);
                    }
                    break;
                case "undefined":
                    this.pageCounterElement.innerHTML = "";
                    break;
                default:
                    this.pageCounterElement.innerHTML = content;
            }
        }
    }
    //setup the pagination buttons
    _setPageButtons() {
        let leftSize = Math.floor((this.count - 1) / 2);
        let rightSize = Math.ceil((this.count - 1) / 2);
        let min = this.max - this.page + leftSize + 1 < this.count ? this.max - this.count + 1 : Math.max(this.page - leftSize, 1);
        let max = this.page <= rightSize ? Math.min(this.count, this.max) : Math.min(this.page + rightSize, this.max);
        while(this.pagesElement.firstChild)this.pagesElement.removeChild(this.pagesElement.firstChild);
        if (this.page == 1) {
            this.firstBut.disabled = true;
            this.prevBut.disabled = true;
        } else {
            this.firstBut.disabled = false;
            this.prevBut.disabled = false;
        }
        if (this.page == this.max) {
            this.lastBut.disabled = true;
            this.nextBut.disabled = true;
        } else {
            this.lastBut.disabled = false;
            this.nextBut.disabled = false;
        }
        for(let i = min; i <= max; i++)if (i > 0 && i <= this.max) this.pagesElement.appendChild(this._generatePageButton(i));
        this.footerRedraw();
    }
    _generatePageButton(page) {
        var button = document.createElement("button");
        button.classList.add("tabulator-page");
        if (page == this.page) button.classList.add("active");
        button.setAttribute("type", "button");
        button.setAttribute("role", "button");
        this.langBind("pagination|page_title", (value)=>{
            button.setAttribute("aria-label", value + " " + page);
            button.setAttribute("title", value + " " + page);
        });
        button.setAttribute("data-page", page);
        button.textContent = page;
        button.addEventListener("click", (e)=>{
            this.setPage(page);
        });
        return button;
    }
    //previous page
    previousPage() {
        if (this.page > 1) {
            this.page--;
            this.trackChanges();
            return this.trigger();
        } else {
            console.warn("Pagination Error - Previous page would be less than page 1:", 0);
            return Promise.reject();
        }
    }
    //next page
    nextPage() {
        if (this.page < this.max) {
            this.page++;
            this.trackChanges();
            return this.trigger();
        } else {
            if (!this.progressiveLoad) console.warn("Pagination Error - Next page would be greater than maximum page of " + this.max + ":", this.max + 1);
            return Promise.reject();
        }
    }
    //return current page number
    getPage() {
        return this.page;
    }
    //return max page number
    getPageMax() {
        return this.max;
    }
    getPageSize(size) {
        return this.size;
    }
    getMode() {
        return this.mode;
    }
    //return appropriate rows for current page
    getRows(data) {
        var actualRowPageSize = 0, output, start, end, actualStartRow;
        var actualRows = data.filter((row)=>{
            return row.type === "row";
        });
        if (this.mode == "local") {
            output = [];
            this.setMaxRows(data.length);
            if (this.size === true) {
                start = 0;
                end = data.length;
            } else {
                start = this.size * (this.page - 1);
                end = start + parseInt(this.size);
            }
            this._setPageButtons();
            for(let i = start; i < end; i++){
                let row = data[i];
                if (row) {
                    output.push(row);
                    if (row.type === "row") {
                        if (!actualStartRow) actualStartRow = row;
                        actualRowPageSize++;
                    }
                }
            }
            this._setPageCounter(actualRows.length, actualRowPageSize, actualStartRow ? actualRows.indexOf(actualStartRow) + 1 : 0);
            return output;
        } else {
            this._setPageButtons();
            this._setPageCounter(actualRows.length);
            return data.slice(0);
        }
    }
    trigger() {
        var left;
        switch(this.mode){
            case "local":
                left = this.table.rowManager.scrollLeft;
                this.refreshData();
                this.table.rowManager.scrollHorizontal(left);
                this.dispatchExternal("pageLoaded", this.getPage());
                return Promise.resolve();
            case "remote":
                this.dataChanging = true;
                return this.reloadData(null).finally(()=>{
                    this.dataChanging = false;
                });
            case "progressive_load":
            case "progressive_scroll":
                return this.reloadData(null, true);
            default:
                console.warn("Pagination Error - no such pagination mode:", this.mode);
                return Promise.reject();
        }
    }
    _parseRemoteData(data) {
        var margin, paginationOutOfRange;
        if (typeof data.last_page === "undefined") console.warn("Remote Pagination Error - Server response missing '" + (this.options("dataReceiveParams").last_page || "last_page") + "' property");
        if (data.data) {
            this.max = parseInt(data.last_page) || 1;
            this.remoteRowCountEstimate = typeof data.last_row !== "undefined" ? data.last_row : data.last_page * this.size - (this.page == data.last_page ? this.size - data.data.length : 0);
            if (this.progressiveLoad) {
                switch(this.mode){
                    case "progressive_load":
                        if (this.page == 1) this.table.rowManager.setData(data.data, false, this.page == 1);
                        else this.table.rowManager.addRows(data.data);
                        if (this.page < this.max) setTimeout(()=>{
                            this.nextPage();
                        }, this.table.options.progressiveLoadDelay);
                        break;
                    case "progressive_scroll":
                        data = this.page === 1 ? data.data : this.table.rowManager.getData().concat(data.data);
                        this.table.rowManager.setData(data, this.page !== 1, this.page == 1);
                        margin = this.table.options.progressiveLoadScrollMargin || this.table.rowManager.element.clientHeight * 2;
                        if (this.table.rowManager.element.scrollHeight <= this.table.rowManager.element.clientHeight + margin) {
                            if (this.page < this.max) setTimeout(()=>{
                                this.nextPage();
                            });
                        }
                        break;
                }
                return false;
            } else {
                if (this.page > this.max) {
                    console.warn("Remote Pagination Error - Server returned last page value lower than the current page");
                    paginationOutOfRange = this.options('paginationOutOfRange');
                    if (paginationOutOfRange) return this.setPage(typeof paginationOutOfRange === 'function' ? paginationOutOfRange.call(this, this.page, this.max) : paginationOutOfRange);
                }
                // left = this.table.rowManager.scrollLeft;
                this.dispatchExternal("pageLoaded", this.getPage());
            // this.table.rowManager.scrollHorizontal(left);
            // this.table.columnManager.scrollHorizontal(left);
            }
        } else console.warn("Remote Pagination Error - Server response missing '" + (this.options("dataReceiveParams").data || "data") + "' property");
        return data.data;
    }
    //handle the footer element being redrawn
    footerRedraw() {
        var footer = this.table.footerManager.containerElement;
        if (Math.ceil(footer.clientWidth) - footer.scrollWidth < 0) this.pagesElement.style.display = 'none';
        else {
            this.pagesElement.style.display = '';
            if (Math.ceil(footer.clientWidth) - footer.scrollWidth < 0) this.pagesElement.style.display = 'none';
        }
    }
}
// read persistance information from storage
var $517dee46856d349e$var$defaultReaders = {
    local: function(id, type) {
        var data = localStorage.getItem(id + "-" + type);
        return data ? JSON.parse(data) : false;
    },
    cookie: function(id, type) {
        var cookie = document.cookie, key = id + "-" + type, cookiePos = cookie.indexOf(key + "="), end, data;
        //if cookie exists, decode and load column data into tabulator
        if (cookiePos > -1) {
            cookie = cookie.slice(cookiePos);
            end = cookie.indexOf(";");
            if (end > -1) cookie = cookie.slice(0, end);
            data = cookie.replace(key + "=", "");
        }
        return data ? JSON.parse(data) : false;
    }
};
//write persistence information to storage
var $517dee46856d349e$var$defaultWriters = {
    local: function(id, type, data) {
        localStorage.setItem(id + "-" + type, JSON.stringify(data));
    },
    cookie: function(id, type, data) {
        var expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + 10000);
        document.cookie = id + "-" + type + "=" + JSON.stringify(data) + "; expires=" + expireDate.toUTCString();
    }
};
class $517dee46856d349e$export$6ce0215a06bec981 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "persistence";
    static moduleInitOrder = -10;
    //load defaults
    static readers = $517dee46856d349e$var$defaultReaders;
    static writers = $517dee46856d349e$var$defaultWriters;
    constructor(table){
        super(table);
        this.mode = "";
        this.id = "";
        // this.persistProps = ["field", "width", "visible"];
        this.defWatcherBlock = false;
        this.config = {};
        this.readFunc = false;
        this.writeFunc = false;
        this.registerTableOption("persistence", false);
        this.registerTableOption("persistenceID", ""); //key for persistent storage
        this.registerTableOption("persistenceMode", true); //mode for storing persistence information
        this.registerTableOption("persistenceReaderFunc", false); //function for handling persistence data reading
        this.registerTableOption("persistenceWriterFunc", false); //function for handling persistence data writing
    }
    // Test for whether localStorage is available for use.
    localStorageTest() {
        var testKey = "_tabulator_test";
        try {
            window.localStorage.setItem(testKey, testKey);
            window.localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }
    //setup parameters
    initialize() {
        if (this.table.options.persistence) {
            //determine persistent layout storage type
            var mode = this.table.options.persistenceMode, id = this.table.options.persistenceID, retrievedData;
            this.mode = mode !== true ? mode : this.localStorageTest() ? "local" : "cookie";
            if (this.table.options.persistenceReaderFunc) {
                if (typeof this.table.options.persistenceReaderFunc === "function") this.readFunc = this.table.options.persistenceReaderFunc;
                else if ($517dee46856d349e$export$6ce0215a06bec981.readers[this.table.options.persistenceReaderFunc]) this.readFunc = $517dee46856d349e$export$6ce0215a06bec981.readers[this.table.options.persistenceReaderFunc];
                else console.warn("Persistence Read Error - invalid reader set", this.table.options.persistenceReaderFunc);
            } else if ($517dee46856d349e$export$6ce0215a06bec981.readers[this.mode]) this.readFunc = $517dee46856d349e$export$6ce0215a06bec981.readers[this.mode];
            else console.warn("Persistence Read Error - invalid reader set", this.mode);
            if (this.table.options.persistenceWriterFunc) {
                if (typeof this.table.options.persistenceWriterFunc === "function") this.writeFunc = this.table.options.persistenceWriterFunc;
                else if ($517dee46856d349e$export$6ce0215a06bec981.writers[this.table.options.persistenceWriterFunc]) this.writeFunc = $517dee46856d349e$export$6ce0215a06bec981.writers[this.table.options.persistenceWriterFunc];
                else console.warn("Persistence Write Error - invalid reader set", this.table.options.persistenceWriterFunc);
            } else if ($517dee46856d349e$export$6ce0215a06bec981.writers[this.mode]) this.writeFunc = $517dee46856d349e$export$6ce0215a06bec981.writers[this.mode];
            else console.warn("Persistence Write Error - invalid writer set", this.mode);
            //set storage tag
            this.id = "tabulator-" + (id || this.table.element.getAttribute("id") || "");
            this.config = {
                sort: this.table.options.persistence === true || this.table.options.persistence.sort,
                filter: this.table.options.persistence === true || this.table.options.persistence.filter,
                headerFilter: this.table.options.persistence === true || this.table.options.persistence.headerFilter,
                group: this.table.options.persistence === true || this.table.options.persistence.group,
                page: this.table.options.persistence === true || this.table.options.persistence.page,
                columns: this.table.options.persistence === true ? [
                    "title",
                    "width",
                    "visible"
                ] : this.table.options.persistence.columns
            };
            //load pagination data if needed
            if (this.config.page) {
                retrievedData = this.retrieveData("page");
                if (retrievedData) {
                    if (typeof retrievedData.paginationSize !== "undefined" && (this.config.page === true || this.config.page.size)) this.table.options.paginationSize = retrievedData.paginationSize;
                    if (typeof retrievedData.paginationInitialPage !== "undefined" && (this.config.page === true || this.config.page.page)) this.table.options.paginationInitialPage = retrievedData.paginationInitialPage;
                }
            }
            //load group data if needed
            if (this.config.group) {
                retrievedData = this.retrieveData("group");
                if (retrievedData) {
                    if (typeof retrievedData.groupBy !== "undefined" && (this.config.group === true || this.config.group.groupBy)) this.table.options.groupBy = retrievedData.groupBy;
                    if (typeof retrievedData.groupStartOpen !== "undefined" && (this.config.group === true || this.config.group.groupStartOpen)) this.table.options.groupStartOpen = retrievedData.groupStartOpen;
                    if (typeof retrievedData.groupHeader !== "undefined" && (this.config.group === true || this.config.group.groupHeader)) this.table.options.groupHeader = retrievedData.groupHeader;
                }
            }
            if (this.config.columns) {
                this.table.options.columns = this.load("columns", this.table.options.columns);
                this.subscribe("column-init", this.initializeColumn.bind(this));
                this.subscribe("column-show", this.save.bind(this, "columns"));
                this.subscribe("column-hide", this.save.bind(this, "columns"));
                this.subscribe("column-moved", this.save.bind(this, "columns"));
            }
            this.subscribe("table-built", this.tableBuilt.bind(this), 0);
            this.subscribe("table-redraw", this.tableRedraw.bind(this));
            this.subscribe("filter-changed", this.eventSave.bind(this, "filter"));
            this.subscribe("filter-changed", this.eventSave.bind(this, "headerFilter"));
            this.subscribe("sort-changed", this.eventSave.bind(this, "sort"));
            this.subscribe("group-changed", this.eventSave.bind(this, "group"));
            this.subscribe("page-changed", this.eventSave.bind(this, "page"));
            this.subscribe("column-resized", this.eventSave.bind(this, "columns"));
            this.subscribe("column-width", this.eventSave.bind(this, "columns"));
            this.subscribe("layout-refreshed", this.eventSave.bind(this, "columns"));
        }
        this.registerTableFunction("getColumnLayout", this.getColumnLayout.bind(this));
        this.registerTableFunction("setColumnLayout", this.setColumnLayout.bind(this));
    }
    eventSave(type) {
        if (this.config[type]) this.save(type);
    }
    tableBuilt() {
        var sorters, filters, headerFilters;
        if (this.config.sort) {
            sorters = this.load("sort");
            if (!sorters === false) this.table.options.initialSort = sorters;
        }
        if (this.config.filter) {
            filters = this.load("filter");
            if (!filters === false) this.table.options.initialFilter = filters;
        }
        if (this.config.headerFilter) {
            headerFilters = this.load("headerFilter");
            if (!headerFilters === false) this.table.options.initialHeaderFilter = headerFilters;
        }
    }
    tableRedraw(force) {
        if (force && this.config.columns) this.save("columns");
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    getColumnLayout() {
        return this.parseColumns(this.table.columnManager.getColumns());
    }
    setColumnLayout(layout) {
        this.table.columnManager.setColumns(this.mergeDefinition(this.table.options.columns, layout, true));
        return true;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumn(column) {
        var def, keys;
        if (this.config.columns) {
            this.defWatcherBlock = true;
            def = column.getDefinition();
            keys = this.config.columns === true ? Object.keys(def) : this.config.columns;
            keys.forEach((key)=>{
                var props = Object.getOwnPropertyDescriptor(def, key);
                var value = def[key];
                if (props) Object.defineProperty(def, key, {
                    set: (newValue)=>{
                        value = newValue;
                        if (!this.defWatcherBlock) this.save("columns");
                        if (props.set) props.set(newValue);
                    },
                    get: ()=>{
                        if (props.get) props.get();
                        return value;
                    }
                });
            });
            this.defWatcherBlock = false;
        }
    }
    //load saved definitions
    load(type, current) {
        var data = this.retrieveData(type);
        if (current) data = data ? this.mergeDefinition(current, data) : current;
        return data;
    }
    //retrieve data from memory
    retrieveData(type) {
        return this.readFunc ? this.readFunc(this.id, type) : false;
    }
    //merge old and new column definitions
    mergeDefinition(oldCols, newCols, mergeAllNew) {
        var output = [];
        newCols = newCols || [];
        newCols.forEach((column, to)=>{
            var from = this._findColumn(oldCols, column), keys;
            if (from) {
                if (mergeAllNew) keys = Object.keys(column);
                else if (this.config.columns === true || this.config.columns == undefined) {
                    keys = Object.keys(from);
                    keys.push("width");
                } else keys = this.config.columns;
                keys.forEach((key)=>{
                    if (key !== "columns" && typeof column[key] !== "undefined") from[key] = column[key];
                });
                if (from.columns) from.columns = this.mergeDefinition(from.columns, column.columns);
                output.push(from);
            }
        });
        oldCols.forEach((column, i)=>{
            var from = this._findColumn(newCols, column);
            if (!from) {
                if (output.length > i) output.splice(i, 0, column);
                else output.push(column);
            }
        });
        return output;
    }
    //find matching columns
    _findColumn(columns, subject) {
        var type = subject.columns ? "group" : subject.field ? "field" : "object";
        return columns.find(function(col) {
            switch(type){
                case "group":
                    return col.title === subject.title && col.columns.length === subject.columns.length;
                case "field":
                    return col.field === subject.field;
                case "object":
                    return col === subject;
            }
        });
    }
    //save data
    save(type) {
        var data = {};
        switch(type){
            case "columns":
                data = this.parseColumns(this.table.columnManager.getColumns());
                break;
            case "filter":
                data = this.table.modules.filter.getFilters();
                break;
            case "headerFilter":
                data = this.table.modules.filter.getHeaderFilters();
                break;
            case "sort":
                data = this.validateSorters(this.table.modules.sort.getSort());
                break;
            case "group":
                data = this.getGroupConfig();
                break;
            case "page":
                data = this.getPageConfig();
                break;
        }
        if (this.writeFunc) this.writeFunc(this.id, type, data);
    }
    //ensure sorters contain no function data
    validateSorters(data) {
        data.forEach(function(item) {
            item.column = item.field;
            delete item.field;
        });
        return data;
    }
    getGroupConfig() {
        var data = {};
        if (this.config.group) {
            if (this.config.group === true || this.config.group.groupBy) data.groupBy = this.table.options.groupBy;
            if (this.config.group === true || this.config.group.groupStartOpen) data.groupStartOpen = this.table.options.groupStartOpen;
            if (this.config.group === true || this.config.group.groupHeader) data.groupHeader = this.table.options.groupHeader;
        }
        return data;
    }
    getPageConfig() {
        var data = {};
        if (this.config.page) {
            if (this.config.page === true || this.config.page.size) data.paginationSize = this.table.modules.page.getPageSize();
            if (this.config.page === true || this.config.page.page) data.paginationInitialPage = this.table.modules.page.getPage();
        }
        return data;
    }
    //parse columns for data to store
    parseColumns(columns) {
        var definitions = [], excludedKeys = [
            "headerContextMenu",
            "headerMenu",
            "contextMenu",
            "clickMenu"
        ];
        columns.forEach((column)=>{
            var defStore = {}, colDef = column.getDefinition(), keys;
            if (column.isGroup) {
                defStore.title = colDef.title;
                defStore.columns = this.parseColumns(column.getColumns());
            } else {
                defStore.field = column.getField();
                if (this.config.columns === true || this.config.columns == undefined) {
                    keys = Object.keys(colDef);
                    keys.push("width");
                    keys.push("visible");
                } else keys = this.config.columns;
                keys.forEach((key)=>{
                    switch(key){
                        case "width":
                            defStore.width = column.getWidth();
                            break;
                        case "visible":
                            defStore.visible = column.visible;
                            break;
                        default:
                            if (typeof colDef[key] !== "function" && excludedKeys.indexOf(key) === -1) defStore[key] = colDef[key];
                    }
                });
            }
            definitions.push(defStore);
        });
        return definitions;
    }
}
class $517dee46856d349e$export$5a0eb14a9c37d425 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "popup";
    constructor(table){
        super(table);
        this.columnSubscribers = {};
        this.registerTableOption("rowContextPopup", false);
        this.registerTableOption("rowClickPopup", false);
        this.registerTableOption("rowDblClickPopup", false);
        this.registerTableOption("groupContextPopup", false);
        this.registerTableOption("groupClickPopup", false);
        this.registerTableOption("groupDblClickPopup", false);
        this.registerColumnOption("headerContextPopup");
        this.registerColumnOption("headerClickPopup");
        this.registerColumnOption("headerDblClickPopup");
        this.registerColumnOption("headerPopup");
        this.registerColumnOption("headerPopupIcon");
        this.registerColumnOption("contextPopup");
        this.registerColumnOption("clickPopup");
        this.registerColumnOption("dblClickPopup");
        this.registerComponentFunction("cell", "popup", this._componentPopupCall.bind(this));
        this.registerComponentFunction("column", "popup", this._componentPopupCall.bind(this));
        this.registerComponentFunction("row", "popup", this._componentPopupCall.bind(this));
        this.registerComponentFunction("group", "popup", this._componentPopupCall.bind(this));
    }
    initialize() {
        this.initializeRowWatchers();
        this.initializeGroupWatchers();
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    _componentPopupCall(component, contents, position) {
        this.loadPopupEvent(contents, null, component, position);
    }
    initializeRowWatchers() {
        if (this.table.options.rowContextPopup) {
            this.subscribe("row-contextmenu", this.loadPopupEvent.bind(this, this.table.options.rowContextPopup));
            this.table.on("rowTapHold", this.loadPopupEvent.bind(this, this.table.options.rowContextPopup));
        }
        if (this.table.options.rowClickPopup) this.subscribe("row-click", this.loadPopupEvent.bind(this, this.table.options.rowClickPopup));
        if (this.table.options.rowDblClickPopup) this.subscribe("row-dblclick", this.loadPopupEvent.bind(this, this.table.options.rowDblClickPopup));
    }
    initializeGroupWatchers() {
        if (this.table.options.groupContextPopup) {
            this.subscribe("group-contextmenu", this.loadPopupEvent.bind(this, this.table.options.groupContextPopup));
            this.table.on("groupTapHold", this.loadPopupEvent.bind(this, this.table.options.groupContextPopup));
        }
        if (this.table.options.groupClickPopup) this.subscribe("group-click", this.loadPopupEvent.bind(this, this.table.options.groupClickPopup));
        if (this.table.options.groupDblClickPopup) this.subscribe("group-dblclick", this.loadPopupEvent.bind(this, this.table.options.groupDblClickPopup));
    }
    initializeColumn(column) {
        var def = column.definition;
        //handle column events
        if (def.headerContextPopup && !this.columnSubscribers.headerContextPopup) {
            this.columnSubscribers.headerContextPopup = this.loadPopupTableColumnEvent.bind(this, "headerContextPopup");
            this.subscribe("column-contextmenu", this.columnSubscribers.headerContextPopup);
            this.table.on("headerTapHold", this.loadPopupTableColumnEvent.bind(this, "headerContextPopup"));
        }
        if (def.headerClickPopup && !this.columnSubscribers.headerClickPopup) {
            this.columnSubscribers.headerClickPopup = this.loadPopupTableColumnEvent.bind(this, "headerClickPopup");
            this.subscribe("column-click", this.columnSubscribers.headerClickPopup);
        }
        if (def.headerDblClickPopup && !this.columnSubscribers.headerDblClickPopup) {
            this.columnSubscribers.headerDblClickPopup = this.loadPopupTableColumnEvent.bind(this, "headerDblClickPopup");
            this.subscribe("column-dblclick", this.columnSubscribers.headerDblClickPopup);
        }
        if (def.headerPopup) this.initializeColumnHeaderPopup(column);
        //handle cell events
        if (def.contextPopup && !this.columnSubscribers.contextPopup) {
            this.columnSubscribers.contextPopup = this.loadPopupTableCellEvent.bind(this, "contextPopup");
            this.subscribe("cell-contextmenu", this.columnSubscribers.contextPopup);
            this.table.on("cellTapHold", this.loadPopupTableCellEvent.bind(this, "contextPopup"));
        }
        if (def.clickPopup && !this.columnSubscribers.clickPopup) {
            this.columnSubscribers.clickPopup = this.loadPopupTableCellEvent.bind(this, "clickPopup");
            this.subscribe("cell-click", this.columnSubscribers.clickPopup);
        }
        if (def.dblClickPopup && !this.columnSubscribers.dblClickPopup) {
            this.columnSubscribers.dblClickPopup = this.loadPopupTableCellEvent.bind(this, "dblClickPopup");
            this.subscribe("cell-click", this.columnSubscribers.dblClickPopup);
        }
    }
    initializeColumnHeaderPopup(column) {
        var icon = column.definition.headerPopupIcon, headerPopupEl;
        headerPopupEl = document.createElement("span");
        headerPopupEl.classList.add("tabulator-header-popup-button");
        if (icon) {
            if (typeof icon === "function") icon = icon(column.getComponent());
            if (icon instanceof HTMLElement) headerPopupEl.appendChild(icon);
            else headerPopupEl.innerHTML = icon;
        } else headerPopupEl.innerHTML = "&vellip;";
        headerPopupEl.addEventListener("click", (e)=>{
            e.stopPropagation();
            e.preventDefault();
            this.loadPopupEvent(column.definition.headerPopup, e, column);
        });
        column.titleElement.insertBefore(headerPopupEl, column.titleElement.firstChild);
    }
    loadPopupTableCellEvent(option, e, cell) {
        if (cell._cell) cell = cell._cell;
        if (cell.column.definition[option]) this.loadPopupEvent(cell.column.definition[option], e, cell);
    }
    loadPopupTableColumnEvent(option, e, column) {
        if (column._column) column = column._column;
        if (column.definition[option]) this.loadPopupEvent(column.definition[option], e, column);
    }
    loadPopupEvent(contents, e, component, position) {
        var renderedCallback;
        function onRendered(callback) {
            renderedCallback = callback;
        }
        if (component._group) component = component._group;
        else if (component._row) component = component._row;
        contents = typeof contents == "function" ? contents.call(this.table, e, component.getComponent(), onRendered) : contents;
        this.loadPopup(e, component, contents, renderedCallback, position);
    }
    loadPopup(e, component, contents, renderedCallback, position) {
        var touch = !(e instanceof MouseEvent), contentsEl, popup;
        if (contents instanceof HTMLElement) contentsEl = contents;
        else {
            contentsEl = document.createElement("div");
            contentsEl.innerHTML = contents;
        }
        contentsEl.classList.add("tabulator-popup");
        contentsEl.addEventListener("click", (e)=>{
            e.stopPropagation();
        });
        if (!touch) e.preventDefault();
        popup = this.popup(contentsEl);
        if (typeof renderedCallback === "function") popup.renderCallback(renderedCallback);
        if (e) popup.show(e);
        else popup.show(component.getElement(), position || "center");
        popup.hideOnBlur(()=>{
            this.dispatchExternal("popupClosed", component.getComponent());
        });
        this.dispatchExternal("popupOpened", component.getComponent());
    }
}
class $517dee46856d349e$export$94fbe99c03f5a051 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "print";
    constructor(table){
        super(table);
        this.element = false;
        this.manualBlock = false;
        this.beforeprintEventHandler = null;
        this.afterprintEventHandler = null;
        this.registerTableOption("printAsHtml", false); //enable print as html
        this.registerTableOption("printFormatter", false); //printing page formatter
        this.registerTableOption("printHeader", false); //page header contents
        this.registerTableOption("printFooter", false); //page footer contents
        this.registerTableOption("printStyled", true); //enable print as html styling
        this.registerTableOption("printRowRange", "visible"); //restrict print to visible rows only
        this.registerTableOption("printConfig", {}); //print config options
        this.registerColumnOption("print");
        this.registerColumnOption("titlePrint");
    }
    initialize() {
        if (this.table.options.printAsHtml) {
            this.beforeprintEventHandler = this.replaceTable.bind(this);
            this.afterprintEventHandler = this.cleanup.bind(this);
            window.addEventListener("beforeprint", this.beforeprintEventHandler);
            window.addEventListener("afterprint", this.afterprintEventHandler);
            this.subscribe("table-destroy", this.destroy.bind(this));
        }
        this.registerTableFunction("print", this.printFullscreen.bind(this));
    }
    destroy() {
        if (this.table.options.printAsHtml) {
            window.removeEventListener("beforeprint", this.beforeprintEventHandler);
            window.removeEventListener("afterprint", this.afterprintEventHandler);
        }
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    replaceTable() {
        if (!this.manualBlock) {
            this.element = document.createElement("div");
            this.element.classList.add("tabulator-print-table");
            this.element.appendChild(this.table.modules.export.generateTable(this.table.options.printConfig, this.table.options.printStyled, this.table.options.printRowRange, "print"));
            this.table.element.style.display = "none";
            this.table.element.parentNode.insertBefore(this.element, this.table.element);
        }
    }
    cleanup() {
        document.body.classList.remove("tabulator-print-fullscreen-hide");
        if (this.element && this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
            this.table.element.style.display = "";
        }
    }
    printFullscreen(visible, style, config) {
        var scrollX = window.scrollX, scrollY = window.scrollY, headerEl = document.createElement("div"), footerEl = document.createElement("div"), tableEl = this.table.modules.export.generateTable(typeof config != "undefined" ? config : this.table.options.printConfig, typeof style != "undefined" ? style : this.table.options.printStyled, visible || this.table.options.printRowRange, "print"), headerContent, footerContent;
        this.manualBlock = true;
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-print-fullscreen");
        if (this.table.options.printHeader) {
            headerEl.classList.add("tabulator-print-header");
            headerContent = typeof this.table.options.printHeader == "function" ? this.table.options.printHeader.call(this.table) : this.table.options.printHeader;
            if (typeof headerContent == "string") headerEl.innerHTML = headerContent;
            else headerEl.appendChild(headerContent);
            this.element.appendChild(headerEl);
        }
        this.element.appendChild(tableEl);
        if (this.table.options.printFooter) {
            footerEl.classList.add("tabulator-print-footer");
            footerContent = typeof this.table.options.printFooter == "function" ? this.table.options.printFooter.call(this.table) : this.table.options.printFooter;
            if (typeof footerContent == "string") footerEl.innerHTML = footerContent;
            else footerEl.appendChild(footerContent);
            this.element.appendChild(footerEl);
        }
        document.body.classList.add("tabulator-print-fullscreen-hide");
        document.body.appendChild(this.element);
        if (this.table.options.printFormatter) this.table.options.printFormatter(this.element, tableEl);
        window.print();
        this.cleanup();
        window.scrollTo(scrollX, scrollY);
        this.manualBlock = false;
    }
}
class $517dee46856d349e$export$1806fba60a0e8399 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "reactiveData";
    constructor(table){
        super(table);
        this.data = false;
        this.blocked = false; //block reactivity while performing update
        this.origFuncs = {}; // hold original data array functions to allow replacement after data is done with
        this.currentVersion = 0;
        this.registerTableOption("reactiveData", false); //enable data reactivity
    }
    initialize() {
        if (this.table.options.reactiveData) {
            this.subscribe("cell-value-save-before", this.block.bind(this, "cellsave"));
            this.subscribe("cell-value-save-after", this.unblock.bind(this, "cellsave"));
            this.subscribe("row-data-save-before", this.block.bind(this, "rowsave"));
            this.subscribe("row-data-save-after", this.unblock.bind(this, "rowsave"));
            this.subscribe("row-data-init-after", this.watchRow.bind(this));
            this.subscribe("data-processing", this.watchData.bind(this));
            this.subscribe("table-destroy", this.unwatchData.bind(this));
        }
    }
    watchData(data) {
        var self = this, version;
        this.currentVersion++;
        version = this.currentVersion;
        this.unwatchData();
        this.data = data;
        //override array push function
        this.origFuncs.push = data.push;
        Object.defineProperty(this.data, "push", {
            enumerable: false,
            configurable: true,
            value: function() {
                var args = Array.from(arguments), result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-push");
                    args.forEach((arg)=>{
                        self.table.rowManager.addRowActual(arg, false);
                    });
                    result = self.origFuncs.push.apply(data, arguments);
                    self.unblock("data-push");
                }
                return result;
            }
        });
        //override array unshift function
        this.origFuncs.unshift = data.unshift;
        Object.defineProperty(this.data, "unshift", {
            enumerable: false,
            configurable: true,
            value: function() {
                var args = Array.from(arguments), result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-unshift");
                    args.forEach((arg)=>{
                        self.table.rowManager.addRowActual(arg, true);
                    });
                    result = self.origFuncs.unshift.apply(data, arguments);
                    self.unblock("data-unshift");
                }
                return result;
            }
        });
        //override array shift function
        this.origFuncs.shift = data.shift;
        Object.defineProperty(this.data, "shift", {
            enumerable: false,
            configurable: true,
            value: function() {
                var row, result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-shift");
                    if (self.data.length) {
                        row = self.table.rowManager.getRowFromDataObject(self.data[0]);
                        if (row) row.deleteActual();
                    }
                    result = self.origFuncs.shift.call(data);
                    self.unblock("data-shift");
                }
                return result;
            }
        });
        //override array pop function
        this.origFuncs.pop = data.pop;
        Object.defineProperty(this.data, "pop", {
            enumerable: false,
            configurable: true,
            value: function() {
                var row, result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-pop");
                    if (self.data.length) {
                        row = self.table.rowManager.getRowFromDataObject(self.data[self.data.length - 1]);
                        if (row) row.deleteActual();
                    }
                    result = self.origFuncs.pop.call(data);
                    self.unblock("data-pop");
                }
                return result;
            }
        });
        //override array splice function
        this.origFuncs.splice = data.splice;
        Object.defineProperty(this.data, "splice", {
            enumerable: false,
            configurable: true,
            value: function() {
                var args = Array.from(arguments), start = args[0] < 0 ? data.length + args[0] : args[0], end = args[1], newRows = args[2] ? args.slice(2) : false, startRow, result;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("data-splice");
                    //add new rows
                    if (newRows) {
                        startRow = data[start] ? self.table.rowManager.getRowFromDataObject(data[start]) : false;
                        if (startRow) newRows.forEach((rowData)=>{
                            self.table.rowManager.addRowActual(rowData, true, startRow, true);
                        });
                        else {
                            newRows = newRows.slice().reverse();
                            newRows.forEach((rowData)=>{
                                self.table.rowManager.addRowActual(rowData, true, false, true);
                            });
                        }
                    }
                    //delete removed rows
                    if (end !== 0) {
                        var oldRows = data.slice(start, typeof args[1] === "undefined" ? args[1] : start + end);
                        oldRows.forEach((rowData, i)=>{
                            var row = self.table.rowManager.getRowFromDataObject(rowData);
                            if (row) row.deleteActual(i !== oldRows.length - 1);
                        });
                    }
                    if (newRows || end !== 0) self.table.rowManager.reRenderInPosition();
                    result = self.origFuncs.splice.apply(data, arguments);
                    self.unblock("data-splice");
                }
                return result;
            }
        });
    }
    unwatchData() {
        if (this.data !== false) for(var key in this.origFuncs)Object.defineProperty(this.data, key, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.origFuncs.key
        });
    }
    watchRow(row) {
        var data = row.getData();
        for(var key in data)this.watchKey(row, data, key);
        if (this.table.options.dataTree) this.watchTreeChildren(row);
    }
    watchTreeChildren(row) {
        var self = this, childField = row.getData()[this.table.options.dataTreeChildField], origFuncs = {};
        if (childField) {
            origFuncs.push = childField.push;
            Object.defineProperty(childField, "push", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-push");
                        var result = origFuncs.push.apply(childField, arguments);
                        this.rebuildTree(row);
                        self.unblock("tree-push");
                    }
                    return result;
                }
            });
            origFuncs.unshift = childField.unshift;
            Object.defineProperty(childField, "unshift", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-unshift");
                        var result = origFuncs.unshift.apply(childField, arguments);
                        this.rebuildTree(row);
                        self.unblock("tree-unshift");
                    }
                    return result;
                }
            });
            origFuncs.shift = childField.shift;
            Object.defineProperty(childField, "shift", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-shift");
                        var result = origFuncs.shift.call(childField);
                        this.rebuildTree(row);
                        self.unblock("tree-shift");
                    }
                    return result;
                }
            });
            origFuncs.pop = childField.pop;
            Object.defineProperty(childField, "pop", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-pop");
                        var result = origFuncs.pop.call(childField);
                        this.rebuildTree(row);
                        self.unblock("tree-pop");
                    }
                    return result;
                }
            });
            origFuncs.splice = childField.splice;
            Object.defineProperty(childField, "splice", {
                enumerable: false,
                configurable: true,
                value: ()=>{
                    if (!self.blocked) {
                        self.block("tree-splice");
                        var result = origFuncs.splice.apply(childField, arguments);
                        this.rebuildTree(row);
                        self.unblock("tree-splice");
                    }
                    return result;
                }
            });
        }
    }
    rebuildTree(row) {
        this.table.modules.dataTree.initializeRow(row);
        this.table.modules.dataTree.layoutRow(row);
        this.table.rowManager.refreshActiveData("tree", false, true);
    }
    watchKey(row, data, key) {
        var self = this, props = Object.getOwnPropertyDescriptor(data, key), value = data[key], version = this.currentVersion;
        Object.defineProperty(data, key, {
            set: (newValue)=>{
                value = newValue;
                if (!self.blocked && version === self.currentVersion) {
                    self.block("key");
                    var update = {};
                    update[key] = newValue;
                    row.updateData(update);
                    self.unblock("key");
                }
                if (props.set) props.set(newValue);
            },
            get: ()=>{
                if (props.get) props.get();
                return value;
            }
        });
    }
    unwatchRow(row) {
        var data = row.getData();
        for(var key in data)Object.defineProperty(data, key, {
            value: data[key]
        });
    }
    block(key) {
        if (!this.blocked) this.blocked = key;
    }
    unblock(key) {
        if (this.blocked === key) this.blocked = false;
    }
}
class $517dee46856d349e$export$3a1ca422b395df54 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "resizeColumns";
    constructor(table){
        super(table);
        this.startColumn = false;
        this.startX = false;
        this.startWidth = false;
        this.latestX = false;
        this.handle = null;
        this.initialNextColumn = null;
        this.nextColumn = null;
        this.initialized = false;
        this.registerColumnOption("resizable", true);
        this.registerTableOption("resizableColumnFit", false);
        this.registerTableOption("resizableColumnGuide", false);
    }
    initialize() {
        this.subscribe("column-rendered", this.layoutColumnHeader.bind(this));
    }
    initializeEventWatchers() {
        if (!this.initialized) {
            this.subscribe("cell-rendered", this.layoutCellHandles.bind(this));
            this.subscribe("cell-delete", this.deInitializeComponent.bind(this));
            this.subscribe("cell-height", this.resizeHandle.bind(this));
            this.subscribe("column-moved", this.columnLayoutUpdated.bind(this));
            this.subscribe("column-hide", this.deInitializeColumn.bind(this));
            this.subscribe("column-show", this.columnLayoutUpdated.bind(this));
            this.subscribe("column-width", this.columnWidthUpdated.bind(this));
            this.subscribe("column-delete", this.deInitializeComponent.bind(this));
            this.subscribe("column-height", this.resizeHandle.bind(this));
            this.initialized = true;
        }
    }
    layoutCellHandles(cell) {
        if (cell.row.type === "row") {
            this.deInitializeComponent(cell);
            this.initializeColumn("cell", cell, cell.column, cell.element);
        }
    }
    layoutColumnHeader(column) {
        if (column.definition.resizable) {
            this.initializeEventWatchers();
            this.deInitializeComponent(column);
            this.initializeColumn("header", column, column, column.element);
        }
    }
    columnLayoutUpdated(column) {
        var prev = column.prevColumn();
        this.reinitializeColumn(column);
        if (prev) this.reinitializeColumn(prev);
    }
    columnWidthUpdated(column) {
        if (column.modules.frozen) {
            if (this.table.modules.frozenColumns.leftColumns.includes(column)) this.table.modules.frozenColumns.leftColumns.forEach((col)=>{
                this.reinitializeColumn(col);
            });
            else if (this.table.modules.frozenColumns.rightColumns.includes(column)) this.table.modules.frozenColumns.rightColumns.forEach((col)=>{
                this.reinitializeColumn(col);
            });
        }
    }
    frozenColumnOffset(column) {
        var offset = false;
        if (column.modules.frozen) {
            offset = column.modules.frozen.marginValue;
            if (column.modules.frozen.position === "left") offset += column.getWidth() - 3;
            else if (offset) offset -= 3;
        }
        return offset !== false ? offset + "px" : false;
    }
    reinitializeColumn(column) {
        var frozenOffset = this.frozenColumnOffset(column);
        column.cells.forEach((cell)=>{
            if (cell.modules.resize && cell.modules.resize.handleEl) {
                if (frozenOffset) {
                    cell.modules.resize.handleEl.style[column.modules.frozen.position] = frozenOffset;
                    cell.modules.resize.handleEl.style["z-index"] = 11;
                }
                cell.element.after(cell.modules.resize.handleEl);
            }
        });
        if (column.modules.resize && column.modules.resize.handleEl) {
            if (frozenOffset) column.modules.resize.handleEl.style[column.modules.frozen.position] = frozenOffset;
            column.element.after(column.modules.resize.handleEl);
        }
    }
    initializeColumn(type, component, column, element) {
        var self = this, variableHeight = false, mode = column.definition.resizable, config = {}, nearestColumn = column.getLastColumn();
        //set column resize mode
        if (type === "header") {
            variableHeight = column.definition.formatter == "textarea" || column.definition.variableHeight;
            config = {
                variableHeight: variableHeight
            };
        }
        if ((mode === true || mode == type) && this._checkResizability(nearestColumn)) {
            var handle = document.createElement('span');
            handle.className = "tabulator-col-resize-handle";
            handle.addEventListener("click", function(e) {
                e.stopPropagation();
            });
            var handleDown = function(e) {
                self.startColumn = column;
                self.initialNextColumn = self.nextColumn = nearestColumn.nextColumn();
                self._mouseDown(e, nearestColumn, handle);
            };
            handle.addEventListener("mousedown", handleDown);
            handle.addEventListener("touchstart", handleDown, {
                passive: true
            });
            //resize column on  double click
            handle.addEventListener("dblclick", (e)=>{
                var oldWidth = nearestColumn.getWidth();
                e.stopPropagation();
                nearestColumn.reinitializeWidth(true);
                if (oldWidth !== nearestColumn.getWidth()) {
                    self.dispatch("column-resized", nearestColumn);
                    self.dispatchExternal("columnResized", nearestColumn.getComponent());
                }
            });
            if (column.modules.frozen) {
                handle.style.position = "sticky";
                handle.style[column.modules.frozen.position] = this.frozenColumnOffset(column);
            }
            config.handleEl = handle;
            if (element.parentNode && column.visible) element.after(handle);
        }
        component.modules.resize = config;
    }
    deInitializeColumn(column) {
        this.deInitializeComponent(column);
        column.cells.forEach((cell)=>{
            this.deInitializeComponent(cell);
        });
    }
    deInitializeComponent(component) {
        var handleEl;
        if (component.modules.resize) {
            handleEl = component.modules.resize.handleEl;
            if (handleEl && handleEl.parentElement) handleEl.parentElement.removeChild(handleEl);
        }
    }
    resizeHandle(component, height) {
        if (component.modules.resize && component.modules.resize.handleEl) component.modules.resize.handleEl.style.height = height;
    }
    resize(e, column) {
        var x = typeof e.clientX === "undefined" ? e.touches[0].clientX : e.clientX, startDiff = x - this.startX, moveDiff = x - this.latestX, blockedBefore, blockedAfter;
        this.latestX = x;
        if (this.table.rtl) {
            startDiff = -startDiff;
            moveDiff = -moveDiff;
        }
        blockedBefore = column.width == column.minWidth || column.width == column.maxWidth;
        column.setWidth(this.startWidth + startDiff);
        blockedAfter = column.width == column.minWidth || column.width == column.maxWidth;
        if (moveDiff < 0) this.nextColumn = this.initialNextColumn;
        if (this.table.options.resizableColumnFit && this.nextColumn && !(blockedBefore && blockedAfter)) {
            let colWidth = this.nextColumn.getWidth();
            if (moveDiff > 0) {
                if (colWidth <= this.nextColumn.minWidth) this.nextColumn = this.nextColumn.nextColumn();
            }
            if (this.nextColumn) this.nextColumn.setWidth(this.nextColumn.getWidth() - moveDiff);
        }
        this.table.columnManager.rerenderColumns(true);
        if (!this.table.browserSlow && column.modules.resize && column.modules.resize.variableHeight) column.checkCellHeights();
    }
    calcGuidePosition(e, column, handle) {
        var mouseX = typeof e.clientX === "undefined" ? e.touches[0].clientX : e.clientX, handleX = handle.getBoundingClientRect().x - this.table.element.getBoundingClientRect().x, tableX = this.table.element.getBoundingClientRect().x, columnX = column.element.getBoundingClientRect().left - tableX, mouseDiff = mouseX - this.startX, pos = Math.max(handleX + mouseDiff, columnX + column.minWidth);
        if (column.maxWidth) pos = Math.min(pos, columnX + column.maxWidth);
        return pos;
    }
    _checkResizability(column) {
        return column.definition.resizable;
    }
    _mouseDown(e, column, handle) {
        var self = this, guideEl;
        this.dispatchExternal("columnResizing", column.getComponent());
        if (self.table.options.resizableColumnGuide) {
            guideEl = document.createElement("span");
            guideEl.classList.add('tabulator-col-resize-guide');
            self.table.element.appendChild(guideEl);
            setTimeout(()=>{
                guideEl.style.left = self.calcGuidePosition(e, column, handle) + "px";
            });
        }
        self.table.element.classList.add("tabulator-block-select");
        function mouseMove(e) {
            if (self.table.options.resizableColumnGuide) guideEl.style.left = self.calcGuidePosition(e, column, handle) + "px";
            else self.resize(e, column);
        }
        function mouseUp(e) {
            if (self.table.options.resizableColumnGuide) {
                self.resize(e, column);
                guideEl.remove();
            }
            //block editor from taking action while resizing is taking place
            if (self.startColumn.modules.edit) self.startColumn.modules.edit.blocked = false;
            if (self.table.browserSlow && column.modules.resize && column.modules.resize.variableHeight) column.checkCellHeights();
            document.body.removeEventListener("mouseup", mouseUp);
            document.body.removeEventListener("mousemove", mouseMove);
            handle.removeEventListener("touchmove", mouseMove);
            handle.removeEventListener("touchend", mouseUp);
            self.table.element.classList.remove("tabulator-block-select");
            if (self.startWidth !== column.getWidth()) {
                self.table.columnManager.verticalAlignHeaders();
                self.dispatch("column-resized", column);
                self.dispatchExternal("columnResized", column.getComponent());
            }
        }
        e.stopPropagation(); //prevent resize from interfering with movable columns
        //block editor from taking action while resizing is taking place
        if (self.startColumn.modules.edit) self.startColumn.modules.edit.blocked = true;
        self.startX = typeof e.clientX === "undefined" ? e.touches[0].clientX : e.clientX;
        self.latestX = self.startX;
        self.startWidth = column.getWidth();
        document.body.addEventListener("mousemove", mouseMove);
        document.body.addEventListener("mouseup", mouseUp);
        handle.addEventListener("touchmove", mouseMove, {
            passive: true
        });
        handle.addEventListener("touchend", mouseUp);
    }
}
class $517dee46856d349e$export$5651a6c35bd86023 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "resizeRows";
    constructor(table){
        super(table);
        this.startColumn = false;
        this.startY = false;
        this.startHeight = false;
        this.handle = null;
        this.prevHandle = null;
        this.registerTableOption("resizableRows", false); //resizable rows
        this.registerTableOption("resizableRowGuide", false);
    }
    initialize() {
        if (this.table.options.resizableRows) this.subscribe("row-layout-after", this.initializeRow.bind(this));
    }
    initializeRow(row) {
        var self = this, rowEl = row.getElement();
        var handle = document.createElement('div');
        handle.className = "tabulator-row-resize-handle";
        var prevHandle = document.createElement('div');
        prevHandle.className = "tabulator-row-resize-handle prev";
        handle.addEventListener("click", function(e) {
            e.stopPropagation();
        });
        var handleDown = function(e) {
            self.startRow = row;
            self._mouseDown(e, row, handle);
        };
        handle.addEventListener("mousedown", handleDown);
        handle.addEventListener("touchstart", handleDown, {
            passive: true
        });
        prevHandle.addEventListener("click", function(e) {
            e.stopPropagation();
        });
        var prevHandleDown = function(e) {
            var prevRow = self.table.rowManager.prevDisplayRow(row);
            if (prevRow) {
                self.startRow = prevRow;
                self._mouseDown(e, prevRow, prevHandle);
            }
        };
        prevHandle.addEventListener("mousedown", prevHandleDown);
        prevHandle.addEventListener("touchstart", prevHandleDown, {
            passive: true
        });
        rowEl.appendChild(handle);
        rowEl.appendChild(prevHandle);
    }
    resize(e, row) {
        row.setHeight(this.startHeight + ((typeof e.screenY === "undefined" ? e.touches[0].screenY : e.screenY) - this.startY));
    }
    calcGuidePosition(e, row, handle) {
        var mouseY = typeof e.screenY === "undefined" ? e.touches[0].screenY : e.screenY, handleY = handle.getBoundingClientRect().y - this.table.element.getBoundingClientRect().y, tableY = this.table.element.getBoundingClientRect().y, rowY = row.element.getBoundingClientRect().top - tableY, mouseDiff = mouseY - this.startY;
        return Math.max(handleY + mouseDiff, rowY);
    }
    _mouseDown(e, row, handle) {
        var self = this, guideEl;
        self.dispatchExternal("rowResizing", row.getComponent());
        if (self.table.options.resizableRowGuide) {
            guideEl = document.createElement("span");
            guideEl.classList.add('tabulator-row-resize-guide');
            self.table.element.appendChild(guideEl);
            setTimeout(()=>{
                guideEl.style.top = self.calcGuidePosition(e, row, handle) + "px";
            });
        }
        self.table.element.classList.add("tabulator-block-select");
        function mouseMove(e) {
            if (self.table.options.resizableRowGuide) guideEl.style.top = self.calcGuidePosition(e, row, handle) + "px";
            else self.resize(e, row);
        }
        function mouseUp(e) {
            if (self.table.options.resizableRowGuide) {
                self.resize(e, row);
                guideEl.remove();
            }
            // //block editor from taking action while resizing is taking place
            // if(self.startColumn.modules.edit){
            // 	self.startColumn.modules.edit.blocked = false;
            // }
            document.body.removeEventListener("mouseup", mouseMove);
            document.body.removeEventListener("mousemove", mouseMove);
            handle.removeEventListener("touchmove", mouseMove);
            handle.removeEventListener("touchend", mouseUp);
            self.table.element.classList.remove("tabulator-block-select");
            self.dispatchExternal("rowResized", row.getComponent());
        }
        e.stopPropagation(); //prevent resize from interfering with movable columns
        //block editor from taking action while resizing is taking place
        // if(self.startColumn.modules.edit){
        // 	self.startColumn.modules.edit.blocked = true;
        // }
        self.startY = typeof e.screenY === "undefined" ? e.touches[0].screenY : e.screenY;
        self.startHeight = row.getHeight();
        document.body.addEventListener("mousemove", mouseMove);
        document.body.addEventListener("mouseup", mouseUp);
        handle.addEventListener("touchmove", mouseMove, {
            passive: true
        });
        handle.addEventListener("touchend", mouseUp);
    }
}
class $517dee46856d349e$export$977e646a85a63aba extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "resizeTable";
    constructor(table){
        super(table);
        this.binding = false;
        this.visibilityObserver = false;
        this.resizeObserver = false;
        this.containerObserver = false;
        this.tableHeight = 0;
        this.tableWidth = 0;
        this.containerHeight = 0;
        this.containerWidth = 0;
        this.autoResize = false;
        this.visible = false;
        this.initialized = false;
        this.initialRedraw = false;
        this.registerTableOption("autoResize", true); //auto resize table
    }
    initialize() {
        if (this.table.options.autoResize) {
            var table = this.table, tableStyle;
            this.tableHeight = table.element.clientHeight;
            this.tableWidth = table.element.clientWidth;
            if (table.element.parentNode) {
                this.containerHeight = table.element.parentNode.clientHeight;
                this.containerWidth = table.element.parentNode.clientWidth;
            }
            if (typeof IntersectionObserver !== "undefined" && typeof ResizeObserver !== "undefined" && table.rowManager.getRenderMode() === "virtual") {
                this.initializeVisibilityObserver();
                this.autoResize = true;
                this.resizeObserver = new ResizeObserver((entry)=>{
                    if (!table.browserMobile || table.browserMobile && (!table.modules.edit || table.modules.edit && !table.modules.edit.currentCell)) {
                        var nodeHeight = Math.floor(entry[0].contentRect.height);
                        var nodeWidth = Math.floor(entry[0].contentRect.width);
                        if (this.tableHeight != nodeHeight || this.tableWidth != nodeWidth) {
                            this.tableHeight = nodeHeight;
                            this.tableWidth = nodeWidth;
                            if (table.element.parentNode) {
                                this.containerHeight = table.element.parentNode.clientHeight;
                                this.containerWidth = table.element.parentNode.clientWidth;
                            }
                            this.redrawTable();
                        }
                    }
                });
                this.resizeObserver.observe(table.element);
                tableStyle = window.getComputedStyle(table.element);
                if (this.table.element.parentNode && !this.table.rowManager.fixedHeight && (tableStyle.getPropertyValue("max-height") || tableStyle.getPropertyValue("min-height"))) {
                    this.containerObserver = new ResizeObserver((entry)=>{
                        if (!table.browserMobile || table.browserMobile && (!table.modules.edit || table.modules.edit && !table.modules.edit.currentCell)) {
                            var nodeHeight = Math.floor(entry[0].contentRect.height);
                            var nodeWidth = Math.floor(entry[0].contentRect.width);
                            if (this.containerHeight != nodeHeight || this.containerWidth != nodeWidth) {
                                this.containerHeight = nodeHeight;
                                this.containerWidth = nodeWidth;
                                this.tableHeight = table.element.clientHeight;
                                this.tableWidth = table.element.clientWidth;
                            }
                            this.redrawTable();
                        }
                    });
                    this.containerObserver.observe(this.table.element.parentNode);
                }
                this.subscribe("table-resize", this.tableResized.bind(this));
            } else {
                this.binding = function() {
                    if (!table.browserMobile || table.browserMobile && (!table.modules.edit || table.modules.edit && !table.modules.edit.currentCell)) {
                        table.columnManager.rerenderColumns(true);
                        table.redraw();
                    }
                };
                window.addEventListener("resize", this.binding);
            }
            this.subscribe("table-destroy", this.clearBindings.bind(this));
        }
    }
    initializeVisibilityObserver() {
        this.visibilityObserver = new IntersectionObserver((entries)=>{
            this.visible = entries[0].isIntersecting;
            if (!this.initialized) {
                this.initialized = true;
                this.initialRedraw = !this.visible;
            } else if (this.visible) {
                this.redrawTable(this.initialRedraw);
                this.initialRedraw = false;
            }
        });
        this.visibilityObserver.observe(this.table.element);
    }
    redrawTable(force) {
        if (this.initialized && this.visible) {
            this.table.columnManager.rerenderColumns(true);
            this.table.redraw(force);
        }
    }
    tableResized() {
        this.table.rowManager.redraw();
    }
    clearBindings() {
        if (this.binding) window.removeEventListener("resize", this.binding);
        if (this.resizeObserver) this.resizeObserver.unobserve(this.table.element);
        if (this.visibilityObserver) this.visibilityObserver.unobserve(this.table.element);
        if (this.containerObserver) this.containerObserver.unobserve(this.table.element.parentNode);
    }
}
function $517dee46856d349e$var$responsiveCollapse(cell, formatterParams, onRendered) {
    var el = document.createElement("div"), config = cell.getRow()._row.modules.responsiveLayout;
    el.classList.add("tabulator-responsive-collapse-toggle");
    el.innerHTML = `<svg class='tabulator-responsive-collapse-toggle-open' viewbox="0 0 24 24">
  <line x1="7" y1="12" x2="17" y2="12" fill="none" stroke-width="3" stroke-linecap="round" />
  <line y1="7" x1="12" y2="17" x2="12" fill="none" stroke-width="3" stroke-linecap="round" />
</svg>

<svg class='tabulator-responsive-collapse-toggle-close' viewbox="0 0 24 24">
  <line x1="7" y1="12" x2="17" y2="12"  fill="none" stroke-width="3" stroke-linecap="round" />
</svg>`;
    cell.getElement().classList.add("tabulator-row-handle");
    function toggleList(isOpen) {
        var collapseEl = config.element;
        config.open = isOpen;
        if (collapseEl) {
            if (config.open) {
                el.classList.add("open");
                collapseEl.style.display = '';
            } else {
                el.classList.remove("open");
                collapseEl.style.display = 'none';
            }
        }
    }
    el.addEventListener("click", function(e) {
        e.stopImmediatePropagation();
        toggleList(!config.open);
        cell.getTable().rowManager.adjustTableSize();
    });
    toggleList(config.open);
    return el;
}
var $517dee46856d349e$var$extensions$2 = {
    format: {
        formatters: {
            responsiveCollapse: $517dee46856d349e$var$responsiveCollapse
        }
    }
};
class $517dee46856d349e$export$cc8706005768c818 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "responsiveLayout";
    static moduleExtensions = $517dee46856d349e$var$extensions$2;
    constructor(table){
        super(table);
        this.columns = [];
        this.hiddenColumns = [];
        this.mode = "";
        this.index = 0;
        this.collapseFormatter = [];
        this.collapseStartOpen = true;
        this.collapseHandleColumn = false;
        this.registerTableOption("responsiveLayout", false); //responsive layout flags
        this.registerTableOption("responsiveLayoutCollapseStartOpen", true); //start showing collapsed data
        this.registerTableOption("responsiveLayoutCollapseUseFormatters", true); //responsive layout collapse formatter
        this.registerTableOption("responsiveLayoutCollapseFormatter", false); //responsive layout collapse formatter
        this.registerColumnOption("responsive");
    }
    //generate responsive columns list
    initialize() {
        if (this.table.options.responsiveLayout) {
            this.subscribe("column-layout", this.initializeColumn.bind(this));
            this.subscribe("column-show", this.updateColumnVisibility.bind(this));
            this.subscribe("column-hide", this.updateColumnVisibility.bind(this));
            this.subscribe("columns-loaded", this.initializeResponsivity.bind(this));
            this.subscribe("column-moved", this.initializeResponsivity.bind(this));
            this.subscribe("column-add", this.initializeResponsivity.bind(this));
            this.subscribe("column-delete", this.initializeResponsivity.bind(this));
            this.subscribe("table-redrawing", this.tableRedraw.bind(this));
            if (this.table.options.responsiveLayout === "collapse") {
                this.subscribe("row-data-changed", this.generateCollapsedRowContent.bind(this));
                this.subscribe("row-init", this.initializeRow.bind(this));
                this.subscribe("row-layout", this.layoutRow.bind(this));
            }
        }
    }
    tableRedraw(force) {
        if ([
            "fitColumns",
            "fitDataStretch"
        ].indexOf(this.layoutMode()) === -1) {
            if (!force) this.update();
        }
    }
    initializeResponsivity() {
        var columns = [];
        this.mode = this.table.options.responsiveLayout;
        this.collapseFormatter = this.table.options.responsiveLayoutCollapseFormatter || this.formatCollapsedData;
        this.collapseStartOpen = this.table.options.responsiveLayoutCollapseStartOpen;
        this.hiddenColumns = [];
        if (this.collapseFormatter) this.collapseFormatter = this.collapseFormatter.bind(this.table);
        //determine level of responsivity for each column
        this.table.columnManager.columnsByIndex.forEach((column, i)=>{
            if (column.modules.responsive) {
                if (column.modules.responsive.order && column.modules.responsive.visible) {
                    column.modules.responsive.index = i;
                    columns.push(column);
                    if (!column.visible && this.mode === "collapse") this.hiddenColumns.push(column);
                }
            }
        });
        //sort list by responsivity
        columns = columns.reverse();
        columns = columns.sort((a, b)=>{
            var diff = b.modules.responsive.order - a.modules.responsive.order;
            return diff || b.modules.responsive.index - a.modules.responsive.index;
        });
        this.columns = columns;
        if (this.mode === "collapse") this.generateCollapsedContent();
        //assign collapse column
        for (let col of this.table.columnManager.columnsByIndex)if (col.definition.formatter == "responsiveCollapse") {
            this.collapseHandleColumn = col;
            break;
        }
        if (this.collapseHandleColumn) {
            if (this.hiddenColumns.length) this.collapseHandleColumn.show();
            else this.collapseHandleColumn.hide();
        }
    }
    //define layout information
    initializeColumn(column) {
        var def = column.getDefinition();
        column.modules.responsive = {
            order: typeof def.responsive === "undefined" ? 1 : def.responsive,
            visible: def.visible === false ? false : true
        };
    }
    initializeRow(row) {
        var el;
        if (row.type !== "calc") {
            el = document.createElement("div");
            el.classList.add("tabulator-responsive-collapse");
            row.modules.responsiveLayout = {
                element: el,
                open: this.collapseStartOpen
            };
            if (!this.collapseStartOpen) el.style.display = 'none';
        }
    }
    layoutRow(row) {
        var rowEl = row.getElement();
        if (row.modules.responsiveLayout) {
            rowEl.appendChild(row.modules.responsiveLayout.element);
            this.generateCollapsedRowContent(row);
        }
    }
    //update column visibility
    updateColumnVisibility(column, responsiveToggle) {
        if (!responsiveToggle && column.modules.responsive) {
            column.modules.responsive.visible = column.visible;
            this.initializeResponsivity();
        }
    }
    hideColumn(column) {
        var colCount = this.hiddenColumns.length;
        column.hide(false, true);
        if (this.mode === "collapse") {
            this.hiddenColumns.unshift(column);
            this.generateCollapsedContent();
            if (this.collapseHandleColumn && !colCount) this.collapseHandleColumn.show();
        }
    }
    showColumn(column) {
        var index;
        column.show(false, true);
        //set column width to prevent calculation loops on uninitialized columns
        column.setWidth(column.getWidth());
        if (this.mode === "collapse") {
            index = this.hiddenColumns.indexOf(column);
            if (index > -1) this.hiddenColumns.splice(index, 1);
            this.generateCollapsedContent();
            if (this.collapseHandleColumn && !this.hiddenColumns.length) this.collapseHandleColumn.hide();
        }
    }
    //redraw columns to fit space
    update() {
        var working = true;
        while(working){
            let width = this.table.modules.layout.getMode() == "fitColumns" ? this.table.columnManager.getFlexBaseWidth() : this.table.columnManager.getWidth();
            let diff = (this.table.options.headerVisible ? this.table.columnManager.element.clientWidth : this.table.element.clientWidth) - width;
            if (diff < 0) {
                //table is too wide
                let column = this.columns[this.index];
                if (column) {
                    this.hideColumn(column);
                    this.index++;
                } else working = false;
            } else {
                //table has spare space
                let column = this.columns[this.index - 1];
                if (column) {
                    if (diff > 0) {
                        if (diff >= column.getWidth()) {
                            this.showColumn(column);
                            this.index--;
                        } else working = false;
                    } else working = false;
                } else working = false;
            }
            if (!this.table.rowManager.activeRowsCount) this.table.rowManager.renderEmptyScroll();
        }
    }
    generateCollapsedContent() {
        var rows = this.table.rowManager.getDisplayRows();
        rows.forEach((row)=>{
            this.generateCollapsedRowContent(row);
        });
    }
    generateCollapsedRowContent(row) {
        var el, contents;
        if (row.modules.responsiveLayout) {
            el = row.modules.responsiveLayout.element;
            while(el.firstChild)el.removeChild(el.firstChild);
            contents = this.collapseFormatter(this.generateCollapsedRowData(row));
            if (contents) el.appendChild(contents);
            row.calcHeight(true);
        }
    }
    generateCollapsedRowData(row) {
        var data = row.getData(), output = [], mockCellComponent;
        this.hiddenColumns.forEach((column)=>{
            var value = column.getFieldValue(data);
            if (column.definition.title && column.field) {
                if (column.modules.format && this.table.options.responsiveLayoutCollapseUseFormatters) {
                    mockCellComponent = {
                        value: false,
                        data: {},
                        getValue: function() {
                            return value;
                        },
                        getData: function() {
                            return data;
                        },
                        getType: function() {
                            return "cell";
                        },
                        getElement: function() {
                            return document.createElement("div");
                        },
                        getRow: function() {
                            return row.getComponent();
                        },
                        getColumn: function() {
                            return column.getComponent();
                        },
                        getTable: ()=>{
                            return this.table;
                        }
                    };
                    function onRendered(callback) {
                        callback();
                    }
                    output.push({
                        field: column.field,
                        title: column.definition.title,
                        value: column.modules.format.formatter.call(this.table.modules.format, mockCellComponent, column.modules.format.params, onRendered)
                    });
                } else output.push({
                    field: column.field,
                    title: column.definition.title,
                    value: value
                });
            }
        });
        return output;
    }
    formatCollapsedData(data) {
        var list = document.createElement("table");
        data.forEach((item)=>{
            var row = document.createElement("tr");
            var titleData = document.createElement("td");
            var valueData = document.createElement("td");
            var node_content;
            var titleHighlight = document.createElement("strong");
            titleData.appendChild(titleHighlight);
            this.modules.localize.bind("columns|" + item.field, function(text) {
                titleHighlight.innerHTML = text || item.title;
            });
            if (item.value instanceof Node) {
                node_content = document.createElement("div");
                node_content.appendChild(item.value);
                valueData.appendChild(node_content);
            } else valueData.innerHTML = item.value;
            row.appendChild(titleData);
            row.appendChild(valueData);
            list.appendChild(row);
        });
        return Object.keys(data).length ? list : "";
    }
}
function $517dee46856d349e$var$rowSelection(cell, formatterParams, onRendered) {
    var checkbox = document.createElement("input");
    var blocked = false;
    checkbox.type = 'checkbox';
    checkbox.setAttribute("aria-label", "Select Row");
    if (this.table.modExists("selectRow", true)) {
        checkbox.addEventListener("click", (e)=>{
            e.stopPropagation();
        });
        if (typeof cell.getRow == 'function') {
            var row = cell.getRow();
            if (row instanceof $517dee46856d349e$export$5df91075f5ba4651) {
                checkbox.addEventListener("change", (e)=>{
                    if (this.table.options.selectableRowsRangeMode === "click") {
                        if (!blocked) row.toggleSelect();
                        else blocked = false;
                    } else row.toggleSelect();
                });
                if (this.table.options.selectableRowsRangeMode === "click") checkbox.addEventListener("click", (e)=>{
                    blocked = true;
                    this.table.modules.selectRow.handleComplexRowClick(row._row, e);
                });
                checkbox.checked = row.isSelected && row.isSelected();
                this.table.modules.selectRow.registerRowSelectCheckbox(row, checkbox);
            } else checkbox = "";
        } else {
            checkbox.addEventListener("change", (e)=>{
                if (this.table.modules.selectRow.selectedRows.length) this.table.deselectRow();
                else this.table.selectRow(formatterParams.rowRange);
            });
            this.table.modules.selectRow.registerHeaderSelectCheckbox(checkbox);
        }
    }
    return checkbox;
}
var $517dee46856d349e$var$extensions$1 = {
    format: {
        formatters: {
            rowSelection: $517dee46856d349e$var$rowSelection
        }
    }
};
class $517dee46856d349e$export$2e4fadc5338e55f5 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "selectRow";
    static moduleExtensions = $517dee46856d349e$var$extensions$1;
    constructor(table){
        super(table);
        this.selecting = false; //flag selecting in progress
        this.lastClickedRow = false; //last clicked row
        this.selectPrev = []; //hold previously selected element for drag drop selection
        this.selectedRows = []; //hold selected rows
        this.headerCheckboxElement = null; // hold header select element
        this.registerTableOption("selectableRows", "highlight"); //highlight rows on hover
        this.registerTableOption("selectableRowsRangeMode", "drag"); //highlight rows on hover
        this.registerTableOption("selectableRowsRollingSelection", true); //roll selection once maximum number of selectable rows is reached
        this.registerTableOption("selectableRowsPersistence", true); // maintain selection when table view is updated
        this.registerTableOption("selectableRowsCheck", function(data, row) {
            return true;
        }); //check whether row is selectable
        this.registerTableFunction("selectRow", this.selectRows.bind(this));
        this.registerTableFunction("deselectRow", this.deselectRows.bind(this));
        this.registerTableFunction("toggleSelectRow", this.toggleRow.bind(this));
        this.registerTableFunction("getSelectedRows", this.getSelectedRows.bind(this));
        this.registerTableFunction("getSelectedData", this.getSelectedData.bind(this));
        //register component functions
        this.registerComponentFunction("row", "select", this.selectRows.bind(this));
        this.registerComponentFunction("row", "deselect", this.deselectRows.bind(this));
        this.registerComponentFunction("row", "toggleSelect", this.toggleRow.bind(this));
        this.registerComponentFunction("row", "isSelected", this.isRowSelected.bind(this));
    }
    initialize() {
        this.deprecatedOptionsCheck();
        if (this.table.options.selectableRows === "highlight" && this.table.options.selectableRange) this.table.options.selectableRows = false;
        if (this.table.options.selectableRows !== false) {
            this.subscribe("row-init", this.initializeRow.bind(this));
            this.subscribe("row-deleting", this.rowDeleted.bind(this));
            this.subscribe("rows-wipe", this.clearSelectionData.bind(this));
            this.subscribe("rows-retrieve", this.rowRetrieve.bind(this));
            if (this.table.options.selectableRows && !this.table.options.selectableRowsPersistence) this.subscribe("data-refreshing", this.deselectRows.bind(this));
        }
    }
    deprecatedOptionsCheck() {
    // this.deprecationCheck("selectable", "selectableRows", true);
    // this.deprecationCheck("selectableRollingSelection", "selectableRowsRollingSelection", true);
    // this.deprecationCheck("selectableRangeMode", "selectableRowsRangeMode", true);
    // this.deprecationCheck("selectablePersistence", "selectableRowsPersistence", true);
    // this.deprecationCheck("selectableCheck", "selectableRowsCheck", true);
    }
    rowRetrieve(type, prevValue) {
        return type === "selected" ? this.selectedRows : prevValue;
    }
    rowDeleted(row) {
        this._deselectRow(row, true);
    }
    clearSelectionData(silent) {
        var prevSelected = this.selectedRows.length;
        this.selecting = false;
        this.lastClickedRow = false;
        this.selectPrev = [];
        this.selectedRows = [];
        if (prevSelected && silent !== true) this._rowSelectionChanged();
    }
    initializeRow(row) {
        var self = this, selectable = self.checkRowSelectability(row), element = row.getElement();
        // trigger end of row selection
        var endSelect = function() {
            setTimeout(function() {
                self.selecting = false;
            }, 50);
            document.body.removeEventListener("mouseup", endSelect);
        };
        row.modules.select = {
            selected: false
        };
        element.classList.toggle("tabulator-selectable", selectable);
        element.classList.toggle("tabulator-unselectable", !selectable);
        //set row selection class
        if (self.checkRowSelectability(row)) {
            if (self.table.options.selectableRows && self.table.options.selectableRows != "highlight") {
                if (self.table.options.selectableRowsRangeMode === "click") element.addEventListener("click", this.handleComplexRowClick.bind(this, row));
                else {
                    element.addEventListener("click", function(e) {
                        if (!self.table.modExists("edit") || !self.table.modules.edit.getCurrentCell()) self.table._clearSelection();
                        if (!self.selecting) self.toggleRow(row);
                    });
                    element.addEventListener("mousedown", function(e) {
                        if (e.shiftKey) {
                            self.table._clearSelection();
                            self.selecting = true;
                            self.selectPrev = [];
                            document.body.addEventListener("mouseup", endSelect);
                            document.body.addEventListener("keyup", endSelect);
                            self.toggleRow(row);
                            return false;
                        }
                    });
                    element.addEventListener("mouseenter", function(e) {
                        if (self.selecting) {
                            self.table._clearSelection();
                            self.toggleRow(row);
                            if (self.selectPrev[1] == row) self.toggleRow(self.selectPrev[0]);
                        }
                    });
                    element.addEventListener("mouseout", function(e) {
                        if (self.selecting) {
                            self.table._clearSelection();
                            self.selectPrev.unshift(row);
                        }
                    });
                }
            }
        }
    }
    handleComplexRowClick(row, e) {
        if (e.shiftKey) {
            this.table._clearSelection();
            this.lastClickedRow = this.lastClickedRow || row;
            var lastClickedRowIdx = this.table.rowManager.getDisplayRowIndex(this.lastClickedRow);
            var rowIdx = this.table.rowManager.getDisplayRowIndex(row);
            var fromRowIdx = lastClickedRowIdx <= rowIdx ? lastClickedRowIdx : rowIdx;
            var toRowIdx = lastClickedRowIdx >= rowIdx ? lastClickedRowIdx : rowIdx;
            var rows = this.table.rowManager.getDisplayRows().slice(0);
            var toggledRows = rows.splice(fromRowIdx, toRowIdx - fromRowIdx + 1);
            if (e.ctrlKey || e.metaKey) {
                toggledRows.forEach((toggledRow)=>{
                    if (toggledRow !== this.lastClickedRow) {
                        if (this.table.options.selectableRows !== true && !this.isRowSelected(row)) {
                            if (this.selectedRows.length < this.table.options.selectableRows) this.toggleRow(toggledRow);
                        } else this.toggleRow(toggledRow);
                    }
                });
                this.lastClickedRow = row;
            } else {
                this.deselectRows(undefined, true);
                if (this.table.options.selectableRows !== true) {
                    if (toggledRows.length > this.table.options.selectableRows) toggledRows = toggledRows.slice(0, this.table.options.selectableRows);
                }
                this.selectRows(toggledRows);
            }
            this.table._clearSelection();
        } else if (e.ctrlKey || e.metaKey) {
            this.toggleRow(row);
            this.lastClickedRow = row;
        } else {
            this.deselectRows(undefined, true);
            this.selectRows(row);
            this.lastClickedRow = row;
        }
    }
    checkRowSelectability(row) {
        if (row && row.type === "row") return this.table.options.selectableRowsCheck.call(this.table, row.getComponent());
        return false;
    }
    //toggle row selection
    toggleRow(row) {
        if (this.checkRowSelectability(row)) {
            if (row.modules.select && row.modules.select.selected) this._deselectRow(row);
            else this._selectRow(row);
        }
    }
    //select a number of rows
    selectRows(rows) {
        var changes = [], rowMatch, change;
        switch(typeof rows){
            case "undefined":
                rowMatch = this.table.rowManager.rows;
                break;
            case "number":
                rowMatch = this.table.rowManager.findRow(rows);
                break;
            case "string":
                rowMatch = this.table.rowManager.findRow(rows);
                if (!rowMatch) rowMatch = this.table.rowManager.getRows(rows);
                break;
            default:
                rowMatch = rows;
                break;
        }
        if (Array.isArray(rowMatch)) {
            if (rowMatch.length) {
                rowMatch.forEach((row)=>{
                    change = this._selectRow(row, true, true);
                    if (change) changes.push(change);
                });
                this._rowSelectionChanged(false, changes);
            }
        } else if (rowMatch) this._selectRow(rowMatch, false, true);
    }
    //select an individual row
    _selectRow(rowInfo, silent, force) {
        //handle max row count
        if (!isNaN(this.table.options.selectableRows) && this.table.options.selectableRows !== true && !force) {
            if (this.selectedRows.length >= this.table.options.selectableRows) {
                if (this.table.options.selectableRowsRollingSelection) this._deselectRow(this.selectedRows[0]);
                else return false;
            }
        }
        var row = this.table.rowManager.findRow(rowInfo);
        if (row) {
            if (this.selectedRows.indexOf(row) == -1) {
                row.getElement().classList.add("tabulator-selected");
                if (!row.modules.select) row.modules.select = {};
                row.modules.select.selected = true;
                if (row.modules.select.checkboxEl) row.modules.select.checkboxEl.checked = true;
                this.selectedRows.push(row);
                if (this.table.options.dataTreeSelectPropagate) this.childRowSelection(row, true);
                this.dispatchExternal("rowSelected", row.getComponent());
                this._rowSelectionChanged(silent, row);
                return row;
            }
        } else if (!silent) console.warn("Selection Error - No such row found, ignoring selection:" + rowInfo);
    }
    isRowSelected(row) {
        return this.selectedRows.indexOf(row) !== -1;
    }
    //deselect a number of rows
    deselectRows(rows, silent) {
        var changes = [], rowMatch, change;
        switch(typeof rows){
            case "undefined":
                rowMatch = Object.assign([], this.selectedRows);
                break;
            case "number":
                rowMatch = this.table.rowManager.findRow(rows);
                break;
            case "string":
                rowMatch = this.table.rowManager.findRow(rows);
                if (!rowMatch) rowMatch = this.table.rowManager.getRows(rows);
                break;
            default:
                rowMatch = rows;
                break;
        }
        if (Array.isArray(rowMatch)) {
            if (rowMatch.length) {
                rowMatch.forEach((row)=>{
                    change = this._deselectRow(row, true, true);
                    if (change) changes.push(change);
                });
                this._rowSelectionChanged(silent, [], changes);
            }
        } else if (rowMatch) this._deselectRow(rowMatch, silent, true);
    }
    //deselect an individual row
    _deselectRow(rowInfo, silent) {
        var self = this, row = self.table.rowManager.findRow(rowInfo), index, element;
        if (row) {
            index = self.selectedRows.findIndex(function(selectedRow) {
                return selectedRow == row;
            });
            if (index > -1) {
                element = row.getElement();
                if (element) element.classList.remove("tabulator-selected");
                if (!row.modules.select) row.modules.select = {};
                row.modules.select.selected = false;
                if (row.modules.select.checkboxEl) row.modules.select.checkboxEl.checked = false;
                self.selectedRows.splice(index, 1);
                if (this.table.options.dataTreeSelectPropagate) this.childRowSelection(row, false);
                this.dispatchExternal("rowDeselected", row.getComponent());
                self._rowSelectionChanged(silent, undefined, row);
                return row;
            }
        } else if (!silent) console.warn("Deselection Error - No such row found, ignoring selection:" + rowInfo);
    }
    getSelectedData() {
        var data = [];
        this.selectedRows.forEach(function(row) {
            data.push(row.getData());
        });
        return data;
    }
    getSelectedRows() {
        var rows = [];
        this.selectedRows.forEach(function(row) {
            rows.push(row.getComponent());
        });
        return rows;
    }
    _rowSelectionChanged(silent, selected = [], deselected = []) {
        if (this.headerCheckboxElement) {
            if (this.selectedRows.length === 0) {
                this.headerCheckboxElement.checked = false;
                this.headerCheckboxElement.indeterminate = false;
            } else if (this.table.rowManager.rows.length === this.selectedRows.length) {
                this.headerCheckboxElement.checked = true;
                this.headerCheckboxElement.indeterminate = false;
            } else {
                this.headerCheckboxElement.indeterminate = true;
                this.headerCheckboxElement.checked = false;
            }
        }
        if (!silent) {
            if (!Array.isArray(selected)) selected = [
                selected
            ];
            selected = selected.map((row)=>row.getComponent());
            if (!Array.isArray(deselected)) deselected = [
                deselected
            ];
            deselected = deselected.map((row)=>row.getComponent());
            this.dispatchExternal("rowSelectionChanged", this.getSelectedData(), this.getSelectedRows(), selected, deselected);
        }
    }
    registerRowSelectCheckbox(row, element) {
        if (!row._row.modules.select) row._row.modules.select = {};
        row._row.modules.select.checkboxEl = element;
    }
    registerHeaderSelectCheckbox(element) {
        this.headerCheckboxElement = element;
    }
    childRowSelection(row, select) {
        var children = this.table.modules.dataTree.getChildren(row, true, true);
        if (select) for (let child of children)this._selectRow(child, true);
        else for (let child of children)this._deselectRow(child, true);
    }
}
class $517dee46856d349e$export$433bfdbc52491af1 {
    constructor(range){
        this._range = range;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._range.table.componentFunctionBinder.handle("range", target._range, name);
            }
        });
    }
    getElement() {
        return this._range.element;
    }
    getData() {
        return this._range.getData();
    }
    getCells() {
        return this._range.getCells(true, true);
    }
    getStructuredCells() {
        return this._range.getStructuredCells();
    }
    getRows() {
        return this._range.getRows().map((row)=>row.getComponent());
    }
    getColumns() {
        return this._range.getColumns().map((column)=>column.getComponent());
    }
    getBounds() {
        return this._range.getBounds();
    }
    getTopEdge() {
        return this._range.top;
    }
    getBottomEdge() {
        return this._range.bottom;
    }
    getLeftEdge() {
        return this._range.left;
    }
    getRightEdge() {
        return this._range.right;
    }
    setBounds(start, end) {
        if (this._range.destroyedGuard("setBounds")) this._range.setBounds(start ? start._cell : start, end ? end._cell : end);
    }
    setStartBound(start) {
        if (this._range.destroyedGuard("setStartBound")) {
            this._range.setEndBound(start ? start._cell : start);
            this._range.rangeManager.layoutElement();
        }
    }
    setEndBound(end) {
        if (this._range.destroyedGuard("setEndBound")) {
            this._range.setEndBound(end ? end._cell : end);
            this._range.rangeManager.layoutElement();
        }
    }
    clearValues() {
        if (this._range.destroyedGuard("clearValues")) this._range.clearValues();
    }
    remove() {
        if (this._range.destroyedGuard("remove")) this._range.destroy(true);
    }
}
class $517dee46856d349e$var$Range extends $517dee46856d349e$var$CoreFeature {
    constructor(table, rangeManager, start, end){
        super(table);
        this.rangeManager = rangeManager;
        this.element = null;
        this.initialized = false;
        this.initializing = {
            start: false,
            end: false
        };
        this.destroyed = false;
        this.top = 0;
        this.bottom = 0;
        this.left = 0;
        this.right = 0;
        this.table = table;
        this.start = {
            row: 0,
            col: 0
        };
        this.end = {
            row: 0,
            col: 0
        };
        if (this.rangeManager.rowHeader) {
            this.left = 1;
            this.right = 1;
            this.start.col = 1;
            this.end.col = 1;
        }
        this.initElement();
        setTimeout(()=>{
            this.initBounds(start, end);
        });
    }
    initElement() {
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-range");
    }
    initBounds(start, end) {
        this._updateMinMax();
        if (start) this.setBounds(start, end || start);
    }
    ///////////////////////////////////
    ///////   Boundary Setup    ///////
    ///////////////////////////////////
    setStart(row, col) {
        if (this.start.row !== row || this.start.col !== col) {
            this.start.row = row;
            this.start.col = col;
            this.initializing.start = true;
            this._updateMinMax();
        }
    }
    setEnd(row, col) {
        if (this.end.row !== row || this.end.col !== col) {
            this.end.row = row;
            this.end.col = col;
            this.initializing.end = true;
            this._updateMinMax();
        }
    }
    setBounds(start, end, visibleRows) {
        if (start) this.setStartBound(start);
        this.setEndBound(end || start);
        this.rangeManager.layoutElement(visibleRows);
    }
    setStartBound(element) {
        var row, col;
        if (element.type === "column") {
            if (this.rangeManager.columnSelection) this.setStart(0, element.getPosition() - 1);
        } else {
            row = element.row.position - 1;
            col = element.column.getPosition() - 1;
            if (element.column === this.rangeManager.rowHeader) this.setStart(row, 1);
            else this.setStart(row, col);
        }
    }
    setEndBound(element) {
        var rowsCount = this._getTableRows().length, row, col, isRowHeader;
        if (element.type === "column") {
            if (this.rangeManager.columnSelection) {
                if (this.rangeManager.selecting === "column") this.setEnd(rowsCount - 1, element.getPosition() - 1);
                else if (this.rangeManager.selecting === "cell") this.setEnd(0, element.getPosition() - 1);
            }
        } else {
            row = element.row.position - 1;
            col = element.column.getPosition() - 1;
            isRowHeader = element.column === this.rangeManager.rowHeader;
            if (this.rangeManager.selecting === "row") this.setEnd(row, this._getTableColumns().length - 1);
            else if (this.rangeManager.selecting !== "row" && isRowHeader) this.setEnd(row, 0);
            else if (this.rangeManager.selecting === "column") this.setEnd(rowsCount - 1, col);
            else this.setEnd(row, col);
        }
    }
    _updateMinMax() {
        this.top = Math.min(this.start.row, this.end.row);
        this.bottom = Math.max(this.start.row, this.end.row);
        this.left = Math.min(this.start.col, this.end.col);
        this.right = Math.max(this.start.col, this.end.col);
        if (this.initialized) this.dispatchExternal("rangeChanged", this.getComponent());
        else if (this.initializing.start && this.initializing.end) {
            this.initialized = true;
            this.dispatchExternal("rangeAdded", this.getComponent());
        }
    }
    _getTableColumns() {
        return this.table.columnManager.getVisibleColumnsByIndex();
    }
    _getTableRows() {
        return this.table.rowManager.getDisplayRows().filter((row)=>row.type === "row");
    }
    ///////////////////////////////////
    ///////      Rendering      ///////
    ///////////////////////////////////
    layout() {
        var _vDomTop = this.table.rowManager.renderer.vDomTop, _vDomBottom = this.table.rowManager.renderer.vDomBottom, _vDomLeft = this.table.columnManager.renderer.leftCol, _vDomRight = this.table.columnManager.renderer.rightCol, top, bottom, left, right, topLeftCell, bottomRightCell, topLeftCellEl, bottomRightCellEl, topLeftRowEl, bottomRightRowEl;
        if (this.table.options.renderHorizontal === "virtual" && this.rangeManager.rowHeader) _vDomRight += 1;
        if (_vDomTop == null) _vDomTop = 0;
        if (_vDomBottom == null) _vDomBottom = Infinity;
        if (_vDomLeft == null) _vDomLeft = 0;
        if (_vDomRight == null) _vDomRight = Infinity;
        if (this.overlaps(_vDomLeft, _vDomTop, _vDomRight, _vDomBottom)) {
            top = Math.max(this.top, _vDomTop);
            bottom = Math.min(this.bottom, _vDomBottom);
            left = Math.max(this.left, _vDomLeft);
            right = Math.min(this.right, _vDomRight);
            topLeftCell = this.rangeManager.getCell(top, left);
            bottomRightCell = this.rangeManager.getCell(bottom, right);
            topLeftCellEl = topLeftCell.getElement();
            bottomRightCellEl = bottomRightCell.getElement();
            topLeftRowEl = topLeftCell.row.getElement();
            bottomRightRowEl = bottomRightCell.row.getElement();
            this.element.classList.add("tabulator-range-active");
            // this.element.classList.toggle("tabulator-range-active", this === this.rangeManager.activeRange);
            if (this.table.rtl) {
                this.element.style.right = topLeftRowEl.offsetWidth - topLeftCellEl.offsetLeft - topLeftCellEl.offsetWidth + "px";
                this.element.style.width = topLeftCellEl.offsetLeft + topLeftCellEl.offsetWidth - bottomRightCellEl.offsetLeft + "px";
            } else {
                this.element.style.left = topLeftRowEl.offsetLeft + topLeftCellEl.offsetLeft + "px";
                this.element.style.width = bottomRightCellEl.offsetLeft + bottomRightCellEl.offsetWidth - topLeftCellEl.offsetLeft + "px";
            }
            this.element.style.top = topLeftRowEl.offsetTop + "px";
            this.element.style.height = bottomRightRowEl.offsetTop + bottomRightRowEl.offsetHeight - topLeftRowEl.offsetTop + "px";
        }
    }
    atTopLeft(cell) {
        return cell.row.position - 1 === this.top && cell.column.getPosition() - 1 === this.left;
    }
    atBottomRight(cell) {
        return cell.row.position - 1 === this.bottom && cell.column.getPosition() - 1 === this.right;
    }
    occupies(cell) {
        return this.occupiesRow(cell.row) && this.occupiesColumn(cell.column);
    }
    occupiesRow(row) {
        return this.top <= row.position - 1 && row.position - 1 <= this.bottom;
    }
    occupiesColumn(col) {
        return this.left <= col.getPosition() - 1 && col.getPosition() - 1 <= this.right;
    }
    overlaps(left, top, right, bottom) {
        if (this.left > right || left > this.right || this.top > bottom || top > this.bottom) return false;
        return true;
    }
    getData() {
        var data = [], rows = this.getRows(), columns = this.getColumns();
        rows.forEach((row)=>{
            var rowData = row.getData(), result = {};
            columns.forEach((column)=>{
                result[column.field] = rowData[column.field];
            });
            data.push(result);
        });
        return data;
    }
    getCells(structured, component) {
        var cells = [], rows = this.getRows(), columns = this.getColumns();
        if (structured) cells = rows.map((row)=>{
            var arr = [];
            row.getCells().forEach((cell)=>{
                if (columns.includes(cell.column)) arr.push(component ? cell.getComponent() : cell);
            });
            return arr;
        });
        else rows.forEach((row)=>{
            row.getCells().forEach((cell)=>{
                if (columns.includes(cell.column)) cells.push(component ? cell.getComponent() : cell);
            });
        });
        return cells;
    }
    getStructuredCells() {
        return this.getCells(true, true);
    }
    getRows() {
        return this._getTableRows().slice(this.top, this.bottom + 1);
    }
    getColumns() {
        return this._getTableColumns().slice(this.left, this.right + 1);
    }
    clearValues() {
        var cells = this.getCells();
        var clearValue = this.table.options.selectableRangeClearCellsValue;
        this.table.blockRedraw();
        cells.forEach((cell)=>{
            cell.setValue(clearValue);
        });
        this.table.restoreRedraw();
    }
    getBounds(component) {
        var cells = this.getCells(false, component), output = {
            start: null,
            end: null
        };
        if (cells.length) {
            output.start = cells[0];
            output.end = cells[cells.length - 1];
        } else console.warn("No bounds defined on range");
        return output;
    }
    getComponent() {
        if (!this.component) this.component = new $517dee46856d349e$export$433bfdbc52491af1(this);
        return this.component;
    }
    destroy(notify) {
        this.destroyed = true;
        this.element.remove();
        if (notify) this.rangeManager.rangeRemoved(this);
        if (this.initialized) this.dispatchExternal("rangeRemoved", this.getComponent());
    }
    destroyedGuard(func) {
        if (this.destroyed) console.warn("You cannot call the " + func + " function on a destroyed range");
        return !this.destroyed;
    }
}
var $517dee46856d349e$var$bindings = {
    rangeJumpUp: [
        "ctrl + 38",
        "meta + 38"
    ],
    rangeJumpDown: [
        "ctrl + 40",
        "meta + 40"
    ],
    rangeJumpLeft: [
        "ctrl + 37",
        "meta + 37"
    ],
    rangeJumpRight: [
        "ctrl + 39",
        "meta + 39"
    ],
    rangeExpandUp: "shift + 38",
    rangeExpandDown: "shift + 40",
    rangeExpandLeft: "shift + 37",
    rangeExpandRight: "shift + 39",
    rangeExpandJumpUp: [
        "ctrl + shift + 38",
        "meta + shift + 38"
    ],
    rangeExpandJumpDown: [
        "ctrl + shift + 40",
        "meta + shift + 40"
    ],
    rangeExpandJumpLeft: [
        "ctrl + shift + 37",
        "meta + shift + 37"
    ],
    rangeExpandJumpRight: [
        "ctrl + shift + 39",
        "meta + shift + 39"
    ]
};
var $517dee46856d349e$var$actions = {
    rangeJumpLeft: function(e) {
        this.dispatch("keybinding-nav-range", e, "left", true, false);
    },
    rangeJumpRight: function(e) {
        this.dispatch("keybinding-nav-range", e, "right", true, false);
    },
    rangeJumpUp: function(e) {
        this.dispatch("keybinding-nav-range", e, "up", true, false);
    },
    rangeJumpDown: function(e) {
        this.dispatch("keybinding-nav-range", e, "down", true, false);
    },
    rangeExpandLeft: function(e) {
        this.dispatch("keybinding-nav-range", e, "left", false, true);
    },
    rangeExpandRight: function(e) {
        this.dispatch("keybinding-nav-range", e, "right", false, true);
    },
    rangeExpandUp: function(e) {
        this.dispatch("keybinding-nav-range", e, "up", false, true);
    },
    rangeExpandDown: function(e) {
        this.dispatch("keybinding-nav-range", e, "down", false, true);
    },
    rangeExpandJumpLeft: function(e) {
        this.dispatch("keybinding-nav-range", e, "left", true, true);
    },
    rangeExpandJumpRight: function(e) {
        this.dispatch("keybinding-nav-range", e, "right", true, true);
    },
    rangeExpandJumpUp: function(e) {
        this.dispatch("keybinding-nav-range", e, "up", true, true);
    },
    rangeExpandJumpDown: function(e) {
        this.dispatch("keybinding-nav-range", e, "down", true, true);
    }
};
var $517dee46856d349e$var$pasteActions = {
    range: function(data) {
        var rows = [], range = this.table.modules.selectRange.activeRange, singleCell = false, bounds, startCell, startRow, rowWidth, dataLength;
        dataLength = data.length;
        if (range) {
            bounds = range.getBounds();
            startCell = bounds.start;
            if (bounds.start === bounds.end) singleCell = true;
            if (startCell) {
                rows = this.table.rowManager.activeRows.slice();
                startRow = rows.indexOf(startCell.row);
                if (singleCell) rowWidth = data.length;
                else rowWidth = rows.indexOf(bounds.end.row) - startRow + 1;
                if (startRow > -1) {
                    this.table.blockRedraw();
                    rows = rows.slice(startRow, startRow + rowWidth);
                    rows.forEach((row, i)=>{
                        row.updateData(data[i % dataLength]);
                    });
                    this.table.restoreRedraw();
                }
            }
        }
        return rows;
    }
};
var $517dee46856d349e$var$pasteParsers = {
    range: function(clipboard) {
        var data = [], rows = [], range = this.table.modules.selectRange.activeRange, singleCell = false, bounds, startCell, colWidth, columnMap, startCol;
        if (range) {
            bounds = range.getBounds();
            startCell = bounds.start;
            if (bounds.start === bounds.end) singleCell = true;
            if (startCell) {
                //get data from clipboard into array of columns and rows.
                clipboard = clipboard.split("\n");
                clipboard.forEach(function(row) {
                    data.push(row.split("\t"));
                });
                if (data.length) {
                    columnMap = this.table.columnManager.getVisibleColumnsByIndex();
                    startCol = columnMap.indexOf(startCell.column);
                    if (startCol > -1) {
                        if (singleCell) colWidth = data[0].length;
                        else colWidth = columnMap.indexOf(bounds.end.column) - startCol + 1;
                        columnMap = columnMap.slice(startCol, startCol + colWidth);
                        data.forEach((item)=>{
                            var row = {};
                            var itemLength = item.length;
                            columnMap.forEach(function(col, i) {
                                row[col.field] = item[i % itemLength];
                            });
                            rows.push(row);
                        });
                        return rows;
                    }
                }
            }
        }
        return false;
    }
};
var $517dee46856d349e$var$columnLookups = {
    range: function() {
        var columns = this.modules.selectRange.selectedColumns();
        if (this.columnManager.rowHeader) columns.unshift(this.columnManager.rowHeader);
        return columns;
    }
};
var $517dee46856d349e$var$rowLookups = {
    range: function() {
        return this.modules.selectRange.selectedRows();
    }
};
var $517dee46856d349e$var$extensions = {
    keybindings: {
        bindings: $517dee46856d349e$var$bindings,
        actions: $517dee46856d349e$var$actions
    },
    clipboard: {
        pasteActions: $517dee46856d349e$var$pasteActions,
        pasteParsers: $517dee46856d349e$var$pasteParsers
    },
    export: {
        columnLookups: $517dee46856d349e$var$columnLookups,
        rowLookups: $517dee46856d349e$var$rowLookups
    }
};
class $517dee46856d349e$export$cd9e469b2c8c819c extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "selectRange";
    static moduleInitOrder = 1;
    static moduleExtensions = $517dee46856d349e$var$extensions;
    constructor(table){
        super(table);
        this.selecting = "cell";
        this.mousedown = false;
        this.ranges = [];
        this.overlay = null;
        this.rowHeader = null;
        this.layoutChangeTimeout = null;
        this.columnSelection = false;
        this.rowSelection = false;
        this.maxRanges = 0;
        this.activeRange = false;
        this.blockKeydown = false;
        this.keyDownEvent = this._handleKeyDown.bind(this);
        this.mouseUpEvent = this._handleMouseUp.bind(this);
        this.registerTableOption("selectableRange", false); //enable selectable range
        this.registerTableOption("selectableRangeColumns", false); //enable selectable range
        this.registerTableOption("selectableRangeRows", false); //enable selectable range
        this.registerTableOption("selectableRangeClearCells", false); //allow clearing of active range
        this.registerTableOption("selectableRangeClearCellsValue", undefined); //value for cleared active range
        this.registerTableOption("selectableRangeAutoFocus", true); //focus on a cell after resetRanges
        this.registerTableFunction("getRangesData", this.getRangesData.bind(this));
        this.registerTableFunction("getRanges", this.getRanges.bind(this));
        this.registerTableFunction("addRange", this.addRangeFromComponent.bind(this));
        this.registerComponentFunction("cell", "getRanges", this.cellGetRanges.bind(this));
        this.registerComponentFunction("row", "getRanges", this.rowGetRanges.bind(this));
        this.registerComponentFunction("column", "getRanges", this.colGetRanges.bind(this));
    }
    ///////////////////////////////////
    ///////    Initialization   ///////
    ///////////////////////////////////
    initialize() {
        if (this.options("selectableRange")) {
            if (!this.options("selectableRows")) {
                this.maxRanges = this.options("selectableRange");
                this.initializeTable();
                this.initializeWatchers();
            } else console.warn("SelectRange functionality cannot be used in conjunction with row selection");
            if (this.options('columns').findIndex((column)=>column.frozen) > 0) console.warn("Having frozen column in arbitrary position with selectRange option may result in unpredictable behavior.");
            if (this.options('columns').filter((column)=>column.frozen) > 1) console.warn("Having multiple frozen columns with selectRange option may result in unpredictable behavior.");
        }
    }
    initializeTable() {
        this.overlay = document.createElement("div");
        this.overlay.classList.add("tabulator-range-overlay");
        this.rangeContainer = document.createElement("div");
        this.rangeContainer.classList.add("tabulator-range-container");
        this.activeRangeCellElement = document.createElement("div");
        this.activeRangeCellElement.classList.add("tabulator-range-cell-active");
        this.overlay.appendChild(this.rangeContainer);
        this.overlay.appendChild(this.activeRangeCellElement);
        this.table.rowManager.element.addEventListener("keydown", this.keyDownEvent);
        this.resetRanges();
        this.table.rowManager.element.appendChild(this.overlay);
        this.table.columnManager.element.setAttribute("tabindex", 0);
        this.table.element.classList.add("tabulator-ranges");
    }
    initializeWatchers() {
        this.columnSelection = this.options("selectableRangeColumns");
        this.rowSelection = this.options("selectableRangeRows");
        this.subscribe("column-init", this.initializeColumn.bind(this));
        this.subscribe("column-mousedown", this.handleColumnMouseDown.bind(this));
        this.subscribe("column-mousemove", this.handleColumnMouseMove.bind(this));
        this.subscribe("column-resized", this.handleColumnResized.bind(this));
        this.subscribe("column-moving", this.handleColumnMoving.bind(this));
        this.subscribe("column-moved", this.handleColumnMoved.bind(this));
        this.subscribe("column-width", this.layoutChange.bind(this));
        this.subscribe("column-height", this.layoutChange.bind(this));
        this.subscribe("column-resized", this.layoutChange.bind(this));
        this.subscribe("columns-loaded", this.updateHeaderColumn.bind(this));
        this.subscribe("cell-height", this.layoutChange.bind(this));
        this.subscribe("cell-rendered", this.renderCell.bind(this));
        this.subscribe("cell-mousedown", this.handleCellMouseDown.bind(this));
        this.subscribe("cell-mousemove", this.handleCellMouseMove.bind(this));
        this.subscribe("cell-click", this.handleCellClick.bind(this));
        this.subscribe("cell-editing", this.handleEditingCell.bind(this));
        this.subscribe("page-changed", this.redraw.bind(this));
        this.subscribe("scroll-vertical", this.layoutChange.bind(this));
        this.subscribe("scroll-horizontal", this.layoutChange.bind(this));
        this.subscribe("data-destroy", this.tableDestroyed.bind(this));
        this.subscribe("data-processed", this.resetRanges.bind(this));
        this.subscribe("table-layout", this.layoutElement.bind(this));
        this.subscribe("table-redraw", this.redraw.bind(this));
        this.subscribe("table-destroy", this.tableDestroyed.bind(this));
        this.subscribe("edit-editor-clear", this.finishEditingCell.bind(this));
        this.subscribe("edit-blur", this.restoreFocus.bind(this));
        this.subscribe("keybinding-nav-prev", this.keyNavigate.bind(this, "left"));
        this.subscribe("keybinding-nav-next", this.keyNavigate.bind(this, "right"));
        this.subscribe("keybinding-nav-left", this.keyNavigate.bind(this, "left"));
        this.subscribe("keybinding-nav-right", this.keyNavigate.bind(this, "right"));
        this.subscribe("keybinding-nav-up", this.keyNavigate.bind(this, "up"));
        this.subscribe("keybinding-nav-down", this.keyNavigate.bind(this, "down"));
        this.subscribe("keybinding-nav-range", this.keyNavigateRange.bind(this));
    }
    initializeColumn(column) {
        if (this.columnSelection && column.definition.headerSort && this.options("headerSortClickElement") !== "icon") console.warn("Using column headerSort with selectableRangeColumns option may result in unpredictable behavior. Consider using headerSortClickElement: 'icon'.");
        column.modules.edit;
    }
    updateHeaderColumn() {
        var frozenCols;
        if (this.rowSelection) {
            this.rowHeader = this.table.columnManager.getVisibleColumnsByIndex()[0];
            if (this.rowHeader) {
                this.rowHeader.definition.cssClass = this.rowHeader.definition.cssClass + " tabulator-range-row-header";
                if (this.rowHeader.definition.headerSort) console.warn("Using column headerSort with selectableRangeRows option may result in unpredictable behavior");
                if (this.rowHeader.definition.editor) console.warn("Using column editor with selectableRangeRows option may result in unpredictable behavior");
            }
        }
        //warn if invalid frozen column configuration detected
        if (this.table.modules.frozenColumns && this.table.modules.frozenColumns.active) {
            frozenCols = this.table.modules.frozenColumns.getFrozenColumns();
            if (frozenCols.length > 1 || frozenCols.length === 1 && frozenCols[0] !== this.rowHeader) console.warn("Using frozen columns that are not the range header in combination with the selectRange option may result in unpredictable behavior");
        }
    }
    ///////////////////////////////////
    ///////   Table Functions   ///////
    ///////////////////////////////////
    getRanges() {
        return this.ranges.map((range)=>range.getComponent());
    }
    getRangesData() {
        return this.ranges.map((range)=>range.getData());
    }
    addRangeFromComponent(start, end) {
        start = start ? start._cell : null;
        end = end ? end._cell : null;
        return this.addRange(start, end);
    }
    ///////////////////////////////////
    /////// Component Functions ///////
    ///////////////////////////////////
    cellGetRanges(cell) {
        var ranges = [];
        if (cell.column === this.rowHeader) ranges = this.ranges.filter((range)=>range.occupiesRow(cell.row));
        else ranges = this.ranges.filter((range)=>range.occupies(cell));
        return ranges.map((range)=>range.getComponent());
    }
    rowGetRanges(row) {
        var ranges = this.ranges.filter((range)=>range.occupiesRow(row));
        return ranges.map((range)=>range.getComponent());
    }
    colGetRanges(col) {
        var ranges = this.ranges.filter((range)=>range.occupiesColumn(col));
        return ranges.map((range)=>range.getComponent());
    }
    ///////////////////////////////////
    ////////// Event Handlers /////////
    ///////////////////////////////////
    _handleMouseUp(e) {
        this.mousedown = false;
        document.removeEventListener("mouseup", this.mouseUpEvent);
    }
    _handleKeyDown(e) {
        if (!this.blockKeydown && (!this.table.modules.edit || this.table.modules.edit && !this.table.modules.edit.currentCell)) {
            if (e.key === "Enter") {
                // is editing a cell?
                if (this.table.modules.edit && this.table.modules.edit.currentCell) return;
                this.table.modules.edit.editCell(this.getActiveCell());
                e.preventDefault();
            }
            if ((e.key === "Backspace" || e.key === "Delete") && this.options("selectableRangeClearCells")) {
                if (this.activeRange) this.activeRange.clearValues();
            }
        }
    }
    initializeFocus(cell) {
        var range;
        this.restoreFocus();
        try {
            if (document.selection) {
                range = document.body.createTextRange();
                range.moveToElementText(cell.getElement());
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNode(cell.getElement());
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
        } catch (e) {}
    }
    restoreFocus(element) {
        this.table.rowManager.element.focus();
        return true;
    }
    ///////////////////////////////////
    ////// Column Functionality ///////
    ///////////////////////////////////
    handleColumnResized(column) {
        var selected;
        if (this.selecting !== "column" && this.selecting !== "all") return;
        selected = this.ranges.some((range)=>range.occupiesColumn(column));
        if (!selected) return;
        this.ranges.forEach((range)=>{
            var selectedColumns = range.getColumns(true);
            selectedColumns.forEach((selectedColumn)=>{
                if (selectedColumn !== column) selectedColumn.setWidth(column.width);
            });
        });
    }
    handleColumnMoving(_event, column) {
        this.resetRanges().setBounds(column);
        this.overlay.style.visibility = "hidden";
    }
    handleColumnMoved(from, _to, _after) {
        this.activeRange.setBounds(from);
        this.layoutElement();
    }
    handleColumnMouseDown(event, column) {
        if (event.button === 2 && (this.selecting === "column" || this.selecting === "all") && this.activeRange.occupiesColumn(column)) return;
        //If columns are movable, allow dragging columns only if they are not
        //selected. Dragging selected columns should move the columns instead.
        if (this.table.options.movableColumns && this.selecting === "column" && this.activeRange.occupiesColumn(column)) return;
        this.mousedown = true;
        document.addEventListener("mouseup", this.mouseUpEvent);
        this.newSelection(event, column);
    }
    handleColumnMouseMove(e, column) {
        if (column === this.rowHeader || !this.mousedown || this.selecting === 'all') return;
        this.activeRange.setBounds(false, column, true);
    }
    ///////////////////////////////////
    //////// Cell Functionality ///////
    ///////////////////////////////////
    renderCell(cell) {
        var el = cell.getElement(), rangeIdx = this.ranges.findIndex((range)=>range.occupies(cell));
        el.classList.toggle("tabulator-range-selected", rangeIdx !== -1);
        el.classList.toggle("tabulator-range-only-cell-selected", this.ranges.length === 1 && this.ranges[0].atTopLeft(cell) && this.ranges[0].atBottomRight(cell));
        el.dataset.range = rangeIdx;
    }
    handleCellMouseDown(event, cell) {
        if (event.button === 2 && (this.activeRange.occupies(cell) || (this.selecting === "row" || this.selecting === "all") && this.activeRange.occupiesRow(cell.row))) return;
        this.mousedown = true;
        document.addEventListener("mouseup", this.mouseUpEvent);
        this.newSelection(event, cell);
    }
    handleCellMouseMove(e, cell) {
        if (!this.mousedown || this.selecting === "all") return;
        this.activeRange.setBounds(false, cell, true);
    }
    handleCellClick(e, cell) {
        this.initializeFocus(cell);
    }
    handleEditingCell(cell) {
        if (this.activeRange) this.activeRange.setBounds(cell);
    }
    finishEditingCell() {
        this.blockKeydown = true;
        this.table.rowManager.element.focus();
        setTimeout(()=>{
            this.blockKeydown = false;
        }, 10);
    }
    ///////////////////////////////////
    ///////     Navigation      ///////
    ///////////////////////////////////
    keyNavigate(dir, e) {
        this.navigate(false, false, dir);
        e.preventDefault();
    }
    keyNavigateRange(e, dir, jump, expand) {
        this.navigate(jump, expand, dir);
        e.preventDefault();
    }
    navigate(jump, expand, dir) {
        var moved = false, range, rangeEdge, prevRect, nextRow, nextCol, row, column, rowRect, rowManagerRect, columnRect, columnManagerRect;
        // Don't navigate while editing
        if (this.table.modules.edit && this.table.modules.edit.currentCell) return false;
        // If there are more than 1 range, use the active range and destroy the others
        if (this.ranges.length > 1) this.ranges = this.ranges.filter((range)=>{
            if (range === this.activeRange) {
                range.setEnd(range.start.row, range.start.col);
                return true;
            }
            range.destroy();
            return false;
        });
        range = this.activeRange;
        prevRect = {
            top: range.top,
            bottom: range.bottom,
            left: range.left,
            right: range.right
        };
        rangeEdge = expand ? range.end : range.start;
        nextRow = rangeEdge.row;
        nextCol = rangeEdge.col;
        if (jump) switch(dir){
            case "left":
                nextCol = this.findJumpCellLeft(range.start.row, rangeEdge.col);
                break;
            case "right":
                nextCol = this.findJumpCellRight(range.start.row, rangeEdge.col);
                break;
            case "up":
                nextRow = this.findJumpCellUp(rangeEdge.row, range.start.col);
                break;
            case "down":
                nextRow = this.findJumpCellDown(rangeEdge.row, range.start.col);
                break;
        }
        else {
            if (expand) {
                if (this.selecting === 'row' && (dir === 'left' || dir === 'right') || this.selecting === 'column' && (dir === 'up' || dir === 'down')) return;
            }
            switch(dir){
                case "left":
                    nextCol = Math.max(nextCol - 1, 0);
                    break;
                case "right":
                    nextCol = Math.min(nextCol + 1, this.getTableColumns().length - 1);
                    break;
                case "up":
                    nextRow = Math.max(nextRow - 1, 0);
                    break;
                case "down":
                    nextRow = Math.min(nextRow + 1, this.getTableRows().length - 1);
                    break;
            }
        }
        if (this.rowHeader && nextCol === 0) nextCol = 1;
        if (!expand) range.setStart(nextRow, nextCol);
        range.setEnd(nextRow, nextCol);
        if (!expand) this.selecting = "cell";
        moved = prevRect.top !== range.top || prevRect.bottom !== range.bottom || prevRect.left !== range.left || prevRect.right !== range.right;
        if (moved) {
            row = this.getRowByRangePos(range.end.row);
            column = this.getColumnByRangePos(range.end.col);
            rowRect = row.getElement().getBoundingClientRect();
            columnRect = column.getElement().getBoundingClientRect();
            rowManagerRect = this.table.rowManager.getElement().getBoundingClientRect();
            columnManagerRect = this.table.columnManager.getElement().getBoundingClientRect();
            if (!(rowRect.top >= rowManagerRect.top && rowRect.bottom <= rowManagerRect.bottom)) {
                if (row.getElement().parentNode && column.getElement().parentNode) // Use faster autoScroll when the elements are on the DOM
                this.autoScroll(range, row.getElement(), column.getElement());
                else row.getComponent().scrollTo(undefined, false);
            }
            if (!(columnRect.left >= columnManagerRect.left + this.getRowHeaderWidth() && columnRect.right <= columnManagerRect.right)) {
                if (row.getElement().parentNode && column.getElement().parentNode) // Use faster autoScroll when the elements are on the DOM
                this.autoScroll(range, row.getElement(), column.getElement());
                else column.getComponent().scrollTo(undefined, false);
            }
            this.layoutElement();
            return true;
        }
    }
    rangeRemoved(removed) {
        this.ranges = this.ranges.filter((range)=>range !== removed);
        if (this.activeRange === removed) {
            if (this.ranges.length) this.activeRange = this.ranges[this.ranges.length - 1];
            else this.addRange();
        }
        this.layoutElement();
    }
    findJumpRow(column, rows, reverse, emptyStart, emptySide) {
        if (reverse) rows = rows.reverse();
        return this.findJumpItem(emptyStart, emptySide, rows, function(row) {
            return row.getData()[column.getField()];
        });
    }
    findJumpCol(row, columns, reverse, emptyStart, emptySide) {
        if (reverse) columns = columns.reverse();
        return this.findJumpItem(emptyStart, emptySide, columns, function(column) {
            return row.getData()[column.getField()];
        });
    }
    findJumpItem(emptyStart, emptySide, items, valueResolver) {
        var nextItem;
        for (let currentItem of items){
            let currentValue = valueResolver(currentItem);
            if (emptyStart) {
                nextItem = currentItem;
                if (currentValue) break;
            } else if (emptySide) {
                nextItem = currentItem;
                if (currentValue) break;
            } else {
                if (currentValue) nextItem = currentItem;
                else break;
            }
        }
        return nextItem;
    }
    findJumpCellLeft(rowPos, colPos) {
        var row = this.getRowByRangePos(rowPos), columns = this.getTableColumns(), isStartingCellEmpty = this.isEmpty(row.getData()[columns[colPos].getField()]), isLeftOfStartingCellEmpty = columns[colPos - 1] ? this.isEmpty(row.getData()[columns[colPos - 1].getField()]) : false, targetCols = this.rowHeader ? columns.slice(1, colPos) : columns.slice(0, colPos), jumpCol = this.findJumpCol(row, targetCols, true, isStartingCellEmpty, isLeftOfStartingCellEmpty);
        if (jumpCol) return jumpCol.getPosition() - 1;
        return colPos;
    }
    findJumpCellRight(rowPos, colPos) {
        var row = this.getRowByRangePos(rowPos), columns = this.getTableColumns(), isStartingCellEmpty = this.isEmpty(row.getData()[columns[colPos].getField()]), isRightOfStartingCellEmpty = columns[colPos + 1] ? this.isEmpty(row.getData()[columns[colPos + 1].getField()]) : false, jumpCol = this.findJumpCol(row, columns.slice(colPos + 1, columns.length), false, isStartingCellEmpty, isRightOfStartingCellEmpty);
        if (jumpCol) return jumpCol.getPosition() - 1;
        return colPos;
    }
    findJumpCellUp(rowPos, colPos) {
        var column = this.getColumnByRangePos(colPos), rows = this.getTableRows(), isStartingCellEmpty = this.isEmpty(rows[rowPos].getData()[column.getField()]), isTopOfStartingCellEmpty = rows[rowPos - 1] ? this.isEmpty(rows[rowPos - 1].getData()[column.getField()]) : false, jumpRow = this.findJumpRow(column, rows.slice(0, rowPos), true, isStartingCellEmpty, isTopOfStartingCellEmpty);
        if (jumpRow) return jumpRow.position - 1;
        return rowPos;
    }
    findJumpCellDown(rowPos, colPos) {
        var column = this.getColumnByRangePos(colPos), rows = this.getTableRows(), isStartingCellEmpty = this.isEmpty(rows[rowPos].getData()[column.getField()]), isBottomOfStartingCellEmpty = rows[rowPos + 1] ? this.isEmpty(rows[rowPos + 1].getData()[column.getField()]) : false, jumpRow = this.findJumpRow(column, rows.slice(rowPos + 1, rows.length), false, isStartingCellEmpty, isBottomOfStartingCellEmpty);
        if (jumpRow) return jumpRow.position - 1;
        return rowPos;
    }
    ///////////////////////////////////
    ///////      Selection      ///////
    ///////////////////////////////////
    newSelection(event, element) {
        var range;
        if (element.type === "column") {
            if (!this.columnSelection) return;
            if (element === this.rowHeader) {
                range = this.resetRanges();
                this.selecting = "all";
                var topLeftCell, bottomRightCell = this.getCell(-1, -1);
                if (this.rowHeader) topLeftCell = this.getCell(0, 1);
                else topLeftCell = this.getCell(0, 0);
                range.setBounds(topLeftCell, bottomRightCell);
                return;
            } else this.selecting = "column";
        } else if (element.column === this.rowHeader) this.selecting = "row";
        else this.selecting = "cell";
        if (event.shiftKey) this.activeRange.setBounds(false, element);
        else if (event.ctrlKey) this.addRange().setBounds(element);
        else this.resetRanges().setBounds(element);
    }
    autoScroll(range, row, column) {
        var tableHolder = this.table.rowManager.element, rect, view, withinHorizontalView, withinVerticalView;
        if (typeof row === 'undefined') row = this.getRowByRangePos(range.end.row).getElement();
        if (typeof column === 'undefined') column = this.getColumnByRangePos(range.end.col).getElement();
        rect = {
            left: column.offsetLeft,
            right: column.offsetLeft + column.offsetWidth,
            top: row.offsetTop,
            bottom: row.offsetTop + row.offsetHeight
        };
        view = {
            left: tableHolder.scrollLeft + this.getRowHeaderWidth(),
            right: Math.ceil(tableHolder.scrollLeft + tableHolder.clientWidth),
            top: tableHolder.scrollTop,
            bottom: tableHolder.scrollTop + tableHolder.offsetHeight - this.table.rowManager.scrollbarWidth
        };
        withinHorizontalView = view.left < rect.left && rect.left < view.right && view.left < rect.right && rect.right < view.right;
        withinVerticalView = view.top < rect.top && rect.top < view.bottom && view.top < rect.bottom && rect.bottom < view.bottom;
        if (!withinHorizontalView) {
            if (rect.left < view.left) tableHolder.scrollLeft = rect.left - this.getRowHeaderWidth();
            else if (rect.right > view.right) tableHolder.scrollLeft = Math.min(rect.right - tableHolder.clientWidth, rect.left - this.getRowHeaderWidth());
        }
        if (!withinVerticalView) {
            if (rect.top < view.top) tableHolder.scrollTop = rect.top;
            else if (rect.bottom > view.bottom) tableHolder.scrollTop = rect.bottom - tableHolder.clientHeight;
        }
    }
    ///////////////////////////////////
    ///////       Layout        ///////
    ///////////////////////////////////
    layoutChange() {
        this.overlay.style.visibility = "hidden";
        clearTimeout(this.layoutChangeTimeout);
        this.layoutChangeTimeout = setTimeout(this.layoutRanges.bind(this), 200);
    }
    redraw(force) {
        if (force) {
            this.selecting = 'cell';
            this.resetRanges();
            this.layoutElement();
        }
    }
    layoutElement(visibleRows) {
        var rows;
        if (visibleRows) rows = this.table.rowManager.getVisibleRows(true);
        else rows = this.table.rowManager.getRows();
        rows.forEach((row)=>{
            if (row.type === "row") {
                this.layoutRow(row);
                row.cells.forEach((cell)=>this.renderCell(cell));
            }
        });
        this.getTableColumns().forEach((column)=>{
            this.layoutColumn(column);
        });
        this.layoutRanges();
    }
    layoutRow(row) {
        var el = row.getElement(), selected = false, occupied = this.ranges.some((range)=>range.occupiesRow(row));
        if (this.selecting === "row") selected = occupied;
        else if (this.selecting === "all") selected = true;
        el.classList.toggle("tabulator-range-selected", selected);
        el.classList.toggle("tabulator-range-highlight", occupied);
    }
    layoutColumn(column) {
        var el = column.getElement(), selected = false, occupied = this.ranges.some((range)=>range.occupiesColumn(column));
        if (this.selecting === "column") selected = occupied;
        else if (this.selecting === "all") selected = true;
        el.classList.toggle("tabulator-range-selected", selected);
        el.classList.toggle("tabulator-range-highlight", occupied);
    }
    layoutRanges() {
        var activeCell, activeCellEl, activeRowEl;
        if (!this.table.initialized) return;
        activeCell = this.getActiveCell();
        if (!activeCell) return;
        activeCellEl = activeCell.getElement();
        activeRowEl = activeCell.row.getElement();
        if (this.table.rtl) this.activeRangeCellElement.style.right = activeRowEl.offsetWidth - activeCellEl.offsetLeft - activeCellEl.offsetWidth + "px";
        else this.activeRangeCellElement.style.left = activeRowEl.offsetLeft + activeCellEl.offsetLeft + "px";
        this.activeRangeCellElement.style.top = activeRowEl.offsetTop + "px";
        this.activeRangeCellElement.style.width = activeCellEl.offsetWidth + "px";
        this.activeRangeCellElement.style.height = activeRowEl.offsetHeight + "px";
        this.ranges.forEach((range)=>range.layout());
        this.overlay.style.visibility = "visible";
    }
    ///////////////////////////////////
    ///////  Helper Functions   ///////
    ///////////////////////////////////	
    getCell(rowIdx, colIdx) {
        var row;
        if (colIdx < 0) {
            colIdx = this.getTableColumns().length + colIdx;
            if (colIdx < 0) return null;
        }
        if (rowIdx < 0) rowIdx = this.getTableRows().length + rowIdx;
        row = this.table.rowManager.getRowFromPosition(rowIdx + 1);
        return row ? row.getCells(false, true).filter((cell)=>cell.column.visible)[colIdx] : null;
    }
    getActiveCell() {
        return this.getCell(this.activeRange.start.row, this.activeRange.start.col);
    }
    getRowByRangePos(pos) {
        return this.getTableRows()[pos];
    }
    getColumnByRangePos(pos) {
        return this.getTableColumns()[pos];
    }
    getTableRows() {
        return this.table.rowManager.getDisplayRows().filter((row)=>row.type === "row");
    }
    getTableColumns() {
        return this.table.columnManager.getVisibleColumnsByIndex();
    }
    addRange(start, end) {
        var range;
        if (this.maxRanges !== true && this.ranges.length >= this.maxRanges) this.ranges.shift().destroy();
        range = new $517dee46856d349e$var$Range(this.table, this, start, end);
        this.activeRange = range;
        this.ranges.push(range);
        this.rangeContainer.appendChild(range.element);
        return range;
    }
    resetRanges() {
        var range, cell, visibleCells;
        this.ranges.forEach((range)=>range.destroy());
        this.ranges = [];
        range = this.addRange();
        if (this.table.rowManager.activeRows.length) {
            visibleCells = this.table.rowManager.activeRows[0].cells.filter((cell)=>cell.column.visible);
            cell = visibleCells[this.rowHeader ? 1 : 0];
            if (cell) {
                range.setBounds(cell);
                if (this.options("selectableRangeAutoFocus")) this.initializeFocus(cell);
            }
        }
        return range;
    }
    tableDestroyed() {
        document.removeEventListener("mouseup", this.mouseUpEvent);
        this.table.rowManager.element.removeEventListener("keydown", this.keyDownEvent);
    }
    selectedRows(component) {
        return component ? this.activeRange.getRows().map((row)=>row.getComponent()) : this.activeRange.getRows();
    }
    selectedColumns(component) {
        return component ? this.activeRange.getColumns().map((col)=>col.getComponent()) : this.activeRange.getColumns();
    }
    getRowHeaderWidth() {
        if (!this.rowHeader) return 0;
        return this.rowHeader.getElement().offsetWidth;
    }
    isEmpty(value) {
        return value === null || value === undefined || value === "";
    }
}
//sort numbers
function $517dee46856d349e$var$number(a, b, aRow, bRow, column, dir, params) {
    var alignEmptyValues = params.alignEmptyValues;
    var decimal = params.decimalSeparator;
    var thousand = params.thousandSeparator;
    var emptyAlign = 0;
    a = String(a);
    b = String(b);
    if (thousand) {
        a = a.split(thousand).join("");
        b = b.split(thousand).join("");
    }
    if (decimal) {
        a = a.split(decimal).join(".");
        b = b.split(decimal).join(".");
    }
    a = parseFloat(a);
    b = parseFloat(b);
    //handle non numeric values
    if (isNaN(a)) emptyAlign = isNaN(b) ? 0 : -1;
    else if (isNaN(b)) emptyAlign = 1;
    else //compare valid values
    return a - b;
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
//sort strings
function $517dee46856d349e$var$string(a, b, aRow, bRow, column, dir, params) {
    var alignEmptyValues = params.alignEmptyValues;
    var emptyAlign = 0;
    var locale;
    //handle empty values
    if (!a) emptyAlign = !b ? 0 : -1;
    else if (!b) emptyAlign = 1;
    else {
        //compare valid values
        switch(typeof params.locale){
            case "boolean":
                if (params.locale) locale = this.langLocale();
                break;
            case "string":
                locale = params.locale;
                break;
        }
        return String(a).toLowerCase().localeCompare(String(b).toLowerCase(), locale);
    }
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
//sort datetime
function $517dee46856d349e$var$datetime(a, b, aRow, bRow, column, dir, params) {
    var DT = this.table.dependencyRegistry.lookup([
        "luxon",
        "DateTime"
    ], "DateTime");
    var format = params.format || "dd/MM/yyyy HH:mm:ss", alignEmptyValues = params.alignEmptyValues, emptyAlign = 0;
    if (typeof DT != "undefined") {
        if (!DT.isDateTime(a)) {
            if (format === "iso") a = DT.fromISO(String(a));
            else a = DT.fromFormat(String(a), format);
        }
        if (!DT.isDateTime(b)) {
            if (format === "iso") b = DT.fromISO(String(b));
            else b = DT.fromFormat(String(b), format);
        }
        if (!a.isValid) emptyAlign = !b.isValid ? 0 : -1;
        else if (!b.isValid) emptyAlign = 1;
        else //compare valid values
        return a - b;
        //fix empty values in position
        if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
        return emptyAlign;
    } else console.error("Sort Error - 'datetime' sorter is dependant on luxon.js");
}
//sort date
function $517dee46856d349e$var$date(a, b, aRow, bRow, column, dir, params) {
    if (!params.format) params.format = "dd/MM/yyyy";
    return $517dee46856d349e$var$datetime.call(this, a, b, aRow, bRow, column, dir, params);
}
//sort times
function $517dee46856d349e$var$time(a, b, aRow, bRow, column, dir, params) {
    if (!params.format) params.format = "HH:mm";
    return $517dee46856d349e$var$datetime.call(this, a, b, aRow, bRow, column, dir, params);
}
//sort booleans
function $517dee46856d349e$var$boolean(a, b, aRow, bRow, column, dir, params) {
    var el1 = a === true || a === "true" || a === "True" || a === 1 ? 1 : 0;
    var el2 = b === true || b === "true" || b === "True" || b === 1 ? 1 : 0;
    return el1 - el2;
}
//sort if element contains any data
function $517dee46856d349e$var$array(a, b, aRow, bRow, column, dir, params) {
    var type = params.type || "length", alignEmptyValues = params.alignEmptyValues, emptyAlign = 0, table = this.table, valueMap;
    if (params.valueMap) {
        if (typeof params.valueMap === "string") valueMap = function(value) {
            return value.map((item)=>{
                return $517dee46856d349e$var$Helpers.retrieveNestedData(table.options.nestedFieldSeparator, params.valueMap, item);
            });
        };
        else valueMap = params.valueMap;
    }
    function calc(value) {
        var result;
        if (valueMap) value = valueMap(value);
        switch(type){
            case "length":
                result = value.length;
                break;
            case "sum":
                result = value.reduce(function(c, d) {
                    return c + d;
                });
                break;
            case "max":
                result = Math.max.apply(null, value);
                break;
            case "min":
                result = Math.min.apply(null, value);
                break;
            case "avg":
                result = value.reduce(function(c, d) {
                    return c + d;
                }) / value.length;
                break;
            case "string":
                result = value.join("");
                break;
        }
        return result;
    }
    //handle non array values
    if (!Array.isArray(a)) emptyAlign = !Array.isArray(b) ? 0 : -1;
    else if (!Array.isArray(b)) emptyAlign = 1;
    else {
        if (type === "string") return String(calc(a)).toLowerCase().localeCompare(String(calc(b)).toLowerCase());
        else return calc(b) - calc(a);
    }
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
//sort if element contains any data
function $517dee46856d349e$var$exists(a, b, aRow, bRow, column, dir, params) {
    var el1 = typeof a == "undefined" ? 0 : 1;
    var el2 = typeof b == "undefined" ? 0 : 1;
    return el1 - el2;
}
//sort alpha numeric strings
function $517dee46856d349e$var$alphanum(as, bs, aRow, bRow, column, dir, params) {
    var a, b, a1, b1, i = 0, L, rx = /(\d+)|(\D+)/g, rd = /\d/;
    var alignEmptyValues = params.alignEmptyValues;
    var emptyAlign = 0;
    //handle empty values
    if (!as && as !== 0) emptyAlign = !bs && bs !== 0 ? 0 : -1;
    else if (!bs && bs !== 0) emptyAlign = 1;
    else {
        if (isFinite(as) && isFinite(bs)) return as - bs;
        a = String(as).toLowerCase();
        b = String(bs).toLowerCase();
        if (a === b) return 0;
        if (!(rd.test(a) && rd.test(b))) return a > b ? 1 : -1;
        a = a.match(rx);
        b = b.match(rx);
        L = a.length > b.length ? b.length : a.length;
        while(i < L){
            a1 = a[i];
            b1 = b[i++];
            if (a1 !== b1) {
                if (isFinite(a1) && isFinite(b1)) {
                    if (a1.charAt(0) === "0") a1 = "." + a1;
                    if (b1.charAt(0) === "0") b1 = "." + b1;
                    return a1 - b1;
                } else return a1 > b1 ? 1 : -1;
            }
        }
        return a.length > b.length;
    }
    //fix empty values in position
    if (alignEmptyValues === "top" && dir === "desc" || alignEmptyValues === "bottom" && dir === "asc") emptyAlign *= -1;
    return emptyAlign;
}
var $517dee46856d349e$var$defaultSorters = {
    number: $517dee46856d349e$var$number,
    string: $517dee46856d349e$var$string,
    date: $517dee46856d349e$var$date,
    time: $517dee46856d349e$var$time,
    datetime: $517dee46856d349e$var$datetime,
    boolean: $517dee46856d349e$var$boolean,
    array: $517dee46856d349e$var$array,
    exists: $517dee46856d349e$var$exists,
    alphanum: $517dee46856d349e$var$alphanum
};
class $517dee46856d349e$export$5b492eb49d632e3f extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "sort";
    //load defaults
    static sorters = $517dee46856d349e$var$defaultSorters;
    constructor(table){
        super(table);
        this.sortList = []; //holder current sort
        this.changed = false; //has the sort changed since last render
        this.registerTableOption("sortMode", "local"); //local or remote sorting
        this.registerTableOption("initialSort", false); //initial sorting criteria
        this.registerTableOption("columnHeaderSortMulti", true); //multiple or single column sorting
        this.registerTableOption("sortOrderReverse", false); //reverse internal sort ordering
        this.registerTableOption("headerSortElement", "<div class='tabulator-arrow'></div>"); //header sort element
        this.registerTableOption("headerSortClickElement", "header"); //element which triggers sort when clicked
        this.registerColumnOption("sorter");
        this.registerColumnOption("sorterParams");
        this.registerColumnOption("headerSort", true);
        this.registerColumnOption("headerSortStartingDir");
        this.registerColumnOption("headerSortTristate");
    }
    initialize() {
        this.subscribe("column-layout", this.initializeColumn.bind(this));
        this.subscribe("table-built", this.tableBuilt.bind(this));
        this.registerDataHandler(this.sort.bind(this), 20);
        this.registerTableFunction("setSort", this.userSetSort.bind(this));
        this.registerTableFunction("getSorters", this.getSort.bind(this));
        this.registerTableFunction("clearSort", this.clearSort.bind(this));
        if (this.table.options.sortMode === "remote") this.subscribe("data-params", this.remoteSortParams.bind(this));
    }
    tableBuilt() {
        if (this.table.options.initialSort) this.setSort(this.table.options.initialSort);
    }
    remoteSortParams(data, config, silent, params) {
        var sorters = this.getSort();
        sorters.forEach((item)=>{
            delete item.column;
        });
        params.sort = sorters;
        return params;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userSetSort(sortList, dir) {
        this.setSort(sortList, dir);
        // this.table.rowManager.sorterRefresh();
        this.refreshSort();
    }
    clearSort() {
        this.clear();
        // this.table.rowManager.sorterRefresh();
        this.refreshSort();
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    //initialize column header for sorting
    initializeColumn(column) {
        var sorter = false, colEl, arrowEl;
        switch(typeof column.definition.sorter){
            case "string":
                if ($517dee46856d349e$export$5b492eb49d632e3f.sorters[column.definition.sorter]) sorter = $517dee46856d349e$export$5b492eb49d632e3f.sorters[column.definition.sorter];
                else console.warn("Sort Error - No such sorter found: ", column.definition.sorter);
                break;
            case "function":
                sorter = column.definition.sorter;
                break;
        }
        column.modules.sort = {
            sorter: sorter,
            dir: "none",
            params: column.definition.sorterParams || {},
            startingDir: column.definition.headerSortStartingDir || "asc",
            tristate: column.definition.headerSortTristate
        };
        if (column.definition.headerSort !== false) {
            colEl = column.getElement();
            colEl.classList.add("tabulator-sortable");
            arrowEl = document.createElement("div");
            arrowEl.classList.add("tabulator-col-sorter");
            switch(this.table.options.headerSortClickElement){
                case "icon":
                    arrowEl.classList.add("tabulator-col-sorter-element");
                    break;
                case "header":
                    colEl.classList.add("tabulator-col-sorter-element");
                    break;
                default:
                    colEl.classList.add("tabulator-col-sorter-element");
                    break;
            }
            switch(this.table.options.headerSortElement){
                case "function":
                    break;
                case "object":
                    arrowEl.appendChild(this.table.options.headerSortElement);
                    break;
                default:
                    arrowEl.innerHTML = this.table.options.headerSortElement;
            }
            //create sorter arrow
            column.titleHolderElement.appendChild(arrowEl);
            column.modules.sort.element = arrowEl;
            this.setColumnHeaderSortIcon(column, "none");
            if (this.table.options.headerSortClickElement === "icon") arrowEl.addEventListener("mousedown", (e)=>{
                e.stopPropagation();
            });
            //sort on click
            (this.table.options.headerSortClickElement === "icon" ? arrowEl : colEl).addEventListener("click", (e)=>{
                var dir = "", sorters = [], match = false;
                if (column.modules.sort) {
                    if (column.modules.sort.tristate) {
                        if (column.modules.sort.dir == "none") dir = column.modules.sort.startingDir;
                        else if (column.modules.sort.dir == column.modules.sort.startingDir) dir = column.modules.sort.dir == "asc" ? "desc" : "asc";
                        else dir = "none";
                    } else switch(column.modules.sort.dir){
                        case "asc":
                            dir = "desc";
                            break;
                        case "desc":
                            dir = "asc";
                            break;
                        default:
                            dir = column.modules.sort.startingDir;
                    }
                    if (this.table.options.columnHeaderSortMulti && (e.shiftKey || e.ctrlKey)) {
                        sorters = this.getSort();
                        match = sorters.findIndex((sorter)=>{
                            return sorter.field === column.getField();
                        });
                        if (match > -1) {
                            sorters[match].dir = dir;
                            match = sorters.splice(match, 1)[0];
                            if (dir != "none") sorters.push(match);
                        } else if (dir != "none") sorters.push({
                            column: column,
                            dir: dir
                        });
                        //add to existing sort
                        this.setSort(sorters);
                    } else if (dir == "none") this.clear();
                    else //sort by column only
                    this.setSort(column, dir);
                    // this.table.rowManager.sorterRefresh(!this.sortList.length);
                    this.refreshSort();
                }
            });
        }
    }
    refreshSort() {
        if (this.table.options.sortMode === "remote") this.reloadData(null, false, false);
        else this.refreshData(true);
    //TODO - Persist left position of row manager
    // left = this.scrollLeft;
    // this.scrollHorizontal(left);
    }
    //check if the sorters have changed since last use
    hasChanged() {
        var changed = this.changed;
        this.changed = false;
        return changed;
    }
    //return current sorters
    getSort() {
        var self = this, sorters = [];
        self.sortList.forEach(function(item) {
            if (item.column) sorters.push({
                column: item.column.getComponent(),
                field: item.column.getField(),
                dir: item.dir
            });
        });
        return sorters;
    }
    //change sort list and trigger sort
    setSort(sortList, dir) {
        var self = this, newSortList = [];
        if (!Array.isArray(sortList)) sortList = [
            {
                column: sortList,
                dir: dir
            }
        ];
        sortList.forEach(function(item) {
            var column;
            column = self.table.columnManager.findColumn(item.column);
            if (column) {
                item.column = column;
                newSortList.push(item);
                self.changed = true;
            } else console.warn("Sort Warning - Sort field does not exist and is being ignored: ", item.column);
        });
        self.sortList = newSortList;
        this.dispatch("sort-changed");
    }
    //clear sorters
    clear() {
        this.setSort([]);
    }
    //find appropriate sorter for column
    findSorter(column) {
        var row = this.table.rowManager.activeRows[0], sorter = "string", field, value;
        if (row) {
            row = row.getData();
            field = column.getField();
            if (field) {
                value = column.getFieldValue(row);
                switch(typeof value){
                    case "undefined":
                        sorter = "string";
                        break;
                    case "boolean":
                        sorter = "boolean";
                        break;
                    default:
                        if (!isNaN(value) && value !== "") sorter = "number";
                        else if (value.match(/((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+$/i)) sorter = "alphanum";
                        break;
                }
            }
        }
        return $517dee46856d349e$export$5b492eb49d632e3f.sorters[sorter];
    }
    //work through sort list sorting data
    sort(data, sortOnly) {
        var self = this, sortList = this.table.options.sortOrderReverse ? self.sortList.slice().reverse() : self.sortList, sortListActual = [], rowComponents = [];
        if (this.subscribedExternal("dataSorting")) this.dispatchExternal("dataSorting", self.getSort());
        if (!sortOnly) self.clearColumnHeaders();
        if (this.table.options.sortMode !== "remote") {
            //build list of valid sorters and trigger column specific callbacks before sort begins
            sortList.forEach(function(item, i) {
                var sortObj;
                if (item.column) {
                    sortObj = item.column.modules.sort;
                    if (sortObj) {
                        //if no sorter has been defined, take a guess
                        if (!sortObj.sorter) sortObj.sorter = self.findSorter(item.column);
                        item.params = typeof sortObj.params === "function" ? sortObj.params(item.column.getComponent(), item.dir) : sortObj.params;
                        sortListActual.push(item);
                    }
                    if (!sortOnly) self.setColumnHeader(item.column, item.dir);
                }
            });
            //sort data
            if (sortListActual.length) self._sortItems(data, sortListActual);
        } else if (!sortOnly) sortList.forEach(function(item, i) {
            self.setColumnHeader(item.column, item.dir);
        });
        if (this.subscribedExternal("dataSorted")) {
            data.forEach((row)=>{
                rowComponents.push(row.getComponent());
            });
            this.dispatchExternal("dataSorted", self.getSort(), rowComponents);
        }
        return data;
    }
    //clear sort arrows on columns
    clearColumnHeaders() {
        this.table.columnManager.getRealColumns().forEach((column)=>{
            if (column.modules.sort) {
                column.modules.sort.dir = "none";
                column.getElement().setAttribute("aria-sort", "none");
                this.setColumnHeaderSortIcon(column, "none");
            }
        });
    }
    //set the column header sort direction
    setColumnHeader(column, dir) {
        column.modules.sort.dir = dir;
        column.getElement().setAttribute("aria-sort", dir === "asc" ? "ascending" : "descending");
        this.setColumnHeaderSortIcon(column, dir);
    }
    setColumnHeaderSortIcon(column, dir) {
        var sortEl = column.modules.sort.element, arrowEl;
        if (column.definition.headerSort && typeof this.table.options.headerSortElement === "function") {
            while(sortEl.firstChild)sortEl.removeChild(sortEl.firstChild);
            arrowEl = this.table.options.headerSortElement.call(this.table, column.getComponent(), dir);
            if (typeof arrowEl === "object") sortEl.appendChild(arrowEl);
            else sortEl.innerHTML = arrowEl;
        }
    }
    //sort each item in sort list
    _sortItems(data, sortList) {
        var sorterCount = sortList.length - 1;
        data.sort((a, b)=>{
            var result;
            for(var i = sorterCount; i >= 0; i--){
                let sortItem = sortList[i];
                result = this._sortRow(a, b, sortItem.column, sortItem.dir, sortItem.params);
                if (result !== 0) break;
            }
            return result;
        });
    }
    //process individual rows for a sort function on active data
    _sortRow(a, b, column, dir, params) {
        var el1Comp, el2Comp;
        //switch elements depending on search direction
        var el1 = dir == "asc" ? a : b;
        var el2 = dir == "asc" ? b : a;
        a = column.getFieldValue(el1.getData());
        b = column.getFieldValue(el2.getData());
        a = typeof a !== "undefined" ? a : "";
        b = typeof b !== "undefined" ? b : "";
        el1Comp = el1.getComponent();
        el2Comp = el2.getComponent();
        return column.modules.sort.sorter.call(this, a, b, el1Comp, el2Comp, column.getComponent(), dir, params);
    }
}
class $517dee46856d349e$var$GridCalculator {
    constructor(columns, rows){
        this.columnCount = columns;
        this.rowCount = rows;
        this.columnString = [];
        this.columns = [];
        this.rows = [];
    }
    genColumns(data) {
        var colCount = Math.max(this.columnCount, Math.max(...data.map((item)=>item.length)));
        this.columnString = [];
        this.columns = [];
        for(let i = 1; i <= colCount; i++){
            this.incrementChar(this.columnString.length - 1);
            this.columns.push(this.columnString.join(""));
        }
        return this.columns;
    }
    genRows(data) {
        var rowCount = Math.max(this.rowCount, data.length);
        this.rows = [];
        for(let i = 1; i <= rowCount; i++)this.rows.push(i);
        return this.rows;
    }
    incrementChar(i) {
        let char = this.columnString[i];
        if (char) {
            if (char !== "Z") this.columnString[i] = String.fromCharCode(this.columnString[i].charCodeAt(0) + 1);
            else {
                this.columnString[i] = "A";
                if (i) this.incrementChar(i - 1);
                else this.columnString.push("A");
            }
        } else this.columnString.push("A");
    }
    setRowCount(count) {
        this.rowCount = count;
    }
    setColumnCount(count) {
        this.columnCount = count;
    }
}
class $517dee46856d349e$export$bcf87d11d46ea94f {
    constructor(sheet){
        this._sheet = sheet;
        return new Proxy(this, {
            get: function(target, name, receiver) {
                if (typeof target[name] !== "undefined") return target[name];
                else return target._sheet.table.componentFunctionBinder.handle("sheet", target._sheet, name);
            }
        });
    }
    getTitle() {
        return this._sheet.title;
    }
    getKey() {
        return this._sheet.key;
    }
    getDefinition() {
        return this._sheet.getDefinition();
    }
    getData() {
        return this._sheet.getData();
    }
    setData(data) {
        return this._sheet.setData(data);
    }
    clear() {
        return this._sheet.clear();
    }
    remove() {
        return this._sheet.remove();
    }
    active() {
        return this._sheet.active();
    }
    setTitle(title) {
        return this._sheet.setTitle(title);
    }
    setRows(rows) {
        return this._sheet.setRows(rows);
    }
    setColumns(columns) {
        return this._sheet.setColumns(columns);
    }
}
class $517dee46856d349e$var$Sheet extends $517dee46856d349e$var$CoreFeature {
    constructor(spreadsheetManager, definition){
        super(spreadsheetManager.table);
        this.spreadsheetManager = spreadsheetManager;
        this.definition = definition;
        this.title = this.definition.title || "";
        this.key = this.definition.key || this.definition.title;
        this.rowCount = this.definition.rows;
        this.columnCount = this.definition.columns;
        this.data = this.definition.data || [];
        this.element = null;
        this.isActive = false;
        this.grid = new $517dee46856d349e$var$GridCalculator(this.columnCount, this.rowCount);
        this.defaultColumnDefinition = {
            width: 100,
            headerHozAlign: "center",
            headerSort: false
        };
        this.columnDefinition = Object.assign(this.defaultColumnDefinition, this.options("spreadsheetColumnDefinition"));
        this.columnDefs = [];
        this.rowDefs = [];
        this.columnFields = [];
        this.columns = [];
        this.rows = [];
        this.scrollTop = null;
        this.scrollLeft = null;
        this.initialize();
        this.dispatchExternal("sheetAdded", this.getComponent());
    }
    ///////////////////////////////////
    ///////// Initialization //////////
    ///////////////////////////////////
    initialize() {
        this.initializeElement();
        this.initializeColumns();
        this.initializeRows();
    }
    reinitialize() {
        this.initializeColumns();
        this.initializeRows();
    }
    initializeElement() {
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-spreadsheet-tab");
        this.element.innerText = this.title;
        this.element.addEventListener("click", ()=>{
            this.spreadsheetManager.loadSheet(this);
        });
    }
    initializeColumns() {
        this.grid.setColumnCount(this.columnCount);
        this.columnFields = this.grid.genColumns(this.data);
        this.columnDefs = [];
        this.columnFields.forEach((ref)=>{
            var def = Object.assign({}, this.columnDefinition);
            def.field = ref;
            def.title = ref;
            this.columnDefs.push(def);
        });
    }
    initializeRows() {
        var refs;
        this.grid.setRowCount(this.rowCount);
        refs = this.grid.genRows(this.data);
        this.rowDefs = [];
        refs.forEach((ref, i)=>{
            var def = {
                "_id": ref
            };
            var data = this.data[i];
            if (data) data.forEach((val, j)=>{
                var field = this.columnFields[j];
                if (field) def[field] = val;
            });
            this.rowDefs.push(def);
        });
    }
    unload() {
        this.isActive = false;
        this.scrollTop = this.table.rowManager.scrollTop;
        this.scrollLeft = this.table.rowManager.scrollLeft;
        this.data = this.getData(true);
        this.element.classList.remove("tabulator-spreadsheet-tab-active");
    }
    load() {
        var wasInactive = !this.isActive;
        this.isActive = true;
        this.table.blockRedraw();
        this.table.setData([]);
        this.table.setColumns(this.columnDefs);
        this.table.setData(this.rowDefs);
        this.table.restoreRedraw();
        if (wasInactive && this.scrollTop !== null) {
            this.table.rowManager.element.scrollLeft = this.scrollLeft;
            this.table.rowManager.element.scrollTop = this.scrollTop;
        }
        this.element.classList.add("tabulator-spreadsheet-tab-active");
        this.dispatchExternal("sheetLoaded", this.getComponent());
    }
    ///////////////////////////////////
    //////// Helper Functions /////////
    ///////////////////////////////////
    getComponent() {
        return new $517dee46856d349e$export$bcf87d11d46ea94f(this);
    }
    getDefinition() {
        return {
            title: this.title,
            key: this.key,
            rows: this.rowCount,
            columns: this.columnCount,
            data: this.getData()
        };
    }
    getData(full) {
        var output = [], rowWidths, outputWidth, outputHeight;
        //map data to array format
        this.rowDefs.forEach((rowData)=>{
            var row = [];
            this.columnFields.forEach((field)=>{
                row.push(rowData[field]);
            });
            output.push(row);
        });
        //trim output
        if (!full && !this.options("spreadsheetOutputFull")) {
            //calculate used area of data
            rowWidths = output.map((row)=>row.findLastIndex((val)=>typeof val !== 'undefined') + 1);
            outputWidth = Math.max(...rowWidths);
            outputHeight = rowWidths.findLastIndex((width)=>width > 0) + 1;
            output = output.slice(0, outputHeight);
            output = output.map((row)=>row.slice(0, outputWidth));
        }
        return output;
    }
    setData(data) {
        this.data = data;
        this.reinitialize();
        this.dispatchExternal("sheetUpdated", this.getComponent());
        if (this.isActive) this.load();
    }
    clear() {
        this.setData([]);
    }
    setTitle(title) {
        this.title = title;
        this.element.innerText = title;
        this.dispatchExternal("sheetUpdated", this.getComponent());
    }
    setRows(rows) {
        this.rowCount = rows;
        this.initializeRows();
        this.dispatchExternal("sheetUpdated", this.getComponent());
        if (this.isActive) this.load();
    }
    setColumns(columns) {
        this.columnCount = columns;
        this.reinitialize();
        this.dispatchExternal("sheetUpdated", this.getComponent());
        if (this.isActive) this.load();
    }
    remove() {
        this.spreadsheetManager.removeSheet(this);
    }
    destroy() {
        if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        this.dispatchExternal("sheetRemoved", this.getComponent());
    }
    active() {
        this.spreadsheetManager.loadSheet(this);
    }
}
class $517dee46856d349e$export$bbb96e34680d7364 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "spreadsheet";
    constructor(table){
        super(table);
        this.sheets = [];
        this.element = null;
        this.registerTableOption("spreadsheet", false);
        this.registerTableOption("spreadsheetRows", 50);
        this.registerTableOption("spreadsheetColumns", 50);
        this.registerTableOption("spreadsheetColumnDefinition", {});
        this.registerTableOption("spreadsheetOutputFull", false);
        this.registerTableOption("spreadsheetData", false);
        this.registerTableOption("spreadsheetSheets", false);
        this.registerTableOption("spreadsheetSheetTabs", false);
        this.registerTableOption("spreadsheetSheetTabsElement", false);
        this.registerTableFunction("setSheets", this.setSheets.bind(this));
        this.registerTableFunction("addSheet", this.addSheet.bind(this));
        this.registerTableFunction("getSheets", this.getSheets.bind(this));
        this.registerTableFunction("getSheetDefinitions", this.getSheetDefinitions.bind(this));
        this.registerTableFunction("setSheetData", this.setSheetData.bind(this));
        this.registerTableFunction("getSheet", this.getSheet.bind(this));
        this.registerTableFunction("getSheetData", this.getSheetData.bind(this));
        this.registerTableFunction("clearSheet", this.clearSheet.bind(this));
        this.registerTableFunction("removeSheet", this.removeSheetFunc.bind(this));
        this.registerTableFunction("activeSheet", this.activeSheetFunc.bind(this));
    }
    ///////////////////////////////////
    ////// Module Initialization //////
    ///////////////////////////////////
    initialize() {
        if (this.options("spreadsheet")) {
            this.subscribe("table-initialized", this.tableInitialized.bind(this));
            this.subscribe("data-loaded", this.loadRemoteData.bind(this));
            this.table.options.index = "_id";
            if (this.options("spreadsheetData") && this.options("spreadsheetSheets")) {
                console.warn("You cannot use spreadsheetData and spreadsheetSheets at the same time, ignoring spreadsheetData");
                this.table.options.spreadsheetData = false;
            }
            this.compatibilityCheck();
            if (this.options("spreadsheetSheetTabs")) this.initializeTabset();
        }
    }
    compatibilityCheck() {
        if (this.options("data")) console.warn("Do not use the data option when working with spreadsheets, use either spreadsheetData or spreadsheetSheets to pass data into the table");
        if (this.options("pagination")) console.warn("The spreadsheet module is not compatible with the pagination module");
        if (this.options("groupBy")) console.warn("The spreadsheet module is not compatible with the row grouping module");
        if (this.options("responsiveCollapse")) console.warn("The spreadsheet module is not compatible with the responsive collapse module");
    }
    initializeTabset() {
        this.element = document.createElement("div");
        this.element.classList.add("tabulator-spreadsheet-tabs");
        var altContainer = this.options("spreadsheetSheetTabsElement");
        if (altContainer && !(altContainer instanceof HTMLElement)) {
            altContainer = document.querySelector(altContainer);
            if (!altContainer) console.warn("Unable to find element matching spreadsheetSheetTabsElement selector:", this.options("spreadsheetSheetTabsElement"));
        }
        if (altContainer) altContainer.appendChild(this.element);
        else this.footerAppend(this.element);
    }
    tableInitialized() {
        if (this.sheets.length) this.loadSheet(this.sheets[0]);
        else {
            if (this.options("spreadsheetSheets")) this.loadSheets(this.options("spreadsheetSheets"));
            else if (this.options("spreadsheetData")) this.loadData(this.options("spreadsheetData"));
        }
    }
    ///////////////////////////////////
    /////////// Ajax Parsing //////////
    ///////////////////////////////////
    loadRemoteData(data, data1, data2) {
        console.log("data", data, data1, data2);
        if (Array.isArray(data)) {
            this.table.dataLoader.clearAlert();
            this.dispatchExternal("dataLoaded", data);
            if (!data.length || Array.isArray(data[0])) this.loadData(data);
            else this.loadSheets(data);
        } else console.error("Spreadsheet Loading Error - Unable to process remote data due to invalid data type \nExpecting: array \nReceived: ", typeof data, "\nData:     ", data);
        return false;
    }
    ///////////////////////////////////
    ///////// Sheet Management ////////
    ///////////////////////////////////
    loadData(data) {
        var def = {
            data: data
        };
        this.loadSheet(this.newSheet(def));
    }
    destroySheets() {
        this.sheets.forEach((sheet)=>{
            sheet.destroy();
        });
        this.sheets = [];
        this.activeSheet = null;
    }
    loadSheets(sheets) {
        if (!Array.isArray(sheets)) sheets = [];
        this.destroySheets();
        sheets.forEach((def)=>{
            this.newSheet(def);
        });
        this.loadSheet(this.sheets[0]);
    }
    loadSheet(sheet) {
        if (this.activeSheet !== sheet) {
            if (this.activeSheet) this.activeSheet.unload();
            this.activeSheet = sheet;
            sheet.load();
        }
    }
    newSheet(definition = {}) {
        var sheet;
        if (!definition.rows) definition.rows = this.options("spreadsheetRows");
        if (!definition.columns) definition.columns = this.options("spreadsheetColumns");
        sheet = new $517dee46856d349e$var$Sheet(this, definition);
        this.sheets.push(sheet);
        if (this.element) this.element.appendChild(sheet.element);
        return sheet;
    }
    removeSheet(sheet) {
        var index = this.sheets.indexOf(sheet), prevSheet;
        if (this.sheets.length > 1) {
            if (index > -1) {
                this.sheets.splice(index, 1);
                sheet.destroy();
                if (this.activeSheet === sheet) {
                    prevSheet = this.sheets[index - 1] || this.sheets[0];
                    if (prevSheet) this.loadSheet(prevSheet);
                    else this.activeSheet = null;
                }
            }
        } else console.warn("Unable to remove sheet, at least one sheet must be active");
    }
    lookupSheet(key) {
        if (!key) return this.activeSheet;
        else if (key instanceof $517dee46856d349e$var$Sheet) return key;
        else if (key instanceof $517dee46856d349e$export$bcf87d11d46ea94f) return key._sheet;
        else return this.sheets.find((sheet)=>sheet.key === key) || false;
    }
    ///////////////////////////////////
    //////// Public Functions /////////
    ///////////////////////////////////
    setSheets(sheets) {
        this.loadSheets(sheets);
        return this.getSheets();
    }
    addSheet(sheet) {
        return this.newSheet(sheet).getComponent();
    }
    getSheetDefinitions() {
        return this.sheets.map((sheet)=>sheet.getDefinition());
    }
    getSheets() {
        return this.sheets.map((sheet)=>sheet.getComponent());
    }
    getSheet(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.getComponent() : false;
    }
    setSheetData(key, data) {
        if (key && !data) {
            data = key;
            key = false;
        }
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.setData(data) : false;
    }
    getSheetData(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.getData() : false;
    }
    clearSheet(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? sheet.clear() : false;
    }
    removeSheetFunc(key) {
        var sheet = this.lookupSheet(key);
        if (sheet) this.removeSheet(sheet);
    }
    activeSheetFunc(key) {
        var sheet = this.lookupSheet(key);
        return sheet ? this.loadSheet(sheet) : false;
    }
}
class $517dee46856d349e$export$d0c662c133b8814e extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "tooltip";
    constructor(table){
        super(table);
        this.tooltipSubscriber = null, this.headerSubscriber = null, this.timeout = null;
        this.popupInstance = null;
        // this.registerTableOption("tooltipGenerationMode", undefined);  //deprecated
        this.registerTableOption("tooltipDelay", 300);
        this.registerColumnOption("tooltip");
        this.registerColumnOption("headerTooltip");
    }
    initialize() {
        this.deprecatedOptionsCheck();
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    deprecatedOptionsCheck() {
    // this.deprecationCheckMsg("tooltipGenerationMode", "This option is no longer needed as tooltips are always generated on hover now");
    }
    initializeColumn(column) {
        if (column.definition.headerTooltip && !this.headerSubscriber) {
            this.headerSubscriber = true;
            this.subscribe("column-mousemove", this.mousemoveCheck.bind(this, "headerTooltip"));
            this.subscribe("column-mouseout", this.mouseoutCheck.bind(this, "headerTooltip"));
        }
        if (column.definition.tooltip && !this.tooltipSubscriber) {
            this.tooltipSubscriber = true;
            this.subscribe("cell-mousemove", this.mousemoveCheck.bind(this, "tooltip"));
            this.subscribe("cell-mouseout", this.mouseoutCheck.bind(this, "tooltip"));
        }
    }
    mousemoveCheck(action, e, component) {
        var tooltip = action === "tooltip" ? component.column.definition.tooltip : component.definition.headerTooltip;
        if (tooltip) {
            this.clearPopup();
            this.timeout = setTimeout(this.loadTooltip.bind(this, e, component, tooltip), this.table.options.tooltipDelay);
        }
    }
    mouseoutCheck(action, e, component) {
        if (!this.popupInstance) this.clearPopup();
    }
    clearPopup(action, e, component) {
        clearTimeout(this.timeout);
        this.timeout = null;
        if (this.popupInstance) this.popupInstance.hide();
    }
    loadTooltip(e, component, tooltip) {
        var contentsEl, renderedCallback, coords;
        function onRendered(callback) {
            renderedCallback = callback;
        }
        if (typeof tooltip === "function") tooltip = tooltip(e, component.getComponent(), onRendered);
        if (tooltip instanceof HTMLElement) contentsEl = tooltip;
        else {
            contentsEl = document.createElement("div");
            if (tooltip === true) {
                if (component instanceof $517dee46856d349e$var$Cell) tooltip = component.value;
                else if (component.definition.field) this.langBind("columns|" + component.definition.field, (value)=>{
                    contentsEl.innerHTML = tooltip = value || component.definition.title;
                });
                else tooltip = component.definition.title;
            }
            contentsEl.innerHTML = tooltip;
        }
        if (tooltip || tooltip === 0 || tooltip === false) {
            contentsEl.classList.add("tabulator-tooltip");
            contentsEl.addEventListener("mousemove", (e)=>e.preventDefault());
            this.popupInstance = this.popup(contentsEl);
            if (typeof renderedCallback === "function") this.popupInstance.renderCallback(renderedCallback);
            coords = this.popupInstance.containerEventCoords(e);
            this.popupInstance.show(coords.x + 15, coords.y + 15).hideOnBlur(()=>{
                this.dispatchExternal("TooltipClosed", component.getComponent());
                this.popupInstance = null;
            });
            this.dispatchExternal("TooltipOpened", component.getComponent());
        }
    }
}
var $517dee46856d349e$var$defaultValidators = {
    //is integer
    integer: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        value = Number(value);
        return !isNaN(value) && isFinite(value) && Math.floor(value) === value;
    },
    //is float
    float: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        value = Number(value);
        return !isNaN(value) && isFinite(value) && value % 1 !== 0;
    },
    //must be a number
    numeric: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return !isNaN(value);
    },
    //must be a string
    string: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return isNaN(value);
    },
    //must be alphanumeric
    alphanumeric: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        var reg = new RegExp(/^[a-z0-9]+$/i);
        return reg.test(value);
    },
    //maximum value
    max: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return parseFloat(value) <= parameters;
    },
    //minimum value
    min: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return parseFloat(value) >= parameters;
    },
    //starts with  value
    starts: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).toLowerCase().startsWith(String(parameters).toLowerCase());
    },
    //ends with  value
    ends: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).toLowerCase().endsWith(String(parameters).toLowerCase());
    },
    //minimum string length
    minLength: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).length >= parameters;
    },
    //maximum string length
    maxLength: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        return String(value).length <= parameters;
    },
    //in provided value list
    in: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        if (typeof parameters == "string") parameters = parameters.split("|");
        return parameters.indexOf(value) > -1;
    },
    //must match provided regex
    regex: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        var reg = new RegExp(parameters);
        return reg.test(value);
    },
    //value must be unique in this column
    unique: function(cell, value, parameters) {
        if (value === "" || value === null || typeof value === "undefined") return true;
        var unique = true;
        var cellData = cell.getData();
        var column = cell.getColumn()._getSelf();
        this.table.rowManager.rows.forEach(function(row) {
            var data = row.getData();
            if (data !== cellData) {
                if (value == column.getFieldValue(data)) unique = false;
            }
        });
        return unique;
    },
    //must have a value
    required: function(cell, value, parameters) {
        return value !== "" && value !== null && typeof value !== "undefined";
    }
};
class $517dee46856d349e$export$db48c5a2fa1f03d4 extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "validate";
    //load defaults
    static validators = $517dee46856d349e$var$defaultValidators;
    constructor(table){
        super(table);
        this.invalidCells = [];
        this.registerTableOption("validationMode", "blocking");
        this.registerColumnOption("validator");
        this.registerTableFunction("getInvalidCells", this.getInvalidCells.bind(this));
        this.registerTableFunction("clearCellValidation", this.userClearCellValidation.bind(this));
        this.registerTableFunction("validate", this.userValidate.bind(this));
        this.registerComponentFunction("cell", "isValid", this.cellIsValid.bind(this));
        this.registerComponentFunction("cell", "clearValidation", this.clearValidation.bind(this));
        this.registerComponentFunction("cell", "validate", this.cellValidate.bind(this));
        this.registerComponentFunction("column", "validate", this.columnValidate.bind(this));
        this.registerComponentFunction("row", "validate", this.rowValidate.bind(this));
    }
    initialize() {
        this.subscribe("cell-delete", this.clearValidation.bind(this));
        this.subscribe("column-layout", this.initializeColumnCheck.bind(this));
        this.subscribe("edit-success", this.editValidate.bind(this));
        this.subscribe("edit-editor-clear", this.editorClear.bind(this));
        this.subscribe("edit-edited-clear", this.editedClear.bind(this));
    }
    ///////////////////////////////////
    ///////// Event Handling //////////
    ///////////////////////////////////
    editValidate(cell, value, previousValue) {
        var valid = this.table.options.validationMode !== "manual" ? this.validate(cell.column.modules.validate, cell, value) : true;
        // allow time for editor to make render changes then style cell
        if (valid !== true) setTimeout(()=>{
            cell.getElement().classList.add("tabulator-validation-fail");
            this.dispatchExternal("validationFailed", cell.getComponent(), value, valid);
        });
        return valid;
    }
    editorClear(cell, cancelled) {
        if (cancelled) {
            if (cell.column.modules.validate) this.cellValidate(cell);
        }
        cell.getElement().classList.remove("tabulator-validation-fail");
    }
    editedClear(cell) {
        if (cell.modules.validate) cell.modules.validate.invalid = false;
    }
    ///////////////////////////////////
    ////////// Cell Functions /////////
    ///////////////////////////////////
    cellIsValid(cell) {
        return cell.modules.validate ? cell.modules.validate.invalid || true : true;
    }
    cellValidate(cell) {
        return this.validate(cell.column.modules.validate, cell, cell.getValue());
    }
    ///////////////////////////////////
    ///////// Column Functions ////////
    ///////////////////////////////////
    columnValidate(column) {
        var invalid = [];
        column.cells.forEach((cell)=>{
            if (this.cellValidate(cell) !== true) invalid.push(cell.getComponent());
        });
        return invalid.length ? invalid : true;
    }
    ///////////////////////////////////
    ////////// Row Functions //////////
    ///////////////////////////////////
    rowValidate(row) {
        var invalid = [];
        row.cells.forEach((cell)=>{
            if (this.cellValidate(cell) !== true) invalid.push(cell.getComponent());
        });
        return invalid.length ? invalid : true;
    }
    ///////////////////////////////////
    ///////// Table Functions /////////
    ///////////////////////////////////
    userClearCellValidation(cells) {
        if (!cells) cells = this.getInvalidCells();
        if (!Array.isArray(cells)) cells = [
            cells
        ];
        cells.forEach((cell)=>{
            this.clearValidation(cell._getSelf());
        });
    }
    userValidate(cells) {
        var output = [];
        //clear row data
        this.table.rowManager.rows.forEach((row)=>{
            row = row.getComponent();
            var valid = row.validate();
            if (valid !== true) output = output.concat(valid);
        });
        return output.length ? output : true;
    }
    ///////////////////////////////////
    ///////// Internal Logic //////////
    ///////////////////////////////////
    initializeColumnCheck(column) {
        if (typeof column.definition.validator !== "undefined") this.initializeColumn(column);
    }
    //validate
    initializeColumn(column) {
        var self = this, config = [], validator;
        if (column.definition.validator) {
            if (Array.isArray(column.definition.validator)) column.definition.validator.forEach((item)=>{
                validator = self._extractValidator(item);
                if (validator) config.push(validator);
            });
            else {
                validator = this._extractValidator(column.definition.validator);
                if (validator) config.push(validator);
            }
            column.modules.validate = config.length ? config : false;
        }
    }
    _extractValidator(value) {
        var type, params, pos;
        switch(typeof value){
            case "string":
                pos = value.indexOf(':');
                if (pos > -1) {
                    type = value.substring(0, pos);
                    params = value.substring(pos + 1);
                } else type = value;
                return this._buildValidator(type, params);
            case "function":
                return this._buildValidator(value);
            case "object":
                return this._buildValidator(value.type, value.parameters);
        }
    }
    _buildValidator(type, params) {
        var func = typeof type == "function" ? type : $517dee46856d349e$export$db48c5a2fa1f03d4.validators[type];
        if (!func) {
            console.warn("Validator Setup Error - No matching validator found:", type);
            return false;
        } else return {
            type: typeof type == "function" ? "function" : type,
            func: func,
            params: params
        };
    }
    validate(validators, cell, value) {
        var self = this, failedValidators = [], invalidIndex = this.invalidCells.indexOf(cell);
        if (validators) validators.forEach((item)=>{
            if (!item.func.call(self, cell.getComponent(), value, item.params)) failedValidators.push({
                type: item.type,
                parameters: item.params
            });
        });
        if (!cell.modules.validate) cell.modules.validate = {};
        if (!failedValidators.length) {
            cell.modules.validate.invalid = false;
            cell.getElement().classList.remove("tabulator-validation-fail");
            if (invalidIndex > -1) this.invalidCells.splice(invalidIndex, 1);
        } else {
            cell.modules.validate.invalid = failedValidators;
            if (this.table.options.validationMode !== "manual") cell.getElement().classList.add("tabulator-validation-fail");
            if (invalidIndex == -1) this.invalidCells.push(cell);
        }
        return failedValidators.length ? failedValidators : true;
    }
    getInvalidCells() {
        var output = [];
        this.invalidCells.forEach((cell)=>{
            output.push(cell.getComponent());
        });
        return output;
    }
    clearValidation(cell) {
        var invalidIndex;
        if (cell.modules.validate && cell.modules.validate.invalid) {
            cell.getElement().classList.remove("tabulator-validation-fail");
            cell.modules.validate.invalid = false;
            invalidIndex = this.invalidCells.indexOf(cell);
            if (invalidIndex > -1) this.invalidCells.splice(invalidIndex, 1);
        }
    }
}
var $517dee46856d349e$var$allModules = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AccessorModule: $517dee46856d349e$export$bf9f5472bce61c69,
    AjaxModule: $517dee46856d349e$export$b25c9f93be571d3a,
    ClipboardModule: $517dee46856d349e$export$3a36bd45ca02edda,
    ColumnCalcsModule: $517dee46856d349e$export$840b3bc55b30dec6,
    DataTreeModule: $517dee46856d349e$export$a5a9878f12569c04,
    DownloadModule: $517dee46856d349e$export$6dd96c6d41f32a97,
    EditModule: $517dee46856d349e$export$2394e2d3d2175314,
    ExportModule: $517dee46856d349e$export$4e0f34fd9829977c,
    FilterModule: $517dee46856d349e$export$2e3bebbdf3339a4e,
    FormatModule: $517dee46856d349e$export$5634f967e02d772d,
    FrozenColumnsModule: $517dee46856d349e$export$c00c4e95a253fbf9,
    FrozenRowsModule: $517dee46856d349e$export$6e51ce5331c5fffa,
    GroupRowsModule: $517dee46856d349e$export$41e6b6ec902cbe0a,
    HistoryModule: $517dee46856d349e$export$173658fc60691186,
    HtmlTableImportModule: $517dee46856d349e$export$b0b448c470bac827,
    ImportModule: $517dee46856d349e$export$bceca318c211ca25,
    InteractionModule: $517dee46856d349e$export$69fa60f71dd0541a,
    KeybindingsModule: $517dee46856d349e$export$a0ff4f1c226a7cef,
    MenuModule: $517dee46856d349e$export$f1ab43fc4c3c5ce0,
    MoveColumnsModule: $517dee46856d349e$export$9ab7496e9b38c128,
    MoveRowsModule: $517dee46856d349e$export$7815d73158f0bb2d,
    MutatorModule: $517dee46856d349e$export$d0f669567356cabd,
    PageModule: $517dee46856d349e$export$7eba6c45a494ceac,
    PersistenceModule: $517dee46856d349e$export$6ce0215a06bec981,
    PopupModule: $517dee46856d349e$export$5a0eb14a9c37d425,
    PrintModule: $517dee46856d349e$export$94fbe99c03f5a051,
    ReactiveDataModule: $517dee46856d349e$export$1806fba60a0e8399,
    ResizeColumnsModule: $517dee46856d349e$export$3a1ca422b395df54,
    ResizeRowsModule: $517dee46856d349e$export$5651a6c35bd86023,
    ResizeTableModule: $517dee46856d349e$export$977e646a85a63aba,
    ResponsiveLayoutModule: $517dee46856d349e$export$cc8706005768c818,
    SelectRangeModule: $517dee46856d349e$export$cd9e469b2c8c819c,
    SelectRowModule: $517dee46856d349e$export$2e4fadc5338e55f5,
    SortModule: $517dee46856d349e$export$5b492eb49d632e3f,
    SpreadsheetModule: $517dee46856d349e$export$bbb96e34680d7364,
    TooltipModule: $517dee46856d349e$export$d0c662c133b8814e,
    ValidateModule: $517dee46856d349e$export$db48c5a2fa1f03d4
});
var $517dee46856d349e$var$defaultOptions = {
    debugEventsExternal: false,
    debugEventsInternal: false,
    debugInvalidOptions: true,
    debugInvalidComponentFuncs: true,
    debugInitialization: true,
    debugDeprecation: true,
    height: false,
    minHeight: false,
    maxHeight: false,
    columnHeaderVertAlign: "top",
    popupContainer: false,
    columns: [],
    columnDefaults: {},
    rowHeader: false,
    data: false,
    autoColumns: false,
    autoColumnsDefinitions: false,
    nestedFieldSeparator: ".",
    footerElement: false,
    index: "id",
    textDirection: "auto",
    addRowPos: "bottom",
    headerVisible: true,
    renderVertical: "virtual",
    renderHorizontal: "basic",
    renderVerticalBuffer: 0,
    scrollToRowPosition: "top",
    scrollToRowIfVisible: true,
    scrollToColumnPosition: "left",
    scrollToColumnIfVisible: true,
    rowFormatter: false,
    rowFormatterPrint: null,
    rowFormatterClipboard: null,
    rowFormatterHtmlOutput: null,
    rowHeight: null,
    placeholder: false,
    dataLoader: true,
    dataLoaderLoading: false,
    dataLoaderError: false,
    dataLoaderErrorTimeout: 3000,
    dataSendParams: {},
    dataReceiveParams: {},
    dependencies: {}
};
class $517dee46856d349e$var$OptionsList {
    constructor(table, msgType, defaults = {}){
        this.table = table;
        this.msgType = msgType;
        this.registeredDefaults = Object.assign({}, defaults);
    }
    register(option, value) {
        this.registeredDefaults[option] = value;
    }
    generate(defaultOptions, userOptions = {}) {
        var output = Object.assign({}, this.registeredDefaults), warn = this.table.options.debugInvalidOptions || userOptions.debugInvalidOptions === true;
        Object.assign(output, defaultOptions);
        for(let key in userOptions)if (!output.hasOwnProperty(key)) {
            if (warn) console.warn("Invalid " + this.msgType + " option:", key);
            output[key] = userOptions.key;
        }
        for(let key in output)if (key in userOptions) output[key] = userOptions[key];
        else {
            if (Array.isArray(output[key])) output[key] = Object.assign([], output[key]);
            else if (typeof output[key] === "object" && output[key] !== null) output[key] = Object.assign({}, output[key]);
            else if (typeof output[key] === "undefined") delete output[key];
        }
        return output;
    }
}
class $517dee46856d349e$export$88530751e3977073 extends $517dee46856d349e$var$CoreFeature {
    constructor(table){
        super(table);
        this.elementVertical = table.rowManager.element;
        this.elementHorizontal = table.columnManager.element;
        this.tableElement = table.rowManager.tableElement;
        this.verticalFillMode = "fit"; // used by row manager to determine how to size the render area ("fit" - fits container to the contents, "fill" - fills the container without resizing it)
    }
    ///////////////////////////////////
    /////// Internal Bindings /////////
    ///////////////////////////////////
    initialize() {
    //initialize core functionality
    }
    clearRows() {
    //clear down existing rows layout
    }
    clearColumns() {
    //clear down existing columns layout
    }
    reinitializeColumnWidths(columns) {
    //resize columns to fit data
    }
    renderRows() {
    //render rows from a clean slate
    }
    renderColumns() {
    //render columns from a clean slate
    }
    rerenderRows(callback) {
        // rerender rows and keep position
        if (callback) callback();
    }
    rerenderColumns(update, blockRedraw) {
    //rerender columns
    }
    renderRowCells(row) {
    //render the cells in a row
    }
    rerenderRowCells(row, force) {
    //rerender the cells in a row
    }
    scrollColumns(left, dir) {
    //handle horizontal scrolling
    }
    scrollRows(top, dir) {
    //handle vertical scrolling
    }
    resize() {
    //container has resized, carry out any needed recalculations (DO NOT RERENDER IN THIS FUNCTION)
    }
    scrollToRow(row) {
    //scroll to a specific row
    }
    scrollToRowNearestTop(row) {
    //determine weather the row is nearest the top or bottom of the table, return true for top or false for bottom
    }
    visibleRows(includingBuffer) {
        //return the visible rows
        return [];
    }
    ///////////////////////////////////
    //////// Helper Functions /////////
    ///////////////////////////////////
    rows() {
        return this.table.rowManager.getDisplayRows();
    }
    styleRow(row, index) {
        var rowEl = row.getElement();
        if (index % 2) {
            rowEl.classList.add("tabulator-row-even");
            rowEl.classList.remove("tabulator-row-odd");
        } else {
            rowEl.classList.add("tabulator-row-odd");
            rowEl.classList.remove("tabulator-row-even");
        }
    }
    ///////////////////////////////////
    /////// External Triggers /////////
    /////// (DO NOT OVERRIDE) /////////
    ///////////////////////////////////
    clear() {
        //clear down existing layout
        this.clearRows();
        this.clearColumns();
    }
    render() {
        //render from a clean slate
        this.renderRows();
        this.renderColumns();
    }
    rerender(callback) {
        // rerender and keep position
        this.rerenderRows();
        this.rerenderColumns();
    }
    scrollToRowPosition(row, position, ifVisible) {
        var rowIndex = this.rows().indexOf(row), rowEl = row.getElement(), offset = 0;
        return new Promise((resolve, reject)=>{
            if (rowIndex > -1) {
                if (typeof ifVisible === "undefined") ifVisible = this.table.options.scrollToRowIfVisible;
                //check row visibility
                if (!ifVisible) {
                    if ($517dee46856d349e$var$Helpers.elVisible(rowEl)) {
                        offset = $517dee46856d349e$var$Helpers.elOffset(rowEl).top - $517dee46856d349e$var$Helpers.elOffset(this.elementVertical).top;
                        if (offset > 0 && offset < this.elementVertical.clientHeight - rowEl.offsetHeight) {
                            resolve();
                            return false;
                        }
                    }
                }
                if (typeof position === "undefined") position = this.table.options.scrollToRowPosition;
                if (position === "nearest") position = this.scrollToRowNearestTop(row) ? "top" : "bottom";
                //scroll to row
                this.scrollToRow(row);
                //align to correct position
                switch(position){
                    case "middle":
                    case "center":
                        if (this.elementVertical.scrollHeight - this.elementVertical.scrollTop == this.elementVertical.clientHeight) this.elementVertical.scrollTop = this.elementVertical.scrollTop + (rowEl.offsetTop - this.elementVertical.scrollTop) - (this.elementVertical.scrollHeight - rowEl.offsetTop) / 2;
                        else this.elementVertical.scrollTop = this.elementVertical.scrollTop - this.elementVertical.clientHeight / 2;
                        break;
                    case "bottom":
                        if (this.elementVertical.scrollHeight - this.elementVertical.scrollTop == this.elementVertical.clientHeight) this.elementVertical.scrollTop = this.elementVertical.scrollTop - (this.elementVertical.scrollHeight - rowEl.offsetTop) + rowEl.offsetHeight;
                        else this.elementVertical.scrollTop = this.elementVertical.scrollTop - this.elementVertical.clientHeight + rowEl.offsetHeight;
                        break;
                    case "top":
                        this.elementVertical.scrollTop = rowEl.offsetTop;
                        break;
                }
                resolve();
            } else {
                console.warn("Scroll Error - Row not visible");
                reject("Scroll Error - Row not visible");
            }
        });
    }
}
class $517dee46856d349e$var$BasicHorizontal extends $517dee46856d349e$export$88530751e3977073 {
    constructor(table){
        super(table);
    }
    renderRowCells(row, inFragment) {
        const rowFrag = document.createDocumentFragment();
        row.cells.forEach((cell)=>{
            rowFrag.appendChild(cell.getElement());
        });
        row.element.appendChild(rowFrag);
        if (!inFragment) row.cells.forEach((cell)=>{
            cell.cellRendered();
        });
    }
    reinitializeColumnWidths(columns) {
        columns.forEach(function(column) {
            column.reinitializeWidth();
        });
    }
}
class $517dee46856d349e$var$VirtualDomHorizontal extends $517dee46856d349e$export$88530751e3977073 {
    constructor(table){
        super(table);
        this.leftCol = 0;
        this.rightCol = 0;
        this.scrollLeft = 0;
        this.vDomScrollPosLeft = 0;
        this.vDomScrollPosRight = 0;
        this.vDomPadLeft = 0;
        this.vDomPadRight = 0;
        this.fitDataColAvg = 0;
        this.windowBuffer = 200; //pixel margin to make column visible before it is shown on screen
        this.visibleRows = null;
        this.initialized = false;
        this.isFitData = false;
        this.columns = [];
    }
    initialize() {
        this.compatibilityCheck();
        this.layoutCheck();
        this.vertScrollListen();
    }
    compatibilityCheck() {
        if (this.options("layout") == "fitDataTable") console.warn("Horizontal Virtual DOM is not compatible with fitDataTable layout mode");
        if (this.options("responsiveLayout")) console.warn("Horizontal Virtual DOM is not compatible with responsive columns");
        if (this.options("rtl")) console.warn("Horizontal Virtual DOM is not currently compatible with RTL text direction");
    }
    layoutCheck() {
        this.isFitData = this.options("layout").startsWith('fitData');
    }
    vertScrollListen() {
        this.subscribe("scroll-vertical", this.clearVisRowCache.bind(this));
        this.subscribe("data-refreshed", this.clearVisRowCache.bind(this));
    }
    clearVisRowCache() {
        this.visibleRows = null;
    }
    //////////////////////////////////////
    ///////// Public Functions ///////////
    //////////////////////////////////////
    renderColumns(row, force) {
        this.dataChange();
    }
    scrollColumns(left, dir) {
        if (this.scrollLeft != left) {
            this.scrollLeft = left;
            this.scroll(left - (this.vDomScrollPosLeft + this.windowBuffer));
        }
    }
    calcWindowBuffer() {
        var buffer = this.elementVertical.clientWidth;
        this.table.columnManager.columnsByIndex.forEach((column)=>{
            if (column.visible) {
                var width = column.getWidth();
                if (width > buffer) buffer = width;
            }
        });
        this.windowBuffer = buffer * 2;
    }
    rerenderColumns(update, blockRedraw) {
        var old = {
            cols: this.columns,
            leftCol: this.leftCol,
            rightCol: this.rightCol
        }, colPos = 0;
        if (update && !this.initialized) return;
        this.clear();
        this.calcWindowBuffer();
        this.scrollLeft = this.elementVertical.scrollLeft;
        this.vDomScrollPosLeft = this.scrollLeft - this.windowBuffer;
        this.vDomScrollPosRight = this.scrollLeft + this.elementVertical.clientWidth + this.windowBuffer;
        this.table.columnManager.columnsByIndex.forEach((column)=>{
            var config = {}, width;
            if (column.visible) {
                if (!column.modules.frozen) {
                    width = column.getWidth();
                    config.leftPos = colPos;
                    config.rightPos = colPos + width;
                    config.width = width;
                    if (this.isFitData) config.fitDataCheck = column.modules.vdomHoz ? column.modules.vdomHoz.fitDataCheck : true;
                    if (colPos + width > this.vDomScrollPosLeft && colPos < this.vDomScrollPosRight) {
                        //column is visible
                        if (this.leftCol == -1) {
                            this.leftCol = this.columns.length;
                            this.vDomPadLeft = colPos;
                        }
                        this.rightCol = this.columns.length;
                    } else // column is hidden
                    if (this.leftCol !== -1) this.vDomPadRight += width;
                    this.columns.push(column);
                    column.modules.vdomHoz = config;
                    colPos += width;
                }
            }
        });
        this.tableElement.style.paddingLeft = this.vDomPadLeft + "px";
        this.tableElement.style.paddingRight = this.vDomPadRight + "px";
        this.initialized = true;
        if (!blockRedraw) {
            if (!update || this.reinitChanged(old)) this.reinitializeRows();
        }
        this.elementVertical.scrollLeft = this.scrollLeft;
    }
    renderRowCells(row) {
        if (this.initialized) this.initializeRow(row);
        else {
            const rowFrag = document.createDocumentFragment();
            row.cells.forEach((cell)=>{
                rowFrag.appendChild(cell.getElement());
            });
            row.element.appendChild(rowFrag);
            row.cells.forEach((cell)=>{
                cell.cellRendered();
            });
        }
    }
    rerenderRowCells(row, force) {
        this.reinitializeRow(row, force);
    }
    reinitializeColumnWidths(columns) {
        for(let i = this.leftCol; i <= this.rightCol; i++){
            let col = this.columns[i];
            if (col) col.reinitializeWidth();
        }
    }
    //////////////////////////////////////
    //////// Internal Rendering //////////
    //////////////////////////////////////
    deinitialize() {
        this.initialized = false;
    }
    clear() {
        this.columns = [];
        this.leftCol = -1;
        this.rightCol = 0;
        this.vDomScrollPosLeft = 0;
        this.vDomScrollPosRight = 0;
        this.vDomPadLeft = 0;
        this.vDomPadRight = 0;
    }
    dataChange() {
        var change = false, row, rowEl;
        if (this.isFitData) {
            this.table.columnManager.columnsByIndex.forEach((column)=>{
                if (!column.definition.width && column.visible) change = true;
            });
            if (change && this.table.rowManager.getDisplayRows().length) {
                this.vDomScrollPosRight = this.scrollLeft + this.elementVertical.clientWidth + this.windowBuffer;
                row = this.chain("rows-sample", [
                    1
                ], [], ()=>{
                    return this.table.rowManager.getDisplayRows();
                })[0];
                if (row) {
                    rowEl = row.getElement();
                    row.generateCells();
                    this.tableElement.appendChild(rowEl);
                    for(let colEnd = 0; colEnd < row.cells.length; colEnd++){
                        let cell = row.cells[colEnd];
                        rowEl.appendChild(cell.getElement());
                        cell.column.reinitializeWidth();
                    }
                    rowEl.parentNode.removeChild(rowEl);
                    this.rerenderColumns(false, true);
                }
            }
        } else if (this.options("layout") === "fitColumns") {
            this.layoutRefresh();
            this.rerenderColumns(false, true);
        }
    }
    reinitChanged(old) {
        var match = true;
        if (old.cols.length !== this.columns.length || old.leftCol !== this.leftCol || old.rightCol !== this.rightCol) return true;
        old.cols.forEach((col, i)=>{
            if (col !== this.columns[i]) match = false;
        });
        return !match;
    }
    reinitializeRows() {
        var visibleRows = this.getVisibleRows(), otherRows = this.table.rowManager.getRows().filter((row)=>!visibleRows.includes(row));
        visibleRows.forEach((row)=>{
            this.reinitializeRow(row, true);
        });
        otherRows.forEach((row)=>{
            row.deinitialize();
        });
    }
    getVisibleRows() {
        if (!this.visibleRows) this.visibleRows = this.table.rowManager.getVisibleRows();
        return this.visibleRows;
    }
    scroll(diff) {
        this.vDomScrollPosLeft += diff;
        this.vDomScrollPosRight += diff;
        if (Math.abs(diff) > this.windowBuffer / 2) this.rerenderColumns();
        else if (diff > 0) {
            //scroll right
            this.addColRight();
            this.removeColLeft();
        } else {
            //scroll left
            this.addColLeft();
            this.removeColRight();
        }
    }
    colPositionAdjust(start, end, diff) {
        for(let i = start; i < end; i++){
            let column = this.columns[i];
            column.modules.vdomHoz.leftPos += diff;
            column.modules.vdomHoz.rightPos += diff;
        }
    }
    addColRight() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.rightCol + 1];
            if (column) {
                if (column.modules.vdomHoz.leftPos <= this.vDomScrollPosRight) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            row.getElement().insertBefore(cell.getElement(), row.getCell(this.columns[this.rightCol]).getElement().nextSibling);
                            cell.cellRendered();
                        }
                    });
                    this.fitDataColActualWidthCheck(column);
                    this.rightCol++; // Don't move this below the >= check below
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.rightCol = this.rightCol;
                    });
                    if (this.rightCol >= this.columns.length - 1) this.vDomPadRight = 0;
                    else this.vDomPadRight -= column.getWidth();
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingRight = this.vDomPadRight + "px";
    }
    addColLeft() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.leftCol - 1];
            if (column) {
                if (column.modules.vdomHoz.rightPos >= this.vDomScrollPosLeft) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            row.getElement().insertBefore(cell.getElement(), row.getCell(this.columns[this.leftCol]).getElement());
                            cell.cellRendered();
                        }
                    });
                    this.leftCol--; // don't move this below the <= check below
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.leftCol = this.leftCol;
                    });
                    if (this.leftCol <= 0) this.vDomPadLeft = 0;
                    else this.vDomPadLeft -= column.getWidth();
                    let diff = this.fitDataColActualWidthCheck(column);
                    if (diff) {
                        this.scrollLeft = this.elementVertical.scrollLeft = this.elementVertical.scrollLeft + diff;
                        this.vDomPadRight -= diff;
                    }
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingLeft = this.vDomPadLeft + "px";
    }
    removeColRight() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.rightCol];
            if (column) {
                if (column.modules.vdomHoz.leftPos > this.vDomScrollPosRight) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            try {
                                row.getElement().removeChild(cell.getElement());
                            } catch (ex) {
                                console.warn("Could not removeColRight", ex.message);
                            }
                        }
                    });
                    this.vDomPadRight += column.getWidth();
                    this.rightCol--;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.rightCol = this.rightCol;
                    });
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingRight = this.vDomPadRight + "px";
    }
    removeColLeft() {
        var changes = false, working = true;
        while(working){
            let column = this.columns[this.leftCol];
            if (column) {
                if (column.modules.vdomHoz.rightPos < this.vDomScrollPosLeft) {
                    changes = true;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") {
                            var cell = row.getCell(column);
                            try {
                                row.getElement().removeChild(cell.getElement());
                            } catch (ex) {
                                console.warn("Could not removeColLeft", ex.message);
                            }
                        }
                    });
                    this.vDomPadLeft += column.getWidth();
                    this.leftCol++;
                    this.getVisibleRows().forEach((row)=>{
                        if (row.type !== "group") row.modules.vdomHoz.leftCol = this.leftCol;
                    });
                } else working = false;
            } else working = false;
        }
        if (changes) this.tableElement.style.paddingLeft = this.vDomPadLeft + "px";
    }
    fitDataColActualWidthCheck(column) {
        var newWidth, widthDiff;
        if (column.modules.vdomHoz.fitDataCheck) {
            column.reinitializeWidth();
            newWidth = column.getWidth();
            widthDiff = newWidth - column.modules.vdomHoz.width;
            if (widthDiff) {
                column.modules.vdomHoz.rightPos += widthDiff;
                column.modules.vdomHoz.width = newWidth;
                this.colPositionAdjust(this.columns.indexOf(column) + 1, this.columns.length, widthDiff);
            }
            column.modules.vdomHoz.fitDataCheck = false;
        }
        return widthDiff;
    }
    initializeRow(row) {
        if (row.type !== "group") {
            row.modules.vdomHoz = {
                leftCol: this.leftCol,
                rightCol: this.rightCol
            };
            if (this.table.modules.frozenColumns) this.table.modules.frozenColumns.leftColumns.forEach((column)=>{
                this.appendCell(row, column);
            });
            for(let i = this.leftCol; i <= this.rightCol; i++)this.appendCell(row, this.columns[i]);
            if (this.table.modules.frozenColumns) this.table.modules.frozenColumns.rightColumns.forEach((column)=>{
                this.appendCell(row, column);
            });
        }
    }
    appendCell(row, column) {
        if (column && column.visible) {
            let cell = row.getCell(column);
            row.getElement().appendChild(cell.getElement());
            cell.cellRendered();
        }
    }
    reinitializeRow(row, force) {
        if (row.type !== "group") {
            if (force || !row.modules.vdomHoz || row.modules.vdomHoz.leftCol !== this.leftCol || row.modules.vdomHoz.rightCol !== this.rightCol) {
                var rowEl = row.getElement();
                while(rowEl.firstChild)rowEl.removeChild(rowEl.firstChild);
                this.initializeRow(row);
            }
        }
    }
}
class $517dee46856d349e$var$ColumnManager extends $517dee46856d349e$var$CoreFeature {
    constructor(table){
        super(table);
        this.blockHozScrollEvent = false;
        this.headersElement = null;
        this.contentsElement = null;
        this.rowHeader = null;
        this.element = null; //containing element
        this.columns = []; // column definition object
        this.columnsByIndex = []; //columns by index
        this.columnsByField = {}; //columns by field
        this.scrollLeft = 0;
        this.optionsList = new $517dee46856d349e$var$OptionsList(this.table, "column definition", $517dee46856d349e$var$defaultColumnOptions);
        this.redrawBlock = false; //prevent redraws to allow multiple data manipulations before continuing
        this.redrawBlockUpdate = null; //store latest redraw update only status
        this.renderer = null;
    }
    ////////////// Setup Functions /////////////////
    initialize() {
        this.initializeRenderer();
        this.headersElement = this.createHeadersElement();
        this.contentsElement = this.createHeaderContentsElement();
        this.element = this.createHeaderElement();
        this.contentsElement.insertBefore(this.headersElement, this.contentsElement.firstChild);
        this.element.insertBefore(this.contentsElement, this.element.firstChild);
        this.initializeScrollWheelWatcher();
        this.subscribe("scroll-horizontal", this.scrollHorizontal.bind(this));
        this.subscribe("scrollbar-vertical", this.padVerticalScrollbar.bind(this));
    }
    padVerticalScrollbar(width) {
        if (this.table.rtl) this.headersElement.style.marginLeft = width + "px";
        else this.headersElement.style.marginRight = width + "px";
    }
    initializeRenderer() {
        var renderClass;
        var renderers = {
            "virtual": $517dee46856d349e$var$VirtualDomHorizontal,
            "basic": $517dee46856d349e$var$BasicHorizontal
        };
        if (typeof this.table.options.renderHorizontal === "string") renderClass = renderers[this.table.options.renderHorizontal];
        else renderClass = this.table.options.renderHorizontal;
        if (renderClass) {
            this.renderer = new renderClass(this.table, this.element, this.tableElement);
            this.renderer.initialize();
        } else console.error("Unable to find matching renderer:", this.table.options.renderHorizontal);
    }
    createHeadersElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-headers");
        el.setAttribute("role", "row");
        return el;
    }
    createHeaderContentsElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-header-contents");
        el.setAttribute("role", "rowgroup");
        return el;
    }
    createHeaderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-header");
        el.setAttribute("role", "rowgroup");
        if (!this.table.options.headerVisible) el.classList.add("tabulator-header-hidden");
        return el;
    }
    //return containing element
    getElement() {
        return this.element;
    }
    //return containing contents element
    getContentsElement() {
        return this.contentsElement;
    }
    //return header containing element
    getHeadersElement() {
        return this.headersElement;
    }
    //scroll horizontally to match table body
    scrollHorizontal(left) {
        this.contentsElement.scrollLeft = left;
        this.scrollLeft = left;
        this.renderer.scrollColumns(left);
    }
    initializeScrollWheelWatcher() {
        this.contentsElement.addEventListener("wheel", (e)=>{
            var left;
            if (e.deltaX) {
                left = this.contentsElement.scrollLeft + e.deltaX;
                this.table.rowManager.scrollHorizontal(left);
                this.table.columnManager.scrollHorizontal(left);
            }
        });
    }
    ///////////// Column Setup Functions /////////////
    generateColumnsFromRowData(data) {
        var cols = [], collProgress = {}, rowSample = this.table.options.autoColumns === "full" ? data : [
            data[0]
        ], definitions = this.table.options.autoColumnsDefinitions;
        if (data && data.length) {
            rowSample.forEach((row)=>{
                Object.keys(row).forEach((key, index)=>{
                    let value = row[key], col;
                    if (!collProgress[key]) {
                        col = {
                            field: key,
                            title: key,
                            sorter: this.calculateSorterFromValue(value)
                        };
                        cols.splice(index, 0, col);
                        collProgress[key] = typeof value === "undefined" ? col : true;
                    } else if (collProgress[key] !== true) {
                        if (typeof value !== "undefined") {
                            collProgress[key].sorter = this.calculateSorterFromValue(value);
                            collProgress[key] = true;
                        }
                    }
                });
            });
            if (definitions) switch(typeof definitions){
                case "function":
                    this.table.options.columns = definitions.call(this.table, cols);
                    break;
                case "object":
                    if (Array.isArray(definitions)) cols.forEach((col)=>{
                        var match = definitions.find((def)=>{
                            return def.field === col.field;
                        });
                        if (match) Object.assign(col, match);
                    });
                    else cols.forEach((col)=>{
                        if (definitions[col.field]) Object.assign(col, definitions[col.field]);
                    });
                    this.table.options.columns = cols;
                    break;
            }
            else this.table.options.columns = cols;
            this.setColumns(this.table.options.columns);
        }
    }
    calculateSorterFromValue(value) {
        var sorter;
        switch(typeof value){
            case "undefined":
                sorter = "string";
                break;
            case "boolean":
                sorter = "boolean";
                break;
            case "number":
                sorter = "number";
                break;
            case "object":
                if (Array.isArray(value)) sorter = "array";
                else sorter = "string";
                break;
            default:
                if (!isNaN(value) && value !== "") sorter = "number";
                else if (value.match(/((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+$/i)) sorter = "alphanum";
                else sorter = "string";
                break;
        }
        return sorter;
    }
    setColumns(cols, row) {
        while(this.headersElement.firstChild)this.headersElement.removeChild(this.headersElement.firstChild);
        this.columns = [];
        this.columnsByIndex = [];
        this.columnsByField = {};
        this.dispatch("columns-loading");
        this.dispatchExternal("columnsLoading");
        if (this.table.options.rowHeader) {
            this.rowHeader = new $517dee46856d349e$var$Column(this.table.options.rowHeader === true ? {} : this.table.options.rowHeader, this, true);
            this.columns.push(this.rowHeader);
            this.headersElement.appendChild(this.rowHeader.getElement());
            this.rowHeader.columnRendered();
        }
        cols.forEach((def, i)=>{
            this._addColumn(def);
        });
        this._reIndexColumns();
        this.dispatch("columns-loaded");
        if (this.subscribedExternal("columnsLoaded")) this.dispatchExternal("columnsLoaded", this.getComponents());
        this.rerenderColumns(false, true);
        this.redraw(true);
    }
    _addColumn(definition, before, nextToColumn) {
        var column = new $517dee46856d349e$var$Column(definition, this), colEl = column.getElement(), index = nextToColumn ? this.findColumnIndex(nextToColumn) : nextToColumn;
        //prevent adding of rows in front of row header
        if (before && this.rowHeader && (!nextToColumn || nextToColumn === this.rowHeader)) {
            before = false;
            nextToColumn = this.rowHeader;
            index = 0;
        }
        if (nextToColumn && index > -1) {
            var topColumn = nextToColumn.getTopColumn();
            var parentIndex = this.columns.indexOf(topColumn);
            var nextEl = topColumn.getElement();
            if (before) {
                this.columns.splice(parentIndex, 0, column);
                nextEl.parentNode.insertBefore(colEl, nextEl);
            } else {
                this.columns.splice(parentIndex + 1, 0, column);
                nextEl.parentNode.insertBefore(colEl, nextEl.nextSibling);
            }
        } else if (before) {
            this.columns.unshift(column);
            this.headersElement.insertBefore(column.getElement(), this.headersElement.firstChild);
        } else {
            this.columns.push(column);
            this.headersElement.appendChild(column.getElement());
        }
        column.columnRendered();
        return column;
    }
    registerColumnField(col) {
        if (col.definition.field) this.columnsByField[col.definition.field] = col;
    }
    registerColumnPosition(col) {
        this.columnsByIndex.push(col);
    }
    _reIndexColumns() {
        this.columnsByIndex = [];
        this.columns.forEach(function(column) {
            column.reRegisterPosition();
        });
    }
    //ensure column headers take up the correct amount of space in column groups
    verticalAlignHeaders() {
        var minHeight = 0;
        if (!this.redrawBlock) {
            this.headersElement.style.height = "";
            this.columns.forEach((column)=>{
                column.clearVerticalAlign();
            });
            this.columns.forEach((column)=>{
                var height = column.getHeight();
                if (height > minHeight) minHeight = height;
            });
            this.headersElement.style.height = minHeight + "px";
            this.columns.forEach((column)=>{
                column.verticalAlign(this.table.options.columnHeaderVertAlign, minHeight);
            });
            this.table.rowManager.adjustTableSize();
        }
    }
    //////////////// Column Details /////////////////
    findColumn(subject) {
        var columns;
        if (typeof subject == "object") {
            if (subject instanceof $517dee46856d349e$var$Column) //subject is column element
            return subject;
            else if (subject instanceof $517dee46856d349e$export$11bb209ad3a8e411) //subject is public column component
            return subject._getSelf() || false;
            else if (typeof HTMLElement !== "undefined" && subject instanceof HTMLElement) {
                columns = [];
                this.columns.forEach((column)=>{
                    columns.push(column);
                    columns = columns.concat(column.getColumns(true));
                });
                //subject is a HTML element of the column header
                let match = columns.find((column)=>{
                    return column.element === subject;
                });
                return match || false;
            }
        } else //subject should be treated as the field name of the column
        return this.columnsByField[subject] || false;
        //catch all for any other type of input
        return false;
    }
    getColumnByField(field) {
        return this.columnsByField[field];
    }
    getColumnsByFieldRoot(root) {
        var matches = [];
        Object.keys(this.columnsByField).forEach((field)=>{
            var fieldRoot = this.table.options.nestedFieldSeparator ? field.split(this.table.options.nestedFieldSeparator)[0] : field;
            if (fieldRoot === root) matches.push(this.columnsByField[field]);
        });
        return matches;
    }
    getColumnByIndex(index) {
        return this.columnsByIndex[index];
    }
    getFirstVisibleColumn() {
        var index = this.columnsByIndex.findIndex((col)=>{
            return col.visible;
        });
        return index > -1 ? this.columnsByIndex[index] : false;
    }
    getVisibleColumnsByIndex() {
        return this.columnsByIndex.filter((col)=>col.visible);
    }
    getColumns() {
        return this.columns;
    }
    findColumnIndex(column) {
        return this.columnsByIndex.findIndex((col)=>{
            return column === col;
        });
    }
    //return all columns that are not groups
    getRealColumns() {
        return this.columnsByIndex;
    }
    //traverse across columns and call action
    traverse(callback) {
        this.columnsByIndex.forEach((column, i)=>{
            callback(column, i);
        });
    }
    //get definitions of actual columns
    getDefinitions(active) {
        var output = [];
        this.columnsByIndex.forEach((column)=>{
            if (!active || active && column.visible) output.push(column.getDefinition());
        });
        return output;
    }
    //get full nested definition tree
    getDefinitionTree() {
        var output = [];
        this.columns.forEach((column)=>{
            output.push(column.getDefinition(true));
        });
        return output;
    }
    getComponents(structured) {
        var output = [], columns = structured ? this.columns : this.columnsByIndex;
        columns.forEach((column)=>{
            output.push(column.getComponent());
        });
        return output;
    }
    getWidth() {
        var width = 0;
        this.columnsByIndex.forEach((column)=>{
            if (column.visible) width += column.getWidth();
        });
        return width;
    }
    moveColumn(from, to, after) {
        to.element.parentNode.insertBefore(from.element, to.element);
        if (after) to.element.parentNode.insertBefore(to.element, from.element);
        this.moveColumnActual(from, to, after);
        this.verticalAlignHeaders();
        this.table.rowManager.reinitialize();
    }
    moveColumnActual(from, to, after) {
        if (from.parent.isGroup) this._moveColumnInArray(from.parent.columns, from, to, after);
        else this._moveColumnInArray(this.columns, from, to, after);
        this._moveColumnInArray(this.columnsByIndex, from, to, after, true);
        this.rerenderColumns(true);
        this.dispatch("column-moved", from, to, after);
        if (this.subscribedExternal("columnMoved")) this.dispatchExternal("columnMoved", from.getComponent(), this.table.columnManager.getComponents());
    }
    _moveColumnInArray(columns, from, to, after, updateRows) {
        var fromIndex = columns.indexOf(from), toIndex, rows = [];
        if (fromIndex > -1) {
            columns.splice(fromIndex, 1);
            toIndex = columns.indexOf(to);
            if (toIndex > -1) {
                if (after) toIndex = toIndex + 1;
            } else toIndex = fromIndex;
            columns.splice(toIndex, 0, from);
            if (updateRows) {
                rows = this.chain("column-moving-rows", [
                    from,
                    to,
                    after
                ], null, []) || [];
                rows = rows.concat(this.table.rowManager.rows);
                rows.forEach(function(row) {
                    if (row.cells.length) {
                        var cell = row.cells.splice(fromIndex, 1)[0];
                        row.cells.splice(toIndex, 0, cell);
                    }
                });
            }
        }
    }
    scrollToColumn(column, position, ifVisible) {
        var left = 0, offset = column.getLeftOffset(), adjust = 0, colEl = column.getElement();
        return new Promise((resolve, reject)=>{
            if (typeof position === "undefined") position = this.table.options.scrollToColumnPosition;
            if (typeof ifVisible === "undefined") ifVisible = this.table.options.scrollToColumnIfVisible;
            if (column.visible) {
                //align to correct position
                switch(position){
                    case "middle":
                    case "center":
                        adjust = -this.element.clientWidth / 2;
                        break;
                    case "right":
                        adjust = colEl.clientWidth - this.headersElement.clientWidth;
                        break;
                }
                //check column visibility
                if (!ifVisible) {
                    if (offset > 0 && offset + colEl.offsetWidth < this.element.clientWidth) return false;
                }
                //calculate scroll position
                left = offset + adjust;
                left = Math.max(Math.min(left, this.table.rowManager.element.scrollWidth - this.table.rowManager.element.clientWidth), 0);
                this.table.rowManager.scrollHorizontal(left);
                this.scrollHorizontal(left);
                resolve();
            } else {
                console.warn("Scroll Error - Column not visible");
                reject("Scroll Error - Column not visible");
            }
        });
    }
    //////////////// Cell Management /////////////////
    generateCells(row) {
        var cells = [];
        this.columnsByIndex.forEach((column)=>{
            cells.push(column.generateCell(row));
        });
        return cells;
    }
    //////////////// Column Management /////////////////
    getFlexBaseWidth() {
        var totalWidth = this.table.element.clientWidth, fixedWidth = 0;
        //adjust for vertical scrollbar if present
        if (this.table.rowManager.element.scrollHeight > this.table.rowManager.element.clientHeight) totalWidth -= this.table.rowManager.element.offsetWidth - this.table.rowManager.element.clientWidth;
        this.columnsByIndex.forEach(function(column) {
            var width, minWidth, colWidth;
            if (column.visible) {
                width = column.definition.width || 0;
                minWidth = parseInt(column.minWidth);
                if (typeof width == "string") {
                    if (width.indexOf("%") > -1) colWidth = totalWidth / 100 * parseInt(width);
                    else colWidth = parseInt(width);
                } else colWidth = width;
                fixedWidth += colWidth > minWidth ? colWidth : minWidth;
            }
        });
        return fixedWidth;
    }
    addColumn(definition, before, nextToColumn) {
        return new Promise((resolve, reject)=>{
            var column = this._addColumn(definition, before, nextToColumn);
            this._reIndexColumns();
            this.dispatch("column-add", definition, before, nextToColumn);
            if (this.layoutMode() != "fitColumns") column.reinitializeWidth();
            this.redraw(true);
            this.table.rowManager.reinitialize();
            this.rerenderColumns();
            resolve(column);
        });
    }
    //remove column from system
    deregisterColumn(column) {
        var field = column.getField(), index;
        //remove from field list
        if (field) delete this.columnsByField[field];
        //remove from index list
        index = this.columnsByIndex.indexOf(column);
        if (index > -1) this.columnsByIndex.splice(index, 1);
        //remove from column list
        index = this.columns.indexOf(column);
        if (index > -1) this.columns.splice(index, 1);
        this.verticalAlignHeaders();
        this.redraw();
    }
    rerenderColumns(update, silent) {
        if (!this.redrawBlock) this.renderer.rerenderColumns(update, silent);
        else if (update === false || update === true && this.redrawBlockUpdate === null) this.redrawBlockUpdate = update;
    }
    blockRedraw() {
        this.redrawBlock = true;
        this.redrawBlockUpdate = null;
    }
    restoreRedraw() {
        this.redrawBlock = false;
        this.verticalAlignHeaders();
        this.renderer.rerenderColumns(this.redrawBlockUpdate);
    }
    //redraw columns
    redraw(force) {
        if ($517dee46856d349e$var$Helpers.elVisible(this.element)) this.verticalAlignHeaders();
        if (force) {
            this.table.rowManager.resetScroll();
            this.table.rowManager.reinitialize();
        }
        if (!this.confirm("table-redrawing", force)) this.layoutRefresh(force);
        this.dispatch("table-redraw", force);
        this.table.footerManager.redraw();
    }
}
class $517dee46856d349e$var$BasicVertical extends $517dee46856d349e$export$88530751e3977073 {
    constructor(table){
        super(table);
        this.verticalFillMode = "fill";
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.scrollTop = 0;
        this.scrollLeft = 0;
    }
    clearRows() {
        var element = this.tableElement;
        // element.children.detach();
        while(element.firstChild)element.removeChild(element.firstChild);
        element.scrollTop = 0;
        element.scrollLeft = 0;
        element.style.minWidth = "";
        element.style.minHeight = "";
        element.style.display = "";
        element.style.visibility = "";
    }
    renderRows() {
        var element = this.tableElement, onlyGroupHeaders = true, tableFrag = document.createDocumentFragment(), rows = this.rows();
        rows.forEach((row, index)=>{
            this.styleRow(row, index);
            row.initialize(false, true);
            if (row.type !== "group") onlyGroupHeaders = false;
            tableFrag.appendChild(row.getElement());
        });
        element.appendChild(tableFrag);
        rows.forEach((row)=>{
            row.rendered();
            if (!row.heightInitialized) row.calcHeight(true);
        });
        rows.forEach((row)=>{
            if (!row.heightInitialized) row.setCellHeight();
        });
        if (onlyGroupHeaders) element.style.minWidth = this.table.columnManager.getWidth() + "px";
        else element.style.minWidth = "";
    }
    rerenderRows(callback) {
        this.clearRows();
        if (callback) callback();
        this.renderRows();
        if (!this.rows().length) this.table.rowManager.tableEmpty();
    }
    scrollToRowNearestTop(row) {
        var rowTop = $517dee46856d349e$var$Helpers.elOffset(row.getElement()).top;
        return !(Math.abs(this.elementVertical.scrollTop - rowTop) > Math.abs(this.elementVertical.scrollTop + this.elementVertical.clientHeight - rowTop));
    }
    scrollToRow(row) {
        var rowEl = row.getElement();
        this.elementVertical.scrollTop = $517dee46856d349e$var$Helpers.elOffset(rowEl).top - $517dee46856d349e$var$Helpers.elOffset(this.elementVertical).top + this.elementVertical.scrollTop;
    }
    visibleRows(includingBuffer) {
        return this.rows();
    }
}
class $517dee46856d349e$var$VirtualDomVertical extends $517dee46856d349e$export$88530751e3977073 {
    constructor(table){
        super(table);
        this.verticalFillMode = "fill";
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.vDomRowHeight = 20; //approximation of row heights for padding
        this.vDomTop = 0; //hold position for first rendered row in the virtual DOM
        this.vDomBottom = 0; //hold position for last rendered row in the virtual DOM
        this.vDomScrollPosTop = 0; //last scroll position of the vDom top;
        this.vDomScrollPosBottom = 0; //last scroll position of the vDom bottom;
        this.vDomTopPad = 0; //hold value of padding for top of virtual DOM
        this.vDomBottomPad = 0; //hold value of padding for bottom of virtual DOM
        this.vDomMaxRenderChain = 90; //the maximum number of dom elements that can be rendered in 1 go
        this.vDomWindowBuffer = 0; //window row buffer before removing elements, to smooth scrolling
        this.vDomWindowMinTotalRows = 20; //minimum number of rows to be generated in virtual dom (prevent buffering issues on tables with tall rows)
        this.vDomWindowMinMarginRows = 5; //minimum number of rows to be generated in virtual dom margin
        this.vDomTopNewRows = []; //rows to normalize after appending to optimize render speed
        this.vDomBottomNewRows = []; //rows to normalize after appending to optimize render speed
    }
    //////////////////////////////////////
    ///////// Public Functions ///////////
    //////////////////////////////////////
    clearRows() {
        var element = this.tableElement;
        // element.children.detach();
        while(element.firstChild)element.removeChild(element.firstChild);
        element.style.paddingTop = "";
        element.style.paddingBottom = "";
        element.style.minHeight = "";
        element.style.display = "";
        element.style.visibility = "";
        this.elementVertical.scrollTop = 0;
        this.elementVertical.scrollLeft = 0;
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.vDomTop = 0;
        this.vDomBottom = 0;
        this.vDomTopPad = 0;
        this.vDomBottomPad = 0;
        this.vDomScrollPosTop = 0;
        this.vDomScrollPosBottom = 0;
    }
    renderRows() {
        this._virtualRenderFill();
    }
    rerenderRows(callback) {
        var scrollTop = this.elementVertical.scrollTop;
        var topRow = false;
        var topOffset = false;
        var left = this.table.rowManager.scrollLeft;
        var rows = this.rows();
        for(var i = this.vDomTop; i <= this.vDomBottom; i++)if (rows[i]) {
            var diff = scrollTop - rows[i].getElement().offsetTop;
            if (topOffset === false || Math.abs(diff) < topOffset) {
                topOffset = diff;
                topRow = i;
            } else break;
        }
        rows.forEach((row)=>{
            row.deinitializeHeight();
        });
        if (callback) callback();
        if (this.rows().length) this._virtualRenderFill(topRow === false ? this.rows.length - 1 : topRow, true, topOffset || 0);
        else {
            this.clear();
            this.table.rowManager.tableEmpty();
        }
        this.scrollColumns(left);
    }
    scrollColumns(left) {
        this.table.rowManager.scrollHorizontal(left);
    }
    scrollRows(top, dir) {
        var topDiff = top - this.vDomScrollPosTop;
        var bottomDiff = top - this.vDomScrollPosBottom;
        var margin = this.vDomWindowBuffer * 2;
        var rows = this.rows();
        this.scrollTop = top;
        if (-topDiff > margin || bottomDiff > margin) {
            //if big scroll redraw table;
            var left = this.table.rowManager.scrollLeft;
            this._virtualRenderFill(Math.floor(this.elementVertical.scrollTop / this.elementVertical.scrollHeight * rows.length));
            this.scrollColumns(left);
        } else if (dir) {
            //scrolling up
            if (topDiff < 0) this._addTopRow(rows, -topDiff);
            if (bottomDiff < 0) {
                //hide bottom row if needed
                if (this.vDomScrollHeight - this.scrollTop > this.vDomWindowBuffer) this._removeBottomRow(rows, -bottomDiff);
                else this.vDomScrollPosBottom = this.scrollTop;
            }
        } else {
            if (bottomDiff >= 0) this._addBottomRow(rows, bottomDiff);
            //scrolling down
            if (topDiff >= 0) {
                //hide top row if needed
                if (this.scrollTop > this.vDomWindowBuffer) this._removeTopRow(rows, topDiff);
                else this.vDomScrollPosTop = this.scrollTop;
            }
        }
    }
    resize() {
        this.vDomWindowBuffer = this.table.options.renderVerticalBuffer || this.elementVertical.clientHeight;
    }
    scrollToRowNearestTop(row) {
        var rowIndex = this.rows().indexOf(row);
        return !(Math.abs(this.vDomTop - rowIndex) > Math.abs(this.vDomBottom - rowIndex));
    }
    scrollToRow(row) {
        var index = this.rows().indexOf(row);
        if (index > -1) this._virtualRenderFill(index, true);
    }
    visibleRows(includingBuffer) {
        var topEdge = this.elementVertical.scrollTop, bottomEdge = this.elementVertical.clientHeight + topEdge, topFound = false, topRow = 0, bottomRow = 0, rows = this.rows();
        if (includingBuffer) {
            topRow = this.vDomTop;
            bottomRow = this.vDomBottom;
        } else {
            for(var i = this.vDomTop; i <= this.vDomBottom; i++)if (rows[i]) {
                if (!topFound) {
                    if (topEdge - rows[i].getElement().offsetTop >= 0) topRow = i;
                    else {
                        topFound = true;
                        if (bottomEdge - rows[i].getElement().offsetTop >= 0) bottomRow = i;
                        else break;
                    }
                } else {
                    if (bottomEdge - rows[i].getElement().offsetTop >= 0) bottomRow = i;
                    else break;
                }
            }
        }
        return rows.slice(topRow, bottomRow + 1);
    }
    //////////////////////////////////////
    //////// Internal Rendering //////////
    //////////////////////////////////////
    //full virtual render
    _virtualRenderFill(position, forceMove, offset) {
        var element = this.tableElement, holder = this.elementVertical, topPad = 0, rowsHeight = 0, rowHeight = 0, heightOccupied = 0, topPadHeight = 0, i = 0, rows = this.rows(), rowsCount = rows.length, index = 0, row, rowFragment, renderedRows = [], totalRowsRendered = 0, rowsToRender = 0, fixedHeight = this.table.rowManager.fixedHeight, containerHeight = this.elementVertical.clientHeight, avgRowHeight = this.table.options.rowHeight, resized = true;
        position = position || 0;
        offset = offset || 0;
        if (!position) this.clear();
        else {
            while(element.firstChild)element.removeChild(element.firstChild);
            //check if position is too close to bottom of table
            heightOccupied = (rowsCount - position + 1) * this.vDomRowHeight;
            if (heightOccupied < containerHeight) {
                position -= Math.ceil((containerHeight - heightOccupied) / this.vDomRowHeight);
                if (position < 0) position = 0;
            }
            //calculate initial pad
            topPad = Math.min(Math.max(Math.floor(this.vDomWindowBuffer / this.vDomRowHeight), this.vDomWindowMinMarginRows), position);
            position -= topPad;
        }
        if (rowsCount && $517dee46856d349e$var$Helpers.elVisible(this.elementVertical)) {
            this.vDomTop = position;
            this.vDomBottom = position - 1;
            if (fixedHeight || this.table.options.maxHeight) {
                if (avgRowHeight) rowsToRender = containerHeight / avgRowHeight + this.vDomWindowBuffer / avgRowHeight;
                rowsToRender = Math.max(this.vDomWindowMinTotalRows, Math.ceil(rowsToRender));
            } else rowsToRender = rowsCount;
            while((rowsToRender == rowsCount || rowsHeight <= containerHeight + this.vDomWindowBuffer || totalRowsRendered < this.vDomWindowMinTotalRows) && this.vDomBottom < rowsCount - 1){
                renderedRows = [];
                rowFragment = document.createDocumentFragment();
                i = 0;
                while(i < rowsToRender && this.vDomBottom < rowsCount - 1){
                    index = this.vDomBottom + 1, row = rows[index];
                    this.styleRow(row, index);
                    row.initialize(false, true);
                    if (!row.heightInitialized && !this.table.options.rowHeight) row.clearCellHeight();
                    rowFragment.appendChild(row.getElement());
                    renderedRows.push(row);
                    this.vDomBottom++;
                    i++;
                }
                if (!renderedRows.length) break;
                element.appendChild(rowFragment);
                // NOTE: The next 3 loops are separate on purpose
                // This is to batch up the dom writes and reads which drastically improves performance 
                renderedRows.forEach((row)=>{
                    row.rendered();
                    if (!row.heightInitialized) row.calcHeight(true);
                });
                renderedRows.forEach((row)=>{
                    if (!row.heightInitialized) row.setCellHeight();
                });
                renderedRows.forEach((row)=>{
                    rowHeight = row.getHeight();
                    if (totalRowsRendered < topPad) topPadHeight += rowHeight;
                    else rowsHeight += rowHeight;
                    if (rowHeight > this.vDomWindowBuffer) this.vDomWindowBuffer = rowHeight * 2;
                    totalRowsRendered++;
                });
                resized = this.table.rowManager.adjustTableSize();
                containerHeight = this.elementVertical.clientHeight;
                if (resized && (fixedHeight || this.table.options.maxHeight)) {
                    avgRowHeight = rowsHeight / totalRowsRendered;
                    rowsToRender = Math.max(this.vDomWindowMinTotalRows, Math.ceil(containerHeight / avgRowHeight + this.vDomWindowBuffer / avgRowHeight));
                }
            }
            if (!position) {
                this.vDomTopPad = 0;
                //adjust row height to match average of rendered elements
                this.vDomRowHeight = Math.floor((rowsHeight + topPadHeight) / totalRowsRendered);
                this.vDomBottomPad = this.vDomRowHeight * (rowsCount - this.vDomBottom - 1);
                this.vDomScrollHeight = topPadHeight + rowsHeight + this.vDomBottomPad - containerHeight;
            } else {
                this.vDomTopPad = !forceMove ? this.scrollTop - topPadHeight : this.vDomRowHeight * this.vDomTop + offset;
                this.vDomBottomPad = this.vDomBottom == rowsCount - 1 ? 0 : Math.max(this.vDomScrollHeight - this.vDomTopPad - rowsHeight - topPadHeight, 0);
            }
            element.style.paddingTop = this.vDomTopPad + "px";
            element.style.paddingBottom = this.vDomBottomPad + "px";
            if (forceMove) this.scrollTop = this.vDomTopPad + topPadHeight + offset - (this.elementVertical.scrollWidth > this.elementVertical.clientWidth ? this.elementVertical.offsetHeight - containerHeight : 0);
            this.scrollTop = Math.min(this.scrollTop, this.elementVertical.scrollHeight - containerHeight);
            //adjust for horizontal scrollbar if present (and not at top of table)
            if (this.elementVertical.scrollWidth > this.elementVertical.clientWidth && forceMove) this.scrollTop += this.elementVertical.offsetHeight - containerHeight;
            this.vDomScrollPosTop = this.scrollTop;
            this.vDomScrollPosBottom = this.scrollTop;
            holder.scrollTop = this.scrollTop;
            this.dispatch("render-virtual-fill");
        }
    }
    _addTopRow(rows, fillableSpace) {
        var table = this.tableElement, addedRows = [], paddingAdjust = 0, index = this.vDomTop - 1, i = 0, working = true;
        while(working)if (this.vDomTop) {
            let row = rows[index], rowHeight, initialized;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                initialized = row.initialized;
                if (fillableSpace >= rowHeight) {
                    this.styleRow(row, index);
                    table.insertBefore(row.getElement(), table.firstChild);
                    if (!row.initialized || !row.heightInitialized) addedRows.push(row);
                    row.initialize();
                    if (!initialized) {
                        rowHeight = row.getElement().offsetHeight;
                        if (rowHeight > this.vDomWindowBuffer) this.vDomWindowBuffer = rowHeight * 2;
                    }
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    this.vDomTop--;
                    index--;
                    i++;
                } else working = false;
            } else working = false;
        } else working = false;
        for (let row of addedRows)row.clearCellHeight();
        this._quickNormalizeRowHeight(addedRows);
        if (paddingAdjust) {
            this.vDomTopPad -= paddingAdjust;
            if (this.vDomTopPad < 0) this.vDomTopPad = index * this.vDomRowHeight;
            if (index < 1) this.vDomTopPad = 0;
            table.style.paddingTop = this.vDomTopPad + "px";
            this.vDomScrollPosTop -= paddingAdjust;
        }
    }
    _removeTopRow(rows, fillableSpace) {
        var removableRows = [], paddingAdjust = 0, i = 0, working = true;
        while(working){
            let row = rows[this.vDomTop], rowHeight;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                if (fillableSpace >= rowHeight) {
                    this.vDomTop++;
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    removableRows.push(row);
                    i++;
                } else working = false;
            } else working = false;
        }
        for (let row of removableRows){
            let rowEl = row.getElement();
            if (rowEl.parentNode) rowEl.parentNode.removeChild(rowEl);
        }
        if (paddingAdjust) {
            this.vDomTopPad += paddingAdjust;
            this.tableElement.style.paddingTop = this.vDomTopPad + "px";
            this.vDomScrollPosTop += this.vDomTop ? paddingAdjust : paddingAdjust + this.vDomWindowBuffer;
        }
    }
    _addBottomRow(rows, fillableSpace) {
        var table = this.tableElement, addedRows = [], paddingAdjust = 0, index = this.vDomBottom + 1, i = 0, working = true;
        while(working){
            let row = rows[index], rowHeight, initialized;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                initialized = row.initialized;
                if (fillableSpace >= rowHeight) {
                    this.styleRow(row, index);
                    table.appendChild(row.getElement());
                    if (!row.initialized || !row.heightInitialized) addedRows.push(row);
                    row.initialize();
                    if (!initialized) {
                        rowHeight = row.getElement().offsetHeight;
                        if (rowHeight > this.vDomWindowBuffer) this.vDomWindowBuffer = rowHeight * 2;
                    }
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    this.vDomBottom++;
                    index++;
                    i++;
                } else working = false;
            } else working = false;
        }
        for (let row of addedRows)row.clearCellHeight();
        this._quickNormalizeRowHeight(addedRows);
        if (paddingAdjust) {
            this.vDomBottomPad -= paddingAdjust;
            if (this.vDomBottomPad < 0 || index == rows.length - 1) this.vDomBottomPad = 0;
            table.style.paddingBottom = this.vDomBottomPad + "px";
            this.vDomScrollPosBottom += paddingAdjust;
        }
    }
    _removeBottomRow(rows, fillableSpace) {
        var removableRows = [], paddingAdjust = 0, i = 0, working = true;
        while(working){
            let row = rows[this.vDomBottom], rowHeight;
            if (row && i < this.vDomMaxRenderChain) {
                rowHeight = row.getHeight() || this.vDomRowHeight;
                if (fillableSpace >= rowHeight) {
                    this.vDomBottom--;
                    fillableSpace -= rowHeight;
                    paddingAdjust += rowHeight;
                    removableRows.push(row);
                    i++;
                } else working = false;
            } else working = false;
        }
        for (let row of removableRows){
            let rowEl = row.getElement();
            if (rowEl.parentNode) rowEl.parentNode.removeChild(rowEl);
        }
        if (paddingAdjust) {
            this.vDomBottomPad += paddingAdjust;
            if (this.vDomBottomPad < 0) this.vDomBottomPad = 0;
            this.tableElement.style.paddingBottom = this.vDomBottomPad + "px";
            this.vDomScrollPosBottom -= paddingAdjust;
        }
    }
    _quickNormalizeRowHeight(rows) {
        for (let row of rows)row.calcHeight();
        for (let row of rows)row.setCellHeight();
    }
}
class $517dee46856d349e$var$RowManager extends $517dee46856d349e$var$CoreFeature {
    constructor(table){
        super(table);
        this.element = this.createHolderElement(); //containing element
        this.tableElement = this.createTableElement(); //table element
        this.heightFixer = this.createTableElement(); //table element
        this.placeholder = null; //placeholder element
        this.placeholderContents = null; //placeholder element
        this.firstRender = false; //handle first render
        this.renderMode = "virtual"; //current rendering mode
        this.fixedHeight = false; //current rendering mode
        this.rows = []; //hold row data objects
        this.activeRowsPipeline = []; //hold calculation of active rows
        this.activeRows = []; //rows currently available to on display in the table
        this.activeRowsCount = 0; //count of active rows
        this.displayRows = []; //rows currently on display in the table
        this.displayRowsCount = 0; //count of display rows
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.redrawBlock = false; //prevent redraws to allow multiple data manipulations before continuing
        this.redrawBlockRestoreConfig = false; //store latest redraw function calls for when redraw is needed
        this.redrawBlockRenderInPosition = false; //store latest redraw function calls for when redraw is needed
        this.dataPipeline = []; //hold data pipeline tasks
        this.displayPipeline = []; //hold data display pipeline tasks
        this.scrollbarWidth = 0;
        this.renderer = null;
    }
    //////////////// Setup Functions /////////////////
    createHolderElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-tableholder");
        el.setAttribute("tabindex", 0);
        // el.setAttribute("role", "rowgroup");
        return el;
    }
    createTableElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-table");
        el.setAttribute("role", "rowgroup");
        return el;
    }
    initializePlaceholder() {
        var placeholder = this.table.options.placeholder;
        if (typeof placeholder === "function") placeholder = placeholder.call(this.table);
        placeholder = this.chain("placeholder", [
            placeholder
        ], placeholder, placeholder) || placeholder;
        //configure placeholder element
        if (placeholder) {
            let el = document.createElement("div");
            el.classList.add("tabulator-placeholder");
            if (typeof placeholder == "string") {
                let contents = document.createElement("div");
                contents.classList.add("tabulator-placeholder-contents");
                contents.innerHTML = placeholder;
                el.appendChild(contents);
                this.placeholderContents = contents;
            } else if (typeof HTMLElement !== "undefined" && placeholder instanceof HTMLElement) {
                el.appendChild(placeholder);
                this.placeholderContents = placeholder;
            } else {
                console.warn("Invalid placeholder provided, must be string or HTML Element", placeholder);
                this.el = null;
            }
            this.placeholder = el;
        }
    }
    //return containing element
    getElement() {
        return this.element;
    }
    //return table element
    getTableElement() {
        return this.tableElement;
    }
    initialize() {
        this.initializePlaceholder();
        this.initializeRenderer();
        //initialize manager
        this.element.appendChild(this.tableElement);
        this.firstRender = true;
        //scroll header along with table body
        this.element.addEventListener("scroll", ()=>{
            var left = this.element.scrollLeft, leftDir = this.scrollLeft > left, top = this.element.scrollTop, topDir = this.scrollTop > top;
            //handle horizontal scrolling
            if (this.scrollLeft != left) {
                this.scrollLeft = left;
                this.dispatch("scroll-horizontal", left, leftDir);
                this.dispatchExternal("scrollHorizontal", left, leftDir);
                this._positionPlaceholder();
            }
            //handle vertical scrolling
            if (this.scrollTop != top) {
                this.scrollTop = top;
                this.renderer.scrollRows(top, topDir);
                this.dispatch("scroll-vertical", top, topDir);
                this.dispatchExternal("scrollVertical", top, topDir);
            }
        });
    }
    ////////////////// Row Manipulation //////////////////
    findRow(subject) {
        if (typeof subject == "object") {
            if (subject instanceof $517dee46856d349e$var$Row) //subject is row element
            return subject;
            else if (subject instanceof $517dee46856d349e$export$5df91075f5ba4651) //subject is public row component
            return subject._getSelf() || false;
            else if (typeof HTMLElement !== "undefined" && subject instanceof HTMLElement) {
                //subject is a HTML element of the row
                let match = this.rows.find((row)=>{
                    return row.getElement() === subject;
                });
                return match || false;
            } else if (subject === null) return false;
        } else if (typeof subject == "undefined") return false;
        else {
            //subject should be treated as the index of the row
            let match = this.rows.find((row)=>{
                return row.data[this.table.options.index] == subject;
            });
            return match || false;
        }
        //catch all for any other type of input
        return false;
    }
    getRowFromDataObject(data) {
        var match = this.rows.find((row)=>{
            return row.data === data;
        });
        return match || false;
    }
    getRowFromPosition(position) {
        return this.getDisplayRows().find((row)=>{
            return row.type === "row" && row.getPosition() === position && row.isDisplayed();
        });
    }
    scrollToRow(row, position, ifVisible) {
        return this.renderer.scrollToRowPosition(row, position, ifVisible);
    }
    ////////////////// Data Handling //////////////////
    setData(data, renderInPosition, columnsChanged) {
        return new Promise((resolve, reject)=>{
            if (renderInPosition && this.getDisplayRows().length) {
                if (this.table.options.pagination) this._setDataActual(data, true);
                else this.reRenderInPosition(()=>{
                    this._setDataActual(data);
                });
            } else {
                if (this.table.options.autoColumns && columnsChanged && this.table.initialized) this.table.columnManager.generateColumnsFromRowData(data);
                this.resetScroll();
                this._setDataActual(data);
            }
            resolve();
        });
    }
    _setDataActual(data, renderInPosition) {
        this.dispatchExternal("dataProcessing", data);
        this._wipeElements();
        if (Array.isArray(data)) {
            this.dispatch("data-processing", data);
            data.forEach((def, i)=>{
                if (def && typeof def === "object") {
                    var row = new $517dee46856d349e$var$Row(def, this);
                    this.rows.push(row);
                } else console.warn("Data Loading Warning - Invalid row data detected and ignored, expecting object but received:", def);
            });
            this.refreshActiveData(false, false, renderInPosition);
            this.dispatch("data-processed", data);
            this.dispatchExternal("dataProcessed", data);
        } else console.error("Data Loading Error - Unable to process data due to invalid data type \nExpecting: array \nReceived: ", typeof data, "\nData:     ", data);
    }
    _wipeElements() {
        this.dispatch("rows-wipe");
        this.destroy();
        this.adjustTableSize();
        this.dispatch("rows-wiped");
    }
    destroy() {
        this.rows.forEach((row)=>{
            row.wipe();
        });
        this.rows = [];
        this.activeRows = [];
        this.activeRowsPipeline = [];
        this.activeRowsCount = 0;
        this.displayRows = [];
        this.displayRowsCount = 0;
    }
    deleteRow(row, blockRedraw) {
        var allIndex = this.rows.indexOf(row), activeIndex = this.activeRows.indexOf(row);
        if (activeIndex > -1) this.activeRows.splice(activeIndex, 1);
        if (allIndex > -1) this.rows.splice(allIndex, 1);
        this.setActiveRows(this.activeRows);
        this.displayRowIterator((rows)=>{
            var displayIndex = rows.indexOf(row);
            if (displayIndex > -1) rows.splice(displayIndex, 1);
        });
        if (!blockRedraw) this.reRenderInPosition();
        this.regenerateRowPositions();
        this.dispatchExternal("rowDeleted", row.getComponent());
        if (!this.displayRowsCount) this.tableEmpty();
        if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.getData());
    }
    addRow(data, pos, index, blockRedraw) {
        var row = this.addRowActual(data, pos, index, blockRedraw);
        return row;
    }
    //add multiple rows
    addRows(data, pos, index, refreshDisplayOnly) {
        var rows = [];
        return new Promise((resolve, reject)=>{
            pos = this.findAddRowPos(pos);
            if (!Array.isArray(data)) data = [
                data
            ];
            if (typeof index == "undefined" && pos || typeof index !== "undefined" && !pos) data.reverse();
            data.forEach((item, i)=>{
                var row = this.addRow(item, pos, index, true);
                rows.push(row);
                this.dispatch("row-added", row, item, pos, index);
            });
            this.refreshActiveData(refreshDisplayOnly ? "displayPipeline" : false, false, true);
            this.regenerateRowPositions();
            if (this.displayRowsCount) this._clearPlaceholder();
            resolve(rows);
        });
    }
    findAddRowPos(pos) {
        if (typeof pos === "undefined") pos = this.table.options.addRowPos;
        if (pos === "pos") pos = true;
        if (pos === "bottom") pos = false;
        return pos;
    }
    addRowActual(data, pos, index, blockRedraw) {
        var row = data instanceof $517dee46856d349e$var$Row ? data : new $517dee46856d349e$var$Row(data || {}, this), top = this.findAddRowPos(pos), allIndex = -1, activeIndex, chainResult;
        if (!index) {
            chainResult = this.chain("row-adding-position", [
                row,
                top
            ], null, {
                index: index,
                top: top
            });
            index = chainResult.index;
            top = chainResult.top;
        }
        if (typeof index !== "undefined") index = this.findRow(index);
        index = this.chain("row-adding-index", [
            row,
            index,
            top
        ], null, index);
        if (index) allIndex = this.rows.indexOf(index);
        if (index && allIndex > -1) {
            activeIndex = this.activeRows.indexOf(index);
            this.displayRowIterator(function(rows) {
                var displayIndex = rows.indexOf(index);
                if (displayIndex > -1) rows.splice(top ? displayIndex : displayIndex + 1, 0, row);
            });
            if (activeIndex > -1) this.activeRows.splice(top ? activeIndex : activeIndex + 1, 0, row);
            this.rows.splice(top ? allIndex : allIndex + 1, 0, row);
        } else if (top) {
            this.displayRowIterator(function(rows) {
                rows.unshift(row);
            });
            this.activeRows.unshift(row);
            this.rows.unshift(row);
        } else {
            this.displayRowIterator(function(rows) {
                rows.push(row);
            });
            this.activeRows.push(row);
            this.rows.push(row);
        }
        this.setActiveRows(this.activeRows);
        this.dispatchExternal("rowAdded", row.getComponent());
        if (this.subscribedExternal("dataChanged")) this.dispatchExternal("dataChanged", this.table.rowManager.getData());
        if (!blockRedraw) this.reRenderInPosition();
        return row;
    }
    moveRow(from, to, after) {
        this.dispatch("row-move", from, to, after);
        this.moveRowActual(from, to, after);
        this.regenerateRowPositions();
        this.dispatch("row-moved", from, to, after);
        this.dispatchExternal("rowMoved", from.getComponent());
    }
    moveRowActual(from, to, after) {
        this.moveRowInArray(this.rows, from, to, after);
        this.moveRowInArray(this.activeRows, from, to, after);
        this.displayRowIterator((rows)=>{
            this.moveRowInArray(rows, from, to, after);
        });
        this.dispatch("row-moving", from, to, after);
    }
    moveRowInArray(rows, from, to, after) {
        var fromIndex, toIndex, start, end;
        if (from !== to) {
            fromIndex = rows.indexOf(from);
            if (fromIndex > -1) {
                rows.splice(fromIndex, 1);
                toIndex = rows.indexOf(to);
                if (toIndex > -1) {
                    if (after) rows.splice(toIndex + 1, 0, from);
                    else rows.splice(toIndex, 0, from);
                } else rows.splice(fromIndex, 0, from);
            }
            //restyle rows
            if (rows === this.getDisplayRows()) {
                start = fromIndex < toIndex ? fromIndex : toIndex;
                end = toIndex > fromIndex ? toIndex : fromIndex + 1;
                for(let i = start; i <= end; i++)if (rows[i]) this.styleRow(rows[i], i);
            }
        }
    }
    clearData() {
        this.setData([]);
    }
    getRowIndex(row) {
        return this.findRowIndex(row, this.rows);
    }
    getDisplayRowIndex(row) {
        var index = this.getDisplayRows().indexOf(row);
        return index > -1 ? index : false;
    }
    nextDisplayRow(row, rowOnly) {
        var index = this.getDisplayRowIndex(row), nextRow = false;
        if (index !== false && index < this.displayRowsCount - 1) nextRow = this.getDisplayRows()[index + 1];
        if (nextRow && (!(nextRow instanceof $517dee46856d349e$var$Row) || nextRow.type != "row")) return this.nextDisplayRow(nextRow, rowOnly);
        return nextRow;
    }
    prevDisplayRow(row, rowOnly) {
        var index = this.getDisplayRowIndex(row), prevRow = false;
        if (index) prevRow = this.getDisplayRows()[index - 1];
        if (rowOnly && prevRow && (!(prevRow instanceof $517dee46856d349e$var$Row) || prevRow.type != "row")) return this.prevDisplayRow(prevRow, rowOnly);
        return prevRow;
    }
    findRowIndex(row, list) {
        var rowIndex;
        row = this.findRow(row);
        if (row) {
            rowIndex = list.indexOf(row);
            if (rowIndex > -1) return rowIndex;
        }
        return false;
    }
    getData(active, transform) {
        var output = [], rows = this.getRows(active);
        rows.forEach(function(row) {
            if (row.type == "row") output.push(row.getData(transform || "data"));
        });
        return output;
    }
    getComponents(active) {
        var output = [], rows = this.getRows(active);
        rows.forEach(function(row) {
            output.push(row.getComponent());
        });
        return output;
    }
    getDataCount(active) {
        var rows = this.getRows(active);
        return rows.length;
    }
    scrollHorizontal(left) {
        this.scrollLeft = left;
        this.element.scrollLeft = left;
        this.dispatch("scroll-horizontal", left);
    }
    registerDataPipelineHandler(handler, priority) {
        if (typeof priority !== "undefined") {
            this.dataPipeline.push({
                handler: handler,
                priority: priority
            });
            this.dataPipeline.sort((a, b)=>{
                return a.priority - b.priority;
            });
        } else console.error("Data pipeline handlers must have a priority in order to be registered");
    }
    registerDisplayPipelineHandler(handler, priority) {
        if (typeof priority !== "undefined") {
            this.displayPipeline.push({
                handler: handler,
                priority: priority
            });
            this.displayPipeline.sort((a, b)=>{
                return a.priority - b.priority;
            });
        } else console.error("Display pipeline handlers must have a priority in order to be registered");
    }
    //set active data set
    refreshActiveData(handler, skipStage, renderInPosition) {
        var table = this.table, stage = "", index = 0, cascadeOrder = [
            "all",
            "dataPipeline",
            "display",
            "displayPipeline",
            "end"
        ];
        if (!this.table.destroyed) {
            if (typeof handler === "function") {
                index = this.dataPipeline.findIndex((item)=>{
                    return item.handler === handler;
                });
                if (index > -1) {
                    stage = "dataPipeline";
                    if (skipStage) {
                        if (index == this.dataPipeline.length - 1) stage = "display";
                        else index++;
                    }
                } else {
                    index = this.displayPipeline.findIndex((item)=>{
                        return item.handler === handler;
                    });
                    if (index > -1) {
                        stage = "displayPipeline";
                        if (skipStage) {
                            if (index == this.displayPipeline.length - 1) stage = "end";
                            else index++;
                        }
                    } else {
                        console.error("Unable to refresh data, invalid handler provided", handler);
                        return;
                    }
                }
            } else {
                stage = handler || "all";
                index = 0;
            }
            if (this.redrawBlock) {
                if (!this.redrawBlockRestoreConfig || this.redrawBlockRestoreConfig && (this.redrawBlockRestoreConfig.stage === stage && index < this.redrawBlockRestoreConfig.index || cascadeOrder.indexOf(stage) < cascadeOrder.indexOf(this.redrawBlockRestoreConfig.stage))) this.redrawBlockRestoreConfig = {
                    handler: handler,
                    skipStage: skipStage,
                    renderInPosition: renderInPosition,
                    stage: stage,
                    index: index
                };
                return;
            } else {
                if ($517dee46856d349e$var$Helpers.elVisible(this.element)) {
                    if (renderInPosition) this.reRenderInPosition(this.refreshPipelines.bind(this, handler, stage, index, renderInPosition));
                    else {
                        this.refreshPipelines(handler, stage, index, renderInPosition);
                        if (!handler) this.table.columnManager.renderer.renderColumns();
                        this.renderTable();
                        if (table.options.layoutColumnsOnNewData) this.table.columnManager.redraw(true);
                    }
                } else this.refreshPipelines(handler, stage, index, renderInPosition);
                this.dispatch("data-refreshed");
            }
        }
    }
    refreshPipelines(handler, stage, index, renderInPosition) {
        this.dispatch("data-refreshing");
        if (!handler || !this.activeRowsPipeline[0]) this.activeRowsPipeline[0] = this.rows.slice(0);
        //cascade through data refresh stages
        switch(stage){
            case "all":
            //handle case where all data needs refreshing
            case "dataPipeline":
                for(let i = index; i < this.dataPipeline.length; i++){
                    let result = this.dataPipeline[i].handler(this.activeRowsPipeline[i].slice(0));
                    this.activeRowsPipeline[i + 1] = result || this.activeRowsPipeline[i].slice(0);
                }
                this.setActiveRows(this.activeRowsPipeline[this.dataPipeline.length]);
            case "display":
                index = 0;
                this.resetDisplayRows();
            case "displayPipeline":
                for(let i = index; i < this.displayPipeline.length; i++){
                    let result = this.displayPipeline[i].handler((i ? this.getDisplayRows(i - 1) : this.activeRows).slice(0), renderInPosition);
                    this.setDisplayRows(result || this.getDisplayRows(i - 1).slice(0), i);
                }
            case "end":
                //case to handle scenario when trying to skip past end stage
                this.regenerateRowPositions();
        }
        if (this.getDisplayRows().length) this._clearPlaceholder();
    }
    //regenerate row positions
    regenerateRowPositions() {
        var rows = this.getDisplayRows();
        var index = 1;
        rows.forEach((row)=>{
            if (row.type === "row") {
                row.setPosition(index);
                index++;
            }
        });
    }
    setActiveRows(activeRows) {
        this.activeRows = this.activeRows = Object.assign([], activeRows);
        this.activeRowsCount = this.activeRows.length;
    }
    //reset display rows array
    resetDisplayRows() {
        this.displayRows = [];
        this.displayRows.push(this.activeRows.slice(0));
        this.displayRowsCount = this.displayRows[0].length;
    }
    //set display row pipeline data
    setDisplayRows(displayRows, index) {
        this.displayRows[index] = displayRows;
        if (index == this.displayRows.length - 1) this.displayRowsCount = this.displayRows[this.displayRows.length - 1].length;
    }
    getDisplayRows(index) {
        if (typeof index == "undefined") return this.displayRows.length ? this.displayRows[this.displayRows.length - 1] : [];
        else return this.displayRows[index] || [];
    }
    getVisibleRows(chain, viewable) {
        var rows = Object.assign([], this.renderer.visibleRows(!viewable));
        if (chain) rows = this.chain("rows-visible", [
            viewable
        ], rows, rows);
        return rows;
    }
    //repeat action across display rows
    displayRowIterator(callback) {
        this.activeRowsPipeline.forEach(callback);
        this.displayRows.forEach(callback);
        this.displayRowsCount = this.displayRows[this.displayRows.length - 1].length;
    }
    //return only actual rows (not group headers etc)
    getRows(type) {
        var rows = [];
        switch(type){
            case "active":
                rows = this.activeRows;
                break;
            case "display":
                rows = this.table.rowManager.getDisplayRows();
                break;
            case "visible":
                rows = this.getVisibleRows(false, true);
                break;
            default:
                rows = this.chain("rows-retrieve", type, null, this.rows) || this.rows;
        }
        return rows;
    }
    ///////////////// Table Rendering /////////////////
    //trigger rerender of table in current position
    reRenderInPosition(callback) {
        if (this.redrawBlock) {
            if (callback) callback();
            else this.redrawBlockRenderInPosition = true;
        } else {
            this.dispatchExternal("renderStarted");
            this.renderer.rerenderRows(callback);
            if (!this.fixedHeight) this.adjustTableSize();
            this.scrollBarCheck();
            this.dispatchExternal("renderComplete");
        }
    }
    scrollBarCheck() {
        var scrollbarWidth = 0;
        //adjust for vertical scrollbar moving table when present
        if (this.element.scrollHeight > this.element.clientHeight) scrollbarWidth = this.element.offsetWidth - this.element.clientWidth;
        if (scrollbarWidth !== this.scrollbarWidth) {
            this.scrollbarWidth = scrollbarWidth;
            this.dispatch("scrollbar-vertical", scrollbarWidth);
        }
    }
    initializeRenderer() {
        var renderClass;
        var renderers = {
            "virtual": $517dee46856d349e$var$VirtualDomVertical,
            "basic": $517dee46856d349e$var$BasicVertical
        };
        if (typeof this.table.options.renderVertical === "string") renderClass = renderers[this.table.options.renderVertical];
        else renderClass = this.table.options.renderVertical;
        if (renderClass) {
            this.renderMode = this.table.options.renderVertical;
            this.renderer = new renderClass(this.table, this.element, this.tableElement);
            this.renderer.initialize();
            if ((this.table.element.clientHeight || this.table.options.height) && !(this.table.options.minHeight && this.table.options.maxHeight)) this.fixedHeight = true;
            else this.fixedHeight = false;
        } else console.error("Unable to find matching renderer:", this.table.options.renderVertical);
    }
    getRenderMode() {
        return this.renderMode;
    }
    renderTable() {
        this.dispatchExternal("renderStarted");
        this.element.scrollTop = 0;
        this._clearTable();
        if (this.displayRowsCount) {
            this.renderer.renderRows();
            if (this.firstRender) {
                this.firstRender = false;
                if (!this.fixedHeight) this.adjustTableSize();
                this.layoutRefresh(true);
            }
        } else this.renderEmptyScroll();
        if (!this.fixedHeight) this.adjustTableSize();
        this.dispatch("table-layout");
        if (!this.displayRowsCount) this._showPlaceholder();
        this.scrollBarCheck();
        this.dispatchExternal("renderComplete");
    }
    //show scrollbars on empty table div
    renderEmptyScroll() {
        if (this.placeholder) this.tableElement.style.display = "none";
        else this.tableElement.style.minWidth = this.table.columnManager.getWidth() + "px";
    }
    _clearTable() {
        this._clearPlaceholder();
        this.scrollTop = 0;
        this.scrollLeft = 0;
        this.renderer.clearRows();
    }
    tableEmpty() {
        this.renderEmptyScroll();
        this._showPlaceholder();
    }
    checkPlaceholder() {
        if (this.displayRowsCount) this._clearPlaceholder();
        else this.tableEmpty();
    }
    _showPlaceholder() {
        if (this.placeholder) {
            if (this.placeholder && this.placeholder.parentNode) this.placeholder.parentNode.removeChild(this.placeholder);
            this.initializePlaceholder();
            this.placeholder.setAttribute("tabulator-render-mode", this.renderMode);
            this.getElement().appendChild(this.placeholder);
            this._positionPlaceholder();
            this.adjustTableSize();
        }
    }
    _clearPlaceholder() {
        if (this.placeholder && this.placeholder.parentNode) this.placeholder.parentNode.removeChild(this.placeholder);
        // clear empty table placeholder min
        this.tableElement.style.minWidth = "";
        this.tableElement.style.display = "";
    }
    _positionPlaceholder() {
        if (this.placeholder && this.placeholder.parentNode) {
            this.placeholder.style.width = this.table.columnManager.getWidth() + "px";
            this.placeholderContents.style.width = this.table.rowManager.element.clientWidth + "px";
            this.placeholderContents.style.marginLeft = this.scrollLeft + "px";
        }
    }
    styleRow(row, index) {
        var rowEl = row.getElement();
        if (index % 2) {
            rowEl.classList.add("tabulator-row-even");
            rowEl.classList.remove("tabulator-row-odd");
        } else {
            rowEl.classList.add("tabulator-row-odd");
            rowEl.classList.remove("tabulator-row-even");
        }
    }
    //normalize height of active rows
    normalizeHeight(force) {
        this.activeRows.forEach(function(row) {
            row.normalizeHeight(force);
        });
    }
    //adjust the height of the table holder to fit in the Tabulator element
    adjustTableSize() {
        let initialHeight = this.element.clientHeight, minHeight;
        let resized = false;
        if (this.renderer.verticalFillMode === "fill") {
            let otherHeight = Math.floor(this.table.columnManager.getElement().getBoundingClientRect().height + (this.table.footerManager && this.table.footerManager.active && !this.table.footerManager.external ? this.table.footerManager.getElement().getBoundingClientRect().height : 0));
            if (this.fixedHeight) {
                minHeight = isNaN(this.table.options.minHeight) ? this.table.options.minHeight : this.table.options.minHeight + "px";
                const height = "calc(100% - " + otherHeight + "px)";
                this.element.style.minHeight = minHeight || "calc(100% - " + otherHeight + "px)";
                this.element.style.height = height;
                this.element.style.maxHeight = height;
            } else {
                this.element.style.height = "";
                this.element.style.height = this.table.element.clientHeight - otherHeight + "px";
                this.element.scrollTop = this.scrollTop;
            }
            this.renderer.resize();
            //check if the table has changed size when dealing with variable height tables
            if (!this.fixedHeight && initialHeight != this.element.clientHeight) {
                resized = true;
                if (this.subscribed("table-resize")) this.dispatch("table-resize");
                else this.redraw();
            }
            this.scrollBarCheck();
        }
        this._positionPlaceholder();
        return resized;
    }
    //reinitialize all rows
    reinitialize() {
        this.rows.forEach(function(row) {
            row.reinitialize(true);
        });
    }
    //prevent table from being redrawn
    blockRedraw() {
        this.redrawBlock = true;
        this.redrawBlockRestoreConfig = false;
    }
    //restore table redrawing
    restoreRedraw() {
        this.redrawBlock = false;
        if (this.redrawBlockRestoreConfig) {
            this.refreshActiveData(this.redrawBlockRestoreConfig.handler, this.redrawBlockRestoreConfig.skipStage, this.redrawBlockRestoreConfig.renderInPosition);
            this.redrawBlockRestoreConfig = false;
        } else if (this.redrawBlockRenderInPosition) this.reRenderInPosition();
        this.redrawBlockRenderInPosition = false;
    }
    //redraw table
    redraw(force) {
        this.adjustTableSize();
        this.table.tableWidth = this.table.element.clientWidth;
        if (!force) {
            this.reRenderInPosition();
            this.scrollHorizontal(this.scrollLeft);
        } else this.renderTable();
    }
    resetScroll() {
        this.element.scrollLeft = 0;
        this.element.scrollTop = 0;
        if (this.table.browser === "ie") {
            var event = document.createEvent("Event");
            event.initEvent("scroll", false, true);
            this.element.dispatchEvent(event);
        } else this.element.dispatchEvent(new Event('scroll'));
    }
}
class $517dee46856d349e$var$FooterManager extends $517dee46856d349e$var$CoreFeature {
    constructor(table){
        super(table);
        this.active = false;
        this.element = this.createElement(); //containing element
        this.containerElement = this.createContainerElement(); //containing element
        this.external = false;
    }
    initialize() {
        this.initializeElement();
    }
    createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-footer");
        return el;
    }
    createContainerElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-footer-contents");
        this.element.appendChild(el);
        return el;
    }
    initializeElement() {
        if (this.table.options.footerElement) switch(typeof this.table.options.footerElement){
            case "string":
                if (this.table.options.footerElement[0] === "<") this.containerElement.innerHTML = this.table.options.footerElement;
                else {
                    this.external = true;
                    this.containerElement = document.querySelector(this.table.options.footerElement);
                }
                break;
            default:
                this.element = this.table.options.footerElement;
                break;
        }
    }
    getElement() {
        return this.element;
    }
    append(element) {
        this.activate();
        this.containerElement.appendChild(element);
        this.table.rowManager.adjustTableSize();
    }
    prepend(element) {
        this.activate();
        this.element.insertBefore(element, this.element.firstChild);
        this.table.rowManager.adjustTableSize();
    }
    remove(element) {
        element.parentNode.removeChild(element);
        this.deactivate();
    }
    deactivate(force) {
        if (!this.element.firstChild || force) {
            if (!this.external) this.element.parentNode.removeChild(this.element);
            this.active = false;
        }
    }
    activate() {
        if (!this.active) {
            this.active = true;
            if (!this.external) {
                this.table.element.appendChild(this.getElement());
                this.table.element.style.display = '';
            }
        }
    }
    redraw() {
        this.dispatch("footer-redraw");
    }
}
class $517dee46856d349e$var$InteractionManager extends $517dee46856d349e$var$CoreFeature {
    constructor(table){
        super(table);
        this.el = null;
        this.abortClasses = [
            "tabulator-headers",
            "tabulator-table"
        ];
        this.previousTargets = {};
        this.listeners = [
            "click",
            "dblclick",
            "contextmenu",
            "mouseenter",
            "mouseleave",
            "mouseover",
            "mouseout",
            "mousemove",
            "mouseup",
            "mousedown",
            "touchstart",
            "touchend"
        ];
        this.componentMap = {
            "tabulator-cell": "cell",
            "tabulator-row": "row",
            "tabulator-group": "group",
            "tabulator-col": "column"
        };
        this.pseudoTrackers = {
            "row": {
                subscriber: null,
                target: null
            },
            "cell": {
                subscriber: null,
                target: null
            },
            "group": {
                subscriber: null,
                target: null
            },
            "column": {
                subscriber: null,
                target: null
            }
        };
        this.pseudoTracking = false;
    }
    initialize() {
        this.el = this.table.element;
        this.buildListenerMap();
        this.bindSubscriptionWatchers();
    }
    buildListenerMap() {
        var listenerMap = {};
        this.listeners.forEach((listener)=>{
            listenerMap[listener] = {
                handler: null,
                components: []
            };
        });
        this.listeners = listenerMap;
    }
    bindPseudoEvents() {
        Object.keys(this.pseudoTrackers).forEach((key)=>{
            this.pseudoTrackers[key].subscriber = this.pseudoMouseEnter.bind(this, key);
            this.subscribe(key + "-mouseover", this.pseudoTrackers[key].subscriber);
        });
        this.pseudoTracking = true;
    }
    pseudoMouseEnter(key, e, target) {
        if (this.pseudoTrackers[key].target !== target) {
            if (this.pseudoTrackers[key].target) this.dispatch(key + "-mouseleave", e, this.pseudoTrackers[key].target);
            this.pseudoMouseLeave(key, e);
            this.pseudoTrackers[key].target = target;
            this.dispatch(key + "-mouseenter", e, target);
        }
    }
    pseudoMouseLeave(key, e) {
        var leaveList = Object.keys(this.pseudoTrackers), linkedKeys = {
            "row": [
                "cell"
            ],
            "cell": [
                "row"
            ]
        };
        leaveList = leaveList.filter((item)=>{
            var links = linkedKeys[key];
            return item !== key && (!links || links && !links.includes(item));
        });
        leaveList.forEach((key)=>{
            var target = this.pseudoTrackers[key].target;
            if (this.pseudoTrackers[key].target) {
                this.dispatch(key + "-mouseleave", e, target);
                this.pseudoTrackers[key].target = null;
            }
        });
    }
    bindSubscriptionWatchers() {
        var listeners = Object.keys(this.listeners), components = Object.values(this.componentMap);
        for (let comp of components)for (let listener of listeners){
            let key = comp + "-" + listener;
            this.subscriptionChange(key, this.subscriptionChanged.bind(this, comp, listener));
        }
        this.subscribe("table-destroy", this.clearWatchers.bind(this));
    }
    subscriptionChanged(component, key, added) {
        var listener = this.listeners[key].components, index = listener.indexOf(component), changed = false;
        if (added) {
            if (index === -1) {
                listener.push(component);
                changed = true;
            }
        } else {
            if (!this.subscribed(component + "-" + key)) {
                if (index > -1) {
                    listener.splice(index, 1);
                    changed = true;
                }
            }
        }
        if ((key === "mouseenter" || key === "mouseleave") && !this.pseudoTracking) this.bindPseudoEvents();
        if (changed) this.updateEventListeners();
    }
    updateEventListeners() {
        for(let key in this.listeners){
            let listener = this.listeners[key];
            if (listener.components.length) {
                if (!listener.handler) {
                    listener.handler = this.track.bind(this, key);
                    this.el.addEventListener(key, listener.handler);
                // this.el.addEventListener(key, listener.handler, {passive: true})
                }
            } else if (listener.handler) {
                this.el.removeEventListener(key, listener.handler);
                listener.handler = null;
            }
        }
    }
    track(type, e) {
        var path = e.composedPath && e.composedPath() || e.path;
        var targets = this.findTargets(path);
        targets = this.bindComponents(type, targets);
        this.triggerEvents(type, e, targets);
        if (this.pseudoTracking && (type == "mouseover" || type == "mouseleave") && !Object.keys(targets).length) this.pseudoMouseLeave("none", e);
    }
    findTargets(path) {
        var targets = {};
        let componentMap = Object.keys(this.componentMap);
        for (let el of path){
            let classList = el.classList ? [
                ...el.classList
            ] : [];
            let abort = classList.filter((item)=>{
                return this.abortClasses.includes(item);
            });
            if (abort.length) break;
            let elTargets = classList.filter((item)=>{
                return componentMap.includes(item);
            });
            for (let target of elTargets)if (!targets[this.componentMap[target]]) targets[this.componentMap[target]] = el;
        }
        if (targets.group && targets.group === targets.row) delete targets.row;
        return targets;
    }
    bindComponents(type, targets) {
        //ensure row component is looked up before cell
        var keys = Object.keys(targets).reverse(), listener = this.listeners[type], matches = {}, output = {}, targetMatches = {};
        for (let key of keys){
            let component, target = targets[key], previousTarget = this.previousTargets[key];
            if (previousTarget && previousTarget.target === target) component = previousTarget.component;
            else switch(key){
                case "row":
                case "group":
                    if (listener.components.includes("row") || listener.components.includes("cell") || listener.components.includes("group")) {
                        let rows = this.table.rowManager.getVisibleRows(true);
                        component = rows.find((row)=>{
                            return row.getElement() === target;
                        });
                        if (targets["row"] && targets["row"].parentNode && targets["row"].parentNode.closest(".tabulator-row")) targets[key] = false;
                    }
                    break;
                case "column":
                    if (listener.components.includes("column")) component = this.table.columnManager.findColumn(target);
                    break;
                case "cell":
                    if (listener.components.includes("cell")) {
                        if (matches["row"] instanceof $517dee46856d349e$var$Row) component = matches["row"].findCell(target);
                        else if (targets["row"]) console.warn("Event Target Lookup Error - The row this cell is attached to cannot be found, has the table been reinitialized without being destroyed first?");
                    }
                    break;
            }
            if (component) {
                matches[key] = component;
                targetMatches[key] = {
                    target: target,
                    component: component
                };
            }
        }
        this.previousTargets = targetMatches;
        //reverse order keys are set in so events trigger in correct sequence
        Object.keys(targets).forEach((key)=>{
            let value = matches[key];
            output[key] = value;
        });
        return output;
    }
    triggerEvents(type, e, targets) {
        var listener = this.listeners[type];
        for(let key in targets)if (targets[key] && listener.components.includes(key)) this.dispatch(key + "-" + type, e, targets[key]);
    }
    clearWatchers() {
        for(let key in this.listeners){
            let listener = this.listeners[key];
            if (listener.handler) {
                this.el.removeEventListener(key, listener.handler);
                listener.handler = null;
            }
        }
    }
}
class $517dee46856d349e$var$ComponentFunctionBinder {
    constructor(table){
        this.table = table;
        this.bindings = {};
    }
    bind(type, funcName, handler) {
        if (!this.bindings[type]) this.bindings[type] = {};
        if (this.bindings[type][funcName]) console.warn("Unable to bind component handler, a matching function name is already bound", type, funcName, handler);
        else this.bindings[type][funcName] = handler;
    }
    handle(type, component, name) {
        if (this.bindings[type] && this.bindings[type][name] && typeof this.bindings[type][name].bind === 'function') return this.bindings[type][name].bind(null, component);
        else {
            if (name !== "then" && typeof name === "string" && !name.startsWith("_")) {
                if (this.table.options.debugInvalidComponentFuncs) console.error("The " + type + " component does not have a " + name + " function, have you checked that you have the correct Tabulator module installed?");
            }
        }
    }
}
class $517dee46856d349e$var$DataLoader extends $517dee46856d349e$var$CoreFeature {
    constructor(table){
        super(table);
        this.requestOrder = 0; //prevent requests coming out of sequence if overridden by another load request
        this.loading = false;
    }
    initialize() {}
    load(data, params, config, replace, silent, columnsChanged) {
        var requestNo = ++this.requestOrder;
        if (this.table.destroyed) return Promise.resolve();
        this.dispatchExternal("dataLoading", data);
        //parse json data to array
        if (data && (data.indexOf("{") == 0 || data.indexOf("[") == 0)) data = JSON.parse(data);
        if (this.confirm("data-loading", [
            data,
            params,
            config,
            silent
        ])) {
            this.loading = true;
            if (!silent) this.alertLoader();
            //get params for request
            params = this.chain("data-params", [
                data,
                config,
                silent
            ], params || {}, params || {});
            params = this.mapParams(params, this.table.options.dataSendParams);
            var result = this.chain("data-load", [
                data,
                params,
                config,
                silent
            ], false, Promise.resolve([]));
            return result.then((response)=>{
                if (!this.table.destroyed) {
                    if (!Array.isArray(response) && typeof response == "object") response = this.mapParams(response, this.objectInvert(this.table.options.dataReceiveParams));
                    var rowData = this.chain("data-loaded", [
                        response
                    ], null, response);
                    if (requestNo == this.requestOrder) {
                        this.clearAlert();
                        if (rowData !== false) {
                            this.dispatchExternal("dataLoaded", rowData);
                            this.table.rowManager.setData(rowData, replace, typeof columnsChanged === "undefined" ? !replace : columnsChanged);
                        }
                    } else console.warn("Data Load Response Blocked - An active data load request was blocked by an attempt to change table data while the request was being made");
                } else console.warn("Data Load Response Blocked - Table has been destroyed");
            }).catch((error)=>{
                console.error("Data Load Error: ", error);
                this.dispatchExternal("dataLoadError", error);
                if (!silent) this.alertError();
                setTimeout(()=>{
                    this.clearAlert();
                }, this.table.options.dataLoaderErrorTimeout);
            }).finally(()=>{
                this.loading = false;
            });
        } else {
            this.dispatchExternal("dataLoaded", data);
            if (!data) data = [];
            this.table.rowManager.setData(data, replace, typeof columnsChanged === "undefined" ? !replace : columnsChanged);
            return Promise.resolve();
        }
    }
    mapParams(params, map) {
        var output = {};
        for(let key in params)output[map.hasOwnProperty(key) ? map[key] : key] = params[key];
        return output;
    }
    objectInvert(obj) {
        var output = {};
        for(let key in obj)output[obj[key]] = key;
        return output;
    }
    blockActiveLoad() {
        this.requestOrder++;
    }
    alertLoader() {
        var shouldLoad = typeof this.table.options.dataLoader === "function" ? this.table.options.dataLoader() : this.table.options.dataLoader;
        if (shouldLoad) this.table.alertManager.alert(this.table.options.dataLoaderLoading || this.langText("data|loading"));
    }
    alertError() {
        this.table.alertManager.alert(this.table.options.dataLoaderError || this.langText("data|error"), "error");
    }
    clearAlert() {
        this.table.alertManager.clear();
    }
}
class $517dee46856d349e$var$ExternalEventBus {
    constructor(table, optionsList, debug){
        this.table = table;
        this.events = {};
        this.optionsList = optionsList || {};
        this.subscriptionNotifiers = {};
        this.dispatch = debug ? this._debugDispatch.bind(this) : this._dispatch.bind(this);
        this.debug = debug;
    }
    subscriptionChange(key, callback) {
        if (!this.subscriptionNotifiers[key]) this.subscriptionNotifiers[key] = [];
        this.subscriptionNotifiers[key].push(callback);
        if (this.subscribed(key)) this._notifySubscriptionChange(key, true);
    }
    subscribe(key, callback) {
        if (!this.events[key]) this.events[key] = [];
        this.events[key].push(callback);
        this._notifySubscriptionChange(key, true);
    }
    unsubscribe(key, callback) {
        var index;
        if (this.events[key]) {
            if (callback) {
                index = this.events[key].findIndex((item)=>{
                    return item === callback;
                });
                if (index > -1) this.events[key].splice(index, 1);
                else {
                    console.warn("Cannot remove event, no matching event found:", key, callback);
                    return;
                }
            } else delete this.events[key];
        } else {
            console.warn("Cannot remove event, no events set on:", key);
            return;
        }
        this._notifySubscriptionChange(key, false);
    }
    subscribed(key) {
        return this.events[key] && this.events[key].length;
    }
    _notifySubscriptionChange(key, subscribed) {
        var notifiers = this.subscriptionNotifiers[key];
        if (notifiers) notifiers.forEach((callback)=>{
            callback(subscribed);
        });
    }
    _dispatch() {
        var args = Array.from(arguments), key = args.shift(), result;
        if (this.events[key]) this.events[key].forEach((callback, i)=>{
            let callResult = callback.apply(this.table, args);
            if (!i) result = callResult;
        });
        return result;
    }
    _debugDispatch() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "ExternalEvent:" + args[0];
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._dispatch(...arguments);
    }
}
class $517dee46856d349e$var$InternalEventBus {
    constructor(debug){
        this.events = {};
        this.subscriptionNotifiers = {};
        this.dispatch = debug ? this._debugDispatch.bind(this) : this._dispatch.bind(this);
        this.chain = debug ? this._debugChain.bind(this) : this._chain.bind(this);
        this.confirm = debug ? this._debugConfirm.bind(this) : this._confirm.bind(this);
        this.debug = debug;
    }
    subscriptionChange(key, callback) {
        if (!this.subscriptionNotifiers[key]) this.subscriptionNotifiers[key] = [];
        this.subscriptionNotifiers[key].push(callback);
        if (this.subscribed(key)) this._notifySubscriptionChange(key, true);
    }
    subscribe(key, callback, priority = 10000) {
        if (!this.events[key]) this.events[key] = [];
        this.events[key].push({
            callback: callback,
            priority: priority
        });
        this.events[key].sort((a, b)=>{
            return a.priority - b.priority;
        });
        this._notifySubscriptionChange(key, true);
    }
    unsubscribe(key, callback) {
        var index;
        if (this.events[key]) {
            if (callback) {
                index = this.events[key].findIndex((item)=>{
                    return item.callback === callback;
                });
                if (index > -1) this.events[key].splice(index, 1);
                else {
                    console.warn("Cannot remove event, no matching event found:", key, callback);
                    return;
                }
            }
        } else {
            console.warn("Cannot remove event, no events set on:", key);
            return;
        }
        this._notifySubscriptionChange(key, false);
    }
    subscribed(key) {
        return this.events[key] && this.events[key].length;
    }
    _chain(key, args, initialValue, fallback) {
        var value = initialValue;
        if (!Array.isArray(args)) args = [
            args
        ];
        if (this.subscribed(key)) {
            this.events[key].forEach((subscriber, i)=>{
                value = subscriber.callback.apply(this, args.concat([
                    value
                ]));
            });
            return value;
        } else return typeof fallback === "function" ? fallback() : fallback;
    }
    _confirm(key, args) {
        var confirmed = false;
        if (!Array.isArray(args)) args = [
            args
        ];
        if (this.subscribed(key)) this.events[key].forEach((subscriber, i)=>{
            if (subscriber.callback.apply(this, args)) confirmed = true;
        });
        return confirmed;
    }
    _notifySubscriptionChange(key, subscribed) {
        var notifiers = this.subscriptionNotifiers[key];
        if (notifiers) notifiers.forEach((callback)=>{
            callback(subscribed);
        });
    }
    _dispatch() {
        var args = Array.from(arguments), key = args.shift();
        if (this.events[key]) this.events[key].forEach((subscriber)=>{
            subscriber.callback.apply(this, args);
        });
    }
    _debugDispatch() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "InternalEvent:" + key;
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._dispatch(...arguments);
    }
    _debugChain() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "InternalEvent:" + key;
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._chain(...arguments);
    }
    _debugConfirm() {
        var args = Array.from(arguments), key = args[0];
        args[0] = "InternalEvent:" + key;
        if (this.debug === true || this.debug.includes(key)) console.log(...args);
        return this._confirm(...arguments);
    }
}
class $517dee46856d349e$var$DeprecationAdvisor extends $517dee46856d349e$var$CoreFeature {
    constructor(table){
        super(table);
    }
    _warnUser() {
        if (this.options("debugDeprecation")) console.warn(...arguments);
    }
    check(oldOption, newOption, convert) {
        var msg = "";
        if (typeof this.options(oldOption) !== "undefined") {
            msg = "Deprecated Setup Option - Use of the %c" + oldOption + "%c option is now deprecated";
            if (newOption) {
                msg = msg + ", Please use the %c" + newOption + "%c option instead";
                this._warnUser(msg, 'font-weight: bold;', 'font-weight: normal;', 'font-weight: bold;', 'font-weight: normal;');
                if (convert) this.table.options[newOption] = this.table.options[oldOption];
            } else this._warnUser(msg, 'font-weight: bold;', 'font-weight: normal;');
            return false;
        } else return true;
    }
    checkMsg(oldOption, msg) {
        if (typeof this.options(oldOption) !== "undefined") {
            this._warnUser("%cDeprecated Setup Option - Use of the %c" + oldOption + " %c option is now deprecated, " + msg, 'font-weight: normal;', 'font-weight: bold;', 'font-weight: normal;');
            return false;
        } else return true;
    }
    msg(msg) {
        this._warnUser(msg);
    }
}
class $517dee46856d349e$var$DependencyRegistry extends $517dee46856d349e$var$CoreFeature {
    constructor(table){
        super(table);
        this.deps = {};
        this.props = {};
    }
    initialize() {
        this.deps = Object.assign({}, this.options("dependencies"));
    }
    lookup(key, prop, silent) {
        if (Array.isArray(key)) {
            for (const item of key){
                var match = this.lookup(item, prop, true);
                if (match) break;
            }
            if (match) return match;
            else this.error(key);
        } else {
            if (prop) return this.lookupProp(key, prop, silent);
            else return this.lookupKey(key, silent);
        }
    }
    lookupProp(key, prop, silent) {
        var dependency;
        if (this.props[key] && this.props[key][prop]) return this.props[key][prop];
        else {
            dependency = this.lookupKey(key, silent);
            if (dependency) {
                if (!this.props[key]) this.props[key] = {};
                this.props[key][prop] = dependency[prop] || dependency;
                return this.props[key][prop];
            }
        }
    }
    lookupKey(key, silent) {
        var dependency;
        if (this.deps[key]) dependency = this.deps[key];
        else if (window[key]) {
            this.deps[key] = window[key];
            dependency = this.deps[key];
        } else if (!silent) this.error(key);
        return dependency;
    }
    error(key) {
        console.error("Unable to find dependency", key, "Please check documentation and ensure you have imported the required library into your project");
    }
}
//resize columns to fit data they contain
function $517dee46856d349e$var$fitData(columns, forced) {
    if (forced) this.table.columnManager.renderer.reinitializeColumnWidths(columns);
    if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
}
//resize columns to fit data they contain and stretch row to fill table, also used for fitDataTable
function $517dee46856d349e$var$fitDataGeneral(columns, forced) {
    columns.forEach(function(column) {
        column.reinitializeWidth();
    });
    if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
}
//resize columns to fit data the contain and stretch last column to fill table
function $517dee46856d349e$var$fitDataStretch(columns, forced) {
    var colsWidth = 0, tableWidth = this.table.rowManager.element.clientWidth, gap = 0, lastCol = false;
    columns.forEach((column, i)=>{
        if (!column.widthFixed) column.reinitializeWidth();
        if (this.table.options.responsiveLayout ? column.modules.responsive.visible : column.visible) lastCol = column;
        if (column.visible) colsWidth += column.getWidth();
    });
    if (lastCol) {
        gap = tableWidth - colsWidth + lastCol.getWidth();
        if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) {
            lastCol.setWidth(0);
            this.table.modules.responsiveLayout.update();
        }
        if (gap > 0) lastCol.setWidth(gap);
        else lastCol.reinitializeWidth();
    } else if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
}
//resize columns to fit
function $517dee46856d349e$var$fitColumns(columns, forced) {
    var totalWidth = this.table.rowManager.element.getBoundingClientRect().width; //table element width
    var fixedWidth = 0; //total width of columns with a defined width
    var flexWidth = 0; //total width available to flexible columns
    var flexGrowUnits = 0; //total number of widthGrow blocks across all columns
    var flexColWidth = 0; //desired width of flexible columns
    var flexColumns = []; //array of flexible width columns
    var fixedShrinkColumns = []; //array of fixed width columns that can shrink
    var flexShrinkUnits = 0; //total number of widthShrink blocks across all columns
    var overflowWidth = 0; //horizontal overflow width
    var gapFill = 0; //number of pixels to be added to final column to close and half pixel gaps
    function calcWidth(width) {
        var colWidth;
        if (typeof width == "string") {
            if (width.indexOf("%") > -1) colWidth = totalWidth / 100 * parseInt(width);
            else colWidth = parseInt(width);
        } else colWidth = width;
        return colWidth;
    }
    //ensure columns resize to take up the correct amount of space
    function scaleColumns(columns, freeSpace, colWidth, shrinkCols) {
        var oversizeCols = [], oversizeSpace = 0, remainingSpace = 0, nextColWidth = 0, remainingFlexGrowUnits = flexGrowUnits, gap = 0, changeUnits = 0, undersizeCols = [];
        function calcGrow(col) {
            return colWidth * (col.column.definition.widthGrow || 1);
        }
        function calcShrink(col) {
            return calcWidth(col.width) - colWidth * (col.column.definition.widthShrink || 0);
        }
        columns.forEach(function(col, i) {
            var width = shrinkCols ? calcShrink(col) : calcGrow(col);
            if (col.column.minWidth >= width) oversizeCols.push(col);
            else if (col.column.maxWidth && col.column.maxWidth < width) {
                col.width = col.column.maxWidth;
                freeSpace -= col.column.maxWidth;
                remainingFlexGrowUnits -= shrinkCols ? col.column.definition.widthShrink || 1 : col.column.definition.widthGrow || 1;
                if (remainingFlexGrowUnits) colWidth = Math.floor(freeSpace / remainingFlexGrowUnits);
            } else {
                undersizeCols.push(col);
                changeUnits += shrinkCols ? col.column.definition.widthShrink || 1 : col.column.definition.widthGrow || 1;
            }
        });
        if (oversizeCols.length) {
            oversizeCols.forEach(function(col) {
                oversizeSpace += shrinkCols ? col.width - col.column.minWidth : col.column.minWidth;
                col.width = col.column.minWidth;
            });
            remainingSpace = freeSpace - oversizeSpace;
            nextColWidth = changeUnits ? Math.floor(remainingSpace / changeUnits) : remainingSpace;
            gap = scaleColumns(undersizeCols, remainingSpace, nextColWidth, shrinkCols);
        } else {
            gap = changeUnits ? freeSpace - Math.floor(freeSpace / changeUnits) * changeUnits : freeSpace;
            undersizeCols.forEach(function(column) {
                column.width = shrinkCols ? calcShrink(column) : calcGrow(column);
            });
        }
        return gap;
    }
    if (this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", true)) this.table.modules.responsiveLayout.update();
    //adjust for vertical scrollbar if present
    if (this.table.rowManager.element.scrollHeight > this.table.rowManager.element.clientHeight) totalWidth -= this.table.rowManager.element.offsetWidth - this.table.rowManager.element.clientWidth;
    columns.forEach(function(column) {
        var width, minWidth, colWidth;
        if (column.visible) {
            width = column.definition.width;
            minWidth = parseInt(column.minWidth);
            if (width) {
                colWidth = calcWidth(width);
                fixedWidth += colWidth > minWidth ? colWidth : minWidth;
                if (column.definition.widthShrink) {
                    fixedShrinkColumns.push({
                        column: column,
                        width: colWidth > minWidth ? colWidth : minWidth
                    });
                    flexShrinkUnits += column.definition.widthShrink;
                }
            } else {
                flexColumns.push({
                    column: column,
                    width: 0
                });
                flexGrowUnits += column.definition.widthGrow || 1;
            }
        }
    });
    //calculate available space
    flexWidth = totalWidth - fixedWidth;
    //calculate correct column size
    flexColWidth = Math.floor(flexWidth / flexGrowUnits);
    //generate column widths
    gapFill = scaleColumns(flexColumns, flexWidth, flexColWidth, false);
    //increase width of last column to account for rounding errors
    if (flexColumns.length && gapFill > 0) flexColumns[flexColumns.length - 1].width += gapFill;
    //calculate space for columns to be shrunk into
    flexColumns.forEach(function(col) {
        flexWidth -= col.width;
    });
    overflowWidth = Math.abs(gapFill) + flexWidth;
    //shrink oversize columns if there is no available space
    if (overflowWidth > 0 && flexShrinkUnits) gapFill = scaleColumns(fixedShrinkColumns, overflowWidth, Math.floor(overflowWidth / flexShrinkUnits), true);
    //decrease width of last column to account for rounding errors
    if (gapFill && fixedShrinkColumns.length) fixedShrinkColumns[fixedShrinkColumns.length - 1].width -= gapFill;
    flexColumns.forEach(function(col) {
        col.column.setWidth(col.width);
    });
    fixedShrinkColumns.forEach(function(col) {
        col.column.setWidth(col.width);
    });
}
var $517dee46856d349e$var$defaultModes = {
    fitData: $517dee46856d349e$var$fitData,
    fitDataFill: $517dee46856d349e$var$fitDataGeneral,
    fitDataTable: $517dee46856d349e$var$fitDataGeneral,
    fitDataStretch: $517dee46856d349e$var$fitDataStretch,
    fitColumns: $517dee46856d349e$var$fitColumns
};
class $517dee46856d349e$var$Layout extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "layout";
    //load defaults
    static modes = $517dee46856d349e$var$defaultModes;
    constructor(table){
        super(table, "layout");
        this.mode = null;
        this.registerTableOption("layout", "fitData"); //layout type
        this.registerTableOption("layoutColumnsOnNewData", false); //update column widths on setData
        this.registerColumnOption("widthGrow");
        this.registerColumnOption("widthShrink");
    }
    //initialize layout system
    initialize() {
        var layout = this.table.options.layout;
        if ($517dee46856d349e$var$Layout.modes[layout]) this.mode = layout;
        else {
            console.warn("Layout Error - invalid mode set, defaulting to 'fitData' : " + layout);
            this.mode = 'fitData';
        }
        this.table.element.setAttribute("tabulator-layout", this.mode);
        this.subscribe("column-init", this.initializeColumn.bind(this));
    }
    initializeColumn(column) {
        if (column.definition.widthGrow) column.definition.widthGrow = Number(column.definition.widthGrow);
        if (column.definition.widthShrink) column.definition.widthShrink = Number(column.definition.widthShrink);
    }
    getMode() {
        return this.mode;
    }
    //trigger table layout
    layout(dataChanged) {
        var variableHeight = this.table.columnManager.columnsByIndex.find((column)=>column.definition.variableHeight || column.definition.formatter === "textarea");
        this.dispatch("layout-refreshing");
        $517dee46856d349e$var$Layout.modes[this.mode].call(this, this.table.columnManager.columnsByIndex, dataChanged);
        if (variableHeight) this.table.rowManager.normalizeHeight(true);
        this.dispatch("layout-refreshed");
    }
}
var $517dee46856d349e$var$defaultLangs = {
    "default": {
        "groups": {
            "item": "item",
            "items": "items"
        },
        "columns": {},
        "data": {
            "loading": "Loading",
            "error": "Error"
        },
        "pagination": {
            "page_size": "Page Size",
            "page_title": "Show Page",
            "first": "First",
            "first_title": "First Page",
            "last": "Last",
            "last_title": "Last Page",
            "prev": "Prev",
            "prev_title": "Prev Page",
            "next": "Next",
            "next_title": "Next Page",
            "all": "All",
            "counter": {
                "showing": "Showing",
                "of": "of",
                "rows": "rows",
                "pages": "pages"
            }
        },
        "headerFilters": {
            "default": "filter column...",
            "columns": {}
        }
    }
};
class $517dee46856d349e$var$Localize extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "localize";
    //load defaults
    static langs = $517dee46856d349e$var$defaultLangs;
    constructor(table){
        super(table);
        this.locale = "default"; //current locale
        this.lang = false; //current language
        this.bindings = {}; //update events to call when locale is changed
        this.langList = {};
        this.registerTableOption("locale", false); //current system language
        this.registerTableOption("langs", {});
    }
    initialize() {
        this.langList = $517dee46856d349e$var$Helpers.deepClone($517dee46856d349e$var$Localize.langs);
        if (this.table.options.columnDefaults.headerFilterPlaceholder !== false) this.setHeaderFilterPlaceholder(this.table.options.columnDefaults.headerFilterPlaceholder);
        for(let locale in this.table.options.langs)this.installLang(locale, this.table.options.langs[locale]);
        this.setLocale(this.table.options.locale);
        this.registerTableFunction("setLocale", this.setLocale.bind(this));
        this.registerTableFunction("getLocale", this.getLocale.bind(this));
        this.registerTableFunction("getLang", this.getLang.bind(this));
    }
    //set header placeholder
    setHeaderFilterPlaceholder(placeholder) {
        this.langList.default.headerFilters.default = placeholder;
    }
    //setup a lang description object
    installLang(locale, lang) {
        if (this.langList[locale]) this._setLangProp(this.langList[locale], lang);
        else this.langList[locale] = lang;
    }
    _setLangProp(lang, values) {
        for(let key in values)if (lang[key] && typeof lang[key] == "object") this._setLangProp(lang[key], values[key]);
        else lang[key] = values[key];
    }
    //set current locale
    setLocale(desiredLocale) {
        desiredLocale = desiredLocale || "default";
        //fill in any matching language values
        function traverseLang(trans, path) {
            for(var prop in trans)if (typeof trans[prop] == "object") {
                if (!path[prop]) path[prop] = {};
                traverseLang(trans[prop], path[prop]);
            } else path[prop] = trans[prop];
        }
        //determining correct locale to load
        if (desiredLocale === true && navigator.language) //get local from system
        desiredLocale = navigator.language.toLowerCase();
        if (desiredLocale) //if locale is not set, check for matching top level locale else use default
        {
            if (!this.langList[desiredLocale]) {
                let prefix = desiredLocale.split("-")[0];
                if (this.langList[prefix]) {
                    console.warn("Localization Error - Exact matching locale not found, using closest match: ", desiredLocale, prefix);
                    desiredLocale = prefix;
                } else {
                    console.warn("Localization Error - Matching locale not found, using default: ", desiredLocale);
                    desiredLocale = "default";
                }
            }
        }
        this.locale = desiredLocale;
        //load default lang template
        this.lang = $517dee46856d349e$var$Helpers.deepClone(this.langList.default || {});
        if (desiredLocale != "default") traverseLang(this.langList[desiredLocale], this.lang);
        this.dispatchExternal("localized", this.locale, this.lang);
        this._executeBindings();
    }
    //get current locale
    getLocale(locale) {
        return this.locale;
    }
    //get lang object for given local or current if none provided
    getLang(locale) {
        return locale ? this.langList[locale] : this.lang;
    }
    //get text for current locale
    getText(path, value) {
        var fillPath = value ? path + "|" + value : path, pathArray = fillPath.split("|"), text = this._getLangElement(pathArray, this.locale);
        // if(text === false){
        // 	console.warn("Localization Error - Matching localized text not found for given path: ", path);
        // }
        return text || "";
    }
    //traverse langs object and find localized copy
    _getLangElement(path, locale) {
        var root = this.lang;
        path.forEach(function(level) {
            var rootPath;
            if (root) {
                rootPath = root[level];
                if (typeof rootPath != "undefined") root = rootPath;
                else root = false;
            }
        });
        return root;
    }
    //set update binding
    bind(path, callback) {
        if (!this.bindings[path]) this.bindings[path] = [];
        this.bindings[path].push(callback);
        callback(this.getText(path), this.lang);
    }
    //iterate through bindings and trigger updates
    _executeBindings() {
        for(let path in this.bindings)this.bindings[path].forEach((binding)=>{
            binding(this.getText(path), this.lang);
        });
    }
}
class $517dee46856d349e$var$Comms extends $517dee46856d349e$export$c3a9d7ff17e4f3ed {
    static moduleName = "comms";
    constructor(table){
        super(table);
    }
    initialize() {
        this.registerTableFunction("tableComms", this.receive.bind(this));
    }
    getConnections(selectors) {
        var connections = [], connection;
        connection = this.table.constructor.registry.lookupTable(selectors);
        connection.forEach((con)=>{
            if (this.table !== con) connections.push(con);
        });
        return connections;
    }
    send(selectors, module, action, data) {
        var connections = this.getConnections(selectors);
        connections.forEach((connection)=>{
            connection.tableComms(this.table.element, module, action, data);
        });
        if (!connections.length && selectors) console.warn("Table Connection Error - No tables matching selector found", selectors);
    }
    receive(table, module, action, data) {
        if (this.table.modExists(module)) return this.table.modules[module].commsReceived(table, action, data);
        else console.warn("Inter-table Comms Error - no such module:", module);
    }
}
var $517dee46856d349e$var$coreModules = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CommsModule: $517dee46856d349e$var$Comms,
    LayoutModule: $517dee46856d349e$var$Layout,
    LocalizeModule: $517dee46856d349e$var$Localize
});
class $517dee46856d349e$var$TableRegistry {
    static registry = {
        tables: [],
        register (table) {
            $517dee46856d349e$var$TableRegistry.registry.tables.push(table);
        },
        deregister (table) {
            var index = $517dee46856d349e$var$TableRegistry.registry.tables.indexOf(table);
            if (index > -1) $517dee46856d349e$var$TableRegistry.registry.tables.splice(index, 1);
        },
        lookupTable (query, silent) {
            var results = [], matches, match;
            if (typeof query === "string") {
                matches = document.querySelectorAll(query);
                if (matches.length) for(var i = 0; i < matches.length; i++){
                    match = $517dee46856d349e$var$TableRegistry.registry.matchElement(matches[i]);
                    if (match) results.push(match);
                }
            } else if (typeof HTMLElement !== "undefined" && query instanceof HTMLElement || query instanceof $517dee46856d349e$var$TableRegistry) {
                match = $517dee46856d349e$var$TableRegistry.registry.matchElement(query);
                if (match) results.push(match);
            } else if (Array.isArray(query)) query.forEach(function(item) {
                results = results.concat($517dee46856d349e$var$TableRegistry.registry.lookupTable(item));
            });
            else if (!silent) console.warn("Table Connection Error - Invalid Selector", query);
            return results;
        },
        matchElement (element) {
            return $517dee46856d349e$var$TableRegistry.registry.tables.find(function(table) {
                return element instanceof $517dee46856d349e$var$TableRegistry ? table === element : table.element === element;
            });
        }
    };
    static findTable(query) {
        var results = $517dee46856d349e$var$TableRegistry.registry.lookupTable(query, true);
        return Array.isArray(results) && !results.length ? false : results;
    }
}
class $517dee46856d349e$var$ModuleBinder extends $517dee46856d349e$var$TableRegistry {
    static moduleBindings = {};
    static moduleExtensions = {};
    static modulesRegistered = false;
    static defaultModules = false;
    constructor(){
        super();
    }
    static initializeModuleBinder(defaultModules) {
        if (!$517dee46856d349e$var$ModuleBinder.modulesRegistered) {
            $517dee46856d349e$var$ModuleBinder.modulesRegistered = true;
            $517dee46856d349e$var$ModuleBinder._registerModules($517dee46856d349e$var$coreModules, true);
            if (defaultModules) $517dee46856d349e$var$ModuleBinder._registerModules(defaultModules);
        }
    }
    static _extendModule(name, property, values) {
        if ($517dee46856d349e$var$ModuleBinder.moduleBindings[name]) {
            var source = $517dee46856d349e$var$ModuleBinder.moduleBindings[name][property];
            if (source) {
                if (typeof values == "object") for(let key in values)source[key] = values[key];
                else console.warn("Module Error - Invalid value type, it must be an object");
            } else console.warn("Module Error - property does not exist:", property);
        } else console.warn("Module Error - module does not exist:", name);
    }
    static _registerModules(modules, core) {
        var mods = Object.values(modules);
        if (core) mods.forEach((mod)=>{
            mod.prototype.moduleCore = true;
        });
        $517dee46856d349e$var$ModuleBinder._registerModule(mods);
    }
    static _registerModule(modules) {
        if (!Array.isArray(modules)) modules = [
            modules
        ];
        modules.forEach((mod)=>{
            $517dee46856d349e$var$ModuleBinder._registerModuleBinding(mod);
            $517dee46856d349e$var$ModuleBinder._registerModuleExtensions(mod);
        });
    }
    static _registerModuleBinding(mod) {
        if (mod.moduleName) $517dee46856d349e$var$ModuleBinder.moduleBindings[mod.moduleName] = mod;
        else console.error("Unable to bind module, no moduleName defined", mod.moduleName);
    }
    static _registerModuleExtensions(mod) {
        var extensions = mod.moduleExtensions;
        if (mod.moduleExtensions) for(let modKey in extensions){
            let ext = extensions[modKey];
            if ($517dee46856d349e$var$ModuleBinder.moduleBindings[modKey]) for(let propKey in ext)$517dee46856d349e$var$ModuleBinder._extendModule(modKey, propKey, ext[propKey]);
            else {
                if (!$517dee46856d349e$var$ModuleBinder.moduleExtensions[modKey]) $517dee46856d349e$var$ModuleBinder.moduleExtensions[modKey] = {};
                for(let propKey in ext){
                    if (!$517dee46856d349e$var$ModuleBinder.moduleExtensions[modKey][propKey]) $517dee46856d349e$var$ModuleBinder.moduleExtensions[modKey][propKey] = {};
                    Object.assign($517dee46856d349e$var$ModuleBinder.moduleExtensions[modKey][propKey], ext[propKey]);
                }
            }
        }
        $517dee46856d349e$var$ModuleBinder._extendModuleFromQueue(mod);
    }
    static _extendModuleFromQueue(mod) {
        var extensions = $517dee46856d349e$var$ModuleBinder.moduleExtensions[mod.moduleName];
        if (extensions) for(let propKey in extensions)$517dee46856d349e$var$ModuleBinder._extendModule(mod.moduleName, propKey, extensions[propKey]);
    }
    //ensure that module are bound to instantiated function
    _bindModules() {
        var orderedStartMods = [], orderedEndMods = [], unOrderedMods = [];
        this.modules = {};
        for(var name in $517dee46856d349e$var$ModuleBinder.moduleBindings){
            let mod = $517dee46856d349e$var$ModuleBinder.moduleBindings[name];
            let module = new mod(this);
            this.modules[name] = module;
            if (mod.prototype.moduleCore) this.modulesCore.push(module);
            else if (mod.moduleInitOrder) {
                if (mod.moduleInitOrder < 0) orderedStartMods.push(module);
                else orderedEndMods.push(module);
            } else unOrderedMods.push(module);
        }
        orderedStartMods.sort((a, b)=>a.moduleInitOrder > b.moduleInitOrder ? 1 : -1);
        orderedEndMods.sort((a, b)=>a.moduleInitOrder > b.moduleInitOrder ? 1 : -1);
        this.modulesRegular = orderedStartMods.concat(unOrderedMods.concat(orderedEndMods));
    }
}
class $517dee46856d349e$var$Alert extends $517dee46856d349e$var$CoreFeature {
    constructor(table){
        super(table);
        this.element = this._createAlertElement();
        this.msgElement = this._createMsgElement();
        this.type = null;
        this.element.appendChild(this.msgElement);
    }
    _createAlertElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-alert");
        return el;
    }
    _createMsgElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-alert-msg");
        el.setAttribute("role", "alert");
        return el;
    }
    _typeClass() {
        return "tabulator-alert-state-" + this.type;
    }
    alert(content, type = "msg") {
        if (content) {
            this.clear();
            this.dispatch("alert-show", type);
            this.type = type;
            while(this.msgElement.firstChild)this.msgElement.removeChild(this.msgElement.firstChild);
            this.msgElement.classList.add(this._typeClass());
            if (typeof content === "function") content = content();
            if (content instanceof HTMLElement) this.msgElement.appendChild(content);
            else this.msgElement.innerHTML = content;
            this.table.element.appendChild(this.element);
        }
    }
    clear() {
        this.dispatch("alert-hide", this.type);
        if (this.element.parentNode) this.element.parentNode.removeChild(this.element);
        this.msgElement.classList.remove(this._typeClass());
    }
}
class $517dee46856d349e$var$Tabulator extends $517dee46856d349e$var$ModuleBinder {
    //default setup options
    static defaultOptions = $517dee46856d349e$var$defaultOptions;
    static extendModule() {
        $517dee46856d349e$var$Tabulator.initializeModuleBinder();
        $517dee46856d349e$var$Tabulator._extendModule(...arguments);
    }
    static registerModule() {
        $517dee46856d349e$var$Tabulator.initializeModuleBinder();
        $517dee46856d349e$var$Tabulator._registerModule(...arguments);
    }
    constructor(element, options, modules){
        super();
        $517dee46856d349e$var$Tabulator.initializeModuleBinder(modules);
        this.options = {};
        this.columnManager = null; // hold Column Manager
        this.rowManager = null; //hold Row Manager
        this.footerManager = null; //holder Footer Manager
        this.alertManager = null; //hold Alert Manager
        this.vdomHoz = null; //holder horizontal virtual dom
        this.externalEvents = null; //handle external event messaging
        this.eventBus = null; //handle internal event messaging
        this.interactionMonitor = false; //track user interaction
        this.browser = ""; //hold current browser type
        this.browserSlow = false; //handle reduced functionality for slower browsers
        this.browserMobile = false; //check if running on mobile, prevent resize cancelling edit on keyboard appearance
        this.rtl = false; //check if the table is in RTL mode
        this.originalElement = null; //hold original table element if it has been replaced
        this.componentFunctionBinder = new $517dee46856d349e$var$ComponentFunctionBinder(this); //bind component functions
        this.dataLoader = false; //bind component functions
        this.modules = {}; //hold all modules bound to this table
        this.modulesCore = []; //hold core modules bound to this table (for initialization purposes)
        this.modulesRegular = []; //hold regular modules bound to this table (for initialization purposes)
        this.deprecationAdvisor = new $517dee46856d349e$var$DeprecationAdvisor(this);
        this.optionsList = new $517dee46856d349e$var$OptionsList(this, "table constructor");
        this.dependencyRegistry = new $517dee46856d349e$var$DependencyRegistry(this);
        this.initialized = false;
        this.destroyed = false;
        if (this.initializeElement(element)) {
            this.initializeCoreSystems(options);
            //delay table creation to allow event bindings immediately after the constructor
            setTimeout(()=>{
                this._create();
            });
        }
        this.constructor.registry.register(this); //register table for inter-device communication
    }
    initializeElement(element) {
        if (typeof HTMLElement !== "undefined" && element instanceof HTMLElement) {
            this.element = element;
            return true;
        } else if (typeof element === "string") {
            this.element = document.querySelector(element);
            if (this.element) return true;
            else {
                console.error("Tabulator Creation Error - no element found matching selector: ", element);
                return false;
            }
        } else {
            console.error("Tabulator Creation Error - Invalid element provided:", element);
            return false;
        }
    }
    initializeCoreSystems(options) {
        this.columnManager = new $517dee46856d349e$var$ColumnManager(this);
        this.rowManager = new $517dee46856d349e$var$RowManager(this);
        this.footerManager = new $517dee46856d349e$var$FooterManager(this);
        this.dataLoader = new $517dee46856d349e$var$DataLoader(this);
        this.alertManager = new $517dee46856d349e$var$Alert(this);
        this._bindModules();
        this.options = this.optionsList.generate($517dee46856d349e$var$Tabulator.defaultOptions, options);
        this._clearObjectPointers();
        this._mapDeprecatedFunctionality();
        this.externalEvents = new $517dee46856d349e$var$ExternalEventBus(this, this.options, this.options.debugEventsExternal);
        this.eventBus = new $517dee46856d349e$var$InternalEventBus(this.options.debugEventsInternal);
        this.interactionMonitor = new $517dee46856d349e$var$InteractionManager(this);
        this.dataLoader.initialize();
        this.footerManager.initialize();
        this.dependencyRegistry.initialize();
    }
    //convert deprecated functionality to new functions
    _mapDeprecatedFunctionality() {
    //all previously deprecated functionality removed in the 6.0 release
    }
    _clearSelection() {
        this.element.classList.add("tabulator-block-select");
        if (window.getSelection) {
            if (window.getSelection().empty) window.getSelection().empty();
            else if (window.getSelection().removeAllRanges) window.getSelection().removeAllRanges();
        } else if (document.selection) document.selection.empty();
        this.element.classList.remove("tabulator-block-select");
    }
    //create table
    _create() {
        this.externalEvents.dispatch("tableBuilding");
        this.eventBus.dispatch("table-building");
        this._rtlCheck();
        this._buildElement();
        this._initializeTable();
        this.initialized = true;
        this._loadInitialData().finally(()=>{
            this.eventBus.dispatch("table-initialized");
            this.externalEvents.dispatch("tableBuilt");
        });
    }
    _rtlCheck() {
        var style = window.getComputedStyle(this.element);
        switch(this.options.textDirection){
            case "auto":
                if (style.direction !== "rtl") break;
            case "rtl":
                this.element.classList.add("tabulator-rtl");
                this.rtl = true;
                break;
            case "ltr":
                this.element.classList.add("tabulator-ltr");
            default:
                this.rtl = false;
        }
    }
    //clear pointers to objects in default config object
    _clearObjectPointers() {
        this.options.columns = this.options.columns.slice(0);
        if (Array.isArray(this.options.data) && !this.options.reactiveData) this.options.data = this.options.data.slice(0);
    }
    //build tabulator element
    _buildElement() {
        var element = this.element, options = this.options, newElement;
        if (element.tagName === "TABLE") {
            this.originalElement = this.element;
            newElement = document.createElement("div");
            //transfer attributes to new element
            var attributes = element.attributes;
            // loop through attributes and apply them on div
            for(var i in attributes)if (typeof attributes[i] == "object") newElement.setAttribute(attributes[i].name, attributes[i].value);
            // replace table with div element
            element.parentNode.replaceChild(newElement, element);
            this.element = element = newElement;
        }
        element.classList.add("tabulator");
        element.setAttribute("role", "grid");
        //empty element
        while(element.firstChild)element.removeChild(element.firstChild);
        //set table height
        if (options.height) {
            options.height = isNaN(options.height) ? options.height : options.height + "px";
            element.style.height = options.height;
        }
        //set table min height
        if (options.minHeight !== false) {
            options.minHeight = isNaN(options.minHeight) ? options.minHeight : options.minHeight + "px";
            element.style.minHeight = options.minHeight;
        }
        //set table maxHeight
        if (options.maxHeight !== false) {
            options.maxHeight = isNaN(options.maxHeight) ? options.maxHeight : options.maxHeight + "px";
            element.style.maxHeight = options.maxHeight;
        }
    }
    //initialize core systems and modules
    _initializeTable() {
        var element = this.element, options = this.options;
        this.interactionMonitor.initialize();
        this.columnManager.initialize();
        this.rowManager.initialize();
        this._detectBrowser();
        //initialize core modules
        this.modulesCore.forEach((mod)=>{
            mod.initialize();
        });
        //build table elements
        element.appendChild(this.columnManager.getElement());
        element.appendChild(this.rowManager.getElement());
        if (options.footerElement) this.footerManager.activate();
        if (options.autoColumns && options.data) this.columnManager.generateColumnsFromRowData(this.options.data);
        //initialize regular modules
        this.modulesRegular.forEach((mod)=>{
            mod.initialize();
        });
        this.columnManager.setColumns(options.columns);
        this.eventBus.dispatch("table-built");
    }
    _loadInitialData() {
        return this.dataLoader.load(this.options.data).finally(()=>{
            this.columnManager.verticalAlignHeaders();
        });
    }
    //deconstructor
    destroy() {
        var element = this.element;
        this.destroyed = true;
        this.constructor.registry.deregister(this); //deregister table from inter-device communication
        this.eventBus.dispatch("table-destroy");
        //clear row data
        this.rowManager.destroy();
        //clear DOM
        while(element.firstChild)element.removeChild(element.firstChild);
        element.classList.remove("tabulator");
        this.externalEvents.dispatch("tableDestroyed");
    }
    _detectBrowser() {
        var ua = navigator.userAgent || navigator.vendor || window.opera;
        if (ua.indexOf("Trident") > -1) {
            this.browser = "ie";
            this.browserSlow = true;
        } else if (ua.indexOf("Edge") > -1) {
            this.browser = "edge";
            this.browserSlow = true;
        } else if (ua.indexOf("Firefox") > -1) {
            this.browser = "firefox";
            this.browserSlow = false;
        } else if (ua.indexOf("Mac OS") > -1) {
            this.browser = "safari";
            this.browserSlow = false;
        } else {
            this.browser = "other";
            this.browserSlow = false;
        }
        this.browserMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(ua) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(ua.slice(0, 4));
    }
    initGuard(func, msg) {
        var stack, line;
        if (this.options.debugInitialization && !this.initialized) {
            if (!func) {
                stack = new Error().stack.split("\n");
                line = stack[0] == "Error" ? stack[2] : stack[1];
                if (line[0] == " ") func = line.trim().split(" ")[1].split(".")[1];
                else func = line.trim().split("@")[0];
            }
            console.warn("Table Not Initialized - Calling the " + func + " function before the table is initialized may result in inconsistent behavior, Please wait for the `tableBuilt` event before calling this function." + (msg ? " " + msg : ""));
        }
        return this.initialized;
    }
    ////////////////// Data Handling //////////////////
    //block table redrawing
    blockRedraw() {
        this.initGuard();
        this.eventBus.dispatch("redraw-blocking");
        this.rowManager.blockRedraw();
        this.columnManager.blockRedraw();
        this.eventBus.dispatch("redraw-blocked");
    }
    //restore table redrawing
    restoreRedraw() {
        this.initGuard();
        this.eventBus.dispatch("redraw-restoring");
        this.rowManager.restoreRedraw();
        this.columnManager.restoreRedraw();
        this.eventBus.dispatch("redraw-restored");
    }
    //load data
    setData(data, params, config) {
        this.initGuard(false, "To set initial data please use the 'data' property in the table constructor.");
        return this.dataLoader.load(data, params, config, false);
    }
    //clear data
    clearData() {
        this.initGuard();
        this.dataLoader.blockActiveLoad();
        this.rowManager.clearData();
    }
    //get table data array
    getData(active) {
        return this.rowManager.getData(active);
    }
    //get table data array count
    getDataCount(active) {
        return this.rowManager.getDataCount(active);
    }
    //replace data, keeping table in position with same sort
    replaceData(data, params, config) {
        this.initGuard();
        return this.dataLoader.load(data, params, config, true, true);
    }
    //update table data
    updateData(data) {
        var responses = 0;
        this.initGuard();
        return new Promise((resolve, reject)=>{
            this.dataLoader.blockActiveLoad();
            if (typeof data === "string") data = JSON.parse(data);
            if (data && data.length > 0) data.forEach((item)=>{
                var row = this.rowManager.findRow(item[this.options.index]);
                if (row) {
                    responses++;
                    row.updateData(item).then(()=>{
                        responses--;
                        if (!responses) resolve();
                    }).catch((e)=>{
                        reject("Update Error - Unable to update row", item, e);
                    });
                } else reject("Update Error - Unable to find row", item);
            });
            else {
                console.warn("Update Error - No data provided");
                reject("Update Error - No data provided");
            }
        });
    }
    addData(data, pos, index) {
        this.initGuard();
        return new Promise((resolve, reject)=>{
            this.dataLoader.blockActiveLoad();
            if (typeof data === "string") data = JSON.parse(data);
            if (data) this.rowManager.addRows(data, pos, index).then((rows)=>{
                var output = [];
                rows.forEach(function(row) {
                    output.push(row.getComponent());
                });
                resolve(output);
            });
            else {
                console.warn("Update Error - No data provided");
                reject("Update Error - No data provided");
            }
        });
    }
    //update table data
    updateOrAddData(data) {
        var rows = [], responses = 0;
        this.initGuard();
        return new Promise((resolve, reject)=>{
            this.dataLoader.blockActiveLoad();
            if (typeof data === "string") data = JSON.parse(data);
            if (data && data.length > 0) data.forEach((item)=>{
                var row = this.rowManager.findRow(item[this.options.index]);
                responses++;
                if (row) row.updateData(item).then(()=>{
                    responses--;
                    rows.push(row.getComponent());
                    if (!responses) resolve(rows);
                });
                else this.rowManager.addRows(item).then((newRows)=>{
                    responses--;
                    rows.push(newRows[0].getComponent());
                    if (!responses) resolve(rows);
                });
            });
            else {
                console.warn("Update Error - No data provided");
                reject("Update Error - No data provided");
            }
        });
    }
    //get row object
    getRow(index) {
        var row = this.rowManager.findRow(index);
        if (row) return row.getComponent();
        else {
            console.warn("Find Error - No matching row found:", index);
            return false;
        }
    }
    //get row object
    getRowFromPosition(position) {
        var row = this.rowManager.getRowFromPosition(position);
        if (row) return row.getComponent();
        else {
            console.warn("Find Error - No matching row found:", position);
            return false;
        }
    }
    //delete row from table
    deleteRow(index) {
        var foundRows = [];
        this.initGuard();
        if (!Array.isArray(index)) index = [
            index
        ];
        //find matching rows
        for (let item of index){
            let row = this.rowManager.findRow(item, true);
            if (row) foundRows.push(row);
            else {
                console.error("Delete Error - No matching row found:", item);
                return Promise.reject("Delete Error - No matching row found");
            }
        }
        //sort rows into correct order to ensure smooth delete from table
        foundRows.sort((a, b)=>{
            return this.rowManager.rows.indexOf(a) > this.rowManager.rows.indexOf(b) ? 1 : -1;
        });
        //delete rows
        foundRows.forEach((row)=>{
            row.delete();
        });
        this.rowManager.reRenderInPosition();
        return Promise.resolve();
    }
    //add row to table
    addRow(data, pos, index) {
        this.initGuard();
        if (typeof data === "string") data = JSON.parse(data);
        return this.rowManager.addRows(data, pos, index, true).then((rows)=>{
            return rows[0].getComponent();
        });
    }
    //update a row if it exists otherwise create it
    updateOrAddRow(index, data) {
        var row = this.rowManager.findRow(index);
        this.initGuard();
        if (typeof data === "string") data = JSON.parse(data);
        if (row) return row.updateData(data).then(()=>{
            return row.getComponent();
        });
        else return this.rowManager.addRows(data).then((rows)=>{
            return rows[0].getComponent();
        });
    }
    //update row data
    updateRow(index, data) {
        var row = this.rowManager.findRow(index);
        this.initGuard();
        if (typeof data === "string") data = JSON.parse(data);
        if (row) return row.updateData(data).then(()=>{
            return Promise.resolve(row.getComponent());
        });
        else {
            console.warn("Update Error - No matching row found:", index);
            return Promise.reject("Update Error - No matching row found");
        }
    }
    //scroll to row in DOM
    scrollToRow(index, position, ifVisible) {
        var row = this.rowManager.findRow(index);
        if (row) return this.rowManager.scrollToRow(row, position, ifVisible);
        else {
            console.warn("Scroll Error - No matching row found:", index);
            return Promise.reject("Scroll Error - No matching row found");
        }
    }
    moveRow(from, to, after) {
        var fromRow = this.rowManager.findRow(from);
        this.initGuard();
        if (fromRow) fromRow.moveToRow(to, after);
        else console.warn("Move Error - No matching row found:", from);
    }
    getRows(active) {
        return this.rowManager.getComponents(active);
    }
    //get position of row in table
    getRowPosition(index) {
        var row = this.rowManager.findRow(index);
        if (row) return row.getPosition();
        else {
            console.warn("Position Error - No matching row found:", index);
            return false;
        }
    }
    /////////////// Column Functions  ///////////////
    setColumns(definition) {
        this.initGuard(false, "To set initial columns please use the 'columns' property in the table constructor");
        this.columnManager.setColumns(definition);
    }
    getColumns(structured) {
        return this.columnManager.getComponents(structured);
    }
    getColumn(field) {
        var column = this.columnManager.findColumn(field);
        if (column) return column.getComponent();
        else {
            console.warn("Find Error - No matching column found:", field);
            return false;
        }
    }
    getColumnDefinitions() {
        return this.columnManager.getDefinitionTree();
    }
    showColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) column.show();
        else {
            console.warn("Column Show Error - No matching column found:", field);
            return false;
        }
    }
    hideColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) column.hide();
        else {
            console.warn("Column Hide Error - No matching column found:", field);
            return false;
        }
    }
    toggleColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) {
            if (column.visible) column.hide();
            else column.show();
        } else {
            console.warn("Column Visibility Toggle Error - No matching column found:", field);
            return false;
        }
    }
    addColumn(definition, before, field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        return this.columnManager.addColumn(definition, before, column).then((column)=>{
            return column.getComponent();
        });
    }
    deleteColumn(field) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) return column.delete();
        else {
            console.warn("Column Delete Error - No matching column found:", field);
            return Promise.reject();
        }
    }
    updateColumnDefinition(field, definition) {
        var column = this.columnManager.findColumn(field);
        this.initGuard();
        if (column) return column.updateDefinition(definition);
        else {
            console.warn("Column Update Error - No matching column found:", field);
            return Promise.reject();
        }
    }
    moveColumn(from, to, after) {
        var fromColumn = this.columnManager.findColumn(from), toColumn = this.columnManager.findColumn(to);
        this.initGuard();
        if (fromColumn) {
            if (toColumn) this.columnManager.moveColumn(fromColumn, toColumn, after);
            else console.warn("Move Error - No matching column found:", toColumn);
        } else console.warn("Move Error - No matching column found:", from);
    }
    //scroll to column in DOM
    scrollToColumn(field, position, ifVisible) {
        return new Promise((resolve, reject)=>{
            var column = this.columnManager.findColumn(field);
            if (column) return this.columnManager.scrollToColumn(column, position, ifVisible);
            else {
                console.warn("Scroll Error - No matching column found:", field);
                return Promise.reject("Scroll Error - No matching column found");
            }
        });
    }
    //////////// General Public Functions ////////////
    //redraw list without updating data
    redraw(force) {
        this.initGuard();
        this.columnManager.redraw(force);
        this.rowManager.redraw(force);
    }
    setHeight(height) {
        this.options.height = isNaN(height) ? height : height + "px";
        this.element.style.height = this.options.height;
        this.rowManager.initializeRenderer();
        this.rowManager.redraw(true);
    }
    //////////////////// Event Bus ///////////////////
    on(key, callback) {
        this.externalEvents.subscribe(key, callback);
    }
    off(key, callback) {
        this.externalEvents.unsubscribe(key, callback);
    }
    dispatchEvent() {
        var args = Array.from(arguments);
        args.shift();
        this.externalEvents.dispatch(...arguments);
    }
    //////////////////// Alerts ///////////////////
    alert(contents, type) {
        this.initGuard();
        this.alertManager.alert(contents, type);
    }
    clearAlert() {
        this.initGuard();
        this.alertManager.clear();
    }
    ////////////// Extension Management //////////////
    modExists(plugin, required) {
        if (this.modules[plugin]) return true;
        else {
            if (required) console.error("Tabulator Module Not Installed: " + plugin);
            return false;
        }
    }
    module(key) {
        var mod = this.modules[key];
        if (!mod) console.error("Tabulator module not installed: " + key);
        return mod;
    }
}
var $517dee46856d349e$export$cd7cfffa934dc7d2 = $517dee46856d349e$var$Tabulator;
//tabulator with all modules installed
class $517dee46856d349e$var$TabulatorFull extends $517dee46856d349e$export$cd7cfffa934dc7d2 {
    static extendModule() {
        $517dee46856d349e$export$cd7cfffa934dc7d2.initializeModuleBinder($517dee46856d349e$var$allModules);
        $517dee46856d349e$export$cd7cfffa934dc7d2._extendModule(...arguments);
    }
    static registerModule() {
        $517dee46856d349e$export$cd7cfffa934dc7d2.initializeModuleBinder($517dee46856d349e$var$allModules);
        $517dee46856d349e$export$cd7cfffa934dc7d2._registerModule(...arguments);
    }
    constructor(element, options, modules){
        super(element, options, $517dee46856d349e$var$allModules);
    }
}
var $517dee46856d349e$export$62676a0a2827a643 = $517dee46856d349e$var$TabulatorFull;
class $517dee46856d349e$export$8d0cd4d1f07aaaa6 {
    constructor(type){
        this.type = type;
        this.element = this._createElement();
    }
    _createElement() {
        var el = document.createElement("div");
        el.classList.add("tabulator-row");
        return el;
    }
    getElement() {
        return this.element;
    }
    getComponent() {
        return false;
    }
    getData() {
        return {};
    }
    getHeight() {
        return this.element.outerHeight;
    }
    initialize() {}
    reinitialize() {}
    normalizeHeight() {}
    generateCells() {}
    reinitializeHeight() {}
    calcHeight() {}
    setCellHeight() {}
    clearCellHeight() {}
    rendered() {}
}


var $fe8436a5a6cf553d$exports = {};
"use strict";
var $fe8436a5a6cf553d$var$__importDefault = $fe8436a5a6cf553d$exports && $fe8436a5a6cf553d$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($fe8436a5a6cf553d$exports, "__esModule", {
    value: true
});
$fe8436a5a6cf553d$exports.__version = $fe8436a5a6cf553d$exports.tensorflow = $fe8436a5a6cf553d$exports.dateRange = $fe8436a5a6cf553d$exports.merge = $fe8436a5a6cf553d$exports.concat = $fe8436a5a6cf553d$exports.getDummies = $fe8436a5a6cf553d$exports.OneHotEncoder = $fe8436a5a6cf553d$exports.LabelEncoder = $fe8436a5a6cf553d$exports.StandardScaler = $fe8436a5a6cf553d$exports.MinMaxScaler = $fe8436a5a6cf553d$exports.toExcel = $fe8436a5a6cf553d$exports.readExcel = $fe8436a5a6cf553d$exports.toJSON = $fe8436a5a6cf553d$exports.readJSON = $fe8436a5a6cf553d$exports.toCSV = $fe8436a5a6cf553d$exports.streamCSV = $fe8436a5a6cf553d$exports.readCSV = $fe8436a5a6cf553d$exports.DataFrame = $fe8436a5a6cf553d$exports.Series = $fe8436a5a6cf553d$exports.toDateTime = $fe8436a5a6cf553d$exports.Dt = $fe8436a5a6cf553d$exports.Str = $fe8436a5a6cf553d$exports.Utils = $fe8436a5a6cf553d$exports.Config = $fe8436a5a6cf553d$exports.NDframe = void 0;

var $4j43E = parcelRequire("4j43E");
Object.defineProperty($fe8436a5a6cf553d$exports, "NDframe", {
    enumerable: true,
    get: function() {
        return $4j43E.NDframe;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "Config", {
    enumerable: true,
    get: function() {
        return $4j43E.Config;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "Utils", {
    enumerable: true,
    get: function() {
        return $4j43E.Utils;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "Str", {
    enumerable: true,
    get: function() {
        return $4j43E.Str;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "Dt", {
    enumerable: true,
    get: function() {
        return $4j43E.Dt;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "MinMaxScaler", {
    enumerable: true,
    get: function() {
        return $4j43E.MinMaxScaler;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "StandardScaler", {
    enumerable: true,
    get: function() {
        return $4j43E.StandardScaler;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "LabelEncoder", {
    enumerable: true,
    get: function() {
        return $4j43E.LabelEncoder;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "OneHotEncoder", {
    enumerable: true,
    get: function() {
        return $4j43E.OneHotEncoder;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "getDummies", {
    enumerable: true,
    get: function() {
        return $4j43E.getDummies;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "concat", {
    enumerable: true,
    get: function() {
        return $4j43E.concat;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "merge", {
    enumerable: true,
    get: function() {
        return $4j43E.merge;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "toDateTime", {
    enumerable: true,
    get: function() {
        return $4j43E.toDateTime;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "dateRange", {
    enumerable: true,
    get: function() {
        return $4j43E.dateRange;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "tensorflow", {
    enumerable: true,
    get: function() {
        return $4j43E.tensorflow;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "__version", {
    enumerable: true,
    get: function() {
        return $4j43E.__version;
    }
});
var $b9dc96d5b5d17565$exports = {};
"use strict";
Object.defineProperty($b9dc96d5b5d17565$exports, "__esModule", {
    value: true
});
$b9dc96d5b5d17565$exports.toExcelBrowser = $b9dc96d5b5d17565$exports.readExcelBrowser = $b9dc96d5b5d17565$exports.toJSONBrowser = $b9dc96d5b5d17565$exports.readJSONBrowser = $b9dc96d5b5d17565$exports.toCSVBrowser = $b9dc96d5b5d17565$exports.streamCSVBrowser = $b9dc96d5b5d17565$exports.readCSVBrowser = void 0;
var $1fe7092f5c137088$exports = {};
"use strict";
var $1fe7092f5c137088$var$__assign = $1fe7092f5c137088$exports && $1fe7092f5c137088$exports.__assign || function() {
    $1fe7092f5c137088$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1fe7092f5c137088$var$__assign.apply(this, arguments);
};
var $1fe7092f5c137088$var$__awaiter = $1fe7092f5c137088$exports && $1fe7092f5c137088$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1fe7092f5c137088$var$__generator = $1fe7092f5c137088$exports && $1fe7092f5c137088$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1fe7092f5c137088$var$__importDefault = $1fe7092f5c137088$exports && $1fe7092f5c137088$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($1fe7092f5c137088$exports, "__esModule", {
    value: true
});
$1fe7092f5c137088$exports.$toCSV = $1fe7092f5c137088$exports.$streamCSV = $1fe7092f5c137088$exports.$readCSV = void 0;

var $4j43E = parcelRequire("4j43E");

var $1fe7092f5c137088$var$papaparse_1 = $1fe7092f5c137088$var$__importDefault((parcelRequire("i9wNk")));
/**
 * Reads a CSV file from local or remote location into a DataFrame.
 * @param filePath URL or local file path to CSV file. `readCSV` uses PapaParse to parse the CSV file,
 * hence all PapaParse options are supported.
 * @param options Configuration object. Supports all Papaparse parse config options.
 * @returns DataFrame containing the parsed CSV file.
 * @throws {Error} If file cannot be read or parsed
 * @example
 * ```
 * import { readCSV } from "danfojs-node"
 * const df = await readCSV("https://raw.githubusercontent.com/test.csv")
 * ```
 * @example
 * ```
 * import { readCSV } from "danfojs-node"
 * const df = await readCSV("https://raw.githubusercontent.com/test.csv", {
 *    delimiter: ",",
 *    headers: {
 *      Accept: "text/csv",
 *      Authorization: "Bearer YWRtaW46YWRtaW4="
 *    }
 * })
 * ```
 * @example
 * ```
 * import { readCSV } from "danfojs-node"
 * const df = await readCSV("./data/sample.csv")
 * ```
 */ var $1fe7092f5c137088$var$$readCSV = function(file, options) {
    return $1fe7092f5c137088$var$__awaiter(void 0, void 0, void 0, function() {
        var frameConfig, hasStringType;
        var _a;
        return $1fe7092f5c137088$var$__generator(this, function(_b) {
            frameConfig = (options === null || options === void 0 ? void 0 : options.frameConfig) || {};
            hasStringType = (_a = frameConfig.dtypes) === null || _a === void 0 ? void 0 : _a.includes("string");
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    var hasError = false;
                    $1fe7092f5c137088$var$papaparse_1.default.parse(file, $1fe7092f5c137088$var$__assign($1fe7092f5c137088$var$__assign({
                        header: true,
                        dynamicTyping: !hasStringType,
                        skipEmptyLines: 'greedy',
                        delimiter: ","
                    }, options), {
                        error: function(error) {
                            hasError = true;
                            reject(new Error("Failed to parse CSV: " + error.message));
                        },
                        download: true,
                        complete: function(results) {
                            if (hasError) return; // Skip if error already occurred
                            if (!results.data || results.data.length === 0) {
                                reject(new Error('No data found in CSV file'));
                                return;
                            }
                            if (results.errors && results.errors.length > 0) {
                                reject(new Error("CSV parsing errors: " + results.errors.map(function(e) {
                                    return e.message;
                                }).join(', ')));
                                return;
                            }
                            try {
                                var df = new $4j43E.DataFrame(results.data, frameConfig);
                                resolve(df);
                            } catch (error) {
                                var errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                                reject(new Error("Failed to create DataFrame from CSV: " + errorMessage));
                            }
                        }
                    }));
                })
            ];
        });
    });
};
$1fe7092f5c137088$exports.$readCSV = $1fe7092f5c137088$var$$readCSV;
/**
 * Streams a CSV file from local or remote location in chunks. Intermediate chunks is passed as a DataFrame to the callback function.
 * @param filePath URL or local file path to CSV file. `readCSV` uses PapaParse to parse the CSV file,
 * hence all PapaParse options are supported.
 * @param options Configuration object. Supports all Papaparse parse config options.
 * @param callback Callback function to be called once the specifed rows are parsed into DataFrame.
 * @example
 * ```
 * import { streamCSV } from "danfojs-node"
 * streamCSV("https://raw.githubusercontent.com/test.csv", (dfRow) => {
 *     const dfModified = dfRow["Names"].map((name) => name.split(",")[0])
 *     return dfModified
 * })
 * ```
 */ var $1fe7092f5c137088$var$$streamCSV = function(file, callback, options) {
    return $1fe7092f5c137088$var$__awaiter(void 0, void 0, void 0, function() {
        var frameConfig;
        return $1fe7092f5c137088$var$__generator(this, function(_a) {
            frameConfig = (options === null || options === void 0 ? void 0 : options.frameConfig) || {};
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    var _a;
                    var count = 0;
                    var hasError = false;
                    var hasStringType = (_a = frameConfig.dtypes) === null || _a === void 0 ? void 0 : _a.includes("string");
                    $1fe7092f5c137088$var$papaparse_1.default.parse(file, $1fe7092f5c137088$var$__assign($1fe7092f5c137088$var$__assign({
                        header: true,
                        download: true,
                        dynamicTyping: !hasStringType,
                        delimiter: ","
                    }, options), {
                        step: function(results) {
                            if (hasError) return;
                            try {
                                var df = new $4j43E.DataFrame([
                                    results.data
                                ], $1fe7092f5c137088$var$__assign($1fe7092f5c137088$var$__assign({}, frameConfig), {
                                    index: [
                                        count++
                                    ]
                                }));
                                callback(df);
                            } catch (error) {
                                hasError = true;
                                var errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                                reject(new Error("Failed to process CSV chunk: " + errorMessage));
                            }
                        },
                        complete: function() {
                            if (!hasError) resolve(null);
                        },
                        error: function(error) {
                            hasError = true;
                            reject(new Error("Failed to parse CSV: " + error.message));
                        }
                    }));
                })
            ];
        });
    });
};
$1fe7092f5c137088$exports.$streamCSV = $1fe7092f5c137088$var$$streamCSV;
/**
 * Converts a DataFrame or Series to CSV.
 * @param df DataFrame or Series to be converted to CSV.
 * @param options Configuration object. Supports the following options:
 * - `filePath`: Local file path to write the CSV file. If not specified, the CSV will be returned as a string.
 * - `header`: Boolean indicating whether to include a header row in the CSV file.
 * - `sep`: Character to be used as a separator in the CSV file.
 * @example
 * ```
 * import { toCSV } from "danfojs-node"
 * const df = new DataFrame([[1, 2, 3], [4, 5, 6]])
 * const csv = toCSV(df)
 * ```
 * @example
 * ```
 * import { toCSV } from "danfojs-node"
 * const df = new DataFrame([[1, 2, 3], [4, 5, 6]])
 * toCSV(df, {
 *     filePath: "./data/sample.csv",
 *     header: true,
 *     sep: "+"
 *   })
 * ```
 */ var $1fe7092f5c137088$var$$toCSV = function(df, options) {
    var _a = $1fe7092f5c137088$var$__assign({
        fileName: "output.csv",
        sep: ",",
        header: true,
        download: false
    }, options), fileName = _a.fileName, download = _a.download, sep = _a.sep, header = _a.header;
    if (df.$isSeries) {
        var csv = df.values.join(sep);
        if (download) {
            if (!fileName.endsWith(".csv")) fileName = fileName + ".csv";
            $1fe7092f5c137088$var$$downloadFileInBrowser(csv, fileName);
        } else return csv;
    } else {
        var rows = df.values;
        var csvStr = header === true ? df.columns.join(sep) + "\n" : "";
        for(var i = 0; i < rows.length; i++){
            var row = rows[i].join(sep) + "\n";
            csvStr += row;
        }
        if (download) {
            if (!fileName.endsWith(".csv")) fileName = fileName + ".csv";
            $1fe7092f5c137088$var$$downloadFileInBrowser(csvStr, fileName);
        } else return csvStr;
    }
};
$1fe7092f5c137088$exports.$toCSV = $1fe7092f5c137088$var$$toCSV;
/**
 * Internal function to download a CSV file in the browser.
 * @param content A string of CSV file contents
 * @param fileName  The name of the file to be downloaded
 */ var $1fe7092f5c137088$var$$downloadFileInBrowser = function(content, fileName) {
    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(content);
    hiddenElement.target = '_blank';
    hiddenElement.download = fileName;
    hiddenElement.click();
};


Object.defineProperty($b9dc96d5b5d17565$exports, "readCSVBrowser", {
    enumerable: true,
    get: function() {
        return $1fe7092f5c137088$exports.$readCSV;
    }
});
Object.defineProperty($b9dc96d5b5d17565$exports, "streamCSVBrowser", {
    enumerable: true,
    get: function() {
        return $1fe7092f5c137088$exports.$streamCSV;
    }
});
Object.defineProperty($b9dc96d5b5d17565$exports, "toCSVBrowser", {
    enumerable: true,
    get: function() {
        return $1fe7092f5c137088$exports.$toCSV;
    }
});
var $9700e2deacfafd60$exports = {};
"use strict";
var $9700e2deacfafd60$var$__assign = $9700e2deacfafd60$exports && $9700e2deacfafd60$exports.__assign || function() {
    $9700e2deacfafd60$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9700e2deacfafd60$var$__assign.apply(this, arguments);
};
var $9700e2deacfafd60$var$__awaiter = $9700e2deacfafd60$exports && $9700e2deacfafd60$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9700e2deacfafd60$var$__generator = $9700e2deacfafd60$exports && $9700e2deacfafd60$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($9700e2deacfafd60$exports, "__esModule", {
    value: true
});
$9700e2deacfafd60$exports.$toJSON = $9700e2deacfafd60$exports.$readJSON = void 0;

var $4j43E = parcelRequire("4j43E");
/**
 * Reads a JSON file from local or remote location into a DataFrame.
 * @param fileName URL or local file path to JSON file.
 * @param options Configuration object. Supported options:
 * - `method`: The HTTP method to use. Defaults to `'GET'`.
 * - `headers`: Additional headers to send with the request. Supports the `node-fetch` [HeadersInit]
 * @example
 * ```
 * import { readJSON } from "danfojs-node"
 * const df = await readJSON("https://raw.githubusercontent.com/test.json")
 * ```
 * @example
 * ```
 * import { readJSON } from "danfojs-node"
 * const df = await readJSON("https://raw.githubusercontent.com/test.json", {
 *    headers: {
 *      Accept: "text/json",
 *      Authorization: "Bearer YWRtaW46YWRtaW4="
 *    }
 * })
 * ```
 * @example
 * ```
 * import { readJSON } from "danfojs-node"
 * const df = await readJSON("./data/sample.json")
 * ```
 */ var $9700e2deacfafd60$var$$readJSON = function(file, options) {
    return $9700e2deacfafd60$var$__awaiter(void 0, void 0, void 0, function() {
        var _a, method, headers, frameConfig;
        return $9700e2deacfafd60$var$__generator(this, function(_b) {
            _a = $9700e2deacfafd60$var$__assign({
                method: "GET",
                headers: {},
                frameConfig: {}
            }, options), method = _a.method, headers = _a.headers, frameConfig = _a.frameConfig;
            if (typeof file === "string" && file.startsWith("http")) return [
                2 /*return*/ ,
                new Promise(function(resolve) {
                    fetch(file, {
                        method: method,
                        headers: headers
                    }).then(function(response) {
                        if (response.status !== 200) throw new Error("Failed to load " + file);
                        response.json().then(function(json) {
                            resolve(new $4j43E.DataFrame(json, frameConfig));
                        });
                    }).catch(function(err) {
                        throw new Error(err);
                    });
                })
            ];
            else if (file instanceof File) return [
                2 /*return*/ ,
                new Promise(function(resolve) {
                    var reader = new FileReader();
                    reader.readAsText(file);
                    reader.onload = function(event) {
                        var _a;
                        var jsonObj = JSON.parse((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.result);
                        resolve(new $4j43E.DataFrame(jsonObj, frameConfig));
                    };
                })
            ];
            else throw new Error("ParamError: File not supported. file must be a url or an input File object");
            return [
                2 /*return*/ 
            ];
        });
    });
};
$9700e2deacfafd60$exports.$readJSON = $9700e2deacfafd60$var$$readJSON;
/**
 * Converts a DataFrame or Series to JSON.
 * @param df DataFrame or Series to be converted to JSON.
 * @param options Configuration object. Supported options:
 * - `fileName`: The file path to write the JSON to. If not specified, the JSON object is returned.
 * - `format`: The format of the JSON. Defaults to `'column'`. E.g for using `column` format:
 * ```
 * [{ "a": 1, "b": 2, "c": 3, "d": 4 },
 *  { "a": 5, "b": 6, "c": 7, "d": 8 }]
 * ```
 * and `row` format:
 * ```
 * { "a": [1, 5, 9],
 *  "b": [2, 6, 10]
 * }
 * ```
 * @example
 * ```
 * import { toJSON } from "danfojs-node"
 * const df = new DataFrame([[1, 2, 3], [4, 5, 6]])
 * const json = toJSON(df)
 * ```
 * @example
 * ```
 * import { toJSON } from "danfojs-node"
 * const df = new DataFrame([[1, 2, 3], [4, 5, 6]])
 * toJSON(df, {
 *     fileName: "./data/sample.json",
 *     format: "row"
 *   })
 * ```
 */ var $9700e2deacfafd60$var$$toJSON = function(df, options) {
    var _a = $9700e2deacfafd60$var$__assign({
        fileName: "output.json",
        download: false,
        format: "column"
    }, options), fileName = _a.fileName, format = _a.format, download = _a.download;
    if (df.$isSeries) {
        var obj = {};
        obj[df.columns[0]] = df.values;
        if (download) {
            if (!fileName.endsWith(".json")) fileName = fileName + ".json";
            $9700e2deacfafd60$var$$downloadFileInBrowser(obj, fileName);
        } else return obj;
    } else if (format === "row") {
        var obj = {};
        for(var i = 0; i < df.columns.length; i++)obj[df.columns[i]] = df.column(df.columns[i]).values;
        if (download) {
            if (!fileName.endsWith(".json")) fileName = fileName + ".json";
            $9700e2deacfafd60$var$$downloadFileInBrowser(obj, fileName);
        } else return obj;
    } else {
        var values = df.values;
        var header_1 = df.columns;
        var jsonArr_1 = [];
        values.forEach(function(val) {
            var obj = {};
            header_1.forEach(function(h, i) {
                obj[h] = val[i];
            });
            jsonArr_1.push(obj);
        });
        if (download) {
            if (!fileName.endsWith(".json")) fileName = fileName + ".json";
            $9700e2deacfafd60$var$$downloadFileInBrowser(jsonArr_1, fileName);
        } else return jsonArr_1;
    }
};
$9700e2deacfafd60$exports.$toJSON = $9700e2deacfafd60$var$$toJSON;
/**
 * Internal function to download a JSON file in the browser.
 * @param content A string of JSON file contents
 * @param fileName  The name of the file to be downloaded
 */ var $9700e2deacfafd60$var$$downloadFileInBrowser = function(content, fileName) {
    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(content));
    hiddenElement.target = '_blank';
    hiddenElement.download = fileName;
    hiddenElement.click();
};


Object.defineProperty($b9dc96d5b5d17565$exports, "readJSONBrowser", {
    enumerable: true,
    get: function() {
        return $9700e2deacfafd60$exports.$readJSON;
    }
});
Object.defineProperty($b9dc96d5b5d17565$exports, "toJSONBrowser", {
    enumerable: true,
    get: function() {
        return $9700e2deacfafd60$exports.$toJSON;
    }
});
var $c80e91a4513448a4$exports = {};
"use strict";
var $c80e91a4513448a4$var$__assign = $c80e91a4513448a4$exports && $c80e91a4513448a4$exports.__assign || function() {
    $c80e91a4513448a4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c80e91a4513448a4$var$__assign.apply(this, arguments);
};
var $c80e91a4513448a4$var$__awaiter = $c80e91a4513448a4$exports && $c80e91a4513448a4$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c80e91a4513448a4$var$__generator = $c80e91a4513448a4$exports && $c80e91a4513448a4$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c80e91a4513448a4$var$__spreadArray = $c80e91a4513448a4$exports && $c80e91a4513448a4$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty($c80e91a4513448a4$exports, "__esModule", {
    value: true
});
$c80e91a4513448a4$exports.$toExcel = $c80e91a4513448a4$exports.$readExcel = void 0;

var $4j43E = parcelRequire("4j43E");
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ 
var $1frus = parcelRequire("1frus");
var $9d5117faee5c78f9$require$Buffer = $1frus.Buffer;
var $9d5117faee5c78f9$var$XLSX = {};
$9d5117faee5c78f9$var$XLSX.version = '0.19.3';
var $9d5117faee5c78f9$var$current_codepage = 1200, $9d5117faee5c78f9$var$current_ansi = 1252;
/*:: declare var cptable:any; */ /*global cptable:true, window */ var $9d5117faee5c78f9$var$$cptable;
var $9d5117faee5c78f9$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $9d5117faee5c78f9$var$CS2CP = {
    /*::[*/ 0: 1252,
    /* ANSI */ /*::[*/ 1: 65001,
    /* DEFAULT */ /*::[*/ 2: 65001,
    /* SYMBOL */ /*::[*/ 77: 10000,
    /* MAC */ /*::[*/ 128: 932,
    /* SHIFTJIS */ /*::[*/ 129: 949,
    /* HANGUL */ /*::[*/ 130: 1361,
    /* JOHAB */ /*::[*/ 134: 936,
    /* GB2312 */ /*::[*/ 136: 950,
    /* CHINESEBIG5 */ /*::[*/ 161: 1253,
    /* GREEK */ /*::[*/ 162: 1254,
    /* TURKISH */ /*::[*/ 163: 1258,
    /* VIETNAMESE */ /*::[*/ 177: 1255,
    /* HEBREW */ /*::[*/ 178: 1256,
    /* ARABIC */ /*::[*/ 186: 1257,
    /* BALTIC */ /*::[*/ 204: 1251,
    /* RUSSIAN */ /*::[*/ 222: 874,
    /* THAI */ /*::[*/ 238: 1250,
    /* EASTEUROPE */ /*::[*/ 255: 1252,
    /* OEM */ /*::[*/ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $9d5117faee5c78f9$var$set_ansi = function(cp /*:number*/ ) {
    if ($9d5117faee5c78f9$var$VALID_ANSI.indexOf(cp) == -1) return;
    $9d5117faee5c78f9$var$current_ansi = $9d5117faee5c78f9$var$CS2CP[0] = cp;
};
function $9d5117faee5c78f9$var$reset_ansi() {
    $9d5117faee5c78f9$var$set_ansi(1252);
}
var $9d5117faee5c78f9$var$set_cp = function(cp /*:number*/ ) {
    $9d5117faee5c78f9$var$current_codepage = cp;
    $9d5117faee5c78f9$var$set_ansi(cp);
};
function $9d5117faee5c78f9$var$reset_cp() {
    $9d5117faee5c78f9$var$set_cp(1200);
    $9d5117faee5c78f9$var$reset_ansi();
}
function $9d5117faee5c78f9$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $9d5117faee5c78f9$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $9d5117faee5c78f9$var$utf16lereadu(data /*:Uint8Array*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data[2 * i] + (data[2 * i + 1] << 8));
    return o.join("");
}
function $9d5117faee5c78f9$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $9d5117faee5c78f9$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $9d5117faee5c78f9$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $9d5117faee5c78f9$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $9d5117faee5c78f9$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $9d5117faee5c78f9$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
function $9d5117faee5c78f9$export$58f247d16f363b86(cptable) {
    $9d5117faee5c78f9$var$$cptable = cptable;
    $9d5117faee5c78f9$var$set_cp = function(cp /*:number*/ ) {
        $9d5117faee5c78f9$var$current_codepage = cp;
        $9d5117faee5c78f9$var$set_ansi(cp);
    };
    $9d5117faee5c78f9$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $9d5117faee5c78f9$var$$cptable.utils.decode(1200, $9d5117faee5c78f9$var$char_codes(data.slice(2)));
        return data;
    };
    $9d5117faee5c78f9$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($9d5117faee5c78f9$var$current_codepage === 1200) return String.fromCharCode(x);
        return $9d5117faee5c78f9$var$$cptable.utils.decode($9d5117faee5c78f9$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $9d5117faee5c78f9$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $9d5117faee5c78f9$var$$cptable.utils.decode($9d5117faee5c78f9$var$current_ansi, [
            x
        ])[0];
    };
    $9d5117faee5c78f9$var$cpdoit();
}
var $9d5117faee5c78f9$var$DENSE = null;
var $9d5117faee5c78f9$var$DIF_XL = true;
var $9d5117faee5c78f9$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $9d5117faee5c78f9$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $9d5117faee5c78f9$var$Base64_map.charAt(e1) + $9d5117faee5c78f9$var$Base64_map.charAt(e2) + $9d5117faee5c78f9$var$Base64_map.charAt(e3) + $9d5117faee5c78f9$var$Base64_map.charAt(e4);
    }
    return o;
}
function $9d5117faee5c78f9$var$Base64_encode_pass(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        if (c1 > 255) c1 = 95;
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        if (c2 > 255) c2 = 95;
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        if (c3 > 255) c3 = 95;
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $9d5117faee5c78f9$var$Base64_map.charAt(e1) + $9d5117faee5c78f9$var$Base64_map.charAt(e2) + $9d5117faee5c78f9$var$Base64_map.charAt(e3) + $9d5117faee5c78f9$var$Base64_map.charAt(e4);
    }
    return o;
}
function $9d5117faee5c78f9$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    input = input.replace(/^data:([^\/]+\/[^\/]+)?;base64\,/, "").replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $9d5117faee5c78f9$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $9d5117faee5c78f9$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $9d5117faee5c78f9$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $9d5117faee5c78f9$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $9d5117faee5c78f9$var$has_buf = /*#__PURE__*/ function() {
    return typeof $9d5117faee5c78f9$require$Buffer !== 'undefined' && false;
}();
var $9d5117faee5c78f9$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $9d5117faee5c78f9$require$Buffer !== 'undefined') {
        var nbfs = !$9d5117faee5c78f9$require$Buffer.from;
        if (!nbfs) try {
            $9d5117faee5c78f9$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $9d5117faee5c78f9$require$Buffer(buf, enc) : new $9d5117faee5c78f9$require$Buffer(buf);
        } : $9d5117faee5c78f9$require$Buffer.from.bind($9d5117faee5c78f9$require$Buffer);
    }
    return function() {};
}();
var $9d5117faee5c78f9$var$buf_utf16le = /*#__PURE__*/ function() {
    if (typeof $9d5117faee5c78f9$require$Buffer === 'undefined') return false;
    var x = $9d5117faee5c78f9$var$Buffer_from([
        65,
        0
    ]);
    if (!x) return false;
    var o = x.toString("utf16le");
    return o.length == 1;
}();
function $9d5117faee5c78f9$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($9d5117faee5c78f9$var$has_buf) return $9d5117faee5c78f9$require$Buffer.alloc ? $9d5117faee5c78f9$require$Buffer.alloc(len) : new $9d5117faee5c78f9$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $9d5117faee5c78f9$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($9d5117faee5c78f9$var$has_buf) return $9d5117faee5c78f9$require$Buffer.allocUnsafe ? $9d5117faee5c78f9$require$Buffer.allocUnsafe(len) : new $9d5117faee5c78f9$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $9d5117faee5c78f9$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($9d5117faee5c78f9$var$has_buf) return $9d5117faee5c78f9$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $9d5117faee5c78f9$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === 'undefined') return $9d5117faee5c78f9$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $9d5117faee5c78f9$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $9d5117faee5c78f9$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === 'undefined') throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $9d5117faee5c78f9$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $9d5117faee5c78f9$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $9d5117faee5c78f9$var$bconcat = $9d5117faee5c78f9$var$has_buf ? function(bufs) {
    return $9d5117faee5c78f9$require$Buffer.concat(bufs.map(function(buf) {
        return $9d5117faee5c78f9$require$Buffer.isBuffer(buf) ? buf : $9d5117faee5c78f9$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") o.set(new Uint8Array($9d5117faee5c78f9$var$s2a(bufs[i])), maxlen);
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $9d5117faee5c78f9$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $9d5117faee5c78f9$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $9d5117faee5c78f9$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $9d5117faee5c78f9$var$bconcat(out);
}
var $9d5117faee5c78f9$var$chr0 = /\u0000/g, $9d5117faee5c78f9$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $9d5117faee5c78f9$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $9d5117faee5c78f9$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $9d5117faee5c78f9$var$fill('0', d - t.length) + t;
}
function $9d5117faee5c78f9$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $9d5117faee5c78f9$var$fill(' ', d - t.length) + t;
}
function $9d5117faee5c78f9$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $9d5117faee5c78f9$var$fill(' ', d - t.length);
}
function $9d5117faee5c78f9$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $9d5117faee5c78f9$var$fill('0', d - t.length) + t;
}
function $9d5117faee5c78f9$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $9d5117faee5c78f9$var$fill('0', d - t.length) + t;
}
var $9d5117faee5c78f9$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $9d5117faee5c78f9$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $9d5117faee5c78f9$var$p2_32 || v < -$9d5117faee5c78f9$var$p2_32) return $9d5117faee5c78f9$var$pad0r1(v, d);
    var i = Math.round(v);
    return $9d5117faee5c78f9$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $9d5117faee5c78f9$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $9d5117faee5c78f9$var$days /*:Array<Array<string> >*/  = [
    [
        'Sun',
        'Sunday'
    ],
    [
        'Mon',
        'Monday'
    ],
    [
        'Tue',
        'Tuesday'
    ],
    [
        'Wed',
        'Wednesday'
    ],
    [
        'Thu',
        'Thursday'
    ],
    [
        'Fri',
        'Friday'
    ],
    [
        'Sat',
        'Saturday'
    ]
];
var $9d5117faee5c78f9$var$months /*:Array<Array<string> >*/  = [
    [
        'J',
        'Jan',
        'January'
    ],
    [
        'F',
        'Feb',
        'February'
    ],
    [
        'M',
        'Mar',
        'March'
    ],
    [
        'A',
        'Apr',
        'April'
    ],
    [
        'M',
        'May',
        'May'
    ],
    [
        'J',
        'Jun',
        'June'
    ],
    [
        'J',
        'Jul',
        'July'
    ],
    [
        'A',
        'Aug',
        'August'
    ],
    [
        'S',
        'Sep',
        'September'
    ],
    [
        'O',
        'Oct',
        'October'
    ],
    [
        'N',
        'Nov',
        'November'
    ],
    [
        'D',
        'Dec',
        'December'
    ]
];
function $9d5117faee5c78f9$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = 'General';
    t[1] = '0';
    t[2] = '0.00';
    t[3] = '#,##0';
    t[4] = '#,##0.00';
    t[9] = '0%';
    t[10] = '0.00%';
    t[11] = '0.00E+00';
    t[12] = '# ?/?';
    t[13] = '# ??/??';
    t[14] = 'm/d/yy';
    t[15] = 'd-mmm-yy';
    t[16] = 'd-mmm';
    t[17] = 'mmm-yy';
    t[18] = 'h:mm AM/PM';
    t[19] = 'h:mm:ss AM/PM';
    t[20] = 'h:mm';
    t[21] = 'h:mm:ss';
    t[22] = 'm/d/yy h:mm';
    t[37] = '#,##0 ;(#,##0)';
    t[38] = '#,##0 ;[Red](#,##0)';
    t[39] = '#,##0.00;(#,##0.00)';
    t[40] = '#,##0.00;[Red](#,##0.00)';
    t[45] = 'mm:ss';
    t[46] = '[h]:mm:ss';
    t[47] = 'mmss.0';
    t[48] = '##0.0E+0';
    t[49] = '@';
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $9d5117faee5c78f9$var$table_fmt = {
    0: 'General',
    1: '0',
    2: '0.00',
    3: '#,##0',
    4: '#,##0.00',
    9: '0%',
    10: '0.00%',
    11: '0.00E+00',
    12: '# ?/?',
    13: '# ??/??',
    14: 'm/d/yy',
    15: 'd-mmm-yy',
    16: 'd-mmm',
    17: 'mmm-yy',
    18: 'h:mm AM/PM',
    19: 'h:mm:ss AM/PM',
    20: 'h:mm',
    21: 'h:mm:ss',
    22: 'm/d/yy h:mm',
    37: '#,##0 ;(#,##0)',
    38: '#,##0 ;[Red](#,##0)',
    39: '#,##0.00;(#,##0.00)',
    40: '#,##0.00;[Red](#,##0.00)',
    45: 'mm:ss',
    46: '[h]:mm:ss',
    47: 'mmss.0',
    48: '##0.0E+0',
    49: '@',
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $9d5117faee5c78f9$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $9d5117faee5c78f9$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $9d5117faee5c78f9$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $9d5117faee5c78f9$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $9d5117faee5c78f9$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
var $9d5117faee5c78f9$var$SSFbasedate = /*#__PURE__*/ new Date(1899, 11, 31, 0, 0, 0);
var $9d5117faee5c78f9$var$SSFdnthresh = /*#__PURE__*/ $9d5117faee5c78f9$var$SSFbasedate.getTime();
var $9d5117faee5c78f9$var$SSFbase1904 = /*#__PURE__*/ new Date(1900, 2, 1, 0, 0, 0);
function $9d5117faee5c78f9$var$datenum_local(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126230400000;
    else if (v >= $9d5117faee5c78f9$var$SSFbase1904) epoch += 86400000;
    return (epoch - ($9d5117faee5c78f9$var$SSFdnthresh + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ $9d5117faee5c78f9$var$SSFbasedate.getTimezoneOffset()) * 60000)) / 86400000;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $9d5117faee5c78f9$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $9d5117faee5c78f9$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $9d5117faee5c78f9$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $9d5117faee5c78f9$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $9d5117faee5c78f9$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $9d5117faee5c78f9$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $9d5117faee5c78f9$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $9d5117faee5c78f9$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $9d5117faee5c78f9$var$SSF_large_exp(v);
    return $9d5117faee5c78f9$var$SSF_strip_decimal($9d5117faee5c78f9$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $9d5117faee5c78f9$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? "TRUE" : "FALSE";
        case 'number':
            return (v | 0) === v ? v.toString(10) : $9d5117faee5c78f9$var$SSF_general_num(v);
        case 'undefined':
            return "";
        case 'object':
            if (v == null) return "";
            if (v instanceof Date) return $9d5117faee5c78f9$var$SSF_format(14, $9d5117faee5c78f9$var$datenum_local(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $9d5117faee5c78f9$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $9d5117faee5c78f9$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $9d5117faee5c78f9$var$months[val.m - 1][1];
                case 5:
                    return $9d5117faee5c78f9$var$months[val.m - 1][0];
                default:
                    return $9d5117faee5c78f9$var$months[val.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $9d5117faee5c78f9$var$days[val.q][0];
                default:
                    return $9d5117faee5c78f9$var$days[val.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.H;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.M;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad minute format: ' + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
            if (val.u === 0 && (fmt == "s" || fmt == "ss")) return $9d5117faee5c78f9$var$pad0(val.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val.S + val.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === 's') return ss === 0 ? "0" : "" + ss / tt;
            o = $9d5117faee5c78f9$var$pad0(ss, 2 + ss0);
            if (fmt === 'ss') return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case '[h]':
                case '[hh]':
                    out = val.D * 24 + val.H;
                    break;
                case '[m]':
                case '[mm]':
                    out = (val.D * 24 + val.H) * 60 + val.M;
                    break;
                case '[s]':
                case '[ss]':
                    out = ((val.D * 24 + val.H) * 60 + val.M) * 60 + Math.round(val.S + val.u);
                    break;
                default:
                    throw 'bad abstime format: ' + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $9d5117faee5c78f9$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $9d5117faee5c78f9$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $9d5117faee5c78f9$var$pct1 = /%/g;
function $9d5117faee5c78f9$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($9d5117faee5c78f9$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $9d5117faee5c78f9$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $9d5117faee5c78f9$var$fill("%", mul);
}
function $9d5117faee5c78f9$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $9d5117faee5c78f9$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $9d5117faee5c78f9$var$write_num_exp(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $9d5117faee5c78f9$var$write_num_exp(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $9d5117faee5c78f9$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $9d5117faee5c78f9$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $9d5117faee5c78f9$var$fill(" ", r[1].length + 1 + r[4].length) : $9d5117faee5c78f9$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $9d5117faee5c78f9$var$pad0(myd, r[4].length));
}
function $9d5117faee5c78f9$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $9d5117faee5c78f9$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $9d5117faee5c78f9$var$dec1 = /^#*0*\.([0#]+)/;
var $9d5117faee5c78f9$var$closeparen = /\).*[0#]/;
var $9d5117faee5c78f9$var$phone = /\(###\) ###\\?-####/;
function $9d5117faee5c78f9$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $9d5117faee5c78f9$var$rnd(val /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val * dd) / dd;
}
function $9d5117faee5c78f9$var$dec(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val - Math.floor(val), dd = Math.pow(10, d);
    if (d < ('' + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $9d5117faee5c78f9$var$carry(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ('' + Math.round((val - Math.floor(val)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $9d5117faee5c78f9$var$flr(val /*:number*/ ) /*:string*/ {
    if (val < 2147483647 && val > -2147483648) return "" + (val >= 0 ? val | 0 : val - 1 | 0);
    return "" + Math.floor(val);
}
function $9d5117faee5c78f9$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($9d5117faee5c78f9$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $9d5117faee5c78f9$var$write_num_flt('n', ffmt, val);
        return '(' + $9d5117faee5c78f9$var$write_num_flt('n', ffmt, -val) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $9d5117faee5c78f9$var$write_num_cm(type, fmt, val);
    if (fmt.indexOf('%') !== -1) return $9d5117faee5c78f9$var$write_num_pct(type, fmt, val);
    if (fmt.indexOf('E') !== -1) return $9d5117faee5c78f9$var$write_num_exp(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $9d5117faee5c78f9$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $9d5117faee5c78f9$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $9d5117faee5c78f9$var$pad0r(val, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $9d5117faee5c78f9$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($9d5117faee5c78f9$var$frac1)) return $9d5117faee5c78f9$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $9d5117faee5c78f9$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($9d5117faee5c78f9$var$dec1)) {
        o = $9d5117faee5c78f9$var$rnd(val, r[1].length).replace(/^([^\.]+)$/, "$1." + $9d5117faee5c78f9$var$hashq(r[1])).replace(/\.$/, "." + $9d5117faee5c78f9$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $9d5117faee5c78f9$var$fill("0", $9d5117faee5c78f9$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $9d5117faee5c78f9$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $9d5117faee5c78f9$var$commaify($9d5117faee5c78f9$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $9d5117faee5c78f9$var$write_num_flt(type, fmt, -val) : $9d5117faee5c78f9$var$commaify("" + (Math.floor(val) + $9d5117faee5c78f9$var$carry(val, r[1].length))) + "." + $9d5117faee5c78f9$var$pad0($9d5117faee5c78f9$var$dec(val, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $9d5117faee5c78f9$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $9d5117faee5c78f9$var$_strrev($9d5117faee5c78f9$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $9d5117faee5c78f9$var$_strrev($9d5117faee5c78f9$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($9d5117faee5c78f9$var$phone)) {
        o = $9d5117faee5c78f9$var$write_num_flt(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $9d5117faee5c78f9$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $9d5117faee5c78f9$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $9d5117faee5c78f9$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $9d5117faee5c78f9$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $9d5117faee5c78f9$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $9d5117faee5c78f9$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $9d5117faee5c78f9$var$rpad_(ff[2], ri) : $9d5117faee5c78f9$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $9d5117faee5c78f9$var$pad0r(val, 0);
        if (fmt.length <= o.length) return o;
        return $9d5117faee5c78f9$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $9d5117faee5c78f9$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $9d5117faee5c78f9$var$dec(val, r[1].length);
        return val < 0 ? "-" + $9d5117faee5c78f9$var$write_num_flt(type, fmt, -val) : $9d5117faee5c78f9$var$commaify($9d5117faee5c78f9$var$flr(val)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $9d5117faee5c78f9$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $9d5117faee5c78f9$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $9d5117faee5c78f9$var$write_num_flt(type, "#,##0.00", val);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $9d5117faee5c78f9$var$commaify($9d5117faee5c78f9$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $9d5117faee5c78f9$var$write_num_flt(type, "###,##0.00", val).replace(/^0\./, ".");
        case "#,###.00":
            return $9d5117faee5c78f9$var$write_num_flt(type, "#,##0.00", val).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $9d5117faee5c78f9$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $9d5117faee5c78f9$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $9d5117faee5c78f9$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($9d5117faee5c78f9$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $9d5117faee5c78f9$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $9d5117faee5c78f9$var$fill("%", mul);
}
function $9d5117faee5c78f9$var$write_num_exp2(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $9d5117faee5c78f9$var$write_num_exp2(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $9d5117faee5c78f9$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($9d5117faee5c78f9$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $9d5117faee5c78f9$var$write_num_int('n', ffmt, val);
        return '(' + $9d5117faee5c78f9$var$write_num_int('n', ffmt, -val) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $9d5117faee5c78f9$var$write_num_cm2(type, fmt, val);
    if (fmt.indexOf('%') !== -1) return $9d5117faee5c78f9$var$write_num_pct2(type, fmt, val);
    if (fmt.indexOf('E') !== -1) return $9d5117faee5c78f9$var$write_num_exp2(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $9d5117faee5c78f9$var$write_num_int(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $9d5117faee5c78f9$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val;
        if (val === 0) o = "";
        return o.length > fmt.length ? o : $9d5117faee5c78f9$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($9d5117faee5c78f9$var$frac1)) return $9d5117faee5c78f9$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $9d5117faee5c78f9$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($9d5117faee5c78f9$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val).replace(/^([^\.]+)$/, "$1." + $9d5117faee5c78f9$var$hashq(r[1])).replace(/\.$/, "." + $9d5117faee5c78f9$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $9d5117faee5c78f9$var$fill("0", $9d5117faee5c78f9$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $9d5117faee5c78f9$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $9d5117faee5c78f9$var$write_num_int(type, fmt, -val) : $9d5117faee5c78f9$var$commaify("" + val) + "." + $9d5117faee5c78f9$var$fill('0', r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $9d5117faee5c78f9$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $9d5117faee5c78f9$var$_strrev($9d5117faee5c78f9$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $9d5117faee5c78f9$var$_strrev($9d5117faee5c78f9$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($9d5117faee5c78f9$var$phone)) {
        o = $9d5117faee5c78f9$var$write_num_int(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $9d5117faee5c78f9$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $9d5117faee5c78f9$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $9d5117faee5c78f9$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $9d5117faee5c78f9$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $9d5117faee5c78f9$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $9d5117faee5c78f9$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $9d5117faee5c78f9$var$rpad_(ff[2], ri) : $9d5117faee5c78f9$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val;
        if (fmt.length <= o.length) return o;
        return $9d5117faee5c78f9$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $9d5117faee5c78f9$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val < 0 ? "-" + $9d5117faee5c78f9$var$write_num_int(type, fmt, -val) : $9d5117faee5c78f9$var$commaify("" + val).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $9d5117faee5c78f9$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $9d5117faee5c78f9$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $9d5117faee5c78f9$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $9d5117faee5c78f9$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val) + $9d5117faee5c78f9$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $9d5117faee5c78f9$var$write_num(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    return (val | 0) === val ? $9d5117faee5c78f9$var$write_num_int(type, fmt, val) : $9d5117faee5c78f9$var$write_num_flt(type, fmt, val);
}
function $9d5117faee5c78f9$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $9d5117faee5c78f9$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $9d5117faee5c78f9$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            if ($9d5117faee5c78f9$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case '\\':
            i += 2;
            break;
        case '_':
            i += 2;
            break;
        case '@':
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            return true;
        case 'A':
        case 'a':
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.match($9d5117faee5c78f9$var$SSF_abstime)) return true;
            break;
        case '.':
        /* falls through */ case '0':
        case '#':
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == '\\' && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case '?':
            while(fmt.charAt(++i) === c);
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break;
        case '(':
        case ')':
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case ' ':
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $9d5117faee5c78f9$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = 't', dt, j, cc;
    var hr = 'H';
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            /* General */ if (!$9d5117faee5c78f9$var$SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 'G',
                v: 'General'
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: 't',
                v: o
            };
            ++i;
            break;
        case '\\':
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : 't';
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case '_':
            out[out.length] = {
                t: 't',
                v: " "
            };
            i += 2;
            break;
        case '@':
            /* Text Placeholder */ out[out.length] = {
                t: 'T',
                v: v
            };
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $9d5117faee5c78f9$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'X',
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
            c = c.toLowerCase();
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            if (v < 0) return "";
            if (dt == null) {
                dt = $9d5117faee5c78f9$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === 'm' && lst.toLowerCase() === 'h') c = 'M';
            if (c === 'h') c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case 'A':
        case 'a':
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $9d5117faee5c78f9$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? fmt.charAt(i + 2) : c;
                q.t = 'T';
                hr = 'h';
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === 'T') return "";
            out[out.length] = q;
            lst = c;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
            if (o.match($9d5117faee5c78f9$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $9d5117faee5c78f9$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'Z',
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$9d5117faee5c78f9$var$fmt_is_date(fmt)) out[out.length] = {
                    t: 't',
                    v: o
                };
            }
            break;
        /* Numbers */ case '.':
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: 's',
                    v: o
                };
                break;
            }
        /* falls through */ case '0':
        case '#':
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: 'n',
                v: o
            };
            break;
        case '?':
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break; // **
        case '(':
        case ')':
            out[out.length] = {
                t: flen === 1 ? 't' : c,
                v: c
            };
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: 'D',
                v: o
            };
            break;
        case ' ':
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case '$':
            out[out.length] = {
                t: 't',
                v: '$'
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 't',
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = 't'; i >= 0; --i)switch(out[i].t){
        case 'h':
        case 'H':
            out[i].t = hr;
            lst = 'h';
            if (bt < 1) bt = 1;
            break;
        case 's':
            if (ssm = out[i].v.match(/\.0+$/)) ss0 = Math.max(ss0, ssm[0].length - 1);
            if (bt < 3) bt = 3;
        /* falls through */ case 'd':
        case 'y':
        case 'M':
        case 'e':
            lst = out[i].t;
            break;
        case 'm':
            if (lst === 's') {
                out[i].t = 'M';
                if (bt < 2) bt = 2;
            }
            break;
        case 'X':
            break;
        case 'Z':
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ switch(bt){
        case 0:
            break;
        case 1:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            break;
        case 2:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case 't':
        case 'T':
        case ' ':
        case 'D':
            break;
        case 'X':
            out[i].v = "";
            out[i].t = ";";
            break;
        case 'd':
        case 'm':
        case 'y':
        case 'h':
        case 'H':
        case 'M':
        case 's':
        case 'e':
        case 'b':
        case 'Z':
            /*::if(!dt) throw "unreachable"; */ out[i].v = $9d5117faee5c78f9$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = 't';
            break;
        case 'n':
        case '?':
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === '?' || out[jj + 1].t === "t" && out[jj + 1].v === '/') || out[i].t === '(' && (c === ' ' || c === 'n' || c === ')') || c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj + 1] != null && out[jj + 1].t == '?'))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case 'G':
            out[i].t = 't';
            out[i].v = $9d5117faee5c78f9$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $9d5117faee5c78f9$var$write_num('n', nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $9d5117faee5c78f9$var$write_num('n', nstr, myv);
            if (myv < 0 && out[0] && out[0].t == 't') {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || 'n?('.indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && 'n?'.indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $9d5117faee5c78f9$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = 't';
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $9d5117faee5c78f9$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $9d5117faee5c78f9$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $9d5117faee5c78f9$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $9d5117faee5c78f9$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($9d5117faee5c78f9$var$cfregex2);
        var m2 = fmt[1].match($9d5117faee5c78f9$var$cfregex2);
        return $9d5117faee5c78f9$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $9d5117faee5c78f9$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $9d5117faee5c78f9$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $9d5117faee5c78f9$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$9d5117faee5c78f9$var$SSF_default_map[fmt]] || $9d5117faee5c78f9$var$table_fmt[$9d5117faee5c78f9$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $9d5117faee5c78f9$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($9d5117faee5c78f9$var$SSF_isgeneral(sfmt, 0)) return $9d5117faee5c78f9$var$SSF_general(v, o);
    if (v instanceof Date) v = $9d5117faee5c78f9$var$datenum_local(v, o.date1904);
    var f = $9d5117faee5c78f9$var$choose_fmt(sfmt, v);
    if ($9d5117faee5c78f9$var$SSF_isgeneral(f[1])) return $9d5117faee5c78f9$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    return $9d5117faee5c78f9$var$eval_fmt(f[1], v, o, f[0]);
}
function $9d5117faee5c78f9$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != 'number') {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($9d5117faee5c78f9$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($9d5117faee5c78f9$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $9d5117faee5c78f9$var$table_fmt[idx] = fmt;
    return idx;
}
function $9d5117faee5c78f9$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $9d5117faee5c78f9$var$SSF_load(tbl[i], i);
}
function $9d5117faee5c78f9$var$make_ssf() {
    $9d5117faee5c78f9$var$table_fmt = $9d5117faee5c78f9$var$SSF_init_table();
}
var $9d5117faee5c78f9$export$40d8edd678456c2b = {
    format: $9d5117faee5c78f9$var$SSF_format,
    load: $9d5117faee5c78f9$var$SSF_load,
    _table: $9d5117faee5c78f9$var$table_fmt,
    load_table: $9d5117faee5c78f9$var$SSF_load_table,
    parse_date_code: $9d5117faee5c78f9$var$SSF_parse_date_code,
    is_date: $9d5117faee5c78f9$var$fmt_is_date,
    get_table: function get_table() {
        return $9d5117faee5c78f9$export$40d8edd678456c2b._table = $9d5117faee5c78f9$var$table_fmt;
    }
};
var $9d5117faee5c78f9$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": 'General',
    "24": 'General',
    "25": 'General',
    "26": 'General',
    "27": 'm/d/yy',
    "28": 'm/d/yy',
    "29": 'm/d/yy',
    "30": 'm/d/yy',
    "31": 'm/d/yy',
    "32": 'h:mm:ss',
    "33": 'h:mm:ss',
    "34": 'h:mm:ss',
    "35": 'h:mm:ss',
    "36": 'm/d/yy',
    "41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
    "50": 'm/d/yy',
    "51": 'm/d/yy',
    "52": 'm/d/yy',
    "53": 'm/d/yy',
    "54": 'm/d/yy',
    "55": 'm/d/yy',
    "56": 'm/d/yy',
    "57": 'm/d/yy',
    "58": 'm/d/yy',
    "59": '0',
    "60": '0.00',
    "61": '#,##0',
    "62": '#,##0.00',
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": '0%',
    "68": '0.00%',
    "69": '# ?/?',
    "70": '# ??/??',
    "71": 'm/d/yy',
    "72": 'm/d/yy',
    "73": 'd-mmm-yy',
    "74": 'd-mmm',
    "75": 'mmm-yy',
    "76": 'h:mm',
    "77": 'h:mm:ss',
    "78": 'm/d/yy h:mm',
    "79": 'mm:ss',
    "80": '[h]:mm:ss',
    "81": 'mmss.0'
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $9d5117faee5c78f9$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $9d5117faee5c78f9$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $9d5117faee5c78f9$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($9d5117faee5c78f9$var$dateNFregex, "(\\d+)");
    return new RegExp("^" + fmt + "$");
}
function $9d5117faee5c78f9$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($9d5117faee5c78f9$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case 'y':
                Y = v;
                break;
            case 'd':
                d = v;
                break;
            case 'h':
                H = v;
                break;
            case 's':
                S = v;
                break;
            case 'm':
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/* table of bad formats written by third-party tools */ var $9d5117faee5c78f9$var$bad_formats = {
    "d.m": "d\\.m" // Issue #2571 Google Sheets writes invalid format 'd.m', correct format is 'd"."m' or 'd\\.m'
};
function $9d5117faee5c78f9$var$SSF__load(fmt, idx) {
    return $9d5117faee5c78f9$var$SSF_load($9d5117faee5c78f9$var$bad_formats[fmt] || fmt, idx);
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $9d5117faee5c78f9$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = '1.2.0';
    /* see perf/crc32table.js */ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== 'undefined' && typeof table.subarray == "function" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $9d5117faee5c78f9$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports /*:CFBModule*/  = /*::(*/ {} /*:: :any)*/ ;
    exports.version = '1.2.2';
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val.setMilliseconds(0);
        val.setFullYear(ymd + 1980);
        val.setMonth(m - 1);
        val.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val.setHours(hms);
        val.setMinutes(M);
        val.setSeconds(S << 1);
        return val;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $9d5117faee5c78f9$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
                /* ZIP64 Extended Information Field */ case 0x0001:
                    var sz1 = blob.read_shift(4), sz2 = blob.read_shift(4);
                    p.usz = sz2 * Math.pow(2, 32) + sz1;
                    sz1 = blob.read_shift(4);
                    sz2 = blob.read_shift(4);
                    p.csz = sz2 * Math.pow(2, 32) + sz1;
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = $9d5117faee5c78f9$var$_fs);
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $9d5117faee5c78f9$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $9d5117faee5c78f9$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, 'i');
        if (mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, 'i');
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk('00100000', 'Mini Stream Cutoff Size: ');
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, 'i');
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, 'i');
        // First DIFAT sector location
        difat_start = blob.read_shift(4, 'i');
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, 'i');
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, 'i');
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        if (dir_start < sector_list.length) sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, 'u');
        return [
            blob.read_shift(2, 'u'),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift);
                break;
            default:
                throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
        }
        // Mini Sector Shift
        blob.chk('0600', 'Mini Sector Shift: ');
        // Reserved
        blob.chk('000000000000', 'Reserved: ');
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $9d5117faee5c78f9$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $9d5117faee5c78f9$var$new_buf(0);
        return $9d5117faee5c78f9$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $9d5117faee5c78f9$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            if (cnt >= 1) sleuth_fat($9d5117faee5c78f9$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $9d5117faee5c78f9$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $9d5117faee5c78f9$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $9d5117faee5c78f9$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $9d5117faee5c78f9$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $9d5117faee5c78f9$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $9d5117faee5c78f9$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, 'i'),
                R: blob.read_shift(4, 'i'),
                C: blob.read_shift(4, 'i'),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, 'i'),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, 'i');
            o.size = blob.read_shift(4, 'i');
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = 'fat';
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = 'minifat';
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $9d5117faee5c78f9$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($9d5117faee5c78f9$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $9d5117faee5c78f9$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($9d5117faee5c78f9$var$s2a($9d5117faee5c78f9$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($9d5117faee5c78f9$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\u0001Sh33tJ5";
        if ($9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $9d5117faee5c78f9$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            while(!s){
                while(dirname(dad) && !fullPaths[dirname(dad)])dad = dirname(dad);
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
                dad = dirname(data[i][0]);
                s = fullPaths[dad];
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == 'mad') return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case 'zip':
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $9d5117faee5c78f9$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            if (_nm.length > 32) {
                console.error("Name " + _nm + " will be truncated to " + _nm.slice(0, 32));
                _nm = _nm.slice(0, 32);
            }
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($9d5117faee5c78f9$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($9d5117faee5c78f9$var$chr1);
        UCPath = UCPath.replace($9d5117faee5c78f9$var$chr0, '');
        if (m) UCPath = UCPath.replace($9d5117faee5c78f9$var$chr1, '!');
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($9d5117faee5c78f9$var$chr1, '!') : UCFullPaths[w]).replace($9d5117faee5c78f9$var$chr0, '') == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($9d5117faee5c78f9$var$chr1, '!') : UCPaths[w]).replace($9d5117faee5c78f9$var$chr0, '') == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = '00000000000000000000000000000000';
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: '3e00',
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            'unknown',
            'storage',
            'stream',
            'lockbytes',
            'property',
            'root'
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $9d5117faee5c78f9$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($9d5117faee5c78f9$var$has_buf) return $9d5117faee5c78f9$require$Buffer.isBuffer(o) ? o : $9d5117faee5c78f9$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $9d5117faee5c78f9$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== 'undefined';
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($9d5117faee5c78f9$var$has_buf) {
            var o = $9d5117faee5c78f9$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $9d5117faee5c78f9$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $9d5117faee5c78f9$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $9d5117faee5c78f9$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== 'undefined') console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $9d5117faee5c78f9$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            /* ZIP64 lengths */ if (EF && EF[0x0001]) {
                if ((EF[0x0001] || {}).usz) usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) csz = EF[0x0001].csz;
            }
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if ((ef[0x0001] || {}).usz) _usz = ef[0x0001].usz;
            if ((ef[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            if (EF) {
                if ((EF[0x5455] || {}).mt) date = EF[0x5455].mt;
                if ((EF[0x0001] || {}).usz) _usz = ef[0x0001].usz;
                if ((EF[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            }
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $9d5117faee5c78f9$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $9d5117faee5c78f9$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = typeof fi.content == "string" ? $9d5117faee5c78f9$var$CRC32.bstr(fi.content, 0) : $9d5117faee5c78f9$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = typeof fi.content == "string" ? $9d5117faee5c78f9$var$s2a(fi.content) : fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $9d5117faee5c78f9$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $9d5117faee5c78f9$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $9d5117faee5c78f9$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $9d5117faee5c78f9$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $9d5117faee5c78f9$var$bconcat([
            $9d5117faee5c78f9$var$bconcat(out /*:any*/ ),
            $9d5117faee5c78f9$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $9d5117faee5c78f9$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $9d5117faee5c78f9$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^(.*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case 'base64':
                fdata = $9d5117faee5c78f9$var$s2a($9d5117faee5c78f9$var$Base64_decode(data.slice(di).join("")));
                break;
            case 'quoted-printable':
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = '------=' + boundary;
        var out = [
            'MIME-Version: 1.0',
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            '',
            '',
            ''
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
            out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
            out.push('Content-Type: ' + get_content_type(fi, fp));
            out.push('');
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + '--\r\n');
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $9d5117faee5c78f9$var$ReadShift,
        CheckField: $9d5117faee5c78f9$var$CheckField,
        prep_blob: $9d5117faee5c78f9$var$prep_blob,
        bconcat: $9d5117faee5c78f9$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
var $9d5117faee5c78f9$var$_fs;
function $9d5117faee5c78f9$export$a48eb669e1768bcf(fs) {
    $9d5117faee5c78f9$var$_fs = fs;
}
/* normalize data for blob ctor */ function $9d5117faee5c78f9$var$blobify(data) {
    if (typeof data === "string") return $9d5117faee5c78f9$var$s2ab(data);
    if (Array.isArray(data)) return $9d5117faee5c78f9$var$a2u(data);
    return data;
}
/* write or download file */ function $9d5117faee5c78f9$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $9d5117faee5c78f9$var$_fs !== 'undefined' && $9d5117faee5c78f9$var$_fs.writeFileSync) return enc ? $9d5117faee5c78f9$var$_fs.writeFileSync(fname, payload, enc) : $9d5117faee5c78f9$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== 'undefined') {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $9d5117faee5c78f9$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $9d5117faee5c78f9$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
    if (typeof Blob !== 'undefined') {
        var blob = new Blob([
            $9d5117faee5c78f9$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== 'undefined') return saveAs(blob, fname);
        if (typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === 'object' && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        }
    }
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $9d5117faee5c78f9$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $9d5117faee5c78f9$var$read_binary(path /*:string*/ ) {
    if (typeof $9d5117faee5c78f9$var$_fs !== 'undefined') return $9d5117faee5c78f9$var$_fs.readFileSync(path);
    if (typeof Deno !== 'undefined') return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $9d5117faee5c78f9$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $9d5117faee5c78f9$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $9d5117faee5c78f9$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $9d5117faee5c78f9$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $9d5117faee5c78f9$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $9d5117faee5c78f9$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $9d5117faee5c78f9$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $9d5117faee5c78f9$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $9d5117faee5c78f9$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $9d5117faee5c78f9$var$basedate = /*#__PURE__*/ new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
function $9d5117faee5c78f9$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126316800000;
    var dnthresh = /*#__PURE__*/ $9d5117faee5c78f9$var$basedate.getTime() + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ $9d5117faee5c78f9$var$basedate.getTimezoneOffset()) * 60000;
    return (epoch - dnthresh) / 86400000;
}
var $9d5117faee5c78f9$var$refdate = /*#__PURE__*/ new Date();
var $9d5117faee5c78f9$var$dnthresh = /*#__PURE__*/ $9d5117faee5c78f9$var$basedate.getTime() + /*#__PURE__*/ ($9d5117faee5c78f9$var$refdate.getTimezoneOffset() - /*#__PURE__*/ $9d5117faee5c78f9$var$basedate.getTimezoneOffset()) * 60000;
var $9d5117faee5c78f9$var$refoffset = /*#__PURE__*/ $9d5117faee5c78f9$var$refdate.getTimezoneOffset();
function $9d5117faee5c78f9$var$numdate(v /*:number*/ ) /*:Date*/ {
    var out = new Date();
    out.setTime(v * 86400000 + $9d5117faee5c78f9$var$dnthresh);
    if (out.getTimezoneOffset() !== $9d5117faee5c78f9$var$refoffset) out.setTime(out.getTime() + (out.getTimezoneOffset() - $9d5117faee5c78f9$var$refoffset) * 60000);
    return out;
}
/* ISO 8601 Duration */ function $9d5117faee5c78f9$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case 'Y':
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case 'D':
                mt *= 24;
            /* falls through */ case 'H':
                mt *= 60;
            /* falls through */ case 'M':
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case 'S':
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
var $9d5117faee5c78f9$var$good_pd_date_1 = /*#__PURE__*/ new Date('2017-02-19T19:06:09.000Z');
var $9d5117faee5c78f9$var$good_pd_date = /*#__PURE__*/ isNaN(/*#__PURE__*/ $9d5117faee5c78f9$var$good_pd_date_1.getFullYear()) ? /*#__PURE__*/ new Date('2/19/17') : $9d5117faee5c78f9$var$good_pd_date_1;
var $9d5117faee5c78f9$var$good_pd = /*#__PURE__*/ $9d5117faee5c78f9$var$good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */ function $9d5117faee5c78f9$var$parseDate(str /*:string|Date*/ , fixdate /*:?number*/ ) /*:Date*/ {
    var d = new Date(str);
    if ($9d5117faee5c78f9$var$good_pd) {
        /*:: if(fixdate == null) fixdate = 0; */ if (fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60000);
        else if (fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60000);
        return d;
    }
    if (str instanceof Date) return str;
    if ($9d5117faee5c78f9$var$good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
        var s = d.getFullYear();
        if (str.indexOf("" + s) > -1) return d;
        d.setFullYear(d.getFullYear() + 100);
        return d;
    }
    var n = str.match(/\d+/g) || [
        "2017",
        "2",
        "19",
        "0",
        "0",
        "0"
    ];
    var out = new Date(+n[0], +n[1] - 1, +n[2], +n[3] || 0, +n[4] || 0, +n[5] || 0);
    if (str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60000);
    return out;
}
function $9d5117faee5c78f9$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(arr)) {
        if (debomit && $9d5117faee5c78f9$var$buf_utf16le) {
            // TODO: temporary patch
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $9d5117faee5c78f9$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $9d5117faee5c78f9$var$utf8write($9d5117faee5c78f9$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $9d5117faee5c78f9$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $9d5117faee5c78f9$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20ac": "\x80",
            "\u201a": "\x82",
            "\u0192": "\x83",
            "\u201e": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02c6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017d": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201c": "\x93",
            "\u201d": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02dc": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203a": "\x9b",
            "\u0153": "\x9c",
            "\u017e": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [];
    for(var i = 0; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
    return o.join("");
}
function $9d5117faee5c78f9$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != 'object' || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $9d5117faee5c78f9$var$dup(o[k]);
    return out;
}
function $9d5117faee5c78f9$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $9d5117faee5c78f9$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(](.*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
/* NOTE: Chrome rejects bare times like 1:23 PM */ var $9d5117faee5c78f9$var$FDRE1 = /^(0?\d|1[0-2])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))\s+([ap])m?$/;
function $9d5117faee5c78f9$var$fuzzytime1(M) /*:Date*/ {
    /* TODO: 1904 adjustment, keep in sync with base date */ if (!M[2]) return new Date(1899, 11, 30, +M[1] % 12 + (M[7] == "p" ? 12 : 0), 0, 0, 0);
    if (M[3]) {
        if (M[4]) return new Date(1899, 11, 30, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[4], parseFloat(M[3]) * 1000);
        else return new Date(1899, 11, 30, M[7] == "p" ? 12 : 0, +M[1], +M[2], parseFloat(M[3]) * 1000);
    } else if (M[5]) return new Date(1899, 11, 30, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0);
    else return new Date(1899, 11, 30, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], 0, 0);
}
var $9d5117faee5c78f9$var$lower_months = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
];
function $9d5117faee5c78f9$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    var lower = s.toLowerCase();
    var lnos = lower.replace(/\s+/g, " ").trim();
    var M = lnos.match($9d5117faee5c78f9$var$FDRE1);
    if (M) return $9d5117faee5c78f9$var$fuzzytime1(M);
    var o = new Date(s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $9d5117faee5c78f9$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.replace(/[ap]m?/, "").match(/[a-z]/)) return n;
    if (y < 0 || y > 8099 || s.match(/[^-0-9:,\/\\]/)) return n;
    return o;
}
var $9d5117faee5c78f9$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $9d5117faee5c78f9$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $9d5117faee5c78f9$var$cc2str(data.content, true);
    if (data.data) return $9d5117faee5c78f9$var$debom(data.data);
    if (data.asNodeBuffer && $9d5117faee5c78f9$var$has_buf) return $9d5117faee5c78f9$var$debom(data.asNodeBuffer().toString('binary'));
    if (data.asBinary) return $9d5117faee5c78f9$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $9d5117faee5c78f9$var$debom($9d5117faee5c78f9$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $9d5117faee5c78f9$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $9d5117faee5c78f9$var$char_codes(data.data);
    if (data.asNodeBuffer && $9d5117faee5c78f9$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $9d5117faee5c78f9$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $9d5117faee5c78f9$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $9d5117faee5c78f9$var$getdatabin(data) : $9d5117faee5c78f9$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $9d5117faee5c78f9$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $9d5117faee5c78f9$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g, '\/');
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $9d5117faee5c78f9$var$getzipfile(zip, file /*:string*/ ) {
    var o = $9d5117faee5c78f9$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $9d5117faee5c78f9$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $9d5117faee5c78f9$var$getdata($9d5117faee5c78f9$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $9d5117faee5c78f9$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $9d5117faee5c78f9$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $9d5117faee5c78f9$var$getdatastr($9d5117faee5c78f9$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $9d5117faee5c78f9$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $9d5117faee5c78f9$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $9d5117faee5c78f9$var$getdatabin($9d5117faee5c78f9$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $9d5117faee5c78f9$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $9d5117faee5c78f9$var$zipentries(zip) {
    var k = zip.FullPaths || $9d5117faee5c78f9$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $9d5117faee5c78f9$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (typeof content == "string") {
            var res;
            if ($9d5117faee5c78f9$var$has_buf) res = $9d5117faee5c78f9$var$Buffer_from(content);
            else res = $9d5117faee5c78f9$var$utf8decode(content);
            return $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $9d5117faee5c78f9$var$zip_new() {
    return $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_new();
}
function $9d5117faee5c78f9$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $9d5117faee5c78f9$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $9d5117faee5c78f9$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $9d5117faee5c78f9$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $9d5117faee5c78f9$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split('/');
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split('/');
    while(target.length !== 0){
        var step = target.shift();
        if (step === '..') result.pop();
        else if (step !== '.') result.push(step);
    }
    return result.join('/');
}
var $9d5117faee5c78f9$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $9d5117faee5c78f9$var$attregexg = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $9d5117faee5c78f9$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, $9d5117faee5c78f9$var$tagregex2 = /<[^>]*>/g;
var $9d5117faee5c78f9$var$tagregex = /*#__PURE__*/ $9d5117faee5c78f9$var$XML_HEADER.match($9d5117faee5c78f9$var$tagregex1) ? $9d5117faee5c78f9$var$tagregex1 : $9d5117faee5c78f9$var$tagregex2;
var $9d5117faee5c78f9$var$nsregex = /<\w*:/, $9d5117faee5c78f9$var$nsregex2 = /<(\/?)\w+:/;
function $9d5117faee5c78f9$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($9d5117faee5c78f9$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i];
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $9d5117faee5c78f9$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($9d5117faee5c78f9$var$nsregex2, "<$1");
}
var $9d5117faee5c78f9$var$encodings = {
    '&quot;': '"',
    '&apos;': "'",
    '&gt;': '>',
    '&lt;': '<',
    '&amp;': '&'
};
var $9d5117faee5c78f9$var$rencoding = /*#__PURE__*/ $9d5117faee5c78f9$var$evert($9d5117faee5c78f9$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $9d5117faee5c78f9$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    function raw_unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + '', i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $9d5117faee5c78f9$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return raw_unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + raw_unescapexml(s.slice(j + 3));
    }
    return function unescapexml(text /*:string*/ , xlsx /*:boolean*/ ) {
        var out = raw_unescapexml(text);
        return xlsx ? out.replace(/\r\n/g, "\n") : out;
    };
}();
var $9d5117faee5c78f9$var$decregex = /[&<>'"]/g, $9d5117faee5c78f9$var$charegex = /[\u0000-\u0008\u000b-\u001f\uFFFE-\uFFFF]/g;
function $9d5117faee5c78f9$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($9d5117faee5c78f9$var$decregex, function(y) {
        return $9d5117faee5c78f9$var$rencoding[y];
    }).replace($9d5117faee5c78f9$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $9d5117faee5c78f9$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $9d5117faee5c78f9$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $9d5117faee5c78f9$var$htmlcharegex = /[\u0000-\u001f]/g;
function $9d5117faee5c78f9$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($9d5117faee5c78f9$var$decregex, function(y) {
        return $9d5117faee5c78f9$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($9d5117faee5c78f9$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $9d5117faee5c78f9$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($9d5117faee5c78f9$var$decregex, function(y) {
        return $9d5117faee5c78f9$var$rencoding[y];
    }).replace($9d5117faee5c78f9$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $9d5117faee5c78f9$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $9d5117faee5c78f9$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "\&#10;");
}
/* note: xsd:boolean valid values: true / 1 / false / 0 */ function $9d5117faee5c78f9$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case '1':
        case 'true':
            return true;
        case 0:
        case false:
        case '0':
        case 'false':
            return false;
    }
    return false;
}
function $9d5117faee5c78f9$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $9d5117faee5c78f9$var$utf8readb(data) {
    var out = $9d5117faee5c78f9$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString('ucs2');
}
function $9d5117faee5c78f9$var$utf8readc(data) {
    return $9d5117faee5c78f9$var$Buffer_from(data, 'binary').toString('utf8');
}
var $9d5117faee5c78f9$var$utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
var $9d5117faee5c78f9$var$utf8read = $9d5117faee5c78f9$var$has_buf && /*#__PURE__*/ ($9d5117faee5c78f9$var$utf8readc($9d5117faee5c78f9$var$utf8corpus) == /*#__PURE__*/ $9d5117faee5c78f9$var$utf8reada($9d5117faee5c78f9$var$utf8corpus) && $9d5117faee5c78f9$var$utf8readc || /*#__PURE__*/ $9d5117faee5c78f9$var$utf8readb($9d5117faee5c78f9$var$utf8corpus) == /*#__PURE__*/ $9d5117faee5c78f9$var$utf8reada($9d5117faee5c78f9$var$utf8corpus) && $9d5117faee5c78f9$var$utf8readb) || $9d5117faee5c78f9$var$utf8reada;
var $9d5117faee5c78f9$var$utf8write /*:StringConv*/  = $9d5117faee5c78f9$var$has_buf ? function(data) {
    return $9d5117faee5c78f9$var$Buffer_from(data, 'utf8').toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
// matches <foo>...</foo> extracts content
var $9d5117faee5c78f9$var$matchtag = /*#__PURE__*/ function() {
    var mtcache /*:{[k:string]:RegExp}*/  = {} /*:any*/ ;
    return function matchtag(f /*:string*/ , g /*:?string*/ ) /*:RegExp*/ {
        var t = f + "|" + (g || "");
        if (mtcache[t]) return mtcache[t];
        return mtcache[t] = new RegExp('<(?:\\w+:)?' + f + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + f + '>', g || "");
    };
}();
var $9d5117faee5c78f9$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            'nbsp',
            ' '
        ],
        [
            'middot',
            "\xb7"
        ],
        [
            'quot',
            '"'
        ],
        [
            'apos',
            "'"
        ],
        [
            'gt',
            '>'
        ],
        [
            'lt',
            '<'
        ],
        [
            'amp',
            '&'
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp('&' + x[0] + ';', "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/[\t\n\r ]+$/, "")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $9d5117faee5c78f9$var$vtregex = /*#__PURE__*/ function() {
    var vt_cache = {};
    return function vt_regex(bt) {
        if (vt_cache[bt] !== undefined) return vt_cache[bt];
        return vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g');
    };
}();
var $9d5117faee5c78f9$var$vtvregex = /<\/?(?:vt:)?variant>/g, $9d5117faee5c78f9$var$vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function $9d5117faee5c78f9$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $9d5117faee5c78f9$var$parsexmltag(data);
    var matches /*:Array<string>*/  = data.match($9d5117faee5c78f9$var$vtregex(h.baseType)) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($9d5117faee5c78f9$var$vtvregex, "").match($9d5117faee5c78f9$var$vtmregex);
        if (v) res.push({
            v: $9d5117faee5c78f9$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $9d5117faee5c78f9$var$wtregex = /(^\s|\s$|\n)/;
function $9d5117faee5c78f9$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return '<' + f + (g.match($9d5117faee5c78f9$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f + '>';
}
function $9d5117faee5c78f9$var$wxt_helper(h) /*:string*/ {
    return $9d5117faee5c78f9$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $9d5117faee5c78f9$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return '<' + f + (h != null ? $9d5117faee5c78f9$var$wxt_helper(h) : "") + (g != null ? (g.match($9d5117faee5c78f9$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';
}
function $9d5117faee5c78f9$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $9d5117faee5c78f9$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case 'string':
            var o = $9d5117faee5c78f9$var$writextag('vt:lpwstr', $9d5117faee5c78f9$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case 'number':
            return $9d5117faee5c78f9$var$writextag((s | 0) == s ? 'vt:i4' : 'vt:r8', $9d5117faee5c78f9$var$escapexml(String(s)));
        case 'boolean':
            return $9d5117faee5c78f9$var$writextag('vt:bool', s ? 'true' : 'false');
    }
    if (s instanceof Date) return $9d5117faee5c78f9$var$writextag('vt:filetime', $9d5117faee5c78f9$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $9d5117faee5c78f9$var$xlml_normalize(d) /*:string*/ {
    if ($9d5117faee5c78f9$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $9d5117faee5c78f9$require$Buffer.isBuffer(d)) return d.toString('utf8');
    if (typeof d === 'string') return d;
    /* duktape */ if (typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return $9d5117faee5c78f9$var$utf8read($9d5117faee5c78f9$var$a2s($9d5117faee5c78f9$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags */ var $9d5117faee5c78f9$var$xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/](?:[^>=]|="[^"]*?")*)?>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
var $9d5117faee5c78f9$var$XMLNS = {
    CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
    RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
    TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
    'dc': 'http://purl.org/dc/elements/1.1/',
    'dcterms': 'http://purl.org/dc/terms/',
    'dcmitype': 'http://purl.org/dc/dcmitype/',
    'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
    'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
    'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
    'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
    'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
    'xsd': 'http://www.w3.org/2001/XMLSchema'
} /*:any*/ ;
var $9d5117faee5c78f9$var$XMLNS_main = [
    'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
    'http://purl.oclc.org/ooxml/spreadsheetml/main',
    'http://schemas.microsoft.com/office/excel/2006/main',
    'http://schemas.microsoft.com/office/excel/2006/2'
];
var $9d5117faee5c78f9$var$XLMLNS = {
    'o': 'urn:schemas-microsoft-com:office:office',
    'x': 'urn:schemas-microsoft-com:office:excel',
    'ss': 'urn:schemas-microsoft-com:office:spreadsheet',
    'dt': 'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
    'mv': 'http://macVmlSchemaUri',
    'v': 'urn:schemas-microsoft-com:vml',
    'html': 'http://www.w3.org/TR/REC-html40'
} /*:any*/ ;
function $9d5117faee5c78f9$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $9d5117faee5c78f9$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $9d5117faee5c78f9$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $9d5117faee5c78f9$var$__toBuffer = $9d5117faee5c78f9$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $9d5117faee5c78f9$require$Buffer.isBuffer(bufs[0][0]) ? $9d5117faee5c78f9$require$Buffer.concat(bufs[0].map(function(x) {
        return $9d5117faee5c78f9$require$Buffer.isBuffer(x) ? x : $9d5117faee5c78f9$var$Buffer_from(x);
    })) : $9d5117faee5c78f9$var$___toBuffer(bufs);
} : $9d5117faee5c78f9$var$___toBuffer;
var $9d5117faee5c78f9$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($9d5117faee5c78f9$var$__readUInt16LE(b, i)));
    return ss.join("").replace($9d5117faee5c78f9$var$chr0, '');
};
var $9d5117faee5c78f9$var$__utf16le = $9d5117faee5c78f9$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$9d5117faee5c78f9$require$Buffer.isBuffer(b) || !$9d5117faee5c78f9$var$buf_utf16le) return $9d5117faee5c78f9$var$___utf16le(b, s, e);
    return b.toString('utf16le', s, e).replace($9d5117faee5c78f9$var$chr0, '') /*.replace(chr1,'!')*/ ;
} : $9d5117faee5c78f9$var$___utf16le;
var $9d5117faee5c78f9$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $9d5117faee5c78f9$var$__hexlify = $9d5117faee5c78f9$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $9d5117faee5c78f9$require$Buffer.isBuffer(b) ? b.toString('hex', s, s + l) : $9d5117faee5c78f9$var$___hexlify(b, s, l);
} : $9d5117faee5c78f9$var$___hexlify;
var $9d5117faee5c78f9$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($9d5117faee5c78f9$var$__readUInt8(b, i)));
    return ss.join("");
};
var $9d5117faee5c78f9$var$__utf8 = $9d5117faee5c78f9$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $9d5117faee5c78f9$require$Buffer.isBuffer(b) ? b.toString('utf8', s, e) : $9d5117faee5c78f9$var$___utf8(b, s, e);
} : $9d5117faee5c78f9$var$___utf8;
var $9d5117faee5c78f9$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $9d5117faee5c78f9$var$__readUInt32LE(b, i);
    return len > 0 ? $9d5117faee5c78f9$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $9d5117faee5c78f9$var$__lpstr = $9d5117faee5c78f9$var$___lpstr;
var $9d5117faee5c78f9$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $9d5117faee5c78f9$var$__readUInt32LE(b, i);
    return len > 0 ? $9d5117faee5c78f9$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $9d5117faee5c78f9$var$__cpstr = $9d5117faee5c78f9$var$___cpstr;
var $9d5117faee5c78f9$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $9d5117faee5c78f9$var$__readUInt32LE(b, i);
    return len > 0 ? $9d5117faee5c78f9$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $9d5117faee5c78f9$var$__lpwstr = $9d5117faee5c78f9$var$___lpwstr;
var $9d5117faee5c78f9$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $9d5117faee5c78f9$var$__readUInt32LE(b, i);
    return len > 0 ? $9d5117faee5c78f9$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $9d5117faee5c78f9$var$__lpp4 = $9d5117faee5c78f9$var$___lpp4;
var $9d5117faee5c78f9$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $9d5117faee5c78f9$var$__readUInt32LE(b, i);
    return len > 0 ? $9d5117faee5c78f9$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $9d5117faee5c78f9$var$__8lpp4 = $9d5117faee5c78f9$var$___8lpp4;
var $9d5117faee5c78f9$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $9d5117faee5c78f9$var$read_double_le(b, idx);
};
var $9d5117faee5c78f9$var$__double = $9d5117faee5c78f9$var$___double;
var $9d5117faee5c78f9$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($9d5117faee5c78f9$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $9d5117faee5c78f9$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$9d5117faee5c78f9$require$Buffer.isBuffer(b)) return $9d5117faee5c78f9$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $9d5117faee5c78f9$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$9d5117faee5c78f9$require$Buffer.isBuffer(b)) return $9d5117faee5c78f9$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $9d5117faee5c78f9$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$9d5117faee5c78f9$require$Buffer.isBuffer(b) || !$9d5117faee5c78f9$var$buf_utf16le) return $9d5117faee5c78f9$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len - 1);
    };
    $9d5117faee5c78f9$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$9d5117faee5c78f9$require$Buffer.isBuffer(b) || !$9d5117faee5c78f9$var$buf_utf16le) return $9d5117faee5c78f9$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len);
    };
    $9d5117faee5c78f9$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$9d5117faee5c78f9$require$Buffer.isBuffer(b)) return $9d5117faee5c78f9$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf8', i + 4, i + 4 + len);
    };
    $9d5117faee5c78f9$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($9d5117faee5c78f9$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $9d5117faee5c78f9$var$___double(b, i);
    };
    $9d5117faee5c78f9$var$is_buf = function is_buf_b(a) {
        return $9d5117faee5c78f9$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $9d5117faee5c78f9$var$cpdoit() {
    $9d5117faee5c78f9$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $9d5117faee5c78f9$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($9d5117faee5c78f9$var$chr0, '');
    };
    $9d5117faee5c78f9$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $9d5117faee5c78f9$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $9d5117faee5c78f9$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $9d5117faee5c78f9$var$__readUInt32LE(b, i);
        return len > 0 ? $9d5117faee5c78f9$var$$cptable.utils.decode($9d5117faee5c78f9$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $9d5117faee5c78f9$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $9d5117faee5c78f9$var$__readUInt32LE(b, i);
        return len > 0 ? $9d5117faee5c78f9$var$$cptable.utils.decode($9d5117faee5c78f9$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $9d5117faee5c78f9$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $9d5117faee5c78f9$var$__readUInt32LE(b, i);
        return len > 0 ? $9d5117faee5c78f9$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $9d5117faee5c78f9$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $9d5117faee5c78f9$var$__readUInt32LE(b, i);
        return len > 0 ? $9d5117faee5c78f9$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $9d5117faee5c78f9$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $9d5117faee5c78f9$var$__readUInt32LE(b, i);
        return len > 0 ? $9d5117faee5c78f9$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $9d5117faee5c78f9$var$$cptable !== 'undefined') $9d5117faee5c78f9$var$cpdoit();
var $9d5117faee5c78f9$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $9d5117faee5c78f9$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $9d5117faee5c78f9$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $9d5117faee5c78f9$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $9d5117faee5c78f9$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $9d5117faee5c78f9$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $9d5117faee5c78f9$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case 'dbcs':
            loc = this.l;
            if ($9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(this) && $9d5117faee5c78f9$var$buf_utf16le) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($9d5117faee5c78f9$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case 'utf8':
            o = $9d5117faee5c78f9$var$__utf8(this, this.l, this.l + size);
            break;
        case 'utf16le':
            size *= 2;
            o = $9d5117faee5c78f9$var$__utf16le(this, this.l, this.l + size);
            break;
        case 'wstr':
            if (typeof $9d5117faee5c78f9$var$$cptable !== 'undefined') o = $9d5117faee5c78f9$var$$cptable.utils.decode($9d5117faee5c78f9$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $9d5117faee5c78f9$var$ReadShift.call(this, size, 'dbcs');
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case 'lpstr-ansi':
            o = $9d5117faee5c78f9$var$__lpstr(this, this.l);
            size = 4 + $9d5117faee5c78f9$var$__readUInt32LE(this, this.l);
            break;
        case 'lpstr-cp':
            o = $9d5117faee5c78f9$var$__cpstr(this, this.l);
            size = 4 + $9d5117faee5c78f9$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case 'lpwstr':
            o = $9d5117faee5c78f9$var$__lpwstr(this, this.l);
            size = 4 + 2 * $9d5117faee5c78f9$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case 'lpp4':
            size = 4 + $9d5117faee5c78f9$var$__readUInt32LE(this, this.l);
            o = $9d5117faee5c78f9$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case '8lpp4':
            size = 4 + $9d5117faee5c78f9$var$__readUInt32LE(this, this.l);
            o = $9d5117faee5c78f9$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case 'cstr':
            size = 0;
            o = "";
            while((w = $9d5117faee5c78f9$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($9d5117faee5c78f9$var$_getchar(w));
            o = oo.join("");
            break;
        case '_wstr':
            size = 0;
            o = "";
            while((w = $9d5117faee5c78f9$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($9d5117faee5c78f9$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case 'dbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $9d5117faee5c78f9$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $9d5117faee5c78f9$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($9d5117faee5c78f9$var$_getchar($9d5117faee5c78f9$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case 'cpstr':
            if (typeof $9d5117faee5c78f9$var$$cptable !== 'undefined') {
                o = $9d5117faee5c78f9$var$$cptable.utils.decode($9d5117faee5c78f9$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case 'sbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $9d5117faee5c78f9$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $9d5117faee5c78f9$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($9d5117faee5c78f9$var$_getchar($9d5117faee5c78f9$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $9d5117faee5c78f9$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === 'i' ? $9d5117faee5c78f9$var$__readInt16LE : $9d5117faee5c78f9$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === 'i' || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $9d5117faee5c78f9$var$__readInt32LE : $9d5117faee5c78f9$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $9d5117faee5c78f9$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === 'f') {
                        if (size == 8) oR = $9d5117faee5c78f9$var$__double(this, this.l);
                        else oR = $9d5117faee5c78f9$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $9d5117faee5c78f9$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $9d5117faee5c78f9$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
    b[idx + 2] = val >>> 16 & 0xFF;
    b[idx + 3] = val >>> 24 & 0xFF;
};
var $9d5117faee5c78f9$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >> 8 & 0xFF;
    b[idx + 2] = val >> 16 & 0xFF;
    b[idx + 3] = val >> 24 & 0xFF;
};
var $9d5117faee5c78f9$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
};
function $9d5117faee5c78f9$var$WriteShift(t /*:number*/ , val /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === 'dbcs') {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)$9d5117faee5c78f9$var$__writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
        size = 2 * val.length;
    } else if (f === 'sbcs' || f == 'cpstr') {
        if (typeof $9d5117faee5c78f9$var$$cptable !== 'undefined' && $9d5117faee5c78f9$var$current_ansi == 874) {
            /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i){
                var cpp = $9d5117faee5c78f9$var$$cptable.utils.encode($9d5117faee5c78f9$var$current_ansi, val.charAt(i));
                this[this.l + i] = cpp[0];
            }
            size = val.length;
        } else if (typeof $9d5117faee5c78f9$var$$cptable !== 'undefined' && f == 'cpstr') {
            cpp = $9d5117faee5c78f9$var$$cptable.utils.encode($9d5117faee5c78f9$var$current_codepage, val);
            /* replace null bytes with _ when relevant */ if (cpp.length == val.length) {
                for(i = 0; i < val.length; ++i)if (cpp[i] == 0 && val.charCodeAt(i) != 0) cpp[i] = 0x5F;
            }
            if (cpp.length == 2 * val.length) {
                for(i = 0; i < val.length; ++i)if (cpp[2 * i] == 0 && cpp[2 * i + 1] == 0 && val.charCodeAt(i) != 0) cpp[2 * i] = 0x5F;
            }
            for(i = 0; i < cpp.length; ++i)this[this.l + i] = cpp[i];
            size = cpp.length;
        } else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val = val.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)this[this.l + i] = val.charCodeAt(i) & 0xFF;
            size = val.length;
        }
    } else if (f === 'hex') {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === 'utf16le') {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val.length, t); ++i){
            var cc = val.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            val >>>= 8;
            this[this.l + 2] = val & 0xFF;
            break;
        case 4:
            size = 4;
            $9d5117faee5c78f9$var$__writeUInt32LE(this, val, this.l);
            break;
        case 8:
            size = 8;
            if (f === 'f') {
                $9d5117faee5c78f9$var$write_double_le(this, val, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $9d5117faee5c78f9$var$__writeInt32LE(this, val, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $9d5117faee5c78f9$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $9d5117faee5c78f9$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
    this.l += hexstr.length >> 1;
}
function $9d5117faee5c78f9$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $9d5117faee5c78f9$var$ReadShift /*:: :any)*/ ;
    blob.chk = $9d5117faee5c78f9$var$CheckField;
    blob.write_shift = $9d5117faee5c78f9$var$WriteShift;
}
function $9d5117faee5c78f9$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $9d5117faee5c78f9$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $9d5117faee5c78f9$var$new_raw_buf(sz);
    $9d5117faee5c78f9$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $9d5117faee5c78f9$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $9d5117faee5c78f9$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $9d5117faee5c78f9$var$XLSBRecordEnum[RT] || $9d5117faee5c78f9$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $9d5117faee5c78f9$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $9d5117faee5c78f9$var$has_buf ? 256 : 2048;
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $9d5117faee5c78f9$var$new_buf(sz);
        $9d5117faee5c78f9$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        // workaround for new Buffer(3).slice(0,0) bug in bun 0.1.3
        if (curbuf.l) {
            if (curbuf.length > curbuf.l) {
                curbuf = curbuf.slice(0, curbuf.l);
                curbuf.l = curbuf.length;
            }
            if (curbuf.length > 0) bufs.push(curbuf);
        }
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $9d5117faee5c78f9$var$bconcat(bufs);
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs
    } /*:any*/ ;
}
function $9d5117faee5c78f9$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $9d5117faee5c78f9$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $9d5117faee5c78f9$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $9d5117faee5c78f9$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $9d5117faee5c78f9$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $9d5117faee5c78f9$var$shift_range_xls(cell, range, opts) {
    var out = $9d5117faee5c78f9$var$dup(cell);
    out.s = $9d5117faee5c78f9$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $9d5117faee5c78f9$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $9d5117faee5c78f9$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $9d5117faee5c78f9$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $9d5117faee5c78f9$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $9d5117faee5c78f9$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $9d5117faee5c78f9$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $9d5117faee5c78f9$var$fix_row(s);
    return s;
}
function $9d5117faee5c78f9$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $9d5117faee5c78f9$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $9d5117faee5c78f9$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $9d5117faee5c78f9$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $9d5117faee5c78f9$var$encode_row(r.e.r);
    }
    return $9d5117faee5c78f9$var$encode_cell_xls(r.s, opts.biff) + ":" + $9d5117faee5c78f9$var$encode_cell_xls(r.e, opts.biff);
}
function $9d5117faee5c78f9$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($9d5117faee5c78f9$var$unfix_row(rowstr), 10) - 1;
}
function $9d5117faee5c78f9$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $9d5117faee5c78f9$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $9d5117faee5c78f9$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $9d5117faee5c78f9$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $9d5117faee5c78f9$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $9d5117faee5c78f9$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $9d5117faee5c78f9$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $9d5117faee5c78f9$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $9d5117faee5c78f9$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function $9d5117faee5c78f9$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
function $9d5117faee5c78f9$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $9d5117faee5c78f9$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $9d5117faee5c78f9$var$decode_cell(range),
        e: $9d5117faee5c78f9$var$decode_cell(range)
    };
    return {
        s: $9d5117faee5c78f9$var$decode_cell(range.slice(0, idx)),
        e: $9d5117faee5c78f9$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $9d5117faee5c78f9$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === 'undefined' || typeof ce === 'number') /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $9d5117faee5c78f9$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== 'string') cs = $9d5117faee5c78f9$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== 'string') ce = $9d5117faee5c78f9$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $9d5117faee5c78f9$var$fix_range(a1 /*:string*/ ) /*:string*/ {
    var s = $9d5117faee5c78f9$var$decode_range(a1);
    return "$" + $9d5117faee5c78f9$var$encode_col(s.s.c) + "$" + $9d5117faee5c78f9$var$encode_row(s.s.r) + ":$" + $9d5117faee5c78f9$var$encode_col(s.e.c) + "$" + $9d5117faee5c78f9$var$encode_row(s.e.r);
}
// List of invalid characters needs to be tested further
function $9d5117faee5c78f9$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname.replace(/'/g, "''") + "'";
    return sname;
}
function $9d5117faee5c78f9$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $9d5117faee5c78f9$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == 'd' && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $9d5117faee5c78f9$var$SSF_format(cell.z, q ? $9d5117faee5c78f9$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $9d5117faee5c78f9$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $9d5117faee5c78f9$var$datenum(v) : v);
    } catch (e) {
        return '' + v;
    }
}
function $9d5117faee5c78f9$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == 'z') return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $9d5117faee5c78f9$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $9d5117faee5c78f9$var$safe_format_cell(cell, cell.v);
    return $9d5117faee5c78f9$var$safe_format_cell(cell, v);
}
function $9d5117faee5c78f9$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $9d5117faee5c78f9$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($9d5117faee5c78f9$var$DENSE != null && dense == null) dense = $9d5117faee5c78f9$var$DENSE;
    var ws /*:Worksheet*/  = _ws || {} /*:any*/ ;
    if (dense && !ws["!data"]) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $9d5117faee5c78f9$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
        if (!ws["!ref"]) ws["!ref"] = "A1:A1";
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws['!ref']) {
        var _range = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref']);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = _range.e.r + 1;
    }
    var row = [];
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        var __R = _R + R, __Rstr = "" + (__R + 1);
        if (dense) {
            if (!ws["!data"][__R]) ws["!data"][__R] = [];
            row = ws["!data"][__R];
        }
        for(var C = 0; C != data[R].length; ++C){
            if (typeof data[R][C] === 'undefined') continue;
            var cell /*:Cell*/  = {
                v: data[R][C]
            } /*:any*/ ;
            var __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            if (data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data[R][C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = 'n';
                    else if (o.nullError) {
                        cell.t = 'e';
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = 'z';
                } else if (typeof cell.v === 'number') cell.t = 'n';
                else if (typeof cell.v === 'boolean') cell.t = 'b';
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $9d5117faee5c78f9$var$table_fmt[14];
                    if (o.cellDates) {
                        cell.t = 'd';
                        cell.w = $9d5117faee5c78f9$var$SSF_format(cell.z, $9d5117faee5c78f9$var$datenum(cell.v, o.date1904));
                    } else {
                        cell.t = 'n';
                        cell.v = $9d5117faee5c78f9$var$datenum(cell.v, o.date1904);
                        cell.w = $9d5117faee5c78f9$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = 's';
            }
            if (dense) {
                if (row[__C] && row[__C].z) cell.z = row[__C].z;
                row[__C] = cell;
            } else {
                var cell_ref = $9d5117faee5c78f9$var$encode_col(__C) + __Rstr /*:any*/ ;
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (range.s.c < 10000000) ws['!ref'] = $9d5117faee5c78f9$var$encode_range(range);
    return ws;
}
function $9d5117faee5c78f9$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $9d5117faee5c78f9$var$sheet_add_aoa(null, data, opts);
}
function $9d5117faee5c78f9$var$parse_Int32LE(data) {
    return data.read_shift(4, 'i');
}
function $9d5117faee5c78f9$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $9d5117faee5c78f9$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $9d5117faee5c78f9$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $9d5117faee5c78f9$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $9d5117faee5c78f9$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $9d5117faee5c78f9$var$write_StrRun(run, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $9d5117faee5c78f9$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $9d5117faee5c78f9$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($9d5117faee5c78f9$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $9d5117faee5c78f9$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $9d5117faee5c78f9$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $9d5117faee5c78f9$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $9d5117faee5c78f9$var$parse_BrtCommentText = $9d5117faee5c78f9$var$parse_RichStr;
function $9d5117faee5c78f9$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $9d5117faee5c78f9$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $9d5117faee5c78f9$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $9d5117faee5c78f9$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $9d5117faee5c78f9$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $9d5117faee5c78f9$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $9d5117faee5c78f9$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $9d5117faee5c78f9$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $9d5117faee5c78f9$var$parse_XLSBCodeName = $9d5117faee5c78f9$var$parse_XLWideString;
var $9d5117faee5c78f9$var$write_XLSBCodeName = $9d5117faee5c78f9$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $9d5117faee5c78f9$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $9d5117faee5c78f9$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $9d5117faee5c78f9$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $9d5117faee5c78f9$var$parse_XLNameWideString = $9d5117faee5c78f9$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $9d5117faee5c78f9$var$parse_RelID = $9d5117faee5c78f9$var$parse_XLNullableWideString;
var $9d5117faee5c78f9$var$write_RelID = $9d5117faee5c78f9$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $9d5117faee5c78f9$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $9d5117faee5c78f9$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $9d5117faee5c78f9$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $9d5117faee5c78f9$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $9d5117faee5c78f9$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $9d5117faee5c78f9$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $9d5117faee5c78f9$var$parse_UncheckedRfX = $9d5117faee5c78f9$var$parse_RfX;
var $9d5117faee5c78f9$var$write_UncheckedRfX = $9d5117faee5c78f9$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $9d5117faee5c78f9$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, 'f');
}
function $9d5117faee5c78f9$var$write_Xnum(data, o) {
    return (o || $9d5117faee5c78f9$var$new_buf(8)).write_shift(8, data, 'f');
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $9d5117faee5c78f9$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, 'i');
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $9d5117faee5c78f9$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $9d5117faee5c78f9$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $9d5117faee5c78f9$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $9d5117faee5c78f9$var$write_BrtColor(color, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || 'FFFFFF';
        if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $9d5117faee5c78f9$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $9d5117faee5c78f9$var$write_FontFlags(font, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $9d5117faee5c78f9$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $9d5117faee5c78f9$var$parse_ClipboardFormatOrAnsiString(o) {
    return $9d5117faee5c78f9$var$parse_ClipboardFormatOrString(o, 1);
}
function $9d5117faee5c78f9$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $9d5117faee5c78f9$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $9d5117faee5c78f9$var$VT_I2 = 0x0002;
var $9d5117faee5c78f9$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $9d5117faee5c78f9$var$VT_BOOL = 0x000B;
var $9d5117faee5c78f9$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $9d5117faee5c78f9$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
//var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $9d5117faee5c78f9$var$VT_FILETIME = 0x0040;
var $9d5117faee5c78f9$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $9d5117faee5c78f9$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
//var VT_VECTOR   = 0x1000;
var $9d5117faee5c78f9$var$VT_VECTOR_VARIANT = 0x100C;
var $9d5117faee5c78f9$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $9d5117faee5c78f9$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $9d5117faee5c78f9$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $9d5117faee5c78f9$var$VT_CUSTOM = [
    $9d5117faee5c78f9$var$VT_STRING,
    $9d5117faee5c78f9$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $9d5117faee5c78f9$var$DocSummaryPIDDSI = {
    /*::[*/ 0x01: {
        n: 'CodePage',
        t: $9d5117faee5c78f9$var$VT_I2
    },
    /*::[*/ 0x02: {
        n: 'Category',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x03: {
        n: 'PresentationFormat',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x04: {
        n: 'ByteCount',
        t: $9d5117faee5c78f9$var$VT_I4
    },
    /*::[*/ 0x05: {
        n: 'LineCount',
        t: $9d5117faee5c78f9$var$VT_I4
    },
    /*::[*/ 0x06: {
        n: 'ParagraphCount',
        t: $9d5117faee5c78f9$var$VT_I4
    },
    /*::[*/ 0x07: {
        n: 'SlideCount',
        t: $9d5117faee5c78f9$var$VT_I4
    },
    /*::[*/ 0x08: {
        n: 'NoteCount',
        t: $9d5117faee5c78f9$var$VT_I4
    },
    /*::[*/ 0x09: {
        n: 'HiddenCount',
        t: $9d5117faee5c78f9$var$VT_I4
    },
    /*::[*/ 0x0a: {
        n: 'MultimediaClipCount',
        t: $9d5117faee5c78f9$var$VT_I4
    },
    /*::[*/ 0x0b: {
        n: 'ScaleCrop',
        t: $9d5117faee5c78f9$var$VT_BOOL
    },
    /*::[*/ 0x0c: {
        n: 'HeadingPairs',
        t: $9d5117faee5c78f9$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    /*::[*/ 0x0d: {
        n: 'TitlesOfParts',
        t: $9d5117faee5c78f9$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    /*::[*/ 0x0e: {
        n: 'Manager',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x0f: {
        n: 'Company',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x10: {
        n: 'LinksUpToDate',
        t: $9d5117faee5c78f9$var$VT_BOOL
    },
    /*::[*/ 0x11: {
        n: 'CharacterCount',
        t: $9d5117faee5c78f9$var$VT_I4
    },
    /*::[*/ 0x13: {
        n: 'SharedDoc',
        t: $9d5117faee5c78f9$var$VT_BOOL
    },
    /*::[*/ 0x16: {
        n: 'HyperlinksChanged',
        t: $9d5117faee5c78f9$var$VT_BOOL
    },
    /*::[*/ 0x17: {
        n: 'AppVersion',
        t: $9d5117faee5c78f9$var$VT_I4,
        p: 'version'
    },
    /*::[*/ 0x18: {
        n: 'DigSig',
        t: $9d5117faee5c78f9$var$VT_BLOB
    },
    /*::[*/ 0x1A: {
        n: 'ContentType',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x1B: {
        n: 'ContentStatus',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x1C: {
        n: 'Language',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x1D: {
        n: 'Version',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: 'Locale',
        t: $9d5117faee5c78f9$var$VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: 'Behavior',
        t: $9d5117faee5c78f9$var$VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $9d5117faee5c78f9$var$SummaryPIDSI = {
    /*::[*/ 0x01: {
        n: 'CodePage',
        t: $9d5117faee5c78f9$var$VT_I2
    },
    /*::[*/ 0x02: {
        n: 'Title',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x03: {
        n: 'Subject',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x04: {
        n: 'Author',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x05: {
        n: 'Keywords',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x06: {
        n: 'Comments',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x07: {
        n: 'Template',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x08: {
        n: 'LastAuthor',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x09: {
        n: 'RevNumber',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x0A: {
        n: 'EditTime',
        t: $9d5117faee5c78f9$var$VT_FILETIME
    },
    /*::[*/ 0x0B: {
        n: 'LastPrinted',
        t: $9d5117faee5c78f9$var$VT_FILETIME
    },
    /*::[*/ 0x0C: {
        n: 'CreatedDate',
        t: $9d5117faee5c78f9$var$VT_FILETIME
    },
    /*::[*/ 0x0D: {
        n: 'ModifiedDate',
        t: $9d5117faee5c78f9$var$VT_FILETIME
    },
    /*::[*/ 0x0E: {
        n: 'PageCount',
        t: $9d5117faee5c78f9$var$VT_I4
    },
    /*::[*/ 0x0F: {
        n: 'WordCount',
        t: $9d5117faee5c78f9$var$VT_I4
    },
    /*::[*/ 0x10: {
        n: 'CharCount',
        t: $9d5117faee5c78f9$var$VT_I4
    },
    /*::[*/ 0x11: {
        n: 'Thumbnail',
        t: $9d5117faee5c78f9$var$VT_CF
    },
    /*::[*/ 0x12: {
        n: 'Application',
        t: $9d5117faee5c78f9$var$VT_STRING
    },
    /*::[*/ 0x13: {
        n: 'DocSecurity',
        t: $9d5117faee5c78f9$var$VT_I4
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: 'Locale',
        t: $9d5117faee5c78f9$var$VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: 'Behavior',
        t: $9d5117faee5c78f9$var$VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $9d5117faee5c78f9$var$CountryEnum = {
    /*::[*/ 0x0001: "US",
    /*::[*/ 0x0002: "CA",
    /*::[*/ 0x0003: "",
    /*::[*/ 0x0007: "RU",
    /*::[*/ 0x0014: "EG",
    /*::[*/ 0x001E: "GR",
    /*::[*/ 0x001F: "NL",
    /*::[*/ 0x0020: "BE",
    /*::[*/ 0x0021: "FR",
    /*::[*/ 0x0022: "ES",
    /*::[*/ 0x0024: "HU",
    /*::[*/ 0x0027: "IT",
    /*::[*/ 0x0029: "CH",
    /*::[*/ 0x002B: "AT",
    /*::[*/ 0x002C: "GB",
    /*::[*/ 0x002D: "DK",
    /*::[*/ 0x002E: "SE",
    /*::[*/ 0x002F: "NO",
    /*::[*/ 0x0030: "PL",
    /*::[*/ 0x0031: "DE",
    /*::[*/ 0x0034: "MX",
    /*::[*/ 0x0037: "BR",
    /*::[*/ 0x003d: "AU",
    /*::[*/ 0x0040: "NZ",
    /*::[*/ 0x0042: "TH",
    /*::[*/ 0x0051: "JP",
    /*::[*/ 0x0052: "KR",
    /*::[*/ 0x0054: "VN",
    /*::[*/ 0x0056: "CN",
    /*::[*/ 0x005A: "TR",
    /*::[*/ 0x0069: "JS",
    /*::[*/ 0x00D5: "DZ",
    /*::[*/ 0x00D8: "MA",
    /*::[*/ 0x00DA: "LY",
    /*::[*/ 0x015F: "PT",
    /*::[*/ 0x0162: "IS",
    /*::[*/ 0x0166: "FI",
    /*::[*/ 0x01A4: "CZ",
    /*::[*/ 0x0376: "TW",
    /*::[*/ 0x03C1: "LB",
    /*::[*/ 0x03C2: "JO",
    /*::[*/ 0x03C3: "SY",
    /*::[*/ 0x03C4: "IQ",
    /*::[*/ 0x03C5: "KW",
    /*::[*/ 0x03C6: "SA",
    /*::[*/ 0x03CB: "AE",
    /*::[*/ 0x03CC: "IL",
    /*::[*/ 0x03CE: "QA",
    /*::[*/ 0x03D5: "IR",
    /*::[*/ 0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $9d5117faee5c78f9$var$XLSFillPattern = [
    null,
    'solid',
    'mediumGray',
    'darkGray',
    'lightGray',
    'darkHorizontal',
    'darkVertical',
    'darkDown',
    'darkUp',
    'darkGrid',
    'darkTrellis',
    'lightHorizontal',
    'lightVertical',
    'lightDown',
    'lightUp',
    'lightGrid',
    'lightTrellis',
    'gray125',
    'gray0625'
];
function $9d5117faee5c78f9$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $9d5117faee5c78f9$var$_XLSIcv = /*#__PURE__*/ $9d5117faee5c78f9$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0x000000,
    /* 0x40 icvForeground ?? */ 0xFFFFFF,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $9d5117faee5c78f9$var$XLSIcv = /*#__PURE__*/ $9d5117faee5c78f9$var$dup($9d5117faee5c78f9$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $9d5117faee5c78f9$var$BErr = {
    /*::[*/ 0x00: "#NULL!",
    /*::[*/ 0x07: "#DIV/0!",
    /*::[*/ 0x0F: "#VALUE!",
    /*::[*/ 0x17: "#REF!",
    /*::[*/ 0x1D: "#NAME?",
    /*::[*/ 0x24: "#NUM!",
    /*::[*/ 0x2A: "#N/A",
    /*::[*/ 0x2B: "#GETTING_DATA",
    /*::[*/ 0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $9d5117faee5c78f9$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
var $9d5117faee5c78f9$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $9d5117faee5c78f9$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $9d5117faee5c78f9$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $9d5117faee5c78f9$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $9d5117faee5c78f9$var$parse_ct(data /*:?string*/ ) {
    var ct = $9d5117faee5c78f9$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($9d5117faee5c78f9$var$tagregex) || []).forEach(function(x) {
        var y = $9d5117faee5c78f9$var$parsexmltag(x);
        switch(y[0].replace($9d5117faee5c78f9$var$nsregex, "<")){
            case '<?xml':
                break;
            case '<Types':
                ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case '<Default':
                ctext[y.Extension.toLowerCase()] = y.ContentType;
                break;
            case '<Override':
                if (ct[$9d5117faee5c78f9$var$ct2type[y.ContentType]] !== undefined) ct[$9d5117faee5c78f9$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $9d5117faee5c78f9$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $9d5117faee5c78f9$var$write_ct(ct, opts, raw) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $9d5117faee5c78f9$var$evert_arr($9d5117faee5c78f9$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    if (!raw) {
        o[o.length] = $9d5117faee5c78f9$var$XML_HEADER;
        o[o.length] = $9d5117faee5c78f9$var$writextag('Types', null, {
            'xmlns': $9d5117faee5c78f9$var$XMLNS.CT,
            'xmlns:xsd': $9d5117faee5c78f9$var$XMLNS.xsd,
            'xmlns:xsi': $9d5117faee5c78f9$var$XMLNS.xsi
        });
        o = o.concat([
            [
                'xml',
                'application/xml'
            ],
            [
                'bin',
                'application/vnd.ms-excel.sheet.binary.macroEnabled.main'
            ],
            [
                'vml',
                'application/vnd.openxmlformats-officedocument.vmlDrawing'
            ],
            [
                'data',
                'application/vnd.openxmlformats-officedocument.model+data'
            ],
            /* from test files */ [
                'bmp',
                'image/bmp'
            ],
            [
                'png',
                'image/png'
            ],
            [
                'gif',
                'image/gif'
            ],
            [
                'emf',
                'image/x-emf'
            ],
            [
                'wmf',
                'image/x-wmf'
            ],
            [
                'jpg',
                'image/jpeg'
            ],
            [
                'jpeg',
                'image/jpeg'
            ],
            [
                'tif',
                'image/tiff'
            ],
            [
                'tiff',
                'image/tiff'
            ],
            [
                'pdf',
                'application/pdf'
            ],
            [
                'rels',
                'application/vnd.openxmlformats-package.relationships+xml'
            ]
        ].map(function(x) {
            return $9d5117faee5c78f9$var$writextag('Default', null, {
                'Extension': x[0],
                'ContentType': x[1]
            });
        }));
    }
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $9d5117faee5c78f9$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $9d5117faee5c78f9$var$CT_LIST[w][opts.bookType] || $9d5117faee5c78f9$var$CT_LIST[w]['xlsx']
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $9d5117faee5c78f9$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $9d5117faee5c78f9$var$CT_LIST[w][opts.bookType] || $9d5117faee5c78f9$var$CT_LIST[w]['xlsx']
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $9d5117faee5c78f9$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': type2ct[t][0]
            });
        });
    };
    f1('workbooks');
    f2('sheets');
    f2('charts');
    f3('themes');
    [
        'strs',
        'styles'
    ].forEach(f1);
    [
        'coreprops',
        'extprops',
        'custprops'
    ].forEach(f3);
    f3('vba');
    f3('comments');
    f3('threadedcomments');
    f3('drawings');
    f2('metadata');
    f3('people');
    if (!raw && o.length > 2) {
        o[o.length] = '</Types>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $9d5117faee5c78f9$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
    CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    CONN: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/connections",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $9d5117faee5c78f9$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + '_rels/' + file.slice(n + 1) + ".rels";
}
function $9d5117faee5c78f9$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== '/') currentFilePath = '/' + currentFilePath;
    var hash = {};
    (data.match($9d5117faee5c78f9$var$tagregex) || []).forEach(function(x) {
        var y = $9d5117faee5c78f9$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === '<Relationship') {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = $9d5117faee5c78f9$var$unescapexml(y.Target);
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === 'External' ? y.Target : $9d5117faee5c78f9$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $9d5117faee5c78f9$var$write_rels(rels) /*:string*/ {
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER,
        $9d5117faee5c78f9$var$writextag('Relationships', null, {
            //'xmlns:ns0': XMLNS.RELS,
            'xmlns': $9d5117faee5c78f9$var$XMLNS.RELS
        })
    ];
    $9d5117faee5c78f9$var$keys(rels['!id']).forEach(function(rid) {
        o[o.length] = $9d5117faee5c78f9$var$writextag('Relationship', null, rels['!id'][rid]);
    });
    if (o.length > 2) {
        o[o.length] = '</Relationships>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $9d5117faee5c78f9$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels['!id']) rels['!id'] = {};
    if (!rels['!idx']) rels['!idx'] = 1;
    if (rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId);
    rels['!idx'] = rId + 1;
    relobj.Id = 'rId' + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $9d5117faee5c78f9$var$RELS.HLINK,
        $9d5117faee5c78f9$var$RELS.XPATH,
        $9d5117faee5c78f9$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels['!id'][relobj.Id] = relobj;
    rels[('/' + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
var $9d5117faee5c78f9$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $9d5117faee5c78f9$var$parse_manifest(d, opts) {
    var str = $9d5117faee5c78f9$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $9d5117faee5c78f9$var$xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break;
        case "file-entry":
            FEtag = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== $9d5117faee5c78f9$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $9d5117faee5c78f9$var$write_manifest(manifest) {
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
function $9d5117faee5c78f9$var$write_rdf_type(file, res, tag) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $9d5117faee5c78f9$var$write_rdf_has(base, file) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $9d5117faee5c78f9$var$write_rdf(rdf) {
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($9d5117faee5c78f9$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($9d5117faee5c78f9$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($9d5117faee5c78f9$var$write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
function $9d5117faee5c78f9$var$write_meta_ods(wb, opts) {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $9d5117faee5c78f9$var$XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $9d5117faee5c78f9$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        'date'
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        'date'
    ]
];
var $9d5117faee5c78f9$var$CORE_PROPS_REGEX /*:Array<RegExp>*/  = /*#__PURE__*/ function() {
    var r = new Array($9d5117faee5c78f9$var$CORE_PROPS.length);
    for(var i = 0; i < $9d5117faee5c78f9$var$CORE_PROPS.length; ++i){
        var f = $9d5117faee5c78f9$var$CORE_PROPS[i];
        var g = "(?:" + f[0].slice(0, f[0].indexOf(":")) + ":)" + f[0].slice(f[0].indexOf(":") + 1);
        r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
    }
    return r;
}();
function $9d5117faee5c78f9$var$parse_core_props(data) {
    var p = {};
    data = $9d5117faee5c78f9$var$utf8read(data);
    for(var i = 0; i < $9d5117faee5c78f9$var$CORE_PROPS.length; ++i){
        var f = $9d5117faee5c78f9$var$CORE_PROPS[i], cur = data.match($9d5117faee5c78f9$var$CORE_PROPS_REGEX[i]);
        if (cur != null && cur.length > 0) p[f[1]] = $9d5117faee5c78f9$var$unescapexml(cur[1]);
        if (f[2] === 'date' && p[f[1]]) p[f[1]] = $9d5117faee5c78f9$var$parseDate(p[f[1]]);
    }
    return p;
}
function $9d5117faee5c78f9$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $9d5117faee5c78f9$var$escapexml(g);
    o[o.length] = h ? $9d5117faee5c78f9$var$writextag(f, g, h) : $9d5117faee5c78f9$var$writetag(f, g);
}
function $9d5117faee5c78f9$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER,
        $9d5117faee5c78f9$var$writextag('cp:coreProperties', null, {
            //'xmlns': XMLNS.CORE_PROPS,
            'xmlns:cp': $9d5117faee5c78f9$var$XMLNS.CORE_PROPS,
            'xmlns:dc': $9d5117faee5c78f9$var$XMLNS.dc,
            'xmlns:dcterms': $9d5117faee5c78f9$var$XMLNS.dcterms,
            'xmlns:dcmitype': $9d5117faee5c78f9$var$XMLNS.dcmitype,
            'xmlns:xsi': $9d5117faee5c78f9$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $9d5117faee5c78f9$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $9d5117faee5c78f9$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $9d5117faee5c78f9$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $9d5117faee5c78f9$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $9d5117faee5c78f9$var$CORE_PROPS.length; ++i){
        var f = $9d5117faee5c78f9$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $9d5117faee5c78f9$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = '</cp:coreProperties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $9d5117faee5c78f9$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $9d5117faee5c78f9$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $9d5117faee5c78f9$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $9d5117faee5c78f9$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $9d5117faee5c78f9$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $9d5117faee5c78f9$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $9d5117faee5c78f9$var$utf8read(data);
    $9d5117faee5c78f9$var$EXT_PROPS.forEach(function(f) {
        var xml = (data.match($9d5117faee5c78f9$var$matchtag(f[0])) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $9d5117faee5c78f9$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $9d5117faee5c78f9$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $9d5117faee5c78f9$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $9d5117faee5c78f9$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $9d5117faee5c78f9$var$XML_HEADER;
    o[o.length] = $9d5117faee5c78f9$var$writextag('Properties', null, {
        'xmlns': $9d5117faee5c78f9$var$XMLNS.EXT_PROPS,
        'xmlns:vt': $9d5117faee5c78f9$var$XMLNS.vt
    });
    $9d5117faee5c78f9$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case 'string':
                v = $9d5117faee5c78f9$var$escapexml(String(cp[f[1]]));
                break;
            case 'bool':
                v = cp[f[1]] ? 'true' : 'false';
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>') + W('vt:variant', W('vt:i4', String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $9d5117faee5c78f9$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $9d5117faee5c78f9$var$custregex = /<[^>]+>[^<]*/g;
function $9d5117faee5c78f9$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($9d5117faee5c78f9$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $9d5117faee5c78f9$var$parsexmltag(x);
        switch($9d5117faee5c78f9$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<Properties':
                break;
            case '<property':
                name = $9d5117faee5c78f9$var$unescapexml(y.name);
                break;
            case '</property>':
                name = null;
                break;
            default:
                if (x.indexOf('<vt:') === 0) {
                    var toks = x.split('>');
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case 'lpstr':
                        case 'bstr':
                        case 'lpwstr':
                            p[name] = $9d5117faee5c78f9$var$unescapexml(text);
                            break;
                        case 'bool':
                            p[name] = $9d5117faee5c78f9$var$parsexmlbool(text);
                            break;
                        case 'i1':
                        case 'i2':
                        case 'i4':
                        case 'i8':
                        case 'int':
                        case 'uint':
                            p[name] = parseInt(text, 10);
                            break;
                        case 'r4':
                        case 'r8':
                        case 'decimal':
                            p[name] = parseFloat(text);
                            break;
                        case 'filetime':
                        case 'date':
                            p[name] = $9d5117faee5c78f9$var$parseDate(text);
                            break;
                        case 'cy':
                        case 'error':
                            p[name] = $9d5117faee5c78f9$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == '/') break;
                            if (opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $9d5117faee5c78f9$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER,
        $9d5117faee5c78f9$var$writextag('Properties', null, {
            'xmlns': $9d5117faee5c78f9$var$XMLNS.CUST_PROPS,
            'xmlns:vt': $9d5117faee5c78f9$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $9d5117faee5c78f9$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $9d5117faee5c78f9$var$writextag('property', $9d5117faee5c78f9$var$write_vt(cp[k], true), {
            'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
            'pid': pid,
            'name': $9d5117faee5c78f9$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $9d5117faee5c78f9$var$XLMLDocPropsMap = {
    Title: 'Title',
    Subject: 'Subject',
    Author: 'Author',
    Keywords: 'Keywords',
    Comments: 'Description',
    LastAuthor: 'LastAuthor',
    RevNumber: 'Revision',
    Application: 'AppName',
    /* TotalTime: 'TotalTime', */ LastPrinted: 'LastPrinted',
    CreatedDate: 'Created',
    ModifiedDate: 'LastSaved',
    /* Pages */ /* Words */ /* Characters */ Category: 'Category',
    /* PresentationFormat */ Manager: 'Manager',
    Company: 'Company',
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: 'Version',
    ContentStatus: 'ContentStatus',
    /* NOTE: missing from schema */ Identifier: 'Identifier',
    /* NOTE: missing from schema */ Language: 'Language' /* NOTE: missing from schema */ 
};
var $9d5117faee5c78f9$var$evert_XLMLDPM;
function $9d5117faee5c78f9$var$xlml_set_prop(Props, tag /*:string*/ , val) {
    if (!$9d5117faee5c78f9$var$evert_XLMLDPM) $9d5117faee5c78f9$var$evert_XLMLDPM = $9d5117faee5c78f9$var$evert($9d5117faee5c78f9$var$XLMLDocPropsMap);
    tag = $9d5117faee5c78f9$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val;
}
function $9d5117faee5c78f9$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $9d5117faee5c78f9$var$keys($9d5117faee5c78f9$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $9d5117faee5c78f9$var$CORE_PROPS.length; ++i)if ($9d5117faee5c78f9$var$CORE_PROPS[i][1] == m) return $9d5117faee5c78f9$var$CORE_PROPS[i];
        for(i = 0; i < $9d5117faee5c78f9$var$EXT_PROPS.length; ++i)if ($9d5117faee5c78f9$var$EXT_PROPS[i][1] == m) return $9d5117faee5c78f9$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case 'date':
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == 'number') m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($9d5117faee5c78f9$var$writetag($9d5117faee5c78f9$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $9d5117faee5c78f9$var$writextag('DocumentProperties', o.join(""), {
        xmlns: $9d5117faee5c78f9$var$XLMLNS.o
    });
}
function $9d5117faee5c78f9$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = 'CustomDocumentProperties';
    var o /*:Array<string>*/  = [];
    if (Props) $9d5117faee5c78f9$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $9d5117faee5c78f9$var$CORE_PROPS.length; ++i)if (k == $9d5117faee5c78f9$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $9d5117faee5c78f9$var$EXT_PROPS.length; ++i)if (k == $9d5117faee5c78f9$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($9d5117faee5c78f9$var$writextag($9d5117faee5c78f9$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $9d5117faee5c78f9$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($9d5117faee5c78f9$var$writextag($9d5117faee5c78f9$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return '<' + T + ' xmlns="' + $9d5117faee5c78f9$var$XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $9d5117faee5c78f9$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $9d5117faee5c78f9$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $9d5117faee5c78f9$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $9d5117faee5c78f9$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, 'lpstr-cp');
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $9d5117faee5c78f9$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, 'lpwstr');
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $9d5117faee5c78f9$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $9d5117faee5c78f9$var$parse_lpwstr(blob);
    return $9d5117faee5c78f9$var$parse_lpstr(blob, stringType, pad);
}
function $9d5117faee5c78f9$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $9d5117faee5c78f9$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $9d5117faee5c78f9$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $9d5117faee5c78f9$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $9d5117faee5c78f9$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, 'lpwstr').replace($9d5117faee5c78f9$var$chr0, '');
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $9d5117faee5c78f9$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, 'lpstr-cp').replace($9d5117faee5c78f9$var$chr0, '');
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $9d5117faee5c78f9$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $9d5117faee5c78f9$var$parse_TypedPropertyValue(blob, $9d5117faee5c78f9$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $9d5117faee5c78f9$var$parse_TypedPropertyValue(blob, $9d5117faee5c78f9$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $9d5117faee5c78f9$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($9d5117faee5c78f9$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $9d5117faee5c78f9$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? 'utf16le' : 'utf8').replace($9d5117faee5c78f9$var$chr0, '').replace($9d5117faee5c78f9$var$chr1, '!');
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $9d5117faee5c78f9$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $9d5117faee5c78f9$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $9d5117faee5c78f9$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $9d5117faee5c78f9$var$VT_VARIANT) {
        if (t !== type && $9d5117faee5c78f9$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
    }
    switch(type === $9d5117faee5c78f9$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, 'i');
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, 'i');
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            return $9d5117faee5c78f9$var$parse_lpstr(blob, t, 4).replace($9d5117faee5c78f9$var$chr0, '');
        case 0x1F /*VT_LPWSTR*/ :
            return $9d5117faee5c78f9$var$parse_lpwstr(blob);
        case 0x40 /*VT_FILETIME*/ :
            return $9d5117faee5c78f9$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $9d5117faee5c78f9$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $9d5117faee5c78f9$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $9d5117faee5c78f9$var$parse_VtString(blob, t, !opts.raw).replace($9d5117faee5c78f9$var$chr0, '');
        case 0x51 /*VT_USTR*/ :
            return $9d5117faee5c78f9$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($9d5117faee5c78f9$var$chr0, '');
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $9d5117faee5c78f9$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $9d5117faee5c78f9$var$parse_VtVecLpwstrValue(blob) : $9d5117faee5c78f9$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $9d5117faee5c78f9$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $9d5117faee5c78f9$var$new_buf(4), p = $9d5117faee5c78f9$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $9d5117faee5c78f9$var$new_buf(8);
            p.write_shift(8, value, 'f');
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $9d5117faee5c78f9$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $9d5117faee5c78f9$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $9d5117faee5c78f9$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $9d5117faee5c78f9$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
        }
        if (PIDSI) {
            if (Props[i][0] == 0 && Props.length > i + 1 && Props[i][1] == Props[i + 1][1]) continue; // R9
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $9d5117faee5c78f9$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $9d5117faee5c78f9$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $9d5117faee5c78f9$var$parse_TypedPropertyValue(blob, $9d5117faee5c78f9$var$VT_I2);
                $9d5117faee5c78f9$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $9d5117faee5c78f9$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $9d5117faee5c78f9$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val = $9d5117faee5c78f9$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val = $9d5117faee5c78f9$var$parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val = $9d5117faee5c78f9$var$parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4, 'i');
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val = blob.read_shift(8, 'f');
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val = $9d5117faee5c78f9$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val = $9d5117faee5c78f9$var$parseDate($9d5117faee5c78f9$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $9d5117faee5c78f9$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
];
function $9d5117faee5c78f9$var$guess_property_type(val /*:any*/ ) /*:number*/ {
    switch(typeof val){
        case "boolean":
            return 0x0B;
        case "number":
            return (val | 0) == val ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $9d5117faee5c78f9$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $9d5117faee5c78f9$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $9d5117faee5c78f9$var$new_buf(8), pio = $9d5117faee5c78f9$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $9d5117faee5c78f9$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $9d5117faee5c78f9$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $9d5117faee5c78f9$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $9d5117faee5c78f9$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($9d5117faee5c78f9$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $9d5117faee5c78f9$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val.split(".");
                val = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $9d5117faee5c78f9$var$write_TypedPropertyValue(pinfo.t, val);
        } else {
            var T = $9d5117faee5c78f9$var$guess_property_type(val);
            if (T == -1) {
                T = 0x1F;
                val = String(val);
            }
            pr = $9d5117faee5c78f9$var$write_TypedPropertyValue(T, val);
        }
        prop.push(pr);
        pio = $9d5117faee5c78f9$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $9d5117faee5c78f9$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $9d5117faee5c78f9$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $9d5117faee5c78f9$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk('feff', 'Byte Order: ');
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $9d5117faee5c78f9$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $9d5117faee5c78f9$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $9d5117faee5c78f9$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $9d5117faee5c78f9$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $9d5117faee5c78f9$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $9d5117faee5c78f9$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $9d5117faee5c78f9$var$bconcat(bufs);
}
function $9d5117faee5c78f9$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $9d5117faee5c78f9$var$writezeroes(n, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $9d5117faee5c78f9$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $9d5117faee5c78f9$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $9d5117faee5c78f9$var$writebool(v /*:any*/ , o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $9d5117faee5c78f9$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, 'u');
}
function $9d5117faee5c78f9$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $9d5117faee5c78f9$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $9d5117faee5c78f9$var$parslurp(blob, length, $9d5117faee5c78f9$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $9d5117faee5c78f9$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $9d5117faee5c78f9$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(2);
    o.write_shift(1, t == 'e' ? +v : +!!v);
    o.write_shift(1, t == 'e' ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $9d5117faee5c78f9$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = 'sbcs-cont';
    var cp = $9d5117faee5c78f9$var$current_codepage;
    if (opts && opts.biff >= 8) $9d5117faee5c78f9$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = 'dbcs-cont';
    } else if (opts.biff == 12) encoding = 'wstr';
    if (opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $9d5117faee5c78f9$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $9d5117faee5c78f9$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $9d5117faee5c78f9$var$current_codepage;
    $9d5117faee5c78f9$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $9d5117faee5c78f9$var$current_codepage = cp;
    return z;
}
function $9d5117faee5c78f9$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $9d5117faee5c78f9$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $9d5117faee5c78f9$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, 'utf16le');
    var out = [
        hdr,
        otext
    ];
    return $9d5117faee5c78f9$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $9d5117faee5c78f9$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
        if (opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, 'sbcs-cont');
    else retval = blob.read_shift(cch, 'dbcs-cont');
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $9d5117faee5c78f9$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $9d5117faee5c78f9$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $9d5117faee5c78f9$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $9d5117faee5c78f9$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */ function $9d5117faee5c78f9$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, 'utf16le');
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $9d5117faee5c78f9$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $9d5117faee5c78f9$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, 'utf16le').replace($9d5117faee5c78f9$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $9d5117faee5c78f9$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, 'lpstr-ansi');
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, 'utf16le').replace($9d5117faee5c78f9$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $9d5117faee5c78f9$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $9d5117faee5c78f9$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $9d5117faee5c78f9$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $9d5117faee5c78f9$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, 'utf16le').replace($9d5117faee5c78f9$var$chr0, "") : "";
    return o;
}
function $9d5117faee5c78f9$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $9d5117faee5c78f9$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $9d5117faee5c78f9$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $9d5117faee5c78f9$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $9d5117faee5c78f9$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $9d5117faee5c78f9$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $9d5117faee5c78f9$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $9d5117faee5c78f9$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $9d5117faee5c78f9$var$write_Hyperlink(hl) {
    var out = $9d5117faee5c78f9$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $9d5117faee5c78f9$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $9d5117faee5c78f9$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $9d5117faee5c78f9$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $9d5117faee5c78f9$var$parse_LongRGB(blob, length) {
    var x = $9d5117faee5c78f9$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $9d5117faee5c78f9$var$parse_XLSCell(blob /*::, length*/ ) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ixfe = blob.read_shift(2);
    return {
        r: rw,
        c: col,
        ixfe: ixfe
    } /*:any*/ ;
}
function $9d5117faee5c78f9$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $9d5117faee5c78f9$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $9d5117faee5c78f9$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $9d5117faee5c78f9$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $9d5117faee5c78f9$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, 'i'), itabLast = blob.read_shift(w, 'i');
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $9d5117faee5c78f9$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $9d5117faee5c78f9$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $9d5117faee5c78f9$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $9d5117faee5c78f9$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $9d5117faee5c78f9$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $9d5117faee5c78f9$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $9d5117faee5c78f9$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $9d5117faee5c78f9$var$parse_Ref = $9d5117faee5c78f9$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $9d5117faee5c78f9$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $9d5117faee5c78f9$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $9d5117faee5c78f9$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $9d5117faee5c78f9$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $9d5117faee5c78f9$var$FtTab = {
    /*::[*/ 0x00: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtEnd */ /*::[*/ 0x04: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtMacro */ /*::[*/ 0x05: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtButton */ /*::[*/ 0x06: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtGmo */ /*::[*/ 0x07: $9d5117faee5c78f9$var$parse_FtCf,
    /* FtCf */ /*::[*/ 0x08: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtPioGrbit */ /*::[*/ 0x09: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtPictFmla */ /*::[*/ 0x0A: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtCbls */ /*::[*/ 0x0B: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtRbo */ /*::[*/ 0x0C: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtSbs */ /*::[*/ 0x0D: $9d5117faee5c78f9$var$parse_FtNts,
    /* FtNts */ /*::[*/ 0x0E: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtSbsFmla */ /*::[*/ 0x0F: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtGboData */ /*::[*/ 0x10: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtEdoData */ /*::[*/ 0x11: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtRboData */ /*::[*/ 0x12: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtCblsData */ /*::[*/ 0x13: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtLbsData */ /*::[*/ 0x14: $9d5117faee5c78f9$var$parse_FtSkip,
    /* FtCblsFmla */ /*::[*/ 0x15: $9d5117faee5c78f9$var$parse_FtCmo
};
function $9d5117faee5c78f9$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts[ft] = $9d5117faee5c78f9$var$FtTab[ft](blob, tgt - blob.l);
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $9d5117faee5c78f9$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $9d5117faee5c78f9$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case 'biff8':
            break;
        case 'biff5':
            h = 0x0500;
            w = 8;
            break;
        case 'biff4':
            h = 0x0004;
            w = 6;
            break;
        case 'biff3':
            h = 0x0003;
            w = 6;
            break;
        case 'biff2':
            h = 0x0002;
            w = 4;
            break;
        case 'xla':
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $9d5117faee5c78f9$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $9d5117faee5c78f9$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $9d5117faee5c78f9$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $9d5117faee5c78f9$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $9d5117faee5c78f9$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $9d5117faee5c78f9$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $9d5117faee5c78f9$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $9d5117faee5c78f9$var$parse_BoundSheet8(blob, length, opts) {
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = 'Worksheet';
            break;
        case 1:
            dt = 'Macrosheet';
            break;
        case 2:
            dt = 'Chartsheet';
            break;
        case 6:
            dt = 'VBAModule';
            break;
    }
    var name = $9d5117faee5c78f9$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $9d5117faee5c78f9$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $9d5117faee5c78f9$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $9d5117faee5c78f9$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($9d5117faee5c78f9$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $9d5117faee5c78f9$var$write_SST(sst, opts) {
    var header = $9d5117faee5c78f9$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $9d5117faee5c78f9$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $9d5117faee5c78f9$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $9d5117faee5c78f9$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $9d5117faee5c78f9$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $9d5117faee5c78f9$var$parse_ForceFullCalculation(blob) {
    var header = $9d5117faee5c78f9$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $9d5117faee5c78f9$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $9d5117faee5c78f9$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $9d5117faee5c78f9$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $9d5117faee5c78f9$var$write_Window1() {
    var o = $9d5117faee5c78f9$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $9d5117faee5c78f9$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $9d5117faee5c78f9$var$write_Window2(view) {
    var o = $9d5117faee5c78f9$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $9d5117faee5c78f9$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $9d5117faee5c78f9$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $9d5117faee5c78f9$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $9d5117faee5c78f9$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $9d5117faee5c78f9$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $9d5117faee5c78f9$var$parse_LabelSst(blob) {
    var cell = $9d5117faee5c78f9$var$parse_XLSCell(blob);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $9d5117faee5c78f9$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $9d5117faee5c78f9$var$new_buf(10);
    $9d5117faee5c78f9$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $9d5117faee5c78f9$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $9d5117faee5c78f9$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2) blob.l++;
    var str = $9d5117faee5c78f9$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $9d5117faee5c78f9$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $9d5117faee5c78f9$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $9d5117faee5c78f9$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $9d5117faee5c78f9$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $9d5117faee5c78f9$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $9d5117faee5c78f9$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $9d5117faee5c78f9$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? 'sbcs' : 'utf16le');
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $9d5117faee5c78f9$var$parse_BIFF2Format = $9d5117faee5c78f9$var$parse_XLUnicodeString2;
/* [MS-XLS] 2.4.90 */ function $9d5117faee5c78f9$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $9d5117faee5c78f9$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $9d5117faee5c78f9$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $9d5117faee5c78f9$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $9d5117faee5c78f9$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $9d5117faee5c78f9$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($9d5117faee5c78f9$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $9d5117faee5c78f9$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $9d5117faee5c78f9$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $9d5117faee5c78f9$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $9d5117faee5c78f9$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $9d5117faee5c78f9$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $9d5117faee5c78f9$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $9d5117faee5c78f9$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.134 */ function $9d5117faee5c78f9$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $9d5117faee5c78f9$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $9d5117faee5c78f9$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $9d5117faee5c78f9$var$parse_BoolErr(blob, length, opts) {
    var cell = $9d5117faee5c78f9$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2 || length == 9) ++blob.l;
    var val = $9d5117faee5c78f9$var$parse_Bes(blob, 2);
    cell.val = val;
    cell.t = val === true || val === false ? 'b' : 'e';
    return cell;
}
function $9d5117faee5c78f9$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $9d5117faee5c78f9$var$new_buf(8);
    $9d5117faee5c78f9$var$write_XLSCell(R, C, os, o);
    $9d5117faee5c78f9$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $9d5117faee5c78f9$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $9d5117faee5c78f9$var$parse_XLSCell(blob, 6);
    var xnum = $9d5117faee5c78f9$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $9d5117faee5c78f9$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $9d5117faee5c78f9$var$new_buf(14);
    $9d5117faee5c78f9$var$write_XLSCell(R, C, os, o);
    $9d5117faee5c78f9$var$write_Xnum(v, o);
    return o;
}
var $9d5117faee5c78f9$var$parse_XLHeaderFooter = $9d5117faee5c78f9$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $9d5117faee5c78f9$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $9d5117faee5c78f9$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($9d5117faee5c78f9$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $9d5117faee5c78f9$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $9d5117faee5c78f9$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ function $9d5117faee5c78f9$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $9d5117faee5c78f9$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $9d5117faee5c78f9$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $9d5117faee5c78f9$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: legacy record filename encoding */ function $9d5117faee5c78f9$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $9d5117faee5c78f9$var$parse_BIFF5ExternSheet(blob, length, opts);
    /* see issue 2907 */ if (!(opts.biff > 8) && length == blob[blob.l] + (blob[blob.l + 1] == 0x03 ? 1 : 0) + 1) return $9d5117faee5c78f9$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($9d5117faee5c78f9$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $9d5117faee5c78f9$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $9d5117faee5c78f9$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $9d5117faee5c78f9$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $9d5117faee5c78f9$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $9d5117faee5c78f9$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $9d5117faee5c78f9$var$parse_ShrFmla(blob, length, opts) {
    var ref = $9d5117faee5c78f9$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $9d5117faee5c78f9$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $9d5117faee5c78f9$var$parse_Array(blob, length, opts) {
    var ref = $9d5117faee5c78f9$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $9d5117faee5c78f9$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $9d5117faee5c78f9$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 TODO: BIFF5 */ function $9d5117faee5c78f9$var$parse_NoteSh(blob, length, opts) {
    if (opts.biff < 8) return;
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $9d5117faee5c78f9$var$parse_XLUnicodeString2(blob, 0, opts);
    if (opts.biff < 8) blob.read_shift(1);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $9d5117faee5c78f9$var$parse_Note(blob, length, opts) {
    /* TODO: Support revisions */ return $9d5117faee5c78f9$var$parse_NoteSh(blob, length, opts);
}
/* [MS-XLS] 2.4.168 */ function $9d5117faee5c78f9$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($9d5117faee5c78f9$var$parse_Ref8U(blob, length));
    return merges;
}
function $9d5117faee5c78f9$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $9d5117faee5c78f9$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$9d5117faee5c78f9$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $9d5117faee5c78f9$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $9d5117faee5c78f9$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $9d5117faee5c78f9$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $9d5117faee5c78f9$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $9d5117faee5c78f9$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $9d5117faee5c78f9$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($9d5117faee5c78f9$var$parse_BIFF5OT[ot] || $9d5117faee5c78f9$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $9d5117faee5c78f9$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $9d5117faee5c78f9$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $9d5117faee5c78f9$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $9d5117faee5c78f9$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $9d5117faee5c78f9$var$parse_HLink(blob, length) {
    var ref = $9d5117faee5c78f9$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $9d5117faee5c78f9$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $9d5117faee5c78f9$var$write_HLink(hl) {
    var O = $9d5117faee5c78f9$var$new_buf(24);
    var ref = $9d5117faee5c78f9$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $9d5117faee5c78f9$var$bconcat([
        O,
        $9d5117faee5c78f9$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $9d5117faee5c78f9$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $9d5117faee5c78f9$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, 'dbcs-cont');
    wzTooltip = wzTooltip.replace($9d5117faee5c78f9$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $9d5117faee5c78f9$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $9d5117faee5c78f9$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $9d5117faee5c78f9$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $9d5117faee5c78f9$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $9d5117faee5c78f9$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $9d5117faee5c78f9$var$CountryEnum[d] || d;
    return o;
}
function $9d5117faee5c78f9$var$write_Country(o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $9d5117faee5c78f9$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($9d5117faee5c78f9$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $9d5117faee5c78f9$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($9d5117faee5c78f9$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $9d5117faee5c78f9$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $9d5117faee5c78f9$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $9d5117faee5c78f9$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $9d5117faee5c78f9$var$write_ColInfo(col, idx) {
    var o = $9d5117faee5c78f9$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $9d5117faee5c78f9$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $9d5117faee5c78f9$var$parse_Xnum(blob, 8);
    o.footer = $9d5117faee5c78f9$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $9d5117faee5c78f9$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $9d5117faee5c78f9$var$write_RRTabId(n /*:number*/ ) {
    var out = $9d5117faee5c78f9$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $9d5117faee5c78f9$var$parse_Blank = $9d5117faee5c78f9$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $9d5117faee5c78f9$var$parse_Scl = $9d5117faee5c78f9$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $9d5117faee5c78f9$var$parse_String = $9d5117faee5c78f9$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $9d5117faee5c78f9$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $9d5117faee5c78f9$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $9d5117faee5c78f9$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var str = $9d5117faee5c78f9$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $9d5117faee5c78f9$var$parse_BIFF2NUM(blob /*::, length*/ ) {
    var cell = $9d5117faee5c78f9$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var num = $9d5117faee5c78f9$var$parse_Xnum(blob, 8);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $9d5117faee5c78f9$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = $9d5117faee5c78f9$var$new_buf(15);
    $9d5117faee5c78f9$var$write_BIFF2Cell(out, r, c);
    out.write_shift(8, val, 'f');
    return out;
}
function $9d5117faee5c78f9$var$parse_BIFF2INT(blob) {
    var cell = $9d5117faee5c78f9$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var num = blob.read_shift(2);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $9d5117faee5c78f9$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = $9d5117faee5c78f9$var$new_buf(9);
    $9d5117faee5c78f9$var$write_BIFF2Cell(out, r, c);
    out.write_shift(2, val);
    return out;
}
function $9d5117faee5c78f9$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, 'sbcs-cont');
}
/* TODO: convert to BIFF8 font struct */ function $9d5117faee5c78f9$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $9d5117faee5c78f9$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $9d5117faee5c78f9$var$parse_XLSCell(blob, 6);
    var cch = blob.read_shift(2);
    var str = $9d5117faee5c78f9$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = 'str';
    cell.val = str;
    return cell;
}
var $9d5117faee5c78f9$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $9d5117faee5c78f9$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /* shapefile DBF extension */ /*::[*/ 0x00: 20127,
        /*::[*/ 0x08: 865,
        /*::[*/ 0x09: 437,
        /*::[*/ 0x0A: 850,
        /*::[*/ 0x0B: 437,
        /*::[*/ 0x0D: 437,
        /*::[*/ 0x0E: 850,
        /*::[*/ 0x0F: 437,
        /*::[*/ 0x10: 850,
        /*::[*/ 0x11: 437,
        /*::[*/ 0x12: 850,
        /*::[*/ 0x13: 932,
        /*::[*/ 0x14: 850,
        /*::[*/ 0x15: 437,
        /*::[*/ 0x16: 850,
        /*::[*/ 0x17: 865,
        /*::[*/ 0x18: 437,
        /*::[*/ 0x19: 437,
        /*::[*/ 0x1A: 850,
        /*::[*/ 0x1B: 437,
        /*::[*/ 0x1C: 863,
        /*::[*/ 0x1D: 850,
        /*::[*/ 0x1F: 852,
        /*::[*/ 0x22: 852,
        /*::[*/ 0x23: 852,
        /*::[*/ 0x24: 860,
        /*::[*/ 0x25: 850,
        /*::[*/ 0x26: 866,
        /*::[*/ 0x37: 850,
        /*::[*/ 0x40: 852,
        /*::[*/ 0x4D: 936,
        /*::[*/ 0x4E: 949,
        /*::[*/ 0x4F: 950,
        /*::[*/ 0x50: 874,
        /*::[*/ 0x57: 1252,
        /*::[*/ 0x58: 1252,
        /*::[*/ 0x59: 1252,
        /*::[*/ 0x6C: 863,
        /*::[*/ 0x86: 737,
        /*::[*/ 0x87: 852,
        /*::[*/ 0x88: 857,
        /*::[*/ 0xCC: 1257,
        /*::[*/ 0xFF: 16969
    };
    var dbf_reverse_map = $9d5117faee5c78f9$var$evert({
        /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /*::[*/ 0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $9d5117faee5c78f9$var$new_raw_buf(1);
        switch(opts.type){
            case 'base64':
                d = $9d5117faee5c78f9$var$s2a($9d5117faee5c78f9$var$Base64_decode(buf));
                break;
            case 'binary':
                d = $9d5117faee5c78f9$var$s2a(buf);
                break;
            case 'buffer':
            case 'array':
                d = buf;
                break;
        }
        $9d5117faee5c78f9$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = (typeof $9d5117faee5c78f9$var$$cptable !== "undefined" ? $9d5117faee5c78f9$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)) : $9d5117faee5c78f9$var$a2s(d.slice(d.l, d.l + ww))).replace(/[\u0000\r\n].*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case 'B':
                    if ((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case 'G':
                case 'P':
                    if (opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case '+':
                case '0':
                case '@':
                case 'C':
                case 'D':
                case 'F':
                case 'I':
                case 'L':
                case 'M':
                case 'N':
                case 'O':
                case 'T':
                case 'Y':
                    break;
                default:
                    throw new Error('Unknown Field Type: ' + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $9d5117faee5c78f9$var$prep_blob(dd, 0);
                var s = typeof $9d5117faee5c78f9$var$$cptable !== "undefined" ? $9d5117faee5c78f9$var$$cptable.utils.decode(current_cp, dd) : $9d5117faee5c78f9$var$a2s(dd);
                switch(fields[C].type){
                    case 'C':
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/\s+$/, "");
                        break;
                    case 'D':
                        if (s.length === 8) out[R][C] = new Date(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8));
                        else out[R][C] = s;
                        break;
                    case 'F':
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case '+':
                    case 'I':
                        out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i');
                        break;
                    case 'L':
                        switch(s.trim().toUpperCase()){
                            case 'Y':
                            case 'T':
                                out[R][C] = true;
                                break;
                            case 'N':
                            case 'F':
                                out[R][C] = false;
                                break;
                            case '':
                            case '?':
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case 'M':
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case 'N':
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case '@':
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
                        break;
                    case 'T':
                        out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4));
                        break;
                    case 'Y':
                        out[R][C] = dd.read_shift(4, 'i') / 1e4 + dd.read_shift(4, 'i') / 1e4 * Math.pow(2, 32);
                        break;
                    case 'O':
                        out[R][C] = -dd.read_shift(-8, 'f');
                        break;
                    case 'B':
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, 'f');
                            break;
                        }
                    /* falls through */ case 'G':
                    case 'P':
                        dd.l += fields[C].len;
                        break;
                    case '0':
                        if (fields[C].name === '_NullFlags') break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $9d5117faee5c78f9$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            var o = $9d5117faee5c78f9$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
            o.bookType = "dbf";
            return o;
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        'B': 8,
        'C': 250,
        'L': 1,
        'D': 8,
        '?': 0,
        '': 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        var old_cp = $9d5117faee5c78f9$var$current_codepage;
        if (+o.codepage >= 0) $9d5117faee5c78f9$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $9d5117faee5c78f9$var$buf_array();
        var aoa /*:AOA*/  = $9d5117faee5c78f9$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref']);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = '', _guess = '', maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = '?';
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case 'number':
                        _guess = 'B';
                        break;
                    case 'string':
                        _guess = 'C';
                        break;
                    case 'boolean':
                        _guess = 'L';
                        break;
                    case 'object':
                        _guess = col[j] instanceof Date ? 'D' : 'C';
                        break;
                    default:
                        _guess = 'C';
                }
                /* TODO: cache the values instead of encoding twice */ maxlen = Math.max(maxlen, (typeof $9d5117faee5c78f9$var$$cptable !== "undefined" && typeof col[j] == "string" ? $9d5117faee5c78f9$var$$cptable.utils.encode($9d5117faee5c78f9$var$current_ansi, col[j]) : String(col[j])).length);
                guess = guess && guess != _guess ? 'C' : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == 'C') {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == 'B' && _guess == 'N') {
                guess = 'N';
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        var cp = +dbf_reverse_map[/*::String(*/ $9d5117faee5c78f9$var$current_codepage /*::)*/ ] || 0x03;
        h.write_shift(4, 0x00000000 | cp << 8);
        if (dbf_codepage_map[cp] != +o.codepage) {
            if (o.codepage) console.error("DBF Unsupported codepage " + $9d5117faee5c78f9$var$current_codepage + ", using 1252");
            $9d5117faee5c78f9$var$current_codepage = 1252;
        }
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            /* TODO: test how applications handle non-ASCII field names */ var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case 'L':
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case 'B':
                        rout.write_shift(8, data[i][j] || 0, 'f');
                        break;
                    case 'N':
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        if (_n.length > colwidths[j]) _n = _n.slice(0, colwidths[j]); // addresses decimal > width
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case 'D':
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case 'C':
                        var _l = rout.l;
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "cpstr");
                        _l += colwidths[j] - rout.l;
                        for(hcnt = 0; hcnt < _l; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        $9d5117faee5c78f9$var$current_codepage = old_cp;
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $9d5117faee5c78f9$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        /*::[*/ 0: 176,
        /*::[*/ 1: 177,
        /*::[*/ 2: 178,
        /*::[*/ 3: 179,
        /*::[*/ 5: 181,
        /*::[*/ 6: 182,
        /*::[*/ 7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\u001BN(" + $9d5117faee5c78f9$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $9d5117faee5c78f9$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $9d5117faee5c78f9$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* https://oss.sheetjs.com/notes/sylk/ for more details */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case 'base64':
                return sylk_to_aoa_str($9d5117faee5c78f9$var$Base64_decode(d), opts);
            case 'binary':
                return sylk_to_aoa_str(d, opts);
            case 'buffer':
                return sylk_to_aoa_str($9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(d) ? d.toString('binary') : $9d5117faee5c78f9$var$a2s(d), opts);
            case 'array':
                return sylk_to_aoa_str($9d5117faee5c78f9$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        var wb = {
            Workbook: {
                WBProps: {},
                Names: []
            }
        };
        if (+opts.codepage >= 0) $9d5117faee5c78f9$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\u0000").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val;
            if (rstr.length > 0) switch(RT){
                case 'ID':
                    break; /* header */ 
                case 'E':
                    break; /* EOF */ 
                case 'B':
                    break; /* dimensions */ 
                case 'O':
                    /* workbook options */ for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'V':
                            var d1904 = parseInt(record[rj].slice(1), 10);
                            // NOTE: it is technically an error if d1904 >= 5 or < 0
                            if (d1904 >= 1 && d1904 <= 4) wb.Workbook.WBProps.date1904 = true;
                            break;
                    }
                    break;
                case 'W':
                    break; /* window */ 
                case 'P':
                    switch(record[1].charAt(0)){
                        case 'P':
                            formats.push(rstr.slice(3).replace(/;;/g, ";"));
                            break;
                    }
                    break;
                case 'NN':
                    var nn = {
                        Sheet: 0
                    };
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'N':
                            nn.Name = record[rj].slice(1);
                            break;
                        case 'E':
                            nn.Ref = (opts && opts.sheet || "Sheet1") + "!" + $9d5117faee5c78f9$var$rc_to_a1(record[rj].slice(1));
                            break;
                    }
                    wb.Workbook.Names.push(nn);
                    break;
                // case 'NE': // ??
                // case 'NU': // ??
                case 'C':
                    /* cell */ var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1, formula = "", cell_t = "z";
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'A':
                            break; // TODO: comment
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            C_seen_X = true;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'K':
                            val = record[rj].slice(1);
                            if (val.charAt(0) === '"') {
                                val = val.slice(1, val.length - 1);
                                cell_t = "s";
                            } else if (val === 'TRUE' || val === 'FALSE') {
                                val = val === 'TRUE';
                                cell_t = "b";
                            } else if (!isNaN($9d5117faee5c78f9$var$fuzzynum(val))) {
                                val = $9d5117faee5c78f9$var$fuzzynum(val);
                                cell_t = "n";
                                if (next_cell_format !== null && $9d5117faee5c78f9$var$fmt_is_date(next_cell_format) && opts.cellDates) {
                                    val = $9d5117faee5c78f9$var$numdate(wb.Workbook.WBProps.date1904 ? val + 1462 : val);
                                    cell_t = "d";
                                }
                            } else if (!isNaN($9d5117faee5c78f9$var$fuzzydate(val).getDate())) {
                                val = $9d5117faee5c78f9$var$parseDate(val);
                                cell_t = "d";
                                if (!opts.cellDates) {
                                    cell_t = "n";
                                    val = $9d5117faee5c78f9$var$datenum(val, wb.Workbook.WBProps.date1904);
                                }
                            }
                            if (typeof $9d5117faee5c78f9$var$$cptable !== 'undefined' && typeof val == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val = $9d5117faee5c78f9$var$$cptable.utils.decode(opts.codepage, val);
                            C_seen_K = true;
                            break;
                        case 'E':
                            C_seen_E = true;
                            formula = $9d5117faee5c78f9$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            break;
                        case 'S':
                            C_seen_S = true;
                            break;
                        case 'G':
                            break; // unknown
                        case 'R':
                            _R = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        case 'C':
                            _C = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        // case 'P': // ??
                        // case 'D': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: cell_t,
                            v: val
                        };
                        else {
                            arr[R][C].t = cell_t;
                            arr[R][C].v = val;
                        }
                        if (next_cell_format) arr[R][C].z = next_cell_format;
                        if (opts.cellText !== false && next_cell_format) arr[R][C].w = $9d5117faee5c78f9$var$SSF_format(arr[R][C].z, arr[R][C].v, {
                            date1904: wb.Workbook.WBProps.date1904
                        });
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        formula = $9d5117faee5c78f9$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    if (formula) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'n',
                            f: formula
                        };
                        else arr[R][C].f = formula;
                    }
                    break;
                case 'F':
                    /* Format */ var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            ++F_seen;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'M':
                            Mval = parseInt(record[rj].slice(1), 10) / 20;
                            break;
                        case 'F':
                            break; /* ??? */ 
                        case 'G':
                            break; /* hide grid */ 
                        case 'P':
                            next_cell_format = formats[parseInt(record[rj].slice(1), 10)];
                            break;
                        case 'S':
                            break; /* cell style */ 
                        case 'D':
                            break; /* column */ 
                        case 'N':
                            break; /* font */ 
                        case 'W':
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                            }
                            break;
                        case 'C':
                            /* default column format */ C = parseInt(record[rj].slice(1), 10) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case 'R':
                            /* row properties */ R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $9d5117faee5c78f9$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        // case 'K': // ??
                        // case 'E': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht['!rows'] = rowinfo;
        if (colinfo.length > 0) sht['!cols'] = colinfo;
        colinfo.forEach(function(col) {
            $9d5117faee5c78f9$var$process_col(col);
        });
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht,
            wb
        ];
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1], wb = aoasht[2];
        var _opts = $9d5117faee5c78f9$var$dup(opts);
        _opts.date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var o = $9d5117faee5c78f9$var$aoa_to_sheet(aoa, _opts);
        $9d5117faee5c78f9$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        var outwb = $9d5117faee5c78f9$var$sheet_to_workbook(o, opts);
        $9d5117faee5c78f9$var$keys(wb).forEach(function(k) {
            outwb[k] = wb[k];
        });
        outwb.bookType = "sylk";
        return outwb;
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case 'n':
                o += cell.v || 0;
                if (cell.f && !cell.F) o += ";E" + $9d5117faee5c78f9$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case 'b':
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case 'e':
                o += cell.w || cell.v;
                break;
            case 'd':
                o += '"' + (cell.w || cell.v) + '"';
                break;
            case 's':
                o += '"' + (cell.v == null ? "" : String(cell.v)).replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == 'number' && !col.wpx) col.wpx = $9d5117faee5c78f9$var$width2px(col.width);
                if (typeof col.wpx == 'number' && !col.wch) col.wch = $9d5117faee5c78f9$var$px2char(col.wpx);
                if (typeof col.wch == 'number') rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $9d5117faee5c78f9$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ , wb /*:?WorkBook*/ ) /*:string*/ {
        /* TODO: codepage */ var preamble /*:Array<string>*/  = [
            "ID;PSheetJS;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        var RS = "\r\n";
        var d1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        preamble.push("P;PGeneral");
        preamble.push("F;P0;DG0G8;M255");
        if (ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
        if (ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
        preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        preamble.push("O;L;D;B" + (d1904 ? ";V4" : "") + ";K47;G100 0.001");
        for(var R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            var p = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$9d5117faee5c78f9$var$encode_col(C) + $9d5117faee5c78f9$var$encode_row(R)];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                p.push(write_ws_cell_sylk(cell, ws, R, C, opts)); // TODO: pass date1904 info
            }
            o.push(p.join(RS));
        }
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        from_sheet: sheet_to_sylk
    };
}();
var $9d5117faee5c78f9$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case 'base64':
                return dif_to_aoa_str($9d5117faee5c78f9$var$Base64_decode(d), opts);
            case 'binary':
                return dif_to_aoa_str(d, opts);
            case 'buffer':
                return dif_to_aoa_str($9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(d) ? d.toString('binary') : $9d5117faee5c78f9$var$a2s(d), opts);
            case 'array':
                return dif_to_aoa_str($9d5117faee5c78f9$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === 'BOT') {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === 'BOT') {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === 'TRUE') arr[R][C] = true;
                    else if (data === 'FALSE') arr[R][C] = false;
                    else if (!isNaN($9d5117faee5c78f9$var$fuzzynum(value))) arr[R][C] = $9d5117faee5c78f9$var$fuzzynum(value);
                    else if (!isNaN($9d5117faee5c78f9$var$fuzzydate(value).getDate())) arr[R][C] = $9d5117faee5c78f9$var$parseDate(value);
                    else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($9d5117faee5c78f9$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== '' ? data : null;
                    break;
            }
            if (data === 'EOD') break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $9d5117faee5c78f9$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        var o = $9d5117faee5c78f9$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
        o.bookType = "dif";
        return o;
    }
    function make_value(v /*:number*/ , s /*:string*/ ) /*:string*/ {
        return "0," + String(v) + "\r\n" + s;
    }
    function make_value_str(s /*:string*/ ) /*:string*/ {
        return "1,0\r\n\"" + s.replace(/"/g, '""') + '"';
    }
    function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var _DIF_XL = $9d5117faee5c78f9$var$DIF_XL;
        var r = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        var o /*:Array<string>*/  = [
            "TABLE\r\n0,1\r\n\"sheetjs\"\r\n",
            "VECTORS\r\n0," + (r.e.r - r.s.r + 1) + "\r\n\"\"\r\n",
            "TUPLES\r\n0," + (r.e.c - r.s.c + 1) + "\r\n\"\"\r\n",
            "DATA\r\n0,0\r\n\"\"\r\n"
        ];
        for(var R = r.s.r; R <= r.e.r; ++R){
            var row = dense ? ws["!data"][R] : [];
            var p = "-1,0\r\nBOT\r\n";
            for(var C = r.s.c; C <= r.e.c; ++C){
                var cell /*:Cell*/  = dense ? row && row[C] : ws[$9d5117faee5c78f9$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (cell == null) {
                    p += "1,0\r\n\"\"\r\n";
                    continue;
                }
                switch(cell.t){
                    case 'n':
                        if (_DIF_XL) {
                            if (cell.w != null) p += "0," + cell.w + "\r\nV";
                            else if (cell.v != null) p += make_value(cell.v, "V"); // TODO: should this call SSF_format?
                            else if (cell.f != null && !cell.F) p += make_value_str("=" + cell.f);
                            else p += "1,0\r\n\"\"";
                        } else if (cell.v == null) p += "1,0\r\n\"\"";
                        else p += make_value(cell.v, "V");
                        break;
                    case 'b':
                        p += cell.v ? make_value(1, "TRUE") : make_value(0, "FALSE");
                        break;
                    case 's':
                        p += make_value_str(!_DIF_XL || isNaN(+cell.v) ? cell.v : '="' + cell.v + '"');
                        break;
                    case 'd':
                        if (!cell.w) cell.w = $9d5117faee5c78f9$var$SSF_format(cell.z || $9d5117faee5c78f9$var$table_fmt[14], $9d5117faee5c78f9$var$datenum($9d5117faee5c78f9$var$parseDate(cell.v)));
                        if (_DIF_XL) p += make_value(cell.w, "V");
                        else p += make_value_str(cell.w);
                        break;
                    default:
                        p += "1,0\r\n\"\"";
                }
                p += "\r\n";
            }
            o.push(p);
        }
        return o.join("") + "-1,0\r\nEOD";
    }
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $9d5117faee5c78f9$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== 'cell') continue;
            var addr = $9d5117faee5c78f9$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case 't':
                    arr[R][C] = decode(record[3]);
                    break;
                case 'v':
                    arr[R][C] = +record[3];
                    break;
                case 'vtf':
                    var _f = record[record.length - 1];
                /* falls through */ case 'vtc':
                    switch(record[3]){
                        case 'nl':
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = +record[4];
                            break;
                    }
                    if (record[2] == 'vtf') arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $9d5117faee5c78f9$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $9d5117faee5c78f9$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws['!ref']) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $9d5117faee5c78f9$var$decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $9d5117faee5c78f9$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === 'z') continue;
            oo = [
                "cell",
                coord,
                't'
            ];
            switch(cell.t){
                case 's':
                case 'str':
                    oo.push(encode(cell.v));
                    break;
                case 'n':
                    if (!cell.f) {
                        oo[2] = 'v';
                        oo[3] = cell.v;
                    } else {
                        oo[2] = 'vtf';
                        oo[3] = 'n';
                        oo[4] = cell.v;
                        oo[5] = encode(cell.f);
                    }
                    break;
                case 'b':
                    oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                    oo[3] = 'nl';
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? 'TRUE' : 'FALSE'));
                    break;
                case 'd':
                    var t = $9d5117faee5c78f9$var$datenum($9d5117faee5c78f9$var$parseDate(cell.v));
                    oo[2] = 'vtc';
                    oo[3] = 'nd';
                    oo[4] = "" + t;
                    oo[5] = cell.w || $9d5117faee5c78f9$var$SSF_format(cell.z || $9d5117faee5c78f9$var$table_fmt[14], t);
                    break;
                case 'e':
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $9d5117faee5c78f9$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === 'TRUE') arr[R][C] = true;
        else if (data === 'FALSE') arr[R][C] = false;
        else if (!isNaN($9d5117faee5c78f9$var$fuzzynum(data))) arr[R][C] = $9d5117faee5c78f9$var$fuzzynum(data);
        else if (!isNaN($9d5117faee5c78f9$var$fuzzydate(data).getDate())) arr[R][C] = $9d5117faee5c78f9$var$parseDate(data);
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        /*::[*/ 0x2C: ',',
        /*::[*/ 0x09: "\t",
        /*::[*/ 0x3B: ';',
        /*::[*/ 0x7C: '|'
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        /*::[*/ 0x2C: 3,
        /*::[*/ 0x09: 2,
        /*::[*/ 0x3B: 1,
        /*::[*/ 0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($9d5117faee5c78f9$var$DENSE != null && o.dense == null) o.dense = $9d5117faee5c78f9$var$DENSE;
        var ws /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) ws["!data"] = [];
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        var _re /*:?RegExp*/  = o.dateNF != null ? $9d5117faee5c78f9$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            var s = str.slice(start, end);
            if (s.slice(-1) == "\r") s = s.slice(0, -1);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (s.length === 0) cell.t = 'z';
            else if (o.raw) {
                cell.t = 's';
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = 's';
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = 's';
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($9d5117faee5c78f9$var$fuzzyfmla(s)) {
                    cell.t = 'n';
                    cell.f = s.slice(1);
                } else {
                    cell.t = 's';
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = 'b';
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = 'b';
                cell.v = false;
            } else if (!isNaN(v = $9d5117faee5c78f9$var$fuzzynum(s))) {
                cell.t = 'n';
                if (o.cellText !== false) cell.w = s;
                cell.v = v;
            } else if (!isNaN((v = $9d5117faee5c78f9$var$fuzzydate(s)).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $9d5117faee5c78f9$var$table_fmt[14];
                var k = 0;
                if (_re && s.match(_re)) {
                    s = $9d5117faee5c78f9$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    k = 1;
                    v = $9d5117faee5c78f9$var$parseDate(s, k);
                }
                if (o.cellDates) {
                    cell.t = 'd';
                    cell.v = v;
                } else {
                    cell.t = 'n';
                    cell.v = $9d5117faee5c78f9$var$datenum(v);
                }
                if (o.cellText !== false) cell.w = $9d5117faee5c78f9$var$SSF_format(cell.z, cell.v instanceof Date ? $9d5117faee5c78f9$var$datenum(cell.v) : cell.v);
                if (!o.cellNF) delete cell.z;
            } else {
                cell.t = 's';
                cell.v = s;
            }
            if (cell.t == 'z') ;
            else if (o.dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = cell;
            } else ws[$9d5117faee5c78f9$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case 0x0d:
                if (instr) break;
                if (str.charCodeAt(end + 1) == 0x0a) ++end;
            /* falls through */ case sepcc:
            case 0x0a:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws['!ref'] = $9d5117faee5c78f9$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $9d5117faee5c78f9$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == 'string' ? [
            0,
            0,
            0,
            0
        ] : $9d5117faee5c78f9$var$firstbyte(d, opts);
        switch(opts.type){
            case 'base64':
                str = $9d5117faee5c78f9$var$Base64_decode(d);
                break;
            case 'binary':
                str = d;
                break;
            case 'buffer':
                if (opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
                else if (opts.codepage && typeof $9d5117faee5c78f9$var$$cptable !== 'undefined') str = $9d5117faee5c78f9$var$$cptable.utils.decode(opts.codepage, d);
                else str = $9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(d) ? d.toString('binary') : $9d5117faee5c78f9$var$a2s(d);
                break;
            case 'array':
                str = $9d5117faee5c78f9$var$cc2str(d);
                break;
            case 'string':
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $9d5117faee5c78f9$var$utf8read(str.slice(3));
        else if (opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = $9d5117faee5c78f9$var$utf8read(str);
        else if (opts.type == 'binary' && typeof $9d5117faee5c78f9$var$$cptable !== 'undefined' && opts.codepage) str = $9d5117faee5c78f9$var$$cptable.utils.decode(opts.codepage, $9d5117faee5c78f9$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $9d5117faee5c78f9$var$ETH.to_sheet(opts.type == 'string' ? str : $9d5117faee5c78f9$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $9d5117faee5c78f9$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        var r = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $9d5117faee5c78f9$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($9d5117faee5c78f9$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $9d5117faee5c78f9$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $9d5117faee5c78f9$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
        return $9d5117faee5c78f9$var$PRN.to_workbook(d, opts);
    }
}
var $9d5117faee5c78f9$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $9d5117faee5c78f9$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case 'base64':
                return lotus_to_workbook_buf($9d5117faee5c78f9$var$s2a($9d5117faee5c78f9$var$Base64_decode(d)), opts);
            case 'binary':
                return lotus_to_workbook_buf($9d5117faee5c78f9$var$s2a(d), opts);
            case 'buffer':
            case 'array':
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($9d5117faee5c78f9$var$DENSE != null && o.dense == null) o.dense = $9d5117faee5c78f9$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ , n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [], sdata = [];
        if (o.dense) sdata = s["!data"] = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        if (d[4] == 0x51 && d[5] == 0x50 && d[6] == 0x57) return qpw_to_workbook_buf(d, opts);
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val;
                        if (val >= 0x1000) o.qpro = true;
                        break;
                    case 0xFF:
                        /* BOF (works 3+) */ o.vers = val;
                        o.works = true;
                        break;
                    case 0x06:
                        refguess = val;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val) next_n = val;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if ((!o.qpro && !o.works || RT == 0x33) && val[1].v.charCodeAt(0) < 0x30) val[1].v = val[1].v.slice(1);
                        if (o.works || o.works2) val[1].v = val[1].v.replace(/\r\n/g, "\n");
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if (RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
                            val[1].z = o.dateNF || $9d5117faee5c78f9$var$table_fmt[14];
                            if (o.cellDates) {
                                val[1].t = 'd';
                                val[1].v = $9d5117faee5c78f9$var$numdate(val[1].v);
                            }
                        }
                        if (o.qpro) {
                            if (val[3] > sidx) {
                                s["!ref"] = $9d5117faee5c78f9$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = {} /*:any*/ ;
                                if (o.dense) sdata = s["!data"] = [];
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (sdata[val[0].r] || [])[val[0].c] : s[$9d5117faee5c78f9$var$encode_cell(val[0])];
                        if (tmpcell) {
                            tmpcell.t = val[1].t;
                            tmpcell.v = val[1].v;
                            if (val[1].z != null) tmpcell.z = val[1].z;
                            if (val[1].f != null) tmpcell.f = val[1].f;
                            break;
                        }
                        if (o.dense) {
                            if (!sdata[val[0].r]) sdata[val[0].r] = [];
                            sdata[val[0].r][val[0].c] = val[1];
                        } else s[$9d5117faee5c78f9$var$encode_cell(val[0])] = val[1];
                        break;
                    case 0x5405:
                        o.works2 = true;
                        break;
                    default:
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ if (val[1].v.charCodeAt(0) < 0x30) val[1].v = val[1].v.slice(1);
                        // TODO: R9 appears to encode control codes this way -- verify against other versions
                        val[1].v = val[1].v.replace(/\x0F./g, function($$) {
                            return String.fromCharCode($$.charCodeAt(1) - 0x20);
                        }).replace(/\r\n/g, "\n");
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val[3] > sidx) {
                            s["!ref"] = $9d5117faee5c78f9$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = {} /*:any*/ ;
                            if (o.dense) sdata = s["!data"] = [];
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!sdata[val[0].r]) sdata[val[0].r] = [];
                            sdata[val[0].r][val[0].c] = val[1];
                        } else s[$9d5117faee5c78f9$var$encode_cell(val[0])] = val[1];
                        if (refguess.e.c < val[0].c) refguess.e.c = val[0].c;
                        if (refguess.e.r < val[0].r) refguess.e.r = val[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val[0]] = val[1];
                        if (val[0] == sidx) n = val[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $9d5117faee5c78f9$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $9d5117faee5c78f9$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $9d5117faee5c78f9$var$buf_array();
        var range = $9d5117faee5c78f9$var$safe_decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var cols = [];
        $9d5117faee5c78f9$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $9d5117faee5c78f9$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $9d5117faee5c78f9$var$encode_col(C);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $9d5117faee5c78f9$var$encode_row(R);
            for(C = range.s.c; C <= range.e.c; ++C){
                var cell = dense ? (ws["!data"][R] || [])[C] : ws[cols[C] + rr];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ if (cell.t == "n") {
                    if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
                    else $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
                } else {
                    var str = $9d5117faee5c78f9$var$format_cell(cell);
                    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $9d5117faee5c78f9$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $9d5117faee5c78f9$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $9d5117faee5c78f9$var$buf_array();
        $9d5117faee5c78f9$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $9d5117faee5c78f9$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $9d5117faee5c78f9$var$safe_decode_range(ws["!ref"]);
            var dense = ws["!data"] != null;
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $9d5117faee5c78f9$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $9d5117faee5c78f9$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $9d5117faee5c78f9$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $9d5117faee5c78f9$var$format_cell(cell);
                        /* TODO: max len? */ $9d5117faee5c78f9$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $9d5117faee5c78f9$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $9d5117faee5c78f9$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $9d5117faee5c78f9$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $9d5117faee5c78f9$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $9d5117faee5c78f9$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else if (opts.works) {
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
            o[2] = blob.read_shift(2);
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if (opts.vers == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $9d5117faee5c78f9$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_STRING(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if (opts.vers == 0x5120) {
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, 'i');
        return o;
    }
    function write_INTEGER(R, C, v) {
        var o = $9d5117faee5c78f9$var$new_buf(7);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, v, 'i');
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, 'f');
        return o;
    }
    function write_NUMBER(R, C, v) {
        var o = $9d5117faee5c78f9$var$new_buf(13);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, v, 'f');
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, 'f');
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $9d5117faee5c78f9$var$encode_col(V) : $9d5117faee5c78f9$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x1F: [
            "NA",
            0
        ],
        // 0x20: ["ERR", 0],
        0x21: [
            "ABS",
            1
        ],
        0x22: [
            "TRUNC",
            1
        ],
        0x23: [
            "SQRT",
            1
        ],
        0x24: [
            "LOG",
            1
        ],
        0x25: [
            "LN",
            1
        ],
        0x26: [
            "PI",
            0
        ],
        0x27: [
            "SIN",
            1
        ],
        0x28: [
            "COS",
            1
        ],
        0x29: [
            "TAN",
            1
        ],
        0x2A: [
            "ATAN2",
            2
        ],
        0x2B: [
            "ATAN",
            1
        ],
        0x2C: [
            "ASIN",
            1
        ],
        0x2D: [
            "ACOS",
            1
        ],
        0x2E: [
            "EXP",
            1
        ],
        0x2F: [
            "MOD",
            2
        ],
        // 0x30
        0x31: [
            "ISNA",
            1
        ],
        0x32: [
            "ISERR",
            1
        ],
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x35: [
            "RAND",
            0
        ],
        // 0x36 DATE
        // 0x37 NOW
        // 0x38 PMT
        // 0x39 PV
        // 0x3A FV
        // 0x3B IF
        // 0x3C DAY
        // 0x3D MONTH
        // 0x3E YEAR
        0x3F: [
            "ROUND",
            2
        ],
        // 0x40 TIME
        // 0x41 HOUR
        // 0x42 MINUTE
        // 0x43 SECOND
        0x44: [
            "ISNUMBER",
            1
        ],
        0x45: [
            "ISTEXT",
            1
        ],
        0x46: [
            "LEN",
            1
        ],
        0x47: [
            "VALUE",
            1
        ],
        // 0x48: ["FIXED", ?? 1],
        0x49: [
            "MID",
            3
        ],
        0x4A: [
            "CHAR",
            1
        ],
        // 0x4B
        // 0x4C FIND
        // 0x4D DATEVALUE
        // 0x4E TIMEVALUE
        // 0x4F CELL
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        // 0x55 VLOOKUP
        // 0x56 NPV
        // 0x57 VAR
        // 0x58 STD
        // 0x59 IRR
        // 0x5A HLOOKUP
        // 0x5B DSUM
        // 0x5C DAVERAGE
        // 0x5D DCOUNTA
        // 0x5E DMIN
        // 0x5F DMAX
        // 0x60 DVARP
        // 0x61 DSTDEVP
        // 0x62 INDEX
        // 0x63 COLS
        // 0x64 ROWS
        // 0x65 REPEAT
        0x66: [
            "UPPER",
            1
        ],
        0x67: [
            "LOWER",
            1
        ],
        // 0x68 LEFT
        // 0x69 RIGHT
        // 0x6A REPLACE
        0x6B: [
            "PROPER",
            1
        ],
        // 0x6C CELL
        0x6D: [
            "TRIM",
            1
        ],
        // 0x6E CLEAN
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $9d5117faee5c78f9$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, 'f'));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = 's';
        o[1].v = blob.read_shift(length - 4, 'cstr');
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $9d5117faee5c78f9$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $9d5117faee5c78f9$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, 'f');
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 12);
        blob.l += length - 12; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, 'cstr');
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $9d5117faee5c78f9$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        /*::[*/ 0x0000: {
            n: "BOF",
            f: $9d5117faee5c78f9$var$parseuint16
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "CALCMODE"
        },
        /*::[*/ 0x0003: {
            n: "CALCORDER"
        },
        /*::[*/ 0x0004: {
            n: "SPLIT"
        },
        /*::[*/ 0x0005: {
            n: "SYNC"
        },
        /*::[*/ 0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        /*::[*/ 0x0007: {
            n: "WINDOW1"
        },
        /*::[*/ 0x0008: {
            n: "COLW1"
        },
        /*::[*/ 0x0009: {
            n: "WINTWO"
        },
        /*::[*/ 0x000A: {
            n: "COLW2"
        },
        /*::[*/ 0x000B: {
            n: "NAME"
        },
        /*::[*/ 0x000C: {
            n: "BLANK"
        },
        /*::[*/ 0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        /*::[*/ 0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        /*::[*/ 0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        /*::[*/ 0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        /*::[*/ 0x0018: {
            n: "TABLE"
        },
        /*::[*/ 0x0019: {
            n: "ORANGE"
        },
        /*::[*/ 0x001A: {
            n: "PRANGE"
        },
        /*::[*/ 0x001B: {
            n: "SRANGE"
        },
        /*::[*/ 0x001C: {
            n: "FRANGE"
        },
        /*::[*/ 0x001D: {
            n: "KRANGE1"
        },
        /*::[*/ 0x0020: {
            n: "HRANGE"
        },
        /*::[*/ 0x0023: {
            n: "KRANGE2"
        },
        /*::[*/ 0x0024: {
            n: "PROTEC"
        },
        /*::[*/ 0x0025: {
            n: "FOOTER"
        },
        /*::[*/ 0x0026: {
            n: "HEADER"
        },
        /*::[*/ 0x0027: {
            n: "SETUP"
        },
        /*::[*/ 0x0028: {
            n: "MARGINS"
        },
        /*::[*/ 0x0029: {
            n: "LABELFMT"
        },
        /*::[*/ 0x002A: {
            n: "TITLES"
        },
        /*::[*/ 0x002B: {
            n: "SHEETJS"
        },
        /*::[*/ 0x002D: {
            n: "GRAPH"
        },
        /*::[*/ 0x002E: {
            n: "NGRAPH"
        },
        /*::[*/ 0x002F: {
            n: "CALCCOUNT"
        },
        /*::[*/ 0x0030: {
            n: "UNFORMATTED"
        },
        /*::[*/ 0x0031: {
            n: "CURSORW12"
        },
        /*::[*/ 0x0032: {
            n: "WINDOW"
        },
        /*::[*/ 0x0033: {
            n: "STRING",
            f: parse_STRING
        },
        /*::[*/ 0x0037: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0038: {
            n: "LOCKED"
        },
        /*::[*/ 0x003C: {
            n: "QUERY"
        },
        /*::[*/ 0x003D: {
            n: "QUERYNAME"
        },
        /*::[*/ 0x003E: {
            n: "PRINT"
        },
        /*::[*/ 0x003F: {
            n: "PRINTNAME"
        },
        /*::[*/ 0x0040: {
            n: "GRAPH2"
        },
        /*::[*/ 0x0041: {
            n: "GRAPHNAME"
        },
        /*::[*/ 0x0042: {
            n: "ZOOM"
        },
        /*::[*/ 0x0043: {
            n: "SYMSPLIT"
        },
        /*::[*/ 0x0044: {
            n: "NSROWS"
        },
        /*::[*/ 0x0045: {
            n: "NSCOLS"
        },
        /*::[*/ 0x0046: {
            n: "RULER"
        },
        /*::[*/ 0x0047: {
            n: "NNAME"
        },
        /*::[*/ 0x0048: {
            n: "ACOMM"
        },
        /*::[*/ 0x0049: {
            n: "AMACRO"
        },
        /*::[*/ 0x004A: {
            n: "PARSE"
        },
        /*::[*/ 0x0066: {
            n: "PRANGES??"
        },
        /*::[*/ 0x0067: {
            n: "RRANGES??"
        },
        /*::[*/ 0x0068: {
            n: "FNAME??"
        },
        /*::[*/ 0x0069: {
            n: "MRANGES??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        /*::[*/ 0x00FF: {
            n: "BOF",
            f: $9d5117faee5c78f9$var$parseuint16
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        /*::[*/ 0x0000: {
            n: "BOF"
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0003: {
            n: "CALCSET"
        },
        /*::[*/ 0x0004: {
            n: "WINDOWSET"
        },
        /*::[*/ 0x0005: {
            n: "SHEETCELLPTR"
        },
        /*::[*/ 0x0006: {
            n: "SHEETLAYOUT"
        },
        /*::[*/ 0x0007: {
            n: "COLUMNWIDTH"
        },
        /*::[*/ 0x0008: {
            n: "HIDDENCOLUMN"
        },
        /*::[*/ 0x0009: {
            n: "USERRANGE"
        },
        /*::[*/ 0x000A: {
            n: "SYSTEMRANGE"
        },
        /*::[*/ 0x000B: {
            n: "ZEROFORCE"
        },
        /*::[*/ 0x000C: {
            n: "SORTKEYDIR"
        },
        /*::[*/ 0x000D: {
            n: "FILESEAL"
        },
        /*::[*/ 0x000E: {
            n: "DATAFILLNUMS"
        },
        /*::[*/ 0x000F: {
            n: "PRINTMAIN"
        },
        /*::[*/ 0x0010: {
            n: "PRINTSTRING"
        },
        /*::[*/ 0x0011: {
            n: "GRAPHMAIN"
        },
        /*::[*/ 0x0012: {
            n: "GRAPHSTRING"
        },
        /*::[*/ 0x0013: {
            n: "??"
        },
        /*::[*/ 0x0014: {
            n: "ERRCELL"
        },
        /*::[*/ 0x0015: {
            n: "NACELL"
        },
        /*::[*/ 0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        /*::[*/ 0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        /*::[*/ 0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        /*::[*/ 0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        /*::[*/ 0x001A: {
            n: "FORMULA1A"
        },
        /*::[*/ 0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        /*::[*/ 0x001C: {
            n: "DTLABELMISC"
        },
        /*::[*/ 0x001D: {
            n: "DTLABELCELL"
        },
        /*::[*/ 0x001E: {
            n: "GRAPHWINDOW"
        },
        /*::[*/ 0x001F: {
            n: "CPA"
        },
        /*::[*/ 0x0020: {
            n: "LPLAUTO"
        },
        /*::[*/ 0x0021: {
            n: "QUERY"
        },
        /*::[*/ 0x0022: {
            n: "HIDDENSHEET"
        },
        /*::[*/ 0x0023: {
            n: "??"
        },
        /*::[*/ 0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        /*::[*/ 0x0026: {
            n: "??"
        },
        /*::[*/ 0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        /*::[*/ 0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        /*::[*/ 0x008E: {
            n: "??"
        },
        /*::[*/ 0x0093: {
            n: "??"
        },
        /*::[*/ 0x0096: {
            n: "??"
        },
        /*::[*/ 0x0097: {
            n: "??"
        },
        /*::[*/ 0x0098: {
            n: "??"
        },
        /*::[*/ 0x0099: {
            n: "??"
        },
        /*::[*/ 0x009A: {
            n: "??"
        },
        /*::[*/ 0x009B: {
            n: "??"
        },
        /*::[*/ 0x009C: {
            n: "??"
        },
        /*::[*/ 0x00A3: {
            n: "??"
        },
        /*::[*/ 0x00AE: {
            n: "??"
        },
        /*::[*/ 0x00AF: {
            n: "??"
        },
        /*::[*/ 0x00B0: {
            n: "??"
        },
        /*::[*/ 0x00B1: {
            n: "??"
        },
        /*::[*/ 0x00B8: {
            n: "??"
        },
        /*::[*/ 0x00B9: {
            n: "??"
        },
        /*::[*/ 0x00BA: {
            n: "??"
        },
        /*::[*/ 0x00BB: {
            n: "??"
        },
        /*::[*/ 0x00BC: {
            n: "??"
        },
        /*::[*/ 0x00C3: {
            n: "??"
        },
        /*::[*/ 0x00C9: {
            n: "??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00CD: {
            n: "??"
        },
        /*::[*/ 0x00CE: {
            n: "??"
        },
        /*::[*/ 0x00CF: {
            n: "??"
        },
        /*::[*/ 0x00D0: {
            n: "??"
        },
        /*::[*/ 0x0100: {
            n: "??"
        },
        /*::[*/ 0x0103: {
            n: "??"
        },
        /*::[*/ 0x0104: {
            n: "??"
        },
        /*::[*/ 0x0105: {
            n: "??"
        },
        /*::[*/ 0x0106: {
            n: "??"
        },
        /*::[*/ 0x0107: {
            n: "??"
        },
        /*::[*/ 0x0109: {
            n: "??"
        },
        /*::[*/ 0x010A: {
            n: "??"
        },
        /*::[*/ 0x010B: {
            n: "??"
        },
        /*::[*/ 0x010C: {
            n: "??"
        },
        /*::[*/ 0x010E: {
            n: "??"
        },
        /*::[*/ 0x010F: {
            n: "??"
        },
        /*::[*/ 0x0180: {
            n: "??"
        },
        /*::[*/ 0x0185: {
            n: "??"
        },
        /*::[*/ 0x0186: {
            n: "??"
        },
        /*::[*/ 0x0189: {
            n: "??"
        },
        /*::[*/ 0x018C: {
            n: "??"
        },
        /*::[*/ 0x0200: {
            n: "??"
        },
        /*::[*/ 0x0202: {
            n: "??"
        },
        /*::[*/ 0x0201: {
            n: "??"
        },
        /*::[*/ 0x0204: {
            n: "??"
        },
        /*::[*/ 0x0205: {
            n: "??"
        },
        /*::[*/ 0x0280: {
            n: "??"
        },
        /*::[*/ 0x0281: {
            n: "??"
        },
        /*::[*/ 0x0282: {
            n: "??"
        },
        /*::[*/ 0x0283: {
            n: "??"
        },
        /*::[*/ 0x0284: {
            n: "??"
        },
        /*::[*/ 0x0285: {
            n: "??"
        },
        /*::[*/ 0x0286: {
            n: "??"
        },
        /*::[*/ 0x0287: {
            n: "??"
        },
        /*::[*/ 0x0288: {
            n: "??"
        },
        /*::[*/ 0x0292: {
            n: "??"
        },
        /*::[*/ 0x0293: {
            n: "??"
        },
        /*::[*/ 0x0294: {
            n: "??"
        },
        /*::[*/ 0x0295: {
            n: "??"
        },
        /*::[*/ 0x0296: {
            n: "??"
        },
        /*::[*/ 0x0299: {
            n: "??"
        },
        /*::[*/ 0x029A: {
            n: "??"
        },
        /*::[*/ 0x0300: {
            n: "??"
        },
        /*::[*/ 0x0304: {
            n: "??"
        },
        /*::[*/ 0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        /*::[*/ 0x0640: {
            n: "??"
        },
        /*::[*/ 0x0642: {
            n: "??"
        },
        /*::[*/ 0x0701: {
            n: "??"
        },
        /*::[*/ 0x0702: {
            n: "??"
        },
        /*::[*/ 0x0703: {
            n: "??"
        },
        /*::[*/ 0x0704: {
            n: "??"
        },
        /*::[*/ 0x0780: {
            n: "??"
        },
        /*::[*/ 0x0800: {
            n: "??"
        },
        /*::[*/ 0x0801: {
            n: "??"
        },
        /*::[*/ 0x0804: {
            n: "??"
        },
        /*::[*/ 0x0A80: {
            n: "??"
        },
        /*::[*/ 0x2AF6: {
            n: "??"
        },
        /*::[*/ 0x3231: {
            n: "??"
        },
        /*::[*/ 0x6E49: {
            n: "??"
        },
        /*::[*/ 0x6F44: {
            n: "??"
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    /* QPW uses a different set of record types */ function qpw_to_workbook_buf(d, opts) /*:Workbook*/ {
        $9d5117faee5c78f9$var$prep_blob(d, 0);
        var o = opts || {};
        if ($9d5117faee5c78f9$var$DENSE != null && o.dense == null) o.dense = $9d5117faee5c78f9$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) s["!data"] = [];
        var SST = [], sname = "", formulae = [];
        var range = {
            s: {
                r: -1,
                c: -1
            },
            e: {
                r: -1,
                c: -1
            }
        };
        var cnt = 0, type = 0, C = 0, R = 0;
        var wb = {
            SheetNames: [],
            Sheets: {}
        };
        outer: while(d.l < d.length){
            var RT = d.read_shift(2), length = d.read_shift(2);
            var p = d.slice(d.l, d.l + length);
            $9d5117faee5c78f9$var$prep_blob(p, 0);
            switch(RT){
                case 0x01:
                    /* BOF */ if (p.read_shift(4) != 0x39575051) throw "Bad QPW9 BOF!";
                    break;
                case 0x02:
                    break outer;
                /* TODO: The behavior here should be consistent with Numbers: QP Notebook ~ .TN.SheetArchive, QP Sheet ~ .TST.TableModelArchive */ case 0x0401:
                    break;
                case 0x0402:
                    break;
                case 0x0407:
                    p.l += 12;
                    while(p.l < p.length){
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        SST.push(p.read_shift(cnt, 'cstr'));
                    }
                    break;
                case 0x0408:
                    break;
                case 0x0601:
                    var sidx = p.read_shift(2);
                    s = {} /*:any*/ ;
                    if (o.dense) s["!data"] = [];
                    range.s.c = p.read_shift(2);
                    range.e.c = p.read_shift(2);
                    range.s.r = p.read_shift(4);
                    range.e.r = p.read_shift(4);
                    p.l += 4;
                    if (p.l + 2 < p.length) {
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        sname = cnt == 0 ? "" : p.read_shift(cnt, 'cstr');
                    }
                    if (!sname) sname = $9d5117faee5c78f9$var$encode_col(sidx);
                    break;
                case 0x0602:
                    /* NOTE: QP valid range A1:IV1000000 */ if (range.s.c > 0xFF || range.s.r > 999999) break;
                    if (range.e.c < range.s.c) range.e.c = range.s.c;
                    if (range.e.r < range.s.r) range.e.r = range.s.r;
                    s["!ref"] = $9d5117faee5c78f9$var$encode_range(range);
                    $9d5117faee5c78f9$var$book_append_sheet(wb, s, sname); // TODO: a barrel roll
                    break;
                case 0x0A01:
                    C = p.read_shift(2);
                    if (range.e.c < C) range.e.c = C;
                    if (range.s.c > C) range.s.c = C;
                    R = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    R = p.read_shift(4);
                    if (range.e.r < R) range.e.r = R;
                    break;
                case 0x0C01:
                    R = p.read_shift(4), cnt = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    if (range.e.r < R + cnt - 1) range.e.r = R + cnt - 1;
                    var CC = $9d5117faee5c78f9$var$encode_col(C);
                    while(p.l < p.length){
                        var cell = {
                            t: "z"
                        };
                        var flags = p.read_shift(1);
                        if (flags & 0x80) p.l += 2;
                        var mul = flags & 0x40 ? p.read_shift(2) - 1 : 0;
                        switch(flags & 0x1F){
                            case 1:
                                break;
                            case 2:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2)
                                };
                                break;
                            case 3:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2, 'i')
                                };
                                break;
                            case 5:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                break;
                            case 7:
                                cell = {
                                    t: "s",
                                    v: SST[type = p.read_shift(4) - 1]
                                };
                                break;
                            case 8:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                p.l += 2; /* cell.f = formulae[p.read_shift(4)]; */ 
                                p.l += 4;
                                break;
                            default:
                                throw "Unrecognized QPW cell type " + (flags & 0x1F);
                        }
                        var delta = 0;
                        if (flags & 0x20) switch(flags & 0x1F){
                            case 2:
                                delta = p.read_shift(2);
                                break;
                            case 3:
                                delta = p.read_shift(2, 'i');
                                break;
                            case 7:
                                delta = p.read_shift(2);
                                break;
                            default:
                                throw "Unsupported delta for QPW cell type " + (flags & 0x1F);
                        }
                        if (!(!o.sheetStubs && cell.t == "z")) {
                            if (s["!data"] != null) {
                                if (!s["!data"][R]) s["!data"][R] = [];
                                s["!data"][R][C] = cell;
                            } else s[CC + $9d5117faee5c78f9$var$encode_row(R)] = cell;
                        }
                        ++R;
                        --cnt;
                        while(mul-- > 0 && cnt >= 0){
                            if (flags & 0x20) switch(flags & 0x1F){
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    break;
                                case 3:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    if (cell.v > 0x7FFF) cell.v -= 0x10000;
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = type + delta >>> 0]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply delta for QPW cell type " + (flags & 0x1F);
                            }
                            else switch(flags & 0x1F){
                                case 1:
                                    cell = {
                                        t: "z"
                                    };
                                    break;
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: p.read_shift(2)
                                    };
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = p.read_shift(4) - 1]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply repeat for QPW cell type " + (flags & 0x1F);
                            }
                            if (!(!o.sheetStubs && cell.t == "z")) {
                                if (s["!data"] != null) {
                                    if (!s["!data"][R]) s["!data"][R] = [];
                                    s["!data"][R][C] = cell;
                                } else s[CC + $9d5117faee5c78f9$var$encode_row(R)] = cell;
                            }
                            ++R;
                            --cnt;
                        }
                    }
                    break;
                default:
                    break;
            }
            d.l += length;
        }
        return wb;
    }
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $9d5117faee5c78f9$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($9d5117faee5c78f9$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $9d5117faee5c78f9$var$parsexmltag(m[i]);
        switch(y[0].replace(/\w*:/g, "")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case '<condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case '<extend':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case '<shadow':
                if (!y.val) break;
            /* falls through */ case '<shadow>':
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case '<charset':
                if (y.val == '1') break;
                font.cp = $9d5117faee5c78f9$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case '<outline':
                if (!y.val) break;
            /* falls through */ case '<outline>':
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
                break;
            /* 18.4.5 rFont CT_FontName */ case '<rFont':
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                if (!y.val) break;
            /* falls through */ case '<strike>':
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                if (!y.val) break;
                switch(y.val){
                    case 'double':
                        font.uval = "double";
                        break;
                    case 'singleAccounting':
                        font.uval = "single-accounting";
                        break;
                    case 'doubleAccounting':
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case '<u>':
            case '<u/>':
                font.u = 1;
                break;
            case '</u>':
                break;
            /* 18.8.2 b */ case '<b':
                if (y.val == '0') break;
            /* falls through */ case '<b>':
            case '<b/>':
                font.b = 1;
                break;
            case '</b>':
                break;
            /* 18.8.26 i */ case '<i':
                if (y.val == '0') break;
            /* falls through */ case '<i>':
            case '<i/>':
                font.i = 1;
                break;
            case '</i>':
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case '<color':
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case '<color>':
            case '<color/>':
            case '</color>':
                break;
            /* 18.8.18 family ST_FontFamily */ case '<family':
                font.family = y.val;
                break;
            case '<family>':
            case '<family/>':
            case '</family>':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case '<vertAlign':
                font.valign = y.val;
                break;
            case '<vertAlign>':
            case '<vertAlign/>':
            case '</vertAlign>':
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case '<scheme':
                break;
            case '<scheme>':
            case '<scheme/>':
            case '</scheme>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
        }
    }
    return font;
}
var $9d5117faee5c78f9$var$parse_rs = /*#__PURE__*/ function() {
    var tregex = $9d5117faee5c78f9$var$matchtag("t"), rpregex = $9d5117faee5c78f9$var$matchtag("rPr");
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = r.match(tregex) /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: 's',
            v: $9d5117faee5c78f9$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = r.match(rpregex);
        if (rpr) o.s = $9d5117faee5c78f9$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $9d5117faee5c78f9$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, '<br/>') + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $9d5117faee5c78f9$var$sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, $9d5117faee5c78f9$var$sirregex = /<(?:\w+:)?r\b[^>]*>/;
var $9d5117faee5c78f9$var$sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function $9d5117faee5c78f9$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $9d5117faee5c78f9$var$unescapexml($9d5117faee5c78f9$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""), true);
        z.r = $9d5117faee5c78f9$var$utf8read(x);
        if (html) z.h = $9d5117faee5c78f9$var$escapehtml(z.t);
    } else if (/*y = */ x.match($9d5117faee5c78f9$var$sirregex)) {
        z.r = $9d5117faee5c78f9$var$utf8read(x);
        z.t = $9d5117faee5c78f9$var$unescapexml($9d5117faee5c78f9$var$utf8read((x.replace($9d5117faee5c78f9$var$sirphregex, '').match($9d5117faee5c78f9$var$sitregex) || []).join("").replace($9d5117faee5c78f9$var$tagregex, "")), true);
        if (html) z.h = $9d5117faee5c78f9$var$rs_to_html($9d5117faee5c78f9$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $9d5117faee5c78f9$var$sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var $9d5117faee5c78f9$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $9d5117faee5c78f9$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $9d5117faee5c78f9$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = data.match($9d5117faee5c78f9$var$sstr0);
    if (sst) {
        ss = sst[2].replace($9d5117faee5c78f9$var$sstr1, "").split($9d5117faee5c78f9$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $9d5117faee5c78f9$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $9d5117faee5c78f9$var$parsexmltag(sst[1]);
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $9d5117faee5c78f9$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $9d5117faee5c78f9$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER
    ];
    o[o.length] = $9d5117faee5c78f9$var$writextag('sst', null, {
        xmlns: $9d5117faee5c78f9$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (typeof s.t !== "string") s.t = String(s.t);
            if (s.t.match($9d5117faee5c78f9$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $9d5117faee5c78f9$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = '</sst>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $9d5117faee5c78f9$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $9d5117faee5c78f9$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $9d5117faee5c78f9$var$recordhopper(data, function hopper_sst(val, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val[0];
                s.Unique = val[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $9d5117faee5c78f9$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $9d5117faee5c78f9$var$write_BrtSSTItem = $9d5117faee5c78f9$var$write_RichStr;
function $9d5117faee5c78f9$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $9d5117faee5c78f9$var$buf_array();
    $9d5117faee5c78f9$var$write_record(ba, 0x009F /* BrtBeginSst */ , $9d5117faee5c78f9$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$9d5117faee5c78f9$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $9d5117faee5c78f9$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $9d5117faee5c78f9$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $9d5117faee5c78f9$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $9d5117faee5c78f9$var$$cptable !== 'undefined') return $9d5117faee5c78f9$var$$cptable.utils.encode($9d5117faee5c78f9$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $9d5117faee5c78f9$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $9d5117faee5c78f9$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, 'lpp4');
    o.R = $9d5117faee5c78f9$var$parse_CRYPTOVersion(blob, 4);
    o.U = $9d5117faee5c78f9$var$parse_CRYPTOVersion(blob, 4);
    o.W = $9d5117faee5c78f9$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $9d5117faee5c78f9$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, 'lpp4')
    });
    o.name = blob.read_shift(0, 'lpp4');
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $9d5117faee5c78f9$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($9d5117faee5c78f9$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $9d5117faee5c78f9$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, 'lpp4'));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $9d5117faee5c78f9$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, 'lpp4');
    o.name = blob.read_shift(0, 'lpp4');
    o.R = $9d5117faee5c78f9$var$parse_CRYPTOVersion(blob, 4);
    o.U = $9d5117faee5c78f9$var$parse_CRYPTOVersion(blob, 4);
    o.W = $9d5117faee5c78f9$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $9d5117faee5c78f9$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $9d5117faee5c78f9$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, '8lpp4');
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $9d5117faee5c78f9$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw 'Unrecognized encryption algorithm: ' + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, 'utf16le');
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $9d5117faee5c78f9$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $9d5117faee5c78f9$var$parse_EncryptionInfo(blob) {
    var vers = $9d5117faee5c78f9$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $9d5117faee5c78f9$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $9d5117faee5c78f9$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $9d5117faee5c78f9$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $9d5117faee5c78f9$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $9d5117faee5c78f9$var$parse_EncryptionHeader(blob, sz);
    var verifier = $9d5117faee5c78f9$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $9d5117faee5c78f9$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $9d5117faee5c78f9$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, 'utf8');
    var o = {};
    xml.replace($9d5117faee5c78f9$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $9d5117faee5c78f9$var$parsexmltag(x);
        switch($9d5117faee5c78f9$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<encryption':
            case '</encryption>':
                break;
            case '<keyData':
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case '<dataIntegrity':
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case '<keyEncryptors>':
            case '<keyEncryptors':
                o.encs = [];
                break;
            case '</keyEncryptors>':
                break;
            case '<keyEncryptor':
                o.uri = y.uri;
                break;
            case '</keyEncryptor>':
                break;
            case '<encryptedKey':
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $9d5117faee5c78f9$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $9d5117faee5c78f9$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $9d5117faee5c78f9$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $9d5117faee5c78f9$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $9d5117faee5c78f9$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $9d5117faee5c78f9$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $9d5117faee5c78f9$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $9d5117faee5c78f9$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $9d5117faee5c78f9$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $9d5117faee5c78f9$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $9d5117faee5c78f9$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $9d5117faee5c78f9$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $9d5117faee5c78f9$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $9d5117faee5c78f9$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $9d5117faee5c78f9$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $9d5117faee5c78f9$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $9d5117faee5c78f9$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $9d5117faee5c78f9$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $9d5117faee5c78f9$var$parseuint16(blob),
        verificationBytes: $9d5117faee5c78f9$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $9d5117faee5c78f9$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $9d5117faee5c78f9$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $9d5117faee5c78f9$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $9d5117faee5c78f9$var$parse_RC4Header(blob, length);
    else o.Data = $9d5117faee5c78f9$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $9d5117faee5c78f9$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $9d5117faee5c78f9$var$parse_FilePassHeader(blob, length - 2, o);
    else $9d5117faee5c78f9$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
function $9d5117faee5c78f9$var$rtf_to_sheet(d, opts) {
    switch(opts.type){
        case "base64":
            return $9d5117faee5c78f9$var$rtf_to_sheet_str($9d5117faee5c78f9$var$Base64_decode(d), opts);
        case "binary":
            return $9d5117faee5c78f9$var$rtf_to_sheet_str(d, opts);
        case "buffer":
            return $9d5117faee5c78f9$var$rtf_to_sheet_str($9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(d) ? d.toString("binary") : $9d5117faee5c78f9$var$a2s(d), opts);
        case "array":
            return $9d5117faee5c78f9$var$rtf_to_sheet_str($9d5117faee5c78f9$var$cc2str(d), opts);
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $9d5117faee5c78f9$var$rtf_to_sheet_str(str, opts) {
    var o = opts || {};
    var ws = {};
    var dense = o.dense;
    if (dense) ws["!data"] = [];
    var rows = str.match(/\\trowd[\s\S]*?\\row\b/g);
    if (!rows) throw new Error("RTF missing table");
    var range = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: rows.length - 1
        }
    };
    var row = [];
    rows.forEach(function(rowtf, R) {
        if (dense) row = ws["!data"][R] = [];
        var rtfre = /\\[\w\-]+\b/g;
        var last_index = 0;
        var res;
        var C = -1;
        var payload = [];
        while((res = rtfre.exec(rowtf)) != null){
            var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
            if (data.charCodeAt(0) == 32) data = data.slice(1);
            if (data.length) payload.push(data);
            switch(res[0]){
                case "\\cell":
                    ++C;
                    if (payload.length) {
                        var cell = {
                            v: payload.join(""),
                            t: "s"
                        };
                        if (cell.v == "TRUE" || cell.v == "FALSE") {
                            cell.v = cell.v == "TRUE";
                            cell.t = "b";
                        } else if (!isNaN($9d5117faee5c78f9$var$fuzzynum(cell.v))) {
                            cell.t = "n";
                            if (o.cellText !== false) cell.w = cell.v;
                            cell.v = $9d5117faee5c78f9$var$fuzzynum(cell.v);
                        }
                        if (dense) row[C] = cell;
                        else ws[$9d5117faee5c78f9$var$encode_cell({
                            r: R,
                            c: C
                        })] = cell;
                    }
                    payload = [];
                    break;
                case "\\par":
                    payload.push("\n");
                    break;
            }
            last_index = rtfre.lastIndex;
        }
        if (C > range.e.c) range.e.c = C;
    });
    ws["!ref"] = $9d5117faee5c78f9$var$encode_range(range);
    return ws;
}
function $9d5117faee5c78f9$var$rtf_to_workbook(d, opts) {
    var wb = $9d5117faee5c78f9$var$sheet_to_workbook($9d5117faee5c78f9$var$rtf_to_sheet(d, opts), opts);
    wb.bookType = "rtf";
    return wb;
}
function $9d5117faee5c78f9$var$sheet_to_rtf(ws, opts) {
    var o = [
        "{\\rtf1\\ansi"
    ];
    if (!ws["!ref"]) return o[0] + "}";
    var r = $9d5117faee5c78f9$var$safe_decode_range(ws["!ref"]), cell;
    var dense = ws["!data"] != null, row = [];
    for(var R = r.s.r; R <= r.e.r; ++R){
        o.push("\\trowd\\trautofit1");
        for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
        o.push("\\pard\\intbl");
        if (dense) row = ws["!data"][R] || [];
        for(C = r.s.c; C <= r.e.c; ++C){
            var coord = $9d5117faee5c78f9$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? row[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) {
                o.push(" \\cell");
                continue;
            }
            o.push(" " + (cell.w || ($9d5117faee5c78f9$var$format_cell(cell), cell.w) || "").replace(/[\r\n]/g, "\\par "));
            o.push("\\cell");
        }
        o.push("\\pard\\intbl\\row");
    }
    return o.join("") + "}";
}
function $9d5117faee5c78f9$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $9d5117faee5c78f9$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $9d5117faee5c78f9$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $9d5117faee5c78f9$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $9d5117faee5c78f9$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $9d5117faee5c78f9$var$rgb2HSL($9d5117faee5c78f9$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $9d5117faee5c78f9$var$rgb2Hex($9d5117faee5c78f9$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $9d5117faee5c78f9$var$DEF_MDW = 6, $9d5117faee5c78f9$var$MAX_MDW = 15, $9d5117faee5c78f9$var$MIN_MDW = 1, $9d5117faee5c78f9$var$MDW = $9d5117faee5c78f9$var$DEF_MDW;
function $9d5117faee5c78f9$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $9d5117faee5c78f9$var$MDW) / 256) * $9d5117faee5c78f9$var$MDW);
}
function $9d5117faee5c78f9$var$px2char(px) {
    return Math.floor((px - 5) / $9d5117faee5c78f9$var$MDW * 100 + 0.5) / 100;
}
function $9d5117faee5c78f9$var$char2width(chr) {
    return Math.round((chr * $9d5117faee5c78f9$var$MDW + 5) / $9d5117faee5c78f9$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $9d5117faee5c78f9$var$cycle_width(collw) {
    return $9d5117faee5c78f9$var$char2width($9d5117faee5c78f9$var$px2char($9d5117faee5c78f9$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $9d5117faee5c78f9$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $9d5117faee5c78f9$var$cycle_width(collw)), _MDW = $9d5117faee5c78f9$var$MDW;
    if (delta > 0.005) {
        for($9d5117faee5c78f9$var$MDW = $9d5117faee5c78f9$var$MIN_MDW; $9d5117faee5c78f9$var$MDW < $9d5117faee5c78f9$var$MAX_MDW; ++$9d5117faee5c78f9$var$MDW)if (Math.abs(collw - $9d5117faee5c78f9$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $9d5117faee5c78f9$var$cycle_width(collw));
            _MDW = $9d5117faee5c78f9$var$MDW;
        }
    }
    $9d5117faee5c78f9$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $9d5117faee5c78f9$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $9d5117faee5c78f9$var$width2px(coll.width);
        coll.wch = $9d5117faee5c78f9$var$px2char(coll.wpx);
        coll.MDW = $9d5117faee5c78f9$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $9d5117faee5c78f9$var$px2char(coll.wpx);
        coll.width = $9d5117faee5c78f9$var$char2width(coll.wch);
        coll.MDW = $9d5117faee5c78f9$var$MDW;
    } else if (typeof coll.wch == 'number') {
        coll.width = $9d5117faee5c78f9$var$char2width(coll.wch);
        coll.wpx = $9d5117faee5c78f9$var$width2px(coll.width);
        coll.MDW = $9d5117faee5c78f9$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $9d5117faee5c78f9$var$DEF_PPI = 96, $9d5117faee5c78f9$var$PPI = $9d5117faee5c78f9$var$DEF_PPI;
function $9d5117faee5c78f9$var$px2pt(px) {
    return px * 96 / $9d5117faee5c78f9$var$PPI;
}
function $9d5117faee5c78f9$var$pt2px(pt) {
    return pt * $9d5117faee5c78f9$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $9d5117faee5c78f9$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $9d5117faee5c78f9$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t[0].match($9d5117faee5c78f9$var$tagregex) || []).forEach(function(x) {
        var y = $9d5117faee5c78f9$var$parsexmltag(x);
        switch($9d5117faee5c78f9$var$strip_ns(y[0])){
            case '<borders':
            case '<borders>':
            case '</borders>':
                break;
            /* 18.8.4 border CT_Border */ case '<border':
            case '<border>':
            case '<border/>':
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $9d5117faee5c78f9$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $9d5117faee5c78f9$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case '</border>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<left/>':
                break;
            case '<left':
            case '<left>':
                break;
            case '</left>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<right/>':
                break;
            case '<right':
            case '<right>':
                break;
            case '</right>':
                break;
            /* 18.8.43 top CT_BorderPr */ case '<top/>':
                break;
            case '<top':
            case '<top>':
                break;
            case '</top>':
                break;
            /* 18.8.6 bottom CT_BorderPr */ case '<bottom/>':
                break;
            case '<bottom':
            case '<bottom>':
                break;
            case '</bottom>':
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case '<diagonal':
            case '<diagonal>':
            case '<diagonal/>':
                break;
            case '</diagonal>':
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case '<horizontal':
            case '<horizontal>':
            case '<horizontal/>':
                break;
            case '</horizontal>':
                break;
            /* 18.8.44 vertical CT_BorderPr */ case '<vertical':
            case '<vertical>':
            case '<vertical/>':
                break;
            case '</vertical>':
                break;
            /* 18.8.37 start CT_BorderPr */ case '<start':
            case '<start>':
            case '<start/>':
                break;
            case '</start>':
                break;
            /* 18.8.16 end CT_BorderPr */ case '<end':
            case '<end>':
            case '<end/>':
                break;
            case '</end>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color>':
                break;
            case '<color/>':
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $9d5117faee5c78f9$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t[0].match($9d5117faee5c78f9$var$tagregex) || []).forEach(function(x) {
        var y = $9d5117faee5c78f9$var$parsexmltag(x);
        switch($9d5117faee5c78f9$var$strip_ns(y[0])){
            case '<fills':
            case '<fills>':
            case '</fills>':
                break;
            /* 18.8.20 fill CT_Fill */ case '<fill>':
            case '<fill':
            case '<fill/>':
                fill = {};
                styles.Fills.push(fill);
                break;
            case '</fill>':
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case '<gradientFill>':
                break;
            case '<gradientFill':
            case '</gradientFill>':
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case '<patternFill':
            case '<patternFill>':
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case '<patternFill/>':
            case '</patternFill>':
                break;
            /* 18.8.3 bgColor CT_Color */ case '<bgColor':
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case '<bgColor/>':
            case '</bgColor>':
                break;
            /* 18.8.19 fgColor CT_Color */ case '<fgColor':
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case '<fgColor/>':
            case '</fgColor>':
                break;
            /* 18.8.38 stop CT_GradientStop */ case '<stop':
            case '<stop/>':
                break;
            case '</stop>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color/>':
                break;
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $9d5117faee5c78f9$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t[0].match($9d5117faee5c78f9$var$tagregex) || []).forEach(function(x) {
        var y = $9d5117faee5c78f9$var$parsexmltag(x);
        switch($9d5117faee5c78f9$var$strip_ns(y[0])){
            case '<fonts':
            case '<fonts>':
            case '</fonts>':
                break;
            /* 18.8.22 font CT_Font */ case '<font':
            case '<font>':
                break;
            case '</font>':
            case '<font/>':
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case '<name':
                if (y.val) font.name = $9d5117faee5c78f9$var$utf8read(y.val);
                break;
            case '<name/>':
            case '</name>':
                break;
            /* 18.8.2  b CT_BooleanProperty */ case '<b':
                font.bold = y.val ? $9d5117faee5c78f9$var$parsexmlbool(y.val) : 1;
                break;
            case '<b/>':
                font.bold = 1;
                break;
            /* 18.8.26 i CT_BooleanProperty */ case '<i':
                font.italic = y.val ? $9d5117faee5c78f9$var$parsexmlbool(y.val) : 1;
                break;
            case '<i/>':
                font.italic = 1;
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case '<u/>':
                font.underline = 1;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                font.strike = y.val ? $9d5117faee5c78f9$var$parsexmlbool(y.val) : 1;
                break;
            case '<strike/>':
                font.strike = 1;
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case '<outline':
                font.outline = y.val ? $9d5117faee5c78f9$var$parsexmlbool(y.val) : 1;
                break;
            case '<outline/>':
                font.outline = 1;
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case '<shadow':
                font.shadow = y.val ? $9d5117faee5c78f9$var$parsexmlbool(y.val) : 1;
                break;
            case '<shadow/>':
                font.shadow = 1;
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case '<condense':
                font.condense = y.val ? $9d5117faee5c78f9$var$parsexmlbool(y.val) : 1;
                break;
            case '<condense/>':
                font.condense = 1;
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case '<extend':
                font.extend = y.val ? $9d5117faee5c78f9$var$parsexmlbool(y.val) : 1;
                break;
            case '<extend/>':
                font.extend = 1;
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                if (y.val) font.sz = +y.val;
                break;
            case '<sz/>':
            case '</sz>':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case '<vertAlign':
                if (y.val) font.vertAlign = y.val;
                break;
            case '<vertAlign/>':
            case '</vertAlign>':
                break;
            /* 18.8.18 family CT_FontFamily */ case '<family':
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case '<family/>':
            case '</family>':
                break;
            /* 18.8.35 scheme CT_FontScheme */ case '<scheme':
                if (y.val) font.scheme = y.val;
                break;
            case '<scheme/>':
            case '</scheme>':
                break;
            /* 18.4.1 charset CT_IntProperty */ case '<charset':
                if (y.val == '1') break;
                y.codepage = $9d5117faee5c78f9$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.?.? color CT_Color */ case '<color':
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $9d5117faee5c78f9$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $9d5117faee5c78f9$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $9d5117faee5c78f9$var$XLSIcv[1];
                    if (!icv) icv = $9d5117faee5c78f9$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $9d5117faee5c78f9$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case '<color/>':
            case '</color>':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $9d5117faee5c78f9$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $9d5117faee5c78f9$var$keys($9d5117faee5c78f9$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $9d5117faee5c78f9$var$table_fmt[k[i]];
    var m = t[0].match($9d5117faee5c78f9$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $9d5117faee5c78f9$var$parsexmltag(m[i]);
        switch($9d5117faee5c78f9$var$strip_ns(y[0])){
            case '<numFmts':
            case '</numFmts>':
            case '<numFmts/>':
            case '<numFmts>':
                break;
            case '<numFmt':
                var f = $9d5117faee5c78f9$var$unescapexml($9d5117faee5c78f9$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $9d5117faee5c78f9$var$SSF__load(f, j);
                }
                break;
            case '</numFmt>':
                break;
            default:
                if (opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
        }
    }
}
function $9d5117faee5c78f9$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $9d5117faee5c78f9$var$writextag('numFmt', null, {
            numFmtId: i,
            formatCode: $9d5117faee5c78f9$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $9d5117faee5c78f9$var$writextag('numFmts', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $9d5117faee5c78f9$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $9d5117faee5c78f9$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $9d5117faee5c78f9$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t[0].match($9d5117faee5c78f9$var$tagregex) || []).forEach(function(x) {
        var y = $9d5117faee5c78f9$var$parsexmltag(x), i = 0;
        switch($9d5117faee5c78f9$var$strip_ns(y[0])){
            case '<cellXfs':
            case '<cellXfs>':
            case '<cellXfs/>':
            case '</cellXfs>':
                break;
            /* 18.8.45 xf CT_Xf */ case '<xf':
            case '<xf/>':
                xf = y;
                delete xf[0];
                for(i = 0; i < $9d5117faee5c78f9$var$cellXF_uint.length; ++i)if (xf[$9d5117faee5c78f9$var$cellXF_uint[i]]) xf[$9d5117faee5c78f9$var$cellXF_uint[i]] = parseInt(xf[$9d5117faee5c78f9$var$cellXF_uint[i]], 10);
                for(i = 0; i < $9d5117faee5c78f9$var$cellXF_bool.length; ++i)if (xf[$9d5117faee5c78f9$var$cellXF_bool[i]]) xf[$9d5117faee5c78f9$var$cellXF_bool[i]] = $9d5117faee5c78f9$var$parsexmlbool(xf[$9d5117faee5c78f9$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case '</xf>':
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case '<alignment':
            case '<alignment/>':
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $9d5117faee5c78f9$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case '</alignment>':
                break;
            /* 18.8.33 protection CT_CellProtection */ case '<protection':
                break;
            case '</protection>':
            case '<protection/>':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
                }
        }
    });
}
function $9d5117faee5c78f9$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $9d5117faee5c78f9$var$writextag('cellXfs', null);
    cellXfs.forEach(function(c) {
        o[o.length] = $9d5117faee5c78f9$var$writextag('xf', null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $9d5117faee5c78f9$var$writextag('cellXfs', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $9d5117faee5c78f9$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
    var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
    var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
    var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
    var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = data.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = data.match(numFmtRegex)) $9d5117faee5c78f9$var$parse_numFmts(t, styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = data.match(fontsRegex)) $9d5117faee5c78f9$var$parse_fonts(t, styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = data.match(fillsRegex)) $9d5117faee5c78f9$var$parse_fills(t, styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = data.match(bordersRegex)) $9d5117faee5c78f9$var$parse_borders(t, styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = data.match(cellXfRegex)) $9d5117faee5c78f9$var$parse_cellXfs(t, styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $9d5117faee5c78f9$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER,
        $9d5117faee5c78f9$var$writextag('styleSheet', null, {
            'xmlns': $9d5117faee5c78f9$var$XMLNS_main[0],
            'xmlns:vt': $9d5117faee5c78f9$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $9d5117faee5c78f9$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $9d5117faee5c78f9$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = '</styleSheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $9d5117faee5c78f9$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $9d5117faee5c78f9$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $9d5117faee5c78f9$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $9d5117faee5c78f9$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $9d5117faee5c78f9$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $9d5117faee5c78f9$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $9d5117faee5c78f9$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $9d5117faee5c78f9$var$parse_XLWideString(data, length - 21);
    return out;
}
function $9d5117faee5c78f9$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $9d5117faee5c78f9$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $9d5117faee5c78f9$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $9d5117faee5c78f9$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $9d5117faee5c78f9$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $9d5117faee5c78f9$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $9d5117faee5c78f9$var$parse_BrtFill = $9d5117faee5c78f9$var$parsenoop;
function $9d5117faee5c78f9$var$write_BrtFill(fill, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(84);
    if (!$9d5117faee5c78f9$var$rev_XLSBFillPTNames) $9d5117faee5c78f9$var$rev_XLSBFillPTNames = $9d5117faee5c78f9$var$evert($9d5117faee5c78f9$var$XLSBFillPTNames);
    var fls /*:number*/  = $9d5117faee5c78f9$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $9d5117faee5c78f9$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $9d5117faee5c78f9$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $9d5117faee5c78f9$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $9d5117faee5c78f9$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $9d5117faee5c78f9$var$write_Blxf(data, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $9d5117faee5c78f9$var$parse_BrtBorder = $9d5117faee5c78f9$var$parsenoop;
function $9d5117faee5c78f9$var$write_BrtBorder(border, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $9d5117faee5c78f9$var$write_Blxf(null, o); /* top */ 
    $9d5117faee5c78f9$var$write_Blxf(null, o); /* bottom */ 
    $9d5117faee5c78f9$var$write_Blxf(null, o); /* left */ 
    $9d5117faee5c78f9$var$write_Blxf(null, o); /* right */ 
    $9d5117faee5c78f9$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $9d5117faee5c78f9$var$write_BrtStyle(style, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $9d5117faee5c78f9$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $9d5117faee5c78f9$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $9d5117faee5c78f9$var$new_buf(2052);
    o.write_shift(4, cnt);
    $9d5117faee5c78f9$var$write_XLNullableWideString(defTableStyle, o);
    $9d5117faee5c78f9$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $9d5117faee5c78f9$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $9d5117faee5c78f9$var$table_fmt)styles.NumberFmt[y] = $9d5117faee5c78f9$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $9d5117faee5c78f9$var$recordhopper(data, function hopper_sty(val, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val[0]] = val[1];
                $9d5117faee5c78f9$var$SSF__load(val[1], val[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val);
                if (val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val.color.rgb = $9d5117faee5c78f9$var$rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $9d5117faee5c78f9$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $9d5117faee5c78f9$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $9d5117faee5c78f9$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $9d5117faee5c78f9$var$write_record(ba, 0x002C /* BrtFmt */ , $9d5117faee5c78f9$var$write_BrtFmt(i, NF[i]));
    });
    $9d5117faee5c78f9$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $9d5117faee5c78f9$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $9d5117faee5c78f9$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $9d5117faee5c78f9$var$write_UInt32LE(cnt));
    $9d5117faee5c78f9$var$write_record(ba, 0x002B /* BrtFont */ , $9d5117faee5c78f9$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $9d5117faee5c78f9$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $9d5117faee5c78f9$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $9d5117faee5c78f9$var$write_record(ba, 0x025B /* BrtBeginFills */ , $9d5117faee5c78f9$var$write_UInt32LE(cnt));
    $9d5117faee5c78f9$var$write_record(ba, 0x002D /* BrtFill */ , $9d5117faee5c78f9$var$write_BrtFill({
        patternType: "none"
    }));
    $9d5117faee5c78f9$var$write_record(ba, 0x002D /* BrtFill */ , $9d5117faee5c78f9$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $9d5117faee5c78f9$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $9d5117faee5c78f9$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $9d5117faee5c78f9$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $9d5117faee5c78f9$var$write_UInt32LE(cnt));
    $9d5117faee5c78f9$var$write_record(ba, 0x002E /* BrtBorder */ , $9d5117faee5c78f9$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $9d5117faee5c78f9$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $9d5117faee5c78f9$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $9d5117faee5c78f9$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $9d5117faee5c78f9$var$write_UInt32LE(cnt));
    $9d5117faee5c78f9$var$write_record(ba, 0x002F /* BrtXF */ , $9d5117faee5c78f9$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $9d5117faee5c78f9$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $9d5117faee5c78f9$var$write_CELLXFS_bin(ba, data) {
    $9d5117faee5c78f9$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $9d5117faee5c78f9$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $9d5117faee5c78f9$var$write_record(ba, 0x002F /* BrtXF */ , $9d5117faee5c78f9$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $9d5117faee5c78f9$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $9d5117faee5c78f9$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $9d5117faee5c78f9$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $9d5117faee5c78f9$var$write_UInt32LE(cnt));
    $9d5117faee5c78f9$var$write_record(ba, 0x0030 /* BrtStyle */ , $9d5117faee5c78f9$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $9d5117faee5c78f9$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $9d5117faee5c78f9$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $9d5117faee5c78f9$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $9d5117faee5c78f9$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $9d5117faee5c78f9$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $9d5117faee5c78f9$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $9d5117faee5c78f9$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $9d5117faee5c78f9$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $9d5117faee5c78f9$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $9d5117faee5c78f9$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $9d5117faee5c78f9$var$write_sty_bin(wb, opts) {
    var ba = $9d5117faee5c78f9$var$buf_array();
    $9d5117faee5c78f9$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $9d5117faee5c78f9$var$write_FMTS_bin(ba, wb.SSF);
    $9d5117faee5c78f9$var$write_FONTS_bin(ba, wb);
    $9d5117faee5c78f9$var$write_FILLS_bin(ba, wb);
    $9d5117faee5c78f9$var$write_BORDERS_bin(ba, wb);
    $9d5117faee5c78f9$var$write_CELLSTYLEXFS_bin(ba, wb);
    $9d5117faee5c78f9$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $9d5117faee5c78f9$var$write_STYLES_bin(ba, wb);
    $9d5117faee5c78f9$var$write_DXFS_bin(ba, wb);
    $9d5117faee5c78f9$var$write_TABLESTYLES_bin(ba, wb);
    $9d5117faee5c78f9$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $9d5117faee5c78f9$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $9d5117faee5c78f9$var$XLSXThemeClrScheme = [
    '</a:lt1>',
    '</a:dk1>',
    '</a:lt2>',
    '</a:dk2>',
    '</a:accent1>',
    '</a:accent2>',
    '</a:accent3>',
    '</a:accent4>',
    '</a:accent5>',
    '</a:accent6>',
    '</a:hlink>',
    '</a:folHlink>'
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $9d5117faee5c78f9$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($9d5117faee5c78f9$var$tagregex) || []).forEach(function(x) {
        var y = $9d5117faee5c78f9$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case '<a:clrScheme':
            case '</a:clrScheme>':
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case '<a:srgbClr':
                color.rgb = y.val;
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case '<a:sysClr':
                color.rgb = y.lastClr;
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case '<a:dk1>':
            case '</a:dk1>':
            case '<a:lt1>':
            case '</a:lt1>':
            case '<a:dk2>':
            case '</a:dk2>':
            case '<a:lt2>':
            case '</a:lt2>':
            case '<a:accent1>':
            case '</a:accent1>':
            case '<a:accent2>':
            case '</a:accent2>':
            case '<a:accent3>':
            case '</a:accent3>':
            case '<a:accent4>':
            case '</a:accent4>':
            case '<a:accent5>':
            case '</a:accent5>':
            case '<a:accent6>':
            case '</a:accent6>':
            case '<a:hlink>':
            case '</a:hlink>':
            case '<a:folHlink>':
            case '</a:folHlink>':
                if (y[0].charAt(1) === '/') {
                    themes.themeElements.clrScheme[$9d5117faee5c78f9$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $9d5117faee5c78f9$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $9d5117faee5c78f9$var$parse_fmtScheme() {}
var $9d5117faee5c78f9$var$clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var $9d5117faee5c78f9$var$fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var $9d5117faee5c78f9$var$fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
/* 20.1.6.10 themeElements CT_BaseStyles */ function $9d5117faee5c78f9$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    [
        /* clrScheme CT_ColorScheme */ [
            'clrScheme',
            $9d5117faee5c78f9$var$clrsregex,
            $9d5117faee5c78f9$var$parse_clrScheme
        ],
        /* fontScheme CT_FontScheme */ [
            'fontScheme',
            $9d5117faee5c78f9$var$fntsregex,
            $9d5117faee5c78f9$var$parse_fontScheme
        ],
        /* fmtScheme CT_StyleMatrix */ [
            'fmtScheme',
            $9d5117faee5c78f9$var$fmtsregex,
            $9d5117faee5c78f9$var$parse_fmtScheme
        ]
    ].forEach(function(m) {
        if (!(t = data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
        m[2](t, themes, opts);
    });
}
var $9d5117faee5c78f9$var$themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
/* 14.2.7 Theme Part */ function $9d5117faee5c78f9$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $9d5117faee5c78f9$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = data.match($9d5117faee5c78f9$var$themeltregex))) throw new Error('themeElements not found in theme');
    $9d5117faee5c78f9$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $9d5117faee5c78f9$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = '<a:themeElements>';
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = '</a:clrScheme>';
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = '<a:majorFont>';
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:majorFont>';
    o[o.length] = '<a:minorFont>';
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:minorFont>';
    o[o.length] = '</a:fontScheme>';
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = '<a:fillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:fillStyleLst>';
    o[o.length] = '<a:lnStyleLst>';
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '</a:lnStyleLst>';
    o[o.length] = '<a:effectStyleLst>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '</a:effectStyleLst>';
    o[o.length] = '<a:bgFillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:bgFillStyleLst>';
    o[o.length] = '</a:fmtScheme>';
    o[o.length] = '</a:themeElements>';
    o[o.length] = '<a:objectDefaults>';
    o[o.length] = '<a:spDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = '</a:spDef>';
    o[o.length] = '<a:lnDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = '</a:lnDef>';
    o[o.length] = '</a:objectDefaults>';
    o[o.length] = '<a:extraClrSchemeLst/>';
    o[o.length] = '</a:theme>';
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $9d5117faee5c78f9$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $9d5117faee5c78f9$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $9d5117faee5c78f9$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $9d5117faee5c78f9$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $9d5117faee5c78f9$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $9d5117faee5c78f9$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $9d5117faee5c78f9$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $9d5117faee5c78f9$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $9d5117faee5c78f9$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $9d5117faee5c78f9$var$parse_IcvXF(blob, length) {
    return $9d5117faee5c78f9$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $9d5117faee5c78f9$var$parse_XFExtGradient(blob, length) {
    return $9d5117faee5c78f9$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $9d5117faee5c78f9$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $9d5117faee5c78f9$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $9d5117faee5c78f9$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $9d5117faee5c78f9$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($9d5117faee5c78f9$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $9d5117faee5c78f9$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $9d5117faee5c78f9$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $9d5117faee5c78f9$var$parse_XLWideString(data, length - 8)
    };
}
function $9d5117faee5c78f9$var$write_BrtMdtinfo(data) {
    var o = $9d5117faee5c78f9$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $9d5117faee5c78f9$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $9d5117faee5c78f9$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $9d5117faee5c78f9$var$write_BrtMdb(mdb) {
    var o = $9d5117faee5c78f9$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $9d5117faee5c78f9$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $9d5117faee5c78f9$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $9d5117faee5c78f9$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $9d5117faee5c78f9$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $9d5117faee5c78f9$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $9d5117faee5c78f9$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $9d5117faee5c78f9$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $9d5117faee5c78f9$var$recordhopper(data, function(val, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val.name
                });
                break;
            case 51:
                val.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $9d5117faee5c78f9$var$write_xlmeta_bin() {
    var ba = $9d5117faee5c78f9$var$buf_array();
    $9d5117faee5c78f9$var$write_record(ba, 332);
    $9d5117faee5c78f9$var$write_record(ba, 334, $9d5117faee5c78f9$var$write_UInt32LE(1));
    $9d5117faee5c78f9$var$write_record(ba, 335, $9d5117faee5c78f9$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $9d5117faee5c78f9$var$write_record(ba, 336);
    $9d5117faee5c78f9$var$write_record(ba, 339, $9d5117faee5c78f9$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $9d5117faee5c78f9$var$write_record(ba, 52);
    $9d5117faee5c78f9$var$write_record(ba, 35, $9d5117faee5c78f9$var$write_UInt32LE(514));
    $9d5117faee5c78f9$var$write_record(ba, 4096, $9d5117faee5c78f9$var$write_UInt32LE(0));
    $9d5117faee5c78f9$var$write_record(ba, 4097, $9d5117faee5c78f9$var$writeuint16(1));
    $9d5117faee5c78f9$var$write_record(ba, 36);
    $9d5117faee5c78f9$var$write_record(ba, 53);
    $9d5117faee5c78f9$var$write_record(ba, 340);
    $9d5117faee5c78f9$var$write_record(ba, 337, $9d5117faee5c78f9$var$write_BrtBeginEsmdb(1, true));
    $9d5117faee5c78f9$var$write_record(ba, 51, $9d5117faee5c78f9$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $9d5117faee5c78f9$var$write_record(ba, 338);
    $9d5117faee5c78f9$var$write_record(ba, 333);
    return ba.end();
}
function $9d5117faee5c78f9$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($9d5117faee5c78f9$var$tagregex, function(x) {
        var y = $9d5117faee5c78f9$var$parsexmltag(x);
        switch($9d5117faee5c78f9$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && (opts == null ? void 0 : opts.WTF)) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $9d5117faee5c78f9$var$write_xlmeta_xml() {
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $9d5117faee5c78f9$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($9d5117faee5c78f9$var$tagregex) || []).forEach(function(x) {
        var y = $9d5117faee5c78f9$var$parsexmltag(x);
        switch(y[0]){
            case '<?xml':
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case '<calcChain':
            case '<calcChain>':
            case '</calcChain>':
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case '<c':
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $9d5117faee5c78f9$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $9d5117faee5c78f9$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = '1';
    if (flags & 0x8) out.a = '1';
    return out;
}
/* 18.6 Calculation Chain */ function $9d5117faee5c78f9$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $9d5117faee5c78f9$var$recordhopper(data, function hopper_cc(val, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $9d5117faee5c78f9$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $9d5117faee5c78f9$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $9d5117faee5c78f9$var$recordhopper(data, function xlink_parse(val, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $9d5117faee5c78f9$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/) || [
        "",
        ""
    ])[1];
    return rels['!id'][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ function $9d5117faee5c78f9$var$write_vml(rId /*:number*/ , comments) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $9d5117faee5c78f9$var$writextag("xml", null, {
            'xmlns:v': $9d5117faee5c78f9$var$XLMLNS.v,
            'xmlns:o': $9d5117faee5c78f9$var$XLMLNS.o,
            'xmlns:x': $9d5117faee5c78f9$var$XLMLNS.x,
            'xmlns:mv': $9d5117faee5c78f9$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $9d5117faee5c78f9$var$writextag("o:shapelayout", $9d5117faee5c78f9$var$writextag("o:idmap", null, {
            'v:ext': "edit",
            'data': rId
        }), {
            'v:ext': "edit"
        })
    ];
    var _shapeid = 65536 * rId;
    var _comments = comments || [];
    if (_comments.length > 0) o.push($9d5117faee5c78f9$var$writextag("v:shapetype", [
        $9d5117faee5c78f9$var$writextag("v:stroke", null, {
            joinstyle: "miter"
        }),
        $9d5117faee5c78f9$var$writextag("v:path", null, {
            gradientshapeok: "t",
            'o:connecttype': "rect"
        })
    ].join(""), {
        id: "_x0000_t202",
        coordsize: csize.join(","),
        'o:spt': 202,
        path: bbox
    }));
    _comments.forEach(function(x) {
        ++_shapeid;
        o.push($9d5117faee5c78f9$var$write_vml_comment(x, _shapeid));
    });
    o.push('</xml>');
    return o.join("");
}
function $9d5117faee5c78f9$var$write_vml_comment(x, _shapeid) /*:string*/ {
    var c = $9d5117faee5c78f9$var$decode_cell(x[0]);
    var fillopts = /*::(*/ {
        'color2': "#BEFF82",
        'type': "gradient"
    } /*:: :any)*/ ;
    if (fillopts.type == "gradient") fillopts.angle = "-180";
    var fillparm = fillopts.type == "gradient" ? $9d5117faee5c78f9$var$writextag("o:fill", null, {
        type: "gradientUnscaled",
        'v:ext': "view"
    }) : null;
    var fillxml = $9d5117faee5c78f9$var$writextag('v:fill', fillparm, fillopts);
    var shadata = {
        on: "t",
        'obscured': "t"
    } /*:any*/ ;
    return [
        '<v:shape' + $9d5117faee5c78f9$var$wxt_helper({
            id: '_x0000_s' + _shapeid,
            type: "#_x0000_t202",
            style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
            fillcolor: "#ECFAD4",
            strokecolor: "#edeaa1"
        }) + '>',
        fillxml,
        $9d5117faee5c78f9$var$writextag("v:shadow", null, shadata),
        $9d5117faee5c78f9$var$writextag("v:path", null, {
            'o:connecttype': "none"
        }),
        '<v:textbox><div style="text-align:left"></div></v:textbox>',
        '<x:ClientData ObjectType="Note">',
        '<x:MoveWithCells/>',
        '<x:SizeWithCells/>',
        /* Part 4 19.4.2.3 Anchor (Anchor) */ $9d5117faee5c78f9$var$writetag('x:Anchor', [
            c.c + 1,
            0,
            c.r + 1,
            0,
            c.c + 3,
            20,
            c.r + 5,
            20
        ].join(",")),
        $9d5117faee5c78f9$var$writetag('x:AutoFill', "False"),
        $9d5117faee5c78f9$var$writetag('x:Row', String(c.r)),
        $9d5117faee5c78f9$var$writetag('x:Column', String(c.c)),
        x[1].hidden ? '' : '<x:Visible/>',
        '</x:ClientData>',
        '</v:shape>'
    ].join("");
}
function $9d5117faee5c78f9$var$sheet_insert_comments(sheet /*:WorkSheet*/ , comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = sheet["!data"] != null;
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $9d5117faee5c78f9$var$decode_cell(comment.ref);
        if (r.r < 0 || r.c < 0) return;
        if (dense) {
            if (!sheet["!data"][r.r]) sheet["!data"][r.r] = [];
            cell = sheet["!data"][r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet["!data"][r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $9d5117faee5c78f9$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $9d5117faee5c78f9$var$encode_range(range);
            sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $9d5117faee5c78f9$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
        if (!cm) return;
        var y = $9d5117faee5c78f9$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $9d5117faee5c78f9$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
        var rt = !!textMatch && !!textMatch[1] && $9d5117faee5c78f9$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $9d5117faee5c78f9$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER,
        $9d5117faee5c78f9$var$writextag('comments', null, {
            'xmlns': $9d5117faee5c78f9$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $9d5117faee5c78f9$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [], tcnt = 0;
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($9d5117faee5c78f9$var$escapexml(c.a));
            if (c.T) ++tcnt;
            ts.push(c.t == null ? "" : $9d5117faee5c78f9$var$escapexml(c.t));
        });
        if (tcnt === 0) d[1].forEach(function(c) {
            o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf($9d5117faee5c78f9$var$escapexml(c.a)) + '"><text>');
            o.push($9d5117faee5c78f9$var$writetag("t", c.t == null ? "" : $9d5117faee5c78f9$var$escapexml(c.t)));
            o.push('</text></comment>');
        });
        else {
            /* based on Threaded Comments -> Comments projection */ o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
            var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($9d5117faee5c78f9$var$writetag("t", $9d5117faee5c78f9$var$escapexml(t)));
            o.push('</text></comment>');
        }
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = '</comments>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $9d5117faee5c78f9$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($9d5117faee5c78f9$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $9d5117faee5c78f9$var$parsexmltag(x);
        switch($9d5117faee5c78f9$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case '<ThreadedComments':
                break;
            case '</ThreadedComments>':
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case '<threadedComment':
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case '</threadedComment>':
                if (comment.t != null) out.push(comment);
                break;
            case '<text>':
            case '<text':
                tidx = idx + x.length;
                break;
            case '</text>':
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case '<mentions':
            case '<mentions>':
                pass = true;
                break;
            case '</mentions>':
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $9d5117faee5c78f9$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER,
        $9d5117faee5c78f9$var$writextag('ThreadedComments', null, {
            'xmlns': $9d5117faee5c78f9$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($9d5117faee5c78f9$var$writextag('threadedComment', $9d5117faee5c78f9$var$writetag('text', c.t || ""), tcopts));
        });
    });
    o.push('</ThreadedComments>');
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $9d5117faee5c78f9$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($9d5117faee5c78f9$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $9d5117faee5c78f9$var$parsexmltag(x);
        switch($9d5117faee5c78f9$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.4.85 personList CT_PersonList */ case '<personList':
                break;
            case '</personList>':
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case '<person':
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case '</person>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $9d5117faee5c78f9$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER,
        $9d5117faee5c78f9$var$writextag('personList', null, {
            'xmlns': $9d5117faee5c78f9$var$XMLNS.TCMNT,
            'xmlns:x': $9d5117faee5c78f9$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($9d5117faee5c78f9$var$writextag('person', null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $9d5117faee5c78f9$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $9d5117faee5c78f9$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $9d5117faee5c78f9$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $9d5117faee5c78f9$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $9d5117faee5c78f9$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $9d5117faee5c78f9$var$parse_BrtCommentAuthor = $9d5117faee5c78f9$var$parse_XLWideString;
function $9d5117faee5c78f9$var$write_BrtCommentAuthor(data) {
    return $9d5117faee5c78f9$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $9d5117faee5c78f9$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $9d5117faee5c78f9$var$recordhopper(data, function hopper_cmnt(val, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val.t;
                c.h = val.h;
                c.r = val.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $9d5117faee5c78f9$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $9d5117faee5c78f9$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $9d5117faee5c78f9$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $9d5117faee5c78f9$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $9d5117faee5c78f9$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $9d5117faee5c78f9$var$write_BrtCommentAuthor(c.a));
        });
    });
    $9d5117faee5c78f9$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $9d5117faee5c78f9$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            c.iauthor = iauthor.indexOf(c.a);
            var range = {
                s: $9d5117faee5c78f9$var$decode_cell(comment[0]),
                e: $9d5117faee5c78f9$var$decode_cell(comment[0])
            };
            $9d5117faee5c78f9$var$write_record(ba, 0x027B /* BrtBeginComment */ , $9d5117faee5c78f9$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $9d5117faee5c78f9$var$write_record(ba, 0x027D /* BrtCommentText */ , $9d5117faee5c78f9$var$write_BrtCommentText(c));
            $9d5117faee5c78f9$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $9d5117faee5c78f9$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $9d5117faee5c78f9$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $9d5117faee5c78f9$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $9d5117faee5c78f9$var$make_vba_xls(cfb) {
    var newcfb = $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $9d5117faee5c78f9$export$9f0e51cd97c572a.write(newcfb);
}
function $9d5117faee5c78f9$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $9d5117faee5c78f9$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $9d5117faee5c78f9$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $9d5117faee5c78f9$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $9d5117faee5c78f9$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
function $9d5117faee5c78f9$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
/* TODO: it will be useful to parse the function str */ var $9d5117faee5c78f9$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $9d5117faee5c78f9$var$encode_col(C) + (rRel ? "" : "$") + $9d5117faee5c78f9$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $9d5117faee5c78f9$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
var $9d5117faee5c78f9$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($9d5117faee5c78f9$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $9d5117faee5c78f9$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $9d5117faee5c78f9$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = $4 == "$" ? r + 1 : r == 0 ? "" : "[" + r + "]";
            var C = $2 == "$" ? c + 1 : c == 0 ? "" : "[" + c + "]";
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $9d5117faee5c78f9$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($9d5117faee5c78f9$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $9d5117faee5c78f9$var$encode_col($9d5117faee5c78f9$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $9d5117faee5c78f9$var$encode_row($9d5117faee5c78f9$var$decode_row($5) + delta.r));
    });
}
function $9d5117faee5c78f9$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $9d5117faee5c78f9$var$decode_range(range), s = r.s, c = $9d5117faee5c78f9$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $9d5117faee5c78f9$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $9d5117faee5c78f9$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $9d5117faee5c78f9$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $9d5117faee5c78f9$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $9d5117faee5c78f9$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $9d5117faee5c78f9$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $9d5117faee5c78f9$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $9d5117faee5c78f9$var$parse_ColRelU(blob, 2);
    var C = $9d5117faee5c78f9$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $9d5117faee5c78f9$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $9d5117faee5c78f9$var$parse_ColRelU(blob, 2), R = $9d5117faee5c78f9$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $9d5117faee5c78f9$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $9d5117faee5c78f9$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $9d5117faee5c78f9$var$parse_ColRelU(blob, 2);
    var C = $9d5117faee5c78f9$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $9d5117faee5c78f9$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $9d5117faee5c78f9$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $9d5117faee5c78f9$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $9d5117faee5c78f9$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $9d5117faee5c78f9$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $9d5117faee5c78f9$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $9d5117faee5c78f9$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $9d5117faee5c78f9$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $9d5117faee5c78f9$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $9d5117faee5c78f9$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $9d5117faee5c78f9$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $9d5117faee5c78f9$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, 'i');
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $9d5117faee5c78f9$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $9d5117faee5c78f9$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $9d5117faee5c78f9$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $9d5117faee5c78f9$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $9d5117faee5c78f9$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $9d5117faee5c78f9$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $9d5117faee5c78f9$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $9d5117faee5c78f9$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $9d5117faee5c78f9$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $9d5117faee5c78f9$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $9d5117faee5c78f9$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $9d5117faee5c78f9$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $9d5117faee5c78f9$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $9d5117faee5c78f9$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $9d5117faee5c78f9$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $9d5117faee5c78f9$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $9d5117faee5c78f9$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $9d5117faee5c78f9$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $9d5117faee5c78f9$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $9d5117faee5c78f9$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $9d5117faee5c78f9$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $9d5117faee5c78f9$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $9d5117faee5c78f9$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $9d5117faee5c78f9$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $9d5117faee5c78f9$var$FtabArgc[iftab],
        $9d5117faee5c78f9$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $9d5117faee5c78f9$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $9d5117faee5c78f9$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $9d5117faee5c78f9$var$Ftab : $9d5117faee5c78f9$var$Cetab)[tab[1]]
    ];
}
function $9d5117faee5c78f9$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $9d5117faee5c78f9$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $9d5117faee5c78f9$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, 'i'),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $9d5117faee5c78f9$var$parse_PtgErr(blob) {
    blob.l++;
    return $9d5117faee5c78f9$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $9d5117faee5c78f9$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $9d5117faee5c78f9$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $9d5117faee5c78f9$var$parse_PtgNum(blob) {
    blob.l++;
    return $9d5117faee5c78f9$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $9d5117faee5c78f9$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $9d5117faee5c78f9$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $9d5117faee5c78f9$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val[0]){
        case 0x02:
            val[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val[0]){
        case 0x04:
            /* SerBool -- boolean */ val[1] = $9d5117faee5c78f9$var$parsebool(blob, 1) ? 'TRUE' : 'FALSE';
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val[1] = $9d5117faee5c78f9$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val[1] = $9d5117faee5c78f9$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val[1] = $9d5117faee5c78f9$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val[0]); /* Unreachable */ 
    }
    return val;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $9d5117faee5c78f9$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $9d5117faee5c78f9$var$parse_UncheckedRfX : $9d5117faee5c78f9$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $9d5117faee5c78f9$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $9d5117faee5c78f9$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $9d5117faee5c78f9$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $9d5117faee5c78f9$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $9d5117faee5c78f9$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $9d5117faee5c78f9$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, 'i'); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $9d5117faee5c78f9$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $9d5117faee5c78f9$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $9d5117faee5c78f9$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $9d5117faee5c78f9$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $9d5117faee5c78f9$var$parse_PtgMemErr = $9d5117faee5c78f9$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $9d5117faee5c78f9$var$parse_PtgMemNoMem = $9d5117faee5c78f9$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $9d5117faee5c78f9$var$parse_PtgTbl = $9d5117faee5c78f9$var$parsenoop;
function $9d5117faee5c78f9$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $9d5117faee5c78f9$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $9d5117faee5c78f9$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $9d5117faee5c78f9$var$parse_PtgElfCol = $9d5117faee5c78f9$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $9d5117faee5c78f9$var$parse_PtgElfColS = $9d5117faee5c78f9$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $9d5117faee5c78f9$var$parse_PtgElfColSV = $9d5117faee5c78f9$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $9d5117faee5c78f9$var$parse_PtgElfColV = $9d5117faee5c78f9$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $9d5117faee5c78f9$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $9d5117faee5c78f9$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $9d5117faee5c78f9$var$parse_PtgElfRadical = $9d5117faee5c78f9$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $9d5117faee5c78f9$var$parse_PtgElfRadicalLel = $9d5117faee5c78f9$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $9d5117faee5c78f9$var$parse_PtgElfRadicalS = $9d5117faee5c78f9$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $9d5117faee5c78f9$var$parse_PtgElfRw = $9d5117faee5c78f9$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $9d5117faee5c78f9$var$parse_PtgElfRwV = $9d5117faee5c78f9$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $9d5117faee5c78f9$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $9d5117faee5c78f9$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $9d5117faee5c78f9$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $9d5117faee5c78f9$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $9d5117faee5c78f9$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $9d5117faee5c78f9$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $9d5117faee5c78f9$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $9d5117faee5c78f9$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $9d5117faee5c78f9$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $9d5117faee5c78f9$var$PtgTypes = {
    /*::[*/ 0x01: {
        n: 'PtgExp',
        f: $9d5117faee5c78f9$var$parse_PtgExp
    },
    /*::[*/ 0x02: {
        n: 'PtgTbl',
        f: $9d5117faee5c78f9$var$parse_PtgTbl
    },
    /*::[*/ 0x03: {
        n: 'PtgAdd',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x04: {
        n: 'PtgSub',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x05: {
        n: 'PtgMul',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x06: {
        n: 'PtgDiv',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x07: {
        n: 'PtgPower',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x08: {
        n: 'PtgConcat',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x09: {
        n: 'PtgLt',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x0A: {
        n: 'PtgLe',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x0B: {
        n: 'PtgEq',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x0C: {
        n: 'PtgGe',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x0D: {
        n: 'PtgGt',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x0E: {
        n: 'PtgNe',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x0F: {
        n: 'PtgIsect',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x10: {
        n: 'PtgUnion',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x11: {
        n: 'PtgRange',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x12: {
        n: 'PtgUplus',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x13: {
        n: 'PtgUminus',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x14: {
        n: 'PtgPercent',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x15: {
        n: 'PtgParen',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x16: {
        n: 'PtgMissArg',
        f: $9d5117faee5c78f9$var$parseread1
    },
    /*::[*/ 0x17: {
        n: 'PtgStr',
        f: $9d5117faee5c78f9$var$parse_PtgStr
    },
    /*::[*/ 0x1A: {
        n: 'PtgSheet',
        f: $9d5117faee5c78f9$var$parse_PtgSheet
    },
    /*::[*/ 0x1B: {
        n: 'PtgEndSheet',
        f: $9d5117faee5c78f9$var$parse_PtgEndSheet
    },
    /*::[*/ 0x1C: {
        n: 'PtgErr',
        f: $9d5117faee5c78f9$var$parse_PtgErr
    },
    /*::[*/ 0x1D: {
        n: 'PtgBool',
        f: $9d5117faee5c78f9$var$parse_PtgBool
    },
    /*::[*/ 0x1E: {
        n: 'PtgInt',
        f: $9d5117faee5c78f9$var$parse_PtgInt
    },
    /*::[*/ 0x1F: {
        n: 'PtgNum',
        f: $9d5117faee5c78f9$var$parse_PtgNum
    },
    /*::[*/ 0x20: {
        n: 'PtgArray',
        f: $9d5117faee5c78f9$var$parse_PtgArray
    },
    /*::[*/ 0x21: {
        n: 'PtgFunc',
        f: $9d5117faee5c78f9$var$parse_PtgFunc
    },
    /*::[*/ 0x22: {
        n: 'PtgFuncVar',
        f: $9d5117faee5c78f9$var$parse_PtgFuncVar
    },
    /*::[*/ 0x23: {
        n: 'PtgName',
        f: $9d5117faee5c78f9$var$parse_PtgName
    },
    /*::[*/ 0x24: {
        n: 'PtgRef',
        f: $9d5117faee5c78f9$var$parse_PtgRef
    },
    /*::[*/ 0x25: {
        n: 'PtgArea',
        f: $9d5117faee5c78f9$var$parse_PtgArea
    },
    /*::[*/ 0x26: {
        n: 'PtgMemArea',
        f: $9d5117faee5c78f9$var$parse_PtgMemArea
    },
    /*::[*/ 0x27: {
        n: 'PtgMemErr',
        f: $9d5117faee5c78f9$var$parse_PtgMemErr
    },
    /*::[*/ 0x28: {
        n: 'PtgMemNoMem',
        f: $9d5117faee5c78f9$var$parse_PtgMemNoMem
    },
    /*::[*/ 0x29: {
        n: 'PtgMemFunc',
        f: $9d5117faee5c78f9$var$parse_PtgMemFunc
    },
    /*::[*/ 0x2A: {
        n: 'PtgRefErr',
        f: $9d5117faee5c78f9$var$parse_PtgRefErr
    },
    /*::[*/ 0x2B: {
        n: 'PtgAreaErr',
        f: $9d5117faee5c78f9$var$parse_PtgAreaErr
    },
    /*::[*/ 0x2C: {
        n: 'PtgRefN',
        f: $9d5117faee5c78f9$var$parse_PtgRefN
    },
    /*::[*/ 0x2D: {
        n: 'PtgAreaN',
        f: $9d5117faee5c78f9$var$parse_PtgAreaN
    },
    /*::[*/ 0x2E: {
        n: 'PtgMemAreaN',
        f: $9d5117faee5c78f9$var$parse_PtgMemAreaN
    },
    /*::[*/ 0x2F: {
        n: 'PtgMemNoMemN',
        f: $9d5117faee5c78f9$var$parse_PtgMemNoMemN
    },
    /*::[*/ 0x39: {
        n: 'PtgNameX',
        f: $9d5117faee5c78f9$var$parse_PtgNameX
    },
    /*::[*/ 0x3A: {
        n: 'PtgRef3d',
        f: $9d5117faee5c78f9$var$parse_PtgRef3d
    },
    /*::[*/ 0x3B: {
        n: 'PtgArea3d',
        f: $9d5117faee5c78f9$var$parse_PtgArea3d
    },
    /*::[*/ 0x3C: {
        n: 'PtgRefErr3d',
        f: $9d5117faee5c78f9$var$parse_PtgRefErr3d
    },
    /*::[*/ 0x3D: {
        n: 'PtgAreaErr3d',
        f: $9d5117faee5c78f9$var$parse_PtgAreaErr3d
    },
    /*::[*/ 0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $9d5117faee5c78f9$var$PtgDupes = {
    /*::[*/ 0x40: 0x20,
    /*::[*/ 0x60: 0x20,
    /*::[*/ 0x41: 0x21,
    /*::[*/ 0x61: 0x21,
    /*::[*/ 0x42: 0x22,
    /*::[*/ 0x62: 0x22,
    /*::[*/ 0x43: 0x23,
    /*::[*/ 0x63: 0x23,
    /*::[*/ 0x44: 0x24,
    /*::[*/ 0x64: 0x24,
    /*::[*/ 0x45: 0x25,
    /*::[*/ 0x65: 0x25,
    /*::[*/ 0x46: 0x26,
    /*::[*/ 0x66: 0x26,
    /*::[*/ 0x47: 0x27,
    /*::[*/ 0x67: 0x27,
    /*::[*/ 0x48: 0x28,
    /*::[*/ 0x68: 0x28,
    /*::[*/ 0x49: 0x29,
    /*::[*/ 0x69: 0x29,
    /*::[*/ 0x4A: 0x2A,
    /*::[*/ 0x6A: 0x2A,
    /*::[*/ 0x4B: 0x2B,
    /*::[*/ 0x6B: 0x2B,
    /*::[*/ 0x4C: 0x2C,
    /*::[*/ 0x6C: 0x2C,
    /*::[*/ 0x4D: 0x2D,
    /*::[*/ 0x6D: 0x2D,
    /*::[*/ 0x4E: 0x2E,
    /*::[*/ 0x6E: 0x2E,
    /*::[*/ 0x4F: 0x2F,
    /*::[*/ 0x6F: 0x2F,
    /*::[*/ 0x58: 0x22,
    /*::[*/ 0x78: 0x22,
    /*::[*/ 0x59: 0x39,
    /*::[*/ 0x79: 0x39,
    /*::[*/ 0x5A: 0x3A,
    /*::[*/ 0x7A: 0x3A,
    /*::[*/ 0x5B: 0x3B,
    /*::[*/ 0x7B: 0x3B,
    /*::[*/ 0x5C: 0x3C,
    /*::[*/ 0x7C: 0x3C,
    /*::[*/ 0x5D: 0x3D,
    /*::[*/ 0x7D: 0x3D
};
var $9d5117faee5c78f9$var$Ptg18 = {
    /*::[*/ 0x01: {
        n: 'PtgElfLel',
        f: $9d5117faee5c78f9$var$parse_PtgElfLel
    },
    /*::[*/ 0x02: {
        n: 'PtgElfRw',
        f: $9d5117faee5c78f9$var$parse_PtgElfRw
    },
    /*::[*/ 0x03: {
        n: 'PtgElfCol',
        f: $9d5117faee5c78f9$var$parse_PtgElfCol
    },
    /*::[*/ 0x06: {
        n: 'PtgElfRwV',
        f: $9d5117faee5c78f9$var$parse_PtgElfRwV
    },
    /*::[*/ 0x07: {
        n: 'PtgElfColV',
        f: $9d5117faee5c78f9$var$parse_PtgElfColV
    },
    /*::[*/ 0x0A: {
        n: 'PtgElfRadical',
        f: $9d5117faee5c78f9$var$parse_PtgElfRadical
    },
    /*::[*/ 0x0B: {
        n: 'PtgElfRadicalS',
        f: $9d5117faee5c78f9$var$parse_PtgElfRadicalS
    },
    /*::[*/ 0x0D: {
        n: 'PtgElfColS',
        f: $9d5117faee5c78f9$var$parse_PtgElfColS
    },
    /*::[*/ 0x0F: {
        n: 'PtgElfColSV',
        f: $9d5117faee5c78f9$var$parse_PtgElfColSV
    },
    /*::[*/ 0x10: {
        n: 'PtgElfRadicalLel',
        f: $9d5117faee5c78f9$var$parse_PtgElfRadicalLel
    },
    /*::[*/ 0x19: {
        n: 'PtgList',
        f: $9d5117faee5c78f9$var$parse_PtgList
    },
    /*::[*/ 0x1D: {
        n: 'PtgSxName',
        f: $9d5117faee5c78f9$var$parse_PtgSxName
    },
    /*::[*/ 0xFF: {}
};
var $9d5117faee5c78f9$var$Ptg19 = {
    /*::[*/ 0x00: {
        n: 'PtgAttrNoop',
        f: $9d5117faee5c78f9$var$parse_PtgAttrNoop
    },
    /*::[*/ 0x01: {
        n: 'PtgAttrSemi',
        f: $9d5117faee5c78f9$var$parse_PtgAttrSemi
    },
    /*::[*/ 0x02: {
        n: 'PtgAttrIf',
        f: $9d5117faee5c78f9$var$parse_PtgAttrIf
    },
    /*::[*/ 0x04: {
        n: 'PtgAttrChoose',
        f: $9d5117faee5c78f9$var$parse_PtgAttrChoose
    },
    /*::[*/ 0x08: {
        n: 'PtgAttrGoto',
        f: $9d5117faee5c78f9$var$parse_PtgAttrGoto
    },
    /*::[*/ 0x10: {
        n: 'PtgAttrSum',
        f: $9d5117faee5c78f9$var$parse_PtgAttrSum
    },
    /*::[*/ 0x20: {
        n: 'PtgAttrBaxcel',
        f: $9d5117faee5c78f9$var$parse_PtgAttrBaxcel
    },
    /*::[*/ 0x21: {
        n: 'PtgAttrBaxcel',
        f: $9d5117faee5c78f9$var$parse_PtgAttrBaxcel
    },
    /*::[*/ 0x40: {
        n: 'PtgAttrSpace',
        f: $9d5117faee5c78f9$var$parse_PtgAttrSpace
    },
    /*::[*/ 0x41: {
        n: 'PtgAttrSpaceSemi',
        f: $9d5117faee5c78f9$var$parse_PtgAttrSpaceSemi
    },
    /*::[*/ 0x80: {
        n: 'PtgAttrIfError',
        f: $9d5117faee5c78f9$var$parse_PtgAttrIfError
    },
    /*::[*/ 0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $9d5117faee5c78f9$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $9d5117faee5c78f9$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case 'PtgArray':
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $9d5117faee5c78f9$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case 'PtgMemArea':
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $9d5117faee5c78f9$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case 'PtgExp':
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case 'PtgList':
        /* TODO: PtgList -> PtgExtraList */ case 'PtgElfRadicalS':
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case 'PtgElfColS':
        /* TODO: PtgElfColS -> PtgExtraElf */ case 'PtgElfColSV':
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($9d5117faee5c78f9$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $9d5117faee5c78f9$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $9d5117faee5c78f9$var$PtgTypes[id] || $9d5117faee5c78f9$var$PtgTypes[$9d5117faee5c78f9$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $9d5117faee5c78f9$var$Ptg18 : $9d5117faee5c78f9$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $9d5117faee5c78f9$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $9d5117faee5c78f9$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $9d5117faee5c78f9$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// TODO: explore space
function $9d5117faee5c78f9$var$make_3d_range(start, end) {
    var s = start.lastIndexOf("!"), e = end.lastIndexOf("!");
    if (s == -1 && e == -1) return start + ":" + end;
    if (s > 0 && e > 0 && start.slice(0, s).toLowerCase() == end.slice(0, e).toLowerCase()) return start + ":" + end.slice(e + 1);
    console.error("Cannot hydrate range", start, end);
    return start + ":" + end;
}
function $9d5117faee5c78f9$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $9d5117faee5c78f9$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $9d5117faee5c78f9$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $9d5117faee5c78f9$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $9d5117faee5c78f9$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case 'PtgUminus':
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case 'PtgUplus':
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case 'PtgPercent':
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case 'PtgAdd':
            /* [MS-XLS] 2.5.198.26 */ case 'PtgConcat':
            /* [MS-XLS] 2.5.198.43 */ case 'PtgDiv':
            /* [MS-XLS] 2.5.198.45 */ case 'PtgEq':
            /* [MS-XLS] 2.5.198.56 */ case 'PtgGe':
            /* [MS-XLS] 2.5.198.64 */ case 'PtgGt':
            /* [MS-XLS] 2.5.198.65 */ case 'PtgLe':
            /* [MS-XLS] 2.5.198.68 */ case 'PtgLt':
            /* [MS-XLS] 2.5.198.69 */ case 'PtgMul':
            /* [MS-XLS] 2.5.198.75 */ case 'PtgNe':
            /* [MS-XLS] 2.5.198.78 */ case 'PtgPower':
            /* [MS-XLS] 2.5.198.82 */ case 'PtgSub':
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $9d5117faee5c78f9$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $9d5117faee5c78f9$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $9d5117faee5c78f9$var$PtgBinOp[f[0]] + e1);
                break;
            case 'PtgIsect':
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case 'PtgUnion':
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case 'PtgRange':
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push($9d5117faee5c78f9$var$make_3d_range(e2, e1));
                break;
            case 'PtgAttrChoose':
                break;
            case 'PtgAttrGoto':
                break;
            case 'PtgAttrIf':
                break;
            case 'PtgAttrIfError':
                break;
            case 'PtgRef':
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $9d5117faee5c78f9$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($9d5117faee5c78f9$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRefN':
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $9d5117faee5c78f9$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($9d5117faee5c78f9$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRef3d':
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $9d5117faee5c78f9$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $9d5117faee5c78f9$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $9d5117faee5c78f9$var$encode_cell_xls(c, biff));
                break;
            case 'PtgFunc':
            /* [MS-XLS] 2.5.198.62 */ case 'PtgFuncVar':
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === 'User') func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case 'PtgBool':
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case 'PtgInt':
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgNum':
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case 'PtgStr':
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case 'PtgErr':
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgAreaN':
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $9d5117faee5c78f9$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($9d5117faee5c78f9$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea':
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $9d5117faee5c78f9$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($9d5117faee5c78f9$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea3d':
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $9d5117faee5c78f9$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $9d5117faee5c78f9$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgAttrSum':
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case 'PtgAttrBaxcel':
            /* [MS-XLS] 2.5.198.33 */ case 'PtgAttrSemi':
                break;
            case 'PtgName':
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case 'PtgNameX':
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($9d5117faee5c78f9$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case 'PtgParen':
                /* [MS-XLS] 2.5.198.80 */ var lp = '(', rp = ')';
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $9d5117faee5c78f9$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $9d5117faee5c78f9$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $9d5117faee5c78f9$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $9d5117faee5c78f9$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case 'PtgRefErr':
                /* [MS-XLS] 2.5.198.86 */ stack.push('#REF!');
                break;
            case 'PtgRefErr3d':
                /* [MS-XLS] 2.5.198.87 */ stack.push('#REF!');
                break;
            case 'PtgExp':
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$9d5117faee5c78f9$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$9d5117faee5c78f9$var$encode_cell(c)];
                    stack.push($9d5117faee5c78f9$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($9d5117faee5c78f9$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case 'PtgArray':
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $9d5117faee5c78f9$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case 'PtgMemArea':
                break;
            case 'PtgAttrSpace':
            /* [MS-XLS] 2.5.198.38 */ case 'PtgAttrSpaceSemi':
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case 'PtgTbl':
                break;
            case 'PtgMemErr':
                break;
            case 'PtgMissArg':
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case 'PtgAreaErr':
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case 'PtgAreaErr3d':
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case 'PtgList':
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case 'PtgMemAreaN':
            case 'PtgMemNoMemN':
            case 'PtgAttrNoop':
            case 'PtgSheet':
            case 'PtgEndSheet':
                break;
            case 'PtgMemFunc':
                break;
            case 'PtgMemNoMem':
                break;
            case 'PtgElfCol':
            /* [MS-XLS] 2.5.198.46 */ case 'PtgElfColS':
            /* [MS-XLS] 2.5.198.47 */ case 'PtgElfColSV':
            /* [MS-XLS] 2.5.198.48 */ case 'PtgElfColV':
            /* [MS-XLS] 2.5.198.49 */ case 'PtgElfLel':
            /* [MS-XLS] 2.5.198.50 */ case 'PtgElfRadical':
            /* [MS-XLS] 2.5.198.51 */ case 'PtgElfRadicalLel':
            /* [MS-XLS] 2.5.198.52 */ case 'PtgElfRadicalS':
            /* [MS-XLS] 2.5.198.53 */ case 'PtgElfRw':
            /* [MS-XLS] 2.5.198.54 */ case 'PtgElfRwV':
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case 'PtgSxName':
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error('Unrecognized Formula Token: ' + String(f));
            default:
                throw new Error('Unrecognized Formula Token: ' + String(f));
        }
        var PtgNonDisp = [
            'PtgAttrSpace',
            'PtgAttrSpaceSemi',
            'PtgAttrGoto'
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $9d5117faee5c78f9$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $9d5117faee5c78f9$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    if (stack[0] == "TRUE") return true;
    if (stack[0] == "FALSE") return false;
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $9d5117faee5c78f9$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $9d5117faee5c78f9$var$parsenoop(blob, length - 2)
    ];
    var rgce = $9d5117faee5c78f9$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $9d5117faee5c78f9$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $9d5117faee5c78f9$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $9d5117faee5c78f9$var$parsenoop(blob, length - 2)
    ];
    var rgce = $9d5117faee5c78f9$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $9d5117faee5c78f9$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $9d5117faee5c78f9$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $9d5117faee5c78f9$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $9d5117faee5c78f9$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $9d5117faee5c78f9$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $9d5117faee5c78f9$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $9d5117faee5c78f9$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $9d5117faee5c78f9$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $9d5117faee5c78f9$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($9d5117faee5c78f9$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $9d5117faee5c78f9$var$parse_Xnum(blob),
        'n'
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                's'
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                'b'
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                'e'
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                's'
            ];
    }
    return [];
}
function $9d5117faee5c78f9$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $9d5117faee5c78f9$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $9d5117faee5c78f9$var$write_Xnum(value);
    return $9d5117faee5c78f9$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $9d5117faee5c78f9$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $9d5117faee5c78f9$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2) ++blob.l;
    var val = $9d5117faee5c78f9$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $9d5117faee5c78f9$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val[1]
    };
}
function $9d5117faee5c78f9$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $9d5117faee5c78f9$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $9d5117faee5c78f9$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $9d5117faee5c78f9$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $9d5117faee5c78f9$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $9d5117faee5c78f9$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $9d5117faee5c78f9$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $9d5117faee5c78f9$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $9d5117faee5c78f9$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $9d5117faee5c78f9$var$parse_XLSBArrayParsedFormula = $9d5117faee5c78f9$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $9d5117faee5c78f9$var$parse_XLSBCellParsedFormula = $9d5117faee5c78f9$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $9d5117faee5c78f9$var$parse_XLSBNameParsedFormula = $9d5117faee5c78f9$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $9d5117faee5c78f9$var$parse_XLSBSharedParsedFormula = $9d5117faee5c78f9$var$parse_XLSBParsedFormula;
/* Writes a PtgNum or PtgInt */ function $9d5117faee5c78f9$var$write_XLSBFormulaNum(val /*:number*/ ) {
    if ((val | 0) == val && val < Math.pow(2, 16) && val >= 0) {
        var oint = $9d5117faee5c78f9$var$new_buf(11);
        oint.write_shift(4, 3);
        oint.write_shift(1, 0x1e);
        oint.write_shift(2, val);
        oint.write_shift(4, 0);
        return oint;
    }
    var num = $9d5117faee5c78f9$var$new_buf(17);
    num.write_shift(4, 11);
    num.write_shift(1, 0x1f);
    num.write_shift(8, val);
    num.write_shift(4, 0);
    return num;
}
/* Writes a PtgErr */ function $9d5117faee5c78f9$var$write_XLSBFormulaErr(val /*:number*/ ) {
    var oint = $9d5117faee5c78f9$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1C);
    oint.write_shift(1, val);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgBool */ function $9d5117faee5c78f9$var$write_XLSBFormulaBool(val /*:boolean*/ ) {
    var oint = $9d5117faee5c78f9$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1D);
    oint.write_shift(1, val ? 1 : 0);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgStr */ function $9d5117faee5c78f9$var$write_XLSBFormulaStr(val /*:string*/ ) {
    var preamble = $9d5117faee5c78f9$var$new_buf(7);
    preamble.write_shift(4, 3 + 2 * val.length);
    preamble.write_shift(1, 0x17);
    preamble.write_shift(2, val.length);
    var body = $9d5117faee5c78f9$var$new_buf(2 * val.length);
    body.write_shift(2 * val.length, val, "utf16le");
    var postamble = $9d5117faee5c78f9$var$new_buf(4);
    postamble.write_shift(4, 0);
    return $9d5117faee5c78f9$var$bconcat([
        preamble,
        body,
        postamble
    ]);
}
/* Writes a PtgRef */ function $9d5117faee5c78f9$var$write_XLSBFormulaRef(str) {
    var cell = $9d5117faee5c78f9$var$decode_cell(str);
    var out = $9d5117faee5c78f9$var$new_buf(15);
    out.write_shift(4, 7);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRef3d */ function $9d5117faee5c78f9$var$write_XLSBFormulaRef3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    var cell = $9d5117faee5c78f9$var$decode_cell(str);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $9d5117faee5c78f9$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRefErr3d */ function $9d5117faee5c78f9$var$write_XLSBFormulaRefErr3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $9d5117faee5c78f9$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 60);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, 0);
    out.write_shift(2, 0); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a single sheet range [PtgRef PtgRef PtgRange] */ function $9d5117faee5c78f9$var$write_XLSBFormulaRange(_str) {
    var parts = _str.split(":"), str = parts[0];
    var out = $9d5117faee5c78f9$var$new_buf(23);
    out.write_shift(4, 15);
    /* start cell */ str = parts[0];
    var cell = $9d5117faee5c78f9$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* end cell */ str = parts[1];
    cell = $9d5117faee5c78f9$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgRef3D PtgRef3D PtgRange] */ function $9d5117faee5c78f9$var$write_XLSBFormulaRangeWS(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var parts = _str.split(":");
    str = parts[0];
    var out = $9d5117faee5c78f9$var$new_buf(27);
    out.write_shift(4, 19);
    /* start cell */ var str = parts[0], cell = $9d5117faee5c78f9$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* end cell */ str = parts[1];
    cell = $9d5117faee5c78f9$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgArea3d] */ function $9d5117faee5c78f9$var$write_XLSBFormulaArea3D(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var range = $9d5117faee5c78f9$var$decode_range(_str);
    var out = $9d5117faee5c78f9$var$new_buf(23);
    out.write_shift(4, 15);
    out.write_shift(1, 59);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, range.s.r);
    out.write_shift(4, range.e.r);
    out.write_shift(2, range.s.c);
    out.write_shift(2, range.e.c);
    out.write_shift(4, 0);
    return out;
}
/* General Formula */ function $9d5117faee5c78f9$var$write_XLSBFormula(val /*:string|number*/ , wb) {
    if (typeof val == "number") return $9d5117faee5c78f9$var$write_XLSBFormulaNum(val);
    if (typeof val == "boolean") return $9d5117faee5c78f9$var$write_XLSBFormulaBool(val);
    if (/^#(DIV\/0!|GETTING_DATA|N\/A|NAME\?|NULL!|NUM!|REF!|VALUE!)$/.test(val)) return $9d5117faee5c78f9$var$write_XLSBFormulaErr(+$9d5117faee5c78f9$var$RBErr[val]);
    if (val.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $9d5117faee5c78f9$var$write_XLSBFormulaRef(val);
    if (val.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $9d5117faee5c78f9$var$write_XLSBFormulaRange(val);
    if (val.match(/^#REF!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $9d5117faee5c78f9$var$write_XLSBFormulaArea3D(val, wb);
    if (val.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $9d5117faee5c78f9$var$write_XLSBFormulaRef3D(val, wb);
    if (val.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $9d5117faee5c78f9$var$write_XLSBFormulaRangeWS(val, wb);
    if (/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!#REF!$/.test(val)) return $9d5117faee5c78f9$var$write_XLSBFormulaRefErr3D(val, wb);
    if (/^".*"$/.test(val)) return $9d5117faee5c78f9$var$write_XLSBFormulaStr(val);
    if (/^[+-]\d+$/.test(val)) return $9d5117faee5c78f9$var$write_XLSBFormulaNum(parseInt(val, 10));
    throw "Formula |" + val + "| not supported for XLSB";
}
var $9d5117faee5c78f9$var$write_XLSBNameParsedFormula = $9d5117faee5c78f9$var$write_XLSBFormula;
var $9d5117faee5c78f9$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $9d5117faee5c78f9$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $9d5117faee5c78f9$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $9d5117faee5c78f9$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    f = f.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    f = f.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $9d5117faee5c78f9$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($9d5117faee5c78f9$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $9d5117faee5c78f9$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    r = r.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    r = r.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $9d5117faee5c78f9$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/!/, ".");
}
var $9d5117faee5c78f9$var$strs = {}; // shared strings
var $9d5117faee5c78f9$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $9d5117faee5c78f9$var$browser_has_Map = typeof Map !== 'undefined';
function $9d5117faee5c78f9$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($9d5117faee5c78f9$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $9d5117faee5c78f9$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($9d5117faee5c78f9$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $9d5117faee5c78f9$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $9d5117faee5c78f9$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $9d5117faee5c78f9$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $9d5117faee5c78f9$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $9d5117faee5c78f9$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == 'xlml') defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $9d5117faee5c78f9$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $9d5117faee5c78f9$var$SSF__load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $9d5117faee5c78f9$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles) {
    try {
        if (opts.cellNF) p.z = $9d5117faee5c78f9$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === 'z' && !opts.cellStyles) return;
    if (p.t === 'd' && typeof p.v === 'string') p.v = $9d5117faee5c78f9$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== 'z') try {
        if ($9d5117faee5c78f9$var$table_fmt[fmtid] == null) $9d5117faee5c78f9$var$SSF__load($9d5117faee5c78f9$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === 'e') p.w = p.w || $9d5117faee5c78f9$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $9d5117faee5c78f9$var$SSF_general_num(p.v);
            } else if (p.t === 'd') {
                var dd = $9d5117faee5c78f9$var$datenum(p.v);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $9d5117faee5c78f9$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $9d5117faee5c78f9$var$SSF_general(p.v, $9d5117faee5c78f9$var$_ssfopts);
        } else if (p.t === 'd') p.w = $9d5117faee5c78f9$var$SSF_format(fmtid, $9d5117faee5c78f9$var$datenum(p.v), $9d5117faee5c78f9$var$_ssfopts);
        else p.w = $9d5117faee5c78f9$var$SSF_format(fmtid, p.v, $9d5117faee5c78f9$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $9d5117faee5c78f9$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $9d5117faee5c78f9$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $9d5117faee5c78f9$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws['!ref']) {
        var range = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref']);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
    }
}
function $9d5117faee5c78f9$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $9d5117faee5c78f9$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $9d5117faee5c78f9$var$encode_range(d);
}
var $9d5117faee5c78f9$var$mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var $9d5117faee5c78f9$var$sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var $9d5117faee5c78f9$var$hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var $9d5117faee5c78f9$var$dimregex = /"(\w*:\w*)"/;
var $9d5117faee5c78f9$var$colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
var $9d5117faee5c78f9$var$afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var $9d5117faee5c78f9$var$marginregex = /<(?:\w:)?pageMargins[^>]*\/>/g;
var $9d5117faee5c78f9$var$sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
var $9d5117faee5c78f9$var$sheetprregex2 = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
var $9d5117faee5c78f9$var$svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
/* 18.3 Worksheets */ function $9d5117faee5c78f9$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    if ($9d5117faee5c78f9$var$DENSE != null && opts.dense == null) opts.dense = $9d5117faee5c78f9$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = {} /*:any*/ ;
    if (opts.dense) s["!data"] = [];
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = data.match($9d5117faee5c78f9$var$sheetdataregex);
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($9d5117faee5c78f9$var$sheetprregex);
    if (sheetPr) $9d5117faee5c78f9$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = data1.match($9d5117faee5c78f9$var$sheetprregex2)) $9d5117faee5c78f9$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($9d5117faee5c78f9$var$dimregex);
        if (ref && !(opts && opts.nodim)) $9d5117faee5c78f9$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = data1.match($9d5117faee5c78f9$var$svsregex);
    if (svs && svs[1]) $9d5117faee5c78f9$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($9d5117faee5c78f9$var$colregex);
        if (cols) $9d5117faee5c78f9$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $9d5117faee5c78f9$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($9d5117faee5c78f9$var$afregex);
    if (afilter) s['!autofilter'] = $9d5117faee5c78f9$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($9d5117faee5c78f9$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $9d5117faee5c78f9$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"") + 1));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($9d5117faee5c78f9$var$hlinkregex);
    if (hlink) $9d5117faee5c78f9$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($9d5117faee5c78f9$var$marginregex);
    if (margins) s['!margins'] = $9d5117faee5c78f9$var$parse_ws_xml_margins($9d5117faee5c78f9$var$parsexmltag(margins[0]));
    if (opts && opts.nodim) refguess.s.c = refguess.s.r = 0;
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $9d5117faee5c78f9$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $9d5117faee5c78f9$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $9d5117faee5c78f9$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    return s;
}
function $9d5117faee5c78f9$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $9d5117faee5c78f9$var$encode_range(merges[i]) + '"/>';
    return o + '</mergeCells>';
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $9d5117faee5c78f9$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $9d5117faee5c78f9$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $9d5117faee5c78f9$var$unescapexml($9d5117faee5c78f9$var$utf8read(data.codeName));
}
function $9d5117faee5c78f9$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $9d5117faee5c78f9$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $9d5117faee5c78f9$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== 'xlsx' && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $9d5117faee5c78f9$var$utf8write($9d5117faee5c78f9$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $9d5117faee5c78f9$var$writextag('outlinePr', null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $9d5117faee5c78f9$var$writextag('sheetPr', payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $9d5117faee5c78f9$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $9d5117faee5c78f9$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $9d5117faee5c78f9$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $9d5117faee5c78f9$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $9d5117faee5c78f9$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $9d5117faee5c78f9$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $9d5117faee5c78f9$var$writextag('sheetProtection', null, o);
}
function $9d5117faee5c78f9$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = s["!data"] != null;
    for(var i = 0; i != data.length; ++i){
        var val = $9d5117faee5c78f9$var$parsexmltag($9d5117faee5c78f9$var$utf8read(data[i]), true);
        if (!val.ref) return;
        var rel = ((rels || {})['!id'] || [])[val.id];
        if (rel) {
            val.Target = rel.Target;
            if (val.location) val.Target += "#" + $9d5117faee5c78f9$var$unescapexml(val.location);
        } else {
            val.Target = "#" + $9d5117faee5c78f9$var$unescapexml(val.location);
            rel = {
                Target: val.Target,
                TargetMode: 'Internal'
            };
        }
        val.Rel = rel;
        if (val.tooltip) {
            val.Tooltip = val.tooltip;
            delete val.tooltip;
        }
        var rng = $9d5117faee5c78f9$var$safe_decode_range(val.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $9d5117faee5c78f9$var$encode_col(C) + $9d5117faee5c78f9$var$encode_row(R);
            if (dense) {
                if (!s["!data"][R]) s["!data"][R] = [];
                if (!s["!data"][R][C]) s["!data"][R][C] = {
                    t: "z",
                    v: undefined
                };
                s["!data"][R][C].l = val;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val;
            }
        }
    }
}
function $9d5117faee5c78f9$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $9d5117faee5c78f9$var$write_ws_xml_margins(margin) /*:string*/ {
    $9d5117faee5c78f9$var$default_margins(margin);
    return $9d5117faee5c78f9$var$writextag('pageMargins', null, margin);
}
function $9d5117faee5c78f9$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $9d5117faee5c78f9$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $9d5117faee5c78f9$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $9d5117faee5c78f9$var$find_mdw_colw(coll.width);
        }
        $9d5117faee5c78f9$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $9d5117faee5c78f9$var$dup(coll);
    }
}
function $9d5117faee5c78f9$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $9d5117faee5c78f9$var$writextag('col', null, $9d5117faee5c78f9$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $9d5117faee5c78f9$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $9d5117faee5c78f9$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $9d5117faee5c78f9$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $9d5117faee5c78f9$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $9d5117faee5c78f9$var$decode_range(ws["!ref"]).e.r;
        ref = $9d5117faee5c78f9$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $9d5117faee5c78f9$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $9d5117faee5c78f9$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $9d5117faee5c78f9$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $9d5117faee5c78f9$var$sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/g;
function $9d5117faee5c78f9$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($9d5117faee5c78f9$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $9d5117faee5c78f9$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if (tag.rightToLeft && $9d5117faee5c78f9$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $9d5117faee5c78f9$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $9d5117faee5c78f9$var$writextag("sheetViews", $9d5117faee5c78f9$var$writextag("sheetView", null, sview), {});
}
function $9d5117faee5c78f9$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts /*::, idx, wb*/ ) /*:string*/ {
    if (cell.c) ws['!comments'].push([
        ref,
        cell.c
    ]);
    if ((cell.v === undefined || cell.t === "z" && !(opts || {}).sheetStubs) && typeof cell.f !== "string" && typeof cell.z == "undefined") return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'n':
            vv = '' + cell.v;
            break;
        case 'e':
            vv = $9d5117faee5c78f9$var$BErr[cell.v];
            break;
        case 'd':
            if (opts && opts.cellDates) vv = $9d5117faee5c78f9$var$parseDate(cell.v, -1).toISOString();
            else {
                cell = $9d5117faee5c78f9$var$dup(cell);
                cell.t = 'n';
                vv = '' + (cell.v = $9d5117faee5c78f9$var$datenum($9d5117faee5c78f9$var$parseDate(cell.v)));
            }
            if (typeof cell.z === 'undefined') cell.z = $9d5117faee5c78f9$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = cell.t == "z" || cell.v == null ? "" : $9d5117faee5c78f9$var$writetag('v', $9d5117faee5c78f9$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $9d5117faee5c78f9$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case 'n':
            break;
        case 'd':
            o.t = "d";
            break;
        case 'b':
            o.t = "b";
            break;
        case 'e':
            o.t = "e";
            break;
        case 'z':
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $9d5117faee5c78f9$var$writetag('v', '' + $9d5117faee5c78f9$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            } else o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $9d5117faee5c78f9$var$writextag('f', $9d5117faee5c78f9$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) {
        cell.l.display = $9d5117faee5c78f9$var$escapexml(vv);
        ws['!links'].push([
            ref,
            cell.l
        ]);
    }
    if (cell.D) o.cm = 1;
    return $9d5117faee5c78f9$var$writextag('c', v, o);
}
var $9d5117faee5c78f9$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
    var refregex = /ref=["']([^"']*)["']/;
    var match_v = $9d5117faee5c78f9$var$matchtag("v"), match_f = $9d5117faee5c78f9$var$matchtag("f");
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = s["!data"] != null;
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $9d5117faee5c78f9$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $9d5117faee5c78f9$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden && $9d5117faee5c78f9$var$parsexmlbool(tag.hidden)) {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $9d5117faee5c78f9$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (!opts.nodim) {
                if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
                if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            }
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $9d5117faee5c78f9$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden && $9d5117faee5c78f9$var$parsexmlbool(tag.hidden)) {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $9d5117faee5c78f9$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $9d5117faee5c78f9$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = d.match(match_v)) != null && /*::cref != null && */ cref[1] !== '') p.v = $9d5117faee5c78f9$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = d.match(match_f)) != null && /*::cref != null && */ cref[1] !== '') {
                        /* TODO: match against XLSXFutureFunctions */ p.f = $9d5117faee5c78f9$var$unescapexml($9d5117faee5c78f9$var$utf8read(cref[1]), true);
                        if (!opts.xlfn) p.f = $9d5117faee5c78f9$var$_xlfn(p.f);
                        if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                            p.F = (d.match(refregex) || [])[1];
                            if (p.F.indexOf(":") > -1) arrayf.push([
                                $9d5117faee5c78f9$var$safe_decode_range(p.F),
                                p.F
                            ]);
                        } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                            // TODO: parse formula
                            ftag = $9d5117faee5c78f9$var$parsexmltag(cref[0]);
                            var ___f = $9d5117faee5c78f9$var$unescapexml($9d5117faee5c78f9$var$utf8read(cref[1]));
                            if (!opts.xlfn) ___f = $9d5117faee5c78f9$var$_xlfn(___f);
                            sharedf[parseInt(ftag.si, 10)] = [
                                ftag,
                                ___f,
                                tag.r
                            ];
                        }
                    } else if (cref = d.match(/<f[^>]*\/>/)) {
                        ftag = $9d5117faee5c78f9$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $9d5117faee5c78f9$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $9d5117faee5c78f9$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case 'n':
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else p.v = parseFloat(p.v);
                        break;
                    case 's':
                        if (typeof p.v == 'undefined') {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else {
                            sstr = $9d5117faee5c78f9$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case 'str':
                        p.t = "s";
                        p.v = p.v != null ? $9d5117faee5c78f9$var$unescapexml($9d5117faee5c78f9$var$utf8read(p.v), true) : '';
                        if (opts.cellHTML) p.h = $9d5117faee5c78f9$var$escapehtml(p.v);
                        break;
                    case 'inlineStr':
                        cref = d.match(isregex);
                        p.t = 's';
                        if (cref != null && (sstr = $9d5117faee5c78f9$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case 'b':
                        p.v = $9d5117faee5c78f9$var$parsexmlbool(p.v);
                        break;
                    case 'd':
                        if (opts.cellDates) p.v = $9d5117faee5c78f9$var$parseDate(p.v, 1);
                        else {
                            p.v = $9d5117faee5c78f9$var$datenum($9d5117faee5c78f9$var$parseDate(p.v, 1));
                            p.t = 'n';
                        }
                        break;
                    /* error string in .w, number in .v */ case 'e':
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $9d5117faee5c78f9$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $9d5117faee5c78f9$var$safe_format(p, fmtid, fillid, opts, themes, styles);
                if (opts.cellDates && do_format && p.t == 'n' && $9d5117faee5c78f9$var$fmt_is_date($9d5117faee5c78f9$var$table_fmt[fmtid])) {
                    p.t = 'd';
                    p.v = $9d5117faee5c78f9$var$numdate(p.v);
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == 'XLDAPR') p.D = true;
                }
                var _r;
                if (opts.nodim) {
                    _r = $9d5117faee5c78f9$var$decode_cell(tag.r);
                    if (guess.s.r > _r.r) guess.s.r = _r.r;
                    if (guess.e.r < _r.r) guess.e.r = _r.r;
                }
                if (dense) {
                    _r = $9d5117faee5c78f9$var$decode_cell(tag.r);
                    if (!s["!data"][_r.r]) s["!data"][_r.r] = [];
                    s["!data"][_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s['!rows'] = rows;
    };
}();
function $9d5117faee5c78f9$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref']), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws['!rows'];
    var dense = ws["!data"] != null;
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $9d5117faee5c78f9$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $9d5117faee5c78f9$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $9d5117faee5c78f9$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $9d5117faee5c78f9$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $9d5117faee5c78f9$var$writextag('row', r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $9d5117faee5c78f9$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $9d5117faee5c78f9$var$writextag('row', "", params);
        }
    }
    return o.join("");
}
function $9d5117faee5c78f9$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER,
        $9d5117faee5c78f9$var$writextag('worksheet', null, {
            'xmlns': $9d5117faee5c78f9$var$XMLNS_main[0],
            'xmlns:r': $9d5117faee5c78f9$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws['!ref'] || 'A1';
    var range = $9d5117faee5c78f9$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $9d5117faee5c78f9$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws['!comments'] = [];
    var _drawing = [];
    $9d5117faee5c78f9$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $9d5117faee5c78f9$var$writextag('dimension', null, {
        'ref': ref
    });
    o[o.length] = $9d5117faee5c78f9$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $9d5117faee5c78f9$var$writextag('sheetFormatPr', null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || '16',
        baseColWidth: opts.sheetFormat.baseColWidth || '10',
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || '7'
    });
    if (ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = $9d5117faee5c78f9$var$write_ws_xml_cols(ws, ws['!cols']);
    o[sidx = o.length] = '<sheetData/>';
    ws['!links'] = [];
    if (ws['!ref'] != null) {
        rdata = $9d5117faee5c78f9$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = '</sheetData>';
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws['!protect']) o[o.length] = $9d5117faee5c78f9$var$write_ws_xml_protection(ws['!protect']);
    /* protectedRanges */ /* scenarios */ if (ws['!autofilter'] != null) o[o.length] = $9d5117faee5c78f9$var$write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = $9d5117faee5c78f9$var$write_ws_xml_merges(ws['!merges']);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws['!links']/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws['!links']/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $9d5117faee5c78f9$var$add_rels(rels, -1, $9d5117faee5c78f9$var$escapexml(l[1].Target).replace(/#.*$/, ""), $9d5117faee5c78f9$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $9d5117faee5c78f9$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $9d5117faee5c78f9$var$escapexml(l[1].Tooltip);
            rel.display = l[1].display;
            o[o.length] = $9d5117faee5c78f9$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws['!links'];
    /* printOptions */ if (ws['!margins'] != null) o[o.length] = $9d5117faee5c78f9$var$write_ws_xml_margins(ws['!margins']);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $9d5117faee5c78f9$var$writetag("ignoredErrors", $9d5117faee5c78f9$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $9d5117faee5c78f9$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $9d5117faee5c78f9$var$RELS.DRAW);
        o[o.length] = $9d5117faee5c78f9$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws['!drawing'] = _drawing;
    }
    if (ws['!comments'].length > 0) {
        rId = $9d5117faee5c78f9$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $9d5117faee5c78f9$var$RELS.VML);
        o[o.length] = $9d5117faee5c78f9$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws['!legacy'] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = '</worksheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $9d5117faee5c78f9$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $9d5117faee5c78f9$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $9d5117faee5c78f9$var$new_buf(145);
    var row = (ws['!rows'] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $9d5117faee5c78f9$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    var dense = ws["!data"] != null;
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = dense ? (ws["!data"][caddr.r] || [])[caddr.c] : ws[$9d5117faee5c78f9$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $9d5117faee5c78f9$var$write_row_header(ba, ws, range, R) {
    var o = $9d5117faee5c78f9$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws['!rows'] || [])[R]) $9d5117faee5c78f9$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $9d5117faee5c78f9$var$parse_BrtWsDim = $9d5117faee5c78f9$var$parse_UncheckedRfX;
var $9d5117faee5c78f9$var$write_BrtWsDim = $9d5117faee5c78f9$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $9d5117faee5c78f9$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $9d5117faee5c78f9$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $9d5117faee5c78f9$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $9d5117faee5c78f9$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $9d5117faee5c78f9$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $9d5117faee5c78f9$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $9d5117faee5c78f9$var$parse_BrtCellBlank(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $9d5117faee5c78f9$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(8);
    return $9d5117faee5c78f9$var$write_XLSBCell(ncell, o);
}
function $9d5117faee5c78f9$var$parse_BrtShortBlank(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $9d5117faee5c78f9$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(4);
    return $9d5117faee5c78f9$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $9d5117faee5c78f9$var$parse_BrtCellBool(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $9d5117faee5c78f9$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(9);
    $9d5117faee5c78f9$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $9d5117faee5c78f9$var$parse_BrtShortBool(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $9d5117faee5c78f9$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(5);
    $9d5117faee5c78f9$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $9d5117faee5c78f9$var$parse_BrtCellError(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $9d5117faee5c78f9$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(9);
    $9d5117faee5c78f9$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $9d5117faee5c78f9$var$parse_BrtShortError(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $9d5117faee5c78f9$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(8);
    $9d5117faee5c78f9$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $9d5117faee5c78f9$var$parse_BrtCellIsst(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $9d5117faee5c78f9$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(12);
    $9d5117faee5c78f9$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $9d5117faee5c78f9$var$parse_BrtShortIsst(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $9d5117faee5c78f9$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(8);
    $9d5117faee5c78f9$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $9d5117faee5c78f9$var$parse_BrtCellReal(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBCell(data);
    var value = $9d5117faee5c78f9$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $9d5117faee5c78f9$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(16);
    $9d5117faee5c78f9$var$write_XLSBCell(ncell, o);
    $9d5117faee5c78f9$var$write_Xnum(cell.v, o);
    return o;
}
function $9d5117faee5c78f9$var$parse_BrtShortReal(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBShortCell(data);
    var value = $9d5117faee5c78f9$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $9d5117faee5c78f9$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(12);
    $9d5117faee5c78f9$var$write_XLSBShortCell(ncell, o);
    $9d5117faee5c78f9$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $9d5117faee5c78f9$var$parse_BrtCellRk(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBCell(data);
    var value = $9d5117faee5c78f9$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $9d5117faee5c78f9$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(12);
    $9d5117faee5c78f9$var$write_XLSBCell(ncell, o);
    $9d5117faee5c78f9$var$write_RkNumber(cell.v, o);
    return o;
}
function $9d5117faee5c78f9$var$parse_BrtShortRk(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBShortCell(data);
    var value = $9d5117faee5c78f9$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $9d5117faee5c78f9$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(8);
    $9d5117faee5c78f9$var$write_XLSBShortCell(ncell, o);
    $9d5117faee5c78f9$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $9d5117faee5c78f9$var$parse_BrtCellRString(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBCell(data);
    var value = $9d5117faee5c78f9$var$parse_RichStr(data);
    return [
        cell,
        value,
        'is'
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $9d5117faee5c78f9$var$parse_BrtCellSt(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBCell(data);
    var value = $9d5117faee5c78f9$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $9d5117faee5c78f9$var$write_BrtCellSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(12 + 4 * cell.v.length);
    $9d5117faee5c78f9$var$write_XLSBCell(ncell, o);
    $9d5117faee5c78f9$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $9d5117faee5c78f9$var$parse_BrtShortSt(data) {
    var cell = $9d5117faee5c78f9$var$parse_XLSBShortCell(data);
    var value = $9d5117faee5c78f9$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $9d5117faee5c78f9$var$write_BrtShortSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(8 + 4 * data.length);
    $9d5117faee5c78f9$var$write_XLSBShortCell(ncell, o);
    $9d5117faee5c78f9$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $9d5117faee5c78f9$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $9d5117faee5c78f9$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'b'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $9d5117faee5c78f9$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $9d5117faee5c78f9$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $9d5117faee5c78f9$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $9d5117faee5c78f9$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'e'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $9d5117faee5c78f9$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $9d5117faee5c78f9$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $9d5117faee5c78f9$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $9d5117faee5c78f9$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $9d5117faee5c78f9$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        'n'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $9d5117faee5c78f9$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $9d5117faee5c78f9$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $9d5117faee5c78f9$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $9d5117faee5c78f9$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $9d5117faee5c78f9$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        'str'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $9d5117faee5c78f9$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $9d5117faee5c78f9$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $9d5117faee5c78f9$var$parse_BrtMergeCell = $9d5117faee5c78f9$var$parse_UncheckedRfX;
var $9d5117faee5c78f9$var$write_BrtMergeCell = $9d5117faee5c78f9$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $9d5117faee5c78f9$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $9d5117faee5c78f9$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $9d5117faee5c78f9$var$parse_UncheckedRfX(data, 16);
    var relId = $9d5117faee5c78f9$var$parse_XLNullableWideString(data);
    var loc = $9d5117faee5c78f9$var$parse_XLWideString(data);
    var tooltip = $9d5117faee5c78f9$var$parse_XLWideString(data);
    var display = $9d5117faee5c78f9$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $9d5117faee5c78f9$var$write_BrtHLink(l, rId) {
    var o = $9d5117faee5c78f9$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $9d5117faee5c78f9$var$write_UncheckedRfX({
        s: $9d5117faee5c78f9$var$decode_cell(l[0]),
        e: $9d5117faee5c78f9$var$decode_cell(l[0])
    }, o);
    $9d5117faee5c78f9$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $9d5117faee5c78f9$var$write_XLWideString(loc || "", o);
    $9d5117faee5c78f9$var$write_XLWideString(l[1].Tooltip || "", o);
    $9d5117faee5c78f9$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $9d5117faee5c78f9$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $9d5117faee5c78f9$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $9d5117faee5c78f9$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $9d5117faee5c78f9$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $9d5117faee5c78f9$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $9d5117faee5c78f9$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $9d5117faee5c78f9$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $9d5117faee5c78f9$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(18);
    var p = $9d5117faee5c78f9$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == 'number') flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $9d5117faee5c78f9$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $9d5117faee5c78f9$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $9d5117faee5c78f9$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $9d5117faee5c78f9$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $9d5117faee5c78f9$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(48);
    $9d5117faee5c78f9$var$default_margins(margins);
    $9d5117faee5c78f9$var$BrtMarginKeys.forEach(function(k) {
        $9d5117faee5c78f9$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $9d5117faee5c78f9$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $9d5117faee5c78f9$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $9d5117faee5c78f9$var$write_BrtCellIgnoreEC(ref) {
    var o = $9d5117faee5c78f9$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $9d5117faee5c78f9$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $9d5117faee5c78f9$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $9d5117faee5c78f9$var$new_buf(66);
    o.write_shift(2, sp.password ? $9d5117faee5c78f9$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $9d5117faee5c78f9$var$parse_BrtDVal() {}
function $9d5117faee5c78f9$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $9d5117faee5c78f9$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        '!id': {}
    };
    if ($9d5117faee5c78f9$var$DENSE != null && opts.dense == null) opts.dense = $9d5117faee5c78f9$var$DENSE;
    var s /*:Worksheet*/  = {};
    if (opts.dense) s["!data"] = [];
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts['!row'] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $9d5117faee5c78f9$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $9d5117faee5c78f9$var$parse_BrtShortReal
    };
    var cm, vm;
    $9d5117faee5c78f9$var$recordhopper(data, function ws_parse(val, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $9d5117faee5c78f9$var$encode_row(R = row.r);
                opts['!row'] = row.r;
                if (val.hidden || val.hpt || val.level != null) {
                    if (val.hpt) val.hpx = $9d5117faee5c78f9$var$pt2px(val.hpt);
                    rowinfo[val.r] = val;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val[2]
                } /*:any*/ ;
                switch(val[2]){
                    case 'n':
                        p.v = val[1];
                        break;
                    case 's':
                        sstr = $9d5117faee5c78f9$var$strs[val[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case 'b':
                        p.v = val[1] ? true : false;
                        break;
                    case 'e':
                        p.v = val[1];
                        if (opts.cellText !== false) p.w = $9d5117faee5c78f9$var$BErr[p.v];
                        break;
                    case 'str':
                        p.t = 's';
                        p.v = val[1];
                        break;
                    case 'is':
                        p.t = 's';
                        p.v = val[1].t;
                        break;
                }
                if (cf = styles.CellXf[val[0].iStyleRef]) $9d5117faee5c78f9$var$safe_format(p, cf.numFmtId, null, opts, themes, styles);
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$9d5117faee5c78f9$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $9d5117faee5c78f9$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val.length > 3) p.f = val[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == 'n' && $9d5117faee5c78f9$var$fmt_is_date($9d5117faee5c78f9$var$table_fmt[cf.numFmtId])) {
                    var _d = $9d5117faee5c78f9$var$SSF_parse_date_code(p.v);
                    if (_d) {
                        p.t = 'd';
                        p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
                    }
                }
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: 'z',
                    v: void 0
                } /*:any*/ ;
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$9d5117faee5c78f9$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels['!id'][val.relId];
                if (rel) {
                    val.Target = rel.Target;
                    if (val.loc) val.Target += "#" + val.loc;
                    val.Rel = rel;
                } else if (val.relId == '') val.Target = "#" + val.loc;
                for(R = val.rfx.s.r; R <= val.rfx.e.r; ++R)for(C = val.rfx.s.c; C <= val.rfx.e.c; ++C)if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    if (!s["!data"][R][C]) s["!data"][R][C] = {
                        t: 'z',
                        v: undefined
                    };
                    s["!data"][R][C].l = val;
                } else {
                    addr = $9d5117faee5c78f9$var$encode_col(C) + $9d5117faee5c78f9$var$encode_row(R);
                    if (!s[addr]) s[addr] = {
                        t: 'z',
                        v: undefined
                    };
                    s[addr].l = val;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val);
                cell = opts.dense ? s["!data"][R][C] : s[$9d5117faee5c78f9$var$encode_col(C) + rr];
                cell.f = $9d5117faee5c78f9$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $9d5117faee5c78f9$var$encode_range(val[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$9d5117faee5c78f9$var$encode_cell(val[0].s)] = val[1];
                cell = opts.dense ? s["!data"][R][C] : s[$9d5117faee5c78f9$var$encode_col(C) + rr];
                cell.f = $9d5117faee5c78f9$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val.e >= val.s){
                    colinfo[val.e--] = {
                        width: val.w / 256,
                        hidden: !!(val.flags & 0x01),
                        level: val.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $9d5117faee5c78f9$var$find_mdw_colw(val.w / 256);
                    }
                    $9d5117faee5c78f9$var$process_col(colinfo[val.e + 1]);
                }
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s['!autofilter'] = {
                    ref: $9d5117faee5c78f9$var$encode_range(val)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s['!margins'] = val;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                if (val.above || val.left) s['!outline'] = {
                    above: val.above,
                    left: val.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts['!row'];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $9d5117faee5c78f9$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $9d5117faee5c78f9$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $9d5117faee5c78f9$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    return s;
}
/* TODO: something useful -- this is a stub */ function $9d5117faee5c78f9$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ ) /*:boolean*/ {
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    if (cell.c) ws['!comments'].push([
        $9d5117faee5c78f9$var$encode_cell(o),
        cell.c
    ]);
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'd':
            cell = $9d5117faee5c78f9$var$dup(cell);
            cell.z = cell.z || $9d5117faee5c78f9$var$table_fmt[14];
            cell.v = $9d5117faee5c78f9$var$datenum($9d5117faee5c78f9$var$parseDate(cell.v));
            cell.t = 'n';
            break;
        /* falls through */ case 'n':
        case 'e':
            vv = '' + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    /* TODO: cell style */ o.s = $9d5117faee5c78f9$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws['!links'].push([
        $9d5117faee5c78f9$var$encode_cell(o),
        cell.l
    ]);
    switch(cell.t){
        case 's':
        case 'str':
            if (opts.bookSST) {
                vv = $9d5117faee5c78f9$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $9d5117faee5c78f9$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $9d5117faee5c78f9$var$write_BrtShortIsst(cell, o));
                else $9d5117faee5c78f9$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $9d5117faee5c78f9$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $9d5117faee5c78f9$var$write_record(ba, 0x0011 /* BrtShortSt */ , $9d5117faee5c78f9$var$write_BrtShortSt(cell, o));
                else $9d5117faee5c78f9$var$write_record(ba, 0x0006 /* BrtCellSt */ , $9d5117faee5c78f9$var$write_BrtCellSt(cell, o));
            }
            return true;
        case 'n':
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $9d5117faee5c78f9$var$write_record(ba, 0x000D /* BrtShortRk */ , $9d5117faee5c78f9$var$write_BrtShortRk(cell, o));
                else $9d5117faee5c78f9$var$write_record(ba, 0x0002 /* BrtCellRk */ , $9d5117faee5c78f9$var$write_BrtCellRk(cell, o));
            } else if (last_seen) $9d5117faee5c78f9$var$write_record(ba, 0x0010 /* BrtShortReal */ , $9d5117faee5c78f9$var$write_BrtShortReal(cell, o));
            else $9d5117faee5c78f9$var$write_record(ba, 0x0005 /* BrtCellReal */ , $9d5117faee5c78f9$var$write_BrtCellReal(cell, o));
            return true;
        case 'b':
            o.t = "b";
            if (last_seen) $9d5117faee5c78f9$var$write_record(ba, 0x000F /* BrtShortBool */ , $9d5117faee5c78f9$var$write_BrtShortBool(cell, o));
            else $9d5117faee5c78f9$var$write_record(ba, 0x0004 /* BrtCellBool */ , $9d5117faee5c78f9$var$write_BrtCellBool(cell, o));
            return true;
        case 'e':
            o.t = "e";
            if (last_seen) $9d5117faee5c78f9$var$write_record(ba, 0x000E /* BrtShortError */ , $9d5117faee5c78f9$var$write_BrtShortError(cell, o));
            else $9d5117faee5c78f9$var$write_record(ba, 0x0003 /* BrtCellError */ , $9d5117faee5c78f9$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $9d5117faee5c78f9$var$write_record(ba, 0x000C /* BrtShortBlank */ , $9d5117faee5c78f9$var$write_BrtShortBlank(cell, o));
    else $9d5117faee5c78f9$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $9d5117faee5c78f9$var$write_BrtCellBlank(cell, o));
    return true;
}
function $9d5117faee5c78f9$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var range = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols /*:Array<string>*/  = [];
    $9d5117faee5c78f9$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = ws["!data"] != null;
    var cap = range.e.r;
    if (ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $9d5117faee5c78f9$var$encode_row(R);
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $9d5117faee5c78f9$var$write_row_header(ba, ws, range, R);
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $9d5117faee5c78f9$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $9d5117faee5c78f9$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
        }
    }
    $9d5117faee5c78f9$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $9d5117faee5c78f9$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!merges']) return;
    $9d5117faee5c78f9$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $9d5117faee5c78f9$var$write_BrtBeginMergeCells(ws['!merges'].length));
    ws['!merges'].forEach(function(m) {
        $9d5117faee5c78f9$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $9d5117faee5c78f9$var$write_BrtMergeCell(m));
    });
    $9d5117faee5c78f9$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $9d5117faee5c78f9$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws['!cols']) return;
    $9d5117faee5c78f9$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws['!cols'].forEach(function(m, i) {
        if (m) $9d5117faee5c78f9$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $9d5117faee5c78f9$var$write_BrtColInfo(i, m));
    });
    $9d5117faee5c78f9$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $9d5117faee5c78f9$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!ref']) return;
    $9d5117faee5c78f9$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $9d5117faee5c78f9$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $9d5117faee5c78f9$var$write_BrtCellIgnoreEC($9d5117faee5c78f9$var$safe_decode_range(ws['!ref'])));
    $9d5117faee5c78f9$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $9d5117faee5c78f9$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws['!links'].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $9d5117faee5c78f9$var$add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), $9d5117faee5c78f9$var$RELS.HLINK);
        $9d5117faee5c78f9$var$write_record(ba, 0x01EE /* BrtHLink */ , $9d5117faee5c78f9$var$write_BrtHLink(l, rId));
    });
    delete ws['!links'];
}
function $9d5117faee5c78f9$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws['!comments'].length > 0) {
        var rId = $9d5117faee5c78f9$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $9d5117faee5c78f9$var$RELS.VML);
        $9d5117faee5c78f9$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $9d5117faee5c78f9$var$write_RelID("rId" + rId));
        ws['!legacy'] = rId;
    }
}
function $9d5117faee5c78f9$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws['!autofilter']) return;
    var data = ws['!autofilter'];
    var ref = typeof data.ref === "string" ? data.ref : $9d5117faee5c78f9$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $9d5117faee5c78f9$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $9d5117faee5c78f9$var$decode_range(ws["!ref"]).e.r;
        ref = $9d5117faee5c78f9$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $9d5117faee5c78f9$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $9d5117faee5c78f9$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: $9d5117faee5c78f9$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $9d5117faee5c78f9$var$fix_range(ref)
    });
    $9d5117faee5c78f9$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $9d5117faee5c78f9$var$write_UncheckedRfX($9d5117faee5c78f9$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $9d5117faee5c78f9$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $9d5117faee5c78f9$var$write_WSVIEWS2(ba, ws, Workbook) {
    $9d5117faee5c78f9$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $9d5117faee5c78f9$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $9d5117faee5c78f9$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $9d5117faee5c78f9$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $9d5117faee5c78f9$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $9d5117faee5c78f9$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $9d5117faee5c78f9$var$write_SHEETPROTECT(ba, ws) {
    if (!ws['!protect']) return;
    /* [BrtSheetProtectionIso] */ $9d5117faee5c78f9$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $9d5117faee5c78f9$var$write_BrtSheetProtection(ws['!protect']));
}
function $9d5117faee5c78f9$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $9d5117faee5c78f9$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref'] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws['!links'] = [];
    /* passed back to write_zip and removed there */ ws['!comments'] = [];
    $9d5117faee5c78f9$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws['!outline']) $9d5117faee5c78f9$var$write_record(ba, 0x0093 /* BrtWsProp */ , $9d5117faee5c78f9$var$write_BrtWsProp(c, ws['!outline']));
    $9d5117faee5c78f9$var$write_record(ba, 0x0094 /* BrtWsDim */ , $9d5117faee5c78f9$var$write_BrtWsDim(r));
    $9d5117faee5c78f9$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $9d5117faee5c78f9$var$write_WSFMTINFO(ba, ws);
    $9d5117faee5c78f9$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $9d5117faee5c78f9$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $9d5117faee5c78f9$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $9d5117faee5c78f9$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $9d5117faee5c78f9$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $9d5117faee5c78f9$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws['!margins']) $9d5117faee5c78f9$var$write_record(ba, 0x01DC /* BrtMargins */ , $9d5117faee5c78f9$var$write_BrtMargins(ws['!margins']));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $9d5117faee5c78f9$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $9d5117faee5c78f9$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $9d5117faee5c78f9$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $9d5117faee5c78f9$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $9d5117faee5c78f9$var$unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || [
        "",
        "General"
    ])[1]);
    (data.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(F) {
        f = F.replace(/<.*?>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $9d5117faee5c78f9$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ (data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(nc) {
        var cache = $9d5117faee5c78f9$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $9d5117faee5c78f9$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            if (cs["!data"]) {
                if (!cs["!data"][i]) cs["!data"][i] = [];
                cs["!data"][i][C] = {
                    t: 'n',
                    v: n,
                    z: cache[1]
                };
            } else cs[col + $9d5117faee5c78f9$var$encode_row(i)] = {
                t: 'n',
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $9d5117faee5c78f9$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $9d5117faee5c78f9$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($9d5117faee5c78f9$var$sheetprregex);
    if (sheetPr) $9d5117faee5c78f9$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s['!rel'] = m[1];
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
//	var o = [XML_HEADER, writextag('chartsheet', null, {
//		'xmlns': XMLNS_main[0],
//		'xmlns:r': XMLNS.r
//	})];
//	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
//	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
//	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
//	return o.join("");
//}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $9d5117faee5c78f9$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $9d5117faee5c78f9$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $9d5117faee5c78f9$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $9d5117faee5c78f9$var$recordhopper(data, function cs_parse(val, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s['!rel'] = val;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_bin(/*::idx:number, opts, wb:Workbook, rels*/) {
//	var ba = buf_array();
//	write_record(ba, 0x0081 /* BrtBeginSheet */);
//	/* [BrtCsProp] */
//	/* CSVIEWS */
//	/* [[BrtCsProtectionIso] BrtCsProtection] */
//	/* [USERCSVIEWS] */
//	/* [BrtMargins] */
//	/* [BrtCsPageSetup] */
//	/* [HEADERFOOTER] */
//	/* BrtDrawing */
//	/* [BrtLegacyDrawing] */
//	/* [BrtLegacyDrawingHF] */
//	/* [BrtBkHim] */
//	/* [WEBPUBITEMS] */
//	/* FRTCHARTSHEET */
//	write_record(ba, 0x0082 /* BrtEndSheet */);
//	return ba.end();
//}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $9d5117faee5c78f9$var$WBPropsDef = [
    [
        'allowRefreshQuery',
        false,
        "bool"
    ],
    [
        'autoCompressPictures',
        true,
        "bool"
    ],
    [
        'backupFile',
        false,
        "bool"
    ],
    [
        'checkCompatibility',
        false,
        "bool"
    ],
    [
        'CodeName',
        ''
    ],
    [
        'date1904',
        false,
        "bool"
    ],
    [
        'defaultThemeVersion',
        0,
        "int"
    ],
    [
        'filterPrivacy',
        false,
        "bool"
    ],
    [
        'hidePivotFieldList',
        false,
        "bool"
    ],
    [
        'promptedSolutions',
        false,
        "bool"
    ],
    [
        'publishItems',
        false,
        "bool"
    ],
    [
        'refreshAllConnections',
        false,
        "bool"
    ],
    [
        'saveExternalLinkValues',
        true,
        "bool"
    ],
    [
        'showBorderUnselectedTables',
        true,
        "bool"
    ],
    [
        'showInkAnnotation',
        true,
        "bool"
    ],
    [
        'showObjects',
        'all'
    ],
    [
        'showPivotChartFilter',
        false,
        "bool"
    ],
    [
        'updateLinks',
        'userSet'
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $9d5117faee5c78f9$var$WBViewDef = [
    [
        'activeTab',
        0,
        "int"
    ],
    [
        'autoFilterDateGrouping',
        true,
        "bool"
    ],
    [
        'firstSheet',
        0,
        "int"
    ],
    [
        'minimized',
        false,
        "bool"
    ],
    [
        'showHorizontalScroll',
        true,
        "bool"
    ],
    [
        'showSheetTabs',
        true,
        "bool"
    ],
    [
        'showVerticalScroll',
        true,
        "bool"
    ],
    [
        'tabRatio',
        600,
        "int"
    ],
    [
        'visibility',
        'visible'
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $9d5117faee5c78f9$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $9d5117faee5c78f9$var$CalcPrDef = [
    [
        'calcCompleted',
        'true'
    ],
    [
        'calcMode',
        'auto'
    ],
    [
        'calcOnSave',
        'true'
    ],
    [
        'concurrentCalc',
        'true'
    ],
    [
        'fullCalcOnLoad',
        'false'
    ],
    [
        'fullPrecision',
        'true'
    ],
    [
        'iterate',
        'false'
    ],
    [
        'iterateCount',
        '100'
    ],
    [
        'iterateDelta',
        '0.001'
    ],
    [
        'refMode',
        'A1'
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $9d5117faee5c78f9$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $9d5117faee5c78f9$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $9d5117faee5c78f9$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $9d5117faee5c78f9$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $9d5117faee5c78f9$var$parse_wb_defaults(wb) {
    $9d5117faee5c78f9$var$push_defaults(wb.WBProps, $9d5117faee5c78f9$var$WBPropsDef);
    $9d5117faee5c78f9$var$push_defaults(wb.CalcPr, $9d5117faee5c78f9$var$CalcPrDef);
    $9d5117faee5c78f9$var$push_defaults_array(wb.WBView, $9d5117faee5c78f9$var$WBViewDef);
    $9d5117faee5c78f9$var$push_defaults_array(wb.Sheets, $9d5117faee5c78f9$var$SheetDef);
    $9d5117faee5c78f9$var$_ssfopts.date1904 = $9d5117faee5c78f9$var$parsexmlbool(wb.WBProps.date1904);
}
function $9d5117faee5c78f9$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $9d5117faee5c78f9$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $9d5117faee5c78f9$var$badchars = /*#__PURE__*/ ":][*?\/\\".split("");
function $9d5117faee5c78f9$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    try {
        if (n == "") throw new Error("Sheet name cannot be blank");
        if (n.length > 31) throw new Error("Sheet name cannot exceed 31 chars");
        if (n.charCodeAt(0) == 0x27 || n.charCodeAt(n.length - 1) == 0x27) throw new Error("Sheet name cannot start or end with apostrophe (')");
        if (n.toLowerCase() == "history") throw new Error("Sheet name cannot be 'History'");
        $9d5117faee5c78f9$var$badchars.forEach(function(c) {
            if (n.indexOf(c) == -1) return;
            throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        });
    } catch (e) {
        if (safe) return false;
        throw e;
    }
    return true;
}
function $9d5117faee5c78f9$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $9d5117faee5c78f9$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $9d5117faee5c78f9$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $9d5117faee5c78f9$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$9d5117faee5c78f9$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
    wb.SheetNames.forEach(function(n, i) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!autofilter"]) return;
        var DN;
        if (!wb.Workbook) wb.Workbook = {};
        if (!wb.Workbook.Names) wb.Workbook.Names = [];
        wb.Workbook.Names.forEach(function(dn) {
            if (dn.Name == "_xlnm._FilterDatabase" && dn.Sheet == i) DN = dn;
        });
        var nn = $9d5117faee5c78f9$var$formula_quote_sheet_name(n) + "!" + $9d5117faee5c78f9$var$fix_range(ws["!autofilter"].ref);
        if (DN) DN.Ref = nn;
        else wb.Workbook.Names.push({
            Name: "_xlnm._FilterDatabase",
            Sheet: i,
            Ref: nn
        });
    });
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $9d5117faee5c78f9$var$wbnsregex = /<\w+:workbook/;
function $9d5117faee5c78f9$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($9d5117faee5c78f9$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $9d5117faee5c78f9$var$parsexmltag(x);
        switch($9d5117faee5c78f9$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case '<workbook':
                if (x.match($9d5117faee5c78f9$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case '</workbook>':
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case '<fileVersion':
                delete y[0];
                wb.AppVersion = y;
                break;
            case '<fileVersion/>':
            case '</fileVersion>':
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case '<fileSharing':
                break;
            case '<fileSharing/>':
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case '<workbookPr':
            case '<workbookPr/>':
                $9d5117faee5c78f9$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $9d5117faee5c78f9$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $9d5117faee5c78f9$var$utf8read(y.codeName);
                break;
            case '</workbookPr>':
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case '<workbookProtection':
                break;
            case '<workbookProtection/>':
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case '<bookViews':
            case '<bookViews>':
            case '</bookViews>':
                break;
            /* 18.2.30   workbookView CT_BookView + */ case '<workbookView':
            case '<workbookView/>':
                delete y[0];
                wb.WBView.push(y);
                break;
            case '</workbookView>':
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case '<sheets':
            case '<sheets>':
            case '</sheets>':
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case '<sheet':
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $9d5117faee5c78f9$var$unescapexml($9d5117faee5c78f9$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case '</sheet>':
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case '<functionGroups':
            case '<functionGroups/>':
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case '<functionGroup':
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case '<externalReferences':
            case '</externalReferences>':
            case '<externalReferences>':
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case '<externalReference':
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case '<definedNames/>':
                break;
            case '<definedNames>':
            case '<definedNames':
                pass = true;
                break;
            case '</definedNames>':
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case '<definedName':
                dname = {};
                dname.Name = $9d5117faee5c78f9$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($9d5117faee5c78f9$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case '</definedName>':
                dname.Ref = $9d5117faee5c78f9$var$unescapexml($9d5117faee5c78f9$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case '<definedName/>':
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case '<calcPr':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '<calcPr/>':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '</calcPr>':
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case '<oleSize':
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case '<customWorkbookViews>':
            case '</customWorkbookViews>':
            case '<customWorkbookViews':
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case '<customWorkbookView':
            case '</customWorkbookView>':
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case '<pivotCaches>':
            case '</pivotCaches>':
            case '<pivotCaches':
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case '<pivotCache':
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case '<smartTagPr':
            case '<smartTagPr/>':
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case '<smartTagTypes':
            case '<smartTagTypes>':
            case '</smartTagTypes>':
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case '<smartTagType':
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case '<webPublishing':
            case '<webPublishing/>':
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case '<fileRecoveryPr':
            case '<fileRecoveryPr/>':
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case '<webPublishObjects>':
            case '<webPublishObjects':
            case '</webPublishObjects>':
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case '<webPublishObject':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break; //TODO: check with versions of excel
            case '</ext>':
                pass = false;
                break;
            /* Others */ case '<ArchID':
                break;
            case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* TODO */ case '<revisionPtr':
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
        }
        return x;
    });
    if ($9d5117faee5c78f9$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $9d5117faee5c78f9$var$parse_wb_defaults(wb);
    return wb;
}
function $9d5117faee5c78f9$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $9d5117faee5c78f9$var$XML_HEADER
    ];
    o[o.length] = $9d5117faee5c78f9$var$writextag('workbook', null, {
        'xmlns': $9d5117faee5c78f9$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        'xmlns:r': $9d5117faee5c78f9$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $9d5117faee5c78f9$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $9d5117faee5c78f9$var$writextag('workbookPr', null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $9d5117faee5c78f9$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $9d5117faee5c78f9$var$writextag('sheet', null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $9d5117faee5c78f9$var$writextag('definedName', $9d5117faee5c78f9$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = '</workbook>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $9d5117faee5c78f9$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $9d5117faee5c78f9$var$parse_RelID(data, length - 8);
    z.name = $9d5117faee5c78f9$var$parse_XLWideString(data);
    return z;
}
function $9d5117faee5c78f9$var$write_BrtBundleSh(data, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $9d5117faee5c78f9$var$write_RelID(data.strRelID, o);
    $9d5117faee5c78f9$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $9d5117faee5c78f9$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $9d5117faee5c78f9$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $9d5117faee5c78f9$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(72);
    var flags = 0;
    if (data) {
        /* TODO: mirror parse_BrtWbProp fields */ if (data.date1904) flags |= 0x01;
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $9d5117faee5c78f9$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $9d5117faee5c78f9$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $9d5117faee5c78f9$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $9d5117faee5c78f9$var$parse_XLNameWideString(data);
    var formula = $9d5117faee5c78f9$var$parse_XLSBNameParsedFormula(data, 0, opts);
    var comment = $9d5117faee5c78f9$var$parse_XLNullableWideString(data);
    if (flags & 0x20) name = "_xlnm." + name;
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula,
        Flags: flags
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
function $9d5117faee5c78f9$var$write_BrtName(name, wb) {
    var o = $9d5117faee5c78f9$var$new_buf(9);
    var flags = 0;
    var dname = name.Name;
    if ($9d5117faee5c78f9$var$XLSLblBuiltIn.indexOf(dname) > -1) {
        flags |= 0x20;
        dname = dname.slice(6);
    }
    o.write_shift(4, flags); // flags
    o.write_shift(1, 0); // chKey
    o.write_shift(4, name.Sheet == null ? 0xFFFFFFFF : name.Sheet);
    var arr = [
        o,
        $9d5117faee5c78f9$var$write_XLWideString(dname),
        $9d5117faee5c78f9$var$write_XLSBNameParsedFormula(name.Ref, wb)
    ];
    if (name.Comment) arr.push($9d5117faee5c78f9$var$write_XLNullableWideString(name.Comment));
    else {
        var x = $9d5117faee5c78f9$var$new_buf(4);
        x.write_shift(4, 0xFFFFFFFF);
        arr.push(x);
    }
    // if macro (flags & 0x0F):
    // write_shift(4, 0xFFFFFFFF);
    // write_XLNullableWideString(description)
    // write_XLNullableWideString(helpTopic)
    // write_shift(4, 0xFFFFFFFF);
    return $9d5117faee5c78f9$var$bconcat(arr);
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $9d5117faee5c78f9$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $9d5117faee5c78f9$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $9d5117faee5c78f9$var$parse_BrtFRTArchID$
    };
    $9d5117faee5c78f9$var$recordhopper(data, function hopper_wb(val, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val.name);
                wb.Sheets.push(val);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val.Sheet != null) opts.SID = val.Sheet;
                val.Ref = $9d5117faee5c78f9$var$stringify_formula(val.Ptg, null, null, supbooks, opts);
                delete opts.SID;
                delete val.Ptg;
                Names.push(val);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val
                ];
                else supbooks.push([
                    RT,
                    val
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                supbooks.XTI = supbooks.XTI.concat(val);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $9d5117faee5c78f9$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $9d5117faee5c78f9$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $9d5117faee5c78f9$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: 'rId' + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $9d5117faee5c78f9$var$write_record(ba, 0x009C /* BrtBundleSh */ , $9d5117faee5c78f9$var$write_BrtBundleSh(d));
    }
    $9d5117faee5c78f9$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $9d5117faee5c78f9$var$write_BrtFileVersion(data, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $9d5117faee5c78f9$var$write_XLWideString("SheetJS", o);
    $9d5117faee5c78f9$var$write_XLWideString($9d5117faee5c78f9$var$XLSX.version, o);
    $9d5117faee5c78f9$var$write_XLWideString($9d5117faee5c78f9$var$XLSX.version, o);
    $9d5117faee5c78f9$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $9d5117faee5c78f9$var$write_BrtBookView(idx, o) {
    if (!o) o = $9d5117faee5c78f9$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $9d5117faee5c78f9$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $9d5117faee5c78f9$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $9d5117faee5c78f9$var$write_record(ba, 0x009E /* BrtBookView */ , $9d5117faee5c78f9$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $9d5117faee5c78f9$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
function $9d5117faee5c78f9$var$write_BRTNAMES(ba, wb) {
    if (!wb.Workbook || !wb.Workbook.Names) return;
    wb.Workbook.Names.forEach(function(name) {
        try {
            if (name.Flags & 0x0e) return; // TODO: macro name write
            $9d5117faee5c78f9$var$write_record(ba, 0x0027 /* BrtName */ , $9d5117faee5c78f9$var$write_BrtName(name, wb));
        } catch (e) {
            console.error("Could not serialize defined name " + JSON.stringify(name));
        }
    });
}
function $9d5117faee5c78f9$var$write_SELF_EXTERNS_xlsb(wb) {
    var L = wb.SheetNames.length;
    var o = $9d5117faee5c78f9$var$new_buf(12 * L + 28);
    o.write_shift(4, L + 2);
    o.write_shift(4, 0);
    o.write_shift(4, -2);
    o.write_shift(4, -2); // workbook-level reference
    o.write_shift(4, 0);
    o.write_shift(4, -1);
    o.write_shift(4, -1); // #REF!...
    for(var i = 0; i < L; ++i){
        o.write_shift(4, 0);
        o.write_shift(4, i);
        o.write_shift(4, i);
    }
    return o;
}
function $9d5117faee5c78f9$var$write_EXTERNALS_xlsb(ba, wb) {
    $9d5117faee5c78f9$var$write_record(ba, 0x0161 /* BrtBeginExternals */ );
    $9d5117faee5c78f9$var$write_record(ba, 0x0165 /* BrtSupSelf */ );
    $9d5117faee5c78f9$var$write_record(ba, 0x016A /* BrtExternSheet */ , $9d5117faee5c78f9$var$write_SELF_EXTERNS_xlsb(wb, 0));
    $9d5117faee5c78f9$var$write_record(ba, 0x0162 /* BrtEndExternals */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $9d5117faee5c78f9$var$write_wb_bin(wb, opts) {
    var ba = $9d5117faee5c78f9$var$buf_array();
    $9d5117faee5c78f9$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $9d5117faee5c78f9$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $9d5117faee5c78f9$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $9d5117faee5c78f9$var$write_record(ba, 0x0099 /* BrtWbProp */ , $9d5117faee5c78f9$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $9d5117faee5c78f9$var$write_BOOKVIEWS(ba, wb, opts);
    $9d5117faee5c78f9$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ $9d5117faee5c78f9$var$write_EXTERNALS_xlsb(ba, wb);
    if ((wb.Workbook || {}).Names) $9d5117faee5c78f9$var$write_BRTNAMES(ba, wb);
    /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $9d5117faee5c78f9$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $9d5117faee5c78f9$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $9d5117faee5c78f9$var$parse_wb_bin(data /*:any*/ , opts);
    return $9d5117faee5c78f9$var$parse_wb_xml(data /*:any*/ , opts);
}
function $9d5117faee5c78f9$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $9d5117faee5c78f9$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $9d5117faee5c78f9$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $9d5117faee5c78f9$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $9d5117faee5c78f9$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $9d5117faee5c78f9$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $9d5117faee5c78f9$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $9d5117faee5c78f9$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $9d5117faee5c78f9$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $9d5117faee5c78f9$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $9d5117faee5c78f9$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $9d5117faee5c78f9$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $9d5117faee5c78f9$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $9d5117faee5c78f9$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $9d5117faee5c78f9$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $9d5117faee5c78f9$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $9d5117faee5c78f9$var$parse_sst_bin(data /*:any*/ , opts);
    return $9d5117faee5c78f9$var$parse_sst_xml(data /*:any*/ , opts);
}
function $9d5117faee5c78f9$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $9d5117faee5c78f9$var$parse_comments_bin(data /*:any*/ , opts);
    return $9d5117faee5c78f9$var$parse_comments_xml(data /*:any*/ , opts);
}
function $9d5117faee5c78f9$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $9d5117faee5c78f9$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $9d5117faee5c78f9$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $9d5117faee5c78f9$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $9d5117faee5c78f9$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $9d5117faee5c78f9$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $9d5117faee5c78f9$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $9d5117faee5c78f9$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $9d5117faee5c78f9$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
var $9d5117faee5c78f9$var$attregexg2 = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $9d5117faee5c78f9$var$attregex2 = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $9d5117faee5c78f9$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($9d5117faee5c78f9$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($9d5117faee5c78f9$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $9d5117faee5c78f9$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($9d5117faee5c78f9$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($9d5117faee5c78f9$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $9d5117faee5c78f9$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $9d5117faee5c78f9$var$xlml_format(format, value) /*:string*/ {
    var fmt = $9d5117faee5c78f9$var$XLMLFormatMap[format] || $9d5117faee5c78f9$var$unescapexml(format);
    if (fmt === "General") return $9d5117faee5c78f9$var$SSF_general(value);
    return $9d5117faee5c78f9$var$SSF_format(fmt, value);
}
function $9d5117faee5c78f9$var$xlml_set_custprop(Custprops, key, cp, val /*:string*/ ) {
    var oval /*:any*/  = val;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $9d5117faee5c78f9$var$parsexmlbool(val);
            break;
        case "i2":
        case "int":
            oval = parseInt(val, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val);
            break;
        case "date":
        case "dateTime.tz":
            oval = $9d5117faee5c78f9$var$parseDate(val);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$9d5117faee5c78f9$var$unescapexml(key)] = oval;
}
function $9d5117faee5c78f9$var$safe_format_xlml(cell /*:Cell*/ , nf, o) {
    if (cell.t === 'z') return;
    if (!o || o.cellText !== false) try {
        if (cell.t === 'e') cell.w = cell.w || $9d5117faee5c78f9$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === 'n') {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $9d5117faee5c78f9$var$SSF_general_num(cell.v);
            } else cell.w = $9d5117faee5c78f9$var$SSF_general(cell.v);
        } else cell.w = $9d5117faee5c78f9$var$xlml_format(nf || "General", cell.v);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $9d5117faee5c78f9$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == 'n' && $9d5117faee5c78f9$var$fmt_is_date(z)) {
            var _d = $9d5117faee5c78f9$var$SSF_parse_date_code(cell.v);
            if (_d) {
                cell.t = 'd';
                cell.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $9d5117faee5c78f9$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $9d5117faee5c78f9$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $9d5117faee5c78f9$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        if (styles[sid].nf) nf = styles[sid].nf;
        if (styles[sid].Interior) interiors.push(styles[sid].Interior);
        if (!styles[sid].Parent) break;
        sid = styles[sid].Parent;
    }
    switch(data.Type){
        case 'Boolean':
            cell.t = 'b';
            cell.v = $9d5117faee5c78f9$var$parsexmlbool(xml);
            break;
        case 'String':
            cell.t = 's';
            cell.r = $9d5117faee5c78f9$var$xlml_fixstr($9d5117faee5c78f9$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $9d5117faee5c78f9$var$unescapexml(ss || xml).replace(/<.*?>/g, "") : cell.r; // todo: BR etc
            break;
        case 'DateTime':
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = ($9d5117faee5c78f9$var$parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / 86400000;
            if (cell.v !== cell.v) cell.v = $9d5117faee5c78f9$var$unescapexml(xml);
            else if (cell.v < 60) cell.v = cell.v - 1;
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case 'Number':
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = 'n';
            break;
        case 'Error':
            cell.t = 'e';
            cell.v = $9d5117faee5c78f9$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = 'z';
            else {
                cell.t = 's';
                cell.v = $9d5117faee5c78f9$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $9d5117faee5c78f9$var$safe_format_xlml(cell, nf, o);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $9d5117faee5c78f9$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $9d5117faee5c78f9$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $9d5117faee5c78f9$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $9d5117faee5c78f9$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $9d5117faee5c78f9$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $9d5117faee5c78f9$var$xlml_prefix_dname(dname) {
    return $9d5117faee5c78f9$var$XLSLblBuiltIn.indexOf("_xlnm." + dname) > -1 ? "_xlnm." + dname : dname;
}
function $9d5117faee5c78f9$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $9d5117faee5c78f9$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $9d5117faee5c78f9$var$make_ssf();
    var str = $9d5117faee5c78f9$var$debom($9d5117faee5c78f9$var$xlml_normalize(d));
    if (opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
        if (typeof $9d5117faee5c78f9$var$$cptable !== 'undefined') str = $9d5117faee5c78f9$var$$cptable.utils.decode(65001, $9d5117faee5c78f9$var$char_codes(str));
        else str = $9d5117faee5c78f9$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $9d5117faee5c78f9$var$dup(opts);
        _o.type = "string";
        return $9d5117faee5c78f9$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $9d5117faee5c78f9$var$html_to_workbook(str, opts);
    $9d5117faee5c78f9$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $9d5117faee5c78f9$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $9d5117faee5c78f9$var$table_fmt[15],
        "Short Date": $9d5117faee5c78f9$var$table_fmt[14],
        "Long Time": $9d5117faee5c78f9$var$table_fmt[19],
        "Medium Time": $9d5117faee5c78f9$var$table_fmt[18],
        "Short Time": $9d5117faee5c78f9$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $9d5117faee5c78f9$var$table_fmt[2],
        "Standard": $9d5117faee5c78f9$var$table_fmt[4],
        "Percent": $9d5117faee5c78f9$var$table_fmt[10],
        "Scientific": $9d5117faee5c78f9$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($9d5117faee5c78f9$var$DENSE != null && opts.dense == null) opts.dense = $9d5117faee5c78f9$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = {}, sheetname = "";
    if (opts.dense) cursheet["!data"] = [];
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $9d5117faee5c78f9$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $9d5117faee5c78f9$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "");
    var raw_Rn3 = "";
    while(Rn = $9d5117faee5c78f9$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case 'data' /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === '/') $9d5117faee5c78f9$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts);
            else {
                ss = "";
                dtag = $9d5117faee5c78f9$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case 'cell' /*case 'Cell'*/ :
            if (Rn[1] === '/') {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== void 0) {
                    if (opts.dense) {
                        if (!cursheet["!data"][r]) cursheet["!data"][r] = [];
                        cursheet["!data"][r][c] = cell;
                    } else cursheet[$9d5117faee5c78f9$var$encode_col(c) + $9d5117faee5c78f9$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $9d5117faee5c78f9$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    if (cc > c || rr > r) merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet["!data"][cmd]) cursheet["!data"][cmd] = [];
                                cursheet["!data"][cmd][cma] = {
                                    t: 'z'
                                };
                            } else cursheet[$9d5117faee5c78f9$var$encode_col(cma) + $9d5117faee5c78f9$var$encode_row(cmd)] = {
                                t: 'z'
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $9d5117faee5c78f9$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case 'row' /*case 'Row'*/ :
            if (Rn[1] === '/' || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $9d5117faee5c78f9$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $9d5117faee5c78f9$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $9d5117faee5c78f9$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case 'worksheet' /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $9d5117faee5c78f9$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $9d5117faee5c78f9$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $9d5117faee5c78f9$var$xlml_parsexmltag(Rn[0]);
                sheetname = $9d5117faee5c78f9$var$unescapexml(tmp.Name);
                cursheet = {};
                if (opts.dense) cursheet["!data"] = [];
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case 'table' /*case 'Table'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case 'style' /*case 'Style'*/ :
            if (Rn[1] === '/') $9d5117faee5c78f9$var$process_style_xlml(styles, stag, opts);
            else stag = $9d5117faee5c78f9$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'numberformat' /*case 'NumberFormat'*/ :
            stag.nf = $9d5117faee5c78f9$var$unescapexml($9d5117faee5c78f9$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($9d5117faee5c78f9$var$XLMLFormatMap[stag.nf]) stag.nf = $9d5117faee5c78f9$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($9d5117faee5c78f9$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($9d5117faee5c78f9$var$table_fmt[ssfidx] == null) {
                    $9d5117faee5c78f9$var$SSF__load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case 'column' /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ 'table') break;
            if (Rn[1] === '/') break;
            csty = $9d5117faee5c78f9$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $9d5117faee5c78f9$var$MDW = $9d5117faee5c78f9$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $9d5117faee5c78f9$var$process_col(cstys[_col]);
            }
            if (seencol) $9d5117faee5c78f9$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $9d5117faee5c78f9$var$dup(csty);
            break;
        case 'namedrange' /*case 'NamedRange'*/ :
            if (Rn[1] === '/') break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $9d5117faee5c78f9$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: $9d5117faee5c78f9$var$xlml_prefix_dname(_NamedRange.Name),
                Ref: $9d5117faee5c78f9$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case 'namedcell' /*case 'NamedCell'*/ :
            break;
        case 'b' /*case 'B'*/ :
            break;
        case 'i' /*case 'I'*/ :
            break;
        case 'u' /*case 'U'*/ :
            break;
        case 's' /*case 'S'*/ :
            break;
        case 'em' /*case 'EM'*/ :
            break;
        case 'h2' /*case 'H2'*/ :
            break;
        case 'h3' /*case 'H3'*/ :
            break;
        case 'sub' /*case 'Sub'*/ :
            break;
        case 'sup' /*case 'Sup'*/ :
            break;
        case 'span' /*case 'Span'*/ :
            break;
        case 'alignment' /*case 'Alignment'*/ :
            break;
        case 'borders' /*case 'Borders'*/ :
            break;
        case 'border' /*case 'Border'*/ :
            break;
        case 'font' /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case 'interior' /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $9d5117faee5c78f9$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'protection' /*case 'Protection'*/ :
            break;
        case 'author' /*case 'Author'*/ :
        case 'title' /*case 'Title'*/ :
        case 'description' /*case 'Description'*/ :
        case 'created' /*case 'Created'*/ :
        case 'keywords' /*case 'Keywords'*/ :
        case 'subject' /*case 'Subject'*/ :
        case 'category' /*case 'Category'*/ :
        case 'company' /*case 'Company'*/ :
        case 'lastauthor' /*case 'LastAuthor'*/ :
        case 'lastsaved' /*case 'LastSaved'*/ :
        case 'lastprinted' /*case 'LastPrinted'*/ :
        case 'version' /*case 'Version'*/ :
        case 'revision' /*case 'Revision'*/ :
        case 'totaltime' /*case 'TotalTime'*/ :
        case 'hyperlinkbase' /*case 'HyperlinkBase'*/ :
        case 'manager' /*case 'Manager'*/ :
        case 'contentstatus' /*case 'ContentStatus'*/ :
        case 'identifier' /*case 'Identifier'*/ :
        case 'language' /*case 'Language'*/ :
        case 'appname' /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $9d5117faee5c78f9$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'paragraphs' /*case 'Paragraphs'*/ :
            break;
        case 'styles' /*case 'Styles'*/ :
        case 'workbook' /*case 'Workbook'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case 'comment' /*case 'Comment'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $9d5117faee5c78f9$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $9d5117faee5c78f9$var$xlml_parsexmltag(Rn[0]);
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case 'autofilter' /*case 'AutoFilter'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                var AutoFilter = $9d5117faee5c78f9$var$xlml_parsexmltag(Rn[0]);
                cursheet['!autofilter'] = {
                    ref: $9d5117faee5c78f9$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case 'name' /*case 'Name'*/ :
            break;
        case 'datavalidation' /*case 'DataValidation'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'pixelsperinch' /*case 'PixelsPerInch'*/ :
            break;
        case 'componentoptions' /*case 'ComponentOptions'*/ :
        case 'documentproperties' /*case 'DocumentProperties'*/ :
        case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/ :
        case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
        case 'pivottable' /*case 'PivotTable'*/ :
        case 'pivotcache' /*case 'PivotCache'*/ :
        case 'names' /*case 'Names'*/ :
        case 'mapinfo' /*case 'MapInfo'*/ :
        case 'pagebreaks' /*case 'PageBreaks'*/ :
        case 'querytable' /*case 'QueryTable'*/ :
        case 'sorting' /*case 'Sorting'*/ :
        case 'schema' /*case 'Schema'*/ :
        case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
        case 'smarttagtype' /*case 'SmartTagType'*/ :
        case 'smarttags' /*case 'SmartTags'*/ :
        case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
        case 'workbookoptions' /*case 'WorkbookOptions'*/ :
        case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'null' /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $9d5117faee5c78f9$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $9d5117faee5c78f9$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case 'allowpng' /*case 'AllowPNG'*/ :
                            break;
                        case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/ :
                            break;
                        case 'downloadcomponents' /*case 'DownloadComponents'*/ :
                            break;
                        case 'locationofcomponents' /*case 'LocationOfComponents'*/ :
                            break;
                        case 'colors' /*case 'Colors'*/ :
                            break;
                        case 'color' /*case 'Color'*/ :
                            break;
                        case 'index' /*case 'Index'*/ :
                            break;
                        case 'rgb' /*case 'RGB'*/ :
                            break;
                        case 'targetscreensize' /*case 'TargetScreenSize'*/ :
                            break;
                        case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case 'componentoptions' /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case 'toolbar' /*case 'Toolbar'*/ :
                            break;
                        case 'hideofficelogo' /*case 'HideOfficeLogo'*/ :
                            break;
                        case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case 'label' /*case 'Label'*/ :
                            break;
                        case 'caption' /*case 'Caption'*/ :
                            break;
                        case 'maxheight' /*case 'MaxHeight'*/ :
                            break;
                        case 'maxwidth' /*case 'MaxWidth'*/ :
                            break;
                        case 'nextsheetnumber' /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case 'date1904' /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case 'windowheight' /*case 'WindowHeight'*/ :
                            break;
                        case 'windowwidth' /*case 'WindowWidth'*/ :
                            break;
                        case 'windowtopx' /*case 'WindowTopX'*/ :
                            break;
                        case 'windowtopy' /*case 'WindowTopY'*/ :
                            break;
                        case 'tabratio' /*case 'TabRatio'*/ :
                            break;
                        case 'protectstructure' /*case 'ProtectStructure'*/ :
                            break;
                        case 'protectwindow' /*case 'ProtectWindow'*/ :
                            break;
                        case 'protectwindows' /*case 'ProtectWindows'*/ :
                            break;
                        case 'activesheet' /*case 'ActiveSheet'*/ :
                            break;
                        case 'displayinknotes' /*case 'DisplayInkNotes'*/ :
                            break;
                        case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/ :
                            break;
                        case 'supbook' /*case 'SupBook'*/ :
                            break;
                        case 'sheetname' /*case 'SheetName'*/ :
                            break;
                        case 'sheetindex' /*case 'SheetIndex'*/ :
                            break;
                        case 'sheetindexfirst' /*case 'SheetIndexFirst'*/ :
                            break;
                        case 'sheetindexlast' /*case 'SheetIndexLast'*/ :
                            break;
                        case 'dll' /*case 'Dll'*/ :
                            break;
                        case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case 'iteration' /*case 'Iteration'*/ :
                            break;
                        case 'maxiterations' /*case 'MaxIterations'*/ :
                            break;
                        case 'maxchange' /*case 'MaxChange'*/ :
                            break;
                        case 'path' /*case 'Path'*/ :
                            break;
                        case 'xct' /*case 'Xct'*/ :
                            break;
                        case 'count' /*case 'Count'*/ :
                            break;
                        case 'selectedsheets' /*case 'SelectedSheets'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        case 'uncalced' /*case 'Uncalced'*/ :
                            break;
                        case 'startupprompt' /*case 'StartupPrompt'*/ :
                            break;
                        case 'crn' /*case 'Crn'*/ :
                            break;
                        case 'externname' /*case 'ExternName'*/ :
                            break;
                        case 'formula' /*case 'Formula'*/ :
                            break;
                        case 'colfirst' /*case 'ColFirst'*/ :
                            break;
                        case 'collast' /*case 'ColLast'*/ :
                            break;
                        case 'wantadvise' /*case 'WantAdvise'*/ :
                            break;
                        case 'boolean' /*case 'Boolean'*/ :
                            break;
                        case 'error' /*case 'Error'*/ :
                            break;
                        case 'text' /*case 'Text'*/ :
                            break;
                        case 'ole' /*case 'OLE'*/ :
                            break;
                        case 'noautorecover' /*case 'NoAutoRecover'*/ :
                            break;
                        case 'publishobjects' /*case 'PublishObjects'*/ :
                            break;
                        case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'refmoder1c1' /*case 'RefModeR1C1'*/ :
                            break;
                        case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case 'workbookoptions' /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case 'owcversion' /*case 'OWCVersion'*/ :
                            break;
                        case 'height' /*case 'Height'*/ :
                            break;
                        case 'width' /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case 'visible' /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case 'header' /*case 'Header'*/ :
                            if (!cursheet['!margins']) $9d5117faee5c78f9$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$9d5117faee5c78f9$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +$9d5117faee5c78f9$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'footer' /*case 'Footer'*/ :
                            if (!cursheet['!margins']) $9d5117faee5c78f9$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$9d5117faee5c78f9$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +$9d5117faee5c78f9$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'pagemargins' /*case 'PageMargins'*/ :
                            var pagemargins = $9d5117faee5c78f9$var$parsexmltag(Rn[0]);
                            if (!cursheet['!margins']) $9d5117faee5c78f9$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
                            break;
                        case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case 'freezepanes' /*case 'FreezePanes'*/ :
                            break;
                        case 'frozennosplit' /*case 'FrozenNoSplit'*/ :
                            break;
                        case 'splithorizontal' /*case 'SplitHorizontal'*/ :
                        case 'splitvertical' /*case 'SplitVertical'*/ :
                            break;
                        case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case 'activerow' /*case 'ActiveRow'*/ :
                            break;
                        case 'activecol' /*case 'ActiveCol'*/ :
                            break;
                        case 'toprowbottompane' /*case 'TopRowBottomPane'*/ :
                            break;
                        case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/ :
                            break;
                        case 'unsynced' /*case 'Unsynced'*/ :
                            break;
                        case 'print' /*case 'Print'*/ :
                            break;
                        case 'printerrors' /*case 'PrintErrors'*/ :
                            break;
                        case 'panes' /*case 'Panes'*/ :
                            break;
                        case 'scale' /*case 'Scale'*/ :
                            break;
                        case 'pane' /*case 'Pane'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'layout' /*case 'Layout'*/ :
                            break;
                        case 'pagesetup' /*case 'PageSetup'*/ :
                            break;
                        case 'selected' /*case 'Selected'*/ :
                            break;
                        case 'protectobjects' /*case 'ProtectObjects'*/ :
                            break;
                        case 'enableselection' /*case 'EnableSelection'*/ :
                            break;
                        case 'protectscenarios' /*case 'ProtectScenarios'*/ :
                            break;
                        case 'validprinterinfo' /*case 'ValidPrinterInfo'*/ :
                            break;
                        case 'horizontalresolution' /*case 'HorizontalResolution'*/ :
                            break;
                        case 'verticalresolution' /*case 'VerticalResolution'*/ :
                            break;
                        case 'numberofcopies' /*case 'NumberofCopies'*/ :
                            break;
                        case 'activepane' /*case 'ActivePane'*/ :
                            break;
                        case 'toprowvisible' /*case 'TopRowVisible'*/ :
                            break;
                        case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/ :
                            break;
                        case 'fittopage' /*case 'FitToPage'*/ :
                            break;
                        case 'rangeselection' /*case 'RangeSelection'*/ :
                            break;
                        case 'papersizeindex' /*case 'PaperSizeIndex'*/ :
                            break;
                        case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/ :
                            break;
                        case 'pagebreakzoom' /*case 'PageBreakZoom'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'fitwidth' /*case 'FitWidth'*/ :
                            break;
                        case 'fitheight' /*case 'FitHeight'*/ :
                            break;
                        case 'commentslayout' /*case 'CommentsLayout'*/ :
                            break;
                        case 'zoom' /*case 'Zoom'*/ :
                            break;
                        case 'lefttoright' /*case 'LeftToRight'*/ :
                            break;
                        case 'gridlines' /*case 'Gridlines'*/ :
                            break;
                        case 'allowsort' /*case 'AllowSort'*/ :
                            break;
                        case 'allowfilter' /*case 'AllowFilter'*/ :
                            break;
                        case 'allowinsertrows' /*case 'AllowInsertRows'*/ :
                            break;
                        case 'allowdeleterows' /*case 'AllowDeleteRows'*/ :
                            break;
                        case 'allowinsertcols' /*case 'AllowInsertCols'*/ :
                            break;
                        case 'allowdeletecols' /*case 'AllowDeleteCols'*/ :
                            break;
                        case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case 'allowformatcells' /*case 'AllowFormatCells'*/ :
                            break;
                        case 'allowsizecols' /*case 'AllowSizeCols'*/ :
                            break;
                        case 'allowsizerows' /*case 'AllowSizeRows'*/ :
                            break;
                        case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case 'tabcolorindex' /*case 'TabColorIndex'*/ :
                            break;
                        case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case 'blackandwhite' /*case 'BlackAndWhite'*/ :
                            break;
                        case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case 'displaypagebreak' /*case 'DisplayPageBreak'*/ :
                            break;
                        case 'rowcolheadings' /*case 'RowColHeadings'*/ :
                            break;
                        case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case 'noorientation' /*case 'NoOrientation'*/ :
                            break;
                        case 'allowusepivottables' /*case 'AllowUsePivotTables'*/ :
                            break;
                        case 'zeroheight' /*case 'ZeroHeight'*/ :
                            break;
                        case 'viewablerange' /*case 'ViewableRange'*/ :
                            break;
                        case 'selection' /*case 'Selection'*/ :
                            break;
                        case 'protectcontents' /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case 'pivottable' /*case 'PivotTable'*/ :
                case 'pivotcache' /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case 'compactrowindent' /*case 'CompactRowIndent'*/ :
                            break;
                        case 'location' /*case 'Location'*/ :
                            break;
                        case 'pivotfield' /*case 'PivotField'*/ :
                            break;
                        case 'orientation' /*case 'Orientation'*/ :
                            break;
                        case 'layoutform' /*case 'LayoutForm'*/ :
                            break;
                        case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case 'layoutcompactrow' /*case 'LayoutCompactRow'*/ :
                            break;
                        case 'position' /*case 'Position'*/ :
                            break;
                        case 'pivotitem' /*case 'PivotItem'*/ :
                            break;
                        case 'datatype' /*case 'DataType'*/ :
                            break;
                        case 'datafield' /*case 'DataField'*/ :
                            break;
                        case 'sourcename' /*case 'SourceName'*/ :
                            break;
                        case 'parentfield' /*case 'ParentField'*/ :
                            break;
                        case 'ptlineitems' /*case 'PTLineItems'*/ :
                            break;
                        case 'ptlineitem' /*case 'PTLineItem'*/ :
                            break;
                        case 'countofsameitems' /*case 'CountOfSameItems'*/ :
                            break;
                        case 'item' /*case 'Item'*/ :
                            break;
                        case 'itemtype' /*case 'ItemType'*/ :
                            break;
                        case 'ptsource' /*case 'PTSource'*/ :
                            break;
                        case 'cacheindex' /*case 'CacheIndex'*/ :
                            break;
                        case 'consolidationreference' /*case 'ConsolidationReference'*/ :
                            break;
                        case 'filename' /*case 'FileName'*/ :
                            break;
                        case 'reference' /*case 'Reference'*/ :
                            break;
                        case 'nocolumngrand' /*case 'NoColumnGrand'*/ :
                            break;
                        case 'norowgrand' /*case 'NoRowGrand'*/ :
                            break;
                        case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/ :
                            break;
                        case 'hidden' /*case 'Hidden'*/ :
                            break;
                        case 'subtotal' /*case 'Subtotal'*/ :
                            break;
                        case 'basefield' /*case 'BaseField'*/ :
                            break;
                        case 'mapchilditems' /*case 'MapChildItems'*/ :
                            break;
                        case 'function' /*case 'Function'*/ :
                            break;
                        case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case 'printsettitles' /*case 'PrintSetTitles'*/ :
                            break;
                        case 'mergelabels' /*case 'MergeLabels'*/ :
                            break;
                        case 'defaultversion' /*case 'DefaultVersion'*/ :
                            break;
                        case 'refreshname' /*case 'RefreshName'*/ :
                            break;
                        case 'refreshdate' /*case 'RefreshDate'*/ :
                            break;
                        case 'refreshdatecopy' /*case 'RefreshDateCopy'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        case 'versionlastupdate' /*case 'VersionLastUpdate'*/ :
                            break;
                        case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/ :
                            break;
                        case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case 'pagebreaks' /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case 'colbreaks' /*case 'ColBreaks'*/ :
                            break;
                        case 'colbreak' /*case 'ColBreak'*/ :
                            break;
                        case 'rowbreaks' /*case 'RowBreaks'*/ :
                            break;
                        case 'rowbreak' /*case 'RowBreak'*/ :
                            break;
                        case 'colstart' /*case 'ColStart'*/ :
                            break;
                        case 'colend' /*case 'ColEnd'*/ :
                            break;
                        case 'rowend' /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case 'autofilter' /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case 'autofiltercolumn' /*case 'AutoFilterColumn'*/ :
                            break;
                        case 'autofiltercondition' /*case 'AutoFilterCondition'*/ :
                            break;
                        case 'autofilterand' /*case 'AutoFilterAnd'*/ :
                            break;
                        case 'autofilteror' /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case 'querytable' /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case 'id' /*case 'Id'*/ :
                            break;
                        case 'autoformatfont' /*case 'AutoFormatFont'*/ :
                            break;
                        case 'autoformatpattern' /*case 'AutoFormatPattern'*/ :
                            break;
                        case 'querysource' /*case 'QuerySource'*/ :
                            break;
                        case 'querytype' /*case 'QueryType'*/ :
                            break;
                        case 'enableredirections' /*case 'EnableRedirections'*/ :
                            break;
                        case 'refreshedinxl9' /*case 'RefreshedInXl9'*/ :
                            break;
                        case 'urlstring' /*case 'URLString'*/ :
                            break;
                        case 'htmltables' /*case 'HTMLTables'*/ :
                            break;
                        case 'connection' /*case 'Connection'*/ :
                            break;
                        case 'commandtext' /*case 'CommandText'*/ :
                            break;
                        case 'refreshinfo' /*case 'RefreshInfo'*/ :
                            break;
                        case 'notitles' /*case 'NoTitles'*/ :
                            break;
                        case 'nextid' /*case 'NextId'*/ :
                            break;
                        case 'columninfo' /*case 'ColumnInfo'*/ :
                            break;
                        case 'overwritecells' /*case 'OverwriteCells'*/ :
                            break;
                        case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/ :
                            break;
                        case 'textwizardsettings' /*case 'TextWizardSettings'*/ :
                            break;
                        case 'source' /*case 'Source'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'decimal' /*case 'Decimal'*/ :
                            break;
                        case 'thousandseparator' /*case 'ThousandSeparator'*/ :
                            break;
                        case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case 'formatsettings' /*case 'FormatSettings'*/ :
                            break;
                        case 'fieldtype' /*case 'FieldType'*/ :
                            break;
                        case 'delimiters' /*case 'Delimiters'*/ :
                            break;
                        case 'tab' /*case 'Tab'*/ :
                            break;
                        case 'comma' /*case 'Comma'*/ :
                            break;
                        case 'autoformatname' /*case 'AutoFormatName'*/ :
                            break;
                        case 'versionlastedit' /*case 'VersionLastEdit'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'datavalidation' /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'sorting' /*case 'Sorting'*/ :
                case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case 'mapinfo' /*case 'MapInfo'*/ :
                case 'schema' /*case 'Schema'*/ :
                case 'data' /*case 'data'*/ :
                    switch(Rn[3]){
                        case 'map' /*case 'Map'*/ :
                            break;
                        case 'entry' /*case 'Entry'*/ :
                            break;
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'xpath' /*case 'XPath'*/ :
                            break;
                        case 'field' /*case 'Field'*/ :
                            break;
                        case 'xsdtype' /*case 'XSDType'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'aggregate' /*case 'Aggregate'*/ :
                            break;
                        case 'elementtype' /*case 'ElementType'*/ :
                            break;
                        case 'attributetype' /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case 'schema' /*case 'schema'*/ :
                        case 'element' /*case 'element'*/ :
                        case 'complextype' /*case 'complexType'*/ :
                        case 'datatype' /*case 'datatype'*/ :
                        case 'all' /*case 'all'*/ :
                        case 'attribute' /*case 'attribute'*/ :
                        case 'extends' /*case 'extends'*/ :
                            break;
                        case 'row' /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case 'smarttags' /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ 'customdocumentproperties') {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $9d5117faee5c78f9$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $9d5117faee5c78f9$var$dup($9d5117faee5c78f9$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    out.bookType = "xlml";
    return out;
}
function $9d5117faee5c78f9$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $9d5117faee5c78f9$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $9d5117faee5c78f9$var$parse_xlml_xml($9d5117faee5c78f9$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $9d5117faee5c78f9$var$parse_xlml_xml(data, opts);
        case "array":
            return $9d5117faee5c78f9$var$parse_xlml_xml($9d5117faee5c78f9$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $9d5117faee5c78f9$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($9d5117faee5c78f9$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($9d5117faee5c78f9$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $9d5117faee5c78f9$var$write_wb_xlml(wb /*::, opts*/ ) /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ if ((((wb || {}).Workbook || {}).WBProps || {}).date1904) return '<ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"><Date1904/></ExcelWorkbook>';
    return "";
}
/* TODO */ function $9d5117faee5c78f9$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($9d5117faee5c78f9$var$writextag('NumberFormat', null, {
            "ss:Format": $9d5117faee5c78f9$var$escapexml($9d5117faee5c78f9$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($9d5117faee5c78f9$var$writextag('Style', payload.join(""), o));
    });
    return $9d5117faee5c78f9$var$writextag("Styles", styles.join(""));
}
function $9d5117faee5c78f9$var$write_name_xlml(n) {
    return $9d5117faee5c78f9$var$writextag("NamedRange", null, {
        "ss:Name": n.Name.slice(0, 6) == "_xlnm." ? n.Name.slice(6) : n.Name,
        "ss:RefersTo": "=" + $9d5117faee5c78f9$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $9d5117faee5c78f9$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($9d5117faee5c78f9$var$write_name_xlml(n));
    }
    return $9d5117faee5c78f9$var$writextag("Names", out.join(""));
}
function $9d5117faee5c78f9$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($9d5117faee5c78f9$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $9d5117faee5c78f9$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws['!margins']) {
        o.push("<PageSetup>");
        if (ws['!margins'].header) o.push($9d5117faee5c78f9$var$writextag("Header", null, {
            'x:Margin': ws['!margins'].header
        }));
        if (ws['!margins'].footer) o.push($9d5117faee5c78f9$var$writextag("Footer", null, {
            'x:Margin': ws['!margins'].footer
        }));
        o.push($9d5117faee5c78f9$var$writextag("PageMargins", null, {
            'x:Bottom': ws['!margins'].bottom || "0.75",
            'x:Left': ws['!margins'].left || "0.7",
            'x:Right': ws['!margins'].right || "0.7",
            'x:Top': ws['!margins'].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($9d5117faee5c78f9$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws['!protect']) {
        o.push($9d5117faee5c78f9$var$writetag("ProtectContents", "True"));
        if (ws['!protect'].objects) o.push($9d5117faee5c78f9$var$writetag("ProtectObjects", "True"));
        if (ws['!protect'].scenarios) o.push($9d5117faee5c78f9$var$writetag("ProtectScenarios", "True"));
        if (ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push($9d5117faee5c78f9$var$writetag("EnableSelection", "NoSelection"));
        else if (ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push($9d5117faee5c78f9$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws['!protect'][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $9d5117faee5c78f9$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $9d5117faee5c78f9$var$XLMLNS.x
    });
}
function $9d5117faee5c78f9$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    return comments.map(function(c) {
        // TODO: formatted text
        var t = $9d5117faee5c78f9$var$xlml_unfixstr(c.t || "");
        var d = $9d5117faee5c78f9$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        return $9d5117faee5c78f9$var$writextag("Comment", d, {
            "ss:Author": c.a
        });
    }).join("");
}
function $9d5117faee5c78f9$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $9d5117faee5c78f9$var$escapexml($9d5117faee5c78f9$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $9d5117faee5c78f9$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $9d5117faee5c78f9$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $9d5117faee5c78f9$var$escapexml(cell.l.Tooltip);
    }
    if (ws['!merges']) {
        var marr = ws['!merges'];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case 'z':
            if (!opts.sheetStubs) return "";
            break;
        case 'n':
            t = 'Number';
            p = String(cell.v);
            break;
        case 'b':
            t = 'Boolean';
            p = cell.v ? "1" : "0";
            break;
        case 'e':
            t = 'Error';
            p = $9d5117faee5c78f9$var$BErr[cell.v];
            break;
        case 'd':
            t = 'DateTime';
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $9d5117faee5c78f9$var$table_fmt[14];
            break;
        case 's':
            t = 'String';
            p = $9d5117faee5c78f9$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $9d5117faee5c78f9$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == 'z' ? "" : '<Data ss:Type="' + t + '">' + _v + '</Data>';
    if ((cell.c || []).length > 0) m += $9d5117faee5c78f9$var$write_ws_xlml_comment(cell.c);
    return $9d5117faee5c78f9$var$writextag("Cell", m, attr);
}
function $9d5117faee5c78f9$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $9d5117faee5c78f9$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + '>';
}
/* TODO */ function $9d5117faee5c78f9$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws['!ref']) return "";
    var range /*:Range*/  = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref']);
    var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
        $9d5117faee5c78f9$var$process_col(n);
        var w = !!n.width;
        var p = $9d5117faee5c78f9$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k['ss:Width'] = $9d5117faee5c78f9$var$width2px(p.width);
        if (n.hidden) k['ss:Hidden'] = "1";
        o.push($9d5117faee5c78f9$var$writextag("Column", null, k));
    });
    var dense = ws["!data"] != null;
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $9d5117faee5c78f9$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
        ];
        for(var C = range.s.c; C <= range.e.c; ++C){
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var addr = {
                r: R,
                c: C
            };
            var ref = $9d5117faee5c78f9$var$encode_col(C) + $9d5117faee5c78f9$var$encode_row(R), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            row.push($9d5117faee5c78f9$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $9d5117faee5c78f9$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $9d5117faee5c78f9$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $9d5117faee5c78f9$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($9d5117faee5c78f9$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    if (ws["!autofilter"]) o.push('<AutoFilter x:Range="' + $9d5117faee5c78f9$var$a1_to_rc($9d5117faee5c78f9$var$fix_range(ws["!autofilter"].ref), {
        r: 0,
        c: 0
    }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
    return o.join("");
}
function $9d5117faee5c78f9$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $9d5117faee5c78f9$var$dup($9d5117faee5c78f9$var$table_fmt);
    if (wb.SSF) {
        $9d5117faee5c78f9$var$make_ssf();
        $9d5117faee5c78f9$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $9d5117faee5c78f9$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $9d5117faee5c78f9$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($9d5117faee5c78f9$var$write_props_xlml(wb, opts));
    d.push($9d5117faee5c78f9$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push("");
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($9d5117faee5c78f9$var$writextag("Worksheet", $9d5117faee5c78f9$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $9d5117faee5c78f9$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $9d5117faee5c78f9$var$write_sty_xlml(wb, opts);
    d[3] = $9d5117faee5c78f9$var$write_names_xlml(wb, opts);
    return $9d5117faee5c78f9$var$XML_HEADER + $9d5117faee5c78f9$var$writextag("Workbook", d.join(""), {
        'xmlns': $9d5117faee5c78f9$var$XLMLNS.ss,
        'xmlns:o': $9d5117faee5c78f9$var$XLMLNS.o,
        'xmlns:x': $9d5117faee5c78f9$var$XLMLNS.x,
        'xmlns:ss': $9d5117faee5c78f9$var$XLMLNS.ss,
        'xmlns:dt': $9d5117faee5c78f9$var$XLMLNS.dt,
        'xmlns:html': $9d5117faee5c78f9$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $9d5117faee5c78f9$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $9d5117faee5c78f9$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $9d5117faee5c78f9$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $9d5117faee5c78f9$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $9d5117faee5c78f9$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002F /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00E1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $9d5117faee5c78f9$var$__readUInt16LE(blob, blob.l), next = $9d5117faee5c78f9$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $9d5117faee5c78f9$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $9d5117faee5c78f9$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $9d5117faee5c78f9$var$XLSRecordEnum[nextrt = $9d5117faee5c78f9$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $9d5117faee5c78f9$var$bconcat(bufs);
    $9d5117faee5c78f9$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $9d5117faee5c78f9$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === 'z') return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF) p.z = $9d5117faee5c78f9$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === 'e') p.w = p.w || $9d5117faee5c78f9$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $9d5117faee5c78f9$var$SSF_general_num(p.v);
            } else p.w = $9d5117faee5c78f9$var$SSF_general(p.v);
        } else p.w = $9d5117faee5c78f9$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == 'n' && $9d5117faee5c78f9$var$fmt_is_date($9d5117faee5c78f9$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $9d5117faee5c78f9$var$SSF_parse_date_code(p.v);
        if (_d) {
            p.t = 'd';
            p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
        }
    }
}
function $9d5117faee5c78f9$var$make_cell(val, ixfe, t) /*:Cell*/ {
    return {
        v: val,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $9d5117faee5c78f9$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($9d5117faee5c78f9$var$DENSE != null && options.dense == null) options.dense = $9d5117faee5c78f9$var$DENSE;
    var out /*:Worksheet*/  = {} /*:any*/ ;
    if (options.dense) out["!data"] = [];
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $9d5117faee5c78f9$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $9d5117faee5c78f9$var$XLSIcv[icv];
        return $9d5117faee5c78f9$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(cell, line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $9d5117faee5c78f9$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $9d5117faee5c78f9$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $9d5117faee5c78f9$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $9d5117faee5c78f9$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $9d5117faee5c78f9$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out["!data"][cell.r]) out["!data"][cell.r] = [];
            out["!data"][cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $9d5117faee5c78f9$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $9d5117faee5c78f9$var$XLSRecordEnum[RecordType];
        if (file_depth == 0 && [
            0x0009,
            0x0209,
            0x0409,
            0x0809
        ].indexOf(RecordType) == -1 /* BOF */ ) break;
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val = /*::(*/ $9d5117faee5c78f9$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* BOF */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $9d5117faee5c78f9$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val.fDialog) out["!type"] = "dialog";
                    if (!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x00e0 /* XF */ :
                    XFs.push(val);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val.Name,
                        Ref: $9d5117faee5c78f9$var$stringify_formula(val.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val.itab > 0) last_lbl.Sheet = val.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val);
                    if (val.Name == "_xlnm._FilterDatabase" && val.itab > 0) {
                        if (val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d') FilterDatabases[val.itab - 1] = {
                            ref: $9d5117faee5c78f9$var$encode_range(val.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                    supbooks.XTI = supbooks.XTI.concat(val);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val !== 0 && opts.WTF) console.error("Password verifier: " + val);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[val.pos] = val;
                    opts.snames.push(val.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $9d5117faee5c78f9$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $9d5117faee5c78f9$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        /*::[*/ 0x0009: 2,
                        /*::[*/ 0x0209: 3,
                        /*::[*/ 0x0409: 4
                    })[RecordType] || ({
                        /*::[*/ 0x0200: 2,
                        /*::[*/ 0x0300: 3,
                        /*::[*/ 0x0400: 4,
                        /*::[*/ 0x0500: 5,
                        /*::[*/ 0x0600: 8,
                        /*::[*/ 0x0002: 2,
                        /*::[*/ 0x0007: 2
                    })[val.BIFFVer] || 8;
                    opts.biffguess = val.BIFFVer == 0;
                    if (val.BIFFVer == 0 && val.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $9d5117faee5c78f9$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
                    if (file_depth++) break;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $9d5117faee5c78f9$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val.dt == 0x20) out["!type"] = "chart";
                    if (val.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out["!data"][val.r] || [])[val.c] : out[$9d5117faee5c78f9$var$encode_col(val.c) + $9d5117faee5c78f9$var$encode_row(val.r)]) ++val.c;
                    }
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe] || {},
                        v: val.val,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $9d5117faee5c78f9$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.val,
                        t: val.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $9d5117faee5c78f9$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.rknum,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $9d5117faee5c78f9$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val.c; j <= val.C; ++j){
                        var ixfe = val.rkrec[j - val.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val.rkrec[j - val.c][1],
                            t: 'n'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $9d5117faee5c78f9$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val.val == 'String') {
                        last_formula = val;
                        break;
                    }
                    temp_val = $9d5117faee5c78f9$var$make_cell(val.val, val.cell.ixfe, val.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $9d5117faee5c78f9$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $9d5117faee5c78f9$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out["!data"][_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $9d5117faee5c78f9$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $9d5117faee5c78f9$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val.cell, temp_val, options);
                    last_formula = val;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val;
                        temp_val = $9d5117faee5c78f9$var$make_cell(val, last_formula.cell.ixfe, 's');
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $9d5117faee5c78f9$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $9d5117faee5c78f9$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val);
                    var _arraystart = $9d5117faee5c78f9$var$encode_cell(val[0].s);
                    cc = options.dense ? (out["!data"][val[0].s.r] || [])[val[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $9d5117faee5c78f9$var$stringify_formula(val[1], range, val[0], supbooks, opts);
                        cc.F = $9d5117faee5c78f9$var$encode_range(val[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$9d5117faee5c78f9$var$encode_cell(last_formula.cell)] = val[0];
                        cc = options.dense ? (out["!data"][last_formula.cell.r] || [])[last_formula.cell.c] : out[$9d5117faee5c78f9$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $9d5117faee5c78f9$var$stringify_formula(val[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $9d5117faee5c78f9$var$make_cell(sst[val.isst].t, val.ixfe, 's');
                    if (sst[val.isst].h) temp_val.h = sst[val.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $9d5117faee5c78f9$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val.ixfe,
                            XF: XFs[val.ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $9d5117faee5c78f9$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val.c; _j <= val.C; ++_j){
                        var _ixfe = val.ixfe[_j - val.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $9d5117faee5c78f9$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $9d5117faee5c78f9$var$make_cell(val.val, val.ixfe, 's');
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $9d5117faee5c78f9$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff == 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($9d5117faee5c78f9$var$table_fmt[b4idx] == val[1]) break;
                        if (b4idx >= 163) $9d5117faee5c78f9$var$SSF__load(val[1], BIFF2Fmt + 163);
                    } else $9d5117faee5c78f9$var$SSF__load(val[1], val[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($9d5117faee5c78f9$var$table_fmt[b2idx] == val) break;
                    if (b2idx >= 163) $9d5117faee5c78f9$var$SSF__load(val, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val);
                    break;
                case 0x005d /* Obj */ :
                    objects[val.cmo[0]] = opts.lastobj = val;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$9d5117faee5c78f9$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$9d5117faee5c78f9$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    if (opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */ 
                    cc = options.dense ? (out["!data"][val[0].r] || [])[val[0].c] : out[$9d5117faee5c78f9$var$encode_cell(val[0])];
                    var noteobj = objects[val[2]];
                    if (!cc) {
                        if (options.dense) {
                            if (!out["!data"][val[0].r]) out["!data"][val[0].r] = [];
                            cc = out["!data"][val[0].r][val[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$9d5117faee5c78f9$var$encode_cell(val[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val[0].r);
                        range.s.r = Math.min(range.s.r, val[0].r);
                        range.e.c = Math.max(range.e.c, val[0].c);
                        range.s.c = Math.min(range.s.c, val[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    cmnt = {
                        a: val[1],
                        t: noteobj.TxO.t
                    };
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $9d5117faee5c78f9$var$update_xfext(XFs[val.ixfe], val.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val.e >= val.s){
                        colinfo[val.e--] = {
                            width: val.w / 256,
                            level: val.level || 0,
                            hidden: !!(val.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $9d5117faee5c78f9$var$find_mdw_colw(val.w / 256);
                        }
                        $9d5117faee5c78f9$var$process_col(colinfo[val.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val.level != null) {
                        rowinfo[val.r] = rowobj;
                        rowobj.level = val.level;
                    }
                    if (val.hidden) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val.hpt) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hpt = val.hpt;
                        rowobj.hpx = $9d5117faee5c78f9$var$pt2px(val.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out['!margins']) $9d5117faee5c78f9$var$default_margins(out['!margins'] = {});
                    out['!margins'][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out['!margins']) $9d5117faee5c78f9$var$default_margins(out['!margins'] = {});
                    out['!margins'].header = val.header;
                    out['!margins'].footer = val.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val;
                    break;
                case 0x008c /* Country */ :
                    country = val;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
                    else wsprops.CodeName = val || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $9d5117faee5c78f9$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r;
    });
    wb.Strings = sst;
    wb.SSF = $9d5117faee5c78f9$var$dup($9d5117faee5c78f9$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $9d5117faee5c78f9$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $9d5117faee5c78f9$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, '/!DocumentSummaryInformation');
    if (DSI && DSI.size > 0) try {
        var DocSummary = $9d5117faee5c78f9$var$parse_PropertySetStream(DSI, $9d5117faee5c78f9$var$DocSummaryPIDDSI, $9d5117faee5c78f9$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, '/!SummaryInformation');
    if (SI && SI.size > 0) try {
        var Summary = $9d5117faee5c78f9$var$parse_PropertySetStream(SI, $9d5117faee5c78f9$var$SummaryPIDSI, $9d5117faee5c78f9$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $9d5117faee5c78f9$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $9d5117faee5c78f9$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $9d5117faee5c78f9$var$evert_key($9d5117faee5c78f9$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $9d5117faee5c78f9$var$evert_key($9d5117faee5c78f9$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $9d5117faee5c78f9$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $9d5117faee5c78f9$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($9d5117faee5c78f9$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $9d5117faee5c78f9$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005SummaryInformation", $9d5117faee5c78f9$var$write_PropertySetStream(SEntries, $9d5117faee5c78f9$var$PSCLSID.SI, SummaryRE, $9d5117faee5c78f9$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", $9d5117faee5c78f9$var$write_PropertySetStream(DSEntries, $9d5117faee5c78f9$var$PSCLSID.DSI, DocSummaryRE, $9d5117faee5c78f9$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $9d5117faee5c78f9$var$PSCLSID.UDI));
}
function $9d5117faee5c78f9$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $9d5117faee5c78f9$var$fix_read_opts(options);
    $9d5117faee5c78f9$var$reset_cp();
    if (options.codepage) $9d5117faee5c78f9$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, '/encryption')) throw new Error("File is password-protected");
        CompObj = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, '!CompObj');
        WB = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, '/Workbook') || $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, '/Book');
    } else {
        switch(options.type){
            case 'base64':
                cfb = $9d5117faee5c78f9$var$s2a($9d5117faee5c78f9$var$Base64_decode(cfb));
                break;
            case 'binary':
                cfb = $9d5117faee5c78f9$var$s2a(cfb);
                break;
            case 'buffer':
                break;
            case 'array':
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $9d5117faee5c78f9$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $9d5117faee5c78f9$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $9d5117faee5c78f9$var$has_buf ? 'buffer' : 'array';
        if (WB && WB.content) WorkbookP = $9d5117faee5c78f9$var$parse_workbook(WB.content, options);
        else if ((_data = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = $9d5117faee5c78f9$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = $9d5117faee5c78f9$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = $9d5117faee5c78f9$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $9d5117faee5c78f9$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $9d5117faee5c78f9$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $9d5117faee5c78f9$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $9d5117faee5c78f9$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $9d5117faee5c78f9$var$fill_vba_xls(cfb, $9d5117faee5c78f9$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $9d5117faee5c78f9$var$XLSBRecordEnum = {
    /*::[*/ 0x0000: {
        f: $9d5117faee5c78f9$var$parse_BrtRowHdr
    },
    /*::[*/ 0x0001: {
        f: $9d5117faee5c78f9$var$parse_BrtCellBlank
    },
    /*::[*/ 0x0002: {
        f: $9d5117faee5c78f9$var$parse_BrtCellRk
    },
    /*::[*/ 0x0003: {
        f: $9d5117faee5c78f9$var$parse_BrtCellError
    },
    /*::[*/ 0x0004: {
        f: $9d5117faee5c78f9$var$parse_BrtCellBool
    },
    /*::[*/ 0x0005: {
        f: $9d5117faee5c78f9$var$parse_BrtCellReal
    },
    /*::[*/ 0x0006: {
        f: $9d5117faee5c78f9$var$parse_BrtCellSt
    },
    /*::[*/ 0x0007: {
        f: $9d5117faee5c78f9$var$parse_BrtCellIsst
    },
    /*::[*/ 0x0008: {
        f: $9d5117faee5c78f9$var$parse_BrtFmlaString
    },
    /*::[*/ 0x0009: {
        f: $9d5117faee5c78f9$var$parse_BrtFmlaNum
    },
    /*::[*/ 0x000A: {
        f: $9d5117faee5c78f9$var$parse_BrtFmlaBool
    },
    /*::[*/ 0x000B: {
        f: $9d5117faee5c78f9$var$parse_BrtFmlaError
    },
    /*::[*/ 0x000C: {
        f: $9d5117faee5c78f9$var$parse_BrtShortBlank
    },
    /*::[*/ 0x000D: {
        f: $9d5117faee5c78f9$var$parse_BrtShortRk
    },
    /*::[*/ 0x000E: {
        f: $9d5117faee5c78f9$var$parse_BrtShortError
    },
    /*::[*/ 0x000F: {
        f: $9d5117faee5c78f9$var$parse_BrtShortBool
    },
    /*::[*/ 0x0010: {
        f: $9d5117faee5c78f9$var$parse_BrtShortReal
    },
    /*::[*/ 0x0011: {
        f: $9d5117faee5c78f9$var$parse_BrtShortSt
    },
    /*::[*/ 0x0012: {
        f: $9d5117faee5c78f9$var$parse_BrtShortIsst
    },
    /*::[*/ 0x0013: {
        f: $9d5117faee5c78f9$var$parse_RichStr
    },
    /*::[*/ 0x0014: {},
    /*::[*/ 0x0015: {},
    /*::[*/ 0x0016: {},
    /*::[*/ 0x0017: {},
    /*::[*/ 0x0018: {},
    /*::[*/ 0x0019: {},
    /*::[*/ 0x001A: {},
    /*::[*/ 0x001B: {},
    /*::[*/ 0x001C: {},
    /*::[*/ 0x001D: {},
    /*::[*/ 0x001E: {},
    /*::[*/ 0x001F: {},
    /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {},
    /*::[*/ 0x0022: {},
    /*::[*/ 0x0023: {
        T: 1
    },
    /*::[*/ 0x0024: {
        T: -1
    },
    /*::[*/ 0x0025: {
        T: 1
    },
    /*::[*/ 0x0026: {
        T: -1
    },
    /*::[*/ 0x0027: {
        f: $9d5117faee5c78f9$var$parse_BrtName
    },
    /*::[*/ 0x0028: {},
    /*::[*/ 0x002A: {},
    /*::[*/ 0x002B: {
        f: $9d5117faee5c78f9$var$parse_BrtFont
    },
    /*::[*/ 0x002C: {
        f: $9d5117faee5c78f9$var$parse_BrtFmt
    },
    /*::[*/ 0x002D: {
        f: $9d5117faee5c78f9$var$parse_BrtFill
    },
    /*::[*/ 0x002E: {
        f: $9d5117faee5c78f9$var$parse_BrtBorder
    },
    /*::[*/ 0x002F: {
        f: $9d5117faee5c78f9$var$parse_BrtXF
    },
    /*::[*/ 0x0030: {},
    /*::[*/ 0x0031: {
        f: $9d5117faee5c78f9$var$parse_Int32LE
    },
    /*::[*/ 0x0032: {},
    /*::[*/ 0x0033: {
        f: $9d5117faee5c78f9$var$parse_BrtMdb
    },
    /*::[*/ 0x0034: {
        T: 1
    },
    /*::[*/ 0x0035: {
        T: -1
    },
    /*::[*/ 0x0036: {
        T: 1
    },
    /*::[*/ 0x0037: {
        T: -1
    },
    /*::[*/ 0x0038: {
        T: 1
    },
    /*::[*/ 0x0039: {
        T: -1
    },
    /*::[*/ 0x003A: {},
    /*::[*/ 0x003B: {},
    /*::[*/ 0x003C: {
        f: $9d5117faee5c78f9$var$parse_ColInfo
    },
    /*::[*/ 0x003E: {
        f: $9d5117faee5c78f9$var$parse_BrtCellRString
    },
    /*::[*/ 0x003F: {
        f: $9d5117faee5c78f9$var$parse_BrtCalcChainItem$
    },
    /*::[*/ 0x0040: {
        f: $9d5117faee5c78f9$var$parse_BrtDVal
    },
    /*::[*/ 0x0041: {},
    /*::[*/ 0x0042: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {},
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0046: {},
    /*::[*/ 0x0080: {},
    /*::[*/ 0x0081: {
        T: 1
    },
    /*::[*/ 0x0082: {
        T: -1
    },
    /*::[*/ 0x0083: {
        T: 1,
        f: $9d5117faee5c78f9$var$parsenoop,
        p: 0
    },
    /*::[*/ 0x0084: {
        T: -1
    },
    /*::[*/ 0x0085: {
        T: 1
    },
    /*::[*/ 0x0086: {
        T: -1
    },
    /*::[*/ 0x0087: {
        T: 1
    },
    /*::[*/ 0x0088: {
        T: -1
    },
    /*::[*/ 0x0089: {
        T: 1,
        f: $9d5117faee5c78f9$var$parse_BrtBeginWsView
    },
    /*::[*/ 0x008A: {
        T: -1
    },
    /*::[*/ 0x008B: {
        T: 1
    },
    /*::[*/ 0x008C: {
        T: -1
    },
    /*::[*/ 0x008D: {
        T: 1
    },
    /*::[*/ 0x008E: {
        T: -1
    },
    /*::[*/ 0x008F: {
        T: 1
    },
    /*::[*/ 0x0090: {
        T: -1
    },
    /*::[*/ 0x0091: {
        T: 1
    },
    /*::[*/ 0x0092: {
        T: -1
    },
    /*::[*/ 0x0093: {
        f: $9d5117faee5c78f9$var$parse_BrtWsProp
    },
    /*::[*/ 0x0094: {
        f: $9d5117faee5c78f9$var$parse_BrtWsDim,
        p: 16
    },
    /*::[*/ 0x0097: {
        f: $9d5117faee5c78f9$var$parse_BrtPane
    },
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {
        f: $9d5117faee5c78f9$var$parse_BrtWbProp
    },
    /*::[*/ 0x009A: {},
    /*::[*/ 0x009B: {},
    /*::[*/ 0x009C: {
        f: $9d5117faee5c78f9$var$parse_BrtBundleSh
    },
    /*::[*/ 0x009D: {},
    /*::[*/ 0x009E: {},
    /*::[*/ 0x009F: {
        T: 1,
        f: $9d5117faee5c78f9$var$parse_BrtBeginSst
    },
    /*::[*/ 0x00A0: {
        T: -1
    },
    /*::[*/ 0x00A1: {
        T: 1,
        f: $9d5117faee5c78f9$var$parse_UncheckedRfX
    },
    /*::[*/ 0x00A2: {
        T: -1
    },
    /*::[*/ 0x00A3: {
        T: 1
    },
    /*::[*/ 0x00A4: {
        T: -1
    },
    /*::[*/ 0x00A5: {
        T: 1
    },
    /*::[*/ 0x00A6: {
        T: -1
    },
    /*::[*/ 0x00A7: {},
    /*::[*/ 0x00A8: {},
    /*::[*/ 0x00A9: {},
    /*::[*/ 0x00AA: {},
    /*::[*/ 0x00AB: {},
    /*::[*/ 0x00AC: {
        T: 1
    },
    /*::[*/ 0x00AD: {
        T: -1
    },
    /*::[*/ 0x00AE: {},
    /*::[*/ 0x00AF: {},
    /*::[*/ 0x00B0: {
        f: $9d5117faee5c78f9$var$parse_BrtMergeCell
    },
    /*::[*/ 0x00B1: {
        T: 1
    },
    /*::[*/ 0x00B2: {
        T: -1
    },
    /*::[*/ 0x00B3: {
        T: 1
    },
    /*::[*/ 0x00B4: {
        T: -1
    },
    /*::[*/ 0x00B5: {
        T: 1
    },
    /*::[*/ 0x00B6: {
        T: -1
    },
    /*::[*/ 0x00B7: {
        T: 1
    },
    /*::[*/ 0x00B8: {
        T: -1
    },
    /*::[*/ 0x00B9: {
        T: 1
    },
    /*::[*/ 0x00BA: {
        T: -1
    },
    /*::[*/ 0x00BB: {
        T: 1
    },
    /*::[*/ 0x00BC: {
        T: -1
    },
    /*::[*/ 0x00BD: {
        T: 1
    },
    /*::[*/ 0x00BE: {
        T: -1
    },
    /*::[*/ 0x00BF: {
        T: 1
    },
    /*::[*/ 0x00C0: {
        T: -1
    },
    /*::[*/ 0x00C1: {
        T: 1
    },
    /*::[*/ 0x00C2: {
        T: -1
    },
    /*::[*/ 0x00C3: {
        T: 1
    },
    /*::[*/ 0x00C4: {
        T: -1
    },
    /*::[*/ 0x00C5: {
        T: 1
    },
    /*::[*/ 0x00C6: {
        T: -1
    },
    /*::[*/ 0x00C7: {
        T: 1
    },
    /*::[*/ 0x00C8: {
        T: -1
    },
    /*::[*/ 0x00C9: {
        T: 1
    },
    /*::[*/ 0x00CA: {
        T: -1
    },
    /*::[*/ 0x00CB: {
        T: 1
    },
    /*::[*/ 0x00CC: {
        T: -1
    },
    /*::[*/ 0x00CD: {
        T: 1
    },
    /*::[*/ 0x00CE: {
        T: -1
    },
    /*::[*/ 0x00CF: {
        T: 1
    },
    /*::[*/ 0x00D0: {
        T: -1
    },
    /*::[*/ 0x00D1: {
        T: 1
    },
    /*::[*/ 0x00D2: {
        T: -1
    },
    /*::[*/ 0x00D3: {
        T: 1
    },
    /*::[*/ 0x00D4: {
        T: -1
    },
    /*::[*/ 0x00D5: {
        T: 1
    },
    /*::[*/ 0x00D6: {
        T: -1
    },
    /*::[*/ 0x00D7: {
        T: 1
    },
    /*::[*/ 0x00D8: {
        T: -1
    },
    /*::[*/ 0x00D9: {
        T: 1
    },
    /*::[*/ 0x00DA: {
        T: -1
    },
    /*::[*/ 0x00DB: {
        T: 1
    },
    /*::[*/ 0x00DC: {
        T: -1
    },
    /*::[*/ 0x00DD: {
        T: 1
    },
    /*::[*/ 0x00DE: {
        T: -1
    },
    /*::[*/ 0x00DF: {
        T: 1
    },
    /*::[*/ 0x00E0: {
        T: -1
    },
    /*::[*/ 0x00E1: {
        T: 1
    },
    /*::[*/ 0x00E2: {
        T: -1
    },
    /*::[*/ 0x00E3: {
        T: 1
    },
    /*::[*/ 0x00E4: {
        T: -1
    },
    /*::[*/ 0x00E5: {
        T: 1
    },
    /*::[*/ 0x00E6: {
        T: -1
    },
    /*::[*/ 0x00E7: {
        T: 1
    },
    /*::[*/ 0x00E8: {
        T: -1
    },
    /*::[*/ 0x00E9: {
        T: 1
    },
    /*::[*/ 0x00EA: {
        T: -1
    },
    /*::[*/ 0x00EB: {
        T: 1
    },
    /*::[*/ 0x00EC: {
        T: -1
    },
    /*::[*/ 0x00ED: {
        T: 1
    },
    /*::[*/ 0x00EE: {
        T: -1
    },
    /*::[*/ 0x00EF: {
        T: 1
    },
    /*::[*/ 0x00F0: {
        T: -1
    },
    /*::[*/ 0x00F1: {
        T: 1
    },
    /*::[*/ 0x00F2: {
        T: -1
    },
    /*::[*/ 0x00F3: {
        T: 1
    },
    /*::[*/ 0x00F4: {
        T: -1
    },
    /*::[*/ 0x00F5: {
        T: 1
    },
    /*::[*/ 0x00F6: {
        T: -1
    },
    /*::[*/ 0x00F7: {
        T: 1
    },
    /*::[*/ 0x00F8: {
        T: -1
    },
    /*::[*/ 0x00F9: {
        T: 1
    },
    /*::[*/ 0x00FA: {
        T: -1
    },
    /*::[*/ 0x00FB: {
        T: 1
    },
    /*::[*/ 0x00FC: {
        T: -1
    },
    /*::[*/ 0x00FD: {
        T: 1
    },
    /*::[*/ 0x00FE: {
        T: -1
    },
    /*::[*/ 0x00FF: {
        T: 1
    },
    /*::[*/ 0x0100: {
        T: -1
    },
    /*::[*/ 0x0101: {
        T: 1
    },
    /*::[*/ 0x0102: {
        T: -1
    },
    /*::[*/ 0x0103: {
        T: 1
    },
    /*::[*/ 0x0104: {
        T: -1
    },
    /*::[*/ 0x0105: {
        T: 1
    },
    /*::[*/ 0x0106: {
        T: -1
    },
    /*::[*/ 0x0107: {
        T: 1
    },
    /*::[*/ 0x0108: {
        T: -1
    },
    /*::[*/ 0x0109: {
        T: 1
    },
    /*::[*/ 0x010A: {
        T: -1
    },
    /*::[*/ 0x010B: {
        T: 1
    },
    /*::[*/ 0x010C: {
        T: -1
    },
    /*::[*/ 0x010D: {
        T: 1
    },
    /*::[*/ 0x010E: {
        T: -1
    },
    /*::[*/ 0x010F: {
        T: 1
    },
    /*::[*/ 0x0110: {
        T: -1
    },
    /*::[*/ 0x0111: {
        T: 1
    },
    /*::[*/ 0x0112: {
        T: -1
    },
    /*::[*/ 0x0113: {
        T: 1
    },
    /*::[*/ 0x0114: {
        T: -1
    },
    /*::[*/ 0x0115: {},
    /*::[*/ 0x0116: {
        T: 1
    },
    /*::[*/ 0x0117: {
        T: -1
    },
    /*::[*/ 0x0118: {
        T: 1
    },
    /*::[*/ 0x0119: {
        T: -1
    },
    /*::[*/ 0x011A: {
        T: 1
    },
    /*::[*/ 0x011B: {
        T: 1
    },
    /*::[*/ 0x011C: {
        T: -1
    },
    /*::[*/ 0x011D: {
        T: 1
    },
    /*::[*/ 0x011E: {
        T: -1
    },
    /*::[*/ 0x011F: {
        T: 1
    },
    /*::[*/ 0x0120: {
        T: -1
    },
    /*::[*/ 0x0121: {
        T: 1
    },
    /*::[*/ 0x0122: {
        T: -1
    },
    /*::[*/ 0x0123: {
        T: 1
    },
    /*::[*/ 0x0124: {
        T: -1
    },
    /*::[*/ 0x0125: {
        T: 1
    },
    /*::[*/ 0x0126: {
        T: -1
    },
    /*::[*/ 0x0127: {
        T: 1
    },
    /*::[*/ 0x0128: {
        T: -1
    },
    /*::[*/ 0x0129: {
        T: 1
    },
    /*::[*/ 0x012A: {
        T: -1
    },
    /*::[*/ 0x012B: {
        T: 1
    },
    /*::[*/ 0x012C: {
        T: -1
    },
    /*::[*/ 0x012D: {
        T: 1
    },
    /*::[*/ 0x012E: {
        T: -1
    },
    /*::[*/ 0x012F: {
        T: 1
    },
    /*::[*/ 0x0130: {
        T: -1
    },
    /*::[*/ 0x0131: {
        T: 1
    },
    /*::[*/ 0x0132: {
        T: -1
    },
    /*::[*/ 0x0133: {
        T: 1
    },
    /*::[*/ 0x0134: {
        T: -1
    },
    /*::[*/ 0x0135: {
        T: 1
    },
    /*::[*/ 0x0136: {
        T: -1
    },
    /*::[*/ 0x0137: {
        T: 1
    },
    /*::[*/ 0x0138: {
        T: -1
    },
    /*::[*/ 0x0139: {
        T: -1
    },
    /*::[*/ 0x013A: {
        T: 1
    },
    /*::[*/ 0x013B: {
        T: -1
    },
    /*::[*/ 0x013C: {
        T: 1
    },
    /*::[*/ 0x013D: {
        T: -1
    },
    /*::[*/ 0x013E: {
        T: 1
    },
    /*::[*/ 0x013F: {
        T: -1
    },
    /*::[*/ 0x0140: {
        T: 1
    },
    /*::[*/ 0x0141: {
        T: -1
    },
    /*::[*/ 0x0142: {
        T: 1
    },
    /*::[*/ 0x0143: {
        T: -1
    },
    /*::[*/ 0x0144: {
        T: 1
    },
    /*::[*/ 0x0145: {
        T: -1
    },
    /*::[*/ 0x0146: {
        T: 1
    },
    /*::[*/ 0x0147: {
        T: -1
    },
    /*::[*/ 0x0148: {
        T: 1
    },
    /*::[*/ 0x0149: {
        T: -1
    },
    /*::[*/ 0x014A: {
        T: 1
    },
    /*::[*/ 0x014B: {
        T: -1
    },
    /*::[*/ 0x014C: {
        T: 1
    },
    /*::[*/ 0x014D: {
        T: -1
    },
    /*::[*/ 0x014E: {
        T: 1
    },
    /*::[*/ 0x014F: {
        f: $9d5117faee5c78f9$var$parse_BrtMdtinfo
    },
    /*::[*/ 0x0150: {
        T: -1
    },
    /*::[*/ 0x0151: {
        f: $9d5117faee5c78f9$var$parse_BrtBeginEsmdb,
        T: 1
    },
    /*::[*/ 0x0152: {
        T: -1
    },
    /*::[*/ 0x0153: {
        T: 1
    },
    /*::[*/ 0x0154: {
        T: -1
    },
    /*::[*/ 0x0155: {
        T: 1
    },
    /*::[*/ 0x0156: {
        T: -1
    },
    /*::[*/ 0x0157: {
        T: 1
    },
    /*::[*/ 0x0158: {
        T: -1
    },
    /*::[*/ 0x0159: {
        T: 1
    },
    /*::[*/ 0x015A: {
        T: -1
    },
    /*::[*/ 0x015B: {
        T: 1
    },
    /*::[*/ 0x015C: {
        T: -1
    },
    /*::[*/ 0x015D: {
        T: 1
    },
    /*::[*/ 0x015E: {
        T: -1
    },
    /*::[*/ 0x015F: {},
    /*::[*/ 0x0160: {},
    /*::[*/ 0x0161: {
        T: 1
    },
    /*::[*/ 0x0162: {
        T: -1
    },
    /*::[*/ 0x0163: {
        f: $9d5117faee5c78f9$var$parse_RelID
    },
    /*::[*/ 0x0165: {},
    /*::[*/ 0x0166: {},
    /*::[*/ 0x0167: {},
    /*::[*/ 0x0168: {
        T: 1
    },
    /*::[*/ 0x0169: {},
    /*::[*/ 0x016A: {
        f: $9d5117faee5c78f9$var$parse_ExternSheet
    },
    /*::[*/ 0x016B: {},
    /*::[*/ 0x016C: {},
    /*::[*/ 0x016E: {},
    /*::[*/ 0x016F: {},
    /*::[*/ 0x0170: {},
    /*::[*/ 0x0171: {},
    /*::[*/ 0x0172: {},
    /*::[*/ 0x0173: {},
    /*::[*/ 0x0174: {
        T: 1
    },
    /*::[*/ 0x0175: {
        T: -1
    },
    /*::[*/ 0x0176: {
        T: 1
    },
    /*::[*/ 0x0177: {
        T: -1
    },
    /*::[*/ 0x0178: {
        T: 1
    },
    /*::[*/ 0x0179: {
        T: -1
    },
    /*::[*/ 0x017A: {
        T: 1
    },
    /*::[*/ 0x017B: {
        T: -1
    },
    /*::[*/ 0x017C: {
        T: 1
    },
    /*::[*/ 0x017D: {
        T: -1
    },
    /*::[*/ 0x017E: {
        T: 1
    },
    /*::[*/ 0x017F: {
        T: -1
    },
    /*::[*/ 0x0180: {
        T: 1
    },
    /*::[*/ 0x0181: {
        T: -1
    },
    /*::[*/ 0x0182: {
        T: 1
    },
    /*::[*/ 0x0183: {
        T: -1
    },
    /*::[*/ 0x0184: {
        T: 1
    },
    /*::[*/ 0x0185: {
        T: -1
    },
    /*::[*/ 0x0186: {
        T: 1
    },
    /*::[*/ 0x0187: {
        T: -1
    },
    /*::[*/ 0x0188: {
        T: 1
    },
    /*::[*/ 0x0189: {
        T: -1
    },
    /*::[*/ 0x018A: {
        T: 1
    },
    /*::[*/ 0x018B: {
        T: -1
    },
    /*::[*/ 0x018C: {},
    /*::[*/ 0x018D: {},
    /*::[*/ 0x018E: {},
    /*::[*/ 0x018F: {},
    /*::[*/ 0x0190: {},
    /*::[*/ 0x0191: {
        T: 1
    },
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x0199: {},
    /*::[*/ 0x019A: {},
    /*::[*/ 0x019B: {},
    /*::[*/ 0x019C: {},
    /*::[*/ 0x019D: {},
    /*::[*/ 0x019E: {},
    /*::[*/ 0x019F: {},
    /*::[*/ 0x01A0: {},
    /*::[*/ 0x01A1: {},
    /*::[*/ 0x01A2: {},
    /*::[*/ 0x01A3: {},
    /*::[*/ 0x01A4: {},
    /*::[*/ 0x01A5: {},
    /*::[*/ 0x01A6: {
        T: 1
    },
    /*::[*/ 0x01A7: {
        T: 1
    },
    /*::[*/ 0x01A8: {
        T: -1
    },
    /*::[*/ 0x01A9: {
        T: -1
    },
    /*::[*/ 0x01AA: {
        f: $9d5117faee5c78f9$var$parse_BrtArrFmla
    },
    /*::[*/ 0x01AB: {
        f: $9d5117faee5c78f9$var$parse_BrtShrFmla
    },
    /*::[*/ 0x01AC: {},
    /*::[*/ 0x01AD: {
        T: 1
    },
    /*::[*/ 0x01AE: {
        T: -1
    },
    /*::[*/ 0x01AF: {
        T: 1
    },
    /*::[*/ 0x01B0: {
        T: -1
    },
    /*::[*/ 0x01B1: {
        T: 1
    },
    /*::[*/ 0x01B2: {
        T: -1
    },
    /*::[*/ 0x01B3: {
        T: 1
    },
    /*::[*/ 0x01B4: {
        T: -1
    },
    /*::[*/ 0x01B5: {
        T: 1
    },
    /*::[*/ 0x01B6: {
        T: -1
    },
    /*::[*/ 0x01B7: {
        T: 1
    },
    /*::[*/ 0x01B8: {
        T: -1
    },
    /*::[*/ 0x01B9: {
        T: 1
    },
    /*::[*/ 0x01BA: {
        T: -1
    },
    /*::[*/ 0x01BB: {
        T: 1
    },
    /*::[*/ 0x01BC: {
        T: -1
    },
    /*::[*/ 0x01BD: {
        T: 1
    },
    /*::[*/ 0x01BE: {
        T: -1
    },
    /*::[*/ 0x01BF: {
        T: 1
    },
    /*::[*/ 0x01C0: {
        T: -1
    },
    /*::[*/ 0x01C1: {
        T: 1
    },
    /*::[*/ 0x01C2: {
        T: -1
    },
    /*::[*/ 0x01C3: {
        T: 1
    },
    /*::[*/ 0x01C4: {
        T: -1
    },
    /*::[*/ 0x01C5: {
        T: 1
    },
    /*::[*/ 0x01C6: {
        T: -1
    },
    /*::[*/ 0x01C7: {
        T: 1
    },
    /*::[*/ 0x01C8: {
        T: -1
    },
    /*::[*/ 0x01C9: {
        T: 1
    },
    /*::[*/ 0x01CA: {
        T: -1
    },
    /*::[*/ 0x01CB: {
        T: 1
    },
    /*::[*/ 0x01CC: {
        T: -1
    },
    /*::[*/ 0x01CD: {
        T: 1
    },
    /*::[*/ 0x01CE: {
        T: -1
    },
    /*::[*/ 0x01CF: {
        T: 1
    },
    /*::[*/ 0x01D0: {
        T: -1
    },
    /*::[*/ 0x01D1: {
        T: 1
    },
    /*::[*/ 0x01D2: {
        T: -1
    },
    /*::[*/ 0x01D3: {
        T: 1
    },
    /*::[*/ 0x01D4: {
        T: -1
    },
    /*::[*/ 0x01D5: {
        T: 1
    },
    /*::[*/ 0x01D6: {
        T: -1
    },
    /*::[*/ 0x01D7: {},
    /*::[*/ 0x01D8: {},
    /*::[*/ 0x01D9: {
        T: 1
    },
    /*::[*/ 0x01DA: {
        T: -1
    },
    /*::[*/ 0x01DB: {},
    /*::[*/ 0x01DC: {
        f: $9d5117faee5c78f9$var$parse_BrtMargins
    },
    /*::[*/ 0x01DD: {},
    /*::[*/ 0x01DE: {},
    /*::[*/ 0x01DF: {
        T: 1
    },
    /*::[*/ 0x01E0: {
        T: -1
    },
    /*::[*/ 0x01E1: {
        T: 1
    },
    /*::[*/ 0x01E2: {
        T: -1
    },
    /*::[*/ 0x01E3: {
        T: 1
    },
    /*::[*/ 0x01E4: {
        T: -1
    },
    /*::[*/ 0x01E5: {
        f: $9d5117faee5c78f9$var$parse_BrtWsFmtInfo
    },
    /*::[*/ 0x01E6: {
        T: 1
    },
    /*::[*/ 0x01E7: {
        T: -1
    },
    /*::[*/ 0x01E8: {
        T: 1
    },
    /*::[*/ 0x01E9: {
        T: -1
    },
    /*::[*/ 0x01EA: {
        T: 1
    },
    /*::[*/ 0x01EB: {
        T: -1
    },
    /*::[*/ 0x01EC: {
        T: 1
    },
    /*::[*/ 0x01ED: {
        T: -1
    },
    /*::[*/ 0x01EE: {
        f: $9d5117faee5c78f9$var$parse_BrtHLink
    },
    /*::[*/ 0x01EF: {
        T: 1
    },
    /*::[*/ 0x01F0: {
        T: -1
    },
    /*::[*/ 0x01F1: {
        T: 1
    },
    /*::[*/ 0x01F2: {
        T: -1
    },
    /*::[*/ 0x01F3: {},
    /*::[*/ 0x01F4: {
        T: 1
    },
    /*::[*/ 0x01F5: {
        T: -1
    },
    /*::[*/ 0x01F6: {
        T: 1
    },
    /*::[*/ 0x01F7: {
        T: -1
    },
    /*::[*/ 0x01F8: {},
    /*::[*/ 0x01F9: {
        T: 1
    },
    /*::[*/ 0x01FA: {
        T: -1
    },
    /*::[*/ 0x01FB: {},
    /*::[*/ 0x01FC: {
        T: 1
    },
    /*::[*/ 0x01FD: {
        T: -1
    },
    /*::[*/ 0x01FE: {
        T: 1
    },
    /*::[*/ 0x01FF: {
        T: -1
    },
    /*::[*/ 0x0200: {},
    /*::[*/ 0x0201: {},
    /*::[*/ 0x0202: {
        T: 1
    },
    /*::[*/ 0x0203: {
        T: -1
    },
    /*::[*/ 0x0204: {
        T: 1
    },
    /*::[*/ 0x0205: {
        T: -1
    },
    /*::[*/ 0x0206: {
        T: 1
    },
    /*::[*/ 0x0207: {
        T: -1
    },
    /*::[*/ 0x0208: {
        T: 1
    },
    /*::[*/ 0x0209: {
        T: -1
    },
    /*::[*/ 0x020A: {},
    /*::[*/ 0x020B: {},
    /*::[*/ 0x020C: {},
    /*::[*/ 0x020D: {},
    /*::[*/ 0x020E: {},
    /*::[*/ 0x020F: {},
    /*::[*/ 0x0210: {
        T: 1
    },
    /*::[*/ 0x0211: {
        T: -1
    },
    /*::[*/ 0x0212: {
        T: 1
    },
    /*::[*/ 0x0213: {
        T: -1
    },
    /*::[*/ 0x0214: {
        T: 1
    },
    /*::[*/ 0x0215: {
        T: -1
    },
    /*::[*/ 0x0216: {},
    /*::[*/ 0x0217: {},
    /*::[*/ 0x0218: {},
    /*::[*/ 0x0219: {},
    /*::[*/ 0x021A: {
        T: 1
    },
    /*::[*/ 0x021B: {
        T: -1
    },
    /*::[*/ 0x021C: {
        T: 1
    },
    /*::[*/ 0x021D: {
        T: -1
    },
    /*::[*/ 0x021E: {
        T: 1
    },
    /*::[*/ 0x0224: {},
    /*::[*/ 0x0225: {},
    /*::[*/ 0x0226: {
        f: $9d5117faee5c78f9$var$parse_RelID
    },
    /*::[*/ 0x0227: {},
    /*::[*/ 0x0228: {},
    /*::[*/ 0x0229: {},
    /*::[*/ 0x022A: {
        T: 1
    },
    /*::[*/ 0x022B: {
        T: -1
    },
    /*::[*/ 0x022C: {
        T: 1
    },
    /*::[*/ 0x022D: {
        T: -1
    },
    /*::[*/ 0x022E: {
        T: 1
    },
    /*::[*/ 0x022F: {
        T: -1
    },
    /*::[*/ 0x0230: {
        T: 1
    },
    /*::[*/ 0x0231: {
        T: -1
    },
    /*::[*/ 0x0232: {},
    /*::[*/ 0x0234: {},
    /*::[*/ 0x0235: {
        T: 1
    },
    /*::[*/ 0x0236: {
        T: -1
    },
    /*::[*/ 0x0239: {
        T: 1
    },
    /*::[*/ 0x023A: {
        T: -1
    },
    /*::[*/ 0x023C: {},
    /*::[*/ 0x023D: {
        T: 1
    },
    /*::[*/ 0x023E: {
        T: -1
    },
    /*::[*/ 0x0241: {},
    /*::[*/ 0x0242: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0244: {},
    /*::[*/ 0x0245: {},
    /*::[*/ 0x0246: {},
    /*::[*/ 0x0247: {},
    /*::[*/ 0x0248: {},
    /*::[*/ 0x0249: {},
    /*::[*/ 0x024A: {},
    /*::[*/ 0x024B: {},
    /*::[*/ 0x024C: {
        T: -1
    },
    /*::[*/ 0x024D: {},
    /*::[*/ 0x024E: {
        T: 1
    },
    /*::[*/ 0x024F: {
        T: -1
    },
    /*::[*/ 0x0250: {
        T: 1
    },
    /*::[*/ 0x0251: {
        T: -1
    },
    /*::[*/ 0x0252: {
        T: 1
    },
    /*::[*/ 0x0253: {
        T: -1
    },
    /*::[*/ 0x0254: {},
    /*::[*/ 0x0255: {
        T: 1
    },
    /*::[*/ 0x0256: {
        T: -1
    },
    /*::[*/ 0x0257: {
        T: 1
    },
    /*::[*/ 0x0258: {
        T: -1
    },
    /*::[*/ 0x0259: {
        T: 1
    },
    /*::[*/ 0x025A: {
        T: -1
    },
    /*::[*/ 0x025B: {
        T: 1
    },
    /*::[*/ 0x025C: {
        T: -1
    },
    /*::[*/ 0x025D: {
        T: 1
    },
    /*::[*/ 0x025E: {
        T: -1
    },
    /*::[*/ 0x025F: {},
    /*::[*/ 0x0260: {
        T: 1
    },
    /*::[*/ 0x0261: {
        T: -1
    },
    /*::[*/ 0x0262: {},
    /*::[*/ 0x0263: {
        T: 1
    },
    /*::[*/ 0x0264: {
        T: -1
    },
    /*::[*/ 0x0265: {
        T: 1
    },
    /*::[*/ 0x0266: {
        T: -1
    },
    /*::[*/ 0x0267: {
        T: 1
    },
    /*::[*/ 0x0268: {
        T: -1
    },
    /*::[*/ 0x0269: {
        T: 1
    },
    /*::[*/ 0x026A: {
        T: -1
    },
    /*::[*/ 0x026B: {
        T: 1
    },
    /*::[*/ 0x026C: {
        T: -1
    },
    /*::[*/ 0x0271: {},
    /*::[*/ 0x0272: {
        T: 1
    },
    /*::[*/ 0x0273: {
        T: -1
    },
    /*::[*/ 0x0274: {
        T: 1
    },
    /*::[*/ 0x0275: {
        T: -1
    },
    /*::[*/ 0x0276: {
        T: 1
    },
    /*::[*/ 0x0277: {
        T: -1
    },
    /*::[*/ 0x0278: {
        f: $9d5117faee5c78f9$var$parse_BrtCommentAuthor
    },
    /*::[*/ 0x0279: {
        T: 1
    },
    /*::[*/ 0x027A: {
        T: -1
    },
    /*::[*/ 0x027B: {
        T: 1,
        f: $9d5117faee5c78f9$var$parse_BrtBeginComment
    },
    /*::[*/ 0x027C: {
        T: -1
    },
    /*::[*/ 0x027D: {
        f: $9d5117faee5c78f9$var$parse_BrtCommentText
    },
    /*::[*/ 0x027E: {
        T: 1
    },
    /*::[*/ 0x027F: {},
    /*::[*/ 0x0280: {
        T: -1
    },
    /*::[*/ 0x0281: {
        T: 1
    },
    /*::[*/ 0x0282: {
        T: -1
    },
    /*::[*/ 0x0283: {
        T: 1
    },
    /*::[*/ 0x0284: {},
    /*::[*/ 0x0285: {
        T: -1
    },
    /*::[*/ 0x0286: {
        T: 1
    },
    /*::[*/ 0x0288: {
        T: 1
    },
    /*::[*/ 0x0289: {},
    /*::[*/ 0x028A: {
        T: -1
    },
    /*::[*/ 0x028B: {
        f: $9d5117faee5c78f9$var$parse_BrtCsProp
    },
    /*::[*/ 0x028C: {},
    /*::[*/ 0x028D: {
        T: 1
    },
    /*::[*/ 0x028E: {
        T: -1
    },
    /*::[*/ 0x028F: {
        T: 1
    },
    /*::[*/ 0x0290: {
        T: -1
    },
    /*::[*/ 0x0291: {
        T: 1
    },
    /*::[*/ 0x0292: {
        T: -1
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0294: {
        T: 1
    },
    /*::[*/ 0x0295: {},
    /*::[*/ 0x0296: {
        T: -1
    },
    /*::[*/ 0x0297: {},
    /*::[*/ 0x0298: {
        T: 1
    },
    /*::[*/ 0x0299: {},
    /*::[*/ 0x029A: {
        T: -1
    },
    /*::[*/ 0x029B: {},
    /*::[*/ 0x029C: {},
    /*::[*/ 0x029D: {},
    /*::[*/ 0x029F: {
        T: 1
    },
    /*::[*/ 0x02A0: {
        T: -1
    },
    /*::[*/ 0x02A1: {
        T: 1
    },
    /*::[*/ 0x02A2: {
        T: -1
    },
    /*::[*/ 0x02A3: {},
    /*::[*/ 0x02A4: {},
    /*::[*/ 0x02A5: {},
    /*::[*/ 0x02A6: {},
    /*::[*/ 0x02A7: {},
    /*::[*/ 0x02A8: {},
    /*::[*/ 0x02A9: {},
    /*::[*/ 0x0400: {},
    /*::[*/ 0x0401: {},
    /*::[*/ 0x0402: {
        T: 1
    },
    /*::[*/ 0x0403: {
        T: -1
    },
    /*::[*/ 0x0404: {
        T: 1
    },
    /*::[*/ 0x0405: {
        T: -1
    },
    /*::[*/ 0x0406: {},
    /*::[*/ 0x0407: {
        T: 1
    },
    /*::[*/ 0x0408: {
        T: -1
    },
    /*::[*/ 0x0409: {
        T: 1
    },
    /*::[*/ 0x040A: {
        T: -1
    },
    /*::[*/ 0x040B: {},
    /*::[*/ 0x040C: {},
    /*::[*/ 0x040D: {},
    /*::[*/ 0x040E: {
        T: 1
    },
    /*::[*/ 0x040F: {
        T: -1
    },
    /*::[*/ 0x0410: {},
    /*::[*/ 0x0411: {
        T: 1
    },
    /*::[*/ 0x0412: {
        T: -1
    },
    /*::[*/ 0x0413: {},
    /*::[*/ 0x0414: {},
    /*::[*/ 0x0415: {},
    /*::[*/ 0x0416: {
        T: 1
    },
    /*::[*/ 0x0417: {
        T: -1
    },
    /*::[*/ 0x0418: {
        T: 1
    },
    /*::[*/ 0x0419: {
        T: -1
    },
    /*::[*/ 0x041A: {},
    /*::[*/ 0x041B: {
        T: 1
    },
    /*::[*/ 0x041C: {
        T: 1
    },
    /*::[*/ 0x041D: {
        f: $9d5117faee5c78f9$var$parse_BrtDVal14
    },
    /*::[*/ 0x041E: {
        T: 1
    },
    /*::[*/ 0x041F: {},
    /*::[*/ 0x0420: {
        T: 1
    },
    /*::[*/ 0x0421: {
        T: -1
    },
    /*::[*/ 0x0422: {
        T: 1
    },
    /*::[*/ 0x0423: {
        T: -1
    },
    /*::[*/ 0x0425: {},
    /*::[*/ 0x0426: {
        T: 1
    },
    /*::[*/ 0x0427: {
        T: -1
    },
    /*::[*/ 0x0428: {
        T: 1
    },
    /*::[*/ 0x0429: {
        T: -1
    },
    /*::[*/ 0x042A: {
        T: 1
    },
    /*::[*/ 0x042B: {
        T: -1
    },
    /*::[*/ 0x042C: {
        T: 1
    },
    /*::[*/ 0x042D: {
        T: -1
    },
    /*::[*/ 0x042E: {
        T: 1
    },
    /*::[*/ 0x042F: {
        T: -1
    },
    /*::[*/ 0x0430: {
        T: 1
    },
    /*::[*/ 0x0431: {
        T: -1
    },
    /*::[*/ 0x0433: {
        T: 1
    },
    /*::[*/ 0x0434: {
        T: -1
    },
    /*::[*/ 0x0435: {
        T: 1
    },
    /*::[*/ 0x0436: {
        T: -1
    },
    /*::[*/ 0x0437: {
        T: 1
    },
    /*::[*/ 0x0438: {
        T: -1
    },
    /*::[*/ 0x0439: {
        T: 1
    },
    /*::[*/ 0x043A: {
        T: -1
    },
    /*::[*/ 0x043B: {
        T: 1
    },
    /*::[*/ 0x043C: {
        T: -1
    },
    /*::[*/ 0x043D: {},
    /*::[*/ 0x043E: {
        T: 1
    },
    /*::[*/ 0x043F: {
        T: -1
    },
    /*::[*/ 0x0440: {
        T: 1
    },
    /*::[*/ 0x0441: {
        T: -1
    },
    /*::[*/ 0x0442: {
        T: 1
    },
    /*::[*/ 0x0443: {
        T: -1
    },
    /*::[*/ 0x0444: {
        T: 1
    },
    /*::[*/ 0x0445: {
        T: -1
    },
    /*::[*/ 0x0446: {
        T: 1
    },
    /*::[*/ 0x0447: {
        T: -1
    },
    /*::[*/ 0x0448: {},
    /*::[*/ 0x0449: {
        T: 1
    },
    /*::[*/ 0x044A: {},
    /*::[*/ 0x044B: {
        T: -1
    },
    /*::[*/ 0x044C: {
        T: 1
    },
    /*::[*/ 0x044D: {
        T: -1
    },
    /*::[*/ 0x044E: {},
    /*::[*/ 0x044F: {},
    /*::[*/ 0x0450: {},
    /*::[*/ 0x0451: {},
    /*::[*/ 0x0457: {},
    /*::[*/ 0x0458: {},
    /*::[*/ 0x0459: {
        T: 1
    },
    /*::[*/ 0x045A: {
        T: -1
    },
    /*::[*/ 0x045B: {
        T: 1
    },
    /*::[*/ 0x045C: {
        T: -1
    },
    /*::[*/ 0x045D: {},
    /*::[*/ 0x045E: {
        T: 1
    },
    /*::[*/ 0x045F: {
        T: -1
    },
    /*::[*/ 0x0460: {
        T: 1
    },
    /*::[*/ 0x0461: {
        T: -1
    },
    /*::[*/ 0x0462: {
        T: 1
    },
    /*::[*/ 0x0463: {
        T: -1
    },
    /*::[*/ 0x0464: {
        T: 1
    },
    /*::[*/ 0x0465: {
        T: -1
    },
    /*::[*/ 0x0466: {},
    /*::[*/ 0x0468: {
        T: 1
    },
    /*::[*/ 0x0469: {
        T: -1
    },
    /*::[*/ 0x046A: {},
    /*::[*/ 0x046B: {
        T: 1
    },
    /*::[*/ 0x046C: {
        T: -1
    },
    /*::[*/ 0x046D: {
        T: 1
    },
    /*::[*/ 0x046E: {
        T: -1
    },
    /*::[*/ 0x046F: {
        T: 1
    },
    /*::[*/ 0x0470: {
        T: -1
    },
    /*::[*/ 0x0471: {
        T: 1
    },
    /*::[*/ 0x0472: {
        T: -1
    },
    /*::[*/ 0x0473: {
        T: 1
    },
    /*::[*/ 0x0474: {
        T: -1
    },
    /*::[*/ 0x0475: {},
    /*::[*/ 0x0476: {
        T: 1
    },
    /*::[*/ 0x0477: {
        T: -1
    },
    /*::[*/ 0x0478: {
        T: 1
    },
    /*::[*/ 0x0479: {
        T: -1
    },
    /*::[*/ 0x047A: {},
    /*::[*/ 0x047B: {
        T: 1
    },
    /*::[*/ 0x047C: {
        T: -1
    },
    /*::[*/ 0x047D: {
        T: 1
    },
    /*::[*/ 0x047E: {
        T: -1
    },
    /*::[*/ 0x0480: {
        T: 1
    },
    /*::[*/ 0x0481: {
        T: -1
    },
    /*::[*/ 0x0482: {
        T: -1
    },
    /*::[*/ 0x0483: {
        T: -1
    },
    /*::[*/ 0x0484: {
        T: -1
    },
    /*::[*/ 0x0485: {
        T: 1
    },
    /*::[*/ 0x0486: {
        T: -1
    },
    /*::[*/ 0x0487: {
        T: 1
    },
    /*::[*/ 0x0488: {
        T: -1
    },
    /*::[*/ 0x0489: {
        T: 1
    },
    /*::[*/ 0x048A: {
        T: -1
    },
    /*::[*/ 0x048B: {
        T: 1
    },
    /*::[*/ 0x048C: {
        T: -1
    },
    /*::[*/ 0x048D: {
        T: 1
    },
    /*::[*/ 0x048E: {
        T: -1
    },
    /*::[*/ 0x048F: {
        T: 1
    },
    /*::[*/ 0x0490: {
        T: -1
    },
    /*::[*/ 0x0491: {
        T: 1
    },
    /*::[*/ 0x0492: {
        T: -1
    },
    /*::[*/ 0x0493: {},
    /*::[*/ 0x0494: {
        T: 1
    },
    /*::[*/ 0x0495: {
        T: -1
    },
    /*::[*/ 0x0499: {},
    /*::[*/ 0x049A: {
        T: 1
    },
    /*::[*/ 0x049C: {},
    /*::[*/ 0x049D: {},
    /*::[*/ 0x049E: {},
    /*::[*/ 0x0800: {
        T: 1
    },
    /*::[*/ 0x0801: {
        T: -1
    },
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {
        T: 1
    },
    /*::[*/ 0x0804: {
        T: -1
    },
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {
        T: 1
    },
    /*::[*/ 0x0808: {
        T: -1
    },
    /*::[*/ 0x0809: {
        T: 1
    },
    /*::[*/ 0x080A: {
        T: -1
    },
    /*::[*/ 0x080C: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0814: {
        T: 1
    },
    /*::[*/ 0x0815: {
        T: -1
    },
    /*::[*/ 0x0816: {},
    /*::[*/ 0x0817: {},
    /*::[*/ 0x0818: {
        T: 1
    },
    /*::[*/ 0x0819: {
        T: -1
    },
    /*::[*/ 0x081B: {},
    /*::[*/ 0x081C: {},
    /*::[*/ 0x081D: {
        T: 1
    },
    /*::[*/ 0x081E: {
        T: -1
    },
    /*::[*/ 0x081F: {},
    /*::[*/ 0x0820: {
        T: 1
    },
    /*::[*/ 0x0821: {
        T: -1
    },
    /*::[*/ 0x0822: {},
    /*::[*/ 0x0823: {
        T: 1
    },
    /*::[*/ 0x0824: {
        T: -1
    },
    /*::[*/ 0x0825: {
        T: 1
    },
    /*::[*/ 0x0826: {
        T: -1
    },
    /*::[*/ 0x0827: {
        T: 1
    },
    /*::[*/ 0x0828: {
        T: -1
    },
    /*::[*/ 0x0829: {
        T: 1
    },
    /*::[*/ 0x082A: {
        T: -1
    },
    /*::[*/ 0x082B: {},
    /*::[*/ 0x082C: {},
    /*::[*/ 0x082D: {
        T: 1
    },
    /*::[*/ 0x082E: {
        T: -1
    },
    /*::[*/ 0x082F: {},
    /*::[*/ 0x0830: {
        T: 1
    },
    /*::[*/ 0x0831: {
        T: -1
    },
    /*::[*/ 0x0832: {
        T: 1
    },
    /*::[*/ 0x0833: {
        T: -1
    },
    /*::[*/ 0x0834: {
        T: 1
    },
    /*::[*/ 0x0835: {
        T: -1
    },
    /*::[*/ 0x0836: {},
    /*::[*/ 0x0837: {
        T: 1
    },
    /*::[*/ 0x0838: {
        T: -1
    },
    /*::[*/ 0x0839: {},
    /*::[*/ 0x083A: {
        T: 1
    },
    /*::[*/ 0x083B: {
        T: -1
    },
    /*::[*/ 0x083C: {},
    /*::[*/ 0x083D: {
        T: 1
    },
    /*::[*/ 0x083E: {
        T: -1
    },
    /*::[*/ 0x083F: {
        T: 1
    },
    /*::[*/ 0x0840: {
        T: -1
    },
    /*::[*/ 0x0841: {
        T: 1
    },
    /*::[*/ 0x0842: {
        T: -1
    },
    /*::[*/ 0x0843: {},
    /*::[*/ 0x0844: {},
    /*::[*/ 0x0845: {},
    /*::[*/ 0x0846: {
        T: 1
    },
    /*::[*/ 0x0847: {
        T: -1
    },
    /*::[*/ 0x0848: {},
    /*::[*/ 0x0849: {
        T: 1
    },
    /*::[*/ 0x084A: {
        T: -1
    },
    /*::[*/ 0x084B: {
        T: 1
    },
    /*::[*/ 0x084C: {
        T: -1
    },
    /*::[*/ 0x084D: {},
    /*::[*/ 0x084E: {
        T: 1
    },
    /*::[*/ 0x084F: {
        T: -1
    },
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {
        T: 1
    },
    /*::[*/ 0x0852: {
        T: -1
    },
    /*::[*/ 0x0853: {
        T: 1
    },
    /*::[*/ 0x0854: {
        T: -1
    },
    /*::[*/ 0x0855: {
        T: 1
    },
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {
        T: 1
    },
    /*::[*/ 0x085A: {
        T: -1
    },
    /*::[*/ 0x085B: {
        T: 1
    },
    /*::[*/ 0x085C: {
        T: -1
    },
    /*::[*/ 0x085D: {},
    /*::[*/ 0x0C00: {},
    /*::[*/ 0x0C01: {},
    /*::[*/ 0x1000: {
        T: 1
    },
    /*::[*/ 0x1001: {
        T: -1
    },
    /*::[*/ 0x138A: {
        T: 1
    },
    /*::[*/ 0x138B: {
        T: -1
    },
    /*::[*/ 0x13D9: {
        T: 1
    },
    /*::[*/ 0x13DA: {
        T: -1
    },
    /*::[*/ 0x13DB: {},
    /*::[*/ 0x13DC: {
        T: 1
    },
    /*::[*/ 0x13DD: {
        T: -1
    },
    /*::[*/ 0x13DE: {
        T: 1
    },
    /*::[*/ 0x13DF: {
        T: -1
    },
    /*::[*/ 0x13E0: {},
    /*::[*/ 0x13E1: {},
    /*::[*/ 0x13E2: {},
    /*::[*/ 0x13E4: {
        T: 1
    },
    /*::[*/ 0x13E5: {
        T: -1
    },
    /*::[*/ 0x13E6: {},
    /*::[*/ 0x13E7: {
        T: 1
    },
    /*::[*/ 0x13E8: {
        T: -1
    },
    /*::[*/ 0x13E9: {},
    /*::[*/ 0x13EB: {},
    /*::[*/ 0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $9d5117faee5c78f9$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ /*::[*/ 0x0006: {
        f: $9d5117faee5c78f9$var$parse_Formula
    },
    /*::[*/ 0x000a: {
        f: $9d5117faee5c78f9$var$parsenoop2
    },
    /*::[*/ 0x000c: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x000d: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x000e: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x000f: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x0010: {
        f: $9d5117faee5c78f9$var$parse_Xnum
    },
    /*::[*/ 0x0011: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x0012: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x0013: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x0014: {
        f: $9d5117faee5c78f9$var$parse_XLHeaderFooter
    },
    /*::[*/ 0x0015: {
        f: $9d5117faee5c78f9$var$parse_XLHeaderFooter
    },
    /*::[*/ 0x0017: {
        f: $9d5117faee5c78f9$var$parse_ExternSheet
    },
    /*::[*/ 0x0018: {
        f: $9d5117faee5c78f9$var$parse_Lbl
    },
    /*::[*/ 0x0019: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x001a: {},
    /*::[*/ 0x001b: {},
    /*::[*/ 0x001c: {
        f: $9d5117faee5c78f9$var$parse_Note
    },
    /*::[*/ 0x001d: {},
    /*::[*/ 0x0022: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x0023: {
        f: $9d5117faee5c78f9$var$parse_ExternName
    },
    /*::[*/ 0x0026: {
        f: $9d5117faee5c78f9$var$parse_Xnum
    },
    /*::[*/ 0x0027: {
        f: $9d5117faee5c78f9$var$parse_Xnum
    },
    /*::[*/ 0x0028: {
        f: $9d5117faee5c78f9$var$parse_Xnum
    },
    /*::[*/ 0x0029: {
        f: $9d5117faee5c78f9$var$parse_Xnum
    },
    /*::[*/ 0x002a: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x002b: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x002f: {
        f: $9d5117faee5c78f9$var$parse_FilePass
    },
    /*::[*/ 0x0031: {
        f: $9d5117faee5c78f9$var$parse_Font
    },
    /*::[*/ 0x0033: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x003c: {},
    /*::[*/ 0x003d: {
        f: $9d5117faee5c78f9$var$parse_Window1
    },
    /*::[*/ 0x0040: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x0041: {
        f: $9d5117faee5c78f9$var$parse_Pane
    },
    /*::[*/ 0x0042: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x004d: {},
    /*::[*/ 0x0050: {},
    /*::[*/ 0x0051: {},
    /*::[*/ 0x0052: {},
    /*::[*/ 0x0055: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x0059: {},
    /*::[*/ 0x005a: {},
    /*::[*/ 0x005b: {},
    /*::[*/ 0x005c: {
        f: $9d5117faee5c78f9$var$parse_WriteAccess
    },
    /*::[*/ 0x005d: {
        f: $9d5117faee5c78f9$var$parse_Obj
    },
    /*::[*/ 0x005e: {},
    /*::[*/ 0x005f: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x0060: {},
    /*::[*/ 0x0061: {},
    /*::[*/ 0x0063: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x007d: {
        f: $9d5117faee5c78f9$var$parse_ColInfo
    },
    /*::[*/ 0x0080: {
        f: $9d5117faee5c78f9$var$parse_Guts
    },
    /*::[*/ 0x0081: {
        f: $9d5117faee5c78f9$var$parse_WsBool
    },
    /*::[*/ 0x0082: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x0083: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x0084: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x0085: {
        f: $9d5117faee5c78f9$var$parse_BoundSheet8
    },
    /*::[*/ 0x0086: {},
    /*::[*/ 0x008c: {
        f: $9d5117faee5c78f9$var$parse_Country
    },
    /*::[*/ 0x008d: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x0090: {},
    /*::[*/ 0x0092: {
        f: $9d5117faee5c78f9$var$parse_Palette
    },
    /*::[*/ 0x0097: {},
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {},
    /*::[*/ 0x009a: {},
    /*::[*/ 0x009b: {},
    /*::[*/ 0x009c: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x009d: {},
    /*::[*/ 0x009e: {},
    /*::[*/ 0x00a0: {
        f: $9d5117faee5c78f9$var$parse_Scl
    },
    /*::[*/ 0x00a1: {
        f: $9d5117faee5c78f9$var$parse_Setup
    },
    /*::[*/ 0x00ae: {},
    /*::[*/ 0x00af: {},
    /*::[*/ 0x00b0: {},
    /*::[*/ 0x00b1: {},
    /*::[*/ 0x00b2: {},
    /*::[*/ 0x00b4: {},
    /*::[*/ 0x00b5: {},
    /*::[*/ 0x00b6: {},
    /*::[*/ 0x00b8: {},
    /*::[*/ 0x00b9: {},
    /*::[*/ 0x00bd: {
        f: $9d5117faee5c78f9$var$parse_MulRk
    },
    /*::[*/ 0x00be: {
        f: $9d5117faee5c78f9$var$parse_MulBlank
    },
    /*::[*/ 0x00c1: {
        f: $9d5117faee5c78f9$var$parsenoop2
    },
    /*::[*/ 0x00c5: {},
    /*::[*/ 0x00c6: {},
    /*::[*/ 0x00c7: {},
    /*::[*/ 0x00c8: {},
    /*::[*/ 0x00c9: {},
    /*::[*/ 0x00ca: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x00cb: {},
    /*::[*/ 0x00cc: {},
    /*::[*/ 0x00cd: {},
    /*::[*/ 0x00ce: {},
    /*::[*/ 0x00cf: {},
    /*::[*/ 0x00d0: {},
    /*::[*/ 0x00d1: {},
    /*::[*/ 0x00d2: {},
    /*::[*/ 0x00d3: {},
    /*::[*/ 0x00d5: {},
    /*::[*/ 0x00d7: {},
    /*::[*/ 0x00d8: {},
    /*::[*/ 0x00d9: {},
    /*::[*/ 0x00da: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x00dc: {},
    /*::[*/ 0x00dd: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x00de: {},
    /*::[*/ 0x00e0: {
        f: $9d5117faee5c78f9$var$parse_XF
    },
    /*::[*/ 0x00e1: {
        f: $9d5117faee5c78f9$var$parse_InterfaceHdr
    },
    /*::[*/ 0x00e2: {
        f: $9d5117faee5c78f9$var$parsenoop2
    },
    /*::[*/ 0x00e3: {},
    /*::[*/ 0x00e5: {
        f: $9d5117faee5c78f9$var$parse_MergeCells
    },
    /*::[*/ 0x00e9: {},
    /*::[*/ 0x00eb: {},
    /*::[*/ 0x00ec: {},
    /*::[*/ 0x00ed: {},
    /*::[*/ 0x00ef: {},
    /*::[*/ 0x00f0: {},
    /*::[*/ 0x00f1: {},
    /*::[*/ 0x00f2: {},
    /*::[*/ 0x00f4: {},
    /*::[*/ 0x00f5: {},
    /*::[*/ 0x00f6: {},
    /*::[*/ 0x00f7: {},
    /*::[*/ 0x00f8: {},
    /*::[*/ 0x00f9: {},
    /*::[*/ 0x00fb: {},
    /*::[*/ 0x00fc: {
        f: $9d5117faee5c78f9$var$parse_SST
    },
    /*::[*/ 0x00fd: {
        f: $9d5117faee5c78f9$var$parse_LabelSst
    },
    /*::[*/ 0x00ff: {
        f: $9d5117faee5c78f9$var$parse_ExtSST
    },
    /*::[*/ 0x0100: {},
    /*::[*/ 0x0103: {},
    /*::[*/ 0x0122: {},
    /*::[*/ 0x0137: {},
    /*::[*/ 0x0138: {},
    /*::[*/ 0x013b: {},
    /*::[*/ 0x013d: {
        f: $9d5117faee5c78f9$var$parseuint16a
    },
    /*::[*/ 0x013e: {},
    /*::[*/ 0x013f: {},
    /*::[*/ 0x0140: {},
    /*::[*/ 0x014a: {},
    /*::[*/ 0x014b: {},
    /*::[*/ 0x014d: {},
    /*::[*/ 0x014e: {},
    /*::[*/ 0x014f: {},
    /*::[*/ 0x0150: {},
    /*::[*/ 0x0151: {},
    /*::[*/ 0x0152: {},
    /*::[*/ 0x0153: {},
    /*::[*/ 0x0154: {},
    /*::[*/ 0x015f: {},
    /*::[*/ 0x0160: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x0161: {
        f: $9d5117faee5c78f9$var$parsenoop2
    },
    /*::[*/ 0x0191: {},
    /*::[*/ 0x0192: {},
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x01a9: {},
    /*::[*/ 0x01aa: {},
    /*::[*/ 0x01ab: {},
    /*::[*/ 0x01ac: {},
    /*::[*/ 0x01ad: {},
    /*::[*/ 0x01ae: {
        f: $9d5117faee5c78f9$var$parse_SupBook
    },
    /*::[*/ 0x01af: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x01b0: {},
    /*::[*/ 0x01b1: {},
    /*::[*/ 0x01b2: {},
    /*::[*/ 0x01b5: {},
    /*::[*/ 0x01b6: {
        f: $9d5117faee5c78f9$var$parse_TxO
    },
    /*::[*/ 0x01b7: {
        f: $9d5117faee5c78f9$var$parsebool
    },
    /*::[*/ 0x01b8: {
        f: $9d5117faee5c78f9$var$parse_HLink
    },
    /*::[*/ 0x01b9: {},
    /*::[*/ 0x01ba: {
        f: $9d5117faee5c78f9$var$parse_XLUnicodeString
    },
    /*::[*/ 0x01bb: {},
    /*::[*/ 0x01bc: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x01bd: {},
    /*::[*/ 0x01be: {},
    /*::[*/ 0x01c0: {
        f: $9d5117faee5c78f9$var$parsenoop2
    },
    /*::[*/ 0x01c1: {
        f: $9d5117faee5c78f9$var$parse_RecalcId,
        r: 2
    },
    /*::[*/ 0x01c2: {
        f: $9d5117faee5c78f9$var$parsenoop2
    },
    /*::[*/ 0x0200: {
        f: $9d5117faee5c78f9$var$parse_Dimensions
    },
    /*::[*/ 0x0201: {
        f: $9d5117faee5c78f9$var$parse_Blank
    },
    /*::[*/ 0x0203: {
        f: $9d5117faee5c78f9$var$parse_Number
    },
    /*::[*/ 0x0204: {
        f: $9d5117faee5c78f9$var$parse_Label
    },
    /*::[*/ 0x0205: {
        f: $9d5117faee5c78f9$var$parse_BoolErr
    },
    /*::[*/ 0x0207: {
        f: $9d5117faee5c78f9$var$parse_String
    },
    /*::[*/ 0x0208: {
        f: $9d5117faee5c78f9$var$parse_Row
    },
    /*::[*/ 0x020b: {},
    /*::[*/ 0x0221: {
        f: $9d5117faee5c78f9$var$parse_Array
    },
    /*::[*/ 0x0225: {
        f: $9d5117faee5c78f9$var$parse_DefaultRowHeight
    },
    /*::[*/ 0x0236: {},
    /*::[*/ 0x023e: {
        f: $9d5117faee5c78f9$var$parse_Window2
    },
    /*::[*/ 0x027e: {
        f: $9d5117faee5c78f9$var$parse_RK
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0418: {},
    /*::[*/ 0x041e: {
        f: $9d5117faee5c78f9$var$parse_Format
    },
    /*::[*/ 0x043c: {},
    /*::[*/ 0x04bc: {
        f: $9d5117faee5c78f9$var$parse_ShrFmla
    },
    /*::[*/ 0x0800: {
        f: $9d5117faee5c78f9$var$parse_HLinkTooltip
    },
    /*::[*/ 0x0801: {},
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {},
    /*::[*/ 0x0804: {},
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {},
    /*::[*/ 0x0808: {},
    /*::[*/ 0x0809: {
        f: $9d5117faee5c78f9$var$parse_BOF
    },
    /*::[*/ 0x080a: {},
    /*::[*/ 0x080b: {},
    /*::[*/ 0x080c: {},
    /*::[*/ 0x080d: {},
    /*::[*/ 0x080e: {},
    /*::[*/ 0x080f: {},
    /*::[*/ 0x0810: {},
    /*::[*/ 0x0812: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {},
    /*::[*/ 0x0852: {},
    /*::[*/ 0x0853: {},
    /*::[*/ 0x0854: {},
    /*::[*/ 0x0855: {},
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {},
    /*::[*/ 0x085a: {},
    /*::[*/ 0x0862: {},
    /*::[*/ 0x0863: {
        r: 12
    },
    /*::[*/ 0x0864: {},
    /*::[*/ 0x0865: {},
    /*::[*/ 0x0866: {},
    /*::[*/ 0x0867: {
        f: $9d5117faee5c78f9$var$parsenoop2
    },
    /*::[*/ 0x0868: {},
    /*::[*/ 0x086a: {},
    /*::[*/ 0x086b: {},
    /*::[*/ 0x086c: {},
    /*::[*/ 0x0871: {},
    /*::[*/ 0x0872: {},
    /*::[*/ 0x0874: {},
    /*::[*/ 0x0875: {},
    /*::[*/ 0x0876: {},
    /*::[*/ 0x0877: {},
    /*::[*/ 0x0878: {},
    /*::[*/ 0x0879: {},
    /*::[*/ 0x087a: {},
    /*::[*/ 0x087b: {},
    /*::[*/ 0x087c: {
        f: $9d5117faee5c78f9$var$parse_XFCRC,
        r: 12
    },
    /*::[*/ 0x087d: {
        f: $9d5117faee5c78f9$var$parse_XFExt,
        r: 12
    },
    /*::[*/ 0x087e: {},
    /*::[*/ 0x087f: {},
    /*::[*/ 0x0884: {},
    /*::[*/ 0x0885: {},
    /*::[*/ 0x0886: {},
    /*::[*/ 0x0887: {},
    /*::[*/ 0x0888: {},
    /*::[*/ 0x0889: {},
    /*::[*/ 0x088a: {},
    /*::[*/ 0x088b: {},
    /*::[*/ 0x088c: {
        f: $9d5117faee5c78f9$var$parsebool,
        r: 12
    },
    /*::[*/ 0x088d: {},
    /*::[*/ 0x088e: {
        r: 12
    },
    /*::[*/ 0x088f: {},
    /*::[*/ 0x0890: {},
    /*::[*/ 0x0892: {},
    /*::[*/ 0x0893: {},
    /*::[*/ 0x0894: {
        f: $9d5117faee5c78f9$var$parse_NameCmt,
        r: 12
    },
    /*::[*/ 0x0895: {},
    /*::[*/ 0x0896: {
        f: $9d5117faee5c78f9$var$parse_Theme,
        r: 12
    },
    /*::[*/ 0x0897: {},
    /*::[*/ 0x0898: {},
    /*::[*/ 0x0899: {},
    /*::[*/ 0x089a: {
        f: $9d5117faee5c78f9$var$parse_MTRSettings,
        r: 12
    },
    /*::[*/ 0x089b: {
        f: $9d5117faee5c78f9$var$parsenoop2
    },
    /*::[*/ 0x089c: {},
    /*::[*/ 0x089d: {},
    /*::[*/ 0x089e: {},
    /*::[*/ 0x089f: {},
    /*::[*/ 0x08a3: {
        f: $9d5117faee5c78f9$var$parse_ForceFullCalculation
    },
    /*::[*/ 0x08a4: {},
    /*::[*/ 0x08a5: {},
    /*::[*/ 0x08a6: {},
    /*::[*/ 0x08a7: {},
    /*::[*/ 0x1001: {},
    /*::[*/ 0x1002: {},
    /*::[*/ 0x1003: {},
    /*::[*/ 0x1006: {},
    /*::[*/ 0x1007: {},
    /*::[*/ 0x1009: {},
    /*::[*/ 0x100a: {},
    /*::[*/ 0x100b: {},
    /*::[*/ 0x100c: {},
    /*::[*/ 0x100d: {},
    /*::[*/ 0x1014: {},
    /*::[*/ 0x1015: {},
    /*::[*/ 0x1016: {},
    /*::[*/ 0x1017: {},
    /*::[*/ 0x1018: {},
    /*::[*/ 0x1019: {},
    /*::[*/ 0x101a: {},
    /*::[*/ 0x101b: {},
    /*::[*/ 0x101c: {},
    /*::[*/ 0x101d: {},
    /*::[*/ 0x101e: {},
    /*::[*/ 0x101f: {},
    /*::[*/ 0x1020: {},
    /*::[*/ 0x1021: {},
    /*::[*/ 0x1022: {},
    /*::[*/ 0x1024: {},
    /*::[*/ 0x1025: {},
    /*::[*/ 0x1026: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x1027: {},
    /*::[*/ 0x1032: {},
    /*::[*/ 0x1033: {},
    /*::[*/ 0x1034: {},
    /*::[*/ 0x1035: {},
    /*::[*/ 0x103a: {},
    /*::[*/ 0x103c: {},
    /*::[*/ 0x103d: {},
    /*::[*/ 0x103e: {},
    /*::[*/ 0x103f: {},
    /*::[*/ 0x1040: {},
    /*::[*/ 0x1041: {},
    /*::[*/ 0x1043: {},
    /*::[*/ 0x1044: {
        f: $9d5117faee5c78f9$var$parse_ShtProps
    },
    /*::[*/ 0x1045: {},
    /*::[*/ 0x1046: {},
    /*::[*/ 0x1048: {},
    /*::[*/ 0x104a: {},
    /*::[*/ 0x104b: {},
    /*::[*/ 0x104e: {},
    /*::[*/ 0x104f: {},
    /*::[*/ 0x1050: {},
    /*::[*/ 0x1051: {},
    /*::[*/ 0x105b: {},
    /*::[*/ 0x105c: {
        f: $9d5117faee5c78f9$var$parse_ClrtClient
    },
    /*::[*/ 0x105d: {},
    /*::[*/ 0x105f: {},
    /*::[*/ 0x1060: {},
    /*::[*/ 0x1061: {},
    /*::[*/ 0x1062: {},
    /*::[*/ 0x1063: {},
    /*::[*/ 0x1064: {},
    /*::[*/ 0x1065: {},
    /*::[*/ 0x1066: {},
    /*::[*/ 0x1067: {},
    /*::[*/ 0x1068: {},
    /*::[*/ 0x0000: {
        f: $9d5117faee5c78f9$var$parse_Dimensions
    },
    /*::[*/ 0x0001: {},
    /*::[*/ 0x0002: {
        f: $9d5117faee5c78f9$var$parse_BIFF2INT
    },
    /*::[*/ 0x0003: {
        f: $9d5117faee5c78f9$var$parse_BIFF2NUM
    },
    /*::[*/ 0x0004: {
        f: $9d5117faee5c78f9$var$parse_BIFF2STR
    },
    /*::[*/ 0x0005: {
        f: $9d5117faee5c78f9$var$parse_BoolErr
    },
    /*::[*/ 0x0007: {
        f: $9d5117faee5c78f9$var$parse_BIFF2STRING
    },
    /*::[*/ 0x0008: {},
    /*::[*/ 0x0009: {
        f: $9d5117faee5c78f9$var$parse_BOF
    },
    /*::[*/ 0x000b: {},
    /*::[*/ 0x0016: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x001e: {
        f: $9d5117faee5c78f9$var$parse_BIFF2Format
    },
    /*::[*/ 0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {
        f: $9d5117faee5c78f9$var$parse_Array
    },
    /*::[*/ 0x0024: {},
    /*::[*/ 0x0025: {
        f: $9d5117faee5c78f9$var$parse_DefaultRowHeight
    },
    // 0x2c ??
    // 0x2d ??
    // 0x2e ??
    // 0x30 FONTCOUNT: number of fonts
    /*::[*/ 0x0032: {
        f: $9d5117faee5c78f9$var$parse_BIFF2FONTXTRA
    },
    // 0x35: INFOOPTS
    // 0x36: TABLE (BIFF2 only)
    // 0x37: TABLE2 (BIFF2 only)
    // 0x38: WNDESK
    // 0x39 ??
    // 0x3a: BEGINPREF
    // 0x3b: ENDPREF
    /*::[*/ 0x003e: {},
    // 0x3f ??
    // 0x46: SHOWSCROLL
    // 0x47: SHOWFORMULA
    // 0x48: STATUSBAR
    // 0x49: SHORTMENUS
    // 0x4A:
    // 0x4B:
    // 0x4C:
    // 0x4E:
    // 0x4F:
    // 0x58: TOOLBAR (BIFF3)
    /* - - - */ /*::[*/ 0x0034: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {
        f: $9d5117faee5c78f9$var$parseuint16
    },
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ /*::[*/ 0x007e: {},
    /* Not necessarily same as 0x027e */ /*::[*/ 0x007f: {
        f: $9d5117faee5c78f9$var$parse_ImData
    },
    /*::[*/ 0x0087: {},
    /*::[*/ 0x0088: {},
    /*::[*/ 0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    // 0x8F
    /*::[*/ 0x0091: {},
    // 0x93 STYLE
    /*::[*/ 0x0094: {},
    /*::[*/ 0x0095: {},
    /*::[*/ 0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    /*::[*/ 0x00a9: {},
    /*::[*/ 0x00ab: {},
    /*::[*/ 0x00bc: {},
    /* Not necessarily same as 0x04bc */ /*::[*/ 0x00bf: {},
    /*::[*/ 0x00c0: {},
    /*::[*/ 0x00c2: {},
    /*::[*/ 0x00c3: {},
    /*::[*/ 0x00d6: {
        f: $9d5117faee5c78f9$var$parse_RString
    },
    /*::[*/ 0x00df: {},
    /*::[*/ 0x00ea: {},
    /*::[*/ 0x0162: {},
    /*::[*/ 0x01a5: {},
    /*::[*/ 0x0206: {
        f: $9d5117faee5c78f9$var$parse_Formula
    },
    /*::[*/ 0x0209: {
        f: $9d5117faee5c78f9$var$parse_BOF
    },
    /*::[*/ 0x0218: {
        f: $9d5117faee5c78f9$var$parse_Lbl
    },
    /*::[*/ 0x0223: {
        f: $9d5117faee5c78f9$var$parse_ExternName
    },
    /*::[*/ 0x0231: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0406: {
        f: $9d5117faee5c78f9$var$parse_Formula
    },
    /*::[*/ 0x0409: {
        f: $9d5117faee5c78f9$var$parse_BOF
    },
    /*::[*/ 0x0443: {},
    /*::[*/ 0x086d: {},
    /*::[*/ 0x0873: {},
    /*::[*/ 0x0881: {},
    /*::[*/ 0x08c0: {},
    /*::[*/ 0x08c1: {},
    /*::[*/ 0x08c2: {},
    /*::[*/ 0x08c3: {},
    /*::[*/ 0x08c4: {},
    /*::[*/ 0x08c5: {},
    /*::[*/ 0x08c6: {},
    /*::[*/ 0x08c7: {},
    /*::[*/ 0x08c8: {},
    /*::[*/ 0x08c9: {},
    /*::[*/ 0x08ca: {},
    /*::[*/ 0x08cb: {},
    /*::[*/ 0x08d6: {
        r: 12
    },
    /* --- multiplan 4 records --- */ /*::[*/ 0x0065: {},
    /*::[*/ 0x0066: {},
    /*::[*/ 0x0069: {},
    /*::[*/ 0x006a: {},
    /*::[*/ 0x006b: {},
    /*::[*/ 0x006d: {},
    /*::[*/ 0x0070: {},
    /*::[*/ 0x0072: {},
    /*::[*/ 0x7262: {}
};
function $9d5117faee5c78f9$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $9d5117faee5c78f9$var$is_buf(payload)) ba.push(payload);
}
function $9d5117faee5c78f9$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $9d5117faee5c78f9$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $9d5117faee5c78f9$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ ) {
    if (!out) out = $9d5117faee5c78f9$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(2, 0);
    out.write_shift(1, 0);
    return out;
}
function $9d5117faee5c78f9$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val, t /*:?string*/ ) {
    var out = $9d5117faee5c78f9$var$new_buf(9);
    $9d5117faee5c78f9$var$write_BIFF2Cell(out, r, c);
    $9d5117faee5c78f9$var$write_Bes(val, t || 'b', out);
    return out;
}
/* TODO: codepage, large strings */ function $9d5117faee5c78f9$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val) {
    var out = $9d5117faee5c78f9$var$new_buf(8 + 2 * val.length);
    $9d5117faee5c78f9$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val.length);
    out.write_shift(val.length, val, 'sbcs');
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $9d5117faee5c78f9$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) {
    if (cell.v != null) switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $9d5117faee5c78f9$var$datenum($9d5117faee5c78f9$var$parseDate(cell.v)) : cell.v;
            if (v == (v | 0) && v >= 0 && v < 65536) $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0002, $9d5117faee5c78f9$var$write_BIFF2INT(R, C, v));
            else $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0003, $9d5117faee5c78f9$var$write_BIFF2NUM(R, C, v));
            return;
        case 'b':
        case 'e':
            $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0005, $9d5117faee5c78f9$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0004, $9d5117faee5c78f9$var$write_BIFF2LABEL(R, C, cell.v == null ? "" : String(cell.v).slice(0, 255)));
            return;
    }
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0001, $9d5117faee5c78f9$var$write_BIFF2Cell(null, R, C));
}
function $9d5117faee5c78f9$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var dense = ws["!data"] != null;
    var range = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref'] || "A1"), ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, 0x3FFF);
    }
    var row = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $9d5117faee5c78f9$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $9d5117faee5c78f9$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $9d5117faee5c78f9$var$write_ws_biff2_cell(ba, cell, R, C, opts);
        }
    }
}
/* Based on test files */ function $9d5117faee5c78f9$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var ba = $9d5117faee5c78f9$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $9d5117faee5c78f9$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $9d5117faee5c78f9$var$write_BOF(wb, 0x10, o));
    /* ... */ $9d5117faee5c78f9$var$write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    /* ... */ $9d5117faee5c78f9$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
function $9d5117faee5c78f9$var$write_FONTS_biff8(ba, data, opts) {
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0031 /* Font */ , $9d5117faee5c78f9$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $9d5117faee5c78f9$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $9d5117faee5c78f9$var$write_biff_rec(ba, 0x041E /* Format */ , $9d5117faee5c78f9$var$write_Format(i, NF[i], opts));
    });
}
function $9d5117faee5c78f9$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $9d5117faee5c78f9$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $9d5117faee5c78f9$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $9d5117faee5c78f9$var$write_Ref8U($9d5117faee5c78f9$var$safe_decode_range(ws['!ref'] || "A1"), o);
    o.write_shift(4, 4);
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $9d5117faee5c78f9$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$9d5117faee5c78f9$var$write_biff_rec(ba, 0x00e0 /* XF */ , $9d5117faee5c78f9$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $9d5117faee5c78f9$var$write_biff_rec(ba, 0x00e0 /* XF */ , $9d5117faee5c78f9$var$write_XF(c, 0, opts));
    });
}
function $9d5117faee5c78f9$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws['!links'].length; ++R){
        var HL = ws['!links'][R];
        $9d5117faee5c78f9$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $9d5117faee5c78f9$var$write_HLink(HL));
        if (HL[1].Tooltip) $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $9d5117faee5c78f9$var$write_HLinkTooltip(HL));
    }
    delete ws['!links'];
}
function $9d5117faee5c78f9$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $9d5117faee5c78f9$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $9d5117faee5c78f9$var$write_ColInfo($9d5117faee5c78f9$var$col_obj_w(idx, col), idx));
    });
}
function $9d5117faee5c78f9$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts) {
    var os = 16 + $9d5117faee5c78f9$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0201 /* Blank */ , $9d5117faee5c78f9$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0006 /* Formula */ , $9d5117faee5c78f9$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $9d5117faee5c78f9$var$datenum($9d5117faee5c78f9$var$parseDate(cell.v)) : cell.v;
            /* TODO: emit RK as appropriate */ $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0203 /* Number */ , $9d5117faee5c78f9$var$write_Number(R, C, v, os, opts));
            break;
        case 'b':
        case 'e':
            $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $9d5117faee5c78f9$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            if (opts.bookSST) {
                var isst = $9d5117faee5c78f9$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                $9d5117faee5c78f9$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $9d5117faee5c78f9$var$write_LabelSst(R, C, isst, os, opts));
            } else $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0204 /* Label */ , $9d5117faee5c78f9$var$write_Label(R, C, (cell.v == null ? "" : String(cell.v)).slice(0, 255), os, opts));
            break;
        default:
            $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0201 /* Blank */ , $9d5117faee5c78f9$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $9d5117faee5c78f9$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $9d5117faee5c78f9$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = ws["!data"] != null;
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref'] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, MAX_ROWS - 1);
    }
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0809, $9d5117faee5c78f9$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $9d5117faee5c78f9$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $9d5117faee5c78f9$var$writeuint16(1));
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $9d5117faee5c78f9$var$writeuint16(100));
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $9d5117faee5c78f9$var$writebool(true));
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $9d5117faee5c78f9$var$writebool(false));
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $9d5117faee5c78f9$var$write_Xnum(0.001));
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $9d5117faee5c78f9$var$writebool(true));
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $9d5117faee5c78f9$var$writebool(false));
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $9d5117faee5c78f9$var$writebool(false));
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $9d5117faee5c78f9$var$writeuint16(1));
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0080 /* Guts */ , $9d5117faee5c78f9$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $9d5117faee5c78f9$var$writebool(false));
    $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $9d5117faee5c78f9$var$writebool(false));
    /* ... */ if (b8) $9d5117faee5c78f9$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $9d5117faee5c78f9$var$write_biff_rec(ba, 0x0200 /* Dimensions */ , $9d5117faee5c78f9$var$write_Dimensions(range, opts));
    /* ... */ if (b8) ws['!links'] = [];
    var comments = [];
    var row = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $9d5117faee5c78f9$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $9d5117faee5c78f9$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var cell = dense ? row[C] : ws[ref];
            if (!cell) continue;
            /* write cell */ $9d5117faee5c78f9$var$write_ws_biff8_cell(ba, cell, R, C, opts);
            if (b8 && cell.l) ws['!links'].push([
                ref,
                cell.l
            ]);
            if (b8 && cell.c) comments.push([
                ref,
                cell.c
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ // if(b8) comments.forEach(function(comment) { write_biff_rec(ba, 0x001c /* Note */, write_NoteSh(comment)); });
    /* ... */ if (b8) $9d5117faee5c78f9$var$write_biff_rec(ba, 0x023e /* Window2 */ , $9d5117faee5c78f9$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws['!merges'] || []).length) $9d5117faee5c78f9$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $9d5117faee5c78f9$var$write_MergeCells(ws['!merges']));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $9d5117faee5c78f9$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $9d5117faee5c78f9$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $9d5117faee5c78f9$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $9d5117faee5c78f9$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $9d5117faee5c78f9$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $9d5117faee5c78f9$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $9d5117faee5c78f9$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x0809, $9d5117faee5c78f9$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $9d5117faee5c78f9$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $9d5117faee5c78f9$var$writeuint16(0x04b0) : null);
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x00c1 /* Mms */ , $9d5117faee5c78f9$var$writezeroes(2));
    if (b5) $9d5117faee5c78f9$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $9d5117faee5c78f9$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $9d5117faee5c78f9$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $9d5117faee5c78f9$var$write_biff_rec(A, 0x0042 /* CodePage */ , $9d5117faee5c78f9$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $9d5117faee5c78f9$var$write_biff_rec(A, 0x0161 /* DSF */ , $9d5117faee5c78f9$var$writeuint16(0));
    if (b8) $9d5117faee5c78f9$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x013d /* RRTabId */ , $9d5117faee5c78f9$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $9d5117faee5c78f9$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $9d5117faee5c78f9$var$write_biff_rec(A, 0x01ba /* CodeName */ , $9d5117faee5c78f9$var$write_XLUnicodeString(cname, opts));
    }
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $9d5117faee5c78f9$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $9d5117faee5c78f9$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $9d5117faee5c78f9$var$writebool(false));
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x0012 /* Protect */ , $9d5117faee5c78f9$var$writebool(false));
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x0013 /* Password */ , $9d5117faee5c78f9$var$writeuint16(0));
    if (b8) $9d5117faee5c78f9$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $9d5117faee5c78f9$var$writebool(false));
    if (b8) $9d5117faee5c78f9$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $9d5117faee5c78f9$var$writeuint16(0));
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x003d /* Window1 */ , $9d5117faee5c78f9$var$write_Window1(opts));
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x0040 /* Backup */ , $9d5117faee5c78f9$var$writebool(false));
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x008d /* HideObj */ , $9d5117faee5c78f9$var$writeuint16(0));
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $9d5117faee5c78f9$var$writebool($9d5117faee5c78f9$var$safe1904(wb) == "true"));
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $9d5117faee5c78f9$var$writebool(true));
    if (b8) $9d5117faee5c78f9$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $9d5117faee5c78f9$var$writebool(false));
    $9d5117faee5c78f9$var$write_biff_rec(A, 0x00DA /* BookBool */ , $9d5117faee5c78f9$var$writeuint16(0));
    /* ... */ $9d5117faee5c78f9$var$write_FONTS_biff8(A, wb, opts);
    $9d5117faee5c78f9$var$write_FMTS_biff8(A, wb.SSF, opts);
    $9d5117faee5c78f9$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $9d5117faee5c78f9$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $9d5117faee5c78f9$var$writebool(false));
    var a = A.end();
    var C = $9d5117faee5c78f9$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $9d5117faee5c78f9$var$write_biff_rec(C, 0x008C /* Country */ , $9d5117faee5c78f9$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */ /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $9d5117faee5c78f9$var$write_biff_continue(C, 0x00FC /* SST */ , $9d5117faee5c78f9$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $9d5117faee5c78f9$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $9d5117faee5c78f9$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $9d5117faee5c78f9$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $9d5117faee5c78f9$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $9d5117faee5c78f9$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $9d5117faee5c78f9$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $9d5117faee5c78f9$var$dup($9d5117faee5c78f9$var$table_fmt);
    if (wb && wb.SSF) {
        $9d5117faee5c78f9$var$make_ssf();
        $9d5117faee5c78f9$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $9d5117faee5c78f9$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $9d5117faee5c78f9$var$fix_write_opts(o);
    o.cellXfs = [];
    $9d5117faee5c78f9$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $9d5117faee5c78f9$var$write_ws_biff8(i, o, wb);
    bufs.unshift($9d5117faee5c78f9$var$write_biff8_global(wb, bufs, o));
    return $9d5117faee5c78f9$var$bconcat(bufs);
}
function $9d5117faee5c78f9$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $9d5117faee5c78f9$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $9d5117faee5c78f9$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $9d5117faee5c78f9$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $9d5117faee5c78f9$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    var dense = opts.dense != null ? opts.dense : $9d5117faee5c78f9$var$DENSE;
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (dense) ws["!data"] = [];
    str = str.replace(/<!--.*?-->/g, "");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $9d5117faee5c78f9$var$split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $9d5117faee5c78f9$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $9d5117faee5c78f9$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: 's',
                v: m
            };
            if (opts.raw || !m.trim().length || _t == 's') ;
            else if (m === 'TRUE') o = {
                t: 'b',
                v: true
            };
            else if (m === 'FALSE') o = {
                t: 'b',
                v: false
            };
            else if (!isNaN($9d5117faee5c78f9$var$fuzzynum(m))) o = {
                t: 'n',
                v: $9d5117faee5c78f9$var$fuzzynum(m)
            };
            else if (!isNaN($9d5117faee5c78f9$var$fuzzydate(m).getDate())) {
                o = {
                    t: 'd',
                    v: $9d5117faee5c78f9$var$parseDate(m)
                } /*:any*/ ;
                if (!opts.cellDates) o = {
                    t: 'n',
                    v: $9d5117faee5c78f9$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $9d5117faee5c78f9$var$table_fmt[14];
            }
            if (dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = o;
            } else ws[$9d5117faee5c78f9$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws['!ref'] = $9d5117faee5c78f9$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $9d5117faee5c78f9$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws['!merges'] || [];
    var oo /*:Array<string>*/  = [];
    var sp = {} /*:any*/ ;
    var dense = ws["!data"] != null;
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $9d5117faee5c78f9$var$encode_col(C) + $9d5117faee5c78f9$var$encode_row(R);
        var cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $9d5117faee5c78f9$var$escapehtml(cell.w || ($9d5117faee5c78f9$var$format_cell(cell), cell.w) || "")) || "";
        sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + '</span>';
        else if (cell) {
            sp["data-t"] = cell && cell.t || 'z';
            if (cell.v != null) sp["data-v"] = cell.v;
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + $9d5117faee5c78f9$var$escapehtml(cell.l.Target) + '">' + w + '</a>';
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($9d5117faee5c78f9$var$writextag('td', w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $9d5117faee5c78f9$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $9d5117faee5c78f9$var$HTML_END = '</body></html>';
function $9d5117faee5c78f9$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) {
        var w = $9d5117faee5c78f9$var$sheet_to_workbook($9d5117faee5c78f9$var$html_to_sheet(mtch[0], opts), opts);
        w.bookType = "html";
        return w;
    }
    var wb = $9d5117faee5c78f9$var$book_new();
    mtch.forEach(function(s, idx) {
        $9d5117faee5c78f9$var$book_append_sheet(wb, $9d5117faee5c78f9$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    wb.bookType = "html";
    return wb;
}
function $9d5117faee5c78f9$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
}
function $9d5117faee5c78f9$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $9d5117faee5c78f9$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $9d5117faee5c78f9$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $9d5117faee5c78f9$var$decode_range(ws['!ref']);
    out.push($9d5117faee5c78f9$var$make_html_preamble(ws, r, o));
    for(var R = r.s.r; R <= r.e.r; ++R)out.push($9d5117faee5c78f9$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $9d5117faee5c78f9$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.rows;
    if (!rows) /* not an HTML TABLE */ throw "Unsupported origin when " + table.tagName + " is not a TABLE";
    var opts = _opts || {};
    var dense = ws["!data"] != null;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == 'number') or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $9d5117faee5c78f9$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $9d5117faee5c78f9$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws['!cols'] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($9d5117faee5c78f9$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.cells;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $9d5117faee5c78f9$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : $9d5117faee5c78f9$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute('data-z') || elt.getAttribute('z');
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: 's',
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || 'z';
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (v === 'TRUE') o = {
                    t: 'b',
                    v: true
                };
                else if (v === 'FALSE') o = {
                    t: 'b',
                    v: false
                };
                else if (!isNaN($9d5117faee5c78f9$var$fuzzynum(v))) o = {
                    t: 'n',
                    v: $9d5117faee5c78f9$var$fuzzynum(v)
                };
                else if (!isNaN($9d5117faee5c78f9$var$fuzzydate(v).getDate())) {
                    o = {
                        t: 'd',
                        v: $9d5117faee5c78f9$var$parseDate(v)
                    } /*:any*/ ;
                    if (!opts.cellDates) o = {
                        t: 'n',
                        v: $9d5117faee5c78f9$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $9d5117faee5c78f9$var$table_fmt[14];
                }
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#" && l.slice(0, 11).toLowerCase() != 'javascript:') o.l = {
                Target: l
            };
            if (dense) {
                if (!ws["!data"][R + or_R]) ws["!data"][R + or_R] = [];
                ws["!data"][R + or_R][C + or_C] = o;
            } else ws[$9d5117faee5c78f9$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws['!ref'] = $9d5117faee5c78f9$var$encode_range(range);
    if (R >= sheetRows) ws['!fullref'] = $9d5117faee5c78f9$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $9d5117faee5c78f9$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    return $9d5117faee5c78f9$var$sheet_add_dom(ws, table, _opts);
}
function $9d5117faee5c78f9$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    var o = $9d5117faee5c78f9$var$sheet_to_workbook($9d5117faee5c78f9$var$parse_dom_table(table, opts), opts);
    //o.bookType = "dom"; // TODO: define a type for this
    return o;
}
function $9d5117faee5c78f9$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = '';
    var get_computed_style /*:?function*/  = $9d5117faee5c78f9$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue('display');
    if (!display) display = element.style && element.style.display;
    return display === 'none';
}
/* global getComputedStyle */ function $9d5117faee5c78f9$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === 'function') return getComputedStyle;
    return null;
}
/* OpenDocument */ function $9d5117faee5c78f9$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^>]*\/>/g, "\t").replace(/<text:line-break\/>/g, "\n");
    var v = $9d5117faee5c78f9$var$unescapexml(fixed.replace(/<[^>]*>/g, ""));
    return [
        v
    ];
}
/* Note: ODS can stick styles in content.xml or styles.xml, FODS blurs lines */ function $9d5117faee5c78f9$var$parse_ods_styles(d /*:string*/ , _opts, _nfm) {
    var number_format_map = _nfm || {};
    var str = $9d5117faee5c78f9$var$xlml_normalize(d);
    $9d5117faee5c78f9$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    var Rn, NFtag, NF = "", tNF = "", y, etpos = 0, tidx = -1, infmt = false, payload = "";
    while(Rn = $9d5117faee5c78f9$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_.*$/, "")){
        /* Number Format Definitions */ case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
        case 'text-style':
            if (Rn[1] === '/') {
                infmt = false;
                if (NFtag['truncate-on-overflow'] == "false") {
                    if (NF.match(/h/)) NF = NF.replace(/h+/, "[$&]");
                    else if (NF.match(/m/)) NF = NF.replace(/m+/, "[$&]");
                    else if (NF.match(/s/)) NF = NF.replace(/s+/, "[$&]");
                }
                number_format_map[NFtag.name] = NF;
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            }
            break;
        // LibreOffice bug https://bugs.documentfoundation.org/show_bug.cgi?id=149484
        case 'boolean-style':
            if (Rn[1] === '/') {
                infmt = false;
                number_format_map[NFtag.name] = "General";
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            }
            break;
        /* Number Format Elements */ case 'boolean':
            NF += "General"; // ODF spec is unfortunately underspecified here
            break;
        case 'text':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $9d5117faee5c78f9$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                if (payload == "%" && NFtag[0] == '<number:percentage-style') NF += "%";
                else NF += '"' + payload.replace(/"/g, '""') + '"';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $9d5117faee5c78f9$var$xlmlregex.lastIndex;
            break;
        case 'day':
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "d";
                    break;
                case "long":
                    NF += "dd";
                    break;
                default:
                    NF += "dd";
                    break; // TODO: error condition
            }
            break;
        case 'day-of-week':
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ddd";
                    break;
                case "long":
                    NF += "dddd";
                    break;
                default:
                    NF += "ddd";
                    break;
            }
            break;
        case 'era':
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ee";
                    break;
                case "long":
                    NF += "eeee";
                    break;
                default:
                    NF += "eeee";
                    break; // TODO: error condition
            }
            break;
        case 'hours':
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "h";
                    break;
                case "long":
                    NF += "hh";
                    break;
                default:
                    NF += "hh";
                    break; // TODO: error condition
            }
            break;
        case 'minutes':
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "mm";
                    break; // TODO: error condition
            }
            break;
        case 'month':
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            if (y["textual"]) NF += "mm";
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "m";
                    break;
            }
            break;
        case 'seconds':
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "s";
                    break;
                case "long":
                    NF += "ss";
                    break;
                default:
                    NF += "ss";
                    break; // TODO: error condition
            }
            if (y["decimal-places"]) NF += "." + $9d5117faee5c78f9$var$fill("0", +y["decimal-places"]);
            break;
        case 'year':
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "yy";
                    break;
                case "long":
                    NF += "yyyy";
                    break;
                default:
                    NF += "yy";
                    break; // TODO: error condition
            }
            break;
        case 'am-pm':
            NF += "AM/PM"; // LO autocorrects A/P -> AM/PM
            break;
        case 'week-of-year':
        case 'quarter':
            console.error("Excel does not support ODS format token " + Rn[3]);
            break;
        case 'fill-character':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $9d5117faee5c78f9$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                NF += '"' + payload.replace(/"/g, '""') + '"*';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $9d5117faee5c78f9$var$xlmlregex.lastIndex;
            break;
        case 'scientific-number':
            // TODO: find a mapping for all parameters
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            NF += "0." + $9d5117faee5c78f9$var$fill("0", +y["min-decimal-places"] || +y["decimal-places"] || 2) + $9d5117faee5c78f9$var$fill("?", +y["decimal-places"] - +y["min-decimal-places"] || 0) + "E" + ($9d5117faee5c78f9$var$parsexmlbool(y["forced-exponent-sign"]) ? "+" : "") + $9d5117faee5c78f9$var$fill("0", +y["min-exponent-digits"] || 2);
            break;
        case 'fraction':
            // TODO: find a mapping for all parameters
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            if (!+y["min-integer-digits"]) NF += "#";
            else NF += $9d5117faee5c78f9$var$fill("0", +y["min-integer-digits"]);
            NF += " ";
            NF += $9d5117faee5c78f9$var$fill("?", +y["min-numerator-digits"] || 1);
            NF += "/";
            if (+y["denominator-value"]) NF += y["denominator-value"];
            else NF += $9d5117faee5c78f9$var$fill("?", +y["min-denominator-digits"] || 1);
            break;
        case 'currency-symbol':
            // TODO: localization with [$-...]
            if (Rn[1] === '/') NF += '"' + str.slice(tidx, $9d5117faee5c78f9$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
            else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $9d5117faee5c78f9$var$xlmlregex.lastIndex;
            else NF += "$";
            break;
        case 'text-properties':
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            switch((y["color"] || "").toLowerCase().replace("#", "")){
                case "ff0000":
                case "red":
                    NF = "[Red]" + NF;
                    break;
            }
            break;
        case 'text-content':
            NF += "@";
            break;
        case 'map':
            // TODO: handle more complex maps
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            if ($9d5117faee5c78f9$var$unescapexml(y["condition"]) == "value()>=0") NF = number_format_map[y["apply-style-name"]] + ";" + NF;
            else console.error("ODS number format may be incorrect: " + y["condition"]);
            break;
        case 'number':
            // TODO: handle all the attributes
            if (Rn[1] === '/') break;
            y = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            tNF = "";
            tNF += $9d5117faee5c78f9$var$fill("0", +y["min-integer-digits"] || 1);
            if ($9d5117faee5c78f9$var$parsexmlbool(y["grouping"])) tNF = $9d5117faee5c78f9$var$commaify($9d5117faee5c78f9$var$fill("#", Math.max(0, 4 - tNF.length)) + tNF);
            if (+y["min-decimal-places"] || +y["decimal-places"]) tNF += ".";
            if (+y["min-decimal-places"]) tNF += $9d5117faee5c78f9$var$fill("0", +y["min-decimal-places"] || 1);
            if (+y["decimal-places"] - (+y["min-decimal-places"] || 0)) tNF += $9d5117faee5c78f9$var$fill("0", +y["decimal-places"] - (+y["min-decimal-places"] || 0)); // TODO: should this be "#" ?
            NF += tNF;
            break;
        case 'embedded-text':
            // TODO: verify interplay with grouping et al
            if (Rn[1] === '/') {
                if (etpos == 0) NF += '"' + str.slice(tidx, $9d5117faee5c78f9$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
                else NF = NF.slice(0, etpos) + '"' + str.slice(tidx, $9d5117faee5c78f9$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"' + NF.slice(etpos);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                tidx = $9d5117faee5c78f9$var$xlmlregex.lastIndex;
                etpos = -+$9d5117faee5c78f9$var$parsexmltag(Rn[0], false)["position"] || 0;
            }
            break;
    }
    return number_format_map;
}
function $9d5117faee5c78f9$var$parse_content_xml(d /*:string*/ , _opts, _nfm) /*:Workbook*/ {
    var opts = _opts || {};
    if ($9d5117faee5c78f9$var$DENSE != null && opts.dense == null) opts.dense = $9d5117faee5c78f9$var$DENSE;
    var str = $9d5117faee5c78f9$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var nfidx, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ ;
    var textR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = _nfm || {}, styles = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: [],
        WBProps: {}
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    var baddate = 0;
    $9d5117faee5c78f9$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    while(Rn = $9d5117faee5c78f9$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_.*$/, "")){
        case 'table':
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === '/') {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = $9d5117faee5c78f9$var$encode_range(range);
                else ws['!ref'] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws['!fullref'] = ws['!ref'];
                    range.e.r = opts.sheetRows - 1;
                    ws['!ref'] = $9d5117faee5c78f9$var$encode_range(range);
                }
                if (merges.length) ws['!merges'] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== 'undefined') JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                sheetag = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = {} /*:any*/ ;
                if (opts.dense) ws["!data"] = [];
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case 'table-row-group':
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case 'table-row':
        case "\u884C":
            if (Rn[1] === '/') {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag['number-rows-repeated'] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case 'covered-table-cell':
            if (Rn[1] !== '/') ++C;
            if (opts.sheetStubs) {
                if (opts.dense) {
                    if (!ws["!data"][R]) ws["!data"][R] = [];
                    ws["!data"][R][C] = {
                        t: 'z'
                    };
                } else ws[$9d5117faee5c78f9$var$encode_cell({
                    r: R,
                    c: C
                })] = {
                    t: 'z'
                };
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case 'table-cell':
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === '/') {
                ++C;
                ctag = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                q = {
                    t: 'z',
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $9d5117faee5c78f9$var$ods_to_csf_formula($9d5117faee5c78f9$var$unescapexml(ctag.formula));
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type']) == "string") {
                    q.t = "s";
                    q.v = $9d5117faee5c78f9$var$unescapexml(ctag['string-value'] || "");
                    if (opts.dense) {
                        if (!ws["!data"][R]) ws["!data"][R] = [];
                        ws["!data"][R][C] = q;
                    } else ws[$9d5117faee5c78f9$var$encode_col(C) + $9d5117faee5c78f9$var$encode_row(R)] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== '/') {
                ++C;
                textp = "";
                textpidx = 0;
                textR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type'],
                    v: null
                } /*:any*/ ;
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $9d5117faee5c78f9$var$unescapexml(ctag.formula);
                    if (ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
                        mR = parseInt(ctag['number-matrix-rows-spanned'], 10) || 0;
                        mC = parseInt(ctag['number-matrix-columns-spanned'], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $9d5117faee5c78f9$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $9d5117faee5c78f9$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
                    mR = parseInt(ctag['number-rows-spanned'], 10) || 0;
                    mC = parseInt(ctag['number-columns-spanned'], 10) || 0;
                    mrange = {
                        s: {
                            r: R,
                            c: C
                        },
                        e: {
                            r: R + mR - 1,
                            c: C + mC - 1
                        }
                    };
                    merges.push(mrange);
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
                /* 19.385 office:value-type */ switch(q.t){
                    case 'boolean':
                        q.t = 'b';
                        q.v = $9d5117faee5c78f9$var$parsexmlbool(ctag['boolean-value']) || +ctag['boolean-value'] >= 1;
                        break;
                    case 'float':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'percentage':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'currency':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'date':
                        q.t = 'd';
                        q.v = $9d5117faee5c78f9$var$parseDate(ctag['date-value']);
                        if (!opts.cellDates) {
                            q.t = 'n';
                            q.v = $9d5117faee5c78f9$var$datenum(q.v, WB.WBProps.date1904) - baddate;
                        }
                        if (!q.z) q.z = 'm/d/yy';
                        break;
                    case 'time':
                        q.t = 'n';
                        q.v = $9d5117faee5c78f9$var$parse_isodur(ctag['time-value']) / 86400;
                        if (opts.cellDates) {
                            q.t = 'd';
                            q.v = $9d5117faee5c78f9$var$numdate(q.v);
                        }
                        if (!q.z) q.z = 'HH:MM:SS';
                        break;
                    case 'number':
                        q.t = 'n';
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === 'string' || q.t === 'text' || !q.t) {
                            q.t = 's';
                            if (ctag['string-value'] != null) {
                                textp = $9d5117faee5c78f9$var$unescapexml(ctag['string-value']);
                                textR = [];
                            }
                        } else throw new Error('Unsupported value type ' + q.t);
                }
            } else {
                isstub = false;
                if (q.t === 's') {
                    q.v = textp || '';
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                        if (opts.dense) {
                            if (!ws["!data"][R + rpt]) ws["!data"][R + rpt] = [];
                            ws["!data"][R + rpt][C] = rpt == 0 ? q : $9d5117faee5c78f9$var$dup(q);
                            while(--colpeat > 0)ws["!data"][R + rpt][C + colpeat] = $9d5117faee5c78f9$var$dup(q);
                        } else {
                            ws[$9d5117faee5c78f9$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$9d5117faee5c78f9$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $9d5117faee5c78f9$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case 'document':
        case 'document-content':
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case 'spreadsheet':
        case "\u4E3B\u4F53":
        case 'scripts':
        case 'styles':
        case 'font-face-decls':
        case 'master-styles':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'annotation':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                false
            ]);
            creator = "";
            creatoridx = 0;
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case 'creator':
            if (Rn[1] === '/') creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case 'meta':
        case "\u5143\u6570\u636E":
        case 'settings':
        case 'config-item-set':
        case 'config-item-map-indexed':
        case 'config-item-map-entry':
        case 'config-item-map-named':
        case 'shapes':
        case 'frame':
        case 'text-box':
        case 'image':
        case 'data-pilot-tables':
        case 'list-style':
        case 'form':
        case 'dde-links':
        case 'event-listeners':
        case 'chart':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case 'scientific-number':
        case 'currency-symbol':
        case 'fill-character':
            break;
        case 'text-style':
        case 'boolean-style':
        case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
            if (Rn[1] === '/') {
                var xlmlidx = $9d5117faee5c78f9$var$xlmlregex.lastIndex;
                $9d5117faee5c78f9$var$parse_ods_styles(str.slice(nfidx, $9d5117faee5c78f9$var$xlmlregex.lastIndex), _opts, number_format_map);
                $9d5117faee5c78f9$var$xlmlregex.lastIndex = xlmlidx;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') nfidx = $9d5117faee5c78f9$var$xlmlregex.lastIndex - Rn[0].length;
            break;
        case 'script':
            break; // 3.13 <office:script>
        case 'libraries':
            break; // TODO: <ooo:libraries>
        case 'automatic-styles':
            break; // 3.15.3 <office:automatic-styles>
        case 'default-style':
        case 'page-layout':
            break; // TODO: <style:page-layout>
        case 'style':
            var styletag = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            if (styletag["family"] == "table-cell" && number_format_map[styletag["data-style-name"]]) styles[styletag["name"]] = number_format_map[styletag["data-style-name"]];
            break;
        case 'map':
            break; // 16.3 <style:map>
        case 'font-face':
            break; // 16.21 <style:font-face>
        case 'paragraph-properties':
            break; // 17.6 <style:paragraph-properties>
        case 'table-properties':
            break; // 17.15 <style:table-properties>
        case 'table-column-properties':
            break; // 17.16 <style:table-column-properties>
        case 'table-row-properties':
            break; // 17.17 <style:table-row-properties>
        case 'table-cell-properties':
            break; // 17.18 <style:table-cell-properties>
        case 'number':
            break;
        case 'fraction':
            break; // TODO 16.27.6 <number:fraction>
        case 'day':
        case 'month':
        case 'year':
        case 'era':
        case 'day-of-week':
        case 'week-of-year':
        case 'quarter':
        case 'hours':
        case 'minutes':
        case 'seconds':
        case 'am-pm':
            break;
        case 'boolean':
            break; // 16.27.24 <number:boolean>
        case 'text':
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case 'number-style':
                case 'date-style':
                case 'time-style':
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'named-range':
            tag = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            _Ref = $9d5117faee5c78f9$var$ods_to_csf_3D(tag['cell-range-address']);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + '!' + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case 'text-content':
            break; // 16.27.27 <number:text-content>
        case 'text-properties':
            break; // 16.27.27 <style:text-properties>
        case 'embedded-text':
            break; // 16.27.4 <number:embedded-text>
        case 'body':
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case 'forms':
            break; // 12.25.2 13.2
        case 'table-column':
            break; // 9.1.6 <table:table-column>
        case 'table-header-rows':
            break; // 9.1.7 <table:table-header-rows>
        case 'table-rows':
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case 'table-column-group':
            break; // 9.1.10 <table:table-column-group>
        case 'table-header-columns':
            break; // 9.1.11 <table:table-header-columns>
        case 'table-columns':
            break; // 9.1.12 <table:table-columns>
        case 'null-date':
            tag = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
            switch(tag["date-value"]){
                case "1904-01-01":
                    WB.WBProps.date1904 = true;
                /* falls through */ case "1900-01-01":
                    baddate = 0;
            }
            break;
        case 'graphic-properties':
            break; // 17.21 <style:graphic-properties>
        case 'calculation-settings':
            break; // 9.4.1 <table:calculation-settings>
        case 'named-expressions':
            break; // 9.4.11 <table:named-expressions>
        case 'label-range':
            break; // 9.4.9 <table:label-range>
        case 'label-ranges':
            break; // 9.4.10 <table:label-ranges>
        case 'named-expression':
            break; // 9.4.13 <table:named-expression>
        case 'sort':
            break; // 9.4.19 <table:sort>
        case 'sort-by':
            break; // 9.4.20 <table:sort-by>
        case 'sort-groups':
            break; // 9.4.22 <table:sort-groups>
        case 'tab':
            break; // 6.1.4 <text:tab>
        case 'line-break':
            break; // 6.1.5 <text:line-break>
        case 'span':
            break; // 6.1.7 <text:span>
        case 'p':
        case "\u6587\u672C\u4E32":
            if ([
                'master-styles'
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === '/' && (!ctag || !ctag['string-value'])) {
                var ptp = $9d5117faee5c78f9$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else {
                textptag = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case 's':
            break; // <text:s>
        case 'database-range':
            if (Rn[1] === '/') break;
            try {
                _Ref = $9d5117faee5c78f9$var$ods_to_csf_3D($9d5117faee5c78f9$var$parsexmltag(Rn[0])['target-range-address']);
                Sheets[_Ref[0]]['!autofilter'] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case 'date':
            break; // <*:date>
        case 'object':
            break; // 10.4.6.2 <draw:object>
        case 'title':
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case 'desc':
            break; // <*:desc>
        case 'binary-data':
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case 'table-source':
            break; // 9.2.6
        case 'scenario':
            break; // 9.2.6
        case 'iteration':
            break; // 9.4.3 <table:iteration>
        case 'content-validations':
            break; // 9.4.4 <table:
        case 'content-validation':
            break; // 9.4.5 <table:
        case 'help-message':
            break; // 9.4.6 <table:
        case 'error-message':
            break; // 9.4.7 <table:
        case 'database-ranges':
            break; // 9.4.14 <table:database-ranges>
        case 'filter':
            break; // 9.5.2 <table:filter>
        case 'filter-and':
            break; // 9.5.3 <table:filter-and>
        case 'filter-or':
            break; // 9.5.4 <table:filter-or>
        case 'filter-condition':
            break; // 9.5.5 <table:filter-condition>
        case 'list-level-style-bullet':
            break; // 16.31 <text:
        case 'list-level-style-number':
            break; // 16.32 <text:
        case 'list-level-properties':
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case 'sender-firstname':
        case 'sender-lastname':
        case 'sender-initials':
        case 'sender-title':
        case 'sender-position':
        case 'sender-email':
        case 'sender-phone-private':
        case 'sender-fax':
        case 'sender-company':
        case 'sender-phone-work':
        case 'sender-street':
        case 'sender-city':
        case 'sender-postal-code':
        case 'sender-country':
        case 'sender-state-or-province':
        case 'author-name':
        case 'author-initials':
        case 'chapter':
        case 'file-name':
        case 'template-name':
        case 'sheet-name':
            break;
        case 'event-listener':
            break;
        /* TODO: FODS Properties */ case 'initial-creator':
        case 'creation-date':
        case 'print-date':
        case 'generator':
        case 'document-statistic':
        case 'user-defined':
        case 'editing-duration':
        case 'editing-cycles':
            break;
        /* TODO: FODS Config */ case 'config-item':
            break;
        /* TODO: style tokens */ case 'page-number':
            break; // TODO <text:page-number>
        case 'page-count':
            break; // TODO <text:page-count>
        case 'time':
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case 'cell-range-source':
            break; // 9.3.1 <table:
        case 'detective':
            break; // 9.3.2 <table:
        case 'operation':
            break; // 9.3.3 <table:
        case 'highlighted-range':
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case 'data-pilot-table':
        case 'source-cell-range':
        case 'source-service':
        case 'data-pilot-field':
        case 'data-pilot-level':
        case 'data-pilot-subtotals':
        case 'data-pilot-subtotal':
        case 'data-pilot-members':
        case 'data-pilot-member':
        case 'data-pilot-display-info':
        case 'data-pilot-sort-info':
        case 'data-pilot-layout-info':
        case 'data-pilot-field-reference':
        case 'data-pilot-groups':
        case 'data-pilot-group':
        case 'data-pilot-group-member':
            break;
        /* 10.3 Drawing Shapes */ case 'rect':
            break;
        /* 14.6 DDE Connections */ case 'dde-connection-decls':
        case 'dde-connection-decl':
        case 'dde-link':
        case 'dde-source':
            break;
        case 'properties':
            break; // 13.7 <form:properties>
        case 'property':
            break; // 13.8 <form:property>
        case 'a':
            if (Rn[1] !== '/') {
                atag = $9d5117faee5c78f9$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $9d5117faee5c78f9$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $9d5117faee5c78f9$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case 'table-protection':
            break;
        case 'data-pilot-grand-total':
            break; // <table:
        case 'office-document-common-attrs':
            break; // bare
        default:
            switch(Rn[2]){
                case 'dc:':
                case 'calcext:':
                case 'loext:':
                case 'ooo:':
                case 'chartooo:':
                case 'draw:':
                case 'style:':
                case 'chart:':
                case 'form:':
                case 'uof:':
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $9d5117faee5c78f9$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($9d5117faee5c78f9$var$safegetzipfile(zip, 'META-INF/manifest.xml')) $9d5117faee5c78f9$var$parse_manifest($9d5117faee5c78f9$var$getzipdata(zip, 'META-INF/manifest.xml'), opts);
    var styles = $9d5117faee5c78f9$var$getzipstr(zip, 'styles.xml');
    var Styles = styles && $9d5117faee5c78f9$var$parse_ods_styles($9d5117faee5c78f9$var$utf8read(styles), opts);
    var content = $9d5117faee5c78f9$var$getzipstr(zip, 'content.xml');
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $9d5117faee5c78f9$var$parse_content_xml($9d5117faee5c78f9$var$utf8read(content), opts, Styles);
    if ($9d5117faee5c78f9$var$safegetzipfile(zip, 'meta.xml')) wb.Props = $9d5117faee5c78f9$var$parse_core_props($9d5117faee5c78f9$var$getzipdata(zip, 'meta.xml'));
    wb.bookType = "ods";
    return wb;
}
function $9d5117faee5c78f9$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var wb = $9d5117faee5c78f9$var$parse_content_xml(data, opts);
    wb.bookType = "fods";
    return wb;
}
/* OpenDocument */ var $9d5117faee5c78f9$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        '<office:master-styles>',
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        '<style:header/>',
        '<style:header-left style:display="false"/>',
        '<style:footer/>',
        '<style:footer-left style:display="false"/>',
        '</style:master-page>',
        '</office:master-styles>'
    ].join("");
    var payload = '<office:document-styles ' + $9d5117faee5c78f9$var$wxt_helper({
        'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        'xmlns:xlink': "http://www.w3.org/1999/xlink",
        'xmlns:dc': "http://purl.org/dc/elements/1.1/",
        'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        'office:version': "1.2"
    }) + '>' + master_styles + '</office:document-styles>';
    return function wso() {
        return $9d5117faee5c78f9$var$XML_HEADER + payload;
    };
}();
// TODO: find out if anyone actually read the spec.  LO has some wild errors
function $9d5117faee5c78f9$var$write_number_format_ods(nf /*:string*/ , nfidx /*:string*/ ) /*:string*/ {
    var type = "number", payload = "", nopts = {
        "style:name": nfidx
    }, c = "", i = 0;
    nf = nf.replace(/"[$]"/g, "$");
    /* TODO: replace with an actual parser based on a real grammar */ j: {
        // TODO: support style maps
        if (nf.indexOf(";") > -1) {
            console.error("Unsupported ODS Style Map exported.  Using first branch of " + nf);
            nf = nf.slice(0, nf.indexOf(";"));
        }
        if (nf == "@") {
            type = "text";
            payload = "<number:text-content/>";
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* opening string literal */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $9d5117faee5c78f9$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $9d5117faee5c78f9$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* fractions */ var t = nf.match(/# (\?+)\/(\?+)/);
        if (t) {
            payload += $9d5117faee5c78f9$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:max-denominator-value": Math.max(+t[1].replace(/./g, "9"), +t[2].replace(/./g, "9"))
            });
            break j;
        }
        if (t = nf.match(/# (\?+)\/(\d+)/)) {
            payload += $9d5117faee5c78f9$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:denominator-value": +t[2]
            });
            break j;
        }
        /* percentages */ if (t = nf.match(/(\d+)(|\.\d+)%/)) {
            type = "percentage";
            payload += $9d5117faee5c78f9$var$writextag("number:number", null, {
                "number:decimal-places": t[2] && t.length - 1 || 0,
                "number:min-decimal-places": t[2] && t.length - 1 || 0,
                "number:min-integer-digits": t[1].length
            }) + "<number:text>%</number:text>";
            break j;
        }
        /* datetime */ var has_time = false;
        if ([
            "y",
            "m",
            "d"
        ].indexOf(nf[0]) > -1) {
            type = "date";
            k: for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "s":
                    has_time = true;
                    --i;
                    break k;
                case "m":
                    l: for(var h = i + 1; h < nf.length; ++h)switch(nf[h]){
                        case "y":
                        case "d":
                            break l;
                        case "h":
                        case "s":
                            has_time = true;
                            --i;
                            break k;
                    }
                /* falls through */ case "y":
                case "d":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "y":
                        case "yy":
                            payload += "<number:year/>";
                            break;
                        case "yyy":
                        case "yyyy":
                            payload += '<number:year number:style="long"/>';
                            break;
                        case "mmmmm":
                            console.error("ODS has no equivalent of format |mmmmm|");
                        /* falls through */ case "m":
                        case "mm":
                        case "mmm":
                        case "mmmm":
                            payload += '<number:month number:style="' + (c.length % 2 ? "short" : "long") + '" number:textual="' + (c.length >= 3 ? "true" : "false") + '"/>';
                            break;
                        case "d":
                        case "dd":
                            payload += '<number:day number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "ddd":
                        case "dddd":
                            payload += '<number:day-of-week number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $9d5117faee5c78f9$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '/':
                    payload += '<number:text>' + $9d5117faee5c78f9$var$escapexml(c) + '</number:text>';
                    break;
                default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            if (!has_time) break j;
            nf = nf.slice(i + 1);
            i = 0;
        }
        if (nf.match(/^\[?[hms]/)) {
            if (type == "number") type = "time";
            if (nf.match(/\[/)) {
                nf = nf.replace(/[\[\]]/g, "");
                nopts['number:truncate-on-overflow'] = "false";
            }
            for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "m":
                case "s":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "h":
                        case "hh":
                            payload += '<number:hours number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "m":
                        case "mm":
                            payload += '<number:minutes number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "s":
                        case "ss":
                            if (nf[i + 1] == ".") do {
                                c += nf[i + 1];
                                ++i;
                            }while (nf[i + 1] == "0");
                            payload += '<number:seconds number:style="' + (c.match("ss") ? "long" : "short") + '"' + (c.match(/\./) ? ' number:decimal-places="' + (c.match(/0+/) || [
                                ""
                            ])[0].length + '"' : "") + '/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $9d5117faee5c78f9$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '/':
                    payload += '<number:text>' + $9d5117faee5c78f9$var$escapexml(c) + '</number:text>';
                    break;
                case "a":
                    if (nf.slice(i, i + 3).toLowerCase() == "a/p") {
                        payload += '<number:am-pm/>';
                        i += 2;
                        break;
                    } // Note: ODF does not support A/P
                    if (nf.slice(i, i + 5).toLowerCase() == "am/pm") {
                        payload += '<number:am-pm/>';
                        i += 4;
                        break;
                    }
                /* falls through */ default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* should be in a char loop */ if (nf[0] == "$") {
            payload += '<number:currency-symbol number:language="en" number:country="US">$</number:currency-symbol>';
            nf = nf.slice(1);
            i = 0;
        }
        i = 0;
        if (nf[i] == '"') {
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $9d5117faee5c78f9$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $9d5117faee5c78f9$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* number TODO: interstitial text e.g. 000)000-0000 */ var np = nf.match(/([#0][0#,]*)(\.[0#]*|)(E[+]?0*|)/i);
        if (!np || !np[0]) console.error("Could not find numeric part of " + nf);
        else {
            var base = np[1].replace(/,/g, "");
            payload += '<number:' + (np[3] ? "scientific-" : "") + 'number' + ' number:min-integer-digits="' + (base.indexOf("0") == -1 ? "0" : base.length - base.indexOf("0")) + '"' + (np[0].indexOf(",") > -1 ? ' number:grouping="true"' : "") + (np[2] && ' number:decimal-places="' + (np[2].length - 1) + '"' || ' number:decimal-places="0"') + (np[3] && np[3].indexOf("+") > -1 ? ' number:forced-exponent-sign="true"' : "") + (np[3] ? ' number:min-exponent-digits="' + np[3].match(/0+/)[0].length + '"' : "") + '>' + /* TODO: interstitial text placeholders */ '</number:' + (np[3] ? "scientific-" : "") + 'number>';
            i = np.index + np[0].length;
        }
        /* residual text */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            payload += '<number:text>' + $9d5117faee5c78f9$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
        }
    }
    if (!payload) {
        console.error("Could not generate ODS number format for |" + nf + "|");
        return "";
    }
    return $9d5117faee5c78f9$var$writextag("number:" + type + "-style", payload, nopts);
}
function $9d5117faee5c78f9$var$write_names_ods(Names, SheetNames, idx) {
    var scoped = Names.filter(function(name) {
        return name.Sheet == (idx == -1 ? null : idx);
    });
    if (!scoped.length) return "";
    return "      <table:named-expressions>\n" + scoped.map(function(name) {
        var odsref = $9d5117faee5c78f9$var$csf_to_ods_3D(name.Ref);
        return "        " + $9d5117faee5c78f9$var$writextag("table:named-range", null, {
            "table:name": name.Name,
            "table:cell-range-address": odsref,
            "table:base-cell-address": odsref.replace(/[\.]?[^\.]*$/, ".$A$1")
        });
    }).join("\n") + "\n      </table:named-expressions>\n";
}
var $9d5117faee5c78f9$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ ) /*:string*/ {
        return $9d5117faee5c78f9$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = '          <table:table-cell />\n';
    var covered_cell_xml = '          <table:covered-table-cell/>\n';
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/ , opts, nfs) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $9d5117faee5c78f9$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $9d5117faee5c78f9$var$decode_range(ws['!ref'] || "A1");
        var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
        var dense = ws["!data"] != null;
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '></table:table-row>\n');
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '>\n');
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct['table:number-columns-spanned'] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct['table:number-rows-spanned'] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push(covered_cell_xml);
                    continue;
                }
                var ref = $9d5117faee5c78f9$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct['table:formula'] = $9d5117faee5c78f9$var$escapexml($9d5117faee5c78f9$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $9d5117faee5c78f9$var$decode_range(cell.F);
                            ct['table:number-matrix-columns-spanned'] = _Fref.e.c - _Fref.s.c + 1;
                            ct['table:number-matrix-rows-spanned'] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case 'b':
                        textp = cell.v ? 'TRUE' : 'FALSE';
                        ct['office:value-type'] = "boolean";
                        ct['office:boolean-value'] = cell.v ? 'true' : 'false';
                        break;
                    case 'n':
                        textp = cell.w || String(cell.v || 0);
                        ct['office:value-type'] = "float";
                        ct['office:value'] = cell.v || 0;
                        break;
                    case 's':
                    case 'str':
                        textp = cell.v == null ? "" : cell.v;
                        ct['office:value-type'] = "string";
                        break;
                    case 'd':
                        textp = cell.w || $9d5117faee5c78f9$var$parseDate(cell.v).toISOString();
                        ct['office:value-type'] = "date";
                        ct['office:date-value'] = $9d5117faee5c78f9$var$parseDate(cell.v).toISOString();
                        ct['table:style-name'] = "ce1";
                        break;
                    //case 'e':
                    default:
                        o.push(null_cell_xml);
                        continue;
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $9d5117faee5c78f9$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
                    text_p = $9d5117faee5c78f9$var$writextag('text:a', text_p, {
                        'xlink:href': _tgt.replace(/&/g, "&amp;")
                    });
                }
                if (nfs[cell.z]) ct["table:style-name"] = "ce" + nfs[cell.z].slice(1);
                o.push('          ' + $9d5117faee5c78f9$var$writextag('table:table-cell', $9d5117faee5c78f9$var$writextag('text:p', text_p, {}), ct) + '\n');
            }
            o.push('        </table:table-row>\n');
        }
        if ((wb.Workbook || {}).Names) o.push($9d5117faee5c78f9$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, i));
        o.push('      </table:table>\n');
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(' <office:automatic-styles>\n');
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $9d5117faee5c78f9$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push('  </style:style>\n');
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push('  </style:style>\n');
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push('  </style:style>\n');
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:day number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:year/>\n');
        o.push('  </number:date-style>\n');
        /* number formats, table cells, text */ var nfs = {};
        var nfi = 69;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            var dense = ws["!data"] != null;
            var range = $9d5117faee5c78f9$var$decode_range(ws["!ref"]);
            for(var R = 0; R <= range.e.r; ++R)for(var C = 0; C <= range.e.c; ++C){
                var c = dense ? (ws["!data"][R] || [])[C] : ws[$9d5117faee5c78f9$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (!c || !c.z || c.z.toLowerCase() == "general") continue;
                if (!nfs[c.z]) {
                    var out = $9d5117faee5c78f9$var$write_number_format_ods(c.z, "N" + nfi);
                    if (out) {
                        nfs[c.z] = "N" + nfi;
                        ++nfi;
                        o.push(out + "\n");
                    }
                }
            }
        });
        o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        $9d5117faee5c78f9$var$keys(nfs).forEach(function(nf) {
            o.push('<style:style style:name="ce' + nfs[nf].slice(1) + '" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="' + nfs[nf] + '"/>\n');
        });
        /* page-layout */ o.push(' </office:automatic-styles>\n');
        return nfs;
    };
    return function wcx(wb, opts) {
        var o = [
            $9d5117faee5c78f9$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $9d5117faee5c78f9$var$wxt_helper({
            'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            'xmlns:xlink': "http://www.w3.org/1999/xlink",
            'xmlns:dc': "http://purl.org/dc/elements/1.1/",
            'xmlns:meta': "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            'xmlns:chart': "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            'xmlns:dr3d': "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            'xmlns:math': "http://www.w3.org/1998/Math/MathML",
            'xmlns:form': "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            'xmlns:script': "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            'xmlns:ooo': "http://openoffice.org/2004/office",
            'xmlns:ooow': "http://openoffice.org/2004/writer",
            'xmlns:oooc': "http://openoffice.org/2004/calc",
            'xmlns:dom': "http://www.w3.org/2001/xml-events",
            'xmlns:xforms': "http://www.w3.org/2002/xforms",
            'xmlns:xsd': "http://www.w3.org/2001/XMLSchema",
            'xmlns:xsi': "http://www.w3.org/2001/XMLSchema-instance",
            'xmlns:sheet': "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            'xmlns:rpt': "http://openoffice.org/2005/report",
            'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            'xmlns:xhtml': "http://www.w3.org/1999/xhtml",
            'xmlns:grddl': "http://www.w3.org/2003/g/data-view#",
            'xmlns:tableooo': "http://openoffice.org/2009/table",
            'xmlns:drawooo': "http://openoffice.org/2010/draw",
            'xmlns:calcext': "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            'xmlns:loext': "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            'xmlns:field': "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            'xmlns:formx': "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            'xmlns:css3t': "http://www.w3.org/TR/css3-text/",
            'office:version': "1.2"
        });
        var fods = $9d5117faee5c78f9$var$wxt_helper({
            'xmlns:config': "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push('<office:document' + attr + fods + '>\n');
            o.push($9d5117faee5c78f9$var$write_meta_ods().replace(/<office:document-meta.*?>/, "").replace(/<\/office:document-meta>/, "") + "\n");
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push('<office:document-content' + attr + '>\n');
        // o.push('  <office:scripts/>\n');
        var nfs = write_automatic_styles_ods(o, wb);
        o.push('  <office:body>\n');
        o.push('    <office:spreadsheet>\n');
        if (((wb.Workbook || {}).WBProps || {}).date1904) o.push('      <table:calculation-settings table:case-sensitive="false" table:search-criteria-must-apply-to-whole-cell="true" table:use-wildcards="true" table:use-regular-expressions="false" table:automatic-find-labels="false">\n        <table:null-date table:date-value="1904-01-01"/>\n      </table:calculation-settings>\n');
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts, nfs));
        if ((wb.Workbook || {}).Names) o.push($9d5117faee5c78f9$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, -1));
        o.push('    </office:spreadsheet>\n');
        o.push('  </office:body>\n');
        if (opts.bookType == "fods") o.push('</office:document>');
        else o.push('</office:document-content>');
        return o.join("");
    };
}();
function $9d5117faee5c78f9$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $9d5117faee5c78f9$var$write_content_ods(wb, opts);
    var zip = $9d5117faee5c78f9$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $9d5117faee5c78f9$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$XML_HEADER + $9d5117faee5c78f9$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ var $9d5117faee5c78f9$var$subarray = function() {
    try {
        if (typeof Uint8Array == "undefined") return "slice";
        if (typeof Uint8Array.prototype.subarray == "undefined") return "slice";
        if (typeof $9d5117faee5c78f9$require$Buffer !== "undefined") {
            if (typeof $9d5117faee5c78f9$require$Buffer.prototype.subarray == "undefined") return "slice";
            if ((typeof $9d5117faee5c78f9$require$Buffer.from == "function" ? $9d5117faee5c78f9$require$Buffer.from([
                72,
                62
            ]) : new $9d5117faee5c78f9$require$Buffer([
                72,
                62
            ])) instanceof Uint8Array) return "subarray";
            return "slice";
        }
        return "subarray";
    } catch (e) {
        return "slice";
    }
}();
function $9d5117faee5c78f9$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $9d5117faee5c78f9$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $9d5117faee5c78f9$var$utf8read($9d5117faee5c78f9$var$a2s(u8));
}
function $9d5117faee5c78f9$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $9d5117faee5c78f9$var$s2a($9d5117faee5c78f9$var$utf8write(str));
}
function $9d5117faee5c78f9$var$u8concat(u8a) {
    var len = 0;
    for(var i = 0; i < u8a.length; ++i)len += u8a[i].length;
    var out = new Uint8Array(len);
    var off = 0;
    for(i = 0; i < u8a.length; ++i){
        var u8 = u8a[i], L = u8.length;
        if (L < 250) for(var j = 0; j < L; ++j)out[off++] = u8[j];
        else {
            out.set(u8, off);
            off += L;
        }
    }
    return out;
}
function $9d5117faee5c78f9$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $9d5117faee5c78f9$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $9d5117faee5c78f9$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 16;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $9d5117faee5c78f9$var$parse_varint49(buf, ptr) {
    var l = ptr.l;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    ptr.l = l;
    return usz;
}
function $9d5117faee5c78f9$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz[$9d5117faee5c78f9$var$subarray](0, L);
}
function $9d5117faee5c78f9$var$parse_packed_varints(buf) {
    var ptr = {
        l: 0
    };
    var out = [];
    while(ptr.l < buf.length)out.push($9d5117faee5c78f9$var$parse_varint49(buf, ptr));
    return out;
}
function $9d5117faee5c78f9$var$write_packed_varints(nums) {
    return $9d5117faee5c78f9$var$u8concat(nums.map(function(x) {
        return $9d5117faee5c78f9$var$write_varint49(x);
    }));
}
function $9d5117faee5c78f9$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        i32 |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 28;
    }
    return i32;
}
function $9d5117faee5c78f9$var$varint_to_u64(buf) {
    var l = 0, lo = buf[l] & 127, hi = 0;
    varint: if (buf[l++] >= 128) {
        lo |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 28;
        hi = buf[l] >> 4 & 7;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 3;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 10;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 17;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 24;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 31;
    }
    return [
        lo >>> 0,
        hi >>> 0
    ];
}
function $9d5117faee5c78f9$var$parse_shallow(buf) {
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var off = ptr.l;
        var num = $9d5117faee5c78f9$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = num / 8 | 0;
        var data;
        var l = ptr.l;
        switch(type){
            case 0:
                while(buf[l++] >= 128);
                data = buf[$9d5117faee5c78f9$var$subarray](ptr.l, l);
                ptr.l = l;
                break;
            case 1:
                data = buf[$9d5117faee5c78f9$var$subarray](l, l + 8);
                ptr.l = l + 8;
                break;
            case 2:
                var len = $9d5117faee5c78f9$var$parse_varint49(buf, ptr);
                data = buf[$9d5117faee5c78f9$var$subarray](ptr.l, ptr.l + len);
                ptr.l += len;
                break;
            case 5:
                data = buf[$9d5117faee5c78f9$var$subarray](l, l + 4);
                ptr.l = l + 4;
                break;
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: data,
            type: type
        };
        if (out[num] == null) out[num] = [];
        out[num].push(v);
    }
    return out;
}
function $9d5117faee5c78f9$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        if (idx == 0) return;
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($9d5117faee5c78f9$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($9d5117faee5c78f9$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $9d5117faee5c78f9$var$u8concat(out);
}
function $9d5117faee5c78f9$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $9d5117faee5c78f9$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var len = $9d5117faee5c78f9$var$parse_varint49(buf, ptr);
        var ai = $9d5117faee5c78f9$var$parse_shallow(buf[$9d5117faee5c78f9$var$subarray](ptr.l, ptr.l + len));
        ptr.l += len;
        var res = {
            id: $9d5117faee5c78f9$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $9d5117faee5c78f9$var$parse_shallow(b.data);
            var fl = $9d5117faee5c78f9$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf[$9d5117faee5c78f9$var$subarray](ptr.l, ptr.l + fl)
            });
            ptr.l += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $9d5117faee5c78f9$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $9d5117faee5c78f9$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [
            [],
            [
                {
                    data: $9d5117faee5c78f9$var$write_varint49(ia.id),
                    type: 0
                }
            ],
            []
        ];
        if (ia.merge != null) ai[3] = [
            {
                data: $9d5117faee5c78f9$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $9d5117faee5c78f9$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $9d5117faee5c78f9$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $9d5117faee5c78f9$var$write_shallow(ai);
        bufs.push($9d5117faee5c78f9$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $9d5117faee5c78f9$var$u8concat(bufs);
}
function $9d5117faee5c78f9$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = {
        l: 0
    };
    var usz = $9d5117faee5c78f9$var$parse_varint49(buf, ptr);
    var chunks = [];
    var l = ptr.l;
    while(l < buf.length){
        var tag = buf[l] & 3;
        if (tag == 0) {
            var len = buf[l++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[l];
                if (c > 1) len |= buf[l + 1] << 8;
                if (c > 2) len |= buf[l + 2] << 16;
                if (c > 3) len |= buf[l + 3] << 24;
                len >>>= 0;
                len++;
                l += c;
            }
            chunks.push(buf[$9d5117faee5c78f9$var$subarray](l, l + len));
            l += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[l] >> 2 & 7) + 4;
                offset = (buf[l++] & 224) << 3;
                offset |= buf[l++];
            } else {
                length = (buf[l++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[l] | buf[l + 1] << 8;
                    l += 2;
                } else {
                    offset = (buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16 | buf[l + 3] << 24) >>> 0;
                    l += 4;
                }
            }
            if (offset == 0) throw new Error("Invalid offset 0");
            var j = chunks.length - 1, off = offset;
            while(j >= 0 && off >= chunks[j].length){
                off -= chunks[j].length;
                --j;
            }
            if (j < 0) {
                if (off == 0) off = chunks[j = 0].length;
                else throw new Error("Invalid offset beyond length");
            }
            if (length < off) chunks.push(chunks[j][$9d5117faee5c78f9$var$subarray](chunks[j].length - off, chunks[j].length - off + length));
            else {
                if (off > 0) {
                    chunks.push(chunks[j][$9d5117faee5c78f9$var$subarray](chunks[j].length - off));
                    length -= off;
                }
                ++j;
                while(length >= chunks[j].length){
                    chunks.push(chunks[j]);
                    length -= chunks[j].length;
                    ++j;
                }
                if (length) chunks.push(chunks[j][$9d5117faee5c78f9$var$subarray](0, length));
            }
            if (chunks.length > 25) chunks = [
                $9d5117faee5c78f9$var$u8concat(chunks)
            ];
        }
    }
    var clen = 0;
    for(var u8i = 0; u8i < chunks.length; ++u8i)clen += chunks[u8i].length;
    if (clen != usz) throw new Error("Unexpected length: ".concat(clen, " != ").concat(usz));
    return chunks;
}
function $9d5117faee5c78f9$var$decompress_iwa_file(buf) {
    if (Array.isArray(buf)) buf = new Uint8Array(buf);
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push.apply(out, $9d5117faee5c78f9$var$parse_snappy_chunk(t, buf[$9d5117faee5c78f9$var$subarray](l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return out.length == 1 ? out[0] : $9d5117faee5c78f9$var$u8concat(out);
}
function $9d5117faee5c78f9$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $9d5117faee5c78f9$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf[$9d5117faee5c78f9$var$subarray](l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $9d5117faee5c78f9$var$u8concat(out);
}
var $9d5117faee5c78f9$var$numbers_lut_new = function() {
    return {
        sst: [],
        rsst: [],
        ofmt: [],
        nfmt: []
    };
};
function $9d5117faee5c78f9$var$numbers_format_cell(cell, t, flags, ofmt, nfmt) {
    var _a, _b, _c, _d;
    var ctype = t & 255, ver = t >> 8;
    var fmt = ver >= 5 ? nfmt : ofmt;
    dur: if (flags & (ver > 4 ? 8 : 4) && cell.t == "n" && ctype == 7) {
        var dstyle = ((_a = fmt[7]) == null ? void 0 : _a[0]) ? $9d5117faee5c78f9$var$varint_to_i32(fmt[7][0].data) : -1;
        if (dstyle == -1) break dur;
        var dmin = ((_b = fmt[15]) == null ? void 0 : _b[0]) ? $9d5117faee5c78f9$var$varint_to_i32(fmt[15][0].data) : -1;
        var dmax = ((_c = fmt[16]) == null ? void 0 : _c[0]) ? $9d5117faee5c78f9$var$varint_to_i32(fmt[16][0].data) : -1;
        var auto = ((_d = fmt[40]) == null ? void 0 : _d[0]) ? $9d5117faee5c78f9$var$varint_to_i32(fmt[40][0].data) : -1;
        var d = cell.v, dd = d;
        autodur: if (auto) {
            if (d == 0) {
                dmin = dmax = 2;
                break autodur;
            }
            if (d >= 604800) dmin = 1;
            else if (d >= 86400) dmin = 2;
            else if (d >= 3600) dmin = 4;
            else if (d >= 60) dmin = 8;
            else if (d >= 1) dmin = 16;
            else dmin = 32;
            if (Math.floor(d) != d) dmax = 32;
            else if (d % 60) dmax = 16;
            else if (d % 3600) dmax = 8;
            else if (d % 86400) dmax = 4;
            else if (d % 604800) dmax = 2;
            if (dmax < dmin) dmax = dmin;
        }
        if (dmin == -1 || dmax == -1) break dur;
        var dstr = [], zstr = [];
        if (dmin == 1) {
            dd = d / 604800;
            if (dmax == 1) zstr.push('d"d"');
            else {
                dd |= 0;
                d -= 604800 * dd;
            }
            dstr.push(dd + (dstyle == 2 ? " week" + (dd == 1 ? "" : "s") : dstyle == 1 ? "w" : ""));
        }
        if (dmin <= 2 && dmax >= 2) {
            dd = d / 86400;
            if (dmax > 2) {
                dd |= 0;
                d -= 86400 * dd;
            }
            zstr.push('d"d"');
            dstr.push(dd + (dstyle == 2 ? " day" + (dd == 1 ? "" : "s") : dstyle == 1 ? "d" : ""));
        }
        if (dmin <= 4 && dmax >= 4) {
            dd = d / 3600;
            if (dmax > 4) {
                dd |= 0;
                d -= 3600 * dd;
            }
            zstr.push((dmin >= 4 ? "[h]" : "h") + '"h"');
            dstr.push(dd + (dstyle == 2 ? " hour" + (dd == 1 ? "" : "s") : dstyle == 1 ? "h" : ""));
        }
        if (dmin <= 8 && dmax >= 8) {
            dd = d / 60;
            if (dmax > 8) {
                dd |= 0;
                d -= 60 * dd;
            }
            zstr.push((dmin >= 8 ? "[m]" : "m") + '"m"');
            if (dstyle == 0) dstr.push((dmin == 8 && dmax == 8 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " minute" + (dd == 1 ? "" : "s") : dstyle == 1 ? "m" : ""));
        }
        if (dmin <= 16 && dmax >= 16) {
            dd = d;
            if (dmax > 16) {
                dd |= 0;
                d -= dd;
            }
            zstr.push((dmin >= 16 ? "[s]" : "s") + '"s"');
            if (dstyle == 0) dstr.push((dmax == 16 && dmin == 16 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " second" + (dd == 1 ? "" : "s") : dstyle == 1 ? "s" : ""));
        }
        if (dmax >= 32) {
            dd = Math.round(1e3 * d);
            if (dmin < 32) zstr.push('.000"ms"');
            if (dstyle == 0) dstr.push((dd >= 100 ? "" : dd >= 10 ? "0" : "00") + dd);
            else dstr.push(dd + (dstyle == 2 ? " millisecond" + (dd == 1 ? "" : "s") : dstyle == 1 ? "ms" : ""));
        }
        cell.w = dstr.join(dstyle == 0 ? ":" : " ");
        cell.z = zstr.join(dstyle == 0 ? '":"' : " ");
        if (dstyle == 0) cell.w = cell.w.replace(/:(\d\d\d)$/, ".$1");
    }
}
function $9d5117faee5c78f9$var$parse_old_storage(buf, lut, v) {
    var dv = $9d5117faee5c78f9$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var ridx = -1, sidx = -1, zidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
    var doff = v > 1 ? 12 : 8;
    if (flags & 2) {
        zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $9d5117faee5c78f9$var$popcnt(flags & (v > 1 ? 3468 : 396)) * 4;
    if (flags & 512) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $9d5117faee5c78f9$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + dv.getFloat64(doff, true) * 1e3);
        doff += 8;
    }
    if (v > 1) {
        flags = dv.getUint32(8, true) >>> 16;
        if (flags & 255) {
            if (zidx == -1) zidx = dv.getUint32(doff, true);
            doff += 4;
        }
    }
    var ret;
    var t = buf[v >= 4 ? 1 : 2];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) ret = {
                t: "s",
                v: lut.rsst[ridx]
            };
            else throw new Error("Unsupported cell type ".concat(buf[$9d5117faee5c78f9$var$subarray](0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[$9d5117faee5c78f9$var$subarray](0, 4)));
    }
    if (zidx > -1) $9d5117faee5c78f9$var$numbers_format_cell(ret, t | v << 8, flags, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $9d5117faee5c78f9$var$parse_new_storage(buf, lut) {
    var dv = $9d5117faee5c78f9$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var fields = dv.getUint32(8, true);
    var doff = 12;
    var ridx = -1, sidx = -1, zidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
    if (fields & 1) {
        d128 = $9d5117faee5c78f9$var$readDecimal128LE(buf, doff);
        doff += 16;
    }
    if (fields & 2) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (fields & 4) {
        dt.setTime(dt.getTime() + dv.getFloat64(doff, true) * 1e3);
        doff += 8;
    }
    if (fields & 8) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 16) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    var ret;
    var t = buf[1];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            ret = {
                t: "s",
                v: lut.rsst[ridx]
            };
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$9d5117faee5c78f9$var$subarray](0, 4)));
    }
    doff += $9d5117faee5c78f9$var$popcnt(fields & 8160) * 4;
    if (fields & 516096) {
        if (zidx == -1) zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (zidx > -1) $9d5117faee5c78f9$var$numbers_format_cell(ret, t | 1280, fields >> 13, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $9d5117faee5c78f9$var$write_new_storage(cell, sst) {
    var out = new Uint8Array(32), dv = $9d5117faee5c78f9$var$u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            out[1] = 2;
            $9d5117faee5c78f9$var$writeDecimal128LE(out, l, cell.v);
            flags |= 1;
            l += 16;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 2;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            var isst = sst.indexOf(s);
            if (isst == -1) sst[isst = sst.length] = s;
            out[1] = 3;
            dv.setUint32(l, isst, true);
            flags |= 8;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, flags, true);
    return out[$9d5117faee5c78f9$var$subarray](0, l);
}
function $9d5117faee5c78f9$var$write_old_storage(cell, sst) {
    var out = new Uint8Array(32), dv = $9d5117faee5c78f9$var$u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 4;
    switch(cell.t){
        case "n":
            out[2] = 2;
            dv.setFloat64(l, cell.v, true);
            flags |= 32;
            l += 8;
            break;
        case "b":
            out[2] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 32;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            var isst = sst.indexOf(s);
            if (isst == -1) sst[isst = sst.length] = s;
            out[2] = 3;
            dv.setUint32(l, isst, true);
            flags |= 16;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, flags, true);
    return out[$9d5117faee5c78f9$var$subarray](0, l);
}
function $9d5117faee5c78f9$var$parse_cell_storage(buf, lut) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return $9d5117faee5c78f9$var$parse_old_storage(buf, lut, buf[0]);
        case 5:
            return $9d5117faee5c78f9$var$parse_new_storage(buf, lut);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $9d5117faee5c78f9$var$parse_TSP_Reference(buf) {
    var pb = $9d5117faee5c78f9$var$parse_shallow(buf);
    return $9d5117faee5c78f9$var$varint_to_i32(pb[1][0].data);
}
function $9d5117faee5c78f9$var$write_TSP_Reference(idx) {
    return $9d5117faee5c78f9$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $9d5117faee5c78f9$var$write_varint49(idx)
            }
        ]
    ]);
}
function $9d5117faee5c78f9$var$numbers_add_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $9d5117faee5c78f9$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    var orefidx = orefs.indexOf(ref);
    if (orefidx == -1) {
        orefs.push(ref);
        iwa.messages[0].meta[5] = [
            {
                type: 2,
                data: $9d5117faee5c78f9$var$write_packed_varints(orefs)
            }
        ];
    }
}
function $9d5117faee5c78f9$var$numbers_del_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $9d5117faee5c78f9$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    iwa.messages[0].meta[5] = [
        {
            type: 2,
            data: $9d5117faee5c78f9$var$write_packed_varints(orefs.filter(function(r) {
                return r != ref;
            }))
        }
    ];
}
function $9d5117faee5c78f9$var$parse_TST_TableDataList(M, root) {
    var pb = $9d5117faee5c78f9$var$parse_shallow(root.data);
    var type = $9d5117faee5c78f9$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var le = $9d5117faee5c78f9$var$parse_shallow(entry.data);
        if (!le[1]) return;
        var key = $9d5117faee5c78f9$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $9d5117faee5c78f9$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$9d5117faee5c78f9$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $9d5117faee5c78f9$var$parse_shallow(rt.data);
                var rtpref = M[$9d5117faee5c78f9$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $9d5117faee5c78f9$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $9d5117faee5c78f9$var$parse_shallow(rtpref.data);
                data[key] = tswpsa[3].map(function(x) {
                    return $9d5117faee5c78f9$var$u8str(x.data);
                }).join("");
                break;
            case 2:
                data[key] = $9d5117faee5c78f9$var$parse_shallow(le[6][0].data);
                break;
            default:
                throw type;
        }
    });
    return data;
}
function $9d5117faee5c78f9$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $9d5117faee5c78f9$var$parse_shallow(u8);
    var R = $9d5117faee5c78f9$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $9d5117faee5c78f9$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $9d5117faee5c78f9$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $9d5117faee5c78f9$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage[$9d5117faee5c78f9$var$subarray](offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage[$9d5117faee5c78f9$var$subarray](offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $9d5117faee5c78f9$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $9d5117faee5c78f9$var$parse_shallow(root.data);
    var storage = -1;
    if ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) {
        if ($9d5117faee5c78f9$var$varint_to_i32(pb[7][0].data) >>> 0) storage = 1;
        else storage = 0;
    }
    var ri = $9d5117faee5c78f9$var$mappa(pb[5], function(u8) {
        return $9d5117faee5c78f9$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $9d5117faee5c78f9$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $9d5117faee5c78f9$var$parse_TST_TableModelArchive(M, root, ws) {
    var _a, _b, _c, _d, _e, _f;
    var pb = $9d5117faee5c78f9$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($9d5117faee5c78f9$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($9d5117faee5c78f9$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $9d5117faee5c78f9$var$encode_range(range);
    var dense = ws["!data"] != null, dws = ws;
    var store = $9d5117faee5c78f9$var$parse_shallow(pb[4][0].data);
    var lut = $9d5117faee5c78f9$var$numbers_lut_new();
    if ((_a = store[4]) == null ? void 0 : _a[0]) lut.sst = $9d5117faee5c78f9$var$parse_TST_TableDataList(M, M[$9d5117faee5c78f9$var$parse_TSP_Reference(store[4][0].data)][0]);
    if ((_b = store[11]) == null ? void 0 : _b[0]) lut.ofmt = $9d5117faee5c78f9$var$parse_TST_TableDataList(M, M[$9d5117faee5c78f9$var$parse_TSP_Reference(store[11][0].data)][0]);
    if ((_c = store[17]) == null ? void 0 : _c[0]) lut.rsst = $9d5117faee5c78f9$var$parse_TST_TableDataList(M, M[$9d5117faee5c78f9$var$parse_TSP_Reference(store[17][0].data)][0]);
    if ((_d = store[22]) == null ? void 0 : _d[0]) lut.nfmt = $9d5117faee5c78f9$var$parse_TST_TableDataList(M, M[$9d5117faee5c78f9$var$parse_TSP_Reference(store[22][0].data)][0]);
    var tile = $9d5117faee5c78f9$var$parse_shallow(store[3][0].data);
    var _R = 0;
    tile[1].forEach(function(t) {
        var tl = $9d5117faee5c78f9$var$parse_shallow(t.data);
        var ref2 = M[$9d5117faee5c78f9$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype2 = $9d5117faee5c78f9$var$varint_to_i32(ref2.meta[1][0].data);
        if (mtype2 != 6002) throw new Error("6001 unexpected reference to ".concat(mtype2));
        var _tile = $9d5117faee5c78f9$var$parse_TST_Tile(M, ref2);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var res = $9d5117faee5c78f9$var$parse_cell_storage(buf, lut);
                if (res) {
                    if (dense) {
                        if (!dws["!data"][_R + R]) dws["!data"][_R + R] = [];
                        dws["!data"][_R + R][C] = res;
                    } else ws[$9d5117faee5c78f9$var$encode_col(C) + $9d5117faee5c78f9$var$encode_row(_R + R)] = res;
                }
            });
        });
        _R += _tile.nrows;
    });
    if ((_e = store[13]) == null ? void 0 : _e[0]) {
        var ref = M[$9d5117faee5c78f9$var$parse_TSP_Reference(store[13][0].data)][0];
        var mtype = $9d5117faee5c78f9$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6144) throw new Error("Expected merge type 6144, found ".concat(mtype));
        ws["!merges"] = (_f = $9d5117faee5c78f9$var$parse_shallow(ref.data)) == null ? void 0 : _f[1].map(function(pi) {
            var merge = $9d5117faee5c78f9$var$parse_shallow(pi.data);
            var origin = $9d5117faee5c78f9$var$u8_to_dataview($9d5117faee5c78f9$var$parse_shallow(merge[1][0].data)[1][0].data), size = $9d5117faee5c78f9$var$u8_to_dataview($9d5117faee5c78f9$var$parse_shallow(merge[2][0].data)[1][0].data);
            return {
                s: {
                    r: origin.getUint16(0, true),
                    c: origin.getUint16(2, true)
                },
                e: {
                    r: origin.getUint16(0, true) + size.getUint16(0, true) - 1,
                    c: origin.getUint16(2, true) + size.getUint16(2, true) - 1
                }
            };
        });
    }
}
function $9d5117faee5c78f9$var$parse_TST_TableInfoArchive(M, root, opts) {
    var pb = $9d5117faee5c78f9$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    if (opts == null ? void 0 : opts.dense) out["!data"] = [];
    var tableref = M[$9d5117faee5c78f9$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $9d5117faee5c78f9$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $9d5117faee5c78f9$var$parse_TST_TableModelArchive(M, tableref[0], out);
    return out;
}
function $9d5117faee5c78f9$var$parse_TN_SheetArchive(M, root, opts) {
    var _a;
    var pb = $9d5117faee5c78f9$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $9d5117faee5c78f9$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $9d5117faee5c78f9$var$mappa(pb[2], $9d5117faee5c78f9$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $9d5117faee5c78f9$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($9d5117faee5c78f9$var$parse_TST_TableInfoArchive(M, m, opts));
        });
    });
    return out;
}
function $9d5117faee5c78f9$var$parse_TN_DocumentArchive(M, root, opts) {
    var _a;
    var out = $9d5117faee5c78f9$var$book_new();
    var pb = $9d5117faee5c78f9$var$parse_shallow(root.data);
    if ((_a = pb[2]) == null ? void 0 : _a[0]) throw new Error("Keynote presentations are not supported");
    var sheetoffs = $9d5117faee5c78f9$var$mappa(pb[1], $9d5117faee5c78f9$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $9d5117faee5c78f9$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $9d5117faee5c78f9$var$parse_TN_SheetArchive(M, m, opts);
                root2.sheets.forEach(function(sheet, idx) {
                    $9d5117faee5c78f9$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    out.bookType = "numbers";
    return out;
}
function $9d5117faee5c78f9$var$parse_numbers_iwa(cfb, opts) {
    var _a, _b, _c, _d, _e, _f, _g;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        if (s.content[0] != 0) return;
        var o;
        try {
            o = $9d5117faee5c78f9$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $9d5117faee5c78f9$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    if (((_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0].meta) == null ? void 0 : _b[1]) == null ? void 0 : _c[0].data) && $9d5117faee5c78f9$var$varint_to_i32(M[1][0].meta[1][0].data) == 1e4) throw new Error("Pages documents are not supported");
    var docroot = ((_g = (_f = (_e = (_d = M == null ? void 0 : M[1]) == null ? void 0 : _d[0]) == null ? void 0 : _e.meta) == null ? void 0 : _f[1]) == null ? void 0 : _g[0].data) && $9d5117faee5c78f9$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $9d5117faee5c78f9$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $9d5117faee5c78f9$var$parse_TN_DocumentArchive(M, docroot, opts);
}
function $9d5117faee5c78f9$var$write_TST_TileRowInfo(data, SST, wide) {
    var _a, _b;
    var tri = [
        [],
        [
            {
                type: 0,
                data: $9d5117faee5c78f9$var$write_varint49(0)
            }
        ],
        [
            {
                type: 0,
                data: $9d5117faee5c78f9$var$write_varint49(0)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $9d5117faee5c78f9$var$write_varint49(5)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $9d5117faee5c78f9$var$write_varint49(1)
            }
        ]
    ];
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var cnt = 0;
    if (tri[7][0].data.length < 2 * data.length) {
        var new_7 = new Uint8Array(2 * data.length);
        new_7.set(tri[7][0].data);
        tri[7][0].data = new_7;
    }
    if (tri[4][0].data.length < 2 * data.length) {
        var new_4 = new Uint8Array(2 * data.length);
        new_4.set(tri[4][0].data);
        tri[4][0].data = new_4;
    }
    var dv = $9d5117faee5c78f9$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $9d5117faee5c78f9$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    var width = wide ? 4 : 1;
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null) {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset / width, true);
        _dv.setUint16(C * 2, _last_offset / width, true);
        var celload, _celload;
        switch(typeof data[C]){
            case "string":
                celload = $9d5117faee5c78f9$var$write_new_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                _celload = $9d5117faee5c78f9$var$write_old_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                break;
            case "number":
                celload = $9d5117faee5c78f9$var$write_new_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                _celload = $9d5117faee5c78f9$var$write_old_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                break;
            case "boolean":
                celload = $9d5117faee5c78f9$var$write_new_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                _celload = $9d5117faee5c78f9$var$write_old_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                break;
            default:
                if (data[C] instanceof Date) {
                    celload = $9d5117faee5c78f9$var$write_new_storage({
                        t: "s",
                        v: data[C].toISOString()
                    }, SST);
                    _celload = $9d5117faee5c78f9$var$write_old_storage({
                        t: "s",
                        v: data[C].toISOString()
                    }, SST);
                    break;
                }
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $9d5117faee5c78f9$var$write_varint49(cnt);
    tri[5][0].data = $9d5117faee5c78f9$var$write_varint49(5);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $9d5117faee5c78f9$var$u8concat(cell_storage);
    tri[3][0].data = $9d5117faee5c78f9$var$u8concat(_cell_storage);
    tri[8] = [
        {
            type: 0,
            data: $9d5117faee5c78f9$var$write_varint49(wide ? 1 : 0)
        }
    ];
    return tri;
}
function $9d5117faee5c78f9$var$write_iwam(type, payload) {
    return {
        meta: [
            [],
            [
                {
                    type: 0,
                    data: $9d5117faee5c78f9$var$write_varint49(type)
                }
            ]
        ],
        data: payload
    };
}
function $9d5117faee5c78f9$var$get_unique_msgid(dep, dependents) {
    if (!dependents.last) dependents.last = 927262;
    for(var i = dependents.last; i < 2e6; ++i)if (!dependents[i]) {
        dependents[dependents.last = i] = dep;
        return i;
    }
    throw new Error("Too many messages");
}
function $9d5117faee5c78f9$var$build_numbers_deps(cfb) {
    var dependents = {};
    var indices = [];
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $9d5117faee5c78f9$var$parse_iwa_file($9d5117faee5c78f9$var$decompress_iwa_file(fi.content)).forEach(function(packet) {
            indices.push(packet.id);
            dependents[packet.id] = {
                deps: [],
                location: fp,
                type: $9d5117faee5c78f9$var$varint_to_i32(packet.messages[0].meta[1][0].data)
            };
        });
    });
    cfb.FileIndex.forEach(function(fi) {
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $9d5117faee5c78f9$var$parse_iwa_file($9d5117faee5c78f9$var$decompress_iwa_file(fi.content)).forEach(function(ia) {
            ia.messages.forEach(function(mess) {
                [
                    5,
                    6
                ].forEach(function(f) {
                    if (!mess.meta[f]) return;
                    mess.meta[f].forEach(function(x) {
                        dependents[ia.id].deps.push($9d5117faee5c78f9$var$varint_to_i32(x.data));
                    });
                });
            });
        });
    });
    return dependents;
}
function $9d5117faee5c78f9$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var cfb = $9d5117faee5c78f9$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    var deps = $9d5117faee5c78f9$var$build_numbers_deps(cfb);
    var docroot = $9d5117faee5c78f9$var$numbers_iwa_find(cfb, deps, 1);
    if (docroot == null) throw "Could not find message ".concat(1, " in Numbers template");
    var sheetrefs = $9d5117faee5c78f9$var$mappa($9d5117faee5c78f9$var$parse_shallow(docroot.messages[0].data)[1], $9d5117faee5c78f9$var$parse_TSP_Reference);
    if (sheetrefs.length > 1) throw new Error("Template NUMBERS file must have exactly one sheet");
    wb.SheetNames.forEach(function(name, idx) {
        if (idx >= 1) {
            $9d5117faee5c78f9$var$numbers_add_ws(cfb, deps, idx + 1);
            docroot = $9d5117faee5c78f9$var$numbers_iwa_find(cfb, deps, 1);
            sheetrefs = $9d5117faee5c78f9$var$mappa($9d5117faee5c78f9$var$parse_shallow(docroot.messages[0].data)[1], $9d5117faee5c78f9$var$parse_TSP_Reference);
        }
        $9d5117faee5c78f9$var$write_numbers_ws(cfb, deps, wb.Sheets[name], name, idx, sheetrefs[idx]);
    });
    return cfb;
}
function $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, id, cb) {
    var entry = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $9d5117faee5c78f9$var$parse_iwa_file($9d5117faee5c78f9$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    cb(ainfo, x);
    entry.content = $9d5117faee5c78f9$var$compress_iwa_file($9d5117faee5c78f9$var$write_iwa_file(x));
    entry.size = entry.content.length;
}
function $9d5117faee5c78f9$var$numbers_iwa_find(cfb, deps, id) {
    var entry = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $9d5117faee5c78f9$var$parse_iwa_file($9d5117faee5c78f9$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    return ainfo;
}
function $9d5117faee5c78f9$var$numbers_add_ws(cfb, deps, wsidx) {
    var sheetref = -1, newsheetref = -1;
    var remap = {};
    $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, 1, function(docroot, arch) {
        var doc = $9d5117faee5c78f9$var$parse_shallow(docroot.messages[0].data);
        sheetref = $9d5117faee5c78f9$var$parse_TSP_Reference($9d5117faee5c78f9$var$parse_shallow(docroot.messages[0].data)[1][0].data);
        newsheetref = $9d5117faee5c78f9$var$get_unique_msgid({
            deps: [
                1
            ],
            location: deps[sheetref].location,
            type: 2
        }, deps);
        remap[sheetref] = newsheetref;
        $9d5117faee5c78f9$var$numbers_add_oref(docroot, newsheetref);
        doc[1].push({
            type: 2,
            data: $9d5117faee5c78f9$var$write_TSP_Reference(newsheetref)
        });
        var sheet = $9d5117faee5c78f9$var$numbers_iwa_find(cfb, deps, sheetref);
        sheet.id = newsheetref;
        if (deps[1].location == deps[newsheetref].location) arch.push(sheet);
        else $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, newsheetref, function(_, x) {
            return x.push(sheet);
        });
        docroot.messages[0].data = $9d5117faee5c78f9$var$write_shallow(doc);
    });
    var tiaref = -1;
    $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, newsheetref, function(sheetroot, arch) {
        var sa = $9d5117faee5c78f9$var$parse_shallow(sheetroot.messages[0].data);
        for(var i = 3; i <= 69; ++i)delete sa[i];
        var drawables = $9d5117faee5c78f9$var$mappa(sa[2], $9d5117faee5c78f9$var$parse_TSP_Reference);
        drawables.forEach(function(n) {
            return $9d5117faee5c78f9$var$numbers_del_oref(sheetroot, n);
        });
        tiaref = $9d5117faee5c78f9$var$get_unique_msgid({
            deps: [
                newsheetref
            ],
            location: deps[drawables[0]].location,
            type: deps[drawables[0]].type
        }, deps);
        $9d5117faee5c78f9$var$numbers_add_oref(sheetroot, tiaref);
        remap[drawables[0]] = tiaref;
        sa[2] = [
            {
                type: 2,
                data: $9d5117faee5c78f9$var$write_TSP_Reference(tiaref)
            }
        ];
        var tia = $9d5117faee5c78f9$var$numbers_iwa_find(cfb, deps, drawables[0]);
        tia.id = tiaref;
        if (deps[drawables[0]].location == deps[newsheetref].location) arch.push(tia);
        else {
            var loc2 = deps[newsheetref].location;
            loc2 = loc2.replace(/^Root Entry\//, "");
            loc2 = loc2.replace(/^Index\//, "").replace(/\.iwa$/, "");
            $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $9d5117faee5c78f9$var$parse_shallow(ai.messages[0].data);
                var parentidx = mlist[3].findIndex(function(m) {
                    var _a, _b;
                    var mm = $9d5117faee5c78f9$var$parse_shallow(m.data);
                    if ((_a = mm[3]) == null ? void 0 : _a[0]) return $9d5117faee5c78f9$var$u8str(mm[3][0].data) == loc2;
                    if (((_b = mm[2]) == null ? void 0 : _b[0]) && $9d5117faee5c78f9$var$u8str(mm[2][0].data) == loc2) return true;
                    return false;
                });
                var parent = $9d5117faee5c78f9$var$parse_shallow(mlist[3][parentidx].data);
                if (!parent[6]) parent[6] = [];
                parent[6].push({
                    type: 2,
                    data: $9d5117faee5c78f9$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $9d5117faee5c78f9$var$write_varint49(tiaref)
                            }
                        ]
                    ])
                });
                mlist[3][parentidx].data = $9d5117faee5c78f9$var$write_shallow(parent);
                ai.messages[0].data = $9d5117faee5c78f9$var$write_shallow(mlist);
            });
            $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, tiaref, function(_, x) {
                return x.push(tia);
            });
        }
        sheetroot.messages[0].data = $9d5117faee5c78f9$var$write_shallow(sa);
    });
    var tmaref = -1;
    $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, tiaref, function(tiaroot, arch) {
        var tia = $9d5117faee5c78f9$var$parse_shallow(tiaroot.messages[0].data);
        var da = $9d5117faee5c78f9$var$parse_shallow(tia[1][0].data);
        for(var i = 3; i <= 69; ++i)delete da[i];
        var dap = $9d5117faee5c78f9$var$parse_TSP_Reference(da[2][0].data);
        da[2][0].data = $9d5117faee5c78f9$var$write_TSP_Reference(remap[dap]);
        tia[1][0].data = $9d5117faee5c78f9$var$write_shallow(da);
        var oldtmaref = $9d5117faee5c78f9$var$parse_TSP_Reference(tia[2][0].data);
        $9d5117faee5c78f9$var$numbers_del_oref(tiaroot, oldtmaref);
        tmaref = $9d5117faee5c78f9$var$get_unique_msgid({
            deps: [
                tiaref
            ],
            location: deps[oldtmaref].location,
            type: deps[oldtmaref].type
        }, deps);
        $9d5117faee5c78f9$var$numbers_add_oref(tiaroot, tmaref);
        remap[oldtmaref] = tmaref;
        tia[2][0].data = $9d5117faee5c78f9$var$write_TSP_Reference(tmaref);
        var tma = $9d5117faee5c78f9$var$numbers_iwa_find(cfb, deps, oldtmaref);
        tma.id = tmaref;
        if (deps[tiaref].location == deps[tmaref].location) arch.push(tma);
        else $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, tmaref, function(_, x) {
            return x.push(tma);
        });
        tiaroot.messages[0].data = $9d5117faee5c78f9$var$write_shallow(tia);
    });
    var loc = deps[tmaref].location;
    loc = loc.replace(/^Root Entry\//, "");
    loc = loc.replace(/^Index\//, "").replace(/\.iwa$/, "");
    $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, tmaref, function(tmaroot, arch) {
        var _a, _b;
        var tma = $9d5117faee5c78f9$var$parse_shallow(tmaroot.messages[0].data);
        var uuid = $9d5117faee5c78f9$var$u8str(tma[1][0].data), new_uuid = uuid.replace(/-[A-Z0-9]*/, "-".concat(wsidx.toString(16).padStart(4, "0")));
        tma[1][0].data = $9d5117faee5c78f9$var$stru8(new_uuid);
        [
            12,
            13,
            29,
            31,
            32,
            33,
            39,
            44,
            47,
            81,
            82,
            84
        ].forEach(function(n) {
            return delete tma[n];
        });
        if (tma[45]) {
            var srrta = $9d5117faee5c78f9$var$parse_shallow(tma[45][0].data);
            var ref = $9d5117faee5c78f9$var$parse_TSP_Reference(srrta[1][0].data);
            $9d5117faee5c78f9$var$numbers_del_oref(tmaroot, ref);
            delete tma[45];
        }
        if (tma[70]) {
            var hsoa = $9d5117faee5c78f9$var$parse_shallow(tma[70][0].data);
            (_a = hsoa[2]) == null || _a.forEach(function(item) {
                var hsa = $9d5117faee5c78f9$var$parse_shallow(item.data);
                [
                    2,
                    3
                ].map(function(n) {
                    return hsa[n][0];
                }).forEach(function(hseadata) {
                    var hsea = $9d5117faee5c78f9$var$parse_shallow(hseadata.data);
                    if (!hsea[8]) return;
                    var ref2 = $9d5117faee5c78f9$var$parse_TSP_Reference(hsea[8][0].data);
                    $9d5117faee5c78f9$var$numbers_del_oref(tmaroot, ref2);
                });
            });
            delete tma[70];
        }
        [
            46,
            30,
            34,
            35,
            36,
            38,
            48,
            49,
            60,
            61,
            62,
            63,
            64,
            71,
            72,
            73,
            74,
            75,
            85,
            86,
            87,
            88,
            89
        ].forEach(function(n) {
            if (!tma[n]) return;
            var ref2 = $9d5117faee5c78f9$var$parse_TSP_Reference(tma[n][0].data);
            delete tma[n];
            $9d5117faee5c78f9$var$numbers_del_oref(tmaroot, ref2);
        });
        var store = $9d5117faee5c78f9$var$parse_shallow(tma[4][0].data);
        [
            2,
            4,
            5,
            6,
            11,
            12,
            13,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22
        ].forEach(function(n) {
            var _a2;
            if (!((_a2 = store[n]) == null ? void 0 : _a2[0])) return;
            var oldref = $9d5117faee5c78f9$var$parse_TSP_Reference(store[n][0].data);
            var newref = $9d5117faee5c78f9$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $9d5117faee5c78f9$var$numbers_del_oref(tmaroot, oldref);
            $9d5117faee5c78f9$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $9d5117faee5c78f9$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $9d5117faee5c78f9$var$compress_iwa_file($9d5117faee5c78f9$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location;
                newloc = newloc.replace(/^Root Entry\//, "");
                newloc = newloc.replace(/^Index\//, "").replace(/\.iwa$/, "");
                $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $9d5117faee5c78f9$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $9d5117faee5c78f9$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $9d5117faee5c78f9$var$write_varint49(newref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $9d5117faee5c78f9$var$stru8(newloc.replace(/-.*$/, ""))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $9d5117faee5c78f9$var$stru8(newloc)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $9d5117faee5c78f9$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $9d5117faee5c78f9$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $9d5117faee5c78f9$var$write_varint49(Math.max(newref + 1, $9d5117faee5c78f9$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    var parentidx = mlist[3].findIndex(function(m) {
                        var _a3, _b2;
                        var mm = $9d5117faee5c78f9$var$parse_shallow(m.data);
                        if ((_a3 = mm[3]) == null ? void 0 : _a3[0]) return $9d5117faee5c78f9$var$u8str(mm[3][0].data) == loc;
                        if (((_b2 = mm[2]) == null ? void 0 : _b2[0]) && $9d5117faee5c78f9$var$u8str(mm[2][0].data) == loc) return true;
                        return false;
                    });
                    var parent = $9d5117faee5c78f9$var$parse_shallow(mlist[3][parentidx].data);
                    if (!parent[6]) parent[6] = [];
                    parent[6].push({
                        type: 2,
                        data: $9d5117faee5c78f9$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $9d5117faee5c78f9$var$write_varint49(newref)
                                }
                            ]
                        ])
                    });
                    mlist[3][parentidx].data = $9d5117faee5c78f9$var$write_shallow(parent);
                    ai.messages[0].data = $9d5117faee5c78f9$var$write_shallow(mlist);
                });
            }
            store[n][0].data = $9d5117faee5c78f9$var$write_TSP_Reference(newref);
        });
        var row_headers = $9d5117faee5c78f9$var$parse_shallow(store[1][0].data);
        (_b = row_headers[2]) == null || _b.forEach(function(tspref) {
            var oldref = $9d5117faee5c78f9$var$parse_TSP_Reference(tspref.data);
            var newref = $9d5117faee5c78f9$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $9d5117faee5c78f9$var$numbers_del_oref(tmaroot, oldref);
            $9d5117faee5c78f9$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $9d5117faee5c78f9$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $9d5117faee5c78f9$var$compress_iwa_file($9d5117faee5c78f9$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location;
                newloc = newloc.replace(/^Root Entry\//, "");
                newloc = newloc.replace(/^Index\//, "").replace(/\.iwa$/, "");
                $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $9d5117faee5c78f9$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $9d5117faee5c78f9$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $9d5117faee5c78f9$var$write_varint49(newref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $9d5117faee5c78f9$var$stru8(newloc.replace(/-.*$/, ""))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $9d5117faee5c78f9$var$stru8(newloc)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $9d5117faee5c78f9$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $9d5117faee5c78f9$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $9d5117faee5c78f9$var$write_varint49(Math.max(newref + 1, $9d5117faee5c78f9$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    var parentidx = mlist[3].findIndex(function(m) {
                        var _a2, _b2;
                        var mm = $9d5117faee5c78f9$var$parse_shallow(m.data);
                        if ((_a2 = mm[3]) == null ? void 0 : _a2[0]) return $9d5117faee5c78f9$var$u8str(mm[3][0].data) == loc;
                        if (((_b2 = mm[2]) == null ? void 0 : _b2[0]) && $9d5117faee5c78f9$var$u8str(mm[2][0].data) == loc) return true;
                        return false;
                    });
                    var parent = $9d5117faee5c78f9$var$parse_shallow(mlist[3][parentidx].data);
                    if (!parent[6]) parent[6] = [];
                    parent[6].push({
                        type: 2,
                        data: $9d5117faee5c78f9$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $9d5117faee5c78f9$var$write_varint49(newref)
                                }
                            ]
                        ])
                    });
                    mlist[3][parentidx].data = $9d5117faee5c78f9$var$write_shallow(parent);
                    ai.messages[0].data = $9d5117faee5c78f9$var$write_shallow(mlist);
                });
            }
            tspref.data = $9d5117faee5c78f9$var$write_TSP_Reference(newref);
        });
        store[1][0].data = $9d5117faee5c78f9$var$write_shallow(row_headers);
        var tiles = $9d5117faee5c78f9$var$parse_shallow(store[3][0].data);
        tiles[1].forEach(function(t) {
            var tst = $9d5117faee5c78f9$var$parse_shallow(t.data);
            var oldtileref = $9d5117faee5c78f9$var$parse_TSP_Reference(tst[2][0].data);
            var newtileref = remap[oldtileref];
            if (!remap[oldtileref]) {
                newtileref = $9d5117faee5c78f9$var$get_unique_msgid({
                    deps: [
                        tmaref
                    ],
                    location: "",
                    type: deps[oldtileref].type
                }, deps);
                deps[newtileref].location = "Root Entry/Index/Tables/Tile-".concat(newtileref, ".iwa");
                remap[oldtileref] = newtileref;
                var oldtile = $9d5117faee5c78f9$var$numbers_iwa_find(cfb, deps, oldtileref);
                oldtile.id = newtileref;
                $9d5117faee5c78f9$var$numbers_del_oref(tmaroot, oldtileref);
                $9d5117faee5c78f9$var$numbers_add_oref(tmaroot, newtileref);
                $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileref, ".iwa"), $9d5117faee5c78f9$var$compress_iwa_file($9d5117faee5c78f9$var$write_iwa_file([
                    oldtile
                ])));
                $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $9d5117faee5c78f9$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $9d5117faee5c78f9$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $9d5117faee5c78f9$var$write_varint49(newtileref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $9d5117faee5c78f9$var$stru8("Tables/Tile")
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $9d5117faee5c78f9$var$stru8("Tables/Tile-".concat(newtileref))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $9d5117faee5c78f9$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $9d5117faee5c78f9$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $9d5117faee5c78f9$var$write_varint49(Math.max(newtileref + 1, $9d5117faee5c78f9$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    var parentidx = mlist[3].findIndex(function(m) {
                        var _a2, _b2;
                        var mm = $9d5117faee5c78f9$var$parse_shallow(m.data);
                        if ((_a2 = mm[3]) == null ? void 0 : _a2[0]) return $9d5117faee5c78f9$var$u8str(mm[3][0].data) == loc;
                        if (((_b2 = mm[2]) == null ? void 0 : _b2[0]) && $9d5117faee5c78f9$var$u8str(mm[2][0].data) == loc) return true;
                        return false;
                    });
                    var parent = $9d5117faee5c78f9$var$parse_shallow(mlist[3][parentidx].data);
                    if (!parent[6]) parent[6] = [];
                    parent[6].push({
                        type: 2,
                        data: $9d5117faee5c78f9$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $9d5117faee5c78f9$var$write_varint49(newtileref)
                                }
                            ]
                        ])
                    });
                    mlist[3][parentidx].data = $9d5117faee5c78f9$var$write_shallow(parent);
                    ai.messages[0].data = $9d5117faee5c78f9$var$write_shallow(mlist);
                });
            }
            tst[2][0].data = $9d5117faee5c78f9$var$write_TSP_Reference(newtileref);
            t.data = $9d5117faee5c78f9$var$write_shallow(tst);
        });
        store[3][0].data = $9d5117faee5c78f9$var$write_shallow(tiles);
        tma[4][0].data = $9d5117faee5c78f9$var$write_shallow(store);
        tmaroot.messages[0].data = $9d5117faee5c78f9$var$write_shallow(tma);
    });
}
function $9d5117faee5c78f9$var$write_numbers_ws(cfb, deps, ws, wsname, sheetidx, rootref) {
    var drawables = [];
    $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, rootref, function(docroot) {
        var sheetref = $9d5117faee5c78f9$var$parse_shallow(docroot.messages[0].data);
        sheetref[1] = [
            {
                type: 2,
                data: $9d5117faee5c78f9$var$stru8(wsname)
            }
        ];
        drawables = $9d5117faee5c78f9$var$mappa(sheetref[2], $9d5117faee5c78f9$var$parse_TSP_Reference);
        docroot.messages[0].data = $9d5117faee5c78f9$var$write_shallow(sheetref);
    });
    var tia = $9d5117faee5c78f9$var$numbers_iwa_find(cfb, deps, drawables[0]);
    var tmaref = $9d5117faee5c78f9$var$parse_TSP_Reference($9d5117faee5c78f9$var$parse_shallow(tia.messages[0].data)[2][0].data);
    $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, tmaref, function(docroot, x) {
        return $9d5117faee5c78f9$var$write_numbers_tma(cfb, deps, ws, docroot, x, tmaref);
    });
}
var $9d5117faee5c78f9$var$USE_WIDE_ROWS = true;
function $9d5117faee5c78f9$var$write_numbers_tma(cfb, deps, ws, tmaroot, tmafile, tmaref) {
    var range = $9d5117faee5c78f9$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 999) {
        trunc = true;
        range.e.c = 999;
    }
    if (range.e.r > 999999) {
        trunc = true;
        range.e.r = 999999;
    }
    if (trunc) console.error("Truncating to ".concat($9d5117faee5c78f9$var$encode_range(range)));
    var data = $9d5117faee5c78f9$var$sheet_to_json(ws, {
        range: range,
        header: 1
    });
    var SST = [
        "~Sh33tJ5~"
    ];
    var loc = deps[tmaref].location;
    loc = loc.replace(/^Root Entry\//, "");
    loc = loc.replace(/^Index\//, "").replace(/\.iwa$/, "");
    var pb = $9d5117faee5c78f9$var$parse_shallow(tmaroot.messages[0].data);
    pb[6][0].data = $9d5117faee5c78f9$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $9d5117faee5c78f9$var$write_varint49(range.e.c + 1);
    delete pb[46];
    var store = $9d5117faee5c78f9$var$parse_shallow(pb[4][0].data);
    var row_header_ref = $9d5117faee5c78f9$var$parse_TSP_Reference($9d5117faee5c78f9$var$parse_shallow(store[1][0].data)[2][0].data);
    $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, row_header_ref, function(rowhead, _x) {
        var _a;
        var base_bucket = $9d5117faee5c78f9$var$parse_shallow(rowhead.messages[0].data);
        if ((_a = base_bucket == null ? void 0 : base_bucket[2]) == null ? void 0 : _a[0]) for(var R2 = 0; R2 < data.length; ++R2){
            var _bucket = $9d5117faee5c78f9$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $9d5117faee5c78f9$var$write_varint49(R2);
            _bucket[4][0].data = $9d5117faee5c78f9$var$write_varint49(data[R2].length);
            base_bucket[2][R2] = {
                type: base_bucket[2][0].type,
                data: $9d5117faee5c78f9$var$write_shallow(_bucket)
            };
        }
        rowhead.messages[0].data = $9d5117faee5c78f9$var$write_shallow(base_bucket);
    });
    var col_header_ref = $9d5117faee5c78f9$var$parse_TSP_Reference(store[2][0].data);
    $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, col_header_ref, function(colhead, _x) {
        var base_bucket = $9d5117faee5c78f9$var$parse_shallow(colhead.messages[0].data);
        for(var C = 0; C <= range.e.c; ++C){
            var _bucket = $9d5117faee5c78f9$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $9d5117faee5c78f9$var$write_varint49(C);
            _bucket[4][0].data = $9d5117faee5c78f9$var$write_varint49(range.e.r + 1);
            base_bucket[2][C] = {
                type: base_bucket[2][0].type,
                data: $9d5117faee5c78f9$var$write_shallow(_bucket)
            };
        }
        colhead.messages[0].data = $9d5117faee5c78f9$var$write_shallow(base_bucket);
    });
    var rbtree = $9d5117faee5c78f9$var$parse_shallow(store[9][0].data);
    rbtree[1] = [];
    var tilestore = $9d5117faee5c78f9$var$parse_shallow(store[3][0].data);
    var tstride = 256;
    tilestore[2] = [
        {
            type: 0,
            data: $9d5117faee5c78f9$var$write_varint49(tstride)
        }
    ];
    var tileref = $9d5117faee5c78f9$var$parse_TSP_Reference($9d5117faee5c78f9$var$parse_shallow(tilestore[1][0].data)[2][0].data);
    var save_token = function() {
        var metadata = $9d5117faee5c78f9$var$numbers_iwa_find(cfb, deps, 2);
        var mlist = $9d5117faee5c78f9$var$parse_shallow(metadata.messages[0].data);
        var mlst = mlist[3].filter(function(m) {
            return $9d5117faee5c78f9$var$varint_to_i32($9d5117faee5c78f9$var$parse_shallow(m.data)[1][0].data) == tileref;
        });
        return (mlst == null ? void 0 : mlst.length) ? $9d5117faee5c78f9$var$varint_to_i32($9d5117faee5c78f9$var$parse_shallow(mlst[0].data)[12][0].data) : 0;
    }();
    $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_del(cfb, deps[tileref].location);
    $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $9d5117faee5c78f9$var$parse_shallow(ai.messages[0].data);
        mlist[3] = mlist[3].filter(function(m) {
            return $9d5117faee5c78f9$var$varint_to_i32($9d5117faee5c78f9$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        var parentidx = mlist[3].findIndex(function(m) {
            var _a, _b;
            var mm = $9d5117faee5c78f9$var$parse_shallow(m.data);
            if ((_a = mm[3]) == null ? void 0 : _a[0]) return $9d5117faee5c78f9$var$u8str(mm[3][0].data) == loc;
            if (((_b = mm[2]) == null ? void 0 : _b[0]) && $9d5117faee5c78f9$var$u8str(mm[2][0].data) == loc) return true;
            return false;
        });
        var parent = $9d5117faee5c78f9$var$parse_shallow(mlist[3][parentidx].data);
        if (!parent[6]) parent[6] = [];
        parent[6] = parent[6].filter(function(m) {
            return $9d5117faee5c78f9$var$varint_to_i32($9d5117faee5c78f9$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        mlist[3][parentidx].data = $9d5117faee5c78f9$var$write_shallow(parent);
        ai.messages[0].data = $9d5117faee5c78f9$var$write_shallow(mlist);
    });
    $9d5117faee5c78f9$var$numbers_del_oref(tmaroot, tileref);
    tilestore[1] = [];
    var ntiles = Math.ceil((range.e.r + 1) / tstride);
    for(var tidx = 0; tidx < ntiles; ++tidx){
        var newtileid = $9d5117faee5c78f9$var$get_unique_msgid({
            deps: [],
            location: "",
            type: 6002
        }, deps);
        deps[newtileid].location = "Root Entry/Index/Tables/Tile-".concat(newtileid, ".iwa");
        var tiledata = [
            [],
            [
                {
                    type: 0,
                    data: $9d5117faee5c78f9$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $9d5117faee5c78f9$var$write_varint49(Math.min(range.e.r + 1, (tidx + 1) * tstride))
                }
            ],
            [
                {
                    type: 0,
                    data: $9d5117faee5c78f9$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $9d5117faee5c78f9$var$write_varint49(Math.min((tidx + 1) * tstride, range.e.r + 1) - tidx * tstride)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $9d5117faee5c78f9$var$write_varint49(5)
                }
            ],
            [
                {
                    type: 0,
                    data: $9d5117faee5c78f9$var$write_varint49(1)
                }
            ],
            [
                {
                    type: 0,
                    data: $9d5117faee5c78f9$var$write_varint49($9d5117faee5c78f9$var$USE_WIDE_ROWS ? 1 : 0)
                }
            ]
        ];
        for(var R = tidx * tstride; R <= Math.min(range.e.r, (tidx + 1) * tstride - 1); ++R){
            var tilerow = $9d5117faee5c78f9$var$write_TST_TileRowInfo(data[R], SST, $9d5117faee5c78f9$var$USE_WIDE_ROWS);
            tilerow[1][0].data = $9d5117faee5c78f9$var$write_varint49(R - tidx * tstride);
            tiledata[5].push({
                data: $9d5117faee5c78f9$var$write_shallow(tilerow),
                type: 2
            });
        }
        tilestore[1].push({
            type: 2,
            data: $9d5117faee5c78f9$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $9d5117faee5c78f9$var$write_varint49(tidx)
                    }
                ],
                [
                    {
                        type: 2,
                        data: $9d5117faee5c78f9$var$write_TSP_Reference(newtileid)
                    }
                ]
            ])
        });
        var newtile = {
            id: newtileid,
            messages: [
                $9d5117faee5c78f9$var$write_iwam(6002, $9d5117faee5c78f9$var$write_shallow(tiledata))
            ]
        };
        var tilecontent = $9d5117faee5c78f9$var$compress_iwa_file($9d5117faee5c78f9$var$write_iwa_file([
            newtile
        ]));
        $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileid, ".iwa"), tilecontent);
        $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $9d5117faee5c78f9$var$parse_shallow(ai.messages[0].data);
            mlist[3].push({
                type: 2,
                data: $9d5117faee5c78f9$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $9d5117faee5c78f9$var$write_varint49(newtileid)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $9d5117faee5c78f9$var$stru8("Tables/Tile")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $9d5117faee5c78f9$var$stru8("Tables/Tile-".concat(newtileid))
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 0,
                            data: $9d5117faee5c78f9$var$write_varint49(0)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $9d5117faee5c78f9$var$write_varint49(save_token)
                        }
                    ]
                ])
            });
            mlist[1] = [
                {
                    type: 0,
                    data: $9d5117faee5c78f9$var$write_varint49(Math.max(newtileid + 1, $9d5117faee5c78f9$var$varint_to_i32(mlist[1][0].data)))
                }
            ];
            var parentidx = mlist[3].findIndex(function(m) {
                var _a, _b;
                var mm = $9d5117faee5c78f9$var$parse_shallow(m.data);
                if ((_a = mm[3]) == null ? void 0 : _a[0]) return $9d5117faee5c78f9$var$u8str(mm[3][0].data) == loc;
                if (((_b = mm[2]) == null ? void 0 : _b[0]) && $9d5117faee5c78f9$var$u8str(mm[2][0].data) == loc) return true;
                return false;
            });
            var parent = $9d5117faee5c78f9$var$parse_shallow(mlist[3][parentidx].data);
            if (!parent[6]) parent[6] = [];
            parent[6].push({
                type: 2,
                data: $9d5117faee5c78f9$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $9d5117faee5c78f9$var$write_varint49(newtileid)
                        }
                    ]
                ])
            });
            mlist[3][parentidx].data = $9d5117faee5c78f9$var$write_shallow(parent);
            ai.messages[0].data = $9d5117faee5c78f9$var$write_shallow(mlist);
        });
        $9d5117faee5c78f9$var$numbers_add_oref(tmaroot, newtileid);
        rbtree[1].push({
            type: 2,
            data: $9d5117faee5c78f9$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $9d5117faee5c78f9$var$write_varint49(tidx * tstride)
                    }
                ],
                [
                    {
                        type: 0,
                        data: $9d5117faee5c78f9$var$write_varint49(tidx)
                    }
                ]
            ])
        });
    }
    store[3][0].data = $9d5117faee5c78f9$var$write_shallow(tilestore);
    store[9][0].data = $9d5117faee5c78f9$var$write_shallow(rbtree);
    store[10] = [
        {
            type: 2,
            data: new Uint8Array([])
        }
    ];
    if (ws["!merges"]) {
        var mergeid = $9d5117faee5c78f9$var$get_unique_msgid({
            type: 6144,
            deps: [
                tmaref
            ],
            location: deps[tmaref].location
        }, deps);
        tmafile.push({
            id: mergeid,
            messages: [
                $9d5117faee5c78f9$var$write_iwam(6144, $9d5117faee5c78f9$var$write_shallow([
                    [],
                    ws["!merges"].map(function(m) {
                        return {
                            type: 2,
                            data: $9d5117faee5c78f9$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 2,
                                        data: $9d5117faee5c78f9$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.s.r,
                                                        m.s.c
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ],
                                [
                                    {
                                        type: 2,
                                        data: $9d5117faee5c78f9$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.e.r - m.s.r + 1,
                                                        m.e.c - m.s.c + 1
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ]
                            ])
                        };
                    })
                ]))
            ]
        });
        store[13] = [
            {
                type: 2,
                data: $9d5117faee5c78f9$var$write_TSP_Reference(mergeid)
            }
        ];
        $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $9d5117faee5c78f9$var$parse_shallow(ai.messages[0].data);
            var parentidx = mlist[3].findIndex(function(m) {
                var _a, _b;
                var mm = $9d5117faee5c78f9$var$parse_shallow(m.data);
                if ((_a = mm[3]) == null ? void 0 : _a[0]) return $9d5117faee5c78f9$var$u8str(mm[3][0].data) == loc;
                if (((_b = mm[2]) == null ? void 0 : _b[0]) && $9d5117faee5c78f9$var$u8str(mm[2][0].data) == loc) return true;
                return false;
            });
            var parent = $9d5117faee5c78f9$var$parse_shallow(mlist[3][parentidx].data);
            if (!parent[6]) parent[6] = [];
            parent[6].push({
                type: 2,
                data: $9d5117faee5c78f9$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $9d5117faee5c78f9$var$write_varint49(mergeid)
                        }
                    ]
                ])
            });
            mlist[3][parentidx].data = $9d5117faee5c78f9$var$write_shallow(parent);
            ai.messages[0].data = $9d5117faee5c78f9$var$write_shallow(mlist);
        });
        $9d5117faee5c78f9$var$numbers_add_oref(tmaroot, mergeid);
    } else delete store[13];
    var sstref = $9d5117faee5c78f9$var$parse_TSP_Reference(store[4][0].data);
    $9d5117faee5c78f9$var$numbers_iwa_doit(cfb, deps, sstref, function(sstroot) {
        var sstdata = $9d5117faee5c78f9$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        SST.forEach(function(str, i) {
            if (i == 0) return;
            sstdata[3].push({
                type: 2,
                data: $9d5117faee5c78f9$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $9d5117faee5c78f9$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $9d5117faee5c78f9$var$write_varint49(1)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $9d5117faee5c78f9$var$stru8(str)
                        }
                    ]
                ])
            });
        });
        sstroot.messages[0].data = $9d5117faee5c78f9$var$write_shallow(sstdata);
    });
    pb[4][0].data = $9d5117faee5c78f9$var$write_shallow(store);
    tmaroot.messages[0].data = $9d5117faee5c78f9$var$write_shallow(pb);
}
function $9d5117faee5c78f9$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $9d5117faee5c78f9$var$fix_read_opts(opts) {
    $9d5117faee5c78f9$var$fix_opts_func([
        [
            'cellNF',
            false
        ],
        /* emit cell number format string as .z */ [
            'cellHTML',
            true
        ],
        /* emit html string as .h */ [
            'cellFormula',
            true
        ],
        /* emit formulae as .f */ [
            'cellStyles',
            false
        ],
        /* emits style/theme as .s */ [
            'cellText',
            true
        ],
        /* emit formatted text as .w */ [
            'cellDates',
            false
        ],
        /* emit date cells with type `d` */ [
            'sheetStubs',
            false
        ],
        /* emit empty cells */ [
            'sheetRows',
            0,
            'n'
        ],
        /* read n rows (0 = read all rows) */ [
            'bookDeps',
            false
        ],
        /* parse calculation chains */ [
            'bookSheets',
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            'bookProps',
            false
        ],
        /* only try to get properties (no Sheets) */ [
            'bookFiles',
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            'bookVBA',
            false
        ],
        /* include vba raw data (vbaraw) */ [
            'password',
            ''
        ],
        /* password */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $9d5117faee5c78f9$var$fix_write_opts(opts) {
    $9d5117faee5c78f9$var$fix_opts_func([
        [
            'cellDates',
            false
        ],
        /* write date cells with type `d` */ [
            'bookSST',
            false
        ],
        /* Generate Shared String Table */ [
            'bookType',
            'xlsx'
        ],
        /* Type of workbook (xlsx/m/b) */ [
            'compression',
            false
        ],
        /* Use file compression */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $9d5117faee5c78f9$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($9d5117faee5c78f9$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($9d5117faee5c78f9$var$RELS.CS && n == $9d5117faee5c78f9$var$RELS.CS) return "chart";
    if ($9d5117faee5c78f9$var$RELS.DS && n == $9d5117faee5c78f9$var$RELS.DS) return "dialog";
    if ($9d5117faee5c78f9$var$RELS.MS && n == $9d5117faee5c78f9$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $9d5117faee5c78f9$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels['!id'][w.id].Target,
                $9d5117faee5c78f9$var$get_sheet_type(wbrels['!id'][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $9d5117faee5c78f9$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $9d5117faee5c78f9$var$parse_rels($9d5117faee5c78f9$var$getzipstr(zip, relsPath, true), path);
        var data = $9d5117faee5c78f9$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case 'sheet':
                _ws = $9d5117faee5c78f9$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'chart':
                _ws = $9d5117faee5c78f9$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws['!drawel']) break;
                var dfile = $9d5117faee5c78f9$var$resolve_path(_ws['!drawel'].Target, path);
                var drelsp = $9d5117faee5c78f9$var$get_rels_path(dfile);
                var draw = $9d5117faee5c78f9$var$parse_drawing($9d5117faee5c78f9$var$getzipstr(zip, dfile, true), $9d5117faee5c78f9$var$parse_rels($9d5117faee5c78f9$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $9d5117faee5c78f9$var$resolve_path(draw, dfile);
                var crelsp = $9d5117faee5c78f9$var$get_rels_path(chartp);
                _ws = $9d5117faee5c78f9$var$parse_chart($9d5117faee5c78f9$var$getzipstr(zip, chartp, true), chartp, opts, $9d5117faee5c78f9$var$parse_rels($9d5117faee5c78f9$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case 'macro':
                _ws = $9d5117faee5c78f9$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'dialog':
                _ws = $9d5117faee5c78f9$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var comments = [], tcomments = [];
        if (sheetRels && sheetRels[sheet]) $9d5117faee5c78f9$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $9d5117faee5c78f9$var$RELS.CMNT) {
                dfile = $9d5117faee5c78f9$var$resolve_path(sheetRels[sheet][n].Target, path);
                comments = $9d5117faee5c78f9$var$parse_cmnt($9d5117faee5c78f9$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $9d5117faee5c78f9$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $9d5117faee5c78f9$var$RELS.TCMNT) {
                dfile = $9d5117faee5c78f9$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($9d5117faee5c78f9$var$parse_tcmnt_xml($9d5117faee5c78f9$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $9d5117faee5c78f9$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $9d5117faee5c78f9$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == '/' ? x.slice(1) : x;
}
function $9d5117faee5c78f9$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $9d5117faee5c78f9$var$make_ssf();
    opts = opts || {};
    $9d5117faee5c78f9$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($9d5117faee5c78f9$var$safegetzipfile(zip, 'META-INF/manifest.xml')) return $9d5117faee5c78f9$var$parse_ods(zip, opts);
    /* UOC */ if ($9d5117faee5c78f9$var$safegetzipfile(zip, 'objectdata.xml')) return $9d5117faee5c78f9$var$parse_ods(zip, opts);
    /* Numbers */ if ($9d5117faee5c78f9$var$safegetzipfile(zip, 'Index/Document.iwa')) {
        if (typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
        if (typeof $9d5117faee5c78f9$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $9d5117faee5c78f9$var$parse_numbers_iwa(zip, opts);
            var _zip = $9d5117faee5c78f9$export$9f0e51cd97c572a.utils.cfb_new();
            $9d5117faee5c78f9$var$zipentries(zip).forEach(function(e) {
                $9d5117faee5c78f9$var$zip_add_file(_zip, e, $9d5117faee5c78f9$var$getzipbin(zip, e));
            });
            return $9d5117faee5c78f9$var$parse_numbers_iwa(_zip, opts);
        }
        throw new Error('Unsupported NUMBERS file');
    }
    if (!$9d5117faee5c78f9$var$safegetzipfile(zip, '[Content_Types].xml')) {
        if ($9d5117faee5c78f9$var$safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
        if ($9d5117faee5c78f9$var$safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
        var index_zip = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(zip, 'Index.zip');
        if (index_zip) {
            opts = $9d5117faee5c78f9$var$dup(opts);
            delete opts.type;
            if (typeof index_zip.content == "string") opts.type = "binary";
            // TODO: Bun buffer bug
            if (typeof Bun !== "undefined" && $9d5117faee5c78f9$require$Buffer.isBuffer(index_zip.content)) return $9d5117faee5c78f9$export$aafa59e2e03f2942(new Uint8Array(index_zip.content), opts);
            return $9d5117faee5c78f9$export$aafa59e2e03f2942(index_zip.content, opts);
        }
        throw new Error('Unsupported ZIP file');
    }
    var entries = $9d5117faee5c78f9$var$zipentries(zip);
    var dir = $9d5117faee5c78f9$var$parse_ct($9d5117faee5c78f9$var$getzipstr(zip, '[Content_Types].xml'));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($9d5117faee5c78f9$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$9d5117faee5c78f9$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $9d5117faee5c78f9$var$strs = [];
        if (dir.sst) try {
            $9d5117faee5c78f9$var$strs = $9d5117faee5c78f9$var$parse_sst($9d5117faee5c78f9$var$getzipdata(zip, $9d5117faee5c78f9$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $9d5117faee5c78f9$var$parse_theme_xml($9d5117faee5c78f9$var$getzipstr(zip, dir.themes[0].replace(/^\//, ''), true) || "", opts);
        if (dir.style) styles = $9d5117faee5c78f9$var$parse_sty($9d5117faee5c78f9$var$getzipdata(zip, $9d5117faee5c78f9$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $9d5117faee5c78f9$var$parse_rels($9d5117faee5c78f9$var$getzipstr(zip, $9d5117faee5c78f9$var$get_rels_path($9d5117faee5c78f9$var$strip_front_slash(link))), link);
            return $9d5117faee5c78f9$var$parse_xlink($9d5117faee5c78f9$var$getzipdata(zip, $9d5117faee5c78f9$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $9d5117faee5c78f9$var$parse_wb($9d5117faee5c78f9$var$getzipdata(zip, $9d5117faee5c78f9$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $9d5117faee5c78f9$var$getzipdata(zip, $9d5117faee5c78f9$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $9d5117faee5c78f9$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $9d5117faee5c78f9$var$getzipdata(zip, $9d5117faee5c78f9$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $9d5117faee5c78f9$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $9d5117faee5c78f9$var$getzipstr(zip, $9d5117faee5c78f9$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $9d5117faee5c78f9$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $9d5117faee5c78f9$var$parse_cc($9d5117faee5c78f9$var$getzipdata(zip, $9d5117faee5c78f9$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$9d5117faee5c78f9$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
    var wbrels = $9d5117faee5c78f9$var$parse_rels($9d5117faee5c78f9$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $9d5117faee5c78f9$var$parse_xlmeta($9d5117faee5c78f9$var$getzipdata(zip, $9d5117faee5c78f9$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $9d5117faee5c78f9$var$parse_people_xml($9d5117faee5c78f9$var$getzipdata(zip, $9d5117faee5c78f9$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $9d5117faee5c78f9$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $9d5117faee5c78f9$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = 'xl/' + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$9d5117faee5c78f9$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$9d5117faee5c78f9$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = 'xl/worksheets/sheet' + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $9d5117faee5c78f9$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $9d5117faee5c78f9$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $9d5117faee5c78f9$var$dup($9d5117faee5c78f9$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $9d5117faee5c78f9$var$getzipdata(zip, $9d5117faee5c78f9$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $9d5117faee5c78f9$var$CT_VBA) out.vbaraw = $9d5117faee5c78f9$var$getzipdata(zip, 'xl/vbaProject.bin', true);
    }
    // TODO: pass back content types metdata for xlsm/xlsx resolution
    out.bookType = xlsb ? "xlsb" : "xlsx";
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $9d5117faee5c78f9$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = 'Workbook', data = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = '/!DataSpaces/Version';
        data = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $9d5117faee5c78f9$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = '/!DataSpaces/DataSpaceMap';
        data = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $9d5117faee5c78f9$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
        data = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $9d5117faee5c78f9$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
        data = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $9d5117faee5c78f9$var$parse_Primary(data.content);
    } catch (e) {}
    f = '/EncryptionInfo';
    data = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $9d5117faee5c78f9$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = '/EncryptedPackage';
    data = $9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $9d5117faee5c78f9$var$write_zip_xlsb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $9d5117faee5c78f9$var$dup($9d5117faee5c78f9$var$table_fmt);
    if (wb && wb.SSF) {
        $9d5117faee5c78f9$var$make_ssf();
        $9d5117faee5c78f9$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $9d5117faee5c78f9$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($9d5117faee5c78f9$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "bin";
    var vbafmt = true;
    var ct = $9d5117faee5c78f9$var$new_ct();
    $9d5117faee5c78f9$var$fix_write_opts(opts = opts || {});
    var zip = $9d5117faee5c78f9$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $9d5117faee5c78f9$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $9d5117faee5c78f9$var$add_rels(opts.rels, 2, f, $9d5117faee5c78f9$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $9d5117faee5c78f9$var$add_rels(opts.rels, 3, f, $9d5117faee5c78f9$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $9d5117faee5c78f9$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $9d5117faee5c78f9$var$add_rels(opts.rels, 4, f, $9d5117faee5c78f9$var$RELS.CUST_PROPS);
    }
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_ws_bin(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $9d5117faee5c78f9$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                cf = "xl/comments" + rId + "." + wbext;
                $9d5117faee5c78f9$var$zip_add_file(zip, cf, $9d5117faee5c78f9$var$write_comments_bin(comments, opts));
                ct.comments.push(cf);
                $9d5117faee5c78f9$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $9d5117faee5c78f9$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $9d5117faee5c78f9$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $9d5117faee5c78f9$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $9d5117faee5c78f9$var$zip_add_file(zip, $9d5117faee5c78f9$var$get_rels_path(f), $9d5117faee5c78f9$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_sst_bin(opts.Strings, opts));
        ct.strs.push(f);
        $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $9d5117faee5c78f9$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_wb_bin(wb, opts));
    ct.workbooks.push(f);
    $9d5117faee5c78f9$var$add_rels(opts.rels, 1, f, $9d5117faee5c78f9$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    var ww = $9d5117faee5c78f9$var$write_theme(wb.Themes, opts);
    $9d5117faee5c78f9$var$zip_add_file(zip, f, ww);
    ct.themes.push(f);
    $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $9d5117faee5c78f9$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_sty_bin(wb, opts));
    ct.styles.push(f);
    $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "styles." + wbext, $9d5117faee5c78f9$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $9d5117faee5c78f9$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $9d5117faee5c78f9$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_xlmeta_bin());
    ct.metadata.push(f);
    $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $9d5117faee5c78f9$var$RELS.XLMETA);
    $9d5117faee5c78f9$var$zip_add_file(zip, "[Content_Types].xml", $9d5117faee5c78f9$var$write_ct(ct, opts));
    $9d5117faee5c78f9$var$zip_add_file(zip, '_rels/.rels', $9d5117faee5c78f9$var$write_rels(opts.rels));
    $9d5117faee5c78f9$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $9d5117faee5c78f9$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $9d5117faee5c78f9$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $9d5117faee5c78f9$var$dup($9d5117faee5c78f9$var$table_fmt);
    if (wb && wb.SSF) {
        $9d5117faee5c78f9$var$make_ssf();
        $9d5117faee5c78f9$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $9d5117faee5c78f9$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($9d5117faee5c78f9$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $9d5117faee5c78f9$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $9d5117faee5c78f9$var$new_ct();
    $9d5117faee5c78f9$var$fix_write_opts(opts = opts || {});
    var zip = $9d5117faee5c78f9$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $9d5117faee5c78f9$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $9d5117faee5c78f9$var$add_rels(opts.rels, 2, f, $9d5117faee5c78f9$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $9d5117faee5c78f9$var$add_rels(opts.rels, 3, f, $9d5117faee5c78f9$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $9d5117faee5c78f9$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $9d5117faee5c78f9$var$add_rels(opts.rels, 4, f, $9d5117faee5c78f9$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $9d5117faee5c78f9$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $9d5117faee5c78f9$var$zip_add_file(zip, cf, $9d5117faee5c78f9$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $9d5117faee5c78f9$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $9d5117faee5c78f9$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $9d5117faee5c78f9$var$zip_add_file(zip, cf, $9d5117faee5c78f9$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $9d5117faee5c78f9$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $9d5117faee5c78f9$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $9d5117faee5c78f9$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $9d5117faee5c78f9$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $9d5117faee5c78f9$var$zip_add_file(zip, $9d5117faee5c78f9$var$get_rels_path(f), $9d5117faee5c78f9$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $9d5117faee5c78f9$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $9d5117faee5c78f9$var$add_rels(opts.rels, 1, f, $9d5117faee5c78f9$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $9d5117faee5c78f9$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "styles." + wbext, $9d5117faee5c78f9$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $9d5117faee5c78f9$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $9d5117faee5c78f9$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $9d5117faee5c78f9$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $9d5117faee5c78f9$var$zip_add_file(zip, f, $9d5117faee5c78f9$var$write_people_xml(people, opts));
        ct.people.push(f);
        $9d5117faee5c78f9$var$add_rels(opts.wbrels, -1, "persons/person.xml", $9d5117faee5c78f9$var$RELS.PEOPLE);
    }
    $9d5117faee5c78f9$var$zip_add_file(zip, "[Content_Types].xml", $9d5117faee5c78f9$var$write_ct(ct, opts));
    $9d5117faee5c78f9$var$zip_add_file(zip, '_rels/.rels', $9d5117faee5c78f9$var$write_rels(opts.rels));
    $9d5117faee5c78f9$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $9d5117faee5c78f9$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $9d5117faee5c78f9$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case 'buffer':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case 'base64':
            x = $9d5117faee5c78f9$var$Base64_decode(f.slice(0, 12));
            break;
        case 'binary':
            x = f;
            break;
        case 'array':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $9d5117faee5c78f9$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($9d5117faee5c78f9$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $9d5117faee5c78f9$var$parse_xlsxcfb(cfb, opts);
    return $9d5117faee5c78f9$export$b41972a043aba84c(cfb, opts);
}
function $9d5117faee5c78f9$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $9d5117faee5c78f9$var$zip_read(d, o);
    return $9d5117faee5c78f9$export$b165387946f79a1(zip, o);
}
function $9d5117faee5c78f9$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $9d5117faee5c78f9$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $9d5117faee5c78f9$var$PRN.to_workbook(data, o);
}
function $9d5117faee5c78f9$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $9d5117faee5c78f9$var$firstbyte(data, o);
    switch(o.type){
        case 'base64':
            str = $9d5117faee5c78f9$var$Base64_decode(data);
            break;
        case 'binary':
            str = data;
            break;
        case 'buffer':
            str = data.toString('binary');
            break;
        case 'array':
            str = $9d5117faee5c78f9$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $9d5117faee5c78f9$var$utf8read(str);
    o.type = "binary";
    return $9d5117faee5c78f9$var$read_plaintext(str, o);
}
function $9d5117faee5c78f9$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == 'base64') d = $9d5117faee5c78f9$var$Base64_decode(d);
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) d = new Uint8Array(data);
    d = typeof $9d5117faee5c78f9$var$$cptable !== "undefined" ? $9d5117faee5c78f9$var$$cptable.utils.decode(1200, d.slice(2), 'str') : $9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(data) ? data.slice(2).toString("utf16le") : typeof Uint8Array !== "undefined" && d instanceof Uint8Array ? typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le").decode(d.slice(2)) : $9d5117faee5c78f9$var$utf16lereadu(d.slice(2)) : $9d5117faee5c78f9$var$utf16leread(d.slice(2));
    o.type = "binary";
    return $9d5117faee5c78f9$var$read_plaintext(d, o);
}
function $9d5117faee5c78f9$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $9d5117faee5c78f9$var$utf8write(data);
}
function $9d5117faee5c78f9$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $9d5117faee5c78f9$var$PRN.to_workbook(data, o);
    }
    return $9d5117faee5c78f9$var$PRN.to_workbook(d, o);
}
function $9d5117faee5c78f9$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $9d5117faee5c78f9$var$reset_cp();
    var o = opts || {};
    if (o.codepage && typeof $9d5117faee5c78f9$var$$cptable === "undefined") console.error("Codepage tables are not loaded.  Non-ASCII characters may not give expected results");
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return $9d5117faee5c78f9$export$aafa59e2e03f2942(new Uint8Array(data), (o = $9d5117faee5c78f9$var$dup(o), o.type = "array", o));
    if (typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $9d5117faee5c78f9$var$_ssfopts = {};
    if (o.dateNF) $9d5117faee5c78f9$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $9d5117faee5c78f9$var$has_buf && $9d5117faee5c78f9$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $9d5117faee5c78f9$var$has_buf ? "buffer" : "binary";
        d = $9d5117faee5c78f9$var$read_binary(data);
        if (typeof Uint8Array !== 'undefined' && !$9d5117faee5c78f9$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $9d5117faee5c78f9$var$bstrify(data);
    }
    if (o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $9d5117faee5c78f9$var$dup(o);
            o.type = 'array';
            return $9d5117faee5c78f9$export$aafa59e2e03f2942($9d5117faee5c78f9$var$ab2a(d), o);
        }
    }
    switch((n = $9d5117faee5c78f9$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $9d5117faee5c78f9$var$read_cfb($9d5117faee5c78f9$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $9d5117faee5c78f9$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $9d5117faee5c78f9$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $9d5117faee5c78f9$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $9d5117faee5c78f9$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $9d5117faee5c78f9$var$read_zip(d, o) : $9d5117faee5c78f9$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $9d5117faee5c78f9$var$parse_xlml(d, o) : $9d5117faee5c78f9$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $9d5117faee5c78f9$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $9d5117faee5c78f9$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $9d5117faee5c78f9$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $9d5117faee5c78f9$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $9d5117faee5c78f9$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $9d5117faee5c78f9$var$rtf_to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $9d5117faee5c78f9$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
        case 0x08:
            if (n[1] === 0xE7) throw new Error("Unsupported Multiplan 1.x file!");
            break;
        case 0x0C:
            if (n[1] === 0xEC) throw new Error("Unsupported Multiplan 2.x file!");
            if (n[1] === 0xED) throw new Error("Unsupported Multiplan 3.x file!");
            break;
    }
    if ($9d5117faee5c78f9$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $9d5117faee5c78f9$var$DBF.to_workbook(d, o);
    return $9d5117faee5c78f9$var$read_prn(data, d, o, str);
}
function $9d5117faee5c78f9$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = 'file';
    return $9d5117faee5c78f9$export$aafa59e2e03f2942(filename, o);
}
function $9d5117faee5c78f9$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $9d5117faee5c78f9$var$write_dl(o.file, $9d5117faee5c78f9$export$9f0e51cd97c572a.write(cfb, {
                type: $9d5117faee5c78f9$var$has_buf ? 'buffer' : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $9d5117faee5c78f9$export$9f0e51cd97c572a.write(cfb, o);
}
function $9d5117faee5c78f9$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    switch(opts.bookType){
        case "ods":
            return $9d5117faee5c78f9$var$write_ods(wb, opts);
        case "numbers":
            return $9d5117faee5c78f9$var$write_numbers_iwa(wb, opts);
        case "xlsb":
            return $9d5117faee5c78f9$var$write_zip_xlsb(wb, opts);
        default:
            return $9d5117faee5c78f9$var$write_zip_xlsx(wb, opts);
    }
}
/*:: declare var encrypt_agile:any; */ function $9d5117faee5c78f9$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $9d5117faee5c78f9$var$dup(opts || {});
    var z = $9d5117faee5c78f9$var$write_zip(wb, o);
    return $9d5117faee5c78f9$var$write_zip_denouement(z, o);
}
function $9d5117faee5c78f9$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $9d5117faee5c78f9$var$dup(opts || {});
    var z = $9d5117faee5c78f9$var$write_zip_xlsx(wb, o);
    return $9d5117faee5c78f9$var$write_zip_denouement(z, o);
}
function $9d5117faee5c78f9$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $9d5117faee5c78f9$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = 'DEFLATE';
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $9d5117faee5c78f9$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($9d5117faee5c78f9$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== 'undefined') return $9d5117faee5c78f9$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $9d5117faee5c78f9$var$write_dl(o.file, out);
    return o.type == "string" ? $9d5117faee5c78f9$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $9d5117faee5c78f9$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $9d5117faee5c78f9$var$write_xlscfb(wb, o);
    return $9d5117faee5c78f9$var$write_cfb_ctr(cfb, o);
}
function $9d5117faee5c78f9$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $9d5117faee5c78f9$var$Base64_encode($9d5117faee5c78f9$var$utf8write(o));
        case "binary":
            return $9d5117faee5c78f9$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $9d5117faee5c78f9$var$write_dl(opts.file, o, 'utf8');
        case "buffer":
            if ($9d5117faee5c78f9$var$has_buf) return $9d5117faee5c78f9$var$Buffer_from(o, 'utf8');
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $9d5117faee5c78f9$var$write_string_type(o, {
                type: 'binary'
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $9d5117faee5c78f9$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $9d5117faee5c78f9$var$Base64_encode_pass(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $9d5117faee5c78f9$var$write_dl(opts.file, out, 'binary');
        case "buffer":
            if ($9d5117faee5c78f9$var$has_buf) return $9d5117faee5c78f9$var$Buffer_from(out, 'binary');
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $9d5117faee5c78f9$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == 'base64' ? $9d5117faee5c78f9$var$Base64_encode(bstr) : opts.type == 'string' ? $9d5117faee5c78f9$var$utf8read(bstr) : bstr;
        case "file":
            return $9d5117faee5c78f9$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $9d5117faee5c78f9$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $9d5117faee5c78f9$var$reset_cp();
    $9d5117faee5c78f9$var$check_wb(wb);
    var o = $9d5117faee5c78f9$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $9d5117faee5c78f9$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $9d5117faee5c78f9$var$s2ab(out);
    }
    return $9d5117faee5c78f9$var$write_zip_typeXLSX(wb, o);
}
function $9d5117faee5c78f9$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $9d5117faee5c78f9$var$reset_cp();
    $9d5117faee5c78f9$var$check_wb(wb);
    var o = $9d5117faee5c78f9$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $9d5117faee5c78f9$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $9d5117faee5c78f9$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || 'xlsb'){
        case 'xml':
        case 'xlml':
            return $9d5117faee5c78f9$var$write_string_type($9d5117faee5c78f9$var$write_xlml(wb, o), o);
        case 'slk':
        case 'sylk':
            return $9d5117faee5c78f9$var$write_string_type($9d5117faee5c78f9$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb), o);
        case 'htm':
        case 'html':
            return $9d5117faee5c78f9$var$write_string_type($9d5117faee5c78f9$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'txt':
            return $9d5117faee5c78f9$var$write_stxt_type($9d5117faee5c78f9$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'csv':
            return $9d5117faee5c78f9$var$write_string_type($9d5117faee5c78f9$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
        case 'dif':
            return $9d5117faee5c78f9$var$write_string_type($9d5117faee5c78f9$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'dbf':
            return $9d5117faee5c78f9$var$write_binary_type($9d5117faee5c78f9$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'prn':
            return $9d5117faee5c78f9$var$write_string_type($9d5117faee5c78f9$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'rtf':
            return $9d5117faee5c78f9$var$write_string_type($9d5117faee5c78f9$var$sheet_to_rtf(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'eth':
            return $9d5117faee5c78f9$var$write_string_type($9d5117faee5c78f9$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'fods':
            return $9d5117faee5c78f9$var$write_string_type($9d5117faee5c78f9$var$write_ods(wb, o), o);
        case 'wk1':
            return $9d5117faee5c78f9$var$write_binary_type($9d5117faee5c78f9$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'wk3':
            return $9d5117faee5c78f9$var$write_binary_type($9d5117faee5c78f9$var$WK_.book_to_wk3(wb, o), o);
        case 'biff2':
            if (!o.biff) o.biff = 2; /* falls through */ 
        case 'biff3':
            if (!o.biff) o.biff = 3; /* falls through */ 
        case 'biff4':
            if (!o.biff) o.biff = 4;
            return $9d5117faee5c78f9$var$write_binary_type($9d5117faee5c78f9$var$write_biff_buf(wb, o), o);
        case 'biff5':
            if (!o.biff) o.biff = 5; /* falls through */ 
        case 'biff8':
        case 'xla':
        case 'xls':
            if (!o.biff) o.biff = 8;
            return $9d5117faee5c78f9$var$write_cfb_type(wb, o);
        case 'xlsx':
        case 'xlsm':
        case 'xlam':
        case 'xlsb':
        case 'numbers':
        case 'ods':
            return $9d5117faee5c78f9$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $9d5117faee5c78f9$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $9d5117faee5c78f9$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $9d5117faee5c78f9$var$resolve_book_type(o);
    return $9d5117faee5c78f9$export$68d8715fc104d294(wb, o);
}
function $9d5117faee5c78f9$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $9d5117faee5c78f9$var$resolve_book_type(o);
    return $9d5117faee5c78f9$export$f6ca43591cb061b1(wb, o);
}
function $9d5117faee5c78f9$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $9d5117faee5c78f9$var$resolve_book_type(o);
    o.type = 'buffer';
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $9d5117faee5c78f9$var$_fs.writeFile(filename, $9d5117faee5c78f9$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $9d5117faee5c78f9$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $9d5117faee5c78f9$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true, dense = sheet["!data"] != null;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, '__rowNum__', {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet["!data"][R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val = dense ? (sheet["!data"][R] || [])[C] : sheet[cols[C] + rr];
        if (val === undefined || val.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val.v;
        switch(val.t){
            case 'z':
                if (v == null) break;
                continue;
            case 'e':
                v = v == 0 ? null : void 0;
                break;
            case 's':
            case 'd':
            case 'b':
            case 'n':
                break;
            default:
                throw new Error('unrecognized type ' + val.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = raw && (val.t !== "n" || val.t === "n" && o.rawNumbers !== false) ? v : $9d5117faee5c78f9$var$format_cell(val, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $9d5117faee5c78f9$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case 'string':
            r = $9d5117faee5c78f9$var$safe_decode_range(range);
            break;
        case 'number':
            r = $9d5117faee5c78f9$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $9d5117faee5c78f9$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $9d5117faee5c78f9$var$encode_col(C);
        val = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $9d5117faee5c78f9$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $9d5117faee5c78f9$var$make_json_row(sheet, r, R, cols, header, hdr, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $9d5117faee5c78f9$var$qreg = /"/g;
function $9d5117faee5c78f9$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $9d5117faee5c78f9$var$encode_row(R);
    var dense = sheet["!data"] != null;
    var datarow = dense && sheet["!data"][R] || [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val = dense ? datarow[C] : sheet[cols[C] + rr];
        if (val == null) txt = "";
        else if (val.v != null) {
            isempty = false;
            txt = '' + (o.rawNumbers && val.t == "n" ? val.v : $9d5117faee5c78f9$var$format_cell(val, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = "\"" + txt.replace($9d5117faee5c78f9$var$qreg, '""') + "\"";
                break;
            }
            if (txt == "ID") txt = '"ID"';
        } else if (val.f != null && !val.F) {
            isempty = false;
            txt = '=' + val.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($9d5117faee5c78f9$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $9d5117faee5c78f9$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $9d5117faee5c78f9$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $9d5117faee5c78f9$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $9d5117faee5c78f9$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
        if (row == null) continue;
        if (o.strip) row = row.replace(endregex, "");
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    return out.join("");
}
function $9d5117faee5c78f9$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "\t";
    opts.RS = "\n";
    var s = $9d5117faee5c78f9$var$sheet_to_csv(sheet, opts);
    if (typeof $9d5117faee5c78f9$var$$cptable == 'undefined' || opts.type == 'string') return s;
    var o = $9d5117faee5c78f9$var$$cptable.utils.encode(1200, s, 'str');
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $9d5117faee5c78f9$var$sheet_to_formulae(sheet /*:Worksheet*/ ) /*:Array<string>*/ {
    var y = "", x, val = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $9d5117faee5c78f9$var$safe_decode_range(sheet['!ref']), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = sheet["!data"] != null;
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $9d5117faee5c78f9$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $9d5117faee5c78f9$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet["!data"][R] || [])[C] : sheet[y];
            val = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val = x.f;
            else if (x.t == 'z') continue;
            else if (x.t == 'n' && x.v != null) val = "" + x.v;
            else if (x.t == 'b') val = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == 's') val = "'" + x.v;
            else val = "" + x.v;
            cmds[cmds.length] = y + "=" + val;
        }
    }
    return cmds;
}
function $9d5117faee5c78f9$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($9d5117faee5c78f9$var$DENSE != null && dense == null) dense = $9d5117faee5c78f9$var$DENSE;
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {};
    if (!_ws && dense) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $9d5117faee5c78f9$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws['!ref']) {
        var _range = $9d5117faee5c78f9$var$safe_decode_range(ws['!ref']);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    var ROW = [];
    js.forEach(function(JS, R /*:number*/ ) {
        if (dense && !ws["!data"][_R + R + offset]) ws["!data"][_R + R + offset] = [];
        if (dense) ROW = ws["!data"][_R + R + offset];
        $9d5117faee5c78f9$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = 'z';
            var z = "";
            var ref = dense ? "" : $9d5117faee5c78f9$var$encode_col(_C + C) + $9d5117faee5c78f9$var$encode_row(_R + R + offset);
            var cell /*:Cell*/  = dense ? ROW[_C + C] : ws[ref];
            if (v && typeof v === 'object' && !(v instanceof Date)) {
                if (dense) ROW[_C + C] = v;
                else ws[ref] = v;
            } else {
                if (typeof v == 'number') t = 'n';
                else if (typeof v == 'boolean') t = 'b';
                else if (typeof v == 'string') t = 's';
                else if (v instanceof Date) {
                    t = 'd';
                    if (!o.cellDates) {
                        t = 'n';
                        v = $9d5117faee5c78f9$var$datenum(v);
                    }
                    z = cell != null && cell.z && $9d5117faee5c78f9$var$fmt_is_date(cell.z) ? cell.z : o.dateNF || $9d5117faee5c78f9$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = 'e';
                    v = 0;
                }
                if (!cell) {
                    if (!dense) ws[ref] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                    else ROW[_C + C] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                } else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $9d5117faee5c78f9$var$encode_row(_R);
    if (dense && !ws["!data"][_R]) ws["!data"][_R] = [];
    if (offset) for(C = 0; C < hdr.length; ++C)if (dense) ws["!data"][_R][C + _C] = {
        t: 's',
        v: hdr[C]
    };
    else ws[$9d5117faee5c78f9$var$encode_col(C + _C) + __R] = {
        t: 's',
        v: hdr[C]
    };
    ws['!ref'] = $9d5117faee5c78f9$var$encode_range(range);
    return ws;
}
function $9d5117faee5c78f9$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $9d5117faee5c78f9$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $9d5117faee5c78f9$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        if (ws["!data"] != null) {
            var RC = $9d5117faee5c78f9$var$decode_cell(R);
            if (!ws["!data"][RC.r]) ws["!data"][RC.r] = [];
            return ws["!data"][RC.r][RC.c] || (ws["!data"][RC.r][RC.c] = {
                t: 'z'
            });
        }
        return ws[R] || (ws[R] = {
            t: 'z'
        });
    }
    /* cell address object */ if (typeof R != "number") return $9d5117faee5c78f9$var$ws_get_cell_stub(ws, $9d5117faee5c78f9$var$encode_cell(R));
    /* R and C are 0-based indices */ return $9d5117faee5c78f9$var$ws_get_cell_stub(ws, $9d5117faee5c78f9$var$encode_col(C || 0) + $9d5117faee5c78f9$var$encode_row(R));
}
/* find sheet index for given name / validate index */ function $9d5117faee5c78f9$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank workbook object */ function $9d5117faee5c78f9$var$book_new() /*:Workbook*/ {
    return {
        SheetNames: [],
        Sheets: {}
    };
}
/* add a worksheet to the end of a given workbook */ function $9d5117faee5c78f9$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0) {
        var m = name.match(/(^.*?)(\d+)$/);
        i = m && +m[2] || 0;
        var root = m && m[1] || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $9d5117faee5c78f9$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $9d5117faee5c78f9$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $9d5117faee5c78f9$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $9d5117faee5c78f9$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $9d5117faee5c78f9$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $9d5117faee5c78f9$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $9d5117faee5c78f9$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $9d5117faee5c78f9$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $9d5117faee5c78f9$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $9d5117faee5c78f9$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $9d5117faee5c78f9$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $9d5117faee5c78f9$var$ws_get_cell_stub(ws, R, C);
        cell.t = 'n';
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    var wsr = $9d5117faee5c78f9$var$decode_range(ws["!ref"]);
    if (wsr.s.r > rng.s.r) wsr.s.r = rng.s.r;
    if (wsr.s.c > rng.s.c) wsr.s.c = rng.s.c;
    if (wsr.e.r < rng.e.r) wsr.e.r = rng.e.r;
    if (wsr.e.c < rng.e.c) wsr.e.c = rng.e.c;
    ws["!ref"] = $9d5117faee5c78f9$var$encode_range(wsr);
    return ws;
}
var $9d5117faee5c78f9$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $9d5117faee5c78f9$var$encode_col,
    encode_row: $9d5117faee5c78f9$var$encode_row,
    encode_cell: $9d5117faee5c78f9$var$encode_cell,
    encode_range: $9d5117faee5c78f9$var$encode_range,
    decode_col: $9d5117faee5c78f9$var$decode_col,
    decode_row: $9d5117faee5c78f9$var$decode_row,
    split_cell: $9d5117faee5c78f9$var$split_cell,
    decode_cell: $9d5117faee5c78f9$var$decode_cell,
    decode_range: $9d5117faee5c78f9$var$decode_range,
    format_cell: $9d5117faee5c78f9$var$format_cell,
    sheet_add_aoa: $9d5117faee5c78f9$var$sheet_add_aoa,
    sheet_add_json: $9d5117faee5c78f9$var$sheet_add_json,
    sheet_add_dom: $9d5117faee5c78f9$var$sheet_add_dom,
    aoa_to_sheet: $9d5117faee5c78f9$var$aoa_to_sheet,
    json_to_sheet: $9d5117faee5c78f9$var$json_to_sheet,
    table_to_sheet: $9d5117faee5c78f9$var$parse_dom_table,
    table_to_book: $9d5117faee5c78f9$var$table_to_book,
    sheet_to_csv: $9d5117faee5c78f9$var$sheet_to_csv,
    sheet_to_txt: $9d5117faee5c78f9$var$sheet_to_txt,
    sheet_to_json: $9d5117faee5c78f9$var$sheet_to_json,
    sheet_to_html: $9d5117faee5c78f9$var$sheet_to_html,
    sheet_to_formulae: $9d5117faee5c78f9$var$sheet_to_formulae,
    sheet_to_row_object_array: $9d5117faee5c78f9$var$sheet_to_json,
    sheet_get_cell: $9d5117faee5c78f9$var$ws_get_cell_stub,
    book_new: $9d5117faee5c78f9$var$book_new,
    book_append_sheet: $9d5117faee5c78f9$var$book_append_sheet,
    book_set_sheet_visibility: $9d5117faee5c78f9$var$book_set_sheet_visibility,
    cell_set_number_format: $9d5117faee5c78f9$var$cell_set_number_format,
    cell_set_hyperlink: $9d5117faee5c78f9$var$cell_set_hyperlink,
    cell_set_internal_link: $9d5117faee5c78f9$var$cell_set_internal_link,
    cell_add_comment: $9d5117faee5c78f9$var$cell_add_comment,
    sheet_set_array_formula: $9d5117faee5c78f9$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $9d5117faee5c78f9$var$_Readable;
function $9d5117faee5c78f9$var$set_readable(R) {
    $9d5117faee5c78f9$var$_Readable = R;
}
function $9d5117faee5c78f9$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $9d5117faee5c78f9$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $9d5117faee5c78f9$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $9d5117faee5c78f9$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $9d5117faee5c78f9$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, o);
            if (row != null) {
                if (o.strip) row = row.replace(endregex, "");
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $9d5117faee5c78f9$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $9d5117faee5c78f9$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $9d5117faee5c78f9$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $9d5117faee5c78f9$var$HTML_END;
    stream.push(header);
    var r = $9d5117faee5c78f9$var$decode_range(ws['!ref']);
    stream.push($9d5117faee5c78f9$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($9d5117faee5c78f9$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $9d5117faee5c78f9$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $9d5117faee5c78f9$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case 'string':
            r = $9d5117faee5c78f9$var$safe_decode_range(range);
            break;
        case 'number':
            r = $9d5117faee5c78f9$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $9d5117faee5c78f9$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $9d5117faee5c78f9$var$encode_col(C);
        val = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $9d5117faee5c78f9$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $9d5117faee5c78f9$var$make_json_row(sheet, r, R, cols, header, hdr, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
var $9d5117faee5c78f9$export$4938110305e6185f = {
    to_json: $9d5117faee5c78f9$var$write_json_stream,
    to_html: $9d5117faee5c78f9$var$write_html_stream,
    to_csv: $9d5117faee5c78f9$var$write_csv_stream,
    set_readable: $9d5117faee5c78f9$var$set_readable
};
const $9d5117faee5c78f9$export$83d89fbfd8236492 = $9d5117faee5c78f9$var$XLSX.version;
var $9d5117faee5c78f9$export$2e2bcd8739ae039 = {
    parse_xlscfb: $9d5117faee5c78f9$export$b41972a043aba84c,
    parse_zip: $9d5117faee5c78f9$export$b165387946f79a1,
    read: $9d5117faee5c78f9$export$aafa59e2e03f2942,
    readFile: $9d5117faee5c78f9$export$72c04af63de9061a,
    readFileSync: $9d5117faee5c78f9$export$72c04af63de9061a,
    write: $9d5117faee5c78f9$export$68d8715fc104d294,
    writeFile: $9d5117faee5c78f9$export$552bfb764b5cd2b4,
    writeFileSync: $9d5117faee5c78f9$export$552bfb764b5cd2b4,
    writeFileAsync: $9d5117faee5c78f9$export$25469296c4b8ebda,
    writeXLSX: $9d5117faee5c78f9$export$f6ca43591cb061b1,
    writeFileXLSX: $9d5117faee5c78f9$export$40a06aea54ee074e,
    utils: $9d5117faee5c78f9$export$eab97d15b1788b8d,
    set_fs: $9d5117faee5c78f9$export$a48eb669e1768bcf,
    set_cptable: $9d5117faee5c78f9$export$58f247d16f363b86,
    stream: $9d5117faee5c78f9$export$4938110305e6185f,
    SSF: $9d5117faee5c78f9$export$40d8edd678456c2b,
    CFB: $9d5117faee5c78f9$export$9f0e51cd97c572a
};


/**
 * Reads a JSON file from local or remote location into a DataFrame.
 * @param file URL or local file path to JSON file.
 * @param options Configuration object. Supported options:
 * - `method`: The HTTP method to use. Defaults to `'GET'`.
 * - `headers`: Additional headers to send with the request. Supports the `node-fetch` [HeadersInit]
 * @example
 * ```
 * import { readExcel } from "danfojs-node"
 * const df = await readExcel("https://raw.githubusercontent.com/test.xlsx")
 * ```
 * @example
 * ```
 * import { readExcel } from "danfojs-node"
 * const df = await readExcel("https://raw.githubusercontent.com/test.xlsx", {
 *    method: "GET",
 *    headers: {
 *      Accept: "text/csv",
 *      Authorization: "Bearer YWRtaW46YWRtaW4="
 *    }
 * })
 * ```
 */ var $c80e91a4513448a4$var$$readExcel = function(file, options) {
    return $c80e91a4513448a4$var$__awaiter(void 0, void 0, void 0, function() {
        var _a, sheet, method, headers, frameConfig, parsingOptions, arrBuf, arrBufInt8, workbook, worksheet, data, df;
        return $c80e91a4513448a4$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = $c80e91a4513448a4$var$__assign({
                        sheet: 0,
                        method: "GET",
                        headers: {},
                        frameConfig: {},
                        parsingOptions: {}
                    }, options), sheet = _a.sheet, method = _a.method, headers = _a.headers, frameConfig = _a.frameConfig, parsingOptions = _a.parsingOptions;
                    if (!(typeof file === "string" && file.startsWith("http"))) return [
                        3 /*break*/ ,
                        1
                    ];
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve) {
                            fetch(file, {
                                method: method,
                                headers: headers
                            }).then(function(response) {
                                if (response.status !== 200) throw new Error("Failed to load " + file);
                                response.arrayBuffer().then(function(arrBuf) {
                                    var arrBufInt8 = new Uint8Array(arrBuf);
                                    var workbook = (0, $9d5117faee5c78f9$export$aafa59e2e03f2942)(arrBufInt8, $c80e91a4513448a4$var$__assign({
                                        type: "array"
                                    }, parsingOptions));
                                    var worksheet = workbook.Sheets[workbook.SheetNames[sheet]];
                                    var data = $9d5117faee5c78f9$export$eab97d15b1788b8d.sheet_to_json(worksheet);
                                    var df = new $4j43E.DataFrame(data, frameConfig);
                                    resolve(df);
                                });
                            }).catch(function(err) {
                                throw new Error(err);
                            });
                        })
                    ];
                case 1:
                    if (!(file instanceof File)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        file.arrayBuffer()
                    ];
                case 2:
                    arrBuf = _b.sent();
                    arrBufInt8 = new Uint8Array(arrBuf);
                    workbook = (0, $9d5117faee5c78f9$export$aafa59e2e03f2942)(arrBufInt8, $c80e91a4513448a4$var$__assign({
                        type: "array"
                    }, parsingOptions));
                    worksheet = workbook.Sheets[workbook.SheetNames[sheet]];
                    data = $9d5117faee5c78f9$export$eab97d15b1788b8d.sheet_to_json(worksheet);
                    df = new $4j43E.DataFrame(data, frameConfig);
                    return [
                        2 /*return*/ ,
                        df
                    ];
                case 3:
                    throw new Error("ParamError: File not supported. file must be a url or an input File object");
            }
        });
    });
};
$c80e91a4513448a4$exports.$readExcel = $c80e91a4513448a4$var$$readExcel;
/**
 * Converts a DataFrame or Series to Excel Sheet.
 * @param df DataFrame or Series to be converted to JSON.
 * @param options Configuration object. Supported options:
 * - `sheetName`: The sheet name to be written to. Defaults to `'Sheet1'`.
 * - `fileName`: The file to be written to. Defaults to `'./output.xlsx'`.
 * @example
 * ```
 * import { toExcel } from "danfojs-node"
 * const df = new DataFrame([[1, 2, 3], [4, 5, 6]])
 * toExcel(df, {
 *     fileName: "./data/sample.xlsx",
 *     sheetName: "MySheet",
 *   })
 * ```
 */ var $c80e91a4513448a4$var$$toExcel = function(df, options) {
    var _a = $c80e91a4513448a4$var$__assign({
        fileName: "./output.xlsx",
        sheetName: "Sheet1"
    }, options), fileName = _a.fileName, sheetName = _a.sheetName, writingOptions = _a.writingOptions;
    if (!fileName.endsWith(".xlsx")) fileName = fileName + ".xlsx";
    var data;
    if (df.$isSeries) {
        var row = df.values;
        var col = df.columns;
        data = $c80e91a4513448a4$var$__spreadArray([
            col
        ], row.map(function(x) {
            return [
                x
            ];
        }), true);
    } else {
        var row = df.values;
        var cols = df.columns;
        data = $c80e91a4513448a4$var$__spreadArray([
            cols
        ], row, true);
    }
    var worksheet = $9d5117faee5c78f9$export$eab97d15b1788b8d.aoa_to_sheet(data);
    var wb = $9d5117faee5c78f9$export$eab97d15b1788b8d.book_new();
    $9d5117faee5c78f9$export$eab97d15b1788b8d.book_append_sheet(wb, worksheet, sheetName);
    (0, $9d5117faee5c78f9$export$552bfb764b5cd2b4)(wb, "" + fileName, writingOptions);
};
$c80e91a4513448a4$exports.$toExcel = $c80e91a4513448a4$var$$toExcel;


Object.defineProperty($b9dc96d5b5d17565$exports, "readExcelBrowser", {
    enumerable: true,
    get: function() {
        return $c80e91a4513448a4$exports.$readExcel;
    }
});
Object.defineProperty($b9dc96d5b5d17565$exports, "toExcelBrowser", {
    enumerable: true,
    get: function() {
        return $c80e91a4513448a4$exports.$toExcel;
    }
});


Object.defineProperty($fe8436a5a6cf553d$exports, "readCSV", {
    enumerable: true,
    get: function() {
        return $b9dc96d5b5d17565$exports.readCSVBrowser;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "streamCSV", {
    enumerable: true,
    get: function() {
        return $b9dc96d5b5d17565$exports.streamCSVBrowser;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "toCSV", {
    enumerable: true,
    get: function() {
        return $b9dc96d5b5d17565$exports.toCSVBrowser;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "readJSON", {
    enumerable: true,
    get: function() {
        return $b9dc96d5b5d17565$exports.readJSONBrowser;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "toJSON", {
    enumerable: true,
    get: function() {
        return $b9dc96d5b5d17565$exports.toJSONBrowser;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "readExcel", {
    enumerable: true,
    get: function() {
        return $b9dc96d5b5d17565$exports.readExcelBrowser;
    }
});
Object.defineProperty($fe8436a5a6cf553d$exports, "toExcel", {
    enumerable: true,
    get: function() {
        return $b9dc96d5b5d17565$exports.toExcelBrowser;
    }
});

var $fe8436a5a6cf553d$var$frame_1 = $fe8436a5a6cf553d$var$__importDefault((parcelRequire("ie8g1")));
$fe8436a5a6cf553d$exports.DataFrame = $fe8436a5a6cf553d$var$frame_1.default;

var $fe8436a5a6cf553d$var$series_1 = $fe8436a5a6cf553d$var$__importDefault((parcelRequire("4NwBO")));
$fe8436a5a6cf553d$exports.Series = $fe8436a5a6cf553d$var$series_1.default;



const $35da740d59af89ba$var$embed = window.vegaEmbed;
var $6b4f39a781de26bf$exports = {};
$6b4f39a781de26bf$exports = import.meta.resolve("cDAqa");


const $35da740d59af89ba$var$DATA_URL = new URL($6b4f39a781de26bf$exports);
const $35da740d59af89ba$var$METRICS = [
    {
        key: "test_acc",
        label: "Acc"
    },
    {
        key: "test_auc",
        label: "AUC"
    },
    {
        key: "test_f1_macro",
        label: "F1"
    }
];
const $35da740d59af89ba$var$METRIC_SUFFIX_TO_KEY = {
    acc: "test_acc",
    auc: "test_auc",
    f1: "test_f1_macro"
};
const $35da740d59af89ba$var$STRATEGY_ORDER = [
    "LP",
    "partial_start_20",
    "partial_end_20",
    "partial_start_40",
    "partial_end_40",
    "partial_start_60",
    "partial_end_60",
    "full"
];
const $35da740d59af89ba$var$BACKBONE_SHAPES = {
    "densenet121": "circle",
    "swin_tiny_patch4_window7_224": "square"
};
const $35da740d59af89ba$var$EXCLUDED_BACKBONES = new Set([
    "resnet18",
    "vit_base_patch16_224"
]);
const $35da740d59af89ba$var$MOBILE_BREAKPOINT = 640;
const $35da740d59af89ba$var$TABLET_BREAKPOINT = 980;
/* Stable color palette for datasets (tableau10 hex values) */ const $35da740d59af89ba$var$TABLEAU10 = [
    "#4e79a7",
    "#f28e2c",
    "#e15759",
    "#76b7b2",
    "#59a14f",
    "#edc949",
    "#af7aa1",
    "#ff9da7",
    "#9c755f",
    "#bab0ab"
];
/** Build a fixed dataset→color map so colours never shuffle. */ const $35da740d59af89ba$var$buildDatasetColorMap = (datasets)=>{
    const map = new Map();
    const sorted = [
        ...datasets
    ].sort();
    sorted.forEach((name, i)=>{
        map.set(name, $35da740d59af89ba$var$TABLEAU10[i % $35da740d59af89ba$var$TABLEAU10.length]);
    });
    return map;
};
/* ── Interaction state ─────────────────────────────────────────────── */ const $35da740d59af89ba$var$interactionState = {
    visibleDatasets: new Set(),
    allDatasets: [],
    currentMetric: "test_acc",
    currentBackbone: null,
    // Reverse map: sanitized key → original dataset name
    datasetKeyToName: new Map(),
    // Fixed color mapping: dataset name → color
    datasetColorMap: new Map(),
    // Current table-driven highlight state
    highlightedDataset: null,
    highlightedStrategy: null,
    // Map dataset name → task type (e.g., "classification", "multilabel")
    datasetTaskMap: new Map(),
    // Set of dataset names where test_auc_macro was used instead of test_auc
    datasetAucMacroSet: new Set()
};
/* ── Helpers ───────────────────────────────────────────────────────── */ const $35da740d59af89ba$var$toNumberSeries = (series)=>{
    const values = series.values.map((value)=>{
        if (value === "" || value === null || value === undefined) return NaN;
        const numberValue = Number(value);
        return Number.isFinite(numberValue) ? numberValue : NaN;
    });
    return values;
};
const $35da740d59af89ba$var$getResponsiveChartDimensions = (chartElement)=>{
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1200;
    const containerWidth = chartElement.clientWidth || chartElement.parentElement?.clientWidth || 960;
    const chartWidth = Math.max(280, Math.floor(containerWidth - 8));
    let chartHeight = 780;
    if (viewportWidth <= $35da740d59af89ba$var$MOBILE_BREAKPOINT) chartHeight = 420;
    else if (viewportWidth <= $35da740d59af89ba$var$TABLET_BREAKPOINT) chartHeight = 600;
    return {
        chartWidth: chartWidth,
        chartHeight: chartHeight,
        isMobile: viewportWidth <= $35da740d59af89ba$var$MOBILE_BREAKPOINT
    };
};
/* ── Pivot ─────────────────────────────────────────────────────────── */ const $35da740d59af89ba$var$buildPivot = (rows)=>{
    const datasetSet = new Set();
    const strategySet = new Set();
    rows.forEach((row)=>{
        if (!row.dataset || !row.strategy) return;
        datasetSet.add(row.dataset);
        strategySet.add(row.strategy);
    });
    const datasets = Array.from(datasetSet).sort();
    const strategies = Array.from(strategySet).sort();
    const datasetKeys = new Map(datasets.map((dataset)=>[
            dataset,
            dataset.replace(/[^a-z0-9]+/gi, "_")
        ]));
    // Build reverse map
    $35da740d59af89ba$var$interactionState.datasetKeyToName.clear();
    datasetKeys.forEach((key, name)=>{
        $35da740d59af89ba$var$interactionState.datasetKeyToName.set(key, name);
    });
    const tableRows = strategies.map((strategy)=>{
        const row = {
            strategy: strategy
        };
        datasets.forEach((dataset)=>{
            const datasetKey = datasetKeys.get(dataset);
            $35da740d59af89ba$var$METRICS.forEach(({ label: label })=>{
                const fieldKey = `${datasetKey}__${label.toLowerCase()}`;
                row[fieldKey] = null;
            });
        });
        return row;
    });
    const rowIndex = new Map(tableRows.map((row)=>[
            row.strategy,
            row
        ]));
    rows.forEach((row)=>{
        const strategyRow = rowIndex.get(row.strategy);
        const datasetKey = datasetKeys.get(row.dataset);
        if (!strategyRow || !datasetKey) return;
        $35da740d59af89ba$var$METRICS.forEach(({ key: key, label: label })=>{
            const metricKey = row.metricKeys?.[key] ?? key;
            const fieldKey = `${datasetKey}__${label.toLowerCase()}`;
            const value = row[metricKey];
            strategyRow[fieldKey] = Number.isFinite(value) ? value : null;
        });
    });
    return {
        datasets: datasets,
        datasetKeys: datasetKeys,
        tableRows: tableRows
    };
};
/* ── Columns (with interactive headers) ────────────────────────────── */ const $35da740d59af89ba$var$buildColumns = (datasets, datasetKeys, tableRows, onDatasetToggle, onMetricClick)=>{
    const metricColumns = $35da740d59af89ba$var$METRICS.map(({ label: label })=>({
            title: label,
            fieldSuffix: label.toLowerCase()
        }));
    const highlightMap = new Map();
    datasets.forEach((dataset)=>{
        const datasetKey = datasetKeys.get(dataset);
        $35da740d59af89ba$var$METRICS.forEach(({ label: label })=>{
            const field = `${datasetKey}__${label.toLowerCase()}`;
            const ranked = tableRows.map((row)=>({
                    strategy: row.strategy,
                    value: row[field]
                })).filter(({ value: value })=>Number.isFinite(value)).sort((a, b)=>{
                if (b.value !== a.value) return b.value - a.value;
                return String(a.strategy).localeCompare(String(b.strategy));
            });
            const topRankings = new Map();
            ranked.slice(0, 3).forEach(({ strategy: strategy }, index)=>{
                topRankings.set(strategy, index + 1);
            });
            highlightMap.set(field, topRankings);
        });
    });
    const formatMetric = (cell)=>{
        const value = cell.getValue();
        if (value == null || Number.isNaN(value)) return "";
        return Number(value).toFixed(4);
    };
    const formatMetricWithHighlight = (cell)=>{
        const output = formatMetric(cell);
        if (!output) return output;
        const field = cell.getField();
        const strategy = cell.getRow().getData().strategy;
        const highlightSet = highlightMap.get(field);
        const element = cell.getElement();
        const rank = highlightSet?.get(strategy);
        if (element) {
            if (rank) element.classList.add("cell-top-rank");
            else element.classList.remove("cell-top-rank");
            // Add hidden-dataset class if this column's dataset is hidden
            const datasetKey = field.split("__")[0];
            const datasetName = $35da740d59af89ba$var$interactionState.datasetKeyToName.get(datasetKey);
            if (datasetName && !$35da740d59af89ba$var$interactionState.visibleDatasets.has(datasetName)) element.classList.add("cell-dataset-hidden");
            else element.classList.remove("cell-dataset-hidden");
        }
        if (!rank) return output;
        return `
      <span class="rank-badge" aria-label="Rank ${rank}">${rank}</span>
      <span class="metric-value">${output}</span>
    `;
    };
    const columns = [
        {
            title: "Strategy",
            field: "strategy",
            headerFilter: "input",
            frozen: true,
            width: 160
        }
    ];
    datasets.forEach((dataset)=>{
        const datasetKey = datasetKeys.get(dataset);
        const isHidden = !$35da740d59af89ba$var$interactionState.visibleDatasets.has(dataset);
        const task = $35da740d59af89ba$var$interactionState.datasetTaskMap.get(dataset);
        const headerTitle = task ? `${dataset} [${task}]` : dataset;
        columns.push({
            title: headerTitle,
            cssClass: `dataset-col-group${isHidden ? " dataset-hidden" : ""}`,
            headerClick: (e, column)=>{
                e.stopPropagation();
                onDatasetToggle(dataset, column);
            },
            columns: metricColumns.filter(({ fieldSuffix: fieldSuffix })=>{
                // For chestmnist, only show AUC (hide Acc and F1)
                if (dataset === "chestmnist" && (fieldSuffix === "acc" || fieldSuffix === "f1")) return false;
                return true;
            }).map(({ title: title, fieldSuffix: fieldSuffix }, _i, filtered)=>{
                const metricKey = $35da740d59af89ba$var$METRIC_SUFFIX_TO_KEY[fieldSuffix];
                const isActiveMetric = metricKey === $35da740d59af89ba$var$interactionState.currentMetric;
                // Show "Macro AUC" for datasets that use test_auc_macro fallback
                const colTitle = fieldSuffix === "auc" && $35da740d59af89ba$var$interactionState.datasetAucMacroSet.has(dataset) ? "Macro AUC" : title;
                // If fewer sub-columns than normal, widen to fill the parent group
                const colWidth = filtered.length < metricColumns.length ? Math.floor(96 * metricColumns.length / filtered.length) : 96;
                return {
                    title: colTitle,
                    field: `${datasetKey}__${fieldSuffix}`,
                    hozAlign: "right",
                    sorter: "number",
                    formatter: formatMetricWithHighlight,
                    width: colWidth,
                    cssClass: `metric-col${isActiveMetric ? " metric-col-active" : ""}`,
                    headerClick: (e, column)=>{
                        e.stopPropagation();
                        onMetricClick(metricKey, column);
                    }
                };
            })
        });
    });
    return columns;
};
/* ── Chart data ────────────────────────────────────────────────────── */ const $35da740d59af89ba$var$buildLineChartData = (rows, metricKey)=>{
    const lineChartData = [];
    const metric = $35da740d59af89ba$var$METRICS.find(({ key: key })=>key === metricKey);
    if (!metric) return lineChartData;
    rows.forEach((row)=>{
        if (!row.dataset || !row.strategy || !row.backbone) return;
        // Filter by visible datasets
        if (!$35da740d59af89ba$var$interactionState.visibleDatasets.has(row.dataset)) return;
        // chestmnist only has AUC; skip it for Acc and F1 metrics
        if (row.dataset === "chestmnist" && (metricKey === "test_acc" || metricKey === "test_f1_macro")) return;
        const metricFieldKey = row.metricKeys?.[metricKey] ?? metricKey;
        const value = row[metricFieldKey];
        if (Number.isFinite(value) && value > 0) lineChartData.push({
            strategy: row.strategy,
            dataset: row.dataset,
            backbone: row.backbone,
            value: value
        });
    });
    return lineChartData;
};
/* ── Chart spec (with hover selection support) ─────────────────────── */ const $35da740d59af89ba$var$buildLineChartSpec = (data, metricKey, chartWidth, chartHeight, activeBackbone, isMobile)=>{
    const metric = $35da740d59af89ba$var$METRICS.find(({ key: key })=>key === metricKey);
    const metricLabel = metric ? metric.label : "Metric";
    const strategySort = [
        ...$35da740d59af89ba$var$STRATEGY_ORDER
    ];
    // Determine if we have a specific backbone highlighted
    const hasBackboneHighlight = activeBackbone != null;
    // Fixed color domain and range from the stable color map
    const colorMap = $35da740d59af89ba$var$interactionState.datasetColorMap;
    const colorDomain = [
        ...colorMap.keys()
    ];
    const colorRange = colorDomain.map((d)=>colorMap.get(d));
    // Table-driven highlight state
    const hlDataset = $35da740d59af89ba$var$interactionState.highlightedDataset;
    const hlStrategy = $35da740d59af89ba$var$interactionState.highlightedStrategy;
    const hasTableHighlight = hlDataset != null;
    const hasCellHighlight = hlDataset != null && hlStrategy != null;
    // Build conditional opacity for backbone highlighting
    const buildLineOpacity = ()=>{
        if (hasCellHighlight) return {
            condition: {
                test: `datum.dataset === '${hlDataset}'`,
                value: 0.8
            },
            value: 0.15
        };
        if (hasTableHighlight) return {
            condition: {
                test: `datum.dataset === '${hlDataset}'`,
                value: 1
            },
            value: 0.15
        };
        if (hasBackboneHighlight) return {
            condition: {
                test: `datum.backbone === '${activeBackbone}'`,
                value: 1
            },
            value: 0.2
        };
        return {
            value: 0.8
        };
    };
    const buildPointOpacity = ()=>{
        if (hasCellHighlight) return {
            condition: {
                test: `datum.strategy === '${hlStrategy}' && datum.dataset === '${hlDataset}'`,
                value: 1
            },
            value: 0.12
        };
        if (hasTableHighlight) return {
            condition: {
                test: `datum.dataset === '${hlDataset}'`,
                value: 1
            },
            value: 0.12
        };
        if (hasBackboneHighlight) return {
            condition: {
                test: `datum.backbone === '${activeBackbone}'`,
                value: 1
            },
            value: 0.15
        };
        return {
            value: 0.8
        };
    };
    const buildPointSize = ()=>{
        if (hasCellHighlight) return {
            condition: {
                test: `datum.strategy === '${hlStrategy}' && datum.dataset === '${hlDataset}'`,
                value: 260
            },
            value: 50
        };
        if (hasTableHighlight) return {
            condition: {
                test: `datum.dataset === '${hlDataset}'`,
                value: 160
            },
            value: 50
        };
        return {
            value: hasBackboneHighlight ? 60 : 80
        };
    };
    const buildPointStroke = ()=>{
        if (hasCellHighlight) return {
            condition: {
                test: `datum.strategy === '${hlStrategy}' && datum.dataset === '${hlDataset}'`,
                value: "#1c2732"
            },
            value: null
        };
        return {
            value: null
        };
    };
    const buildPointStrokeWidth = ()=>{
        if (hasCellHighlight) return {
            condition: {
                test: `datum.strategy === '${hlStrategy}' && datum.dataset === '${hlDataset}'`,
                value: 2.5
            },
            value: 0
        };
        return {
            value: 0
        };
    };
    const lineOpacity = buildLineOpacity();
    const pointOpacity = buildPointOpacity();
    return {
        $schema: "https://vega.github.io/schema/vega-lite/v5.json",
        width: chartWidth,
        height: chartHeight,
        autosize: {
            type: "fit",
            contains: "padding"
        },
        data: {
            values: data
        },
        layer: [
            {
                mark: {
                    type: "line",
                    point: false
                },
                encoding: {
                    x: {
                        field: "strategy",
                        type: "ordinal",
                        title: "Strategy",
                        scale: {
                            domain: strategySort
                        },
                        axis: {
                            labelAngle: isMobile ? -35 : -45,
                            labelLimit: isMobile ? 90 : 120
                        }
                    },
                    y: {
                        field: "value",
                        type: "quantitative",
                        title: metricLabel,
                        scale: {
                            zero: false
                        }
                    },
                    color: {
                        field: "dataset",
                        type: "nominal",
                        title: "Dataset",
                        scale: {
                            domain: colorDomain,
                            range: colorRange
                        }
                    },
                    detail: [
                        {
                            field: "dataset",
                            type: "nominal"
                        },
                        {
                            field: "backbone",
                            type: "nominal"
                        }
                    ],
                    opacity: lineOpacity,
                    strokeWidth: hasBackboneHighlight ? {
                        condition: {
                            test: `datum.backbone === '${activeBackbone}'`,
                            value: 2.5
                        },
                        value: 1
                    } : {
                        value: 1.5
                    }
                }
            },
            {
                mark: {
                    type: "point",
                    filled: true,
                    size: 80
                },
                encoding: {
                    x: {
                        field: "strategy",
                        type: "ordinal",
                        scale: {
                            domain: strategySort
                        }
                    },
                    y: {
                        field: "value",
                        type: "quantitative"
                    },
                    color: {
                        field: "dataset",
                        type: "nominal",
                        scale: {
                            domain: colorDomain,
                            range: colorRange
                        },
                        legend: null
                    },
                    shape: {
                        field: "backbone",
                        type: "nominal",
                        title: "Backbone",
                        legend: isMobile ? null : {
                            orient: "right"
                        },
                        scale: {
                            domain: Object.keys($35da740d59af89ba$var$BACKBONE_SHAPES),
                            range: Object.values($35da740d59af89ba$var$BACKBONE_SHAPES)
                        }
                    },
                    opacity: pointOpacity,
                    size: buildPointSize(),
                    stroke: buildPointStroke(),
                    strokeWidth: buildPointStrokeWidth(),
                    tooltip: [
                        {
                            field: "strategy",
                            type: "nominal",
                            title: "Strategy"
                        },
                        {
                            field: "dataset",
                            type: "nominal",
                            title: "Dataset"
                        },
                        {
                            field: "backbone",
                            type: "nominal",
                            title: "Backbone"
                        },
                        {
                            field: "value",
                            type: "quantitative",
                            title: metricLabel,
                            format: ".4f"
                        }
                    ]
                }
            }
        ],
        config: {
            axis: {
                labelFontSize: isMobile ? 10 : 11,
                titleFontSize: isMobile ? 11 : 12
            },
            legend: {
                labelFontSize: isMobile ? 10 : 11,
                titleFontSize: isMobile ? 11 : 12
            }
        }
    };
};
/* ── Render chart ──────────────────────────────────────────────────── */ const $35da740d59af89ba$var$renderLineChart = (rows, metricKey = "test_acc", activeBackbone = null)=>{
    const chartElement = document.querySelector("#heatmap-chart");
    if (!chartElement) return;
    if (!rows.length) {
        chartElement.textContent = "No data available for chart.";
        return;
    }
    const data = $35da740d59af89ba$var$buildLineChartData(rows, metricKey);
    if (!data.length) {
        chartElement.textContent = "No data available for chart.";
        return;
    }
    const { chartWidth: chartWidth, chartHeight: chartHeight, isMobile: isMobile } = $35da740d59af89ba$var$getResponsiveChartDimensions(chartElement);
    const spec = $35da740d59af89ba$var$buildLineChartSpec(data, metricKey, chartWidth, chartHeight, activeBackbone, isMobile);
    $35da740d59af89ba$var$embed(chartElement, spec, {
        actions: {
            source: false,
            compiled: false,
            editor: false
        }
    }).catch((error)=>{
        console.error("Failed to render line chart", error?.message ?? error);
        chartElement.textContent = "Failed to render line chart.";
    });
};
/* ── Highlight chart from table hover (re-renders with updated state) ── */ let $35da740d59af89ba$var$_highlightRenderPending = false;
let $35da740d59af89ba$var$_highlightRenderRows = null;
const $35da740d59af89ba$var$scheduleHighlightRender = (rows)=>{
    $35da740d59af89ba$var$_highlightRenderRows = rows;
    if ($35da740d59af89ba$var$_highlightRenderPending) return;
    $35da740d59af89ba$var$_highlightRenderPending = true;
    requestAnimationFrame(()=>{
        $35da740d59af89ba$var$_highlightRenderPending = false;
        if ($35da740d59af89ba$var$_highlightRenderRows) $35da740d59af89ba$var$renderLineChart($35da740d59af89ba$var$_highlightRenderRows, $35da740d59af89ba$var$interactionState.currentMetric, $35da740d59af89ba$var$interactionState.currentBackbone);
    });
};
const $35da740d59af89ba$var$highlightChartPoint = (strategy, datasetName, rows)=>{
    const changed = $35da740d59af89ba$var$interactionState.highlightedStrategy !== strategy || $35da740d59af89ba$var$interactionState.highlightedDataset !== datasetName;
    if (!changed) return;
    $35da740d59af89ba$var$interactionState.highlightedStrategy = strategy;
    $35da740d59af89ba$var$interactionState.highlightedDataset = datasetName;
    if (rows) $35da740d59af89ba$var$scheduleHighlightRender(rows);
};
const $35da740d59af89ba$var$highlightChartDataset = (datasetName, rows)=>{
    $35da740d59af89ba$var$highlightChartPoint(null, datasetName, rows);
};
/* ── Tabs ──────────────────────────────────────────────────────────── */ const $35da740d59af89ba$var$renderTabs = (backbones, onSelect)=>{
    const tabBar = document.querySelector("#backbone-tabs");
    if (!tabBar) return;
    tabBar.innerHTML = "";
    tabBar.setAttribute("role", "tablist");
    tabBar.setAttribute("aria-label", "Backbone filters");
    const setActiveTab = (button)=>{
        const buttons = Array.from(tabBar.querySelectorAll(".tab"));
        buttons.forEach((tabButton)=>{
            const isActive = tabButton === button;
            tabButton.classList.toggle("active", isActive);
            tabButton.setAttribute("aria-selected", isActive ? "true" : "false");
            tabButton.tabIndex = isActive ? 0 : -1;
        });
    };
    const selectTab = (button)=>{
        if (!button) return;
        setActiveTab(button);
        const name = button.dataset.backbone;
        onSelect(name === "All" ? null : name);
    };
    const allTabs = [
        "All",
        ...backbones
    ];
    allTabs.forEach((name, index)=>{
        const button = document.createElement("button");
        button.className = `tab${index === 0 ? " active" : ""}`;
        button.type = "button";
        button.textContent = name;
        button.dataset.backbone = name;
        button.setAttribute("role", "tab");
        button.setAttribute("aria-controls", "data-table");
        button.setAttribute("aria-selected", index === 0 ? "true" : "false");
        button.tabIndex = index === 0 ? 0 : -1;
        button.addEventListener("click", ()=>selectTab(button));
        button.addEventListener("keydown", (event)=>{
            const keys = [
                "ArrowLeft",
                "ArrowRight",
                "Home",
                "End"
            ];
            if (!keys.includes(event.key)) return;
            const buttons = Array.from(tabBar.querySelectorAll(".tab"));
            const currentIndex = buttons.indexOf(button);
            if (currentIndex === -1) return;
            let nextIndex = currentIndex;
            if (event.key === "ArrowLeft") nextIndex = Math.max(0, currentIndex - 1);
            if (event.key === "ArrowRight") nextIndex = Math.min(buttons.length - 1, currentIndex + 1);
            if (event.key === "Home") nextIndex = 0;
            if (event.key === "End") nextIndex = buttons.length - 1;
            const nextButton = buttons[nextIndex];
            if (nextButton) {
                nextButton.focus();
                selectTab(nextButton);
            }
        });
        tabBar.appendChild(button);
    });
};
/* ── Table ─────────────────────────────────────────────────────────── */ const $35da740d59af89ba$var$renderTable = (rows, onChartUpdate, chartRows)=>{
    const tableElement = document.querySelector("#data-table");
    if (!tableElement) return;
    if (!rows.length) {
        if (window.__tabulatorTable) {
            window.__tabulatorTable.destroy();
            window.__tabulatorTable = null;
        }
        tableElement.textContent = "No data available.";
        return;
    }
    const { datasets: datasets, datasetKeys: datasetKeys, tableRows: tableRows } = $35da740d59af89ba$var$buildPivot(rows);
    if (!datasets.length) {
        if (window.__tabulatorTable) {
            window.__tabulatorTable.destroy();
            window.__tabulatorTable = null;
        }
        tableElement.textContent = "No datasets found.";
        return;
    }
    // Initialize visible datasets if empty (first render or tab switch)
    if ($35da740d59af89ba$var$interactionState.allDatasets.length === 0 || $35da740d59af89ba$var$interactionState.visibleDatasets.size === 0) {
        $35da740d59af89ba$var$interactionState.allDatasets = datasets;
        $35da740d59af89ba$var$interactionState.visibleDatasets = new Set(datasets);
    }
    /* ── Dataset toggle handler ──────────────────────────────────────── */ const onDatasetToggle = (datasetName, column)=>{
        const isVisible = $35da740d59af89ba$var$interactionState.visibleDatasets.has(datasetName);
        // Prevent hiding the last visible dataset
        if (isVisible && $35da740d59af89ba$var$interactionState.visibleDatasets.size <= 1) return;
        if (isVisible) $35da740d59af89ba$var$interactionState.visibleDatasets.delete(datasetName);
        else $35da740d59af89ba$var$interactionState.visibleDatasets.add(datasetName);
        // Update column header visual
        $35da740d59af89ba$var$applyDatasetHeaderStyles();
        // Update cell styles
        if (window.__tabulatorTable) window.__tabulatorTable.getRows().forEach((row)=>{
            row.getCells().forEach((cell)=>{
                const field = cell.getField();
                if (!field || field === "strategy") return;
                const key = field.split("__")[0];
                const name = $35da740d59af89ba$var$interactionState.datasetKeyToName.get(key);
                if (name) {
                    const el = cell.getElement();
                    if ($35da740d59af89ba$var$interactionState.visibleDatasets.has(name)) el.classList.remove("cell-dataset-hidden");
                    else el.classList.add("cell-dataset-hidden");
                }
            });
        });
        // Re-render chart with filtered data
        onChartUpdate();
    };
    /* ── Metric click handler ────────────────────────────────────────── */ const onMetricClick = (metricKey)=>{
        if (!metricKey || metricKey === $35da740d59af89ba$var$interactionState.currentMetric) return;
        $35da740d59af89ba$var$interactionState.currentMetric = metricKey;
        // Sync the dropdown
        const dropdown = document.querySelector("#metric-selector");
        if (dropdown) dropdown.value = metricKey;
        // Update metric column active styles
        $35da740d59af89ba$var$applyMetricHeaderStyles();
        // Re-render chart
        onChartUpdate();
    };
    const columns = $35da740d59af89ba$var$buildColumns(datasets, datasetKeys, tableRows, onDatasetToggle, onMetricClick);
    /* ── Cell hover handlers ─────────────────────────────────────────── */ const cellMouseEnter = (e, cell)=>{
        const field = cell.getField();
        if (!field || field === "strategy") return;
        const parts = field.split("__");
        if (parts.length < 2) return;
        const datasetKey = parts[0];
        const datasetName = $35da740d59af89ba$var$interactionState.datasetKeyToName.get(datasetKey);
        if (!datasetName) return;
        // Don't highlight if dataset is hidden
        if (!$35da740d59af89ba$var$interactionState.visibleDatasets.has(datasetName)) return;
        const rowData = cell.getRow().getData();
        const strategy = rowData.strategy;
        // Visual highlight on cell
        cell.getElement().classList.add("cell-hover-highlight");
        // Highlight corresponding point in chart (re-renders with greyed-out others)
        $35da740d59af89ba$var$highlightChartPoint(strategy, datasetName, chartRows);
    };
    const cellMouseLeave = (e, cell)=>{
        cell.getElement().classList.remove("cell-hover-highlight");
        $35da740d59af89ba$var$highlightChartPoint(null, null, chartRows);
    };
    if (window.__tabulatorTable) {
        // Re-register cell hover handlers (old ones are detached on setColumns)
        window.__tabulatorTable.off("cellMouseEnter");
        window.__tabulatorTable.off("cellMouseLeave");
        window.__tabulatorTable.on("cellMouseEnter", cellMouseEnter);
        window.__tabulatorTable.on("cellMouseLeave", cellMouseLeave);
        window.__tabulatorTable.setColumns(columns);
        window.__tabulatorTable.replaceData(tableRows);
        // Re-apply styles after data update
        setTimeout(()=>{
            $35da740d59af89ba$var$applyDatasetHeaderStyles();
            $35da740d59af89ba$var$applyMetricHeaderStyles();
            $35da740d59af89ba$var$attachDatasetHeaderHoverHandlers(chartRows);
        }, 50);
        return;
    }
    tableElement.textContent = "";
    window.__tabulatorTable = new (0, $517dee46856d349e$export$62676a0a2827a643)(tableElement, {
        data: tableRows,
        layout: "fitDataTable",
        columns: columns
    });
    window.__tabulatorTable.on("cellMouseEnter", cellMouseEnter);
    window.__tabulatorTable.on("cellMouseLeave", cellMouseLeave);
    // Apply styles once table is built
    window.__tabulatorTable.on("tableBuilt", ()=>{
        $35da740d59af89ba$var$applyDatasetHeaderStyles();
        $35da740d59af89ba$var$applyMetricHeaderStyles();
        $35da740d59af89ba$var$attachDatasetHeaderHoverHandlers(chartRows);
    });
};
/* ── Style helpers (applied after render) ──────────────────────────── */ const $35da740d59af89ba$var$applyDatasetHeaderStyles = ()=>{
    // Column groups are not returned by getColumns() in Tabulator;
    // query the DOM directly for group header elements.
    const groupHeaders = document.querySelectorAll(".tabulator-col-group");
    groupHeaders.forEach((el)=>{
        const titleEl = el.querySelector(":scope > .tabulator-col-content .tabulator-col-title");
        const rawTitle = titleEl?.textContent?.trim();
        if (!rawTitle) return;
        // Strip task suffix (e.g., "bloodmnist [classification]" → "bloodmnist")
        const datasetName = rawTitle.replace(/\s*\[.*\]$/, "");
        el.classList.add("dataset-col-group");
        if ($35da740d59af89ba$var$interactionState.visibleDatasets.has(datasetName)) el.classList.remove("dataset-hidden");
        else el.classList.add("dataset-hidden");
    });
};
const $35da740d59af89ba$var$applyMetricHeaderStyles = ()=>{
    if (!window.__tabulatorTable) return;
    // Leaf columns are accessible via getColumns()
    const leafCols = window.__tabulatorTable.getColumns();
    leafCols.forEach((col)=>{
        const field = col.getField();
        if (!field || field === "strategy") return;
        const suffix = field.split("__")[1];
        if (!suffix) return;
        const metricKey = $35da740d59af89ba$var$METRIC_SUFFIX_TO_KEY[suffix];
        const el = col.getElement();
        if (!el) return;
        el.classList.add("metric-col");
        if (metricKey === $35da740d59af89ba$var$interactionState.currentMetric) el.classList.add("metric-col-active");
        else el.classList.remove("metric-col-active");
    });
};
/* ── Attach hover handlers to dataset column group headers ─────────── */ const $35da740d59af89ba$var$attachDatasetHeaderHoverHandlers = (chartRows)=>{
    const groupHeaders = document.querySelectorAll(".tabulator-col-group");
    groupHeaders.forEach((el)=>{
        // Avoid attaching duplicate listeners
        if (el._datasetHoverAttached) return;
        el._datasetHoverAttached = true;
        const titleEl = el.querySelector(":scope > .tabulator-col-content .tabulator-col-title");
        const rawTitle = titleEl?.textContent?.trim();
        if (!rawTitle) return;
        // Strip task suffix (e.g., "bloodmnist [classification]" → "bloodmnist")
        const datasetName = rawTitle.replace(/\s*\[.*\]$/, "");
        el.addEventListener("mouseenter", ()=>{
            if (!$35da740d59af89ba$var$interactionState.visibleDatasets.has(datasetName)) return;
            $35da740d59af89ba$var$highlightChartDataset(datasetName, chartRows);
        });
        el.addEventListener("mouseleave", ()=>{
            $35da740d59af89ba$var$highlightChartDataset(null, chartRows);
        });
    });
};
/* ── Init ──────────────────────────────────────────────────────────── */ const $35da740d59af89ba$var$init = async ()=>{
    const tableElement = document.querySelector("#data-table");
    if (tableElement) tableElement.textContent = "Loading data...";
    const resolvedUrl = $35da740d59af89ba$var$DATA_URL.toString();
    try {
        const rawDataframe = await $fe8436a5a6cf553d$exports.readCSV(resolvedUrl);
        // Filter out excluded backbones
        const backboneValues = rawDataframe["backbone"]?.values ?? [];
        const keepIndices = [];
        for(let i = 0; i < backboneValues.length; i += 1)if (!$35da740d59af89ba$var$EXCLUDED_BACKBONES.has(backboneValues[i])) keepIndices.push(i);
        const dataframe = rawDataframe.iloc({
            rows: keepIndices
        });
        $35da740d59af89ba$var$METRICS.forEach(({ key: key })=>{
            if (dataframe.columns.includes(key)) dataframe.addColumn(key, $35da740d59af89ba$var$toNumberSeries(dataframe[key]), {
                inplace: true
            });
        });
        // Fall back to test_auc_macro where test_auc is missing (e.g., chestmnist)
        // First, capture original test_auc values BEFORE the merge to detect which datasets needed the fallback
        const datasetAucMacroSet = new Set();
        if (dataframe.columns.includes("test_auc_macro")) {
            dataframe.addColumn("test_auc_macro", $35da740d59af89ba$var$toNumberSeries(dataframe["test_auc_macro"]), {
                inplace: true
            });
            const aucValues = dataframe["test_auc"].values;
            const aucMacroValues = dataframe["test_auc_macro"].values;
            const dsValues = dataframe["dataset"].values;
            // Detect datasets where ALL test_auc values are NaN (before merge)
            const datasetHasAuc = new Set();
            for(let i = 0; i < dsValues.length; i += 1)if (Number.isFinite(aucValues[i])) datasetHasAuc.add(dsValues[i]);
            const allDs = new Set(dsValues);
            allDs.forEach((ds)=>{
                if (!datasetHasAuc.has(ds)) datasetAucMacroSet.add(ds);
            });
            // Merge: where test_auc is NaN, use test_auc_macro
            const mergedAuc = aucValues.map((v, i)=>Number.isFinite(v) ? v : aucMacroValues[i]);
            dataframe.addColumn("test_auc", mergedAuc, {
                inplace: true
            });
        }
        $35da740d59af89ba$var$interactionState.datasetAucMacroSet = datasetAucMacroSet;
        const backbones = Array.from(dataframe["backbone"].unique().values).sort();
        // Build fixed color map from ALL datasets so colors are stable
        const allDatasetNames = Array.from(dataframe["dataset"].unique().values).sort();
        $35da740d59af89ba$var$interactionState.datasetColorMap = $35da740d59af89ba$var$buildDatasetColorMap(allDatasetNames);
        // Build dataset-to-task mapping (task is a dataset-level attribute)
        const datasetTaskMap = new Map();
        const datasetValues = dataframe["dataset"]?.values ?? [];
        const taskValues = dataframe["task"]?.values ?? [];
        for(let i = 0; i < datasetValues.length; i += 1)if (!datasetTaskMap.has(datasetValues[i]) && taskValues[i]) datasetTaskMap.set(datasetValues[i], String(taskValues[i]));
        $35da740d59af89ba$var$interactionState.datasetTaskMap = datasetTaskMap;
        const filterByBackbone = (frame, backbone)=>{
            if (!backbone) return frame;
            const values = frame["backbone"]?.values ?? [];
            const rowIndices = [];
            for(let index = 0; index < values.length; index += 1)if (values[index] === backbone) rowIndices.push(index);
            return frame.iloc({
                rows: rowIndices
            });
        };
        const buildRows = (backbone)=>{
            const scoped = filterByBackbone(dataframe, backbone);
            const working = scoped.copy();
            const strategyValues = working["strategy"].values;
            const unfreezeValues = working["unfreeze_pct"]?.values ?? [];
            const directionValues = working["Direction"]?.values ?? [];
            const derivedStrategies = strategyValues.map((value, index)=>{
                if (value !== "partial") return value;
                const pct = Number(unfreezeValues[index]);
                const direction = String(directionValues[index] ?? "").toLowerCase();
                if (!Number.isFinite(pct)) return "partial";
                if (!direction) return `partial_${Math.round(pct)}`;
                return `partial_${direction}_${Math.round(pct)}`;
            });
            working.addColumn("strategy_group", new $fe8436a5a6cf553d$exports.Series(derivedStrategies), {
                inplace: true
            });
            const grouped = working.groupby([
                "strategy_group",
                "dataset",
                "backbone"
            ]).col($35da740d59af89ba$var$METRICS.map(({ key: key })=>key)).mean();
            const groupedColumns = grouped.columns;
            const metricKeys = $35da740d59af89ba$var$METRICS.reduce((acc, { key: key })=>{
                const meanKey = `${key}_mean`;
                acc[key] = groupedColumns.includes(meanKey) ? meanKey : key;
                return acc;
            }, {});
            return $fe8436a5a6cf553d$exports.toJSON(grouped).map((row)=>{
                const { strategy_group: strategyGroup, ...rest } = row;
                return {
                    ...rest,
                    strategy: strategyGroup ?? row.strategy,
                    metricKeys: metricKeys
                };
            });
        };
        const dataCache = new Map();
        const getRows = (backbone)=>{
            const key = backbone ?? "All";
            if (!dataCache.has(key)) dataCache.set(key, buildRows(backbone));
            return dataCache.get(key);
        };
        const updateViews = (backbone, metric)=>{
            const rows = getRows(backbone);
            const onChartUpdate = ()=>{
                $35da740d59af89ba$var$renderLineChart(rows, $35da740d59af89ba$var$interactionState.currentMetric, $35da740d59af89ba$var$interactionState.currentBackbone);
            };
            $35da740d59af89ba$var$renderTable(rows, onChartUpdate, rows);
            $35da740d59af89ba$var$renderLineChart(rows, metric, $35da740d59af89ba$var$interactionState.currentBackbone);
        };
        let resizeRenderPending = false;
        const scheduleResponsiveRender = ()=>{
            if (resizeRenderPending) return;
            resizeRenderPending = true;
            requestAnimationFrame(()=>{
                resizeRenderPending = false;
                const rows = getRows($35da740d59af89ba$var$interactionState.currentBackbone);
                if (window.__tabulatorTable) window.__tabulatorTable.redraw(true);
                $35da740d59af89ba$var$renderLineChart(rows, $35da740d59af89ba$var$interactionState.currentMetric, $35da740d59af89ba$var$interactionState.currentBackbone);
            });
        };
        const chartElement = document.querySelector("#heatmap-chart");
        if (chartElement && "ResizeObserver" in window) {
            const chartResizeObserver = new ResizeObserver(()=>{
                scheduleResponsiveRender();
            });
            chartResizeObserver.observe(chartElement);
        }
        window.addEventListener("resize", scheduleResponsiveRender);
        /* ── Metric selector dropdown ────────────────────────────────────── */ const metricSelector = document.querySelector("#metric-selector");
        if (metricSelector) metricSelector.addEventListener("change", (event)=>{
            $35da740d59af89ba$var$interactionState.currentMetric = event.target.value;
            $35da740d59af89ba$var$applyMetricHeaderStyles();
            const rows = getRows($35da740d59af89ba$var$interactionState.currentBackbone);
            $35da740d59af89ba$var$renderLineChart(rows, $35da740d59af89ba$var$interactionState.currentMetric, $35da740d59af89ba$var$interactionState.currentBackbone);
        });
        /* ── Reset datasets button ───────────────────────────────────────── */ const resetButton = document.querySelector("#reset-datasets");
        if (resetButton) resetButton.addEventListener("click", ()=>{
            $35da740d59af89ba$var$interactionState.visibleDatasets = new Set($35da740d59af89ba$var$interactionState.allDatasets);
            $35da740d59af89ba$var$applyDatasetHeaderStyles();
            // Update cell styles
            if (window.__tabulatorTable) window.__tabulatorTable.getRows().forEach((row)=>{
                row.getCells().forEach((cell)=>{
                    cell.getElement().classList.remove("cell-dataset-hidden");
                });
            });
            const rows = getRows($35da740d59af89ba$var$interactionState.currentBackbone);
            $35da740d59af89ba$var$renderLineChart(rows, $35da740d59af89ba$var$interactionState.currentMetric, $35da740d59af89ba$var$interactionState.currentBackbone);
        });
        /* ── Backbone tabs ───────────────────────────────────────────────── */ $35da740d59af89ba$var$renderTabs(backbones, (backbone)=>{
            $35da740d59af89ba$var$interactionState.currentBackbone = backbone;
            // Reset visible datasets on tab switch
            $35da740d59af89ba$var$interactionState.allDatasets = [];
            $35da740d59af89ba$var$interactionState.visibleDatasets.clear();
            updateViews(backbone, $35da740d59af89ba$var$interactionState.currentMetric);
        });
        updateViews(null, $35da740d59af89ba$var$interactionState.currentMetric);
    } catch (error) {
        console.error("Failed to load dataset", error);
        if (tableElement) {
            const message = error instanceof Error ? error.message : "Failed to load data.";
            tableElement.textContent = message;
        }
    }
};
$35da740d59af89ba$var$init();


//# sourceMappingURL=MedMNIST-Fine-Tuning-Visualization.df725eba.js.map
